(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888,5152,9008,1664,1163,4298,357,9967,1045],{

/***/ 39879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "InMemoryCache": function() { return /* reexport */ InMemoryCache; },
  "cacheSlot": function() { return /* reexport */ cacheSlot; },
  "makeVar": function() { return /* reexport */ makeVar; }
});

// UNUSED EXPORTS: ApolloCache, Cache, MissingFieldError, defaultDataIdFromObject, isReference, makeReference

;// CONCATENATED MODULE: ./node_modules/@wry/trie/lib/trie.esm.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function () { return Object.create(null); };
// Useful for processing arguments objects as well as arrays.
var _a = Array.prototype, forEach = _a.forEach, slice = _a.slice;
var Trie = /** @class */ (function () {
    function Trie(weakness, makeData) {
        if (weakness === void 0) { weakness = true; }
        if (makeData === void 0) { makeData = defaultMakeData; }
        this.weakness = weakness;
        this.makeData = makeData;
    }
    Trie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    Trie.prototype.lookupArray = function (array) {
        var node = this;
        forEach.call(array, function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = this.makeData(slice.call(array)));
    };
    Trie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    };
    return Trie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}


//# sourceMappingURL=trie.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/context.esm.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map

;// CONCATENATED MODULE: ./node_modules/optimism/lib/bundle.esm.js





function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var node = this.getNode(key);
        return node && node.value;
    };
    Cache.prototype.getNode = function (key) {
        var node = this.map.get(key);
        if (node && node !== this.newest) {
            var older = node.older, newer = node.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    };
    Cache.prototype.set = function (key, value) {
        var node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new Slot();

function maybeUnsubscribe(entryOrDep) {
    var unsubscribe = entryOrDep.unsubscribe;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    Entry.prototype.peek = function () {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            return this.value[0];
        }
    };
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function (args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        forgetChildren(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        forgetChildren(this);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function (parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.prototype.dependOn = function (dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    };
    Entry.prototype.forgetDeps = function () {
        var _this = this;
        if (this.deps) {
            this.deps.forEach(function (dep) { return dep.delete(_this); });
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
}
function reportClean(child) {
    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

function dep(options) {
    var depsByKey = new Map();
    var subscribe = options && options.subscribe;
    function depend(key) {
        var parent = parentEntrySlot.getValue();
        if (parent) {
            var dep_1 = depsByKey.get(key);
            if (!dep_1) {
                depsByKey.set(key, dep_1 = new Set);
            }
            parent.dependOn(dep_1);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep_1);
                dep_1.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key) {
        var dep = depsByKey.get(key);
        if (dep) {
            dep.forEach(function (entry) { return entry.setDirty(); });
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new Trie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var keyArgs = options.keyArgs;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.subscribe = options.subscribe;
        }
        var value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        return value;
    }
    function lookup() {
        var key = makeCacheKey.apply(null, arguments);
        if (key !== void 0) {
            return cache.get(key);
        }
    }
    optimistic.dirty = function () {
        var entry = lookup.apply(null, arguments);
        if (entry) {
            entry.setDirty();
        }
    };
    optimistic.peek = function () {
        var entry = lookup.apply(null, arguments);
        if (entry) {
            return entry.peek();
        }
    };
    optimistic.forget = function () {
        var key = makeCacheKey.apply(null, arguments);
        return key !== void 0 && cache.delete(key);
    };
    return optimistic;
}


//# sourceMappingURL=bundle.esm.js.map

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/cache.js


var ApolloCache = (function () {
    function ApolloCache() {
        this.getFragmentDoc = wrap(utilities/* getFragmentQueryDocument */.Yk);
    }
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read({
            rootId: options.id || 'ROOT_QUERY',
            query: options.query,
            variables: options.variables,
            returnPartialData: options.returnPartialData,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read({
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            returnPartialData: options.returnPartialData,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        return this.write({
            dataId: options.id || 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
            broadcast: options.broadcast,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        return this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            broadcast: options.broadcast,
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/types/Cache.js
var Cache_Cache;
(function (Cache) {
})(Cache_Cache || (Cache_Cache = {}));
//# sourceMappingURL=Cache.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/types/common.js
var MissingFieldError = (function () {
    function MissingFieldError(message, path, query, clientOnly, variables) {
        this.message = message;
        this.path = path;
        this.query = query;
        this.clientOnly = clientOnly;
        this.variables = variables;
    }
    return MissingFieldError;
}());

//# sourceMappingURL=common.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js

var hasOwn = Object.prototype.hasOwnProperty;
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference)
        ? store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function helpers_fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if (result && typeof result === "object") {
        return Array.isArray(result)
            ? result.every(function (item) { return selectionSetMatchesResult(selectionSet, item, variables); })
            : selectionSet.selections.every(function (field) {
                if ((0,utilities/* isField */.My)(field) && (0,utilities/* shouldInclude */.LZ)(field, variables)) {
                    var key = (0,utilities/* resultKeyNameFromField */.u2)(field);
                    return hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables));
                }
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return value !== null &&
        typeof value === "object" &&
        !(0,utilities/* isReference */.hh)(value) &&
        !Array.isArray(value);
}
function makeProcessedFieldsMerger() {
    return new utilities/* DeepMerger */.w0;
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/entityStore.js





var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        this.rootIds = Object.create(null);
        this.refs = Object.create(null);
        this.getFieldValue = function (objectOrReference, storeFieldName) { return (0,utilities/* maybeDeepFreeze */.Jv)((0,utilities/* isReference */.hh)(objectOrReference)
            ? _this.get(objectOrReference.__ref, storeFieldName)
            : objectOrReference && objectOrReference[storeFieldName]); };
        this.canRead = function (objOrRef) {
            return (0,utilities/* isReference */.hh)(objOrRef)
                ? _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,utilities/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,utilities/* isReference */.hh)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,utilities/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (dataId, incoming) {
        var _this = this;
        var existing = this.lookup(dataId);
        var merged = new utilities/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        fieldsToDirty_1[storeFieldName] = 1;
                        var fieldName = helpers_fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) { return _this.group.dirty(dataId, fieldName); });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: utilities/* isReference */.hh,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) { return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                    fieldName: fieldNameOrOptions,
                    from: from || (0,utilities/* makeReference */.kQ)(dataId),
                } : fieldNameOrOptions, { store: _this }); },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = helpers_fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function"
                    ? fields
                    : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === delModifier ? DELETE :
                        modify((0,utilities/* maybeDeepFreeze */.Jv)(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName,
                            storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) }));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args
                ? this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer) {
                evicted = this.parent.evict(options) || evicted;
            }
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var workSet_1 = new Set([this.data[dataId]]);
            var canTraverse_1 = function (obj) { return obj !== null && typeof obj === 'object'; };
            workSet_1.forEach(function (obj) {
                if ((0,utilities/* isReference */.hh)(obj)) {
                    found_1[obj.__ref] = true;
                }
                else if (canTraverse_1(obj)) {
                    Object.values(obj)
                        .filter(canTraverse_1)
                        .forEach(workSet_1.add, workSet_1);
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.group.keyMaker.lookupArray(args);
    };
    return EntityStore;
}());

var CacheGroup = (function () {
    function CacheGroup(caching) {
        this.caching = caching;
        this.d = null;
        this.keyMaker = new Trie(utilities/* canUseWeakMap */.mr);
        this.d = caching ? dep() : null;
    }
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = helpers_fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                this.d(makeDepKey(dataId, fieldName));
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName));
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    return storeFieldName + '#' + dataId;
}
(function (EntityStore) {
    var Root = (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.storageTrie = new Trie(utilities/* canUseWeakMap */.mr);
            _this.sharedLayerGroup = new CacheGroup(resultCaching);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            return new Layer(layerId, this, replay, this.sharedLayerGroup);
        };
        Root.prototype.removeLayer = function () {
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
var Layer = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                Object.keys(this.data).forEach(function (dataId) {
                    if (_this.data[dataId] !== parent.lookup(dataId)) {
                        _this.delete(dataId);
                    }
                });
            }
            return parent;
        }
        if (parent === this.parent)
            return this;
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, arguments);
    };
    return Layer;
}(EntityStore));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    return (0,equality_esm/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/readFromStore.js







;
function missingFromInvariant(err, context) {
    return new MissingFieldError(err.message, context.path.slice(), context.query, context.clientOnly, context.variables);
}
var StoreReader = (function () {
    function StoreReader(config) {
        var _this = this;
        this.config = config;
        this.executeSelectionSet = wrap(function (options) { return _this.execSelectionSetImpl(options); }, {
            keyArgs: function (options) {
                return [
                    options.selectionSet,
                    options.objectOrReference,
                    options.context,
                ];
            },
            makeCacheKey: function (selectionSet, parent, context) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,utilities/* isReference */.hh)(parent) ? parent.__ref : parent, context.varString);
                }
            }
        });
        this.knownResults = new WeakMap();
        this.executeSubSelectedArray = wrap(function (options) {
            return _this.execSubSelectedArrayImpl(options);
        }, {
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            }
        });
        this.config = (0,tslib_es6/* __assign */.pi)({ addTypename: true }, config);
    }
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? 'ROOT_QUERY' : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,utilities/* getDefaultValues */.O4)((0,utilities/* getQueryDefinition */.iW)(query))), variables);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,utilities/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: (0,utilities/* makeReference */.kQ)(rootId),
            context: {
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0,utilities/* createFragmentMap */.F)((0,utilities/* getFragmentDefinitions */.kU)(query)),
                path: [],
                clientOnly: false,
            },
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            throw execResult.missing[0];
        }
        return {
            result: execResult.result,
            missing: execResult.missing,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context);
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, context = _a.context;
        if ((0,utilities/* isReference */.hh)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: {},
                missing: [missingFromInvariant( true ? new invariant_esm/* InvariantError */.ej(4) : 0, context)],
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var objectsToMerge = [];
        var finalResult = { result: null };
        var typename = store.getFieldValue(objectOrReference, "__typename");
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            objectsToMerge.push({ __typename: typename });
        }
        function getMissing() {
            return finalResult.missing || (finalResult.missing = []);
        }
        function handleMissing(result) {
            var _a;
            if (result.missing)
                (_a = getMissing()).push.apply(_a, result.missing);
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a;
            if (!(0,utilities/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,utilities/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,utilities/* resultKeyNameFromField */.u2)(selection);
                context.path.push(resultName);
                var wasClientOnly = context.clientOnly;
                context.clientOnly = wasClientOnly || !!(selection.directives &&
                    selection.directives.some(function (d) { return d.name.value === "client"; }));
                if (fieldValue === void 0) {
                    if (!utilities/* addTypenameToDocument.added */.Gw.added(selection)) {
                        getMissing().push(missingFromInvariant( true ? new invariant_esm/* InvariantError */.ej(5) : 0, context));
                    }
                }
                else if (Array.isArray(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        context: context,
                    }));
                }
                else if (!selection.selectionSet) {
                    if (false) {}
                }
                else if (fieldValue != null) {
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        context: context,
                    }));
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_a = {}, _a[resultName] = fieldValue, _a));
                }
                context.clientOnly = wasClientOnly;
                (0,invariant_esm/* invariant */.kG)(context.path.pop() === resultName);
            }
            else {
                var fragment = (0,utilities/* getFragmentFromSelection */.hi)(selection, context.fragmentMap);
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        finalResult.result = (0,utilities/* mergeDeepArray */.bw)(objectsToMerge);
        if (false) {}
        this.knownResults.set(finalResult.result, selectionSet);
        return finalResult;
    };
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, context = _a.context;
        var missing;
        function handleMissing(childResult, i) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            (0,invariant_esm/* invariant */.kG)(context.path.pop() === i);
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            if (item === null) {
                return null;
            }
            context.path.push(i);
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    context: context,
                }), i);
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    context: context,
                }), i);
            }
            if (false) {}
            (0,invariant_esm/* invariant */.kG)(context.path.pop() === i);
            return item;
        });
        if (false) {}
        return { result: array, missing: missing };
    };
    return StoreReader;
}());

function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if (value && typeof value === "object") {
                 true ? invariant(!isReference(value), 6) : 0;
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/writeToStore.js





;
var StoreWriter = (function () {
    function StoreWriter(cache, reader) {
        this.cache = cache;
        this.reader = reader;
    }
    StoreWriter.prototype.writeToStore = function (_a) {
        var query = _a.query, result = _a.result, dataId = _a.dataId, store = _a.store, variables = _a.variables;
        var operationDefinition = (0,utilities/* getOperationDefinition */.$H)(query);
        var merger = makeProcessedFieldsMerger();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,utilities/* getDefaultValues */.O4)(operationDefinition)), variables);
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map },
            context: {
                store: store,
                written: Object.create(null),
                merge: function (existing, incoming) {
                    return merger.merge(existing, incoming);
                },
                variables: variables,
                varString: JSON.stringify(variables),
                fragmentMap: (0,utilities/* createFragmentMap */.F)((0,utilities/* getFragmentDefinitions */.kU)(query)),
            },
        });
        if (!(0,utilities/* isReference */.hh)(ref)) {
            throw  true ? new invariant_esm/* InvariantError */.ej(7) : 0;
        }
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        var _b = policies.identify(result, selectionSet, context.fragmentMap), id = _b[0], keyObject = _b[1];
        dataId = dataId || id;
        if ("string" === typeof dataId) {
            var sets = context.written[dataId] || (context.written[dataId] = []);
            var ref = (0,utilities/* makeReference */.kQ)(dataId);
            if (sets.indexOf(selectionSet) >= 0)
                return ref;
            sets.push(selectionSet);
            if (this.reader && this.reader.isFresh(result, ref, selectionSet, context)) {
                return ref;
            }
        }
        var incomingFields = Object.create(null);
        if (keyObject) {
            incomingFields = context.merge(incomingFields, keyObject);
        }
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,utilities/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incomingFields.__typename = typename;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a;
            if (!(0,utilities/* shouldInclude */.LZ)(selection, context.variables))
                return;
            if ((0,utilities/* isField */.My)(selection)) {
                var resultFieldKey = (0,utilities/* resultKeyNameFromField */.u2)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    var storeFieldName = policies.getStoreFieldName({
                        typename: typename,
                        fieldName: selection.name.value,
                        field: selection,
                        variables: context.variables,
                    });
                    var childTree = getChildMergeTree(mergeTree, storeFieldName);
                    var incomingValue = _this.processFieldValue(value, selection, context, childTree);
                    var childTypename = selection.selectionSet
                        && context.store.getFieldValue(incomingValue, "__typename")
                        || void 0;
                    var merge = policies.getMergeFunction(typename, selection.name.value, childTypename);
                    if (merge) {
                        childTree.info = {
                            field: selection,
                            typename: typename,
                            merge: merge,
                        };
                    }
                    else {
                        maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                    }
                    incomingFields = context.merge(incomingFields, (_a = {},
                        _a[storeFieldName] = incomingValue,
                        _a));
                }
                else if (policies.usingPossibleTypes &&
                    !(0,utilities/* hasDirectives */.FS)(["defer", "client"], selection)) {
                    throw  true ? new invariant_esm/* InvariantError */.ej(8) : 0;
                }
            }
            else {
                var fragment = (0,utilities/* getFragmentFromSelection */.hi)(selection, context.fragmentMap);
                if (fragment &&
                    policies.fragmentMatches(fragment, typename, result, context.variables)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        if ("string" === typeof dataId) {
            var entityRef_1 = (0,utilities/* makeReference */.kQ)(dataId);
            if (mergeTree.map.size) {
                incomingFields = this.applyMerges(mergeTree, entityRef_1, incomingFields, context);
            }
            if (false) { var hasMergeFunction_1, fieldsWithSelectionSets_1, hasSelectionSet_1; }
            context.store.merge(dataId, incomingFields);
            return entityRef_1;
        }
        return incomingFields;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            return  true ? value : 0;
        }
        if (Array.isArray(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,utilities/* isReference */.hh)(incoming)) {
            var e_1 = (!Array.isArray(incoming) &&
                ((0,utilities/* isReference */.hh)(existing) || storeValueIsStoreObject(existing))) ? existing : void 0;
            var i_1 = incoming;
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,utilities/* isReference */.hh)(e_1) ? e_1.__ref : e_1];
            }
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return Array.isArray(from)
                    ? (typeof name === "number" ? from[name] : void 0)
                    : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map;
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,invariant_esm/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                incoming = (Array.isArray(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map });
    }
    return map.get(name);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree &&
        !childTree.info &&
        !childTree.map.size) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    if (isReference(existing))
        return;
    if (equal(existing, incoming))
        return;
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = parentType + "." + fieldName;
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    if (!Array.isArray(existing) &&
        !Array.isArray(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" &&
                !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
     true || 0;
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js


var cacheSlot = new Slot();
function consumeAndIterate(set, callback) {
    if (set.size) {
        var items_1 = [];
        set.forEach(function (item) { return items_1.push(item); });
        set.clear();
        items_1.forEach(callback);
    }
}
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, info = {
            vars: new Set,
            dep: dep(),
        });
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    getCacheInfo(cache).dep.dirty(rv);
                    broadcast(cache);
                });
                consumeAndIterate(listeners, function (listener) { return listener(value); });
            }
        }
        else {
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/policies.js






function argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args :
        spec.field ? (0,utilities/* argumentsObjectFromField */.NC)(spec.field, spec.variables) : null;
}
var defaultDataIdFromObject = function (_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                id !== void 0 ? { id: id } :
                    _id !== void 0 ? { _id: _id } :
                        void 0;
        }
        if (id === void 0)
            id = _id;
        if (id !== void 0) {
            return __typename + ":" + ((typeof id === "number" ||
                typeof id === "string") ? id : JSON.stringify(id));
        }
    }
};
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        this.supertypeMap = new Map();
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, selectionSet, fragmentMap) {
        var typename = selectionSet && fragmentMap
            ? (0,utilities/* getTypenameFromResult */.qw)(object, selectionSet, fragmentMap)
            : object.__typename;
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        var context = {
            typename: typename,
            selectionSet: selectionSet,
            fragmentMap: fragmentMap,
        };
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(object, context);
            if (Array.isArray(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge :
                    merge === true ? mergeTrueFn :
                        merge === false ? mergeFalseFn :
                            existing.merge;
        }
        setMerge(existing, incoming.merge);
        existing.keyFn =
            keyFields === false ? nullKeyFieldsFn :
                Array.isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields) :
                    typeof keyFields === "function" ? keyFields :
                        existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        keyArgs === false ? simpleKeyArgsFn :
                            Array.isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) :
                                typeof keyArgs === "function" ? keyArgs :
                                    existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
             true ? (0,invariant_esm/* invariant */.kG)(!old || old === which, 1) : 0;
            if (old)
                delete this.rootIdsByTypename[old];
            this.rootIdsByTypename[typename] = rootId;
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            var supertypes = this.supertypeMap.get(typename);
            if (supertypes && supertypes.size) {
                supertypes.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            this.updateTypePolicy(typename, utilities/* compact.apply */.oA.apply(void 0, inbox.splice(0)));
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || (createIfMissing && (fieldPolicies[fieldName] = Object.create(null)));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, supertypeSet = new Set());
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes &&
            this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                             true || 0;
                        }
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    i === workQueue_1.length - 1 &&
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if (Array.isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName = fieldSpec.field
                ? (0,utilities/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                : (0,utilities/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        if (storeFieldName === false) {
            return fieldName;
        }
        return fieldName === helpers_fieldNameFromStoreName(storeFieldName)
            ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = helpers_fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,utilities/* isReference */.hh)(objectOrReference)
                ? objectOrReference.__ref
                : objectOrReference, storeFieldName));
            return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
        }
        return existing;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            return makeMergeObjectsFunction(context.store.getFieldValue)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            return incoming;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, { typename: typename, fieldName: field.name.value, field: field, variables: context.variables }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = helpers_fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, getFieldValue = _a.getFieldValue, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: utilities/* isReference */.hh,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function (fieldNameOrOptions, from) {
            var options = typeof fieldNameOrOptions === "string" ? {
                fieldName: fieldNameOrOptions,
                from: from,
            } : (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
            if (void 0 === options.from) {
                options.from = objectOrReference;
            }
            if (void 0 === options.variables) {
                options.variables = variables;
            }
            return policies.readField(options, context);
        },
        mergeObjects: makeMergeObjectsFunction(getFieldValue),
    };
}
function makeMergeObjectsFunction(getFieldValue) {
    return function mergeObjects(existing, incoming) {
        if (Array.isArray(existing) || Array.isArray(incoming)) {
            throw  true ? new invariant_esm/* InvariantError */.ej(2) : 0;
        }
        if (existing && typeof existing === "object" &&
            incoming && typeof incoming === "object") {
            var eType = getFieldValue(existing, "__typename");
            var iType = getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer ||
                !storeValueIsStoreObject(existing) ||
                !storeValueIsStoreObject(incoming)) {
                return incoming;
            }
            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
        }
        return incoming;
    };
}
function keyArgsFnFromSpecifier(specifier) {
    return function (args, context) {
        return args ? context.fieldName + ":" + JSON.stringify(computeKeyObject(args, specifier, false)) : context.fieldName;
    };
}
function keyFieldsFnFromSpecifier(specifier) {
    var trie = new Trie(utilities/* canUseWeakMap */.mr);
    return function (object, context) {
        var aliasMap;
        if (context.selectionSet && context.fragmentMap) {
            var info = trie.lookupArray([
                context.selectionSet,
                context.fragmentMap,
            ]);
            aliasMap = info.aliasMap || (info.aliasMap = makeAliasMap(context.selectionSet, context.fragmentMap));
        }
        var keyObject = context.keyObject =
            computeKeyObject(object, specifier, true, aliasMap);
        return context.typename + ":" + JSON.stringify(keyObject);
    };
}
function makeAliasMap(selectionSet, fragmentMap) {
    var map = Object.create(null);
    var workQueue = new Set([selectionSet]);
    workQueue.forEach(function (selectionSet) {
        selectionSet.selections.forEach(function (selection) {
            if ((0,utilities/* isField */.My)(selection)) {
                if (selection.alias) {
                    var responseKey = selection.alias.value;
                    var storeKey = selection.name.value;
                    if (storeKey !== responseKey) {
                        var aliases = map.aliases || (map.aliases = Object.create(null));
                        aliases[storeKey] = responseKey;
                    }
                }
                if (selection.selectionSet) {
                    var subsets = map.subsets || (map.subsets = Object.create(null));
                    subsets[selection.name.value] =
                        makeAliasMap(selection.selectionSet, fragmentMap);
                }
            }
            else {
                var fragment = (0,utilities/* getFragmentFromSelection */.hi)(selection, fragmentMap);
                if (fragment) {
                    workQueue.add(fragment.selectionSet);
                }
            }
        });
    });
    return map;
}
function computeKeyObject(response, specifier, strict, aliasMap) {
    var keyObj = Object.create(null);
    var prevKey;
    specifier.forEach(function (s) {
        if (Array.isArray(s)) {
            if (typeof prevKey === "string") {
                var subsets = aliasMap && aliasMap.subsets;
                var subset = subsets && subsets[prevKey];
                keyObj[prevKey] = computeKeyObject(response[prevKey], s, strict, subset);
            }
        }
        else {
            var aliases = aliasMap && aliasMap.aliases;
            var responseName = aliases && aliases[s] || s;
            if (hasOwn.call(response, responseName)) {
                keyObj[prevKey = s] = response[responseName];
            }
            else {
                 true ? (0,invariant_esm/* invariant */.kG)(!strict, 3) : 0;
                prevKey = void 0;
            }
        }
    });
    return keyObj;
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js












var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    typePolicies: {},
};
var InMemoryCache = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.maybeBroadcastWatch = wrap(function (c, fromOptimisticTransaction) {
            return _this.broadcastWatch.call(_this, c, !!fromOptimisticTransaction);
        }, {
            makeCacheKey: function (c) {
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, rootId = c.rootId, variables = c.variables;
                    return store.makeCacheKey(c.query, c.callback, JSON.stringify({ optimistic: optimistic, rootId: rootId, variables: variables }));
                }
            }
        });
        _this.watchDep = dep();
        _this.config = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultConfig), config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.data = new EntityStore.Root({
            policies: _this.policies,
            resultCaching: _this.config.resultCaching,
        });
        _this.optimisticData = _this.data;
        _this.storeWriter = new StoreWriter(_this, _this.storeReader = new StoreReader({
            cache: _this,
            addTypename: _this.addTypename,
        }));
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var _a = options.returnPartialData, returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: options.query,
                variables: options.variables,
                rootId: options.rootId,
                config: this.config,
                returnPartialData: returnPartialData,
            }).result || null;
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore({
                store: this.data,
                query: options.query,
                result: options.result,
                dataId: options.dataId,
                variables: options.variables,
            });
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            return false;
        }
        var store = options.optimistic
            ? this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore({
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            query: options.query,
            variables: options.variables,
            returnPartialData: options.returnPartialData,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            _this.watchDep.dirty(watch);
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function () {
        return this.optimisticData.gc();
    };
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    InMemoryCache.prototype.identify = function (object) {
        return (0,utilities/* isReference */.hh)(object) ? object.__ref :
            this.policies.identify(object)[0];
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            ++this.txCount;
            return this.optimisticData.evict(options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.optimisticData = this.data;
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _this = this;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                transaction(_this);
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var fromOptimisticTransaction = false;
        if (typeof optimisticId === 'string') {
            this.optimisticData = this.optimisticData.addLayer(optimisticId, perform);
            fromOptimisticTransaction = true;
        }
        else if (optimisticId === null) {
            perform(this.data);
        }
        else {
            perform();
        }
        this.broadcastWatches(fromOptimisticTransaction);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0,utilities/* addTypenameToDocument */.Gw)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function (fromOptimisticTransaction) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, fromOptimisticTransaction); });
        }
    };
    InMemoryCache.prototype.broadcastWatch = function (c, fromOptimisticTransaction) {
        this.watchDep.dirty(c);
        this.watchDep(c);
        var diff = this.diff({
            query: c.query,
            variables: c.variables,
            optimistic: c.optimistic,
        });
        if (c.optimistic && fromOptimisticTransaction) {
            diff.fromOptimisticTransaction = true;
        }
        c.callback(diff);
    };
    return InMemoryCache;
}(ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/index.js








//# sourceMappingURL=index.js.map

/***/ }),

/***/ 35367:
/***/ (function() {

;
;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 5870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; },
  "J": function() { return /* binding */ mergeOptions; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/index.js
var core = __webpack_require__(81707);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/version.js
var version = '3.3.15';
//# sourceMappingURL=version.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/index.js + 9 modules
var http = __webpack_require__(66414);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(21498);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js + 1 modules
var ObservableQuery = __webpack_require__(36268);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(85942);
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/index.js + 13 modules
var cache = __webpack_require__(39879);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/LocalState.js





var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,utilities/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,utilities/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if ((0,utilities/* hasDirectives */.FS)(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return (0,utilities/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache,
            getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,utilities/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = (0,utilities/* getMainDefinition */.p$)(document);
                fragments = (0,utilities/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,utilities/* createFragmentMap */.F)(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!(0,utilities/* shouldInclude */.LZ)(selection, variables)) {
                            return [2];
                        }
                        if ((0,utilities/* isField */.My)(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,utilities/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,utilities/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                             true ? (0,invariant_esm/* invariant */.kG)(fragment, 11) : 0;
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,utilities/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,utilities/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(cache.cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                (0,utilities/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryInfo.js



var destructiveMethodCounts = new (utilities/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
var QueryInfo = (function () {
    function QueryInfo(cache) {
        this.cache = cache;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.subscriptions = new Set();
        this.stopped = false;
        this.dirty = false;
        this.diff = null;
        this.observableQuery = null;
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.I.loading &&
            !(0,equality_esm/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.I.setVariables;
        }
        if (!(0,equality_esm/* equal */.D)(query.variables, this.variables)) {
            this.diff = null;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.diff = null;
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function (variables) {
        if (variables === void 0) { variables = this.variables; }
        if (this.diff && (0,equality_esm/* equal */.D)(variables, this.variables)) {
            return this.diff;
        }
        this.updateWatch(this.variables = variables);
        return this.diff = this.cache.diff({
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
        });
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.diff;
        this.diff = diff;
        if (!this.dirty &&
            (diff && diff.result) !== (oldDiff && oldDiff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function () {
                if (_this.getDiff().fromOptimisticTransaction) {
                    oq["observe"]();
                }
                else {
                    oq.reobserve();
                }
            });
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.O)(this.networkStatus) &&
            this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" &&
                fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            this.reset();
            this.cancel();
            delete this.cancel;
            this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        if (!this.lastWatch ||
            this.lastWatch.query !== this.document ||
            !(0,equality_esm/* equal */.D)(variables, this.lastWatch.variables)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = {
                query: this.document,
                variables: variables,
                optimistic: true,
                callback: function (diff) { return _this.setDiff(diff); },
            });
        }
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,equality_esm/* equal */.D)(variables, lastWrite.variables) &&
            (0,equality_esm/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, options, allowCacheWrite) {
        var _this = this;
        this.graphQLErrors = (0,utilities/* isNonEmptyArray */.Of)(result.errors) ? result.errors : [];
        this.reset();
        if (options.fetchPolicy === 'no-cache') {
            this.diff = { result: result.data, complete: true };
        }
        else if (!this.stopped && allowCacheWrite) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: _this.document,
                            data: result.data,
                            variables: options.variables,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        if (_this.diff && _this.diff.complete) {
                            result.data = _this.diff.result;
                            return;
                        }
                    }
                    var diff = cache.diff({
                        query: _this.document,
                        variables: options.variables,
                        returnPartialData: true,
                        optimistic: true,
                    });
                    if (!_this.stopped) {
                        _this.updateWatch(options.variables);
                    }
                    _this.diff = diff;
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return this.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.I.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" ||
        errorPolicy === "all";
    var writeWithErrors = !(0,utilities/* graphQLResultHasError */.d2)(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryManager.js










var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.clientAwareness = {};
        this.queries = new Map();
        this.fetchCancelFns = new Map();
        this.transformCache = new (utilities/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        this.inFlightLinkObservables = new Map();
        this.cache = cache;
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches( true ? new invariant_esm/* InvariantError */.ej(12) : 0);
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                         true ? (0,invariant_esm/* invariant */.kG)(mutation, 13) : 0;
                         true ? (0,invariant_esm/* invariant */.kG)(!fetchPolicy || fetchPolicy === 'no-cache', 14) : 0;
                        mutationId = this.generateMutationId();
                        mutation = this.transform(mutation).document;
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                errorPolicy: errorPolicy,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false).subscribe({
                                    next: function (result) {
                                        if ((0,utilities/* graphQLResultHasError */.d2)(result) && errorPolicy === 'none') {
                                            error = new errors/* ApolloError */.c({
                                                graphQLErrors: result.errors,
                                            });
                                            return;
                                        }
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = null;
                                        }
                                        if (fetchPolicy !== 'no-cache') {
                                            try {
                                                self.markMutationResult({
                                                    mutationId: mutationId,
                                                    result: result,
                                                    document: mutation,
                                                    variables: variables,
                                                    errorPolicy: errorPolicy,
                                                    updateQueries: updateQueries,
                                                    update: updateWithProxyFn,
                                                });
                                            }
                                            catch (e) {
                                                error = new errors/* ApolloError */.c({
                                                    networkError: e,
                                                });
                                                return;
                                            }
                                        }
                                        storeResult = result;
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(new errors/* ApolloError */.c({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (error && mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = error;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') {
                                            refetchQueries = refetchQueries(storeResult);
                                        }
                                        var refetchQueryPromises = [];
                                        if ((0,utilities/* isNonEmptyArray */.Of)(refetchQueries)) {
                                            refetchQueries.forEach(function (refetchQuery) {
                                                if (typeof refetchQuery === 'string') {
                                                    self.queries.forEach(function (_a) {
                                                        var observableQuery = _a.observableQuery;
                                                        if (observableQuery &&
                                                            observableQuery.hasObservers() &&
                                                            observableQuery.queryName === refetchQuery) {
                                                            refetchQueryPromises.push(observableQuery.refetch());
                                                        }
                                                    });
                                                }
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only',
                                                    };
                                                    if (refetchQuery.context) {
                                                        queryOptions.context = refetchQuery.context;
                                                    }
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                        }
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                            if (errorPolicy === 'ignore' &&
                                                storeResult &&
                                                (0,utilities/* graphQLResultHasError */.d2)(storeResult)) {
                                                delete storeResult.errors;
                                            }
                                            resolve(storeResult);
                                        }, reject);
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        if (shouldWriteResult(mutation.result, mutation.errorPolicy)) {
            var cacheWrites_1 = [{
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                }];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: document && (0,utilities/* getOperationName */.rY)(document) || void 0,
                            queryVariables: variables,
                        });
                        if (nextQueryResult) {
                            cacheWrites_1.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
            cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
                var update = mutation.update;
                if (update) {
                    update(c, mutation.result);
                }
            }, null);
        }
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function"
            ? optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                 true || 0;
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchQueryObservable(queryId, options, networkStatus).promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var transformed = this.cache.transformDocument(document);
            var forLink = (0,utilities/* removeConnectionDirectiveFromDocument */.Fo)(this.cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = forLink && this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0,utilities/* hasClientExports */.mj)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0,utilities/* getDefaultValues */.O4)((0,utilities/* getOperationDefinition */.$H)(transformed)),
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(options.query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this.cache);
        var observable = new ObservableQuery/* ObservableQuery */.u({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        this.queries.set(observable.queryId, queryInfo);
        queryInfo.init({
            document: options.query,
            observableQuery: observable,
            variables: options.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
         true ? (0,invariant_esm/* invariant */.kG)(options.query, 15) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(options.query.kind === 'Document', 16) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(!options.returnPartialData, 17) : 0;
         true ? (0,invariant_esm/* invariant */.kG)(!options.pollInterval, 18) : 0;
        var queryId = this.generateQueryId();
        return this.fetchQuery(queryId, options).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function () {
        this.cancelPendingFetches( true ? new invariant_esm/* InvariantError */.ej(19) : 0);
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        return this.cache.reset();
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery && observableQuery.hasObservers()) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' &&
                    (includeStandby || fetchPolicy !== 'standby')) {
                    observableQueryPromises.push(observableQuery.refetch());
                }
                _this.getQuery(queryId).setDiff(null);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, errorPolicy = _a.errorPolicy, variables = _a.variables, _b = _a.context, context = _b === void 0 ? {} : _b;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables, false).map(function (result) {
                if (fetchPolicy !== 'no-cache') {
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: 'ROOT_SUBSCRIPTION',
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                if ((0,utilities/* graphQLResultHasError */.d2)(result)) {
                    throw new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new utilities/* Observable */.y$(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchCancelFns.delete(queryId);
        this.getQuery(queryId).stop();
        this.queries.delete(queryId);
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _b = this, inFlightLinkObservables_1 = _b.inFlightLinkObservables, link = _b.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,utilities/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new utilities/* Concast */.X_([
                        (0,core.execute)(link, operation)
                    ]);
                    byVariables_1.set(varJson_1, observable = concast);
                    concast.cleanup(function () {
                        if (byVariables_1.delete(varJson_1) &&
                            byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(serverQuery);
                        }
                    });
                }
            }
            else {
                observable = new utilities/* Concast */.X_([
                    (0,core.execute)(link, operation)
                ]);
            }
        }
        else {
            observable = new utilities/* Concast */.X_([
                utilities/* Observable.of */.y$.of({ data: {} })
            ]);
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = (0,utilities/* asyncMap */.sz)(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, allowCacheWrite, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        return (0,utilities/* asyncMap */.sz)(this.getObservableFromLink(queryInfo.document, options.context, options.variables), function (result) {
            var hasErrors = (0,utilities/* isNonEmptyArray */.Of)(result.errors);
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    throw queryInfo.markError(new errors/* ApolloError */.c({
                        graphQLErrors: result.errors,
                    }));
                }
                queryInfo.markResult(result, options, allowCacheWrite);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: queryInfo.networkStatus || core_networkStatus/* NetworkStatus.ready */.I.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = result.errors;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,errors/* isApolloError */.M)(networkError)
                ? networkError
                : new errors/* ApolloError */.c({ networkError: networkError });
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.I.loading; }
        var query = this.transform(options.query).document;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var oldNetworkStatus = queryInfo.networkStatus;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var mightUseNetwork = fetchPolicy === "cache-first" ||
            fetchPolicy === "cache-and-network" ||
            fetchPolicy === "network-only" ||
            fetchPolicy === "no-cache";
        if (mightUseNetwork &&
            notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus)) {
            if (fetchPolicy !== "cache-first") {
                fetchPolicy = "cache-and-network";
            }
            returnPartialData = true;
        }
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            normalized.variables = variables;
            return _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
        };
        this.fetchCancelFns.set(queryId, function (reason) {
            Promise.resolve().then(function () { return concast.cancel(reason); });
        });
        var concast = new utilities/* Concast */.X_(this.transform(normalized.query).hasClientExports
            ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables)
            : fromVariables(normalized.variables));
        concast.cleanup(function () {
            _this.fetchCancelFns.delete(queryId);
            var nextFetchPolicy = options.nextFetchPolicy;
            if (nextFetchPolicy) {
                options.nextFetchPolicy = void 0;
                options.fetchPolicy = typeof nextFetchPolicy === "function"
                    ? nextFetchPolicy.call(options, options.fetchPolicy || "cache-first")
                    : nextFetchPolicy;
            }
        });
        return concast;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, options, networkStatus) {
        var _this = this;
        var query = options.query, variables = options.variables, fetchPolicy = options.fetchPolicy, errorPolicy = options.errorPolicy, returnPartialData = options.returnPartialData, context = options.context;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(variables); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.I.loading; }
            var data = diff.result;
            if (false) {}
            var fromData = function (data) { return utilities/* Observable.of */.y$.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true }))); };
            if (_this.transform(query).hasForcedResolvers) {
                return _this.localState.runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                }).then(function (resolved) { return fromData(resolved.data); });
            }
            return fromData(data);
        };
        var resultsFromLink = function (allowCacheWrite) {
            return _this.getResultsFromLink(queryInfo, allowCacheWrite, {
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
            });
        };
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return [
                        resultsFromCache(diff, queryInfo.markReady()),
                    ];
                }
                if (returnPartialData) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(true),
                    ];
                }
                return [
                    resultsFromLink(true),
                ];
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData) {
                    return [
                        resultsFromCache(diff),
                        resultsFromLink(true),
                    ];
                }
                return [
                    resultsFromLink(true),
                ];
            }
            case "cache-only":
                return [
                    resultsFromCache(readCache(), queryInfo.markReady()),
                ];
            case "network-only":
                return [resultsFromLink(true)];
            case "no-cache":
                return [resultsFromLink(false)];
            case "standby":
                return [];
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this.cache));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ApolloClient.js








var hasSuggestedDevtools = false;
function mergeOptions(defaults, options) {
    return (0,utilities/* compact */.oA)(defaults, options, options.variables && {
        variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaults.variables), options.variables),
    });
}
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, _c = options.connectToDevTools, connectToDevTools = _c === void 0 ? typeof window === 'object' &&
            !window.__APOLLO_CLIENT__ &&
            "production" !== 'production' : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? false : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link = uri
                ? new http/* HttpLink */.uG({ uri: uri, credentials: credentials, headers: headers })
                : core.ApolloLink.empty();
        }
        if (!cache) {
            throw  true ? new invariant_esm/* InvariantError */.ej(9) : 0;
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        if (connectToDevTools && typeof window === 'object') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && "production" !== 'production') { var url, ua, nav; }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.getQueryStore(),
                            mutations: _this.queryManager.mutationStore || {},
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            } : void 0,
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = mergeOptions(this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = mergeOptions(this.defaultOptions.query, options);
        }
         true ? (0,invariant_esm/* invariant */.kG)(options.fetchPolicy !== 'cache-and-network', 10) : 0;
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = mergeOptions(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.writeFragment = function (options) {
        this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return (0,core.execute)(this.link, payload);
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 36268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ObservableQuery; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(85942);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/Reobserver.js



var Reobserver = (function () {
    function Reobserver(observer, options, fetch, shouldFetch) {
        this.observer = observer;
        this.options = options;
        this.fetch = fetch;
        this.shouldFetch = shouldFetch;
    }
    Reobserver.prototype.reobserve = function (newOptions, newNetworkStatus) {
        if (newOptions) {
            this.updateOptions(newOptions);
        }
        else {
            this.updatePolling();
        }
        var concast = this.fetch(this.options, newNetworkStatus);
        if (this.concast) {
            this.concast.removeObserver(this.observer, true);
        }
        concast.addObserver(this.observer);
        return (this.concast = concast).promise;
    };
    Reobserver.prototype.updateOptions = function (newOptions) {
        Object.assign(this.options, (0,utilities/* compact */.oA)(newOptions));
        this.updatePolling();
        return this;
    };
    Reobserver.prototype.stop = function () {
        if (this.concast) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
        }
        if (this.pollingInfo) {
            clearTimeout(this.pollingInfo.timeout);
            this.options.pollInterval = 0;
            this.updatePolling();
        }
    };
    Reobserver.prototype.updatePolling = function () {
        var _this = this;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo &&
            pollingInfo.interval === pollInterval) {
            return;
        }
         true ? (0,invariant_esm/* invariant */.kG)(pollInterval, 20) : 0;
        if (this.shouldFetch === false) {
            return;
        }
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (_this.shouldFetch && _this.shouldFetch()) {
                    _this.reobserve({
                        fetchPolicy: "network-only",
                        nextFetchPolicy: _this.options.fetchPolicy || "cache-first",
                    }, core_networkStatus/* NetworkStatus.poll */.I.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
            ;
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    return Reobserver;
}());

//# sourceMappingURL=Reobserver.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js






var warnedAboutUpdateQuery = false;
var ObservableQuery = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.observer = {
            next: function (result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    _this.updateLastResult(result);
                    (0,utilities/* iterateObserversSafely */.pM)(_this.observers, 'next', result);
                }
            },
            error: function (error) {
                _this.updateLastResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, _this.lastResult), { error: error, errors: error.graphQLErrors, networkStatus: core_networkStatus/* NetworkStatus.error */.I.error, loading: false }));
                (0,utilities/* iterateObserversSafely */.pM)(_this.observers, 'error', _this.lastError = error);
            },
        };
        _this.isTornDown = false;
        _this.options = options;
        _this.queryId = queryManager.generateQueryId();
        var opDef = (0,utilities/* getOperationDefinition */.$H)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        _this.queryInfo = queryInfo;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        var lastResult = this.lastResult;
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            core_networkStatus/* NetworkStatus.ready */.I.ready;
        var result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, lastResult), { loading: (0,core_networkStatus/* isNetworkRequestInFlight */.O)(networkStatus), networkStatus: networkStatus });
        if (this.isTornDown) {
            return result;
        }
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        if (fetchPolicy === 'no-cache' ||
            fetchPolicy === 'network-only') {
            delete result.partial;
        }
        else if (!result.data ||
            !this.queryManager.transform(this.options.query).hasForcedResolvers) {
            var diff = this.queryInfo.getDiff();
            result.data = (diff.complete ||
                this.options.returnPartialData) ? diff.result : void 0;
            if (diff.complete) {
                if (result.networkStatus === core_networkStatus/* NetworkStatus.loading */.I.loading &&
                    (fetchPolicy === 'cache-first' ||
                        fetchPolicy === 'cache-only')) {
                    result.networkStatus = core_networkStatus/* NetworkStatus.ready */.I.ready;
                    result.loading = false;
                }
                delete result.partial;
            }
            else {
                result.partial = true;
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        return !(0,equality_esm/* equal */.D)(this.lastResultSnapshot, newResult);
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var reobserveOptions = {
            pollInterval: 0,
        };
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'cache-and-network') {
            reobserveOptions.fetchPolicy = 'network-only';
            reobserveOptions.nextFetchPolicy = fetchPolicy || "cache-first";
        }
        if (variables && !(0,equality_esm/* equal */.D)(this.options.variables, variables)) {
            reobserveOptions.variables = this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), variables);
        }
        return this.newReobserver(false).reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.refetch */.I.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), fetchMoreOptions.variables) }))), { fetchPolicy: "no-cache" });
        var qid = this.queryManager.generateQueryId();
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.queryInfo.networkStatus = core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore;
            this.observe();
        }
        return this.queryManager.fetchQuery(qid, combinedOptions, core_networkStatus/* NetworkStatus.fetchMore */.I.fetchMore).then(function (fetchMoreResult) {
            var data = fetchMoreResult.data;
            var updateQuery = fetchMoreOptions.updateQuery;
            if (updateQuery) {
                if (false) {}
                _this.updateQuery(function (previous) { return updateQuery(previous, {
                    fetchMoreResult: data,
                    variables: combinedOptions.variables,
                }); });
            }
            else {
                _this.queryManager.cache.writeQuery({
                    query: combinedOptions.query,
                    variables: combinedOptions.variables,
                    data: data,
                });
            }
            return fetchMoreResult;
        }).finally(function () {
            _this.queryManager.stopQuery(qid);
            _this.reobserve();
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                 true || 0;
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,equality_esm/* equal */.D)(this.variables, variables)) {
            return this.observers.size
                ? this.result()
                : Promise.resolve();
        }
        this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? 'cache-first' : _a;
        var reobserveOptions = {
            fetchPolicy: fetchPolicy,
            variables: variables,
        };
        if (fetchPolicy !== 'cache-first' &&
            fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'network-only') {
            reobserveOptions.fetchPolicy = 'cache-and-network';
            reobserveOptions.nextFetchPolicy = fetchPolicy;
        }
        return this.reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.setVariables */.I.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a;
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            previousResult: (_a = this.lastResult) === null || _a === void 0 ? void 0 : _a.data,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.getReobserver().updateOptions({ pollInterval: pollInterval });
    };
    ObservableQuery.prototype.stopPolling = function () {
        if (this.reobserver) {
            this.reobserver.updateOptions({ pollInterval: 0 });
        }
    };
    ObservableQuery.prototype.updateLastResult = function (newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults
            ? newResult
            : (0,utilities/* cloneDeep */.Xh)(newResult);
        if (!(0,utilities/* isNonEmptyArray */.Of)(newResult.errors)) {
            delete this.lastError;
        }
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        if (observer === this.observer) {
            return function () { };
        }
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) {
                subObserver.error = defaultSubscriptionObserverErrorCallback;
            }
        }
        catch (_a) { }
        var first = !this.observers.size;
        this.observers.add(observer);
        if (this.lastError) {
            observer.error && observer.error(this.lastError);
        }
        else if (this.lastResult) {
            observer.next && observer.next(this.lastResult);
        }
        if (first) {
            this.reobserve().catch(function (_) {
            });
        }
        return function () {
            if (_this.observers.delete(observer) && !_this.observers.size) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.getReobserver = function () {
        return this.reobserver || (this.reobserver = this.newReobserver(true));
    };
    ObservableQuery.prototype.newReobserver = function (shareOptions) {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        queryManager.setObservableQuery(this);
        return new Reobserver(this.observer, shareOptions ? this.options : (0,tslib_es6/* __assign */.pi)({}, this.options), function (currentOptions, newNetworkStatus) {
            queryManager.setObservableQuery(_this);
            return queryManager.fetchQueryObservable(queryId, currentOptions, newNetworkStatus);
        }, !queryManager.ssrMode && (function () { return !(0,core_networkStatus/* isNetworkRequestInFlight */.O)(_this.queryInfo.networkStatus); }));
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        this.isTornDown = false;
        return this.getReobserver().reobserve(newOptions, newNetworkStatus);
    };
    ObservableQuery.prototype.observe = function () {
        this.observer.next(this.getCurrentResult(false));
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.reobserver) {
            this.reobserver.stop();
            delete this.reobserver;
        }
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    return ObservableQuery;
}(utilities/* Observable */.y$));

(0,utilities/* fixObservableSubclass */.Dy)(ObservableQuery);
function defaultSubscriptionObserverErrorCallback(error) {
     true || 0;
}
//# sourceMappingURL=ObservableQuery.js.map

/***/ }),

/***/ 71439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ApolloClient": function() { return /* reexport safe */ _ApolloClient_js__WEBPACK_IMPORTED_MODULE_0__.f; },
/* harmony export */   "ApolloError": function() { return /* reexport safe */ _errors_index_js__WEBPACK_IMPORTED_MODULE_4__.c; },
/* harmony export */   "ApolloLink": function() { return /* reexport safe */ _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.ApolloLink; },
/* harmony export */   "HttpLink": function() { return /* reexport safe */ _link_http_index_js__WEBPACK_IMPORTED_MODULE_8__.uG; },
/* harmony export */   "InMemoryCache": function() { return /* reexport safe */ _cache_index_js__WEBPACK_IMPORTED_MODULE_5__.InMemoryCache; },
/* harmony export */   "NetworkStatus": function() { return /* reexport safe */ _networkStatus_js__WEBPACK_IMPORTED_MODULE_2__.I; },
/* harmony export */   "createHttpLink": function() { return /* reexport safe */ _link_http_index_js__WEBPACK_IMPORTED_MODULE_8__.LQ; },
/* harmony export */   "from": function() { return /* reexport safe */ _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.from; },
/* harmony export */   "gql": function() { return /* reexport safe */ graphql_tag__WEBPACK_IMPORTED_MODULE_12__.ZP; },
/* harmony export */   "makeVar": function() { return /* reexport safe */ _cache_index_js__WEBPACK_IMPORTED_MODULE_5__.makeVar; },
/* harmony export */   "mergeOptions": function() { return /* reexport safe */ _ApolloClient_js__WEBPACK_IMPORTED_MODULE_0__.J; }
/* harmony export */ });
/* unused harmony exports resetCaches, disableFragmentWarnings, enableExperimentalFragmentVariables, disableExperimentalFragmentVariables */
/* harmony import */ var _ApolloClient_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5870);
/* harmony import */ var _ObservableQuery_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36268);
/* harmony import */ var _networkStatus_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85942);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72191);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_types_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "ApolloLink")) __webpack_require__.d(__webpack_exports__, { "ApolloLink": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.ApolloLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "HttpLink")) __webpack_require__.d(__webpack_exports__, { "HttpLink": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.HttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "createHttpLink")) __webpack_require__.d(__webpack_exports__, { "createHttpLink": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.createHttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "from")) __webpack_require__.d(__webpack_exports__, { "from": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.from; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "useApolloClient")) __webpack_require__.d(__webpack_exports__, { "useApolloClient": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.useApolloClient; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "useLazyQuery")) __webpack_require__.d(__webpack_exports__, { "useLazyQuery": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.useLazyQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_3__, "useSubscription")) __webpack_require__.d(__webpack_exports__, { "useSubscription": function() { return _types_js__WEBPACK_IMPORTED_MODULE_3__.useSubscription; } });
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21498);
/* harmony import */ var _cache_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39879);
/* harmony import */ var _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35367);
/* harmony import */ var _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "ApolloLink")) __webpack_require__.d(__webpack_exports__, { "ApolloLink": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.ApolloLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "HttpLink")) __webpack_require__.d(__webpack_exports__, { "HttpLink": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.HttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "createHttpLink")) __webpack_require__.d(__webpack_exports__, { "createHttpLink": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.createHttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "from")) __webpack_require__.d(__webpack_exports__, { "from": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.from; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "useApolloClient")) __webpack_require__.d(__webpack_exports__, { "useApolloClient": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.useApolloClient; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "useLazyQuery")) __webpack_require__.d(__webpack_exports__, { "useLazyQuery": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.useLazyQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__, "useSubscription")) __webpack_require__.d(__webpack_exports__, { "useSubscription": function() { return _cache_inmemory_types_js__WEBPACK_IMPORTED_MODULE_6__.useSubscription; } });
/* harmony import */ var _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81707);
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "HttpLink")) __webpack_require__.d(__webpack_exports__, { "HttpLink": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.HttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "createHttpLink")) __webpack_require__.d(__webpack_exports__, { "createHttpLink": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.createHttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "useApolloClient")) __webpack_require__.d(__webpack_exports__, { "useApolloClient": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.useApolloClient; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "useLazyQuery")) __webpack_require__.d(__webpack_exports__, { "useLazyQuery": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.useLazyQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_link_core_index_js__WEBPACK_IMPORTED_MODULE_7__, "useSubscription")) __webpack_require__.d(__webpack_exports__, { "useSubscription": function() { return _link_core_index_js__WEBPACK_IMPORTED_MODULE_7__.useSubscription; } });
/* harmony import */ var _link_http_index_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66414);
/* harmony import */ var _link_utils_index_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26822);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94248);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10212);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80133);













(0,ts_invariant__WEBPACK_IMPORTED_MODULE_11__/* .setVerbosity */ .U6)("log");

var resetCaches = graphql_tag__WEBPACK_IMPORTED_MODULE_12__/* ["default"].resetCaches */ .ZP.resetCaches, disableFragmentWarnings = graphql_tag__WEBPACK_IMPORTED_MODULE_12__/* ["default"].disableFragmentWarnings */ .ZP.disableFragmentWarnings, enableExperimentalFragmentVariables = graphql_tag__WEBPACK_IMPORTED_MODULE_12__/* ["default"].enableExperimentalFragmentVariables */ .ZP.enableExperimentalFragmentVariables, disableExperimentalFragmentVariables = graphql_tag__WEBPACK_IMPORTED_MODULE_12__/* ["default"].disableExperimentalFragmentVariables */ .ZP.disableExperimentalFragmentVariables;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 85942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "O": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 72191:
/***/ (function() {

//# sourceMappingURL=types.js.map

/***/ }),

/***/ 21498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ isApolloError; },
/* harmony export */   "c": function() { return /* binding */ ApolloError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23564);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94248);


function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonEmptyArray */ .Of)(err.graphQLErrors)) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += err.networkError.message + "\n";
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .ZT)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HttpLink": function() { return /* reexport safe */ _core_index_js__WEBPACK_IMPORTED_MODULE_0__.HttpLink; },
/* harmony export */   "gql": function() { return /* reexport safe */ _core_index_js__WEBPACK_IMPORTED_MODULE_0__.gql; },
/* harmony export */   "useApolloClient": function() { return /* reexport safe */ _react_index_js__WEBPACK_IMPORTED_MODULE_1__.useApolloClient; },
/* harmony export */   "useLazyQuery": function() { return /* reexport safe */ _react_index_js__WEBPACK_IMPORTED_MODULE_1__.useLazyQuery; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _react_index_js__WEBPACK_IMPORTED_MODULE_1__.useMutation; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _react_index_js__WEBPACK_IMPORTED_MODULE_1__.useQuery; },
/* harmony export */   "useSubscription": function() { return /* reexport safe */ _react_index_js__WEBPACK_IMPORTED_MODULE_1__.useSubscription; }
/* harmony export */ });
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71439);
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "ApolloLink")) __webpack_require__.d(__webpack_exports__, { "ApolloLink": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.ApolloLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "from")) __webpack_require__.d(__webpack_exports__, { "from": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.from; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "useApolloClient")) __webpack_require__.d(__webpack_exports__, { "useApolloClient": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.useApolloClient; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "useLazyQuery")) __webpack_require__.d(__webpack_exports__, { "useLazyQuery": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.useLazyQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_core_index_js__WEBPACK_IMPORTED_MODULE_0__, "useSubscription")) __webpack_require__.d(__webpack_exports__, { "useSubscription": function() { return _core_index_js__WEBPACK_IMPORTED_MODULE_0__.useSubscription; } });
/* harmony import */ var _react_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63341);
/* harmony reexport (checked) */ if(__webpack_require__.o(_react_index_js__WEBPACK_IMPORTED_MODULE_1__, "ApolloLink")) __webpack_require__.d(__webpack_exports__, { "ApolloLink": function() { return _react_index_js__WEBPACK_IMPORTED_MODULE_1__.ApolloLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_react_index_js__WEBPACK_IMPORTED_MODULE_1__, "from")) __webpack_require__.d(__webpack_exports__, { "from": function() { return _react_index_js__WEBPACK_IMPORTED_MODULE_1__.from; } });


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 97222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ApolloLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23564);
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10212);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94248);
/* harmony import */ var _utils_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26822);




function passthrough(op, forward) {
    return (forward ? forward(op) : _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of());
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var LinkError = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .ZT)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation)
                    ? leftLink.request(operation) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of()
                    : rightLink.request(operation) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation)
                    ? leftLink.request(operation, forward) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of()
                    : rightLink.request(operation, forward) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request((0,_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .createOperation */ .zi)(operation.context, (0,_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .transformOperation */ .DQ)((0,_utils_index_js__WEBPACK_IMPORTED_MODULE_2__/* .validateOperation */ .Ak)(operation)))) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
             true || 0;
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of(); }) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of();
                }) || _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable.of */ .y$.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new ts_invariant__WEBPACK_IMPORTED_MODULE_0__/* .InvariantError */ .ej(21) : 0;
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            return false;
        }
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 24957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concat */
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97222);

var concat = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.concat */ .i.concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ 67325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export empty */
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97222);

var empty = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.empty */ .i.empty;
//# sourceMappingURL=empty.js.map

/***/ }),

/***/ 2550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ execute; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97222);

var execute = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.execute */ .i.execute;
//# sourceMappingURL=execute.js.map

/***/ }),

/***/ 34674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ from; }
/* harmony export */ });
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97222);

var from = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.from */ .i.from;
//# sourceMappingURL=from.js.map

/***/ }),

/***/ 81707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ApolloLink": function() { return /* reexport safe */ _ApolloLink_js__WEBPACK_IMPORTED_MODULE_5__.i; },
/* harmony export */   "execute": function() { return /* reexport safe */ _execute_js__WEBPACK_IMPORTED_MODULE_4__.h; },
/* harmony export */   "from": function() { return /* reexport safe */ _from_js__WEBPACK_IMPORTED_MODULE_1__.D; }
/* harmony export */ });
/* harmony import */ var _empty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67325);
/* harmony import */ var _from_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34674);
/* harmony import */ var _split_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64738);
/* harmony import */ var _concat_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24957);
/* harmony import */ var _execute_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2550);
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97222);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79875);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_types_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "HttpLink")) __webpack_require__.d(__webpack_exports__, { "HttpLink": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.HttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "createHttpLink")) __webpack_require__.d(__webpack_exports__, { "createHttpLink": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.createHttpLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "useApolloClient")) __webpack_require__.d(__webpack_exports__, { "useApolloClient": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.useApolloClient; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "useLazyQuery")) __webpack_require__.d(__webpack_exports__, { "useLazyQuery": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.useLazyQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "useMutation")) __webpack_require__.d(__webpack_exports__, { "useMutation": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.useMutation; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "useQuery")) __webpack_require__.d(__webpack_exports__, { "useQuery": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.useQuery; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_js__WEBPACK_IMPORTED_MODULE_6__, "useSubscription")) __webpack_require__.d(__webpack_exports__, { "useSubscription": function() { return _types_js__WEBPACK_IMPORTED_MODULE_6__.useSubscription; } });







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 64738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export split */
/* harmony import */ var _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97222);

var split = _ApolloLink_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink.split */ .i.split;
//# sourceMappingURL=split.js.map

/***/ }),

/***/ 79875:
/***/ (function() {

;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 13984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ onError; }
/* harmony export */ });
/* unused harmony export ErrorLink */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23564);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81707);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94248);



function onError(errorHandler) {
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_0__.ApolloLink(function (operation, forward) {
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y$(function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
var ErrorLink = (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .ZT)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_0__.ApolloLink));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uG": function() { return /* reexport */ HttpLink; },
  "LQ": function() { return /* reexport */ createHttpLink; }
});

// UNUSED EXPORTS: checkFetcher, createSignalIfSupported, fallbackHttpConfig, parseAndCheckHttpResponse, rewriteURIForGET, selectHttpOptionsAndBody, selectURI, serializeFetchParameter

// EXTERNAL MODULE: ./node_modules/@apollo/client/link/utils/index.js + 7 modules
var utils = __webpack_require__(26822);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js

var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function parseAndCheckHttpResponse(operations) {
    return function (response) { return response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            throw parseError;
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            (0,utils/* throwServerError */.PW)(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !parseAndCheckHttpResponse_hasOwnProperty.call(result, 'data') &&
            !parseAndCheckHttpResponse_hasOwnProperty.call(result, 'errors')) {
            (0,utils/* throwServerError */.PW)(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }); };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/serializeFetchParameter.js

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError =  true ? new invariant_esm/* InvariantError */.ej(23) : 0;
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/graphql/language/printer.mjs
var printer = __webpack_require__(39011);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fallbackConfig.options), { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http || {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = (0,printer/* print */.S)(query);
    return {
        options: options,
        body: body,
    };
};
//# sourceMappingURL=selectHttpOptionsAndBody.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/checkFetcher.js

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        throw  true ? new invariant_esm/* InvariantError */.ej(22) : 0;
    }
};
//# sourceMappingURL=checkFetcher.js.map
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/index.js
var core = __webpack_require__(81707);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectURI.js
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};
//# sourceMappingURL=selectURI.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/createSignalIfSupported.js
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/rewriteURIForGET.js

function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js












var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, _b = linkOptions.includeUnusedVariables, includeUnusedVariables = _b === void 0 ? false : _b, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries", "includeUnusedVariables"]);
    checkFetcher(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new core.ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            var unusedNames_1 = new Set(Object.keys(body.variables));
            (0,visitor/* visit */.Vn)(operation.query, {
                Variable: function (node, _key, parent) {
                    if (parent && parent.kind !== 'VariableDefinition') {
                        unusedNames_1.delete(node.name.value);
                    }
                },
            });
            if (unusedNames_1.size) {
                body.variables = (0,tslib_es6/* __assign */.pi)({}, body.variables);
                unusedNames_1.forEach(function (name) {
                    delete body.variables[name];
                });
            }
        }
        var controller;
        if (!options.signal) {
            var _c = createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return (0,utils/* fromError */.Qc)(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return (0,utils/* fromError */.Qc)(parseError);
            }
        }
        return new utilities/* Observable */.y$(function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/HttpLink.js



var HttpLink = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(core.ApolloLink));

//# sourceMappingURL=HttpLink.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/index.js









//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zi": function() { return /* reexport */ createOperation; },
  "Qc": function() { return /* reexport */ fromError; },
  "PW": function() { return /* reexport */ throwServerError; },
  "DQ": function() { return /* reexport */ transformOperation; },
  "Ak": function() { return /* reexport */ validateOperation; }
});

// UNUSED EXPORTS: fromPromise, toPromise

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/fromError.js

function fromError(errorValue) {
    return new utilities/* Observable */.y$(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/toPromise.js

function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                     true || 0;
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
//# sourceMappingURL=toPromise.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/fromPromise.js

function fromPromise(promise) {
    return new Observable(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
//# sourceMappingURL=fromPromise.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new invariant_esm/* InvariantError */.ej(26) : 0;
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? (0,utilities/* getOperationName */.rY)(transformedOperation.query) || undefined
                : '';
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/index.js







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 80133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; }
});

// UNUSED EXPORTS: disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, gql, resetCaches

;// CONCATENATED MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ./node_modules/graphql/language/parser.mjs + 12 modules
var parser = __webpack_require__(16297);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign(__assign({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,parser/* parse */.Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 23564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; },
/* harmony export */   "pr": function() { return /* binding */ __spreadArrays; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __createBinding, __exportStar, __values, __read, __spread, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 30811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "KZ": function() { return /* reexport */ ApolloContext_getApolloContext; }
});

// UNUSED EXPORTS: ApolloConsumer, ApolloProvider, resetApolloContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js


var cache = new (utilities/* canUseWeakMap */.mr ? WeakMap : Map)();
function ApolloContext_getApolloContext() {
    var context = cache.get(react.createContext);
    if (!context) {
        context = react.createContext({});
        context.displayName = 'ApolloContext';
        cache.set(react.createContext, context);
    }
    return context;
}

//# sourceMappingURL=ApolloContext.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloConsumer.js



var ApolloConsumer = function (props) {
    var ApolloContext = getApolloContext();
    return React.createElement(ApolloContext.Consumer, null, function (context) {
         true ? invariant(context && context.client, 27) : 0;
        return props.children(context.client);
    });
};
//# sourceMappingURL=ApolloConsumer.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js



var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = getApolloContext();
    return React.createElement(ApolloContext.Consumer, null, function (context) {
        if (context === void 0) { context = {}; }
        if (client && context.client !== client) {
            context = Object.assign({}, context, { client: client });
        }
         true ? invariant(context.client, 28) : 0;
        return (React.createElement(ApolloContext.Provider, { value: context }, children));
    });
};
//# sourceMappingURL=ApolloProvider.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xJ": function() { return /* reexport */ useApolloClient; },
  "td": function() { return /* reexport */ useLazyQuery; },
  "Db": function() { return /* reexport */ useMutation; },
  "aM": function() { return /* reexport */ useQuery; },
  "mU": function() { return /* reexport */ useSubscription; }
});

// UNUSED EXPORTS: useReactiveVar

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/index.js + 3 modules
var react_context = __webpack_require__(30811);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js



function useApolloClient() {
    var client = react.useContext((0,react_context/* getApolloContext */.KZ)()).client;
     true ? (0,invariant_esm/* invariant */.kG)(client, 33) : 0;
    return client;
}
//# sourceMappingURL=useApolloClient.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/equality.esm.js
var equality_esm = __webpack_require__(82152);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(94901);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/data/OperationData.js



var OperationData = (function () {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function () {
        return this.options;
    };
    OperationData.prototype.setOptions = function (newOptions, storePrevious) {
        if (storePrevious === void 0) { storePrevious = false; }
        if (storePrevious && !(0,equality_esm/* equal */.D)(this.options, newOptions)) {
            this.previousOptions = this.options;
        }
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function () {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function () {
        var client = (this.options && this.options.client) ||
            (this.context && this.context.client);
         true ? (0,invariant_esm/* invariant */.kG)(!!client, 29) : 0;
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function (document, type) {
        var operation = (0,parser/* parser */.E2)(document);
        var requiredOperationName = (0,parser/* operationName */.mw)(type);
        var usedOperationName = (0,parser/* operationName */.mw)(operation.type);
         true ? (0,invariant_esm/* invariant */.kG)(operation.type === type, 30) : 0;
    };
    return OperationData;
}());

//# sourceMappingURL=OperationData.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/data/SubscriptionData.js



var SubscriptionData = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function (result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) {
            currentResult = this.getLoadingResult();
        }
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') {
            shouldResubscribe = !!shouldResubscribe(this.getOptions());
        }
        if (shouldResubscribe !== false &&
            this.previousOptions &&
            Object.keys(this.previousOptions).length > 0 &&
            (this.previousOptions.subscription !== this.getOptions().subscription ||
                !(0,equality_esm/* equal */.D)(this.previousOptions.variables, this.getOptions().variables) ||
                this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, currentResult), { variables: this.getOptions().variables });
    };
    SubscriptionData.prototype.afterExecute = function () {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function () {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function (options) {
        if (this.currentObservable.query || this.getOptions().skip === true)
            return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy,
            context: options.context,
        });
    };
    SubscriptionData.prototype.startSubscription = function () {
        if (this.currentObservable.subscription)
            return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function () {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function (result) {
        if (this.isMounted) {
            this.setResult(result);
        }
    };
    SubscriptionData.prototype.updateCurrentData = function (result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) {
            onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        }
    };
    SubscriptionData.prototype.updateError = function (error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function () {
        var _this = this;
        Promise.resolve().then(function () {
            var onSubscriptionComplete = _this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete)
                onSubscriptionComplete();
            _this.endSubscription();
        });
    };
    SubscriptionData.prototype.endSubscription = function () {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}(OperationData));

//# sourceMappingURL=SubscriptionData.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(21498);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/data/MutationData.js






var MutationData = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function (mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) { mutationFunctionOptions = {}; }
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions)
                .then(function (response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            })
                .catch(function (error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError)
                    throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, parser/* DocumentType.Mutation */.n_.Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function (result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, parser/* DocumentType.Mutation */.n_.Mutation);
        return [
            this.runMutation,
            (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { client: this.refreshClient().client })
        ];
    };
    MutationData.prototype.afterExecute = function () {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function () {
    };
    MutationData.prototype.mutate = function (options) {
        return this.refreshClient().client.mutate((0,core.mergeOptions)(this.getOptions(), options));
    };
    MutationData.prototype.onMutationStart = function () {
        if (!this.result.loading && !this.getOptions().ignoreResults) {
            this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        }
    };
    MutationData.prototype.onMutationCompleted = function (response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0
            ? new client_errors/* ApolloError */.c({ graphQLErrors: errors })
            : undefined;
        var callOncomplete = function () {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) {
            this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
        }
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function (error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) {
            this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
        }
        if (onError) {
            onError(error);
        }
    };
    MutationData.prototype.generateNewMutationId = function () {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function (mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function (result) {
        if (this.isMounted &&
            (!this.previousResult || !(0,equality_esm/* equal */.D)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}(OperationData));

//# sourceMappingURL=MutationData.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/data/QueryData.js






var QueryData = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.runLazy = false;
        _this.previous = Object.create(null);
        _this.runLazyQuery = function (options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getQueryResult = function () {
            var result = _this.observableQueryFields();
            var options = _this.getOptions();
            if (options.skip) {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: undefined, error: undefined, loading: false, networkStatus: core.NetworkStatus.ready, called: true });
            }
            else if (_this.currentObservable) {
                var currentResult = _this.currentObservable.getCurrentResult();
                var data = currentResult.data, loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) {
                    error = new client_errors/* ApolloError */.c({ graphQLErrors: errors });
                }
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: data,
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error, called: true });
                if (loading) {
                }
                else if (error) {
                    Object.assign(result, {
                        data: (_this.currentObservable.getLastResult() || {})
                            .data
                    });
                }
                else {
                    var fetchPolicy = _this.currentObservable.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch &&
                        partial &&
                        (!data || Object.keys(data).length === 0) &&
                        fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: core.NetworkStatus.loading
                        });
                        result.refetch();
                        return result;
                    }
                }
            }
            result.client = _this.client;
            _this.setOptions(options, true);
            var previousResult = _this.previous.result;
            _this.previous.loading =
                previousResult && previousResult.loading || false;
            result.previousData = previousResult &&
                (previousResult.data || previousResult.previousData);
            _this.previous.result = result;
            _this.currentObservable && _this.currentObservable.resetQueryStoreErrors();
            return result;
        };
        _this.obsRefetch = function (variables) { var _a; return (_a = _this.currentObservable) === null || _a === void 0 ? void 0 : _a.refetch(variables); };
        _this.obsFetchMore = function (fetchMoreOptions) { return _this.currentObservable.fetchMore(fetchMoreOptions); };
        _this.obsUpdateQuery = function (mapFn) { return _this.currentObservable.updateQuery(mapFn); };
        _this.obsStartPolling = function (pollInterval) {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 ? void 0 : _a.startPolling(pollInterval);
        };
        _this.obsStopPolling = function () {
            var _a;
            (_a = _this.currentObservable) === null || _a === void 0 ? void 0 : _a.stopPolling();
        };
        _this.obsSubscribeToMore = function (options) { return _this.currentObservable.subscribeToMore(options); };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function () {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previous.query) {
            this.removeQuerySubscription();
            this.removeObservable(!skip);
            this.previous.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted)
            this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function () {
        return !this.runLazy
            ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: core.NetworkStatus.ready,
                    called: false,
                    data: undefined
                }
            ]
            : [this.runLazyQuery, this.execute()];
    };
    QueryData.prototype.fetchData = function () {
        var _this = this;
        var options = this.getOptions();
        if (options.skip || options.ssr === false)
            return false;
        return new Promise(function (resolve) { return _this.startQuerySubscription(resolve); });
    };
    QueryData.prototype.afterExecute = function (_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function () {
        this.removeQuerySubscription();
        this.removeObservable(true);
        delete this.previous.result;
    };
    QueryData.prototype.getOptions = function () {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.variables), this.lazyOptions.variables);
            options.context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) {
            delete options.skip;
        }
        return options;
    };
    QueryData.prototype.ssrInitiated = function () {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteResult = function () {
        var result = this.getQueryResult();
        this.startQuerySubscription();
        return result;
    };
    ;
    QueryData.prototype.getExecuteSsrResult = function () {
        var _a = this.getOptions(), ssr = _a.ssr, skip = _a.skip;
        var ssrDisabled = ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0,tslib_es6/* __assign */.pi)({ loading: true, networkStatus: core.NetworkStatus.loading, called: true, data: undefined, stale: false, client: this.client }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previous.result = ssrLoading;
            return ssrLoading;
        }
        if (this.ssrInitiated()) {
            var result = this.getQueryResult() || ssrLoading;
            if (result.loading && !skip) {
                this.context.renderPromises.addQueryPromise(this, function () { return null; });
            }
            return result;
        }
    };
    QueryData.prototype.prepareObservableQueryOptions = function () {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, parser/* DocumentType.Query */.n_.Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options.fetchPolicy = 'cache-first';
        }
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { displayName: displayName, context: options.context });
    };
    QueryData.prototype.initializeObservableQuery = function () {
        if (this.ssrInitiated()) {
            this.currentObservable = this.context.renderPromises.getSSRObservable(this.getOptions());
        }
        if (!this.currentObservable) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previous.observableQueryOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, observableQueryOptions), { children: null });
            this.currentObservable = this.refreshClient().client.watchQuery((0,tslib_es6/* __assign */.pi)({}, observableQueryOptions));
            if (this.ssrInitiated()) {
                this.context.renderPromises.registerSSRObservable(this.currentObservable, observableQueryOptions);
            }
        }
    };
    QueryData.prototype.updateObservableQuery = function () {
        if (!this.currentObservable) {
            this.initializeObservableQuery();
            return;
        }
        if (this.getOptions().skip)
            return;
        var newObservableQueryOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.prepareObservableQueryOptions()), { children: null });
        if (!(0,equality_esm/* equal */.D)(newObservableQueryOptions, this.previous.observableQueryOptions)) {
            this.previous.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable
                .setOptions(newObservableQueryOptions)
                .catch(function () { });
        }
    };
    QueryData.prototype.startQuerySubscription = function (onNewData) {
        var _this = this;
        if (onNewData === void 0) { onNewData = this.onNewData; }
        if (this.currentSubscription || this.getOptions().skip)
            return;
        this.currentSubscription = this.currentObservable.subscribe({
            next: function (_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previous.result;
                if (previousResult &&
                    previousResult.loading === loading &&
                    previousResult.networkStatus === networkStatus &&
                    (0,equality_esm/* equal */.D)(previousResult.data, data)) {
                    return;
                }
                onNewData();
            },
            error: function (error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors'))
                    throw error;
                var previousResult = _this.previous.result;
                if ((previousResult && previousResult.loading) ||
                    !(0,equality_esm/* equal */.D)(error, _this.previous.error)) {
                    _this.previous.error = error;
                    onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function () {
        this.removeQuerySubscription();
        var currentObservable = this.currentObservable;
        if (currentObservable) {
            var lastError = currentObservable.getLastError();
            var lastResult = currentObservable.getLastResult();
            currentObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(currentObservable, {
                lastError: lastError,
                lastResult: lastResult
            });
        }
    };
    QueryData.prototype.handleErrorOrCompleted = function () {
        if (!this.currentObservable || !this.previous.result)
            return;
        var _a = this.previous.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError, skip = _b.skip;
            if (this.previousOptions &&
                !this.previous.loading &&
                (0,equality_esm/* equal */.D)(this.previousOptions.query, query) &&
                (0,equality_esm/* equal */.D)(this.previousOptions.variables, variables)) {
                return;
            }
            if (onCompleted && !error && !skip) {
                onCompleted(data);
            }
            else if (onError && error) {
                onError(error);
            }
        }
    };
    QueryData.prototype.removeQuerySubscription = function () {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
            delete this.currentSubscription;
        }
    };
    QueryData.prototype.removeObservable = function (andDelete) {
        if (this.currentObservable) {
            this.currentObservable["tearDownQuery"]();
            if (andDelete) {
                delete this.currentObservable;
            }
        }
    };
    QueryData.prototype.observableQueryFields = function () {
        var _a;
        return {
            variables: (_a = this.currentObservable) === null || _a === void 0 ? void 0 : _a.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}(OperationData));

//# sourceMappingURL=QueryData.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/data/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/utils/useDeepMemo.js


function useDeepMemo(memoFn, key) {
    var ref = (0,react.useRef)();
    if (!ref.current || !(0,equality_esm/* equal */.D)(key, ref.current.key)) {
        ref.current = { key: key, value: memoFn() };
    }
    return ref.current.value;
}
//# sourceMappingURL=useDeepMemo.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/utils/useBaseQuery.js





function useBaseQuery(query, options, lazy) {
    if (lazy === void 0) { lazy = false; }
    var context = (0,react.useContext)((0,react_context/* getApolloContext */.KZ)());
    var _a = (0,react.useReducer)(function (x) { return x + 1; }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: query }) : { query: query };
    var queryDataRef = (0,react.useRef)();
    var queryData = queryDataRef.current || (queryDataRef.current = new QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function () {
            if (!queryData.ssrInitiated()) {
                Promise.resolve().then(function () { return queryDataRef.current && forceUpdate(); });
            }
            else {
                forceUpdate();
            }
        }
    }));
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, updatedOptions), { onError: undefined, onCompleted: undefined }),
        context: context,
        tick: tick
    };
    var result = useDeepMemo(function () { return (lazy ? queryData.executeLazy() : queryData.execute()); }, memo);
    var queryResult = lazy
        ? result[1]
        : result;
    (0,react.useEffect)(function () {
        return function () { return queryData.cleanup(); };
    }, []);
    (0,react.useEffect)(function () { return queryData.afterExecute({ lazy: lazy }); }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data,
    ]);
    return result;
}
//# sourceMappingURL=useBaseQuery.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js

function useLazyQuery(query, options) {
    return useBaseQuery(query, options, true);
}
//# sourceMappingURL=useLazyQuery.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js




function useMutation(mutation, options) {
    var context = (0,react.useContext)((0,react_context/* getApolloContext */.KZ)());
    var _a = (0,react.useState)({ called: false, loading: false }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { mutation: mutation }) : { mutation: mutation };
    var mutationDataRef = (0,react.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) {
            mutationDataRef.current = new MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
        }
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0,react.useEffect)(function () { return mutationData.afterExecute(); });
    return mutationData.execute(result);
}
//# sourceMappingURL=useMutation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js

function useQuery(query, options) {
    return useBaseQuery(query, options, false);
}
//# sourceMappingURL=useQuery.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useSubscription.js




function useSubscription(subscription, options) {
    var context = (0,react.useContext)((0,react_context/* getApolloContext */.KZ)());
    var updatedOptions = options
        ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { subscription: subscription }) : { subscription: subscription };
    var _a = (0,react.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0,react.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) {
            subscriptionDataRef.current = new SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
        }
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0,react.useEffect)(function () { return subscriptionData.afterExecute(); });
    (0,react.useEffect)(function () { return subscriptionData.cleanup.bind(subscriptionData); }, []);
    return subscriptionData.execute(result);
}
//# sourceMappingURL=useSubscription.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useReactiveVar.js

function useReactiveVar(rv) {
    var value = rv();
    var _a = useState(value), setValue = _a[1];
    useEffect(function () { return rv.onNextChange(setValue); }, [value]);
    useEffect(function () {
        setValue(rv());
    }, []);
    return value;
}
//# sourceMappingURL=useReactiveVar.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/index.js






//# sourceMappingURL=index.js.map

/***/ }),

/***/ 63341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useApolloClient": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__.xJ; },
/* harmony export */   "useLazyQuery": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__.td; },
/* harmony export */   "useMutation": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__.Db; },
/* harmony export */   "useQuery": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__.aM; },
/* harmony export */   "useSubscription": function() { return /* reexport safe */ _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__.mU; }
/* harmony export */ });
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30811);
/* harmony import */ var _hooks_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42100);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94901);
/* harmony import */ var _types_types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95923);
/* harmony import */ var _types_types_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_types_types_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_types_js__WEBPACK_IMPORTED_MODULE_3__, "ApolloLink")) __webpack_require__.d(__webpack_exports__, { "ApolloLink": function() { return _types_types_js__WEBPACK_IMPORTED_MODULE_3__.ApolloLink; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_types_types_js__WEBPACK_IMPORTED_MODULE_3__, "from")) __webpack_require__.d(__webpack_exports__, { "from": function() { return _types_types_js__WEBPACK_IMPORTED_MODULE_3__.from; } });




//# sourceMappingURL=index.js.map

/***/ }),

/***/ 94901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ parser; },
/* harmony export */   "mw": function() { return /* binding */ operationName; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* harmony import */ var ts_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10212);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = 'Query';
            break;
        case DocumentType.Mutation:
            name = 'Mutation';
            break;
        case DocumentType.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
     true ? (0,ts_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 34) : 0;
    var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
    var queries = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function (x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
     true ? (0,ts_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        (queries.length || mutations.length || subscriptions.length), 35) : 0;
     true ? (0,ts_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queries.length + mutations.length + subscriptions.length <= 1, 36) : 0;
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length
        ? queries
        : mutations.length
            ? mutations
            : subscriptions;
     true ? (0,ts_invariant__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 37) : 0;
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 95923:
/***/ (function() {

//# sourceMappingURL=types.js.map

/***/ }),

/***/ 94248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X_": function() { return /* reexport */ Concast; },
  "w0": function() { return /* reexport */ DeepMerger; },
  "y$": function() { return /* reexport */ (zen_observable_default()); },
  "Gw": function() { return /* reexport */ addTypenameToDocument; },
  "NC": function() { return /* reexport */ argumentsObjectFromField; },
  "sz": function() { return /* reexport */ asyncMap; },
  "aL": function() { return /* reexport */ buildQueryFromSelectionSet; },
  "mr": function() { return /* reexport */ canUseWeakMap; },
  "Xh": function() { return /* reexport */ cloneDeep; },
  "oA": function() { return /* reexport */ compact; },
  "xn": function() { return /* reexport */ concatPagination; },
  "F": function() { return /* reexport */ createFragmentMap; },
  "Dy": function() { return /* reexport */ fixObservableSubclass; },
  "O4": function() { return /* reexport */ getDefaultValues; },
  "kU": function() { return /* reexport */ getFragmentDefinitions; },
  "hi": function() { return /* reexport */ getFragmentFromSelection; },
  "Yk": function() { return /* reexport */ getFragmentQueryDocument; },
  "p$": function() { return /* reexport */ getMainDefinition; },
  "$H": function() { return /* reexport */ getOperationDefinition; },
  "rY": function() { return /* reexport */ getOperationName; },
  "iW": function() { return /* reexport */ getQueryDefinition; },
  "PT": function() { return /* reexport */ getStoreKeyName; },
  "qw": function() { return /* reexport */ getTypenameFromResult; },
  "d2": function() { return /* reexport */ graphQLResultHasError; },
  "mj": function() { return /* reexport */ hasClientExports; },
  "FS": function() { return /* reexport */ hasDirectives; },
  "My": function() { return /* reexport */ storeUtils_isField; },
  "Ao": function() { return /* reexport */ isInlineFragment; },
  "Of": function() { return /* reexport */ isNonEmptyArray; },
  "hh": function() { return /* reexport */ isReference; },
  "pM": function() { return /* reexport */ iterateObserversSafely; },
  "kQ": function() { return /* reexport */ makeReference; },
  "Jv": function() { return /* reexport */ maybeDeepFreeze; },
  "Ee": function() { return /* reexport */ mergeDeep; },
  "bw": function() { return /* reexport */ mergeDeepArray; },
  "CV": function() { return /* reexport */ offsetLimitPagination; },
  "ZB": function() { return /* reexport */ relayStylePagination; },
  "ob": function() { return /* reexport */ removeClientSetsFromDocument; },
  "Fo": function() { return /* reexport */ removeConnectionDirectiveFromDocument; },
  "u2": function() { return /* reexport */ resultKeyNameFromField; },
  "LZ": function() { return /* reexport */ shouldInclude; },
  "vf": function() { return /* reexport */ storeKeyNameFromField; }
});

// UNUSED EXPORTS: checkDocument, getDirectiveNames, getFragmentDefinition, getInclusionDirectives, removeArgumentsFromDocument, removeDirectivesFromDocument, removeFragmentSpreadFromDocument, valueToObjectRepresentation

// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js + 1 modules
var invariant_esm = __webpack_require__(10212);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables && variables[ifArgument.value.name.value];
             true ? (0,invariant_esm/* invariant */.kG)(evaledValue !== void 0, 38) : 0;
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    (0,visitor/* visit */.Vn)(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, root) {
    return getDirectiveNames(root).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
             true ? (0,invariant_esm/* invariant */.kG)(directiveArguments && directiveArguments.length === 1, 39) : 0;
            var ifArgument = directiveArguments[0];
             true ? (0,invariant_esm/* invariant */.kG)(ifArgument.name && ifArgument.name.value === 'if', 40) : 0;
            var ifValue = ifArgument.value;
             true ? (0,invariant_esm/* invariant */.kG)(ifValue &&
                (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 41) : 0;
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(23564);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js


function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new invariant_esm/* InvariantError */.ej(42) : 0;
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? (0,invariant_esm/* invariant */.kG)(fragments.length === 1, 43) : 0;
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: (0,tslib_es6/* __spreadArrays */.pr)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case 'InlineFragment':
            return selection;
        case 'FragmentSpread': {
            var fragment = fragmentMap && fragmentMap[selection.name.value];
             true ? (0,invariant_esm/* invariant */.kG)(fragment, 44) : 0;
            return fragment;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map
// EXTERNAL MODULE: ./node_modules/fast-json-stable-stringify/index.js
var fast_json_stable_stringify = __webpack_require__(35035);
var fast_json_stable_stringify_default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new invariant_esm/* InvariantError */.ej(53) : 0;
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (args &&
        directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = fast_json_stable_stringify_default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    if (typeof result.__typename === 'string') {
        return result.__typename;
    }
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (storeUtils_isField(selection)) {
            if (selection.name.value === '__typename') {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else {
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === 'string') {
                return typename;
            }
        }
    }
}
function storeUtils_isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
//# sourceMappingURL=storeUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js


function checkDocument(doc) {
     true ? (0,invariant_esm/* invariant */.kG)(doc && doc.kind === 'Document', 45) : 0;
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new invariant_esm/* InvariantError */.ej(46) : 0;
        }
        return definition;
    });
     true ? (0,invariant_esm/* invariant */.kG)(operations.length <= 1, 47) : 0;
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? (0,invariant_esm/* invariant */.kG)(queryDef && queryDef.operation === 'query', 48) : 0;
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? (0,invariant_esm/* invariant */.kG)(doc.kind === 'Document', 49) : 0;
     true ? (0,invariant_esm/* invariant */.kG)(doc.definitions.length <= 1, 50) : 0;
    var fragmentDef = doc.definitions[0];
     true ? (0,invariant_esm/* invariant */.kG)(fragmentDef.kind === 'FragmentDefinition', 51) : 0;
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new invariant_esm/* InvariantError */.ej(52) : 0;
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/filterInPlace.js
function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}
//# sourceMappingURL=filterInPlace.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js







var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !!v.name && !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !!fs.name && !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return (0,visitor/* visit */.Vn)(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (storeUtils_isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (storeUtils_isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { selections: (0,tslib_es6/* __spreadArrays */.pr)(selections, [TYPENAME_FIELD]) });
            },
        },
    });
}
addTypenameToDocument.added = function (field) {
    return field === TYPENAME_FIELD;
};
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                 true || 0;
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) : [] });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty((0,visitor/* visit */.Vn)(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((storeUtils_isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = (0,visitor/* visit */.Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = (0,visitor/* visit */.Vn)(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return storeUtils_isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js

var mergeDeep_hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = isObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if (isObject(source) && isObject(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (mergeDeep_hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib_es6/* __spreadArrays */.pr)([target, source, sourceKey], context));
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if (isObject(value) && !this.pastCopies.has(value)) {
            if (Array.isArray(value)) {
                value = value.slice(0);
            }
            else {
                value = (0,tslib_es6/* __assign */.pi)({ __proto__: Object.getPrototypeOf(value) }, value);
            }
            this.pastCopies.add(value);
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/policies/pagination.js



function concatPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming) {
            return existing ? (0,tslib_es6/* __spreadArrays */.pr)(existing, incoming) : incoming;
        },
    };
}
function offsetLimitPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (args) {
                var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                for (var i = 0; i < incoming.length; ++i) {
                    merged[offset + i] = incoming[i];
                }
            }
            else {
                merged.push.apply(merged, incoming);
            }
            return merged;
        },
    };
}
function relayStylePagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        read: function (existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing)
                return;
            var edges = [];
            var startCursor = "";
            var endCursor = "";
            existing.edges.forEach(function (edge) {
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        startCursor = startCursor || edge.cursor;
                        endCursor = edge.cursor;
                    }
                }
            });
            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getExtras(existing)), { edges: edges, pageInfo: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing.pageInfo), { startCursor: startCursor,
                    endCursor: endCursor }) });
        },
        merge: function (existing, incoming, _a) {
            if (existing === void 0) { existing = makeEmptyData(); }
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            var incomingEdges = incoming.edges ? incoming.edges.map(function (edge) {
                if (isReference(edge = (0,tslib_es6/* __assign */.pi)({}, edge))) {
                    edge.cursor = readField("cursor", edge);
                }
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                if (firstEdge && startCursor) {
                    firstEdge.cursor = startCursor;
                }
                if (lastEdge && endCursor) {
                    lastEdge.cursor = endCursor;
                }
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) {
                    incoming = mergeDeep(incoming, {
                        pageInfo: {
                            startCursor: firstCursor,
                        },
                    });
                }
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) {
                    incoming = mergeDeep(incoming, {
                        pageInfo: {
                            endCursor: lastCursor,
                        },
                    });
                }
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.after; });
                if (index >= 0) {
                    prefix = prefix.slice(0, index + 1);
                }
            }
            else if (args && args.before) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.before; });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            }
            else if (incoming.edges) {
                prefix = [];
            }
            var edges = (0,tslib_es6/* __spreadArrays */.pr)(prefix, incomingEdges, suffix);
            var pageInfo = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0,tslib_es6/* __rest */._T)(_b, ["hasPreviousPage", "hasNextPage", "startCursor", "endCursor"]);
                Object.assign(pageInfo, extras);
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage)
                        pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor)
                        pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage)
                        pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor)
                        pageInfo.endCursor = endCursor;
                }
            }
            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, getExtras(existing)), getExtras(incoming)), { edges: edges,
                pageInfo: pageInfo });
        },
    };
}
var getExtras = function (obj) { return (0,tslib_es6/* __rest */._T)(obj, notExtras); };
var notExtras = ["edges", "pageInfo"];
function makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: "",
        },
    };
}
//# sourceMappingURL=pagination.js.map
// EXTERNAL MODULE: ./node_modules/zen-observable/index.js
var zen_observable = __webpack_require__(49329);
var zen_observable_default = /*#__PURE__*/__webpack_require__.n(zen_observable);
// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js + 1 modules
var es = __webpack_require__(98123);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/Observable.js


var Observable_prototype = (zen_observable_default()).prototype;
var fakeObsSymbol = '@@observable';
if (!Observable_prototype[fakeObsSymbol]) {
    Observable_prototype[fakeObsSymbol] = function () { return this; };
}

//# sourceMappingURL=Observable.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep_toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (cloneDeep_toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map;
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/environment.js
/* provided dependency */ var process = __webpack_require__(34155);
function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}
//# sourceMappingURL=environment.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js

function maybeDeepFreeze_isObject(value) {
    return value !== null && typeof value === "object";
}
function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if (maybeDeepFreeze_isObject(obj)) {
            if (!Object.isFrozen(obj))
                Object.freeze(obj);
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if (maybeDeepFreeze_isObject(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function maybeDeepFreeze(obj) {
    if (false) {}
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/iteration.js
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/asyncMap.js

function asyncMap(observable, mapFn, catchFn) {
    return new (zen_observable_default())(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeCallbackCount = 0;
        var completed = false;
        var promiseQueue = {
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, delegate) {
            if (examiner) {
                return function (arg) {
                    ++activeCallbackCount;
                    var both = function () { return examiner(arg); };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) {
                        --activeCallbackCount;
                        next && next.call(observer, result);
                        if (completed) {
                            handler.complete();
                        }
                    }, function (error) {
                        --activeCallbackCount;
                        throw error;
                    }).catch(function (caught) {
                        error && error.call(observer, caught);
                    });
                };
            }
            else {
                return function (arg) { return delegate && delegate.call(observer, arg); };
            }
        }
        var handler = {
            next: makeCallback(mapFn, next),
            error: makeCallback(catchFn, error),
            complete: function () {
                completed = true;
                if (!activeCallbackCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/subclassing.js

function fixObservableSubclass(subclass) {
    function set(key) {
        Object.defineProperty(subclass, key, { value: (zen_observable_default()) });
    }
    if (typeof Symbol === "function" && Symbol.species) {
        set(Symbol.species);
    }
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
var Concast = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        _this.observers = new Set();
        _this.addCount = 0;
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    if (sub)
                        Promise.resolve().then(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                if (_this.sub !== null) {
                    var value = _this.sources.shift();
                    if (!value) {
                        _this.sub = null;
                        if (_this.latest &&
                            _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return _this.sub = obs.subscribe(_this.handlers); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        _this.promise.catch(function (_) { });
        if (typeof sources === "function") {
            sources = [new (zen_observable_default())(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        this.sources = Array.from(sources);
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            if (this.sub === null &&
                nextOrError === "next" &&
                observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            this.deliverLastMessage(observer);
            this.observers.add(observer);
            ++this.addCount;
        }
    };
    Concast.prototype.removeObserver = function (observer, quietly) {
        if (this.observers.delete(observer) &&
            --this.addCount < 1 &&
            !quietly) {
            this.handlers.error(new Error("Observable cancelled prematurely"));
        }
    };
    Concast.prototype.cleanup = function (callback) {
        var _this = this;
        var called = false;
        var once = function () {
            if (!called) {
                called = true;
                _this.observers.delete(observer);
                callback();
            }
        };
        var observer = {
            next: once,
            error: once,
            complete: once,
        };
        var count = this.addCount;
        this.addObserver(observer);
        this.addCount = count;
    };
    return Concast;
}((zen_observable_default())));

fixObservableSubclass(Concast);
//# sourceMappingURL=Concast.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/errorHandling.js
function graphQLResultHasError(result) {
    return (result.errors && result.errors.length > 0) || false;
}
//# sourceMappingURL=errorHandling.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
//# sourceMappingURL=canUse.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/index.js


















//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21129:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Breakpoints = exports.BreakpointConstraint = void 0;

var _Utils = __webpack_require__(86046);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function breakpointKey(breakpoint) {
  return Array.isArray(breakpoint) ? breakpoint.join("-") : breakpoint;
}

var BreakpointConstraint;
/**
 * Encapsulates all breakpoint data needed by the Media component. The data is
 * generated on initialization so no further runtime work is necessary.
 */

exports.BreakpointConstraint = BreakpointConstraint;

(function (BreakpointConstraint) {
  BreakpointConstraint["at"] = "at";
  BreakpointConstraint["lessThan"] = "lessThan";
  BreakpointConstraint["greaterThan"] = "greaterThan";
  BreakpointConstraint["greaterThanOrEqual"] = "greaterThanOrEqual";
  BreakpointConstraint["between"] = "between";
})(BreakpointConstraint || (exports.BreakpointConstraint = BreakpointConstraint = {}));

var Breakpoints = /*#__PURE__*/function () {
  _createClass(Breakpoints, null, [{
    key: "validKeys",
    value: function validKeys() {
      return [BreakpointConstraint.at, BreakpointConstraint.lessThan, BreakpointConstraint.greaterThan, BreakpointConstraint.greaterThanOrEqual, BreakpointConstraint.between];
    }
  }]);

  function Breakpoints(_breakpoints) {
    var _this = this,
        _this$_mediaQueries;

    _classCallCheck(this, Breakpoints);

    _defineProperty(this, "_sortedBreakpoints", void 0);

    _defineProperty(this, "_breakpoints", void 0);

    _defineProperty(this, "_mediaQueries", void 0);

    _defineProperty(this, "findBreakpointsForWidths", function (fromWidth, throughWidth) {
      var fromBreakpoint = _this.findBreakpointAtWidth(fromWidth);

      if (!fromBreakpoint) {
        return undefined;
      }

      var throughBreakpoint = _this.findBreakpointAtWidth(throughWidth);

      if (!throughBreakpoint || fromBreakpoint === throughBreakpoint) {
        return [fromBreakpoint];
      } else {
        return _this._sortedBreakpoints.slice(_this._sortedBreakpoints.indexOf(fromBreakpoint), _this._sortedBreakpoints.indexOf(throughBreakpoint) + 1);
      }
    });

    _defineProperty(this, "findBreakpointAtWidth", function (width) {
      return _this._sortedBreakpoints.find(function (breakpoint, i) {
        var nextBreakpoint = _this._sortedBreakpoints[i + 1];

        if (nextBreakpoint) {
          return width >= _this._breakpoints[breakpoint] && width < _this._breakpoints[nextBreakpoint];
        } else {
          return width >= _this._breakpoints[breakpoint];
        }
      });
    });

    _defineProperty(this, "valuesWithBreakpointProps", function (values) {
      var max = values.length;
      var valueBreakpoints = [];
      var lastTuple;

      _this._sortedBreakpoints.forEach(function (breakpoint, i) {
        var value = values[i];

        if (i < max && (!lastTuple || lastTuple[0] !== value)) {
          lastTuple = [value, [breakpoint]];
          valueBreakpoints.push(lastTuple);
        } else {
          lastTuple[1].push(breakpoint);
        }
      });

      return valueBreakpoints.map(function (_ref, i) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[0],
            breakpoints = _ref2[1];

        var props = {};

        if (i === valueBreakpoints.length - 1) {
          props.greaterThanOrEqual = breakpoints[0];
        } else if (breakpoints.length === 1) {
          props.at = breakpoints[0];
        } else {
          // TODO: This is less than ideal, would be good to have a `through`
          //       prop, which unlike `between` is inclusive.
          props.between = [breakpoints[0], valueBreakpoints[i + 1][1][0]];
        }

        return [value, props];
      });
    });

    this._breakpoints = _breakpoints;
    this._sortedBreakpoints = Object.keys(_breakpoints).map(function (breakpoint) {
      return [breakpoint, _breakpoints[breakpoint]];
    }).sort(function (a, b) {
      return a[1] < b[1] ? -1 : 1;
    }).map(function (breakpointAndValue) {
      return breakpointAndValue[0];
    }); // List of all possible and valid `between` combinations

    var betweenCombinations = this._sortedBreakpoints.slice(0, -1).reduce(function (acc, b1, i) {
      return _toConsumableArray(acc).concat(_toConsumableArray(_this._sortedBreakpoints.slice(i + 1).map(function (b2) {
        return [b1, b2];
      })));
    }, []);

    this._mediaQueries = (_this$_mediaQueries = {}, _defineProperty(_this$_mediaQueries, BreakpointConstraint.at, this._createBreakpointQueries(BreakpointConstraint.at, this._sortedBreakpoints)), _defineProperty(_this$_mediaQueries, BreakpointConstraint.lessThan, this._createBreakpointQueries(BreakpointConstraint.lessThan, this._sortedBreakpoints.slice(1))), _defineProperty(_this$_mediaQueries, BreakpointConstraint.greaterThan, this._createBreakpointQueries(BreakpointConstraint.greaterThan, this._sortedBreakpoints.slice(0, -1))), _defineProperty(_this$_mediaQueries, BreakpointConstraint.greaterThanOrEqual, this._createBreakpointQueries(BreakpointConstraint.greaterThanOrEqual, this._sortedBreakpoints)), _defineProperty(_this$_mediaQueries, BreakpointConstraint.between, this._createBreakpointQueries(BreakpointConstraint.between, betweenCombinations)), _this$_mediaQueries);
  }

  _createClass(Breakpoints, [{
    key: "toVisibleAtBreakpointSet",
    value: function toVisibleAtBreakpointSet(breakpointProps) {
      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var breakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.lessThan;
        });
        return this.sortedBreakpoints.slice(0, breakpointIndex);
      } else if (breakpointProps.greaterThan) {
        var _breakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.greaterThan;
        });

        return this.sortedBreakpoints.slice(_breakpointIndex + 1);
      } else if (breakpointProps.greaterThanOrEqual) {
        var _breakpointIndex2 = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === breakpointProps.greaterThanOrEqual;
        });

        return this.sortedBreakpoints.slice(_breakpointIndex2);
      } else if (breakpointProps.between) {
        var between = breakpointProps.between;
        var fromBreakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === between[0];
        });
        var toBreakpointIndex = this.sortedBreakpoints.findIndex(function (bp) {
          return bp === between[1];
        });
        return this.sortedBreakpoints.slice(fromBreakpointIndex, toBreakpointIndex);
      }

      return [];
    }
  }, {
    key: "toRuleSets",
    value: function toRuleSets() {
      var _this2 = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Breakpoints.validKeys();
      var selectedMediaQueries = keys.reduce(function (mediaQueries, query) {
        mediaQueries[query] = _this2._mediaQueries[query];
        return mediaQueries;
      }, {});
      return Object.entries(selectedMediaQueries).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            type = _ref4[0],
            queries = _ref4[1];

        queries.forEach(function (query, breakpoint) {
          // We need to invert the query, such that it matches when we want the
          // element to be hidden.
          acc.push((0, _Utils.createRuleSet)((0, _Utils.createClassName)(type, breakpoint), "not all and ".concat(query)));
        });
        return acc;
      }, []);
    }
  }, {
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(breakpointProps, onlyRenderAt) {
      var _this3 = this;

      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var width = this._breakpoints[breakpointProps.lessThan];
        var lowestAllowedWidth = Math.min.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));
        return lowestAllowedWidth < width;
      } else if (breakpointProps.greaterThan) {
        var _width = this._breakpoints[this._findNextBreakpoint(breakpointProps.greaterThan)];

        var highestAllowedWidth = Math.max.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));
        return highestAllowedWidth >= _width;
      } else if (breakpointProps.greaterThanOrEqual) {
        var _width2 = this._breakpoints[breakpointProps.greaterThanOrEqual];

        var _highestAllowedWidth = Math.max.apply(Math, _toConsumableArray(onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        })));

        return _highestAllowedWidth >= _width2;
      } else if (breakpointProps.between) {
        // TODO: This is the only useful breakpoint to negate, but we’ll
        //       we’ll see when/if we need it. We could then also decide
        //       to add `oustide`.
        var fromWidth = this._breakpoints[breakpointProps.between[0]];
        var toWidth = this._breakpoints[breakpointProps.between[1]];
        var allowedWidths = onlyRenderAt.map(function (breakpoint) {
          return _this3._breakpoints[breakpoint];
        });
        return !(Math.max.apply(Math, _toConsumableArray(allowedWidths)) < fromWidth || Math.min.apply(Math, _toConsumableArray(allowedWidths)) >= toWidth);
      }

      return false;
    }
  }, {
    key: "_normalizeProps",
    value: function _normalizeProps(breakpointProps) {
      if (breakpointProps.at) {
        var fromIndex = this._sortedBreakpoints.indexOf(breakpointProps.at);

        var to = this._sortedBreakpoints[fromIndex + 1];
        return to ? {
          between: [breakpointProps.at, to]
        } : {
          greaterThanOrEqual: breakpointProps.at
        };
      }

      return breakpointProps;
    }
  }, {
    key: "_createBreakpointQuery",
    value: function _createBreakpointQuery(breakpointProps) {
      breakpointProps = this._normalizeProps(breakpointProps);

      if (breakpointProps.lessThan) {
        var width = this._breakpoints[breakpointProps.lessThan];
        return "(max-width:".concat(width - 0.02, "px)");
      } else if (breakpointProps.greaterThan) {
        var _width3 = this._breakpoints[this._findNextBreakpoint(breakpointProps.greaterThan)];

        return "(min-width:".concat(_width3, "px)");
      } else if (breakpointProps.greaterThanOrEqual) {
        var _width4 = this._breakpoints[breakpointProps.greaterThanOrEqual];
        return "(min-width:".concat(_width4, "px)");
      } else if (breakpointProps.between) {
        // TODO: This is the only useful breakpoint to negate, but we’ll
        //       we’ll see when/if we need it. We could then also decide
        //       to add `outside`.
        var fromWidth = this._breakpoints[breakpointProps.between[0]];
        var toWidth = this._breakpoints[breakpointProps.between[1]];
        return "(min-width:".concat(fromWidth, "px) and (max-width:").concat(toWidth - 0.02, "px)");
      }

      throw new Error("Unexpected breakpoint props: ".concat(JSON.stringify(breakpointProps)));
    }
  }, {
    key: "_createBreakpointQueries",
    value: function _createBreakpointQueries(key, forBreakpoints) {
      var _this4 = this;

      return forBreakpoints.reduce(function (map, breakpoint) {
        map.set(breakpointKey(breakpoint), _this4._createBreakpointQuery(_defineProperty({}, key, breakpoint)));
        return map;
      }, new Map());
    }
  }, {
    key: "_findNextBreakpoint",
    value: function _findNextBreakpoint(breakpoint) {
      var nextBreakpoint = this._sortedBreakpoints[this._sortedBreakpoints.indexOf(breakpoint) + 1];

      if (!nextBreakpoint) {
        throw new Error("There is no breakpoint larger than ".concat(breakpoint));
      }

      return nextBreakpoint;
    }
  }, {
    key: "sortedBreakpoints",
    get: function get() {
      return this._sortedBreakpoints;
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return Array.from(this._mediaQueries[BreakpointConstraint.at].entries()).reduce(function (acc, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            k = _ref6[0],
            v = _ref6[1];

        return _objectSpread({}, acc, _defineProperty({}, k, v));
      }, {});
    }
  }, {
    key: "largestBreakpoint",
    get: function get() {
      return this._sortedBreakpoints[this._sortedBreakpoints.length - 1];
    }
  }]);

  return Breakpoints;
}();

exports.Breakpoints = Breakpoints;
//# sourceMappingURL=Breakpoints.js.map

/***/ }),

/***/ 91211:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createResponsiveComponents = createResponsiveComponents;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var shallowEqual = function shallowEqual(a, b) {
  for (var _key in a) {
    if (a[_key] !== b[_key]) return false;
  }

  return true;
};
/** TODO */


function createResponsiveComponents() {
  var ResponsiveContext = _react.default.createContext({});

  ResponsiveContext.displayName = "Media.DynamicContext";
  var ResponsiveConsumer = ResponsiveContext.Consumer;
  return {
    Consumer: ResponsiveConsumer,
    Provider: /*#__PURE__*/function (_React$Component) {
      _inherits(ResponsiveProvider, _React$Component);

      function ResponsiveProvider(props) {
        var _this;

        _classCallCheck(this, ResponsiveProvider);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveProvider).call(this, props));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isSupportedEnvironment", function () {
          return typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setupMatchers", function (mediaQueries) {
          return Object.keys(mediaQueries).reduce(function (matchers, key) {
            return _objectSpread({}, matchers, _defineProperty({}, key, window.matchMedia(mediaQueries[key])));
          }, {});
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "checkMatchers", function (mediaQueryMatchers) {
          return Object.keys(mediaQueryMatchers).reduce(function (matches, key) {
            return _objectSpread({}, matches, _defineProperty({}, key, mediaQueryMatchers[key].matches));
          }, {});
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mediaQueryStatusChangedCallback", function () {
          var mediaQueryMatches = _this.checkMatchers(_this.state.mediaQueryMatchers);

          _this.setState({
            mediaQueryMatches: mediaQueryMatches
          });
        });

        var _mediaQueryMatchers = undefined;

        var _mediaQueryMatches;

        if (_this.isSupportedEnvironment()) {
          _mediaQueryMatchers = _this.setupMatchers(props.mediaQueries);
          _mediaQueryMatches = _this.checkMatchers(_mediaQueryMatchers);
        } else {
          _mediaQueryMatches = Object.keys(props.mediaQueries).reduce(function (matches, key) {
            return _objectSpread({}, matches, _defineProperty({}, key, !!props.initialMatchingMediaQueries && props.initialMatchingMediaQueries.includes(key)));
          }, {});
        }

        _this.state = {
          mediaQueryMatchers: _mediaQueryMatchers,
          mediaQueryMatches: _mediaQueryMatches
        };
        return _this;
      }

      _createClass(ResponsiveProvider, [{
        key: "componentDidMount",
        // Lifecycle methods
        value: function componentDidMount() {
          if (this.state.mediaQueryMatchers) {
            var mediaQueryStatusChangedCallback = this.mediaQueryStatusChangedCallback;
            Object.values(this.state.mediaQueryMatchers).forEach(function (matcher) {
              matcher.addListener(mediaQueryStatusChangedCallback);
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.state.mediaQueryMatchers) {
            var mediaQueryStatusChangedCallback = this.mediaQueryStatusChangedCallback;
            Object.values(this.state.mediaQueryMatchers).forEach(function (matcher) {
              return matcher.removeListener(mediaQueryStatusChangedCallback);
            });
          }
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          if (!this.state.mediaQueryMatchers) return false;
          if (nextProps.children !== this.props.children) return true;

          if (shallowEqual(this.state.mediaQueryMatches, nextState.mediaQueryMatches)) {
            return false;
          }

          return true;
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(ResponsiveContext.Provider, {
            value: this.state.mediaQueryMatches
          }, this.props.children);
        }
      }]);

      return ResponsiveProvider;
    }(_react.default.Component)
  };
}
//# sourceMappingURL=DynamicResponsive.js.map

/***/ }),

/***/ 50971:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Interactions = exports.InteractionKey = void 0;

var _Utils = __webpack_require__(86046);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InteractionKey;
/**
 * Encapsulates all interaction data needed by the Media component. The data is
 * generated on initialization so no further runtime work is necessary.
 */

exports.InteractionKey = InteractionKey;

(function (InteractionKey) {
  InteractionKey["interaction"] = "interaction";
})(InteractionKey || (exports.InteractionKey = InteractionKey = {}));

var Interactions = /*#__PURE__*/function () {
  _createClass(Interactions, null, [{
    key: "validKeys",
    value: function validKeys() {
      return [InteractionKey.interaction];
    }
  }]);

  function Interactions(interactions) {
    _classCallCheck(this, Interactions);

    _defineProperty(this, "_interactions", void 0);

    this._interactions = interactions;
  }

  _createClass(Interactions, [{
    key: "toRuleSets",
    value: function toRuleSets() {
      return Object.entries(this._interactions).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            query = _ref2[1];

        return _toConsumableArray(acc).concat([(0, _Utils.createRuleSet)((0, _Utils.createClassName)(InteractionKey.interaction, name), query)]);
      }, []);
    }
  }, {
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(interaction, onlyMatch) {
      return !!(onlyMatch && onlyMatch.includes(interaction));
    }
  }, {
    key: "interactions",
    get: function get() {
      return Object.keys(this._interactions);
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return Object.entries(this._interactions).reduce(function (acc, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            name = _ref4[0],
            query = _ref4[1];

        return _objectSpread({}, acc, _defineProperty({}, name, query));
      }, {});
    }
  }]);

  return Interactions;
}();

exports.Interactions = Interactions;
//# sourceMappingURL=Interactions.js.map

/***/ }),

/***/ 98603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createMedia = createMedia;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _DynamicResponsive = __webpack_require__(91211);

var _MediaQueries = __webpack_require__(16482);

var _Utils = __webpack_require__(86046);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This is used to generate a Media component, its context provider, and CSS
 * rules based on your application’s breakpoints and interactions.
 *
 * Note that the interaction queries are entirely up to you to define and they
 * should be written in such a way that they match when you want the element to
 * be hidden.
 *
 * @example
 *
   ```tsx
   const MyAppMedia = createMedia({
     breakpoints: {
       xs: 0,
       sm: 768,
       md: 900
       lg: 1024,
       xl: 1192,
     },
     interactions: {
       hover: `not all and (hover:hover)`
     },
   })

   export const Media = MyAppMedia.Media
   export const MediaContextProvider = MyAppMedia.MediaContextProvider
   export const createMediaStyle = MyAppMedia.createMediaStyle
   ```
 *
 */
function createMedia(config) {
  var _class, _temp;

  var breakpoints = (0, _Utils.castBreakpointsToIntegers)(config.breakpoints);
  var mediaQueries = new _MediaQueries.MediaQueries(breakpoints, config.interactions || {});
  var DynamicResponsive = (0, _DynamicResponsive.createResponsiveComponents)();

  var MediaContext = _react.default.createContext({});

  MediaContext.displayName = "Media.Context";

  var MediaParentContext = _react.default.createContext({
    hasParentMedia: false,
    breakpointProps: {}
  });

  MediaContext.displayName = "MediaParent.Context";
  var getMediaContextValue = (0, _Utils.memoize)(function (onlyMatch) {
    return {
      onlyMatch: onlyMatch
    };
  });

  var MediaContextProvider = function MediaContextProvider(_ref) {
    var disableDynamicMediaQueries = _ref.disableDynamicMediaQueries,
        onlyMatch = _ref.onlyMatch,
        children = _ref.children;

    if (disableDynamicMediaQueries) {
      var MediaContextValue = getMediaContextValue(onlyMatch);
      return _react.default.createElement(MediaContext.Provider, {
        value: MediaContextValue
      }, children);
    } else {
      return _react.default.createElement(DynamicResponsive.Provider, {
        mediaQueries: mediaQueries.dynamicResponsiveMediaQueries,
        initialMatchingMediaQueries: (0, _Utils.intersection)(mediaQueries.mediaQueryTypes, onlyMatch)
      }, _react.default.createElement(DynamicResponsive.Consumer, null, function (matches) {
        var matchingMediaQueries = Object.keys(matches).filter(function (key) {
          return matches[key];
        });
        var MediaContextValue = getMediaContextValue((0, _Utils.intersection)(matchingMediaQueries, onlyMatch));
        return _react.default.createElement(MediaContext.Provider, {
          value: MediaContextValue
        }, children);
      }));
    }
  };

  var Media = (_temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(Media, _React$Component);

    function Media(props) {
      var _this;

      _classCallCheck(this, Media);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Media).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMediaParentContextValue", (0, _Utils.memoize)(function (breakpointProps) {
        return {
          hasParentMedia: true,
          breakpointProps: breakpointProps
        };
      }));

      validateProps(props);
      return _this;
    }

    _createClass(Media, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = this.props;

        var children = props.children,
            passedClassName = props.className,
            style = props.style,
            interaction = props.interaction,
            breakpointProps = _objectWithoutProperties(props, ["children", "className", "style", "interaction"]);

        var mediaParentContextValue = this.getMediaParentContextValue(breakpointProps);
        return _react.default.createElement(MediaParentContext.Consumer, null, function (mediaParentContext) {
          return _react.default.createElement(MediaParentContext.Provider, {
            value: mediaParentContextValue
          }, _react.default.createElement(MediaContext.Consumer, null, function () {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                onlyMatch = _ref2.onlyMatch;

            var className;

            if (props.interaction) {
              className = (0, _Utils.createClassName)("interaction", props.interaction);
            } else {
              if (props.at) {
                var largestBreakpoint = mediaQueries.breakpoints.largestBreakpoint;

                if (props.at === largestBreakpoint) {
                  // TODO: We should look into making React’s __DEV__ available
                  //       and have webpack completely compile these away.
                  var ownerName = null;

                  try {
                    var owner = _this2._reactInternalFiber._debugOwner.type;
                    ownerName = owner.displayName || owner.name;
                  } catch (err) {// no-op
                  }

                  console.warn("[@artsy/fresnel] " + "`at` is being used with the largest breakpoint. " + "Consider using `<Media greaterThanOrEqual=" + "\"".concat(largestBreakpoint, "\">` to account for future ") + "breakpoint definitions outside of this range.".concat(ownerName ? " It is being used in the ".concat(ownerName, " component.") : ""));
                }
              }

              var type = (0, _Utils.propKey)(breakpointProps);
              var breakpoint = breakpointProps[type];
              className = (0, _Utils.createClassName)(type, breakpoint);
            }

            var doesMatchParent = !mediaParentContext.hasParentMedia || (0, _Utils.intersection)(mediaQueries.breakpoints.toVisibleAtBreakpointSet(mediaParentContext.breakpointProps), mediaQueries.breakpoints.toVisibleAtBreakpointSet(breakpointProps)).length > 0;
            var renderChildren = doesMatchParent && (onlyMatch === undefined || mediaQueries.shouldRenderMediaQuery(_objectSpread({}, breakpointProps, {
              interaction: interaction
            }), onlyMatch));

            if (props.children instanceof Function) {
              return props.children(className, renderChildren);
            } else {
              return _react.default.createElement("div", {
                className: "fresnel-container ".concat(className, " ").concat(passedClassName),
                style: style,
                suppressHydrationWarning: !renderChildren
              }, renderChildren ? props.children : null);
            }
          }));
        });
      }
    }]);

    return Media;
  }(_react.default.Component), _defineProperty(_class, "defaultProps", {
    className: "",
    style: {}
  }), _defineProperty(_class, "contextType", MediaParentContext), _temp);
  return {
    Media: Media,
    MediaContextProvider: MediaContextProvider,
    createMediaStyle: mediaQueries.toStyle,
    SortedBreakpoints: _toConsumableArray(mediaQueries.breakpoints.sortedBreakpoints),
    findBreakpointAtWidth: mediaQueries.breakpoints.findBreakpointAtWidth,
    findBreakpointsForWidths: mediaQueries.breakpoints.findBreakpointsForWidths,
    valuesWithBreakpointProps: mediaQueries.breakpoints.valuesWithBreakpointProps
  };
}

var MutuallyExclusiveProps = _MediaQueries.MediaQueries.validKeys();

function validateProps(props) {
  var selectedProps = Object.keys(props).filter(function (prop) {
    return MutuallyExclusiveProps.includes(prop);
  });

  if (selectedProps.length < 1) {
    throw new Error("1 of ".concat(MutuallyExclusiveProps.join(", "), " is required."));
  } else if (selectedProps.length > 1) {
    throw new Error("Only 1 of ".concat(selectedProps.join(", "), " is allowed at a time."));
  }
}
//# sourceMappingURL=Media.js.map

/***/ }),

/***/ 16482:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MediaQueries = void 0;

var _Breakpoints = __webpack_require__(21129);

var _Interactions = __webpack_require__(50971);

var _Utils = __webpack_require__(86046);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Encapsulates all interaction data (and breakpoint data in the superclass)
 * needed by the Media component. The data is generated on initialization so no
 * further runtime work is necessary.
 */
var MediaQueries = /*#__PURE__*/function () {
  _createClass(MediaQueries, null, [{
    key: "validKeys",
    value: function validKeys() {
      return _toConsumableArray(_Breakpoints.Breakpoints.validKeys()).concat(_toConsumableArray(_Interactions.Interactions.validKeys()));
    }
  }]);

  function MediaQueries(breakpoints, interactions) {
    var _this = this;

    _classCallCheck(this, MediaQueries);

    _defineProperty(this, "_breakpoints", void 0);

    _defineProperty(this, "_interactions", void 0);

    _defineProperty(this, "toStyle", function (breakpointKeys) {
      return [// Don’t add any size to the layout
      ".fresnel-container{margin:0;padding:0;}"].concat(_toConsumableArray(_this._breakpoints.toRuleSets(breakpointKeys)), _toConsumableArray(_this._interactions.toRuleSets())).join("\n");
    });

    this._breakpoints = new _Breakpoints.Breakpoints(breakpoints);
    this._interactions = new _Interactions.Interactions(interactions || {});
  }

  _createClass(MediaQueries, [{
    key: "shouldRenderMediaQuery",
    value: function shouldRenderMediaQuery(mediaQueryProps, onlyMatch) {
      var interaction = mediaQueryProps.interaction,
          breakpointProps = _objectWithoutProperties(mediaQueryProps, ["interaction"]);

      if (interaction) {
        return this._interactions.shouldRenderMediaQuery(interaction, onlyMatch);
      } // Remove any interaction possibilities from the list.


      var onlyMatchBreakpoints = (0, _Utils.intersection)(onlyMatch, this._breakpoints.sortedBreakpoints);
      return this._breakpoints.shouldRenderMediaQuery(breakpointProps, onlyMatchBreakpoints);
    }
  }, {
    key: "breakpoints",
    get: function get() {
      return this._breakpoints;
    }
  }, {
    key: "mediaQueryTypes",
    get: function get() {
      return _toConsumableArray(this._breakpoints.sortedBreakpoints).concat(_toConsumableArray(this._interactions.interactions));
    }
  }, {
    key: "dynamicResponsiveMediaQueries",
    get: function get() {
      return _objectSpread({}, this._breakpoints.dynamicResponsiveMediaQueries, this._interactions.dynamicResponsiveMediaQueries);
    }
  }]);

  return MediaQueries;
}();

exports.MediaQueries = MediaQueries;
//# sourceMappingURL=MediaQueries.js.map

/***/ }),

/***/ 86046:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.propKey = propKey;
exports.intersection = intersection;
exports.createRuleSet = createRuleSet;
exports.createClassName = createClassName;
exports.castBreakpointsToIntegers = castBreakpointsToIntegers;
exports.memoize = memoize;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Extracts the single breakpoint prop from the props object.
 */
function propKey(breakpointProps) {
  return Object.keys(breakpointProps)[0];
}
/**
 * Returns the intersection of two arrays.
 */


function intersection(a1, a2) {
  return a2 ? a1.filter(function (element) {
    return a2.indexOf(element) >= 0;
  }) : _toConsumableArray(a1);
}
/**
 * Generate a style rule for a given class name that will hide the element
 * when the given query matches.
 */


function createRuleSet(className, query) {
  return "@media ".concat(query, "{.").concat(className, "{display:none!important;}}");
}
/**
 * Given a list of strings, or string tuples, generates a class name.
 */


function createClassName() {
  for (var _len = arguments.length, components = new Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return ["fresnel"].concat(_toConsumableArray(components.reduce(function (acc, breakpoint) {
    return Array.isArray(breakpoint) ? _toConsumableArray(acc).concat(_toConsumableArray(breakpoint)) : _toConsumableArray(acc).concat([breakpoint]);
  }, []))).join("-");
}
/**
 * Returns an object with every values casted to integers.
 */


function castBreakpointsToIntegers(breakpoints) {
  var keys = Object.keys(breakpoints);
  return keys.reduce(function (previous, current, currentIndex) {
    return _objectSpread({}, previous, _defineProperty({}, keys[currentIndex], Math.round(Number(breakpoints[current]))));
  }, {});
}
/**
 * Use this function to memoize any function
 */


function memoize(func) {
  var results = {};
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var argsKey = JSON.stringify(args);

    if (!results[argsKey]) {
      results[argsKey] = func.apply(void 0, args);
    }

    return results[argsKey];
  };
}
//# sourceMappingURL=Utils.js.map

/***/ }),

/***/ 2082:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "Wm", ({
  enumerable: true,
  get: function get() {
    return _Media.createMedia;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Breakpoints.BreakpointConstraint;
  }
});

var _Media = __webpack_require__(98603);

var _Breakpoints = __webpack_require__(21129);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 53061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Alert: () => Alert,
  AlertDescription: () => AlertDescription,
  AlertIcon: () => AlertIcon,
  AlertTitle: () => AlertTitle,
  useAlertStyles: () => useAlertStyles
});
module.exports = __toCommonJS(src_exports);

// src/alert.tsx
var import_shared_utils = __webpack_require__(42409);
var import_system = __webpack_require__(84491);

// src/alert-context.ts
var import_react_context = __webpack_require__(12518);

// src/icons.tsx
var import_icon = __webpack_require__(59470);
var import_jsx_runtime = __webpack_require__(85893);
function CheckIcon(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_icon.Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
    }
  ) });
}
function InfoIcon(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_icon.Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "path",
    {
      fill: "currentColor",
      d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
    }
  ) });
}
function WarningIcon(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_icon.Icon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "path",
    {
      fill: "currentColor",
      d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
    }
  ) });
}

// src/alert-context.ts
var import_spinner = __webpack_require__(43130);
var [AlertProvider, useAlertContext] = (0, import_react_context.createContext)({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
});
var [AlertStylesProvider, useAlertStyles] = (0, import_react_context.createContext)({
  name: `AlertStylesContext`,
  hookName: `useAlertStyles`,
  providerName: "<Alert />"
});
var STATUSES = {
  info: { icon: InfoIcon, colorScheme: "blue" },
  warning: { icon: WarningIcon, colorScheme: "orange" },
  success: { icon: CheckIcon, colorScheme: "green" },
  error: { icon: WarningIcon, colorScheme: "red" },
  loading: { icon: import_spinner.Spinner, colorScheme: "blue" }
};
function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}
function getStatusIcon(status) {
  return STATUSES[status].icon;
}

// src/alert.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var Alert = (0, import_system.forwardRef)(function Alert2(props, ref) {
  var _a;
  const { status = "info", addRole = true, ...rest } = (0, import_system.omitThemingProps)(props);
  const colorScheme = (_a = props.colorScheme) != null ? _a : getStatusColorScheme(status);
  const styles = (0, import_system.useMultiStyleConfig)("Alert", { ...props, colorScheme });
  const alertStyles = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    ...styles.container
  };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(AlertProvider, { value: { status }, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(AlertStylesProvider, { value: styles, children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_system.chakra.div,
    {
      "data-status": status,
      role: addRole ? "alert" : void 0,
      ref,
      ...rest,
      className: (0, import_shared_utils.cx)("chakra-alert", props.className),
      __css: alertStyles
    }
  ) }) });
});
Alert.displayName = "Alert";

// src/alert-description.tsx
var import_shared_utils2 = __webpack_require__(42409);
var import_system2 = __webpack_require__(84491);
var import_jsx_runtime3 = __webpack_require__(85893);
var AlertDescription = (0, import_system2.forwardRef)(
  function AlertDescription2(props, ref) {
    const styles = useAlertStyles();
    const { status } = useAlertContext();
    const descriptionStyles = {
      display: "inline",
      ...styles.description
    };
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_system2.chakra.div,
      {
        ref,
        "data-status": status,
        ...props,
        className: (0, import_shared_utils2.cx)("chakra-alert__desc", props.className),
        __css: descriptionStyles
      }
    );
  }
);
AlertDescription.displayName = "AlertDescription";

// src/alert-icon.tsx
var import_shared_utils3 = __webpack_require__(42409);
var import_system3 = __webpack_require__(84491);
var import_jsx_runtime4 = __webpack_require__(85893);
function AlertIcon(props) {
  const { status } = useAlertContext();
  const BaseIcon = getStatusIcon(status);
  const styles = useAlertStyles();
  const css = status === "loading" ? styles.spinner : styles.icon;
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_system3.chakra.span,
    {
      display: "inherit",
      "data-status": status,
      ...props,
      className: (0, import_shared_utils3.cx)("chakra-alert__icon", props.className),
      __css: css,
      children: props.children || /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(BaseIcon, { h: "100%", w: "100%" })
    }
  );
}
AlertIcon.displayName = "AlertIcon";

// src/alert-title.tsx
var import_shared_utils4 = __webpack_require__(42409);
var import_system4 = __webpack_require__(84491);
var import_jsx_runtime5 = __webpack_require__(85893);
var AlertTitle = (0, import_system4.forwardRef)(
  function AlertTitle2(props, ref) {
    const styles = useAlertStyles();
    const { status } = useAlertContext();
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      import_system4.chakra.div,
      {
        ref,
        "data-status": status,
        ...props,
        className: (0, import_shared_utils4.cx)("chakra-alert__title", props.className),
        __css: styles.title
      }
    );
  }
);
AlertTitle.displayName = "AlertTitle";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 24195:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ColorModeContext: () => ColorModeContext,
  ColorModeProvider: () => ColorModeProvider,
  ColorModeScript: () => ColorModeScript,
  DarkMode: () => DarkMode,
  LightMode: () => LightMode,
  cookieStorageManager: () => cookieStorageManager,
  cookieStorageManagerSSR: () => cookieStorageManagerSSR,
  createCookieStorageManager: () => createCookieStorageManager,
  createLocalStorageManager: () => createLocalStorageManager,
  getScriptSrc: () => getScriptSrc,
  localStorageManager: () => localStorageManager,
  useColorMode: () => useColorMode,
  useColorModeValue: () => useColorModeValue
});
module.exports = __toCommonJS(src_exports);

// src/color-mode-provider.tsx
var import_react_use_safe_layout_effect = __webpack_require__(5414);
var import_react2 = __webpack_require__(67294);

// src/color-mode-context.ts
var import_react = __webpack_require__(67294);
var ColorModeContext = (0, import_react.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0, import_react.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}

// src/color-mode.utils.ts
var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils(options = {}) {
  const { preventTransition = true } = options;
  const utils = {
    setDataset: (value) => {
      const cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(fallback) {
      var _a;
      const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener(fn) {
      const mql = utils.query();
      const listener = (e) => {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function")
        mql.addListener(listener);
      else
        mql.addEventListener("change", listener);
      return () => {
        if (typeof mql.removeListener === "function")
          mql.removeListener(listener);
        else
          mql.removeEventListener("change", listener);
      };
    },
    preventTransition() {
      const css = document.createElement("style");
      css.appendChild(
        document.createTextNode(
          `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
        )
      );
      document.head.appendChild(css);
      return () => {
        ;
        (() => window.getComputedStyle(document.body))();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      let value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {
      }
      return value || init;
    },
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
      }
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get(init) {
      if (cookie)
        return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      return parseCookie(document.cookie, key) || init;
    },
    set(value) {
      document.cookie = `${key}=${value}; max-age=31536000; path=/`;
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = (cookie) => createCookieStorageManager(STORAGE_KEY, cookie);

// src/color-mode-provider.tsx
var import_jsx_runtime = __webpack_require__(85893);
var noop = () => {
};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  const {
    value,
    children,
    options: {
      useSystemColorMode,
      initialColorMode,
      disableTransitionOnChange
    } = {},
    colorModeManager = localStorageManager
  } = props;
  const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  const [colorMode, rawSetColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager, defaultColorMode)
  );
  const [resolvedColorMode, setResolvedColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager)
  );
  const { getSystemTheme, setClassName, setDataset, addListener } = (0, import_react2.useMemo)(
    () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
    [disableTransitionOnChange]
  );
  const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  const setColorMode = (0, import_react2.useCallback)(
    (value2) => {
      const resolved = value2 === "system" ? getSystemTheme() : value2;
      rawSetColorMode(resolved);
      setClassName(resolved === "dark");
      setDataset(resolved);
      colorModeManager.set(resolved);
    },
    [colorModeManager, getSystemTheme, setClassName, setDataset]
  );
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  const toggleColorMode = (0, import_react2.useCallback)(() => {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  (0, import_react2.useEffect)(() => {
    if (!useSystemColorMode)
      return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    }),
    [resolvedValue, toggleColorMode, setColorMode, value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, children });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
LightMode.displayName = "LightMode";

// src/color-mode-script.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var VALID_VALUES = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function normalize(initialColorMode) {
  let value = initialColorMode;
  if (!VALID_VALUES.has(value))
    value = "light";
  return value;
}
function getScriptSrc(props = {}) {
  const {
    initialColorMode = "light",
    type = "localStorage",
    storageKey: key = "chakra-ui-color-mode"
  } = props;
  const init = normalize(initialColorMode);
  const isCookie = type === "cookie";
  const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
  const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  const fn = isCookie ? cookieScript : localStorageScript;
  return `!${fn}`.trim();
}
function ColorModeScript(props = {}) {
  const { nonce } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "script",
    {
      id: "chakra-script",
      nonce,
      dangerouslySetInnerHTML: { __html: getScriptSrc(props) }
    }
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 59470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Icon: () => Icon,
  createIcon: () => createIcon,
  default: () => icon_default
});
module.exports = __toCommonJS(src_exports);

// src/icon.tsx
var import_system = __webpack_require__(84491);
var import_shared_utils = __webpack_require__(42409);
var import_jsx_runtime = __webpack_require__(85893);
var fallbackIcon = {
  path: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
};
var Icon = (0, import_system.forwardRef)((props, ref) => {
  const {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css,
    ...rest
  } = props;
  const _className = (0, import_shared_utils.cx)("chakra-icon", className);
  const customStyles = (0, import_system.useStyleConfig)("Icon", props);
  const styles = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color,
    ...__css,
    ...customStyles
  };
  const shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };
  const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { as: element, ...shared, ...rest });
  }
  const _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
});
Icon.displayName = "Icon";
var icon_default = Icon;

// src/create-icon.tsx
var import_system2 = __webpack_require__(84491);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = import_react.Children.toArray(options.path);
  const Comp = (0, import_system2.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Icon, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 12518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createContext: () => createContext
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function getErrorMessage(hook, provider) {
  return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage,
    defaultValue
  } = options;
  const Context = (0, import_react.createContext)(defaultValue);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = (0, import_react.useContext)(Context);
    if (!context && strict) {
      const error = new Error(
        errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName)
      );
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 5414:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSafeLayoutEffect: () => useSafeLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? import_react.useLayoutEffect : import_react.useEffect;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 43130:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Spinner: () => Spinner
});
module.exports = __toCommonJS(src_exports);

// src/spinner.tsx
var import_system = __webpack_require__(84491);
var import_shared_utils = __webpack_require__(42409);
var import_jsx_runtime = __webpack_require__(85893);
var spin = (0, import_system.keyframes)({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = (0, import_system.forwardRef)((props, ref) => {
  const styles = (0, import_system.useStyleConfig)("Spinner", props);
  const {
    label = "Loading...",
    thickness = "2px",
    speed = "0.45s",
    emptyColor = "transparent",
    className,
    ...rest
  } = (0, import_system.omitThemingProps)(props);
  const _className = (0, import_shared_utils.cx)("chakra-spinner", className);
  const spinnerStyles = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: `${spin} ${speed} linear infinite`,
    ...styles
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_system.chakra.div,
    {
      ref,
      __css: spinnerStyles,
      className: _className,
      ...rest,
      children: label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.span, { srOnly: true, children: label })
    }
  );
});
Spinner.displayName = "Spinner";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 84491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSVars: () => CSSVars,
  GlobalStyle: () => GlobalStyle,
  StylesProvider: () => StylesProvider,
  ThemeProvider: () => ThemeProvider,
  chakra: () => chakra,
  createStylesContext: () => createStylesContext,
  forwardRef: () => forwardRef,
  getToken: () => getToken,
  keyframes: () => import_react8.keyframes,
  shouldForwardProp: () => shouldForwardProp,
  styled: () => styled,
  toCSSObject: () => toCSSObject,
  useChakra: () => useChakra,
  useComponentStyles__unstable: () => useComponentStyles__unstable,
  useMultiStyleConfig: () => useMultiStyleConfig,
  useStyleConfig: () => useStyleConfig,
  useStyles: () => useStyles,
  useTheme: () => useTheme,
  useToken: () => useToken
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(24195), module.exports);
__reExport(src_exports, __webpack_require__(77504), module.exports);
var import_react8 = __webpack_require__(43234);

// src/hooks.ts
var import_color_mode = __webpack_require__(24195);

// src/use-theme.ts
var import_react = __webpack_require__(43234);
var import_react2 = __webpack_require__(67294);
function useTheme() {
  const theme = (0, import_react2.useContext)(
    import_react.ThemeContext
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}

// src/hooks.ts
function useChakra() {
  const colorModeResult = (0, import_color_mode.useColorMode)();
  const theme = useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a2, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/providers.tsx
var import_color_mode2 = __webpack_require__(24195);
var import_react_utils = __webpack_require__(32819);
var import_styled_system = __webpack_require__(77504);
var import_utils = __webpack_require__(18171);
var import_react3 = __webpack_require__(43234);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ThemeProvider(props) {
  const { cssVarsRoot, theme, children } = props;
  const computedTheme = (0, import_react4.useMemo)(() => (0, import_styled_system.toCSSVar)(theme), [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, { theme: computedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CSSVars, { root: cssVarsRoot }),
    children
  ] });
}
function CSSVars({ root = ":host, :root" }) {
  const selector = [root, `[data-theme]`].join(",");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react3.Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
}
var [StylesProvider, useStyles] = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: `${componentName}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
  });
}
function GlobalStyle() {
  const { colorMode } = (0, import_color_mode2.useColorMode)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react3.Global,
    {
      styles: (theme) => {
        const styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
        const globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, { theme, colorMode });
        if (!globalStyles)
          return void 0;
        const styles = (0, import_styled_system.css)(globalStyles)(theme);
        return styles;
      }
    }
  );
}

// src/system.ts
var import_color_mode3 = __webpack_require__(24195);
var import_styled_system3 = __webpack_require__(77504);
var import_utils2 = __webpack_require__(18171);
var import_object_utils = __webpack_require__(19707);
var import_styled = __toESM(__webpack_require__(6029));
var import_react5 = __toESM(__webpack_require__(67294));

// src/should-forward-prop.ts
var import_styled_system2 = __webpack_require__(77504);
var allPropNames = /* @__PURE__ */ new Set([
  ...import_styled_system2.propNames,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/system.ts
var _a;
var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0, import_utils2.objectFilter)(rest, (_, prop) => (0, import_styled_system3.isStyleProp)(prop));
  const finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
  const finalStyles = (0, import_object_utils.assignAfter)(
    {},
    __css,
    finalBaseStyle,
    (0, import_utils2.filterUndefined)(styleProps),
    sx
  );
  const computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0, import_color_mode3.useColorMode)();
    return import_react5.default.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}

// src/forward-ref.tsx
var import_react6 = __webpack_require__(67294);
function forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
}

// src/use-style-config.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_utils = __webpack_require__(71024);
var import_utils3 = __webpack_require__(18171);
var import_react7 = __webpack_require__(67294);
var import_react_fast_compare = __toESM(__webpack_require__(69590));
function useStyleConfigImpl(themeKey, props = {}) {
  var _a2;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = useChakra();
  const themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = (0, import_utils3.mergeWith)(
    { theme, colorMode },
    (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {},
    (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"]))
  );
  const stylesRef = (0, import_react7.useRef)({});
  if (styleConfig) {
    const getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a2;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  const styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 71024:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: () => extendBaseTheme,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = __webpack_require__(60);
var import_lodash = __toESM(__webpack_require__(38554));
function isFunction(value) {
  return typeof value === "function";
}
function pipe(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
var createExtendTheme = (theme2) => {
  return function extendTheme2(...extensions) {
    let overrides = [...extensions];
    let activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) && overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe(
      ...overrides.map(
        (extension) => (prevTheme) => isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
      )
    )(activeTheme);
  };
};
var extendTheme = createExtendTheme(import_theme.theme);
var extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function mergeThemeOverride(...overrides) {
  return (0, import_lodash.default)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = isFunction(source) ? source(...args) : source;
      const overrideValue = isFunction(override) ? override(...args) : override;
      return (0, import_lodash.default)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = __webpack_require__(42409);
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withColorScheme = {
            defaultProps: {
              colorScheme
            }
          };
          return [componentName, withColorScheme];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = __webpack_require__(42409);
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withSize = {
            defaultProps: {
              size
            }
          };
          return [componentName, withSize];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = __webpack_require__(42409);
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withVariant = {
            defaultProps: {
              variant
            }
          };
          return [componentName, withVariant];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride(pipe2(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 34382:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  accordionAnatomy: () => accordionAnatomy,
  alertAnatomy: () => alertAnatomy,
  anatomy: () => anatomy,
  avatarAnatomy: () => avatarAnatomy,
  breadcrumbAnatomy: () => breadcrumbAnatomy,
  buttonAnatomy: () => buttonAnatomy,
  cardAnatomy: () => cardAnatomy,
  checkboxAnatomy: () => checkboxAnatomy,
  circularProgressAnatomy: () => circularProgressAnatomy,
  drawerAnatomy: () => drawerAnatomy,
  editableAnatomy: () => editableAnatomy,
  formAnatomy: () => formAnatomy,
  formErrorAnatomy: () => formErrorAnatomy,
  inputAnatomy: () => inputAnatomy,
  listAnatomy: () => listAnatomy,
  menuAnatomy: () => menuAnatomy,
  modalAnatomy: () => modalAnatomy,
  numberInputAnatomy: () => numberInputAnatomy,
  pinInputAnatomy: () => pinInputAnatomy,
  popoverAnatomy: () => popoverAnatomy,
  progressAnatomy: () => progressAnatomy,
  radioAnatomy: () => radioAnatomy,
  selectAnatomy: () => selectAnatomy,
  sliderAnatomy: () => sliderAnatomy,
  statAnatomy: () => statAnatomy,
  switchAnatomy: () => switchAnatomy,
  tableAnatomy: () => tableAnatomy,
  tabsAnatomy: () => tabsAnatomy,
  tagAnatomy: () => tagAnatomy
});
module.exports = __toCommonJS(src_exports);

// src/anatomy.ts
function anatomy(name, map = {}) {
  let called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function parts(...values) {
    assert();
    for (const part of values) {
      ;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend(...parts2) {
    for (const part of parts2) {
      if (part in map)
        continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.selector])
    );
    return value;
  }
  function classnames() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.className])
    );
    return value;
  }
  function toPart(part) {
    const el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    const attr = el.filter(Boolean).join("__");
    const className = `chakra-${attr}`;
    const partObj = {
      className,
      selector: `.${className}`,
      toString: () => part
    };
    return partObj;
  }
  const __type = {};
  return {
    parts,
    toPart,
    extend,
    selectors,
    classnames,
    get keys() {
      return Object.keys(map);
    },
    __type
  };
}

// src/components.ts
var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
var buttonAnatomy = anatomy("button").parts();
var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
var circularProgressAnatomy = anatomy("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy("editable").parts(
  "preview",
  "input",
  "textarea"
);
var formAnatomy = anatomy("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
var formErrorAnatomy = anatomy("formError").parts("text", "icon");
var inputAnatomy = anatomy("input").parts("addon", "field", "element");
var listAnatomy = anatomy("list").parts("container", "item", "icon");
var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
var pinInputAnatomy = anatomy("pininput").parts("field");
var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy("progress").parts(
  "label",
  "filledTrack",
  "track"
);
var radioAnatomy = anatomy("radio").parts(
  "container",
  "control",
  "label"
);
var selectAnatomy = anatomy("select").parts("field", "icon");
var sliderAnatomy = anatomy("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
var statAnatomy = anatomy("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
var switchAnatomy = anatomy("switch").parts(
  "container",
  "track",
  "thumb"
);
var tableAnatomy = anatomy("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
var tabsAnatomy = anatomy("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
var tagAnatomy = anatomy("tag").parts(
  "container",
  "label",
  "closeButton"
);
var cardAnatomy = anatomy("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 65568:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  analyzeBreakpoints: () => analyzeBreakpoints,
  arrayToObjectNotation: () => arrayToObjectNotation,
  breakpoints: () => breakpoints,
  isCustomBreakpoint: () => isCustomBreakpoint,
  isResponsiveObjectLike: () => isResponsiveObjectLike,
  mapResponsive: () => mapResponsive,
  objectToArrayNotation: () => objectToArrayNotation,
  px: () => px,
  toMediaQueryString: () => toMediaQueryString
});
module.exports = __toCommonJS(src_exports);

// src/responsive.ts
var import_shared_utils = __webpack_require__(42409);
var breakpoints = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function mapResponsive(prop, mapper) {
  if (Array.isArray(prop)) {
    return prop.map((item) => item === null ? null : mapper(item));
  }
  if ((0, import_shared_utils.isObject)(prop)) {
    return Object.keys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj, bps = breakpoints) {
  const result = bps.map((br) => {
    var _a;
    return (_a = obj[br]) != null ? _a : null;
  });
  const lastItem = result[result.length - 1];
  while (lastItem === null)
    result.pop();
  return result;
}
function arrayToObjectNotation(values, bps = breakpoints) {
  const result = {};
  values.forEach((value, index) => {
    const key = bps[index];
    if (value == null)
      return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps = breakpoints) {
  const keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every((key) => bps.includes(key));
}
var isCustomBreakpoint = (v) => Number.isNaN(Number(v));

// src/breakpoint.ts
var import_shared_utils2 = __webpack_require__(42409);
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function analyzeCSSValue(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue(value);
  return unitless || typeof value === "number" ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints2) => Object.fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
function normalize(breakpoints2) {
  const sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints2) {
  const value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}
function subtract(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const OFFSET = -0.02;
  return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + OFFSET}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints2) {
  var _a;
  if (!breakpoints2)
    return null;
  breakpoints2.base = (_a = breakpoints2.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints2);
  const queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints2);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    get(key) {
      return queries.find((q) => q.breakpoint === key);
    },
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!(0, import_shared_utils2.isObject)(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 76844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Button: () => Button,
  ButtonGroup: () => ButtonGroup,
  ButtonSpinner: () => ButtonSpinner,
  IconButton: () => IconButton,
  useButtonGroup: () => useButtonGroup
});
module.exports = __toCommonJS(src_exports);

// src/button.tsx
var import_react_use_merge_refs = __webpack_require__(26308);
var import_system3 = __webpack_require__(70767);
var import_shared_utils3 = __webpack_require__(42409);
var import_react4 = __webpack_require__(67294);

// src/button-context.ts
var import_react_context = __webpack_require__(55988);
var [ButtonGroupProvider, useButtonGroup] = (0, import_react_context.createContext)({
  strict: false,
  name: "ButtonGroupContext"
});

// src/button-icon.tsx
var import_system = __webpack_require__(70767);
var import_shared_utils = __webpack_require__(42409);
var import_react = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ButtonIcon(props) {
  const { children, className, ...rest } = props;
  const _children = (0, import_react.isValidElement)(children) ? (0, import_react.cloneElement)(children, {
    "aria-hidden": true,
    focusable: false
  }) : children;
  const _className = (0, import_shared_utils.cx)("chakra-button__icon", className);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_system.chakra.span,
    {
      display: "inline-flex",
      alignSelf: "center",
      flexShrink: 0,
      ...rest,
      className: _className,
      children: _children
    }
  );
}
ButtonIcon.displayName = "ButtonIcon";

// src/button-spinner.tsx
var import_spinner = __webpack_require__(50855);
var import_system2 = __webpack_require__(70767);
var import_shared_utils2 = __webpack_require__(42409);
var import_react2 = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
function ButtonSpinner(props) {
  const {
    label,
    placement,
    spacing = "0.5rem",
    children = /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_spinner.Spinner, { color: "currentColor", width: "1em", height: "1em" }),
    className,
    __css,
    ...rest
  } = props;
  const _className = (0, import_shared_utils2.cx)("chakra-button__spinner", className);
  const marginProp = placement === "start" ? "marginEnd" : "marginStart";
  const spinnerStyles = (0, import_react2.useMemo)(
    () => ({
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute",
      [marginProp]: label ? spacing : 0,
      fontSize: "1em",
      lineHeight: "normal",
      ...__css
    }),
    [__css, label, marginProp, spacing]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_system2.chakra.div, { className: _className, ...rest, __css: spinnerStyles, children });
}
ButtonSpinner.displayName = "ButtonSpinner";

// src/use-button-type.tsx
var import_react3 = __webpack_require__(67294);
function useButtonType(value) {
  const [isButton, setIsButton] = (0, import_react3.useState)(!value);
  const refCallback = (0, import_react3.useCallback)((node) => {
    if (!node)
      return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  const type = isButton ? "button" : void 0;
  return { ref: refCallback, type };
}

// src/button.tsx
var import_jsx_runtime3 = __webpack_require__(85893);
var Button = (0, import_system3.forwardRef)((props, ref) => {
  const group = useButtonGroup();
  const styles = (0, import_system3.useStyleConfig)("Button", { ...group, ...props });
  const {
    isDisabled = group == null ? void 0 : group.isDisabled,
    isLoading,
    isActive,
    children,
    leftIcon,
    rightIcon,
    loadingText,
    iconSpacing = "0.5rem",
    type,
    spinner,
    spinnerPlacement = "start",
    className,
    as,
    ...rest
  } = (0, import_system3.omitThemingProps)(props);
  const buttonStyles = (0, import_react4.useMemo)(() => {
    const _focus = { ...styles == null ? void 0 : styles["_focus"], zIndex: 1 };
    return {
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      ...styles,
      ...!!group && { _focus }
    };
  }, [styles, group]);
  const { ref: _ref, type: defaultType } = useButtonType(as);
  const contentProps = { rightIcon, leftIcon, iconSpacing, children };
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    import_system3.chakra.button,
    {
      disabled: isDisabled || isLoading,
      ref: (0, import_react_use_merge_refs.useMergeRefs)(ref, _ref),
      as,
      type: type != null ? type : defaultType,
      "data-active": (0, import_shared_utils3.dataAttr)(isActive),
      "data-loading": (0, import_shared_utils3.dataAttr)(isLoading),
      __css: buttonStyles,
      className: (0, import_shared_utils3.cx)("chakra-button", className),
      ...rest,
      children: [
        isLoading && spinnerPlacement === "start" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          ButtonSpinner,
          {
            className: "chakra-button__spinner--start",
            label: loadingText,
            placement: "start",
            spacing: iconSpacing,
            children: spinner
          }
        ),
        isLoading ? loadingText || /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_system3.chakra.span, { opacity: 0, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ButtonContent, { ...contentProps }) }) : /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ButtonContent, { ...contentProps }),
        isLoading && spinnerPlacement === "end" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          ButtonSpinner,
          {
            className: "chakra-button__spinner--end",
            label: loadingText,
            placement: "end",
            spacing: iconSpacing,
            children: spinner
          }
        )
      ]
    }
  );
});
Button.displayName = "Button";
function ButtonContent(props) {
  const { leftIcon, rightIcon, children, iconSpacing } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
    leftIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ButtonIcon, { marginEnd: iconSpacing, children: leftIcon }),
    children,
    rightIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(ButtonIcon, { marginStart: iconSpacing, children: rightIcon })
  ] });
}

// src/button-group.tsx
var import_system4 = __webpack_require__(70767);
var import_shared_utils4 = __webpack_require__(42409);
var import_react5 = __webpack_require__(67294);
var import_jsx_runtime4 = __webpack_require__(85893);
var attachedStyles = {
  horizontal: {
    "> *:first-of-type:not(:last-of-type)": { borderEndRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderStartRadius: 0 }
  },
  vertical: {
    "> *:first-of-type:not(:last-of-type)": { borderBottomRadius: 0 },
    "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
    "> *:not(:first-of-type):last-of-type": { borderTopRadius: 0 }
  }
};
var gapStyles = {
  horizontal: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginStart: spacing }
  }),
  vertical: (spacing) => ({
    "& > *:not(style) ~ *:not(style)": { marginTop: spacing }
  })
};
var ButtonGroup = (0, import_system4.forwardRef)(
  function ButtonGroup2(props, ref) {
    const {
      size,
      colorScheme,
      variant,
      className,
      spacing = "0.5rem",
      isAttached,
      isDisabled,
      orientation = "horizontal",
      ...rest
    } = props;
    const _className = (0, import_shared_utils4.cx)("chakra-button__group", className);
    const context = (0, import_react5.useMemo)(
      () => ({ size, colorScheme, variant, isDisabled }),
      [size, colorScheme, variant, isDisabled]
    );
    let groupStyles = {
      display: "inline-flex",
      ...isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing)
    };
    const isVertical = orientation === "vertical";
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ButtonGroupProvider, { value: context, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      import_system4.chakra.div,
      {
        ref,
        role: "group",
        __css: groupStyles,
        className: _className,
        "data-attached": isAttached ? "" : void 0,
        "data-orientation": orientation,
        flexDir: isVertical ? "column" : void 0,
        ...rest
      }
    ) });
  }
);
ButtonGroup.displayName = "ButtonGroup";

// src/icon-button.tsx
var import_system5 = __webpack_require__(70767);
var import_react6 = __webpack_require__(67294);
var import_jsx_runtime5 = __webpack_require__(85893);
var IconButton = (0, import_system5.forwardRef)(
  (props, ref) => {
    const { icon, children, isRound, "aria-label": ariaLabel, ...rest } = props;
    const element = icon || children;
    const _children = (0, import_react6.isValidElement)(element) ? (0, import_react6.cloneElement)(element, {
      "aria-hidden": true,
      focusable: false
    }) : null;
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      Button,
      {
        padding: "0",
        borderRadius: isRound ? "full" : void 0,
        ref,
        "aria-label": ariaLabel,
        ...rest,
        children: _children
      }
    );
  }
);
IconButton.displayName = "IconButton";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 46724:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ColorModeContext: () => ColorModeContext,
  ColorModeProvider: () => ColorModeProvider,
  ColorModeScript: () => ColorModeScript,
  DarkMode: () => DarkMode,
  LightMode: () => LightMode,
  cookieStorageManager: () => cookieStorageManager,
  cookieStorageManagerSSR: () => cookieStorageManagerSSR,
  createCookieStorageManager: () => createCookieStorageManager,
  createLocalStorageManager: () => createLocalStorageManager,
  getScriptSrc: () => getScriptSrc,
  localStorageManager: () => localStorageManager,
  useColorMode: () => useColorMode,
  useColorModeValue: () => useColorModeValue
});
module.exports = __toCommonJS(src_exports);

// src/color-mode-provider.tsx
var import_react_use_safe_layout_effect = __webpack_require__(39404);
var import_react2 = __webpack_require__(67294);

// src/color-mode-context.ts
var import_react = __webpack_require__(67294);
var ColorModeContext = (0, import_react.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0, import_react.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}

// src/color-mode.utils.ts
var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils(options = {}) {
  const { preventTransition = true } = options;
  const utils = {
    setDataset: (value) => {
      const cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(fallback) {
      var _a;
      const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener(fn) {
      const mql = utils.query();
      const listener = (e) => {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function")
        mql.addListener(listener);
      else
        mql.addEventListener("change", listener);
      return () => {
        if (typeof mql.removeListener === "function")
          mql.removeListener(listener);
        else
          mql.removeEventListener("change", listener);
      };
    },
    preventTransition() {
      const css = document.createElement("style");
      css.appendChild(
        document.createTextNode(
          `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
        )
      );
      document.head.appendChild(css);
      return () => {
        ;
        (() => window.getComputedStyle(document.body))();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      let value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {
      }
      return value || init;
    },
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
      }
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get(init) {
      if (cookie)
        return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      return parseCookie(document.cookie, key) || init;
    },
    set(value) {
      document.cookie = `${key}=${value}; max-age=31536000; path=/`;
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = (cookie) => createCookieStorageManager(STORAGE_KEY, cookie);

// src/color-mode-provider.tsx
var import_jsx_runtime = __webpack_require__(85893);
var noop = () => {
};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  const {
    value,
    children,
    options: {
      useSystemColorMode,
      initialColorMode,
      disableTransitionOnChange
    } = {},
    colorModeManager = localStorageManager
  } = props;
  const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  const [colorMode, rawSetColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager, defaultColorMode)
  );
  const [resolvedColorMode, setResolvedColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager)
  );
  const { getSystemTheme, setClassName, setDataset, addListener } = (0, import_react2.useMemo)(
    () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
    [disableTransitionOnChange]
  );
  const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  const setColorMode = (0, import_react2.useCallback)(
    (value2) => {
      const resolved = value2 === "system" ? getSystemTheme() : value2;
      rawSetColorMode(resolved);
      setClassName(resolved === "dark");
      setDataset(resolved);
      colorModeManager.set(resolved);
    },
    [colorModeManager, getSystemTheme, setClassName, setDataset]
  );
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  const toggleColorMode = (0, import_react2.useCallback)(() => {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  (0, import_react2.useEffect)(() => {
    if (!useSystemColorMode)
      return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    }),
    [resolvedValue, toggleColorMode, setColorMode, value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, children });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
LightMode.displayName = "LightMode";

// src/color-mode-script.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var VALID_VALUES = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function normalize(initialColorMode) {
  let value = initialColorMode;
  if (!VALID_VALUES.has(value))
    value = "light";
  return value;
}
function getScriptSrc(props = {}) {
  const {
    initialColorMode = "light",
    type = "localStorage",
    storageKey: key = "chakra-ui-color-mode"
  } = props;
  const init = normalize(initialColorMode);
  const isCookie = type === "cookie";
  const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
  const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  const fn = isCookie ? cookieScript : localStorageScript;
  return `!${fn}`.trim();
}
function ColorModeScript(props = {}) {
  const { nonce } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "script",
    {
      id: "chakra-script",
      nonce,
      dangerouslySetInnerHTML: { __html: getScriptSrc(props) }
    }
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 55988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createContext: () => createContext
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function getErrorMessage(hook, provider) {
  return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage
  } = options;
  const Context = (0, import_react.createContext)(void 0);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = (0, import_react.useContext)(Context);
    if (!context && strict) {
      const error = new Error(
        errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName)
      );
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 26308:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  assignRef: () => assignRef,
  mergeRefs: () => mergeRefs,
  useMergeRefs: () => useMergeRefs
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function assignRef(ref, value) {
  if (ref == null)
    return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}
function useMergeRefs(...refs) {
  return (0, import_react.useMemo)(() => mergeRefs(...refs), refs);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 39404:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSafeLayoutEffect: () => useSafeLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? import_react.useLayoutEffect : import_react.useEffect;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 50855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Spinner: () => Spinner
});
module.exports = __toCommonJS(src_exports);

// src/spinner.tsx
var import_system = __webpack_require__(70767);
var import_shared_utils = __webpack_require__(42409);
var import_jsx_runtime = __webpack_require__(85893);
var spin = (0, import_system.keyframes)({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
});
var Spinner = (0, import_system.forwardRef)((props, ref) => {
  const styles = (0, import_system.useStyleConfig)("Spinner", props);
  const {
    label = "Loading...",
    thickness = "2px",
    speed = "0.45s",
    emptyColor = "transparent",
    className,
    ...rest
  } = (0, import_system.omitThemingProps)(props);
  const _className = (0, import_shared_utils.cx)("chakra-spinner", className);
  const spinnerStyles = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: thickness,
    borderBottomColor: emptyColor,
    borderLeftColor: emptyColor,
    animation: `${spin} ${speed} linear infinite`,
    ...styles
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_system.chakra.div,
    {
      ref,
      __css: spinnerStyles,
      className: _className,
      ...rest,
      children: label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.span, { srOnly: true, children: label })
    }
  );
});
Spinner.displayName = "Spinner";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 70767:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSVars: () => CSSVars,
  GlobalStyle: () => GlobalStyle,
  StylesProvider: () => StylesProvider,
  ThemeProvider: () => ThemeProvider,
  chakra: () => chakra,
  createStylesContext: () => createStylesContext,
  forwardRef: () => forwardRef,
  getToken: () => getToken,
  keyframes: () => import_react8.keyframes,
  shouldForwardProp: () => shouldForwardProp,
  styled: () => styled,
  toCSSObject: () => toCSSObject,
  useChakra: () => useChakra,
  useComponentStyles__unstable: () => useComponentStyles__unstable,
  useMultiStyleConfig: () => useMultiStyleConfig,
  useStyleConfig: () => useStyleConfig,
  useStyles: () => useStyles,
  useTheme: () => useTheme,
  useToken: () => useToken
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(46724), module.exports);
__reExport(src_exports, __webpack_require__(77504), module.exports);
var import_react8 = __webpack_require__(43234);

// src/hooks.ts
var import_color_mode = __webpack_require__(46724);

// src/use-theme.ts
var import_react = __webpack_require__(43234);
var import_react2 = __webpack_require__(67294);
function useTheme() {
  const theme = (0, import_react2.useContext)(
    import_react.ThemeContext
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}

// src/hooks.ts
function useChakra() {
  const colorModeResult = (0, import_color_mode.useColorMode)();
  const theme = useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a2, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/providers.tsx
var import_color_mode2 = __webpack_require__(46724);
var import_react_utils = __webpack_require__(32819);
var import_styled_system = __webpack_require__(77504);
var import_utils = __webpack_require__(18171);
var import_react3 = __webpack_require__(43234);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ThemeProvider(props) {
  const { cssVarsRoot, theme, children } = props;
  const computedTheme = (0, import_react4.useMemo)(() => (0, import_styled_system.toCSSVar)(theme), [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, { theme: computedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CSSVars, { root: cssVarsRoot }),
    children
  ] });
}
function CSSVars({ root = ":host, :root" }) {
  const selector = [root, `[data-theme]`].join(",");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react3.Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
}
var [StylesProvider, useStyles] = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: `${componentName}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
  });
}
function GlobalStyle() {
  const { colorMode } = (0, import_color_mode2.useColorMode)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react3.Global,
    {
      styles: (theme) => {
        const styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
        const globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, { theme, colorMode });
        if (!globalStyles)
          return void 0;
        const styles = (0, import_styled_system.css)(globalStyles)(theme);
        return styles;
      }
    }
  );
}

// src/system.ts
var import_color_mode3 = __webpack_require__(46724);
var import_styled_system3 = __webpack_require__(77504);
var import_utils2 = __webpack_require__(18171);
var import_object_utils = __webpack_require__(19707);
var import_styled = __toESM(__webpack_require__(6029));
var import_react5 = __toESM(__webpack_require__(67294));

// src/should-forward-prop.ts
var import_styled_system2 = __webpack_require__(77504);
var allPropNames = /* @__PURE__ */ new Set([
  ...import_styled_system2.propNames,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/system.ts
var _a;
var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0, import_utils2.objectFilter)(rest, (_, prop) => (0, import_styled_system3.isStyleProp)(prop));
  const finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
  const finalStyles = (0, import_object_utils.assignAfter)(
    {},
    __css,
    finalBaseStyle,
    (0, import_utils2.filterUndefined)(styleProps),
    sx
  );
  const computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0, import_color_mode3.useColorMode)();
    return import_react5.default.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}

// src/forward-ref.tsx
var import_react6 = __webpack_require__(67294);
function forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
}

// src/use-style-config.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_utils = __webpack_require__(67362);
var import_utils3 = __webpack_require__(18171);
var import_react7 = __webpack_require__(67294);
var import_react_fast_compare = __toESM(__webpack_require__(69590));
function useStyleConfigImpl(themeKey, props = {}) {
  var _a2;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = useChakra();
  const themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = (0, import_utils3.mergeWith)(
    { theme, colorMode },
    (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {},
    (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"]))
  );
  const stylesRef = (0, import_react7.useRef)({});
  if (styleConfig) {
    const getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a2;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  const styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 67362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: () => extendBaseTheme,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = __webpack_require__(60);
var import_lodash = __toESM(__webpack_require__(38554));
function isFunction(value) {
  return typeof value === "function";
}
function pipe(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
var createExtendTheme = (theme2) => {
  return function extendTheme2(...extensions) {
    let overrides = [...extensions];
    let activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) && overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe(
      ...overrides.map(
        (extension) => (prevTheme) => isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
      )
    )(activeTheme);
  };
};
var extendTheme = createExtendTheme(import_theme.theme);
var extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function mergeThemeOverride(...overrides) {
  return (0, import_lodash.default)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = isFunction(source) ? source(...args) : source;
      const overrideValue = isFunction(override) ? override(...args) : override;
      return (0, import_lodash.default)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = __webpack_require__(42409);
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withColorScheme = {
            defaultProps: {
              colorScheme
            }
          };
          return [componentName, withColorScheme];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = __webpack_require__(42409);
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withSize = {
            defaultProps: {
              size
            }
          };
          return [componentName, withSize];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = __webpack_require__(42409);
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withVariant = {
            defaultProps: {
              variant
            }
          };
          return [componentName, withVariant];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride(pipe2(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 56766:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CloseButton: () => CloseButton
});
module.exports = __toCommonJS(src_exports);

// src/close-button.tsx
var import_icon = __webpack_require__(28446);
var import_system = __webpack_require__(18691);
var import_jsx_runtime = __webpack_require__(85893);
function CloseIcon(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_icon.Icon, { focusable: "false", "aria-hidden": true, ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "path",
    {
      fill: "currentColor",
      d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
    }
  ) });
}
var CloseButton = (0, import_system.forwardRef)(
  function CloseButton2(props, ref) {
    const styles = (0, import_system.useStyleConfig)("CloseButton", props);
    const { children, isDisabled, __css, ...rest } = (0, import_system.omitThemingProps)(props);
    const baseStyle = {
      outline: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0
    };
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_system.chakra.button,
      {
        type: "button",
        "aria-label": "Close",
        ref,
        disabled: isDisabled,
        __css: {
          ...baseStyle,
          ...styles,
          ...__css
        },
        ...rest,
        children: children || /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CloseIcon, { width: "1em", height: "1em" })
      }
    );
  }
);
CloseButton.displayName = "CloseButton";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 78727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ColorModeContext: () => ColorModeContext,
  ColorModeProvider: () => ColorModeProvider,
  ColorModeScript: () => ColorModeScript,
  DarkMode: () => DarkMode,
  LightMode: () => LightMode,
  cookieStorageManager: () => cookieStorageManager,
  cookieStorageManagerSSR: () => cookieStorageManagerSSR,
  createCookieStorageManager: () => createCookieStorageManager,
  createLocalStorageManager: () => createLocalStorageManager,
  getScriptSrc: () => getScriptSrc,
  localStorageManager: () => localStorageManager,
  useColorMode: () => useColorMode,
  useColorModeValue: () => useColorModeValue
});
module.exports = __toCommonJS(src_exports);

// src/color-mode-provider.tsx
var import_react_use_safe_layout_effect = __webpack_require__(79464);
var import_react2 = __webpack_require__(67294);

// src/color-mode-context.ts
var import_react = __webpack_require__(67294);
var ColorModeContext = (0, import_react.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0, import_react.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}

// src/color-mode.utils.ts
var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils(options = {}) {
  const { preventTransition = true } = options;
  const utils = {
    setDataset: (value) => {
      const cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(fallback) {
      var _a;
      const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener(fn) {
      const mql = utils.query();
      const listener = (e) => {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function")
        mql.addListener(listener);
      else
        mql.addEventListener("change", listener);
      return () => {
        if (typeof mql.removeListener === "function")
          mql.removeListener(listener);
        else
          mql.removeEventListener("change", listener);
      };
    },
    preventTransition() {
      const css = document.createElement("style");
      css.appendChild(
        document.createTextNode(
          `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
        )
      );
      document.head.appendChild(css);
      return () => {
        ;
        (() => window.getComputedStyle(document.body))();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      let value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {
      }
      return value || init;
    },
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
      }
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get(init) {
      if (cookie)
        return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      return parseCookie(document.cookie, key) || init;
    },
    set(value) {
      document.cookie = `${key}=${value}; max-age=31536000; path=/`;
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = (cookie) => createCookieStorageManager(STORAGE_KEY, cookie);

// src/color-mode-provider.tsx
var import_jsx_runtime = __webpack_require__(85893);
var noop = () => {
};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  const {
    value,
    children,
    options: {
      useSystemColorMode,
      initialColorMode,
      disableTransitionOnChange
    } = {},
    colorModeManager = localStorageManager
  } = props;
  const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  const [colorMode, rawSetColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager, defaultColorMode)
  );
  const [resolvedColorMode, setResolvedColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager)
  );
  const { getSystemTheme, setClassName, setDataset, addListener } = (0, import_react2.useMemo)(
    () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
    [disableTransitionOnChange]
  );
  const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  const setColorMode = (0, import_react2.useCallback)(
    (value2) => {
      const resolved = value2 === "system" ? getSystemTheme() : value2;
      rawSetColorMode(resolved);
      setClassName(resolved === "dark");
      setDataset(resolved);
      colorModeManager.set(resolved);
    },
    [colorModeManager, getSystemTheme, setClassName, setDataset]
  );
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  const toggleColorMode = (0, import_react2.useCallback)(() => {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  (0, import_react2.useEffect)(() => {
    if (!useSystemColorMode)
      return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    }),
    [resolvedValue, toggleColorMode, setColorMode, value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, children });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
LightMode.displayName = "LightMode";

// src/color-mode-script.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var VALID_VALUES = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function normalize(initialColorMode) {
  let value = initialColorMode;
  if (!VALID_VALUES.has(value))
    value = "light";
  return value;
}
function getScriptSrc(props = {}) {
  const {
    initialColorMode = "light",
    type = "localStorage",
    storageKey: key = "chakra-ui-color-mode"
  } = props;
  const init = normalize(initialColorMode);
  const isCookie = type === "cookie";
  const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
  const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  const fn = isCookie ? cookieScript : localStorageScript;
  return `!${fn}`.trim();
}
function ColorModeScript(props = {}) {
  const { nonce } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "script",
    {
      id: "chakra-script",
      nonce,
      dangerouslySetInnerHTML: { __html: getScriptSrc(props) }
    }
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 28446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Icon: () => Icon,
  createIcon: () => createIcon,
  default: () => icon_default
});
module.exports = __toCommonJS(src_exports);

// src/icon.tsx
var import_system = __webpack_require__(18691);
var import_shared_utils = __webpack_require__(42409);
var import_jsx_runtime = __webpack_require__(85893);
var fallbackIcon = {
  path: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
};
var Icon = (0, import_system.forwardRef)((props, ref) => {
  const {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css,
    ...rest
  } = props;
  const _className = (0, import_shared_utils.cx)("chakra-icon", className);
  const customStyles = (0, import_system.useStyleConfig)("Icon", props);
  const styles = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color,
    ...__css,
    ...customStyles
  };
  const shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };
  const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { as: element, ...shared, ...rest });
  }
  const _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
});
Icon.displayName = "Icon";
var icon_default = Icon;

// src/create-icon.tsx
var import_system2 = __webpack_require__(18691);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = import_react.Children.toArray(options.path);
  const Comp = (0, import_system2.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Icon, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 79464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSafeLayoutEffect: () => useSafeLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? import_react.useLayoutEffect : import_react.useEffect;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 18691:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSVars: () => CSSVars,
  GlobalStyle: () => GlobalStyle,
  StylesProvider: () => StylesProvider,
  ThemeProvider: () => ThemeProvider,
  chakra: () => chakra,
  createStylesContext: () => createStylesContext,
  forwardRef: () => forwardRef,
  getToken: () => getToken,
  keyframes: () => import_react8.keyframes,
  shouldForwardProp: () => shouldForwardProp,
  styled: () => styled,
  toCSSObject: () => toCSSObject,
  useChakra: () => useChakra,
  useComponentStyles__unstable: () => useComponentStyles__unstable,
  useMultiStyleConfig: () => useMultiStyleConfig,
  useStyleConfig: () => useStyleConfig,
  useStyles: () => useStyles,
  useTheme: () => useTheme,
  useToken: () => useToken
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(78727), module.exports);
__reExport(src_exports, __webpack_require__(77504), module.exports);
var import_react8 = __webpack_require__(43234);

// src/hooks.ts
var import_color_mode = __webpack_require__(78727);

// src/use-theme.ts
var import_react = __webpack_require__(43234);
var import_react2 = __webpack_require__(67294);
function useTheme() {
  const theme = (0, import_react2.useContext)(
    import_react.ThemeContext
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}

// src/hooks.ts
function useChakra() {
  const colorModeResult = (0, import_color_mode.useColorMode)();
  const theme = useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a2, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/providers.tsx
var import_color_mode2 = __webpack_require__(78727);
var import_react_utils = __webpack_require__(32819);
var import_styled_system = __webpack_require__(77504);
var import_utils = __webpack_require__(18171);
var import_react3 = __webpack_require__(43234);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ThemeProvider(props) {
  const { cssVarsRoot, theme, children } = props;
  const computedTheme = (0, import_react4.useMemo)(() => (0, import_styled_system.toCSSVar)(theme), [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, { theme: computedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CSSVars, { root: cssVarsRoot }),
    children
  ] });
}
function CSSVars({ root = ":host, :root" }) {
  const selector = [root, `[data-theme]`].join(",");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react3.Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
}
var [StylesProvider, useStyles] = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: `${componentName}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
  });
}
function GlobalStyle() {
  const { colorMode } = (0, import_color_mode2.useColorMode)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react3.Global,
    {
      styles: (theme) => {
        const styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
        const globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, { theme, colorMode });
        if (!globalStyles)
          return void 0;
        const styles = (0, import_styled_system.css)(globalStyles)(theme);
        return styles;
      }
    }
  );
}

// src/system.ts
var import_color_mode3 = __webpack_require__(78727);
var import_styled_system3 = __webpack_require__(77504);
var import_utils2 = __webpack_require__(18171);
var import_object_utils = __webpack_require__(19707);
var import_styled = __toESM(__webpack_require__(6029));
var import_react5 = __toESM(__webpack_require__(67294));

// src/should-forward-prop.ts
var import_styled_system2 = __webpack_require__(77504);
var allPropNames = /* @__PURE__ */ new Set([
  ...import_styled_system2.propNames,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/system.ts
var _a;
var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0, import_utils2.objectFilter)(rest, (_, prop) => (0, import_styled_system3.isStyleProp)(prop));
  const finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
  const finalStyles = (0, import_object_utils.assignAfter)(
    {},
    __css,
    finalBaseStyle,
    (0, import_utils2.filterUndefined)(styleProps),
    sx
  );
  const computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0, import_color_mode3.useColorMode)();
    return import_react5.default.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}

// src/forward-ref.tsx
var import_react6 = __webpack_require__(67294);
function forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
}

// src/use-style-config.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_utils = __webpack_require__(92220);
var import_utils3 = __webpack_require__(18171);
var import_react7 = __webpack_require__(67294);
var import_react_fast_compare = __toESM(__webpack_require__(69590));
function useStyleConfigImpl(themeKey, props = {}) {
  var _a2;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = useChakra();
  const themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = (0, import_utils3.mergeWith)(
    { theme, colorMode },
    (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {},
    (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"]))
  );
  const stylesRef = (0, import_react7.useRef)({});
  if (styleConfig) {
    const getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a2;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  const styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 92220:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: () => extendBaseTheme,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = __webpack_require__(60);
var import_lodash = __toESM(__webpack_require__(38554));
function isFunction(value) {
  return typeof value === "function";
}
function pipe(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
var createExtendTheme = (theme2) => {
  return function extendTheme2(...extensions) {
    let overrides = [...extensions];
    let activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) && overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe(
      ...overrides.map(
        (extension) => (prevTheme) => isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
      )
    )(activeTheme);
  };
};
var extendTheme = createExtendTheme(import_theme.theme);
var extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function mergeThemeOverride(...overrides) {
  return (0, import_lodash.default)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = isFunction(source) ? source(...args) : source;
      const overrideValue = isFunction(override) ? override(...args) : override;
      return (0, import_lodash.default)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = __webpack_require__(42409);
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withColorScheme = {
            defaultProps: {
              colorScheme
            }
          };
          return [componentName, withColorScheme];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = __webpack_require__(42409);
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withSize = {
            defaultProps: {
              size
            }
          };
          return [componentName, withSize];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = __webpack_require__(42409);
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withVariant = {
            defaultProps: {
              variant
            }
          };
          return [componentName, withVariant];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride(pipe2(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 85080:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  contains: () => contains,
  getActiveElement: () => getActiveElement,
  getAllFocusable: () => getAllFocusable,
  getAllTabbable: () => getAllTabbable,
  getEventWindow: () => getEventWindow,
  getFirstFocusable: () => getFirstFocusable,
  getFirstTabbableIn: () => getFirstTabbableIn,
  getLastTabbableIn: () => getLastTabbableIn,
  getNextTabbable: () => getNextTabbable,
  getOwnerDocument: () => getOwnerDocument,
  getOwnerWindow: () => getOwnerWindow,
  getPreviousTabbable: () => getPreviousTabbable,
  getScrollParent: () => getScrollParent,
  hasDisplayNone: () => hasDisplayNone,
  hasFocusWithin: () => hasFocusWithin,
  hasNegativeTabIndex: () => hasNegativeTabIndex,
  hasTabIndex: () => hasTabIndex,
  isActiveElement: () => isActiveElement,
  isBrowser: () => isBrowser,
  isContentEditable: () => isContentEditable,
  isDisabled: () => isDisabled,
  isElement: () => isElement,
  isFocusable: () => isFocusable,
  isHTMLElement: () => isHTMLElement,
  isHidden: () => isHidden,
  isInputElement: () => isInputElement,
  isTabbable: () => isTabbable
});
module.exports = __toCommonJS(src_exports);

// src/dom.ts
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el))
    return false;
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return (_b = (_a = getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window;
}
function getOwnerDocument(node) {
  return isElement(node) ? node.ownerDocument : document;
}
function getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function isBrowser() {
  return Boolean(globalThis == null ? void 0 : globalThis.document);
}
function getActiveElement(node) {
  return getOwnerDocument(node).activeElement;
}
function contains(parent, child) {
  if (!parent)
    return false;
  return parent === child || parent.contains(child);
}

// src/tabbable.ts
var hasDisplayNone = (element) => window.getComputedStyle(element).display === "none";
var hasTabIndex = (element) => element.hasAttribute("tabindex");
var hasNegativeTabIndex = (element) => hasTabIndex(element) && element.tabIndex === -1;
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isInputElement(element) {
  return isHTMLElement(element) && element.localName === "input" && "select" in element;
}
function isActiveElement(element) {
  const doc = isHTMLElement(element) ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function hasFocusWithin(element) {
  if (!document.activeElement)
    return false;
  return element.contains(document.activeElement);
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement))
    return true;
  return element.hidden;
}
function isContentEditable(element) {
  const value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }
  const { localName } = element;
  const focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0)
    return true;
  const others = {
    a: () => element.hasAttribute("href"),
    audio: () => element.hasAttribute("controls"),
    video: () => element.hasAttribute("controls")
  };
  if (localName in others) {
    return others[localName]();
  }
  if (isContentEditable(element))
    return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element)
    return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

// src/scroll.ts
function isScrollParent(el) {
  const win = el.ownerDocument.defaultView || window;
  const { overflow, overflowX, overflowY } = win.getComputedStyle(el);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getParent(el) {
  if (el.localName === "html")
    return el;
  return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
}
function getScrollParent(el) {
  if (["html", "body", "#document"].includes(el.localName)) {
    return el.ownerDocument.body;
  }
  if (isHTMLElement(el) && isScrollParent(el)) {
    return el;
  }
  return getScrollParent(getParent(el));
}

// src/index.ts
var focusableElList = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
];
var focusableElSelector = focusableElList.join();
var isVisible = (el) => el.offsetWidth > 0 && el.offsetHeight > 0;
function getAllFocusable(container) {
  const focusableEls = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  focusableEls.unshift(container);
  return focusableEls.filter((el) => isFocusable(el) && isVisible(el));
}
function getFirstFocusable(container) {
  const allFocusable = getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function getAllTabbable(container, fallbackToFocusable) {
  const allFocusable = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  const allTabbable = allFocusable.filter(isTabbable);
  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }
  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }
  return allTabbable;
}
function getFirstTabbableIn(container, fallbackToFocusable) {
  const [first] = getAllTabbable(container, fallbackToFocusable);
  return first || null;
}
function getLastTabbableIn(container, fallbackToFocusable) {
  const allTabbable = getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function getNextTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container);
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function getPreviousTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container).reverse();
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 40261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Hide: () => Hide,
  Show: () => Show,
  useBreakpoint: () => useBreakpoint,
  useBreakpointValue: () => useBreakpointValue,
  useColorModePreference: () => useColorModePreference,
  useMediaQuery: () => useMediaQuery,
  usePrefersReducedMotion: () => usePrefersReducedMotion,
  useQuery: () => useQuery
});
module.exports = __toCommonJS(src_exports);

// src/media-query.tsx
var import_system = __webpack_require__(64427);
var getBreakpoint = (theme, value) => {
  var _a, _b;
  return (_b = (_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) != null ? _b : value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0, import_system.useTheme)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts
var import_react_env = __webpack_require__(97925);
var import_react = __webpack_require__(67294);
function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const { getWindow } = (0, import_react_env.useEnvironment)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0, import_react.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : getWindow().matchMedia(query2).matches
    }));
  });
  (0, import_react.useEffect)(() => {
    const win = getWindow();
    setValue(
      queries.map((query2) => ({
        media: query2,
        matches: win.matchMedia(query2).matches
      }))
    );
    const mql = queries.map((query2) => win.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [getWindow]);
  return value.map((item) => item.matches);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/hide.tsx
var import_jsx_runtime = __webpack_require__(85893);
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Visibility, { breakpoint: query, hide: true, ssr, children });
}
Hide.displayName = "Hide";

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery(
    "(prefers-reduced-motion: reduce)",
    options
  );
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(
    ["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"],
    options
  );
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/show.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Visibility, { breakpoint: query, ssr, children });
}
Show.displayName = "Show";

// src/use-breakpoint.ts
var import_system2 = __webpack_require__(64427);
var import_shared_utils = __webpack_require__(42409);
function useBreakpoint(arg) {
  var _a, _b;
  const opts = (0, import_shared_utils.isObject)(arg) ? arg : { fallback: arg != null ? arg : "base" };
  const theme = (0, import_system2.useTheme)();
  const breakpoints = theme.__breakpoints.details.map(
    ({ minMaxQuery, breakpoint }) => ({
      breakpoint,
      query: minMaxQuery.replace("@media screen and ", "")
    })
  );
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(
    breakpoints.map((bp) => bp.query),
    { fallback, ssr: opts.ssr }
  );
  const index = values.findIndex((value) => value == true);
  return (_b = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) != null ? _b : opts.fallback;
}

// src/use-breakpoint-value.ts
var import_system3 = __webpack_require__(64427);
var import_shared_utils2 = __webpack_require__(42409);
var import_breakpoint_utils2 = __webpack_require__(65568);

// src/media-query.utils.ts
var import_breakpoint_utils = __webpack_require__(65568);
function getClosestValue(values, breakpoint, breakpoints = import_breakpoint_utils.breakpoints) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = (0, import_shared_utils2.isObject)(arg) ? arg : { fallback: arg != null ? arg : "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0, import_system3.useTheme)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(
    Object.entries((0, import_breakpoint_utils2.arrayToObjectNotation)(values, breakpoints)).map(
      ([key, value]) => [key, value]
    )
  ) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 52748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ColorModeContext: () => ColorModeContext,
  ColorModeProvider: () => ColorModeProvider,
  ColorModeScript: () => ColorModeScript,
  DarkMode: () => DarkMode,
  LightMode: () => LightMode,
  cookieStorageManager: () => cookieStorageManager,
  cookieStorageManagerSSR: () => cookieStorageManagerSSR,
  createCookieStorageManager: () => createCookieStorageManager,
  createLocalStorageManager: () => createLocalStorageManager,
  getScriptSrc: () => getScriptSrc,
  localStorageManager: () => localStorageManager,
  useColorMode: () => useColorMode,
  useColorModeValue: () => useColorModeValue
});
module.exports = __toCommonJS(src_exports);

// src/color-mode-provider.tsx
var import_react_use_safe_layout_effect = __webpack_require__(61683);
var import_react2 = __webpack_require__(67294);

// src/color-mode-context.ts
var import_react = __webpack_require__(67294);
var ColorModeContext = (0, import_react.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0, import_react.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}

// src/color-mode.utils.ts
var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils(options = {}) {
  const { preventTransition = true } = options;
  const utils = {
    setDataset: (value) => {
      const cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(fallback) {
      var _a;
      const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener(fn) {
      const mql = utils.query();
      const listener = (e) => {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function")
        mql.addListener(listener);
      else
        mql.addEventListener("change", listener);
      return () => {
        if (typeof mql.removeListener === "function")
          mql.removeListener(listener);
        else
          mql.removeEventListener("change", listener);
      };
    },
    preventTransition() {
      const css = document.createElement("style");
      css.appendChild(
        document.createTextNode(
          `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
        )
      );
      document.head.appendChild(css);
      return () => {
        ;
        (() => window.getComputedStyle(document.body))();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      let value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {
      }
      return value || init;
    },
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
      }
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get(init) {
      if (cookie)
        return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      return parseCookie(document.cookie, key) || init;
    },
    set(value) {
      document.cookie = `${key}=${value}; max-age=31536000; path=/`;
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = (cookie) => createCookieStorageManager(STORAGE_KEY, cookie);

// src/color-mode-provider.tsx
var import_jsx_runtime = __webpack_require__(85893);
var noop = () => {
};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  const {
    value,
    children,
    options: {
      useSystemColorMode,
      initialColorMode,
      disableTransitionOnChange
    } = {},
    colorModeManager = localStorageManager
  } = props;
  const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  const [colorMode, rawSetColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager, defaultColorMode)
  );
  const [resolvedColorMode, setResolvedColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager)
  );
  const { getSystemTheme, setClassName, setDataset, addListener } = (0, import_react2.useMemo)(
    () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
    [disableTransitionOnChange]
  );
  const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  const setColorMode = (0, import_react2.useCallback)(
    (value2) => {
      const resolved = value2 === "system" ? getSystemTheme() : value2;
      rawSetColorMode(resolved);
      setClassName(resolved === "dark");
      setDataset(resolved);
      colorModeManager.set(resolved);
    },
    [colorModeManager, getSystemTheme, setClassName, setDataset]
  );
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  const toggleColorMode = (0, import_react2.useCallback)(() => {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  (0, import_react2.useEffect)(() => {
    if (!useSystemColorMode)
      return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    }),
    [resolvedValue, toggleColorMode, setColorMode, value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, children });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
LightMode.displayName = "LightMode";

// src/color-mode-script.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var VALID_VALUES = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function normalize(initialColorMode) {
  let value = initialColorMode;
  if (!VALID_VALUES.has(value))
    value = "light";
  return value;
}
function getScriptSrc(props = {}) {
  const {
    initialColorMode = "light",
    type = "localStorage",
    storageKey: key = "chakra-ui-color-mode"
  } = props;
  const init = normalize(initialColorMode);
  const isCookie = type === "cookie";
  const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
  const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  const fn = isCookie ? cookieScript : localStorageScript;
  return `!${fn}`.trim();
}
function ColorModeScript(props = {}) {
  const { nonce } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "script",
    {
      id: "chakra-script",
      nonce,
      dangerouslySetInnerHTML: { __html: getScriptSrc(props) }
    }
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 97925:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  EnvironmentProvider: () => EnvironmentProvider,
  useEnvironment: () => useEnvironment
});
module.exports = __toCommonJS(src_exports);

// src/env.tsx
var import_react_use_safe_layout_effect = __webpack_require__(61683);
var import_react = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
var EnvironmentContext = (0, import_react.createContext)({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
EnvironmentContext.displayName = "EnvironmentContext";
function useEnvironment({ defer } = {}) {
  const [, forceUpdate] = (0, import_react.useReducer)((c) => c + 1, 0);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (!defer)
      return;
    forceUpdate();
  }, [defer]);
  return (0, import_react.useContext)(EnvironmentContext);
}
function EnvironmentProvider(props) {
  const { children, environment: environmentProp, disabled } = props;
  const ref = (0, import_react.useRef)(null);
  const context = (0, import_react.useMemo)(() => {
    if (environmentProp)
      return environmentProp;
    return {
      getDocument: () => {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
      },
      getWindow: () => {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
      }
    };
  }, [environmentProp]);
  const showSpan = !disabled || !environmentProp;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(EnvironmentContext.Provider, { value: context, children: [
    children,
    showSpan && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { id: "__chakra_env", hidden: true, ref })
  ] });
}
EnvironmentProvider.displayName = "EnvironmentProvider";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 61683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSafeLayoutEffect: () => useSafeLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? import_react.useLayoutEffect : import_react.useEffect;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 64427:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSVars: () => CSSVars,
  GlobalStyle: () => GlobalStyle,
  StylesProvider: () => StylesProvider,
  ThemeProvider: () => ThemeProvider,
  chakra: () => chakra,
  createStylesContext: () => createStylesContext,
  forwardRef: () => forwardRef,
  getToken: () => getToken,
  keyframes: () => import_react8.keyframes,
  shouldForwardProp: () => shouldForwardProp,
  styled: () => styled,
  toCSSObject: () => toCSSObject,
  useChakra: () => useChakra,
  useComponentStyles__unstable: () => useComponentStyles__unstable,
  useMultiStyleConfig: () => useMultiStyleConfig,
  useStyleConfig: () => useStyleConfig,
  useStyles: () => useStyles,
  useTheme: () => useTheme,
  useToken: () => useToken
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(52748), module.exports);
__reExport(src_exports, __webpack_require__(77504), module.exports);
var import_react8 = __webpack_require__(43234);

// src/hooks.ts
var import_color_mode = __webpack_require__(52748);

// src/use-theme.ts
var import_react = __webpack_require__(43234);
var import_react2 = __webpack_require__(67294);
function useTheme() {
  const theme = (0, import_react2.useContext)(
    import_react.ThemeContext
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}

// src/hooks.ts
function useChakra() {
  const colorModeResult = (0, import_color_mode.useColorMode)();
  const theme = useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a2, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/providers.tsx
var import_color_mode2 = __webpack_require__(52748);
var import_react_utils = __webpack_require__(32819);
var import_styled_system = __webpack_require__(77504);
var import_utils = __webpack_require__(18171);
var import_react3 = __webpack_require__(43234);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ThemeProvider(props) {
  const { cssVarsRoot, theme, children } = props;
  const computedTheme = (0, import_react4.useMemo)(() => (0, import_styled_system.toCSSVar)(theme), [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, { theme: computedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CSSVars, { root: cssVarsRoot }),
    children
  ] });
}
function CSSVars({ root = ":host, :root" }) {
  const selector = [root, `[data-theme]`].join(",");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react3.Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
}
var [StylesProvider, useStyles] = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: `${componentName}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
  });
}
function GlobalStyle() {
  const { colorMode } = (0, import_color_mode2.useColorMode)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react3.Global,
    {
      styles: (theme) => {
        const styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
        const globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, { theme, colorMode });
        if (!globalStyles)
          return void 0;
        const styles = (0, import_styled_system.css)(globalStyles)(theme);
        return styles;
      }
    }
  );
}

// src/system.ts
var import_color_mode3 = __webpack_require__(52748);
var import_styled_system3 = __webpack_require__(77504);
var import_utils2 = __webpack_require__(18171);
var import_object_utils = __webpack_require__(19707);
var import_styled = __toESM(__webpack_require__(6029));
var import_react5 = __toESM(__webpack_require__(67294));

// src/should-forward-prop.ts
var import_styled_system2 = __webpack_require__(77504);
var allPropNames = /* @__PURE__ */ new Set([
  ...import_styled_system2.propNames,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/system.ts
var _a;
var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0, import_utils2.objectFilter)(rest, (_, prop) => (0, import_styled_system3.isStyleProp)(prop));
  const finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
  const finalStyles = (0, import_object_utils.assignAfter)(
    {},
    __css,
    finalBaseStyle,
    (0, import_utils2.filterUndefined)(styleProps),
    sx
  );
  const computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0, import_color_mode3.useColorMode)();
    return import_react5.default.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}

// src/forward-ref.tsx
var import_react6 = __webpack_require__(67294);
function forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
}

// src/use-style-config.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_utils = __webpack_require__(49421);
var import_utils3 = __webpack_require__(18171);
var import_react7 = __webpack_require__(67294);
var import_react_fast_compare = __toESM(__webpack_require__(69590));
function useStyleConfigImpl(themeKey, props = {}) {
  var _a2;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = useChakra();
  const themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = (0, import_utils3.mergeWith)(
    { theme, colorMode },
    (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {},
    (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"]))
  );
  const stylesRef = (0, import_react7.useRef)({});
  if (styleConfig) {
    const getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a2;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  const styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 49421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: () => extendBaseTheme,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = __webpack_require__(60);
var import_lodash = __toESM(__webpack_require__(38554));
function isFunction(value) {
  return typeof value === "function";
}
function pipe(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
var createExtendTheme = (theme2) => {
  return function extendTheme2(...extensions) {
    let overrides = [...extensions];
    let activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) && overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe(
      ...overrides.map(
        (extension) => (prevTheme) => isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
      )
    )(activeTheme);
  };
};
var extendTheme = createExtendTheme(import_theme.theme);
var extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function mergeThemeOverride(...overrides) {
  return (0, import_lodash.default)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = isFunction(source) ? source(...args) : source;
      const overrideValue = isFunction(override) ? override(...args) : override;
      return (0, import_lodash.default)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = __webpack_require__(42409);
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withColorScheme = {
            defaultProps: {
              colorScheme
            }
          };
          return [componentName, withColorScheme];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = __webpack_require__(42409);
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withSize = {
            defaultProps: {
              size
            }
          };
          return [componentName, withSize];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = __webpack_require__(42409);
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withVariant = {
            defaultProps: {
              variant
            }
          };
          return [componentName, withVariant];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride(pipe2(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 19707:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  assignAfter: () => assignAfter,
  compact: () => compact,
  omit: () => omit,
  pick: () => pick,
  split: () => split,
  walkObject: () => walkObject
});
module.exports = __toCommonJS(src_exports);

// src/assign-after.ts
function assignAfter(target, ...sources) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }
  const result = { ...target };
  for (const nextSource of sources) {
    if (nextSource == null)
      continue;
    for (const nextKey in nextSource) {
      if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey))
        continue;
      if (nextKey in result)
        delete result[nextKey];
      result[nextKey] = nextSource[nextKey];
    }
  }
  return result;
}

// src/compact.ts
function compact(object) {
  const clone = Object.assign({}, object);
  for (let key in clone) {
    if (clone[key] === void 0)
      delete clone[key];
  }
  return clone;
}

// src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// src/pick.ts
function pick(object, keysToPick) {
  const result = {};
  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

// src/split.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/walk-object.ts
function isObject(value) {
  return typeof value === "object" && value != null && !Array.isArray(value);
}
function walkObject(target, predicate, options = {}) {
  const { stop, getKey } = options;
  function inner(value, path = []) {
    var _a;
    if (isObject(value) || Array.isArray(value)) {
      const result = {};
      for (const [prop, child] of Object.entries(value)) {
        const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
        const childPath = [...path, key];
        if (stop == null ? void 0 : stop(value, childPath)) {
          return predicate(value, path);
        }
        result[key] = inner(child, childPath);
      }
      return result;
    }
    return predicate(value, path);
  }
  return inner(target);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 52734:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  getValidChildren: () => getValidChildren
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function getValidChildren(children) {
  return import_react.Children.toArray(children).filter(
    (child) => (0, import_react.isValidElement)(child)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 94028:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useTimeout: () => useTimeout
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var import_react_use_callback_ref = __webpack_require__(93644);
function useTimeout(callback, delay) {
  const fn = (0, import_react_use_callback_ref.useCallbackRef)(callback);
  (0, import_react.useEffect)(() => {
    if (delay == null)
      return void 0;
    let timeoutId = null;
    timeoutId = window.setTimeout(() => {
      fn();
    }, delay);
    return () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [delay, fn]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 93644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useCallbackRef: () => useCallbackRef
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function useCallbackRef(callback, deps = []) {
  const callbackRef = (0, import_react.useRef)(callback);
  (0, import_react.useEffect)(() => {
    callbackRef.current = callback;
  });
  return (0, import_react.useCallback)((...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, deps);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 32819:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  assignRef: () => assignRef,
  createContext: () => createContext,
  getValidChildren: () => getValidChildren,
  mergeRefs: () => mergeRefs
});
module.exports = __toCommonJS(src_exports);

// src/refs.ts
var import_utils = __webpack_require__(18171);
function assignRef(ref, value) {
  if (ref == null)
    return;
  if ((0, import_utils.isFunction)(ref)) {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}

// src/context.ts
var import_react = __webpack_require__(67294);
function createContext(options = {}) {
  const {
    strict = true,
    errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name
  } = options;
  const Context = (0, import_react.createContext)(void 0);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = (0, import_react.useContext)(Context);
    if (!context && strict) {
      const error = new Error(errorMessage);
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [
    Context.Provider,
    useContext,
    Context
  ];
}

// src/children.ts
var import_react2 = __webpack_require__(67294);
function getValidChildren(children) {
  return import_react2.Children.toArray(children).filter(
    (child) => (0, import_react2.isValidElement)(child)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 42409:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 77504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  addPrefix: () => addPrefix,
  background: () => background,
  border: () => border,
  calc: () => calc,
  color: () => color,
  createMultiStyleConfigHelpers: () => createMultiStyleConfigHelpers,
  css: () => css,
  cssVar: () => cssVar,
  defineCssVars: () => defineCssVars,
  defineStyle: () => defineStyle,
  defineStyleConfig: () => defineStyleConfig,
  effect: () => effect,
  filter: () => filter,
  flattenTokens: () => flattenTokens,
  flexbox: () => flexbox,
  getCSSVar: () => getCSSVar,
  getCss: () => getCss,
  grid: () => grid,
  interactivity: () => interactivity,
  isStyleProp: () => isStyleProp,
  layout: () => layout,
  layoutPropNames: () => layoutPropNames,
  list: () => list,
  omitThemingProps: () => omitThemingProps,
  others: () => others,
  position: () => position,
  propNames: () => propNames,
  pseudoPropNames: () => pseudoPropNames,
  pseudoSelectors: () => pseudoSelectors,
  resolveStyleConfig: () => resolveStyleConfig,
  ring: () => ring,
  scroll: () => scroll,
  space: () => space,
  systemProps: () => systemProps,
  textDecoration: () => textDecoration,
  toCSSVar: () => toCSSVar,
  toVarDefinition: () => toVarDefinition,
  toVarReference: () => toVarReference,
  tokenToCSSVar: () => tokenToCSSVar,
  transform: () => transform,
  transition: () => transition,
  typography: () => typography
});
module.exports = __toCommonJS(src_exports);

// src/utils/create-transform.ts
var import_shared_utils = __webpack_require__(42409);
var isImportant = (value) => /!(important)?$/.test(value);
var withoutImportant = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var tokenToCSSVar = (scale, value) => (theme) => {
  const valueStr = String(value);
  const important = isImportant(valueStr);
  const valueWithoutImportant = withoutImportant(valueStr);
  const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
  let transformed = (0, import_shared_utils.isObject)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
  transformed = withoutImportant(transformed);
  return important ? `${transformed} !important` : transformed;
};
function createTransform(options) {
  const { scale, transform: transform2, compose } = options;
  const fn = (value, theme) => {
    var _a;
    const _value = tokenToCSSVar(scale, value)(theme);
    let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
    if (compose) {
      result = compose(result, theme);
    }
    return result;
  };
  return fn;
}

// src/utils/pipe.ts
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);

// src/utils/prop-config.ts
function toConfig(scale, transform2) {
  return (property) => {
    const result = { property, scale };
    result.transform = createTransform({
      scale,
      transform: transform2
    });
    return result;
  };
}
var getRtl = ({ rtl, ltr }) => (theme) => theme.direction === "rtl" ? rtl : ltr;
function logical(options) {
  const { property, scale, transform: transform2 } = options;
  return {
    scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale,
      compose: transform2
    }) : transform2
  };
}

// src/utils/templates.ts
var transformTemplate = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function getTransformTemplate() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...transformTemplate
  ].join(" ");
}
function getTransformGpuTemplate() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...transformTemplate
  ].join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
    "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
    "--chakra-ring-width": value,
    boxShadow: [
      `var(--chakra-ring-offset-shadow)`,
      `var(--chakra-ring-shadow)`,
      `var(--chakra-shadow, 0 0 #0000)`
    ].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};

// src/utils/parse-gradient.ts
var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]);
var trimSpace = (str) => str.trim();
function parseGradient(value, theme) {
  if (value == null || globalSet.has(value))
    return value;
  const prevent = isCSSFunction(value) || globalSet.has(value);
  if (!prevent)
    return `url('${value}')`;
  const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
  const results = regex.exec(value);
  const type = results == null ? void 0 : results[1];
  const values = results == null ? void 0 : results[2];
  if (!type || !values)
    return value;
  const _type = type.includes("-gradient") ? type : `${type}-gradient`;
  const [maybeDirection, ...stops] = values.split(",").map(trimSpace).filter(Boolean);
  if ((stops == null ? void 0 : stops.length) === 0)
    return value;
  const direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);
  const _values = stops.map((stop) => {
    if (valueSet.has(stop))
      return stop;
    const firstStop = stop.indexOf(" ");
    const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
    const _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
    const key = `colors.${_color}`;
    const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [
      color2,
      ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
    ].join(" ") : color2;
  });
  return `${_type}(${_values.join(", ")})`;
}
var isCSSFunction = (value) => {
  return typeof value === "string" && value.includes("(") && value.includes(")");
};
var gradientTransform = (value, theme) => parseGradient(value, theme != null ? theme : {});

// src/utils/transform-functions.ts
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
var analyzeCSSValue = (value) => {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
};
var wrap = (str) => (value) => `${str}(${value})`;
var transformFunctions = {
  filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip(value) {
    return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
  },
  transform(value) {
    if (value === "auto")
      return getTransformTemplate();
    if (value === "auto-gpu")
      return getTransformGpuTemplate();
    return value;
  },
  vh(value) {
    return value === "$100vh" ? "var(--chakra-vh)" : value;
  },
  px(value) {
    if (value == null)
      return value;
    const { unitless } = analyzeCSSValue(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
  },
  fraction(value) {
    return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
  },
  float(value, theme) {
    const map = { left: "right", right: "left" };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree(value) {
    if (isCssVar(value) || value == null)
      return value;
    const unitless = typeof value === "string" && !value.endsWith("deg");
    return typeof value === "number" || unitless ? `${value}deg` : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage(value) {
    if (value == null)
      return value;
    const prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? `url(${value})` : value;
  },
  outline(value) {
    const isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
  },
  flexDirection(value) {
    var _a;
    const { space: space2, divide: divide2 } = (_a = flexDirectionTemplate[value]) != null ? _a : {};
    const result = { flexDirection: value };
    if (space2)
      result[space2] = 1;
    if (divide2)
      result[divide2] = 1;
    return result;
  }
};

// src/utils/index.ts
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  gradients: toConfig("gradients", transformFunctions.gradient),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  spaceT: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  degreeT(property) {
    return { property, transform: transformFunctions.degree };
  },
  prop(property, scale, transform2) {
    return {
      property,
      scale,
      ...scale && {
        transform: createTransform({ scale, transform: transform2 })
      }
    };
  },
  propT(property, transform2) {
    return { property, transform: transform2 };
  },
  sizes: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.px)),
  sizesT: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.fraction)),
  shadows: toConfig("shadows"),
  logical,
  blur: toConfig("blur", transformFunctions.blur)
};

// src/config/background.ts
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.gradients("backgroundImage"),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: { transform: transformFunctions.bgClip },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.gradients("backgroundImage"),
  bgClip: { transform: transformFunctions.bgClip }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});

// src/config/border.ts
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});

// src/config/color.ts
var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};

// src/config/effect.ts
var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});

// src/config/filter.ts
var filter = {
  filter: { transform: transformFunctions.filter },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: { transform: transformFunctions.backdropFilter },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT(
    "--chakra-backdrop-brightness",
    transformFunctions.brightness
  ),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};

// src/config/flexbox.ts
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: { transform: transformFunctions.flexDirection },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});

// src/config/grid.ts
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};

// src/config/interactivity.ts
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: { transform: transformFunctions.outline },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};

// src/config/layout.ts
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  aspectRatio: true,
  hideFrom: {
    scale: "breakpoints",
    transform: (value, theme) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
      const mq = `@media screen and (min-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (value, theme) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
      const mq = `@media screen and (max-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  float: t.propT("float", transformFunctions.float),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});

// src/config/list.ts
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};

// src/get.ts
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);

// src/config/others.ts
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};
var getWithPriority = (theme, key, styles) => {
  const result = {};
  const obj = memoizedGet(theme, key, {});
  for (const prop in obj) {
    const isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles)
      result[prop] = obj[prop];
  }
  return result;
};
var others = {
  srOnly: {
    transform(value) {
      if (value === true)
        return srOnly;
      if (value === "focusable")
        return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, `layerStyles.${value}`, styles)
  },
  textStyle: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, `textStyles.${value}`, styles)
  },
  apply: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, value, styles)
  }
};

// src/config/position.ts
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});

// src/config/ring.ts
var ring = {
  ring: { transform: transformFunctions.ring },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};

// src/config/space.ts
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});

// src/config/text-decoration.ts
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: { property: "textDecoration" },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};

// src/config/transform.ts
var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};

// src/config/transition.ts
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
};

// src/config/typography.ts
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  textIndent: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  isTruncated: {
    transform(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
};

// src/config/scroll.ts
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

// src/create-theme-vars/calc.ts
var import_shared_utils2 = __webpack_require__(42409);
function resolveReference(operand) {
  if ((0, import_shared_utils2.isObject)(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpression = (operator, ...operands) => operands.map(resolveReference).join(` ${operator} `).replace(/calc/g, "");
var add = (...operands) => `calc(${toExpression("+", ...operands)})`;
var subtract = (...operands) => `calc(${toExpression("-", ...operands)})`;
var multiply = (...operands) => `calc(${toExpression("*", ...operands)})`;
var divide = (...operands) => `calc(${toExpression("/", ...operands)})`;
var negate = (x) => {
  const value = resolveReference(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
  }
  return multiply(value, -1);
};
var calc = Object.assign(
  (x) => ({
    add: (...operands) => calc(add(x, ...operands)),
    subtract: (...operands) => calc(subtract(x, ...operands)),
    multiply: (...operands) => calc(multiply(x, ...operands)),
    divide: (...operands) => calc(divide(x, ...operands)),
    negate: () => calc(negate(x)),
    toString: () => x.toString()
  }),
  {
    add,
    subtract,
    multiply,
    divide,
    negate
  }
);

// src/create-theme-vars/css-var.ts
function replaceWhiteSpace(value, replaceValue = "-") {
  return value.replace(/\s+/g, replaceValue);
}
function escape(value) {
  const valueStr = replaceWhiteSpace(value.toString());
  return escapeSymbol(escapeDot(valueStr));
}
function escapeDot(value) {
  if (value.includes("\\."))
    return value;
  const isDecimal = !Number.isInteger(parseFloat(value.toString()));
  return isDecimal ? value.replace(".", `\\.`) : value;
}
function escapeSymbol(value) {
  return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function addPrefix(value, prefix = "") {
  return [prefix, value].filter(Boolean).join("-");
}
function toVarReference(name, fallback) {
  return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function toVarDefinition(value, prefix = "") {
  return escape(`--${addPrefix(value, prefix)}`);
}
function cssVar(name, fallback, cssVarPrefix) {
  const cssVariable = toVarDefinition(name, cssVarPrefix);
  return {
    variable: cssVariable,
    reference: toVarReference(cssVariable, fallback)
  };
}
function defineCssVars(scope, keys2) {
  const vars = {};
  for (const key of keys2) {
    if (Array.isArray(key)) {
      const [name, fallback] = key;
      vars[name] = cssVar(`${scope}-${name}`, fallback);
      continue;
    }
    vars[key] = cssVar(`${scope}-${key}`);
  }
  return vars;
}

// ../../utilities/breakpoint-utils/src/breakpoint.ts
var import_shared_utils3 = __webpack_require__(42409);
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function analyzeCSSValue2(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue2(value);
  return unitless || typeof value === "number" ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints) => Object.fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
function normalize(breakpoints) {
  const sorted = sortBps(breakpoints);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints) {
  const value = Object.keys(sortBps(breakpoints));
  return new Set(value);
}
function subtract2(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const OFFSET = -0.02;
  return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + OFFSET}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints) {
  var _a;
  if (!breakpoints)
    return null;
  breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints);
  const queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract2(maxW) : void 0;
    return {
      _minW: subtract2(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints),
    asArray: normalize(breakpoints),
    details: queries,
    get(key) {
      return queries.find((q) => q.breakpoint === key);
    },
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!(0, import_shared_utils3.isObject)(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/create-theme-vars/create-theme-vars.ts
var import_shared_utils4 = __webpack_require__(42409);

// src/pseudos.ts
var state = {
  hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
  focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
  focusVisible: (str, post) => `${str}:focus-visible ${post}`,
  focusWithin: (str, post) => `${str}:focus-within ${post}`,
  active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
  disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
  invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
  checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
  indeterminate: (str, post) => `${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
  readOnly: (str, post) => `${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
  expanded: (str, post) => `${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
  placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
};
var toGroup = (fn) => merge((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
var toPeer = (fn) => merge((v) => fn(v, "~ &"), "[data-peer]", ".peer");
var merge = (fn, ...selectors) => selectors.map(fn).join(", ");
var pseudoSelectors = {
  _hover: "&:hover, &[data-hover]",
  _active: "&:active, &[data-active]",
  _focus: "&:focus, &[data-focus]",
  _highlighted: "&[data-highlighted]",
  _focusWithin: "&:focus-within",
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _before: "&::before",
  _after: "&::after",
  _empty: "&:empty",
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  _checked: "&[aria-checked=true], &[data-checked]",
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[data-valid], &[data-state=valid]",
  _loading: "&[data-loading], &[aria-busy=true]",
  _selected: "&[aria-selected=true], &[data-selected]",
  _hidden: "&[hidden], &[data-hidden]",
  _autofill: "&:-webkit-autofill",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _first: "&:first-of-type",
  _firstLetter: "&::first-letter",
  _last: "&:last-of-type",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _visited: "&:visited",
  _activeLink: "&[aria-current=page]",
  _activeStep: "&[aria-current=step]",
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  _groupHover: toGroup(state.hover),
  _peerHover: toPeer(state.hover),
  _groupFocus: toGroup(state.focus),
  _peerFocus: toPeer(state.focus),
  _groupFocusVisible: toGroup(state.focusVisible),
  _peerFocusVisible: toPeer(state.focusVisible),
  _groupActive: toGroup(state.active),
  _peerActive: toPeer(state.active),
  _groupDisabled: toGroup(state.disabled),
  _peerDisabled: toPeer(state.disabled),
  _groupInvalid: toGroup(state.invalid),
  _peerInvalid: toPeer(state.invalid),
  _groupChecked: toGroup(state.checked),
  _peerChecked: toPeer(state.checked),
  _groupFocusWithin: toGroup(state.focusWithin),
  _peerFocusWithin: toPeer(state.focusWithin),
  _peerPlaceholderShown: toPeer(state.placeholderShown),
  _placeholder: "&::placeholder",
  _placeholderShown: "&:placeholder-shown",
  _fullScreen: "&:fullscreen",
  _selection: "&::selection",
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  _mediaDark: "@media (prefers-color-scheme: dark)",
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  _horizontal: "&[data-orientation=horizontal]",
  _vertical: "&[data-orientation=vertical]"
};
var pseudoPropNames = Object.keys(
  pseudoSelectors
);

// src/create-theme-vars/create-theme-vars.ts
var import_lodash = __toESM(__webpack_require__(38554));
function tokenToCssVar(token, prefix) {
  return cssVar(String(token).replace(/\./g, "-"), void 0, prefix);
}
function createThemeVars(flatTokens, options) {
  let cssVars = {};
  const cssMap = {};
  for (const [token, tokenValue] of Object.entries(flatTokens)) {
    const { isSemantic, value } = tokenValue;
    const { variable, reference } = tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
    if (!isSemantic) {
      if (token.startsWith("space")) {
        const keys2 = token.split(".");
        const [firstKey, ...referenceKeys] = keys2;
        const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
        const negativeValue = calc.negate(value);
        const negatedReference = calc.negate(reference);
        cssMap[negativeLookupKey] = {
          value: negativeValue,
          var: variable,
          varRef: negatedReference
        };
      }
      cssVars[variable] = value;
      cssMap[token] = {
        value,
        var: variable,
        varRef: reference
      };
      continue;
    }
    const lookupToken = (maybeToken) => {
      const scale = String(token).split(".")[0];
      const withScale = [scale, maybeToken].join(".");
      const resolvedTokenValue = flatTokens[withScale];
      if (!resolvedTokenValue)
        return maybeToken;
      const { reference: reference2 } = tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
      return reference2;
    };
    const normalizedValue = (0, import_shared_utils4.isObject)(value) ? value : { default: value };
    cssVars = (0, import_lodash.default)(
      cssVars,
      Object.entries(normalizedValue).reduce(
        (acc, [conditionAlias, conditionValue]) => {
          var _a, _b;
          if (!conditionValue)
            return acc;
          const tokenReference = lookupToken(`${conditionValue}`);
          if (conditionAlias === "default") {
            acc[variable] = tokenReference;
            return acc;
          }
          const conditionSelector = (_b = (_a = pseudoSelectors) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
          acc[conditionSelector] = { [variable]: tokenReference };
          return acc;
        },
        {}
      )
    );
    cssMap[token] = {
      value: reference,
      var: variable,
      varRef: reference
    };
  }
  return {
    cssVars,
    cssMap
  };
}

// ../../utilities/object-utils/src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick(object, keysToPick) {
  const result = {};
  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

// ../../utilities/object-utils/src/walk-object.ts
function isObject5(value) {
  return typeof value === "object" && value != null && !Array.isArray(value);
}
function walkObject(target, predicate, options = {}) {
  const { stop, getKey } = options;
  function inner(value, path = []) {
    var _a;
    if (isObject5(value) || Array.isArray(value)) {
      const result = {};
      for (const [prop, child] of Object.entries(value)) {
        const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
        const childPath = [...path, key];
        if (stop == null ? void 0 : stop(value, childPath)) {
          return predicate(value, path);
        }
        result[key] = inner(child, childPath);
      }
      return result;
    }
    return predicate(value, path);
  }
  return inner(target);
}

// src/create-theme-vars/theme-tokens.ts
var tokens = [
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
];
function extractTokens(theme) {
  const _tokens = tokens;
  return pick(theme, _tokens);
}
function extractSemanticTokens(theme) {
  return theme.semanticTokens;
}
function omitVars(rawTheme) {
  const { __cssMap, __cssVars, __breakpoints, ...cleanTheme } = rawTheme;
  return cleanTheme;
}

// src/create-theme-vars/flatten-tokens.ts
var isSemanticCondition = (key) => pseudoPropNames.includes(key) || "default" === key;
function flattenTokens({
  tokens: tokens2,
  semanticTokens
}) {
  const result = {};
  walkObject(tokens2, (value, path) => {
    if (value == null)
      return;
    result[path.join(".")] = { isSemantic: false, value };
  });
  walkObject(
    semanticTokens,
    (value, path) => {
      if (value == null)
        return;
      result[path.join(".")] = { isSemantic: true, value };
    },
    {
      stop: (value) => Object.keys(value).every(isSemanticCondition)
    }
  );
  return result;
}

// src/create-theme-vars/to-css-var.ts
function toCSSVar(rawTheme) {
  var _a;
  const theme = omitVars(rawTheme);
  const tokens2 = extractTokens(theme);
  const semanticTokens = extractSemanticTokens(theme);
  const flatTokens = flattenTokens({ tokens: tokens2, semanticTokens });
  const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
  const {
    cssMap,
    cssVars
  } = createThemeVars(flatTokens, { cssVarPrefix });
  const defaultCssVars = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  Object.assign(theme, {
    __cssVars: { ...defaultCssVars, ...cssVars },
    __cssMap: cssMap,
    __breakpoints: analyzeBreakpoints(theme.breakpoints)
  });
  return theme;
}

// src/css.ts
var import_shared_utils6 = __webpack_require__(42409);
var import_lodash3 = __toESM(__webpack_require__(38554));

// src/system.ts
var import_lodash2 = __toESM(__webpack_require__(38554));
var systemProps = (0, import_lodash2.default)(
  {},
  background,
  border,
  color,
  flexbox,
  layout,
  filter,
  ring,
  interactivity,
  grid,
  others,
  position,
  effect,
  space,
  scroll,
  typography,
  textDecoration,
  transform,
  list,
  transition
);
var layoutSystem = Object.assign({}, space, layout, flexbox, grid, position);
var layoutPropNames = Object.keys(
  layoutSystem
);
var propNames = [...Object.keys(systemProps), ...pseudoPropNames];
var styleProps = { ...systemProps, ...pseudoSelectors };
var isStyleProp = (prop) => prop in styleProps;

// src/utils/expand-responsive.ts
var import_shared_utils5 = __webpack_require__(42409);
var expandResponsive = (styles) => (theme) => {
  if (!theme.__breakpoints)
    return styles;
  const { isResponsive, toArrayValue, media: medias } = theme.__breakpoints;
  const computedStyles = {};
  for (const key in styles) {
    let value = (0, import_shared_utils5.runIfFn)(styles[key], theme);
    if (value == null)
      continue;
    value = (0, import_shared_utils5.isObject)(value) && isResponsive(value) ? toArrayValue(value) : value;
    if (!Array.isArray(value)) {
      computedStyles[key] = value;
      continue;
    }
    const queries = value.slice(0, medias.length).length;
    for (let index = 0; index < queries; index += 1) {
      const media = medias == null ? void 0 : medias[index];
      if (!media) {
        computedStyles[key] = value[index];
        continue;
      }
      computedStyles[media] = computedStyles[media] || {};
      if (value[index] == null) {
        continue;
      }
      computedStyles[media][key] = value[index];
    }
  }
  return computedStyles;
};

// src/utils/split-by-comma.ts
function splitByComma(value) {
  const chunks = [];
  let chunk = "";
  let inParens = false;
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (char === "(") {
      inParens = true;
      chunk += char;
    } else if (char === ")") {
      inParens = false;
      chunk += char;
    } else if (char === "," && !inParens) {
      chunks.push(chunk);
      chunk = "";
    } else {
      chunk += char;
    }
  }
  chunk = chunk.trim();
  if (chunk) {
    chunks.push(chunk);
  }
  return chunks;
}

// src/css.ts
function isCssVar2(value) {
  return /^var\(--.+\)$/.test(value);
}
var isCSSVariableTokenValue = (key, value) => key.startsWith("--") && typeof value === "string" && !isCssVar2(value);
var resolveTokenValue = (theme, value) => {
  var _a, _b;
  if (value == null)
    return value;
  const getVar = (val) => {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
  };
  const getValue = (val) => {
    var _a2;
    return (_a2 = getVar(val)) != null ? _a2 : val;
  };
  const [tokenValue, fallbackValue] = splitByComma(value);
  value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
  return value;
};
function getCss(options) {
  const { configs = {}, pseudos = {}, theme } = options;
  const css2 = (stylesOrFn, nested = false) => {
    var _a, _b, _c;
    const _styles = (0, import_shared_utils6.runIfFn)(stylesOrFn, theme);
    const styles = expandResponsive(_styles)(theme);
    let computedStyles = {};
    for (let key in styles) {
      const valueOrFn = styles[key];
      let value = (0, import_shared_utils6.runIfFn)(valueOrFn, theme);
      if (key in pseudos) {
        key = pseudos[key];
      }
      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }
      let config = configs[key];
      if (config === true) {
        config = { property: key };
      }
      if ((0, import_shared_utils6.isObject)(value)) {
        computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
        computedStyles[key] = (0, import_lodash3.default)(
          {},
          computedStyles[key],
          css2(value, true)
        );
        continue;
      }
      let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
      rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
      const configProperty = (0, import_shared_utils6.runIfFn)(config == null ? void 0 : config.property, theme);
      if (!nested && (config == null ? void 0 : config.static)) {
        const staticStyles = (0, import_shared_utils6.runIfFn)(config.static, theme);
        computedStyles = (0, import_lodash3.default)({}, computedStyles, staticStyles);
      }
      if (configProperty && Array.isArray(configProperty)) {
        for (const property of configProperty) {
          computedStyles[property] = rawValue;
        }
        continue;
      }
      if (configProperty) {
        if (configProperty === "&" && (0, import_shared_utils6.isObject)(rawValue)) {
          computedStyles = (0, import_lodash3.default)({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }
        continue;
      }
      if ((0, import_shared_utils6.isObject)(rawValue)) {
        computedStyles = (0, import_lodash3.default)({}, computedStyles, rawValue);
        continue;
      }
      computedStyles[key] = rawValue;
    }
    return computedStyles;
  };
  return css2;
}
var css = (styles) => (theme) => {
  const cssFn = getCss({
    theme,
    pseudos: pseudoSelectors,
    configs: systemProps
  });
  return cssFn(styles);
};

// src/define-styles.ts
function defineStyle(styles) {
  return styles;
}
function defineStyleConfig(config) {
  return config;
}
function createMultiStyleConfigHelpers(parts) {
  return {
    definePartsStyle(config) {
      return config;
    },
    defineMultiStyleConfig(config) {
      return { parts, ...config };
    }
  };
}

// src/style-config.ts
var import_shared_utils7 = __webpack_require__(42409);
var import_lodash4 = __toESM(__webpack_require__(38554));
function normalize2(value, toArray) {
  if (Array.isArray(value))
    return value;
  if ((0, import_shared_utils7.isObject)(value))
    return toArray(value);
  if (value != null)
    return [value];
}
function getNextIndex(values, i) {
  for (let j = i + 1; j < values.length; j++) {
    if (values[j] != null)
      return j;
  }
  return -1;
}
function createResolver(theme) {
  const breakpointUtil = theme.__breakpoints;
  return function resolver(config, prop, value, props) {
    var _a, _b;
    if (!breakpointUtil)
      return;
    const result = {};
    const normalized = normalize2(value, breakpointUtil.toArrayValue);
    if (!normalized)
      return result;
    const len = normalized.length;
    const isSingle = len === 1;
    const isMultipart = !!config.parts;
    for (let i = 0; i < len; i++) {
      const key = breakpointUtil.details[i];
      const nextKey = breakpointUtil.details[getNextIndex(normalized, i)];
      const query = toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
      const styles = (0, import_shared_utils7.runIfFn)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
      if (!styles)
        continue;
      if (isMultipart) {
        (_b = config.parts) == null ? void 0 : _b.forEach((part) => {
          (0, import_lodash4.default)(result, {
            [part]: isSingle ? styles[part] : { [query]: styles[part] }
          });
        });
        continue;
      }
      if (!isMultipart) {
        if (isSingle)
          (0, import_lodash4.default)(result, styles);
        else
          result[query] = styles;
        continue;
      }
      result[query] = styles;
    }
    return result;
  };
}
function resolveStyleConfig(config) {
  return (props) => {
    var _a;
    const { variant, size, theme } = props;
    const recipe = createResolver(theme);
    return (0, import_lodash4.default)(
      {},
      (0, import_shared_utils7.runIfFn)((_a = config.baseStyle) != null ? _a : {}, props),
      recipe(config, "sizes", size, props),
      recipe(config, "variants", variant, props)
    );
  };
}

// src/get-css-var.ts
function getCSSVar(theme, scale, value) {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}

// src/theming-props.ts
function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 60723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  addPrefix: () => addPrefix,
  anatomy: () => import_anatomy.anatomy,
  blacken: () => blacken,
  calc: () => calc,
  complementary: () => complementary,
  contrast: () => contrast,
  createBreakpoints: () => createBreakpoints,
  cssVar: () => cssVar,
  darken: () => darken,
  generateStripe: () => generateStripe,
  getColor: () => getColor,
  getColorVar: () => getColorVar,
  isAccessible: () => isAccessible,
  isDark: () => isDark,
  isDecimal: () => isDecimal,
  isLight: () => isLight,
  isReadable: () => isReadable,
  lighten: () => lighten,
  mode: () => mode,
  orient: () => orient,
  randomColor: () => randomColor,
  readability: () => readability,
  toVar: () => toVar,
  toVarRef: () => toVarRef,
  tone: () => tone,
  transparentize: () => transparentize,
  whiten: () => whiten
});
module.exports = __toCommonJS(src_exports);
var import_anatomy = __webpack_require__(34382);

// src/color.ts
var import_styled_system = __webpack_require__(77504);
var import_color2k = __webpack_require__(34595);

// ../../../node_modules/.pnpm/dlv@1.1.3/node_modules/dlv/dist/dlv.es.js
function dlv_es_default(t, e, l, n, r) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)
    t = t ? t[e[n]] : r;
  return t === r ? l : t;
}

// src/color.ts
var isEmptyObject = (obj) => Object.keys(obj).length === 0;
var getColor = (theme, color, fallback) => {
  const hex = dlv_es_default(theme, `colors.${color}`, color);
  try {
    (0, import_color2k.toHex)(hex);
    return hex;
  } catch {
    return fallback != null ? fallback : "#000000";
  }
};
var getColorVar = (theme, color, fallback) => {
  var _a;
  return (_a = (0, import_styled_system.getCSSVar)(theme, "colors", color)) != null ? _a : fallback;
};
var getBrightness = (color) => {
  const [r, g, b] = (0, import_color2k.parseToRgba)(color);
  return (r * 299 + g * 587 + b * 114) / 1e3;
};
var tone = (color) => (theme) => {
  const hex = getColor(theme, color);
  const brightness = getBrightness(hex);
  const isDark2 = brightness < 128;
  return isDark2 ? "dark" : "light";
};
var isDark = (color) => (theme) => tone(color)(theme) === "dark";
var isLight = (color) => (theme) => tone(color)(theme) === "light";
var transparentize = (color, opacity) => (theme) => {
  const raw = getColor(theme, color);
  return (0, import_color2k.transparentize)(raw, 1 - opacity);
};
var whiten = (color, amount) => (theme) => {
  const raw = getColor(theme, color);
  return (0, import_color2k.toHex)((0, import_color2k.mix)(raw, "#fff", amount));
};
var blacken = (color, amount) => (theme) => {
  const raw = getColor(theme, color);
  return (0, import_color2k.toHex)((0, import_color2k.mix)(raw, "#000", amount / 100));
};
var darken = (color, amount) => (theme) => {
  const raw = getColor(theme, color);
  return (0, import_color2k.toHex)((0, import_color2k.darken)(raw, amount / 100));
};
var lighten = (color, amount) => (theme) => {
  const raw = getColor(theme, color);
  (0, import_color2k.toHex)((0, import_color2k.lighten)(raw, amount / 100));
};
var contrast = (fg, bg) => (theme) => (0, import_color2k.getContrast)(getColor(theme, bg), getColor(theme, fg));
var isAccessible = (textColor, bgColor, options) => (theme) => isReadable(getColor(theme, bgColor), getColor(theme, textColor), options);
function isReadable(color1, color2, wcag2 = { level: "AA", size: "small" }) {
  var _a, _b;
  const readabilityLevel = readability(color1, color2);
  switch (((_a = wcag2.level) != null ? _a : "AA") + ((_b = wcag2.size) != null ? _b : "small")) {
    case "AAsmall":
    case "AAAlarge":
      return readabilityLevel >= 4.5;
    case "AAlarge":
      return readabilityLevel >= 3;
    case "AAAsmall":
      return readabilityLevel >= 7;
    default:
      return false;
  }
}
function readability(color1, color2) {
  return (Math.max((0, import_color2k.getLuminance)(color1), (0, import_color2k.getLuminance)(color2)) + 0.05) / (Math.min((0, import_color2k.getLuminance)(color1), (0, import_color2k.getLuminance)(color2)) + 0.05);
}
var complementary = (color) => (theme) => {
  const raw = getColor(theme, color);
  const hsl = (0, import_color2k.parseToHsla)(raw);
  const complementHsl = Object.assign(hsl, [
    (hsl[0] + 180) % 360
  ]);
  return (0, import_color2k.toHex)((0, import_color2k.hsla)(...complementHsl));
};
function generateStripe(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
  return {
    backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: `${size} ${size}`
  };
}
var randomHex = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
function randomColor(opts) {
  const fallback = randomHex();
  if (!opts || isEmptyObject(opts)) {
    return fallback;
  }
  if (opts.string && opts.colors) {
    return randomColorFromList(opts.string, opts.colors);
  }
  if (opts.string && !opts.colors) {
    return randomColorFromString(opts.string);
  }
  if (opts.colors && !opts.string) {
    return randomFromList(opts.colors);
  }
  return fallback;
}
function randomColorFromString(str) {
  let hash = 0;
  if (str.length === 0)
    return hash.toString();
  for (let i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  let color = "#";
  for (let j = 0; j < 3; j += 1) {
    const value = hash >> j * 8 & 255;
    color += `00${value.toString(16)}`.substr(-2);
  }
  return color;
}
function randomColorFromList(str, list) {
  let index = 0;
  if (str.length === 0)
    return list[0];
  for (let i = 0; i < str.length; i += 1) {
    index = str.charCodeAt(i) + ((index << 5) - index);
    index = index & index;
  }
  index = (index % list.length + list.length) % list.length;
  return list[index];
}
function randomFromList(list) {
  return list[Math.floor(Math.random() * list.length)];
}

// src/component.ts
function mode(light, dark) {
  return (props) => props.colorMode === "dark" ? dark : light;
}
function orient(options) {
  const { orientation, vertical, horizontal } = options;
  if (!orientation)
    return {};
  return orientation === "vertical" ? vertical : horizontal;
}

// src/create-breakpoints.ts
var import_shared_utils = __webpack_require__(42409);
var createBreakpoints = (config) => {
  (0, import_shared_utils.warn)({
    condition: true,
    message: [
      `[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon`,
      `simply pass the breakpoints as an object. Remove the createBreakpoints(..) call`
    ].join("")
  });
  return { base: "0em", ...config };
};

// src/css-calc.ts
var import_shared_utils2 = __webpack_require__(42409);
function toRef(operand) {
  if ((0, import_shared_utils2.isObject)(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpr = (operator, ...operands) => operands.map(toRef).join(` ${operator} `).replace(/calc/g, "");
var add = (...operands) => `calc(${toExpr("+", ...operands)})`;
var subtract = (...operands) => `calc(${toExpr("-", ...operands)})`;
var multiply = (...operands) => `calc(${toExpr("*", ...operands)})`;
var divide = (...operands) => `calc(${toExpr("/", ...operands)})`;
var negate = (x) => {
  const value = toRef(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
  }
  return multiply(value, -1);
};
var calc = Object.assign(
  (x) => ({
    add: (...operands) => calc(add(x, ...operands)),
    subtract: (...operands) => calc(subtract(x, ...operands)),
    multiply: (...operands) => calc(multiply(x, ...operands)),
    divide: (...operands) => calc(divide(x, ...operands)),
    negate: () => calc(negate(x)),
    toString: () => x.toString()
  }),
  {
    add,
    subtract,
    multiply,
    divide,
    negate
  }
);

// src/css-var.ts
function isDecimal(value) {
  return !Number.isInteger(parseFloat(value.toString()));
}
function replaceWhiteSpace(value, replaceValue = "-") {
  return value.replace(/\s+/g, replaceValue);
}
function escape(value) {
  const valueStr = replaceWhiteSpace(value.toString());
  if (valueStr.includes("\\."))
    return value;
  return isDecimal(value) ? valueStr.replace(".", `\\.`) : value;
}
function addPrefix(value, prefix = "") {
  return [prefix, escape(value)].filter(Boolean).join("-");
}
function toVarRef(name, fallback) {
  return `var(${escape(name)}${fallback ? `, ${fallback}` : ""})`;
}
function toVar(value, prefix = "") {
  return `--${addPrefix(value, prefix)}`;
}
function cssVar(name, options) {
  const cssVariable = toVar(name, options == null ? void 0 : options.prefix);
  return {
    variable: cssVariable,
    reference: toVarRef(cssVariable, getFallback(options == null ? void 0 : options.fallback))
  };
}
function getFallback(fallback) {
  if (typeof fallback === "string")
    return fallback;
  return fallback == null ? void 0 : fallback.reference;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 60:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  baseTheme: () => baseTheme,
  default: () => src_default,
  isChakraTheme: () => isChakraTheme,
  requiredChakraThemeKeys: () => requiredChakraThemeKeys,
  theme: () => theme
});
module.exports = __toCommonJS(src_exports);

// src/components/accordion.ts
var import_anatomy = __webpack_require__(34382);
var import_styled_system = __webpack_require__(77504);
var { definePartsStyle, defineMultiStyleConfig } = (0, import_styled_system.createMultiStyleConfigHelpers)(import_anatomy.accordionAnatomy.keys);
var baseStyleContainer = (0, import_styled_system.defineStyle)({
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
});
var baseStyleButton = (0, import_styled_system.defineStyle)({
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "md",
  _focusVisible: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: "4",
  py: "2"
});
var baseStylePanel = (0, import_styled_system.defineStyle)({
  pt: "2",
  px: "4",
  pb: "5"
});
var baseStyleIcon = (0, import_styled_system.defineStyle)({
  fontSize: "1.25em"
});
var baseStyle = definePartsStyle({
  container: baseStyleContainer,
  button: baseStyleButton,
  panel: baseStylePanel,
  icon: baseStyleIcon
});
var accordionTheme = defineMultiStyleConfig({ baseStyle });

// src/components/alert.ts
var import_anatomy2 = __webpack_require__(34382);
var import_styled_system2 = __webpack_require__(77504);
var import_theme_tools = __webpack_require__(60723);
var { definePartsStyle: definePartsStyle2, defineMultiStyleConfig: defineMultiStyleConfig2 } = (0, import_styled_system2.createMultiStyleConfigHelpers)(import_anatomy2.alertAnatomy.keys);
var $fg = (0, import_styled_system2.cssVar)("alert-fg");
var $bg = (0, import_styled_system2.cssVar)("alert-bg");
var baseStyle2 = definePartsStyle2({
  container: {
    bg: $bg.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
});
function getBg(props) {
  const { theme: theme2, colorScheme: c } = props;
  const darkBg = (0, import_theme_tools.transparentize)(`${c}.200`, 0.16)(theme2);
  return {
    light: `colors.${c}.100`,
    dark: darkBg
  };
}
var variantSubtle = definePartsStyle2((props) => {
  const { colorScheme: c } = props;
  const bg = getBg(props);
  return {
    container: {
      [$fg.variable]: `colors.${c}.500`,
      [$bg.variable]: bg.light,
      _dark: {
        [$fg.variable]: `colors.${c}.200`,
        [$bg.variable]: bg.dark
      }
    }
  };
});
var variantLeftAccent = definePartsStyle2((props) => {
  const { colorScheme: c } = props;
  const bg = getBg(props);
  return {
    container: {
      [$fg.variable]: `colors.${c}.500`,
      [$bg.variable]: bg.light,
      _dark: {
        [$fg.variable]: `colors.${c}.200`,
        [$bg.variable]: bg.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: $fg.reference
    }
  };
});
var variantTopAccent = definePartsStyle2((props) => {
  const { colorScheme: c } = props;
  const bg = getBg(props);
  return {
    container: {
      [$fg.variable]: `colors.${c}.500`,
      [$bg.variable]: bg.light,
      _dark: {
        [$fg.variable]: `colors.${c}.200`,
        [$bg.variable]: bg.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: $fg.reference
    }
  };
});
var variantSolid = definePartsStyle2((props) => {
  const { colorScheme: c } = props;
  return {
    container: {
      [$fg.variable]: `colors.white`,
      [$bg.variable]: `colors.${c}.500`,
      _dark: {
        [$fg.variable]: `colors.gray.900`,
        [$bg.variable]: `colors.${c}.200`
      },
      color: $fg.reference
    }
  };
});
var variants = {
  subtle: variantSubtle,
  "left-accent": variantLeftAccent,
  "top-accent": variantTopAccent,
  solid: variantSolid
};
var alertTheme = defineMultiStyleConfig2({
  baseStyle: baseStyle2,
  variants,
  defaultProps: {
    variant: "subtle",
    colorScheme: "blue"
  }
});

// src/components/avatar.ts
var import_anatomy3 = __webpack_require__(34382);
var import_styled_system3 = __webpack_require__(77504);
var import_theme_tools2 = __webpack_require__(60723);

// src/foundations/spacing.ts
var spacing = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};

// src/foundations/sizes.ts
var largeSizes = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem",
  prose: "60ch"
};
var container = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
};
var sizes = {
  ...spacing,
  ...largeSizes,
  container
};
var sizes_default = sizes;

// src/utils/run-if-fn.ts
var isFunction = (value) => typeof value === "function";
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

// src/components/avatar.ts
var { definePartsStyle: definePartsStyle3, defineMultiStyleConfig: defineMultiStyleConfig3 } = (0, import_styled_system3.createMultiStyleConfigHelpers)(import_anatomy3.avatarAnatomy.keys);
var $border = (0, import_styled_system3.cssVar)("avatar-border-color");
var $bg2 = (0, import_styled_system3.cssVar)("avatar-bg");
var $fs = (0, import_styled_system3.cssVar)("avatar-font-size");
var $size = (0, import_styled_system3.cssVar)("avatar-size");
var baseStyleBadge = (0, import_styled_system3.defineStyle)({
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: $border.reference,
  [$border.variable]: "white",
  _dark: {
    [$border.variable]: "colors.gray.800"
  }
});
var baseStyleExcessLabel = (0, import_styled_system3.defineStyle)({
  bg: $bg2.reference,
  fontSize: $fs.reference,
  width: $size.reference,
  height: $size.reference,
  lineHeight: "1",
  [$bg2.variable]: "colors.gray.200",
  _dark: {
    [$bg2.variable]: "colors.whiteAlpha.400"
  }
});
var baseStyleContainer2 = (0, import_styled_system3.defineStyle)((props) => {
  const { name, theme: theme2 } = props;
  const bg = name ? (0, import_theme_tools2.randomColor)({ string: name }) : "colors.gray.400";
  const isBgDark = (0, import_theme_tools2.isDark)(bg)(theme2);
  let color = "white";
  if (!isBgDark)
    color = "gray.800";
  return {
    bg: $bg2.reference,
    fontSize: $fs.reference,
    color,
    borderColor: $border.reference,
    verticalAlign: "top",
    width: $size.reference,
    height: $size.reference,
    "&:not([data-loaded])": {
      [$bg2.variable]: bg
    },
    [$border.variable]: "colors.white",
    _dark: {
      [$border.variable]: "colors.gray.800"
    }
  };
});
var baseStyleLabel = (0, import_styled_system3.defineStyle)({
  fontSize: $fs.reference,
  lineHeight: "1"
});
var baseStyle3 = definePartsStyle3((props) => ({
  badge: runIfFn(baseStyleBadge, props),
  excessLabel: runIfFn(baseStyleExcessLabel, props),
  container: runIfFn(baseStyleContainer2, props),
  label: baseStyleLabel
}));
function getSize(size2) {
  const themeSize = size2 !== "100%" ? sizes_default[size2] : void 0;
  return definePartsStyle3({
    container: {
      [$size.variable]: themeSize != null ? themeSize : size2,
      [$fs.variable]: `calc(${themeSize != null ? themeSize : size2} / 2.5)`
    },
    excessLabel: {
      [$size.variable]: themeSize != null ? themeSize : size2,
      [$fs.variable]: `calc(${themeSize != null ? themeSize : size2} / 2.5)`
    }
  });
}
var sizes2 = {
  "2xs": getSize(4),
  xs: getSize(6),
  sm: getSize(8),
  md: getSize(12),
  lg: getSize(16),
  xl: getSize(24),
  "2xl": getSize(32),
  full: getSize("100%")
};
var avatarTheme = defineMultiStyleConfig3({
  baseStyle: baseStyle3,
  sizes: sizes2,
  defaultProps: {
    size: "md"
  }
});

// src/components/badge.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_tools3 = __webpack_require__(60723);
var vars = (0, import_styled_system4.defineCssVars)("badge", ["bg", "color", "shadow"]);
var baseStyle4 = (0, import_styled_system4.defineStyle)({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var variantSolid2 = (0, import_styled_system4.defineStyle)((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  const dark = (0, import_theme_tools3.transparentize)(`${c}.500`, 0.6)(theme2);
  return {
    [vars.bg.variable]: `colors.${c}.500`,
    [vars.color.variable]: `colors.white`,
    _dark: {
      [vars.bg.variable]: dark,
      [vars.color.variable]: `colors.whiteAlpha.800`
    }
  };
});
var variantSubtle2 = (0, import_styled_system4.defineStyle)((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  const darkBg = (0, import_theme_tools3.transparentize)(`${c}.200`, 0.16)(theme2);
  return {
    [vars.bg.variable]: `colors.${c}.100`,
    [vars.color.variable]: `colors.${c}.800`,
    _dark: {
      [vars.bg.variable]: darkBg,
      [vars.color.variable]: `colors.${c}.200`
    }
  };
});
var variantOutline = (0, import_styled_system4.defineStyle)((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  const darkColor = (0, import_theme_tools3.transparentize)(`${c}.200`, 0.8)(theme2);
  return {
    [vars.color.variable]: `colors.${c}.500`,
    _dark: {
      [vars.color.variable]: darkColor
    },
    [vars.shadow.variable]: `inset 0 0 0px 1px ${vars.color.reference}`
  };
});
var variants2 = {
  solid: variantSolid2,
  subtle: variantSubtle2,
  outline: variantOutline
};
var badgeTheme = (0, import_styled_system4.defineStyleConfig)({
  baseStyle: baseStyle4,
  variants: variants2,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});

// src/components/breadcrumb.ts
var import_anatomy4 = __webpack_require__(34382);
var import_styled_system5 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig4, definePartsStyle: definePartsStyle4 } = (0, import_styled_system5.createMultiStyleConfigHelpers)(import_anatomy4.breadcrumbAnatomy.keys);
var $decor = (0, import_styled_system5.cssVar)("breadcrumb-link-decor");
var baseStyleLink = (0, import_styled_system5.defineStyle)({
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  outline: "none",
  color: "inherit",
  textDecoration: $decor.reference,
  [$decor.variable]: "none",
  "&:not([aria-current=page])": {
    cursor: "pointer",
    _hover: {
      [$decor.variable]: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  }
});
var baseStyle5 = definePartsStyle4({
  link: baseStyleLink
});
var breadcrumbTheme = defineMultiStyleConfig4({
  baseStyle: baseStyle5
});

// src/components/button.ts
var import_styled_system6 = __webpack_require__(77504);
var import_theme_tools4 = __webpack_require__(60723);
var baseStyle6 = (0, import_styled_system6.defineStyle)({
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
});
var variantGhost = (0, import_styled_system6.defineStyle)((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  if (c === "gray") {
    return {
      color: (0, import_theme_tools4.mode)(`gray.800`, `whiteAlpha.900`)(props),
      _hover: {
        bg: (0, import_theme_tools4.mode)(`gray.100`, `whiteAlpha.200`)(props)
      },
      _active: { bg: (0, import_theme_tools4.mode)(`gray.200`, `whiteAlpha.300`)(props) }
    };
  }
  const darkHoverBg = (0, import_theme_tools4.transparentize)(`${c}.200`, 0.12)(theme2);
  const darkActiveBg = (0, import_theme_tools4.transparentize)(`${c}.200`, 0.24)(theme2);
  return {
    color: (0, import_theme_tools4.mode)(`${c}.600`, `${c}.200`)(props),
    bg: "transparent",
    _hover: {
      bg: (0, import_theme_tools4.mode)(`${c}.50`, darkHoverBg)(props)
    },
    _active: {
      bg: (0, import_theme_tools4.mode)(`${c}.100`, darkActiveBg)(props)
    }
  };
});
var variantOutline2 = (0, import_styled_system6.defineStyle)((props) => {
  const { colorScheme: c } = props;
  const borderColor = (0, import_theme_tools4.mode)(`gray.200`, `whiteAlpha.300`)(props);
  return {
    border: "1px solid",
    borderColor: c === "gray" ? borderColor : "currentColor",
    ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
    ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
    ...runIfFn(variantGhost, props)
  };
});
var accessibleColorMap = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
};
var variantSolid3 = (0, import_styled_system6.defineStyle)((props) => {
  var _a8;
  const { colorScheme: c } = props;
  if (c === "gray") {
    const bg2 = (0, import_theme_tools4.mode)(`gray.100`, `whiteAlpha.200`)(props);
    return {
      bg: bg2,
      color: (0, import_theme_tools4.mode)(`gray.800`, `whiteAlpha.900`)(props),
      _hover: {
        bg: (0, import_theme_tools4.mode)(`gray.200`, `whiteAlpha.300`)(props),
        _disabled: {
          bg: bg2
        }
      },
      _active: { bg: (0, import_theme_tools4.mode)(`gray.300`, `whiteAlpha.400`)(props) }
    };
  }
  const {
    bg = `${c}.500`,
    color = "white",
    hoverBg = `${c}.600`,
    activeBg = `${c}.700`
  } = (_a8 = accessibleColorMap[c]) != null ? _a8 : {};
  const background = (0, import_theme_tools4.mode)(bg, `${c}.200`)(props);
  return {
    bg: background,
    color: (0, import_theme_tools4.mode)(color, `gray.800`)(props),
    _hover: {
      bg: (0, import_theme_tools4.mode)(hoverBg, `${c}.300`)(props),
      _disabled: {
        bg: background
      }
    },
    _active: { bg: (0, import_theme_tools4.mode)(activeBg, `${c}.400`)(props) }
  };
});
var variantLink = (0, import_styled_system6.defineStyle)((props) => {
  const { colorScheme: c } = props;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: (0, import_theme_tools4.mode)(`${c}.500`, `${c}.200`)(props),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: (0, import_theme_tools4.mode)(`${c}.700`, `${c}.500`)(props)
    }
  };
});
var variantUnstyled = (0, import_styled_system6.defineStyle)({
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: "0",
  p: "0"
});
var variants3 = {
  ghost: variantGhost,
  outline: variantOutline2,
  solid: variantSolid3,
  link: variantLink,
  unstyled: variantUnstyled
};
var sizes3 = {
  lg: (0, import_styled_system6.defineStyle)({
    h: "12",
    minW: "12",
    fontSize: "lg",
    px: "6"
  }),
  md: (0, import_styled_system6.defineStyle)({
    h: "10",
    minW: "10",
    fontSize: "md",
    px: "4"
  }),
  sm: (0, import_styled_system6.defineStyle)({
    h: "8",
    minW: "8",
    fontSize: "sm",
    px: "3"
  }),
  xs: (0, import_styled_system6.defineStyle)({
    h: "6",
    minW: "6",
    fontSize: "xs",
    px: "2"
  })
};
var buttonTheme = (0, import_styled_system6.defineStyleConfig)({
  baseStyle: baseStyle6,
  variants: variants3,
  sizes: sizes3,
  defaultProps: {
    variant: "solid",
    size: "md",
    colorScheme: "gray"
  }
});

// src/components/card.ts
var import_anatomy5 = __webpack_require__(34382);
var import_styled_system7 = __webpack_require__(77504);
var { definePartsStyle: definePartsStyle5, defineMultiStyleConfig: defineMultiStyleConfig5 } = (0, import_styled_system7.createMultiStyleConfigHelpers)(import_anatomy5.cardAnatomy.keys);
var $bg3 = (0, import_styled_system7.cssVar)("card-bg");
var $padding = (0, import_styled_system7.cssVar)("card-padding");
var $shadow = (0, import_styled_system7.cssVar)("card-shadow");
var $radius = (0, import_styled_system7.cssVar)("card-radius");
var $border2 = (0, import_styled_system7.cssVar)("card-border-width", "0");
var $borderColor = (0, import_styled_system7.cssVar)("card-border-color");
var baseStyle7 = definePartsStyle5({
  container: {
    [$bg3.variable]: "colors.chakra-body-bg",
    backgroundColor: $bg3.reference,
    boxShadow: $shadow.reference,
    borderRadius: $radius.reference,
    color: "chakra-body-text",
    borderWidth: $border2.reference,
    borderColor: $borderColor.reference
  },
  body: {
    padding: $padding.reference,
    flex: "1 1 0%"
  },
  header: {
    padding: $padding.reference
  },
  footer: {
    padding: $padding.reference
  }
});
var sizes4 = {
  sm: definePartsStyle5({
    container: {
      [$radius.variable]: "radii.base",
      [$padding.variable]: "space.3"
    }
  }),
  md: definePartsStyle5({
    container: {
      [$radius.variable]: "radii.md",
      [$padding.variable]: "space.5"
    }
  }),
  lg: definePartsStyle5({
    container: {
      [$radius.variable]: "radii.xl",
      [$padding.variable]: "space.7"
    }
  })
};
var variants4 = {
  elevated: definePartsStyle5({
    container: {
      [$shadow.variable]: "shadows.base",
      _dark: {
        [$bg3.variable]: "colors.gray.700"
      }
    }
  }),
  outline: definePartsStyle5({
    container: {
      [$border2.variable]: "1px",
      [$borderColor.variable]: "colors.chakra-border-color"
    }
  }),
  filled: definePartsStyle5({
    container: {
      [$bg3.variable]: "colors.chakra-subtle-bg"
    }
  }),
  unstyled: {
    body: {
      [$padding.variable]: 0
    },
    header: {
      [$padding.variable]: 0
    },
    footer: {
      [$padding.variable]: 0
    }
  }
};
var cardTheme = defineMultiStyleConfig5({
  baseStyle: baseStyle7,
  variants: variants4,
  sizes: sizes4,
  defaultProps: {
    variant: "elevated",
    size: "md"
  }
});

// src/components/checkbox.ts
var import_anatomy6 = __webpack_require__(34382);
var import_styled_system8 = __webpack_require__(77504);
var import_theme_tools5 = __webpack_require__(60723);
var { definePartsStyle: definePartsStyle6, defineMultiStyleConfig: defineMultiStyleConfig6 } = (0, import_styled_system8.createMultiStyleConfigHelpers)(import_anatomy6.checkboxAnatomy.keys);
var $size2 = (0, import_styled_system8.cssVar)("checkbox-size");
var baseStyleControl = (0, import_styled_system8.defineStyle)((props) => {
  const { colorScheme: c } = props;
  return {
    w: $size2.reference,
    h: $size2.reference,
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: (0, import_theme_tools5.mode)(`${c}.500`, `${c}.200`)(props),
      borderColor: (0, import_theme_tools5.mode)(`${c}.500`, `${c}.200`)(props),
      color: (0, import_theme_tools5.mode)("white", "gray.900")(props),
      _hover: {
        bg: (0, import_theme_tools5.mode)(`${c}.600`, `${c}.300`)(props),
        borderColor: (0, import_theme_tools5.mode)(`${c}.600`, `${c}.300`)(props)
      },
      _disabled: {
        borderColor: (0, import_theme_tools5.mode)("gray.200", "transparent")(props),
        bg: (0, import_theme_tools5.mode)("gray.200", "whiteAlpha.300")(props),
        color: (0, import_theme_tools5.mode)("gray.500", "whiteAlpha.500")(props)
      }
    },
    _indeterminate: {
      bg: (0, import_theme_tools5.mode)(`${c}.500`, `${c}.200`)(props),
      borderColor: (0, import_theme_tools5.mode)(`${c}.500`, `${c}.200`)(props),
      color: (0, import_theme_tools5.mode)("white", "gray.900")(props)
    },
    _disabled: {
      bg: (0, import_theme_tools5.mode)("gray.100", "whiteAlpha.100")(props),
      borderColor: (0, import_theme_tools5.mode)("gray.100", "transparent")(props)
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: (0, import_theme_tools5.mode)("red.500", "red.300")(props)
    }
  };
});
var baseStyleContainer3 = (0, import_styled_system8.defineStyle)({
  _disabled: { cursor: "not-allowed" }
});
var baseStyleLabel2 = (0, import_styled_system8.defineStyle)({
  userSelect: "none",
  _disabled: { opacity: 0.4 }
});
var baseStyleIcon2 = (0, import_styled_system8.defineStyle)({
  transitionProperty: "transform",
  transitionDuration: "normal"
});
var baseStyle8 = definePartsStyle6((props) => ({
  icon: baseStyleIcon2,
  container: baseStyleContainer3,
  control: runIfFn(baseStyleControl, props),
  label: baseStyleLabel2
}));
var sizes5 = {
  sm: definePartsStyle6({
    control: { [$size2.variable]: "sizes.3" },
    label: { fontSize: "sm" },
    icon: { fontSize: "3xs" }
  }),
  md: definePartsStyle6({
    control: { [$size2.variable]: "sizes.4" },
    label: { fontSize: "md" },
    icon: { fontSize: "2xs" }
  }),
  lg: definePartsStyle6({
    control: { [$size2.variable]: "sizes.5" },
    label: { fontSize: "lg" },
    icon: { fontSize: "2xs" }
  })
};
var checkboxTheme = defineMultiStyleConfig6({
  baseStyle: baseStyle8,
  sizes: sizes5,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/close-button.ts
var import_styled_system9 = __webpack_require__(77504);
var import_theme_tools6 = __webpack_require__(60723);
var $size3 = (0, import_theme_tools6.cssVar)("close-button-size");
var $bg4 = (0, import_theme_tools6.cssVar)("close-button-bg");
var baseStyle9 = (0, import_styled_system9.defineStyle)({
  w: [$size3.reference],
  h: [$size3.reference],
  borderRadius: "md",
  transitionProperty: "common",
  transitionDuration: "normal",
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    [$bg4.variable]: "colors.blackAlpha.100",
    _dark: {
      [$bg4.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [$bg4.variable]: "colors.blackAlpha.200",
    _dark: {
      [$bg4.variable]: "colors.whiteAlpha.200"
    }
  },
  _focusVisible: {
    boxShadow: "outline"
  },
  bg: $bg4.reference
});
var sizes6 = {
  lg: (0, import_styled_system9.defineStyle)({
    [$size3.variable]: "sizes.10",
    fontSize: "md"
  }),
  md: (0, import_styled_system9.defineStyle)({
    [$size3.variable]: "sizes.8",
    fontSize: "xs"
  }),
  sm: (0, import_styled_system9.defineStyle)({
    [$size3.variable]: "sizes.6",
    fontSize: "2xs"
  })
};
var closeButtonTheme = (0, import_styled_system9.defineStyleConfig)({
  baseStyle: baseStyle9,
  sizes: sizes6,
  defaultProps: {
    size: "md"
  }
});

// src/components/code.ts
var import_styled_system10 = __webpack_require__(77504);
var { variants: variants5, defaultProps } = badgeTheme;
var baseStyle10 = (0, import_styled_system10.defineStyle)({
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm",
  bg: vars.bg.reference,
  color: vars.color.reference,
  boxShadow: vars.shadow.reference
});
var codeTheme = (0, import_styled_system10.defineStyleConfig)({
  baseStyle: baseStyle10,
  variants: variants5,
  defaultProps
});

// src/components/container.ts
var import_styled_system11 = __webpack_require__(77504);
var baseStyle11 = (0, import_styled_system11.defineStyle)({
  w: "100%",
  mx: "auto",
  maxW: "prose",
  px: "4"
});
var containerTheme = (0, import_styled_system11.defineStyleConfig)({
  baseStyle: baseStyle11
});

// src/components/divider.ts
var import_styled_system12 = __webpack_require__(77504);
var baseStyle12 = (0, import_styled_system12.defineStyle)({
  opacity: 0.6,
  borderColor: "inherit"
});
var variantSolid4 = (0, import_styled_system12.defineStyle)({
  borderStyle: "solid"
});
var variantDashed = (0, import_styled_system12.defineStyle)({
  borderStyle: "dashed"
});
var variants6 = {
  solid: variantSolid4,
  dashed: variantDashed
};
var dividerTheme = (0, import_styled_system12.defineStyleConfig)({
  baseStyle: baseStyle12,
  variants: variants6,
  defaultProps: {
    variant: "solid"
  }
});

// src/components/drawer.ts
var import_anatomy7 = __webpack_require__(34382);
var import_styled_system13 = __webpack_require__(77504);
var { definePartsStyle: definePartsStyle7, defineMultiStyleConfig: defineMultiStyleConfig7 } = (0, import_styled_system13.createMultiStyleConfigHelpers)(import_anatomy7.drawerAnatomy.keys);
var $bg5 = (0, import_styled_system13.cssVar)("drawer-bg");
var $bs = (0, import_styled_system13.cssVar)("drawer-box-shadow");
function getSize2(value) {
  if (value === "full") {
    return definePartsStyle7({
      dialog: { maxW: "100vw", h: "100vh" }
    });
  }
  return definePartsStyle7({
    dialog: { maxW: value }
  });
}
var baseStyleOverlay = (0, import_styled_system13.defineStyle)({
  bg: "blackAlpha.600",
  zIndex: "overlay"
});
var baseStyleDialogContainer = (0, import_styled_system13.defineStyle)({
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
});
var baseStyleDialog = (0, import_styled_system13.defineStyle)((props) => {
  const { isFullHeight } = props;
  return {
    ...isFullHeight && { height: "100vh" },
    zIndex: "modal",
    maxH: "100vh",
    color: "inherit",
    [$bg5.variable]: "colors.white",
    [$bs.variable]: "shadows.lg",
    _dark: {
      [$bg5.variable]: "colors.gray.700",
      [$bs.variable]: "shadows.dark-lg"
    },
    bg: $bg5.reference,
    boxShadow: $bs.reference
  };
});
var baseStyleHeader = (0, import_styled_system13.defineStyle)({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton = (0, import_styled_system13.defineStyle)({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody = (0, import_styled_system13.defineStyle)({
  px: "6",
  py: "2",
  flex: "1",
  overflow: "auto"
});
var baseStyleFooter = (0, import_styled_system13.defineStyle)({
  px: "6",
  py: "4"
});
var baseStyle13 = definePartsStyle7((props) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer,
  dialog: runIfFn(baseStyleDialog, props),
  header: baseStyleHeader,
  closeButton: baseStyleCloseButton,
  body: baseStyleBody,
  footer: baseStyleFooter
}));
var sizes7 = {
  xs: getSize2("xs"),
  sm: getSize2("md"),
  md: getSize2("lg"),
  lg: getSize2("2xl"),
  xl: getSize2("4xl"),
  full: getSize2("full")
};
var drawerTheme = defineMultiStyleConfig7({
  baseStyle: baseStyle13,
  sizes: sizes7,
  defaultProps: {
    size: "xs"
  }
});

// src/components/editable.ts
var import_anatomy8 = __webpack_require__(34382);
var import_styled_system14 = __webpack_require__(77504);
var { definePartsStyle: definePartsStyle8, defineMultiStyleConfig: defineMultiStyleConfig8 } = (0, import_styled_system14.createMultiStyleConfigHelpers)(import_anatomy8.editableAnatomy.keys);
var baseStylePreview = (0, import_styled_system14.defineStyle)({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal"
});
var baseStyleInput = (0, import_styled_system14.defineStyle)({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
});
var baseStyleTextarea = (0, import_styled_system14.defineStyle)({
  borderRadius: "md",
  py: "1",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focusVisible: { boxShadow: "outline" },
  _placeholder: { opacity: 0.6 }
});
var baseStyle14 = definePartsStyle8({
  preview: baseStylePreview,
  input: baseStyleInput,
  textarea: baseStyleTextarea
});
var editableTheme = defineMultiStyleConfig8({
  baseStyle: baseStyle14
});

// src/components/form-control.ts
var import_anatomy9 = __webpack_require__(34382);
var import_styled_system15 = __webpack_require__(77504);
var { definePartsStyle: definePartsStyle9, defineMultiStyleConfig: defineMultiStyleConfig9 } = (0, import_styled_system15.createMultiStyleConfigHelpers)(import_anatomy9.formAnatomy.keys);
var $fg2 = (0, import_styled_system15.cssVar)("form-control-color");
var baseStyleRequiredIndicator = (0, import_styled_system15.defineStyle)({
  marginStart: "1",
  [$fg2.variable]: "colors.red.500",
  _dark: {
    [$fg2.variable]: "colors.red.300"
  },
  color: $fg2.reference
});
var baseStyleHelperText = (0, import_styled_system15.defineStyle)({
  mt: "2",
  [$fg2.variable]: "colors.gray.600",
  _dark: {
    [$fg2.variable]: "colors.whiteAlpha.600"
  },
  color: $fg2.reference,
  lineHeight: "normal",
  fontSize: "sm"
});
var baseStyle15 = definePartsStyle9({
  container: {
    width: "100%",
    position: "relative"
  },
  requiredIndicator: baseStyleRequiredIndicator,
  helperText: baseStyleHelperText
});
var formTheme = defineMultiStyleConfig9({
  baseStyle: baseStyle15
});

// src/components/form-error.ts
var import_anatomy10 = __webpack_require__(34382);
var import_styled_system16 = __webpack_require__(77504);
var { definePartsStyle: definePartsStyle10, defineMultiStyleConfig: defineMultiStyleConfig10 } = (0, import_styled_system16.createMultiStyleConfigHelpers)(import_anatomy10.formErrorAnatomy.keys);
var $fg3 = (0, import_styled_system16.cssVar)("form-error-color");
var baseStyleText = (0, import_styled_system16.defineStyle)({
  [$fg3.variable]: `colors.red.500`,
  _dark: {
    [$fg3.variable]: `colors.red.300`
  },
  color: $fg3.reference,
  mt: "2",
  fontSize: "sm",
  lineHeight: "normal"
});
var baseStyleIcon3 = (0, import_styled_system16.defineStyle)({
  marginEnd: "0.5em",
  [$fg3.variable]: `colors.red.500`,
  _dark: {
    [$fg3.variable]: `colors.red.300`
  },
  color: $fg3.reference
});
var baseStyle16 = definePartsStyle10({
  text: baseStyleText,
  icon: baseStyleIcon3
});
var formErrorTheme = defineMultiStyleConfig10({
  baseStyle: baseStyle16
});

// src/components/form-label.ts
var import_styled_system17 = __webpack_require__(77504);
var baseStyle17 = (0, import_styled_system17.defineStyle)({
  fontSize: "md",
  marginEnd: "3",
  mb: "2",
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
});
var formLabelTheme = (0, import_styled_system17.defineStyleConfig)({
  baseStyle: baseStyle17
});

// src/components/heading.ts
var import_styled_system18 = __webpack_require__(77504);
var baseStyle18 = (0, import_styled_system18.defineStyle)({
  fontFamily: "heading",
  fontWeight: "bold"
});
var sizes8 = {
  "4xl": (0, import_styled_system18.defineStyle)({
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  }),
  "3xl": (0, import_styled_system18.defineStyle)({
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  }),
  "2xl": (0, import_styled_system18.defineStyle)({
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  }),
  xl: (0, import_styled_system18.defineStyle)({
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  }),
  lg: (0, import_styled_system18.defineStyle)({
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  }),
  md: (0, import_styled_system18.defineStyle)({
    fontSize: "xl",
    lineHeight: 1.2
  }),
  sm: (0, import_styled_system18.defineStyle)({
    fontSize: "md",
    lineHeight: 1.2
  }),
  xs: (0, import_styled_system18.defineStyle)({
    fontSize: "sm",
    lineHeight: 1.2
  })
};
var headingTheme = (0, import_styled_system18.defineStyleConfig)({
  baseStyle: baseStyle18,
  sizes: sizes8,
  defaultProps: {
    size: "xl"
  }
});

// src/components/input.ts
var import_anatomy11 = __webpack_require__(34382);
var import_styled_system19 = __webpack_require__(77504);
var import_theme_tools7 = __webpack_require__(60723);
var { definePartsStyle: definePartsStyle11, defineMultiStyleConfig: defineMultiStyleConfig11 } = (0, import_styled_system19.createMultiStyleConfigHelpers)(import_anatomy11.inputAnatomy.keys);
var baseStyle19 = definePartsStyle11({
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  }
});
var size = {
  lg: (0, import_styled_system19.defineStyle)({
    fontSize: "lg",
    px: "4",
    h: "12",
    borderRadius: "md"
  }),
  md: (0, import_styled_system19.defineStyle)({
    fontSize: "md",
    px: "4",
    h: "10",
    borderRadius: "md"
  }),
  sm: (0, import_styled_system19.defineStyle)({
    fontSize: "sm",
    px: "3",
    h: "8",
    borderRadius: "sm"
  }),
  xs: (0, import_styled_system19.defineStyle)({
    fontSize: "xs",
    px: "2",
    h: "6",
    borderRadius: "sm"
  })
};
var sizes9 = {
  lg: definePartsStyle11({
    field: size.lg,
    addon: size.lg
  }),
  md: definePartsStyle11({
    field: size.md,
    addon: size.md
  }),
  sm: definePartsStyle11({
    field: size.sm,
    addon: size.sm
  }),
  xs: definePartsStyle11({
    field: size.xs,
    addon: size.xs
  })
};
function getDefaults(props) {
  const { focusBorderColor: fc, errorBorderColor: ec } = props;
  return {
    focusBorderColor: fc || (0, import_theme_tools7.mode)("blue.500", "blue.300")(props),
    errorBorderColor: ec || (0, import_theme_tools7.mode)("red.500", "red.300")(props)
  };
}
var variantOutline3 = definePartsStyle11((props) => {
  const { theme: theme2 } = props;
  const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: (0, import_theme_tools7.mode)("gray.300", "whiteAlpha.400")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, ec),
        boxShadow: `0 0 0 1px ${(0, import_theme_tools7.getColorVar)(theme2, ec)}`
      },
      _focusVisible: {
        zIndex: 1,
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, fc),
        boxShadow: `0 0 0 1px ${(0, import_theme_tools7.getColorVar)(theme2, fc)}`
      }
    },
    addon: {
      border: "1px solid",
      borderColor: (0, import_theme_tools7.mode)("inherit", "whiteAlpha.50")(props),
      bg: (0, import_theme_tools7.mode)("gray.100", "whiteAlpha.300")(props)
    }
  };
});
var variantFilled = definePartsStyle11((props) => {
  const { theme: theme2 } = props;
  const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: (0, import_theme_tools7.mode)("gray.100", "whiteAlpha.50")(props),
      _hover: {
        bg: (0, import_theme_tools7.mode)("gray.200", "whiteAlpha.100")(props)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, ec)
      },
      _focusVisible: {
        bg: "transparent",
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, fc)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: (0, import_theme_tools7.mode)("gray.100", "whiteAlpha.50")(props)
    }
  };
});
var variantFlushed = definePartsStyle11((props) => {
  const { theme: theme2 } = props;
  const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, ec),
        boxShadow: `0px 1px 0px 0px ${(0, import_theme_tools7.getColorVar)(theme2, ec)}`
      },
      _focusVisible: {
        borderColor: (0, import_theme_tools7.getColorVar)(theme2, fc),
        boxShadow: `0px 1px 0px 0px ${(0, import_theme_tools7.getColorVar)(theme2, fc)}`
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: "0",
      px: "0",
      bg: "transparent"
    }
  };
});
var variantUnstyled2 = definePartsStyle11({
  field: {
    bg: "transparent",
    px: "0",
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: "0",
    height: "auto"
  }
});
var variants7 = {
  outline: variantOutline3,
  filled: variantFilled,
  flushed: variantFlushed,
  unstyled: variantUnstyled2
};
var inputTheme = defineMultiStyleConfig11({
  baseStyle: baseStyle19,
  sizes: sizes9,
  variants: variants7,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});

// src/components/kbd.ts
var import_styled_system20 = __webpack_require__(77504);
var $bg6 = (0, import_styled_system20.cssVar)("kbd-bg");
var baseStyle20 = (0, import_styled_system20.defineStyle)({
  [$bg6.variable]: "colors.gray.100",
  _dark: {
    [$bg6.variable]: "colors.whiteAlpha.100"
  },
  bg: $bg6.reference,
  borderRadius: "md",
  borderWidth: "1px",
  borderBottomWidth: "3px",
  fontSize: "0.8em",
  fontWeight: "bold",
  lineHeight: "normal",
  px: "0.4em",
  whiteSpace: "nowrap"
});
var kbdTheme = (0, import_styled_system20.defineStyleConfig)({
  baseStyle: baseStyle20
});

// src/components/link.ts
var import_styled_system21 = __webpack_require__(77504);
var baseStyle21 = (0, import_styled_system21.defineStyle)({
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
});
var linkTheme = (0, import_styled_system21.defineStyleConfig)({
  baseStyle: baseStyle21
});

// src/components/list.ts
var import_anatomy12 = __webpack_require__(34382);
var import_styled_system22 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig12, definePartsStyle: definePartsStyle12 } = (0, import_styled_system22.createMultiStyleConfigHelpers)(import_anatomy12.listAnatomy.keys);
var baseStyleIcon4 = (0, import_styled_system22.defineStyle)({
  marginEnd: "2",
  display: "inline",
  verticalAlign: "text-bottom"
});
var baseStyle22 = definePartsStyle12({
  icon: baseStyleIcon4
});
var listTheme = defineMultiStyleConfig12({
  baseStyle: baseStyle22
});

// src/components/menu.ts
var import_anatomy13 = __webpack_require__(34382);
var import_styled_system23 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig13, definePartsStyle: definePartsStyle13 } = (0, import_styled_system23.createMultiStyleConfigHelpers)(import_anatomy13.menuAnatomy.keys);
var $bg7 = (0, import_styled_system23.cssVar)("menu-bg");
var $shadow2 = (0, import_styled_system23.cssVar)("menu-shadow");
var baseStyleList = (0, import_styled_system23.defineStyle)({
  [$bg7.variable]: "#fff",
  [$shadow2.variable]: "shadows.sm",
  _dark: {
    [$bg7.variable]: "colors.gray.700",
    [$shadow2.variable]: "shadows.dark-lg"
  },
  color: "inherit",
  minW: "3xs",
  py: "2",
  zIndex: 1,
  borderRadius: "md",
  borderWidth: "1px",
  bg: $bg7.reference,
  boxShadow: $shadow2.reference
});
var baseStyleItem = (0, import_styled_system23.defineStyle)({
  py: "1.5",
  px: "3",
  transitionProperty: "background",
  transitionDuration: "ultra-fast",
  transitionTimingFunction: "ease-in",
  _focus: {
    [$bg7.variable]: "colors.gray.100",
    _dark: {
      [$bg7.variable]: "colors.whiteAlpha.100"
    }
  },
  _active: {
    [$bg7.variable]: "colors.gray.200",
    _dark: {
      [$bg7.variable]: "colors.whiteAlpha.200"
    }
  },
  _expanded: {
    [$bg7.variable]: "colors.gray.100",
    _dark: {
      [$bg7.variable]: "colors.whiteAlpha.100"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  bg: $bg7.reference
});
var baseStyleGroupTitle = (0, import_styled_system23.defineStyle)({
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
});
var baseStyleCommand = (0, import_styled_system23.defineStyle)({
  opacity: 0.6
});
var baseStyleDivider = (0, import_styled_system23.defineStyle)({
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "2",
  opacity: 0.6
});
var baseStyleButton2 = (0, import_styled_system23.defineStyle)({
  transitionProperty: "common",
  transitionDuration: "normal"
});
var baseStyle23 = definePartsStyle13({
  button: baseStyleButton2,
  list: baseStyleList,
  item: baseStyleItem,
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider
});
var menuTheme = defineMultiStyleConfig13({
  baseStyle: baseStyle23
});

// src/components/modal.ts
var import_anatomy14 = __webpack_require__(34382);
var import_styled_system24 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig14, definePartsStyle: definePartsStyle14 } = (0, import_styled_system24.createMultiStyleConfigHelpers)(import_anatomy14.modalAnatomy.keys);
var $bg8 = (0, import_styled_system24.cssVar)("modal-bg");
var $shadow3 = (0, import_styled_system24.cssVar)("modal-shadow");
var baseStyleOverlay2 = (0, import_styled_system24.defineStyle)({
  bg: "blackAlpha.600",
  zIndex: "modal"
});
var baseStyleDialogContainer2 = (0, import_styled_system24.defineStyle)((props) => {
  const { isCentered, scrollBehavior } = props;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: isCentered ? "center" : "flex-start",
    overflow: scrollBehavior === "inside" ? "hidden" : "auto",
    overscrollBehaviorY: "none"
  };
});
var baseStyleDialog2 = (0, import_styled_system24.defineStyle)((props) => {
  const { isCentered, scrollBehavior } = props;
  return {
    borderRadius: "md",
    color: "inherit",
    my: isCentered ? "auto" : "16",
    mx: isCentered ? "auto" : void 0,
    zIndex: "modal",
    maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
    [$bg8.variable]: "colors.white",
    [$shadow3.variable]: "shadows.lg",
    _dark: {
      [$bg8.variable]: "colors.gray.700",
      [$shadow3.variable]: "shadows.dark-lg"
    },
    bg: $bg8.reference,
    boxShadow: $shadow3.reference
  };
});
var baseStyleHeader2 = (0, import_styled_system24.defineStyle)({
  px: "6",
  py: "4",
  fontSize: "xl",
  fontWeight: "semibold"
});
var baseStyleCloseButton2 = (0, import_styled_system24.defineStyle)({
  position: "absolute",
  top: "2",
  insetEnd: "3"
});
var baseStyleBody2 = (0, import_styled_system24.defineStyle)((props) => {
  const { scrollBehavior } = props;
  return {
    px: "6",
    py: "2",
    flex: "1",
    overflow: scrollBehavior === "inside" ? "auto" : void 0
  };
});
var baseStyleFooter2 = (0, import_styled_system24.defineStyle)({
  px: "6",
  py: "4"
});
var baseStyle24 = definePartsStyle14((props) => ({
  overlay: baseStyleOverlay2,
  dialogContainer: runIfFn(baseStyleDialogContainer2, props),
  dialog: runIfFn(baseStyleDialog2, props),
  header: baseStyleHeader2,
  closeButton: baseStyleCloseButton2,
  body: runIfFn(baseStyleBody2, props),
  footer: baseStyleFooter2
}));
function getSize3(value) {
  if (value === "full") {
    return definePartsStyle14({
      dialog: {
        maxW: "100vw",
        minH: "$100vh",
        my: "0",
        borderRadius: "0"
      }
    });
  }
  return definePartsStyle14({
    dialog: { maxW: value }
  });
}
var sizes10 = {
  xs: getSize3("xs"),
  sm: getSize3("sm"),
  md: getSize3("md"),
  lg: getSize3("lg"),
  xl: getSize3("xl"),
  "2xl": getSize3("2xl"),
  "3xl": getSize3("3xl"),
  "4xl": getSize3("4xl"),
  "5xl": getSize3("5xl"),
  "6xl": getSize3("6xl"),
  full: getSize3("full")
};
var modalTheme = defineMultiStyleConfig14({
  baseStyle: baseStyle24,
  sizes: sizes10,
  defaultProps: { size: "md" }
});

// src/components/number-input.ts
var import_anatomy15 = __webpack_require__(34382);
var import_styled_system25 = __webpack_require__(77504);
var import_theme_tools8 = __webpack_require__(60723);

// src/foundations/typography.ts
var typography = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": ".75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
  },
  fontSizes: {
    "3xs": "0.45rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
};
var typography_default = typography;

// src/components/number-input.ts
var { defineMultiStyleConfig: defineMultiStyleConfig15, definePartsStyle: definePartsStyle15 } = (0, import_styled_system25.createMultiStyleConfigHelpers)(import_anatomy15.numberInputAnatomy.keys);
var $stepperWidth = (0, import_theme_tools8.cssVar)("number-input-stepper-width");
var $inputPadding = (0, import_theme_tools8.cssVar)("number-input-input-padding");
var inputPaddingValue = (0, import_theme_tools8.calc)($stepperWidth).add("0.5rem").toString();
var $bg9 = (0, import_theme_tools8.cssVar)("number-input-bg");
var $fg4 = (0, import_theme_tools8.cssVar)("number-input-color");
var $border3 = (0, import_theme_tools8.cssVar)("number-input-border-color");
var baseStyleRoot = (0, import_styled_system25.defineStyle)({
  [$stepperWidth.variable]: "sizes.6",
  [$inputPadding.variable]: inputPaddingValue
});
var baseStyleField = (0, import_styled_system25.defineStyle)(
  (props) => {
    var _a8, _b5;
    return (_b5 = (_a8 = runIfFn(inputTheme.baseStyle, props)) == null ? void 0 : _a8.field) != null ? _b5 : {};
  }
);
var baseStyleStepperGroup = (0, import_styled_system25.defineStyle)({
  width: $stepperWidth.reference
});
var baseStyleStepper = (0, import_styled_system25.defineStyle)({
  borderStart: "1px solid",
  borderStartColor: $border3.reference,
  color: $fg4.reference,
  bg: $bg9.reference,
  [$fg4.variable]: "colors.chakra-body-text",
  [$border3.variable]: "colors.chakra-border-color",
  _dark: {
    [$fg4.variable]: "colors.whiteAlpha.800",
    [$border3.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [$bg9.variable]: "colors.gray.200",
    _dark: {
      [$bg9.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
});
var baseStyle25 = definePartsStyle15((props) => {
  var _a8;
  return {
    root: baseStyleRoot,
    field: (_a8 = runIfFn(baseStyleField, props)) != null ? _a8 : {},
    stepperGroup: baseStyleStepperGroup,
    stepper: baseStyleStepper
  };
});
function getSize4(size2) {
  var _a8, _b5, _c3;
  const sizeStyle = (_a8 = inputTheme.sizes) == null ? void 0 : _a8[size2];
  const radius = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  };
  const _fontSize = (_c3 = (_b5 = sizeStyle.field) == null ? void 0 : _b5.fontSize) != null ? _c3 : "md";
  const fontSize = typography_default.fontSizes[_fontSize];
  return definePartsStyle15({
    field: {
      ...sizeStyle.field,
      paddingInlineEnd: $inputPadding.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: (0, import_theme_tools8.calc)(fontSize).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: radius[size2]
      },
      _last: {
        borderBottomEndRadius: radius[size2],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var sizes11 = {
  xs: getSize4("xs"),
  sm: getSize4("sm"),
  md: getSize4("md"),
  lg: getSize4("lg")
};
var numberInputTheme = defineMultiStyleConfig15({
  baseStyle: baseStyle25,
  sizes: sizes11,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});

// src/components/pin-input.ts
var import_styled_system26 = __webpack_require__(77504);
var _a;
var baseStyle26 = (0, import_styled_system26.defineStyle)({
  ...(_a = inputTheme.baseStyle) == null ? void 0 : _a.field,
  textAlign: "center"
});
var sizes12 = {
  lg: (0, import_styled_system26.defineStyle)({
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  }),
  md: (0, import_styled_system26.defineStyle)({
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  }),
  sm: (0, import_styled_system26.defineStyle)({
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  }),
  xs: (0, import_styled_system26.defineStyle)({
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  })
};
var _a2, _b;
var variants8 = {
  outline: (0, import_styled_system26.defineStyle)(
    (props) => {
      var _a8, _b5, _c3;
      return (_c3 = (_b5 = runIfFn((_a8 = inputTheme.variants) == null ? void 0 : _a8.outline, props)) == null ? void 0 : _b5.field) != null ? _c3 : {};
    }
  ),
  flushed: (0, import_styled_system26.defineStyle)(
    (props) => {
      var _a8, _b5, _c3;
      return (_c3 = (_b5 = runIfFn((_a8 = inputTheme.variants) == null ? void 0 : _a8.flushed, props)) == null ? void 0 : _b5.field) != null ? _c3 : {};
    }
  ),
  filled: (0, import_styled_system26.defineStyle)(
    (props) => {
      var _a8, _b5, _c3;
      return (_c3 = (_b5 = runIfFn((_a8 = inputTheme.variants) == null ? void 0 : _a8.filled, props)) == null ? void 0 : _b5.field) != null ? _c3 : {};
    }
  ),
  unstyled: (_b = (_a2 = inputTheme.variants) == null ? void 0 : _a2.unstyled.field) != null ? _b : {}
};
var pinInputTheme = (0, import_styled_system26.defineStyleConfig)({
  baseStyle: baseStyle26,
  sizes: sizes12,
  variants: variants8,
  defaultProps: inputTheme.defaultProps
});

// src/components/popover.ts
var import_anatomy16 = __webpack_require__(34382);
var import_styled_system27 = __webpack_require__(77504);
var import_theme_tools9 = __webpack_require__(60723);
var { defineMultiStyleConfig: defineMultiStyleConfig16, definePartsStyle: definePartsStyle16 } = (0, import_styled_system27.createMultiStyleConfigHelpers)(import_anatomy16.popoverAnatomy.keys);
var $popperBg = (0, import_theme_tools9.cssVar)("popper-bg");
var $arrowBg = (0, import_theme_tools9.cssVar)("popper-arrow-bg");
var $arrowShadowColor = (0, import_theme_tools9.cssVar)("popper-arrow-shadow-color");
var baseStylePopper = (0, import_styled_system27.defineStyle)({ zIndex: 10 });
var baseStyleContent = (0, import_styled_system27.defineStyle)({
  [$popperBg.variable]: `colors.white`,
  bg: $popperBg.reference,
  [$arrowBg.variable]: $popperBg.reference,
  [$arrowShadowColor.variable]: `colors.gray.200`,
  _dark: {
    [$popperBg.variable]: `colors.gray.700`,
    [$arrowShadowColor.variable]: `colors.whiteAlpha.300`
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
});
var baseStyleHeader3 = (0, import_styled_system27.defineStyle)({
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
});
var baseStyleBody3 = (0, import_styled_system27.defineStyle)({
  px: 3,
  py: 2
});
var baseStyleFooter3 = (0, import_styled_system27.defineStyle)({
  px: 3,
  py: 2,
  borderTopWidth: "1px"
});
var baseStyleCloseButton3 = (0, import_styled_system27.defineStyle)({
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
});
var baseStyle27 = definePartsStyle16({
  popper: baseStylePopper,
  content: baseStyleContent,
  header: baseStyleHeader3,
  body: baseStyleBody3,
  footer: baseStyleFooter3,
  closeButton: baseStyleCloseButton3
});
var popoverTheme = defineMultiStyleConfig16({
  baseStyle: baseStyle27
});

// src/components/progress.ts
var import_anatomy17 = __webpack_require__(34382);
var import_styled_system28 = __webpack_require__(77504);
var import_theme_tools10 = __webpack_require__(60723);
var { defineMultiStyleConfig: defineMultiStyleConfig17, definePartsStyle: definePartsStyle17 } = (0, import_styled_system28.createMultiStyleConfigHelpers)(import_anatomy17.progressAnatomy.keys);
var filledStyle = (0, import_styled_system28.defineStyle)((props) => {
  const { colorScheme: c, theme: t, isIndeterminate, hasStripe } = props;
  const stripeStyle = (0, import_theme_tools10.mode)(
    (0, import_theme_tools10.generateStripe)(),
    (0, import_theme_tools10.generateStripe)("1rem", "rgba(0,0,0,0.1)")
  )(props);
  const bgColor = (0, import_theme_tools10.mode)(`${c}.500`, `${c}.200`)(props);
  const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${(0, import_theme_tools10.getColorVar)(t, bgColor)} 50%,
    transparent 100%
  )`;
  const addStripe = !isIndeterminate && hasStripe;
  return {
    ...addStripe && stripeStyle,
    ...isIndeterminate ? { bgImage: gradient } : { bgColor }
  };
});
var baseStyleLabel3 = (0, import_styled_system28.defineStyle)({
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
});
var baseStyleTrack = (0, import_styled_system28.defineStyle)((props) => {
  return {
    bg: (0, import_theme_tools10.mode)("gray.100", "whiteAlpha.300")(props)
  };
});
var baseStyleFilledTrack = (0, import_styled_system28.defineStyle)((props) => {
  return {
    transitionProperty: "common",
    transitionDuration: "slow",
    ...filledStyle(props)
  };
});
var baseStyle28 = definePartsStyle17((props) => ({
  label: baseStyleLabel3,
  filledTrack: baseStyleFilledTrack(props),
  track: baseStyleTrack(props)
}));
var sizes13 = {
  xs: definePartsStyle17({
    track: { h: "1" }
  }),
  sm: definePartsStyle17({
    track: { h: "2" }
  }),
  md: definePartsStyle17({
    track: { h: "3" }
  }),
  lg: definePartsStyle17({
    track: { h: "4" }
  })
};
var progressTheme = defineMultiStyleConfig17({
  sizes: sizes13,
  baseStyle: baseStyle28,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/radio.ts
var import_anatomy18 = __webpack_require__(34382);
var import_styled_system29 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig18, definePartsStyle: definePartsStyle18 } = (0, import_styled_system29.createMultiStyleConfigHelpers)(import_anatomy18.radioAnatomy.keys);
var baseStyleControl2 = (0, import_styled_system29.defineStyle)((props) => {
  var _a8;
  const controlStyle = (_a8 = runIfFn(checkboxTheme.baseStyle, props)) == null ? void 0 : _a8.control;
  return {
    ...controlStyle,
    borderRadius: "full",
    _checked: {
      ...controlStyle == null ? void 0 : controlStyle["_checked"],
      _before: {
        content: `""`,
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    }
  };
});
var baseStyle29 = definePartsStyle18((props) => {
  var _a8, _b5, _c3, _d3;
  return {
    label: (_b5 = (_a8 = checkboxTheme).baseStyle) == null ? void 0 : _b5.call(_a8, props).label,
    container: (_d3 = (_c3 = checkboxTheme).baseStyle) == null ? void 0 : _d3.call(_c3, props).container,
    control: baseStyleControl2(props)
  };
});
var sizes14 = {
  md: definePartsStyle18({
    control: { w: "4", h: "4" },
    label: { fontSize: "md" }
  }),
  lg: definePartsStyle18({
    control: { w: "5", h: "5" },
    label: { fontSize: "lg" }
  }),
  sm: definePartsStyle18({
    control: { width: "3", height: "3" },
    label: { fontSize: "sm" }
  })
};
var radioTheme = defineMultiStyleConfig18({
  baseStyle: baseStyle29,
  sizes: sizes14,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/select.ts
var import_anatomy19 = __webpack_require__(34382);
var import_styled_system30 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig19, definePartsStyle: definePartsStyle19 } = (0, import_styled_system30.createMultiStyleConfigHelpers)(import_anatomy19.selectAnatomy.keys);
var $bg10 = (0, import_styled_system30.cssVar)("select-bg");
var _a3;
var baseStyleField2 = (0, import_styled_system30.defineStyle)({
  ...(_a3 = inputTheme.baseStyle) == null ? void 0 : _a3.field,
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: $bg10.reference,
  [$bg10.variable]: "colors.white",
  _dark: {
    [$bg10.variable]: "colors.gray.700"
  },
  "> option, > optgroup": {
    bg: $bg10.reference
  }
});
var baseStyleIcon5 = (0, import_styled_system30.defineStyle)({
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
});
var baseStyle30 = definePartsStyle19({
  field: baseStyleField2,
  icon: baseStyleIcon5
});
var iconSpacing = (0, import_styled_system30.defineStyle)({
  paddingInlineEnd: "8"
});
var _a4, _b2, _c, _d, _e, _f, _g, _h;
var sizes15 = {
  lg: {
    ...(_a4 = inputTheme.sizes) == null ? void 0 : _a4.lg,
    field: {
      ...(_b2 = inputTheme.sizes) == null ? void 0 : _b2.lg.field,
      ...iconSpacing
    }
  },
  md: {
    ...(_c = inputTheme.sizes) == null ? void 0 : _c.md,
    field: {
      ...(_d = inputTheme.sizes) == null ? void 0 : _d.md.field,
      ...iconSpacing
    }
  },
  sm: {
    ...(_e = inputTheme.sizes) == null ? void 0 : _e.sm,
    field: {
      ...(_f = inputTheme.sizes) == null ? void 0 : _f.sm.field,
      ...iconSpacing
    }
  },
  xs: {
    ...(_g = inputTheme.sizes) == null ? void 0 : _g.xs,
    field: {
      ...(_h = inputTheme.sizes) == null ? void 0 : _h.xs.field,
      ...iconSpacing
    },
    icon: {
      insetEnd: "1"
    }
  }
};
var selectTheme = defineMultiStyleConfig19({
  baseStyle: baseStyle30,
  sizes: sizes15,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});

// src/components/skeleton.ts
var import_styled_system31 = __webpack_require__(77504);
var $startColor = (0, import_styled_system31.cssVar)("skeleton-start-color");
var $endColor = (0, import_styled_system31.cssVar)("skeleton-end-color");
var baseStyle31 = (0, import_styled_system31.defineStyle)({
  [$startColor.variable]: "colors.gray.100",
  [$endColor.variable]: "colors.gray.400",
  _dark: {
    [$startColor.variable]: "colors.gray.800",
    [$endColor.variable]: "colors.gray.600"
  },
  background: $startColor.reference,
  borderColor: $endColor.reference,
  opacity: 0.7,
  borderRadius: "sm"
});
var skeletonTheme = (0, import_styled_system31.defineStyleConfig)({
  baseStyle: baseStyle31
});

// src/components/skip-link.ts
var import_styled_system32 = __webpack_require__(77504);
var $bg11 = (0, import_styled_system32.cssVar)("skip-link-bg");
var baseStyle32 = (0, import_styled_system32.defineStyle)({
  borderRadius: "md",
  fontWeight: "semibold",
  _focusVisible: {
    boxShadow: "outline",
    padding: "4",
    position: "fixed",
    top: "6",
    insetStart: "6",
    [$bg11.variable]: "colors.white",
    _dark: {
      [$bg11.variable]: "colors.gray.700"
    },
    bg: $bg11.reference
  }
});
var skipLinkTheme = (0, import_styled_system32.defineStyleConfig)({
  baseStyle: baseStyle32
});

// src/components/slider.ts
var import_anatomy20 = __webpack_require__(34382);
var import_styled_system33 = __webpack_require__(77504);
var import_theme_tools11 = __webpack_require__(60723);
var { defineMultiStyleConfig: defineMultiStyleConfig20, definePartsStyle: definePartsStyle20 } = (0, import_styled_system33.createMultiStyleConfigHelpers)(import_anatomy20.sliderAnatomy.keys);
var $thumbSize = (0, import_styled_system33.cssVar)("slider-thumb-size");
var $trackSize = (0, import_styled_system33.cssVar)("slider-track-size");
var $bg12 = (0, import_styled_system33.cssVar)("slider-bg");
var baseStyleContainer4 = (0, import_styled_system33.defineStyle)((props) => {
  const { orientation } = props;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    },
    ...(0, import_theme_tools11.orient)({
      orientation,
      vertical: { h: "100%" },
      horizontal: { w: "100%" }
    })
  };
});
var baseStyleTrack2 = (0, import_styled_system33.defineStyle)((props) => {
  const orientationStyles = (0, import_theme_tools11.orient)({
    orientation: props.orientation,
    horizontal: { h: $trackSize.reference },
    vertical: { w: $trackSize.reference }
  });
  return {
    ...orientationStyles,
    overflow: "hidden",
    borderRadius: "sm",
    [$bg12.variable]: "colors.gray.200",
    _dark: {
      [$bg12.variable]: "colors.whiteAlpha.200"
    },
    _disabled: {
      [$bg12.variable]: "colors.gray.300",
      _dark: {
        [$bg12.variable]: "colors.whiteAlpha.300"
      }
    },
    bg: $bg12.reference
  };
});
var baseStyleThumb = (0, import_styled_system33.defineStyle)((props) => {
  const { orientation } = props;
  const orientationStyle = (0, import_theme_tools11.orient)({
    orientation,
    vertical: {
      left: "50%",
      transform: `translateX(-50%)`,
      _active: {
        transform: `translateX(-50%) scale(1.15)`
      }
    },
    horizontal: {
      top: "50%",
      transform: `translateY(-50%)`,
      _active: {
        transform: `translateY(-50%) scale(1.15)`
      }
    }
  });
  return {
    ...orientationStyle,
    w: $thumbSize.reference,
    h: $thumbSize.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  };
});
var baseStyleFilledTrack2 = (0, import_styled_system33.defineStyle)((props) => {
  const { colorScheme: c } = props;
  return {
    width: "inherit",
    height: "inherit",
    [$bg12.variable]: `colors.${c}.500`,
    _dark: {
      [$bg12.variable]: `colors.${c}.200`
    },
    bg: $bg12.reference
  };
});
var baseStyle33 = definePartsStyle20((props) => ({
  container: baseStyleContainer4(props),
  track: baseStyleTrack2(props),
  thumb: baseStyleThumb(props),
  filledTrack: baseStyleFilledTrack2(props)
}));
var sizeLg = definePartsStyle20({
  container: {
    [$thumbSize.variable]: `sizes.4`,
    [$trackSize.variable]: `sizes.1`
  }
});
var sizeMd = definePartsStyle20({
  container: {
    [$thumbSize.variable]: `sizes.3.5`,
    [$trackSize.variable]: `sizes.1`
  }
});
var sizeSm = definePartsStyle20({
  container: {
    [$thumbSize.variable]: `sizes.2.5`,
    [$trackSize.variable]: `sizes.0.5`
  }
});
var sizes16 = {
  lg: sizeLg,
  md: sizeMd,
  sm: sizeSm
};
var sliderTheme = defineMultiStyleConfig20({
  baseStyle: baseStyle33,
  sizes: sizes16,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/spinner.ts
var import_styled_system34 = __webpack_require__(77504);
var import_theme_tools12 = __webpack_require__(60723);
var $size4 = (0, import_theme_tools12.cssVar)("spinner-size");
var baseStyle34 = (0, import_styled_system34.defineStyle)({
  width: [$size4.reference],
  height: [$size4.reference]
});
var sizes17 = {
  xs: (0, import_styled_system34.defineStyle)({
    [$size4.variable]: "sizes.3"
  }),
  sm: (0, import_styled_system34.defineStyle)({
    [$size4.variable]: "sizes.4"
  }),
  md: (0, import_styled_system34.defineStyle)({
    [$size4.variable]: "sizes.6"
  }),
  lg: (0, import_styled_system34.defineStyle)({
    [$size4.variable]: "sizes.8"
  }),
  xl: (0, import_styled_system34.defineStyle)({
    [$size4.variable]: "sizes.12"
  })
};
var spinnerTheme = (0, import_styled_system34.defineStyleConfig)({
  baseStyle: baseStyle34,
  sizes: sizes17,
  defaultProps: {
    size: "md"
  }
});

// src/components/stat.ts
var import_anatomy21 = __webpack_require__(34382);
var import_styled_system35 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig21, definePartsStyle: definePartsStyle21 } = (0, import_styled_system35.createMultiStyleConfigHelpers)(import_anatomy21.statAnatomy.keys);
var baseStyleLabel4 = (0, import_styled_system35.defineStyle)({
  fontWeight: "medium"
});
var baseStyleHelpText = (0, import_styled_system35.defineStyle)({
  opacity: 0.8,
  marginBottom: "2"
});
var baseStyleNumber = (0, import_styled_system35.defineStyle)({
  verticalAlign: "baseline",
  fontWeight: "semibold"
});
var baseStyleIcon6 = (0, import_styled_system35.defineStyle)({
  marginEnd: 1,
  w: "3.5",
  h: "3.5",
  verticalAlign: "middle"
});
var baseStyle35 = definePartsStyle21({
  container: {},
  label: baseStyleLabel4,
  helpText: baseStyleHelpText,
  number: baseStyleNumber,
  icon: baseStyleIcon6
});
var sizes18 = {
  md: definePartsStyle21({
    label: { fontSize: "sm" },
    helpText: { fontSize: "sm" },
    number: { fontSize: "2xl" }
  })
};
var statTheme = defineMultiStyleConfig21({
  baseStyle: baseStyle35,
  sizes: sizes18,
  defaultProps: {
    size: "md"
  }
});

// src/components/stepper.ts
var import_styled_system36 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig22, definePartsStyle: definePartsStyle22 } = (0, import_styled_system36.createMultiStyleConfigHelpers)([
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
]);
var $size5 = (0, import_styled_system36.cssVar)("stepper-indicator-size");
var $iconSize = (0, import_styled_system36.cssVar)("stepper-icon-size");
var $titleFontSize = (0, import_styled_system36.cssVar)("stepper-title-font-size");
var $descFontSize = (0, import_styled_system36.cssVar)("stepper-description-font-size");
var $accentColor = (0, import_styled_system36.cssVar)("stepper-accent-color");
var baseStyle36 = definePartsStyle22(({ colorScheme: c }) => ({
  stepper: {
    display: "flex",
    justifyContent: "space-between",
    gap: "4",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
      alignItems: "flex-start"
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center"
    },
    [$accentColor.variable]: `colors.${c}.500`,
    _dark: {
      [$accentColor.variable]: `colors.${c}.200`
    }
  },
  title: {
    fontSize: $titleFontSize.reference,
    fontWeight: "medium"
  },
  description: {
    fontSize: $descFontSize.reference,
    color: "chakra-subtle-text"
  },
  number: {
    fontSize: $titleFontSize.reference
  },
  step: {
    flexShrink: 0,
    position: "relative",
    display: "flex",
    gap: "2",
    "&[data-orientation=horizontal]": {
      alignItems: "center"
    },
    flex: "1",
    "&:last-of-type:not([data-stretch])": {
      flex: "initial"
    }
  },
  icon: {
    flexShrink: 0,
    width: $iconSize.reference,
    height: $iconSize.reference
  },
  indicator: {
    flexShrink: 0,
    borderRadius: "full",
    width: $size5.reference,
    height: $size5.reference,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&[data-status=active]": {
      borderWidth: "2px",
      borderColor: $accentColor.reference
    },
    "&[data-status=complete]": {
      bg: $accentColor.reference,
      color: "chakra-inverse-text"
    },
    "&[data-status=incomplete]": {
      borderWidth: "2px"
    }
  },
  separator: {
    bg: "chakra-border-color",
    flex: "1",
    "&[data-status=complete]": {
      bg: $accentColor.reference
    },
    "&[data-orientation=horizontal]": {
      width: "100%",
      height: "2px",
      marginStart: "2"
    },
    "&[data-orientation=vertical]": {
      width: "2px",
      position: "absolute",
      height: "100%",
      maxHeight: `calc(100% - ${$size5.reference} - 8px)`,
      top: `calc(${$size5.reference} + 4px)`,
      insetStart: `calc(${$size5.reference} / 2 - 1px)`
    }
  }
}));
var stepperTheme = defineMultiStyleConfig22({
  baseStyle: baseStyle36,
  sizes: {
    xs: definePartsStyle22({
      stepper: {
        [$size5.variable]: "sizes.4",
        [$iconSize.variable]: "sizes.3",
        [$titleFontSize.variable]: "fontSizes.xs",
        [$descFontSize.variable]: "fontSizes.xs"
      }
    }),
    sm: definePartsStyle22({
      stepper: {
        [$size5.variable]: "sizes.6",
        [$iconSize.variable]: "sizes.4",
        [$titleFontSize.variable]: "fontSizes.sm",
        [$descFontSize.variable]: "fontSizes.xs"
      }
    }),
    md: definePartsStyle22({
      stepper: {
        [$size5.variable]: "sizes.8",
        [$iconSize.variable]: "sizes.5",
        [$titleFontSize.variable]: "fontSizes.md",
        [$descFontSize.variable]: "fontSizes.sm"
      }
    }),
    lg: definePartsStyle22({
      stepper: {
        [$size5.variable]: "sizes.10",
        [$iconSize.variable]: "sizes.6",
        [$titleFontSize.variable]: "fontSizes.lg",
        [$descFontSize.variable]: "fontSizes.md"
      }
    })
  },
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/switch.ts
var import_anatomy22 = __webpack_require__(34382);
var import_styled_system37 = __webpack_require__(77504);
var import_theme_tools13 = __webpack_require__(60723);
var { defineMultiStyleConfig: defineMultiStyleConfig23, definePartsStyle: definePartsStyle23 } = (0, import_styled_system37.createMultiStyleConfigHelpers)(import_anatomy22.switchAnatomy.keys);
var $width = (0, import_theme_tools13.cssVar)("switch-track-width");
var $height = (0, import_theme_tools13.cssVar)("switch-track-height");
var $diff = (0, import_theme_tools13.cssVar)("switch-track-diff");
var diffValue = import_theme_tools13.calc.subtract($width, $height);
var $translateX = (0, import_theme_tools13.cssVar)("switch-thumb-x");
var $bg13 = (0, import_theme_tools13.cssVar)("switch-bg");
var baseStyleTrack3 = (0, import_styled_system37.defineStyle)((props) => {
  const { colorScheme: c } = props;
  return {
    borderRadius: "full",
    p: "0.5",
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    [$bg13.variable]: "colors.gray.300",
    _dark: {
      [$bg13.variable]: "colors.whiteAlpha.400"
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      [$bg13.variable]: `colors.${c}.500`,
      _dark: {
        [$bg13.variable]: `colors.${c}.200`
      }
    },
    bg: $bg13.reference
  };
});
var baseStyleThumb2 = (0, import_styled_system37.defineStyle)({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [$height.reference],
  height: [$height.reference],
  _checked: {
    transform: `translateX(${$translateX.reference})`
  }
});
var baseStyle37 = definePartsStyle23((props) => ({
  container: {
    [$diff.variable]: diffValue,
    [$translateX.variable]: $diff.reference,
    _rtl: {
      [$translateX.variable]: (0, import_theme_tools13.calc)($diff).negate().toString()
    }
  },
  track: baseStyleTrack3(props),
  thumb: baseStyleThumb2
}));
var sizes19 = {
  sm: definePartsStyle23({
    container: {
      [$width.variable]: "1.375rem",
      [$height.variable]: "sizes.3"
    }
  }),
  md: definePartsStyle23({
    container: {
      [$width.variable]: "1.875rem",
      [$height.variable]: "sizes.4"
    }
  }),
  lg: definePartsStyle23({
    container: {
      [$width.variable]: "2.875rem",
      [$height.variable]: "sizes.6"
    }
  })
};
var switchTheme = defineMultiStyleConfig23({
  baseStyle: baseStyle37,
  sizes: sizes19,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});

// src/components/table.ts
var import_anatomy23 = __webpack_require__(34382);
var import_styled_system38 = __webpack_require__(77504);
var import_theme_tools14 = __webpack_require__(60723);
var { defineMultiStyleConfig: defineMultiStyleConfig24, definePartsStyle: definePartsStyle24 } = (0, import_styled_system38.createMultiStyleConfigHelpers)(import_anatomy23.tableAnatomy.keys);
var baseStyle38 = definePartsStyle24({
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
});
var numericStyles = (0, import_styled_system38.defineStyle)({
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
});
var variantSimple = definePartsStyle24((props) => {
  const { colorScheme: c } = props;
  return {
    th: {
      color: (0, import_theme_tools14.mode)("gray.600", "gray.400")(props),
      borderBottom: "1px",
      borderColor: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props),
      ...numericStyles
    },
    td: {
      borderBottom: "1px",
      borderColor: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props),
      ...numericStyles
    },
    caption: {
      color: (0, import_theme_tools14.mode)("gray.600", "gray.100")(props)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
});
var variantStripe = definePartsStyle24((props) => {
  const { colorScheme: c } = props;
  return {
    th: {
      color: (0, import_theme_tools14.mode)("gray.600", "gray.400")(props),
      borderBottom: "1px",
      borderColor: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props),
      ...numericStyles
    },
    td: {
      borderBottom: "1px",
      borderColor: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props),
      ...numericStyles
    },
    caption: {
      color: (0, import_theme_tools14.mode)("gray.600", "gray.100")(props)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props)
          },
          td: {
            background: (0, import_theme_tools14.mode)(`${c}.100`, `${c}.700`)(props)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
});
var variants9 = {
  simple: variantSimple,
  striped: variantStripe,
  unstyled: (0, import_styled_system38.defineStyle)({})
};
var sizes20 = {
  sm: definePartsStyle24({
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  }),
  md: definePartsStyle24({
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  }),
  lg: definePartsStyle24({
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  })
};
var tableTheme = defineMultiStyleConfig24({
  baseStyle: baseStyle38,
  variants: variants9,
  sizes: sizes20,
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "gray"
  }
});

// src/components/tabs.ts
var import_anatomy24 = __webpack_require__(34382);
var import_styled_system39 = __webpack_require__(77504);
var import_theme_tools15 = __webpack_require__(60723);
var $fg5 = (0, import_styled_system39.cssVar)("tabs-color");
var $bg14 = (0, import_styled_system39.cssVar)("tabs-bg");
var $border4 = (0, import_styled_system39.cssVar)("tabs-border-color");
var { defineMultiStyleConfig: defineMultiStyleConfig25, definePartsStyle: definePartsStyle25 } = (0, import_styled_system39.createMultiStyleConfigHelpers)(import_anatomy24.tabsAnatomy.keys);
var baseStyleRoot2 = (0, import_styled_system39.defineStyle)((props) => {
  const { orientation } = props;
  return {
    display: orientation === "vertical" ? "flex" : "block"
  };
});
var baseStyleTab = (0, import_styled_system39.defineStyle)((props) => {
  const { isFitted } = props;
  return {
    flex: isFitted ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    },
    _disabled: {
      cursor: "not-allowed",
      opacity: 0.4
    }
  };
});
var baseStyleTablist = (0, import_styled_system39.defineStyle)((props) => {
  const { align = "start", orientation } = props;
  const alignments = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: alignments[align],
    flexDirection: orientation === "vertical" ? "column" : "row"
  };
});
var baseStyleTabpanel = (0, import_styled_system39.defineStyle)({
  p: 4
});
var baseStyle39 = definePartsStyle25((props) => ({
  root: baseStyleRoot2(props),
  tab: baseStyleTab(props),
  tablist: baseStyleTablist(props),
  tabpanel: baseStyleTabpanel
}));
var sizes21 = {
  sm: definePartsStyle25({
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  }),
  md: definePartsStyle25({
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }),
  lg: definePartsStyle25({
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  })
};
var variantLine = definePartsStyle25((props) => {
  const { colorScheme: c, orientation } = props;
  const isVertical = orientation === "vertical";
  const borderProp = isVertical ? "borderStart" : "borderBottom";
  const marginProp = isVertical ? "marginStart" : "marginBottom";
  return {
    tablist: {
      [borderProp]: "2px solid",
      borderColor: "inherit"
    },
    tab: {
      [borderProp]: "2px solid",
      borderColor: "transparent",
      [marginProp]: "-2px",
      _selected: {
        [$fg5.variable]: `colors.${c}.600`,
        _dark: {
          [$fg5.variable]: `colors.${c}.300`
        },
        borderColor: "currentColor"
      },
      _active: {
        [$bg14.variable]: "colors.gray.200",
        _dark: {
          [$bg14.variable]: "colors.whiteAlpha.300"
        }
      },
      _disabled: {
        _active: { bg: "none" }
      },
      color: $fg5.reference,
      bg: $bg14.reference
    }
  };
});
var variantEnclosed = definePartsStyle25((props) => {
  const { colorScheme: c } = props;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      [$border4.variable]: "transparent",
      _selected: {
        [$fg5.variable]: `colors.${c}.600`,
        [$border4.variable]: `colors.white`,
        _dark: {
          [$fg5.variable]: `colors.${c}.300`,
          [$border4.variable]: `colors.gray.800`
        },
        borderColor: "inherit",
        borderBottomColor: $border4.reference
      },
      color: $fg5.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantEnclosedColored = definePartsStyle25((props) => {
  const { colorScheme: c } = props;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      [$bg14.variable]: "colors.gray.50",
      _dark: {
        [$bg14.variable]: "colors.whiteAlpha.50"
      },
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        [$bg14.variable]: "colors.white",
        [$fg5.variable]: `colors.${c}.600`,
        _dark: {
          [$bg14.variable]: "colors.gray.800",
          [$fg5.variable]: `colors.${c}.300`
        },
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      },
      color: $fg5.reference,
      bg: $bg14.reference
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
});
var variantSoftRounded = definePartsStyle25((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: (0, import_theme_tools15.getColor)(theme2, `${c}.700`),
        bg: (0, import_theme_tools15.getColor)(theme2, `${c}.100`)
      }
    }
  };
});
var variantSolidRounded = definePartsStyle25((props) => {
  const { colorScheme: c } = props;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      [$fg5.variable]: "colors.gray.600",
      _dark: {
        [$fg5.variable]: "inherit"
      },
      _selected: {
        [$fg5.variable]: "colors.white",
        [$bg14.variable]: `colors.${c}.600`,
        _dark: {
          [$fg5.variable]: "colors.gray.800",
          [$bg14.variable]: `colors.${c}.300`
        }
      },
      color: $fg5.reference,
      bg: $bg14.reference
    }
  };
});
var variantUnstyled3 = definePartsStyle25({});
var variants10 = {
  line: variantLine,
  enclosed: variantEnclosed,
  "enclosed-colored": variantEnclosedColored,
  "soft-rounded": variantSoftRounded,
  "solid-rounded": variantSolidRounded,
  unstyled: variantUnstyled3
};
var tabsTheme = defineMultiStyleConfig25({
  baseStyle: baseStyle39,
  sizes: sizes21,
  variants: variants10,
  defaultProps: {
    size: "md",
    variant: "line",
    colorScheme: "blue"
  }
});

// src/components/tag.ts
var import_anatomy25 = __webpack_require__(34382);
var import_styled_system40 = __webpack_require__(77504);
var { defineMultiStyleConfig: defineMultiStyleConfig26, definePartsStyle: definePartsStyle26 } = (0, import_styled_system40.createMultiStyleConfigHelpers)(import_anatomy25.tagAnatomy.keys);
var $bg15 = (0, import_styled_system40.cssVar)("tag-bg");
var $color = (0, import_styled_system40.cssVar)("tag-color");
var $shadow4 = (0, import_styled_system40.cssVar)("tag-shadow");
var $minH = (0, import_styled_system40.cssVar)("tag-min-height");
var $minW = (0, import_styled_system40.cssVar)("tag-min-width");
var $fontSize = (0, import_styled_system40.cssVar)("tag-font-size");
var $paddingX = (0, import_styled_system40.cssVar)("tag-padding-inline");
var baseStyleContainer5 = (0, import_styled_system40.defineStyle)({
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  [$color.variable]: vars.color.reference,
  [$bg15.variable]: vars.bg.reference,
  [$shadow4.variable]: vars.shadow.reference,
  color: $color.reference,
  bg: $bg15.reference,
  boxShadow: $shadow4.reference,
  borderRadius: "md",
  minH: $minH.reference,
  minW: $minW.reference,
  fontSize: $fontSize.reference,
  px: $paddingX.reference,
  _focusVisible: {
    [$shadow4.variable]: "shadows.outline"
  }
});
var baseStyleLabel5 = (0, import_styled_system40.defineStyle)({
  lineHeight: 1.2,
  overflow: "visible"
});
var baseStyleCloseButton4 = (0, import_styled_system40.defineStyle)({
  fontSize: "lg",
  w: "5",
  h: "5",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "1.5",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focusVisible: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
});
var baseStyle40 = definePartsStyle26({
  container: baseStyleContainer5,
  label: baseStyleLabel5,
  closeButton: baseStyleCloseButton4
});
var sizes22 = {
  sm: definePartsStyle26({
    container: {
      [$minH.variable]: "sizes.5",
      [$minW.variable]: "sizes.5",
      [$fontSize.variable]: "fontSizes.xs",
      [$paddingX.variable]: "space.2"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  }),
  md: definePartsStyle26({
    container: {
      [$minH.variable]: "sizes.6",
      [$minW.variable]: "sizes.6",
      [$fontSize.variable]: "fontSizes.sm",
      [$paddingX.variable]: "space.2"
    }
  }),
  lg: definePartsStyle26({
    container: {
      [$minH.variable]: "sizes.8",
      [$minW.variable]: "sizes.8",
      [$fontSize.variable]: "fontSizes.md",
      [$paddingX.variable]: "space.3"
    }
  })
};
var variants11 = {
  subtle: definePartsStyle26((props) => {
    var _a8;
    return {
      container: (_a8 = badgeTheme.variants) == null ? void 0 : _a8.subtle(props)
    };
  }),
  solid: definePartsStyle26((props) => {
    var _a8;
    return {
      container: (_a8 = badgeTheme.variants) == null ? void 0 : _a8.solid(props)
    };
  }),
  outline: definePartsStyle26((props) => {
    var _a8;
    return {
      container: (_a8 = badgeTheme.variants) == null ? void 0 : _a8.outline(props)
    };
  })
};
var tagTheme = defineMultiStyleConfig26({
  variants: variants11,
  baseStyle: baseStyle40,
  sizes: sizes22,
  defaultProps: {
    size: "md",
    variant: "subtle",
    colorScheme: "gray"
  }
});

// src/components/textarea.ts
var import_styled_system41 = __webpack_require__(77504);
var _a5;
var baseStyle41 = (0, import_styled_system41.defineStyle)({
  ...(_a5 = inputTheme.baseStyle) == null ? void 0 : _a5.field,
  paddingY: "2",
  minHeight: "20",
  lineHeight: "short",
  verticalAlign: "top"
});
var _a6, _b3;
var variants12 = {
  outline: (0, import_styled_system41.defineStyle)(
    (props) => {
      var _a8, _b5;
      return (_b5 = (_a8 = inputTheme.variants) == null ? void 0 : _a8.outline(props).field) != null ? _b5 : {};
    }
  ),
  flushed: (0, import_styled_system41.defineStyle)(
    (props) => {
      var _a8, _b5;
      return (_b5 = (_a8 = inputTheme.variants) == null ? void 0 : _a8.flushed(props).field) != null ? _b5 : {};
    }
  ),
  filled: (0, import_styled_system41.defineStyle)(
    (props) => {
      var _a8, _b5;
      return (_b5 = (_a8 = inputTheme.variants) == null ? void 0 : _a8.filled(props).field) != null ? _b5 : {};
    }
  ),
  unstyled: (_b3 = (_a6 = inputTheme.variants) == null ? void 0 : _a6.unstyled.field) != null ? _b3 : {}
};
var _a7, _b4, _c2, _d2, _e2, _f2, _g2, _h2;
var sizes23 = {
  xs: (_b4 = (_a7 = inputTheme.sizes) == null ? void 0 : _a7.xs.field) != null ? _b4 : {},
  sm: (_d2 = (_c2 = inputTheme.sizes) == null ? void 0 : _c2.sm.field) != null ? _d2 : {},
  md: (_f2 = (_e2 = inputTheme.sizes) == null ? void 0 : _e2.md.field) != null ? _f2 : {},
  lg: (_h2 = (_g2 = inputTheme.sizes) == null ? void 0 : _g2.lg.field) != null ? _h2 : {}
};
var textareaTheme = (0, import_styled_system41.defineStyleConfig)({
  baseStyle: baseStyle41,
  sizes: sizes23,
  variants: variants12,
  defaultProps: {
    size: "md",
    variant: "outline"
  }
});

// src/components/tooltip.ts
var import_styled_system42 = __webpack_require__(77504);
var import_theme_tools16 = __webpack_require__(60723);
var $bg16 = (0, import_theme_tools16.cssVar)("tooltip-bg");
var $fg6 = (0, import_theme_tools16.cssVar)("tooltip-fg");
var $arrowBg2 = (0, import_theme_tools16.cssVar)("popper-arrow-bg");
var baseStyle42 = (0, import_styled_system42.defineStyle)({
  bg: $bg16.reference,
  color: $fg6.reference,
  [$bg16.variable]: "colors.gray.700",
  [$fg6.variable]: "colors.whiteAlpha.900",
  _dark: {
    [$bg16.variable]: "colors.gray.300",
    [$fg6.variable]: "colors.gray.900"
  },
  [$arrowBg2.variable]: $bg16.reference,
  px: "2",
  py: "0.5",
  borderRadius: "sm",
  fontWeight: "medium",
  fontSize: "sm",
  boxShadow: "md",
  maxW: "xs",
  zIndex: "tooltip"
});
var tooltipTheme = (0, import_styled_system42.defineStyleConfig)({
  baseStyle: baseStyle42
});

// src/components/index.ts
var components = {
  Accordion: accordionTheme,
  Alert: alertTheme,
  Avatar: avatarTheme,
  Badge: badgeTheme,
  Breadcrumb: breadcrumbTheme,
  Button: buttonTheme,
  Checkbox: checkboxTheme,
  CloseButton: closeButtonTheme,
  Code: codeTheme,
  Container: containerTheme,
  Divider: dividerTheme,
  Drawer: drawerTheme,
  Editable: editableTheme,
  Form: formTheme,
  FormError: formErrorTheme,
  FormLabel: formLabelTheme,
  Heading: headingTheme,
  Input: inputTheme,
  Kbd: kbdTheme,
  Link: linkTheme,
  List: listTheme,
  Menu: menuTheme,
  Modal: modalTheme,
  NumberInput: numberInputTheme,
  PinInput: pinInputTheme,
  Popover: popoverTheme,
  Progress: progressTheme,
  Radio: radioTheme,
  Select: selectTheme,
  Skeleton: skeletonTheme,
  SkipLink: skipLinkTheme,
  Slider: sliderTheme,
  Spinner: spinnerTheme,
  Stat: statTheme,
  Switch: switchTheme,
  Table: tableTheme,
  Tabs: tabsTheme,
  Tag: tagTheme,
  Textarea: textareaTheme,
  Tooltip: tooltipTheme,
  Card: cardTheme,
  Stepper: stepperTheme
};

// src/foundations/borders.ts
var borders = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
};
var borders_default = borders;

// src/foundations/breakpoints.ts
var breakpoints = {
  base: "0em",
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
};
var breakpoints_default = breakpoints;

// src/foundations/colors.ts
var colors = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
};
var colors_default = colors;

// src/foundations/radius.ts
var radii = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
};
var radius_default = radii;

// src/foundations/shadows.ts
var shadows = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
};
var shadows_default = shadows;

// src/foundations/transition.ts
var transitionProperty = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
};
var transitionTimingFunction = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var transitionDuration = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
};
var transition = {
  property: transitionProperty,
  easing: transitionTimingFunction,
  duration: transitionDuration
};
var transition_default = transition;

// src/foundations/z-index.ts
var zIndices = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
};
var z_index_default = zIndices;

// src/foundations/blur.ts
var blur = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
};
var blur_default = blur;

// src/foundations/index.ts
var foundations = {
  breakpoints: breakpoints_default,
  zIndices: z_index_default,
  radii: radius_default,
  blur: blur_default,
  colors: colors_default,
  ...typography_default,
  sizes: sizes_default,
  shadows: shadows_default,
  space: spacing,
  borders: borders_default,
  transition: transition_default
};

// src/semantic-tokens.ts
var semanticTokens = {
  colors: {
    "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "white", _dark: "gray.800" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
  }
};

// src/styles.ts
var styles = {
  global: {
    body: {
      fontFamily: "body",
      color: "chakra-body-text",
      bg: "chakra-body-bg",
      transitionProperty: "background-color",
      transitionDuration: "normal",
      lineHeight: "base"
    },
    "*::placeholder": {
      color: "chakra-placeholder-color"
    },
    "*, *::before, &::after": {
      borderColor: "chakra-border-color"
    }
  }
};

// src/utils/is-chakra-theme.ts
var import_shared_utils = __webpack_require__(42409);
var requiredChakraThemeKeys = [
  "borders",
  "breakpoints",
  "colors",
  "components",
  "config",
  "direction",
  "fonts",
  "fontSizes",
  "fontWeights",
  "letterSpacings",
  "lineHeights",
  "radii",
  "shadows",
  "sizes",
  "space",
  "styles",
  "transition",
  "zIndices"
];
function isChakraTheme(unit) {
  if (!(0, import_shared_utils.isObject)(unit)) {
    return false;
  }
  return requiredChakraThemeKeys.every(
    (propertyName) => Object.prototype.hasOwnProperty.call(unit, propertyName)
  );
}

// src/index.ts
var direction = "ltr";
var config = {
  useSystemColorMode: false,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
};
var theme = {
  semanticTokens,
  direction,
  ...foundations,
  components,
  styles,
  config
};
var src_default = theme;
var baseTheme = {
  semanticTokens,
  direction,
  components: {},
  ...foundations,
  styles,
  config
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 18171:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PanSession: () => PanSession,
  __DEV__: () => __DEV__,
  __TEST__: () => __TEST__,
  addDomEvent: () => addDomEvent,
  addItem: () => addItem,
  addPointerEvent: () => addPointerEvent,
  analyzeBreakpoints: () => analyzeBreakpoints,
  ariaAttr: () => ariaAttr,
  arrayToObjectNotation: () => arrayToObjectNotation,
  breakpoints: () => breakpoints,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  canUseDOM: () => canUseDOM,
  chunk: () => chunk,
  clampValue: () => clampValue,
  closest: () => closest,
  compose: () => compose,
  contains: () => contains,
  countDecimalPlaces: () => countDecimalPlaces,
  cx: () => cx,
  dataAttr: () => dataAttr,
  detectBrowser: () => detectBrowser,
  detectDeviceType: () => detectDeviceType,
  detectOS: () => detectOS,
  detectTouch: () => detectTouch,
  determineLazyBehavior: () => determineLazyBehavior,
  distance: () => distance,
  error: () => error,
  extractEventInfo: () => extractEventInfo,
  filterUndefined: () => filterUndefined,
  flatten: () => flatten,
  focus: () => focus,
  focusNextTabbable: () => focusNextTabbable,
  focusPreviousTabbable: () => focusPreviousTabbable,
  fromEntries: () => fromEntries,
  get: () => get,
  getActiveElement: () => getActiveElement,
  getAllFocusable: () => getAllFocusable,
  getAllTabbable: () => getAllTabbable,
  getCSSVar: () => getCSSVar,
  getEventWindow: () => getEventWindow,
  getFirstFocusable: () => getFirstFocusable,
  getFirstItem: () => getFirstItem,
  getFirstTabbableIn: () => getFirstTabbableIn,
  getLastItem: () => getLastItem,
  getLastTabbableIn: () => getLastTabbableIn,
  getNextIndex: () => getNextIndex,
  getNextItem: () => getNextItem,
  getNextItemFromSearch: () => getNextItemFromSearch,
  getNextTabbable: () => getNextTabbable,
  getOwnerDocument: () => getOwnerDocument,
  getOwnerWindow: () => getOwnerWindow,
  getPointerEventName: () => getPointerEventName,
  getPrevIndex: () => getPrevIndex,
  getPrevItem: () => getPrevItem,
  getPreviousTabbable: () => getPreviousTabbable,
  getRelatedTarget: () => getRelatedTarget,
  getViewportPointFromEvent: () => getViewportPointFromEvent,
  getWithDefault: () => getWithDefault,
  hasDisplayNone: () => hasDisplayNone,
  hasFocusWithin: () => hasFocusWithin,
  hasNegativeTabIndex: () => hasNegativeTabIndex,
  hasTabIndex: () => hasTabIndex,
  isActiveElement: () => isActiveElement,
  isArray: () => isArray,
  isBrowser: () => isBrowser,
  isContentEditable: () => isContentEditable,
  isCssVar: () => isCssVar,
  isCustomBreakpoint: () => isCustomBreakpoint,
  isDefined: () => isDefined,
  isDisabled: () => isDisabled,
  isElement: () => isElement,
  isEmpty: () => isEmpty,
  isEmptyArray: () => isEmptyArray,
  isEmptyObject: () => isEmptyObject,
  isFocusable: () => isFocusable,
  isFunction: () => isFunction,
  isHTMLElement: () => isHTMLElement,
  isHidden: () => isHidden,
  isInputElement: () => isInputElement,
  isInputEvent: () => isInputEvent,
  isMouseEvent: () => isMouseEvent,
  isMultiTouchEvent: () => isMultiTouchEvent,
  isNotEmptyObject: () => isNotEmptyObject,
  isNotNumber: () => isNotNumber,
  isNull: () => isNull,
  isNumber: () => isNumber,
  isNumeric: () => isNumeric,
  isObject: () => isObject,
  isRefObject: () => isRefObject,
  isResponsiveObjectLike: () => isResponsiveObjectLike,
  isRightClick: () => isRightClick,
  isString: () => isString,
  isTabbable: () => isTabbable,
  isTouchEvent: () => isTouchEvent,
  isUndefined: () => isUndefined,
  mapResponsive: () => mapResponsive,
  maxSafeInteger: () => maxSafeInteger,
  memoize: () => memoize,
  memoizedGet: () => memoizedGet,
  mergeWith: () => import_lodash.default,
  minSafeInteger: () => minSafeInteger,
  noop: () => noop,
  normalizeEventKey: () => normalizeEventKey,
  objectFilter: () => objectFilter,
  objectKeys: () => objectKeys,
  objectToArrayNotation: () => objectToArrayNotation,
  omit: () => omit,
  once: () => once,
  percentToValue: () => percentToValue,
  pick: () => pick,
  pipe: () => pipe,
  px: () => px,
  removeIndex: () => removeIndex,
  removeItem: () => removeItem,
  roundValueToStep: () => roundValueToStep,
  runIfFn: () => runIfFn,
  split: () => split,
  toMediaQueryString: () => toMediaQueryString,
  toPrecision: () => toPrecision,
  valueToPercent: () => valueToPercent,
  walkObject: () => walkObject,
  warn: () => warn,
  wrapPointerEventHandler: () => wrapPointerEventHandler
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(49129), module.exports);

// src/array.ts
function getFirstItem(array) {
  return array != null && array.length ? array[0] : void 0;
}
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function getPrevItem(index, array, loop = true) {
  const prevIndex = getPrevIndex(index, array.length, loop);
  return array[prevIndex];
}
function getNextItem(index, array, loop = true) {
  const nextIndex = getNextIndex(index, array.length, 1, loop);
  return array[nextIndex];
}
function removeIndex(array, index) {
  return array.filter((_, idx) => idx !== index);
}
function addItem(array, item) {
  return [...array, item];
}
function removeItem(array, item) {
  return array.filter((eachItem) => eachItem !== item);
}
function getNextIndex(currentIndex, length, step = 1, loop = true) {
  const lastIndex = length - 1;
  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }
  const nextIndex = currentIndex + step;
  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }
  if (nextIndex >= length) {
    if (loop)
      return 0;
    return currentIndex > length ? length : currentIndex;
  }
  return nextIndex;
}
function getPrevIndex(index, count, loop = true) {
  return getNextIndex(index, count, -1, loop);
}
function chunk(array, size) {
  return array.reduce((rows, currentValue, index) => {
    if (index % size === 0) {
      rows.push([currentValue]);
    } else {
      rows[rows.length - 1].push(currentValue);
    }
    return rows;
  }, []);
}
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }
  if (!currentItem) {
    const foundItem = items.find(
      (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
    );
    return foundItem;
  }
  const matchingItems = items.filter(
    (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
  );
  if (matchingItems.length > 0) {
    let nextIndex;
    if (matchingItems.includes(currentItem)) {
      const currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;
      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }
      return matchingItems[nextIndex];
    }
    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }
  return currentItem;
}

// src/assertion.ts
function isNumber(value) {
  return typeof value === "number";
}
function isNotNumber(value) {
  return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
}
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
function isFunction(value) {
  return typeof value === "function";
}
function isDefined(value) {
  return typeof value !== "undefined" && value !== void 0;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === void 0;
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
}
function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
function isEmpty(value) {
  if (isArray(value))
    return isEmptyArray(value);
  if (isObject(value))
    return isEmptyObject(value);
  if (value == null || value === "")
    return true;
  return false;
}
var __DEV__ = "production" !== "production";
var __TEST__ = "production" === "test";
function isRefObject(val) {
  return "current" in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}

// src/object.ts
var import_lodash = __toESM(__webpack_require__(38554));
function omit(object, keys2) {
  const result = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key))
      return;
    result[key] = object[key];
  });
  return result;
}
function pick(object, keys2) {
  const result = {};
  keys2.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}
function split(object, keys2) {
  const picked = {};
  const omitted = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key)) {
      picked[key] = object[key];
    } else {
      omitted[key] = object[key];
    }
  });
  return [picked, omitted];
}
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
function getWithDefault(path, scale) {
  return memoizedGet(scale, path, path);
}
function objectFilter(object, fn) {
  const result = {};
  Object.keys(object).forEach((key) => {
    const value = object[key];
    const shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);
var objectKeys = (obj) => Object.keys(obj);
var fromEntries = (entries) => entries.reduce((carry, [key, value]) => {
  carry[key] = value;
  return carry;
}, {});
var getCSSVar = (theme, scale, value) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/breakpoint.ts
function analyzeCSSValue(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue(value);
  return unitless || isNumber(value) ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints2) => fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
function normalize(breakpoints2) {
  const sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints2) {
  const value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}
function subtract(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const factor = value.endsWith("px") ? -0.02 : -0.01;
  return isNumber(value) ? `${value + factor}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + factor}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints2) {
  var _a;
  if (!breakpoints2)
    return null;
  breakpoints2.base = (_a = breakpoints2.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints2);
  const queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints2);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/dom.ts
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el)) {
    return false;
  }
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return isElement(node) ? (_b = (_a = getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function getOwnerDocument(node) {
  var _a;
  return isElement(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = /* @__PURE__ */ canUseDOM();
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function getActiveElement(node) {
  const doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  if (!parent)
    return false;
  return parent === child || parent.contains(child);
}
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return () => {
    target.removeEventListener(eventName, handler, options);
  };
}
function normalizeEventKey(event) {
  const { key, keyCode } = event;
  const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  const eventKey = isArrowKey ? `Arrow${key}` : key;
  return eventKey;
}
function getRelatedTarget(event) {
  var _a, _b;
  const target = (_a = event.target) != null ? _a : event.currentTarget;
  const activeElement = getActiveElement(target);
  return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function isRightClick(event) {
  return event.button !== 0;
}

// src/tabbable.ts
var hasDisplayNone = (element) => window.getComputedStyle(element).display === "none";
var hasTabIndex = (element) => element.hasAttribute("tabindex");
var hasNegativeTabIndex = (element) => hasTabIndex(element) && element.tabIndex === -1;
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isInputElement(element) {
  return isHTMLElement(element) && element.localName === "input" && "select" in element;
}
function isActiveElement(element) {
  const doc = isHTMLElement(element) ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function hasFocusWithin(element) {
  if (!document.activeElement)
    return false;
  return element.contains(document.activeElement);
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement))
    return true;
  return element.hidden;
}
function isContentEditable(element) {
  const value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }
  const { localName } = element;
  const focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0)
    return true;
  const others = {
    a: () => element.hasAttribute("href"),
    audio: () => element.hasAttribute("controls"),
    video: () => element.hasAttribute("controls")
  };
  if (localName in others) {
    return others[localName]();
  }
  if (isContentEditable(element))
    return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element)
    return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

// src/dom-query.ts
var focusableElList = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
];
var focusableElSelector = focusableElList.join();
var isVisible = (el) => el.offsetWidth > 0 && el.offsetHeight > 0;
function getAllFocusable(container) {
  const focusableEls = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  focusableEls.unshift(container);
  return focusableEls.filter((el) => isFocusable(el) && isVisible(el));
}
function getFirstFocusable(container) {
  const allFocusable = getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function getAllTabbable(container, fallbackToFocusable) {
  const allFocusable = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  const allTabbable = allFocusable.filter(isTabbable);
  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }
  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }
  return allTabbable;
}
function getFirstTabbableIn(container, fallbackToFocusable) {
  const [first] = getAllTabbable(container, fallbackToFocusable);
  return first || null;
}
function getLastTabbableIn(container, fallbackToFocusable) {
  const allTabbable = getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function getNextTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container);
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function getPreviousTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container).reverse();
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function focusNextTabbable(container, fallbackToFocusable) {
  const nextTabbable = getNextTabbable(container, fallbackToFocusable);
  if (nextTabbable && isHTMLElement(nextTabbable)) {
    nextTabbable.focus();
  }
}
function focusPreviousTabbable(container, fallbackToFocusable) {
  const previousTabbable = getPreviousTabbable(container, fallbackToFocusable);
  if (previousTabbable && isHTMLElement(previousTabbable)) {
    previousTabbable.focus();
  }
}
function matches(element, selectors) {
  if ("matches" in element)
    return element.matches(selectors);
  if ("msMatchesSelector" in element)
    return element.msMatchesSelector(selectors);
  return element.webkitMatchesSelector(selectors);
}
function closest(element, selectors) {
  if ("closest" in element)
    return element.closest(selectors);
  do {
    if (matches(element, selectors))
      return element;
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);
  return null;
}

// src/function.ts
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
var compose = (fn1, ...fns) => fns.reduce(
  (f1, f2) => (...args) => f1(f2(...args)),
  fn1
);
function once(fn) {
  let result;
  return function func(...args) {
    if (fn) {
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}
var noop = () => {
};
var warn = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.warn(message);
  }
});
var error = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.error(message);
  }
});
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
var distance1D = (a, b) => Math.abs(a - b);
var isPoint = (point) => "x" in point && "y" in point;
function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }
  if (isPoint(a) && isPoint(b)) {
    const xDelta = distance1D(a.x, b.x);
    const yDelta = distance1D(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
  }
  return 0;
}

// src/focus.ts
function focus(element, options = {}) {
  const {
    isActive = isActiveElement,
    nextTick,
    preventScroll = true,
    selectTextIfInput = true
  } = options;
  if (!element || isActive(element))
    return -1;
  function triggerFocus() {
    if (!element) {
      warn({
        condition: true,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }
    if (supportsPreventScroll()) {
      element.focus({ preventScroll });
    } else {
      element.focus();
      if (preventScroll) {
        const scrollableElements = getScrollableElements(element);
        restoreScrollPosition(scrollableElements);
      }
    }
    if (selectTextIfInput) {
      if (isInputElement(element)) {
        element.select();
      } else if ("setSelectionRange" in element) {
        const el = element;
        el.setSelectionRange(el.value.length, el.value.length);
      }
    }
  }
  if (nextTick) {
    return requestAnimationFrame(triggerFocus);
  }
  triggerFocus();
  return -1;
}
var supportsPreventScrollCached = null;
function supportsPreventScroll() {
  if (supportsPreventScrollCached == null) {
    supportsPreventScrollCached = false;
    try {
      const div = document.createElement("div");
      div.focus({
        get preventScroll() {
          supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
    }
  }
  return supportsPreventScrollCached;
}
function getScrollableElements(element) {
  var _a;
  const doc = getOwnerDocument(element);
  const win = (_a = doc.defaultView) != null ? _a : window;
  let parent = element.parentNode;
  const scrollableElements = [];
  const rootScrollingElement = doc.scrollingElement || doc.documentElement;
  while (parent instanceof win.HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof win.HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }
  return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
  for (const { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

// src/flatten.ts
function flatten(target, maxDepth = Infinity) {
  if (!isObject(target) && !Array.isArray(target) || !maxDepth) {
    return target;
  }
  return Object.entries(target).reduce((result, [key, value]) => {
    if (isObject(value) || isArray(value)) {
      Object.entries(flatten(value, maxDepth - 1)).forEach(
        ([childKey, childValue]) => {
          result[`${key}.${childKey}`] = childValue;
        }
      );
    } else {
      result[key] = value;
    }
    return result;
  }, {});
}

// src/lazy.ts
function determineLazyBehavior(options) {
  const {
    hasBeenSelected,
    isLazy,
    isSelected,
    lazyBehavior = "unmount"
  } = options;
  if (!isLazy)
    return true;
  if (isSelected)
    return true;
  if (lazyBehavior === "keepMounted" && hasBeenSelected)
    return true;
  return false;
}

// src/number.ts
var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
function toNumber(value) {
  const num = parseFloat(value);
  return isNotNumber(num) ? 0 : num;
}
function toPrecision(value, precision) {
  let nextValue = toNumber(value);
  const scaleFactor = 10 ** (precision != null ? precision : 10);
  nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
  return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function countDecimalPlaces(value) {
  if (!Number.isFinite(value))
    return 0;
  let e = 1;
  let p = 0;
  while (Math.round(value * e) / e !== value) {
    e *= 10;
    p += 1;
  }
  return p;
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function roundValueToStep(value, from, step) {
  const nextValue = Math.round((value - from) / step) * step + from;
  const precision = countDecimalPlaces(step);
  return toPrecision(nextValue, precision);
}
function clampValue(value, min, max) {
  if (value == null)
    return value;
  warn({
    condition: max < min,
    message: "clamp: max cannot be less than min"
  });
  return Math.min(Math.max(value, min), max);
}

// src/pan-event.ts
var import_framesync = __toESM(__webpack_require__(84839));

// src/pointer-event.ts
function isMouseEvent(event) {
  const win = getEventWindow(event);
  if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof win.MouseEvent;
}
function isTouchEvent(event) {
  const hasTouches = !!event.touches;
  return hasTouches;
}
function filterPrimaryPointer(eventHandler) {
  return (event) => {
    const win = getEventWindow(event);
    const isMouseEvent2 = event instanceof win.MouseEvent;
    const isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
  const primaryTouch = e.touches[0] || e.changedTouches[0];
  const point = primaryTouch || defaultPagePoint;
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function pointFromMouse(point, pointType = "page") {
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function extractEventInfo(event, pointType = "page") {
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
function getViewportPointFromEvent(event) {
  return extractEventInfo(event, "client");
}
var wrapPointerEventHandler = (handler, shouldFilterPrimaryPointer = false) => {
  const listener = (event) => handler(event, extractEventInfo(event));
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
var supportsPointerEvents = () => isBrowser && window.onpointerdown === null;
var supportsTouchEvents = () => isBrowser && window.ontouchstart === null;
var supportsMouseEvents = () => isBrowser && window.onmousedown === null;
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  }
  if (supportsTouchEvents()) {
    return touchEventNames[name];
  }
  if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(
    target,
    getPointerEventName(eventName),
    wrapPointerEventHandler(handler, eventName === "pointerdown"),
    options
  );
}
function isMultiTouchEvent(event) {
  return isTouchEvent(event) && event.touches.length > 1;
}

// src/pan-event.ts
var PanSession = class {
  constructor(event, handlers, threshold) {
    __publicField(this, "history", []);
    __publicField(this, "startEvent", null);
    __publicField(this, "lastEvent", null);
    __publicField(this, "lastEventInfo", null);
    __publicField(this, "handlers", {});
    __publicField(this, "removeListeners", noop);
    __publicField(this, "threshold", 3);
    __publicField(this, "win");
    __publicField(this, "updatePoint", () => {
      if (!(this.lastEvent && this.lastEventInfo))
        return;
      const info = getPanInfo(this.lastEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= this.threshold;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { timestamp } = (0, import_framesync.getFrameData)();
      this.history.push({ ...info.point, timestamp });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart == null ? void 0 : onStart(this.lastEvent, info);
        this.startEvent = this.lastEvent;
      }
      onMove == null ? void 0 : onMove(this.lastEvent, info);
    });
    __publicField(this, "onPointerMove", (event, info) => {
      this.lastEvent = event;
      this.lastEventInfo = info;
      if (isMouseEvent(event) && event.buttons === 0) {
        this.onPointerUp(event, info);
        return;
      }
      import_framesync.default.update(this.updatePoint, true);
    });
    __publicField(this, "onPointerUp", (event, info) => {
      const panInfo = getPanInfo(info, this.history);
      const { onEnd, onSessionEnd } = this.handlers;
      onSessionEnd == null ? void 0 : onSessionEnd(event, panInfo);
      this.end();
      if (!onEnd || !this.startEvent)
        return;
      onEnd == null ? void 0 : onEnd(event, panInfo);
    });
    this.win = getEventWindow(event);
    if (isMultiTouchEvent(event))
      return;
    this.handlers = handlers;
    if (threshold) {
      this.threshold = threshold;
    }
    event.stopPropagation();
    event.preventDefault();
    const info = extractEventInfo(event);
    const { timestamp } = (0, import_framesync.getFrameData)();
    this.history = [{ ...info.point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart == null ? void 0 : onSessionStart(event, getPanInfo(info, this.history));
    this.removeListeners = pipe(
      addPointerEvent(this.win, "pointermove", this.onPointerMove),
      addPointerEvent(this.win, "pointerup", this.onPointerUp),
      addPointerEvent(this.win, "pointercancel", this.onPointerUp)
    );
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    var _a;
    (_a = this.removeListeners) == null ? void 0 : _a.call(this);
    import_framesync.cancelSync.update(this.updatePoint);
  }
};
function subtractPoint(a, b) {
  return { x: a.x - b.x, y: a.y - b.y };
}
function startPanPoint(history) {
  return history[0];
}
function lastPanPoint(history) {
  return history[history.length - 1];
}
function getPanInfo(info, history) {
  return {
    point: info.point,
    delta: subtractPoint(info.point, lastPanPoint(history)),
    offset: subtractPoint(info.point, startPanPoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
var toMilliseconds = (seconds) => seconds * 1e3;
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > toMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// src/responsive.ts
var breakpoints = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map((item) => {
      if (item === null) {
        return null;
      }
      return mapper(item);
    });
  }
  if (isObject(prop)) {
    return objectKeys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj, bps = breakpoints) {
  const result = bps.map((br) => {
    var _a;
    return (_a = obj[br]) != null ? _a : null;
  });
  while (getLastItem(result) === null) {
    result.pop();
  }
  return result;
}
function arrayToObjectNotation(values, bps = breakpoints) {
  const result = {};
  values.forEach((value, index) => {
    const key = bps[index];
    if (value == null)
      return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps = breakpoints) {
  const keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every((key) => bps.includes(key));
}
var isCustomBreakpoint = (maybeBreakpoint) => Number.isNaN(Number(maybeBreakpoint));

// src/user-agent.ts
function getUserAgentBrowser(navigator) {
  const { userAgent: ua, vendor } = navigator;
  const android = /(android)/i.test(ua);
  switch (true) {
    case /CriOS/.test(ua):
      return "Chrome for iOS";
    case /Edg\//.test(ua):
      return "Edge";
    case (android && /Silk\//.test(ua)):
      return "Silk";
    case (/Chrome/.test(ua) && /Google Inc/.test(vendor)):
      return "Chrome";
    case /Firefox\/\d+\.\d+$/.test(ua):
      return "Firefox";
    case android:
      return "AOSP";
    case /MSIE|Trident/.test(ua):
      return "IE";
    case (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua)):
      return "Safari";
    case /AppleWebKit/.test(ua):
      return "WebKit";
    default:
      return null;
  }
}
function getUserAgentOS(navigator) {
  const { userAgent: ua, platform } = navigator;
  switch (true) {
    case /Android/.test(ua):
      return "Android";
    case /iPhone|iPad|iPod/.test(platform):
      return "iOS";
    case /Win/.test(platform):
      return "Windows";
    case /Mac/.test(platform):
      return "Mac";
    case /CrOS/.test(ua):
      return "Chrome OS";
    case /Firefox/.test(ua):
      return "Firefox OS";
    default:
      return null;
  }
}
function detectDeviceType(navigator) {
  const { userAgent: ua } = navigator;
  if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua))
    return "tablet";
  if (/(mobi)/i.test(ua))
    return "phone";
  return "desktop";
}
function detectOS(os) {
  if (!isBrowser)
    return false;
  return getUserAgentOS(window.navigator) === os;
}
function detectBrowser(browser) {
  if (!isBrowser)
    return false;
  return getUserAgentBrowser(window.navigator) === browser;
}
function detectTouch() {
  if (!isBrowser)
    return false;
  return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}

// src/walk-object.ts
function walkObject(target, predicate) {
  function inner(value, path = []) {
    if (isArray(value)) {
      return value.map((item, index) => inner(item, [...path, String(index)]));
    }
    if (isObject(value)) {
      return fromEntries(
        Object.entries(value).map(([key, child]) => [
          key,
          inner(child, [...path, key])
        ])
      );
    }
    return predicate(value, path);
  }
  return inner(target);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 8678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40812);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64933);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);



function makePublicApi(stub) {
    var publicApi = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({
        version: "4.34.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return _tools_monitor__WEBPACK_IMPORTED_MODULE_1__/* .setDebugMode */ .yD;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0,_tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map

/***/ }),

/***/ 83206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addEventListener; },
/* harmony export */   "y": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(eventTarget, event, listener, options) {
    return addEventListeners(eventTarget, [event], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(eventTarget, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrappedListener = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'addEventListener');
    events.forEach(function (event) { return add.call(eventTarget, event, wrappedListener, options); });
    function stop() {
        var remove = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'removeEventListener');
        events.forEach(function (event) { return remove.call(eventTarget, event, wrappedListener, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),

/***/ 49647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ COOKIE_ACCESS_DELAY; },
/* harmony export */   "WQ": function() { return /* binding */ getCurrentSite; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "oX": function() { return /* binding */ areCookiesAuthorized; }
/* harmony export */ });
/* unused harmony export deleteCookie */
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);


var COOKIE_ACCESS_DELAY = _tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .WT;
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValue */ .MY)(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, _tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.error */ .j.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, _tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_SECOND */ .WT, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ 18679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ initFetchObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55801);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_timeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82027);
/* harmony import */ var _tools_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54343);





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .Su)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
    var url = (0,_tools_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__/* .normalizeUrl */ .D5)((typeof input === 'object' && input.url) || input);
    var startClocks = (0,_tools_timeUtils__WEBPACK_IMPORTED_MODULE_4__/* .clocksNow */ .$I)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch), (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map

/***/ }),

/***/ 9024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; },
/* harmony export */   "Pd": function() { return /* binding */ createPageExitObservable; },
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64828);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83206);



var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    FROZEN: 'page_frozen',
};
function createPageExitObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var stopListeners = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_1__/* .addEventListeners */ .y)(window, ["visibilitychange" /* VISIBILITY_CHANGE */, "freeze" /* FREEZE */], function (event) {
            if (event.type === "visibilitychange" /* VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        /**
         * Safari does not support yet to send a request during:
         * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
         * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
         */
        var stopBeforeUnloadListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_1__/* .addEventListener */ .O)(window, "beforeunload" /* BEFORE_UNLOAD */, function () {
            observable.notify({ reason: PageExitReason.UNLOADING });
        }).stop;
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
function isPageExitReason(reason) {
    return (0,_tools_utils__WEBPACK_IMPORTED_MODULE_2__/* .includes */ .q9)((0,_tools_utils__WEBPACK_IMPORTED_MODULE_2__/* .objectValues */ .TT)(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map

/***/ }),

/***/ 5343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ initXhrObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55801);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82027);
/* harmony import */ var _tools_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54343);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64828);






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable() {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable();
    }
    return xhrObservable;
}
function createXhrObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var stopInstrumentingStart = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: (0,_tools_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__/* .normalizeUrl */ .D5)(String(url)),
    });
}
function sendXhr(observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = (0,_tools_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .relativeNow */ ._q)();
    startContext.startClocks = (0,_tools_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .clocksNow */ .$I)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_4__/* .monitor */ .zk)(function () {
        _this.removeEventListener('loadend', onEnd);
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0,_tools_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .elapsed */ ._J)(startContext.startClocks.timeStamp, (0,_tools_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .timeStampNow */ .n$)());
        completeContext.status = _this.status;
        observable.notify((0,_tools_utils__WEBPACK_IMPORTED_MODULE_5__/* .shallowClone */ .mv)(completeContext));
    });
    this.addEventListener('loadend', onEnd);
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map

/***/ }),

/***/ 59665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jj": function() { return /* binding */ DefaultPrivacyLevel; },
  "HZ": function() { return /* binding */ buildCookieOptions; },
  "JZ": function() { return /* binding */ serializeConfiguration; },
  "fP": function() { return /* binding */ validateAndBuildConfiguration; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
var catchUserErrors = __webpack_require__(40812);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(60469);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/urlPolyfill.js
var urlPolyfill = __webpack_require__(54343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(11095);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js




var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, retry) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, retry);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = (0,urlPolyfill/* normalizeUrl */.D5)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = (0,urlPolyfill/* normalizeUrl */.D5)(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites/* INTAKE_SITE_US1 */.D_ : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites/* INTAKE_SITE_US1 */.D_) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites/* INTAKE_SITE_US1 */.D_);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== intakeSites/* INTAKE_SITE_AP1 */.G8 ? "".concat(ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, retry) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var tags = ["sdk_version:".concat("4.34.1"), "api:".concat(api)].concat(configurationTags);
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.34.1")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0,utils/* generateUUID */.DO)()),
    ];
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat((0,timeUtils/* timeStampNow */.n$)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display/* display.warn */.j.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0,utils/* objectValues */.TT)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0,utils/* assign */.f0)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites/* INTAKE_SITE_US1 */.D_,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0,utils/* assign */.f0)({}, initConfiguration, {
        site: intakeSites/* INTAKE_SITE_US1 */.D_,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0,utils/* objectValues */.TT)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0,utils/* assign */.f0)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js






var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display/* display.error */.j.error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !(0,utils/* isPercentage */.zz)(sessionSampleRate)) {
        display/* display.error */.j.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0,utils/* isPercentage */.zz)(initConfiguration.telemetrySampleRate)) {
        display/* display.error */.j.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0,utils/* isPercentage */.zz)(initConfiguration.telemetryConfigurationSampleRate)) {
        display/* display.error */.j.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    (0,experimentalFeatures/* updateExperimentalFeatures */.V$)(initConfiguration.enableExperimentalFeatures);
    return (0,utils/* assign */.f0)({
        beforeSend: initConfiguration.beforeSend && (0,catchUserErrors/* catchUserErrors */.Z)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        cookieOptions: buildCookieOptions(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * utils/* ONE_KIBI_BYTE */.Hi,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: 30 * utils/* ONE_SECOND */.WT,
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * utils/* ONE_KIBI_BYTE */.Hi,
    }, computeTransportConfiguration(initConfiguration));
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(initConfiguration);
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0,cookie/* getCurrentSite */.WQ)();
    }
    return cookieOptions;
}
function mustUseSecureCookie(initConfiguration) {
    return !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
}
function serializeConfiguration(configuration) {
    var _a, _b;
    var proxy = (_a = configuration.proxy) !== null && _a !== void 0 ? _a : configuration.proxyUrl;
    return {
        session_sample_rate: (_b = configuration.sessionSampleRate) !== null && _b !== void 0 ? _b : configuration.sampleRate,
        telemetry_sample_rate: configuration.telemetrySampleRate,
        telemetry_configuration_sample_rate: configuration.telemetryConfigurationSampleRate,
        use_before_send: !!configuration.beforeSend,
        use_cross_site_session_cookie: configuration.useCrossSiteSessionCookie,
        use_secure_session_cookie: configuration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: configuration.silentMultipleInit,
        track_session_across_subdomains: configuration.trackSessionAcrossSubdomains,
        track_resources: configuration.trackResources,
        track_long_task: configuration.trackLongTasks,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),

/***/ 60469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V$": function() { return /* binding */ updateExperimentalFeatures; },
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; }
/* harmony export */ });
/* unused harmony export resetExperimentalFeatures */
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 */


var enabledExperimentalFeatures;
function updateExperimentalFeatures(enabledFeatures) {
    // Safely handle external data
    if (!Array.isArray(enabledFeatures)) {
        return;
    }
    if (!enabledExperimentalFeatures) {
        enabledExperimentalFeatures = new Set(enabledFeatures);
    }
    enabledFeatures
        .filter(function (flag) { return typeof flag === 'string'; })
        .forEach(function (flag) {
        if ((0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .includes */ .q9)(flag, '-')) {
            _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.warn */ .j.warn("please use snake case for '".concat(flag, "'"));
        }
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return !!enabledExperimentalFeatures && enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures = new Set();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures || new Set();
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),

/***/ 11095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "G8": function() { return /* binding */ INTAKE_SITE_AP1; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map

/***/ }),

/***/ 86296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ initConsoleObservable; }
/* harmony export */ });
/* harmony import */ var _tracekit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1307);
/* harmony import */ var _tools_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37697);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64828);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13842);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);






var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .mergeObservables.apply */ .$.apply(void 0, consoleObservables);
}
/* eslint-disable no-console */
function createConsoleObservable(api) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var originalConsoleApi = console[api];
        console[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0,_tools_error__WEBPACK_IMPORTED_MODULE_1__/* .createHandlingStack */ .Xp)();
            (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            console[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    if (api === _tools_display__WEBPACK_IMPORTED_MODULE_3__/* .ConsoleApiName.error */ .v.error) {
        var firstErrorParam = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_4__/* .find */ .sE)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0,_tools_error__WEBPACK_IMPORTED_MODULE_1__/* .toStackTraceString */ .P3)((0,_tracekit__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(firstErrorParam)) : undefined;
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return (0,_tools_error__WEBPACK_IMPORTED_MODULE_1__/* .formatErrorMessage */ .jN)((0,_tracekit__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(param));
    }
    return (0,_tools_utils__WEBPACK_IMPORTED_MODULE_4__/* .jsonStringify */ .lh)(param, undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map

/***/ }),

/***/ 6299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ trackRuntimeError; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js
var error = __webpack_require__(37697);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(55801);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(1307);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/tracekit.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'onerror', {
        before: function (message, url, lineNo, columnNo, errorObj) {
            var stack;
            if (errorObj) {
                stack = (0,computeStackTrace/* computeStackTrace */._)(errorObj);
                callback(stack, errorObj);
            }
            else {
                var location_1 = {
                    url: url,
                    column: columnNo,
                    line: lineNo,
                };
                var name_1;
                var msg = message;
                if ({}.toString.call(message) === '[object String]') {
                    var groups = ERROR_TYPES_RE.exec(msg);
                    if (groups) {
                        name_1 = groups[1];
                        msg = groups[2];
                    }
                }
                stack = {
                    name: name_1,
                    message: typeof msg === 'string' ? msg : undefined,
                    stack: [location_1],
                };
                callback(stack, message);
            }
        },
    });
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0,computeStackTrace/* computeStackTrace */._)(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js



function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, originalError) {
        errorObservable.notify((0,error/* computeRawError */.AP)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            nonErrorPrefix: 'Uncaught',
            source: error/* ErrorSource.SOURCE */.zH.SOURCE,
            handling: "unhandled" /* UNHANDLED */,
        }));
    });
}
//# sourceMappingURL=trackRuntimeError.js.map

/***/ }),

/***/ 73670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ RawReportType; },
/* harmony export */   "v": function() { return /* binding */ initReportObservable; }
/* harmony export */ });
/* harmony import */ var _tools_error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37697);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73473);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83206);





var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(apis) {
    var observables = [];
    if ((0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .includes */ .q9)(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable());
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .mergeObservables.apply */ .$.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(function (reports) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        var handleCspViolation = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        });
        var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .addEventListener */ .O)(document, "securitypolicyviolation" /* SECURITY_POLICY_VIOLATION */, handleCspViolation).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .safeTruncate */ ._z)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return (sourceFile &&
        (0,_tools_error__WEBPACK_IMPORTED_MODULE_4__/* .toStackTraceString */ .P3)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber,
                    column: columnNumber,
                },
            ],
        }));
}
//# sourceMappingURL=reportObservable.js.map

/***/ }),

/***/ 78981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "s": function() { return /* binding */ SESSION_EXPIRATION_DELAY; }
/* harmony export */ });
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

var SESSION_TIME_OUT_DELAY = 4 * _tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
var SESSION_EXPIRATION_DELAY = 15 * _tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
//# sourceMappingURL=sessionConstants.js.map

/***/ }),

/***/ 73186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HX": function() { return /* binding */ startSessionManager; }
});

// UNUSED EXPORTS: VISIBILITY_CHECK_DELAY, stopSessionManager

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextHistory.js
var contextHistory = __webpack_require__(73072);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/browserDetection.js
var browserDetection = __webpack_require__(63002);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionCookieStore.js






var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
var SESSION_COOKIE_NAME = '_dd_s';
// arbitrary values
var LOCK_RETRY_DELAY = 10;
var MAX_NUMBER_OF_LOCK_RETRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function withCookieLockAccess(operations, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (numberOfRetries >= MAX_NUMBER_OF_LOCK_RETRIES) {
        next();
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isCookieLockEnabled()) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = utils/* generateUUID */.DO();
        currentSession.lock = currentLock;
        setSession(currentSession, operations.options);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isCookieLockEnabled()) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        persistSession(processedSession, operations.options);
    }
    if (isCookieLockEnabled()) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            setSession(currentSession, operations.options);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date cookie value, the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next();
}
/**
 * Cookie lock strategy allows mitigating issues due to concurrent access to cookie.
 * This issue concerns only chromium browsers and enabling this on firefox increase cookie write failures.
 */
function isCookieLockEnabled() {
    return (0,browserDetection/* isChromium */.m)();
}
function retryLater(operations, currentNumberOfRetries) {
    setTimeout((0,monitor/* monitor */.zk)(function () {
        withCookieLockAccess(operations, currentNumberOfRetries + 1);
    }), LOCK_RETRY_DELAY);
}
function next() {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        withCookieLockAccess(nextOperations);
    }
}
function persistSession(session, options) {
    if (isExpiredState(session)) {
        clearSession(options);
        return;
    }
    session.expire = String((0,timeUtils/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.s);
    setSession(session, options);
}
function setSession(session, options) {
    (0,cookie/* setCookie */.d8)(SESSION_COOKIE_NAME, toSessionString(session), sessionConstants/* SESSION_EXPIRATION_DELAY */.s, options);
}
function toSessionString(session) {
    return utils/* objectEntries */.qP(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function retrieveSession() {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_COOKIE_NAME);
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function isExpiredState(session) {
    return utils/* isEmptyObject */.Qr(session);
}
function clearSession(options) {
    (0,cookie/* setCookie */.d8)(SESSION_COOKIE_NAME, '', 0, options);
}
//# sourceMappingURL=sessionCookieStore.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js


var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(options) {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_COOKIE_NAME);
    var oldSessionId = (0,cookie/* getCookie */.ej)(OLD_SESSION_COOKIE_NAME);
    var oldRumType = (0,cookie/* getCookie */.ej)(OLD_RUM_COOKIE_NAME);
    var oldLogsType = (0,cookie/* getCookie */.ej)(OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        persistSession(session, options);
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(73473);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js







/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(options, productKey, computeSessionState) {
    var renewObservable = new observable/* Observable */.y();
    var expireObservable = new observable/* Observable */.y();
    var watchSessionTimeoutId = setInterval((0,monitor/* monitor */.zk)(watchSession), cookie/* COOKIE_ACCESS_DELAY */.MI);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) {
                var synchronizedSession = synchronizeSession(cookieSession);
                isTracked = expandOrRenewCookie(synchronizedSession);
                return synchronizedSession;
            },
            after: function (cookieSession) {
                if (isTracked && !hasSessionInCache()) {
                    renewSession(cookieSession);
                }
                sessionCache = cookieSession;
            },
        });
    }
    function expandSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (hasSessionInCache() ? synchronizeSession(cookieSession) : undefined); },
        });
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session cookie
     * - if the session is not active, clear the session cookie and expire the session cache
     */
    function watchSession() {
        withCookieLockAccess({
            options: options,
            process: function (cookieSession) { return (!isActiveSession(cookieSession) ? {} : undefined); },
            after: synchronizeSession,
        });
    }
    function synchronizeSession(cookieSession) {
        if (!isActiveSession(cookieSession)) {
            cookieSession = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(cookieSession)) {
                expireSession();
            }
            else {
                sessionCache = cookieSession;
            }
        }
        return cookieSession;
    }
    function expandOrRenewCookie(cookieSession) {
        var _a = computeSessionState(cookieSession[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        cookieSession[productKey] = trackingType;
        if (isTracked && !cookieSession.id) {
            cookieSession.id = utils/* generateUUID */.DO();
            cookieSession.created = String((0,timeUtils/* dateNow */.m6)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(cookieSession) {
        return sessionCache.id !== cookieSession.id || sessionCache[productKey] !== cookieSession[productKey];
    }
    function expireSession() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSession(cookieSession) {
        sessionCache = cookieSession;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(session) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((session.created === undefined || (0,timeUtils/* dateNow */.m6)() - Number(session.created) < sessionConstants/* SESSION_TIME_OUT_DELAY */.T) &&
            (session.expire === undefined || (0,timeUtils/* dateNow */.m6)() < Number(session.expire)));
    }
    return {
        expandOrRenewSession: utils/* throttle */.P2((0,monitor/* monitor */.zk)(expandOrRenewSession), cookie/* COOKIE_ACCESS_DELAY */.MI).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        stop: function () {
            clearInterval(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js








var VISIBILITY_CHECK_DELAY = utils/* ONE_MINUTE */.yR;
var SESSION_CONTEXT_TIMEOUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
var stopCallbacks = [];
function startSessionManager(options, productKey, computeSessionState) {
    tryOldCookiesMigration(options);
    var sessionStore = startSessionStore(options, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new contextHistory/* ContextHistory */.W(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0,timeUtils/* relativeNow */._q)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0,timeUtils/* relativeNow */._q)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0,timeUtils/* clocksOrigin */.cQ)().relative);
    trackActivity(function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
    var stop = (0,addEventListener/* addEventListeners */.y)(window, ["click" /* CLICK */, "touchstart" /* TOUCH_START */, "keydown" /* KEY_DOWN */, "scroll" /* SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = (0,monitor/* monitor */.zk)(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = (0,addEventListener/* addEventListener */.O)(document, "visibilitychange" /* VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map

/***/ }),

/***/ 99262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ getSyntheticsTestId; },
/* harmony export */   "QB": function() { return /* binding */ getSyntheticsResultId; },
/* harmony export */   "Y9": function() { return /* binding */ willSyntheticsInjectRum; }
/* harmony export */ });
/* unused harmony exports SYNTHETICS_TEST_ID_COOKIE_NAME, SYNTHETICS_RESULT_ID_COOKIE_NAME, SYNTHETICS_INJECTS_RUM_COOKIE_NAME */
/* harmony import */ var _browser_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49647);

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map

/***/ }),

/***/ 18797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "VG": function() { return /* binding */ isTelemetryReplicationAllowed; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, resetTelemetry, scrubCustomerFrames, startFakeTelemetry

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js
var error = __webpack_require__(37697);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(11095);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(60469);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(1307);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js










var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new tools_observable/* Observable */.y();
    telemetryConfiguration.telemetryEnabled =
        !(0,utils/* includes */.q9)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0,utils/* performDraw */.y7)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0,utils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate);
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent);
            observable.notify(event_1);
            (0,sendToExtension/* sendToExtension */.j)('telemetry', event_1);
        }
    };
    (0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
    (0,utils/* assign */.f0)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event) {
        return (0,utils/* combine */.$e)({
            type: 'telemetry',
            date: (0,timeUtils/* timeStampNow */.n$)(),
            service: telemetryService,
            version: "4.34.1",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: event,
            experimental_features: (0,utils/* arrayFrom */.Oc)((0,experimentalFeatures/* getExperimentalFeatures */.u0)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
    (0,monitor/* displayIfDebugEnabled */.DV)(display/* ConsoleApiName.debug */.v.debug, message, context);
    addTelemetry((0,utils/* assign */.f0)({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* debug */,
    }, context));
}
function addTelemetryError(e) {
    addTelemetry((0,utils/* assign */.f0)({
        type: TelemetryType.log,
        status: "error" /* error */,
    }, formatError(e)));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0,error/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught ".concat((0,utils/* jsonStringify */.lh)(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0,utils/* startsWith */.Ny)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),

/***/ 1307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; }
/* harmony export */ });
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .startsWith */ .Ny)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),

/***/ 54910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ sanitizeUser; },
/* harmony export */   "z": function() { return /* binding */ checkUser; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);


/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(newUser) === 'object';
    if (!isValid) {
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.error */ .j.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map

/***/ }),

/***/ 68783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BoundedBuffer; }
/* harmony export */ });
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map

/***/ }),

/***/ 63002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ isChromium; },
/* harmony export */   "w": function() { return /* binding */ isIE; }
/* harmony export */ });
function isIE() {
    return Boolean(document.documentMode);
}
function isChromium() {
    return !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent);
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),

/***/ 40812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .j.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),

/***/ 73072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ ContextHistory; }
/* harmony export */ });
/* unused harmony export CLEAR_OLD_CONTEXTS_INTERVAL */
/* harmony import */ var _timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82027);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);


var END_OF_TIMES = Infinity;
var CLEAR_OLD_CONTEXTS_INTERVAL = _utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
/**
 * Store and keep track of contexts spans. This whole class assumes that contexts are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ContextHistory = /** @class */ (function () {
    function ContextHistory(expireDelay) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.entries = [];
        this.clearOldContextsInterval = setInterval(function () { return _this.clearOldContexts(); }, CLEAR_OLD_CONTEXTS_INTERVAL);
    }
    /**
     * Add a context to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ContextHistory.prototype.add = function (context, startTime) {
        var _this = this;
        var entry = {
            context: context,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest context that was active during `startTime`, or the currently active context
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ContextHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.context;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active context, if any. This method assumes that entries
     * are not overlapping.
     */
    ContextHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all contexts that were active during `startTime`, or all currently active contexts if no
     * `startTime` is provided.
     */
    ContextHistory.prototype.findAll = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        return this.entries
            .filter(function (entry) { return entry.startTime <= startTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.context; });
    };
    /**
     * Remove all entries from this collection.
     */
    ContextHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ContextHistory.prototype.stop = function () {
        clearInterval(this.clearOldContextsInterval);
    };
    ContextHistory.prototype.clearOldContexts = function () {
        var oldTimeThreshold = (0,_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .relativeNow */ ._q)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ContextHistory;
}());

//# sourceMappingURL=contextHistory.js.map

/***/ }),

/***/ 26839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ createContextManager; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

function createContextManager(computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = _utils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt; }
    var context = {};
    var bytesCountCache;
    return {
        getBytesCount: function () {
            if (bytesCountCache === undefined) {
                bytesCountCache = computeBytesCountImpl((0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .lh)(context));
            }
            return bytesCountCache;
        },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            bytesCountCache = undefined;
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            bytesCountCache = undefined;
        },
        getContext: function () { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(context); },
        setContext: function (newContext) {
            context = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(newContext);
            bytesCountCache = undefined;
        },
        setContextProperty: function (key, property) {
            context[key] = (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .deepClone */ .I8)(property);
            bytesCountCache = undefined;
        },
        removeContextProperty: function (key) {
            delete context[key];
            bytesCountCache = undefined;
        },
        clearContext: function () {
            context = {};
            bytesCountCache = undefined;
        },
    };
}
//# sourceMappingURL=contextManager.js.map

/***/ }),

/***/ 28393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ createEventRateLimiter; }
/* harmony export */ });
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37697);
/* harmony import */ var _timeUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82027);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                setTimeout(function () {
                    eventCount = 0;
                }, _utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorSource.AGENT */ .zH.AGENT,
                        startClocks: (0,_timeUtils__WEBPACK_IMPORTED_MODULE_2__/* .clocksNow */ .$I)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map

/***/ }),

/***/ 13842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ display; },
/* harmony export */   "v": function() { return /* binding */ ConsoleApiName; }
/* harmony export */ });
/* eslint-disable no-console, local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
var display = function (api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!Object.prototype.hasOwnProperty.call(ConsoleApiName, api)) {
        api = ConsoleApiName.log;
    }
    display[api].apply(display, args);
};
display.debug = console.debug.bind(console);
display.log = console.log.bind(console);
display.info = console.info.bind(console);
display.warn = console.warn.bind(console);
display.error = console.error.bind(console);
//# sourceMappingURL=display.js.map

/***/ }),

/***/ 37697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ computeRawError; },
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "u5": function() { return /* binding */ getFileFromStackTraceString; },
/* harmony export */   "zH": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
/* unused harmony export flattenErrorCauses */
/* harmony import */ var _domain_tracekit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1307);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64933);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);



var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    if (!stackTrace || (stackTrace.message === undefined && !(originalError instanceof Error))) {
        return {
            startClocks: startClocks,
            source: source,
            handling: handling,
            originalError: originalError,
            message: "".concat(nonErrorPrefix, " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .lh)(originalError)),
            stack: 'No stack, consider using an instance of Error',
            handlingStack: handlingStack,
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        originalError: originalError,
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        handlingStack: handlingStack,
        type: stackTrace.name,
        causes: flattenErrorCauses(originalError, source),
    };
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .ZT)();
        }
    }
    (0,_monitor__WEBPACK_IMPORTED_MODULE_1__/* .callMonitored */ .L6)(function () {
        var stackTrace = (0,_domain_tracekit__WEBPACK_IMPORTED_MODULE_2__/* .computeStackTrace */ ._)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0,_domain_tracekit__WEBPACK_IMPORTED_MODULE_2__/* .computeStackTrace */ ._)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 59693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = window;
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),

/***/ 55801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ instrumentMethodAndCallOriginal; },
/* harmony export */   "Su": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "Xk": function() { return /* binding */ instrumentSetter; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64828);


function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: _utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        setTimeout((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function () {
            after(thisObject, value);
        }), 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = _utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),

/***/ 64933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ displayIfDebugEnabled; },
/* harmony export */   "L6": function() { return /* binding */ callMonitored; },
/* harmony export */   "P_": function() { return /* binding */ startMonitorErrorCollection; },
/* harmony export */   "Th": function() { return /* binding */ monitored; },
/* harmony export */   "yD": function() { return /* binding */ setDebugMode; },
/* harmony export */   "zk": function() { return /* binding */ monitor; }
/* harmony export */ });
/* unused harmony export resetMonitor */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13842);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(_display__WEBPACK_IMPORTED_MODULE_0__/* .ConsoleApiName.error */ .v.error, e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(_display__WEBPACK_IMPORTED_MODULE_0__/* .ConsoleApiName.error */ .v.error, e);
            }
        }
    }
}
function displayIfDebugEnabled(api) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (debugMode) {
        _display__WEBPACK_IMPORTED_MODULE_0__/* .display.apply */ .j.apply(void 0, __spreadArray([api, '[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),

/***/ 73473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ mergeObservables; },
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 18057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ readBytesFromStream; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64828);


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        _utils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map

/***/ }),

/***/ 38971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),

/***/ 82027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "Cn": function() { return /* binding */ looksLikeRelativeTime; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "QA": function() { return /* binding */ currentDrift; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "c0": function() { return /* binding */ toServerDuration; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "ni": function() { return /* binding */ getRelativeTime; }
/* harmony export */ });
/* unused harmony exports getTimeStamp, resetNavigationStart */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!(0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(duration)) {
        return duration;
    }
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < _utils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_YEAR */ .P5;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),

/***/ 54343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "P$": function() { return /* binding */ getOrigin; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* unused harmony exports haveSameOrigin, getSearch, getHash */
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

function normalizeUrl(url) {
    return buildUrl(url, (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getLocationOrigin */ .Dp)()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .getLinkElementOrigin */ .j1)(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),

/***/ 64828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Ap": function() { return /* binding */ elementMatches; },
/* harmony export */   "DO": function() { return /* binding */ generateUUID; },
/* harmony export */   "Dp": function() { return /* binding */ getLocationOrigin; },
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "I8": function() { return /* binding */ deepClone; },
/* harmony export */   "Kk": function() { return /* binding */ requestIdleCallback; },
/* harmony export */   "MY": function() { return /* binding */ findCommaSeparatedValue; },
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "Ny": function() { return /* binding */ startsWith; },
/* harmony export */   "Oc": function() { return /* binding */ arrayFrom; },
/* harmony export */   "P2": function() { return /* binding */ throttle; },
/* harmony export */   "P5": function() { return /* binding */ ONE_YEAR; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "QA": function() { return /* binding */ cssEscape; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "R1": function() { return /* binding */ removeDuplicates; },
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_z": function() { return /* binding */ safeTruncate; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "f0": function() { return /* binding */ assign; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "j1": function() { return /* binding */ getLinkElementOrigin; },
/* harmony export */   "lh": function() { return /* binding */ jsonStringify; },
/* harmony export */   "mv": function() { return /* binding */ shallowClone; },
/* harmony export */   "o": function() { return /* binding */ isMatchOption; },
/* harmony export */   "oL": function() { return /* binding */ getType; },
/* harmony export */   "pn": function() { return /* binding */ endsWith; },
/* harmony export */   "q9": function() { return /* binding */ includes; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; },
/* harmony export */   "sE": function() { return /* binding */ find; },
/* harmony export */   "ul": function() { return /* binding */ tryToClone; },
/* harmony export */   "v4": function() { return /* binding */ matchList; },
/* harmony export */   "y7": function() { return /* binding */ performDraw; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, mergeInto */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13842);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64933);


var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = setTimeout(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
function shallowClone(object) {
    return assign({}, object);
}
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return noop;
}
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = getType(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function requestIdleCallback(callback, opts) {
    // Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
    // browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
    // fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
    // browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes
    // efficiently.
    if (window.requestIdleCallback) {
        var id_1 = window.requestIdleCallback((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return arrayFrom(set);
}
function isMatchOption(item) {
    var itemType = getType(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? startsWith(value, item) : item === value;
            }
        }
        catch (e) {
            _display__WEBPACK_IMPORTED_MODULE_1__/* .display.error */ .j.error(e);
        }
        return false;
    });
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 53789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Batch; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13842);
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64828);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64933);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73473);




var Batch = /** @class */ (function () {
    function Batch(request, batchMessagesLimit, batchBytesLimit, messageBytesLimit, flushTimeout, pageExitObservable) {
        var _this = this;
        this.request = request;
        this.batchMessagesLimit = batchMessagesLimit;
        this.batchBytesLimit = batchBytesLimit;
        this.messageBytesLimit = messageBytesLimit;
        this.flushTimeout = flushTimeout;
        this.pageExitObservable = pageExitObservable;
        this.flushObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y();
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesCount = 0;
        this.bufferMessagesCount = 0;
        pageExitObservable.subscribe(function () { return _this.flush(_this.request.sendOnExit); });
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function (sendFn) {
        if (sendFn === void 0) { sendFn = this.request.send; }
        if (this.bufferMessagesCount !== 0) {
            var messages = this.pushOnlyBuffer.concat((0,_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* .objectValues */ .TT)(this.upsertBuffer));
            var bytesCount = this.bufferBytesCount;
            this.flushObservable.notify({
                bufferBytesCount: this.bufferBytesCount,
                bufferMessagesCount: this.bufferMessagesCount,
            });
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesCount = 0;
            this.bufferMessagesCount = 0;
            sendFn({ data: messages.join('\n'), bytesCount: bytesCount });
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .j.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesCount)) {
            this.flush();
        }
        this.push(processedMessage, messageBytesCount, key);
        if (this.isFull()) {
            this.flush();
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* .jsonStringify */ .lh)(message);
        var messageBytesCount = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* .computeBytesCount */ .qt)(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        if (this.bufferMessagesCount > 0) {
            // \n separator at serialization
            this.bufferBytesCount += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesCount += messageBytesCount;
        this.bufferMessagesCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_1__/* .computeBytesCount */ .qt)(removedMessage);
        this.bufferBytesCount -= messageBytesCount;
        this.bufferMessagesCount -= 1;
        if (this.bufferMessagesCount > 0) {
            this.bufferBytesCount -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesCount) {
        // byte of the separator at the end of the message
        return this.bufferBytesCount + messageBytesCount + 1 >= this.batchBytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessagesCount === this.batchMessagesLimit || this.bufferBytesCount >= this.batchBytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout((0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .monitor */ .zk)(function () {
            _this.flush();
            _this.flushPeriodically();
        }), this.flushTimeout);
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map

/***/ }),

/***/ 76876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getEventBridge; },
/* harmony export */   "x": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* harmony import */ var _tools_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64828);

function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .endsWith */ .pn)(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return (0,_tools_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),

/***/ 30481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchKeepAliveStrategy, sendXHR

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js
var error = __webpack_require__(37697);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js




var MAX_ONGOING_BYTES_COUNT = 80 * utils/* ONE_KIBI_BYTE */.Hi;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * utils/* ONE_MEBI_BYTE */.X9;
var MAX_BACKOFF_TIME = utils/* ONE_MINUTE */.yR;
var INITIAL_BACKOFF_TIME = utils/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* DOWN */) {
        return;
    }
    setTimeout((0,monitor/* monitor */.zk)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }), state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* FAILURE_DETECTED */ : 2 /* DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / utils/* ONE_MEBI_BYTE */.X9, "MiB"),
            source: error/* ErrorSource.AGENT */.zH.AGENT,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            response.status >= 500));
}
function newRetryState() {
    return {
        transportStatus: 0 /* UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js



function createHttpRequest(endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, _a) {
    var data = _a.data, bytesCount = _a.bytesCount;
    var canUseBeacon = !!navigator.sendBeacon && bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon');
            var isQueued = navigator.sendBeacon(beaconUrl, data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr');
    sendXHR(xhrUrl, data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0,telemetry/* addTelemetryError */.Sz)(e);
    }
}
function fetchKeepAliveStrategy(endpointBuilder, bytesLimit, _a, onResponse) {
    var data = _a.data, bytesCount = _a.bytesCount, retry = _a.retry;
    var canUseKeepAlive = isKeepAliveSupported() && bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', retry);
        fetch(fetchUrl, { method: 'POST', body: data, keepalive: true, mode: 'cors' }).then((0,monitor/* monitor */.zk)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0,monitor/* monitor */.zk)(function () {
            var xhrUrl = endpointBuilder.build('xhr', retry);
            // failed to queue the request
            sendXHR(xhrUrl, data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', retry);
        sendXHR(xhrUrl, data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(url, data, onResponse) {
    var request = new XMLHttpRequest();
    var onLoadEnd = (0,monitor/* monitor */.zk)(function () {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        request.removeEventListener('loadend', onLoadEnd);
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    });
    request.open('POST', url, true);
    request.addEventListener('loadend', onLoadEnd);
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),

/***/ 27571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fy": function() { return /* binding */ datadogLogs; }
});

// UNUSED EXPORTS: HandlerType, Logger, StatusType

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextManager.js
var contextManager = __webpack_require__(26839);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(68783);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(54910);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(73670);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * utils/* ONE_KIBI_BYTE */.Hi;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0,utils/* objectValues */.TT)(display/* ConsoleApiName */.v), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0,utils/* objectValues */.TT)(reportObservable/* RawReportType */._), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0,utils/* includes */.q9)(forwardConsoleLogs, display/* ConsoleApiName.error */.v.error)) {
        forwardConsoleLogs.push(display/* ConsoleApiName.error */.v.error);
    }
    return (0,utils/* assign */.f0)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0,utils/* includes */.q9)(allowedValues, api); })))) {
        display/* display.error */.j.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : (0,utils/* removeDuplicates */.R1)(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,utils/* assign */.f0)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js
var tools_error = __webpack_require__(37697);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0,contextManager/* createContextManager */.W)();
        this.contextManager.set((0,utils/* assign */.f0)({}, loggerContext, name ? { logger: { name: name } } : undefined));
    }
    Logger.prototype.log = function (message, messageContext, status) {
        if (status === void 0) { status = StatusType.info; }
        this.handleLogStrategy({ message: message, context: (0,utils/* deepClone */.I8)(messageContext), status: status }, this);
    };
    Logger.prototype.debug = function (message, messageContext) {
        this.log(message, messageContext, StatusType.debug);
    };
    Logger.prototype.info = function (message, messageContext) {
        this.log(message, messageContext, StatusType.info);
    };
    Logger.prototype.warn = function (message, messageContext) {
        this.log(message, messageContext, StatusType.warn);
    };
    Logger.prototype.error = function (message, messageContext) {
        var errorOrigin = {
            error: {
                origin: tools_error/* ErrorSource.LOGGER */.zH.LOGGER,
            },
        };
        this.log(message, (0,utils/* combine */.$e)(errorOrigin, messageContext), StatusType.error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.set(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.get();
    };
    Logger.prototype.addContext = function (key, value) {
        this.contextManager.add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.contextManager.remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitor/* monitored */.Th
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js



function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)();
    var userContextManager = (0,contextManager/* createContextManager */.W)();
    var customLoggers = {};
    var getInternalContextStrategy = function () { return undefined; };
    var beforeInitLoggerLog = new boundedBuffer/* BoundedBuffer */.S();
    var handleLogStrategy = function (logsMessage, logger, savedCommonContext, date) {
        if (savedCommonContext === void 0) { savedCommonContext = (0,utils/* deepClone */.I8)(buildCommonContext()); }
        if (date === void 0) { date = (0,timeUtils/* timeStampNow */.n$)(); }
        beforeInitLoggerLog.add(function () { return handleLogStrategy(logsMessage, logger, savedCommonContext, date); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return handleLogStrategy.apply(void 0, params);
    });
    function buildCommonContext() {
        return {
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
            context: globalContextManager.getContext(),
            user: userContextManager.getContext(),
        };
    }
    return (0,init/* makePublicApi */.r)({
        logger: mainLogger,
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) {
            var _a;
            // This function should be available, regardless of initialization success.
            getInitConfigurationStrategy = function () { return (0,utils/* deepClone */.I8)(initConfiguration); };
            if ((0,eventBridge/* canUseEventBridge */.x)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            ;
            (_a = startLogsImpl(initConfiguration, configuration, buildCommonContext, mainLogger), handleLogStrategy = _a.handleLog, getInternalContextStrategy = _a.getInternalContext);
            beforeInitLoggerLog.drain();
            isAlreadyInitialized = true;
        }),
        /** @deprecated: use getGlobalContext instead */
        getLoggerGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.get),
        getGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setLoggerGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.set),
        setGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.setContext),
        /** @deprecated: use setGlobalContextProperty instead */
        addLoggerGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.add),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeLoggerGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.remove),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(globalContextManager.removeContextProperty),
        clearGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.clearContext),
        createLogger: (0,monitor/* monitor */.zk)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return handleLogStrategy.apply(void 0, params);
            }, name, conf.handler, conf.level, conf.context);
            return customLoggers[name];
        }),
        getLogger: (0,monitor/* monitor */.zk)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(userContextManager.getContext),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(userContextManager.removeContextProperty),
        clearUser: (0,monitor/* monitor */.zk)(userContextManager.clearContext),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,utils/* assign */.f0)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.j.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=logsPublicApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(99262);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js
var batch = __webpack_require__(53789);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var httpRequest = __webpack_require__(30481);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js


function startBatchWithReplica(configuration, endpoint, reportError, pageExitObservable, replicaEndpoint) {
    var primaryBatch = createBatch(endpoint);
    var replicaBatch;
    if (replicaEndpoint) {
        replicaBatch = createBatch(replicaEndpoint);
    }
    function createBatch(endpointBuilder) {
        return new batch/* Batch */.E((0,httpRequest/* createHttpRequest */.UF)(endpointBuilder, configuration.batchBytesLimit, reportError), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, pageExitObservable);
    }
    return {
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(message);
            }
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js + 3 modules
var session_sessionManager = __webpack_require__(73186);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration.cookieOptions, LOGS_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
    };
}
function computeTrackingType(configuration) {
    if (!(0,utils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* NOT_TRACKED */;
    }
    return "1" /* TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* NOT_TRACKED */ || trackingType === "1" /* TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(28393);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsCollection/logger/loggerCollection.js
var _a;


var STATUS_PRIORITIES = (_a = {},
    _a[StatusType.debug] = 0,
    _a[StatusType.info] = 1,
    _a[StatusType.warn] = 2,
    _a[StatusType.error] = 3,
    _a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = logsMessage.context;
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            (0,display/* display */.j)(logsMessage.status, logsMessage.message, (0,utils/* combine */.$e)(logger.getContext(), messageContext));
        }
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: savedDate || (0,timeUtils/* timeStampNow */.n$)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: tools_error/* ErrorSource.LOGGER */.zH.LOGGER,
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext,
            logger: logger,
        });
    }
    return {
        handleLog: handleLog,
    };
}
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && (0,utils/* includes */.q9)(sanitizedHandlerType, handlerType));
}
//# sourceMappingURL=loggerCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/assembly.js



function startLogsAssembly(sessionManager, configuration, lifeCycle, buildCommonContext, mainLogger, // Todo: [RUMF-1230] Remove this parameter in the next major release
reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0,createEventRateLimiter/* createEventRateLimiter */.K)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c, _d;
        var rawLogsEvent = _a.rawLogsEvent, _e = _a.messageContext, messageContext = _e === void 0 ? undefined : _e, _f = _a.savedCommonContext, savedCommonContext = _f === void 0 ? undefined : _f, _g = _a.logger, logger = _g === void 0 ? mainLogger : _g;
        var startTime = (0,timeUtils/* getRelativeTime */.ni)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || buildCommonContext();
        var log = (0,utils/* combine */.$e)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0,utils/* isEmptyObject */.Qr)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, logger.getContext(), messageContext);
        if (
        // Todo: [RUMF-1230] Move this check to the logger collection in the next major release
        !isAuthorized(rawLogsEvent.status, HandlerType.http, logger) ||
            ((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (((_c = log.error) === null || _c === void 0 ? void 0 : _c.origin) !== tools_error/* ErrorSource.AGENT */.zH.AGENT &&
                ((_d = logRateLimiters[log.status]) !== null && _d !== void 0 ? _d : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LOG_COLLECTED */, log);
    });
}
var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)(),
                resultId: (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=assembly.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(86296);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsCollection/console/consoleCollection.js
var consoleCollection_a;


var LogStatusForApi = (consoleCollection_a = {},
    consoleCollection_a[display/* ConsoleApiName.log */.v.log] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.debug */.v.debug] = StatusType.debug,
    consoleCollection_a[display/* ConsoleApiName.info */.v.info] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.warn */.v.warn] = StatusType.warn,
    consoleCollection_a[display/* ConsoleApiName.error */.v.error] = StatusType.error,
    consoleCollection_a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0,consoleObservable/* initConsoleObservable */.a)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: log.message,
                origin: tools_error/* ErrorSource.CONSOLE */.zH.CONSOLE,
                error: log.api === display/* ConsoleApiName.error */.v.error
                    ? {
                        origin: tools_error/* ErrorSource.CONSOLE */.zH.CONSOLE,
                        stack: log.stack,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsCollection/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[reportObservable/* RawReportType.cspViolation */._.cspViolation] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.intervention */._.intervention] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.deprecation */._.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0,reportObservable/* initReportObservable */.v)(configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                origin: tools_error/* ErrorSource.REPORT */.zH.REPORT,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0,tools_error/* getFileFromStackTraceString */.u5)(report.stack));
        }
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: message,
                origin: tools_error/* ErrorSource.REPORT */.zH.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(5343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(18679);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(1307);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(18057);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsCollection/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: utils/* noop */.ZT };
    }
    var xhrSubscription = (0,xhrObservable/* initXhrObservable */.S)().subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* XHR */, context);
        }
    });
    var fetchSubscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || isServerError(request))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        origin: tools_error/* ErrorSource.NETWORK */.zH.NETWORK,
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: tools_error/* ErrorSource.NETWORK */.zH.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0,tools_error/* toStackTraceString */.P3)((0,computeStackTrace/* computeStackTrace */._)(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = (0,utils/* tryToClone */.ul)(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then((0,monitor/* monitor */.zk)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0,monitor/* monitor */.zk)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function isServerError(request) {
    return request.status >= 500;
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0,readBytesFromStream/* readBytesFromStream */.n)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js + 1 modules
var trackRuntimeError = __webpack_require__(6299);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/logsCollection/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: utils/* noop */.ZT };
    }
    var rawErrorObservable = new observable/* Observable */.y();
    var stopRuntimeErrorTracking = (0,trackRuntimeError/* trackRuntimeError */.L)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    origin: tools_error/* ErrorSource.SOURCE */.zH.SOURCE,
                    stack: rawError.stack,
                },
                origin: tools_error/* ErrorSource.SOURCE */.zH.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());

//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable) {
    var _a;
    var batch = startBatchWithReplica(configuration, configuration.logsEndpointBuilder, reportError, pageExitObservable, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.logsEndpointBuilder);
    lifeCycle.subscribe(1 /* LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(1 /* LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/domain/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, buildCommonContext, mainLogger) {
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(1 /* LOG_COLLECTED */, function (log) { return (0,sendToExtension/* sendToExtension */.j)('logs', log); });
    var reportError = function (error) {
        return lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                error: {
                    origin: tools_error/* ErrorSource.AGENT */.zH.AGENT, // Todo: Remove in the next major release
                },
                origin: tools_error/* ErrorSource.AGENT */.zH.AGENT,
                status: StatusType.error,
            },
        });
    };
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)();
    var telemetry = startLogsTelemetry(configuration, reportError, pageExitObservable);
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    var session = (0,cookie/* areCookiesAuthorized */.oX)(configuration.cookieOptions) && !(0,eventBridge/* canUseEventBridge */.x)() && !(0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()
        ? startLogsSessionManager(configuration)
        : startLogsSessionManagerStub(configuration);
    startLogsAssembly(session, configuration, lifeCycle, buildCommonContext, mainLogger, reportError);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable);
    }
    else {
        startLogsBridge(lifeCycle);
    }
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeLogsConfiguration(initConfiguration));
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
    };
}
function startLogsTelemetry(configuration, reportError, pageExitObservable) {
    var _a;
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-logs-sdk" /* LOGS */, configuration);
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    else {
        var telemetryBatch_1 = startBatchWithReplica(configuration, configuration.rumEndpointBuilder, reportError, pageExitObservable, (_a = configuration.replica) === null || _a === void 0 ? void 0 : _a.rumEndpointBuilder);
        telemetry.observable.subscribe(function (event) { return telemetryBatch_1.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration)); });
    }
    return telemetry;
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js




var datadogLogs = makeLogsPublicApi(startLogs);
(0,init/* defineGlobal */.y)((0,utils/* getGlobalObject */.Rf)(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 80669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



// EXTERNAL MODULE: ./node_modules/stylis/src/Tokenizer.js
var Tokenizer = __webpack_require__(46411);
// EXTERNAL MODULE: ./node_modules/stylis/src/Utility.js
var Utility = __webpack_require__(26686);
// EXTERNAL MODULE: ./node_modules/stylis/src/Middleware.js + 1 modules
var Middleware = __webpack_require__(94582);
// EXTERNAL MODULE: ./node_modules/stylis/src/Serializer.js
var Serializer = __webpack_require__(20211);
// EXTERNAL MODULE: ./node_modules/stylis/src/Parser.js
var Parser = __webpack_require__(92190);
;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = (0,Tokenizer/* peek */.fj)(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if ((0,Tokenizer/* token */.r)(character)) {
      break;
    }

    (0,Tokenizer/* next */.lp)();
  }

  return (0,Tokenizer/* slice */.tP)(begin, Tokenizer/* position */.FK);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch ((0,Tokenizer/* token */.r)(character)) {
      case 0:
        // &\f
        if (character === 38 && (0,Tokenizer/* peek */.fj)() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(Tokenizer/* position */.FK - 1, points, index);
        break;

      case 2:
        parsed[index] += (0,Tokenizer/* delimit */.iF)(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = (0,Tokenizer/* peek */.fj)() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += (0,Utility/* from */.Dp)(character);
    }
  } while (character = (0,Tokenizer/* next */.lp)());

  return parsed;
};

var getRules = function getRules(value, points) {
  return (0,Tokenizer/* dealloc */.cE)(toRules((0,Tokenizer/* alloc */.un)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [Middleware/* prefixer */.Ji];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [Serializer/* stringify */.P,  false ? 0 : (0,Middleware/* rulesheet */.cD)(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = (0,Middleware/* middleware */.qR)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return (0,Serializer/* serialize */.q)((0,Parser/* compile */.MY)(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 32566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_css_create_instance_esm; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/css/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(81087);
// EXTERNAL MODULE: ./node_modules/@emotion/css/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 1 modules
var emotion_serialize_browser_esm = __webpack_require__(330);
;// CONCATENATED MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = (0,emotion_cache_browser_esm/* default */.Z)(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {}

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered, undefined);
    insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ var emotion_css_create_instance_esm = (createEmotion);


/***/ }),

/***/ 97133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "cx": function() { return /* binding */ cx; },
/* harmony export */   "iv": function() { return /* binding */ css; }
/* harmony export */ });
/* unused harmony exports cache, flush, getRegisteredStyles, hydrate, injectGlobal, merge, sheet */
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81087);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(330);
/* harmony import */ var _create_instance_dist_emotion_css_create_instance_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32566);





var _createEmotion = (0,_create_instance_dist_emotion_css_create_instance_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),

/***/ 81087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ emotion_cache_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = element.parent === children[0]; // in nested rules comments become children of the "auto-inserted" rule
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? children[0].children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);


/***/ }),

/***/ 330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
var emotion_hash_esm = __webpack_require__(66292);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var emotion_unitless_esm = __webpack_require__(94371);
;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/css/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,emotion_hash_esm/* default */.Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 66292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["Z"] = (murmur2);


/***/ }),

/***/ 79313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ is_prop_valid_browser_esm; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);


/***/ }),

/***/ 65706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CacheProvider; },
  "E": function() { return /* binding */ Emotion; },
  "T": function() { return /* binding */ ThemeContext; },
  "_": function() { return /* binding */ __unsafe_useEmotionCache; },
  "a": function() { return /* binding */ ThemeProvider; },
  "b": function() { return /* binding */ withTheme; },
  "c": function() { return /* binding */ createEmotionProps; },
  "h": function() { return /* binding */ emotion_element_699e6908_browser_esm_hasOwnProperty; },
  "u": function() { return /* binding */ useTheme; },
  "w": function() { return /* binding */ withEmotionCache; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 1 modules
var emotion_cache_browser_esm = __webpack_require__(80669);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ var weak_memoize_browser_esm = (weakMemoize);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics = (function (targetComponent, sourceComponent) {
  return hoist_non_react_statics_cjs_default()(targetComponent, sourceComponent);
});

/* harmony default export */ var emotion_react_isolated_hnrs_browser_esm = (hoistNonReactStatics);

// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(67728);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 3 modules
var emotion_serialize_browser_esm = __webpack_require__(18459);
;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js








var emotion_element_699e6908_browser_esm_hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */(0,react.createContext)( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,emotion_cache_browser_esm/* default */.Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return (0,react.useContext)(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */(0,react.createContext)({});

if (false) {}

var useTheme = function useTheme() {
  return (0,react.useContext)(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return (0,esm_extends/* default */.Z)({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weak_memoize_browser_esm(function (outerTheme) {
  return weak_memoize_browser_esm(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider = function ThemeProvider(props) {
  var theme = (0,react.useContext)(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/(0,react.createElement)(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = (0,react.useContext)(ThemeContext);
    return /*#__PURE__*/(0,react.createElement)(Component, (0,esm_extends/* default */.Z)({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/(0,react.forwardRef)(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return emotion_react_isolated_hnrs_browser_esm(WithTheme, Component);
}

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);

  if (match) {
    // The match may be something like 'Object.createEmotionProps'
    var parts = match[1].split('.');
    return parts[parts.length - 1];
  } // Safari / Firefox


  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return match[1];
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (emotion_element_699e6908_browser_esm_hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(registeredStyles, undefined, (0,react.useContext)(ThemeContext));

  if (false) { var labelFromStack; }

  var rules = (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (emotion_element_699e6908_browser_esm_hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/(0,react.createElement)(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
});

if (false) {}




/***/ }),

/***/ 43234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CacheProvider": function() { return /* reexport */ emotion_element_699e6908_browser_esm.C; },
  "ClassNames": function() { return /* binding */ ClassNames; },
  "Global": function() { return /* binding */ Global; },
  "ThemeContext": function() { return /* reexport */ emotion_element_699e6908_browser_esm.T; },
  "ThemeProvider": function() { return /* reexport */ emotion_element_699e6908_browser_esm.a; },
  "__unsafe_useEmotionCache": function() { return /* reexport */ emotion_element_699e6908_browser_esm._; },
  "createElement": function() { return /* binding */ jsx; },
  "css": function() { return /* binding */ css; },
  "jsx": function() { return /* binding */ jsx; },
  "keyframes": function() { return /* binding */ keyframes; },
  "useTheme": function() { return /* reexport */ emotion_element_699e6908_browser_esm.u; },
  "withEmotionCache": function() { return /* reexport */ emotion_element_699e6908_browser_esm.w; },
  "withTheme": function() { return /* reexport */ emotion_element_699e6908_browser_esm.b; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 1 modules
var emotion_cache_browser_esm = __webpack_require__(80669);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js + 2 modules
var emotion_element_699e6908_browser_esm = __webpack_require__(65706);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
// EXTERNAL MODULE: ./node_modules/@emotion/react/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(67728);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 3 modules
var emotion_serialize_browser_esm = __webpack_require__(18459);
;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js












var pkg = {
	name: "@emotion/react",
	version: "11.7.1",
	main: "dist/emotion-react.cjs.js",
	module: "dist/emotion-react.esm.js",
	browser: {
		"./dist/emotion-react.cjs.js": "./dist/emotion-react.browser.cjs.js",
		"./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
	},
	types: "types/index.d.ts",
	files: [
		"src",
		"dist",
		"jsx-runtime",
		"jsx-dev-runtime",
		"_isolated-hnrs",
		"types/*.d.ts",
		"macro.js",
		"macro.d.ts",
		"macro.js.flow"
	],
	sideEffects: false,
	author: "mitchellhamilton <mitchell@mitchellhamilton.me>",
	license: "MIT",
	scripts: {
		"test:typescript": "dtslint types"
	},
	dependencies: {
		"@babel/runtime": "^7.13.10",
		"@emotion/cache": "^11.7.1",
		"@emotion/serialize": "^1.0.2",
		"@emotion/sheet": "^1.1.0",
		"@emotion/utils": "^1.0.0",
		"@emotion/weak-memoize": "^0.2.5",
		"hoist-non-react-statics": "^3.3.1"
	},
	peerDependencies: {
		"@babel/core": "^7.0.0",
		react: ">=16.8.0"
	},
	peerDependenciesMeta: {
		"@babel/core": {
			optional: true
		},
		"@types/react": {
			optional: true
		}
	},
	devDependencies: {
		"@babel/core": "^7.13.10",
		"@emotion/css": "11.7.1",
		"@emotion/css-prettifier": "1.0.1",
		"@emotion/server": "11.4.0",
		"@emotion/styled": "11.6.0",
		"@types/react": "^16.9.11",
		dtslint: "^0.3.0",
		"html-tag-names": "^1.1.2",
		react: "16.14.0",
		"svg-tag-names": "^1.1.1"
	},
	repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
	publishConfig: {
		access: "public"
	},
	"umd:main": "dist/emotion-react.umd.min.js",
	preconstruct: {
		entrypoints: [
			"./index.js",
			"./jsx-runtime.js",
			"./jsx-dev-runtime.js",
			"./_isolated-hnrs.js"
		],
		umdName: "emotionReact"
	}
};

var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !emotion_element_699e6908_browser_esm.h.call(props, 'css')) {
    // $FlowFixMe
    return react.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = emotion_element_699e6908_browser_esm.E;
  createElementArgArray[1] = (0,emotion_element_699e6908_browser_esm.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return react.createElement.apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,emotion_element_699e6908_browser_esm.w)(function (props, cache) {
  if (false) {}

  var styles = props.styles;
  var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)([styles], undefined, (0,react.useContext)(emotion_element_699e6908_browser_esm.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = (0,react.useRef)();
  (0,react.useLayoutEffect)(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,react.useLayoutEffect)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

if (false) {}

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            if (false) {}

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.f)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Noop = function Noop() {
  return null;
};

var ClassNames = /* #__PURE__ */(0,emotion_element_699e6908_browser_esm.w)(function (props, cache) {
  var hasRendered = false;

  var css = function css() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(args, cache.registered);

    {
      (0,emotion_utils_browser_esm/* insertStyles */.M)(cache, serialized, false);
    }

    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && "production" !== 'production') {}

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: (0,react.useContext)(emotion_element_699e6908_browser_esm.T)
  };
  var ele = props.children(content);
  hasRendered = true;
  var possiblyStyleElement = /*#__PURE__*/(0,react.createElement)(Noop, null);


  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, possiblyStyleElement, ele);
});

if (false) {}

if (false) { var globalKey, globalContext, isJest, isBrowser; }




/***/ }),

/***/ 35944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fragment": function() { return /* binding */ Fragment; },
/* harmony export */   "jsx": function() { return /* binding */ jsx; },
/* harmony export */   "jsxs": function() { return /* binding */ jsxs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80669);
/* harmony import */ var _dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65706);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18459);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);











var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(type, props, key);
  }

  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E, (0,_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(type, props, key);
  }

  return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E, (0,_dist_emotion_element_699e6908_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props), key);
}




/***/ }),

/***/ 67728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ insertStyles; },
/* harmony export */   "f": function() { return /* binding */ getRegisteredStyles; }
/* harmony export */ });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 18459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/node_modules/@emotion/hash/dist/hash.browser.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ var hash_browser_esm = (murmur2);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_browser_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless_browser_esm[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hash_browser_esm(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),

/***/ 6029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ emotion_styled_browser_esm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/memoize/dist/emotion-memoize.browser.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_browser_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */emotion_memoize_browser_esm(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var emotion_is_prop_valid_browser_esm = (isPropValid);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js + 2 modules
var emotion_element_699e6908_browser_esm = __webpack_require__(65706);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js + 3 modules
var emotion_serialize_browser_esm = __webpack_require__(18459);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = emotion_is_prop_valid_browser_esm;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var useInsertionEffect = react_namespaceObject['useInsertion' + 'Effect'] ? react_namespaceObject['useInsertion' + 'Effect'] : function useInsertionEffect(create) {
  create();
};
function useInsertionEffectMaybe(create) {

  useInsertionEffect(create);
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectMaybe(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_699e6908_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_699e6908_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_browser_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/(0,react.createElement)(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js








var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);


/***/ }),

/***/ 94371:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 99776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'blogger';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f37c';
var svgPathData = 'M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports._i = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 54470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'facebook-f';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f39e';
var svgPathData = 'M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.AY = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 78279:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'instagram';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f16d';
var svgPathData = 'M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Zz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 50263:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'linkedin-in';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f0e1';
var svgPathData = 'M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.hw = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 41153:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'tiktok';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e07b';
var svgPathData = 'M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.AB = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 51719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'twitter';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f099';
var svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.md = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 28138:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fab';
var iconName = 'youtube';
var width = 576;
var height = 512;
var aliases = [61802];
var unicode = 'f167';
var svgPathData = 'M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.op = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 90770:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'angle-down';
var width = 448;
var height = 512;
var aliases = [8964];
var unicode = 'f107';
var svgPathData = 'M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.gc = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 77905:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'angle-left';
var width = 320;
var height = 512;
var aliases = [8249];
var unicode = 'f104';
var svgPathData = 'M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Ey = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 83183:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'angle-right';
var width = 320;
var height = 512;
var aliases = [8250];
var unicode = 'f105';
var svgPathData = 'M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.yO = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 9688:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'angle-up';
var width = 448;
var height = 512;
var aliases = [8963];
var unicode = 'f106';
var svgPathData = 'M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.on = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 34019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(63209);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.OF = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 68807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(25744);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.FR = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 61730:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-down';
var width = 384;
var height = 512;
var aliases = [8595];
var unicode = 'f063';
var svgPathData = 'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.r5 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 55346:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-left';
var width = 448;
var height = 512;
var aliases = [8592];
var unicode = 'f060';
var svgPathData = 'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.ac = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 50906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eF = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 774:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'bars';
var width = 448;
var height = 512;
var aliases = ["navicon"];
var unicode = 'f0c9';
var svgPathData = 'M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xi = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'basket-shopping';
var width = 576;
var height = 512;
var aliases = ["shopping-basket"];
var unicode = 'f291';
var svgPathData = 'M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBasketShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 71421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'caret-down';
var width = 320;
var height = 512;
var aliases = [];
var unicode = 'f0d7';
var svgPathData = 'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.eW = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 68055:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'check';
var width = 448;
var height = 512;
var aliases = [10003,10004];
var unicode = 'f00c';
var svgPathData = 'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LE = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 6811:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(16686);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.f8 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 85020:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-left';
var width = 320;
var height = 512;
var aliases = [9001];
var unicode = 'f053';
var svgPathData = 'M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.A3 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 65394:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var aliases = [9002];
var unicode = 'f054';
var svgPathData = 'M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports._t = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 17319:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'circle';
var width = 512;
var height = 512;
var aliases = [128308,128309,128992,128993,128994,128995,128996,9679,9898,9899,11044,61708,61915];
var unicode = 'f111';
var svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.di = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 63209:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-arrow-left';
var width = 512;
var height = 512;
var aliases = ["arrow-circle-left"];
var unicode = 'f0a8';
var svgPathData = 'M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleArrowLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 25744:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-arrow-right';
var width = 512;
var height = 512;
var aliases = ["arrow-circle-right"];
var unicode = 'f0a9';
var svgPathData = 'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleArrowRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 16686:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-check';
var width = 512;
var height = 512;
var aliases = [61533,"check-circle"];
var unicode = 'f058';
var svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 20495:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-exclamation';
var width = 512;
var height = 512;
var aliases = ["exclamation-circle"];
var unicode = 'f06a';
var svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleExclamation = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 213:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'circle-plus';
var width = 512;
var height = 512;
var aliases = ["plus-circle"];
var unicode = 'f055';
var svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCirclePlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 30332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'computer-mouse';
var width = 384;
var height = 512;
var aliases = [128433,"mouse"];
var unicode = 'f8cc';
var svgPathData = 'M0 192l176 0L176 0 160 0C71.6 0 0 71.6 0 160l0 32zm0 32L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-128-192 0L0 224zm384-32l0-32C384 71.6 312.4 0 224 0L208 0l0 192 176 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComputerMouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'copy';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f0c5';
var svgPathData = 'M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.kZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 48626:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'cross';
var width = 384;
var height = 512;
var aliases = [128327,10013];
var unicode = 'f654';
var svgPathData = 'M176 0c-26.5 0-48 21.5-48 48l0 80-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 208c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-208 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-80c0-26.5-21.5-48-48-48L176 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.xb = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 73864:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(97798);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.iV = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 97798:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'ellipsis-vertical';
var width = 128;
var height = 512;
var aliases = ["ellipsis-v"];
var unicode = 'f142';
var svgPathData = 'M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEllipsisVertical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 20702:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(20495);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.RL = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 75969:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'gift';
var width = 512;
var height = 512;
var aliases = [127873];
var unicode = 'f06b';
var svgPathData = 'M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 82740:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'mars';
var width = 448;
var height = 512;
var aliases = [9794];
var unicode = 'f222';
var svgPathData = 'M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8l112 0c13.3 0 24 10.7 24 24l0 112c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80s0 0 0 0s0 0 0 0s0 0 0 0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Ac = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 6767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'minus';
var width = 448;
var height = 512;
var aliases = [8211,8722,10134,"subtract"];
var unicode = 'f068';
var svgPathData = 'M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Kl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 21:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(30332);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.ML = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 12714:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plane-departure';
var width = 640;
var height = 512;
var aliases = [128747];
var unicode = 'f5b0';
var svgPathData = 'M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2l137.7 0c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.gR = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 40098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var aliases = [10133,61543,"add"];
var unicode = '2b';
var svgPathData = 'M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.r8 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 45573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(213);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Kt = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 80264:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'print';
var width = 512;
var height = 512;
var aliases = [128424,128438,9113];
var unicode = 'f02f';
var svgPathData = 'M128 0C92.7 0 64 28.7 64 64l0 96 64 0 0-96 226.7 0L384 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0L128 0zM384 352l0 32 0 64-256 0 0-64 0-16 0-16 256 0zm64 32l32 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.wf = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 70952:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(2943);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Yc = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 92332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = 'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.LM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 13461:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [11088,61446];
var unicode = 'f005';
var svgPathData = 'M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.T = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 53035:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'table-cells-large';
var width = 512;
var height = 512;
var aliases = ["th-large"];
var unicode = 'f009';
var svgPathData = 'M448 96l0 128-160 0 0-128 160 0zm0 192l0 128-160 0 0-128 160 0zM224 224L64 224 64 96l160 0 0 128zM64 288l160 0 0 128L64 416l0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTableCellsLarge = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 32660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(53035);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.To = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 59895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = 'M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2l144 0c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48l-97.5 0c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3l0-38.3 0-48 0-24.9c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.u8 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 59545:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(87709);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 88673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(62263);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.I7 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 62263:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'trash-can';
var width = 448;
var height = 512;
var aliases = [61460,"trash-alt"];
var unicode = 'f2ed';
var svgPathData = 'M135.2 17.7C140.6 6.8 151.7 0 163.8 0L284.2 0c12.1 0 23.2 6.8 28.6 17.7L320 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 7.2-14.3zM32 128l384 0 0 320c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-320zm96 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrashCan = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 39216:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'utensils';
var width = 448;
var height = 512;
var aliases = [127860,61685,"cutlery"];
var unicode = 'f2e7';
var svgPathData = 'M416 0C400 0 288 32 288 176l0 112c0 35.3 28.7 64 64 64l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 0-112 0-208c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7L80 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224.4c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16l0 134.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8L64 16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.fk = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 66781:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'venus';
var width = 384;
var height = 512;
var aliases = [9792];
var unicode = 'f221';
var svgPathData = 'M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.hT = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 87709:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'xmark';
var width = 384;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 62488:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fal';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 61437:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'chevron-down';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 40853:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fal';
var iconName = 'chevron-right';
var width = 320;
var height = 512;
var aliases = [9002];
var unicode = 'f054';
var svgPathData = 'M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports._t = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 95780:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(1028);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 1028:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fal';
var iconName = 'xmark';
var width = 384;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 72839:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'angle-left';
var width = 320;
var height = 512;
var aliases = [8249];
var unicode = 'f104';
var svgPathData = 'M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Ey = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 25215:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 87609:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'arrow-right-from-bracket';
var width = 512;
var height = 512;
var aliases = ["sign-out"];
var unicode = 'f08b';
var svgPathData = 'M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowRightFromBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 53626:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'arrow-rotate-left';
var width = 512;
var height = 512;
var aliases = [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"];
var unicode = 'f0e2';
var svgPathData = 'M40 224c-13.3 0-24-10.7-24-24L16 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80.1 20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-50.4 0-97-16.7-134.4-44.8c-10.6-8-12.7-23-4.8-33.6s23-12.7 33.6-4.8C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176s-78.8-176-176-176c-54.3 0-102.9 24.6-135.2 63.4l-.1 .2s0 0 0 0L93.1 176l90.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowRotateLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 87680:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'box-heart';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f49d';
var svgPathData = 'M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zM48 208l352 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm152-48L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM212.7 404.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 267.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.mM = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 98896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(72316);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.IV = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 72316:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'calendar-days';
var width = 448;
var height = 512;
var aliases = ["calendar-alt"];
var unicode = 'f073';
var svgPathData = 'M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCalendarDays = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 3926:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'calendar-star';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f736';
var svgPathData = 'M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM233.3 242.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L224 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.dZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 55426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'check';
var width = 448;
var height = 512;
var aliases = [10003,10004];
var unicode = 'f00c';
var svgPathData = 'M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 12489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(36522);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.f8 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 13910:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'chevron-down';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.pt = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 36522:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-check';
var width = 512;
var height = 512;
var aliases = [61533,"check-circle"];
var unicode = 'f058';
var svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 12587:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-play';
var width = 512;
var height = 512;
var aliases = [61469,"play-circle"];
var unicode = 'f144';
var svgPathData = 'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCirclePlay = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 22391:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'circle-xmark';
var width = 512;
var height = 512;
var aliases = [61532,"times-circle","xmark-circle"];
var unicode = 'f057';
var svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 51379:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'comment-lines';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4b0';
var svgPathData = 'M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Of = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 82059:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'credit-card';
var width = 576;
var height = 512;
var aliases = [128179,62083,"credit-card-alt"];
var unicode = 'f09d';
var svgPathData = 'M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Oz = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 22159:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = 'M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.FU = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'envelope-open';
var width = 512;
var height = 512;
var aliases = [62135];
var unicode = 'f2b6';
var svgPathData = 'M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.dw = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 1966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'gift';
var width = 512;
var height = 512;
var aliases = [127873];
var unicode = 'f06b';
var svgPathData = 'M231.9 44.4C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40L48 128c-26.5 0-48 21.5-48 48l0 64c0 20.9 13.4 38.7 32 45.3l0 2.7 0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160 0-2.7c18.6-6.6 32-24.4 32-45.3l0-64c0-26.5-21.5-48-48-48l-25.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176l0 64-32 0-144 0 0-64 72 0 104 0zm-240 0l0 64L80 240l-32 0 0-64 104 0 72 0zm0 112l0 176L96 464c-8.8 0-16-7.2-16-16l0-160 144 0zm64 176l0-176 144 0 0 160c0 8.8-7.2 16-16 16l-128 0zm72-336l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0l-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8L225.3 128l-1.3 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Cl = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 63850:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'gift-card';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f663';
var svgPathData = 'M353.5 68.8L318.7 128l1.3 0 72 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176 184 176 64 176c-8.8 0-16 7.2-16 16l0 128 480 0 0-128c0-8.8-7.2-16-16-16l-120 0-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384l0 64c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-64L48 384zM256 128l1.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l72 0zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40l41.6 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l41.6 0C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.I1 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 16101:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'gifts';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f79c';
var svgPathData = 'M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l136.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l80 0c0 0 0 0 .1 0l80 0 32.4 0c5.3-8.2 11.7-15.7 19-22.1C263.8 106.2 245.1 96 224 96l-6.2 0 28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24l-4.1 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-4.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zm0 72l72 0 56 0 8 0 0 72-136 0 0-72zm0 120l136 0 0 72-136 0 0-72zm320 0l0 72-136 0 0-72 136 0zM456 344l0-72 8 0 56 0 72 0 0 72-136 0zm88-144c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.BH = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 29839:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'hand-sparkles';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e05d';
var svgPathData = 'M262.4 36C272.8 14.7 294.7 0 320 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 163.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-29.3 8.4c7.7-14.9 12.8-31.4 14.5-48.9c.1-1.3 .4-2.5 .7-3.7L496 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L416 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L336 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L304 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c30.9-1.5 59.1-13.4 81.2-32.1l0 .3c0 17.6 10.8 33.3 27 39.6c-28.5 22.8-63.8 37.3-102.5 39.9c-1.4 .3-3 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L82.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L176 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zm50.3 290.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm257.5 33.1L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7zM104 88l40 11.4 0 25.1L104 136 90.2 184.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 136 7.7 122.2C3.1 120.9 0 116.7 0 112s3.1-8.9 7.7-10.2L56 88 69.8 39.7C71.1 35.1 75.3 32 80 32s8.9 3.1 10.2 7.7L104 88z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.oc = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 49996:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'laptop-mobile';
var width = 640;
var height = 512;
var aliases = ["phone-laptop"];
var unicode = 'f87a';
var svgPathData = 'M128 48l320 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 256-48 0c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l304 0 0-64-240 0 0-256c0-8.8 7.2-16 16-16zM384 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 288zm208 0l-160 0 0-288 160 0 0 288z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptopMobile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 55203:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'leaf-heart';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cb';
var svgPathData = 'M272 144l104 0c31.6 0 61-9.1 85.7-24.9c1.5 12.2 2.3 24.7 2.3 37.5c0 143.2-93.8 242.9-191.2 243.4c0 0 0 0-.1 0l-.8 0c0 0 0 0-.1 0C201.3 400 144 342.7 144 272c0-70.7 57.3-128 128-128zM450.6 67.5C430.8 85.2 404.7 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-26.4-2.9-51.9-8.3-76.2c-.4-1.9-.9-3.8-1.3-5.6c-2.2-9.3-4.8-18.3-7.8-27.2c-1.2-3.6-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-4.9 7.7-10.8 14.7-17.4 20.9c-.7 .7-1.4 1.3-2.1 1.9zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.VW = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 85226:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'link';
var width = 640;
var height = 512;
var aliases = [128279,"chain"];
var unicode = 'f0c1';
var svgPathData = 'M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.nN = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 18655:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'mobile';
var width = 384;
var height = 512;
var aliases = [128241,"mobile-android","mobile-phone"];
var unicode = 'f3ce';
var svgPathData = 'M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.Z_ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 4595:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'paper-plane';
var width = 512;
var height = 512;
var aliases = [61913];
var unicode = 'f1d8';
var svgPathData = 'M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.XC = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 49008:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'phone';
var width = 512;
var height = 512;
var aliases = [128222,128379];
var unicode = 'f095';
var svgPathData = 'M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.j1 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 2744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(49996);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.Ie = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 62856:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(12587);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.aQ = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 27009:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(87609);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.HE = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 31420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(67391);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.NB = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 61210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(22391);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.nY = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 19050:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var source = __webpack_require__(53626);
exports.DF = {
  prefix: source.prefix,
  iconName: source.iconName,
  icon: [
    source.width,
    source.height,
    source.aliases,
    source.unicode,
    source.svgPathData
  ]};

exports.X7 = exports.DF;
__webpack_unused_export__ = source.prefix;
__webpack_unused_export__ = source.iconName;
__webpack_unused_export__ = source.width;
__webpack_unused_export__ = source.height;
__webpack_unused_export__ = source.aliases;
__webpack_unused_export__ = source.unicode;
__webpack_unused_export__ = source.svgPathData;
__webpack_unused_export__ = source.aliases;

/***/ }),

/***/ 20824:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'user';
var width = 448;
var height = 512;
var aliases = [128100,62144];
var unicode = 'f007';
var svgPathData = 'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.IL = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 3457:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'wallet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f555';
var svgPathData = 'M88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88l0-176c0-48.6-39.4-88-88-88l-304 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c22.1 0 40 17.9 40 40l0 176c0 22.1-17.9 40-40 40L88 432c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.X5 = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 67391:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'far';
var iconName = 'xmark';
var width = 384;
var height = 512;
var aliases = [128473,10005,10006,10060,215,"close","multiply","remove","times"];
var unicode = 'f00d';
var svgPathData = 'M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faXmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 19824:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'arrow-right';
var width = 448;
var height = 512;
var aliases = [8594];
var unicode = 'f061';
var svgPathData = 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 65586:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'calendar-star';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f736';
var svgPathData = 'M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm233.3 58.9c-3.8-7.7-14.8-7.7-18.7 0l-23.6 47.8-52.7 7.7c-8.5 1.2-11.9 11.7-5.8 17.7l38.2 37.2-9 52.5c-1.5 8.5 7.5 15 15.1 11L224 400l47.2 24.8c7.6 4 16.5-2.5 15.1-11l-9-52.5 38.2-37.2c6.2-6 2.8-16.5-5.8-17.7l-52.7-7.7-23.6-47.8z';

exports.DF = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.dZ = exports.DF;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = aliases;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;
__webpack_unused_export__ = aliases;

/***/ }),

/***/ 69238:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var prefix = 'fas';
var iconName = 'lock-keyhole';
var width = 448;
var height = 512;
var aliases = ["lock-alt"];
var unicode = 'f30d';
var svgPathData = 'M224 64c44.2 0 80 35.8 80 80l0 48-160 0 0-48c0-44.2 35.8-80 80-80zM80 144l0 48-16 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLockKeyhole = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;

/***/ }),

/***/ 67814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FontAwesomeIcon": function() { return /* binding */ FontAwesomeIcon; }
/* harmony export */ });
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23636);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89632);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var beat = props.beat,
      fade = props.fade,
      beatFade = props.beatFade,
      bounce = props.bounce,
      shake = props.shake,
      flash = props.flash,
      spin = props.spin,
      spinPulse = props.spinPulse,
      spinReverse = props.spinReverse,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-beat': beat,
    'fa-fade': fade,
    'fa-beat-fade': beatFade,
    'fa-bounce': bounce,
    'fa-shake': shake,
    'fa-flash': flash,
    'fa-spin': spin,
    'fa-spin-reverse': spinReverse,
    'fa-spin-pulse': spinPulse,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip': flip === true,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

var _excluded = ["style"];

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, _excluded);

  mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }

  if (_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon) {
    return _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.icon */ .Qc.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}

var defaultProps = {
  border: false,
  className: '',
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: '',
  titleId: null,
  transform: null,
  swapOpacity: false
};
var FontAwesomeIcon = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function (props, ref) {
  var allProps = _objectSpread2(_objectSpread2({}, defaultProps), props);

  var iconArgs = allProps.icon,
      maskArgs = allProps.mask,
      symbol = allProps.symbol,
      className = allProps.className,
      title = allProps.title,
      titleId = allProps.titleId,
      maskId = allProps.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(allProps)), _toConsumableArray((className || '').split(' '))));
  var transform = objectWithKey('transform', typeof allProps.transform === 'string' ? _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .parse.transform */ .Qc.transform(allProps.transform) : allProps.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = (0,_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_0__/* .icon */ .qv)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
    symbol: symbol,
    title: title,
    titleId: titleId,
    maskId: maskId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: ref
  };
  Object.keys(allProps).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!defaultProps.hasOwnProperty(key)) {
      extraProps[key] = allProps[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  beat: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  border: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  beatFade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  bounce: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fade: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flash: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  mask: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  maskId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  fixedWidth: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  inverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  flip: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([true, false, 'horizontal', 'vertical', 'both']),
  icon: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().object), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().array), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  listItem: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  pull: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['right', 'left']),
  pulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  rotation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([0, 90, 180, 270]),
  shake: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinPulse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  spinReverse: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
  symbol: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)]),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  titleId: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  transform: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)]),
  swapOpacity: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
var convertCurry = convert.bind(null, react__WEBPACK_IMPORTED_MODULE_1__.createElement);




/***/ }),

/***/ 1516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(88841);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 89632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1516)();
}


/***/ }),

/***/ 88841:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 18225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48924);

/***/ }),

/***/ 81516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);
var settle = __webpack_require__(96210);
var cookies = __webpack_require__(13169);
var buildURL = __webpack_require__(88339);
var buildFullPath = __webpack_require__(27283);
var parseHeaders = __webpack_require__(73995);
var isURLSameOrigin = __webpack_require__(5652);
var createError = __webpack_require__(79052);
var transitionalDefaults = __webpack_require__(7035);
var Cancel = __webpack_require__(59837);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 48924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);
var bind = __webpack_require__(52780);
var Axios = __webpack_require__(30655);
var mergeConfig = __webpack_require__(13860);
var defaults = __webpack_require__(11310);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(59837);
axios.CancelToken = __webpack_require__(98491);
axios.isCancel = __webpack_require__(93809);
axios.VERSION = (__webpack_require__(77024).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(67606);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(52550);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 59837:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 98491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(59837);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 93809:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);
var buildURL = __webpack_require__(88339);
var InterceptorManager = __webpack_require__(9998);
var dispatchRequest = __webpack_require__(31053);
var mergeConfig = __webpack_require__(13860);
var validator = __webpack_require__(50583);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 9998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 27283:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(76829);
var combineURLs = __webpack_require__(58533);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 79052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(21283);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 31053:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);
var transformData = __webpack_require__(99358);
var isCancel = __webpack_require__(93809);
var defaults = __webpack_require__(11310);
var Cancel = __webpack_require__(59837);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 21283:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 13860:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 96210:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(79052);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 99358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);
var defaults = __webpack_require__(11310);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 11310:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var utils = __webpack_require__(62666);
var normalizeHeaderName = __webpack_require__(62087);
var enhanceError = __webpack_require__(21283);
var transitionalDefaults = __webpack_require__(7035);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(81516);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(81516);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 7035:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 77024:
/***/ (function(module) {

module.exports = {
  "version": "0.26.1"
};

/***/ }),

/***/ 52780:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 88339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 58533:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 13169:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 76829:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 52550:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 5652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 62087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 73995:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62666);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 67606:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 50583:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(77024).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 62666:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(52780);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 34320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ScrollOffset": function() { return /* reexport */ ScrollOffset; },
  "animate": function() { return /* reexport */ animate; },
  "animateStyle": function() { return /* reexport */ animateStyle; },
  "createAnimate": function() { return /* reexport */ createAnimate; },
  "createMotionState": function() { return /* reexport */ createMotionState; },
  "createStyleString": function() { return /* reexport */ createStyleString; },
  "createStyles": function() { return /* reexport */ createStyles; },
  "getAnimationData": function() { return /* reexport */ getAnimationData; },
  "getStyleName": function() { return /* reexport */ getStyleName; },
  "glide": function() { return /* reexport */ index_es_glide; },
  "inView": function() { return /* reexport */ inView; },
  "mountedStates": function() { return /* reexport */ mountedStates; },
  "resize": function() { return /* reexport */ resize; },
  "scroll": function() { return /* reexport */ index_es_scroll; },
  "spring": function() { return /* reexport */ index_es_spring; },
  "stagger": function() { return /* reexport */ stagger; },
  "style": function() { return /* reexport */ style; },
  "timeline": function() { return /* reexport */ timeline; },
  "withControls": function() { return /* reexport */ withControls; }
});

;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/defaults.es.js
const defaults = {
    duration: 0.3,
    delay: 0,
    endDelay: 0,
    repeat: 0,
    easing: "ease",
};



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/noop.es.js
const noop = () => { };
const noopReturn = (v) => v;



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-easing-generator.es.js
const isEasingGenerator = (easing) => typeof easing === "object" &&
    Boolean(easing.createAnimation);



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-number.es.js
const isNumber = (value) => typeof value === "number";



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-easing-list.es.js


const isEasingList = (easing) => Array.isArray(easing) && !isNumber(easing[0]);



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/mix.es.js
const mix = (min, max, progress) => -progress * min + progress * max + min;



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/progress.es.js
const progress = (min, max, value) => max - min === 0 ? 1 : (value - min) / (max - min);



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/offset.es.js



function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress(0, remaining, i);
        offset.push(mix(min, 1, offsetProgress));
    }
}
function defaultOffset(length) {
    const offset = [0];
    fillOffset(offset, length - 1);
    return offset;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/wrap.es.js
const wrap = (min, max, v) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/easing.es.js



function getEasingForSegment(easing, i) {
    return isEasingList(easing)
        ? easing[wrap(0, easing.length, i)]
        : easing;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/clamp.es.js
const clamp = (min, max, v) => Math.min(Math.max(v, min), max);



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/interpolate.es.js







function interpolate(output, input = defaultOffset(output.length), easing = noopReturn) {
    const length = output.length;
    /**
     * If the input length is lower than the output we
     * fill the input to match. This currently assumes the input
     * is an animation progress value so is a good candidate for
     * moving outside the function.
     */
    const remainder = length - input.length;
    remainder > 0 && fillOffset(input, remainder);
    return (t) => {
        let i = 0;
        for (; i < length - 2; i++) {
            if (t < input[i + 1])
                break;
        }
        let progressInRange = clamp(0, 1, progress(input[i], input[i + 1], t));
        const segmentEasing = getEasingForSegment(easing, i);
        progressInRange = segmentEasing(progressInRange);
        return mix(output[i], output[i + 1], progressInRange);
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/easing/dist/cubic-bezier.es.js


/*
  Bezier function generator

  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.

  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.

  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noopReturn;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/easing/dist/steps.es.js


const steps = (steps, direction = "end") => (progress) => {
    progress =
        direction === "end"
            ? Math.min(progress, 0.999)
            : Math.max(progress, 0.001);
    const expanded = progress * steps;
    const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
    return clamp(0, 1, rounded / steps);
};



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-cubic-bezier.es.js


const isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);



;// CONCATENATED MODULE: ./node_modules/@motionone/animation/dist/utils/easing.es.js



const namedEasings = {
    ease: cubicBezier(0.25, 0.1, 0.25, 1.0),
    "ease-in": cubicBezier(0.42, 0.0, 1.0, 1.0),
    "ease-in-out": cubicBezier(0.42, 0.0, 0.58, 1.0),
    "ease-out": cubicBezier(0.0, 0.0, 0.58, 1.0),
};
const functionArgsRegex = /\((.*?)\)/;
function getEasingFunction(definition) {
    // If already an easing function, return
    if (isFunction(definition))
        return definition;
    // If an easing curve definition, return bezier function
    if (isCubicBezier(definition))
        return cubicBezier(...definition);
    // If we have a predefined easing function, return
    if (namedEasings[definition])
        return namedEasings[definition];
    // If this is a steps function, attempt to create easing curve
    if (definition.startsWith("steps")) {
        const args = functionArgsRegex.exec(definition);
        if (args) {
            const argsArray = args[1].split(",");
            return steps(parseFloat(argsArray[0]), argsArray[1].trim());
        }
    }
    return noopReturn;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/animation/dist/Animation.es.js



class Animation {
    constructor(output, keyframes = [0, 1], { easing, duration: initialDuration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, offset, direction = "normal", } = {}) {
        this.startTime = null;
        this.rate = 1;
        this.t = 0;
        this.cancelTimestamp = null;
        this.easing = noopReturn;
        this.duration = 0;
        this.totalDuration = 0;
        this.repeat = 0;
        this.playState = "idle";
        this.finished = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        easing = easing || defaults.easing;
        if (isEasingGenerator(easing)) {
            const custom = easing.createAnimation(keyframes);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            initialDuration = custom.duration || initialDuration;
        }
        this.repeat = repeat;
        this.easing = isEasingList(easing) ? noopReturn : getEasingFunction(easing);
        this.updateDuration(initialDuration);
        const interpolate$1 = interpolate(keyframes, offset, isEasingList(easing) ? easing.map(getEasingFunction) : noopReturn);
        this.tick = (timestamp) => {
            var _a;
            // TODO: Temporary fix for OptionsResolver typing
            delay = delay;
            let t = 0;
            if (this.pauseTime !== undefined) {
                t = this.pauseTime;
            }
            else {
                t = (timestamp - this.startTime) * this.rate;
            }
            this.t = t;
            // Convert to seconds
            t /= 1000;
            // Rebase on delay
            t = Math.max(t - delay, 0);
            /**
             * If this animation has finished, set the current time
             * to the total duration.
             */
            if (this.playState === "finished" && this.pauseTime === undefined) {
                t = this.totalDuration;
            }
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */
            const progress = t / this.duration;
            // TODO progress += iterationStart
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */
            let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */
            let iterationProgress = progress % 1.0;
            if (!iterationProgress && progress >= 1) {
                iterationProgress = 1;
            }
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */
            iterationProgress === 1 && currentIteration--;
            /**
             * Reverse progress if we're not running in "normal" direction
             */
            const iterationIsOdd = currentIteration % 2;
            if (direction === "reverse" ||
                (direction === "alternate" && iterationIsOdd) ||
                (direction === "alternate-reverse" && !iterationIsOdd)) {
                iterationProgress = 1 - iterationProgress;
            }
            const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
            const latest = interpolate$1(this.easing(p));
            output(latest);
            const isAnimationFinished = this.pauseTime === undefined &&
                (this.playState === "finished" || t >= this.totalDuration + endDelay);
            if (isAnimationFinished) {
                this.playState = "finished";
                (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, latest);
            }
            else if (this.playState !== "idle") {
                this.frameRequestId = requestAnimationFrame(this.tick);
            }
        };
        this.play();
    }
    play() {
        const now = performance.now();
        this.playState = "running";
        if (this.pauseTime !== undefined) {
            this.startTime = now - this.pauseTime;
        }
        else if (!this.startTime) {
            this.startTime = now;
        }
        this.cancelTimestamp = this.startTime;
        this.pauseTime = undefined;
        this.frameRequestId = requestAnimationFrame(this.tick);
    }
    pause() {
        this.playState = "paused";
        this.pauseTime = this.t;
    }
    finish() {
        this.playState = "finished";
        this.tick(0);
    }
    stop() {
        var _a;
        this.playState = "idle";
        if (this.frameRequestId !== undefined) {
            cancelAnimationFrame(this.frameRequestId);
        }
        (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, false);
    }
    cancel() {
        this.stop();
        this.tick(this.cancelTimestamp);
    }
    reverse() {
        this.rate *= -1;
    }
    commitStyles() { }
    updateDuration(duration) {
        this.duration = duration;
        this.totalDuration = duration * (this.repeat + 1);
    }
    get currentTime() {
        return this.t;
    }
    set currentTime(t) {
        if (this.pauseTime !== undefined || this.rate === 0) {
            this.pauseTime = t;
        }
        else {
            this.startTime = performance.now() - t / this.rate;
        }
    }
    get playbackRate() {
        return this.rate;
    }
    set playbackRate(rate) {
        this.rate = rate;
    }
}



// EXTERNAL MODULE: ./node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(24394);
;// CONCATENATED MODULE: ./node_modules/@motionone/types/dist/MotionValue.es.js
/**
 * The MotionValue tracks the state of a single animatable
 * value. Currently, updatedAt and current are unused. The
 * long term idea is to use this to minimise the number
 * of DOM reads, and to abstract the DOM interactions here.
 */
class MotionValue {
    setAnimation(animation) {
        this.animation = animation;
        animation === null || animation === void 0 ? void 0 : animation.finished.then(() => this.clearAnimation()).catch(() => { });
    }
    clearAnimation() {
        this.animation = this.generator = undefined;
    }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/data.es.js


const data = new WeakMap();
function getAnimationData(element) {
    if (!data.has(element)) {
        data.set(element, {
            transforms: [],
            values: new Map(),
        });
    }
    return data.get(element);
}
function getMotionValue(motionValues, name) {
    if (!motionValues.has(name)) {
        motionValues.set(name, new MotionValue());
    }
    return motionValues.get(name);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/array.es.js
function addUniqueItem(array, item) {
    array.indexOf(item) === -1 && array.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/transforms.es.js



/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */
const axes = ["", "X", "Y", "Z"];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */
const order = ["translate", "scale", "rotate", "skew"];
const transformAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
};
const rotation = {
    syntax: "<angle>",
    initialValue: "0deg",
    toDefaultUnit: (v) => v + "deg",
};
const baseTransformProperties = {
    translate: {
        syntax: "<length-percentage>",
        initialValue: "0px",
        toDefaultUnit: (v) => v + "px",
    },
    rotate: rotation,
    scale: {
        syntax: "<number>",
        initialValue: 1,
        toDefaultUnit: noopReturn,
    },
    skew: rotation,
};
const transformDefinitions = new Map();
const asTransformCssVar = (name) => `--motion-${name}`;
/**
 * Generate a list of every possible transform key
 */
const transforms = ["x", "y", "z"];
order.forEach((name) => {
    axes.forEach((axis) => {
        transforms.push(name + axis);
        transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
const compareTransformOrder = (a, b) => transforms.indexOf(a) - transforms.indexOf(b);
/**
 * Provide a quick way to check if a string is the name of a transform
 */
const transformLookup = new Set(transforms);
const isTransform = (name) => transformLookup.has(name);
const addTransformToElement = (element, name) => {
    // Map x to translateX etc
    if (transformAlias[name])
        name = transformAlias[name];
    const { transforms } = getAnimationData(element);
    addUniqueItem(transforms, name);
    /**
     * TODO: An optimisation here could be to cache the transform in element data
     * and only update if this has changed.
     */
    element.style.transform = buildTransformTemplate(transforms);
};
const buildTransformTemplate = (transforms) => transforms
    .sort(compareTransformOrder)
    .reduce(transformListToString, "")
    .trim();
const transformListToString = (template, name) => `${template} ${name}(var(${asTransformCssVar(name)}))`;



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/css-var.es.js


const isCssVar = (name) => name.startsWith("--");
const registeredProperties = new Set();
function registerCssVariable(name) {
    if (registeredProperties.has(name))
        return;
    registeredProperties.add(name);
    try {
        const { syntax, initialValue } = transformDefinitions.has(name)
            ? transformDefinitions.get(name)
            : {};
        CSS.registerProperty({
            name,
            inherits: false,
            syntax,
            initialValue,
        });
    }
    catch (e) { }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/time.es.js
const time = {
    ms: (seconds) => seconds * 1000,
    s: (milliseconds) => milliseconds / 1000,
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/feature-detection.es.js
const testAnimation = (keyframes, options) => document.createElement("div").animate(keyframes, options);
const featureTests = {
    cssRegisterProperty: () => typeof CSS !== "undefined" &&
        Object.hasOwnProperty.call(CSS, "registerProperty"),
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
    partialKeyframes: () => {
        try {
            testAnimation({ opacity: [1] });
        }
        catch (e) {
            return false;
        }
        return true;
    },
    finished: () => Boolean(testAnimation({ opacity: [0, 1] }, { duration: 0.001 }).finished),
    linearEasing: () => {
        try {
            testAnimation({ opacity: 0 }, { easing: "linear(0, 1)" });
        }
        catch (e) {
            return false;
        }
        return true;
    },
};
const results = {};
const supports = {};
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/easing.es.js



// Create a linear easing point for every x second
const resolution = 0.015;
const generateLinearEasingPoints = (easing, duration) => {
    let points = "";
    const numPoints = Math.round(duration / resolution);
    for (let i = 0; i < numPoints; i++) {
        points += easing(progress(0, numPoints - 1, i)) + ", ";
    }
    return points.substring(0, points.length - 2);
};
const convertEasing = (easing, duration) => {
    if (isFunction(easing)) {
        return supports.linearEasing()
            ? `linear(${generateLinearEasingPoints(easing, duration)})`
            : defaults.easing;
    }
    else {
        return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
    }
};
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/keyframes.es.js
function hydrateKeyframes(keyframes, readInitialValue) {
    for (let i = 0; i < keyframes.length; i++) {
        if (keyframes[i] === null) {
            keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
        }
    }
    return keyframes;
}
const keyframesList = (keyframes) => Array.isArray(keyframes) ? keyframes : [keyframes];



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/get-style-name.es.js


function getStyleName(key) {
    if (transformAlias[key])
        key = transformAlias[key];
    return isTransform(key) ? asTransformCssVar(key) : key;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/style.es.js




const style = {
    get: (element, name) => {
        name = getStyleName(name);
        let value = isCssVar(name)
            ? element.style.getPropertyValue(name)
            : getComputedStyle(element)[name];
        if (!value && value !== 0) {
            const definition = transformDefinitions.get(name);
            if (definition)
                value = definition.initialValue;
        }
        return value;
    },
    set: (element, name, value) => {
        name = getStyleName(name);
        if (isCssVar(name)) {
            element.style.setProperty(name, value);
        }
        else {
            element.style[name] = value;
        }
    },
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/stop-animation.es.js
function stopAnimation(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished")
        return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) {
            animation.stop();
        }
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    }
    catch (e) { }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-string.es.js
const isString = (value) => typeof value === "string";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/get-unit.es.js


function getUnitConverter(keyframes, definition) {
    var _a;
    let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noopReturn;
    const finalKeyframe = keyframes[keyframes.length - 1];
    if (isString(finalKeyframe)) {
        const unit = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
        if (unit)
            toUnit = (value) => value + unit;
    }
    return toUnit;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/animate-style.es.js












function getDevToolsRecord() {
    return window.__MOTION_DEV_TOOLS_RECORD;
}
function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
    const record = getDevToolsRecord();
    const isRecording = options.record !== false && record;
    let animation;
    let { duration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, easing = defaults.easing, persist = false, direction, offset, allowWebkitAcceleration = false, } = options;
    const data = getAnimationData(element);
    const valueIsTransform = isTransform(key);
    let canAnimateNatively = supports.waapi();
    /**
     * If this is an individual transform, we need to map its
     * key to a CSS variable and update the element's transform style
     */
    valueIsTransform && addTransformToElement(element, key);
    const name = getStyleName(key);
    const motionValue = getMotionValue(data.values, name);
    /**
     * Get definition of value, this will be used to convert numerical
     * keyframes into the default value type.
     */
    const definition = transformDefinitions.get(name);
    /**
     * Stop the current animation, if any. Because this will trigger
     * commitStyles (DOM writes) and we might later trigger DOM reads,
     * this is fired now and we return a factory function to create
     * the actual animation that can get called in batch,
     */
    stopAnimation(motionValue.animation, !(isEasingGenerator(easing) && motionValue.generator) &&
        options.record !== false);
    /**
     * Batchable factory function containing all DOM reads.
     */
    return () => {
        const readInitialValue = () => { var _a, _b; return (_b = (_a = style.get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0; };
        /**
         * Replace null values with the previous keyframe value, or read
         * it from the DOM if it's the first keyframe.
         */
        let keyframes = hydrateKeyframes(keyframesList(keyframesDefinition), readInitialValue);
        /**
         * Detect unit type of keyframes.
         */
        const toUnit = getUnitConverter(keyframes, definition);
        if (isEasingGenerator(easing)) {
            const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
            easing = custom.easing;
            keyframes = custom.keyframes || keyframes;
            duration = custom.duration || duration;
        }
        /**
         * If this is a CSS variable we need to register it with the browser
         * before it can be animated natively. We also set it with setProperty
         * rather than directly onto the element.style object.
         */
        if (isCssVar(name)) {
            if (supports.cssRegisterProperty()) {
                registerCssVariable(name);
            }
            else {
                canAnimateNatively = false;
            }
        }
        /**
         * If we've been passed a custom easing function, and this browser
         * does **not** support linear() easing, and the value is a transform
         * (and thus a pure number) we can still support the custom easing
         * by falling back to the animation polyfill.
         */
        if (valueIsTransform &&
            !supports.linearEasing() &&
            (isFunction(easing) || (isEasingList(easing) && easing.some(isFunction)))) {
            canAnimateNatively = false;
        }
        /**
         * If we can animate this value with WAAPI, do so.
         */
        if (canAnimateNatively) {
            /**
             * Convert numbers to default value types. Currently this only supports
             * transforms but it could also support other value types.
             */
            if (definition) {
                keyframes = keyframes.map((value) => isNumber(value) ? definition.toDefaultUnit(value) : value);
            }
            /**
             * If this browser doesn't support partial/implicit keyframes we need to
             * explicitly provide one.
             */
            if (keyframes.length === 1 &&
                (!supports.partialKeyframes() || isRecording)) {
                keyframes.unshift(readInitialValue());
            }
            const animationOptions = {
                delay: time.ms(delay),
                duration: time.ms(duration),
                endDelay: time.ms(endDelay),
                easing: !isEasingList(easing)
                    ? convertEasing(easing, duration)
                    : undefined,
                direction,
                iterations: repeat + 1,
                fill: "both",
            };
            animation = element.animate({
                [name]: keyframes,
                offset,
                easing: isEasingList(easing)
                    ? easing.map((thisEasing) => convertEasing(thisEasing, duration))
                    : undefined,
            }, animationOptions);
            /**
             * Polyfill finished Promise in browsers that don't support it
             */
            if (!animation.finished) {
                animation.finished = new Promise((resolve, reject) => {
                    animation.onfinish = resolve;
                    animation.oncancel = reject;
                });
            }
            const target = keyframes[keyframes.length - 1];
            animation.finished
                .then(() => {
                if (persist)
                    return;
                // Apply styles to target
                style.set(element, name, target);
                // Ensure fill modes don't persist
                animation.cancel();
            })
                .catch(noop);
            /**
             * This forces Webkit to run animations on the main thread by exploiting
             * this condition:
             * https://trac.webkit.org/browser/webkit/trunk/Source/WebCore/platform/graphics/ca/GraphicsLayerCA.cpp?rev=281238#L1099
             *
             * This fixes Webkit's timing bugs, like accelerated animations falling
             * out of sync with main thread animations and massive delays in starting
             * accelerated animations in WKWebView.
             */
            if (!allowWebkitAcceleration)
                animation.playbackRate = 1.000001;
            /**
             * If we can't animate the value natively then we can fallback to the numbers-only
             * polyfill for transforms.
             */
        }
        else if (AnimationPolyfill && valueIsTransform) {
            /**
             * If any keyframe is a string (because we measured it from the DOM), we need to convert
             * it into a number before passing to the Animation polyfill.
             */
            keyframes = keyframes.map((value) => typeof value === "string" ? parseFloat(value) : value);
            /**
             * If we only have a single keyframe, we need to create an initial keyframe by reading
             * the current value from the DOM.
             */
            if (keyframes.length === 1) {
                keyframes.unshift(parseFloat(readInitialValue()));
            }
            animation = new AnimationPolyfill((latest) => {
                style.set(element, name, toUnit ? toUnit(latest) : latest);
            }, keyframes, Object.assign(Object.assign({}, options), { duration,
                easing }));
        }
        else {
            const target = keyframes[keyframes.length - 1];
            style.set(element, name, definition && isNumber(target)
                ? definition.toDefaultUnit(target)
                : target);
        }
        if (isRecording) {
            record(element, key, keyframes, {
                duration,
                delay: delay,
                easing,
                repeat,
                offset,
            }, "motion-one");
        }
        motionValue.setAnimation(animation);
        return animation;
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/options.es.js
const getOptions = (options, key) => 
/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */
options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/controls.es.js



const createAnimation = (factory) => factory();
const withControls = (animationFactory, options, duration = defaults.duration) => {
    return new Proxy({
        animations: animationFactory.map(createAnimation).filter(Boolean),
        duration,
        options,
    }, controls);
};
/**
 * TODO:
 * Currently this returns the first animation, ideally it would return
 * the first active animation.
 */
const getActiveAnimation = (state) => state.animations[0];
const controls = {
    get: (target, key) => {
        const activeAnimation = getActiveAnimation(target);
        switch (key) {
            case "duration":
                return target.duration;
            case "currentTime":
                return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
            case "playbackRate":
            case "playState":
                return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
            case "finished":
                if (!target.finished) {
                    target.finished = Promise.all(target.animations.map(selectFinished)).catch(noop);
                }
                return target.finished;
            case "stop":
                return () => {
                    target.animations.forEach((animation) => stopAnimation(animation));
                };
            case "forEachNative":
                /**
                 * This is for internal use only, fire a callback for each
                 * underlying animation.
                 */
                return (callback) => {
                    target.animations.forEach((animation) => callback(animation, target));
                };
            default:
                return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined"
                    ? undefined
                    : () => target.animations.forEach((animation) => animation[key]());
        }
    },
    set: (target, key, value) => {
        switch (key) {
            case "currentTime":
                value = time.ms(value);
            case "currentTime":
            case "playbackRate":
                for (let i = 0; i < target.animations.length; i++) {
                    target.animations[i][key] = value;
                }
                return true;
        }
        return false;
    },
};
const selectFinished = (animation) => animation.finished;



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/stagger.es.js



function stagger(duration = 0.1, { start = 0, from = 0, easing } = {}) {
    return (i, total) => {
        const fromIndex = isNumber(from) ? from : getFromIndex(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (easing) {
            const maxDelay = total * duration;
            const easingFunction = getEasingFunction(easing);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return start + delay;
    };
}
function getFromIndex(from, total) {
    if (from === "first") {
        return 0;
    }
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function resolveOption(option, i, total) {
    return isFunction(option) ? option(i, total) : option;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/create-animate.es.js







function createAnimate(AnimatePolyfill) {
    return function animate(elements, keyframes, options = {}) {
        elements = resolveElements(elements);
        const numElements = elements.length;
        (0,hey_listen_es.invariant)(Boolean(numElements), "No valid element provided.");
        (0,hey_listen_es.invariant)(Boolean(keyframes), "No keyframes defined.");
        /**
         * Create and start new animations
         */
        const animationFactories = [];
        for (let i = 0; i < numElements; i++) {
            const element = elements[i];
            for (const key in keyframes) {
                const valueOptions = getOptions(options, key);
                valueOptions.delay = resolveOption(valueOptions.delay, i, numElements);
                const animation = animateStyle(element, key, keyframes[key], valueOptions, AnimatePolyfill);
                animationFactories.push(animation);
            }
        }
        return withControls(animationFactories, options, 
        /**
         * TODO:
         * If easing is set to spring or glide, duration will be dynamically
         * generated. Ideally we would dynamically generate this from
         * animation.effect.getComputedTiming().duration but this isn't
         * supported in iOS13 or our number polyfill. Perhaps it's possible
         * to Proxy animations returned from animateStyle that has duration
         * as a getter.
         */
        options.duration);
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/index.es.js



const animate = createAnimate(Animation);



// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/timeline/utils/calc-time.es.js


function calcNextTime(current, next, prev, labels) {
    var _a;
    if (isNumber(next)) {
        return next;
    }
    else if (next.startsWith("-") || next.startsWith("+")) {
        return Math.max(0, current + parseFloat(next));
    }
    else if (next === "<") {
        return prev;
    }
    else {
        return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
    }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/timeline/utils/edit.es.js


function eraseKeyframes(sequence, startTime, endTime) {
    for (let i = 0; i < sequence.length; i++) {
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            removeItem(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */
    eraseKeyframes(sequence, startTime, endTime);
    for (let i = 0; i < keyframes.length; i++) {
        sequence.push({
            value: keyframes[i],
            at: mix(startTime, endTime, offset[i]),
            easing: getEasingForSegment(easing, i),
        });
    }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/timeline/utils/sort.es.js
function compareByTime(a, b) {
    if (a.at === b.at) {
        return a.value === null ? 1 : -1;
    }
    else {
        return a.at - b.at;
    }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/timeline/index.es.js














function timeline(definition, options = {}) {
    var _a;
    const animationDefinitions = createAnimationsFromTimeline(definition, options);
    /**
     * Create and start animations
     */
    const animationFactories = animationDefinitions
        .map((definition) => animateStyle(...definition, Animation))
        .filter(Boolean);
    return withControls(animationFactories, options, 
    // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration);
}
function createAnimationsFromTimeline(definition, _a = {}) {
    var { defaultOptions = {} } = _a, timelineOptions = (0,tslib_es6.__rest)(_a, ["defaultOptions"]);
    const animationDefinitions = [];
    const elementSequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the definition array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */
    for (let i = 0; i < definition.length; i++) {
        const segment = definition[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */
        if (isString(segment)) {
            timeLabels.set(segment, currentTime);
            continue;
        }
        else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        const [elementDefinition, keyframes, options = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */
        if (options.at !== undefined) {
            currentTime = calcNextTime(currentTime, options.at, prevTime, timeLabels);
        }
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */
        let maxDuration = 0;
        /**
         * Find all the elements specified in the definition and parse value
         * keyframes from their timeline definitions.
         */
        const elements = resolveElements(elementDefinition, elementCache);
        const numElements = elements.length;
        for (let elementIndex = 0; elementIndex < numElements; elementIndex++) {
            const element = elements[elementIndex];
            const elementSequence = getElementSequence(element, elementSequences);
            for (const key in keyframes) {
                const valueSequence = getValueSequence(key, elementSequence);
                let valueKeyframes = keyframesList(keyframes[key]);
                const valueOptions = getOptions(options, key);
                let { duration = defaultOptions.duration || defaults.duration, easing = defaultOptions.easing || defaults.easing, } = valueOptions;
                if (isEasingGenerator(easing)) {
                    (0,hey_listen_es.invariant)(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
                    const custom = easing.createAnimation(valueKeyframes, key !== "opacity", () => 0, key);
                    easing = custom.easing;
                    valueKeyframes = custom.keyframes || valueKeyframes;
                    duration = custom.duration || duration;
                }
                const delay = resolveOption(options.delay, elementIndex, numElements) || 0;
                const startTime = currentTime + delay;
                const targetTime = startTime + duration;
                /**
                 *
                 */
                let { offset = defaultOffset(valueKeyframes.length) } = valueOptions;
                /**
                 * If there's only one offset of 0, fill in a second with length 1
                 *
                 * TODO: Ensure there's a test that covers this removal
                 */
                if (offset.length === 1 && offset[0] === 0) {
                    offset[1] = 1;
                }
                /**
                 * Fill out if offset if fewer offsets than keyframes
                 */
                const remainder = offset.length - valueKeyframes.length;
                remainder > 0 && fillOffset(offset, remainder);
                /**
                 * If only one value has been set, ie [1], push a null to the start of
                 * the keyframe array. This will let us mark a keyframe at this point
                 * that will later be hydrated with the previous value.
                 */
                valueKeyframes.length === 1 && valueKeyframes.unshift(null);
                /**
                 * Add keyframes, mapping offsets to absolute time.
                 */
                addKeyframes(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
                maxDuration = Math.max(delay + duration, maxDuration);
                totalDuration = Math.max(targetTime, totalDuration);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */
    elementSequences.forEach((valueSequences, element) => {
        for (const key in valueSequences) {
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */
            valueSequence.sort(compareByTime);
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */
            for (let i = 0; i < valueSequence.length; i++) {
                const { at, value, easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push(progress(0, totalDuration, at));
                valueEasing.push(easing || defaults.easing);
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */
            if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift("linear");
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */
            if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            animationDefinitions.push([
                element,
                key,
                keyframes,
                Object.assign(Object.assign(Object.assign({}, defaultOptions), { duration: totalDuration, easing: valueEasing, offset: valueOffset }), timelineOptions),
            ]);
        }
    });
    return animationDefinitions;
}
function getElementSequence(element, sequences) {
    !sequences.has(element) && sequences.set(element, {});
    return sequences.get(element);
}
function getValueSequence(name, sequences) {
    if (!sequences[name])
        sequences[name] = [];
    return sequences[name];
}



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/spring/defaults.es.js
const defaults_es_defaults = {
    stiffness: 100.0,
    damping: 10.0,
    mass: 1.0,
};



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/spring/utils.es.js


const calcDampingRatio = (stiffness = defaults_es_defaults.stiffness, damping = defaults_es_defaults.damping, mass = defaults_es_defaults.mass) => damping / (2 * Math.sqrt(stiffness * mass));



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/utils/has-reached-target.es.js
function hasReachedTarget(origin, target, current) {
    return ((origin < target && current >= target) ||
        (origin > target && current <= target));
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/velocity.es.js
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/utils/velocity.es.js


const sampleT = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - sampleT, 0);
    return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/spring/index.es.js






const spring = ({ stiffness = defaults_es_defaults.stiffness, damping = defaults_es_defaults.damping, mass = defaults_es_defaults.mass, from = 0, to = 1, velocity = 0.0, restSpeed = 2, restDistance = 0.5, } = {}) => {
    velocity = velocity ? time.s(velocity) : 0.0;
    const state = {
        done: false,
        hasReachedTarget: false,
        current: from,
        target: to,
    };
    const initialDelta = to - from;
    const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
    const dampingRatio = calcDampingRatio(stiffness, damping, mass);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = undampedAngularFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
        // Underdamped spring (bouncy)
        resolveSpring = (t) => to -
            Math.exp(-dampingRatio * undampedAngularFreq * t) *
                (((-velocity + dampingRatio * undampedAngularFreq * initialDelta) /
                    angularFreq) *
                    Math.sin(angularFreq * t) +
                    initialDelta * Math.cos(angularFreq * t));
    }
    else {
        // Critically damped spring
        resolveSpring = (t) => {
            return (to -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta + (-velocity + undampedAngularFreq * initialDelta) * t));
        };
    }
    return (t) => {
        state.current = resolveSpring(t);
        const currentVelocity = t === 0
            ? velocity
            : calcGeneratorVelocity(resolveSpring, t, state.current);
        const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        const isBelowDisplacementThreshold = Math.abs(to - state.current) <= restDistance;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
        state.hasReachedTarget = hasReachedTarget(from, to, state.current);
        return state;
    };
};



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/utils/pregenerate-keyframes.es.js


const timeStep = 10;
const maxDuration = 10000;
function pregenerateKeyframes(generator, toUnit = noopReturn) {
    let overshootDuration = undefined;
    let timestamp = timeStep;
    let state = generator(0);
    const keyframes = [toUnit(state.current)];
    while (!state.done && timestamp < maxDuration) {
        state = generator(timestamp);
        keyframes.push(toUnit(state.done ? state.target : state.current));
        if (overshootDuration === undefined && state.hasReachedTarget) {
            overshootDuration = timestamp;
        }
        timestamp += timeStep;
    }
    const duration = timestamp - timeStep;
    /**
     * If generating an animation that didn't actually move,
     * generate a second keyframe so we have an origin and target.
     */
    if (keyframes.length === 1)
        keyframes.push(state.current);
    return {
        keyframes,
        duration: duration / 1000,
        overshootDuration: (overshootDuration !== null && overshootDuration !== void 0 ? overshootDuration : duration) / 1000,
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/easing/create-generator-easing.es.js






function canGenerate(value) {
    return isNumber(value) && !isNaN(value);
}
function getAsNumber(value) {
    return isString(value) ? parseFloat(value) : value;
}
function createGeneratorEasing(createGenerator) {
    const keyframesCache = new WeakMap();
    return (options = {}) => {
        const generatorCache = new Map();
        const getGenerator = (from = 0, to = 100, velocity = 0, isScale = false) => {
            const key = `${from}-${to}-${velocity}-${isScale}`;
            if (!generatorCache.has(key)) {
                generatorCache.set(key, createGenerator(Object.assign({ from,
                    to,
                    velocity, restSpeed: isScale ? 0.05 : 2, restDistance: isScale ? 0.01 : 0.5 }, options)));
            }
            return generatorCache.get(key);
        };
        const getKeyframes = (generator, toUnit) => {
            if (!keyframesCache.has(generator)) {
                keyframesCache.set(generator, pregenerateKeyframes(generator, toUnit));
            }
            return keyframesCache.get(generator);
        };
        return {
            createAnimation: (keyframes, shouldGenerate = true, getOrigin, name, motionValue) => {
                let settings;
                let origin;
                let target;
                let velocity = 0;
                let toUnit = noopReturn;
                const numKeyframes = keyframes.length;
                /**
                 * If we should generate an animation for this value, run some preperation
                 * like resolving target/origin, finding a unit (if any) and determine if
                 * it is actually possible to generate.
                 */
                if (shouldGenerate) {
                    toUnit = getUnitConverter(keyframes, name ? transformDefinitions.get(getStyleName(name)) : undefined);
                    const targetDefinition = keyframes[numKeyframes - 1];
                    target = getAsNumber(targetDefinition);
                    if (numKeyframes > 1 && keyframes[0] !== null) {
                        /**
                         * If we have multiple keyframes, take the initial keyframe as the origin.
                         */
                        origin = getAsNumber(keyframes[0]);
                    }
                    else {
                        const prevGenerator = motionValue === null || motionValue === void 0 ? void 0 : motionValue.generator;
                        /**
                         * If we have an existing generator for this value we can use it to resolve
                         * the animation's current value and velocity.
                         */
                        if (prevGenerator) {
                            /**
                             * If we have a generator for this value we can use it to resolve
                             * the animations's current value and velocity.
                             */
                            const { animation, generatorStartTime } = motionValue;
                            const startTime = (animation === null || animation === void 0 ? void 0 : animation.startTime) || generatorStartTime || 0;
                            const currentTime = (animation === null || animation === void 0 ? void 0 : animation.currentTime) || performance.now() - startTime;
                            const prevGeneratorCurrent = prevGenerator(currentTime).current;
                            origin = prevGeneratorCurrent;
                            velocity = calcGeneratorVelocity((t) => prevGenerator(t).current, currentTime, prevGeneratorCurrent);
                        }
                        else if (getOrigin) {
                            /**
                             * As a last resort, read the origin from the DOM.
                             */
                            origin = getAsNumber(getOrigin());
                        }
                    }
                }
                /**
                 * If we've determined it is possible to generate an animation, do so.
                 */
                if (canGenerate(origin) && canGenerate(target)) {
                    const generator = getGenerator(origin, target, velocity, name === null || name === void 0 ? void 0 : name.includes("scale"));
                    settings = Object.assign(Object.assign({}, getKeyframes(generator, toUnit)), { easing: "linear" });
                    // TODO Add test for this
                    if (motionValue) {
                        motionValue.generator = generator;
                        motionValue.generatorStartTime = performance.now();
                    }
                }
                /**
                 * If by now we haven't generated a set of keyframes, create a generic generator
                 * based on the provided props that animates from 0-100 to fetch a rough
                 * "overshootDuration" - the moment when the generator first hits the animation target.
                 * Then return animation settings that will run a normal animation for that duration.
                 */
                if (!settings) {
                    const keyframesMetadata = getKeyframes(getGenerator(0, 100));
                    settings = {
                        easing: "ease",
                        duration: keyframesMetadata.overshootDuration,
                    };
                }
                return settings;
            },
        };
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/easing/spring/index.es.js



const index_es_spring = createGeneratorEasing(spring);



;// CONCATENATED MODULE: ./node_modules/@motionone/generators/dist/glide/index.es.js




const glide = ({ from = 0, velocity = 0.0, power = 0.8, decay = 0.325, bounceDamping, bounceStiffness, changeTarget, min, max, restDistance = 0.5, restSpeed, }) => {
    decay = time.ms(decay);
    const state = {
        hasReachedTarget: false,
        done: false,
        current: from,
        target: from,
    };
    const isOutOfBounds = (v) => (min !== undefined && v < min) || (max !== undefined && v > max);
    const nearestBoundary = (v) => {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = changeTarget === undefined ? ideal : changeTarget(ideal);
    state.target = target;
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - from;
    const calcDelta = (t) => -amplitude * Math.exp(-t / decay);
    const calcLatest = (t) => target + calcDelta(t);
    const applyFriction = (t) => {
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDistance;
        state.current = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */
    let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t) => {
        if (!isOutOfBounds(state.current))
            return;
        timeReachedBoundary = t;
        spring$1 = spring({
            from: state.current,
            to: nearestBoundary(state.current),
            velocity: calcGeneratorVelocity(calcLatest, t, state.current),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDistance,
            restSpeed,
        });
    };
    checkCatchBoundary(0);
    return (t) => {
        /**
         * We need to resolve the friction to figure out if we need a
         * spring but we don't want to do this twice per frame. So here
         * we flag if we updated for this frame and later if we did
         * we can skip doing it again.
         */
        let hasUpdatedFrame = false;
        if (!spring$1 && timeReachedBoundary === undefined) {
            hasUpdatedFrame = true;
            applyFriction(t);
            checkCatchBoundary(t);
        }
        /**
         * If we have a spring and the provided t is beyond the moment the friction
         * animation crossed the min/max boundary, use the spring.
         */
        if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
            state.hasReachedTarget = true;
            return spring$1(t - timeReachedBoundary);
        }
        else {
            state.hasReachedTarget = false;
            !hasUpdatedFrame && applyFriction(t);
            return state;
        }
    };
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/easing/glide/index.es.js



const index_es_glide = createGeneratorEasing(glide);



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/resize/handle-element.es.js


const resizeHandlers = new WeakMap();
let observer;
function getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize, blockSize } = borderBoxSize[0];
        return { width: inlineSize, height: blockSize };
    }
    else if (target instanceof SVGElement && "getBBox" in target) {
        return target.getBBox();
    }
    else {
        return {
            width: target.offsetWidth,
            height: target.offsetHeight,
        };
    }
}
function notifyTarget({ target, contentRect, borderBoxSize, }) {
    var _a;
    (_a = resizeHandlers.get(target)) === null || _a === void 0 ? void 0 : _a.forEach((handler) => {
        handler({
            target,
            contentSize: contentRect,
            get size() {
                return getElementSize(target, borderBoxSize);
            },
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined")
        return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer)
        createResizeObserver();
    const elements = resolveElements(target);
    elements.forEach((element) => {
        let elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer === null || observer === void 0 ? void 0 : observer.observe(element);
    });
    return () => {
        elements.forEach((element) => {
            const elementHandlers = resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) {
                observer === null || observer === void 0 ? void 0 : observer.unobserve(element);
            }
        });
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/resize/handle-window.es.js
const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = () => {
        const size = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        const info = {
            target: window,
            size,
            contentSize: size,
        };
        windowCallbacks.forEach((callback) => callback(info));
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler)
        createWindowResizeHandler();
    return () => {
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && windowResizeHandler) {
            windowResizeHandler = undefined;
        }
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/resize/index.es.js




function resize(a, b) {
    return isFunction(a) ? resizeWindow(a) : resizeElement(a, b);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/info.es.js


/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */
const maxElapsed = 50;
const createAxisInfo = () => ({
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0,
});
const createScrollInfo = () => ({
    time: 0,
    x: createAxisInfo(),
    y: createAxisInfo(),
});
const keys = {
    x: {
        length: "Width",
        position: "Left",
    },
    y: {
        length: "Height",
        position: "Top",
    },
};
function updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length, position } = keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element["scroll" + position];
    axis.scrollLength = element["scroll" + length] - element["client" + length];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = progress(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity =
        elapsed > maxElapsed ? 0 : velocityPerSecond(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
    updateAxisInfo(element, "x", info, time);
    updateAxisInfo(element, "y", info, time);
    info.time = time;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/inset.es.js
function calcInset(element, container) {
    let inset = { x: 0, y: 0 };
    let current = element;
    while (current && current !== container) {
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        }
        else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top, left } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */
            while (current && current.tagName !== "svg") {
                current = current.parentNode;
            }
        }
    }
    return inset;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/presets.es.js
const ScrollOffset = {
    Enter: [
        [0, 1],
        [1, 1],
    ],
    Exit: [
        [0, 0],
        [1, 0],
    ],
    Any: [
        [1, 0],
        [0, 1],
    ],
    All: [
        [0, 0],
        [1, 1],
    ],
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/edge.es.js


const namedEdges = {
    start: 0,
    center: 0.5,
    end: 1,
};
function resolveEdge(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */
    if (namedEdges[edge] !== undefined) {
        edge = namedEdges[edge];
    }
    /**
     * Handle unit values
     */
    if (isString(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) {
            delta = asNumber;
        }
        else if (edge.endsWith("%")) {
            edge = asNumber / 100;
        }
        else if (edge.endsWith("vw")) {
            delta = (asNumber / 100) * document.documentElement.clientWidth;
        }
        else if (edge.endsWith("vh")) {
            delta = (asNumber / 100) * document.documentElement.clientHeight;
        }
        else {
            edge = asNumber;
        }
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */
    if (isNumber(edge)) {
        delta = length * edge;
    }
    return inset + delta;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/offset.es.js



const offset_es_defaultOffset = [0, 0];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : offset_es_defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if (isNumber(offset)) {
        /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */
        offsetDefinition = [offset, offset];
    }
    else if (isString(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) {
            offsetDefinition = offset.split(" ");
        }
        else {
            /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */
            offsetDefinition = [offset, namedEdges[offset] ? offset : `0`];
        }
    }
    targetPoint = resolveEdge(offsetDefinition[0], targetLength, targetInset);
    containerPoint = resolveEdge(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/offsets/index.es.js





const point = { x: 0, y: 0 };
function resolveOffsets(container, info, options) {
    let { offset: offsetDefinition = ScrollOffset.All } = options;
    const { target = container, axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? calcInset(target, container) : point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */
    const targetSize = target === container
        ? { width: container.scrollWidth, height: container.scrollHeight }
        : { width: target.clientWidth, height: target.clientHeight };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight,
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */
    info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */
    let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for (let i = 0; i < numOffsets; i++) {
        const offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
            hasChanged = true;
        }
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */
    if (hasChanged) {
        info[axis].interpolate = interpolate(defaultOffset(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [...info[axis].offset];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/on-scroll-handler.es.js




function measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */
    info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while (node && node != container) {
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength =
        target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength =
        target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: () => measure(element, options.target, info),
        update: (time) => {
            updateScrollInfo(element, info, time);
            if (options.offset || options.target) {
                resolveOffsets(element, info, options);
            }
        },
        notify: isFunction(onScroll)
            ? () => onScroll(info)
            : scrubAnimation(onScroll, info[axis]),
    };
}
function scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing }) => {
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing)
                animation.easing = noopReturn;
            animation.updateDuration(1);
        }
        else {
            const timingOptions = { duration: 1000 };
            if (!easing)
                timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 ? void 0 : _b.call(_a, timingOptions);
        }
    });
    return () => {
        controls.currentTime = axisInfo.progress;
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/scroll/index.es.js





const scrollListeners = new WeakMap();
const resizeListeners = new WeakMap();
const onScrollHandlers = new WeakMap();
const getEventTarget = (element) => element === document.documentElement ? window : element;
function index_es_scroll(onScroll, _a = {}) {
    var { container = document.documentElement } = _a, options = (0,tslib_es6.__rest)(_a, ["container"]);
    let containerHandlers = onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */
    if (!containerHandlers) {
        containerHandlers = new Set();
        onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */
    const info = createScrollInfo();
    const containerHandler = createOnScrollHandler(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */
    if (!scrollListeners.has(container)) {
        const listener = () => {
            const time = performance.now();
            for (const handler of containerHandlers)
                handler.measure();
            for (const handler of containerHandlers)
                handler.update(time);
            for (const handler of containerHandlers)
                handler.notify();
        };
        scrollListeners.set(container, listener);
        const target = getEventTarget(container);
        window.addEventListener("resize", listener, { passive: true });
        if (container !== document.documentElement) {
            resizeListeners.set(container, resize(container, listener));
        }
        target.addEventListener("scroll", listener, { passive: true });
    }
    const listener = scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return () => {
        var _a;
        if (typeof onScroll !== "function")
            onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */
        const containerHandlers = onScrollHandlers.get(container);
        if (!containerHandlers)
            return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size)
            return;
        /**
         * If no more handlers, remove the scroll listener too.
         */
        const listener = scrollListeners.get(container);
        scrollListeners.delete(container);
        if (listener) {
            getEventTarget(container).removeEventListener("scroll", listener);
            (_a = resizeListeners.get(container)) === null || _a === void 0 ? void 0 : _a();
            window.removeEventListener("resize", listener);
        }
    };
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/utils/has-changed.es.js
function hasChanged(a, b) {
    if (typeof a !== typeof b)
        return true;
    if (Array.isArray(a) && Array.isArray(b))
        return !shallowCompare(a, b);
    return a !== b;
}
function shallowCompare(next, prev) {
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/utils/is-variant.es.js
function isVariant(definition) {
    return typeof definition === "object";
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/utils/resolve-variant.es.js


function resolveVariant(definition, variants) {
    if (isVariant(definition)) {
        return definition;
    }
    else if (definition && variants) {
        return variants[definition];
    }
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/utils/schedule.es.js


let scheduled = undefined;
function processScheduledAnimations() {
    if (!scheduled)
        return;
    const generators = scheduled.sort(compareByDepth).map(fireAnimateUpdates);
    generators.forEach(fireNext);
    generators.forEach(fireNext);
    scheduled = undefined;
}
function scheduleAnimation(state) {
    if (!scheduled) {
        scheduled = [state];
        requestAnimationFrame(processScheduledAnimations);
    }
    else {
        addUniqueItem(scheduled, state);
    }
}
function unscheduleAnimation(state) {
    scheduled && removeItem(scheduled, state);
}
const compareByDepth = (a, b) => a.getDepth() - b.getDepth();
const fireAnimateUpdates = (state) => state.animateUpdates();
const fireNext = (iterator) => iterator.next();



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/utils/events.es.js
const motionEvent = (name, target) => new CustomEvent(name, { detail: { target } });
function dispatchPointerEvent(element, name, event) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEvent: event } }));
}
function dispatchViewEvent(element, name, entry) {
    element.dispatchEvent(new CustomEvent(name, { detail: { originalEntry: entry } }));
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/gestures/in-view.es.js




const in_view_es_inView = {
    isActive: (options) => Boolean(options.inView),
    subscribe: (element, { enable, disable }, { inViewOptions = {} }) => {
        const { once } = inViewOptions, viewOptions = (0,tslib_es6.__rest)(inViewOptions, ["once"]);
        return inView(element, (enterEntry) => {
            enable();
            dispatchViewEvent(element, "viewenter", enterEntry);
            if (!once) {
                return (leaveEntry) => {
                    disable();
                    dispatchViewEvent(element, "viewleave", leaveEntry);
                };
            }
        }, viewOptions);
    },
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/gestures/hover.es.js


const mouseEvent = (element, name, action) => (event) => {
    if (event.pointerType && event.pointerType !== "mouse")
        return;
    action();
    dispatchPointerEvent(element, name, event);
};
const hover = {
    isActive: (options) => Boolean(options.hover),
    subscribe: (element, { enable, disable }) => {
        const onEnter = mouseEvent(element, "hoverstart", enable);
        const onLeave = mouseEvent(element, "hoverend", disable);
        element.addEventListener("pointerenter", onEnter);
        element.addEventListener("pointerleave", onLeave);
        return () => {
            element.removeEventListener("pointerenter", onEnter);
            element.removeEventListener("pointerleave", onLeave);
        };
    },
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/gestures/press.es.js


const press = {
    isActive: (options) => Boolean(options.press),
    subscribe: (element, { enable, disable }) => {
        const onPointerUp = (event) => {
            disable();
            dispatchPointerEvent(element, "pressend", event);
            window.removeEventListener("pointerup", onPointerUp);
        };
        const onPointerDown = (event) => {
            enable();
            dispatchPointerEvent(element, "pressstart", event);
            window.addEventListener("pointerup", onPointerUp);
        };
        element.addEventListener("pointerdown", onPointerDown);
        return () => {
            element.removeEventListener("pointerdown", onPointerDown);
            window.removeEventListener("pointerup", onPointerUp);
        };
    },
};



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/state/index.es.js















const gestures = { inView: in_view_es_inView, hover: hover, press: press };
/**
 * A list of state types, in priority order. If a value is defined in
 * a righter-most type, it will override any definition in a lefter-most.
 */
const stateTypes = ["initial", "animate", ...Object.keys(gestures), "exit"];
/**
 * A global store of all generated motion states. This can be used to lookup
 * a motion state for a given Element.
 */
const mountedStates = new WeakMap();
function createMotionState(options = {}, parent) {
    /**
     * The element represented by the motion state. This is an empty reference
     * when we create the state to support SSR and allow for later mounting
     * in view libraries.
     *
     * @ts-ignore
     */
    let element;
    /**
     * Calculate a depth that we can use to order motion states by tree depth.
     */
    let depth = parent ? parent.getDepth() + 1 : 0;
    /**
     * Track which states are currently active.
     */
    const activeStates = { initial: true, animate: true };
    /**
     * A map of functions that, when called, will remove event listeners for
     * a given gesture.
     */
    const gestureSubscriptions = {};
    /**
     * Initialise a context to share through motion states. This
     * will be populated by variant names (if any).
     */
    const context = {};
    for (const name of stateTypes) {
        context[name] =
            typeof options[name] === "string"
                ? options[name]
                : parent === null || parent === void 0 ? void 0 : parent.getContext()[name];
    }
    /**
     * If initial is set to false we use the animate prop as the initial
     * animation state.
     */
    const initialVariantSource = options.initial === false ? "animate" : "initial";
    /**
     * Destructure an initial target out from the resolved initial variant.
     */
    let _a = resolveVariant(options[initialVariantSource] || context[initialVariantSource], options.variants) || {}, target = (0,tslib_es6.__rest)(_a, ["transition"]);
    /**
     * The base target is a cached map of values that we'll use to animate
     * back to if a value is removed from all active state types. This
     * is usually the initial value as read from the DOM, for instance if
     * it hasn't been defined in initial.
     */
    const baseTarget = Object.assign({}, target);
    /**
     * A generator that will be processed by the global animation scheduler.
     * This yeilds when it switches from reading the DOM to writing to it
     * to prevent layout thrashing.
     */
    function* animateUpdates() {
        var _a, _b;
        const prevTarget = target;
        target = {};
        const animationOptions = {};
        for (const name of stateTypes) {
            if (!activeStates[name])
                continue;
            const variant = resolveVariant(options[name]);
            if (!variant)
                continue;
            for (const key in variant) {
                if (key === "transition")
                    continue;
                target[key] = variant[key];
                animationOptions[key] = getOptions((_b = (_a = variant.transition) !== null && _a !== void 0 ? _a : options.transition) !== null && _b !== void 0 ? _b : {}, key);
            }
        }
        const allTargetKeys = new Set([
            ...Object.keys(target),
            ...Object.keys(prevTarget),
        ]);
        const animationFactories = [];
        allTargetKeys.forEach((key) => {
            var _a;
            if (target[key] === undefined) {
                target[key] = baseTarget[key];
            }
            if (hasChanged(prevTarget[key], target[key])) {
                (_a = baseTarget[key]) !== null && _a !== void 0 ? _a : (baseTarget[key] = style.get(element, key));
                animationFactories.push(animateStyle(element, key, target[key], animationOptions[key], Animation));
            }
        });
        // Wait for all animation states to read from the DOM
        yield;
        const animations = animationFactories
            .map((factory) => factory())
            .filter(Boolean);
        if (!animations.length)
            return;
        const animationTarget = target;
        element.dispatchEvent(motionEvent("motionstart", animationTarget));
        Promise.all(animations.map((animation) => animation.finished))
            .then(() => {
            element.dispatchEvent(motionEvent("motioncomplete", animationTarget));
        })
            .catch(noop);
    }
    const setGesture = (name, isActive) => () => {
        activeStates[name] = isActive;
        scheduleAnimation(state);
    };
    const updateGestureSubscriptions = () => {
        for (const name in gestures) {
            const isGestureActive = gestures[name].isActive(options);
            const remove = gestureSubscriptions[name];
            if (isGestureActive && !remove) {
                gestureSubscriptions[name] = gestures[name].subscribe(element, {
                    enable: setGesture(name, true),
                    disable: setGesture(name, false),
                }, options);
            }
            else if (!isGestureActive && remove) {
                remove();
                delete gestureSubscriptions[name];
            }
        }
    };
    const state = {
        update: (newOptions) => {
            if (!element)
                return;
            options = newOptions;
            updateGestureSubscriptions();
            scheduleAnimation(state);
        },
        setActive: (name, isActive) => {
            if (!element)
                return;
            activeStates[name] = isActive;
            scheduleAnimation(state);
        },
        animateUpdates,
        getDepth: () => depth,
        getTarget: () => target,
        getOptions: () => options,
        getContext: () => context,
        mount: (newElement) => {
            (0,hey_listen_es.invariant)(Boolean(newElement), "Animation state must be mounted with valid Element");
            element = newElement;
            mountedStates.set(element, state);
            updateGestureSubscriptions();
            return () => {
                mountedStates.delete(element);
                unscheduleAnimation(state);
                for (const key in gestureSubscriptions) {
                    gestureSubscriptions[key]();
                }
            };
        },
        isMounted: () => Boolean(element),
    };
    return state;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/style-object.es.js



function createStyles(keyframes) {
    const initialKeyframes = {};
    const transformKeys = [];
    for (let key in keyframes) {
        const value = keyframes[key];
        if (isTransform(key)) {
            if (transformAlias[key])
                key = transformAlias[key];
            transformKeys.push(key);
            key = asTransformCssVar(key);
        }
        let initialKeyframe = Array.isArray(value) ? value[0] : value;
        /**
         * If this is a number and we have a default value type, convert the number
         * to this type.
         */
        const definition = transformDefinitions.get(key);
        if (definition) {
            initialKeyframe = isNumber(value)
                ? definition.toDefaultUnit(value)
                : value;
        }
        initialKeyframes[key] = initialKeyframe;
    }
    if (transformKeys.length) {
        initialKeyframes.transform = buildTransformTemplate(transformKeys);
    }
    return initialKeyframes;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/animate/utils/style-string.es.js


const camelLetterToPipeLetter = (letter) => `-${letter.toLowerCase()}`;
const camelToPipeCase = (str) => str.replace(/[A-Z]/g, camelLetterToPipeLetter);
function createStyleString(target = {}) {
    const styles = createStyles(target);
    let style = "";
    for (const key in styles) {
        style += key.startsWith("--") ? key : camelToPipeCase(key);
        style += `: ${styles[key]}; `;
    }
    return style;
}



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/index.es.js




















/***/ }),

/***/ 51075:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*
 * Module dependencies.
 */

var keys = __webpack_require__(74331);

var objToString = Object.prototype.toString;

/**
 * Tests if a value is a number.
 *
 * @name isNumber
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if `val` is a number, otherwise `false`.
 */
// TODO: Move to library
var isNumber = function isNumber(val) {
  var type = typeof val;
  return type === 'number' || (type === 'object' && objToString.call(val) === '[object Number]');
};

/**
 * Tests if a value is an array.
 *
 * @name isArray
 * @api private
 * @param {*} val The value to test.
 * @return {boolean} Returns `true` if the value is an array, otherwise `false`.
 */
// TODO: Move to library
var isArray = typeof Array.isArray === 'function' ? Array.isArray : function isArray(val) {
  return objToString.call(val) === '[object Array]';
};

/**
 * Tests if a value is array-like. Array-like means the value is not a function and has a numeric
 * `.length` property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */
// TODO: Move to library
var isArrayLike = function isArrayLike(val) {
  return val != null && (isArray(val) || (val !== 'function' && isNumber(val.length)));
};

/**
 * Internal implementation of `each`. Works on arrays and array-like data structures.
 *
 * @name arrayEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array} array The array(-like) structure to iterate over.
 * @return {undefined}
 */
var arrayEach = function arrayEach(iterator, array) {
  for (var i = 0; i < array.length; i += 1) {
    // Break iteration early if `iterator` returns `false`
    if (iterator(array[i], i, array) === false) {
      break;
    }
  }
};

/**
 * Internal implementation of `each`. Works on objects.
 *
 * @name baseEach
 * @api private
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Object} object The object to iterate over.
 * @return {undefined}
 */
var baseEach = function baseEach(iterator, object) {
  var ks = keys(object);

  for (var i = 0; i < ks.length; i += 1) {
    // Break iteration early if `iterator` returns `false`
    if (iterator(object[ks[i]], ks[i], object) === false) {
      break;
    }
  }
};

/**
 * Iterate over an input collection, invoking an `iterator` function for each element in the
 * collection and passing to it three arguments: `(value, index, collection)`. The `iterator`
 * function can end iteration early by returning `false`.
 *
 * @name each
 * @api public
 * @param {Function(value, key, collection)} iterator The function to invoke per iteration.
 * @param {Array|Object|string} collection The collection to iterate over.
 * @return {undefined} Because `each` is run only for side effects, always returns `undefined`.
 * @example
 * var log = console.log.bind(console);
 *
 * each(log, ['a', 'b', 'c']);
 * //-> 'a', 0, ['a', 'b', 'c']
 * //-> 'b', 1, ['a', 'b', 'c']
 * //-> 'c', 2, ['a', 'b', 'c']
 * //=> undefined
 *
 * each(log, 'tim');
 * //-> 't', 2, 'tim'
 * //-> 'i', 1, 'tim'
 * //-> 'm', 0, 'tim'
 * //=> undefined
 *
 * // Note: Iteration order not guaranteed across environments
 * each(log, { name: 'tim', occupation: 'enchanter' });
 * //-> 'tim', 'name', { name: 'tim', occupation: 'enchanter' }
 * //-> 'enchanter', 'occupation', { name: 'tim', occupation: 'enchanter' }
 * //=> undefined
 */
var each = function each(iterator, collection) {
  return (isArrayLike(collection) ? arrayEach : baseEach).call(this, iterator, collection);
};

/*
 * Exports.
 */

module.exports = each;


/***/ }),

/***/ 74331:
/***/ (function(module) {

"use strict";


var hop = Object.prototype.hasOwnProperty;
var strCharAt = String.prototype.charAt;
var toStr = Object.prototype.toString;

/**
 * Returns the character at a given index.
 *
 * @param {string} str
 * @param {number} index
 * @return {string|undefined}
 */
// TODO: Move to a library
var charAt = function(str, index) {
  return strCharAt.call(str, index);
};

/**
 * hasOwnProperty, wrapped as a function.
 *
 * @name has
 * @api private
 * @param {*} context
 * @param {string|number} prop
 * @return {boolean}
 */

// TODO: Move to a library
var has = function has(context, prop) {
  return hop.call(context, prop);
};

/**
 * Returns true if a value is a string, otherwise false.
 *
 * @name isString
 * @api private
 * @param {*} val
 * @return {boolean}
 */

// TODO: Move to a library
var isString = function isString(val) {
  return toStr.call(val) === '[object String]';
};

/**
 * Returns true if a value is array-like, otherwise false. Array-like means a
 * value is not null, undefined, or a function, and has a numeric `length`
 * property.
 *
 * @name isArrayLike
 * @api private
 * @param {*} val
 * @return {boolean}
 */
// TODO: Move to a library
var isArrayLike = function isArrayLike(val) {
  return val != null && (typeof val !== 'function' && typeof val.length === 'number');
};


/**
 * indexKeys
 *
 * @name indexKeys
 * @api private
 * @param {} target
 * @param {Function} pred
 * @return {Array}
 */
var indexKeys = function indexKeys(target, pred) {
  pred = pred || has;

  var results = [];

  for (var i = 0, len = target.length; i < len; i += 1) {
    if (pred(target, i)) {
      results.push(String(i));
    }
  }

  return results;
};

/**
 * Returns an array of an object's owned keys.
 *
 * @name objectKeys
 * @api private
 * @param {*} target
 * @param {Function} pred Predicate function used to include/exclude values from
 * the resulting array.
 * @return {Array}
 */
var objectKeys = function objectKeys(target, pred) {
  pred = pred || has;

  var results = [];

  for (var key in target) {
    if (pred(target, key)) {
      results.push(String(key));
    }
  }

  return results;
};

/**
 * Creates an array composed of all keys on the input object. Ignores any non-enumerable properties.
 * More permissive than the native `Object.keys` function (non-objects will not throw errors).
 *
 * @name keys
 * @api public
 * @category Object
 * @param {Object} source The value to retrieve keys from.
 * @return {Array} An array containing all the input `source`'s keys.
 * @example
 * keys({ likes: 'avocado', hates: 'pineapple' });
 * //=> ['likes', 'pineapple'];
 *
 * // Ignores non-enumerable properties
 * var hasHiddenKey = { name: 'Tim' };
 * Object.defineProperty(hasHiddenKey, 'hidden', {
 *   value: 'i am not enumerable!',
 *   enumerable: false
 * })
 * keys(hasHiddenKey);
 * //=> ['name'];
 *
 * // Works on arrays
 * keys(['a', 'b', 'c']);
 * //=> ['0', '1', '2']
 *
 * // Skips unpopulated indices in sparse arrays
 * var arr = [1];
 * arr[4] = 4;
 * keys(arr);
 * //=> ['0', '4']
 */
var keys = function keys(source) {
  if (source == null) {
    return [];
  }

  // IE6-8 compatibility (string)
  if (isString(source)) {
    return indexKeys(source, charAt);
  }

  // IE6-8 compatibility (arguments)
  if (isArrayLike(source)) {
    return indexKeys(source, has);
  }

  return objectKeys(source);
};

/*
 * Exports.
 */

module.exports = keys;


/***/ }),

/***/ 48580:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/*
 * Module dependencies.
 */

var each = __webpack_require__(51075);

/**
 * Produce a new array by passing each value in the input `collection` through a transformative
 * `iterator` function. The `iterator` function is passed three arguments:
 * `(value, index, collection)`.
 *
 * @name map
 * @api public
 * @param {Function} iterator The transformer function to invoke per iteration.
 * @param {Array} collection The collection to iterate over.
 * @return {Array} A new array containing the results of each `iterator` invocation.
 * @example
 * var square = function(x) { return x * x; };
 *
 * map(square, [1, 2, 3]);
 * //=> [1, 4, 9]
 */
var map = function map(iterator, collection) {
  if (typeof iterator !== 'function') {
    throw new TypeError('Expected a function but received a ' + typeof iterator);
  }

  var result = [];

  each(function(val, i, collection) {
    result.push(iterator(val, i, collection));
  }, collection);

  return result;
};

/*
 * Exports.
 */

module.exports = map;


/***/ }),

/***/ 68989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var AccordionContext_1 = __webpack_require__(86520);
var style = __importStar(__webpack_require__(24918));
var Accordion = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'accordion' : _b, allowMultipleExpanded = _a.allowMultipleExpanded, allowZeroExpanded = _a.allowZeroExpanded, onChange = _a.onChange, preExpanded = _a.preExpanded, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, rest = __rest(_a, ["className", "allowMultipleExpanded", "allowZeroExpanded", "onChange", "preExpanded", "variant"]);
    return ((0, jsx_runtime_1.jsx)(AccordionContext_1.Provider, __assign({ preExpanded: preExpanded, allowMultipleExpanded: allowMultipleExpanded, allowZeroExpanded: allowZeroExpanded, onChange: onChange, variant: variant }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "Accordion", css: style.accordion(variant), className: className }, rest)) })));
};
exports["default"] = Accordion;
//# sourceMappingURL=Accordion.js.map

/***/ }),

/***/ 24918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.backgroundStyle = exports.item = exports.panel = exports.button = exports.accordion = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
// TODO: Add theming
var accordionBorder = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n"], ["\n  border: 1px solid ", ";\n"])), tokens_1.colors.gray200);
var accordion = function (variant) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  border-radius: 4px;\n  overflow: hidden;\n\n  .collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition: height 0.35s ease;\n\n    [hidden] {\n      display: block;\n    }\n  }\n"], ["\n  ", "\n  border-radius: 4px;\n  overflow: hidden;\n\n  .collapsing {\n    position: relative;\n    height: 0;\n    overflow: hidden;\n    transition: height 0.35s ease;\n\n    [hidden] {\n      display: block;\n    }\n  }\n"])), variant === 'primary' && accordionBorder); };
exports.accordion = accordion;
exports.button = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: ", " ", " ", " ", ";\n  width: 100%;\n  text-align: left;\n  border: none;\n  position: relative;\n  align-items: center;\n  min-height: 70px;\n  font-weight: 600;\n  font-size: ", ";\n  line-height: ", ";\n\n  &:hover {\n    background-color: ", ";\n    transition-duration: 0.75s;\n    transition-property: background-color;\n  }\n\n  &:after {\n    color: ", ";\n    display: inline-block;\n    content: '';\n    height: 10px;\n    width: 10px;\n    border-bottom: 2px solid currentColor;\n    border-right: 2px solid currentColor;\n    position: absolute;\n    top: calc(50% - 7.5px);\n    right: ", ";\n    transform: rotate(45deg);\n    transition: transform 0.2s ease-in-out;\n  }\n\n  &[aria-expanded='true']:after,\n  &[aria-selected='true']:after {\n    transform: rotate(-135deg);\n  } \n"], ["\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: ", " ", " ", " ", ";\n  width: 100%;\n  text-align: left;\n  border: none;\n  position: relative;\n  align-items: center;\n  min-height: 70px;\n  font-weight: 600;\n  font-size: ", ";\n  line-height: ", ";\n\n  &:hover {\n    background-color: ", ";\n    transition-duration: 0.75s;\n    transition-property: background-color;\n  }\n\n  &:after {\n    color: ", ";\n    display: inline-block;\n    content: '';\n    height: 10px;\n    width: 10px;\n    border-bottom: 2px solid currentColor;\n    border-right: 2px solid currentColor;\n    position: absolute;\n    top: calc(50% - 7.5px);\n    right: ", ";\n    transform: rotate(45deg);\n    transition: transform 0.2s ease-in-out;\n  }\n\n  &[aria-expanded='true']:after,\n  &[aria-selected='true']:after {\n    transform: rotate(-135deg);\n  } \n"])), tokens_1.spacing.spacing03, tokens_1.spacing.spacing05, tokens_1.spacing.spacing03, tokens_1.spacing.spacing05, tokens_1.spacing.spacing04, tokens_1.spacing.spacing06, tokens_1.colors.gray200, tokens_1.colors.purple400, tokens_1.spacing.spacing05);
var panel = function (backgroundColor, borderTop) { return (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0 ", ";\n  border-top: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  margin: 0 ", ";\n  border-top: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), tokens_1.spacing.spacing05, borderTop ? "1px solid ".concat(tokens_1.colors.gray300) : "none", backgroundColor, tokens_1.colors.gray600, tokens_1.spacing.spacing035, tokens_1.spacing.spacing05); };
exports.panel = panel;
exports.item = (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  & + & {\n    border-top: 1px solid ", ";\n  }\n  color: ", "\n"], ["\n  & + & {\n    border-top: 1px solid ", ";\n  }\n  color: ", "\n"])), tokens_1.colors.gray200, tokens_1.colors.gray800);
var backgroundStyle = function (color) { return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n"], ["\n  background-color: ", ";\n  width: 100%;\n"])), color); };
exports.backgroundStyle = backgroundStyle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Accordion.style.js.map

/***/ }),

/***/ 86520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var AccordionStore_1 = __importDefault(__webpack_require__(94118));
var Context = (0, react_1.createContext)(null);
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = new AccordionStore_1.default({
            expanded: _this.props.preExpanded,
            allowMultipleExpanded: _this.props.allowMultipleExpanded,
            allowZeroExpanded: _this.props.allowZeroExpanded,
        });
        _this.toggleExpanded = function (key) {
            _this.setState(function (state) { return state.toggleExpanded(key); }, function () {
                if (_this.props.onChange) {
                    _this.props.onChange(_this.state.expanded);
                }
            });
        };
        _this.isItemDisabled = function (key) {
            return _this.state.isItemDisabled(key);
        };
        _this.isItemExpanded = function (key) {
            return _this.state.isItemExpanded(key);
        };
        _this.getPanelAttributes = function (key, dangerouslySetExpanded) {
            return _this.state.getPanelAttributes(key, dangerouslySetExpanded);
        };
        _this.getHeadingAttributes = function () {
            // uuid: UUID
            return _this.state.getHeadingAttributes();
        };
        _this.getButtonAttributes = function (key, dangerouslySetExpanded) {
            return _this.state.getButtonAttributes(key, dangerouslySetExpanded);
        };
        return _this;
    }
    Provider.prototype.render = function () {
        var _a = this.state, allowZeroExpanded = _a.allowZeroExpanded, allowMultipleExpanded = _a.allowMultipleExpanded;
        var variant = this.props.variant;
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                allowMultipleExpanded: allowMultipleExpanded,
                allowZeroExpanded: allowZeroExpanded,
                toggleExpanded: this.toggleExpanded,
                isItemDisabled: this.isItemDisabled,
                isItemExpanded: this.isItemExpanded,
                getPanelAttributes: this.getPanelAttributes,
                getHeadingAttributes: this.getHeadingAttributes,
                getButtonAttributes: this.getButtonAttributes,
                variant: variant,
            } }, { children: this.props.children || null })));
    };
    Provider.defaultProps = {
        allowMultipleExpanded: false,
        allowZeroExpanded: false,
        variant: 'primary'
    };
    return Provider;
}(react_1.PureComponent));
exports.Provider = Provider;
var Consumer = /** @class */ (function (_super) {
    __extends(Consumer, _super);
    function Consumer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChildren = function (container) {
            return container ? _this.props.children(container) : null;
        };
        return _this;
    }
    Consumer.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: this.renderChildren });
    };
    return Consumer;
}(react_1.PureComponent));
exports.Consumer = Consumer;
//# sourceMappingURL=AccordionContext.js.map

/***/ }),

/***/ 4006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_uid_1 = __webpack_require__(43412);
var DisplayName_1 = __importDefault(__webpack_require__(60228));
var uuid_1 = __webpack_require__(62647);
var ItemContext_1 = __webpack_require__(70447);
var style = __importStar(__webpack_require__(24918));
var AccordionItem = function (_a) {
    var customUuid = _a.uuid, dangerouslySetExpanded = _a.dangerouslySetExpanded, _b = _a.className, className = _b === void 0 ? 'accordion__item' : _b, activeClassName = _a.activeClassName, rest = __rest(_a, ["uuid", "dangerouslySetExpanded", "className", "activeClassName"]);
    var instanceUuid = (0, react_uid_1.useUID)();
    var uuid = customUuid !== null && customUuid !== void 0 ? customUuid : instanceUuid;
    var renderChildren = function (itemContext) {
        var expanded = itemContext.expanded;
        var cx = expanded && activeClassName ? activeClassName : className;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "AccordionItem", css: style.item, className: cx }, rest)));
    };
    (0, uuid_1.assertValidHtmlId)(uuid.toString());
    if (rest.id) {
        (0, uuid_1.assertValidHtmlId)(rest.id);
    }
    return ((0, jsx_runtime_1.jsx)(ItemContext_1.Provider, __assign({ uuid: uuid, dangerouslySetExpanded: dangerouslySetExpanded }, { children: (0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: renderChildren }) })));
};
AccordionItem.displayName = DisplayName_1.default.AccordionItem;
exports["default"] = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map

/***/ }),

/***/ 32450:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var focus_1 = __webpack_require__(19724);
var keycodes_1 = __importDefault(__webpack_require__(76662));
var uuid_1 = __webpack_require__(62647);
var ItemContext_1 = __webpack_require__(70447);
var style = __importStar(__webpack_require__(24918));
var theme_1 = __webpack_require__(72265);
var tokens_1 = __webpack_require__(53126);
var AccordionItemButton = function (_a) {
    var _b, _c;
    var toggleExpanded = _a.toggleExpanded, _d = _a.className, className = _d === void 0 ? 'accordion__button' : _d, _e = _a.variant, variant = _e === void 0 ? 'primary' : _e, rest = __rest(_a, ["toggleExpanded", "className", "variant"]);
    var theme = (0, theme_1.useTheme)();
    var handleKeyPress = function (evt) {
        var keyCode = evt.key;
        if (keyCode === keycodes_1.default.ENTER ||
            keyCode === keycodes_1.default.SPACE ||
            keyCode === keycodes_1.default.SPACE_DEPRECATED) {
            evt.preventDefault();
            toggleExpanded();
        }
        /* The following block is ignored from test coverage because at time
         * time of writing Jest/react-testing-library can not assert 'focus'
         * functionality.
         */
        // istanbul ignore next
        if (evt.target instanceof HTMLElement) {
            switch (keyCode) {
                case keycodes_1.default.HOME: {
                    evt.preventDefault();
                    (0, focus_1.focusFirstSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.END: {
                    evt.preventDefault();
                    (0, focus_1.focusLastSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.LEFT:
                case keycodes_1.default.UP: {
                    evt.preventDefault();
                    (0, focus_1.focusPreviousSiblingOf)(evt.target);
                    break;
                }
                case keycodes_1.default.RIGHT:
                case keycodes_1.default.DOWN: {
                    evt.preventDefault();
                    (0, focus_1.focusNextSiblingOf)(evt.target);
                    break;
                }
                default: {
                    //
                }
            }
        }
    };
    if (rest.id) {
        (0, uuid_1.assertValidHtmlId)(rest.id);
    }
    var backgroundColor = ((_c = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.accordions[variant]) === null || _c === void 0 ? void 0 : _c.panelBackgroundColor) || tokens_1.colors.white;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: [style.button, style.backgroundStyle(backgroundColor)], className: className }, rest, { role: "button", tabIndex: 0, onClick: toggleExpanded, onKeyDown: handleKeyPress, "data-accordion-component": "AccordionItemButton" })));
};
var AccordionItemButtonWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: function (itemContext) {
        var toggleExpanded = itemContext.toggleExpanded, buttonAttributes = itemContext.buttonAttributes, variant = itemContext.variant;
        return ((0, jsx_runtime_1.jsx)(AccordionItemButton, __assign({ toggleExpanded: toggleExpanded }, props, buttonAttributes, { variant: variant })));
    } })); };
exports["default"] = AccordionItemButtonWrapper;
//# sourceMappingURL=AccordionItemButton.js.map

/***/ }),

/***/ 33302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AccordionItemHeading = exports.SPEC_ERROR = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var React = __importStar(__webpack_require__(67294));
var DisplayName_1 = __importDefault(__webpack_require__(60228));
var uuid_1 = __webpack_require__(62647);
var ItemContext_1 = __webpack_require__(70447);
var defaultProps = {
    className: 'accordion__heading',
    'aria-level': 3,
};
exports.SPEC_ERROR = "AccordionItemButton may contain only one child element, which must be an instance of AccordionItemButton.\n\nFrom the WAI-ARIA spec (https://www.w3.org/TR/wai-aria-practices-1.1/#accordion):\n\n\u201CThe button element is the only element inside the heading element. That is, if there are other visually persistent elements, they are not included inside the heading element.\u201D\n\n";
var AccordionItemHeading = /** @class */ (function (_super) {
    __extends(AccordionItemHeading, _super);
    function AccordionItemHeading() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setRef = function (ref) {
            _this.ref = ref;
        };
        return _this;
    }
    AccordionItemHeading.VALIDATE = function (ref) {
        if (ref === undefined) {
            throw new Error('ref is undefined');
        }
        if (!(ref.childElementCount === 1 &&
            ref.firstElementChild &&
            ref.firstElementChild.getAttribute('data-accordion-component') === 'AccordionItemButton')) {
            throw new Error(exports.SPEC_ERROR);
        }
    };
    AccordionItemHeading.prototype.componentDidUpdate = function () {
        AccordionItemHeading.VALIDATE(this.ref);
    };
    AccordionItemHeading.prototype.componentDidMount = function () {
        AccordionItemHeading.VALIDATE(this.ref);
    };
    AccordionItemHeading.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "AccordionItemHeading" }, this.props, { ref: this.setRef })));
    };
    AccordionItemHeading.defaultProps = defaultProps;
    return AccordionItemHeading;
}(React.PureComponent));
exports.AccordionItemHeading = AccordionItemHeading;
var AccordionItemHeadingWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: function (itemContext) {
        var headingAttributes = itemContext.headingAttributes;
        if (props.id) {
            (0, uuid_1.assertValidHtmlId)(props.id);
        }
        return (0, jsx_runtime_1.jsx)(AccordionItemHeading, __assign({}, props, headingAttributes));
    } })); };
AccordionItemHeadingWrapper.displayName = DisplayName_1.default.AccordionItemHeading;
exports["default"] = AccordionItemHeadingWrapper;
//# sourceMappingURL=AccordionItemHeading.js.map

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var uuid_1 = __webpack_require__(62647);
var ItemContext_1 = __webpack_require__(70447);
var collapse_1 = __importDefault(__webpack_require__(39258));
var theme_1 = __webpack_require__(72265);
var style = __importStar(__webpack_require__(24918));
var tokens_1 = __webpack_require__(53126);
var AccordionItemPanel = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'accordion__panel' : _b, region = _a.region, id = _a.id, _c = _a.borderTop, borderTop = _c === void 0 ? false : _c, rest = __rest(_a, ["className", "region", "id", "borderTop"]);
    var theme = (0, theme_1.useTheme)();
    var renderChildren = function (_a) {
        var _b, _c;
        var panelAttributes = _a.panelAttributes, expanded = _a.expanded, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d;
        if (id) {
            (0, uuid_1.assertValidHtmlId)(id);
        }
        var attrs = __assign(__assign({}, panelAttributes), { 'aria-labelledby': region ? panelAttributes['aria-labelledby'] : undefined });
        var backgroundColor = ((_c = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.accordions[variant]) === null || _c === void 0 ? void 0 : _c.panelBackgroundColor) || tokens_1.colors.white;
        return ((0, jsx_runtime_1.jsx)(collapse_1.default, __assign({ visible: expanded, timeout: 5350, css: style.backgroundStyle(backgroundColor) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ "data-accordion-component": "AccordionItemPanel", className: className, css: style.panel(backgroundColor, borderTop) }, rest, attrs, { role: region ? 'region' : undefined })) })));
    };
    return (0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: renderChildren });
};
exports["default"] = AccordionItemPanel;
//# sourceMappingURL=AccordionItemPanel.js.map

/***/ }),

/***/ 46359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var React = __importStar(__webpack_require__(67294));
var ItemContext_1 = __webpack_require__(70447);
var AccordionItemState = function (_a) {
    var children = _a.children;
    var renderChildren = function (itemContext) {
        var expanded = itemContext.expanded, disabled = itemContext.disabled;
        return (0, jsx_runtime_1.jsx)(React.Fragment, { children: children({ expanded: expanded, disabled: disabled }) });
    };
    return (0, jsx_runtime_1.jsx)(ItemContext_1.Consumer, { children: renderChildren });
};
exports["default"] = AccordionItemState;
//# sourceMappingURL=AccordionItemState.js.map

/***/ }),

/***/ 70447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var React = __importStar(__webpack_require__(67294));
var AccordionContext_1 = __webpack_require__(86520);
var Context = React.createContext(null);
var Provider = function (_a) {
    var children = _a.children, uuid = _a.uuid, accordionContext = _a.accordionContext, dangerouslySetExpanded = _a.dangerouslySetExpanded;
    var toggleExpanded = function () {
        accordionContext.toggleExpanded(uuid);
    };
    var variant = accordionContext.variant;
    var renderChildren = function (accordionContext) {
        var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : accordionContext.isItemExpanded(uuid);
        var disabled = accordionContext.isItemDisabled(uuid);
        var panelAttributes = accordionContext.getPanelAttributes(uuid, dangerouslySetExpanded);
        var headingAttributes = accordionContext.getHeadingAttributes(uuid);
        var buttonAttributes = accordionContext.getButtonAttributes(uuid, dangerouslySetExpanded);
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                uuid: uuid,
                expanded: expanded,
                disabled: disabled,
                toggleExpanded: toggleExpanded,
                panelAttributes: panelAttributes,
                headingAttributes: headingAttributes,
                buttonAttributes: buttonAttributes,
                variant: variant,
            } }, { children: children })));
    };
    return (0, jsx_runtime_1.jsx)(AccordionContext_1.Consumer, { children: renderChildren });
};
var ProviderWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(AccordionContext_1.Consumer, { children: function (accordionContext) { return ((0, jsx_runtime_1.jsx)(Provider, __assign({}, props, { accordionContext: accordionContext }))); } })); };
exports.Provider = ProviderWrapper;
var Consumer = function (_a) {
    var children = _a.children;
    var renderChildren = function (container) {
        return container ? children(container) : null;
    };
    return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: renderChildren });
};
exports.Consumer = Consumer;
//# sourceMappingURL=ItemContext.js.map

/***/ }),

/***/ 94118:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var AccordionStore = /** @class */ (function () {
    function AccordionStore(_a) {
        var _b = _a.expanded, expanded = _b === void 0 ? [] : _b, _c = _a.allowMultipleExpanded, allowMultipleExpanded = _c === void 0 ? false : _c, _d = _a.allowZeroExpanded, allowZeroExpanded = _d === void 0 ? false : _d;
        var _this = this;
        this.toggleExpanded = function (uuid) {
            if (_this.isItemDisabled(uuid)) {
                return _this;
            }
            var isExpanded = _this.isItemExpanded(uuid);
            if (!isExpanded) {
                return _this.augment({
                    expanded: _this.allowMultipleExpanded ? __spreadArray(__spreadArray([], __read(_this.expanded), false), [uuid], false) : [uuid],
                });
            }
            else {
                return _this.augment({
                    expanded: _this.expanded.filter(function (expandedUuid) { return expandedUuid !== uuid; }),
                });
            }
        };
        /*
         * From the spec:
         *
         * “If the accordion panel associated with an accordion header is visible,
         * and if the accordion does not permit the panel to be collapsed, the
         * header button element has aria-disabled set to true.”
         */
        this.isItemDisabled = function (uuid) {
            var isExpanded = _this.isItemExpanded(uuid);
            var isOnlyOneExpanded = _this.expanded.length === 1;
            return Boolean(isExpanded && !_this.allowZeroExpanded && isOnlyOneExpanded);
        };
        this.isItemExpanded = function (uuid) {
            return _this.expanded.indexOf(uuid) !== -1;
        };
        this.getPanelAttributes = function (uuid, dangerouslySetExpanded) {
            var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);
            return {
                role: _this.allowMultipleExpanded ? undefined : 'region',
                'aria-hidden': _this.allowMultipleExpanded ? !expanded : undefined,
                'aria-labelledby': _this.getButtonId(uuid),
                id: _this.getPanelId(uuid),
                hidden: expanded ? undefined : true,
            };
        };
        this.getHeadingAttributes = function () {
            return {
                role: 'heading',
            };
        };
        this.getButtonAttributes = function (uuid, dangerouslySetExpanded) {
            var expanded = dangerouslySetExpanded !== null && dangerouslySetExpanded !== void 0 ? dangerouslySetExpanded : _this.isItemExpanded(uuid);
            var disabled = _this.isItemDisabled(uuid);
            return {
                id: _this.getButtonId(uuid),
                'aria-disabled': disabled,
                'aria-expanded': expanded,
                'aria-controls': _this.getPanelId(uuid),
                role: 'button',
                tabIndex: 0,
            };
        };
        this.getPanelId = function (uuid) { return "accordion__panel-".concat(uuid); };
        this.getButtonId = function (uuid) { return "accordion__heading-".concat(uuid); };
        this.augment = function (args) {
            return new AccordionStore(__assign({ expanded: _this.expanded, allowMultipleExpanded: _this.allowMultipleExpanded, allowZeroExpanded: _this.allowZeroExpanded }, args));
        };
        this.expanded = expanded;
        this.allowMultipleExpanded = allowMultipleExpanded;
        this.allowZeroExpanded = allowZeroExpanded;
    }
    return AccordionStore;
}());
exports["default"] = AccordionStore;
//# sourceMappingURL=AccordionStore.js.map

/***/ }),

/***/ 60228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var DisplayName;
(function (DisplayName) {
    DisplayName["Accordion"] = "PrezzeeAccordion";
    DisplayName["AccordionItem"] = "PrezzeeAccordionItem";
    DisplayName["AccordionItemButton"] = "PrezzeeAccordionItemButton";
    DisplayName["AccordionItemHeading"] = "PrezzeeAccordionItemHeading";
    DisplayName["AccordionItemPanel"] = "PrezzeeAccordionItemPanel";
})(DisplayName || (DisplayName = {}));
exports["default"] = DisplayName;
//# sourceMappingURL=DisplayName.js.map

/***/ }),

/***/ 19724:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.focusPreviousSiblingOf = exports.focusNextSiblingOf = exports.focusLastSiblingOf = exports.focusFirstSiblingOf = exports.getSiblingButtons = exports.getClosestAccordion = void 0;
function getClosestAccordion(el) {
    return (el &&
        (el.matches('[data-accordion-component="Accordion"]')
            ? el
            : getClosestAccordion(el.parentElement)));
}
exports.getClosestAccordion = getClosestAccordion;
function getSiblingButtons(item) {
    var parentAccordion = getClosestAccordion(item);
    return (parentAccordion &&
        Array.from(parentAccordion.querySelectorAll('[data-accordion-component="AccordionItemButton"]')));
}
exports.getSiblingButtons = getSiblingButtons;
function focusFirstSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var first = siblings[0];
    if (first) {
        first.focus();
    }
}
exports.focusFirstSiblingOf = focusFirstSiblingOf;
function focusLastSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var last = siblings[siblings.length - 1];
    if (last) {
        last.focus();
    }
}
exports.focusLastSiblingOf = focusLastSiblingOf;
function focusNextSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var currentIndex = siblings.indexOf(item);
    if (currentIndex !== -1) {
        var next = siblings[currentIndex + 1];
        if (next) {
            next.focus();
        }
    }
}
exports.focusNextSiblingOf = focusNextSiblingOf;
function focusPreviousSiblingOf(item) {
    var siblings = getSiblingButtons(item) || [];
    var currentIndex = siblings.indexOf(item);
    if (currentIndex !== -1) {
        var previous = siblings[currentIndex - 1];
        if (previous) {
            previous.focus();
        }
    }
}
exports.focusPreviousSiblingOf = focusPreviousSiblingOf;
//# sourceMappingURL=focus.js.map

/***/ }),

/***/ 76662:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var keycodes = {
    END: 'End',
    ENTER: 'Enter',
    HOME: 'Home',
    SPACE: ' ',
    SPACE_DEPRECATED: 'Spacebar',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
};
exports["default"] = keycodes;
//# sourceMappingURL=keycodes.js.map

/***/ }),

/***/ 62647:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assertValidHtmlId = void 0;
// HTML5 ids allow all unicode characters, except for ASCII whitespaces
// https://infra.spec.whatwg.org/#ascii-whitespace
// eslint-disable-next-line no-control-regex
var idRegex = /[\u0009\u000a\u000c\u000d\u0020]/g;
function assertValidHtmlId(htmlId) {
    if (htmlId === '' || idRegex.test(htmlId)) {
        console.error("uuid must be a valid HTML5 id but was given \"".concat(htmlId, "\", ASCII whitespaces are forbidden"));
        return false;
    }
    return true;
}
exports.assertValidHtmlId = assertValidHtmlId;
//# sourceMappingURL=uuid.js.map

/***/ }),

/***/ 14327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AccordionItemState = exports.AccordionItemPanel = exports.AccordionItemHeading = exports.AccordionItemButton = exports.AccordionItem = exports.Accordion = void 0;
var Accordion_1 = __webpack_require__(68989);
Object.defineProperty(exports, "Accordion", ({ enumerable: true, get: function () { return __importDefault(Accordion_1).default; } }));
var AccordionItem_1 = __webpack_require__(4006);
Object.defineProperty(exports, "AccordionItem", ({ enumerable: true, get: function () { return __importDefault(AccordionItem_1).default; } }));
var AccordionItemButton_1 = __webpack_require__(32450);
Object.defineProperty(exports, "AccordionItemButton", ({ enumerable: true, get: function () { return __importDefault(AccordionItemButton_1).default; } }));
var AccordionItemHeading_1 = __webpack_require__(33302);
Object.defineProperty(exports, "AccordionItemHeading", ({ enumerable: true, get: function () { return __importDefault(AccordionItemHeading_1).default; } }));
var AccordionItemPanel_1 = __webpack_require__(45509);
Object.defineProperty(exports, "AccordionItemPanel", ({ enumerable: true, get: function () { return __importDefault(AccordionItemPanel_1).default; } }));
var AccordionItemState_1 = __webpack_require__(46359);
Object.defineProperty(exports, "AccordionItemState", ({ enumerable: true, get: function () { return __importDefault(AccordionItemState_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72163:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var AlertContext_1 = __webpack_require__(74914);
var style = __importStar(__webpack_require__(94985));
var Alert = function (props) {
    var children = props.children, _a = props.color, color = _a === void 0 ? 'blue' : _a, _b = props.className, className = _b === void 0 ? 'alert' : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.size, size = _d === void 0 ? 'small' : _d, _e = props.variant, variant = _e === void 0 ? 'light' : _e, _f = props.hidden, hidden = _f === void 0 ? false : _f, _g = props.status, status = _g === void 0 ? 'info' : _g, _h = props.boxShadow, boxShadow = _h === void 0 ? false : _h;
    var propStyles = [
        style.fullWidth(fullWidth),
        size && style.size(size),
        boxShadow && style.boxShadow,
        color && variant && style.variantStyle(color, variant),
        hidden ? style.hiddenStyle : style.visibleStyle,
    ];
    return ((0, jsx_runtime_1.jsx)(AlertContext_1.Provider, __assign({ variant: variant, color: color, size: size, status: status }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ css: __spreadArray([style.base], __read(propStyles), false), className: className }, { children: children })) })));
};
exports["default"] = Alert;
//# sourceMappingURL=Alert.js.map

/***/ }),

/***/ 94985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hiddenStyle = exports.visibleStyle = exports.closeButton = exports.variantStyle = exports.base = exports.boxShadow = exports.darkVariant = exports.lightVariant = exports.fullWidth = exports.size = exports.baseDescription = exports.baseTitle = exports.textColorStyle = exports.textContainer = exports.iconStyle = exports.baseIcon = exports.textStyles = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var sizeStyles = {
    small: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), tokens_1.spacing.spacing03),
    large: (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), tokens_1.spacing.spacing04),
};
var colorStyles = {
    light: {
        red: {
            text: tokens_1.colors.red600,
            background: tokens_1.colors.red50,
            icon: tokens_1.colors.red400,
            border: tokens_1.colors.red400,
        },
        green: {
            text: tokens_1.colors.green600,
            background: tokens_1.colors.green50,
            icon: tokens_1.colors.green400,
            border: tokens_1.colors.green400,
        },
        blue: {
            text: tokens_1.colors.blue600,
            background: tokens_1.colors.blue50,
            icon: tokens_1.colors.notificationBlue,
            border: tokens_1.colors.notificationBlue,
        },
        yellow: {
            text: tokens_1.colors.yellow700,
            background: tokens_1.colors.yellow50,
            icon: tokens_1.colors.yellow500,
            border: tokens_1.colors.yellow400,
        },
        purple: {
            text: tokens_1.colors.purple600,
            icon: tokens_1.colors.purple500,
            background: tokens_1.colors.purple50,
            border: tokens_1.colors.purple400,
        },
    },
    dark: {
        red: {
            background: tokens_1.colors.red500,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        green: {
            background: tokens_1.colors.green600,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        blue: {
            background: tokens_1.colors.blue500,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        purple: {
            background: tokens_1.colors.purple400,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
        yellow: {
            background: tokens_1.colors.yellow600,
            text: tokens_1.colors.white,
            icon: tokens_1.colors.white,
        },
    },
};
exports.textStyles = {
    small: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), tokens_1.spacing.spacing035, tokens_1.spacing.spacing06),
    large: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    line-height: ", ";\n  "], ["\n    font-size: ", ";\n    line-height: ", ";\n  "])), tokens_1.spacing.spacing04, tokens_1.spacing.spacing06),
};
exports.baseIcon = (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  svg {\n    width: ", ";\n    height: ", ";\n    margin-top: 3px; // Vertically centering\n  }\n"], ["\n  svg {\n    width: ", ";\n    height: ", ";\n    margin-top: 3px; // Vertically centering\n  }\n"])), tokens_1.spacing.spacing05, tokens_1.spacing.spacing05);
var iconStyle = function (variant, color) {
    var theme = colorStyles[variant][color];
    return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    svg {\n      color: ", ";\n    }\n  "], ["\n    svg {\n      color: ", ";\n    }\n  "])), theme.icon);
};
exports.iconStyle = iconStyle;
exports.textContainer = (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  padding-left: ", ";\n"])), tokens_1.spacing.spacing03);
var textColorStyle = function (variant, color) {
    var theme = colorStyles[variant][color];
    return (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.text);
};
exports.textColorStyle = textColorStyle;
exports.baseTitle = (0, react_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-weight: 600;\n  margin-right: ", ";\n"], ["\n  font-weight: 600;\n  margin-right: ", ";\n"])), tokens_1.spacing.spacing03);
var baseDescription = function (variant) { return (0, react_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-weight: 400;\n  margin-top: ", ";\n  margin-right: ", ";\n  ", ";\n"], ["\n  font-weight: 400;\n  margin-top: ", ";\n  margin-right: ", ";\n  ", ";\n"])), tokens_1.spacing.spacing03, tokens_1.spacing.spacing03, variant === 'dark' ? "color: white" : "color: ".concat(tokens_1.colors.gray800)); };
exports.baseDescription = baseDescription;
var size = function (size) { return sizeStyles[size]; };
exports.size = size;
var fullWidth = function (fullWidth) {
    var width = fullWidth ? '100%' : 'fit-content';
    return (0, react_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), width);
};
exports.fullWidth = fullWidth;
var lightVariant = function (color) {
    var lightTheme = colorStyles.light[color];
    return (0, react_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "], ["\n    background-color: ", ";\n    border: 1px solid ", ";\n  "])), lightTheme.background, lightTheme.border);
};
exports.lightVariant = lightVariant;
var darkVariant = function (color) {
    var darkTheme = colorStyles.dark[color];
    return (0, react_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    background-color: ", ";\n    color: white;\n  "], ["\n    background-color: ", ";\n    color: white;\n  "])), darkTheme.background);
};
exports.darkVariant = darkVariant;
exports.boxShadow = (0, react_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n"], ["\n  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n"])));
exports.base = (0, react_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  display: flex;\n  border-radius: 5px;\n"], ["\n  display: flex;\n  border-radius: 5px;\n"])));
var variantStyle = function (color, variant) { return (0, react_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), variant === 'dark' && (0, exports.darkVariant)(color), variant === 'light' && (0, exports.lightVariant)(color)); };
exports.variantStyle = variantStyle;
var closeButton = function (variant) {
    var buttonColor = variant === 'light' ? tokens_1.colors.gray800 : tokens_1.colors.white;
    return (0, react_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 20px;\n    height: 20px;\n    position: relative;\n    margin-top: 3px; // Helps with centering\n    margin-left: auto;\n\n    :hover {\n      cursor: pointer;\n      opacity: 0.7;\n      transition: opacity 0s 0.3s, opacity 0.3s linear;\n    }\n\n    :after {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(45deg);\n      left: 10px;\n    }\n\n    :before {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(-45deg);\n      left: 10px;\n    }\n  "], ["\n    width: 20px;\n    height: 20px;\n    position: relative;\n    margin-top: 3px; // Helps with centering\n    margin-left: auto;\n\n    :hover {\n      cursor: pointer;\n      opacity: 0.7;\n      transition: opacity 0s 0.3s, opacity 0.3s linear;\n    }\n\n    :after {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(45deg);\n      left: 10px;\n    }\n\n    :before {\n      content: '';\n      height: 20px;\n      border-left: 2px solid ", ";\n      position: absolute;\n      transform: rotate(-45deg);\n      left: 10px;\n    }\n  "])), buttonColor, buttonColor);
};
exports.closeButton = closeButton;
exports.visibleStyle = (0, react_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  visibility: visible;\n  opacity: 1;\n"], ["\n  visibility: visible;\n  opacity: 1;\n"])));
exports.hiddenStyle = (0, react_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s 0.3s, opacity 0.3s linear;\n"], ["\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s 0.3s, opacity 0.3s linear;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;
//# sourceMappingURL=Alert.style.js.map

/***/ }),

/***/ 74914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consumer = exports.Provider = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var Context = (0, react_1.createContext)(null);
var Provider = /** @class */ (function (_super) {
    __extends(Provider, _super);
    function Provider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Provider.prototype.render = function () {
        var _a = this.props, variant = _a.variant, color = _a.color, size = _a.size, status = _a.status;
        return ((0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: {
                variant: variant,
                color: color,
                size: size,
                status: status
            } }, { children: this.props.children || null })));
    };
    Provider.defaultProps = {
        variant: 'light',
        color: 'blue',
        size: 'large',
        status: 'info'
    };
    return Provider;
}(react_1.PureComponent));
exports.Provider = Provider;
var Consumer = /** @class */ (function (_super) {
    __extends(Consumer, _super);
    function Consumer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChildren = function (container) {
            return container ? _this.props.children(container) : null;
        };
        return _this;
    }
    Consumer.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(Context.Consumer, { children: this.renderChildren });
    };
    return Consumer;
}(react_1.PureComponent));
exports.Consumer = Consumer;
//# sourceMappingURL=AlertContext.js.map

/***/ }),

/***/ 56494:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var AlertContext_1 = __webpack_require__(74914);
var style = __importStar(__webpack_require__(94985));
var typography_1 = __importDefault(__webpack_require__(55489));
var AlertDescription = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? 'alert_description' : _b, variant = _a.variant, size = _a.size;
    var propStyles = [
        size && style.textStyles[size],
    ];
    return ((0, jsx_runtime_1.jsx)(typography_1.default, __assign({ className: className, css: __spreadArray([style.baseDescription(variant)], __read(propStyles), false) }, { children: children })));
};
var AlertDescriptionWrapper = function (props) {
    return ((0, jsx_runtime_1.jsx)(AlertContext_1.Consumer, { children: function (alertContext) {
            var variant = alertContext.variant, size = alertContext.size;
            return ((0, jsx_runtime_1.jsx)(AlertDescription, __assign({ variant: variant, size: size }, props)));
        } }));
};
exports["default"] = AlertDescriptionWrapper;
//# sourceMappingURL=AlertDescription.js.map

/***/ }),

/***/ 45371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var AlertContext_1 = __webpack_require__(74914);
var style = __importStar(__webpack_require__(94985));
var iconSvgs = {
    info: ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 0.125C4.28516 0.125 0.5 3.94336 0.5 8.625C0.5 13.3398 4.28516 17.125 9 17.125C13.6816 17.125 17.5 13.3398 17.5 8.625C17.5 3.94336 13.6816 0.125 9 0.125ZM9 15.5312C5.18164 15.5312 2.09375 12.4434 2.09375 8.625C2.09375 4.83984 5.18164 1.71875 9 1.71875C12.7852 1.71875 15.9062 4.83984 15.9062 8.625C15.9062 12.4434 12.7852 15.5312 9 15.5312ZM10.3281 11.2812H9.79688V8.35938C9.79688 7.92773 9.43164 7.5625 9 7.5625H7.9375C7.47266 7.5625 7.14062 7.92773 7.14062 8.35938C7.14062 8.82422 7.47266 9.15625 7.9375 9.15625H8.20312V11.2812H7.67188C7.20703 11.2812 6.875 11.6465 6.875 12.0781C6.875 12.543 7.20703 12.875 7.67188 12.875H10.3281C10.7598 12.875 11.125 12.543 11.125 12.0781C11.125 11.6465 10.7598 11.2812 10.3281 11.2812ZM9 6.5C9.56445 6.5 10.0625 6.03516 10.0625 5.4375C10.0625 4.87305 9.56445 4.375 9 4.375C8.40234 4.375 7.9375 4.87305 7.9375 5.4375C7.9375 6.03516 8.40234 6.5 9 6.5Z", fill: "currentColor" }) }))),
    success: ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8.56836 11.4141C8.20312 11.7793 7.63867 11.7793 7.27344 11.4141L5.14844 9.28906C4.7832 8.92383 4.7832 8.35938 5.14844 7.99414C5.51367 7.62891 6.07812 7.62891 6.44336 7.99414L7.9375 9.45508L11.5234 5.86914C11.8887 5.50391 12.4531 5.50391 12.8184 5.86914C13.1836 6.23438 13.1836 6.79883 12.8184 7.16406L8.56836 11.4141ZM17.5 8.625C17.5 13.3398 13.6816 17.125 9 17.125C4.28516 17.125 0.5 13.3398 0.5 8.625C0.5 3.94336 4.28516 0.125 9 0.125C13.6816 0.125 17.5 3.94336 17.5 8.625ZM9 1.71875C5.18164 1.71875 2.09375 4.83984 2.09375 8.625C2.09375 12.4434 5.18164 15.5312 9 15.5312C12.7852 15.5312 15.9062 12.4434 15.9062 8.625C15.9062 4.83984 12.7852 1.71875 9 1.71875Z", fill: "currentColor" }) }))),
    error: ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.6562 5.93555C11.3242 5.63672 10.8262 5.63672 10.5273 5.93555L9 7.5293L7.40625 5.93555C7.07422 5.63672 6.57617 5.63672 6.27734 5.93555C5.94531 6.26758 5.94531 6.76562 6.27734 7.06445L7.83789 8.625L6.31055 10.1855C5.97852 10.5176 5.97852 11.0156 6.31055 11.3145C6.60938 11.6465 7.10742 11.6465 7.40625 11.3145L9 9.75391L10.5605 11.3145C10.8594 11.6465 11.3574 11.6465 11.6562 11.3145C11.9883 11.0156 11.9883 10.5176 11.6562 10.1855L10.0957 8.625L11.6562 7.06445C11.9883 6.76562 11.9883 6.26758 11.6562 5.93555ZM9 0.125C4.28516 0.125 0.5 3.94336 0.5 8.625C0.5 13.3398 4.28516 17.125 9 17.125C13.6816 17.125 17.5 13.3398 17.5 8.625C17.5 3.94336 13.6816 0.125 9 0.125ZM9 15.5312C5.18164 15.5312 2.09375 12.4434 2.09375 8.625C2.09375 4.83984 5.18164 1.71875 9 1.71875C12.7852 1.71875 15.9062 4.83984 15.9062 8.625C15.9062 12.4434 12.7852 15.5312 9 15.5312Z", fill: "currentColor" }) }))),
    warning: ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M9 0.125C4.28516 0.125 0.5 3.94336 0.5 8.625C0.5 13.3398 4.28516 17.125 9 17.125C13.6816 17.125 17.5 13.3398 17.5 8.625C17.5 3.94336 13.6816 0.125 9 0.125ZM9 15.5312C5.18164 15.5312 2.09375 12.4434 2.09375 8.625C2.09375 4.83984 5.18164 1.71875 9 1.71875C12.7852 1.71875 15.9062 4.83984 15.9062 8.625C15.9062 12.4434 12.7852 15.5312 9 15.5312ZM9 10.2188C9.43164 10.2188 9.79688 9.88672 9.79688 9.42188V5.17188C9.79688 4.74023 9.43164 4.375 9 4.375C8.53516 4.375 8.20312 4.74023 8.20312 5.17188V9.42188C8.20312 9.88672 8.53516 10.2188 9 10.2188ZM9 11.3477C8.40234 11.3477 7.9375 11.8125 7.9375 12.377C7.9375 12.9414 8.40234 13.4062 9 13.4062C9.56445 13.4062 10.0293 12.9414 10.0293 12.377C10.0293 11.8125 9.56445 11.3477 9 11.3477Z", fill: "currentColor" }) }))),
};
var AlertIcon = function (_a) {
    var color = _a.color, variant = _a.variant, _b = _a.className, className = _b === void 0 ? 'alert_icon' : _b, _c = _a.status, status = _c === void 0 ? 'info' : _c;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: className, css: [style.baseIcon, style.iconStyle(variant, color)] }, { children: iconSvgs[status] })));
};
var AlertIconWrapper = function () { return ((0, jsx_runtime_1.jsx)(AlertContext_1.Consumer, { children: function (alertContext) {
        var color = alertContext.color, variant = alertContext.variant, status = alertContext.status;
        return (0, jsx_runtime_1.jsx)(AlertIcon, { color: color, variant: variant, status: status });
    } })); };
exports["default"] = AlertIconWrapper;
//# sourceMappingURL=AlertIcon.js.map

/***/ }),

/***/ 44386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var style = __importStar(__webpack_require__(94985));
var AlertTextContainer = function (_a) {
    var _b = _a.className, className = _b === void 0 ? 'alert_container' : _b, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: className, css: style.textContainer }, { children: children })));
};
exports["default"] = AlertTextContainer;
//# sourceMappingURL=AlertTextContainer.js.map

/***/ }),

/***/ 85335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var AlertContext_1 = __webpack_require__(74914);
var style = __importStar(__webpack_require__(94985));
var typography_1 = __importDefault(__webpack_require__(55489));
var AlertTitle = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? 'alert_title' : _b, color = _a.color, variant = _a.variant, size = _a.size;
    var propStyles = [
        size && style.textStyles[size],
        color && variant && style.textColorStyle(variant, color),
    ];
    return ((0, jsx_runtime_1.jsx)(typography_1.default, __assign({ className: className, css: __spreadArray([style.baseTitle], __read(propStyles), false) }, { children: children })));
};
var AlertTitleWrapper = function (props) {
    return ((0, jsx_runtime_1.jsx)(AlertContext_1.Consumer, { children: function (alertContext) {
            var color = alertContext.color, variant = alertContext.variant, size = alertContext.size;
            return ((0, jsx_runtime_1.jsx)(AlertTitle, __assign({ color: color, variant: variant, size: size }, props)));
        } }));
};
exports["default"] = AlertTitleWrapper;
//# sourceMappingURL=AlertTitle.js.map

/***/ }),

/***/ 62637:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var style = __importStar(__webpack_require__(94985));
var AlertContext_1 = __webpack_require__(74914);
var CloseButton = function (_a) {
    var onClick = _a.onClick, variant = _a.variant;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.closeButton(variant), onClick: onClick, width: "12", height: "12", viewBox: "0 0 12 12", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M11.0469 9.57617C11.3457 9.9082 11.3457 10.4062 11.0469 10.7051C10.7148 11.0371 10.2168 11.0371 9.91797 10.7051L6 6.75391L2.04883 10.7051C1.7168 11.0371 1.21875 11.0371 0.919922 10.7051C0.587891 10.4062 0.587891 9.9082 0.919922 9.57617L4.87109 5.625L0.919922 1.67383C0.587891 1.3418 0.587891 0.84375 0.919922 0.544922C1.21875 0.212891 1.7168 0.212891 2.01562 0.544922L6 4.5293L9.95117 0.578125C10.25 0.246094 10.748 0.246094 11.0469 0.578125C11.3789 0.876953 11.3789 1.375 11.0469 1.70703L7.0957 5.625L11.0469 9.57617Z", fill: "currentColor" }) })));
};
var CloseButtonWrapper = function (props) { return ((0, jsx_runtime_1.jsx)(AlertContext_1.Consumer, { children: function (alertContext) {
        var variant = alertContext.variant;
        return (0, jsx_runtime_1.jsx)(CloseButton, __assign({ variant: variant }, props));
    } })); };
exports["default"] = CloseButtonWrapper;
//# sourceMappingURL=CloseButton.js.map

/***/ }),

/***/ 33722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CloseButton = exports.AlertDescription = exports.AlertTitle = exports.AlertTextContainer = exports.AlertIcon = exports.Alert = void 0;
var Alert_1 = __webpack_require__(72163);
Object.defineProperty(exports, "Alert", ({ enumerable: true, get: function () { return __importDefault(Alert_1).default; } }));
var AlertIcon_1 = __webpack_require__(45371);
Object.defineProperty(exports, "AlertIcon", ({ enumerable: true, get: function () { return __importDefault(AlertIcon_1).default; } }));
var AlertTextContainer_1 = __webpack_require__(44386);
Object.defineProperty(exports, "AlertTextContainer", ({ enumerable: true, get: function () { return __importDefault(AlertTextContainer_1).default; } }));
var AlertTitle_1 = __webpack_require__(85335);
Object.defineProperty(exports, "AlertTitle", ({ enumerable: true, get: function () { return __importDefault(AlertTitle_1).default; } }));
var AlertDescription_1 = __webpack_require__(56494);
Object.defineProperty(exports, "AlertDescription", ({ enumerable: true, get: function () { return __importDefault(AlertDescription_1).default; } }));
var CloseButton_1 = __webpack_require__(62637);
Object.defineProperty(exports, "CloseButton", ({ enumerable: true, get: function () { return __importDefault(CloseButton_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 78466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var fade_1 = __importDefault(__webpack_require__(77216));
var Backdrop_style_1 = __importDefault(__webpack_require__(36334));
var Backdrop = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, _a = props.invisible, invisible = _a === void 0 ? false : _a, open = props.open, transitionDuration = props.transitionDuration, _b = props.TransitionComponent, TransitionComponent = _b === void 0 ? fade_1.default : _b, rest = __rest(props, ["children", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
    return ((0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ in: open, timeout: transitionDuration }, rest, { children: (0, jsx_runtime_1.jsx)("div", __assign({ css: (0, Backdrop_style_1.default)(invisible), "aria-hidden": true, className: className, ref: ref }, { children: children })) })));
});
exports["default"] = Backdrop;
//# sourceMappingURL=Backdrop.js.map

/***/ }),

/***/ 36334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
exports["default"] = (function (invisible) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  align-tems: center;\n  justify-content: center;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  -webkit-tap-highlight-color: transparent;\n"], ["\n  position: fixed;\n  display: flex;\n  align-tems: center;\n  justify-content: center;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: ", ";\n  -webkit-tap-highlight-color: transparent;\n"])), invisible ? 'transparent' : 'rgba(0, 0, 0, 0.5)'); });
var templateObject_1;
//# sourceMappingURL=Backdrop.style.js.map

/***/ }),

/***/ 75338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Backdrop_1 = __webpack_require__(78466);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Backdrop_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 25743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var clsx_1 = __importDefault(__webpack_require__(86010));
var utils_1 = __webpack_require__(48247);
var style = __importStar(__webpack_require__(21139));
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
var ButtonBase = (0, react_1.forwardRef)(function (props, ref) {
    var action = props.action, children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'button' : _a, 
    // @ts-ignore
    css = props.css, _b = props.disabled, disabled = _b === void 0 ? false : _b, focusVisibleClassName = props.focusVisibleClassName, _c = props.LinkComponent, LinkComponent = _c === void 0 ? 'a' : _c, onBlur = props.onBlur, onClick = props.onClick, onContextMenu = props.onContextMenu, onDragLeave = props.onDragLeave, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, _d = props.tabIndex, tabIndex = _d === void 0 ? 0 : _d, type = props.type, other = __rest(props, ["action", "children", "className", "component", "css", "disabled", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "type"]);
    var buttonRef = (0, react_1.useRef)(null);
    var _e = (0, utils_1.useIsFocusVisible)(), isFocusVisibleRef = _e.isFocusVisibleRef, handleFocusVisible = _e.onFocus, handleBlurVisible = _e.onBlur, focusVisibleRef = _e.ref;
    var _f = __read((0, react_1.useState)(false), 2), focusVisible = _f[0], setFocusVisible = _f[1];
    if (disabled && focusVisible) {
        setFocusVisible(false);
    }
    (0, react_1.useImperativeHandle)(action, function () { return ({
        focusVisible: function () {
            setFocusVisible(true);
            buttonRef.current.focus();
        },
    }); }, []);
    var handleMouseDown = onMouseDown;
    var handleContextMenu = onContextMenu;
    var handleDragLeave = onDragLeave;
    var handleMouseUp = onMouseUp;
    var handleMouseLeave = function (event) {
        if (focusVisible) {
            event.preventDefault();
        }
        if (onMouseLeave) {
            onMouseLeave(event);
        }
    };
    var handleTouchStart = onTouchStart;
    var handleTouchEnd = onTouchEnd;
    var handleTouchMove = onTouchMove;
    var handleBlur = function (event) {
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setFocusVisible(false);
        }
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleFocus = (0, utils_1.useEventCallback)(function (event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) {
            buttonRef.current = event.currentTarget;
        }
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) {
                onFocusVisible(event);
            }
        }
        if (onFocus) {
            onFocus(event);
        }
    });
    var isNonNativeButton = function () {
        var button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
     * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
     */
    var keydownRef = (0, react_1.useRef)(false);
    var handleKeyDown = (0, utils_1.useEventCallback)(function (event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (!keydownRef.current && focusVisible && event.key === ' ') {
            keydownRef.current = true;
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
            event.preventDefault();
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget &&
            isNonNativeButton() &&
            event.key === 'Enter' &&
            !disabled) {
            event.preventDefault();
            if (onClick) {
                onClick(event);
            }
        }
    });
    var handleKeyUp = (0, utils_1.useEventCallback)(function (event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (event.key === ' ' && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
        }
        if (onKeyUp) {
            onKeyUp(event);
        }
        // Keyboard accessibility for non interactive elements
        if (onClick &&
            event.target === event.currentTarget &&
            isNonNativeButton() &&
            event.key === ' ' &&
            !event.defaultPrevented) {
            onClick(event);
        }
    });
    var ComponentProp = component;
    // @ts-ignore
    if (ComponentProp === 'button' && (other.href || other.to)) {
        ComponentProp = LinkComponent;
    }
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    }
    else {
        // @ts-ignore
        if (!other.href && !other.to) {
            buttonProps.role = 'button';
        }
        if (disabled) {
            buttonProps['aria-disabled'] = disabled;
        }
    }
    var handleOwnRef = (0, utils_1.useForkRef)(focusVisibleRef, buttonRef);
    var handleRef = (0, utils_1.useForkRef)(ref, handleOwnRef);
    var ButtonBaseRoot = ComponentProp;
    return ((0, jsx_runtime_1.jsx)(ButtonBaseRoot, __assign({ css: [style.root, css && css], className: (0, clsx_1.default)([className, focusVisible && focusVisibleClassName && focusVisibleClassName]), onBlur: handleBlur, onClick: onClick, onContextMenu: handleContextMenu, onFocus: handleFocus, onKeyDown: handleKeyDown, onKeyUp: handleKeyUp, onMouseDown: handleMouseDown, onMouseLeave: handleMouseLeave, onMouseUp: handleMouseUp, onDragLeave: handleDragLeave, onTouchEnd: handleTouchEnd, onTouchMove: handleTouchMove, onTouchStart: handleTouchStart, ref: handleRef, tabIndex: disabled ? -1 : tabIndex, type: type }, buttonProps, other, { children: children })));
});
exports["default"] = ButtonBase;
//# sourceMappingURL=ButtonBase.js.map

/***/ }),

/***/ 21139:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.root = void 0;
var react_1 = __webpack_require__(43234);
exports.root = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  background-color: transparent; // Reset default value\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n  border: 0;\n  margin: 0; // Remove the margin in Safari\n  border-radius: 0;\n  padding: 0; // Remove the padding in Firefox\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  -moz-appearance: none; // Reset\n  -webkit-appearance: none; // Reset\n  text-decoration: none;\n  // So we take precedent over the style of a native <a /> element.\n  color: inherit;\n\n  &::-moz-focus-inner: {\n    borderstyle: none; // Remove Firefox dotted outline.\n  }\n\n  &:disabled {\n    pointer-events: none; // Disable link interactions\n    cursor: default;\n  }\n\n  @media print {\n    color-adjust: exact;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: transparent;\n  background-color: transparent; // Reset default value\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n  border: 0;\n  margin: 0; // Remove the margin in Safari\n  border-radius: 0;\n  padding: 0; // Remove the padding in Firefox\n  cursor: pointer;\n  user-select: none;\n  vertical-align: middle;\n  -moz-appearance: none; // Reset\n  -webkit-appearance: none; // Reset\n  text-decoration: none;\n  // So we take precedent over the style of a native <a /> element.\n  color: inherit;\n\n  &::-moz-focus-inner: {\n    borderstyle: none; // Remove Firefox dotted outline.\n  }\n\n  &:disabled {\n    pointer-events: none; // Disable link interactions\n    cursor: default;\n  }\n\n  @media print {\n    color-adjust: exact;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=ButtonBase.style.js.map

/***/ }),

/***/ 10071:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ButtonBase_1 = __webpack_require__(25743);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ButtonBase_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 45513:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ButtonEndIcon = exports.ButtonStartIcon = void 0;
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var tokens_1 = __webpack_require__(53126);
var style = __importStar(__webpack_require__(34809));
var theme_1 = __webpack_require__(72265);
var button_base_1 = __importDefault(__webpack_require__(10071));
var ButtonStartIcon = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ css: style.startIcon }, { children: children })));
};
exports.ButtonStartIcon = ButtonStartIcon;
var ButtonEndIcon = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ css: style.endIcon }, { children: children })));
};
exports.ButtonEndIcon = ButtonEndIcon;
var blackBtn = {
    base: tokens_1.colors.black,
    baseText: tokens_1.colors.white,
    hover: tokens_1.colors.gray500,
    hoverText: tokens_1.colors.white,
    active: tokens_1.colors.gray400,
    activeText: tokens_1.colors.white,
};
var whiteBtn = {
    base: tokens_1.colors.white,
    baseText: tokens_1.colors.black,
    hover: tokens_1.colors.gray100,
    hoverText: tokens_1.colors.black,
    active: tokens_1.colors.gray200,
    activeText: tokens_1.colors.black,
};
var variants = {
    outlined: function (color) { return style.outlined(color); },
    text: function (color) { return style.text(color); },
    contained: function (color) { return style.contained(color); },
};
var Button = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, _a = props.color, color = _a === void 0 ? 'primary' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, endIconProp = props.endIcon, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.size, size = _d === void 0 ? 'medium' : _d, _e = props.type, type = _e === void 0 ? 'button' : _e, startIconProp = props.startIcon, _f = props.variant, variant = _f === void 0 ? 'contained' : _f, rest = __rest(props, ["children", "color", "disabled", "endIcon", "fullWidth", "size", "type", "startIcon", "variant"]);
    var theme = (0, theme_1.useTheme)();
    var colors = __assign(__assign({}, theme.palette), { white: whiteBtn, black: blackBtn });
    var propStyles = [
        fullWidth && style.fullWidth,
        size && style.size(size),
        color && variant && variants[variant](colors[color]),
    ];
    var startIcon = startIconProp && (0, jsx_runtime_1.jsx)(exports.ButtonStartIcon, { children: startIconProp });
    var endIcon = endIconProp && (0, jsx_runtime_1.jsx)(exports.ButtonEndIcon, { children: endIconProp });
    return ((0, jsx_runtime_1.jsxs)(button_base_1.default, __assign({ css: __spreadArray([style.base], __read(propStyles), false), ref: ref, disabled: disabled, type: type }, rest, { children: [startIcon, children, endIcon] })));
});
Button.displayName = 'PrezzeeButton';
exports["default"] = Button;
//# sourceMappingURL=Button.js.map

/***/ }),

/***/ 34809:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.endIcon = exports.startIcon = exports.text = exports.outlined = exports.contained = exports.fullWidth = exports.size = exports.sizeStyles = exports.base = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var transitionTime = '0.125s';
exports.base = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  border: 1px solid transparent;\n  transition: color ", " ease, background-color ", " ease,\n    border-color ", " ease;\n  font-weight: 600;\n  line-height: 1.5;\n  outline: none;\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  border-radius: 4px;\n  border: 1px solid transparent;\n  transition: color ", " ease, background-color ", " ease,\n    border-color ", " ease;\n  font-weight: 600;\n  line-height: 1.5;\n  outline: none;\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), transitionTime, transitionTime, transitionTime);
exports.sizeStyles = {
    small: (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 0.4375rem ", " 0.5625rem; //adjusting for 2px font offset\n    font-size: 0.875rem;\n  "], ["\n    padding: 0.4375rem ", " 0.5625rem; //adjusting for 2px font offset\n    font-size: 0.875rem;\n  "])), tokens_1.spacing.spacing03),
    medium: (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0.4375rem ", " 0.5625rem; //adjusting for 2px font offset\n    font-size: 1rem;\n  "], ["\n    padding: 0.4375rem ", " 0.5625rem; //adjusting for 2px font offset\n    font-size: 1rem;\n  "])), tokens_1.spacing.spacing05),
    large: (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 0.6875rem ", " 0.8125rem; //adjusting for 2px font offset\n    font-size: 1rem;\n  "], ["\n    padding: 0.6875rem ", " 0.8125rem; //adjusting for 2px font offset\n    font-size: 1rem;\n  "])), tokens_1.spacing.spacing08),
};
var size = function (size) { return exports.sizeStyles[size]; };
exports.size = size;
exports.fullWidth = (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var contained = function (color) { return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n"])), color.base, color.base, color.baseText, color.hover, color.hover, color.hoverText, color.active, color.active, color.activeText, tokens_1.colors.gray300, tokens_1.colors.gray300, tokens_1.colors.white, tokens_1.colors.gray300, tokens_1.colors.gray300); };
exports.contained = contained;
var outlined = function (color) { return (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  background-color: transparent;\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  background-color: transparent;\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    &:hover,\n    &:focus {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n    }\n  }\n"])), color.base, color.base, color.base, color.base, color.baseText, color.active, color.active, color.activeText, tokens_1.colors.gray100, tokens_1.colors.gray400, tokens_1.colors.gray400, tokens_1.colors.gray100, tokens_1.colors.gray400, tokens_1.colors.gray400); };
exports.outlined = outlined;
var text = function (color) { return (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  background-color: transparent;\n  color: ", ";\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: ", ";\n  }\n"], ["\n  background-color: transparent;\n  color: ", ";\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: ", ";\n  }\n"])), color.base, tokens_1.colors.gray400); };
exports.text = text;
exports.startIcon = (0, react_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-right: ", ";\n"], ["\n  margin-right: ", ";\n"])), tokens_1.spacing.spacing015);
exports.endIcon = (0, react_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), tokens_1.spacing.spacing015);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=Button.style.js.map

/***/ }),

/***/ 76967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Button_1 = __webpack_require__(45513);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Button_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var Checkbox_style_1 = __importDefault(__webpack_require__(45704));
var Checkbox = (0, react_1.forwardRef)(function (_a, ref) {
    var checked = _a.checked, value = _a.value, children = _a.children, className = _a.className, defaultChecked = _a.defaultChecked, disabled = _a.disabled, id = _a.id, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, rest = __rest(_a, ["checked", "value", "children", "className", "defaultChecked", "disabled", "id", "label", "name", "onBlur", "onChange", "onFocus"]);
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: id, className: className, css: (0, Checkbox_style_1.default)(disabled || false) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ id: id, ref: ref, name: name, type: 'checkbox', checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: onFocus, onBlur: onBlur, value: value }, rest)), label, children] })));
});
Checkbox.displayName = 'PrezzeeCheckbox';
exports["default"] = Checkbox;
//# sourceMappingURL=Checkbox.js.map

/***/ }),

/***/ 45704:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var transitionTime = '0.125s';
var disabledStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  &:hover {\n    cursor: not-allowed;\n  }\n\n  input[type='checkbox']:hover {\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  &:hover {\n    cursor: not-allowed;\n  }\n\n  input[type='checkbox']:hover {\n    background-color: ", ";\n  }\n"])), tokens_1.colors.gray300, tokens_1.colors.white);
exports["default"] = (function (disabled) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-grid;\n  grid-template-columns: 1em auto;\n  gap: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  input[type='checkbox'] {\n    appearance: none;\n    background-color: ", ";\n    margin: 0;\n    font: inherit;\n    color: currentColor;\n    width: 18px;\n    height: 18px;\n    border: 0.15em solid ", ";\n    border-radius: 0.15em;\n    transform: translateY(-0.075em);\n    display: grid;\n    place-content: center;\n\n    :hover {\n      border: 2px solid ", ";\n    }\n\n    &::before {\n      content: '';\n      width: 0.65em;\n      height: 0.65em;\n      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n      transform: scale(0);\n      box-shadow: inset 1em 1em ", ";\n      transition: background-color ", " ease;\n      /* Windows High Contrast Mode */\n      background-color: CanvasText;\n    }\n\n    &:hover,\n    &:focus {\n      border: 2px solid ", ";\n      cursor: pointer;\n      background-color: ", ";\n    }\n\n    &:checked {\n      background-color: ", ";\n\n      &::before {\n        transform: scale(1);\n      }\n    }\n\n    &:disabled {\n      border-color: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  ", "\n"], ["\n  display: inline-grid;\n  grid-template-columns: 1em auto;\n  gap: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  input[type='checkbox'] {\n    appearance: none;\n    background-color: ", ";\n    margin: 0;\n    font: inherit;\n    color: currentColor;\n    width: 18px;\n    height: 18px;\n    border: 0.15em solid ", ";\n    border-radius: 0.15em;\n    transform: translateY(-0.075em);\n    display: grid;\n    place-content: center;\n\n    :hover {\n      border: 2px solid ", ";\n    }\n\n    &::before {\n      content: '';\n      width: 0.65em;\n      height: 0.65em;\n      clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);\n      transform: scale(0);\n      box-shadow: inset 1em 1em ", ";\n      transition: background-color ", " ease;\n      /* Windows High Contrast Mode */\n      background-color: CanvasText;\n    }\n\n    &:hover,\n    &:focus {\n      border: 2px solid ", ";\n      cursor: pointer;\n      background-color: ", ";\n    }\n\n    &:checked {\n      background-color: ", ";\n\n      &::before {\n        transform: scale(1);\n      }\n    }\n\n    &:disabled {\n      border-color: ", ";\n      cursor: not-allowed;\n    }\n  }\n\n  ", "\n"])), tokens_1.spacing.spacing03, tokens_1.colors.white, tokens_1.colors.gray600, tokens_1.colors.purple400, tokens_1.colors.white, transitionTime, tokens_1.colors.purple400, tokens_1.colors.gray100, tokens_1.colors.purple400, tokens_1.colors.gray300, disabled && disabledStyle); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=Checkbox.style.js.map

/***/ }),

/***/ 62689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Checkbox_1 = __webpack_require__(42468);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Checkbox_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 39258:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var classnames_1 = __importDefault(__webpack_require__(94184));
var react_transition_group_1 = __webpack_require__(78472);
var hooks_1 = __webpack_require__(87815);
var Collapse = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, horizontal = _a.horizontal, _b = _a.timeout, timeout = _b === void 0 ? 350 : _b, onHide = _a.onHide, onShow = _a.onShow, visible = _a.visible, rest = __rest(_a, ["children", "className", "horizontal", "timeout", "onHide", "onShow", "visible"]);
    var _c = __read((0, react_1.useState)(), 2), height = _c[0], setHeight = _c[1];
    var _d = __read((0, react_1.useState)(), 2), width = _d[0], setWidth = _d[1];
    var collapseRef = (0, react_1.useRef)(null);
    var forkedRef = (0, hooks_1.useForkedRef)(ref, collapseRef);
    var getTransitionClass = function (state) {
        return state === 'entering'
            ? 'collapsing'
            : state === 'entered'
                ? 'collapse show'
                : state === 'exiting'
                    ? 'collapsing'
                    : 'collapse';
    };
    var onEntering = function () {
        onShow && onShow();
        if (horizontal) {
            collapseRef.current && setWidth(collapseRef.current.scrollWidth);
            return;
        }
        collapseRef.current && setHeight(collapseRef.current.scrollHeight);
    };
    var onEntered = function () {
        if (horizontal) {
            setWidth(0);
            return;
        }
        setHeight(0);
    };
    var onExit = function () {
        if (horizontal) {
            collapseRef.current && setWidth(collapseRef.current.scrollWidth);
            return;
        }
        collapseRef.current && setHeight(collapseRef.current.scrollHeight);
    };
    var onExiting = function () {
        onHide && onHide();
        if (horizontal) {
            setWidth(0);
            return;
        }
        setHeight(0);
    };
    var onExited = function () {
        if (horizontal) {
            setWidth(0);
            return;
        }
        setHeight(0);
    };
    var _className = (0, classnames_1.default)({
        'collapse-horizontal': horizontal,
    }, className);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, __assign({ in: visible, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, timeout: timeout }, { children: function (state) {
            var transitionClass = getTransitionClass(state);
            var currentHeight = height === 0 ? null : { height: height };
            var currentWidth = width === 0 ? null : { width: width };
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(_className, transitionClass), style: __assign(__assign({}, currentHeight), currentWidth) }, rest, { ref: forkedRef }, { children: children })));
        } })));
});
Collapse.displayName = 'PrezzeeCollapse';
exports["default"] = Collapse;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 87815:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// problem described https://github.com/facebook/react/issues/13029
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isFunction = exports.assignRef = exports.useForkedRef = void 0;
var react_1 = __webpack_require__(67294);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useForkedRef() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return (0, react_1.useMemo)(function () {
        if (refs.every(function (ref) { return ref == null; })) {
            return null;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function (node) {
            refs.forEach(function (ref) {
                assignRef(ref, node);
            });
        };
    }, refs);
}
exports.useForkedRef = useForkedRef;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function assignRef(ref, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    if (ref == null)
        return;
    if (isFunction(ref)) {
        ref(value);
    }
    else {
        try {
            ref.current = value;
        }
        catch (error) {
            throw new Error("Cannot assign value \"".concat(value, "\" to ref \"").concat(ref, "\""));
        }
    }
}
exports.assignRef = assignRef;
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
function isFunction(value) {
    return !!(value && {}.toString.call(value) == '[object Function]');
}
exports.isFunction = isFunction;
//# sourceMappingURL=hooks.js.map

/***/ }),

/***/ 34906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Dialog = exports.InputAdornment = exports.Select = exports.TextField = exports.Typography = exports.Radio = exports.useScreenClass = exports.setConfiguration = exports.ScreenClassContext = exports.ScreenClassProvider = exports.ScreenClassRender = exports.Visible = exports.Hidden = exports.Row = exports.Container = exports.Col = exports.Collapse = exports.Checkbox = exports.Button = exports.CloseButton = exports.AlertDescription = exports.AlertTitle = exports.AlertTextContainer = exports.AlertIcon = exports.Alert = exports.AccordionItemState = exports.AccordionItemPanel = exports.AccordionItemHeading = exports.AccordionItemButton = exports.AccordionItem = exports.Accordion = void 0;
var accordion_1 = __webpack_require__(14327);
Object.defineProperty(exports, "Accordion", ({ enumerable: true, get: function () { return accordion_1.Accordion; } }));
Object.defineProperty(exports, "AccordionItem", ({ enumerable: true, get: function () { return accordion_1.AccordionItem; } }));
Object.defineProperty(exports, "AccordionItemButton", ({ enumerable: true, get: function () { return accordion_1.AccordionItemButton; } }));
Object.defineProperty(exports, "AccordionItemHeading", ({ enumerable: true, get: function () { return accordion_1.AccordionItemHeading; } }));
Object.defineProperty(exports, "AccordionItemPanel", ({ enumerable: true, get: function () { return accordion_1.AccordionItemPanel; } }));
Object.defineProperty(exports, "AccordionItemState", ({ enumerable: true, get: function () { return accordion_1.AccordionItemState; } }));
var alert_1 = __webpack_require__(33722);
Object.defineProperty(exports, "Alert", ({ enumerable: true, get: function () { return alert_1.Alert; } }));
Object.defineProperty(exports, "AlertIcon", ({ enumerable: true, get: function () { return alert_1.AlertIcon; } }));
Object.defineProperty(exports, "AlertTextContainer", ({ enumerable: true, get: function () { return alert_1.AlertTextContainer; } }));
Object.defineProperty(exports, "AlertTitle", ({ enumerable: true, get: function () { return alert_1.AlertTitle; } }));
Object.defineProperty(exports, "AlertDescription", ({ enumerable: true, get: function () { return alert_1.AlertDescription; } }));
Object.defineProperty(exports, "CloseButton", ({ enumerable: true, get: function () { return alert_1.CloseButton; } }));
var button_1 = __webpack_require__(76967);
Object.defineProperty(exports, "Button", ({ enumerable: true, get: function () { return __importDefault(button_1).default; } }));
var checkbox_1 = __webpack_require__(62689);
Object.defineProperty(exports, "Checkbox", ({ enumerable: true, get: function () { return __importDefault(checkbox_1).default; } }));
var collapse_1 = __webpack_require__(39258);
Object.defineProperty(exports, "Collapse", ({ enumerable: true, get: function () { return __importDefault(collapse_1).default; } }));
var grid_1 = __webpack_require__(40733);
Object.defineProperty(exports, "Col", ({ enumerable: true, get: function () { return grid_1.Col; } }));
Object.defineProperty(exports, "Container", ({ enumerable: true, get: function () { return grid_1.Container; } }));
Object.defineProperty(exports, "Row", ({ enumerable: true, get: function () { return grid_1.Row; } }));
Object.defineProperty(exports, "Hidden", ({ enumerable: true, get: function () { return grid_1.Hidden; } }));
Object.defineProperty(exports, "Visible", ({ enumerable: true, get: function () { return grid_1.Visible; } }));
Object.defineProperty(exports, "ScreenClassRender", ({ enumerable: true, get: function () { return grid_1.ScreenClassRender; } }));
Object.defineProperty(exports, "ScreenClassProvider", ({ enumerable: true, get: function () { return grid_1.ScreenClassProvider; } }));
Object.defineProperty(exports, "ScreenClassContext", ({ enumerable: true, get: function () { return grid_1.ScreenClassContext; } }));
Object.defineProperty(exports, "setConfiguration", ({ enumerable: true, get: function () { return grid_1.setConfiguration; } }));
Object.defineProperty(exports, "useScreenClass", ({ enumerable: true, get: function () { return grid_1.useScreenClass; } }));
var radio_1 = __webpack_require__(11834);
Object.defineProperty(exports, "Radio", ({ enumerable: true, get: function () { return __importDefault(radio_1).default; } }));
var typography_1 = __webpack_require__(55489);
Object.defineProperty(exports, "Typography", ({ enumerable: true, get: function () { return __importDefault(typography_1).default; } }));
var text_field_1 = __webpack_require__(24308);
Object.defineProperty(exports, "TextField", ({ enumerable: true, get: function () { return __importDefault(text_field_1).default; } }));
var select_1 = __webpack_require__(37318);
Object.defineProperty(exports, "Select", ({ enumerable: true, get: function () { return __importDefault(select_1).default; } }));
var input_adornment_1 = __webpack_require__(14795);
Object.defineProperty(exports, "InputAdornment", ({ enumerable: true, get: function () { return __importDefault(input_adornment_1).default; } }));
var dialog_1 = __webpack_require__(59966);
Object.defineProperty(exports, "Dialog", ({ enumerable: true, get: function () { return __importDefault(dialog_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var react_uid_1 = __webpack_require__(43412);
var modal_1 = __importDefault(__webpack_require__(97249));
var fade_1 = __importDefault(__webpack_require__(77216));
var paper_1 = __importDefault(__webpack_require__(58679));
// import Backdrop from '@prezzee/backdrop';
var DialogContext_1 = __importDefault(__webpack_require__(93401));
var theme_1 = __webpack_require__(72265);
var style = __importStar(__webpack_require__(47069));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
var Dialog = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };
    var ariaDescribedby = props["aria-describedby"], ariaLabelledbyProp = props["aria-labelledby"], 
    // BackdropComponent,
    // BackdropProps,
    children = props.children, className = props.className, _a = props.disableEscapeKeyDown, disableEscapeKeyDown = _a === void 0 ? false : _a, _b = props.fullScreen, fullScreen = _b === void 0 ? false : _b, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.maxWidth, maxWidth = _d === void 0 ? 'sm' : _d, onClose = props.onClose, open = props.open, _e = props.PaperComponent, PaperComponent = _e === void 0 ? paper_1.default : _e, _f = props.PaperProps, PaperProps = _f === void 0 ? {} : _f, _g = props.scroll, scroll = _g === void 0 ? 'paper' : _g, _h = props.TransitionComponent, TransitionComponent = _h === void 0 ? fade_1.default : _h, _j = props.transitionDuration, transitionDuration = _j === void 0 ? defaultTransitionDuration : _j, TransitionProps = props.TransitionProps, other = __rest(props, ['aria-describedby', 'aria-labelledby', "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
    var ownerState = __assign(__assign({}, props), { disableEscapeKeyDown: disableEscapeKeyDown, fullScreen: fullScreen, fullWidth: fullWidth, maxWidth: maxWidth, scroll: scroll });
    var backdropClick = (0, react_1.useRef)();
    var handleMouseDown = function (event) {
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    var handleBackdropClick = function (event) {
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) {
            return;
        }
        backdropClick.current = null;
        if (onClose) {
            onClose(event, 'backdropClick');
        }
    };
    var uid = (0, react_uid_1.useUID)();
    var ariaLabelledby = ariaLabelledbyProp || 'dialog-' + uid;
    var dialogContextValue = (0, react_1.useMemo)(function () {
        return { titleId: ariaLabelledby };
    }, [ariaLabelledby]);
    return ((0, jsx_runtime_1.jsx)(modal_1.default, __assign({ className: className, 
        // BackdropProps={{
        //   transitionDuration,
        //   // as: BackdropComponent,
        //   // ...BackdropProps,
        // }}
        closeAfterTransition: true, 
        // BackdropComponent={Backdrop}
        disableEscapeKeyDown: disableEscapeKeyDown, onClose: onClose, open: open, ref: ref, onClick: handleBackdropClick }, other, { children: (0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ appear: true, in: open, timeout: transitionDuration, role: "presentation" }, TransitionProps, { children: (0, jsx_runtime_1.jsx)("div", __assign({ onMouseDown: handleMouseDown, css: style.container(ownerState) }, { children: (0, jsx_runtime_1.jsx)(PaperComponent, __assign({ elevation: "xl", role: "dialog", "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledby }, PaperProps, { className: PaperProps.className, css: style.paper(ownerState) }, { children: (0, jsx_runtime_1.jsx)(DialogContext_1.default.Provider, __assign({ value: dialogContextValue }, { children: children })) })) })) })) })));
});
Dialog.displayName = 'PrezzeeDialog';
exports["default"] = Dialog;
//# sourceMappingURL=Dialog.js.map

/***/ }),

/***/ 47069:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paper = exports.container = void 0;
var react_1 = __webpack_require__(43234);
var container = function (state) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n\n  @media print: {\n    height: auto;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  height: 100%;\n\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n\n  @media print: {\n    height: auto;\n  }\n\n  ", "\n\n  ", "\n"])), state.scroll === 'paper' &&
    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n", state.scroll === 'body' &&
    "\n  overflow-y: auto;\n  overflow-x: hidden;\n  text-align: center;\n  \n  &:after {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    height: 100%;\n    width: 0;\n  }  \n"); };
exports.container = container;
var paper = function (state) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 20px;\n  position: relative;\n  overflow-y: auto; // Fix IE11 issue; to remove at some point.\n\n  @media print: {\n    overflow-y: visible;\n    boxshadow: none;\n  }\n\n  ", "\n\n  ", "\n\n", "\n\n", "\n\n", "\n"], ["\n  margin: 20px;\n  position: relative;\n  overflow-y: auto; // Fix IE11 issue; to remove at some point.\n\n  @media print: {\n    overflow-y: visible;\n    boxshadow: none;\n  }\n\n  ", "\n\n  ", "\n\n", "\n\n", "\n\n", "\n"])), state.scroll === 'paper' &&
    "\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100% - 64px);\n", state.scroll === 'body' &&
    "\n    display: inline-block;\n    vertical-align: middle;\n    text-align: left; // initial doesnt work on IE11\n", !state.maxWidth && 'max-width: calc(100% - 64px);', state.fullWidth &&
    "\n    width: calc(100% - 64px);\n", state.fullScreen &&
    "\n    margin: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    max-height: none;\n    border-radius: 0;\n"); };
exports.paper = paper;
var templateObject_1, templateObject_2;
// &.${dialogClasses.paperScrollBody} {
//   margin: 0;
//   maxWidth: 100%;
// };
// ...(ownerState.maxWidth === xs && {
//   maxWidth:
//     theme.breakpoints.unit === px
//       ? Math.max(theme.breakpoints.values.xs; 444)
//       : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`;
//   [`&.${dialogClasses.paperScrollBody}`]: {
//     [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs; 444) + 32 * 2)]: {
//       maxWidth: calc(100% - 64px);
//     };
//   };
// });
// ...(ownerState.maxWidth !== xs && {
//   maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`;
//   [`&.${dialogClasses.paperScrollBody}`]: {
//     [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
//       maxWidth: calc(100% - 64px);
//     };
//   };
// });
//# sourceMappingURL=Dialog.style.js.map

/***/ }),

/***/ 93401:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var DialogContext = (0, react_1.createContext)({});
if (false) {}
exports["default"] = DialogContext;
//# sourceMappingURL=DialogContext.js.map

/***/ }),

/***/ 59966:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Dialog_1 = __webpack_require__(3114);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Dialog_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var react_transition_group_1 = __webpack_require__(78472);
var theme_1 = __webpack_require__(72265);
var utils_1 = __webpack_require__(48247);
var styles = {
    entering: {
        opacity: 1,
    },
    entered: {
        opacity: 1,
    },
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Fade = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };
    var addEndListener = props.addEndListener, _a = props.appear, appear = _a === void 0 ? true : _a, children = props.children, easing = props.easing, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _b = props.timeout, timeout = _b === void 0 ? defaultTimeout : _b, refProp = props.ref, other = __rest(props, ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "ref"]);
    var enableStrictModeCompat = true;
    var nodeRef = (0, react_1.useRef)(null);
    // @ts-ignore
    var foreignRef = (0, utils_1.useForkRef)(children.ref, ref);
    var handleRef = (0, utils_1.useForkRef)(nodeRef, foreignRef);
    var normalizedTransitionCallback = function (callback) { return function (maybeIsAppearing) {
        if (callback) {
            var node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) {
                callback(node);
            }
            else {
                callback(node, maybeIsAppearing);
            }
        }
    }; };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
        (0, utils_1.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'enter',
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
        var transitionProps = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'exit',
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) {
            onExit(node);
        }
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function (next) {
        if (addEndListener && nodeRef.current) {
            // Old call signature before `react-transition-group` implemented `nodeRef`
            addEndListener(nodeRef.current, next);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, __assign({ appear: appear, in: inProp, nodeRef: enableStrictModeCompat ? nodeRef : undefined, onEnter: handleEnter, onEntered: handleEntered, onEntering: handleEntering, onExit: handleExit, onExited: handleExited, onExiting: handleExiting, addEndListener: handleAddEndListener, timeout: timeout }, other, { ref: refProp }, { children: function (state, childProps) {
            return (0, react_1.cloneElement)(children, __assign({ style: __assign(__assign(__assign({ opacity: 0, visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
        } })));
});
exports["default"] = Fade;
//# sourceMappingURL=Fade.js.map

/***/ }),

/***/ 77216:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Fade_1 = __webpack_require__(9782);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Fade_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51603:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var input_base_1 = __importDefault(__webpack_require__(10635));
var FilledInput_style_1 = __importDefault(__webpack_require__(79462));
var form_control_1 = __webpack_require__(42329);
var FilledInput = (0, react_1.forwardRef)(function (_a, ref) {
    var disableUnderline = _a.disableUnderline, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, hiddenLabel = _a.hiddenLabel, _c = _a.multiline, multiline = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'text' : _d, rest = __rest(_a, ["disableUnderline", "fullWidth", "hiddenLabel", "multiline", "type"]);
    var formControl = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)(input_base_1.default, __assign({ fullWidth: fullWidth, multiline: multiline, styles: {
            root: (0, FilledInput_style_1.default)(formControl.focused, !!formControl.error, !!(rest === null || rest === void 0 ? void 0 : rest.startAdornment), !!(rest === null || rest === void 0 ? void 0 : rest.endAdornment)),
        }, ref: ref, type: type }, rest)));
});
FilledInput.displayName = 'PrezzeeFilledInput';
exports["default"] = FilledInput;
//# sourceMappingURL=FilledInput.js.map

/***/ }),

/***/ 79462:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports["default"] = (function (grow, error, startAdornment, endAdornment) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  ", "\n  ", "\n\n  &:hover:before {\n    border-bottom-color: ", ";\n  }\n\n  &:before {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  &:after {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transform: ", ";\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  input {\n    padding: 25px 12px 8px;\n\n    ", "\n    ", "\n  }\n"], ["\n  background-color: ", ";\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  ", "\n  ", "\n\n  &:hover:before {\n    border-bottom-color: ", ";\n  }\n\n  &:before {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  &:after {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transform: ", ";\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  input {\n    padding: 25px 12px 8px;\n\n    ", "\n    ", "\n  }\n"])), tokens_1.colors.gray50, startAdornment && 'padding-left: 12px;', endAdornment && 'padding-right: 12px;', tokens_1.colors.gray600, tokens_1.colors.gray400, error ? tokens_1.colors.red400 : tokens_1.colors.blue400, grow || error ? 'scaleX(1)' : 'scaleX(0)', startAdornment && 'padding-left: 0px;', endAdornment && 'padding-right: 0px;'); });
var templateObject_1;
//# sourceMappingURL=FilledInput.style.js.map

/***/ }),

/***/ 2401:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var FilledInput_1 = __webpack_require__(51603);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(FilledInput_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2959:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var FormControl_style_1 = __importDefault(__webpack_require__(3965));
var utils_1 = __webpack_require__(48247);
var FormControlContext_1 = __importDefault(__webpack_require__(84872));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
var FormControl = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, 
    // component = 'div',
    _a = props.disabled, 
    // component = 'div',
    disabled = _a === void 0 ? false : _a, _b = props.error, error = _b === void 0 ? false : _b, visuallyFocused = props.focused, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.hiddenLabel, hiddenLabel = _d === void 0 ? false : _d, _e = props.margin, margin = _e === void 0 ? 'none' : _e, _f = props.required, required = _f === void 0 ? false : _f, _g = props.size, size = _g === void 0 ? 'medium' : _g, _h = props.variant, variant = _h === void 0 ? 'outlined' : _h, rest = __rest(props, ["children", "className", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"]);
    var inputNames = ['PrezzeeInput', 'PrezzeeOutlinedInput', 'PrezzeeFilledInput'];
    var _j = __read((0, react_1.useState)(function () {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) {
            react_1.Children.forEach(children, function (child) {
                var _a;
                if (!(0, utils_1.isPrezzeeElement)(child, __spreadArray(__spreadArray([], __read(inputNames), false), ['PrezzeeSelect'], false))) {
                    return;
                }
                // @ts-ignore
                var input = (0, utils_1.isPrezzeeElement)(child, ['PrezzeeSelect']) ? child.props.input : child;
                if (input && ((_a = input === null || input === void 0 ? void 0 : input.props) === null || _a === void 0 ? void 0 : _a.startAdornment)) {
                    initialAdornedStart = true;
                }
            });
        }
        return initialAdornedStart;
    }), 2), adornedStart = _j[0], setAdornedStart = _j[1];
    var _k = __read((0, react_1.useState)(function () {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) {
            react_1.Children.forEach(children, function (child) {
                if (!(0, utils_1.isPrezzeeElement)(child, __spreadArray(__spreadArray([], __read(inputNames), false), ['PrezzeeSelect'], false))) {
                    return;
                }
                if ((0, react_1.isValidElement)(child) && (0, utils_1.isFilled)(child === null || child === void 0 ? void 0 : child.props, true)) {
                    initialFilled = true;
                }
            });
        }
        return initialFilled;
    }), 2), filled = _k[0], setFilled = _k[1];
    var _l = __read((0, react_1.useState)(false), 2), focusedState = _l[0], setFocused = _l[1];
    if (disabled && focusedState) {
        setFocused(false);
    }
    var focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    var registerEffect;
    if (false) { var registeredInput_1; }
    var onFilled = (0, react_1.useCallback)(function () {
        setFilled(true);
    }, []);
    var onEmpty = (0, react_1.useCallback)(function () {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        // color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        size: size,
        onBlur: function () {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function () {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant,
    };
    var FormControlRoot = 'div';
    return ((0, jsx_runtime_1.jsx)(FormControlContext_1.default.Provider, __assign({ value: childContext }, { children: (0, jsx_runtime_1.jsx)(FormControlRoot, __assign({ css: (0, FormControl_style_1.default)(fullWidth), className: className, ref: ref }, rest, { children: children })) })));
});
exports["default"] = FormControl;
//# sourceMappingURL=FormControl.js.map

/***/ }),

/***/ 3965:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
exports["default"] = (function (fullWidth) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  min-width: 0px;\n  padding: 0px;\n  margin: 0px;\n  border: 0px;\n  vertical-align: top;\n  ", ";\n"], ["\n  display: inline-flex;\n  flex-direction: column;\n  position: relative;\n  min-width: 0px;\n  padding: 0px;\n  margin: 0px;\n  border: 0px;\n  vertical-align: top;\n  ", ";\n"])), fullWidth && 'width: 100%'); });
var templateObject_1;
//# sourceMappingURL=FormControl.style.js.map

/***/ }),

/***/ 84872:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var FormControlContext = (0, react_1.createContext)({});
FormControlContext.displayName = 'PrezzeeFormControlContext';
exports["default"] = FormControlContext;
//# sourceMappingURL=FormControlContext.js.map

/***/ }),

/***/ 42329:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useFormControl = exports.FormControlContext = exports["default"] = void 0;
var FormControl_1 = __webpack_require__(2959);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(FormControl_1).default; } }));
var FormControlContext_1 = __webpack_require__(84872);
Object.defineProperty(exports, "FormControlContext", ({ enumerable: true, get: function () { return __importDefault(FormControlContext_1).default; } }));
var useFormControl_1 = __webpack_require__(78997);
Object.defineProperty(exports, "useFormControl", ({ enumerable: true, get: function () { return __importDefault(useFormControl_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 78997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var FormControlContext_1 = __importDefault(__webpack_require__(84872));
function useFormControl() {
    return (0, react_1.useContext)(FormControlContext_1.default);
}
exports["default"] = useFormControl;
//# sourceMappingURL=useFormControl.js.map

/***/ }),

/***/ 62152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var form_control_1 = __webpack_require__(42329);
var FormHelperText_style_1 = __importDefault(__webpack_require__(65992));
var FormHelperText = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var formControl = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)("p", __assign({ css: (0, FormHelperText_style_1.default)(formControl.variant, formControl.error) }, rest, { children: children })));
};
FormHelperText.displayName = 'PrezzeeFormHelperText';
exports["default"] = FormHelperText;
//# sourceMappingURL=FormHelperText.js.map

/***/ }),

/***/ 65992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports["default"] = (function (variant, error) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  letter-spacing: 0.03333em;\n  text-align: left;\n\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  color: ", ";\n  font-weight: 400;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  letter-spacing: 0.03333em;\n  text-align: left;\n\n  ", ";\n  ", ";\n  ", ";\n"])), error ? tokens_1.colors.red400 : tokens_1.colors.gray600, variant === 'filled' && 'margin: 3px 12px 0px', variant === 'outlined' && 'margin: 0.25rem 0 0', variant === 'standard' && 'margin: 3px 0px 0px'); });
var templateObject_1;
//# sourceMappingURL=FormHelperText.style.js.map

/***/ }),

/***/ 41011:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var FormHelperText_1 = __webpack_require__(62152);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(FormHelperText_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var react_1 = __webpack_require__(43234);
var Row_1 = __webpack_require__(10850);
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var config_1 = __webpack_require__(85731);
var style_1 = __importDefault(__webpack_require__(84710));
var Col = function (_a) {
    var xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, 
    // xxl,
    offset = _a.offset, pull = _a.pull, push = _a.push, _b = _a.component, component = _b === void 0 ? 'div' : _b, children = _a.children, width = _a.width, rest = __rest(_a, ["xs", "sm", "md", "lg", "xl", "offset", "pull", "push", "component", "children", "width"]);
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) { return ((0, jsx_runtime_1.jsx)(Row_1.GutterWidthContext.Consumer, { children: function (gutterWidth) {
                return (0, react_1.jsx)(component, __assign({ css: (0, style_1.default)({
                        forceWidth: width,
                        width: {
                            xs: xs,
                            sm: sm,
                            md: md,
                            lg: lg,
                            xl: xl,
                            // xxl,
                        },
                        offset: offset,
                        pull: pull,
                        push: push,
                        screenClass: screenClass,
                        gutterWidth: gutterWidth,
                        gridColumns: (0, config_1.getConfiguration)().gridColumns,
                    }) }, rest), children);
            } })); } }));
};
exports["default"] = Col;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 84710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(81490);
var hasWidth = function (widths) {
    return Object.keys(widths).reduce(function (acc, cur) { return acc || widths[cur]; }, false);
};
var getWidth = function (width, gridColumns) {
    if (typeof width !== 'number')
        return undefined;
    var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
    return "".concat((100 / gridColumns) * normalizedWidth, "%");
};
exports["default"] = (function (_a) {
    var _b = _a.forceWidth, forceWidth = _b === void 0 ? undefined : _b, width = _a.width, _c = _a.offset, offset = _c === void 0 ? {} : _c, _d = _a.pull, pull = _d === void 0 ? {} : _d, _e = _a.push, push = _e === void 0 ? {} : _e, screenClass = _a.screenClass, gutterWidth = _a.gutterWidth, gridColumns = _a.gridColumns;
    var styles = {
        boxSizing: 'border-box',
        minHeight: 1,
        position: 'relative',
        paddingLeft: gutterWidth / 2,
        paddingRight: gutterWidth / 2,
        width: '100%',
    };
    styles.flexBasis = '100%';
    styles.flexGrow = 0;
    styles.flexShrink = 0;
    styles.maxWidth = '100%';
    styles.marginLeft = '0%';
    styles.right = 'auto';
    styles.left = 'auto';
    utils_1.screenClasses.forEach(function (s, index) {
        var size = s;
        if (utils_1.screenClasses.indexOf(screenClass) >= index) {
            var currentWidth = getWidth(width[size], gridColumns);
            var isSizedToContent = width[size] === 'content';
            styles.flexBasis = isSizedToContent ? 'auto' : currentWidth || styles.flexBasis;
            styles.width = styles.flexBasis;
            styles.maxWidth = currentWidth || styles.maxWidth;
            styles.marginLeft = getWidth(offset[size], gridColumns) || styles.marginLeft;
            styles.right = getWidth(pull[size], gridColumns) || styles.right;
            styles.left = getWidth(push[size], gridColumns) || styles.left;
        }
    });
    if (!hasWidth(width)) {
        styles.flexBasis = 0;
        styles.flexGrow = 1;
    }
    if (forceWidth) {
        styles.flexBasis = 'unset';
        styles.flexGrow = 'unset';
        styles.flexShrink = 'unset';
        styles.width = forceWidth;
    }
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map

/***/ }),

/***/ 71783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var react_1 = __webpack_require__(43234);
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var style_1 = __importDefault(__webpack_require__(27171));
var config_1 = __webpack_require__(85731);
var Container = function (_a) {
    var fluid = _a.fluid, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, 
    // xxl,
    _b = _a.component, 
    // xxl,
    component = _b === void 0 ? 'div' : _b, children = _a.children, rest = __rest(_a, ["fluid", "xs", "sm", "md", "lg", "xl", "component", "children"]);
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            return (0, react_1.jsx)(component, __assign({ css: (0, style_1.default)({
                    fluid: fluid,
                    xs: xs,
                    sm: sm,
                    md: md,
                    lg: lg,
                    xl: xl,
                    // xxl,
                    screenClass: screenClass,
                    containerWidths: (0, config_1.getConfiguration)().containerWidths,
                    marginWidths: (0, config_1.getConfiguration)().marginWidths,
                }) }, rest), children);
        } }));
};
exports["default"] = Container;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 27171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = (function (_a) {
    var fluid = _a.fluid, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, 
    // xxl,
    screenClass = _a.screenClass, containerWidths = _a.containerWidths, marginWidths = _a.marginWidths;
    var styles = {
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
    };
    if (fluid && !xs && !sm && !md && !lg && !xl) {
        return __assign({}, styles);
    }
    if (screenClass === 'xs' && containerWidths[0] && !xs) {
        styles.maxWidth = containerWidths[0];
        styles.paddingLeft = marginWidths[0];
        styles.paddingRight = marginWidths[0];
    }
    if (screenClass === 'sm' && containerWidths[0] && !sm) {
        styles.maxWidth = containerWidths[0];
        styles.paddingLeft = marginWidths[0];
        styles.paddingRight = marginWidths[0];
    }
    if (screenClass === 'md' && containerWidths[1] && !md) {
        styles.maxWidth = containerWidths[1];
        styles.paddingLeft = marginWidths[1];
        styles.paddingRight = marginWidths[1];
    }
    if (screenClass === 'lg' && containerWidths[2] && !lg) {
        styles.maxWidth = containerWidths[2];
        styles.paddingLeft = marginWidths[2];
        styles.paddingRight = marginWidths[2];
    }
    if (screenClass === 'xl' && containerWidths[3] && !xl) {
        styles.maxWidth = containerWidths[3];
        styles.paddingLeft = marginWidths[3];
        styles.paddingRight = marginWidths[3];
    }
    // if (screenClass === 'xxl' && containerWidths[4] && !xxl) {
    //   styles.maxWidth = containerWidths[4];
    // }
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map

/***/ }),

/***/ 10850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GutterWidthContext = void 0;
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var react_2 = __webpack_require__(43234);
var config_1 = __webpack_require__(85731);
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var style_1 = __importDefault(__webpack_require__(72202));
exports.GutterWidthContext = (0, react_1.createContext)(20);
var Row = function (_a) {
    var children = _a.children, align = _a.align, justify = _a.justify, wrap = _a.wrap, noGutter = _a.noGutter, gutterWidth = _a.gutterWidth, _b = _a.component, component = _b === void 0 ? 'div' : _b, direction = _a.direction, rest = __rest(_a, ["children", "align", "justify", "wrap", "noGutter", "gutterWidth", "component", "direction"]);
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            var theGutterWidth = 20;
            var gutterWidths = (0, config_1.getConfiguration)().gutterWidths;
            if (screenClass === 'xs' && gutterWidths[0]) {
                theGutterWidth = gutterWidths[0];
            }
            if (screenClass === 'sm' && gutterWidths[1]) {
                theGutterWidth = gutterWidths[1];
            }
            if (screenClass === 'md' && gutterWidths[2]) {
                theGutterWidth = gutterWidths[2];
            }
            if (screenClass === 'lg' && gutterWidths[3]) {
                theGutterWidth = gutterWidths[3];
            }
            if (screenClass === 'xl' && gutterWidths[3]) {
                theGutterWidth = gutterWidths[3];
            }
            if (noGutter)
                theGutterWidth = 0;
            if (typeof gutterWidth === 'number')
                theGutterWidth = gutterWidth;
            return (0, react_2.jsx)(component, __assign({ css: (0, style_1.default)({
                    gutterWidth: theGutterWidth,
                    align: align,
                    justify: justify,
                    direction: direction,
                    wrap: wrap,
                }) }, rest), (0, jsx_runtime_1.jsx)(exports.GutterWidthContext.Provider, __assign({ value: theGutterWidth }, { children: children })));
        } }));
};
exports["default"] = Row;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = (function (_a) {
    var gutterWidth = _a.gutterWidth, align = _a.align, justify = _a.justify, direction = _a.direction, wrap = _a.wrap;
    // Vertical alignment
    var alignItems = align;
    if (align === 'start')
        alignItems = 'flex-start';
    if (align === 'end')
        alignItems = 'flex-end';
    // Horizontal alignment
    var justifyContent = justify;
    if (justify === 'start')
        justifyContent = 'flex-start';
    if (justify === 'end')
        justifyContent = 'flex-end';
    if (justify === 'between')
        justifyContent = 'space-between';
    if (justify === 'around')
        justifyContent = 'space-around';
    if (justify === 'center')
        justifyContent = 'center';
    if (justify === 'initial')
        justifyContent = 'initial';
    if (justify === 'inherit')
        justifyContent = 'inherit';
    var flexDirection = ['column', 'row', 'column-reverse', 'row-reverse'].includes(direction)
        ? direction
        : undefined;
    var flexWrap = wrap;
    if (wrap === 'nowrap')
        flexWrap = 'nowrap';
    if (wrap === 'wrap')
        flexWrap = 'wrap';
    if (wrap === 'reverse')
        flexWrap = 'wrap-reverse';
    var styles = {
        marginLeft: -gutterWidth / 2,
        marginRight: -gutterWidth / 2,
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexDirection: flexDirection,
        flexWrap: flexWrap,
    };
    return __assign({}, styles);
});
//# sourceMappingURL=style.js.map

/***/ }),

/***/ 85731:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setConfiguration = exports.getConfiguration = void 0;
var configuration = {
    breakpoints: [600, 987, 1281, 1536],
    containerWidths: [640, 1027, 1321, 1576],
    gutterWidths: [16, 20, 20, 20],
    marginWidths: [20, 32, 32, 32],
    gridColumns: 12,
    defaultScreenClass: 'xl',
    maxScreenClass: 'xl',
};
var getConfiguration = function () { return configuration; };
exports.getConfiguration = getConfiguration;
var setConfiguration = function (newConfiguration) {
    configuration = __assign(__assign({}, configuration), newConfiguration);
};
exports.setConfiguration = setConfiguration;
//# sourceMappingURL=config.js.map

/***/ }),

/***/ 69560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScreenClassContext = exports.NO_PROVIDER_FLAG = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var utils_1 = __webpack_require__(81490);
var config_1 = __webpack_require__(85731);
exports.NO_PROVIDER_FLAG = 'NO_PROVIDER_FLAG';
exports.ScreenClassContext = (0, react_1.createContext)(exports.NO_PROVIDER_FLAG);
var ScreenClassProvider = function (_a) {
    var useOwnWidth = _a.useOwnWidth, children = _a.children, fallbackScreenClass = _a.fallbackScreenClass;
    var screenClassRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), mounted = _b[0], setMounted = _b[1];
    var detectedScreenClass = (0, utils_1.useScreenClass)(screenClassRef, fallbackScreenClass);
    var defaultScreenClass = (0, config_1.getConfiguration)().defaultScreenClass;
    var screenClass = mounted ? detectedScreenClass : fallbackScreenClass || defaultScreenClass;
    (0, react_1.useEffect)(function () { return setMounted(true); }, []);
    return ((0, jsx_runtime_1.jsx)(exports.ScreenClassContext.Provider, __assign({ value: screenClass }, { children: useOwnWidth ? ((0, jsx_runtime_1.jsx)("div", __assign({ ref: useOwnWidth ? screenClassRef : null }, { children: children }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })) })));
};
ScreenClassProvider.defaultProps = {
    useOwnWidth: false,
    fallbackScreenClass: null,
};
exports["default"] = ScreenClassProvider;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var ScreenClassProvider_1 = __importStar(__webpack_require__(69560));
var ScreenClassResolver = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(ScreenClassProvider_1.ScreenClassContext.Consumer, { children: function (screenClassCheck) {
            if (screenClassCheck === ScreenClassProvider_1.NO_PROVIDER_FLAG) {
                return ((0, jsx_runtime_1.jsx)(ScreenClassProvider_1.default, { children: (0, jsx_runtime_1.jsx)(ScreenClassProvider_1.ScreenClassContext.Consumer, { children: function (screenClassResolved) { return children(screenClassResolved); } }) }));
            }
            return children(screenClassCheck);
        } }));
};
exports["default"] = ScreenClassResolver;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 40733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useScreenClass = exports.setConfiguration = exports.ScreenClassContext = exports.ScreenClassProvider = exports.ScreenClassRender = exports.Visible = exports.Hidden = exports.Row = exports.Container = exports.Col = void 0;
// Grid
var Col_1 = __webpack_require__(5247);
Object.defineProperty(exports, "Col", ({ enumerable: true, get: function () { return __importDefault(Col_1).default; } }));
var Container_1 = __webpack_require__(71783);
Object.defineProperty(exports, "Container", ({ enumerable: true, get: function () { return __importDefault(Container_1).default; } }));
var Row_1 = __webpack_require__(10850);
Object.defineProperty(exports, "Row", ({ enumerable: true, get: function () { return __importDefault(Row_1).default; } }));
// Utilities
var Hidden_1 = __webpack_require__(43581);
Object.defineProperty(exports, "Hidden", ({ enumerable: true, get: function () { return __importDefault(Hidden_1).default; } }));
var Visible_1 = __webpack_require__(48039);
Object.defineProperty(exports, "Visible", ({ enumerable: true, get: function () { return __importDefault(Visible_1).default; } }));
var ScreenClassRender_1 = __webpack_require__(87261);
Object.defineProperty(exports, "ScreenClassRender", ({ enumerable: true, get: function () { return __importDefault(ScreenClassRender_1).default; } }));
var ScreenClassProvider_1 = __webpack_require__(69560);
Object.defineProperty(exports, "ScreenClassProvider", ({ enumerable: true, get: function () { return __importDefault(ScreenClassProvider_1).default; } }));
Object.defineProperty(exports, "ScreenClassContext", ({ enumerable: true, get: function () { return ScreenClassProvider_1.ScreenClassContext; } }));
var config_1 = __webpack_require__(85731);
Object.defineProperty(exports, "setConfiguration", ({ enumerable: true, get: function () { return config_1.setConfiguration; } }));
var utils_1 = __webpack_require__(81490);
Object.defineProperty(exports, "useScreenClass", ({ enumerable: true, get: function () { return utils_1.useScreenClass; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 43581:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var style_1 = __importDefault(__webpack_require__(81664));
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var Hidden = function (_a) {
    var children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            return (0, style_1.default)({
                screenClass: screenClass,
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl,
                // xxl,
            })
                ? null
                : children;
        } }));
};
Hidden.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    // xxl: false,
};
exports["default"] = Hidden;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 81664:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = (function (_a) {
    var screenClass = _a.screenClass, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    // if (screenClass === 'xxl') return xxl;
    if (screenClass === 'xl')
        return xl;
    if (screenClass === 'lg')
        return lg;
    if (screenClass === 'md')
        return md;
    if (screenClass === 'sm')
        return sm;
    return xs;
});
//# sourceMappingURL=style.js.map

/***/ }),

/***/ 87261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var ScreenClassRender = function (_a) {
    var render = _a.render;
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) { return render(screenClass); } }));
};
exports["default"] = ScreenClassRender;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 48039:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var style = __importStar(__webpack_require__(41596));
var ScreenClassResolver_1 = __importDefault(__webpack_require__(21246));
var Visible = function (_a) {
    var children = _a.children, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    return ((0, jsx_runtime_1.jsx)(ScreenClassResolver_1.default, { children: function (screenClass) {
            return !style.visible({
                screenClass: screenClass,
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl,
                // xxl,
            })
                ? null
                : children;
        } }));
};
Visible.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    // xxl: false,
};
exports["default"] = Visible;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 41596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.visible = void 0;
var visible = function (_a) {
    var screenClass = _a.screenClass, xs = _a.xs, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl;
    // if (screenClass === 'xxl') return xxl;
    if (screenClass === 'xl')
        return xl;
    if (screenClass === 'lg')
        return lg;
    if (screenClass === 'md')
        return md;
    if (screenClass === 'sm')
        return sm;
    return xs;
};
exports.visible = visible;
exports["default"] = exports.visible;
//# sourceMappingURL=style.js.map

/***/ }),

/***/ 81490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useScreenClass = exports.screenClasses = void 0;
var react_1 = __webpack_require__(67294);
var config_1 = __webpack_require__(85731);
var getViewPort = function (source) {
    if (source && source.current && source.current.clientWidth) {
        return source.current.clientWidth;
    }
    if (typeof window !== 'undefined' && window.innerWidth) {
        return window.innerWidth;
    }
    return null;
};
exports.screenClasses = ['xs', 'sm', 'md', 'lg', 'xl'];
var useScreenClass = function (source, fallbackScreenClass) {
    var getScreenClass = function () {
        var _a = (0, config_1.getConfiguration)(), breakpoints = _a.breakpoints, defaultScreenClass = _a.defaultScreenClass, maxScreenClass = _a.maxScreenClass;
        var newScreenClass = defaultScreenClass;
        var viewport = getViewPort(source);
        if (viewport) {
            newScreenClass = 'xs';
            if (breakpoints[0] && viewport >= breakpoints[0])
                newScreenClass = 'sm';
            if (breakpoints[1] && viewport >= breakpoints[1])
                newScreenClass = 'md';
            if (breakpoints[2] && viewport >= breakpoints[2])
                newScreenClass = 'lg';
            if (breakpoints[3] && viewport >= breakpoints[3])
                newScreenClass = 'xl';
            // if (breakpoints[4] && viewport >= breakpoints[4]) newScreenClass = 'xxl';
        }
        else if (fallbackScreenClass) {
            newScreenClass = fallbackScreenClass;
        }
        var newScreenClassIndex = exports.screenClasses.indexOf(newScreenClass);
        var maxScreenClassIndex = exports.screenClasses.indexOf(maxScreenClass);
        if (maxScreenClassIndex >= 0 && newScreenClassIndex > maxScreenClassIndex) {
            newScreenClass = exports.screenClasses[maxScreenClassIndex];
        }
        return newScreenClass;
    };
    var _a = __read((0, react_1.useState)(function () { return getScreenClass(); }), 2), screenClass = _a[0], setScreenClass = _a[1];
    (0, react_1.useEffect)(function () {
        var handleWindowResized = function () { return setScreenClass(getScreenClass()); };
        window.addEventListener('resize', handleWindowResized, false);
        return function () {
            window.removeEventListener('resize', handleWindowResized, false);
        };
    }, []);
    return screenClass;
};
exports.useScreenClass = useScreenClass;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 39447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var react_transition_group_1 = __webpack_require__(78472);
var theme_1 = __webpack_require__(72265);
var utils_1 = __webpack_require__(48247);
function getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var styles = {
    entering: {
        opacity: 1,
        transform: getScale(1),
    },
    entered: {
        opacity: 1,
        transform: 'none',
    },
};
/**
 * Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 * Remove this workaround once the WebKit bug fix is released.
 */
var isWebKit154 = typeof navigator !== 'undefined' &&
    /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) &&
    /(os |version\/)15(.|_)[4-9]/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Grow = (0, react_1.forwardRef)(function (props, ref) {
    var addEndListener = props.addEndListener, _a = props.appear, appear = _a === void 0 ? true : _a, children = props.children, easing = props.easing, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _b = props.timeout, timeout = _b === void 0 ? 'auto' : _b, refProp = props.ref, other = __rest(props, ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "ref"]);
    var timer = (0, react_1.useRef)();
    var autoTimeout = (0, react_1.useRef)();
    var theme = (0, theme_1.useTheme)();
    var nodeRef = (0, react_1.useRef)(null);
    // @ts-ignore
    var foreignRef = (0, utils_1.useForkRef)(children.ref, ref);
    var handleRef = (0, utils_1.useForkRef)(nodeRef, foreignRef);
    var normalizedTransitionCallback = function (callback) { return function (maybeIsAppearing) {
        if (callback) {
            var node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) {
                callback(node);
            }
            else {
                callback(node, maybeIsAppearing);
            }
        }
    }; };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
        (0, utils_1.reflow)(node); // So the animation always start from the start.
        var _a = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'enter',
        }), transitionDuration = _a.duration, delay = _a.delay, transitionTimingFunction = _a.easing;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay,
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction,
            }),
        ].join(',');
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
        var _a = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'exit',
        }), transitionDuration = _a.duration, delay = _a.delay, transitionTimingFunction = _a.easing;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay,
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction,
            }),
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = getScale(0.75);
        if (onExit) {
            onExit(node);
        }
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function (next) {
        if (timeout === 'auto') {
            timer.current = setTimeout(next, autoTimeout.current || 0);
        }
        if (addEndListener) {
            // Old call signature before `react-transition-group` implemented `nodeRef`
            addEndListener(nodeRef.current, next);
        }
    };
    (0, react_1.useEffect)(function () {
        return function () {
            clearTimeout(timer.current);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, __assign({ appear: appear, in: inProp, nodeRef: nodeRef, onEnter: handleEnter, onEntered: handleEntered, onEntering: handleEntering, onExit: handleExit, onExited: handleExited, onExiting: handleExiting, addEndListener: handleAddEndListener, timeout: timeout === 'auto' ? undefined : timeout }, other, { ref: refProp }, { children: function (state, childProps) {
            return (0, react_1.cloneElement)(children, __assign({ style: __assign(__assign(__assign({ opacity: 0, transform: getScale(0.75), visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
        } })));
});
exports["default"] = Grow;
//# sourceMappingURL=Grow.js.map

/***/ }),

/***/ 90925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Grow_1 = __webpack_require__(39447);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Grow_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98711:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var typography_1 = __importDefault(__webpack_require__(55489));
var form_control_1 = __webpack_require__(42329);
var style = __importStar(__webpack_require__(47917));
var InputAdornment = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'div' : _a, _b = props.disablePointerEvents, disablePointerEvents = _b === void 0 ? false : _b, _c = props.disableTypography, disableTypography = _c === void 0 ? false : _c, position = props.position, variantProp = props.variant, other = __rest(props, ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
    var formControl = (0, form_control_1.useFormControl)();
    var variant = variantProp;
    if (variantProp && formControl.variant) {
        if (false) {}
    }
    if (formControl && !variant) {
        variant = formControl.variant;
    }
    var InputAdornmentRoot = component;
    return (
    // <FormControlContext.Provider value={null}>
    (0, jsx_runtime_1.jsx)(InputAdornmentRoot, __assign({ css: style.root({ position: position, disablePointerEvents: disablePointerEvents, variant: variant }), className: className, ref: ref }, other, { children: typeof children === 'string' && !disableTypography ? ((0, jsx_runtime_1.jsx)(typography_1.default, __assign({ color: "text.secondary" }, { children: children }))) : ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [position === 'start' ? (
                /* notranslate needed while Google Translate will not fix zero-width space issue */
                (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" }))) : null, children] })) }))
    // </FormControlContext.Provider>
    );
});
InputAdornment.displayName = 'PrezzeeInputAdornment';
exports["default"] = InputAdornment;
//# sourceMappingURL=InputAdornment.js.map

/***/ }),

/***/ 47917:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.root = void 0;
var react_1 = __webpack_require__(43234);
var root = function (_a) {
    var position = _a.position, disablePointerEvents = _a.disablePointerEvents, variant = _a.variant;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 0.01em; // Fix IE11 flexbox alignment. To remove at some point.\n  max-height: 2em;\n  align-items: center;\n  white-space: nowrap;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  height: 0.01em; // Fix IE11 flexbox alignment. To remove at some point.\n  max-height: 2em;\n  align-items: center;\n  white-space: nowrap;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), position === 'start' && variant === 'filled' && "margin-top: 16px;", position === 'start' && 'margin-right: 8px;', position === 'end' && 'margin-left: 8px;', disablePointerEvents && 'pointerEvents: none;');
};
exports.root = root;
var templateObject_1;
//# sourceMappingURL=InputAdornment.style.js.map

/***/ }),

/***/ 14795:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var InputAdornment_1 = __webpack_require__(98711);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(InputAdornment_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82885:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var style = __importStar(__webpack_require__(63610));
var form_control_1 = __webpack_require__(42329);
var utils_1 = __webpack_require__(48247);
var InputBase = (0, react_1.forwardRef)(function (_a, ref) {
    var ariaDescribedby = _a["aria-describedby"], autoComplete = _a.autoComplete, autoFocus = _a.autoFocus, className = _a.className, defaultValue = _a.defaultValue, disabled = _a.disabled, error = _a.error, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, id = _a.id, _c = _a.inputComponent, inputComponent = _c === void 0 ? 'input' : _c, _d = _a.inputProps, inputPropsProp = _d === void 0 ? {} : _d, inputRefProp = _a.inputRef, maxRows = _a.maxRows, minRows = _a.minRows, _e = _a.multiline, multiline = _e === void 0 ? false : _e, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onClick = _a.onClick, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, placeholder = _a.placeholder, readOnly = _a.readOnly, renderSuffix = _a.renderSuffix, required = _a.required, rows = _a.rows, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, styles = _a.styles, _f = _a.type, type = _f === void 0 ? 'text' : _f, valueProp = _a.value, rest = __rest(_a, ['aria-describedby', "autoComplete", "autoFocus", "className", "defaultValue", "disabled", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "required", "rows", "startAdornment", "endAdornment", "styles", "type", "value"]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var isControlled = (0, react_1.useRef)(value != null).current;
    var inputRef = (0, react_1.useRef)();
    var handleInputRef = (0, utils_1.useForkRef)(inputRef, inputRefProp);
    var formControl = (0, form_control_1.useFormControl)();
    var _g = __read((0, react_1.useState)(false), 2), focused = _g[0], setFocused = _g[1];
    formControl.focused = formControl ? formControl.focused : focused;
    (0, react_1.useEffect)(function () {
        if (!formControl && disabled && focused) {
            setFocused(false);
            if (onBlur) {
                onBlur(null);
            }
        }
    }, [formControl, disabled, focused, onBlur]);
    var onFilled = formControl && formControl.onFilled;
    var onEmpty = formControl && formControl.onEmpty;
    var checkDirty = (0, react_1.useCallback)(function (obj) {
        if ((0, utils_1.isFilled)(obj)) {
            if (onFilled)
                onFilled();
        }
        else if (onEmpty) {
            onEmpty();
        }
    }, [onFilled, onEmpty]);
    var handleBlur = function (event) {
        if (onBlur)
            onBlur(event);
        if (formControl && formControl.onBlur) {
            formControl.onBlur();
        }
        else {
            setFocused(false);
        }
    };
    var handleFocus = function (event) {
        if (onFocus)
            onFocus(event);
        if (formControl && formControl.onFocus) {
            formControl.onFocus();
        }
        else {
            setFocused(true);
        }
    };
    var handleChange = function (event) {
        if (!isControlled) {
            var element = event.target;
            if (element == null) {
                throw new Error('Expected valid input target');
            }
            checkDirty({
                value: element.value,
            });
        }
        if (onChange)
            onChange(event);
    };
    var handleClick = function (event) {
        if (onClick)
            onClick(event);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    (0, react_1.useEffect)(function () {
        checkDirty(inputRef.current);
    }, [valueProp]);
    var InputComponent = inputComponent;
    var inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) {
            if (false) {}
            inputProps = __assign({ type: undefined, minRows: rows, maxRows: rows }, inputProps);
        }
        else {
            inputProps = __assign({ type: undefined, maxRows: maxRows, minRows: minRows }, inputProps);
        }
        InputComponent = 'textarea';
    }
    var rootStyles = [style.root, (styles === null || styles === void 0 ? void 0 : styles.root) && (styles === null || styles === void 0 ? void 0 : styles.root)];
    var inputStyles = [
        style.input((formControl === null || formControl === void 0 ? void 0 : formControl.focused) && !(formControl === null || formControl === void 0 ? void 0 : formControl.filled)),
        (styles === null || styles === void 0 ? void 0 : styles.input) && (styles === null || styles === void 0 ? void 0 : styles.input),
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: handleClick, className: className, ref: ref, css: rootStyles }, rest, { children: [startAdornment, (0, jsx_runtime_1.jsx)(InputComponent, __assign({ css: inputStyles, "aria-invalid": !!error, "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, id: id, name: name, placeholder: placeholder, readOnly: readOnly, required: required, rows: rows, value: value, onKeyDown: onKeyDown, onKeyUp: onKeyUp, type: type }, inputProps, { ref: handleInputRef, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus })), endAdornment, renderSuffix ? renderSuffix(__assign({}, formControl)) : null] })));
});
InputBase.displayName = 'PrezzeeInputBase';
exports["default"] = InputBase;
//# sourceMappingURL=InputBase.js.map

/***/ }),

/***/ 63610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.input = exports.root = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports.root = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.4375em;\n  letter-spacing: 0.00938em;\n  color: black;\n  box-sizing: border-box;\n  cursor: text;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n"], ["\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.4375em;\n  letter-spacing: 0.00938em;\n  color: black;\n  box-sizing: border-box;\n  cursor: text;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n"])));
var input = function (showPlaceholder) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font: inherit;\n  letter-spacing: inherit;\n  color: currentcolor;\n  border: 0px;\n  box-sizing: content-box;\n  background: none;\n  height: 1.4375em;\n  margin: 0px;\n  -webkit-tap-highlight-color: transparent;\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  outline: none;\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  font: inherit;\n  letter-spacing: inherit;\n  color: currentcolor;\n  border: 0px;\n  box-sizing: content-box;\n  background: none;\n  height: 1.4375em;\n  margin: 0px;\n  -webkit-tap-highlight-color: transparent;\n  display: block;\n  min-width: 0px;\n  width: 100%;\n  outline: none;\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), showPlaceholder ? tokens_1.colors.gray400 : 'transparent'); };
exports.input = input;
var templateObject_1, templateObject_2;
//# sourceMappingURL=InputBase.style.js.map

/***/ }),

/***/ 10635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var InputBase_1 = __webpack_require__(82885);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(InputBase_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 47520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
var InputLabel_style_1 = __importDefault(__webpack_require__(58307));
var form_control_1 = __webpack_require__(42329);
var InputLabel = function (_a) {
    var children = _a.children, shrink = _a.shrink, rest = __rest(_a, ["children", "shrink"]);
    var formControl = (0, form_control_1.useFormControl)();
    if (typeof shrink === 'undefined' && formControl) {
        shrink = formControl.filled || formControl.focused || formControl.adornedStart;
    }
    return ((0, jsx_runtime_1.jsx)("label", __assign({}, rest, { css: (0, InputLabel_style_1.default)(formControl.variant, Boolean(formControl.filled || formControl.focused || shrink)) }, { children: children })));
};
InputLabel.displayName = 'PrezzeeInputLabel';
exports["default"] = InputLabel;
//# sourceMappingURL=InputLabel.js.map

/***/ }),

/***/ 58307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports["default"] = (function (variant, shrink) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: ", ";\n  letter-spacing: 0.00938em;\n  padding: ", "; //adjusting for 2px font offset\n  display: block;\n  transform-origin: left top;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  z-index: 1;\n  pointer-events: none;\n  color: ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: ", ";\n  letter-spacing: 0.00938em;\n  padding: ", "; //adjusting for 2px font offset\n  display: block;\n  transform-origin: left top;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  z-index: 1;\n  pointer-events: none;\n  color: ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), variant === 'outlined' ? '1em' : '1.4375em', variant === 'outlined' ? '0.125rem 0.25rem 0.25rem' : '0', tokens_1.colors.gray600, shrink && 'user-select: none;', variant === 'outlined' ?
    "max-width: ".concat(shrink ? 'calc(112% - 20px)' : 'calc(100% - 2rem)') : "max-width: ".concat(shrink ? 'calc(133% - 24px)' : 'calc(100% - 24px)'), variant === 'outlined' &&
    "transform: ".concat(shrink ? 'translate(0.75rem, -0.55rem) scale(0.875)' : 'translate(0.75rem, 0.875rem) scale(1)'), variant === 'filled' &&
    "transform: ".concat(shrink ? 'translate(12px, 7px) scale(0.75)' : 'translate(12px, 16px) scale(1)'), variant === 'standard' &&
    "transform: ".concat(shrink ? 'translate(0px, -1.5px) scale(0.75)' : 'translate(0px, 20px) scale(1)')); });
var templateObject_1;
//# sourceMappingURL=InputLabel.style.js.map

/***/ }),

/***/ 39067:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var InputLabel_1 = __webpack_require__(47520);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(InputLabel_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 85787:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var input_base_1 = __importDefault(__webpack_require__(10635));
var Input_style_1 = __importDefault(__webpack_require__(78297));
var form_control_1 = __webpack_require__(42329);
var Input = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = _a.multiline, multiline = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'text' : _d, rest = __rest(_a, ["fullWidth", "multiline", "type"]);
    var formControl = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)(input_base_1.default, __assign({ fullWidth: fullWidth, multiline: multiline, styles: { root: (0, Input_style_1.default)(formControl.focused, !!formControl.error) }, ref: ref, type: type }, rest)));
});
Input.displayName = 'PrezzeeInput';
exports["default"] = Input;
//# sourceMappingURL=Input.js.map

/***/ }),

/***/ 78297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports["default"] = (function (grow, error) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  label + & {\n    margin-top: 16px;\n  }\n\n  &:hover:before {\n    border-color: ", ";\n  }\n\n  &:before {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  &:after {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transform: ", ";\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  input {\n    padding: 4px 0px 5px;\n  }\n"], ["\n  label + & {\n    margin-top: 16px;\n  }\n\n  &:hover:before {\n    border-color: ", ";\n  }\n\n  &:before {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  &:after {\n    content: '';\n    border-bottom: 1px solid ", ";\n    left: 0px;\n    bottom: 0px;\n    position: absolute;\n    right: 0px;\n    transform: ", ";\n    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    pointer-events: none;\n  }\n\n  input {\n    padding: 4px 0px 5px;\n  }\n"])), tokens_1.colors.gray600, tokens_1.colors.gray400, error ? tokens_1.colors.red400 : tokens_1.colors.blue400, grow || error ? 'scaleX(1)' : 'scaleX(0)'); });
var templateObject_1;
//# sourceMappingURL=Input.style.js.map

/***/ }),

/***/ 89612:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Input_1 = __webpack_require__(85787);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Input_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var ListContext_1 = __importDefault(__webpack_require__(73341));
var style = __importStar(__webpack_require__(62903));
var List = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, _a = props.dense, dense = _a === void 0 ? false : _a, _b = props.disablePadding, disablePadding = _b === void 0 ? false : _b, subheader = props.subheader, rest = __rest(props, ["children", "className", "dense", "disablePadding", "subheader"]);
    var context = (0, react_1.useMemo)(function () { return ({ dense: dense }); }, [dense]);
    var ownerState = {
        disablePadding: disablePadding,
        subheader: subheader,
    };
    return ((0, jsx_runtime_1.jsx)(ListContext_1.default.Provider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsxs)("ul", __assign({ css: style.root(ownerState), className: className, ref: ref }, rest, { children: [subheader, children] })) })));
});
List.displayName = 'PrezzeeList';
exports["default"] = List;
//# sourceMappingURL=List.js.map

/***/ }),

/***/ 62903:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.root = void 0;
var react_1 = __webpack_require__(43234);
var root = function (state) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  ", ";\n  ", "\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  ", ";\n  ", "\n"])), !state.disablePadding &&
    "\n  padding-top: 8px;\n  padding-bottom: 8px;\n", state.subheader && 'padding-top: 0;'); };
exports.root = root;
var templateObject_1;
//# sourceMappingURL=List.style.js.map

/***/ }),

/***/ 73341:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(67294));
var ListContext = React.createContext({});
ListContext.displayName = 'PrezzeeListContext';
exports["default"] = ListContext;
//# sourceMappingURL=ListContext.js.map

/***/ }),

/***/ 18593:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ListContext = exports["default"] = void 0;
var List_1 = __webpack_require__(82053);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(List_1).default; } }));
var ListContext_1 = __webpack_require__(73341);
Object.defineProperty(exports, "ListContext", ({ enumerable: true, get: function () { return __importDefault(ListContext_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 27553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var list_1 = __webpack_require__(18593);
var utils_1 = __webpack_require__(48247);
var button_base_1 = __importDefault(__webpack_require__(10071));
var style = __importStar(__webpack_require__(95390));
var MenuItem = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, _a = props.autoFocus, autoFocus = _a === void 0 ? false : _a, _b = props.dense, dense = _b === void 0 ? false : _b, _c = props.divider, divider = _c === void 0 ? false : _c, _d = props.disableGutters, disableGutters = _d === void 0 ? false : _d, focusVisibleClassName = props.focusVisibleClassName, _e = props.role, role = _e === void 0 ? 'menuitem' : _e, tabIndexProp = props.tabIndex, other = __rest(props, ["children", "autoFocus", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"]);
    var context = (0, react_1.useContext)(list_1.ListContext);
    var childContext = {
        dense: dense || context.dense || false,
        disableGutters: disableGutters,
    };
    var menuItemRef = (0, react_1.useRef)(null);
    (0, utils_1.useEnhancedEffect)(function () {
        if (autoFocus) {
            if (menuItemRef.current) {
                menuItemRef.current.focus();
            }
            else if (false) {}
        }
    }, [autoFocus]);
    var handleRef = (0, utils_1.useForkRef)(menuItemRef, ref);
    var tabIndex;
    if (!props.disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return ((0, jsx_runtime_1.jsx)(list_1.ListContext.Provider, __assign({ value: childContext }, { children: (0, jsx_runtime_1.jsx)(button_base_1.default, __assign({ component: 'li', css: style.root, ref: handleRef, 
            // role={role}
            tabIndex: tabIndex, focusVisibleClassName: focusVisibleClassName }, other, { children: children })) })));
});
exports["default"] = MenuItem;
//# sourceMappingURL=MenuItem.js.map

/***/ }),

/***/ 95390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.root = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var root = function (state) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n  min-height: 48px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  box-sizing: border-box;\n  white-space: nowrap;\n\n  ", "\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    background-color: ", ";\n\n    // Reset on touch devices, it doesn't add specificity\n    @media (hover: none) {\n      background-color: transparent;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  text-decoration: none;\n  min-height: 48px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  box-sizing: border-box;\n  white-space: nowrap;\n\n  ", "\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    background-color: ", ";\n\n    // Reset on touch devices, it doesn't add specificity\n    @media (hover: none) {\n      background-color: transparent;\n    }\n  }\n"])), !state.disableGutters && "padding-left: 16px; padding-right: 16px;", tokens_1.colors.gray100); };
exports.root = root;
var templateObject_1;
//# sourceMappingURL=MenuItem.style.js.map

/***/ }),

/***/ 98286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var MenuItem_1 = __webpack_require__(27553);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(MenuItem_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 95799:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var react_is_1 = __webpack_require__(59864);
var utils_1 = __webpack_require__(48247);
var list_1 = __importDefault(__webpack_require__(18593));
function nextItem(list, item, disableListWrap) {
    if (list === item) {
        return list.firstChild;
    }
    if (item && item.nextElementSibling) {
        return item.nextElementSibling;
    }
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) {
        return disableListWrap ? list.firstChild : list.lastChild;
    }
    if (item && item.previousElementSibling) {
        return item.previousElementSibling;
    }
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) {
        return true;
    }
    var text = nextFocus.innerText;
    if (text === undefined) {
        // jsdom doesn't support innerText
        text = nextFocus.textContent;
    }
    text = text.trim().toLowerCase();
    if (text.length === 0) {
        return false;
    }
    if (textCriteria.repeating) {
        return text[0] === textCriteria.keys[0];
    }
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while (nextFocus) {
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) {
                return false;
            }
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable
            ? false
            : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') ||
            !textCriteriaMatches(nextFocus, textCriteria) ||
            nextFocusDisabled) {
            // Move to the next element.
            nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        }
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */
var MenuList = (0, react_1.forwardRef)(function (_a, ref) {
    var 
    // @ts-ignore
    actions = _a.actions, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = _a.autoFocusItem, autoFocusItem = _c === void 0 ? false : _c, children = _a.children, className = _a.className, _d = _a.disabledItemsFocusable, disabledItemsFocusable = _d === void 0 ? false : _d, _e = _a.disableListWrap, disableListWrap = _e === void 0 ? false : _e, onKeyDown = _a.onKeyDown, _f = _a.variant, variant = _f === void 0 ? 'selectedMenu' : _f, other = __rest(_a, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
    var listRef = (0, react_1.useRef)(null);
    var textCriteriaRef = (0, react_1.useRef)({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null,
    });
    (0, utils_1.useEnhancedEffect)(function () {
        var _a;
        if (autoFocus) {
            (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocus]);
    (0, react_1.useImperativeHandle)(actions, function () { return ({
        adjustStyleForScrollbar: function (containerElement, theme) {
            // Let's ignore that piece of logic if users are already overriding the width
            // of the menu.
            if (listRef.current) {
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, utils_1.getScrollbarSize)((0, utils_1.ownerDocument)(containerElement)), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] =
                        scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
            }
            return listRef.current;
        },
    }); }, []);
    var handleKeyDown = function (event) {
        var list = listRef.current;
        var key = event.key;
        /**
         * @type {Element} - will always be defined since we are in a keydown handler
         * attached to an element. A keydown event is either dispatched to the activeElement
         * or document.body or document.documentElement. Only the first case will
         * trigger this specific handler.
         */
        var currentFocus = (0, utils_1.ownerDocument)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        }
        else if (key === 'ArrowUp') {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        }
        else if (key === 'Home') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        }
        else if (key === 'End') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        }
        else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (criteria.lastTime && currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                }
                else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
                    criteria.repeating = false;
                }
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched &&
                (keepFocusOnCurrent ||
                    moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
                event.preventDefault();
            }
            else {
                criteria.previousKeyMatched = false;
            }
        }
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    var handleRef = (0, utils_1.useForkRef)(listRef, ref);
    /**
     * the index of the item should receive focus
     * in a `variant="selectedMenu"` it's the first `selected` item
     * otherwise it's the very first item.
     */
    var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    react_1.Children.forEach(children, function (child, index) {
        if (!(0, react_1.isValidElement)(child)) {
            return;
        }
        if (false) {}
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) {
                activeItemIndex = index;
            }
            else if (activeItemIndex === -1) {
                activeItemIndex = index;
            }
        }
    });
    var items = react_1.Children.map(children, function (child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (!(0, react_1.isValidElement)(child))
                return;
            if (autoFocusItem) {
                newChildProps.autoFocus = true;
            }
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
                newChildProps.tabIndex = 0;
            }
            return (0, react_1.cloneElement)(child, newChildProps);
        }
        return child;
    });
    return ((0, jsx_runtime_1.jsx)(list_1.default, __assign({ role: "menu", ref: handleRef, className: className, onKeyDown: handleKeyDown, tabIndex: autoFocus ? 0 : -1 }, other, { children: items })));
});
exports["default"] = MenuList;
//# sourceMappingURL=MenuList.js.map

/***/ }),

/***/ 50911:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var MenuList_1 = __webpack_require__(95799);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(MenuList_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49741:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var react_is_1 = __webpack_require__(59864);
var menu_list_1 = __importDefault(__webpack_require__(50911));
var paper_1 = __importDefault(__webpack_require__(58679));
var popover_1 = __importDefault(__webpack_require__(1604));
var theme_1 = __webpack_require__(72265);
var style = __importStar(__webpack_require__(62160));
var RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right',
};
var LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left',
};
var Menu = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.autoFocus, autoFocus = _a === void 0 ? true : _a, children = props.children, _b = props.disableAutoFocusItem, disableAutoFocusItem = _b === void 0 ? false : _b, _c = props.MenuListProps, MenuListProps = _c === void 0 ? {} : _c, onClose = props.onClose, open = props.open, 
    // @ts-ignore
    _d = props.PaperProps, 
    // @ts-ignore
    PaperProps = _d === void 0 ? {} : _d, 
    // PopoverClasses,
    _e = props.transitionDuration, 
    // PopoverClasses,
    transitionDuration = _e === void 0 ? 'auto' : _e, _f = props.TransitionProps, _g = _f === void 0 ? {} : _f, onEntering = _g.onEntering, TransitionProps = __rest(_g, ["onEntering"]), _h = props.variant, variant = _h === void 0 ? 'selectedMenu' : _h, other = __rest(props, ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "transitionDuration", "TransitionProps", "variant"]);
    var theme = (0, theme_1.useTheme)();
    // const isRtl = theme.direction === 'rtl';
    var isRtl = false;
    // const ownerState = {
    //   ...props,
    //   autoFocus,
    //   disableAutoFocusItem,
    //   MenuListProps,
    //   onEntering,
    //   PaperProps,
    //   transitionDuration,
    //   TransitionProps,
    //   variant,
    // };
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = (0, react_1.useRef)(null);
    var handleEntering = function (element, isAppearing) {
        if (menuListActionsRef.current) {
            // @ts-ignore
            menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        }
        if (onEntering) {
            onEntering(element, isAppearing);
        }
    };
    var handleListKeyDown = function (event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) {
                // @ts-ignore
                onClose(event, 'tabKeyDown');
            }
        }
    };
    /**
     * the index of the item should receive focus
     * in a `variant="selectedMenu"` it's the first `selected` item
     * otherwise it's the very first item.
     */
    var activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    react_1.Children.map(children, function (child, index) {
        if (!(0, react_1.isValidElement)(child)) {
            return;
        }
        if (false) {}
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) {
                activeItemIndex = index;
            }
            else if (activeItemIndex === -1) {
                activeItemIndex = index;
            }
        }
    });
    return ((0, jsx_runtime_1.jsx)(popover_1.default
    // classes={PopoverClasses}
    , __assign({ 
        // classes={PopoverClasses}
        onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left',
        }, 
        // @ts-ignore
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN, PaperProps: __assign(__assign({ component: paper_1.default }, PaperProps), { css: style.paper }), 
        // className={classes.root}
        open: open, ref: ref, transitionDuration: transitionDuration, TransitionProps: __assign({ onEntering: handleEntering }, TransitionProps) }, other, { children: (0, jsx_runtime_1.jsx)(menu_list_1.default, __assign({ onKeyDown: handleListKeyDown, 
            // @ts-ignore
            actions: menuListActionsRef, autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem), autoFocusItem: autoFocusItem, variant: variant }, MenuListProps, { children: children })) })));
});
exports["default"] = Menu;
//# sourceMappingURL=Menu.js.map

/***/ }),

/***/ 62160:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paper = void 0;
var react_1 = __webpack_require__(43234);
exports.paper = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  // specZ: The maximum height of a simple menu should be one or more rows less than the view\n  // height. This ensures a tapable area outside of the simple menu with which to dismiss\n  // the menu.\n  max-height: calc(100% - 96px);\n  // Add iOS momentum scrolling for iOS < 13.0\n  -webkit-overflow-scrolling: touch;\n"], ["\n  // specZ: The maximum height of a simple menu should be one or more rows less than the view\n  // height. This ensures a tapable area outside of the simple menu with which to dismiss\n  // the menu.\n  max-height: calc(100% - 96px);\n  // Add iOS momentum scrolling for iOS < 13.0\n  -webkit-overflow-scrolling: touch;\n"])));
var templateObject_1;
//# sourceMappingURL=Menu.style.js.map

/***/ }),

/***/ 22047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Menu_1 = __webpack_require__(49741);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Menu_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 58053:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ariaHidden = void 0;
var utils_1 = __webpack_require__(48247);
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    var doc = (0, utils_1.ownerDocument)(container);
    if (doc.body === container) {
        return (0, utils_1.ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
    }
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
    if (show) {
        element.setAttribute('aria-hidden', 'true');
    }
    else {
        element.removeAttribute('aria-hidden');
    }
}
exports.ariaHidden = ariaHidden;
function getPaddingRight(element) {
    return parseInt((0, utils_1.ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    if (elementsToExclude === void 0) { elementsToExclude = []; }
    var blacklist = __spreadArray([mountElement, currentElement], __read(elementsToExclude), false);
    var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
    [].forEach.call(container.children, function (element) {
        if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) {
            ariaHidden(element, show);
        }
    });
}
function findIndexOf(items, callback) {
    var idx = -1;
    items.some(function (item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize_1 = (0, utils_1.getScrollbarSize)((0, utils_1.ownerDocument)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container,
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize_1, "px");
            // .mui-fixed is a global helper.
            var fixedElements = (0, utils_1.ownerDocument)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, function (element) {
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element,
                });
                element.style.paddingRight = "".concat(getPaddingRight(element) + scrollbarSize_1, "px");
            });
        }
        // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent_1 = container.parentElement;
        var containerWindow = (0, utils_1.ownerWindow)(container);
        var scrollContainer = (parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent_1).overflowY === 'scroll'
            ? parent_1
            : container;
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer,
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer,
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer,
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function () {
        restoreStyle.forEach(function (_a) {
            var value = _a.value, el = _a.el, property = _a.property;
            if (value) {
                el.style.setProperty(property, value);
            }
            else {
                el.style.removeProperty(property);
            }
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function (element) {
        if (element.getAttribute('aria-hidden') === 'true') {
            hiddenSiblings.push(element);
        }
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
var ModalManager = /** @class */ (function () {
    function ModalManager() {
        this.modals = [];
        this.containers = [];
    }
    ModalManager.prototype.add = function (modal, container) {
        var modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) {
            return modalIndex;
        }
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) {
            ariaHidden(modal.modalRef, false);
        }
        var hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        var containerIndex = findIndexOf(this.containers, function (item) { return item.container === container; });
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [modal],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings,
        });
        return modalIndex;
    };
    ModalManager.prototype.mount = function (modal, props) {
        var containerIndex = findIndexOf(this.containers, function (item) { return item.modals.indexOf(modal) !== -1; });
        var containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) {
            containerInfo.restore = handleContainer(containerInfo, props);
        }
    };
    ModalManager.prototype.remove = function (modal) {
        var modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) {
            return modalIndex;
        }
        var containerIndex = findIndexOf(this.containers, function (item) { return item.modals.indexOf(modal) !== -1; });
        var containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) {
                containerInfo.restore();
            }
            if (modal.modalRef) {
                // In case the modal wasn't in the DOM yet.
                ariaHidden(modal.modalRef, true);
            }
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        }
        else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) {
                ariaHidden(nextTop.modalRef, false);
            }
        }
        return modalIndex;
    };
    ModalManager.prototype.isTopModal = function (modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    };
    return ModalManager;
}());
exports["default"] = ModalManager;
//# sourceMappingURL=ModalManager.js.map

/***/ }),

/***/ 37542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var utils_1 = __webpack_require__(48247);
var portal_1 = __importDefault(__webpack_require__(8444));
var ModalManager_1 = __importStar(__webpack_require__(58053));
var trap_focus_1 = __importDefault(__webpack_require__(71824));
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var defaultManager = new ModalManager_1.default();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
var ModalUnstyled = (0, react_1.forwardRef)(function (props, ref) {
    var BackdropComponent = props.BackdropComponent, BackdropProps = props.BackdropProps, children = props.children, className = props.className, _a = props.closeAfterTransition, closeAfterTransition = _a === void 0 ? false : _a, _b = props.component, component = _b === void 0 ? 'div' : _b, _c = props.components, components = _c === void 0 ? {} : _c, _d = props.componentsProps, componentsProps = _d === void 0 ? {} : _d, container = props.container, _e = props.disableAutoFocus, disableAutoFocus = _e === void 0 ? false : _e, _f = props.disableEnforceFocus, disableEnforceFocus = _f === void 0 ? false : _f, _g = props.disableEscapeKeyDown, disableEscapeKeyDown = _g === void 0 ? false : _g, _h = props.disablePortal, disablePortal = _h === void 0 ? false : _h, _j = props.disableRestoreFocus, disableRestoreFocus = _j === void 0 ? false : _j, _k = props.disableScrollLock, disableScrollLock = _k === void 0 ? false : _k, _l = props.hideBackdrop, hideBackdrop = _l === void 0 ? false : _l, _m = props.keepMounted, keepMounted = _m === void 0 ? false : _m, 
    // private
    // @ts-ignore
    _o = props.manager, 
    // private
    // @ts-ignore
    manager = _o === void 0 ? defaultManager : _o, onClose = props.onClose, onKeyDown = props.onKeyDown, open = props.open, onTransitionEnter = props.onTransitionEnter, onTransitionExited = props.onTransitionExited, other = __rest(props, ["BackdropComponent", "BackdropProps", "children", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onClose", "onKeyDown", "open", "onTransitionEnter", "onTransitionExited"]);
    var _p = __read((0, react_1.useState)(true), 2), exited = _p[0], setExited = _p[1];
    var modal = (0, react_1.useRef)({});
    var mountNodeRef = (0, react_1.useRef)(null);
    var modalRef = (0, react_1.useRef)(null);
    var handleRef = (0, utils_1.useForkRef)(modalRef, ref);
    var hasTransition = getHasTransition(props);
    var getDoc = function () { return (0, utils_1.ownerDocument)(mountNodeRef.current); };
    var getModal = function () {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function () {
        manager.mount(getModal(), { disableScrollLock: disableScrollLock });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current)
            modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, utils_1.useEventCallback)(function () {
        var resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) {
            handleMounted();
        }
    });
    var isTopModal = (0, react_1.useCallback)(function () { return manager.isTopModal(getModal()); }, [manager]);
    var handlePortalRef = (0, utils_1.useEventCallback)(function (node) {
        mountNodeRef.current = node;
        if (!node) {
            return;
        }
        if (open && isTopModal()) {
            handleMounted();
        }
        else {
            (0, ModalManager_1.ariaHidden)(modalRef.current, true);
        }
    });
    var handleClose = (0, react_1.useCallback)(function () {
        manager.remove(getModal());
    }, [manager]);
    (0, react_1.useEffect)(function () {
        return function () {
            handleClose();
        };
    }, [handleClose]);
    (0, react_1.useEffect)(function () {
        if (open) {
            handleOpen();
        }
        else if (!hasTransition || !closeAfterTransition) {
            handleClose();
        }
    }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
    if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
    }
    var handleEnter = function () {
        setExited(false);
        if (onTransitionEnter) {
            onTransitionEnter();
        }
    };
    var handleExited = function () {
        setExited(true);
        if (onTransitionExited) {
            onTransitionExited();
        }
        if (closeAfterTransition) {
            handleClose();
        }
    };
    var handleBackdropClick = function (event) {
        if (event.target !== event.currentTarget) {
            return;
        }
        if (onClose) {
            onClose(event, 'backdropClick');
        }
    };
    var handleKeyDown = function (event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) {
            return;
        }
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) {
                onClose(event, 'escapeKeyDown');
            }
        }
    };
    var childProps = {};
    if (children.props.tabIndex === undefined) {
        childProps.tabIndex = '-1';
    }
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, utils_1.createChainedFunction)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, utils_1.createChainedFunction)(handleExited, children.props.onExited);
    }
    var Root = components.Root || component;
    var rootProps = componentsProps.root || {};
    return ((0, jsx_runtime_1.jsx)(portal_1.default, __assign({ ref: handlePortalRef, container: container, disablePortal: disablePortal }, { children: (0, jsx_runtime_1.jsxs)(Root, __assign({ role: "presentation" }, rootProps, other, { ref: handleRef, onKeyDown: handleKeyDown, className: className }, { children: [!hideBackdrop && BackdropComponent ? ((0, jsx_runtime_1.jsx)(BackdropComponent, __assign({ "aria-hidden": true, open: open, onClick: handleBackdropClick }, BackdropProps))) : null, (0, jsx_runtime_1.jsx)(trap_focus_1.default, __assign({ disableEnforceFocus: disableEnforceFocus, disableAutoFocus: disableAutoFocus, disableRestoreFocus: disableRestoreFocus, isEnabled: isTopModal, open: open }, { children: (0, react_1.cloneElement)(children, childProps) }))] })) })));
});
exports["default"] = ModalUnstyled;
//# sourceMappingURL=ModalUnstyled.js.map

/***/ }),

/***/ 48373:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var ModalUnstyled_1 = __webpack_require__(37542);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(ModalUnstyled_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26654:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var modal_unstyled_1 = __importDefault(__webpack_require__(48373));
var backdrop_1 = __importDefault(__webpack_require__(75338));
var style = __importStar(__webpack_require__(39772));
var styled_1 = __importDefault(__webpack_require__(6029));
var ModalBackdrop = (0, styled_1.default)(backdrop_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), style.backdrop);
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog]
 * - [Drawer]
 * - [Menu]
 * - [Popover]
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog] component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
var Modal = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.BackdropComponent, BackdropComponent = _a === void 0 ? ModalBackdrop : _a, _b = props.closeAfterTransition, closeAfterTransition = _b === void 0 ? false : _b, children = props.children, _c = props.components, components = _c === void 0 ? {} : _c, _d = props.componentsProps, componentsProps = _d === void 0 ? {} : _d, _e = props.disableAutoFocus, disableAutoFocus = _e === void 0 ? false : _e, _f = props.disableEnforceFocus, disableEnforceFocus = _f === void 0 ? false : _f, _g = props.disableEscapeKeyDown, disableEscapeKeyDown = _g === void 0 ? false : _g, _h = props.disablePortal, disablePortal = _h === void 0 ? false : _h, _j = props.disableRestoreFocus, disableRestoreFocus = _j === void 0 ? false : _j, _k = props.disableScrollLock, disableScrollLock = _k === void 0 ? false : _k, _l = props.hideBackdrop, hideBackdrop = _l === void 0 ? false : _l, _m = props.keepMounted, keepMounted = _m === void 0 ? false : _m, other = __rest(props, ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"]);
    var _o = __read((0, react_1.useState)(true), 2), exited = _o[0], setExited = _o[1];
    var commonProps = {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
    };
    var rootStyle = style.root(true, exited);
    return ((0, jsx_runtime_1.jsx)(modal_unstyled_1.default, __assign({ components: __assign({ Root: 'div' }, components), componentsProps: {
            root: __assign(__assign({}, componentsProps.root), { css: rootStyle }),
        }, BackdropComponent: BackdropComponent, onTransitionEnter: function () { return setExited(false); }, onTransitionExited: function () { return setExited(true); }, ref: ref }, other, commonProps, { children: children })));
});
exports["default"] = Modal;
var templateObject_1;
//# sourceMappingURL=Modal.js.map

/***/ }),

/***/ 39772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.backdrop = exports.root = void 0;
var react_1 = __webpack_require__(43234);
var root = function (open, exited) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 1000;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  ", ";\n"], ["\n  position: fixed;\n  z-index: 1000;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  ", ";\n"])), !open && exited && 'visibility: hidden'); };
exports.root = root;
exports.backdrop = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  z-index: -1;\n"], ["\n  z-index: -1;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=Modal.style.js.map

/***/ }),

/***/ 97249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Modal_1 = __webpack_require__(26654);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Modal_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21718:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
// import clsx from 'clsx';
var NativeSelectInput_1 = __importDefault(__webpack_require__(73617));
var form_control_1 = __webpack_require__(42329);
// import ArrowDropDownIcon from '../internal/svg-icons/ArrowDropDown';
var input_1 = __importDefault(__webpack_require__(89612));
var ArrowDropDownIcon = function () { return (0, jsx_runtime_1.jsx)("div", {}); };
var defaultInput = (0, jsx_runtime_1.jsx)(input_1.default, {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */
var NativeSelect = (0, react_1.forwardRef)(function (props, ref) {
    var className = props.className, children = props.children, 
    // classes: classesProp = {},
    _a = props.IconComponent, 
    // classes: classesProp = {},
    IconComponent = _a === void 0 ? ArrowDropDownIcon : _a, _b = props.input, input = _b === void 0 ? defaultInput : _b, inputProps = props.inputProps, variant = props.variant, other = __rest(props, ["className", "children", "IconComponent", "input", "inputProps", "variant"]);
    var formControl = (0, form_control_1.useFormControl)();
    return (0, react_1.cloneElement)(input, __assign({ 
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: NativeSelectInput_1.default, inputProps: __assign(__assign({ children: children, 
            // classes: otherClasses,
            IconComponent: IconComponent, variant: formControl.variant, type: undefined }, inputProps), (input ? input.props.inputProps : {})), ref: ref }, other));
});
NativeSelect.displayName = 'PrezzeeNativeSelect';
exports["default"] = NativeSelect;
//# sourceMappingURL=NativeSelect.js.map

/***/ }),

/***/ 76215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.icon = exports.root = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports.root = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  user-select: none;\n  border-radius: 0;\n  cursor: pointer;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &[multiple] {\n    height: auto;\n  }\n"], ["\n  appearance: none;\n  user-select: none;\n  border-radius: 0;\n  cursor: pointer;\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n\n  &[multiple] {\n    height: auto;\n  }\n"])));
exports.icon = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  user-select: none;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  fill: currentcolor;\n  flex-shrink: 0;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-size: 1.5rem;\n  position: absolute;\n  right: 7px;\n  top: calc(50% - 0.5em);\n  pointer-events: none;\n  color: ", ";\n"], ["\n  user-select: none;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  fill: currentcolor;\n  flex-shrink: 0;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-size: 1.5rem;\n  position: absolute;\n  right: 7px;\n  top: calc(50% - 0.5em);\n  pointer-events: none;\n  color: ", ";\n"])), tokens_1.colors.gray800);
var templateObject_1, templateObject_2;
//# sourceMappingURL=NativeSelect.style.js.map

/***/ }),

/***/ 73617:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var clsx_1 = __importDefault(__webpack_require__(86010));
var style = __importStar(__webpack_require__(76215));
var SelectIcon = function () {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.icon, focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "ArrowDropDownIcon" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7 10l5 5 5-5z" }) })));
};
var NativeSelectInput = (0, react_1.forwardRef)(function (props, ref) {
    var className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _a = props.variant, variant = _a === void 0 ? 'standard' : _a, 
    // @ts-ignore
    options = props.options, multiple = props.multiple, rest = __rest(props, ["className", "disabled", "IconComponent", "inputRef", "variant", "options", "multiple"]);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("select", __assign({ className: (0, clsx_1.default)(className), css: style.root, disabled: disabled, ref: inputRef || ref }, rest, { children: options &&
                    options.map(function (option, index) {
                        if ((option === null || option === void 0 ? void 0 : option.value) === undefined) {
                            return;
                        }
                        else {
                            return ((0, jsx_runtime_1.jsx)("option", __assign({ value: option === null || option === void 0 ? void 0 : option.value }, { children: (option === null || option === void 0 ? void 0 : option.label) ? option === null || option === void 0 ? void 0 : option.label : option === null || option === void 0 ? void 0 : option.value }), index));
                        }
                    }) })), multiple ? null : (0, jsx_runtime_1.jsx)(SelectIcon, {})] }));
});
exports["default"] = NativeSelectInput;
//# sourceMappingURL=NativeSelectInput.js.map

/***/ }),

/***/ 1727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NativeSelectInput = exports["default"] = void 0;
var NativeSelect_1 = __webpack_require__(21718);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(NativeSelect_1).default; } }));
var NativeSelectInput_1 = __webpack_require__(73617);
Object.defineProperty(exports, "NativeSelectInput", ({ enumerable: true, get: function () { return __importDefault(NativeSelectInput_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 89832:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var form_control_1 = __webpack_require__(42329);
var style = __importStar(__webpack_require__(35307));
function NotchedOutline(_a) {
    var children = _a.children, className = _a.className, label = _a.label, notched = _a.notched, rest = __rest(_a, ["children", "className", "label", "notched"]);
    var formControl = (0, form_control_1.useFormControl)();
    var withLabel = label != null && label !== '';
    return ((0, jsx_runtime_1.jsx)("fieldset", __assign({ "aria-hidden": true, className: className }, rest, { css: style.fieldset(!!formControl.error, Boolean(formControl.focused)) }, { children: (0, jsx_runtime_1.jsx)("legend", __assign({ css: style.legend(Boolean(formControl.focused || formControl.filled || notched)) }, { children: withLabel ? (0, jsx_runtime_1.jsx)("span", { children: label }) : (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" })) })) })));
}
exports["default"] = NotchedOutline;
//# sourceMappingURL=NotchedOutline.js.map

/***/ }),

/***/ 35307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.legend = exports.fieldset = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var fieldset = function (error, focused) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: left;\n  position: absolute;\n  inset: -0.625rem 0 0;\n  margin: 0px;\n  padding: 0px 10px;\n  pointer-events: none;\n  border-radius: inherit;\n  border-style: solid;\n  border-width: 1px;\n  overflow: hidden;\n  min-width: 0%;\n  border-color: ", ";\n  transition: border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  ", "\n"], ["\n  text-align: left;\n  position: absolute;\n  inset: -0.625rem 0 0;\n  margin: 0px;\n  padding: 0px 10px;\n  pointer-events: none;\n  border-radius: inherit;\n  border-style: solid;\n  border-width: 1px;\n  overflow: hidden;\n  min-width: 0%;\n  border-color: ", ";\n  transition: border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  ", "\n"])), error ? tokens_1.colors.red400 : tokens_1.colors.gray400, focused &&
    "border-color: ".concat(error ? tokens_1.colors.red400 : tokens_1.colors.blue400, ";  \n  ")); };
exports.fieldset = fieldset;
var legend = function (shrink) { return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  float: unset;\n  overflow: hidden;\n  display: block;\n  width: auto;\n  padding: 0px;\n  height: 1.25rem;\n  font-size: 0.875rem;\n  line-height: 1em;\n  visibility: hidden;\n  max-width: ", ";\n  transition: max-width ", " cubic-bezier(0, 0, 0.2, 1) 0ms;\n  white-space: nowrap;\n\n  span {\n    padding: 0.1875rem 0.25rem;\n    display: inline-block;\n    opacity: 0;\n    visibility: visible;\n  }\n"], ["\n  float: unset;\n  overflow: hidden;\n  display: block;\n  width: auto;\n  padding: 0px;\n  height: 1.25rem;\n  font-size: 0.875rem;\n  line-height: 1em;\n  visibility: hidden;\n  max-width: ", ";\n  transition: max-width ", " cubic-bezier(0, 0, 0.2, 1) 0ms;\n  white-space: nowrap;\n\n  span {\n    padding: 0.1875rem 0.25rem;\n    display: inline-block;\n    opacity: 0;\n    visibility: visible;\n  }\n"])), shrink ? '100%' : '0.01px', shrink ? '100ms' : '50ms'); };
exports.legend = legend;
var templateObject_1, templateObject_2;
//# sourceMappingURL=NotchedOutline.style.js.map

/***/ }),

/***/ 74590:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var input_base_1 = __importDefault(__webpack_require__(10635));
var NotchedOutline_1 = __importDefault(__webpack_require__(89832));
var style = __importStar(__webpack_require__(17910));
var form_control_1 = __webpack_require__(42329);
var OutlinedInput = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, label = _a.label, _c = _a.multiline, multiline = _c === void 0 ? false : _c, required = _a.required, _d = _a.type, type = _d === void 0 ? 'text' : _d, error = _a.error, rest = __rest(_a, ["fullWidth", "label", "multiline", "required", "type", "error"]);
    var fcs = (0, form_control_1.useFormControl)();
    return ((0, jsx_runtime_1.jsx)(input_base_1.default, __assign({ fullWidth: fullWidth, styles: { root: style.root(__assign(__assign({ error: error }, fcs), rest)), input: style.input(__assign({}, rest)) }, renderSuffix: function (_) { return ((0, jsx_runtime_1.jsx)(NotchedOutline_1.default, { label: label, notched: Boolean((rest === null || rest === void 0 ? void 0 : rest.startAdornment) || fcs.filled || fcs.focused) })); }, multiline: multiline, inputRef: ref, type: type }, rest)));
});
OutlinedInput.displayName = 'PrezzeeOutlinedInput';
exports["default"] = OutlinedInput;
//# sourceMappingURL=OutlinedInput.js.map

/***/ }),

/***/ 17910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.input = exports.root = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var root = function (_a) {
    var error = _a.error, focused = _a.focused, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment;
    return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n\n  ", "\n  ", "\n\n  ", "\n"], ["\n  border-radius: 4px;\n\n  ", "\n  ", "\n\n  ", "\n"])), startAdornment && 'padding-left: 14px;', endAdornment && 'padding-right: 14px;', !focused &&
        "\n  &:hover {\n    fieldset {\n      border-color: ".concat(error ? tokens_1.colors.red400 : tokens_1.colors.gray600, ";\n    }\n  }\n  "));
};
exports.root = root;
var input = function (_a) {
    var startAdornment = _a.startAdornment, endAdornment = _a.endAdornment;
    return (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0.8125rem 1rem 0.9375rem; //adjusting for 2px font offset\n  color: ", ";\n  line-height: 1.375rem;\n  box-sizing: border-box;\n  height: 3.125rem;\n\n  ", "\n  ", "\n"], ["\n  padding: 0.8125rem 1rem 0.9375rem; //adjusting for 2px font offset\n  color: ", ";\n  line-height: 1.375rem;\n  box-sizing: border-box;\n  height: 3.125rem;\n\n  ", "\n  ", "\n"])), tokens_1.colors.gray800, startAdornment && 'padding-left: 0px;', endAdornment && 'padding-right: 0px;');
};
exports.input = input;
var templateObject_1, templateObject_2;
//# sourceMappingURL=OutlinedInput.style.js.map

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var OutlinedInput_1 = __webpack_require__(74590);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(OutlinedInput_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var style = __importStar(__webpack_require__(82591));
var theme_1 = __webpack_require__(72265);
var Paper = (0, react_1.forwardRef)(function (props, ref) {
    var theme = (0, theme_1.useTheme)();
    var children = props.children, className = props.className, _a = props.component, component = _a === void 0 ? 'div' : _a, _b = props.elevation, elevation = _b === void 0 ? 'sm' : _b, role = props.role, _c = props.square, square = _c === void 0 ? false : _c, _d = props.variant, variant = _d === void 0 ? 'elevation' : _d, other = __rest(props, ["children", "className", "component", "elevation", "role", "square", "variant"]);
    var ownerState = __assign(__assign({}, props), { component: component, elevation: elevation, square: square, variant: variant });
    // if (process.env.NODE_ENV !== 'production') {
    //   // eslint-disable-next-line react-hooks/rules-of-hooks
    //   const theme = useTheme();
    //   if (theme.shadows[elevation] === undefined) {
    //     console.error(
    //       [
    //         `The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
    //         `Please make sure that \`theme.shadows[${elevation}]\` is defined.`,
    //       ].join('\n'),
    //     );
    //   }
    // }
    var PaperRoot = component;
    // TODO: add ref here
    return (
    // @ts-ignore
    (0, jsx_runtime_1.jsx)(PaperRoot, __assign({ css: style.root(ownerState, theme), className: className, ref: ref, role: role }, other, { children: children })));
});
exports["default"] = Paper;
//# sourceMappingURL=Paper.js.map

/***/ }),

/***/ 82591:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.root = void 0;
var react_1 = __webpack_require__(43234);
var root = function (state, theme) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  color: ", ";\n  transition: ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  background-color: white;\n  color: ", ";\n  transition: ", ";\n  ", "\n  ", "\n  ", "\n"])), theme.palette.text.primary, theme.transitions.create('box-shadow'), !state.square && "border-radius: ".concat(4, "px;"), state.variant === 'outlined' && "border: 1px solid ".concat('blue', ";"), state.variant === 'elevation' && "box-shadow: ".concat(theme.shadows[state.elevation], ";")); };
exports.root = root;
var templateObject_1;
//# sourceMappingURL=Paper.style.js.map

/***/ }),

/***/ 58679:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Paper_1 = __webpack_require__(26649);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Paper_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33454:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getOffsetLeft = exports.getOffsetTop = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var React = __importStar(__webpack_require__(67294));
var utils_1 = __webpack_require__(48247);
var grow_1 = __importDefault(__webpack_require__(90925));
var modal_1 = __importDefault(__webpack_require__(97249));
var paper_1 = __importDefault(__webpack_require__(58679));
var styled_1 = __importDefault(__webpack_require__(6029));
var style = __importStar(__webpack_require__(19114));
function getOffsetTop(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') {
        offset = vertical;
    }
    else if (vertical === 'center') {
        offset = rect.height / 2;
    }
    else if (vertical === 'bottom') {
        offset = rect.height;
    }
    return offset;
}
exports.getOffsetTop = getOffsetTop;
function getOffsetLeft(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') {
        offset = horizontal;
    }
    else if (horizontal === 'center') {
        offset = rect.width / 2;
    }
    else if (horizontal === 'right') {
        offset = rect.width;
    }
    return offset;
}
exports.getOffsetLeft = getOffsetLeft;
function getTransformOriginValue(transformOrigin) {
    return [transformOrigin.horizontal, transformOrigin.vertical]
        .map(function (n) { return (typeof n === 'number' ? "".concat(n, "px") : n); })
        .join(' ');
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var PopoverPaper = (0, styled_1.default)(paper_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style.paper);
var Popover = React.forwardRef(function (props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _a = props.anchorOrigin, anchorOrigin = _a === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _a, anchorPosition = props.anchorPosition, _b = props.anchorReference, anchorReference = _b === void 0 ? 'anchorEl' : _b, children = props.children, className = props.className, containerProp = props.container, _c = props.elevation, elevation = _c === void 0 ? 'sm' : _c, _d = props.marginThreshold, marginThreshold = _d === void 0 ? 16 : _d, open = props.open, _e = props.PaperProps, PaperProps = _e === void 0 ? {} : _e, _f = props.transformOrigin, transformOrigin = _f === void 0 ? {
        vertical: 'top',
        horizontal: 'left',
    } : _f, _g = props.TransitionComponent, TransitionComponent = _g === void 0 ? grow_1.default : _g, _h = props.transitionDuration, transitionDurationProp = _h === void 0 ? 'auto' : _h, _j = props.TransitionProps, _k = _j === void 0 ? {} : _j, onEntering = _k.onEntering, TransitionProps = __rest(_k, ["onEntering"]), other = __rest(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
    var paperRef = React.useRef();
    // @ts-ignore
    var handlePaperRef = (0, utils_1.useForkRef)(paperRef, PaperProps.ref);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = React.useCallback(function () {
        if (anchorReference === 'anchorPosition') {
            if (false) {}
            return anchorPosition;
        }
        var resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1
            ? resolvedAnchorEl
            : (0, utils_1.ownerDocument)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        if (false) { var box; }
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal),
        };
    }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);
    // Returns the base transform origin using the element
    var getTransformOrigin = React.useCallback(function (elemRect) {
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal),
        };
    }, [transformOrigin.horizontal, transformOrigin.vertical]);
    var getPositioningStyle = React.useCallback(function (element) {
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
        };
        // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') {
            return {
                top: null,
                left: null,
                transformOrigin: getTransformOriginValue(elemTransformOrigin),
            };
        }
        // Get the offset of the anchoring element
        var anchorOffset = getAnchorOffset();
        // Calculate element positioning
        var top = (anchorOffset === null || anchorOffset === void 0 ? void 0 : anchorOffset.top) - elemTransformOrigin.vertical;
        var left = (anchorOffset === null || anchorOffset === void 0 ? void 0 : anchorOffset.left) - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        var containerWindow = (0, utils_1.ownerWindow)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        else if (bottom > heightThreshold) {
            var diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (false) {}
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            var diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        else if (right > widthThreshold) {
            var diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: getTransformOriginValue(elemTransformOrigin),
        };
    }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
    var setPositioningStyles = React.useCallback(function () {
        var element = paperRef.current;
        if (!element) {
            return;
        }
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) {
            element.style.top = positioning.top;
        }
        if (positioning.left !== null) {
            element.style.left = positioning.left;
        }
        element.style.transformOrigin = positioning.transformOrigin;
    }, [getPositioningStyle]);
    var handleEntering = function (element, isAppearing) {
        if (onEntering) {
            onEntering(element, isAppearing);
        }
        setPositioningStyles();
    };
    React.useEffect(function () {
        if (open) {
            setPositioningStyles();
        }
    });
    React.useImperativeHandle(action, function () {
        return open
            ? {
                updatePosition: function () {
                    setPositioningStyles();
                },
            }
            : null;
    }, [open, setPositioningStyles]);
    React.useEffect(function () {
        if (!open) {
            return undefined;
        }
        var handleResize = (0, utils_1.debounce)(function () {
            setPositioningStyles();
        });
        var containerWindow = (0, utils_1.ownerWindow)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return function () {
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [anchorEl, open, setPositioningStyles]);
    var transitionDuration = transitionDurationProp;
    // @ts-ignore
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        // @ts-ignore
        transitionDuration = undefined;
    }
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, utils_1.ownerDocument)(resolveAnchorEl(anchorEl)).body : undefined);
    return ((0, jsx_runtime_1.jsx)(modal_1.default
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        BackdropProps: { invisible: true }, className: className, container: container, open: open, ref: ref }, other, { children: (0, jsx_runtime_1.jsx)(TransitionComponent, __assign({ appear: true, in: open, onEntering: handleEntering, timeout: transitionDuration }, TransitionProps, { children: (0, jsx_runtime_1.jsx)(PopoverPaper, __assign({ elevation: elevation }, PaperProps, { 
                // @ts-ignore
                ref: handlePaperRef, className: PaperProps.className }, { children: children })) })) })));
});
exports["default"] = Popover;
var templateObject_1;
//# sourceMappingURL=Popover.js.map

/***/ }),

/***/ 19114:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paper = void 0;
var react_1 = __webpack_require__(43234);
exports.paper = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  // So we see the popover when its empty.\n  // Its most likely on issue on userland.\n  min-width: 16px;\n  min-height: 16px;\n  max-width: calc(100% - 32px);\n  max-height: calc(100% - 32px);\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n"], ["\n  position: absolute;\n  overflow-y: auto;\n  overflow-x: hidden;\n  // So we see the popover when its empty.\n  // Its most likely on issue on userland.\n  min-width: 16px;\n  min-height: 16px;\n  max-width: calc(100% - 32px);\n  max-height: calc(100% - 32px);\n  // We disable the focus ring for mouse; touch and keyboard users.\n  outline: 0;\n"])));
var templateObject_1;
//# sourceMappingURL=Popover.style.js.map

/***/ }),

/***/ 1604:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Popover_1 = __webpack_require__(33454);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Popover_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 74133:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var react_dom_1 = __webpack_require__(73935);
var utils_1 = __webpack_require__(48247);
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */
var Portal = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, container = props.container, _a = props.disablePortal, disablePortal = _a === void 0 ? false : _a;
    var _b = __read((0, react_1.useState)(null), 2), mountNode = _b[0], setMountNode = _b[1];
    // @ts-ignore
    var handleRef = (0, utils_1.useForkRef)((0, react_1.isValidElement)(children) ? children.ref : null, ref);
    (0, utils_1.useEnhancedEffect)(function () {
        if (!disablePortal) {
            setMountNode(getContainer(container) || document.body);
        }
    }, [container, disablePortal]);
    (0, utils_1.useEnhancedEffect)(function () {
        if (mountNode && !disablePortal) {
            (0, utils_1.setRef)(ref, mountNode);
            return function () {
                (0, utils_1.setRef)(ref, null);
            };
        }
        return undefined;
    }, [ref, mountNode, disablePortal]);
    if (disablePortal) {
        if ((0, react_1.isValidElement)(children)) {
            return (0, react_1.cloneElement)(children, {
                ref: handleRef,
            });
        }
        return children;
    }
    return mountNode ? (0, react_dom_1.createPortal)(children, mountNode) : mountNode;
});
exports["default"] = Portal;
//# sourceMappingURL=Portal.js.map

/***/ }),

/***/ 8444:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Portal_1 = __webpack_require__(74133);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Portal_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82231:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var Radio_style_1 = __importDefault(__webpack_require__(60597));
var Radio = (0, react_1.forwardRef)(function (_a, ref) {
    var checked = _a.checked, children = _a.children, className = _a.className, defaultChecked = _a.defaultChecked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, id = _a.id, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.unselected, unselected = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'standard' : _e, rest = __rest(_a, ["checked", "children", "className", "defaultChecked", "disabled", "id", "label", "name", "onBlur", "onChange", "onFocus", "fullWidth", "unselected", "variant"]);
    var _f = __read((0, react_1.useState)(false), 2), focused = _f[0], setFocused = _f[1];
    var handleFocus = function (event) {
        setFocused(true);
        onFocus && onFocus(event);
    };
    var handleBlur = function (event) {
        setFocused(false);
        onBlur && onBlur(event);
    };
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: id, className: className, css: (0, Radio_style_1.default)(disabled, fullWidth, variant, unselected, focused) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ id: id, ref: ref, name: name, type: 'radio', checked: checked, defaultChecked: defaultChecked, disabled: disabled, onChange: onChange, onFocus: handleFocus, onBlur: handleBlur }, rest)), variant === 'contained' ? (0, jsx_runtime_1.jsx)("span", __assign({ className: "radio-span" }, { children: label })) : label, children] })));
});
Radio.displayName = 'PrezzeeRadio';
exports["default"] = Radio;
//# sourceMappingURL=Radio.js.map

/***/ }),

/***/ 60597:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
var transitionTime = '0.125s';
var disabledStyle = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  span {\n    color: ", " !important;\n    cursor: not-allowed !important;\n    background-color: ", " !important;\n    border: 1px solid ", " !important;\n  }\n"], ["\n  span {\n    color: ", " !important;\n    cursor: not-allowed !important;\n    background-color: ", " !important;\n    border: 1px solid ", " !important;\n  }\n"])), tokens_1.colors.gray300, tokens_1.colors.white, tokens_1.colors.gray300);
var fullWidthStyle = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var containedStyle = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-grid;\n  height: 100%;\n\n  &:hover .radio-span {\n    cursor: pointer;\n    color: ", ";\n    background-color: ", ";\n    transition-duration: 0.3s;\n    transition-property: background-color color;\n  }\n\n  input[type='radio'] {\n    position: fixed;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  span {\n    width: 100%;\n    display: flex;\n    border: 1px solid ", ";\n    color: ", ";\n    border-radius: 4px;\n    padding: 12px;\n    padding-bottom: 13px; // Vertically centers text\n    font-weight: 500;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    grid-template-columns: 1em auto;\n  }\n\n  input[type='radio']:checked + .radio-span {\n    color: ", ";\n    background-color: ", ";\n    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n  }\n"], ["\n  display: inline-grid;\n  height: 100%;\n\n  &:hover .radio-span {\n    cursor: pointer;\n    color: ", ";\n    background-color: ", ";\n    transition-duration: 0.3s;\n    transition-property: background-color color;\n  }\n\n  input[type='radio'] {\n    position: fixed;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  span {\n    width: 100%;\n    display: flex;\n    border: 1px solid ", ";\n    color: ", ";\n    border-radius: 4px;\n    padding: 12px;\n    padding-bottom: 13px; // Vertically centers text\n    font-weight: 500;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    grid-template-columns: 1em auto;\n  }\n\n  input[type='radio']:checked + .radio-span {\n    color: ", ";\n    background-color: ", ";\n    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.11);\n  }\n"])), tokens_1.colors.white, tokens_1.colors.purple600, tokens_1.colors.gray800, tokens_1.colors.gray800, tokens_1.colors.white, tokens_1.colors.purple400);
var standardStyle = (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-grid;\n  grid-template-columns: 1em auto;\n  gap: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  input[type='radio'] {\n    appearance: none;\n    background-color: ", ";\n    margin: 0;\n    font: inherit;\n    color: currentColor;\n    width: 18px;\n    height: 18px;\n    border: 2px solid ", ";\n    border-radius: 50%;\n    transform: translateY(-0.075em);\n    display: grid;\n    place-content: center;\n    position: relative;\n\n    :hover {\n      border: 2px solid ", ";\n    }\n\n    &::before {\n      content: '';\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      display: block;\n      transition: background-color ", " ease;\n      background-color: transparent;\n    }\n\n    &:hover,\n    &:focus {\n      &::before {\n        cursor: pointer;\n        background-color: ", ";\n      }\n    }\n\n    &:checked {\n      border: 2px solid ", ";\n      &::before {\n        background-color: ", ";\n      }\n    }\n\n    &:disabled {\n      border-color: ", ";\n      cursor: not-allowed;\n    }\n  }\n"], ["\n  display: inline-grid;\n  grid-template-columns: 1em auto;\n  gap: ", ";\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  input[type='radio'] {\n    appearance: none;\n    background-color: ", ";\n    margin: 0;\n    font: inherit;\n    color: currentColor;\n    width: 18px;\n    height: 18px;\n    border: 2px solid ", ";\n    border-radius: 50%;\n    transform: translateY(-0.075em);\n    display: grid;\n    place-content: center;\n    position: relative;\n\n    :hover {\n      border: 2px solid ", ";\n    }\n\n    &::before {\n      content: '';\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      display: block;\n      transition: background-color ", " ease;\n      background-color: transparent;\n    }\n\n    &:hover,\n    &:focus {\n      &::before {\n        cursor: pointer;\n        background-color: ", ";\n      }\n    }\n\n    &:checked {\n      border: 2px solid ", ";\n      &::before {\n        background-color: ", ";\n      }\n    }\n\n    &:disabled {\n      border-color: ", ";\n      cursor: not-allowed;\n    }\n  }\n"])), tokens_1.spacing.spacing03, tokens_1.colors.white, tokens_1.colors.gray600, tokens_1.colors.purple400, transitionTime, tokens_1.colors.gray100, tokens_1.colors.purple400, tokens_1.colors.purple400, tokens_1.colors.gray300);
var unselectedStyle = (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  span {\n    color: ", ";\n    border: 1px solid ", ";\n  }\n"], ["\n  span {\n    color: ", ";\n    border: 1px solid ", ";\n  }\n"])), tokens_1.colors.gray600, tokens_1.colors.gray600);
var focusedStyle = (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  span {\n    outline: 5px auto Highlight;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n"], ["\n  span {\n    outline: 5px auto Highlight;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n"])));
exports["default"] = (function (disabled, fullWidth, variant, unselected, focused) { return (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), fullWidth && fullWidthStyle, variant === 'contained' && containedStyle, variant === 'standard' && standardStyle, unselected && unselectedStyle, disabled && disabledStyle, focused && focusedStyle); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=Radio.style.js.map

/***/ }),

/***/ 11834:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Radio_1 = __webpack_require__(82231);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Radio_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 64657:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  accordionAnatomy: () => accordionAnatomy,
  alertAnatomy: () => alertAnatomy,
  anatomy: () => anatomy,
  avatarAnatomy: () => avatarAnatomy,
  breadcrumbAnatomy: () => breadcrumbAnatomy,
  buttonAnatomy: () => buttonAnatomy,
  cardAnatomy: () => cardAnatomy,
  checkboxAnatomy: () => checkboxAnatomy,
  circularProgressAnatomy: () => circularProgressAnatomy,
  drawerAnatomy: () => drawerAnatomy,
  editableAnatomy: () => editableAnatomy,
  formAnatomy: () => formAnatomy,
  formErrorAnatomy: () => formErrorAnatomy,
  inputAnatomy: () => inputAnatomy,
  listAnatomy: () => listAnatomy,
  menuAnatomy: () => menuAnatomy,
  modalAnatomy: () => modalAnatomy,
  numberInputAnatomy: () => numberInputAnatomy,
  pinInputAnatomy: () => pinInputAnatomy,
  popoverAnatomy: () => popoverAnatomy,
  progressAnatomy: () => progressAnatomy,
  radioAnatomy: () => radioAnatomy,
  selectAnatomy: () => selectAnatomy,
  sliderAnatomy: () => sliderAnatomy,
  statAnatomy: () => statAnatomy,
  switchAnatomy: () => switchAnatomy,
  tableAnatomy: () => tableAnatomy,
  tabsAnatomy: () => tabsAnatomy,
  tagAnatomy: () => tagAnatomy
});
module.exports = __toCommonJS(src_exports);

// src/anatomy.ts
function anatomy(name, map = {}) {
  let called = false;
  function assert() {
    if (!called) {
      called = true;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function parts(...values) {
    assert();
    for (const part of values) {
      ;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function extend(...parts2) {
    for (const part of parts2) {
      if (part in map)
        continue;
      map[part] = toPart(part);
    }
    return anatomy(name, map);
  }
  function selectors() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.selector])
    );
    return value;
  }
  function classnames() {
    const value = Object.fromEntries(
      Object.entries(map).map(([key, part]) => [key, part.className])
    );
    return value;
  }
  function toPart(part) {
    const el = ["container", "root"].includes(part != null ? part : "") ? [name] : [name, part];
    const attr = el.filter(Boolean).join("__");
    const className = `chakra-${attr}`;
    const partObj = {
      className,
      selector: `.${className}`,
      toString: () => part
    };
    return partObj;
  }
  const __type = {};
  return {
    parts,
    toPart,
    extend,
    selectors,
    classnames,
    get keys() {
      return Object.keys(map);
    },
    __type
  };
}

// src/components.ts
var accordionAnatomy = anatomy("accordion").parts("root", "container", "button", "panel").extend("icon");
var alertAnatomy = anatomy("alert").parts("title", "description", "container").extend("icon", "spinner");
var avatarAnatomy = anatomy("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
var breadcrumbAnatomy = anatomy("breadcrumb").parts("link", "item", "container").extend("separator");
var buttonAnatomy = anatomy("button").parts();
var checkboxAnatomy = anatomy("checkbox").parts("control", "icon", "container").extend("label");
var circularProgressAnatomy = anatomy("progress").parts("track", "filledTrack").extend("label");
var drawerAnatomy = anatomy("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var editableAnatomy = anatomy("editable").parts(
  "preview",
  "input",
  "textarea"
);
var formAnatomy = anatomy("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
var formErrorAnatomy = anatomy("formError").parts("text", "icon");
var inputAnatomy = anatomy("input").parts("addon", "field", "element");
var listAnatomy = anatomy("list").parts("container", "item", "icon");
var menuAnatomy = anatomy("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var modalAnatomy = anatomy("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
var numberInputAnatomy = anatomy("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
var pinInputAnatomy = anatomy("pininput").parts("field");
var popoverAnatomy = anatomy("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
var progressAnatomy = anatomy("progress").parts(
  "label",
  "filledTrack",
  "track"
);
var radioAnatomy = anatomy("radio").parts(
  "container",
  "control",
  "label"
);
var selectAnatomy = anatomy("select").parts("field", "icon");
var sliderAnatomy = anatomy("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
var statAnatomy = anatomy("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
var switchAnatomy = anatomy("switch").parts(
  "container",
  "track",
  "thumb"
);
var tableAnatomy = anatomy("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
var tabsAnatomy = anatomy("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
var tagAnatomy = anatomy("tag").parts(
  "container",
  "label",
  "closeButton"
);
var cardAnatomy = anatomy("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 88760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ColorModeContext: () => ColorModeContext,
  ColorModeProvider: () => ColorModeProvider,
  ColorModeScript: () => ColorModeScript,
  DarkMode: () => DarkMode,
  LightMode: () => LightMode,
  cookieStorageManager: () => cookieStorageManager,
  cookieStorageManagerSSR: () => cookieStorageManagerSSR,
  createCookieStorageManager: () => createCookieStorageManager,
  createLocalStorageManager: () => createLocalStorageManager,
  getScriptSrc: () => getScriptSrc,
  localStorageManager: () => localStorageManager,
  useColorMode: () => useColorMode,
  useColorModeValue: () => useColorModeValue
});
module.exports = __toCommonJS(src_exports);

// src/color-mode-provider.tsx
var import_react_use_safe_layout_effect = __webpack_require__(24122);
var import_react2 = __webpack_require__(67294);

// src/color-mode-context.ts
var import_react = __webpack_require__(67294);
var ColorModeContext = (0, import_react.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0, import_react.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}

// src/color-mode.utils.ts
var classNames = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
};
function getColorModeUtils(options = {}) {
  const { preventTransition = true } = options;
  const utils = {
    setDataset: (value) => {
      const cleanup = preventTransition ? utils.preventTransition() : void 0;
      document.documentElement.dataset.theme = value;
      document.documentElement.style.colorScheme = value;
      cleanup == null ? void 0 : cleanup();
    },
    setClassName(dark) {
      document.body.classList.add(dark ? classNames.dark : classNames.light);
      document.body.classList.remove(dark ? classNames.light : classNames.dark);
    },
    query() {
      return window.matchMedia("(prefers-color-scheme: dark)");
    },
    getSystemTheme(fallback) {
      var _a;
      const dark = (_a = utils.query().matches) != null ? _a : fallback === "dark";
      return dark ? "dark" : "light";
    },
    addListener(fn) {
      const mql = utils.query();
      const listener = (e) => {
        fn(e.matches ? "dark" : "light");
      };
      if (typeof mql.addListener === "function")
        mql.addListener(listener);
      else
        mql.addEventListener("change", listener);
      return () => {
        if (typeof mql.removeListener === "function")
          mql.removeListener(listener);
        else
          mql.removeEventListener("change", listener);
      };
    },
    preventTransition() {
      const css = document.createElement("style");
      css.appendChild(
        document.createTextNode(
          `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
        )
      );
      document.head.appendChild(css);
      return () => {
        ;
        (() => window.getComputedStyle(document.body))();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            document.head.removeChild(css);
          });
        });
      };
    }
  };
  return utils;
}

// src/storage-manager.ts
var STORAGE_KEY = "chakra-ui-color-mode";
function createLocalStorageManager(key) {
  return {
    ssr: false,
    type: "localStorage",
    get(init) {
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      let value;
      try {
        value = localStorage.getItem(key) || init;
      } catch (e) {
      }
      return value || init;
    },
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
      }
    }
  };
}
var localStorageManager = createLocalStorageManager(STORAGE_KEY);
function parseCookie(cookie, key) {
  const match = cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
  return match == null ? void 0 : match[2];
}
function createCookieStorageManager(key, cookie) {
  return {
    ssr: !!cookie,
    type: "cookie",
    get(init) {
      if (cookie)
        return parseCookie(cookie, key);
      if (!(globalThis == null ? void 0 : globalThis.document))
        return init;
      return parseCookie(document.cookie, key) || init;
    },
    set(value) {
      document.cookie = `${key}=${value}; max-age=31536000; path=/`;
    }
  };
}
var cookieStorageManager = createCookieStorageManager(STORAGE_KEY);
var cookieStorageManagerSSR = (cookie) => createCookieStorageManager(STORAGE_KEY, cookie);

// src/color-mode-provider.tsx
var import_jsx_runtime = __webpack_require__(85893);
var noop = () => {
};
function getTheme(manager, fallback) {
  return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
}
function ColorModeProvider(props) {
  const {
    value,
    children,
    options: {
      useSystemColorMode,
      initialColorMode,
      disableTransitionOnChange
    } = {},
    colorModeManager = localStorageManager
  } = props;
  const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
  const [colorMode, rawSetColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager, defaultColorMode)
  );
  const [resolvedColorMode, setResolvedColorMode] = (0, import_react2.useState)(
    () => getTheme(colorModeManager)
  );
  const { getSystemTheme, setClassName, setDataset, addListener } = (0, import_react2.useMemo)(
    () => getColorModeUtils({ preventTransition: disableTransitionOnChange }),
    [disableTransitionOnChange]
  );
  const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
  const setColorMode = (0, import_react2.useCallback)(
    (value2) => {
      const resolved = value2 === "system" ? getSystemTheme() : value2;
      rawSetColorMode(resolved);
      setClassName(resolved === "dark");
      setDataset(resolved);
      colorModeManager.set(resolved);
    },
    [colorModeManager, getSystemTheme, setClassName, setDataset]
  );
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (initialColorMode === "system") {
      setResolvedColorMode(getSystemTheme());
    }
  }, []);
  (0, import_react2.useEffect)(() => {
    const managerValue = colorModeManager.get();
    if (managerValue) {
      setColorMode(managerValue);
      return;
    }
    if (initialColorMode === "system") {
      setColorMode("system");
      return;
    }
    setColorMode(defaultColorMode);
  }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
  const toggleColorMode = (0, import_react2.useCallback)(() => {
    setColorMode(resolvedValue === "dark" ? "light" : "dark");
  }, [resolvedValue, setColorMode]);
  (0, import_react2.useEffect)(() => {
    if (!useSystemColorMode)
      return;
    return addListener(setColorMode);
  }, [useSystemColorMode, addListener, setColorMode]);
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: value != null ? value : resolvedValue,
      toggleColorMode: value ? noop : toggleColorMode,
      setColorMode: value ? noop : setColorMode,
      forced: value !== void 0
    }),
    [resolvedValue, toggleColorMode, setColorMode, value]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, children });
}
ColorModeProvider.displayName = "ColorModeProvider";
function DarkMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "dark",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
DarkMode.displayName = "DarkMode";
function LightMode(props) {
  const context = (0, import_react2.useMemo)(
    () => ({
      colorMode: "light",
      toggleColorMode: noop,
      setColorMode: noop,
      forced: true
    }),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ColorModeContext.Provider, { value: context, ...props });
}
LightMode.displayName = "LightMode";

// src/color-mode-script.tsx
var import_jsx_runtime2 = __webpack_require__(85893);
var VALID_VALUES = /* @__PURE__ */ new Set(["dark", "light", "system"]);
function normalize(initialColorMode) {
  let value = initialColorMode;
  if (!VALID_VALUES.has(value))
    value = "light";
  return value;
}
function getScriptSrc(props = {}) {
  const {
    initialColorMode = "light",
    type = "localStorage",
    storageKey: key = "chakra-ui-color-mode"
  } = props;
  const init = normalize(initialColorMode);
  const isCookie = type === "cookie";
  const cookieScript = `(function(){try{var a=function(o){var l="(prefers-color-scheme: dark)",v=window.matchMedia(l).matches?"dark":"light",e=o==="system"?v:o,d=document.documentElement,m=document.body,i="chakra-ui-light",n="chakra-ui-dark",s=e==="dark";return m.classList.add(s?n:i),m.classList.remove(s?i:n),d.style.colorScheme=e,d.dataset.theme=e,e},u=a,h="${init}",r="${key}",t=document.cookie.match(new RegExp("(^| )".concat(r,"=([^;]+)"))),c=t?t[2]:null;c?a(c):document.cookie="".concat(r,"=").concat(a(h),"; max-age=31536000; path=/")}catch(a){}})();
  `;
  const localStorageScript = `(function(){try{var a=function(c){var v="(prefers-color-scheme: dark)",h=window.matchMedia(v).matches?"dark":"light",r=c==="system"?h:c,o=document.documentElement,s=document.body,l="chakra-ui-light",d="chakra-ui-dark",i=r==="dark";return s.classList.add(i?d:l),s.classList.remove(i?l:d),o.style.colorScheme=r,o.dataset.theme=r,r},n=a,m="${init}",e="${key}",t=localStorage.getItem(e);t?a(t):localStorage.setItem(e,a(m))}catch(a){}})();
  `;
  const fn = isCookie ? cookieScript : localStorageScript;
  return `!${fn}`.trim();
}
function ColorModeScript(props = {}) {
  const { nonce } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "script",
    {
      id: "chakra-script",
      nonce,
      dangerouslySetInnerHTML: { __html: getScriptSrc(props) }
    }
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 25:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSPolyfill: () => CSSPolyfill,
  CSSReset: () => CSSReset,
  default: () => css_reset_default
});
module.exports = __toCommonJS(src_exports);

// src/css-reset.tsx
var import_react = __webpack_require__(43234);
var import_jsx_runtime = __webpack_require__(85893);
var css = String.raw;
var vhPolyfill = css`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
var CSSPolyfill = () => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.Global, { styles: vhPolyfill });
var CSSReset = ({ scope = "" }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  import_react.Global,
  {
    styles: css`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${vhPolyfill}
    `
  }
);
var css_reset_default = CSSReset;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 59721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  FocusLock: () => FocusLock
});
module.exports = __toCommonJS(src_exports);

// src/focus-lock.tsx
var import_react_focus_lock = __toESM(__webpack_require__(37096));
var import_dom_utils = __webpack_require__(85080);
var import_react = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
var _a;
var FocusTrap = (_a = import_react_focus_lock.default.default) != null ? _a : import_react_focus_lock.default;
var FocusLock = (props) => {
  const {
    initialFocusRef,
    finalFocusRef,
    contentRef,
    restoreFocus,
    children,
    isDisabled,
    autoFocus,
    persistentFocus,
    lockFocusAcrossFrames
  } = props;
  const onActivation = (0, import_react.useCallback)(() => {
    if (initialFocusRef == null ? void 0 : initialFocusRef.current) {
      initialFocusRef.current.focus();
    } else if (contentRef == null ? void 0 : contentRef.current) {
      const focusables = (0, import_dom_utils.getAllFocusable)(contentRef.current);
      if (focusables.length === 0) {
        requestAnimationFrame(() => {
          var _a2;
          (_a2 = contentRef.current) == null ? void 0 : _a2.focus();
        });
      }
    }
  }, [initialFocusRef, contentRef]);
  const onDeactivation = (0, import_react.useCallback)(() => {
    var _a2;
    (_a2 = finalFocusRef == null ? void 0 : finalFocusRef.current) == null ? void 0 : _a2.focus();
  }, [finalFocusRef]);
  const returnFocus = restoreFocus && !finalFocusRef;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    FocusTrap,
    {
      crossFrame: lockFocusAcrossFrames,
      persistentFocus,
      autoFocus,
      disabled: isDisabled,
      onActivation,
      onDeactivation,
      returnFocus,
      children
    }
  );
};
FocusLock.displayName = "FocusLock";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 21354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Icon: () => Icon,
  createIcon: () => createIcon,
  default: () => icon_default
});
module.exports = __toCommonJS(src_exports);

// src/icon.tsx
var import_system = __webpack_require__(26812);
var import_shared_utils = __webpack_require__(66307);
var import_jsx_runtime = __webpack_require__(85893);
var fallbackIcon = {
  path: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
};
var Icon = (0, import_system.forwardRef)((props, ref) => {
  const {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css,
    ...rest
  } = props;
  const _className = (0, import_shared_utils.cx)("chakra-icon", className);
  const customStyles = (0, import_system.useStyleConfig)("Icon", props);
  const styles = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color,
    ...__css,
    ...customStyles
  };
  const shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };
  const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { as: element, ...shared, ...rest });
  }
  const _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
});
Icon.displayName = "Icon";
var icon_default = Icon;

// src/create-icon.tsx
var import_system2 = __webpack_require__(26812);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = import_react.Children.toArray(options.path);
  const Comp = (0, import_system2.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Icon, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 33559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AbsoluteCenter: () => AbsoluteCenter,
  AspectRatio: () => AspectRatio,
  Badge: () => Badge,
  Box: () => Box,
  Center: () => Center,
  Circle: () => Circle,
  Code: () => Code,
  Container: () => Container,
  Divider: () => Divider,
  Flex: () => Flex,
  Grid: () => Grid,
  GridItem: () => GridItem,
  HStack: () => HStack,
  Heading: () => Heading,
  Highlight: () => Highlight,
  Indicator: () => Indicator,
  Kbd: () => Kbd,
  Link: () => Link,
  LinkBox: () => LinkBox,
  LinkOverlay: () => LinkOverlay,
  List: () => List,
  ListIcon: () => ListIcon,
  ListItem: () => ListItem,
  Mark: () => Mark,
  OrderedList: () => OrderedList,
  SimpleGrid: () => SimpleGrid,
  Spacer: () => Spacer,
  Square: () => Square,
  Stack: () => Stack,
  StackDivider: () => StackDivider,
  StackItem: () => StackItem,
  Text: () => Text,
  UnorderedList: () => UnorderedList,
  VStack: () => VStack,
  Wrap: () => Wrap,
  WrapItem: () => WrapItem,
  useHighlight: () => useHighlight,
  useListStyles: () => useListStyles
});
module.exports = __toCommonJS(src_exports);

// src/aspect-ratio.tsx
var import_system = __webpack_require__(26812);
var import_breakpoint_utils = __webpack_require__(65568);
var import_shared_utils = __webpack_require__(62513);
var import_react = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
var AspectRatio = (0, import_system.forwardRef)(function(props, ref) {
  const { ratio = 4 / 3, children, className, ...rest } = props;
  const child = import_react.Children.only(children);
  const _className = (0, import_shared_utils.cx)("chakra-aspect-ratio", className);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_system.chakra.div,
    {
      ref,
      position: "relative",
      className: _className,
      _before: {
        height: 0,
        content: `""`,
        display: "block",
        paddingBottom: (0, import_breakpoint_utils.mapResponsive)(ratio, (r) => `${1 / r * 100}%`)
      },
      __css: {
        "& > *:not(style)": {
          overflow: "hidden",
          position: "absolute",
          top: "0",
          right: "0",
          bottom: "0",
          left: "0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%"
        },
        "& > img, & > video": {
          objectFit: "cover"
        }
      },
      ...rest,
      children: child
    }
  );
});
AspectRatio.displayName = "AspectRatio";

// src/badge.tsx
var import_system2 = __webpack_require__(26812);
var import_shared_utils2 = __webpack_require__(62513);
var import_jsx_runtime2 = __webpack_require__(85893);
var Badge = (0, import_system2.forwardRef)(function Badge2(props, ref) {
  const styles = (0, import_system2.useStyleConfig)("Badge", props);
  const { className, ...rest } = (0, import_system2.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_system2.chakra.span,
    {
      ref,
      className: (0, import_shared_utils2.cx)("chakra-badge", props.className),
      ...rest,
      __css: {
        display: "inline-block",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...styles
      }
    }
  );
});
Badge.displayName = "Badge";

// src/box.tsx
var import_system3 = __webpack_require__(26812);
var import_jsx_runtime3 = __webpack_require__(85893);
var Box = (0, import_system3.chakra)("div");
Box.displayName = "Box";
var Square = (0, import_system3.forwardRef)(function Square2(props, ref) {
  const { size, centerContent = true, ...rest } = props;
  const styles = centerContent ? { display: "flex", alignItems: "center", justifyContent: "center" } : {};
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    Box,
    {
      ref,
      boxSize: size,
      __css: {
        ...styles,
        flexShrink: 0,
        flexGrow: 0
      },
      ...rest
    }
  );
});
Square.displayName = "Square";
var Circle = (0, import_system3.forwardRef)(function Circle2(props, ref) {
  const { size, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Square, { size, ref, borderRadius: "9999px", ...rest });
});
Circle.displayName = "Circle";

// src/center.tsx
var import_system4 = __webpack_require__(26812);
var import_jsx_runtime4 = __webpack_require__(85893);
var Center = (0, import_system4.chakra)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
Center.displayName = "Center";
var centerStyles = {
  horizontal: {
    insetStart: "50%",
    transform: "translateX(-50%)"
  },
  vertical: {
    top: "50%",
    transform: "translateY(-50%)"
  },
  both: {
    insetStart: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  }
};
var AbsoluteCenter = (0, import_system4.forwardRef)(
  function AbsoluteCenter2(props, ref) {
    const { axis = "both", ...rest } = props;
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      import_system4.chakra.div,
      {
        ref,
        __css: centerStyles[axis],
        ...rest,
        position: "absolute"
      }
    );
  }
);

// src/code.tsx
var import_system5 = __webpack_require__(26812);
var import_shared_utils3 = __webpack_require__(62513);
var import_jsx_runtime5 = __webpack_require__(85893);
var Code = (0, import_system5.forwardRef)(function Code2(props, ref) {
  const styles = (0, import_system5.useStyleConfig)("Code", props);
  const { className, ...rest } = (0, import_system5.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    import_system5.chakra.code,
    {
      ref,
      className: (0, import_shared_utils3.cx)("chakra-code", props.className),
      ...rest,
      __css: {
        display: "inline-block",
        ...styles
      }
    }
  );
});
Code.displayName = "Code";

// src/container.tsx
var import_system6 = __webpack_require__(26812);
var import_shared_utils4 = __webpack_require__(62513);
var import_jsx_runtime6 = __webpack_require__(85893);
var Container = (0, import_system6.forwardRef)(function Container2(props, ref) {
  const { className, centerContent, ...rest } = (0, import_system6.omitThemingProps)(props);
  const styles = (0, import_system6.useStyleConfig)("Container", props);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    import_system6.chakra.div,
    {
      ref,
      className: (0, import_shared_utils4.cx)("chakra-container", className),
      ...rest,
      __css: {
        ...styles,
        ...centerContent && {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }
    }
  );
});
Container.displayName = "Container";

// src/divider.tsx
var import_system7 = __webpack_require__(26812);
var import_shared_utils5 = __webpack_require__(62513);
var import_jsx_runtime7 = __webpack_require__(85893);
var Divider = (0, import_system7.forwardRef)(function Divider2(props, ref) {
  const {
    borderLeftWidth,
    borderBottomWidth,
    borderTopWidth,
    borderRightWidth,
    borderWidth,
    borderStyle,
    borderColor,
    ...styles
  } = (0, import_system7.useStyleConfig)("Divider", props);
  const {
    className,
    orientation = "horizontal",
    __css,
    ...rest
  } = (0, import_system7.omitThemingProps)(props);
  const dividerStyles = {
    vertical: {
      borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    import_system7.chakra.hr,
    {
      ref,
      "aria-orientation": orientation,
      ...rest,
      __css: {
        ...styles,
        border: "0",
        borderColor,
        borderStyle,
        ...dividerStyles[orientation],
        ...__css
      },
      className: (0, import_shared_utils5.cx)("chakra-divider", className)
    }
  );
});
Divider.displayName = "Divider";

// src/flex.tsx
var import_system8 = __webpack_require__(26812);
var import_jsx_runtime8 = __webpack_require__(85893);
var Flex = (0, import_system8.forwardRef)(function Flex2(props, ref) {
  const { direction, align, justify, wrap, basis, grow, shrink, ...rest } = props;
  const styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_system8.chakra.div, { ref, __css: styles, ...rest });
});
Flex.displayName = "Flex";

// src/grid.tsx
var import_system9 = __webpack_require__(26812);
var import_jsx_runtime9 = __webpack_require__(85893);
var Grid = (0, import_system9.forwardRef)(function Grid2(props, ref) {
  const {
    templateAreas,
    gap,
    rowGap,
    columnGap,
    column,
    row,
    autoFlow,
    autoRows,
    templateRows,
    autoColumns,
    templateColumns,
    ...rest
  } = props;
  const styles = {
    display: "grid",
    gridTemplateAreas: templateAreas,
    gridGap: gap,
    gridRowGap: rowGap,
    gridColumnGap: columnGap,
    gridAutoColumns: autoColumns,
    gridColumn: column,
    gridRow: row,
    gridAutoFlow: autoFlow,
    gridAutoRows: autoRows,
    gridTemplateRows: templateRows,
    gridTemplateColumns: templateColumns
  };
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_system9.chakra.div, { ref, __css: styles, ...rest });
});
Grid.displayName = "Grid";

// src/grid-item.tsx
var import_system10 = __webpack_require__(26812);
var import_object_utils = __webpack_require__(19707);
var import_breakpoint_utils2 = __webpack_require__(65568);
var import_jsx_runtime10 = __webpack_require__(85893);
function spanFn(span) {
  return (0, import_breakpoint_utils2.mapResponsive)(
    span,
    (value) => value === "auto" ? "auto" : `span ${value}/span ${value}`
  );
}
var GridItem = (0, import_system10.forwardRef)(function GridItem2(props, ref) {
  const {
    area,
    colSpan,
    colStart,
    colEnd,
    rowEnd,
    rowSpan,
    rowStart,
    ...rest
  } = props;
  const styles = (0, import_object_utils.compact)({
    gridArea: area,
    gridColumn: spanFn(colSpan),
    gridRow: spanFn(rowSpan),
    gridColumnStart: colStart,
    gridColumnEnd: colEnd,
    gridRowStart: rowStart,
    gridRowEnd: rowEnd
  });
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_system10.chakra.div, { ref, __css: styles, ...rest });
});
GridItem.displayName = "GridItem";

// src/heading.tsx
var import_system11 = __webpack_require__(26812);
var import_shared_utils6 = __webpack_require__(62513);
var import_jsx_runtime11 = __webpack_require__(85893);
var Heading = (0, import_system11.forwardRef)(function Heading2(props, ref) {
  const styles = (0, import_system11.useStyleConfig)("Heading", props);
  const { className, ...rest } = (0, import_system11.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    import_system11.chakra.h2,
    {
      ref,
      className: (0, import_shared_utils6.cx)("chakra-heading", props.className),
      ...rest,
      __css: styles
    }
  );
});
Heading.displayName = "Heading";

// src/highlight.tsx
var import_system12 = __webpack_require__(26812);
var import_react2 = __webpack_require__(67294);
var import_jsx_runtime12 = __webpack_require__(85893);
var escapeRegexp = (term) => term.replace(/[|\\{}()[\]^$+*?.-]/g, (char) => `\\${char}`);
function buildRegex(query) {
  const _query = query.filter((text) => text.length !== 0).map((text) => escapeRegexp(text.trim()));
  if (!_query.length) {
    return null;
  }
  return new RegExp(`(${_query.join("|")})`, "ig");
}
function highlightWords({ text, query }) {
  const regex = buildRegex(Array.isArray(query) ? query : [query]);
  if (!regex) {
    return [{ text, match: false }];
  }
  const result = text.split(regex).filter(Boolean);
  return result.map((str) => ({ text: str, match: regex.test(str) }));
}
function useHighlight(props) {
  const { text, query } = props;
  return (0, import_react2.useMemo)(() => highlightWords({ text, query }), [text, query]);
}
var Mark = (0, import_system12.forwardRef)(function Mark2(props, ref) {
  const styles = (0, import_system12.useStyleConfig)("Mark", props);
  const ownProps = (0, import_system12.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    Box,
    {
      ref,
      ...ownProps,
      as: "mark",
      __css: { bg: "transparent", whiteSpace: "nowrap", ...styles }
    }
  );
});
function Highlight(props) {
  const { children, query, styles } = props;
  if (typeof children !== "string") {
    throw new Error("The children prop of Highlight must be a string");
  }
  const chunks = useHighlight({ query, text: children });
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_jsx_runtime12.Fragment, { children: chunks.map((chunk, index) => {
    return chunk.match ? /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(Mark, { sx: styles, children: chunk.text }, index) : /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(import_react2.Fragment, { children: chunk.text }, index);
  }) });
}

// src/kbd.tsx
var import_system13 = __webpack_require__(26812);
var import_shared_utils7 = __webpack_require__(62513);
var import_jsx_runtime13 = __webpack_require__(85893);
var Kbd = (0, import_system13.forwardRef)(function Kbd2(props, ref) {
  const styles = (0, import_system13.useStyleConfig)("Kbd", props);
  const { className, ...rest } = (0, import_system13.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
    import_system13.chakra.kbd,
    {
      ref,
      className: (0, import_shared_utils7.cx)("chakra-kbd", className),
      ...rest,
      __css: {
        fontFamily: "mono",
        ...styles
      }
    }
  );
});
Kbd.displayName = "Kbd";

// src/link.tsx
var import_system14 = __webpack_require__(26812);
var import_shared_utils8 = __webpack_require__(62513);
var import_jsx_runtime14 = __webpack_require__(85893);
var Link = (0, import_system14.forwardRef)(function Link2(props, ref) {
  const styles = (0, import_system14.useStyleConfig)("Link", props);
  const { className, isExternal, ...rest } = (0, import_system14.omitThemingProps)(props);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
    import_system14.chakra.a,
    {
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener" : void 0,
      ref,
      className: (0, import_shared_utils8.cx)("chakra-link", className),
      ...rest,
      __css: styles
    }
  );
});
Link.displayName = "Link";

// src/link-box.tsx
var import_system15 = __webpack_require__(26812);
var import_shared_utils9 = __webpack_require__(62513);
var import_jsx_runtime15 = __webpack_require__(85893);
var LinkOverlay = (0, import_system15.forwardRef)(
  function LinkOverlay2(props, ref) {
    const { isExternal, target, rel, className, ...rest } = props;
    return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
      import_system15.chakra.a,
      {
        ...rest,
        ref,
        className: (0, import_shared_utils9.cx)("chakra-linkbox__overlay", className),
        rel: isExternal ? "noopener noreferrer" : rel,
        target: isExternal ? "_blank" : target,
        __css: {
          position: "static",
          "&::before": {
            content: "''",
            cursor: "inherit",
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
            width: "100%",
            height: "100%"
          }
        }
      }
    );
  }
);
var LinkBox = (0, import_system15.forwardRef)(function LinkBox2(props, ref) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    import_system15.chakra.div,
    {
      ref,
      position: "relative",
      ...rest,
      className: (0, import_shared_utils9.cx)("chakra-linkbox", className),
      __css: {
        "a[href]:not(.chakra-linkbox__overlay), abbr[title]": {
          position: "relative",
          zIndex: 1
        }
      }
    }
  );
});

// src/list.tsx
var import_icon = __webpack_require__(4388);
var import_react_context = __webpack_require__(61652);
var import_react_children_utils = __webpack_require__(52734);
var import_system16 = __webpack_require__(26812);
var import_jsx_runtime16 = __webpack_require__(85893);
var [ListStylesProvider, useListStyles] = (0, import_react_context.createContext)({
  name: `ListStylesContext`,
  errorMessage: `useListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<List />" `
});
var List = (0, import_system16.forwardRef)(function List2(props, ref) {
  const styles = (0, import_system16.useMultiStyleConfig)("List", props);
  const {
    children,
    styleType = "none",
    stylePosition,
    spacing,
    ...rest
  } = (0, import_system16.omitThemingProps)(props);
  const validChildren = (0, import_react_children_utils.getValidChildren)(children);
  const selector = "& > *:not(style) ~ *:not(style)";
  const spacingStyle = spacing ? { [selector]: { mt: spacing } } : {};
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(ListStylesProvider, { value: styles, children: /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    import_system16.chakra.ul,
    {
      ref,
      listStyleType: styleType,
      listStylePosition: stylePosition,
      role: "list",
      __css: { ...styles.container, ...spacingStyle },
      ...rest,
      children: validChildren
    }
  ) });
});
List.displayName = "List";
var OrderedList = (0, import_system16.forwardRef)((props, ref) => {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(List, { ref, as: "ol", styleType: "decimal", marginStart: "1em", ...rest });
});
OrderedList.displayName = "OrderedList";
var UnorderedList = (0, import_system16.forwardRef)(function UnorderedList2(props, ref) {
  const { as, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(List, { ref, as: "ul", styleType: "initial", marginStart: "1em", ...rest });
});
UnorderedList.displayName = "UnorderedList";
var ListItem = (0, import_system16.forwardRef)(function ListItem2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_system16.chakra.li, { ref, ...props, __css: styles.item });
});
ListItem.displayName = "ListItem";
var ListIcon = (0, import_system16.forwardRef)(function ListIcon2(props, ref) {
  const styles = useListStyles();
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(import_icon.Icon, { ref, role: "presentation", ...props, __css: styles.icon });
});
ListIcon.displayName = "ListIcon";

// src/simple-grid.tsx
var import_system17 = __webpack_require__(26812);
var import_breakpoint_utils3 = __webpack_require__(65568);
var import_jsx_runtime17 = __webpack_require__(85893);
var SimpleGrid = (0, import_system17.forwardRef)(
  function SimpleGrid2(props, ref) {
    const { columns, spacingX, spacingY, spacing, minChildWidth, ...rest } = props;
    const theme = (0, import_system17.useTheme)();
    const templateColumns = minChildWidth ? widthToColumns(minChildWidth, theme) : countToColumns(columns);
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
      Grid,
      {
        ref,
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        templateColumns,
        ...rest
      }
    );
  }
);
SimpleGrid.displayName = "SimpleGrid";
function toPx(n) {
  return typeof n === "number" ? `${n}px` : n;
}
function widthToColumns(width, theme) {
  return (0, import_breakpoint_utils3.mapResponsive)(width, (value) => {
    const _value = (0, import_system17.getToken)("sizes", value, toPx(value))(theme);
    return value === null ? null : `repeat(auto-fit, minmax(${_value}, 1fr))`;
  });
}
function countToColumns(count) {
  return (0, import_breakpoint_utils3.mapResponsive)(
    count,
    (value) => value === null ? null : `repeat(${value}, minmax(0, 1fr))`
  );
}

// src/spacer.tsx
var import_system18 = __webpack_require__(26812);
var Spacer = (0, import_system18.chakra)("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
Spacer.displayName = "Spacer";

// src/stack/h-stack.tsx
var import_system21 = __webpack_require__(26812);

// src/stack/stack.tsx
var import_react_children_utils2 = __webpack_require__(52734);
var import_shared_utils10 = __webpack_require__(62513);
var import_system20 = __webpack_require__(26812);
var import_react3 = __webpack_require__(67294);

// src/stack/stack-item.tsx
var import_system19 = __webpack_require__(26812);
var import_jsx_runtime18 = __webpack_require__(85893);
var StackItem = (props) => /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
  import_system19.chakra.div,
  {
    className: "chakra-stack__item",
    ...props,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...props["__css"]
    }
  }
);
StackItem.displayName = "StackItem";

// src/stack/stack.utils.tsx
var import_breakpoint_utils4 = __webpack_require__(65568);
function getDividerStyles(options) {
  const { spacing, direction } = options;
  const dividerStyles = {
    column: {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: spacing,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: spacing,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": (0, import_breakpoint_utils4.mapResponsive)(
      direction,
      (value) => dividerStyles[value]
    )
  };
}

// src/stack/stack.tsx
var import_jsx_runtime19 = __webpack_require__(85893);
var Stack = (0, import_system20.forwardRef)((props, ref) => {
  const {
    isInline,
    direction: directionProp,
    align,
    justify,
    spacing = "0.5rem",
    wrap,
    children,
    divider,
    className,
    shouldWrapChildren,
    ...rest
  } = props;
  const direction = isInline ? "row" : directionProp != null ? directionProp : "column";
  const dividerStyle = (0, import_react3.useMemo)(
    () => getDividerStyles({ spacing, direction }),
    [spacing, direction]
  );
  const hasDivider = !!divider;
  const shouldUseChildren = !shouldWrapChildren && !hasDivider;
  const clones = (0, import_react3.useMemo)(() => {
    const validChildren = (0, import_react_children_utils2.getValidChildren)(children);
    return shouldUseChildren ? validChildren : validChildren.map((child, index) => {
      const key = typeof child.key !== "undefined" ? child.key : index;
      const isLast = index + 1 === validChildren.length;
      const wrappedChild = /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(StackItem, { children: child }, key);
      const _child = shouldWrapChildren ? wrappedChild : child;
      if (!hasDivider)
        return _child;
      const clonedDivider = (0, import_react3.cloneElement)(
        divider,
        {
          __css: dividerStyle
        }
      );
      const _divider = isLast ? null : clonedDivider;
      return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)(import_react3.Fragment, { children: [
        _child,
        _divider
      ] }, key);
    });
  }, [
    divider,
    dividerStyle,
    hasDivider,
    shouldUseChildren,
    shouldWrapChildren,
    children
  ]);
  const _className = (0, import_shared_utils10.cx)("chakra-stack", className);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    import_system20.chakra.div,
    {
      ref,
      display: "flex",
      alignItems: align,
      justifyContent: justify,
      flexDirection: direction,
      flexWrap: wrap,
      gap: hasDivider ? void 0 : spacing,
      className: _className,
      ...rest,
      children: clones
    }
  );
});
Stack.displayName = "Stack";

// src/stack/h-stack.tsx
var import_jsx_runtime20 = __webpack_require__(85893);
var HStack = (0, import_system21.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(Stack, { align: "center", ...props, direction: "row", ref }));
HStack.displayName = "HStack";

// src/stack/stack-divider.tsx
var import_system22 = __webpack_require__(26812);
var import_jsx_runtime21 = __webpack_require__(85893);
var StackDivider = (props) => /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
  import_system22.chakra.div,
  {
    className: "chakra-stack__divider",
    ...props,
    __css: {
      ...props["__css"],
      borderWidth: 0,
      alignSelf: "stretch",
      borderColor: "inherit",
      width: "auto",
      height: "auto"
    }
  }
);
StackDivider.displayName = "StackDivider";

// src/stack/v-stack.tsx
var import_system23 = __webpack_require__(26812);
var import_jsx_runtime22 = __webpack_require__(85893);
var VStack = (0, import_system23.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(Stack, { align: "center", ...props, direction: "column", ref }));
VStack.displayName = "VStack";

// src/text.tsx
var import_system24 = __webpack_require__(26812);
var import_shared_utils11 = __webpack_require__(62513);
var import_object_utils2 = __webpack_require__(19707);
var import_jsx_runtime23 = __webpack_require__(85893);
var Text = (0, import_system24.forwardRef)(function Text2(props, ref) {
  const styles = (0, import_system24.useStyleConfig)("Text", props);
  const { className, align, decoration, casing, ...rest } = (0, import_system24.omitThemingProps)(props);
  const aliasedProps = (0, import_object_utils2.compact)({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    import_system24.chakra.p,
    {
      ref,
      className: (0, import_shared_utils11.cx)("chakra-text", props.className),
      ...aliasedProps,
      ...rest,
      __css: styles
    }
  );
});
Text.displayName = "Text";

// src/wrap.tsx
var import_shared_utils12 = __webpack_require__(62513);
var import_system25 = __webpack_require__(26812);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime24 = __webpack_require__(85893);
var Wrap = (0, import_system25.forwardRef)(function Wrap2(props, ref) {
  const {
    spacing = "0.5rem",
    spacingX,
    spacingY,
    children,
    justify,
    direction,
    align,
    className,
    shouldWrapChildren,
    ...rest
  } = props;
  const _children = (0, import_react4.useMemo)(
    () => shouldWrapChildren ? import_react4.Children.map(children, (child, index) => /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(WrapItem, { children: child }, index)) : children,
    [children, shouldWrapChildren]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(import_system25.chakra.div, { ref, className: (0, import_shared_utils12.cx)("chakra-wrap", className), ...rest, children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    import_system25.chakra.ul,
    {
      className: "chakra-wrap__list",
      __css: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: justify,
        alignItems: align,
        flexDirection: direction,
        listStyleType: "none",
        gap: spacing,
        columnGap: spacingX,
        rowGap: spacingY,
        padding: "0"
      },
      children: _children
    }
  ) });
});
Wrap.displayName = "Wrap";
var WrapItem = (0, import_system25.forwardRef)(function WrapItem2(props, ref) {
  const { className, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    import_system25.chakra.li,
    {
      ref,
      __css: { display: "flex", alignItems: "flex-start" },
      className: (0, import_shared_utils12.cx)("chakra-wrap__listitem", className),
      ...rest
    }
  );
});
WrapItem.displayName = "WrapItem";

// src/indicator.tsx
var import_breakpoint_utils5 = __webpack_require__(65568);
var import_system26 = __webpack_require__(26812);
var import_react5 = __webpack_require__(67294);
var import_jsx_runtime25 = __webpack_require__(85893);
var Indicator = (0, import_system26.forwardRef)(function Indicator2(props, ref) {
  const {
    offsetX,
    offsetY,
    offset = "0",
    placement = "top-end",
    ...rest
  } = props;
  const styles = (0, import_react5.useMemo)(
    () => ({
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      insetBlockStart: (0, import_breakpoint_utils5.mapResponsive)(placement, (v) => {
        const [side] = v.split("-");
        const map = {
          top: offsetY != null ? offsetY : offset,
          middle: "50%",
          bottom: "auto"
        };
        return map[side];
      }),
      insetBlockEnd: (0, import_breakpoint_utils5.mapResponsive)(placement, (v) => {
        const [side] = v.split("-");
        const map = {
          top: "auto",
          middle: "50%",
          bottom: offsetY != null ? offsetY : offset
        };
        return map[side];
      }),
      insetStart: (0, import_breakpoint_utils5.mapResponsive)(placement, (v) => {
        const [, align] = v.split("-");
        const map = {
          start: offsetX != null ? offsetX : offset,
          center: "50%",
          end: "auto"
        };
        return map[align];
      }),
      insetEnd: (0, import_breakpoint_utils5.mapResponsive)(placement, (v) => {
        const [, align] = v.split("-");
        const map = {
          start: "auto",
          center: "50%",
          end: offsetX != null ? offsetX : offset
        };
        return map[align];
      }),
      translate: (0, import_breakpoint_utils5.mapResponsive)(placement, (v) => {
        const [side, align] = v.split("-");
        const mapX = { start: "-50%", center: "-50%", end: "50%" };
        const mapY = { top: "-50%", middle: "-50%", bottom: "50%" };
        return `${mapX[align]} ${mapY[side]}`;
      })
    }),
    [offset, offsetX, offsetY, placement]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(import_system26.chakra.div, { ref, __css: styles, ...rest });
});
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 4388:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Icon: () => Icon,
  createIcon: () => createIcon,
  default: () => icon_default
});
module.exports = __toCommonJS(src_exports);

// src/icon.tsx
var import_system = __webpack_require__(26812);
var import_shared_utils = __webpack_require__(62513);
var import_jsx_runtime = __webpack_require__(85893);
var fallbackIcon = {
  path: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
};
var Icon = (0, import_system.forwardRef)((props, ref) => {
  const {
    as: element,
    viewBox,
    color = "currentColor",
    focusable = false,
    children,
    className,
    __css,
    ...rest
  } = props;
  const _className = (0, import_shared_utils.cx)("chakra-icon", className);
  const customStyles = (0, import_system.useStyleConfig)("Icon", props);
  const styles = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color,
    ...__css,
    ...customStyles
  };
  const shared = {
    ref,
    focusable,
    className: _className,
    __css: styles
  };
  const _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
  if (element && typeof element !== "string") {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { as: element, ...shared, ...rest });
  }
  const _path = children != null ? children : fallbackIcon.path;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.chakra.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
});
Icon.displayName = "Icon";
var icon_default = Icon;

// src/create-icon.tsx
var import_system2 = __webpack_require__(26812);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
function createIcon(options) {
  const {
    viewBox = "0 0 24 24",
    d: pathDefinition,
    displayName,
    defaultProps = {}
  } = options;
  const path = import_react.Children.toArray(options.path);
  const Comp = (0, import_system2.forwardRef)((props, ref) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Icon, { ref, viewBox, ...defaultProps, ...props, children: path.length ? path : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentColor", d: pathDefinition }) }));
  Comp.displayName = displayName;
  return Comp;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 62513:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 8394:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AlertDialog: () => AlertDialog,
  AlertDialogBody: () => ModalBody,
  AlertDialogCloseButton: () => ModalCloseButton,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogFooter: () => ModalFooter,
  AlertDialogHeader: () => ModalHeader,
  AlertDialogOverlay: () => ModalOverlay,
  Drawer: () => Drawer,
  DrawerBody: () => ModalBody,
  DrawerCloseButton: () => ModalCloseButton,
  DrawerContent: () => DrawerContent,
  DrawerFooter: () => ModalFooter,
  DrawerHeader: () => ModalHeader,
  DrawerOverlay: () => ModalOverlay,
  Modal: () => Modal,
  ModalBody: () => ModalBody,
  ModalCloseButton: () => ModalCloseButton,
  ModalContent: () => ModalContent,
  ModalContextProvider: () => ModalContextProvider,
  ModalFocusScope: () => ModalFocusScope,
  ModalFooter: () => ModalFooter,
  ModalHeader: () => ModalHeader,
  ModalOverlay: () => ModalOverlay,
  useDrawerContext: () => useDrawerContext,
  useModal: () => useModal,
  useModalContext: () => useModalContext,
  useModalManager: () => useModalManager,
  useModalStyles: () => useModalStyles
});
module.exports = __toCommonJS(src_exports);

// src/alert-dialog.tsx
var import_system9 = __webpack_require__(26812);

// src/modal.tsx
var import_portal = __webpack_require__(57948);
var import_react_context = __webpack_require__(61652);
var import_system = __webpack_require__(26812);
var import_framer_motion = __webpack_require__(46431);

// src/use-modal.ts
var import_shared_utils = __webpack_require__(48506);
var import_react_use_merge_refs = __webpack_require__(17688);
var import_aria_hidden = __webpack_require__(23541);
var import_react2 = __webpack_require__(67294);

// src/modal-manager.ts
var import_react = __webpack_require__(67294);
var ModalManager = class {
  constructor() {
    __publicField(this, "modals");
    this.modals = /* @__PURE__ */ new Map();
  }
  add(modal) {
    this.modals.set(modal, this.modals.size + 1);
    return this.modals.size;
  }
  remove(modal) {
    this.modals.delete(modal);
  }
  isTopModal(modal) {
    if (!modal)
      return false;
    return this.modals.get(modal) === this.modals.size;
  }
};
var modalManager = new ModalManager();
function useModalManager(ref, isOpen) {
  const [index, setIndex] = (0, import_react.useState)(0);
  (0, import_react.useEffect)(() => {
    const node = ref.current;
    if (!node)
      return;
    if (isOpen) {
      const index2 = modalManager.add(node);
      setIndex(index2);
    }
    return () => {
      modalManager.remove(node);
      setIndex(0);
    };
  }, [isOpen, ref]);
  return index;
}

// src/use-modal.ts
function useModal(props) {
  const {
    isOpen,
    onClose,
    id,
    closeOnOverlayClick = true,
    closeOnEsc = true,
    useInert = true,
    onOverlayClick: onOverlayClickProp,
    onEsc
  } = props;
  const dialogRef = (0, import_react2.useRef)(null);
  const overlayRef = (0, import_react2.useRef)(null);
  const [dialogId, headerId, bodyId] = useIds(
    id,
    `chakra-modal`,
    `chakra-modal--header`,
    `chakra-modal--body`
  );
  useAriaHidden(dialogRef, isOpen && useInert);
  const index = useModalManager(dialogRef, isOpen);
  const mouseDownTarget = (0, import_react2.useRef)(null);
  const onMouseDown = (0, import_react2.useCallback)((event) => {
    mouseDownTarget.current = event.target;
  }, []);
  const onKeyDown = (0, import_react2.useCallback)(
    (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        if (closeOnEsc) {
          onClose == null ? void 0 : onClose();
        }
        onEsc == null ? void 0 : onEsc();
      }
    },
    [closeOnEsc, onClose, onEsc]
  );
  const [headerMounted, setHeaderMounted] = (0, import_react2.useState)(false);
  const [bodyMounted, setBodyMounted] = (0, import_react2.useState)(false);
  const getDialogProps = (0, import_react2.useCallback)(
    (props2 = {}, ref = null) => ({
      role: "dialog",
      ...props2,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, dialogRef),
      id: dialogId,
      tabIndex: -1,
      "aria-modal": true,
      "aria-labelledby": headerMounted ? headerId : void 0,
      "aria-describedby": bodyMounted ? bodyId : void 0,
      onClick: (0, import_shared_utils.callAllHandlers)(
        props2.onClick,
        (event) => event.stopPropagation()
      )
    }),
    [bodyId, bodyMounted, dialogId, headerId, headerMounted]
  );
  const onOverlayClick = (0, import_react2.useCallback)(
    (event) => {
      event.stopPropagation();
      if (mouseDownTarget.current !== event.target)
        return;
      if (!modalManager.isTopModal(dialogRef.current))
        return;
      if (closeOnOverlayClick) {
        onClose == null ? void 0 : onClose();
      }
      onOverlayClickProp == null ? void 0 : onOverlayClickProp();
    },
    [onClose, closeOnOverlayClick, onOverlayClickProp]
  );
  const getDialogContainerProps = (0, import_react2.useCallback)(
    (props2 = {}, ref = null) => ({
      ...props2,
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, overlayRef),
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onOverlayClick),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDown),
      onMouseDown: (0, import_shared_utils.callAllHandlers)(props2.onMouseDown, onMouseDown)
    }),
    [onKeyDown, onMouseDown, onOverlayClick]
  );
  return {
    isOpen,
    onClose,
    headerId,
    bodyId,
    setBodyMounted,
    setHeaderMounted,
    dialogRef,
    overlayRef,
    getDialogProps,
    getDialogContainerProps,
    index
  };
}
function useAriaHidden(ref, shouldHide) {
  const currentElement = ref.current;
  (0, import_react2.useEffect)(() => {
    if (!ref.current || !shouldHide)
      return void 0;
    return (0, import_aria_hidden.hideOthers)(ref.current);
  }, [shouldHide, ref, currentElement]);
}
function useIds(idProp, ...prefixes) {
  const reactId = (0, import_react2.useId)();
  const id = idProp || reactId;
  return (0, import_react2.useMemo)(() => {
    return prefixes.map((prefix) => `${prefix}-${id}`);
  }, [id, prefixes]);
}

// src/modal.tsx
var import_jsx_runtime = __webpack_require__(85893);
var [ModalStylesProvider, useModalStyles] = (0, import_react_context.createContext)({
  name: `ModalStylesContext`,
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
});
var [ModalContextProvider, useModalContext] = (0, import_react_context.createContext)({
  strict: true,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
var Modal = (props) => {
  const modalProps = {
    scrollBehavior: "outside",
    autoFocus: true,
    trapFocus: true,
    returnFocusOnClose: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    motionPreset: "scale",
    lockFocusAcrossFrames: true,
    ...props
  };
  const {
    portalProps,
    children,
    autoFocus,
    trapFocus,
    initialFocusRef,
    finalFocusRef,
    returnFocusOnClose,
    blockScrollOnMount,
    allowPinchZoom,
    preserveScrollBarGap,
    motionPreset,
    lockFocusAcrossFrames,
    onCloseComplete
  } = modalProps;
  const styles = (0, import_system.useMultiStyleConfig)("Modal", modalProps);
  const modal = useModal(modalProps);
  const context = {
    ...modal,
    autoFocus,
    trapFocus,
    initialFocusRef,
    finalFocusRef,
    returnFocusOnClose,
    blockScrollOnMount,
    allowPinchZoom,
    preserveScrollBarGap,
    motionPreset,
    lockFocusAcrossFrames
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalContextProvider, { value: context, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ModalStylesProvider, { value: styles, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_framer_motion.AnimatePresence, { onExitComplete: onCloseComplete, children: context.isOpen && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.Portal, { ...portalProps, children }) }) }) });
};
Modal.displayName = "Modal";

// src/modal-content.tsx
var import_shared_utils2 = __webpack_require__(48506);
var import_system3 = __webpack_require__(26812);

// src/modal-focus.tsx
var import_focus_lock = __webpack_require__(59721);
var import_framer_motion2 = __webpack_require__(46431);
var import_react3 = __webpack_require__(67294);
var import_react_remove_scroll = __webpack_require__(80846);
var import_jsx_runtime2 = __webpack_require__(85893);
function ModalFocusScope(props) {
  const {
    autoFocus,
    trapFocus,
    dialogRef,
    initialFocusRef,
    blockScrollOnMount,
    allowPinchZoom,
    finalFocusRef,
    returnFocusOnClose,
    preserveScrollBarGap,
    lockFocusAcrossFrames,
    isOpen
  } = useModalContext();
  const [isPresent, safeToRemove] = (0, import_framer_motion2.usePresence)();
  (0, import_react3.useEffect)(() => {
    if (!isPresent && safeToRemove) {
      setTimeout(safeToRemove);
    }
  }, [isPresent, safeToRemove]);
  const index = useModalManager(dialogRef, isOpen);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_focus_lock.FocusLock,
    {
      autoFocus,
      isDisabled: !trapFocus,
      initialFocusRef,
      finalFocusRef,
      restoreFocus: returnFocusOnClose,
      contentRef: dialogRef,
      lockFocusAcrossFrames,
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        import_react_remove_scroll.RemoveScroll,
        {
          removeScrollBar: !preserveScrollBarGap,
          allowPinchZoom,
          enabled: index === 1 && blockScrollOnMount,
          forwardProps: true,
          children: props.children
        }
      )
    }
  );
}

// src/modal-transition.tsx
var import_system2 = __webpack_require__(26812);
var import_transition = __webpack_require__(53897);
var import_framer_motion3 = __webpack_require__(46431);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime3 = __webpack_require__(85893);
var transitions = {
  slideInBottom: {
    ...import_transition.slideFadeConfig,
    custom: { offsetY: 16, reverse: true }
  },
  slideInRight: {
    ...import_transition.slideFadeConfig,
    custom: { offsetX: 16, reverse: true }
  },
  scale: {
    ...import_transition.scaleFadeConfig,
    custom: { initialScale: 0.95, reverse: true }
  },
  none: {}
};
var MotionSection = (0, import_system2.chakra)(import_framer_motion3.motion.section);
var getMotionProps = (preset) => {
  return transitions[preset || "none"];
};
var ModalTransition = (0, import_react4.forwardRef)(
  (props, ref) => {
    const { preset, motionProps = getMotionProps(preset), ...rest } = props;
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(MotionSection, { ref, ...motionProps, ...rest });
  }
);
ModalTransition.displayName = "ModalTransition";

// src/modal-content.tsx
var import_jsx_runtime4 = __webpack_require__(85893);
var ModalContent = (0, import_system3.forwardRef)(
  (props, ref) => {
    const {
      className,
      children,
      containerProps: rootProps,
      motionProps,
      ...rest
    } = props;
    const { getDialogProps, getDialogContainerProps } = useModalContext();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, import_shared_utils2.cx)("chakra-modal__content", className);
    const styles = useModalStyles();
    const dialogStyles = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...styles.dialog
    };
    const dialogContainerStyles = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...styles.dialogContainer
    };
    const { motionPreset } = useModalContext();
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(ModalFocusScope, { children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      import_system3.chakra.div,
      {
        ...containerProps,
        className: "chakra-modal__content-container",
        tabIndex: -1,
        __css: dialogContainerStyles,
        children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
          ModalTransition,
          {
            preset: motionPreset,
            motionProps,
            className: _className,
            ...dialogProps,
            __css: dialogStyles,
            children
          }
        )
      }
    ) });
  }
);
ModalContent.displayName = "ModalContent";

// src/modal-body.tsx
var import_shared_utils3 = __webpack_require__(48506);
var import_system4 = __webpack_require__(26812);
var import_react5 = __webpack_require__(67294);
var import_jsx_runtime5 = __webpack_require__(85893);
var ModalBody = (0, import_system4.forwardRef)((props, ref) => {
  const { className, ...rest } = props;
  const { bodyId, setBodyMounted } = useModalContext();
  (0, import_react5.useEffect)(() => {
    setBodyMounted(true);
    return () => setBodyMounted(false);
  }, [setBodyMounted]);
  const _className = (0, import_shared_utils3.cx)("chakra-modal__body", className);
  const styles = useModalStyles();
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    import_system4.chakra.div,
    {
      ref,
      className: _className,
      id: bodyId,
      ...rest,
      __css: styles.body
    }
  );
});
ModalBody.displayName = "ModalBody";

// src/modal-close-button.tsx
var import_close_button = __webpack_require__(56766);
var import_shared_utils4 = __webpack_require__(48506);
var import_system5 = __webpack_require__(26812);
var import_jsx_runtime6 = __webpack_require__(85893);
var ModalCloseButton = (0, import_system5.forwardRef)(
  (props, ref) => {
    const { onClick, className, ...rest } = props;
    const { onClose } = useModalContext();
    const _className = (0, import_shared_utils4.cx)("chakra-modal__close-btn", className);
    const styles = useModalStyles();
    return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      import_close_button.CloseButton,
      {
        ref,
        __css: styles.closeButton,
        className: _className,
        onClick: (0, import_shared_utils4.callAllHandlers)(onClick, (event) => {
          event.stopPropagation();
          onClose();
        }),
        ...rest
      }
    );
  }
);
ModalCloseButton.displayName = "ModalCloseButton";

// src/modal-footer.tsx
var import_shared_utils5 = __webpack_require__(48506);
var import_system6 = __webpack_require__(26812);
var import_jsx_runtime7 = __webpack_require__(85893);
var ModalFooter = (0, import_system6.forwardRef)(
  (props, ref) => {
    const { className, ...rest } = props;
    const _className = (0, import_shared_utils5.cx)("chakra-modal__footer", className);
    const styles = useModalStyles();
    const footerStyles = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...styles.footer
    };
    return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
      import_system6.chakra.footer,
      {
        ref,
        ...rest,
        __css: footerStyles,
        className: _className
      }
    );
  }
);
ModalFooter.displayName = "ModalFooter";

// src/modal-header.tsx
var import_shared_utils6 = __webpack_require__(48506);
var import_system7 = __webpack_require__(26812);
var import_react6 = __webpack_require__(67294);
var import_jsx_runtime8 = __webpack_require__(85893);
var ModalHeader = (0, import_system7.forwardRef)(
  (props, ref) => {
    const { className, ...rest } = props;
    const { headerId, setHeaderMounted } = useModalContext();
    (0, import_react6.useEffect)(() => {
      setHeaderMounted(true);
      return () => setHeaderMounted(false);
    }, [setHeaderMounted]);
    const _className = (0, import_shared_utils6.cx)("chakra-modal__header", className);
    const styles = useModalStyles();
    const headerStyles = {
      flex: 0,
      ...styles.header
    };
    return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
      import_system7.chakra.header,
      {
        ref,
        className: _className,
        id: headerId,
        ...rest,
        __css: headerStyles
      }
    );
  }
);
ModalHeader.displayName = "ModalHeader";

// src/modal-overlay.tsx
var import_shared_utils7 = __webpack_require__(48506);
var import_system8 = __webpack_require__(26812);
var import_transition2 = __webpack_require__(53897);
var import_framer_motion4 = __webpack_require__(46431);
var import_jsx_runtime9 = __webpack_require__(85893);
var MotionDiv = (0, import_system8.chakra)(import_framer_motion4.motion.div);
var ModalOverlay = (0, import_system8.forwardRef)(
  (props, ref) => {
    const { className, transition, motionProps: _motionProps, ...rest } = props;
    const _className = (0, import_shared_utils7.cx)("chakra-modal__overlay", className);
    const styles = useModalStyles();
    const overlayStyle = {
      pos: "fixed",
      left: "0",
      top: "0",
      w: "100vw",
      h: "100vh",
      ...styles.overlay
    };
    const { motionPreset } = useModalContext();
    const defaultMotionProps = motionPreset === "none" ? {} : import_transition2.fadeConfig;
    const motionProps = _motionProps || defaultMotionProps;
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
      MotionDiv,
      {
        ...motionProps,
        __css: overlayStyle,
        ref,
        className: _className,
        ...rest
      }
    );
  }
);
ModalOverlay.displayName = "ModalOverlay";

// src/alert-dialog.tsx
var import_jsx_runtime10 = __webpack_require__(85893);
function AlertDialog(props) {
  const { leastDestructiveRef, ...rest } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(Modal, { ...rest, initialFocusRef: leastDestructiveRef });
}
var AlertDialogContent = (0, import_system9.forwardRef)(
  (props, ref) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(ModalContent, { ref, role: "alertdialog", ...props })
);

// src/drawer.tsx
var import_react_context2 = __webpack_require__(61652);
var import_system10 = __webpack_require__(26812);
var import_jsx_runtime11 = __webpack_require__(85893);
var [DrawerContextProvider, useDrawerContext] = (0, import_react_context2.createContext)();
var placementMap = {
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
};
function getDrawerPlacement(placement, dir) {
  var _a, _b;
  if (!placement)
    return;
  return (_b = (_a = placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}
function Drawer(props) {
  var _a;
  const {
    isOpen,
    onClose,
    placement: placementProp = "right",
    children,
    ...rest
  } = props;
  const theme = (0, import_system10.useTheme)();
  const drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
  const placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(DrawerContextProvider, { value: { placement }, children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    Modal,
    {
      isOpen,
      onClose,
      styleConfig: drawerStyleConfig,
      ...rest,
      children
    }
  ) });
}

// src/drawer-content.tsx
var import_shared_utils8 = __webpack_require__(48506);
var import_system11 = __webpack_require__(26812);
var import_transition3 = __webpack_require__(53897);
var import_jsx_runtime12 = __webpack_require__(85893);
var MotionDiv2 = (0, import_system11.chakra)(import_transition3.Slide);
var DrawerContent = (0, import_system11.forwardRef)(
  (props, ref) => {
    const {
      className,
      children,
      motionProps,
      containerProps: rootProps,
      ...rest
    } = props;
    const { getDialogProps, getDialogContainerProps, isOpen } = useModalContext();
    const dialogProps = getDialogProps(rest, ref);
    const containerProps = getDialogContainerProps(rootProps);
    const _className = (0, import_shared_utils8.cx)("chakra-modal__content", className);
    const styles = useModalStyles();
    const dialogStyles = {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      width: "100%",
      outline: 0,
      ...styles.dialog
    };
    const dialogContainerStyles = {
      display: "flex",
      width: "100vw",
      height: "$100vh",
      position: "fixed",
      left: 0,
      top: 0,
      ...styles.dialogContainer
    };
    const { placement } = useDrawerContext();
    return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(ModalFocusScope, { children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
      import_system11.chakra.div,
      {
        ...containerProps,
        className: "chakra-modal__content-container",
        __css: dialogContainerStyles,
        children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
          MotionDiv2,
          {
            motionProps,
            direction: placement,
            in: isOpen,
            className: _className,
            ...dialogProps,
            __css: dialogStyles,
            children
          }
        )
      }
    ) });
  }
);
DrawerContent.displayName = "DrawerContent";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 48506:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 53897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Collapse: () => Collapse,
  EASINGS: () => TRANSITION_EASINGS,
  Fade: () => Fade,
  ScaleFade: () => ScaleFade,
  Slide: () => Slide,
  SlideFade: () => SlideFade,
  fadeConfig: () => fadeConfig,
  getSlideTransition: () => getSlideTransition,
  scaleFadeConfig: () => scaleFadeConfig,
  slideFadeConfig: () => slideFadeConfig,
  withDelay: () => withDelay
});
module.exports = __toCommonJS(src_exports);

// src/collapse.tsx
var import_shared_utils = __webpack_require__(48506);
var import_framer_motion = __webpack_require__(46431);
var import_react = __webpack_require__(67294);

// src/transition-utils.ts
var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function getSlideTransition(options) {
  var _a;
  const side = (_a = options == null ? void 0 : options.direction) != null ? _a : "right";
  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;
    case "left":
      return TRANSITION_VARIANTS.slideLeft;
    case "bottom":
      return TRANSITION_VARIANTS.slideDown;
    case "top":
      return TRANSITION_VARIANTS.slideUp;
    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}
var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var withDelay = {
  enter: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
  }),
  exit: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
  })
};

// src/collapse.tsx
var import_jsx_runtime = __webpack_require__(85893);
var isNumeric = (value) => value != null && parseInt(value.toString(), 10) > 0;
var defaultTransitions = {
  exit: {
    height: { duration: 0.2, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.3, ease: TRANSITION_EASINGS.ease }
  },
  enter: {
    height: { duration: 0.3, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.4, ease: TRANSITION_EASINGS.ease }
  }
};
var variants = {
  exit: ({
    animateOpacity,
    startingHeight,
    transition,
    transitionEnd,
    delay
  }) => {
    var _a;
    return {
      ...animateOpacity && { opacity: isNumeric(startingHeight) ? 1 : 0 },
      height: startingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransitions.exit, delay)
    };
  },
  enter: ({
    animateOpacity,
    endingHeight,
    transition,
    transitionEnd,
    delay
  }) => {
    var _a;
    return {
      ...animateOpacity && { opacity: 1 },
      height: endingHeight,
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransitions.enter, delay)
    };
  }
};
var Collapse = (0, import_react.forwardRef)(
  (props, ref) => {
    const {
      in: isOpen,
      unmountOnExit,
      animateOpacity = true,
      startingHeight = 0,
      endingHeight = "auto",
      style,
      className,
      transition,
      transitionEnd,
      ...rest
    } = props;
    const [mounted, setMounted] = (0, import_react.useState)(false);
    (0, import_react.useEffect)(() => {
      const timeout = setTimeout(() => {
        setMounted(true);
      });
      return () => clearTimeout(timeout);
    }, []);
    (0, import_shared_utils.warn)({
      condition: Number(startingHeight) > 0 && !!unmountOnExit,
      message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
    });
    const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
    const custom = {
      startingHeight,
      endingHeight,
      animateOpacity,
      transition: !mounted ? { enter: { duration: 0 } } : transition,
      transitionEnd: {
        enter: transitionEnd == null ? void 0 : transitionEnd.enter,
        exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : {
          ...transitionEnd == null ? void 0 : transitionEnd.exit,
          display: hasStartingHeight ? "block" : "none"
        }
      }
    };
    const show = unmountOnExit ? isOpen : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_framer_motion.AnimatePresence, { initial: false, custom, children: show && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_framer_motion.motion.div,
      {
        ref,
        ...rest,
        className: (0, import_shared_utils.cx)("chakra-collapse", className),
        style: {
          overflow: "hidden",
          display: "block",
          ...style
        },
        custom,
        variants,
        initial: unmountOnExit ? "exit" : false,
        animate,
        exit: "exit"
      }
    ) });
  }
);
Collapse.displayName = "Collapse";

// src/fade.tsx
var import_shared_utils2 = __webpack_require__(48506);
var import_framer_motion2 = __webpack_require__(46431);
var import_react2 = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
var variants2 = {
  enter: ({ transition, transitionEnd, delay } = {}) => {
    var _a;
    return {
      opacity: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: ({ transition, transitionEnd, delay } = {}) => {
    var _a;
    return {
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  }
};
var fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants2
};
var Fade = (0, import_react2.forwardRef)(function Fade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const custom = { transition, transitionEnd, delay };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_framer_motion2.AnimatePresence, { custom, children: show && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_framer_motion2.motion.div,
    {
      ref,
      className: (0, import_shared_utils2.cx)("chakra-fade", className),
      custom,
      ...fadeConfig,
      animate,
      ...rest
    }
  ) });
});
Fade.displayName = "Fade";

// src/scale-fade.tsx
var import_shared_utils3 = __webpack_require__(48506);
var import_framer_motion3 = __webpack_require__(46431);
var import_react3 = __webpack_require__(67294);
var import_jsx_runtime3 = __webpack_require__(85893);
var variants3 = {
  exit: ({ reverse, initialScale, transition, transitionEnd, delay }) => {
    var _a;
    return {
      opacity: 0,
      ...reverse ? { scale: initialScale, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { scale: initialScale, ...transitionEnd == null ? void 0 : transitionEnd.exit } },
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
    };
  },
  enter: ({ transitionEnd, transition, delay }) => {
    var _a;
    return {
      opacity: 1,
      scale: 1,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants3
};
var ScaleFade = (0, import_react3.forwardRef)(
  function ScaleFade2(props, ref) {
    const {
      unmountOnExit,
      in: isOpen,
      reverse = true,
      initialScale = 0.95,
      className,
      transition,
      transitionEnd,
      delay,
      ...rest
    } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = { initialScale, reverse, transition, transitionEnd, delay };
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_framer_motion3.AnimatePresence, { custom, children: show && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_framer_motion3.motion.div,
      {
        ref,
        className: (0, import_shared_utils3.cx)("chakra-offset-slide", className),
        ...scaleFadeConfig,
        animate,
        custom,
        ...rest
      }
    ) });
  }
);
ScaleFade.displayName = "ScaleFade";

// src/slide.tsx
var import_shared_utils4 = __webpack_require__(48506);
var import_framer_motion4 = __webpack_require__(46431);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime4 = __webpack_require__(85893);
var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants4 = {
  exit: ({ direction, transition, transitionEnd, delay }) => {
    var _a;
    const { exit: exitStyles } = getSlideTransition({ direction });
    return {
      ...exitStyles,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: ({ direction, transitionEnd, transition, delay }) => {
    var _a;
    const { enter: enterStyles } = getSlideTransition({ direction });
    return {
      ...enterStyles,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var Slide = (0, import_react4.forwardRef)(function Slide2(props, ref) {
  const {
    direction = "right",
    style,
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    motionProps,
    ...rest
  } = props;
  const transitionStyles = getSlideTransition({ direction });
  const computedStyle = Object.assign(
    { position: "fixed" },
    transitionStyles.position,
    style
  );
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { transitionEnd, transition, direction, delay };
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_framer_motion4.AnimatePresence, { custom, children: show && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    import_framer_motion4.motion.div,
    {
      ...rest,
      ref,
      initial: "exit",
      className: (0, import_shared_utils4.cx)("chakra-slide", className),
      animate,
      exit: "exit",
      custom,
      variants: variants4,
      style: computedStyle,
      ...motionProps
    }
  ) });
});
Slide.displayName = "Slide";

// src/slide-fade.tsx
var import_shared_utils5 = __webpack_require__(48506);
var import_framer_motion5 = __webpack_require__(46431);
var import_react5 = __webpack_require__(67294);
var import_jsx_runtime5 = __webpack_require__(85893);
var variants5 = {
  initial: ({ offsetX, offsetY, transition, transitionEnd, delay }) => {
    var _a;
    return {
      opacity: 0,
      x: offsetX,
      y: offsetY,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: ({ transition, transitionEnd, delay }) => {
    var _a;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (_a = transition == null ? void 0 : transition.enter) != null ? _a : withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  },
  exit: ({ offsetY, offsetX, transition, transitionEnd, reverse, delay }) => {
    var _a;
    const offset = { x: offsetX, y: offsetY };
    return {
      opacity: 0,
      transition: (_a = transition == null ? void 0 : transition.exit) != null ? _a : withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      ...reverse ? { ...offset, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { ...offset, ...transitionEnd == null ? void 0 : transitionEnd.exit } }
    };
  }
};
var slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants5
};
var SlideFade = (0, import_react5.forwardRef)(
  function SlideFade2(props, ref) {
    const {
      unmountOnExit,
      in: isOpen,
      reverse = true,
      className,
      offsetX = 0,
      offsetY = 8,
      transition,
      transitionEnd,
      delay,
      ...rest
    } = props;
    const show = unmountOnExit ? isOpen && unmountOnExit : true;
    const animate = isOpen || unmountOnExit ? "enter" : "exit";
    const custom = {
      offsetX,
      offsetY,
      reverse,
      transition,
      transitionEnd,
      delay
    };
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_framer_motion5.AnimatePresence, { custom, children: show && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      import_framer_motion5.motion.div,
      {
        ref,
        className: (0, import_shared_utils5.cx)("chakra-offset-slide", className),
        custom,
        ...slideFadeConfig,
        animate,
        ...rest
      }
    ) });
  }
);
SlideFade.displayName = "SlideFade";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 57948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Portal: () => Portal,
  PortalManager: () => PortalManager,
  usePortalManager: () => usePortalManager
});
module.exports = __toCommonJS(src_exports);

// src/portal-manager.tsx
var import_react_context = __webpack_require__(61652);
var import_jsx_runtime = __webpack_require__(85893);
var [PortalManagerContextProvider, usePortalManager] = (0, import_react_context.createContext)({
  strict: false,
  name: "PortalManagerContext"
});
function PortalManager(props) {
  const { children, zIndex } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(PortalManagerContextProvider, { value: { zIndex }, children });
}
PortalManager.displayName = "PortalManager";

// src/portal.tsx
var import_react_use_safe_layout_effect = __webpack_require__(24122);
var import_react_context2 = __webpack_require__(61652);
var import_react_dom = __webpack_require__(73935);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
var [PortalContextProvider, usePortalContext] = (0, import_react_context2.createContext)({
  strict: false,
  name: "PortalContext"
});
var PORTAL_CLASSNAME = "chakra-portal";
var PORTAL_SELECTOR = `.chakra-portal`;
var Container = (props) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "div",
  {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: props.zIndex,
      top: 0,
      left: 0,
      right: 0
    },
    children: props.children
  }
);
var DefaultPortal = (props) => {
  const { appendToParentPortal, children } = props;
  const [tempNode, setTempNode] = (0, import_react.useState)(null);
  const portal = (0, import_react.useRef)(null);
  const [, forceUpdate] = (0, import_react.useState)({});
  (0, import_react.useEffect)(() => forceUpdate({}), []);
  const parentPortal = usePortalContext();
  const manager = usePortalManager();
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (!tempNode)
      return;
    const doc = tempNode.ownerDocument;
    const host = appendToParentPortal ? parentPortal != null ? parentPortal : doc.body : doc.body;
    if (!host)
      return;
    portal.current = doc.createElement("div");
    portal.current.className = PORTAL_CLASSNAME;
    host.appendChild(portal.current);
    forceUpdate({});
    const portalNode = portal.current;
    return () => {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, [tempNode]);
  const _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Container, { zIndex: manager == null ? void 0 : manager.zIndex, children }) : children;
  return portal.current ? (0, import_react_dom.createPortal)(
    /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(PortalContextProvider, { value: portal.current, children: _children }),
    portal.current
  ) : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "span",
    {
      ref: (el) => {
        if (el)
          setTempNode(el);
      }
    }
  );
};
var ContainerPortal = (props) => {
  const { children, containerRef, appendToParentPortal } = props;
  const containerEl = containerRef.current;
  const host = containerEl != null ? containerEl : typeof window !== "undefined" ? document.body : void 0;
  const portal = (0, import_react.useMemo)(() => {
    const node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
    if (node)
      node.className = PORTAL_CLASSNAME;
    return node;
  }, [containerEl]);
  const [, forceUpdate] = (0, import_react.useState)({});
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => forceUpdate({}), []);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (!portal || !host)
      return;
    host.appendChild(portal);
    return () => {
      host.removeChild(portal);
    };
  }, [portal, host]);
  if (host && portal) {
    return (0, import_react_dom.createPortal)(
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(PortalContextProvider, { value: appendToParentPortal ? portal : null, children }),
      portal
    );
  }
  return null;
};
function Portal(props) {
  const portalProps = {
    appendToParentPortal: true,
    ...props
  };
  const { containerRef, ...rest } = portalProps;
  return containerRef ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(ContainerPortal, { containerRef, ...rest }) : /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(DefaultPortal, { ...rest });
}
Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;
Portal.displayName = "Portal";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 35735:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ChakraProvider: () => ChakraProvider
});
module.exports = __toCommonJS(src_exports);

// src/chakra-provider.tsx
var import_css_reset = __webpack_require__(25);
var import_portal = __webpack_require__(57948);
var import_system = __webpack_require__(26812);
var import_react_env = __webpack_require__(18572);
var import_jsx_runtime = __webpack_require__(85893);
var ChakraProvider = (props) => {
  const {
    children,
    colorModeManager,
    portalZIndex,
    resetScope,
    resetCSS = true,
    theme = {},
    environment,
    cssVarsRoot,
    disableEnvironment,
    disableGlobalStyle
  } = props;
  const _children = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react_env.EnvironmentProvider,
    {
      environment,
      disabled: disableEnvironment,
      children
    }
  );
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.ThemeProvider, { theme, cssVarsRoot, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    import_system.ColorModeProvider,
    {
      colorModeManager,
      options: theme.config,
      children: [
        resetCSS ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_css_reset.CSSReset, { scope: resetScope }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_css_reset.CSSPolyfill, {}),
        !disableGlobalStyle && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_system.GlobalStyle, {}),
        portalZIndex ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_portal.PortalManager, { zIndex: portalZIndex, children: _children }) : _children
      ]
    }
  ) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 61652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createContext: () => createContext
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function getErrorMessage(hook, provider) {
  return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
}
function createContext(options = {}) {
  const {
    name,
    strict = true,
    hookName = "useContext",
    providerName = "Provider",
    errorMessage,
    defaultValue
  } = options;
  const Context = (0, import_react.createContext)(defaultValue);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = (0, import_react.useContext)(Context);
    if (!context && strict) {
      const error = new Error(
        errorMessage != null ? errorMessage : getErrorMessage(hookName, providerName)
      );
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [Context.Provider, useContext, Context];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 18572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  EnvironmentProvider: () => EnvironmentProvider,
  useEnvironment: () => useEnvironment
});
module.exports = __toCommonJS(src_exports);

// src/env.tsx
var import_react_use_safe_layout_effect = __webpack_require__(24122);
var import_react = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
var EnvironmentContext = (0, import_react.createContext)({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
EnvironmentContext.displayName = "EnvironmentContext";
function useEnvironment({ defer } = {}) {
  const [, forceUpdate] = (0, import_react.useReducer)((c) => c + 1, 0);
  (0, import_react_use_safe_layout_effect.useSafeLayoutEffect)(() => {
    if (!defer)
      return;
    forceUpdate();
  }, [defer]);
  return (0, import_react.useContext)(EnvironmentContext);
}
function EnvironmentProvider(props) {
  const { children, environment: environmentProp, disabled } = props;
  const ref = (0, import_react.useRef)(null);
  const context = (0, import_react.useMemo)(() => {
    if (environmentProp)
      return environmentProp;
    return {
      getDocument: () => {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument) != null ? _b : document;
      },
      getWindow: () => {
        var _a, _b;
        return (_b = (_a = ref.current) == null ? void 0 : _a.ownerDocument.defaultView) != null ? _b : window;
      }
    };
  }, [environmentProp]);
  const showSpan = !disabled || !environmentProp;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(EnvironmentContext.Provider, { value: context, children: [
    children,
    showSpan && /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { id: "__chakra_env", hidden: true, ref })
  ] });
}
EnvironmentProvider.displayName = "EnvironmentProvider";
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 17688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  assignRef: () => assignRef,
  mergeRefs: () => mergeRefs,
  useMergeRefs: () => useMergeRefs
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function assignRef(ref, value) {
  if (ref == null)
    return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      assignRef(ref, node);
    });
  };
}
function useMergeRefs(...refs) {
  return (0, import_react.useMemo)(() => mergeRefs(...refs), refs);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 24122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useSafeLayoutEffect: () => useSafeLayoutEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
var useSafeLayoutEffect = Boolean(globalThis == null ? void 0 : globalThis.document) ? import_react.useLayoutEffect : import_react.useEffect;
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 34801:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  useUpdateEffect: () => useUpdateEffect
});
module.exports = __toCommonJS(src_exports);
var import_react = __webpack_require__(67294);
function useUpdateEffect(callback, deps) {
  const renderCycleRef = (0, import_react.useRef)(false);
  const effectCycleRef = (0, import_react.useRef)(false);
  (0, import_react.useEffect)(() => {
    const mounted = renderCycleRef.current;
    const run = mounted && effectCycleRef.current;
    if (run) {
      return callback();
    }
    effectCycleRef.current = true;
  }, deps);
  (0, import_react.useEffect)(() => {
    renderCycleRef.current = true;
    return () => {
      renderCycleRef.current = false;
    };
  }, []);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 66307:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 26812:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CSSVars: () => CSSVars,
  GlobalStyle: () => GlobalStyle,
  StylesProvider: () => StylesProvider,
  ThemeProvider: () => ThemeProvider,
  chakra: () => chakra,
  createStylesContext: () => createStylesContext,
  forwardRef: () => forwardRef,
  getToken: () => getToken,
  keyframes: () => import_react8.keyframes,
  shouldForwardProp: () => shouldForwardProp,
  styled: () => styled,
  toCSSObject: () => toCSSObject,
  useChakra: () => useChakra,
  useComponentStyles__unstable: () => useComponentStyles__unstable,
  useMultiStyleConfig: () => useMultiStyleConfig,
  useStyleConfig: () => useStyleConfig,
  useStyles: () => useStyles,
  useTheme: () => useTheme,
  useToken: () => useToken
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(88760), module.exports);
__reExport(src_exports, __webpack_require__(77504), module.exports);
var import_react8 = __webpack_require__(43234);

// src/hooks.ts
var import_color_mode = __webpack_require__(88760);

// src/use-theme.ts
var import_react = __webpack_require__(43234);
var import_react2 = __webpack_require__(67294);
function useTheme() {
  const theme = (0, import_react2.useContext)(
    import_react.ThemeContext
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}

// src/hooks.ts
function useChakra() {
  const colorModeResult = (0, import_color_mode.useColorMode)();
  const theme = useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__breakpoints) == null ? void 0 : _a3.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a2, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a3, _b2;
    return (_b2 = (_a3 = theme.__cssMap) == null ? void 0 : _a3[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a2 = getValue(value)) != null ? _a2 : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a2, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a2 = fallbackArr[index]) != null ? _a2 : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}

// src/providers.tsx
var import_color_mode2 = __webpack_require__(88760);
var import_react_utils = __webpack_require__(32819);
var import_styled_system = __webpack_require__(77504);
var import_utils = __webpack_require__(14211);
var import_react3 = __webpack_require__(43234);
var import_react4 = __webpack_require__(67294);
var import_jsx_runtime = __webpack_require__(85893);
function ThemeProvider(props) {
  const { cssVarsRoot, theme, children } = props;
  const computedTheme = (0, import_react4.useMemo)(() => (0, import_styled_system.toCSSVar)(theme), [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react3.ThemeProvider, { theme: computedTheme, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(CSSVars, { root: cssVarsRoot }),
    children
  ] });
}
function CSSVars({ root = ":host, :root" }) {
  const selector = [root, `[data-theme]`].join(",");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react3.Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
}
var [StylesProvider, useStyles] = (0, import_react_utils.createContext)({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function createStylesContext(componentName) {
  return (0, import_react_utils.createContext)({
    name: `${componentName}StylesContext`,
    errorMessage: `useStyles: "styles" is undefined. Seems you forgot to wrap the components in "<${componentName} />" `
  });
}
function GlobalStyle() {
  const { colorMode } = (0, import_color_mode2.useColorMode)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_react3.Global,
    {
      styles: (theme) => {
        const styleObjectOrFn = (0, import_utils.memoizedGet)(theme, "styles.global");
        const globalStyles = (0, import_utils.runIfFn)(styleObjectOrFn, { theme, colorMode });
        if (!globalStyles)
          return void 0;
        const styles = (0, import_styled_system.css)(globalStyles)(theme);
        return styles;
      }
    }
  );
}

// src/system.ts
var import_color_mode3 = __webpack_require__(88760);
var import_styled_system3 = __webpack_require__(77504);
var import_utils2 = __webpack_require__(14211);
var import_object_utils = __webpack_require__(19707);
var import_styled = __toESM(__webpack_require__(6029));
var import_react5 = __toESM(__webpack_require__(67294));

// src/should-forward-prop.ts
var import_styled_system2 = __webpack_require__(77504);
var allPropNames = /* @__PURE__ */ new Set([
  ...import_styled_system2.propNames,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}

// src/system.ts
var _a;
var emotion_styled = (_a = import_styled.default.default) != null ? _a : import_styled.default;
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0, import_utils2.objectFilter)(rest, (_, prop) => (0, import_styled_system3.isStyleProp)(prop));
  const finalBaseStyle = (0, import_utils2.runIfFn)(baseStyle, props);
  const finalStyles = (0, import_object_utils.assignAfter)(
    {},
    __css,
    finalBaseStyle,
    (0, import_utils2.filterUndefined)(styleProps),
    sx
  );
  const computedCSS = (0, import_styled_system3.css)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = import_react5.default.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0, import_color_mode3.useColorMode)();
    return import_react5.default.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}

// src/forward-ref.tsx
var import_react6 = __webpack_require__(67294);
function forwardRef(component) {
  return (0, import_react6.forwardRef)(component);
}

// src/use-style-config.ts
var import_styled_system4 = __webpack_require__(77504);
var import_theme_utils = __webpack_require__(33847);
var import_utils3 = __webpack_require__(14211);
var import_react7 = __webpack_require__(67294);
var import_react_fast_compare = __toESM(__webpack_require__(69590));
function useStyleConfigImpl(themeKey, props = {}) {
  var _a2;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = useChakra();
  const themeStyleConfig = themeKey ? (0, import_utils3.memoizedGet)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = (0, import_utils3.mergeWith)(
    { theme, colorMode },
    (_a2 = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a2 : {},
    (0, import_utils3.filterUndefined)((0, import_utils3.omit)(rest, ["children"]))
  );
  const stylesRef = (0, import_react7.useRef)({});
  if (styleConfig) {
    const getStyles = (0, import_styled_system4.resolveStyleConfig)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = (0, import_react_fast_compare.default)(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a2;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a2 = theme.components) == null ? void 0 : _a2[themeKey];
  const styleConfig = overrides ? (0, import_theme_utils.mergeThemeOverride)(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 14211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PanSession: () => PanSession,
  __DEV__: () => __DEV__,
  __TEST__: () => __TEST__,
  addDomEvent: () => addDomEvent,
  addItem: () => addItem,
  addPointerEvent: () => addPointerEvent,
  analyzeBreakpoints: () => analyzeBreakpoints,
  ariaAttr: () => ariaAttr,
  arrayToObjectNotation: () => arrayToObjectNotation,
  breakpoints: () => breakpoints,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  canUseDOM: () => canUseDOM,
  chunk: () => chunk,
  clampValue: () => clampValue,
  closest: () => closest,
  compose: () => compose,
  contains: () => contains,
  countDecimalPlaces: () => countDecimalPlaces,
  cx: () => cx,
  dataAttr: () => dataAttr,
  detectBrowser: () => detectBrowser,
  detectDeviceType: () => detectDeviceType,
  detectOS: () => detectOS,
  detectTouch: () => detectTouch,
  determineLazyBehavior: () => determineLazyBehavior,
  distance: () => distance,
  error: () => error,
  extractEventInfo: () => extractEventInfo,
  filterUndefined: () => filterUndefined,
  flatten: () => flatten,
  focus: () => focus,
  focusNextTabbable: () => focusNextTabbable,
  focusPreviousTabbable: () => focusPreviousTabbable,
  fromEntries: () => fromEntries,
  get: () => get,
  getActiveElement: () => getActiveElement,
  getAllFocusable: () => getAllFocusable,
  getAllTabbable: () => getAllTabbable,
  getCSSVar: () => getCSSVar,
  getEventWindow: () => getEventWindow,
  getFirstFocusable: () => getFirstFocusable,
  getFirstItem: () => getFirstItem,
  getFirstTabbableIn: () => getFirstTabbableIn,
  getLastItem: () => getLastItem,
  getLastTabbableIn: () => getLastTabbableIn,
  getNextIndex: () => getNextIndex,
  getNextItem: () => getNextItem,
  getNextItemFromSearch: () => getNextItemFromSearch,
  getNextTabbable: () => getNextTabbable,
  getOwnerDocument: () => getOwnerDocument,
  getOwnerWindow: () => getOwnerWindow,
  getPointerEventName: () => getPointerEventName,
  getPrevIndex: () => getPrevIndex,
  getPrevItem: () => getPrevItem,
  getPreviousTabbable: () => getPreviousTabbable,
  getRelatedTarget: () => getRelatedTarget,
  getViewportPointFromEvent: () => getViewportPointFromEvent,
  getWithDefault: () => getWithDefault,
  hasDisplayNone: () => hasDisplayNone,
  hasFocusWithin: () => hasFocusWithin,
  hasNegativeTabIndex: () => hasNegativeTabIndex,
  hasTabIndex: () => hasTabIndex,
  isActiveElement: () => isActiveElement,
  isArray: () => isArray,
  isBrowser: () => isBrowser,
  isContentEditable: () => isContentEditable,
  isCssVar: () => isCssVar,
  isCustomBreakpoint: () => isCustomBreakpoint,
  isDefined: () => isDefined,
  isDisabled: () => isDisabled,
  isElement: () => isElement,
  isEmpty: () => isEmpty,
  isEmptyArray: () => isEmptyArray,
  isEmptyObject: () => isEmptyObject,
  isFocusable: () => isFocusable,
  isFunction: () => isFunction,
  isHTMLElement: () => isHTMLElement,
  isHidden: () => isHidden,
  isInputElement: () => isInputElement,
  isInputEvent: () => isInputEvent,
  isMouseEvent: () => isMouseEvent,
  isMultiTouchEvent: () => isMultiTouchEvent,
  isNotEmptyObject: () => isNotEmptyObject,
  isNotNumber: () => isNotNumber,
  isNull: () => isNull,
  isNumber: () => isNumber,
  isNumeric: () => isNumeric,
  isObject: () => isObject,
  isRefObject: () => isRefObject,
  isResponsiveObjectLike: () => isResponsiveObjectLike,
  isRightClick: () => isRightClick,
  isString: () => isString,
  isTabbable: () => isTabbable,
  isTouchEvent: () => isTouchEvent,
  isUndefined: () => isUndefined,
  mapResponsive: () => mapResponsive,
  maxSafeInteger: () => maxSafeInteger,
  memoize: () => memoize,
  memoizedGet: () => memoizedGet,
  mergeWith: () => import_lodash.default,
  minSafeInteger: () => minSafeInteger,
  noop: () => noop,
  normalizeEventKey: () => normalizeEventKey,
  objectFilter: () => objectFilter,
  objectKeys: () => objectKeys,
  objectToArrayNotation: () => objectToArrayNotation,
  omit: () => omit,
  once: () => once,
  percentToValue: () => percentToValue,
  pick: () => pick,
  pipe: () => pipe,
  px: () => px,
  removeIndex: () => removeIndex,
  removeItem: () => removeItem,
  roundValueToStep: () => roundValueToStep,
  runIfFn: () => runIfFn,
  split: () => split,
  toMediaQueryString: () => toMediaQueryString,
  toPrecision: () => toPrecision,
  valueToPercent: () => valueToPercent,
  walkObject: () => walkObject,
  warn: () => warn,
  wrapPointerEventHandler: () => wrapPointerEventHandler
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(49129), module.exports);

// src/array.ts
function getFirstItem(array) {
  return array != null && array.length ? array[0] : void 0;
}
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function getPrevItem(index, array, loop = true) {
  const prevIndex = getPrevIndex(index, array.length, loop);
  return array[prevIndex];
}
function getNextItem(index, array, loop = true) {
  const nextIndex = getNextIndex(index, array.length, 1, loop);
  return array[nextIndex];
}
function removeIndex(array, index) {
  return array.filter((_, idx) => idx !== index);
}
function addItem(array, item) {
  return [...array, item];
}
function removeItem(array, item) {
  return array.filter((eachItem) => eachItem !== item);
}
function getNextIndex(currentIndex, length, step = 1, loop = true) {
  const lastIndex = length - 1;
  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }
  const nextIndex = currentIndex + step;
  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }
  if (nextIndex >= length) {
    if (loop)
      return 0;
    return currentIndex > length ? length : currentIndex;
  }
  return nextIndex;
}
function getPrevIndex(index, count, loop = true) {
  return getNextIndex(index, count, -1, loop);
}
function chunk(array, size) {
  return array.reduce((rows, currentValue, index) => {
    if (index % size === 0) {
      rows.push([currentValue]);
    } else {
      rows[rows.length - 1].push(currentValue);
    }
    return rows;
  }, []);
}
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }
  if (!currentItem) {
    const foundItem = items.find(
      (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
    );
    return foundItem;
  }
  const matchingItems = items.filter(
    (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
  );
  if (matchingItems.length > 0) {
    let nextIndex;
    if (matchingItems.includes(currentItem)) {
      const currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;
      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }
      return matchingItems[nextIndex];
    }
    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }
  return currentItem;
}

// src/assertion.ts
function isNumber(value) {
  return typeof value === "number";
}
function isNotNumber(value) {
  return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
}
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
function isFunction(value) {
  return typeof value === "function";
}
function isDefined(value) {
  return typeof value !== "undefined" && value !== void 0;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === void 0;
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
}
function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
function isEmpty(value) {
  if (isArray(value))
    return isEmptyArray(value);
  if (isObject(value))
    return isEmptyObject(value);
  if (value == null || value === "")
    return true;
  return false;
}
var __DEV__ = "production" !== "production";
var __TEST__ = "production" === "test";
function isRefObject(val) {
  return "current" in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}

// src/object.ts
var import_lodash = __toESM(__webpack_require__(38554));
function omit(object, keys2) {
  const result = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key))
      return;
    result[key] = object[key];
  });
  return result;
}
function pick(object, keys2) {
  const result = {};
  keys2.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}
function split(object, keys2) {
  const picked = {};
  const omitted = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key)) {
      picked[key] = object[key];
    } else {
      omitted[key] = object[key];
    }
  });
  return [picked, omitted];
}
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
function getWithDefault(path, scale) {
  return memoizedGet(scale, path, path);
}
function objectFilter(object, fn) {
  const result = {};
  Object.keys(object).forEach((key) => {
    const value = object[key];
    const shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);
var objectKeys = (obj) => Object.keys(obj);
var fromEntries = (entries) => entries.reduce((carry, [key, value]) => {
  carry[key] = value;
  return carry;
}, {});
var getCSSVar = (theme, scale, value) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/breakpoint.ts
function analyzeCSSValue(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue(value);
  return unitless || isNumber(value) ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints2) => fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
function normalize(breakpoints2) {
  const sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints2) {
  const value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}
function subtract(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const factor = value.endsWith("px") ? -0.02 : -0.01;
  return isNumber(value) ? `${value + factor}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + factor}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints2) {
  var _a;
  if (!breakpoints2)
    return null;
  breakpoints2.base = (_a = breakpoints2.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints2);
  const queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints2);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/dom.ts
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el)) {
    return false;
  }
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return isElement(node) ? (_b = (_a = getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function getOwnerDocument(node) {
  var _a;
  return isElement(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = /* @__PURE__ */ canUseDOM();
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function getActiveElement(node) {
  const doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  if (!parent)
    return false;
  return parent === child || parent.contains(child);
}
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return () => {
    target.removeEventListener(eventName, handler, options);
  };
}
function normalizeEventKey(event) {
  const { key, keyCode } = event;
  const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  const eventKey = isArrowKey ? `Arrow${key}` : key;
  return eventKey;
}
function getRelatedTarget(event) {
  var _a, _b;
  const target = (_a = event.target) != null ? _a : event.currentTarget;
  const activeElement = getActiveElement(target);
  return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function isRightClick(event) {
  return event.button !== 0;
}

// src/tabbable.ts
var hasDisplayNone = (element) => window.getComputedStyle(element).display === "none";
var hasTabIndex = (element) => element.hasAttribute("tabindex");
var hasNegativeTabIndex = (element) => hasTabIndex(element) && element.tabIndex === -1;
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isInputElement(element) {
  return isHTMLElement(element) && element.localName === "input" && "select" in element;
}
function isActiveElement(element) {
  const doc = isHTMLElement(element) ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function hasFocusWithin(element) {
  if (!document.activeElement)
    return false;
  return element.contains(document.activeElement);
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement))
    return true;
  return element.hidden;
}
function isContentEditable(element) {
  const value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }
  const { localName } = element;
  const focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0)
    return true;
  const others = {
    a: () => element.hasAttribute("href"),
    audio: () => element.hasAttribute("controls"),
    video: () => element.hasAttribute("controls")
  };
  if (localName in others) {
    return others[localName]();
  }
  if (isContentEditable(element))
    return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element)
    return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

// src/dom-query.ts
var focusableElList = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
];
var focusableElSelector = focusableElList.join();
var isVisible = (el) => el.offsetWidth > 0 && el.offsetHeight > 0;
function getAllFocusable(container) {
  const focusableEls = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  focusableEls.unshift(container);
  return focusableEls.filter((el) => isFocusable(el) && isVisible(el));
}
function getFirstFocusable(container) {
  const allFocusable = getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function getAllTabbable(container, fallbackToFocusable) {
  const allFocusable = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  const allTabbable = allFocusable.filter(isTabbable);
  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }
  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }
  return allTabbable;
}
function getFirstTabbableIn(container, fallbackToFocusable) {
  const [first] = getAllTabbable(container, fallbackToFocusable);
  return first || null;
}
function getLastTabbableIn(container, fallbackToFocusable) {
  const allTabbable = getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function getNextTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container);
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function getPreviousTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container).reverse();
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function focusNextTabbable(container, fallbackToFocusable) {
  const nextTabbable = getNextTabbable(container, fallbackToFocusable);
  if (nextTabbable && isHTMLElement(nextTabbable)) {
    nextTabbable.focus();
  }
}
function focusPreviousTabbable(container, fallbackToFocusable) {
  const previousTabbable = getPreviousTabbable(container, fallbackToFocusable);
  if (previousTabbable && isHTMLElement(previousTabbable)) {
    previousTabbable.focus();
  }
}
function matches(element, selectors) {
  if ("matches" in element)
    return element.matches(selectors);
  if ("msMatchesSelector" in element)
    return element.msMatchesSelector(selectors);
  return element.webkitMatchesSelector(selectors);
}
function closest(element, selectors) {
  if ("closest" in element)
    return element.closest(selectors);
  do {
    if (matches(element, selectors))
      return element;
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);
  return null;
}

// src/function.ts
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
var compose = (fn1, ...fns) => fns.reduce(
  (f1, f2) => (...args) => f1(f2(...args)),
  fn1
);
function once(fn) {
  let result;
  return function func(...args) {
    if (fn) {
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}
var noop = () => {
};
var warn = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.warn(message);
  }
});
var error = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.error(message);
  }
});
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
var distance1D = (a, b) => Math.abs(a - b);
var isPoint = (point) => "x" in point && "y" in point;
function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }
  if (isPoint(a) && isPoint(b)) {
    const xDelta = distance1D(a.x, b.x);
    const yDelta = distance1D(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
  }
  return 0;
}

// src/focus.ts
function focus(element, options = {}) {
  const {
    isActive = isActiveElement,
    nextTick,
    preventScroll = true,
    selectTextIfInput = true
  } = options;
  if (!element || isActive(element))
    return -1;
  function triggerFocus() {
    if (!element) {
      warn({
        condition: true,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }
    if (supportsPreventScroll()) {
      element.focus({ preventScroll });
    } else {
      element.focus();
      if (preventScroll) {
        const scrollableElements = getScrollableElements(element);
        restoreScrollPosition(scrollableElements);
      }
    }
    if (selectTextIfInput) {
      if (isInputElement(element)) {
        element.select();
      } else if ("setSelectionRange" in element) {
        const el = element;
        el.setSelectionRange(el.value.length, el.value.length);
      }
    }
  }
  if (nextTick) {
    return requestAnimationFrame(triggerFocus);
  }
  triggerFocus();
  return -1;
}
var supportsPreventScrollCached = null;
function supportsPreventScroll() {
  if (supportsPreventScrollCached == null) {
    supportsPreventScrollCached = false;
    try {
      const div = document.createElement("div");
      div.focus({
        get preventScroll() {
          supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
    }
  }
  return supportsPreventScrollCached;
}
function getScrollableElements(element) {
  var _a;
  const doc = getOwnerDocument(element);
  const win = (_a = doc.defaultView) != null ? _a : window;
  let parent = element.parentNode;
  const scrollableElements = [];
  const rootScrollingElement = doc.scrollingElement || doc.documentElement;
  while (parent instanceof win.HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof win.HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }
  return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
  for (const { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

// src/flatten.ts
function flatten(target, maxDepth = Infinity) {
  if (!isObject(target) && !Array.isArray(target) || !maxDepth) {
    return target;
  }
  return Object.entries(target).reduce((result, [key, value]) => {
    if (isObject(value) || isArray(value)) {
      Object.entries(flatten(value, maxDepth - 1)).forEach(
        ([childKey, childValue]) => {
          result[`${key}.${childKey}`] = childValue;
        }
      );
    } else {
      result[key] = value;
    }
    return result;
  }, {});
}

// src/lazy.ts
function determineLazyBehavior(options) {
  const {
    hasBeenSelected,
    isLazy,
    isSelected,
    lazyBehavior = "unmount"
  } = options;
  if (!isLazy)
    return true;
  if (isSelected)
    return true;
  if (lazyBehavior === "keepMounted" && hasBeenSelected)
    return true;
  return false;
}

// src/number.ts
var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
function toNumber(value) {
  const num = parseFloat(value);
  return isNotNumber(num) ? 0 : num;
}
function toPrecision(value, precision) {
  let nextValue = toNumber(value);
  const scaleFactor = 10 ** (precision != null ? precision : 10);
  nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
  return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function countDecimalPlaces(value) {
  if (!Number.isFinite(value))
    return 0;
  let e = 1;
  let p = 0;
  while (Math.round(value * e) / e !== value) {
    e *= 10;
    p += 1;
  }
  return p;
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function roundValueToStep(value, from, step) {
  const nextValue = Math.round((value - from) / step) * step + from;
  const precision = countDecimalPlaces(step);
  return toPrecision(nextValue, precision);
}
function clampValue(value, min, max) {
  if (value == null)
    return value;
  warn({
    condition: max < min,
    message: "clamp: max cannot be less than min"
  });
  return Math.min(Math.max(value, min), max);
}

// src/pan-event.ts
var import_framesync = __toESM(__webpack_require__(84839));

// src/pointer-event.ts
function isMouseEvent(event) {
  const win = getEventWindow(event);
  if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof win.MouseEvent;
}
function isTouchEvent(event) {
  const hasTouches = !!event.touches;
  return hasTouches;
}
function filterPrimaryPointer(eventHandler) {
  return (event) => {
    const win = getEventWindow(event);
    const isMouseEvent2 = event instanceof win.MouseEvent;
    const isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
  const primaryTouch = e.touches[0] || e.changedTouches[0];
  const point = primaryTouch || defaultPagePoint;
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function pointFromMouse(point, pointType = "page") {
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function extractEventInfo(event, pointType = "page") {
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
function getViewportPointFromEvent(event) {
  return extractEventInfo(event, "client");
}
var wrapPointerEventHandler = (handler, shouldFilterPrimaryPointer = false) => {
  const listener = (event) => handler(event, extractEventInfo(event));
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
var supportsPointerEvents = () => isBrowser && window.onpointerdown === null;
var supportsTouchEvents = () => isBrowser && window.ontouchstart === null;
var supportsMouseEvents = () => isBrowser && window.onmousedown === null;
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  }
  if (supportsTouchEvents()) {
    return touchEventNames[name];
  }
  if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(
    target,
    getPointerEventName(eventName),
    wrapPointerEventHandler(handler, eventName === "pointerdown"),
    options
  );
}
function isMultiTouchEvent(event) {
  return isTouchEvent(event) && event.touches.length > 1;
}

// src/pan-event.ts
var PanSession = class {
  constructor(event, handlers, threshold) {
    __publicField(this, "history", []);
    __publicField(this, "startEvent", null);
    __publicField(this, "lastEvent", null);
    __publicField(this, "lastEventInfo", null);
    __publicField(this, "handlers", {});
    __publicField(this, "removeListeners", noop);
    __publicField(this, "threshold", 3);
    __publicField(this, "win");
    __publicField(this, "updatePoint", () => {
      if (!(this.lastEvent && this.lastEventInfo))
        return;
      const info = getPanInfo(this.lastEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= this.threshold;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { timestamp } = (0, import_framesync.getFrameData)();
      this.history.push({ ...info.point, timestamp });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart == null ? void 0 : onStart(this.lastEvent, info);
        this.startEvent = this.lastEvent;
      }
      onMove == null ? void 0 : onMove(this.lastEvent, info);
    });
    __publicField(this, "onPointerMove", (event, info) => {
      this.lastEvent = event;
      this.lastEventInfo = info;
      if (isMouseEvent(event) && event.buttons === 0) {
        this.onPointerUp(event, info);
        return;
      }
      import_framesync.default.update(this.updatePoint, true);
    });
    __publicField(this, "onPointerUp", (event, info) => {
      const panInfo = getPanInfo(info, this.history);
      const { onEnd, onSessionEnd } = this.handlers;
      onSessionEnd == null ? void 0 : onSessionEnd(event, panInfo);
      this.end();
      if (!onEnd || !this.startEvent)
        return;
      onEnd == null ? void 0 : onEnd(event, panInfo);
    });
    this.win = getEventWindow(event);
    if (isMultiTouchEvent(event))
      return;
    this.handlers = handlers;
    if (threshold) {
      this.threshold = threshold;
    }
    event.stopPropagation();
    event.preventDefault();
    const info = extractEventInfo(event);
    const { timestamp } = (0, import_framesync.getFrameData)();
    this.history = [{ ...info.point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart == null ? void 0 : onSessionStart(event, getPanInfo(info, this.history));
    this.removeListeners = pipe(
      addPointerEvent(this.win, "pointermove", this.onPointerMove),
      addPointerEvent(this.win, "pointerup", this.onPointerUp),
      addPointerEvent(this.win, "pointercancel", this.onPointerUp)
    );
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    var _a;
    (_a = this.removeListeners) == null ? void 0 : _a.call(this);
    import_framesync.cancelSync.update(this.updatePoint);
  }
};
function subtractPoint(a, b) {
  return { x: a.x - b.x, y: a.y - b.y };
}
function startPanPoint(history) {
  return history[0];
}
function lastPanPoint(history) {
  return history[history.length - 1];
}
function getPanInfo(info, history) {
  return {
    point: info.point,
    delta: subtractPoint(info.point, lastPanPoint(history)),
    offset: subtractPoint(info.point, startPanPoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
var toMilliseconds = (seconds) => seconds * 1e3;
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > toMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// src/responsive.ts
var breakpoints = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map((item) => {
      if (item === null) {
        return null;
      }
      return mapper(item);
    });
  }
  if (isObject(prop)) {
    return objectKeys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj, bps = breakpoints) {
  const result = bps.map((br) => {
    var _a;
    return (_a = obj[br]) != null ? _a : null;
  });
  while (getLastItem(result) === null) {
    result.pop();
  }
  return result;
}
function arrayToObjectNotation(values, bps = breakpoints) {
  const result = {};
  values.forEach((value, index) => {
    const key = bps[index];
    if (value == null)
      return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps = breakpoints) {
  const keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every((key) => bps.includes(key));
}
var isCustomBreakpoint = (maybeBreakpoint) => Number.isNaN(Number(maybeBreakpoint));

// src/user-agent.ts
function getUserAgentBrowser(navigator) {
  const { userAgent: ua, vendor } = navigator;
  const android = /(android)/i.test(ua);
  switch (true) {
    case /CriOS/.test(ua):
      return "Chrome for iOS";
    case /Edg\//.test(ua):
      return "Edge";
    case (android && /Silk\//.test(ua)):
      return "Silk";
    case (/Chrome/.test(ua) && /Google Inc/.test(vendor)):
      return "Chrome";
    case /Firefox\/\d+\.\d+$/.test(ua):
      return "Firefox";
    case android:
      return "AOSP";
    case /MSIE|Trident/.test(ua):
      return "IE";
    case (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua)):
      return "Safari";
    case /AppleWebKit/.test(ua):
      return "WebKit";
    default:
      return null;
  }
}
function getUserAgentOS(navigator) {
  const { userAgent: ua, platform } = navigator;
  switch (true) {
    case /Android/.test(ua):
      return "Android";
    case /iPhone|iPad|iPod/.test(platform):
      return "iOS";
    case /Win/.test(platform):
      return "Windows";
    case /Mac/.test(platform):
      return "Mac";
    case /CrOS/.test(ua):
      return "Chrome OS";
    case /Firefox/.test(ua):
      return "Firefox OS";
    default:
      return null;
  }
}
function detectDeviceType(navigator) {
  const { userAgent: ua } = navigator;
  if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua))
    return "tablet";
  if (/(mobi)/i.test(ua))
    return "phone";
  return "desktop";
}
function detectOS(os) {
  if (!isBrowser)
    return false;
  return getUserAgentOS(window.navigator) === os;
}
function detectBrowser(browser) {
  if (!isBrowser)
    return false;
  return getUserAgentBrowser(window.navigator) === browser;
}
function detectTouch() {
  if (!isBrowser)
    return false;
  return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}

// src/walk-object.ts
function walkObject(target, predicate) {
  function inner(value, path = []) {
    if (isArray(value)) {
      return value.map((item, index) => inner(item, [...path, String(index)]));
    }
    if (isObject(value)) {
      return fromEntries(
        Object.entries(value).map(([key, child]) => [
          key,
          inner(child, [...path, key])
        ])
      );
    }
    return predicate(value, path);
  }
  return inner(target);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 33847:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  extendBaseTheme: () => extendBaseTheme,
  extendTheme: () => extendTheme,
  mergeThemeOverride: () => mergeThemeOverride,
  withDefaultColorScheme: () => withDefaultColorScheme,
  withDefaultProps: () => withDefaultProps,
  withDefaultSize: () => withDefaultSize,
  withDefaultVariant: () => withDefaultVariant
});
module.exports = __toCommonJS(src_exports);

// src/extend-theme.ts
var import_theme = __webpack_require__(60);
var import_lodash = __toESM(__webpack_require__(38554));
function isFunction(value) {
  return typeof value === "function";
}
function pipe(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
var createExtendTheme = (theme2) => {
  return function extendTheme2(...extensions) {
    let overrides = [...extensions];
    let activeTheme = extensions[extensions.length - 1];
    if ((0, import_theme.isChakraTheme)(activeTheme) && overrides.length > 1) {
      overrides = overrides.slice(0, overrides.length - 1);
    } else {
      activeTheme = theme2;
    }
    return pipe(
      ...overrides.map(
        (extension) => (prevTheme) => isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
      )
    )(activeTheme);
  };
};
var extendTheme = createExtendTheme(import_theme.theme);
var extendBaseTheme = createExtendTheme(import_theme.baseTheme);
function mergeThemeOverride(...overrides) {
  return (0, import_lodash.default)({}, ...overrides, mergeThemeCustomizer);
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return (...args) => {
      const sourceValue = isFunction(source) ? source(...args) : source;
      const overrideValue = isFunction(override) ? override(...args) : override;
      return (0, import_lodash.default)({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// src/theme-extensions/with-default-color-scheme.ts
var import_shared_utils = __webpack_require__(99506);
function withDefaultColorScheme({
  colorScheme,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withColorScheme = {
            defaultProps: {
              colorScheme
            }
          };
          return [componentName, withColorScheme];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-size.ts
var import_shared_utils2 = __webpack_require__(99506);
function withDefaultSize({
  size,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils2.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withSize = {
            defaultProps: {
              size
            }
          };
          return [componentName, withSize];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-variant.ts
var import_shared_utils3 = __webpack_require__(99506);
function withDefaultVariant({
  variant,
  components
}) {
  return (theme2) => {
    let names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if ((0, import_shared_utils3.isObject)(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(
        names.map((componentName) => {
          const withVariant = {
            defaultProps: {
              variant
            }
          };
          return [componentName, withVariant];
        })
      )
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2(...fns) {
  return (v) => fns.reduce((a, b) => b(a), v);
}
function withDefaultProps({
  defaultProps: { colorScheme, variant, size },
  components
}) {
  const identity = (t) => t;
  const fns = [
    colorScheme ? withDefaultColorScheme({ colorScheme, components }) : identity,
    size ? withDefaultSize({ size, components }) : identity,
    variant ? withDefaultVariant({ variant, components }) : identity
  ];
  return (theme2) => mergeThemeOverride(pipe2(...fns)(theme2));
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 99506:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 95224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Toast: () => Toast,
  ToastOptionProvider: () => ToastOptionProvider,
  ToastProvider: () => ToastProvider,
  createRenderToast: () => createRenderToast,
  createStandaloneToast: () => createStandaloneToast,
  createToastFn: () => createToastFn,
  getToastPlacement: () => getToastPlacement,
  useToast: () => useToast
});
module.exports = __toCommonJS(src_exports);

// src/use-toast.tsx
var import_system3 = __webpack_require__(26812);

// src/toast.tsx
var import_alert = __webpack_require__(53061);
var import_system = __webpack_require__(26812);
var import_close_button = __webpack_require__(56766);
var import_shared_utils = __webpack_require__(27347);

// src/toast.placement.ts
function getToastPlacement(position, dir) {
  var _a;
  const computedPosition = position != null ? position : "bottom";
  const logicals = {
    "top-start": { ltr: "top-left", rtl: "top-right" },
    "top-end": { ltr: "top-right", rtl: "top-left" },
    "bottom-start": { ltr: "bottom-left", rtl: "bottom-right" },
    "bottom-end": { ltr: "bottom-right", rtl: "bottom-left" }
  };
  const logical = logicals[computedPosition];
  return (_a = logical == null ? void 0 : logical[dir]) != null ? _a : computedPosition;
}

// src/toast.utils.ts
var findById = (arr, id) => arr.find((toast) => toast.id === id);
function findToast(toasts, id) {
  const position = getToastPosition(toasts, id);
  const index = position ? toasts[position].findIndex((toast) => toast.id === id) : -1;
  return {
    position,
    index
  };
}
function getToastPosition(toasts, id) {
  for (const [position, values] of Object.entries(toasts)) {
    if (findById(values, id)) {
      return position;
    }
  }
}
function getToastStyle(position) {
  const isRighty = position.includes("right");
  const isLefty = position.includes("left");
  let alignItems = "center";
  if (isRighty)
    alignItems = "flex-end";
  if (isLefty)
    alignItems = "flex-start";
  return {
    display: "flex",
    flexDirection: "column",
    alignItems
  };
}
function getToastListStyle(position) {
  const isTopOrBottom = position === "top" || position === "bottom";
  const margin = isTopOrBottom ? "0 auto" : void 0;
  const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
  const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
  const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
  const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
  return {
    position: "fixed",
    zIndex: "var(--toast-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin,
    top,
    bottom,
    right,
    left
  };
}

// src/toast.store.ts
var initialState = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
};
var toastStore = createStore(initialState);
function createStore(initialState2) {
  let state = initialState2;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (setStateFn) => {
    state = setStateFn(state);
    listeners.forEach((l) => l());
  };
  return {
    getState: () => state,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        setState(() => initialState2);
        listeners.delete(listener);
      };
    },
    removeToast: (id, position) => {
      setState((prevState) => ({
        ...prevState,
        [position]: prevState[position].filter((toast) => toast.id != id)
      }));
    },
    notify: (message, options) => {
      const toast = createToast(message, options);
      const { position, id } = toast;
      setState((prevToasts) => {
        var _a, _b;
        const isTop = position.includes("top");
        const toasts = isTop ? [toast, ...(_a = prevToasts[position]) != null ? _a : []] : [...(_b = prevToasts[position]) != null ? _b : [], toast];
        return {
          ...prevToasts,
          [position]: toasts
        };
      });
      return id;
    },
    update: (id, options) => {
      if (!id)
        return;
      setState((prevState) => {
        const nextState = { ...prevState };
        const { position, index } = findToast(nextState, id);
        if (position && index !== -1) {
          nextState[position][index] = {
            ...nextState[position][index],
            ...options,
            message: createRenderToast(options)
          };
        }
        return nextState;
      });
    },
    closeAll: ({ positions } = {}) => {
      setState((prev) => {
        const allPositions = [
          "bottom",
          "bottom-right",
          "bottom-left",
          "top",
          "top-left",
          "top-right"
        ];
        const positionsToClose = positions != null ? positions : allPositions;
        return positionsToClose.reduce(
          (acc, position) => {
            acc[position] = prev[position].map((toast) => ({
              ...toast,
              requestClose: true
            }));
            return acc;
          },
          { ...prev }
        );
      });
    },
    close: (id) => {
      setState((prevState) => {
        const position = getToastPosition(prevState, id);
        if (!position)
          return prevState;
        return {
          ...prevState,
          [position]: prevState[position].map((toast) => {
            if (toast.id == id) {
              return {
                ...toast,
                requestClose: true
              };
            }
            return toast;
          })
        };
      });
    },
    isActive: (id) => Boolean(findToast(toastStore.getState(), id).position)
  };
}
var counter = 0;
function createToast(message, options = {}) {
  var _a, _b;
  counter += 1;
  const id = (_a = options.id) != null ? _a : counter;
  const position = (_b = options.position) != null ? _b : "bottom";
  return {
    id,
    message,
    position,
    duration: options.duration,
    onCloseComplete: options.onCloseComplete,
    onRequestRemove: () => toastStore.removeToast(String(id), position),
    status: options.status,
    requestClose: false,
    containerStyle: options.containerStyle
  };
}

// src/toast.tsx
var import_jsx_runtime = __webpack_require__(85893);
var Toast = (props) => {
  const {
    status,
    variant = "solid",
    id,
    title,
    isClosable,
    onClose,
    description,
    colorScheme,
    icon
  } = props;
  const ids = id ? {
    root: `toast-${id}`,
    title: `toast-${id}-title`,
    description: `toast-${id}-description`
  } : void 0;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
    import_alert.Alert,
    {
      addRole: false,
      status,
      variant,
      id: ids == null ? void 0 : ids.root,
      alignItems: "start",
      borderRadius: "md",
      boxShadow: "lg",
      paddingEnd: 8,
      textAlign: "start",
      width: "auto",
      colorScheme,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_alert.AlertIcon, { children: icon }),
        /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_system.chakra.div, { flex: "1", maxWidth: "100%", children: [
          title && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_alert.AlertTitle, { id: ids == null ? void 0 : ids.title, children: title }),
          description && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_alert.AlertDescription, { id: ids == null ? void 0 : ids.description, display: "block", children: description })
        ] }),
        isClosable && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          import_close_button.CloseButton,
          {
            size: "sm",
            onClick: onClose,
            position: "absolute",
            insetEnd: 1,
            top: 1
          }
        )
      ]
    }
  );
};
function createRenderToast(options = {}) {
  const { render, toastComponent: ToastComponent2 = Toast } = options;
  const renderToast = (props) => {
    if (typeof render === "function") {
      return render({ ...props, ...options });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ToastComponent2, { ...props, ...options });
  };
  return renderToast;
}
function createToastFn(dir, defaultOptions) {
  const normalizeToastOptions = (options) => {
    var _a;
    return {
      ...defaultOptions,
      ...options,
      position: getToastPlacement(
        (_a = options == null ? void 0 : options.position) != null ? _a : defaultOptions == null ? void 0 : defaultOptions.position,
        dir
      )
    };
  };
  const toast = (options) => {
    const normalizedToastOptions = normalizeToastOptions(options);
    const Message = createRenderToast(normalizedToastOptions);
    return toastStore.notify(Message, normalizedToastOptions);
  };
  toast.update = (id, options) => {
    toastStore.update(id, normalizeToastOptions(options));
  };
  toast.promise = (promise, options) => {
    const id = toast({
      ...options.loading,
      status: "loading",
      duration: null
    });
    promise.then(
      (data) => toast.update(id, {
        status: "success",
        duration: 5e3,
        ...(0, import_shared_utils.runIfFn)(options.success, data)
      })
    ).catch(
      (error) => toast.update(id, {
        status: "error",
        duration: 5e3,
        ...(0, import_shared_utils.runIfFn)(options.error, error)
      })
    );
  };
  toast.closeAll = toastStore.closeAll;
  toast.close = toastStore.close;
  toast.isActive = toastStore.isActive;
  return toast;
}

// src/use-toast.tsx
var import_react3 = __webpack_require__(67294);

// src/toast.provider.tsx
var import_framer_motion2 = __webpack_require__(46431);
var import_portal = __webpack_require__(57948);

// src/toast.component.tsx
var import_react_use_timeout = __webpack_require__(94028);
var import_react_use_update_effect = __webpack_require__(34801);
var import_shared_utils2 = __webpack_require__(27347);
var import_framer_motion = __webpack_require__(46431);
var import_system2 = __webpack_require__(26812);
var import_react = __webpack_require__(67294);
var import_jsx_runtime2 = __webpack_require__(85893);
var toastMotionVariants = {
  initial: (props) => {
    const { position } = props;
    const dir = ["top", "bottom"].includes(position) ? "y" : "x";
    let factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
    if (position === "bottom")
      factor = 1;
    return {
      opacity: 0,
      [dir]: factor * 24
    };
  },
  animate: {
    opacity: 1,
    y: 0,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    scale: 0.85,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 1, 1]
    }
  }
};
var ToastComponent = (0, import_react.memo)((props) => {
  const {
    id,
    message,
    onCloseComplete,
    onRequestRemove,
    requestClose = false,
    position = "bottom",
    duration = 5e3,
    containerStyle,
    motionVariants = toastMotionVariants,
    toastSpacing = "0.5rem"
  } = props;
  const [delay, setDelay] = (0, import_react.useState)(duration);
  const isPresent = (0, import_framer_motion.useIsPresent)();
  (0, import_react_use_update_effect.useUpdateEffect)(() => {
    if (!isPresent) {
      onCloseComplete == null ? void 0 : onCloseComplete();
    }
  }, [isPresent]);
  (0, import_react_use_update_effect.useUpdateEffect)(() => {
    setDelay(duration);
  }, [duration]);
  const onMouseEnter = () => setDelay(null);
  const onMouseLeave = () => setDelay(duration);
  const close = () => {
    if (isPresent)
      onRequestRemove();
  };
  (0, import_react.useEffect)(() => {
    if (isPresent && requestClose) {
      onRequestRemove();
    }
  }, [isPresent, requestClose, onRequestRemove]);
  (0, import_react_use_timeout.useTimeout)(close, delay);
  const containerStyles = (0, import_react.useMemo)(
    () => ({
      pointerEvents: "auto",
      maxWidth: 560,
      minWidth: 300,
      margin: toastSpacing,
      ...containerStyle
    }),
    [containerStyle, toastSpacing]
  );
  const toastStyle = (0, import_react.useMemo)(() => getToastStyle(position), [position]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    import_framer_motion.motion.div,
    {
      layout: true,
      className: "chakra-toast",
      variants: motionVariants,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      onHoverStart: onMouseEnter,
      onHoverEnd: onMouseLeave,
      custom: { position },
      style: toastStyle,
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        import_system2.chakra.div,
        {
          role: "status",
          "aria-atomic": "true",
          className: "chakra-toast__inner",
          __css: containerStyles,
          children: (0, import_shared_utils2.runIfFn)(message, { id, onClose: close })
        }
      )
    }
  );
});
ToastComponent.displayName = "ToastComponent";

// src/toast.provider.tsx
var import_react2 = __webpack_require__(67294);
var import_react_context = __webpack_require__(61652);
var import_jsx_runtime3 = __webpack_require__(85893);
var [ToastOptionProvider, useToastOptionContext] = (0, import_react_context.createContext)({
  name: `ToastOptionsContext`,
  strict: false
});
var ToastProvider = (props) => {
  const state = (0, import_react2.useSyncExternalStore)(
    toastStore.subscribe,
    toastStore.getState,
    toastStore.getState
  );
  const {
    motionVariants,
    component: Component = ToastComponent,
    portalProps
  } = props;
  const stateKeys = Object.keys(state);
  const toastList = stateKeys.map((position) => {
    const toasts = state[position];
    return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        id: `chakra-toast-manager-${position}`,
        style: getToastListStyle(position),
        children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_framer_motion2.AnimatePresence, { initial: false, children: toasts.map((toast) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          Component,
          {
            motionVariants,
            ...toast
          },
          toast.id
        )) })
      },
      position
    );
  });
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_portal.Portal, { ...portalProps, children: toastList });
};

// src/use-toast.tsx
function useToast(options) {
  const { theme } = (0, import_system3.useChakra)();
  const defaultOptions = useToastOptionContext();
  return (0, import_react3.useMemo)(
    () => createToastFn(theme.direction, {
      ...defaultOptions,
      ...options
    }),
    [options, theme.direction, defaultOptions]
  );
}

// src/create-standalone-toast.tsx
var import_system4 = __webpack_require__(26812);
var import_theme = __toESM(__webpack_require__(60));
var import_jsx_runtime4 = __webpack_require__(85893);
var defaults = {
  duration: 5e3,
  variant: "solid"
};
var defaultStandaloneParam = {
  theme: import_theme.default,
  colorMode: "light",
  toggleColorMode: () => {
  },
  setColorMode: () => {
  },
  defaultOptions: defaults,
  forced: false
};
function createStandaloneToast({
  theme = defaultStandaloneParam.theme,
  colorMode = defaultStandaloneParam.colorMode,
  toggleColorMode = defaultStandaloneParam.toggleColorMode,
  setColorMode = defaultStandaloneParam.setColorMode,
  defaultOptions = defaultStandaloneParam.defaultOptions,
  motionVariants,
  toastSpacing,
  component,
  forced
} = defaultStandaloneParam) {
  const colorModeContextValue = {
    colorMode,
    setColorMode,
    toggleColorMode,
    forced
  };
  const ToastContainer = () => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_system4.ThemeProvider, { theme, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_system4.ColorModeContext.Provider, { value: colorModeContextValue, children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    ToastProvider,
    {
      defaultOptions,
      motionVariants,
      toastSpacing,
      component
    }
  ) }) });
  return {
    ToastContainer,
    toast: createToastFn(theme.direction, defaultOptions)
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 27347:
/***/ (function(module) {

"use strict";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ariaAttr: () => ariaAttr,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  cx: () => cx,
  dataAttr: () => dataAttr,
  isObject: () => isObject,
  runIfFn: () => runIfFn,
  warn: () => warn
});
module.exports = __toCommonJS(src_exports);
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 46141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PanSession: () => PanSession,
  __DEV__: () => __DEV__,
  __TEST__: () => __TEST__,
  addDomEvent: () => addDomEvent,
  addItem: () => addItem,
  addPointerEvent: () => addPointerEvent,
  analyzeBreakpoints: () => analyzeBreakpoints,
  ariaAttr: () => ariaAttr,
  arrayToObjectNotation: () => arrayToObjectNotation,
  breakpoints: () => breakpoints,
  callAll: () => callAll,
  callAllHandlers: () => callAllHandlers,
  canUseDOM: () => canUseDOM,
  chunk: () => chunk,
  clampValue: () => clampValue,
  closest: () => closest,
  compose: () => compose,
  contains: () => contains,
  countDecimalPlaces: () => countDecimalPlaces,
  cx: () => cx,
  dataAttr: () => dataAttr,
  detectBrowser: () => detectBrowser,
  detectDeviceType: () => detectDeviceType,
  detectOS: () => detectOS,
  detectTouch: () => detectTouch,
  determineLazyBehavior: () => determineLazyBehavior,
  distance: () => distance,
  error: () => error,
  extractEventInfo: () => extractEventInfo,
  filterUndefined: () => filterUndefined,
  flatten: () => flatten,
  focus: () => focus,
  focusNextTabbable: () => focusNextTabbable,
  focusPreviousTabbable: () => focusPreviousTabbable,
  fromEntries: () => fromEntries,
  get: () => get,
  getActiveElement: () => getActiveElement,
  getAllFocusable: () => getAllFocusable,
  getAllTabbable: () => getAllTabbable,
  getCSSVar: () => getCSSVar,
  getEventWindow: () => getEventWindow,
  getFirstFocusable: () => getFirstFocusable,
  getFirstItem: () => getFirstItem,
  getFirstTabbableIn: () => getFirstTabbableIn,
  getLastItem: () => getLastItem,
  getLastTabbableIn: () => getLastTabbableIn,
  getNextIndex: () => getNextIndex,
  getNextItem: () => getNextItem,
  getNextItemFromSearch: () => getNextItemFromSearch,
  getNextTabbable: () => getNextTabbable,
  getOwnerDocument: () => getOwnerDocument,
  getOwnerWindow: () => getOwnerWindow,
  getPointerEventName: () => getPointerEventName,
  getPrevIndex: () => getPrevIndex,
  getPrevItem: () => getPrevItem,
  getPreviousTabbable: () => getPreviousTabbable,
  getRelatedTarget: () => getRelatedTarget,
  getViewportPointFromEvent: () => getViewportPointFromEvent,
  getWithDefault: () => getWithDefault,
  hasDisplayNone: () => hasDisplayNone,
  hasFocusWithin: () => hasFocusWithin,
  hasNegativeTabIndex: () => hasNegativeTabIndex,
  hasTabIndex: () => hasTabIndex,
  isActiveElement: () => isActiveElement,
  isArray: () => isArray,
  isBrowser: () => isBrowser,
  isContentEditable: () => isContentEditable,
  isCssVar: () => isCssVar,
  isCustomBreakpoint: () => isCustomBreakpoint,
  isDefined: () => isDefined,
  isDisabled: () => isDisabled,
  isElement: () => isElement,
  isEmpty: () => isEmpty,
  isEmptyArray: () => isEmptyArray,
  isEmptyObject: () => isEmptyObject,
  isFocusable: () => isFocusable,
  isFunction: () => isFunction,
  isHTMLElement: () => isHTMLElement,
  isHidden: () => isHidden,
  isInputElement: () => isInputElement,
  isInputEvent: () => isInputEvent,
  isMouseEvent: () => isMouseEvent,
  isMultiTouchEvent: () => isMultiTouchEvent,
  isNotEmptyObject: () => isNotEmptyObject,
  isNotNumber: () => isNotNumber,
  isNull: () => isNull,
  isNumber: () => isNumber,
  isNumeric: () => isNumeric,
  isObject: () => isObject,
  isRefObject: () => isRefObject,
  isResponsiveObjectLike: () => isResponsiveObjectLike,
  isRightClick: () => isRightClick,
  isString: () => isString,
  isTabbable: () => isTabbable,
  isTouchEvent: () => isTouchEvent,
  isUndefined: () => isUndefined,
  mapResponsive: () => mapResponsive,
  maxSafeInteger: () => maxSafeInteger,
  memoize: () => memoize,
  memoizedGet: () => memoizedGet,
  mergeWith: () => import_lodash.default,
  minSafeInteger: () => minSafeInteger,
  noop: () => noop,
  normalizeEventKey: () => normalizeEventKey,
  objectFilter: () => objectFilter,
  objectKeys: () => objectKeys,
  objectToArrayNotation: () => objectToArrayNotation,
  omit: () => omit,
  once: () => once,
  percentToValue: () => percentToValue,
  pick: () => pick,
  pipe: () => pipe,
  px: () => px,
  removeIndex: () => removeIndex,
  removeItem: () => removeItem,
  roundValueToStep: () => roundValueToStep,
  runIfFn: () => runIfFn,
  split: () => split,
  toMediaQueryString: () => toMediaQueryString,
  toPrecision: () => toPrecision,
  valueToPercent: () => valueToPercent,
  walkObject: () => walkObject,
  warn: () => warn,
  wrapPointerEventHandler: () => wrapPointerEventHandler
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(49129), module.exports);

// src/array.ts
function getFirstItem(array) {
  return array != null && array.length ? array[0] : void 0;
}
function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function getPrevItem(index, array, loop = true) {
  const prevIndex = getPrevIndex(index, array.length, loop);
  return array[prevIndex];
}
function getNextItem(index, array, loop = true) {
  const nextIndex = getNextIndex(index, array.length, 1, loop);
  return array[nextIndex];
}
function removeIndex(array, index) {
  return array.filter((_, idx) => idx !== index);
}
function addItem(array, item) {
  return [...array, item];
}
function removeItem(array, item) {
  return array.filter((eachItem) => eachItem !== item);
}
function getNextIndex(currentIndex, length, step = 1, loop = true) {
  const lastIndex = length - 1;
  if (currentIndex === -1) {
    return step > 0 ? 0 : lastIndex;
  }
  const nextIndex = currentIndex + step;
  if (nextIndex < 0) {
    return loop ? lastIndex : 0;
  }
  if (nextIndex >= length) {
    if (loop)
      return 0;
    return currentIndex > length ? length : currentIndex;
  }
  return nextIndex;
}
function getPrevIndex(index, count, loop = true) {
  return getNextIndex(index, count, -1, loop);
}
function chunk(array, size) {
  return array.reduce((rows, currentValue, index) => {
    if (index % size === 0) {
      rows.push([currentValue]);
    } else {
      rows[rows.length - 1].push(currentValue);
    }
    return rows;
  }, []);
}
function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
  if (searchString == null) {
    return currentItem;
  }
  if (!currentItem) {
    const foundItem = items.find(
      (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
    );
    return foundItem;
  }
  const matchingItems = items.filter(
    (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
  );
  if (matchingItems.length > 0) {
    let nextIndex;
    if (matchingItems.includes(currentItem)) {
      const currentIndex = matchingItems.indexOf(currentItem);
      nextIndex = currentIndex + 1;
      if (nextIndex === matchingItems.length) {
        nextIndex = 0;
      }
      return matchingItems[nextIndex];
    }
    nextIndex = items.indexOf(matchingItems[0]);
    return items[nextIndex];
  }
  return currentItem;
}

// src/assertion.ts
function isNumber(value) {
  return typeof value === "number";
}
function isNotNumber(value) {
  return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
}
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
function isFunction(value) {
  return typeof value === "function";
}
function isDefined(value) {
  return typeof value !== "undefined" && value !== void 0;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === void 0;
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
}
function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
function isEmpty(value) {
  if (isArray(value))
    return isEmptyArray(value);
  if (isObject(value))
    return isEmptyObject(value);
  if (value == null || value === "")
    return true;
  return false;
}
var __DEV__ = "production" !== "production";
var __TEST__ = "production" === "test";
function isRefObject(val) {
  return "current" in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}

// src/object.ts
var import_lodash = __toESM(__webpack_require__(38554));
function omit(object, keys2) {
  const result = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key))
      return;
    result[key] = object[key];
  });
  return result;
}
function pick(object, keys2) {
  const result = {};
  keys2.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}
function split(object, keys2) {
  const picked = {};
  const omitted = {};
  Object.keys(object).forEach((key) => {
    if (keys2.includes(key)) {
      picked[key] = object[key];
    } else {
      omitted[key] = object[key];
    }
  });
  return [picked, omitted];
}
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
function getWithDefault(path, scale) {
  return memoizedGet(scale, path, path);
}
function objectFilter(object, fn) {
  const result = {};
  Object.keys(object).forEach((key) => {
    const value = object[key];
    const shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);
var objectKeys = (obj) => Object.keys(obj);
var fromEntries = (entries) => entries.reduce((carry, [key, value]) => {
  carry[key] = value;
  return carry;
}, {});
var getCSSVar = (theme, scale, value) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};

// src/breakpoint.ts
function analyzeCSSValue(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue(value);
  return unitless || isNumber(value) ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints2) => fromEntries(Object.entries(breakpoints2).sort(sortByBreakpointValue));
function normalize(breakpoints2) {
  const sorted = sortBps(breakpoints2);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints2) {
  const value = Object.keys(sortBps(breakpoints2));
  return new Set(value);
}
function subtract(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const factor = value.endsWith("px") ? -0.02 : -0.01;
  return isNumber(value) ? `${value + factor}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + factor}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints2) {
  var _a;
  if (!breakpoints2)
    return null;
  breakpoints2.base = (_a = breakpoints2.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints2);
  const queries = Object.entries(breakpoints2).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract(maxW) : void 0;
    return {
      _minW: subtract(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints2);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints2),
    asArray: normalize(breakpoints2),
    details: queries,
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!isObject(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/dom.ts
function isElement(el) {
  return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
}
function isHTMLElement(el) {
  var _a;
  if (!isElement(el)) {
    return false;
  }
  const win = (_a = el.ownerDocument.defaultView) != null ? _a : window;
  return el instanceof win.HTMLElement;
}
function getOwnerWindow(node) {
  var _a, _b;
  return isElement(node) ? (_b = (_a = getOwnerDocument(node)) == null ? void 0 : _a.defaultView) != null ? _b : window : window;
}
function getOwnerDocument(node) {
  var _a;
  return isElement(node) ? (_a = node.ownerDocument) != null ? _a : document : document;
}
function getEventWindow(event) {
  var _a;
  return (_a = event.view) != null ? _a : window;
}
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var isBrowser = /* @__PURE__ */ canUseDOM();
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function getActiveElement(node) {
  const doc = getOwnerDocument(node);
  return doc == null ? void 0 : doc.activeElement;
}
function contains(parent, child) {
  if (!parent)
    return false;
  return parent === child || parent.contains(child);
}
function addDomEvent(target, eventName, handler, options) {
  target.addEventListener(eventName, handler, options);
  return () => {
    target.removeEventListener(eventName, handler, options);
  };
}
function normalizeEventKey(event) {
  const { key, keyCode } = event;
  const isArrowKey = keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0;
  const eventKey = isArrowKey ? `Arrow${key}` : key;
  return eventKey;
}
function getRelatedTarget(event) {
  var _a, _b;
  const target = (_a = event.target) != null ? _a : event.currentTarget;
  const activeElement = getActiveElement(target);
  return (_b = event.relatedTarget) != null ? _b : activeElement;
}
function isRightClick(event) {
  return event.button !== 0;
}

// src/tabbable.ts
var hasDisplayNone = (element) => window.getComputedStyle(element).display === "none";
var hasTabIndex = (element) => element.hasAttribute("tabindex");
var hasNegativeTabIndex = (element) => hasTabIndex(element) && element.tabIndex === -1;
function isDisabled(element) {
  return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
}
function isInputElement(element) {
  return isHTMLElement(element) && element.localName === "input" && "select" in element;
}
function isActiveElement(element) {
  const doc = isHTMLElement(element) ? getOwnerDocument(element) : document;
  return doc.activeElement === element;
}
function hasFocusWithin(element) {
  if (!document.activeElement)
    return false;
  return element.contains(document.activeElement);
}
function isHidden(element) {
  if (element.parentElement && isHidden(element.parentElement))
    return true;
  return element.hidden;
}
function isContentEditable(element) {
  const value = element.getAttribute("contenteditable");
  return value !== "false" && value != null;
}
function isFocusable(element) {
  if (!isHTMLElement(element) || isHidden(element) || isDisabled(element)) {
    return false;
  }
  const { localName } = element;
  const focusableTags = ["input", "select", "textarea", "button"];
  if (focusableTags.indexOf(localName) >= 0)
    return true;
  const others = {
    a: () => element.hasAttribute("href"),
    audio: () => element.hasAttribute("controls"),
    video: () => element.hasAttribute("controls")
  };
  if (localName in others) {
    return others[localName]();
  }
  if (isContentEditable(element))
    return true;
  return hasTabIndex(element);
}
function isTabbable(element) {
  if (!element)
    return false;
  return isHTMLElement(element) && isFocusable(element) && !hasNegativeTabIndex(element);
}

// src/dom-query.ts
var focusableElList = [
  "input:not(:disabled):not([disabled])",
  "select:not(:disabled):not([disabled])",
  "textarea:not(:disabled):not([disabled])",
  "embed",
  "iframe",
  "object",
  "a[href]",
  "area[href]",
  "button:not(:disabled):not([disabled])",
  "[tabindex]",
  "audio[controls]",
  "video[controls]",
  "*[tabindex]:not([aria-disabled])",
  "*[contenteditable]"
];
var focusableElSelector = focusableElList.join();
var isVisible = (el) => el.offsetWidth > 0 && el.offsetHeight > 0;
function getAllFocusable(container) {
  const focusableEls = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  focusableEls.unshift(container);
  return focusableEls.filter((el) => isFocusable(el) && isVisible(el));
}
function getFirstFocusable(container) {
  const allFocusable = getAllFocusable(container);
  return allFocusable.length ? allFocusable[0] : null;
}
function getAllTabbable(container, fallbackToFocusable) {
  const allFocusable = Array.from(
    container.querySelectorAll(focusableElSelector)
  );
  const allTabbable = allFocusable.filter(isTabbable);
  if (isTabbable(container)) {
    allTabbable.unshift(container);
  }
  if (!allTabbable.length && fallbackToFocusable) {
    return allFocusable;
  }
  return allTabbable;
}
function getFirstTabbableIn(container, fallbackToFocusable) {
  const [first] = getAllTabbable(container, fallbackToFocusable);
  return first || null;
}
function getLastTabbableIn(container, fallbackToFocusable) {
  const allTabbable = getAllTabbable(container, fallbackToFocusable);
  return allTabbable[allTabbable.length - 1] || null;
}
function getNextTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container);
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function getPreviousTabbable(container, fallbackToFocusable) {
  const allFocusable = getAllFocusable(container).reverse();
  const index = allFocusable.indexOf(document.activeElement);
  const slice = allFocusable.slice(index + 1);
  return slice.find(isTabbable) || allFocusable.find(isTabbable) || (fallbackToFocusable ? slice[0] : null);
}
function focusNextTabbable(container, fallbackToFocusable) {
  const nextTabbable = getNextTabbable(container, fallbackToFocusable);
  if (nextTabbable && isHTMLElement(nextTabbable)) {
    nextTabbable.focus();
  }
}
function focusPreviousTabbable(container, fallbackToFocusable) {
  const previousTabbable = getPreviousTabbable(container, fallbackToFocusable);
  if (previousTabbable && isHTMLElement(previousTabbable)) {
    previousTabbable.focus();
  }
}
function matches(element, selectors) {
  if ("matches" in element)
    return element.matches(selectors);
  if ("msMatchesSelector" in element)
    return element.msMatchesSelector(selectors);
  return element.webkitMatchesSelector(selectors);
}
function closest(element, selectors) {
  if ("closest" in element)
    return element.closest(selectors);
  do {
    if (matches(element, selectors))
      return element;
    element = element.parentElement || element.parentNode;
  } while (element !== null && element.nodeType === 1);
  return null;
}

// src/function.ts
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
var compose = (fn1, ...fns) => fns.reduce(
  (f1, f2) => (...args) => f1(f2(...args)),
  fn1
);
function once(fn) {
  let result;
  return function func(...args) {
    if (fn) {
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}
var noop = () => {
};
var warn = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.warn(message);
  }
});
var error = /* @__PURE__ */ once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.error(message);
  }
});
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
var distance1D = (a, b) => Math.abs(a - b);
var isPoint = (point) => "x" in point && "y" in point;
function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }
  if (isPoint(a) && isPoint(b)) {
    const xDelta = distance1D(a.x, b.x);
    const yDelta = distance1D(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
  }
  return 0;
}

// src/focus.ts
function focus(element, options = {}) {
  const {
    isActive = isActiveElement,
    nextTick,
    preventScroll = true,
    selectTextIfInput = true
  } = options;
  if (!element || isActive(element))
    return -1;
  function triggerFocus() {
    if (!element) {
      warn({
        condition: true,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }
    if (supportsPreventScroll()) {
      element.focus({ preventScroll });
    } else {
      element.focus();
      if (preventScroll) {
        const scrollableElements = getScrollableElements(element);
        restoreScrollPosition(scrollableElements);
      }
    }
    if (selectTextIfInput) {
      if (isInputElement(element)) {
        element.select();
      } else if ("setSelectionRange" in element) {
        const el = element;
        el.setSelectionRange(el.value.length, el.value.length);
      }
    }
  }
  if (nextTick) {
    return requestAnimationFrame(triggerFocus);
  }
  triggerFocus();
  return -1;
}
var supportsPreventScrollCached = null;
function supportsPreventScroll() {
  if (supportsPreventScrollCached == null) {
    supportsPreventScrollCached = false;
    try {
      const div = document.createElement("div");
      div.focus({
        get preventScroll() {
          supportsPreventScrollCached = true;
          return true;
        }
      });
    } catch (e) {
    }
  }
  return supportsPreventScrollCached;
}
function getScrollableElements(element) {
  var _a;
  const doc = getOwnerDocument(element);
  const win = (_a = doc.defaultView) != null ? _a : window;
  let parent = element.parentNode;
  const scrollableElements = [];
  const rootScrollingElement = doc.scrollingElement || doc.documentElement;
  while (parent instanceof win.HTMLElement && parent !== rootScrollingElement) {
    if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
      scrollableElements.push({
        element: parent,
        scrollTop: parent.scrollTop,
        scrollLeft: parent.scrollLeft
      });
    }
    parent = parent.parentNode;
  }
  if (rootScrollingElement instanceof win.HTMLElement) {
    scrollableElements.push({
      element: rootScrollingElement,
      scrollTop: rootScrollingElement.scrollTop,
      scrollLeft: rootScrollingElement.scrollLeft
    });
  }
  return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
  for (const { element, scrollTop, scrollLeft } of scrollableElements) {
    element.scrollTop = scrollTop;
    element.scrollLeft = scrollLeft;
  }
}

// src/flatten.ts
function flatten(target, maxDepth = Infinity) {
  if (!isObject(target) && !Array.isArray(target) || !maxDepth) {
    return target;
  }
  return Object.entries(target).reduce((result, [key, value]) => {
    if (isObject(value) || isArray(value)) {
      Object.entries(flatten(value, maxDepth - 1)).forEach(
        ([childKey, childValue]) => {
          result[`${key}.${childKey}`] = childValue;
        }
      );
    } else {
      result[key] = value;
    }
    return result;
  }, {});
}

// src/lazy.ts
function determineLazyBehavior(options) {
  const {
    hasBeenSelected,
    isLazy,
    isSelected,
    lazyBehavior = "unmount"
  } = options;
  if (!isLazy)
    return true;
  if (isSelected)
    return true;
  if (lazyBehavior === "keepMounted" && hasBeenSelected)
    return true;
  return false;
}

// src/number.ts
var minSafeInteger = Number.MIN_SAFE_INTEGER || -9007199254740991;
var maxSafeInteger = Number.MAX_SAFE_INTEGER || 9007199254740991;
function toNumber(value) {
  const num = parseFloat(value);
  return isNotNumber(num) ? 0 : num;
}
function toPrecision(value, precision) {
  let nextValue = toNumber(value);
  const scaleFactor = 10 ** (precision != null ? precision : 10);
  nextValue = Math.round(nextValue * scaleFactor) / scaleFactor;
  return precision ? nextValue.toFixed(precision) : nextValue.toString();
}
function countDecimalPlaces(value) {
  if (!Number.isFinite(value))
    return 0;
  let e = 1;
  let p = 0;
  while (Math.round(value * e) / e !== value) {
    e *= 10;
    p += 1;
  }
  return p;
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function roundValueToStep(value, from, step) {
  const nextValue = Math.round((value - from) / step) * step + from;
  const precision = countDecimalPlaces(step);
  return toPrecision(nextValue, precision);
}
function clampValue(value, min, max) {
  if (value == null)
    return value;
  warn({
    condition: max < min,
    message: "clamp: max cannot be less than min"
  });
  return Math.min(Math.max(value, min), max);
}

// src/pan-event.ts
var import_framesync = __toESM(__webpack_require__(84839));

// src/pointer-event.ts
function isMouseEvent(event) {
  const win = getEventWindow(event);
  if (typeof win.PointerEvent !== "undefined" && event instanceof win.PointerEvent) {
    return !!(event.pointerType === "mouse");
  }
  return event instanceof win.MouseEvent;
}
function isTouchEvent(event) {
  const hasTouches = !!event.touches;
  return hasTouches;
}
function filterPrimaryPointer(eventHandler) {
  return (event) => {
    const win = getEventWindow(event);
    const isMouseEvent2 = event instanceof win.MouseEvent;
    const isPrimaryPointer = !isMouseEvent2 || isMouseEvent2 && event.button === 0;
    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
  const primaryTouch = e.touches[0] || e.changedTouches[0];
  const point = primaryTouch || defaultPagePoint;
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function pointFromMouse(point, pointType = "page") {
  return {
    x: point[`${pointType}X`],
    y: point[`${pointType}Y`]
  };
}
function extractEventInfo(event, pointType = "page") {
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}
function getViewportPointFromEvent(event) {
  return extractEventInfo(event, "client");
}
var wrapPointerEventHandler = (handler, shouldFilterPrimaryPointer = false) => {
  const listener = (event) => handler(event, extractEventInfo(event));
  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};
var supportsPointerEvents = () => isBrowser && window.onpointerdown === null;
var supportsTouchEvents = () => isBrowser && window.ontouchstart === null;
var supportsMouseEvents = () => isBrowser && window.onmousedown === null;
var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  }
  if (supportsTouchEvents()) {
    return touchEventNames[name];
  }
  if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }
  return name;
}
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(
    target,
    getPointerEventName(eventName),
    wrapPointerEventHandler(handler, eventName === "pointerdown"),
    options
  );
}
function isMultiTouchEvent(event) {
  return isTouchEvent(event) && event.touches.length > 1;
}

// src/pan-event.ts
var PanSession = class {
  constructor(event, handlers, threshold) {
    __publicField(this, "history", []);
    __publicField(this, "startEvent", null);
    __publicField(this, "lastEvent", null);
    __publicField(this, "lastEventInfo", null);
    __publicField(this, "handlers", {});
    __publicField(this, "removeListeners", noop);
    __publicField(this, "threshold", 3);
    __publicField(this, "win");
    __publicField(this, "updatePoint", () => {
      if (!(this.lastEvent && this.lastEventInfo))
        return;
      const info = getPanInfo(this.lastEventInfo, this.history);
      const isPanStarted = this.startEvent !== null;
      const isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= this.threshold;
      if (!isPanStarted && !isDistancePastThreshold)
        return;
      const { timestamp } = (0, import_framesync.getFrameData)();
      this.history.push({ ...info.point, timestamp });
      const { onStart, onMove } = this.handlers;
      if (!isPanStarted) {
        onStart == null ? void 0 : onStart(this.lastEvent, info);
        this.startEvent = this.lastEvent;
      }
      onMove == null ? void 0 : onMove(this.lastEvent, info);
    });
    __publicField(this, "onPointerMove", (event, info) => {
      this.lastEvent = event;
      this.lastEventInfo = info;
      if (isMouseEvent(event) && event.buttons === 0) {
        this.onPointerUp(event, info);
        return;
      }
      import_framesync.default.update(this.updatePoint, true);
    });
    __publicField(this, "onPointerUp", (event, info) => {
      const panInfo = getPanInfo(info, this.history);
      const { onEnd, onSessionEnd } = this.handlers;
      onSessionEnd == null ? void 0 : onSessionEnd(event, panInfo);
      this.end();
      if (!onEnd || !this.startEvent)
        return;
      onEnd == null ? void 0 : onEnd(event, panInfo);
    });
    this.win = getEventWindow(event);
    if (isMultiTouchEvent(event))
      return;
    this.handlers = handlers;
    if (threshold) {
      this.threshold = threshold;
    }
    event.stopPropagation();
    event.preventDefault();
    const info = extractEventInfo(event);
    const { timestamp } = (0, import_framesync.getFrameData)();
    this.history = [{ ...info.point, timestamp }];
    const { onSessionStart } = handlers;
    onSessionStart == null ? void 0 : onSessionStart(event, getPanInfo(info, this.history));
    this.removeListeners = pipe(
      addPointerEvent(this.win, "pointermove", this.onPointerMove),
      addPointerEvent(this.win, "pointerup", this.onPointerUp),
      addPointerEvent(this.win, "pointercancel", this.onPointerUp)
    );
  }
  updateHandlers(handlers) {
    this.handlers = handlers;
  }
  end() {
    var _a;
    (_a = this.removeListeners) == null ? void 0 : _a.call(this);
    import_framesync.cancelSync.update(this.updatePoint);
  }
};
function subtractPoint(a, b) {
  return { x: a.x - b.x, y: a.y - b.y };
}
function startPanPoint(history) {
  return history[0];
}
function lastPanPoint(history) {
  return history[history.length - 1];
}
function getPanInfo(info, history) {
  return {
    point: info.point,
    delta: subtractPoint(info.point, lastPanPoint(history)),
    offset: subtractPoint(info.point, startPanPoint(history)),
    velocity: getVelocity(history, 0.1)
  };
}
function lastDevicePoint(history) {
  return history[history.length - 1];
}
var toMilliseconds = (seconds) => seconds * 1e3;
function getVelocity(history, timeDelta) {
  if (history.length < 2) {
    return { x: 0, y: 0 };
  }
  let i = history.length - 1;
  let timestampedPoint = null;
  const lastPoint = lastDevicePoint(history);
  while (i >= 0) {
    timestampedPoint = history[i];
    if (lastPoint.timestamp - timestampedPoint.timestamp > toMilliseconds(timeDelta)) {
      break;
    }
    i--;
  }
  if (!timestampedPoint) {
    return { x: 0, y: 0 };
  }
  const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1e3;
  if (time === 0) {
    return { x: 0, y: 0 };
  }
  const currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };
  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }
  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }
  return currentVelocity;
}

// src/responsive.ts
var breakpoints = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function mapResponsive(prop, mapper) {
  if (isArray(prop)) {
    return prop.map((item) => {
      if (item === null) {
        return null;
      }
      return mapper(item);
    });
  }
  if (isObject(prop)) {
    return objectKeys(prop).reduce((result, key) => {
      result[key] = mapper(prop[key]);
      return result;
    }, {});
  }
  if (prop != null) {
    return mapper(prop);
  }
  return null;
}
function objectToArrayNotation(obj, bps = breakpoints) {
  const result = bps.map((br) => {
    var _a;
    return (_a = obj[br]) != null ? _a : null;
  });
  while (getLastItem(result) === null) {
    result.pop();
  }
  return result;
}
function arrayToObjectNotation(values, bps = breakpoints) {
  const result = {};
  values.forEach((value, index) => {
    const key = bps[index];
    if (value == null)
      return;
    result[key] = value;
  });
  return result;
}
function isResponsiveObjectLike(obj, bps = breakpoints) {
  const keys2 = Object.keys(obj);
  return keys2.length > 0 && keys2.every((key) => bps.includes(key));
}
var isCustomBreakpoint = (maybeBreakpoint) => Number.isNaN(Number(maybeBreakpoint));

// src/user-agent.ts
function getUserAgentBrowser(navigator) {
  const { userAgent: ua, vendor } = navigator;
  const android = /(android)/i.test(ua);
  switch (true) {
    case /CriOS/.test(ua):
      return "Chrome for iOS";
    case /Edg\//.test(ua):
      return "Edge";
    case (android && /Silk\//.test(ua)):
      return "Silk";
    case (/Chrome/.test(ua) && /Google Inc/.test(vendor)):
      return "Chrome";
    case /Firefox\/\d+\.\d+$/.test(ua):
      return "Firefox";
    case android:
      return "AOSP";
    case /MSIE|Trident/.test(ua):
      return "IE";
    case (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(ua)):
      return "Safari";
    case /AppleWebKit/.test(ua):
      return "WebKit";
    default:
      return null;
  }
}
function getUserAgentOS(navigator) {
  const { userAgent: ua, platform } = navigator;
  switch (true) {
    case /Android/.test(ua):
      return "Android";
    case /iPhone|iPad|iPod/.test(platform):
      return "iOS";
    case /Win/.test(platform):
      return "Windows";
    case /Mac/.test(platform):
      return "Mac";
    case /CrOS/.test(ua):
      return "Chrome OS";
    case /Firefox/.test(ua):
      return "Firefox OS";
    default:
      return null;
  }
}
function detectDeviceType(navigator) {
  const { userAgent: ua } = navigator;
  if (/(tablet)|(iPad)|(Nexus 9)/i.test(ua))
    return "tablet";
  if (/(mobi)/i.test(ua))
    return "phone";
  return "desktop";
}
function detectOS(os) {
  if (!isBrowser)
    return false;
  return getUserAgentOS(window.navigator) === os;
}
function detectBrowser(browser) {
  if (!isBrowser)
    return false;
  return getUserAgentBrowser(window.navigator) === browser;
}
function detectTouch() {
  if (!isBrowser)
    return false;
  return window.ontouchstart === null && window.ontouchmove === null && window.ontouchend === null;
}

// src/walk-object.ts
function walkObject(target, predicate) {
  function inner(value, path = []) {
    if (isArray(value)) {
      return value.map((item, index) => inner(item, [...path, String(index)]));
    }
    if (isObject(value)) {
      return fromEntries(
        Object.entries(value).map(([key, child]) => [
          key,
          inner(child, [...path, key])
        ])
      );
    }
    return predicate(value, path);
  }
  return inner(target);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 55952:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(77139);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(63146);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(55021);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 77139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(91486);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(91444);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(63146);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(52723);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(55021);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(53504);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(37135);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 63146:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(55021);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 37135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(53504);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 52723:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 91486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(64923);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 53504:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 55021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 91444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(64923);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 64923:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 15764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(55952);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 39137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var SelectInput_1 = __importDefault(__webpack_require__(90155));
var form_control_1 = __importDefault(__webpack_require__(42329));
var native_select_1 = __webpack_require__(1727);
var input_label_1 = __importDefault(__webpack_require__(39067));
var utils_1 = __webpack_require__(48247);
var input_1 = __importDefault(__webpack_require__(89612));
var filled_input_1 = __importDefault(__webpack_require__(2401));
var outlined_input_1 = __importDefault(__webpack_require__(9918));
var form_helper_text_1 = __importDefault(__webpack_require__(41011));
var style = __importStar(__webpack_require__(8967));
var Select = (0, react_1.forwardRef)(function (props, ref) {
    var _a = props.autoWidth, autoWidth = _a === void 0 ? false : _a, children = props.children, className = props.className, _b = props.defaultOpen, defaultOpen = _b === void 0 ? false : _b, disabled = props.disabled, _c = props.displayEmpty, displayEmpty = _c === void 0 ? false : _c, error = props.error, fullWidth = props.fullWidth, helperText = props.helperText, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _d = props.multiple, multiple = _d === void 0 ? false : _d, _e = props.native, native = _e === void 0 ? true : _e, onClose = props.onClose, onOpen = props.onOpen, open = props.open, _f = props.options, options = _f === void 0 ? [] : _f, renderValue = props.renderValue, required = props.required, SelectDisplayProps = props.SelectDisplayProps, _g = props.variant, variant = _g === void 0 ? 'outlined' : _g, other = __rest(props, ["autoWidth", "children", "className", "defaultOpen", "disabled", "displayEmpty", "error", "fullWidth", "helperText", "id", "input", "inputProps", "label", "labelId", "multiple", "native", "onClose", "onOpen", "open", "options", "renderValue", "required", "SelectDisplayProps", "variant"]);
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputComponent = native ? native_select_1.NativeSelectInput : SelectInput_1.default;
    // TODO: fix type
    var InputComponent = {
        standard: (0, jsx_runtime_1.jsx)(input_1.default, {}),
        outlined: (0, jsx_runtime_1.jsx)(outlined_input_1.default, { label: label }),
        filled: (0, jsx_runtime_1.jsx)(filled_input_1.default, {}),
    }[variant];
    var inputComponentRef = (0, utils_1.useForkRef)(ref, InputComponent.ref);
    return ((0, jsx_runtime_1.jsxs)(form_control_1.default, __assign({ className: className, disabled: disabled, error: error, fullWidth: fullWidth, ref: ref, required: required, variant: variant, css: style.formControl }, { children: [label != null && label !== '' && ((0, jsx_runtime_1.jsx)(input_label_1.default, __assign({ id: labelId, htmlFor: id }, { children: label }))), (0, react_1.cloneElement)(InputComponent, __assign(__assign(__assign({ 
                // Most of the logic is implemented in `SelectInput`.
                // The `Select` component is a simple API wrapper to expose something better to play with.
                inputComponent: inputComponent, inputProps: __assign(__assign({ children: children, type: undefined, // We render a select. We can ignore the type provided by the `Input`.
                    multiple: multiple, options: options }, (native
                    ? { id: id }
                    : {
                        autoWidth: autoWidth,
                        defaultOpen: defaultOpen,
                        displayEmpty: displayEmpty,
                        labelId: labelId,
                        onClose: onClose,
                        onOpen: onOpen,
                        open: open,
                        renderValue: renderValue,
                        SelectDisplayProps: __assign({ id: id }, SelectDisplayProps),
                    })), inputProps) }, (multiple && native && variant === 'outlined' ? { notched: true } : {})), { inputRef: inputComponentRef, className: className, variant: variant }), other)), (helperText || typeof error === 'string') && ((0, jsx_runtime_1.jsx)(form_helper_text_1.default, __assign({ id: helperTextId }, { children: typeof error === 'string' ? error : helperText && helperText })))] })));
});
Select.displayName = 'PrezzeeSelect';
exports["default"] = Select;
//# sourceMappingURL=Select.js.map

/***/ }),

/***/ 8967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formControl = void 0;
var react_1 = __webpack_require__(43234);
exports.formControl = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 120px;\n"], ["\n  min-width: 120px;\n"])));
var templateObject_1;
//# sourceMappingURL=Select.style.js.map

/***/ }),

/***/ 90155:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
// import { isFragment } from 'react-is';
var clsx_1 = __importDefault(__webpack_require__(86010));
var style = __importStar(__webpack_require__(57290));
var menu_1 = __importDefault(__webpack_require__(22047));
var menu_item_1 = __importDefault(__webpack_require__(98286));
var utils_1 = __webpack_require__(48247);
var utils_2 = __webpack_require__(48247);
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) {
        return a === b;
    }
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || (typeof display === 'string' && !display.trim());
}
var SelectIcon = function (_a) {
    var open = _a.open;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ css: style.icon(open), focusable: "false", "aria-hidden": "true", viewBox: "0 0 24 24", "data-testid": "ArrowDropDownIcon" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7 10l5 5 5-5z" }) })));
};
/**
 * @ignore - internal component.
 */
var SelectInput = (0, react_1.forwardRef)(function (props, ref) {
    var ariaDescribedby = props["aria-describedby"], ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, className = props.className, defaultOpen = props.defaultOpen, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _a = props.MenuProps, MenuProps = _a === void 0 ? {} : _a, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, _b = props.options, options = _b === void 0 ? [] : _b, readOnly = props.readOnly, renderValue = props.renderValue, _c = props.SelectDisplayProps, SelectDisplayProps = _c === void 0 ? {} : _c, tabIndexProp = props.tabIndex, 
    // catching `type` from Input which makes no sense for SelectInput
    // @ts-ignore
    type = props.type, valueProp = props.value, _d = props.variant, variant = _d === void 0 ? 'standard' : _d, rest = __rest(props, ['aria-describedby', 'aria-label', "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "options", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
    var _e = __read((0, utils_2.useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select',
    }), 2), value = _e[0], setValueState = _e[1];
    var _f = __read((0, utils_2.useControlled)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select Open',
    }), 2), openState = _f[0], setOpenState = _f[1];
    var inputRef = (0, react_1.useRef)(null);
    var displayRef = (0, react_1.useRef)(null);
    var _g = __read((0, react_1.useState)(null), 2), displayNode = _g[0], setDisplayNode = _g[1];
    var isOpenControlled = (0, react_1.useRef)(openProp != null).current;
    var _h = __read((0, react_1.useState)(null), 2), menuMinWidthState = _h[0], setMenuMinWidthState = _h[1];
    var handleRef = (0, utils_2.useForkRef)(ref, inputRefProp);
    var handleDisplayRef = (0, react_1.useCallback)(function (node) {
        displayRef.current = node;
        if (node) {
            setDisplayNode(node);
        }
    }, []);
    (0, react_1.useImperativeHandle)(handleRef, function () { return ({
        focus: function () {
            var _a;
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        node: inputRef.current,
        value: value,
    }); }, [value]);
    // Resize menu on `defaultOpen` automatic toggle.
    (0, react_1.useEffect)(function () {
        var _a;
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayNode, autoWidth]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    (0, react_1.useEffect)(function () {
        var _a;
        if (autoFocus) {
            (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocus]);
    (0, react_1.useEffect)(function () {
        if (!labelId) {
            return undefined;
        }
        var label = (0, utils_2.ownerDocument)(displayRef.current).getElementById(labelId);
        if (label) {
            var handler_1 = function () {
                var _a, _b;
                if ((_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.isCollapsed) {
                    (_b = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            };
            label.addEventListener('click', handler_1);
            return function () {
                label.removeEventListener('click', handler_1);
            };
        }
        return undefined;
    }, [labelId]);
    var update = function (open, event) {
        if (open) {
            if (onOpen) {
                onOpen(event);
            }
        }
        else if (onClose) {
            onClose(event);
        }
        if (!isOpenControlled && displayNode) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function (event) {
        var _a;
        // Ignore everything but left-click
        if (event.button !== 0) {
            return;
        }
        // Hijack the default focus behavior.
        event.preventDefault();
        (_a = displayRef === null || displayRef === void 0 ? void 0 : displayRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        update(true, event);
    };
    // TODO: fix type
    var handleClose = function (event) {
        update(false, event);
    };
    var childrenArray = react_1.Children.toArray(children);
    // Support autofill.
    // TODO: fix type
    var handleChange = function (event) {
        var index = childrenArray.map(function (child) { return child.props.value; }).indexOf(event.target.value);
        if (index === -1) {
            return;
        }
        var child = childrenArray[index];
        setValueState(child.props.value);
        if (onChange) {
            onChange(event, child);
        }
    };
    // TODO: fix type
    var handleItemClick = function (option) { return function (event) {
        var newValue;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            var itemIndex = value.indexOf(option.value);
            if (itemIndex === -1) {
                newValue.push(option.value);
            }
            else {
                newValue.splice(itemIndex, 1);
            }
        }
        else {
            newValue = option.value;
        }
        if (value !== newValue) {
            setValueState(newValue);
            if (onChange) {
                // Redefine target to allow name and value to be read.
                // This allows seamless integration with the most popular form libraries
                // Clone the event to not override `target` of the original event.
                var nativeEvent = event.nativeEvent || event;
                var clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                Object.defineProperty(clonedEvent, 'target', {
                    writable: true,
                    value: { value: newValue, name: name },
                });
                onChange(clonedEvent);
            }
        }
        if (!multiple) {
            update(false, event);
        }
    }; };
    var handleKeyDown = function (event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on MacOS, but it's recommended by
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter',
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && openState;
    var handleBlur = function (event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', { writable: true, value: { value: value, name: name } });
            onBlur(event);
        }
    };
    delete rest['aria-invalid'];
    var display;
    var displaySingle;
    // TODO: fix type
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, utils_1.isFilled)({ value: value }) || displayEmpty) {
        if (renderValue) {
            display = renderValue(value);
        }
        else {
            computeDisplay = true;
        }
    }
    var items = options.map(function (option, index) {
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) {
                throw new Error('The `value` prop must be an array ' +
                    'when using the `Select` component with `multiple`.');
            }
            selected = value.some(function (v) { return areEqualValues(v, option.value); });
            if (selected && computeDisplay) {
                displayMultiple.push(option.label ? option.label : option.value);
            }
        }
        else {
            selected = areEqualValues(value, option.value);
            if (selected && computeDisplay) {
                displaySingle = option.label ? option.label : option.value;
            }
        }
        if (selected) {
            foundMatch = true;
        }
        if (option.value === undefined) {
            return ((0, jsx_runtime_1.jsx)(menu_item_1.default, __assign({ "aria-readonly": true, role: "option" }, { children: option.label ? option.label : option.value }), index));
        }
        return ((0, jsx_runtime_1.jsx)(menu_item_1.default, __assign({ "aria-selected": selected ? true : false, onClick: handleItemClick(option), onKeyUp: function (event) {
                if (event.key === ' ') {
                    // otherwise our MenuItems dispatches a click event
                    // it's not behavior of the native <option> and causes
                    // the select to close immediately since we open on space keydown
                    event.preventDefault();
                }
            }, role: "option", 
            // @ts-ignore
            selected: selected, value: undefined, "data-value": value }, { children: option.label ? option.label : option.value }), index));
    });
    if (false) {}
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) {
                display = null;
            }
            else {
                display = displayMultiple.reduce(function (output, child, index) {
                    output.push(child);
                    if (index < displayMultiple.length - 1) {
                        output.push(', ');
                    }
                    return output;
                }, []);
            }
        }
        else {
            display = displaySingle;
        }
    }
    // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) {
        menuMinWidth = displayNode.clientWidth;
    }
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
    }
    else {
        tabIndex = disabled ? undefined : 0;
    }
    var buttonId = SelectDisplayProps.id || (name ? "prezzee-component-select-".concat(name) : undefined);
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ ref: handleDisplayRef, tabIndex: tabIndex, role: "button", "aria-disabled": disabled ? 'true' : undefined, "aria-expanded": open ? 'true' : 'false', "aria-haspopup": "listbox", "aria-label": ariaLabel, "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined, "aria-describedby": ariaDescribedby, onKeyDown: handleKeyDown, onMouseDown: disabled || readOnly ? undefined : handleMouseDown, onBlur: handleBlur, onFocus: onFocus }, SelectDisplayProps, { css: style.container, className: (0, clsx_1.default)(className, SelectDisplayProps.className), 
                // The id is required for proper a11y
                id: buttonId }, { children: isEmpty(display) ? (
                // notranslate needed while Google Translate will not fix zero-width space issue
                (0, jsx_runtime_1.jsx)("span", __assign({ className: "notranslate" }, { children: "\u200B" }))) : (display) })), (0, jsx_runtime_1.jsx)("input", __assign({ value: Array.isArray(value) ? value.join(',') : value, name: name, ref: inputRef, "aria-hidden": true, onChange: handleChange, tabIndex: -1, disabled: disabled, autoFocus: autoFocus }, rest, { css: style.nativeSelect })), (0, jsx_runtime_1.jsx)(SelectIcon, { open: open }), (0, jsx_runtime_1.jsx)(menu_1.default, __assign({ id: "menu-".concat(name || ''), anchorEl: displayNode, open: open, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, MenuProps, { MenuListProps: __assign({ 'aria-labelledby': labelId, role: 'listbox', disableListWrap: true }, MenuProps.MenuListProps), PaperProps: __assign(__assign({}, MenuProps.PaperProps), { style: __assign({ minWidth: menuMinWidth }, (MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)) }) }, { children: items }))] }));
});
exports["default"] = SelectInput;
//# sourceMappingURL=SelectInput.js.map

/***/ }),

/***/ 57290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.icon = exports.nativeSelect = exports.container = void 0;
var react_1 = __webpack_require__(43234);
var tokens_1 = __webpack_require__(53126);
exports.container = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: auto !important;\n  min-height: 1.4375em !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  cursor: pointer;\n"], ["\n  height: auto !important;\n  min-height: 1.4375em !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  cursor: pointer;\n"])));
exports.nativeSelect = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%;\n  box-sizing: border-box;\n"], ["\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%;\n  box-sizing: border-box;\n"])));
var icon = function (open) { return (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  user-select: none;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  fill: currentcolor;\n  flex-shrink: 0;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-size: 1.5rem;\n  position: absolute;\n  right: 7px;\n  top: calc(50% - 0.5em);\n  pointer-events: none;\n  color: ", ";\n  ", "\n"], ["\n  user-select: none;\n  width: 1em;\n  height: 1em;\n  display: inline-block;\n  fill: currentcolor;\n  flex-shrink: 0;\n  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  font-size: 1.5rem;\n  position: absolute;\n  right: 7px;\n  top: calc(50% - 0.5em);\n  pointer-events: none;\n  color: ", ";\n  ", "\n"])), tokens_1.colors.gray800, open && 'transform: rotate(180deg);'); };
exports.icon = icon;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SelectInput.style.js.map

/***/ }),

/***/ 37318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Select_1 = __webpack_require__(39137);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Select_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4020:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(35944);
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var react_uid_1 = __webpack_require__(43412);
var outlined_input_1 = __importDefault(__webpack_require__(9918));
var filled_input_1 = __importDefault(__webpack_require__(2401));
var input_1 = __importDefault(__webpack_require__(89612));
var input_label_1 = __importDefault(__webpack_require__(39067));
var form_helper_text_1 = __importDefault(__webpack_require__(41011));
var form_control_1 = __importDefault(__webpack_require__(42329));
var variantComponent = {
    standard: input_1.default,
    filled: filled_input_1.default,
    outlined: outlined_input_1.default,
};
var TextField = (0, react_1.forwardRef)(function (_a, ref) {
    var autoComplete = _a.autoComplete, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, className = _a.className, defaultValue = _a.defaultValue, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, helperText = _a.helperText, idOverride = _a.id, inputRef = _a.inputRef, InputProps = _a.InputProps, label = _a.label, maxRows = _a.maxRows, minRows = _a.minRows, _f = _a.multiline, multiline = _f === void 0 ? false : _f, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, _g = _a.required, required = _g === void 0 ? false : _g, rows = _a.rows, type = _a.type, value = _a.value, _h = _a.variant, variant = _h === void 0 ? 'outlined' : _h, other = __rest(_a, ["autoComplete", "autoFocus", "className", "defaultValue", "disabled", "error", "fullWidth", "helperText", "id", "inputRef", "InputProps", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "type", "value", "variant"]);
    var uid = (0, react_uid_1.useUID)();
    var id = idOverride || 'text-field-' + uid;
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputElement = variantComponent[variant];
    var dynamicProps = {};
    if (variant === 'outlined') {
        dynamicProps.label = label;
    }
    return ((0, jsx_runtime_1.jsxs)(form_control_1.default, __assign({ className: className, disabled: disabled, error: error, fullWidth: fullWidth, ref: ref, required: required, variant: variant }, other, { children: [label != null && label !== '' && ((0, jsx_runtime_1.jsx)(input_label_1.default, __assign({ id: inputLabelId, htmlFor: id }, { children: label }))), (0, jsx_runtime_1.jsx)(InputElement, __assign({ "aria-describedby": helperTextId, autoComplete: autoComplete, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, fullWidth: fullWidth, multiline: multiline, name: name, rows: rows, maxRows: maxRows, minRows: minRows, type: type, value: value, id: id, ref: inputRef, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder }, dynamicProps, InputProps)), (helperText || typeof error === 'string') && ((0, jsx_runtime_1.jsx)(form_helper_text_1.default, __assign({ id: helperTextId }, { children: typeof error === 'string' ? error : helperText && helperText })))] })));
});
TextField.displayName = 'PrezzeeTextField';
exports["default"] = TextField;
//# sourceMappingURL=TextField.js.map

/***/ }),

/***/ 24308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var TextField_1 = __webpack_require__(4020);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(TextField_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultBreakpoints = void 0;
exports.defaultBreakpoints = {
    xs: 0,
    sm: 600,
    md: 986,
    lg: 1281,
    xl: 1536,
};
//# sourceMappingURL=breakpoints.js.map

/***/ }),

/***/ 49458:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAccordions = exports.defaultThemeAccordions = void 0;
var tokens_1 = __webpack_require__(53126);
exports.defaultThemeAccordions = {
    primary: {
        buttonBackgroundColor: tokens_1.colors.white,
        panelBackgroundColor: tokens_1.colors.white,
    },
    secondary: {
        buttonBackgroundColor: tokens_1.colors.gray100,
        panelBackgroundColor: tokens_1.colors.gray100,
    }
};
var createAccordions = function (accordionTransitions
// accordionTransitions: any
) {
    var mergedPrimary = __assign(__assign({}, exports.defaultThemeAccordions.primary), accordionTransitions === null || accordionTransitions === void 0 ? void 0 : accordionTransitions.primary);
    var mergedSecondary = __assign(__assign({}, exports.defaultThemeAccordions.secondary), accordionTransitions === null || accordionTransitions === void 0 ? void 0 : accordionTransitions.secondary);
    return {
        primary: mergedPrimary,
        secondary: mergedSecondary
    };
};
exports.createAccordions = createAccordions;
//# sourceMappingURL=accordions.js.map

/***/ }),

/***/ 96726:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.composeComponents = void 0;
var Accordions = __importStar(__webpack_require__(49458));
var composeComponents = function (componentThemes) {
    Accordions.createAccordions(componentThemes === null || componentThemes === void 0 ? void 0 : componentThemes.accordions);
};
exports.composeComponents = composeComponents;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 13499:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTheme = exports.ThemeProvider = exports.ThemeContext = exports.createTheme = exports.defaultTheme = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var breakpoints_1 = __webpack_require__(6742);
var palette_1 = __webpack_require__(33125);
var typography_1 = __webpack_require__(36019);
var transitions_1 = __webpack_require__(48284);
var accordions_1 = __webpack_require__(49458);
var deepmerge_1 = __importDefault(__webpack_require__(9996));
var shadows_1 = __webpack_require__(50064);
var components_1 = __webpack_require__(96726);
exports.defaultTheme = {
    breakpoints: breakpoints_1.defaultBreakpoints,
    palette: palette_1.defaultPalette,
    shadows: shadows_1.defaultShadows,
    typography: typography_1.defaultTypography,
    transitions: (0, transitions_1.createTransitions)({}),
    components: {
        accordions: accordions_1.defaultThemeAccordions,
    }
};
function createTheme(options) {
    if (options === void 0) { options = {}; }
    var _a = options.breakpoints, breakpointsInput = _a === void 0 ? {} : _a, 
    // mixins: mixinsInput = {},
    // spacing: spacingInput,
    _b = options.palette, 
    // mixins: mixinsInput = {},
    // spacing: spacingInput,
    paletteInput = _b === void 0 ? {} : _b, _c = options.transitions, transitionsInput = _c === void 0 ? {} : _c, _d = options.typography, typographyInput = _d === void 0 ? {} : _d, _e = options.components, componentsInput = _e === void 0 ? {} : _e;
    return (0, deepmerge_1.default)(exports.defaultTheme, {
        breakpoints: breakpointsInput,
        palettee: (0, palette_1.createPalette)(paletteInput),
        typography: (0, typography_1.createTypography)(typographyInput),
        transitions: (0, transitions_1.createTransitions)(transitionsInput),
        components: (0, components_1.composeComponents)(componentsInput),
    });
}
exports.createTheme = createTheme;
exports.ThemeContext = (0, react_1.createContext)(exports.defaultTheme);
var ThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (0, jsx_runtime_1.jsx)(exports.ThemeContext.Provider, __assign({ value: theme }, { children: children }));
};
exports.ThemeProvider = ThemeProvider;
var useTheme = function () {
    var context = (0, react_1.useContext)(exports.ThemeContext);
    if (!context)
        return exports.defaultTheme;
    return context;
};
exports.useTheme = useTheme;
//# sourceMappingURL=context.js.map

/***/ }),

/***/ 72265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(6742), exports);
__exportStar(__webpack_require__(13499), exports);
__exportStar(__webpack_require__(33125), exports);
__exportStar(__webpack_require__(36019), exports);
__exportStar(__webpack_require__(48284), exports);
__exportStar(__webpack_require__(49458), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 33125:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createPalette = exports.defaultPalette = void 0;
var tokens_1 = __webpack_require__(53126);
exports.defaultPalette = {
    primary: {
        base: tokens_1.colors.red400,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.red500,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.red700,
        activeText: tokens_1.colors.white,
    },
    secondary: {
        base: tokens_1.colors.purple400,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.purple600,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.purple700,
        activeText: tokens_1.colors.white,
    },
    tertiary: {
        base: tokens_1.colors.blue500,
        baseText: tokens_1.colors.white,
        hover: tokens_1.colors.blue300,
        hoverText: tokens_1.colors.white,
        active: tokens_1.colors.blue700,
        activeText: tokens_1.colors.white,
    },
    text: {
        heading: tokens_1.colors.gray800,
        body: tokens_1.colors.gray600,
    },
};
// TODO: Setup deepmerge of palette input for theme
function createPalette(paletteInput) {
    console.log(paletteInput);
    return exports.defaultPalette;
}
exports.createPalette = createPalette;
//# sourceMappingURL=palette.js.map

/***/ }),

/***/ 50064:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultShadows = void 0;
var tokens_1 = __webpack_require__(53126);
exports.defaultShadows = {
    xs: tokens_1.shadows.xs,
    sm: tokens_1.shadows.sm,
    md: tokens_1.shadows.md,
    lg: tokens_1.shadows.lg,
    xl: tokens_1.shadows.xl,
};
//# sourceMappingURL=shadows.js.map

/***/ }),

/***/ 48284:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createTransitions = exports.duration = exports.easing = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};
// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195,
};
function formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
function getAutoHeightDuration(height) {
    if (!height) {
        return 0;
    }
    var constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    var mergedEasing = __assign(__assign({}, exports.easing), inputTransitions.easing);
    var mergedDuration = __assign(__assign({}, exports.duration), inputTransitions.duration);
    var create = function (props, options) {
        if (props === void 0) { props = ['all']; }
        if (options === void 0) { options = {}; }
        var _a = options.duration, durationOption = _a === void 0 ? mergedDuration.standard : _a, _b = options.easing, easingOption = _b === void 0 ? mergedEasing.easeInOut : _b, _c = options.delay, delay = _c === void 0 ? 0 : _c, other = __rest(options, ["duration", "easing", "delay"]);
        if (false) { var isNumber, isString; }
        return (Array.isArray(props) ? props : [props])
            .map(function (animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
        })
            .join(',');
    };
    return __assign(__assign({ getAutoHeightDuration: getAutoHeightDuration, create: create }, inputTransitions), { easing: mergedEasing, duration: mergedDuration });
}
exports.createTransitions = createTransitions;
//# sourceMappingURL=transitions.js.map

/***/ }),

/***/ 36019:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createTypography = exports.defaultTypography = void 0;
var breakpoints_1 = __webpack_require__(6742);
exports.defaultTypography = {
    display1: {
        fontSize: '3.875rem',
        lineHeight: '1.13',
        responsive: (_a = {},
            _a["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.875rem',
                lineHeight: '1.17',
            },
            _a),
    },
    display2: {
        fontSize: '3.25rem',
        lineHeight: '1.19',
        responsive: (_b = {},
            _b["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.625rem',
                lineHeight: '1.24',
            },
            _b),
    },
    h1: {
        fontSize: '2.625rem',
        lineHeight: '1.24',
        responsive: (_c = {},
            _c["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2.25rem',
                lineHeight: '1.28',
            },
            _c),
    },
    h2: {
        fontSize: '2.25rem',
        lineHeight: '1.28',
        responsive: (_d = {},
            _d["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '2rem',
                lineHeight: '1.31',
            },
            _d),
    },
    h3: {
        fontSize: '2rem',
        lineHeight: '1.31',
        responsive: (_e = {},
            _e["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.75rem',
                lineHeight: '1.36',
            },
            _e),
    },
    h4: {
        fontSize: '1.5rem',
        lineHeight: '1.33',
        responsive: (_f = {},
            _f["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.5rem',
            },
            _f),
    },
    h5: {
        fontSize: '1.375rem',
        lineHeight: '1.3',
        responsive: (_g = {},
            _g["@media (max-width: ".concat(breakpoints_1.defaultBreakpoints.sm, "px)")] = {
                fontSize: '1.375rem',
                lineHeight: '1.36',
            },
            _g),
    },
    h6: {
        fontSize: '1.25rem',
        lineHeight: '1.4',
    },
    subtitle1: {
        fontSize: '1.125rem',
        lineHeight: '1.44',
    },
    subtitle2: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
    body1: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
    body2: {
        fontSize: '0.875rem',
        lineHeight: '1.57',
    },
    caption: {
        fontSize: '0.75rem',
        lineHeight: '1.67',
    },
    link: {
        fontSize: '1rem',
        lineHeight: '1.5',
    },
};
// TODO: setup deepmerge
function createTypography(typograghyInput) {
    console.log(typograghyInput);
    return exports.defaultTypography;
}
exports.createTypography = createTypography;
//# sourceMappingURL=typography.js.map

/***/ }),

/***/ 26993:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.yellow600 = exports.yellow700 = exports.green50 = exports.green100 = exports.green200 = exports.green300 = exports.green400 = exports.green500 = exports.green600 = exports.green700 = exports.blue50 = exports.blue100 = exports.blue200 = exports.blue300 = exports.blue400 = exports.blue500 = exports.blue600 = exports.blue700 = exports.lilac50 = exports.lilac100 = exports.lilac200 = exports.lilac300 = exports.lilac400 = exports.lilac500 = exports.lilac600 = exports.lilac700 = exports.pink50 = exports.pink100 = exports.pink200 = exports.pink300 = exports.pink400 = exports.pink500 = exports.pink600 = exports.pink700 = exports.red50 = exports.red100 = exports.red200 = exports.red300 = exports.red400 = exports.red500 = exports.red600 = exports.red700 = exports.purple50 = exports.purple100 = exports.purple200 = exports.purple300 = exports.purple400 = exports.purple500 = exports.purple600 = exports.purple700 = void 0;
exports.inactiveGray = exports.notificationBlue = exports.accentBlue = exports.accentYellow = exports.accentPink = exports.white = exports.gray50 = exports.gray100 = exports.gray200 = exports.gray300 = exports.gray400 = exports.gray500 = exports.gray600 = exports.gray700 = exports.gray800 = exports.black = exports.orange50 = exports.orange100 = exports.orange200 = exports.orange300 = exports.orange400 = exports.orange500 = exports.orange600 = exports.orange700 = exports.yellow50 = exports.yellow100 = exports.yellow200 = exports.yellow300 = exports.yellow400 = exports.yellow500 = void 0;
exports.purple700 = '#2B0840';
exports.purple600 = '#32064C';
exports.purple500 = '#410861';
exports.purple400 = '#48096C';
exports.purple300 = '#6D3A89';
exports.purple200 = '#916BA7';
exports.purple100 = '#DACEE2';
exports.purple50 = '#EDE6F0';
exports.red700 = '#480610';
exports.red600 = '#900C20';
exports.red500 = '#BE1807';
exports.red400 = '#ED0B09';
exports.red300 = '#F1453A';
exports.red200 = '#F4736B';
exports.red100 = '#FABCB5';
exports.red50 = '#FDE9E6';
exports.pink700 = '#CC7970';
exports.pink600 = '#FF978C';
exports.pink500 = '#FFB6AF';
exports.pink400 = '#FFD2BD';
exports.pink300 = '#FFE0D1';
exports.pink200 = '#FFE9DE';
exports.pink100 = '#FFF6F2';
exports.pink50 = '#FFFBF8';
exports.lilac700 = '#A09EB0';
exports.lilac600 = '#B7B5C9';
exports.lilac500 = '#CECBE2';
exports.lilac400 = '#E5E2FB';
exports.lilac300 = '#EAE8FC';
exports.lilac200 = '#EDEBFC7';
exports.lilac100 = '#F7F5FD';
exports.lilac50 = '#F6F7F9';
exports.blue700 = '#102C60';
exports.blue600 = '#174291';
exports.blue500 = '#1E54B7';
exports.blue400 = '#1A65F0';
exports.blue300 = '#5B91F5';
exports.blue200 = '#A0BFF8';
exports.blue100 = '#D4E2FC';
exports.blue50 = '#EFF3FE';
exports.green700 = '#0B3429';
exports.green600 = '#166852';
exports.green500 = '#1E8B6D';
exports.green400 = '#25AE88';
exports.green300 = '#51BEA0';
exports.green200 = '#7CCEB8';
exports.green100 = '#A8DFCF';
exports.green50 = '#E9F7F3';
exports.yellow700 = '#806022';
exports.yellow600 = '#B3862F';
exports.yellow500 = '#CC9A36';
exports.yellow400 = '#FFC043';
exports.yellow300 = '#FFCF70';
exports.yellow200 = '#FFE3AC';
exports.yellow100 = '#FFF2D9';
exports.yellow50 = '#FFFAF0';
exports.orange700 = '#7D2714';
exports.orange600 = '#AE371C';
exports.orange500 = '#CC492C';
exports.orange400 = '#FF6937';
exports.orange300 = '#FA9269';
exports.orange200 = '#FABDA5';
exports.orange100 = '#FFE1D6';
exports.orange50 = '#FFF3EF';
exports.black = '#000000';
exports.gray800 = '#1E1E1E';
exports.gray700 = '#302F2F';
exports.gray600 = '#4B4B4B';
exports.gray500 = '#787878';
exports.gray400 = '#A0A0A0';
exports.gray300 = '#C7C3C3';
exports.gray200 = '#E0DEDE';
exports.gray100 = '#F0EDED';
exports.gray50 = '#F8F8F8';
exports.white = '#FFFFFF';
exports.accentPink = '#FFC5EE';
exports.accentYellow = '#F9FF4E';
exports.accentBlue = '#88FDFF';
exports.notificationBlue = '#276EF1';
exports.inactiveGray = '#A9AA9';
//# sourceMappingURL=colors.js.map

/***/ }),

/***/ 53126:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.spacing = exports.shadows = exports.colors = void 0;
var colors = __importStar(__webpack_require__(26993));
exports.colors = colors;
var shadows = __importStar(__webpack_require__(29256));
exports.shadows = shadows;
var spacing = __importStar(__webpack_require__(54231));
exports.spacing = spacing;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29256:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.xl = exports.lg = exports.md = exports.sm = exports.xs = void 0;
exports.xs = '0px 4px 8px rgba(0, 0, 0, 0.08)';
exports.sm = '0px 6px 12px rgba(0, 0, 0, 0.11)';
exports.md = '0px 9px 18px rgba(0, 0, 0, 0.15)';
exports.lg = '0px 13px 37px rgba(0, 0, 0, 0.21)';
exports.xl = '0px 20px 56px rgba(0, 0, 0, 0.29)';
//# sourceMappingURL=shadows.js.map

/***/ }),

/***/ 54231:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Using JSDoc comments to allow px value to show through tellisense.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.spacing40 = exports.spacing36 = exports.spacing32 = exports.spacing28 = exports.spacing24 = exports.spacing20 = exports.spacing16 = exports.spacing14 = exports.spacing12 = exports.spacing11 = exports.spacing10 = exports.spacing09 = exports.spacing08 = exports.spacing07 = exports.spacing06 = exports.spacing05 = exports.spacing04 = exports.spacing035 = exports.spacing03 = exports.spacing025 = exports.spacing02 = exports.spacing015 = exports.spacing01 = exports.spacing005 = void 0;
/**
 * 2px
 */
exports.spacing005 = '0.125rem';
/**
 * 4px
 */
exports.spacing01 = '0.25rem';
/**
 * 6px
 */
exports.spacing015 = '0.375rem';
/**
 * 8px
 */
exports.spacing02 = '0.5rem';
/**
 * 10px
 */
exports.spacing025 = '0.625rem';
/**
 * 12px
 */
exports.spacing03 = '0.75rem';
/**
 * 14px
 */
exports.spacing035 = '0.875rem';
/**
 * 16px
 */
exports.spacing04 = '1rem';
/**
 * 20px
 */
exports.spacing05 = '1.25rem';
/**
 * 24px
 */
exports.spacing06 = '1.5rem';
/**
 * 28px
 */
exports.spacing07 = '1.75rem';
/**
 * 32px
 */
exports.spacing08 = '2rem';
/**
 * 36px
 */
exports.spacing09 = '2.25rem';
/**
 * 40px
 */
exports.spacing10 = '2.5rem';
/**
 * 44px
 */
exports.spacing11 = '2.75rem';
/**
 * 48px
 */
exports.spacing12 = '3rem';
/**
 * 56px
 */
exports.spacing14 = '3.5rem';
/**
 * 64px
 */
exports.spacing16 = '4rem';
/**
 * 80px
 */
exports.spacing20 = '5rem';
/**
 * 96px
 */
exports.spacing24 = '6rem';
/**
 * 112px
 */
exports.spacing28 = '7rem';
/**
 * 128px
 */
exports.spacing32 = '8rem';
/**
 * 144px
 */
exports.spacing36 = '9rem';
/**
 * 160px
 */
exports.spacing40 = '10rem';
//# sourceMappingURL=spacing.js.map

/***/ }),

/***/ 65601:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
var utils_1 = __webpack_require__(48247);
// Inspired by https://github.com/focus-trap/tabbable
var candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
].join(',');
function getTabIndex(node) {
    var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
    if (!Number.isNaN(tabindexAttr)) {
        return tabindexAttr;
    }
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' ||
        ((node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') &&
            node.getAttribute('tabindex') === null)) {
        return 0;
    }
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') {
        return false;
    }
    if (!node.name) {
        return false;
    }
    var getRadio = function (selector) {
        return node.ownerDocument.querySelector("input[type=\"radio\"]".concat(selector));
    };
    var roving = getRadio("[name=\"".concat(node.name, "\"]:checked"));
    if (!roving) {
        roving = getRadio("[name=\"".concat(node.name, "\"]"));
    }
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled ||
        (node.tagName === 'INPUT' && node.type === 'hidden') ||
        isNonTabbableRadio(node)) {
        return false;
    }
    return true;
}
function defaultGetTabbable(root) {
    var regularTabNodes = [];
    var orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach(function (node, i) {
        var nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
            return;
        }
        if (nodeTabIndex === 0) {
            regularTabNodes.push(node);
        }
        else {
            orderedTabNodes.push({
                documentOrder: i,
                tabIndex: nodeTabIndex,
                node: node,
            });
        }
    });
    return orderedTabNodes
        .sort(function (a, b) {
        return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
    })
        .map(function (a) { return a.node; })
        .concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 */
function TrapFocus(props) {
    var children = props.children, _a = props.disableAutoFocus, disableAutoFocus = _a === void 0 ? false : _a, _b = props.disableEnforceFocus, disableEnforceFocus = _b === void 0 ? false : _b, _c = props.disableRestoreFocus, disableRestoreFocus = _c === void 0 ? false : _c, _d = props.getTabbable, getTabbable = _d === void 0 ? defaultGetTabbable : _d, _e = props.isEnabled, isEnabled = _e === void 0 ? defaultIsEnabled : _e, open = props.open;
    var ignoreNextEnforceFocus = (0, react_1.useRef)();
    var sentinelStart = (0, react_1.useRef)(null);
    var sentinelEnd = (0, react_1.useRef)(null);
    var nodeToRestore = (0, react_1.useRef)(null);
    var reactFocusEventTarget = (0, react_1.useRef)(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    var activated = (0, react_1.useRef)(false);
    var rootRef = (0, react_1.useRef)(null);
    // @ts-ignore
    var handleRef = (0, utils_1.useForkRef)(children.ref, rootRef);
    var lastKeydown = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        // We might render an empty child.
        if (!open || !rootRef.current) {
            return;
        }
        activated.current = !disableAutoFocus;
    }, [disableAutoFocus, open]);
    (0, react_1.useEffect)(function () {
        // We might render an empty child.
        if (!open || !rootRef.current) {
            return;
        }
        var doc = (0, utils_1.ownerDocument)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) {
                if (false) {}
                rootRef.current.setAttribute('tabIndex', '-1');
            }
            if (activated.current) {
                rootRef.current.focus();
            }
        }
        return function () {
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
        // Missing `disableRestoreFocus` which is fine.
        // We don't support changing that prop on an open TrapFocus
    }, [open]);
    (0, react_1.useEffect)(function () {
        // We might render an empty child.
        if (!open || !rootRef.current) {
            return;
        }
        var doc = (0, utils_1.ownerDocument)(rootRef.current);
        var contain = function (nativeEvent) {
            var _a, _b;
            var rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) {
                return;
            }
            if (!doc.hasFocus() ||
                disableEnforceFocus ||
                !isEnabled() ||
                ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if ((nativeEvent && reactFocusEventTarget.current !== nativeEvent.target) ||
                    doc.activeElement !== reactFocusEventTarget.current) {
                    reactFocusEventTarget.current = null;
                }
                else if (reactFocusEventTarget.current !== null) {
                    return;
                }
                if (!activated.current) {
                    return;
                }
                var tabbable = [];
                if (doc.activeElement === sentinelStart.current ||
                    doc.activeElement === sentinelEnd.current) {
                    tabbable = getTabbable(rootRef.current);
                }
                if (tabbable.length > 0) {
                    var isShiftTab = Boolean(((_a = lastKeydown.current) === null || _a === void 0 ? void 0 : _a.shiftKey) && ((_b = lastKeydown.current) === null || _b === void 0 ? void 0 : _b.key) === 'Tab');
                    var focusNext = tabbable[0];
                    var focusPrevious = tabbable[tabbable.length - 1];
                    if (isShiftTab) {
                        focusPrevious.focus();
                    }
                    else {
                        focusNext.focus();
                    }
                }
                else {
                    rootElement.focus();
                }
            }
        };
        var loopFocus = function (nativeEvent) {
            var _a;
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
                return;
            }
            // Make sure the next tab starts from the right place.
            // doc.activeElement referes to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                (_a = sentinelEnd.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function () {
            var _a;
            if (((_a = doc === null || doc === void 0 ? void 0 : doc.activeElement) === null || _a === void 0 ? void 0 : _a.tagName) === 'BODY') {
                contain();
            }
        }, 50);
        return function () {
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
    var onFocus = function (event) {
        if (nodeToRestore.current === null) {
            nodeToRestore.current = event.relatedTarget;
        }
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        var childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) {
            childrenPropsHandler(event);
        }
    };
    var handleFocusSentinel = function (event) {
        if (nodeToRestore.current === null) {
            nodeToRestore.current = event.relatedTarget;
        }
        activated.current = true;
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { tabIndex: 0, onFocus: handleFocusSentinel, ref: sentinelStart, "data-test": "sentinelStart" }), (0, react_1.cloneElement)(children, { ref: handleRef, onFocus: onFocus }), (0, jsx_runtime_1.jsx)("div", { tabIndex: 0, onFocus: handleFocusSentinel, ref: sentinelEnd, "data-test": "sentinelEnd" })] }));
}
exports["default"] = TrapFocus;
//# sourceMappingURL=TrapFocus.js.map

/***/ }),

/***/ 71824:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var TrapFocus_1 = __webpack_require__(65601);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(TrapFocus_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46520:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/** @jsxImportSource @emotion/react */
var react_1 = __webpack_require__(67294);
var react_2 = __webpack_require__(43234);
var Typography_style_1 = __webpack_require__(40250);
var theme_1 = __webpack_require__(72265);
var defaultVariantMapping = {
    display1: 'h1',
    display2: 'h1',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'p',
    subtitle2: 'p',
    body1: 'p',
    body2: 'p',
    caption: 'caption',
    link: 'p',
    inherit: 'p',
};
var Typography = (0, react_1.forwardRef)(function (_a, ref) {
    var component = _a.component, _b = _a.gutterBottom, gutterBottom = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'body1' : _c, _d = _a.variantMapping, variantMapping = _d === void 0 ? defaultVariantMapping : _d, children = _a.children, rest = __rest(_a, ["component", "gutterBottom", "variant", "variantMapping", "children"]);
    var theme = (0, theme_1.useTheme)();
    var Component = component || variantMapping[variant] || 'span';
    var style = [Typography_style_1.styles[variant](theme)];
    if (!gutterBottom)
        style.push(Typography_style_1.noGutter);
    return (0, react_2.jsx)(Component, __assign({ css: style, ref: ref }, rest), children);
});
exports["default"] = Typography;
//# sourceMappingURL=Typography.js.map

/***/ }),

/***/ 40250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = exports.noGutter = void 0;
var react_1 = __webpack_require__(43234);
var base = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0.67em;\n"], ["\n  margin-top: 0;\n  margin-bottom: 0.67em;\n"])));
var headingBase = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
exports.noGutter = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var generateStyle = function (options) {
    var styles = '';
    if (options.fontSize)
        styles += "font-size: ".concat(options.fontSize, ";");
    if (options.lineHeight)
        styles += "line-height: ".concat(options.lineHeight, ";");
    if (options.responsive) {
        Object.keys(options.responsive).forEach(function (mediaQuery) {
            var _a;
            var responsiveObj = (_a = options === null || options === void 0 ? void 0 : options.responsive) === null || _a === void 0 ? void 0 : _a[mediaQuery];
            styles += "".concat(mediaQuery, " {");
            if (responsiveObj) {
                Object.keys(responsiveObj).forEach(function (innerKey) {
                    if (innerKey === 'fontSize')
                        styles += "font-size: ".concat(responsiveObj.fontSize, ";");
                    if (innerKey === 'lineHeight')
                        styles += "line-height: ".concat(responsiveObj.lineHeight, ";");
                });
            }
            styles += '}';
        });
    }
    return (0, react_1.css)(styles);
};
exports.styles = {
    display1: function (theme) { return (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.display1), theme.palette.text.heading); },
    display2: function (theme) { return (0, react_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.display2), theme.palette.text.heading); },
    h1: function (theme) { return (0, react_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h1), theme.palette.text.heading); },
    h2: function (theme) { return (0, react_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h2), theme.palette.text.heading); },
    h3: function (theme) { return (0, react_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h3), theme.palette.text.heading); },
    h4: function (theme) { return (0, react_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h4), theme.palette.text.heading); },
    h5: function (theme) { return (0, react_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h5), theme.palette.text.heading); },
    h6: function (theme) { return (0, react_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    ", "\n    color: ", ";\n  "])), base, headingBase, generateStyle(theme.typography.h6), theme.palette.text.heading); },
    subtitle1: function (theme) { return (0, react_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n    ", "\n    font-weight: 600;\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    font-weight: 600;\n    color: ", ";\n  "])), base, generateStyle(theme.typography.subtitle1), theme.palette.text.heading); },
    subtitle2: function (theme) { return (0, react_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n    ", "\n    font-weight: 600;\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    font-weight: 600;\n    color: ", ";\n  "])), base, generateStyle(theme.typography.subtitle2), theme.palette.text.heading); },
    body1: function (theme) { return (0, react_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    color: ", ";\n  "])), base, generateStyle(theme.typography.body1), theme.palette.text.body); },
    body2: function (theme) { return (0, react_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    color: ", ";\n  "])), base, generateStyle(theme.typography.body2), theme.palette.text.body); },
    caption: function (theme) { return (0, react_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", "\n    ", "\n    color: ", ";\n  "], ["\n    ", "\n    ", "\n    color: ", ";\n  "])), base, generateStyle(theme.typography.caption), theme.palette.text.body); },
    link: function (theme) { return (0, react_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n  "])), base, generateStyle(theme.typography.link)); },
    inherit: function (_) { return (0, react_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", "\n    font-size: inherit;\n    line-height: inherit;\n  "], ["\n    ", "\n    font-size: inherit;\n    line-height: inherit;\n  "])), base); },
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
//# sourceMappingURL=Typography.style.js.map

/***/ }),

/***/ 55489:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var Typography_1 = __webpack_require__(46520);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(Typography_1).default; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 36253:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function capitalize(string) {
    if (typeof string !== 'string') {
        throw new Error('`capitalize(string)` expects a string argument.');
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports["default"] = capitalize;
//# sourceMappingURL=capitalize.js.map

/***/ }),

/***/ 99232:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return funcs.reduce(function (acc, func) {
        if (func == null) {
            return acc;
        }
        return function chainedFunction() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function () { });
}
exports["default"] = createChainedFunction;
//# sourceMappingURL=createChainedFunction.js.map

/***/ }),

/***/ 83989:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// Corresponds to 10 frames at 60 Hz.
function debounce(func, wait) {
    if (wait === void 0) { wait = 166; }
    var timeout;
    function debounced() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var later = function () {
            func.apply(_this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function () {
        clearTimeout(timeout);
    };
    // @ts-ignore
    return debounced;
}
exports["default"] = debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ 4176:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    var documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}
exports["default"] = getScrollbarSize;
//# sourceMappingURL=getScrollbarSize.js.map

/***/ }),

/***/ 1078:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
exports["default"] = hasValue;
//# sourceMappingURL=hasValue.js.map

/***/ }),

/***/ 48247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTransitionProps = exports.reflow = exports.useIsFocusVisible = exports.isHostComponent = exports.useEventCallback = exports.createChainedFunction = exports.debounce = exports.useEnhancedEffect = exports.getScrollbarSize = exports.isPrezzeeElement = exports.useControlled = exports.ownerWindow = exports.ownerDocument = exports.capitalize = exports.setRef = exports.useForkRef = exports.hasValue = exports.isFilled = void 0;
var isFilled_1 = __webpack_require__(26996);
Object.defineProperty(exports, "isFilled", ({ enumerable: true, get: function () { return __importDefault(isFilled_1).default; } }));
var hasValue_1 = __webpack_require__(1078);
Object.defineProperty(exports, "hasValue", ({ enumerable: true, get: function () { return __importDefault(hasValue_1).default; } }));
var useForkRef_1 = __webpack_require__(23930);
Object.defineProperty(exports, "useForkRef", ({ enumerable: true, get: function () { return __importDefault(useForkRef_1).default; } }));
var setRef_1 = __webpack_require__(34474);
Object.defineProperty(exports, "setRef", ({ enumerable: true, get: function () { return __importDefault(setRef_1).default; } }));
var capitalize_1 = __webpack_require__(36253);
Object.defineProperty(exports, "capitalize", ({ enumerable: true, get: function () { return __importDefault(capitalize_1).default; } }));
var ownerDocument_1 = __webpack_require__(88134);
Object.defineProperty(exports, "ownerDocument", ({ enumerable: true, get: function () { return __importDefault(ownerDocument_1).default; } }));
var ownerWindow_1 = __webpack_require__(71353);
Object.defineProperty(exports, "ownerWindow", ({ enumerable: true, get: function () { return __importDefault(ownerWindow_1).default; } }));
var useControlled_1 = __webpack_require__(3517);
Object.defineProperty(exports, "useControlled", ({ enumerable: true, get: function () { return __importDefault(useControlled_1).default; } }));
var isPrezzeeElement_1 = __webpack_require__(84282);
Object.defineProperty(exports, "isPrezzeeElement", ({ enumerable: true, get: function () { return __importDefault(isPrezzeeElement_1).default; } }));
var getScrollbarSize_1 = __webpack_require__(4176);
Object.defineProperty(exports, "getScrollbarSize", ({ enumerable: true, get: function () { return __importDefault(getScrollbarSize_1).default; } }));
var useEnhancedEffect_1 = __webpack_require__(29043);
Object.defineProperty(exports, "useEnhancedEffect", ({ enumerable: true, get: function () { return __importDefault(useEnhancedEffect_1).default; } }));
var debounce_1 = __webpack_require__(83989);
Object.defineProperty(exports, "debounce", ({ enumerable: true, get: function () { return __importDefault(debounce_1).default; } }));
var createChainedFunction_1 = __webpack_require__(99232);
Object.defineProperty(exports, "createChainedFunction", ({ enumerable: true, get: function () { return __importDefault(createChainedFunction_1).default; } }));
var useEventCallback_1 = __webpack_require__(9641);
Object.defineProperty(exports, "useEventCallback", ({ enumerable: true, get: function () { return __importDefault(useEventCallback_1).default; } }));
var isHostComponent_1 = __webpack_require__(22389);
Object.defineProperty(exports, "isHostComponent", ({ enumerable: true, get: function () { return __importDefault(isHostComponent_1).default; } }));
var useIsFocusVisible_1 = __webpack_require__(61214);
Object.defineProperty(exports, "useIsFocusVisible", ({ enumerable: true, get: function () { return __importDefault(useIsFocusVisible_1).default; } }));
var transitions_1 = __webpack_require__(86224);
Object.defineProperty(exports, "reflow", ({ enumerable: true, get: function () { return transitions_1.reflow; } }));
Object.defineProperty(exports, "getTransitionProps", ({ enumerable: true, get: function () { return transitions_1.getTransitionProps; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 26996:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var hasValue_1 = __importDefault(__webpack_require__(1078));
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR) {
    if (SSR === void 0) { SSR = false; }
    return (obj &&
        (((0, hasValue_1.default)(obj.value) && obj.value !== '') ||
            (SSR && (0, hasValue_1.default)(obj.defaultValue) && obj.defaultValue !== '')));
}
exports["default"] = isFilled;
//# sourceMappingURL=isFilled.js.map

/***/ }),

/***/ 22389:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
    return typeof element === 'string';
}
exports["default"] = isHostComponent;
//# sourceMappingURL=isHostComponent.js.map

/***/ }),

/***/ 84282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
function isPrezzeeElement(element, names) {
    var _a;
    return (0, react_1.isValidElement)(element) && names.indexOf((_a = element.type) === null || _a === void 0 ? void 0 : _a.displayName) !== -1;
}
exports["default"] = isPrezzeeElement;
//# sourceMappingURL=isPrezzeeElement.js.map

/***/ }),

/***/ 88134:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function ownerDocument(node) {
    return (node && node.ownerDocument) || document;
}
exports["default"] = ownerDocument;
//# sourceMappingURL=ownerDocument.js.map

/***/ }),

/***/ 71353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var ownerDocument_1 = __importDefault(__webpack_require__(88134));
function ownerWindow(node) {
    var doc = (0, ownerDocument_1.default)(node);
    return doc.defaultView || window;
}
exports["default"] = ownerWindow;
//# sourceMappingURL=ownerWindow.js.map

/***/ }),

/***/ 34474:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 *
 * Passes {value} to {ref}
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
}
exports["default"] = setRef;
//# sourceMappingURL=setRef.js.map

/***/ }),

/***/ 86224:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTransitionProps = exports.reflow = void 0;
var reflow = function (node) { return node.scrollTop; };
exports.reflow = reflow;
function getTransitionProps(props, options) {
    var _a, _b;
    var timeout = props.timeout, easing = props.easing, _c = props.style, style = _c === void 0 ? {} : _c;
    return {
        duration: (_a = style.transitionDuration) !== null && _a !== void 0 ? _a : (typeof timeout === 'number'
            ? timeout
            : typeof timeout === 'object'
                ? timeout[options.mode]
                : 0),
        easing: (_b = style.transitionTimingFunction) !== null && _b !== void 0 ? _b : (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay,
    };
}
exports.getTransitionProps = getTransitionProps;
//# sourceMappingURL=transitions.js.map

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
var React = __importStar(__webpack_require__(67294));
function useControlled(_a) {
    var controlled = _a.controlled, defaultProp = _a.default, name = _a.name, _b = _a.state, state = _b === void 0 ? 'value' : _b;
    // isControlled is ignored in the hook dependency lists as it should never change.
    var isControlled = React.useRef(controlled !== undefined).current;
    var _c = __read(React.useState(defaultProp), 2), valueState = _c[0], setValue = _c[1];
    var value = isControlled ? controlled : valueState;
    if (false) { var defaultValue_1; }
    var setValueIfUncontrolled = React.useCallback(function (newValue) {
        if (!isControlled) {
            setValue(newValue);
        }
    }, []);
    // @ts-ignore
    return [value, setValueIfUncontrolled];
}
exports["default"] = useControlled;
//# sourceMappingURL=useControlled.js.map

/***/ }),

/***/ 29043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(67294);
var useEnhancedEffect = typeof window !== 'undefined' ? react_1.useLayoutEffect : react_1.useEffect;
exports["default"] = useEnhancedEffect;
//# sourceMappingURL=useEnhancedEffect.js.map

/***/ }),

/***/ 9641:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(67294));
var useEnhancedEffect_1 = __importDefault(__webpack_require__(29043));
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */
function useEventCallback(fn) {
    var ref = React.useRef(fn);
    (0, useEnhancedEffect_1.default)(function () {
        ref.current = fn;
    });
    return React.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // @ts-expect-error hide `this`
        // tslint:disable-next-line:ban-comma-operator
        return (0, ref.current).apply(void 0, __spreadArray([], __read(args), false));
    }, []);
}
exports["default"] = useEventCallback;
//# sourceMappingURL=useEventCallback.js.map

/***/ }),

/***/ 23930:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var React = __importStar(__webpack_require__(67294));
var setRef_1 = __importDefault(__webpack_require__(34474));
function useForkRef(refA, refB) {
    /**
     * This will create a new function if the ref props change and are defined.
     * This means react will call the old forkRef with `null` and the new forkRef
     * with the ref. Cleanup naturally emerges from this behavior.
     */
    return React.useMemo(function () {
        if (refA == null && refB == null) {
            return null;
        }
        return function (refValue) {
            (0, setRef_1.default)(refA, refValue);
            (0, setRef_1.default)(refB, refValue);
        };
    }, [refA, refB]);
}
exports["default"] = useForkRef;
//# sourceMappingURL=useForkRef.js.map

/***/ }),

/***/ 61214:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.teardown = void 0;
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var React = __importStar(__webpack_require__(67294));
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout;
var inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true,
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
    var _a = node, type = _a.type, tagName = _a.tagName;
    if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
        return true;
    }
    if (tagName === 'TEXTAREA' && !node.readOnly) {
        return true;
    }
    if (node.isContentEditable) {
        return true;
    }
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) {
        return;
    }
    hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
    hadKeyboardEvent = false;
}
function handleVisibilityChange() {
    if (this.visibilityState === 'hidden') {
        // If the tab becomes active again, the browser will handle calling focus
        // on the element (Safari actually calls it twice).
        // If this tab change caused a blur on an element with focus-visible,
        // re-apply the class when the user switches back to the tab.
        if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
        }
    }
}
function prepare(doc) {
    doc.addEventListener('keydown', handleKeyDown, true);
    doc.addEventListener('mousedown', handlePointerDown, true);
    doc.addEventListener('pointerdown', handlePointerDown, true);
    doc.addEventListener('touchstart', handlePointerDown, true);
    doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
    doc.removeEventListener('keydown', handleKeyDown, true);
    doc.removeEventListener('mousedown', handlePointerDown, true);
    doc.removeEventListener('pointerdown', handlePointerDown, true);
    doc.removeEventListener('touchstart', handlePointerDown, true);
    doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
exports.teardown = teardown;
function isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    }
    catch (error) {
        // Browsers not implementing :focus-visible will throw a SyntaxError.
        // We use our own heuristic for those browsers.
        // Rethrow might be better if it's not the expected error but do we really
        // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
    var ref = React.useCallback(function (node) {
        if (node != null) {
            prepare(node.ownerDocument);
        }
    }, []);
    var isFocusVisibleRef = React.useRef(false);
    /**
     * Should be called if a blur event is fired
     */
    function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            window.clearTimeout(hadFocusVisibleRecentlyTimeout);
            hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
                hadFocusVisibleRecently = false;
            }, 100);
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
     * Should be called if a blur event is fired
     */
    function handleFocusVisible(event) {
        if (isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: ref };
}
exports["default"] = useIsFocusVisible;
//# sourceMappingURL=useIsFocusVisible.js.map

/***/ }),

/***/ 28235:
/***/ (function(module) {

module.exports=function(settings) {
var __t, __p = '';
__p += '(function(){\n\n  // Create a queue, but don\'t obliterate an existing one!\n  var analytics = window.analytics = window.analytics || [];\n\n  // If the real analytics.js is already on the page return.\n  if (analytics.initialize) return;\n\n  // If the snippet was invoked already show an error.\n  if (analytics.invoked) {\n    if (window.console && console.error) {\n      console.error(\'Segment snippet included twice.\');\n    }\n    return;\n  }\n\n  // Invoked flag, to make sure the snippet\n  // is never invoked twice.\n  analytics.invoked = true;\n\n  // A list of the methods in Analytics.js to stub.\n  analytics.methods = [\n    \'trackSubmit\',\n    \'trackClick\',\n    \'trackLink\',\n    \'trackForm\',\n    \'pageview\',\n    \'identify\',\n    \'reset\',\n    \'group\',\n    \'track\',\n    \'ready\',\n    \'alias\',\n    \'debug\',\n    \'page\',\n    \'once\',\n    \'off\',\n    \'on\',\n    \'addSourceMiddleware\',\n    \'addIntegrationMiddleware\',\n    \'setAnonymousId\',\n    \'addDestinationMiddleware\'\n  ];\n\n  // Define a factory to create stubs. These are placeholders\n  // for methods in Analytics.js so that you never have to wait\n  // for it to load to actually record data. The `method` is\n  // stored as the first argument, so we can replay the data.\n  analytics.factory = function(method){\n    return function(){\n      var args = Array.prototype.slice.call(arguments);\n      args.unshift(method);\n      analytics.push(args);\n      return analytics;\n    };\n  };\n\n  // For each of our methods, generate a queueing stub.\n  for (var i = 0; i < analytics.methods.length; i++) {\n    var key = analytics.methods[i];\n    analytics[key] = analytics.factory(key);\n  }\n\n  // Define a method to load Analytics.js from our CDN,\n  // and that will be sure to only ever load it once.\n  analytics.load = function(key, options){\n    // Create an async script element based on your key.\n    var script = document.createElement(\'script\');\n    script.type = \'text/javascript\';\n    script.async = true;\n    script.src = "https://' +
((__t = ( settings.host )) == null ? '' : __t) +
'' +
((__t = ( settings.ajsPath )) == null ? '' : __t) +
'";\n\n    // Insert our script next to the first script element.\n    var first = document.getElementsByTagName(\'script\')[0];\n    first.parentNode.insertBefore(script, first);\n    analytics._loadOptions = options;\n  };\n  analytics._writeKey = \'' +
((__t = ( settings.apiKey )) == null ? '' : __t) +
'\';\n\n  ' +
((__t = ( settings.optionalCDN )) == null ? '' : __t) +
'\n\n  // Add a version to keep track of what\'s in the wild.\n  analytics.SNIPPET_VERSION = \'4.15.3\';\n\n  // Load Analytics.js with your key, which will automatically\n  // load the tools you\'ve enabled for your account. Boosh!\n  ' +
((__t = ( settings.load )) == null ? '' : __t) +
'\n\n  // Make the first page call to load the integrations. If\n  // you\'d like to manually name or tag the page, edit or\n  // move this call however you\'d like.\n  ' +
((__t = ( settings.page )) == null ? '' : __t) +
'\n})();\n';
return __p
}

/***/ }),

/***/ 35334:
/***/ (function(module) {

module.exports=function(settings) {
var __t, __p = '';
__p += '!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://' +
((__t = ( settings.host )) == null ? '' : __t) +
'' +
((__t = ( settings.ajsPath )) == null ? '' : __t) +
'";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="' +
((__t = ( settings.apiKey )) == null ? '' : __t) +
'";' +
((__t = ( settings.optionalCDN )) == null ? '' : __t) +
';analytics.SNIPPET_VERSION="4.15.3";\n' +
((__t = ( settings.load )) == null ? '' : __t) +
'\n' +
((__t = ( settings.page )) == null ? '' : __t) +
'\n}}();';
return __p
}

/***/ }),

/***/ 72913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


/**
 * Module Dependencies.
 */

var map = __webpack_require__(48580);
var maxTemplate = __webpack_require__(28235);
var minTemplate = __webpack_require__(35334);

/**
 * Has convenience alias
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Return the maxified templating function.
 *
 * @param {Object} options (optional)
 * @return {String} rendered
 */

__webpack_unused_export__ = function(options) {
  var settings = defaults(options);
  settings.load = renderLoad(settings);
  settings.page = renderPage(settings.page);
  settings.optionalCDN = renderOptionalCDNHost(settings);

  return maxTemplate(settings);
};

/**
 * Return the minified templating function.
 *
 * @param {Object} options
 * @return {String} min
 */

exports.V = function(options) {
  var settings = defaults(options);
  settings.load = renderLoad(settings);
  settings.page = renderPage(settings.page);
  settings.optionalCDN = renderOptionalCDNHost(settings);

  return minTemplate(settings);
};

/**
 * Back an options object with the snippet defaults.
 *
 * @param {Object} options (optional)
 * @return {Object}
 */

function defaults(options) {
  options || (options = {});
  options.apiKey || (options.apiKey = 'YOUR_API_KEY');
  options.host || (options.host = 'cdn.segment.com');
  options.ajsPath || (options.ajsPath = '/analytics.js/v1/\" + key + \"/analytics.min.js');
  options.useHostForBundles || (options.useHostForBundles = false);

  if (!has.call(options, 'page')) options.page = true;
  if (!has.call(options, 'load')) options.load = true;
  return options;
}

/**
 * Handlebars helper which will render the window.analytics.page call.
 *
 * By default just render the empty call, adding whatever arguments are
 * passed in explicitly.
 *
 * @param {Object|Boolean} page options (name, category, properties)
 * @return {String}
 */

function renderPage(page) {
  if (!page) return '';

  var args = [];

  if (page.category) args.push(page.category);
  if (page.name) args.push(page.name);
  if (page.properties) args.push(page.properties);

  // eslint-disable-next-line no-restricted-globals
  var res = 'analytics.page(' + map(JSON.stringify, args).join(', ') + ');';

  return res;
}

function renderLoad(settings) {
  if (!settings.load) return '';

  if (typeof settings.load !== 'boolean') {
    // eslint-disable-next-line no-restricted-globals
    var loadOptions = JSON.stringify(settings.load);
    return 'analytics.load("' + settings.apiKey + '", ' + loadOptions + ');';
  }

  return 'analytics.load("' + settings.apiKey + '");';
}

function renderOptionalCDNHost(settings) {
  if (!settings) return '';

  if (typeof settings.useHostForBundles === 'boolean' && settings.useHostForBundles) {
    return 'analytics._cdn = "https://' + settings.host + '"';
  }

  return '';
}


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 82152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = definedKeys(a);
            var bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            var aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
var nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    var fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (equal)));

//# sourceMappingURL=equality.esm.js.map


/***/ }),

/***/ 23541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hideOthers": function() { return /* binding */ hideOthers; },
/* harmony export */   "inertOthers": function() { return /* binding */ inertOthers; },
/* harmony export */   "supportsInert": function() { return /* binding */ supportsInert; },
/* harmony export */   "suppressOthers": function() { return /* binding */ suppressOthers; }
/* harmony export */ });
var getDefaultParent = function (originalTarget) {
    if (typeof document === 'undefined') {
        return null;
    }
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
    return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
    return targets
        .map(function (target) {
        if (parent.contains(target)) {
            return target;
        }
        var correctedTarget = unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) {
            return correctedTarget;
        }
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    })
        .filter(function (x) { return Boolean(x); });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
    var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    if (!markerMap[markerName]) {
        markerMap[markerName] = new WeakMap();
    }
    var markerCounter = markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function (el) {
        if (!el || elementsToKeep.has(el)) {
            return;
        }
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function (parent) {
        if (!parent || elementsToStop.has(parent)) {
            return;
        }
        Array.prototype.forEach.call(parent.children, function (node) {
            if (elementsToKeep.has(node)) {
                deep(node);
            }
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = (counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) {
                    uncontrolledNodes.set(node, true);
                }
                if (markerValue === 1) {
                    node.setAttribute(markerName, 'true');
                }
                if (!alreadyHidden) {
                    node.setAttribute(controlAttribute, 'true');
                }
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    lockCount++;
    return function () {
        hiddenNodes.forEach(function (node) {
            var counterValue = counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!uncontrolledNodes.has(node)) {
                    node.removeAttribute(controlAttribute);
                }
                uncontrolledNodes.delete(node);
            }
            if (!markerValue) {
                node.removeAttribute(markerName);
            }
        });
        lockCount--;
        if (!lockCount) {
            // clear
            counterMap = new WeakMap();
            counterMap = new WeakMap();
            uncontrolledNodes = new WeakMap();
            markerMap = {};
        }
    };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-aria-hidden'; }
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
    return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-inert-ed'; }
    var activeParentNode = parentNode || getDefaultParent(originalTarget);
    if (!activeParentNode) {
        return function () { return null; };
    }
    return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
    if (markerName === void 0) { markerName = 'data-suppressed'; }
    return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};


/***/ }),

/***/ 11073:
/***/ (function(module) {

module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 86010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
}


/***/ }),

/***/ 8874:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 34595:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * A simple guard function:
 *
 * ```js
 * Math.min(Math.max(low, value), high)
 * ```
 */
function guard(low, high, value) {
  return Math.min(Math.max(low, value), high);
}

class ColorError extends Error {
  constructor(color) {
    super(`Failed to parse color: "${color}"`);
  }
}
var ColorError$1 = ColorError;

/**
 * Parses a color into red, gree, blue, alpha parts
 *
 * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
 */
function parseToRgba(color) {
  if (typeof color !== 'string') throw new ColorError$1(color);
  if (color.trim().toLowerCase() === 'transparent') return [0, 0, 0, 0];
  let normalizedColor = color.trim();
  normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
  const reducedHexMatch = reducedHexRegex.exec(normalizedColor);
  if (reducedHexMatch) {
    const arr = Array.from(reducedHexMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(r(x, 2), 16)), parseInt(r(arr[3] || 'f', 2), 16) / 255];
  }
  const hexMatch = hexRegex.exec(normalizedColor);
  if (hexMatch) {
    const arr = Array.from(hexMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(x, 16)), parseInt(arr[3] || 'ff', 16) / 255];
  }
  const rgbaMatch = rgbaRegex.exec(normalizedColor);
  if (rgbaMatch) {
    const arr = Array.from(rgbaMatch).slice(1);
    return [...arr.slice(0, 3).map(x => parseInt(x, 10)), parseFloat(arr[3] || '1')];
  }
  const hslaMatch = hslaRegex.exec(normalizedColor);
  if (hslaMatch) {
    const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
    if (guard(0, 100, s) !== s) throw new ColorError$1(color);
    if (guard(0, 100, l) !== l) throw new ColorError$1(color);
    return [...hslToRgb(h, s, l), Number.isNaN(a) ? 1 : a];
  }
  throw new ColorError$1(color);
}
function hash(str) {
  let hash = 5381;
  let i = str.length;
  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return (hash >>> 0) % 2341;
}
const colorToInt = x => parseInt(x.replace(/_/g, ''), 36);
const compressedColorMap = '1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm'.split(' ').reduce((acc, next) => {
  const key = colorToInt(next.substring(0, 3));
  const hex = colorToInt(next.substring(3)).toString(16);

  // NOTE: padStart could be used here but it breaks Node 6 compat
  // https://github.com/ricokahler/color2k/issues/351
  let prefix = '';
  for (let i = 0; i < 6 - hex.length; i++) {
    prefix += '0';
  }
  acc[key] = `${prefix}${hex}`;
  return acc;
}, {});

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 */
function nameToHex(color) {
  const normalizedColorName = color.toLowerCase().trim();
  const result = compressedColorMap[hash(normalizedColorName)];
  if (!result) throw new ColorError$1(color);
  return `#${result}`;
}
const r = (str, amount) => Array.from(Array(amount)).map(() => str).join('');
const reducedHexRegex = new RegExp(`^#${r('([a-f0-9])', 3)}([a-f0-9])?$`, 'i');
const hexRegex = new RegExp(`^#${r('([a-f0-9]{2})', 3)}([a-f0-9]{2})?$`, 'i');
const rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r(',\\s*(\\d+)\\s*', 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, 'i');
const hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
const namedColorRegex = /^[a-z]+$/i;
const roundColor = color => {
  return Math.round(color * 255);
};
const hslToRgb = (hue, saturation, lightness) => {
  let l = lightness / 100;
  if (saturation === 0) {
    // achromatic
    return [l, l, l].map(roundColor);
  }

  // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
  const huePrime = (hue % 360 + 360) % 360 / 60;
  const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
  const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  let red = 0;
  let green = 0;
  let blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  const lightnessModification = l - chroma / 2;
  const finalRed = red + lightnessModification;
  const finalGreen = green + lightnessModification;
  const finalBlue = blue + lightnessModification;
  return [finalRed, finalGreen, finalBlue].map(roundColor);
};

// taken from:

/**
 * Parses a color in hue, saturation, lightness, and the alpha channel.
 *
 * Hue is a number between 0 and 360, saturation, lightness, and alpha are
 * decimal percentages between 0 and 1
 */
function parseToHsla(color) {
  const [red, green, blue, alpha] = parseToRgba(color).map((value, index) =>
  // 3rd index is alpha channel which is already normalized
  index === 3 ? value : value / 255);
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const lightness = (max + min) / 2;

  // achromatic
  if (max === min) return [0, 0, lightness, alpha];
  const delta = max - min;
  const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
  return [hue, saturation, lightness, alpha];
}

/**
 * Takes in hsla parts and constructs an hsla string
 *
 * @param hue The color circle (from 0 to 360) - 0 (or 360) is red, 120 is green, 240 is blue
 * @param saturation Percentage of saturation, given as a decimal between 0 and 1
 * @param lightness Percentage of lightness, given as a decimal between 0 and 1
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */
function hsla(hue, saturation, lightness, alpha) {
  return `hsla(${(hue % 360).toFixed()}, ${guard(0, 100, saturation * 100).toFixed()}%, ${guard(0, 100, lightness * 100).toFixed()}%, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}

/**
 * Adjusts the current hue of the color by the given degrees. Wraps around when
 * over 360.
 *
 * @param color input color
 * @param degrees degrees to adjust the input color, accepts degree integers
 * (0 - 360) and wraps around on overflow
 */
function adjustHue(color, degrees) {
  const [h, s, l, a] = parseToHsla(color);
  return hsla(h + degrees, s, l, a);
}

/**
 * Darkens using lightness. This is equivalent to subtracting the lightness
 * from the L in HSL.
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */
function darken(color, amount) {
  const [hue, saturation, lightness, alpha] = parseToHsla(color);
  return hsla(hue, saturation, lightness - amount, alpha);
}

/**
 * Desaturates the input color by the given amount via subtracting from the `s`
 * in `hsla`.
 *
 * @param amount The amount to desaturate, given as a decimal between 0 and 1
 */
function desaturate(color, amount) {
  const [h, s, l, a] = parseToHsla(color);
  return hsla(h, s - amount, l, a);
}

// taken from:
// https://github.com/styled-components/polished/blob/0764c982551b487469043acb56281b0358b3107b/src/color/getLuminance.js

/**
 * Returns a number (float) representing the luminance of a color.
 */
function getLuminance(color) {
  if (color === 'transparent') return 0;
  function f(x) {
    const channel = x / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }
  const [r, g, b] = parseToRgba(color);
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}

// taken from:

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 */
function getContrast(color1, color2) {
  const luminance1 = getLuminance(color1);
  const luminance2 = getLuminance(color2);
  return luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05);
}

/**
 * Takes in rgba parts and returns an rgba string
 *
 * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
 * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
 * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
 * @param alpha Percentage of opacity, given as a decimal between 0 and 1
 */
function rgba(red, green, blue, alpha) {
  return `rgba(${guard(0, 255, red).toFixed()}, ${guard(0, 255, green).toFixed()}, ${guard(0, 255, blue).toFixed()}, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}

/**
 * Mixes two colors together. Taken from sass's implementation.
 */
function mix(color1, color2, weight) {
  const normalize = (n, index) =>
  // 3rd index is alpha channel which is already normalized
  index === 3 ? n : n / 255;
  const [r1, g1, b1, a1] = parseToRgba(color1).map(normalize);
  const [r2, g2, b2, a2] = parseToRgba(color2).map(normalize);

  // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  const alphaDelta = a2 - a1;
  const normalizedWeight = weight * 2 - 1;
  const combinedWeight = normalizedWeight * alphaDelta === -1 ? normalizedWeight : normalizedWeight + alphaDelta / (1 + normalizedWeight * alphaDelta);
  const weight2 = (combinedWeight + 1) / 2;
  const weight1 = 1 - weight2;
  const r = (r1 * weight1 + r2 * weight2) * 255;
  const g = (g1 * weight1 + g2 * weight2) * 255;
  const b = (b1 * weight1 + b2 * weight2) * 255;
  const a = a2 * weight + a1 * (1 - weight);
  return rgba(r, g, b, a);
}

/**
 * Given a series colors, this function will return a `scale(x)` function that
 * accepts a percentage as a decimal between 0 and 1 and returns the color at
 * that percentage in the scale.
 *
 * ```js
 * const scale = getScale('red', 'yellow', 'green');
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(0.5)); // rgba(255, 255, 0, 1)
 * console.log(scale(1)); // rgba(0, 128, 0, 1)
 * ```
 *
 * If you'd like to limit the domain and range like chroma-js, we recommend
 * wrapping scale again.
 *
 * ```js
 * const _scale = getScale('red', 'yellow', 'green');
 * const scale = x => _scale(x / 100);
 *
 * console.log(scale(0)); // rgba(255, 0, 0, 1)
 * console.log(scale(50)); // rgba(255, 255, 0, 1)
 * console.log(scale(100)); // rgba(0, 128, 0, 1)
 * ```
 */
function getScale(...colors) {
  return n => {
    const lastIndex = colors.length - 1;
    const lowIndex = guard(0, lastIndex, Math.floor(n * lastIndex));
    const highIndex = guard(0, lastIndex, Math.ceil(n * lastIndex));
    const color1 = colors[lowIndex];
    const color2 = colors[highIndex];
    const unit = 1 / lastIndex;
    const weight = (n - unit * lowIndex) / unit;
    return mix(color1, color2, weight);
  };
}

const guidelines = {
  decorative: 1.5,
  readable: 3,
  aa: 4.5,
  aaa: 7
};

/**
 * Returns whether or not a color has bad contrast against a background
 * according to a given standard.
 */
function hasBadContrast(color, standard = 'aa', background = '#fff') {
  return getContrast(color, background) < guidelines[standard];
}

/**
 * Lightens a color by a given amount. This is equivalent to
 * `darken(color, -amount)`
 *
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */
function lighten(color, amount) {
  return darken(color, -amount);
}

/**
 * Takes in a color and makes it more transparent by convert to `rgba` and
 * decreasing the amount in the alpha channel.
 *
 * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
 */
function transparentize(color, amount) {
  const [r, g, b, a] = parseToRgba(color);
  return rgba(r, g, b, a - amount);
}

/**
 * Takes a color and un-transparentizes it. Equivalent to
 * `transparentize(color, -amount)`
 *
 * @param amount The amount to increase the opacity by, given as a decimal between 0 and 1
 */
function opacify(color, amount) {
  return transparentize(color, -amount);
}

/**
 * An alternative function to `readableColor`. Returns whether or not the 
 * readable color (i.e. the color to be place on top the input color) should be
 * black.
 */
function readableColorIsBlack(color) {
  return getLuminance(color) > 0.179;
}

/**
 * Returns black or white for best contrast depending on the luminosity of the
 * given color.
 */
function readableColor(color) {
  return readableColorIsBlack(color) ? '#000' : '#fff';
}

/**
 * Saturates a color by converting it to `hsl` and increasing the saturation
 * amount. Equivalent to `desaturate(color, -amount)`
 * 
 * @param color Input color
 * @param amount The amount to darken, given as a decimal between 0 and 1
 */
function saturate(color, amount) {
  return desaturate(color, -amount);
}

/**
 * Takes in any color and returns it as a hex code.
 */
function toHex(color) {
  const [r, g, b, a] = parseToRgba(color);
  let hex = x => {
    const h = guard(0, 255, x).toString(16);
    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    return h.length === 1 ? `0${h}` : h;
  };
  return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ''}`;
}

/**
 * Takes in any color and returns it as an rgba string.
 */
function toRgba(color) {
  return rgba(...parseToRgba(color));
}

/**
 * Takes in any color and returns it as an hsla string.
 */
function toHsla(color) {
  return hsla(...parseToHsla(color));
}

exports.ColorError = ColorError$1;
exports.adjustHue = adjustHue;
exports.darken = darken;
exports.desaturate = desaturate;
exports.getContrast = getContrast;
exports.getLuminance = getLuminance;
exports.getScale = getScale;
exports.guard = guard;
exports.hasBadContrast = hasBadContrast;
exports.hsla = hsla;
exports.lighten = lighten;
exports.mix = mix;
exports.opacify = opacify;
exports.parseToHsla = parseToHsla;
exports.parseToRgba = parseToRgba;
exports.readableColor = readableColor;
exports.readableColorIsBlack = readableColorIsBlack;
exports.rgba = rgba;
exports.saturate = saturate;
exports.toHex = toHex;
exports.toHsla = toHsla;
exports.toRgba = toRgba;
exports.transparentize = transparentize;
//# sourceMappingURL=index.exports.require.cjs.js.map


/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

__webpack_unused_export__ = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 40452:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(98269), __webpack_require__(68214), __webpack_require__(90888), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            var t;

	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),

/***/ 75109:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(90888));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            var block;

	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            var modeCreator;

	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            var finalProcessedBlocks;

	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            var wordArray;

	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            var salt;

	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),

/***/ 78249:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.crypto) {
	        crypto = __webpack_require__.g.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(42480);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ 98269:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ 43786:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64url encoding strategy.
	     */
	    var Base64url = C_enc.Base64url = {
	        /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */
	        stringify: function (wordArray, urlSafe=true) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = urlSafe ? this._safe_map : this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */
	        parse: function (base64Str, urlSafe=true) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = urlSafe ? this._safe_map : this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                reverseMap = this._reverseMap = [];
	                for (var j = 0; j < map.length; j++) {
	                    reverseMap[map.charCodeAt(j)] = j;
	                }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
	        _safe_map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	        var words = [];
	        var nBytes = 0;
	        for (var i = 0; i < base64StrLength; i++) {
	            if (i % 4) {
	                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	                var bitsCombined = bits1 | bits2;
	                words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	                nBytes++;
	            }
	        }
	        return WordArray.create(words, nBytes);
	    }
	}());

	return CryptoJS.enc.Base64url;

}));

/***/ }),

/***/ 50298:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),

/***/ 55743:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS.enc.Utf8;

}));

/***/ }),

/***/ 90888:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(62783), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            var block;

	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),

/***/ 42209:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),

/***/ 89824:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ 81354:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(64938), __webpack_require__(4433), __webpack_require__(50298), __webpack_require__(98269), __webpack_require__(43786), __webpack_require__(68214), __webpack_require__(62783), __webpack_require__(52153), __webpack_require__(87792), __webpack_require__(70034), __webpack_require__(17460), __webpack_require__(13327), __webpack_require__(30706), __webpack_require__(89824), __webpack_require__(2112), __webpack_require__(90888), __webpack_require__(75109), __webpack_require__(8568), __webpack_require__(74242), __webpack_require__(59968), __webpack_require__(27660), __webpack_require__(31148), __webpack_require__(43615), __webpack_require__(92807), __webpack_require__(71077), __webpack_require__(56475), __webpack_require__(16991), __webpack_require__(42209), __webpack_require__(40452), __webpack_require__(94253), __webpack_require__(51857), __webpack_require__(84454), __webpack_require__(93974));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),

/***/ 4433:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),

/***/ 68214:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ 8568:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        var keystream;

	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),

/***/ 59968:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),

/***/ 74242:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),

/***/ 31148:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),

/***/ 27660:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),

/***/ 43615:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),

/***/ 92807:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),

/***/ 71077:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),

/***/ 16991:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),

/***/ 56475:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        for (var i = data.sigBytes - 1; i >= 0; i--) {
	            if (((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	                data.sigBytes = i + 1;
	                break;
	            }
	        }
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),

/***/ 2112:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(62783), __webpack_require__(89824));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),

/***/ 93974:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(98269), __webpack_require__(68214), __webpack_require__(90888), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),

/***/ 84454:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(98269), __webpack_require__(68214), __webpack_require__(90888), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),

/***/ 51857:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(98269), __webpack_require__(68214), __webpack_require__(90888), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),

/***/ 30706:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),

/***/ 62783:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ 87792:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(52153));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),

/***/ 52153:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ 13327:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(64938));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    var tMsw;
	                    var tLsw;

	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),

/***/ 17460:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(64938), __webpack_require__(70034));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),

/***/ 70034:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(64938));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                var Wil;
	                var Wih;

	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    Wih = Wi.high = M[offset + i * 2]     | 0;
	                    Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    Wil = gamma0l + Wi7l;
	                    Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    Wil = Wil + gamma1l;
	                    Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    Wil = Wil + Wi16l;
	                    Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),

/***/ 94253:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249), __webpack_require__(98269), __webpack_require__(68214), __webpack_require__(90888), __webpack_require__(75109));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            // Make sure the key length is valid (64, 128 or >= 192 bit)
	            if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) {
	                throw new Error('Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.');
	            }

	            // Extend the key according to the keying options defined in 3DES standard
	            var key1 = keyWords.slice(0, 2);
	            var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
	            var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(key1));
	            this._des2 = DES.createEncryptor(WordArray.create(key2));
	            this._des3 = DES.createEncryptor(WordArray.create(key3));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),

/***/ 64938:
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(78249));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),

/***/ 49129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "calculateBox": function() { return /* binding */ calculateBox; },
  "createBox": function() { return /* binding */ createBox; },
  "expand": function() { return /* binding */ expand; },
  "getBox": function() { return /* binding */ getBox; },
  "getRect": function() { return /* binding */ getRect; },
  "offset": function() { return /* binding */ offset; },
  "shrink": function() { return /* binding */ shrink; },
  "withScroll": function() { return /* binding */ withScroll; }
});

;// CONCATENATED MODULE: ./node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}



;// CONCATENATED MODULE: ./node_modules/css-box-model/dist/css-box-model.esm.js


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? 0 : invariant(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};




/***/ }),

/***/ 20890:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = fromRgba;
__webpack_unused_export__ = fromRgb;
__webpack_unused_export__ = fromHsla;
__webpack_unused_export__ = fromHsl;
exports.mL = fromString;
__webpack_unused_export__ = void 0;

var _colorName = _interopRequireDefault(__webpack_require__(8874));

var _cssUnitConverter = _interopRequireDefault(__webpack_require__(33258));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var hex = /^#([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})?$/;
var shortHex = /^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])?$/;
var rgb = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*(0|1|0?\.\d+|\d+%))?\s*\)$/;
var rgbfn = /^rgba?\(\s*(\d+)\s+(\d+)\s+(\d+)(?:\s*\/\s*(0|1|0?\.\d+|\d+%))?\s*\)$/;
var rgbperc = /^rgba?\(\s*(\d+%)\s*,\s*(\d+%)\s*,\s*(\d+%)(?:\s*,\s*(0|1|0?\.\d+|\d+%))?\s*\)$/;
var rgbpercfn = /^rgba?\(\s*(\d+%)\s+(\d+%)\s+(\d+%)(?:\s*\/\s*(0|1|0?\.\d+|\d+%))?\s*\)$/;
var hsl = /^hsla?\(\s*(\d+)(deg|rad|grad|turn)?\s*,\s*(\d+)%\s*,\s*(\d+)%(?:\s*,\s*(0|1|0?\.\d+|\d+%))?\s*\)$/;

function contains(haystack, needle) {
  return haystack.indexOf(needle) > -1;
}

function rgbToHsl(r, g, b) {
  var rprim = r / 255;
  var gprim = g / 255;
  var bprim = b / 255;
  var cmax = Math.max(rprim, gprim, bprim);
  var cmin = Math.min(rprim, gprim, bprim);
  var delta = cmax - cmin;
  var l = (cmax + cmin) / 2;

  if (delta === 0) {
    return [0, 0, l * 100];
  }

  var s = delta / (1 - Math.abs(2 * l - 1));

  var h = function () {
    switch (cmax) {
      case rprim:
        {
          return (gprim - bprim) / delta % 6;
        }

      case gprim:
        {
          return (bprim - rprim) / delta + 2;
        }

      default:
        {
          return (rprim - gprim) / delta + 4;
        }
    }
  }();

  return [h * 60, s * 100, l * 100];
}

function hslToRgb(h, s, l) {
  var hprim = h / 60;
  var sprim = s / 100;
  var lprim = l / 100;
  var c = (1 - Math.abs(2 * lprim - 1)) * sprim;
  var x = c * (1 - Math.abs(hprim % 2 - 1));
  var m = lprim - c / 2;

  var _ref = function () {
    if (hprim < 1) return [c, x, 0];
    if (hprim < 2) return [x, c, 0];
    if (hprim < 3) return [0, c, x];
    if (hprim < 4) return [0, x, c];
    if (hprim < 5) return [x, 0, c];
    return [c, 0, x];
  }(),
      _ref2 = _slicedToArray(_ref, 3),
      rprim = _ref2[0],
      gprim = _ref2[1],
      bprim = _ref2[2];

  return [(rprim + m) * 255, (gprim + m) * 255, (bprim + m) * 255];
}

var Color = /*#__PURE__*/function () {
  function Color(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 4),
        r = _ref4[0],
        g = _ref4[1],
        b = _ref4[2],
        a = _ref4[3];

    _classCallCheck(this, Color);

    this.values = [Math.max(Math.min(parseInt(r, 10), 255), 0), Math.max(Math.min(parseInt(g, 10), 255), 0), Math.max(Math.min(parseInt(b, 10), 255), 0), a == null ? 1 : Math.max(Math.min(parseFloat(a), 255), 0)];
  }

  _createClass(Color, [{
    key: "toRgbString",
    value: function toRgbString() {
      var _this$values = _slicedToArray(this.values, 4),
          r = _this$values[0],
          g = _this$values[1],
          b = _this$values[2],
          a = _this$values[3];

      if (a === 1) {
        return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
      }

      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")");
    }
  }, {
    key: "toHslString",
    value: function toHslString() {
      var _this$toHslaArray = this.toHslaArray(),
          _this$toHslaArray2 = _slicedToArray(_this$toHslaArray, 4),
          h = _this$toHslaArray2[0],
          s = _this$toHslaArray2[1],
          l = _this$toHslaArray2[2],
          a = _this$toHslaArray2[3];

      if (a === 1) {
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
      }

      return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      var _this$values2 = _slicedToArray(this.values, 4),
          r = _this$values2[0],
          g = _this$values2[1],
          b = _this$values2[2],
          a = _this$values2[3];

      r = Number(r).toString(16).padStart(2, '0');
      g = Number(g).toString(16).padStart(2, '0');
      b = Number(b).toString(16).padStart(2, '0');
      a = a < 1 ? parseInt(a * 255, 10).toString(16).padStart(2, '0') : '';
      return "#".concat(r).concat(g).concat(b).concat(a);
    }
  }, {
    key: "toRgbaArray",
    value: function toRgbaArray() {
      return this.values;
    }
  }, {
    key: "toHslaArray",
    value: function toHslaArray() {
      var _this$values3 = _slicedToArray(this.values, 4),
          r = _this$values3[0],
          g = _this$values3[1],
          b = _this$values3[2],
          a = _this$values3[3];

      var _rgbToHsl = rgbToHsl(r, g, b),
          _rgbToHsl2 = _slicedToArray(_rgbToHsl, 3),
          h = _rgbToHsl2[0],
          s = _rgbToHsl2[1],
          l = _rgbToHsl2[2];

      return [h, s, l, a];
    }
  }]);

  return Color;
}();

function fromRgba(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 4),
      r = _ref6[0],
      g = _ref6[1],
      b = _ref6[2],
      a = _ref6[3];

  return new Color([r, g, b, a]);
}

function fromRgb(_ref7) {
  var _ref8 = _slicedToArray(_ref7, 3),
      r = _ref8[0],
      g = _ref8[1],
      b = _ref8[2];

  return fromRgba([r, g, b, 1]);
}

function fromHsla(_ref9) {
  var _ref10 = _slicedToArray(_ref9, 4),
      h = _ref10[0],
      s = _ref10[1],
      l = _ref10[2],
      a = _ref10[3];

  var _hslToRgb = hslToRgb(h, s, l),
      _hslToRgb2 = _slicedToArray(_hslToRgb, 3),
      r = _hslToRgb2[0],
      g = _hslToRgb2[1],
      b = _hslToRgb2[2];

  return fromRgba([r, g, b, a]);
}

function fromHsl(_ref11) {
  var _ref12 = _slicedToArray(_ref11, 3),
      h = _ref12[0],
      s = _ref12[1],
      l = _ref12[2];

  return fromHsla([h, s, l, 1]);
}

function fromHexString(str) {
  var _ref13 = hex.exec(str) || shortHex.exec(str),
      _ref14 = _slicedToArray(_ref13, 5),
      r = _ref14[1],
      g = _ref14[2],
      b = _ref14[3],
      a = _ref14[4];

  r = parseInt(r.length < 2 ? r.repeat(2) : r, 16);
  g = parseInt(g.length < 2 ? g.repeat(2) : g, 16);
  b = parseInt(b.length < 2 ? b.repeat(2) : b, 16);
  a = a && (parseInt(a.length < 2 ? a.repeat(2) : a, 16) / 255).toPrecision(1) || 1;
  return fromRgba([r, g, b, a]);
}

function fromRgbString(str) {
  var _ref15 = rgb.exec(str) || rgbperc.exec(str) || rgbfn.exec(str) || rgbpercfn.exec(str),
      _ref16 = _slicedToArray(_ref15, 5),
      r = _ref16[1],
      g = _ref16[2],
      b = _ref16[3],
      a = _ref16[4];

  r = contains(r, '%') ? parseInt(r, 10) * 255 / 100 : parseInt(r, 10);
  g = contains(g, '%') ? parseInt(g, 10) * 255 / 100 : parseInt(g, 10);
  b = contains(b, '%') > 0 ? parseInt(b, 10) * 255 / 100 : parseInt(b, 10);
  a = a === undefined ? 1 : parseFloat(a) / (contains(a, '%') ? 100 : 1);
  return fromRgba([r, g, b, a]);
}

function fromHslString(str) {
  var _hsl$exec = hsl.exec(str),
      _hsl$exec2 = _slicedToArray(_hsl$exec, 6),
      h = _hsl$exec2[1],
      unit = _hsl$exec2[2],
      s = _hsl$exec2[3],
      l = _hsl$exec2[4],
      a = _hsl$exec2[5];

  unit = unit || 'deg';
  h = (0, _cssUnitConverter["default"])(parseFloat(h), unit, 'deg');
  s = parseFloat(s);
  l = parseFloat(l);
  a = a === undefined ? 1 : parseFloat(a) / (contains(a, '%') ? 100 : 1);
  return fromHsla([h, s, l, a]);
}

function fromString(str) {
  if (_colorName["default"][str]) {
    return fromRgb(_colorName["default"][str]);
  }

  if (hex.test(str) || shortHex.test(str)) {
    return fromHexString(str);
  }

  if (rgb.test(str) || rgbperc.test(str) || rgbfn.test(str) || rgbpercfn.test(str)) {
    return fromRgbString(str);
  }

  if (hsl.test(str)) {
    return fromHslString(str);
  }

  return null;
}

var _default = {
  fromString: fromString,
  fromRgb: fromRgb,
  fromRgba: fromRgba,
  fromHsl: fromHsl,
  fromHsla: fromHsla
};
__webpack_unused_export__ = _default;

/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.attributeRules = void 0;
var boolbase_1 = __webpack_require__(11073);
/**
 * All reserved characters in a regex, used for escaping.
 *
 * Taken from XRegExp, (c) 2007-2020 Steven Levithan under the MIT license
 * https://github.com/slevithan/xregexp/blob/95eeebeb8fac8754d54eafe2b4743661ac1cf028/src/xregexp.js#L794
 */
var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
function escapeRegex(value) {
    return value.replace(reChars, "\\$&");
}
/**
 * Attributes that are case-insensitive in HTML.
 *
 * @private
 * @see https://html.spec.whatwg.org/multipage/semantics-other.html#case-sensitivity-of-selectors
 */
var caseInsensitiveAttributes = new Set([
    "accept",
    "accept-charset",
    "align",
    "alink",
    "axis",
    "bgcolor",
    "charset",
    "checked",
    "clear",
    "codetype",
    "color",
    "compact",
    "declare",
    "defer",
    "dir",
    "direction",
    "disabled",
    "enctype",
    "face",
    "frame",
    "hreflang",
    "http-equiv",
    "lang",
    "language",
    "link",
    "media",
    "method",
    "multiple",
    "nohref",
    "noresize",
    "noshade",
    "nowrap",
    "readonly",
    "rel",
    "rev",
    "rules",
    "scope",
    "scrolling",
    "selected",
    "shape",
    "target",
    "text",
    "type",
    "valign",
    "valuetype",
    "vlink",
]);
function shouldIgnoreCase(selector, options) {
    return typeof selector.ignoreCase === "boolean"
        ? selector.ignoreCase
        : selector.ignoreCase === "quirks"
            ? !!options.quirksMode
            : !options.xmlMode && caseInsensitiveAttributes.has(selector.name);
}
/**
 * Attribute selectors
 */
exports.attributeRules = {
    equals: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length === value.length &&
                    attr.toLowerCase() === value &&
                    next(elem));
            };
        }
        return function (elem) {
            return adapter.getAttributeValue(elem, name) === value && next(elem);
        };
    },
    hyphen: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function hyphenIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    (attr.length === len || attr.charAt(len) === "-") &&
                    attr.substr(0, len).toLowerCase() === value &&
                    next(elem));
            };
        }
        return function hyphen(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return (attr != null &&
                (attr.length === len || attr.charAt(len) === "-") &&
                attr.substr(0, len) === value &&
                next(elem));
        };
    },
    element: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (/\s/.test(value)) {
            return boolbase_1.falseFunc;
        }
        var regex = new RegExp("(?:^|\\s)".concat(escapeRegex(value), "(?:$|\\s)"), shouldIgnoreCase(data, options) ? "i" : "");
        return function element(elem) {
            var attr = adapter.getAttributeValue(elem, name);
            return (attr != null &&
                attr.length >= value.length &&
                regex.test(attr) &&
                next(elem));
        };
    },
    exists: function (next, _a, _b) {
        var name = _a.name;
        var adapter = _b.adapter;
        return function (elem) { return adapter.hasAttrib(elem, name) && next(elem); };
    },
    start: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = value.length;
        if (len === 0) {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length >= len &&
                    attr.substr(0, len).toLowerCase() === value &&
                    next(elem));
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.startsWith(value)) &&
                next(elem);
        };
    },
    end: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        var len = -value.length;
        if (len === 0) {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var _a;
                return ((_a = adapter
                    .getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.substr(len).toLowerCase()) === value && next(elem);
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.endsWith(value)) &&
                next(elem);
        };
    },
    any: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name, value = data.value;
        if (value === "") {
            return boolbase_1.falseFunc;
        }
        if (shouldIgnoreCase(data, options)) {
            var regex_1 = new RegExp(escapeRegex(value), "i");
            return function anyIC(elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return (attr != null &&
                    attr.length >= value.length &&
                    regex_1.test(attr) &&
                    next(elem));
            };
        }
        return function (elem) {
            var _a;
            return !!((_a = adapter.getAttributeValue(elem, name)) === null || _a === void 0 ? void 0 : _a.includes(value)) &&
                next(elem);
        };
    },
    not: function (next, data, options) {
        var adapter = options.adapter;
        var name = data.name;
        var value = data.value;
        if (value === "") {
            return function (elem) {
                return !!adapter.getAttributeValue(elem, name) && next(elem);
            };
        }
        else if (shouldIgnoreCase(data, options)) {
            value = value.toLowerCase();
            return function (elem) {
                var attr = adapter.getAttributeValue(elem, name);
                return ((attr == null ||
                    attr.length !== value.length ||
                    attr.toLowerCase() !== value) &&
                    next(elem));
            };
        }
        return function (elem) {
            return adapter.getAttributeValue(elem, name) !== value && next(elem);
        };
    },
};


/***/ }),

/***/ 98866:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compileToken = exports.compileUnsafe = exports.compile = void 0;
var css_what_1 = __webpack_require__(67209);
var boolbase_1 = __webpack_require__(11073);
var sort_1 = __importDefault(__webpack_require__(57353));
var procedure_1 = __webpack_require__(57177);
var general_1 = __webpack_require__(93621);
var subselects_1 = __webpack_require__(61768);
/**
 * Compiles a selector to an executable function.
 *
 * @param selector Selector to compile.
 * @param options Compilation options.
 * @param context Optional context for the selector.
 */
function compile(selector, options, context) {
    var next = compileUnsafe(selector, options, context);
    return (0, subselects_1.ensureIsTag)(next, options.adapter);
}
exports.compile = compile;
function compileUnsafe(selector, options, context) {
    var token = typeof selector === "string" ? (0, css_what_1.parse)(selector) : selector;
    return compileToken(token, options, context);
}
exports.compileUnsafe = compileUnsafe;
function includesScopePseudo(t) {
    return (t.type === "pseudo" &&
        (t.name === "scope" ||
            (Array.isArray(t.data) &&
                t.data.some(function (data) { return data.some(includesScopePseudo); }))));
}
var DESCENDANT_TOKEN = { type: css_what_1.SelectorType.Descendant };
var FLEXIBLE_DESCENDANT_TOKEN = {
    type: "_flexibleDescendant",
};
var SCOPE_TOKEN = {
    type: css_what_1.SelectorType.Pseudo,
    name: "scope",
    data: null,
};
/*
 * CSS 4 Spec (Draft): 3.3.1. Absolutizing a Scope-relative Selector
 * http://www.w3.org/TR/selectors4/#absolutizing
 */
function absolutize(token, _a, context) {
    var adapter = _a.adapter;
    // TODO Use better check if the context is a document
    var hasContext = !!(context === null || context === void 0 ? void 0 : context.every(function (e) {
        var parent = adapter.isTag(e) && adapter.getParent(e);
        return e === subselects_1.PLACEHOLDER_ELEMENT || (parent && adapter.isTag(parent));
    }));
    for (var _i = 0, token_1 = token; _i < token_1.length; _i++) {
        var t = token_1[_i];
        if (t.length > 0 && (0, procedure_1.isTraversal)(t[0]) && t[0].type !== "descendant") {
            // Don't continue in else branch
        }
        else if (hasContext && !t.some(includesScopePseudo)) {
            t.unshift(DESCENDANT_TOKEN);
        }
        else {
            continue;
        }
        t.unshift(SCOPE_TOKEN);
    }
}
function compileToken(token, options, context) {
    var _a;
    token = token.filter(function (t) { return t.length > 0; });
    token.forEach(sort_1.default);
    context = (_a = options.context) !== null && _a !== void 0 ? _a : context;
    var isArrayContext = Array.isArray(context);
    var finalContext = context && (Array.isArray(context) ? context : [context]);
    absolutize(token, options, finalContext);
    var shouldTestNextSiblings = false;
    var query = token
        .map(function (rules) {
        if (rules.length >= 2) {
            var first = rules[0], second = rules[1];
            if (first.type !== "pseudo" || first.name !== "scope") {
                // Ignore
            }
            else if (isArrayContext && second.type === "descendant") {
                rules[1] = FLEXIBLE_DESCENDANT_TOKEN;
            }
            else if (second.type === "adjacent" ||
                second.type === "sibling") {
                shouldTestNextSiblings = true;
            }
        }
        return compileRules(rules, options, finalContext);
    })
        .reduce(reduceRules, boolbase_1.falseFunc);
    query.shouldTestNextSiblings = shouldTestNextSiblings;
    return query;
}
exports.compileToken = compileToken;
function compileRules(rules, options, context) {
    var _a;
    return rules.reduce(function (previous, rule) {
        return previous === boolbase_1.falseFunc
            ? boolbase_1.falseFunc
            : (0, general_1.compileGeneralSelector)(previous, rule, options, context, compileToken);
    }, (_a = options.rootFunc) !== null && _a !== void 0 ? _a : boolbase_1.trueFunc);
}
function reduceRules(a, b) {
    if (b === boolbase_1.falseFunc || a === boolbase_1.trueFunc) {
        return a;
    }
    if (a === boolbase_1.falseFunc || b === boolbase_1.trueFunc) {
        return b;
    }
    return function combine(elem) {
        return a(elem) || b(elem);
    };
}


/***/ }),

/***/ 93621:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compileGeneralSelector = void 0;
var attributes_1 = __webpack_require__(70996);
var pseudo_selectors_1 = __webpack_require__(98677);
var css_what_1 = __webpack_require__(67209);
/*
 * All available rules
 */
function compileGeneralSelector(next, selector, options, context, compileToken) {
    var adapter = options.adapter, equals = options.equals;
    switch (selector.type) {
        case css_what_1.SelectorType.PseudoElement: {
            throw new Error("Pseudo-elements are not supported by css-select");
        }
        case css_what_1.SelectorType.ColumnCombinator: {
            throw new Error("Column combinators are not yet supported by css-select");
        }
        case css_what_1.SelectorType.Attribute: {
            if (selector.namespace != null) {
                throw new Error("Namespaced attributes are not yet supported by css-select");
            }
            if (!options.xmlMode || options.lowerCaseAttributeNames) {
                selector.name = selector.name.toLowerCase();
            }
            return attributes_1.attributeRules[selector.action](next, selector, options);
        }
        case css_what_1.SelectorType.Pseudo: {
            return (0, pseudo_selectors_1.compilePseudoSelector)(next, selector, options, context, compileToken);
        }
        // Tags
        case css_what_1.SelectorType.Tag: {
            if (selector.namespace != null) {
                throw new Error("Namespaced tag names are not yet supported by css-select");
            }
            var name_1 = selector.name;
            if (!options.xmlMode || options.lowerCaseTags) {
                name_1 = name_1.toLowerCase();
            }
            return function tag(elem) {
                return adapter.getName(elem) === name_1 && next(elem);
            };
        }
        // Traversal
        case css_what_1.SelectorType.Descendant: {
            if (options.cacheResults === false ||
                typeof WeakSet === "undefined") {
                return function descendant(elem) {
                    var current = elem;
                    while ((current = adapter.getParent(current))) {
                        if (adapter.isTag(current) && next(current)) {
                            return true;
                        }
                    }
                    return false;
                };
            }
            // @ts-expect-error `ElementNode` is not extending object
            var isFalseCache_1 = new WeakSet();
            return function cachedDescendant(elem) {
                var current = elem;
                while ((current = adapter.getParent(current))) {
                    if (!isFalseCache_1.has(current)) {
                        if (adapter.isTag(current) && next(current)) {
                            return true;
                        }
                        isFalseCache_1.add(current);
                    }
                }
                return false;
            };
        }
        case "_flexibleDescendant": {
            // Include element itself, only used while querying an array
            return function flexibleDescendant(elem) {
                var current = elem;
                do {
                    if (adapter.isTag(current) && next(current))
                        return true;
                } while ((current = adapter.getParent(current)));
                return false;
            };
        }
        case css_what_1.SelectorType.Parent: {
            return function parent(elem) {
                return adapter
                    .getChildren(elem)
                    .some(function (elem) { return adapter.isTag(elem) && next(elem); });
            };
        }
        case css_what_1.SelectorType.Child: {
            return function child(elem) {
                var parent = adapter.getParent(elem);
                return parent != null && adapter.isTag(parent) && next(parent);
            };
        }
        case css_what_1.SelectorType.Sibling: {
            return function sibling(elem) {
                var siblings = adapter.getSiblings(elem);
                for (var i = 0; i < siblings.length; i++) {
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling))
                        break;
                    if (adapter.isTag(currentSibling) && next(currentSibling)) {
                        return true;
                    }
                }
                return false;
            };
        }
        case css_what_1.SelectorType.Adjacent: {
            if (adapter.prevElementSibling) {
                return function adjacent(elem) {
                    var previous = adapter.prevElementSibling(elem);
                    return previous != null && next(previous);
                };
            }
            return function adjacent(elem) {
                var siblings = adapter.getSiblings(elem);
                var lastElement;
                for (var i = 0; i < siblings.length; i++) {
                    var currentSibling = siblings[i];
                    if (equals(elem, currentSibling))
                        break;
                    if (adapter.isTag(currentSibling)) {
                        lastElement = currentSibling;
                    }
                }
                return !!lastElement && next(lastElement);
            };
        }
        case css_what_1.SelectorType.Universal: {
            if (selector.namespace != null && selector.namespace !== "*") {
                throw new Error("Namespaced universal selectors are not yet supported by css-select");
            }
            return next;
        }
    }
}
exports.compileGeneralSelector = compileGeneralSelector;


/***/ }),

/***/ 75366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.aliases = exports.pseudos = exports.filters = exports.is = exports.selectOne = exports.selectAll = exports.prepareContext = exports._compileToken = exports._compileUnsafe = exports.compile = void 0;
var DomUtils = __importStar(__webpack_require__(51296));
var boolbase_1 = __webpack_require__(11073);
var compile_1 = __webpack_require__(98866);
var subselects_1 = __webpack_require__(61768);
var defaultEquals = function (a, b) { return a === b; };
var defaultOptions = {
    adapter: DomUtils,
    equals: defaultEquals,
};
function convertOptionFormats(options) {
    var _a, _b, _c, _d;
    /*
     * We force one format of options to the other one.
     */
    // @ts-expect-error Default options may have incompatible `Node` / `ElementNode`.
    var opts = options !== null && options !== void 0 ? options : defaultOptions;
    // @ts-expect-error Same as above.
    (_a = opts.adapter) !== null && _a !== void 0 ? _a : (opts.adapter = DomUtils);
    // @ts-expect-error `equals` does not exist on `Options`
    (_b = opts.equals) !== null && _b !== void 0 ? _b : (opts.equals = (_d = (_c = opts.adapter) === null || _c === void 0 ? void 0 : _c.equals) !== null && _d !== void 0 ? _d : defaultEquals);
    return opts;
}
function wrapCompile(func) {
    return function addAdapter(selector, options, context) {
        var opts = convertOptionFormats(options);
        return func(selector, opts, context);
    };
}
/**
 * Compiles the query, returns a function.
 */
exports.compile = wrapCompile(compile_1.compile);
exports._compileUnsafe = wrapCompile(compile_1.compileUnsafe);
exports._compileToken = wrapCompile(compile_1.compileToken);
function getSelectorFunc(searchFunc) {
    return function select(query, elements, options) {
        var opts = convertOptionFormats(options);
        if (typeof query !== "function") {
            query = (0, compile_1.compileUnsafe)(query, opts, elements);
        }
        var filteredElements = prepareContext(elements, opts.adapter, query.shouldTestNextSiblings);
        return searchFunc(query, filteredElements, opts);
    };
}
function prepareContext(elems, adapter, shouldTestNextSiblings) {
    if (shouldTestNextSiblings === void 0) { shouldTestNextSiblings = false; }
    /*
     * Add siblings if the query requires them.
     * See https://github.com/fb55/css-select/pull/43#issuecomment-225414692
     */
    if (shouldTestNextSiblings) {
        elems = appendNextSiblings(elems, adapter);
    }
    return Array.isArray(elems)
        ? adapter.removeSubsets(elems)
        : adapter.getChildren(elems);
}
exports.prepareContext = prepareContext;
function appendNextSiblings(elem, adapter) {
    // Order matters because jQuery seems to check the children before the siblings
    var elems = Array.isArray(elem) ? elem.slice(0) : [elem];
    var elemsLength = elems.length;
    for (var i = 0; i < elemsLength; i++) {
        var nextSiblings = (0, subselects_1.getNextSiblings)(elems[i], adapter);
        elems.push.apply(elems, nextSiblings);
    }
    return elems;
}
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns All matching elements.
 *
 */
exports.selectAll = getSelectorFunc(function (query, elems, options) {
    return query === boolbase_1.falseFunc || !elems || elems.length === 0
        ? []
        : options.adapter.findAll(query, elems);
});
/**
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elems Elements to query. If it is an element, its children will be queried..
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns the first match, or null if there was no match.
 */
exports.selectOne = getSelectorFunc(function (query, elems, options) {
    return query === boolbase_1.falseFunc || !elems || elems.length === 0
        ? null
        : options.adapter.findOne(query, elems);
});
/**
 * Tests whether or not an element is matched by query.
 *
 * @template Node The generic Node type for the DOM adapter being used.
 * @template ElementNode The Node type for elements for the DOM adapter being used.
 * @param elem The element to test if it matches the query.
 * @param query can be either a CSS selector string or a compiled query function.
 * @param [options] options for querying the document.
 * @see compile for supported selector queries.
 * @returns
 */
function is(elem, query, options) {
    var opts = convertOptionFormats(options);
    return (typeof query === "function" ? query : (0, compile_1.compile)(query, opts))(elem);
}
exports.is = is;
/**
 * Alias for selectAll(query, elems, options).
 * @see [compile] for supported selector queries.
 */
exports["default"] = exports.selectAll;
// Export filters, pseudos and aliases to allow users to supply their own.
var pseudo_selectors_1 = __webpack_require__(98677);
Object.defineProperty(exports, "filters", ({ enumerable: true, get: function () { return pseudo_selectors_1.filters; } }));
Object.defineProperty(exports, "pseudos", ({ enumerable: true, get: function () { return pseudo_selectors_1.pseudos; } }));
Object.defineProperty(exports, "aliases", ({ enumerable: true, get: function () { return pseudo_selectors_1.aliases; } }));


/***/ }),

/***/ 57177:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isTraversal = exports.procedure = void 0;
exports.procedure = {
    universal: 50,
    tag: 30,
    attribute: 1,
    pseudo: 0,
    "pseudo-element": 0,
    "column-combinator": -1,
    descendant: -1,
    child: -1,
    parent: -1,
    sibling: -1,
    adjacent: -1,
    _flexibleDescendant: -1,
};
function isTraversal(t) {
    return exports.procedure[t.type] < 0;
}
exports.isTraversal = isTraversal;


/***/ }),

/***/ 92968:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.aliases = void 0;
/**
 * Aliases are pseudos that are expressed as selectors.
 */
exports.aliases = {
    // Links
    "any-link": ":is(a, area, link)[href]",
    link: ":any-link:not(:visited)",
    // Forms
    // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
    disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
    enabled: ":not(:disabled)",
    checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
    required: ":is(input, select, textarea)[required]",
    optional: ":is(input, select, textarea):not([required])",
    // JQuery extensions
    // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
    selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
    checkbox: "[type=checkbox]",
    file: "[type=file]",
    password: "[type=password]",
    radio: "[type=radio]",
    reset: "[type=reset]",
    image: "[type=image]",
    submit: "[type=submit]",
    parent: ":not(:empty)",
    header: ":is(h1, h2, h3, h4, h5, h6)",
    button: ":is(button, input[type=button])",
    input: ":is(input, textarea, select, button)",
    text: "input:is(:not([type!='']), [type=text])",
};


/***/ }),

/***/ 57689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.filters = void 0;
var nth_check_1 = __importDefault(__webpack_require__(97540));
var boolbase_1 = __webpack_require__(11073);
function getChildFunc(next, adapter) {
    return function (elem) {
        var parent = adapter.getParent(elem);
        return parent != null && adapter.isTag(parent) && next(elem);
    };
}
exports.filters = {
    contains: function (next, text, _a) {
        var adapter = _a.adapter;
        return function contains(elem) {
            return next(elem) && adapter.getText(elem).includes(text);
        };
    },
    icontains: function (next, text, _a) {
        var adapter = _a.adapter;
        var itext = text.toLowerCase();
        return function icontains(elem) {
            return (next(elem) &&
                adapter.getText(elem).toLowerCase().includes(itext));
        };
    },
    // Location specific methods
    "nth-child": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = 0; i < siblings.length; i++) {
                if (equals(elem, siblings[i]))
                    break;
                if (adapter.isTag(siblings[i])) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-child": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthLastChild(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = siblings.length - 1; i >= 0; i--) {
                if (equals(elem, siblings[i]))
                    break;
                if (adapter.isTag(siblings[i])) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-of-type": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = 0; i < siblings.length; i++) {
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling))
                    break;
                if (adapter.isTag(currentSibling) &&
                    adapter.getName(currentSibling) === adapter.getName(elem)) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    "nth-last-of-type": function (next, rule, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var func = (0, nth_check_1.default)(rule);
        if (func === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (func === boolbase_1.trueFunc)
            return getChildFunc(next, adapter);
        return function nthLastOfType(elem) {
            var siblings = adapter.getSiblings(elem);
            var pos = 0;
            for (var i = siblings.length - 1; i >= 0; i--) {
                var currentSibling = siblings[i];
                if (equals(elem, currentSibling))
                    break;
                if (adapter.isTag(currentSibling) &&
                    adapter.getName(currentSibling) === adapter.getName(elem)) {
                    pos++;
                }
            }
            return func(pos) && next(elem);
        };
    },
    // TODO determine the actual root element
    root: function (next, _rule, _a) {
        var adapter = _a.adapter;
        return function (elem) {
            var parent = adapter.getParent(elem);
            return (parent == null || !adapter.isTag(parent)) && next(elem);
        };
    },
    scope: function (next, rule, options, context) {
        var equals = options.equals;
        if (!context || context.length === 0) {
            // Equivalent to :root
            return exports.filters.root(next, rule, options);
        }
        if (context.length === 1) {
            // NOTE: can't be unpacked, as :has uses this for side-effects
            return function (elem) { return equals(context[0], elem) && next(elem); };
        }
        return function (elem) { return context.includes(elem) && next(elem); };
    },
    hover: dynamicStatePseudo("isHovered"),
    visited: dynamicStatePseudo("isVisited"),
    active: dynamicStatePseudo("isActive"),
};
/**
 * Dynamic state pseudos. These depend on optional Adapter methods.
 *
 * @param name The name of the adapter method to call.
 * @returns Pseudo for the `filters` object.
 */
function dynamicStatePseudo(name) {
    return function dynamicPseudo(next, _rule, _a) {
        var adapter = _a.adapter;
        var func = adapter[name];
        if (typeof func !== "function") {
            return boolbase_1.falseFunc;
        }
        return function active(elem) {
            return func(elem) && next(elem);
        };
    };
}


/***/ }),

/***/ 98677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compilePseudoSelector = exports.aliases = exports.pseudos = exports.filters = void 0;
/*
 * Pseudo selectors
 *
 * Pseudo selectors are available in three forms:
 *
 * 1. Filters are called when the selector is compiled and return a function
 *  that has to return either false, or the results of `next()`.
 * 2. Pseudos are called on execution. They have to return a boolean.
 * 3. Subselects work like filters, but have an embedded selector that will be run separately.
 *
 * Filters are great if you want to do some pre-processing, or change the call order
 * of `next()` and your code.
 * Pseudos should be used to implement simple checks.
 */
var boolbase_1 = __webpack_require__(11073);
var css_what_1 = __webpack_require__(67209);
var filters_1 = __webpack_require__(57689);
Object.defineProperty(exports, "filters", ({ enumerable: true, get: function () { return filters_1.filters; } }));
var pseudos_1 = __webpack_require__(57221);
Object.defineProperty(exports, "pseudos", ({ enumerable: true, get: function () { return pseudos_1.pseudos; } }));
var aliases_1 = __webpack_require__(92968);
Object.defineProperty(exports, "aliases", ({ enumerable: true, get: function () { return aliases_1.aliases; } }));
var subselects_1 = __webpack_require__(61768);
function compilePseudoSelector(next, selector, options, context, compileToken) {
    var name = selector.name, data = selector.data;
    if (Array.isArray(data)) {
        return subselects_1.subselects[name](next, data, options, context, compileToken);
    }
    if (name in aliases_1.aliases) {
        if (data != null) {
            throw new Error("Pseudo ".concat(name, " doesn't have any arguments"));
        }
        // The alias has to be parsed here, to make sure options are respected.
        var alias = (0, css_what_1.parse)(aliases_1.aliases[name]);
        return subselects_1.subselects.is(next, alias, options, context, compileToken);
    }
    if (name in filters_1.filters) {
        return filters_1.filters[name](next, data, options, context);
    }
    if (name in pseudos_1.pseudos) {
        var pseudo_1 = pseudos_1.pseudos[name];
        (0, pseudos_1.verifyPseudoArgs)(pseudo_1, name, data);
        return pseudo_1 === boolbase_1.falseFunc
            ? boolbase_1.falseFunc
            : next === boolbase_1.trueFunc
                ? function (elem) { return pseudo_1(elem, options, data); }
                : function (elem) { return pseudo_1(elem, options, data) && next(elem); };
    }
    throw new Error("unmatched pseudo-class :".concat(name));
}
exports.compilePseudoSelector = compilePseudoSelector;


/***/ }),

/***/ 57221:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifyPseudoArgs = exports.pseudos = void 0;
// While filters are precompiled, pseudos get called when they are needed
exports.pseudos = {
    empty: function (elem, _a) {
        var adapter = _a.adapter;
        return !adapter.getChildren(elem).some(function (elem) {
            // FIXME: `getText` call is potentially expensive.
            return adapter.isTag(elem) || adapter.getText(elem) !== "";
        });
    },
    "first-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var firstChild = adapter
            .getSiblings(elem)
            .find(function (elem) { return adapter.isTag(elem); });
        return firstChild != null && equals(elem, firstChild);
    },
    "last-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        for (var i = siblings.length - 1; i >= 0; i--) {
            if (equals(elem, siblings[i]))
                return true;
            if (adapter.isTag(siblings[i]))
                break;
        }
        return false;
    },
    "first-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for (var i = 0; i < siblings.length; i++) {
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling))
                return true;
            if (adapter.isTag(currentSibling) &&
                adapter.getName(currentSibling) === elemName) {
                break;
            }
        }
        return false;
    },
    "last-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var siblings = adapter.getSiblings(elem);
        var elemName = adapter.getName(elem);
        for (var i = siblings.length - 1; i >= 0; i--) {
            var currentSibling = siblings[i];
            if (equals(elem, currentSibling))
                return true;
            if (adapter.isTag(currentSibling) &&
                adapter.getName(currentSibling) === elemName) {
                break;
            }
        }
        return false;
    },
    "only-of-type": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        var elemName = adapter.getName(elem);
        return adapter
            .getSiblings(elem)
            .every(function (sibling) {
            return equals(elem, sibling) ||
                !adapter.isTag(sibling) ||
                adapter.getName(sibling) !== elemName;
        });
    },
    "only-child": function (elem, _a) {
        var adapter = _a.adapter, equals = _a.equals;
        return adapter
            .getSiblings(elem)
            .every(function (sibling) { return equals(elem, sibling) || !adapter.isTag(sibling); });
    },
};
function verifyPseudoArgs(func, name, subselect) {
    if (subselect === null) {
        if (func.length > 2) {
            throw new Error("pseudo-selector :".concat(name, " requires an argument"));
        }
    }
    else if (func.length === 2) {
        throw new Error("pseudo-selector :".concat(name, " doesn't have any arguments"));
    }
}
exports.verifyPseudoArgs = verifyPseudoArgs;


/***/ }),

/***/ 61768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.subselects = exports.getNextSiblings = exports.ensureIsTag = exports.PLACEHOLDER_ELEMENT = void 0;
var boolbase_1 = __webpack_require__(11073);
var procedure_1 = __webpack_require__(57177);
/** Used as a placeholder for :has. Will be replaced with the actual element. */
exports.PLACEHOLDER_ELEMENT = {};
function ensureIsTag(next, adapter) {
    if (next === boolbase_1.falseFunc)
        return boolbase_1.falseFunc;
    return function (elem) { return adapter.isTag(elem) && next(elem); };
}
exports.ensureIsTag = ensureIsTag;
function getNextSiblings(elem, adapter) {
    var siblings = adapter.getSiblings(elem);
    if (siblings.length <= 1)
        return [];
    var elemIndex = siblings.indexOf(elem);
    if (elemIndex < 0 || elemIndex === siblings.length - 1)
        return [];
    return siblings.slice(elemIndex + 1).filter(adapter.isTag);
}
exports.getNextSiblings = getNextSiblings;
var is = function (next, token, options, context, compileToken) {
    var opts = {
        xmlMode: !!options.xmlMode,
        adapter: options.adapter,
        equals: options.equals,
    };
    var func = compileToken(token, opts, context);
    return function (elem) { return func(elem) && next(elem); };
};
/*
 * :not, :has, :is, :matches and :where have to compile selectors
 * doing this in src/pseudos.ts would lead to circular dependencies,
 * so we add them here
 */
exports.subselects = {
    is: is,
    /**
     * `:matches` and `:where` are aliases for `:is`.
     */
    matches: is,
    where: is,
    not: function (next, token, options, context, compileToken) {
        var opts = {
            xmlMode: !!options.xmlMode,
            adapter: options.adapter,
            equals: options.equals,
        };
        var func = compileToken(token, opts, context);
        if (func === boolbase_1.falseFunc)
            return next;
        if (func === boolbase_1.trueFunc)
            return boolbase_1.falseFunc;
        return function not(elem) {
            return !func(elem) && next(elem);
        };
    },
    has: function (next, subselect, options, _context, compileToken) {
        var adapter = options.adapter;
        var opts = {
            xmlMode: !!options.xmlMode,
            adapter: adapter,
            equals: options.equals,
        };
        // @ts-expect-error Uses an array as a pointer to the current element (side effects)
        var context = subselect.some(function (s) {
            return s.some(procedure_1.isTraversal);
        })
            ? [exports.PLACEHOLDER_ELEMENT]
            : undefined;
        var compiled = compileToken(subselect, opts, context);
        if (compiled === boolbase_1.falseFunc)
            return boolbase_1.falseFunc;
        if (compiled === boolbase_1.trueFunc) {
            return function (elem) {
                return adapter.getChildren(elem).some(adapter.isTag) && next(elem);
            };
        }
        var hasElement = ensureIsTag(compiled, adapter);
        var _a = compiled.shouldTestNextSiblings, shouldTestNextSiblings = _a === void 0 ? false : _a;
        /*
         * `shouldTestNextSiblings` will only be true if the query starts with
         * a traversal (sibling or adjacent). That means we will always have a context.
         */
        if (context) {
            return function (elem) {
                context[0] = elem;
                var childs = adapter.getChildren(elem);
                var nextElements = shouldTestNextSiblings
                    ? __spreadArray(__spreadArray([], childs, true), getNextSiblings(elem, adapter), true) : childs;
                return (next(elem) && adapter.existsOne(hasElement, nextElements));
            };
        }
        return function (elem) {
            return next(elem) &&
                adapter.existsOne(hasElement, adapter.getChildren(elem));
        };
    },
};


/***/ }),

/***/ 57353:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var css_what_1 = __webpack_require__(67209);
var procedure_1 = __webpack_require__(57177);
var attributes = {
    exists: 10,
    equals: 8,
    not: 7,
    start: 6,
    end: 6,
    any: 5,
    hyphen: 4,
    element: 4,
};
/**
 * Sort the parts of the passed selector,
 * as there is potential for optimization
 * (some types of selectors are faster than others)
 *
 * @param arr Selector to sort
 */
function sortByProcedure(arr) {
    var procs = arr.map(getProcedure);
    for (var i = 1; i < arr.length; i++) {
        var procNew = procs[i];
        if (procNew < 0)
            continue;
        for (var j = i - 1; j >= 0 && procNew < procs[j]; j--) {
            var token = arr[j + 1];
            arr[j + 1] = arr[j];
            arr[j] = token;
            procs[j + 1] = procs[j];
            procs[j] = procNew;
        }
    }
}
exports["default"] = sortByProcedure;
function getProcedure(token) {
    var proc = procedure_1.procedure[token.type];
    if (token.type === css_what_1.SelectorType.Attribute) {
        proc = attributes[token.action];
        if (proc === attributes.equals && token.name === "id") {
            // Prefer ID selectors (eg. #ID)
            proc = 9;
        }
        if (token.ignoreCase) {
            /*
             * IgnoreCase adds some overhead, prefer "normal" token
             * this is a binary operation, to ensure it's still an int
             */
            proc >>= 1;
        }
    }
    else if (token.type === css_what_1.SelectorType.Pseudo) {
        if (!token.data) {
            proc = 3;
        }
        else if (token.name === "has" || token.name === "contains") {
            proc = 0; // Expensive in any case
        }
        else if (Array.isArray(token.data)) {
            // "matches" and "not"
            proc = 0;
            for (var i = 0; i < token.data.length; i++) {
                // TODO better handling of complex selectors
                if (token.data[i].length !== 1)
                    continue;
                var cur = getProcedure(token.data[i][0]);
                // Avoid executing :has or :contains
                if (cur === 0) {
                    proc = 0;
                    break;
                }
                if (cur > proc)
                    proc = cur;
            }
            if (token.data.length > 1 && proc > 0)
                proc -= 1;
        }
        else {
            proc = 1;
        }
    }
    return proc;
}


/***/ }),

/***/ 94480:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.attributeNames = exports.elementNames = void 0;
exports.elementNames = new Map([
    ["altglyph", "altGlyph"],
    ["altglyphdef", "altGlyphDef"],
    ["altglyphitem", "altGlyphItem"],
    ["animatecolor", "animateColor"],
    ["animatemotion", "animateMotion"],
    ["animatetransform", "animateTransform"],
    ["clippath", "clipPath"],
    ["feblend", "feBlend"],
    ["fecolormatrix", "feColorMatrix"],
    ["fecomponenttransfer", "feComponentTransfer"],
    ["fecomposite", "feComposite"],
    ["feconvolvematrix", "feConvolveMatrix"],
    ["fediffuselighting", "feDiffuseLighting"],
    ["fedisplacementmap", "feDisplacementMap"],
    ["fedistantlight", "feDistantLight"],
    ["fedropshadow", "feDropShadow"],
    ["feflood", "feFlood"],
    ["fefunca", "feFuncA"],
    ["fefuncb", "feFuncB"],
    ["fefuncg", "feFuncG"],
    ["fefuncr", "feFuncR"],
    ["fegaussianblur", "feGaussianBlur"],
    ["feimage", "feImage"],
    ["femerge", "feMerge"],
    ["femergenode", "feMergeNode"],
    ["femorphology", "feMorphology"],
    ["feoffset", "feOffset"],
    ["fepointlight", "fePointLight"],
    ["fespecularlighting", "feSpecularLighting"],
    ["fespotlight", "feSpotLight"],
    ["fetile", "feTile"],
    ["feturbulence", "feTurbulence"],
    ["foreignobject", "foreignObject"],
    ["glyphref", "glyphRef"],
    ["lineargradient", "linearGradient"],
    ["radialgradient", "radialGradient"],
    ["textpath", "textPath"],
]);
exports.attributeNames = new Map([
    ["definitionurl", "definitionURL"],
    ["attributename", "attributeName"],
    ["attributetype", "attributeType"],
    ["basefrequency", "baseFrequency"],
    ["baseprofile", "baseProfile"],
    ["calcmode", "calcMode"],
    ["clippathunits", "clipPathUnits"],
    ["diffuseconstant", "diffuseConstant"],
    ["edgemode", "edgeMode"],
    ["filterunits", "filterUnits"],
    ["glyphref", "glyphRef"],
    ["gradienttransform", "gradientTransform"],
    ["gradientunits", "gradientUnits"],
    ["kernelmatrix", "kernelMatrix"],
    ["kernelunitlength", "kernelUnitLength"],
    ["keypoints", "keyPoints"],
    ["keysplines", "keySplines"],
    ["keytimes", "keyTimes"],
    ["lengthadjust", "lengthAdjust"],
    ["limitingconeangle", "limitingConeAngle"],
    ["markerheight", "markerHeight"],
    ["markerunits", "markerUnits"],
    ["markerwidth", "markerWidth"],
    ["maskcontentunits", "maskContentUnits"],
    ["maskunits", "maskUnits"],
    ["numoctaves", "numOctaves"],
    ["pathlength", "pathLength"],
    ["patterncontentunits", "patternContentUnits"],
    ["patterntransform", "patternTransform"],
    ["patternunits", "patternUnits"],
    ["pointsatx", "pointsAtX"],
    ["pointsaty", "pointsAtY"],
    ["pointsatz", "pointsAtZ"],
    ["preservealpha", "preserveAlpha"],
    ["preserveaspectratio", "preserveAspectRatio"],
    ["primitiveunits", "primitiveUnits"],
    ["refx", "refX"],
    ["refy", "refY"],
    ["repeatcount", "repeatCount"],
    ["repeatdur", "repeatDur"],
    ["requiredextensions", "requiredExtensions"],
    ["requiredfeatures", "requiredFeatures"],
    ["specularconstant", "specularConstant"],
    ["specularexponent", "specularExponent"],
    ["spreadmethod", "spreadMethod"],
    ["startoffset", "startOffset"],
    ["stddeviation", "stdDeviation"],
    ["stitchtiles", "stitchTiles"],
    ["surfacescale", "surfaceScale"],
    ["systemlanguage", "systemLanguage"],
    ["tablevalues", "tableValues"],
    ["targetx", "targetX"],
    ["targety", "targetY"],
    ["textlength", "textLength"],
    ["viewbox", "viewBox"],
    ["viewtarget", "viewTarget"],
    ["xchannelselector", "xChannelSelector"],
    ["ychannelselector", "yChannelSelector"],
    ["zoomandpan", "zoomAndPan"],
]);


/***/ }),

/***/ 93969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/*
 * Module dependencies
 */
var ElementType = __importStar(__webpack_require__(94637));
var entities_1 = __webpack_require__(45863);
/**
 * Mixed-case SVG and MathML tags & attributes
 * recognized by the HTML parser.
 *
 * @see https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inforeign
 */
var foreignNames_1 = __webpack_require__(94480);
var unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript",
]);
/**
 * Format attributes
 */
function formatAttributes(attributes, opts) {
    if (!attributes)
        return;
    return Object.keys(attributes)
        .map(function (key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") {
            /* Fix up mixed-case attribute names */
            key = (_b = foreignNames_1.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        }
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") {
            return key;
        }
        return key + "=\"" + (opts.decodeEntities !== false
            ? entities_1.encodeXML(value)
            : value.replace(/"/g, "&quot;")) + "\"";
    })
        .join(" ");
}
/**
 * Self-enclosing tags
 */
var singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */
function render(node, options) {
    if (options === void 0) { options = {}; }
    var nodes = "length" in node ? node : [node];
    var output = "";
    for (var i = 0; i < nodes.length; i++) {
        output += renderNode(nodes[i], options);
    }
    return output;
}
exports["default"] = render;
function renderNode(node, options) {
    switch (node.type) {
        case ElementType.Root:
            return render(node.children, options);
        case ElementType.Directive:
        case ElementType.Doctype:
            return renderDirective(node);
        case ElementType.Comment:
            return renderComment(node);
        case ElementType.CDATA:
            return renderCdata(node);
        case ElementType.Script:
        case ElementType.Style:
        case ElementType.Tag:
            return renderTag(node, options);
        case ElementType.Text:
            return renderText(node, options);
    }
}
var foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title",
]);
var foreignElements = new Set(["svg", "math"]);
function renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */
        elem.name = (_a = foreignNames_1.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */
        if (elem.parent &&
            foreignModeIntegrationPoints.has(elem.parent.name)) {
            opts = __assign(__assign({}, opts), { xmlMode: false });
        }
    }
    if (!opts.xmlMode && foreignElements.has(elem.name)) {
        opts = __assign(__assign({}, opts), { xmlMode: "foreign" });
    }
    var tag = "<" + elem.name;
    var attribs = formatAttributes(elem.attribs, opts);
    if (attribs) {
        tag += " " + attribs;
    }
    if (elem.children.length === 0 &&
        (opts.xmlMode
            ? // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
                opts.selfClosingTags !== false
            : // User explicitly asked for self-closing tags, even in HTML mode
                opts.selfClosingTags && singleTag.has(elem.name))) {
        if (!opts.xmlMode)
            tag += " ";
        tag += "/>";
    }
    else {
        tag += ">";
        if (elem.children.length > 0) {
            tag += render(elem.children, opts);
        }
        if (opts.xmlMode || !singleTag.has(elem.name)) {
            tag += "</" + elem.name + ">";
        }
    }
    return tag;
}
function renderDirective(elem) {
    return "<" + elem.data + ">";
}
function renderText(elem, opts) {
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (opts.decodeEntities !== false &&
        !(!opts.xmlMode &&
            elem.parent &&
            unencodedElements.has(elem.parent.name))) {
        data = entities_1.encodeXML(data);
    }
    return data;
}
function renderCdata(elem) {
    return "<![CDATA[" + elem.children[0].data + "]]>";
}
function renderComment(elem) {
    return "<!--" + elem.data + "-->";
}


/***/ }),

/***/ 94637:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 69673:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */
var ElementType;
(function (ElementType) {
    /** Type for the root element of a document */
    ElementType["Root"] = "root";
    /** Type for Text */
    ElementType["Text"] = "text";
    /** Type for <? ... ?> */
    ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */
    ElementType["Comment"] = "comment";
    /** Type for <script> tags */
    ElementType["Script"] = "script";
    /** Type for <style> tags */
    ElementType["Style"] = "style";
    /** Type for Any tag */
    ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */
    ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */
exports.Root = ElementType.Root;
/** Type for Text */
exports.Text = ElementType.Text;
/** Type for <? ... ?> */
exports.Directive = ElementType.Directive;
/** Type for <!-- ... --> */
exports.Comment = ElementType.Comment;
/** Type for <script> tags */
exports.Script = ElementType.Script;
/** Type for <style> tags */
exports.Style = ElementType.Style;
/** Type for Any tag */
exports.Tag = ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */
exports.CDATA = ElementType.CDATA;
/** Type for <!doctype ...> */
exports.Doctype = ElementType.Doctype;


/***/ }),

/***/ 60731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DomHandler = void 0;
var domelementtype_1 = __webpack_require__(69673);
var node_1 = __webpack_require__(93327);
__exportStar(__webpack_require__(93327), exports);
var reWhitespace = /\s+/g;
// Default options
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler = /** @class */ (function () {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */
    function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */
        this.dom = [];
        /** The root element for the DOM */
        this.root = new node_1.Document(this.dom);
        /** Indicated whether parsing has been completed. */
        this.done = false;
        /** Stack of open tags. */
        this.tagStack = [this.root];
        /** A data node that is still being written to. */
        this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */
        this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports["default"] = DomHandler;


/***/ }),

/***/ 93327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
var domelementtype_1 = __webpack_require__(69673);
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */
var Node = /** @class */ (function () {
    /**
     *
     * @param type The type of the node.
     */
    function Node(type) {
        this.type = type;
        /** Parent of the node */
        this.parent = null;
        /** Previous sibling */
        this.prev = null;
        /** Next sibling */
        this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
        this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        // Read-only aliases
        /**
         * [DOM spec](https://dom.spec.whatwg.org/#dom-node-nodetype)-compatible
         * node {@link type}.
         */
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
exports.Node = Node;
/**
 * A node that contains some data.
 */
var DataNode = /** @class */ (function (_super) {
    __extends(DataNode, _super);
    /**
     * @param type The type of the node
     * @param data The content of the data node
     */
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
exports.DataNode = DataNode;
/**
 * Text within the document.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
exports.Text = Text;
/**
 * Comments within the document.
 */
var Comment = /** @class */ (function (_super) {
    __extends(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
exports.Comment = Comment;
/**
 * Processing instructions, including doc types.
 */
var ProcessingInstruction = /** @class */ (function (_super) {
    __extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
exports.ProcessingInstruction = ProcessingInstruction;
/**
 * A `Node` that can have children.
 */
var NodeWithChildren = /** @class */ (function (_super) {
    __extends(NodeWithChildren, _super);
    /**
     * @param type Type of the node.
     * @param children Children of the node. Only certain node types can have children.
     */
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
exports.NodeWithChildren = NodeWithChildren;
/**
 * The root node of the document.
 */
var Document = /** @class */ (function (_super) {
    __extends(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
exports.Document = Document;
/**
 * An element within the DOM.
 */
var Element = /** @class */ (function (_super) {
    __extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
exports.Element = Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
exports.isTag = isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
exports.isCDATA = isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
exports.isText = isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
exports.isComment = isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
exports.isDirective = isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
exports.isDocument = isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `NodeWithChildren` (has children), `false` otherwise.
 */
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
exports.hasChildren = hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
exports.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


/***/ }),

/***/ 68910:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getFeed = void 0;
var stringify_1 = __webpack_require__(86639);
var legacy_1 = __webpack_require__(5884);
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */
function getFeed(doc) {
    var feedRoot = getOneElement(isValidFeed, doc);
    return !feedRoot
        ? null
        : feedRoot.name === "feed"
            ? getAtomFeed(feedRoot)
            : getRssFeed(feedRoot);
}
exports.getFeed = getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, legacy_1.getElementsByTagName)("entry", childs).map(function (item) {
            var _a;
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "id", children);
            addConditionally(entry, "title", "title", children);
            var href = (_a = getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs.href;
            if (href) {
                entry.link = href;
            }
            var description = fetch("summary", children) || fetch("content", children);
            if (description) {
                entry.description = description;
            }
            var pubDate = fetch("updated", children);
            if (pubDate) {
                entry.pubDate = new Date(pubDate);
            }
            return entry;
        }),
    };
    addConditionally(feed, "id", "id", childs);
    addConditionally(feed, "title", "title", childs);
    var href = (_a = getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs.href;
    if (href) {
        feed.link = href;
    }
    addConditionally(feed, "description", "subtitle", childs);
    var updated = fetch("updated", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */
function getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, legacy_1.getElementsByTagName)("item", feedRoot.children).map(function (item) {
            var children = item.children;
            var entry = { media: getMediaElements(children) };
            addConditionally(entry, "id", "guid", children);
            addConditionally(entry, "title", "title", children);
            addConditionally(entry, "link", "link", children);
            addConditionally(entry, "description", "description", children);
            var pubDate = fetch("pubDate", children);
            if (pubDate)
                entry.pubDate = new Date(pubDate);
            return entry;
        }),
    };
    addConditionally(feed, "title", "title", childs);
    addConditionally(feed, "link", "link", childs);
    addConditionally(feed, "description", "description", childs);
    var updated = fetch("lastBuildDate", childs);
    if (updated) {
        feed.updated = new Date(updated);
    }
    addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var MEDIA_KEYS_STRING = ["url", "type", "lang"];
var MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width",
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */
function getMediaElements(where) {
    return (0, legacy_1.getElementsByTagName)("media:content", where).map(function (elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs.medium,
            isDefault: !!attribs.isDefault,
        };
        for (var _i = 0, MEDIA_KEYS_STRING_1 = MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++) {
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) {
                media[attrib] = attribs[attrib];
            }
        }
        for (var _a = 0, MEDIA_KEYS_INT_1 = MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++) {
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) {
                media[attrib] = parseInt(attribs[attrib], 10);
            }
        }
        if (attribs.expression) {
            media.expression =
                attribs.expression;
        }
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */
function getOneElement(tagName, node) {
    return (0, legacy_1.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where  Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */
function fetch(tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    return (0, stringify_1.textContent)((0, legacy_1.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */
function addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) { recurse = false; }
    var val = fetch(tagName, where, recurse);
    if (val)
        obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */
function isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}


/***/ }),

/***/ 73484:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uniqueSort = exports.compareDocumentPosition = exports.removeSubsets = void 0;
var domhandler_1 = __webpack_require__(60731);
/**
 * Given an array of nodes, remove any member that is contained by another.
 *
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't subtrees of each other.
 */
function removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */
    while (--idx >= 0) {
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */
        if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for (var ancestor = node.parent; ancestor; ancestor = ancestor.parent) {
            if (nodes.includes(ancestor)) {
                nodes.splice(idx, 1);
                break;
            }
        }
    }
    return nodes;
}
exports.removeSubsets = removeSubsets;
/**
 * Compare the position of one node against another node in any other document.
 * The return value is a bitmask with the following values:
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent./
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */
function compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) {
        return 0;
    }
    var current = (0, domhandler_1.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while (current) {
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, domhandler_1.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while (current) {
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while (idx < maxIdx && aParents[idx] === bParents[idx]) {
        idx++;
    }
    if (idx === 0) {
        return 1 /* DISCONNECTED */;
    }
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) {
            return 4 /* FOLLOWING */ | 16 /* CONTAINED_BY */;
        }
        return 4 /* FOLLOWING */;
    }
    if (sharedParent === nodeA) {
        return 2 /* PRECEDING */ | 8 /* CONTAINS */;
    }
    return 2 /* PRECEDING */;
}
exports.compareDocumentPosition = compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document and
 * remove any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */
function uniqueSort(nodes) {
    nodes = nodes.filter(function (node, i, arr) { return !arr.includes(node, i + 1); });
    nodes.sort(function (a, b) {
        var relative = compareDocumentPosition(a, b);
        if (relative & 2 /* PRECEDING */) {
            return -1;
        }
        else if (relative & 4 /* FOLLOWING */) {
            return 1;
        }
        return 0;
    });
    return nodes;
}
exports.uniqueSort = uniqueSort;


/***/ }),

/***/ 51296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hasChildren = exports.isDocument = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = void 0;
__exportStar(__webpack_require__(86639), exports);
__exportStar(__webpack_require__(34290), exports);
__exportStar(__webpack_require__(28944), exports);
__exportStar(__webpack_require__(66669), exports);
__exportStar(__webpack_require__(5884), exports);
__exportStar(__webpack_require__(73484), exports);
__exportStar(__webpack_require__(68910), exports);
/** @deprecated Use these methods from `domhandler` directly. */
var domhandler_1 = __webpack_require__(60731);
Object.defineProperty(exports, "isTag", ({ enumerable: true, get: function () { return domhandler_1.isTag; } }));
Object.defineProperty(exports, "isCDATA", ({ enumerable: true, get: function () { return domhandler_1.isCDATA; } }));
Object.defineProperty(exports, "isText", ({ enumerable: true, get: function () { return domhandler_1.isText; } }));
Object.defineProperty(exports, "isComment", ({ enumerable: true, get: function () { return domhandler_1.isComment; } }));
Object.defineProperty(exports, "isDocument", ({ enumerable: true, get: function () { return domhandler_1.isDocument; } }));
Object.defineProperty(exports, "hasChildren", ({ enumerable: true, get: function () { return domhandler_1.hasChildren; } }));


/***/ }),

/***/ 5884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getElementsByTagType = exports.getElementsByTagName = exports.getElementById = exports.getElements = exports.testElement = void 0;
var domhandler_1 = __webpack_require__(60731);
var querying_1 = __webpack_require__(66669);
var Checks = {
    tag_name: function (name) {
        if (typeof name === "function") {
            return function (elem) { return (0, domhandler_1.isTag)(elem) && name(elem.name); };
        }
        else if (name === "*") {
            return domhandler_1.isTag;
        }
        return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.name === name; };
    },
    tag_type: function (type) {
        if (typeof type === "function") {
            return function (elem) { return type(elem.type); };
        }
        return function (elem) { return elem.type === type; };
    },
    tag_contains: function (data) {
        if (typeof data === "function") {
            return function (elem) { return (0, domhandler_1.isText)(elem) && data(elem.data); };
        }
        return function (elem) { return (0, domhandler_1.isText)(elem) && elem.data === data; };
    },
};
/**
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a particular value.
 */
function getAttribCheck(attrib, value) {
    if (typeof value === "function") {
        return function (elem) { return (0, domhandler_1.isTag)(elem) && value(elem.attribs[attrib]); };
    }
    return function (elem) { return (0, domhandler_1.isTag)(elem) && elem.attribs[attrib] === value; };
}
/**
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either
 * of the input functions returns `true` for the node.
 */
function combineFuncs(a, b) {
    return function (elem) { return a(elem) || b(elem); };
}
/**
 * @param options An object describing nodes to look for.
 * @returns A function executing all checks in `options` and returning `true`
 * if any of them match a node.
 */
function compileTest(options) {
    var funcs = Object.keys(options).map(function (key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call(Checks, key)
            ? Checks[key](value)
            : getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce(combineFuncs);
}
/**
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */
function testElement(options, node) {
    var test = compileTest(options);
    return test ? test(node) : true;
}
exports.testElement = testElement;
/**
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */
function getElements(options, nodes, recurse, limit) {
    if (limit === void 0) { limit = Infinity; }
    var test = compileTest(options);
    return test ? (0, querying_1.filter)(test, nodes, recurse, limit) : [];
}
exports.getElements = getElements;
/**
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */
function getElementById(id, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    if (!Array.isArray(nodes))
        nodes = [nodes];
    return (0, querying_1.findOne)(getAttribCheck("id", id), nodes, recurse);
}
exports.getElementById = getElementById;
/**
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */
function getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_name(tagName), nodes, recurse, limit);
}
exports.getElementsByTagName = getElementsByTagName;
/**
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */
function getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    return (0, querying_1.filter)(Checks.tag_type(type), nodes, recurse, limit);
}
exports.getElementsByTagType = getElementsByTagType;


/***/ }),

/***/ 28944:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.prepend = exports.prependChild = exports.append = exports.appendChild = exports.replaceElement = exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @param elem The element to be removed
 */
function removeElement(elem) {
    if (elem.prev)
        elem.prev.next = elem.next;
    if (elem.next)
        elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        childs.splice(childs.lastIndexOf(elem), 1);
    }
}
exports.removeElement = removeElement;
/**
 * Replace an element in the dom
 *
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */
function replaceElement(elem, replacement) {
    var prev = (replacement.prev = elem.prev);
    if (prev) {
        prev.next = replacement;
    }
    var next = (replacement.next = elem.next);
    if (next) {
        next.prev = replacement;
    }
    var parent = (replacement.parent = elem.parent);
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
    }
}
exports.replaceElement = replaceElement;
/**
 * Append a child to an element.
 *
 * @param elem The element to append to.
 * @param child The element to be added as a child.
 */
function appendChild(elem, child) {
    removeElement(child);
    child.next = null;
    child.parent = elem;
    if (elem.children.push(child) > 1) {
        var sibling = elem.children[elem.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    }
    else {
        child.prev = null;
    }
}
exports.appendChild = appendChild;
/**
 * Append an element after another.
 *
 * @param elem The element to append after.
 * @param next The element be added.
 */
function append(elem, next) {
    removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    }
    else if (parent) {
        parent.children.push(next);
    }
}
exports.append = append;
/**
 * Prepend a child to an element.
 *
 * @param elem The element to prepend before.
 * @param child The element to be added as a child.
 */
function prependChild(elem, child) {
    removeElement(child);
    child.parent = elem;
    child.prev = null;
    if (elem.children.unshift(child) !== 1) {
        var sibling = elem.children[1];
        sibling.prev = child;
        child.next = sibling;
    }
    else {
        child.next = null;
    }
}
exports.prependChild = prependChild;
/**
 * Prepend an element before another.
 *
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */
function prepend(elem, prev) {
    removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) {
        elem.prev.next = prev;
    }
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
exports.prepend = prepend;


/***/ }),

/***/ 66669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.findAll = exports.existsOne = exports.findOne = exports.findOneChild = exports.find = exports.filter = void 0;
var domhandler_1 = __webpack_require__(60731);
/**
 * Search a node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function filter(test, node, recurse, limit) {
    if (recurse === void 0) { recurse = true; }
    if (limit === void 0) { limit = Infinity; }
    if (!Array.isArray(node))
        node = [node];
    return find(test, node, recurse, limit);
}
exports.filter = filter;
/**
 * Search an array of node and its children for nodes passing a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */
function find(test, nodes, recurse, limit) {
    var result = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var elem = nodes_1[_i];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0)
                break;
        }
        if (recurse && (0, domhandler_1.hasChildren)(elem) && elem.children.length > 0) {
            var children = find(test, elem.children, recurse, limit);
            result.push.apply(result, children);
            limit -= children.length;
            if (limit <= 0)
                break;
        }
    }
    return result;
}
exports.find = find;
/**
 * Finds the first element inside of an array that matches a test function.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 */
function findOneChild(test, nodes) {
    return nodes.find(test);
}
exports.findOneChild = findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first child node that passes `test`.
 */
function findOne(test, nodes, recurse) {
    if (recurse === void 0) { recurse = true; }
    var elem = null;
    for (var i = 0; i < nodes.length && !elem; i++) {
        var checked = nodes[i];
        if (!(0, domhandler_1.isTag)(checked)) {
            continue;
        }
        else if (test(checked)) {
            elem = checked;
        }
        else if (recurse && checked.children.length > 0) {
            elem = findOne(test, checked.children);
        }
    }
    return elem;
}
exports.findOne = findOne;
/**
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing a test.
 */
function existsOne(test, nodes) {
    return nodes.some(function (checked) {
        return (0, domhandler_1.isTag)(checked) &&
            (test(checked) ||
                (checked.children.length > 0 &&
                    existsOne(test, checked.children)));
    });
}
exports.existsOne = existsOne;
/**
 * Search and array of nodes and its children for nodes passing a test function.
 *
 * Same as `find`, only with less options, leading to reduced complexity.
 *
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */
function findAll(test, nodes) {
    var _a;
    var result = [];
    var stack = nodes.filter(domhandler_1.isTag);
    var elem;
    while ((elem = stack.shift())) {
        var children = (_a = elem.children) === null || _a === void 0 ? void 0 : _a.filter(domhandler_1.isTag);
        if (children && children.length > 0) {
            stack.unshift.apply(stack, children);
        }
        if (test(elem))
            result.push(elem);
    }
    return result;
}
exports.findAll = findAll;


/***/ }),

/***/ 86639:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.innerText = exports.textContent = exports.getText = exports.getInnerHTML = exports.getOuterHTML = void 0;
var domhandler_1 = __webpack_require__(60731);
var dom_serializer_1 = __importDefault(__webpack_require__(93969));
var domelementtype_1 = __webpack_require__(69673);
/**
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s outer HTML.
 */
function getOuterHTML(node, options) {
    return (0, dom_serializer_1.default)(node, options);
}
exports.getOuterHTML = getOuterHTML;
/**
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @deprecated Use the `dom-serializer` module directly.
 * @returns `node`'s inner HTML.
 */
function getInnerHTML(node, options) {
    return (0, domhandler_1.hasChildren)(node)
        ? node.children.map(function (node) { return getOuterHTML(node, options); }).join("")
        : "";
}
exports.getInnerHTML = getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags.
 *
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */
function getText(node) {
    if (Array.isArray(node))
        return node.map(getText).join("");
    if ((0, domhandler_1.isTag)(node))
        return node.name === "br" ? "\n" : getText(node.children);
    if ((0, domhandler_1.isCDATA)(node))
        return getText(node.children);
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.getText = getText;
/**
 * Get a node's text content.
 *
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */
function textContent(node) {
    if (Array.isArray(node))
        return node.map(textContent).join("");
    if ((0, domhandler_1.hasChildren)(node) && !(0, domhandler_1.isComment)(node)) {
        return textContent(node.children);
    }
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.textContent = textContent;
/**
 * Get a node's inner text.
 *
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */
function innerText(node) {
    if (Array.isArray(node))
        return node.map(innerText).join("");
    if ((0, domhandler_1.hasChildren)(node) && (node.type === domelementtype_1.ElementType.Tag || (0, domhandler_1.isCDATA)(node))) {
        return innerText(node.children);
    }
    if ((0, domhandler_1.isText)(node))
        return node.data;
    return "";
}
exports.innerText = innerText;


/***/ }),

/***/ 34290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.prevElementSibling = exports.nextElementSibling = exports.getName = exports.hasAttrib = exports.getAttributeValue = exports.getSiblings = exports.getParent = exports.getChildren = void 0;
var domhandler_1 = __webpack_require__(60731);
var emptyArray = [];
/**
 * Get a node's children.
 *
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */
function getChildren(elem) {
    var _a;
    return (_a = elem.children) !== null && _a !== void 0 ? _a : emptyArray;
}
exports.getChildren = getChildren;
/**
 * Get a node's parent.
 *
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node.
 */
function getParent(elem) {
    return elem.parent || null;
}
exports.getParent = getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first.
 * If we don't have a parent (the element is a root node),
 * we walk the element's `prev` & `next` to get all remaining nodes.
 *
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings.
 */
function getSiblings(elem) {
    var _a, _b;
    var parent = getParent(elem);
    if (parent != null)
        return getChildren(parent);
    var siblings = [elem];
    var prev = elem.prev, next = elem.next;
    while (prev != null) {
        siblings.unshift(prev);
        (_a = prev, prev = _a.prev);
    }
    while (next != null) {
        siblings.push(next);
        (_b = next, next = _b.next);
    }
    return siblings;
}
exports.getSiblings = getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */
function getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
exports.getAttributeValue = getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */
function hasAttrib(elem, name) {
    return (elem.attribs != null &&
        Object.prototype.hasOwnProperty.call(elem.attribs, name) &&
        elem.attribs[name] != null);
}
exports.hasAttrib = hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */
function getName(elem) {
    return elem.name;
}
exports.getName = getName;
/**
 * Returns the next element sibling of a node.
 *
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag.
 */
function nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while (next !== null && !(0, domhandler_1.isTag)(next))
        (_a = next, next = _a.next);
    return next;
}
exports.nextElementSibling = nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag.
 */
function prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while (prev !== null && !(0, domhandler_1.isTag)(prev))
        (_a = prev, prev = _a.prev);
    return prev;
}
exports.prevElementSibling = prevElementSibling;


/***/ }),

/***/ 33258:
/***/ (function(module) {

var conversions = {
    // length
    'px': {
        'px': 1,
        'cm': 96.0/2.54,
        'mm': 96.0/25.4,
        'in': 96,
        'pt': 96.0/72.0,
        'pc': 16
    },
    'cm': {
        'px': 2.54/96.0,
        'cm': 1,
        'mm': 0.1,
        'in': 2.54,
        'pt': 2.54/72.0,
        'pc': 2.54/6.0
    },
    'mm': {
        'px': 25.4/96.0,
        'cm': 10,
        'mm': 1,
        'in': 25.4,
        'pt': 25.4/72.0,
        'pc': 25.4/6.0
    },
    'in': {
        'px': 1.0/96.0,
        'cm': 1.0/2.54,
        'mm': 1.0/25.4,
        'in': 1,
        'pt': 1.0/72.0,
        'pc': 1.0/6.0
    },
    'pt': {
        'px': 0.75,
        'cm': 72.0/2.54,
        'mm': 72.0/25.4,
        'in': 72,
        'pt': 1,
        'pc': 12
    },
    'pc': {
        'px': 6.0/96.0,
        'cm': 6.0/2.54,
        'mm': 6.0/25.4,
        'in': 6,
        'pt': 6.0/72.0,
        'pc': 1
    },
    // angle
    'deg': {
        'deg': 1,
        'grad': 0.9,
        'rad': 180/Math.PI,
        'turn': 360
    },
    'grad': {
        'deg': 400/360,
        'grad': 1,
        'rad': 200/Math.PI,
        'turn': 400
    },
    'rad': {
        'deg': Math.PI/180,
        'grad': Math.PI/200,
        'rad': 1,
        'turn': Math.PI*2
    },
    'turn': {
        'deg': 1/360,
        'grad': 1/400,
        'rad': 0.5/Math.PI,
        'turn': 1
    },
    // time
    's': {
        's': 1,
        'ms': 1/1000
    },
    'ms': {
        's': 1000,
        'ms': 1
    },
    // frequency
    'Hz': {
        'Hz': 1,
        'kHz': 1000
    },
    'kHz': {
        'Hz': 1/1000,
        'kHz': 1
    },
    // resolution
    'dpi': {
        'dpi': 1,
        'dpcm': 1.0/2.54,
        'dppx': 1/96
    },
    'dpcm': {
        'dpi': 2.54,
        'dpcm': 1,
        'dppx': 2.54/96.0
    },
    'dppx': {
        'dpi': 96,
        'dpcm': 96.0/2.54,
        'dppx': 1
    }
};

module.exports = function (value, sourceUnit, targetUnit, precision) {
    if (!conversions.hasOwnProperty(targetUnit))
        throw new Error("Cannot convert to " + targetUnit);

    if (!conversions[targetUnit].hasOwnProperty(sourceUnit))
        throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    
    var converted = conversions[targetUnit][sourceUnit] * value;
    
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    
    return converted;
};


/***/ }),

/***/ 67209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AttributeAction": function() { return /* reexport */ AttributeAction; },
  "IgnoreCaseMode": function() { return /* reexport */ IgnoreCaseMode; },
  "SelectorType": function() { return /* reexport */ SelectorType; },
  "isTraversal": function() { return /* reexport */ isTraversal; },
  "parse": function() { return /* reexport */ parse; },
  "stringify": function() { return /* reexport */ stringify; }
});

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/types.js
var SelectorType;
(function (SelectorType) {
    SelectorType["Attribute"] = "attribute";
    SelectorType["Pseudo"] = "pseudo";
    SelectorType["PseudoElement"] = "pseudo-element";
    SelectorType["Tag"] = "tag";
    SelectorType["Universal"] = "universal";
    // Traversals
    SelectorType["Adjacent"] = "adjacent";
    SelectorType["Child"] = "child";
    SelectorType["Descendant"] = "descendant";
    SelectorType["Parent"] = "parent";
    SelectorType["Sibling"] = "sibling";
    SelectorType["ColumnCombinator"] = "column-combinator";
})(SelectorType || (SelectorType = {}));
/**
 * Modes for ignore case.
 *
 * This could be updated to an enum, and the object is
 * the current stand-in that will allow code to be updated
 * without big changes.
 */
const IgnoreCaseMode = {
    Unknown: null,
    QuirksMode: "quirks",
    IgnoreCase: true,
    CaseSensitive: false,
};
var AttributeAction;
(function (AttributeAction) {
    AttributeAction["Any"] = "any";
    AttributeAction["Element"] = "element";
    AttributeAction["End"] = "end";
    AttributeAction["Equals"] = "equals";
    AttributeAction["Exists"] = "exists";
    AttributeAction["Hyphen"] = "hyphen";
    AttributeAction["Not"] = "not";
    AttributeAction["Start"] = "start";
})(AttributeAction || (AttributeAction = {}));

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/parse.js

const reName = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/;
const reEscape = /\\([\da-f]{1,6}\s?|(\s)|.)/gi;
const actionTypes = new Map([
    [126 /* Tilde */, AttributeAction.Element],
    [94 /* Circumflex */, AttributeAction.Start],
    [36 /* Dollar */, AttributeAction.End],
    [42 /* Asterisk */, AttributeAction.Any],
    [33 /* ExclamationMark */, AttributeAction.Not],
    [124 /* Pipe */, AttributeAction.Hyphen],
]);
// Pseudos, whose data property is parsed as well.
const unpackPseudos = new Set([
    "has",
    "not",
    "matches",
    "is",
    "where",
    "host",
    "host-context",
]);
/**
 * Checks whether a specific selector is a traversal.
 * This is useful eg. in swapping the order of elements that
 * are not traversals.
 *
 * @param selector Selector to check.
 */
function isTraversal(selector) {
    switch (selector.type) {
        case SelectorType.Adjacent:
        case SelectorType.Child:
        case SelectorType.Descendant:
        case SelectorType.Parent:
        case SelectorType.Sibling:
        case SelectorType.ColumnCombinator:
            return true;
        default:
            return false;
    }
}
const stripQuotesFromPseudos = new Set(["contains", "icontains"]);
// Unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L152
function funescape(_, escaped, escapedWhitespace) {
    const high = parseInt(escaped, 16) - 0x10000;
    // NaN means non-codepoint
    return high !== high || escapedWhitespace
        ? escaped
        : high < 0
            ? // BMP codepoint
                String.fromCharCode(high + 0x10000)
            : // Supplemental Plane codepoint (surrogate pair)
                String.fromCharCode((high >> 10) | 0xd800, (high & 0x3ff) | 0xdc00);
}
function unescapeCSS(str) {
    return str.replace(reEscape, funescape);
}
function isQuote(c) {
    return c === 39 /* SingleQuote */ || c === 34 /* DoubleQuote */;
}
function isWhitespace(c) {
    return (c === 32 /* Space */ ||
        c === 9 /* Tab */ ||
        c === 10 /* NewLine */ ||
        c === 12 /* FormFeed */ ||
        c === 13 /* CarriageReturn */);
}
/**
 * Parses `selector`, optionally with the passed `options`.
 *
 * @param selector Selector to parse.
 * @param options Options for parsing.
 * @returns Returns a two-dimensional array.
 * The first dimension represents selectors separated by commas (eg. `sub1, sub2`),
 * the second contains the relevant tokens for that selector.
 */
function parse(selector) {
    const subselects = [];
    const endIndex = parseSelector(subselects, `${selector}`, 0);
    if (endIndex < selector.length) {
        throw new Error(`Unmatched selector: ${selector.slice(endIndex)}`);
    }
    return subselects;
}
function parseSelector(subselects, selector, selectorIndex) {
    let tokens = [];
    function getName(offset) {
        const match = selector.slice(selectorIndex + offset).match(reName);
        if (!match) {
            throw new Error(`Expected name, found ${selector.slice(selectorIndex)}`);
        }
        const [name] = match;
        selectorIndex += offset + name.length;
        return unescapeCSS(name);
    }
    function stripWhitespace(offset) {
        selectorIndex += offset;
        while (selectorIndex < selector.length &&
            isWhitespace(selector.charCodeAt(selectorIndex))) {
            selectorIndex++;
        }
    }
    function readValueWithParenthesis() {
        selectorIndex += 1;
        const start = selectorIndex;
        let counter = 1;
        for (; counter > 0 && selectorIndex < selector.length; selectorIndex++) {
            if (selector.charCodeAt(selectorIndex) ===
                40 /* LeftParenthesis */ &&
                !isEscaped(selectorIndex)) {
                counter++;
            }
            else if (selector.charCodeAt(selectorIndex) ===
                41 /* RightParenthesis */ &&
                !isEscaped(selectorIndex)) {
                counter--;
            }
        }
        if (counter) {
            throw new Error("Parenthesis not matched");
        }
        return unescapeCSS(selector.slice(start, selectorIndex - 1));
    }
    function isEscaped(pos) {
        let slashCount = 0;
        while (selector.charCodeAt(--pos) === 92 /* BackSlash */)
            slashCount++;
        return (slashCount & 1) === 1;
    }
    function ensureNotTraversal() {
        if (tokens.length > 0 && isTraversal(tokens[tokens.length - 1])) {
            throw new Error("Did not expect successive traversals.");
        }
    }
    function addTraversal(type) {
        if (tokens.length > 0 &&
            tokens[tokens.length - 1].type === SelectorType.Descendant) {
            tokens[tokens.length - 1].type = type;
            return;
        }
        ensureNotTraversal();
        tokens.push({ type });
    }
    function addSpecialAttribute(name, action) {
        tokens.push({
            type: SelectorType.Attribute,
            name,
            action,
            value: getName(1),
            namespace: null,
            ignoreCase: "quirks",
        });
    }
    /**
     * We have finished parsing the current part of the selector.
     *
     * Remove descendant tokens at the end if they exist,
     * and return the last index, so that parsing can be
     * picked up from here.
     */
    function finalizeSubselector() {
        if (tokens.length &&
            tokens[tokens.length - 1].type === SelectorType.Descendant) {
            tokens.pop();
        }
        if (tokens.length === 0) {
            throw new Error("Empty sub-selector");
        }
        subselects.push(tokens);
    }
    stripWhitespace(0);
    if (selector.length === selectorIndex) {
        return selectorIndex;
    }
    loop: while (selectorIndex < selector.length) {
        const firstChar = selector.charCodeAt(selectorIndex);
        switch (firstChar) {
            // Whitespace
            case 32 /* Space */:
            case 9 /* Tab */:
            case 10 /* NewLine */:
            case 12 /* FormFeed */:
            case 13 /* CarriageReturn */: {
                if (tokens.length === 0 ||
                    tokens[0].type !== SelectorType.Descendant) {
                    ensureNotTraversal();
                    tokens.push({ type: SelectorType.Descendant });
                }
                stripWhitespace(1);
                break;
            }
            // Traversals
            case 62 /* GreaterThan */: {
                addTraversal(SelectorType.Child);
                stripWhitespace(1);
                break;
            }
            case 60 /* LessThan */: {
                addTraversal(SelectorType.Parent);
                stripWhitespace(1);
                break;
            }
            case 126 /* Tilde */: {
                addTraversal(SelectorType.Sibling);
                stripWhitespace(1);
                break;
            }
            case 43 /* Plus */: {
                addTraversal(SelectorType.Adjacent);
                stripWhitespace(1);
                break;
            }
            // Special attribute selectors: .class, #id
            case 46 /* Period */: {
                addSpecialAttribute("class", AttributeAction.Element);
                break;
            }
            case 35 /* Hash */: {
                addSpecialAttribute("id", AttributeAction.Equals);
                break;
            }
            case 91 /* LeftSquareBracket */: {
                stripWhitespace(1);
                // Determine attribute name and namespace
                let name;
                let namespace = null;
                if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */) {
                    // Equivalent to no namespace
                    name = getName(1);
                }
                else if (selector.startsWith("*|", selectorIndex)) {
                    namespace = "*";
                    name = getName(2);
                }
                else {
                    name = getName(0);
                    if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ &&
                        selector.charCodeAt(selectorIndex + 1) !==
                            61 /* Equal */) {
                        namespace = name;
                        name = getName(1);
                    }
                }
                stripWhitespace(0);
                // Determine comparison operation
                let action = AttributeAction.Exists;
                const possibleAction = actionTypes.get(selector.charCodeAt(selectorIndex));
                if (possibleAction) {
                    action = possibleAction;
                    if (selector.charCodeAt(selectorIndex + 1) !==
                        61 /* Equal */) {
                        throw new Error("Expected `=`");
                    }
                    stripWhitespace(2);
                }
                else if (selector.charCodeAt(selectorIndex) === 61 /* Equal */) {
                    action = AttributeAction.Equals;
                    stripWhitespace(1);
                }
                // Determine value
                let value = "";
                let ignoreCase = null;
                if (action !== "exists") {
                    if (isQuote(selector.charCodeAt(selectorIndex))) {
                        const quote = selector.charCodeAt(selectorIndex);
                        let sectionEnd = selectorIndex + 1;
                        while (sectionEnd < selector.length &&
                            (selector.charCodeAt(sectionEnd) !== quote ||
                                isEscaped(sectionEnd))) {
                            sectionEnd += 1;
                        }
                        if (selector.charCodeAt(sectionEnd) !== quote) {
                            throw new Error("Attribute value didn't end");
                        }
                        value = unescapeCSS(selector.slice(selectorIndex + 1, sectionEnd));
                        selectorIndex = sectionEnd + 1;
                    }
                    else {
                        const valueStart = selectorIndex;
                        while (selectorIndex < selector.length &&
                            ((!isWhitespace(selector.charCodeAt(selectorIndex)) &&
                                selector.charCodeAt(selectorIndex) !==
                                    93 /* RightSquareBracket */) ||
                                isEscaped(selectorIndex))) {
                            selectorIndex += 1;
                        }
                        value = unescapeCSS(selector.slice(valueStart, selectorIndex));
                    }
                    stripWhitespace(0);
                    // See if we have a force ignore flag
                    const forceIgnore = selector.charCodeAt(selectorIndex) | 0x20;
                    // If the forceIgnore flag is set (either `i` or `s`), use that value
                    if (forceIgnore === 115 /* LowerS */) {
                        ignoreCase = false;
                        stripWhitespace(1);
                    }
                    else if (forceIgnore === 105 /* LowerI */) {
                        ignoreCase = true;
                        stripWhitespace(1);
                    }
                }
                if (selector.charCodeAt(selectorIndex) !==
                    93 /* RightSquareBracket */) {
                    throw new Error("Attribute selector didn't terminate");
                }
                selectorIndex += 1;
                const attributeSelector = {
                    type: SelectorType.Attribute,
                    name,
                    action,
                    value,
                    namespace,
                    ignoreCase,
                };
                tokens.push(attributeSelector);
                break;
            }
            case 58 /* Colon */: {
                if (selector.charCodeAt(selectorIndex + 1) === 58 /* Colon */) {
                    tokens.push({
                        type: SelectorType.PseudoElement,
                        name: getName(2).toLowerCase(),
                        data: selector.charCodeAt(selectorIndex) ===
                            40 /* LeftParenthesis */
                            ? readValueWithParenthesis()
                            : null,
                    });
                    continue;
                }
                const name = getName(1).toLowerCase();
                let data = null;
                if (selector.charCodeAt(selectorIndex) ===
                    40 /* LeftParenthesis */) {
                    if (unpackPseudos.has(name)) {
                        if (isQuote(selector.charCodeAt(selectorIndex + 1))) {
                            throw new Error(`Pseudo-selector ${name} cannot be quoted`);
                        }
                        data = [];
                        selectorIndex = parseSelector(data, selector, selectorIndex + 1);
                        if (selector.charCodeAt(selectorIndex) !==
                            41 /* RightParenthesis */) {
                            throw new Error(`Missing closing parenthesis in :${name} (${selector})`);
                        }
                        selectorIndex += 1;
                    }
                    else {
                        data = readValueWithParenthesis();
                        if (stripQuotesFromPseudos.has(name)) {
                            const quot = data.charCodeAt(0);
                            if (quot === data.charCodeAt(data.length - 1) &&
                                isQuote(quot)) {
                                data = data.slice(1, -1);
                            }
                        }
                        data = unescapeCSS(data);
                    }
                }
                tokens.push({ type: SelectorType.Pseudo, name, data });
                break;
            }
            case 44 /* Comma */: {
                finalizeSubselector();
                tokens = [];
                stripWhitespace(1);
                break;
            }
            default: {
                if (selector.startsWith("/*", selectorIndex)) {
                    const endIndex = selector.indexOf("*/", selectorIndex + 2);
                    if (endIndex < 0) {
                        throw new Error("Comment was not terminated");
                    }
                    selectorIndex = endIndex + 2;
                    // Remove leading whitespace
                    if (tokens.length === 0) {
                        stripWhitespace(0);
                    }
                    break;
                }
                let namespace = null;
                let name;
                if (firstChar === 42 /* Asterisk */) {
                    selectorIndex += 1;
                    name = "*";
                }
                else if (firstChar === 124 /* Pipe */) {
                    name = "";
                    if (selector.charCodeAt(selectorIndex + 1) === 124 /* Pipe */) {
                        addTraversal(SelectorType.ColumnCombinator);
                        stripWhitespace(2);
                        break;
                    }
                }
                else if (reName.test(selector.slice(selectorIndex))) {
                    name = getName(0);
                }
                else {
                    break loop;
                }
                if (selector.charCodeAt(selectorIndex) === 124 /* Pipe */ &&
                    selector.charCodeAt(selectorIndex + 1) !== 124 /* Pipe */) {
                    namespace = name;
                    if (selector.charCodeAt(selectorIndex + 1) ===
                        42 /* Asterisk */) {
                        name = "*";
                        selectorIndex += 2;
                    }
                    else {
                        name = getName(1);
                    }
                }
                tokens.push(name === "*"
                    ? { type: SelectorType.Universal, namespace }
                    : { type: SelectorType.Tag, name, namespace });
            }
        }
    }
    finalizeSubselector();
    return selectorIndex;
}

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/stringify.js

const attribValChars = ["\\", '"'];
const pseudoValChars = [...attribValChars, "(", ")"];
const charsToEscapeInAttributeValue = new Set(attribValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInPseudoValue = new Set(pseudoValChars.map((c) => c.charCodeAt(0)));
const charsToEscapeInName = new Set([
    ...pseudoValChars,
    "~",
    "^",
    "$",
    "*",
    "+",
    "!",
    "|",
    ":",
    "[",
    "]",
    " ",
    ".",
].map((c) => c.charCodeAt(0)));
/**
 * Turns `selector` back into a string.
 *
 * @param selector Selector to stringify.
 */
function stringify(selector) {
    return selector
        .map((token) => token.map(stringifyToken).join(""))
        .join(", ");
}
function stringifyToken(token, index, arr) {
    switch (token.type) {
        // Simple types
        case SelectorType.Child:
            return index === 0 ? "> " : " > ";
        case SelectorType.Parent:
            return index === 0 ? "< " : " < ";
        case SelectorType.Sibling:
            return index === 0 ? "~ " : " ~ ";
        case SelectorType.Adjacent:
            return index === 0 ? "+ " : " + ";
        case SelectorType.Descendant:
            return " ";
        case SelectorType.ColumnCombinator:
            return index === 0 ? "|| " : " || ";
        case SelectorType.Universal:
            // Return an empty string if the selector isn't needed.
            return token.namespace === "*" &&
                index + 1 < arr.length &&
                "name" in arr[index + 1]
                ? ""
                : `${getNamespace(token.namespace)}*`;
        case SelectorType.Tag:
            return getNamespacedName(token);
        case SelectorType.PseudoElement:
            return `::${escapeName(token.name, charsToEscapeInName)}${token.data === null
                ? ""
                : `(${escapeName(token.data, charsToEscapeInPseudoValue)})`}`;
        case SelectorType.Pseudo:
            return `:${escapeName(token.name, charsToEscapeInName)}${token.data === null
                ? ""
                : `(${typeof token.data === "string"
                    ? escapeName(token.data, charsToEscapeInPseudoValue)
                    : stringify(token.data)})`}`;
        case SelectorType.Attribute: {
            if (token.name === "id" &&
                token.action === AttributeAction.Equals &&
                token.ignoreCase === "quirks" &&
                !token.namespace) {
                return `#${escapeName(token.value, charsToEscapeInName)}`;
            }
            if (token.name === "class" &&
                token.action === AttributeAction.Element &&
                token.ignoreCase === "quirks" &&
                !token.namespace) {
                return `.${escapeName(token.value, charsToEscapeInName)}`;
            }
            const name = getNamespacedName(token);
            if (token.action === AttributeAction.Exists) {
                return `[${name}]`;
            }
            return `[${name}${getActionValue(token.action)}="${escapeName(token.value, charsToEscapeInAttributeValue)}"${token.ignoreCase === null ? "" : token.ignoreCase ? " i" : " s"}]`;
        }
    }
}
function getActionValue(action) {
    switch (action) {
        case AttributeAction.Equals:
            return "";
        case AttributeAction.Element:
            return "~";
        case AttributeAction.Start:
            return "^";
        case AttributeAction.End:
            return "$";
        case AttributeAction.Any:
            return "*";
        case AttributeAction.Not:
            return "!";
        case AttributeAction.Hyphen:
            return "|";
        case AttributeAction.Exists:
            throw new Error("Shouldn't be here");
    }
}
function getNamespacedName(token) {
    return `${getNamespace(token.namespace)}${escapeName(token.name, charsToEscapeInName)}`;
}
function getNamespace(namespace) {
    return namespace !== null
        ? `${namespace === "*"
            ? "*"
            : escapeName(namespace, charsToEscapeInName)}|`
        : "";
}
function escapeName(str, charsToEscape) {
    let lastIdx = 0;
    let ret = "";
    for (let i = 0; i < str.length; i++) {
        if (charsToEscape.has(str.charCodeAt(i))) {
            ret += `${str.slice(lastIdx, i)}\\${str.charAt(i)}`;
            lastIdx = i + 1;
        }
    }
    return ret.length > 0 ? ret + str.slice(lastIdx) : str;
}

;// CONCATENATED MODULE: ./node_modules/css-what/lib/es/index.js





/***/ }),

/***/ 9996:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 44076:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeHTML = exports.decodeHTMLStrict = exports.decodeXML = void 0;
var entities_json_1 = __importDefault(__webpack_require__(59323));
var legacy_json_1 = __importDefault(__webpack_require__(29591));
var xml_json_1 = __importDefault(__webpack_require__(2586));
var decode_codepoint_1 = __importDefault(__webpack_require__(26));
var strictEntityRe = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
exports.decodeXML = getStrictDecoder(xml_json_1.default);
exports.decodeHTMLStrict = getStrictDecoder(entities_json_1.default);
function getStrictDecoder(map) {
    var replace = getReplacer(map);
    return function (str) { return String(str).replace(strictEntityRe, replace); };
}
var sorter = function (a, b) { return (a < b ? 1 : -1); };
exports.decodeHTML = (function () {
    var legacy = Object.keys(legacy_json_1.default).sort(sorter);
    var keys = Object.keys(entities_json_1.default).sort(sorter);
    for (var i = 0, j = 0; i < keys.length; i++) {
        if (legacy[j] === keys[i]) {
            keys[i] += ";?";
            j++;
        }
        else {
            keys[i] += ";";
        }
    }
    var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g");
    var replace = getReplacer(entities_json_1.default);
    function replacer(str) {
        if (str.substr(-1) !== ";")
            str += ";";
        return replace(str);
    }
    // TODO consider creating a merged map
    return function (str) { return String(str).replace(re, replacer); };
})();
function getReplacer(map) {
    return function replace(str) {
        if (str.charAt(1) === "#") {
            var secondChar = str.charAt(2);
            if (secondChar === "X" || secondChar === "x") {
                return decode_codepoint_1.default(parseInt(str.substr(3), 16));
            }
            return decode_codepoint_1.default(parseInt(str.substr(2), 10));
        }
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        return map[str.slice(1, -1)] || str;
    };
}


/***/ }),

/***/ 26:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var decode_json_1 = __importDefault(__webpack_require__(33600));
// Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
var fromCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    if (codePoint in decode_json_1.default) {
        codePoint = decode_json_1.default[codePoint];
    }
    return fromCodePoint(codePoint);
}
exports["default"] = decodeCodePoint;


/***/ }),

/***/ 87322:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = void 0;
var xml_json_1 = __importDefault(__webpack_require__(2586));
var inverseXML = getInverseObj(xml_json_1.default);
var xmlReplacer = getInverseReplacer(inverseXML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeXML = getASCIIEncoder(inverseXML);
var entities_json_1 = __importDefault(__webpack_require__(59323));
var inverseHTML = getInverseObj(entities_json_1.default);
var htmlReplacer = getInverseReplacer(inverseHTML);
/**
 * Encodes all entities and non-ASCII characters in the input.
 *
 * This includes characters that are valid ASCII characters in HTML documents.
 * For example `#` will be encoded as `&num;`. To get a more compact output,
 * consider using the `encodeNonAsciiHTML` function.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeHTML = getInverse(inverseHTML, htmlReplacer);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */
exports.encodeNonAsciiHTML = getASCIIEncoder(inverseHTML);
function getInverseObj(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (inverse, name) {
        inverse[obj[name]] = "&" + name + ";";
        return inverse;
    }, {});
}
function getInverseReplacer(inverse) {
    var single = [];
    var multiple = [];
    for (var _i = 0, _a = Object.keys(inverse); _i < _a.length; _i++) {
        var k = _a[_i];
        if (k.length === 1) {
            // Add value to single array
            single.push("\\" + k);
        }
        else {
            // Add value to multiple array
            multiple.push(k);
        }
    }
    // Add ranges to single characters.
    single.sort();
    for (var start = 0; start < single.length - 1; start++) {
        // Find the end of a run of characters
        var end = start;
        while (end < single.length - 1 &&
            single[end].charCodeAt(1) + 1 === single[end + 1].charCodeAt(1)) {
            end += 1;
        }
        var count = 1 + end - start;
        // We want to replace at least three characters
        if (count < 3)
            continue;
        single.splice(start, count, single[start] + "-" + single[end]);
    }
    multiple.unshift("[" + single.join("") + "]");
    return new RegExp(multiple.join("|"), "g");
}
// /[^\0-\x7F]/gu
var reNonASCII = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g;
var getCodePoint = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        function (str) { return str.codePointAt(0); }
    : // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        function (c) {
            return (c.charCodeAt(0) - 0xd800) * 0x400 +
                c.charCodeAt(1) -
                0xdc00 +
                0x10000;
        };
function singleCharReplacer(c) {
    return "&#x" + (c.length > 1 ? getCodePoint(c) : c.charCodeAt(0))
        .toString(16)
        .toUpperCase() + ";";
}
function getInverse(inverse, re) {
    return function (data) {
        return data
            .replace(re, function (name) { return inverse[name]; })
            .replace(reNonASCII, singleCharReplacer);
    };
}
var reEscapeChars = new RegExp(xmlReplacer.source + "|" + reNonASCII.source, "g");
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */
function escape(data) {
    return data.replace(reEscapeChars, singleCharReplacer);
}
exports.escape = escape;
/**
 * Encodes all characters not valid in XML documents using numeric hexadecimal
 * reference (eg. `&#xfc;`).
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */
function escapeUTF8(data) {
    return data.replace(xmlReplacer, singleCharReplacer);
}
exports.escapeUTF8 = escapeUTF8;
function getASCIIEncoder(obj) {
    return function (data) {
        return data.replace(reEscapeChars, function (c) { return obj[c] || singleCharReplacer(c); });
    };
}


/***/ }),

/***/ 45863:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodeXMLStrict = exports.decodeHTML5Strict = exports.decodeHTML4Strict = exports.decodeHTML5 = exports.decodeHTML4 = exports.decodeHTMLStrict = exports.decodeHTML = exports.decodeXML = exports.encodeHTML5 = exports.encodeHTML4 = exports.escapeUTF8 = exports.escape = exports.encodeNonAsciiHTML = exports.encodeHTML = exports.encodeXML = exports.encode = exports.decodeStrict = exports.decode = void 0;
var decode_1 = __webpack_require__(44076);
var encode_1 = __webpack_require__(87322);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeXML` or `decodeHTML` directly.
 */
function decode(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTML)(data);
}
exports.decode = decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param level Optional level to decode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `decodeHTMLStrict` or `decodeXML` directly.
 */
function decodeStrict(data, level) {
    return (!level || level <= 0 ? decode_1.decodeXML : decode_1.decodeHTMLStrict)(data);
}
exports.decodeStrict = decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param level Optional level to encode at. 0 = XML, 1 = HTML. Default is 0.
 * @deprecated Use `encodeHTML`, `encodeXML` or `encodeNonAsciiHTML` directly.
 */
function encode(data, level) {
    return (!level || level <= 0 ? encode_1.encodeXML : encode_1.encodeHTML)(data);
}
exports.encode = encode;
var encode_2 = __webpack_require__(87322);
Object.defineProperty(exports, "encodeXML", ({ enumerable: true, get: function () { return encode_2.encodeXML; } }));
Object.defineProperty(exports, "encodeHTML", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeNonAsciiHTML", ({ enumerable: true, get: function () { return encode_2.encodeNonAsciiHTML; } }));
Object.defineProperty(exports, "escape", ({ enumerable: true, get: function () { return encode_2.escape; } }));
Object.defineProperty(exports, "escapeUTF8", ({ enumerable: true, get: function () { return encode_2.escapeUTF8; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "encodeHTML4", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
Object.defineProperty(exports, "encodeHTML5", ({ enumerable: true, get: function () { return encode_2.encodeHTML; } }));
var decode_2 = __webpack_require__(44076);
Object.defineProperty(exports, "decodeXML", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));
Object.defineProperty(exports, "decodeHTML", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
// Legacy aliases (deprecated)
Object.defineProperty(exports, "decodeHTML4", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML5", ({ enumerable: true, get: function () { return decode_2.decodeHTML; } }));
Object.defineProperty(exports, "decodeHTML4Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeHTML5Strict", ({ enumerable: true, get: function () { return decode_2.decodeHTMLStrict; } }));
Object.defineProperty(exports, "decodeXMLStrict", ({ enumerable: true, get: function () { return decode_2.decodeXML; } }));


/***/ }),

/***/ 58875:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 35202:
/***/ (function() {

(function (global, factory) {
   true ? factory() :
  0;
}(this, (function () { 'use strict';

  /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */
  function applyFocusVisiblePolyfill(scope) {
    var hadKeyboardEvent = true;
    var hadFocusVisibleRecently = false;
    var hadFocusVisibleRecentlyTimeout = null;

    var inputTypesAllowlist = {
      text: true,
      search: true,
      url: true,
      tel: true,
      email: true,
      password: true,
      number: true,
      date: true,
      month: true,
      week: true,
      time: true,
      datetime: true,
      'datetime-local': true
    };

    /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */
    function isValidFocusTarget(el) {
      if (
        el &&
        el !== document &&
        el.nodeName !== 'HTML' &&
        el.nodeName !== 'BODY' &&
        'classList' in el &&
        'contains' in el.classList
      ) {
        return true;
      }
      return false;
    }

    /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */
    function focusTriggersKeyboardModality(el) {
      var type = el.type;
      var tagName = el.tagName;

      if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
        return true;
      }

      if (tagName === 'TEXTAREA' && !el.readOnly) {
        return true;
      }

      if (el.isContentEditable) {
        return true;
      }

      return false;
    }

    /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */
    function addFocusVisibleClass(el) {
      if (el.classList.contains('focus-visible')) {
        return;
      }
      el.classList.add('focus-visible');
      el.setAttribute('data-focus-visible-added', '');
    }

    /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */
    function removeFocusVisibleClass(el) {
      if (!el.hasAttribute('data-focus-visible-added')) {
        return;
      }
      el.classList.remove('focus-visible');
      el.removeAttribute('data-focus-visible-added');
    }

    /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */
    function onKeyDown(e) {
      if (e.metaKey || e.altKey || e.ctrlKey) {
        return;
      }

      if (isValidFocusTarget(scope.activeElement)) {
        addFocusVisibleClass(scope.activeElement);
      }

      hadKeyboardEvent = true;
    }

    /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */
    function onPointerDown(e) {
      hadKeyboardEvent = false;
    }

    /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */
    function onFocus(e) {
      // Prevent IE from focusing the document or HTML element.
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
        addFocusVisibleClass(e.target);
      }
    }

    /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */
    function onBlur(e) {
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (
        e.target.classList.contains('focus-visible') ||
        e.target.hasAttribute('data-focus-visible-added')
      ) {
        // To detect a tab/window switch, we look for a blur event followed
        // rapidly by a visibility change.
        // If we don't see a visibility change within 100ms, it's probably a
        // regular focus change.
        hadFocusVisibleRecently = true;
        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
        hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
          hadFocusVisibleRecently = false;
        }, 100);
        removeFocusVisibleClass(e.target);
      }
    }

    /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */
    function onVisibilityChange(e) {
      if (document.visibilityState === 'hidden') {
        // If the tab becomes active again, the browser will handle calling focus
        // on the element (Safari actually calls it twice).
        // If this tab change caused a blur on an element with focus-visible,
        // re-apply the class when the user switches back to the tab.
        if (hadFocusVisibleRecently) {
          hadKeyboardEvent = true;
        }
        addInitialPointerMoveListeners();
      }
    }

    /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */
    function addInitialPointerMoveListeners() {
      document.addEventListener('mousemove', onInitialPointerMove);
      document.addEventListener('mousedown', onInitialPointerMove);
      document.addEventListener('mouseup', onInitialPointerMove);
      document.addEventListener('pointermove', onInitialPointerMove);
      document.addEventListener('pointerdown', onInitialPointerMove);
      document.addEventListener('pointerup', onInitialPointerMove);
      document.addEventListener('touchmove', onInitialPointerMove);
      document.addEventListener('touchstart', onInitialPointerMove);
      document.addEventListener('touchend', onInitialPointerMove);
    }

    function removeInitialPointerMoveListeners() {
      document.removeEventListener('mousemove', onInitialPointerMove);
      document.removeEventListener('mousedown', onInitialPointerMove);
      document.removeEventListener('mouseup', onInitialPointerMove);
      document.removeEventListener('pointermove', onInitialPointerMove);
      document.removeEventListener('pointerdown', onInitialPointerMove);
      document.removeEventListener('pointerup', onInitialPointerMove);
      document.removeEventListener('touchmove', onInitialPointerMove);
      document.removeEventListener('touchstart', onInitialPointerMove);
      document.removeEventListener('touchend', onInitialPointerMove);
    }

    /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */
    function onInitialPointerMove(e) {
      // Work around a Safari quirk that fires a mousemove on <html> whenever the
      // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
      if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
        return;
      }

      hadKeyboardEvent = false;
      removeInitialPointerMoveListeners();
    }

    // For some kinds of state, we are interested in changes at the global scope
    // only. For example, global pointer input, global key presses and global
    // visibility change should affect the state at every scope:
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousedown', onPointerDown, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('touchstart', onPointerDown, true);
    document.addEventListener('visibilitychange', onVisibilityChange, true);

    addInitialPointerMoveListeners();

    // For focus and blur, we specifically care about state changes in the local
    // scope. This is because focus / blur events that originate from within a
    // shadow root are not re-dispatched from the host element if it was already
    // the active element in its own scope:
    scope.addEventListener('focus', onFocus, true);
    scope.addEventListener('blur', onBlur, true);

    // We detect that a node is a ShadowRoot by ensuring that it is a
    // DocumentFragment and also has a host property. This check covers native
    // implementation and polyfill implementation transparently. If we only cared
    // about the native implementation, we could just check if the scope was
    // an instance of a ShadowRoot.
    if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
      // Since a ShadowRoot is a special kind of DocumentFragment, it does not
      // have a root element to add a class to. So, we add this attribute to the
      // host element instead:
      scope.host.setAttribute('data-js-focus-visible', '');
    } else if (scope.nodeType === Node.DOCUMENT_NODE) {
      document.documentElement.classList.add('js-focus-visible');
      document.documentElement.setAttribute('data-js-focus-visible', '');
    }
  }

  // It is important to wrap all references to global window and document in
  // these checks to support server-side rendering use cases
  // @see https://github.com/WICG/focus-visible/issues/199
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Make the polyfill helper globally available. This can be used as a signal
    // to interested libraries that wish to coordinate with the polyfill for e.g.,
    // applying the polyfill to a shadow root:
    window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

    // Notify interested libraries of the polyfill's presence, in case the
    // polyfill was loaded lazily:
    var event;

    try {
      event = new CustomEvent('focus-visible-polyfill-ready');
    } catch (error) {
      // IE11 does not support using CustomEvent as a constructor directly:
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
    }

    window.dispatchEvent(event);
  }

  if (typeof document !== 'undefined') {
    // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
  }

})));


/***/ }),

/***/ 46431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


Object.defineProperty(exports, "__esModule", ({ value: true }));

var React = __webpack_require__(67294);
var heyListen = __webpack_require__(24394);
var dom = __webpack_require__(34320);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

/**
 * @public
 */
const MotionConfigContext = React.createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

const MotionContext = React.createContext({});
function useVisualElementContext() {
    return React.useContext(MotionContext).visualElement;
}

/**
 * @public
 */
const PresenceContext = React.createContext(null);

const isBrowser = typeof document !== "undefined";

const useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

const LazyContext = React.createContext({ strict: false });

function useVisualElement(Component, visualState, props, createVisualElement) {
    const parent = useVisualElementContext();
    const lazyContext = React.useContext(LazyContext);
    const presenceContext = React.useContext(PresenceContext);
    const reducedMotionConfig = React.useContext(MotionConfigContext).reducedMotion;
    const visualElementRef = React.useRef();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */
    createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceId: presenceContext ? presenceContext.id : undefined,
            blockInitialAnimation: presenceContext
                ? presenceContext.initial === false
                : false,
            reducedMotionConfig,
        });
    }
    const visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(() => {
        visualElement && visualElement.render();
    });
    /**
     * If we have optimised appear animations to handoff from, trigger animateChanges
     * from a synchronous useLayoutEffect to ensure there's no flash of incorrectly
     * styled component in the event of a hydration error.
     */
    useIsomorphicLayoutEffect(() => {
        if (visualElement && visualElement.animationState) {
            visualElement.animationState.animateChanges();
        }
    });
    useIsomorphicLayoutEffect(() => () => visualElement && visualElement.notify("Unmount"), []);
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */
function useMotionRef(visualState, visualElement, externalRef) {
    return React.useCallback((instance) => {
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    }, 
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [visualElement]);
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

const variantProps$1 = [
    "initial",
    "animate",
    "exit",
    "whileHover",
    "whileDrag",
    "whileTap",
    "whileFocus",
    "whileInView",
];
function isControllingVariants(props) {
    return (isAnimationControls(props.animate) ||
        variantProps$1.some((name) => isVariantLabel(props[name])));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (isControllingVariants(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    const { initial, animate } = getCurrentTreeVariants(props, React.useContext(MotionContext));
    return React.useMemo(() => ({ initial, animate }), [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

const createDefinition = (propNames) => ({
    isEnabled: (props) => propNames.some((name) => !!props[name]),
});
const featureDefinitions = {
    measureLayout: createDefinition(["layout", "layoutId", "drag"]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave",
    ]),
};

function loadFeatures(features) {
    for (const key in features) {
        if (key === "projectionNodeConstructor") {
            featureDefinitions.projectionNodeConstructor = features[key];
        }
        else {
            featureDefinitions[key].Component = features[key];
        }
    }
}

/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */
function useConstant(init) {
    const ref = React.useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */
    hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */
    hasEverUpdated: false,
};

let id$2 = 1;
function useProjectionId() {
    return useConstant(() => {
        if (globalProjectionState.hasEverUpdated) {
            return id$2++;
        }
    });
}

const LayoutGroupContext = React.createContext({});

class VisualElementHandler extends React__default["default"].Component {
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */
    getSnapshotBeforeUpdate() {
        const { visualElement, props } = this.props;
        if (visualElement)
            visualElement.setProps(props);
        return null;
    }
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = React.createContext({});

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */
function createMotionComponent({ preloadedFeatures, createVisualElement, projectionNodeConstructor, useRender, useVisualState, Component, }) {
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        const configAndProps = {
            ...React.useContext(MotionConfigContext),
            ...props,
            layoutId: useLayoutId(props),
        };
        const { isStatic } = configAndProps;
        let features = null;
        const context = useCreateMotionContext(props);
        /**
         * Create a unique projection ID for this component. If a new component is added
         * during a layout animation we'll use this to query the DOM and hydrate its ref early, allowing
         * us to measure it as soon as any layout effect flushes pending layout animations.
         *
         * Performance note: It'd be better not to have to search the DOM for these elements.
         * For newly-entering components it could be enough to only correct treeScale, in which
         * case we could mount in a scale-correction mode. This wouldn't be enough for
         * shared element transitions however. Perhaps for those we could revert to a root node
         * that gets forceRendered and layout animations are triggered on its layout effect.
         */
        const projectionId = isStatic ? undefined : useProjectionId();
        /**
         *
         */
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && isBrowser) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */
            context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */
            const lazyStrictMode = React.useContext(LazyContext).strict;
            const initialLayoutGroupConfig = React.useContext(SwitchLayoutGroupContext);
            if (context.visualElement) {
                features = context.visualElement.loadFeatures(
                // Note: Pass the full new combined props to correctly re-render dynamic feature components.
                configAndProps, lazyStrictMode, preloadedFeatures, projectionId, projectionNodeConstructor ||
                    featureDefinitions.projectionNodeConstructor, initialLayoutGroupConfig);
            }
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */
        return (React__namespace.createElement(VisualElementHandler, { visualElement: context.visualElement, props: configAndProps },
            features,
            React__namespace.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement))));
    }
    const ForwardRefComponent = React.forwardRef(MotionComponent);
    ForwardRefComponent[motionComponentSymbol] = Component;
    return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = React.useContext(LayoutGroupContext).id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */
function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */
    const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */
        get: (_target, key) => {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof Component !== "string" ||
        /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */
        Component.includes("-")) {
        return false;
    }
    else if (
    /**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /**
         * If it contains a capital letter, it's an SVG component
         */
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

const scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
];
/**
 * A quick lookup for transform props.
 */
const transformProps = new Set(transformPropOrder);

function isForcedMotionValue(key, { layout, layoutId }) {
    return (transformProps.has(key) ||
        key.startsWith("origin") ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

const isMotionValue = (value) => !!(value === null || value === void 0 ? void 0 : value.getVelocity);

const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */
const sortTransformProps = (a, b) => transformPropOrder.indexOf(a) - transformPropOrder.indexOf(b);
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform({ transform, transformKeys, }, { enableHardwareAcceleration = true, allowTransformNone = true, }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort(sortTransformProps);
    // Loop over each transform and build them into transformString
    for (const key of transformKeys) {
        transformString += `${translateAlias[key] || key}(${transform[key]}) `;
    }
    if (enableHardwareAcceleration && !transform.z) {
        transformString += "translateZ(0)";
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}

/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable$1(key) {
    return key.startsWith("--");
}

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
const getValueAsType = (value, type) => {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

const number = {
    test: (v) => typeof v === "number",
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = {
    ...number,
    transform: (v) => clamp(0, 1, v),
};
const scale = {
    ...number,
    default: 1,
};

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
const sanitize = (v) => Math.round(v * 100000) / 100000;
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
    return typeof v === "string";
}

const createUnitType = (unit) => ({
    test: (v) => isString(v) && v.endsWith(unit) && v.split(" ").length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType("deg");
const percent = createUnitType("%");
const px = createUnitType("px");
const vh = createUnitType("vh");
const vw = createUnitType("vw");
const progressPercentage = {
    ...percent,
    parse: (v) => percent.parse(v) / 100,
    transform: (v) => percent.transform(v * 100),
};

const int = {
    ...number,
    transform: Math.round,
};

const numberValueTypes = {
    // Border props
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    // Positioning props
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    // Spacing props
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    // Transform props
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    // Misc
    zIndex: int,
    // SVG
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int,
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    const { style, vars, transform, transformKeys, transformOrigin } = state;
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */
    for (const key in latestValues) {
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */
        if (isCSSVariable$1(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = numberValueTypes[key];
        const valueAsType = getValueAsType(value, valueType);
        if (transformProps.has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone)
                continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0))
                transformIsNone = false;
        }
        else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) {
            style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
        }
        else if (style.transform) {
            /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */
            style.transform = "none";
        }
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */
    if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0, } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

const createHtmlRenderState = () => ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
});

function copyRawValuesOnly(target, source, props) {
    for (const key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues({ transformTemplate }, visualState, isStatic) {
    return React.useMemo(() => {
        const state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function useHTMLProps(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        // Disable scrolling on the draggable direction
        style.touchAction =
            props.drag === true
                ? "none"
                : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    htmlProps.style = style;
    return htmlProps;
}

const animationProps = [
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView",
];
const tapProps = ["whileTap", "onTap", "onTapStart", "onTapCancel"];
const panProps = ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"];
const inViewProps = [
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
];
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */
const validMotionProps = new Set([
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "onHoverStart",
    "onHoverEnd",
    "layoutScroll",
    ...inViewProps,
    ...tapProps,
    ...animationProps,
    ...panProps,
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}

let shouldForward = (key) => !isValidMotionProp(key);
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    // Explicitly filter our events
    shouldForward = (key) => key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */
try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */
    loadExternalIsValidProp((__webpack_require__(79313)/* ["default"] */ .Z));
}
catch (_a) {
    // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for (const key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            // If trying to use native HTML drag events, forward drag listeners
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
    const pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    const pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}

const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset
    attrs[keys.offset] = px.transform(-offset);
    // Build the dash array
    const pathLength = px.transform(length);
    const pathSpacing = px.transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, { attrX, attrY, originX, originY, pathLength, pathSpacing = 1, pathOffset = 0, 
// This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    buildHTMLStyles(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */
    if (isSVGTag) {
        if (state.style.viewBox) {
            state.attrs.viewBox = state.style.viewBox;
        }
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style, dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

const createSvgRenderState = () => ({
    ...createHtmlRenderState(),
    attrs: {},
});

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = React.useMemo(() => {
        const state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, isSVGTag(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: { ...state.style },
        };
    }, [visualState]);
    if (props.style) {
        const rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = { ...rawStyles, ...visualProps.style };
    }
    return visualProps;
}

function createUseRender(forwardMotionProps = false) {
    const useRender = (Component, props, projectionId, ref, { latestValues }, isStatic) => {
        const useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref,
        };
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return React.createElement(Component, elementProps);
    };
    return useRender;
}

/**
 * Convert camelCase to dash-case properties.
 */
const camelToDash = (str) => str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function renderHTML(element, { style, vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for (const key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
]);

function renderSVG(element, renderState, _styleProp, projection) {
    renderHTML(element, renderState, undefined, projection);
    for (const key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props) {
    const { style } = props;
    const newValues = {};
    for (const key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props) {
    const newValues = scrapeMotionValuesFromProps$1(props);
    for (const key in props) {
        if (isMotionValue(props[key])) {
            const targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function resolveVariantFromProps(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */
    if (typeof definition === "string") {
        definition = props.variants && props.variants[definition];
    }
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */
    if (typeof definition === "function") {
        definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

const isCustomValue = (v) => {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const resolveFinalValueInKeyframes = (v) => {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */
function resolveMotionValue(value) {
    const unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

function makeState({ scrapeMotionValuesFromProps, createRenderState, onMount, }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = (instance) => onMount(props, instance, state);
    }
    return state;
}
const makeUseVisualState = (config) => (props, isStatic) => {
    const context = React.useContext(MotionContext);
    const presenceContext = React.useContext(PresenceContext);
    const make = () => makeState(config, props, context, presenceContext);
    return isStatic ? make() : useConstant(make);
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props);
    for (const key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    let { initial, animate } = props;
    const isControllingVariants$1 = isControllingVariants(props);
    const isVariantNode$1 = isVariantNode(props);
    if (context &&
        isVariantNode$1 &&
        !isControllingVariants$1 &&
        props.inherit !== false) {
        if (initial === undefined)
            initial = context.initial;
        if (animate === undefined)
            animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext
        ? presenceContext.initial === false
        : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach((definition) => {
            const resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            const { transitionEnd, transition, ...target } = resolved;
            for (const key in target) {
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */
                    const index = isInitialAnimationBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (const key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

const svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: (props, instance, { renderState, latestValues }) => {
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, isSVGTag(instance.tagName), props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

const htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, { forwardMotionProps = false }, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    const baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return {
        ...baseConfig,
        preloadedFeatures,
        useRender: createUseRender(forwardMotionProps),
        createVisualElement,
        projectionNodeConstructor,
        Component,
    };
}

exports.AnimationType = void 0;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(exports.AnimationType || (exports.AnimationType = {}));

function addDomEvent(target, eventName, handler, options = { passive: true }) {
    target.addEventListener(eventName, handler, options);
    return () => target.removeEventListener(eventName, handler);
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */
function useDomEvent(ref, eventName, handler, options) {
    React.useEffect(() => {
        const element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}

/**
 *
 * @param props
 * @param ref
 * @internal
 */
function useFocusGesture({ whileFocus, visualElement, }) {
    const { animationState } = visualElement;
    const onFocus = () => {
        animationState && animationState.setActive(exports.AnimationType.Focus, true);
    };
    const onBlur = () => {
        animationState && animationState.setActive(exports.AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}

function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    const hasTouches = !!event.touches;
    return hasTouches;
}

/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */
function filterPrimaryPointer(eventHandler) {
    return (event) => {
        const isMouseEvent = event instanceof MouseEvent;
        const isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
const defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType = "page") {
    const primaryTouch = e.touches[0] || e.changedTouches[0];
    const point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType = "page") {
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType = "page") {
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
const wrapHandler = (handler, shouldFilterPrimaryPointer = false) => {
    const listener = (event) => handler(event, extractEventInfo(event));
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};

// We check for event support via functions in case they've been mocked by a testing suite.
const supportsPointerEvents = () => isBrowser && window.onpointerdown === null;
const supportsTouchEvents = () => isBrowser && window.ontouchstart === null;
const supportsMouseEvents = () => isBrowser && window.onmousedown === null;

const mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
const touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

function createLock(name) {
    let lock = null;
    return () => {
        const openLock = () => {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const globalHorizontalLock = createLock("dragHorizontal");
const globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    let lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        const openHorizontal = globalHorizontalLock();
        const openVertical = globalVerticalLock();
        if (openHorizontal && openVertical) {
            lock = () => {
                openHorizontal();
                openVertical();
            };
        }
        else {
            // Release the locks because we don't use them
            if (openHorizontal)
                openHorizontal();
            if (openVertical)
                openVertical();
        }
    }
    return lock;
}
function isDragActive() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

function createHoverEvent(visualElement, isActive, callback) {
    return (event, info) => {
        if (!isMouseEvent(event) || isDragActive())
            return;
        /**
         * Ensure we trigger animations before firing event callback
         */
        if (visualElement.animationState) {
            visualElement.animationState.setActive(exports.AnimationType.Hover, isActive);
        }
        callback && callback(event, info);
    };
}
function useHoverGesture({ onHoverStart, onHoverEnd, whileHover, visualElement, }) {
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined, { passive: !onHoverStart });
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined, { passive: !onHoverEnd });
}

/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */
const isNodeOrChild = (parent, child) => {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function useUnmountEffect(callback) {
    return React.useEffect(() => () => callback(), []);
}

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

/**
 * @param handlers -
 * @internal
 */
function useTapGesture({ onTap, onTapStart, onTapCancel, whileTap, visualElement, }) {
    const hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    const isPressing = React.useRef(false);
    const cancelPointerEndListeners = React.useRef(null);
    /**
     * Only set listener to passive if there are no external listeners.
     */
    const eventOptions = {
        passive: !(onTapStart || onTap || onTapCancel || onPointerDown),
    };
    function removePointerEndListener() {
        cancelPointerEndListeners.current && cancelPointerEndListeners.current();
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        removePointerEndListener();
        isPressing.current = false;
        visualElement.animationState &&
            visualElement.animationState.setActive(exports.AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */
        !isNodeOrChild(visualElement.current, event.target)
            ? onTapCancel && onTapCancel(event, info)
            : onTap && onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel && onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp, eventOptions), addPointerEvent(window, "pointercancel", onPointerCancel, eventOptions));
        /**
         * Ensure we trigger animations before firing event callback
         */
        visualElement.animationState &&
            visualElement.animationState.setActive(exports.AnimationType.Tap, true);
        onTapStart && onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined, eventOptions);
    useUnmountEffect(removePointerEndListener);
}

/**
 * Browser-safe usage of process
 */
const defaultEnvironment = "production";
const env = typeof process === "undefined" || process.env === undefined
    ? defaultEnvironment
    : "production" || 0;

const warned = new Set();
function warnOnce(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */
const observers = new WeakMap();
const fireObserverCallback = (entry) => {
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries) => {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, { root, ...options });
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return () => {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

function useViewport({ visualElement, whileInView, onViewportEnter, onViewportLeave, viewport = {}, }) {
    const state = React.useRef({
        hasEnteredView: false,
        isInView: false,
    });
    let shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView)
        shouldObserve = false;
    const useObserver = typeof IntersectionObserver === "undefined"
        ? useMissingIntersectionObserver
        : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
const thresholdNames = {
    some: 0,
    all: 1,
};
function useIntersectionObserver(shouldObserve, state, visualElement, { root, margin: rootMargin, amount = "some", once }) {
    React.useEffect(() => {
        if (!shouldObserve || !visualElement.current)
            return;
        const options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        const intersectionCallback = (entry) => {
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */
            if (state.isInView === isIntersecting)
                return;
            state.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */
            if (once && !isIntersecting && state.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                state.hasEnteredView = true;
            }
            if (visualElement.animationState) {
                visualElement.animationState.setActive(exports.AnimationType.InView, isIntersecting);
            }
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */
            const props = visualElement.getProps();
            const callback = isIntersecting
                ? props.onViewportEnter
                : props.onViewportLeave;
            callback && callback(entry);
        };
        return observeIntersection(visualElement.current, options, intersectionCallback);
    }, [shouldObserve, root, rootMargin, amount]);
}
/**
 * If IntersectionObserver is missing, we activate inView and fire onViewportEnter
 * on mount. This way, the page will be in the state the author expects users
 * to see it in for everyone.
 */
function useMissingIntersectionObserver(shouldObserve, state, visualElement, { fallback = true }) {
    React.useEffect(() => {
        if (!shouldObserve || !fallback)
            return;
        if (env !== "production") {
            warnOnce(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        }
        /**
         * Fire this in an rAF because, at this point, the animation state
         * won't have flushed for the first time and there's certain logic in
         * there that behaves differently on the initial animation.
         *
         * This hook should be quite rarely called so setting this in an rAF
         * is preferred to changing the behaviour of the animation state.
         */
        requestAnimationFrame(() => {
            state.hasEnteredView = true;
            const { onViewportEnter } = visualElement.getProps();
            onViewportEnter && onViewportEnter(null);
            if (visualElement.animationState) {
                visualElement.animationState.setActive(exports.AnimationType.InView, true);
            }
        });
    }, [shouldObserve]);
}

const makeRenderlessComponent = (hook) => (props) => {
    hook(props);
    return null;
};

const gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */
function usePresence() {
    const context = React.useContext(PresenceContext);
    if (context === null)
        return [true, null];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useId when released in React
    const id = React.useId();
    React.useEffect(() => register(id), []);
    const safeToRemove = () => onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */
function useIsPresent() {
    return isPresent(React.useContext(PresenceContext));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    const prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (let i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
const isNumericalString = (v) => /^\-?\d*\.?\d+$/.test(v);

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
const isZeroValueString = (v) => /^0[^.\s]+$/.test(v);

const frameData = {
    delta: 0,
    timestamp: 0,
};

/*
  Detect and load appropriate clock setting for the execution environment
 */
const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

function createRenderStep(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */
    let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */
    let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */
    const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */
        process: (frameData) => {
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(frameData);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frameData);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frameData.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - frameData.timestamp, maxElapsed), 1);
    frameData.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};

function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1)
        arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1)
        arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

class SubscriptionManager {
    constructor() {
        this.subscriptions = [];
    }
    add(handler) {
        addUniqueItem(this.subscriptions, handler);
        return () => removeItem(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            /**
             * If there's only a single handler we can just call it without invoking a loop.
             */
            this.subscriptions[0](a, b, c);
        }
        else {
            for (let i = 0; i < numSubscriptions; i++) {
                /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */
                const handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

const isFloat = (value) => {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */
    constructor(init, options = {}) {
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */
        this.version = "7.10.3";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */
        this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */
        this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */
        this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        this.updateAndNotify = (v, render = true) => {
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta, timestamp } = frameData;
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                sync.postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) {
                this.events.change.notify(this.current);
            }
            // Update velocity subscribers
            if (this.events.velocityChange) {
                this.events.velocityChange.notify(this.getVelocity());
            }
            // Update render subscribers
            if (render && this.events.renderRequest) {
                this.events.renderRequest.notify(this.current);
            }
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.scheduleVelocityCheck = () => sync.postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */
        this.velocityCheck = ({ timestamp }) => {
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) {
                    this.events.velocityChange.notify(this.getVelocity());
                }
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @privateRemarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */
    onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    clearListeners() {
        for (const eventManagers in this.events) {
            this.events[eventManagers].clear();
        }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
    attach(passiveEffect) {
        this.passiveEffect = passiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
    set(v, render = true) {
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
    get() {
        return this.current;
    }
    /**
     * @public
     */
    getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
    getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity
            ? // These casts could be avoided if parseFloat would be typed better
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
    start(animation) {
        this.stop();
        return new Promise((resolve) => {
            this.hasAnimated = true;
            this.stopAnimation = animation(resolve);
            if (this.events.animationStart) {
                this.events.animationStart.notify();
            }
        }).then(() => {
            if (this.events.animationComplete) {
                this.events.animationComplete.notify();
            }
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
    stop() {
        if (this.stopAnimation) {
            this.stopAnimation();
            if (this.events.animationCancel) {
                this.events.animationCancel.notify();
            }
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
    isAnimating() {
        return !!this.stopAnimation;
    }
    clearAnimation() {
        this.stopAnimation = null;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
    destroy() {
        this.clearListeners();
        this.stop();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
const isColorString = (type, testProp) => (v) => {
    return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const clampRgbUnit = (v) => clamp(0, 255, v);
const rgbUnit = {
    ...number,
    transform: (v) => Math.round(clampRgbUnit(v)),
};
const rgba = {
    test: isColorString("rgb", "red"),
    parse: splitColor("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" +
        rgbUnit.transform(red) +
        ", " +
        rgbUnit.transform(green) +
        ", " +
        rgbUnit.transform(blue) +
        ", " +
        sanitize(alpha.transform(alpha$1)) +
        ")",
};

function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
        // Or we have 3 characters, ie #F00
    }
    else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex = {
    test: isColorString("#"),
    parse: parseHex,
    transform: rgba.transform,
};

const hsla = {
    test: isColorString("hsl", "hue"),
    parse: splitColor("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ("hsla(" +
            Math.round(hue) +
            ", " +
            percent.transform(sanitize(saturation)) +
            ", " +
            percent.transform(sanitize(lightness)) +
            ", " +
            sanitize(alpha.transform(alpha$1)) +
            ")");
    },
};

const color = {
    test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
    parse: (v) => {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else {
            return hex.parse(v);
        }
    },
    transform: (v) => {
        return isString(v)
            ? v
            : v.hasOwnProperty("red")
                ? rgba.transform(v)
                : hsla.transform(v);
    },
};

const colorToken = "${c}";
const numberToken = "${n}";
function test(v) {
    var _a, _b;
    return (isNaN(v) &&
        isString(v) &&
        (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) +
            (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) >
            0);
}
function analyseComplexValue(v) {
    if (typeof v === "number")
        v = `${v}`;
    const values = [];
    let numColors = 0;
    let numNumbers = 0;
    const colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        // Strip colors from input so they're not picked up by number regex.
        // There's a better way to combine these regex searches, but its beyond my regex skills
        v = v.replace(colorRegex, colorToken);
        values.push(...colors.map(color.parse));
    }
    const numbers = v.match(floatRegex);
    if (numbers) {
        numNumbers = numbers.length;
        v = v.replace(floatRegex, numberToken);
        values.push(...numbers.map(number.parse));
    }
    return { values, numColors, numNumbers, tokenised: v };
}
function parse(v) {
    return analyseComplexValue(v).values;
}
function createTransformer(source) {
    const { values, numColors, tokenised } = analyseComplexValue(source);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors
                ? color.transform(v[i])
                : sanitize(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === "number" ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parse(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test, parse, createTransformer, getAnimatableNone: getAnimatableNone$1 };

/**
 * Properties that should default to 1 or 100%
 */
const maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow")
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter = {
    ...complex,
    getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    },
};

/**
 * A map of default value types for common values
 */
const defaultValueTypes = {
    ...numberValueTypes,
    // Color props
    color,
    backgroundColor: color,
    outlineColor: color,
    fill: color,
    stroke: color,
    // Border props
    borderColor: color,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: color,
    filter,
    WebkitFilter: filter,
};
/**
 * Gets the default ValueType for the provided value key
 */
const getDefaultValueType = (key) => defaultValueTypes[key];

function getAnimatableNone(key, value) {
    var _a;
    let defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter)
        defaultValueType = complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

/**
 * Tests a provided value against a ValueType
 */
const testValueType = (v) => (type) => type.test(v);

/**
 * ValueType for "auto"
 */
const auto = {
    test: (v) => v === "auto",
    parse: (v) => v,
};

/**
 * A list of value types commonly used for dimensions
 */
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));

/**
 * A list of all ValueTypes
 */
const valueTypes = [...dimensionValueTypes, color, complex];
/**
 * Tests a value against the list of ValueTypes
 */
const findValueType = (v) => valueTypes.find(testValueType(v));

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key) => (current[key] = value.get()));
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity$1(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key) => (velocity[key] = value.getVelocity()));
    return velocity;
}
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    const resolved = resolveVariant(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = { ...target, ...transitionEnd };
    for (const key in target) {
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function setVariants(visualElement, variantLabels) {
    const reversedLabels = [...variantLabels].reverse();
    reversedLabels.forEach((key) => {
        var _a;
        const variant = visualElement.getVariant(key);
        variant && setTarget(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => {
            setVariants(child, variantLabels);
        });
    });
}
function setValues(visualElement, definition) {
    if (Array.isArray(definition)) {
        return setVariants(visualElement, definition);
    }
    else if (typeof definition === "string") {
        return setVariants(visualElement, [definition]);
    }
    else {
        setTarget(visualElement, definition);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key) => !visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (let i = 0; i < numNewValues; i++) {
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value, { owner: visualElement }));
        if (origin[key] === undefined) {
            origin[key] = value;
        }
        if (value !== null)
            visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a;
    const origin = {};
    for (const key in target) {
        const transitionOrigin = getOriginFromTransition(key, transition);
        origin[key] =
            transitionOrigin !== undefined
                ? transitionOrigin
                : (_a = visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.get();
    }
    return origin;
}

function isWillChangeMotionValue(value) {
    return Boolean(isMotionValue(value) && value.add);
}

const appearStoreId = (id, value) => `${id}: ${value}`;

function handoffOptimizedAppearAnimation(id, name) {
    const { MotionAppearAnimations } = window;
    const animationId = appearStoreId(id, transformProps.has(name) ? "transform" : name);
    const animation = MotionAppearAnimations && MotionAppearAnimations.get(animationId);
    if (animation) {
        /**
         * We allow the animation to persist until the next frame:
         *   1. So it continues to play until Framer Motion is ready to render
         *      (avoiding a potential flash of the element's original state)
         *   2. As all independent transforms share a single transform animation, stopping
         *      it synchronously would prevent subsequent transforms from handing off.
         */
        sync.render(() => {
            /**
             * Animation.cancel() throws so it needs to be wrapped in a try/catch
             */
            try {
                animation.cancel();
                MotionAppearAnimations.delete(animationId);
            }
            catch (e) { }
        });
        return animation.currentTime || 0;
    }
    else {
        return 0;
    }
}

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
const secondsToMilliseconds = (seconds) => seconds * 1000;

const instantAnimationState = {
    current: false,
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const mirrorEasing = (easing) => (p) => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const reverseEasing = (easing) => (p) => 1 - easing(1 - p);

const easeIn = (p) => p * p;
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
const mix = (from, to, progress) => -progress * from + progress * to + from;

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const colorTypes = [hex, rgba, hsla];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    heyListen.invariant(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === hsla) {
        // TODO Remove this cast - needed since Framer Motion's stricter typing
        model = hslaToRgba(model);
    }
    return model;
}
const mixColor = (from, to) => {
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    const blended = { ...fromRGBA };
    return (v) => {
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
        return rgba.transform(blended);
    };
};

function getMixer$1(origin, target) {
    if (typeof origin === "number") {
        return (v) => mix(origin, target, v);
    }
    else if (color.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer$1(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = { ...origin, ...target };
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer$1(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyseComplexValue(origin);
    const targetStats = analyseComplexValue(target);
    const canInterpolate = originStats.numColors === targetStats.numColors &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.values, targetStats.values), template);
    }
    else {
        heyListen.warning(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p) => `${p > 0 ? target : origin}`;
    }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === "number") {
        return mixNumber;
    }
    else if (typeof v === "string") {
        if (color.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === "object") {
        return mixObject;
    }
    return mixNumber;
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    heyListen.invariant(inputLength === output.length, "Both input and output ranges must be the same length");
    heyListen.invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [...input].reverse();
        output = [...output].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v) => {
        let i = 0;
        if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
                if (v < input[i + 1])
                    break;
            }
        }
        const progressInRange = progress(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp
        ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v))
        : interpolator;
}

const noop = (any) => any;

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2) => (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) *
    t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) {
            upperBound = currentT;
        }
        else {
            lowerBound = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2)
        return noop;
    const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

const circIn = (p) => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);

const backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = reverseEasing(backOut);
const backInOut = mirrorEasing(backIn);

const anticipate = (p) => (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

const easingLookup = {
    linear: noop,
    easeIn,
    easeInOut,
    easeOut,
    circIn,
    circInOut,
    circOut,
    backIn,
    backInOut,
    backOut,
    anticipate,
};
const easingDefinitionToFunction = (definition) => {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        heyListen.invariant(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        // Else lookup from table
        heyListen.invariant(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return easingLookup[definition];
    }
    return definition;
};
const isEasingArray = (ease) => {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i) => i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}
function keyframes({ keyframes: keyframeValues, ease = easeInOut, times, duration = 300, }) {
    keyframeValues = [...keyframeValues];
    const origin = keyframes[0];
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */
    const easingFunctions = isEasingArray(ease)
        ? ease.map(easingDefinitionToFunction)
        : easingDefinitionToFunction(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    /**
     * Create a times array based on the provided 0-1 offsets
     */
    const absoluteTimes = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframes.length
        ? times
        : defaultOffset(keyframeValues), duration);
    function createInterpolator() {
        return interpolate(absoluteTimes, keyframeValues, {
            ease: Array.isArray(easingFunctions)
                ? easingFunctions
                : defaultEasing(keyframeValues, easingFunctions),
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t) => {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: () => {
            keyframeValues.reverse();
            interpolator = createInterpolator();
        },
    };
}

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    heyListen.warning(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */
    dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
    duration = clamp(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        /**
         * Critically-damped spring
         */
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options,
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0,
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
const velocitySampleDuration = 5;
/**
 * This is based on the spring implementation of Wobble https://github.com/skevy/wobble
 */
function spring({ keyframes, restSpeed = 2, restDelta = 0.01, ...options }) {
    let origin = keyframes[0];
    let target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    const { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    let resolveSpring = zero;
    let initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    function createSpring() {
        const initialDelta = target - origin;
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        /**
         * If we're working within what looks like a 0-1 range, change the default restDelta
         * to 0.01
         */
        if (restDelta === undefined) {
            restDelta = Math.min(Math.abs(target - origin) / 100, 0.4);
        }
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            // Underdamped spring
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (target -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq) *
                            Math.sin(angularFreq * t) +
                            initialDelta * Math.cos(angularFreq * t)));
            };
        }
        else if (dampingRatio === 1) {
            // Critically damped spring
            resolveSpring = (t) => target -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta +
                        (initialVelocity + undampedAngularFreq * initialDelta) *
                            t);
        }
        else {
            // Overdamped spring
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                // When performing sinh or cosh values can hit Infinity so we cap them here
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return (target -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq);
            };
        }
    }
    createSpring();
    return {
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */
                    if (dampingRatio < 1) {
                        const prevT = Math.max(0, t - velocitySampleDuration);
                        currentVelocity = velocityPerSecond(current - resolveSpring(prevT), t - prevT);
                    }
                    else {
                        currentVelocity = 0;
                    }
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? target : current;
            return state;
        },
        flipTarget: () => {
            initialVelocity = -initialVelocity;
            [origin, target] = [target, origin];
            createSpring();
        },
    };
}
spring.needsInterpolation = (a, b) => typeof a === "string" || typeof b === "string";
const zero = (_t) => 0;

function decay({ 
/**
 * The decay animation dynamically calculates an end of the animation
 * based on the initial keyframe, so we only need to define a single keyframe
 * as default.
 */
keyframes = [0], velocity = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget, }) {
    const origin = keyframes[0];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */
    const state = { done: false, value: origin };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */
    if (target !== ideal)
        amplitude = target - origin;
    return {
        next: (t) => {
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: () => { },
    };
}

const types = {
    decay,
    keyframes: keyframes,
    tween: keyframes,
    spring,
};
function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration = 0, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}
const framesync = (update) => {
    const passTimestamp = ({ delta }) => update(delta);
    return {
        start: () => sync.update(passTimestamp, true),
        stop: () => cancelSync.update(passTimestamp),
    };
};
function animate$1({ duration, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, keyframes, autoplay = true, onPlay, onStop, onComplete, onRepeat, onUpdate, type = "keyframes", ...options }) {
    var _a, _b;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = types[keyframes.length > 2 ? "keyframes" : type];
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    if ((_b = (_a = animator).needsInterpolation) === null || _b === void 0 ? void 0 : _b.call(_a, origin, target)) {
        interpolateFromNumber = interpolate([0, 100], [origin, target], {
            clamp: false,
        });
        keyframes = [0, 100];
    }
    const animation = animator({
        ...options,
        duration,
        keyframes,
    });
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate && onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) {
                computedDuration =
                    computedDuration !== undefined ? computedDuration : elapsed;
            }
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay && onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: () => {
            onStop && onStop();
            driverControls.stop();
        },
        sample: (t) => {
            return animation.next(Math.max(0, t));
        },
    };
}

function isWaapiSupportedEasing(easing) {
    return (!easing || // Default easing
        Array.isArray(easing) || // Bezier curve
        (typeof easing === "string" && supportedWaapiEasing[easing]));
}
const cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
    circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
    backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
    backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99]),
};
function mapEasingToNativeEasing(easing) {
    if (!easing)
        return undefined;
    return Array.isArray(easing)
        ? cubicBezierAsString(easing)
        : supportedWaapiEasing[easing];
}

function animateStyle(element, valueName, keyframes, { delay = 0, duration, repeat = 0, repeatType = "loop", ease, times, } = {}) {
    return element.animate({ [valueName]: keyframes, offset: times }, {
        delay,
        duration,
        easing: mapEasingToNativeEasing(ease),
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal",
    });
}

/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
const sampleDelta = 10; //ms
function createAcceleratedAnimation(value, valueName, { onUpdate, onComplete, ...options }) {
    let { keyframes, duration = 0.3, elapsed = 0, ease } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */
    if (options.type === "spring" || !isWaapiSupportedEasing(options.ease)) {
        const sampleAnimation = animate$1(options);
        let state = { done: false, value: keyframes[0] };
        const pregeneratedKeyframes = [];
        let t = 0;
        while (!state.done) {
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += sampleDelta;
        }
        keyframes = pregeneratedKeyframes;
        duration = t - sampleDelta;
        ease = "linear";
    }
    const animation = animateStyle(value.owner.current, valueName, keyframes, {
        ...options,
        delay: -elapsed,
        duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */
        ease: ease,
    });
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */
    animation.onfinish = () => {
        value.set(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
    };
    /**
     * Animation interrupt callback.
     */
    return () => {
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */
        const { currentTime } = animation;
        if (currentTime) {
            const sampleAnimation = animate$1(options);
            value.setWithVelocity(sampleAnimation.sample(currentTime - sampleDelta).value, sampleAnimation.sample(currentTime).value, sampleDelta);
        }
        sync.update(() => animation.cancel());
    };
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelSync.read(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    sync.read(checkElapsed, true);
    return () => cancelSync.read(checkElapsed);
}

function createInstantAnimation({ keyframes, elapsed, onUpdate, onComplete, }) {
    const setValue = () => {
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        return () => { };
    };
    return elapsed ? delay(setValue, -elapsed) : setValue();
}

function inertia({ keyframes, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop, }) {
    const origin = keyframes[0];
    let currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function findNearestBoundary(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate$1({
            keyframes: [0, 1],
            velocity: 0,
            ...options,
            driver,
            onUpdate: (v) => {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            },
            onComplete,
            onStop,
        });
    }
    function startSpring(options) {
        startAnimation({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta,
            ...options,
        });
    }
    if (isOutOfBounds(origin)) {
        // Start the animation with spring if outside the defined boundaries
        startSpring({
            velocity,
            keyframes: [origin, findNearestBoundary(origin)],
        });
    }
    else {
        /**
         * Or if the value is out of bounds, simulate the inertia movement
         * with the decay animation.
         *
         * Pre-calculate the target so we can detect if it's out-of-bounds.
         * If it is, we want to check per frame when to switch to a spring
         * animation
         */
        let target = power * velocity + origin;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        const boundary = findNearestBoundary(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v) => {
            prev = current;
            current = v;
            velocity = velocityPerSecond(v - prev, frameData.delta);
            if ((heading === 1 && v > boundary) ||
                (heading === -1 && v < boundary)) {
                startSpring({ keyframes: [v, boundary], velocity });
            }
        };
        startAnimation({
            type: "decay",
            keyframes: [origin, 0],
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(),
    };
}

const underDampedSpring = () => ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
});
const criticallyDampedSpring = (target) => ({
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
});
const linearTween = () => ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
});
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8,
};
const defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
const getDefaultTransition = (valueKey, { keyframes }) => {
    if (keyframes.length > 2) {
        return keyframesTransition;
    }
    else {
        const factory = defaultTransitions[valueKey] || defaultTransitions.default;
        return factory(keyframes[1]);
    }
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
const isAnimatable = (key, value) => {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex")
        return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" && // It's animatable if we have a string
        complex.test(value) && // And it contains numbers and/or colors
        !value.startsWith("url(") // Unless it starts with "url("
    ) {
        return true;
    }
    return false;
};

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined({ when, delay: _delay, delayChildren, staggerChildren, staggerDirection, repeat, repeatType, repeatDelay, from, ...transition }) {
    return !!Object.keys(transition).length;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}

function getKeyframes(value, valueName, target, transition) {
    const isTargetAnimatable = isAnimatable(valueName, target);
    let origin = transition.from !== undefined ? transition.from : value.get();
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */
        origin = getAnimatableNone(valueName, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    /**
     * If the target has been defined as a series of keyframes
     */
    if (Array.isArray(target)) {
        /**
         * Ensure an initial wildcard keyframe is hydrated by the origin.
         * TODO: Support extra wildcard keyframes i.e [1, null, 0]
         */
        if (target[0] === null) {
            target[0] = origin;
        }
        return target;
    }
    else {
        return [origin, target];
    }
}

const featureTests = {
    waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
};
const results = {};
const supports = {};
/**
 * Generate features tests that cache their results.
 */
for (const key in featureTests) {
    supports[key] = () => {
        if (results[key] === undefined)
            results[key] = featureTests[key]();
        return results[key];
    };
}

/**
 * A list of values that can be hardware-accelerated.
 */
const acceleratedValues = new Set(["opacity"]);
const createMotionValueAnimation = (valueName, value, target, transition = {}) => {
    return (onComplete) => {
        const valueTransition = getValueTransition(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */
        const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */
        let { elapsed = 0 } = transition;
        elapsed = elapsed - secondsToMilliseconds(delay);
        const keyframes = getKeyframes(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */
        const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = isAnimatable(valueName, originKeyframe);
        const isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
        heyListen.warning(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes,
            velocity: value.getVelocity(),
            ...valueTransition,
            elapsed,
            onUpdate: (v) => {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: () => {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
        };
        if (!isOriginAnimatable ||
            !isTargetAnimatable ||
            instantAnimationState.current ||
            valueTransition.type === false) {
            /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */
            return createInstantAnimation(options);
        }
        else if (valueTransition.type === "inertia") {
            /**
             * If this is an inertia animation, we currently don't support pre-generating
             * keyframes for this as such it must always run on the main thread.
             */
            const animation = inertia(options);
            return () => animation.stop();
        }
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */
        if (!isTransitionDefined(valueTransition)) {
            options = {
                ...options,
                ...getDefaultTransition(valueName, options),
            };
        }
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */
        if (options.duration) {
            options.duration = secondsToMilliseconds(options.duration);
        }
        if (options.repeatDelay) {
            options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
        }
        const visualElement = value.owner;
        const element = visualElement && visualElement.current;
        const canAccelerateAnimation = supports.waapi() &&
            acceleratedValues.has(valueName) &&
            !options.repeatDelay &&
            options.repeatType !== "mirror" &&
            options.damping !== 0 &&
            visualElement &&
            element instanceof HTMLElement &&
            !visualElement.getProps().onUpdate;
        if (canAccelerateAnimation) {
            /**
             * If this animation is capable of being run via WAAPI, then do so.
             */
            return createAcceleratedAnimation(value, valueName, options);
        }
        else {
            /**
             * Otherwise, fall back to the main thread.
             */
            const animation = animate$1(options);
            return () => animation.stop();
        }
    };
};

function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant) => animateVariant(visualElement, variant, options));
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        const resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(() => visualElement.notify("AnimationComplete", definition));
}
function animateVariant(visualElement, variant, options = {}) {
    var _a;
    const resolved = resolveVariant(visualElement, variant, options.custom);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getAnimation = resolved
        ? () => animateTarget(visualElement, resolved, options)
        : () => Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */
    const getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? (forwardDelay = 0) => {
            const { delayChildren = 0, staggerChildren, staggerDirection, } = transition;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : () => Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */
    const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
/**
 * @internal
 */
function animateTarget(visualElement, definition, { delay = 0, transitionOverride, type } = {}) {
    var _a;
    let { transition = visualElement.getDefaultTransition(), transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride)
        transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && ((_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.getState()[type]);
    for (const key in target) {
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        let valueTransition = { delay, elapsed: 0, ...transition };
        /**
         * Make animation instant if this is a transform prop and we should reduce motion.
         */
        if (visualElement.shouldReduceMotion && transformProps.has(key)) {
            valueTransition = {
                ...valueTransition,
                type: false,
                delay: 0,
            };
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */
        if (!value.hasAnimated) {
            const appearId = visualElement.getProps()[optimizedAppearDataAttribute];
            if (appearId) {
                valueTransition.elapsed = handoffOptimizedAppearAnimation(appearId, key);
            }
        }
        let animation = value.start(createMotionValueAnimation(key, value, valueTarget, valueTransition));
        if (isWillChangeMotionValue(willChange)) {
            willChange.add(key);
            animation = animation.then(() => willChange.remove(key));
        }
        animations.push(animation);
    }
    return Promise.all(animations).then(() => {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1
        ? (i = 0) => i * staggerChildren
        : (i = 0) => maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach((child, i) => {
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i),
        }).then(() => child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function stopAnimation(visualElement) {
    visualElement.values.forEach((value) => value.stop());
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

const variantPriorityOrder = [
    exports.AnimationType.Animate,
    exports.AnimationType.InView,
    exports.AnimationType.Focus,
    exports.AnimationType.Hover,
    exports.AnimationType.Tap,
    exports.AnimationType.Drag,
    exports.AnimationType.Exit,
];
const reversePriorityOrder = [...variantPriorityOrder].reverse();
const numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return (animations) => Promise.all(animations.map(({ animation, options }) => animateVisualElement(visualElement, animation, options)));
}
function createAnimationState(visualElement) {
    let animate = animateList(visualElement);
    const state = createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */
    const buildResolvedTypeValues = (acc, definition) => {
        const resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            const { transition, transitionEnd, ...target } = resolved;
            acc = { ...acc, ...target, ...transitionEnd };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */
    function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */
        const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */
        const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */
        let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */
        let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */
        for (let i = 0; i < numAnimationTypes; i++) {
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = isVariantLabel(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */
            const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */
            let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */
            typeState.protectedKeys = { ...encounteredKeys };
            // Check if we can skip analysing this prop early
            if (
            // If it isn't active and hasn't *just* been set as inactive
            (!typeState.isActive && activeDelta === null) ||
                // If we didn't and don't have any defined prop for this animation type
                (!prop && !typeState.prevProp) ||
                // Or if the prop doesn't define an animation
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */
            const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange ||
                // If we're making this variant active, we want to always make it active
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                // If we removed a higher-priority variant (i is in reverse order)
                (i > removedVariantIndex && propIsVariant);
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */
            const definitionList = Array.isArray(prop) ? prop : [prop];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */
            let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */
            const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues,
            };
            const markToAnimate = (key) => {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (const key in allKeys) {
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */
                if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        // If next is defined and doesn't equal prev, it needs animating
                        markToAnimate(key);
                    }
                    else {
                        // If it's undefined, it's been removed.
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */
                    markToAnimate(key);
                }
                else {
                    /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */
                    typeState.protectedKeys[key] = true;
                }
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */
            if (typeState.isActive) {
                encounteredKeys = { ...encounteredKeys, ...resolvedValues };
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */
            if (shouldAnimateType && !isInherited) {
                animations.push(...definitionList.map((animation) => ({
                    animation: animation,
                    options: { type, ...options },
                })));
            }
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */
        if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key) => {
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */
    function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive)
            return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach((child) => { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for (const key in state) {
            state[key].protectedKeys = {};
        }
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: () => state,
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (Array.isArray(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    return {
        [exports.AnimationType.Animate]: createTypeState(true),
        [exports.AnimationType.InView]: createTypeState(),
        [exports.AnimationType.Hover]: createTypeState(),
        [exports.AnimationType.Tap]: createTypeState(),
        [exports.AnimationType.Drag]: createTypeState(),
        [exports.AnimationType.Focus]: createTypeState(),
        [exports.AnimationType.Exit]: createTypeState(),
    };
}

const animations = {
    animation: makeRenderlessComponent(({ visualElement, animate }) => {
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */
        if (isAnimationControls(animate)) {
            React.useEffect(() => animate.subscribe(visualElement), [animate]);
        }
    }),
    exit: makeRenderlessComponent((props) => {
        const { custom, visualElement } = props;
        const [isPresent, safeToRemove] = usePresence();
        const presenceContext = React.useContext(PresenceContext);
        React.useEffect(() => {
            visualElement.isPresent = isPresent;
            const animation = visualElement.animationState &&
                visualElement.animationState.setActive(exports.AnimationType.Exit, !isPresent, {
                    custom: (presenceContext && presenceContext.custom) ||
                        custom,
                });
            if (animation && !isPresent) {
                animation.then(safeToRemove);
            }
        }, [isPresent]);
    }),
};

const distance = (a, b) => Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

/**
 * @internal
 */
class PanSession {
    constructor(event, handlers, { transformPagePoint } = {}) {
        /**
         * @internal
         */
        this.startEvent = null;
        /**
         * @internal
         */
        this.lastMoveEvent = null;
        /**
         * @internal
         */
        this.lastMoveEventInfo = null;
        /**
         * @internal
         */
        this.handlers = {};
        this.updatePoint = () => {
            if (!(this.lastMoveEvent && this.lastMoveEventInfo))
                return;
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = distance2D(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            const { point } = info;
            const { timestamp } = frameData;
            this.history.push({ ...point, timestamp });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info) => {
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if (isMouseEvent(event) && event.buttons === 0) {
                this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            sync.update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info) => {
            this.end();
            const { onEnd, onSessionEnd } = this.handlers;
            const panInfo = getPanInfo(transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = extractEventInfo(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = frameData;
        this.history = [{ ...point, timestamp }];
        const { onSessionStart } = handlers;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    const time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */
function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) {
        // If we have a min point defined, and this is outside of that, constrain
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        // If we have a max point defined, and this is outside of that, constrain
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */
function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        [min, max] = [max, min];
    }
    return { min, max };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */
function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = calcLength(source);
    const targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */
function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */
function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number"
        ? dragElastic
        : dragElastic[label] || 0;
}

const createAxisDelta = () => ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
});
const createDelta = () => ({
    x: createAxisDelta(),
    y: createAxisDelta(),
});
const createAxis = () => ({ min: 0, max: 0 });
const createBox = () => ({
    x: createAxis(),
    y: createAxis(),
});

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox({ top, left, right, bottom, }) {
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    const topLeft = transformPoint({ x: point.left, y: point.top });
    const bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        has2DTranslate(values) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    var _a, _b;
    const treeLength = treePath.length;
    if (!treeLength)
        return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for (let i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
            continue;
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, {
                x: -node.scroll.offset.x,
                y: -node.scroll.offset.y,
            });
        }
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */
    treeScale.x = snapToDefault(treeScale.x);
    treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
    if (Number.isInteger(scale))
        return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = mix(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys$1 = ["x", "scaleX", "originX"];
const yKeys$1 = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.offset.x);
        translateAxis(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

const elementDragControls = new WeakMap();
/**
 *
 */
// let latestPointerEvent: AnyPointerEvent
class VisualElementDragControls {
    constructor(visualElement) {
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        /**
         * The permitted boundaries of travel, in pixels.
         */
        this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */
        if (this.visualElement.isPresent === false)
            return;
        const onSessionStart = (event) => {
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) {
                this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        const onStart = (event, info) => {
            var _a;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock)
                    this.openGlobalLock();
                this.openGlobalLock = getGlobalLock(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock)
                    return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */
            eachAxis((axis) => {
                var _a, _b;
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */
                if (percent.test(current)) {
                    const measuredAxis = (_b = (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.layoutBox[axis];
                    if (measuredAxis) {
                        const length = calcLength(measuredAxis);
                        current = length * (parseFloat(current) / 100);
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
            (_a = this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(exports.AnimationType.Drag, true);
        };
        const onMove = (event, info) => {
            // latestPointerEvent = event
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag, } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock)
                return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) {
                    onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(this.currentDirection);
                }
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */
            this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        };
        const onSessionEnd = (event, info) => this.stop(event, info);
        this.panSession = new PanSession(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        const { velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    }
    cancel() {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) {
            this.visualElement.projection.isAnimationBlocked = false;
        }
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = undefined;
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(exports.AnimationType.Drag, false);
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const { layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.layoutBox, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis((axis) => {
                if (this.getAxisMotionValue(axis)) {
                    this.constraints[axis] = rebaseAxisConstraints(layout.layoutBox[axis], this.constraints[axis]);
                }
            });
        }
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !isRefObject(constraints))
            return false;
        const constraintsElement = constraints.current;
        heyListen.invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout)
            return false;
        const constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = calcViewportConstraints(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */
        if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd, } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = eachAxis((axis) => {
            if (!shouldDrag(axis, drag, this.currentDirection)) {
                return;
            }
            let transition = (constraints === null || constraints === void 0 ? void 0 : constraints[axis]) || {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */
            const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition,
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start(createMotionValueAnimation(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        eachAxis((axis) => this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */
    getAxisMotionValue(axis) {
        var _a;
        const dragKey = "_drag" + axis.toUpperCase();
        const externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, ((_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) || 0);
    }
    snapToCursor(point) {
        eachAxis((axis) => {
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection))
                return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */
    scalePositionWithinConstraints() {
        var _a;
        if (!this.visualElement.current)
            return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */
        this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */
        const boxProgress = { x: 0, y: 0 };
        eachAxis((axis) => {
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */
        const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */
        eachAxis((axis) => {
            if (!shouldDrag(axis, drag, null))
                return;
            /**
             * Calculate a new transform based on the previous box progress
             */
            const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        var _a;
        if (!this.visualElement.current)
            return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */
        const stopPointerListener = addPointerEvent(element, "pointerdown", (event) => {
            const { drag, dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = () => {
            const { dragConstraints } = this.getProps();
            if (isRefObject(dragConstraints)) {
                this.constraints = this.resolveRefConstraints();
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */
        const stopResizeListener = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */
        const stopLayoutUpdateListener = projection.addEventListener("didUpdate", (({ delta, hasLayoutChanged }) => {
            if (this.isDragging && hasLayoutChanged) {
                eachAxis((axis) => {
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        }));
        return () => {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = defaultElastic, dragMomentum = true, } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum,
        };
    }
}
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */
function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */
function useDrag(props) {
    const { dragControls: groupDragControls, visualElement } = props;
    const dragControls = useConstant(() => new VisualElementDragControls(visualElement));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    React.useEffect(() => groupDragControls && groupDragControls.subscribe(dragControls), [dragControls, groupDragControls]);
    // Apply the event listeners to the element
    React.useEffect(() => dragControls.addListeners(), [dragControls]);
}

/**
 *
 * @param handlers -
 * @param ref -
 *
 * @privateRemarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */
function usePanGesture({ onPan, onPanStart, onPanEnd, onPanSessionStart, visualElement, }) {
    const hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    const panSession = React.useRef(null);
    const { transformPagePoint } = React.useContext(MotionConfigContext);
    const handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: (event, info) => {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    React.useEffect(() => {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(() => panSession.current && panSession.current.end());
}

const drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};

function isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
const cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    const match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    const [, token, fallback] = match;
    return [token, fallback];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    heyListen.invariant(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token)
        return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariable(fallback)) {
        // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element))
        return { target, transitionEnd };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) {
        transitionEnd = { ...transitionEnd };
    }
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value) => {
        const current = value.get();
        if (!isCSSVariable(current))
            return;
        const resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for (const key in target) {
        const current = target[key];
        if (!isCSSVariable(current))
            continue;
        const resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd && transitionEnd[key] === undefined) {
            transitionEnd[key] = current;
        }
    }
    return { target, transitionEnd };
}

const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
const isPositionalKey = (key) => positionalKeys.has(key);
const hasPositionalKey = (target) => {
    return Object.keys(target).some(isPositionalKey);
};
const setAndResetVelocity = (value, to) => {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
const isNumOrPxType = (v) => v === number || v === px;
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
const getPosFromMatrix = (matrix, pos) => parseFloat(matrix.split(", ")[pos]);
const getTranslateFromMatrix = (pos2, pos3) => (_bbox, { transform }) => {
    if (transform === "none" || !transform)
        return 0;
    const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
        return getPosFromMatrix(matrix3d[1], pos3);
    }
    else {
        const matrix = transform.match(/^matrix\((.+)\)$/);
        if (matrix) {
            return getPosFromMatrix(matrix[1], pos2);
        }
        else {
            return 0;
        }
    }
};
const transformKeys = new Set(["x", "y", "z"]);
const nonTranslationalTransformKeys = transformPropOrder.filter((key) => !transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length)
        visualElement.render();
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0" }) => x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y }, { paddingTop = "0", paddingBottom = "0" }) => y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top }) => parseFloat(top),
    left: (_bbox, { left }) => parseFloat(left),
    bottom: ({ y }, { top }) => parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left }) => parseFloat(left) + (x.max - x.min),
    // Transform
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
const convertChangedValueTypes = (target, visualElement, changedKeys) => {
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    /**
     * Record origins before we render and update styles
     */
    changedKeys.forEach((key) => {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key) => {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {}) => {
    target = { ...target };
    transitionEnd = { ...transitionEnd };
    const targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key) => {
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        let from = origin[key];
        let fromType = findDimensionValueType(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if (isKeyframesTarget(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (let i = fromIndex; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    heyListen.invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    heyListen.invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0
            ? window.pageYOffset
            : null;
        const convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) {
            removedTransformValues.forEach(([key, value]) => {
                visualElement.getValue(key).set(value);
            });
        }
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if (isBrowser && scrollY !== null) {
            window.scrollTo({ top: scrollY });
        }
        return { target: convertedTarget, transitionEnd };
    }
    else {
        return { target, transitionEnd };
    }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target, transitionEnd };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
const parseDomVariant = (visualElement, target, origin, transitionEnd) => {
    const resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
const prefersReducedMotion = { current: null };
const hasReducedMotionListener = { current: false };

function initPrefersReducedMotion() {
    hasReducedMotionListener.current = true;
    if (!isBrowser)
        return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = () => (prefersReducedMotion.current = motionMediaQuery.matches);
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    }
    else {
        prefersReducedMotion.current = false;
    }
}

function updateMotionValuesFromProps(element, next, prev) {
    const { willChange } = next;
    for (const key in next) {
        const nextValue = next[key];
        const prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */
            element.addValue(key, nextValue);
            if (isWillChangeMotionValue(willChange)) {
                willChange.add(key);
            }
            /**
             * Check the version of the incoming motion value with this version
             * and warn against mismatches.
             */
            if (false) {}
        }
        else if (isMotionValue(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */
            element.addValue(key, motionValue(nextValue, { owner: element }));
            if (isWillChangeMotionValue(willChange)) {
                willChange.remove(key);
            }
        }
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */
            if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, motionValue(latestValue !== undefined ? latestValue : nextValue));
            }
        }
    }
    // Handle removed values
    for (const key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

const featureNames = Object.keys(featureDefinitions);
const numFeatures = featureNames.length;
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "Unmount",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete",
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
class VisualElement {
    constructor({ parent, props, reducedMotionConfig, visualState, }, options = {}) {
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */
        this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */
        this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */
        this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */
        this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */
        this.values = new Map();
        /**
         * Tracks whether this VisualElement's React component is currently present
         * within the defined React tree.
         */
        this.isPresent = true;
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */
        this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */
        this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */
        this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */
        this.propEventSubscriptions = {};
        this.notifyUpdate = () => this.notify("Update", this.latestValues);
        this.render = () => {
            if (!this.current)
                return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = () => sync.render(this.render, false, true);
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = { ...latestValues };
        this.initialValues = props.initial ? { ...latestValues } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = isControllingVariants(props);
        this.isVariantNode = isVariantNode(props);
        if (this.isVariantNode) {
            this.variantChildren = new Set();
        }
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */
        const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props);
        for (const key in initialMotionValues) {
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
                if (isWillChangeMotionValue(willChange)) {
                    willChange.add(key);
                }
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */
    scrapeMotionValuesFromProps(_props) {
        return {};
    }
    mount(instance) {
        var _a;
        this.current = instance;
        if (this.projection) {
            this.projection.mount(instance);
        }
        if (this.parent && this.isVariantNode && !this.isControllingVariants) {
            this.removeFromVariantTree = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.addVariantChild(this);
        }
        this.values.forEach((value, key) => this.bindToMotionValue(key, value));
        if (!hasReducedMotionListener.current) {
            initPrefersReducedMotion();
        }
        this.shouldReduceMotion =
            this.reducedMotionConfig === "never"
                ? false
                : this.reducedMotionConfig === "always"
                    ? true
                    : prefersReducedMotion.current;
        if (this.parent)
            this.parent.children.add(this);
        this.setProps(this.props);
    }
    unmount() {
        var _a, _b, _c;
        (_a = this.projection) === null || _a === void 0 ? void 0 : _a.unmount();
        cancelSync.update(this.notifyUpdate);
        cancelSync.render(this.render);
        this.valueSubscriptions.forEach((remove) => remove());
        (_b = this.removeFromVariantTree) === null || _b === void 0 ? void 0 : _b.call(this);
        (_c = this.parent) === null || _c === void 0 ? void 0 : _c.children.delete(this);
        for (const key in this.events) {
            this.events[key].clear();
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = transformProps.has(key);
        const removeOnChange = value.on("change", (latestValue) => {
            this.latestValues[key] = latestValue;
            this.props.onUpdate &&
                sync.update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) {
                this.projection.isTransformDirty = true;
            }
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, () => {
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */
        if (!this.current ||
            !this.sortInstanceNodePosition ||
            this.type !== other.type)
            return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures(renderedProps, isStrict, preloadedFeatures, projectionId, ProjectionNodeConstructor, initialLayoutGroupConfig) {
        const features = [];
        /**
         * If we're in development mode, check to make sure we're not rendering a motion component
         * as a child of LazyMotion, as this will break the file-size benefits of using it.
         */
        if (env !== "production" && preloadedFeatures && isStrict) {
            heyListen.invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
        }
        for (let i = 0; i < numFeatures; i++) {
            const name = featureNames[i];
            const { isEnabled, Component } = featureDefinitions[name];
            /**
             * It might be possible in the future to use this moment to
             * dynamically request functionality. In initial tests this
             * was producing a lot of duplication amongst bundles.
             */
            if (isEnabled(renderedProps) && Component) {
                features.push(React.createElement(Component, {
                    key: name,
                    ...renderedProps,
                    visualElement: this,
                }));
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(projectionId, this.latestValues, this.parent && this.parent.projection);
            const { layoutId, layout, drag, dragConstraints, layoutScroll } = renderedProps;
            this.projection.setOptions({
                layoutId,
                layout,
                alwaysMeasureLayout: Boolean(drag) ||
                    (dragConstraints && isRefObject(dragConstraints)),
                visualElement: this,
                scheduleRender: () => this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */
                animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll,
            });
        }
        return features;
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
    measureViewportBox() {
        return this.current
            ? this.measureInstanceViewportBox(this.current, this.props)
            : createBox();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
    makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
    setProps(props) {
        if (props.transformTemplate || this.props.transformTemplate) {
            this.scheduleRender();
        }
        this.props = props;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */
        for (let i = 0; i < propEventHandlers.length; i++) {
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) {
                this.propEventSubscriptions[key] = this.on(key, listener);
            }
        }
        this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props), this.prevMotionValues);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
    getVariant(name) {
        var _a;
        return (_a = this.props.variants) === null || _a === void 0 ? void 0 : _a[name];
    }
    /**
     * Returns the defined default transition on this component.
     */
    getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        var _a;
        return this.isVariantNode ? this : (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getClosestVariantNode();
    }
    getVariantContext(startAtParent = false) {
        var _a, _b;
        if (startAtParent)
            return (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getVariantContext();
        if (!this.isControllingVariants) {
            const context = ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.getVariantContext()) || {};
            if (this.props.initial !== undefined) {
                context.initial = this.props.initial;
            }
            return context;
        }
        const context = {};
        for (let i = 0; i < numVariantProps; i++) {
            const name = variantProps[i];
            const prop = this.props[name];
            if (isVariantLabel(prop) || prop === false) {
                context[name] = prop;
            }
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
    addVariantChild(child) {
        var _a;
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
            return () => closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
    addValue(key, value) {
        // Remove existing value if it exists
        if (this.hasValue(key))
            this.removeValue(key);
        this.values.set(key, value);
        this.latestValues[key] = value.get();
        this.bindToMotionValue(key, value);
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
    removeValue(key) {
        var _a;
        this.values.delete(key);
        (_a = this.valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
        this.valueSubscriptions.delete(key);
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
    hasValue(key) {
        return this.values.has(key);
    }
    /**
     * Get a motion value for this key. If called with a default
     * value, we'll create one if none exists.
     */
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) {
            return this.props.values[key];
        }
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = motionValue(defaultValue, { owner: this });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
    readValue(key) {
        return this.latestValues[key] !== undefined || !this.current
            ? this.latestValues[key]
            : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
    setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
    getBaseTarget(key) {
        var _a;
        const { initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object"
            ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key]
            : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */
        if (initial && valueFromInitial !== undefined) {
            return valueFromInitial;
        }
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */
        const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !isMotionValue(target))
            return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */
        return this.initialValues[key] !== undefined &&
            valueFromInitial === undefined
            ? undefined
            : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = new SubscriptionManager();
        }
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        var _a;
        (_a = this.events[eventName]) === null || _a === void 0 ? void 0 : _a.notify(...args);
    }
}
const variantProps = ["initial", ...variantPriorityOrder];
const numVariantProps = variantProps.length;

class DOMVisualElement extends VisualElement {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }, { transformValues }, isMounted) {
        let origin = getOrigin(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(this, target, origin);
            const parsed = parseDomVariant(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition,
            transitionEnd,
            ...target,
        };
    }
}

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends DOMVisualElement {
    readValueFromInstance(instance, key) {
        if (transformProps.has(key)) {
            const defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            const computedStyle = getComputedStyle$1(instance);
            const value = (isCSSVariable$1(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return measureViewportBox(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props) {
        return scrapeMotionValuesFromProps$1(props);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderHTML(instance, renderState, styleProp, projection);
    }
}

class SVGVisualElement extends DOMVisualElement {
    constructor() {
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        var _a;
        if (transformProps.has(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return createBox();
    }
    scrapeMotionValuesFromProps(props) {
        return scrapeMotionValuesFromProps(props);
    }
    build(renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        renderSVG(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = isSVGTag(instance.tagName);
        super.mount(instance);
    }
}

const createDomVisualElement = (Component, options) => {
    return isSVGComponent(Component)
        ? new SVGVisualElement(options, { enableHardwareAcceleration: false })
        : new HTMLVisualElement(options, { enableHardwareAcceleration: true });
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */
const correctBorderRadius = {
    correct: (latest, node) => {
        if (!node.target)
            return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */
        const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    },
};

const varToken = "_$css";
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta }) => {
        const original = latest;
        /**
         * We need to first strip and store CSS variables from the string.
         */
        const containsCSSVariables = latest.includes("var(");
        const cssVariables = [];
        if (containsCSSVariables) {
            latest = latest.replace(cssVariableRegex, (match) => {
                cssVariables.push(match);
                return varToken;
            });
        }
        const shadow = complex.parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5)
            return original;
        const template = complex.createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */
        const averageScale = mix(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        let output = template(shadow);
        if (containsCSSVariables) {
            let i = 0;
            output = output.replace(varToken, () => {
                const cssVariable = cssVariables[i];
                i++;
                return cssVariable;
            });
        }
        return output;
    },
};

class MeasureLayoutWithContext extends React__default["default"].Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group)
                layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", () => {
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: () => this.safeToRemove(),
            });
        }
        globalProjectionState.hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection)
            return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */
                sync.postRender(() => {
                    var _a;
                    if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
                        this.safeToRemove();
                    }
                });
            }
        }
        return null;
    }
    componentDidUpdate() {
        const { projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) {
                this.safeToRemove();
            }
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext, } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = usePresence();
    const layoutGroup = React.useContext(LayoutGroupContext);
    return (React__default["default"].createElement(MeasureLayoutWithContext, { ...props, layoutGroup: layoutGroup, switchLayoutGroup: React.useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove }));
}
const defaultScaleCorrectors = {
    borderRadius: {
        ...correctBorderRadius,
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ],
    },
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

const layoutFeatures = {
    measureLayout: MeasureLayout,
};

/**
 * Animate a single value or a `MotionValue`.
 *
 * The first argument is either a `MotionValue` to animate, or an initial animation value.
 *
 * The second is either a value to animate to, or an array of keyframes to animate through.
 *
 * The third argument can be either tween or spring options, and optional lifecycle methods: `onUpdate`, `onPlay`, `onComplete`, `onRepeat` and `onStop`.
 *
 * Returns `AnimationPlaybackControls`, currently just a `stop` method.
 *
 * ```javascript
 * const x = useMotionValue(0)
 *
 * useEffect(() => {
 *   const controls = animate(x, 100, {
 *     type: "spring",
 *     stiffness: 2000,
 *     onComplete: v => {}
 *   })
 *
 *   return controls.stop
 * })
 * ```
 *
 * @public
 */
function animate(from, to, transition = {}) {
    const value = isMotionValue(from) ? from : motionValue(from);
    value.start(createMotionValueAnimation("", value, to, transition));
    return {
        stop: () => value.stop(),
        isAnimating: () => value.isAnimating(),
    };
}

const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
const numBorders = borders.length;
const asNumber = (value) => typeof value === "string" ? parseFloat(value) : value;
const isPx = (value) => typeof value === "number" || px.test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0, 
        // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix(follow.opacity !== undefined ? follow.opacity : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    }
    /**
     * Mix border radius
     */
    for (let i = 0; i < numBorders; i++) {
        const borderLabel = `border${borders[i]}Radius`;
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    /**
     * Mix rotation
     */
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined
        ? values[radiusName]
        : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const easeCrossfadeIn = compress(0, 0.5, circOut);
const easeCrossfadeOut = compress(0.5, 0.95, noop);
function compress(min, max, easing) {
    return (p) => {
        // Could replace ifs with clamp
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */
function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */
function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    let originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
const xKeys = ["x", "scaleX", "originX"];
const yKeys = ["y", "scaleY", "originY"];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}
function aspectRatio(box) {
    return calcLength(box.x) / calcLength(box.y);
}

class NodeStack {
    constructor() {
        this.members = [];
    }
    add(node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member) => node === member);
        if (indexOfNode === 0)
            return false;
        /**
         * Find the next projection node that is present
         */
        let prevLead;
        for (let i = indexOfNode; i >= 0; i--) {
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    }
    promote(node, preserveFollowOpacity) {
        var _a;
        const prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
                node.isLayoutDirty = true;
            }
            const { crossfade } = node.options;
            if (crossfade === false) {
                prevLead.hide();
            }
            /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */
        }
    }
    exitAnimationComplete() {
        this.members.forEach((node) => {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
        });
    }
    scheduleRender() {
        this.members.forEach((node) => {
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */
    removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    }
}

function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */
    const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) {
        transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    }
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */
    if (treeScale.x !== 1 || treeScale.y !== 1) {
        transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    }
    if (latestTransform) {
        const { rotate, rotateX, rotateY } = latestTransform;
        if (rotate)
            transform += `rotate(${rotate}deg) `;
        if (rotateX)
            transform += `rotateX(${rotateX}deg) `;
        if (rotateY)
            transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */
    const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) {
        transform += `scale(${elementScaleX}, ${elementScaleY})`;
    }
    return transform || "none";
}

const compareByDepth = (a, b) => a.depth - b.depth;

class FlatTree {
    constructor() {
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        removeItem(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

const transformAxes = ["", "X", "Y", "Z"];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */
const animationTarget = 1000;
let id$1 = 0;
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform, }) {
    return class ProjectionNode {
        constructor(elementId, latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()) {
            /**
             * A unique ID generated for every projection node.
             */
            this.id = id$1++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */
            this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */
            this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */
            this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */
            this.isLayoutDirty = false;
            this.isTransformDirty = false;
            /**
             * Flag to true if we think the projection calculations for this or any
             * child might need recalculating as a result of an updated transform or layout animation.
             */
            this.isProjectionDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */
            this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */
            this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */
            this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */
            this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */
            this.treeScale = { x: 1, y: 1 };
            /**
             *
             */
            this.eventHandlers = new Map();
            // Note: Currently only running on root node
            this.potentialNodes = new Map();
            this.checkUpdateFailed = () => {
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */
            this.updateProjection = () => {
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */
            // TODO Only running on root node
            this.sharedNodes = new Map();
            this.elementId = elementId;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [...parent.path, parent] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            elementId && this.root.registerPotentialNode(elementId, this);
            for (let i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        registerPotentialNode(elementId, node) {
            this.potentialNodes.set(elementId, node);
        }
        /**
         * Lifecycles
         */
        mount(instance, isLayoutDirty = false) {
            var _a;
            if (this.instance)
                return;
            this.isSVG =
                instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children.add(this);
            this.elementId && this.root.potentialNodes.delete(this.elementId);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = () => (this.root.updateBlockedByResize = false);
                attachResizeListener(instance, () => {
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = delay(resizeUnblockUpdate, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeTargetChanged, layout: newLayout, }) => {
                    var _a, _b, _c, _d, _e;
                    if (this.isTreeAnimationBlocked()) {
                        this.target = undefined;
                        this.relativeTarget = undefined;
                        return;
                    }
                    // TODO: Check here if an animation exists
                    const layoutTransition = (_b = (_a = this.options.transition) !== null && _a !== void 0 ? _a : visualElement.getDefaultTransition()) !== null && _b !== void 0 ? _b : defaultLayoutTransition;
                    const { onLayoutAnimationStart, onLayoutAnimationComplete, } = visualElement.getProps();
                    /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */
                    const targetChanged = !this.targetLayout ||
                        !boxEquals(this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */
                    const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (((_c = this.resumeFrom) === null || _c === void 0 ? void 0 : _c.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !this.currentAnimation))) {
                        if (this.resumeFrom) {
                            this.resumingFrom = this.resumeFrom;
                            this.resumingFrom.resumingFrom = undefined;
                        }
                        this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        const animationOptions = {
                            ...getValueTransition(layoutTransition, "layout"),
                            onPlay: onLayoutAnimationStart,
                            onComplete: onLayoutAnimationComplete,
                        };
                        if (visualElement.shouldReduceMotion) {
                            animationOptions.delay = 0;
                            animationOptions.type = false;
                        }
                        this.startAnimation(animationOptions);
                    }
                    else {
                        /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */
                        if (!hasLayoutChanged &&
                            this.animationProgress === 0) {
                            finishAnimation(this);
                        }
                        this.isLead() && ((_e = (_d = this.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d));
                    }
                    this.targetLayout = newLayout;
                });
            }
        }
        unmount() {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.remove(this);
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
            this.instance = undefined;
            cancelSync.preRender(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            var _a;
            return (this.isAnimationBlocked ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) ||
                false);
        }
        // Note: currently only running on root node
        startUpdate() {
            var _a;
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.forEach(resetRotation);
            this.animationId++;
        }
        willUpdate(shouldNotifyListeners = true) {
            var _a, _b, _c;
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout)
                return;
            const transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        // Note: Currently only running on root node
        didUpdate() {
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating)
                return;
            this.isUpdating = false;
            /**
             * Search for and mount newly-added projection elements.
             *
             * TODO: Every time a new component is rendered we could search up the tree for
             * the closest mounted node and query from there rather than document.
             */
            if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            /**
             * Write
             */
            this.nodes.forEach(resetTransformStyle);
            /**
             * Read ==================
             */
            // Update layout measurements of updated children
            this.nodes.forEach(updateLayout);
            /**
             * Write
             */
            // Notify listeners that the layout is updated
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            flushSync.update();
            flushSync.preRender();
            flushSync.render();
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            sync.preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */
            sync.postRender(() => {
                if (this.isLayoutDirty) {
                    this.root.didUpdate();
                }
                else {
                    this.root.checkUpdateFailed();
                }
            });
        }
        /**
         * Update measurements
         */
        updateSnapshot() {
            if (this.snapshot || !this.instance)
                return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            var _a;
            if (!this.instance)
                return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (let i = 0; i < this.path.length; i++) {
                    const node = this.path[i];
                    node.updateScroll();
                }
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.notify("LayoutMeasure", this.layout.layoutBox, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.layoutBox);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll &&
                this.scroll.animationId === this.root.animationId &&
                this.scroll.phase === phase) {
                needsMeasurement = false;
            }
            if (needsMeasurement) {
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot: checkIsScrollRoot(this.instance),
                    offset: measureScroll(this.instance),
                };
            }
        }
        resetTransform() {
            var _a;
            if (!resetTransform)
                return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            const transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */
            if (removeTransform) {
                layoutBox = this.removeTransform(layoutBox);
            }
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id,
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement)
                return createBox();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll } = this.root;
            if (scroll) {
                translateAxis(box.x, scroll.offset.x);
                translateAxis(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */
                    if (scroll.isRoot) {
                        copyBoxInto(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */
                        if (rootScroll) {
                            translateAxis(boxWithoutScroll.x, -rootScroll.offset.x);
                            translateAxis(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    translateAxis(boxWithoutScroll.x, scroll.offset.x);
                    translateAxis(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.offset.x,
                        y: -node.scroll.offset.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        }
        removeTransform(box) {
            var _a;
            const boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (let i = 0; i < this.path.length; i++) {
                const node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                const sourceBox = createBox();
                const nodeBox = node.measurePageBox();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layoutBox, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        }
        /**
         *
         */
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.isProjectionDirty = true;
            this.root.scheduleUpdateProjection();
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true,
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        /**
         * Frame calculations
         */
        resolveTargetDelta() {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */
            const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */
            if (!this.isProjectionDirty && !this.attemptToResolveRelativeTarget)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */
            // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */
            if (!this.relativeTarget && !this.targetDelta)
                return;
            /**
             * Lazy-init target data structure
             */
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) {
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
                /**
                 * If we've only got a targetDelta, resolve it into a target
                 */
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    // TODO: This is creating a new object every frame
                    this.target = this.applyTransform(this.layout.layoutBox);
                }
                else {
                    copyBoxInto(this.target, this.layout.layoutBox);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                /**
                 * If no target, use own layout as target
                 */
                copyBoxInto(this.target, this.layout.layoutBox);
            }
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent &&
                    Boolean(relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !relativeParent.options.layoutScroll &&
                    relativeParent.target) {
                    this.relativeParent = relativeParent;
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
                else {
                    this.relativeParent = this.relativeTarget = undefined;
                }
            }
        }
        getClosestProjectingParent() {
            if (!this.parent ||
                hasScale(this.parent.latestValues) ||
                has2DTranslate(this.parent.latestValues))
                return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) &&
                this.parent.layout) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        }
        calcProjection() {
            var _a;
            const { isProjectionDirty, isTransformDirty } = this;
            this.isProjectionDirty = this.isTransformDirty = false;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            if (isProjectionDirty)
                canSkip = false;
            if (isShared && isTransformDirty)
                canSkip = false;
            if (canSkip)
                return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */
            this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */
            copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target } = lead;
            if (!target)
                return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        }
        hide() {
            this.isVisible = false;
            // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
            // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a, _b, _c;
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            var _a, _b;
            const snapshot = this.snapshot;
            const snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            const mixedValues = { ...this.latestValues };
            const targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = createBox();
            const isSharedLayoutAnimation = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.source) !== ((_a = this.layout) === null || _a === void 0 ? void 0 : _a.source);
            const isOnlyMember = (((_b = this.getStack()) === null || _b === void 0 ? void 0 : _b.members.length) || 0) <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            this.mixTargetDelta = (latest) => {
                var _a;
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget &&
                    this.relativeTargetOrigin &&
                    this.layout &&
                    ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(0);
        }
        startAnimation(options) {
            var _a, _b;
            this.notifyListeners("animationStart");
            (_a = this.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            if (this.resumingFrom) {
                (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
            }
            if (this.pendingAnimation) {
                cancelSync.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */
            this.pendingAnimation = sync.update(() => {
                globalProjectionState.hasAnimatedSinceResize = true;
                this.currentAnimation = animate(0, animationTarget, {
                    ...options,
                    onUpdate: (latest) => {
                        var _a;
                        this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, latest);
                    },
                    onComplete: () => {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                        this.completeAnimation();
                    },
                });
                if (this.resumingFrom) {
                    this.resumingFrom.currentAnimation = this.currentAnimation;
                }
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 ? void 0 : _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout)
                return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */
            if (this !== lead &&
                this.layout &&
                layout &&
                shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || createBox();
                const xLength = calcLength(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = calcLength(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            copyBoxInto(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */
            transformBox(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node),
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity, } = {}) {
            const stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        }
        resetRotation() {
            const { visualElement } = this.options;
            if (!visualElement)
                return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */
            const { latestValues } = visualElement;
            if (latestValues.rotate ||
                latestValues.rotateX ||
                latestValues.rotateY ||
                latestValues.rotateZ) {
                hasRotate = true;
            }
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate)
                return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for (let i = 0; i < transformAxes.length; i++) {
                const key = "rotate" + transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement === null || visualElement === void 0 ? void 0 : visualElement.render();
            // Put back all the values we reset
            for (const key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b, _c;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            const transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity =
                        this.latestValues.opacity !== undefined
                            ? this.latestValues.opacity
                            : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            const { x, y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) {
                /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */
                styles.opacity =
                    lead === this
                        ? (_c = (_b = valuesToRender.opacity) !== null && _b !== void 0 ? _b : this.latestValues.opacity) !== null && _c !== void 0 ? _c : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */
                styles.opacity =
                    lead === this
                        ? valuesToRender.opacity !== undefined
                            ? valuesToRender.opacity
                            : ""
                        : valuesToRender.opacityExit !== undefined
                            ? valuesToRender.opacityExit
                            : 0;
            }
            /**
             * Apply scale correction
             */
            for (const key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                const { correct, applyTo } = scaleCorrectors[key];
                const corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for (let i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node) => { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(axisSnapshot);
                axisSnapshot.min = layout[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) {
            eachAxis((axis) => {
                const axisSnapshot = isShared
                    ? snapshot.measuredBox[axis]
                    : snapshot.layoutBox[axis];
                const length = calcLength(layout[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        const layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = createDelta();
        if (isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        }
        else {
            calcBoxDelta(visualDelta, layout, snapshot.layoutBox);
        }
        const hasLayoutChanged = !isDeltaZero(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */
            if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout, parentLayout.layoutBox);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        (_c = (_b = node.options).onExitComplete) === null || _c === void 0 ? void 0 : _c.call(_b);
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */
    node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Propagate isProjectionDirty. Nodes are ordered by depth, so if the parent here
     * is dirty we can simply pass this forward.
     */
    node.isProjectionDirty || (node.isProjectionDirty = Boolean(node.parent && node.parent.isProjectionDirty));
    /**
     * Propagate isTransformDirty.
     */
    node.isTransformDirty || (node.isTransformDirty = Boolean(node.parent && node.parent.isTransformDirty));
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement === null || visualElement === void 0 ? void 0 : visualElement.getProps().onBeforeLayoutMeasure) {
        visualElement.notify("BeforeLayoutMeasure");
    }
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function mountNodeEarly(node, elementId) {
    /**
     * Rather than searching the DOM from document we can search the
     * path for the deepest mounted ancestor and search from there
     */
    let searchNode = node.root;
    for (let i = node.path.length - 1; i >= 0; i--) {
        if (Boolean(node.path[i].instance)) {
            searchNode = node.path[i];
            break;
        }
    }
    const searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    const element = searchElement.querySelector(`[data-projection-id="${elementId}"]`);
    if (element)
        node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return (animationType === "position" ||
        (animationType === "preserve-aspect" &&
            !isNear(aspectRatio(snapshot), aspectRatio(layout), 0.2)));
}

const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});

const rootProjectionNode = {
    current: undefined,
};
const HTMLProjectionNode = createProjectionNode({
    measureScroll: (instance) => ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }),
    defaultParent: () => {
        if (!rootProjectionNode.current) {
            const documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value) => {
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance) => Boolean(window.getComputedStyle(instance).position === "fixed"),
});

const featureBundle = {
    ...animations,
    ...gestureAnimations,
    ...drag,
    ...layoutFeatures,
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
const motion = /*@__PURE__*/ createMotionProxy((Component, config) => createDomMotionConfig(Component, config, featureBundle, createDomVisualElement, HTMLProjectionNode));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */
function createDomMotionComponent(key) {
    return createMotionComponent(createDomMotionConfig(key, { forwardMotionProps: false }, featureBundle, createDomVisualElement, HTMLProjectionNode));
}

/**
 * @public
 */
const m = createMotionProxy(createDomMotionConfig);

function useIsMounted() {
    const isMounted = React.useRef(false);
    useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}

function useForceUpdate() {
    const isMounted = useIsMounted();
    const [forcedRenderCount, setForcedRenderCount] = React.useState(0);
    const forceRender = React.useCallback(() => {
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */
    const deferredForceRender = React.useCallback(() => sync.postRender(forceRender), [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}

/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends React__namespace.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent }) {
    const id = React.useId();
    const ref = React.useRef(null);
    const size = React.useRef({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    React.useInsertionEffect(() => {
        const { width, height, top, left } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        }
        return () => {
            document.head.removeChild(style);
        };
    }, [isPresent]);
    return (React__namespace.createElement(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size }, React__namespace.cloneElement(children, { ref })));
}

const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, }) => {
    const presenceChildren = useConstant(newChildrenMap);
    const id = React.useId();
    const context = React.useMemo(() => ({
        id,
        initial,
        isPresent,
        custom,
        onExitComplete: (childId) => {
            presenceChildren.set(childId, true);
            for (const isComplete of presenceChildren.values()) {
                if (!isComplete)
                    return; // can stop searching when any is incomplete
            }
            onExitComplete && onExitComplete();
        },
        register: (childId) => {
            presenceChildren.set(childId, false);
            return () => presenceChildren.delete(childId);
        },
    }), 
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    presenceAffectsLayout ? undefined : [isPresent]);
    React.useMemo(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    React__namespace.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = React__namespace.createElement(PopChild, { isPresent: isPresent }, children);
    }
    return (React__namespace.createElement(PresenceContext.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}

const getChildKey = (child) => child.key || "";
function updateChildLookup(children, allChildren) {
    children.forEach((child) => {
        const key = getChildKey(child);
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, custom, initial = true, onExitComplete, exitBeforeEnter, presenceAffectsLayout = true, mode = "sync", }) => {
    // Support deprecated exitBeforeEnter prop
    if (exitBeforeEnter) {
        mode = "wait";
        warnOnce(false, "Replace exitBeforeEnter with mode='wait'");
    }
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    let [forceRender] = useForceUpdate();
    const forceRenderLayoutGroup = React.useContext(LayoutGroupContext).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    const isMounted = useIsMounted();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = onlyElements(children);
    let childrenToRender = filteredChildren;
    const exiting = new Set();
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = React.useRef(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = React.useRef(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = React.useRef(true);
    useIsomorphicLayoutEffect(() => {
        isInitialRender.current = false;
        updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    useUnmountEffect(() => {
        isInitialRender.current = true;
        allChildren.clear();
        exiting.clear();
    });
    if (isInitialRender.current) {
        return (React__namespace.createElement(React__namespace.Fragment, null, childrenToRender.map((child) => (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child)))));
    }
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [...childrenToRender];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map(getChildKey);
    const targetKeys = filteredChildren.map(getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for (let i = 0; i < numPresent; i++) {
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exiting.size) {
        childrenToRender = [];
    }
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach((key) => {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1)
            return;
        const child = allChildren.get(key);
        if (!child)
            return;
        const insertionIndex = presentKeys.indexOf(key);
        const onExit = () => {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            const removeIndex = presentChildren.current.findIndex((presentChild) => presentChild.key === key);
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false)
                    return;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child) => {
        const key = child.key;
        return exiting.has(key) ? (child) : (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout, mode: mode }, child));
    });
    if (env !== "production" &&
        mode === "wait" &&
        childrenToRender.length > 1) {
        console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
    }
    return (React__namespace.createElement(React__namespace.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map((child) => React.cloneElement(child))));
};

/**
 * @deprecated
 */
const DeprecatedLayoutGroupContext = React.createContext(null);

const notify = (node) => !node.isLayoutDirty && node.willUpdate(false);
function nodeGroup() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = () => nodes.forEach(notify);
    return {
        add: (node) => {
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node) => {
            var _a;
            nodes.delete(node);
            (_a = subscriptions.get(node)) === null || _a === void 0 ? void 0 : _a();
            subscriptions.delete(node);
            dirtyAll();
        },
        dirty: dirtyAll,
    };
}

const shouldInheritGroup = (inherit) => inherit === true;
const shouldInheritId = (inherit) => shouldInheritGroup(inherit === true) || inherit === "id";
const LayoutGroup = ({ children, id, inheritId, inherit = true }) => {
    // Maintain backwards-compatibility with inheritId until 7.0
    if (inheritId !== undefined)
        inherit = inheritId;
    const layoutGroupContext = React.useContext(LayoutGroupContext);
    const deprecatedLayoutGroupContext = React.useContext(DeprecatedLayoutGroupContext);
    const [forceRender, key] = useForceUpdate();
    const context = React.useRef(null);
    const upstreamId = layoutGroupContext.id || deprecatedLayoutGroupContext;
    if (context.current === null) {
        if (shouldInheritId(inherit) && upstreamId) {
            id = id ? upstreamId + "-" + id : upstreamId;
        }
        context.current = {
            id,
            group: shouldInheritGroup(inherit)
                ? layoutGroupContext.group || nodeGroup()
                : nodeGroup(),
        };
    }
    const memoizedContext = React.useMemo(() => ({ ...context.current, forceRender }), [key]);
    return (React__namespace.createElement(LayoutGroupContext.Provider, { value: memoizedContext }, children));
};

let id = 0;
const AnimateSharedLayout = ({ children, }) => {
    React__namespace.useEffect(() => {
        heyListen.warning(false, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
    }, []);
    return (React__namespace.createElement(LayoutGroup, { id: useConstant(() => `asl-${id++}`) }, children));
};

/**
 * `MotionConfig` is used to set configuration options for all children `motion` components.
 *
 * ```jsx
 * import { motion, MotionConfig } from "framer-motion"
 *
 * export function App() {
 *   return (
 *     <MotionConfig transition={{ type: "spring" }}>
 *       <motion.div animate={{ x: 100 }} />
 *     </MotionConfig>
 *   )
 * }
 * ```
 *
 * @public
 */
function MotionConfig({ children, isValidProp, ...config }) {
    isValidProp && loadExternalIsValidProp(isValidProp);
    /**
     * Inherit props from any parent MotionConfig components
     */
    config = { ...React.useContext(MotionConfigContext), ...config };
    /**
     * Don't allow isStatic to change between renders as it affects how many hooks
     * motion components fire.
     */
    config.isStatic = useConstant(() => config.isStatic);
    /**
     * Creating a new config context object will re-render every `motion` component
     * every time it renders. So we only want to create a new one sparingly.
     */
    const context = React.useMemo(() => config, [JSON.stringify(config.transition), config.transformPagePoint, config.reducedMotion]);
    return (React__namespace.createElement(MotionConfigContext.Provider, { value: context }, children));
}

/**
 * Used in conjunction with the `m` component to reduce bundle size.
 *
 * `m` is a version of the `motion` component that only loads functionality
 * critical for the initial render.
 *
 * `LazyMotion` can then be used to either synchronously or asynchronously
 * load animation and gesture support.
 *
 * ```jsx
 * // Synchronous loading
 * import { LazyMotion, m, domAnimations } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={domAnimations}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 *
 * // Asynchronous loading
 * import { LazyMotion, m } from "framer-motion"
 *
 * function App() {
 *   return (
 *     <LazyMotion features={() => import('./path/to/domAnimations')}>
 *       <m.div animate={{ scale: 2 }} />
 *     </LazyMotion>
 *   )
 * }
 * ```
 *
 * @public
 */
function LazyMotion({ children, features, strict = false }) {
    const [, setIsLoaded] = React.useState(!isLazyBundle(features));
    const loadedRenderer = React.useRef(undefined);
    /**
     * If this is a synchronous load, load features immediately
     */
    if (!isLazyBundle(features)) {
        const { renderer, ...loadedFeatures } = features;
        loadedRenderer.current = renderer;
        loadFeatures(loadedFeatures);
    }
    React.useEffect(() => {
        if (isLazyBundle(features)) {
            features().then(({ renderer, ...loadedFeatures }) => {
                loadFeatures(loadedFeatures);
                loadedRenderer.current = renderer;
                setIsLoaded(true);
            });
        }
    }, []);
    return (React__namespace.createElement(LazyContext.Provider, { value: { renderer: loadedRenderer.current, strict } }, children));
}
function isLazyBundle(features) {
    return typeof features === "function";
}

const ReorderContext = React.createContext(null);

function checkReorder(order, value, offset, velocity) {
    if (!velocity)
        return order;
    const index = order.findIndex((item) => item.value === value);
    if (index === -1)
        return order;
    const nextOffset = velocity > 0 ? 1 : -1;
    const nextItem = order[index + nextOffset];
    if (!nextItem)
        return order;
    const item = order[index];
    const nextLayout = nextItem.layout;
    const nextItemCenter = mix(nextLayout.min, nextLayout.max, 0.5);
    if ((nextOffset === 1 && item.layout.max + offset > nextItemCenter) ||
        (nextOffset === -1 && item.layout.min + offset < nextItemCenter)) {
        return moveItem(order, index, index + nextOffset);
    }
    return order;
}

function ReorderGroup({ children, as = "ul", axis = "y", onReorder, values, ...props }, externalRef) {
    const Component = useConstant(() => motion(as));
    const order = [];
    const isReordering = React.useRef(false);
    heyListen.invariant(Boolean(values), "Reorder.Group must be provided a values prop");
    const context = {
        axis,
        registerItem: (value, layout) => {
            /**
             * Ensure entries can't add themselves more than once
             */
            if (layout &&
                order.findIndex((entry) => value === entry.value) === -1) {
                order.push({ value, layout: layout[axis] });
                order.sort(compareMin);
            }
        },
        updateOrder: (id, offset, velocity) => {
            if (isReordering.current)
                return;
            const newOrder = checkReorder(order, id, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder
                    .map(getValue)
                    .filter((value) => values.indexOf(value) !== -1));
            }
        },
    };
    React.useEffect(() => {
        isReordering.current = false;
    });
    return (React__namespace.createElement(Component, { ...props, ref: externalRef },
        React__namespace.createElement(ReorderContext.Provider, { value: context }, children)));
}
const Group = React.forwardRef(ReorderGroup);
function getValue(item) {
    return item.value;
}
function compareMin(a, b) {
    return a.layout.min - b.layout.min;
}

/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    const value = useConstant(() => motionValue(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    const { isStatic } = React.useContext(MotionConfigContext);
    if (isStatic) {
        const [, setLatest] = React.useState(initial);
        React.useEffect(() => value.on("change", setLatest), []);
    }
    return value;
}

const isCustomValueType = (v) => {
    return typeof v === "object" && v.mix;
};
const getMixer = (v) => (isCustomValueType(v) ? v.mix : undefined);
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = interpolate(inputRange, outputRange, {
        mixer: getMixer(outputRange[0]),
        ...options,
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}

function useOnChange(value, callback) {
    useIsomorphicLayoutEffect(() => {
        if (isMotionValue(value)) {
            callback(value.get());
            return value.on("change", callback);
        }
    }, [value, callback]);
}
function useMultiOnChange(values, handler, cleanup) {
    useIsomorphicLayoutEffect(() => {
        const subscriptions = values.map((value) => value.on("change", handler));
        return () => {
            subscriptions.forEach((unsubscribe) => unsubscribe());
            cleanup();
        };
    });
}

function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    const value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    const updateValue = () => value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    useMultiOnChange(values, () => sync.update(updateValue, false, true), () => cancelSync.update(updateValue));
    return value;
}

function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    const transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], ([latest]) => transformer(latest));
}
function useListTransform(values, transformer) {
    const latest = useConstant(() => []);
    return useCombineMotionValues(values, () => {
        latest.length = 0;
        const numValues = values.length;
        for (let i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}

function useDefaultMotionValue(value, defaultValue = 0) {
    return isMotionValue(value) ? value : useMotionValue(defaultValue);
}
function ReorderItem({ children, style = {}, value, as = "li", onDrag, layout = true, ...props }, externalRef) {
    const Component = useConstant(() => motion(as));
    const context = React.useContext(ReorderContext);
    const point = {
        x: useDefaultMotionValue(style.x),
        y: useDefaultMotionValue(style.y),
    };
    const zIndex = useTransform([point.x, point.y], ([latestX, latestY]) => latestX || latestY ? 1 : "unset");
    const measuredLayout = React.useRef(null);
    heyListen.invariant(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    const { axis, registerItem, updateOrder } = context;
    React.useEffect(() => {
        registerItem(value, measuredLayout.current);
    }, [context]);
    return (React__namespace.createElement(Component, { drag: axis, ...props, dragSnapToOrigin: true, style: { ...style, x: point.x, y: point.y, zIndex }, layout: layout, onDrag: (event, gesturePoint) => {
            const { velocity } = gesturePoint;
            velocity[axis] &&
                updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag && onDrag(event, gesturePoint);
        }, onLayoutMeasure: (measured) => {
            measuredLayout.current = measured;
        }, ref: externalRef }, children));
}
const Item = React.forwardRef(ReorderItem);

const Reorder = {
    Group,
    Item,
};

/**
 * @public
 */
const domAnimation = {
    renderer: createDomVisualElement,
    ...animations,
    ...gestureAnimations,
};

/**
 * @public
 */
const domMax = {
    ...domAnimation,
    ...drag,
    ...layoutFeatures,
    projectionNodeConstructor: HTMLProjectionNode,
};

/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments, ...values) {
    /**
     * Create a function that will build a string from the latest motion values.
     */
    const numFragments = fragments.length;
    function buildValue() {
        let output = ``;
        for (let i = 0; i < numFragments; i++) {
            output += fragments[i];
            const value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return useCombineMotionValues(values, buildValue);
}

/**
 * Creates a `MotionValue` that, when `set`, will use a spring animation to animate to its new state.
 *
 * It can either work as a stand-alone `MotionValue` by initialising it with a value, or as a subscriber
 * to another `MotionValue`.
 *
 * @remarks
 *
 * ```jsx
 * const x = useSpring(0, { stiffness: 300 })
 * const y = useSpring(x, { damping: 10 })
 * ```
 *
 * @param inputValue - `MotionValue` or number. If provided a `MotionValue`, when the input `MotionValue` changes, the created `MotionValue` will spring towards that value.
 * @param springConfig - Configuration options for the spring.
 * @returns `MotionValue`
 *
 * @public
 */
function useSpring(source, config = {}) {
    const { isStatic } = React.useContext(MotionConfigContext);
    const activeSpringAnimation = React.useRef(null);
    const value = useMotionValue(isMotionValue(source) ? source.get() : source);
    React.useMemo(() => {
        return value.attach((v, set) => {
            /**
             * A more hollistic approach to this might be to use isStatic to fix VisualElement animations
             * at that level, but this will work for now
             */
            if (isStatic)
                return set(v);
            if (activeSpringAnimation.current) {
                activeSpringAnimation.current.stop();
            }
            activeSpringAnimation.current = animate$1({
                keyframes: [value.get(), v],
                velocity: value.getVelocity(),
                type: "spring",
                ...config,
                onUpdate: set,
            });
            return value.get();
        });
    }, [JSON.stringify(config)]);
    useOnChange(source, (v) => value.set(parseFloat(v)));
    return value;
}

/**
 * Creates a `MotionValue` that updates when the velocity of the provided `MotionValue` changes.
 *
 * ```javascript
 * const x = useMotionValue(0)
 * const xVelocity = useVelocity(x)
 * const xAcceleration = useVelocity(xVelocity)
 * ```
 *
 * @public
 */
function useVelocity(value) {
    const velocity = useMotionValue(value.getVelocity());
    React.useEffect(() => {
        return value.on("velocityChange", (newVelocity) => {
            velocity.set(newVelocity);
        });
    }, [value]);
    return velocity;
}

const createScrollMotionValues = () => ({
    scrollX: motionValue(0),
    scrollY: motionValue(0),
    scrollXProgress: motionValue(0),
    scrollYProgress: motionValue(0),
});
function useScroll({ container, target, layoutEffect = true, ...options } = {}) {
    const values = useConstant(createScrollMotionValues);
    const useLifecycleEffect = layoutEffect
        ? useIsomorphicLayoutEffect
        : React.useEffect;
    useLifecycleEffect(() => {
        return dom.scroll(({ x, y }) => {
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, {
            ...options,
            container: (container === null || container === void 0 ? void 0 : container.current) || undefined,
            target: (target === null || target === void 0 ? void 0 : target.current) || undefined,
        });
    }, []);
    return values;
}

/**
 * @deprecated useElementScroll is deprecated. Convert to useScroll({ container: ref })
 */
function useElementScroll(ref) {
    warnOnce(false, "useElementScroll is deprecated. Convert to useScroll({ container: ref }).");
    return useScroll({ container: ref });
}

/**
 * @deprecated useViewportScroll is deprecated. Convert to useScroll()
 */
function useViewportScroll() {
    warnOnce(false, "useViewportScroll is deprecated. Convert to useScroll().");
    return useScroll();
}

function useAnimationFrame(callback) {
    const initialTimestamp = React.useRef(0);
    const { isStatic } = React.useContext(MotionConfigContext);
    React.useEffect(() => {
        if (isStatic)
            return;
        const provideTimeSinceStart = ({ timestamp, delta }) => {
            if (!initialTimestamp.current)
                initialTimestamp.current = timestamp;
            callback(timestamp - initialTimestamp.current, delta);
        };
        sync.update(provideTimeSinceStart, true);
        return () => cancelSync.update(provideTimeSinceStart);
    }, [callback]);
}

function useTime() {
    const time = useMotionValue(0);
    useAnimationFrame((t) => time.set(t));
    return time;
}

class WillChangeMotionValue extends MotionValue {
    constructor() {
        super(...arguments);
        this.members = [];
        this.transforms = new Set();
    }
    add(name) {
        let memberName;
        if (transformProps.has(name)) {
            this.transforms.add(name);
            memberName = "transform";
        }
        else if (!name.startsWith("origin") &&
            !isCSSVariable$1(name) &&
            name !== "willChange") {
            memberName = camelToDash(name);
        }
        if (memberName) {
            addUniqueItem(this.members, memberName);
            this.update();
        }
    }
    remove(name) {
        if (transformProps.has(name)) {
            this.transforms.delete(name);
            if (!this.transforms.size) {
                removeItem(this.members, "transform");
            }
        }
        else {
            removeItem(this.members, camelToDash(name));
        }
        this.update();
    }
    update() {
        this.set(this.members.length ? this.members.join(", ") : "auto");
    }
}
function useWillChange() {
    return useConstant(() => new WillChangeMotionValue("auto"));
}

function useMotionValueEvent(value, event, callback) {
    useIsomorphicLayoutEffect(() => value.on(event, callback), [value, event, callback]);
}

/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */
function useReducedMotion() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */
    !hasReducedMotionListener.current && initPrefersReducedMotion();
    const [shouldReduceMotion] = React.useState(prefersReducedMotion.current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */
    return shouldReduceMotion;
}

function useReducedMotionConfig() {
    const reducedMotionPreference = useReducedMotion();
    const { reducedMotion } = React.useContext(MotionConfigContext);
    if (reducedMotion === "never") {
        return false;
    }
    else if (reducedMotion === "always") {
        return true;
    }
    else {
        return reducedMotionPreference;
    }
}

/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    let hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    const pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    const subscribers = new Set();
    const controls = {
        subscribe(visualElement) {
            subscribers.add(visualElement);
            return () => void subscribers.delete(visualElement);
        },
        start(definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                const animations = [];
                subscribers.forEach((visualElement) => {
                    animations.push(animateVisualElement(visualElement, definition, {
                        transitionOverride,
                    }));
                });
                return Promise.all(animations);
            }
            else {
                return new Promise((resolve) => {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve,
                    });
                });
            }
        },
        set(definition) {
            heyListen.invariant(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement) => {
                setValues(visualElement, definition);
            });
        },
        stop() {
            subscribers.forEach((visualElement) => {
                stopAnimation(visualElement);
            });
        },
        mount() {
            hasMounted = true;
            pendingAnimations.forEach(({ animation, resolve }) => {
                controls.start(...animation).then(resolve);
            });
            return () => {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}

/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimationControls() {
    const controls = useConstant(animationControls);
    React.useEffect(controls.mount, []);
    return controls;
}
const useAnimation = useAnimationControls;

const wrap = (min, max, v) => {
    const rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

/**
 * Cycles through a series of visual properties. Can be used to toggle between or cycle through animations. It works similar to `useState` in React. It is provided an initial array of possible states, and returns an array of two arguments.
 *
 * An index value can be passed to the returned `cycle` function to cycle to a specific index.
 *
 * ```jsx
 * import * as React from "react"
 * import { motion, useCycle } from "framer-motion"
 *
 * export const MyComponent = () => {
 *   const [x, cycleX] = useCycle(0, 50, 100)
 *
 *   return (
 *     <motion.div
 *       animate={{ x: x }}
 *       onTap={() => cycleX()}
 *      />
 *    )
 * }
 * ```
 *
 * @param items - items to cycle through
 * @returns [currentState, cycleState]
 *
 * @public
 */
function useCycle(...items) {
    const index = React.useRef(0);
    const [item, setItem] = React.useState(items[index.current]);
    const runCycle = React.useCallback((next) => {
        index.current =
            typeof next !== "number"
                ? wrap(0, items.length, index.current + 1)
                : next;
        setItem(items[index.current]);
    }, 
    // The array will change on each call, but by putting items.length at
    // the front of this array, we guarantee the dependency comparison will match up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [items.length, ...items]);
    return [item, runCycle];
}

function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = React.useState(false);
    React.useEffect(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return dom.inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}

/**
 * Can manually trigger a drag gesture on one or more `drag`-enabled `motion` components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
class DragControls {
    constructor() {
        this.componentControls = new Set();
    }
    /**
     * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
     *
     * @internal
     */
    subscribe(controls) {
        this.componentControls.add(controls);
        return () => this.componentControls.delete(controls);
    }
    /**
     * Start a drag gesture on every `motion` component that has this set of drag controls
     * passed into it via the `dragControls` prop.
     *
     * ```jsx
     * dragControls.start(e, {
     *   snapToCursor: true
     * })
     * ```
     *
     * @param event - PointerEvent
     * @param options - Options
     *
     * @public
     */
    start(event, options) {
        this.componentControls.forEach((controls) => {
            controls.start(event.nativeEvent || event, options);
        });
    }
}
const createDragControls = () => new DragControls();
/**
 * Usually, dragging is initiated by pressing down on a `motion` component with a `drag` prop
 * and moving it. For some use-cases, for instance clicking at an arbitrary point on a video scrubber, we
 * might want to initiate that dragging from a different component than the draggable one.
 *
 * By creating a `dragControls` using the `useDragControls` hook, we can pass this into
 * the draggable component's `dragControls` prop. It exposes a `start` method
 * that can start dragging from pointer events on other components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */
function useDragControls() {
    return useConstant(createDragControls);
}

/**
 * Checks if a component is a `motion` component.
 */
function isMotionComponent(component) {
    return (component !== null &&
        typeof component === "object" &&
        motionComponentSymbol in component);
}

/**
 * Unwraps a `motion` component and returns either a string for `motion.div` or
 * the React component for `motion(Component)`.
 *
 * If the component is not a `motion` component it returns undefined.
 */
function unwrapMotionComponent(component) {
    if (isMotionComponent(component)) {
        return component[motionComponentSymbol];
    }
    return undefined;
}

function useInstantLayoutTransition() {
    return startTransition;
}
function startTransition(callback) {
    if (!rootProjectionNode.current)
        return;
    rootProjectionNode.current.isUpdating = false;
    rootProjectionNode.current.blockUpdate();
    callback && callback();
}

function useInstantTransition() {
    const [forceUpdate, forcedRenderCount] = useForceUpdate();
    const startInstantLayoutTransition = useInstantLayoutTransition();
    React.useEffect(() => {
        /**
         * Unblock after two animation frames, otherwise this will unblock too soon.
         */
        sync.postRender(() => sync.postRender(() => (instantAnimationState.current = false)));
    }, [forcedRenderCount]);
    return (callback) => {
        startInstantLayoutTransition(() => {
            instantAnimationState.current = true;
            forceUpdate();
            callback();
        });
    };
}

function useResetProjection() {
    const reset = React__namespace.useCallback(() => {
        const root = rootProjectionNode.current;
        if (!root)
            return;
        root.resetTree();
    }, []);
    return reset;
}

function startOptimizedAppearAnimation(element, name, keyframes, options) {
    window.MotionAppearAnimations || (window.MotionAppearAnimations = new Map());
    const id = element.dataset[optimizedAppearDataId];
    const animation = animateStyle(element, name, keyframes, options);
    if (id && animation) {
        window.MotionAppearAnimations.set(appearStoreId(id, name), animation);
    }
    return animation;
}

const createObject = () => ({});
class StateVisualElement extends VisualElement {
    build() { }
    measureInstanceViewportBox() {
        return createBox();
    }
    resetTransform() { }
    restoreTransform() { }
    removeValueFromRenderState() { }
    renderInstance() { }
    scrapeMotionValuesFromProps() {
        return createObject();
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    readValueFromInstance(_state, key, options) {
        return options.initialState[key] || 0;
    }
    sortInstanceNodePosition() {
        return 0;
    }
    makeTargetAnimatableFromInstance({ transition, transitionEnd, ...target }) {
        const origin = getOrigin(target, transition || {}, this);
        checkTargetForNewValues(this, target, origin);
        return { transition, transitionEnd, ...target };
    }
}
const useVisualState = makeUseVisualState({
    scrapeMotionValuesFromProps: createObject,
    createRenderState: createObject,
});
/**
 * This is not an officially supported API and may be removed
 * on any version.
 */
function useAnimatedState(initialState) {
    const [animationState, setAnimationState] = React.useState(initialState);
    const visualState = useVisualState({}, false);
    const element = useConstant(() => {
        return new StateVisualElement({ props: {}, visualState }, { initialState });
    });
    React.useEffect(() => {
        element.mount({});
        return () => element.unmount();
    }, [element]);
    React.useEffect(() => {
        element.setProps({
            onUpdate: (v) => {
                setAnimationState({ ...v });
            },
        });
    }, [setAnimationState, element]);
    const startAnimation = useConstant(() => (animationDefinition) => {
        return animateVisualElement(element, animationDefinition);
    });
    return [animationState, startAnimation];
}

// Keep things reasonable and avoid scale: Infinity. In practise we might need
// to add another value, opacity, that could interpolate scaleX/Y [0,0.01] => [0,1]
// to simply hide content at unreasonable scales.
const maxScale = 100000;
const invertScale = (scale) => scale > 0.001 ? 1 / scale : maxScale;
let hasWarned = false;
/**
 * Returns a `MotionValue` each for `scaleX` and `scaleY` that update with the inverse
 * of their respective parent scales.
 *
 * This is useful for undoing the distortion of content when scaling a parent component.
 *
 * By default, `useInvertedScale` will automatically fetch `scaleX` and `scaleY` from the nearest parent.
 * By passing other `MotionValue`s in as `useInvertedScale({ scaleX, scaleY })`, it will invert the output
 * of those instead.
 *
 * ```jsx
 * const MyComponent = () => {
 *   const { scaleX, scaleY } = useInvertedScale()
 *   return <motion.div style={{ scaleX, scaleY }} />
 * }
 * ```
 *
 * @deprecated
 */
function useInvertedScale(scale) {
    let parentScaleX = useMotionValue(1);
    let parentScaleY = useMotionValue(1);
    const visualElement = useVisualElementContext();
    heyListen.invariant(!!(scale || visualElement), "If no scale values are provided, useInvertedScale must be used within a child of another motion component.");
    heyListen.warning(hasWarned, "useInvertedScale is deprecated and will be removed in 3.0. Use the layout prop instead.");
    hasWarned = true;
    if (scale) {
        parentScaleX = scale.scaleX || parentScaleX;
        parentScaleY = scale.scaleY || parentScaleY;
    }
    else if (visualElement) {
        parentScaleX = visualElement.getValue("scaleX", 1);
        parentScaleY = visualElement.getValue("scaleY", 1);
    }
    const scaleX = useTransform(parentScaleX, invertScale);
    const scaleY = useTransform(parentScaleY, invertScale);
    return { scaleX, scaleY };
}

exports.AnimatePresence = AnimatePresence;
exports.AnimateSharedLayout = AnimateSharedLayout;
exports.DeprecatedLayoutGroupContext = DeprecatedLayoutGroupContext;
exports.DragControls = DragControls;
exports.FlatTree = FlatTree;
exports.LayoutGroup = LayoutGroup;
exports.LayoutGroupContext = LayoutGroupContext;
exports.LazyMotion = LazyMotion;
exports.MotionConfig = MotionConfig;
exports.MotionConfigContext = MotionConfigContext;
exports.MotionContext = MotionContext;
exports.MotionValue = MotionValue;
exports.PresenceContext = PresenceContext;
exports.Reorder = Reorder;
exports.SwitchLayoutGroupContext = SwitchLayoutGroupContext;
exports.VisualElement = VisualElement;
exports.addPointerEvent = addPointerEvent;
exports.addScaleCorrector = addScaleCorrector;
exports.animate = animate;
exports.animateVisualElement = animateVisualElement;
exports.animationControls = animationControls;
exports.animations = animations;
exports.buildTransform = buildTransform;
exports.calcLength = calcLength;
exports.checkTargetForNewValues = checkTargetForNewValues;
exports.clamp = clamp;
exports.createBox = createBox;
exports.createDomMotionComponent = createDomMotionComponent;
exports.createMotionComponent = createMotionComponent;
exports.delay = delay;
exports.distance = distance;
exports.distance2D = distance2D;
exports.domAnimation = domAnimation;
exports.domMax = domMax;
exports.filterProps = filterProps;
exports.isBrowser = isBrowser;
exports.isDragActive = isDragActive;
exports.isMotionComponent = isMotionComponent;
exports.isMotionValue = isMotionValue;
exports.isValidMotionProp = isValidMotionProp;
exports.m = m;
exports.makeUseVisualState = makeUseVisualState;
exports.mix = mix;
exports.motion = motion;
exports.motionValue = motionValue;
exports.optimizedAppearDataAttribute = optimizedAppearDataAttribute;
exports.pipe = pipe;
exports.resolveMotionValue = resolveMotionValue;
exports.spring = spring;
exports.startOptimizedAppearAnimation = startOptimizedAppearAnimation;
exports.transform = transform;
exports.unwrapMotionComponent = unwrapMotionComponent;
exports.useAnimation = useAnimation;
exports.useAnimationControls = useAnimationControls;
exports.useAnimationFrame = useAnimationFrame;
exports.useCycle = useCycle;
exports.useDeprecatedAnimatedState = useAnimatedState;
exports.useDeprecatedInvertedScale = useInvertedScale;
exports.useDomEvent = useDomEvent;
exports.useDragControls = useDragControls;
exports.useElementScroll = useElementScroll;
exports.useForceUpdate = useForceUpdate;
exports.useInView = useInView;
exports.useInstantLayoutTransition = useInstantLayoutTransition;
exports.useInstantTransition = useInstantTransition;
exports.useIsPresent = useIsPresent;
exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;
exports.useMotionTemplate = useMotionTemplate;
exports.useMotionValue = useMotionValue;
exports.useMotionValueEvent = useMotionValueEvent;
exports.usePresence = usePresence;
exports.useReducedMotion = useReducedMotion;
exports.useReducedMotionConfig = useReducedMotionConfig;
exports.useResetProjection = useResetProjection;
exports.useScroll = useScroll;
exports.useSpring = useSpring;
exports.useTime = useTime;
exports.useTransform = useTransform;
exports.useUnmountEffect = useUnmountEffect;
exports.useVelocity = useVelocity;
exports.useViewportScroll = useViewportScroll;
exports.useVisualElementContext = useVisualElementContext;
exports.useWillChange = useWillChange;
exports.wrap = wrap;
exports.wrapHandler = wrapHandler;


/***/ }),

/***/ 84839:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

function createRenderStep(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData) => {
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
    delta: 0,
    timestamp: 0,
};
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(frame);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frame);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frame.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
const getFrameData = () => frame;

exports.cancelSync = cancelSync;
exports["default"] = sync;
exports.flushSync = flushSync;
exports.getFrameData = getFrameData;


/***/ }),

/***/ 86492:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ 24394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "invariant": function() { return /* binding */ invariant; },
/* harmony export */   "warning": function() { return /* binding */ warning; }
/* harmony export */ });
var warning = function () { };
var invariant = function () { };
if (false) {}




/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 66337:
/***/ (function() {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}

/**
 * Returns the embedding frame element, if any.
 * @param {!Document} doc
 * @return {!Element}
 */
function getFrameElement(doc) {
  try {
    return doc.defaultView && doc.defaultView.frameElement || null;
  } catch (e) {
    // Ignore the error.
    return null;
  }
}

/**
 * A local reference to the root document.
 */
var document = (function(startDoc) {
  var doc = startDoc;
  var frame = getFrameElement(doc);
  while (frame) {
    doc = frame.ownerDocument;
    frame = getFrameElement(doc);
  }
  return doc;
})(window.document);

/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];

/**
 * The signal updater for cross-origin intersection. When not null, it means
 * that the polyfill is configured to work in a cross-origin mode.
 * @type {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
var crossOriginUpdater = null;

/**
 * The current cross-origin intersection. Only used in the cross-origin mode.
 * @type {DOMRect|ClientRect}
 */
var crossOriginRect = null;


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = ensureDOMRect(entry.rootBounds);
  this.boundingClientRect = ensureDOMRect(entry.boundingClientRect);
  this.intersectionRect = ensureDOMRect(entry.intersectionRect || getEmptyRect());
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (
    options.root &&
    options.root.nodeType != 1 &&
    options.root.nodeType != 9
  ) {
    throw new Error('root must be a Document or Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');

  /** @private @const {!Array<!Document>} */
  this._monitoringDocuments = [];
  /** @private @const {!Array<function()>} */
  this._monitoringUnsubscribes = [];
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Sets up the polyfill in the cross-origin mode. The result is the
 * updater function that accepts two arguments: `boundingClientRect` and
 * `intersectionRect` - just as these fields would be available to the
 * parent via `IntersectionObserverEntry`. This function should be called
 * each time the iframe receives intersection information from the parent
 * window, e.g. via messaging.
 * @return {function(DOMRect|ClientRect, DOMRect|ClientRect)}
 */
IntersectionObserver._setupCrossOriginUpdater = function() {
  if (!crossOriginUpdater) {
    /**
     * @param {DOMRect|ClientRect} boundingClientRect
     * @param {DOMRect|ClientRect} intersectionRect
     */
    crossOriginUpdater = function(boundingClientRect, intersectionRect) {
      if (!boundingClientRect || !intersectionRect) {
        crossOriginRect = getEmptyRect();
      } else {
        crossOriginRect = convertFromParentRect(boundingClientRect, intersectionRect);
      }
      registry.forEach(function(observer) {
        observer._checkForIntersections();
      });
    };
  }
  return crossOriginUpdater;
};


/**
 * Resets the cross-origin mode.
 */
IntersectionObserver._resetCrossOriginUpdater = function() {
  crossOriginUpdater = null;
  crossOriginRect = null;
};


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections(target.ownerDocument);
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {
        return item.element != target;
      });
  this._unmonitorIntersections(target.ownerDocument);
  if (this._observationTargets.length == 0) {
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorAllIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function(doc) {
  var win = doc.defaultView;
  if (!win) {
    // Already destroyed.
    return;
  }
  if (this._monitoringDocuments.indexOf(doc) != -1) {
    // Already monitoring.
    return;
  }

  // Private state for monitoring.
  var callback = this._checkForIntersections;
  var monitoringInterval = null;
  var domObserver = null;

  // If a poll interval is set, use polling instead of listening to
  // resize and scroll events or DOM mutations.
  if (this.POLL_INTERVAL) {
    monitoringInterval = win.setInterval(callback, this.POLL_INTERVAL);
  } else {
    addEvent(win, 'resize', callback, true);
    addEvent(doc, 'scroll', callback, true);
    if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in win) {
      domObserver = new win.MutationObserver(callback);
      domObserver.observe(doc, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  this._monitoringDocuments.push(doc);
  this._monitoringUnsubscribes.push(function() {
    // Get the window object again. When a friendly iframe is destroyed, it
    // will be null.
    var win = doc.defaultView;

    if (win) {
      if (monitoringInterval) {
        win.clearInterval(monitoringInterval);
      }
      removeEvent(win, 'resize', callback, true);
    }

    removeEvent(doc, 'scroll', callback, true);
    if (domObserver) {
      domObserver.disconnect();
    }
  });

  // Also monitor the parent.
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._monitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function(doc) {
  var index = this._monitoringDocuments.indexOf(doc);
  if (index == -1) {
    return;
  }

  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;

  // Check if any dependent targets are still remaining.
  var hasDependentTargets =
      this._observationTargets.some(function(item) {
        var itemDoc = item.element.ownerDocument;
        // Target is in this context.
        if (itemDoc == doc) {
          return true;
        }
        // Target is nested in this context.
        while (itemDoc && itemDoc != rootDoc) {
          var frame = getFrameElement(itemDoc);
          itemDoc = frame && frame.ownerDocument;
          if (itemDoc == doc) {
            return true;
          }
        }
        return false;
      });
  if (hasDependentTargets) {
    return;
  }

  // Unsubscribe.
  var unsubscribe = this._monitoringUnsubscribes[index];
  this._monitoringDocuments.splice(index, 1);
  this._monitoringUnsubscribes.splice(index, 1);
  unsubscribe();

  // Also unmonitor the parent.
  if (doc != rootDoc) {
    var frame = getFrameElement(doc);
    if (frame) {
      this._unmonitorIntersections(frame.ownerDocument);
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @param {!Document} doc
 * @private
 */
IntersectionObserver.prototype._unmonitorAllIntersections = function() {
  var unsubscribes = this._monitoringUnsubscribes.slice(0);
  this._monitoringDocuments.length = 0;
  this._monitoringUnsubscribes.length = 0;
  for (var i = 0; i < unsubscribes.length; i++) {
    unsubscribes[i]();
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  if (!this.root && crossOriginUpdater && !crossOriginRect) {
    // Cross origin monitoring, but no initial data available yet.
    return;
  }

  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, targetRect, rootRect);

    var rootBounds = null;
    if (!this._rootContainsTarget(target)) {
      rootBounds = getEmptyRect();
    } else if (!crossOriginUpdater || this.root) {
      rootBounds = rootRect;
    }

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootBounds,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} targetRect The bounding rect of the target.
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, targetRect, rootRect) {
  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot && parent) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return null;

    if (parent == this.root || parent.nodeType == /* DOCUMENT */ 9) {
      atRoot = true;
      if (parent == this.root || parent == document) {
        if (crossOriginUpdater && !this.root) {
          if (!crossOriginRect ||
              crossOriginRect.width == 0 && crossOriginRect.height == 0) {
            // A 0-size cross-origin intersection means no-intersection.
            parent = null;
            parentRect = null;
            intersectionRect = null;
          } else {
            parentRect = crossOriginRect;
          }
        } else {
          parentRect = rootRect;
        }
      } else {
        // Check if there's a frame that can be navigated to.
        var frame = getParentNode(parent);
        var frameRect = frame && getBoundingClientRect(frame);
        var frameIntersect =
            frame &&
            this._computeTargetAndRootIntersection(frame, frameRect, rootRect);
        if (frameRect && frameIntersect) {
          parent = frame;
          parentRect = convertFromParentRect(frameRect, frameIntersect);
        } else {
          parent = null;
          intersectionRect = null;
        }
      }
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      var doc = parent.ownerDocument;
      if (parent != doc.body &&
          parent != doc.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);
    }
    if (!intersectionRect) break;
    parent = parent && getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {ClientRect} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root && !isDoc(this.root)) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var doc = isDoc(this.root) ? this.root : document;
    var html = doc.documentElement;
    var body = doc.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {DOMRect|ClientRect} rect The rect object to expand.
 * @return {ClientRect} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  var rootDoc =
    (this.root && (this.root.ownerDocument || this.root)) || document;
  return (
    containsDeep(rootDoc, target) &&
    (!this.root || rootDoc == target.ownerDocument)
  );
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object|?ClientRect} The intersection rect or undefined if no
 *     intersection is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  } || null;
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {DOMRect|ClientRect} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {ClientRect} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}


/**
 * Ensure that the result has all of the necessary fields of the DOMRect.
 * Specifically this ensures that `x` and `y` fields are set.
 *
 * @param {?DOMRect|?ClientRect} rect
 * @return {?DOMRect}
 */
function ensureDOMRect(rect) {
  // A `DOMRect` object has `x` and `y` fields.
  if (!rect || 'x' in rect) {
    return rect;
  }
  // A IE's `ClientRect` type does not have `x` and `y`. The same is the case
  // for internally calculated Rect objects. For the purposes of
  // `IntersectionObserver`, it's sufficient to simply mirror `left` and `top`
  // for these fields.
  return {
    top: rect.top,
    y: rect.top,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    right: rect.right,
    width: rect.width,
    height: rect.height
  };
}


/**
 * Inverts the intersection and bounding rect from the parent (frame) BCR to
 * the local BCR space.
 * @param {DOMRect|ClientRect} parentBoundingRect The parent's bound client rect.
 * @param {DOMRect|ClientRect} parentIntersectionRect The parent's own intersection rect.
 * @return {ClientRect} The local root bounding rect for the parent's children.
 */
function convertFromParentRect(parentBoundingRect, parentIntersectionRect) {
  var top = parentIntersectionRect.top - parentBoundingRect.top;
  var left = parentIntersectionRect.left - parentBoundingRect.left;
  return {
    top: top,
    left: left,
    height: parentIntersectionRect.height,
    width: parentIntersectionRect.width,
    bottom: top + parentIntersectionRect.height,
    right: left + parentIntersectionRect.width
  };
}


/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (node.nodeType == /* DOCUMENT */ 9 && node != document) {
    // If this node is a document node, look for the embedding frame.
    return getFrameElement(node);
  }

  // If the parent has element that is assigned through shadow root slot
  if (parent && parent.assignedSlot) {
    parent = parent.assignedSlot.parentNode
  }

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  return parent;
}

/**
 * Returns true if `node` is a Document.
 * @param {!Node} node
 * @returns {boolean}
 */
function isDoc(node) {
  return node && node.nodeType === 9;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());


/***/ }),

/***/ 24417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(52217);


/***/ }),

/***/ 52217:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Author: <Ha Huynh> https://github.com/huynhsamha
 * Github: https://github.com/huynhsamha/js-convert-case
 * NPM Package: https://www.npmjs.com/package/js-convert-case
 */
__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = exports.snakeKeys = exports.camelKeys = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var js_camelcase_1 = __webpack_require__(68319);
__webpack_unused_export__ = js_camelcase_1.default;
var js_snakecase_1 = __webpack_require__(2888);
__webpack_unused_export__ = js_snakecase_1.default;
var js_pascalcase_1 = __webpack_require__(50707);
__webpack_unused_export__ = js_pascalcase_1.default;
var js_dotcase_1 = __webpack_require__(9017);
__webpack_unused_export__ = js_dotcase_1.default;
var js_pathcase_1 = __webpack_require__(36293);
__webpack_unused_export__ = js_pathcase_1.default;
var js_textcase_1 = __webpack_require__(80068);
__webpack_unused_export__ = js_textcase_1.default;
var js_sentencecase_1 = __webpack_require__(16433);
__webpack_unused_export__ = js_sentencecase_1.default;
var js_headercase_1 = __webpack_require__(45202);
__webpack_unused_export__ = js_headercase_1.default;
var js_kebabcase_1 = __webpack_require__(25896);
__webpack_unused_export__ = js_kebabcase_1.default;
var lowercase_keys_object_1 = __webpack_require__(29102);
__webpack_unused_export__ = lowercase_keys_object_1.default;
var uppercase_keys_object_1 = __webpack_require__(25745);
__webpack_unused_export__ = uppercase_keys_object_1.default;
var camelcase_keys_object_1 = __webpack_require__(47658);
exports.camelKeys = camelcase_keys_object_1.default;
var snakecase_keys_object_1 = __webpack_require__(16509);
exports.snakeKeys = snakecase_keys_object_1.default;
var pascalcase_keys_object_1 = __webpack_require__(69278);
__webpack_unused_export__ = pascalcase_keys_object_1.default;
var kebabcase_keys_object_1 = __webpack_require__(4703);
__webpack_unused_export__ = kebabcase_keys_object_1.default;
var toLowerCase = function (str) { return String(str || '').toLowerCase(); };
__webpack_unused_export__ = toLowerCase;
var toUpperCase = function (str) { return String(str || '').toUpperCase(); };
__webpack_unused_export__ = toUpperCase;
var jsConvert = {
    toCamelCase: js_camelcase_1.default,
    toSnakeCase: js_snakecase_1.default,
    toPascalCase: js_pascalcase_1.default,
    toDotCase: js_dotcase_1.default,
    toPathCase: js_pathcase_1.default,
    toTextCase: js_textcase_1.default,
    toSentenceCase: js_sentencecase_1.default,
    toHeaderCase: js_headercase_1.default,
    toKebabCase: js_kebabcase_1.default,
    toUpperCase: toUpperCase,
    toLowerCase: toLowerCase,
    lowerKeys: lowercase_keys_object_1.default,
    upperKeys: uppercase_keys_object_1.default,
    camelKeys: camelcase_keys_object_1.default,
    snakeKeys: snakecase_keys_object_1.default,
    pascalKeys: pascalcase_keys_object_1.default,
    kebabKeys: kebabcase_keys_object_1.default
};
__webpack_unused_export__ = jsConvert;


/***/ }),

/***/ 47658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
var js_camelcase_1 = __webpack_require__(68319);
/**
 * Convert string keys in an object to camelCase format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function camelKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = js_camelcase_1.default(key);
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = camelKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = camelKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = camelKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = camelKeys;


/***/ }),

/***/ 4703:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
var js_kebabcase_1 = __webpack_require__(25896);
/**
 * Convert string keys in an object to kebab-case format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function kebabKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = js_kebabcase_1.default(key);
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = kebabKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = kebabKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = kebabKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = kebabKeys;


/***/ }),

/***/ 29102:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
/**
 * Convert string keys in an object to lowercase format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function lowerKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = key.toLowerCase();
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = lowerKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = lowerKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = lowerKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = lowerKeys;


/***/ }),

/***/ 69278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
var js_pascalcase_1 = __webpack_require__(50707);
/**
 * Convert string keys in an object to PascalCase format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function pascalKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = js_pascalcase_1.default(key);
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = pascalKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = pascalKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = pascalKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = pascalKeys;


/***/ }),

/***/ 16509:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
var js_snakecase_1 = __webpack_require__(2888);
/**
 * Convert string keys in an object to snake_case format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function snakeKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = js_snakecase_1.default(key);
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = snakeKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = snakeKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = snakeKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = snakeKeys;


/***/ }),

/***/ 25745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(5920);
/**
 * Convert string keys in an object to UPPERCASE format.
 * @param obj: object to convert keys. If `obj` isn't a json object, `null` is returned.
 * @param opt: (optional) Options parameter, default is non-recursive.
 */
function upperKeys(obj, opt) {
    if (opt === void 0) { opt = utils_1.DefaultOption; }
    if (!utils_1.isValidObject(obj))
        return null;
    opt = utils_1.validateOptions(opt);
    var res = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        var nkey = key.toUpperCase();
        if (opt.recursive) {
            if (utils_1.isValidObject(value)) {
                if (!utils_1.belongToTypes(value, opt.keepTypesOnRecursion)) {
                    value = upperKeys(value, opt);
                }
            }
            else if (opt.recursiveInArray && utils_1.isArrayObject(value)) {
                value = __spreadArrays(value).map(function (v) {
                    var ret = v;
                    if (utils_1.isValidObject(v)) {
                        // object in array
                        if (!utils_1.belongToTypes(ret, opt.keepTypesOnRecursion)) {
                            ret = upperKeys(v, opt);
                        }
                    }
                    else if (utils_1.isArrayObject(v)) {
                        // array in array
                        // workaround by using an object holding array value
                        var temp = upperKeys({ key: v }, opt);
                        ret = temp.key;
                    }
                    return ret;
                });
            }
        }
        res[nkey] = value;
    });
    return res;
}
exports["default"] = upperKeys;


/***/ }),

/***/ 5920:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.belongToTypes = exports.isValidObject = exports.isArrayObject = exports.validateOptions = exports.DefaultOption = void 0;
/**
 * Default options for convert function. This option is not recursive.
 */
exports.DefaultOption = {
    recursive: false,
    recursiveInArray: false,
    keepTypesOnRecursion: []
};
exports.validateOptions = function (opt) {
    if (opt === void 0) { opt = exports.DefaultOption; }
    if (opt.recursive == null) {
        opt = exports.DefaultOption;
    }
    else if (opt.recursiveInArray == null) {
        opt.recursiveInArray = false;
    }
    return opt;
};
exports.isArrayObject = function (obj) { return obj != null && Array.isArray(obj); };
exports.isValidObject = function (obj) { return obj != null && typeof obj === 'object' && !Array.isArray(obj); };
exports.belongToTypes = function (obj, types) { return (types || []).some(function (Type) { return obj instanceof Type; }); };


/***/ }),

/***/ 68319:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toCamelCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/[^A-Za-z0-9]+/g, '$')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "$" + b; })
        .toLowerCase()
        .replace(/(\$)(\w)/g, function (m, a, b) { return b.toUpperCase(); });
}
exports["default"] = toCamelCase;


/***/ }),

/***/ 9017:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toDotCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "_" + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, '.')
        .toLowerCase();
}
exports["default"] = toDotCase;


/***/ }),

/***/ 45202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toHeaderCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "_" + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, ' ')
        .toLowerCase()
        .replace(/( ?)(\w+)( ?)/g, function (m, a, b, c) { return a + b.charAt(0).toUpperCase() + b.slice(1) + c; });
}
exports["default"] = toHeaderCase;


/***/ }),

/***/ 25896:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toKebabCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "_" + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, '-')
        .toLowerCase();
}
exports["default"] = toKebabCase;


/***/ }),

/***/ 50707:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toPascalCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '$')
        .replace(/[^A-Za-z0-9]+/g, '$')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "$" + b; })
        .toLowerCase()
        .replace(/(\$)(\w?)/g, function (m, a, b) { return b.toUpperCase(); });
}
exports["default"] = toPascalCase;


/***/ }),

/***/ 36293:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toPathCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "_" + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, '/')
        .toLowerCase();
}
exports["default"] = toPathCase;


/***/ }),

/***/ 16433:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toSentenceCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    var textcase = String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + "_" + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, ' ')
        .toLowerCase();
    return textcase.charAt(0).toUpperCase() + textcase.slice(1);
}
exports["default"] = toSentenceCase;


/***/ }),

/***/ 2888:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toSnakeCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + '_' + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, '_')
        .toLowerCase();
}
exports["default"] = toSnakeCase;


/***/ }),

/***/ 80068:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function toTextCase(str) {
    if (str === void 0) { str = ''; }
    if (!str)
        return '';
    return String(str)
        .replace(/^[^A-Za-z0-9]*|[^A-Za-z0-9]*$/g, '')
        .replace(/([a-z])([A-Z])/g, function (m, a, b) { return a + '_' + b.toLowerCase(); })
        .replace(/[^A-Za-z0-9]+|_+/g, ' ')
        .toLowerCase();
}
exports["default"] = toTextCase;


/***/ }),

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 77090:
/***/ (function(module) {

(function(window, factory) {
	var lazySizes = factory(window, window.document, Date);
	window.lazySizes = lazySizes;
	if( true && module.exports){
		module.exports = lazySizes;
	}
}(typeof window != 'undefined' ?
      window : {}, 
/**
 * import("./types/global")
 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
 */
function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
	'use strict';
	/*jshint eqnull:true */

	var lazysizes,
		/**
		 * @type { LazySizesConfigPartial }
		 */
		lazySizesCfg;

	(function(){
		var prop;

		var lazySizesDefaults = {
			lazyClass: 'lazyload',
			loadedClass: 'lazyloaded',
			loadingClass: 'lazyloading',
			preloadClass: 'lazypreload',
			errorClass: 'lazyerror',
			//strictClass: 'lazystrict',
			autosizesClass: 'lazyautosizes',
			fastLoadedClass: 'ls-is-cached',
			iframeLoadMode: 0,
			srcAttr: 'data-src',
			srcsetAttr: 'data-srcset',
			sizesAttr: 'data-sizes',
			//preloadAfterLoad: false,
			minSize: 40,
			customMedia: {},
			init: true,
			expFactor: 1.5,
			hFac: 0.8,
			loadMode: 2,
			loadHidden: true,
			ricTimeout: 0,
			throttleDelay: 125,
		};

		lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

		for(prop in lazySizesDefaults){
			if(!(prop in lazySizesCfg)){
				lazySizesCfg[prop] = lazySizesDefaults[prop];
			}
		}
	})();

	if (!document || !document.getElementsByClassName) {
		return {
			init: function () {},
			/**
			 * @type { LazySizesConfigPartial }
			 */
			cfg: lazySizesCfg,
			/**
			 * @type { true }
			 */
			noSupport: true,
		};
	}

	var docElem = document.documentElement;

	var supportPicture = window.HTMLPictureElement;

	var _addEventListener = 'addEventListener';

	var _getAttribute = 'getAttribute';

	/**
	 * Update to bind to window because 'this' becomes null during SSR
	 * builds.
	 */
	var addEventListener = window[_addEventListener].bind(window);

	var setTimeout = window.setTimeout;

	var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

	var requestIdleCallback = window.requestIdleCallback;

	var regPicture = /^picture$/i;

	var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

	var regClassCache = {};

	var forEach = Array.prototype.forEach;

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var hasClass = function(ele, cls) {
		if(!regClassCache[cls]){
			regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
		}
		return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var addClass = function(ele, cls) {
		if (!hasClass(ele, cls)){
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
		}
	};

	/**
	 * @param ele {Element}
	 * @param cls {string}
	 */
	var removeClass = function(ele, cls) {
		var reg;
		if ((reg = hasClass(ele,cls))) {
			ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
		}
	};

	var addRemoveLoadEvents = function(dom, fn, add){
		var action = add ? _addEventListener : 'removeEventListener';
		if(add){
			addRemoveLoadEvents(dom, fn);
		}
		loadEvents.forEach(function(evt){
			dom[action](evt, fn);
		});
	};

	/**
	 * @param elem { Element }
	 * @param name { string }
	 * @param detail { any }
	 * @param noBubbles { boolean }
	 * @param noCancelable { boolean }
	 * @returns { CustomEvent }
	 */
	var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
		var event = document.createEvent('Event');

		if(!detail){
			detail = {};
		}

		detail.instance = lazysizes;

		event.initEvent(name, !noBubbles, !noCancelable);

		event.detail = detail;

		elem.dispatchEvent(event);
		return event;
	};

	var updatePolyfill = function (el, full){
		var polyfill;
		if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
			if(full && full.src && !el[_getAttribute]('srcset')){
				el.setAttribute('srcset', full.src);
			}
			polyfill({reevaluate: true, elements: [el]});
		} else if(full && full.src){
			el.src = full.src;
		}
	};

	var getCSS = function (elem, style){
		return (getComputedStyle(elem, null) || {})[style];
	};

	/**
	 *
	 * @param elem { Element }
	 * @param parent { Element }
	 * @param [width] {number}
	 * @returns {number}
	 */
	var getWidth = function(elem, parent, width){
		width = width || elem.offsetWidth;

		while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
			width =  parent.offsetWidth;
			parent = parent.parentNode;
		}

		return width;
	};

	var rAF = (function(){
		var running, waiting;
		var firstFns = [];
		var secondFns = [];
		var fns = firstFns;

		var run = function(){
			var runFns = fns;

			fns = firstFns.length ? secondFns : firstFns;

			running = true;
			waiting = false;

			while(runFns.length){
				runFns.shift()();
			}

			running = false;
		};

		var rafBatch = function(fn, queue){
			if(running && !queue){
				fn.apply(this, arguments);
			} else {
				fns.push(fn);

				if(!waiting){
					waiting = true;
					(document.hidden ? setTimeout : requestAnimationFrame)(run);
				}
			}
		};

		rafBatch._lsFlush = run;

		return rafBatch;
	})();

	var rAFIt = function(fn, simple){
		return simple ?
			function() {
				rAF(fn);
			} :
			function(){
				var that = this;
				var args = arguments;
				rAF(function(){
					fn.apply(that, args);
				});
			}
		;
	};

	var throttle = function(fn){
		var running;
		var lastTime = 0;
		var gDelay = lazySizesCfg.throttleDelay;
		var rICTimeout = lazySizesCfg.ricTimeout;
		var run = function(){
			running = false;
			lastTime = Date.now();
			fn();
		};
		var idleCallback = requestIdleCallback && rICTimeout > 49 ?
			function(){
				requestIdleCallback(run, {timeout: rICTimeout});

				if(rICTimeout !== lazySizesCfg.ricTimeout){
					rICTimeout = lazySizesCfg.ricTimeout;
				}
			} :
			rAFIt(function(){
				setTimeout(run);
			}, true)
		;

		return function(isPriority){
			var delay;

			if((isPriority = isPriority === true)){
				rICTimeout = 33;
			}

			if(running){
				return;
			}

			running =  true;

			delay = gDelay - (Date.now() - lastTime);

			if(delay < 0){
				delay = 0;
			}

			if(isPriority || delay < 9){
				idleCallback();
			} else {
				setTimeout(idleCallback, delay);
			}
		};
	};

	//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
	var debounce = function(func) {
		var timeout, timestamp;
		var wait = 99;
		var run = function(){
			timeout = null;
			func();
		};
		var later = function() {
			var last = Date.now() - timestamp;

			if (last < wait) {
				setTimeout(later, wait - last);
			} else {
				(requestIdleCallback || run)(run);
			}
		};

		return function() {
			timestamp = Date.now();

			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
		};
	};

	var loader = (function(){
		var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

		var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

		var regImg = /^img$/i;
		var regIframe = /^iframe$/i;

		var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

		var shrinkExpand = 0;
		var currentExpand = 0;

		var isLoading = 0;
		var lowRuns = -1;

		var resetPreloading = function(e){
			isLoading--;
			if(!e || isLoading < 0 || !e.target){
				isLoading = 0;
			}
		};

		var isVisible = function (elem) {
			if (isBodyHidden == null) {
				isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
			}

			return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
		};

		var isNestedVisible = function(elem, elemExpand){
			var outerRect;
			var parent = elem;
			var visible = isVisible(elem);

			eLtop -= elemExpand;
			eLbottom += elemExpand;
			eLleft -= elemExpand;
			eLright += elemExpand;

			while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
				visible = ((getCSS(parent, 'opacity') || 1) > 0);

				if(visible && getCSS(parent, 'overflow') != 'visible'){
					outerRect = parent.getBoundingClientRect();
					visible = eLright > outerRect.left &&
						eLleft < outerRect.right &&
						eLbottom > outerRect.top - 1 &&
						eLtop < outerRect.bottom + 1
					;
				}
			}

			return visible;
		};

		var checkElements = function() {
			var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
				beforeExpandVal, defaultExpand, preloadExpand, hFac;
			var lazyloadElems = lazysizes.elements;

			if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

				i = 0;

				lowRuns++;

				for(; i < eLlen; i++){

					if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

					if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

					if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
						elemExpand = currentExpand;
					}

					if (!defaultExpand) {
						defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
							docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
							lazySizesCfg.expand;

						lazysizes._defEx = defaultExpand;

						preloadExpand = defaultExpand * lazySizesCfg.expFactor;
						hFac = lazySizesCfg.hFac;
						isBodyHidden = null;

						if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
							currentExpand = preloadExpand;
							lowRuns = 0;
						} else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
							currentExpand = defaultExpand;
						} else {
							currentExpand = shrinkExpand;
						}
					}

					if(beforeExpandVal !== elemExpand){
						eLvW = innerWidth + (elemExpand * hFac);
						elvH = innerHeight + elemExpand;
						elemNegativeExpand = elemExpand * -1;
						beforeExpandVal = elemExpand;
					}

					rect = lazyloadElems[i].getBoundingClientRect();

					if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
						(eLtop = rect.top) <= elvH &&
						(eLright = rect.right) >= elemNegativeExpand * hFac &&
						(eLleft = rect.left) <= eLvW &&
						(eLbottom || eLright || eLleft || eLtop) &&
						(lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
						((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
						unveilElement(lazyloadElems[i]);
						loadedSomething = true;
						if(isLoading > 9){break;}
					} else if(!loadedSomething && isCompleted && !autoLoadElem &&
						isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
						(preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
						(preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
						autoLoadElem = preloadElems[0] || lazyloadElems[i];
					}
				}

				if(autoLoadElem && !loadedSomething){
					unveilElement(autoLoadElem);
				}
			}
		};

		var throttledCheckElements = throttle(checkElements);

		var switchLoadingClass = function(e){
			var elem = e.target;

			if (elem._lazyCache) {
				delete elem._lazyCache;
				return;
			}

			resetPreloading(e);
			addClass(elem, lazySizesCfg.loadedClass);
			removeClass(elem, lazySizesCfg.loadingClass);
			addRemoveLoadEvents(elem, rafSwitchLoadingClass);
			triggerEvent(elem, 'lazyloaded');
		};
		var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
		var rafSwitchLoadingClass = function(e){
			rafedSwitchLoadingClass({target: e.target});
		};

		var changeIframeSrc = function(elem, src){
			var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

			// loadMode can be also a string!
			if (loadMode == 0) {
				elem.contentWindow.location.replace(src);
			} else if (loadMode == 1) {
				elem.src = src;
			}
		};

		var handleSources = function(source){
			var customMedia;

			var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

			if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
				source.setAttribute('media', customMedia);
			}

			if(sourceSrcset){
				source.setAttribute('srcset', sourceSrcset);
			}
		};

		var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
			var src, srcset, parent, isPicture, event, firesLoad;

			if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

				if(sizes){
					if(isAuto){
						addClass(elem, lazySizesCfg.autosizesClass);
					} else {
						elem.setAttribute('sizes', sizes);
					}
				}

				srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
				src = elem[_getAttribute](lazySizesCfg.srcAttr);

				if(isImg) {
					parent = elem.parentNode;
					isPicture = parent && regPicture.test(parent.nodeName || '');
				}

				firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

				event = {target: elem};

				addClass(elem, lazySizesCfg.loadingClass);

				if(firesLoad){
					clearTimeout(resetPreloadingTimer);
					resetPreloadingTimer = setTimeout(resetPreloading, 2500);
					addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
				}

				if(isPicture){
					forEach.call(parent.getElementsByTagName('source'), handleSources);
				}

				if(srcset){
					elem.setAttribute('srcset', srcset);
				} else if(src && !isPicture){
					if(regIframe.test(elem.nodeName)){
						changeIframeSrc(elem, src);
					} else {
						elem.src = src;
					}
				}

				if(isImg && (srcset || isPicture)){
					updatePolyfill(elem, {src: src});
				}
			}

			if(elem._lazyRace){
				delete elem._lazyRace;
			}
			removeClass(elem, lazySizesCfg.lazyClass);

			rAF(function(){
				// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
				var isLoaded = elem.complete && elem.naturalWidth > 1;

				if( !firesLoad || isLoaded){
					if (isLoaded) {
						addClass(elem, lazySizesCfg.fastLoadedClass);
					}
					switchLoadingClass(event);
					elem._lazyCache = true;
					setTimeout(function(){
						if ('_lazyCache' in elem) {
							delete elem._lazyCache;
						}
					}, 9);
				}
				if (elem.loading == 'lazy') {
					isLoading--;
				}
			}, true);
		});

		/**
		 *
		 * @param elem { Element }
		 */
		var unveilElement = function (elem){
			if (elem._lazyRace) {return;}
			var detail;

			var isImg = regImg.test(elem.nodeName);

			//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
			var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
			var isAuto = sizes == 'auto';

			if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

			detail = triggerEvent(elem, 'lazyunveilread').detail;

			if(isAuto){
				 autoSizer.updateElem(elem, true, elem.offsetWidth);
			}

			elem._lazyRace = true;
			isLoading++;

			lazyUnveil(elem, detail, isAuto, sizes, isImg);
		};

		var afterScroll = debounce(function(){
			lazySizesCfg.loadMode = 3;
			throttledCheckElements();
		});

		var altLoadmodeScrollListner = function(){
			if(lazySizesCfg.loadMode == 3){
				lazySizesCfg.loadMode = 2;
			}
			afterScroll();
		};

		var onload = function(){
			if(isCompleted){return;}
			if(Date.now() - started < 999){
				setTimeout(onload, 999);
				return;
			}


			isCompleted = true;

			lazySizesCfg.loadMode = 3;

			throttledCheckElements();

			addEventListener('scroll', altLoadmodeScrollListner, true);
		};

		return {
			_: function(){
				started = Date.now();

				lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
				preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

				addEventListener('scroll', throttledCheckElements, true);

				addEventListener('resize', throttledCheckElements, true);

				addEventListener('pageshow', function (e) {
					if (e.persisted) {
						var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

						if (loadingElements.length && loadingElements.forEach) {
							requestAnimationFrame(function () {
								loadingElements.forEach( function (img) {
									if (img.complete) {
										unveilElement(img);
									}
								});
							});
						}
					}
				});

				if(window.MutationObserver){
					new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
				} else {
					docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
					docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
					setInterval(throttledCheckElements, 999);
				}

				addEventListener('hashchange', throttledCheckElements, true);

				//, 'fullscreenchange'
				['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
					document[_addEventListener](name, throttledCheckElements, true);
				});

				if((/d$|^c/.test(document.readyState))){
					onload();
				} else {
					addEventListener('load', onload);
					document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
					setTimeout(onload, 20000);
				}

				if(lazysizes.elements.length){
					checkElements();
					rAF._lsFlush();
				} else {
					throttledCheckElements();
				}
			},
			checkElems: throttledCheckElements,
			unveil: unveilElement,
			_aLSL: altLoadmodeScrollListner,
		};
	})();


	var autoSizer = (function(){
		var autosizesElems;

		var sizeElement = rAFIt(function(elem, parent, event, width){
			var sources, i, len;
			elem._lazysizesWidth = width;
			width += 'px';

			elem.setAttribute('sizes', width);

			if(regPicture.test(parent.nodeName || '')){
				sources = parent.getElementsByTagName('source');
				for(i = 0, len = sources.length; i < len; i++){
					sources[i].setAttribute('sizes', width);
				}
			}

			if(!event.detail.dataAttr){
				updatePolyfill(elem, event.detail);
			}
		});
		/**
		 *
		 * @param elem {Element}
		 * @param dataAttr
		 * @param [width] { number }
		 */
		var getSizeElement = function (elem, dataAttr, width){
			var event;
			var parent = elem.parentNode;

			if(parent){
				width = getWidth(elem, parent, width);
				event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

				if(!event.defaultPrevented){
					width = event.detail.width;

					if(width && width !== elem._lazysizesWidth){
						sizeElement(elem, parent, event, width);
					}
				}
			}
		};

		var updateElementsSizes = function(){
			var i;
			var len = autosizesElems.length;
			if(len){
				i = 0;

				for(; i < len; i++){
					getSizeElement(autosizesElems[i]);
				}
			}
		};

		var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

		return {
			_: function(){
				autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
				addEventListener('resize', debouncedUpdateElementsSizes);
			},
			checkElems: debouncedUpdateElementsSizes,
			updateElem: getSizeElement
		};
	})();

	var init = function(){
		if(!init.i && document.getElementsByClassName){
			init.i = true;
			autoSizer._();
			loader._();
		}
	};

	setTimeout(function(){
		if(lazySizesCfg.init){
			init();
		}
	});

	lazysizes = {
		/**
		 * @type { LazySizesConfigPartial }
		 */
		cfg: lazySizesCfg,
		autoSizer: autoSizer,
		loader: loader,
		init: init,
		uP: updatePolyfill,
		aC: addClass,
		rC: removeClass,
		hC: hasClass,
		fire: triggerEvent,
		gW: getWidth,
		rAF: rAF,
	};

	return lazysizes;
}
));


/***/ }),

/***/ 38554:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = mergeWith;


/***/ }),

/***/ 2962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PB": function() { return /* binding */ NextSeo; },
/* harmony export */   "lX": function() { return /* binding */ DefaultSeo; }
/* harmony export */ });
/* unused harmony exports ArticleJsonLd, BrandJsonLd, BreadcrumbJsonLd, CarouselJsonLd, CollectionPageJsonLd, CorporateContactJsonLd, CourseJsonLd, DatasetJsonLd, EventJsonLd, FAQPageJsonLd, HowToJsonLd, ImageJsonLd, JobPostingJsonLd, LocalBusinessJsonLd, LogoJsonLd, NewsArticleJsonLd, OrganizationJsonLd, ProductJsonLd, ProfilePageJsonLd, QAPageJsonLd, RecipeJsonLd, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd, SoftwareAppJsonLd, VideoGameJsonLd, VideoJsonLd, WebPageJsonLd */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded$x = ["keyOverride"],
  _excluded2$2 = ["crossOrigin"];
var defaults = {
  templateTitle: '',
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
  if (media === void 0) {
    media = [];
  }
  var _ref = _temp === void 0 ? {} : _temp,
    defaultWidth = _ref.defaultWidth,
    defaultHeight = _ref.defaultHeight;
  return media.reduce(function (tags, medium, index) {
    tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:" + mediaType + ":0" + index,
      property: "og:" + mediaType,
      content: medium.url
    }));
    if (medium.alt) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":alt0" + index,
        property: "og:" + mediaType + ":alt",
        content: medium.alt
      }));
    }
    if (medium.secureUrl) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":secure_url0" + index,
        property: "og:" + mediaType + ":secure_url",
        content: medium.secureUrl.toString()
      }));
    }
    if (medium.type) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":type0" + index,
        property: "og:" + mediaType + ":type",
        content: medium.type.toString()
      }));
    }
    if (medium.width) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: medium.width.toString()
      }));
    } else if (defaultWidth) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: defaultWidth.toString()
      }));
    }
    if (medium.height) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: medium.height.toString()
      }));
    } else if (defaultHeight) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: defaultHeight.toString()
      }));
    }
    return tags;
  }, []);
};
var buildTags = function buildTags(config) {
  var _config$openGraph, _config$openGraph3, _config$additionalLin;
  var tagsToRender = [];
  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }
  var updatedTitle = '';
  if (config.title) {
    updatedTitle = config.title;
    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, function () {
        return updatedTitle;
      });
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }
  if (updatedTitle) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
      key: "title"
    }, updatedTitle));
  }
  var noindex = config.noindex === undefined ? defaults.noindex || config.dangerouslySetAllPagesToNoIndex : config.noindex;
  var nofollow = config.nofollow === undefined ? defaults.nofollow || config.dangerouslySetAllPagesToNoFollow : config.nofollow;
  var robotsParams = '';
  if (config.robotsProps) {
    var _config$robotsProps = config.robotsProps,
      nosnippet = _config$robotsProps.nosnippet,
      maxSnippet = _config$robotsProps.maxSnippet,
      maxImagePreview = _config$robotsProps.maxImagePreview,
      maxVideoPreview = _config$robotsProps.maxVideoPreview,
      noarchive = _config$robotsProps.noarchive,
      noimageindex = _config$robotsProps.noimageindex,
      notranslate = _config$robotsProps.notranslate,
      unavailableAfter = _config$robotsProps.unavailableAfter;
    robotsParams = "" + (nosnippet ? ',nosnippet' : '') + (maxSnippet ? ",max-snippet:" + maxSnippet : '') + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : '') + (noarchive ? ',noarchive' : '') + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : '') + (noimageindex ? ',noimageindex' : '') + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : '') + (notranslate ? ',notranslate' : '');
  }
  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }
    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: (noindex ? 'noindex' : 'index') + "," + (nofollow ? 'nofollow' : 'follow') + robotsParams
    }));
  } else {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: "index,follow" + robotsParams
    }));
  }
  if (config.description) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "description",
      name: "description",
      content: config.description
    }));
  }
  if (config.themeColor) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "theme-color",
      name: "theme-color",
      content: config.themeColor
    }));
  }
  if (config.mobileAlternate) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "alternate",
      key: "mobileAlternate",
      media: config.mobileAlternate.media,
      href: config.mobileAlternate.href
    }));
  }
  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach(function (languageAlternate) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
        rel: "alternate",
        key: "languageAlternate-" + languageAlternate.hrefLang,
        hrefLang: languageAlternate.hrefLang,
        href: languageAlternate.href
      }));
    });
  }
  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:card",
        name: "twitter:card",
        content: config.twitter.cardType
      }));
    }
    if (config.twitter.site) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:site",
        name: "twitter:site",
        content: config.twitter.site
      }));
    }
    if (config.twitter.handle) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "twitter:creator",
        name: "twitter:creator",
        content: config.twitter.handle
      }));
    }
  }
  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "fb:app_id",
        property: "fb:app_id",
        content: config.facebook.appId
      }));
    }
  }
  if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
    var _config$openGraph2;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:title",
      property: "og:title",
      content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
    }));
  }
  if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
    var _config$openGraph4;
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
      key: "og:description",
      property: "og:description",
      content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
    }));
  }
  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: config.openGraph.url || config.canonical
      }));
    }
    if (config.openGraph.type) {
      var type = config.openGraph.type.toLowerCase();
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: type
      }));
      if (type === 'profile' && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:first_name",
            property: "profile:first_name",
            content: config.openGraph.profile.firstName
          }));
        }
        if (config.openGraph.profile.lastName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:last_name",
            property: "profile:last_name",
            content: config.openGraph.profile.lastName
          }));
        }
        if (config.openGraph.profile.username) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:username",
            property: "profile:username",
            content: config.openGraph.profile.username
          }));
        }
        if (config.openGraph.profile.gender) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "profile:gender",
            property: "profile:gender",
            content: config.openGraph.profile.gender
          }));
        }
      } else if (type === 'book' && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:author:0" + index,
              property: "book:author",
              content: author
            }));
          });
        }
        if (config.openGraph.book.isbn) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:isbn",
            property: "book:isbn",
            content: config.openGraph.book.isbn
          }));
        }
        if (config.openGraph.book.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "book:release_date",
            property: "book:release_date",
            content: config.openGraph.book.releaseDate
          }));
        }
        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "book:tag:0" + index,
              property: "book:tag",
              content: tag
            }));
          });
        }
      } else if (type === 'article' && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:published_time",
            property: "article:published_time",
            content: config.openGraph.article.publishedTime
          }));
        }
        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:modified_time",
            property: "article:modified_time",
            content: config.openGraph.article.modifiedTime
          }));
        }
        if (config.openGraph.article.expirationTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:expiration_time",
            property: "article:expiration_time",
            content: config.openGraph.article.expirationTime
          }));
        }
        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:author:0" + index,
              property: "article:author",
              content: author
            }));
          });
        }
        if (config.openGraph.article.section) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "article:section",
            property: "article:section",
            content: config.openGraph.article.section
          }));
        }
        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "article:tag:0" + index,
              property: "article:tag",
              content: tag
            }));
          });
        }
      } else if ((type === 'video.movie' || type === 'video.episode' || type === 'video.tv_show' || type === 'video.other') && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach(function (actor, index) {
            if (actor.profile) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:0" + index,
                property: "video:actor",
                content: actor.profile
              }));
            }
            if (actor.role) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
                key: "video:actor:role:0" + index,
                property: "video:actor:role",
                content: actor.role
              }));
            }
          });
        }
        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach(function (director, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:director:0" + index,
              property: "video:director",
              content: director
            }));
          });
        }
        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach(function (writer, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:writer:0" + index,
              property: "video:writer",
              content: writer
            }));
          });
        }
        if (config.openGraph.video.duration) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:duration",
            property: "video:duration",
            content: config.openGraph.video.duration.toString()
          }));
        }
        if (config.openGraph.video.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:release_date",
            property: "video:release_date",
            content: config.openGraph.video.releaseDate
          }));
        }
        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
              key: "video:tag:0" + index,
              property: "video:tag",
              content: tag
            }));
          });
        }
        if (config.openGraph.video.series) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
            key: "video:series",
            property: "video:series",
            content: config.openGraph.video.series
          }));
        }
      }
    }
    // images
    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }
    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }
    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('image', config.openGraph.images, {
        defaultWidth: defaults.defaultOpenGraphImageWidth,
        defaultHeight: defaults.defaultOpenGraphImageHeight
      }));
    }
    // videos
    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }
    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }
    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('video', config.openGraph.videos, {
        defaultWidth: defaults.defaultOpenGraphVideoWidth,
        defaultHeight: defaults.defaultOpenGraphVideoHeight
      }));
    }
    // audio
    if (config.openGraph.audio) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('audio', config.openGraph.audio));
    }
    if (config.openGraph.locale) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:locale",
        property: "og:locale",
        content: config.openGraph.locale
      }));
    }
    if (config.openGraph.siteName || config.openGraph.site_name) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", {
        key: "og:site_name",
        property: "og:site_name",
        content: config.openGraph.siteName || config.openGraph.site_name
      }));
    }
  }
  if (config.canonical) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", {
      rel: "canonical",
      href: config.canonical,
      key: "canonical"
    }));
  }
  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach(function (_ref2) {
      var _ref3, _ref4;
      var keyOverride = _ref2.keyOverride,
        tag = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("meta", _extends({
        key: "meta:" + ((_ref3 = (_ref4 = keyOverride != null ? keyOverride : tag.name) != null ? _ref4 : tag.property) != null ? _ref3 : tag.httpEquiv)
      }, tag)));
    });
  }
  if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
    config.additionalLinkTags.forEach(function (tag) {
      var _rest$keyOverride;
      var tagCrossOrigin = tag.crossOrigin,
        rest = _objectWithoutPropertiesLoose(tag, _excluded2$2);
      var crossOrigin = tagCrossOrigin === 'anonymous' || tagCrossOrigin === 'use-credentials' || tagCrossOrigin === '' ? tagCrossOrigin : undefined;
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("link", _extends({
        key: "link" + ((_rest$keyOverride = rest.keyOverride) != null ? _rest$keyOverride : rest.href) + rest.rel
      }, rest, {
        crossOrigin: crossOrigin
      })));
    });
  }
  return tagsToRender;
};

var WithHead = function WithHead(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, buildTags(props));
};

var DefaultSeo = function DefaultSeo(_ref) {
  var title = _ref.title,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    themeColor = _ref.themeColor,
    _ref$dangerouslySetAl = _ref.dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoIndex = _ref$dangerouslySetAl === void 0 ? false : _ref$dangerouslySetAl,
    _ref$dangerouslySetAl2 = _ref.dangerouslySetAllPagesToNoFollow,
    dangerouslySetAllPagesToNoFollow = _ref$dangerouslySetAl2 === void 0 ? false : _ref$dangerouslySetAl2,
    description = _ref.description,
    canonical = _ref.canonical,
    facebook = _ref.facebook,
    openGraph = _ref.openGraph,
    additionalMetaTags = _ref.additionalMetaTags,
    twitter = _ref.twitter,
    defaultOpenGraphImageWidth = _ref.defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight = _ref.defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth = _ref.defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight = _ref.defaultOpenGraphVideoHeight,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags,
    robotsProps = _ref.robotsProps;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    themeColor: themeColor,
    dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
    dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
    defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
    defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
    defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags,
    robotsProps: robotsProps
  });
};

var NextSeo = function NextSeo(_ref) {
  var title = _ref.title,
    themeColor = _ref.themeColor,
    noindex = _ref.noindex,
    nofollow = _ref.nofollow,
    robotsProps = _ref.robotsProps,
    description = _ref.description,
    canonical = _ref.canonical,
    openGraph = _ref.openGraph,
    facebook = _ref.facebook,
    twitter = _ref.twitter,
    additionalMetaTags = _ref.additionalMetaTags,
    titleTemplate = _ref.titleTemplate,
    defaultTitle = _ref.defaultTitle,
    mobileAlternate = _ref.mobileAlternate,
    languageAlternates = _ref.languageAlternates,
    additionalLinkTags = _ref.additionalLinkTags;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WithHead, {
    title: title,
    themeColor: themeColor,
    noindex: noindex,
    nofollow: nofollow,
    robotsProps: robotsProps,
    description: description,
    canonical: canonical,
    facebook: facebook,
    openGraph: openGraph,
    additionalMetaTags: additionalMetaTags,
    twitter: twitter,
    titleTemplate: titleTemplate,
    defaultTitle: defaultTitle,
    mobileAlternate: mobileAlternate,
    languageAlternates: languageAlternates,
    additionalLinkTags: additionalLinkTags
  }));
};

var toJson = function toJson(type, jsonld) {
  var data = jsonld;
  if (Array.isArray(data) && data.length === 1) {
    data = _extends({}, jsonld[0]);
  }
  var jsonLdObject = Array.isArray(data) ? data.map(function (item) {
    return formatObjectForSchema(type, item);
  }) : formatObjectForSchema(type, data);
  return {
    __html: JSON.stringify(jsonLdObject, safeJsonLdReplacer)
  };
};
var formatObjectForSchema = function formatObjectForSchema(type, jsonld) {
  var _jsonld$id = jsonld.id,
    id = _jsonld$id === void 0 ? undefined : _jsonld$id;
  var updated = _extends({}, id ? {
    '@id': jsonld.id
  } : {}, jsonld);
  delete updated.id;
  return _extends({
    '@context': 'https://schema.org',
    '@type': type
  }, updated);
};
var ESCAPE_ENTITIES = Object.freeze({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join('') + "]", 'g');
var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
  return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
var safeJsonLdReplacer = function () {
  // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
  // Solution from https://stackoverflow.com/a/5499821/864313
  return function (_, value) {
    switch (typeof value) {
      case 'object':
        // Omit null values.
        if (value === null) {
          return undefined;
        }
        return value;
      // JSON.stringify will recursively call replacer.
      case 'number':
      case 'boolean':
      case 'bigint':
        return value;
      // These values are not risky.
      case 'string':
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
      default:
        {
          // JSON.stringify will remove this element.
          return undefined;
        }
    }
  };
}();

var _excluded$w = (/* unused pure expression or super */ null && (["type", "keyOverride", "scriptKey", "scriptId", "dataArray", "useAppDir"]));
function JsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Thing' : _ref$type,
    keyOverride = _ref.keyOverride,
    scriptKey = _ref.scriptKey,
    _ref$scriptId = _ref.scriptId,
    scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId,
    dataArray = _ref.dataArray,
    _ref$useAppDir = _ref.useAppDir,
    useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var JsonLdScript = function JsonLdScript() {
    return /*#__PURE__*/React.createElement("script", {
      type: "application/ld+json",
      id: scriptId,
      "data-testid": scriptId,
      dangerouslySetInnerHTML: toJson(type, dataArray === undefined ? _extends({}, rest) : dataArray),
      key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : '')
    });
  };
  if (useAppDir) {
    return /*#__PURE__*/React.createElement(JsonLdScript, null);
  }
  return /*#__PURE__*/React.createElement(Head, null, JsonLdScript());
}

/**
 * Generate author information
 * @param author
 * @returns
 */
function generateAuthorInfo(author) {
  if (typeof author === 'string') {
    return {
      '@type': 'Person',
      name: author
    };
  } else if (!!author.name) {
    var _author$type;
    return {
      '@type': (_author$type = author == null ? void 0 : author.type) != null ? _author$type : 'Person',
      name: author.name,
      url: author == null ? void 0 : author.url
    };
  }
  return;
}
function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map(function (item) {
      return generateAuthorInfo(item);
    }).filter(function (item) {
      return !!item;
    });
  } else if (author) {
    return generateAuthorInfo(author);
  }
  return;
}

function setImage(image) {
  if (image) {
    return {
      '@type': 'ImageObject',
      url: image
    };
  }
  return undefined;
}

function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return undefined;
  }
  return {
    '@type': 'Organization',
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

function setReviewRating(rating) {
  if (rating) {
    return _extends({}, rating, {
      '@type': 'Rating'
    });
  }
  return undefined;
}

var _excluded$v = (/* unused pure expression or super */ null && (["reviewRating", "author", "publisher"]));
function setReviews(reviews) {
  function mapReview(_ref) {
    var reviewRating = _ref.reviewRating,
      author = _ref.author,
      publisher = _ref.publisher,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
    return _extends({}, rest, {
      '@type': 'Review'
    }, author && {
      author: setAuthor(author)
    }, reviewRating && {
      reviewRating: setReviewRating(reviewRating)
    }, publisher && {
      publisher: setPublisher(publisher.name)
    });
  }
  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }
  return undefined;
}

function setNutrition(calories) {
  if (calories) {
    return {
      '@type': 'NutritionInformation',
      calories: calories + " calories"
    };
  }
  return undefined;
}

function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      '@type': 'AggregateRating',
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue,
      worstRating: aggregateRating.worstRating
    };
  }
  return undefined;
}

function setClip(clips) {
  function mapClip(clip) {
    return _extends({}, clip, {
      '@type': 'Clip'
    });
  }
  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }
  return undefined;
}

function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/WatchAction',
      userInteractionCount: watchCount
    };
  }
  return undefined;
}

function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication) {
    return _extends({}, publication, {
      '@type': 'BroadcastEvent'
    });
  }
  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }
    return mapBroadcastEvent(publication);
  }
  return undefined;
}

var _excluded$u = (/* unused pure expression or super */ null && (["thumbnailUrls", "hasPart", "watchCount", "publication"]));
function setVideo(video, setContext) {
  if (setContext === void 0) {
    setContext = false;
  }
  function mapVideo(_ref, context) {
    var thumbnailUrls = _ref.thumbnailUrls,
      hasPart = _ref.hasPart,
      watchCount = _ref.watchCount,
      publication = _ref.publication,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
    return _extends({}, rest, {
      '@type': 'VideoObject'
    }, context && {
      '@context': 'https://schema.org'
    }, {
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    });
  }
  if (video) {
    return mapVideo(video, setContext);
  }
  return undefined;
}

function setInstruction(instruction) {
  if (instruction) {
    return _extends({}, instruction, {
      '@type': 'HowToStep'
    });
  }
  return undefined;
}

var _excluded$t = (/* unused pure expression or super */ null && (["type", "keyOverride", "ofType", "data"])),
  _excluded2$1 = (/* unused pure expression or super */ null && (["authorName", "images", "yields", "category", "calories", "aggregateRating", "video", "ingredients", "instructions", "cuisine"]));
function CarouselJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Carousel' : _ref$type,
    keyOverride = _ref.keyOverride,
    ofType = _ref.ofType,
    data = _ref.data,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  function generateList(data, ofType) {
    switch (ofType) {
      case 'default':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            url: item.url
          };
        });
      case 'course':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Course',
              url: item.url,
              name: item.courseName,
              description: item.description,
              provider: {
                '@type': 'Organization',
                name: item.providerName,
                sameAs: item.providerUrl
              }
            }
          };
        });
      case 'movie':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Movie',
              name: item.name,
              url: item.url,
              image: item.image,
              dateCreated: item.dateCreated,
              director: item.director ? Array.isArray(item.director) ? item.director.map(function (director) {
                return {
                  '@type': 'Person',
                  name: director.name
                };
              }) : {
                '@type': 'Person',
                name: item.director.name
              } : undefined,
              review: setReviews(item.review)
            }
          };
        });
      case 'recipe':
        return data.map(function (_ref2, index) {
          var authorName = _ref2.authorName,
            images = _ref2.images,
            yields = _ref2.yields,
            category = _ref2.category,
            calories = _ref2.calories,
            aggregateRating = _ref2.aggregateRating,
            video = _ref2.video,
            ingredients = _ref2.ingredients,
            instructions = _ref2.instructions,
            cuisine = _ref2.cuisine,
            rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: _extends({
              '@context': 'https://schema.org',
              '@type': 'Recipe'
            }, rest, {
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            })
          };
        });
    }
  }
  var jsonLdData = _extends({
    '@type': 'ItemList',
    itemListElement: generateList(data, ofType)
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, jsonLdData, {
    scriptKey: "Carousel"
  }));
}

var _excluded$s = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "section", "dateCreated", "datePublished", "dateModified", "authorName", "authorType", "publisherName", "publisherLogo", "body", "isAccessibleForFree"]));
function NewsArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'NewsArticle' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    section = _ref.section,
    dateCreated = _ref.dateCreated,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    publisherName = _ref.publisherName,
    publisherLogo = _ref.publisherLogo,
    body = _ref.body,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var data = _extends({}, rest, {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body,
    isAccessibleForFree: isAccessibleForFree
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "NewsArticle"
  }));
}

var _excluded$r = (/* unused pure expression or super */ null && (["type", "keyOverride", "baseSalary", "hiringOrganization", "applicantLocationRequirements", "experienceRequirements", "jobLocation"]));
function JobPostingJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'JobPosting' : _ref$type,
    keyOverride = _ref.keyOverride,
    baseSalary = _ref.baseSalary,
    hiringOrganization = _ref.hiringOrganization,
    applicantLocationRequirements = _ref.applicantLocationRequirements,
    experienceRequirements = _ref.experienceRequirements,
    jobLocation = _ref.jobLocation,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  function setBaseSalary(baseSalary) {
    if (baseSalary) {
      return {
        '@type': 'MonetaryAmount',
        currency: baseSalary.currency,
        value: _extends({
          '@type': 'QuantitativeValue',
          unitText: baseSalary.unitText
        }, Array.isArray(baseSalary.value) ? {
          minValue: baseSalary.value[0],
          maxValue: baseSalary.value[1]
        } : {
          value: baseSalary.value
        })
      };
    }
    return undefined;
  }
  function setHiringOrganization(org) {
    if (org === 'confidential') {
      return 'confidential';
    }
    return {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }
  function setJobLocation(location) {
    if (location) {
      return {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }
    return undefined;
  }
  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        '@type': 'Country',
        name: requirements
      };
    }
    return undefined;
  }
  function setOccupationalExperienceRequirements(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'OccupationalExperienceRequirements',
        monthsOfExperience: requirements.minimumMonthsOfExperience
      };
    }
    return undefined;
  }
  function setEducationalOccupationalCredential(requirements) {
    if (requirements) {
      return {
        '@type': requirements['@type'] ? requirements['@type'] : 'EducationalOccupationalCredential',
        credentialCategory: requirements.credentialCategory
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements),
    experienceRequirements: setOccupationalExperienceRequirements(experienceRequirements == null ? void 0 : experienceRequirements.occupational),
    educationRequirements: setEducationalOccupationalCredential(experienceRequirements == null ? void 0 : experienceRequirements.educational),
    experienceInPlaceOfEducation: experienceRequirements == null ? void 0 : experienceRequirements.experienceInPlaceOfEducation
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "JobPosting"
  }));
}

function setAddress(address) {
  if (!address) return undefined;
  if (!Array.isArray(address)) return toPostalAddress(address);
  // If array of one address, replace with single address
  if (address.length === 1) return toPostalAddress(address[0]);
  // If array, return mapped array of PostalAddresses
  return address.map(toPostalAddress);
}
function toPostalAddress(address) {
  if (typeof address === 'string') return address;
  return _extends({
    '@type': 'PostalAddress'
  }, address);
}

function setGeo(geo) {
  if (geo) {
    return _extends({}, geo, {
      '@type': 'GeoCoordinates'
    });
  }
  return undefined;
}

function setAction(action) {
  if (action) {
    return {
      '@type': action.actionType,
      name: action.actionName,
      target: action.target
    };
  }
  return undefined;
}

function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }
  return undefined;
}

function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }
    return undefined;
  }
  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return _extends({}, itemOffered, {
        '@type': 'Service'
      });
    }
    return undefined;
  }
  if (offer) {
    return _extends({}, offer, {
      '@type': 'Offer',
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    });
  }
  return undefined;
}

function setOpeningHours(openingHours) {
  if (openingHours) {
    return _extends({}, openingHours, {
      '@type': 'OpeningHoursSpecification'
    });
  }
  return undefined;
}

var _excluded$q = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "geo", "rating", "review", "action", "areaServed", "makesOffer", "openingHours", "images"]));
function LocalBusinessJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'LocalBusiness' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    geo = _ref.geo,
    rating = _ref.rating,
    review = _ref.review,
    action = _ref.action,
    areaServed = _ref.areaServed,
    makesOffer = _ref.makesOffer,
    openingHours = _ref.openingHours,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var data = _extends({}, rest, {
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "LocalBusiness"
  }));
}

var _excluded$p = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"])),
  _excluded2 = (/* unused pure expression or super */ null && (["upvoteCount"]));
function QAPageJsonLd(_ref) {
  var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'QAPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  var data = _extends({}, rest, {
    mainEntity: _extends({}, mainEntity, {
      '@type': 'Question',
      author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
    }, mainEntity.acceptedAnswer && {
      acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
        '@type': 'Answer',
        author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
      })
    }, mainEntity.suggestedAnswer && {
      suggestedAnswer: mainEntity.suggestedAnswer.map(function (_ref2) {
        var _rest$author;
        var upvoteCount = _ref2.upvoteCount,
          rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        return _extends({}, rest, {
          '@type': 'Answer',
          upvoteCount: upvoteCount || 0,
          author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
        });
      })
    })
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "QAPage"
  }));
}

function setItemListElements(items) {
  if (items && items.length) {
    return items.map(function (item) {
      return {
        '@type': 'ListItem',
        position: item.position,
        item: {
          '@id': item.item,
          name: item.name
        }
      };
    });
  }
  return undefined;
}

var _excluded$o = (/* unused pure expression or super */ null && (["type", "keyOverride", "breadcrumb"]));
function ProfilePageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'ProfilePage' : _ref$type,
    keyOverride = _ref.keyOverride,
    breadcrumb = _ref.breadcrumb,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var data = _extends({}, rest, {
    breadcrumb: Array.isArray(breadcrumb) ? {
      '@type': 'BreadcrumbList',
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "ProfilePage"
  }));
}

var _excluded$n = (/* unused pure expression or super */ null && (["type", "keyOverride", "potentialActions"]));
function SiteLinksSearchBoxJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'WebSite' : _ref$type,
    keyOverride = _ref.keyOverride,
    potentialActions = _ref.potentialActions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  function setPotentialAction(action) {
    if (action) {
      var target = action.target,
        queryInput = action.queryInput;
      return {
        '@type': 'SearchAction',
        target: target + "={" + queryInput + "}",
        'query-input': "required name=" + queryInput
      };
    }
    return undefined;
  }
  var data = _extends({}, rest, {
    potentialAction: potentialActions.map(setPotentialAction)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "jsonld-siteLinksSearchBox"
  }));
}

var _excluded$m = (/* unused pure expression or super */ null && (["type", "keyOverride", "authorName", "images", "yields", "category", "cuisine", "calories", "aggregateRating", "video", "ingredients", "instructions"]));
function RecipeJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Recipe' : _ref$type,
    keyOverride = _ref.keyOverride,
    authorName = _ref.authorName,
    images = _ref.images,
    yields = _ref.yields,
    category = _ref.category,
    cuisine = _ref.cuisine,
    calories = _ref.calories,
    aggregateRating = _ref.aggregateRating,
    video = _ref.video,
    ingredients = _ref.ingredients,
    instructions = _ref.instructions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var data = _extends({}, rest, {
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions ? instructions.map(setInstruction) : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "recipe"
  }));
}

function setLocation(location) {
  if (!location) {
    return undefined;
  }
  if (typeof location === 'string') {
    return location;
  }
  if ('url' in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}
function setVirtualLocation(location) {
  return _extends({}, location, {
    '@type': 'VirtualLocation'
  });
}
function setPlace(location) {
  return _extends({}, location, {
    address: setAddress(location.address),
    '@type': 'Place'
  });
}

var _excluded$l = (/* unused pure expression or super */ null && (["type"]));
function setPerformer(performer) {
  if (performer) {
    var type = performer.type,
      restPerformer = _objectWithoutPropertiesLoose(performer, _excluded$l);
    return _extends({}, restPerformer, {
      '@type': type || 'PerformingGroup'
    });
  }
  return undefined;
}

var _excluded$k = (/* unused pure expression or super */ null && (["seller"]));
function setOffers(offers) {
  function mapOffer(_ref) {
    var seller = _ref.seller,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
    return _extends({}, rest, {
      '@type': 'Offer'
    }, seller && {
      seller: {
        '@type': 'Organization',
        name: seller.name
      }
    });
  }
  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }
  return undefined;
}

function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }
  return undefined;
}

var _excluded$j = (/* unused pure expression or super */ null && (["type"]));
function setOrganizer(organizer) {
  if (organizer) {
    var type = organizer.type,
      restOrganizer = _objectWithoutPropertiesLoose(organizer, _excluded$j);
    return _extends({}, restOrganizer, {
      '@type': type || 'Person'
    });
  }
  return undefined;
}

var _excluded$i = (/* unused pure expression or super */ null && (["type", "keyOverride", "location", "images", "offers", "aggregateOffer", "performers", "organizer", "eventStatus", "eventAttendanceMode"]));
function EventJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Event' : _ref$type,
    keyOverride = _ref.keyOverride,
    location = _ref.location,
    images = _ref.images,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    performers = _ref.performers,
    organizer = _ref.organizer,
    eventStatus = _ref.eventStatus,
    eventAttendanceMode = _ref.eventAttendanceMode,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var data = _extends({}, rest, {
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: eventStatus ? "https://schema.org/" + eventStatus : undefined,
    eventAttendanceMode: eventAttendanceMode ? "https://schema.org/" + eventAttendanceMode : undefined
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Event"
  }));
}

function setContactPoint(contactPoint) {
  if (contactPoint) {
    return _extends({}, contactPoint, {
      '@type': 'ContactPoint'
    });
  }
  return undefined;
}

var _excluded$h = (/* unused pure expression or super */ null && (["type", "keyOverride", "contactPoint"]));
function CorporateContactJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var data = _extends({}, rest, {
    contactPoint: contactPoint.map(setContactPoint)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CorporateContact"
  }));
}

function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return _extends({}, creativeWork, {
      '@type': 'CreativeWork'
    });
  }
  return undefined;
}

var _excluded$g = (/* unused pure expression or super */ null && (["type", "keyOverride", "hasPart"]));
function CollectionPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'CollectionPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    hasPart = _ref.hasPart,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var data = _extends({}, rest, {
    hasPart: hasPart.map(setCreativeWork)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CollectionPage"
  }));
}

function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      '@type': 'Organization',
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }
  return undefined;
}

function setBrand(brand) {
  if (brand) {
    return {
      '@type': 'Brand',
      name: brand
    };
  }
  return undefined;
}

var _excluded$f = (/* unused pure expression or super */ null && (["type", "keyOverride", "images", "brand", "reviews", "aggregateRating", "manufacturerLogo", "manufacturerName", "offers", "aggregateOffer", "productName"]));
function ProductJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Product' : _ref$type,
    keyOverride = _ref.keyOverride,
    images = _ref.images,
    brand = _ref.brand,
    reviews = _ref.reviews,
    aggregateRating = _ref.aggregateRating,
    manufacturerLogo = _ref.manufacturerLogo,
    manufacturerName = _ref.manufacturerName,
    offers = _ref.offers,
    aggregateOffer = _ref.aggregateOffer,
    productName = _ref.productName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var data = _extends({}, rest, {
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({
      manufacturerLogo: manufacturerLogo,
      manufacturerName: manufacturerName
    }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Product"
  }));
}

var _excluded$e = (/* unused pure expression or super */ null && (["type", "keyOverride", "priceCurrency", "price", "aggregateRating", "review"]));
function SoftwareAppJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'SoftwareApplication' : _ref$type,
    keyOverride = _ref.keyOverride,
    priceCurrency = _ref.priceCurrency,
    price = _ref.price,
    aggregateRating = _ref.aggregateRating,
    review = _ref.review,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var data = _extends({}, rest, {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "SoftwareApp"
  }));
}

var _excluded$d = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function VideoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Video' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var data = setVideo(rest, true);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Video"
  }));
}

function setProducer(producer) {
  if (producer) {
    return {
      '@type': 'Organization',
      sameAs: producer.url,
      name: producer.name
    };
  }
  return undefined;
}

function setProvider(provider) {
  if (provider) {
    return {
      '@type': provider.type || 'Organization',
      name: provider.name,
      sameAs: provider.url
    };
  }
  return undefined;
}

var _excluded$c = (/* unused pure expression or super */ null && (["type", "keyOverride", "aggregateRating", "trailer", "reviews", "image", "authorName", "provider", "producerName", "producerUrl", "offers", "operatingSystemName", "platformName", "translatorName", "languageName", "genreName", "publisherName"]));
function VideoGameJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'VideoGame' : _ref$type,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    trailer = _ref.trailer,
    reviews = _ref.reviews,
    image = _ref.image,
    authorName = _ref.authorName,
    provider = _ref.provider,
    producerName = _ref.producerName,
    producerUrl = _ref.producerUrl,
    offers = _ref.offers,
    operatingSystemName = _ref.operatingSystemName,
    platformName = _ref.platformName,
    translatorName = _ref.translatorName,
    languageName = _ref.languageName,
    genreName = _ref.genreName,
    publisherName = _ref.publisherName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  var data = _extends({}, rest, {
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({
      name: producerName,
      url: producerUrl
    }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "VideoGame"
  }));
}

function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map(function (contactPoint) {
      return _extends({
        '@type': 'ContactPoint'
      }, contactPoint);
    });
  }
  return undefined;
}

var _excluded$b = (/* unused pure expression or super */ null && (["type", "keyOverride", "address", "contactPoints", "contactPoint"]));
function OrganizationJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    address = _ref.address,
    contactPoints = _ref.contactPoints,
    contactPoint = _ref.contactPoint,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var data = _extends({}, rest, {
    address: setAddress(address),
    contactPoint: setContactPoints(contactPoint || contactPoints)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "organization"
  }));
}

function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map(function (question) {
      return {
        '@type': 'Question',
        name: question.questionName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.acceptedAnswerText
        }
      };
    });
  }
  return undefined;
}

var _excluded$a = (/* unused pure expression or super */ null && (["type", "keyOverride", "mainEntity"]));
function FAQPageJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'FAQPage' : _ref$type,
    keyOverride = _ref.keyOverride,
    mainEntity = _ref.mainEntity,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var data = _extends({}, rest, {
    mainEntity: setQuestions(mainEntity)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "faq-page"
  }));
}

var _excluded$9 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function LogoJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Organization' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "Logo"
  }));
}

var _excluded$8 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function DatasetJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Dataset' : _ref$type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "dataset"
  }));
}

var _excluded$7 = (/* unused pure expression or super */ null && (["type", "keyOverride", "courseName", "provider"]));
function CourseJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Course' : _ref$type,
    keyOverride = _ref.keyOverride,
    courseName = _ref.courseName,
    provider = _ref.provider,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var data = _extends({
    name: courseName
  }, rest, {
    provider: setProvider(provider)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "course"
  }));
}

var _excluded$6 = (/* unused pure expression or super */ null && (["type", "keyOverride", "itemListElements"]));
function BreadCrumbJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'BreadcrumbList' : _ref$type,
    keyOverride = _ref.keyOverride,
    itemListElements = _ref.itemListElements,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var data = _extends({}, rest, {
    itemListElement: setItemListElements(itemListElements)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "breadcrumb"
  }));
}

var _excluded$5 = (/* unused pure expression or super */ null && (["type", "id", "keyOverride", "aggregateRating"]));
function BrandJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Brand' : _ref$type,
    id = _ref.id,
    keyOverride = _ref.keyOverride,
    aggregateRating = _ref.aggregateRating,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var data = _extends({
    aggregateRating: setAggregateRating(aggregateRating),
    '@id': id
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "brand"
  }));
}

var _excluded$4 = (/* unused pure expression or super */ null && (["type", "keyOverride", "url", "title", "images", "datePublished", "dateModified", "authorName", "publisherName", "publisherLogo", "description", "isAccessibleForFree"]));
function ArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Article' : _ref$type,
    keyOverride = _ref.keyOverride,
    url = _ref.url,
    title = _ref.title,
    images = _ref.images,
    datePublished = _ref.datePublished,
    dateModified = _ref.dateModified,
    authorName = _ref.authorName,
    _ref$publisherName = _ref.publisherName,
    publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName,
    _ref$publisherLogo = _ref.publisherLogo,
    publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo,
    description = _ref.description,
    isAccessibleForFree = _ref.isAccessibleForFree,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var data = _extends({
    datePublished: datePublished,
    description: description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    isAccessibleForFree: isAccessibleForFree
  }, rest);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "article"
  }));
}

function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return _extends({
      '@type': (reviewedBy == null ? void 0 : reviewedBy.type) || 'Organization'
    }, reviewedBy);
  }
  return undefined;
}

var _excluded$3 = (/* unused pure expression or super */ null && (["keyOverride", "reviewedBy"]));
function WebPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    reviewedBy = _ref.reviewedBy,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var data = _extends({}, rest, {
    reviewedBy: setReviewedBy(reviewedBy)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    keyOverride: keyOverride
  }, data, {
    type: "WebPage",
    scriptKey: "WebPage"
  }));
}

var _excluded$2 = (/* unused pure expression or super */ null && (["type", "keyOverride"]));
function SocialProfileJsonLd(_ref) {
  var type = _ref.type,
    keyOverride = _ref.keyOverride,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "social"
  }));
}

function setCost(cost) {
  if (cost) {
    return _extends({}, cost, {
      '@type': 'MonetaryAmount'
    });
  }
  return undefined;
}

function setSupply(supply) {
  if (supply) {
    return supply.map(function (supplyItem) {
      return {
        '@type': 'HowToSupply',
        name: supplyItem
      };
    });
  }
  return undefined;
}

function setTool(tool) {
  if (tool) {
    return tool.map(function (toolItem) {
      return {
        '@type': 'HowToTool',
        name: toolItem
      };
    });
  }
  return undefined;
}

function setStep(step) {
  if (step) {
    return step.map(function (stepElement) {
      var itemListElement = stepElement.itemListElement,
        image = stepElement.image;
      var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function (_ref) {
        var type = _ref.type,
          text = _ref.text;
        return {
          '@type': type,
          text: text
        };
      });
      return _extends({}, stepElement, {
        '@type': 'HowToStep',
        itemListElement: currentListElements,
        image: setImage(image)
      });
    });
  }
  return undefined;
}

var _excluded$1 = (/* unused pure expression or super */ null && (["type", "keyOverride", "image", "estimatedCost", "supply", "tool", "step"]));
function howToJsonLd(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'HowTo' : _ref$type,
    keyOverride = _ref.keyOverride,
    image = _ref.image,
    estimatedCost = _ref.estimatedCost,
    supply = _ref.supply,
    tool = _ref.tool,
    step = _ref.step,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var data = _extends({}, rest, {
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  });
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "howTo"
  }));
}

var _excluded = (/* unused pure expression or super */ null && (["keyOverride", "images"]));
function ImageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
    images = _ref.images,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({}, rest, {
    type: "ImageObject",
    keyOverride: keyOverride,
    dataArray: images,
    scriptKey: "image"
  }));
}




/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(19711);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; },
  "requestInterceptor": function() { return /* binding */ requestInterceptor; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation.css
var navigation = __webpack_require__(94375);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(18698);
// EXTERNAL MODULE: ./src/css/index.css
var css = __webpack_require__(36483);
// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/styles.css
var styles = __webpack_require__(77720);
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/style.css
var style = __webpack_require__(86408);
// EXTERNAL MODULE: ./node_modules/@uppy/core/dist/style.css
var dist_style = __webpack_require__(13627);
// EXTERNAL MODULE: ./node_modules/@uppy/status-bar/dist/style.css
var status_bar_dist_style = __webpack_require__(33212);
// EXTERNAL MODULE: ./node_modules/@uppy/informer/dist/style.css
var informer_dist_style = __webpack_require__(40893);
// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(66337);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(77090);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faBlogger.js
var faBlogger = __webpack_require__(99776);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faFacebookF.js
var faFacebookF = __webpack_require__(54470);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faInstagram.js
var faInstagram = __webpack_require__(78279);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faLinkedinIn.js
var faLinkedinIn = __webpack_require__(50263);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faTwitter.js
var faTwitter = __webpack_require__(51719);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faYoutube.js
var faYoutube = __webpack_require__(28138);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/faTiktok.js
var faTiktok = __webpack_require__(41153);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faAngleDown.js
var faAngleDown = __webpack_require__(90770);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faAngleLeft.js
var faAngleLeft = __webpack_require__(77905);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faAngleRight.js
var faAngleRight = __webpack_require__(83183);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faAngleUp.js
var faAngleUp = __webpack_require__(9688);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowCircleLeft.js
var faArrowCircleLeft = __webpack_require__(34019);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowCircleRight.js
var faArrowCircleRight = __webpack_require__(68807);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowDown.js
var faArrowDown = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowLeft.js
var faArrowLeft = __webpack_require__(55346);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(50906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faBars.js
var faBars = __webpack_require__(774);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js
var faCaretDown = __webpack_require__(71421);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCheckCircle.js
var faCheckCircle = __webpack_require__(6811);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faChevronLeft.js
var faChevronLeft = __webpack_require__(85020);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faChevronRight.js
var faChevronRight = __webpack_require__(65394);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCircle.js
var faCircle = __webpack_require__(17319);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCopy.js
var faCopy = __webpack_require__(2909);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faEllipsisV.js
var faEllipsisV = __webpack_require__(73864);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faExclamationCircle.js
var faExclamationCircle = __webpack_require__(20702);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faGift.js
var faGift = __webpack_require__(75969);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faMars.js
var faMars = __webpack_require__(82740);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faMinus.js
var faMinus = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faMouse.js
var faMouse = __webpack_require__(21);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faPlaneDeparture.js
var faPlaneDeparture = __webpack_require__(12714);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faPlus.js
var faPlus = __webpack_require__(40098);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faPlusCircle.js
var faPlusCircle = __webpack_require__(45573);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faPrint.js
var faPrint = __webpack_require__(80264);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faShoppingBasket.js
var faShoppingBasket = __webpack_require__(70952);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faSpinner.js
var faSpinner = __webpack_require__(92332);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faStar.js
var faStar = __webpack_require__(13461);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faThLarge.js
var faThLarge = __webpack_require__(32660);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCross.js
var faCross = __webpack_require__(48626);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faThumbsUp.js
var faThumbsUp = __webpack_require__(59895);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faTimes.js
var faTimes = __webpack_require__(59545);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faTrashAlt.js
var faTrashAlt = __webpack_require__(88673);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faUtensils.js
var faUtensils = __webpack_require__(39216);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faVenus.js
var faVenus = __webpack_require__(66781);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/faCheck.js
var faCheck = __webpack_require__(68055);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCalendarStar.js
var faCalendarStar = __webpack_require__(65586);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faLink.js
var faLink = __webpack_require__(85226);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faAngleLeft.js
var pro_regular_svg_icons_faAngleLeft = __webpack_require__(72839);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faArrowRight.js
var pro_regular_svg_icons_faArrowRight = __webpack_require__(25215);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faBoxHeart.js
var faBoxHeart = __webpack_require__(87680);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCalendarAlt.js
var faCalendarAlt = __webpack_require__(98896);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCalendarStar.js
var pro_regular_svg_icons_faCalendarStar = __webpack_require__(3926);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCheck.js
var pro_regular_svg_icons_faCheck = __webpack_require__(55426);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCommentLines.js
var faCommentLines = __webpack_require__(51379);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCreditCard.js
var faCreditCard = __webpack_require__(82059);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faEnvelope.js
var faEnvelope = __webpack_require__(22159);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faEnvelopeOpen.js
var faEnvelopeOpen = __webpack_require__(25267);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faGift.js
var pro_regular_svg_icons_faGift = __webpack_require__(1966);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faGiftCard.js
var faGiftCard = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faGifts.js
var faGifts = __webpack_require__(16101);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faHandSparkles.js
var faHandSparkles = __webpack_require__(29839);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faLeafHeart.js
var faLeafHeart = __webpack_require__(55203);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faMobile.js
var faMobile = __webpack_require__(18655);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faPaperPlane.js
var faPaperPlane = __webpack_require__(4595);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faPhoneLaptop.js
var faPhoneLaptop = __webpack_require__(2744);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faSignOut.js
var faSignOut = __webpack_require__(27009);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faTimes.js
var pro_regular_svg_icons_faTimes = __webpack_require__(31420);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faTimesCircle.js
var faTimesCircle = __webpack_require__(61210);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faUser.js
var faUser = __webpack_require__(20824);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faWallet.js
var faWallet = __webpack_require__(3457);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faPlayCircle.js
var faPlayCircle = __webpack_require__(62856);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faUndo.js
var faUndo = __webpack_require__(19050);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faChevronDown.js
var faChevronDown = __webpack_require__(13910);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faCheckCircle.js
var pro_regular_svg_icons_faCheckCircle = __webpack_require__(12489);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faPhone.js
var faPhone = __webpack_require__(49008);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var pro_regular_svg_icons = __webpack_require__(68779);
;// CONCATENATED MODULE: ./src/utils/fontAwesome.ts
var library = (__webpack_require__(23636)/* .library */ .vI);











































































library.add(faCross/* faCross */.xb, faBlogger/* faBlogger */._i, faInstagram/* faInstagram */.Zz, faFacebookF/* faFacebookF */.AY, faTwitter/* faTwitter */.md, faLinkedinIn/* faLinkedinIn */.hw, faCreditCard/* faCreditCard */.Oz, faUser/* faUser */.IL, faStar/* faStar */.T, faUtensils/* faUtensils */.fk, faPlaneDeparture/* faPlaneDeparture */.gR, faMouse/* faMouse */.ML, faMars/* faMars */.Ac, faMinus/* faMinus */.Kl, faVenus/* faVenus */.hT, faArrowRight/* faArrowRight */.eF, faBars/* faBars */.xi, faTimes/* faTimes */.NB, faPlus/* faPlus */.r8, faArrowCircleRight/* faArrowCircleRight */.FR, faArrowCircleLeft/* faArrowCircleLeft */.OF, faArrowLeft/* faArrowLeft */.ac, faArrowDown/* faArrowDown */.r5, faCheckCircle/* faCheckCircle */.f8, faCaretDown/* faCaretDown */.eW, faGift/* faGift */.Cl, faPrint/* faPrint */.wf, faTrashAlt/* faTrashAlt */.I7, faCopy/* faCopy */.kZ, faAngleDown/* faAngleDown */.gc, faAngleUp/* faAngleUp */.on, faAngleRight/* faAngleRight */.yO, faAngleLeft/* faAngleLeft */.Ey, faThumbsUp/* faThumbsUp */.u8, faEllipsisV/* faEllipsisV */.iV, faCircle/* faCircle */.di, faShoppingBasket/* faShoppingBasket */.Yc, faPlusCircle/* faPlusCircle */.Kt, faWallet/* faWallet */.X5, faPhone/* faPhone */.j1, faSignOut/* faSignOut */.HE, faChevronRight/* faChevronRight */._t, faChevronLeft/* faChevronLeft */.A3, faGifts/* faGifts */.BH, faPaperPlane/* faPaperPlane */.XC, faLeafHeart/* faLeafHeart */.VW, faEnvelopeOpen/* faEnvelopeOpen */.dw, pro_regular_svg_icons_faCalendarStar/* faCalendarStar */.dZ, faHandSparkles/* faHandSparkles */.oc, faCalendarAlt/* faCalendarAlt */.IV, faMobile/* faMobile */.Z_, faEnvelope/* faEnvelope */.FU, faBoxHeart/* faBoxHeart */.mM, faGiftCard/* faGiftCard */.I1, faExclamationCircle/* faExclamationCircle */.RL, faTimesCircle/* faTimesCircle */.nY, pro_regular_svg_icons_faGift/* faGift */.Cl, pro_regular_svg_icons_faTimes/* faTimes */.NB, faSpinner/* faSpinner */.LM, faHandSparkles/* faHandSparkles */.oc, faPhoneLaptop/* faPhoneLaptop */.Ie, faCommentLines/* faCommentLines */.Of, faThLarge/* faThLarge */.To, faYoutube/* faYoutube */.op, faTiktok/* faTiktok */.AB, faCalendarStar/* faCalendarStar */.dZ, pro_regular_svg_icons_faCheck.faCheck, faPlayCircle/* faPlayCircle */.aQ, faUndo/* faUndo */.X7, pro_regular_svg_icons_faCheckCircle/* faCheckCircle */.f8, faCheck/* faCheck */.LE, faChevronDown/* faChevronDown */.pt, pro_regular_svg_icons_faAngleLeft/* faAngleLeft */.Ey, pro_regular_svg_icons_faArrowRight.faArrowRight, pro_regular_svg_icons/* faSearch */.wn1, pro_regular_svg_icons/* faSlidersH */.MUh, faLink/* faLink */.nN);

// EXTERNAL MODULE: ./node_modules/@module-federation/nextjs-mf/src/include-defaults.js
var include_defaults = __webpack_require__(14473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js + 16 modules
var main = __webpack_require__(27571);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(8678);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils.js
var utils = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextManager.js
var contextManager = __webpack_require__(26839);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(68783);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timeUtils.js
var timeUtils = __webpack_require__(82027);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(99262);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(76876);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(60469);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/error.js
var tools_error = __webpack_require__(37697);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(54910);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(49647);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(59665);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(13842);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/urlPolyfill.js
var urlPolyfill = __webpack_require__(54343);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return ((0,utils/* getType */.oL)(expectedItem) === 'object' &&
        (0,utils/* isMatchOption */.o)(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0,utils/* shallowClone */.mv)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0,utils/* objectEntries */.qP)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0,utils/* find */.sE)(configuration.allowedTracingUrls, function (tracingOption) {
        return (0,utils/* matchList */.v4)([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0,utils/* isNumber */.hj)(configuration.traceSampleRate) || (0,utils/* performDraw */.y7)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0,utils/* assign */.f0)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0,utils/* assign */.f0)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0,utils/* assign */.f0)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0,utils/* assign */.f0)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration.js


function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        display/* display.error */.j.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0,utils/* isPercentage */.zz)(initConfiguration.sessionReplaySampleRate)) {
        display/* display.error */.j.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        display/* display.warn */.j.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !(0,utils/* isPercentage */.zz)(premiumSampleRate)) {
        display/* display.error */.j.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !(0,utils/* isPercentage */.zz)(traceSampleRate)) {
        display/* display.error */.j.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display/* display.error */.j.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return (0,utils/* assign */.f0)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        defaultPrivacyLevel: (0,utils/* objectHasValue */.E5)(configuration_configuration/* DefaultPrivacyLevel */.Jj, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        display/* display.warn */.j.warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            display/* display.error */.j.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.j.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if ((0,utils/* isMatchOption */.o)(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if (isTracingOption(option)) {
                tracingOptions_1.push(option);
            }
            else {
                display/* display.warn */.j.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display/* display.error */.j.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.j.error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test((0,urlPolyfill/* getOrigin */.P$)(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item((0,urlPolyfill/* getOrigin */.P$)(url)); };
    }
    if (match === undefined) {
        display/* display.warn */.j.warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if ((0,utils/* isMatchOption */.o)(option)) {
                usedTracingPropagators.add('datadog');
            }
            else {
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return (0,utils/* arrayFrom */.Oc)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,utils/* assign */.f0)({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)();
    var userContextManager = (0,contextManager/* createContextManager */.W)();
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return (0,utils/* deepClone */.I8)(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
            return;
        }
        if ((0,eventBridge/* canUseEventBridge */.x)()) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        else if (!canHandleSession(initConfiguration)) {
            return;
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('feature_flags')) {
            ;
            rumPublicApi.addFeatureFlagEvaluation = (0,monitor/* monitor */.zk)(function (key, value) {
                addFeatureFlagEvaluationStrategy(key, value);
            });
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = (0,monitor/* monitor */.zk)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = (0,init/* makePublicApi */.r)({
        init: (0,monitor/* monitor */.zk)(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.add),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(globalContextManager.setContextProperty),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.remove),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(globalContextManager.removeContextProperty),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.get),
        getGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.getContext),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.set),
        setGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.setContext),
        clearGlobalContext: (0,monitor/* monitor */.zk)(globalContextManager.clearContext),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        addAction: (0,monitor/* monitor */.zk)(function (name, context) {
            addActionStrategy({
                name: name,
                context: (0,utils/* deepClone */.I8)(context),
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
                type: "custom" /* CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0,tools_error/* createHandlingStack */.Xp)();
            (0,monitor/* callMonitored */.L6)(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0,utils/* deepClone */.I8)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                });
            });
        },
        addTiming: (0,monitor/* monitor */.zk)(function (name, time) {
            addTimingStrategy(name, time);
        }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(userContextManager.getContext),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(userContextManager.removeContextProperty),
        /** @deprecated: renamed to clearUser */
        removeUser: (0,monitor/* monitor */.zk)(userContextManager.clearContext),
        clearUser: (0,monitor/* monitor */.zk)(userContextManager.clearContext),
        startView: startView,
        startSessionReplayRecording: (0,monitor/* monitor */.zk)(recorderApi.start),
        stopSessionReplayRecording: (0,monitor/* monitor */.zk)(recorderApi.stop),
    });
    return rumPublicApi;
    function canHandleSession(initConfiguration) {
        if (!(0,cookie/* areCookiesAuthorized */.oX)((0,configuration_configuration/* buildCookieOptions */.HZ)(initConfiguration))) {
            display/* display.warn */.j.warn('Cookies are not authorized, we will not send any data.');
            return false;
        }
        if (isLocalFile()) {
            display/* display.error */.j.error('Execution is not allowed in the current context.');
            return false;
        }
        return true;
    }
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.j.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,utils/* assign */.f0)({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
    function isLocalFile() {
        return window.location.protocol === 'file:';
    }
}
//# sourceMappingURL=rumPublicApi.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(38971);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(9024);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(18797);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(73473);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
var getZoneJsOriginalValue = __webpack_require__(59693);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new tools_observable/* Observable */.y(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0,monitor/* monitor */.zk)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(utils/* noop */.ZT);
            var originalInstance = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(83206);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/runOnReadyState.js

function runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* LOAD */ : "DOMContentLoaded" /* DOM_CONTENT_LOADED */;
        (0,addEventListener/* addEventListener */.O)(window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* IMAGE */,
        function (initiatorType, path) {
            return (0,utils/* includes */.q9)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* MEDIA */,
        function (initiatorType, path) {
            return (0,utils/* includes */.q9)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) {
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* OTHER */;
    }
    var path = (0,urlPolyfill/* getPathName */.ye)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(startTime, responseEnd));
    }
    return (0,timeUtils/* toServerDuration */.c0)(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0,utils/* assign */.f0)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(start, end)),
        start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function getChildNodes(node) {
    return isNodeShadowHost(node) ? node.shadowRoot.childNodes : node.childNodes;
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * utils/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0,timeUtils/* dateNow */.m6)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0,utils/* findCommaSeparatedValue */.MY)(comment, 'trace-id'), (0,utils/* findCommaSeparatedValue */.MY)(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        setTimeout((0,monitor/* monitor */.zk)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); }));
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0,monitor/* monitor */.zk)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = ['resource', 'navigation', 'longtask', 'paint'];
        var experimentalEntries = ['largest-contentful-paint', 'first-input', 'layout-shift'];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({ type: type, buffered: true });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            performance.addEventListener('resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent('navigation')) {
        retrieveNavigationTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent('first-input')) {
        retrieveFirstInputTiming(function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(callback) {
    runOnReadyState('interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
        };
        if (supportPerformanceTimingEvent('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = (0,utils/* assign */.f0)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0,utils/* assign */.f0)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback((0,utils/* assign */.f0)(computeRelativePerformanceTiming(), {
            entryType: 'navigation',
        }));
    }
    runOnReadyState('complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        setTimeout((0,monitor/* monitor */.zk)(sendFakeTiming));
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(callback) {
    var startTimeStamp = (0,timeUtils/* dateNow */.m6)();
    var timingSent = false;
    var removeEventListeners = (0,addEventListener/* addEventListeners */.y)(window, ["click" /* CLICK */, "mousedown" /* MOUSE_DOWN */, "keydown" /* KEY_DOWN */, "touchstart" /* TOUCH_START */, "pointerdown" /* POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: (0,timeUtils/* relativeNow */._q)(),
            startTime: evt.timeStamp,
        };
        if (evt.type === "pointerdown" /* POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(timing) {
        (0,addEventListener/* addEventListeners */.y)(window, ["pointerup" /* POINTER_UP */, "pointercancel" /* POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0,timeUtils/* dateNow */.m6)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0,utils/* isNumber */.hj)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0,timeUtils/* getRelativeTime */.ni)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return entry.entryType === 'resource' ||
            entry.entryType === 'navigation' ||
            entry.entryType === 'paint' ||
            entry.entryType === 'longtask' ||
            entry.entryType === 'largest-contentful-paint' ||
            entry.entryType === 'first-input' ||
            entry.entryType === 'layout-shift';
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(28393);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0,utils/* deepClone */.I8)(object);
    var result = modifier(clone);
    modifiableFieldPaths.forEach(function (path) {
        var originalValue = get(object, path);
        var newValue = get(clone, path);
        var originalType = (0,utils/* getType */.oL)(originalValue);
        var newType = (0,utils/* getType */.oL)(newValue);
        if (newType === originalType) {
            set(object, path, newValue);
        }
        else if (originalType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, path, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObjectContaining(object, field) {
    return typeof object === 'object' && object !== null && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)();
    var resultId = (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable() {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable();
    }
    return viewportObservable;
}
function createViewportObservable() {
    var observable = new tools_observable/* Observable */.y(function () {
        var updateDimension = (0,utils/* throttle */.P2)((0,monitor/* monitor */.zk)(function () {
            observable.notify(getViewportDimension());
        }), 200).throttled;
        return (0,addEventListener/* addEventListener */.O)(window, "resize" /* RESIZE */, updateDimension, { capture: true, passive: true }).stop;
    });
    return observable;
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js


var viewport;
var stopListeners;
function getDisplayContext() {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('clickmap')) {
        return;
    }
    if (!viewport) {
        viewport = getViewportDimension();
        stopListeners = initViewportObservable().subscribe(function (viewportDimension) {
            viewport = viewportDimension;
        }).unsubscribe;
    }
    return {
        viewport: viewport,
    };
}
function resetDisplayContext() {
    if (stopListeners) {
        stopListeners();
    }
    viewport = undefined;
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.js




var VIEW_EVENTS_MODIFIABLE_FIELD_PATHS = [
    // Fields with sensitive data
    'view.url',
    'view.referrer',
    'action.target.name',
    'error.message',
    'error.stack',
    'error.resource.url',
    'resource.url',
];
var OTHER_EVENTS_MODIFIABLE_FIELD_PATHS = VIEW_EVENTS_MODIFIABLE_FIELD_PATHS.concat([
    // User-customizable field
    'context',
]);
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError) {
    var _a;
    var eventRateLimiters = (_a = {},
        _a["error" /* ERROR */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("error" /* ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _a["action" /* ACTION */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("action" /* ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _a);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        // allow to send events if the session was tracked when they start
        // except for views which are continuously updated
        // TODO: stop sending view updates when session is expired
        var session = sessionManager.findTrackedSession(rawRumEvent.type !== "view" /* VIEW */ ? startTime : undefined);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0,timeUtils/* currentDrift */.QA)(),
                    session: {
                        plan: session.plan,
                    },
                    browser_sdk_version: (0,eventBridge/* canUseEventBridge */.x)() ? "4.34.1" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0,timeUtils/* timeStampNow */.n$)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SYNTHETICS */ : ciTestContext ? "ci_test" /* CI_TEST */ : "user" /* USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: getDisplayContext(),
            };
            var serverRumEvent = (0,utils/* combine */.$e)(rumContext, rawRumEvent);
            serverRumEvent.context = (0,utils/* combine */.$e)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!(0,utils/* isEmptyObject */.Qr)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0,utils/* isEmptyObject */.Qr)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, event.type === "view" /* VIEW */ ? VIEW_EVENTS_MODIFIABLE_FIELD_PATHS : OTHER_EVENTS_MODIFIABLE_FIELD_PATHS, function (event) { return beforeSend(event, domainContext); });
        if (result === false && event.type !== "view" /* VIEW */) {
            return false;
        }
        if (result === false) {
            display/* display.warn */.j.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* ERROR */, "resource" /* RESOURCE */, "long_task" /* LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/foregroundContexts.js

// Arbitrary value to cap number of element mostly for backend & to save bandwidth
var MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS = 500;
// Arbitrary value to cap number of element mostly for memory consumption in the browser
var MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS = 2500;
var foregroundPeriods = [];
function startForegroundContexts() {
    if (document.hasFocus()) {
        addNewForegroundPeriod();
    }
    var stopForegroundTracking = trackFocus(addNewForegroundPeriod).stop;
    var stopBlurTracking = trackBlur(closeForegroundPeriod).stop;
    return {
        isInForegroundAt: isInForegroundAt,
        selectInForegroundPeriodsFor: selectInForegroundPeriodsFor,
        stop: function () {
            foregroundPeriods = [];
            stopForegroundTracking();
            stopBlurTracking();
        },
    };
}
function addNewForegroundPeriod() {
    if (foregroundPeriods.length > MAX_NUMBER_OF_STORED_FOREGROUND_PERIODS) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = (0,timeUtils/* relativeNow */._q)();
    if (currentForegroundPeriod !== undefined && currentForegroundPeriod.end === undefined) {
        return;
    }
    foregroundPeriods.push({
        start: now,
    });
}
function closeForegroundPeriod() {
    if (foregroundPeriods.length === 0) {
        return;
    }
    var currentForegroundPeriod = foregroundPeriods[foregroundPeriods.length - 1];
    var now = (0,timeUtils/* relativeNow */._q)();
    if (currentForegroundPeriod.end !== undefined) {
        return;
    }
    currentForegroundPeriod.end = now;
}
function trackFocus(onFocusChange) {
    return (0,addEventListener/* addEventListener */.O)(window, "focus" /* FOCUS */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onFocusChange();
    });
}
function trackBlur(onBlurChange) {
    return (0,addEventListener/* addEventListener */.O)(window, "blur" /* BLUR */, function (event) {
        if (!event.isTrusted) {
            return;
        }
        onBlurChange();
    });
}
function isInForegroundAt(startTime) {
    for (var i = foregroundPeriods.length - 1; i >= 0; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && startTime > foregroundPeriod.end) {
            break;
        }
        if (startTime > foregroundPeriod.start &&
            (foregroundPeriod.end === undefined || startTime < foregroundPeriod.end)) {
            return true;
        }
    }
    return false;
}
function selectInForegroundPeriodsFor(eventStartTime, duration) {
    var eventEndTime = (0,timeUtils/* addDuration */.WK)(eventStartTime, duration);
    var filteredForegroundPeriods = [];
    var earliestIndex = Math.max(0, foregroundPeriods.length - MAX_NUMBER_OF_SELECTABLE_FOREGROUND_PERIODS);
    for (var i = foregroundPeriods.length - 1; i >= earliestIndex; i--) {
        var foregroundPeriod = foregroundPeriods[i];
        if (foregroundPeriod.end !== undefined && eventStartTime > foregroundPeriod.end) {
            // event starts after the end of the current focus period
            // since the array is sorted, we can stop looking for foreground periods
            break;
        }
        if (eventEndTime < foregroundPeriod.start) {
            // event ends before the start of the current focus period
            // continue to previous one
            continue;
        }
        var startTime = eventStartTime > foregroundPeriod.start ? eventStartTime : foregroundPeriod.start;
        var startDuration = (0,timeUtils/* elapsed */._J)(eventStartTime, startTime);
        var endTime = foregroundPeriod.end === undefined || eventEndTime < foregroundPeriod.end ? eventEndTime : foregroundPeriod.end;
        var endDuration = (0,timeUtils/* elapsed */._J)(startTime, endTime);
        filteredForegroundPeriods.unshift({
            start: (0,timeUtils/* toServerDuration */.c0)(startDuration),
            duration: (0,timeUtils/* toServerDuration */.c0)(endDuration),
        });
    }
    return filteredForegroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js
var LifeCycle = /** @class */ (function () {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    LifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return LifeCycle;
}());

//# sourceMappingURL=lifeCycle.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(78981);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/contextHistory.js
var contextHistory = __webpack_require__(73072);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new contextHistory/* ContextHistory */.W(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(5343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(18679);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(18057);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0,xhrObservable/* initXhrObservable */.S)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0,utils/* tryToClone */.ul)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
    }
    else {
        (0,readBytesFromStream/* readBytesFromStream */.n)(clonedResponse.body, function () {
            callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? utils/* noop */.ZT : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) {
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RESOURCE */:
                eventCounts.resourceCount += 1;
                callback();
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(55801);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js

// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = setTimeout((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration &&
        setTimeout((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: (0,timeUtils/* timeStampNow */.n$)() }); }), maxDuration);
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        clearTimeout(validationTimeoutId);
        clearTimeout(pageActivityEndTimeoutId);
        var lastChangeTime = (0,timeUtils/* timeStampNow */.n$)();
        if (!isBusy) {
            pageActivityEndTimeoutId = setTimeout((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        clearTimeout(validationTimeoutId);
        clearTimeout(pageActivityEndTimeoutId);
        clearTimeout(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new tools_observable/* Observable */.y(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === 'resource' && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return (0,utils/* matchList */.v4)(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = utils/* ONE_SECOND */.WT;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeout;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        clearTimeout(maxDurationBetweenClicksTimeout);
        maxDurationBetweenClicksTimeout = setTimeout((0,monitor/* monitor */.zk)(dontAcceptMoreClick), MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        clearTimeout(maxDurationBetweenClicksTimeout);
        if (status === 0 /* WaitingForMoreClicks */) {
            status = 1 /* WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/browserDetection.js
var browserDetection = __webpack_require__(63002);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0,utils/* find */.sE)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0,utils/* safeTruncate */._z)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0,browserDetection/* isIE */.w)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0,utils/* cssEscape */.QA)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat(element.tagName, ".").concat((0,utils/* cssEscape */.QA)(className));
        }
    }
}
function getTagNameSelector(element) {
    return element.tagName;
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat(element.tagName, "[").concat(attributeName, "=\"").concat((0,utils/* cssEscape */.QA)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat(element.tagName, ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/listenActionEvents.js

function listenActionEvents(_a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0,addEventListener/* addEventListener */.O)(window, "pointerdown" /* POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(window, "selectionchange" /* SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(window, "pointerup" /* POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(window, "input" /* INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/computeFrustration.js

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            utils/* ONE_SECOND */.WT) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0,utils/* elementMatches */.Ap)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/trackClickActions.js








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * utils/* ONE_SECOND */.WT;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * utils/* ONE_MINUTE */.yR; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new contextHistory/* ContextHistory */.W(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new tools_observable/* Observable */.y();
    var currentClickChain;
    lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents({
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var target;
    var position;
    if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('clickmap')) {
        var rect = event.target.getBoundingClientRect();
        target = {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, actionNameAttribute),
        };
        position = {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        };
    }
    return {
        type: "click" /* CLICK */,
        target: target,
        position: position,
        name: getActionNameFromElement(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0,utils/* generateUUID */.DO)();
    var startClocks = (0,timeUtils/* clocksNow */.$I)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0,utils/* includes */.q9)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new tools_observable/* Observable */.y();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0,timeUtils/* getRelativeTime */.ni)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* STOPPED */ || status === 2 /* FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0,utils/* assign */.f0)({
                type: "click" /* CLICK */,
                duration: activityEndTime && (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0,timeUtils/* timeStampNow */.n$)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts) {
    lifeCycle.subscribe(1 /* AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processAction(action, foregroundContexts));
    });
    var actionContexts = { findActionId: utils/* noop */.ZT };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, (0,utils/* assign */.f0)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, foregroundContexts)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, foregroundContexts) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0,timeUtils/* toServerDuration */.c0)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0,utils/* combine */.$e)({
        action: {
            id: (0,utils/* generateUUID */.DO)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* ACTION */,
    }, autoActionProperties);
    var inForeground = foregroundContexts.isInForegroundAt(action.startClocks.relative);
    if (inForeground !== undefined) {
        actionEvent.view = { in_foreground: inForeground };
    }
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js + 1 modules
var trackRuntimeError = __webpack_require__(6299);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(1307);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(86296);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = (0,consoleObservable/* initConsoleObservable */.a)([display/* ConsoleApiName.error */.v.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: consoleError.message,
            stack: consoleError.stack,
            source: tools_error/* ErrorSource.CONSOLE */.zH.CONSOLE,
            handling: "handled" /* HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(73670);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/trackReportError.js

function trackReportError(errorObservable) {
    var subscription = (0,reportObservable/* initReportObservable */.v)([reportObservable/* RawReportType.cspViolation */._.cspViolation, reportObservable/* RawReportType.intervention */._.intervention]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: tools_error/* ErrorSource.REPORT */.zH.REPORT,
            handling: "unhandled" /* UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/error/errorCollection.js



function startErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    var errorObservable = new tools_observable/* Observable */.y();
    trackConsoleError(errorObservable);
    (0,trackRuntimeError/* trackRuntimeError */.L)(errorObservable);
    trackReportError(errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts) {
    lifeCycle.subscribe(12 /* RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, (0,utils/* assign */.f0)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, foregroundContexts, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,tools_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: 'Provided',
                source: tools_error/* ErrorSource.CUSTOM */.zH.CUSTOM,
                handling: "handled" /* HANDLED */,
            });
            lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, foregroundContexts, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0,utils/* generateUUID */.DO)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
        },
        type: "error" /* ERROR */,
    };
    var inForeground = foregroundContexts.isInForegroundAt(error.startClocks.relative);
    if (inForeground) {
        rawRumEvent.view = { in_foreground: inForeground };
    }
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0,utils/* isEmptyObject */.Qr)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/longTask/longTaskCollection.js

function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== 'longtask') {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,utils/* generateUUID */.DO)(),
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                },
                type: "long_task" /* LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/matchRequestTiming.js


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return (0,timeUtils/* addDuration */.WK)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0,timeUtils/* addDuration */.WK)(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/resource/resourceCollection.js



function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'resource' && !isRequestKind(entry)) {
                lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* XHR */ ? "xhr" /* XHR */ : "fetch" /* FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? (0,timeUtils/* relativeToClocks */.DY)(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = (0,timeUtils/* toServerDuration */.c0)(request.duration);
    var durationOverrideInfo = computeDurationOverrideInfo(duration, correspondingTimingOverrides === null || correspondingTimingOverrides === void 0 ? void 0 : correspondingTimingOverrides.resource.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0,utils/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,utils/* generateUUID */.DO)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, durationOverrideInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0,utils/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,utils/* generateUUID */.DO)(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0,utils/* assign */.f0)({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeDurationOverrideInfo(computedDuration, performanceEntryDuration) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('resource_durations')) {
        return;
    }
    return {
        _dd: {
            computed_duration: computedDuration,
            performance_entry_duration: performanceEntryDuration,
            override_duration_diff: performanceEntryDuration ? computedDuration - performanceEntryDuration : undefined,
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0,utils/* isNumber */.hj)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('resource_page_states')) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackFirstHidden.js

var trackFirstHiddenSingleton;
var trackFirstHidden_stopListeners;
function trackFirstHidden(eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    if (!trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') {
            trackFirstHiddenSingleton = {
                timeStamp: 0,
            };
        }
        else {
            trackFirstHiddenSingleton = {
                timeStamp: Infinity,
            };
            (trackFirstHidden_stopListeners = (0,addEventListener/* addEventListeners */.y)(eventTarget, ["pagehide" /* PAGE_HIDE */, "visibilitychange" /* VISIBILITY_CHANGE */], function (event) {
                if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
                    trackFirstHiddenSingleton.timeStamp = event.timeStamp;
                    trackFirstHidden_stopListeners();
                }
            }, { capture: true }).stop);
        }
    }
    return trackFirstHiddenSingleton;
}
function resetFirstHidden() {
    if (trackFirstHidden_stopListeners) {
        trackFirstHidden_stopListeners();
    }
    trackFirstHiddenSingleton = undefined;
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackInitialViewTimings.js


// Discard LCP and FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var TIMING_MAXIMUM_DELAY = 10 * utils/* ONE_MINUTE */.yR;
function trackInitialViewTimings(lifeCycle, callback) {
    var timings = {};
    function setTimings(newTimings) {
        (0,utils/* assign */.f0)(timings, newTimings);
        callback(timings);
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, setTimings).stop;
    var stopFCPTracking = trackFirstContentfulPaintTiming(lifeCycle, function (firstContentfulPaint) {
        return setTimings({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaintTiming(lifeCycle, window, function (largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime;
        setTimings({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    return {
        stop: function () {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        },
    };
}
function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'navigation') {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0,timeUtils/* relativeNow */._q)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
function trackFirstContentfulPaintTiming(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0,utils/* find */.sE)(entries, function (entry) {
            return entry.entryType === 'paint' &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return { stop: stop };
}
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getLCP.ts
 */
function trackLargestContentfulPaintTiming(lifeCycle, eventTarget, callback) {
    var firstHidden = trackFirstHidden();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0,addEventListener/* addEventListeners */.y)(eventTarget, ["pointerdown" /* POINTER_DOWN */, "keydown" /* KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0,utils/* findLast */.dF)(entries, function (entry) {
            return entry.entryType === 'largest-contentful-paint' &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < TIMING_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            callback(lcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInputTimings(lifeCycle, callback) {
    var firstHidden = trackFirstHidden();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0,utils/* find */.sE)(entries, function (entry) {
            return entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0,timeUtils/* elapsed */._J)(firstInputEntry.startTime, firstInputEntry.processingStart);
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                firstInputDelay: firstInputDelay >= 0 ? firstInputDelay : 0,
                firstInputTime: firstInputEntry.startTime,
            });
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
//# sourceMappingURL=trackInitialViewTimings.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewMetrics.js



function trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var viewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        viewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopCLSTracking;
    if (isLayoutShiftSupported()) {
        viewMetrics.cumulativeLayoutShift = 0;
        (stopCLSTracking = trackCumulativeLayoutShift(lifeCycle, function (cumulativeLayoutShift) {
            viewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
            scheduleViewUpdate();
        }).stop);
    }
    else {
        stopCLSTracking = utils/* noop */.ZT;
    }
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
        },
        setLoadEvent: setLoadEvent,
        viewMetrics: viewMetrics,
    };
}
function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0,timeUtils/* elapsed */._J)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(lifeCycle, callback) {
    var maxClsValue = 0;
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    callback((0,utils/* round */.NM)(maxClsValue, 4));
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    return {
        update: function (entry) {
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= utils/* ONE_SECOND */.WT ||
                entry.startTime - startTime >= 5 * utils/* ONE_SECOND */.WT;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
        },
        value: function () { return value; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent('layout-shift');
}
//# sourceMappingURL=trackViewMetrics.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViewEventCounts.js


// Some events are not being counted as they transcend views. To reduce the occurrence;
// an arbitrary delay is added for stopping event counting after the view ends.
//
// Ideally, we would not stop and keep counting events until the end of the session.
// But this might have a small performance impact if there are many many views:
// we would need to go through each event to see if the related view matches.
// So let's have a fairly short delay to avoid impacting performances too much.
//
// In the future, we could have views stored in a data structure similar to ContextHistory. Whenever
// a child event is collected, we could look into this history to find the matching view and
// increase the associated and increase its counter. Having a centralized data structure for it
// would allow us to look for views more efficiently.
//
// For now, having a small cleanup delay will already improve the situation in most cases.
var KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY = 5 * utils/* ONE_MINUTE */.yR;
function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        scheduleStop: function () {
            setTimeout((0,monitor/* monitor */.zk)(stop), KEEP_TRACKING_EVENT_COUNTS_AFTER_VIEW_DELAY);
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * utils/* ONE_MINUTE */.yR;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var _a = trackInitialView(initialViewOptions), stopInitialViewTracking = _a.stop, initialView = _a.initialView;
    var currentView = initialView;
    var stopViewLifeCycle = startViewLifeCycle().stop;
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function trackInitialView(options) {
        var initialView = newView(lifeCycle, domMutationObservable, configuration, location, "initial_load" /* INITIAL_LOAD */, (0,timeUtils/* clocksOrigin */.cQ)(), options);
        var stop = trackInitialViewTimings(lifeCycle, function (timings) {
            initialView.updateTimings(timings);
            initialView.scheduleUpdate();
        }).stop;
        return { initialView: initialView, stop: stop };
    }
    function trackViewChange(startClocks, viewOptions) {
        return newView(lifeCycle, domMutationObservable, configuration, location, "route_change" /* ROUTE_CHANGE */, startClocks, viewOptions);
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
            // do not trigger view update to avoid wrong data
            currentView.end();
            // Renew view on session renewal
            currentView = trackViewChange(undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING) {
                currentView.end();
                currentView.triggerUpdate();
            }
        });
        // Session keep alive
        var keepAliveInterval = window.setInterval((0,monitor/* monitor */.zk)(function () {
            currentView.triggerUpdate();
        }), SESSION_KEEP_ALIVE_INTERVAL);
        return {
            stop: function () {
                clearInterval(keepAliveInterval);
            },
        };
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView.triggerUpdate();
                currentView = trackViewChange();
                return;
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
            currentView.addTiming(name, time);
            currentView.scheduleUpdate();
        },
        startView: function (options, startClocks) {
            currentView.end(startClocks);
            currentView.triggerUpdate();
            currentView = trackViewChange(startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            stopInitialViewTracking();
            stopViewLifeCycle();
            currentView.end();
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
    // Setup initial values
    var id = (0,utils/* generateUUID */.DO)();
    var timings = {};
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0,utils/* shallowClone */.mv)(initialLocation);
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = (0,utils/* throttle */.P2)((0,monitor/* monitor */.zk)(triggerViewUpdate), THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopViewMetricsTracking = _b.stop, viewMetrics = _b.viewMetrics;
    var _c = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), scheduleStopEventCountsTracking = _c.scheduleStop, eventCounts = _c.eventCounts;
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0,timeUtils/* timeStampNow */.n$)() : endClocks.timeStamp;
        lifeCycle.notify(3 /* VIEW_UPDATED */, (0,utils/* assign */.f0)({
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            timings: timings,
            duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            eventCounts: eventCounts,
        }, viewMetrics));
    }
    return {
        name: name,
        service: service,
        version: version,
        scheduleUpdate: scheduleViewUpdate,
        end: function (clocks) {
            if (clocks === void 0) { clocks = (0,timeUtils/* clocksNow */.$I)(); }
            endClocks = clocks;
            lifeCycle.notify(4 /* VIEW_ENDED */, { endClocks: endClocks });
            stopViewMetricsTracking();
            scheduleStopEventCountsTracking();
        },
        triggerUpdate: function () {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function (newTimings) {
            timings = newTimings;
            if (newTimings.loadEvent !== undefined) {
                setLoadEvent(newTimings.loadEvent);
            }
        },
        addTiming: function (name, time) {
            var relativeTime = (0,timeUtils/* looksLikeRelativeTime */.Cn)(time) ? time : (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display/* display.warn */.j.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumEventsCollection/view/viewCollection.js


function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, foregroundContexts, featureFlagContexts, recorderApi) {
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: view.cumulativeLayoutShift,
            first_byte: (0,timeUtils/* toServerDuration */.c0)(view.timings.firstByte),
            dom_complete: (0,timeUtils/* toServerDuration */.c0)(view.timings.domComplete),
            dom_content_loaded: (0,timeUtils/* toServerDuration */.c0)(view.timings.domContentLoaded),
            dom_interactive: (0,timeUtils/* toServerDuration */.c0)(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.timings.firstContentfulPaint),
            first_input_delay: (0,timeUtils/* toServerDuration */.c0)(view.timings.firstInputDelay),
            first_input_time: (0,timeUtils/* toServerDuration */.c0)(view.timings.firstInputTime),
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.timings.largestContentfulPaint),
            load_event: (0,timeUtils/* toServerDuration */.c0)(view.timings.loadEvent),
            loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(view.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0,timeUtils/* toServerDuration */.c0)(view.duration),
            in_foreground_periods: foregroundContexts.selectInForegroundPeriodsFor(view.startClocks.relative, view.duration),
        },
        feature_flags: featureFlagContext && !(0,utils/* isEmptyObject */.Qr)(featureFlagContext) ? featureFlagContext : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
        },
    };
    if (!(0,utils/* isEmptyObject */.Qr)(view.customTimings)) {
        viewEvent.view.custom_timings = (0,utils/* mapValues */.Q8)(view.customTimings, timeUtils/* toServerDuration */.c0);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0,utils/* isNumber */.hj)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js + 3 modules
var session_sessionManager = __webpack_require__(73186);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration.cookieOptions, RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* WITH_SESSION_REPLAY */
                : 1 /* WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* WITH_SESSION_REPLAY */,
            };
        },
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0,utils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        trackingType = "0" /* NOT_TRACKED */;
    }
    else if (!(0,utils/* performDraw */.y7)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* NOT_TRACKED */ ||
        trackingType === "1" /* TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.js
var batch = __webpack_require__(53789);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(30481);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable) {
    var batch = makeRumBatch(configuration, reportError, pageExitObservable);
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration)); });
    return batch;
}
function makeRumBatch(configuration, reportError, pageExitObservable) {
    var primaryBatch = createRumBatch(configuration.rumEndpointBuilder);
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) {
        replicaBatch = createRumBatch(replica.rumEndpointBuilder);
    }
    function createRumBatch(endpointBuilder) {
        return new batch/* Batch */.E((0,transport_httpRequest/* createHttpRequest */.UF)(endpointBuilder, configuration.batchBytesLimit, reportError), configuration.batchMessagesLimit, configuration.batchBytesLimit, configuration.messageBytesLimit, configuration.flushTimeout, pageExitObservable);
    }
    function withReplicaApplicationId(message) {
        return (0,utils/* combine */.$e)(message, { application: { id: replica.applicationId } });
    }
    return {
        flushObservable: primaryBatch.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(withReplicaApplicationId(message));
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(withReplicaApplicationId(message), key);
            }
        },
    };
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new contextHistory/* ContextHistory */.W(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0,timeUtils/* relativeNow */._q)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(location) {
    var currentLocation = (0,utils/* shallowClone */.mv)(location);
    var observable = new tools_observable/* Observable */.y(function () {
        var stopHistoryTracking = trackHistory(onLocationChange).stop;
        var stopHashTracking = trackHash(onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = (0,utils/* shallowClone */.mv)(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(onHistoryChange) {
    var stopInstrumentingPushState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = (0,addEventListener/* addEventListener */.O)(window, "popstate" /* POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(onHashChange) {
    return (0,addEventListener/* addEventListener */.O)(window, "hashchange" /* HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = utils/* computeBytesCount */.qt; }
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('feature_flags')) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: utils/* noop */.ZT,
        };
    }
    var featureFlagContexts = new contextHistory/* ContextHistory */.W(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache;
    lifeCycle.subscribe(4 /* VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = undefined;
    });
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            if (bytesCountCache === undefined) {
                bytesCountCache = computeBytesCountImpl((0,utils/* jsonStringify */.lh)(currentContext));
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = (0,utils/* deepClone */.I8)(value);
                bytesCountCache = undefined;
            }
        },
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * utils/* ONE_SECOND */.WT;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0,utils/* performDraw */.y7)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !(0,utils/* isEmptyObject */.Qr)(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !(0,utils/* isEmptyObject */.Qr)(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = (0,utils/* includes */.q9)(["view" /* VIEW */, "error" /* ERROR */], event.type) &&
            featureFlagContext &&
            !(0,utils/* isEmptyObject */.Qr)(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bufferBytesCount = _a.bufferBytesCount, bufferMessagesCount = _a.bufferMessagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bufferBytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, bufferMessagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    setInterval((0,monitor/* monitor */.zk)(sendCurrentPeriodMeasures), MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

var MAX_PAGE_STATE_ENTRIES = 500;
var pageStateEntries = [];
var currentPageState;
function startPageStateHistory() {
    addPageState(getPageState());
    var stop = (0,addEventListener/* addEventListeners */.y)(window, [
        "pageshow" /* PAGE_SHOW */,
        "focus" /* FOCUS */,
        "blur" /* BLUR */,
        "visibilitychange" /* VISIBILITY_CHANGE */,
        "resume" /* RESUME */,
        "freeze" /* FREEZE */,
        "pagehide" /* PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (!event.isTrusted) {
            return;
        }
        if (event.type === "freeze" /* FREEZE */) {
            addPageState("frozen" /* FROZEN */);
        }
        else if (event.type === "pagehide" /* PAGE_HIDE */) {
            addPageState(event.persisted ? "frozen" /* FROZEN */ : "terminated" /* TERMINATED */);
        }
        else {
            addPageState(getPageState());
        }
    }, { capture: true }).stop;
    return {
        findAll: function (startTime, duration) {
            var entries = [];
            var endTime = (0,timeUtils/* addDuration */.WK)(startTime, duration);
            for (var i = pageStateEntries.length - 1; i >= 0; i--) {
                var stateStartTime = pageStateEntries[i].startTime;
                if (stateStartTime >= endTime) {
                    continue;
                }
                entries.unshift(pageStateEntries[i]);
                if (stateStartTime < startTime) {
                    break;
                }
            }
            return entries.length ? entries : undefined;
        },
        stop: stop,
    };
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* ACTIVE */;
    }
    return "passive" /* PASSIVE */;
}
function addPageState(nextPageState, maxPageStateEntries) {
    if (maxPageStateEntries === void 0) { maxPageStateEntries = MAX_PAGE_STATE_ENTRIES; }
    if (nextPageState === currentPageState) {
        return;
    }
    currentPageState = nextPageState;
    if (pageStateEntries.length === maxPageStateEntries) {
        pageStateEntries.shift();
    }
    pageStateEntries.push({ state: currentPageState, startTime: (0,timeUtils/* relativeNow */._q)() });
}
function resetPageStates() {
    pageStateEntries = [];
    currentPageState = undefined;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.js
























function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(11 /* RUM_EVENT_COLLECTED */, function (event) { return (0,sendToExtension/* sendToExtension */.j)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)();
        pageExitObservable.subscribe(function (event) {
            lifeCycle.notify(9 /* PAGE_EXITED */, event);
        });
        var batch = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable);
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var session = !(0,eventBridge/* canUseEventBridge */.x)() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return buildCommonContext(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, foregroundContexts = _a.foregroundContexts, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction;
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
    startLongTaskCollection(lifeCycle, session);
    var pageStateHistory = startPageStateHistory();
    startResourceCollection(lifeCycle, configuration, session, pageStateHistory);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, foregroundContexts, featureFlagContexts, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView;
    var addError = startErrorCollection(lifeCycle, foregroundContexts, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        getInternalContext: internalContext.get,
    };
}
function startRumTelemetry(configuration) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-rum-sdk" /* RUM */, configuration);
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var foregroundContexts = startForegroundContexts();
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, foregroundContexts), addAction = _a.addAction, actionContexts = _a.actionContexts;
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        foregroundContexts: foregroundContexts,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            viewContexts.stop();
            foregroundContexts.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.js








//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_configuration/* DefaultPrivacyLevel.ALLOW */.Jj.ALLOW,
    MASK: configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
    MASK_USER_INPUT: configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/privacy.js


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel) &&
        // Style tags are `overruled` (Use `hide` to enforce privacy)
        !isStyle) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serializationUtils.js




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0,urlPolyfill/* buildUrl */.Q2)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/serialize.js






function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
function serializeDocumentFragmentNode(element, options) {
    var childNodes = [];
    if (element.childNodes.length) {
        childNodes = serializeChildNodes(element, options);
    }
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: childNodes,
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot
            ? serializeStyleSheets(element.adoptedStyleSheets)
            : undefined,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = getAttributesForPrivacyLevel(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (element.childNodes.length) {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0,utils/* assign */.f0)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    if (isNodeShadowHost(element)) {
        var shadowRoot = serializeNodeWithId(element.shadowRoot, options);
        if (shadowRoot !== null) {
            childNodes.push(shadowRoot);
        }
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (!textContent) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
        isStyle: parentTagName === 'STYLE' ? true : undefined,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
function serializeChildNodes(node, options) {
    var result = [];
    node.childNodes.forEach(function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0,utils/* startsWith */.Ny)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
function getCssRulesString(s) {
    try {
        var rules = s.rules || s.cssRules;
        if (rules) {
            var styleSheetCssText = Array.from(rules, getCssRuleString).join('');
            return switchToAbsoluteUrl(styleSheetCssText, s.href);
        }
        return null;
    }
    catch (error) {
        return null;
    }
}
function getCssRuleString(rule) {
    return isCSSImportRule(rule) ? getCssRulesString(rule.styleSheet) || '' : rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
function getAttributesForPrivacyLevel(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' &&
        element.sheet &&
        // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
        !(element.innerText || element.textContent || '').trim().length) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            safeAttrs.checked = CENSORED_STRING_MARK;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
//# sourceMappingURL=serialize.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/utils.js


function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0,utils/* assign */.f0)({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: (0,timeUtils/* timeStampNow */.n$)(),
    };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = utils/* noop */.ZT;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = (0,utils/* requestIdleCallback */.Kk)(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/mutationObserver.js







/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function startMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: utils/* noop */.ZT, flush: utils/* noop */.ZT };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController, target);
    });
    var observer = new MutationObserver((0,monitor/* monitor */.zk)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController, target) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return target.contains(mutation.target) &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    getChildNodes(removedNode).forEach(function (child) { return traverseRemovedShadowDom(child, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn() {
    var visual = window.visualViewport;
    return (Math.abs(visual.pageTop - visual.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visual.pageLeft - visual.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visual = window.visualViewport;
    var normalised = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visual) {
        // On old browsers, we cannot normalise, so fallback to clientX/Y
        return normalised;
    }
    else if (isVisualViewportFactoredIn()) {
        // Typically Mobile Devices
        normalised.layoutViewportX = Math.round(clientX + visual.offsetLeft);
        normalised.layoutViewportY = Math.round(clientY + visual.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalised.visualViewportX = Math.round(clientX - visual.offsetLeft);
        normalised.visualViewportY = Math.round(clientY - visual.offsetTop);
    }
    return normalised;
};
var getVisualViewport = function () {
    var visual = window.visualViewport;
    return {
        scale: visual.scale,
        offsetLeft: visual.offsetLeft,
        offsetTop: visual.offsetTop,
        pageLeft: visual.pageLeft,
        pageTop: visual.pageTop,
        height: visual.height,
        width: visual.width,
    };
};
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/observers.js
var _a;









var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
var SCROLL_OBSERVER_THRESHOLD = 100;
var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
var recordIds = new WeakMap();
var nextId = 1;
function getRecordIdForEvent(event) {
    if (!recordIds.has(event)) {
        recordIds.set(event, nextId++);
    }
    return recordIds.get(event);
}
function initObservers(o) {
    var mutationHandler = initMutationObserver(o.mutationCb, o.configuration, o.shadowRootsController);
    var mousemoveHandler = initMoveObserver(o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(o.mouseInteractionCb, o.configuration.defaultPrivacyLevel);
    var scrollHandler = initScrollObserver(o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = initViewportResizeObserver(o.viewportResizeCb);
    var inputHandler = initInputObserver(o.inputCb, o.configuration.defaultPrivacyLevel);
    var mediaInteractionHandler = initMediaInteractionObserver(o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
    var focusHandler = initFocusObserver(o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(o.visualViewportResizeCb);
    var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
function initMutationObserver(cb, configuration, shadowRootsController) {
    return startMutationObserver(cb, configuration, shadowRootsController, document);
}
function initMoveObserver(cb) {
    var updatePosition = (0,utils/* throttle */.P2)((0,monitor/* monitor */.zk)(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }), MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return (0,addEventListener/* addEventListeners */.y)(document, ["mousemove" /* MOUSE_MOVE */, "touchmove" /* TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* POINTER_UP */] = MouseInteractionType.MouseUp,
    _a["mousedown" /* MOUSE_DOWN */] = MouseInteractionType.MouseDown,
    _a["click" /* CLICK */] = MouseInteractionType.Click,
    _a["contextmenu" /* CONTEXT_MENU */] = MouseInteractionType.ContextMenu,
    _a["dblclick" /* DBL_CLICK */] = MouseInteractionType.DblClick,
    _a["focus" /* FOCUS */] = MouseInteractionType.Focus,
    _a["blur" /* BLUR */] = MouseInteractionType.Blur,
    _a["touchstart" /* TOUCH_START */] = MouseInteractionType.TouchStart,
    _a["touchend" /* TOUCH_END */] = MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(cb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN || !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0,utils/* assign */.f0)({ id: getRecordIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0,addEventListener/* addEventListeners */.y)(document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
function initScrollObserver(cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = (0,utils/* throttle */.P2)((0,monitor/* monitor */.zk)(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }), SCROLL_OBSERVER_THRESHOLD).throttled;
    return (0,addEventListener/* addEventListener */.O)(document, "scroll" /* SCROLL */, updatePosition, { capture: true, passive: true }).stop;
}
function initViewportResizeObserver(cb) {
    return initViewportObservable().subscribe(cb).unsubscribe;
}
function initInputObserver(cb, defaultPrivacyLevel, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.domEvents, domEvents = _c === void 0 ? ["input" /* INPUT */, "change" /* CHANGE */] : _c, _d = _b.target, target = _d === void 0 ? document : _d;
    var lastInputStateMap = new WeakMap();
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            forEach(document.querySelectorAll("input[type=\"radio\"][name=\"".concat(name, "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0,utils/* assign */.f0)({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
    var stopEventListeners = (0,addEventListener/* addEventListeners */.y)(target, domEvents, function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var instrumentationStoppers = [
        (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'value', onElementChange),
        (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'checked', onElementChange),
        (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'value', onElementChange),
        (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLTextAreaElement.prototype, 'value', onElementChange),
        (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
    ];
    return function () {
        instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); });
        stopEventListeners();
    };
}
function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function initMediaInteractionObserver(mediaInteractionCb, defaultPrivacyLevel) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* PLAY */ ? MediaInteractionType.Play : MediaInteractionType.Pause,
        });
    };
    return (0,addEventListener/* addEventListeners */.y)(document, ["play" /* PLAY */, "pause" /* PAUSE */], handler, { capture: true, passive: true }).stop;
}
function initFocusObserver(focusCb) {
    return (0,addEventListener/* addEventListeners */.y)(window, ["focus" /* FOCUS */, "blur" /* BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
function initVisualViewportResizeObserver(cb) {
    if (!window.visualViewport) {
        return utils/* noop */.ZT;
    }
    var _a = (0,utils/* throttle */.P2)((0,monitor/* monitor */.zk)(function () {
        cb(getVisualViewport());
    }), VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListeners */.y)(window.visualViewport, ["resize" /* RESIZE */, "scroll" /* SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
function initFrustrationObserver(lifeCycle, frustrationCb) {
    return lifeCycle.subscribe(10 /* RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* ACTION */ &&
            data.rawRumEvent.action.type === "click" /* CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return getRecordIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=observers.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js



var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = startMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(inputCb, configuration.defaultPrivacyLevel, {
                target: shadowRoot,
                domEvents: ["change" /* CHANGE */],
            });
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('no shadow root in map', {
                    shadowRoot: shadowRoot ? shadowRoot.nodeName : 'no node name',
                    childrenLength: shadowRoot ? shadowRoot.childElementCount : '-1',
                    controllerByShadowRootSize: controllerByShadowRoot.size,
                    html: shadowRoot && (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)('shadow_dom_debug')
                        ? shadowRoot.innerHTML.substring(0, 2000)
                        : undefined,
                });
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/record.js









function record(options) {
    var emit = options.emit;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = createElementsScrollPositions();
    var mutationCb = function (mutation) {
        emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, s)); };
    var shadowRootsController = initShadowRootsController(options.configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0,timeUtils/* timeStampNow */.n$)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, options.configuration, serializationContext),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = initObservers({
        lifeCycle: options.lifeCycle,
        configuration: options.configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    toFormEntries(metadata, function (key, value) { return formData.append(key, value); });
    formData.append('raw_segment_size', rawSegmentBytesCount.toString());
    return { data: formData, bytesCount: data.byteLength };
}
function toFormEntries(input, onEntry, prefix) {
    if (prefix === void 0) { prefix = ''; }
    (0,utils/* objectEntries */.qP)(input).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (typeof value === 'object' && value !== null) {
            toFormEntries(value, onEntry, "".concat(prefix).concat(key, "."));
        }
        else {
            onEntry("".concat(prefix).concat(key), String(value));
        }
    });
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var segment_nextId = 0;
var Segment = /** @class */ (function () {
    function Segment(worker, context, creationReason, initialRecord, onWrote, onFlushed) {
        var _this = this;
        this.worker = worker;
        this.id = segment_nextId++;
        var viewId = context.view.id;
        this.metadata = (0,utils/* assign */.f0)({
            start: initialRecord.timestamp,
            end: initialRecord.timestamp,
            creation_reason: creationReason,
            records_count: 1,
            has_full_snapshot: initialRecord.type === RecordType.FullSnapshot,
            index_in_view: getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        addSegment(viewId);
        addRecord(viewId);
        var listener = (0,monitor/* monitor */.zk)(function (_a) {
            var data = _a.data;
            if (data.type === 'errored' || data.type === 'initialized') {
                return;
            }
            if (data.id === _this.id) {
                addWroteData(viewId, data.additionalBytesCount);
                if (data.type === 'flushed') {
                    onFlushed(data.result, data.rawBytesCount);
                    worker.removeEventListener('message', listener);
                }
                else {
                    onWrote(data.compressedBytesCount);
                }
            }
            else if (data.id > _this.id) {
                // Messages should be received in the same order as they are sent, so if we receive a
                // message with an id superior to this Segment instance id, we know that another, more
                // recent Segment instance is being used.
                //
                // In theory, a "flush" response should have been received at this point, so the listener
                // should already have been removed. But if something goes wrong and we didn't receive a
                // "flush" response, remove the listener to avoid any leak, and send a monitor message to
                // help investigate the issue.
                worker.removeEventListener('message', listener);
                (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Segment did not receive a 'flush' response before being replaced.");
            }
        });
        worker.addEventListener('message', listener);
        (0,sendToExtension/* sendToExtension */.j)('record', { record: initialRecord, segment: this.metadata });
        this.worker.postMessage({ data: "{\"records\":[".concat(JSON.stringify(initialRecord)), id: this.id, action: 'write' });
    }
    Segment.prototype.addRecord = function (record) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        addRecord(this.metadata.view.id);
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        (0,sendToExtension/* sendToExtension */.j)('record', { record: record, segment: this.metadata });
        this.worker.postMessage({ data: ",".concat(JSON.stringify(record)), id: this.id, action: 'write' });
    };
    Segment.prototype.flush = function (reason) {
        this.worker.postMessage({
            data: "],".concat(JSON.stringify(this.metadata).slice(1), "\n"),
            id: this.id,
            action: 'flush',
        });
        this.flushReason = reason;
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * utils/* ONE_SECOND */.WT;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, applicationId, sessionManager, viewContexts, httpRequest, worker) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(applicationId, sessionManager, viewContexts); }, httpRequest, worker);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, worker) {
    var state = {
        status: 0 /* WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentPending */) {
            state.segment.flush(flushReason);
            clearTimeout(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* Stopped */,
            };
        }
    }
    function createNewSegment(creationReason, initialRecord) {
        var context = getSegmentContext();
        if (!context) {
            return;
        }
        var segment = new Segment(worker, context, creationReason, initialRecord, function (compressedSegmentBytesCount) {
            if (!segment.flushReason && compressedSegmentBytesCount > SEGMENT_BYTES_LIMIT) {
                flushSegment('segment_bytes_limit');
            }
        }, function (data, rawSegmentBytesCount) {
            var payload = buildReplayPayload(data, segment.metadata, rawSegmentBytesCount);
            if ((0,browser_pageExitObservable/* isPageExitReason */.PT)(segment.flushReason)) {
                httpRequest.sendOnExit(payload);
            }
            else {
                httpRequest.send(payload);
            }
        });
        state = {
            status: 1 /* SegmentPending */,
            segment: segment,
            expirationTimeoutId: setTimeout((0,monitor/* monitor */.zk)(function () {
                flushSegment('segment_duration_limit');
            }), SEGMENT_DURATION_LIMIT),
        };
    }
    return {
        addRecord: function (record) {
            switch (state.status) {
                case 0 /* WaitingForInitialRecord */:
                    createNewSegment(state.nextSegmentCreationReason, record);
                    break;
                case 1 /* SegmentPending */:
                    state.segment.addRecord(record);
                    break;
            }
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/deflateWorker.js
var workerURL;
function createDeflateWorker() {
    // Lazily compute the worker URL to allow importing the SDK in NodeJS
    if (!workerURL) {
        workerURL = URL.createObjectURL(new Blob(["(".concat(workerCodeFn, ")(self)")]));
    }
    return new Worker(workerURL);
}
function workerCodeFn() {
    monitor(function () {
        var _a = makePakoDeflate(), Deflate = _a.Deflate, constants = _a.constants, string2buf = _a.string2buf;
        var deflate = new Deflate();
        var rawBytesCount = 0;
        self.addEventListener('message', monitor(function (event) {
            var data = event.data;
            switch (data.action) {
                case 'init':
                    self.postMessage({
                        type: 'initialized',
                    });
                    break;
                case 'write': {
                    var additionalBytesCount = pushData(data.data);
                    self.postMessage({
                        type: 'wrote',
                        id: data.id,
                        compressedBytesCount: deflate.chunks.reduce(function (total, chunk) { return total + chunk.length; }, 0),
                        additionalBytesCount: additionalBytesCount,
                    });
                    break;
                }
                case 'flush': {
                    var additionalBytesCount = data.data ? pushData(data.data) : 0;
                    deflate.push('', constants.Z_FINISH);
                    self.postMessage({
                        type: 'flushed',
                        id: data.id,
                        result: deflate.result,
                        additionalBytesCount: additionalBytesCount,
                        rawBytesCount: rawBytesCount,
                    });
                    deflate = new Deflate();
                    rawBytesCount = 0;
                    break;
                }
            }
        }));
        function pushData(data) {
            // TextEncoder is not supported on old browser version like Edge 18, therefore we use string2buf
            var binaryData = string2buf(data);
            deflate.push(binaryData, constants.Z_SYNC_FLUSH);
            rawBytesCount += binaryData.length;
            return binaryData.length;
        }
    })();
    function monitor(fn) {
        return function () {
            try {
                return fn.apply(this, arguments);
            }
            catch (e) {
                try {
                    self.postMessage({
                        type: 'errored',
                        error: e,
                    });
                }
                catch (_) {
                    // DATA_CLONE_ERR, cf https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
                    self.postMessage({
                        type: 'errored',
                        error: "".concat(e),
                    });
                }
            }
        };
    }
    // https://github.com/nodeca/pako/blob/034669ba0f1a4c0590e45f7c2820128200f972b3/dist/pako_deflate.es5.js
    function makePakoDeflate() {
        /* eslint-disable camelcase, no-bitwise */
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        /* Public constants ========================================================== */
        /* =========================================================================== */
        // const Z_FILTERED          = 1;
        // const Z_HUFFMAN_ONLY      = 2;
        // const Z_RLE               = 3;
        var Z_FIXED = 4; // const Z_DEFAULT_STRATEGY  = 0;
        /* Possible values of the data_type field (though see inflate()) */
        var Z_BINARY = 0;
        var Z_TEXT = 1; // const Z_ASCII             = 1; // = Z_TEXT
        var Z_UNKNOWN = 2;
        /* ============================================================================ */
        function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        } // From zutil.h
        var STORED_BLOCK = 0;
        var STATIC_TREES = 1;
        var DYN_TREES = 2;
        /* The three kinds of block type */
        var MIN_MATCH = 3;
        var MAX_MATCH = 258;
        /* The minimum and maximum match lengths */
        // From deflate.h
        /* ===========================================================================
         * Internal compression state.
         */
        var LENGTH_CODES = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS = 256;
        /* number of literal bytes 0..255 */
        var L_CODES = LITERALS + 1 + LENGTH_CODES;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES = 30;
        /* number of distance codes */
        var BL_CODES = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE = 2 * L_CODES + 1;
        /* maximum heap size */
        var MAX_BITS = 15;
        /* All codes must not exceed MAX_BITS bits */
        var Buf_size = 16;
        /* size of bit buffer in bi_buf */
        /* ===========================================================================
         * Constants
         */
        var MAX_BL_BITS = 7;
        /* Bit length codes must not exceed MAX_BL_BITS bits */
        var END_BLOCK = 256;
        /* end of block literal code */
        var REP_3_6 = 16;
        /* repeat previous bit length 3-6 times (2 bits of repeat count) */
        var REPZ_3_10 = 17;
        /* repeat a zero length 3-10 times  (3 bits of repeat count) */
        var REPZ_11_138 = 18;
        /* repeat a zero length 11-138 times  (7 bits of repeat count) */
        var extra_lbits = 
        /* extra bits for each length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]);
        var extra_dbits = 
        /* extra bits for each distance code */
        new Uint8Array([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]);
        var extra_blbits = 
        /* extra bits for each bit length code */
        new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]);
        var bl_order = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
        /* eslint-enable comma-spacing,array-bracket-spacing */
        /* The lengths of the bit length codes are sent in order of decreasing
         * probability, to avoid transmitting the lengths for unused bit length codes.
         */
        /* ===========================================================================
         * Local data. These are initialized only once.
         */
        // We pre-fill arrays with 0 to avoid uninitialized gaps
        var DIST_CODE_LEN = 512;
        /* see definition of array dist_code below */
        // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
        var static_ltree = new Array((L_CODES + 2) * 2);
        zero(static_ltree);
        /* The static literal tree. Since the bit lengths are imposed, there is no
         * need for the L_CODES extra codes used during heap construction. However
         * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
         * below).
         */
        var static_dtree = new Array(D_CODES * 2);
        zero(static_dtree);
        /* The static distance tree. (Actually a trivial tree since all codes use
         * 5 bits.)
         */
        var _dist_code = new Array(DIST_CODE_LEN);
        zero(_dist_code);
        /* Distance codes. The first 256 values correspond to the distances
         * 3 .. 258, the last 256 values correspond to the top 8 bits of
         * the 15 bit distances.
         */
        var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
        zero(_length_code);
        /* length code for each normalized match length (0 == MIN_MATCH) */
        var base_length = new Array(LENGTH_CODES);
        zero(base_length);
        /* First normalized length for each code (0 = MIN_MATCH) */
        var base_dist = new Array(D_CODES);
        zero(base_dist);
        /* First normalized distance for each code (0 = distance of 1) */
        function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
            this.static_tree = static_tree;
            /* static tree or NULL */
            this.extra_bits = extra_bits;
            /* extra bits for each code or NULL */
            this.extra_base = extra_base;
            /* base index for extra_bits */
            this.elems = elems;
            /* max number of elements in the tree */
            this.max_length = max_length;
            /* max bit length for the codes */
            // show if `static_tree` has data or dummy - needed for monomorphic objects
            this.has_stree = static_tree && static_tree.length;
        }
        var static_l_desc;
        var static_d_desc;
        var static_bl_desc;
        function TreeDesc(dyn_tree, stat_desc) {
            this.dyn_tree = dyn_tree;
            /* the dynamic tree */
            this.max_code = 0;
            /* largest code with non zero frequency */
            this.stat_desc = stat_desc;
            /* the corresponding static tree */
        }
        var d_code = function d_code(dist) {
            return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
        };
        /* ===========================================================================
         * Output a short LSB first on the stream.
         * IN assertion: there is enough room in pendingBuf.
         */
        var put_short = function put_short(s, w) {
            //    put_byte(s, (uch)((w) & 0xff));
            //    put_byte(s, (uch)((ush)(w) >> 8));
            s.pending_buf[s.pending++] = w & 0xff;
            s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
        };
        /* ===========================================================================
         * Send a value on a given number of bits.
         * IN assertion: length <= 16 and value fits in length bits.
         */
        var send_bits = function send_bits(s, value, length) {
            if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
            }
            else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
            }
        };
        var send_code = function send_code(s, c, tree) {
            send_bits(s, tree[c * 2], 
            /* .Code */
            tree[c * 2 + 1]
            /* .Len */
            );
        };
        /* ===========================================================================
         * Reverse the first len bits of a code, using straightforward code (a faster
         * method would use a table)
         * IN assertion: 1 <= len <= 15
         */
        var bi_reverse = function bi_reverse(code, len) {
            var res = 0;
            do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
            } while (--len > 0);
            return res >>> 1;
        };
        /* ===========================================================================
         * Flush the bit buffer, keeping at most 7 bits in it.
         */
        var bi_flush = function bi_flush(s) {
            if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
            }
            else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
            }
        };
        /* ===========================================================================
         * Compute the optimal bit lengths for a tree and update the total bit length
         * for the current block.
         * IN assertion: the fields freq and dad are set, heap[heap_max] and
         *    above are the tree nodes sorted by increasing frequency.
         * OUT assertions: the field len is set to the optimal bit length, the
         *     array bl_count contains the frequencies for each bit length.
         *     The length opt_len is updated; static_len is also updated if stree is
         *     not null.
         */
        var gen_bitlen = function gen_bitlen(s, desc //    deflate_state *s; //    tree_desc *desc;    /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var max_code = desc.max_code;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var extra = desc.stat_desc.extra_bits;
            var base = desc.stat_desc.extra_base;
            var max_length = desc.stat_desc.max_length;
            var h;
            /* heap index */
            var n;
            var m;
            /* iterate over the tree elements */
            var bits;
            /* bit length */
            var xbits;
            /* extra bits */
            var f;
            /* frequency */
            var overflow = 0;
            /* number of elements with bit length too large */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
            }
            /* In a first pass, compute the optimal bit lengths (which may
             * overflow in the case of the bit length tree).
             */
            tree[s.heap[s.heap_max] * 2 + 1] =
                /* .Len */
                0;
            /* root of the heap */
            for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits =
                    tree[tree[n * 2 + 1] *
                        /* .Dad */
                        2 +
                        1] +
                        /* .Len */
                        1;
                if (bits > max_length) {
                    bits = max_length;
                    overflow++;
                }
                tree[n * 2 + 1] =
                    /* .Len */
                    bits;
                /* We overwrite tree[n].Dad which is no longer needed */
                if (n > max_code) {
                    continue;
                }
                /* not a leaf node */
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                    xbits = extra[n - base];
                }
                f = tree[n * 2];
                /* .Freq */
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                    s.static_len +=
                        f *
                            (stree[n * 2 + 1] +
                                /* .Len */
                                xbits);
                }
            }
            if (overflow === 0) {
                return;
            } // Trace((stderr,"\nbit length overflow\n"));
            /* This happens for example on obj2 and pic of the Calgary corpus */
            /* Find the first bit length which could increase: */
            do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                    bits--;
                }
                s.bl_count[bits]--;
                /* move one leaf down the tree */
                s.bl_count[bits + 1] += 2;
                /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
            } while (overflow > 0);
            /* Now recompute all bit lengths, scanning in increasing frequency.
             * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
             * lengths instead of fixing only the wrong ones. This idea is taken
             * from 'ar' written by Haruhiko Okumura.)
             */
            for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                    m = s.heap[--h];
                    if (m > max_code) {
                        continue;
                    }
                    if (tree[m * 2 + 1] !==
                        /* .Len */
                        bits) {
                        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                        s.opt_len +=
                            (bits - tree[m * 2 + 1]) *
                                /* .Len */
                                tree[m * 2];
                        /* .Freq */
                        tree[m * 2 + 1] =
                            /* .Len */
                            bits;
                    }
                    n--;
                }
            }
        };
        /* ===========================================================================
         * Generate the codes for a given tree and bit counts (which need not be
         * optimal).
         * IN assertion: the array bl_count contains the bit length statistics for
         * the given tree and the field len is set for all tree elements.
         * OUT assertion: the field code is set for all tree elements of non
         *     zero code length.
         */
        var gen_codes = function gen_codes(tree, max_code, bl_count
        //    ct_data *tree;             /* the tree to decorate */
        //    int max_code;              /* largest code with non zero frequency */
        //    ushf *bl_count;            /* number of codes at each bit length */
        ) {
            var next_code = new Array(MAX_BITS + 1);
            /* next code value for each bit length */
            var code = 0;
            /* running code value */
            var bits;
            /* bit index */
            var n;
            /* code index */
            /* The distribution counts are first used to generate the code values
             * without bit reversal.
             */
            for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
            }
            /* Check that the bit counts in bl_count are consistent. The last code
             * must be all ones.
             */
            // Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
            //        "inconsistent bit counts");
            // Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
            for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1];
                /* .Len */
                if (len === 0) {
                    continue;
                }
                /* Now reverse the bits */
                tree[n * 2] =
                    /* .Code */
                    bi_reverse(next_code[len]++, len); // Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
            }
        };
        /* ===========================================================================
         * Initialize the various 'constant' tables.
         */
        var tr_static_init = function tr_static_init() {
            var n;
            /* iterates over tree elements */
            var bits;
            /* bit counter */
            var length;
            /* length value */
            var code;
            /* code value */
            var dist;
            /* distance index */
            var bl_count = new Array(MAX_BITS + 1);
            /* number of codes at each bit length for an optimal tree */
            // do check in _tr_init()
            // if (static_init_done) return;
            /* For some embedded targets, global variables are not initialized: */
            /* #ifdef NO_INIT_GLOBAL_POINTERS
            static_l_desc.static_tree = static_ltree;
            static_l_desc.extra_bits = extra_lbits;
            static_d_desc.static_tree = static_dtree;
            static_d_desc.extra_bits = extra_dbits;
            static_bl_desc.extra_bits = extra_blbits;
          #endif */
            /* Initialize the mapping length (0..255) -> length code (0..28) */
            length = 0;
            for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                    _length_code[length++] = code;
                }
            } // Assert (length == 256, "tr_static_init: length != 256");
            /* Note that the length 255 (match length 258) can be represented
             * in two different ways: code 284 + 5 bits or code 285, so we
             * overwrite length_code[255] to use the best encoding:
             */
            _length_code[length - 1] = code;
            /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
            dist = 0;
            for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                    _dist_code[dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: dist != 256");
            dist >>= 7;
            /* from now on, all distances are divided by 128 */
            for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                    _dist_code[256 + dist++] = code;
                }
            } // Assert (dist == 256, "tr_static_init: 256+dist != 512");
            /* Construct the codes of the static literal tree */
            for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
            }
            n = 0;
            while (n <= 143) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            while (n <= 255) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    9;
                n++;
                bl_count[9]++;
            }
            while (n <= 279) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    7;
                n++;
                bl_count[7]++;
            }
            while (n <= 287) {
                static_ltree[n * 2 + 1] =
                    /* .Len */
                    8;
                n++;
                bl_count[8]++;
            }
            /* Codes 286 and 287 do not exist, but we must include them in the
             * tree construction to get a canonical Huffman tree (longest code
             * all ones)
             */
            gen_codes(static_ltree, L_CODES + 1, bl_count);
            /* The static distance tree is trivial: */
            for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] =
                    /* .Len */
                    5;
                static_dtree[n * 2] =
                    /* .Code */
                    bi_reverse(n, 5);
            } // Now data ready and we can init static trees
            static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
            static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
            static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
            // static_init_done = true;
        };
        /* ===========================================================================
         * Initialize a new block.
         */
        var init_block = function init_block(s) {
            var n;
            /* iterates over tree elements */
            /* Initialize the trees. */
            for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] =
                    /* .Freq */
                    0;
            }
            for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] =
                    /* .Freq */
                    0;
            }
            s.dyn_ltree[END_BLOCK * 2] =
                /* .Freq */
                1;
            s.opt_len = s.static_len = 0;
            s.last_lit = s.matches = 0;
        };
        /* ===========================================================================
         * Flush the bit buffer and align the output on a byte boundary
         */
        var bi_windup = function bi_windup(s) {
            if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
            }
            else if (s.bi_valid > 0) {
                // put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
            }
            s.bi_buf = 0;
            s.bi_valid = 0;
        };
        /* ===========================================================================
         * Copy a stored block, storing first the length and its
         * one's complement if requested.
         */
        var copy_block = function copy_block(s, buf, len, header
        // DeflateState *s;
        // charf    *buf;    /* the input data */
        // unsigned len;     /* its length */
        // int      header;  /* true if block header must be written */
        ) {
            bi_windup(s);
            /* align on byte boundary */
            if (header) {
                put_short(s, len);
                put_short(s, ~len);
            }
            //  while (len--) {
            //    put_byte(s, *buf++);
            //  }
            s.pending_buf.set(s.window.subarray(buf, buf + len), s.pending);
            s.pending += len;
        };
        /* ===========================================================================
         * Compares to subtrees, using the tree depth as tie breaker when
         * the subtrees have equal frequency. This minimizes the worst case length.
         */
        var smaller = function smaller(tree, n, m, depth) {
            var _n2 = n * 2;
            var _m2 = m * 2;
            return (tree[_n2] <
                /* .Freq */
                tree[_m2] ||
                /* .Freq */
                (tree[_n2] ===
                    /* .Freq */
                    tree[_m2] &&
                    /* .Freq */
                    depth[n] <= depth[m]));
        };
        /* ===========================================================================
         * Restore the heap property by moving down the tree starting at node k,
         * exchanging a node with the smallest of its two sons if necessary, stopping
         * when the heap property is re-established (each father smaller than its
         * two sons).
         */
        var pqdownheap = function pqdownheap(s, tree, k
        //    deflate_state *s;
        //    ct_data *tree;  /* the tree to restore */
        //    int k;               /* node to move down */
        ) {
            var v = s.heap[k];
            var j = k << 1;
            /* left son of k */
            while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
                    j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                    break;
                }
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
            }
            s.heap[k] = v;
        }; // inlined manually
        // const SMALLEST = 1;
        /* ===========================================================================
         * Send the block data compressed using the given Huffman trees
         */
        var compress_block = function compress_block(s, ltree, dtree
        //    deflate_state *s;
        //    const ct_data *ltree; /* literal tree */
        //    const ct_data *dtree; /* distance tree */
        ) {
            var dist;
            /* distance of matched string */
            var lc;
            /* match length or unmatched char (if dist == 0) */
            var lx = 0;
            /* running index in l_buf */
            var code;
            /* the code to send */
            var extra;
            /* number of extra bits to send */
            if (s.last_lit !== 0) {
                do {
                    dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | s.pending_buf[s.d_buf + lx * 2 + 1];
                    lc = s.pending_buf[s.l_buf + lx];
                    lx++;
                    if (dist === 0) {
                        send_code(s, lc, ltree);
                        /* send a literal byte */
                        // Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                    }
                    else {
                        /* Here, lc is the match length - MIN_MATCH */
                        code = _length_code[lc];
                        send_code(s, code + LITERALS + 1, ltree);
                        /* send the length code */
                        extra = extra_lbits[code];
                        if (extra !== 0) {
                            lc -= base_length[code];
                            send_bits(s, lc, extra);
                            /* send the extra length bits */
                        }
                        dist--;
                        /* dist is now the match distance - 1 */
                        code = d_code(dist); // Assert (code < D_CODES, "bad d_code");
                        send_code(s, code, dtree);
                        /* send the distance code */
                        extra = extra_dbits[code];
                        if (extra !== 0) {
                            dist -= base_dist[code];
                            send_bits(s, dist, extra);
                            /* send the extra distance bits */
                        }
                    }
                    /* literal or match pair ? */
                    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                    // Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                    //       "pendingBuf overflow");
                } while (lx < s.last_lit);
            }
            send_code(s, END_BLOCK, ltree);
        };
        /* ===========================================================================
         * Construct one Huffman tree and assigns the code bit strings and lengths.
         * Update the total bit length for the current block.
         * IN assertion: the field freq is set for all tree elements.
         * OUT assertions: the fields len and code are set to the optimal bit length
         *     and corresponding code. The length opt_len is updated; static_len is
         *     also updated if stree is not null. The field max_code is set.
         */
        var build_tree = function build_tree(s, desc //    deflate_state *s; //    tree_desc *desc; /* the tree descriptor */
        ) {
            var tree = desc.dyn_tree;
            var stree = desc.stat_desc.static_tree;
            var has_stree = desc.stat_desc.has_stree;
            var elems = desc.stat_desc.elems;
            var n;
            var m;
            /* iterate over heap elements */
            var max_code = -1;
            /* largest code with non zero frequency */
            var node;
            /* new node being created */
            /* Construct the initial heap, with least frequent element in
             * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
             * heap[0] is not used.
             */
            s.heap_len = 0;
            s.heap_max = HEAP_SIZE;
            for (n = 0; n < elems; n++) {
                if (tree[n * 2] !==
                    /* .Freq */
                    0) {
                    s.heap[++s.heap_len] = max_code = n;
                    s.depth[n] = 0;
                }
                else {
                    tree[n * 2 + 1] =
                        /* .Len */
                        0;
                }
            }
            /* The pkzip format requires that at least one distance code exists,
             * and that at least one bit should be sent even if there is only one
             * possible code. So to avoid special checks later on we force at least
             * two codes of non zero frequency.
             */
            while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] =
                    /* .Freq */
                    1;
                s.depth[node] = 0;
                s.opt_len--;
                if (has_stree) {
                    s.static_len -= stree[node * 2 + 1];
                    /* .Len */
                }
                /* node is 0 or 1 so it does not have extra bits */
            }
            desc.max_code = max_code;
            /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
             * establish sub-heaps of increasing lengths:
             */
            for (n = s.heap_len >> 1; 
            /* int /2 */
            n >= 1; n--) {
                pqdownheap(s, tree, n);
            }
            /* Construct the Huffman tree by repeatedly combining the least two
             * frequent nodes.
             */
            node = elems;
            /* next internal node of the tree */
            do {
                // pqremove(s, tree, n);  /* n = node of least frequency */
                /** * pqremove ** */
                n = s.heap[1];
                /* SMALLEST */
                s.heap[1] = s.heap[s.heap_len--];
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
                /***/
                m = s.heap[1];
                /* SMALLEST */
                /* m = node of next least frequency */
                s.heap[--s.heap_max] = n;
                /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
                /* Create a new node father of n and m */
                tree[node * 2] =
                    /* .Freq */
                    tree[n * 2] +
                        /* .Freq */
                        tree[m * 2];
                /* .Freq */
                s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] =
                    /* .Dad */
                    tree[m * 2 + 1] =
                        /* .Dad */
                        node;
                /* and insert the new node in the heap */
                s.heap[1] = node++;
                /* SMALLEST */
                pqdownheap(s, tree, 1
                /* SMALLEST */
                );
            } while (s.heap_len >= 2);
            s.heap[--s.heap_max] = s.heap[1];
            /* SMALLEST */
            /* At this point, the fields freq and dad are set. We can now
             * generate the bit lengths.
             */
            gen_bitlen(s, desc);
            /* The field len is now set, we can generate the bit codes */
            gen_codes(tree, max_code, s.bl_count);
        };
        /* ===========================================================================
         * Scan a literal or distance tree to determine the frequencies of the codes
         * in the bit length tree.
         */
        var scan_tree = function scan_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree;   /* the tree to be scanned */
        //    int max_code;    /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            tree[(max_code + 1) * 2 + 1] =
                /* .Len */
                0xffff;
            /* guard */
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    s.bl_tree[curlen * 2] +=
                        /* .Freq */
                        count;
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        s.bl_tree[curlen * 2] /* .Freq */++;
                    }
                    s.bl_tree[REP_3_6 * 2] /* .Freq */++;
                }
                else if (count <= 10) {
                    s.bl_tree[REPZ_3_10 * 2] /* .Freq */++;
                }
                else {
                    s.bl_tree[REPZ_11_138 * 2] /* .Freq */++;
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Send a literal or distance tree in compressed form, using the codes in
         * bl_tree.
         */
        var send_tree = function send_tree(s, tree, max_code
        //    deflate_state *s;
        //    ct_data *tree; /* the tree to be scanned */
        //    int max_code;       /* and its largest code of non zero frequency */
        ) {
            var n;
            /* iterates over all tree elements */
            var prevlen = -1;
            /* last emitted length */
            var curlen;
            /* length of current code */
            var nextlen = tree[0 * 2 + 1];
            /* .Len */
            /* length of next code */
            var count = 0;
            /* repeat count of the current code */
            var max_count = 7;
            /* max repeat count */
            var min_count = 4;
            /* min repeat count */
            /* tree[max_code+1].Len = -1; */
            /* guard already set */
            if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
            }
            for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1];
                /* .Len */
                if (++count < max_count && curlen === nextlen) {
                    continue;
                }
                else if (count < min_count) {
                    do {
                        send_code(s, curlen, s.bl_tree);
                    } while (--count !== 0);
                }
                else if (curlen !== 0) {
                    if (curlen !== prevlen) {
                        send_code(s, curlen, s.bl_tree);
                        count--;
                    } // Assert(count >= 3 && count <= 6, " 3_6?");
                    send_code(s, REP_3_6, s.bl_tree);
                    send_bits(s, count - 3, 2);
                }
                else if (count <= 10) {
                    send_code(s, REPZ_3_10, s.bl_tree);
                    send_bits(s, count - 3, 3);
                }
                else {
                    send_code(s, REPZ_11_138, s.bl_tree);
                    send_bits(s, count - 11, 7);
                }
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                    max_count = 138;
                    min_count = 3;
                }
                else if (curlen === nextlen) {
                    max_count = 6;
                    min_count = 3;
                }
                else {
                    max_count = 7;
                    min_count = 4;
                }
            }
        };
        /* ===========================================================================
         * Construct the Huffman tree for the bit lengths and return the index in
         * bl_order of the last bit length code to send.
         */
        var build_bl_tree = function build_bl_tree(s) {
            var max_blindex;
            /* index of last bit length code of non zero freq */
            /* Determine the bit length frequencies for literal and distance trees */
            scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
            scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
            /* Build the bit length tree: */
            build_tree(s, s.bl_desc);
            /* opt_len now includes the length of the tree representations, except
             * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
             */
            /* Determine the number of bit length codes to send. The pkzip format
             * requires that at least 4 bit length codes be sent. (appnote.txt says
             * 3 but the actual value used is 4.)
             */
            for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !==
                    /* .Len */
                    0) {
                    break;
                }
            }
            /* Update opt_len to include the bit length tree and counts */
            s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4; // Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
            //        s->opt_len, s->static_len));
            return max_blindex;
        };
        /* ===========================================================================
         * Send the header for a block using dynamic Huffman trees: the counts, the
         * lengths of the bit length codes, the literal tree and the distance tree.
         * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
         */
        var send_all_trees = function send_all_trees(s, lcodes, dcodes, blcodes //    deflate_state *s; //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
        ) {
            var rank;
            /* index in bl_order */
            // Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
            // Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
            //        "too many codes");
            // Tracev((stderr, "\nbl counts: "));
            send_bits(s, lcodes - 257, 5);
            /* not +255 as stated in appnote.txt */
            send_bits(s, dcodes - 1, 5);
            send_bits(s, blcodes - 4, 4);
            /* not -3 as stated in appnote.txt */
            for (rank = 0; rank < blcodes; rank++) {
                // Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 
                /* .Len */
                3);
            } // Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_ltree, lcodes - 1);
            /* literal tree */
            // Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
            send_tree(s, s.dyn_dtree, dcodes - 1);
            /* distance tree */
            // Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
        };
        /* ===========================================================================
         * Check if the data type is TEXT or BINARY, using the following algorithm:
         * - TEXT if the two conditions below are satisfied:
         *    a) There are no non-portable control characters belonging to the
         *       "black list" (0..6, 14..25, 28..31).
         *    b) There is at least one printable character belonging to the
         *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
         * - BINARY otherwise.
         * - The following partially-portable control characters form a
         *   "gray list" that is ignored in this detection algorithm:
         *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
         * IN assertion: the fields Freq of dyn_ltree are set.
         */
        var detect_data_type = function detect_data_type(s) {
            /* black_mask is the bit mask of black-listed bytes
             * set bits 0..6, 14..25, and 28..31
             * 0xf3ffc07f = binary 11110011111111111100000001111111
             */
            var black_mask = 0xf3ffc07f;
            var n;
            /* Check for non-textual ("black-listed") bytes. */
            for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 &&
                    s.dyn_ltree[n * 2] !==
                        /* .Freq */
                        0) {
                    return Z_BINARY;
                }
            }
            /* Check for textual ("white-listed") bytes. */
            if (s.dyn_ltree[9 * 2] !==
                /* .Freq */
                0 ||
                s.dyn_ltree[10 * 2] !==
                    /* .Freq */
                    0 ||
                s.dyn_ltree[13 * 2] !==
                    /* .Freq */
                    0) {
                return Z_TEXT;
            }
            for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] !==
                    /* .Freq */
                    0) {
                    return Z_TEXT;
                }
            }
            /* There are no "black-listed" or "white-listed" bytes:
             * this stream either is empty or has tolerated ("gray-listed") bytes only.
             */
            return Z_BINARY;
        };
        var static_init_done = false;
        /* ===========================================================================
         * Initialize the tree data structures for a new zlib stream.
         */
        var _tr_init = function _tr_init(s) {
            if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
            }
            s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
            s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
            s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
            s.bi_buf = 0;
            s.bi_valid = 0;
            /* Initialize the first block of the first file: */
            init_block(s);
        };
        /* ===========================================================================
         * Send a stored block
         */
        var _tr_stored_block = function _tr_stored_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
            /* send block type */
            copy_block(s, buf, stored_len, true);
            /* with header */
        };
        /* ===========================================================================
         * Send one empty static block to give enough lookahead for inflate.
         * This takes 10 bits, of which 7 may remain in the bit buffer.
         */
        var _tr_align = function _tr_align(s) {
            send_bits(s, STATIC_TREES << 1, 3);
            send_code(s, END_BLOCK, static_ltree);
            bi_flush(s);
        };
        /* ===========================================================================
         * Determine the best encoding for the current block: dynamic trees, static
         * trees or store, and output the encoded block to the zip file.
         */
        var _tr_flush_block = function _tr_flush_block(s, buf, stored_len, last
        // DeflateState *s;
        // charf *buf;       /* input block, or NULL if too old */
        // ulg stored_len;   /* length of input block */
        // int last;         /* one if this is the last block for a file */
        ) {
            var opt_lenb;
            var static_lenb;
            /* opt_len and static_len in bytes */
            var max_blindex = 0;
            /* index of last bit length code of non zero freq */
            /* Build the Huffman trees unless a stored block is forced */
            if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                    s.strm.data_type = detect_data_type(s);
                }
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc); // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                build_tree(s, s.d_desc); // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3; // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
                if (static_lenb <= opt_lenb) {
                    opt_lenb = static_lenb;
                }
            }
            else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb = stored_len + 5;
                /* force a stored block */
            }
            if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
            }
            else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
            }
            else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
            } // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
            /* The above check is made mod 2^32, for files larger than 512 MB
             * and uLong implemented on 32 bits.
             */
            init_block(s);
            if (last) {
                bi_windup(s);
            } // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
            //       s->compressed_len-7*last));
        };
        /* ===========================================================================
         * Save the match info and tally the frequency counts. Return true if
         * the current block must be flushed.
         */
        var _tr_tally = function _tr_tally(s, dist, lc
        //    deflate_state *s;
        //    unsigned dist;  /* distance of matched string */
        //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
        ) {
            // let out_length, in_length, dcode;
            s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
            s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
            s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
            s.last_lit++;
            if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /* .Freq */++;
            }
            else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--;
                /* dist = match distance - 1 */
                // Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /* .Freq */++;
                s.dyn_dtree[d_code(dist) * 2] /* .Freq */++;
            } // (!) This block is disabled in zlib defaults,
            // don't enable it for binary compatibility
            // #ifdef TRUNCATE_BLOCK
            //  /* Try to guess if it is profitable to stop the current block here */
            //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
            //    /* Compute an upper bound for the compressed length */
            //    out_length = s.last_lit*8;
            //    in_length = s.strstart - s.block_start;
            //
            //    for (dcode = 0; dcode < D_CODES; dcode++) {
            //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
            //    }
            //    out_length >>>= 3;
            //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
            //    //       s->last_lit, in_length, out_length,
            //    //       100L - out_length*100L/in_length));
            //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
            //      return true;
            //    }
            //  }
            // #endif
            return s.last_lit === s.lit_bufsize - 1;
            /* We avoid equality with lit_bufsize because of wraparound at 64K
             * on 16 bit machines and because stored blocks are restricted to
             * 64K-1 bytes.
             */
        };
        var _tr_init_1 = _tr_init;
        var _tr_stored_block_1 = _tr_stored_block;
        var _tr_flush_block_1 = _tr_flush_block;
        var _tr_tally_1 = _tr_tally;
        var _tr_align_1 = _tr_align;
        var trees = {
            _tr_init: _tr_init_1,
            _tr_stored_block: _tr_stored_block_1,
            _tr_flush_block: _tr_flush_block_1,
            _tr_tally: _tr_tally_1,
            _tr_align: _tr_align_1,
        };
        // It isn't worth it to make additional optimizations as in original.
        // Small size is preferable.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var adler32 = function adler32(adler, buf, len, pos) {
            var s1 = (adler & 0xffff) | 0;
            var s2 = ((adler >>> 16) & 0xffff) | 0;
            var n = 0;
            while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
                do {
                    s1 = (s1 + buf[pos++]) | 0;
                    s2 = (s2 + s1) | 0;
                } while (--n);
                s1 %= 65521;
                s2 %= 65521;
            }
            return s1 | (s2 << 16) | 0;
        };
        var adler32_1 = adler32;
        // So write code to minimize size - no pregenerated tables
        // and array tools dependencies.
        // (C) 1995-2013 Jean-loup Gailly and Mark Adler
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        // Use ordinary array, since untyped makes no boost here
        var makeTable = function makeTable() {
            var c;
            var table = [];
            for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                    c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
            }
            return table;
        }; // Create table on load. Just 255 signed longs. Not a problem.
        var crcTable = new Uint32Array(makeTable());
        var crc32 = function crc32(crc, buf, len, pos) {
            var t = crcTable;
            var end = pos + len;
            crc ^= -1;
            for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
            }
            return crc ^ -1; // >>> 0;
        };
        var crc32_1 = crc32;
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var messages = {
            2: 'need dictionary',
            /* Z_NEED_DICT       2  */
            1: 'stream end',
            /* Z_STREAM_END      1  */
            0: '',
            /* Z_OK              0  */
            '-1': 'file error',
            /* Z_ERRNO         (-1) */
            '-2': 'stream error',
            /* Z_STREAM_ERROR  (-2) */
            '-3': 'data error',
            /* Z_DATA_ERROR    (-3) */
            '-4': 'insufficient memory',
            /* Z_MEM_ERROR     (-4) */
            '-5': 'buffer error',
            /* Z_BUF_ERROR     (-5) */
            '-6': 'incompatible version',
            /* Z_VERSION_ERROR (-6) */
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var constants = {
            /* Allowed flush values; see deflate() and inflate() below for details */
            Z_NO_FLUSH: 0,
            Z_PARTIAL_FLUSH: 1,
            Z_SYNC_FLUSH: 2,
            Z_FULL_FLUSH: 3,
            Z_FINISH: 4,
            Z_BLOCK: 5,
            Z_TREES: 6,
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            Z_OK: 0,
            Z_STREAM_END: 1,
            Z_NEED_DICT: 2,
            Z_ERRNO: -1,
            Z_STREAM_ERROR: -2,
            Z_DATA_ERROR: -3,
            Z_MEM_ERROR: -4,
            Z_BUF_ERROR: -5,
            // Z_VERSION_ERROR: -6,
            /* compression levels */
            Z_NO_COMPRESSION: 0,
            Z_BEST_SPEED: 1,
            Z_BEST_COMPRESSION: 9,
            Z_DEFAULT_COMPRESSION: -1,
            Z_FILTERED: 1,
            Z_HUFFMAN_ONLY: 2,
            Z_RLE: 3,
            Z_FIXED: 4,
            Z_DEFAULT_STRATEGY: 0,
            /* Possible values of the data_type field (though see inflate()) */
            Z_BINARY: 0,
            Z_TEXT: 1,
            // Z_ASCII:                1, // = Z_TEXT (deprecated)
            Z_UNKNOWN: 2,
            /* The deflate compression method */
            Z_DEFLATED: 8, // Z_NULL:                 null // Use -1 or null inline, depending on var type
        };
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        var _tr_init$1 = trees._tr_init;
        var _tr_stored_block$1 = trees._tr_stored_block;
        var _tr_flush_block$1 = trees._tr_flush_block;
        var _tr_tally$1 = trees._tr_tally;
        var _tr_align$1 = trees._tr_align;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH = constants.Z_NO_FLUSH;
        var Z_PARTIAL_FLUSH = constants.Z_PARTIAL_FLUSH;
        var Z_FULL_FLUSH = constants.Z_FULL_FLUSH;
        var Z_FINISH = constants.Z_FINISH;
        var Z_BLOCK = constants.Z_BLOCK;
        var Z_OK = constants.Z_OK;
        var Z_STREAM_END = constants.Z_STREAM_END;
        var Z_STREAM_ERROR = constants.Z_STREAM_ERROR;
        var Z_DATA_ERROR = constants.Z_DATA_ERROR;
        var Z_BUF_ERROR = constants.Z_BUF_ERROR;
        var Z_DEFAULT_COMPRESSION = constants.Z_DEFAULT_COMPRESSION;
        var Z_FILTERED = constants.Z_FILTERED;
        var Z_HUFFMAN_ONLY = constants.Z_HUFFMAN_ONLY;
        var Z_RLE = constants.Z_RLE;
        var Z_FIXED$1 = constants.Z_FIXED;
        var Z_DEFAULT_STRATEGY = constants.Z_DEFAULT_STRATEGY;
        var Z_UNKNOWN$1 = constants.Z_UNKNOWN;
        var Z_DEFLATED = constants.Z_DEFLATED;
        /* ============================================================================ */
        var MAX_MEM_LEVEL = 9;
        /* Maximum value for memLevel in deflateInit2 */
        var MAX_WBITS = 15;
        /* 32K LZ77 window */
        var DEF_MEM_LEVEL = 8;
        var LENGTH_CODES$1 = 29;
        /* number of length codes, not counting the special END_BLOCK code */
        var LITERALS$1 = 256;
        /* number of literal bytes 0..255 */
        var L_CODES$1 = LITERALS$1 + 1 + LENGTH_CODES$1;
        /* number of Literal or Length codes, including the END_BLOCK code */
        var D_CODES$1 = 30;
        /* number of distance codes */
        var BL_CODES$1 = 19;
        /* number of codes used to transfer the bit lengths */
        var HEAP_SIZE$1 = 2 * L_CODES$1 + 1;
        /* maximum heap size */
        var MAX_BITS$1 = 15;
        /* All codes must not exceed MAX_BITS bits */
        var MIN_MATCH$1 = 3;
        var MAX_MATCH$1 = 258;
        var MIN_LOOKAHEAD = MAX_MATCH$1 + MIN_MATCH$1 + 1;
        var PRESET_DICT = 0x20;
        var INIT_STATE = 42;
        var EXTRA_STATE = 69;
        var NAME_STATE = 73;
        var COMMENT_STATE = 91;
        var HCRC_STATE = 103;
        var BUSY_STATE = 113;
        var FINISH_STATE = 666;
        var BS_NEED_MORE = 1;
        /* block not completed, need more input or more output */
        var BS_BLOCK_DONE = 2;
        /* block flush performed */
        var BS_FINISH_STARTED = 3;
        /* finish started, need only more output at next deflate */
        var BS_FINISH_DONE = 4;
        /* finish done, accept no more input or output */
        var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
        var err = function err(strm, errorCode) {
            strm.msg = messages[errorCode];
            return errorCode;
        };
        var rank = function rank(f) {
            return (f << 1) - (f > 4 ? 9 : 0);
        };
        var zero$1 = function zero(buf) {
            var len = buf.length;
            while (--len >= 0) {
                buf[len] = 0;
            }
        };
        var HASH_ZLIB = function HASH_ZLIB(s, prev, data) {
            return ((prev << s.hash_shift) ^ data) & s.hash_mask;
        }; // This hash causes less collisions, https://github.com/nodeca/pako/issues/135
        // But breaks binary compatibility
        // let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
        var HASH = HASH_ZLIB;
        /* =========================================================================
         * Flush as much pending output as possible. All deflate() output goes
         * through this function so some applications may wish to modify it
         * to avoid allocating a large strm->output buffer and copying into it.
         * (See also read_buf()).
         */
        var flush_pending = function flush_pending(strm) {
            var s = strm.state; // _tr_flush_bits(s);
            var len = s.pending;
            if (len > strm.avail_out) {
                len = strm.avail_out;
            }
            if (len === 0) {
                return;
            }
            strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
            strm.next_out += len;
            s.pending_out += len;
            strm.total_out += len;
            strm.avail_out -= len;
            s.pending -= len;
            if (s.pending === 0) {
                s.pending_out = 0;
            }
        };
        var flush_block_only = function flush_block_only(s, last) {
            _tr_flush_block$1(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
            s.block_start = s.strstart;
            flush_pending(s.strm);
        };
        var put_byte = function put_byte(s, b) {
            s.pending_buf[s.pending++] = b;
        };
        /* =========================================================================
         * Put a short in the pending buffer. The 16-bit value is put in MSB order.
         * IN assertion: the stream state is correct and there is enough room in
         * pending_buf.
         */
        var putShortMSB = function putShortMSB(s, b) {
            //  put_byte(s, (Byte)(b >> 8));
            //  put_byte(s, (Byte)(b & 0xff));
            s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
            s.pending_buf[s.pending++] = b & 0xff;
        };
        /* ===========================================================================
         * Read a new buffer from the current input stream, update the adler32
         * and total number of bytes read.  All deflate() input goes through
         * this function so some applications may wish to modify it to avoid
         * allocating a large strm->input buffer and copying from it.
         * (See also flush_pending()).
         */
        var read_buf = function read_buf(strm, buf, start, size) {
            var len = strm.avail_in;
            if (len > size) {
                len = size;
            }
            if (len === 0) {
                return 0;
            }
            strm.avail_in -= len; // zmemcpy(buf, strm->next_in, len);
            buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
            if (strm.state.wrap === 1) {
                strm.adler = adler32_1(strm.adler, buf, len, start);
            }
            else if (strm.state.wrap === 2) {
                strm.adler = crc32_1(strm.adler, buf, len, start);
            }
            strm.next_in += len;
            strm.total_in += len;
            return len;
        };
        /* ===========================================================================
         * Set match_start to the longest match starting at the given string and
         * return its length. Matches shorter or equal to prev_length are discarded,
         * in which case the result is equal to prev_length and match_start is
         * garbage.
         * IN assertions: cur_match is the head of the hash chain for the current
         *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
         * OUT assertion: the match length is not greater than s->lookahead.
         */
        var longest_match = function longest_match(s, cur_match) {
            var chain_length = s.max_chain_length;
            /* max hash chain length */
            var scan = s.strstart;
            /* current string */
            var match;
            /* matched string */
            var len;
            /* length of current match */
            var best_len = s.prev_length;
            /* best match length so far */
            var nice_match = s.nice_match;
            /* stop if match long enough */
            var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
            /* NIL */
            var _win = s.window; // shortcut
            var wmask = s.w_mask;
            var prev = s.prev;
            /* Stop when cur_match becomes <= limit. To simplify the code,
             * we prevent matches with the string of window index 0.
             */
            var strend = s.strstart + MAX_MATCH$1;
            var scan_end1 = _win[scan + best_len - 1];
            var scan_end = _win[scan + best_len];
            /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
             * It is easy to get rid of this optimization if necessary.
             */
            // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
            /* Do not waste too much time if we already have a good match: */
            if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
            }
            /* Do not look for matches beyond the end of the input. This is necessary
             * to make deflate deterministic.
             */
            if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
            } // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
            do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
                if (_win[match + best_len] !== scan_end ||
                    _win[match + best_len - 1] !== scan_end1 ||
                    _win[match] !== _win[scan] ||
                    _win[++match] !== _win[scan + 1]) {
                    continue;
                }
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++; // Assert(*scan == *match, "match[2]?");
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                    /* jshint noempty:false */
                } while (_win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    _win[++scan] === _win[++match] &&
                    scan < strend); // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
                len = MAX_MATCH$1 - (strend - scan);
                scan = strend - MAX_MATCH$1;
                if (len > best_len) {
                    s.match_start = cur_match;
                    best_len = len;
                    if (len >= nice_match) {
                        break;
                    }
                    scan_end1 = _win[scan + best_len - 1];
                    scan_end = _win[scan + best_len];
                }
            } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
            if (best_len <= s.lookahead) {
                return best_len;
            }
            return s.lookahead;
        };
        /* ===========================================================================
         * Fill the window when the lookahead becomes insufficient.
         * Updates strstart and lookahead.
         *
         * IN assertion: lookahead < MIN_LOOKAHEAD
         * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
         *    At least one byte has been read, or avail_in == 0; reads are
         *    performed for at least two bytes (required for the zip translate_eol
         *    option -- not supported here).
         */
        var fill_window = function fill_window(s) {
            var _w_size = s.w_size;
            var p;
            var n;
            var m;
            var more;
            var str; // Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
            do {
                more = s.window_size - s.lookahead - s.strstart; // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                // if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                // }
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                    s.window.set(s.window.subarray(_w_size, _w_size + _w_size), 0);
                    s.match_start -= _w_size;
                    s.strstart -= _w_size;
                    /* we now have strstart >= MAX_DIST */
                    s.block_start -= _w_size;
                    /* Slide the hash table (could be avoided with 32 bit values
                   at the expense of memory usage). We slide even when level == 0
                   to keep the hash table consistent if we switch back to level > 0
                   later. (Using level 0 permanently is not an optimal usage of
                   zlib, so we don't care about this pathological case.)
                   */
                    n = s.hash_size;
                    p = n;
                    do {
                        m = s.head[--p];
                        s.head[p] = m >= _w_size ? m - _w_size : 0;
                    } while (--n);
                    n = _w_size;
                    p = n;
                    do {
                        m = s.prev[--p];
                        s.prev[p] = m >= _w_size ? m - _w_size : 0;
                        /* If n is not on any hash chain, prev[n] is garbage but
                         * its value will never be used.
                         */
                    } while (--n);
                    more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                    break;
                }
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                // Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH$1) {
                    str = s.strstart - s.insert;
                    s.ins_h = s.window[str];
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + 1]); // #if MIN_MATCH != 3
                    //        Call update_hash() MIN_MATCH-3 more times
                    // #endif
                    while (s.insert) {
                        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                        s.prev[str & s.w_mask] = s.head[s.ins_h];
                        s.head[s.ins_h] = str;
                        str++;
                        s.insert--;
                        if (s.lookahead + s.insert < MIN_MATCH$1) {
                            break;
                        }
                    }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
            } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
            /* If the WIN_INIT bytes after the end of the current data have never been
             * written, then zero those bytes in order to avoid memory check reports of
             * the use of uninitialized (or uninitialised as Julian writes) bytes by
             * the longest match routines.  Update the high water mark for the next
             * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
             * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
             */
            //  if (s.high_water < s.window_size) {
            //    const curr = s.strstart + s.lookahead;
            //    let init = 0;
            //
            //    if (s.high_water < curr) {
            //      /* Previous high water mark below current data -- zero WIN_INIT
            //       * bytes or up to end of window, whichever is less.
            //       */
            //      init = s.window_size - curr;
            //      if (init > WIN_INIT)
            //        init = WIN_INIT;
            //      zmemzero(s->window + curr, (unsigned)init);
            //      s->high_water = curr + init;
            //    }
            //    else if (s->high_water < (ulg)curr + WIN_INIT) {
            //      /* High water mark at or above current data, but below current data
            //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
            //       * to end of window, whichever is less.
            //       */
            //      init = (ulg)curr + WIN_INIT - s->high_water;
            //      if (init > s->window_size - s->high_water)
            //        init = s->window_size - s->high_water;
            //      zmemzero(s->window + s->high_water, (unsigned)init);
            //      s->high_water += init;
            //    }
            //  }
            //
            //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
            //    "not enough room for search");
        };
        /* ===========================================================================
         * Copy without compression as much as possible from the input stream, return
         * the current block state.
         * This function does not insert new strings in the dictionary since
         * uncompressible data is probably not useful. This function is used
         * only for the level=0 compression option.
         * NOTE: this function should be optimized to avoid extra copying from
         * window to pending_buf.
         */
        var deflate_stored = function deflate_stored(s, flush) {
            /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
             * to pending_buf_size, and each stored block has a 5 byte header:
             */
            var max_block_size = 0xffff;
            if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
            }
            /* Copy as much as possible from input to output: */
            for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                    // Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                    //  s->block_start >= (long)s->w_size, "slide too late");
                    //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                    //        s.block_start >= s.w_size)) {
                    //        throw  new Error("slide too late");
                    //      }
                    fill_window(s);
                    if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                } // Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
                s.strstart += s.lookahead;
                s.lookahead = 0;
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
                if (s.strstart === 0 || s.strstart >= max_start) {
                    /* strstart == 0 is possible when wraparound on 16-bit machine */
                    s.lookahead = s.strstart - max_start;
                    s.strstart = max_start;
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.strstart > s.block_start) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_NEED_MORE;
        };
        /* ===========================================================================
         * Compress as much as possible from the input stream, return the current
         * block state.
         * This function does not perform lazy evaluation of matches and inserts
         * new strings in the dictionary only for unmatched strings or for short
         * matches. It is used only for the fast compression options.
         */
        var deflate_fast = function deflate_fast(s, flush) {
            var hash_head;
            /* head of the hash chain */
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                        /* flush the current block */
                    }
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (hash_head !== 0 &&
                    /* NIL */
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
                    /** * _tr_tally_dist(s, s.strstart - s.match_start,
                                 s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, s.strstart - s.match_start, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    /* Insert new strings in the hash table only if the match length
                     * is not too large. This saves time but degrades compression.
                     */
                    if (s.match_length <= s.max_lazy_match &&
                        /* max_insert_length */
                        s.lookahead >= MIN_MATCH$1) {
                        s.match_length--;
                        /* string at strstart already in table */
                        do {
                            s.strstart++;
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                            /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                             * always MIN_MATCH bytes ahead.
                             */
                        } while (--s.match_length !== 0);
                        s.strstart++;
                    }
                    else {
                        s.strstart += s.match_length;
                        s.match_length = 0;
                        s.ins_h = s.window[s.strstart];
                        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]); // #if MIN_MATCH != 3
                        //                Call UPDATE_HASH() MIN_MATCH-3 more times
                        // #endif
                        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                         * matter since it will be recomputed at next deflate call.
                         */
                    }
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s.window[s.strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * Same as above, but achieves better compression. We use a lazy
         * evaluation for matches: a match is finally adopted only if there is
         * no better match at the next window position.
         */
        var deflate_slow = function deflate_slow(s, flush) {
            var hash_head;
            /* head of hash chain */
            var bflush;
            /* set if current block must be flushed */
            var max_insert;
            /* Process the input block. */
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                    fill_window(s);
                    if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0;
                /* NIL */
                if (s.lookahead >= MIN_MATCH$1) {
                    /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                    s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                    /***/
                }
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH$1 - 1;
                if (hash_head !== 0 &&
                    /* NIL */
                    s.prev_length < s.max_lazy_match &&
                    s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                /* MAX_DIST(s) */
                ) {
                    /* To simplify the code, we prevent matches with the string
                     * of window index 0 (in particular we have to avoid a match
                     * of the string with itself at the start of the input file).
                     */
                    s.match_length = longest_match(s, hash_head);
                    /* longest_match() sets match_start */
                    if (s.match_length <= 5 &&
                        (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH$1 && s.strstart - s.match_start > 4096))
                    /* TOO_FAR */
                    ) {
                        /* If prev_match is also MIN_MATCH, match_start is garbage
                         * but we will ignore the current match anyway.
                         */
                        s.match_length = MIN_MATCH$1 - 1;
                    }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (s.prev_length >= MIN_MATCH$1 && s.match_length <= s.prev_length) {
                    max_insert = s.strstart + s.lookahead - MIN_MATCH$1;
                    /* Do not insert strings in hash table beyond this. */
                    // check_match(s, s.strstart-1, s.prev_match, s.prev_length);
                    /** *_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                                 s.prev_length - MIN_MATCH, bflush);** */
                    bflush = _tr_tally$1(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH$1);
                    /* Insert in hash table all strings up to the end of the match.
                     * strstart-1 and strstart are already inserted. If there is not
                     * enough lookahead, the last two strings are not inserted in
                     * the hash table.
                     */
                    s.lookahead -= s.prev_length - 1;
                    s.prev_length -= 2;
                    do {
                        if (++s.strstart <= max_insert) {
                            /** * INSERT_STRING(s, s.strstart, hash_head); ** */
                            s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH$1 - 1]);
                            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                            s.head[s.ins_h] = s.strstart;
                            /***/
                        }
                    } while (--s.prev_length !== 0);
                    s.match_available = 0;
                    s.match_length = MIN_MATCH$1 - 1;
                    s.strstart++;
                    if (bflush) {
                        /** * FLUSH_BLOCK(s, 0); ** */
                        flush_block_only(s, false);
                        if (s.strm.avail_out === 0) {
                            return BS_NEED_MORE;
                        }
                        /***/
                    }
                }
                else if (s.match_available) {
                    /* If there was no match at the previous position, output a
                     * single literal. If there was a match but the current match
                     * is longer, truncate the previous match to a single literal.
                     */
                    // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                    /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                    if (bflush) {
                        /** * FLUSH_BLOCK_ONLY(s, 0) ** */
                        flush_block_only(s, false);
                        /***/
                    }
                    s.strstart++;
                    s.lookahead--;
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                }
                else {
                    /* There is no previous match to compare with, wait for
                     * the next step to decide.
                     */
                    s.match_available = 1;
                    s.strstart++;
                    s.lookahead--;
                }
            } // Assert (flush != Z_NO_FLUSH, "no flush?");
            if (s.match_available) {
                // Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /** * _tr_tally_lit(s, s.window[s.strstart-1], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart - 1]);
                s.match_available = 0;
            }
            s.insert = s.strstart < MIN_MATCH$1 - 1 ? s.strstart : MIN_MATCH$1 - 1;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_RLE, simply look for runs of bytes, generate matches only of distance
         * one.  Do not maintain a hash table.  (It will be regenerated if this run of
         * deflate switches away from Z_RLE.)
         */
        var deflate_rle = function deflate_rle(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            var prev;
            /* byte at distance one to match */
            var scan;
            var strend;
            /* scan goes up to strend for length of run */
            var _win = s.window;
            for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH$1) {
                    fill_window(s);
                    if (s.lookahead <= MAX_MATCH$1 && flush === Z_NO_FLUSH) {
                        return BS_NEED_MORE;
                    }
                    if (s.lookahead === 0) {
                        break;
                    }
                    /* flush the current block */
                }
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH$1 && s.strstart > 0) {
                    scan = s.strstart - 1;
                    prev = _win[scan];
                    if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                        strend = s.strstart + MAX_MATCH$1;
                        do {
                            /* jshint noempty:false */
                        } while (prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            prev === _win[++scan] &&
                            scan < strend);
                        s.match_length = MAX_MATCH$1 - (strend - scan);
                        if (s.match_length > s.lookahead) {
                            s.match_length = s.lookahead;
                        }
                    } // Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH$1) {
                    // check_match(s, s.strstart, s.strstart - 1, s.match_length);
                    /** * _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ** */
                    bflush = _tr_tally$1(s, 1, s.match_length - MIN_MATCH$1);
                    s.lookahead -= s.match_length;
                    s.strstart += s.match_length;
                    s.match_length = 0;
                }
                else {
                    /* No match, output a literal byte */
                    // Tracevv((stderr,"%c", s->window[s->strstart]));
                    /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                    bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                    s.lookahead--;
                    s.strstart++;
                }
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* ===========================================================================
         * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
         * (It will be regenerated if this run of deflate switches away from Huffman.)
         */
        var deflate_huff = function deflate_huff(s, flush) {
            var bflush;
            /* set if current block must be flushed */
            for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                    fill_window(s);
                    if (s.lookahead === 0) {
                        if (flush === Z_NO_FLUSH) {
                            return BS_NEED_MORE;
                        }
                        break;
                        /* flush the current block */
                    }
                }
                /* Output a literal byte */
                s.match_length = 0; // Tracevv((stderr,"%c", s->window[s->strstart]));
                /** * _tr_tally_lit(s, s.window[s.strstart], bflush); ** */
                bflush = _tr_tally$1(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                    /** * FLUSH_BLOCK(s, 0); ** */
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                        return BS_NEED_MORE;
                    }
                    /***/
                }
            }
            s.insert = 0;
            if (flush === Z_FINISH) {
                /** * FLUSH_BLOCK(s, 1); ** */
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                    return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
            }
            if (s.last_lit) {
                /** * FLUSH_BLOCK(s, 0); ** */
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                }
                /***/
            }
            return BS_BLOCK_DONE;
        };
        /* Values for max_lazy_match, good_match and max_chain_length, depending on
         * the desired pack level (0..9). The values given below have been tuned to
         * exclude worst case performance for pathological files. Better values may be
         * found for specific files.
         */
        function Config(good_length, max_lazy, nice_length, max_chain, func) {
            this.good_length = good_length;
            this.max_lazy = max_lazy;
            this.nice_length = nice_length;
            this.max_chain = max_chain;
            this.func = func;
        }
        var configuration_table = [
            /*      good lazy nice chain */
            new Config(0, 0, 0, 0, deflate_stored),
            /* 0 store only */
            new Config(4, 4, 8, 4, deflate_fast),
            /* 1 max speed, no lazy matches */
            new Config(4, 5, 16, 8, deflate_fast),
            /* 2 */
            new Config(4, 6, 32, 32, deflate_fast),
            /* 3 */
            new Config(4, 4, 16, 16, deflate_slow),
            /* 4 lazy matches */
            new Config(8, 16, 32, 32, deflate_slow),
            /* 5 */
            new Config(8, 16, 128, 128, deflate_slow),
            /* 6 */
            new Config(8, 32, 128, 256, deflate_slow),
            /* 7 */
            new Config(32, 128, 258, 1024, deflate_slow),
            /* 8 */
            new Config(32, 258, 258, 4096, deflate_slow),
            /* 9 max compression */
        ];
        /* ===========================================================================
         * Initialize the "longest match" routines for a new zlib stream
         */
        var lm_init = function lm_init(s) {
            s.window_size = 2 * s.w_size;
            /** * CLEAR_HASH(s); ** */
            zero$1(s.head); // Fill with NIL (= 0);
            /* Set the default configuration parameters:
             */
            s.max_lazy_match = configuration_table[s.level].max_lazy;
            s.good_match = configuration_table[s.level].good_length;
            s.nice_match = configuration_table[s.level].nice_length;
            s.max_chain_length = configuration_table[s.level].max_chain;
            s.strstart = 0;
            s.block_start = 0;
            s.lookahead = 0;
            s.insert = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            s.ins_h = 0;
        };
        function DeflateState() {
            this.strm = null;
            /* pointer back to this zlib stream */
            this.status = 0;
            /* as the name implies */
            this.pending_buf = null;
            /* output still pending */
            this.pending_buf_size = 0;
            /* size of pending_buf */
            this.pending_out = 0;
            /* next pending byte to output to the stream */
            this.pending = 0;
            /* nb of bytes in the pending buffer */
            this.wrap = 0;
            /* bit 0 true for zlib, bit 1 true for gzip */
            this.gzhead = null;
            /* gzip header information to write */
            this.gzindex = 0;
            /* where in extra, name, or comment */
            this.method = Z_DEFLATED;
            /* can only be DEFLATED */
            this.last_flush = -1;
            /* value of flush param for previous deflate call */
            this.w_size = 0;
            /* LZ77 window size (32K by default) */
            this.w_bits = 0;
            /* log2(w_size)  (8..16) */
            this.w_mask = 0;
            /* w_size - 1 */
            this.window = null;
            /* Sliding window. Input bytes are read into the second half of the window,
             * and move to the first half later to keep a dictionary of at least wSize
             * bytes. With this organization, matches are limited to a distance of
             * wSize-MAX_MATCH bytes, but this ensures that IO is always
             * performed with a length multiple of the block size.
             */
            this.window_size = 0;
            /* Actual size of window: 2*wSize, except when the user input buffer
             * is directly used as sliding window.
             */
            this.prev = null;
            /* Link to older string with same hash index. To limit the size of this
             * array to 64K, this link is maintained only for the last 32K strings.
             * An index in this array is thus a window index modulo 32K.
             */
            this.head = null;
            /* Heads of the hash chains or NIL. */
            this.ins_h = 0;
            /* hash index of string to be inserted */
            this.hash_size = 0;
            /* number of elements in hash table */
            this.hash_bits = 0;
            /* log2(hash_size) */
            this.hash_mask = 0;
            /* hash_size-1 */
            this.hash_shift = 0;
            /* Number of bits by which ins_h must be shifted at each input
             * step. It must be such that after MIN_MATCH steps, the oldest
             * byte no longer takes part in the hash key, that is:
             *   hash_shift * MIN_MATCH >= hash_bits
             */
            this.block_start = 0;
            /* Window position at the beginning of the current output block. Gets
             * negative when the window is moved backwards.
             */
            this.match_length = 0;
            /* length of best match */
            this.prev_match = 0;
            /* previous match */
            this.match_available = 0;
            /* set if previous match exists */
            this.strstart = 0;
            /* start of string to insert */
            this.match_start = 0;
            /* start of matching string */
            this.lookahead = 0;
            /* number of valid bytes ahead in window */
            this.prev_length = 0;
            /* Length of the best match at previous step. Matches not greater than this
             * are discarded. This is used in the lazy match evaluation.
             */
            this.max_chain_length = 0;
            /* To speed up deflation, hash chains are never searched beyond this
             * length.  A higher limit improves compression ratio but degrades the
             * speed.
             */
            this.max_lazy_match = 0;
            /* Attempt to find a better match only when the current match is strictly
             * smaller than this value. This mechanism is used only for compression
             * levels >= 4.
             */
            // That's alias to max_lazy_match, don't use directly
            // this.max_insert_length = 0;
            /* Insert new strings in the hash table only if the match length is not
             * greater than this length. This saves time but degrades compression.
             * max_insert_length is used only for compression levels <= 3.
             */
            this.level = 0;
            /* compression level (1..9) */
            this.strategy = 0;
            /* favor or force Huffman coding */
            this.good_match = 0;
            /* Use a faster search when the previous match is longer than this */
            this.nice_match = 0;
            /* Stop searching when current match exceeds this */
            /* used by trees.c: */
            /* Didn't use ct_data typedef below to suppress compiler warning */
            // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
            // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
            // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
            // Use flat array of DOUBLE size, with interleaved fata,
            // because JS does not support effective
            this.dyn_ltree = new Uint16Array(HEAP_SIZE$1 * 2);
            this.dyn_dtree = new Uint16Array((2 * D_CODES$1 + 1) * 2);
            this.bl_tree = new Uint16Array((2 * BL_CODES$1 + 1) * 2);
            zero$1(this.dyn_ltree);
            zero$1(this.dyn_dtree);
            zero$1(this.bl_tree);
            this.l_desc = null;
            /* desc. for literal tree */
            this.d_desc = null;
            /* desc. for distance tree */
            this.bl_desc = null;
            /* desc. for bit length tree */
            // ush bl_count[MAX_BITS+1];
            this.bl_count = new Uint16Array(MAX_BITS$1 + 1);
            /* number of codes at each bit length for an optimal tree */
            // int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
            this.heap = new Uint16Array(2 * L_CODES$1 + 1);
            /* heap used to build the Huffman trees */
            zero$1(this.heap);
            this.heap_len = 0;
            /* number of elements in the heap */
            this.heap_max = 0;
            /* element of largest frequency */
            /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
             * The same heap array is used to build all trees.
             */
            this.depth = new Uint16Array(2 * L_CODES$1 + 1); // uch depth[2*L_CODES+1];
            zero$1(this.depth);
            /* Depth of each subtree used as tie breaker for trees of equal frequency
             */
            this.l_buf = 0;
            /* buffer index for literals or lengths */
            this.lit_bufsize = 0;
            /* Size of match buffer for literals/lengths.  There are 4 reasons for
             * limiting lit_bufsize to 64K:
             *   - frequencies can be kept in 16 bit counters
             *   - if compression is not successful for the first block, all input
             *     data is still in the window so we can still emit a stored block even
             *     when input comes from standard input.  (This can also be done for
             *     all blocks if lit_bufsize is not greater than 32K.)
             *   - if compression is not successful for a file smaller than 64K, we can
             *     even emit a stored file instead of a stored block (saving 5 bytes).
             *     This is applicable only for zip (not gzip or zlib).
             *   - creating new Huffman trees less frequently may not provide fast
             *     adaptation to changes in the input data statistics. (Take for
             *     example a binary file with poorly compressible code followed by
             *     a highly compressible string table.) Smaller buffer sizes give
             *     fast adaptation but have of course the overhead of transmitting
             *     trees more frequently.
             *   - I can't count above 4
             */
            this.last_lit = 0;
            /* running index in l_buf */
            this.d_buf = 0;
            /* Buffer index for distances. To simplify the code, d_buf and l_buf have
             * the same number of elements. To use different lengths, an extra flag
             * array would be necessary.
             */
            this.opt_len = 0;
            /* bit length of current block with optimal trees */
            this.static_len = 0;
            /* bit length of current block with static trees */
            this.matches = 0;
            /* number of string matches in current block */
            this.insert = 0;
            /* bytes at end of window left to insert */
            this.bi_buf = 0;
            /* Output buffer. bits are inserted starting at the bottom (least
             * significant bits).
             */
            this.bi_valid = 0;
            /* Number of valid bits in bi_buf.  All bits above the last valid bit
             * are always zero.
             */
            // Used for window memory init. We safely ignore it for JS. That makes
            // sense only for pointers and memory check tools.
            // this.high_water = 0;
            /* High water mark offset in window for initialized bytes -- bytes above
             * this are set to zero in order to avoid memory check warnings when
             * longest match routines access bytes past the input.  This is then
             * updated to the new high water mark.
             */
        }
        var deflateResetKeep = function deflateResetKeep(strm) {
            if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.total_in = strm.total_out = 0;
            strm.data_type = Z_UNKNOWN$1;
            var s = strm.state;
            s.pending = 0;
            s.pending_out = 0;
            if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
            }
            s.status = s.wrap ? INIT_STATE : BUSY_STATE;
            strm.adler =
                s.wrap === 2
                    ? 0 // crc32(0, Z_NULL, 0)
                    : 1; // adler32(0, Z_NULL, 0)
            s.last_flush = Z_NO_FLUSH;
            _tr_init$1(s);
            return Z_OK;
        };
        var deflateReset = function deflateReset(strm) {
            var ret = deflateResetKeep(strm);
            if (ret === Z_OK) {
                lm_init(strm.state);
            }
            return ret;
        };
        var deflateSetHeader = function deflateSetHeader(strm, head) {
            if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
            }
            if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
            }
            strm.state.gzhead = head;
            return Z_OK;
        };
        var deflateInit2 = function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
            if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
            }
            var wrap = 1;
            if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
            }
            if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
            }
            else if (windowBits > 15) {
                wrap = 2;
                /* write gzip wrapper instead */
                windowBits -= 16;
            }
            if (memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED$1) {
                return err(strm, Z_STREAM_ERROR);
            }
            if (windowBits === 8) {
                windowBits = 9;
            }
            /* until 256-byte window bug fixed */
            var s = new DeflateState();
            strm.state = s;
            s.strm = strm;
            s.wrap = wrap;
            s.gzhead = null;
            s.w_bits = windowBits;
            s.w_size = 1 << s.w_bits;
            s.w_mask = s.w_size - 1;
            s.hash_bits = memLevel + 7;
            s.hash_size = 1 << s.hash_bits;
            s.hash_mask = s.hash_size - 1;
            s.hash_shift = ~~((s.hash_bits + MIN_MATCH$1 - 1) / MIN_MATCH$1);
            s.window = new Uint8Array(s.w_size * 2);
            s.head = new Uint16Array(s.hash_size);
            s.prev = new Uint16Array(s.w_size); // Don't need mem init magic for JS.
            // s.high_water = 0;  /* nothing written to s->window yet */
            s.lit_bufsize = 1 << (memLevel + 6);
            /* 16K elements by default */
            s.pending_buf_size = s.lit_bufsize * 4;
            // overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
            // s->pending_buf = (uchf *) overlay;
            // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
            s.pending_buf = new Uint8Array(s.pending_buf_size);
            // s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
            s.d_buf = 1 * s.lit_bufsize; // s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
            s.l_buf = (1 + 2) * s.lit_bufsize;
            s.level = level;
            s.strategy = strategy;
            s.method = method;
            return deflateReset(strm);
        };
        var deflateInit = function deflateInit(strm, level) {
            return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
        };
        var deflate = function deflate(strm, flush) {
            var beg;
            var val; // for gzip header write only
            if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
            }
            var s = strm.state;
            if (!strm.output || (!strm.input && strm.avail_in !== 0) || (s.status === FINISH_STATE && flush !== Z_FINISH)) {
                return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
            }
            s.strm = strm;
            /* just in case */
            var old_flush = s.last_flush;
            s.last_flush = flush;
            /* Write the header */
            if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                    // GZIP header
                    strm.adler = 0; // crc32(0L, Z_NULL, 0);
                    put_byte(s, 31);
                    put_byte(s, 139);
                    put_byte(s, 8);
                    if (!s.gzhead) {
                        // s->gzhead == Z_NULL
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, 0);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, OS_CODE);
                        s.status = BUSY_STATE;
                    }
                    else {
                        put_byte(s, (s.gzhead.text ? 1 : 0) +
                            (s.gzhead.hcrc ? 2 : 0) +
                            (!s.gzhead.extra ? 0 : 4) +
                            (!s.gzhead.name ? 0 : 8) +
                            (!s.gzhead.comment ? 0 : 16));
                        put_byte(s, s.gzhead.time & 0xff);
                        put_byte(s, (s.gzhead.time >> 8) & 0xff);
                        put_byte(s, (s.gzhead.time >> 16) & 0xff);
                        put_byte(s, (s.gzhead.time >> 24) & 0xff);
                        put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                        put_byte(s, s.gzhead.os & 0xff);
                        if (s.gzhead.extra && s.gzhead.extra.length) {
                            put_byte(s, s.gzhead.extra.length & 0xff);
                            put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                        }
                        if (s.gzhead.hcrc) {
                            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
                        }
                        s.gzindex = 0;
                        s.status = EXTRA_STATE;
                    }
                } // DEFLATE header
                else {
                    var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                    var level_flags = -1;
                    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                        level_flags = 0;
                    }
                    else if (s.level < 6) {
                        level_flags = 1;
                    }
                    else if (s.level === 6) {
                        level_flags = 2;
                    }
                    else {
                        level_flags = 3;
                    }
                    header |= level_flags << 6;
                    if (s.strstart !== 0) {
                        header |= PRESET_DICT;
                    }
                    header += 31 - (header % 31);
                    s.status = BUSY_STATE;
                    putShortMSB(s, header);
                    /* Save the adler32 of the preset dictionary: */
                    if (s.strstart !== 0) {
                        putShortMSB(s, strm.adler >>> 16);
                        putShortMSB(s, strm.adler & 0xffff);
                    }
                    strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
            } // #ifdef GZIP
            if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                break;
                            }
                        }
                        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                        s.gzindex++;
                    }
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (s.gzindex === s.gzhead.extra.length) {
                        s.gzindex = 0;
                        s.status = NAME_STATE;
                    }
                }
                else {
                    s.status = NAME_STATE;
                }
            }
            if (s.status === NAME_STATE) {
                if (s.gzhead.name
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.name.length) {
                            val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.gzindex = 0;
                        s.status = COMMENT_STATE;
                    }
                }
                else {
                    s.status = COMMENT_STATE;
                }
            }
            if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment
                /* != Z_NULL */
                ) {
                    beg = s.pending;
                    /* start of bytes to update crc */
                    // int val;
                    do {
                        if (s.pending === s.pending_buf_size) {
                            if (s.gzhead.hcrc && s.pending > beg) {
                                strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                            }
                            flush_pending(strm);
                            beg = s.pending;
                            if (s.pending === s.pending_buf_size) {
                                val = 1;
                                break;
                            }
                        } // JS specific: little magic to add zero terminator to end of string
                        if (s.gzindex < s.gzhead.comment.length) {
                            val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                        }
                        else {
                            val = 0;
                        }
                        put_byte(s, val);
                    } while (val !== 0);
                    if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    }
                    if (val === 0) {
                        s.status = HCRC_STATE;
                    }
                }
                else {
                    s.status = HCRC_STATE;
                }
            }
            if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                    if (s.pending + 2 > s.pending_buf_size) {
                        flush_pending(strm);
                    }
                    if (s.pending + 2 <= s.pending_buf_size) {
                        put_byte(s, strm.adler & 0xff);
                        put_byte(s, (strm.adler >> 8) & 0xff);
                        strm.adler = 0; // crc32(0L, Z_NULL, 0);
                        s.status = BUSY_STATE;
                    }
                }
                else {
                    s.status = BUSY_STATE;
                }
            } // #endif
            /* Flush as much pending output as possible */
            if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                    /* Since avail_out is 0, deflate will be called again with
                     * more output space, but possibly with both pending and
                     * avail_in equal to zero. There won't be anything to do,
                     * but this is not an error situation so make sure we
                     * return OK instead of BUF_ERROR at next call of deflate:
                     */
                    s.last_flush = -1;
                    return Z_OK;
                }
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
            }
            else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
                return err(strm, Z_BUF_ERROR);
            }
            /* User must not provide more input after the first FINISH: */
            if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
            }
            /* Start a new block or continue the current one.
             */
            if (strm.avail_in !== 0 || s.lookahead !== 0 || (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
                var bstate = s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                        ? deflate_rle(s, flush)
                        : configuration_table[s.level].func(s, flush);
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                    s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR next call, see above */
                    }
                    return Z_OK;
                    /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                     * of deflate should use the same flush parameter to make sure
                     * that the flush is complete. So we don't have to output an
                     * empty block here, this will be done at next call. This also
                     * ensures that for a very small output buffer, we emit at most
                     * one empty block.
                     */
                }
                if (bstate === BS_BLOCK_DONE) {
                    if (flush === Z_PARTIAL_FLUSH) {
                        _tr_align$1(s);
                    }
                    else if (flush !== Z_BLOCK) {
                        /* FULL_FLUSH or SYNC_FLUSH */
                        _tr_stored_block$1(s, 0, 0, false);
                        /* For a full flush, this empty block will be recognized
                         * as a special marker by inflate_sync().
                         */
                        if (flush === Z_FULL_FLUSH) {
                            /** * CLEAR_HASH(s); ** */
                            /* forget history */
                            zero$1(s.head); // Fill with NIL (= 0);
                            if (s.lookahead === 0) {
                                s.strstart = 0;
                                s.block_start = 0;
                                s.insert = 0;
                            }
                        }
                    }
                    flush_pending(strm);
                    if (strm.avail_out === 0) {
                        s.last_flush = -1;
                        /* avoid BUF_ERROR at next call, see above */
                        return Z_OK;
                    }
                }
            } // Assert(strm->avail_out > 0, "bug2");
            // if (strm.avail_out <= 0) { throw new Error("bug2");}
            if (flush !== Z_FINISH) {
                return Z_OK;
            }
            if (s.wrap <= 0) {
                return Z_STREAM_END;
            }
            /* Write the trailer */
            if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
            }
            else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            flush_pending(strm);
            /* If avail_out is zero, the application will call deflate again
             * to flush the rest.
             */
            if (s.wrap > 0) {
                s.wrap = -s.wrap;
            }
            /* write the trailer only once! */
            return s.pending !== 0 ? Z_OK : Z_STREAM_END;
        };
        var deflateEnd = function deflateEnd(strm) {
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var status = strm.state.status;
            if (status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE) {
                return err(strm, Z_STREAM_ERROR);
            }
            strm.state = null;
            return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
        };
        /* =========================================================================
         * Initializes the compression dictionary from the given byte
         * sequence without producing any compressed output.
         */
        var deflateSetDictionary = function deflateSetDictionary(strm, dictionary) {
            var dictLength = dictionary.length;
            if (!strm ||
                /* == Z_NULL */
                !strm.state
            /* == Z_NULL */
            ) {
                return Z_STREAM_ERROR;
            }
            var s = strm.state;
            var wrap = s.wrap;
            if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
                return Z_STREAM_ERROR;
            }
            /* when using zlib wrappers, compute Adler-32 for provided dictionary */
            if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
            }
            s.wrap = 0;
            /* avoid computing Adler-32 in read_buf */
            /* if dictionary would fill window, just replace the history */
            if (dictLength >= s.w_size) {
                if (wrap === 0) {
                    /* already empty otherwise */
                    /** * CLEAR_HASH(s); ** */
                    zero$1(s.head); // Fill with NIL (= 0);
                    s.strstart = 0;
                    s.block_start = 0;
                    s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                var tmpDict = new Uint8Array(s.w_size);
                tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
                dictionary = tmpDict;
                dictLength = s.w_size;
            }
            /* insert dictionary into window and hash */
            var avail = strm.avail_in;
            var next = strm.next_in;
            var input = strm.input;
            strm.avail_in = dictLength;
            strm.next_in = 0;
            strm.input = dictionary;
            fill_window(s);
            while (s.lookahead >= MIN_MATCH$1) {
                var str = s.strstart;
                var n = s.lookahead - (MIN_MATCH$1 - 1);
                do {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH$1 - 1]);
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH$1 - 1;
                fill_window(s);
            }
            s.strstart += s.lookahead;
            s.block_start = s.strstart;
            s.insert = s.lookahead;
            s.lookahead = 0;
            s.match_length = s.prev_length = MIN_MATCH$1 - 1;
            s.match_available = 0;
            strm.next_in = next;
            strm.input = input;
            strm.avail_in = avail;
            s.wrap = wrap;
            return Z_OK;
        };
        var deflateInit_1 = deflateInit;
        var deflateInit2_1 = deflateInit2;
        var deflateReset_1 = deflateReset;
        var deflateResetKeep_1 = deflateResetKeep;
        var deflateSetHeader_1 = deflateSetHeader;
        var deflate_2 = deflate;
        var deflateEnd_1 = deflateEnd;
        var deflateSetDictionary_1 = deflateSetDictionary;
        var deflateInfo = 'pako deflate (from Nodeca project)';
        /* Not implemented
      module.exports.deflateBound = deflateBound;
      module.exports.deflateCopy = deflateCopy;
      module.exports.deflateParams = deflateParams;
      module.exports.deflatePending = deflatePending;
      module.exports.deflatePrime = deflatePrime;
      module.exports.deflateTune = deflateTune;
      */
        var deflate_1 = {
            deflateInit: deflateInit_1,
            deflateInit2: deflateInit2_1,
            deflateReset: deflateReset_1,
            deflateResetKeep: deflateResetKeep_1,
            deflateSetHeader: deflateSetHeader_1,
            deflate: deflate_2,
            deflateEnd: deflateEnd_1,
            deflateSetDictionary: deflateSetDictionary_1,
            deflateInfo: deflateInfo,
        };
        // Join array of chunks to single array.
        function flattenChunks(chunks) {
            // calculate data length
            var len = 0;
            for (var i = 0, l = chunks.length; i < l; i++) {
                len += chunks[i].length;
            } // join chunks
            var result = new Uint8Array(len);
            for (var _i = 0, pos = 0, _l = chunks.length; _i < _l; _i++) {
                var chunk = chunks[_i];
                result.set(chunk, pos);
                pos += chunk.length;
            }
            return result;
        }
        // String encode/decode helpers
        //
        // - apply(Array) can fail on Android 2.2
        // - apply(Uint8Array) can fail on iOS 5.1 Safari
        //
        // Table with utf8 lengths (calculated by first byte of sequence)
        // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
        // because max possible codepoint is 0x10ffff
        var _utf8len = new Uint8Array(256);
        for (var q = 0; q < 256; q++) {
            _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
        }
        _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
        // convert string to array (typed, when possible)
        // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
        //
        // This software is provided 'as-is', without any express or implied
        // warranty. In no event will the authors be held liable for any damages
        // arising from the use of this software.
        //
        // Permission is granted to anyone to use this software for any purpose,
        // including commercial applications, and to alter it and redistribute it
        // freely, subject to the following restrictions:
        //
        // 1. The origin of this software must not be misrepresented; you must not
        //   claim that you wrote the original software. If you use this software
        //   in a product, an acknowledgment in the product documentation would be
        //   appreciated but is not required.
        // 2. Altered source versions must be plainly marked as such, and must not be
        //   misrepresented as being the original software.
        // 3. This notice may not be removed or altered from any source distribution.
        function ZStream() {
            /* next input byte */
            this.input = null; // JS specific, because we have no pointers
            this.next_in = 0;
            /* number of bytes available at input */
            this.avail_in = 0;
            /* total number of input bytes read so far */
            this.total_in = 0;
            /* next output byte should be put there */
            this.output = null; // JS specific, because we have no pointers
            this.next_out = 0;
            /* remaining free space at output */
            this.avail_out = 0;
            /* total number of bytes output so far */
            this.total_out = 0;
            /* last error message, NULL if no error */
            this.msg = '';
            /* Z_NULL */
            /* not visible by applications */
            this.state = null;
            /* best guess about the data type: binary or text */
            this.data_type = 2;
            /* Z_UNKNOWN */
            /* adler32 value of the uncompressed data */
            this.adler = 0;
        }
        var zstream = ZStream;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var toString = Object.prototype.toString;
        /* Public constants ========================================================== */
        /* =========================================================================== */
        var Z_NO_FLUSH$1 = constants.Z_NO_FLUSH;
        var Z_SYNC_FLUSH = constants.Z_SYNC_FLUSH;
        var Z_FULL_FLUSH$1 = constants.Z_FULL_FLUSH;
        var Z_FINISH$1 = constants.Z_FINISH;
        var Z_OK$1 = constants.Z_OK;
        var Z_STREAM_END$1 = constants.Z_STREAM_END;
        var Z_DEFAULT_COMPRESSION$1 = constants.Z_DEFAULT_COMPRESSION;
        var Z_DEFAULT_STRATEGY$1 = constants.Z_DEFAULT_STRATEGY;
        var Z_DEFLATED$1 = constants.Z_DEFLATED;
        /* =========================================================================== */
        /**
         * class Deflate
         *
         * Generic JS-style wrapper for zlib calls. If you don't need
         * streaming behaviour - use more simple functions: [[deflate]],
         * [[deflateRaw]] and [[gzip]].
         * */
        /* internal
         * Deflate.chunks -> Array
         *
         * Chunks of output data, if [[Deflate#onData]] not overridden.
         * */
        /**
         * Deflate.result -> Uint8Array
         *
         * Compressed result, generated by default [[Deflate#onData]]
         * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
         * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
         * */
        /**
         * Deflate.err -> Number
         *
         * Error code after deflate finished. 0 (Z_OK) on success.
         * You will not need it in real life, because deflate errors
         * are possible only on wrong options or bad `onData` / `onEnd`
         * custom handlers.
         * */
        /**
         * Deflate.msg -> String
         *
         * Error message, if [[Deflate.err]] != 0
         * */
        /**
         * new Deflate(options)
         * - options (Object): zlib deflate options.
         *
         * Creates new deflator instance with specified params. Throws exception
         * on bad params. Supported options:
         *
         * - `level`
         * - `windowBits`
         * - `memLevel`
         * - `strategy`
         * - `dictionary`
         *
         * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
         * for more information on these.
         *
         * Additional options, for internal needs:
         *
         * * `chunkSize` - size of generated data chunks (16K by default)
         * * `raw` (Boolean) - do raw deflate
         * * `gzip` (Boolean) - create gzip wrapper
         * * `header` (Object) - custom header for gzip
         * ** `text` (Boolean) - true if compressed data believed to be text
         * ** `time` (Number) - modification time, unix timestamp
         * ** `os` (Number) - operation system code
         * ** `extra` (Array) - array of bytes with extra data (max 65536)
         * ** `name` (String) - file name (binary string)
         * ** `comment` (String) - comment (binary string)
         * ** `hcrc` (Boolean) - true if header crc should be added
         *
         * ##### Example:
         *
         * ```javascript
         * const pako = require('pako')
         *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
         *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
         *
         * const deflate = new pako.Deflate({ level: 3});
         *
         * deflate.push(chunk1, false);
         * deflate.push(chunk2, true);  // true -> last chunk
         *
         * if (deflate.err) { throw new Error(deflate.err); }
         *
         * console.log(deflate.result);
         * ```
         * */
        function Deflate() {
            this.options = {
                level: Z_DEFAULT_COMPRESSION$1,
                method: Z_DEFLATED$1,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: Z_DEFAULT_STRATEGY$1,
            };
            var opt = this.options;
            if (opt.raw && opt.windowBits > 0) {
                opt.windowBits = -opt.windowBits;
            }
            else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
                opt.windowBits += 16;
            }
            this.err = 0; // error code, if happens (0 = Z_OK)
            this.msg = ''; // error message
            this.ended = false; // used to avoid multiple onEnd() calls
            this.chunks = []; // chunks of compressed data
            this.strm = new zstream();
            this.strm.avail_out = 0;
            var status = deflate_1.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
            if (status !== Z_OK$1) {
                throw new Error(messages[status]);
            }
            if (opt.header) {
                deflate_1.deflateSetHeader(this.strm, opt.header);
            }
            if (opt.dictionary) {
                var dict; // Convert data if needed
                if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
                    dict = new Uint8Array(opt.dictionary);
                }
                else {
                    dict = opt.dictionary;
                }
                status = deflate_1.deflateSetDictionary(this.strm, dict);
                if (status !== Z_OK$1) {
                    throw new Error(messages[status]);
                }
                this._dict_set = true;
            }
        }
        /**
         * Deflate#push(data[, flush_mode]) -> Boolean
         * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
         * converted to utf8 byte sequence.
         * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
         * See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
         *
         * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
         * new compressed chunks. Returns `true` on success. The last data block must
         * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
         * buffers and call [[Deflate#onEnd]].
         *
         * On fail call [[Deflate#onEnd]] with error code and return false.
         *
         * ##### Example
         *
         * ```javascript
         * push(chunk, false); // push one of data chunks
         * ...
         * push(chunk, true);  // push last chunk
         * ```
         * */
        Deflate.prototype.push = function (data, flush_mode) {
            var strm = this.strm;
            var chunkSize = this.options.chunkSize;
            var status;
            var _flush_mode;
            if (this.ended) {
                return false;
            }
            if (flush_mode === ~~flush_mode) {
                _flush_mode = flush_mode;
            }
            else {
                _flush_mode = flush_mode === true ? Z_FINISH$1 : Z_NO_FLUSH$1;
            } // Convert data if needed
            if (toString.call(data) === '[object ArrayBuffer]') {
                strm.input = new Uint8Array(data);
            }
            else {
                strm.input = data;
            }
            strm.next_in = 0;
            strm.avail_in = strm.input.length;
            for (;;) {
                if (strm.avail_out === 0) {
                    strm.output = new Uint8Array(chunkSize);
                    strm.next_out = 0;
                    strm.avail_out = chunkSize;
                } // Make sure avail_out > 6 to avoid repeating markers
                if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH$1) && strm.avail_out <= 6) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                status = deflate_1.deflate(strm, _flush_mode); // Ended => flush and finish
                if (status === Z_STREAM_END$1) {
                    if (strm.next_out > 0) {
                        this.onData(strm.output.subarray(0, strm.next_out));
                    }
                    status = deflate_1.deflateEnd(this.strm);
                    this.onEnd(status);
                    this.ended = true;
                    return status === Z_OK$1;
                } // Flush if out buffer full
                if (strm.avail_out === 0) {
                    this.onData(strm.output);
                    continue;
                } // Flush if requested and has data
                if (_flush_mode > 0 && strm.next_out > 0) {
                    this.onData(strm.output.subarray(0, strm.next_out));
                    strm.avail_out = 0;
                    continue;
                }
                if (strm.avail_in === 0) {
                    break;
                }
            }
            return true;
        };
        /**
         * Deflate#onData(chunk) -> Void
         * - chunk (Uint8Array): output data.
         *
         * By default, stores data blocks in `chunks[]` property and glue
         * those in `onEnd`. Override this handler, if you need another behaviour.
         * */
        Deflate.prototype.onData = function (chunk) {
            this.chunks.push(chunk);
        };
        /**
         * Deflate#onEnd(status) -> Void
         * - status (Number): deflate status. 0 (Z_OK) on success,
         * other if not.
         *
         * Called once after you tell deflate that the input stream is
         * complete (Z_FINISH). By default - join collected chunks,
         * free memory and fill `results` / `err` properties.
         * */
        Deflate.prototype.onEnd = function (status) {
            // On success - join
            if (status === Z_OK$1) {
                this.result = flattenChunks(this.chunks);
            }
            this.chunks = [];
            this.err = status;
            this.msg = this.strm.msg;
        };
        // https://github.com/nodeca/pako/blob/26dff4fb3472c5532b3bd8856421146d35ab7592/lib/utils/strings.js#L26
        function string2buf(str) {
            if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
                return new TextEncoder().encode(str);
            }
            var buf;
            var c;
            var c2;
            var m_pos;
            var i;
            var str_len = str.length;
            var buf_len = 0;
            // count binary size
            for (m_pos = 0; m_pos < str_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
            }
            // allocate buffer
            buf = new Uint8Array(buf_len);
            // convert
            for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
                c = str.charCodeAt(m_pos);
                if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
                    c2 = str.charCodeAt(m_pos + 1);
                    if ((c2 & 0xfc00) === 0xdc00) {
                        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                        m_pos++;
                    }
                }
                if (c < 0x80) {
                    /* one byte */
                    buf[i++] = c;
                }
                else if (c < 0x800) {
                    /* two bytes */
                    buf[i++] = 0xc0 | (c >>> 6);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else if (c < 0x10000) {
                    /* three bytes */
                    buf[i++] = 0xe0 | (c >>> 12);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
                else {
                    /* four bytes */
                    buf[i++] = 0xf0 | (c >>> 18);
                    buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
                    buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
                    buf[i++] = 0x80 | (c & 0x3f);
                }
            }
            return buf;
        }
        return { Deflate: Deflate, constants: constants, string2buf: string2buf };
    }
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/startDeflateWorker.js


var state = { status: 0 /* Nil */ };
function startDeflateWorker(callback, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    switch (state.status) {
        case 0 /* Nil */:
            state = { status: 1 /* Loading */, callbacks: [callback] };
            doStartDeflateWorker(createDeflateWorkerImpl);
            break;
        case 1 /* Loading */:
            state.callbacks.push(callback);
            break;
        case 2 /* Error */:
            callback();
            break;
        case 3 /* Initialized */:
            callback(state.worker);
            break;
    }
}
function resetDeflateWorkerState() {
    state = { status: 0 /* Nil */ };
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker_1 = createDeflateWorkerImpl();
        worker_1.addEventListener('error', (0,monitor/* monitor */.zk)(onError));
        worker_1.addEventListener('message', (0,monitor/* monitor */.zk)(function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(data.error);
            }
            else if (data.type === 'initialized') {
                onInitialized(worker_1);
            }
        }));
        worker_1.postMessage({ action: 'init' });
        return worker_1;
    }
    catch (error) {
        onError(error);
    }
}
function onInitialized(worker) {
    if (state.status === 1 /* Loading */) {
        state.callbacks.forEach(function (callback) { return callback(worker); });
        state = { status: 3 /* Initialized */, worker: worker };
    }
}
function onError(error) {
    if (state.status === 1 /* Loading */) {
        display/* display.error */.j.error('Session Replay recording failed to start: an error occurred while creating the Worker:', error);
        if (error instanceof Event || (error instanceof Error && (0,utils/* includes */.q9)(error.message, 'Content Security Policy'))) {
            display/* display.error */.j.error('Please make sure CSP is correctly configured ' +
                'https://docs.datadoghq.com/real_user_monitoring/faq/content_security_policy');
        }
        else {
            (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
        }
        state.callbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* Error */ };
    }
    else {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
    }
}
//# sourceMappingURL=startDeflateWorker.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* RAW_ERROR_COLLECTED */, { error: error });
    };
    var replayRequest = httpRequest || (0,transport_httpRequest/* createHttpRequest */.UF)(configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, viewContexts, replayRequest, worker), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.js



function makeRecorderApi(startRecordingImpl, startDeflateWorkerImpl) {
    if (startDeflateWorkerImpl === void 0) { startDeflateWorkerImpl = startDeflateWorker; }
    if ((0,eventBridge/* canUseEventBridge */.x)() || !isBrowserSupported()) {
        return {
            start: utils/* noop */.ZT,
            stop: utils/* noop */.ZT,
            getReplayStats: function () { return undefined; },
            onRumStart: utils/* noop */.ZT,
            isRecording: function () { return false; },
        };
    }
    var state = {
        status: 0 /* Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getReplayStats: getReplayStats,
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* SESSION_EXPIRED */, function () {
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    stopStrategy();
                    state = { status: 1 /* IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* SESSION_RENEWED */, function () {
                if (state.status === 1 /* IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* Starting */ || state.status === 3 /* Started */) {
                    return;
                }
                state = { status: 2 /* Starting */ };
                runOnReadyState('interactive', function () {
                    if (state.status !== 2 /* Starting */) {
                        return;
                    }
                    startDeflateWorkerImpl(function (worker) {
                        if (state.status !== 2 /* Starting */) {
                            return;
                        }
                        if (!worker) {
                            state = {
                                status: 0 /* Stopped */,
                            };
                            return;
                        }
                        var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, worker).stop;
                        state = {
                            status: 3 /* Started */,
                            stopRecording: stopRecording,
                        };
                    });
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* Stopped */) {
                    return;
                }
                if (state.status === 3 /* Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* Stopped */,
                };
            };
            if (state.status === 1 /* IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () { return state.status === 3 /* Started */; },
    };
}
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' && typeof CSSSupportsRule === 'function' && 'forEach' in NodeList.prototype);
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
(0,init/* defineGlobal */.y)((0,utils/* getGlobalObject */.Rf)(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/sizes.js
var sizes = __webpack_require__(34882);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/breakpoints.js
var breakpoints = __webpack_require__(72486);
;// CONCATENATED MODULE: ./src/theme.ts





var theme = {
    breakpoints: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, breakpoints["default"]), {
        xl: "1280px",
        "2xl": breakpoints["default"].xl,
        "3xl": breakpoints["default"]["2xl"]
    }),
    sizes: {
        container: (0,_object_spread/* default */.Z)({}, sizes/* default.container */.Z.container)
    },
    components: {
        Menu: {
            variants: {
                filter: {
                    groupTitle: {
                        fontSize: "md",
                        position: "sticky",
                        zIndex: 1,
                        backgroundColor: "white",
                        top: 0,
                        left: 0,
                        margin: 0,
                        padding: 4
                    },
                    list: {
                        paddingTop: 0,
                        paddingBottom: 4
                    },
                    item: {
                        paddingX: 4,
                        paddingY: 2,
                        fontSize: "sm"
                    }
                }
            }
        },
        Button: {
            variants: {
                link: {
                    fontWeight: 400
                }
            }
        },
        Tabs: {
            variants: {
                "soft-rounded": {
                    tablist: {
                        border: "1px solid ".concat(colors["default"].gray[300]),
                        padding: 1,
                        rounded: "full"
                    },
                    tab: {
                        padding: 3
                    }
                }
            }
        }
    }
};
/* harmony default export */ var src_theme = (theme);

;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/iframe.js
function isInsideIFrame() {
    return window.self !== window.top;
}
//# sourceMappingURL=iframe.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/errors.js
function AssertionError(message) {
    const error = new Error(message);
    error.name = 'AssertionError';
    return error;
}
function NotImplementedError(message) {
    const error = new Error(message);
    error.name = 'NotImplementedError';
    return error;
}
function InvalidEnvironmentError(message) {
    const error = new Error(message);
    error.name = 'InvalidEnvironmentError';
    return error;
}
function NotInitializedError(message) {
    const error = new Error(message);
    error.name = 'NotInitializedError';
    return error;
}
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/abstract/KSLCustomElement.js

// Custom elements API as well as all Web Component definitions can only be run in a browser environment,
// because they require build-in browser APIs, which are not available on the backend (during SSR).
// There are several libraries that allow server-side rendering of Web Components. It is usually done by
// redefining the whole DOM API on the backend. For the purpose of this SDK it is not required to
// support server-side rendering of Web Components, because whole page must be loaded for SDK to work properly.
// However, some SSR frameworks (such as Next.js) will try to run this code on the server side first during SSR,
// which could result in a crash because HTMLElement is not defined on the backend. That is why we are setting
// this property to null in a global Nodejs scope.
const isNotInBrowser = typeof window === 'undefined';
if (isNotInBrowser) {
    // eslint-disable-next-line
    // @ts-ignore: required to support SSR frameworks
    __webpack_require__.g['HTMLElement'] = null;
}
/**
 * This is a base class for all kontent-smart-link custom elements.
 */
let KSLCustomElement = /** @class */ (() => {
    class KSLCustomElement extends HTMLElement {
        constructor() {
            super();
            // We are using an "open" mode here, so that it is easier for users to manipulate the shadow root
            // of our custom elements if they want to change or customize something.
            const shadowRootConfig = { mode: 'open' };
            const selfClass = Object.getPrototypeOf(this).constructor;
            const shadowRoot = this.attachShadow(shadowRootConfig);
            shadowRoot.appendChild(selfClass.template.content.cloneNode(true));
        }
        /**
         * Name of the custom element that will be added to the CustomElementRegistry.
         * This name will be used to add a custom element to the page.
         *
         * @type {string}
         */
        static get is() {
            throw NotImplementedError('KSLCustomElement: "is" getter is not implemented for this custom element.');
        }
        /**
         * Template is usually stored in the scope of custom element file, but this does not work with SSR,
         * since `document` is not available on the backend. That is why we are storing the template in a static
         * constructor property and initialize it when we are sure we are in a browser environment.
         *
         * @type {HTMLTemplateElement}
         */
        static get template() {
            if (!this._template) {
                this._template = this.initializeTemplate();
            }
            return this._template;
        }
        /**
         * Add this custom element to the CustomElementRegistry so that it can be used on the page.
         * Usually customElements.define is called inline right at the bottom of the custom element file,
         * but this would not work with SSR, since custom elements can't be defined on the backend.
         */
        static define() {
            if (typeof window === 'undefined') {
                throw InvalidEnvironmentError('KSLCustomElement: custom elements can only be defined in a browser environment.');
            }
            if (!window.customElements) {
                throw InvalidEnvironmentError('KSLCustomElement: custom elements API is not available.');
            }
            // The 'this' keyword refers to current constructor in static methods.
            // Conversion to unknown is needed so that we can explicitly converse
            // this class to CustomElementConstructor.
            const self = this;
            if (!window.customElements.get(this.is)) {
                customElements.define(this.is, self);
                return customElements.whenDefined(this.is);
            }
            return Promise.resolve();
        }
        /**
         * Initialize a template for the custom element.
         * Each KSL custom element class should implement this static method.
         *
         * @returns {HTMLTemplateElement}
         */
        static initializeTemplate() {
            throw NotImplementedError('KSLCustomElement: "initializeTemplate" method should be implemented for every component.');
        }
        /**
         * Update attribute value on the custom element.
         *
         * @param {string} attributeName
         * @param {string | number | boolean | null} attributeValue
         */
        updateAttribute(attributeName, attributeValue) {
            if (attributeValue) {
                this.setAttribute(attributeName, attributeValue.toString());
            }
            else {
                this.removeAttribute(attributeName);
            }
        }
        /**
         * Dispatch an asynchronous event from component. Dispatching this event returns Promise
         * which resolves if event was successful and rejects if events is not successful.
         *
         * @param {string} eventType
         * @param {TEventData} eventData
         * @param {number | null} timeout
         * @protected
         */
        dispatchAsyncEvent(eventType, eventData, timeout = null) {
            return new Promise((resolve, reject) => {
                const timeoutId = timeout ? window.setTimeout(reject, timeout) : 0;
                const customEvent = new CustomEvent(eventType, {
                    detail: {
                        eventData: eventData,
                        onResolve: (data) => {
                            window.clearTimeout(timeoutId);
                            resolve(data);
                        },
                        onReject: (reason) => {
                            window.clearTimeout(timeoutId);
                            reject(reason);
                        },
                    },
                });
                this.dispatchEvent(customEvent);
            });
        }
    }
    KSLCustomElement._template = null;
    return KSLCustomElement;
})();

//# sourceMappingURL=KSLCustomElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/Logger.js
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Warn"] = 3] = "Warn";
    LogLevel[LogLevel["Error"] = 4] = "Error";
})(LogLevel || (LogLevel = {}));
let Logger = /** @class */ (() => {
    class Logger {
        static setLogLevel(level) {
            Logger.logLevel = level;
        }
        static error(...args) {
            if (Logger.logLevel <= LogLevel.Error) {
                console.error('[KSL][Error]: ', ...args);
            }
        }
        static warn(...args) {
            if (Logger.logLevel <= LogLevel.Warn) {
                console.warn('[KSL][Warning]: ', ...args);
            }
        }
        static info(...args) {
            if (Logger.logLevel <= LogLevel.Info) {
                console.info('[KSL][Info]: ', ...args);
            }
        }
        static debug(...args) {
            if (Logger.logLevel <= LogLevel.Debug) {
                console.log(...args);
            }
        }
        static debugGroupCollapsed(...args) {
            if (Logger.logLevel <= LogLevel.Debug) {
                console.groupCollapsed(...args);
            }
        }
        static debugGroup(...args) {
            if (Logger.logLevel <= LogLevel.Debug) {
                console.group(...args);
            }
        }
        static debugGroupEnd() {
            if (Logger.logLevel <= LogLevel.Debug) {
                console.groupEnd();
            }
        }
    }
    Logger.logLevel = LogLevel.Info;
    return Logger;
})();

//# sourceMappingURL=Logger.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/assert.js


function assert(condition, message) {
    if (!condition) {
        const error = AssertionError(message);
        Logger.error(error);
        throw error;
    }
}
//# sourceMappingURL=assert.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/node.js
function groupElementsByRenderingRoot(elements) {
    var _a;
    const results = new Map();
    for (const element of elements) {
        const root = getRenderingRootForElement(element);
        const prev = (_a = results.get(root)) !== null && _a !== void 0 ? _a : new Set();
        results.set(root, prev.add(element));
    }
    return results;
}
/**
 * Iterate through node ancestors and find an element which will be used as a parent for
 * the ksl-container. This element should either be positioned (position is anything except static) or should
 * have its content clipped. In case of table element (td, th, table) it should be positioned or it will be ignored
 * (even if its content is clipped).
 *
 * @param {HTMLElement} element
 * @returns {HTMLElement | null}
 */
function getRenderingRootForElement(element) {
    const parentElement = element.parentElement;
    if (parentElement instanceof HTMLElement) {
        const metadata = getRenderingRootMetadata(parentElement);
        // Table HTML element (td, th, table) can be an offset parent of some node, but unless it is positioned it will not be
        // used as a offset parent for the absolute positioned child (highlight). That is why we should ignore those elements and
        // do not use them as parents unless they are positioned. Otherwise, the highlighting might broke for the tables.
        const isNotTable = !['TD', 'TH', 'TABLE'].includes(parentElement.tagName);
        return metadata.isPositioned || (metadata.isContentClipped && isNotTable)
            ? parentElement
            : getRenderingRootForElement(parentElement);
    }
    return null;
}
function getRenderingRootMetadata(root) {
    const computedStyles = window.getComputedStyle(root);
    const position = computedStyles.getPropertyValue('position');
    const overflow = computedStyles.getPropertyValue('overflow');
    return {
        isPositioned: position !== 'static',
        isContentClipped: overflow.split(' ').some((value) => ['auto', 'scroll', 'clip', 'hidden'].includes(value)),
    };
}
/**
 * Iterate through node ancestors until HTMLElement.offsetParent is reached and sum scroll offsets.
 *
 * @param {HTMLElement | null} node
 * @returns {[number, number]}
 *  where the first number is a totalScrollTop, and the second number is a totalScrollLeft.
 */
function getTotalScrollOffset(node) {
    if (!node) {
        return [0, 0];
    }
    const offsetParent = node.offsetParent;
    // HTMLElement.offsetParent can be null when the node is <body> or <html>
    if (!offsetParent) {
        return [0, 0];
    }
    let scrollTop = 0;
    let scrollLeft = 0;
    let currentNode = node;
    while (currentNode.parentElement) {
        currentNode = currentNode.parentElement;
        if (offsetParent && offsetParent.isSameNode(currentNode)) {
            break;
        }
        scrollTop += currentNode.scrollTop;
        scrollLeft += currentNode.scrollLeft;
    }
    return [scrollTop, scrollLeft];
}
/**
 * Get all element ancestors.
 * @param {HTMLElement} element
 */
function getElementAncestors(element) {
    const ancestors = [];
    let parent = element.parentElement;
    while (parent !== null) {
        ancestors.push(parent);
        parent = parent.parentElement;
    }
    return ancestors;
}
function createTemplateForCustomElement(html) {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template;
}
//# sourceMappingURL=node.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLIconElement.js



var IconName;
(function (IconName) {
    IconName["CollapseScheme"] = "icon-collapse-scheme";
    IconName["Edit"] = "icon-edit";
    IconName["Plus"] = "icon-plus";
    IconName["PlusPuzzle"] = "icon-plus-puzzle";
    IconName["Puzzle"] = "icon-puzzle";
    IconName["Spinner"] = "icon-spinner";
})(IconName || (IconName = {}));
const iconsHTML = `
  <template id="${IconName.Edit}">
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1 14.993V10.0515L9.47121 1.58221C10.2522 0.801373 11.5183 0.801373 12.2993 1.58221L14.4132 3.69561C15.1945 4.47669 15.1945 5.74327 14.4132 6.52436L5.94263 14.993H1ZM5.52848 13.993L10.7581 8.7646L7.22982 5.23714L2 10.4658V13.993H5.52848ZM7.937 4.53012L11.4653 8.05757L13.7062 5.81717C14.0968 5.42663 14.0968 4.79334 13.7062 4.4028L11.5923 2.28939C11.2018 1.89898 10.5687 1.89898 10.1782 2.28939L7.937 4.53012Z"
      />
      <path
          d="M9.48975 13.9982C9.2136 13.9982 8.98975 14.2221 8.98975 14.4982C8.98975 14.7743 9.2136 14.9982 9.48975 14.9982H14.4865C14.7626 14.9982 14.9865 14.7743 14.9865 14.4982C14.9865 14.2221 14.7626 13.9982 14.4865 13.9982H9.48975Z"
      />
    </svg>
  </template>
  <template id="${IconName.Plus}">
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M7.75366 16.5C7.75366 17.1904 8.31331 17.75 9.00366 17.75C9.69402 17.75 10.2537 17.1904 10.2537 16.5V10.2861H16.5C17.1904 10.2861 17.75 9.72642 17.75 9.03606C17.75 8.34571 17.1904 7.78606 16.5 7.78606H10.2537V1.5C10.2537 0.809643 9.69402 0.25 9.00366 0.25C8.31331 0.25 7.75366 0.809644 7.75366 1.5V7.78606H1.5C0.809644 7.78606 0.25 8.34571 0.25 9.03606C0.25 9.72642 0.809644 10.2861 1.5 10.2861H7.75366V16.5Z"
      />
    </svg>
  </template>
  <template id="${IconName.Spinner}">
    <svg class="spin-500" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M1.25049 10.0001C1.25049 5.16797 5.16766 1.25069 9.99979 1.25061C10.345 1.2506 10.6248 1.53042 10.6248 1.8756C10.6248 2.22078 10.345 2.5006 9.99981 2.50061C5.85803 2.50068 2.50049 5.85831 2.50049 10.0001C2.50049 14.1418 5.85811 17.4995 9.99993 17.4995C14.1418 17.4995 17.4994 14.1418 17.4994 10.0001C17.4994 8.00692 16.7227 6.19654 15.4542 4.85289C15.2172 4.60189 15.2286 4.20633 15.4796 3.96937C15.7306 3.73241 16.1261 3.74379 16.3631 3.99479C17.8419 5.5612 18.7494 7.67533 18.7494 10.0001C18.7494 14.8322 14.8321 18.7495 9.99993 18.7495C5.16775 18.7495 1.25049 14.8322 1.25049 10.0001Z"
      />
    </svg>
  </template>
  <template id="${IconName.Puzzle}">
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.36522 2.48835C5.12409 2.7724 5.03429 3.10232 5.03429 3.27273V4.50861C5.03429 4.78476 4.81043 5.00861 4.53429 5.00861H2V14H4.0343V13.2727C4.0343 12.8522 4.21698 12.2958 4.60288 11.8412C5.00497 11.3675 5.63191 11 6.49745 11C7.36086 11 7.99972 11.3654 8.41593 11.8319C8.81555 12.2798 9.02461 12.8381 9.02461 13.2727V14.0072L11.0125 14.0014V11.4936C11.0125 11.2175 11.2363 10.9936 11.5125 10.9936H12.7273C12.8923 10.9936 13.2215 10.9016 13.5081 10.6537C13.7758 10.4221 14 10.0599 14 9.50642C14 8.95199 13.7748 8.58042 13.5038 8.34043C13.2141 8.08395 12.8857 7.98937 12.7273 7.98937H11.5125C11.2363 7.98937 11.0125 7.76551 11.0125 7.48937V5.00861H8.52459C8.24845 5.00861 8.02459 4.78476 8.02459 4.50861V3.27273C8.02459 3.11648 7.92916 2.7884 7.66975 2.49765C7.42692 2.2255 7.0522 2 6.49743 2C5.94479 2 5.59016 2.22337 5.36522 2.48835ZM4.60286 1.84119C5.00495 1.36753 5.6319 1 6.49743 1C7.36085 1 7.9997 1.36541 8.41592 1.83189C8.81554 2.27978 9.0246 2.83807 9.0246 3.27273V4.00861H11.5125C11.7886 4.00861 12.0125 4.23247 12.0125 4.50861V6.98937H12.7273C13.1597 6.98937 13.7177 7.19422 14.1667 7.59172C14.6343 8.00572 15 8.64268 15 9.50642C15 10.3712 14.6333 11.0025 14.1624 11.41C13.7103 11.8011 13.1531 11.9936 12.7273 11.9936H12.0125V14.5C12.0125 14.7756 11.7895 14.9992 11.5139 15L8.52605 15.0086C8.3932 15.009 8.26565 14.9565 8.17157 14.8627C8.07749 14.7689 8.02461 14.6415 8.02461 14.5086V13.2727C8.02461 13.1165 7.92918 12.7884 7.66976 12.4977C7.42694 12.2255 7.05222 12 6.49745 12C5.9448 12 5.59017 12.2234 5.36523 12.4884C5.12411 12.7724 5.0343 13.1023 5.0343 13.2727V14.5C5.0343 14.7761 4.81044 15 4.5343 15H1.5C1.22386 15 1 14.7761 1 14.5V4.50861C1 4.23247 1.22386 4.00861 1.5 4.00861H4.03429V3.27273C4.03429 2.85223 4.21696 2.29579 4.60286 1.84119Z"/>
    </svg>
  </template>
  <template id="${IconName.PlusPuzzle}">
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 8.97021C4.22386 8.97021 4 9.19407 4 9.47021C4 9.74636 4.22386 9.97021 4.5 9.97021H6.01123V11.5C6.01123 11.7761 6.23509 12 6.51123 12C6.78737 12 7.01123 11.7761 7.01123 11.5V9.97021H8.5C8.77614 9.97021 9 9.74636 9 9.47021C9 9.19407 8.77614 8.97021 8.5 8.97021H7.01123V7.5C7.01123 7.22386 6.78737 7 6.51123 7C6.23509 7 6.01123 7.22386 6.01123 7.5V8.97021H4.5Z" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49743 1C5.6319 1 5.00495 1.36753 4.60286 1.84119C4.21696 2.29579 4.03429 2.85223 4.03429 3.27273V4.00861H1.5C1.22386 4.00861 1 4.23247 1 4.50861V10.9545C1 12.5357 1.67001 13.5722 2.53739 14.1967C3.37928 14.8028 4.37453 15 5.04545 15H11.5125C11.7886 15 12.0125 14.7761 12.0125 14.5V11.9936H12.7273C13.1531 11.9936 13.7103 11.8011 14.1624 11.41C14.6333 11.0025 15 10.3712 15 9.50642C15 8.64268 14.6343 8.00572 14.1667 7.59172C13.7177 7.19422 13.1597 6.98937 12.7273 6.98937H12.0125V4.50861C12.0125 4.23247 11.7886 4.00861 11.5125 4.00861H9.0246V3.27273C9.0246 2.83807 8.81554 2.27978 8.41592 1.83189C7.9997 1.36541 7.36085 1 6.49743 1ZM5.03429 3.27273C5.03429 3.10232 5.12409 2.7724 5.36522 2.48835C5.59016 2.22337 5.94479 2 6.49743 2C7.0522 2 7.42692 2.2255 7.66975 2.49765C7.92916 2.7884 8.02459 3.11648 8.02459 3.27273V4.50861C8.02459 4.78476 8.24845 5.00861 8.52459 5.00861H11.0125V7.48937C11.0125 7.76551 11.2363 7.98937 11.5125 7.98937H12.7273C12.8857 7.98937 13.2141 8.08395 13.5038 8.34043C13.7748 8.58042 14 8.95199 14 9.50642C14 10.0599 13.7758 10.4221 13.5081 10.6537C13.2215 10.9016 12.8923 10.9936 12.7273 10.9936H11.5125C11.2363 10.9936 11.0125 11.2175 11.0125 11.4936V14H5.04545C4.53456 14 3.75708 13.8426 3.1217 13.3851C2.51181 12.946 2 12.2098 2 10.9545V5.00861H4.53429C4.81043 5.00861 5.03429 4.78476 5.03429 4.50861V3.27273Z" />
    </svg>
  </template>
  <template id="${IconName.CollapseScheme}">
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.9952 2.54249V4.99715H15.0024V6.99547H14.0027V6.00319H2.00561L2.00561 6.99547H1.00586L1.00586 6.00319H1.00244V2.54249C1.00244 1.69346 1.62932 1.00439 2.40172 1.00439H13.596C14.3684 1.00439 14.9952 1.69346 14.9952 2.54249ZM13.9955 5.00403H2.00561V4.99715H2.0022V2.54249C2.0022 2.15367 2.26888 2.00356 2.40172 2.00356H13.596C13.7288 2.00356 13.9955 2.15366 13.9955 2.54249V5.00403Z"
      />
      <path
          d="M1.00625 14.0052H3.00537L3.00498 15.0044H1.50732C1.37433 15.0044 1.24678 14.938 1.15273 14.8198C1.05869 14.7016 1.00586 14.5412 1.00586 14.3741L1.00625 14.0052Z"
      />
      <path
          d="M13.0029 13.9964H15.0021L15.0024 14.3653C15.0024 14.5325 14.9496 14.6928 14.8556 14.811C14.7615 14.9292 14.634 14.9956 14.501 14.9956H13.0033L13.0029 13.9964Z"
      />
      <path d="M1.00586 11.0039L1.00586 13.0022H2.00561L2.00561 11.0039H1.00586Z"/>
      <path d="M14.0027 13.0022V11.0039H15.0024V13.0022H14.0027Z"/>
      <path d="M1.00586 7.99464L1.00586 9.99296H2.00561L2.00561 7.99464H1.00586Z"/>
      <path d="M14.0027 7.99464V9.99296H15.0024V7.99464H14.0027Z"/>
      <path d="M6.00464 14.0052H4.00513L4.00513 15.0044H6.00464V14.0052Z"/>
      <path d="M7.00439 14.0052H9.00391V15.0044H7.00439V14.0052Z"/>
      <path d="M12.0032 14.0052H10.0037V15.0044H12.0032V14.0052Z"/>
    </svg>
  </template>
`;
const templateHTML = `
  <style>
    @-webkit-keyframes spin-500 {
      0% {
        -webkit-transform: rotate(0deg);
      }
  
      100% {
        -webkit-transform: rotate(359deg);
      }
    }
  
    @keyframes spin-500 {
      0% {
        transform: rotate(0deg);
      }
  
      100% {
        transform: rotate(359deg);
      }
    }
  
  
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: var(--ksl-icon-width, 0px);
      height: var(--ksl-icon-height, 0px);
    }
  
    .spin-500 {
      animation-direction: normal;
      animation-delay: 0s;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-name: spin-500;
      animation-timing-function: linear;
      transform-origin: center;
    }
  </style>
`;
let KSLIconElement = /** @class */ (() => {
    class KSLIconElement extends KSLCustomElement {
        constructor() {
            super();
            this.getTemplateByIconName = (iconName) => {
                if (!iconName) {
                    return null;
                }
                const template = KSLIconElement.icons.content.querySelector(`template#${iconName}`);
                if (template instanceof HTMLTemplateElement) {
                    return template;
                }
                else {
                    return null;
                }
            };
            this.updateIcon = (iconName) => {
                if (!this.shadowRoot) {
                    return;
                }
                const template = this.getTemplateByIconName(iconName);
                if (template) {
                    const content = template.content.cloneNode(true);
                    if (this.iconRef) {
                        this.shadowRoot.replaceChild(content, this.iconRef);
                    }
                    else {
                        this.shadowRoot.appendChild(content);
                    }
                    this.iconRef = this.shadowRoot.lastElementChild;
                }
                else if (this.iconRef) {
                    this.iconRef.remove();
                    this.iconRef = null;
                }
            };
            assert(this.shadowRoot, 'Shadow root must be always accessible in "open" mode.');
            const name = this.getAttribute('icon-name');
            const template = this.getTemplateByIconName(name);
            if (template) {
                const content = template.content.cloneNode(true);
                this.shadowRoot.appendChild(content);
                this.iconRef = this.shadowRoot.lastElementChild;
            }
            else {
                this.iconRef = null;
            }
        }
        static get is() {
            return 'ksl-icon';
        }
        static get icons() {
            if (!this._icons) {
                const template = document.createElement('template');
                template.innerHTML = iconsHTML;
                this._icons = template;
            }
            return this._icons;
        }
        static get observedAttributes() {
            return ['icon-name'];
        }
        get iconName() {
            return this.getAttribute('icon-name');
        }
        set iconName(value) {
            this.updateAttribute('icon-name', value);
        }
        static initializeTemplate() {
            return createTemplateForCustomElement(templateHTML);
        }
        attributeChangedCallback(attributeName, _oldValue, newValue) {
            if (attributeName === 'icon-name') {
                this.updateIcon(newValue);
            }
        }
    }
    KSLIconElement._icons = null;
    return KSLIconElement;
})();

//# sourceMappingURL=KSLIconElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/abstract/KSLPositionedElement.js

var ElementPositionOffset;
(function (ElementPositionOffset) {
    ElementPositionOffset["Bottom"] = "bottom";
    ElementPositionOffset["BottomEnd"] = "bottom-end";
    ElementPositionOffset["BottomStart"] = "bottom-start";
    ElementPositionOffset["Left"] = "left";
    ElementPositionOffset["LeftEnd"] = "left-end";
    ElementPositionOffset["LeftStart"] = "left-start";
    ElementPositionOffset["None"] = "";
    ElementPositionOffset["Right"] = "right";
    ElementPositionOffset["RightEnd"] = "right-end";
    ElementPositionOffset["RightStart"] = "right-start";
    ElementPositionOffset["Top"] = "top";
    ElementPositionOffset["TopEnd"] = "top-end";
    ElementPositionOffset["TopStart"] = "top-start";
})(ElementPositionOffset || (ElementPositionOffset = {}));
class KSLPositionedElement extends KSLCustomElement {
    constructor() {
        super(...arguments);
        this.targetRef = null;
    }
    get position() {
        return ElementPositionOffset.None;
    }
    connectedCallback() {
        if (!this.hasAttribute('tabindex')) {
            this.setAttribute('tabindex', '-1');
        }
    }
    disconnectedCallback() {
        this.targetRef = null;
    }
    attachTo(element) {
        this.targetRef = element;
    }
    calculateTopOffset(thisRect, targetRect) {
        switch (this.position) {
            case ElementPositionOffset.TopStart:
            case ElementPositionOffset.Top:
            case ElementPositionOffset.TopEnd:
                return -thisRect.height;
            case ElementPositionOffset.BottomStart:
            case ElementPositionOffset.Bottom:
            case ElementPositionOffset.BottomEnd:
                return targetRect.height;
            case ElementPositionOffset.Left:
            case ElementPositionOffset.Right:
                return (targetRect.height - thisRect.height) / 2;
            case ElementPositionOffset.LeftEnd:
            case ElementPositionOffset.RightEnd:
                return targetRect.height - thisRect.height;
            case ElementPositionOffset.LeftStart:
            case ElementPositionOffset.RightStart:
            case ElementPositionOffset.None:
            default:
                return 0;
        }
    }
    calculateLeftOffset(thisRect, targetRect) {
        switch (this.position) {
            case ElementPositionOffset.Top:
            case ElementPositionOffset.Bottom:
                return (targetRect.width - thisRect.width) / 2;
            case ElementPositionOffset.TopEnd:
            case ElementPositionOffset.BottomEnd:
                return targetRect.width - thisRect.width;
            case ElementPositionOffset.LeftStart:
            case ElementPositionOffset.Left:
            case ElementPositionOffset.LeftEnd:
                return -thisRect.width;
            case ElementPositionOffset.RightStart:
            case ElementPositionOffset.Right:
            case ElementPositionOffset.RightEnd:
                return targetRect.width;
            case ElementPositionOffset.TopStart:
            case ElementPositionOffset.BottomStart:
            case ElementPositionOffset.None:
            default:
                return 0;
        }
    }
}
//# sourceMappingURL=KSLPositionedElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/tokens/colors.js
var Colors;
(function (Colors) {
    Colors["BackgroundDefault"] = "rgba(255, 255, 255, 1)";
    Colors["BackgroundDefaultDisabled"] = "rgba(223, 223, 223, 1)";
    Colors["BackgroundDefaultHover"] = "rgba(21, 21, 21, 0.1)";
    Colors["BackgroundDefaultSelected"] = "rgba(255, 240, 239, 1)";
    Colors["BackgroundSecondary"] = "rgba(20, 22, 25, 1)";
    Colors["Primary"] = "rgba(219, 60, 0, 1)";
    Colors["PrimaryHover"] = "rgba(149, 48, 0, 1)";
    Colors["PrimaryTransparent"] = "rgba(219, 60, 0, 0.5)";
    Colors["TextDefault"] = "rgba(21, 21, 21, 1)";
    Colors["TextDefaultDisabled"] = "rgba(140, 140, 140, 1)";
    Colors["TextSecondary"] = "rgba(255, 255, 255, 1)";
})(Colors || (Colors = {}));
//# sourceMappingURL=colors.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/tokens/shadows.js
var Shadows;
(function (Shadows) {
    Shadows["Default"] = "0 8px 32px rgba(16, 33, 60, 0.24), 0 0 8px rgba(0, 0, 0, 0.03)";
    Shadows["Primary"] = "0 8px 10px rgba(219, 60, 0, 0.2), 0 6px 20px rgba(219, 60, 0, 0.12), 0 8px 14px rgba(219, 60, 0, 0.14)";
})(Shadows || (Shadows = {}));
//# sourceMappingURL=shadows.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/abstract/KSLPopUpElement.js




const KSLPopUpElement_templateHTML = `
  <style>
    :host {
      --arrow-size: var(--ksl-pop-up-arrow-size, 12px);
      --background-color: var(--ksl-pop-up-background-color, ${Colors.BackgroundDefault});
      --border-radius: var(--ksl-pop-up-border-radius, 4px);
      --box-shadow: var(--ksl-pop-up-box-shadow, ${Shadows.Default});
      --color: var(--ksl-pop-up-color, ${Colors.TextDefault});
      --padding: var(--ksl-pop-up-padding, 8px 8px);
      
      display: block;
      position: absolute;
      opacity: 0;
      z-index: 10000;
      transition: opacity 250ms ease-in-out;
    }
  
    :host([visible]) {
      opacity: 1;
    }
    
    :host(:focus) {
      outline: none;
    }
  
    .ksl-pop-up__content {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      box-shadow: var(--box-shadow);
      background-color: var(--background-color);
      padding: var(--padding);
      border-radius: var(--border-radius);
      font-size: 12px;
      line-height: 16px;
      font-weight: normal;
      color: var(--color);
    }
  
    :host([position="${ElementPositionOffset.RightStart}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.Right}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.RightEnd}"]) .ksl-pop-up__content {
      margin-left: var(--arrow-size);
    }
  
    :host([position="${ElementPositionOffset.LeftStart}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.Left}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.LeftEnd}"]) .ksl-pop-up__content {
      margin-right: var(--arrow-size);
    }
  
    :host([position="${ElementPositionOffset.BottomStart}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.Bottom}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.BottomEnd}"]) .ksl-pop-up__content {
      margin-top: var(--arrow-size);
    }
  
    :host([position="${ElementPositionOffset.TopStart}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.Top}"]) .ksl-pop-up__content,
    :host([position="${ElementPositionOffset.TopEnd}"]) .ksl-pop-up__content {
      margin-bottom: var(--arrow-size);
    }
  
    .ksl-pop-up__arrow {
      position: absolute;
      width: 0;
      height: 0;
      margin: 0 .25rem;
    }
  
    :host([position="${ElementPositionOffset.RightStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Right}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.RightEnd}"]) .ksl-pop-up__arrow {
      left: -(var(--arrow-size));
      border-right: var(--arrow-size) solid var(--background-color);
      border-top: var(--arrow-size) solid transparent;
      border-bottom: var(--arrow-size) solid transparent;
    }
  
    :host([position="${ElementPositionOffset.LeftStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Left}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.LeftEnd}"]) .ksl-pop-up__arrow {
      right: -(var(--arrow-size));
      border-top: var(--arrow-size) solid transparent;
      border-left: var(--arrow-size) solid var(--background-color);
      border-bottom: var(--arrow-size) solid transparent;
    }
  
    :host([position="${ElementPositionOffset.BottomStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Bottom}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.BottomEnd}"]) .ksl-pop-up__arrow {
      top: 0;
      border-left: var(--arrow-size) solid transparent;
      border-right: var(--arrow-size) solid transparent;
      border-bottom: var(--arrow-size) solid var(--background-color);
    }
  
    :host([position="${ElementPositionOffset.TopStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Top}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.TopEnd}"]) .ksl-pop-up__arrow {
      bottom: 0;
      border-top: var(--arrow-size) solid var(--background-color);
      border-left: var(--arrow-size) solid transparent;
      border-right: var(--arrow-size) solid transparent;
    }
  
    :host([position="${ElementPositionOffset.Top}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Bottom}"]) .ksl-pop-up__arrow {
      left: calc(50% - var(--arrow-size) - 0.25rem);
    }
  
    :host([position="${ElementPositionOffset.TopEnd}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.BottomEnd}"]) .ksl-pop-up__arrow {
      right: 0;
    }
  
    :host([position="${ElementPositionOffset.TopStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.BottomStart}"]) .ksl-pop-up__arrow {
      left: 0;
    }
  
    :host([position="${ElementPositionOffset.Left}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.Right}"]) .ksl-pop-up__arrow {
      top: 8px;
    }
  
    :host([position="${ElementPositionOffset.LeftEnd}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.RightEnd}"]) .ksl-pop-up__arrow {
      bottom: 0;
    }
  
    :host([position="${ElementPositionOffset.LeftStart}"]) .ksl-pop-up__arrow,
    :host([position="${ElementPositionOffset.RightStart}"]) .ksl-pop-up__arrow {
      top: 0;
    }
  </style>
  <div class="ksl-pop-up__content">
    <slot></slot>
  </div>
  <div class="ksl-pop-up__arrow"/>
`;
class KSLPopUpElement extends KSLPositionedElement {
    constructor() {
        super(...arguments);
        this.attachTo = (element) => {
            super.attachTo(element);
            this.adjustPosition();
        };
        this.adjustPosition = () => {
            if (!this.targetRef || !this.offsetParent) {
                return; // Can't position without target reference or when not mounted to DOM.
            }
            const thisRect = this.getBoundingClientRect();
            const targetRect = this.targetRef.getBoundingClientRect();
            const parentRect = this.offsetParent.getBoundingClientRect();
            const isOffsetToBody = this.offsetParent.isSameNode(document.body);
            const isOffsetToTarget = this.offsetParent.isSameNode(this.targetRef);
            const topOffset = this.calculateTopOffset(thisRect, targetRect);
            const leftOffset = this.calculateLeftOffset(thisRect, targetRect);
            let thisTop;
            let thisLeft;
            if (isOffsetToTarget) {
                thisTop = topOffset;
                thisLeft = leftOffset;
            }
            else {
                const [scrollOffsetTop, scrollOffsetLeft] = getTotalScrollOffset(this.parentElement);
                thisTop = targetRect.top + topOffset + (isOffsetToBody ? window.pageYOffset : scrollOffsetTop);
                thisLeft = targetRect.left + leftOffset + (isOffsetToBody ? window.pageXOffset : scrollOffsetLeft);
            }
            if (isOffsetToBody) {
                if (parentRect.top + thisTop + thisRect.height > window.innerHeight) {
                    this.style.bottom = parentRect.height + 'px';
                    this.style.top = 'auto';
                }
                else {
                    this.style.bottom = 'auto';
                    this.style.top = Math.max(-parentRect.top, thisTop) + 'px';
                }
                if (parentRect.left + thisLeft + thisRect.width > window.innerWidth) {
                    this.style.right = '0px';
                    this.style.left = 'auto';
                }
                else {
                    this.style.right = 'auto';
                    this.style.left = Math.max(-parentRect.left, thisLeft) + 'px';
                }
            }
            else {
                this.style.right = 'auto';
                this.style.left = `${thisLeft}px`;
                this.style.bottom = 'auto';
                this.style.top = `${thisTop}px`;
            }
        };
    }
    get position() {
        var _a;
        return (_a = this.getAttribute('position')) !== null && _a !== void 0 ? _a : ElementPositionOffset.Bottom;
    }
    set position(value) {
        this.updateAttribute('position', value);
    }
    get visible() {
        return this.hasAttribute('visible');
    }
    set visible(value) {
        this.updateAttribute('visible', value);
    }
    static initializeTemplate() {
        return createTemplateForCustomElement(KSLPopUpElement_templateHTML);
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('role')) {
            this.setAttribute('role', 'tooltip');
        }
        window.addEventListener('resize', this.adjustPosition, { capture: true });
        window.addEventListener('scroll', this.adjustPosition, { capture: true });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('resize', this.adjustPosition, { capture: true });
        window.removeEventListener('scroll', this.adjustPosition, { capture: true });
    }
}
//# sourceMappingURL=KSLPopUpElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLTooltipElement.js



const KSLTooltipElement_templateHTML = `
  <style>
    :host {
      --ksl-pop-up-arrow-size: 4px;
      --ksl-pop-up-background-color: var(--ksl-color-background-secondary, ${Colors.BackgroundSecondary});
      --ksl-pop-up-box-shadow: none;
      --ksl-pop-up-color: var(--ksl-color-text-secondary, ${Colors.TextSecondary});
      --ksl-pop-up-padding: 4px 6px;
    }
  </style>
`;
class KSLTooltipElement extends KSLPopUpElement {
    static get is() {
        return 'ksl-tooltip';
    }
    static initializeTemplate() {
        const baseTemplate = KSLPopUpElement.initializeTemplate();
        const thisTemplate = createTemplateForCustomElement(KSLTooltipElement_templateHTML);
        baseTemplate.content.appendChild(thisTemplate.content.cloneNode(true));
        return baseTemplate;
    }
}
//# sourceMappingURL=KSLTooltipElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/abstract/KSLCustomElementWithTooltip.js



class KSLCustomElementWithTooltip extends KSLCustomElement {
    constructor() {
        super(...arguments);
        this.tooltipRef = null;
        this.showTooltip = () => {
            if (this.tooltipRef) {
                this.hideTooltip();
            }
            if (!this.tooltipMessage || this.tooltipDisabled) {
                return;
            }
            const tooltip = document.createElement(KSLTooltipElement.is);
            tooltip.innerText = this.tooltipMessage;
            this.tooltipRef = document.body.appendChild(tooltip);
            this.tooltipRef.position = this.tooltipPosition;
            this.tooltipRef.attachTo(this);
            this.tooltipRef.visible = true;
        };
        this.hideTooltip = () => {
            if (this.tooltipRef) {
                this.tooltipRef.visible = false;
                this.tooltipRef.remove();
                this.tooltipRef = null;
            }
        };
    }
    static get observedAttributes() {
        return ['tooltip-disabled', 'tooltip-message'];
    }
    get tooltipDisabled() {
        return this.hasAttribute('tooltip-disabled');
    }
    set tooltipDisabled(value) {
        this.updateAttribute('tooltip-disabled', value);
    }
    get tooltipMessage() {
        return this.getAttribute('tooltip-message');
    }
    set tooltipMessage(value) {
        this.updateAttribute('tooltip-message', value);
    }
    get tooltipPosition() {
        return this.getAttribute('tooltip-position') || ElementPositionOffset.Bottom;
    }
    set tooltipPosition(value) {
        this.updateAttribute('tooltip-position', value);
    }
    connectedCallback() {
        this.addEventListener('focus', this.showTooltip);
        this.addEventListener('mouseenter', this.showTooltip);
        this.addEventListener('blur', this.hideTooltip);
        this.addEventListener('mouseleave', this.hideTooltip);
    }
    disconnectedCallback() {
        this.hideTooltip();
        this.removeEventListener('focus', this.showTooltip);
        this.removeEventListener('mouseenter', this.showTooltip);
        this.removeEventListener('blur', this.hideTooltip);
        this.removeEventListener('mouseleave', this.hideTooltip);
    }
    attributeChangedCallback(attributeName, _oldValue, newValue) {
        if (attributeName === 'tooltip-disabled') {
            if (newValue) {
                this.hideTooltip();
            }
        }
        else if (attributeName === 'tooltip-message') {
            if (!newValue) {
                this.hideTooltip();
            }
        }
    }
}
//# sourceMappingURL=KSLCustomElementWithTooltip.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLButtonElement.js






var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["Quinary"] = "quinary";
})(ButtonType || (ButtonType = {}));
const KSLButtonElement_templateHTML = `
  <style>
    :host,
    :host * {
      box-sizing: border-box;
    }
    
    :host {
      display: block;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    :host(:focus) {
      outline: none;
    }

    .ksl-button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: none;
      cursor: pointer;
    }
    
    .ksl-button:focus {
      outline: none;
    }
    
    :host([disabled]) .ksl-button {
      cursor: not-allowed;
    }
    
    .ksl-button__content,
    :host([loading]) .ksl-button__loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    
    .ksl-button__loader,
    :host([loading]) .ksl-button__content {
      display: none;
    }
    
    :host([type=${ButtonType.Primary}]) .ksl-button {
      --ksl-icon-width: 18px;
      --ksl-icon-height: 18px;
      min-width: 40px;
      max-width: 40px;
      min-height: 40px;
      max-height: 40px;
      border-radius: 5000px;
      box-shadow: var(--ksl-shadow-primary, ${Shadows.Primary});
      background-color: var(--ksl-color-primary, ${Colors.Primary});
      color: var(--ksl-color-text-secondary, ${Colors.TextSecondary});
      fill: var(--ksl-color-text-secondary, ${Colors.TextSecondary});
    }
    
    :host([type=${ButtonType.Primary}]:not([disabled])) .ksl-button:hover,
    :host([type=${ButtonType.Primary}]:not([disabled])) .ksl-button:active {
      background-color: var(--ksl-color-primary-hover, ${Colors.PrimaryHover});
    }
    
    :host([type=${ButtonType.Primary}][disabled]) .ksl-button {
      background-color: var(--ksl-color-background-default-disabled, ${Colors.BackgroundDefaultDisabled});
      color: var(--ksl-color-text-default-disabled, ${Colors.TextDefaultDisabled});
      fill: var(--ksl-color-text-default-disabled, ${Colors.TextDefaultDisabled});
      box-shadow: none;
    }
    
    :host([type=${ButtonType.Primary}][loading]) .ksl-button {
      color: var(--ksl-color-primary, ${Colors.Primary});
      fill: var(--ksl-color-primary, ${Colors.Primary});
      box-shadow: none;
    }
    
    :host([type=${ButtonType.Quinary}]) .ksl-button {
      --ksl-icon-width: 16px;
      --ksl-icon-height: 16px;
      border-radius: 5px;
      padding: 0;
      min-height: 24px;
      min-width: 24px;
      max-height: 24px;
      max-width: 24px;
      color: var(--ksl-color-text-default, ${Colors.TextDefault});
      fill: var(--ksl-color-text-default, ${Colors.TextDefault});
      background-color: var(--ksl-color-background-default, ${Colors.BackgroundDefault});
    }
    
    :host([type=${ButtonType.Quinary}][disabled]) .ksl-button {
      color: var(--ksl-color-text-default-disabled, ${Colors.TextDefaultDisabled});
      fill: var(--ksl-color-text-default-disabled, ${Colors.TextDefaultDisabled});
    }
    
    :host([type=${ButtonType.Quinary}]:not([disabled])) .ksl-button:hover {
      background-color: var(--ksl-color-background-default-hover, ${Colors.BackgroundDefaultHover});
    }
    
    :host([type=${ButtonType.Quinary}]:not([disabled])) .ksl-button:active {
      background-color: var(--ksl-color-background-default-selected, ${Colors.BackgroundDefaultSelected});
    }
  </style>
  <button class="ksl-button">
    <div class="ksl-button__content">
      <slot></slot>
    </div>
    <ksl-icon icon-name="${IconName.Spinner}" class="ksl-button__loader" />
  </button>
`;
class KSLButtonElement extends KSLCustomElementWithTooltip {
    constructor() {
        super();
        this.handleClick = (event) => {
            // make sure the disabled button does not trigger events
            if (this.disabled) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        };
        assert(this.shadowRoot, 'Shadow root must be always accessible in "open" mode.');
        this.buttonRef = this.shadowRoot.querySelector('button');
    }
    static get is() {
        return 'ksl-button';
    }
    static get observedAttributes() {
        const base = KSLCustomElementWithTooltip.observedAttributes;
        return [...base, 'loading'];
    }
    get loading() {
        return this.hasAttribute('loading');
    }
    set loading(value) {
        this.updateAttribute('loading', value);
    }
    get disabled() {
        return this.hasAttribute('disabled');
    }
    set disabled(value) {
        this.updateAttribute('disabled', value);
    }
    static initializeTemplate() {
        return createTemplateForCustomElement(KSLButtonElement_templateHTML);
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this.handleClick, { capture: true });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.handleClick, { capture: true });
    }
    attributeChangedCallback(attributeName, _oldValue, newValue) {
        super.attributeChangedCallback(attributeName, _oldValue, newValue);
        if (attributeName === 'loading') {
            const value = Boolean(newValue);
            this.disabled = value;
            this.tooltipDisabled = value;
        }
    }
}
//# sourceMappingURL=KSLButtonElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLPopoverElement.js




const KSLPopoverElement_templateHTML = `
  <style>
    :host {
      --ksl-pop-up-arrow-size: 12px;
      --ksl-pop-up-background-color: var(--ksl-color-background-default, ${Colors.BackgroundDefault});
      --ksl-pop-up-border-radius: 4px;
      --ksl-pop-up-box-shadow: var(--ksl-shadow-default, ${Shadows.Default});;
      --ksl-pop-up-color: var(--ksl-color-text-default, ${Colors.TextDefault});
      --ksl-pop-up-padding: 8px;
    }
  </style>
`;
class KSLPopoverElement extends KSLPopUpElement {
    static get is() {
        return 'ksl-popover';
    }
    static initializeTemplate() {
        const baseTemplate = KSLPopUpElement.initializeTemplate();
        const thisTemplate = createTemplateForCustomElement(KSLPopoverElement_templateHTML);
        baseTemplate.content.appendChild(thisTemplate.content.cloneNode(true));
        return baseTemplate;
    }
}
//# sourceMappingURL=KSLPopoverElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/IFrameCommunicatorTypes.js
var InsertPositionPlacement;
(function (InsertPositionPlacement) {
    InsertPositionPlacement["After"] = "after";
    InsertPositionPlacement["Before"] = "before";
    InsertPositionPlacement["End"] = "end";
    InsertPositionPlacement["Start"] = "start";
})(InsertPositionPlacement || (InsertPositionPlacement = {}));
var AddButtonAction;
(function (AddButtonAction) {
    AddButtonAction["CreateComponent"] = "CreateComponent";
    AddButtonAction["CreateLinkedItem"] = "CreateLinkedItem";
    AddButtonAction["InsertLinkedItem"] = "InsertLinkedItem";
})(AddButtonAction || (AddButtonAction = {}));
var AddButtonElementType;
(function (AddButtonElementType) {
    AddButtonElementType["LinkedItems"] = "LinkedItems";
    AddButtonElementType["RichText"] = "RichText";
    AddButtonElementType["Unknown"] = "Unknown";
})(AddButtonElementType || (AddButtonElementType = {}));
var AddButtonPermission;
(function (AddButtonPermission) {
    AddButtonPermission["CreateNew"] = "createNew";
    AddButtonPermission["Edit"] = "edit";
    AddButtonPermission["ViewParent"] = "viewParent";
})(AddButtonPermission || (AddButtonPermission = {}));
var AddButtonPermissionCheckResult;
(function (AddButtonPermissionCheckResult) {
    AddButtonPermissionCheckResult["ItemNotTranslated"] = "ItemNotTranslated";
    AddButtonPermissionCheckResult["Ok"] = "Ok";
    AddButtonPermissionCheckResult["PermissionMissing"] = "PermissionMissing";
    AddButtonPermissionCheckResult["RteWithForbiddenComponents"] = "RteWithForbiddenComponents";
    AddButtonPermissionCheckResult["Unknown"] = "Unknown";
})(AddButtonPermissionCheckResult || (AddButtonPermissionCheckResult = {}));
var IFrameMessageType;
(function (IFrameMessageType) {
    IFrameMessageType["ElementClicked"] = "kontent-smart-link:element:clicked";
    IFrameMessageType["ContentItemClicked"] = "kontent-smart-link:content-item:clicked";
    IFrameMessageType["ContentComponentClicked"] = "kontent-smart-link:content-component:clicked";
    IFrameMessageType["Initialized"] = "kontent-smart-link:initialized";
    IFrameMessageType["Status"] = "kontent-smart-link:status";
    IFrameMessageType["AddInitial"] = "kontent-smart-link:add:initial";
    IFrameMessageType["AddAction"] = "kontent-smart-link:add:action";
})(IFrameMessageType || (IFrameMessageType = {}));
var IFrameResponseType;
(function (IFrameResponseType) {
    IFrameResponseType["AddInitialResponse"] = "kontent-smart-link:add:initial:response";
})(IFrameResponseType || (IFrameResponseType = {}));
//# sourceMappingURL=IFrameCommunicatorTypes.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/dataAttributes.js




/**
 * Data-attributes are used to get some Kontent related data from DOM.
 * Data from data-attributes is used to generate smart links or iframe messages to Kontent.
 * However, this data can also be used in rendering (e.g. HTML elements with element codename attribute
 * have highlights).
 */
var DataAttribute;
(function (DataAttribute) {
    DataAttribute["AddButtonInsertPosition"] = "data-kontent-add-button-insert-position";
    DataAttribute["ElementCodename"] = "data-kontent-element-codename";
    DataAttribute["ComponentId"] = "data-kontent-component-id";
    DataAttribute["ItemId"] = "data-kontent-item-id";
    DataAttribute["LanguageCodename"] = "data-kontent-language-codename";
    DataAttribute["ProjectId"] = "data-kontent-project-id";
})(DataAttribute || (DataAttribute = {}));
/**
 * Metadata-attributes are used to get some metadata about some of the SDK features.
 * Metadata is used for SDK inner logic (such as rendering, event handling, etc.).
 */
var MetadataAttribute;
(function (MetadataAttribute) {
    MetadataAttribute["AddButton"] = "data-kontent-add-button";
    MetadataAttribute["AddButtonRenderPosition"] = "data-kontent-add-button-render-position";
    MetadataAttribute["DisableFeatures"] = "data-kontent-disable-features";
})(MetadataAttribute || (MetadataAttribute = {}));
/**
 * Valid values of the MetadataAttribute.DisableFeatures attribute.
 * Those values can be used to disable certain features for the selected node.
 */
var DisableableFeature;
(function (DisableableFeature) {
    DisableableFeature["Highlight"] = "highlight";
})(DisableableFeature || (DisableableFeature = {}));
var ParserTokenKey;
(function (ParserTokenKey) {
    ParserTokenKey["ProjectId"] = "projectId";
    ParserTokenKey["LanguageCodename"] = "languageCodename";
    ParserTokenKey["ItemId"] = "itemId";
    ParserTokenKey["ComponentId"] = "contentComponentId";
    ParserTokenKey["ElementCodename"] = "elementCodename";
    ParserTokenKey["Placement"] = "placement";
    ParserTokenKey["TargetId"] = "targetId";
})(ParserTokenKey || (ParserTokenKey = {}));
const baseParserPattern = [
    { key: ParserTokenKey.LanguageCodename, dataAttributes: [DataAttribute.LanguageCodename] },
    { key: ParserTokenKey.ProjectId, dataAttributes: [DataAttribute.ProjectId] },
];
const itemEditButtonParserPattern = [
    { key: ParserTokenKey.ItemId, dataAttributes: [DataAttribute.ItemId] },
    ...baseParserPattern,
];
const componentEditButtonParserPattern = [
    { key: ParserTokenKey.ComponentId, dataAttributes: [DataAttribute.ComponentId] },
    ...itemEditButtonParserPattern,
];
const elementEditButtonParserPattern = [
    { key: ParserTokenKey.ElementCodename, dataAttributes: [DataAttribute.ElementCodename] },
    { key: ParserTokenKey.ComponentId, dataAttributes: [DataAttribute.ComponentId], optional: true },
    ...itemEditButtonParserPattern,
];
const baseAddButtonParserPattern = [
    { key: ParserTokenKey.ElementCodename, dataAttributes: [DataAttribute.ElementCodename] },
    { key: ParserTokenKey.ComponentId, dataAttributes: [DataAttribute.ComponentId], optional: true },
    { key: ParserTokenKey.ItemId, dataAttributes: [DataAttribute.ItemId] },
    ...baseParserPattern,
];
const relativeAddButtonParserPattern = [
    { key: ParserTokenKey.Placement, dataAttributes: [DataAttribute.AddButtonInsertPosition], optional: true },
    { key: ParserTokenKey.TargetId, dataAttributes: [DataAttribute.ComponentId, DataAttribute.ItemId] },
    ...baseAddButtonParserPattern,
];
const fixedAddButtonParserPattern = [
    { key: ParserTokenKey.Placement, dataAttributes: [DataAttribute.AddButtonInsertPosition], optional: true },
    ...baseAddButtonParserPattern,
];
function parseEditButtonDataAttributes(target) {
    const type = getHighlightTypeForElement(target);
    const pattern = getEditButtonDataAttributesPattern(type);
    const parsed = parseDataAttributes(pattern, target);
    return Object.assign(Object.assign({ projectId: parsed.get(ParserTokenKey.ProjectId), languageCodename: parsed.get(ParserTokenKey.LanguageCodename), itemId: parsed.get(ParserTokenKey.ItemId) }, (parsed.has(ParserTokenKey.ComponentId) && { contentComponentId: parsed.get(ParserTokenKey.ComponentId) })), (parsed.has(ParserTokenKey.ElementCodename) && { elementCodename: parsed.get(ParserTokenKey.ElementCodename) }));
}
function parseAddButtonDataAttributes(target) {
    const position = target.getAttribute(DataAttribute.AddButtonInsertPosition);
    const pattern = getAddButtonDataAttributesPattern(position);
    const parsed = parseDataAttributes(pattern, target);
    return Object.assign(Object.assign({ projectId: parsed.get(ParserTokenKey.ProjectId), languageCodename: parsed.get(ParserTokenKey.LanguageCodename), itemId: parsed.get(ParserTokenKey.ItemId) }, (parsed.get(ParserTokenKey.ComponentId) && { contentComponentId: parsed.get(ParserTokenKey.ComponentId) })), { elementCodename: parsed.get(ParserTokenKey.ElementCodename), insertPosition: getAddButtonInsertPosition(parsed) });
}
function getEditButtonDataAttributesPattern(type) {
    switch (type) {
        case HighlightType.Element:
            return elementEditButtonParserPattern;
        case HighlightType.ContentComponent:
            return componentEditButtonParserPattern;
        case HighlightType.ContentItem:
            return itemEditButtonParserPattern;
        default:
            return baseParserPattern;
    }
}
function getAddButtonDataAttributesPattern(position) {
    switch (position) {
        case InsertPositionPlacement.End:
        case InsertPositionPlacement.Start:
            return fixedAddButtonParserPattern;
        case InsertPositionPlacement.After:
        case InsertPositionPlacement.Before:
        default:
            return relativeAddButtonParserPattern;
    }
}
function getAddButtonInsertPosition(parsed) {
    var _a;
    const placement = (_a = parsed.get(ParserTokenKey.Placement)) !== null && _a !== void 0 ? _a : InsertPositionPlacement.After;
    const targetId = parsed.get(ParserTokenKey.TargetId);
    switch (placement) {
        case InsertPositionPlacement.End:
        case InsertPositionPlacement.Start:
            return { placement };
        case InsertPositionPlacement.Before:
        case InsertPositionPlacement.After:
            return { placement, targetId };
        default:
            return { targetId, placement: InsertPositionPlacement.After };
    }
}
/**
 * Parse data-attributes starting from target to its ancestors using the parsing pattern.
 *
 * @param {DataAttributesParserPattern} pattern
 * @param {HTMLElement} startFrom
 * @returns {ReadonlyMap<ParserTokenKey, string>}
 */
function parseDataAttributes(pattern, startFrom) {
    const parsed = new Map();
    Logger.debugGroup('Parse data-attributes starting with ', startFrom);
    const elements = [startFrom, ...getElementAncestors(startFrom)];
    Logger.debug('Elements that will be parsed: ', elements);
    Logger.debug('Parsing pattern: ', pattern);
    for (const element of elements) {
        const takenDataAttributes = new Set();
        Logger.debugGroup('Checking data-attributes on ', element);
        for (const token of pattern) {
            const { key, dataAttributes, optional } = token;
            Logger.debugGroupCollapsed(`Looking for '${key}' [${dataAttributes}]`);
            const [dataAttribute, value] = findDataAttribute(element, dataAttributes);
            Logger.debug('Value: ', value);
            Logger.debug('Already parsed: ', parsed.has(key));
            Logger.debug('Already taken by previous token: ', takenDataAttributes.has(dataAttribute));
            if (!value && !parsed.has(key) && !optional) {
                Logger.debug('[Result]: Required data-attribute is missing.');
                Logger.debugGroupEnd();
                // Required data-attribute is missing. There is no point in continuing parsing data-attributes
                // on current element, we should move to the next ancestor.
                break;
            }
            if (parsed.has(key)) {
                Logger.debug('[Result]: This data-attribute has already been parsed in some of the previous steps.');
                Logger.debugGroupEnd();
                continue;
            }
            if (!value) {
                Logger.debug('[Result]: This data attribute has no value.');
                Logger.debugGroupEnd();
                continue;
            }
            if (takenDataAttributes.has(dataAttribute)) {
                Logger.debug('[Result]: A previous token has already used this data-attribute.');
                Logger.debugGroupEnd();
                continue;
            }
            const currentTokenIndex = pattern.indexOf(token);
            const tokensWithHigherPriority = pattern.slice(currentTokenIndex, pattern.length);
            const areSomeTokensWithHigherPriorityParsed = tokensWithHigherPriority.some((token) => parsed.has(token.key));
            // If some higher token has already been parsed, it can mean two things:
            // a) Current data-attribute is optional and is not related to the current scope. In that case, it can be ignored.
            // b) Parsed data is related to some lower scope (or invalid) and should be cleared.
            if (areSomeTokensWithHigherPriorityParsed) {
                if (optional) {
                    Logger.debug('[Result]: Attribute is not related to the current scope.');
                    Logger.debugGroupEnd();
                    continue;
                }
                for (const token of tokensWithHigherPriority) {
                    parsed.delete(token.key);
                }
            }
            parsed.set(token.key, value);
            takenDataAttributes.add(dataAttribute);
            Logger.debug('[Result]: Attribute successfully parsed!');
            Logger.debugGroupEnd();
        }
        Logger.debug('Values parsed so far: ', parsed);
        Logger.debugGroupEnd();
    }
    Logger.debugGroupEnd();
    Logger.debug('[Result]: ', parsed);
    return parsed;
}
function findDataAttribute(element, dataAttributes) {
    for (const attribute of dataAttributes) {
        const value = element.getAttribute(attribute);
        if (value) {
            return [attribute, value];
        }
    }
    return [null, null];
}
//# sourceMappingURL=dataAttributes.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/ConfigurationManager.js

const defaultConfiguration = {
    debug: false,
    defaultDataAttributes: {
        languageCodename: undefined,
        projectId: undefined,
    },
    forceWebSpotlightMode: false,
    isInsideWebSpotlight: false,
    queryParam: 'ksl-enabled',
};
class ConfigurationManager {
    constructor() {
        this.update = (configuration = {}) => {
            this.configuration = Object.assign(Object.assign({}, this.configuration), configuration);
        };
        this.configuration = defaultConfiguration;
    }
    get debug() {
        return this.configuration.debug;
    }
    get queryParam() {
        return this.configuration.queryParam;
    }
    get defaultLanguageCodename() {
        return this.configuration.defaultDataAttributes.languageCodename;
    }
    get defaultProjectId() {
        return this.configuration.defaultDataAttributes.projectId;
    }
    get isInsideWebSpotlightPreviewIFrame() {
        const { forceWebSpotlightMode, isInsideWebSpotlight } = this.configuration;
        return forceWebSpotlightMode || (isInsideIFrame() && isInsideWebSpotlight);
    }
    static getInstance() {
        if (!ConfigurationManager.instance) {
            ConfigurationManager.instance = new ConfigurationManager();
        }
        return ConfigurationManager.instance;
    }
}
//# sourceMappingURL=ConfigurationManager.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/customElements.js


var HighlightType;
(function (HighlightType) {
    HighlightType["None"] = "";
    HighlightType["Element"] = "element";
    HighlightType["ContentComponent"] = "content-component";
    HighlightType["ContentItem"] = "content-item";
})(HighlightType || (HighlightType = {}));
const DisabledHighlightFeatureSelector = `[${MetadataAttribute.DisableFeatures}*="${DisableableFeature.Highlight}"]`;
const ElementSelector = `*[${DataAttribute.ElementCodename}]:not(${DisabledHighlightFeatureSelector})`;
const ContentComponentSelector = `*[${DataAttribute.ComponentId}]:not([${DataAttribute.ElementCodename}]):not(${DisabledHighlightFeatureSelector})`;
const ContentItemSelector = `*[${DataAttribute.ItemId}]:not([${DataAttribute.ComponentId}]):not([${DataAttribute.ElementCodename}]):not(${DisabledHighlightFeatureSelector})`;
const ElementsWithAddButtonSelector = `*[${MetadataAttribute.AddButton}]`;
const AllAugmentableElementsSelector = `${ElementSelector}, ${ContentComponentSelector}, ${ContentItemSelector}, ${ElementsWithAddButtonSelector}`;
/**
 * Find all descendant HTML elements that could be augmented (have highlights or add buttons near them).
 *
 * @param {HTMLElement | Document} node
 * @returns {NodeListOf<HTMLElement>}
 */
function getAugmentableDescendants(node) {
    const configurationManager = ConfigurationManager.getInstance();
    const isInsideWebSpotlight = configurationManager.isInsideWebSpotlightPreviewIFrame;
    if (isInsideWebSpotlight) {
        return node.querySelectorAll(AllAugmentableElementsSelector);
    }
    return node.querySelectorAll(ElementSelector);
}
/**
 * Checks if HTML element could be augmented (have highlights or add buttons near them).
 *
 * @param {HTMLElement | null} element
 * @returns {boolean}
 */
function isElementAugmentable(element) {
    return shouldElementHaveHighlight(element) || shouldElementHaveAddButton(element);
}
/**
 * Check if node should have highlights based on its data-attributes.
 *
 * @param {HTMLElement | null} element
 * @returns {boolean}
 */
function shouldElementHaveHighlight(element) {
    const highlightType = getHighlightTypeForElement(element);
    switch (highlightType) {
        case HighlightType.None:
            return false;
        case HighlightType.Element:
            return true;
        case HighlightType.ContentItem:
        case HighlightType.ContentComponent:
        default: {
            const configurationManager = ConfigurationManager.getInstance();
            return configurationManager.isInsideWebSpotlightPreviewIFrame;
        }
    }
}
/**
 * Check if node should have a add button based on its data-attributes.
 *
 * @param {HTMLElement | null} element
 * @returns {boolean}
 */
function shouldElementHaveAddButton(element) {
    const configurationManager = ConfigurationManager.getInstance();
    const isInsideWebSpotlight = configurationManager.isInsideWebSpotlightPreviewIFrame;
    // add button should only be visible inside Web Spotlight
    return Boolean(isInsideWebSpotlight && element && element.hasAttribute(MetadataAttribute.AddButton));
}
/**
 * Get HighlightType based on the HTML element data-attributes.
 *
 * @param {HTMLElement | null} element
 * @returns {HighlightType}
 */
function getHighlightTypeForElement(element) {
    if (!element || isFeatureDisabledForElement(element, DisableableFeature.Highlight)) {
        return HighlightType.None;
    }
    // treat node as element if it has element codename attribute
    if (element.hasAttribute(DataAttribute.ElementCodename)) {
        return HighlightType.Element;
    }
    // else treat node as content component if it has component id attribute
    else if (element.hasAttribute(DataAttribute.ComponentId)) {
        return HighlightType.ContentComponent;
    }
    // else treat node as content item if it has item id attribute
    else if (element.hasAttribute(DataAttribute.ItemId)) {
        return HighlightType.ContentItem;
    }
    return HighlightType.None;
}
function isFeatureDisabledForElement(element, feature) {
    var _a;
    const attribute = element.getAttribute(MetadataAttribute.DisableFeatures);
    return (_a = attribute === null || attribute === void 0 ? void 0 : attribute.toLowerCase().includes(feature)) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=customElements.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLHighlightElement.js











const KSLHighlightElement_templateHTML = `
  <style>
    :host,
    :host * {
      box-sizing: border-box;
    }
    
    :host {
      display: block;
      position: absolute;
      pointer-events: none;
      touch-action: none;
      min-height: 40px;
      min-width: 40px;
      width: 100%;
      height: 100%;
      border: 2px dashed;
      border-color: var(--ksl-color-primary-transparent, ${Colors.PrimaryTransparent});
      border-radius: 5px;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    :host(:hover),
    :host([selected]) {
      border-color: var(--ksl-color-primary, ${Colors.Primary});
      z-index: 20;
    }
    
    :host(:focus) {
      outline: none;
    }
    
    .ksl-highlight__toolbar {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      pointer-events: all;
      touch-action: auto;
      min-height: 40px;
      max-height: 40px;
      border-radius: 8px;
      background-color: var(--ksl-color-background-default, ${Colors.BackgroundDefault});
      z-index: 10;
      padding: 8px;
      box-shadow: var(--ksl-shadow-default, ${Shadows.Default});
    }
    
    .ksl-highlight__toolbar:hover {
      z-index: 20;
    }
    
    .ksl-highlight__toolbar-button + .ksl-highlight__toolbar-button {
      margin-left: 4px;
    }
  </style>
  <div id="ksl-toolbar" class="ksl-highlight__toolbar">
    <ksl-button 
      id="ksl-edit" 
      class="ksl-highlight__toolbar-button"
      type="${ButtonType.Quinary}"
      tooltip-position="${ElementPositionOffset.BottomEnd}"
    >
      <ksl-icon icon-name="${IconName.Edit}" />
    </ksl-button>
  </div>
`;
class KSLHighlightElement extends KSLPositionedElement {
    constructor() {
        super();
        this.attachTo = (node) => {
            this.unregisterTargetNodeListeners();
            super.attachTo(node);
            const type = this.type;
            this.hidden = type === HighlightType.None;
            this.editButtonRef.tooltipMessage = KSLHighlightElement.getEditButtonTooltip(type);
            if (this.targetRef) {
                this.targetRef.addEventListener('mousemove', this.handleTargetNodeMouseEnter);
                this.targetRef.addEventListener('mouseleave', this.handleTargetNodeMouseLeave);
                this.targetRef.addEventListener('click', this.handleEditButtonClick);
            }
        };
        this.adjustPosition = () => {
            if (!this.targetRef || !this.offsetParent) {
                return;
            }
            if (!(this.offsetParent instanceof KSLContainerElement)) {
                Logger.warn('KSLHighlightElement: should be located inside KSLContainerElement to be positioned properly.');
            }
            const offsetParentRect = this.offsetParent.getBoundingClientRect();
            const targetRect = this.targetRef.getBoundingClientRect();
            this.style.top = `${targetRect.top - offsetParentRect.top}px`;
            this.style.left = `${targetRect.left - offsetParentRect.left}px`;
            this.style.width = `${targetRect.width}px`;
            this.style.height = `${targetRect.height}px`;
        };
        this.unregisterTargetNodeListeners = () => {
            if (this.targetRef) {
                this.targetRef.removeEventListener('mousemove', this.handleTargetNodeMouseEnter);
                this.targetRef.removeEventListener('mouseleave', this.handleTargetNodeMouseLeave);
                this.targetRef.removeEventListener('click', this.handleEditButtonClick);
            }
        };
        this.handleTargetNodeMouseEnter = () => {
            this.selected = true;
        };
        this.handleTargetNodeMouseLeave = () => {
            this.selected = false;
        };
        this.handleEditButtonClick = (event) => {
            assert(this.targetRef, 'Target node is not set for this highlight.');
            event.preventDefault();
            event.stopPropagation();
            const dataAttributes = parseEditButtonDataAttributes(this.targetRef);
            this.dispatchEditEvent(dataAttributes);
        };
        this.dispatchEditEvent = (data) => {
            assert(this.targetRef, 'Target node is not set for this highlight element.');
            const customEvent = new CustomEvent('ksl:highlight:edit', {
                detail: {
                    data,
                    targetNode: this.targetRef,
                },
            });
            this.dispatchEvent(customEvent);
        };
        assert(this.shadowRoot, 'Shadow root must be always accessible in "open" mode.');
        this.editButtonRef = this.shadowRoot.querySelector('#ksl-edit');
    }
    static get is() {
        return 'ksl-highlight';
    }
    get type() {
        return getHighlightTypeForElement(this.targetRef);
    }
    get selected() {
        return this.hasAttribute('selected');
    }
    set selected(value) {
        this.updateAttribute('selected', value);
    }
    static initializeTemplate() {
        return createTemplateForCustomElement(KSLHighlightElement_templateHTML);
    }
    static getEditButtonTooltip(type) {
        switch (type) {
            case HighlightType.Element:
                return 'Edit element';
            case HighlightType.ContentComponent:
                return 'Edit component';
            case HighlightType.ContentItem:
                return 'Edit item';
            default:
                return 'Edit';
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this.editButtonRef.addEventListener('click', this.handleEditButtonClick);
    }
    disconnectedCallback() {
        super.connectedCallback();
        this.editButtonRef.removeEventListener('click', this.handleEditButtonClick);
        this.unregisterTargetNodeListeners();
    }
}
//# sourceMappingURL=KSLHighlightElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLContainerElement.js




const KSLContainerElement_templateHTML = `
  <style>
    :host {
      display: block;
      position: absolute;
      box-sizing: border-box;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      pointer-events: none;
      touch-action: none;
    }
    
    :host([clipped]) {
      overflow: hidden;
    }
  </style>
  <slot></slot>
`;
class KSLContainerElement extends KSLCustomElement {
    constructor() {
        super(...arguments);
        this._boundingClientRect = null;
        this.createHighlightForElement = (element) => {
            const highlight = document.createElement(KSLHighlightElement.is);
            highlight.attachTo(element);
            this.appendChild(highlight);
            return highlight;
        };
        this.createAddButtonForElement = (element) => {
            const button = document.createElement(KSLAddButtonElement.is);
            button.attachTo(element);
            this.appendChild(button);
            return button;
        };
        this.adjustPosition = () => {
            const parent = this.parentElement;
            if (!parent) {
                return; // No need to adjust position when element is not mounted.
            }
            const metadata = getRenderingRootMetadata(parent);
            if (!metadata.isPositioned) {
                // When parent element is not positioned it means that container
                // will be positioned relatively to some other element. That is why we need
                // to keep in mind all of the scroll offsets on the way to this relative element.
                const [scrollOffsetTop, scrollOffsetLeft] = getTotalScrollOffset(parent);
                this.style.height = `${parent.clientHeight}px`;
                this.style.width = `${parent.clientWidth}px`;
                this.style.top = `${parent.offsetTop - scrollOffsetTop}px`;
                this.style.left = `${parent.offsetLeft - scrollOffsetLeft}px`;
                // When parent element is not positioned and its content is clipped
                // we need to hide overflow of the container as well to prevent
                // highlights from appearing for overflown content.
                this.updateAttribute('clipped', Boolean(metadata.isContentClipped));
            }
            this.getBoundingClientRect(true);
        };
    }
    static get is() {
        return 'ksl-container';
    }
    static initializeTemplate() {
        return createTemplateForCustomElement(KSLContainerElement_templateHTML);
    }
    getBoundingClientRect(shouldRecompute = false) {
        if (!this._boundingClientRect || shouldRecompute) {
            this._boundingClientRect = super.getBoundingClientRect();
        }
        return this._boundingClientRect;
    }
}
//# sourceMappingURL=KSLContainerElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/KSLAddButtonElement.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const ContentIsPublishedTooltip = 'Content is published';
const DefaultTooltipMessage = 'Insert...';
const getCreateLinkedItemTooltip = (canUserCreateLinkedItem) => canUserCreateLinkedItem ? 'Create new item' : 'Your role cannot create items from the allowed types';
var PopoverButtonId;
(function (PopoverButtonId) {
    PopoverButtonId["CreateComponent"] = "create-component";
    PopoverButtonId["CreateLinkedItem"] = "create-linked-item";
    PopoverButtonId["InsertLinkedItem"] = "insert-linked-item";
})(PopoverButtonId || (PopoverButtonId = {}));
const getPopoverHtml = ({ elementType, isParentPublished, permissions }) => {
    const canUserCreateLinkedItem = permissions.get(AddButtonPermission.CreateNew) === AddButtonPermissionCheckResult.Ok;
    return `
    <style>
    .ksl-add-button__popover-button + .ksl-add-button__popover-button {
      margin-left: 4px;
    }
  </style>
  <ksl-button
    id="${PopoverButtonId.InsertLinkedItem}"
    class="ksl-add-button__popover-button"
    type="${ButtonType.Quinary}"
    tooltip-position="${ElementPositionOffset.Top}"
    tooltip-message="${isParentPublished ? ContentIsPublishedTooltip : 'Insert existing item'}"
    ${isParentPublished && 'disabled'}
  >
    <ksl-icon icon-name="${IconName.Puzzle}"/>
  </ksl-button>
  <ksl-button
    id="${PopoverButtonId.CreateLinkedItem}"
    class="ksl-add-button__popover-button"
    type="${ButtonType.Quinary}"
    tooltip-position="${ElementPositionOffset.Top}"
    tooltip-message="${isParentPublished ? ContentIsPublishedTooltip : getCreateLinkedItemTooltip(canUserCreateLinkedItem)}"
    ${(isParentPublished || !canUserCreateLinkedItem) && 'disabled'}
    ${elementType !== AddButtonElementType.LinkedItems && 'hidden'}
  >
    <ksl-icon icon-name="${IconName.PlusPuzzle}"/>
  </ksl-button>
  <ksl-button
    id="${PopoverButtonId.CreateComponent}"
    class="ksl-add-button__popover-button"
    type="${ButtonType.Quinary}"
    tooltip-position="${ElementPositionOffset.Top}"
    tooltip-message="${isParentPublished ? ContentIsPublishedTooltip : 'Insert new component'}"
    ${isParentPublished && 'disabled'}
    ${elementType !== AddButtonElementType.RichText && 'hidden'}
  >
    <ksl-icon icon-name="${IconName.CollapseScheme}"/>
  </ksl-button>
`;
};
const KSLAddButtonElement_templateHTML = `
  <style>
    :host {
      display: inline-block;
      position: absolute;
      z-index: 9999;
      pointer-events: all;
      touch-action: initial;
    }
    
    :host(:focus) {
      outline: none;
    }
  </style>
  <ksl-button
      type="${ButtonType.Primary}"
      tooltip-position="${ElementPositionOffset.Top}"
  >
    <ksl-icon icon-name="${IconName.Plus}"/>
  </ksl-button>
`;
class KSLAddButtonElement extends KSLPositionedElement {
    constructor() {
        super();
        this.popoverRef = null;
        this.adjustPosition = () => {
            if (!this.targetRef || !this.offsetParent) {
                return;
            }
            if (!(this.offsetParent instanceof KSLContainerElement)) {
                console.warn('KSLAddButtonElement: should be located inside KSLContainerElement to be positioned properly.');
            }
            const offsetParentRect = this.offsetParent.getBoundingClientRect();
            const targetRect = this.targetRef.getBoundingClientRect();
            const thisRect = this.getBoundingClientRect();
            const verticalOffset = this.calculateTopOffset(thisRect, targetRect);
            const horizontalOffset = this.calculateLeftOffset(thisRect, targetRect);
            this.style.top = `${targetRect.top - offsetParentRect.top + verticalOffset}px`;
            this.style.left = `${targetRect.left - offsetParentRect.left + horizontalOffset}px`;
        };
        this.handleClick = (event) => __awaiter(this, void 0, void 0, function* () {
            if (this.popoverRef) {
                return;
            }
            assert(this.targetRef, 'Target node is not set for this add button.');
            event.preventDefault();
            event.stopPropagation();
            this.buttonRef.loading = true;
            const data = parseAddButtonDataAttributes(this.targetRef);
            try {
                const eventData = { data, targetNode: this.targetRef };
                const response = yield this.dispatchAsyncEvent('ksl:add-button:initial', eventData);
                const { permissions } = response;
                const isUserMissingPermissions = !permissions ||
                    permissions.get(AddButtonPermission.ViewParent) !== AddButtonPermissionCheckResult.Ok ||
                    permissions.get(AddButtonPermission.Edit) !== AddButtonPermissionCheckResult.Ok;
                const areComponentsForbidden = permissions.get(AddButtonPermission.CreateNew) === AddButtonPermissionCheckResult.RteWithForbiddenComponents;
                if (isUserMissingPermissions || areComponentsForbidden) {
                    this.buttonRef.loading = false;
                    this.buttonRef.disabled = true;
                    this.buttonRef.tooltipMessage = isUserMissingPermissions
                        ? 'You are not allowed to add content here'
                        : "Components and items can't be added here";
                }
                else {
                    this.buttonRef.loading = false;
                    this.buttonRef.disabled = false;
                    this.buttonRef.tooltipMessage = DefaultTooltipMessage;
                    this.showPopover(response);
                }
            }
            catch (reason) {
                Logger.error(reason);
                this.buttonRef.loading = false;
                this.buttonRef.disabled = true;
                if (reason && typeof reason.message === 'string') {
                    this.buttonRef.tooltipMessage = reason.message;
                }
                else {
                    this.buttonRef.tooltipMessage = 'Something went wrong';
                }
            }
        });
        this.handleClickOutside = (event) => {
            if (!this.popoverRef || !(event.target instanceof Element)) {
                return;
            }
            const clickedInside = this.isSameNode(event.target) || this.contains(event.target);
            if (!clickedInside) {
                this.hidePopover();
            }
        };
        this.showPopover = (response) => {
            assert(this.shadowRoot, 'Shadow root must be available in "open" mode.');
            if (this.popoverRef) {
                this.hidePopover();
            }
            this.buttonRef.tooltipPosition = ElementPositionOffset.Bottom;
            const popover = document.createElement(KSLPopoverElement.is);
            popover.innerHTML = getPopoverHtml(response);
            const popoverParent = this.shadowRoot;
            this.popoverRef = popoverParent.appendChild(popover);
            this.popoverRef.position = ElementPositionOffset.Top;
            this.popoverRef.attachTo(this);
            this.addPopoverEventListeners(response.elementType);
            this.popoverRef.visible = true;
            this.popoverRef.adjustPosition();
        };
        this.hidePopover = () => {
            this.buttonRef.tooltipPosition = ElementPositionOffset.Top;
            if (this.popoverRef) {
                this.removePopoverEventListeners();
                this.popoverRef.visible = false;
                this.popoverRef.remove();
                this.popoverRef = null;
            }
        };
        this.addPopoverEventListeners = (elementType) => {
            if (!this.popoverRef) {
                return;
            }
            const createComponentButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.CreateComponent}`);
            const createLinkedItemButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.CreateLinkedItem}`);
            const insertLinkedItemButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.InsertLinkedItem}`);
            if (createComponentButtonRef && elementType === AddButtonElementType.RichText) {
                createComponentButtonRef.addEventListener('click', this.handleCreateComponentClick);
            }
            if (createLinkedItemButtonRef && elementType === AddButtonElementType.LinkedItems) {
                createLinkedItemButtonRef.addEventListener('click', this.handleCreateLinkedItemClick);
            }
            if (insertLinkedItemButtonRef) {
                insertLinkedItemButtonRef.addEventListener('click', this.handleInsertLinkedItemClick);
            }
        };
        this.removePopoverEventListeners = () => {
            if (!this.popoverRef) {
                return;
            }
            const createComponentButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.CreateComponent}`);
            const createLinkedItemButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.CreateLinkedItem}`);
            const insertLinkedItemButtonRef = this.popoverRef.querySelector(`#${PopoverButtonId.InsertLinkedItem}`);
            if (createComponentButtonRef) {
                createComponentButtonRef.removeEventListener('click', this.handleCreateComponentClick);
            }
            if (createLinkedItemButtonRef) {
                createLinkedItemButtonRef.removeEventListener('click', this.handleCreateLinkedItemClick);
            }
            if (insertLinkedItemButtonRef) {
                insertLinkedItemButtonRef.removeEventListener('click', this.handleInsertLinkedItemClick);
            }
        };
        this.handleCreateComponentClick = (event) => {
            this.handleAddActionClick(event, AddButtonAction.CreateComponent);
        };
        this.handleCreateLinkedItemClick = (event) => {
            this.handleAddActionClick(event, AddButtonAction.CreateLinkedItem);
        };
        this.handleInsertLinkedItemClick = (event) => {
            this.handleAddActionClick(event, AddButtonAction.InsertLinkedItem);
        };
        this.handleAddActionClick = (event, action) => {
            assert(this.targetRef, 'Target node is not set for this add button.');
            event.preventDefault();
            event.stopPropagation();
            const data = parseAddButtonDataAttributes(this.targetRef);
            const customEvent = new CustomEvent('ksl:add-button:action', {
                detail: {
                    data: Object.assign(Object.assign({}, data), { action }),
                    targetNode: this.targetRef,
                },
            });
            this.hidePopover();
            this.dispatchEvent(customEvent);
        };
        assert(this.shadowRoot, 'Shadow root must be available in "open" mode.');
        this.buttonRef = this.shadowRoot.querySelector(KSLButtonElement.is);
    }
    static get is() {
        return 'ksl-add-button';
    }
    get position() {
        var _a, _b;
        return (_b = (_a = this.targetRef) === null || _a === void 0 ? void 0 : _a.getAttribute(MetadataAttribute.AddButtonRenderPosition)) !== null && _b !== void 0 ? _b : ElementPositionOffset.Bottom;
    }
    static initializeTemplate() {
        return createTemplateForCustomElement(KSLAddButtonElement_templateHTML);
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('click', this.handleClickOutside, { capture: true });
        this.buttonRef.addEventListener('click', this.handleClick);
        this.buttonRef.tooltipMessage = DefaultTooltipMessage;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('click', this.handleClickOutside, { capture: true });
        this.buttonRef.removeEventListener('click', this.handleClick);
        this.hidePopover();
    }
    calculateTopOffset(thisRect, targetRect) {
        const offset = super.calculateTopOffset(thisRect, targetRect);
        switch (this.position) {
            case ElementPositionOffset.TopStart:
            case ElementPositionOffset.Top:
            case ElementPositionOffset.TopEnd:
                return offset / 2;
            case ElementPositionOffset.BottomStart:
            case ElementPositionOffset.Bottom:
            case ElementPositionOffset.BottomEnd:
                return offset - thisRect.height / 2;
            default:
                return offset;
        }
    }
    calculateLeftOffset(thisRect, targetRect) {
        const offset = super.calculateLeftOffset(thisRect, targetRect);
        switch (this.position) {
            case ElementPositionOffset.LeftStart:
            case ElementPositionOffset.Left:
            case ElementPositionOffset.LeftEnd:
                return offset / 2;
            case ElementPositionOffset.RightStart:
            case ElementPositionOffset.Right:
            case ElementPositionOffset.RightEnd:
                return targetRect.width - thisRect.width / 2;
            default:
                return offset;
        }
    }
}
//# sourceMappingURL=KSLAddButtonElement.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/web-components/components.js







const webComponents = [
    KSLIconElement,
    KSLButtonElement,
    KSLAddButtonElement,
    KSLHighlightElement,
    KSLContainerElement,
    KSLTooltipElement,
    KSLPopoverElement,
];
const webComponentTags = webComponents.map((component) => component.is);
/**
 * Define all web components if it is possible.
 *
 * @returns {Promise<void[]>}
 */
function defineAllRequiredWebComponents() {
    const allDefined = webComponents.map((webComponent) => webComponent.define());
    return Promise.all(allDefined);
}
/**
 * Check if element is a web component based on its tag name.
 *
 * @param {HTMLElement} element
 * @returns {boolean}
 */
function isElementWebComponent(element) {
    return webComponentTags.includes(element.tagName.toLowerCase());
}
//# sourceMappingURL=components.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/SmartLinkRenderer.js



class SmartLinkRenderer {
    constructor() {
        this.render = (visibleElements, observedElements) => {
            var _a, _b;
            if (observedElements.size === 0) {
                this.clear();
            }
            else {
                const newAddButtonByElement = new Map();
                const newHighlightByElement = new Map();
                // Group elements by their rendering roots to avoid unnecessary re-calculations (e.g. reposition container only once
                // instead of repositioning it for every child, calculating bounding client rects, etc.).
                const elementsByRenderingRoot = groupElementsByRenderingRoot(visibleElements);
                for (const [root, elements] of elementsByRenderingRoot.entries()) {
                    const container = this.createContainerIfNotExist(root);
                    container.adjustPosition();
                    for (const element of elements) {
                        // This check is needed to prevent highlight rendering for the "flat" elements (height or/and width === 0),
                        // because those elements are basically invisible and cannot be clicked.
                        const isFlat = element.offsetHeight === 0 || element.offsetHeight === 0;
                        if (!isFlat && shouldElementHaveHighlight(element)) {
                            const highlight = (_a = this.highlightByElement.get(element)) !== null && _a !== void 0 ? _a : container.createHighlightForElement(element);
                            highlight.adjustPosition();
                            // We are creating a new highlight by element map to be able to compare it with an old one to find out
                            // which elements have been removed before renders and remove their highlights from the DOM.
                            newHighlightByElement.set(element, highlight);
                            this.highlightByElement.delete(element);
                        }
                        if (shouldElementHaveAddButton(element)) {
                            const button = (_b = this.addButtonByElement.get(element)) !== null && _b !== void 0 ? _b : container.createAddButtonForElement(element);
                            button.adjustPosition();
                            // We are creating a new add button by element map to be able to compare it with an old one to find out
                            // which elements have been removed before renders and remove their add buttons from the DOM.
                            newAddButtonByElement.set(element, button);
                            this.addButtonByElement.delete(element);
                        }
                    }
                }
                // All highlights that are left in the old highlightByElement map are the remnants of the old render.
                // We check if they are still observed and relevant for the renderer and if not they can be removed.
                for (const [element, highlight] of this.highlightByElement.entries()) {
                    if (!observedElements.has(element)) {
                        highlight.remove();
                        this.highlightByElement.delete(element);
                    }
                    else {
                        newHighlightByElement.set(element, highlight);
                    }
                }
                // All add buttons that are left in the old addButtonByElement map are the remnants of the old render.
                // We check if they are still observed and relevant for the renderer and if not they can be removed.
                for (const [element, addButton] of this.addButtonByElement.entries()) {
                    if (!observedElements.has(element)) {
                        addButton.remove();
                        this.addButtonByElement.delete(element);
                    }
                    else {
                        newAddButtonByElement.set(element, addButton);
                    }
                }
                // All containers that have no children can be removed because they are not used by any highlight, or a add button.
                for (const [parent, container] of this.containerByRenderingRoot.entries()) {
                    if (container.children.length === 0) {
                        container.remove();
                        this.containerByRenderingRoot.delete(parent);
                    }
                }
                this.highlightByElement = newHighlightByElement;
                this.addButtonByElement = newAddButtonByElement;
            }
        };
        this.destroy = () => {
            this.clear();
            this.defaultContainer.remove();
        };
        this.clear = () => {
            for (const [element, addButton] of this.addButtonByElement.entries()) {
                addButton.remove();
                this.addButtonByElement.delete(element);
            }
            for (const [element, highlight] of this.highlightByElement.entries()) {
                highlight.remove();
                this.highlightByElement.delete(element);
            }
            for (const [root, container] of this.containerByRenderingRoot.entries()) {
                container.remove();
                this.containerByRenderingRoot.delete(root);
            }
            this.highlightByElement = new Map();
            this.containerByRenderingRoot = new Map();
            this.addButtonByElement = new Map();
            this.defaultContainer.innerHTML = '';
        };
        this.createContainerIfNotExist = (root) => {
            // if root is not specified or root is body
            if (!root || root === document.body) {
                return this.defaultContainer;
            }
            let container = this.containerByRenderingRoot.get(root);
            if (container) {
                return container;
            }
            container = document.createElement(KSLContainerElement.is);
            root.appendChild(container);
            this.containerByRenderingRoot.set(root, container);
            return container;
        };
        this.containerByRenderingRoot = new Map();
        this.highlightByElement = new Map();
        this.addButtonByElement = new Map();
        this.defaultContainer = SmartLinkRenderer.createAndMountDefaultContainer();
    }
    static createAndMountDefaultContainer() {
        const container = document.createElement(KSLContainerElement.is);
        window.document.body.appendChild(container);
        return container;
    }
}
//# sourceMappingURL=SmartLinkRenderer.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/validation.js

function logErrors(errors) {
    errors.forEach((error) => {
        Logger.error(error);
    });
}
function validateContentItemClickEditMessageData(data) {
    const errors = [];
    if (!data.projectId) {
        errors.push('Project ID is required to handle element click.');
    }
    if (!data.languageCodename) {
        errors.push('Language codename is required to handle element click.');
    }
    if (!data.itemId) {
        errors.push('Item ID is required to handle element click.');
    }
    logErrors(errors);
    return errors.length === 0;
}
function validateElementClickMessageData(data) {
    if (!data.elementCodename) {
        Logger.error('Element codename is required to handle element click.');
        return false;
    }
    return validateContentItemClickEditMessageData(data);
}
function validateContentComponentClickMessageData(data) {
    if (!data.contentComponentId) {
        Logger.error('Content component ID is required to handle element click.');
        return false;
    }
    return validateContentItemClickEditMessageData(data);
}
function validateAddInitialMessageData(data) {
    const errors = [];
    if (!data.projectId) {
        errors.push('Project ID is required to handle add button click.');
    }
    if (!data.languageCodename) {
        errors.push('Language codename is required to handle add button click.');
    }
    if (!data.itemId) {
        errors.push('Item ID is required to handle add button click.');
    }
    if (!data.elementCodename) {
        errors.push('Element codename is required to handle add button click.');
    }
    if (!data.insertPosition) {
        errors.push('Insert position (placement, targetId) is required to handle add button click.');
    }
    logErrors(errors);
    return errors.length === 0;
}
function validateAddActionMessageData(data) {
    if (!data.action) {
        Logger.error('Action is required to handle add button click.');
        return false;
    }
    return validateAddInitialMessageData(data);
}
//# sourceMappingURL=validation.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/link.js
function buildItemLink(projectId, languageCodename, itemId) {
    return `https://app.kontent.ai/goto/edit-item/project/${projectId}/variant-codename/${languageCodename}/item/${itemId}`;
}
function buildElementLink(projectId, languageCodename, itemId, elementCodename) {
    return `${buildItemLink(projectId, languageCodename, itemId)}/element/${elementCodename}`;
}
function buildComponentElementLink(projectId, languageCodename, itemId, contentComponentId, componentElementCodename) {
    return `${buildItemLink(projectId, languageCodename, itemId)}/component/${contentComponentId}/element/${componentElementCodename}`;
}
function buildKontentLink(data) {
    if (data.contentComponentId) {
        return buildComponentElementLink(data.projectId, data.languageCodename, data.itemId, data.contentComponentId, data.elementCodename);
    }
    else {
        return buildElementLink(data.projectId, data.languageCodename, data.itemId, data.elementCodename);
    }
}
//# sourceMappingURL=link.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/NodeSmartLinkProvider.js








class NodeSmartLinkProvider {
    constructor(iframeCommunicator) {
        this.iframeCommunicator = iframeCommunicator;
        this.enabled = false;
        this.renderingTimeoutId = 0;
        this.observedElements = new Set();
        this.visibleElements = new Set();
        this.toggle = (force) => {
            const shouldEnable = typeof force !== 'undefined' ? force : !this.enabled;
            if (shouldEnable) {
                this.enable();
            }
            else {
                this.disable();
            }
        };
        this.enable = () => {
            if (this.enabled)
                return;
            this.startRenderingInterval();
            this.listenToGlobalEvents();
            this.observeDomMutations();
            this.enabled = true;
        };
        this.disable = () => {
            if (!this.enabled)
                return;
            this.stopRenderingInterval();
            this.unlistenToGlobalEvents();
            this.disconnectObservers();
            this.renderer.clear();
            this.enabled = false;
        };
        this.destroy = () => {
            this.disable();
            this.renderer.destroy();
        };
        this.augmentVisibleElements = () => {
            requestAnimationFrame(() => {
                this.renderer.render(this.visibleElements, this.observedElements);
            });
        };
        /**
         * Start an interval rendering (1s) that will re-render highlights for all visible elements using `setTimeout`.
         * It helps to adjust highlights position even in situations that are currently not supported by
         * the SDK (e.g. element position change w/o animations, some infinite animations and other possible unhandled cases)
         * for better user experience.
         */
        this.startRenderingInterval = () => {
            this.augmentVisibleElements();
            this.renderingTimeoutId = window.setTimeout(this.startRenderingInterval, 1000);
        };
        this.stopRenderingInterval = () => {
            if (this.renderingTimeoutId) {
                clearTimeout(this.renderingTimeoutId);
                this.renderingTimeoutId = 0;
            }
        };
        this.listenToGlobalEvents = () => {
            window.addEventListener('scroll', this.augmentVisibleElements, { capture: true });
            window.addEventListener('resize', this.augmentVisibleElements, { passive: true });
            window.addEventListener('animationend', this.augmentVisibleElements, { passive: true, capture: true });
            window.addEventListener('transitionend', this.augmentVisibleElements, { passive: true, capture: true });
            window.addEventListener('ksl:add-button:initial', this.onAddInitialClick, { capture: true });
            window.addEventListener('ksl:add-button:action', this.onAddActionClick, { capture: true });
            window.addEventListener('ksl:highlight:edit', this.onEditElement, { capture: true });
        };
        this.unlistenToGlobalEvents = () => {
            window.removeEventListener('scroll', this.augmentVisibleElements, { capture: true });
            window.removeEventListener('resize', this.augmentVisibleElements);
            window.removeEventListener('animationend', this.augmentVisibleElements, { capture: true });
            window.removeEventListener('transitionend', this.augmentVisibleElements, { capture: true });
            window.removeEventListener('ksl:add-button:initial', this.onAddInitialClick, { capture: true });
            window.removeEventListener('ksl:add-button:action', this.onAddActionClick, { capture: true });
            window.removeEventListener('ksl:highlight:edit', this.onEditElement, { capture: true });
        };
        this.observeDomMutations = () => {
            if (this.enabled)
                return;
            this.mutationObserver.observe(window.document.body, {
                childList: true,
                subtree: true,
            });
            getAugmentableDescendants(document).forEach((element) => {
                if (element instanceof HTMLElement) {
                    this.observeElementVisibility(element);
                }
            });
        };
        this.disconnectObservers = () => {
            this.mutationObserver.disconnect();
            this.intersectionObserver.disconnect();
            this.observedElements.forEach((element) => {
                this.unobserveElementVisibility(element);
            });
            this.observedElements = new Set();
            this.visibleElements = new Set();
        };
        this.observeElementVisibility = (element) => {
            if (this.observedElements.has(element))
                return;
            this.intersectionObserver.observe(element);
            this.observedElements.add(element);
        };
        this.unobserveElementVisibility = (element) => {
            if (!this.observedElements.has(element))
                return;
            this.intersectionObserver.unobserve(element);
            this.observedElements.delete(element);
            this.visibleElements.delete(element);
        };
        this.onDomMutation = (mutations) => {
            const relevantMutations = mutations.filter((mutation) => {
                const isTypeRelevant = mutation.type === 'childList';
                const isTargetRelevant = mutation.target instanceof HTMLElement && !isElementWebComponent(mutation.target);
                if (!isTypeRelevant || !isTargetRelevant) {
                    return false;
                }
                const hasRelevantAddedNodes = Array.from(mutation.addedNodes).some((node) => node instanceof HTMLElement && !isElementWebComponent(node));
                const hasRelevantRemovedNodes = Array.from(mutation.removedNodes).some((node) => node instanceof HTMLElement && !isElementWebComponent(node));
                return hasRelevantAddedNodes || hasRelevantRemovedNodes;
            });
            for (const mutation of relevantMutations) {
                for (const node of mutation.addedNodes) {
                    if (!(node instanceof HTMLElement))
                        continue;
                    if (isElementAugmentable(node)) {
                        this.observeElementVisibility(node);
                    }
                    for (const element of getAugmentableDescendants(node)) {
                        if (!(element instanceof HTMLElement))
                            continue;
                        this.observeElementVisibility(element);
                    }
                }
                for (const node of mutation.removedNodes) {
                    if (!(node instanceof HTMLElement))
                        continue;
                    if (isElementAugmentable(node)) {
                        this.unobserveElementVisibility(node);
                    }
                    for (const element of getAugmentableDescendants(node)) {
                        if (!(element instanceof HTMLElement))
                            continue;
                        this.unobserveElementVisibility(element);
                    }
                }
            }
            if (relevantMutations.length > 0) {
                this.augmentVisibleElements();
            }
        };
        this.onElementVisibilityChange = (entries) => {
            const filteredEntries = entries.filter((entry) => entry.target instanceof HTMLElement);
            for (const entry of filteredEntries) {
                const target = entry.target;
                if (entry.isIntersecting) {
                    this.visibleElements.add(target);
                }
                else {
                    this.visibleElements.delete(target);
                }
            }
            if (filteredEntries.length > 0) {
                this.augmentVisibleElements();
            }
        };
        this.onEditElement = (event) => {
            var _a, _b;
            const isInsideWebSpotlight = this.configurationManager.isInsideWebSpotlightPreviewIFrame;
            const { data, targetNode } = event.detail;
            const messageData = Object.assign(Object.assign({}, data), { projectId: (_a = data.projectId) !== null && _a !== void 0 ? _a : this.configurationManager.defaultProjectId, languageCodename: (_b = data.languageCodename) !== null && _b !== void 0 ? _b : this.configurationManager.defaultLanguageCodename });
            const messageMetadata = {
                elementRect: targetNode.getBoundingClientRect(),
            };
            if ('elementCodename' in messageData && messageData.elementCodename) {
                if (validateElementClickMessageData(messageData)) {
                    if (isInsideWebSpotlight) {
                        this.iframeCommunicator.sendMessage(IFrameMessageType.ElementClicked, messageData, messageMetadata);
                    }
                    else {
                        const link = buildKontentLink(messageData);
                        window.open(link, '_blank');
                    }
                }
            }
            else if ('contentComponentId' in messageData && messageData.contentComponentId) {
                if (validateContentComponentClickMessageData(messageData)) {
                    if (isInsideWebSpotlight) {
                        this.iframeCommunicator.sendMessage(IFrameMessageType.ContentComponentClicked, messageData, messageMetadata);
                    }
                    else {
                        Logger.warn('Edit buttons for content components are only functional inside Web Spotlight.');
                    }
                }
            }
            else if ('itemId' in messageData && messageData.itemId) {
                if (validateContentItemClickEditMessageData(messageData)) {
                    if (isInsideWebSpotlight) {
                        this.iframeCommunicator.sendMessage(IFrameMessageType.ContentItemClicked, messageData, messageMetadata);
                    }
                    else {
                        Logger.warn('Add buttons for content items are only functional inside Web Spotlight.');
                    }
                }
            }
            else {
                Logger.warn('Some required attributes are not found or the edit button for this type of element is not yet supported.');
            }
        };
        this.onAddInitialClick = (event) => {
            var _a, _b;
            const isInsideWebSpotlight = this.configurationManager.isInsideWebSpotlightPreviewIFrame;
            const { eventData, onResolve, onReject } = event.detail;
            const { data, targetNode } = eventData;
            const messageData = Object.assign(Object.assign({}, data), { languageCodename: (_a = data.languageCodename) !== null && _a !== void 0 ? _a : this.configurationManager.defaultLanguageCodename, projectId: (_b = data.projectId) !== null && _b !== void 0 ? _b : this.configurationManager.defaultProjectId });
            if (validateAddInitialMessageData(messageData)) {
                if (isInsideWebSpotlight) {
                    const messageMetadata = {
                        elementRect: targetNode.getBoundingClientRect(),
                    };
                    this.iframeCommunicator.sendMessageWithResponse(IFrameMessageType.AddInitial, messageData, (response) => {
                        if (!response || response.elementType === AddButtonElementType.Unknown) {
                            return onReject({ message: 'Something went wrong' });
                        }
                        return onResolve(response);
                    }, messageMetadata);
                }
                else {
                    Logger.warn('Add buttons are only functional inside Web Spotlight.');
                    onReject({ message: 'Add buttons are only functional inside Web Spotlight' });
                }
            }
            else {
                onReject({ message: 'Required data attributes are missing' });
            }
        };
        this.onAddActionClick = (event) => {
            var _a, _b;
            const isInsideWebSpotlight = this.configurationManager.isInsideWebSpotlightPreviewIFrame;
            const { data, targetNode } = event.detail;
            const messageData = Object.assign(Object.assign({}, data), { languageCodename: (_a = data.languageCodename) !== null && _a !== void 0 ? _a : this.configurationManager.defaultLanguageCodename, projectId: (_b = data.projectId) !== null && _b !== void 0 ? _b : this.configurationManager.defaultProjectId });
            if (validateAddActionMessageData(messageData)) {
                if (isInsideWebSpotlight) {
                    const messageMetadata = {
                        elementRect: targetNode.getBoundingClientRect(),
                    };
                    this.iframeCommunicator.sendMessage(IFrameMessageType.AddAction, messageData, messageMetadata);
                }
                else {
                    Logger.warn('Add buttons are only functional inside Web Spotlight.');
                }
            }
        };
        this.configurationManager = ConfigurationManager.getInstance();
        this.mutationObserver = new MutationObserver(this.onDomMutation);
        this.intersectionObserver = new IntersectionObserver(this.onElementVisibilityChange);
        this.renderer = new SmartLinkRenderer();
    }
}
//# sourceMappingURL=NodeSmartLinkProvider.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/storage.js

const LocalStorageNotAvailable = 'Local storage is not available or access to local storage is denied for the current document. It may affect the proper work of the SDK.';
function createStorage(key) {
    return {
        get() {
            try {
                const value = window.localStorage.getItem(key);
                return value ? JSON.parse(value) : null;
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
                return null;
            }
        },
        set(data) {
            try {
                const json = JSON.stringify(data);
                window.localStorage.setItem(key, json);
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
            }
        },
        remove() {
            try {
                window.localStorage.removeItem(key);
            }
            catch (_a) {
                Logger.warn(LocalStorageNotAvailable);
            }
        },
    };
}
//# sourceMappingURL=storage.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/EventManager.js
class EventManager {
    constructor() {
        this.listeners = new Map();
        this.on = (event, listener) => {
            var _a, _b;
            const newListeners = (_b = (_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.add(listener)) !== null && _b !== void 0 ? _b : new Set([listener]);
            this.listeners.set(event, newListeners);
        };
        this.off = (event, listener) => {
            var _a;
            (_a = this.listeners.get(event)) === null || _a === void 0 ? void 0 : _a.delete(listener);
        };
        this.emit = (event, ...data) => {
            const listeners = this.listeners.get(event);
            if (listeners && listeners.size > 0) {
                listeners.forEach((callback) => {
                    callback(...data);
                });
            }
        };
        this.removeAllListeners = () => {
            this.listeners = new Map();
        };
    }
}
//# sourceMappingURL=EventManager.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/utils/createUuid.js
const createUuid = () => {
    const randomUint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
    return randomUint32.toString(16);
};
//# sourceMappingURL=createUuid.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/IFrameCommunicator.js





class IFrameCommunicator {
    constructor() {
        this.events = new EventManager();
        this.callbacks = new Map();
        this.addMessageListener = (type, listener) => {
            this.events.on(type, listener);
        };
        this.removeMessageListener = (type, listener) => {
            this.events.off(type, listener);
        };
        this.sendMessageWithResponse = (type, data, callback, metadata) => {
            const requestId = createUuid();
            this.registerCallback(requestId, callback);
            this.sendMessage(type, data, metadata, requestId);
        };
        this.sendMessage = (type, data, metadata, requestId) => {
            if (!isInsideIFrame()) {
                throw InvalidEnvironmentError('IFrameCommunicator: iframe message can only be send while inside iframe.');
            }
            const message = { type, data, metadata, requestId };
            window.parent.postMessage(message, '*');
        };
        this.onMessage = (event) => {
            if (!event.data)
                return;
            const message = event.data;
            this.events.emit(message.type, message.data);
            if (message.requestId) {
                this.executeCallback(message.requestId, message.data);
            }
        };
        this.registerCallback = (requestId, callback) => {
            if (!callback) {
                return;
            }
            this.callbacks.set(requestId, callback);
        };
        this.executeCallback = (requestId, data) => {
            const callback = this.callbacks.get(requestId);
            if (callback) {
                callback(data);
                this.callbacks.delete(requestId);
            }
        };
    }
    initialize() {
        window.addEventListener('message', this.onMessage, true);
    }
    destroy() {
        this.events.removeAllListeners();
        window.removeEventListener('message', this.onMessage, true);
    }
}
//# sourceMappingURL=IFrameCommunicator.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/lib/QueryParamPresenceWatcher.js
let QueryParamPresenceWatcher = /** @class */ (() => {
    class QueryParamPresenceWatcher {
        constructor() {
            this.previousValue = new Map();
            this.timers = new Map();
            this.watch = (queryParam, onChange) => {
                const timerId = this.timers.get(queryParam);
                if (timerId) {
                    clearTimeout(timerId);
                }
                const isPresent = QueryParamPresenceWatcher.isQueryParamPresent(queryParam);
                const hasChanged = this.previousValue.get(queryParam) !== isPresent;
                if (hasChanged) {
                    onChange(isPresent);
                }
                const newTimerId = window.setTimeout(() => this.watch(queryParam, onChange), QueryParamPresenceWatcher.WatchTimeoutMs);
                this.timers.set(queryParam, newTimerId);
            };
            this.unwatchAll = () => {
                this.timers.forEach((timerId) => {
                    clearTimeout(timerId);
                });
                this.timers.clear();
            };
        }
        /**
         * Check if query parameter is present in the current page URL.
         * Query parameter value is ignored, only presence is checked.
         *
         * @param {string} queryParam
         * @returns {boolean}
         */
        static isQueryParamPresent(queryParam) {
            const regex = new RegExp(`[?&]${queryParam}([=&]|$)`, 'i');
            return regex.test(window.location.search);
        }
    }
    QueryParamPresenceWatcher.WatchTimeoutMs = 1000;
    return QueryParamPresenceWatcher;
})();

//# sourceMappingURL=QueryParamPresenceWatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/sdk.js
var sdk_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










class KontentSmartLinkSDK {
    constructor(configuration) {
        this.initialize = () => sdk_awaiter(this, void 0, void 0, function* () {
            yield defineAllRequiredWebComponents();
            const level = this.configurationManager.debug ? LogLevel.Debug : LogLevel.Info;
            Logger.setLogLevel(level);
            if (this.configurationManager.queryParam) {
                this.queryParamPresenceWatcher.watch(this.configurationManager.queryParam, this.nodeSmartLinkProvider.toggle);
            }
            else {
                this.nodeSmartLinkProvider.enable();
            }
            if (isInsideIFrame()) {
                this.initializeIFrameCommunication();
            }
        });
        this.destroy = () => {
            this.queryParamPresenceWatcher.unwatchAll();
            this.iframeCommunicator.destroy();
            this.nodeSmartLinkProvider.destroy();
        };
        this.updateConfiguration = (configuration) => {
            if (typeof configuration.queryParam !== 'undefined') {
                if (!configuration.queryParam) {
                    this.nodeSmartLinkProvider.enable();
                }
                else if (configuration.queryParam !== this.configurationManager.queryParam) {
                    this.queryParamPresenceWatcher.unwatchAll();
                    this.queryParamPresenceWatcher.watch(configuration.queryParam, this.nodeSmartLinkProvider.toggle);
                }
            }
            if (typeof configuration.debug !== 'undefined') {
                const level = configuration.debug ? LogLevel.Debug : LogLevel.Info;
                Logger.setLogLevel(level);
            }
            this.configurationManager.update(configuration);
        };
        this.initializeIFrameCommunication = () => {
            var _a, _b;
            this.iframeCommunicator.initialize();
            const storage = createStorage('kontent-smart-link:iframe-settings');
            const stored = storage.get();
            const enabled = stored !== null ? stored === null || stored === void 0 ? void 0 : stored.enabled : true;
            const messageData = {
                projectId: (_a = this.configurationManager.defaultProjectId) !== null && _a !== void 0 ? _a : null,
                languageCodename: (_b = this.configurationManager.defaultLanguageCodename) !== null && _b !== void 0 ? _b : null,
                enabled,
            };
            this.iframeCommunicator.sendMessageWithResponse(IFrameMessageType.Initialized, messageData, () => {
                this.configurationManager.update({ isInsideWebSpotlight: true });
                this.queryParamPresenceWatcher.unwatchAll();
                this.nodeSmartLinkProvider.disable();
                if (enabled) {
                    this.nodeSmartLinkProvider.enable();
                }
                this.iframeCommunicator.addMessageListener(IFrameMessageType.Status, (data) => {
                    if (!data || !this.nodeSmartLinkProvider)
                        return;
                    this.nodeSmartLinkProvider.toggle(data.enabled);
                    storage.set({
                        enabled: data.enabled,
                    });
                });
            });
        };
        this.configurationManager = ConfigurationManager.getInstance();
        this.configurationManager.update(configuration);
        this.queryParamPresenceWatcher = new QueryParamPresenceWatcher();
        this.iframeCommunicator = new IFrameCommunicator();
        this.nodeSmartLinkProvider = new NodeSmartLinkProvider(this.iframeCommunicator);
        this.initialize();
    }
}
class KontentSmartLink {
    constructor() {
        this.sdk = null;
        this.destroy = () => {
            var _a;
            (_a = this.sdk) === null || _a === void 0 ? void 0 : _a.destroy();
            this.sdk = null;
        };
        this.setConfiguration = (configuration) => {
            if (!this.sdk) {
                throw NotInitializedError('KontentSmartLink is not initialized or has already been destroyed.');
            }
            else {
                this.sdk.updateConfiguration(configuration);
            }
        };
    }
    static initializeOnLoad(configuration) {
        return new Promise((resolve) => {
            window.addEventListener('load', () => {
                resolve(KontentSmartLink.initialize(configuration));
            });
        });
    }
    static initialize(configuration) {
        if (!KontentSmartLink.instance) {
            KontentSmartLink.instance = new KontentSmartLink();
        }
        if (!KontentSmartLink.instance.sdk) {
            KontentSmartLink.instance.sdk = new KontentSmartLinkSDK(configuration);
        }
        return KontentSmartLink.instance;
    }
}
/* harmony default export */ var sdk = (KontentSmartLink);
//# sourceMappingURL=sdk.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-smart-link/es/index.js


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/ThemeProvider.js
var ThemeProvider = __webpack_require__(56631);
// EXTERNAL MODULE: ./src/api/graphql/CmsData.bs.js + 212 modules
var CmsData_bs = __webpack_require__(607);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/auth/user/UserContext.bs.js
var UserContext_bs = __webpack_require__(81098);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/auth/user/AuthContext.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function AuthContext(props) {
    var value = props.value;
    var match = react.useReducer(UserContext_bs.reducer, value !== undefined ? /* Authenticated */ {
        _0: value
    } : /* Guest */ 0);
    var dispatch = match[1];
    react.useEffect(function() {
        var currentState = belt_Option/* mapWithDefault */.k7(AuthUtils_bs/* getUserInfo */.bG(undefined), /* Logout */ 0, function(i) {
            return {
                TAG: /* Login */ 0,
                _0: i
            };
        });
        curry._1(dispatch, currentState);
    }, [
        value
    ]);
    return jsx_runtime.jsx(UserContext_bs.UserProvider.make, {
        value: [
            match[0],
            dispatch
        ],
        children: props.children
    });
}
var make = (/* unused pure expression or super */ null && (AuthContext));
var $$default = AuthContext;
 /* react Not a pure module */ 

// EXTERNAL MODULE: ./src/bindings/segment.js
var segment = __webpack_require__(91435);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/layouts/Page.bs.js + 33 modules
var Page_bs = __webpack_require__(19638);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/layouts/Shared.bs.js
var Shared_bs = __webpack_require__(53827);
;// CONCATENATED MODULE: ./src/layouts/LandingPage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function LandingPage(props) {
    return jsx_runtime.jsx(Shared_bs/* make */.Sy, {
        children: props.children
    });
}
var LandingPage_bs_make = LandingPage;
 /* Shared Not a pure module */ 

// EXTERNAL MODULE: ./src/components/pages/error/ServerError.bs.js
var ServerError_bs = __webpack_require__(35965);
// EXTERNAL MODULE: ./src/css/Themes.bs.js
var Themes_bs = __webpack_require__(86167);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Result.js
var belt_Result = __webpack_require__(70677);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./src/components/StaticImage.bs.js
var StaticImage_bs = __webpack_require__(30369);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/components/CookieSettingButton.bs.js + 1 modules
var CookieSettingButton_bs = __webpack_require__(1223);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer.bs.js
var Footer_bs = __webpack_require__(56473);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./src/components/library/NewsletterSubscription.bs.js
var NewsletterSubscription_bs = __webpack_require__(20025);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js + 1 modules
var TextField_bs = __webpack_require__(98923);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Link.bs.js
var Footer_Link_bs = __webpack_require__(24798);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Column.bs.js
var Footer_Column_bs = __webpack_require__(50574);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Heading.bs.js
var Footer_Heading_bs = __webpack_require__(92426);
// EXTERNAL MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js + 1 modules
var Gql_DictionaryItems_Decoder_bs = __webpack_require__(44623);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__LinkList.bs.js
var Footer_LinkList_bs = __webpack_require__(48778);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Copyright.bs.js
var Footer_Copyright_bs = __webpack_require__(57787);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Responsive.bs.js
var Footer_Responsive_bs = __webpack_require__(42465);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__SocialIcon.bs.js + 1 modules
var Footer_SocialIcon_bs = __webpack_require__(70966);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionList/RegionListLineContent.bs.js
var RegionListLineContent_bs = __webpack_require__(69422);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorTextual.bs.js
var RegionIndicatorTextual_bs = __webpack_require__(80176);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorCountryDisplay.bs.js
var RegionIndicatorCountryDisplay_bs = __webpack_require__(75870);
;// CONCATENATED MODULE: ./src/layouts/BusinessFooter.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


































var subscribeColumn = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* mobile */.ai, {
        hd: Css_bs/* gridRowStart */.lpz(1),
        tl: {
            hd: Css_bs/* important */.efO(Css_bs/* unsafe */.K47("gridColumn", "span 1")),
            tl: /* [] */ 0
        }
    }),
    tl: {
        hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* tablet */.Mq, {
            hd: Css_bs/* important */.efO(Css_bs/* unsafe */.K47("gridColumn", "span 2")),
            tl: {
                hd: Css_bs/* unsafe */.K47("gridArea", "1/2"),
                tl: /* [] */ 0
            }
        }),
        tl: /* [] */ 0
    }
});
var successText = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(18)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(24)),
        tl: {
            hd: Css_bs/* backgroundColor */.Czw(Css_bs/* rgba */.m4f(255, 255, 255, {
                NAME: "num",
                VAL: 0.1
            })),
            tl: {
                hd: Css_bs/* borderRadius */.E0l(Css_bs.px(100)),
                tl: {
                    hd: Css_bs/* width */.bf$(Css_bs.px(250)),
                    tl: {
                        hd: Css_bs/* height */.Cb8(Css_bs.px(38)),
                        tl: {
                            hd: Css_bs/* display */.jfB("flex"),
                            tl: {
                                hd: Css_bs/* justifyContent */.KlP("center"),
                                tl: {
                                    hd: Css_bs/* alignItems */.cq$("center"),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var emailField = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* marginRight */.wzR(Css_bs.px(10)),
    tl: {
        hd: Css_bs/* flexGrow */.H78(1),
        tl: {
            hd: Css_bs/* flexShrink */.i4v(1),
            tl: {
                hd: Css_bs/* marginBottom */.yl7(Css_bs.px(25)),
                tl: /* [] */ 0
            }
        }
    }
});
var isoColumn = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* tablet */.Mq, {
        hd: Css_bs/* gridArea */.fD_({
            NAME: "num",
            VAL: 1
        }),
        tl: /* [] */ 0
    }),
    tl: {
        hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* mobile */.ai, {
            hd: Css_bs/* gridArea */.fD_({
                NAME: "num",
                VAL: 2
            }),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var isoImage = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* width */.bf$(Css_bs/* pct */.hdZ(100)),
    tl: {
        hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* tablet */.Mq, {
            hd: Css_bs/* width */.bf$(Css_bs.px(110)),
            tl: /* [] */ 0
        }),
        tl: {
            hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* mobile */.ai, {
                hd: Css_bs/* width */.bf$(Css_bs.px(110)),
                tl: /* [] */ 0
            }),
            tl: /* [] */ 0
        }
    }
});
var linkColumn = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* whiteSpace */.d8w("nowrap"),
    tl: /* [] */ 0
});
var section = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* display */.jfB("grid"),
    tl: {
        hd: Css_bs/* gridTemplateColumns */.K$K({
            hd: {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 7
                    },
                    {
                        NAME: "fr",
                        VAL: 1
                    }
                ]
            },
            tl: /* [] */ 0
        }),
        tl: {
            hd: Css_bs/* gridColumnGap */.W3B({
                NAME: "percent",
                VAL: 5
            }),
            tl: {
                hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* tablet */.Mq, {
                    hd: Css_bs/* gridTemplateColumns */.K$K({
                        hd: {
                            NAME: "repeat",
                            VAL: [
                                {
                                    NAME: "num",
                                    VAL: 3
                                },
                                {
                                    NAME: "fr",
                                    VAL: 1
                                }
                            ]
                        },
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }),
                tl: {
                    hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* mobile */.ai, {
                        hd: Css_bs/* gridTemplateColumns */.K$K({
                            hd: {
                                NAME: "fr",
                                VAL: 1
                            },
                            tl: /* [] */ 0
                        }),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Styles = {
    subscribeColumn: subscribeColumn,
    successText: successText,
    emailField: emailField,
    isoColumn: isoColumn,
    isoImage: isoImage,
    linkColumn: linkColumn,
    section: section
};
function linkListIcon(lli) {
    if (lli.TAG !== /* FontAwesomeIcon */ 0) {
        return null;
    }
    var fa = lli._0;
    return jsx_runtime.jsx(Footer_SocialIcon_bs/* make */.S, {
        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
            icon: [
                fa.style,
                fa.icon
            ]
        })
    });
}
function linkItem(ll) {
    var icon = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(ll.icon, linkListIcon), null);
    var match = ll.smartLink;
    var itemId = match.itemId;
    var href = ll.url;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsxs("a", {
                children: [
                    icon,
                    ll.link_text
                ],
                href: href,
                target: ll.open_in_new_window ? "_blank" : "_self"
            })
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function mailtoItem(ll) {
    var match = ll.smartLink;
    var itemId = match.itemId;
    var href = "mailto:" + ll.email_address;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsx("a", {
                children: ll.link_text,
                href: href
            })
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function cookieSettingItem(ll) {
    var match = ll.smartLink;
    var itemId = match.itemId;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsx(CookieSettingButton_bs/* make */.S, {
                text: ll.text
            })
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function linkList(ll) {
    var variant = ll.NAME;
    if (variant === "MailtoLinkContentType") {
        return mailtoItem(ll.VAL);
    } else if (variant === "OnetrustCookieSettingButtonContentType") {
        return cookieSettingItem(ll.VAL);
    } else {
        return linkItem(ll.VAL);
    }
}
function columns(col) {
    var match = col.smartLink;
    var itemId = match.itemId;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsxs(Footer_Column_bs/* make */.S, {
            children: [
                jsx_runtime.jsx(Kontent_bs/* Context.Provider.make */._.Provider.make, {
                    children: jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                        children: col.title
                    }),
                    elementCodename: "title"
                }),
                jsx_runtime.jsx(Footer_LinkList_bs/* make */.S, {
                    children: belt_Array/* map */.UI(col.links, linkList)
                })
            ],
            className: linkColumn
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function removeTrailingSlash(url) {
    var slashIndex = url.lastIndexOf("/");
    if (slashIndex === (url.length - 1 | 0)) {
        return url.substring(0, slashIndex);
    } else {
        return url;
    }
}
var isStg = "https://www.prezzee.co.nz/".includes("stg");
function toStgUrl(url) {
    return url.replace("https://www.prezzee", "https://stg.prezzee");
}
function BusinessFooter$NewsletterForm(props) {
    var form = props.form;
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var footer = belt_Option/* flatMap */.VS(state, function(s) {
        return s.businessFooter;
    });
    var subscribe_helper_text = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.subscribe_helper_text;
    }), "");
    var subscribe_cta = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.subscribe_cta;
    }), "");
    var match = belt_Option/* mapWithDefault */.k7(footer, [
        /* Regular */ 0,
        /* White */ 2,
        /* Contained */ 0
    ], function(f) {
        return f.subscribe_cta_style;
    });
    return jsx_runtime.jsx("form", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                    className: emailField,
                    label: subscribe_helper_text,
                    name: "email_address",
                    theme: /* Dark */ 1,
                    type_: "email",
                    error: belt_Option/* isSome */.pC(FormHelpers_bs/* getFieldError */.zQ(form.errors, "email_address")),
                    helperText: FormHelpers_bs/* getFieldError */.zQ(form.errors, "email_address"),
                    inputRef: caml_option/* some */.G(curry._1(form.register, NewsletterSubscription_bs/* newsletterInput */.T))
                }),
                jsx_runtime.jsx(Button_bs.make, {
                    children: jsx_runtime.jsx("button", {
                        children: util_bs/* ReactStuff.s */.p_.s(subscribe_cta),
                        disabled: form.formState.isSubmitted,
                        type: "submit"
                    }),
                    fill: match[2],
                    colour: match[1],
                    variant: match[0]
                })
            ],
            className: "flex flex-wrap"
        }),
        onSubmit: curry._2(form.handleSubmit, props.onSubmit, FormHelpers_bs/* onError */.qQ)
    });
}
var NewsletterForm = {
    make: BusinessFooter$NewsletterForm
};
function BusinessFooter(props) {
    var data = props.data;
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    var footer = data !== undefined ? data : belt_Option/* flatMap */.VS(state, function(s) {
        return s.businessFooter;
    });
    var footerItemId = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.smartLink.itemId;
    }), "");
    var footerCodename = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.smartLink.codename;
    }), "");
    var subscribe_title = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.subscribe_title;
    }), "");
    var region_selector_text = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.region_selector_text;
    }), "");
    var currentYear = (new Date().getFullYear() | 0).toString();
    var disclaimer_level_1 = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.disclaimer_level_1;
    }), "").replace("{0}", currentYear);
    var disclaimer_level_2 = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.disclaimer_level_2;
    }), "").replace("{0}", currentYear);
    var regions = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.regions;
    }), []);
    var domainPostfix = belt_Result/* mapWithDefault */.k7(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), "", function(c) {
        return util_bs/* EnvUtil.getDomainPostfix */.i3.getDomainPostfix(c);
    });
    var regionIndex = belt_Option/* getWithDefault */.tj(belt_Array/* getIndexBy */._n(regions, function(region) {
        return removeTrailingSlash(region.url).endsWith(domainPostfix);
    }), 0);
    var match = react.useState(function() {
        return regionIndex;
    });
    var setSelectedRegion = match[1];
    var selectedRegion = match[0];
    var onChange = function onChange(selected) {
        curry._1(setSelectedRegion, function(param) {
            return selected;
        });
        var region = belt_Array/* get */.U2(regions, selected);
        var url = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(region, function(r) {
            if (isStg) {
                return r.url.replace("https://www.prezzee", "https://stg.prezzee");
            } else {
                return r.url;
            }
        }), "");
        var changeLocation = function cl(url) {
            window.location.assign(url);
        };
        return changeLocation(url);
    };
    var newsletterSuccess = jsx_runtime.jsx("p", {
        children: util_bs/* ReactStuff.s */.p_.s("Woohoo! You're on the list."),
        className: successText
    });
    var regionIndicator = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(s) {
        return s.dictionaryItems;
    }), function(s) {
        return s.app_yourcurrentshoppingregion;
    }), {
        value: "You're currently shopping in {0}",
        smartLink: Gql_DictionaryItems_Decoder_bs/* emptyDictionaryEntry.smartLink */.$d.smartLink
    }, function(param) {
        var smartLink = param.smartLink;
        var value = param.value;
        if (value === "") {
            return {
                value: "You're currently shopping in {0}",
                smartLink: smartLink
            };
        } else {
            return {
                value: value,
                smartLink: smartLink
            };
        }
    });
    var regionIndicatorText = regionIndicator.value;
    var match$1 = regionIndicator.smartLink;
    var regionModalItemId = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.smartLink.itemId;
    }), "");
    var regionModalCodename = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.smartLink.codename;
    }), "");
    var regionPickerTitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.title;
    }), "Change location");
    var regionPickerSubtitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.subtitle;
    }), "Want to send gift cards to family and friends in another country? Change your region below.");
    var regionPickerCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.ctaText;
    }), "Save location");
    var regionPickerStrings = {
        heading: regionPickerTitle,
        heading_subtext: regionPickerSubtitle,
        cta_button: regionPickerCtaText
    };
    var regionListLines = belt_Array/* map */.UI(regions, function(r) {
        var match = r.regionListLine;
        var smartLink = match.smartLink;
        var flag = match.flag;
        var currency = match.currency;
        var name = match.name;
        var el = jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(RegionListLineContent_bs/* make */.S, {
                flag: flag,
                name: name,
                currency: currency
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
        return {
            name: name,
            currency: currency,
            flag: flag,
            el: el
        };
    });
    return jsx_runtime.jsx("footer", {
        children: jsx_runtime.jsxs("div", {
            children: [
                belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
                    return f.link_columns;
                }), []), columns),
                jsx_runtime.jsx(Footer_Column_bs/* make */.S, {
                    children: jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                        children: jsx_runtime.jsx(StaticImage_bs/* make */.S, {
                            src: "/images/lrqa_badge.png",
                            alt: "LRQA certification badge",
                            width: 110,
                            height: 119,
                            className: isoImage
                        })
                    }),
                    colWidth: 1,
                    className: isoColumn
                }),
                jsx_runtime.jsxs(Footer_Column_bs/* make */.S, {
                    children: [
                        jsx_runtime.jsxs(KontentContextProvider_bs/* make */.S, {
                            children: [
                                jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                                    children: util_bs/* ReactStuff.s */.p_.s(subscribe_title)
                                }),
                                jsx_runtime.jsx(NewsletterSubscription_bs/* make */.S, {
                                    formComponent: BusinessFooter$NewsletterForm,
                                    successElement: newsletterSuccess,
                                    store: "business"
                                })
                            ],
                            itemId: footerItemId,
                            elementCodename: footerCodename
                        }),
                        jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                            children: jsx_runtime.jsx(RegionIndicatorTextual_bs/* make */.S, {
                                regions: regionListLines,
                                strings: regionPickerStrings,
                                selected: selectedRegion,
                                children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                                    children: jsx_runtime.jsx(RegionIndicatorCountryDisplay_bs/* make */.S, {
                                        text: regionIndicatorText,
                                        regions: regionListLines,
                                        selected: selectedRegion
                                    }),
                                    itemId: match$1.itemId,
                                    elementCodename: match$1.codename
                                }),
                                onChange: onChange,
                                text: region_selector_text
                            }),
                            itemId: regionModalItemId,
                            elementCodename: regionModalCodename
                        })
                    ],
                    colWidth: 3,
                    className: subscribeColumn
                }),
                jsx_runtime.jsxs(Footer_Copyright_bs/* make */.S, {
                    children: [
                        disclaimer_level_1 !== "" ? jsx_runtime.jsx("div", {
                            children: disclaimer_level_1
                        }) : null,
                        disclaimer_level_2 !== "" ? jsx_runtime.jsx("div", {
                            children: disclaimer_level_2
                        }) : null
                    ]
                })
            ],
            className: Cn_bs/* make */.S([
                IndexStyles_bs/* section */.qi,
                section
            ])
        }),
        className: Footer_bs/* Styles.footerBlock */.z0.footerBlock(theme)
    });
}
var Kontent;
var Footer;
var RegionIndicatorTextual;
var RegionIndicatorCountryDisplay;
var RegionPicker;
var FooterContainer;
var BusinessFooter_bs_make = BusinessFooter;
 /* subscribeColumn Not a pure module */ 

;// CONCATENATED MODULE: ./src/layouts/BusinessPage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function BusinessPage(props) {
    var m = belt_Option/* getWithDefault */.tj(props.mainClassName, Page_bs/* Styles.mainContainer */.z0.mainContainer);
    return jsx_runtime.jsx(Page_bs/* make */.Sy, {
        children: props.children,
        mainClassName: m,
        footer: caml_option/* some */.G(jsx_runtime.jsx(BusinessFooter_bs_make, {})),
        isBusinessContainer: true,
        theme: Themes_bs/* business */.k
    });
}
var BusinessPage_bs_make = BusinessPage;
 /* Page Not a pure module */ 

;// CONCATENATED MODULE: ./src/common/Pages.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function Pages(props) {
    var content = props.content;
    var router = props.router;
    var match = router.route;
    var exit = 0;
    switch(match){
        case "/404":
        case "/404/":
            exit = 6;
            break;
        case "/_error":
            return jsx_runtime.jsx(Page_bs/* make */.Sy, {
                children: jsx_runtime.jsx(ServerError_bs/* make */.S, {})
            });
        case "/about":
        case "/about/":
            exit = 11;
            break;
        case "/about/adrian-turner":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Adrian Turner",
                        description: "Learn more about Adrian Turner.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/claire-morris":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Claire Morris",
                        description: "Learn more about Claire Morris.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/cliff-rosenberg":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Cliff Rosenberg",
                        description: "Learn more about Cliff Rosenberg.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/edward-piazza":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Edward Piazza",
                        description: "Learn more about Edward Piazza.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/philip-corne":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Philip Corne",
                        description: "Learn more about Philip Corne.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/roger-hatem":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Roger Hatem",
                        description: "Learn more about Roger Hatem.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/ruth-newfield":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Ruth Newfield",
                        description: "Learn more about Ruth Newfield.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/shaun-bonett":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Shaun Bonett",
                        description: "Learn more about Shaun Bonett.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/steve-bonett":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Steve Bonett",
                        description: "Learn more about Steve Bonett.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/susan-omalley":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Susan O'Malley",
                        description: "Learn more about Susan O'Malley.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/about/tony-karp":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Prezzee Digital Gift Cards | Tony Karp",
                        description: "Learn more about Tony Karp.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/business":
        case "/business/":
        case "/business/faq":
        case "/business/faq/":
            return jsx_runtime.jsx(BusinessPage_bs_make, {
                children: content
            });
        case "/business/gift-cards":
        case "/business/gift-cards/[pid]":
            exit = 4;
            break;
        case "/contact":
            var match$1 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp;
            if (match$1.TAG === /* Ok */ 0) {
                switch(match$1._0){
                    case /* GreatBritain */ 1:
                        tmp = "Contact Us | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp = "Contact Us | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp = "Contact Us | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp = "Contact Us | Prezzee";
                        break;
                }
            } else {
                tmp = "Contact Us | Prezzee";
            }
            var match$2 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$1;
            if (match$2.TAG === /* Ok */ 0) {
                switch(match$2._0){
                    case /* UnitedStates */ 2:
                        tmp$1 = "Have a question about our gift cards? We're available seven days a week. Get in touch! We'd love to hear from you. Click here to find out more.";
                        break;
                    case /* Australia */ 0:
                    case /* GreatBritain */ 1:
                    case /* NewZealand */ 3:
                    case /* Canada */ 4:
                        tmp$1 = "Contact us at Prezzee. Please ask any questions about eGift cards, leave a comment or suggestion with us. Contact us via email or call our help desk today.";
                        break;
                }
            } else {
                tmp$1 = "Contact us at Prezzee. Please ask any questions about eGift cards, leave a comment or suggestion with us. Contact us via email or call our help desk today.";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp,
                        description: tmp$1,
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/error":
        case "/error/":
            exit = 5;
            break;
        case "/exchange/card/[...pid]":
            return jsx_runtime.jsxs(jsx_runtime.Fragment, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        noindex: true,
                        nofollow: true
                    }),
                    content
                ]
            });
        case "/forgot-email-address":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Forgot Email Address | Prezzee",
                        description: "Forgot your Prezzee email address? Recover your email address with Prezzee. Read more about Prezzee gift cards. Shop online today.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ],
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer,
                footerInFlexibleContainer: false
            });
        case "/forgot-password":
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: "Forgot Password | Prezzee",
                        description: "Forgot your Prezzee password? Recover your password with Prezzee. Read more about Prezzee gift cards. Shop online today.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ],
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer,
                footerInFlexibleContainer: false
            });
        case "/international":
            var match$3 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$2;
            if (match$3.TAG === /* Ok */ 0) {
                switch(match$3._0){
                    case /* GreatBritain */ 1:
                        tmp$2 = "International Gift Cards | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$2 = "eGift Card | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$2 = "International Gift Cards | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$2 = "International Gift Cards | Prezzee";
                        break;
                }
            } else {
                tmp$2 = "International Gift Cards | Prezzee";
            }
            var match$4 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$3;
            if (match$4.TAG === /* Ok */ 0) {
                switch(match$4._0){
                    case /* GreatBritain */ 1:
                        tmp$3 = "Prezzee digital gift cards are now available for overseas country brands including USA, AUS and NZ. Click here for our Prezzee International gift cards.";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$3 = "The Prezzee eGift Card makes buying, sending, storing and redeeming digital Gift Cards easier than ever before! Shop online today for the perfect present!";
                        break;
                    case /* NewZealand */ 3:
                        tmp$3 = "Prezzee digital gift cards are now available for overseas country brands including USA, AUS and UK. Click here for our Prezzee International gift cards.";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$3 = "Prezzee digital gift cards are now available for overseas country brands including USA, UK and NZ. Learn more about Prezzee International.";
                        break;
                }
            } else {
                tmp$3 = "Prezzee digital gift cards are now available for overseas country brands including USA, UK and NZ. Learn more about Prezzee International.";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$2,
                        description: tmp$3,
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/business/landing/[landing]":
        case "/landing/[landing]":
            return jsx_runtime.jsx(LandingPage_bs_make, {
                children: content
            });
        case "/login":
        case "/login/":
            exit = 7;
            break;
        case "/delete-account":
        case "/my-details":
            exit = 9;
            break;
        case "/gift/[...pid]":
        case "/gift/open-ndl/[uid]":
        case "/gift/open-ndl/[uid]/auth":
        case "/gift/open-ndl/[uid]/login":
        case "/gift/open-ndl/[uid]/signup":
        case "/gift/open/[uid]":
        case "/gift/open/[uid]/auth":
        case "/gift/open/[uid]/login":
        case "/gift/open/[uid]/signup":
        case "/partner/exchange":
            exit = 12;
            break;
        case "/pending":
            return jsx_runtime.jsx(Page_bs/* make */.Sy, {
                children: content,
                mainClassName: "flex"
            });
        case "/register":
        case "/register/":
            exit = 8;
            break;
        case "/reminders":
        case "/reminders/":
            exit = 10;
            break;
        case "/orders":
        case "/orders/[uid]":
        case "/reset-password/[uid]":
            exit = 3;
            break;
        case "/store":
            var match$5 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$4;
            if (match$5.TAG === /* Ok */ 0) {
                switch(match$5._0){
                    case /* GreatBritain */ 1:
                        tmp$4 = "Digital Gift Cards | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$4 = "Buy Digital Gift Cards | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$4 = "Digital Gift Cards | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$4 = "Our Digital Gift Cards | Prezzee";
                        break;
                }
            } else {
                tmp$4 = "Our Digital Gift Cards | Prezzee";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$4,
                        description: "Check out our Prezzee store to access hundreds of gift cards for loads of different retailers. You can buy digital gift cards and vouchers from home. See more.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/":
        case "/board":
        case "/confirmed":
        case "/news":
        case "/policies":
        case "/team":
            exit = 1;
            break;
        case "/terms-promotions":
            var match$6 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$5;
            if (match$6.TAG === /* Ok */ 0) {
                switch(match$6._0){
                    case /* GreatBritain */ 1:
                        tmp$5 = "Promotion Terms & Conditions | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$5 = "Buy Gift Cards | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$5 = "Promotion Terms & Conditions | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$5 = "Promotion Terms & Conditions | Prezzee";
                        break;
                }
            } else {
                tmp$5 = "Promotion Terms & Conditions | Prezzee";
            }
            var match$7 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$6;
            if (match$7.TAG === /* Ok */ 0) {
                switch(match$7._0){
                    case /* GreatBritain */ 1:
                        tmp$6 = "Read more about our Prezzee Terms and Conditions for our digital gift cards. Learn more about Prezzee and shop online today.";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$6 = "Give a gift you know they'll love when you buy gift cards from Prezzee. Check out our complete range of gift cards from hundreds of top brands. Give today!";
                        break;
                    case /* Australia */ 0:
                    case /* NewZealand */ 3:
                    case /* Canada */ 4:
                        tmp$6 = "View our range of Prezzee eGift Cards Promotions Terms and Conditions for promotions and competitions. Shop online for Prezzee eGift cards today.";
                        break;
                }
            } else {
                tmp$6 = "View our range of Prezzee eGift Cards Promotions Terms and Conditions for promotions and competitions. Shop online for Prezzee eGift cards today.";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$5,
                        description: tmp$6,
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case "/terms-promotions/[...pid]":
            return content;
        case "/history/[uid]":
        case "/wallet":
            exit = 2;
            break;
        default:
            return jsx_runtime.jsx(Page_bs/* make */.Sy, {
                children: content
            });
    }
    switch(exit){
        case 2:
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        noindex: true,
                        nofollow: true
                    }),
                    content
                ]
            });
        case 4:
            return jsx_runtime.jsx(BusinessPage_bs_make, {
                children: content,
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer
            });
        case 5:
            return jsx_runtime.jsx(Page_bs/* make */.Sy, {
                children: jsx_runtime.jsx(ServerError_bs/* make */.S, {})
            });
        case 1:
        case 6:
            return jsx_runtime.jsx(Page_bs/* make */.Sy, {
                children: content
            });
        case 7:
            var match$8 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$7;
            if (match$8.TAG === /* Ok */ 0) {
                switch(match$8._0){
                    case /* GreatBritain */ 1:
                        tmp$7 = "Sign In | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$7 = "Sign In| Online Gifts & Vouchers | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$7 = "Sign In | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$7 = "Sign In | Prezzee";
                        break;
                }
            } else {
                tmp$7 = "Sign In | Prezzee";
            }
            var match$9 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$8;
            if (match$9.TAG === /* Ok */ 0) {
                switch(match$9._0){
                    case /* UnitedStates */ 2:
                        tmp$8 = "Sign in to your Prezzee account to manage your gift cards, get offers and send gifts even faster. Log in today for the best present!";
                        break;
                    case /* Australia */ 0:
                    case /* GreatBritain */ 1:
                    case /* NewZealand */ 3:
                    case /* Canada */ 4:
                        tmp$8 = "Prezzee makes sending eGift Cards instant, easy and it's free! Sign in to your account with Prezzee digital gift cards. Shop online today.";
                        break;
                }
            } else {
                tmp$8 = "Prezzee makes sending eGift Cards instant, easy and it's free! Sign in to your account with Prezzee digital gift cards. Shop online today.";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$7,
                        description: tmp$8,
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ],
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer,
                footerInFlexibleContainer: false
            });
        case 8:
            var match$10 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$9;
            if (match$10.TAG === /* Ok */ 0) {
                switch(match$10._0){
                    case /* GreatBritain */ 1:
                        tmp$9 = "Register Your Account | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$9 = "Register | Online Gifts & Vouchers | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$9 = "Register Your Account | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$9 = "Register Your Account | Prezzee";
                        break;
                }
            } else {
                tmp$9 = "Register Your Account | Prezzee";
            }
            var match$11 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$10;
            if (match$11.TAG === /* Ok */ 0) {
                switch(match$11._0){
                    case /* UnitedStates */ 2:
                        tmp$10 = "Register with Prezzee to make buying, sending, storing and redeeming digital Gift Cards easier than ever before! Shop online today for the best present!";
                        break;
                    case /* Australia */ 0:
                    case /* GreatBritain */ 1:
                    case /* NewZealand */ 3:
                    case /* Canada */ 4:
                        tmp$10 = "Prezzee makes sending eGift Cards instant, easy and it's free! Read more about how to register your account with Prezzee digital gift cards. Shop online today.";
                        break;
                }
            } else {
                tmp$10 = "Prezzee makes sending eGift Cards instant, easy and it's free! Read more about how to register your account with Prezzee digital gift cards. Shop online today.";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$9,
                        description: tmp$10,
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ],
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer,
                footerInFlexibleContainer: false
            });
        case 3:
        case 9:
        case 10:
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        noindex: true,
                        nofollow: true
                    }),
                    content
                ],
                mainClassName: Page_bs/* Styles.fullHeightMainContainer */.z0.fullHeightMainContainer,
                footerInFlexibleContainer: false
            });
        case 11:
            var match$12 = util_bs/* EnvUtil.currentCountry */.i3.currentCountry;
            var tmp$11;
            if (match$12.TAG === /* Ok */ 0) {
                switch(match$12._0){
                    case /* GreatBritain */ 1:
                        tmp$11 = "About Us | Prezzee UK";
                        break;
                    case /* UnitedStates */ 2:
                        tmp$11 = "Digital Gift Cards | Online Gifts & Vouchers | Prezzee US";
                        break;
                    case /* NewZealand */ 3:
                        tmp$11 = "About Us | Prezzee NZ";
                        break;
                    case /* Australia */ 0:
                    case /* Canada */ 4:
                        tmp$11 = "About Us | Prezzee";
                        break;
                }
            } else {
                tmp$11 = "About Us | Prezzee";
            }
            return jsx_runtime.jsxs(Page_bs/* make */.Sy, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        title: tmp$11,
                        description: "Prezzee digital gift cards makes buying, sending, storing and redeeming easier than ever before! Learn more about Prezzee eGift cards today.",
                        canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath),
                        languageAlternates: util_bs/* SEOUtil.getLanguageAlternates */.br.getLanguageAlternates(router.asPath)
                    }),
                    content
                ]
            });
        case 12:
            return jsx_runtime.jsxs(jsx_runtime.Fragment, {
                children: [
                    jsx_runtime.jsx(next_seo_module/* NextSeo */.PB, {
                        noindex: true,
                        nofollow: true
                    }),
                    content
                ]
            });
    }
}
var Head;
var Script;
var Pages_bs_make = Pages;
 /* Page Not a pure module */ 

// EXTERNAL MODULE: ./src/config/Config.bs.js
var Config_bs = __webpack_require__(43217);
// EXTERNAL MODULE: ./src/contexts/LayoutDataContext.ts
var LayoutDataContext = __webpack_require__(25149);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@prezzee/grid/lib/index.js
var grid_lib = __webpack_require__(40733);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx + 2 modules
var contexts_AuthContext = __webpack_require__(35248);
;// CONCATENATED MODULE: ./src/utils/segment.ts
var SegmentCookieIdentifier;
(function(SegmentCookieIdentifier) {
    SegmentCookieIdentifier["Accept"] = "accept";
    SegmentCookieIdentifier["Unaccept"] = "unaccept";
})(SegmentCookieIdentifier || (SegmentCookieIdentifier = {}));

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs
var build_lib = __webpack_require__(90041);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/api/client.ts + 5 modules
var client = __webpack_require__(86723);
// EXTERNAL MODULE: ./src/api/queries/webConfig.ts
var webConfig = __webpack_require__(88486);
// EXTERNAL MODULE: ./src/contexts/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(33162);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/hooks/useAdaAutoOpen.ts




/**
 * A React hook that automatically opens Ada chat widget on specific paths and manages its state.
 *
 * This hook:
 * - Automatically opens Ada chat when navigating to specified paths
 * - Prevents auto-opening if user manually closed the chat
 * - Restores the previous chat state when leaving target paths
 * - Tracks manual close events to prevent unwanted re-opening
 * - Ensures chat only auto-opens once per session on target paths
 *
 * @param config - Configuration object
 * @param config.paths - Array of URL paths where Ada chat should auto-open
 * @param config.adaReady - Boolean indicating if Ada embed is loaded and ready
 *
 * @example
 * ```tsx
 * // Auto-open Ada chat on checkout and support pages
 * useAdaAutoOpen({
 *   paths: ['/checkout', '/support'],
 *   adaReady: isAdaLoaded
 * });
 * ```
 */ var useAdaAutoOpen = function(param) {
    var paths = param.paths, adaReady = param.adaReady;
    var ref = (0,react.useState)(false), wasManuallyClosed = ref[0], setWasManuallyClosed = ref[1];
    var ref1 = (0,react.useState)(false), hasAutoOpened = ref1[0], setHasAutoOpened = ref1[1];
    var ref2 = (0,react.useState)(null), previousState = ref2[0], setPreviousState = ref2[1];
    var pathname = (0,next_router.useRouter)().pathname;
    var isTargetPath = paths.includes(pathname);
    var restorePreviousState = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var info, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!window.adaEmbed || previousState === null) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        window.adaEmbed.getInfo()
                    ];
                case 2:
                    info = _state.sent();
                    if (info.isChatOpen !== previousState) {
                        window.adaEmbed.toggle();
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("Failed to restore Ada chat state:", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        previousState
    ]);
    var checkAndToggleAda = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var info, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(isTargetPath && adaReady && window.adaEmbed && !wasManuallyClosed && !hasAutoOpened)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        window.adaEmbed.getInfo()
                    ];
                case 2:
                    info = _state.sent();
                    // Store the current state before we potentially change it
                    if (previousState === null) {
                        setPreviousState(info.isChatOpen);
                    }
                    if (!info.isChatOpen) {
                        window.adaEmbed.toggle();
                    }
                    setHasAutoOpened(true);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("Failed to get Ada chat info:", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        isTargetPath,
        adaReady,
        wasManuallyClosed,
        hasAutoOpened,
        previousState
    ]);
    var resetStates = (0,react.useCallback)(function() {
        setPreviousState(null);
        setWasManuallyClosed(false);
        setHasAutoOpened(false);
    }, []);
    // Restore previous state when leaving target paths
    (0,react.useEffect)(function() {
        if (!isTargetPath) {
            if (previousState !== null && adaReady && window.adaEmbed) {
                restorePreviousState().finally(resetStates);
            } else {
                resetStates();
            }
        }
    }, [
        isTargetPath,
        adaReady,
        previousState,
        restorePreviousState,
        resetStates
    ]);
    // Track manual close events
    (0,react.useEffect)(function() {
        if (!adaReady || !window.adaEmbed) return;
        var handleAdaClose = function() {
            if (isTargetPath && hasAutoOpened) {
                setWasManuallyClosed(true);
            }
        };
        window.addEventListener("ada:chat_closed", handleAdaClose);
        return function() {
            window.removeEventListener("ada:chat_closed", handleAdaClose);
        };
    }, [
        adaReady,
        isTargetPath,
        hasAutoOpened
    ]);
    // Listen for route changes
    (0,react.useEffect)(function() {
        checkAndToggleAda();
    }, [
        checkAndToggleAda
    ]);
};
/* harmony default export */ var hooks_useAdaAutoOpen = (useAdaAutoOpen);

;// CONCATENATED MODULE: ./src/contexts/AdaSupport.tsx





var AdaSupportContext = /*#__PURE__*/ (0,react.createContext)({});
var AdaSupportProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), hidden = ref[0], setHidden = ref[1];
    var ref1 = (0,react.useState)(false), adaReady = ref1[0], setAdaReady = ref1[1];
    var hide = (0,react.useCallback)(function() {
        return setHidden(true);
    }, []);
    var show = (0,react.useCallback)(function() {
        return setHidden(false);
    }, []);
    hooks_useAdaAutoOpen({
        paths: [
            "/contact"
        ],
        adaReady: adaReady
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AdaSupportContext.Provider, {
        value: {
            hide: hide,
            show: show
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                async: true,
                src: "https://static.ada.support/embed2.js",
                id: "__ada",
                "data-handle":  true ? "prezzee-gen" : 0,
                strategy: "lazyOnload",
                onLoad: function() {
                    window.adaSettings = {
                        adaReadyCallback: function() {
                            setAdaReady(true);
                        }
                    };
                }
            }),
            hidden && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("style", {
                    children: "#ada-entry { display: none; }"
                })
            }),
            children
        ]
    });
};
var useAdaSupport = function() {
    var ctx = React.useContext(AdaSupportContext);
    if (!ctx) {
        throw new Error("useAdaSupport must be used within a AdaSupportProvider");
    }
    return ctx;
};

// EXTERNAL MODULE: ./src/contexts/ErrorContext.tsx
var ErrorContext = __webpack_require__(80602);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs + 1 modules
var chunk_2OOHT3W5 = __webpack_require__(14000);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 2 modules
var chunk_ZHQNHOQS = __webpack_require__(48618);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-KRPLQIP4.mjs
'use client'

// src/flex.tsx
;

var Flex = (0,chunk_ZJJGQIVY/* forwardRef */.G)(function Flex2(props, ref) {
  const { direction, align, justify, wrap, basis, grow, shrink, ...rest } = props;
  const styles = {
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    flexBasis: basis,
    flexGrow: grow,
    flexShrink: shrink
  };
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(chunk_ZHQNHOQS/* chakra.div */.m.div, { ref, __css: styles, ...rest });
});
Flex.displayName = "Flex";


//# sourceMappingURL=chunk-KRPLQIP4.mjs.map
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Modal/index.js
var Modal = __webpack_require__(15115);
;// CONCATENATED MODULE: ./src/components/common/ErrorModal.tsx







var ErrorModal = function() {
    var ref = (0,ErrorContext/* useErrorModal */._b)(), errorMessage = ref.errorMessage, hideErrorModal = ref.hideErrorModal;
    var ref1 = errorMessage !== null && errorMessage !== void 0 ? errorMessage : {}, title = ref1.title, message = ref1.message, _onClose = ref1.onClose, onClose = _onClose === void 0 ? function() {} : _onClose, _primaryButtonText = ref1.primaryButtonText, primaryButtonText = _primaryButtonText === void 0 ? "close" : _primaryButtonText, secondaryButtonText = ref1.secondaryButtonText, secondaryButtonAction = ref1.secondaryButtonAction;
    var handlePrimaryClose = function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        hideErrorModal();
    };
    var handleSecondaryClose = function() {
        secondaryButtonAction === null || secondaryButtonAction === void 0 ? void 0 : secondaryButtonAction();
        hideErrorModal();
    };
    var isOpen = errorMessage !== null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* Modal */.u_, {
        isOpen: isOpen,
        closeOnOverlayClick: false,
        onClose: handlePrimaryClose,
        isCentered: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Modal/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(chunk_2OOHT3W5/* Text */.x, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: pro_regular_svg_icons/* faCircleXmark */.WA2,
                                    size: "2xl"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                                " ",
                                title
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalBody */.fe, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(chunk_2OOHT3W5/* Text */.x, {
                            align: "center",
                            children: message
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalFooter */.mz, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Flex, {
                            width: "100%",
                            justifyContent: "space-between",
                            children: [
                                secondaryButtonText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                    variant: "outline",
                                    onClick: handleSecondaryClose,
                                    ml: 2,
                                    children: secondaryButtonText
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                    onClick: handlePrimaryClose,
                                    children: primaryButtonText
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_ErrorModal = (ErrorModal);

// EXTERNAL MODULE: ./src/contexts/NavVisibilityContext.tsx
var NavVisibilityContext = __webpack_require__(28750);
// EXTERNAL MODULE: ./src/contexts/ConsumerFeaturesProvider.tsx + 1 modules
var ConsumerFeaturesProvider = __webpack_require__(5641);
// EXTERNAL MODULE: ./node_modules/@segment/snippet/lib/index.js
var snippet_lib = __webpack_require__(72913);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
;// CONCATENATED MODULE: ./src/components/common/GtagMeasurement.ts
var gtagMap = {
    AU: "G-4JFSVXJZVS",
    US: "G-4N079SVHPH",
    NZ: "G-HXB1LZ6XMC",
    GB: "G-TFVX71PJQ6"
};

;// CONCATENATED MODULE: ./src/components/scripts.tsx







var Scripts = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "onetrust-js",
                strategy: "beforeInteractive",
                src: "https://cdn-au.onetrust.com/scripttemplates/otSDKStub.js",
                type: "text/javascript",
                charSet: "UTF-8",
                "data-domain-script": "d8830dde-cc34-44fe-bee0-26af8bf77d42"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "onetrust-consent-wrapper",
                strategy: "beforeInteractive",
                src: "https://cdn.jsdelivr.net/npm/@segment/analytics-consent-wrapper-onetrust@latest/dist/umd/analytics-onetrust.umd.js"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "onetrust-optanon-wrapper",
                type: "text/javascript",
                strategy: "beforeInteractive",
                // Regex below grabs the body of the function as a string
                dangerouslySetInnerHTML: {
                    __html: "function OptanonWrapper() {}"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "cookie-destinations-checker",
                type: "text/javascript",
                async: true,
                dangerouslySetInnerHTML: {
                    __html: "\n                window.onerror = function(e) {\n                  e.toString() === 'Script error.' \n                    ? window.isCookieDestinationsDefined = true\n                    : (() => void 0)();\n                }\n              "
                }
            }),
             false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "segment-snippet",
                "data-ot-ignore": true,
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: snippet_lib/* min */.V({
                        apiKey: "NEp8liwMTEA28ZnjAahJHJg8nepBPmz8",
                        page: false,
                        // @note: Segment library load irrespective of customer accept/reject cookie popup for UK region
                        load: false
                    })
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "segmentLoad",
                dangerouslySetInnerHTML: {
                    __html: "\n        const measurementId = '".concat(gtagMap["NZ"], '\';\n\n        const getQueryParam = (param) => {\n          const urlParams = new URLSearchParams(window.location.search);\n          return urlParams.get(param);\n        };\n\n        const getGATrackingInfo = async (tagId, types) => {\n          if (!Array.isArray(types)) return null;\n\n          return new Promise((resolve) => {\n            const maxRetries = 5;\n            const checkInterval = 100;\n            let attempts = 0;\n\n            const intervalId = setInterval(() => {\n              attempts++;\n\n              if (typeof window.gtag === \'function\') {\n                clearInterval(intervalId);\n\n                const trackingPromises = types.map(\n                  (type) =>\n                    new Promise((resolveType) => {\n                      let resolved = false;\n\n                      const timeoutId = setTimeout(() => {\n                        if (!resolved) {\n                          resolved = true;\n                          resolveType({\n                            type,\n                            value: null,\n                            status: "rejected",\n                            reason: "timeout",\n                          });\n                        }\n                      }, 1000);\n\n                      window.gtag(\'get\', tagId, type, (trackId) => {\n                        if (!resolved) {\n                          resolved = true;\n                          clearTimeout(timeoutId);\n                          resolveType({\n                            type,\n                            value: trackId ? String(trackId) : null,\n                            status: trackId ? "fulfilled" : "rejected",\n                          });\n                        }\n                        return undefined;\n                      });\n                    })\n                );\n\n                Promise.allSettled(trackingPromises).then((results) => {\n                  const trackingData = results.reduce((acc, result) => {\n                    if (result.status === "fulfilled" && result.value.value) {\n                      acc[result.value.type] = result.value.value;\n                    }\n                    return acc;\n                  }, {});\n                  resolve(trackingData);\n                });\n              } else if (attempts >= maxRetries) {\n                clearInterval(intervalId);\n                  console.log("Object window.gtag not found after" + maxRetries + "attempts.");\n                resolve({});\n              }\n            }, checkInterval);\n          });\n        };\n\n        const getCookie = (name) => {\n          const cookies = document.cookie.split(\';\');\n          for (let i = 0; i < cookies.length; i++) {\n          const cookie = cookies[i].trim();\n            if (cookie.startsWith(name + \'=\')) {\n              return cookie.substring(name.length + 1);\n            }\n          }\n          return null;\n        };\n\n        const setCookie = (name, value, days) => {\n          let expires = "";\n          if (days) {\n            const date = new Date();\n            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));\n            expires = "; expires=" + date.toUTCString();\n          }\n          document.cookie = name + "=" + (value || "") + expires + "; path=/";\n        };\n\n        const gatherTrackingInfo = async (measurementId) => {\n          const userAgent = navigator.userAgent;\n          const fbp = getCookie("_fbp");\n          const fbc = getCookie("_fbc");\n          const gclid = getQueryParam("gclid") || getCookie("gclid");\n          const msclkid = getQueryParam("msclkid") || getCookie("msclkid");\n          const linkedinId = getCookie("li_fat_id");\n          const globalMeasurementId = \'G-9V8NCQWXNE\';\n\n          let ga4Info = {};\n          let globalGa4Info = {};\n\n          if (getCookie("gclid") !== gclid && gclid) {\n            setCookie("gclid", gclid, 365);\n          }\n          if (getCookie("msclkid") !== msclkid && msclkid) {\n            setCookie("msclkid", msclkid, 365);\n          }\n\n          if (measurementId) {\n            ga4Info = await getGATrackingInfo(measurementId, [\n              "client_id",\n              "session_id",\n              "session_number",\n            ]);\n            }\n\n          if (globalMeasurementId) {\n            const globalSessionData = await getGATrackingInfo(globalMeasurementId, [\n              "session_id",\n            ]);\n            globalGa4Info = {\n              ...(globalSessionData.session_id && {\n                global_session_id: globalSessionData.session_id,\n              }),\n            };\n          }\n\n          return {\n            ga4: {\n              ...ga4Info,\n              ...globalGa4Info,\n            },\n            google_ads: { ...(gclid && { gclid: gclid }) },\n            fb: {\n              ...(fbc && { fbc: fbc }),\n              ...(fbp && { fbp: fbp }),\n              ...(userAgent && { user_agent: userAgent }),\n            },\n            linkedin: { ...(linkedinId && { li_fat_id: linkedinId }) },\n            microsoft_ads:{ ...(msclkid && { msclkid }) }\n          };\n        };\n\n        const pathname = window.location.pathname;\n        const integrations ={}\n          if (!pathname.startsWith(\'/business/\')) {\n            integrations[\'HubSpot\'] = false;\n          }\n        withOneTrust(analytics).load(\'').concat("NEp8liwMTEA28ZnjAahJHJg8nepBPmz8", "', { integrations: integrations });\n        analytics.addSourceMiddleware(({ payload, next }) => {\n          const oneTrustActiveGroupArray = window.OnetrustActiveGroups.split(',').filter(e => e.startsWith('C'));\n          if(oneTrustActiveGroupArray){\n            const googlePreferences = {\n              ad_user_data: oneTrustActiveGroupArray.includes('C0004') ? 'granted' : 'denied',\n              ad_personalisation: oneTrustActiveGroupArray.includes('C0004') ? 'granted' : 'denied',\n              ad_storage: oneTrustActiveGroupArray.includes('C0004') ? 'granted' : 'denied',\n              analytics_storage: oneTrustActiveGroupArray.includes('C0002') ? 'granted' : 'denied',\n            };\n          payload.obj.context = {...payload.obj.context, ...googlePreferences}\n          }\n          next(payload)\n        });\n\n        analytics.addSourceMiddleware(async ({ payload, next }) => {\n          if (payload.obj.type === 'identify') {\n            const trackingInfo = await gatherTrackingInfo(measurementId);\n\n            payload.obj.traits = {\n              ...payload.obj.traits,\n              marketing_data: trackingInfo,\n            };\n          }\n          next(payload);\n        });\n\n        analytics.ready(() => {\n          if (measurementId) {\n            const maxRetries = 50;\n            const checkInterval = 100;\n            let attempts = 0;\n\n            const intervalId = setInterval(() => {\n              attempts += 1;\n\n              if (typeof window.gtag === 'function') {\n                window.gtag('config', measurementId);\n                clearInterval(intervalId);\n                return;\n              }\n\n              if (attempts >= maxRetries) {\n                clearInterval(intervalId);\n                return;\n              }\n            }, checkInterval);\n          }\n        });\n    ")
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "shirl",
                async: true,
                src: "https://static.srcspot.com/libs/shirl.js",
                type: "application/javascript"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "global-env",
                async: true,
                dangerouslySetInnerHTML: {
                    __html: '\n              window.GLOBAL = {\n                env: {\n                  CLIENT_COOKIE_STORAGE_NAME: "'.concat(AuthUtils_bs/* cookieName */.YN, '",\n                  CLIENT_ENV: "', "production", '",\n                  CLIENT_APP_ENV: "').concat("production", '",\n                  CLIENT_ENCRYPTION_KEY: "').concat("hM23OPzVXo1RgV7nvpE6uJftHk58PzoSyGRayI21Q3dVP1Cu1NtM0bjd1tsKa6oH", '",\n                  CLIENT_GRAPHQL_API_URL: "').concat("https://consumer-bff.prezzee.co.nz/graphql", '",\n                  CLIENT_PREZZEE_SERVER_BASE_URL: "').concat("https://www.prezzee.co.nz/", '",\n                  CLIENT_REGION: "').concat("NZ", '",\n                  CLIENT_SEGMENT_API_KEY: "').concat("NEp8liwMTEA28ZnjAahJHJg8nepBPmz8", '",\n                  CLIENT_CONSUMER_BFF_URL_AU: "').concat("", '",\n                  CLIENT_CONSUMER_BFF_URL_US: "').concat("", '",\n                  CLIENT_CONSUMER_BFF_URL_UK: "').concat("", '",\n                  CLIENT_CONSUMER_BFF_URL_CA: "').concat("", '",\n                  CLIENT_CONSUMER_BFF_URL_NZ: "').concat("https://consumer-bff.prezzee.co.nz/graphql", '"\n                },\n              };\n                ')
                }
            }),
             true && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "sardine-load",
                src: "https://".concat("m-a.prezzee.co.nz", "/assets/loader.min.js"),
                onLoad: function() {
                    window.sardineContext = window._Sardine.createContext({
                        clientId: "3f2a1ca7-327d-4367-a04d-7c7eb69842a4",
                        sessionKey: (0,helpers/* getSessionIdToken */.qB)({
                            updateConfig: false
                        }),
                        flow: location.pathname,
                        environment:  true ? "production" : 0,
                        parentElement: document.body,
                        apiSubdomain: "m-a.prezzee.co.nz",
                        pixelSubdomain: "m-b.prezzee.co.nz",
                        // called when sardine generates/restores deviceID for given device.
                        onDeviceResponse: function onDeviceResponse(data) {}
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((script_default()), {
                id: "cross-domain-tracking",
                async: true,
                dangerouslySetInnerHTML: {
                    __html: "\n        // Function to append stored parameters to all links for whitelisted domains\n        function appendParamsToLinks() {\n          analytics.ready(function () {\n            const currentDomain = window.location.hostname;\n            const validSubdomains = ['www', 'gifttracker'];\n            const domainWhitelist = ['prezzee.com', 'prezzee.com.au', 'prezzee.ca', 'prezzee.co.nz', 'prezzee.uk'].filter(\n              domain => domain !== getNakedDomain(currentDomain)\n            );\n\n            // Get naked domain\n            function getNakedDomain(domain) {\n              const parts = domain.split('.');\n\n              // Check if the first part is a known subdomain and remove it\n              if (validSubdomains.includes(parts[0])) {\n                parts.shift(); // Remove the subdomain part\n              }\n\n              // Return the remaining parts joined by a dot\n              return parts.join('.');\n            }\n\n            // Function to check if a URL belongs to one of the whitelisted domain\n            function isWhitelistedDomain(url) {\n              try {\n                const urlObject = new URL(url);\n                const nakedDomain = getNakedDomain(urlObject.hostname);\n                return domainWhitelist.some(domain => nakedDomain === domain);\n              } catch (e) {\n                return false;\n              }\n            }\n\n            // Function to append parameters to a given URL\n            function appendParamsToUrl(url, params) {\n              const urlObject = new URL(url);\n              Object.keys(params).forEach(key => {\n                urlObject.searchParams.set(key, params[key]);\n              });\n              return urlObject.toString();\n            }\n\n            // Function to get a cookie value by name\n            function getCookie(name) {\n              const value = '; ' + document.cookie;\n              const parts = value.split('; ' + name + '=');\n              if (parts.length === 2) return parts.pop().split(';').shift();\n              return null;\n            }\n\n            // Generate relevant parameters (wait for all pixels to have loaded)\n            let urlParams = {\n              // Segment\n              ajs_uid: analytics.user().id(), // Auto-processed\n              ajs_aid: analytics.user().anonymousId(), // Auto-processed\n              // Microsoft Ads\n              msclkid: getCookie('msclkid'), // Auto-processed\n              // Meta Ads\n              _fbp: getCookie('_fbp'),\n              _fbc: getCookie('_fbc'),\n              // TikTok\n              ttclid: getCookie('ttclid'), // Auto-processed\n              _ttp: getCookie('_ttp'),\n              // LinkedIn\n              li_fat_id: getCookie('li_fat_id'), // Auto-processed\n            };\n\n            // Remove keys with null values\n            for (let key in urlParams) {\n              if (urlParams[key] === null) {\n                delete urlParams[key];\n              }\n            }\n\n            // Get all anchor tags on the page\n            const links = document.querySelectorAll('a');\n\n            // Iterate over each link and append stored parameters if the domain is in the whitelist\n            links.forEach(link => {\n              if (isWhitelistedDomain(link.href)) {\n                link.href = appendParamsToUrl(link.href, urlParams);\n              }\n            });\n          });\n        }\n\n        // Execute appending of parameters to links after the full site has loaded\n        function runAppendParamsToLinks() {\n          if (document.readyState === 'complete') {\n            // Document is already loaded, call the function immediately\n            appendParamsToLinks();\n          } else {\n            // Otherwise, attach the function to the load event\n            window.onload = function () {\n              appendParamsToLinks();\n            };\n          }\n        }\n\n        // Call the function to check the state and potentially attach the event listener\n        runAppendParamsToLinks();\n\n        // Function to read URL parameters and store whitelisted ones\n        function readAndStoreUrlParameters() {\n          // Segment parameters (ajs_*) are actioned by Segment code\n          // msclkid, ttclid, li_fat_id are automatically processed by respective pixels\n          const urlParamsWhitelist = {\n            _fbp: { expires: 90, path: '/', sameSite: 'Lax' },\n            _fbc: { expires: 90, path: '/', sameSite: 'Lax' },\n            _ttp: { expires: 90, path: '/', sameSite: 'Lax' },\n          };\n          const params = new URLSearchParams(window.location.search);\n\n          // Function to set a cookie\n          function setCookie(name, value, options = {}) {\n            let cookieString = encodeURIComponent(name) + '=' + encodeURIComponent(value);\n\n            if (options.expires) {\n              let expires = options.expires;\n              if (typeof expires === 'number') {\n                const date = new Date();\n                date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000); // expires in days\n                expires = date;\n              }\n              cookieString += '; expires=' + expires.toUTCString();\n            }\n\n            if (options.path) {\n              cookieString += '; path=' + options.path;\n            }\n\n            // Dynamically set the domain to the current hostname\n            const domain = window.location.hostname;\n            cookieString += '; domain=' + options.domain;\n\n            if (options.secure) {\n              cookieString += '; secure';\n            }\n\n            if (options.sameSite) {\n              cookieString += '; samesite=' + options.sameSite;\n            }\n\n            document.cookie = cookieString;\n          }\n\n          // Iterate over each key in the whitelist\n          for (const param in urlParamsWhitelist) {\n            if (params.has(param)) {\n              const value = params.get(param);\n              const options = urlParamsWhitelist[param];\n              setCookie(param, value, options);\n            }\n          }\n        }\n\n        // Execute reading and storing of URL parameters as soon as possible\n        document.addEventListener('DOMContentLoaded', readAndStoreUrlParameters);\n"
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/_app.tsx
/* provided dependency */ var process = __webpack_require__(34155);






















































var country = "NZ";
var serverUrl = "https://www.prezzee.co.nz/";
var indexBlackList = [
    "staging",
    "sandbox",
    "demo",
    "dev",
    "model",
    "arena",
    "local"
];
var appEnv = "production";
var defaultTitle = function() {
    switch(country){
        case "AU":
            return "Prezzee AU | Digital Gift Cards and Gift Vouchers Online";
        case "NZ":
            return "Prezzee NZ | Digital Gift Cards and Vouchers Online";
        case "GB":
            return "Prezzee UK | Digital Gift Cards and Gift Vouchers Online";
        case "US":
            return "eGift Cards | Digital Gift Cards & Vouchers | Prezzee US";
        default:
            return "Prezzee AU | Digital Gift Cards and Gift Vouchers Online";
    }
}();
// Determines whether noindex meta tag added to head of document
var noIndex = indexBlackList.some(function(v) {
    return appEnv.includes(v);
});
// Used by next-integration-fixture.ts to pass requestInterceptor to each test,
// where it can be used to set up the server-side request mocks.
var requestInterceptor = process.env.PLAYWRIGHT === "1" && "object" === "undefined" ? 0 : undefined;
var App = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    // const RESTRICTED_ROUTES =
    //   /^\/gift\/+(open(?:-ndl)?|say-thanks)\/[^\/]+(\/auth|\/login|\/signup)?\/|^\/confirmed\/?$/g;
    var openAda = router.query["openAda"];
    var authCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
    var ref = (0,react.useState)((pageProps === null || pageProps === void 0 ? void 0 : pageProps.pageLayoutData) || null), layoutState = ref[0], _ = ref[1];
    var currentConfig = (0,react.useRef)((pageProps === null || pageProps === void 0 ? void 0 : pageProps.config) || null);
    // These 4 variables are used to determine when to load segment
    var isGdprCountry = util_bs/* EnvUtil.checkGdprCountry */.i3.checkGdprCountry(country);
    var hasAcceptedCookies = true;
    var isPb = router.pathname.startsWith(util_bs/* Business.pathname */.e.pathname);
    var isInitialPB = (0,react.useMemo)(function() {
        return router.pathname.startsWith(util_bs/* Business.pathname */.e.pathname);
    }, []);
    (0,react.useEffect)(function() {
        var datadogConfig = {
            clientToken: "pub16cba38ed21e4b5f6acf7bdb7541c0b0",
            site: "datadoghq.com",
            env: appEnv,
            version: Config_bs/* buildVersion */.Bm,
            service: "prezzee-frontend",
            forwardErrorsToLogs: true,
            silentMultipleInit: true,
            sessionSampleRate: 100
        };
        var datadogRumConfig = {
            applicationId: "aee5144b-778c-4823-b851-f70f2504a6ff",
            clientToken: "pube84233671369669c2bf2337f204f7ec2",
            site: "datadoghq.com",
            service: "Prezzee Frontend",
            env: appEnv,
            version: Config_bs/* buildVersion */.Bm,
            sessionSampleRate: noIndex ? 100 : 10,
            sessionReplaySampleRate: 0,
            trackUserInteractions: true,
            silentMultipleInit: true,
            allowedTracingUrls: [
                serverUrl
            ],
            beforeSend: function(event) {
                event.context = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event.context), {
                    country: country
                });
            }
        };
        main/* datadogLogs.init */.fy.init(datadogConfig);
        datadogRum.init(datadogRumConfig);
        // Segment.debug(noIndex);
        segment/* brazeAlias */.pV();
        // Open chatbot if query includes ada
        if (openAda !== undefined) {
            window["adaSettings"] = {
                adaReadyCallback: function() {
                    window["adaEmbed"].toggle();
                }
            };
        }
        router.events.on("routeChangeStart", function(url) {
            var isPB = url.startsWith(util_bs/* Business.pathname */.e.pathname);
            var pathPCtoPB = isPB && !isInitialPB;
            var pathPBtoPC = !isPB && isInitialPB;
            if (pathPCtoPB || pathPBtoPC) {
                window.location.assign(window.location.origin + url);
            }
        });
        var fingerprint = js_cookie_default().get("fingerprint-pz");
        if (!js_cookie_default().get("auth-mfe-ready") || !fingerprint) {
            js_cookie_default().remove("fingerprint-pz");
            js_cookie_default().set("fingerprint-pz", fingerprint !== null && fingerprint !== void 0 ? fingerprint : (0,v4/* default */.Z)(), {
                expires: 400,
                domain: (0,AuthUtils_bs/* getCookieDomain */.yT)()
            });
            js_cookie_default().set("auth-mfe-ready", "true", {
                expires: 400,
                domain: (0,AuthUtils_bs/* getCookieDomain */.yT)()
            });
        }
        var defaultTraits = isPb ? Segment_bs/* businessStore */.wY : Segment_bs/* consumerStore */.Zk;
        var traits = isGdprCountry && !hasAcceptedCookies ? defaultTraits : Object.assign({}, defaultTraits, {
            cookie_policy: SegmentCookieIdentifier.Accept
        });
        analytics.ready(function() {
            Segment_bs/* identifyWithContext */.Dx(void 0, traits, isPb);
        });
        var TTCLID_STORAGE_NAME = "ttclid"; // @note: the setting parameter
        if (router.query && router.query.ttclid && typeof router.query.ttclid === "string") {
            localStorage.setItem(TTCLID_STORAGE_NAME, router.query.ttclid);
        }
        if (localStorage.getItem("chakra-ui-color-mode") !== "light") {
            localStorage.setItem("chakra-ui-color-mode", "light");
            document.getElementsByTagName("html")[0].setAttribute("data-theme", "light");
        }
    }, []);
    // Segment hash page on router change
    (0,react.useEffect)(function() {
        var acceptCookie = js_cookie_default().get(util_bs/* CookieUtils.acceptCookies */.le.acceptCookies);
        var isPb = router.pathname.startsWith(util_bs/* Business.pathname */.e.pathname);
        Segment_bs/* hashPage */.Fe(country === "GB" ? acceptCookie === "true" : true, isPb);
        // Open chatbot if query includes ada
        openAda && window["adaEmbed"] && window["adaEmbed"].toggle();
    }, [
        router.route,
        router.query
    ]);
    // Kentico Kontent initialize
    (0,react.useEffect)(function() {
        var ref = (layoutState === null || layoutState === void 0 ? void 0 : layoutState.kontentData) || {}, projectId = ref.projectId, languageCodename = ref.languageCodename;
        if (projectId && languageCodename) {
            var body = document.querySelector("body");
            if (body) {
                body.setAttribute("data-kontent-project-id", projectId);
                body.setAttribute("data-kontent-language-codename", languageCodename);
            }
        }
        var smartLink = sdk.initialize({
            debug: false,
            queryParam: "editor-mode",
            defaultDataAttributes: {
                projectId: projectId,
                languageCodename: languageCodename
            }
        });
        return function() {
            if (smartLink && smartLink.destroy) smartLink.destroy();
        };
    }, [
        layoutState
    ]);
    // Setting react-modal app element - http://reactcommunity.org/react-modal/accessibility/#app-element
    lib_default().setAppElement("#__next");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ThemeProvider/* default */.ZP, {
        theme: src_theme,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Scripts, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(grid_lib.ScreenClassProvider, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ConfigProvider/* ConfigProvider */.iV, {
                    value: currentConfig.current,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ErrorContext/* ErrorModalProvider */.ao, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(QueryClientProvider/* QueryClientProvider */.aH, {
                            client: client/* default */.Z,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_seo_module/* DefaultSeo */.lX, {
                                    title: defaultTitle,
                                    canonical: util_bs/* SEOUtil.getCanonicalUrl */.br.getCanonicalUrl(router.asPath)
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AdaSupportProvider, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LayoutDataContext/* LayoutDataContext.Provider */.N.Provider, {
                                        value: layoutState,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contexts_AuthContext/* AuthProvider */.Ho, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ConsumerFeaturesProvider/* ConsumerFeaturesProvider */.y, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(contexts_AuthContext/* AuthContext.Consumer */.Vo.Consumer, {
                                                    children: function(param) {
                                                        var user = param.user;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)($$default, {
                                                            value: user || undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_seo_module/* DefaultSeo */.lX, {
                                                                    dangerouslySetAllPagesToNoIndex: noIndex,
                                                                    dangerouslySetAllPagesToNoFollow: noIndex
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(NavVisibilityContext/* NavVisibilityProvider */.iu, {
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pages_bs_make, {
                                                                        router: router,
                                                                        content: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                                    })
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(common_ErrorModal, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(build_lib/* ReactQueryDevtools */.t, {
                                    initialIsOpen: false
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
App.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _ctx, req, res, query, isPreview, language, isInBrowser, isInEditorMode, config, pageLayoutData, userIp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ctx = param.ctx, req = _ctx.req, res = _ctx.res, query = param.router.query;
                    isPreview = query.preview !== undefined;
                    language = query.lang;
                    isInBrowser = "object" !== "undefined";
                    isInEditorMode = !!(query["editor-mode"] === "inline");
                    return [
                        4,
                        (0,webConfig/* default */.Z)()
                    ];
                case 1:
                    config = _state.sent();
                    if (!!isInBrowser) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,CmsData_bs/* getCmsData */.rX)(util_bs/* EnvUtil.getCmsLanguage */.i3.getCmsLanguage(language), isPreview, isInEditorMode)
                    ];
                case 2:
                    pageLayoutData = _state.sent();
                    userIp = req.headers["x-real-ip"] || req.headers["x-forwarded-for"] || req.socket.remoteAddress;
                    res.setHeader("Set-Cookie", [
                        "user-ip=".concat(userIp, ";")
                    ]);
                    return [
                        2,
                        {
                            pageProps: {
                                pageLayoutData: pageLayoutData,
                                config: config
                            }
                        }
                    ];
                case 3:
                    return [
                        2,
                        {
                            pageProps: null
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 98461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _head = _interop_require_default(__webpack_require__(5443));
var _imageBlurSvg = __webpack_require__(42730);
var _imageConfig = __webpack_require__(99309);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, fill = _param.fill, style = _param.style, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _object_without_properties_loose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "className",
        "quality",
        "width",
        "height",
        "fill",
        "style",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var loader = defaultLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _object_without_properties_loose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var blurWidth;
    var blurHeight;
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        if (!staticImageData.height || !staticImageData.width) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurWidth = staticImageData.blurWidth;
        blurHeight = staticImageData.blurHeight;
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!fill) {
            if (!widthInt && !heightInt) {
                widthInt = staticImageData.width;
                heightInt = staticImageData.height;
            } else if (widthInt && !heightInt) {
                var ratio = widthInt / staticImageData.width;
                heightInt = Math.round(staticImageData.height * ratio);
            } else if (!widthInt && heightInt) {
                var ratio1 = heightInt / staticImageData.height;
                widthInt = Math.round(staticImageData.width * ratio1);
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if (config.unoptimized) {
        unoptimized = true;
    }
    var ref = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(false), 2), showAltText = ref1[0], setShowAltText = ref1[1];
    var qualityInt = getInt(quality);
    if (false) { var url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign(fill ? {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    } : {}, showAltText ? {} : {
        color: "transparent"
    }, style);
    var blurStyle = placeholder === "blur" && blurDataURL && !blurComplete ? {
        backgroundSize: imgStyle.objectFit || "cover",
        backgroundPosition: imgStyle.objectPosition || "50% 50%",
        backgroundRepeat: "no-repeat",
        backgroundImage: 'url("data:image/svg+xml;charset=utf-8,'.concat((0, _imageBlurSvg).getImageBlurSvg({
            widthInt: widthInt,
            heightInt: heightInt,
            blurWidth: blurWidth,
            blurHeight: blurHeight,
            blurDataURL: blurDataURL
        }), '")')
    } : {};
    if (false) {}
    var imgAttributes = generateImgAttrs({
        config: config,
        src: src,
        unoptimized: unoptimized,
        width: widthInt,
        quality: qualityInt,
        sizes: sizes,
        loader: loader
    });
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _defineProperty(_obj, "crossOrigin", rest.crossOrigin), _obj);
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        fill: fill,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setShowAltText: setShowAltText
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
"client";
var configEnv = {"deviceSizes":[200,320,375,425,768,1024,1440,2560],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image/","loader":"default","dangerouslyAllowSVG":false,"unoptimized":false};
var allImgs = new Map();
var perfObserver;
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number" || typeof x === "undefined") {
        return x;
    }
    if (typeof x === "string" && /^[0-9]+$/.test(x)) {
        return parseInt(x, 10);
    }
    return NaN;
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            onLoadingCompleteRef.current(img);
        }
        if (false) { var widthModified, heightModified, valid, position, widthViewportRatio; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, fill = _param.fill, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setShowAltText = _param.setShowAltText, onLoad = _param.onLoad, onError = _param.onError, rest = _object_without_properties_loose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "fill",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setShowAltText",
        "onLoad",
        "onError"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        width: widthInt,
        height: heightInt,
        decoding: "async",
        "data-nimg": "future".concat(fill ? "-fill" : ""),
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            srcString,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete,
            onError, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            // if the real image fails to load, this will ensure "alt" is visible
            setShowAltText(true);
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })));
};
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat(config.path, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 71210:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 42730:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getImageBlurSvg = getImageBlurSvg;
function getImageBlurSvg(param) {
    var widthInt = param.widthInt, heightInt = param.heightInt, blurWidth = param.blurWidth, blurHeight = param.blurHeight, blurDataURL = param.blurDataURL;
    var std = blurWidth && blurHeight ? "1" : "20";
    var svgWidth = blurWidth || widthInt;
    var svgHeight = blurHeight || heightInt;
    var feComponentTransfer = blurDataURL.startsWith("data:image/jpeg") ? "%3CfeComponentTransfer%3E%3CfeFuncA type='discrete' tableValues='1 1'/%3E%3C/feComponentTransfer%3E%" : "";
    return "%3Csvg xmlns='http%3A//www.w3.org/2000/svg' viewBox='0 0 ".concat(svgWidth, " ").concat(svgHeight, "'%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='").concat(std, "'/%3E").concat(feComponentTransfer, "%3C/filter%3E%3Cimage filter='url(%23b)' x='0' y='0' height='100%25' width='100%25' href='").concat(blurDataURL, "'/%3E%3C/svg%3E");
} //# sourceMappingURL=image-blur-svg.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( true ? __webpack_require__(67294) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 1045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34155);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
exports.StyleRegistry = StyleRegistry;
exports.createStyleRegistry = createStyleRegistry;
exports.style = JSXStyle;
exports.useStyleRegistry = useStyleRegistry;


/***/ }),

/***/ 89967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(1045);


/***/ }),

/***/ 60357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(1045).style;


/***/ }),

/***/ 44054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ networkError; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
function networkError(msgOpt, status) {
    var msg = msgOpt !== undefined ? msgOpt : "Network error";
    return {
        TAG: /* NetworkError */ 0,
        _0: status,
        _1: msg
    };
}
 /* No side effect */ 


/***/ }),

/***/ 38060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Decode; }
/* harmony export */ });
/* unused harmony export optionalNullable */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94518);
/* harmony import */ var _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77058);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25400);
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE






function optionalNullable(decode, json) {
    try {
        return _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_3__/* .fromOption */ .Yo(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__._1(decode, json)));
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return null;
        }
        throw exn;
    }
}
function category(json) {
    return {
        name: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        position: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("position", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        slug: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("slug", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        cms_id: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("cms_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        image: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function categories(json) {
    return {
        count: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("count", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        next: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("next", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        previous: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("previous", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        results: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("results", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(category, param);
        }, json)
    };
}
function safeDecodeCategoriesData(json) {
    var result;
    try {
        result = categories(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode = {
    category: category,
    categories: categories,
    safeDecodeCategoriesData: safeDecodeCategoriesData
};
 /* No side effect */ 


/***/ }),

/***/ 65496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Decode; }
/* harmony export */ });
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91574);
/* harmony import */ var _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77058);
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE




function theme(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        thumbImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("thumb_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        squareIcon: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("square_icon", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        textureImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("texture_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        keyColour: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("key_colour", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        textColour: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("text_colour", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json)
    };
}
function phone(json) {
    return {
        phone: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("phone", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json)
    };
}
function providerDetails(json) {
    return {
        videoId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("video_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        accountId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("account_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        playerId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("player_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json)
    };
}
function media(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        mediaType: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("media_type", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        provider: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("provider", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        providerDetails: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("provider_details", providerDetails, json)
    };
}
function card(json) {
    var _$gift = function _$gift(json) {
        return {
            uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
            status: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("status", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
            regifted: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("regifted", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
            message: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("message", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
            recipientName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("recipient_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
            recipientEmail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("recipient_email", function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
            }, json),
            senderName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_name", function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
            }, json),
            senderEmail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
            }, json),
            senderLogoUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_logo_url", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
            }, json),
            card: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card", card, json),
            theme: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme", theme, json),
            media: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("media", function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX(media, param);
            }, json),
            unwrappingAuthFlowV2: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("unwrapping_auth_flow_v2", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json)
        };
    };
    var innerGift = function innerGift(json) {
        if (typeof json === "string") {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI(function(str) {
                return {
                    TAG: /* CardId */ 0,
                    _0: str
                };
            }, _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json);
        }
        return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI(function(gift) {
            return {
                TAG: /* GiftInstance */ 1,
                _0: gift
            };
        }, _$gift, json);
    };
    return {
        themeUid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme_uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        themeImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        themekeyColour: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme_key_colour", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        themeTextColour: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme_text_colour", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        value: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("value", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        originalBalance: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("original_balance", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        valueCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("value_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        originalBalanceCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("original_balance_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        balance: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("balance", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        balanceCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("balance_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        expiry: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("expiry", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        isExpired: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("is_expired", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        balanceUpdatedAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("balance_updated_at", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        notes: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("notes", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        productType: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("product_type", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        cardLabel: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card_label", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        cardPin: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card_pin", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        cardId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        number: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        barcodeNumber: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("barcode_number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        instoreNumber: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("instore_number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        onlineNumber: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("online_number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        pin: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("pin", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        pinFieldName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("pin_field_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        cardBarcodeFormat: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card_barcode_format", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        cardLogo: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card_logo", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        merchantTerms: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("merchant_terms", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        status: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("status", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        subtype: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("subtype", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        updatedAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("updated_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        activatedAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("activated_at", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        createdAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("created_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        receivedAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("received_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        gift: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("gift", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(innerGift, param);
        }, json),
        isSwapCard: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("is_swap_card", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        isSchemeCard: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("is_scheme_card", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        swapCard: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("swap_card", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        donation: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("donation", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        supportsRegift: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("supports_regift", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        supportsBalanceCheck: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("supports_balance_check", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        supportsAppleWalletExport: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("supports_apple_wallet_export", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        supportsGoogleWalletExport: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("supports_google_wallet_export", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        receiptText: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("receipt_text", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        receiptLogoTop: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("receipt_logo_top", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        redemptionUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("redemption_url", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        balanceCheckUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("balance_check_url", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        howToUse: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("how_to_use", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        skuDisplayName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sku_display_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        skuUid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sku_uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        pdfUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("pdf_url", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        defaultProductCode: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("default_product_code", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        defaultProductThemeCode: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("default_product_theme_code", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        defaultSkuUid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("default_sku_uid", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json)
    };
}
function gift(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        status: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("status", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        regifted: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("regifted", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        message: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("message", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        recipientName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("recipient_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        recipientEmail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("recipient_email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        senderName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_name", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        senderEmail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        senderLogoUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("sender_logo_url", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        card: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("card", card, json),
        theme: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("theme", theme, json),
        media: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("media", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX(media, param);
        }, json),
        unwrappingAuthFlowV2: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("unwrapping_auth_flow_v2", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json)
    };
}
function wallet(json) {
    return {
        cards: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("cards", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX(card, param);
        }, json)
    };
}
function customerData(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        firstName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("first_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        lastName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("last_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        email: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        phone: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("phone", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        marketingOptin: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("marketing_optin", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg, json),
        wallet: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("wallet", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG(wallet, param);
        }, json)
    };
}
function safeDecodeCustomerData(json) {
    var result;
    try {
        result = customerData(json);
    } catch (raw_e) {
        var e = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_e);
        if (e.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DecodeError */ ._9) {
            _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error({
                err: e._1,
                type: "Safe Decode Customer Data"
            }, "error: Could not decode response from the server");
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
function safeDecodeGift(json) {
    var result;
    try {
        result = gift(json);
    } catch (raw_e) {
        var e = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_e);
        if (e.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DecodeError */ ._9) {
            _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error({
                err: e._1,
                type: "Safe Decode Gift"
            }, "error: Could not decode response from the server");
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
function safeDecodePhoneValidation(json) {
    var result;
    try {
        result = phone(json);
    } catch (raw_e) {
        var e = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_e);
        if (e.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DecodeError */ ._9) {
            _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error({
                err: e._1,
                type: "Safe Decode Phone Validation Data"
            }, "error: Could not decode response from the server");
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode = {
    theme: theme,
    phone: phone,
    providerDetails: providerDetails,
    media: media,
    card: card,
    gift: gift,
    wallet: wallet,
    customerData: customerData,
    safeDecodeCustomerData: safeDecodeCustomerData,
    safeDecodeGift: safeDecodeGift,
    safeDecodePhoneValidation: safeDecodePhoneValidation
};
 /* Pino Not a pure module */ 


/***/ }),

/***/ 77058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Decode; }
/* harmony export */ });
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE


function error(json) {
    return {
        detail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .field */ .EP("detail", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_, json)
    };
}
function safeDecodeError(json) {
    var e;
    try {
        e = error(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_1__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DecodeError */ ._9) {
            return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* JsonParsingError */ 1,
                    _0: "Could not decode error from the server."
                }
            };
        }
        throw exn;
    }
    return {
        TAG: /* Error */ 1,
        _0: {
            TAG: /* ServerError */ 2,
            _0: {
                TAG: /* ServerValidationError */ 0,
                _0: e.detail
            }
        }
    };
}
var Decode = {
    error: error,
    safeDecodeError: safeDecodeError
};
 /* No side effect */ 


/***/ }),

/***/ 21005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Decode; }
/* harmony export */ });
/* unused harmony export optionalNullable */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94518);
/* harmony import */ var _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77058);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25400);
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE






function optionalNullable(decode, json) {
    try {
        return _rescript_std_lib_es6_js_null_js__WEBPACK_IMPORTED_MODULE_3__/* .fromOption */ .Yo(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_5__._1(decode, json)));
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return null;
        }
        throw exn;
    }
}
function denominations(json) {
    return {
        code: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("code", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        value: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("value", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        valueCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("value_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        price: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("price", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        priceCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("price_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function theme(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        code: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("code", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        image: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function template(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        imageFrame: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("image_frame", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        imagePreview: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("image_preview", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function promo(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        title: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("title", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        enabled: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("enabled", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, json),
        promoText: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("promo_text", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        terms: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("terms", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function category(json) {
    return {
        name: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        slug: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("slug", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        position: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("position", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        order: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("order", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        skuPosition: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_position", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json)
    };
}
function alert(json) {
    return {
        title: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("title", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        messageMarkdown: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("message_markdown", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        level: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("level", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        priority: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("priority", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json)
    };
}
function merchant(json) {
    return {
        terms: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("terms", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function sku(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        name: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        searchableTerms: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("searchable_terms", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        similarTerms: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("similar_terms", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        displayName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("display_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        productType: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("product_type", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        code: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("code", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        templates: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("templates", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(template, param);
        }, json),
        themes: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("themes", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(theme, param);
        }, json),
        promos: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("promos", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(promo, param);
        }, json),
        denominations: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("denominations", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(denominations, param);
        }, json),
        description: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("description", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        longDescription: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("long_description", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        tagline: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("tagline", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        descriptionMarkdown: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("description_markdown", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        isSwappable: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("is_swappable", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, json),
        categories: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("categories", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(category, param);
        }, json),
        expiryTermDisplay: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("expiry_term_display", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        alerts: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("alerts", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(alert, param);
        }, json),
        slug: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("slug", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        isPbCategoryHidden: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("hide_from_all_business_categories", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, json),
        isPcCategoryHidden: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("hide_from_all_classic_categories", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, json),
        merchant: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("merchant", merchant, json),
        cmsId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("cms_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        createdAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("created_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        layerEnabled: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("layer_enabled", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, param);
        }, json),
        layerExpiryTerm: optionalNullable(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("layer_expiry_term", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json)
    };
}
function inventory(json) {
    return {
        skus: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("skus", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(sku, param);
        }, json)
    };
}
function safeDecodeInventory(json) {
    var value;
    try {
        value = inventory(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
function safeDecodeInventoryForData(json) {
    var value;
    try {
        value = inventory(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return;
        }
        throw exn;
    }
    return value;
}
function safeDecodeSku(json) {
    var value;
    try {
        value = sku(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return;
        }
        throw exn;
    }
    return value;
}
var Decode = {
    denominations: denominations,
    theme: theme,
    template: template,
    promo: promo,
    category: category,
    alert: alert,
    merchant: merchant,
    sku: sku,
    inventory: inventory,
    safeDecodeInventory: safeDecodeInventory,
    safeDecodeInventoryForData: safeDecodeInventoryForData,
    safeDecodeSku: safeDecodeSku
};
 /* No side effect */ 


/***/ }),

/***/ 47861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BFFNewsletter": function() { return /* binding */ BFFNewsletter; },
  "businessContact": function() { return /* binding */ businessContact; },
  "businessLandingContactForm": function() { return /* binding */ businessLandingContactForm; },
  "claimGift": function() { return /* binding */ claimGift; },
  "contact": function() { return /* binding */ contact; },
  "createDraftOrder": function() { return /* binding */ createDraftOrder; },
  "edmOptIn": function() { return /* binding */ edmOptIn; },
  "exchangeInventory": function() { return /* binding */ exchangeInventory; },
  "finaliseOrder": function() { return /* binding */ finaliseOrder; },
  "getBraintreePaymentIntent": function() { return /* binding */ getBraintreePaymentIntent; },
  "getCategories": function() { return /* binding */ getCategories; },
  "getGiftThemes": function() { return /* binding */ getGiftThemes; },
  "getHomePageData": function() { return /* binding */ getHomePageData; },
  "getInventoryForProduct": function() { return /* binding */ getInventoryForProduct; },
  "getPaymentIntent": function() { return /* binding */ getPaymentIntent; },
  "getPrivacyPolicy": function() { return /* binding */ getPrivacyPolicy; },
  "getPromotionTerms": function() { return /* binding */ getPromotionTerms; },
  "getPromotionTermsSingle": function() { return /* binding */ getPromotionTermsSingle; },
  "getSkuBySlug": function() { return /* binding */ getSkuBySlug; },
  "getTermsOfSale": function() { return /* binding */ getTermsOfSale; },
  "getTermsOfService": function() { return /* binding */ getTermsOfService; },
  "getWebConfigs": function() { return /* binding */ getWebConfigs; },
  "openGift": function() { return /* binding */ openGift; },
  "openGiftServer": function() { return /* binding */ openGiftServer; },
  "resetPassword": function() { return /* binding */ resetPassword; },
  "sayThanks": function() { return /* binding */ sayThanks; },
  "securityCode": function() { return /* binding */ PrezzeePublicClient_bs_securityCode; },
  "uploadTheme": function() { return /* binding */ uploadTheme; },
  "validateCustomerPassword": function() { return /* binding */ validateCustomerPassword; },
  "validatePhoneNumber": function() { return /* binding */ validatePhoneNumber; },
  "validatePromoCode": function() { return /* binding */ validatePromoCode; }
});

// EXTERNAL MODULE: ./src/bindings/Pino.bs.js
var Pino_bs = __webpack_require__(91574);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/bs-fetch/src/Fetch.bs.js
var Fetch_bs = __webpack_require__(90917);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/pervasives.js + 1 modules
var pervasives = __webpack_require__(60702);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_decode.bs.js
var Json_decode_bs = __webpack_require__(35847);
;// CONCATENATED MODULE: ./src/api/Data/BFFData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function query(email, region, subscribed, store, _type) {
    return js_dict/* fromList */.hy({
        hd: [
            "query",
            'mutation {\n      postNewsletterSubscription(email: "' + email + '", region: "' + region + '", subscribed: ' + pervasives/* string_of_bool */.ln(subscribed) + ', store: "' + store + '", type: "' + _type + '") {\n        globalGuid\n        email\n        regions {\n          AU {\n            regionId\n          }\n          NZ {\n            regionId\n          }\n          UK {\n            regionId\n          }\n          US {\n            regionId\n          }\n        }\n        lastUpdatedAt\n      }\n    }'
        ],
        tl: /* [] */ 0
    });
}
function region(json) {
    return {
        regionId: Json_decode_bs/* field */.EP("regionId", Json_decode_bs/* string */.Z_, json)
    };
}
function regions(json) {
    return {
        au: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("AU", region, param);
        }, json),
        nz: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("NZ", region, param);
        }, json),
        uk: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("UK", region, param);
        }, json),
        us: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("US", region, param);
        }, json)
    };
}
function postNewsletterSubscriptionData(json) {
    return {
        globalGuid: Json_decode_bs/* field */.EP("globalGuid", Json_decode_bs/* string */.Z_, json),
        email: Json_decode_bs/* field */.EP("email", Json_decode_bs/* string */.Z_, json),
        regions: Json_decode_bs/* field */.EP("regions", regions, json),
        lastUpdatedAt: Json_decode_bs/* field */.EP("lastUpdatedAt", Json_decode_bs/* string */.Z_, json)
    };
}
function postNewsletterSubscription(json) {
    return {
        postNewsletterSubscription: Json_decode_bs/* field */.EP("postNewsletterSubscription", postNewsletterSubscriptionData, json)
    };
}
function data(json) {
    return {
        data: Json_decode_bs/* field */.EP("data", postNewsletterSubscription, json)
    };
}
var Decode = {
    region: region,
    regions: regions,
    postNewsletterSubscriptionData: postNewsletterSubscriptionData,
    postNewsletterSubscription: postNewsletterSubscription,
    data: data
};
var NewsletterSubscription = {
    query: query,
    Decode: Decode
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/bindings/Datadog.bs.js
var Datadog_bs = __webpack_require__(7280);
// EXTERNAL MODULE: ./src/common/Request.bs.js
var Request_bs = __webpack_require__(24429);
// EXTERNAL MODULE: ./src/api/Data/ErrorData.bs.js
var ErrorData_bs = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_js_exceptions.js
var caml_js_exceptions = __webpack_require__(37082);
;// CONCATENATED MODULE: ./src/api/Data/GiftData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function card(json) {
    return {
        themeUid: Json_decode_bs/* field */.EP("theme_uid", Json_decode_bs/* string */.Z_, json),
        themeImage: Json_decode_bs/* field */.EP("theme_image", Json_decode_bs/* string */.Z_, json),
        themekeyColour: Json_decode_bs/* field */.EP("theme_key_colour", Json_decode_bs/* string */.Z_, json),
        themeTextColour: Json_decode_bs/* field */.EP("theme_text_colour", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        originalBalance: Json_decode_bs/* field */.EP("original_balance", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        originalBalanceCurrency: Json_decode_bs/* field */.EP("original_balance_currency", Json_decode_bs/* string */.Z_, json),
        balance: Json_decode_bs/* field */.EP("balance", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        balanceCurrency: Json_decode_bs/* field */.EP("balance_currency", Json_decode_bs/* string */.Z_, json),
        expiry: Json_decode_bs/* field */.EP("expiry", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        isExpired: Json_decode_bs/* field */.EP("is_expired", Json_decode_bs/* bool */.Xg, json),
        balanceUpdatedAt: Json_decode_bs/* field */.EP("balance_updated_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        notes: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        productType: Json_decode_bs/* field */.EP("product_type", Json_decode_bs/* string */.Z_, json),
        cardLabel: Json_decode_bs/* field */.EP("card_label", Json_decode_bs/* string */.Z_, json),
        cardPin: Json_decode_bs/* field */.EP("card_pin", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        cardId: Json_decode_bs/* field */.EP("card_id", Json_decode_bs/* string */.Z_, json),
        number: Json_decode_bs/* field */.EP("number", Json_decode_bs/* string */.Z_, json),
        barcodeNumber: Json_decode_bs/* field */.EP("barcode_number", Json_decode_bs/* string */.Z_, json),
        barcodeLabel: Json_decode_bs/* field */.EP("barcode_label", Json_decode_bs/* string */.Z_, json),
        instoreNumber: Json_decode_bs/* field */.EP("instore_number", Json_decode_bs/* string */.Z_, json),
        onlineNumber: Json_decode_bs/* field */.EP("online_number", Json_decode_bs/* string */.Z_, json),
        pin: Json_decode_bs/* field */.EP("pin", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        pinFieldName: Json_decode_bs/* field */.EP("pin_field_name", Json_decode_bs/* string */.Z_, json),
        cardBarcodeFormat: Json_decode_bs/* field */.EP("card_barcode_format", Json_decode_bs/* string */.Z_, json),
        cardLogo: Json_decode_bs/* field */.EP("card_logo", Json_decode_bs/* string */.Z_, json),
        merchantTerms: Json_decode_bs/* field */.EP("merchant_terms", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        subtype: Json_decode_bs/* field */.EP("subtype", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        updatedAt: Json_decode_bs/* field */.EP("updated_at", Json_decode_bs/* string */.Z_, json),
        activatedAt: Json_decode_bs/* field */.EP("activated_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        createdAt: Json_decode_bs/* field */.EP("created_at", Json_decode_bs/* string */.Z_, json),
        receivedAt: Json_decode_bs/* field */.EP("received_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        gift: Json_decode_bs/* field */.EP("gift", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        isSwapCard: Json_decode_bs/* field */.EP("is_swap_card", Json_decode_bs/* bool */.Xg, json),
        isSchemeCard: Json_decode_bs/* field */.EP("is_scheme_card", Json_decode_bs/* bool */.Xg, json),
        swapCard: Json_decode_bs/* field */.EP("swap_card", Json_decode_bs/* bool */.Xg, json),
        donation: Json_decode_bs/* field */.EP("donation", Json_decode_bs/* bool */.Xg, json),
        supportsRegift: Json_decode_bs/* field */.EP("supports_regift", Json_decode_bs/* bool */.Xg, json),
        supportsBalanceCheck: Json_decode_bs/* field */.EP("supports_balance_check", Json_decode_bs/* bool */.Xg, json),
        supportsAppleWalletExport: Json_decode_bs/* field */.EP("supports_apple_wallet_export", Json_decode_bs/* bool */.Xg, json),
        supportsGoogleWalletExport: Json_decode_bs/* field */.EP("supports_google_wallet_export", Json_decode_bs/* bool */.Xg, json),
        receiptText: Json_decode_bs/* field */.EP("receipt_text", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        receiptLogoTop: Json_decode_bs/* field */.EP("receipt_logo_top", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        redemptionUrl: Json_decode_bs/* field */.EP("redemption_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        balanceCheckUrl: Json_decode_bs/* field */.EP("balance_check_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        howToUse: Json_decode_bs/* field */.EP("how_to_use", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        skuDisplayName: Json_decode_bs/* field */.EP("sku_display_name", Json_decode_bs/* string */.Z_, json),
        skuUid: Json_decode_bs/* field */.EP("sku_uid", Json_decode_bs/* string */.Z_, json),
        pdfUrl: Json_decode_bs/* field */.EP("pdf_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultProductCode: Json_decode_bs/* field */.EP("default_product_code", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultProductThemeCode: Json_decode_bs/* field */.EP("default_product_theme_code", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultSkuUid: Json_decode_bs/* field */.EP("default_sku_uid", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function theme(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        thumbImage: Json_decode_bs/* field */.EP("thumb_image", Json_decode_bs/* string */.Z_, json),
        squareIcon: Json_decode_bs/* field */.EP("square_icon", Json_decode_bs/* string */.Z_, json),
        textureImage: Json_decode_bs/* field */.EP("texture_image", Json_decode_bs/* string */.Z_, json),
        keyColour: Json_decode_bs/* field */.EP("key_colour", Json_decode_bs/* string */.Z_, json),
        textColour: Json_decode_bs/* field */.EP("text_colour", Json_decode_bs/* string */.Z_, json)
    };
}
function providerDetails(json) {
    return {
        videoId: Json_decode_bs/* field */.EP("video_id", Json_decode_bs/* string */.Z_, json),
        accountId: Json_decode_bs/* field */.EP("account_id", Json_decode_bs/* string */.Z_, json),
        playerId: Json_decode_bs/* field */.EP("player_id", Json_decode_bs/* string */.Z_, json)
    };
}
function media(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        mediaType: Json_decode_bs/* field */.EP("media_type", Json_decode_bs/* string */.Z_, json),
        provider: Json_decode_bs/* field */.EP("provider", Json_decode_bs/* string */.Z_, json),
        providerDetails: Json_decode_bs/* field */.EP("provider_details", providerDetails, json)
    };
}
function historyCard(json) {
    return {
        uid: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, param);
        }, json),
        cardLabel: Json_decode_bs/* field */.EP("card_label", Json_decode_bs/* string */.Z_, json),
        themeImage: Json_decode_bs/* field */.EP("theme_image", Json_decode_bs/* string */.Z_, json),
        balance: Json_decode_bs/* field */.EP("balance", Json_decode_bs/* string */.Z_, json),
        balanceCurrency: Json_decode_bs/* field */.EP("balance_currency", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        originalBalance: Json_decode_bs/* field */.EP("original_balance", Json_decode_bs/* string */.Z_, json),
        originalBalanceCurrency: Json_decode_bs/* field */.EP("original_balance_currency", Json_decode_bs/* string */.Z_, json)
    };
}
function historyGift(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        card: Json_decode_bs/* field */.EP("card", historyCard, json),
        theme: Json_decode_bs/* field */.EP("theme", theme, json)
    };
}
function skuTheme(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        code: Json_decode_bs/* field */.EP("code", Json_decode_bs/* string */.Z_, json),
        image: Json_decode_bs/* field */.EP("image", Json_decode_bs/* string */.Z_, json),
        keyColour: Json_decode_bs/* field */.EP("key_colour", Json_decode_bs/* string */.Z_, json),
        textColour: Json_decode_bs/* field */.EP("text_colour", Json_decode_bs/* string */.Z_, json)
    };
}
function failedCard(json) {
    return {
        orderNumber: Json_decode_bs/* field */.EP("order_number", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        skuTheme: Json_decode_bs/* field */.EP("sku_theme", skuTheme, json),
        skuDisplayName: Json_decode_bs/* field */.EP("sku_display_name", Json_decode_bs/* string */.Z_, json),
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json)
    };
}
function giftData(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        regifted: Json_decode_bs/* field */.EP("regifted", Json_decode_bs/* bool */.Xg, json),
        message: Json_decode_bs/* field */.EP("message", Json_decode_bs/* string */.Z_, json),
        recipientName: Json_decode_bs/* field */.EP("recipient_name", Json_decode_bs/* string */.Z_, json),
        recipientEmail: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("recipient_email", Json_decode_bs/* string */.Z_, param);
        }, json),
        senderName: Json_decode_bs/* field */.EP("sender_name", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        senderEmail: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("sender_email", Json_decode_bs/* string */.Z_, param);
        }, json),
        senderType: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("sender_type", Json_decode_bs/* string */.Z_, param);
        }, json),
        senderLogoUrl: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("sender_logo_url", Json_decode_bs/* string */.Z_, param);
        }, json),
        card: Json_decode_bs/* field */.EP("card", card, json),
        theme: Json_decode_bs/* field */.EP("theme", theme, json),
        media: Json_decode_bs/* field */.EP("media", function(param) {
            return Json_decode_bs/* array */.IX(media, param);
        }, json),
        exchangeHistory: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("exchange_history", function(param) {
                return Json_decode_bs/* array */.IX(historyGift, param);
            }, param);
        }, json),
        exchangeHistoryFailure: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("exchange_history_failure", function(param) {
                return Json_decode_bs/* array */.IX(failedCard, param);
            }, param);
        }, json),
        giphyId: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("giphy_id", Json_decode_bs/* string */.Z_, param);
        }, json),
        giphyUrl: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("giphy_url", Json_decode_bs/* string */.Z_, param);
        }, json),
        canAddToWallet: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("can_add_to_wallet", Json_decode_bs/* bool */.Xg, param);
        }, json),
        unwrappedAt: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("unwrapped_at", Json_decode_bs/* string */.Z_, param);
        }, json),
        unwrappingAuthFlowV2: Json_decode_bs/* field */.EP("unwrapping_auth_flow_v2", Json_decode_bs/* bool */.Xg, json),
        relatedGiftingOccasions: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("related_gifting_occasions", function(param) {
                return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
            }, param);
        }, json),
        pinStatus: Json_decode_bs/* field */.EP("pin_status", Json_decode_bs/* string */.Z_, json),
        forcedSignIn: Json_decode_bs/* field */.EP("forced_sign_in", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeGiftData(json) {
    var result;
    try {
        result = giftData(json);
    } catch (raw_e) {
        var e = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e._1,
                type: "Safe Decode Gift Data"
            }, "error: Could not decode response from the server");
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var GiftData_bs_Decode = {
    card: card,
    theme: theme,
    providerDetails: providerDetails,
    media: media,
    historyCard: historyCard,
    historyGift: historyGift,
    skuTheme: skuTheme,
    failedCard: failedCard,
    giftData: giftData,
    safeDecodeGiftData: safeDecodeGiftData
};
 /* Pino Not a pure module */ 

// EXTERNAL MODULE: ./src/api/ApiErrors.bs.js
var ApiErrors_bs = __webpack_require__(44054);
;// CONCATENATED MODULE: ./src/api/Data/TermsData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function terms(json) {
    return {
        title: Json_decode_bs/* field */.EP("title", Json_decode_bs/* string */.Z_, json),
        html_title: Json_decode_bs/* field */.EP("html_title", Json_decode_bs/* string */.Z_, json),
        meta_description: Json_decode_bs/* field */.EP("meta_description", Json_decode_bs/* string */.Z_, json),
        content: Json_decode_bs/* field */.EP("content", Json_decode_bs/* string */.Z_, json)
    };
}
var TermsData_bs_Decode = {
    terms: terms
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/WebConfig.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function config(json) {
    return {
        featureStripeBillingAddress: Json_decode_bs/* field */.EP("feature_stripe_billing_address", Json_decode_bs/* bool */.Xg, json),
        featureBraintreePaymentOptionGuest: Json_decode_bs/* field */.EP("feature_braintree_payment_option_guest", Json_decode_bs/* bool */.Xg, json),
        featureBraintreePaymentOptionUser: Json_decode_bs/* field */.EP("feature_braintree_payment_option_member", Json_decode_bs/* bool */.Xg, json),
        featureGuestCheckout: Json_decode_bs/* withDefault */.Wc(false, function(param) {
            return Json_decode_bs/* field */.EP("feature_guest_checkout_web", Json_decode_bs/* bool */.Xg, param);
        }, json),
        senderAliases: Json_decode_bs/* field */.EP("gift_sender_aliases", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json),
        featureLayer: Json_decode_bs/* withDefault */.Wc(false, function(param) {
            return Json_decode_bs/* field */.EP("feature_layer", Json_decode_bs/* bool */.Xg, param);
        }, json),
        featureLayerForClassic: Json_decode_bs/* withDefault */.Wc(false, function(param) {
            return Json_decode_bs/* field */.EP("feature_layer_for_classic", Json_decode_bs/* bool */.Xg, param);
        }, json),
        featureEmailTypoDetection: Json_decode_bs/* field */.EP("feature_email_typo_detection", Json_decode_bs/* bool */.Xg, json)
    };
}
function safeDecodeWebConfig(json) {
    var value;
    try {
        value = config(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var WebConfig_bs_Decode = {
    config: config,
    safeDecodeWebConfig: safeDecodeWebConfig
};
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/api/Data/CustomerData.bs.js
var CustomerData_bs = __webpack_require__(65496);
;// CONCATENATED MODULE: ./src/api/Data/HomePageData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function banner(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        name: Json_decode_bs/* field */.EP("name", Json_decode_bs/* string */.Z_, json),
        url: Json_decode_bs/* field */.EP("url", Json_decode_bs/* string */.Z_, json),
        text: Json_decode_bs/* field */.EP("text", Json_decode_bs/* string */.Z_, json),
        textColour: Json_decode_bs/* field */.EP("text_colour", Json_decode_bs/* string */.Z_, json),
        backgroundColour: Json_decode_bs/* field */.EP("background_colour", Json_decode_bs/* string */.Z_, json),
        buttonText: Json_decode_bs/* field */.EP("button_text", Json_decode_bs/* string */.Z_, json),
        prefixText: Json_decode_bs/* field */.EP("prefix_text", Json_decode_bs/* string */.Z_, json),
        fontawesomeIconClass: Json_decode_bs/* field */.EP("fontawesome_icon_class", Json_decode_bs/* string */.Z_, json)
    };
}
function slide(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        name: Json_decode_bs/* field */.EP("name", Json_decode_bs/* string */.Z_, json),
        buttonBackgroundColour: Json_decode_bs/* field */.EP("button_background_colour", Json_decode_bs/* string */.Z_, json),
        buttonBorderColour: Json_decode_bs/* field */.EP("button_border_colour", Json_decode_bs/* string */.Z_, json),
        buttonTextColour: Json_decode_bs/* field */.EP("button_text_colour", Json_decode_bs/* string */.Z_, json),
        buttonBackgroundColourHover: Json_decode_bs/* field */.EP("button_background_colour_hover", Json_decode_bs/* string */.Z_, json),
        buttonBorderColourHover: Json_decode_bs/* field */.EP("button_border_colour_hover", Json_decode_bs/* string */.Z_, json),
        buttonTextColourHover: Json_decode_bs/* field */.EP("button_text_colour_hover", Json_decode_bs/* string */.Z_, json),
        backgroundImage: Json_decode_bs/* field */.EP("background_image", Json_decode_bs/* string */.Z_, json),
        leftImage: Json_decode_bs/* field */.EP("left_image", Json_decode_bs/* string */.Z_, json),
        centeredImage: Json_decode_bs/* field */.EP("centered_image", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        titleColour: Json_decode_bs/* field */.EP("title_colour", Json_decode_bs/* string */.Z_, json),
        titleShadowColour: Json_decode_bs/* field */.EP("title_shadow_colour", Json_decode_bs/* string */.Z_, json),
        enableTitleShadow: Json_decode_bs/* field */.EP("enable_title_shadow", Json_decode_bs/* bool */.Xg, json),
        title: Json_decode_bs/* field */.EP("title", Json_decode_bs/* string */.Z_, json),
        subtitle: Json_decode_bs/* field */.EP("subtitle", Json_decode_bs/* string */.Z_, json),
        subtitleColour: Json_decode_bs/* field */.EP("subtitle_colour", Json_decode_bs/* string */.Z_, json),
        buttonVimeoVideoId: Json_decode_bs/* field */.EP("button_vimeo_video_id", Json_decode_bs/* string */.Z_, json),
        buttonShowVideoPopup: Json_decode_bs/* field */.EP("button_show_video_popup", Json_decode_bs/* bool */.Xg, json),
        buttonUrl: Json_decode_bs/* field */.EP("button_url", Json_decode_bs/* string */.Z_, json),
        buttonLabel: Json_decode_bs/* field */.EP("button_label", Json_decode_bs/* string */.Z_, json)
    };
}
function homepage(json) {
    return {
        banner: Json_decode_bs/* field */.EP("banner", function(param) {
            return Json_decode_bs/* nullable */.AG(banner, param);
        }, json),
        slides: Json_decode_bs/* field */.EP("slides", function(param) {
            return Json_decode_bs/* array */.IX(slide, param);
        }, json)
    };
}
function safeDecodeHomepageData(json) {
    var homepage$1;
    try {
        homepage$1 = homepage(json);
    } catch (raw_e) {
        var e = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e._1,
                type: "Safe Decode Homepage Data"
            }, "error: Could not decode response from the server");
            return;
        }
        throw e;
    }
    return homepage$1;
}
var HomePageData_bs_Decode = {
    banner: banner,
    slide: slide,
    homepage: homepage,
    safeDecodeHomepageData: safeDecodeHomepageData
};
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/Data/GiftThemeData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function giftTheme(json) {
    return {
        title: Json_decode_bs/* field */.EP("title", Json_decode_bs/* string */.Z_, json),
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        thumbImage: Json_decode_bs/* field */.EP("thumb_image", Json_decode_bs/* string */.Z_, json),
        squareIcon: Json_decode_bs/* field */.EP("square_icon", Json_decode_bs/* string */.Z_, json),
        textureImage: Json_decode_bs/* field */.EP("texture_image", Json_decode_bs/* string */.Z_, json),
        keyColour: Json_decode_bs/* field */.EP("key_colour", Json_decode_bs/* string */.Z_, json)
    };
}
function giftThemes(json) {
    return {
        giftThemes: Json_decode_bs/* field */.EP("giftthemes", function(param) {
            return Json_decode_bs/* array */.IX(giftTheme, param);
        }, json)
    };
}
function GiftThemeData_bs_safeDecodeGiftData(json) {
    var result;
    try {
        result = giftThemes(json);
    } catch (raw_e) {
        var e = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e._1,
                type: "Safe Decode Gift Themes Data"
            }, "error: Could not decode response from the server");
            return;
        }
        throw e;
    }
    return result;
}
var GiftThemeData_bs_Decode = {
    giftTheme: giftTheme,
    giftThemes: giftThemes,
    safeDecodeGiftData: GiftThemeData_bs_safeDecodeGiftData
};
 /* Pino Not a pure module */ 

// EXTERNAL MODULE: ./src/api/Data/InventoryData.bs.js
var InventoryData_bs = __webpack_require__(21005);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_List.js
var belt_List = __webpack_require__(84462);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_encode.bs.js
var Json_encode_bs = __webpack_require__(64221);
;// CONCATENATED MODULE: ./src/models/PaymentModels.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function checkout(l) {
    var schedule = belt_Option/* mapWithDefault */.k7(l.scheduledDeliveryAt, /* [] */ 0, function(schedule) {
        return {
            hd: [
                "scheduled_delivery_at",
                schedule
            ],
            tl: /* [] */ 0
        };
    });
    var giftMedia = belt_Option/* mapWithDefault */.k7(l.giftMediaUid, /* [] */ 0, function(schedule) {
        return {
            hd: [
                "giftmedia_uid",
                schedule
            ],
            tl: /* [] */ 0
        };
    });
    return Json_encode_bs/* object_ */.GN(belt_List/* concat */.zo(belt_List/* concat */.zo({
        hd: [
            "value",
            l.value
        ],
        tl: {
            hd: [
                "sender_alias",
                Json_encode_bs/* nullable */.AG(function(prim) {
                    return prim;
                }, l.senderAlias)
            ],
            tl: {
                hd: [
                    "sku_uid",
                    l.skuUid
                ],
                tl: {
                    hd: [
                        "promo_code",
                        l.promoCode
                    ],
                    tl: {
                        hd: [
                            "theme_uid",
                            l.themeUid
                        ],
                        tl: {
                            hd: [
                                "gifttheme_uid",
                                l.giftthemeUid
                            ],
                            tl: {
                                hd: [
                                    "name",
                                    l.name
                                ],
                                tl: {
                                    hd: [
                                        "email",
                                        Json_encode_bs/* nullable */.AG(function(prim) {
                                            return prim;
                                        }, l.email)
                                    ],
                                    tl: {
                                        hd: [
                                            "phone",
                                            Json_encode_bs/* nullable */.AG(function(prim) {
                                                return prim;
                                            }, l.phone)
                                        ],
                                        tl: {
                                            hd: [
                                                "message",
                                                l.message
                                            ],
                                            tl: {
                                                hd: [
                                                    "guest_first_name",
                                                    l.guestFirstName
                                                ],
                                                tl: {
                                                    hd: [
                                                        "guest_last_name",
                                                        l.guestLastName
                                                    ],
                                                    tl: {
                                                        hd: [
                                                            "guest_email",
                                                            l.guestEmail
                                                        ],
                                                        tl: {
                                                            hd: [
                                                                "type",
                                                                l.guestType
                                                            ],
                                                            tl: {
                                                                hd: [
                                                                    "status",
                                                                    l.status
                                                                ],
                                                                tl: {
                                                                    hd: [
                                                                        "recipient_timezone",
                                                                        Json_encode_bs/* nullable */.AG(function(prim) {
                                                                            return prim;
                                                                        }, l.recipientTimezone)
                                                                    ],
                                                                    tl: /* [] */ 0
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, schedule), giftMedia));
}
var Encode = {
    checkout: checkout
};
var ForAFriend = {
    Encode: Encode
};
function checkout$1(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "value",
            l.value
        ],
        tl: {
            hd: [
                "sku_uid",
                l.skuUid
            ],
            tl: {
                hd: [
                    "promo_code",
                    l.promoCode
                ],
                tl: {
                    hd: [
                        "theme_uid",
                        l.themeUid
                    ],
                    tl: {
                        hd: [
                            "gifttheme_uid",
                            l.giftthemeUid
                        ],
                        tl: {
                            hd: [
                                "guest_first_name",
                                l.guestFirstName
                            ],
                            tl: {
                                hd: [
                                    "guest_last_name",
                                    l.guestLastName
                                ],
                                tl: {
                                    hd: [
                                        "guest_email",
                                        l.guestEmail
                                    ],
                                    tl: {
                                        hd: [
                                            "type",
                                            l.guestType
                                        ],
                                        tl: {
                                            hd: [
                                                "status",
                                                l.status
                                            ],
                                            tl: /* [] */ 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    });
}
var Encode$1 = {
    checkout: checkout$1
};
var ForSelf = {
    Encode: Encode$1
};
var GuestCheckout = {
    ForAFriend: ForAFriend,
    ForSelf: ForSelf
};
function checkout$2(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "sku_uid",
            l.skuUid
        ],
        tl: {
            hd: [
                "promo_code",
                l.promoCode
            ],
            tl: {
                hd: [
                    "theme_uid",
                    l.themeUid
                ],
                tl: {
                    hd: [
                        "value",
                        l.value
                    ],
                    tl: {
                        hd: [
                            "status",
                            l.status
                        ],
                        tl: {
                            hd: [
                                "device_id",
                                l.deviceId
                            ],
                            tl: {
                                hd: [
                                    "status",
                                    l.status
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    });
}
var Encode$2 = {
    checkout: checkout$2
};
var ForSelf$1 = {
    Encode: Encode$2
};
function checkout$3(l) {
    var schedule = belt_Option/* mapWithDefault */.k7(l.scheduledDeliveryAt, /* [] */ 0, function(schedule) {
        return {
            hd: [
                "scheduled_delivery_at",
                schedule
            ],
            tl: /* [] */ 0
        };
    });
    var giftMedia = belt_Option/* mapWithDefault */.k7(l.giftMediaUid, /* [] */ 0, function(schedule) {
        return {
            hd: [
                "giftmedia_uid",
                schedule
            ],
            tl: /* [] */ 0
        };
    });
    return Json_encode_bs/* object_ */.GN(belt_List/* concat */.zo(belt_List/* concat */.zo({
        hd: [
            "email",
            Json_encode_bs/* nullable */.AG(function(prim) {
                return prim;
            }, l.email)
        ],
        tl: {
            hd: [
                "gifttheme_uid",
                l.giftThemeUid
            ],
            tl: {
                hd: [
                    "message",
                    l.message
                ],
                tl: {
                    hd: [
                        "sender_alias",
                        Json_encode_bs/* nullable */.AG(function(prim) {
                            return prim;
                        }, l.senderAlias)
                    ],
                    tl: {
                        hd: [
                            "name",
                            l.name
                        ],
                        tl: {
                            hd: [
                                "sku_uid",
                                l.skuUid
                            ],
                            tl: {
                                hd: [
                                    "promo_code",
                                    l.promoCode
                                ],
                                tl: {
                                    hd: [
                                        "theme_uid",
                                        l.themeUid
                                    ],
                                    tl: {
                                        hd: [
                                            "value",
                                            l.value
                                        ],
                                        tl: {
                                            hd: [
                                                "phone",
                                                Json_encode_bs/* nullable */.AG(function(prim) {
                                                    return prim;
                                                }, l.phone)
                                            ],
                                            tl: {
                                                hd: [
                                                    "status",
                                                    l.status
                                                ],
                                                tl: {
                                                    hd: [
                                                        "device_id",
                                                        l.deviceId
                                                    ],
                                                    tl: {
                                                        hd: [
                                                            "recipient_timezone",
                                                            Json_encode_bs/* nullable */.AG(function(prim) {
                                                                return prim;
                                                            }, l.recipientTimezone)
                                                        ],
                                                        tl: /* [] */ 0
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }, schedule), giftMedia));
}
var Encode$3 = {
    checkout: checkout$3
};
var ForAFriend$1 = {
    Encode: Encode$3
};
var UserCheckout = {
    ForSelf: ForSelf$1,
    ForAFriend: ForAFriend$1
};
function response(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        regifted: Json_decode_bs/* field */.EP("regifted", Json_decode_bs/* bool */.Xg, json),
        message: Json_decode_bs/* field */.EP("message", Json_decode_bs/* string */.Z_, json),
        recipientName: Json_decode_bs/* field */.EP("recipient_name", Json_decode_bs/* string */.Z_, json),
        recipientEmail: Json_decode_bs/* field */.EP("recipient_email", Json_decode_bs/* string */.Z_, json),
        senderName: Json_decode_bs/* field */.EP("sender_name", Json_decode_bs/* string */.Z_, json),
        senderEmail: Json_decode_bs/* field */.EP("sender_email", Json_decode_bs/* string */.Z_, json),
        orderNumber: Json_decode_bs/* field */.EP("order_number", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeResponse(json) {
    var result;
    try {
        result = response(json);
    } catch (raw_e) {
        var e = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e._1,
                type: "Payment Model"
            }, "error: Could not decode error from the server");
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var PaymentModels_bs_Decode = {
    response: response,
    safeDecodeResponse: safeDecodeResponse
};
var $$Response = {
    Decode: PaymentModels_bs_Decode
};
function paymentOptions(json) {
    return {
        stripe: Json_decode_bs/* field */.EP("stripe", Json_decode_bs/* string */.Z_, json),
        braintree: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("braintree", Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function draftOrderResponse(json) {
    return {
        order: Json_decode_bs/* field */.EP("order", Json_decode_bs/* string */.Z_, json),
        total: Json_decode_bs/* field */.EP("total", Json_decode_bs/* string */.Z_, json),
        orderNumber: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("order_number", Json_decode_bs/* string */.Z_, param);
        }, json),
        totalCurrency: Json_decode_bs/* field */.EP("total_currency", Json_decode_bs/* string */.Z_, json),
        paymentOptions: Json_decode_bs/* field */.EP("payment_options", paymentOptions, json),
        collectBillingAddress: Json_decode_bs/* field */.EP("feature_stripe_billing_address", Json_decode_bs/* bool */.Xg, json)
    };
}
function safeDecodeDraftOrderResponse(json) {
    var result;
    try {
        result = draftOrderResponse(json);
    } catch (raw_e) {
        var e = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e._1
            }, "error: could not decode Draft Order Response");
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode$1 = {
    paymentOptions: paymentOptions,
    draftOrderResponse: draftOrderResponse,
    safeDecodeDraftOrderResponse: safeDecodeDraftOrderResponse
};
var DraftOrderResponse = {
    Decode: Decode$1
};
function paymentIntentRequest(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "total",
            l.total
        ],
        tl: {
            hd: [
                "total_currency",
                l.totalCurrency
            ],
            tl: {
                hd: [
                    "payment_method",
                    l.paymentMethod
                ],
                tl: {
                    hd: [
                        "device_id",
                        l.deviceId
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    });
}
function paymentIntentBraintreeRequest(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "total",
            l.total
        ],
        tl: {
            hd: [
                "total_currency",
                l.totalCurrency
            ],
            tl: {
                hd: [
                    "payment_method_type",
                    "nonce"
                ],
                tl: {
                    hd: [
                        "payment_method",
                        l.paymentMethod
                    ],
                    tl: {
                        hd: [
                            "device_id",
                            l.deviceId
                        ],
                        tl: /* [] */ 0
                    }
                }
            }
        }
    });
}
var Encode$4 = {
    paymentIntentRequest: paymentIntentRequest,
    paymentIntentBraintreeRequest: paymentIntentBraintreeRequest
};
var PaymentIntentRequest = {
    Encode: Encode$4
};
function paymentIntentResponse(json) {
    return {
        stripeClientSecret: Json_decode_bs/* field */.EP("stripe_client_secret", Json_decode_bs/* string */.Z_, json),
        stripePaymentIntent: Json_decode_bs/* field */.EP("stripe_payment_intent", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodePaymentIntentResponse(json) {
    var result;
    try {
        result = paymentIntentResponse(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode$2 = {
    paymentIntentResponse: paymentIntentResponse,
    safeDecodePaymentIntentResponse: safeDecodePaymentIntentResponse
};
var PaymentIntentResponse = {
    Decode: Decode$2
};
function finalisePaymentRequest(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "status",
            l.status
        ],
        tl: {
            hd: [
                "payment-method-nonce",
                l.paymentMethodNonce
            ],
            tl: /* [] */ 0
        }
    });
}
var Encode$5 = {
    finalisePaymentRequest: finalisePaymentRequest
};
var FinalisePaymentRequest = {
    Encode: Encode$5
};
function order(json) {
    return {
        orderNumber: Json_decode_bs/* field */.EP("order_number", Json_decode_bs/* string */.Z_, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeOrder(json) {
    var result;
    try {
        result = order(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode$3 = {
    order: order,
    safeDecodeOrder: safeDecodeOrder
};
var Order = {
    Decode: Decode$3
};
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/Data/PromoCodeData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function discount(json) {
    return {
        name: Json_decode_bs/* field */.EP("name", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json)
    };
}
function bonusCardtheme(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        image: Json_decode_bs/* field */.EP("image", Json_decode_bs/* string */.Z_, json),
        code: Json_decode_bs/* field */.EP("code", Json_decode_bs/* string */.Z_, json),
        keyColour: Json_decode_bs/* field */.EP("key_colour", Json_decode_bs/* string */.Z_, json),
        textColour: Json_decode_bs/* field */.EP("text_colour", Json_decode_bs/* string */.Z_, json)
    };
}
function bonusCard(json) {
    return {
        name: Json_decode_bs/* field */.EP("name", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        theme: Json_decode_bs/* field */.EP("theme", function(param) {
            return Json_decode_bs/* optional */.jt(bonusCardtheme, param);
        }, json)
    };
}
function promoCodeData(json) {
    return {
        skuUID: Json_decode_bs/* field */.EP("sku_uid", Json_decode_bs/* string */.Z_, json),
        denomination: Json_decode_bs/* field */.EP("denomination", Json_decode_bs/* string */.Z_, json),
        denominationCurrency: Json_decode_bs/* field */.EP("denomination_currency", Json_decode_bs/* string */.Z_, json),
        promoCode: Json_decode_bs/* field */.EP("promo_code", Json_decode_bs/* string */.Z_, json),
        discounts: Json_decode_bs/* field */.EP("discounts", function(param) {
            return Json_decode_bs/* nullable */.AG(function(param) {
                return Json_decode_bs/* array */.IX(discount, param);
            }, param);
        }, json),
        bonusCards: Json_decode_bs/* field */.EP("bonus_cards", function(param) {
            return Json_decode_bs/* nullable */.AG(function(param) {
                return Json_decode_bs/* array */.IX(bonusCard, param);
            }, param);
        }, json),
        totalPrice: Json_decode_bs/* field */.EP("total_price", Json_decode_bs/* string */.Z_, json),
        totalPriceCurrency: Json_decode_bs/* field */.EP("total_price_currency", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodePromoCodeData(json) {
    var result;
    try {
        result = promoCodeData(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var PromoCodeData_bs_Decode = {
    discount: discount,
    bonusCardtheme: bonusCardtheme,
    bonusCard: bonusCard,
    promoCodeData: promoCodeData,
    safeDecodePromoCodeData: safeDecodePromoCodeData
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/SayThanksData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function t(json) {
    return {
        senderName: Json_decode_bs/* field */.EP("sender_name", Json_decode_bs/* string */.Z_, json),
        amount: Json_decode_bs/* field */.EP("amount", Json_decode_bs/* string */.Z_, json),
        currency: Json_decode_bs/* field */.EP("currency", Json_decode_bs/* string */.Z_, json),
        sku: Json_decode_bs/* field */.EP("sku", Json_decode_bs/* string */.Z_, json),
        thanksGivenAt: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("thanks_given_at", Json_decode_bs/* string */.Z_, param);
        }, json),
        thanksMessage: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("thanks_message", Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function safeDecodeSayThanksData(json) {
    var result;
    try {
        result = t(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var SayThanksData_bs_Decode = {
    t: t,
    safeDecodeSayThanksData: safeDecodeSayThanksData
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/Data/CategoriesData.bs.js
var CategoriesData_bs = __webpack_require__(38060);
;// CONCATENATED MODULE: ./src/api/Data/ContactErrorData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function detail(json) {
    return {
        email: util_bs/* JsonUtil.optionalField */.pH.optionalField("email", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json),
        enquiryType: util_bs/* JsonUtil.optionalField */.pH.optionalField("enquiry_type", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json),
        message: util_bs/* JsonUtil.optionalField */.pH.optionalField("message", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json),
        name: util_bs/* JsonUtil.optionalField */.pH.optionalField("full_name", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json),
        phoneNumber: util_bs/* JsonUtil.optionalField */.pH.optionalField("phone_number", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function error(json) {
    return {
        code: Json_decode_bs/* field */.EP("code", Json_decode_bs/* string */.Z_, json),
        detail: Json_decode_bs/* field */.EP("detail", detail, json)
    };
}
function contactError(json) {
    return {
        error: Json_decode_bs/* field */.EP("error", error, json)
    };
}
function safeDecodeContactError(json) {
    var e;
    try {
        e = contactError(json);
    } catch (raw_e) {
        var e$1 = caml_js_exceptions/* internalToOCamlException */.UW(raw_e);
        if (e$1.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            Pino_bs/* logger.error */.k.error({
                err: e$1._1,
                type: "Safe Decode Contact"
            }, "error: Could not decode error from the server");
            return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* JsonParsingError */ 1,
                    _0: "Could not decode error from the server."
                }
            };
        }
        throw e$1;
    }
    Pino_bs/* logger.error */.k.error({
        err: e,
        type: "Safe Decode Contact"
    }, "error: Could not decode response from the server");
    return {
        TAG: /* Error */ 1,
        _0: {
            TAG: /* ServerError */ 2,
            _0: {
                TAG: /* ServerContactValidationError */ 1,
                _0: e.error.detail
            }
        }
    };
}
var ContactErrorData_bs_Decode = {
    detail: detail,
    error: error,
    contactError: contactError,
    safeDecodeContactError: safeDecodeContactError
};
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/Data/SecurityCodeData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function securityCode(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "email",
            l.email
        ],
        tl: {
            hd: [
                "phone",
                l.phoneNumber
            ],
            tl: /* [] */ 0
        }
    });
}
var SecurityCodeData_bs_Encode = {
    securityCode: securityCode
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/ResetPasswordData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function toRequestPayload(d) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "reset_token",
            d.token
        ],
        tl: {
            hd: [
                "new_password",
                d.password
            ],
            tl: /* [] */ 0
        }
    });
}
var ResetPasswordData_bs_Encode = {
    toRequestPayload: toRequestPayload
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/PromotionTermsData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function promotionResult(json) {
    return {
        title: Json_decode_bs/* field */.EP("title", Json_decode_bs/* string */.Z_, json),
        slug: Json_decode_bs/* field */.EP("slug", Json_decode_bs/* string */.Z_, json),
        category: Json_decode_bs/* field */.EP("type", Json_decode_bs/* string */.Z_, json)
    };
}
function promotionTerms(json) {
    return {
        results: Json_decode_bs/* field */.EP("results", function(param) {
            return Json_decode_bs/* array */.IX(promotionResult, param);
        }, json)
    };
}
function singlePromotionTerm(json) {
    return {
        title: Json_decode_bs/* field */.EP("title", Json_decode_bs/* string */.Z_, json),
        htmlTitle: Json_decode_bs/* field */.EP("html_title", Json_decode_bs/* string */.Z_, json),
        metaDescription: Json_decode_bs/* field */.EP("meta_description", Json_decode_bs/* string */.Z_, json),
        content: Json_decode_bs/* field */.EP("content", Json_decode_bs/* string */.Z_, json)
    };
}
var PromotionTermsData_bs_Decode = {
    promotionResult: promotionResult,
    promotionTerms: promotionTerms,
    singlePromotionTerm: singlePromotionTerm
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/SecurityCodeResponseData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function securityCodeResponse(json) {
    return {
        detail: Json_decode_bs/* field */.EP("detail", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeSecurityCodeResponse(json) {
    var response;
    try {
        response = securityCodeResponse(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return {
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ServerError */ 2,
                    _0: {
                        TAG: /* ServerValidationError */ 0,
                        _0: "Invalid security"
                    }
                }
            };
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: response
    };
}
var SecurityCodeResponseData_bs_Decode = {
    securityCodeResponse: securityCodeResponse,
    safeDecodeSecurityCodeResponse: safeDecodeSecurityCodeResponse
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/ValidateCustomerPasswordData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function ValidateCustomerPasswordData_bs_toRequestPayload(d) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "first_name",
            d.firstName
        ],
        tl: {
            hd: [
                "last_name",
                d.lastName
            ],
            tl: {
                hd: [
                    "email",
                    d.email
                ],
                tl: {
                    hd: [
                        "password",
                        d.password
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    });
}
var ValidateCustomerPasswordData_bs_Encode = {
    toRequestPayload: ValidateCustomerPasswordData_bs_toRequestPayload
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/PrezzeePublicClient.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
































function resetPassword(data) {
    var payload = ResetPasswordData_bs_Encode.toRequestPayload(data);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf("api/v3/reset-password/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 200 && n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    var e = ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
                    var tmp;
                    if (e.TAG === /* Ok */ 0) {
                        tmp = e;
                    } else {
                        var match = e._0;
                        switch(match.TAG | 0){
                            case /* NetworkError */ 0:
                            case /* JsonParsingError */ 1:
                                tmp = e;
                                break;
                            case /* ServerError */ 2:
                                var detail = match._0;
                                tmp = typeof detail === "number" || detail.TAG !== /* ServerValidationError */ 0 ? e : {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        TAG: /* ServerError */ 2,
                                        _0: {
                                            TAG: /* ServerValidationError */ 0,
                                            _0: detail._0
                                        }
                                    }
                                };
                                break;
                        }
                    }
                    return Promise.resolve(tmp);
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function validateCustomerPassword(data) {
    var payload = ValidateCustomerPasswordData_bs_Encode.toRequestPayload(data);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/customer/validate-password/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 200 && n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    var e = ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
                    var tmp;
                    if (e.TAG === /* Ok */ 0) {
                        tmp = e;
                    } else {
                        var match = e._0;
                        switch(match.TAG | 0){
                            case /* NetworkError */ 0:
                            case /* JsonParsingError */ 1:
                                tmp = e;
                                break;
                            case /* ServerError */ 2:
                                var detail = match._0;
                                tmp = typeof detail === "number" || detail.TAG !== /* ServerValidationError */ 0 ? e : {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        TAG: /* ServerError */ 2,
                                        _0: {
                                            TAG: /* ServerValidationError */ 0,
                                            _0: detail._0
                                        }
                                    }
                                };
                                break;
                        }
                    }
                    return Promise.resolve(tmp);
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function PrezzeePublicClient_bs_securityCode(securityCodeData) {
    var payload = SecurityCodeData_bs_Encode.securityCode(securityCodeData);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf("api/v3/customer/securitycode/request/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, SecurityCodeResponseData_bs_Decode.safeDecodeSecurityCodeResponse);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function exchangeInventory(cardUid) {
    var route = "api/v3/inventory/" + (cardUid + "/");
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf(route);
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, InventoryData_bs/* Decode.safeDecodeInventory */.f.safeDecodeInventory);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function validatePhoneNumber(phone) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "phone",
            phone
        ],
        tl: /* [] */ 0
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/customer/validate-phone/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, CustomerData_bs/* Decode.safeDecodePhoneValidation */.f.safeDecodePhoneValidation);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function getInventoryForProduct(token) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    return js_promise/* $$catch */.y(function(e) {
        Pino_bs/* logger.error */.k.error({
            err: e,
            source: "Inventory API"
        }, "error: Could not retrieve Inventory for Product");
        return Promise.resolve(undefined);
    }, js_promise/* then_ */.k(function(json) {
        return Promise.resolve(InventoryData_bs/* Decode.safeDecodeInventoryForData */.f.safeDecodeInventoryForData(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/inventory/"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)))));
}
function getSkuBySlug(slug, token) {
    var route = "api/v3/sku/by-slug/" + slug;
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    return js_promise/* $$catch */.y(function(e) {
        Pino_bs/* logger.error */.k.error({
            err: e,
            source: "SKU by Slug API"
        }, "error: Could not retrieve SKU by Slug");
        return Promise.resolve(undefined);
    }, js_promise/* then_ */.k(function(json) {
        return Promise.resolve(InventoryData_bs/* Decode.safeDecodeSku */.f.safeDecodeSku(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf(route), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)))));
}
function getCategories(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, CategoriesData_bs/* Decode.safeDecodeCategoriesData */.f.safeDecodeCategoriesData);
    };
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf("api/v3/categories/"), request, headerlessRequest, callback, false);
}
function getGiftThemes(code, param) {
    var route = code !== undefined ? "api/v3/giftthemes/?sku_code=" + code : "api/v3/giftthemes/";
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    return js_promise/* $$catch */.y(function(e) {
        Pino_bs/* logger.error */.k.error({
            err: e,
            source: "Gift Themes API"
        }, "error: Could not retrieve SKU by Slug Gift Themes failed");
        return Promise.resolve(undefined);
    }, js_promise/* then_ */.k(function(json) {
        return Promise.resolve(GiftThemeData_bs_Decode.safeDecodeGiftData(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf(route), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)))));
}
function openGift(uid, blob, pin) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "pin",
            belt_Option/* getWithDefault */.tj(pin, "")
        ],
        tl: /* [] */ 0
    });
    var route = blob !== undefined ? "api/v3/gift/open/" + (uid + ("/?b=" + blob)) : "api/v3/gift/open/" + (uid + "/");
    var url = Request_bs/* makeUrl */.bf(route);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, GiftData_bs_Decode.safeDecodeGiftData);
    };
    var initReq;
    var exit = 0;
    if (blob !== undefined && pin !== undefined) {
        initReq = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    } else {
        exit = 1;
    }
    if (exit === 1) {
        initReq = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    }
    var headerlessRequest;
    var exit$1 = 0;
    if (blob !== undefined && pin !== undefined) {
        headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    } else {
        exit$1 = 1;
    }
    if (exit$1 === 1) {
        headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    }
    return Request_bs/* makeRequest */.$f(url, initReq, headerlessRequest, callback, true);
}
function openGiftServer(uid) {
    var route = "api/v3/gift/" + (uid + "/say-thanks/");
    var url = Request_bs/* makeUrl */.bf(route);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, SayThanksData_bs_Decode.safeDecodeSayThanksData);
    };
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    return Request_bs/* makeRequest */.$f(url, request, request, callback, true);
}
function claimGift(uid) {
    var route = "api/v3/gift/claim/" + (uid + "/");
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf(route);
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, GiftData_bs_Decode.safeDecodeGiftData);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function validatePromoCode(skuUid, denomination, promoCode, recipientCount) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "sku_uid",
            skuUid
        ],
        tl: {
            hd: [
                "denomination",
                denomination
            ],
            tl: {
                hd: [
                    "promo_code",
                    promoCode
                ],
                tl: {
                    hd: [
                        "item_count",
                        recipientCount
                    ],
                    tl: /* [] */ 0
                }
            }
        }
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/validate-promo-code/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, PromoCodeData_bs_Decode.safeDecodePromoCodeData);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function getWebConfigs(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/config/client/web/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(WebConfig_bs_Decode.safeDecodeWebConfig(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(url, request)));
}
function getHomePageData(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* $$catch */.y(function(e) {
        Pino_bs/* logger.error */.k.error({
            err: e,
            source: "Homepage API"
        }, "error: Could not retrieve Home Page Data");
        return Promise.resolve(undefined);
    }, js_promise/* then_ */.k(function(json) {
        return Promise.resolve(HomePageData_bs_Decode.safeDecodeHomepageData(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/home-page/"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)))));
}
function getTermsOfSale(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(TermsData_bs_Decode.terms(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/articles/by-slug/terms-of-sale/"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
}
function getTermsOfService(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(TermsData_bs_Decode.terms(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/articles/by-slug/terms-of-service/"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
}
function getPromotionTerms(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(PromotionTermsData_bs_Decode.promotionTerms(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/articles/?type=promo-terms&page_size=100"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
}
function getPromotionTermsSingle(slug) {
    var route = "api/v3/articles/by-slug/" + slug;
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(PromotionTermsData_bs_Decode.singlePromotionTerm(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf(route), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
}
function getPrivacyPolicy(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withMagicUserAgentOnServerOnly */.oK.withMagicUserAgentOnServerOnly(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    return js_promise/* then_ */.k(function(json) {
        return Promise.resolve(TermsData_bs_Decode.terms(json));
    }, js_promise/* then_ */.k(Fetch_bs/* $$Response.json */.PX.json, fetch(Request_bs/* makeUrl */.bf("api/v3/articles/by-slug/privacy-policy/"), Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined))));
}
function createDraftOrder(checkout) {
    var route;
    if (typeof checkout === "number") {
        route = "";
    } else {
        switch(checkout.TAG | 0){
            case /* GuestCheckoutSelf */ 0:
            case /* GuestCheckoutFriend */ 1:
                route = "api/v3/gifts-guest/";
                break;
            case /* UserCheckoutSelf */ 2:
                route = "api/v3/cards/";
                break;
            case /* UserCheckoutFriend */ 3:
                route = "api/v3/gifts/";
                break;
        }
    }
    var payload;
    if (typeof checkout === "number") {
        payload = null;
    } else {
        switch(checkout.TAG | 0){
            case /* GuestCheckoutSelf */ 0:
                payload = curry._1(GuestCheckout.ForSelf.Encode.checkout, checkout._0);
                break;
            case /* GuestCheckoutFriend */ 1:
                payload = curry._1(GuestCheckout.ForAFriend.Encode.checkout, checkout._0);
                break;
            case /* UserCheckoutSelf */ 2:
                payload = curry._1(UserCheckout.ForSelf.Encode.checkout, checkout._0);
                break;
            case /* UserCheckoutFriend */ 3:
                payload = curry._1(UserCheckout.ForAFriend.Encode.checkout, checkout._0);
                break;
        }
    }
    var headers;
    var exit = 0;
    if (typeof checkout === "number") {
        exit = 2;
    } else {
        switch(checkout.TAG | 0){
            case /* UserCheckoutSelf */ 2:
            case /* UserCheckoutFriend */ 3:
                exit = 1;
                break;
            default:
                exit = 2;
        }
    }
    switch(exit){
        case 1:
            headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
            break;
        case 2:
            headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
            break;
    }
    var url = Request_bs/* makeUrl */.bf(route);
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, DraftOrderResponse.Decode.safeDecodeDraftOrderResponse);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function getPaymentIntent(url, paymentIntentRequest) {
    var payload = curry._1(PaymentIntentRequest.Encode.paymentIntentRequest, paymentIntentRequest);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, PaymentIntentResponse.Decode.safeDecodePaymentIntentResponse);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function getBraintreePaymentIntent(url, paymentIntentRequest) {
    var payload = curry._1(PaymentIntentRequest.Encode.paymentIntentBraintreeRequest, paymentIntentRequest);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 200 && n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: undefined
            });
        }
    }, fetch(url, request));
}
function finaliseOrder(orderUrl, finalisePaymentRequest) {
    var payload = curry._1(FinalisePaymentRequest.Encode.finalisePaymentRequest, finalisePaymentRequest);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Patch */ 8, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Patch */ 8, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse1 */.ZB(response, Order.Decode.safeDecodeOrder);
    };
    return Request_bs/* makeRequest */.$f(orderUrl, request, headerlessRequest, callback, true);
}
function edmOptIn(email) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "email",
            email
        ],
        tl: /* [] */ 0
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf("api/v3/subscriptions/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        return Promise.resolve({
            TAG: /* Ok */ 0,
            _0: response
        });
    }, fetch(url, request));
}
function subscribe(email, region, subscribe$1, store) {
    var url = "https://consumer-bff.prezzee.co.nz/graphql";
    var payload = NewsletterSubscription.query(email, region, subscribe$1, store, "newsletter_subscriber");
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var parseResult = function parseResult(region, response) {
        if (region === undefined) {
            return {
                TAG: /* Error */ 1,
                _0: response
            };
        }
        var match = region.regionId;
        if (match === "") {
            return {
                TAG: /* Error */ 1,
                _0: response
            };
        } else {
            return {
                TAG: /* Ok */ 0,
                _0: response
            };
        }
    };
    return js_promise/* then_ */.k(function(response) {
        var edmResponse;
        var exit = 0;
        var value;
        try {
            value = curry._1(NewsletterSubscription.Decode.data, response);
            exit = 1;
        } catch (raw_exn) {
            var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
            if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
                edmResponse = undefined;
            } else {
                throw exn;
            }
        }
        if (exit === 1) {
            edmResponse = value;
        }
        if (edmResponse === undefined) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: response
            });
        }
        var regions = edmResponse.data.postNewsletterSubscription.regions;
        var match = "NZ";
        switch(match){
            case "AU":
                return Promise.resolve(parseResult(regions.au, response));
            case "GB":
                return Promise.resolve(parseResult(regions.uk, response));
            case "NZ":
                return Promise.resolve(parseResult(regions.nz, response));
            case "US":
                return Promise.resolve(parseResult(regions.us, response));
            default:
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: response
                });
        }
    }, js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        return Fetch_bs/* $$Response.json */.PX.json(response);
    }, fetch(url, request)));
}
var BFFNewsletter = {
    subscribe: subscribe
};
function contact(name, email, enquiryType, message, phoneNumber) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "full_name",
            name
        ],
        tl: {
            hd: [
                "email",
                email
            ],
            tl: {
                hd: [
                    "enquiry_type",
                    enquiryType
                ],
                tl: {
                    hd: [
                        "message",
                        message
                    ],
                    tl: {
                        hd: [
                            "phone_number",
                            phoneNumber
                        ],
                        tl: /* [] */ 0
                    }
                }
            }
        }
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    return js_promise/* then_ */.k(function(response) {
        var n = response.status;
        if (n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ContactErrorData_bs_Decode.safeDecodeContactError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(Request_bs/* makeUrl */.bf("api/v3/contact/"), Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)));
}
function businessLandingContactForm(payload, route) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    return js_promise/* then_ */.k(function(response) {
        var n = response.status;
        if (n !== 200) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(Request_bs/* makeUrl */.bf(route), request));
}
function uploadTheme(image, imageName, templateUUID) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.acceptContentTypeJson */.oK.acceptContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    if (false) {}
    var formData = new FormData();
    Fetch_bs/* $$FormData.set */.rL.set("uid", templateUUID, formData);
    var blob = util_bs/* FileUtil.convertToBlob */.iK.convertToBlob(image);
    Fetch_bs/* $$FormData.appendBlob */.rL.appendBlob("image", blob, imageName, formData);
    js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response", response, Request_bs/* logger */.kg);
        return Fetch_bs/* $$Response.json */.PX.json(response);
    }, fetch(Request_bs/* makeUrl */.bf("api/v3/designs/"), Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(formData), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)));
}
function sayThanks(uid, message) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "message",
            message
        ],
        tl: /* [] */ 0
    });
    var route = "api/v3/gift/" + uid + "/say-thanks/";
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf(route);
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 200) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function businessContact(fields) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "form_name",
            "contact_me"
        ],
        tl: {
            hd: [
                "fields",
                fields
            ],
            tl: /* [] */ 0
        }
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, undefined, undefined, undefined, undefined, undefined, undefined)(undefined);
    return js_promise/* then_ */.k(function(response) {
        var n = response.status;
        if (n !== 200) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(Request_bs/* makeUrl */.bf("api/v3/hubspot/form/"), request));
}
 /* Pino Not a pure module */ 


/***/ }),

/***/ 86723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ api_client; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/logger.mjs
var logger = __webpack_require__(30819);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/removable.mjs
var removable = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/query.mjs






// CLASS
class Query extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || logger/* defaultLogger */._;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = (0,utils/* replaceData */.oE)(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (!Array.isArray(this.options.queryKey)) {
      if (false) {}
    }

    const abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        var _this$cache$config$on, _this$cache$config;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);

        if (false) {}
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on2, _this$cache$config2;

        if (typeof data === 'undefined') {
          if (false) {}

          onError(new Error('undefined'));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, data, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
            return { ...this.revertState
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}


//# sourceMappingURL=query.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryCache.mjs





// CLASS
class QueryCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  find(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => (0,utils/* matchQuery */._x)(filters, query));
  }

  findAll(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => (0,utils/* matchQuery */._x)(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}


//# sourceMappingURL=queryCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var lib_mutation = __webpack_require__(89886);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationCache.mjs





// CLASS
class MutationCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new lib_mutation/* Mutation */.m({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    const pausedMutations = this.mutations.filter(x => x.state.isPaused);
    return notifyManager/* notifyManager.batch */.V.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(utils/* noop */.ZT)), Promise.resolve()));
  }

}


//# sourceMappingURL=mutationCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineManager = __webpack_require__(96474);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject('Missing queryFn'));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    const nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    const previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }
}


//# sourceMappingURL=infiniteQueryBehavior.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs









// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || logger/* defaultLogger */._;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];

    if (false) {}
  }

  mount() {
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  }

  isFetching(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = (0,utils/* functionalUpdate */.SE)(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  removeQueries(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  }

  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}


//# sourceMappingURL=queryClient.mjs.map

;// CONCATENATED MODULE: ./src/api/client.ts

var client = new QueryClient();
/* harmony default export */ var api_client = (client);


/***/ }),

/***/ 93875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "tq": function() { return /* binding */ emptyButton; },
/* harmony export */   "vn": function() { return /* binding */ parse_cta_style; }
/* harmony export */ });
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93717);
/* harmony import */ var _components_library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35705);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
// Generated by ReScript, PLEASE EDIT WITH CARE




function parse_cta_style(style) {
    switch(style){
        case "business_ghost_charcoal":
            return [
                /* Regular */ 0,
                /* BusinessCharcoal */ 4,
                /* Outlined */ 1
            ];
        case "business_primary_purple":
            return [
                /* Regular */ 0,
                /* BusinessPurple */ 3,
                /* Contained */ 0
            ];
        case "ghost_charcoal":
            return [
                /* Regular */ 0,
                /* Charcoal */ 1,
                /* Outlined */ 1
            ];
        case "ghost_red":
            return [
                /* Regular */ 0,
                /* Red */ 0,
                /* Outlined */ 1
            ];
        case "primary_charcoal":
            return [
                /* Regular */ 0,
                /* Charcoal */ 1,
                /* Contained */ 0
            ];
        case "primary_red":
            return [
                /* Regular */ 0,
                /* Red */ 0,
                /* Contained */ 0
            ];
        case "primary_regular":
            return [
                /* Regular */ 0,
                /* Primary */ 5,
                /* Contained */ 0
            ];
        case "primary_regular_ghost":
            return [
                /* Regular */ 0,
                /* Primary */ 5,
                /* Outlined */ 1
            ];
        case "primary_small":
            return [
                /* Small */ 1,
                /* Primary */ 5,
                /* Contained */ 0
            ];
        case "primary_small_ghost":
            return [
                /* Small */ 1,
                /* Primary */ 5,
                /* Outlined */ 1
            ];
        case "secondary_charcoal":
            return [
                /* Small */ 1,
                /* Charcoal */ 1,
                /* Contained */ 0
            ];
        case "secondary_red":
            return [
                /* Small */ 1,
                /* Red */ 0,
                /* Contained */ 0
            ];
        case "secondary_regular":
            return [
                /* Regular */ 0,
                /* Secondary */ 6,
                /* Contained */ 0
            ];
        case "secondary_regular_ghost":
            return [
                /* Regular */ 0,
                /* Secondary */ 6,
                /* Outlined */ 1
            ];
        case "secondary_small":
            return [
                /* Small */ 1,
                /* Secondary */ 6,
                /* Contained */ 0
            ];
        case "secondary_small_ghost":
            return [
                /* Small */ 1,
                /* Secondary */ 6,
                /* Outlined */ 1
            ];
        case "tertiary_regular":
            return [
                /* Regular */ 0,
                /* Tertiary */ 7,
                /* Contained */ 0
            ];
        case "tertiary_regular_ghost":
            return [
                /* Regular */ 0,
                /* Tertiary */ 7,
                /* Outlined */ 1
            ];
        case "tertiary_small":
            return [
                /* Small */ 1,
                /* Tertiary */ 7,
                /* Contained */ 0
            ];
        case "tertiary_small_ghost":
            return [
                /* Small */ 1,
                /* Tertiary */ 7,
                /* Outlined */ 1
            ];
        case "video_play":
            return [
                /* Icon */ 2,
                /* Charcoal */ 1,
                /* Outlined */ 1
            ];
        case "white_regular":
            return [
                /* Regular */ 0,
                /* White */ 2,
                /* Contained */ 0
            ];
        case "white_regular_ghost":
            return [
                /* Regular */ 0,
                /* White */ 2,
                /* Outlined */ 1
            ];
        case "white_small":
            return [
                /* Small */ 1,
                /* White */ 2,
                /* Contained */ 0
            ];
        case "white_small_ghost":
            return [
                /* Small */ 1,
                /* White */ 2,
                /* Outlined */ 1
            ];
        default:
            return [
                /* Regular */ 0,
                /* Primary */ 5,
                /* Contained */ 0
            ];
    }
}
var emptyButton = {
    cta_text: "",
    cta_url: "",
    cta_variant: "",
    variant: /* Regular */ 0,
    colour: /* Red */ 0,
    fill: /* Contained */ 0,
    open_in_new_window: false,
    smartLink: _components_library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .emptySmartLink */ .R
};
function get(c) {
    var cta_text = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.cta_text, function(c) {
        return c.value;
    }), "");
    var cta_url = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.cta_url, function(f) {
        return f.value;
    }), "");
    var open_in_new_window = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .mapWithDefault */ .k7(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.open_in_new_window, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), 0), function(c) {
        return c.codename;
    }), false, function(str) {
        if (str === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var match = parse_cta_style(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.cta_style__style, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), function(v) {
        return v.codename;
    }), 0), "primary_regular"));
    var cta_variant = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.cta_style__style, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), function(v) {
        return v.codename;
    }), 0), "primary_regular");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        cta_text: cta_text,
        cta_url: cta_url,
        cta_variant: cta_variant,
        variant: match[0],
        colour: match[1],
        fill: match[2],
        open_in_new_window: open_in_new_window,
        smartLink: smartLink
    };
}
 /* No side effect */ 


/***/ }),

/***/ 607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rX": function() { return /* binding */ getCmsData; },
  "Zi": function() { return /* binding */ getEnrichedTextBlockFields; },
  "hh": function() { return /* binding */ getGiftLandingPageTheme; },
  "Tz": function() { return /* binding */ getLandingPage; },
  "nW": function() { return /* binding */ getPageContent; }
});

// UNUSED EXPORTS: KontentData, getGlobalConfiguration, getSkuPresentation, getSkuPresentationList, getStoreCategory, querySkuPresentationList

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/bindings/Pino.bs.js
var Pino_bs = __webpack_require__(91574);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var _apollo_client = __webpack_require__(46829);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_exn.js
var js_exn = __webpack_require__(49263);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_js_exceptions.js
var caml_js_exceptions = __webpack_require__(37082);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/errors/ApolloClient__Errors_ApolloError.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var ensureError = function ensureError(unknown) {
    if ((0,_instanceof/* default */.Z)(unknown, Error)) {
        return unknown;
    } else {
        unknown = unknown || {};
        var message = unknown.message;
        var errorMessage = unknown.errorMessage;
        var keys = Object.keys(unknown);
        var _$error = new Error(message || errorMessage || "[Non-error exception with keys: " + keys.join(", ") + "]");
        keys.forEach(function(key) {
            _$error[key] = unknown[key];
        });
        return _$error;
    }
};
function error(v) {
    return v;
}
function serverError(v) {
    return v;
}
function serverParseError(v) {
    return v;
}
function classify(v) {
    if (function(v) {
        return "bodyText" in v && "response" in v && "statusCode" in v;
    }(v)) {
        return {
            TAG: /* ServerError */ 1,
            _0: v
        };
    } else if (function(v) {
        return "result" in v && "response" in v && "statusCode" in v;
    }(v)) {
        return {
            TAG: /* ServerParseError */ 2,
            _0: v
        };
    } else {
        return {
            TAG: /* Error */ 0,
            _0: v
        };
    }
}
var NetworkErrorUnion = {
    error: error,
    serverError: serverError,
    serverParseError: serverParseError,
    classify: classify
};
function ensureApolloError(error) {
    return function(_$error, makeApolloError, ensureError) {
        var _$error = _$error || {};
        if (Array.isArray(_$error.graphQLErrors)) {
            return _$error;
        } else if (_$error && typeof _$error.message === "string" && _$error.extensions) {
            return makeApolloError({
                graphQLErrors: [
                    _$error
                ]
            });
        } else {
            return makeApolloError({
                networkError: ensureError(_$error)
            });
        }
    }(error, function(prim) {
        return new core.ApolloError(prim);
    }, ensureError);
}
var Js_ = {
    NetworkErrorUnion: NetworkErrorUnion,
    ensureApolloError: ensureApolloError
};
function fromJs(untrustedJs) {
    var js = ensureApolloError(untrustedJs);
    return {
        extraInfo: js.extraInfo,
        graphQLErrors: belt_Option/* getWithDefault */.tj(js.graphQLErrors, []),
        networkError: belt_Option/* map */.UI(caml_option/* nullable_to_opt */.Tl(js.networkError), function(networkError) {
            var _$error = classify(networkError);
            switch(_$error.TAG | 0){
                case /* Error */ 0:
                    return {
                        TAG: /* FetchFailure */ 0,
                        _0: _$error._0
                    };
                case /* ServerError */ 1:
                    var error$1 = _$error._0;
                    return {
                        TAG: /* BadStatus */ 1,
                        _0: error$1.statusCode,
                        _1: error$1
                    };
                case /* ServerParseError */ 2:
                    return {
                        TAG: /* BadBody */ 2,
                        _0: _$error._0
                    };
            }
        }),
        name: js.name,
        message: js.message,
        stack: js.stack
    };
}
function make(graphQLErrors, networkError, errorMessage, extraInfo, param) {
    var errorWithoutNetworkError = fromJs(new core.ApolloError({
        graphQLErrors: graphQLErrors,
        networkError: undefined,
        errorMessage: errorMessage,
        extraInfo: extraInfo
    }));
    return {
        extraInfo: errorWithoutNetworkError.extraInfo,
        graphQLErrors: errorWithoutNetworkError.graphQLErrors,
        networkError: networkError,
        name: errorWithoutNetworkError.name,
        message: errorWithoutNetworkError.message,
        stack: errorWithoutNetworkError.stack
    };
}
var Graphql;
var GraphQLError;
var ServerError;
var ServerParseError;
var Types;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/ApolloClient__Utils.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function ApolloClient_Utils_bs_safeParse(parse, jsData) {
    var data;
    try {
        data = curry._1(parse, jsData);
    } catch (raw_error) {
        var error = caml_js_exceptions/* internalToOCamlException */.UW(raw_error);
        if (error.RE_EXN_ID === js_exn/* $$Error */.lC) {
            return {
                TAG: /* Error */ 1,
                _0: {
                    value: jsData,
                    error: error._1
                }
            };
        }
        throw error;
    }
    return {
        TAG: /* Ok */ 0,
        _0: data
    };
}
function safeParseAndLiftToCommonResultProps(jsData, graphQLErrors, apolloError, safeParse) {
    var existingError = apolloError !== undefined ? apolloError : graphQLErrors !== undefined ? make(graphQLErrors, undefined, undefined, undefined, undefined) : undefined;
    var match = belt_Option/* map */.UI(jsData, curry.__1(safeParse));
    if (match !== undefined) {
        if (match.TAG === /* Ok */ 0) {
            return [
                caml_option/* some */.G(match._0),
                existingError
            ];
        } else if (belt_Option/* isSome */.pC(existingError)) {
            return [
                undefined,
                existingError
            ];
        } else {
            return [
                undefined,
                make(graphQLErrors, {
                    TAG: /* ParseError */ 3,
                    _0: match._0
                }, undefined, undefined, undefined)
            ];
        }
    } else {
        return [
            undefined,
            existingError
        ];
    }
}
function useGuaranteedMemo1(f, dependency) {
    var value = react.useRef(curry._1(f, undefined));
    var previousDependency = react.useRef(dependency);
    if (dependency !== previousDependency.current) {
        value.current = curry._1(f, undefined);
        previousDependency.current = dependency;
    }
    return value.current;
}
var ApolloError;
var ApolloClient_Utils_bs_Graphql;
var ApolloClient_Utils_bs_Types;
var ApolloClient_Utils_bs_ensureError = ensureError;
 /* react Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_null.js
var js_null = __webpack_require__(94518);
;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/link/core/ApolloClient__Link_Core_Types.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_Link_Core_Types_bs_Js_ = {};
var GraphQLRequest = {
    Js_: ApolloClient_Link_Core_Types_bs_Js_
};
var Js_$1 = {};
var preserveJsPropsAndContext = function preserveJsPropsAndContext(js, t) {
    return Object.assign(js, t);
};
function ApolloClient_Link_Core_Types_bs_fromJs(js) {
    return preserveJsPropsAndContext(js, {
        query: js.query,
        variables: js.variables,
        operationName: js.operationName,
        extensions: js.extensions,
        rescript_setContext: function rescript_setContext(context) {
            return js.setContext(context);
        },
        rescript_getContext: function rescript_getContext(param) {
            return js.getContext();
        }
    });
}
var Operation = {
    Js_: Js_$1,
    preserveJsPropsAndContext: preserveJsPropsAndContext,
    fromJs: ApolloClient_Link_Core_Types_bs_fromJs
};
var Js_$2 = {};
function fromJs$1(js, safeParse) {
    var match = safeParseAndLiftToCommonResultProps(caml_option/* nullable_to_opt */.Tl(js.data), js.errors, undefined, safeParse);
    return {
        data: match[0],
        extensions: js.extensions,
        context: js.context,
        error: match[1]
    };
}
function fromError(error) {
    return {
        data: undefined,
        extensions: undefined,
        context: undefined,
        error: error
    };
}
function toResult(fetchResult) {
    var data = fetchResult.data;
    if (data !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                data: caml_option/* valFromOption */.xt(data),
                error: fetchResult.error,
                extensions: fetchResult.extensions,
                context: fetchResult.context
            }
        };
    } else if (fetchResult.error !== undefined) {
        return {
            TAG: /* Error */ 1,
            _0: fetchResult.error
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: make(undefined, undefined, "No data and no error on FetchResult.t. Shouldn't this be impossible?", undefined, undefined)
        };
    }
}
var FetchResult = {
    Js_: Js_$2,
    fromJs: fromJs$1,
    fromError: fromError,
    toResult: toResult
};
var Js_$3 = {};
var NextLink = {
    Js_: Js_$3
};
var Js_$4 = {};
function toJs(t) {
    return function(operation, forward) {
        return js_null/* fromOption */.Yo(curry._2(t, operation, forward));
    };
}
var RequestHandler = {
    Js_: Js_$4,
    toJs: toJs
};
var ApolloClient_Link_Core_Types_bs_ApolloError;
var ApolloClient_Link_Core_Types_bs_Graphql;
var ApolloClient_Link_Core_Types_bs_GraphQLError;
var Observable;
var ApolloClient_Link_Core_Types_bs_Types;
var Utils;
 /* ApolloClient__Utils Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_NetworkStatus.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
var ApolloClient_Core_NetworkStatus_bs_Js_ = {};
function ApolloClient_Core_NetworkStatus_bs_fromJs(js) {
    switch(js){
        case 1:
            return /* Loading */ 0;
        case 2:
            return /* SetVariables */ 1;
        case 3:
            return /* FetchMore */ 2;
        case 4:
            return /* Refetch */ 3;
        case 5:
            return /* SkippedOrNotPresent */ 7;
        case 6:
            return /* Poll */ 4;
        case 7:
            return /* Ready */ 5;
        case 8:
            return /* Error */ 6;
        default:
            return /* SkippedOrNotPresent */ 7;
    }
}
var NetworkStatus = {
    Js_: ApolloClient_Core_NetworkStatus_bs_Js_,
    fromJs: ApolloClient_Core_NetworkStatus_bs_fromJs
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_Types.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var ApolloClient_Core_Types_bs_Js_ = {};
var OperationVariables = {
    Js_: ApolloClient_Core_Types_bs_Js_
};
var ApolloClient_Core_Types_bs_Js_$1 = {};
function ApolloClient_Core_Types_bs_toJs(t) {
    return {
        query: t.query,
        variables: t.variables,
        context: t.context
    };
}
var PureQueryOptions = {
    Js_: ApolloClient_Core_Types_bs_Js_$1,
    toJs: ApolloClient_Core_Types_bs_toJs
};
var ApolloClient_Core_Types_bs_Js_$2 = {};
function ApolloClient_Core_Types_bs_fromJs(js, safeParse) {
    var match = safeParseAndLiftToCommonResultProps(js.data, js.errors, undefined, safeParse);
    return {
        data: match[0],
        error: match[1],
        loading: js.loading,
        networkStatus: NetworkStatus.fromJs(js.networkStatus)
    };
}
function ApolloClient_Core_Types_bs_fromError(error) {
    return {
        data: undefined,
        error: error,
        loading: false,
        networkStatus: /* Error */ 6
    };
}
function ApolloClient_Core_Types_bs_toResult(apolloQueryResult) {
    var data = apolloQueryResult.data;
    if (data !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                data: caml_option/* valFromOption */.xt(data),
                error: apolloQueryResult.error,
                loading: apolloQueryResult.loading,
                networkStatus: apolloQueryResult.networkStatus
            }
        };
    } else if (apolloQueryResult.error !== undefined) {
        return {
            TAG: /* Error */ 1,
            _0: apolloQueryResult.error
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: make(undefined, undefined, "No data and no error on ApolloQueryResult.t. Shouldn't this be impossible?", undefined, undefined)
        };
    }
}
var ApolloQueryResult = {
    Js_: ApolloClient_Core_Types_bs_Js_$2,
    fromJs: ApolloClient_Core_Types_bs_fromJs,
    fromError: ApolloClient_Core_Types_bs_fromError,
    toResult: ApolloClient_Core_Types_bs_toResult
};
var ApolloClient_Core_Types_bs_Js_$3 = {};
function toJs$1(t, safeParse) {
    return function(previousResult, jsOptions) {
        return curry._2(t, previousResult, {
            mutationResult: FetchResult.fromJs(jsOptions.mutationResult, safeParse),
            queryName: jsOptions.queryName,
            queryVariables: jsOptions.queryVariables
        });
    };
}
var MutationQueryReducer = {
    Js_: ApolloClient_Core_Types_bs_Js_$3,
    toJs: toJs$1
};
var ApolloClient_Core_Types_bs_Js_$4 = {};
function toJs$2(t, safeParse) {
    return js_dict/* map */.UI(function(mutationQueryReducer) {
        return toJs$1(mutationQueryReducer, safeParse);
    }, t);
}
var MutationQueryReducersMap = {
    Js_: ApolloClient_Core_Types_bs_Js_$4,
    toJs: toJs$2
};
var Js_$5 = {};
var Resolvers = {
    Js_: Js_$5
};
var ApolloClient_Core_Types_bs_ApolloError;
var ApolloClient_Core_Types_bs_Graphql;
var ApolloClient_Core_Types_bs_FetchResult;
var ApolloClient_Core_Types_bs_NetworkStatus;
var Resolver;
var ApolloClient_Core_Types_bs_Types;
var ApolloClient_Core_Types_bs_Utils;
 /* ApolloClient__Utils Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/zen-observable/ApolloClient__ZenObservable.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ApolloClient_ZenObservable_bs_Js_ = {};
function ApolloClient_ZenObservable_bs_fromJs(js) {
    return {
        closed: js.closed,
        unsubscribe: function unsubscribe(param) {
            js.unsubscribe();
        }
    };
}
var Subscription = {
    Js_: ApolloClient_ZenObservable_bs_Js_,
    fromJs: ApolloClient_ZenObservable_bs_fromJs
};
var ApolloClient_ZenObservable_bs_Js_$1 = {};
var Observer = {
    Js_: ApolloClient_ZenObservable_bs_Js_$1
};
var ApolloClient_ZenObservable_bs_Js_$2 = {};
function ApolloClient_ZenObservable_bs_fromJs$1(t) {
    return {
        subscribe: function subscribe(onNext, onError, onComplete, param) {
            return ApolloClient_ZenObservable_bs_fromJs(t.subscribe(onNext, onError !== undefined ? caml_option/* valFromOption */.xt(onError) : undefined, onComplete !== undefined ? caml_option/* valFromOption */.xt(onComplete) : undefined));
        }
    };
}
var ApolloClient_ZenObservable_bs_Observable = {
    Js_: ApolloClient_ZenObservable_bs_Js_$2,
    fromJs: ApolloClient_ZenObservable_bs_fromJs$1
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_ObservableQuery.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function fakeMap(js, fn) {
    return function(js, fn) {
        var originalSubscribe = js.subscribe.bind(js);
        js.subscribe = function(onNext, onError, onComplete) {
            var newOnNext = function newOnNext(result) {
                var parsedData = result.data ? fn(result.data, onError) : undefined;
                var transformedResult = parsedData ? Object.assign({}, result, {
                    data: parsedData
                }) : result;
                return onNext(transformedResult);
            };
            return originalSubscribe(newOnNext, onError, onComplete);
        };
        return js;
    }(js, fn);
}
var ApolloClient_Core_ObservableQuery_bs_Js_ = {
    fakeMap: fakeMap
};
function ApolloClient_Core_ObservableQuery_bs_preserveJsPropsAndContext(js, t) {
    return function(js, t) {
        return Object.assign(js, t);
    }(js, t);
}
function ApolloClient_Core_ObservableQuery_bs_fromJs(js, safeParse) {
    var parseWithOnErrorCall = function parseWithOnErrorCall(jsData, onError) {
        var data = curry._1(safeParse, jsData);
        if (data.TAG === /* Ok */ 0) {
            return caml_option/* some */.G(data._0);
        }
        curry._1(onError, data._0.error);
    };
    var observableWithParsedData = fakeMap(js, parseWithOnErrorCall);
    return ApolloClient_Core_ObservableQuery_bs_preserveJsPropsAndContext(observableWithParsedData, {
        rescript_subscribe: function rescript_subscribe(onNext, onError, onComplete, param) {
            return Subscription.fromJs(js.subscribe(function(jsApolloQueryResult) {
                curry._1(onNext, ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse));
            }, onError !== undefined ? caml_option/* valFromOption */.xt(onError) : undefined, onComplete !== undefined ? caml_option/* valFromOption */.xt(onComplete) : undefined));
        }
    });
}
var ObservableQuery = {
    ApolloQueryResult: undefined,
    Subscription: undefined,
    Observer: undefined,
    Js_: ApolloClient_Core_ObservableQuery_bs_Js_,
    preserveJsPropsAndContext: ApolloClient_Core_ObservableQuery_bs_preserveJsPropsAndContext,
    fromJs: ApolloClient_Core_ObservableQuery_bs_fromJs
};
var ApolloClient_Core_ObservableQuery_bs_Types;
 /* ApolloClient__Core_Types Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_WatchQueryOptions.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_Core_WatchQueryOptions_bs_Js_ = {};
function ApolloClient_Core_WatchQueryOptions_bs_toJs(x) {
    switch(x){
        case /* None */ 0:
            return "none";
        case /* Ignore */ 1:
            return "ignore";
        case /* All */ 2:
            return "all";
    }
}
var ErrorPolicy = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_,
    toJs: ApolloClient_Core_WatchQueryOptions_bs_toJs
};
var ApolloClient_Core_WatchQueryOptions_bs_Js_$1 = {};
function ApolloClient_Core_WatchQueryOptions_bs_toJs$1(x) {
    switch(x){
        case /* CacheFirst */ 0:
            return "cache-first";
        case /* CacheOnly */ 1:
            return "cache-only";
        case /* NetworkOnly */ 2:
            return "network-only";
        case /* NoCache */ 3:
            return "no-cache";
        case /* Standby */ 4:
            return "standby";
    }
}
var FetchPolicy = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_$1,
    toJs: ApolloClient_Core_WatchQueryOptions_bs_toJs$1
};
var ApolloClient_Core_WatchQueryOptions_bs_Js_$2 = {};
function ApolloClient_Core_WatchQueryOptions_bs_toJs$2(x) {
    return "no-cache";
}
var FetchPolicy__noCacheExtracted = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_$2,
    toJs: ApolloClient_Core_WatchQueryOptions_bs_toJs$2
};
var ApolloClient_Core_WatchQueryOptions_bs_Js_$3 = {};
function toJs$3(x) {
    switch(x){
        case /* CacheAndNetwork */ 0:
            return "cache-and-network";
        case /* CacheFirst */ 1:
            return "cache-first";
        case /* CacheOnly */ 2:
            return "cache-only";
        case /* NetworkOnly */ 3:
            return "network-only";
        case /* NoCache */ 4:
            return "no-cache";
        case /* Standby */ 5:
            return "standby";
    }
}
var WatchQueryFetchPolicy = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_$3,
    toJs: toJs$3
};
var ApolloClient_Core_WatchQueryOptions_bs_Js_$4 = {};
function toJs$4(t, mapJsVariables, serializeVariables) {
    return {
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs$1),
        query: t.query,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs),
        context: t.context
    };
}
var QueryOptions = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_$4,
    toJs: toJs$4
};
var ApolloClient_Core_WatchQueryOptions_bs_Js_$5 = {};
function toJs$5(t, mapJsVariables, serializeVariables) {
    return {
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, toJs$3),
        nextFetchPolicy: belt_Option/* map */.UI(t.nextFetchPolicy, toJs$3),
        query: t.query,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs),
        context: t.context
    };
}
var WatchQueryOptions = {
    Js_: ApolloClient_Core_WatchQueryOptions_bs_Js_$5,
    toJs: toJs$5
};
var Js_$6 = {};
function toJs$6(t, onParseError, querySafeParse, querySerialize, subscriptionSafeParse) {
    return function(jsQueryData, param) {
        var match = curry._1(querySafeParse, jsQueryData);
        var match$1 = curry._1(subscriptionSafeParse, param.subscriptionData.data);
        if (match.TAG === /* Ok */ 0) {
            if (match$1.TAG === /* Ok */ 0) {
                return curry._1(querySerialize, curry._2(t, match._0, {
                    subscriptionData: {
                        data: match$1._0
                    }
                }));
            }
            curry._1(onParseError, match$1._0);
            return jsQueryData;
        }
        curry._1(onParseError, match._0);
        return jsQueryData;
    };
}
var UpdateQueryFn = {
    Js_: Js_$6,
    toJs: toJs$6
};
var Js_$7 = {};
function toJs$7(t, onUpdateQueryParseError, querySafeParse, querySerialize, subscriptionSafeParse) {
    return {
        document: t.document,
        variables: t.variables,
        updateQuery: belt_Option/* map */.UI(t.updateQuery, function(param) {
            return toJs$6(param, onUpdateQueryParseError, querySafeParse, querySerialize, subscriptionSafeParse);
        }),
        onError: t.onError,
        context: t.context
    };
}
var SubscribeToMoreOptions = {
    Js_: Js_$7,
    toJs: toJs$7
};
var Js_$8 = {};
function toJs$8(t, mapJsVariables, serializeVariables) {
    return {
        query: t.query,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs$1),
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs),
        context: t.context
    };
}
var SubscriptionOptions = {
    Js_: Js_$8,
    toJs: toJs$8
};
var Js_$9 = {};
function toJs$9(mutationUpdaterFn, safeParse) {
    return function(cache, jsFetchResult) {
        curry._2(mutationUpdaterFn, cache, FetchResult.fromJs(jsFetchResult, safeParse));
    };
}
var MutationUpdaterFn = {
    Js_: Js_$9,
    toJs: toJs$9
};
function string(v) {
    return v;
}
function pureQueryOptions(v) {
    return v;
}
var Union = {
    string: string,
    pureQueryOptions: pureQueryOptions
};
var Js_$10 = {
    Union: Union
};
function toJs$10(__x) {
    return belt_Array/* map */.UI(__x, function(x) {
        if (x.TAG === /* PureQueryOptions */ 0) {
            return PureQueryOptions.toJs(x._0);
        } else {
            return x._0;
        }
    });
}
var RefetchQueryDescription = {
    Js_: Js_$10,
    toJs: toJs$10
};
var Js_$11 = {};
function toJs$11(t, mapJsVariables, safeParse, serialize, serializeVariables) {
    var func = MutationQueryReducersMap.toJs;
    return {
        mutation: t.mutation,
        context: t.context,
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs$2),
        awaitRefetchQueries: t.awaitRefetchQueries,
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ApolloClient_Core_WatchQueryOptions_bs_toJs),
        optimisticResponse: belt_Option/* map */.UI(t.optimisticResponse, function(optimisticResponse) {
            return function(variables) {
                return curry._1(serialize, curry._1(optimisticResponse, variables));
            };
        }),
        update: belt_Option/* map */.UI(t.update, function(param) {
            return toJs$9(param, safeParse);
        }),
        updateQueries: belt_Option/* map */.UI(t.updateQueries, function(param) {
            return curry._2(func, param, safeParse);
        }),
        refetchQueries: belt_Option/* map */.UI(t.refetchQueries, toJs$10),
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables))
    };
}
var MutationOptions = {
    Js_: Js_$11,
    toJs: toJs$11
};
var ApolloCache;
var ApolloClient_Core_WatchQueryOptions_bs_FetchResult;
var ApolloClient_Core_WatchQueryOptions_bs_Graphql;
var ApolloClient_Core_WatchQueryOptions_bs_MutationQueryReducersMap;
var ApolloClient_Core_WatchQueryOptions_bs_Types;
var ApolloClient_Core_WatchQueryOptions_bs_PureQueryOptions;
 /* ApolloClient__Core_Types Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/core/types/ApolloClient__Cache_Core_Types_DataProxy.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ApolloClient_Cache_Core_Types_DataProxy_bs_Js_ = {};
function ApolloClient_Cache_Core_Types_DataProxy_bs_toJs(t, mapJsVariablesOpt, serializeVariables) {
    var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
        return prim;
    };
    return {
        query: t.query,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        id: t.id
    };
}
var Query = {
    Js_: ApolloClient_Cache_Core_Types_DataProxy_bs_Js_,
    toJs: ApolloClient_Cache_Core_Types_DataProxy_bs_toJs
};
var ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$1 = {};
var Fragment = {
    Js_: ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$1
};
var ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$2 = {};
function ApolloClient_Cache_Core_Types_DataProxy_bs_toJs$1(t, mapJsVariablesOpt, serialize, serializeVariables) {
    var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
        return prim;
    };
    return {
        data: curry._1(serialize, t.data),
        broadcast: t.broadcast,
        query: t.query,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        id: t.id
    };
}
var WriteQueryOptions = {
    Js_: ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$2,
    toJs: ApolloClient_Cache_Core_Types_DataProxy_bs_toJs$1
};
var ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$3 = {};
function ApolloClient_Cache_Core_Types_DataProxy_bs_toJs$2(t, serialize) {
    return {
        data: curry._1(serialize, t.data),
        broadcast: t.broadcast,
        id: t.id,
        fragment: t.fragment,
        fragmentName: t.fragmentName
    };
}
var WriteFragmentOptions = {
    Js_: ApolloClient_Cache_Core_Types_DataProxy_bs_Js_$3,
    toJs: ApolloClient_Cache_Core_Types_DataProxy_bs_toJs$2
};
var ApolloClient_Cache_Core_Types_DataProxy_bs_Graphql;
var ApolloClient_Cache_Core_Types_DataProxy_bs_Utils;
 /* No side effect */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_ApolloClient.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













var ApolloClient_Core_ApolloClient_bs_Js_ = {};
function ApolloClient_Core_ApolloClient_bs_toJs(t) {
    return {
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, WatchQueryFetchPolicy.toJs),
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs),
        context: t.context
    };
}
function ApolloClient_Core_ApolloClient_bs_make(fetchPolicy, errorPolicy, context, param) {
    return {
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        context: context
    };
}
var DefaultWatchQueryOptions = {
    Js_: ApolloClient_Core_ApolloClient_bs_Js_,
    toJs: ApolloClient_Core_ApolloClient_bs_toJs,
    make: ApolloClient_Core_ApolloClient_bs_make
};
var ApolloClient_Core_ApolloClient_bs_Js_$1 = {};
function ApolloClient_Core_ApolloClient_bs_toJs$1(t) {
    return {
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, FetchPolicy.toJs),
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs),
        context: t.context
    };
}
function make$1(fetchPolicy, errorPolicy, context, param) {
    return {
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        context: context
    };
}
var DefaultQueryOptions = {
    Js_: ApolloClient_Core_ApolloClient_bs_Js_$1,
    toJs: ApolloClient_Core_ApolloClient_bs_toJs$1,
    make: make$1
};
var ApolloClient_Core_ApolloClient_bs_Js_$2 = {};
function ApolloClient_Core_ApolloClient_bs_toJs$2(t) {
    return {
        context: t.context,
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, FetchPolicy__noCacheExtracted.toJs),
        awaitRefetchQueries: t.awaitRefetchQueries,
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs),
        refetchQueries: belt_Option/* map */.UI(t.refetchQueries, RefetchQueryDescription.toJs)
    };
}
function make$2(context, fetchPolicy, awaitRefetchQueries, errorPolicy, refetchQueries, param) {
    return {
        context: context,
        fetchPolicy: fetchPolicy,
        awaitRefetchQueries: awaitRefetchQueries,
        errorPolicy: errorPolicy,
        refetchQueries: refetchQueries
    };
}
var DefaultMutateOptions = {
    Js_: ApolloClient_Core_ApolloClient_bs_Js_$2,
    toJs: ApolloClient_Core_ApolloClient_bs_toJs$2,
    make: make$2
};
var ApolloClient_Core_ApolloClient_bs_Js_$3 = {};
function ApolloClient_Core_ApolloClient_bs_toJs$3(t) {
    return {
        watchQuery: belt_Option/* map */.UI(t.watchQuery, ApolloClient_Core_ApolloClient_bs_toJs),
        query: belt_Option/* map */.UI(t.query, ApolloClient_Core_ApolloClient_bs_toJs$1),
        mutate: belt_Option/* map */.UI(t.mutate, ApolloClient_Core_ApolloClient_bs_toJs$2)
    };
}
function make$3(mutate, query, watchQuery, param) {
    return {
        watchQuery: watchQuery,
        query: query,
        mutate: mutate
    };
}
var DefaultOptions = {
    Js_: ApolloClient_Core_ApolloClient_bs_Js_$3,
    toJs: ApolloClient_Core_ApolloClient_bs_toJs$3,
    make: make$3
};
var ApolloClient_Core_ApolloClient_bs_Js_$4 = {};
function ApolloClient_Core_ApolloClient_bs_toJs$4(t) {
    return {
        uri: t.uri,
        credentials: t.credentials,
        headers: t.headers,
        link: t.link,
        cache: t.cache,
        ssrForceFetchDelay: t.ssrForceFetchDelay,
        ssrMode: t.ssrMode,
        connectToDevTools: t.connectToDevTools,
        queryDeduplication: t.queryDeduplication,
        defaultOptions: belt_Option/* map */.UI(t.defaultOptions, ApolloClient_Core_ApolloClient_bs_toJs$3),
        assumeImmutableResults: t.assumeImmutableResults,
        resolvers: t.resolvers,
        typeDefs: t.typeDefs,
        fragmentMatcher: t.fragmentMatcher,
        name: t.name,
        version: t.version
    };
}
var ApolloClientOptions = {
    Js_: ApolloClient_Core_ApolloClient_bs_Js_$4,
    toJs: ApolloClient_Core_ApolloClient_bs_toJs$4
};
var Cast = {};
var ApolloClient_Core_ApolloClient_bs_Js_$5 = {
    Cast: Cast
};
var ApolloClient_Core_ApolloClient_bs_preserveJsPropsAndContext = function preserveJsPropsAndContext(js, t) {
    return Object.assign(js, t);
};
function make$4(uri, credentials, headers, link, cache, ssrForceFetchDelay, ssrMode, connectToDevTools, queryDeduplication, defaultOptions, assumeImmutableResults, resolvers, typeDefs, fragmentMatcher, name, version, param) {
    var jsClient = new core.ApolloClient(ApolloClient_Core_ApolloClient_bs_toJs$4({
        uri: uri,
        credentials: credentials,
        headers: headers,
        link: link,
        cache: cache,
        ssrForceFetchDelay: ssrForceFetchDelay,
        ssrMode: ssrMode,
        connectToDevTools: connectToDevTools,
        queryDeduplication: queryDeduplication,
        defaultOptions: defaultOptions,
        assumeImmutableResults: assumeImmutableResults,
        resolvers: resolvers,
        typeDefs: typeDefs,
        fragmentMatcher: fragmentMatcher,
        name: name,
        version: version
    }));
    var clearStore = function clearStore(param) {
        var __x = jsClient.clearStore();
        var __x$1 = js_promise/* then_ */.k(function(value) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: value
            });
        }, __x);
        return js_promise/* $$catch */.y(function(e) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: ApolloClient_Utils_bs_ensureError(e)
            });
        }, __x$1);
    };
    var mutate = function mutate(Operation, awaitRefetchQueries, context, errorPolicy, fetchPolicy, $staropt$star, optimisticResponse, refetchQueries, updateQueries, update, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        var __x = jsClient.mutate(MutationOptions.toJs({
            context: context,
            fetchPolicy: fetchPolicy,
            mutation: Operation.query,
            awaitRefetchQueries: awaitRefetchQueries,
            errorPolicy: errorPolicy,
            optimisticResponse: optimisticResponse,
            refetchQueries: refetchQueries,
            update: update,
            updateQueries: updateQueries,
            variables: variables
        }, mapJsVariables, safeParse, Operation.serialize, Operation.serializeVariables));
        var __x$1 = js_promise/* then_ */.k(function(jsFetchResult) {
            return Promise.resolve(FetchResult.toResult(FetchResult.fromJs(jsFetchResult, safeParse)));
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    var onClearStore = function onClearStore(cb) {
        return function(param) {
            jsClient.onClearStore(cb);
        };
    };
    var onResetStore = function onResetStore(cb) {
        return function(param) {
            jsClient.onResetStore(cb);
        };
    };
    var query = function query(Operation, context, errorPolicy, fetchPolicy, $staropt$star, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        var __x = jsClient.query(QueryOptions.toJs({
            fetchPolicy: fetchPolicy,
            query: Operation.query,
            variables: variables,
            errorPolicy: errorPolicy,
            context: context
        }, mapJsVariables, Operation.serializeVariables));
        var __x$1 = js_promise/* then_ */.k(function(jsApolloQueryResult) {
            return Promise.resolve(ApolloQueryResult.toResult(ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse)));
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    var readFragment = function readFragment(Fragment, id, optimistic, fragmentName, param) {
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Fragment.parse, param);
        };
        return belt_Option/* map */.UI(caml_option/* nullable_to_opt */.Tl(jsClient.readFragment({
            id: id,
            fragment: Fragment.query,
            fragmentName: fragmentName
        }, optimistic !== undefined ? caml_option/* valFromOption */.xt(optimistic) : undefined)), safeParse);
    };
    var readQuery = function readQuery(Operation, id, $staropt$star, optimistic, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        return belt_Option/* map */.UI(caml_option/* nullable_to_opt */.Tl(jsClient.readQuery(Query.toJs({
            query: Operation.query,
            variables: variables,
            id: id
        }, mapJsVariables, Operation.serializeVariables), optimistic)), safeParse);
    };
    var resetStore = function resetStore(param) {
        var __x = jsClient.resetStore();
        var __x$1 = js_promise/* then_ */.k(function(value) {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: value == null ? undefined : caml_option/* some */.G(value)
            });
        }, __x);
        return js_promise/* $$catch */.y(function(e) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: ApolloClient_Utils_bs_ensureError(e)
            });
        }, __x$1);
    };
    var restore = function restore(serializedState) {
        return jsClient.restore(serializedState);
    };
    var setLink = function setLink(link) {
        jsClient.setLink(link);
    };
    var subscribe = function subscribe(Operation, context, errorPolicy, fetchPolicy, $staropt$star, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        var jsObservable = jsClient.subscribe(SubscriptionOptions.toJs({
            query: Operation.query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            context: context
        }, mapJsVariables, Operation.serializeVariables));
        return {
            subscribe: function subscribe(onNext, onError, onComplete, param) {
                var onNext$p = function onNext$p(jsFetchResult) {
                    var ok = FetchResult.toResult(FetchResult.fromJs(jsFetchResult, safeParse));
                    if (ok.TAG === /* Ok */ 0) {
                        return curry._1(onNext, ok._0);
                    } else if (onError !== undefined) {
                        return curry._1(onError, ok._0);
                    } else {
                        return;
                    }
                };
                var onError$p = belt_Option/* map */.UI(onError, function(onError) {
                    return function(unknown) {
                        curry._1(onError, fromJs(Js_.ensureApolloError(unknown)));
                    };
                });
                var observable = ApolloClient_ZenObservable_bs_Observable.fromJs(jsObservable);
                return curry._4(observable.subscribe, onNext$p, onError$p, onComplete, undefined);
            }
        };
    };
    var watchQuery = function watchQuery(Operation, context, errorPolicy, fetchPolicy, nextFetchPolicy, $staropt$star, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        return ObservableQuery.fromJs(jsClient.watchQuery(WatchQueryOptions.toJs({
            fetchPolicy: fetchPolicy,
            nextFetchPolicy: nextFetchPolicy,
            query: Operation.query,
            variables: variables,
            errorPolicy: errorPolicy,
            context: context
        }, mapJsVariables, Operation.serializeVariables)), safeParse);
    };
    var writeFragment = function writeFragment(Fragment, data, broadcast, id, fragmentName, param) {
        jsClient.writeFragment(WriteFragmentOptions.toJs({
            data: data,
            broadcast: broadcast,
            id: id,
            fragment: Fragment.query,
            fragmentName: fragmentName
        }, Fragment.serialize));
    };
    var writeQuery = function writeQuery(Operation, broadcast, data, id, $staropt$star, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        jsClient.writeQuery(WriteQueryOptions.toJs({
            data: data,
            broadcast: broadcast,
            query: Operation.query,
            variables: variables,
            id: id
        }, mapJsVariables, Operation.serialize, Operation.serializeVariables));
    };
    return ApolloClient_Core_ApolloClient_bs_preserveJsPropsAndContext(jsClient, {
        rescript_clearStore: clearStore,
        rescript_mutate: mutate,
        rescript_onClearStore: onClearStore,
        rescript_onResetStore: onResetStore,
        rescript_query: query,
        rescript_readFragment: readFragment,
        rescript_readQuery: readQuery,
        rescript_resetStore: resetStore,
        rescript_restore: restore,
        rescript_setLink: setLink,
        rescript_subscribe: subscribe,
        rescript_watchQuery: watchQuery,
        rescript_writeFragment: writeFragment,
        rescript_writeQuery: writeQuery
    });
}
var ApolloClient_Core_ApolloClient_bs_ApolloCache;
var ApolloClient_Core_ApolloClient_bs_ApolloError;
var ApolloLink;
var ApolloClient_Core_ApolloClient_bs_ApolloQueryResult;
var DataProxy;
var ApolloClient_Core_ApolloClient_bs_ErrorPolicy;
var ApolloClient_Core_ApolloClient_bs_FetchPolicy;
var ApolloClient_Core_ApolloClient_bs_FetchPolicy_noCacheExtracted;
var ApolloClient_Core_ApolloClient_bs_FetchResult;
var FragmentMatcher;
var ApolloClient_Core_ApolloClient_bs_Graphql;
var ApolloClient_Core_ApolloClient_bs_MutationOptions;
var ApolloClient_Core_ApolloClient_bs_MutationQueryReducersMap;
var ApolloClient_Core_ApolloClient_bs_MutationUpdaterFn;
var ApolloClient_Core_ApolloClient_bs_Observable;
var ApolloClient_Core_ApolloClient_bs_ObservableQuery;
var ApolloClient_Core_ApolloClient_bs_QueryOptions;
var ApolloClient_Core_ApolloClient_bs_PureQueryOptions;
var ApolloClient_Core_ApolloClient_bs_RefetchQueryDescription;
var ApolloClient_Core_ApolloClient_bs_Resolvers;
var ApolloClient_Core_ApolloClient_bs_SubscriptionOptions;
var ApolloClient_Core_ApolloClient_bs_Types;
var UriFunction;
var ApolloClient_Core_ApolloClient_bs_Utils;
var ApolloClient_Core_ApolloClient_bs_WatchQueryFetchPolicy;
var ApolloClient_Core_ApolloClient_bs_WatchQueryOptions;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/link/core/ApolloClient__Link_Core_ApolloLink.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var Static = {};
var ApolloClient_Link_Core_ApolloLink_bs_Js_ = {
    Static: Static
};
function ApolloClient_Link_Core_ApolloLink_bs_make(requestHandler) {
    return new _apollo_client.ApolloLink(RequestHandler.toJs(requestHandler));
}
function concat(prim0, prim1) {
    return prim0.concat(prim1);
}
function from(prim0, prim1) {
    return prim0.from(prim1);
}
function setOnError(prim0, prim1) {
    prim0.onError(prim1);
}
function split(t, test, whenTrue, whenFalse) {
    return t.split(function(jsOperation) {
        return Curry._1(test, ApolloClient__Link_Core_Types.Operation.fromJs(jsOperation));
    }, whenTrue, whenFalse);
}
var ApolloClient_Link_Core_ApolloLink_bs_FetchResult;
var ApolloClient_Link_Core_ApolloLink_bs_GraphQLRequest;
var ApolloClient_Link_Core_ApolloLink_bs_Observable;
var ApolloClient_Link_Core_ApolloLink_bs_Operation;
var ApolloClient_Link_Core_ApolloLink_bs_RequestHandler;
var Static$1;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/react/types/ApolloClient__React_Types.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE










var ApolloClient_React_Types_bs_Js_ = {};
function ApolloClient_React_Types_bs_toJs(t, mapJsVariables, safeParse, serializeVariables) {
    return {
        query: t.query,
        displayName: t.displayName,
        skip: t.skip,
        onCompleted: belt_Option/* map */.UI(t.onCompleted, function(onCompleted, jsData) {
            curry._1(onCompleted, curry._1(safeParse, jsData));
        }),
        onError: belt_Option/* map */.UI(t.onError, function(onError) {
            return function(jsApolloError) {
                curry._1(onError, fromJs(jsApolloError));
            };
        }),
        client: t.client,
        context: t.context,
        errorPolicy: belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs),
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, WatchQueryFetchPolicy.toJs),
        nextFetchPolicy: belt_Option/* map */.UI(t.nextFetchPolicy, WatchQueryFetchPolicy.toJs),
        notifyOnNetworkStatusChange: t.notifyOnNetworkStatusChange,
        partialRefetch: t.partialRefetch,
        pollInterval: t.pollInterval,
        ssr: t.ssr,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables))
    };
}
var QueryHookOptions = {
    Js_: ApolloClient_React_Types_bs_Js_,
    toJs: ApolloClient_React_Types_bs_toJs
};
function ApolloClient_React_Types_bs_make(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11, prim12, prim13, prim14) {
    var tmp = {};
    if (prim0 !== undefined) {
        tmp.query = caml_option/* valFromOption */.xt(prim0);
    }
    if (prim1 !== undefined) {
        tmp.displayName = caml_option/* valFromOption */.xt(prim1);
    }
    if (prim2 !== undefined) {
        tmp.onCompleted = caml_option/* valFromOption */.xt(prim2);
    }
    if (prim3 !== undefined) {
        tmp.onError = caml_option/* valFromOption */.xt(prim3);
    }
    if (prim4 !== undefined) {
        tmp.client = caml_option/* valFromOption */.xt(prim4);
    }
    if (prim5 !== undefined) {
        tmp.context = caml_option/* valFromOption */.xt(prim5);
    }
    if (prim6 !== undefined) {
        tmp.errorPolicy = caml_option/* valFromOption */.xt(prim6);
    }
    if (prim7 !== undefined) {
        tmp.fetchPolicy = caml_option/* valFromOption */.xt(prim7);
    }
    if (prim8 !== undefined) {
        tmp.nextFetchPolicy = caml_option/* valFromOption */.xt(prim8);
    }
    if (prim9 !== undefined) {
        tmp.notifyOnNetworkStatusChange = caml_option/* valFromOption */.xt(prim9);
    }
    if (prim10 !== undefined) {
        tmp.partialRefetch = caml_option/* valFromOption */.xt(prim10);
    }
    if (prim11 !== undefined) {
        tmp.pollInterval = caml_option/* valFromOption */.xt(prim11);
    }
    if (prim12 !== undefined) {
        tmp.ssr = caml_option/* valFromOption */.xt(prim12);
    }
    if (prim13 !== undefined) {
        tmp.variables = caml_option/* valFromOption */.xt(prim13);
    }
    return tmp;
}
var ApolloClient_React_Types_bs_Js_$1 = {
    make: ApolloClient_React_Types_bs_make
};
function ApolloClient_React_Types_bs_toJs$1(t, safeParse, serializeVariables) {
    return ApolloClient_React_Types_bs_make(t.query, t.displayName, belt_Option/* map */.UI(t.onCompleted, function(onCompleted, jsData) {
        curry._1(onCompleted, curry._1(safeParse, jsData));
    }), belt_Option/* map */.UI(t.onError, function(onError) {
        return function(jsApolloError) {
            curry._1(onError, fromJs(jsApolloError));
        };
    }), t.client, t.context, belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs), belt_Option/* map */.UI(t.fetchPolicy, WatchQueryFetchPolicy.toJs), undefined, t.notifyOnNetworkStatusChange, t.partialRefetch, t.pollInterval, t.ssr, belt_Option/* map */.UI(t.variables, serializeVariables), undefined);
}
var LazyQueryHookOptions = {
    Js_: ApolloClient_React_Types_bs_Js_$1,
    toJs: ApolloClient_React_Types_bs_toJs$1
};
var ApolloClient_React_Types_bs_Js_$2 = {};
var QueryLazyOptions = {
    Js_: ApolloClient_React_Types_bs_Js_$2
};
var ApolloClient_React_Types_bs_Js_$3 = {};
function ApolloClient_React_Types_bs_fromJs(js, safeParse, serialize, serializeVariables) {
    var match = safeParseAndLiftToCommonResultProps(js.data, undefined, belt_Option/* map */.UI(js.error, fromJs), safeParse);
    var previousData = belt_Option/* map */.UI(js.previousData, safeParse);
    var fetchMore = function fetchMore(context, mapJsVariablesOpt, variables, updateQuery, param) {
        var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
            return prim;
        };
        var parseErrorDuringCall = {
            contents: undefined
        };
        var tmp = {};
        var tmp$1 = belt_Option/* map */.UI(variables, function(v) {
            return curry._1(mapJsVariables, curry._1(serializeVariables, v));
        });
        if (tmp$1 !== undefined) {
            tmp.variables = caml_option/* valFromOption */.xt(tmp$1);
        }
        if (context !== undefined) {
            tmp.context = caml_option/* valFromOption */.xt(context);
        }
        var tmp$2 = belt_Option/* map */.UI(updateQuery, function(updateQuery) {
            return function(previousResult, jsFetchMoreOptions) {
                var match = curry._1(safeParse, previousResult);
                var match$1 = belt_Option/* map */.UI(jsFetchMoreOptions.fetchMoreResult, safeParse);
                if (match.TAG === /* Ok */ 0) {
                    var previousResult$1 = match._0;
                    if (match$1 === undefined) {
                        return curry._1(serialize, curry._2(updateQuery, previousResult$1, {
                            fetchMoreResult: undefined,
                            variables: jsFetchMoreOptions.variables
                        }));
                    }
                    if (match$1.TAG === /* Ok */ 0) {
                        return curry._1(serialize, curry._2(updateQuery, previousResult$1, {
                            fetchMoreResult: caml_option/* some */.G(match$1._0),
                            variables: jsFetchMoreOptions.variables
                        }));
                    }
                    parseErrorDuringCall.contents = {
                        TAG: /* Error */ 1,
                        _0: match$1._0
                    };
                    return previousResult;
                }
                parseErrorDuringCall.contents = {
                    TAG: /* Error */ 1,
                    _0: match._0
                };
                return previousResult;
            };
        });
        if (tmp$2 !== undefined) {
            tmp.updateQuery = caml_option/* valFromOption */.xt(tmp$2);
        }
        var __x = js.fetchMore(tmp);
        var __x$1 = js_promise/* then_ */.k(function(jsApolloQueryResult) {
            var match = parseErrorDuringCall.contents;
            var tmp;
            tmp = match !== undefined && match.TAG !== /* Ok */ 0 ? {
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* ParseError */ 3,
                    _0: match._0
                }, undefined, undefined, undefined)
            } : ApolloQueryResult.toResult(ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse));
            return Promise.resolve(tmp);
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    var refetch = function refetch(mapJsVariablesOpt, variables, param) {
        var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
            return prim;
        };
        var __x = js.refetch(belt_Option/* map */.UI(variables, function(v) {
            return curry._1(mapJsVariables, curry._1(serializeVariables, v));
        }));
        var __x$1 = js_promise/* then_ */.k(function(jsApolloQueryResult) {
            return Promise.resolve(ApolloQueryResult.toResult(ApolloQueryResult.fromJs(jsApolloQueryResult, safeParse)));
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    var startPolling = function startPolling(pollInterval) {
        js.startPolling(pollInterval);
    };
    var stopPolling = function stopPolling(param) {
        js.stopPolling();
    };
    var subscribeToMore = function subscribeToMore(Operation, updateQuery, onError, context, variables) {
        var subscriptionSafeParse = function subscriptionSafeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        return js.subscribeToMore(SubscribeToMoreOptions.toJs({
            document: Operation.query,
            variables: variables,
            updateQuery: updateQuery,
            onError: belt_Option/* map */.UI(onError, function(onError, error) {
                curry._1(onError, {
                    TAG: /* SubscriptionError */ 1,
                    _0: error
                });
            }),
            context: context
        }, function(parseError) {
            if (onError !== undefined) {
                return curry._1(onError, {
                    TAG: /* ParseError */ 0,
                    _0: parseError
                });
            }
        }, safeParse, serialize, subscriptionSafeParse));
    };
    var updateQuery = function updateQuery(updateQueryFn) {
        js.updateQuery(function(jsPreviousData, options) {
            return curry._1(serialize, curry._2(updateQueryFn, curry._1(safeParse, jsPreviousData), options));
        });
    };
    return {
        called: js.called,
        client: js.client,
        data: match[0],
        previousData: previousData,
        error: match[1],
        loading: js.loading,
        networkStatus: NetworkStatus.fromJs(js.networkStatus),
        fetchMore: fetchMore,
        refetch: refetch,
        startPolling: startPolling,
        stopPolling: stopPolling,
        subscribeToMore: subscribeToMore,
        updateQuery: updateQuery
    };
}
var QueryResult = {
    Js_: ApolloClient_React_Types_bs_Js_$3,
    fromJs: ApolloClient_React_Types_bs_fromJs
};
var ApolloClient_React_Types_bs_Js_$4 = {};
function ApolloClient_React_Types_bs_fromJs$1(js) {
    return {
        loading: js.loading,
        networkStatus: NetworkStatus.fromJs(js.networkStatus),
        called: js.called
    };
}
var UnexecutedLazyResult = {
    Js_: ApolloClient_React_Types_bs_Js_$4,
    fromJs: ApolloClient_React_Types_bs_fromJs$1
};
function unexecutedLazyResult(v) {
    return v;
}
function queryResult(v) {
    return v;
}
function ApolloClient_React_Types_bs_classify(v) {
    if (function(value) {
        return "client" in value;
    }(v)) {
        return {
            TAG: /* QueryResult */ 1,
            _0: v
        };
    } else {
        return {
            TAG: /* UnexecutedLazyResult */ 0,
            _0: v
        };
    }
}
var ApolloClient_React_Types_bs_Union = {
    unexecutedLazyResult: unexecutedLazyResult,
    queryResult: queryResult,
    classify: ApolloClient_React_Types_bs_classify
};
var ApolloClient_React_Types_bs_Js_$5 = {
    Union: ApolloClient_React_Types_bs_Union
};
function fromJs$2(js, safeParse, serialize, serializeVariables) {
    var v = ApolloClient_React_Types_bs_classify(js);
    if (v.TAG === /* UnexecutedLazyResult */ 0) {
        return {
            TAG: /* Unexecuted */ 1,
            _0: ApolloClient_React_Types_bs_fromJs$1(v._0)
        };
    } else {
        return {
            TAG: /* Executed */ 0,
            _0: ApolloClient_React_Types_bs_fromJs(v._0, safeParse, serialize, serializeVariables)
        };
    }
}
var LazyQueryResult = {
    Js_: ApolloClient_React_Types_bs_Js_$5,
    fromJs: fromJs$2
};
var ApolloClient_React_Types_bs_Js_$6 = {};
function fromJs$3(param, safeParse, serialize, serializeVariables) {
    var jsExecuteQuery = param[0];
    return [
        function(context, mapJsVariablesOpt, variables) {
            var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
                return prim;
            };
            curry._1(jsExecuteQuery, {
                variables: curry._1(mapJsVariables, curry._1(serializeVariables, variables)),
                context: context
            });
        },
        fromJs$2(param[1], safeParse, serialize, serializeVariables)
    ];
}
var QueryTuple = {
    Js_: ApolloClient_React_Types_bs_Js_$6,
    fromJs: fromJs$3
};
var ApolloClient_React_Types_bs_Js_$7 = {};
function fromJs$4(param, mapJsVariables, safeParse, serialize, serializeVariables, variables) {
    var jsExecuteQuery = param[0];
    return [
        function(context, param) {
            curry._1(jsExecuteQuery, {
                variables: curry._1(mapJsVariables, curry._1(serializeVariables, variables)),
                context: context
            });
        },
        fromJs$2(param[1], safeParse, serialize, serializeVariables)
    ];
}
var QueryTuple__noVariables = {
    Js_: ApolloClient_React_Types_bs_Js_$7,
    fromJs: fromJs$4
};
var ApolloClient_React_Types_bs_Js_$8 = {};
var BaseMutationOptions = {
    Js_: ApolloClient_React_Types_bs_Js_$8
};
function ApolloClient_React_Types_bs_make$1(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9, prim10, prim11, prim12, prim13) {
    var tmp = {};
    if (prim0 !== undefined) {
        tmp.mutation = caml_option/* valFromOption */.xt(prim0);
    }
    if (prim1 !== undefined) {
        tmp.awaitRefetchQueries = caml_option/* valFromOption */.xt(prim1);
    }
    if (prim2 !== undefined) {
        tmp.client = caml_option/* valFromOption */.xt(prim2);
    }
    if (prim3 !== undefined) {
        tmp.context = caml_option/* valFromOption */.xt(prim3);
    }
    if (prim4 !== undefined) {
        tmp.errorPolicy = caml_option/* valFromOption */.xt(prim4);
    }
    if (prim5 !== undefined) {
        tmp.fetchPolicy = caml_option/* valFromOption */.xt(prim5);
    }
    if (prim6 !== undefined) {
        tmp.ignoreResults = caml_option/* valFromOption */.xt(prim6);
    }
    if (prim7 !== undefined) {
        tmp.notifyOnNetworkStatusChange = caml_option/* valFromOption */.xt(prim7);
    }
    if (prim8 !== undefined) {
        tmp.onError = caml_option/* valFromOption */.xt(prim8);
    }
    if (prim9 !== undefined) {
        tmp.optimisticResponse = caml_option/* valFromOption */.xt(prim9);
    }
    if (prim10 !== undefined) {
        tmp.refetchQueries = caml_option/* valFromOption */.xt(prim10);
    }
    if (prim11 !== undefined) {
        tmp.update = caml_option/* valFromOption */.xt(prim11);
    }
    if (prim12 !== undefined) {
        tmp.variables = caml_option/* valFromOption */.xt(prim12);
    }
    return tmp;
}
var ApolloClient_React_Types_bs_Js_$9 = {
    make: ApolloClient_React_Types_bs_make$1
};
function ApolloClient_React_Types_bs_toJs$2(t, mapJsVariables, safeParse, serialize, serializeVariables) {
    var func = MutationUpdaterFn.toJs;
    return ApolloClient_React_Types_bs_make$1(t.mutation, t.awaitRefetchQueries, t.client, t.context, belt_Option/* map */.UI(t.errorPolicy, ErrorPolicy.toJs), belt_Option/* map */.UI(t.fetchPolicy, FetchPolicy__noCacheExtracted.toJs), t.ignoreResults, t.notifyOnNetworkStatusChange, belt_Option/* map */.UI(t.onError, function(onError) {
        return function(jsApolloError) {
            curry._1(onError, fromJs(jsApolloError));
        };
    }), belt_Option/* map */.UI(t.optimisticResponse, function(optimisticResponse, variables) {
        return curry._1(serialize, curry._1(optimisticResponse, variables));
    }), belt_Option/* map */.UI(t.refetchQueries, RefetchQueryDescription.toJs), belt_Option/* map */.UI(t.update, function(param) {
        return curry._2(func, param, safeParse);
    }), belt_Option/* map */.UI(t.variables, function(v) {
        return curry._1(mapJsVariables, curry._1(serializeVariables, v));
    }), undefined);
}
var MutationHookOptions = {
    Js_: ApolloClient_React_Types_bs_Js_$9,
    toJs: ApolloClient_React_Types_bs_toJs$2
};
var ApolloClient_React_Types_bs_Js_$10 = {};
function fromJs$5(js, safeParse) {
    var match = safeParseAndLiftToCommonResultProps(caml_option/* nullable_to_opt */.Tl(js.data), undefined, belt_Option/* map */.UI(js.error, fromJs), safeParse);
    return {
        data: match[0],
        error: match[1],
        loading: js.loading,
        called: js.called,
        client: js.client
    };
}
var MutationResult = {
    Js_: ApolloClient_React_Types_bs_Js_$10,
    fromJs: fromJs$5
};
var ApolloClient_React_Types_bs_Js_$11 = {};
function ApolloClient_React_Types_bs_toJs$3(t, mapJsVariables, safeParse, serialize, serializeVariables) {
    var func = MutationUpdaterFn.toJs;
    return {
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        optimisticResponse: belt_Option/* map */.UI(t.optimisticResponse, function(optimisticResponse) {
            return function(variables) {
                return curry._1(serialize, curry._1(optimisticResponse, variables));
            };
        }),
        refetchQueries: belt_Option/* map */.UI(t.refetchQueries, RefetchQueryDescription.toJs),
        awaitRefetchQueries: t.awaitRefetchQueries,
        update: belt_Option/* map */.UI(t.update, function(param) {
            return curry._2(func, param, safeParse);
        }),
        context: t.context,
        fetchPolicy: belt_Option/* map */.UI(t.fetchPolicy, WatchQueryFetchPolicy.toJs)
    };
}
var MutationFunctionOptions = {
    Js_: ApolloClient_React_Types_bs_Js_$11,
    toJs: ApolloClient_React_Types_bs_toJs$3
};
var Js_$12 = {};
function fromJs$6(param, safeParse, serialize, serializeVariables) {
    var jsMutationFn = param[0];
    var mutationFn = function mutationFn(awaitRefetchQueries, context, fetchPolicy, mapJsVariablesOpt, optimisticResponse, refetchQueries, update, variables) {
        var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
            return prim;
        };
        var __x = curry._1(jsMutationFn, ApolloClient_React_Types_bs_toJs$3({
            variables: variables,
            optimisticResponse: optimisticResponse,
            refetchQueries: refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: context,
            fetchPolicy: fetchPolicy
        }, mapJsVariables, safeParse, serialize, serializeVariables));
        var __x$1 = js_promise/* then_ */.k(function(jsFetchResult) {
            return Promise.resolve(FetchResult.toResult(FetchResult.fromJs(jsFetchResult, safeParse)));
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    return [
        mutationFn,
        fromJs$5(param[1], safeParse)
    ];
}
var MutationTuple = {
    Js_: Js_$12,
    fromJs: fromJs$6
};
var Js_$13 = {};
function fromJs$7(param, mapJsVariables, safeParse, serialize, serializeVariables, variables) {
    var jsMutationFn = param[0];
    var mutationFn = function mutationFn(optimisticResponse, refetchQueries, awaitRefetchQueries, update, context, fetchPolicy, param) {
        var __x = curry._1(jsMutationFn, ApolloClient_React_Types_bs_toJs$3({
            variables: variables,
            optimisticResponse: optimisticResponse,
            refetchQueries: refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: context,
            fetchPolicy: fetchPolicy
        }, mapJsVariables, safeParse, serialize, serializeVariables));
        var __x$1 = js_promise/* then_ */.k(function(jsFetchResult) {
            return Promise.resolve(FetchResult.toResult(FetchResult.fromJs(jsFetchResult, safeParse)));
        }, __x);
        return js_promise/* $$catch */.y(function(error) {
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: make(undefined, {
                    TAG: /* FetchFailure */ 0,
                    _0: ApolloClient_Utils_bs_ensureError(error)
                }, undefined, undefined, undefined)
            });
        }, __x$1);
    };
    return [
        mutationFn,
        fromJs$5(param[1], safeParse)
    ];
}
var MutationTuple__noVariables = {
    Js_: Js_$13,
    fromJs: fromJs$7
};
var Js_$14 = {};
function fromJs$8(js, safeParse) {
    var match = safeParseAndLiftToCommonResultProps(js.data, undefined, belt_Option/* map */.UI(js.error, fromJs), safeParse);
    return {
        loading: js.loading,
        data: match[0],
        error: match[1]
    };
}
var SubscriptionResult = {
    Js_: Js_$14,
    fromJs: fromJs$8
};
var Js_$15 = {};
function fromJs$9(js, safeParse) {
    return {
        client: js.client,
        subscriptionData: fromJs$8(js.subscriptionData, safeParse)
    };
}
var OnSubscriptionDataOptions = {
    Js_: Js_$15,
    fromJs: fromJs$9
};
var Js_$16 = {};
function fromJs$10(js) {
    return {
        variables: js.variables,
        fetchPolicy: js.fetchPolicy,
        shouldResubscribe: js.shouldResubscribe,
        client: js.client,
        skip: js.skip,
        onSubscriptionData: js.onSubscriptionData,
        onSubscriptionComplete: js.onSubscriptionComplete
    };
}
var BaseSubscriptionOptions = {
    Js_: Js_$16,
    fromJs: fromJs$10
};
var Js_$17 = {};
function ApolloClient_React_Types_bs_toJs$4(t, mapJsVariables, safeParse, serializeVariables) {
    return {
        subscription: t.subscription,
        variables: curry._1(mapJsVariables, curry._1(serializeVariables, t.variables)),
        fetchPolicy: t.fetchPolicy,
        shouldResubscribe: belt_Option/* map */.UI(t.shouldResubscribe, function(shouldResubscribe) {
            return function(jsBaseSubscriptionOptions) {
                return curry._1(shouldResubscribe, fromJs$10(jsBaseSubscriptionOptions));
            };
        }),
        client: t.client,
        skip: t.skip,
        onSubscriptionData: belt_Option/* map */.UI(t.onSubscriptionData, function(onSubscriptionData) {
            return function(jsOnSubscriptionDataOptions) {
                curry._1(onSubscriptionData, fromJs$9(jsOnSubscriptionDataOptions, safeParse));
            };
        }),
        onSubscriptionComplete: t.onSubscriptionComplete
    };
}
var SubscriptionHookOptions = {
    Js_: Js_$17,
    toJs: ApolloClient_React_Types_bs_toJs$4
};
var ApolloClient;
var ApolloClient_React_Types_bs_ApolloError;
var ApolloClient_React_Types_bs_ApolloQueryResult;
var ApolloClient_React_Types_bs_ErrorPolicy;
var ApolloClient_React_Types_bs_FetchPolicy;
var ApolloClient_React_Types_bs_FetchPolicy_noCacheExtracted;
var ApolloClient_React_Types_bs_FetchResult;
var ApolloClient_React_Types_bs_Graphql;
var ApolloClient_React_Types_bs_MutationUpdaterFn;
var ApolloClient_React_Types_bs_NetworkStatus;
var ApolloClient_React_Types_bs_RefetchQueryDescription;
var ApolloClient_React_Types_bs_SubscribeToMoreOptions;
var ApolloClient_React_Types_bs_Types;
var ApolloClient_React_Types_bs_UpdateQueryFn;
var ApolloClient_React_Types_bs_Utils;
var ApolloClient_React_Types_bs_WatchQueryFetchPolicy;
 /* ApolloClient__Utils Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseLazyQuery.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var ApolloClient_React_Hooks_UseLazyQuery_bs_Js_ = {};
function useLazyQuery(Operation, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, param) {
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsQueryTuple = _apollo_client.useLazyQuery(Operation.query, LazyQueryHookOptions.toJs({
        query: undefined,
        displayName: displayName,
        onCompleted: onCompleted,
        onError: onError,
        client: client,
        context: context,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        nextFetchPolicy: nextFetchPolicy,
        notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
        partialRefetch: partialRefetch,
        pollInterval: pollInterval,
        ssr: ssr,
        variables: undefined
    }, safeParse, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        return QueryTuple.fromJs(jsQueryTuple, safeParse, Operation.serialize, Operation.serializeVariables);
    }, jsQueryTuple);
}
function useLazyQueryWithVariables(Operation, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, $staropt$star, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
        return prim;
    };
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsQueryTuple = _apollo_client.useLazyQuery(Operation.query, LazyQueryHookOptions.toJs({
        query: undefined,
        displayName: displayName,
        onCompleted: onCompleted,
        onError: onError,
        client: client,
        context: context,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        nextFetchPolicy: nextFetchPolicy,
        notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
        partialRefetch: partialRefetch,
        pollInterval: pollInterval,
        ssr: ssr,
        variables: caml_option/* some */.G(variables)
    }, safeParse, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        return QueryTuple__noVariables.fromJs(jsQueryTuple, mapJsVariables, safeParse, Operation.serialize, Operation.serializeVariables, variables);
    }, jsQueryTuple);
}
var ApolloClient_React_Hooks_UseLazyQuery_bs_ApolloClient;
var ApolloClient_React_Hooks_UseLazyQuery_bs_ApolloError;
var ApolloClient_React_Hooks_UseLazyQuery_bs_ErrorPolicy;
var ApolloClient_React_Hooks_UseLazyQuery_bs_Graphql;
var ApolloClient_React_Hooks_UseLazyQuery_bs_LazyQueryHookOptions;
var ApolloClient_React_Hooks_UseLazyQuery_bs_QueryTuple;
var ApolloClient_React_Hooks_UseLazyQuery_bs_QueryTuple_noVariables;
var ApolloClient_React_Hooks_UseLazyQuery_bs_Types;
var ApolloClient_React_Hooks_UseLazyQuery_bs_Utils;
var ApolloClient_React_Hooks_UseLazyQuery_bs_WatchQueryFetchPolicy;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_React_Hooks_UseQuery_bs_Js_ = {};
function useQuery(Operation, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, $staropt$star, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, skip, ssr, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
        return prim;
    };
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsQueryResult = _apollo_client.useQuery(Operation.query, QueryHookOptions.toJs({
        query: undefined,
        displayName: displayName,
        skip: skip,
        onCompleted: onCompleted,
        onError: onError,
        client: client,
        context: context,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        nextFetchPolicy: nextFetchPolicy,
        notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
        partialRefetch: partialRefetch,
        pollInterval: pollInterval,
        ssr: ssr,
        variables: variables
    }, mapJsVariables, safeParse, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        return QueryResult.fromJs(jsQueryResult, safeParse, Operation.serialize, Operation.serializeVariables);
    }, jsQueryResult);
}
function Extend(M) {
    var refetchQueryDescription = function refetchQueryDescription(context, mapJsVariablesOpt, variables) {
        var mapJsVariables = mapJsVariablesOpt !== undefined ? mapJsVariablesOpt : function mapJsVariables(prim) {
            return prim;
        };
        var jsVariables = curry._1(mapJsVariables, curry._1(M.serializeVariables, variables));
        return {
            TAG: /* PureQueryOptions */ 0,
            _0: {
                query: M.query,
                variables: jsVariables,
                context: context
            }
        };
    };
    var use = function use(client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, mapJsVariables, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, skip, ssr, variables) {
        return useQuery(M, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, mapJsVariables, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, skip, ssr, variables);
    };
    var useLazy = function useLazy(client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, param) {
        return useLazyQuery(M, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, undefined);
    };
    var useLazyWithVariables = function useLazyWithVariables(client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, mapJsVariables, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, variables) {
        return useLazyQueryWithVariables(M, client, context, displayName, errorPolicy, fetchPolicy, nextFetchPolicy, mapJsVariables, notifyOnNetworkStatusChange, onCompleted, onError, partialRefetch, pollInterval, ssr, variables);
    };
    return {
        refetchQueryDescription: refetchQueryDescription,
        use: use,
        useLazy: useLazy,
        useLazyWithVariables: useLazyWithVariables
    };
}
var ApolloClient_React_Hooks_UseQuery_bs_ApolloClient;
var ApolloClient_React_Hooks_UseQuery_bs_ApolloError;
var ApolloClient_React_Hooks_UseQuery_bs_ErrorPolicy;
var ApolloClient_React_Hooks_UseQuery_bs_Graphql;
var ApolloClient_React_Hooks_UseQuery_bs_QueryHookOptions;
var ApolloClient_React_Hooks_UseQuery_bs_QueryResult;
var ApolloClient_React_Hooks_UseQuery_bs_RefetchQueryDescription;
var ApolloClient_React_Hooks_UseQuery_bs_Types;
var ApolloClient_React_Hooks_UseQuery_bs_Utils;
var ApolloClient_React_Hooks_UseQuery_bs_WatchQueryFetchPolicy;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var ApolloClient_React_Hooks_UseMutation_bs_Js_ = {};
function useMutation(Operation, awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, param) {
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsMutationTuple = _apollo_client.useMutation(Operation.query, MutationHookOptions.toJs({
        mutation: undefined,
        awaitRefetchQueries: awaitRefetchQueries,
        context: context,
        client: client,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        ignoreResults: ignoreResults,
        notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
        onError: onError,
        onCompleted: onCompleted,
        optimisticResponse: optimisticResponse,
        refetchQueries: refetchQueries,
        update: update,
        variables: undefined
    }, function(prim) {
        return prim;
    }, safeParse, Operation.serialize, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        return MutationTuple.fromJs(jsMutationTuple, safeParse, Operation.serialize, Operation.serializeVariables);
    }, jsMutationTuple);
}
function useMutationWithVariables(Operation, awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, $staropt$star, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
        return prim;
    };
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsMutationTuple = _apollo_client.useMutation(Operation.query, MutationHookOptions.toJs({
        mutation: undefined,
        awaitRefetchQueries: awaitRefetchQueries,
        context: context,
        client: client,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        ignoreResults: ignoreResults,
        notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
        onError: onError,
        onCompleted: onCompleted,
        optimisticResponse: optimisticResponse,
        refetchQueries: refetchQueries,
        update: update,
        variables: caml_option/* some */.G(variables)
    }, mapJsVariables, safeParse, Operation.serialize, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        var match = MutationTuple__noVariables.fromJs(jsMutationTuple, mapJsVariables, safeParse, Operation.serialize, Operation.serializeVariables, variables);
        return [
            match[0],
            match[1]
        ];
    }, jsMutationTuple);
}
function ApolloClient_React_Hooks_UseMutation_bs_Extend(M) {
    var use = function use(awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, param) {
        return useMutation(M, awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, undefined);
    };
    var useWithVariables = function useWithVariables(awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, mapJsVariables, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, variables) {
        return useMutationWithVariables(M, awaitRefetchQueries, context, client, errorPolicy, fetchPolicy, ignoreResults, mapJsVariables, notifyOnNetworkStatusChange, onError, onCompleted, optimisticResponse, refetchQueries, update, variables);
    };
    return {
        use: use,
        useWithVariables: useWithVariables
    };
}
var ApolloClient_React_Hooks_UseMutation_bs_ApolloClient;
var ApolloClient_React_Hooks_UseMutation_bs_ApolloError;
var ApolloClient_React_Hooks_UseMutation_bs_ErrorPolicy;
var ApolloClient_React_Hooks_UseMutation_bs_FetchPolicy_noCacheExtracted;
var ApolloClient_React_Hooks_UseMutation_bs_Graphql;
var ApolloClient_React_Hooks_UseMutation_bs_MutationHookOptions;
var ApolloClient_React_Hooks_UseMutation_bs_MutationTuple;
var ApolloClient_React_Hooks_UseMutation_bs_MutationTuple_noVariables;
var ApolloClient_React_Hooks_UseMutation_bs_MutationUpdaterFn;
var ApolloClient_React_Hooks_UseMutation_bs_OperationVariables;
var ApolloClient_React_Hooks_UseMutation_bs_RefetchQueryDescription;
var ApolloClient_React_Hooks_UseMutation_bs_Types;
var ApolloClient_React_Hooks_UseMutation_bs_Utils;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_ReactiveVars.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ApolloClient_Cache_InMemory_ReactiveVars_bs_Js_ = {};
var ReactiveVar = {
    Js_: ApolloClient_Cache_InMemory_ReactiveVars_bs_Js_
};
var ApolloClient_Cache_InMemory_ReactiveVars_bs_Js_$1 = {};
function makeVar(prim) {
    return core.makeVar(prim);
}
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseSubscription.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_React_Hooks_UseSubscription_bs_Js_ = {};
function useSubscription(Operation, client, fetchPolicy, $staropt$star, onSubscriptionData, onSubscriptionComplete, shouldResubscribe, skip, variables) {
    var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
        return prim;
    };
    var safeParse = function safeParse(param) {
        return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
    };
    var jsSubscriptionResult = _apollo_client.useSubscription(Operation.query, SubscriptionHookOptions.toJs({
        subscription: undefined,
        variables: variables,
        fetchPolicy: fetchPolicy,
        shouldResubscribe: shouldResubscribe,
        client: client,
        skip: skip,
        onSubscriptionData: onSubscriptionData,
        onSubscriptionComplete: onSubscriptionComplete
    }, mapJsVariables, safeParse, Operation.serializeVariables));
    return useGuaranteedMemo1(function(param) {
        return {
            variables: jsSubscriptionResult.variables,
            loading: jsSubscriptionResult.loading,
            data: belt_Option/* map */.UI(jsSubscriptionResult.data, Operation.parse),
            error: belt_Option/* map */.UI(jsSubscriptionResult.error, fromJs)
        };
    }, jsSubscriptionResult);
}
function ApolloClient_React_Hooks_UseSubscription_bs_Extend(M) {
    var use = function use(client, fetchPolicy, onSubscriptionData, onSubscriptionComplete, shouldResubscribe, skip, variables) {
        return useSubscription(M, client, fetchPolicy, undefined, onSubscriptionData, onSubscriptionComplete, shouldResubscribe, skip, variables);
    };
    return {
        use: use
    };
}
var ApolloClient_React_Hooks_UseSubscription_bs_ApolloClient;
var ApolloClient_React_Hooks_UseSubscription_bs_ApolloError;
var ApolloClient_React_Hooks_UseSubscription_bs_BaseSubscriptionOptions;
var ApolloClient_React_Hooks_UseSubscription_bs_FetchPolicy;
var ApolloClient_React_Hooks_UseSubscription_bs_Graphql;
var ApolloClient_React_Hooks_UseSubscription_bs_OnSubscriptionDataOptions;
var ApolloClient_React_Hooks_UseSubscription_bs_SubscriptionHookOptions;
var ApolloClient_React_Hooks_UseSubscription_bs_Types;
var ApolloClient_React_Hooks_UseSubscription_bs_Utils;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








function useApolloClient(prim) {
    return _apollo_client.useApolloClient();
}
var React = {
    ApolloProvider: undefined,
    useApolloClient: useApolloClient,
    useMutation: useMutation,
    useMutationWithVariables: useMutationWithVariables,
    useLazyQuery: useLazyQuery,
    useLazyQueryWithVariables: useLazyQueryWithVariables,
    useQuery: useQuery,
    useSubscription: useSubscription
};
var Cache = {
    InMemoryCache: undefined,
    makeVar: makeVar
};
function ReasonMLCommunity_ApolloClient_bs_concat(prim0, prim1) {
    return _apollo_client.ApolloLink.concat(prim0, prim1);
}
function execute(prim0, prim1) {
    return _apollo_client.ApolloLink.execute(prim0, prim1);
}
function empty(prim) {
    return _apollo_client.ApolloLink.empty();
}
function ReasonMLCommunity_ApolloClient_bs_from(prim) {
    return _apollo_client.ApolloLink.from(prim);
}
function ReasonMLCommunity_ApolloClient_bs_split(prim0, prim1, prim2) {
    return _apollo_client.ApolloLink.split(prim0, prim1, prim2);
}
var Link = {
    ContextLink: undefined,
    ErrorLink: undefined,
    HttpLink: undefined,
    RetryLink: undefined,
    WebSocketLink: undefined,
    concat: ReasonMLCommunity_ApolloClient_bs_concat,
    execute: execute,
    empty: empty,
    make: ApolloClient_Link_Core_ApolloLink_bs_make,
    from: ReasonMLCommunity_ApolloClient_bs_from,
    split: ReasonMLCommunity_ApolloClient_bs_split
};
var Bindings = {
    Client: undefined,
    Graphql: undefined,
    SubscriptionTransportWs: undefined,
    ZenObservable: undefined
};
var GraphQL_PPX = {
    ExtendMutation: undefined,
    ExtendQuery: undefined,
    ExtendSubscription: undefined
};
var ReasonMLCommunity_ApolloClient_bs_Types = {
    ApolloError: undefined,
    ApolloQueryResult: undefined,
    ApolloLink: undefined,
    ApolloCache: undefined,
    BaseSubscriptionOptions: undefined,
    ConnectionParamsOptions: undefined,
    DataProxy: undefined,
    ErrorPolicy: undefined,
    ErrorResponse: undefined,
    FetchPolicy: undefined,
    FetchPolicy__noCacheExtracted: undefined,
    FetchResult: undefined,
    FieldPolicy: undefined,
    FieldReadFunction: undefined,
    FieldMergeFunction: undefined,
    FragmentMatcher: undefined,
    GraphqlError: undefined,
    GraphQLRequest: undefined,
    KeyArgs: undefined,
    KeySpecifier: undefined,
    KeyFieldsFunction: undefined,
    LazyQueryHookOptions: undefined,
    MutationHookOptions: undefined,
    MutationOptions: undefined,
    MutationQueryReducersMap: undefined,
    MutationTuple: undefined,
    MutationTuple__noVariables: undefined,
    MutationUpdaterFn: undefined,
    Observable: undefined,
    ObservableQuery: undefined,
    OnSubscriptionDataOptions: undefined,
    Operation: undefined,
    OperationVariables: undefined,
    QueryHookOptions: undefined,
    QueryOptions: undefined,
    QueryTuple: undefined,
    QueryTuple__noVariables: undefined,
    QueryResult: undefined,
    PossibleTypesMap: undefined,
    PureQueryOptions: undefined,
    ReactiveVar: undefined,
    RefetchQueryDescription: undefined,
    RequestHandler: undefined,
    Resolvers: undefined,
    SubscriptionHookOptions: undefined,
    SubscriptionOptions: undefined,
    TypePolicies: undefined,
    TypePolicy: undefined,
    UriFunction: undefined,
    WatchQueryFetchPolicy: undefined,
    WatchQueryOptions: undefined
};
var ReasonMLCommunity_ApolloClient_bs_make = make$4;
var ReasonMLCommunity_ApolloClient_bs_DefaultWatchQueryOptions;
var ReasonMLCommunity_ApolloClient_bs_DefaultQueryOptions;
var ReasonMLCommunity_ApolloClient_bs_DefaultMutateOptions;
var ReasonMLCommunity_ApolloClient_bs_DefaultOptions;
var Utilities;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/ApolloClient.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ApolloClient_bs_make = ReasonMLCommunity_ApolloClient_bs_make;
var ApolloClient_bs_DefaultWatchQueryOptions = ReasonMLCommunity_ApolloClient_bs_DefaultWatchQueryOptions;
var ApolloClient_bs_DefaultQueryOptions = ReasonMLCommunity_ApolloClient_bs_DefaultQueryOptions;
var ApolloClient_bs_DefaultMutateOptions = ReasonMLCommunity_ApolloClient_bs_DefaultMutateOptions;
var ApolloClient_bs_DefaultOptions = ReasonMLCommunity_ApolloClient_bs_DefaultOptions;
var ApolloClient_bs_React = React;
var ApolloClient_bs_Cache = Cache;
var ApolloClient_bs_Link = Link;
var ApolloClient_bs_Utilities = Utilities;
var ApolloClient_bs_Bindings = Bindings;
var ApolloClient_bs_GraphQL_PPX = GraphQL_PPX;
var ApolloClient_bs_Types = ReasonMLCommunity_ApolloClient_bs_Types;
 /* ReasonMLCommunity__ApolloClient Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var link_error = __webpack_require__(13984);
;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/link/error/ApolloClient__Link_Error.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function ApolloClient_Link_Error_bs_error(v) {
    return v;
}
function ApolloClient_Link_Error_bs_serverError(v) {
    return v;
}
function ApolloClient_Link_Error_bs_serverParseError(v) {
    return v;
}
function ApolloClient_Link_Error_bs_classify(v) {
    if (function(v) {
        return "bodyText" in v && "response" in v && "statusCode" in v;
    }(v)) {
        return {
            TAG: /* ServerError */ 1,
            _0: v
        };
    } else if (function(v) {
        return "result" in v && "response" in v && "statusCode" in v;
    }(v)) {
        return {
            TAG: /* ServerParseError */ 2,
            _0: v
        };
    } else {
        return {
            TAG: /* Error */ 0,
            _0: v
        };
    }
}
var ApolloClient_Link_Error_bs_NetworkErrorUnion = {
    error: ApolloClient_Link_Error_bs_error,
    serverError: ApolloClient_Link_Error_bs_serverError,
    serverParseError: ApolloClient_Link_Error_bs_serverParseError,
    classify: ApolloClient_Link_Error_bs_classify
};
var ApolloClient_Link_Error_bs_Js_ = {
    NetworkErrorUnion: ApolloClient_Link_Error_bs_NetworkErrorUnion
};
function ApolloClient_Link_Error_bs_fromJs(js) {
    return {
        graphQLErrors: js.graphQLErrors,
        networkError: belt_Option/* map */.UI(js.networkError, function(networkError) {
            var _$error = ApolloClient_Link_Error_bs_classify(networkError);
            switch(_$error.TAG | 0){
                case /* Error */ 0:
                    return {
                        TAG: /* FetchFailure */ 0,
                        _0: _$error._0
                    };
                case /* ServerError */ 1:
                    var error$1 = _$error._0;
                    return {
                        TAG: /* BadStatus */ 1,
                        _0: error$1.statusCode,
                        _1: error$1
                    };
                case /* ServerParseError */ 2:
                    return {
                        TAG: /* BadBody */ 2,
                        _0: _$error._0
                    };
            }
        }),
        response: js.response,
        operation: Operation.fromJs(js.operation),
        forward: function forward(operation) {
            return js.forward(operation);
        }
    };
}
var ErrorResponse = {
    Js_: ApolloClient_Link_Error_bs_Js_,
    fromJs: ApolloClient_Link_Error_bs_fromJs
};
var ApolloClient_Link_Error_bs_Js_$1 = {};
var ErrorHandler = {
    Js_: ApolloClient_Link_Error_bs_Js_$1
};
var ApolloClient_Link_Error_bs_Js_$2 = {};
function onError(errorCb) {
    return link_error/* onError */.q(function(jsErrorResponse) {
        return curry._1(errorCb, ApolloClient_Link_Error_bs_fromJs(jsErrorResponse));
    });
}
var ErrorLink = {
    make: onError
};
var ApolloClient_Link_Error_bs_ApolloLink;
var ApolloClient_Link_Error_bs_ApolloError;
var ApolloClient_Link_Error_bs_GraphQLError;
var ExecutionResult;
var ApolloClient_Link_Error_bs_FetchResult;
var ApolloClient_Link_Error_bs_NextLink;
var ApolloClient_Link_Error_bs_Observable;
var ApolloClient_Link_Error_bs_Operation;
var ApolloClient_Link_Error_bs_ServerError;
var ApolloClient_Link_Error_bs_ServerParseError;
 /* @apollo/client/link/error Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/link/http/ApolloClient__Link_Http_HttpLink.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var ApolloClient_Link_Http_HttpLink_bs_Js_ = {};
function ApolloClient_Link_Http_HttpLink_bs_make(uri, includeExtensions, $$fetch, headers, credentials, fetchOptions, useGETForQueries, param) {
    return new core.HttpLink({
        uri: uri,
        includeExtensions: includeExtensions,
        fetch: $$fetch,
        headers: headers,
        credentials: credentials,
        fetchOptions: fetchOptions,
        useGETForQueries: useGETForQueries
    });
}
var ApolloClient_Link_Http_HttpLink_bs_ApolloLink;
var HttpOptions;
var ApolloClient_Link_Http_HttpLink_bs_UriFunction;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/core/ApolloClient__Cache_Core_Cache.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var ApolloClient_Cache_Core_Cache_bs_Js_ = {};
function ApolloClient_Cache_Core_Cache_bs_preserveJsPropsAndContext(js, t) {
    return function(js, t) {
        return Object.assign(js, t);
    }(js, t);
}
function ApolloClient_Cache_Core_Cache_bs_fromJs(js) {
    var readFragment = function readFragment(Fragment, id, optimistic, fragmentName, param) {
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Fragment.parse, param);
        };
        return belt_Option/* map */.UI(caml_option/* nullable_to_opt */.Tl(js.readFragment({
            id: id,
            fragment: Fragment.query,
            fragmentName: fragmentName
        }, optimistic !== undefined ? caml_option/* valFromOption */.xt(optimistic) : undefined)), safeParse);
    };
    var readQuery = function readQuery(Operation, id, $staropt$star, optimistic, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        var safeParse = function safeParse(param) {
            return ApolloClient_Utils_bs_safeParse(Operation.parse, param);
        };
        return belt_Option/* map */.UI(caml_option/* nullable_to_opt */.Tl(js.readQuery(Query.toJs({
            query: Operation.query,
            variables: variables,
            id: id
        }, mapJsVariables, Operation.serializeVariables), optimistic)), safeParse);
    };
    var writeFragment = function writeFragment(Fragment, data, broadcast, id, fragmentName, param) {
        return js.writeFragment(WriteFragmentOptions.toJs({
            data: data,
            broadcast: broadcast,
            id: id,
            fragment: Fragment.query,
            fragmentName: fragmentName
        }, Fragment.serialize));
    };
    var writeQuery = function writeQuery(Operation, broadcast, data, id, $staropt$star, variables) {
        var mapJsVariables = $staropt$star !== undefined ? $staropt$star : function mapJsVariables(prim) {
            return prim;
        };
        return js.writeQuery(WriteQueryOptions.toJs({
            data: data,
            broadcast: broadcast,
            query: Operation.query,
            variables: variables,
            id: id
        }, mapJsVariables, Operation.serialize, Operation.serializeVariables));
    };
    return ApolloClient_Cache_Core_Cache_bs_preserveJsPropsAndContext(js, {
        rescript_readFragment: readFragment,
        rescript_readQuery: readQuery,
        rescript_writeFragment: writeFragment,
        rescript_writeQuery: writeQuery
    });
}
var ApolloClient_Cache_Core_Cache_bs_ApolloCache = {
    Js_: ApolloClient_Cache_Core_Cache_bs_Js_,
    preserveJsPropsAndContext: ApolloClient_Cache_Core_Cache_bs_preserveJsPropsAndContext,
    fromJs: ApolloClient_Cache_Core_Cache_bs_fromJs
};
var ApolloClient_Cache_Core_Cache_bs_DataProxy;
var ApolloClient_Cache_Core_Cache_bs_Types;
var ApolloClient_Cache_Core_Cache_bs_Utils;
 /* ApolloClient__Utils Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/index.js + 20 modules
var utilities = __webpack_require__(94248);
;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_Policies_FieldPolicy.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_ = {};
var FieldMergeFunction = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$1 = {};
var StorageType = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$1
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$2 = {};
function ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_fromJs(js) {
    return {
        args: js.args,
        fieldName: js.fieldName,
        storeFieldName: js.storeFieldName,
        field: js.field,
        variables: js.variables,
        isReference: js.isReference,
        toReference: js.toReference,
        storage: js.storage,
        cache: js.cache,
        readField: js.readField,
        canRead: js.canRead,
        mergeObjects: function mergeObjects(existing, incoming) {
            return js.canRead(existing, incoming);
        }
    };
}
var FieldFunctionOptions = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$2,
    fromJs: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_fromJs
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$3 = {};
function ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs(t, existing, jsFieldFunctionOptions) {
    return curry._2(t, existing, ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_fromJs(jsFieldFunctionOptions));
}
var FieldReadFunction = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$3,
    toJs: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$4 = {};
var KeySpecifier = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$4
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$5 = {};
var KeyArgsFunction = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$5
};
function keySpecifier(v) {
    return v;
}
function keyArgsFunction(v) {
    return v;
}
var KeyArgsUnion = {
    keySpecifier: keySpecifier,
    keyArgsFunction: keyArgsFunction,
    false_: false
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$6 = {
    KeyArgsUnion: KeyArgsUnion
};
function ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs$1(x) {
    if (typeof x === "number") {
        return false;
    } else {
        return x._0;
    }
}
var FieldPolicy_KeyArgs = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$6,
    toJs: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs$1
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$7 = {};
function ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs$2(t) {
    return {
        keyArgs: belt_Option/* map */.UI(t.keyArgs, ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs$1),
        read: belt_Option/* map */.UI(t.read, ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs),
        merge: t.merge
    };
}
var FieldPolicy = {
    Js_: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_Js_$7,
    toJs: ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_toJs$2
};
var ApolloClient_Cache_InMemory_Policies_FieldPolicy_bs_ApolloCache;
var CanReadFunction;
var FieldNode;
var ReadFieldFunction;
var ToReferenceFunction;
 /* No side effect */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/utilities/policies/ApolloClient__Utilities_Policies_Pagination.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var ApolloClient_Utilities_Policies_Pagination_bs_Js_ = {};
function concatPagination(keyArgs) {
    return utilities/* concatPagination */.xn(caml_option/* some */.G(FieldPolicy_KeyArgs.toJs(keyArgs)));
}
function offsetLimitPagination(keyArgs) {
    return utilities/* offsetLimitPagination */.CV(caml_option/* some */.G(FieldPolicy_KeyArgs.toJs(keyArgs)));
}
function relayStylePagination(keyArgs) {
    return utilities/* relayStylePagination */.ZB(caml_option/* some */.G(FieldPolicy_KeyArgs.toJs(keyArgs)));
}
var ApolloClient_Utilities_Policies_Pagination_bs_FieldPolicy;
var KeyArgs;
 /* @apollo/client/utilities Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_Policies.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_Cache_InMemory_Policies_bs_Js_ = {};
var KeyFieldsContext = {
    Js_: ApolloClient_Cache_InMemory_Policies_bs_Js_
};
var ApolloClient_Cache_InMemory_Policies_bs_Js_$1 = {};
var KeyFieldsFunction = {
    Js_: ApolloClient_Cache_InMemory_Policies_bs_Js_$1
};
function fieldPolicy(v) {
    return v;
}
function fieldReadFunction(v) {
    return v;
}
var FieldsUnion = {
    fieldPolicy: fieldPolicy,
    fieldReadFunction: fieldReadFunction
};
var ApolloClient_Cache_InMemory_Policies_bs_Js_$2 = {
    FieldsUnion: FieldsUnion
};
function ApolloClient_Cache_InMemory_Policies_bs_toJs(t) {
    return {
        keyFields: belt_Option/* map */.UI(t.keyFields, FieldPolicy_KeyArgs.toJs),
        queryType: t.queryType,
        mutationType: t.mutationType,
        subscriptionType: t.subscriptionType,
        fields: belt_Option/* map */.UI(t.fields, function(fields) {
            return js_dict/* fromArray */.nI(belt_Array/* map */.UI(fields, function(param) {
                var t_field = param[1];
                var tmp;
                switch(t_field.TAG | 0){
                    case /* ConcatPagination */ 0:
                        tmp = concatPagination(t_field._0);
                        break;
                    case /* OffsetLimitPagination */ 1:
                        tmp = offsetLimitPagination(t_field._0);
                        break;
                    case /* RelayStylePagination */ 2:
                        tmp = relayStylePagination(t_field._0);
                        break;
                    case /* FieldPolicy */ 3:
                        tmp = FieldPolicy.toJs(t_field._0);
                        break;
                    case /* FieldReadFunction */ 4:
                        var partial_arg = t_field._0;
                        tmp = function tmp(param, param$1) {
                            return FieldReadFunction.toJs(partial_arg, param, param$1);
                        };
                        break;
                }
                return [
                    param[0],
                    tmp
                ];
            }));
        })
    };
}
function ApolloClient_Cache_InMemory_Policies_bs_make(fields, keyFields, mutationType, queryType, subscriptionType, param) {
    return {
        keyFields: keyFields,
        queryType: queryType,
        mutationType: mutationType,
        subscriptionType: subscriptionType,
        fields: fields
    };
}
var TypePolicy = {
    Js_: ApolloClient_Cache_InMemory_Policies_bs_Js_$2,
    toJs: ApolloClient_Cache_InMemory_Policies_bs_toJs,
    make: ApolloClient_Cache_InMemory_Policies_bs_make
};
var ApolloClient_Cache_InMemory_Policies_bs_Js_$3 = {};
function ApolloClient_Cache_InMemory_Policies_bs_toJs$1(t) {
    return js_dict/* fromArray */.nI(belt_Array/* map */.UI(t, function(param) {
        return [
            param[0],
            ApolloClient_Cache_InMemory_Policies_bs_toJs(param[1])
        ];
    }));
}
var TypePolicies = {
    Js_: ApolloClient_Cache_InMemory_Policies_bs_Js_$3,
    toJs: ApolloClient_Cache_InMemory_Policies_bs_toJs$1
};
var ApolloClient_Cache_InMemory_Policies_bs_Js_$4 = {};
var PossibleTypesMap = {
    Js_: ApolloClient_Cache_InMemory_Policies_bs_Js_$4
};
var FragmentMap;
var ApolloClient_Cache_InMemory_Policies_bs_FieldPolicy;
var ApolloClient_Cache_InMemory_Policies_bs_FieldReadFunction;
var ApolloClient_Cache_InMemory_Policies_bs_FieldMergeFunction;
var ApolloClient_Cache_InMemory_Policies_bs_KeyArgs;
var ApolloClient_Cache_InMemory_Policies_bs_KeySpecifier;
var Pagination;
var SelectionSetNode;
 /* ApolloClient__Utilities_Policies_Pagination Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_InMemoryCache.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var ApolloClient_Cache_InMemory_InMemoryCache_bs_Js_ = {};
function ApolloClient_Cache_InMemory_InMemoryCache_bs_make(prim0, prim1, prim2, prim3, prim4, prim5) {
    var tmp = {};
    if (prim0 !== undefined) {
        tmp.resultCaching = caml_option/* valFromOption */.xt(prim0);
    }
    if (prim1 !== undefined) {
        tmp.possibleTypes = caml_option/* valFromOption */.xt(prim1);
    }
    if (prim2 !== undefined) {
        tmp.typePolicies = caml_option/* valFromOption */.xt(prim2);
    }
    if (prim3 !== undefined) {
        tmp.dataIdFromObject = caml_option/* valFromOption */.xt(prim3);
    }
    if (prim4 !== undefined) {
        tmp.addTypename = caml_option/* valFromOption */.xt(prim4);
    }
    return tmp;
}
var InMemoryCacheConfig = {
    Js_: ApolloClient_Cache_InMemory_InMemoryCache_bs_Js_,
    make: ApolloClient_Cache_InMemory_InMemoryCache_bs_make
};
var ApolloClient_Cache_InMemory_InMemoryCache_bs_Js_$1 = {};
function ApolloClient_Cache_InMemory_InMemoryCache_bs_make$1(addTypename, dataIdFromObject, possibleTypes, resultCaching, typePolicies, param) {
    return ApolloClient_Cache_Core_Cache_bs_ApolloCache.fromJs(new core.InMemoryCache(ApolloClient_Cache_InMemory_InMemoryCache_bs_make(resultCaching, possibleTypes, belt_Option/* map */.UI(typePolicies, TypePolicies.toJs), dataIdFromObject, addTypename, undefined)));
}
var ApolloClient_Cache_InMemory_InMemoryCache_bs_ApolloCache;
var ApolloClient_Cache_InMemory_InMemoryCache_bs_KeyFieldsFunction;
var ApolloClient_Cache_InMemory_InMemoryCache_bs_PossibleTypesMap;
var ApolloClient_Cache_InMemory_InMemoryCache_bs_TypePolicy;
var ApolloClient_Cache_InMemory_InMemoryCache_bs_TypePolicies;
 /* @apollo/client Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Apollo.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var isServer = "object" === "undefined";
var errorLink = ErrorLink.make(function(param) {
    var networkError = param.networkError;
    var graphQLErrors = param.graphQLErrors;
    if (belt_Option/* isSome */.pC(networkError) && isServer) {
        Pino_bs/* logger.error */.k.error({
            err: networkError,
            type: "Apollo"
        }, "error: Graphql network error");
    }
    if (belt_Option/* isSome */.pC(graphQLErrors) && isServer) {
        Pino_bs/* logger.error */.k.error({
            err: graphQLErrors,
            type: "Apollo"
        }, "error: Graphql error");
    }
    return caml_option/* some */.G(curry._1(param.forward, param.operation));
});
var httpLink = ApolloClient_Link_Http_HttpLink_bs_make(function(param) {
    return "https://prezzee-prod-nz.graphcdn.app/";
}, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
var client = ApolloClient_bs_make(undefined, undefined, undefined, caml_option/* some */.G(Link.from([
    errorLink,
    httpLink
])), ApolloClient_Cache_InMemory_InMemoryCache_bs_make$1(undefined, undefined, undefined, false, undefined, undefined), undefined, true, false, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
 /* isServer Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/GqlUtils.bs.js
var GqlUtils_bs = __webpack_require__(93717);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_array.js
var js_array = __webpack_require__(32867);
;// CONCATENATED MODULE: ./node_modules/@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function deepMerge(json1, json2) {
    var match_0 = json1 === null;
    var match_1 = Array.isArray(json1);
    var match_2 = typeof json1 === "object";
    var match_0$1 = json2 === null;
    var match_1$1 = Array.isArray(json2);
    var match_2$1 = typeof json2 === "object";
    if (match_1) {
        if (match_1$1) {
            return js_array/* mapi */.x1(function(el1, idx) {
                var el2 = json2[idx];
                if (typeof el2 === "object") {
                    return deepMerge(el1, el2);
                } else {
                    return el2;
                }
            }, json1);
        } else {
            return json2;
        }
    }
    if (match_0) {
        return json2;
    }
    if (!match_2) {
        return json2;
    }
    if (match_0$1) {
        return json2;
    }
    if (match_1$1) {
        return json2;
    }
    if (!match_2$1) {
        return json2;
    }
    var obj1 = Object.assign({}, json1);
    js_array/* forEach */.Ed(function(key) {
        var existingVal = obj1[key];
        var newVal = json2[key];
        obj1[key] = typeof existingVal !== "object" ? newVal : deepMerge(existingVal, newVal);
    }, Object.keys(json2));
    return obj1;
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Video/Gql__Video__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment Video on VideoContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    url  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Raw = {};
var query = (__webpack_require__(46829).gql)(_templateObject());
function parse(value) {
    var value$1 = value.system;
    var value$2 = value.url;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        url: tmp
    };
}
function serialize(value) {
    var value$1 = value.url;
    var url;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        url = {
            __typename: value$4,
            value: value$3
        };
    } else {
        url = null;
    }
    var value$5 = value.system;
    var value$6 = value$5.codename;
    var value$7 = value$5.id;
    var value$8 = value$5.__typename;
    var system = {
        __typename: value$8,
        id: value$7,
        codename: value$6
    };
    var value$9 = value.__typename;
    return {
        __typename: value$9,
        system: system,
        url: url
    };
}
function verifyArgsAndParse(_Video, value) {
    return parse(value);
}
function verifyName(param) {}
var Video = {
    Raw: Raw,
    query: query,
    parse: parse,
    serialize: serialize,
    verifyArgsAndParse: verifyArgsAndParse,
    verifyName: verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/FAQ/Gql__FAQ__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FAQ_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FAQBlock on FaqBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    faq_sections  {\n      __typename\n      value  {\n        __typename\n        ...on FaqSectionContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          faq_items  {\n            __typename\n            value  {\n              __typename\n              ...on FaqItemContentType   {\n                __typename\n                system  {\n                  __typename\n                  id\n                  codename\n                }\n                title  {\n                  __typename\n                  value\n                }\n                body_text  {\n                  __typename\n                  value\n                }\n                body_content  {\n                  __typename\n                  value  {\n                    __typename\n                    ...on RichTextBlockContentType   {\n                      __typename\n                      content  {\n                        __typename\n                        value\n                      }\n                    }\n                    ...on VideoContentType   {\n                      ...Video\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    additional_content  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_FAQ_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_FAQ_Fragment_bs_Raw = {};
var Gql_FAQ_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_FAQ_Fragment_bs_templateObject(), frag_0);
}(Video.query);
function Gql_FAQ_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.faq_sections;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "FaqSectionContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.faq_items;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp;
                                if (typename === "FaqItemContentType") {
                                    var value$1 = value.system;
                                    var value$2 = value.title;
                                    var tmp$1;
                                    if (value$2 == null) {
                                        tmp$1 = undefined;
                                    } else {
                                        var value$3 = value$2.value;
                                        tmp$1 = {
                                            __typename: value$2.__typename,
                                            value: !(value$3 == null) ? value$3 : undefined
                                        };
                                    }
                                    var value$4 = value.body_text;
                                    var tmp$2;
                                    if (value$4 == null) {
                                        tmp$2 = undefined;
                                    } else {
                                        var value$5 = value$4.value;
                                        tmp$2 = {
                                            __typename: value$4.__typename,
                                            value: !(value$5 == null) ? value$5 : undefined
                                        };
                                    }
                                    var value$6 = value.body_content;
                                    var tmp$3;
                                    if (value$6 == null) {
                                        tmp$3 = undefined;
                                    } else {
                                        var value$7 = value$6.value;
                                        tmp$3 = {
                                            __typename: value$6.__typename,
                                            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                                if (value == null) {
                                                    return;
                                                }
                                                var typename = value["__typename"];
                                                var tmp;
                                                switch(typename){
                                                    case "RichTextBlockContentType":
                                                        var value$1 = value.content;
                                                        var tmp$1;
                                                        if (value$1 == null) {
                                                            tmp$1 = undefined;
                                                        } else {
                                                            var value$2 = value$1.value;
                                                            tmp$1 = {
                                                                __typename: value$1.__typename,
                                                                value: !(value$2 == null) ? value$2 : undefined
                                                            };
                                                        }
                                                        tmp = {
                                                            NAME: "RichTextBlockContentType",
                                                            VAL: {
                                                                __typename: value.__typename,
                                                                content: tmp$1
                                                            }
                                                        };
                                                        break;
                                                    case "VideoContentType":
                                                        tmp = {
                                                            NAME: "VideoContentType",
                                                            VAL: {
                                                                video: Video.verifyArgsAndParse("Video", value)
                                                            }
                                                        };
                                                        break;
                                                    default:
                                                        tmp = {
                                                            NAME: "UnspecifiedFragment",
                                                            VAL: typename
                                                        };
                                                }
                                                return tmp;
                                            }, value$7) : undefined
                                        };
                                    }
                                    tmp = {
                                        NAME: "FaqItemContentType",
                                        VAL: {
                                            __typename: value.__typename,
                                            system: {
                                                __typename: value$1.__typename,
                                                id: value$1.id,
                                                codename: value$1.codename
                                            },
                                            title: tmp$1,
                                            body_text: tmp$2,
                                            body_content: tmp$3
                                        }
                                    };
                                } else {
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                                }
                                return tmp;
                            }, value$5) : undefined
                        };
                    }
                    tmp = {
                        NAME: "FaqSectionContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            faq_items: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.additional_content;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        faq_sections: tmp$1,
        additional_content: tmp$2
    };
}
function Gql_FAQ_Fragment_bs_serialize(value) {
    var value$1 = value.additional_content;
    var additional_content;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        additional_content = {
            __typename: value$4,
            value: value$3
        };
    } else {
        additional_content = null;
    }
    var value$5 = value.faq_sections;
    var faq_sections;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME !== "FaqSectionContentType") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.faq_items;
            var faq_items;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    }
                    var value$1 = value.VAL;
                    var value$2 = value$1.body_content;
                    var body_content;
                    if (value$2 !== undefined) {
                        var value$3 = value$2.value;
                        var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                            if (value === undefined) {
                                return null;
                            }
                            var variant = value.NAME;
                            if (variant === "UnspecifiedFragment") {
                                return {};
                            }
                            if (variant === "VideoContentType") {
                                return js_array/* reduce */.u4(deepMerge, function(prim) {
                                    return {};
                                }, [
                                    Video.serialize(value.VAL.video)
                                ]);
                            }
                            var value$1 = value.VAL.content;
                            var content;
                            if (value$1 !== undefined) {
                                var value$2 = value$1.value;
                                var value$3 = value$2 !== undefined ? value$2 : null;
                                var value$4 = value$1.__typename;
                                content = {
                                    __typename: value$4,
                                    value: value$3
                                };
                            } else {
                                content = null;
                            }
                            return {
                                __typename: "RichTextBlockContentType",
                                content: content
                            };
                        }, value$3) : null;
                        var value$5 = value$2.__typename;
                        body_content = {
                            __typename: value$5,
                            value: value$4
                        };
                    } else {
                        body_content = null;
                    }
                    var value$6 = value$1.body_text;
                    var body_text;
                    if (value$6 !== undefined) {
                        var value$7 = value$6.value;
                        var value$8 = value$7 !== undefined ? value$7 : null;
                        var value$9 = value$6.__typename;
                        body_text = {
                            __typename: value$9,
                            value: value$8
                        };
                    } else {
                        body_text = null;
                    }
                    var value$10 = value$1.title;
                    var title;
                    if (value$10 !== undefined) {
                        var value$11 = value$10.value;
                        var value$12 = value$11 !== undefined ? value$11 : null;
                        var value$13 = value$10.__typename;
                        title = {
                            __typename: value$13,
                            value: value$12
                        };
                    } else {
                        title = null;
                    }
                    var value$14 = value$1.system;
                    var value$15 = value$14.codename;
                    var value$16 = value$14.id;
                    var value$17 = value$14.__typename;
                    var system = {
                        __typename: value$17,
                        id: value$16,
                        codename: value$15
                    };
                    return {
                        __typename: "FaqItemContentType",
                        system: system,
                        title: title,
                        body_text: body_text,
                        body_content: body_content
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                faq_items = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                faq_items = null;
            }
            var value$6 = value$1.title;
            var title;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                title = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                title = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "FaqSectionContentType",
                system: system,
                title: title,
                faq_items: faq_items
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        faq_sections = {
            __typename: value$8,
            value: value$7
        };
    } else {
        faq_sections = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        faq_sections: faq_sections,
        additional_content: additional_content
    };
}
function Gql_FAQ_Fragment_bs_verifyArgsAndParse(_FAQBlock, value) {
    return Gql_FAQ_Fragment_bs_parse(value);
}
function Gql_FAQ_Fragment_bs_verifyName(param) {}
var FAQBlock = {
    Raw: Gql_FAQ_Fragment_bs_Raw,
    query: Gql_FAQ_Fragment_bs_query,
    parse: Gql_FAQ_Fragment_bs_parse,
    serialize: Gql_FAQ_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_FAQ_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_FAQ_Fragment_bs_verifyName
};
var Gql_FAQ_Fragment_bs_Video;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Image/Gql__Image__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Image_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment Image on ImageContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    width  {\n      __typename\n      value\n    }\n    file  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n"
    ]);
    Gql_Image_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_Image_Fragment_bs_Raw = {};
var Gql_Image_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_Image_Fragment_bs_templateObject());
function Gql_Image_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.width;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.file;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$5) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        width: tmp,
        file: tmp$1
    };
}
function Gql_Image_Fragment_bs_serialize(value) {
    var value$1 = value.file;
    var file;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        file = {
            __typename: value$4,
            value: value$3
        };
    } else {
        file = null;
    }
    var value$5 = value.width;
    var width;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        width = {
            __typename: value$8,
            value: value$7
        };
    } else {
        width = null;
    }
    var value$9 = value.system;
    var value$10 = value$9.codename;
    var value$11 = value$9.id;
    var value$12 = value$9.__typename;
    var system = {
        __typename: value$12,
        id: value$11,
        codename: value$10
    };
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        system: system,
        width: width,
        file: file
    };
}
function Gql_Image_Fragment_bs_verifyArgsAndParse(_Image, value) {
    return Gql_Image_Fragment_bs_parse(value);
}
function Gql_Image_Fragment_bs_verifyName(param) {}
var $$Image = {
    Raw: Gql_Image_Fragment_bs_Raw,
    query: Gql_Image_Fragment_bs_query,
    parse: Gql_Image_Fragment_bs_parse,
    serialize: Gql_Image_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_Image_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_Image_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SeoMetaContentType/Gql__SeoMeta__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SeoMeta_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SeoMetaBlock on SeoMetaContentType   {\n    __typename\n    system  {\n      __typename\n      codename\n      language\n    }\n    seo_meta__basic__title  {\n      __typename\n      value\n    }\n    seo_meta__basic__description  {\n      __typename\n      value\n    }\n    seo_meta__og__title  {\n      __typename\n      value\n    }\n    seo_meta__og__description  {\n      __typename\n      value\n    }\n    seo_meta__og__image_asset  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    seo_meta__og__type  {\n      __typename\n      value\n    }\n    seo_meta__og__url  {\n      __typename\n      value\n    }\n    seo_meta__tw__title  {\n      __typename\n      value\n    }\n    seo_meta__tw__description  {\n      __typename\n      value\n    }\n    seo_meta__tw__image_asset  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    seo_meta__tw__image_asset_url  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_SeoMeta_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_SeoMeta_Fragment_bs_Raw = {};
var Gql_SeoMeta_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SeoMeta_Fragment_bs_templateObject(), frag_0);
}($$Image.query);
function Gql_SeoMeta_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.seo_meta__basic__title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.seo_meta__basic__description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.seo_meta__og__title;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.seo_meta__og__description;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.seo_meta__og__image_asset;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$11) : undefined
        };
    }
    var value$12 = value.seo_meta__og__type;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? value$13 : undefined
        };
    }
    var value$14 = value.seo_meta__og__url;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.seo_meta__tw__title;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.seo_meta__tw__description;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.seo_meta__tw__image_asset;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$21) : undefined
        };
    }
    var value$22 = value.seo_meta__tw__image_asset_url;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? value$23 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            codename: value$1.codename,
            language: value$1.language
        },
        seo_meta__basic__title: tmp,
        seo_meta__basic__description: tmp$1,
        seo_meta__og__title: tmp$2,
        seo_meta__og__description: tmp$3,
        seo_meta__og__image_asset: tmp$4,
        seo_meta__og__type: tmp$5,
        seo_meta__og__url: tmp$6,
        seo_meta__tw__title: tmp$7,
        seo_meta__tw__description: tmp$8,
        seo_meta__tw__image_asset: tmp$9,
        seo_meta__tw__image_asset_url: tmp$10
    };
}
function Gql_SeoMeta_Fragment_bs_serialize(value) {
    var value$1 = value.seo_meta__tw__image_asset_url;
    var seo_meta__tw__image_asset_url;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        seo_meta__tw__image_asset_url = {
            __typename: value$4,
            value: value$3
        };
    } else {
        seo_meta__tw__image_asset_url = null;
    }
    var value$5 = value.seo_meta__tw__image_asset;
    var seo_meta__tw__image_asset;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        seo_meta__tw__image_asset = {
            __typename: value$8,
            value: value$7
        };
    } else {
        seo_meta__tw__image_asset = null;
    }
    var value$9 = value.seo_meta__tw__description;
    var seo_meta__tw__description;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        seo_meta__tw__description = {
            __typename: value$12,
            value: value$11
        };
    } else {
        seo_meta__tw__description = null;
    }
    var value$13 = value.seo_meta__tw__title;
    var seo_meta__tw__title;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        seo_meta__tw__title = {
            __typename: value$16,
            value: value$15
        };
    } else {
        seo_meta__tw__title = null;
    }
    var value$17 = value.seo_meta__og__url;
    var seo_meta__og__url;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        seo_meta__og__url = {
            __typename: value$20,
            value: value$19
        };
    } else {
        seo_meta__og__url = null;
    }
    var value$21 = value.seo_meta__og__type;
    var seo_meta__og__type;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        seo_meta__og__type = {
            __typename: value$24,
            value: value$23
        };
    } else {
        seo_meta__og__type = null;
    }
    var value$25 = value.seo_meta__og__image_asset;
    var seo_meta__og__image_asset;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$26) : null;
        var value$28 = value$25.__typename;
        seo_meta__og__image_asset = {
            __typename: value$28,
            value: value$27
        };
    } else {
        seo_meta__og__image_asset = null;
    }
    var value$29 = value.seo_meta__og__description;
    var seo_meta__og__description;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? value$30 : null;
        var value$32 = value$29.__typename;
        seo_meta__og__description = {
            __typename: value$32,
            value: value$31
        };
    } else {
        seo_meta__og__description = null;
    }
    var value$33 = value.seo_meta__og__title;
    var seo_meta__og__title;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        seo_meta__og__title = {
            __typename: value$36,
            value: value$35
        };
    } else {
        seo_meta__og__title = null;
    }
    var value$37 = value.seo_meta__basic__description;
    var seo_meta__basic__description;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? value$38 : null;
        var value$40 = value$37.__typename;
        seo_meta__basic__description = {
            __typename: value$40,
            value: value$39
        };
    } else {
        seo_meta__basic__description = null;
    }
    var value$41 = value.seo_meta__basic__title;
    var seo_meta__basic__title;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? value$42 : null;
        var value$44 = value$41.__typename;
        seo_meta__basic__title = {
            __typename: value$44,
            value: value$43
        };
    } else {
        seo_meta__basic__title = null;
    }
    var value$45 = value.system;
    var value$46 = value$45.language;
    var value$47 = value$45.codename;
    var value$48 = value$45.__typename;
    var system = {
        __typename: value$48,
        codename: value$47,
        language: value$46
    };
    var value$49 = value.__typename;
    return {
        __typename: value$49,
        system: system,
        seo_meta__basic__title: seo_meta__basic__title,
        seo_meta__basic__description: seo_meta__basic__description,
        seo_meta__og__title: seo_meta__og__title,
        seo_meta__og__description: seo_meta__og__description,
        seo_meta__og__image_asset: seo_meta__og__image_asset,
        seo_meta__og__type: seo_meta__og__type,
        seo_meta__og__url: seo_meta__og__url,
        seo_meta__tw__title: seo_meta__tw__title,
        seo_meta__tw__description: seo_meta__tw__description,
        seo_meta__tw__image_asset: seo_meta__tw__image_asset,
        seo_meta__tw__image_asset_url: seo_meta__tw__image_asset_url
    };
}
function Gql_SeoMeta_Fragment_bs_verifyArgsAndParse(_SeoMetaBlock, value) {
    return Gql_SeoMeta_Fragment_bs_parse(value);
}
function Gql_SeoMeta_Fragment_bs_verifyName(param) {}
var SeoMetaBlock = {
    Raw: Gql_SeoMeta_Fragment_bs_Raw,
    query: Gql_SeoMeta_Fragment_bs_query,
    parse: Gql_SeoMeta_Fragment_bs_parse,
    serialize: Gql_SeoMeta_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SeoMeta_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SeoMeta_Fragment_bs_verifyName
};
var Gql_SeoMeta_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CallToAction/Gql__CallToAction__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CallToAction_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CallToAction on CallToActionLinkD6a3d61ContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    cta_text  {\n      __typename\n      value\n    }\n    cta_url  {\n      __typename\n      value\n    }\n    open_in_new_window  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    cta_style__style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n  }\n"
    ]);
    Gql_CallToAction_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_CallToAction_Fragment_bs_Raw = {};
var Gql_CallToAction_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_CallToAction_Fragment_bs_templateObject());
function Gql_CallToAction_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.cta_text;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.cta_url;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.open_in_new_window;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.cta_style__style;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        cta_text: tmp,
        cta_url: tmp$1,
        open_in_new_window: tmp$2,
        cta_style__style: tmp$3
    };
}
function Gql_CallToAction_Fragment_bs_serialize(value) {
    var value$1 = value.cta_style__style;
    var cta_style__style;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        cta_style__style = {
            __typename: value$4,
            value: value$3
        };
    } else {
        cta_style__style = null;
    }
    var value$5 = value.open_in_new_window;
    var open_in_new_window;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        open_in_new_window = {
            __typename: value$8,
            value: value$7
        };
    } else {
        open_in_new_window = null;
    }
    var value$9 = value.cta_url;
    var cta_url;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        cta_url = {
            __typename: value$12,
            value: value$11
        };
    } else {
        cta_url = null;
    }
    var value$13 = value.cta_text;
    var cta_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        cta_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        cta_text = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        cta_text: cta_text,
        cta_url: cta_url,
        open_in_new_window: open_in_new_window,
        cta_style__style: cta_style__style
    };
}
function Gql_CallToAction_Fragment_bs_verifyArgsAndParse(_CallToAction, value) {
    return Gql_CallToAction_Fragment_bs_parse(value);
}
function Gql_CallToAction_Fragment_bs_verifyName(param) {}
var CallToAction = {
    Raw: Gql_CallToAction_Fragment_bs_Raw,
    query: Gql_CallToAction_Fragment_bs_query,
    parse: Gql_CallToAction_Fragment_bs_parse,
    serialize: Gql_CallToAction_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_CallToAction_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_CallToAction_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment HeroTileBlock on HeroTileBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    block_style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    bottom_distance  {\n      __typename\n      value\n    }\n    top_distance  {\n      __typename\n      value\n    }\n    hero_tiles  {\n      __typename\n      value  {\n        __typename\n        ...on HeroTileContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          subtitle  {\n            __typename\n            value\n          }\n          description  {\n            __typename\n            value\n          }\n          text_colour  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          video_cta_text  {\n            __typename\n            value\n          }\n          buttons  {\n            __typename\n            value  {\n              __typename\n              ...on CallToActionLinkD6a3d61ContentType   {\n                ...CallToAction\n              }\n            }\n          }\n          foreground_image  {\n            __typename\n            name\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          mobile_background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          tablet_background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_colour  {\n            __typename\n            value\n          }\n          background_video_new  {\n            __typename\n            value  {\n              __typename\n              ...on VideoContentType   {\n                ...Video\n              }\n            }\n          }\n          mobile_background_video  {\n            __typename\n            value  {\n              __typename\n              ...on VideoContentType   {\n                ...Video\n              }\n            }\n          }\n          tablet_background_video  {\n            __typename\n            value  {\n              __typename\n              ...on VideoContentType   {\n                ...Video\n              }\n            }\n          }\n          loop_background_video  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          content_vertical_alignment  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          background_horizontal_alignment  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          cta  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          info_cta  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_HeroTiles_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Gql_HeroTiles_Fragment_bs_Raw = {};
var Gql_HeroTiles_Fragment_bs_query = function(frag_0, frag_1, frag_2) {
    return (__webpack_require__(46829).gql)(Gql_HeroTiles_Fragment_bs_templateObject(), frag_0, frag_1, frag_2);
}(CallToAction.query, $$Image.query, Video.query);
function Gql_HeroTiles_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.block_style;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.bottom_distance;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.top_distance;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.hero_tiles;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "HeroTileContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.subtitle;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.description;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.text_colour;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$9) : undefined
                        };
                    }
                    var value$10 = value.video_cta_text;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? value$11 : undefined
                        };
                    }
                    var value$12 = value.buttons;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                    NAME: "CallToActionLinkD6a3d61ContentType",
                                    VAL: {
                                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$13) : undefined
                        };
                    }
                    var value$14 = value.foreground_image;
                    var tmp$7;
                    if (value$14 == null) {
                        tmp$7 = undefined;
                    } else {
                        var value$15 = value$14.value;
                        tmp$7 = {
                            __typename: value$14.__typename,
                            name: value$14.name,
                            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$15) : undefined
                        };
                    }
                    var value$16 = value.background_image;
                    var tmp$8;
                    if (value$16 == null) {
                        tmp$8 = undefined;
                    } else {
                        var value$17 = value$16.value;
                        tmp$8 = {
                            __typename: value$16.__typename,
                            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$17) : undefined
                        };
                    }
                    var value$18 = value.mobile_background_image;
                    var tmp$9;
                    if (value$18 == null) {
                        tmp$9 = undefined;
                    } else {
                        var value$19 = value$18.value;
                        tmp$9 = {
                            __typename: value$18.__typename,
                            value: !(value$19 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$19) : undefined
                        };
                    }
                    var value$20 = value.tablet_background_image;
                    var tmp$10;
                    if (value$20 == null) {
                        tmp$10 = undefined;
                    } else {
                        var value$21 = value$20.value;
                        tmp$10 = {
                            __typename: value$20.__typename,
                            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$21) : undefined
                        };
                    }
                    var value$22 = value.background_colour;
                    var tmp$11;
                    if (value$22 == null) {
                        tmp$11 = undefined;
                    } else {
                        var value$23 = value$22.value;
                        tmp$11 = {
                            __typename: value$22.__typename,
                            value: !(value$23 == null) ? value$23 : undefined
                        };
                    }
                    var value$24 = value.background_video_new;
                    var tmp$12;
                    if (value$24 == null) {
                        tmp$12 = undefined;
                    } else {
                        var value$25 = value$24.value;
                        tmp$12 = {
                            __typename: value$24.__typename,
                            value: !(value$25 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "VideoContentType" ? {
                                    NAME: "VideoContentType",
                                    VAL: {
                                        video: Video.verifyArgsAndParse("Video", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$25) : undefined
                        };
                    }
                    var value$26 = value.mobile_background_video;
                    var tmp$13;
                    if (value$26 == null) {
                        tmp$13 = undefined;
                    } else {
                        var value$27 = value$26.value;
                        tmp$13 = {
                            __typename: value$26.__typename,
                            value: !(value$27 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "VideoContentType" ? {
                                    NAME: "VideoContentType",
                                    VAL: {
                                        video: Video.verifyArgsAndParse("Video", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$27) : undefined
                        };
                    }
                    var value$28 = value.tablet_background_video;
                    var tmp$14;
                    if (value$28 == null) {
                        tmp$14 = undefined;
                    } else {
                        var value$29 = value$28.value;
                        tmp$14 = {
                            __typename: value$28.__typename,
                            value: !(value$29 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "VideoContentType" ? {
                                    NAME: "VideoContentType",
                                    VAL: {
                                        video: Video.verifyArgsAndParse("Video", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$29) : undefined
                        };
                    }
                    var value$30 = value.loop_background_video;
                    var tmp$15;
                    if (value$30 == null) {
                        tmp$15 = undefined;
                    } else {
                        var value$31 = value$30.value;
                        tmp$15 = {
                            __typename: value$30.__typename,
                            value: !(value$31 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$31) : undefined
                        };
                    }
                    var value$32 = value.content_vertical_alignment;
                    var tmp$16;
                    if (value$32 == null) {
                        tmp$16 = undefined;
                    } else {
                        var value$33 = value$32.value;
                        tmp$16 = {
                            __typename: value$32.__typename,
                            value: !(value$33 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$33) : undefined
                        };
                    }
                    var value$34 = value.background_horizontal_alignment;
                    var tmp$17;
                    if (value$34 == null) {
                        tmp$17 = undefined;
                    } else {
                        var value$35 = value$34.value;
                        tmp$17 = {
                            __typename: value$34.__typename,
                            value: !(value$35 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$35) : undefined
                        };
                    }
                    var value$36 = value.cta;
                    var tmp$18;
                    if (value$36 == null) {
                        tmp$18 = undefined;
                    } else {
                        var value$37 = value$36.value;
                        tmp$18 = {
                            __typename: value$36.__typename,
                            value: !(value$37 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$37) : undefined
                        };
                    }
                    var value$38 = value.info_cta;
                    var tmp$19;
                    if (value$38 == null) {
                        tmp$19 = undefined;
                    } else {
                        var value$39 = value$38.value;
                        tmp$19 = {
                            __typename: value$38.__typename,
                            value: !(value$39 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$39) : undefined
                        };
                    }
                    tmp = {
                        NAME: "HeroTileContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            subtitle: tmp$2,
                            description: tmp$3,
                            text_colour: tmp$4,
                            video_cta_text: tmp$5,
                            buttons: tmp$6,
                            foreground_image: tmp$7,
                            background_image: tmp$8,
                            mobile_background_image: tmp$9,
                            tablet_background_image: tmp$10,
                            background_colour: tmp$11,
                            background_video_new: tmp$12,
                            mobile_background_video: tmp$13,
                            tablet_background_video: tmp$14,
                            loop_background_video: tmp$15,
                            content_vertical_alignment: tmp$16,
                            background_horizontal_alignment: tmp$17,
                            cta: tmp$18,
                            info_cta: tmp$19
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$9) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        block_style: tmp,
        bottom_distance: tmp$1,
        top_distance: tmp$2,
        hero_tiles: tmp$3
    };
}
function Gql_HeroTiles_Fragment_bs_serialize(value) {
    var value$1 = value.hero_tiles;
    var hero_tiles;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.info_cta;
            var info_cta;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                info_cta = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                info_cta = null;
            }
            var value$6 = value$1.cta;
            var cta;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$7) : null;
                var value$9 = value$6.__typename;
                cta = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                cta = null;
            }
            var value$10 = value$1.background_horizontal_alignment;
            var background_horizontal_alignment;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$11) : null;
                var value$13 = value$10.__typename;
                background_horizontal_alignment = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                background_horizontal_alignment = null;
            }
            var value$14 = value$1.content_vertical_alignment;
            var content_vertical_alignment;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$15) : null;
                var value$17 = value$14.__typename;
                content_vertical_alignment = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                content_vertical_alignment = null;
            }
            var value$18 = value$1.loop_background_video;
            var loop_background_video;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$19) : null;
                var value$21 = value$18.__typename;
                loop_background_video = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                loop_background_video = null;
            }
            var value$22 = value$1.tablet_background_video;
            var tablet_background_video;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "VideoContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                Video.serialize(value.VAL.video)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$23) : null;
                var value$25 = value$22.__typename;
                tablet_background_video = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                tablet_background_video = null;
            }
            var value$26 = value$1.mobile_background_video;
            var mobile_background_video;
            if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "VideoContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                Video.serialize(value.VAL.video)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$27) : null;
                var value$29 = value$26.__typename;
                mobile_background_video = {
                    __typename: value$29,
                    value: value$28
                };
            } else {
                mobile_background_video = null;
            }
            var value$30 = value$1.background_video_new;
            var background_video_new;
            if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "VideoContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                Video.serialize(value.VAL.video)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$31) : null;
                var value$33 = value$30.__typename;
                background_video_new = {
                    __typename: value$33,
                    value: value$32
                };
            } else {
                background_video_new = null;
            }
            var value$34 = value$1.background_colour;
            var background_colour;
            if (value$34 !== undefined) {
                var value$35 = value$34.value;
                var value$36 = value$35 !== undefined ? value$35 : null;
                var value$37 = value$34.__typename;
                background_colour = {
                    __typename: value$37,
                    value: value$36
                };
            } else {
                background_colour = null;
            }
            var value$38 = value$1.tablet_background_image;
            var tablet_background_image;
            if (value$38 !== undefined) {
                var value$39 = value$38.value;
                var value$40 = value$39 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$39) : null;
                var value$41 = value$38.__typename;
                tablet_background_image = {
                    __typename: value$41,
                    value: value$40
                };
            } else {
                tablet_background_image = null;
            }
            var value$42 = value$1.mobile_background_image;
            var mobile_background_image;
            if (value$42 !== undefined) {
                var value$43 = value$42.value;
                var value$44 = value$43 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$43) : null;
                var value$45 = value$42.__typename;
                mobile_background_image = {
                    __typename: value$45,
                    value: value$44
                };
            } else {
                mobile_background_image = null;
            }
            var value$46 = value$1.background_image;
            var background_image;
            if (value$46 !== undefined) {
                var value$47 = value$46.value;
                var value$48 = value$47 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$47) : null;
                var value$49 = value$46.__typename;
                background_image = {
                    __typename: value$49,
                    value: value$48
                };
            } else {
                background_image = null;
            }
            var value$50 = value$1.foreground_image;
            var foreground_image;
            if (value$50 !== undefined) {
                var value$51 = value$50.value;
                var value$52 = value$51 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$51) : null;
                var value$53 = value$50.name;
                var value$54 = value$50.__typename;
                foreground_image = {
                    __typename: value$54,
                    name: value$53,
                    value: value$52
                };
            } else {
                foreground_image = null;
            }
            var value$55 = value$1.buttons;
            var buttons;
            if (value$55 !== undefined) {
                var value$56 = value$55.value;
                var value$57 = value$56 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                CallToAction.serialize(value.VAL.callToAction)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$56) : null;
                var value$58 = value$55.__typename;
                buttons = {
                    __typename: value$58,
                    value: value$57
                };
            } else {
                buttons = null;
            }
            var value$59 = value$1.video_cta_text;
            var video_cta_text;
            if (value$59 !== undefined) {
                var value$60 = value$59.value;
                var value$61 = value$60 !== undefined ? value$60 : null;
                var value$62 = value$59.__typename;
                video_cta_text = {
                    __typename: value$62,
                    value: value$61
                };
            } else {
                video_cta_text = null;
            }
            var value$63 = value$1.text_colour;
            var text_colour;
            if (value$63 !== undefined) {
                var value$64 = value$63.value;
                var value$65 = value$64 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$64) : null;
                var value$66 = value$63.__typename;
                text_colour = {
                    __typename: value$66,
                    value: value$65
                };
            } else {
                text_colour = null;
            }
            var value$67 = value$1.description;
            var description;
            if (value$67 !== undefined) {
                var value$68 = value$67.value;
                var value$69 = value$68 !== undefined ? value$68 : null;
                var value$70 = value$67.__typename;
                description = {
                    __typename: value$70,
                    value: value$69
                };
            } else {
                description = null;
            }
            var value$71 = value$1.subtitle;
            var subtitle;
            if (value$71 !== undefined) {
                var value$72 = value$71.value;
                var value$73 = value$72 !== undefined ? value$72 : null;
                var value$74 = value$71.__typename;
                subtitle = {
                    __typename: value$74,
                    value: value$73
                };
            } else {
                subtitle = null;
            }
            var value$75 = value$1.title;
            var title;
            if (value$75 !== undefined) {
                var value$76 = value$75.value;
                var value$77 = value$76 !== undefined ? value$76 : null;
                var value$78 = value$75.__typename;
                title = {
                    __typename: value$78,
                    value: value$77
                };
            } else {
                title = null;
            }
            var value$79 = value$1.system;
            var value$80 = value$79.codename;
            var value$81 = value$79.id;
            var value$82 = value$79.__typename;
            var system = {
                __typename: value$82,
                id: value$81,
                codename: value$80
            };
            return {
                __typename: "HeroTileContentType",
                system: system,
                title: title,
                subtitle: subtitle,
                description: description,
                text_colour: text_colour,
                video_cta_text: video_cta_text,
                buttons: buttons,
                foreground_image: foreground_image,
                background_image: background_image,
                mobile_background_image: mobile_background_image,
                tablet_background_image: tablet_background_image,
                background_colour: background_colour,
                background_video_new: background_video_new,
                mobile_background_video: mobile_background_video,
                tablet_background_video: tablet_background_video,
                loop_background_video: loop_background_video,
                content_vertical_alignment: content_vertical_alignment,
                background_horizontal_alignment: background_horizontal_alignment,
                cta: cta,
                info_cta: info_cta
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        hero_tiles = {
            __typename: value$4,
            value: value$3
        };
    } else {
        hero_tiles = null;
    }
    var value$5 = value.top_distance;
    var top_distance;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        top_distance = {
            __typename: value$8,
            value: value$7
        };
    } else {
        top_distance = null;
    }
    var value$9 = value.bottom_distance;
    var bottom_distance;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        bottom_distance = {
            __typename: value$12,
            value: value$11
        };
    } else {
        bottom_distance = null;
    }
    var value$13 = value.block_style;
    var block_style;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        block_style = {
            __typename: value$16,
            value: value$15
        };
    } else {
        block_style = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        block_style: block_style,
        bottom_distance: bottom_distance,
        top_distance: top_distance,
        hero_tiles: hero_tiles
    };
}
function Gql_HeroTiles_Fragment_bs_verifyArgsAndParse(_HeroTileBlock, value) {
    return Gql_HeroTiles_Fragment_bs_parse(value);
}
function Gql_HeroTiles_Fragment_bs_verifyName(param) {}
var HeroTileBlock = {
    Raw: Gql_HeroTiles_Fragment_bs_Raw,
    query: Gql_HeroTiles_Fragment_bs_query,
    parse: Gql_HeroTiles_Fragment_bs_parse,
    serialize: Gql_HeroTiles_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeroTiles_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeroTiles_Fragment_bs_verifyName
};
var Gql_HeroTiles_Fragment_bs_$$Image;
var Gql_HeroTiles_Fragment_bs_Video;
var Gql_HeroTiles_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NarrowCta/Gql__NarrowCta__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NarrowCta_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NarrowCta on NarrowCtaContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    cta  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    image_desktop  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image_tablet  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image_mobile  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_NarrowCta_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_NarrowCta_Fragment_bs_Raw = {};
var Gql_NarrowCta_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_NarrowCta_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_NarrowCta_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.background_colour;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.cta;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.image_desktop;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.image_tablet;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.image_mobile;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$13) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        background_colour: tmp$1,
        cta: tmp$2,
        image_desktop: tmp$3,
        image_tablet: tmp$4,
        image_mobile: tmp$5
    };
}
function Gql_NarrowCta_Fragment_bs_serialize(value) {
    var value$1 = value.image_mobile;
    var image_mobile;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        image_mobile = {
            __typename: value$4,
            value: value$3
        };
    } else {
        image_mobile = null;
    }
    var value$5 = value.image_tablet;
    var image_tablet;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        image_tablet = {
            __typename: value$8,
            value: value$7
        };
    } else {
        image_tablet = null;
    }
    var value$9 = value.image_desktop;
    var image_desktop;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        image_desktop = {
            __typename: value$12,
            value: value$11
        };
    } else {
        image_desktop = null;
    }
    var value$13 = value.cta;
    var cta;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$14) : null;
        var value$16 = value$13.__typename;
        cta = {
            __typename: value$16,
            value: value$15
        };
    } else {
        cta = null;
    }
    var value$17 = value.background_colour;
    var background_colour;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        background_colour = {
            __typename: value$20,
            value: value$19
        };
    } else {
        background_colour = null;
    }
    var value$21 = value.title;
    var title;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        title = {
            __typename: value$24,
            value: value$23
        };
    } else {
        title = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        title: title,
        background_colour: background_colour,
        cta: cta,
        image_desktop: image_desktop,
        image_tablet: image_tablet,
        image_mobile: image_mobile
    };
}
function Gql_NarrowCta_Fragment_bs_verifyArgsAndParse(_NarrowCta, value) {
    return Gql_NarrowCta_Fragment_bs_parse(value);
}
function Gql_NarrowCta_Fragment_bs_verifyName(param) {}
var NarrowCta = {
    Raw: Gql_NarrowCta_Fragment_bs_Raw,
    query: Gql_NarrowCta_Fragment_bs_query,
    parse: Gql_NarrowCta_Fragment_bs_parse,
    serialize: Gql_NarrowCta_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NarrowCta_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NarrowCta_Fragment_bs_verifyName
};
var Gql_NarrowCta_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__N1ColumnBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroBanner_N1ColumnBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment N1ColumnHero on N1ColumnHeroBannerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    copy_block_alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    image_treatment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title  {\n      __typename\n      value\n    }\n    highlight_text_colour  {\n      __typename\n      value\n    }\n    title_font_style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title_text_colour  {\n      __typename\n      value\n    }\n    title_font_size  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    description  {\n      __typename\n      value\n    }\n    description_text_colour  {\n      __typename\n      value\n    }\n    description_font_size  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    buttons  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    image_desktop  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image_tablet  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image_mobile  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image__2_desktop  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image__2_tablet  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    image__2_mobile  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    display_badge  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    badge_alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    badge_text  {\n      __typename\n      value\n    }\n    badge_text_colour  {\n      __typename\n      value\n    }\n    badge_background_colour  {\n      __typename\n      value\n    }\n    badge_outline_colour  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_HeroBanner_N1ColumnBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_HeroBanner_N1ColumnBanner_Fragment_bs_Raw = {};
var Gql_HeroBanner_N1ColumnBanner_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_HeroBanner_N1ColumnBanner_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_HeroBanner_N1ColumnBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.background_colour;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.copy_block_alignment;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.image_treatment;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.title;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.highlight_text_colour;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.title_font_style;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.title_text_colour;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.title_font_size;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$17) : undefined
        };
    }
    var value$18 = value.description;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.description_text_colour;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? value$21 : undefined
        };
    }
    var value$22 = value.description_font_size;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$23) : undefined
        };
    }
    var value$24 = value.buttons;
    var tmp$11;
    if (value$24 == null) {
        tmp$11 = undefined;
    } else {
        var value$25 = value$24.value;
        tmp$11 = {
            __typename: value$24.__typename,
            value: !(value$25 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$25) : undefined
        };
    }
    var value$26 = value.image_desktop;
    var tmp$12;
    if (value$26 == null) {
        tmp$12 = undefined;
    } else {
        var value$27 = value$26.value;
        tmp$12 = {
            __typename: value$26.__typename,
            value: !(value$27 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$27) : undefined
        };
    }
    var value$28 = value.image_tablet;
    var tmp$13;
    if (value$28 == null) {
        tmp$13 = undefined;
    } else {
        var value$29 = value$28.value;
        tmp$13 = {
            __typename: value$28.__typename,
            value: !(value$29 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$29) : undefined
        };
    }
    var value$30 = value.image_mobile;
    var tmp$14;
    if (value$30 == null) {
        tmp$14 = undefined;
    } else {
        var value$31 = value$30.value;
        tmp$14 = {
            __typename: value$30.__typename,
            value: !(value$31 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$31) : undefined
        };
    }
    var value$32 = value.image__2_desktop;
    var tmp$15;
    if (value$32 == null) {
        tmp$15 = undefined;
    } else {
        var value$33 = value$32.value;
        tmp$15 = {
            __typename: value$32.__typename,
            value: !(value$33 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$33) : undefined
        };
    }
    var value$34 = value.image__2_tablet;
    var tmp$16;
    if (value$34 == null) {
        tmp$16 = undefined;
    } else {
        var value$35 = value$34.value;
        tmp$16 = {
            __typename: value$34.__typename,
            value: !(value$35 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$35) : undefined
        };
    }
    var value$36 = value.image__2_mobile;
    var tmp$17;
    if (value$36 == null) {
        tmp$17 = undefined;
    } else {
        var value$37 = value$36.value;
        tmp$17 = {
            __typename: value$36.__typename,
            value: !(value$37 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$37) : undefined
        };
    }
    var value$38 = value.display_badge;
    var tmp$18;
    if (value$38 == null) {
        tmp$18 = undefined;
    } else {
        var value$39 = value$38.value;
        tmp$18 = {
            __typename: value$38.__typename,
            value: !(value$39 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$39) : undefined
        };
    }
    var value$40 = value.badge_alignment;
    var tmp$19;
    if (value$40 == null) {
        tmp$19 = undefined;
    } else {
        var value$41 = value$40.value;
        tmp$19 = {
            __typename: value$40.__typename,
            value: !(value$41 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$41) : undefined
        };
    }
    var value$42 = value.badge_text;
    var tmp$20;
    if (value$42 == null) {
        tmp$20 = undefined;
    } else {
        var value$43 = value$42.value;
        tmp$20 = {
            __typename: value$42.__typename,
            value: !(value$43 == null) ? value$43 : undefined
        };
    }
    var value$44 = value.badge_text_colour;
    var tmp$21;
    if (value$44 == null) {
        tmp$21 = undefined;
    } else {
        var value$45 = value$44.value;
        tmp$21 = {
            __typename: value$44.__typename,
            value: !(value$45 == null) ? value$45 : undefined
        };
    }
    var value$46 = value.badge_background_colour;
    var tmp$22;
    if (value$46 == null) {
        tmp$22 = undefined;
    } else {
        var value$47 = value$46.value;
        tmp$22 = {
            __typename: value$46.__typename,
            value: !(value$47 == null) ? value$47 : undefined
        };
    }
    var value$48 = value.badge_outline_colour;
    var tmp$23;
    if (value$48 == null) {
        tmp$23 = undefined;
    } else {
        var value$49 = value$48.value;
        tmp$23 = {
            __typename: value$48.__typename,
            value: !(value$49 == null) ? value$49 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        background_colour: tmp,
        copy_block_alignment: tmp$1,
        image_treatment: tmp$2,
        title: tmp$3,
        highlight_text_colour: tmp$4,
        title_font_style: tmp$5,
        title_text_colour: tmp$6,
        title_font_size: tmp$7,
        description: tmp$8,
        description_text_colour: tmp$9,
        description_font_size: tmp$10,
        buttons: tmp$11,
        image_desktop: tmp$12,
        image_tablet: tmp$13,
        image_mobile: tmp$14,
        image__2_desktop: tmp$15,
        image__2_tablet: tmp$16,
        image__2_mobile: tmp$17,
        display_badge: tmp$18,
        badge_alignment: tmp$19,
        badge_text: tmp$20,
        badge_text_colour: tmp$21,
        badge_background_colour: tmp$22,
        badge_outline_colour: tmp$23
    };
}
function Gql_HeroBanner_N1ColumnBanner_Fragment_bs_serialize(value) {
    var value$1 = value.badge_outline_colour;
    var badge_outline_colour;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        badge_outline_colour = {
            __typename: value$4,
            value: value$3
        };
    } else {
        badge_outline_colour = null;
    }
    var value$5 = value.badge_background_colour;
    var badge_background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        badge_background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        badge_background_colour = null;
    }
    var value$9 = value.badge_text_colour;
    var badge_text_colour;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        badge_text_colour = {
            __typename: value$12,
            value: value$11
        };
    } else {
        badge_text_colour = null;
    }
    var value$13 = value.badge_text;
    var badge_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        badge_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        badge_text = null;
    }
    var value$17 = value.badge_alignment;
    var badge_alignment;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        badge_alignment = {
            __typename: value$20,
            value: value$19
        };
    } else {
        badge_alignment = null;
    }
    var value$21 = value.display_badge;
    var display_badge;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$22) : null;
        var value$24 = value$21.__typename;
        display_badge = {
            __typename: value$24,
            value: value$23
        };
    } else {
        display_badge = null;
    }
    var value$25 = value.image__2_mobile;
    var image__2_mobile;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$26) : null;
        var value$28 = value$25.__typename;
        image__2_mobile = {
            __typename: value$28,
            value: value$27
        };
    } else {
        image__2_mobile = null;
    }
    var value$29 = value.image__2_tablet;
    var image__2_tablet;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        image__2_tablet = {
            __typename: value$32,
            value: value$31
        };
    } else {
        image__2_tablet = null;
    }
    var value$33 = value.image__2_desktop;
    var image__2_desktop;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$34) : null;
        var value$36 = value$33.__typename;
        image__2_desktop = {
            __typename: value$36,
            value: value$35
        };
    } else {
        image__2_desktop = null;
    }
    var value$37 = value.image_mobile;
    var image_mobile;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$38) : null;
        var value$40 = value$37.__typename;
        image_mobile = {
            __typename: value$40,
            value: value$39
        };
    } else {
        image_mobile = null;
    }
    var value$41 = value.image_tablet;
    var image_tablet;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$42) : null;
        var value$44 = value$41.__typename;
        image_tablet = {
            __typename: value$44,
            value: value$43
        };
    } else {
        image_tablet = null;
    }
    var value$45 = value.image_desktop;
    var image_desktop;
    if (value$45 !== undefined) {
        var value$46 = value$45.value;
        var value$47 = value$46 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$46) : null;
        var value$48 = value$45.__typename;
        image_desktop = {
            __typename: value$48,
            value: value$47
        };
    } else {
        image_desktop = null;
    }
    var value$49 = value.buttons;
    var buttons;
    if (value$49 !== undefined) {
        var value$50 = value$49.value;
        var value$51 = value$50 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$50) : null;
        var value$52 = value$49.__typename;
        buttons = {
            __typename: value$52,
            value: value$51
        };
    } else {
        buttons = null;
    }
    var value$53 = value.description_font_size;
    var description_font_size;
    if (value$53 !== undefined) {
        var value$54 = value$53.value;
        var value$55 = value$54 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$54) : null;
        var value$56 = value$53.__typename;
        description_font_size = {
            __typename: value$56,
            value: value$55
        };
    } else {
        description_font_size = null;
    }
    var value$57 = value.description_text_colour;
    var description_text_colour;
    if (value$57 !== undefined) {
        var value$58 = value$57.value;
        var value$59 = value$58 !== undefined ? value$58 : null;
        var value$60 = value$57.__typename;
        description_text_colour = {
            __typename: value$60,
            value: value$59
        };
    } else {
        description_text_colour = null;
    }
    var value$61 = value.description;
    var description;
    if (value$61 !== undefined) {
        var value$62 = value$61.value;
        var value$63 = value$62 !== undefined ? value$62 : null;
        var value$64 = value$61.__typename;
        description = {
            __typename: value$64,
            value: value$63
        };
    } else {
        description = null;
    }
    var value$65 = value.title_font_size;
    var title_font_size;
    if (value$65 !== undefined) {
        var value$66 = value$65.value;
        var value$67 = value$66 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$66) : null;
        var value$68 = value$65.__typename;
        title_font_size = {
            __typename: value$68,
            value: value$67
        };
    } else {
        title_font_size = null;
    }
    var value$69 = value.title_text_colour;
    var title_text_colour;
    if (value$69 !== undefined) {
        var value$70 = value$69.value;
        var value$71 = value$70 !== undefined ? value$70 : null;
        var value$72 = value$69.__typename;
        title_text_colour = {
            __typename: value$72,
            value: value$71
        };
    } else {
        title_text_colour = null;
    }
    var value$73 = value.title_font_style;
    var title_font_style;
    if (value$73 !== undefined) {
        var value$74 = value$73.value;
        var value$75 = value$74 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$74) : null;
        var value$76 = value$73.__typename;
        title_font_style = {
            __typename: value$76,
            value: value$75
        };
    } else {
        title_font_style = null;
    }
    var value$77 = value.highlight_text_colour;
    var highlight_text_colour;
    if (value$77 !== undefined) {
        var value$78 = value$77.value;
        var value$79 = value$78 !== undefined ? value$78 : null;
        var value$80 = value$77.__typename;
        highlight_text_colour = {
            __typename: value$80,
            value: value$79
        };
    } else {
        highlight_text_colour = null;
    }
    var value$81 = value.title;
    var title;
    if (value$81 !== undefined) {
        var value$82 = value$81.value;
        var value$83 = value$82 !== undefined ? value$82 : null;
        var value$84 = value$81.__typename;
        title = {
            __typename: value$84,
            value: value$83
        };
    } else {
        title = null;
    }
    var value$85 = value.image_treatment;
    var image_treatment;
    if (value$85 !== undefined) {
        var value$86 = value$85.value;
        var value$87 = value$86 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$86) : null;
        var value$88 = value$85.__typename;
        image_treatment = {
            __typename: value$88,
            value: value$87
        };
    } else {
        image_treatment = null;
    }
    var value$89 = value.copy_block_alignment;
    var copy_block_alignment;
    if (value$89 !== undefined) {
        var value$90 = value$89.value;
        var value$91 = value$90 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$90) : null;
        var value$92 = value$89.__typename;
        copy_block_alignment = {
            __typename: value$92,
            value: value$91
        };
    } else {
        copy_block_alignment = null;
    }
    var value$93 = value.background_colour;
    var background_colour;
    if (value$93 !== undefined) {
        var value$94 = value$93.value;
        var value$95 = value$94 !== undefined ? value$94 : null;
        var value$96 = value$93.__typename;
        background_colour = {
            __typename: value$96,
            value: value$95
        };
    } else {
        background_colour = null;
    }
    var value$97 = value.system;
    var value$98 = value$97.codename;
    var value$99 = value$97.id;
    var value$100 = value$97.__typename;
    var system = {
        __typename: value$100,
        id: value$99,
        codename: value$98
    };
    var value$101 = value.__typename;
    return {
        __typename: value$101,
        system: system,
        background_colour: background_colour,
        copy_block_alignment: copy_block_alignment,
        image_treatment: image_treatment,
        title: title,
        highlight_text_colour: highlight_text_colour,
        title_font_style: title_font_style,
        title_text_colour: title_text_colour,
        title_font_size: title_font_size,
        description: description,
        description_text_colour: description_text_colour,
        description_font_size: description_font_size,
        buttons: buttons,
        image_desktop: image_desktop,
        image_tablet: image_tablet,
        image_mobile: image_mobile,
        image__2_desktop: image__2_desktop,
        image__2_tablet: image__2_tablet,
        image__2_mobile: image__2_mobile,
        display_badge: display_badge,
        badge_alignment: badge_alignment,
        badge_text: badge_text,
        badge_text_colour: badge_text_colour,
        badge_background_colour: badge_background_colour,
        badge_outline_colour: badge_outline_colour
    };
}
function Gql_HeroBanner_N1ColumnBanner_Fragment_bs_verifyArgsAndParse(_N1ColumnHero, value) {
    return Gql_HeroBanner_N1ColumnBanner_Fragment_bs_parse(value);
}
function Gql_HeroBanner_N1ColumnBanner_Fragment_bs_verifyName(param) {}
var N1ColumnHero = {
    Raw: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_Raw,
    query: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_query,
    parse: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_parse,
    serialize: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeroBanner_N1ColumnBanner_Fragment_bs_verifyName
};
var Gql_HeroBanner_N1ColumnBanner_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__N2ColumnBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroBanner_N2ColumnBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment N2ColumnHero on N2ColumnHeroBannerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    background_colour_2  {\n      __typename\n      value\n    }\n    copy_block_alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    copy_block_alignment_2  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    image_treatment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    image_treatment_2  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title  {\n      __typename\n      value\n    }\n    title_2  {\n      __typename\n      value\n    }\n    highlight_text_colour  {\n      __typename\n      value\n    }\n    highlight_text_colour_2  {\n      __typename\n      value\n    }\n    title_font_style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title_font_style_2  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title_text_colour  {\n      __typename\n      value\n    }\n    title_text_colour_2  {\n      __typename\n      value\n    }\n    title_font_size  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title_font_size_2  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    description  {\n      __typename\n      value\n    }\n    description_2  {\n      __typename\n      value\n    }\n    description_text_colour  {\n      __typename\n      value\n    }\n    description_text_colour_2  {\n      __typename\n      value\n    }\n    description_font_size  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    description_font_size_2  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    cta_s  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    cta_s_2  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    desktop_image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    desktop_image_2  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    tablet_image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    tablet_image_2  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    mobile_image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    mobile_image_2  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    display_badge  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    badge_alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    badge_text  {\n      __typename\n      value\n    }\n    badge_text_colour  {\n      __typename\n      value\n    }\n    badge_background_colour  {\n      __typename\n      value\n    }\n    badge_outline_colour  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_HeroBanner_N2ColumnBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_HeroBanner_N2ColumnBanner_Fragment_bs_Raw = {};
var Gql_HeroBanner_N2ColumnBanner_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_HeroBanner_N2ColumnBanner_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_HeroBanner_N2ColumnBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.background_colour;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.background_colour_2;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.copy_block_alignment;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.copy_block_alignment_2;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.image_treatment;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.image_treatment_2;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.title;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.title_2;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.highlight_text_colour;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.highlight_text_colour_2;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? value$21 : undefined
        };
    }
    var value$22 = value.title_font_style;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$23) : undefined
        };
    }
    var value$24 = value.title_font_style_2;
    var tmp$11;
    if (value$24 == null) {
        tmp$11 = undefined;
    } else {
        var value$25 = value$24.value;
        tmp$11 = {
            __typename: value$24.__typename,
            value: !(value$25 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$25) : undefined
        };
    }
    var value$26 = value.title_text_colour;
    var tmp$12;
    if (value$26 == null) {
        tmp$12 = undefined;
    } else {
        var value$27 = value$26.value;
        tmp$12 = {
            __typename: value$26.__typename,
            value: !(value$27 == null) ? value$27 : undefined
        };
    }
    var value$28 = value.title_text_colour_2;
    var tmp$13;
    if (value$28 == null) {
        tmp$13 = undefined;
    } else {
        var value$29 = value$28.value;
        tmp$13 = {
            __typename: value$28.__typename,
            value: !(value$29 == null) ? value$29 : undefined
        };
    }
    var value$30 = value.title_font_size;
    var tmp$14;
    if (value$30 == null) {
        tmp$14 = undefined;
    } else {
        var value$31 = value$30.value;
        tmp$14 = {
            __typename: value$30.__typename,
            value: !(value$31 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$31) : undefined
        };
    }
    var value$32 = value.title_font_size_2;
    var tmp$15;
    if (value$32 == null) {
        tmp$15 = undefined;
    } else {
        var value$33 = value$32.value;
        tmp$15 = {
            __typename: value$32.__typename,
            value: !(value$33 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$33) : undefined
        };
    }
    var value$34 = value.description;
    var tmp$16;
    if (value$34 == null) {
        tmp$16 = undefined;
    } else {
        var value$35 = value$34.value;
        tmp$16 = {
            __typename: value$34.__typename,
            value: !(value$35 == null) ? value$35 : undefined
        };
    }
    var value$36 = value.description_2;
    var tmp$17;
    if (value$36 == null) {
        tmp$17 = undefined;
    } else {
        var value$37 = value$36.value;
        tmp$17 = {
            __typename: value$36.__typename,
            value: !(value$37 == null) ? value$37 : undefined
        };
    }
    var value$38 = value.description_text_colour;
    var tmp$18;
    if (value$38 == null) {
        tmp$18 = undefined;
    } else {
        var value$39 = value$38.value;
        tmp$18 = {
            __typename: value$38.__typename,
            value: !(value$39 == null) ? value$39 : undefined
        };
    }
    var value$40 = value.description_text_colour_2;
    var tmp$19;
    if (value$40 == null) {
        tmp$19 = undefined;
    } else {
        var value$41 = value$40.value;
        tmp$19 = {
            __typename: value$40.__typename,
            value: !(value$41 == null) ? value$41 : undefined
        };
    }
    var value$42 = value.description_font_size;
    var tmp$20;
    if (value$42 == null) {
        tmp$20 = undefined;
    } else {
        var value$43 = value$42.value;
        tmp$20 = {
            __typename: value$42.__typename,
            value: !(value$43 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$43) : undefined
        };
    }
    var value$44 = value.description_font_size_2;
    var tmp$21;
    if (value$44 == null) {
        tmp$21 = undefined;
    } else {
        var value$45 = value$44.value;
        tmp$21 = {
            __typename: value$44.__typename,
            value: !(value$45 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$45) : undefined
        };
    }
    var value$46 = value.cta_s;
    var tmp$22;
    if (value$46 == null) {
        tmp$22 = undefined;
    } else {
        var value$47 = value$46.value;
        tmp$22 = {
            __typename: value$46.__typename,
            value: !(value$47 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$47) : undefined
        };
    }
    var value$48 = value.cta_s_2;
    var tmp$23;
    if (value$48 == null) {
        tmp$23 = undefined;
    } else {
        var value$49 = value$48.value;
        tmp$23 = {
            __typename: value$48.__typename,
            value: !(value$49 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$49) : undefined
        };
    }
    var value$50 = value.desktop_image;
    var tmp$24;
    if (value$50 == null) {
        tmp$24 = undefined;
    } else {
        var value$51 = value$50.value;
        tmp$24 = {
            __typename: value$50.__typename,
            value: !(value$51 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$51) : undefined
        };
    }
    var value$52 = value.desktop_image_2;
    var tmp$25;
    if (value$52 == null) {
        tmp$25 = undefined;
    } else {
        var value$53 = value$52.value;
        tmp$25 = {
            __typename: value$52.__typename,
            value: !(value$53 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$53) : undefined
        };
    }
    var value$54 = value.tablet_image;
    var tmp$26;
    if (value$54 == null) {
        tmp$26 = undefined;
    } else {
        var value$55 = value$54.value;
        tmp$26 = {
            __typename: value$54.__typename,
            value: !(value$55 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$55) : undefined
        };
    }
    var value$56 = value.tablet_image_2;
    var tmp$27;
    if (value$56 == null) {
        tmp$27 = undefined;
    } else {
        var value$57 = value$56.value;
        tmp$27 = {
            __typename: value$56.__typename,
            value: !(value$57 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$57) : undefined
        };
    }
    var value$58 = value.mobile_image;
    var tmp$28;
    if (value$58 == null) {
        tmp$28 = undefined;
    } else {
        var value$59 = value$58.value;
        tmp$28 = {
            __typename: value$58.__typename,
            value: !(value$59 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$59) : undefined
        };
    }
    var value$60 = value.mobile_image_2;
    var tmp$29;
    if (value$60 == null) {
        tmp$29 = undefined;
    } else {
        var value$61 = value$60.value;
        tmp$29 = {
            __typename: value$60.__typename,
            value: !(value$61 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$61) : undefined
        };
    }
    var value$62 = value.display_badge;
    var tmp$30;
    if (value$62 == null) {
        tmp$30 = undefined;
    } else {
        var value$63 = value$62.value;
        tmp$30 = {
            __typename: value$62.__typename,
            value: !(value$63 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$63) : undefined
        };
    }
    var value$64 = value.badge_alignment;
    var tmp$31;
    if (value$64 == null) {
        tmp$31 = undefined;
    } else {
        var value$65 = value$64.value;
        tmp$31 = {
            __typename: value$64.__typename,
            value: !(value$65 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$65) : undefined
        };
    }
    var value$66 = value.badge_text;
    var tmp$32;
    if (value$66 == null) {
        tmp$32 = undefined;
    } else {
        var value$67 = value$66.value;
        tmp$32 = {
            __typename: value$66.__typename,
            value: !(value$67 == null) ? value$67 : undefined
        };
    }
    var value$68 = value.badge_text_colour;
    var tmp$33;
    if (value$68 == null) {
        tmp$33 = undefined;
    } else {
        var value$69 = value$68.value;
        tmp$33 = {
            __typename: value$68.__typename,
            value: !(value$69 == null) ? value$69 : undefined
        };
    }
    var value$70 = value.badge_background_colour;
    var tmp$34;
    if (value$70 == null) {
        tmp$34 = undefined;
    } else {
        var value$71 = value$70.value;
        tmp$34 = {
            __typename: value$70.__typename,
            value: !(value$71 == null) ? value$71 : undefined
        };
    }
    var value$72 = value.badge_outline_colour;
    var tmp$35;
    if (value$72 == null) {
        tmp$35 = undefined;
    } else {
        var value$73 = value$72.value;
        tmp$35 = {
            __typename: value$72.__typename,
            value: !(value$73 == null) ? value$73 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        background_colour: tmp,
        background_colour_2: tmp$1,
        copy_block_alignment: tmp$2,
        copy_block_alignment_2: tmp$3,
        image_treatment: tmp$4,
        image_treatment_2: tmp$5,
        title: tmp$6,
        title_2: tmp$7,
        highlight_text_colour: tmp$8,
        highlight_text_colour_2: tmp$9,
        title_font_style: tmp$10,
        title_font_style_2: tmp$11,
        title_text_colour: tmp$12,
        title_text_colour_2: tmp$13,
        title_font_size: tmp$14,
        title_font_size_2: tmp$15,
        description: tmp$16,
        description_2: tmp$17,
        description_text_colour: tmp$18,
        description_text_colour_2: tmp$19,
        description_font_size: tmp$20,
        description_font_size_2: tmp$21,
        cta_s: tmp$22,
        cta_s_2: tmp$23,
        desktop_image: tmp$24,
        desktop_image_2: tmp$25,
        tablet_image: tmp$26,
        tablet_image_2: tmp$27,
        mobile_image: tmp$28,
        mobile_image_2: tmp$29,
        display_badge: tmp$30,
        badge_alignment: tmp$31,
        badge_text: tmp$32,
        badge_text_colour: tmp$33,
        badge_background_colour: tmp$34,
        badge_outline_colour: tmp$35
    };
}
function Gql_HeroBanner_N2ColumnBanner_Fragment_bs_serialize(value) {
    var value$1 = value.badge_outline_colour;
    var badge_outline_colour;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        badge_outline_colour = {
            __typename: value$4,
            value: value$3
        };
    } else {
        badge_outline_colour = null;
    }
    var value$5 = value.badge_background_colour;
    var badge_background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        badge_background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        badge_background_colour = null;
    }
    var value$9 = value.badge_text_colour;
    var badge_text_colour;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        badge_text_colour = {
            __typename: value$12,
            value: value$11
        };
    } else {
        badge_text_colour = null;
    }
    var value$13 = value.badge_text;
    var badge_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        badge_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        badge_text = null;
    }
    var value$17 = value.badge_alignment;
    var badge_alignment;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        badge_alignment = {
            __typename: value$20,
            value: value$19
        };
    } else {
        badge_alignment = null;
    }
    var value$21 = value.display_badge;
    var display_badge;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$22) : null;
        var value$24 = value$21.__typename;
        display_badge = {
            __typename: value$24,
            value: value$23
        };
    } else {
        display_badge = null;
    }
    var value$25 = value.mobile_image_2;
    var mobile_image_2;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$26) : null;
        var value$28 = value$25.__typename;
        mobile_image_2 = {
            __typename: value$28,
            value: value$27
        };
    } else {
        mobile_image_2 = null;
    }
    var value$29 = value.mobile_image;
    var mobile_image;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        mobile_image = {
            __typename: value$32,
            value: value$31
        };
    } else {
        mobile_image = null;
    }
    var value$33 = value.tablet_image_2;
    var tablet_image_2;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$34) : null;
        var value$36 = value$33.__typename;
        tablet_image_2 = {
            __typename: value$36,
            value: value$35
        };
    } else {
        tablet_image_2 = null;
    }
    var value$37 = value.tablet_image;
    var tablet_image;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$38) : null;
        var value$40 = value$37.__typename;
        tablet_image = {
            __typename: value$40,
            value: value$39
        };
    } else {
        tablet_image = null;
    }
    var value$41 = value.desktop_image_2;
    var desktop_image_2;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$42) : null;
        var value$44 = value$41.__typename;
        desktop_image_2 = {
            __typename: value$44,
            value: value$43
        };
    } else {
        desktop_image_2 = null;
    }
    var value$45 = value.desktop_image;
    var desktop_image;
    if (value$45 !== undefined) {
        var value$46 = value$45.value;
        var value$47 = value$46 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$46) : null;
        var value$48 = value$45.__typename;
        desktop_image = {
            __typename: value$48,
            value: value$47
        };
    } else {
        desktop_image = null;
    }
    var value$49 = value.cta_s_2;
    var cta_s_2;
    if (value$49 !== undefined) {
        var value$50 = value$49.value;
        var value$51 = value$50 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$50) : null;
        var value$52 = value$49.__typename;
        cta_s_2 = {
            __typename: value$52,
            value: value$51
        };
    } else {
        cta_s_2 = null;
    }
    var value$53 = value.cta_s;
    var cta_s;
    if (value$53 !== undefined) {
        var value$54 = value$53.value;
        var value$55 = value$54 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$54) : null;
        var value$56 = value$53.__typename;
        cta_s = {
            __typename: value$56,
            value: value$55
        };
    } else {
        cta_s = null;
    }
    var value$57 = value.description_font_size_2;
    var description_font_size_2;
    if (value$57 !== undefined) {
        var value$58 = value$57.value;
        var value$59 = value$58 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$58) : null;
        var value$60 = value$57.__typename;
        description_font_size_2 = {
            __typename: value$60,
            value: value$59
        };
    } else {
        description_font_size_2 = null;
    }
    var value$61 = value.description_font_size;
    var description_font_size;
    if (value$61 !== undefined) {
        var value$62 = value$61.value;
        var value$63 = value$62 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$62) : null;
        var value$64 = value$61.__typename;
        description_font_size = {
            __typename: value$64,
            value: value$63
        };
    } else {
        description_font_size = null;
    }
    var value$65 = value.description_text_colour_2;
    var description_text_colour_2;
    if (value$65 !== undefined) {
        var value$66 = value$65.value;
        var value$67 = value$66 !== undefined ? value$66 : null;
        var value$68 = value$65.__typename;
        description_text_colour_2 = {
            __typename: value$68,
            value: value$67
        };
    } else {
        description_text_colour_2 = null;
    }
    var value$69 = value.description_text_colour;
    var description_text_colour;
    if (value$69 !== undefined) {
        var value$70 = value$69.value;
        var value$71 = value$70 !== undefined ? value$70 : null;
        var value$72 = value$69.__typename;
        description_text_colour = {
            __typename: value$72,
            value: value$71
        };
    } else {
        description_text_colour = null;
    }
    var value$73 = value.description_2;
    var description_2;
    if (value$73 !== undefined) {
        var value$74 = value$73.value;
        var value$75 = value$74 !== undefined ? value$74 : null;
        var value$76 = value$73.__typename;
        description_2 = {
            __typename: value$76,
            value: value$75
        };
    } else {
        description_2 = null;
    }
    var value$77 = value.description;
    var description;
    if (value$77 !== undefined) {
        var value$78 = value$77.value;
        var value$79 = value$78 !== undefined ? value$78 : null;
        var value$80 = value$77.__typename;
        description = {
            __typename: value$80,
            value: value$79
        };
    } else {
        description = null;
    }
    var value$81 = value.title_font_size_2;
    var title_font_size_2;
    if (value$81 !== undefined) {
        var value$82 = value$81.value;
        var value$83 = value$82 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$82) : null;
        var value$84 = value$81.__typename;
        title_font_size_2 = {
            __typename: value$84,
            value: value$83
        };
    } else {
        title_font_size_2 = null;
    }
    var value$85 = value.title_font_size;
    var title_font_size;
    if (value$85 !== undefined) {
        var value$86 = value$85.value;
        var value$87 = value$86 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$86) : null;
        var value$88 = value$85.__typename;
        title_font_size = {
            __typename: value$88,
            value: value$87
        };
    } else {
        title_font_size = null;
    }
    var value$89 = value.title_text_colour_2;
    var title_text_colour_2;
    if (value$89 !== undefined) {
        var value$90 = value$89.value;
        var value$91 = value$90 !== undefined ? value$90 : null;
        var value$92 = value$89.__typename;
        title_text_colour_2 = {
            __typename: value$92,
            value: value$91
        };
    } else {
        title_text_colour_2 = null;
    }
    var value$93 = value.title_text_colour;
    var title_text_colour;
    if (value$93 !== undefined) {
        var value$94 = value$93.value;
        var value$95 = value$94 !== undefined ? value$94 : null;
        var value$96 = value$93.__typename;
        title_text_colour = {
            __typename: value$96,
            value: value$95
        };
    } else {
        title_text_colour = null;
    }
    var value$97 = value.title_font_style_2;
    var title_font_style_2;
    if (value$97 !== undefined) {
        var value$98 = value$97.value;
        var value$99 = value$98 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$98) : null;
        var value$100 = value$97.__typename;
        title_font_style_2 = {
            __typename: value$100,
            value: value$99
        };
    } else {
        title_font_style_2 = null;
    }
    var value$101 = value.title_font_style;
    var title_font_style;
    if (value$101 !== undefined) {
        var value$102 = value$101.value;
        var value$103 = value$102 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$102) : null;
        var value$104 = value$101.__typename;
        title_font_style = {
            __typename: value$104,
            value: value$103
        };
    } else {
        title_font_style = null;
    }
    var value$105 = value.highlight_text_colour_2;
    var highlight_text_colour_2;
    if (value$105 !== undefined) {
        var value$106 = value$105.value;
        var value$107 = value$106 !== undefined ? value$106 : null;
        var value$108 = value$105.__typename;
        highlight_text_colour_2 = {
            __typename: value$108,
            value: value$107
        };
    } else {
        highlight_text_colour_2 = null;
    }
    var value$109 = value.highlight_text_colour;
    var highlight_text_colour;
    if (value$109 !== undefined) {
        var value$110 = value$109.value;
        var value$111 = value$110 !== undefined ? value$110 : null;
        var value$112 = value$109.__typename;
        highlight_text_colour = {
            __typename: value$112,
            value: value$111
        };
    } else {
        highlight_text_colour = null;
    }
    var value$113 = value.title_2;
    var title_2;
    if (value$113 !== undefined) {
        var value$114 = value$113.value;
        var value$115 = value$114 !== undefined ? value$114 : null;
        var value$116 = value$113.__typename;
        title_2 = {
            __typename: value$116,
            value: value$115
        };
    } else {
        title_2 = null;
    }
    var value$117 = value.title;
    var title;
    if (value$117 !== undefined) {
        var value$118 = value$117.value;
        var value$119 = value$118 !== undefined ? value$118 : null;
        var value$120 = value$117.__typename;
        title = {
            __typename: value$120,
            value: value$119
        };
    } else {
        title = null;
    }
    var value$121 = value.image_treatment_2;
    var image_treatment_2;
    if (value$121 !== undefined) {
        var value$122 = value$121.value;
        var value$123 = value$122 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$122) : null;
        var value$124 = value$121.__typename;
        image_treatment_2 = {
            __typename: value$124,
            value: value$123
        };
    } else {
        image_treatment_2 = null;
    }
    var value$125 = value.image_treatment;
    var image_treatment;
    if (value$125 !== undefined) {
        var value$126 = value$125.value;
        var value$127 = value$126 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$126) : null;
        var value$128 = value$125.__typename;
        image_treatment = {
            __typename: value$128,
            value: value$127
        };
    } else {
        image_treatment = null;
    }
    var value$129 = value.copy_block_alignment_2;
    var copy_block_alignment_2;
    if (value$129 !== undefined) {
        var value$130 = value$129.value;
        var value$131 = value$130 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$130) : null;
        var value$132 = value$129.__typename;
        copy_block_alignment_2 = {
            __typename: value$132,
            value: value$131
        };
    } else {
        copy_block_alignment_2 = null;
    }
    var value$133 = value.copy_block_alignment;
    var copy_block_alignment;
    if (value$133 !== undefined) {
        var value$134 = value$133.value;
        var value$135 = value$134 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$134) : null;
        var value$136 = value$133.__typename;
        copy_block_alignment = {
            __typename: value$136,
            value: value$135
        };
    } else {
        copy_block_alignment = null;
    }
    var value$137 = value.background_colour_2;
    var background_colour_2;
    if (value$137 !== undefined) {
        var value$138 = value$137.value;
        var value$139 = value$138 !== undefined ? value$138 : null;
        var value$140 = value$137.__typename;
        background_colour_2 = {
            __typename: value$140,
            value: value$139
        };
    } else {
        background_colour_2 = null;
    }
    var value$141 = value.background_colour;
    var background_colour;
    if (value$141 !== undefined) {
        var value$142 = value$141.value;
        var value$143 = value$142 !== undefined ? value$142 : null;
        var value$144 = value$141.__typename;
        background_colour = {
            __typename: value$144,
            value: value$143
        };
    } else {
        background_colour = null;
    }
    var value$145 = value.system;
    var value$146 = value$145.codename;
    var value$147 = value$145.id;
    var value$148 = value$145.__typename;
    var system = {
        __typename: value$148,
        id: value$147,
        codename: value$146
    };
    var value$149 = value.__typename;
    return {
        __typename: value$149,
        system: system,
        background_colour: background_colour,
        background_colour_2: background_colour_2,
        copy_block_alignment: copy_block_alignment,
        copy_block_alignment_2: copy_block_alignment_2,
        image_treatment: image_treatment,
        image_treatment_2: image_treatment_2,
        title: title,
        title_2: title_2,
        highlight_text_colour: highlight_text_colour,
        highlight_text_colour_2: highlight_text_colour_2,
        title_font_style: title_font_style,
        title_font_style_2: title_font_style_2,
        title_text_colour: title_text_colour,
        title_text_colour_2: title_text_colour_2,
        title_font_size: title_font_size,
        title_font_size_2: title_font_size_2,
        description: description,
        description_2: description_2,
        description_text_colour: description_text_colour,
        description_text_colour_2: description_text_colour_2,
        description_font_size: description_font_size,
        description_font_size_2: description_font_size_2,
        cta_s: cta_s,
        cta_s_2: cta_s_2,
        desktop_image: desktop_image,
        desktop_image_2: desktop_image_2,
        tablet_image: tablet_image,
        tablet_image_2: tablet_image_2,
        mobile_image: mobile_image,
        mobile_image_2: mobile_image_2,
        display_badge: display_badge,
        badge_alignment: badge_alignment,
        badge_text: badge_text,
        badge_text_colour: badge_text_colour,
        badge_background_colour: badge_background_colour,
        badge_outline_colour: badge_outline_colour
    };
}
function Gql_HeroBanner_N2ColumnBanner_Fragment_bs_verifyArgsAndParse(_N2ColumnHero, value) {
    return Gql_HeroBanner_N2ColumnBanner_Fragment_bs_parse(value);
}
function Gql_HeroBanner_N2ColumnBanner_Fragment_bs_verifyName(param) {}
var N2ColumnHero = {
    Raw: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_Raw,
    query: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_query,
    parse: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_parse,
    serialize: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeroBanner_N2ColumnBanner_Fragment_bs_verifyName
};
var Gql_HeroBanner_N2ColumnBanner_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment HeroBanner on HeroBannerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    width  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    search_bar_overlay  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    apply_radius  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    n1_column_banner_s  {\n      __typename\n      value  {\n        __typename\n        ...on N1ColumnHeroBannerContentType   {\n          ...N1ColumnHero\n        }\n      }\n    }\n    n2_column_banner  {\n      __typename\n      value  {\n        __typename\n        ...on N2ColumnHeroBannerContentType   {\n          ...N2ColumnHero\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_HeroBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_HeroBanner_Fragment_bs_Raw = {};
var Gql_HeroBanner_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_HeroBanner_Fragment_bs_templateObject(), frag_0, frag_1);
}(N1ColumnHero.query, N2ColumnHero.query);
function Gql_HeroBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.width;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.search_bar_overlay;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.apply_radius;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.n1_column_banner_s;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "N1ColumnHeroBannerContentType" ? {
                    NAME: "N1ColumnHeroBannerContentType",
                    VAL: {
                        n1ColumnHero: N1ColumnHero.verifyArgsAndParse("N1ColumnHero", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.n2_column_banner;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "N2ColumnHeroBannerContentType" ? {
                    NAME: "N2ColumnHeroBannerContentType",
                    VAL: {
                        n2ColumnHero: N2ColumnHero.verifyArgsAndParse("N2ColumnHero", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$11) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        width: tmp,
        search_bar_overlay: tmp$1,
        apply_radius: tmp$2,
        n1_column_banner_s: tmp$3,
        n2_column_banner: tmp$4
    };
}
function Gql_HeroBanner_Fragment_bs_serialize(value) {
    var value$1 = value.n2_column_banner;
    var n2_column_banner;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "N2ColumnHeroBannerContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        N2ColumnHero.serialize(value.VAL.n2ColumnHero)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        n2_column_banner = {
            __typename: value$4,
            value: value$3
        };
    } else {
        n2_column_banner = null;
    }
    var value$5 = value.n1_column_banner_s;
    var n1_column_banner_s;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        N1ColumnHero.serialize(value.VAL.n1ColumnHero)
                    ]);
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        n1_column_banner_s = {
            __typename: value$8,
            value: value$7
        };
    } else {
        n1_column_banner_s = null;
    }
    var value$9 = value.apply_radius;
    var apply_radius;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        apply_radius = {
            __typename: value$12,
            value: value$11
        };
    } else {
        apply_radius = null;
    }
    var value$13 = value.search_bar_overlay;
    var search_bar_overlay;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        search_bar_overlay = {
            __typename: value$16,
            value: value$15
        };
    } else {
        search_bar_overlay = null;
    }
    var value$17 = value.width;
    var width;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        width = {
            __typename: value$20,
            value: value$19
        };
    } else {
        width = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        width: width,
        search_bar_overlay: search_bar_overlay,
        apply_radius: apply_radius,
        n1_column_banner_s: n1_column_banner_s,
        n2_column_banner: n2_column_banner
    };
}
function Gql_HeroBanner_Fragment_bs_verifyArgsAndParse(_HeroBanner, value) {
    return Gql_HeroBanner_Fragment_bs_parse(value);
}
function Gql_HeroBanner_Fragment_bs_verifyName(param) {}
var HeroBanner = {
    Raw: Gql_HeroBanner_Fragment_bs_Raw,
    query: Gql_HeroBanner_Fragment_bs_query,
    parse: Gql_HeroBanner_Fragment_bs_parse,
    serialize: Gql_HeroBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeroBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeroBanner_Fragment_bs_verifyName
};
var Gql_HeroBanner_Fragment_bs_N1ColumnHero;
var Gql_HeroBanner_Fragment_bs_N2ColumnHero;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/DeviceSizeImage/Gql__DeviceSizeImage__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_DeviceSizeImage_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment DeviceSizeImage on DeviceSizeImageContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    desktop_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    tablet_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    mobile_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n"
    ]);
    Gql_DeviceSizeImage_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_DeviceSizeImage_Fragment_bs_Raw = {};
var Gql_DeviceSizeImage_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_DeviceSizeImage_Fragment_bs_templateObject());
function Gql_DeviceSizeImage_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.desktop_asset;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.tablet_asset;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.mobile_asset;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        desktop_asset: tmp,
        tablet_asset: tmp$1,
        mobile_asset: tmp$2
    };
}
function Gql_DeviceSizeImage_Fragment_bs_serialize(value) {
    var value$1 = value.mobile_asset;
    var mobile_asset;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        mobile_asset = {
            __typename: value$4,
            value: value$3
        };
    } else {
        mobile_asset = null;
    }
    var value$5 = value.tablet_asset;
    var tablet_asset;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        tablet_asset = {
            __typename: value$8,
            value: value$7
        };
    } else {
        tablet_asset = null;
    }
    var value$9 = value.desktop_asset;
    var desktop_asset;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        desktop_asset = {
            __typename: value$12,
            value: value$11
        };
    } else {
        desktop_asset = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        desktop_asset: desktop_asset,
        tablet_asset: tablet_asset,
        mobile_asset: mobile_asset
    };
}
function Gql_DeviceSizeImage_Fragment_bs_verifyArgsAndParse(_DeviceSizeImage, value) {
    return Gql_DeviceSizeImage_Fragment_bs_parse(value);
}
function Gql_DeviceSizeImage_Fragment_bs_verifyName(param) {}
var DeviceSizeImage = {
    Raw: Gql_DeviceSizeImage_Fragment_bs_Raw,
    query: Gql_DeviceSizeImage_Fragment_bs_query,
    parse: Gql_DeviceSizeImage_Fragment_bs_parse,
    serialize: Gql_DeviceSizeImage_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_DeviceSizeImage_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_DeviceSizeImage_Fragment_bs_verifyName
};
var Gql_DeviceSizeImage_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/PromoTiles/Gql__PromoTiles__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_PromoTiles_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment PromoTileBlock on PromoTileBlockContentType   {\n    __typename\n    tiles  {\n      __typename\n      value  {\n        __typename\n        ...on PromoTileContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value\n          }\n          background_colour  {\n            __typename\n            value\n          }\n          background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n              ...on DeviceSizeImageContentType   {\n                ...DeviceSizeImage\n              }\n            }\n          }\n          graphic_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          text_colour  {\n            __typename\n            value\n          }\n          desktop_text_width  {\n            __typename\n            value\n          }\n          icon_colour  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_PromoTiles_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_PromoTiles_Fragment_bs_Raw = {};
var Gql_PromoTiles_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_PromoTiles_Fragment_bs_templateObject(), frag_0, frag_1);
}(DeviceSizeImage.query, $$Image.query);
function Gql_PromoTiles_Fragment_bs_parse(value) {
    var value$1 = value.tiles;
    var tmp;
    if (value$1 == null) {
        tmp = undefined;
    } else {
        var value$2 = value$1.value;
        tmp = {
            __typename: value$1.__typename,
            value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "PromoTileContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.url;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.background_colour;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.background_image;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp;
                                switch(typename){
                                    case "DeviceSizeImageContentType":
                                        tmp = {
                                            NAME: "DeviceSizeImageContentType",
                                            VAL: {
                                                deviceSizeImage: DeviceSizeImage.verifyArgsAndParse("DeviceSizeImage", value)
                                            }
                                        };
                                        break;
                                    case "ImageContentType":
                                        tmp = {
                                            NAME: "ImageContentType",
                                            VAL: {
                                                image: $$Image.verifyArgsAndParse("Image", value)
                                            }
                                        };
                                        break;
                                    default:
                                        tmp = {
                                            NAME: "UnspecifiedFragment",
                                            VAL: typename
                                        };
                                }
                                return tmp;
                            }, value$9) : undefined
                        };
                    }
                    var value$10 = value.graphic_asset;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$11) : undefined
                        };
                    }
                    var value$12 = value.text_colour;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? value$13 : undefined
                        };
                    }
                    var value$14 = value.desktop_text_width;
                    var tmp$7;
                    if (value$14 == null) {
                        tmp$7 = undefined;
                    } else {
                        var value$15 = value$14.value;
                        tmp$7 = {
                            __typename: value$14.__typename,
                            value: !(value$15 == null) ? value$15 : undefined
                        };
                    }
                    var value$16 = value.icon_colour;
                    var tmp$8;
                    if (value$16 == null) {
                        tmp$8 = undefined;
                    } else {
                        var value$17 = value$16.value;
                        tmp$8 = {
                            __typename: value$16.__typename,
                            value: !(value$17 == null) ? value$17 : undefined
                        };
                    }
                    tmp = {
                        NAME: "PromoTileContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            url: tmp$2,
                            background_colour: tmp$3,
                            background_image: tmp$4,
                            graphic_asset: tmp$5,
                            text_colour: tmp$6,
                            desktop_text_width: tmp$7,
                            icon_colour: tmp$8
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$2) : undefined
        };
    }
    return {
        __typename: value.__typename,
        tiles: tmp
    };
}
function Gql_PromoTiles_Fragment_bs_serialize(value) {
    var value$1 = value.tiles;
    var tiles;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.icon_colour;
            var icon_colour;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                icon_colour = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                icon_colour = null;
            }
            var value$6 = value$1.desktop_text_width;
            var desktop_text_width;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                desktop_text_width = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                desktop_text_width = null;
            }
            var value$10 = value$1.text_colour;
            var text_colour;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                text_colour = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                text_colour = null;
            }
            var value$14 = value$1.graphic_asset;
            var graphic_asset;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$15) : null;
                var value$17 = value$14.__typename;
                graphic_asset = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                graphic_asset = null;
            }
            var value$18 = value$1.background_image;
            var background_image;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var variant = value.NAME;
                    if (variant === "UnspecifiedFragment") {
                        return {};
                    } else if (variant === "DeviceSizeImageContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            DeviceSizeImage.serialize(value.VAL.deviceSizeImage)
                        ]);
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            $$Image.serialize(value.VAL.image)
                        ]);
                    }
                }, value$19) : null;
                var value$21 = value$18.__typename;
                background_image = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                background_image = null;
            }
            var value$22 = value$1.background_colour;
            var background_colour;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? value$23 : null;
                var value$25 = value$22.__typename;
                background_colour = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                background_colour = null;
            }
            var value$26 = value$1.url;
            var url;
            if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? value$27 : null;
                var value$29 = value$26.__typename;
                url = {
                    __typename: value$29,
                    value: value$28
                };
            } else {
                url = null;
            }
            var value$30 = value$1.title;
            var title;
            if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? value$31 : null;
                var value$33 = value$30.__typename;
                title = {
                    __typename: value$33,
                    value: value$32
                };
            } else {
                title = null;
            }
            var value$34 = value$1.system;
            var value$35 = value$34.codename;
            var value$36 = value$34.id;
            var value$37 = value$34.__typename;
            var system = {
                __typename: value$37,
                id: value$36,
                codename: value$35
            };
            return {
                __typename: "PromoTileContentType",
                system: system,
                title: title,
                url: url,
                background_colour: background_colour,
                background_image: background_image,
                graphic_asset: graphic_asset,
                text_colour: text_colour,
                desktop_text_width: desktop_text_width,
                icon_colour: icon_colour
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        tiles = {
            __typename: value$4,
            value: value$3
        };
    } else {
        tiles = null;
    }
    var value$5 = value.__typename;
    return {
        __typename: value$5,
        tiles: tiles
    };
}
function Gql_PromoTiles_Fragment_bs_verifyArgsAndParse(_PromoTileBlock, value) {
    return Gql_PromoTiles_Fragment_bs_parse(value);
}
function Gql_PromoTiles_Fragment_bs_verifyName(param) {}
var PromoTileBlock = {
    Raw: Gql_PromoTiles_Fragment_bs_Raw,
    query: Gql_PromoTiles_Fragment_bs_query,
    parse: Gql_PromoTiles_Fragment_bs_parse,
    serialize: Gql_PromoTiles_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_PromoTiles_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_PromoTiles_Fragment_bs_verifyName
};
var Gql_PromoTiles_Fragment_bs_$$Image;
var Gql_PromoTiles_Fragment_bs_DeviceSizeImage;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Icon/Gql__Icon__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Icon_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment Icon on IconContentType   {\n    __typename\n    svg  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n"
    ]);
    Gql_Icon_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_Icon_Fragment_bs_Raw = {};
var Gql_Icon_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_Icon_Fragment_bs_templateObject());
function Gql_Icon_Fragment_bs_parse(value) {
    var value$1 = value.svg;
    var tmp;
    if (value$1 == null) {
        tmp = undefined;
    } else {
        var value$2 = value$1.value;
        tmp = {
            __typename: value$1.__typename,
            value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$2) : undefined
        };
    }
    return {
        __typename: value.__typename,
        svg: tmp
    };
}
function Gql_Icon_Fragment_bs_serialize(value) {
    var value$1 = value.svg;
    var svg;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        svg = {
            __typename: value$4,
            value: value$3
        };
    } else {
        svg = null;
    }
    var value$5 = value.__typename;
    return {
        __typename: value$5,
        svg: svg
    };
}
function Gql_Icon_Fragment_bs_verifyArgsAndParse(_Icon, value) {
    return Gql_Icon_Fragment_bs_parse(value);
}
function Gql_Icon_Fragment_bs_verifyName(param) {}
var Icon = {
    Raw: Gql_Icon_Fragment_bs_Raw,
    query: Gql_Icon_Fragment_bs_query,
    parse: Gql_Icon_Fragment_bs_parse,
    serialize: Gql_Icon_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_Icon_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_Icon_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StatsTiles_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StatsTilesBlock on EnvironmentalImpactsBlockContentType   {\n    __typename\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    environmental_impact_cards  {\n      __typename\n      value  {\n        __typename\n        ...on EnvironmentalImpactCardContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          subtitle  {\n            __typename\n            value\n          }\n          text_colour  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          icon  {\n            __typename\n            value  {\n              __typename\n              ...on IconContentType   {\n                ...Icon\n              }\n            }\n          }\n          fontawesome_icon_class  {\n            __typename\n            value\n          }\n          background_colour  {\n            __typename\n            value\n          }\n          background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_image_mobile  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_StatsTiles_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_StatsTiles_Fragment_bs_Raw = {};
var Gql_StatsTiles_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_StatsTiles_Fragment_bs_templateObject(), frag_0, frag_1);
}(Icon.query, $$Image.query);
function Gql_StatsTiles_Fragment_bs_parse(value) {
    var value$1 = value.title;
    var tmp;
    if (value$1 == null) {
        tmp = undefined;
    } else {
        var value$2 = value$1.value;
        tmp = {
            __typename: value$1.__typename,
            value: !(value$2 == null) ? value$2 : undefined
        };
    }
    var value$3 = value.description;
    var tmp$1;
    if (value$3 == null) {
        tmp$1 = undefined;
    } else {
        var value$4 = value$3.value;
        tmp$1 = {
            __typename: value$3.__typename,
            value: !(value$4 == null) ? value$4 : undefined
        };
    }
    var value$5 = value.environmental_impact_cards;
    var tmp$2;
    if (value$5 == null) {
        tmp$2 = undefined;
    } else {
        var value$6 = value$5.value;
        tmp$2 = {
            __typename: value$5.__typename,
            value: !(value$6 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "EnvironmentalImpactCardContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.subtitle;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.text_colour;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$7) : undefined
                        };
                    }
                    var value$8 = value.icon;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "IconContentType" ? {
                                    NAME: "IconContentType",
                                    VAL: {
                                        icon: Icon.verifyArgsAndParse("Icon", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$9) : undefined
                        };
                    }
                    var value$10 = value.fontawesome_icon_class;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? value$11 : undefined
                        };
                    }
                    var value$12 = value.background_colour;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? value$13 : undefined
                        };
                    }
                    var value$14 = value.background_image;
                    var tmp$7;
                    if (value$14 == null) {
                        tmp$7 = undefined;
                    } else {
                        var value$15 = value$14.value;
                        tmp$7 = {
                            __typename: value$14.__typename,
                            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$15) : undefined
                        };
                    }
                    var value$16 = value.background_image_mobile;
                    var tmp$8;
                    if (value$16 == null) {
                        tmp$8 = undefined;
                    } else {
                        var value$17 = value$16.value;
                        tmp$8 = {
                            __typename: value$16.__typename,
                            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$17) : undefined
                        };
                    }
                    tmp = {
                        NAME: "EnvironmentalImpactCardContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            subtitle: tmp$2,
                            text_colour: tmp$3,
                            icon: tmp$4,
                            fontawesome_icon_class: tmp$5,
                            background_colour: tmp$6,
                            background_image: tmp$7,
                            background_image_mobile: tmp$8
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$6) : undefined
        };
    }
    return {
        __typename: value.__typename,
        title: tmp,
        description: tmp$1,
        environmental_impact_cards: tmp$2
    };
}
function Gql_StatsTiles_Fragment_bs_serialize(value) {
    var value$1 = value.environmental_impact_cards;
    var environmental_impact_cards;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.background_image_mobile;
            var background_image_mobile;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$3) : null;
                var value$5 = value$2.__typename;
                background_image_mobile = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                background_image_mobile = null;
            }
            var value$6 = value$1.background_image;
            var background_image;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$7) : null;
                var value$9 = value$6.__typename;
                background_image = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                background_image = null;
            }
            var value$10 = value$1.background_colour;
            var background_colour;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                background_colour = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                background_colour = null;
            }
            var value$14 = value$1.fontawesome_icon_class;
            var fontawesome_icon_class;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                fontawesome_icon_class = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                fontawesome_icon_class = null;
            }
            var value$18 = value$1.icon;
            var icon;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                Icon.serialize(value.VAL.icon)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$19) : null;
                var value$21 = value$18.__typename;
                icon = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                icon = null;
            }
            var value$22 = value$1.text_colour;
            var text_colour;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$23) : null;
                var value$25 = value$22.__typename;
                text_colour = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                text_colour = null;
            }
            var value$26 = value$1.subtitle;
            var subtitle;
            if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? value$27 : null;
                var value$29 = value$26.__typename;
                subtitle = {
                    __typename: value$29,
                    value: value$28
                };
            } else {
                subtitle = null;
            }
            var value$30 = value$1.title;
            var title;
            if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? value$31 : null;
                var value$33 = value$30.__typename;
                title = {
                    __typename: value$33,
                    value: value$32
                };
            } else {
                title = null;
            }
            var value$34 = value$1.system;
            var value$35 = value$34.codename;
            var value$36 = value$34.id;
            var value$37 = value$34.__typename;
            var system = {
                __typename: value$37,
                id: value$36,
                codename: value$35
            };
            return {
                __typename: "EnvironmentalImpactCardContentType",
                system: system,
                title: title,
                subtitle: subtitle,
                text_colour: text_colour,
                icon: icon,
                fontawesome_icon_class: fontawesome_icon_class,
                background_colour: background_colour,
                background_image: background_image,
                background_image_mobile: background_image_mobile
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        environmental_impact_cards = {
            __typename: value$4,
            value: value$3
        };
    } else {
        environmental_impact_cards = null;
    }
    var value$5 = value.description;
    var description;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        description = {
            __typename: value$8,
            value: value$7
        };
    } else {
        description = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        title: title,
        description: description,
        environmental_impact_cards: environmental_impact_cards
    };
}
function Gql_StatsTiles_Fragment_bs_verifyArgsAndParse(_StatsTilesBlock, value) {
    return Gql_StatsTiles_Fragment_bs_parse(value);
}
function Gql_StatsTiles_Fragment_bs_verifyName(param) {}
var StatsTilesBlock = {
    Raw: Gql_StatsTiles_Fragment_bs_Raw,
    query: Gql_StatsTiles_Fragment_bs_query,
    parse: Gql_StatsTiles_Fragment_bs_parse,
    serialize: Gql_StatsTiles_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_StatsTiles_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_StatsTiles_Fragment_bs_verifyName
};
var Gql_StatsTiles_Fragment_bs_$$Image;
var Gql_StatsTiles_Fragment_bs_Icon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuCarousel/Gql__SkuCarousel__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SkuCarousel_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SkuCarouselBlock on SkuCarouselBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n      language\n    }\n    title  {\n      __typename\n      value\n    }\n    subtitle  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    background  {\n      __typename\n      name\n      value  {\n        __typename\n        codename\n      }\n    }\n    sku_list  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_SkuCarousel_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_SkuCarousel_Fragment_bs_Raw = {};
var Gql_SkuCarousel_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SkuCarousel_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_SkuCarousel_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.subtitle;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.button;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.background;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            name: value$10.name,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.sku_list;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? value$13 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename,
            language: value$1.language
        },
        title: tmp,
        subtitle: tmp$1,
        description: tmp$2,
        button: tmp$3,
        background: tmp$4,
        sku_list: tmp$5
    };
}
function Gql_SkuCarousel_Fragment_bs_serialize(value) {
    var value$1 = value.sku_list;
    var sku_list;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        sku_list = {
            __typename: value$4,
            value: value$3
        };
    } else {
        sku_list = null;
    }
    var value$5 = value.background;
    var background;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$6) : null;
        var value$8 = value$5.name;
        var value$9 = value$5.__typename;
        background = {
            __typename: value$9,
            name: value$8,
            value: value$7
        };
    } else {
        background = null;
    }
    var value$10 = value.button;
    var button;
    if (value$10 !== undefined) {
        var value$11 = value$10.value;
        var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$11) : null;
        var value$13 = value$10.__typename;
        button = {
            __typename: value$13,
            value: value$12
        };
    } else {
        button = null;
    }
    var value$14 = value.description;
    var description;
    if (value$14 !== undefined) {
        var value$15 = value$14.value;
        var value$16 = value$15 !== undefined ? value$15 : null;
        var value$17 = value$14.__typename;
        description = {
            __typename: value$17,
            value: value$16
        };
    } else {
        description = null;
    }
    var value$18 = value.subtitle;
    var subtitle;
    if (value$18 !== undefined) {
        var value$19 = value$18.value;
        var value$20 = value$19 !== undefined ? value$19 : null;
        var value$21 = value$18.__typename;
        subtitle = {
            __typename: value$21,
            value: value$20
        };
    } else {
        subtitle = null;
    }
    var value$22 = value.title;
    var title;
    if (value$22 !== undefined) {
        var value$23 = value$22.value;
        var value$24 = value$23 !== undefined ? value$23 : null;
        var value$25 = value$22.__typename;
        title = {
            __typename: value$25,
            value: value$24
        };
    } else {
        title = null;
    }
    var value$26 = value.system;
    var value$27 = value$26.language;
    var value$28 = value$26.codename;
    var value$29 = value$26.id;
    var value$30 = value$26.__typename;
    var system = {
        __typename: value$30,
        id: value$29,
        codename: value$28,
        language: value$27
    };
    var value$31 = value.__typename;
    return {
        __typename: value$31,
        system: system,
        title: title,
        subtitle: subtitle,
        description: description,
        button: button,
        background: background,
        sku_list: sku_list
    };
}
function Gql_SkuCarousel_Fragment_bs_verifyArgsAndParse(_SkuCarouselBlock, value) {
    return Gql_SkuCarousel_Fragment_bs_parse(value);
}
function Gql_SkuCarousel_Fragment_bs_verifyName(param) {}
var SkuCarouselBlock = {
    Raw: Gql_SkuCarousel_Fragment_bs_Raw,
    query: Gql_SkuCarousel_Fragment_bs_query,
    parse: Gql_SkuCarousel_Fragment_bs_parse,
    serialize: Gql_SkuCarousel_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SkuCarousel_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SkuCarousel_Fragment_bs_verifyName
};
var Gql_SkuCarousel_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/EnrichedTextBlock/Gql__EnrichedTextBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_EnrichedTextBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment EnrichedTextBlock on EnrichedTextBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    width  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    content  {\n      __typename\n      value\n    }\n    distance_top  {\n      __typename\n      value\n    }\n    distance_bottom  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_EnrichedTextBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_EnrichedTextBlock_Fragment_bs_Raw = {};
var Gql_EnrichedTextBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_EnrichedTextBlock_Fragment_bs_templateObject());
function Gql_EnrichedTextBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.width;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.alignment;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.content;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.distance_top;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.distance_bottom;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        width: tmp,
        alignment: tmp$1,
        content: tmp$2,
        distance_top: tmp$3,
        distance_bottom: tmp$4
    };
}
function Gql_EnrichedTextBlock_Fragment_bs_serialize(value) {
    var value$1 = value.distance_bottom;
    var distance_bottom;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        distance_bottom = {
            __typename: value$4,
            value: value$3
        };
    } else {
        distance_bottom = null;
    }
    var value$5 = value.distance_top;
    var distance_top;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        distance_top = {
            __typename: value$8,
            value: value$7
        };
    } else {
        distance_top = null;
    }
    var value$9 = value.content;
    var content;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        content = {
            __typename: value$12,
            value: value$11
        };
    } else {
        content = null;
    }
    var value$13 = value.alignment;
    var alignment;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        alignment = {
            __typename: value$16,
            value: value$15
        };
    } else {
        alignment = null;
    }
    var value$17 = value.width;
    var width;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        width = {
            __typename: value$20,
            value: value$19
        };
    } else {
        width = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        width: width,
        alignment: alignment,
        content: content,
        distance_top: distance_top,
        distance_bottom: distance_bottom
    };
}
function Gql_EnrichedTextBlock_Fragment_bs_verifyArgsAndParse(_EnrichedTextBlock, value) {
    return Gql_EnrichedTextBlock_Fragment_bs_parse(value);
}
function Gql_EnrichedTextBlock_Fragment_bs_verifyName(param) {}
var EnrichedTextBlock = {
    Raw: Gql_EnrichedTextBlock_Fragment_bs_Raw,
    query: Gql_EnrichedTextBlock_Fragment_bs_query,
    parse: Gql_EnrichedTextBlock_Fragment_bs_parse,
    serialize: Gql_EnrichedTextBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_EnrichedTextBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_EnrichedTextBlock_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SmartCardHeroBlock/Gql__SmartCardHeroBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SmartCardHeroBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SmartCardHeroBlock on SmartCardHeroBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    primary_button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    secondary_button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    tablet_image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_SmartCardHeroBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_SmartCardHeroBlock_Fragment_bs_Raw = {};
var Gql_SmartCardHeroBlock_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SmartCardHeroBlock_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_SmartCardHeroBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.primary_button;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.secondary_button;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.image;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.tablet_image;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$13) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        primary_button: tmp$2,
        secondary_button: tmp$3,
        image: tmp$4,
        tablet_image: tmp$5
    };
}
function Gql_SmartCardHeroBlock_Fragment_bs_serialize(value) {
    var value$1 = value.tablet_image;
    var tablet_image;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        tablet_image = {
            __typename: value$4,
            value: value$3
        };
    } else {
        tablet_image = null;
    }
    var value$5 = value.image;
    var image;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        image = {
            __typename: value$8,
            value: value$7
        };
    } else {
        image = null;
    }
    var value$9 = value.secondary_button;
    var secondary_button;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        secondary_button = {
            __typename: value$12,
            value: value$11
        };
    } else {
        secondary_button = null;
    }
    var value$13 = value.primary_button;
    var primary_button;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$14) : null;
        var value$16 = value$13.__typename;
        primary_button = {
            __typename: value$16,
            value: value$15
        };
    } else {
        primary_button = null;
    }
    var value$17 = value.description;
    var description;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        description = {
            __typename: value$20,
            value: value$19
        };
    } else {
        description = null;
    }
    var value$21 = value.title;
    var title;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        title = {
            __typename: value$24,
            value: value$23
        };
    } else {
        title = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        title: title,
        description: description,
        primary_button: primary_button,
        secondary_button: secondary_button,
        image: image,
        tablet_image: tablet_image
    };
}
function Gql_SmartCardHeroBlock_Fragment_bs_verifyArgsAndParse(_SmartCardHeroBlock, value) {
    return Gql_SmartCardHeroBlock_Fragment_bs_parse(value);
}
function Gql_SmartCardHeroBlock_Fragment_bs_verifyName(param) {}
var SmartCardHeroBlock = {
    Raw: Gql_SmartCardHeroBlock_Fragment_bs_Raw,
    query: Gql_SmartCardHeroBlock_Fragment_bs_query,
    parse: Gql_SmartCardHeroBlock_Fragment_bs_parse,
    serialize: Gql_SmartCardHeroBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SmartCardHeroBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SmartCardHeroBlock_Fragment_bs_verifyName
};
var Gql_SmartCardHeroBlock_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/StoreContentContentType/Gql__StoreContent__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StoreContent_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StoreContentBlock on StoreContentContentType   {\n    __typename\n    system  {\n      __typename\n      codename\n      language\n    }\n    smart_card_content  {\n      __typename\n      value  {\n        __typename\n        ...on EnrichedTextBlockContentType   {\n          ...EnrichedTextBlock\n        }\n        ...on SmartCardHeroBlockContentType   {\n          ...SmartCardHeroBlock\n        }\n      }\n    }\n    retailer_card_content  {\n      __typename\n      value  {\n        __typename\n        ...on EnrichedTextBlockContentType   {\n          ...EnrichedTextBlock\n        }\n      }\n    }\n    end_of_page_content  {\n      __typename\n      value  {\n        __typename\n        ...on EnrichedTextBlockContentType   {\n          ...EnrichedTextBlock\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_StoreContent_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_StoreContent_Fragment_bs_Raw = {};
var Gql_StoreContent_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_StoreContent_Fragment_bs_templateObject(), frag_0, frag_1);
}(EnrichedTextBlock.query, SmartCardHeroBlock.query);
function Gql_StoreContent_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.smart_card_content;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                switch(typename){
                    case "EnrichedTextBlockContentType":
                        tmp = {
                            NAME: "EnrichedTextBlockContentType",
                            VAL: {
                                enrichedTextBlock: EnrichedTextBlock.verifyArgsAndParse("EnrichedTextBlock", value)
                            }
                        };
                        break;
                    case "SmartCardHeroBlockContentType":
                        tmp = {
                            NAME: "SmartCardHeroBlockContentType",
                            VAL: {
                                smartCardHeroBlock: SmartCardHeroBlock.verifyArgsAndParse("SmartCardHeroBlock", value)
                            }
                        };
                        break;
                    default:
                        tmp = {
                            NAME: "UnspecifiedFragment",
                            VAL: typename
                        };
                }
                return tmp;
            }, value$3) : undefined
        };
    }
    var value$4 = value.retailer_card_content;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "EnrichedTextBlockContentType" ? {
                    NAME: "EnrichedTextBlockContentType",
                    VAL: {
                        enrichedTextBlock: EnrichedTextBlock.verifyArgsAndParse("EnrichedTextBlock", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.end_of_page_content;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "EnrichedTextBlockContentType" ? {
                    NAME: "EnrichedTextBlockContentType",
                    VAL: {
                        enrichedTextBlock: EnrichedTextBlock.verifyArgsAndParse("EnrichedTextBlock", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            codename: value$1.codename,
            language: value$1.language
        },
        smart_card_content: tmp,
        retailer_card_content: tmp$1,
        end_of_page_content: tmp$2
    };
}
function Gql_StoreContent_Fragment_bs_serialize(value) {
    var value$1 = value.end_of_page_content;
    var end_of_page_content;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "EnrichedTextBlockContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        EnrichedTextBlock.serialize(value.VAL.enrichedTextBlock)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        end_of_page_content = {
            __typename: value$4,
            value: value$3
        };
    } else {
        end_of_page_content = null;
    }
    var value$5 = value.retailer_card_content;
    var retailer_card_content;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "EnrichedTextBlockContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        EnrichedTextBlock.serialize(value.VAL.enrichedTextBlock)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        retailer_card_content = {
            __typename: value$8,
            value: value$7
        };
    } else {
        retailer_card_content = null;
    }
    var value$9 = value.smart_card_content;
    var smart_card_content;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var variant = value.NAME;
            if (variant === "UnspecifiedFragment") {
                return {};
            } else if (variant === "EnrichedTextBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    EnrichedTextBlock.serialize(value.VAL.enrichedTextBlock)
                ]);
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    SmartCardHeroBlock.serialize(value.VAL.smartCardHeroBlock)
                ]);
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        smart_card_content = {
            __typename: value$12,
            value: value$11
        };
    } else {
        smart_card_content = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.language;
    var value$15 = value$13.codename;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        codename: value$15,
        language: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        smart_card_content: smart_card_content,
        retailer_card_content: retailer_card_content,
        end_of_page_content: end_of_page_content
    };
}
function Gql_StoreContent_Fragment_bs_verifyArgsAndParse(_StoreContentBlock, value) {
    return Gql_StoreContent_Fragment_bs_parse(value);
}
function Gql_StoreContent_Fragment_bs_verifyName(param) {}
var StoreContentBlock = {
    Raw: Gql_StoreContent_Fragment_bs_Raw,
    query: Gql_StoreContent_Fragment_bs_query,
    parse: Gql_StoreContent_Fragment_bs_parse,
    serialize: Gql_StoreContent_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_StoreContent_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_StoreContent_Fragment_bs_verifyName
};
var Gql_StoreContent_Fragment_bs_EnrichedTextBlock;
var Gql_StoreContent_Fragment_bs_SmartCardHeroBlock;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CategoryTiles/Gql__CategoryTiles__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CategoryTiles_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CategoryTileBlock on CategoryTileBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    tiles  {\n      __typename\n      value  {\n        __typename\n        ...on CategoryTileContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value\n          }\n          background_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          label_background_color  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_CategoryTiles_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_CategoryTiles_Fragment_bs_Raw = {};
var Gql_CategoryTiles_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_CategoryTiles_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_CategoryTiles_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.button;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.tiles;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "CategoryTileContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.url;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.background_asset;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$7) : undefined
                        };
                    }
                    var value$8 = value.label_background_color;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? value$9 : undefined
                        };
                    }
                    tmp = {
                        NAME: "CategoryTileContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            url: tmp$2,
                            background_asset: tmp$3,
                            label_background_color: tmp$4
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        button: tmp$1,
        tiles: tmp$2
    };
}
function Gql_CategoryTiles_Fragment_bs_serialize(value) {
    var value$1 = value.tiles;
    var tiles;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.label_background_color;
            var label_background_color;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                label_background_color = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                label_background_color = null;
            }
            var value$6 = value$1.background_asset;
            var background_asset;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$7) : null;
                var value$9 = value$6.__typename;
                background_asset = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                background_asset = null;
            }
            var value$10 = value$1.url;
            var url;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                url = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                url = null;
            }
            var value$14 = value$1.title;
            var title;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                title = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                title = null;
            }
            var value$18 = value$1.system;
            var value$19 = value$18.codename;
            var value$20 = value$18.id;
            var value$21 = value$18.__typename;
            var system = {
                __typename: value$21,
                id: value$20,
                codename: value$19
            };
            return {
                __typename: "CategoryTileContentType",
                system: system,
                title: title,
                url: url,
                background_asset: background_asset,
                label_background_color: label_background_color
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        tiles = {
            __typename: value$4,
            value: value$3
        };
    } else {
        tiles = null;
    }
    var value$5 = value.button;
    var button;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        button = {
            __typename: value$8,
            value: value$7
        };
    } else {
        button = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        button: button,
        tiles: tiles
    };
}
function Gql_CategoryTiles_Fragment_bs_verifyArgsAndParse(_CategoryTileBlock, value) {
    return Gql_CategoryTiles_Fragment_bs_parse(value);
}
function Gql_CategoryTiles_Fragment_bs_verifyName(param) {}
var CategoryTileBlock = {
    Raw: Gql_CategoryTiles_Fragment_bs_Raw,
    query: Gql_CategoryTiles_Fragment_bs_query,
    parse: Gql_CategoryTiles_Fragment_bs_parse,
    serialize: Gql_CategoryTiles_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_CategoryTiles_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_CategoryTiles_Fragment_bs_verifyName
};
var Gql_CategoryTiles_Fragment_bs_$$Image;
var Gql_CategoryTiles_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/IconCardBlock/Gql__IconCardBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_IconCardBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment IconCardBlock on IconCardBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    theme  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    icon_cards  {\n      __typename\n      value  {\n        __typename\n        ...on IconCardContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          description  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value\n          }\n          open_in_new_window  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          icon_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          icon_size  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n          title_colour  {\n            __typename\n            value\n          }\n          text_colour  {\n            __typename\n            value\n          }\n          background_colour  {\n            __typename\n            value\n          }\n          content_alignment  {\n            __typename\n            value  {\n              __typename\n              codename\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_IconCardBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_IconCardBlock_Fragment_bs_Raw = {};
var Gql_IconCardBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_IconCardBlock_Fragment_bs_templateObject());
function Gql_IconCardBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.theme;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.background_colour;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.title;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.description;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.icon_cards;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "IconCardContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.description;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.url;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.open_in_new_window;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$9) : undefined
                        };
                    }
                    var value$10 = value.icon_asset;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$11) : undefined
                        };
                    }
                    var value$12 = value.icon_size;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$13) : undefined
                        };
                    }
                    var value$14 = value.title_colour;
                    var tmp$7;
                    if (value$14 == null) {
                        tmp$7 = undefined;
                    } else {
                        var value$15 = value$14.value;
                        tmp$7 = {
                            __typename: value$14.__typename,
                            value: !(value$15 == null) ? value$15 : undefined
                        };
                    }
                    var value$16 = value.text_colour;
                    var tmp$8;
                    if (value$16 == null) {
                        tmp$8 = undefined;
                    } else {
                        var value$17 = value$16.value;
                        tmp$8 = {
                            __typename: value$16.__typename,
                            value: !(value$17 == null) ? value$17 : undefined
                        };
                    }
                    var value$18 = value.background_colour;
                    var tmp$9;
                    if (value$18 == null) {
                        tmp$9 = undefined;
                    } else {
                        var value$19 = value$18.value;
                        tmp$9 = {
                            __typename: value$18.__typename,
                            value: !(value$19 == null) ? value$19 : undefined
                        };
                    }
                    var value$20 = value.content_alignment;
                    var tmp$10;
                    if (value$20 == null) {
                        tmp$10 = undefined;
                    } else {
                        var value$21 = value$20.value;
                        tmp$10 = {
                            __typename: value$20.__typename,
                            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.codename;
                                return {
                                    __typename: value.__typename,
                                    codename: !(value$1 == null) ? value$1 : undefined
                                };
                            }, value$21) : undefined
                        };
                    }
                    tmp = {
                        NAME: "IconCardContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            description: tmp$2,
                            url: tmp$3,
                            open_in_new_window: tmp$4,
                            icon_asset: tmp$5,
                            icon_size: tmp$6,
                            title_colour: tmp$7,
                            text_colour: tmp$8,
                            background_colour: tmp$9,
                            content_alignment: tmp$10
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$11) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        theme: tmp,
        background_colour: tmp$1,
        title: tmp$2,
        description: tmp$3,
        icon_cards: tmp$4
    };
}
function Gql_IconCardBlock_Fragment_bs_serialize(value) {
    var value$1 = value.icon_cards;
    var icon_cards;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.content_alignment;
            var content_alignment;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                content_alignment = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                content_alignment = null;
            }
            var value$6 = value$1.background_colour;
            var background_colour;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                background_colour = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                background_colour = null;
            }
            var value$10 = value$1.text_colour;
            var text_colour;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                text_colour = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                text_colour = null;
            }
            var value$14 = value$1.title_colour;
            var title_colour;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                title_colour = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                title_colour = null;
            }
            var value$18 = value$1.icon_size;
            var icon_size;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$19) : null;
                var value$21 = value$18.__typename;
                icon_size = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                icon_size = null;
            }
            var value$22 = value$1.icon_asset;
            var icon_asset;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$23) : null;
                var value$25 = value$22.__typename;
                icon_asset = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                icon_asset = null;
            }
            var value$26 = value$1.open_in_new_window;
            var open_in_new_window;
            if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.codename;
                    var codename = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        codename: codename
                    };
                }, value$27) : null;
                var value$29 = value$26.__typename;
                open_in_new_window = {
                    __typename: value$29,
                    value: value$28
                };
            } else {
                open_in_new_window = null;
            }
            var value$30 = value$1.url;
            var url;
            if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? value$31 : null;
                var value$33 = value$30.__typename;
                url = {
                    __typename: value$33,
                    value: value$32
                };
            } else {
                url = null;
            }
            var value$34 = value$1.description;
            var description;
            if (value$34 !== undefined) {
                var value$35 = value$34.value;
                var value$36 = value$35 !== undefined ? value$35 : null;
                var value$37 = value$34.__typename;
                description = {
                    __typename: value$37,
                    value: value$36
                };
            } else {
                description = null;
            }
            var value$38 = value$1.title;
            var title;
            if (value$38 !== undefined) {
                var value$39 = value$38.value;
                var value$40 = value$39 !== undefined ? value$39 : null;
                var value$41 = value$38.__typename;
                title = {
                    __typename: value$41,
                    value: value$40
                };
            } else {
                title = null;
            }
            var value$42 = value$1.system;
            var value$43 = value$42.codename;
            var value$44 = value$42.id;
            var value$45 = value$42.__typename;
            var system = {
                __typename: value$45,
                id: value$44,
                codename: value$43
            };
            return {
                __typename: "IconCardContentType",
                system: system,
                title: title,
                description: description,
                url: url,
                open_in_new_window: open_in_new_window,
                icon_asset: icon_asset,
                icon_size: icon_size,
                title_colour: title_colour,
                text_colour: text_colour,
                background_colour: background_colour,
                content_alignment: content_alignment
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        icon_cards = {
            __typename: value$4,
            value: value$3
        };
    } else {
        icon_cards = null;
    }
    var value$5 = value.description;
    var description;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        description = {
            __typename: value$8,
            value: value$7
        };
    } else {
        description = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.background_colour;
    var background_colour;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        background_colour = {
            __typename: value$16,
            value: value$15
        };
    } else {
        background_colour = null;
    }
    var value$17 = value.theme;
    var theme;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        theme = {
            __typename: value$20,
            value: value$19
        };
    } else {
        theme = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        theme: theme,
        background_colour: background_colour,
        title: title,
        description: description,
        icon_cards: icon_cards
    };
}
function Gql_IconCardBlock_Fragment_bs_verifyArgsAndParse(_IconCardBlock, value) {
    return Gql_IconCardBlock_Fragment_bs_parse(value);
}
function Gql_IconCardBlock_Fragment_bs_verifyName(param) {}
var IconCardBlock = {
    Raw: Gql_IconCardBlock_Fragment_bs_Raw,
    query: Gql_IconCardBlock_Fragment_bs_query,
    parse: Gql_IconCardBlock_Fragment_bs_parse,
    serialize: Gql_IconCardBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_IconCardBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_IconCardBlock_Fragment_bs_verifyName
};
var Gql_IconCardBlock_Fragment_bs_Icon;
var FontAwesomeIcon;
var CardIcon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/FontAwesomeIcon/Gql__FontAwesomeIcon__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FontAwesomeIcon_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FontAwesomeIcon on FontAwesomeContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    font_awesome_icon_name  {\n      __typename\n      value\n    }\n    style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n  }\n"
    ]);
    Gql_FontAwesomeIcon_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_FontAwesomeIcon_Fragment_bs_Raw = {};
var Gql_FontAwesomeIcon_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_FontAwesomeIcon_Fragment_bs_templateObject());
function Gql_FontAwesomeIcon_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.font_awesome_icon_name;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.style;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        font_awesome_icon_name: tmp,
        style: tmp$1
    };
}
function Gql_FontAwesomeIcon_Fragment_bs_serialize(value) {
    var value$1 = value.style;
    var style;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        style = {
            __typename: value$4,
            value: value$3
        };
    } else {
        style = null;
    }
    var value$5 = value.font_awesome_icon_name;
    var font_awesome_icon_name;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        font_awesome_icon_name = {
            __typename: value$8,
            value: value$7
        };
    } else {
        font_awesome_icon_name = null;
    }
    var value$9 = value.system;
    var value$10 = value$9.codename;
    var value$11 = value$9.id;
    var value$12 = value$9.__typename;
    var system = {
        __typename: value$12,
        id: value$11,
        codename: value$10
    };
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        system: system,
        font_awesome_icon_name: font_awesome_icon_name,
        style: style
    };
}
function Gql_FontAwesomeIcon_Fragment_bs_verifyArgsAndParse(_FontAwesomeIcon, value) {
    return Gql_FontAwesomeIcon_Fragment_bs_parse(value);
}
function Gql_FontAwesomeIcon_Fragment_bs_verifyName(param) {}
var Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon = {
    Raw: Gql_FontAwesomeIcon_Fragment_bs_Raw,
    query: Gql_FontAwesomeIcon_Fragment_bs_query,
    parse: Gql_FontAwesomeIcon_Fragment_bs_parse,
    serialize: Gql_FontAwesomeIcon_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_FontAwesomeIcon_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_FontAwesomeIcon_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftExperience/Gql__GiftExperience__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_GiftExperience_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment GiftExperienceBlock on TheGiftExperienceContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    promo_image_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    buttons  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    list_items  {\n      __typename\n      value  {\n        __typename\n        ...on TheGiftExperienceListItemContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          description  {\n            __typename\n            value\n          }\n          fontawesome_icon  {\n            __typename\n            value  {\n              __typename\n              ...on FontAwesomeContentType   {\n                ...FontAwesomeIcon\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_GiftExperience_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_GiftExperience_Fragment_bs_Raw = {};
var Gql_GiftExperience_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_GiftExperience_Fragment_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.query);
function Gql_GiftExperience_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.promo_image_asset;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.buttons;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.list_items;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "TheGiftExperienceListItemContentType") {
                    var value$1 = value.system;
                    var value$2 = value.description;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.fontawesome_icon;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "FontAwesomeContentType" ? {
                                    NAME: "FontAwesomeContentType",
                                    VAL: {
                                        fontAwesomeIcon: Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.verifyArgsAndParse("FontAwesomeIcon", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$5) : undefined
                        };
                    }
                    tmp = {
                        NAME: "TheGiftExperienceListItemContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            description: tmp$1,
                            fontawesome_icon: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$9) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        promo_image_asset: tmp$1,
        buttons: tmp$2,
        list_items: tmp$3
    };
}
function Gql_GiftExperience_Fragment_bs_serialize(value) {
    var value$1 = value.list_items;
    var list_items;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.fontawesome_icon;
            var fontawesome_icon;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "FontAwesomeContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.serialize(value.VAL.fontAwesomeIcon)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$3) : null;
                var value$5 = value$2.__typename;
                fontawesome_icon = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                fontawesome_icon = null;
            }
            var value$6 = value$1.description;
            var description;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                description = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                description = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "TheGiftExperienceListItemContentType",
                system: system,
                description: description,
                fontawesome_icon: fontawesome_icon
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        list_items = {
            __typename: value$4,
            value: value$3
        };
    } else {
        list_items = null;
    }
    var value$5 = value.buttons;
    var buttons;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        buttons = {
            __typename: value$8,
            value: value$7
        };
    } else {
        buttons = null;
    }
    var value$9 = value.promo_image_asset;
    var promo_image_asset;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        promo_image_asset = {
            __typename: value$12,
            value: value$11
        };
    } else {
        promo_image_asset = null;
    }
    var value$13 = value.title;
    var title;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        title = {
            __typename: value$16,
            value: value$15
        };
    } else {
        title = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        title: title,
        promo_image_asset: promo_image_asset,
        buttons: buttons,
        list_items: list_items
    };
}
function Gql_GiftExperience_Fragment_bs_verifyArgsAndParse(_GiftExperienceBlock, value) {
    return Gql_GiftExperience_Fragment_bs_parse(value);
}
function Gql_GiftExperience_Fragment_bs_verifyName(param) {}
var GiftExperienceBlock = {
    Raw: Gql_GiftExperience_Fragment_bs_Raw,
    query: Gql_GiftExperience_Fragment_bs_query,
    parse: Gql_GiftExperience_Fragment_bs_parse,
    serialize: Gql_GiftExperience_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_GiftExperience_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_GiftExperience_Fragment_bs_verifyName
};
var Gql_GiftExperience_Fragment_bs_$$Image;
var Gql_GiftExperience_Fragment_bs_CallToAction;
var Gql_GiftExperience_Fragment_bs_FontAwesomeIcon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_VideoTextPromo_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment VideoTextPromoBlock on VideoTextPromoBoxContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    tagline  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    text_colour  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    featured_video  {\n      __typename\n      value  {\n        __typename\n        ...on VideoContentType   {\n          ...Video\n        }\n      }\n    }\n    featured_video_mobile  {\n      __typename\n      value  {\n        __typename\n        ...on VideoContentType   {\n          ...Video\n        }\n      }\n    }\n    loop_featured_video  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    feature_video_poster  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    background_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_VideoTextPromo_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_VideoTextPromo_Fragment_bs_Raw = {};
var Gql_VideoTextPromo_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_VideoTextPromo_Fragment_bs_templateObject(), frag_0, frag_1);
}($$Image.query, Video.query);
function Gql_VideoTextPromo_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.tagline;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.text_colour;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.featured_video;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "VideoContentType" ? {
                    NAME: "VideoContentType",
                    VAL: {
                        video: Video.verifyArgsAndParse("Video", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$11) : undefined
        };
    }
    var value$12 = value.featured_video_mobile;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "VideoContentType" ? {
                    NAME: "VideoContentType",
                    VAL: {
                        video: Video.verifyArgsAndParse("Video", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$13) : undefined
        };
    }
    var value$14 = value.loop_featured_video;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$15) : undefined
        };
    }
    var value$16 = value.feature_video_poster;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$17) : undefined
        };
    }
    var value$18 = value.background_colour;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.background_image;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$21) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        tagline: tmp$1,
        description: tmp$2,
        text_colour: tmp$3,
        featured_video: tmp$4,
        featured_video_mobile: tmp$5,
        loop_featured_video: tmp$6,
        feature_video_poster: tmp$7,
        background_colour: tmp$8,
        background_image: tmp$9
    };
}
function Gql_VideoTextPromo_Fragment_bs_serialize(value) {
    var value$1 = value.background_image;
    var background_image;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        background_image = {
            __typename: value$4,
            value: value$3
        };
    } else {
        background_image = null;
    }
    var value$5 = value.background_colour;
    var background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_colour = null;
    }
    var value$9 = value.feature_video_poster;
    var feature_video_poster;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        feature_video_poster = {
            __typename: value$12,
            value: value$11
        };
    } else {
        feature_video_poster = null;
    }
    var value$13 = value.loop_featured_video;
    var loop_featured_video;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        loop_featured_video = {
            __typename: value$16,
            value: value$15
        };
    } else {
        loop_featured_video = null;
    }
    var value$17 = value.featured_video_mobile;
    var featured_video_mobile;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "VideoContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        Video.serialize(value.VAL.video)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$18) : null;
        var value$20 = value$17.__typename;
        featured_video_mobile = {
            __typename: value$20,
            value: value$19
        };
    } else {
        featured_video_mobile = null;
    }
    var value$21 = value.featured_video;
    var featured_video;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "VideoContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        Video.serialize(value.VAL.video)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$22) : null;
        var value$24 = value$21.__typename;
        featured_video = {
            __typename: value$24,
            value: value$23
        };
    } else {
        featured_video = null;
    }
    var value$25 = value.text_colour;
    var text_colour;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$26) : null;
        var value$28 = value$25.__typename;
        text_colour = {
            __typename: value$28,
            value: value$27
        };
    } else {
        text_colour = null;
    }
    var value$29 = value.description;
    var description;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? value$30 : null;
        var value$32 = value$29.__typename;
        description = {
            __typename: value$32,
            value: value$31
        };
    } else {
        description = null;
    }
    var value$33 = value.tagline;
    var tagline;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        tagline = {
            __typename: value$36,
            value: value$35
        };
    } else {
        tagline = null;
    }
    var value$37 = value.title;
    var title;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? value$38 : null;
        var value$40 = value$37.__typename;
        title = {
            __typename: value$40,
            value: value$39
        };
    } else {
        title = null;
    }
    var value$41 = value.system;
    var value$42 = value$41.codename;
    var value$43 = value$41.id;
    var value$44 = value$41.__typename;
    var system = {
        __typename: value$44,
        id: value$43,
        codename: value$42
    };
    var value$45 = value.__typename;
    return {
        __typename: value$45,
        system: system,
        title: title,
        tagline: tagline,
        description: description,
        text_colour: text_colour,
        featured_video: featured_video,
        featured_video_mobile: featured_video_mobile,
        loop_featured_video: loop_featured_video,
        feature_video_poster: feature_video_poster,
        background_colour: background_colour,
        background_image: background_image
    };
}
function Gql_VideoTextPromo_Fragment_bs_verifyArgsAndParse(_VideoTextPromoBlock, value) {
    return Gql_VideoTextPromo_Fragment_bs_parse(value);
}
function Gql_VideoTextPromo_Fragment_bs_verifyName(param) {}
var VideoTextPromoBlock = {
    Raw: Gql_VideoTextPromo_Fragment_bs_Raw,
    query: Gql_VideoTextPromo_Fragment_bs_query,
    parse: Gql_VideoTextPromo_Fragment_bs_parse,
    serialize: Gql_VideoTextPromo_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_VideoTextPromo_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_VideoTextPromo_Fragment_bs_verifyName
};
var Gql_VideoTextPromo_Fragment_bs_$$Image;
var Gql_VideoTextPromo_Fragment_bs_Video;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NewsletterBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsletterBlock on EmailSignUpBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    text_colour  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    input_box_placeholder_text  {\n      __typename\n      value\n    }\n    success_message  {\n      __typename\n      value\n    }\n    background_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    background_image_tablet  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    background_image_mobile  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_NewsletterBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_NewsletterBlock_Fragment_bs_Raw = {};
var Gql_NewsletterBlock_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_NewsletterBlock_Fragment_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, $$Image.query);
function Gql_NewsletterBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.text_colour;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.input_box_placeholder_text;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.success_message;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.background_image;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$13) : undefined
        };
    }
    var value$14 = value.background_image_tablet;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$15) : undefined
        };
    }
    var value$16 = value.background_image_mobile;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$17) : undefined
        };
    }
    var value$18 = value.background_colour;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.button;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$21) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        text_colour: tmp$2,
        input_box_placeholder_text: tmp$3,
        success_message: tmp$4,
        background_image: tmp$5,
        background_image_tablet: tmp$6,
        background_image_mobile: tmp$7,
        background_colour: tmp$8,
        button: tmp$9
    };
}
function Gql_NewsletterBlock_Fragment_bs_serialize(value) {
    var value$1 = value.button;
    var button;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        button = {
            __typename: value$4,
            value: value$3
        };
    } else {
        button = null;
    }
    var value$5 = value.background_colour;
    var background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_colour = null;
    }
    var value$9 = value.background_image_mobile;
    var background_image_mobile;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        background_image_mobile = {
            __typename: value$12,
            value: value$11
        };
    } else {
        background_image_mobile = null;
    }
    var value$13 = value.background_image_tablet;
    var background_image_tablet;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$14) : null;
        var value$16 = value$13.__typename;
        background_image_tablet = {
            __typename: value$16,
            value: value$15
        };
    } else {
        background_image_tablet = null;
    }
    var value$17 = value.background_image;
    var background_image;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$18) : null;
        var value$20 = value$17.__typename;
        background_image = {
            __typename: value$20,
            value: value$19
        };
    } else {
        background_image = null;
    }
    var value$21 = value.success_message;
    var success_message;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        success_message = {
            __typename: value$24,
            value: value$23
        };
    } else {
        success_message = null;
    }
    var value$25 = value.input_box_placeholder_text;
    var input_box_placeholder_text;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        input_box_placeholder_text = {
            __typename: value$28,
            value: value$27
        };
    } else {
        input_box_placeholder_text = null;
    }
    var value$29 = value.text_colour;
    var text_colour;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        text_colour = {
            __typename: value$32,
            value: value$31
        };
    } else {
        text_colour = null;
    }
    var value$33 = value.description;
    var description;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        description = {
            __typename: value$36,
            value: value$35
        };
    } else {
        description = null;
    }
    var value$37 = value.title;
    var title;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? value$38 : null;
        var value$40 = value$37.__typename;
        title = {
            __typename: value$40,
            value: value$39
        };
    } else {
        title = null;
    }
    var value$41 = value.system;
    var value$42 = value$41.codename;
    var value$43 = value$41.id;
    var value$44 = value$41.__typename;
    var system = {
        __typename: value$44,
        id: value$43,
        codename: value$42
    };
    var value$45 = value.__typename;
    return {
        __typename: value$45,
        system: system,
        title: title,
        description: description,
        text_colour: text_colour,
        input_box_placeholder_text: input_box_placeholder_text,
        success_message: success_message,
        background_image: background_image,
        background_image_tablet: background_image_tablet,
        background_image_mobile: background_image_mobile,
        background_colour: background_colour,
        button: button
    };
}
function Gql_NewsletterBlock_Fragment_bs_verifyArgsAndParse(_NewsletterBlock, value) {
    return Gql_NewsletterBlock_Fragment_bs_parse(value);
}
function Gql_NewsletterBlock_Fragment_bs_verifyName(param) {}
var NewsletterBlock = {
    Raw: Gql_NewsletterBlock_Fragment_bs_Raw,
    query: Gql_NewsletterBlock_Fragment_bs_query,
    parse: Gql_NewsletterBlock_Fragment_bs_parse,
    serialize: Gql_NewsletterBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NewsletterBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NewsletterBlock_Fragment_bs_verifyName
};
var Gql_NewsletterBlock_Fragment_bs_$$Image;
var Gql_NewsletterBlock_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/AutomateSimplify/Gql__AutomateSimplify__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_AutomateSimplify_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AutomateSimplifyBlock on AutomateAndSimplifyContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    heading  {\n      __typename\n      value\n    }\n    body_text  {\n      __typename\n      value\n    }\n    cta_button_s  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_AutomateSimplify_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_AutomateSimplify_Fragment_bs_Raw = {};
var Gql_AutomateSimplify_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_AutomateSimplify_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_AutomateSimplify_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.heading;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.body_text;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.cta_button_s;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        heading: tmp,
        body_text: tmp$1,
        cta_button_s: tmp$2
    };
}
function Gql_AutomateSimplify_Fragment_bs_serialize(value) {
    var value$1 = value.cta_button_s;
    var cta_button_s;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        cta_button_s = {
            __typename: value$4,
            value: value$3
        };
    } else {
        cta_button_s = null;
    }
    var value$5 = value.body_text;
    var body_text;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        body_text = {
            __typename: value$8,
            value: value$7
        };
    } else {
        body_text = null;
    }
    var value$9 = value.heading;
    var heading;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        heading = {
            __typename: value$12,
            value: value$11
        };
    } else {
        heading = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        heading: heading,
        body_text: body_text,
        cta_button_s: cta_button_s
    };
}
function Gql_AutomateSimplify_Fragment_bs_verifyArgsAndParse(_AutomateSimplifyBlock, value) {
    return Gql_AutomateSimplify_Fragment_bs_parse(value);
}
function Gql_AutomateSimplify_Fragment_bs_verifyName(param) {}
var AutomateSimplifyBlock = {
    Raw: Gql_AutomateSimplify_Fragment_bs_Raw,
    query: Gql_AutomateSimplify_Fragment_bs_query,
    parse: Gql_AutomateSimplify_Fragment_bs_parse,
    serialize: Gql_AutomateSimplify_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_AutomateSimplify_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_AutomateSimplify_Fragment_bs_verifyName
};
var Gql_AutomateSimplify_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NarrowBannerFull/Gql__NarrowBannerFull__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NarrowBannerFull_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NarrowBannerFull on NarrowBannerFullContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    subtitle  {\n      __typename\n      value\n    }\n    alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    banner_colour  {\n      __typename\n      value\n    }\n    banner_height  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_NarrowBannerFull_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_NarrowBannerFull_Fragment_bs_Raw = {};
var Gql_NarrowBannerFull_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_NarrowBannerFull_Fragment_bs_templateObject());
function Gql_NarrowBannerFull_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.subtitle;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.alignment;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.banner_colour;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.banner_height;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        subtitle: tmp$1,
        alignment: tmp$2,
        banner_colour: tmp$3,
        banner_height: tmp$4
    };
}
function Gql_NarrowBannerFull_Fragment_bs_serialize(value) {
    var value$1 = value.banner_height;
    var banner_height;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        banner_height = {
            __typename: value$4,
            value: value$3
        };
    } else {
        banner_height = null;
    }
    var value$5 = value.banner_colour;
    var banner_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        banner_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        banner_colour = null;
    }
    var value$9 = value.alignment;
    var alignment;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        alignment = {
            __typename: value$12,
            value: value$11
        };
    } else {
        alignment = null;
    }
    var value$13 = value.subtitle;
    var subtitle;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        subtitle = {
            __typename: value$16,
            value: value$15
        };
    } else {
        subtitle = null;
    }
    var value$17 = value.title;
    var title;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        title = {
            __typename: value$20,
            value: value$19
        };
    } else {
        title = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        title: title,
        subtitle: subtitle,
        alignment: alignment,
        banner_colour: banner_colour,
        banner_height: banner_height
    };
}
function Gql_NarrowBannerFull_Fragment_bs_verifyArgsAndParse(_NarrowBannerFull, value) {
    return Gql_NarrowBannerFull_Fragment_bs_parse(value);
}
function Gql_NarrowBannerFull_Fragment_bs_verifyName(param) {}
var NarrowBannerFull = {
    Raw: Gql_NarrowBannerFull_Fragment_bs_Raw,
    query: Gql_NarrowBannerFull_Fragment_bs_query,
    parse: Gql_NarrowBannerFull_Fragment_bs_parse,
    serialize: Gql_NarrowBannerFull_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NarrowBannerFull_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NarrowBannerFull_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/ImageCollection/Gql__ImageCollection__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_ImageCollection_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ImageCollection on ImageCollectionContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    images  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n        ...on DeviceSizeImageContentType   {\n          ...DeviceSizeImage\n        }\n      }\n    }\n    display_per_row_desktop  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    display_per_row_tablet  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    display_per_row_mobile  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    gap_desktop  {\n      __typename\n      value\n    }\n    gap_tablet  {\n      __typename\n      value\n    }\n    gap_mobile  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_ImageCollection_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_ImageCollection_Fragment_bs_Raw = {};
var Gql_ImageCollection_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_ImageCollection_Fragment_bs_templateObject(), frag_0, frag_1);
}(DeviceSizeImage.query, $$Image.query);
function Gql_ImageCollection_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.images;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                switch(typename){
                    case "DeviceSizeImageContentType":
                        tmp = {
                            NAME: "DeviceSizeImageContentType",
                            VAL: {
                                deviceSizeImage: DeviceSizeImage.verifyArgsAndParse("DeviceSizeImage", value)
                            }
                        };
                        break;
                    case "ImageContentType":
                        tmp = {
                            NAME: "ImageContentType",
                            VAL: {
                                image: $$Image.verifyArgsAndParse("Image", value)
                            }
                        };
                        break;
                    default:
                        tmp = {
                            NAME: "UnspecifiedFragment",
                            VAL: typename
                        };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.display_per_row_desktop;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.display_per_row_tablet;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.display_per_row_mobile;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.gap_desktop;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.gap_tablet;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.gap_mobile;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        images: tmp$2,
        display_per_row_desktop: tmp$3,
        display_per_row_tablet: tmp$4,
        display_per_row_mobile: tmp$5,
        gap_desktop: tmp$6,
        gap_tablet: tmp$7,
        gap_mobile: tmp$8
    };
}
function Gql_ImageCollection_Fragment_bs_serialize(value) {
    var value$1 = value.gap_mobile;
    var gap_mobile;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        gap_mobile = {
            __typename: value$4,
            value: value$3
        };
    } else {
        gap_mobile = null;
    }
    var value$5 = value.gap_tablet;
    var gap_tablet;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        gap_tablet = {
            __typename: value$8,
            value: value$7
        };
    } else {
        gap_tablet = null;
    }
    var value$9 = value.gap_desktop;
    var gap_desktop;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        gap_desktop = {
            __typename: value$12,
            value: value$11
        };
    } else {
        gap_desktop = null;
    }
    var value$13 = value.display_per_row_mobile;
    var display_per_row_mobile;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        display_per_row_mobile = {
            __typename: value$16,
            value: value$15
        };
    } else {
        display_per_row_mobile = null;
    }
    var value$17 = value.display_per_row_tablet;
    var display_per_row_tablet;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        display_per_row_tablet = {
            __typename: value$20,
            value: value$19
        };
    } else {
        display_per_row_tablet = null;
    }
    var value$21 = value.display_per_row_desktop;
    var display_per_row_desktop;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$22) : null;
        var value$24 = value$21.__typename;
        display_per_row_desktop = {
            __typename: value$24,
            value: value$23
        };
    } else {
        display_per_row_desktop = null;
    }
    var value$25 = value.images;
    var images;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var variant = value.NAME;
            if (variant === "UnspecifiedFragment") {
                return {};
            } else if (variant === "DeviceSizeImageContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    DeviceSizeImage.serialize(value.VAL.deviceSizeImage)
                ]);
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    $$Image.serialize(value.VAL.image)
                ]);
            }
        }, value$26) : null;
        var value$28 = value$25.__typename;
        images = {
            __typename: value$28,
            value: value$27
        };
    } else {
        images = null;
    }
    var value$29 = value.description;
    var description;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? value$30 : null;
        var value$32 = value$29.__typename;
        description = {
            __typename: value$32,
            value: value$31
        };
    } else {
        description = null;
    }
    var value$33 = value.title;
    var title;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        title = {
            __typename: value$36,
            value: value$35
        };
    } else {
        title = null;
    }
    var value$37 = value.system;
    var value$38 = value$37.codename;
    var value$39 = value$37.id;
    var value$40 = value$37.__typename;
    var system = {
        __typename: value$40,
        id: value$39,
        codename: value$38
    };
    var value$41 = value.__typename;
    return {
        __typename: value$41,
        system: system,
        title: title,
        description: description,
        images: images,
        display_per_row_desktop: display_per_row_desktop,
        display_per_row_tablet: display_per_row_tablet,
        display_per_row_mobile: display_per_row_mobile,
        gap_desktop: gap_desktop,
        gap_tablet: gap_tablet,
        gap_mobile: gap_mobile
    };
}
function Gql_ImageCollection_Fragment_bs_verifyArgsAndParse(_ImageCollection, value) {
    return Gql_ImageCollection_Fragment_bs_parse(value);
}
function Gql_ImageCollection_Fragment_bs_verifyName(param) {}
var ImageCollection = {
    Raw: Gql_ImageCollection_Fragment_bs_Raw,
    query: Gql_ImageCollection_Fragment_bs_query,
    parse: Gql_ImageCollection_Fragment_bs_parse,
    serialize: Gql_ImageCollection_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_ImageCollection_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_ImageCollection_Fragment_bs_verifyName
};
var Gql_ImageCollection_Fragment_bs_$$Image;
var Gql_ImageCollection_Fragment_bs_DeviceSizeImage;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/OffsetTilesBlock/Gql__OffsetTilesBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_OffsetTilesBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment OffsetTilesBlock on OffsetTilesBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    tiles  {\n      __typename\n      value  {\n        __typename\n        ...on ImageCollectionContentType   {\n          ...ImageCollection\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_OffsetTilesBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_OffsetTilesBlock_Fragment_bs_Raw = {};
var Gql_OffsetTilesBlock_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_OffsetTilesBlock_Fragment_bs_templateObject(), frag_0);
}(ImageCollection.query);
function Gql_OffsetTilesBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.background_colour;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.tiles;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageCollectionContentType" ? {
                    NAME: "ImageCollectionContentType",
                    VAL: {
                        imageCollection: ImageCollection.verifyArgsAndParse("ImageCollection", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        background_colour: tmp$1,
        tiles: tmp$2
    };
}
function Gql_OffsetTilesBlock_Fragment_bs_serialize(value) {
    var value$1 = value.tiles;
    var tiles;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "ImageCollectionContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        ImageCollection.serialize(value.VAL.imageCollection)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        tiles = {
            __typename: value$4,
            value: value$3
        };
    } else {
        tiles = null;
    }
    var value$5 = value.background_colour;
    var background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_colour = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        background_colour: background_colour,
        tiles: tiles
    };
}
function Gql_OffsetTilesBlock_Fragment_bs_verifyArgsAndParse(_OffsetTilesBlock, value) {
    return Gql_OffsetTilesBlock_Fragment_bs_parse(value);
}
function Gql_OffsetTilesBlock_Fragment_bs_verifyName(param) {}
var OffsetTilesBlock = {
    Raw: Gql_OffsetTilesBlock_Fragment_bs_Raw,
    query: Gql_OffsetTilesBlock_Fragment_bs_query,
    parse: Gql_OffsetTilesBlock_Fragment_bs_parse,
    serialize: Gql_OffsetTilesBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_OffsetTilesBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_OffsetTilesBlock_Fragment_bs_verifyName
};
var Gql_OffsetTilesBlock_Fragment_bs_ImageCollection;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/ProductHeroIcon/Gql__ProductHeroIcon__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_ProductHeroIcon_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductHeroIcon on ProductHeroIconContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    icon  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    text  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_ProductHeroIcon_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_ProductHeroIcon_Fragment_bs_Raw = {};
var Gql_ProductHeroIcon_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_ProductHeroIcon_Fragment_bs_templateObject());
function Gql_ProductHeroIcon_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.icon;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.text;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        icon: tmp,
        text: tmp$1
    };
}
function Gql_ProductHeroIcon_Fragment_bs_serialize(value) {
    var value$1 = value.text;
    var text;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        text = {
            __typename: value$4,
            value: value$3
        };
    } else {
        text = null;
    }
    var value$5 = value.icon;
    var icon;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        icon = {
            __typename: value$8,
            value: value$7
        };
    } else {
        icon = null;
    }
    var value$9 = value.system;
    var value$10 = value$9.codename;
    var value$11 = value$9.id;
    var value$12 = value$9.__typename;
    var system = {
        __typename: value$12,
        id: value$11,
        codename: value$10
    };
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        system: system,
        icon: icon,
        text: text
    };
}
function Gql_ProductHeroIcon_Fragment_bs_verifyArgsAndParse(_ProductHeroIcon, value) {
    return Gql_ProductHeroIcon_Fragment_bs_parse(value);
}
function Gql_ProductHeroIcon_Fragment_bs_verifyName(param) {}
var ProductHeroIcon = {
    Raw: Gql_ProductHeroIcon_Fragment_bs_Raw,
    query: Gql_ProductHeroIcon_Fragment_bs_query,
    parse: Gql_ProductHeroIcon_Fragment_bs_parse,
    serialize: Gql_ProductHeroIcon_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_ProductHeroIcon_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_ProductHeroIcon_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/ProductHeroBlock/Gql__ProductHeroBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_ProductHeroBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductHeroBlock on ProductHeroBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    subtitle  {\n      __typename\n      value\n    }\n    enhanced_description  {\n      __typename\n      value\n    }\n    icons  {\n      __typename\n      value  {\n        __typename\n        ...on ProductHeroIconContentType   {\n          ...ProductHeroIcon\n        }\n      }\n    }\n    image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    primary_button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    secondary_button  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    product_slug  {\n      __typename\n      value\n    }\n    additional_description  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_ProductHeroBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_ProductHeroBlock_Fragment_bs_Raw = {};
var Gql_ProductHeroBlock_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_ProductHeroBlock_Fragment_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, ProductHeroIcon.query);
function Gql_ProductHeroBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.subtitle;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.enhanced_description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.icons;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ProductHeroIconContentType" ? {
                    NAME: "ProductHeroIconContentType",
                    VAL: {
                        productHeroIcon: ProductHeroIcon.verifyArgsAndParse("ProductHeroIcon", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.image;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.primary_button;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$13) : undefined
        };
    }
    var value$14 = value.secondary_button;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$15) : undefined
        };
    }
    var value$16 = value.product_slug;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.additional_description;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        subtitle: tmp$1,
        enhanced_description: tmp$2,
        icons: tmp$3,
        image: tmp$4,
        primary_button: tmp$5,
        secondary_button: tmp$6,
        product_slug: tmp$7,
        additional_description: tmp$8
    };
}
function Gql_ProductHeroBlock_Fragment_bs_serialize(value) {
    var value$1 = value.additional_description;
    var additional_description;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        additional_description = {
            __typename: value$4,
            value: value$3
        };
    } else {
        additional_description = null;
    }
    var value$5 = value.product_slug;
    var product_slug;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        product_slug = {
            __typename: value$8,
            value: value$7
        };
    } else {
        product_slug = null;
    }
    var value$9 = value.secondary_button;
    var secondary_button;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        secondary_button = {
            __typename: value$12,
            value: value$11
        };
    } else {
        secondary_button = null;
    }
    var value$13 = value.primary_button;
    var primary_button;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$14) : null;
        var value$16 = value$13.__typename;
        primary_button = {
            __typename: value$16,
            value: value$15
        };
    } else {
        primary_button = null;
    }
    var value$17 = value.image;
    var image;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        image = {
            __typename: value$20,
            value: value$19
        };
    } else {
        image = null;
    }
    var value$21 = value.icons;
    var icons;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        ProductHeroIcon.serialize(value.VAL.productHeroIcon)
                    ]);
                }
            } else {
                return null;
            }
        }, value$22) : null;
        var value$24 = value$21.__typename;
        icons = {
            __typename: value$24,
            value: value$23
        };
    } else {
        icons = null;
    }
    var value$25 = value.enhanced_description;
    var enhanced_description;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        enhanced_description = {
            __typename: value$28,
            value: value$27
        };
    } else {
        enhanced_description = null;
    }
    var value$29 = value.subtitle;
    var subtitle;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? value$30 : null;
        var value$32 = value$29.__typename;
        subtitle = {
            __typename: value$32,
            value: value$31
        };
    } else {
        subtitle = null;
    }
    var value$33 = value.title;
    var title;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        title = {
            __typename: value$36,
            value: value$35
        };
    } else {
        title = null;
    }
    var value$37 = value.system;
    var value$38 = value$37.codename;
    var value$39 = value$37.id;
    var value$40 = value$37.__typename;
    var system = {
        __typename: value$40,
        id: value$39,
        codename: value$38
    };
    var value$41 = value.__typename;
    return {
        __typename: value$41,
        system: system,
        title: title,
        subtitle: subtitle,
        enhanced_description: enhanced_description,
        icons: icons,
        image: image,
        primary_button: primary_button,
        secondary_button: secondary_button,
        product_slug: product_slug,
        additional_description: additional_description
    };
}
function Gql_ProductHeroBlock_Fragment_bs_verifyArgsAndParse(_ProductHeroBlock, value) {
    return Gql_ProductHeroBlock_Fragment_bs_parse(value);
}
function Gql_ProductHeroBlock_Fragment_bs_verifyName(param) {}
var ProductHeroBlock = {
    Raw: Gql_ProductHeroBlock_Fragment_bs_Raw,
    query: Gql_ProductHeroBlock_Fragment_bs_query,
    parse: Gql_ProductHeroBlock_Fragment_bs_parse,
    serialize: Gql_ProductHeroBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_ProductHeroBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_ProductHeroBlock_Fragment_bs_verifyName
};
var Gql_ProductHeroBlock_Fragment_bs_CallToAction;
var Gql_ProductHeroBlock_Fragment_bs_ProductHeroIcon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/TeamMembersBlock/Gql__TeamMembersBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TeamMembersBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TeamMembersBlock on TeamMembersBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    cards_per_row  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    team_member_cards  {\n      __typename\n      value  {\n        __typename\n        ...on TeamMemberCardContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          photo_front_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          photo_back_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          name  {\n            __typename\n            value\n          }\n          title  {\n            __typename\n            value\n          }\n          description  {\n            __typename\n            value\n          }\n          link  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_TeamMembersBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_TeamMembersBlock_Fragment_bs_Raw = {};
var Gql_TeamMembersBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_TeamMembersBlock_Fragment_bs_templateObject());
function Gql_TeamMembersBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.cards_per_row;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.team_member_cards;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "TeamMemberCardContentType") {
                    var value$1 = value.system;
                    var value$2 = value.photo_front_asset;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$3) : undefined
                        };
                    }
                    var value$4 = value.photo_back_asset;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$5) : undefined
                        };
                    }
                    var value$6 = value.name;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.title;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? value$9 : undefined
                        };
                    }
                    var value$10 = value.description;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? value$11 : undefined
                        };
                    }
                    var value$12 = value.link;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? value$13 : undefined
                        };
                    }
                    tmp = {
                        NAME: "TeamMemberCardContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            photo_front_asset: tmp$1,
                            photo_back_asset: tmp$2,
                            name: tmp$3,
                            title: tmp$4,
                            description: tmp$5,
                            link: tmp$6
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        cards_per_row: tmp$1,
        team_member_cards: tmp$2
    };
}
function Gql_TeamMembersBlock_Fragment_bs_serialize(value) {
    var value$1 = value.team_member_cards;
    var team_member_cards;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.link;
            var link;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                link = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                link = null;
            }
            var value$6 = value$1.description;
            var description;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                description = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                description = null;
            }
            var value$10 = value$1.title;
            var title;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                title = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                title = null;
            }
            var value$14 = value$1.name;
            var name;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                name = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                name = null;
            }
            var value$18 = value$1.photo_back_asset;
            var photo_back_asset;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$19) : null;
                var value$21 = value$18.__typename;
                photo_back_asset = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                photo_back_asset = null;
            }
            var value$22 = value$1.photo_front_asset;
            var photo_front_asset;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$23) : null;
                var value$25 = value$22.__typename;
                photo_front_asset = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                photo_front_asset = null;
            }
            var value$26 = value$1.system;
            var value$27 = value$26.codename;
            var value$28 = value$26.id;
            var value$29 = value$26.__typename;
            var system = {
                __typename: value$29,
                id: value$28,
                codename: value$27
            };
            return {
                __typename: "TeamMemberCardContentType",
                system: system,
                photo_front_asset: photo_front_asset,
                photo_back_asset: photo_back_asset,
                name: name,
                title: title,
                description: description,
                link: link
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        team_member_cards = {
            __typename: value$4,
            value: value$3
        };
    } else {
        team_member_cards = null;
    }
    var value$5 = value.cards_per_row;
    var cards_per_row;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        cards_per_row = {
            __typename: value$8,
            value: value$7
        };
    } else {
        cards_per_row = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        cards_per_row: cards_per_row,
        team_member_cards: team_member_cards
    };
}
function Gql_TeamMembersBlock_Fragment_bs_verifyArgsAndParse(_TeamMembersBlock, value) {
    return Gql_TeamMembersBlock_Fragment_bs_parse(value);
}
function Gql_TeamMembersBlock_Fragment_bs_verifyName(param) {}
var TeamMembersBlock = {
    Raw: Gql_TeamMembersBlock_Fragment_bs_Raw,
    query: Gql_TeamMembersBlock_Fragment_bs_query,
    parse: Gql_TeamMembersBlock_Fragment_bs_parse,
    serialize: Gql_TeamMembersBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_TeamMembersBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_TeamMembersBlock_Fragment_bs_verifyName
};
var Gql_TeamMembersBlock_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/DownloadAppsBlock/Gql__DownloadAppsBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_DownloadAppsBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AppDownloadBlock on AppDownloadBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    selling_points  {\n      __typename\n      value  {\n        __typename\n        ...on UniqueSellingPointContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          icon_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n        }\n      }\n    }\n    app_stores  {\n      __typename\n      value  {\n        __typename\n        ...on AppStoreItemContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          app_store_name  {\n            __typename\n            value\n          }\n          app_store_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          app_store_download_link  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n    background_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    mobile_background_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_DownloadAppsBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_DownloadAppsBlock_Fragment_bs_Raw = {};
var Gql_DownloadAppsBlock_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_DownloadAppsBlock_Fragment_bs_templateObject(), frag_0);
}($$Image.query);
function Gql_DownloadAppsBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.selling_points;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "UniqueSellingPointContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.icon_asset;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$5) : undefined
                        };
                    }
                    tmp = {
                        NAME: "UniqueSellingPointContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            icon_asset: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.app_stores;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "AppStoreItemContentType") {
                    var value$1 = value.system;
                    var value$2 = value.app_store_name;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.app_store_asset;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$5) : undefined
                        };
                    }
                    var value$6 = value.app_store_download_link;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    tmp = {
                        NAME: "AppStoreItemContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            app_store_name: tmp$1,
                            app_store_asset: tmp$2,
                            app_store_download_link: tmp$3
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.background_image;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$11) : undefined
        };
    }
    var value$12 = value.mobile_background_image;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$13) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        selling_points: tmp$2,
        app_stores: tmp$3,
        background_image: tmp$4,
        mobile_background_image: tmp$5
    };
}
function Gql_DownloadAppsBlock_Fragment_bs_serialize(value) {
    var value$1 = value.mobile_background_image;
    var mobile_background_image;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        mobile_background_image = {
            __typename: value$4,
            value: value$3
        };
    } else {
        mobile_background_image = null;
    }
    var value$5 = value.background_image;
    var background_image;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        background_image = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_image = null;
    }
    var value$9 = value.app_stores;
    var app_stores;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.app_store_download_link;
            var app_store_download_link;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                app_store_download_link = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                app_store_download_link = null;
            }
            var value$6 = value$1.app_store_asset;
            var app_store_asset;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$7) : null;
                var value$9 = value$6.__typename;
                app_store_asset = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                app_store_asset = null;
            }
            var value$10 = value$1.app_store_name;
            var app_store_name;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                app_store_name = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                app_store_name = null;
            }
            var value$14 = value$1.system;
            var value$15 = value$14.codename;
            var value$16 = value$14.id;
            var value$17 = value$14.__typename;
            var system = {
                __typename: value$17,
                id: value$16,
                codename: value$15
            };
            return {
                __typename: "AppStoreItemContentType",
                system: system,
                app_store_name: app_store_name,
                app_store_asset: app_store_asset,
                app_store_download_link: app_store_download_link
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        app_stores = {
            __typename: value$12,
            value: value$11
        };
    } else {
        app_stores = null;
    }
    var value$13 = value.selling_points;
    var selling_points;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.icon_asset;
            var icon_asset;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                icon_asset = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                icon_asset = null;
            }
            var value$6 = value$1.title;
            var title;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                title = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                title = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "UniqueSellingPointContentType",
                system: system,
                title: title,
                icon_asset: icon_asset
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        selling_points = {
            __typename: value$16,
            value: value$15
        };
    } else {
        selling_points = null;
    }
    var value$17 = value.description;
    var description;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        description = {
            __typename: value$20,
            value: value$19
        };
    } else {
        description = null;
    }
    var value$21 = value.title;
    var title;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        title = {
            __typename: value$24,
            value: value$23
        };
    } else {
        title = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        title: title,
        description: description,
        selling_points: selling_points,
        app_stores: app_stores,
        background_image: background_image,
        mobile_background_image: mobile_background_image
    };
}
function Gql_DownloadAppsBlock_Fragment_bs_verifyArgsAndParse(_AppDownloadBlock, value) {
    return Gql_DownloadAppsBlock_Fragment_bs_parse(value);
}
function Gql_DownloadAppsBlock_Fragment_bs_verifyName(param) {}
var AppDownloadBlock = {
    Raw: Gql_DownloadAppsBlock_Fragment_bs_Raw,
    query: Gql_DownloadAppsBlock_Fragment_bs_query,
    parse: Gql_DownloadAppsBlock_Fragment_bs_parse,
    serialize: Gql_DownloadAppsBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_DownloadAppsBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_DownloadAppsBlock_Fragment_bs_verifyName
};
var Gql_DownloadAppsBlock_Fragment_bs_$$Image;
var Gql_DownloadAppsBlock_Fragment_bs_Icon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CustomerCareBanner/Gql__CustomerCareBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CustomerCareBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CustomerCareBannerBlock on CustomerCareBannerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    text  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    banner_asset_desktop  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    banner_asset_tablet  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    banner_asset_mobile  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    address  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_CustomerCareBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_CustomerCareBanner_Fragment_bs_Raw = {};
var Gql_CustomerCareBanner_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_CustomerCareBanner_Fragment_bs_templateObject());
function Gql_CustomerCareBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.text;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.background_colour;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.banner_asset_desktop;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.banner_asset_tablet;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.banner_asset_mobile;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.address;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        text: tmp$1,
        background_colour: tmp$2,
        banner_asset_desktop: tmp$3,
        banner_asset_tablet: tmp$4,
        banner_asset_mobile: tmp$5,
        address: tmp$6
    };
}
function Gql_CustomerCareBanner_Fragment_bs_serialize(value) {
    var value$1 = value.address;
    var address;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        address = {
            __typename: value$4,
            value: value$3
        };
    } else {
        address = null;
    }
    var value$5 = value.banner_asset_mobile;
    var banner_asset_mobile;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        banner_asset_mobile = {
            __typename: value$8,
            value: value$7
        };
    } else {
        banner_asset_mobile = null;
    }
    var value$9 = value.banner_asset_tablet;
    var banner_asset_tablet;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        banner_asset_tablet = {
            __typename: value$12,
            value: value$11
        };
    } else {
        banner_asset_tablet = null;
    }
    var value$13 = value.banner_asset_desktop;
    var banner_asset_desktop;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        banner_asset_desktop = {
            __typename: value$16,
            value: value$15
        };
    } else {
        banner_asset_desktop = null;
    }
    var value$17 = value.background_colour;
    var background_colour;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        background_colour = {
            __typename: value$20,
            value: value$19
        };
    } else {
        background_colour = null;
    }
    var value$21 = value.text;
    var text;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        text = {
            __typename: value$24,
            value: value$23
        };
    } else {
        text = null;
    }
    var value$25 = value.title;
    var title;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        title = {
            __typename: value$28,
            value: value$27
        };
    } else {
        title = null;
    }
    var value$29 = value.system;
    var value$30 = value$29.codename;
    var value$31 = value$29.id;
    var value$32 = value$29.__typename;
    var system = {
        __typename: value$32,
        id: value$31,
        codename: value$30
    };
    var value$33 = value.__typename;
    return {
        __typename: value$33,
        system: system,
        title: title,
        text: text,
        background_colour: background_colour,
        banner_asset_desktop: banner_asset_desktop,
        banner_asset_tablet: banner_asset_tablet,
        banner_asset_mobile: banner_asset_mobile,
        address: address
    };
}
function Gql_CustomerCareBanner_Fragment_bs_verifyArgsAndParse(_CustomerCareBannerBlock, value) {
    return Gql_CustomerCareBanner_Fragment_bs_parse(value);
}
function Gql_CustomerCareBanner_Fragment_bs_verifyName(param) {}
var CustomerCareBannerBlock = {
    Raw: Gql_CustomerCareBanner_Fragment_bs_Raw,
    query: Gql_CustomerCareBanner_Fragment_bs_query,
    parse: Gql_CustomerCareBanner_Fragment_bs_parse,
    serialize: Gql_CustomerCareBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_CustomerCareBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_CustomerCareBanner_Fragment_bs_verifyName
};
var Gql_CustomerCareBanner_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CustomerCareCallUs/Gql__CustomerCareCallUs__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CustomerCareCallUs_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CustomerCareCallUsBlock on CustomerCareCallUsContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    pre_title  {\n      __typename\n      value\n    }\n    title  {\n      __typename\n      value\n    }\n    text  {\n      __typename\n      value\n    }\n    subtext  {\n      __typename\n      value\n    }\n    phone_contact_method_icon_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    form_contact_method_icon_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    local_phone_number  {\n      __typename\n      value\n    }\n    form_contact_method_label  {\n      __typename\n      value\n    }\n    form_contact_method_url  {\n      __typename\n      value\n    }\n    international_phone_number_text  {\n      __typename\n      value\n    }\n    international_phone_number  {\n      __typename\n      value\n    }\n    location_phone_numbers  {\n      __typename\n      value  {\n        __typename\n        ...on LocationPhoneNumbersContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          location  {\n            __typename\n            value\n          }\n          phone_number  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n    location_addresses  {\n      __typename\n      value  {\n        __typename\n        ...on AddressEntryContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          address_block  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_CustomerCareCallUs_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_CustomerCareCallUs_Fragment_bs_Raw = {};
var Gql_CustomerCareCallUs_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_CustomerCareCallUs_Fragment_bs_templateObject());
function Gql_CustomerCareCallUs_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.pre_title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.title;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.text;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.subtext;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.phone_contact_method_icon_asset;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.form_contact_method_icon_asset;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.local_phone_number;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.form_contact_method_label;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.form_contact_method_url;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.international_phone_number_text;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? value$21 : undefined
        };
    }
    var value$22 = value.international_phone_number;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? value$23 : undefined
        };
    }
    var value$24 = value.location_phone_numbers;
    var tmp$11;
    if (value$24 == null) {
        tmp$11 = undefined;
    } else {
        var value$25 = value$24.value;
        tmp$11 = {
            __typename: value$24.__typename,
            value: !(value$25 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "LocationPhoneNumbersContentType") {
                    var value$1 = value.system;
                    var value$2 = value.location;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.phone_number;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    tmp = {
                        NAME: "LocationPhoneNumbersContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            location: tmp$1,
                            phone_number: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$25) : undefined
        };
    }
    var value$26 = value.location_addresses;
    var tmp$12;
    if (value$26 == null) {
        tmp$12 = undefined;
    } else {
        var value$27 = value$26.value;
        tmp$12 = {
            __typename: value$26.__typename,
            value: !(value$27 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "AddressEntryContentType") {
                    var value$1 = value.system;
                    var value$2 = value.address_block;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    tmp = {
                        NAME: "AddressEntryContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            address_block: tmp$1
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$27) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        pre_title: tmp,
        title: tmp$1,
        text: tmp$2,
        subtext: tmp$3,
        phone_contact_method_icon_asset: tmp$4,
        form_contact_method_icon_asset: tmp$5,
        local_phone_number: tmp$6,
        form_contact_method_label: tmp$7,
        form_contact_method_url: tmp$8,
        international_phone_number_text: tmp$9,
        international_phone_number: tmp$10,
        location_phone_numbers: tmp$11,
        location_addresses: tmp$12
    };
}
function Gql_CustomerCareCallUs_Fragment_bs_serialize(value) {
    var value$1 = value.location_addresses;
    var location_addresses;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.address_block;
            var address_block;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                address_block = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                address_block = null;
            }
            var value$6 = value$1.system;
            var value$7 = value$6.codename;
            var value$8 = value$6.id;
            var value$9 = value$6.__typename;
            var system = {
                __typename: value$9,
                id: value$8,
                codename: value$7
            };
            return {
                __typename: "AddressEntryContentType",
                system: system,
                address_block: address_block
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        location_addresses = {
            __typename: value$4,
            value: value$3
        };
    } else {
        location_addresses = null;
    }
    var value$5 = value.location_phone_numbers;
    var location_phone_numbers;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.phone_number;
            var phone_number;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                phone_number = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                phone_number = null;
            }
            var value$6 = value$1.location;
            var $$location;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                $$location = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                $$location = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "LocationPhoneNumbersContentType",
                system: system,
                location: $$location,
                phone_number: phone_number
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        location_phone_numbers = {
            __typename: value$8,
            value: value$7
        };
    } else {
        location_phone_numbers = null;
    }
    var value$9 = value.international_phone_number;
    var international_phone_number;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        international_phone_number = {
            __typename: value$12,
            value: value$11
        };
    } else {
        international_phone_number = null;
    }
    var value$13 = value.international_phone_number_text;
    var international_phone_number_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        international_phone_number_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        international_phone_number_text = null;
    }
    var value$17 = value.form_contact_method_url;
    var form_contact_method_url;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        form_contact_method_url = {
            __typename: value$20,
            value: value$19
        };
    } else {
        form_contact_method_url = null;
    }
    var value$21 = value.form_contact_method_label;
    var form_contact_method_label;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        form_contact_method_label = {
            __typename: value$24,
            value: value$23
        };
    } else {
        form_contact_method_label = null;
    }
    var value$25 = value.local_phone_number;
    var local_phone_number;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        local_phone_number = {
            __typename: value$28,
            value: value$27
        };
    } else {
        local_phone_number = null;
    }
    var value$29 = value.form_contact_method_icon_asset;
    var form_contact_method_icon_asset;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        form_contact_method_icon_asset = {
            __typename: value$32,
            value: value$31
        };
    } else {
        form_contact_method_icon_asset = null;
    }
    var value$33 = value.phone_contact_method_icon_asset;
    var phone_contact_method_icon_asset;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$34) : null;
        var value$36 = value$33.__typename;
        phone_contact_method_icon_asset = {
            __typename: value$36,
            value: value$35
        };
    } else {
        phone_contact_method_icon_asset = null;
    }
    var value$37 = value.subtext;
    var subtext;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? value$38 : null;
        var value$40 = value$37.__typename;
        subtext = {
            __typename: value$40,
            value: value$39
        };
    } else {
        subtext = null;
    }
    var value$41 = value.text;
    var text;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? value$42 : null;
        var value$44 = value$41.__typename;
        text = {
            __typename: value$44,
            value: value$43
        };
    } else {
        text = null;
    }
    var value$45 = value.title;
    var title;
    if (value$45 !== undefined) {
        var value$46 = value$45.value;
        var value$47 = value$46 !== undefined ? value$46 : null;
        var value$48 = value$45.__typename;
        title = {
            __typename: value$48,
            value: value$47
        };
    } else {
        title = null;
    }
    var value$49 = value.pre_title;
    var pre_title;
    if (value$49 !== undefined) {
        var value$50 = value$49.value;
        var value$51 = value$50 !== undefined ? value$50 : null;
        var value$52 = value$49.__typename;
        pre_title = {
            __typename: value$52,
            value: value$51
        };
    } else {
        pre_title = null;
    }
    var value$53 = value.system;
    var value$54 = value$53.codename;
    var value$55 = value$53.id;
    var value$56 = value$53.__typename;
    var system = {
        __typename: value$56,
        id: value$55,
        codename: value$54
    };
    var value$57 = value.__typename;
    return {
        __typename: value$57,
        system: system,
        pre_title: pre_title,
        title: title,
        text: text,
        subtext: subtext,
        phone_contact_method_icon_asset: phone_contact_method_icon_asset,
        form_contact_method_icon_asset: form_contact_method_icon_asset,
        local_phone_number: local_phone_number,
        form_contact_method_label: form_contact_method_label,
        form_contact_method_url: form_contact_method_url,
        international_phone_number_text: international_phone_number_text,
        international_phone_number: international_phone_number,
        location_phone_numbers: location_phone_numbers,
        location_addresses: location_addresses
    };
}
function Gql_CustomerCareCallUs_Fragment_bs_verifyArgsAndParse(_CustomerCareCallUsBlock, value) {
    return Gql_CustomerCareCallUs_Fragment_bs_parse(value);
}
function Gql_CustomerCareCallUs_Fragment_bs_verifyName(param) {}
var CustomerCareCallUsBlock = {
    Raw: Gql_CustomerCareCallUs_Fragment_bs_Raw,
    query: Gql_CustomerCareCallUs_Fragment_bs_query,
    parse: Gql_CustomerCareCallUs_Fragment_bs_parse,
    serialize: Gql_CustomerCareCallUs_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_CustomerCareCallUs_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_CustomerCareCallUs_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthTextBlock/Gql__FullWidthTextBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthTextBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FullWidthTextBlock on FullWidthTextBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    text_colour  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    background_colour  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_FullWidthTextBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_FullWidthTextBlock_Fragment_bs_Raw = {};
var Gql_FullWidthTextBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_FullWidthTextBlock_Fragment_bs_templateObject());
function Gql_FullWidthTextBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.text_colour;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.background_colour;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        text_colour: tmp$2,
        background_colour: tmp$3
    };
}
function Gql_FullWidthTextBlock_Fragment_bs_serialize(value) {
    var value$1 = value.background_colour;
    var background_colour;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        background_colour = {
            __typename: value$4,
            value: value$3
        };
    } else {
        background_colour = null;
    }
    var value$5 = value.text_colour;
    var text_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        text_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        text_colour = null;
    }
    var value$9 = value.description;
    var description;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        description = {
            __typename: value$12,
            value: value$11
        };
    } else {
        description = null;
    }
    var value$13 = value.title;
    var title;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        title = {
            __typename: value$16,
            value: value$15
        };
    } else {
        title = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        title: title,
        description: description,
        text_colour: text_colour,
        background_colour: background_colour
    };
}
function Gql_FullWidthTextBlock_Fragment_bs_verifyArgsAndParse(_FullWidthTextBlock, value) {
    return Gql_FullWidthTextBlock_Fragment_bs_parse(value);
}
function Gql_FullWidthTextBlock_Fragment_bs_verifyName(param) {}
var FullWidthTextBlock = {
    Raw: Gql_FullWidthTextBlock_Fragment_bs_Raw,
    query: Gql_FullWidthTextBlock_Fragment_bs_query,
    parse: Gql_FullWidthTextBlock_Fragment_bs_parse,
    serialize: Gql_FullWidthTextBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_FullWidthTextBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_FullWidthTextBlock_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SellingPointsBlockItem/Gql__SellingPointsBlockItem__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SellingPointsBlockItem_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SellingPointsBlockItem on SellingPointsBlockItemContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    video_mp4  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    video_webm  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n"
    ]);
    Gql_SellingPointsBlockItem_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_SellingPointsBlockItem_Fragment_bs_Raw = {};
var Gql_SellingPointsBlockItem_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_SellingPointsBlockItem_Fragment_bs_templateObject());
function Gql_SellingPointsBlockItem_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.image;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.title;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.video_mp4;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.video_webm;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        image: tmp,
        title: tmp$1,
        description: tmp$2,
        video_mp4: tmp$3,
        video_webm: tmp$4
    };
}
function Gql_SellingPointsBlockItem_Fragment_bs_serialize(value) {
    var value$1 = value.video_webm;
    var video_webm;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        video_webm = {
            __typename: value$4,
            value: value$3
        };
    } else {
        video_webm = null;
    }
    var value$5 = value.video_mp4;
    var video_mp4;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        video_mp4 = {
            __typename: value$8,
            value: value$7
        };
    } else {
        video_mp4 = null;
    }
    var value$9 = value.description;
    var description;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        description = {
            __typename: value$12,
            value: value$11
        };
    } else {
        description = null;
    }
    var value$13 = value.title;
    var title;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        title = {
            __typename: value$16,
            value: value$15
        };
    } else {
        title = null;
    }
    var value$17 = value.image;
    var image;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        image = {
            __typename: value$20,
            value: value$19
        };
    } else {
        image = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        image: image,
        title: title,
        description: description,
        video_mp4: video_mp4,
        video_webm: video_webm
    };
}
function Gql_SellingPointsBlockItem_Fragment_bs_verifyArgsAndParse(_SellingPointsBlockItem, value) {
    return Gql_SellingPointsBlockItem_Fragment_bs_parse(value);
}
function Gql_SellingPointsBlockItem_Fragment_bs_verifyName(param) {}
var SellingPointsBlockItem = {
    Raw: Gql_SellingPointsBlockItem_Fragment_bs_Raw,
    query: Gql_SellingPointsBlockItem_Fragment_bs_query,
    parse: Gql_SellingPointsBlockItem_Fragment_bs_parse,
    serialize: Gql_SellingPointsBlockItem_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SellingPointsBlockItem_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SellingPointsBlockItem_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SellingPointsBlock/Gql__SellingPointsBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SellingPointsBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SellingPointsBlock on SellingPointsBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    items  {\n      __typename\n      value  {\n        __typename\n        ...on SellingPointsBlockItemContentType   {\n          ...SellingPointsBlockItem\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_SellingPointsBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_SellingPointsBlock_Fragment_bs_Raw = {};
var Gql_SellingPointsBlock_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SellingPointsBlock_Fragment_bs_templateObject(), frag_0);
}(SellingPointsBlockItem.query);
function Gql_SellingPointsBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.background_colour;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.items;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "SellingPointsBlockItemContentType" ? {
                    NAME: "SellingPointsBlockItemContentType",
                    VAL: {
                        sellingPointsBlockItem: SellingPointsBlockItem.verifyArgsAndParse("SellingPointsBlockItem", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        background_colour: tmp$1,
        items: tmp$2
    };
}
function Gql_SellingPointsBlock_Fragment_bs_serialize(value) {
    var value$1 = value.items;
    var items;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        SellingPointsBlockItem.serialize(value.VAL.sellingPointsBlockItem)
                    ]);
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        items = {
            __typename: value$4,
            value: value$3
        };
    } else {
        items = null;
    }
    var value$5 = value.background_colour;
    var background_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        background_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_colour = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        background_colour: background_colour,
        items: items
    };
}
function Gql_SellingPointsBlock_Fragment_bs_verifyArgsAndParse(_SellingPointsBlock, value) {
    return Gql_SellingPointsBlock_Fragment_bs_parse(value);
}
function Gql_SellingPointsBlock_Fragment_bs_verifyName(param) {}
var SellingPointsBlock = {
    Raw: Gql_SellingPointsBlock_Fragment_bs_Raw,
    query: Gql_SellingPointsBlock_Fragment_bs_query,
    parse: Gql_SellingPointsBlock_Fragment_bs_parse,
    serialize: Gql_SellingPointsBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SellingPointsBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SellingPointsBlock_Fragment_bs_verifyName
};
var Gql_SellingPointsBlock_Fragment_bs_SellingPointsBlockItem;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/TextField/Gql__TextField__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TextField_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TextField on TextFieldContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    name  {\n      __typename\n      value\n    }\n    type  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    label  {\n      __typename\n      value\n    }\n    placeholder  {\n      __typename\n      value\n    }\n    validation_message  {\n      __typename\n      value\n    }\n    required  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n  }\n"
    ]);
    Gql_TextField_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_TextField_Fragment_bs_Raw = {};
var Gql_TextField_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_TextField_Fragment_bs_templateObject());
function Gql_TextField_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.name;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.type;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.label;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.placeholder;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.validation_message;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.required;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$13) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        name: tmp,
        type: tmp$1,
        label: tmp$2,
        placeholder: tmp$3,
        validation_message: tmp$4,
        required: tmp$5
    };
}
function Gql_TextField_Fragment_bs_serialize(value) {
    var value$1 = value.required;
    var required;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        required = {
            __typename: value$4,
            value: value$3
        };
    } else {
        required = null;
    }
    var value$5 = value.validation_message;
    var validation_message;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        validation_message = {
            __typename: value$8,
            value: value$7
        };
    } else {
        validation_message = null;
    }
    var value$9 = value.placeholder;
    var placeholder;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        placeholder = {
            __typename: value$12,
            value: value$11
        };
    } else {
        placeholder = null;
    }
    var value$13 = value.label;
    var label;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        label = {
            __typename: value$16,
            value: value$15
        };
    } else {
        label = null;
    }
    var value$17 = value.type;
    var type_;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        type_ = {
            __typename: value$20,
            value: value$19
        };
    } else {
        type_ = null;
    }
    var value$21 = value.name;
    var name;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        name = {
            __typename: value$24,
            value: value$23
        };
    } else {
        name = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        name: name,
        type: type_,
        label: label,
        placeholder: placeholder,
        validation_message: validation_message,
        required: required
    };
}
function Gql_TextField_Fragment_bs_verifyArgsAndParse(_TextField, value) {
    return Gql_TextField_Fragment_bs_parse(value);
}
function Gql_TextField_Fragment_bs_verifyName(param) {}
var TextField = {
    Raw: Gql_TextField_Fragment_bs_Raw,
    query: Gql_TextField_Fragment_bs_query,
    parse: Gql_TextField_Fragment_bs_parse,
    serialize: Gql_TextField_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_TextField_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_TextField_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/BusinessContactForm/Gql__BusinessContactForm__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_BusinessContactForm_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment BusinessContactFormBlock on BusinessContactFormContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    email_icon_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    email  {\n      __typename\n      value\n    }\n    phone_icon_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    phone  {\n      __typename\n      value\n    }\n    body_text  {\n      __typename\n      value\n    }\n    body_ctas  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    fields  {\n      __typename\n      value  {\n        __typename\n        ...on TextFieldContentType   {\n          ...TextField\n        }\n      }\n    }\n    submit_cta_text  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_BusinessContactForm_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_BusinessContactForm_Fragment_bs_Raw = {};
var Gql_BusinessContactForm_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_BusinessContactForm_Fragment_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, TextField.query);
function Gql_BusinessContactForm_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.email_icon_asset;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.email;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.phone_icon_asset;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$9) : undefined
        };
    }
    var value$10 = value.phone;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.body_text;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? value$13 : undefined
        };
    }
    var value$14 = value.body_ctas;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$15) : undefined
        };
    }
    var value$16 = value.fields;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "TextFieldContentType" ? {
                    NAME: "TextFieldContentType",
                    VAL: {
                        textField: TextField.verifyArgsAndParse("TextField", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$17) : undefined
        };
    }
    var value$18 = value.submit_cta_text;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        email_icon_asset: tmp$1,
        email: tmp$2,
        phone_icon_asset: tmp$3,
        phone: tmp$4,
        body_text: tmp$5,
        body_ctas: tmp$6,
        fields: tmp$7,
        submit_cta_text: tmp$8
    };
}
function Gql_BusinessContactForm_Fragment_bs_serialize(value) {
    var value$1 = value.submit_cta_text;
    var submit_cta_text;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        submit_cta_text = {
            __typename: value$4,
            value: value$3
        };
    } else {
        submit_cta_text = null;
    }
    var value$5 = value.fields;
    var fields;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "TextFieldContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        TextField.serialize(value.VAL.textField)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        fields = {
            __typename: value$8,
            value: value$7
        };
    } else {
        fields = null;
    }
    var value$9 = value.body_ctas;
    var body_ctas;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        body_ctas = {
            __typename: value$12,
            value: value$11
        };
    } else {
        body_ctas = null;
    }
    var value$13 = value.body_text;
    var body_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        body_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        body_text = null;
    }
    var value$17 = value.phone;
    var phone;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        phone = {
            __typename: value$20,
            value: value$19
        };
    } else {
        phone = null;
    }
    var value$21 = value.phone_icon_asset;
    var phone_icon_asset;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$22) : null;
        var value$24 = value$21.__typename;
        phone_icon_asset = {
            __typename: value$24,
            value: value$23
        };
    } else {
        phone_icon_asset = null;
    }
    var value$25 = value.email;
    var email;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        email = {
            __typename: value$28,
            value: value$27
        };
    } else {
        email = null;
    }
    var value$29 = value.email_icon_asset;
    var email_icon_asset;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        email_icon_asset = {
            __typename: value$32,
            value: value$31
        };
    } else {
        email_icon_asset = null;
    }
    var value$33 = value.title;
    var title;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        title = {
            __typename: value$36,
            value: value$35
        };
    } else {
        title = null;
    }
    var value$37 = value.system;
    var value$38 = value$37.codename;
    var value$39 = value$37.id;
    var value$40 = value$37.__typename;
    var system = {
        __typename: value$40,
        id: value$39,
        codename: value$38
    };
    var value$41 = value.__typename;
    return {
        __typename: value$41,
        system: system,
        title: title,
        email_icon_asset: email_icon_asset,
        email: email,
        phone_icon_asset: phone_icon_asset,
        phone: phone,
        body_text: body_text,
        body_ctas: body_ctas,
        fields: fields,
        submit_cta_text: submit_cta_text
    };
}
function Gql_BusinessContactForm_Fragment_bs_verifyArgsAndParse(_BusinessContactFormBlock, value) {
    return Gql_BusinessContactForm_Fragment_bs_parse(value);
}
function Gql_BusinessContactForm_Fragment_bs_verifyName(param) {}
var BusinessContactFormBlock = {
    Raw: Gql_BusinessContactForm_Fragment_bs_Raw,
    query: Gql_BusinessContactForm_Fragment_bs_query,
    parse: Gql_BusinessContactForm_Fragment_bs_parse,
    serialize: Gql_BusinessContactForm_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_BusinessContactForm_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_BusinessContactForm_Fragment_bs_verifyName
};
var Gql_BusinessContactForm_Fragment_bs_TextField;
var Gql_BusinessContactForm_Fragment_bs_CallToAction;
var Gql_BusinessContactForm_Fragment_bs_CardIcon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FullWidthHeroBannerBlock on FullWidthHeroContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    scrolling_text  {\n      __typename\n      value  {\n        __typename\n        ...on TextListContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          text_list_items  {\n            __typename\n            value  {\n              __typename\n              ...on TextListItemContentType   {\n                __typename\n                system  {\n                  __typename\n                  id\n                  codename\n                }\n                text  {\n                  __typename\n                  value\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    scrolling_text_colour  {\n      __typename\n      value\n    }\n    buttons  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    video_button_icon  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    video_button_url  {\n      __typename\n      value\n    }\n    video_button_text  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    desktop_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    tablet_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    mobile_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_FullWidthHeroBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_FullWidthHeroBanner_Fragment_bs_Raw = {};
var Gql_FullWidthHeroBanner_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_FullWidthHeroBanner_Fragment_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, $$Image.query);
function Gql_FullWidthHeroBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.scrolling_text;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "TextListContentType") {
                    var value$1 = value.system;
                    var value$2 = value.text_list_items;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp;
                                if (typename === "TextListItemContentType") {
                                    var value$1 = value.system;
                                    var value$2 = value.text;
                                    var tmp$1;
                                    if (value$2 == null) {
                                        tmp$1 = undefined;
                                    } else {
                                        var value$3 = value$2.value;
                                        tmp$1 = {
                                            __typename: value$2.__typename,
                                            value: !(value$3 == null) ? value$3 : undefined
                                        };
                                    }
                                    tmp = {
                                        NAME: "TextListItemContentType",
                                        VAL: {
                                            __typename: value.__typename,
                                            system: {
                                                __typename: value$1.__typename,
                                                id: value$1.id,
                                                codename: value$1.codename
                                            },
                                            text: tmp$1
                                        }
                                    };
                                } else {
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                                }
                                return tmp;
                            }, value$3) : undefined
                        };
                    }
                    tmp = {
                        NAME: "TextListContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            text_list_items: tmp$1
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    var value$8 = value.scrolling_text_colour;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.buttons;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$11) : undefined
        };
    }
    var value$12 = value.video_button_icon;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$13) : undefined
        };
    }
    var value$14 = value.video_button_url;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.video_button_text;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.background_colour;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.desktop_image;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$21) : undefined
        };
    }
    var value$22 = value.tablet_image;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$23) : undefined
        };
    }
    var value$24 = value.mobile_image;
    var tmp$11;
    if (value$24 == null) {
        tmp$11 = undefined;
    } else {
        var value$25 = value$24.value;
        tmp$11 = {
            __typename: value$24.__typename,
            value: !(value$25 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$25) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        scrolling_text: tmp$2,
        scrolling_text_colour: tmp$3,
        buttons: tmp$4,
        video_button_icon: tmp$5,
        video_button_url: tmp$6,
        video_button_text: tmp$7,
        background_colour: tmp$8,
        desktop_image: tmp$9,
        tablet_image: tmp$10,
        mobile_image: tmp$11
    };
}
function Gql_FullWidthHeroBanner_Fragment_bs_serialize(value) {
    var value$1 = value.mobile_image;
    var mobile_image;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        mobile_image = {
            __typename: value$4,
            value: value$3
        };
    } else {
        mobile_image = null;
    }
    var value$5 = value.tablet_image;
    var tablet_image;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        tablet_image = {
            __typename: value$8,
            value: value$7
        };
    } else {
        tablet_image = null;
    }
    var value$9 = value.desktop_image;
    var desktop_image;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        desktop_image = {
            __typename: value$12,
            value: value$11
        };
    } else {
        desktop_image = null;
    }
    var value$13 = value.background_colour;
    var background_colour;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        background_colour = {
            __typename: value$16,
            value: value$15
        };
    } else {
        background_colour = null;
    }
    var value$17 = value.video_button_text;
    var video_button_text;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        video_button_text = {
            __typename: value$20,
            value: value$19
        };
    } else {
        video_button_text = null;
    }
    var value$21 = value.video_button_url;
    var video_button_url;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        video_button_url = {
            __typename: value$24,
            value: value$23
        };
    } else {
        video_button_url = null;
    }
    var value$25 = value.video_button_icon;
    var video_button_icon;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$26) : null;
        var value$28 = value$25.__typename;
        video_button_icon = {
            __typename: value$28,
            value: value$27
        };
    } else {
        video_button_icon = null;
    }
    var value$29 = value.buttons;
    var buttons;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$30) : null;
        var value$32 = value$29.__typename;
        buttons = {
            __typename: value$32,
            value: value$31
        };
    } else {
        buttons = null;
    }
    var value$33 = value.scrolling_text_colour;
    var scrolling_text_colour;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        scrolling_text_colour = {
            __typename: value$36,
            value: value$35
        };
    } else {
        scrolling_text_colour = null;
    }
    var value$37 = value.scrolling_text;
    var scrolling_text;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.text_list_items;
            var text_list_items;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    if (value.NAME !== "TextListItemContentType") {
                        return {};
                    }
                    var value$1 = value.VAL;
                    var value$2 = value$1.text;
                    var text;
                    if (value$2 !== undefined) {
                        var value$3 = value$2.value;
                        var value$4 = value$3 !== undefined ? value$3 : null;
                        var value$5 = value$2.__typename;
                        text = {
                            __typename: value$5,
                            value: value$4
                        };
                    } else {
                        text = null;
                    }
                    var value$6 = value$1.system;
                    var value$7 = value$6.codename;
                    var value$8 = value$6.id;
                    var value$9 = value$6.__typename;
                    var system = {
                        __typename: value$9,
                        id: value$8,
                        codename: value$7
                    };
                    return {
                        __typename: "TextListItemContentType",
                        system: system,
                        text: text
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                text_list_items = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                text_list_items = null;
            }
            var value$6 = value$1.system;
            var value$7 = value$6.codename;
            var value$8 = value$6.id;
            var value$9 = value$6.__typename;
            var system = {
                __typename: value$9,
                id: value$8,
                codename: value$7
            };
            return {
                __typename: "TextListContentType",
                system: system,
                text_list_items: text_list_items
            };
        }, value$38) : null;
        var value$40 = value$37.__typename;
        scrolling_text = {
            __typename: value$40,
            value: value$39
        };
    } else {
        scrolling_text = null;
    }
    var value$41 = value.description;
    var description;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? value$42 : null;
        var value$44 = value$41.__typename;
        description = {
            __typename: value$44,
            value: value$43
        };
    } else {
        description = null;
    }
    var value$45 = value.title;
    var title;
    if (value$45 !== undefined) {
        var value$46 = value$45.value;
        var value$47 = value$46 !== undefined ? value$46 : null;
        var value$48 = value$45.__typename;
        title = {
            __typename: value$48,
            value: value$47
        };
    } else {
        title = null;
    }
    var value$49 = value.system;
    var value$50 = value$49.codename;
    var value$51 = value$49.id;
    var value$52 = value$49.__typename;
    var system = {
        __typename: value$52,
        id: value$51,
        codename: value$50
    };
    var value$53 = value.__typename;
    return {
        __typename: value$53,
        system: system,
        title: title,
        description: description,
        scrolling_text: scrolling_text,
        scrolling_text_colour: scrolling_text_colour,
        buttons: buttons,
        video_button_icon: video_button_icon,
        video_button_url: video_button_url,
        video_button_text: video_button_text,
        background_colour: background_colour,
        desktop_image: desktop_image,
        tablet_image: tablet_image,
        mobile_image: mobile_image
    };
}
function Gql_FullWidthHeroBanner_Fragment_bs_verifyArgsAndParse(_FullWidthHeroBannerBlock, value) {
    return Gql_FullWidthHeroBanner_Fragment_bs_parse(value);
}
function Gql_FullWidthHeroBanner_Fragment_bs_verifyName(param) {}
var FullWidthHeroBannerBlock = {
    Raw: Gql_FullWidthHeroBanner_Fragment_bs_Raw,
    query: Gql_FullWidthHeroBanner_Fragment_bs_query,
    parse: Gql_FullWidthHeroBanner_Fragment_bs_parse,
    serialize: Gql_FullWidthHeroBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_FullWidthHeroBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_FullWidthHeroBanner_Fragment_bs_verifyName
};
var Gql_FullWidthHeroBanner_Fragment_bs_$$Image;
var Gql_FullWidthHeroBanner_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/InnovativeWayToGift/Gql__InnovativeWayToGift__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_InnovativeWayToGift_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment InnovativeWayToGiftBlock on InnovativeWayToGiftContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    cta_button_s  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    desktop_background_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    tablet_background_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    mobile_background_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_InnovativeWayToGift_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_InnovativeWayToGift_Fragment_bs_Raw = {};
var Gql_InnovativeWayToGift_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_InnovativeWayToGift_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_InnovativeWayToGift_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.background_colour;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.cta_button_s;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.desktop_background_asset;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.tablet_background_asset;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.mobile_background_asset;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$15) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        background_colour: tmp$2,
        cta_button_s: tmp$3,
        desktop_background_asset: tmp$4,
        tablet_background_asset: tmp$5,
        mobile_background_asset: tmp$6
    };
}
function Gql_InnovativeWayToGift_Fragment_bs_serialize(value) {
    var value$1 = value.mobile_background_asset;
    var mobile_background_asset;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        mobile_background_asset = {
            __typename: value$4,
            value: value$3
        };
    } else {
        mobile_background_asset = null;
    }
    var value$5 = value.tablet_background_asset;
    var tablet_background_asset;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        tablet_background_asset = {
            __typename: value$8,
            value: value$7
        };
    } else {
        tablet_background_asset = null;
    }
    var value$9 = value.desktop_background_asset;
    var desktop_background_asset;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        desktop_background_asset = {
            __typename: value$12,
            value: value$11
        };
    } else {
        desktop_background_asset = null;
    }
    var value$13 = value.cta_button_s;
    var cta_button_s;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$14) : null;
        var value$16 = value$13.__typename;
        cta_button_s = {
            __typename: value$16,
            value: value$15
        };
    } else {
        cta_button_s = null;
    }
    var value$17 = value.background_colour;
    var background_colour;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        background_colour = {
            __typename: value$20,
            value: value$19
        };
    } else {
        background_colour = null;
    }
    var value$21 = value.description;
    var description;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        description = {
            __typename: value$24,
            value: value$23
        };
    } else {
        description = null;
    }
    var value$25 = value.title;
    var title;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        title = {
            __typename: value$28,
            value: value$27
        };
    } else {
        title = null;
    }
    var value$29 = value.system;
    var value$30 = value$29.codename;
    var value$31 = value$29.id;
    var value$32 = value$29.__typename;
    var system = {
        __typename: value$32,
        id: value$31,
        codename: value$30
    };
    var value$33 = value.__typename;
    return {
        __typename: value$33,
        system: system,
        title: title,
        description: description,
        background_colour: background_colour,
        cta_button_s: cta_button_s,
        desktop_background_asset: desktop_background_asset,
        tablet_background_asset: tablet_background_asset,
        mobile_background_asset: mobile_background_asset
    };
}
function Gql_InnovativeWayToGift_Fragment_bs_verifyArgsAndParse(_InnovativeWayToGiftBlock, value) {
    return Gql_InnovativeWayToGift_Fragment_bs_parse(value);
}
function Gql_InnovativeWayToGift_Fragment_bs_verifyName(param) {}
var InnovativeWayToGiftBlock = {
    Raw: Gql_InnovativeWayToGift_Fragment_bs_Raw,
    query: Gql_InnovativeWayToGift_Fragment_bs_query,
    parse: Gql_InnovativeWayToGift_Fragment_bs_parse,
    serialize: Gql_InnovativeWayToGift_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_InnovativeWayToGift_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_InnovativeWayToGift_Fragment_bs_verifyName
};
var Gql_InnovativeWayToGift_Fragment_bs_$$Image;
var Gql_InnovativeWayToGift_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/BoardOfDirectorsBlock/Gql__BoardOfDirectorsBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_BoardOfDirectorsBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment BoardOfDirectorsBlock on BoardOfDirectorsBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    board_of_directors_cards  {\n      __typename\n      value  {\n        __typename\n        ...on BoardOfDirectorsCardContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          name  {\n            __typename\n            value\n          }\n          title  {\n            __typename\n            value\n          }\n          link  {\n            __typename\n            value\n          }\n          photo_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_BoardOfDirectorsBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_BoardOfDirectorsBlock_Fragment_bs_Raw = {};
var Gql_BoardOfDirectorsBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_BoardOfDirectorsBlock_Fragment_bs_templateObject());
function Gql_BoardOfDirectorsBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.board_of_directors_cards;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "BoardOfDirectorsCardContentType") {
                    var value$1 = value.system;
                    var value$2 = value.name;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.title;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.link;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.photo_asset;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$9) : undefined
                        };
                    }
                    tmp = {
                        NAME: "BoardOfDirectorsCardContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            name: tmp$1,
                            title: tmp$2,
                            link: tmp$3,
                            photo_asset: tmp$4
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$5) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        board_of_directors_cards: tmp$1
    };
}
function Gql_BoardOfDirectorsBlock_Fragment_bs_serialize(value) {
    var value$1 = value.board_of_directors_cards;
    var board_of_directors_cards;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME !== "BoardOfDirectorsCardContentType") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.photo_asset;
            var photo_asset;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                photo_asset = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                photo_asset = null;
            }
            var value$6 = value$1.link;
            var link;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                link = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                link = null;
            }
            var value$10 = value$1.title;
            var title;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                title = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                title = null;
            }
            var value$14 = value$1.name;
            var name;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                name = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                name = null;
            }
            var value$18 = value$1.system;
            var value$19 = value$18.codename;
            var value$20 = value$18.id;
            var value$21 = value$18.__typename;
            var system = {
                __typename: value$21,
                id: value$20,
                codename: value$19
            };
            return {
                __typename: "BoardOfDirectorsCardContentType",
                system: system,
                name: name,
                title: title,
                link: link,
                photo_asset: photo_asset
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        board_of_directors_cards = {
            __typename: value$4,
            value: value$3
        };
    } else {
        board_of_directors_cards = null;
    }
    var value$5 = value.title;
    var title;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        title = {
            __typename: value$8,
            value: value$7
        };
    } else {
        title = null;
    }
    var value$9 = value.system;
    var value$10 = value$9.codename;
    var value$11 = value$9.id;
    var value$12 = value$9.__typename;
    var system = {
        __typename: value$12,
        id: value$11,
        codename: value$10
    };
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        system: system,
        title: title,
        board_of_directors_cards: board_of_directors_cards
    };
}
function Gql_BoardOfDirectorsBlock_Fragment_bs_verifyArgsAndParse(_BoardOfDirectorsBlock, value) {
    return Gql_BoardOfDirectorsBlock_Fragment_bs_parse(value);
}
function Gql_BoardOfDirectorsBlock_Fragment_bs_verifyName(param) {}
var BoardOfDirectorsBlock = {
    Raw: Gql_BoardOfDirectorsBlock_Fragment_bs_Raw,
    query: Gql_BoardOfDirectorsBlock_Fragment_bs_query,
    parse: Gql_BoardOfDirectorsBlock_Fragment_bs_parse,
    serialize: Gql_BoardOfDirectorsBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_BoardOfDirectorsBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_BoardOfDirectorsBlock_Fragment_bs_verifyName
};
var Gql_BoardOfDirectorsBlock_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/TrustpilotWidgetBlock/Gql__TrustpilotWidgetBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TrustpilotWidgetBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TrustpilotWidgetBlock on TrustpilotWidgetBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title_text  {\n      __typename\n      value\n    }\n    title_alignment  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    title_heading  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    widget_code  {\n      __typename\n      value\n    }\n    top_distance  {\n      __typename\n      value\n    }\n    bottom_distance  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_TrustpilotWidgetBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_TrustpilotWidgetBlock_Fragment_bs_Raw = {};
var Gql_TrustpilotWidgetBlock_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_TrustpilotWidgetBlock_Fragment_bs_templateObject());
function Gql_TrustpilotWidgetBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title_text;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.title_alignment;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.title_heading;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.widget_code;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.top_distance;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.bottom_distance;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? value$13 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title_text: tmp,
        title_alignment: tmp$1,
        title_heading: tmp$2,
        widget_code: tmp$3,
        top_distance: tmp$4,
        bottom_distance: tmp$5
    };
}
function Gql_TrustpilotWidgetBlock_Fragment_bs_serialize(value) {
    var value$1 = value.bottom_distance;
    var bottom_distance;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        bottom_distance = {
            __typename: value$4,
            value: value$3
        };
    } else {
        bottom_distance = null;
    }
    var value$5 = value.top_distance;
    var top_distance;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        top_distance = {
            __typename: value$8,
            value: value$7
        };
    } else {
        top_distance = null;
    }
    var value$9 = value.widget_code;
    var widget_code;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        widget_code = {
            __typename: value$12,
            value: value$11
        };
    } else {
        widget_code = null;
    }
    var value$13 = value.title_heading;
    var title_heading;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        title_heading = {
            __typename: value$16,
            value: value$15
        };
    } else {
        title_heading = null;
    }
    var value$17 = value.title_alignment;
    var title_alignment;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$18) : null;
        var value$20 = value$17.__typename;
        title_alignment = {
            __typename: value$20,
            value: value$19
        };
    } else {
        title_alignment = null;
    }
    var value$21 = value.title_text;
    var title_text;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        title_text = {
            __typename: value$24,
            value: value$23
        };
    } else {
        title_text = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        title_text: title_text,
        title_alignment: title_alignment,
        title_heading: title_heading,
        widget_code: widget_code,
        top_distance: top_distance,
        bottom_distance: bottom_distance
    };
}
function Gql_TrustpilotWidgetBlock_Fragment_bs_verifyArgsAndParse(_TrustpilotWidgetBlock, value) {
    return Gql_TrustpilotWidgetBlock_Fragment_bs_parse(value);
}
function Gql_TrustpilotWidgetBlock_Fragment_bs_verifyName(param) {}
var TrustpilotWidgetBlock = {
    Raw: Gql_TrustpilotWidgetBlock_Fragment_bs_Raw,
    query: Gql_TrustpilotWidgetBlock_Fragment_bs_query,
    parse: Gql_TrustpilotWidgetBlock_Fragment_bs_parse,
    serialize: Gql_TrustpilotWidgetBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_TrustpilotWidgetBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_TrustpilotWidgetBlock_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/LandingPageContactForm/Gql__LandingPageContactForm__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_LandingPageContactForm_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LandingPageContactFormBlock on LandingPageContactFormContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    action  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    form_name  {\n      __typename\n      value\n    }\n    title  {\n      __typename\n      value\n    }\n    body_text  {\n      __typename\n      value\n    }\n    fields  {\n      __typename\n      value  {\n        __typename\n        ...on FormControlWrapperContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          desktop_width  {\n            __typename\n            value\n          }\n          tablet_width  {\n            __typename\n            value\n          }\n          mobile_width  {\n            __typename\n            value\n          }\n          control  {\n            __typename\n            value  {\n              __typename\n              ...on TextFieldContentType   {\n                ...TextField\n              }\n            }\n          }\n        }\n      }\n    }\n    submit_cta_text  {\n      __typename\n      value\n    }\n    success_message_heading  {\n      __typename\n      value\n    }\n    success_message_text  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_LandingPageContactForm_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_LandingPageContactForm_Fragment_bs_Raw = {};
var Gql_LandingPageContactForm_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_LandingPageContactForm_Fragment_bs_templateObject(), frag_0);
}(TextField.query);
function Gql_LandingPageContactForm_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.action;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.form_name;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.title;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.body_text;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.fields;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "FormControlWrapperContentType") {
                    var value$1 = value.system;
                    var value$2 = value.desktop_width;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.tablet_width;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.mobile_width;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.control;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "TextFieldContentType" ? {
                                    NAME: "TextFieldContentType",
                                    VAL: {
                                        textField: TextField.verifyArgsAndParse("TextField", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$9) : undefined
                        };
                    }
                    tmp = {
                        NAME: "FormControlWrapperContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            desktop_width: tmp$1,
                            tablet_width: tmp$2,
                            mobile_width: tmp$3,
                            control: tmp$4
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$11) : undefined
        };
    }
    var value$12 = value.submit_cta_text;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? value$13 : undefined
        };
    }
    var value$14 = value.success_message_heading;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.success_message_text;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        action: tmp,
        form_name: tmp$1,
        title: tmp$2,
        body_text: tmp$3,
        fields: tmp$4,
        submit_cta_text: tmp$5,
        success_message_heading: tmp$6,
        success_message_text: tmp$7
    };
}
function Gql_LandingPageContactForm_Fragment_bs_serialize(value) {
    var value$1 = value.success_message_text;
    var success_message_text;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        success_message_text = {
            __typename: value$4,
            value: value$3
        };
    } else {
        success_message_text = null;
    }
    var value$5 = value.success_message_heading;
    var success_message_heading;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        success_message_heading = {
            __typename: value$8,
            value: value$7
        };
    } else {
        success_message_heading = null;
    }
    var value$9 = value.submit_cta_text;
    var submit_cta_text;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        submit_cta_text = {
            __typename: value$12,
            value: value$11
        };
    } else {
        submit_cta_text = null;
    }
    var value$13 = value.fields;
    var fields;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.control;
            var control;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "TextFieldContentType") {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                TextField.serialize(value.VAL.textField)
                            ]);
                        } else {
                            return {};
                        }
                    } else {
                        return null;
                    }
                }, value$3) : null;
                var value$5 = value$2.__typename;
                control = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                control = null;
            }
            var value$6 = value$1.mobile_width;
            var mobile_width;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                mobile_width = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                mobile_width = null;
            }
            var value$10 = value$1.tablet_width;
            var tablet_width;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                tablet_width = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                tablet_width = null;
            }
            var value$14 = value$1.desktop_width;
            var desktop_width;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                desktop_width = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                desktop_width = null;
            }
            var value$18 = value$1.system;
            var value$19 = value$18.codename;
            var value$20 = value$18.id;
            var value$21 = value$18.__typename;
            var system = {
                __typename: value$21,
                id: value$20,
                codename: value$19
            };
            return {
                __typename: "FormControlWrapperContentType",
                system: system,
                desktop_width: desktop_width,
                tablet_width: tablet_width,
                mobile_width: mobile_width,
                control: control
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        fields = {
            __typename: value$16,
            value: value$15
        };
    } else {
        fields = null;
    }
    var value$17 = value.body_text;
    var body_text;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        body_text = {
            __typename: value$20,
            value: value$19
        };
    } else {
        body_text = null;
    }
    var value$21 = value.title;
    var title;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        title = {
            __typename: value$24,
            value: value$23
        };
    } else {
        title = null;
    }
    var value$25 = value.form_name;
    var form_name;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        form_name = {
            __typename: value$28,
            value: value$27
        };
    } else {
        form_name = null;
    }
    var value$29 = value.action;
    var action;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$30) : null;
        var value$32 = value$29.__typename;
        action = {
            __typename: value$32,
            value: value$31
        };
    } else {
        action = null;
    }
    var value$33 = value.system;
    var value$34 = value$33.codename;
    var value$35 = value$33.id;
    var value$36 = value$33.__typename;
    var system = {
        __typename: value$36,
        id: value$35,
        codename: value$34
    };
    var value$37 = value.__typename;
    return {
        __typename: value$37,
        system: system,
        action: action,
        form_name: form_name,
        title: title,
        body_text: body_text,
        fields: fields,
        submit_cta_text: submit_cta_text,
        success_message_heading: success_message_heading,
        success_message_text: success_message_text
    };
}
function Gql_LandingPageContactForm_Fragment_bs_verifyArgsAndParse(_LandingPageContactFormBlock, value) {
    return Gql_LandingPageContactForm_Fragment_bs_parse(value);
}
function Gql_LandingPageContactForm_Fragment_bs_verifyName(param) {}
var LandingPageContactFormBlock = {
    Raw: Gql_LandingPageContactForm_Fragment_bs_Raw,
    query: Gql_LandingPageContactForm_Fragment_bs_query,
    parse: Gql_LandingPageContactForm_Fragment_bs_parse,
    serialize: Gql_LandingPageContactForm_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_LandingPageContactForm_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_LandingPageContactForm_Fragment_bs_verifyName
};
var Gql_LandingPageContactForm_Fragment_bs_TextField;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TestimonialCarouselBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment TestimonialCarouselBlock on TestimonialCarouselBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    testimonial_image_grid  {\n      __typename\n      value  {\n        __typename\n        ...on ImageCollectionContentType   {\n          ...ImageCollection\n        }\n      }\n    }\n    testimonial_carousel_items  {\n      __typename\n      value  {\n        __typename\n        ...on TestimonialCarouselItemContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          image_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          quote  {\n            __typename\n            value\n          }\n          author  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value  {\n              __typename\n              ...on LinkItemContentType   {\n                __typename\n                url  {\n                  __typename\n                  value\n                }\n                open_in_new_window  {\n                  __typename\n                  value  {\n                    __typename\n                    codename\n                  }\n                }\n              }\n            }\n          }\n          background_image  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_image_tablet  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_image_mobile  {\n            __typename\n            value  {\n              __typename\n              ...on ImageContentType   {\n                ...Image\n              }\n            }\n          }\n          background_colour  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_TestimonialCarouselBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_TestimonialCarouselBlock_Fragment_bs_Raw = {};
var Gql_TestimonialCarouselBlock_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_TestimonialCarouselBlock_Fragment_bs_templateObject(), frag_0, frag_1);
}($$Image.query, ImageCollection.query);
function Gql_TestimonialCarouselBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.testimonial_image_grid;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageCollectionContentType" ? {
                    NAME: "ImageCollectionContentType",
                    VAL: {
                        imageCollection: ImageCollection.verifyArgsAndParse("ImageCollection", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.testimonial_carousel_items;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "TestimonialCarouselItemContentType") {
                    var value$1 = value.system;
                    var value$2 = value.image_asset;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$3) : undefined
                        };
                    }
                    var value$4 = value.quote;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.author;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    var value$8 = value.url;
                    var tmp$4;
                    if (value$8 == null) {
                        tmp$4 = undefined;
                    } else {
                        var value$9 = value$8.value;
                        tmp$4 = {
                            __typename: value$8.__typename,
                            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp;
                                if (typename === "LinkItemContentType") {
                                    var value$1 = value.url;
                                    var tmp$1;
                                    if (value$1 == null) {
                                        tmp$1 = undefined;
                                    } else {
                                        var value$2 = value$1.value;
                                        tmp$1 = {
                                            __typename: value$1.__typename,
                                            value: !(value$2 == null) ? value$2 : undefined
                                        };
                                    }
                                    var value$3 = value.open_in_new_window;
                                    var tmp$2;
                                    if (value$3 == null) {
                                        tmp$2 = undefined;
                                    } else {
                                        var value$4 = value$3.value;
                                        tmp$2 = {
                                            __typename: value$3.__typename,
                                            value: !(value$4 == null) ? js_array/* map */.UI(function(value) {
                                                if (value == null) {
                                                    return;
                                                }
                                                var value$1 = value.codename;
                                                return {
                                                    __typename: value.__typename,
                                                    codename: !(value$1 == null) ? value$1 : undefined
                                                };
                                            }, value$4) : undefined
                                        };
                                    }
                                    tmp = {
                                        NAME: "LinkItemContentType",
                                        VAL: {
                                            __typename: value.__typename,
                                            url: tmp$1,
                                            open_in_new_window: tmp$2
                                        }
                                    };
                                } else {
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                                }
                                return tmp;
                            }, value$9) : undefined
                        };
                    }
                    var value$10 = value.background_image;
                    var tmp$5;
                    if (value$10 == null) {
                        tmp$5 = undefined;
                    } else {
                        var value$11 = value$10.value;
                        tmp$5 = {
                            __typename: value$10.__typename,
                            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$11) : undefined
                        };
                    }
                    var value$12 = value.background_image_tablet;
                    var tmp$6;
                    if (value$12 == null) {
                        tmp$6 = undefined;
                    } else {
                        var value$13 = value$12.value;
                        tmp$6 = {
                            __typename: value$12.__typename,
                            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$13) : undefined
                        };
                    }
                    var value$14 = value.background_image_mobile;
                    var tmp$7;
                    if (value$14 == null) {
                        tmp$7 = undefined;
                    } else {
                        var value$15 = value$14.value;
                        tmp$7 = {
                            __typename: value$14.__typename,
                            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? {
                                    NAME: "ImageContentType",
                                    VAL: {
                                        image: $$Image.verifyArgsAndParse("Image", value)
                                    }
                                } : {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                                return tmp;
                            }, value$15) : undefined
                        };
                    }
                    var value$16 = value.background_colour;
                    var tmp$8;
                    if (value$16 == null) {
                        tmp$8 = undefined;
                    } else {
                        var value$17 = value$16.value;
                        tmp$8 = {
                            __typename: value$16.__typename,
                            value: !(value$17 == null) ? value$17 : undefined
                        };
                    }
                    tmp = {
                        NAME: "TestimonialCarouselItemContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            image_asset: tmp$1,
                            quote: tmp$2,
                            author: tmp$3,
                            url: tmp$4,
                            background_image: tmp$5,
                            background_image_tablet: tmp$6,
                            background_image_mobile: tmp$7,
                            background_colour: tmp$8
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        testimonial_image_grid: tmp$1,
        testimonial_carousel_items: tmp$2
    };
}
function Gql_TestimonialCarouselBlock_Fragment_bs_serialize(value) {
    var value$1 = value.testimonial_carousel_items;
    var testimonial_carousel_items;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.background_colour;
            var background_colour;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                background_colour = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                background_colour = null;
            }
            var value$6 = value$1.background_image_mobile;
            var background_image_mobile;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$7) : null;
                var value$9 = value$6.__typename;
                background_image_mobile = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                background_image_mobile = null;
            }
            var value$10 = value$1.background_image_tablet;
            var background_image_tablet;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$11) : null;
                var value$13 = value$10.__typename;
                background_image_tablet = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                background_image_tablet = null;
            }
            var value$14 = value$1.background_image;
            var background_image;
            if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value !== undefined) {
                        if (value.NAME === "UnspecifiedFragment") {
                            return {};
                        } else {
                            return js_array/* reduce */.u4(deepMerge, function(prim) {
                                return {};
                            }, [
                                $$Image.serialize(value.VAL.image)
                            ]);
                        }
                    } else {
                        return null;
                    }
                }, value$15) : null;
                var value$17 = value$14.__typename;
                background_image = {
                    __typename: value$17,
                    value: value$16
                };
            } else {
                background_image = null;
            }
            var value$18 = value$1.url;
            var url;
            if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    }
                    var value$1 = value.VAL;
                    var value$2 = value$1.open_in_new_window;
                    var open_in_new_window;
                    if (value$2 !== undefined) {
                        var value$3 = value$2.value;
                        var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                            if (value === undefined) {
                                return null;
                            }
                            var value$1 = value.codename;
                            var codename = value$1 !== undefined ? value$1 : null;
                            var value$2 = value.__typename;
                            return {
                                __typename: value$2,
                                codename: codename
                            };
                        }, value$3) : null;
                        var value$5 = value$2.__typename;
                        open_in_new_window = {
                            __typename: value$5,
                            value: value$4
                        };
                    } else {
                        open_in_new_window = null;
                    }
                    var value$6 = value$1.url;
                    var url;
                    if (value$6 !== undefined) {
                        var value$7 = value$6.value;
                        var value$8 = value$7 !== undefined ? value$7 : null;
                        var value$9 = value$6.__typename;
                        url = {
                            __typename: value$9,
                            value: value$8
                        };
                    } else {
                        url = null;
                    }
                    return {
                        __typename: "LinkItemContentType",
                        url: url,
                        open_in_new_window: open_in_new_window
                    };
                }, value$19) : null;
                var value$21 = value$18.__typename;
                url = {
                    __typename: value$21,
                    value: value$20
                };
            } else {
                url = null;
            }
            var value$22 = value$1.author;
            var author;
            if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? value$23 : null;
                var value$25 = value$22.__typename;
                author = {
                    __typename: value$25,
                    value: value$24
                };
            } else {
                author = null;
            }
            var value$26 = value$1.quote;
            var quote;
            if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? value$27 : null;
                var value$29 = value$26.__typename;
                quote = {
                    __typename: value$29,
                    value: value$28
                };
            } else {
                quote = null;
            }
            var value$30 = value$1.image_asset;
            var image_asset;
            if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$31) : null;
                var value$33 = value$30.__typename;
                image_asset = {
                    __typename: value$33,
                    value: value$32
                };
            } else {
                image_asset = null;
            }
            var value$34 = value$1.system;
            var value$35 = value$34.codename;
            var value$36 = value$34.id;
            var value$37 = value$34.__typename;
            var system = {
                __typename: value$37,
                id: value$36,
                codename: value$35
            };
            return {
                __typename: "TestimonialCarouselItemContentType",
                system: system,
                image_asset: image_asset,
                quote: quote,
                author: author,
                url: url,
                background_image: background_image,
                background_image_tablet: background_image_tablet,
                background_image_mobile: background_image_mobile,
                background_colour: background_colour
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        testimonial_carousel_items = {
            __typename: value$4,
            value: value$3
        };
    } else {
        testimonial_carousel_items = null;
    }
    var value$5 = value.testimonial_image_grid;
    var testimonial_image_grid;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "ImageCollectionContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        ImageCollection.serialize(value.VAL.imageCollection)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        testimonial_image_grid = {
            __typename: value$8,
            value: value$7
        };
    } else {
        testimonial_image_grid = null;
    }
    var value$9 = value.title;
    var title;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        title = {
            __typename: value$12,
            value: value$11
        };
    } else {
        title = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        title: title,
        testimonial_image_grid: testimonial_image_grid,
        testimonial_carousel_items: testimonial_carousel_items
    };
}
function Gql_TestimonialCarouselBlock_Fragment_bs_verifyArgsAndParse(_TestimonialCarouselBlock, value) {
    return Gql_TestimonialCarouselBlock_Fragment_bs_parse(value);
}
function Gql_TestimonialCarouselBlock_Fragment_bs_verifyName(param) {}
var TestimonialCarouselBlock = {
    Raw: Gql_TestimonialCarouselBlock_Fragment_bs_Raw,
    query: Gql_TestimonialCarouselBlock_Fragment_bs_query,
    parse: Gql_TestimonialCarouselBlock_Fragment_bs_parse,
    serialize: Gql_TestimonialCarouselBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_TestimonialCarouselBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_TestimonialCarouselBlock_Fragment_bs_verifyName
};
var Gql_TestimonialCarouselBlock_Fragment_bs_ImageCollection;
var Gql_TestimonialCarouselBlock_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/UniqueSellingPointsBlock/Gql__UniqueSellingPointsBlock__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_UniqueSellingPointsBlock_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment UniqueSellingPointsBlock on UniqueSellingPointsBlockContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    tagline  {\n      __typename\n      value\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    background_image  {\n      __typename\n      value  {\n        __typename\n        ...on ImageContentType   {\n          ...Image\n        }\n      }\n    }\n    background_image_position  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    unique_selling_points  {\n      __typename\n      value  {\n        __typename\n        ...on UniqueSellingPointContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          icon_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n          fontawesome_icon_class  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_UniqueSellingPointsBlock_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_UniqueSellingPointsBlock_Fragment_bs_Raw = {};
var Gql_UniqueSellingPointsBlock_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_UniqueSellingPointsBlock_Fragment_bs_templateObject(), frag_0);
}($$Image.query);
function Gql_UniqueSellingPointsBlock_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.tagline;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.title;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.background_image;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "ImageContentType" ? {
                    NAME: "ImageContentType",
                    VAL: {
                        image: $$Image.verifyArgsAndParse("Image", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    var value$10 = value.background_image_position;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$11) : undefined
        };
    }
    var value$12 = value.unique_selling_points;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "UniqueSellingPointContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.icon_asset;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$5) : undefined
                        };
                    }
                    var value$6 = value.fontawesome_icon_class;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    tmp = {
                        NAME: "UniqueSellingPointContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            icon_asset: tmp$2,
                            fontawesome_icon_class: tmp$3
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$13) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        tagline: tmp,
        title: tmp$1,
        description: tmp$2,
        background_image: tmp$3,
        background_image_position: tmp$4,
        unique_selling_points: tmp$5
    };
}
function Gql_UniqueSellingPointsBlock_Fragment_bs_serialize(value) {
    var value$1 = value.unique_selling_points;
    var unique_selling_points;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.fontawesome_icon_class;
            var fontawesome_icon_class;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                fontawesome_icon_class = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                fontawesome_icon_class = null;
            }
            var value$6 = value$1.icon_asset;
            var icon_asset;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$7) : null;
                var value$9 = value$6.__typename;
                icon_asset = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                icon_asset = null;
            }
            var value$10 = value$1.title;
            var title;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                title = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                title = null;
            }
            var value$14 = value$1.system;
            var value$15 = value$14.codename;
            var value$16 = value$14.id;
            var value$17 = value$14.__typename;
            var system = {
                __typename: value$17,
                id: value$16,
                codename: value$15
            };
            return {
                __typename: "UniqueSellingPointContentType",
                system: system,
                title: title,
                icon_asset: icon_asset,
                fontawesome_icon_class: fontawesome_icon_class
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        unique_selling_points = {
            __typename: value$4,
            value: value$3
        };
    } else {
        unique_selling_points = null;
    }
    var value$5 = value.background_image_position;
    var background_image_position;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        background_image_position = {
            __typename: value$8,
            value: value$7
        };
    } else {
        background_image_position = null;
    }
    var value$9 = value.background_image;
    var background_image;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        $$Image.serialize(value.VAL.image)
                    ]);
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        background_image = {
            __typename: value$12,
            value: value$11
        };
    } else {
        background_image = null;
    }
    var value$13 = value.description;
    var description;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        description = {
            __typename: value$16,
            value: value$15
        };
    } else {
        description = null;
    }
    var value$17 = value.title;
    var title;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        title = {
            __typename: value$20,
            value: value$19
        };
    } else {
        title = null;
    }
    var value$21 = value.tagline;
    var tagline;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        tagline = {
            __typename: value$24,
            value: value$23
        };
    } else {
        tagline = null;
    }
    var value$25 = value.system;
    var value$26 = value$25.codename;
    var value$27 = value$25.id;
    var value$28 = value$25.__typename;
    var system = {
        __typename: value$28,
        id: value$27,
        codename: value$26
    };
    var value$29 = value.__typename;
    return {
        __typename: value$29,
        system: system,
        tagline: tagline,
        title: title,
        description: description,
        background_image: background_image,
        background_image_position: background_image_position,
        unique_selling_points: unique_selling_points
    };
}
function Gql_UniqueSellingPointsBlock_Fragment_bs_verifyArgsAndParse(_UniqueSellingPointsBlock, value) {
    return Gql_UniqueSellingPointsBlock_Fragment_bs_parse(value);
}
function Gql_UniqueSellingPointsBlock_Fragment_bs_verifyName(param) {}
var UniqueSellingPointsBlock = {
    Raw: Gql_UniqueSellingPointsBlock_Fragment_bs_Raw,
    query: Gql_UniqueSellingPointsBlock_Fragment_bs_query,
    parse: Gql_UniqueSellingPointsBlock_Fragment_bs_parse,
    serialize: Gql_UniqueSellingPointsBlock_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_UniqueSellingPointsBlock_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_UniqueSellingPointsBlock_Fragment_bs_verifyName
};
var Gql_UniqueSellingPointsBlock_Fragment_bs_$$Image;
var Gql_UniqueSellingPointsBlock_Fragment_bs_Icon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/PageBuilder/Gql__PageBuilder__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_PageBuilder_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment PageContent on PageBuilderContentType   {\n    __typename\n    system  {\n      __typename\n      codename\n      language\n    }\n    seo_meta  {\n      __typename\n      value  {\n        __typename\n        ...on SeoMetaContentType   {\n          ...SeoMetaBlock\n        }\n      }\n    }\n    store_content  {\n      __typename\n      value  {\n        __typename\n        ...on StoreContentContentType   {\n          ...StoreContentBlock\n        }\n      }\n    }\n    content_blocks  {\n      __typename\n      value  {\n        __typename\n        ...on CategoryTileBlockContentType   {\n          ...CategoryTileBlock\n        }\n        ...on AppDownloadBlockContentType   {\n          ...AppDownloadBlock\n        }\n        ...on FullWidthTextBlockContentType   {\n          ...FullWidthTextBlock\n        }\n        ...on EmailSignUpBlockContentType   {\n          ...NewsletterBlock\n        }\n        ...on HeroTileBlockContentType   {\n          ...HeroTileBlock\n        }\n        ...on UniqueSellingPointsBlockContentType   {\n          ...UniqueSellingPointsBlock\n        }\n        ...on PromoTileBlockContentType   {\n          ...PromoTileBlock\n        }\n        ...on EnvironmentalImpactsBlockContentType   {\n          ...StatsTilesBlock\n        }\n        ...on VideoTextPromoBoxContentType   {\n          ...VideoTextPromoBlock\n        }\n        ...on SkuCarouselBlockContentType   {\n          ...SkuCarouselBlock\n        }\n        ...on TeamMembersBlockContentType   {\n          ...TeamMembersBlock\n        }\n        ...on CustomerCareBannerContentType   {\n          ...CustomerCareBannerBlock\n        }\n        ...on CustomerCareCallUsContentType   {\n          ...CustomerCareCallUsBlock\n        }\n        ...on BoardOfDirectorsBlockContentType   {\n          ...BoardOfDirectorsBlock\n        }\n        ...on FullWidthHeroContentType   {\n          ...FullWidthHeroBannerBlock\n        }\n        ...on InnovativeWayToGiftContentType   {\n          ...InnovativeWayToGiftBlock\n        }\n        ...on IconCardBlockContentType   {\n          ...IconCardBlock\n        }\n        ...on TheGiftExperienceContentType   {\n          ...GiftExperienceBlock\n        }\n        ...on TestimonialCarouselBlockContentType   {\n          ...TestimonialCarouselBlock\n        }\n        ...on BusinessContactFormContentType   {\n          ...BusinessContactFormBlock\n        }\n        ...on AutomateAndSimplifyContentType   {\n          ...AutomateSimplifyBlock\n        }\n        ...on OffsetTilesBlockContentType   {\n          ...OffsetTilesBlock\n        }\n        ...on FaqBlockContentType   {\n          ...FAQBlock\n        }\n        ...on LandingPageContactFormContentType   {\n          ...LandingPageContactFormBlock\n        }\n        ...on EnrichedTextBlockContentType   {\n          ...EnrichedTextBlock\n        }\n        ...on TrustpilotWidgetBlockContentType   {\n          ...TrustpilotWidgetBlock\n        }\n        ...on NarrowBannerFullContentType   {\n          ...NarrowBannerFull\n        }\n        ...on HeroBannerContentType   {\n          ...HeroBanner\n        }\n        ...on ProductHeroBlockContentType   {\n          ...ProductHeroBlock\n        }\n        ...on SellingPointsBlockContentType   {\n          ...SellingPointsBlock\n        }\n        ...on NarrowCtaContentType   {\n          ...NarrowCta\n        }\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_PageBuilder_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



































var Gql_PageBuilder_Fragment_bs_Raw = {};
var Gql_PageBuilder_Fragment_bs_query = function(frag_0, frag_1, frag_2, frag_3, frag_4, frag_5, frag_6, frag_7, frag_8, frag_9, frag_10, frag_11, frag_12, frag_13, frag_14, frag_15, frag_16, frag_17, frag_18, frag_19, frag_20, frag_21, frag_22, frag_23, frag_24, frag_25, frag_26, frag_27, frag_28, frag_29, frag_30, frag_31, frag_32) {
    return (__webpack_require__(46829).gql)(Gql_PageBuilder_Fragment_bs_templateObject(), frag_0, frag_1, frag_2, frag_3, frag_4, frag_5, frag_6, frag_7, frag_8, frag_9, frag_10, frag_11, frag_12, frag_13, frag_14, frag_15, frag_16, frag_17, frag_18, frag_19, frag_20, frag_21, frag_22, frag_23, frag_24, frag_25, frag_26, frag_27, frag_28, frag_29, frag_30, frag_31, frag_32);
}(AppDownloadBlock.query, AutomateSimplifyBlock.query, BoardOfDirectorsBlock.query, BusinessContactFormBlock.query, CategoryTileBlock.query, CustomerCareBannerBlock.query, CustomerCareCallUsBlock.query, EnrichedTextBlock.query, FAQBlock.query, FullWidthHeroBannerBlock.query, FullWidthTextBlock.query, GiftExperienceBlock.query, HeroBanner.query, HeroTileBlock.query, IconCardBlock.query, InnovativeWayToGiftBlock.query, LandingPageContactFormBlock.query, NarrowBannerFull.query, NarrowCta.query, NewsletterBlock.query, OffsetTilesBlock.query, ProductHeroBlock.query, PromoTileBlock.query, SellingPointsBlock.query, SeoMetaBlock.query, SkuCarouselBlock.query, StatsTilesBlock.query, StoreContentBlock.query, TeamMembersBlock.query, TestimonialCarouselBlock.query, TrustpilotWidgetBlock.query, UniqueSellingPointsBlock.query, VideoTextPromoBlock.query);
function Gql_PageBuilder_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.seo_meta;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "SeoMetaContentType" ? {
                    NAME: "SeoMetaContentType",
                    VAL: {
                        seoMetaBlock: SeoMetaBlock.verifyArgsAndParse("SeoMetaBlock", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$3) : undefined
        };
    }
    var value$4 = value.store_content;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "StoreContentContentType" ? {
                    NAME: "StoreContentContentType",
                    VAL: {
                        storeContentBlock: StoreContentBlock.verifyArgsAndParse("StoreContentBlock", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.content_blocks;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                switch(typename){
                    case "AppDownloadBlockContentType":
                        tmp = {
                            NAME: "AppDownloadBlockContentType",
                            VAL: {
                                appDownloadBlock: AppDownloadBlock.verifyArgsAndParse("AppDownloadBlock", value)
                            }
                        };
                        break;
                    case "AutomateAndSimplifyContentType":
                        tmp = {
                            NAME: "AutomateAndSimplifyContentType",
                            VAL: {
                                automateSimplifyBlock: AutomateSimplifyBlock.verifyArgsAndParse("AutomateSimplifyBlock", value)
                            }
                        };
                        break;
                    case "BoardOfDirectorsBlockContentType":
                        tmp = {
                            NAME: "BoardOfDirectorsBlockContentType",
                            VAL: {
                                boardOfDirectorsBlock: BoardOfDirectorsBlock.verifyArgsAndParse("BoardOfDirectorsBlock", value)
                            }
                        };
                        break;
                    case "BusinessContactFormContentType":
                        tmp = {
                            NAME: "BusinessContactFormContentType",
                            VAL: {
                                businessContactFormBlock: BusinessContactFormBlock.verifyArgsAndParse("BusinessContactFormBlock", value)
                            }
                        };
                        break;
                    case "CategoryTileBlockContentType":
                        tmp = {
                            NAME: "CategoryTileBlockContentType",
                            VAL: {
                                categoryTileBlock: CategoryTileBlock.verifyArgsAndParse("CategoryTileBlock", value)
                            }
                        };
                        break;
                    case "CustomerCareBannerContentType":
                        tmp = {
                            NAME: "CustomerCareBannerContentType",
                            VAL: {
                                customerCareBannerBlock: CustomerCareBannerBlock.verifyArgsAndParse("CustomerCareBannerBlock", value)
                            }
                        };
                        break;
                    case "CustomerCareCallUsContentType":
                        tmp = {
                            NAME: "CustomerCareCallUsContentType",
                            VAL: {
                                customerCareCallUsBlock: CustomerCareCallUsBlock.verifyArgsAndParse("CustomerCareCallUsBlock", value)
                            }
                        };
                        break;
                    case "EmailSignUpBlockContentType":
                        tmp = {
                            NAME: "EmailSignUpBlockContentType",
                            VAL: {
                                newsletterBlock: NewsletterBlock.verifyArgsAndParse("NewsletterBlock", value)
                            }
                        };
                        break;
                    case "EnrichedTextBlockContentType":
                        tmp = {
                            NAME: "EnrichedTextBlockContentType",
                            VAL: {
                                enrichedTextBlock: EnrichedTextBlock.verifyArgsAndParse("EnrichedTextBlock", value)
                            }
                        };
                        break;
                    case "EnvironmentalImpactsBlockContentType":
                        tmp = {
                            NAME: "EnvironmentalImpactsBlockContentType",
                            VAL: {
                                statsTilesBlock: StatsTilesBlock.verifyArgsAndParse("StatsTilesBlock", value)
                            }
                        };
                        break;
                    case "FaqBlockContentType":
                        tmp = {
                            NAME: "FaqBlockContentType",
                            VAL: {
                                fAQBlock: FAQBlock.verifyArgsAndParse("FAQBlock", value)
                            }
                        };
                        break;
                    case "FullWidthHeroContentType":
                        tmp = {
                            NAME: "FullWidthHeroContentType",
                            VAL: {
                                fullWidthHeroBannerBlock: FullWidthHeroBannerBlock.verifyArgsAndParse("FullWidthHeroBannerBlock", value)
                            }
                        };
                        break;
                    case "FullWidthTextBlockContentType":
                        tmp = {
                            NAME: "FullWidthTextBlockContentType",
                            VAL: {
                                fullWidthTextBlock: FullWidthTextBlock.verifyArgsAndParse("FullWidthTextBlock", value)
                            }
                        };
                        break;
                    case "HeroBannerContentType":
                        tmp = {
                            NAME: "HeroBannerContentType",
                            VAL: {
                                heroBanner: HeroBanner.verifyArgsAndParse("HeroBanner", value)
                            }
                        };
                        break;
                    case "HeroTileBlockContentType":
                        tmp = {
                            NAME: "HeroTileBlockContentType",
                            VAL: {
                                heroTileBlock: HeroTileBlock.verifyArgsAndParse("HeroTileBlock", value)
                            }
                        };
                        break;
                    case "IconCardBlockContentType":
                        tmp = {
                            NAME: "IconCardBlockContentType",
                            VAL: {
                                iconCardBlock: IconCardBlock.verifyArgsAndParse("IconCardBlock", value)
                            }
                        };
                        break;
                    case "InnovativeWayToGiftContentType":
                        tmp = {
                            NAME: "InnovativeWayToGiftContentType",
                            VAL: {
                                innovativeWayToGiftBlock: InnovativeWayToGiftBlock.verifyArgsAndParse("InnovativeWayToGiftBlock", value)
                            }
                        };
                        break;
                    case "LandingPageContactFormContentType":
                        tmp = {
                            NAME: "LandingPageContactFormContentType",
                            VAL: {
                                landingPageContactFormBlock: LandingPageContactFormBlock.verifyArgsAndParse("LandingPageContactFormBlock", value)
                            }
                        };
                        break;
                    case "NarrowBannerFullContentType":
                        tmp = {
                            NAME: "NarrowBannerFullContentType",
                            VAL: {
                                narrowBannerFull: NarrowBannerFull.verifyArgsAndParse("NarrowBannerFull", value)
                            }
                        };
                        break;
                    case "NarrowCtaContentType":
                        tmp = {
                            NAME: "NarrowCtaContentType",
                            VAL: {
                                narrowCta: NarrowCta.verifyArgsAndParse("NarrowCta", value)
                            }
                        };
                        break;
                    case "OffsetTilesBlockContentType":
                        tmp = {
                            NAME: "OffsetTilesBlockContentType",
                            VAL: {
                                offsetTilesBlock: OffsetTilesBlock.verifyArgsAndParse("OffsetTilesBlock", value)
                            }
                        };
                        break;
                    case "ProductHeroBlockContentType":
                        tmp = {
                            NAME: "ProductHeroBlockContentType",
                            VAL: {
                                productHeroBlock: ProductHeroBlock.verifyArgsAndParse("ProductHeroBlock", value)
                            }
                        };
                        break;
                    case "PromoTileBlockContentType":
                        tmp = {
                            NAME: "PromoTileBlockContentType",
                            VAL: {
                                promoTileBlock: PromoTileBlock.verifyArgsAndParse("PromoTileBlock", value)
                            }
                        };
                        break;
                    case "SellingPointsBlockContentType":
                        tmp = {
                            NAME: "SellingPointsBlockContentType",
                            VAL: {
                                sellingPointsBlock: SellingPointsBlock.verifyArgsAndParse("SellingPointsBlock", value)
                            }
                        };
                        break;
                    case "SkuCarouselBlockContentType":
                        tmp = {
                            NAME: "SkuCarouselBlockContentType",
                            VAL: {
                                skuCarouselBlock: SkuCarouselBlock.verifyArgsAndParse("SkuCarouselBlock", value)
                            }
                        };
                        break;
                    case "TeamMembersBlockContentType":
                        tmp = {
                            NAME: "TeamMembersBlockContentType",
                            VAL: {
                                teamMembersBlock: TeamMembersBlock.verifyArgsAndParse("TeamMembersBlock", value)
                            }
                        };
                        break;
                    case "TestimonialCarouselBlockContentType":
                        tmp = {
                            NAME: "TestimonialCarouselBlockContentType",
                            VAL: {
                                testimonialCarouselBlock: TestimonialCarouselBlock.verifyArgsAndParse("TestimonialCarouselBlock", value)
                            }
                        };
                        break;
                    case "TheGiftExperienceContentType":
                        tmp = {
                            NAME: "TheGiftExperienceContentType",
                            VAL: {
                                giftExperienceBlock: GiftExperienceBlock.verifyArgsAndParse("GiftExperienceBlock", value)
                            }
                        };
                        break;
                    case "TrustpilotWidgetBlockContentType":
                        tmp = {
                            NAME: "TrustpilotWidgetBlockContentType",
                            VAL: {
                                trustpilotWidgetBlock: TrustpilotWidgetBlock.verifyArgsAndParse("TrustpilotWidgetBlock", value)
                            }
                        };
                        break;
                    case "UniqueSellingPointsBlockContentType":
                        tmp = {
                            NAME: "UniqueSellingPointsBlockContentType",
                            VAL: {
                                uniqueSellingPointsBlock: UniqueSellingPointsBlock.verifyArgsAndParse("UniqueSellingPointsBlock", value)
                            }
                        };
                        break;
                    case "VideoTextPromoBoxContentType":
                        tmp = {
                            NAME: "VideoTextPromoBoxContentType",
                            VAL: {
                                videoTextPromoBlock: VideoTextPromoBlock.verifyArgsAndParse("VideoTextPromoBlock", value)
                            }
                        };
                        break;
                    default:
                        tmp = {
                            NAME: "UnspecifiedFragment",
                            VAL: typename
                        };
                }
                return tmp;
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            codename: value$1.codename,
            language: value$1.language
        },
        seo_meta: tmp,
        store_content: tmp$1,
        content_blocks: tmp$2
    };
}
function Gql_PageBuilder_Fragment_bs_serialize(value) {
    var value$1 = value.content_blocks;
    var content_blocks;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var variant = value.NAME;
            if (variant === "OffsetTilesBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    OffsetTilesBlock.serialize(value.VAL.offsetTilesBlock)
                ]);
            } else if (variant === "FaqBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    FAQBlock.serialize(value.VAL.fAQBlock)
                ]);
            } else if (variant === "TestimonialCarouselBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    TestimonialCarouselBlock.serialize(value.VAL.testimonialCarouselBlock)
                ]);
            } else if (variant === "IconCardBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    IconCardBlock.serialize(value.VAL.iconCardBlock)
                ]);
            } else if (variant === "SellingPointsBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    SellingPointsBlock.serialize(value.VAL.sellingPointsBlock)
                ]);
            } else if (variant === "CategoryTileBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    CategoryTileBlock.serialize(value.VAL.categoryTileBlock)
                ]);
            } else if (variant === "HeroBannerContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    HeroBanner.serialize(value.VAL.heroBanner)
                ]);
            } else if (variant === "ProductHeroBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    ProductHeroBlock.serialize(value.VAL.productHeroBlock)
                ]);
            } else if (variant === "TeamMembersBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    TeamMembersBlock.serialize(value.VAL.teamMembersBlock)
                ]);
            } else if (variant === "LandingPageContactFormContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    LandingPageContactFormBlock.serialize(value.VAL.landingPageContactFormBlock)
                ]);
            } else if (variant === "CustomerCareCallUsContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    CustomerCareCallUsBlock.serialize(value.VAL.customerCareCallUsBlock)
                ]);
            } else if (variant === "EnvironmentalImpactsBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    StatsTilesBlock.serialize(value.VAL.statsTilesBlock)
                ]);
            } else if (variant === "VideoTextPromoBoxContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    VideoTextPromoBlock.serialize(value.VAL.videoTextPromoBlock)
                ]);
            } else if (variant === "PromoTileBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    PromoTileBlock.serialize(value.VAL.promoTileBlock)
                ]);
            } else if (variant === "SkuCarouselBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    SkuCarouselBlock.serialize(value.VAL.skuCarouselBlock)
                ]);
            } else if (variant === "AppDownloadBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    AppDownloadBlock.serialize(value.VAL.appDownloadBlock)
                ]);
            } else if (variant === "BusinessContactFormContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    BusinessContactFormBlock.serialize(value.VAL.businessContactFormBlock)
                ]);
            } else if (variant === "InnovativeWayToGiftContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    InnovativeWayToGiftBlock.serialize(value.VAL.innovativeWayToGiftBlock)
                ]);
            } else if (variant === "EmailSignUpBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    NewsletterBlock.serialize(value.VAL.newsletterBlock)
                ]);
            } else if (variant === "UnspecifiedFragment") {
                return {};
            } else if (variant === "NarrowBannerFullContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    NarrowBannerFull.serialize(value.VAL.narrowBannerFull)
                ]);
            } else if (variant === "FullWidthTextBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    FullWidthTextBlock.serialize(value.VAL.fullWidthTextBlock)
                ]);
            } else if (variant === "TheGiftExperienceContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    GiftExperienceBlock.serialize(value.VAL.giftExperienceBlock)
                ]);
            } else if (variant === "FullWidthHeroContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    FullWidthHeroBannerBlock.serialize(value.VAL.fullWidthHeroBannerBlock)
                ]);
            } else if (variant === "BoardOfDirectorsBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    BoardOfDirectorsBlock.serialize(value.VAL.boardOfDirectorsBlock)
                ]);
            } else if (variant === "AutomateAndSimplifyContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    AutomateSimplifyBlock.serialize(value.VAL.automateSimplifyBlock)
                ]);
            } else if (variant === "UniqueSellingPointsBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    UniqueSellingPointsBlock.serialize(value.VAL.uniqueSellingPointsBlock)
                ]);
            } else if (variant === "TrustpilotWidgetBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    TrustpilotWidgetBlock.serialize(value.VAL.trustpilotWidgetBlock)
                ]);
            } else if (variant === "CustomerCareBannerContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    CustomerCareBannerBlock.serialize(value.VAL.customerCareBannerBlock)
                ]);
            } else if (variant === "EnrichedTextBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    EnrichedTextBlock.serialize(value.VAL.enrichedTextBlock)
                ]);
            } else if (variant === "HeroTileBlockContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    HeroTileBlock.serialize(value.VAL.heroTileBlock)
                ]);
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    NarrowCta.serialize(value.VAL.narrowCta)
                ]);
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        content_blocks = {
            __typename: value$4,
            value: value$3
        };
    } else {
        content_blocks = null;
    }
    var value$5 = value.store_content;
    var store_content;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        StoreContentBlock.serialize(value.VAL.storeContentBlock)
                    ]);
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        store_content = {
            __typename: value$8,
            value: value$7
        };
    } else {
        store_content = null;
    }
    var value$9 = value.seo_meta;
    var seo_meta;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "SeoMetaContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        SeoMetaBlock.serialize(value.VAL.seoMetaBlock)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$10) : null;
        var value$12 = value$9.__typename;
        seo_meta = {
            __typename: value$12,
            value: value$11
        };
    } else {
        seo_meta = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.language;
    var value$15 = value$13.codename;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        codename: value$15,
        language: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        seo_meta: seo_meta,
        store_content: store_content,
        content_blocks: content_blocks
    };
}
function Gql_PageBuilder_Fragment_bs_verifyArgsAndParse(_PageContent, value) {
    return Gql_PageBuilder_Fragment_bs_parse(value);
}
function Gql_PageBuilder_Fragment_bs_verifyName(param) {}
var PageContent = {
    Raw: Gql_PageBuilder_Fragment_bs_Raw,
    query: Gql_PageBuilder_Fragment_bs_query,
    parse: Gql_PageBuilder_Fragment_bs_parse,
    serialize: Gql_PageBuilder_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_PageBuilder_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_PageBuilder_Fragment_bs_verifyName
};
var Gql_PageBuilder_Fragment_bs_CategoryTileBlock;
var Gql_PageBuilder_Fragment_bs_AppDownloadBlock;
var Gql_PageBuilder_Fragment_bs_FullWidthTextBlock;
var Gql_PageBuilder_Fragment_bs_NewsletterBlock;
var Gql_PageBuilder_Fragment_bs_HeroTileBlock;
var Gql_PageBuilder_Fragment_bs_UniqueSellingPointsBlock;
var Gql_PageBuilder_Fragment_bs_PromoTileBlock;
var Gql_PageBuilder_Fragment_bs_StatsTilesBlock;
var Gql_PageBuilder_Fragment_bs_VideoTextPromoBlock;
var Gql_PageBuilder_Fragment_bs_SkuCarouselBlock;
var Gql_PageBuilder_Fragment_bs_TeamMembersBlock;
var Gql_PageBuilder_Fragment_bs_CustomerCareBannerBlock;
var Gql_PageBuilder_Fragment_bs_CustomerCareCallUsBlock;
var Gql_PageBuilder_Fragment_bs_BoardOfDirectorsBlock;
var Gql_PageBuilder_Fragment_bs_FullWidthHeroBannerBlock;
var Gql_PageBuilder_Fragment_bs_InnovativeWayToGiftBlock;
var Gql_PageBuilder_Fragment_bs_IconCardBlock;
var Gql_PageBuilder_Fragment_bs_GiftExperienceBlock;
var Gql_PageBuilder_Fragment_bs_TestimonialCarouselBlock;
var Gql_PageBuilder_Fragment_bs_BusinessContactFormBlock;
var Gql_PageBuilder_Fragment_bs_AutomateSimplifyBlock;
var Gql_PageBuilder_Fragment_bs_OffsetTilesBlock;
var Gql_PageBuilder_Fragment_bs_FAQBlock;
var Gql_PageBuilder_Fragment_bs_LandingPageContactFormBlock;
var Gql_PageBuilder_Fragment_bs_SeoMetaBlock;
var Gql_PageBuilder_Fragment_bs_StoreContentBlock;
var Gql_PageBuilder_Fragment_bs_EnrichedTextBlock;
var Gql_PageBuilder_Fragment_bs_TrustpilotWidgetBlock;
var Gql_PageBuilder_Fragment_bs_NarrowBannerFull;
var Gql_PageBuilder_Fragment_bs_ProductHeroBlock;
var Gql_PageBuilder_Fragment_bs_SellingPointsBlock;
var Gql_PageBuilder_Fragment_bs_NarrowCta;
var Gql_PageBuilder_Fragment_bs_HeroBanner;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Page/Gql__Page__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Page_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query PageContent($language: String!, $preview: Boolean, $url: String!)  {\n    itemsByType(type: "page", limit: 1, depth: 5, language: $language, preview: $preview, filters: [{type: EQUALS, prop: "elements.url", val: $url}])  {\n      __typename\n      ...on PageContentType   {\n        __typename\n        content  {\n          __typename\n          value  {\n            __typename\n            ...on PageBuilderContentType   {\n              ...PageContent\n            }\n          }\n        }\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    Gql_Page_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_Page_Query_bs_Raw = {};
var Gql_Page_Query_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_Page_Query_bs_templateObject(), frag_0);
}(PageContent.query);
function Gql_Page_Query_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "PageContentType") {
                var value$1 = value.content;
                var tmp$1;
                if (value$1 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$2 = value$1.value;
                    tmp$1 = {
                        __typename: value$1.__typename,
                        value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "PageBuilderContentType" ? {
                                NAME: "PageBuilderContentType",
                                VAL: {
                                    pageContent: PageContent.verifyArgsAndParse("PageContent", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$2) : undefined
                    };
                }
                tmp = {
                    NAME: "PageContentType",
                    VAL: {
                        __typename: value.__typename,
                        content: tmp$1
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_Page_Query_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME === "UnspecifiedFragment") {
            return {};
        }
        var value$1 = value.VAL.content;
        var content;
        if (value$1 !== undefined) {
            var value$2 = value$1.value;
            var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            PageContent.serialize(value.VAL.pageContent)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$2) : null;
            var value$4 = value$1.__typename;
            content = {
                __typename: value$4,
                value: value$3
            };
        } else {
            content = null;
        }
        return {
            __typename: "PageContentType",
            content: content
        };
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        url: inp.url
    };
}
function makeVariables(language, preview, url, param) {
    return {
        language: language,
        preview: preview,
        url: url
    };
}
var Query_inner = {
    Raw: Gql_Page_Query_bs_Raw,
    query: Gql_Page_Query_bs_query,
    parse: Gql_Page_Query_bs_parse,
    serialize: Gql_Page_Query_bs_serialize,
    serializeVariables: serializeVariables,
    makeVariables: makeVariables
};
var include = Extend({
    query: Gql_Page_Query_bs_query,
    Raw: Gql_Page_Query_bs_Raw,
    parse: Gql_Page_Query_bs_parse,
    serialize: Gql_Page_Query_bs_serialize,
    serializeVariables: serializeVariables
});
var Query_refetchQueryDescription = include.refetchQueryDescription;
var Query_use = include.use;
var Query_useLazy = include.useLazy;
var Query_useLazyWithVariables = include.useLazyWithVariables;
var Gql_Page_Query_bs_Query = {
    Query_inner: Query_inner,
    Raw: Gql_Page_Query_bs_Raw,
    query: Gql_Page_Query_bs_query,
    parse: Gql_Page_Query_bs_parse,
    serialize: Gql_Page_Query_bs_serialize,
    serializeVariables: serializeVariables,
    makeVariables: makeVariables,
    refetchQueryDescription: Query_refetchQueryDescription,
    use: Query_use,
    useLazy: Query_useLazy,
    useLazyWithVariables: Query_useLazyWithVariables
};
var Gql_Page_Query_bs_PageContent;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Video/Gql__Video__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function get(content) {
    return belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.url, function(c) {
        return c.value;
    }), "");
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FAQ/Gql__FAQ__Decoder__BodyContent.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function Gql_FAQ_Decoder_BodyContent_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    var variant = c.NAME;
    if (variant !== "RichTextBlockContentType") {
        if (variant === "VideoContentType") {
            return {
                NAME: "Video",
                VAL: get(c.VAL.video)
            };
        } else {
            return;
        }
    }
    var content = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.VAL.content, function(c) {
        return c.value;
    }), "");
    return {
        NAME: "RichText",
        VAL: content
    };
}
var Gql_FAQ_Decoder_BodyContent_bs_Video;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FAQ/Gql__FAQ__Decoder__Item.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_FAQ_Decoder_Item_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "FaqItemContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var body_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_text, function(c) {
        return c.value;
    }), "");
    var body_content = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FAQ_Decoder_BodyContent_bs_get);
    var smart_link_itemId = c.system.id;
    var smart_link_codename = c.system.codename;
    var smart_link = {
        itemId: smart_link_itemId,
        codename: smart_link_codename
    };
    return {
        title: title,
        body_text: body_text,
        body_content: body_content,
        smart_link: smart_link
    };
}
var BodyContent;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FAQ/Gql__FAQ__Decoder__Section.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_FAQ_Decoder_Section_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "FaqSectionContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var faq_items = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.faq_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FAQ_Decoder_Item_bs_get);
    var smart_link_itemId = c.system.id;
    var smart_link_codename = c.system.codename;
    var smart_link = {
        itemId: smart_link_itemId,
        codename: smart_link_codename
    };
    return {
        title: title,
        faq_items: faq_items,
        smart_link: smart_link
    };
}
var Item;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FAQ/Gql__FAQ__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_FAQ_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var faq_sections = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.faq_sections, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FAQ_Decoder_Section_bs_get);
    var additionalContent = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.additional_content, function(c) {
        return c.value;
    }), "");
    var smart_link_itemId = c.system.id;
    var smart_link_codename = c.system.codename;
    var smart_link = {
        itemId: smart_link_itemId,
        codename: smart_link_codename
    };
    return {
        title: title,
        faq_sections: faq_sections,
        additionalContent: additionalContent,
        smart_link: smart_link
    };
}
var Section;
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/SeoMetaContentType/Gql__SeoMeta__Decoder.bs.js
var Gql_SeoMeta_Decoder_bs = __webpack_require__(39994);
// EXTERNAL MODULE: ./src/api/graphql/CallToAction/Gql__CallToAction__Decoder.bs.js
var Gql_CallToAction_Decoder_bs = __webpack_require__(93875);
;// CONCATENATED MODULE: ./src/api/graphql/NarrowCta/Gql__NarrowCta__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_NarrowCta_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var backgroundColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_desktop, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$1,
        url: url$1,
        width: width$1,
        height: height$1
    };
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.name;
    }), "");
    var description$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.description;
    }), "");
    var url$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.url;
    }), "");
    var width$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.width;
    }), 0);
    var height$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.height;
    }), 0);
    var result$2 = {
        name: name$2,
        description: description$2,
        url: url$2,
        width: width$2,
        height: height$2
    };
    var cta = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        backgroundColour: backgroundColour,
        bgImageDesktop: result,
        bgImageTablet: result$1,
        bgImageMobile: result$2,
        cta: cta,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__N1ColumnBanner__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_HeroBanner_N1ColumnBanner_Decoder_bs_get(c) {
    var displayBadge = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.display_badge, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "no", function(str) {
        return str;
    });
    var badgeAlignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var badgeTextColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_text_colour, function(c) {
        return c.value;
    }), "");
    var badgeBackgroundColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_background_colour, function(c) {
        return c.value;
    }), "");
    var badgeOutlineColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_outline_colour, function(c) {
        return c.value;
    }), "");
    var badgeText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_text, function(c) {
        return c.value;
    }), "");
    var bgColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var copyBlockAlignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.copy_block_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var imageTreatment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_treatment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "edge_to_edge", function(str) {
        return str;
    });
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var highlightTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.highlight_text_colour, function(c) {
        return c.value;
    }), "");
    var titleFont = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_style, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "sofia_pro", function(str) {
        return str;
    });
    var titleTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_text_colour, function(c) {
        return c.value;
    }), "");
    var titleFontSize = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_size, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "xxl", function(str) {
        return str;
    });
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var descriptionTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_text_colour, function(c) {
        return c.value;
    }), "");
    var descriptionFontSize = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_font_size, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "regular", function(str) {
        return str;
    });
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.buttons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_desktop, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description$1,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$2,
        url: url$1,
        width: width$1,
        height: height$1
    };
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.name;
    }), "");
    var description$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.description;
    }), "");
    var url$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.url;
    }), "");
    var width$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.width;
    }), 0);
    var height$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.height;
    }), 0);
    var result$2 = {
        name: name$2,
        description: description$3,
        url: url$2,
        width: width$2,
        height: height$2
    };
    var value$3 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image__2_desktop, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var imageN2Desktop;
    if (value$3 !== undefined) {
        var name$3 = belt_Option/* getWithDefault */.tj(value$3.name, "");
        var description$4 = belt_Option/* getWithDefault */.tj(value$3.description, "");
        var url$3 = belt_Option/* getWithDefault */.tj(value$3.url, "");
        var width$3 = belt_Option/* getWithDefault */.tj(value$3.width, 0);
        var height$3 = belt_Option/* getWithDefault */.tj(value$3.height, 0);
        imageN2Desktop = {
            name: name$3,
            description: description$4,
            url: url$3,
            width: width$3,
            height: height$3
        };
    } else {
        imageN2Desktop = undefined;
    }
    var value$4 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image__2_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var imageN2Tablet;
    if (value$4 !== undefined) {
        var name$4 = belt_Option/* getWithDefault */.tj(value$4.name, "");
        var description$5 = belt_Option/* getWithDefault */.tj(value$4.description, "");
        var url$4 = belt_Option/* getWithDefault */.tj(value$4.url, "");
        var width$4 = belt_Option/* getWithDefault */.tj(value$4.width, 0);
        var height$4 = belt_Option/* getWithDefault */.tj(value$4.height, 0);
        imageN2Tablet = {
            name: name$4,
            description: description$5,
            url: url$4,
            width: width$4,
            height: height$4
        };
    } else {
        imageN2Tablet = undefined;
    }
    var value$5 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image__2_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var imageN2Mobile;
    if (value$5 !== undefined) {
        var name$5 = belt_Option/* getWithDefault */.tj(value$5.name, "");
        var description$6 = belt_Option/* getWithDefault */.tj(value$5.description, "");
        var url$5 = belt_Option/* getWithDefault */.tj(value$5.url, "");
        var width$5 = belt_Option/* getWithDefault */.tj(value$5.width, 0);
        var height$5 = belt_Option/* getWithDefault */.tj(value$5.height, 0);
        imageN2Mobile = {
            name: name$5,
            description: description$6,
            url: url$5,
            width: width$5,
            height: height$5
        };
    } else {
        imageN2Mobile = undefined;
    }
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        displayBadge: displayBadge,
        badgeAlignment: badgeAlignment,
        badgeText: badgeText,
        badgeTextColor: badgeTextColor,
        badgeBackgroundColor: badgeBackgroundColor,
        badgeOutlineColor: badgeOutlineColor,
        smartLink: smartLink,
        bgColour: bgColour,
        copyBlockAlignment: copyBlockAlignment,
        imageTreatment: imageTreatment,
        title: title,
        highlightTextColour: highlightTextColour,
        titleFont: titleFont,
        titleTextColour: titleTextColour,
        titleFontSize: titleFontSize,
        description: description,
        descriptionTextColour: descriptionTextColour,
        descriptionFontSize: descriptionFontSize,
        buttons: buttons,
        imageDesktop: result,
        imageTablet: result$1,
        imageMobile: result$2,
        imageN2Desktop: imageN2Desktop,
        imageN2Tablet: imageN2Tablet,
        imageN2Mobile: imageN2Mobile
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__N2ColumnBanner__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_HeroBanner_N2ColumnBanner_Decoder_bs_get(c) {
    var displayBadge = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.display_badge, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "no", function(str) {
        return str;
    });
    var badgeAlignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var badgeTextColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_text_colour, function(c) {
        return c.value;
    }), "");
    var badgeBackgroundColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_background_colour, function(c) {
        return c.value;
    }), "");
    var badgeOutlineColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_outline_colour, function(c) {
        return c.value;
    }), "");
    var badgeText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.badge_text, function(c) {
        return c.value;
    }), "");
    var bgColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var bgColour2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour_2, function(c) {
        return c.value;
    }), "");
    var copyBlockAlignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.copy_block_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var copyBlockAlignment2 = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.copy_block_alignment_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var imageTreatment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_treatment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "edge_to_edge", function(str) {
        return str;
    });
    var imageTreatment2 = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_treatment_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "edge_to_edge", function(str) {
        return str;
    });
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var title2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_2, function(c) {
        return c.value;
    }), "");
    var highlightTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.highlight_text_colour, function(c) {
        return c.value;
    }), "");
    var highlightTextColour2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.highlight_text_colour_2, function(c) {
        return c.value;
    }), "");
    var titleFont = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_style, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "sofia_pro", function(str) {
        return str;
    });
    var titleFont2 = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_style_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "sofia_pro", function(str) {
        return str;
    });
    var titleTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_text_colour, function(c) {
        return c.value;
    }), "");
    var titleTextColour2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_text_colour_2, function(c) {
        return c.value;
    }), "");
    var titleFontSize = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_size, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "xxl", function(str) {
        return str;
    });
    var titleFontSize2 = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_font_size_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "xxl", function(str) {
        return str;
    });
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var description2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_2, function(c) {
        return c.value;
    }), "");
    var descriptionTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_text_colour, function(c) {
        return c.value;
    }), "");
    var descriptionTextColour2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_text_colour_2, function(c) {
        return c.value;
    }), "");
    var descriptionFontSize = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_font_size, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "regular", function(str) {
        return str;
    });
    var descriptionFontSize2 = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_font_size_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "regular", function(str) {
        return str;
    });
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta_s, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var buttons2 = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta_s_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description$1,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$2,
        url: url$1,
        width: width$1,
        height: height$1
    };
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.name;
    }), "");
    var description$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.description;
    }), "");
    var url$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.url;
    }), "");
    var width$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.width;
    }), 0);
    var height$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$2, function(f) {
        return f.height;
    }), 0);
    var result$2 = {
        name: name$2,
        description: description$3,
        url: url$2,
        width: width$2,
        height: height$2
    };
    var value$3 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_image_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$3, function(f) {
        return f.name;
    }), "");
    var description$4 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$3, function(f) {
        return f.description;
    }), "");
    var url$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$3, function(f) {
        return f.url;
    }), "");
    var width$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$3, function(f) {
        return f.width;
    }), 0);
    var height$3 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$3, function(f) {
        return f.height;
    }), 0);
    var result$3 = {
        name: name$3,
        description: description$4,
        url: url$3,
        width: width$3,
        height: height$3
    };
    var value$4 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_image_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$4 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$4, function(f) {
        return f.name;
    }), "");
    var description$5 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$4, function(f) {
        return f.description;
    }), "");
    var url$4 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$4, function(f) {
        return f.url;
    }), "");
    var width$4 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$4, function(f) {
        return f.width;
    }), 0);
    var height$4 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$4, function(f) {
        return f.height;
    }), 0);
    var result$4 = {
        name: name$4,
        description: description$5,
        url: url$4,
        width: width$4,
        height: height$4
    };
    var value$5 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_image_2, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$5 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$5, function(f) {
        return f.name;
    }), "");
    var description$6 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$5, function(f) {
        return f.description;
    }), "");
    var url$5 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$5, function(f) {
        return f.url;
    }), "");
    var width$5 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$5, function(f) {
        return f.width;
    }), 0);
    var height$5 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$5, function(f) {
        return f.height;
    }), 0);
    var result$5 = {
        name: name$5,
        description: description$6,
        url: url$5,
        width: width$5,
        height: height$5
    };
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        smartLink: smartLink,
        leftGroup: {
            displayBadge: displayBadge,
            badgeAlignment: badgeAlignment,
            badgeText: badgeText,
            badgeTextColor: badgeTextColor,
            badgeBackgroundColor: badgeBackgroundColor,
            badgeOutlineColor: badgeOutlineColor,
            bgColour: bgColour,
            copyBlockAlignment: copyBlockAlignment,
            imageTreatment: imageTreatment,
            title: title,
            highlightTextColour: highlightTextColour,
            titleFont: titleFont,
            titleTextColour: titleTextColour,
            titleFontSize: titleFontSize,
            description: description,
            descriptionTextColour: descriptionTextColour,
            descriptionFontSize: descriptionFontSize,
            buttons: buttons,
            imageDesktop: result,
            imageTablet: result$1,
            imageMobile: result$2
        },
        rightGroup: {
            bgColour: bgColour2,
            copyBlockAlignment: copyBlockAlignment2,
            imageTreatment: imageTreatment2,
            title: title2,
            highlightTextColour: highlightTextColour2,
            titleFont: titleFont2,
            titleTextColour: titleTextColour2,
            titleFontSize: titleFontSize2,
            description: description2,
            descriptionTextColour: descriptionTextColour2,
            descriptionFontSize: descriptionFontSize2,
            buttons: buttons2,
            imageDesktop: result$3,
            imageTablet: result$4,
            imageMobile: result$5
        }
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroBanner/Gql__HeroBanner__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_HeroBanner_Decoder_bs_get(c) {
    var width = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.width, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "full_width", function(str) {
        return str;
    });
    var isSearchBarOverlay = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.search_bar_overlay, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "no", function(str) {
        return str;
    }) === "yes";
    var isBorderRadius = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.apply_radius, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "no", function(str) {
        return str;
    }) === "yes";
    var n1ColumnBanners = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.n1_column_banner_s, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "N1ColumnHeroBannerContentType") {
            return Gql_HeroBanner_N1ColumnBanner_Decoder_bs_get(f.VAL.n1ColumnHero);
        }
    });
    var n2ColumnBanner = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.n2_column_banner, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "N2ColumnHeroBannerContentType") {
            return Gql_HeroBanner_N2ColumnBanner_Decoder_bs_get(f.VAL.n2ColumnHero);
        }
    }), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        smartLink: smartLink,
        width: width,
        isSearchBarOverlay: isSearchBarOverlay,
        isBorderRadius: isBorderRadius,
        n1ColumnBanners: n1ColumnBanners,
        n2ColumnBanner: n2ColumnBanner
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/EnrichedTextBlock/Gql__EnrichedTextBlock__Decoder.bs.js
var Gql_EnrichedTextBlock_Decoder_bs = __webpack_require__(5290);
;// CONCATENATED MODULE: ./src/api/graphql/SmartCardHeroBlock/Gql__SmartCardHeroBlock__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_SmartCardHeroBlock_Decoder_bs_get(c) {
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(w) {
        return w.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(f) {
        return f.value;
    }), "");
    var primaryButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.primary_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var secondaryButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.secondary_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description$1,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$2,
        url: url$1,
        width: width$1,
        height: height$1
    };
    return {
        smartLink: smartLink,
        title: title,
        description: description,
        primaryButton: primaryButton,
        secondaryButton: secondaryButton,
        image: result,
        mobileImage: result$1
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StoreContentContentType/Gql__StoreContent__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_StoreContent_Decoder_bs_get(content) {
    var smart_card_content = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.smart_card_content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f !== "object") {
            return;
        }
        var variant = f.NAME;
        if (variant === "SmartCardHeroBlockContentType") {
            return {
                NAME: "SmartCardHeroBlock",
                VAL: Gql_SmartCardHeroBlock_Decoder_bs_get(f.VAL.smartCardHeroBlock)
            };
        } else if (variant === "EnrichedTextBlockContentType") {
            return {
                NAME: "EnrichedTextBlock",
                VAL: Gql_EnrichedTextBlock_Decoder_bs/* get */.U(f.VAL.enrichedTextBlock)
            };
        } else {
            return;
        }
    });
    var retailer_card_content = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.retailer_card_content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "EnrichedTextBlockContentType") {
            return Gql_EnrichedTextBlock_Decoder_bs/* get */.U(f.VAL.enrichedTextBlock);
        }
    }), GqlUtils_bs.id), 0);
    var end_of_page_content = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.end_of_page_content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "EnrichedTextBlockContentType") {
            return Gql_EnrichedTextBlock_Decoder_bs/* get */.U(f.VAL.enrichedTextBlock);
        }
    }), GqlUtils_bs.id), 0);
    return {
        smart_card_content: smart_card_content,
        retailer_card_content: retailer_card_content,
        end_of_page_content: end_of_page_content
    };
}
 /* Gql__EnrichedTextBlock__Decoder Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/AutomateSimplify/Gql__AutomateSimplify__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_AutomateSimplify_Decoder_bs_get(c) {
    var heading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.heading, function(c) {
        return c.value;
    }), "");
    var body_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_text, function(c) {
        return c.value;
    }), "");
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta_button_s, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        heading: heading,
        body_text: body_text,
        buttons: buttons,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NarrowBannerFull/Gql__NarrowBannerFull__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_NarrowBannerFull_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(f) {
        return f.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subtitle, function(f) {
        return f.value;
    }), "");
    var alignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var banner_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.banner_colour, function(f) {
        return f.value;
    }), "");
    var banner_height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.banner_height, function(f) {
        return f.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        subtitle: subtitle,
        banner_colour: banner_colour,
        banner_height: banner_height,
        alignment: alignment,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/ProductHeroIcon/Gql__ProductHeroIcon__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_ProductHeroIcon_Decoder_bs_get(c) {
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        icon: result,
        text: text,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/ProductHeroBlock/Gql__ProductHeroBlock__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_ProductHeroBlock_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subtitle, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.enhanced_description, function(c) {
        return c.value;
    }), "");
    var icons = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "ProductHeroIconContentType") {
            return Gql_ProductHeroIcon_Decoder_bs_get(f.VAL.productHeroIcon);
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description$1,
        url: url,
        width: width,
        height: height
    };
    var primaryButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.primary_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var secondaryButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.secondary_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var productSlug = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.product_slug, function(c) {
        return c.value;
    }), "");
    var additionalDescription = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.additional_description, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        subtitle: subtitle,
        description: description,
        icons: icons,
        image: result,
        primaryButton: primaryButton,
        secondaryButton: secondaryButton,
        productSlug: productSlug,
        additionalDescription: additionalDescription,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/CustomerCareBanner/Gql__CustomerCareBanner__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_CustomerCareBanner_Decoder_bs_get(content) {
    var codename = content.system.codename;
    var smartLink_itemId = content.system.id;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: codename
    };
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.title, function(c) {
        return c.value;
    }), "");
    var text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.text, function(c) {
        return c.value;
    }), "");
    var backgroundColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.background_colour, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.banner_asset_desktop, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var bannerImageDesktop;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        bannerImageDesktop = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        bannerImageDesktop = undefined;
    }
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.banner_asset_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var bannerImageTablet;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        bannerImageTablet = {
            name: name$1,
            description: description$1,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        bannerImageTablet = undefined;
    }
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.banner_asset_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var bannerImageMobile;
    if (value$2 !== undefined) {
        var name$2 = belt_Option/* getWithDefault */.tj(value$2.name, "");
        var description$2 = belt_Option/* getWithDefault */.tj(value$2.description, "");
        var url$2 = belt_Option/* getWithDefault */.tj(value$2.url, "");
        var width$2 = belt_Option/* getWithDefault */.tj(value$2.width, 0);
        var height$2 = belt_Option/* getWithDefault */.tj(value$2.height, 0);
        bannerImageMobile = {
            name: name$2,
            description: description$2,
            url: url$2,
            width: width$2,
            height: height$2
        };
    } else {
        bannerImageMobile = undefined;
    }
    var address = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.address, function(c) {
        return c.value;
    }), "");
    return {
        title: title,
        text: text,
        backgroundColour: backgroundColour,
        bannerImageDesktop: bannerImageDesktop,
        bannerImageTablet: bannerImageTablet,
        bannerImageMobile: bannerImageMobile,
        address: address,
        smartLink: smartLink
    };
}
var Gql_CustomerCareBanner_Decoder_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/CustomerCareCallUs/Gql__CustomerCareCallUs__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_CustomerCareCallUs_Decoder_bs_get(content) {
    var elementId = content.system.id;
    var codename = content.system.codename;
    var smartLink = {
        itemId: elementId,
        codename: codename
    };
    var preTitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.pre_title, function(c) {
        return c.value;
    }), "");
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.title, function(c) {
        return c.value;
    }), "");
    var formContactMethodLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.form_contact_method_label, function(c) {
        return c.value;
    }), "");
    var formContactMethodUrl = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.form_contact_method_url, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.phone_contact_method_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var phoneContactMethodIcon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        phoneContactMethodIcon = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        phoneContactMethodIcon = undefined;
    }
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.form_contact_method_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var formContactMethodIcon;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        formContactMethodIcon = {
            name: name$1,
            description: description$1,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        formContactMethodIcon = undefined;
    }
    var text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.text, function(c) {
        return c.value;
    }), "");
    var localPhoneNumber = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.local_phone_number, function(c) {
        return c.value;
    }), "");
    var internationalPhoneNumberText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.international_phone_number_text, function(c) {
        return c.value;
    }), "");
    var internationalPhoneNumber = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.international_phone_number, function(c) {
        return c.value;
    }), "");
    var subtext = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.subtext, function(c) {
        return c.value;
    }), "");
    return {
        preTitle: preTitle,
        title: title,
        text: text,
        formContactMethodIcon: formContactMethodIcon,
        formContactMethodLabel: formContactMethodLabel,
        formContactMethodUrl: formContactMethodUrl,
        phoneContactMethodIcon: phoneContactMethodIcon,
        localPhoneNumber: localPhoneNumber,
        internationalPhoneNumberText: internationalPhoneNumberText,
        internationalPhoneNumber: internationalPhoneNumber,
        subtext: subtext,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/SellingPointsBlockItem/Gql__SellingPointsBlockItem__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_SellingPointsBlockItem_Decoder_bs_get(c) {
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_mp4, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var video_mp4;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$2 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        video_mp4 = {
            name: name$1,
            description: description$2,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        video_mp4 = undefined;
    }
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_webm, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var video_webm;
    if (value$2 !== undefined) {
        var name$2 = belt_Option/* getWithDefault */.tj(value$2.name, "");
        var description$3 = belt_Option/* getWithDefault */.tj(value$2.description, "");
        var url$2 = belt_Option/* getWithDefault */.tj(value$2.url, "");
        var width$2 = belt_Option/* getWithDefault */.tj(value$2.width, 0);
        var height$2 = belt_Option/* getWithDefault */.tj(value$2.height, 0);
        video_webm = {
            name: name$2,
            description: description$3,
            url: url$2,
            width: width$2,
            height: height$2
        };
    } else {
        video_webm = undefined;
    }
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        image: result,
        title: title,
        description: description$1,
        smartLink: smartLink,
        video_mp4: video_mp4,
        video_webm: video_webm
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/SellingPointsBlock/Gql__SellingPointsBlock__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_SellingPointsBlock_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var backgroundColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var items = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "SellingPointsBlockItemContentType") {
            return Gql_SellingPointsBlockItem_Decoder_bs_get(f.VAL.sellingPointsBlockItem);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        backgroundColour: backgroundColour,
        items: items,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TextField/Gql__TextField__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_TextField_Decoder_bs_get(c) {
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.name, function(f) {
        return f.value;
    }), "");
    var type_ = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.type, function(f) {
        return f.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.codename;
    }), "text", function(str) {
        if (str === "phone") {
            return "tel";
        } else {
            return str;
        }
    });
    var label = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.label, function(f) {
        return f.value;
    }), "");
    var placeholder = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.placeholder, function(f) {
        return f.value;
    }), "");
    var validation_message = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.validation_message, function(f) {
        return f.value;
    }), "");
    var required = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.required, function(f) {
        return f.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.codename;
    }), true, function(str) {
        switch(str){
            case "false":
                return false;
            case "true":
                return true;
            default:
                return true;
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        name: name,
        type_: type_,
        label: label,
        placeholder: placeholder,
        validation_message: validation_message,
        required: required,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/BusinessContactForm/Gql__BusinessContactForm__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_BusinessContactForm_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.email_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var email_icon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        email_icon = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        email_icon = undefined;
    }
    var email = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.email, function(c) {
        return c.value;
    }), "");
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.phone_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var phone_icon;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        phone_icon = {
            name: name$1,
            description: description$1,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        phone_icon = undefined;
    }
    var phone = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.phone, function(c) {
        return c.value;
    }), "");
    var body_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_text, function(c) {
        return c.value;
    }), "");
    var body_ctas = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_ctas, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var fields = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.fields, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "TextFieldContentType") {
            return Gql_TextField_Decoder_bs_get(f.VAL.textField);
        }
    });
    var submit_cta_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.submit_cta_text, function(c) {
        return c.value;
    }), "");
    var smart_link_itemId = c.system.id;
    var smart_link_codename = c.system.codename;
    var smart_link = {
        itemId: smart_link_itemId,
        codename: smart_link_codename
    };
    return {
        title: title,
        email_icon: email_icon,
        email: email,
        phone_icon: phone_icon,
        phone: phone,
        body_text: body_text,
        body_ctas: body_ctas,
        fields: fields,
        submit_cta_text: submit_cta_text,
        smart_link: smart_link
    };
}
var Gql_BusinessContactForm_Decoder_bs_TextField;
var Gql_BusinessContactForm_Decoder_bs_CardIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/IconCardBlock/Gql__IconCardBlock__Decoder__Card.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_IconCardBlock_Decoder_Card_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "IconCardContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), "");
    var open_in_new_window = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.open_in_new_window, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        return v === "yes";
    });
    var title_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_colour, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), "");
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var icon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        icon = {
            name: name,
            description: description$1,
            url: url$1,
            width: width,
            height: height
        };
    } else {
        icon = undefined;
    }
    var iconSize = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_size, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "small", function(str) {
        return str;
    });
    var contentAlignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.content_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        url: url,
        open_in_new_window: open_in_new_window,
        title_colour: title_colour,
        text_colour: text_colour,
        background_colour: background_colour,
        icon: icon,
        iconSize: iconSize,
        contentAlignment: contentAlignment,
        smartLink: smartLink
    };
}
var Gql_IconCardBlock_Decoder_Card_bs_CardIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/IconCardBlock/Gql__IconCardBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_IconCardBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var theme = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.theme, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "");
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var icon_cards = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_cards, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_IconCardBlock_Decoder_Card_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        theme: theme,
        icon_cards: icon_cards,
        background_colour: background_colour,
        smartLink: smartLink
    };
}
var IconCard;
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/FontAwesomeIcon/Gql__FontAwesomeIcon__Decoder.bs.js
var Gql_FontAwesomeIcon_Decoder_bs = __webpack_require__(58259);
;// CONCATENATED MODULE: ./src/api/graphql/GiftExperience/Gql__GiftExperience__Decoder__ListItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_GiftExperience_Decoder_ListItem_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "TheGiftExperienceListItemContentType") {
        return;
    }
    var c = content.VAL;
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var icon = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.fontawesome_icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "FontAwesomeContentType") {
            return Gql_FontAwesomeIcon_Decoder_bs/* get */.U(f.VAL.fontAwesomeIcon);
        }
    }), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        icon: icon,
        description: description,
        smartLink: smartLink
    };
}
var Gql_GiftExperience_Decoder_ListItem_bs_FontAwesomeIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftExperience/Gql__GiftExperience__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_GiftExperience_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.promo_image_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var promo_image;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        promo_image = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        promo_image = undefined;
    }
    var list_items = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.list_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_GiftExperience_Decoder_ListItem_bs_get);
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.buttons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        promo_image: promo_image,
        list_items: list_items,
        buttons: buttons,
        smartLink: smartLink
    };
}
var Gql_GiftExperience_Decoder_Block_bs_$$Image;
var Gql_GiftExperience_Decoder_Block_bs_IconCard;
var ListItem;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuCarousel/Gql__SkuCarousel__Decoder__Carousel.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function getButton(contents) {
    if (typeof contents === "object" && contents.NAME === "CallToActionLinkD6a3d61ContentType") {
        return Gql_CallToAction_Decoder_bs/* get */.U2(contents.VAL.callToAction);
    }
}
function Gql_SkuCarousel_Decoder_Carousel_bs_get(c) {
    var uid = c.system.id;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subtitle, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var button = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), getButton);
    var background = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "white");
    var skuList = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.sku_list, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        uid: uid,
        title: title,
        subtitle: subtitle,
        description: description,
        button: button,
        background: background,
        skuList: skuList,
        smartLink: smartLink
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./src/utils/Regex.bs.js
var Regex_bs = __webpack_require__(7618);
;// CONCATENATED MODULE: ./src/api/graphql/TrustpilotWidgetBlock/Gql__TrustpilotWidgetBlock__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_TrustpilotWidgetBlock_Decoder_bs_get(c) {
    var title_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_text, function(f) {
        return f.value;
    }), "");
    var title_alignment = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "h2", function(str) {
        return str;
    });
    var title_heading = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_heading, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var widget_code = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.widget_code, function(f) {
        return f.value;
    }), "").replace(Regex_bs/* htmlCommentRegex */.bI, "");
    var top_distance = belt_Option/* flatMap */.VS(c.top_distance, function(c) {
        return c.value;
    });
    var bottom_distance = belt_Option/* flatMap */.VS(c.bottom_distance, function(c) {
        return c.value;
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        smartLink: smartLink,
        title_text: title_text,
        title_alignment: title_alignment,
        title_heading: title_heading,
        widget_code: widget_code,
        bottom_distance: bottom_distance,
        top_distance: top_distance
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./src/components/library/SmartLink.bs.js
var SmartLink_bs = __webpack_require__(35705);
;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Decoder__Video.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_VideoTextPromo_Decoder_Video_bs_get(content) {
    if (typeof content === "object" && content.NAME === "VideoContentType") {
        return get(content.VAL.video);
    }
}
var Gql_VideoTextPromo_Decoder_Video_bs_Video;
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/Image/Gql__Image__Decoder.bs.js
var Gql_Image_Decoder_bs = __webpack_require__(46271);
;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Decoder__SideImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_VideoTextPromo_Decoder_SideImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_VideoTextPromo_Decoder_SideImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Decoder__MobileVideo.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_VideoTextPromo_Decoder_MobileVideo_bs_get(content) {
    if (typeof content === "object" && content.NAME === "VideoContentType") {
        return get(content.VAL.video);
    }
}
var Gql_VideoTextPromo_Decoder_MobileVideo_bs_Video;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Decoder__VideoPoster.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_VideoTextPromo_Decoder_VideoPoster_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_VideoTextPromo_Decoder_VideoPoster_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/VideoTextPromo/Gql__VideoTextPromo__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var emptyBlock = {
    tagline: "",
    title: "",
    description: "",
    text_colour: /* Dark */ 0,
    video: undefined,
    mobile_video: undefined,
    loop_video: true,
    video_poster: undefined,
    side_image: undefined,
    smartLink: SmartLink_bs/* emptySmartLink */.R
};
function Gql_VideoTextPromo_Decoder_Block_bs_get(c) {
    var tagline = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tagline, function(c) {
        return c.value;
    }), "");
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Dark */ 0, function(str) {
        switch(str){
            case "dark":
                return /* Dark */ 0;
            case "light":
                return /* Light */ 1;
            default:
                return /* Dark */ 0;
        }
    });
    var video = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.featured_video, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_VideoTextPromo_Decoder_Video_bs_get), 0);
    var mobile_video = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.featured_video_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_VideoTextPromo_Decoder_MobileVideo_bs_get), 0);
    var loop_video = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.loop_featured_video, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), true, function(str) {
        switch(str){
            case "false":
                return false;
            case "true":
                return true;
            default:
                return true;
        }
    });
    var video_poster = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.feature_video_poster, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_VideoTextPromo_Decoder_VideoPoster_bs_get), 0);
    var side_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_VideoTextPromo_Decoder_SideImage_bs_get), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        tagline: tagline,
        title: title,
        description: description,
        text_colour: text_colour,
        video: video,
        mobile_video: mobile_video,
        loop_video: loop_video,
        video_poster: video_poster,
        side_image: side_image,
        smartLink: smartLink
    };
}
var Gql_VideoTextPromo_Decoder_Block_bs_$$Image;
var Gql_VideoTextPromo_Decoder_Block_bs_Video;
var MobileVideo;
var VideoPoster;
var SideImage;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Decoder__Button.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


var emptyButton = {
    cta_text: "Subscribe",
    cta_url: "",
    cta_variant: "",
    variant: /* Regular */ 0,
    colour: /* Red */ 0,
    fill: /* Contained */ 0,
    open_in_new_window: false,
    smartLink: SmartLink_bs/* emptySmartLink */.R
};
function Gql_NewsletterBlock_Decoder_Button_bs_get(content) {
    if (typeof content === "object" && content.NAME === "CallToActionLinkD6a3d61ContentType") {
        return Gql_CallToAction_Decoder_bs/* get */.U2(content.VAL.callToAction);
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Decoder__BackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NewsletterBlock_Decoder_BackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_NewsletterBlock_Decoder_BackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Decoder__BackgroundImageMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NewsletterBlock_Decoder_BackgroundImageMobile_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_NewsletterBlock_Decoder_BackgroundImageMobile_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Decoder__BackgroundImageTablet.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NewsletterBlock_Decoder_BackgroundImageTablet_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_NewsletterBlock_Decoder_BackgroundImageTablet_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NewsletterBlock/Gql__NewsletterBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function Gql_NewsletterBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Dark */ 0, function(str) {
        switch(str){
            case "dark":
                return /* Dark */ 0;
            case "light":
                return /* Light */ 1;
            default:
                return /* Dark */ 0;
        }
    });
    var input_box_placeholder_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.input_box_placeholder_text, function(c) {
        return c.value;
    }), "Email address");
    var success_message = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.success_message, function(c) {
        return c.value;
    }), "");
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_NewsletterBlock_Decoder_BackgroundImage_bs_get), 0);
    var background_image_tablet = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_NewsletterBlock_Decoder_BackgroundImageTablet_bs_get), 0);
    var background_image_mobile = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_NewsletterBlock_Decoder_BackgroundImageMobile_bs_get), 0);
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var button = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), Gql_NewsletterBlock_Decoder_Button_bs_get), emptyButton);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        text_colour: text_colour,
        input_box_placeholder_text: input_box_placeholder_text,
        success_message: success_message,
        background_image: background_image,
        background_image_tablet: background_image_tablet,
        background_image_mobile: background_image_mobile,
        background_colour: background_colour,
        button: button,
        smartLink: smartLink
    };
}
var Gql_NewsletterBlock_Decoder_Block_bs_$$Image;
var BackgroundImage;
var BackgroundImageTablet;
var BackgroundImageMobile;
var Button;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/DeviceSizeImage/Gql__DeviceSizeImage__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_DeviceSizeImage_Decoder_bs_get(c) {
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var desktop_image;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        desktop_image = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        desktop_image = undefined;
    }
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var tablet_image;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        tablet_image = {
            name: name$1,
            description: description$1,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        tablet_image = undefined;
    }
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var mobile_image;
    if (value$2 !== undefined) {
        var name$2 = belt_Option/* getWithDefault */.tj(value$2.name, "");
        var description$2 = belt_Option/* getWithDefault */.tj(value$2.description, "");
        var url$2 = belt_Option/* getWithDefault */.tj(value$2.url, "");
        var width$2 = belt_Option/* getWithDefault */.tj(value$2.width, 0);
        var height$2 = belt_Option/* getWithDefault */.tj(value$2.height, 0);
        mobile_image = {
            name: name$2,
            description: description$2,
            url: url$2,
            width: width$2,
            height: height$2
        };
    } else {
        mobile_image = undefined;
    }
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        desktop_image: desktop_image,
        tablet_image: tablet_image,
        mobile_image: mobile_image,
        smartLink: smartLink
    };
}
var Gql_DeviceSizeImage_Decoder_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/ImageCollection/Gql__ImageCollection__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function convertPerRowToInt(str) {
    switch(str){
        case "eight":
            return 8;
        case "five":
            return 5;
        case "four":
            return 4;
        case "one":
            return 1;
        case "seven":
            return 7;
        case "six":
            return 6;
        case "three":
            return 3;
        case "two":
            return 2;
        default:
            return 1;
    }
}
function Gql_ImageCollection_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var images = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.images, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(i) {
        if (typeof i !== "object") {
            return;
        }
        var variant = i.NAME;
        if (variant === "ImageContentType") {
            return {
                NAME: "Image",
                VAL: Gql_Image_Decoder_bs/* get */.U(i.VAL.image)
            };
        } else if (variant === "DeviceSizeImageContentType") {
            return {
                NAME: "DeviceSizeImage",
                VAL: Gql_DeviceSizeImage_Decoder_bs_get(i.VAL.deviceSizeImage)
            };
        } else {
            return;
        }
    });
    var display_per_row_desktop = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.display_per_row_desktop, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), 1, convertPerRowToInt);
    var display_per_row_tablet = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.display_per_row_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), 1, convertPerRowToInt);
    var display_per_row_mobile = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.display_per_row_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), 1, convertPerRowToInt);
    var gap_desktop = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.gap_desktop, function(c) {
        return c.value;
    }), 0);
    var gap_tablet = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.gap_tablet, function(c) {
        return c.value;
    }), 0);
    var gap_mobile = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.gap_mobile, function(c) {
        return c.value;
    }), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        images: images,
        display_per_row_desktop: display_per_row_desktop,
        display_per_row_tablet: display_per_row_tablet,
        display_per_row_mobile: display_per_row_mobile,
        gap_desktop: gap_desktop,
        gap_tablet: gap_tablet,
        gap_mobile: gap_mobile,
        smartLink: smartLink
    };
}
var Gql_ImageCollection_Decoder_bs_$$Image;
var Gql_ImageCollection_Decoder_bs_DeviceSizeImage;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/OffsetTilesBlock/Gql__OffsetTilesBlock__Decoder__Images.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_OffsetTilesBlock_Decoder_Images_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageCollectionContentType") {
        return Gql_ImageCollection_Decoder_bs_get(content.VAL.imageCollection);
    }
}
var Gql_OffsetTilesBlock_Decoder_Images_bs_ImageCollection;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/OffsetTilesBlock/Gql__OffsetTilesBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_OffsetTilesBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var background_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), undefined, function(c) {
        if (c === "") {
            return;
        } else {
            return c;
        }
    });
    var tiles = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tiles, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_OffsetTilesBlock_Decoder_Images_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        background_colour: background_colour,
        tiles: tiles,
        smartLink: smartLink
    };
}
var Gql_OffsetTilesBlock_Decoder_Block_bs_ImageCollection;
var Images;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TeamMembersBlock/Gql__TeamMembersBlock__Decoder__Card.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_TeamMembersBlock_Decoder_Card_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "TeamMemberCardContentType") {
        return;
    }
    var c = content.VAL;
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.photo_front_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.photo_back_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var photo_back;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        photo_back = {
            name: name$1,
            description: description$1,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        photo_back = undefined;
    }
    var name$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.name, function(c) {
        return c.value;
    }), "");
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description$2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var link = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.link, function(c) {
        return c.value;
    }), undefined, function(link) {
        if (link === "") {
            return;
        } else {
            return link;
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        photo_front: result,
        photo_back: photo_back,
        name: name$2,
        title: title,
        description: description$2,
        link: link,
        smartLink: smartLink
    };
}
var Gql_TeamMembersBlock_Decoder_Card_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TeamMembersBlock/Gql__TeamMembersBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_TeamMembersBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var cards_per_row = belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cards_per_row, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), "");
    var team_member_cards = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.team_member_cards, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TeamMembersBlock_Decoder_Card_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        cards_per_row: cards_per_row,
        team_member_cards: team_member_cards,
        smartLink: smartLink
    };
}
var Card;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/DownloadAppsBlock/Gql__DownloadAppsBlock__Decoder__AppStore.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_DownloadAppsBlock_Decoder_AppStore_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "AppStoreItemContentType") {
        return;
    }
    var c = content.VAL;
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var app_store_name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_name, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var app_store_image;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        app_store_image = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        app_store_image = undefined;
    }
    var app_store_download_link = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_download_link, function(c) {
        return c.value;
    }), "");
    return {
        smartLink: smartLink,
        app_store_name: app_store_name,
        app_store_image: app_store_image,
        app_store_download_link: app_store_download_link
    };
}
var Gql_DownloadAppsBlock_Decoder_AppStore_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/DownloadAppsBlock/Gql__DownloadAppsBlock__Decoder__SellingPoint.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_DownloadAppsBlock_Decoder_SellingPoint_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "UniqueSellingPointContentType") {
        return;
    }
    var c = content.VAL;
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var icon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        icon = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        icon = undefined;
    }
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    return {
        smartLink: smartLink,
        icon: icon,
        title: title
    };
}
var Gql_DownloadAppsBlock_Decoder_SellingPoint_bs_Icon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/DownloadAppsBlock/Gql__DownloadAppsBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function Gql_DownloadAppsBlock_Decoder_Block_bs_get(c) {
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var selling_points = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.selling_points, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_DownloadAppsBlock_Decoder_SellingPoint_bs_get);
    var app_stores = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_stores, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_DownloadAppsBlock_Decoder_AppStore_bs_get);
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(x) {
        if (typeof x === "object" && x.NAME === "ImageContentType") {
            return Gql_Image_Decoder_bs/* get */.U(x.VAL.image);
        }
    }), 0);
    var mobile_background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(x) {
        if (typeof x === "object" && x.NAME === "ImageContentType") {
            return Gql_Image_Decoder_bs/* get */.U(x.VAL.image);
        }
    }), 0);
    return {
        smartLink: smartLink,
        title: title,
        description: description,
        selling_points: selling_points,
        app_stores: app_stores,
        background_image: background_image,
        mobile_background_image: mobile_background_image
    };
}
var SellingPoints;
var AppStore;
var Gql_DownloadAppsBlock_Decoder_Block_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__Button.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_Button_bs_get(content) {
    if (typeof content === "object" && content.NAME === "CallToActionLinkD6a3d61ContentType") {
        return Gql_CallToAction_Decoder_bs/* get */.U2(content.VAL.callToAction);
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__BackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_BackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_HeroTiles_Decoder_BackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__BackgroundVideo.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_BackgroundVideo_bs_get(content) {
    if (typeof content === "object" && content.NAME === "VideoContentType") {
        return get(content.VAL.video);
    }
}
var Gql_HeroTiles_Decoder_BackgroundVideo_bs_Video;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__ForegroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_ForegroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_HeroTiles_Decoder_ForegroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__MobileBackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_MobileBackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_HeroTiles_Decoder_MobileBackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__MobileBackgroundVideo.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_MobileBackgroundVideo_bs_get(content) {
    if (typeof content === "object" && content.NAME === "VideoContentType") {
        return get(content.VAL.video);
    }
}
var Gql_HeroTiles_Decoder_MobileBackgroundVideo_bs_Video;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__TabletBackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_TabletBackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_HeroTiles_Decoder_TabletBackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__TabletBackgroundVideo.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeroTiles_Decoder_TabletBackgroundVideo_bs_get(content) {
    if (typeof content === "object" && content.NAME === "VideoContentType") {
        return get(content.VAL.video);
    }
}
var Gql_HeroTiles_Decoder_TabletBackgroundVideo_bs_Video;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__HeroTile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE












var emptyHeroTile_buttons = [];
var emptyHeroTile = {
    title: "",
    subtitle: "",
    description: "",
    text_colour: /* Dark */ 0,
    video_cta_text: "",
    buttons: emptyHeroTile_buttons,
    foreground_image: undefined,
    background_image: undefined,
    mobile_background_image: undefined,
    tablet_background_image: undefined,
    background_colour: undefined,
    background_video: undefined,
    mobile_background_video: undefined,
    tablet_background_video: undefined,
    loop_background_video: true,
    content_vertical_alignment: "",
    background_horizontal_alignment: "",
    smartLink: SmartLink_bs/* emptySmartLink */.R,
    cta: false,
    infoCta: false
};
function Gql_HeroTiles_Decoder_HeroTile_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "HeroTileContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subtitle, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Dark */ 0, function(str) {
        switch(str){
            case "dark":
                return /* Dark */ 0;
            case "light":
                return /* Light */ 1;
            default:
                return /* Dark */ 0;
        }
    });
    var video_cta_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_cta_text, function(c) {
        return c.value;
    }), "");
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.buttons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_Button_bs_get);
    var foreground_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.foreground_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_ForegroundImage_bs_get), 0);
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_BackgroundImage_bs_get), 0);
    var mobile_background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_MobileBackgroundImage_bs_get), 0);
    var tablet_background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_TabletBackgroundImage_bs_get), 0);
    var background_colour = belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    });
    var background_video = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_video_new, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_BackgroundVideo_bs_get), 0);
    var mobile_background_video = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_background_video, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_MobileBackgroundVideo_bs_get), 0);
    var tablet_background_video = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_background_video, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_TabletBackgroundVideo_bs_get), 0);
    var loop_background_video = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.loop_background_video, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), true, function(str) {
        switch(str){
            case "false":
                return false;
            case "true":
                return true;
            default:
                return true;
        }
    });
    var content_vertical_alignment = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.content_vertical_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "");
    var background_horizontal_alignment = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_horizontal_alignment, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var cta = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        return v === "enable_as_cta";
    });
    var infoCta = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.info_cta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        return v === "enable_as_info_cta";
    });
    return {
        title: title,
        subtitle: subtitle,
        description: description,
        text_colour: text_colour,
        video_cta_text: video_cta_text,
        buttons: buttons,
        foreground_image: foreground_image,
        background_image: background_image,
        mobile_background_image: mobile_background_image,
        tablet_background_image: tablet_background_image,
        background_colour: background_colour,
        background_video: background_video,
        mobile_background_video: mobile_background_video,
        tablet_background_video: tablet_background_video,
        loop_background_video: loop_background_video,
        content_vertical_alignment: content_vertical_alignment,
        background_horizontal_alignment: background_horizontal_alignment,
        smartLink: smartLink,
        cta: cta,
        infoCta: infoCta
    };
}
var Gql_HeroTiles_Decoder_HeroTile_bs_$$Image;
var ForegroundImage;
var Gql_HeroTiles_Decoder_HeroTile_bs_BackgroundImage;
var MobileBackgroundImage;
var TabletBackgroundImage;
var Gql_HeroTiles_Decoder_HeroTile_bs_Button;
var BackgroundVideo;
var MobileBackgroundVideo;
var TabletBackgroundVideo;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeroTiles/Gql__HeroTiles__Decoder__HeroTileBlock.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var emptyBlock_hero_tiles = [];
var emptyBlock_bottom_distance = 0;
var emptyBlock_top_distance = 0;
var Gql_HeroTiles_Decoder_HeroTileBlock_bs_emptyBlock = {
    block_style: /* TwoOneStack */ 0,
    hero_tiles: emptyBlock_hero_tiles,
    smartLink: SmartLink_bs/* emptySmartLink */.R,
    bottom_distance: emptyBlock_bottom_distance,
    top_distance: emptyBlock_top_distance
};
function Gql_HeroTiles_Decoder_HeroTileBlock_bs_get(c) {
    var block_style = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.block_style, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* TwoOneStack */ 0, function(str) {
        switch(str){
            case "full_width":
                return /* FullWidth */ 2;
            case "tiled_offset":
                return /* TiledOffset */ 1;
            case "two_one_stack":
                return /* TwoOneStack */ 0;
            default:
                return /* TwoOneStack */ 0;
        }
    });
    var hero_tiles = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.hero_tiles, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_HeroTiles_Decoder_HeroTile_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var bottom_distance = belt_Option/* flatMap */.VS(c.bottom_distance, function(c) {
        return c.value;
    });
    var top_distance = belt_Option/* flatMap */.VS(c.top_distance, function(c) {
        return c.value;
    });
    return {
        block_style: block_style,
        hero_tiles: hero_tiles,
        smartLink: smartLink,
        bottom_distance: bottom_distance,
        top_distance: top_distance
    };
}
var HeroTile;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthTextBlock/Gql__FullWidthTextBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_FullWidthTextBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Dark */ 0, function(str) {
        switch(str){
            case "dark":
                return /* Dark */ 0;
            case "light":
                return /* Light */ 1;
            default:
                return /* Dark */ 0;
        }
    });
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        text_colour: text_colour,
        background_colour: background_colour,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__Button.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_Button_bs_get(content) {
    if (typeof content === "object" && content.NAME === "CallToActionLinkD6a3d61ContentType") {
        return Gql_CallToAction_Decoder_bs/* get */.U2(content.VAL.callToAction);
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__ImageMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_ImageMobile_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_FullWidthHeroBanner_Decoder_ImageMobile_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__ImageTablet.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_ImageTablet_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_FullWidthHeroBanner_Decoder_ImageTablet_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__ImageDesktop.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_ImageDesktop_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_FullWidthHeroBanner_Decoder_ImageDesktop_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__ScrollingTextItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_ScrollingTextItem_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "TextListItemContentType") {
        return;
    }
    var item = content.VAL;
    var text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(item.text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = item.system.id;
    var smartLink_codename = item.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        text: text,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__ScrollingText.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_FullWidthHeroBanner_Decoder_ScrollingText_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "TextListContentType") {
        return;
    }
    var c = content.VAL;
    var items = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_list_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_ScrollingTextItem_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        items: items,
        smartLink: smartLink
    };
}
var ScrollingTextItem;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__VideoButtonIcon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_FullWidthHeroBanner_Decoder_VideoButtonIcon_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_FullWidthHeroBanner_Decoder_VideoButtonIcon_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/FullWidthHeroBanner/Gql__FullWidthHeroBanner__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









function Gql_FullWidthHeroBanner_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var scrolling_text = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.scrolling_text, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_ScrollingText_bs_get), 0);
    var scrolling_text_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.scrolling_text_colour, function(c) {
        return c.value;
    }), "");
    var background_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), undefined, function(c) {
        if (c === "") {
            return;
        } else {
            return c;
        }
    });
    var desktop_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_ImageDesktop_bs_get), 0);
    var tablet_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_ImageTablet_bs_get), 0);
    var mobile_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_ImageMobile_bs_get), 0);
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.buttons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_Button_bs_get);
    var video_button_icon = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_button_icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_FullWidthHeroBanner_Decoder_VideoButtonIcon_bs_get), 0);
    var video_button_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_button_text, function(c) {
        return c.value;
    }), "");
    var video_button_url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.video_button_url, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        scrolling_text: scrolling_text,
        scrolling_text_colour: scrolling_text_colour,
        buttons: buttons,
        video_button_icon: video_button_icon,
        video_button_text: video_button_text,
        video_button_url: video_button_url,
        background_colour: background_colour,
        desktop_image: desktop_image,
        tablet_image: tablet_image,
        mobile_image: mobile_image,
        smartLink: smartLink
    };
}
var Gql_FullWidthHeroBanner_Decoder_Block_bs_Button;
var Gql_FullWidthHeroBanner_Decoder_Block_bs_$$Image;
var ImageDesktop;
var ImageTablet;
var ImageMobile;
var VideoButtonIcon;
var ScrollingText;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/InnovativeWayToGift/Gql__InnovativeWayToGift__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_InnovativeWayToGift_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var background_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), undefined, function(c) {
        if (c === "") {
            return;
        } else {
            return c;
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_background_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var desktop_background;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description$1 = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        desktop_background = {
            name: name,
            description: description$1,
            url: url,
            width: width,
            height: height
        };
    } else {
        desktop_background = undefined;
    }
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_background_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var tablet_background;
    if (value$1 !== undefined) {
        var name$1 = belt_Option/* getWithDefault */.tj(value$1.name, "");
        var description$2 = belt_Option/* getWithDefault */.tj(value$1.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value$1.url, "");
        var width$1 = belt_Option/* getWithDefault */.tj(value$1.width, 0);
        var height$1 = belt_Option/* getWithDefault */.tj(value$1.height, 0);
        tablet_background = {
            name: name$1,
            description: description$2,
            url: url$1,
            width: width$1,
            height: height$1
        };
    } else {
        tablet_background = undefined;
    }
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_background_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var mobile_background;
    if (value$2 !== undefined) {
        var name$2 = belt_Option/* getWithDefault */.tj(value$2.name, "");
        var description$3 = belt_Option/* getWithDefault */.tj(value$2.description, "");
        var url$2 = belt_Option/* getWithDefault */.tj(value$2.url, "");
        var width$2 = belt_Option/* getWithDefault */.tj(value$2.width, 0);
        var height$2 = belt_Option/* getWithDefault */.tj(value$2.height, 0);
        mobile_background = {
            name: name$2,
            description: description$3,
            url: url$2,
            width: width$2,
            height: height$2
        };
    } else {
        mobile_background = undefined;
    }
    var buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.cta_button_s, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        description: description,
        background_colour: background_colour,
        desktop_background: desktop_background,
        tablet_background: tablet_background,
        mobile_background: mobile_background,
        buttons: buttons,
        smartLink: smartLink
    };
}
var Gql_InnovativeWayToGift_Decoder_Block_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/PromoTiles/Gql__PromoTiles__Decoder__PromoTile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_PromoTiles_Decoder_PromoTile_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "PromoTileContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var link = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), "");
    var image = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(i) {
        if (typeof i !== "object") {
            return;
        }
        var variant = i.NAME;
        if (variant === "ImageContentType") {
            return {
                NAME: "Image",
                VAL: Gql_Image_Decoder_bs/* get */.U(i.VAL.image)
            };
        } else if (variant === "DeviceSizeImageContentType") {
            return {
                NAME: "DeviceSizeImage",
                VAL: Gql_DeviceSizeImage_Decoder_bs_get(i.VAL.deviceSizeImage)
            };
        } else {
            return;
        }
    });
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.graphic_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var graphic = result;
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), "");
    var desktop_text_width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_text_width, function(c) {
        return c.value;
    }), "");
    var icon_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_colour, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        image: image,
        graphic: graphic,
        link: link,
        background_colour: background_colour,
        text_colour: text_colour,
        desktop_text_width: desktop_text_width,
        icon_colour: icon_colour,
        smartLink: smartLink
    };
}
var Gql_PromoTiles_Decoder_PromoTile_bs_$$Image;
var Gql_PromoTiles_Decoder_PromoTile_bs_DeviceSizeImage;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/PromoTiles/Gql__PromoTiles__Decoder__PromoTileBlock.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_PromoTiles_Decoder_PromoTileBlock_bs_get(c) {
    return belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tiles, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_PromoTiles_Decoder_PromoTile_bs_get);
}
var PromoTile;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Icon/Gql__Icon__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_Icon_Decoder_bs_get(content) {
    var file = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.svg, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.height;
    }), 0);
    return {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Decoder__Icon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StatsTiles_Decoder_Icon_bs_get(content) {
    if (typeof content === "object" && content.NAME === "IconContentType") {
        return Gql_Icon_Decoder_bs_get(content.VAL.icon);
    }
}
var Gql_StatsTiles_Decoder_Icon_bs_Icon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Decoder__BackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StatsTiles_Decoder_BackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_StatsTiles_Decoder_BackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Decoder__BackgroundImageMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StatsTiles_Decoder_BackgroundImageMobile_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_StatsTiles_Decoder_BackgroundImageMobile_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Decoder__StatsTile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function Gql_StatsTiles_Decoder_StatsTile_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "EnvironmentalImpactCardContentType") {
        return;
    }
    var c = content.VAL;
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subtitle, function(c) {
        return c.value;
    }), "");
    var text_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Dark */ 0, function(str) {
        switch(str){
            case "dark":
                return /* Dark */ 0;
            case "light":
                return /* Light */ 1;
            default:
                return /* Dark */ 0;
        }
    });
    var icon = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_StatsTiles_Decoder_Icon_bs_get), 0);
    var fontawesome_icon_class = belt_Option/* flatMap */.VS(c.fontawesome_icon_class, function(c) {
        return c.value;
    });
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_StatsTiles_Decoder_BackgroundImage_bs_get), 0);
    var background_image_mobile = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_StatsTiles_Decoder_BackgroundImageMobile_bs_get), 0);
    var background_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), "");
    return {
        smartLink: smartLink,
        title: title,
        subtitle: subtitle,
        text_colour: text_colour,
        icon: icon,
        fontawesome_icon_class: fontawesome_icon_class,
        background_image: background_image,
        background_image_mobile: background_image_mobile,
        background_colour: background_colour
    };
}
var Gql_StatsTiles_Decoder_StatsTile_bs_Icon;
var StatsTileIcon;
var Gql_StatsTiles_Decoder_StatsTile_bs_$$Image;
var Gql_StatsTiles_Decoder_StatsTile_bs_BackgroundImage;
var Gql_StatsTiles_Decoder_StatsTile_bs_BackgroundImageMobile;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/StatsTiles/Gql__StatsTiles__Decoder__StatsTilesBlock.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_StatsTiles_Decoder_StatsTilesBlock_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var stats_tiles = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.environmental_impact_cards, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_StatsTiles_Decoder_StatsTile_bs_get);
    return {
        title: title,
        description: description,
        stats_tiles: stats_tiles
    };
}
var StatsTile;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/BoardOfDirectorsBlock/Gql__BoardOfDirectorsBlock__Decoder__Card.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_BoardOfDirectorsBlock_Decoder_Card_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "BoardOfDirectorsCardContentType") {
        return;
    }
    var c = content.VAL;
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.photo_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.name, function(c) {
        return c.value;
    }), "");
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var link = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.link, function(c) {
        return c.value;
    }), undefined, function(link) {
        if (link === "") {
            return;
        } else {
            return link;
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        photo: result,
        name: name$1,
        title: title,
        link: link,
        smartLink: smartLink
    };
}
var Gql_BoardOfDirectorsBlock_Decoder_Card_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/BoardOfDirectorsBlock/Gql__BoardOfDirectorsBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_BoardOfDirectorsBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var board_of_directors_cards = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.board_of_directors_cards, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_BoardOfDirectorsBlock_Decoder_Card_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        board_of_directors_cards: board_of_directors_cards,
        smartLink: smartLink
    };
}
var Gql_BoardOfDirectorsBlock_Decoder_Block_bs_Card;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/LandingPageContactForm/Gql__LandingPageContactForm__Decoder__Control.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_LandingPageContactForm_Decoder_Control_bs_get(content) {
    if (typeof content === "object" && content.NAME === "TextFieldContentType") {
        return {
            NAME: "TextField",
            VAL: Gql_TextField_Decoder_bs_get(content.VAL.textField)
        };
    }
}
var TextFieldDecoder;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/LandingPageContactForm/Gql__LandingPageContactForm__Decoder__ControlWrapper.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_LandingPageContactForm_Decoder_ControlWrapper_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "FormControlWrapperContentType") {
        return;
    }
    var c = content.VAL;
    var desktop_width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_width, function(c) {
        return c.value;
    }), "");
    var tablet_width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tablet_width, function(c) {
        return c.value;
    }), "");
    var mobile_width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_width, function(c) {
        return c.value;
    }), "");
    var control = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.control, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_LandingPageContactForm_Decoder_Control_bs_get), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        desktop_width: desktop_width,
        tablet_width: tablet_width,
        mobile_width: mobile_width,
        control: control,
        smartLink: smartLink
    };
}
var Control;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/LandingPageContactForm/Gql__LandingPageContactForm__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_LandingPageContactForm_Decoder_Block_bs_get(c) {
    var action = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.action, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), undefined, function(a) {
        switch(a){
            case "gleam":
                return /* Gleam */ 1;
            case "hubspot":
                return /* Hubspot */ 0;
            default:
                return;
        }
    });
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var form_name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.form_name, function(c) {
        return c.value;
    }), "");
    var body_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_text, function(c) {
        return c.value;
    }), "");
    var fields = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.fields, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_LandingPageContactForm_Decoder_ControlWrapper_bs_get);
    var submit_cta_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.submit_cta_text, function(c) {
        return c.value;
    }), "");
    var success_message_heading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.success_message_heading, function(c) {
        return c.value;
    }), "");
    var success_message_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.success_message_text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        action: action,
        form_name: form_name,
        title: title,
        body_text: body_text,
        fields: fields,
        submit_cta_text: submit_cta_text,
        success_message_heading: success_message_heading,
        success_message_text: success_message_text,
        smartLink: smartLink
    };
}
var ControlWrapper;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__ImageGrid.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TestimonialCarouselBlock_Decoder_ImageGrid_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageCollectionContentType") {
        return Gql_ImageCollection_Decoder_bs_get(content.VAL.imageCollection);
    }
}
var Gql_TestimonialCarouselBlock_Decoder_ImageGrid_bs_ImageCollection;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__CarouselBg.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TestimonialCarouselBlock_Decoder_CarouselBg_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_TestimonialCarouselBlock_Decoder_CarouselBg_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__CarouselLink.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_TestimonialCarouselBlock_Decoder_CarouselLink_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "LinkItemContentType") {
        return;
    }
    var c = content.VAL;
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), "");
    var open_in_new_window = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.open_in_new_window, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), false, function(c) {
        if (c === "yes") {
            return true;
        } else {
            return false;
        }
    });
    if (url === "") {
        return;
    } else {
        return {
            url: url,
            open_in_new_window: open_in_new_window
        };
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__CarouselBgMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TestimonialCarouselBlock_Decoder_CarouselBgMobile_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_TestimonialCarouselBlock_Decoder_CarouselBgMobile_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__CarouselBgTablet.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_TestimonialCarouselBlock_Decoder_CarouselBgTablet_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_TestimonialCarouselBlock_Decoder_CarouselBgTablet_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__CarouselItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function Gql_TestimonialCarouselBlock_Decoder_CarouselItem_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "TestimonialCarouselItemContentType") {
        return;
    }
    var c = content.VAL;
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var image;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        image = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        image = undefined;
    }
    var quote = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.quote, function(c) {
        return c.value;
    }), "");
    var author = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.author, function(c) {
        return c.value;
    }), "");
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_CarouselBg_bs_get), 0);
    var background_image_tablet = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_tablet, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_CarouselBgTablet_bs_get), 0);
    var background_image_mobile = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_mobile, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_CarouselBgMobile_bs_get), 0);
    var background_colour = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(c.background_colour, function(c) {
        return c.value;
    }), undefined, function(c) {
        if (c === "") {
            return;
        } else {
            return c;
        }
    });
    var url$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_CarouselLink_bs_get), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        image: image,
        quote: quote,
        author: author,
        url: url$1,
        background_image: background_image,
        background_image_tablet: background_image_tablet,
        background_image_mobile: background_image_mobile,
        background_colour: background_colour,
        smartLink: smartLink
    };
}
var Gql_TestimonialCarouselBlock_Decoder_CarouselItem_bs_$$Image;
var Bg;
var BgTablet;
var BgMobile;
var Gql_TestimonialCarouselBlock_Decoder_CarouselItem_bs_Link;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/TestimonialCarouselBlock/Gql__TestimonialCarouselBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_TestimonialCarouselBlock_Decoder_Block_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var testimonial_image_grid = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.testimonial_image_grid, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_ImageGrid_bs_get), 0);
    var testimonial_carousel_items = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.testimonial_carousel_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_TestimonialCarouselBlock_Decoder_CarouselItem_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        testimonial_image_grid: testimonial_image_grid,
        testimonial_carousel_items: testimonial_carousel_items,
        smartLink: smartLink
    };
}
var Gql_TestimonialCarouselBlock_Decoder_Block_bs_$$Image;
var CarouselItem;
var ImageGrid;
var Gql_TestimonialCarouselBlock_Decoder_Block_bs_ImageCollection;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/UniqueSellingPointsBlock/Gql__UniqueSellingPointsBlock__Decoder__BackgroundImage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_UniqueSellingPointsBlock_Decoder_BackgroundImage_bs_get(content) {
    if (typeof content === "object" && content.NAME === "ImageContentType") {
        return Gql_Image_Decoder_bs/* get */.U(content.VAL.image);
    }
}
var Gql_UniqueSellingPointsBlock_Decoder_BackgroundImage_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/UniqueSellingPointsBlock/Gql__UniqueSellingPointsBlock__Decoder__UniqueSellingPoint.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_UniqueSellingPointsBlock_Decoder_UniqueSellingPoint_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "UniqueSellingPointContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var icon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        icon = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        icon = undefined;
    }
    var fontawesome_icon_class = belt_Option/* flatMap */.VS(c.fontawesome_icon_class, function(c) {
        return c.value;
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        icon: icon,
        fontawesome_icon_class: fontawesome_icon_class,
        smartLink: smartLink
    };
}
var Gql_UniqueSellingPointsBlock_Decoder_UniqueSellingPoint_bs_Icon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/UniqueSellingPointsBlock/Gql__UniqueSellingPointsBlock__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_UniqueSellingPointsBlock_Decoder_Block_bs_get(c) {
    var tagline = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tagline, function(c) {
        return c.value;
    }), "");
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(c) {
        return c.value;
    }), "");
    var background_image = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_UniqueSellingPointsBlock_Decoder_BackgroundImage_bs_get), 0);
    var background_image_position = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_image_position, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), /* Right */ 1, function(str) {
        switch(str){
            case "left":
                return /* Left */ 0;
            case "right":
                return /* Right */ 1;
            default:
                return /* Right */ 1;
        }
    });
    var unique_selling_points = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.unique_selling_points, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_UniqueSellingPointsBlock_Decoder_UniqueSellingPoint_bs_get);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        tagline: tagline,
        title: title,
        description: description,
        background_image: background_image,
        background_image_position: background_image_position,
        unique_selling_points: unique_selling_points,
        smartLink: smartLink
    };
}
var Gql_UniqueSellingPointsBlock_Decoder_Block_bs_$$Image;
var UniqueSellingPoint;
var Gql_UniqueSellingPointsBlock_Decoder_Block_bs_BackgroundImage;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/CategoryTiles/Gql__CategoryTiles__Decoder__Button.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CategoryTiles_Decoder_Button_bs_get(content) {
    if (typeof content === "object" && content.NAME === "CallToActionLinkD6a3d61ContentType") {
        return Gql_CallToAction_Decoder_bs/* get */.U2(content.VAL.callToAction);
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/CategoryTiles/Gql__CategoryTiles__Decoder__CategoryTile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_CategoryTiles_Decoder_CategoryTile_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "CategoryTileContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var link = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.background_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var image;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        image = {
            name: name,
            description: description,
            url: url,
            width: width,
            height: height
        };
    } else {
        image = undefined;
    }
    var labelBackgroundColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.label_background_color, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        image: image,
        link: link,
        labelBackgroundColor: labelBackgroundColor,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/CategoryTiles/Gql__CategoryTiles__Decoder__CategoryTileBlock.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Gql_CategoryTiles_Decoder_CategoryTileBlock_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var tiles = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.tiles, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_CategoryTiles_Decoder_CategoryTile_bs_get);
    var button = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_CategoryTiles_Decoder_Button_bs_get), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        tiles: tiles,
        button: button,
        smartLink: smartLink
    };
}
var CategoryTile;
var Gql_CategoryTiles_Decoder_CategoryTileBlock_bs_Button;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/PageBuilder/Gql__PageBuilder__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




































function contentBlockSwitch(content) {
    if (typeof content !== "object") {
        return;
    }
    var variant = content.NAME;
    if (variant === "NarrowCtaContentType") {
        return {
            NAME: "NarrowCta",
            VAL: Gql_NarrowCta_Decoder_bs_get(content.VAL.narrowCta)
        };
    } else if (variant === "OffsetTilesBlockContentType") {
        return {
            NAME: "OffsetTilesBlock",
            VAL: Gql_OffsetTilesBlock_Decoder_Block_bs_get(content.VAL.offsetTilesBlock)
        };
    } else if (variant === "FaqBlockContentType") {
        return {
            NAME: "FAQBlock",
            VAL: Gql_FAQ_Decoder_bs_get(content.VAL.fAQBlock)
        };
    } else if (variant === "TestimonialCarouselBlockContentType") {
        return {
            NAME: "TestimonialCarouselBlock",
            VAL: Gql_TestimonialCarouselBlock_Decoder_Block_bs_get(content.VAL.testimonialCarouselBlock)
        };
    } else if (variant === "IconCardBlockContentType") {
        return {
            NAME: "IconCardBlock",
            VAL: Gql_IconCardBlock_Decoder_Block_bs_get(content.VAL.iconCardBlock)
        };
    } else if (variant === "SellingPointsBlockContentType") {
        return {
            NAME: "SellingPointsBlock",
            VAL: Gql_SellingPointsBlock_Decoder_bs_get(content.VAL.sellingPointsBlock)
        };
    } else if (variant === "CategoryTileBlockContentType") {
        return {
            NAME: "CategoryTileBlock",
            VAL: Gql_CategoryTiles_Decoder_CategoryTileBlock_bs_get(content.VAL.categoryTileBlock)
        };
    } else if (variant === "HeroBannerContentType") {
        return {
            NAME: "HeroBanner",
            VAL: Gql_HeroBanner_Decoder_bs_get(content.VAL.heroBanner)
        };
    } else if (variant === "ProductHeroBlockContentType") {
        return {
            NAME: "ProductHeroBlock",
            VAL: Gql_ProductHeroBlock_Decoder_bs_get(content.VAL.productHeroBlock)
        };
    } else if (variant === "TeamMembersBlockContentType") {
        return {
            NAME: "TeamMembersBlock",
            VAL: Gql_TeamMembersBlock_Decoder_Block_bs_get(content.VAL.teamMembersBlock)
        };
    } else if (variant === "LandingPageContactFormContentType") {
        return {
            NAME: "LandingPageContactFormBlock",
            VAL: Gql_LandingPageContactForm_Decoder_Block_bs_get(content.VAL.landingPageContactFormBlock)
        };
    } else if (variant === "CustomerCareCallUsContentType") {
        return {
            NAME: "CustomerCareCallUsBlock",
            VAL: Gql_CustomerCareCallUs_Decoder_bs_get(content.VAL.customerCareCallUsBlock)
        };
    } else if (variant === "EnvironmentalImpactsBlockContentType") {
        return {
            NAME: "StatsTilesBlock",
            VAL: Gql_StatsTiles_Decoder_StatsTilesBlock_bs_get(content.VAL.statsTilesBlock)
        };
    } else if (variant === "VideoTextPromoBoxContentType") {
        return {
            NAME: "VideoTextPromoBlock",
            VAL: Gql_VideoTextPromo_Decoder_Block_bs_get(content.VAL.videoTextPromoBlock)
        };
    } else if (variant === "PromoTileBlockContentType") {
        return {
            NAME: "PromoTileBlock",
            VAL: Gql_PromoTiles_Decoder_PromoTileBlock_bs_get(content.VAL.promoTileBlock)
        };
    } else if (variant === "SkuCarouselBlockContentType") {
        return {
            NAME: "SkuCarouselBlock",
            VAL: Gql_SkuCarousel_Decoder_Carousel_bs_get(content.VAL.skuCarouselBlock)
        };
    } else if (variant === "AppDownloadBlockContentType") {
        return {
            NAME: "DownloadAppsBlock",
            VAL: Gql_DownloadAppsBlock_Decoder_Block_bs_get(content.VAL.appDownloadBlock)
        };
    } else if (variant === "BusinessContactFormContentType") {
        return {
            NAME: "BusinessContactFormBlock",
            VAL: Gql_BusinessContactForm_Decoder_bs_get(content.VAL.businessContactFormBlock)
        };
    } else if (variant === "InnovativeWayToGiftContentType") {
        return {
            NAME: "InnovativeWayToGiftBlock",
            VAL: Gql_InnovativeWayToGift_Decoder_Block_bs_get(content.VAL.innovativeWayToGiftBlock)
        };
    } else if (variant === "EmailSignUpBlockContentType") {
        return {
            NAME: "NewsletterBlock",
            VAL: Gql_NewsletterBlock_Decoder_Block_bs_get(content.VAL.newsletterBlock)
        };
    } else if (variant === "NarrowBannerFullContentType") {
        return {
            NAME: "NarrowBannerFull",
            VAL: Gql_NarrowBannerFull_Decoder_bs_get(content.VAL.narrowBannerFull)
        };
    } else if (variant === "FullWidthTextBlockContentType") {
        return {
            NAME: "FullWidthTextBlock",
            VAL: Gql_FullWidthTextBlock_Decoder_Block_bs_get(content.VAL.fullWidthTextBlock)
        };
    } else if (variant === "TheGiftExperienceContentType") {
        return {
            NAME: "GiftExperienceBlock",
            VAL: Gql_GiftExperience_Decoder_Block_bs_get(content.VAL.giftExperienceBlock)
        };
    } else if (variant === "FullWidthHeroContentType") {
        return {
            NAME: "FullWidthHeroBannerBlock",
            VAL: Gql_FullWidthHeroBanner_Decoder_Block_bs_get(content.VAL.fullWidthHeroBannerBlock)
        };
    } else if (variant === "BoardOfDirectorsBlockContentType") {
        return {
            NAME: "BoardOfDirectorsBlock",
            VAL: Gql_BoardOfDirectorsBlock_Decoder_Block_bs_get(content.VAL.boardOfDirectorsBlock)
        };
    } else if (variant === "AutomateAndSimplifyContentType") {
        return {
            NAME: "AutomateSimplifyBlock",
            VAL: Gql_AutomateSimplify_Decoder_bs_get(content.VAL.automateSimplifyBlock)
        };
    } else if (variant === "UniqueSellingPointsBlockContentType") {
        return {
            NAME: "UniqueSellingPointsBlock",
            VAL: Gql_UniqueSellingPointsBlock_Decoder_Block_bs_get(content.VAL.uniqueSellingPointsBlock)
        };
    } else if (variant === "TrustpilotWidgetBlockContentType") {
        return {
            NAME: "TrustpilotWidgetBlock",
            VAL: Gql_TrustpilotWidgetBlock_Decoder_bs_get(content.VAL.trustpilotWidgetBlock)
        };
    } else if (variant === "CustomerCareBannerContentType") {
        return {
            NAME: "CustomerCareBannerBlock",
            VAL: Gql_CustomerCareBanner_Decoder_bs_get(content.VAL.customerCareBannerBlock)
        };
    } else if (variant === "EnrichedTextBlockContentType") {
        return {
            NAME: "EnrichedTextBlock",
            VAL: Gql_EnrichedTextBlock_Decoder_bs/* get */.U(content.VAL.enrichedTextBlock)
        };
    } else if (variant === "HeroTileBlockContentType") {
        return {
            NAME: "HeroTileBlock",
            VAL: Gql_HeroTiles_Decoder_HeroTileBlock_bs_get(content.VAL.heroTileBlock)
        };
    } else {
        return;
    }
}
var Private = {
    contentBlockSwitch: contentBlockSwitch
};
function seoMetaBlock(content) {
    if (typeof content === "object" && content.NAME === "SeoMetaContentType") {
        return {
            NAME: "SeoMetaBlock",
            VAL: Gql_SeoMeta_Decoder_bs/* get */.U(content.VAL.seoMetaBlock)
        };
    }
}
var SeoMetaMapper = {
    seoMetaBlock: seoMetaBlock
};
function storeContentBlock(content) {
    if (typeof content === "object" && content.NAME === "StoreContentContentType") {
        return {
            NAME: "StoreContentBlock",
            VAL: Gql_StoreContent_Decoder_bs_get(content.VAL.storeContentBlock)
        };
    }
}
var StoreContentMapper = {
    storeContentBlock: storeContentBlock
};
function Gql_PageBuilder_Decoder_bs_get(content) {
    var content_blocks = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.content_blocks, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), contentBlockSwitch);
    var seo_meta = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.seo_meta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), seoMetaBlock), 0);
    var store_content = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.store_content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), storeContentBlock), 0);
    return {
        content_blocks: content_blocks,
        seo_meta: seo_meta,
        store_content: store_content
    };
}
var Gql_PageBuilder_Decoder_bs_CategoryTileBlock;
var Gql_PageBuilder_Decoder_bs_AppDownloadBlock;
var Gql_PageBuilder_Decoder_bs_FullWidthTextBlock;
var Gql_PageBuilder_Decoder_bs_NewsletterBlock;
var Gql_PageBuilder_Decoder_bs_HeroTileBlock;
var Gql_PageBuilder_Decoder_bs_UniqueSellingPointsBlock;
var Gql_PageBuilder_Decoder_bs_PromoTileBlock;
var Gql_PageBuilder_Decoder_bs_StatsTilesBlock;
var Gql_PageBuilder_Decoder_bs_VideoTextPromoBlock;
var Gql_PageBuilder_Decoder_bs_SkuCarouselBlock;
var Gql_PageBuilder_Decoder_bs_TeamMembersBlock;
var Gql_PageBuilder_Decoder_bs_CustomerCareBannerBlock;
var Gql_PageBuilder_Decoder_bs_CustomerCareCallUsBlock;
var Gql_PageBuilder_Decoder_bs_BoardOfDirectorsBlock;
var Gql_PageBuilder_Decoder_bs_FullWidthHeroBannerBlock;
var Gql_PageBuilder_Decoder_bs_InnovativeWayToGiftBlock;
var Gql_PageBuilder_Decoder_bs_IconCardBlock;
var Gql_PageBuilder_Decoder_bs_GiftExperienceBlock;
var Gql_PageBuilder_Decoder_bs_TestimonialCarouselBlock;
var Gql_PageBuilder_Decoder_bs_BusinessContactFormBlock;
var Gql_PageBuilder_Decoder_bs_AutomateSimplifyBlock;
var Gql_PageBuilder_Decoder_bs_OffsetTilesBlock;
var Gql_PageBuilder_Decoder_bs_FAQBlock;
var Gql_PageBuilder_Decoder_bs_LandingPageContactFormBlock;
var Gql_PageBuilder_Decoder_bs_StoreContentBlock;
var Gql_PageBuilder_Decoder_bs_SeoMetaBlock;
var Gql_PageBuilder_Decoder_bs_EnrichedTextBlock;
var Gql_PageBuilder_Decoder_bs_TrustpilotWidgetBlock;
var Gql_PageBuilder_Decoder_bs_NarrowBannerFull;
var Gql_PageBuilder_Decoder_bs_ProductHeroBlock;
var Gql_PageBuilder_Decoder_bs_SellingPointsBlock;
var Gql_PageBuilder_Decoder_bs_NarrowCta;
var Gql_PageBuilder_Decoder_bs_HeroBanner;
 /* Gql__StoreContent__Decoder Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Page/Gql__Page__Decoder__Page.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_Page_Decoder_Page_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "PageContentType") {
        return;
    }
    var contentData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.VAL.content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var content$1 = contentData !== undefined && typeof contentData === "object" && contentData.NAME === "PageBuilderContentType" ? Gql_PageBuilder_Decoder_bs_get(contentData.VAL.pageContent) : undefined;
    return {
        content: content$1
    };
}
var HeaderBlock;
var NavMenuBlock;
var FooterBlock;
var PageBuilder;
 /* Gql__PageBuilder__Decoder Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Page/Gql__Page__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function decode(gqlQueryResult) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.itemsByType, []), 0), GqlUtils_bs.id), Gql_Page_Decoder_Page_bs_get);
}
function handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(decode(result._0.data));
    }
    Pino_bs/* logger.error */.k.error({
        err: result._0,
        type: "Page decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Decoder = {
    decode: decode,
    handleResult: handleResult
};
var Page;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Footer_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FooterBlock on FooterContainerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    link_columns  {\n      __typename\n      value  {\n        __typename\n        ...on LinkColumnContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          title  {\n            __typename\n            value\n          }\n          links  {\n            __typename\n            value  {\n              __typename\n              ...on LinkItemContentType   {\n                __typename\n                system  {\n                  __typename\n                  id\n                  codename\n                }\n                link_text  {\n                  __typename\n                  value\n                }\n                url  {\n                  __typename\n                  value\n                }\n                open_in_new_window  {\n                  __typename\n                  value  {\n                    __typename\n                    codename\n                  }\n                }\n                links  {\n                  __typename\n                  value  {\n                    __typename\n                    ...on FontAwesomeContentType   {\n                      ...FontAwesomeIcon\n                    }\n                    ...on ImageContentType   {\n                      ...Image\n                    }\n                  }\n                }\n              }\n              ...on MailtoLinkContentType   {\n                __typename\n                system  {\n                  __typename\n                  id\n                  codename\n                }\n                link_title  {\n                  __typename\n                  value\n                }\n                email_address  {\n                  __typename\n                  value\n                }\n              }\n              ...on OnetrustCookieSettingButtonContentType   {\n                __typename\n                system  {\n                  __typename\n                  id\n                  codename\n                }\n                text  {\n                  __typename\n                  value\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    subscribe_title  {\n      __typename\n      value\n    }\n    subscribe_description  {\n      __typename\n      value\n    }\n    subscribe_helper_text  {\n      __typename\n      value\n    }\n    subscribe_cta  {\n      __typename\n      value\n    }\n    cta_style__style  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    region_selector_text  {\n      __typename\n      value\n    }\n    app_store_title  {\n      __typename\n      value\n    }\n    app_stores_container  {\n      __typename\n      value  {\n        __typename\n        ...on AppStoreItemContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          app_store_name  {\n            __typename\n            value\n          }\n          app_store_download_link  {\n            __typename\n            value\n          }\n          app_store_asset  {\n            __typename\n            value  {\n              __typename\n              name\n              description\n              url\n              width\n              height\n            }\n          }\n        }\n      }\n    }\n    footer_disclaimer_level_1  {\n      __typename\n      value\n    }\n    footer_disclaimer_level_2  {\n      __typename\n      value\n    }\n    background_colour  {\n      __typename\n      value\n    }\n    heading_colour  {\n      __typename\n      value\n    }\n    body_colour  {\n      __typename\n      value\n    }\n    body_hover_colour  {\n      __typename\n      value\n    }\n    icon_background_colour  {\n      __typename\n      value\n    }\n    icon_hover_background_colour  {\n      __typename\n      value\n    }\n    icon_colour  {\n      __typename\n      value\n    }\n    icon_hover_colour  {\n      __typename\n      value\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_Footer_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_Footer_Fragment_bs_Raw = {};
var Gql_Footer_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_Footer_Fragment_bs_templateObject(), frag_0, frag_1);
}(Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.query, $$Image.query);
function Gql_Footer_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.link_columns;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "LinkColumnContentType") {
                    var value$1 = value.system;
                    var value$2 = value.title;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.links;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var typename = value["__typename"];
                                var tmp;
                                switch(typename){
                                    case "LinkItemContentType":
                                        var value$1 = value.system;
                                        var value$2 = value.link_text;
                                        var tmp$1;
                                        if (value$2 == null) {
                                            tmp$1 = undefined;
                                        } else {
                                            var value$3 = value$2.value;
                                            tmp$1 = {
                                                __typename: value$2.__typename,
                                                value: !(value$3 == null) ? value$3 : undefined
                                            };
                                        }
                                        var value$4 = value.url;
                                        var tmp$2;
                                        if (value$4 == null) {
                                            tmp$2 = undefined;
                                        } else {
                                            var value$5 = value$4.value;
                                            tmp$2 = {
                                                __typename: value$4.__typename,
                                                value: !(value$5 == null) ? value$5 : undefined
                                            };
                                        }
                                        var value$6 = value.open_in_new_window;
                                        var tmp$3;
                                        if (value$6 == null) {
                                            tmp$3 = undefined;
                                        } else {
                                            var value$7 = value$6.value;
                                            tmp$3 = {
                                                __typename: value$6.__typename,
                                                value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                                    if (value == null) {
                                                        return;
                                                    }
                                                    var value$1 = value.codename;
                                                    return {
                                                        __typename: value.__typename,
                                                        codename: !(value$1 == null) ? value$1 : undefined
                                                    };
                                                }, value$7) : undefined
                                            };
                                        }
                                        var value$8 = value.links;
                                        var tmp$4;
                                        if (value$8 == null) {
                                            tmp$4 = undefined;
                                        } else {
                                            var value$9 = value$8.value;
                                            tmp$4 = {
                                                __typename: value$8.__typename,
                                                value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                                    if (value == null) {
                                                        return;
                                                    }
                                                    var typename = value["__typename"];
                                                    var tmp;
                                                    switch(typename){
                                                        case "FontAwesomeContentType":
                                                            tmp = {
                                                                NAME: "FontAwesomeContentType",
                                                                VAL: {
                                                                    fontAwesomeIcon: Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.verifyArgsAndParse("FontAwesomeIcon", value)
                                                                }
                                                            };
                                                            break;
                                                        case "ImageContentType":
                                                            tmp = {
                                                                NAME: "ImageContentType",
                                                                VAL: {
                                                                    image: $$Image.verifyArgsAndParse("Image", value)
                                                                }
                                                            };
                                                            break;
                                                        default:
                                                            tmp = {
                                                                NAME: "UnspecifiedFragment",
                                                                VAL: typename
                                                            };
                                                    }
                                                    return tmp;
                                                }, value$9) : undefined
                                            };
                                        }
                                        tmp = {
                                            NAME: "LinkItemContentType",
                                            VAL: {
                                                __typename: value.__typename,
                                                system: {
                                                    __typename: value$1.__typename,
                                                    id: value$1.id,
                                                    codename: value$1.codename
                                                },
                                                link_text: tmp$1,
                                                url: tmp$2,
                                                open_in_new_window: tmp$3,
                                                links: tmp$4
                                            }
                                        };
                                        break;
                                    case "MailtoLinkContentType":
                                        var value$10 = value.system;
                                        var value$11 = value.link_title;
                                        var tmp$5;
                                        if (value$11 == null) {
                                            tmp$5 = undefined;
                                        } else {
                                            var value$12 = value$11.value;
                                            tmp$5 = {
                                                __typename: value$11.__typename,
                                                value: !(value$12 == null) ? value$12 : undefined
                                            };
                                        }
                                        var value$13 = value.email_address;
                                        var tmp$6;
                                        if (value$13 == null) {
                                            tmp$6 = undefined;
                                        } else {
                                            var value$14 = value$13.value;
                                            tmp$6 = {
                                                __typename: value$13.__typename,
                                                value: !(value$14 == null) ? value$14 : undefined
                                            };
                                        }
                                        tmp = {
                                            NAME: "MailtoLinkContentType",
                                            VAL: {
                                                __typename: value.__typename,
                                                system: {
                                                    __typename: value$10.__typename,
                                                    id: value$10.id,
                                                    codename: value$10.codename
                                                },
                                                link_title: tmp$5,
                                                email_address: tmp$6
                                            }
                                        };
                                        break;
                                    case "OnetrustCookieSettingButtonContentType":
                                        var value$15 = value.system;
                                        var value$16 = value.text;
                                        var tmp$7;
                                        if (value$16 == null) {
                                            tmp$7 = undefined;
                                        } else {
                                            var value$17 = value$16.value;
                                            tmp$7 = {
                                                __typename: value$16.__typename,
                                                value: !(value$17 == null) ? value$17 : undefined
                                            };
                                        }
                                        tmp = {
                                            NAME: "OnetrustCookieSettingButtonContentType",
                                            VAL: {
                                                __typename: value.__typename,
                                                system: {
                                                    __typename: value$15.__typename,
                                                    id: value$15.id,
                                                    codename: value$15.codename
                                                },
                                                text: tmp$7
                                            }
                                        };
                                        break;
                                    default:
                                        tmp = {
                                            NAME: "UnspecifiedFragment",
                                            VAL: typename
                                        };
                                }
                                return tmp;
                            }, value$5) : undefined
                        };
                    }
                    tmp = {
                        NAME: "LinkColumnContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            title: tmp$1,
                            links: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$3) : undefined
        };
    }
    var value$4 = value.subscribe_title;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.subscribe_description;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.subscribe_helper_text;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.subscribe_cta;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    var value$12 = value.cta_style__style;
    var tmp$5;
    if (value$12 == null) {
        tmp$5 = undefined;
    } else {
        var value$13 = value$12.value;
        tmp$5 = {
            __typename: value$12.__typename,
            value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$13) : undefined
        };
    }
    var value$14 = value.region_selector_text;
    var tmp$6;
    if (value$14 == null) {
        tmp$6 = undefined;
    } else {
        var value$15 = value$14.value;
        tmp$6 = {
            __typename: value$14.__typename,
            value: !(value$15 == null) ? value$15 : undefined
        };
    }
    var value$16 = value.app_store_title;
    var tmp$7;
    if (value$16 == null) {
        tmp$7 = undefined;
    } else {
        var value$17 = value$16.value;
        tmp$7 = {
            __typename: value$16.__typename,
            value: !(value$17 == null) ? value$17 : undefined
        };
    }
    var value$18 = value.app_stores_container;
    var tmp$8;
    if (value$18 == null) {
        tmp$8 = undefined;
    } else {
        var value$19 = value$18.value;
        tmp$8 = {
            __typename: value$18.__typename,
            value: !(value$19 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "AppStoreItemContentType") {
                    var value$1 = value.system;
                    var value$2 = value.app_store_name;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.app_store_download_link;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.app_store_asset;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                if (value == null) {
                                    return;
                                }
                                var value$1 = value.name;
                                var value$2 = value.description;
                                var value$3 = value.url;
                                var value$4 = value.width;
                                var value$5 = value.height;
                                return {
                                    __typename: value.__typename,
                                    name: !(value$1 == null) ? value$1 : undefined,
                                    description: !(value$2 == null) ? value$2 : undefined,
                                    url: !(value$3 == null) ? value$3 : undefined,
                                    width: !(value$4 == null) ? value$4 : undefined,
                                    height: !(value$5 == null) ? value$5 : undefined
                                };
                            }, value$7) : undefined
                        };
                    }
                    tmp = {
                        NAME: "AppStoreItemContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            app_store_name: tmp$1,
                            app_store_download_link: tmp$2,
                            app_store_asset: tmp$3
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$19) : undefined
        };
    }
    var value$20 = value.footer_disclaimer_level_1;
    var tmp$9;
    if (value$20 == null) {
        tmp$9 = undefined;
    } else {
        var value$21 = value$20.value;
        tmp$9 = {
            __typename: value$20.__typename,
            value: !(value$21 == null) ? value$21 : undefined
        };
    }
    var value$22 = value.footer_disclaimer_level_2;
    var tmp$10;
    if (value$22 == null) {
        tmp$10 = undefined;
    } else {
        var value$23 = value$22.value;
        tmp$10 = {
            __typename: value$22.__typename,
            value: !(value$23 == null) ? value$23 : undefined
        };
    }
    var value$24 = value.background_colour;
    var tmp$11;
    if (value$24 == null) {
        tmp$11 = undefined;
    } else {
        var value$25 = value$24.value;
        tmp$11 = {
            __typename: value$24.__typename,
            value: !(value$25 == null) ? value$25 : undefined
        };
    }
    var value$26 = value.heading_colour;
    var tmp$12;
    if (value$26 == null) {
        tmp$12 = undefined;
    } else {
        var value$27 = value$26.value;
        tmp$12 = {
            __typename: value$26.__typename,
            value: !(value$27 == null) ? value$27 : undefined
        };
    }
    var value$28 = value.body_colour;
    var tmp$13;
    if (value$28 == null) {
        tmp$13 = undefined;
    } else {
        var value$29 = value$28.value;
        tmp$13 = {
            __typename: value$28.__typename,
            value: !(value$29 == null) ? value$29 : undefined
        };
    }
    var value$30 = value.body_hover_colour;
    var tmp$14;
    if (value$30 == null) {
        tmp$14 = undefined;
    } else {
        var value$31 = value$30.value;
        tmp$14 = {
            __typename: value$30.__typename,
            value: !(value$31 == null) ? value$31 : undefined
        };
    }
    var value$32 = value.icon_background_colour;
    var tmp$15;
    if (value$32 == null) {
        tmp$15 = undefined;
    } else {
        var value$33 = value$32.value;
        tmp$15 = {
            __typename: value$32.__typename,
            value: !(value$33 == null) ? value$33 : undefined
        };
    }
    var value$34 = value.icon_hover_background_colour;
    var tmp$16;
    if (value$34 == null) {
        tmp$16 = undefined;
    } else {
        var value$35 = value$34.value;
        tmp$16 = {
            __typename: value$34.__typename,
            value: !(value$35 == null) ? value$35 : undefined
        };
    }
    var value$36 = value.icon_colour;
    var tmp$17;
    if (value$36 == null) {
        tmp$17 = undefined;
    } else {
        var value$37 = value$36.value;
        tmp$17 = {
            __typename: value$36.__typename,
            value: !(value$37 == null) ? value$37 : undefined
        };
    }
    var value$38 = value.icon_hover_colour;
    var tmp$18;
    if (value$38 == null) {
        tmp$18 = undefined;
    } else {
        var value$39 = value$38.value;
        tmp$18 = {
            __typename: value$38.__typename,
            value: !(value$39 == null) ? value$39 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        link_columns: tmp,
        subscribe_title: tmp$1,
        subscribe_description: tmp$2,
        subscribe_helper_text: tmp$3,
        subscribe_cta: tmp$4,
        cta_style__style: tmp$5,
        region_selector_text: tmp$6,
        app_store_title: tmp$7,
        app_stores_container: tmp$8,
        footer_disclaimer_level_1: tmp$9,
        footer_disclaimer_level_2: tmp$10,
        background_colour: tmp$11,
        heading_colour: tmp$12,
        body_colour: tmp$13,
        body_hover_colour: tmp$14,
        icon_background_colour: tmp$15,
        icon_hover_background_colour: tmp$16,
        icon_colour: tmp$17,
        icon_hover_colour: tmp$18
    };
}
function Gql_Footer_Fragment_bs_serialize(value) {
    var value$1 = value.icon_hover_colour;
    var icon_hover_colour;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        icon_hover_colour = {
            __typename: value$4,
            value: value$3
        };
    } else {
        icon_hover_colour = null;
    }
    var value$5 = value.icon_colour;
    var icon_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        icon_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        icon_colour = null;
    }
    var value$9 = value.icon_hover_background_colour;
    var icon_hover_background_colour;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        icon_hover_background_colour = {
            __typename: value$12,
            value: value$11
        };
    } else {
        icon_hover_background_colour = null;
    }
    var value$13 = value.icon_background_colour;
    var icon_background_colour;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        icon_background_colour = {
            __typename: value$16,
            value: value$15
        };
    } else {
        icon_background_colour = null;
    }
    var value$17 = value.body_hover_colour;
    var body_hover_colour;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        body_hover_colour = {
            __typename: value$20,
            value: value$19
        };
    } else {
        body_hover_colour = null;
    }
    var value$21 = value.body_colour;
    var body_colour;
    if (value$21 !== undefined) {
        var value$22 = value$21.value;
        var value$23 = value$22 !== undefined ? value$22 : null;
        var value$24 = value$21.__typename;
        body_colour = {
            __typename: value$24,
            value: value$23
        };
    } else {
        body_colour = null;
    }
    var value$25 = value.heading_colour;
    var heading_colour;
    if (value$25 !== undefined) {
        var value$26 = value$25.value;
        var value$27 = value$26 !== undefined ? value$26 : null;
        var value$28 = value$25.__typename;
        heading_colour = {
            __typename: value$28,
            value: value$27
        };
    } else {
        heading_colour = null;
    }
    var value$29 = value.background_colour;
    var background_colour;
    if (value$29 !== undefined) {
        var value$30 = value$29.value;
        var value$31 = value$30 !== undefined ? value$30 : null;
        var value$32 = value$29.__typename;
        background_colour = {
            __typename: value$32,
            value: value$31
        };
    } else {
        background_colour = null;
    }
    var value$33 = value.footer_disclaimer_level_2;
    var footer_disclaimer_level_2;
    if (value$33 !== undefined) {
        var value$34 = value$33.value;
        var value$35 = value$34 !== undefined ? value$34 : null;
        var value$36 = value$33.__typename;
        footer_disclaimer_level_2 = {
            __typename: value$36,
            value: value$35
        };
    } else {
        footer_disclaimer_level_2 = null;
    }
    var value$37 = value.footer_disclaimer_level_1;
    var footer_disclaimer_level_1;
    if (value$37 !== undefined) {
        var value$38 = value$37.value;
        var value$39 = value$38 !== undefined ? value$38 : null;
        var value$40 = value$37.__typename;
        footer_disclaimer_level_1 = {
            __typename: value$40,
            value: value$39
        };
    } else {
        footer_disclaimer_level_1 = null;
    }
    var value$41 = value.app_stores_container;
    var app_stores_container;
    if (value$41 !== undefined) {
        var value$42 = value$41.value;
        var value$43 = value$42 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.app_store_asset;
            var app_store_asset;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.height;
                    var height = value$1 !== undefined ? value$1 : null;
                    var value$2 = value.width;
                    var width = value$2 !== undefined ? value$2 : null;
                    var value$3 = value.url;
                    var url = value$3 !== undefined ? value$3 : null;
                    var value$4 = value.description;
                    var description = value$4 !== undefined ? value$4 : null;
                    var value$5 = value.name;
                    var name = value$5 !== undefined ? value$5 : null;
                    var value$6 = value.__typename;
                    return {
                        __typename: value$6,
                        name: name,
                        description: description,
                        url: url,
                        width: width,
                        height: height
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                app_store_asset = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                app_store_asset = null;
            }
            var value$6 = value$1.app_store_download_link;
            var app_store_download_link;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                app_store_download_link = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                app_store_download_link = null;
            }
            var value$10 = value$1.app_store_name;
            var app_store_name;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                app_store_name = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                app_store_name = null;
            }
            var value$14 = value$1.system;
            var value$15 = value$14.codename;
            var value$16 = value$14.id;
            var value$17 = value$14.__typename;
            var system = {
                __typename: value$17,
                id: value$16,
                codename: value$15
            };
            return {
                __typename: "AppStoreItemContentType",
                system: system,
                app_store_name: app_store_name,
                app_store_download_link: app_store_download_link,
                app_store_asset: app_store_asset
            };
        }, value$42) : null;
        var value$44 = value$41.__typename;
        app_stores_container = {
            __typename: value$44,
            value: value$43
        };
    } else {
        app_stores_container = null;
    }
    var value$45 = value.app_store_title;
    var app_store_title;
    if (value$45 !== undefined) {
        var value$46 = value$45.value;
        var value$47 = value$46 !== undefined ? value$46 : null;
        var value$48 = value$45.__typename;
        app_store_title = {
            __typename: value$48,
            value: value$47
        };
    } else {
        app_store_title = null;
    }
    var value$49 = value.region_selector_text;
    var region_selector_text;
    if (value$49 !== undefined) {
        var value$50 = value$49.value;
        var value$51 = value$50 !== undefined ? value$50 : null;
        var value$52 = value$49.__typename;
        region_selector_text = {
            __typename: value$52,
            value: value$51
        };
    } else {
        region_selector_text = null;
    }
    var value$53 = value.cta_style__style;
    var cta_style__style;
    if (value$53 !== undefined) {
        var value$54 = value$53.value;
        var value$55 = value$54 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$54) : null;
        var value$56 = value$53.__typename;
        cta_style__style = {
            __typename: value$56,
            value: value$55
        };
    } else {
        cta_style__style = null;
    }
    var value$57 = value.subscribe_cta;
    var subscribe_cta;
    if (value$57 !== undefined) {
        var value$58 = value$57.value;
        var value$59 = value$58 !== undefined ? value$58 : null;
        var value$60 = value$57.__typename;
        subscribe_cta = {
            __typename: value$60,
            value: value$59
        };
    } else {
        subscribe_cta = null;
    }
    var value$61 = value.subscribe_helper_text;
    var subscribe_helper_text;
    if (value$61 !== undefined) {
        var value$62 = value$61.value;
        var value$63 = value$62 !== undefined ? value$62 : null;
        var value$64 = value$61.__typename;
        subscribe_helper_text = {
            __typename: value$64,
            value: value$63
        };
    } else {
        subscribe_helper_text = null;
    }
    var value$65 = value.subscribe_description;
    var subscribe_description;
    if (value$65 !== undefined) {
        var value$66 = value$65.value;
        var value$67 = value$66 !== undefined ? value$66 : null;
        var value$68 = value$65.__typename;
        subscribe_description = {
            __typename: value$68,
            value: value$67
        };
    } else {
        subscribe_description = null;
    }
    var value$69 = value.subscribe_title;
    var subscribe_title;
    if (value$69 !== undefined) {
        var value$70 = value$69.value;
        var value$71 = value$70 !== undefined ? value$70 : null;
        var value$72 = value$69.__typename;
        subscribe_title = {
            __typename: value$72,
            value: value$71
        };
    } else {
        subscribe_title = null;
    }
    var value$73 = value.link_columns;
    var link_columns;
    if (value$73 !== undefined) {
        var value$74 = value$73.value;
        var value$75 = value$74 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME !== "LinkColumnContentType") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.links;
            var links;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var variant = value.NAME;
                    if (variant === "MailtoLinkContentType") {
                        var value$1 = value.VAL;
                        var value$2 = value$1.email_address;
                        var email_address;
                        if (value$2 !== undefined) {
                            var value$3 = value$2.value;
                            var value$4 = value$3 !== undefined ? value$3 : null;
                            var value$5 = value$2.__typename;
                            email_address = {
                                __typename: value$5,
                                value: value$4
                            };
                        } else {
                            email_address = null;
                        }
                        var value$6 = value$1.link_title;
                        var link_title;
                        if (value$6 !== undefined) {
                            var value$7 = value$6.value;
                            var value$8 = value$7 !== undefined ? value$7 : null;
                            var value$9 = value$6.__typename;
                            link_title = {
                                __typename: value$9,
                                value: value$8
                            };
                        } else {
                            link_title = null;
                        }
                        var value$10 = value$1.system;
                        var value$11 = value$10.codename;
                        var value$12 = value$10.id;
                        var value$13 = value$10.__typename;
                        var system = {
                            __typename: value$13,
                            id: value$12,
                            codename: value$11
                        };
                        return {
                            __typename: "MailtoLinkContentType",
                            system: system,
                            link_title: link_title,
                            email_address: email_address
                        };
                    }
                    if (variant === "UnspecifiedFragment") {
                        return {};
                    }
                    if (variant === "OnetrustCookieSettingButtonContentType") {
                        var value$14 = value.VAL;
                        var value$15 = value$14.text;
                        var text;
                        if (value$15 !== undefined) {
                            var value$16 = value$15.value;
                            var value$17 = value$16 !== undefined ? value$16 : null;
                            var value$18 = value$15.__typename;
                            text = {
                                __typename: value$18,
                                value: value$17
                            };
                        } else {
                            text = null;
                        }
                        var value$19 = value$14.system;
                        var value$20 = value$19.codename;
                        var value$21 = value$19.id;
                        var value$22 = value$19.__typename;
                        var system$1 = {
                            __typename: value$22,
                            id: value$21,
                            codename: value$20
                        };
                        return {
                            __typename: "OnetrustCookieSettingButtonContentType",
                            system: system$1,
                            text: text
                        };
                    }
                    var value$23 = value.VAL;
                    var value$24 = value$23.links;
                    var links;
                    if (value$24 !== undefined) {
                        var value$25 = value$24.value;
                        var value$26 = value$25 !== undefined ? js_array/* map */.UI(function(value) {
                            if (value === undefined) {
                                return null;
                            }
                            var variant = value.NAME;
                            if (variant === "UnspecifiedFragment") {
                                return {};
                            } else if (variant === "FontAwesomeContentType") {
                                return js_array/* reduce */.u4(deepMerge, function(prim) {
                                    return {};
                                }, [
                                    Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.serialize(value.VAL.fontAwesomeIcon)
                                ]);
                            } else {
                                return js_array/* reduce */.u4(deepMerge, function(prim) {
                                    return {};
                                }, [
                                    $$Image.serialize(value.VAL.image)
                                ]);
                            }
                        }, value$25) : null;
                        var value$27 = value$24.__typename;
                        links = {
                            __typename: value$27,
                            value: value$26
                        };
                    } else {
                        links = null;
                    }
                    var value$28 = value$23.open_in_new_window;
                    var open_in_new_window;
                    if (value$28 !== undefined) {
                        var value$29 = value$28.value;
                        var value$30 = value$29 !== undefined ? js_array/* map */.UI(function(value) {
                            if (value === undefined) {
                                return null;
                            }
                            var value$1 = value.codename;
                            var codename = value$1 !== undefined ? value$1 : null;
                            var value$2 = value.__typename;
                            return {
                                __typename: value$2,
                                codename: codename
                            };
                        }, value$29) : null;
                        var value$31 = value$28.__typename;
                        open_in_new_window = {
                            __typename: value$31,
                            value: value$30
                        };
                    } else {
                        open_in_new_window = null;
                    }
                    var value$32 = value$23.url;
                    var url;
                    if (value$32 !== undefined) {
                        var value$33 = value$32.value;
                        var value$34 = value$33 !== undefined ? value$33 : null;
                        var value$35 = value$32.__typename;
                        url = {
                            __typename: value$35,
                            value: value$34
                        };
                    } else {
                        url = null;
                    }
                    var value$36 = value$23.link_text;
                    var link_text;
                    if (value$36 !== undefined) {
                        var value$37 = value$36.value;
                        var value$38 = value$37 !== undefined ? value$37 : null;
                        var value$39 = value$36.__typename;
                        link_text = {
                            __typename: value$39,
                            value: value$38
                        };
                    } else {
                        link_text = null;
                    }
                    var value$40 = value$23.system;
                    var value$41 = value$40.codename;
                    var value$42 = value$40.id;
                    var value$43 = value$40.__typename;
                    var system$2 = {
                        __typename: value$43,
                        id: value$42,
                        codename: value$41
                    };
                    return {
                        __typename: "LinkItemContentType",
                        system: system$2,
                        link_text: link_text,
                        url: url,
                        open_in_new_window: open_in_new_window,
                        links: links
                    };
                }, value$3) : null;
                var value$5 = value$2.__typename;
                links = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                links = null;
            }
            var value$6 = value$1.title;
            var title;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                title = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                title = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "LinkColumnContentType",
                system: system,
                title: title,
                links: links
            };
        }, value$74) : null;
        var value$76 = value$73.__typename;
        link_columns = {
            __typename: value$76,
            value: value$75
        };
    } else {
        link_columns = null;
    }
    var value$77 = value.system;
    var value$78 = value$77.codename;
    var value$79 = value$77.id;
    var value$80 = value$77.__typename;
    var system = {
        __typename: value$80,
        id: value$79,
        codename: value$78
    };
    var value$81 = value.__typename;
    return {
        __typename: value$81,
        system: system,
        link_columns: link_columns,
        subscribe_title: subscribe_title,
        subscribe_description: subscribe_description,
        subscribe_helper_text: subscribe_helper_text,
        subscribe_cta: subscribe_cta,
        cta_style__style: cta_style__style,
        region_selector_text: region_selector_text,
        app_store_title: app_store_title,
        app_stores_container: app_stores_container,
        footer_disclaimer_level_1: footer_disclaimer_level_1,
        footer_disclaimer_level_2: footer_disclaimer_level_2,
        background_colour: background_colour,
        heading_colour: heading_colour,
        body_colour: body_colour,
        body_hover_colour: body_hover_colour,
        icon_background_colour: icon_background_colour,
        icon_hover_background_colour: icon_hover_background_colour,
        icon_colour: icon_colour,
        icon_hover_colour: icon_hover_colour
    };
}
function Gql_Footer_Fragment_bs_verifyArgsAndParse(_FooterBlock, value) {
    return Gql_Footer_Fragment_bs_parse(value);
}
function Gql_Footer_Fragment_bs_verifyName(param) {}
var Gql_Footer_Fragment_bs_FooterBlock = {
    Raw: Gql_Footer_Fragment_bs_Raw,
    query: Gql_Footer_Fragment_bs_query,
    parse: Gql_Footer_Fragment_bs_parse,
    serialize: Gql_Footer_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_Footer_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_Footer_Fragment_bs_verifyName
};
var Gql_Footer_Fragment_bs_FontAwesomeIcon;
var Gql_Footer_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Header/Gql__Header__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Header_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment HeaderBlock on PageContentType   {\n    __typename\n    subpages  {\n      __typename\n      value  {\n        __typename\n        ...on PageContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          show_in_navigation  {\n            __typename\n            value  {\n              __typename\n              name\n            }\n          }\n          title  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_Header_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_Header_Fragment_bs_Raw = {};
var Gql_Header_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_Header_Fragment_bs_templateObject());
function Gql_Header_Fragment_bs_parse(value) {
    var value$1 = value.subpages;
    var tmp;
    if (value$1 == null) {
        tmp = undefined;
    } else {
        var value$2 = value$1.value;
        tmp = {
            __typename: value$1.__typename,
            value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "PageContentType") {
                    var value$1 = value.system;
                    var value$2 = value.show_in_navigation;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                                if (!(value == null)) {
                                    return {
                                        __typename: value.__typename,
                                        name: value.name
                                    };
                                }
                            }, value$3) : undefined
                        };
                    }
                    var value$4 = value.title;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    var value$6 = value.url;
                    var tmp$3;
                    if (value$6 == null) {
                        tmp$3 = undefined;
                    } else {
                        var value$7 = value$6.value;
                        tmp$3 = {
                            __typename: value$6.__typename,
                            value: !(value$7 == null) ? value$7 : undefined
                        };
                    }
                    tmp = {
                        NAME: "PageContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            show_in_navigation: tmp$1,
                            title: tmp$2,
                            url: tmp$3
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$2) : undefined
        };
    }
    return {
        __typename: value.__typename,
        subpages: tmp
    };
}
function Gql_Header_Fragment_bs_serialize(value) {
    var value$1 = value.subpages;
    var subpages;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.url;
            var url;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                url = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                url = null;
            }
            var value$6 = value$1.title;
            var title;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                title = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                title = null;
            }
            var value$10 = value$1.show_in_navigation;
            var show_in_navigation;
            if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
                    if (value === undefined) {
                        return null;
                    }
                    var value$1 = value.name;
                    var value$2 = value.__typename;
                    return {
                        __typename: value$2,
                        name: value$1
                    };
                }, value$11) : null;
                var value$13 = value$10.__typename;
                show_in_navigation = {
                    __typename: value$13,
                    value: value$12
                };
            } else {
                show_in_navigation = null;
            }
            var value$14 = value$1.system;
            var value$15 = value$14.codename;
            var value$16 = value$14.id;
            var value$17 = value$14.__typename;
            var system = {
                __typename: value$17,
                id: value$16,
                codename: value$15
            };
            return {
                __typename: "PageContentType",
                system: system,
                show_in_navigation: show_in_navigation,
                title: title,
                url: url
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        subpages = {
            __typename: value$4,
            value: value$3
        };
    } else {
        subpages = null;
    }
    var value$5 = value.__typename;
    return {
        __typename: value$5,
        subpages: subpages
    };
}
function Gql_Header_Fragment_bs_verifyArgsAndParse(_HeaderBlock, value) {
    return Gql_Header_Fragment_bs_parse(value);
}
function Gql_Header_Fragment_bs_verifyName(param) {}
var Gql_Header_Fragment_bs_HeaderBlock = {
    Raw: Gql_Header_Fragment_bs_Raw,
    query: Gql_Header_Fragment_bs_query,
    parse: Gql_Header_Fragment_bs_parse,
    serialize: Gql_Header_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_Header_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_Header_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/LandingPage/Gql__LandingPage__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_LandingPage_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query LandingPageContent($language: String!, $preview: Boolean, $url: String!)  {\n    itemsByType(type: "landing_page", limit: 1, depth: 5, language: $language, preview: $preview, filters: [{type: EQUALS, prop: "elements.url", val: $url}])  {\n      __typename\n      ...on LandingPageContentType   {\n        __typename\n        logo  {\n          __typename\n          value  {\n            __typename\n            ...on ImageContentType   {\n              ...Image\n            }\n          }\n        }\n        navigation_buttons  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        subpages  {\n          __typename\n          value  {\n            __typename\n            ...on PageContentType   {\n              ...HeaderBlock\n            }\n          }\n        }\n        content  {\n          __typename\n          value  {\n            __typename\n            ...on PageBuilderContentType   {\n              ...PageContent\n            }\n          }\n        }\n        footer  {\n          __typename\n          value  {\n            __typename\n            ...on FooterContainerContentType   {\n              ...FooterBlock\n            }\n          }\n        }\n      }\n    }\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_LandingPage_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Gql_LandingPage_Query_bs_Raw = {};
var Gql_LandingPage_Query_bs_query = function(frag_0, frag_1, frag_2, frag_3, frag_4) {
    return (__webpack_require__(46829).gql)(Gql_LandingPage_Query_bs_templateObject(), frag_0, frag_1, frag_2, frag_3, frag_4);
}(CallToAction.query, Gql_Footer_Fragment_bs_FooterBlock.query, Gql_Header_Fragment_bs_HeaderBlock.query, $$Image.query, PageContent.query);
function Gql_LandingPage_Query_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "LandingPageContentType") {
                var value$1 = value.logo;
                var tmp$1;
                if (value$1 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$2 = value$1.value;
                    tmp$1 = {
                        __typename: value$1.__typename,
                        value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "ImageContentType" ? {
                                NAME: "ImageContentType",
                                VAL: {
                                    image: $$Image.verifyArgsAndParse("Image", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$2) : undefined
                    };
                }
                var value$3 = value.navigation_buttons;
                var tmp$2;
                if (value$3 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$4 = value$3.value;
                    tmp$2 = {
                        __typename: value$3.__typename,
                        value: !(value$4 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$4) : undefined
                    };
                }
                var value$5 = value.subpages;
                var tmp$3;
                if (value$5 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$6 = value$5.value;
                    tmp$3 = {
                        __typename: value$5.__typename,
                        value: !(value$6 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "PageContentType" ? {
                                NAME: "PageContentType",
                                VAL: {
                                    headerBlock: Gql_Header_Fragment_bs_HeaderBlock.verifyArgsAndParse("HeaderBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$6) : undefined
                    };
                }
                var value$7 = value.content;
                var tmp$4;
                if (value$7 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$8 = value$7.value;
                    tmp$4 = {
                        __typename: value$7.__typename,
                        value: !(value$8 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "PageBuilderContentType" ? {
                                NAME: "PageBuilderContentType",
                                VAL: {
                                    pageContent: PageContent.verifyArgsAndParse("PageContent", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$8) : undefined
                    };
                }
                var value$9 = value.footer;
                var tmp$5;
                if (value$9 == null) {
                    tmp$5 = undefined;
                } else {
                    var value$10 = value$9.value;
                    tmp$5 = {
                        __typename: value$9.__typename,
                        value: !(value$10 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "FooterContainerContentType" ? {
                                NAME: "FooterContainerContentType",
                                VAL: {
                                    footerBlock: Gql_Footer_Fragment_bs_FooterBlock.verifyArgsAndParse("FooterBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$10) : undefined
                    };
                }
                tmp = {
                    NAME: "LandingPageContentType",
                    VAL: {
                        __typename: value.__typename,
                        logo: tmp$1,
                        navigation_buttons: tmp$2,
                        subpages: tmp$3,
                        content: tmp$4,
                        footer: tmp$5
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_LandingPage_Query_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME === "UnspecifiedFragment") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.footer;
        var footer;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "FooterContainerContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_Footer_Fragment_bs_FooterBlock.serialize(value.VAL.footerBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$3) : null;
            var value$5 = value$2.__typename;
            footer = {
                __typename: value$5,
                value: value$4
            };
        } else {
            footer = null;
        }
        var value$6 = value$1.content;
        var content;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            PageContent.serialize(value.VAL.pageContent)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$7) : null;
            var value$9 = value$6.__typename;
            content = {
                __typename: value$9,
                value: value$8
            };
        } else {
            content = null;
        }
        var value$10 = value$1.subpages;
        var subpages;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_Header_Fragment_bs_HeaderBlock.serialize(value.VAL.headerBlock)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$11) : null;
            var value$13 = value$10.__typename;
            subpages = {
                __typename: value$13,
                value: value$12
            };
        } else {
            subpages = null;
        }
        var value$14 = value$1.navigation_buttons;
        var navigation_buttons;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$15) : null;
            var value$17 = value$14.__typename;
            navigation_buttons = {
                __typename: value$17,
                value: value$16
            };
        } else {
            navigation_buttons = null;
        }
        var value$18 = value$1.logo;
        var logo;
        if (value$18 !== undefined) {
            var value$19 = value$18.value;
            var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            $$Image.serialize(value.VAL.image)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$19) : null;
            var value$21 = value$18.__typename;
            logo = {
                __typename: value$21,
                value: value$20
            };
        } else {
            logo = null;
        }
        return {
            __typename: "LandingPageContentType",
            logo: logo,
            navigation_buttons: navigation_buttons,
            subpages: subpages,
            content: content,
            footer: footer
        };
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function Gql_LandingPage_Query_bs_serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        url: inp.url
    };
}
function Gql_LandingPage_Query_bs_makeVariables(language, preview, url, param) {
    return {
        language: language,
        preview: preview,
        url: url
    };
}
var Gql_LandingPage_Query_bs_Query_inner = {
    Raw: Gql_LandingPage_Query_bs_Raw,
    query: Gql_LandingPage_Query_bs_query,
    parse: Gql_LandingPage_Query_bs_parse,
    serialize: Gql_LandingPage_Query_bs_serialize,
    serializeVariables: Gql_LandingPage_Query_bs_serializeVariables,
    makeVariables: Gql_LandingPage_Query_bs_makeVariables
};
var Gql_LandingPage_Query_bs_include = Extend({
    query: Gql_LandingPage_Query_bs_query,
    Raw: Gql_LandingPage_Query_bs_Raw,
    parse: Gql_LandingPage_Query_bs_parse,
    serialize: Gql_LandingPage_Query_bs_serialize,
    serializeVariables: Gql_LandingPage_Query_bs_serializeVariables
});
var Gql_LandingPage_Query_bs_Query_refetchQueryDescription = Gql_LandingPage_Query_bs_include.refetchQueryDescription;
var Gql_LandingPage_Query_bs_Query_use = Gql_LandingPage_Query_bs_include.use;
var Gql_LandingPage_Query_bs_Query_useLazy = Gql_LandingPage_Query_bs_include.useLazy;
var Gql_LandingPage_Query_bs_Query_useLazyWithVariables = Gql_LandingPage_Query_bs_include.useLazyWithVariables;
var Gql_LandingPage_Query_bs_Query = {
    Query_inner: Gql_LandingPage_Query_bs_Query_inner,
    Raw: Gql_LandingPage_Query_bs_Raw,
    query: Gql_LandingPage_Query_bs_query,
    parse: Gql_LandingPage_Query_bs_parse,
    serialize: Gql_LandingPage_Query_bs_serialize,
    serializeVariables: Gql_LandingPage_Query_bs_serializeVariables,
    makeVariables: Gql_LandingPage_Query_bs_makeVariables,
    refetchQueryDescription: Gql_LandingPage_Query_bs_Query_refetchQueryDescription,
    use: Gql_LandingPage_Query_bs_Query_use,
    useLazy: Gql_LandingPage_Query_bs_Query_useLazy,
    useLazyWithVariables: Gql_LandingPage_Query_bs_Query_useLazyWithVariables
};
var Gql_LandingPage_Query_bs_CallToAction;
var Gql_LandingPage_Query_bs_PageContent;
var Gql_LandingPage_Query_bs_HeaderBlock;
var Gql_LandingPage_Query_bs_$$Image;
var Gql_LandingPage_Query_bs_FooterBlock;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Header/Gql__Header__Decoder__Page.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_Header_Decoder_Page_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "PageContentType") {
        return;
    }
    var subpage = content.VAL;
    var showInNavigation = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(subpage.show_in_navigation, function(p) {
        return p.value;
    }), []), GqlUtils_bs.id), 0), function(x) {
        return x.name === "Yes";
    }), false);
    if (!showInNavigation) {
        return;
    }
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(subpage.title, function(t) {
        return t.value;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(subpage.url, function(u) {
        return u.value;
    }), "");
    var smartLink_itemId = subpage.system.id;
    var smartLink_codename = subpage.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        url: url,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Header/Gql__Header__Decoder__Homepage.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_Header_Decoder_Homepage_bs_get(header) {
    var subpages = belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(header.subpages, function(subpagesContent) {
        return subpagesContent.value;
    }), []), GqlUtils_bs.id);
    var subpagesData = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(subpages, Gql_Header_Decoder_Page_bs_get), GqlUtils_bs.id);
    if (subpagesData.length !== 0) {
        return subpagesData;
    }
}
var Gql_Header_Decoder_Homepage_bs_Page;
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__FooterContainer.bs.js + 7 modules
var Gql_Footer_Decoder_FooterContainer_bs = __webpack_require__(91842);
;// CONCATENATED MODULE: ./src/api/graphql/LandingPage/Gql__LandingPage__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









function Gql_LandingPage_Decoder_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "LandingPageContentType") {
        return;
    }
    var c = content.VAL;
    var logo = belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.logo, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(i) {
        if (typeof i === "object" && i.NAME === "ImageContentType") {
            return Gql_Image_Decoder_bs/* get */.U(i.VAL.image);
        }
    }), 0), Gql_Image_Decoder_bs/* emptyImage */.P);
    var navigation_buttons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.navigation_buttons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var headerBlockData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.subpages, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var header = headerBlockData !== undefined && typeof headerBlockData === "object" && headerBlockData.NAME === "PageContentType" ? Gql_Header_Decoder_Homepage_bs_get(headerBlockData.VAL.headerBlock) : undefined;
    var contentData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.content, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var content$1 = contentData !== undefined && typeof contentData === "object" && contentData.NAME === "PageBuilderContentType" ? Gql_PageBuilder_Decoder_bs_get(contentData.VAL.pageContent) : undefined;
    var footerBlockData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.footer, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var footer = footerBlockData !== undefined && typeof footerBlockData === "object" && footerBlockData.NAME === "FooterContainerContentType" ? Gql_Footer_Decoder_FooterContainer_bs/* get */.U2(footerBlockData.VAL.footerBlock) : undefined;
    return {
        logo: logo,
        navigation_buttons: navigation_buttons,
        header: header,
        content: content$1,
        footer: footer
    };
}
var LandingPage = {
    get: Gql_LandingPage_Decoder_bs_get
};
function Gql_LandingPage_Decoder_bs_decode(gqlQueryResult) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.itemsByType, []), 0), GqlUtils_bs.id), Gql_LandingPage_Decoder_bs_get);
}
function Gql_LandingPage_Decoder_bs_handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(Gql_LandingPage_Decoder_bs_decode(result._0.data));
    }
    Pino_bs/* logger.error */.k.error({
        err: result._0,
        type: "Landing Page decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Gql_LandingPage_Decoder_bs_Decoder = {
    decode: Gql_LandingPage_Decoder_bs_decode,
    handleResult: Gql_LandingPage_Decoder_bs_handleResult
};
var Gql_LandingPage_Decoder_bs_$$Image;
var Gql_LandingPage_Decoder_bs_HeaderBlock;
var Gql_LandingPage_Decoder_bs_PageBuilder;
var Gql_LandingPage_Decoder_bs_FooterBlock;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/StoreCategory/Gql__StoreCategory__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_StoreCategory_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query PageContent($language: String!, $preview: Boolean, $codename: String!)  {\n    itemsByType(type: "store_category", limit: 1, depth: 5, language: $language, preview: $preview, filters: [{type: EQUALS, prop: "system.codename", val: $codename}])  {\n      __typename\n      ...on StoreCategoryContentType   {\n        __typename\n        system  {\n          __typename\n          id\n          codename\n        }\n        slug  {\n          __typename\n          value\n        }\n        display_name  {\n          __typename\n          value\n        }\n        page_top_content  {\n          __typename\n          value  {\n            __typename\n            ...on EnrichedTextBlockContentType   {\n              ...EnrichedTextBlock\n            }\n          }\n        }\n        seo_meta  {\n          __typename\n          value  {\n            __typename\n            ...on SeoMetaContentType   {\n              ...SeoMetaBlock\n            }\n          }\n        }\n      }\n    }\n  }\n  ',
        "\n  ",
        "\n"
    ]);
    Gql_StoreCategory_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Gql_StoreCategory_Query_bs_Raw = {};
var Gql_StoreCategory_Query_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_StoreCategory_Query_bs_templateObject(), frag_0, frag_1);
}(EnrichedTextBlock.query, SeoMetaBlock.query);
function Gql_StoreCategory_Query_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "StoreCategoryContentType") {
                var value$1 = value.system;
                var value$2 = value.slug;
                var tmp$1;
                if (value$2 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$3 = value$2.value;
                    tmp$1 = {
                        __typename: value$2.__typename,
                        value: !(value$3 == null) ? value$3 : undefined
                    };
                }
                var value$4 = value.display_name;
                var tmp$2;
                if (value$4 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$5 = value$4.value;
                    tmp$2 = {
                        __typename: value$4.__typename,
                        value: !(value$5 == null) ? value$5 : undefined
                    };
                }
                var value$6 = value.page_top_content;
                var tmp$3;
                if (value$6 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$7 = value$6.value;
                    tmp$3 = {
                        __typename: value$6.__typename,
                        value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "EnrichedTextBlockContentType" ? {
                                NAME: "EnrichedTextBlockContentType",
                                VAL: {
                                    enrichedTextBlock: EnrichedTextBlock.verifyArgsAndParse("EnrichedTextBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$7) : undefined
                    };
                }
                var value$8 = value.seo_meta;
                var tmp$4;
                if (value$8 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$9 = value$8.value;
                    tmp$4 = {
                        __typename: value$8.__typename,
                        value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "SeoMetaContentType" ? {
                                NAME: "SeoMetaContentType",
                                VAL: {
                                    seoMetaBlock: SeoMetaBlock.verifyArgsAndParse("SeoMetaBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$9) : undefined
                    };
                }
                tmp = {
                    NAME: "StoreCategoryContentType",
                    VAL: {
                        __typename: value.__typename,
                        system: {
                            __typename: value$1.__typename,
                            id: value$1.id,
                            codename: value$1.codename
                        },
                        slug: tmp$1,
                        display_name: tmp$2,
                        page_top_content: tmp$3,
                        seo_meta: tmp$4
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_StoreCategory_Query_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME === "UnspecifiedFragment") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.seo_meta;
        var seo_meta;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "SeoMetaContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            SeoMetaBlock.serialize(value.VAL.seoMetaBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$3) : null;
            var value$5 = value$2.__typename;
            seo_meta = {
                __typename: value$5,
                value: value$4
            };
        } else {
            seo_meta = null;
        }
        var value$6 = value$1.page_top_content;
        var page_top_content;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "EnrichedTextBlockContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            EnrichedTextBlock.serialize(value.VAL.enrichedTextBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$7) : null;
            var value$9 = value$6.__typename;
            page_top_content = {
                __typename: value$9,
                value: value$8
            };
        } else {
            page_top_content = null;
        }
        var value$10 = value$1.display_name;
        var display_name;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? value$11 : null;
            var value$13 = value$10.__typename;
            display_name = {
                __typename: value$13,
                value: value$12
            };
        } else {
            display_name = null;
        }
        var value$14 = value$1.slug;
        var slug;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? value$15 : null;
            var value$17 = value$14.__typename;
            slug = {
                __typename: value$17,
                value: value$16
            };
        } else {
            slug = null;
        }
        var value$18 = value$1.system;
        var value$19 = value$18.codename;
        var value$20 = value$18.id;
        var value$21 = value$18.__typename;
        var system = {
            __typename: value$21,
            id: value$20,
            codename: value$19
        };
        return {
            __typename: "StoreCategoryContentType",
            system: system,
            slug: slug,
            display_name: display_name,
            page_top_content: page_top_content,
            seo_meta: seo_meta
        };
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function Gql_StoreCategory_Query_bs_serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        codename: inp.codename
    };
}
function Gql_StoreCategory_Query_bs_makeVariables(language, preview, codename, param) {
    return {
        language: language,
        preview: preview,
        codename: codename
    };
}
var Gql_StoreCategory_Query_bs_Query_inner = {
    Raw: Gql_StoreCategory_Query_bs_Raw,
    query: Gql_StoreCategory_Query_bs_query,
    parse: Gql_StoreCategory_Query_bs_parse,
    serialize: Gql_StoreCategory_Query_bs_serialize,
    serializeVariables: Gql_StoreCategory_Query_bs_serializeVariables,
    makeVariables: Gql_StoreCategory_Query_bs_makeVariables
};
var Gql_StoreCategory_Query_bs_include = Extend({
    query: Gql_StoreCategory_Query_bs_query,
    Raw: Gql_StoreCategory_Query_bs_Raw,
    parse: Gql_StoreCategory_Query_bs_parse,
    serialize: Gql_StoreCategory_Query_bs_serialize,
    serializeVariables: Gql_StoreCategory_Query_bs_serializeVariables
});
var Gql_StoreCategory_Query_bs_Query_refetchQueryDescription = Gql_StoreCategory_Query_bs_include.refetchQueryDescription;
var Gql_StoreCategory_Query_bs_Query_use = Gql_StoreCategory_Query_bs_include.use;
var Gql_StoreCategory_Query_bs_Query_useLazy = Gql_StoreCategory_Query_bs_include.useLazy;
var Gql_StoreCategory_Query_bs_Query_useLazyWithVariables = Gql_StoreCategory_Query_bs_include.useLazyWithVariables;
var Gql_StoreCategory_Query_bs_Query = {
    Query_inner: Gql_StoreCategory_Query_bs_Query_inner,
    Raw: Gql_StoreCategory_Query_bs_Raw,
    query: Gql_StoreCategory_Query_bs_query,
    parse: Gql_StoreCategory_Query_bs_parse,
    serialize: Gql_StoreCategory_Query_bs_serialize,
    serializeVariables: Gql_StoreCategory_Query_bs_serializeVariables,
    makeVariables: Gql_StoreCategory_Query_bs_makeVariables,
    refetchQueryDescription: Gql_StoreCategory_Query_bs_Query_refetchQueryDescription,
    use: Gql_StoreCategory_Query_bs_Query_use,
    useLazy: Gql_StoreCategory_Query_bs_Query_useLazy,
    useLazyWithVariables: Gql_StoreCategory_Query_bs_Query_useLazyWithVariables
};
var Gql_StoreCategory_Query_bs_EnrichedTextBlock;
var Gql_StoreCategory_Query_bs_SeoMetaBlock;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuTheme/Gql__SkuTheme__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SkuTheme_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SkuThemeFragment on SkuThemeContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    code  {\n      __typename\n      value\n    }\n    image  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    key_colour  {\n      __typename\n      value\n    }\n    text_colour  {\n      __typename\n      value\n    }\n    enabled  {\n      __typename\n      value  {\n        __typename\n        name\n      }\n    }\n  }\n"
    ]);
    Gql_SkuTheme_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_SkuTheme_Fragment_bs_Raw = {};
var Gql_SkuTheme_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_SkuTheme_Fragment_bs_templateObject());
function Gql_SkuTheme_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.code;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.image;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$5) : undefined
        };
    }
    var value$6 = value.key_colour;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.text_colour;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.enabled;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                if (!(value == null)) {
                    return {
                        __typename: value.__typename,
                        name: value.name
                    };
                }
            }, value$11) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        code: tmp,
        image: tmp$1,
        key_colour: tmp$2,
        text_colour: tmp$3,
        enabled: tmp$4
    };
}
function Gql_SkuTheme_Fragment_bs_serialize(value) {
    var value$1 = value.enabled;
    var enabled;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.name;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                name: value$1
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        enabled = {
            __typename: value$4,
            value: value$3
        };
    } else {
        enabled = null;
    }
    var value$5 = value.text_colour;
    var text_colour;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        text_colour = {
            __typename: value$8,
            value: value$7
        };
    } else {
        text_colour = null;
    }
    var value$9 = value.key_colour;
    var key_colour;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        key_colour = {
            __typename: value$12,
            value: value$11
        };
    } else {
        key_colour = null;
    }
    var value$13 = value.image;
    var image;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        image = {
            __typename: value$16,
            value: value$15
        };
    } else {
        image = null;
    }
    var value$17 = value.code;
    var code;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        code = {
            __typename: value$20,
            value: value$19
        };
    } else {
        code = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        code: code,
        image: image,
        key_colour: key_colour,
        text_colour: text_colour,
        enabled: enabled
    };
}
function Gql_SkuTheme_Fragment_bs_verifyArgsAndParse(_SkuThemeFragment, value) {
    return Gql_SkuTheme_Fragment_bs_parse(value);
}
function Gql_SkuTheme_Fragment_bs_verifyName(param) {}
var SkuThemeFragment = {
    Raw: Gql_SkuTheme_Fragment_bs_Raw,
    query: Gql_SkuTheme_Fragment_bs_query,
    parse: Gql_SkuTheme_Fragment_bs_parse,
    serialize: Gql_SkuTheme_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SkuTheme_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SkuTheme_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SkuPresentation_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment SkuPresentationFragment on SkuPresentationContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    themes  {\n      __typename\n      value  {\n        __typename\n        ...on SkuThemeContentType   {\n          ...SkuThemeFragment\n        }\n      }\n    }\n    seo_meta  {\n      __typename\n      value  {\n        __typename\n        ...on SeoMetaContentType   {\n          ...SeoMetaBlock\n        }\n      }\n    }\n    sold_out  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    audience  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    interest  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    occasion  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    location_au  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    location___nz  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    location___uk  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n    location___us  {\n      __typename\n      name\n      value  {\n        __typename\n        name\n        codename\n      }\n      taxonomyGroup\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_SkuPresentation_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_SkuPresentation_Fragment_bs_Raw = {};
var Gql_SkuPresentation_Fragment_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_SkuPresentation_Fragment_bs_templateObject(), frag_0, frag_1);
}(SeoMetaBlock.query, SkuThemeFragment.query);
function Gql_SkuPresentation_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.themes;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "SkuThemeContentType" ? {
                    NAME: "SkuThemeContentType",
                    VAL: {
                        skuThemeFragment: SkuThemeFragment.verifyArgsAndParse("SkuThemeFragment", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$3) : undefined
        };
    }
    var value$4 = value.seo_meta;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "SeoMetaContentType" ? {
                    NAME: "SeoMetaContentType",
                    VAL: {
                        seoMetaBlock: SeoMetaBlock.verifyArgsAndParse("SeoMetaBlock", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    var value$6 = value.sold_out;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.audience;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        var value$10 = value$8.taxonomyGroup;
        tmp$3 = {
            __typename: value$8.__typename,
            name: value$8.name,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined,
            taxonomyGroup: !(value$10 == null) ? value$10 : undefined
        };
    }
    var value$11 = value.interest;
    var tmp$4;
    if (value$11 == null) {
        tmp$4 = undefined;
    } else {
        var value$12 = value$11.value;
        var value$13 = value$11.taxonomyGroup;
        tmp$4 = {
            __typename: value$11.__typename,
            name: value$11.name,
            value: !(value$12 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$12) : undefined,
            taxonomyGroup: !(value$13 == null) ? value$13 : undefined
        };
    }
    var value$14 = value.occasion;
    var tmp$5;
    if (value$14 == null) {
        tmp$5 = undefined;
    } else {
        var value$15 = value$14.value;
        var value$16 = value$14.taxonomyGroup;
        tmp$5 = {
            __typename: value$14.__typename,
            name: value$14.name,
            value: !(value$15 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$15) : undefined,
            taxonomyGroup: !(value$16 == null) ? value$16 : undefined
        };
    }
    var value$17 = value.location_au;
    var tmp$6;
    if (value$17 == null) {
        tmp$6 = undefined;
    } else {
        var value$18 = value$17.value;
        var value$19 = value$17.taxonomyGroup;
        tmp$6 = {
            __typename: value$17.__typename,
            name: value$17.name,
            value: !(value$18 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$18) : undefined,
            taxonomyGroup: !(value$19 == null) ? value$19 : undefined
        };
    }
    var value$20 = value.location___nz;
    var tmp$7;
    if (value$20 == null) {
        tmp$7 = undefined;
    } else {
        var value$21 = value$20.value;
        var value$22 = value$20.taxonomyGroup;
        tmp$7 = {
            __typename: value$20.__typename,
            name: value$20.name,
            value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$21) : undefined,
            taxonomyGroup: !(value$22 == null) ? value$22 : undefined
        };
    }
    var value$23 = value.location___uk;
    var tmp$8;
    if (value$23 == null) {
        tmp$8 = undefined;
    } else {
        var value$24 = value$23.value;
        var value$25 = value$23.taxonomyGroup;
        tmp$8 = {
            __typename: value$23.__typename,
            name: value$23.name,
            value: !(value$24 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$24) : undefined,
            taxonomyGroup: !(value$25 == null) ? value$25 : undefined
        };
    }
    var value$26 = value.location___us;
    var tmp$9;
    if (value$26 == null) {
        tmp$9 = undefined;
    } else {
        var value$27 = value$26.value;
        var value$28 = value$26.taxonomyGroup;
        tmp$9 = {
            __typename: value$26.__typename,
            name: value$26.name,
            value: !(value$27 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    name: value.name,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$27) : undefined,
            taxonomyGroup: !(value$28 == null) ? value$28 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        themes: tmp,
        seo_meta: tmp$1,
        sold_out: tmp$2,
        audience: tmp$3,
        interest: tmp$4,
        occasion: tmp$5,
        location_au: tmp$6,
        location___nz: tmp$7,
        location___uk: tmp$8,
        location___us: tmp$9
    };
}
function Gql_SkuPresentation_Fragment_bs_serialize(value) {
    var value$1 = value.location___us;
    var location___us;
    if (value$1 !== undefined) {
        var value$2 = value$1.taxonomyGroup;
        var taxonomyGroup = value$2 !== undefined ? value$2 : null;
        var value$3 = value$1.value;
        var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$3) : null;
        var value$5 = value$1.name;
        var value$6 = value$1.__typename;
        location___us = {
            __typename: value$6,
            name: value$5,
            value: value$4,
            taxonomyGroup: taxonomyGroup
        };
    } else {
        location___us = null;
    }
    var value$7 = value.location___uk;
    var location___uk;
    if (value$7 !== undefined) {
        var value$8 = value$7.taxonomyGroup;
        var taxonomyGroup$1 = value$8 !== undefined ? value$8 : null;
        var value$9 = value$7.value;
        var value$10 = value$9 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$9) : null;
        var value$11 = value$7.name;
        var value$12 = value$7.__typename;
        location___uk = {
            __typename: value$12,
            name: value$11,
            value: value$10,
            taxonomyGroup: taxonomyGroup$1
        };
    } else {
        location___uk = null;
    }
    var value$13 = value.location___nz;
    var location___nz;
    if (value$13 !== undefined) {
        var value$14 = value$13.taxonomyGroup;
        var taxonomyGroup$2 = value$14 !== undefined ? value$14 : null;
        var value$15 = value$13.value;
        var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$15) : null;
        var value$17 = value$13.name;
        var value$18 = value$13.__typename;
        location___nz = {
            __typename: value$18,
            name: value$17,
            value: value$16,
            taxonomyGroup: taxonomyGroup$2
        };
    } else {
        location___nz = null;
    }
    var value$19 = value.location_au;
    var location_au;
    if (value$19 !== undefined) {
        var value$20 = value$19.taxonomyGroup;
        var taxonomyGroup$3 = value$20 !== undefined ? value$20 : null;
        var value$21 = value$19.value;
        var value$22 = value$21 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$21) : null;
        var value$23 = value$19.name;
        var value$24 = value$19.__typename;
        location_au = {
            __typename: value$24,
            name: value$23,
            value: value$22,
            taxonomyGroup: taxonomyGroup$3
        };
    } else {
        location_au = null;
    }
    var value$25 = value.occasion;
    var occasion;
    if (value$25 !== undefined) {
        var value$26 = value$25.taxonomyGroup;
        var taxonomyGroup$4 = value$26 !== undefined ? value$26 : null;
        var value$27 = value$25.value;
        var value$28 = value$27 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$27) : null;
        var value$29 = value$25.name;
        var value$30 = value$25.__typename;
        occasion = {
            __typename: value$30,
            name: value$29,
            value: value$28,
            taxonomyGroup: taxonomyGroup$4
        };
    } else {
        occasion = null;
    }
    var value$31 = value.interest;
    var interest;
    if (value$31 !== undefined) {
        var value$32 = value$31.taxonomyGroup;
        var taxonomyGroup$5 = value$32 !== undefined ? value$32 : null;
        var value$33 = value$31.value;
        var value$34 = value$33 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$33) : null;
        var value$35 = value$31.name;
        var value$36 = value$31.__typename;
        interest = {
            __typename: value$36,
            name: value$35,
            value: value$34,
            taxonomyGroup: taxonomyGroup$5
        };
    } else {
        interest = null;
    }
    var value$37 = value.audience;
    var audience;
    if (value$37 !== undefined) {
        var value$38 = value$37.taxonomyGroup;
        var taxonomyGroup$6 = value$38 !== undefined ? value$38 : null;
        var value$39 = value$37.value;
        var value$40 = value$39 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.name;
            var value$3 = value.__typename;
            return {
                __typename: value$3,
                name: value$2,
                codename: codename
            };
        }, value$39) : null;
        var value$41 = value$37.name;
        var value$42 = value$37.__typename;
        audience = {
            __typename: value$42,
            name: value$41,
            value: value$40,
            taxonomyGroup: taxonomyGroup$6
        };
    } else {
        audience = null;
    }
    var value$43 = value.sold_out;
    var sold_out;
    if (value$43 !== undefined) {
        var value$44 = value$43.value;
        var value$45 = value$44 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$44) : null;
        var value$46 = value$43.__typename;
        sold_out = {
            __typename: value$46,
            value: value$45
        };
    } else {
        sold_out = null;
    }
    var value$47 = value.seo_meta;
    var seo_meta;
    if (value$47 !== undefined) {
        var value$48 = value$47.value;
        var value$49 = value$48 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "SeoMetaContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        SeoMetaBlock.serialize(value.VAL.seoMetaBlock)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$48) : null;
        var value$50 = value$47.__typename;
        seo_meta = {
            __typename: value$50,
            value: value$49
        };
    } else {
        seo_meta = null;
    }
    var value$51 = value.themes;
    var themes;
    if (value$51 !== undefined) {
        var value$52 = value$51.value;
        var value$53 = value$52 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        SkuThemeFragment.serialize(value.VAL.skuThemeFragment)
                    ]);
                }
            } else {
                return null;
            }
        }, value$52) : null;
        var value$54 = value$51.__typename;
        themes = {
            __typename: value$54,
            value: value$53
        };
    } else {
        themes = null;
    }
    var value$55 = value.system;
    var value$56 = value$55.codename;
    var value$57 = value$55.id;
    var value$58 = value$55.__typename;
    var system = {
        __typename: value$58,
        id: value$57,
        codename: value$56
    };
    var value$59 = value.__typename;
    return {
        __typename: value$59,
        system: system,
        themes: themes,
        seo_meta: seo_meta,
        sold_out: sold_out,
        audience: audience,
        interest: interest,
        occasion: occasion,
        location_au: location_au,
        location___nz: location___nz,
        location___uk: location___uk,
        location___us: location___us
    };
}
function Gql_SkuPresentation_Fragment_bs_verifyArgsAndParse(_SkuPresentationFragment, value) {
    return Gql_SkuPresentation_Fragment_bs_parse(value);
}
function Gql_SkuPresentation_Fragment_bs_verifyName(param) {}
var SkuPresentationFragment = {
    Raw: Gql_SkuPresentation_Fragment_bs_Raw,
    query: Gql_SkuPresentation_Fragment_bs_query,
    parse: Gql_SkuPresentation_Fragment_bs_parse,
    serialize: Gql_SkuPresentation_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_SkuPresentation_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_SkuPresentation_Fragment_bs_verifyName
};
var Gql_SkuPresentation_Fragment_bs_SkuThemeFragment;
var Gql_SkuPresentation_Fragment_bs_SeoMetaBlock;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SkuPresentation_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query SkuPresentation($language: String!, $preview: Boolean, $codename: String!)  {\n    itemsByType(type: "sku_presentation", language: $language, preview: $preview, limit: 1, filters: [{type: EQUALS, prop: "system.codename", val: $codename}])  {\n      __typename\n      ...on SkuPresentationContentType   {\n        ...SkuPresentationFragment\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    Gql_SkuPresentation_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_SkuPresentation_Query_bs_Raw = {};
var Gql_SkuPresentation_Query_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SkuPresentation_Query_bs_templateObject(), frag_0);
}(SkuPresentationFragment.query);
function Gql_SkuPresentation_Query_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp = typename === "SkuPresentationContentType" ? {
                NAME: "SkuPresentationContentType",
                VAL: {
                    skuPresentationFragment: SkuPresentationFragment.verifyArgsAndParse("SkuPresentationFragment", value)
                }
            } : {
                NAME: "UnspecifiedFragment",
                VAL: typename
            };
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_SkuPresentation_Query_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value !== undefined) {
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    SkuPresentationFragment.serialize(value.VAL.skuPresentationFragment)
                ]);
            }
        } else {
            return null;
        }
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function Gql_SkuPresentation_Query_bs_serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        codename: inp.codename
    };
}
function Gql_SkuPresentation_Query_bs_makeVariables(language, preview, codename, param) {
    return {
        language: language,
        preview: preview,
        codename: codename
    };
}
var Gql_SkuPresentation_Query_bs_Query_inner = {
    Raw: Gql_SkuPresentation_Query_bs_Raw,
    query: Gql_SkuPresentation_Query_bs_query,
    parse: Gql_SkuPresentation_Query_bs_parse,
    serialize: Gql_SkuPresentation_Query_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_bs_serializeVariables,
    makeVariables: Gql_SkuPresentation_Query_bs_makeVariables
};
var Gql_SkuPresentation_Query_bs_include = Extend({
    query: Gql_SkuPresentation_Query_bs_query,
    Raw: Gql_SkuPresentation_Query_bs_Raw,
    parse: Gql_SkuPresentation_Query_bs_parse,
    serialize: Gql_SkuPresentation_Query_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_bs_serializeVariables
});
var Gql_SkuPresentation_Query_bs_Query_refetchQueryDescription = Gql_SkuPresentation_Query_bs_include.refetchQueryDescription;
var Gql_SkuPresentation_Query_bs_Query_use = Gql_SkuPresentation_Query_bs_include.use;
var Gql_SkuPresentation_Query_bs_Query_useLazy = Gql_SkuPresentation_Query_bs_include.useLazy;
var Gql_SkuPresentation_Query_bs_Query_useLazyWithVariables = Gql_SkuPresentation_Query_bs_include.useLazyWithVariables;
var Gql_SkuPresentation_Query_bs_Query = {
    Query_inner: Gql_SkuPresentation_Query_bs_Query_inner,
    Raw: Gql_SkuPresentation_Query_bs_Raw,
    query: Gql_SkuPresentation_Query_bs_query,
    parse: Gql_SkuPresentation_Query_bs_parse,
    serialize: Gql_SkuPresentation_Query_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_bs_serializeVariables,
    makeVariables: Gql_SkuPresentation_Query_bs_makeVariables,
    refetchQueryDescription: Gql_SkuPresentation_Query_bs_Query_refetchQueryDescription,
    use: Gql_SkuPresentation_Query_bs_Query_use,
    useLazy: Gql_SkuPresentation_Query_bs_Query_useLazy,
    useLazyWithVariables: Gql_SkuPresentation_Query_bs_Query_useLazyWithVariables
};
var Gql_SkuPresentation_Query_bs_SeoMetaBlock;
var Gql_SkuPresentation_Query_bs_SkuPresentationFragment;
 /* query Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/StoreCategory/Gql__StoreCategory__Decoder.bs.js
var Gql_StoreCategory_Decoder_bs = __webpack_require__(29160);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json.bs.js
var Json_bs = __webpack_require__(57687);
// EXTERNAL MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Fragment__Decoder.bs.js + 1 modules
var Gql_SkuPresentation_Fragment_Decoder_bs = __webpack_require__(22775);
;// CONCATENATED MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function Gql_SkuPresentation_Decoder_bs_get(content) {
    if (typeof content === "object" && content.NAME === "SkuPresentationContentType") {
        return Gql_SkuPresentation_Fragment_Decoder_bs/* decode */.Jx(content.VAL.skuPresentationFragment);
    }
}
var SkuPresentation = {
    get: Gql_SkuPresentation_Decoder_bs_get
};
function Gql_SkuPresentation_Decoder_bs_decode(gqlQueryResult) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.itemsByType, []), 0), GqlUtils_bs.id), Gql_SkuPresentation_Decoder_bs_get);
}
function Gql_SkuPresentation_Decoder_bs_handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(Gql_SkuPresentation_Decoder_bs_decode(result._0.data));
    }
    Pino_bs/* logger.error */.k.error({
        err: result._0,
        type: "Sku Presentation decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Gql_SkuPresentation_Decoder_bs_Decoder = {
    decode: Gql_SkuPresentation_Decoder_bs_decode,
    handleResult: Gql_SkuPresentation_Decoder_bs_handleResult
};
function Gql_SkuPresentation_Decoder_bs_parse(data) {
    return Belt_Option.map(data === null ? undefined : Caml_option.some(data), Json.parseOrRaise);
}
var FragmentDecoder;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeaderLogo/Gql__HeaderLogo__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeaderLogo_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment HeaderLogo on HeaderLogoContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    classic_logo_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    classic_logo_width  {\n      __typename\n      value\n    }\n    business_logo_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    business_logo_width  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_HeaderLogo_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_HeaderLogo_Fragment_bs_Raw = {};
var Gql_HeaderLogo_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_HeaderLogo_Fragment_bs_templateObject());
function Gql_HeaderLogo_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.classic_logo_asset;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$3) : undefined
        };
    }
    var value$4 = value.classic_logo_width;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.business_logo_asset;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.business_logo_width;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        classic_logo_asset: tmp,
        classic_logo_width: tmp$1,
        business_logo_asset: tmp$2,
        business_logo_width: tmp$3
    };
}
function Gql_HeaderLogo_Fragment_bs_serialize(value) {
    var value$1 = value.business_logo_width;
    var business_logo_width;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        business_logo_width = {
            __typename: value$4,
            value: value$3
        };
    } else {
        business_logo_width = null;
    }
    var value$5 = value.business_logo_asset;
    var business_logo_asset;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        business_logo_asset = {
            __typename: value$8,
            value: value$7
        };
    } else {
        business_logo_asset = null;
    }
    var value$9 = value.classic_logo_width;
    var classic_logo_width;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        classic_logo_width = {
            __typename: value$12,
            value: value$11
        };
    } else {
        classic_logo_width = null;
    }
    var value$13 = value.classic_logo_asset;
    var classic_logo_asset;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$14) : null;
        var value$16 = value$13.__typename;
        classic_logo_asset = {
            __typename: value$16,
            value: value$15
        };
    } else {
        classic_logo_asset = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        classic_logo_asset: classic_logo_asset,
        classic_logo_width: classic_logo_width,
        business_logo_asset: business_logo_asset,
        business_logo_width: business_logo_width
    };
}
function Gql_HeaderLogo_Fragment_bs_verifyArgsAndParse(_HeaderLogo, value) {
    return Gql_HeaderLogo_Fragment_bs_parse(value);
}
function Gql_HeaderLogo_Fragment_bs_verifyName(param) {}
var HeaderLogo = {
    Raw: Gql_HeaderLogo_Fragment_bs_Raw,
    query: Gql_HeaderLogo_Fragment_bs_query,
    parse: Gql_HeaderLogo_Fragment_bs_parse,
    serialize: Gql_HeaderLogo_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeaderLogo_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeaderLogo_Fragment_bs_verifyName
};
var Gql_HeaderLogo_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/AlertBanner/Gql__AlertBanner__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_AlertBanner_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AlertBannerBlock on AlertBannerContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    desktop_text  {\n      __typename\n      value\n    }\n    mobile_text  {\n      __typename\n      value\n    }\n    background_color  {\n      __typename\n      value  {\n        __typename\n        codename\n      }\n    }\n    custom_color  {\n      __typename\n      value\n    }\n    url  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_AlertBanner_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_AlertBanner_Fragment_bs_Raw = {};
var Gql_AlertBanner_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_AlertBanner_Fragment_bs_templateObject());
function Gql_AlertBanner_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.desktop_text;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.mobile_text;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.background_color;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.codename;
                return {
                    __typename: value.__typename,
                    codename: !(value$1 == null) ? value$1 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.custom_color;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.url;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        desktop_text: tmp,
        mobile_text: tmp$1,
        background_color: tmp$2,
        custom_color: tmp$3,
        url: tmp$4
    };
}
function Gql_AlertBanner_Fragment_bs_serialize(value) {
    var value$1 = value.url;
    var url;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        url = {
            __typename: value$4,
            value: value$3
        };
    } else {
        url = null;
    }
    var value$5 = value.custom_color;
    var custom_color;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        custom_color = {
            __typename: value$8,
            value: value$7
        };
    } else {
        custom_color = null;
    }
    var value$9 = value.background_color;
    var background_color;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.codename;
            var codename = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                codename: codename
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        background_color = {
            __typename: value$12,
            value: value$11
        };
    } else {
        background_color = null;
    }
    var value$13 = value.mobile_text;
    var mobile_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        mobile_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        mobile_text = null;
    }
    var value$17 = value.desktop_text;
    var desktop_text;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        desktop_text = {
            __typename: value$20,
            value: value$19
        };
    } else {
        desktop_text = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        desktop_text: desktop_text,
        mobile_text: mobile_text,
        background_color: background_color,
        custom_color: custom_color,
        url: url
    };
}
function Gql_AlertBanner_Fragment_bs_verifyArgsAndParse(_AlertBannerBlock, value) {
    return Gql_AlertBanner_Fragment_bs_parse(value);
}
function Gql_AlertBanner_Fragment_bs_verifyName(param) {}
var AlertBannerBlock = {
    Raw: Gql_AlertBanner_Fragment_bs_Raw,
    query: Gql_AlertBanner_Fragment_bs_query,
    parse: Gql_AlertBanner_Fragment_bs_parse,
    serialize: Gql_AlertBanner_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_AlertBanner_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_AlertBanner_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CookiePopup/Gql__CookiePopup__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_CookiePopup_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CookiePopupBlock on GdprCookiePopupContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    cookie_popup_text  {\n      __typename\n      value\n    }\n    cookie_popup_accept_button  {\n      __typename\n      value\n    }\n    cookie_popup_decline_button  {\n      __typename\n      value\n    }\n    cookie_popup_icon  {\n      __typename\n      value  {\n        __typename\n        url\n      }\n    }\n  }\n"
    ]);
    Gql_CookiePopup_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_CookiePopup_Fragment_bs_Raw = {};
var Gql_CookiePopup_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_CookiePopup_Fragment_bs_templateObject());
function Gql_CookiePopup_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.cookie_popup_text;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.cookie_popup_accept_button;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.cookie_popup_decline_button;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? value$7 : undefined
        };
    }
    var value$8 = value.cookie_popup_icon;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.url;
                return {
                    __typename: value.__typename,
                    url: !(value$1 == null) ? value$1 : undefined
                };
            }, value$9) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        cookie_popup_text: tmp,
        cookie_popup_accept_button: tmp$1,
        cookie_popup_decline_button: tmp$2,
        cookie_popup_icon: tmp$3
    };
}
function Gql_CookiePopup_Fragment_bs_serialize(value) {
    var value$1 = value.cookie_popup_icon;
    var cookie_popup_icon;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.url;
            var url = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                __typename: value$2,
                url: url
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        cookie_popup_icon = {
            __typename: value$4,
            value: value$3
        };
    } else {
        cookie_popup_icon = null;
    }
    var value$5 = value.cookie_popup_decline_button;
    var cookie_popup_decline_button;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        cookie_popup_decline_button = {
            __typename: value$8,
            value: value$7
        };
    } else {
        cookie_popup_decline_button = null;
    }
    var value$9 = value.cookie_popup_accept_button;
    var cookie_popup_accept_button;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        cookie_popup_accept_button = {
            __typename: value$12,
            value: value$11
        };
    } else {
        cookie_popup_accept_button = null;
    }
    var value$13 = value.cookie_popup_text;
    var cookie_popup_text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        cookie_popup_text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        cookie_popup_text = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        cookie_popup_text: cookie_popup_text,
        cookie_popup_accept_button: cookie_popup_accept_button,
        cookie_popup_decline_button: cookie_popup_decline_button,
        cookie_popup_icon: cookie_popup_icon
    };
}
function Gql_CookiePopup_Fragment_bs_verifyArgsAndParse(_CookiePopupBlock, value) {
    return Gql_CookiePopup_Fragment_bs_parse(value);
}
function Gql_CookiePopup_Fragment_bs_verifyName(param) {}
var CookiePopupBlock = {
    Raw: Gql_CookiePopup_Fragment_bs_Raw,
    query: Gql_CookiePopup_Fragment_bs_query,
    parse: Gql_CookiePopup_Fragment_bs_parse,
    serialize: Gql_CookiePopup_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_CookiePopup_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_CookiePopup_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/AppStoreItem/Gql__AppStoreItem__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_AppStoreItem_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment AppStoreItem on AppStoreItemContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    app_store_name  {\n      __typename\n      value\n    }\n    app_store_download_link  {\n      __typename\n      value\n    }\n    app_store_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n  }\n"
    ]);
    Gql_AppStoreItem_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_AppStoreItem_Fragment_bs_Raw = {};
var Gql_AppStoreItem_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_AppStoreItem_Fragment_bs_templateObject());
function Gql_AppStoreItem_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.app_store_name;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.app_store_download_link;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.app_store_asset;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$7) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        app_store_name: tmp,
        app_store_download_link: tmp$1,
        app_store_asset: tmp$2
    };
}
function Gql_AppStoreItem_Fragment_bs_serialize(value) {
    var value$1 = value.app_store_asset;
    var app_store_asset;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        app_store_asset = {
            __typename: value$4,
            value: value$3
        };
    } else {
        app_store_asset = null;
    }
    var value$5 = value.app_store_download_link;
    var app_store_download_link;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        app_store_download_link = {
            __typename: value$8,
            value: value$7
        };
    } else {
        app_store_download_link = null;
    }
    var value$9 = value.app_store_name;
    var app_store_name;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        app_store_name = {
            __typename: value$12,
            value: value$11
        };
    } else {
        app_store_name = null;
    }
    var value$13 = value.system;
    var value$14 = value$13.codename;
    var value$15 = value$13.id;
    var value$16 = value$13.__typename;
    var system = {
        __typename: value$16,
        id: value$15,
        codename: value$14
    };
    var value$17 = value.__typename;
    return {
        __typename: value$17,
        system: system,
        app_store_name: app_store_name,
        app_store_download_link: app_store_download_link,
        app_store_asset: app_store_asset
    };
}
function Gql_AppStoreItem_Fragment_bs_verifyArgsAndParse(_AppStoreItem, value) {
    return Gql_AppStoreItem_Fragment_bs_parse(value);
}
function Gql_AppStoreItem_Fragment_bs_verifyName(param) {}
var AppStoreItem = {
    Raw: Gql_AppStoreItem_Fragment_bs_Raw,
    query: Gql_AppStoreItem_Fragment_bs_query,
    parse: Gql_AppStoreItem_Fragment_bs_parse,
    serialize: Gql_AppStoreItem_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_AppStoreItem_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_AppStoreItem_Fragment_bs_verifyName
};
var Gql_AppStoreItem_Fragment_bs_$$Image;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NavMenuItems/Gql__NavMenuItems__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NavMenuItems_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NavMenuBlock on NavbarMenuItemContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    text  {\n      __typename\n      value\n    }\n    url  {\n      __typename\n      value\n    }\n    menu_icon_asset  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    fontawesome_icon  {\n      __typename\n      value  {\n        __typename\n        ...on FontAwesomeContentType   {\n          ...FontAwesomeIcon\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_NavMenuItems_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_NavMenuItems_Fragment_bs_Raw = {};
var Gql_NavMenuItems_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_NavMenuItems_Fragment_bs_templateObject(), frag_0);
}(Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.query);
function Gql_NavMenuItems_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.text;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.url;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.menu_icon_asset;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.fontawesome_icon;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "FontAwesomeContentType" ? {
                    NAME: "FontAwesomeContentType",
                    VAL: {
                        fontAwesomeIcon: Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.verifyArgsAndParse("FontAwesomeIcon", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$9) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        text: tmp,
        url: tmp$1,
        menu_icon_asset: tmp$2,
        fontawesome_icon: tmp$3
    };
}
function Gql_NavMenuItems_Fragment_bs_serialize(value) {
    var value$1 = value.fontawesome_icon;
    var fontawesome_icon;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "FontAwesomeContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        Gql_FontAwesomeIcon_Fragment_bs_FontAwesomeIcon.serialize(value.VAL.fontAwesomeIcon)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        fontawesome_icon = {
            __typename: value$4,
            value: value$3
        };
    } else {
        fontawesome_icon = null;
    }
    var value$5 = value.menu_icon_asset;
    var menu_icon_asset;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$6) : null;
        var value$8 = value$5.__typename;
        menu_icon_asset = {
            __typename: value$8,
            value: value$7
        };
    } else {
        menu_icon_asset = null;
    }
    var value$9 = value.url;
    var url;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? value$10 : null;
        var value$12 = value$9.__typename;
        url = {
            __typename: value$12,
            value: value$11
        };
    } else {
        url = null;
    }
    var value$13 = value.text;
    var text;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        text = {
            __typename: value$16,
            value: value$15
        };
    } else {
        text = null;
    }
    var value$17 = value.system;
    var value$18 = value$17.codename;
    var value$19 = value$17.id;
    var value$20 = value$17.__typename;
    var system = {
        __typename: value$20,
        id: value$19,
        codename: value$18
    };
    var value$21 = value.__typename;
    return {
        __typename: value$21,
        system: system,
        text: text,
        url: url,
        menu_icon_asset: menu_icon_asset,
        fontawesome_icon: fontawesome_icon
    };
}
function Gql_NavMenuItems_Fragment_bs_verifyArgsAndParse(_NavMenuBlock, value) {
    return Gql_NavMenuItems_Fragment_bs_parse(value);
}
function Gql_NavMenuItems_Fragment_bs_verifyName(param) {}
var Gql_NavMenuItems_Fragment_bs_NavMenuBlock = {
    Raw: Gql_NavMenuItems_Fragment_bs_Raw,
    query: Gql_NavMenuItems_Fragment_bs_query,
    parse: Gql_NavMenuItems_Fragment_bs_parse,
    serialize: Gql_NavMenuItems_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NavMenuItems_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NavMenuItems_Fragment_bs_verifyName
};
var Gql_NavMenuItems_Fragment_bs_CardIcon;
var Gql_NavMenuItems_Fragment_bs_FontAwesomeIcon;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NavbarSelectCta/Gql__NavbarSelectCta__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NavbarSelectCta_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NavbarSelectCTA on NavbarSelectCtaContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    select_cta  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n    option_ctas  {\n      __typename\n      value  {\n        __typename\n        ...on CallToActionLinkD6a3d61ContentType   {\n          ...CallToAction\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    Gql_NavbarSelectCta_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Gql_NavbarSelectCta_Fragment_bs_Raw = {};
var Gql_NavbarSelectCta_Fragment_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_NavbarSelectCta_Fragment_bs_templateObject(), frag_0);
}(CallToAction.query);
function Gql_NavbarSelectCta_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.select_cta;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$3) : undefined
        };
    }
    var value$4 = value.option_ctas;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                    NAME: "CallToActionLinkD6a3d61ContentType",
                    VAL: {
                        callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                    }
                } : {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
                return tmp;
            }, value$5) : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        select_cta: tmp,
        option_ctas: tmp$1
    };
}
function Gql_NavbarSelectCta_Fragment_bs_serialize(value) {
    var value$1 = value.option_ctas;
    var option_ctas;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$2) : null;
        var value$4 = value$1.__typename;
        option_ctas = {
            __typename: value$4,
            value: value$3
        };
    } else {
        option_ctas = null;
    }
    var value$5 = value.select_cta;
    var select_cta;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? js_array/* map */.UI(function(value) {
            if (value !== undefined) {
                if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return {};
                }
            } else {
                return null;
            }
        }, value$6) : null;
        var value$8 = value$5.__typename;
        select_cta = {
            __typename: value$8,
            value: value$7
        };
    } else {
        select_cta = null;
    }
    var value$9 = value.system;
    var value$10 = value$9.codename;
    var value$11 = value$9.id;
    var value$12 = value$9.__typename;
    var system = {
        __typename: value$12,
        id: value$11,
        codename: value$10
    };
    var value$13 = value.__typename;
    return {
        __typename: value$13,
        system: system,
        select_cta: select_cta,
        option_ctas: option_ctas
    };
}
function Gql_NavbarSelectCta_Fragment_bs_verifyArgsAndParse(_NavbarSelectCTA, value) {
    return Gql_NavbarSelectCta_Fragment_bs_parse(value);
}
function Gql_NavbarSelectCta_Fragment_bs_verifyName(param) {}
var NavbarSelectCTA = {
    Raw: Gql_NavbarSelectCta_Fragment_bs_Raw,
    query: Gql_NavbarSelectCta_Fragment_bs_query,
    parse: Gql_NavbarSelectCta_Fragment_bs_parse,
    serialize: Gql_NavbarSelectCta_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NavbarSelectCta_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NavbarSelectCta_Fragment_bs_verifyName
};
var Gql_NavbarSelectCta_Fragment_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/NoSearchResults/Gql__NoSearchResults__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_NoSearchResults_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NoSearchResults on NoSearchResultsContentType   {\n    __typename\n    system  {\n      __typename\n      id\n      codename\n    }\n    title  {\n      __typename\n      value\n    }\n    description  {\n      __typename\n      value\n    }\n    icon  {\n      __typename\n      value  {\n        __typename\n        name\n        description\n        url\n        width\n        height\n      }\n    }\n    title_scp  {\n      __typename\n      value\n    }\n    description_scp  {\n      __typename\n      value\n    }\n  }\n"
    ]);
    Gql_NoSearchResults_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_NoSearchResults_Fragment_bs_Raw = {};
var Gql_NoSearchResults_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_NoSearchResults_Fragment_bs_templateObject());
function Gql_NoSearchResults_Fragment_bs_parse(value) {
    var value$1 = value.system;
    var value$2 = value.title;
    var tmp;
    if (value$2 == null) {
        tmp = undefined;
    } else {
        var value$3 = value$2.value;
        tmp = {
            __typename: value$2.__typename,
            value: !(value$3 == null) ? value$3 : undefined
        };
    }
    var value$4 = value.description;
    var tmp$1;
    if (value$4 == null) {
        tmp$1 = undefined;
    } else {
        var value$5 = value$4.value;
        tmp$1 = {
            __typename: value$4.__typename,
            value: !(value$5 == null) ? value$5 : undefined
        };
    }
    var value$6 = value.icon;
    var tmp$2;
    if (value$6 == null) {
        tmp$2 = undefined;
    } else {
        var value$7 = value$6.value;
        tmp$2 = {
            __typename: value$6.__typename,
            value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var value$1 = value.name;
                var value$2 = value.description;
                var value$3 = value.url;
                var value$4 = value.width;
                var value$5 = value.height;
                return {
                    __typename: value.__typename,
                    name: !(value$1 == null) ? value$1 : undefined,
                    description: !(value$2 == null) ? value$2 : undefined,
                    url: !(value$3 == null) ? value$3 : undefined,
                    width: !(value$4 == null) ? value$4 : undefined,
                    height: !(value$5 == null) ? value$5 : undefined
                };
            }, value$7) : undefined
        };
    }
    var value$8 = value.title_scp;
    var tmp$3;
    if (value$8 == null) {
        tmp$3 = undefined;
    } else {
        var value$9 = value$8.value;
        tmp$3 = {
            __typename: value$8.__typename,
            value: !(value$9 == null) ? value$9 : undefined
        };
    }
    var value$10 = value.description_scp;
    var tmp$4;
    if (value$10 == null) {
        tmp$4 = undefined;
    } else {
        var value$11 = value$10.value;
        tmp$4 = {
            __typename: value$10.__typename,
            value: !(value$11 == null) ? value$11 : undefined
        };
    }
    return {
        __typename: value.__typename,
        system: {
            __typename: value$1.__typename,
            id: value$1.id,
            codename: value$1.codename
        },
        title: tmp,
        description: tmp$1,
        icon: tmp$2,
        title_scp: tmp$3,
        description_scp: tmp$4
    };
}
function Gql_NoSearchResults_Fragment_bs_serialize(value) {
    var value$1 = value.description_scp;
    var description_scp;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? value$2 : null;
        var value$4 = value$1.__typename;
        description_scp = {
            __typename: value$4,
            value: value$3
        };
    } else {
        description_scp = null;
    }
    var value$5 = value.title_scp;
    var title_scp;
    if (value$5 !== undefined) {
        var value$6 = value$5.value;
        var value$7 = value$6 !== undefined ? value$6 : null;
        var value$8 = value$5.__typename;
        title_scp = {
            __typename: value$8,
            value: value$7
        };
    } else {
        title_scp = null;
    }
    var value$9 = value.icon;
    var icon;
    if (value$9 !== undefined) {
        var value$10 = value$9.value;
        var value$11 = value$10 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            var value$1 = value.height;
            var height = value$1 !== undefined ? value$1 : null;
            var value$2 = value.width;
            var width = value$2 !== undefined ? value$2 : null;
            var value$3 = value.url;
            var url = value$3 !== undefined ? value$3 : null;
            var value$4 = value.description;
            var description = value$4 !== undefined ? value$4 : null;
            var value$5 = value.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value.__typename;
            return {
                __typename: value$6,
                name: name,
                description: description,
                url: url,
                width: width,
                height: height
            };
        }, value$10) : null;
        var value$12 = value$9.__typename;
        icon = {
            __typename: value$12,
            value: value$11
        };
    } else {
        icon = null;
    }
    var value$13 = value.description;
    var description;
    if (value$13 !== undefined) {
        var value$14 = value$13.value;
        var value$15 = value$14 !== undefined ? value$14 : null;
        var value$16 = value$13.__typename;
        description = {
            __typename: value$16,
            value: value$15
        };
    } else {
        description = null;
    }
    var value$17 = value.title;
    var title;
    if (value$17 !== undefined) {
        var value$18 = value$17.value;
        var value$19 = value$18 !== undefined ? value$18 : null;
        var value$20 = value$17.__typename;
        title = {
            __typename: value$20,
            value: value$19
        };
    } else {
        title = null;
    }
    var value$21 = value.system;
    var value$22 = value$21.codename;
    var value$23 = value$21.id;
    var value$24 = value$21.__typename;
    var system = {
        __typename: value$24,
        id: value$23,
        codename: value$22
    };
    var value$25 = value.__typename;
    return {
        __typename: value$25,
        system: system,
        title: title,
        description: description,
        icon: icon,
        title_scp: title_scp,
        description_scp: description_scp
    };
}
function Gql_NoSearchResults_Fragment_bs_verifyArgsAndParse(_NoSearchResults, value) {
    return Gql_NoSearchResults_Fragment_bs_parse(value);
}
function Gql_NoSearchResults_Fragment_bs_verifyName(param) {}
var NoSearchResults = {
    Raw: Gql_NoSearchResults_Fragment_bs_Raw,
    query: Gql_NoSearchResults_Fragment_bs_query,
    parse: Gql_NoSearchResults_Fragment_bs_parse,
    serialize: Gql_NoSearchResults_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_NoSearchResults_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_NoSearchResults_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeaderNavigation/Gql__HeaderNavigation__Fragment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_HeaderNavigation_Fragment_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment HeaderNavigation on AppContentType   {\n    __typename\n    subpages_subviews  {\n      __typename\n      value  {\n        __typename\n        ...on HeaderNavigationContentType   {\n          __typename\n          system  {\n            __typename\n            id\n            codename\n          }\n          label  {\n            __typename\n            value\n          }\n          url  {\n            __typename\n            value\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    Gql_HeaderNavigation_Fragment_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Gql_HeaderNavigation_Fragment_bs_Raw = {};
var Gql_HeaderNavigation_Fragment_bs_query = (__webpack_require__(46829).gql)(Gql_HeaderNavigation_Fragment_bs_templateObject());
function Gql_HeaderNavigation_Fragment_bs_parse(value) {
    var value$1 = value.subpages_subviews;
    var tmp;
    if (value$1 == null) {
        tmp = undefined;
    } else {
        var value$2 = value$1.value;
        tmp = {
            __typename: value$1.__typename,
            value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                if (value == null) {
                    return;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "HeaderNavigationContentType") {
                    var value$1 = value.system;
                    var value$2 = value.label;
                    var tmp$1;
                    if (value$2 == null) {
                        tmp$1 = undefined;
                    } else {
                        var value$3 = value$2.value;
                        tmp$1 = {
                            __typename: value$2.__typename,
                            value: !(value$3 == null) ? value$3 : undefined
                        };
                    }
                    var value$4 = value.url;
                    var tmp$2;
                    if (value$4 == null) {
                        tmp$2 = undefined;
                    } else {
                        var value$5 = value$4.value;
                        tmp$2 = {
                            __typename: value$4.__typename,
                            value: !(value$5 == null) ? value$5 : undefined
                        };
                    }
                    tmp = {
                        NAME: "HeaderNavigationContentType",
                        VAL: {
                            __typename: value.__typename,
                            system: {
                                __typename: value$1.__typename,
                                id: value$1.id,
                                codename: value$1.codename
                            },
                            label: tmp$1,
                            url: tmp$2
                        }
                    };
                } else {
                    tmp = {
                        NAME: "UnspecifiedFragment",
                        VAL: typename
                    };
                }
                return tmp;
            }, value$2) : undefined
        };
    }
    return {
        __typename: value.__typename,
        subpages_subviews: tmp
    };
}
function Gql_HeaderNavigation_Fragment_bs_serialize(value) {
    var value$1 = value.subpages_subviews;
    var subpages_subviews;
    if (value$1 !== undefined) {
        var value$2 = value$1.value;
        var value$3 = value$2 !== undefined ? js_array/* map */.UI(function(value) {
            if (value === undefined) {
                return null;
            }
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            }
            var value$1 = value.VAL;
            var value$2 = value$1.url;
            var url;
            if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? value$3 : null;
                var value$5 = value$2.__typename;
                url = {
                    __typename: value$5,
                    value: value$4
                };
            } else {
                url = null;
            }
            var value$6 = value$1.label;
            var label;
            if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? value$7 : null;
                var value$9 = value$6.__typename;
                label = {
                    __typename: value$9,
                    value: value$8
                };
            } else {
                label = null;
            }
            var value$10 = value$1.system;
            var value$11 = value$10.codename;
            var value$12 = value$10.id;
            var value$13 = value$10.__typename;
            var system = {
                __typename: value$13,
                id: value$12,
                codename: value$11
            };
            return {
                __typename: "HeaderNavigationContentType",
                system: system,
                label: label,
                url: url
            };
        }, value$2) : null;
        var value$4 = value$1.__typename;
        subpages_subviews = {
            __typename: value$4,
            value: value$3
        };
    } else {
        subpages_subviews = null;
    }
    var value$5 = value.__typename;
    return {
        __typename: value$5,
        subpages_subviews: subpages_subviews
    };
}
function Gql_HeaderNavigation_Fragment_bs_verifyArgsAndParse(_HeaderNavigation, value) {
    return Gql_HeaderNavigation_Fragment_bs_parse(value);
}
function Gql_HeaderNavigation_Fragment_bs_verifyName(param) {}
var HeaderNavigation = {
    Raw: Gql_HeaderNavigation_Fragment_bs_Raw,
    query: Gql_HeaderNavigation_Fragment_bs_query,
    parse: Gql_HeaderNavigation_Fragment_bs_parse,
    serialize: Gql_HeaderNavigation_Fragment_bs_serialize,
    verifyArgsAndParse: Gql_HeaderNavigation_Fragment_bs_verifyArgsAndParse,
    verifyName: Gql_HeaderNavigation_Fragment_bs_verifyName
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/GlobalConfiguration/Gql__GlobalConfiguration__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_GlobalConfiguration_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query GlobalConfiguration($language: String!, $preview: Boolean)  {\n    globalConfiguration: itemsByType(type: "global_configuration", limit: 1, depth: 5, language: $language, preview: $preview)  {\n      __typename\n      ...on GlobalConfigurationContentType   {\n        __typename\n        gdpr_cookie_popup  {\n          __typename\n          value  {\n            __typename\n            ...on GdprCookiePopupContentType   {\n              ...CookiePopupBlock\n            }\n          }\n        }\n        alert_banner  {\n          __typename\n          value  {\n            __typename\n            ...on AlertBannerContentType   {\n              ...AlertBannerBlock\n            }\n          }\n        }\n        navigation_root  {\n          __typename\n          value  {\n            __typename\n            ...on AppContentType   {\n              ...HeaderNavigation\n            }\n            ...on PageContentType   {\n              ...HeaderBlock\n            }\n          }\n        }\n        business_navigation  {\n          __typename\n          value  {\n            __typename\n            ...on AppContentType   {\n              ...HeaderNavigation\n            }\n            ...on PageContentType   {\n              ...HeaderBlock\n            }\n          }\n        }\n        desktop_navbar_menu_items  {\n          __typename\n          value  {\n            __typename\n            ...on NavbarMenuItemContentType   {\n              ...NavMenuBlock\n            }\n          }\n        }\n        mobile_navbar_menu_items  {\n          __typename\n          value  {\n            __typename\n            ...on NavbarMenuItemContentType   {\n              ...NavMenuBlock\n            }\n          }\n        }\n        footer  {\n          __typename\n          value  {\n            __typename\n            ...on FooterContainerContentType   {\n              ...FooterBlock\n            }\n          }\n        }\n        business_footer  {\n          __typename\n          value  {\n            __typename\n            ...on FooterContainerContentType   {\n              ...FooterBlock\n            }\n          }\n        }\n        login  {\n          __typename\n          value  {\n            __typename\n            ...on LoginContentType   {\n              __typename\n              system  {\n                __typename\n                codename\n                id\n              }\n              title  {\n                __typename\n                value\n              }\n              subtitle  {\n                __typename\n                value\n              }\n              email_label  {\n                __typename\n                value\n              }\n              password_label  {\n                __typename\n                value\n              }\n              required_email_text  {\n                __typename\n                value\n              }\n              required_password_text  {\n                __typename\n                value\n              }\n              invalid_email_text  {\n                __typename\n                value\n              }\n              submit_cta_text  {\n                __typename\n                value\n              }\n              submit_cta_submitting_text  {\n                __typename\n                value\n              }\n              forgot_password_text  {\n                __typename\n                value\n              }\n              forgot_email_text  {\n                __typename\n                value\n              }\n            }\n          }\n        }\n        register  {\n          __typename\n          value  {\n            __typename\n            ...on RegisterContentType   {\n              __typename\n              system  {\n                __typename\n                codename\n                id\n              }\n              register_title  {\n                __typename\n                value\n              }\n              register_subtitle  {\n                __typename\n                value\n              }\n              next_button_text  {\n                __typename\n                value\n              }\n              back_button_text  {\n                __typename\n                value\n              }\n              step_title___name  {\n                __typename\n                value\n              }\n              first_name_label  {\n                __typename\n                value\n              }\n              first_name_required_text  {\n                __typename\n                value\n              }\n              invalid_first_name_text  {\n                __typename\n                value\n              }\n              last_name_label  {\n                __typename\n                value\n              }\n              last_name_required_text  {\n                __typename\n                value\n              }\n              invalid_last_name_text  {\n                __typename\n                value\n              }\n              step_title___email  {\n                __typename\n                value\n              }\n              email_label  {\n                __typename\n                value\n              }\n              email_required_text  {\n                __typename\n                value\n              }\n              invalid_email_text  {\n                __typename\n                value\n              }\n              step_title___password  {\n                __typename\n                value\n              }\n              password_requirements  {\n                __typename\n                value\n              }\n              password_label  {\n                __typename\n                value\n              }\n              password_required_text  {\n                __typename\n                value\n              }\n              invalid_password_text  {\n                __typename\n                value\n              }\n              step_title___phone_number  {\n                __typename\n                value\n              }\n              phone_number_required_text  {\n                __typename\n                value\n              }\n              invalid_phone_number_text  {\n                __typename\n                value\n              }\n              newsletter_checkbox_label  {\n                __typename\n                value\n              }\n              t_cs_checkbox_label  {\n                __typename\n                value\n              }\n              nz_not_prezzy_disclaimer  {\n                __typename\n                value\n              }\n              send_security_code_cta_text  {\n                __typename\n                value\n              }\n              step_title___security_code  {\n                __typename\n                value\n              }\n              resend_code_text  {\n                __typename\n                value\n              }\n              resending_code_text  {\n                __typename\n                value\n              }\n              sign_up_cta_text  {\n                __typename\n                value\n              }\n              already_registered_text  {\n                __typename\n                value\n              }\n            }\n          }\n        }\n        warnings  {\n          __typename\n          value  {\n            __typename\n            ...on WarningContentType   {\n              __typename\n              id  {\n                __typename\n                value\n              }\n              heading  {\n                __typename\n                value\n              }\n              description  {\n                __typename\n                value\n              }\n            }\n          }\n        }\n        header_logo  {\n          __typename\n          value  {\n            __typename\n            ...on HeaderLogoContentType   {\n              ...HeaderLogo\n            }\n          }\n        }\n        not_logged_in_navbar_menu_items___consumer  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n            ...on NavbarSelectCtaContentType   {\n              ...NavbarSelectCTA\n            }\n          }\n        }\n        not_logged_in_navbar_menu_items___business  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        search_bar_placeholder_text  {\n          __typename\n          value\n        }\n        no_search_result  {\n          __typename\n          value  {\n            __typename\n            ...on NoSearchResultsContentType   {\n              ...NoSearchResults\n            }\n          }\n        }\n        sold_out_badge_text  {\n          __typename\n          value\n        }\n      }\n    }\n    dictionaryItems: itemsByType(type: "dictionary_item", language: $language, preview: $preview, depth: 3)  {\n      __typename\n      ...on DictionaryItemContentType   {\n        __typename\n        system  {\n          __typename\n          id\n          codename\n        }\n        value  {\n          __typename\n          value\n        }\n      }\n    }\n    locations: itemsByType(type: "modal_change_location", language: $language, preview: $preview, limit: 3, depth: 3)  {\n      __typename\n      ...on ModalChangeLocationContentType   {\n        __typename\n        system  {\n          __typename\n          id\n          codename\n        }\n        title  {\n          __typename\n          value\n        }\n        subtitle  {\n          __typename\n          value\n        }\n        cta_text  {\n          __typename\n          value\n        }\n        region_location  {\n          __typename\n          value  {\n            __typename\n            ...on RegionLocationContentType   {\n              __typename\n              system  {\n                __typename\n                id\n                codename\n              }\n              currency  {\n                __typename\n                value\n              }\n              country_name  {\n                __typename\n                value\n              }\n              country_flag  {\n                __typename\n                value  {\n                  __typename\n                  name\n                  url\n                }\n              }\n              url  {\n                __typename\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    giftLandingPage: itemsByType(type: "gift_landing_page", language: $language, preview: $preview, depth: 3)  {\n      __typename\n      ...on GiftLandingPageContentType   {\n        __typename\n        system  {\n          __typename\n          codename\n          id\n        }\n        classic_logo_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        business_logo_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        sender_message  {\n          __typename\n          value\n        }\n        gift_reveal_cta_text  {\n          __typename\n          value\n        }\n        confetti_lottie  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        faqs  {\n          __typename\n          value  {\n            __typename\n            ...on GiftLandingPageFaqItemContentType   {\n              __typename\n              system  {\n                __typename\n                codename\n                id\n              }\n              title  {\n                __typename\n                value\n              }\n              body_text  {\n                __typename\n                value\n              }\n              include_how_to_use  {\n                __typename\n                value  {\n                  __typename\n                  codename\n                }\n              }\n              include_pdf_download  {\n                __typename\n                value  {\n                  __typename\n                  codename\n                }\n              }\n              include_card_merchant_terms  {\n                __typename\n                value  {\n                  __typename\n                  codename\n                }\n              }\n            }\n          }\n        }\n        no_expiry_text  {\n          __typename\n          value\n        }\n        expiry_label  {\n          __typename\n          value\n        }\n        check_balance_text  {\n          __typename\n          value\n        }\n        check_balance_icon_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        store_in_wallet_cta_title  {\n          __typename\n          value\n        }\n        swap_egift_card_cta_title  {\n          __typename\n          value\n        }\n        optional_gift_card_cta  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        gift_unwrap_cta_text  {\n          __typename\n          value\n        }\n        gift_unwrap_lottie_segments  {\n          __typename\n          value\n        }\n        classic_gift_unwrap_lottie  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        business_gift_unwrap_lottie  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        replay_button_icon_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        replay_button_text  {\n          __typename\n          value\n        }\n        redeem_online_text  {\n          __typename\n          value\n        }\n        redeem_online_text_colour  {\n          __typename\n          value\n        }\n        redeem_online_button  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        download_option_text  {\n          __typename\n          value\n        }\n        download_option_text_colour  {\n          __typename\n          value\n        }\n        download_button  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        spend_it_now_heading  {\n          __typename\n          value\n        }\n        clipboard_item_copy_text  {\n          __typename\n          value\n        }\n        clipboard_item_copied_text  {\n          __typename\n          value\n        }\n        barcode_number_clipboard_heading  {\n          __typename\n          value\n        }\n        in_store_number_clipboard_heading  {\n          __typename\n          value\n        }\n        online_number_clipboard_heading  {\n          __typename\n          value\n        }\n        online_and_in_store_clipboard_heading  {\n          __typename\n          value\n        }\n        swap_cards_title  {\n          __typename\n          value\n        }\n        swap_card_alt  {\n          __typename\n          value\n        }\n        swap_card_original_value_label  {\n          __typename\n          value\n        }\n        swap_card_button_style  {\n          __typename\n          value  {\n            __typename\n            ...on CallToActionLinkD6a3d61ContentType   {\n              ...CallToAction\n            }\n          }\n        }\n        save_in_apple_google_wallet_text  {\n          __typename\n          value\n        }\n        save_in_apple_google_wallet_text_colour  {\n          __typename\n          value\n        }\n        google_wallet_image_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        apple_wallet_image_asset  {\n          __typename\n          value  {\n            __typename\n            name\n            description\n            url\n            width\n            height\n          }\n        }\n        footer_copyright_text  {\n          __typename\n          value\n        }\n        footer_download_text  {\n          __typename\n          value\n        }\n        app_store_icons  {\n          __typename\n          value  {\n            __typename\n            ...on AppStoreItemContentType   {\n              ...AppStoreItem\n            }\n          }\n        }\n        create_account_modal_title  {\n          __typename\n          value\n        }\n        create_account_modal_list  {\n          __typename\n          value\n        }\n        create_account_modal_cta_text  {\n          __typename\n          value\n        }\n      }\n    }\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    Gql_GlobalConfiguration_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Gql_GlobalConfiguration_Query_bs_Raw = {};
var Gql_GlobalConfiguration_Query_bs_query = function(frag_0, frag_1, frag_2, frag_3, frag_4, frag_5, frag_6, frag_7, frag_8, frag_9, frag_10) {
    return (__webpack_require__(46829).gql)(Gql_GlobalConfiguration_Query_bs_templateObject(), frag_0, frag_1, frag_2, frag_3, frag_4, frag_5, frag_6, frag_7, frag_8, frag_9, frag_10);
}(AlertBannerBlock.query, AppStoreItem.query, CallToAction.query, CookiePopupBlock.query, Gql_Footer_Fragment_bs_FooterBlock.query, Gql_Header_Fragment_bs_HeaderBlock.query, HeaderLogo.query, HeaderNavigation.query, Gql_NavMenuItems_Fragment_bs_NavMenuBlock.query, NavbarSelectCTA.query, NoSearchResults.query);
function Gql_GlobalConfiguration_Query_bs_parse(value) {
    var value$1 = value.globalConfiguration;
    var value$2 = value.dictionaryItems;
    var value$3 = value.locations;
    var value$4 = value.giftLandingPage;
    return {
        globalConfiguration: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "GlobalConfigurationContentType") {
                var value$1 = value.gdpr_cookie_popup;
                var tmp$1;
                if (value$1 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$2 = value$1.value;
                    tmp$1 = {
                        __typename: value$1.__typename,
                        value: !(value$2 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "GdprCookiePopupContentType" ? {
                                NAME: "GdprCookiePopupContentType",
                                VAL: {
                                    cookiePopupBlock: CookiePopupBlock.verifyArgsAndParse("CookiePopupBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$2) : undefined
                    };
                }
                var value$3 = value.alert_banner;
                var tmp$2;
                if (value$3 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$4 = value$3.value;
                    tmp$2 = {
                        __typename: value$3.__typename,
                        value: !(value$4 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "AlertBannerContentType" ? {
                                NAME: "AlertBannerContentType",
                                VAL: {
                                    alertBannerBlock: AlertBannerBlock.verifyArgsAndParse("AlertBannerBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$4) : undefined
                    };
                }
                var value$5 = value.navigation_root;
                var tmp$3;
                if (value$5 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$6 = value$5.value;
                    tmp$3 = {
                        __typename: value$5.__typename,
                        value: !(value$6 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            switch(typename){
                                case "AppContentType":
                                    tmp = {
                                        NAME: "AppContentType",
                                        VAL: {
                                            headerNavigation: HeaderNavigation.verifyArgsAndParse("HeaderNavigation", value)
                                        }
                                    };
                                    break;
                                case "PageContentType":
                                    tmp = {
                                        NAME: "PageContentType",
                                        VAL: {
                                            headerBlock: Gql_Header_Fragment_bs_HeaderBlock.verifyArgsAndParse("HeaderBlock", value)
                                        }
                                    };
                                    break;
                                default:
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                            }
                            return tmp;
                        }, value$6) : undefined
                    };
                }
                var value$7 = value.business_navigation;
                var tmp$4;
                if (value$7 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$8 = value$7.value;
                    tmp$4 = {
                        __typename: value$7.__typename,
                        value: !(value$8 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            switch(typename){
                                case "AppContentType":
                                    tmp = {
                                        NAME: "AppContentType",
                                        VAL: {
                                            headerNavigation: HeaderNavigation.verifyArgsAndParse("HeaderNavigation", value)
                                        }
                                    };
                                    break;
                                case "PageContentType":
                                    tmp = {
                                        NAME: "PageContentType",
                                        VAL: {
                                            headerBlock: Gql_Header_Fragment_bs_HeaderBlock.verifyArgsAndParse("HeaderBlock", value)
                                        }
                                    };
                                    break;
                                default:
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                            }
                            return tmp;
                        }, value$8) : undefined
                    };
                }
                var value$9 = value.desktop_navbar_menu_items;
                var tmp$5;
                if (value$9 == null) {
                    tmp$5 = undefined;
                } else {
                    var value$10 = value$9.value;
                    tmp$5 = {
                        __typename: value$9.__typename,
                        value: !(value$10 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "NavbarMenuItemContentType" ? {
                                NAME: "NavbarMenuItemContentType",
                                VAL: {
                                    navMenuBlock: Gql_NavMenuItems_Fragment_bs_NavMenuBlock.verifyArgsAndParse("NavMenuBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$10) : undefined
                    };
                }
                var value$11 = value.mobile_navbar_menu_items;
                var tmp$6;
                if (value$11 == null) {
                    tmp$6 = undefined;
                } else {
                    var value$12 = value$11.value;
                    tmp$6 = {
                        __typename: value$11.__typename,
                        value: !(value$12 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "NavbarMenuItemContentType" ? {
                                NAME: "NavbarMenuItemContentType",
                                VAL: {
                                    navMenuBlock: Gql_NavMenuItems_Fragment_bs_NavMenuBlock.verifyArgsAndParse("NavMenuBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$12) : undefined
                    };
                }
                var value$13 = value.footer;
                var tmp$7;
                if (value$13 == null) {
                    tmp$7 = undefined;
                } else {
                    var value$14 = value$13.value;
                    tmp$7 = {
                        __typename: value$13.__typename,
                        value: !(value$14 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "FooterContainerContentType" ? {
                                NAME: "FooterContainerContentType",
                                VAL: {
                                    footerBlock: Gql_Footer_Fragment_bs_FooterBlock.verifyArgsAndParse("FooterBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$14) : undefined
                    };
                }
                var value$15 = value.business_footer;
                var tmp$8;
                if (value$15 == null) {
                    tmp$8 = undefined;
                } else {
                    var value$16 = value$15.value;
                    tmp$8 = {
                        __typename: value$15.__typename,
                        value: !(value$16 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "FooterContainerContentType" ? {
                                NAME: "FooterContainerContentType",
                                VAL: {
                                    footerBlock: Gql_Footer_Fragment_bs_FooterBlock.verifyArgsAndParse("FooterBlock", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$16) : undefined
                    };
                }
                var value$17 = value.login;
                var tmp$9;
                if (value$17 == null) {
                    tmp$9 = undefined;
                } else {
                    var value$18 = value$17.value;
                    tmp$9 = {
                        __typename: value$17.__typename,
                        value: !(value$18 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            if (typename === "LoginContentType") {
                                var value$1 = value.system;
                                var value$2 = value.title;
                                var tmp$1;
                                if (value$2 == null) {
                                    tmp$1 = undefined;
                                } else {
                                    var value$3 = value$2.value;
                                    tmp$1 = {
                                        __typename: value$2.__typename,
                                        value: !(value$3 == null) ? value$3 : undefined
                                    };
                                }
                                var value$4 = value.subtitle;
                                var tmp$2;
                                if (value$4 == null) {
                                    tmp$2 = undefined;
                                } else {
                                    var value$5 = value$4.value;
                                    tmp$2 = {
                                        __typename: value$4.__typename,
                                        value: !(value$5 == null) ? value$5 : undefined
                                    };
                                }
                                var value$6 = value.email_label;
                                var tmp$3;
                                if (value$6 == null) {
                                    tmp$3 = undefined;
                                } else {
                                    var value$7 = value$6.value;
                                    tmp$3 = {
                                        __typename: value$6.__typename,
                                        value: !(value$7 == null) ? value$7 : undefined
                                    };
                                }
                                var value$8 = value.password_label;
                                var tmp$4;
                                if (value$8 == null) {
                                    tmp$4 = undefined;
                                } else {
                                    var value$9 = value$8.value;
                                    tmp$4 = {
                                        __typename: value$8.__typename,
                                        value: !(value$9 == null) ? value$9 : undefined
                                    };
                                }
                                var value$10 = value.required_email_text;
                                var tmp$5;
                                if (value$10 == null) {
                                    tmp$5 = undefined;
                                } else {
                                    var value$11 = value$10.value;
                                    tmp$5 = {
                                        __typename: value$10.__typename,
                                        value: !(value$11 == null) ? value$11 : undefined
                                    };
                                }
                                var value$12 = value.required_password_text;
                                var tmp$6;
                                if (value$12 == null) {
                                    tmp$6 = undefined;
                                } else {
                                    var value$13 = value$12.value;
                                    tmp$6 = {
                                        __typename: value$12.__typename,
                                        value: !(value$13 == null) ? value$13 : undefined
                                    };
                                }
                                var value$14 = value.invalid_email_text;
                                var tmp$7;
                                if (value$14 == null) {
                                    tmp$7 = undefined;
                                } else {
                                    var value$15 = value$14.value;
                                    tmp$7 = {
                                        __typename: value$14.__typename,
                                        value: !(value$15 == null) ? value$15 : undefined
                                    };
                                }
                                var value$16 = value.submit_cta_text;
                                var tmp$8;
                                if (value$16 == null) {
                                    tmp$8 = undefined;
                                } else {
                                    var value$17 = value$16.value;
                                    tmp$8 = {
                                        __typename: value$16.__typename,
                                        value: !(value$17 == null) ? value$17 : undefined
                                    };
                                }
                                var value$18 = value.submit_cta_submitting_text;
                                var tmp$9;
                                if (value$18 == null) {
                                    tmp$9 = undefined;
                                } else {
                                    var value$19 = value$18.value;
                                    tmp$9 = {
                                        __typename: value$18.__typename,
                                        value: !(value$19 == null) ? value$19 : undefined
                                    };
                                }
                                var value$20 = value.forgot_password_text;
                                var tmp$10;
                                if (value$20 == null) {
                                    tmp$10 = undefined;
                                } else {
                                    var value$21 = value$20.value;
                                    tmp$10 = {
                                        __typename: value$20.__typename,
                                        value: !(value$21 == null) ? value$21 : undefined
                                    };
                                }
                                var value$22 = value.forgot_email_text;
                                var tmp$11;
                                if (value$22 == null) {
                                    tmp$11 = undefined;
                                } else {
                                    var value$23 = value$22.value;
                                    tmp$11 = {
                                        __typename: value$22.__typename,
                                        value: !(value$23 == null) ? value$23 : undefined
                                    };
                                }
                                tmp = {
                                    NAME: "LoginContentType",
                                    VAL: {
                                        __typename: value.__typename,
                                        system: {
                                            __typename: value$1.__typename,
                                            codename: value$1.codename,
                                            id: value$1.id
                                        },
                                        title: tmp$1,
                                        subtitle: tmp$2,
                                        email_label: tmp$3,
                                        password_label: tmp$4,
                                        required_email_text: tmp$5,
                                        required_password_text: tmp$6,
                                        invalid_email_text: tmp$7,
                                        submit_cta_text: tmp$8,
                                        submit_cta_submitting_text: tmp$9,
                                        forgot_password_text: tmp$10,
                                        forgot_email_text: tmp$11
                                    }
                                };
                            } else {
                                tmp = {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                            }
                            return tmp;
                        }, value$18) : undefined
                    };
                }
                var value$19 = value.register;
                var tmp$10;
                if (value$19 == null) {
                    tmp$10 = undefined;
                } else {
                    var value$20 = value$19.value;
                    tmp$10 = {
                        __typename: value$19.__typename,
                        value: !(value$20 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            if (typename === "RegisterContentType") {
                                var value$1 = value.system;
                                var value$2 = value.register_title;
                                var tmp$1;
                                if (value$2 == null) {
                                    tmp$1 = undefined;
                                } else {
                                    var value$3 = value$2.value;
                                    tmp$1 = {
                                        __typename: value$2.__typename,
                                        value: !(value$3 == null) ? value$3 : undefined
                                    };
                                }
                                var value$4 = value.register_subtitle;
                                var tmp$2;
                                if (value$4 == null) {
                                    tmp$2 = undefined;
                                } else {
                                    var value$5 = value$4.value;
                                    tmp$2 = {
                                        __typename: value$4.__typename,
                                        value: !(value$5 == null) ? value$5 : undefined
                                    };
                                }
                                var value$6 = value.next_button_text;
                                var tmp$3;
                                if (value$6 == null) {
                                    tmp$3 = undefined;
                                } else {
                                    var value$7 = value$6.value;
                                    tmp$3 = {
                                        __typename: value$6.__typename,
                                        value: !(value$7 == null) ? value$7 : undefined
                                    };
                                }
                                var value$8 = value.back_button_text;
                                var tmp$4;
                                if (value$8 == null) {
                                    tmp$4 = undefined;
                                } else {
                                    var value$9 = value$8.value;
                                    tmp$4 = {
                                        __typename: value$8.__typename,
                                        value: !(value$9 == null) ? value$9 : undefined
                                    };
                                }
                                var value$10 = value.step_title___name;
                                var tmp$5;
                                if (value$10 == null) {
                                    tmp$5 = undefined;
                                } else {
                                    var value$11 = value$10.value;
                                    tmp$5 = {
                                        __typename: value$10.__typename,
                                        value: !(value$11 == null) ? value$11 : undefined
                                    };
                                }
                                var value$12 = value.first_name_label;
                                var tmp$6;
                                if (value$12 == null) {
                                    tmp$6 = undefined;
                                } else {
                                    var value$13 = value$12.value;
                                    tmp$6 = {
                                        __typename: value$12.__typename,
                                        value: !(value$13 == null) ? value$13 : undefined
                                    };
                                }
                                var value$14 = value.first_name_required_text;
                                var tmp$7;
                                if (value$14 == null) {
                                    tmp$7 = undefined;
                                } else {
                                    var value$15 = value$14.value;
                                    tmp$7 = {
                                        __typename: value$14.__typename,
                                        value: !(value$15 == null) ? value$15 : undefined
                                    };
                                }
                                var value$16 = value.invalid_first_name_text;
                                var tmp$8;
                                if (value$16 == null) {
                                    tmp$8 = undefined;
                                } else {
                                    var value$17 = value$16.value;
                                    tmp$8 = {
                                        __typename: value$16.__typename,
                                        value: !(value$17 == null) ? value$17 : undefined
                                    };
                                }
                                var value$18 = value.last_name_label;
                                var tmp$9;
                                if (value$18 == null) {
                                    tmp$9 = undefined;
                                } else {
                                    var value$19 = value$18.value;
                                    tmp$9 = {
                                        __typename: value$18.__typename,
                                        value: !(value$19 == null) ? value$19 : undefined
                                    };
                                }
                                var value$20 = value.last_name_required_text;
                                var tmp$10;
                                if (value$20 == null) {
                                    tmp$10 = undefined;
                                } else {
                                    var value$21 = value$20.value;
                                    tmp$10 = {
                                        __typename: value$20.__typename,
                                        value: !(value$21 == null) ? value$21 : undefined
                                    };
                                }
                                var value$22 = value.invalid_last_name_text;
                                var tmp$11;
                                if (value$22 == null) {
                                    tmp$11 = undefined;
                                } else {
                                    var value$23 = value$22.value;
                                    tmp$11 = {
                                        __typename: value$22.__typename,
                                        value: !(value$23 == null) ? value$23 : undefined
                                    };
                                }
                                var value$24 = value.step_title___email;
                                var tmp$12;
                                if (value$24 == null) {
                                    tmp$12 = undefined;
                                } else {
                                    var value$25 = value$24.value;
                                    tmp$12 = {
                                        __typename: value$24.__typename,
                                        value: !(value$25 == null) ? value$25 : undefined
                                    };
                                }
                                var value$26 = value.email_label;
                                var tmp$13;
                                if (value$26 == null) {
                                    tmp$13 = undefined;
                                } else {
                                    var value$27 = value$26.value;
                                    tmp$13 = {
                                        __typename: value$26.__typename,
                                        value: !(value$27 == null) ? value$27 : undefined
                                    };
                                }
                                var value$28 = value.email_required_text;
                                var tmp$14;
                                if (value$28 == null) {
                                    tmp$14 = undefined;
                                } else {
                                    var value$29 = value$28.value;
                                    tmp$14 = {
                                        __typename: value$28.__typename,
                                        value: !(value$29 == null) ? value$29 : undefined
                                    };
                                }
                                var value$30 = value.invalid_email_text;
                                var tmp$15;
                                if (value$30 == null) {
                                    tmp$15 = undefined;
                                } else {
                                    var value$31 = value$30.value;
                                    tmp$15 = {
                                        __typename: value$30.__typename,
                                        value: !(value$31 == null) ? value$31 : undefined
                                    };
                                }
                                var value$32 = value.step_title___password;
                                var tmp$16;
                                if (value$32 == null) {
                                    tmp$16 = undefined;
                                } else {
                                    var value$33 = value$32.value;
                                    tmp$16 = {
                                        __typename: value$32.__typename,
                                        value: !(value$33 == null) ? value$33 : undefined
                                    };
                                }
                                var value$34 = value.password_requirements;
                                var tmp$17;
                                if (value$34 == null) {
                                    tmp$17 = undefined;
                                } else {
                                    var value$35 = value$34.value;
                                    tmp$17 = {
                                        __typename: value$34.__typename,
                                        value: !(value$35 == null) ? value$35 : undefined
                                    };
                                }
                                var value$36 = value.password_label;
                                var tmp$18;
                                if (value$36 == null) {
                                    tmp$18 = undefined;
                                } else {
                                    var value$37 = value$36.value;
                                    tmp$18 = {
                                        __typename: value$36.__typename,
                                        value: !(value$37 == null) ? value$37 : undefined
                                    };
                                }
                                var value$38 = value.password_required_text;
                                var tmp$19;
                                if (value$38 == null) {
                                    tmp$19 = undefined;
                                } else {
                                    var value$39 = value$38.value;
                                    tmp$19 = {
                                        __typename: value$38.__typename,
                                        value: !(value$39 == null) ? value$39 : undefined
                                    };
                                }
                                var value$40 = value.invalid_password_text;
                                var tmp$20;
                                if (value$40 == null) {
                                    tmp$20 = undefined;
                                } else {
                                    var value$41 = value$40.value;
                                    tmp$20 = {
                                        __typename: value$40.__typename,
                                        value: !(value$41 == null) ? value$41 : undefined
                                    };
                                }
                                var value$42 = value.step_title___phone_number;
                                var tmp$21;
                                if (value$42 == null) {
                                    tmp$21 = undefined;
                                } else {
                                    var value$43 = value$42.value;
                                    tmp$21 = {
                                        __typename: value$42.__typename,
                                        value: !(value$43 == null) ? value$43 : undefined
                                    };
                                }
                                var value$44 = value.phone_number_required_text;
                                var tmp$22;
                                if (value$44 == null) {
                                    tmp$22 = undefined;
                                } else {
                                    var value$45 = value$44.value;
                                    tmp$22 = {
                                        __typename: value$44.__typename,
                                        value: !(value$45 == null) ? value$45 : undefined
                                    };
                                }
                                var value$46 = value.invalid_phone_number_text;
                                var tmp$23;
                                if (value$46 == null) {
                                    tmp$23 = undefined;
                                } else {
                                    var value$47 = value$46.value;
                                    tmp$23 = {
                                        __typename: value$46.__typename,
                                        value: !(value$47 == null) ? value$47 : undefined
                                    };
                                }
                                var value$48 = value.newsletter_checkbox_label;
                                var tmp$24;
                                if (value$48 == null) {
                                    tmp$24 = undefined;
                                } else {
                                    var value$49 = value$48.value;
                                    tmp$24 = {
                                        __typename: value$48.__typename,
                                        value: !(value$49 == null) ? value$49 : undefined
                                    };
                                }
                                var value$50 = value.t_cs_checkbox_label;
                                var tmp$25;
                                if (value$50 == null) {
                                    tmp$25 = undefined;
                                } else {
                                    var value$51 = value$50.value;
                                    tmp$25 = {
                                        __typename: value$50.__typename,
                                        value: !(value$51 == null) ? value$51 : undefined
                                    };
                                }
                                var value$52 = value.nz_not_prezzy_disclaimer;
                                var tmp$26;
                                if (value$52 == null) {
                                    tmp$26 = undefined;
                                } else {
                                    var value$53 = value$52.value;
                                    tmp$26 = {
                                        __typename: value$52.__typename,
                                        value: !(value$53 == null) ? value$53 : undefined
                                    };
                                }
                                var value$54 = value.send_security_code_cta_text;
                                var tmp$27;
                                if (value$54 == null) {
                                    tmp$27 = undefined;
                                } else {
                                    var value$55 = value$54.value;
                                    tmp$27 = {
                                        __typename: value$54.__typename,
                                        value: !(value$55 == null) ? value$55 : undefined
                                    };
                                }
                                var value$56 = value.step_title___security_code;
                                var tmp$28;
                                if (value$56 == null) {
                                    tmp$28 = undefined;
                                } else {
                                    var value$57 = value$56.value;
                                    tmp$28 = {
                                        __typename: value$56.__typename,
                                        value: !(value$57 == null) ? value$57 : undefined
                                    };
                                }
                                var value$58 = value.resend_code_text;
                                var tmp$29;
                                if (value$58 == null) {
                                    tmp$29 = undefined;
                                } else {
                                    var value$59 = value$58.value;
                                    tmp$29 = {
                                        __typename: value$58.__typename,
                                        value: !(value$59 == null) ? value$59 : undefined
                                    };
                                }
                                var value$60 = value.resending_code_text;
                                var tmp$30;
                                if (value$60 == null) {
                                    tmp$30 = undefined;
                                } else {
                                    var value$61 = value$60.value;
                                    tmp$30 = {
                                        __typename: value$60.__typename,
                                        value: !(value$61 == null) ? value$61 : undefined
                                    };
                                }
                                var value$62 = value.sign_up_cta_text;
                                var tmp$31;
                                if (value$62 == null) {
                                    tmp$31 = undefined;
                                } else {
                                    var value$63 = value$62.value;
                                    tmp$31 = {
                                        __typename: value$62.__typename,
                                        value: !(value$63 == null) ? value$63 : undefined
                                    };
                                }
                                var value$64 = value.already_registered_text;
                                var tmp$32;
                                if (value$64 == null) {
                                    tmp$32 = undefined;
                                } else {
                                    var value$65 = value$64.value;
                                    tmp$32 = {
                                        __typename: value$64.__typename,
                                        value: !(value$65 == null) ? value$65 : undefined
                                    };
                                }
                                tmp = {
                                    NAME: "RegisterContentType",
                                    VAL: {
                                        __typename: value.__typename,
                                        system: {
                                            __typename: value$1.__typename,
                                            codename: value$1.codename,
                                            id: value$1.id
                                        },
                                        register_title: tmp$1,
                                        register_subtitle: tmp$2,
                                        next_button_text: tmp$3,
                                        back_button_text: tmp$4,
                                        step_title___name: tmp$5,
                                        first_name_label: tmp$6,
                                        first_name_required_text: tmp$7,
                                        invalid_first_name_text: tmp$8,
                                        last_name_label: tmp$9,
                                        last_name_required_text: tmp$10,
                                        invalid_last_name_text: tmp$11,
                                        step_title___email: tmp$12,
                                        email_label: tmp$13,
                                        email_required_text: tmp$14,
                                        invalid_email_text: tmp$15,
                                        step_title___password: tmp$16,
                                        password_requirements: tmp$17,
                                        password_label: tmp$18,
                                        password_required_text: tmp$19,
                                        invalid_password_text: tmp$20,
                                        step_title___phone_number: tmp$21,
                                        phone_number_required_text: tmp$22,
                                        invalid_phone_number_text: tmp$23,
                                        newsletter_checkbox_label: tmp$24,
                                        t_cs_checkbox_label: tmp$25,
                                        nz_not_prezzy_disclaimer: tmp$26,
                                        send_security_code_cta_text: tmp$27,
                                        step_title___security_code: tmp$28,
                                        resend_code_text: tmp$29,
                                        resending_code_text: tmp$30,
                                        sign_up_cta_text: tmp$31,
                                        already_registered_text: tmp$32
                                    }
                                };
                            } else {
                                tmp = {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                            }
                            return tmp;
                        }, value$20) : undefined
                    };
                }
                var value$21 = value.warnings;
                var tmp$11;
                if (value$21 == null) {
                    tmp$11 = undefined;
                } else {
                    var value$22 = value$21.value;
                    tmp$11 = {
                        __typename: value$21.__typename,
                        value: !(value$22 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            if (typename === "WarningContentType") {
                                var value$1 = value.id;
                                var tmp$1;
                                if (value$1 == null) {
                                    tmp$1 = undefined;
                                } else {
                                    var value$2 = value$1.value;
                                    tmp$1 = {
                                        __typename: value$1.__typename,
                                        value: !(value$2 == null) ? value$2 : undefined
                                    };
                                }
                                var value$3 = value.heading;
                                var tmp$2;
                                if (value$3 == null) {
                                    tmp$2 = undefined;
                                } else {
                                    var value$4 = value$3.value;
                                    tmp$2 = {
                                        __typename: value$3.__typename,
                                        value: !(value$4 == null) ? value$4 : undefined
                                    };
                                }
                                var value$5 = value.description;
                                var tmp$3;
                                if (value$5 == null) {
                                    tmp$3 = undefined;
                                } else {
                                    var value$6 = value$5.value;
                                    tmp$3 = {
                                        __typename: value$5.__typename,
                                        value: !(value$6 == null) ? value$6 : undefined
                                    };
                                }
                                tmp = {
                                    NAME: "WarningContentType",
                                    VAL: {
                                        __typename: value.__typename,
                                        id: tmp$1,
                                        heading: tmp$2,
                                        description: tmp$3
                                    }
                                };
                            } else {
                                tmp = {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                            }
                            return tmp;
                        }, value$22) : undefined
                    };
                }
                var value$23 = value.header_logo;
                var tmp$12;
                if (value$23 == null) {
                    tmp$12 = undefined;
                } else {
                    var value$24 = value$23.value;
                    tmp$12 = {
                        __typename: value$23.__typename,
                        value: !(value$24 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "HeaderLogoContentType" ? {
                                NAME: "HeaderLogoContentType",
                                VAL: {
                                    headerLogo: HeaderLogo.verifyArgsAndParse("HeaderLogo", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$24) : undefined
                    };
                }
                var value$25 = value.not_logged_in_navbar_menu_items___consumer;
                var tmp$13;
                if (value$25 == null) {
                    tmp$13 = undefined;
                } else {
                    var value$26 = value$25.value;
                    tmp$13 = {
                        __typename: value$25.__typename,
                        value: !(value$26 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            switch(typename){
                                case "CallToActionLinkD6a3d61ContentType":
                                    tmp = {
                                        NAME: "CallToActionLinkD6a3d61ContentType",
                                        VAL: {
                                            callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                        }
                                    };
                                    break;
                                case "NavbarSelectCtaContentType":
                                    tmp = {
                                        NAME: "NavbarSelectCtaContentType",
                                        VAL: {
                                            navbarSelectCTA: NavbarSelectCTA.verifyArgsAndParse("NavbarSelectCTA", value)
                                        }
                                    };
                                    break;
                                default:
                                    tmp = {
                                        NAME: "UnspecifiedFragment",
                                        VAL: typename
                                    };
                            }
                            return tmp;
                        }, value$26) : undefined
                    };
                }
                var value$27 = value.not_logged_in_navbar_menu_items___business;
                var tmp$14;
                if (value$27 == null) {
                    tmp$14 = undefined;
                } else {
                    var value$28 = value$27.value;
                    tmp$14 = {
                        __typename: value$27.__typename,
                        value: !(value$28 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$28) : undefined
                    };
                }
                var value$29 = value.search_bar_placeholder_text;
                var tmp$15;
                if (value$29 == null) {
                    tmp$15 = undefined;
                } else {
                    var value$30 = value$29.value;
                    tmp$15 = {
                        __typename: value$29.__typename,
                        value: !(value$30 == null) ? value$30 : undefined
                    };
                }
                var value$31 = value.no_search_result;
                var tmp$16;
                if (value$31 == null) {
                    tmp$16 = undefined;
                } else {
                    var value$32 = value$31.value;
                    tmp$16 = {
                        __typename: value$31.__typename,
                        value: !(value$32 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "NoSearchResultsContentType" ? {
                                NAME: "NoSearchResultsContentType",
                                VAL: {
                                    noSearchResults: NoSearchResults.verifyArgsAndParse("NoSearchResults", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$32) : undefined
                    };
                }
                var value$33 = value.sold_out_badge_text;
                var tmp$17;
                if (value$33 == null) {
                    tmp$17 = undefined;
                } else {
                    var value$34 = value$33.value;
                    tmp$17 = {
                        __typename: value$33.__typename,
                        value: !(value$34 == null) ? value$34 : undefined
                    };
                }
                tmp = {
                    NAME: "GlobalConfigurationContentType",
                    VAL: {
                        __typename: value.__typename,
                        gdpr_cookie_popup: tmp$1,
                        alert_banner: tmp$2,
                        navigation_root: tmp$3,
                        business_navigation: tmp$4,
                        desktop_navbar_menu_items: tmp$5,
                        mobile_navbar_menu_items: tmp$6,
                        footer: tmp$7,
                        business_footer: tmp$8,
                        login: tmp$9,
                        register: tmp$10,
                        warnings: tmp$11,
                        header_logo: tmp$12,
                        not_logged_in_navbar_menu_items___consumer: tmp$13,
                        not_logged_in_navbar_menu_items___business: tmp$14,
                        search_bar_placeholder_text: tmp$15,
                        no_search_result: tmp$16,
                        sold_out_badge_text: tmp$17
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$1) : undefined,
        dictionaryItems: !(value$2 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "DictionaryItemContentType") {
                var value$1 = value.system;
                var value$2 = value.value;
                var tmp$1;
                if (value$2 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$3 = value$2.value;
                    tmp$1 = {
                        __typename: value$2.__typename,
                        value: !(value$3 == null) ? value$3 : undefined
                    };
                }
                tmp = {
                    NAME: "DictionaryItemContentType",
                    VAL: {
                        __typename: value.__typename,
                        system: {
                            __typename: value$1.__typename,
                            id: value$1.id,
                            codename: value$1.codename
                        },
                        value: tmp$1
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$2) : undefined,
        locations: !(value$3 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "ModalChangeLocationContentType") {
                var value$1 = value.system;
                var value$2 = value.title;
                var tmp$1;
                if (value$2 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$3 = value$2.value;
                    tmp$1 = {
                        __typename: value$2.__typename,
                        value: !(value$3 == null) ? value$3 : undefined
                    };
                }
                var value$4 = value.subtitle;
                var tmp$2;
                if (value$4 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$5 = value$4.value;
                    tmp$2 = {
                        __typename: value$4.__typename,
                        value: !(value$5 == null) ? value$5 : undefined
                    };
                }
                var value$6 = value.cta_text;
                var tmp$3;
                if (value$6 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$7 = value$6.value;
                    tmp$3 = {
                        __typename: value$6.__typename,
                        value: !(value$7 == null) ? value$7 : undefined
                    };
                }
                var value$8 = value.region_location;
                var tmp$4;
                if (value$8 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$9 = value$8.value;
                    tmp$4 = {
                        __typename: value$8.__typename,
                        value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            if (typename === "RegionLocationContentType") {
                                var value$1 = value.system;
                                var value$2 = value.currency;
                                var tmp$1;
                                if (value$2 == null) {
                                    tmp$1 = undefined;
                                } else {
                                    var value$3 = value$2.value;
                                    tmp$1 = {
                                        __typename: value$2.__typename,
                                        value: !(value$3 == null) ? value$3 : undefined
                                    };
                                }
                                var value$4 = value.country_name;
                                var tmp$2;
                                if (value$4 == null) {
                                    tmp$2 = undefined;
                                } else {
                                    var value$5 = value$4.value;
                                    tmp$2 = {
                                        __typename: value$4.__typename,
                                        value: !(value$5 == null) ? value$5 : undefined
                                    };
                                }
                                var value$6 = value.country_flag;
                                var tmp$3;
                                if (value$6 == null) {
                                    tmp$3 = undefined;
                                } else {
                                    var value$7 = value$6.value;
                                    tmp$3 = {
                                        __typename: value$6.__typename,
                                        value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                            if (value == null) {
                                                return;
                                            }
                                            var value$1 = value.name;
                                            var value$2 = value.url;
                                            return {
                                                __typename: value.__typename,
                                                name: !(value$1 == null) ? value$1 : undefined,
                                                url: !(value$2 == null) ? value$2 : undefined
                                            };
                                        }, value$7) : undefined
                                    };
                                }
                                var value$8 = value.url;
                                var tmp$4;
                                if (value$8 == null) {
                                    tmp$4 = undefined;
                                } else {
                                    var value$9 = value$8.value;
                                    tmp$4 = {
                                        __typename: value$8.__typename,
                                        value: !(value$9 == null) ? value$9 : undefined
                                    };
                                }
                                tmp = {
                                    NAME: "RegionLocationContentType",
                                    VAL: {
                                        __typename: value.__typename,
                                        system: {
                                            __typename: value$1.__typename,
                                            id: value$1.id,
                                            codename: value$1.codename
                                        },
                                        currency: tmp$1,
                                        country_name: tmp$2,
                                        country_flag: tmp$3,
                                        url: tmp$4
                                    }
                                };
                            } else {
                                tmp = {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                            }
                            return tmp;
                        }, value$9) : undefined
                    };
                }
                tmp = {
                    NAME: "ModalChangeLocationContentType",
                    VAL: {
                        __typename: value.__typename,
                        system: {
                            __typename: value$1.__typename,
                            id: value$1.id,
                            codename: value$1.codename
                        },
                        title: tmp$1,
                        subtitle: tmp$2,
                        cta_text: tmp$3,
                        region_location: tmp$4
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$3) : undefined,
        giftLandingPage: !(value$4 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "GiftLandingPageContentType") {
                var value$1 = value.system;
                var value$2 = value.classic_logo_asset;
                var tmp$1;
                if (value$2 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$3 = value$2.value;
                    tmp$1 = {
                        __typename: value$2.__typename,
                        value: !(value$3 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$3) : undefined
                    };
                }
                var value$4 = value.business_logo_asset;
                var tmp$2;
                if (value$4 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$5 = value$4.value;
                    tmp$2 = {
                        __typename: value$4.__typename,
                        value: !(value$5 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$5) : undefined
                    };
                }
                var value$6 = value.sender_message;
                var tmp$3;
                if (value$6 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$7 = value$6.value;
                    tmp$3 = {
                        __typename: value$6.__typename,
                        value: !(value$7 == null) ? value$7 : undefined
                    };
                }
                var value$8 = value.gift_reveal_cta_text;
                var tmp$4;
                if (value$8 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$9 = value$8.value;
                    tmp$4 = {
                        __typename: value$8.__typename,
                        value: !(value$9 == null) ? value$9 : undefined
                    };
                }
                var value$10 = value.confetti_lottie;
                var tmp$5;
                if (value$10 == null) {
                    tmp$5 = undefined;
                } else {
                    var value$11 = value$10.value;
                    tmp$5 = {
                        __typename: value$10.__typename,
                        value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$11) : undefined
                    };
                }
                var value$12 = value.faqs;
                var tmp$6;
                if (value$12 == null) {
                    tmp$6 = undefined;
                } else {
                    var value$13 = value$12.value;
                    tmp$6 = {
                        __typename: value$12.__typename,
                        value: !(value$13 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp;
                            if (typename === "GiftLandingPageFaqItemContentType") {
                                var value$1 = value.system;
                                var value$2 = value.title;
                                var tmp$1;
                                if (value$2 == null) {
                                    tmp$1 = undefined;
                                } else {
                                    var value$3 = value$2.value;
                                    tmp$1 = {
                                        __typename: value$2.__typename,
                                        value: !(value$3 == null) ? value$3 : undefined
                                    };
                                }
                                var value$4 = value.body_text;
                                var tmp$2;
                                if (value$4 == null) {
                                    tmp$2 = undefined;
                                } else {
                                    var value$5 = value$4.value;
                                    tmp$2 = {
                                        __typename: value$4.__typename,
                                        value: !(value$5 == null) ? value$5 : undefined
                                    };
                                }
                                var value$6 = value.include_how_to_use;
                                var tmp$3;
                                if (value$6 == null) {
                                    tmp$3 = undefined;
                                } else {
                                    var value$7 = value$6.value;
                                    tmp$3 = {
                                        __typename: value$6.__typename,
                                        value: !(value$7 == null) ? js_array/* map */.UI(function(value) {
                                            if (value == null) {
                                                return;
                                            }
                                            var value$1 = value.codename;
                                            return {
                                                __typename: value.__typename,
                                                codename: !(value$1 == null) ? value$1 : undefined
                                            };
                                        }, value$7) : undefined
                                    };
                                }
                                var value$8 = value.include_pdf_download;
                                var tmp$4;
                                if (value$8 == null) {
                                    tmp$4 = undefined;
                                } else {
                                    var value$9 = value$8.value;
                                    tmp$4 = {
                                        __typename: value$8.__typename,
                                        value: !(value$9 == null) ? js_array/* map */.UI(function(value) {
                                            if (value == null) {
                                                return;
                                            }
                                            var value$1 = value.codename;
                                            return {
                                                __typename: value.__typename,
                                                codename: !(value$1 == null) ? value$1 : undefined
                                            };
                                        }, value$9) : undefined
                                    };
                                }
                                var value$10 = value.include_card_merchant_terms;
                                var tmp$5;
                                if (value$10 == null) {
                                    tmp$5 = undefined;
                                } else {
                                    var value$11 = value$10.value;
                                    tmp$5 = {
                                        __typename: value$10.__typename,
                                        value: !(value$11 == null) ? js_array/* map */.UI(function(value) {
                                            if (value == null) {
                                                return;
                                            }
                                            var value$1 = value.codename;
                                            return {
                                                __typename: value.__typename,
                                                codename: !(value$1 == null) ? value$1 : undefined
                                            };
                                        }, value$11) : undefined
                                    };
                                }
                                tmp = {
                                    NAME: "GiftLandingPageFaqItemContentType",
                                    VAL: {
                                        __typename: value.__typename,
                                        system: {
                                            __typename: value$1.__typename,
                                            codename: value$1.codename,
                                            id: value$1.id
                                        },
                                        title: tmp$1,
                                        body_text: tmp$2,
                                        include_how_to_use: tmp$3,
                                        include_pdf_download: tmp$4,
                                        include_card_merchant_terms: tmp$5
                                    }
                                };
                            } else {
                                tmp = {
                                    NAME: "UnspecifiedFragment",
                                    VAL: typename
                                };
                            }
                            return tmp;
                        }, value$13) : undefined
                    };
                }
                var value$14 = value.no_expiry_text;
                var tmp$7;
                if (value$14 == null) {
                    tmp$7 = undefined;
                } else {
                    var value$15 = value$14.value;
                    tmp$7 = {
                        __typename: value$14.__typename,
                        value: !(value$15 == null) ? value$15 : undefined
                    };
                }
                var value$16 = value.expiry_label;
                var tmp$8;
                if (value$16 == null) {
                    tmp$8 = undefined;
                } else {
                    var value$17 = value$16.value;
                    tmp$8 = {
                        __typename: value$16.__typename,
                        value: !(value$17 == null) ? value$17 : undefined
                    };
                }
                var value$18 = value.check_balance_text;
                var tmp$9;
                if (value$18 == null) {
                    tmp$9 = undefined;
                } else {
                    var value$19 = value$18.value;
                    tmp$9 = {
                        __typename: value$18.__typename,
                        value: !(value$19 == null) ? value$19 : undefined
                    };
                }
                var value$20 = value.check_balance_icon_asset;
                var tmp$10;
                if (value$20 == null) {
                    tmp$10 = undefined;
                } else {
                    var value$21 = value$20.value;
                    tmp$10 = {
                        __typename: value$20.__typename,
                        value: !(value$21 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$21) : undefined
                    };
                }
                var value$22 = value.store_in_wallet_cta_title;
                var tmp$11;
                if (value$22 == null) {
                    tmp$11 = undefined;
                } else {
                    var value$23 = value$22.value;
                    tmp$11 = {
                        __typename: value$22.__typename,
                        value: !(value$23 == null) ? value$23 : undefined
                    };
                }
                var value$24 = value.swap_egift_card_cta_title;
                var tmp$12;
                if (value$24 == null) {
                    tmp$12 = undefined;
                } else {
                    var value$25 = value$24.value;
                    tmp$12 = {
                        __typename: value$24.__typename,
                        value: !(value$25 == null) ? value$25 : undefined
                    };
                }
                var value$26 = value.optional_gift_card_cta;
                var tmp$13;
                if (value$26 == null) {
                    tmp$13 = undefined;
                } else {
                    var value$27 = value$26.value;
                    tmp$13 = {
                        __typename: value$26.__typename,
                        value: !(value$27 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$27) : undefined
                    };
                }
                var value$28 = value.gift_unwrap_cta_text;
                var tmp$14;
                if (value$28 == null) {
                    tmp$14 = undefined;
                } else {
                    var value$29 = value$28.value;
                    tmp$14 = {
                        __typename: value$28.__typename,
                        value: !(value$29 == null) ? value$29 : undefined
                    };
                }
                var value$30 = value.gift_unwrap_lottie_segments;
                var tmp$15;
                if (value$30 == null) {
                    tmp$15 = undefined;
                } else {
                    var value$31 = value$30.value;
                    tmp$15 = {
                        __typename: value$30.__typename,
                        value: !(value$31 == null) ? value$31 : undefined
                    };
                }
                var value$32 = value.classic_gift_unwrap_lottie;
                var tmp$16;
                if (value$32 == null) {
                    tmp$16 = undefined;
                } else {
                    var value$33 = value$32.value;
                    tmp$16 = {
                        __typename: value$32.__typename,
                        value: !(value$33 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$33) : undefined
                    };
                }
                var value$34 = value.business_gift_unwrap_lottie;
                var tmp$17;
                if (value$34 == null) {
                    tmp$17 = undefined;
                } else {
                    var value$35 = value$34.value;
                    tmp$17 = {
                        __typename: value$34.__typename,
                        value: !(value$35 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$35) : undefined
                    };
                }
                var value$36 = value.replay_button_icon_asset;
                var tmp$18;
                if (value$36 == null) {
                    tmp$18 = undefined;
                } else {
                    var value$37 = value$36.value;
                    tmp$18 = {
                        __typename: value$36.__typename,
                        value: !(value$37 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$37) : undefined
                    };
                }
                var value$38 = value.replay_button_text;
                var tmp$19;
                if (value$38 == null) {
                    tmp$19 = undefined;
                } else {
                    var value$39 = value$38.value;
                    tmp$19 = {
                        __typename: value$38.__typename,
                        value: !(value$39 == null) ? value$39 : undefined
                    };
                }
                var value$40 = value.redeem_online_text;
                var tmp$20;
                if (value$40 == null) {
                    tmp$20 = undefined;
                } else {
                    var value$41 = value$40.value;
                    tmp$20 = {
                        __typename: value$40.__typename,
                        value: !(value$41 == null) ? value$41 : undefined
                    };
                }
                var value$42 = value.redeem_online_text_colour;
                var tmp$21;
                if (value$42 == null) {
                    tmp$21 = undefined;
                } else {
                    var value$43 = value$42.value;
                    tmp$21 = {
                        __typename: value$42.__typename,
                        value: !(value$43 == null) ? value$43 : undefined
                    };
                }
                var value$44 = value.redeem_online_button;
                var tmp$22;
                if (value$44 == null) {
                    tmp$22 = undefined;
                } else {
                    var value$45 = value$44.value;
                    tmp$22 = {
                        __typename: value$44.__typename,
                        value: !(value$45 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$45) : undefined
                    };
                }
                var value$46 = value.download_option_text;
                var tmp$23;
                if (value$46 == null) {
                    tmp$23 = undefined;
                } else {
                    var value$47 = value$46.value;
                    tmp$23 = {
                        __typename: value$46.__typename,
                        value: !(value$47 == null) ? value$47 : undefined
                    };
                }
                var value$48 = value.download_option_text_colour;
                var tmp$24;
                if (value$48 == null) {
                    tmp$24 = undefined;
                } else {
                    var value$49 = value$48.value;
                    tmp$24 = {
                        __typename: value$48.__typename,
                        value: !(value$49 == null) ? value$49 : undefined
                    };
                }
                var value$50 = value.download_button;
                var tmp$25;
                if (value$50 == null) {
                    tmp$25 = undefined;
                } else {
                    var value$51 = value$50.value;
                    tmp$25 = {
                        __typename: value$50.__typename,
                        value: !(value$51 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$51) : undefined
                    };
                }
                var value$52 = value.spend_it_now_heading;
                var tmp$26;
                if (value$52 == null) {
                    tmp$26 = undefined;
                } else {
                    var value$53 = value$52.value;
                    tmp$26 = {
                        __typename: value$52.__typename,
                        value: !(value$53 == null) ? value$53 : undefined
                    };
                }
                var value$54 = value.clipboard_item_copy_text;
                var tmp$27;
                if (value$54 == null) {
                    tmp$27 = undefined;
                } else {
                    var value$55 = value$54.value;
                    tmp$27 = {
                        __typename: value$54.__typename,
                        value: !(value$55 == null) ? value$55 : undefined
                    };
                }
                var value$56 = value.clipboard_item_copied_text;
                var tmp$28;
                if (value$56 == null) {
                    tmp$28 = undefined;
                } else {
                    var value$57 = value$56.value;
                    tmp$28 = {
                        __typename: value$56.__typename,
                        value: !(value$57 == null) ? value$57 : undefined
                    };
                }
                var value$58 = value.barcode_number_clipboard_heading;
                var tmp$29;
                if (value$58 == null) {
                    tmp$29 = undefined;
                } else {
                    var value$59 = value$58.value;
                    tmp$29 = {
                        __typename: value$58.__typename,
                        value: !(value$59 == null) ? value$59 : undefined
                    };
                }
                var value$60 = value.in_store_number_clipboard_heading;
                var tmp$30;
                if (value$60 == null) {
                    tmp$30 = undefined;
                } else {
                    var value$61 = value$60.value;
                    tmp$30 = {
                        __typename: value$60.__typename,
                        value: !(value$61 == null) ? value$61 : undefined
                    };
                }
                var value$62 = value.online_number_clipboard_heading;
                var tmp$31;
                if (value$62 == null) {
                    tmp$31 = undefined;
                } else {
                    var value$63 = value$62.value;
                    tmp$31 = {
                        __typename: value$62.__typename,
                        value: !(value$63 == null) ? value$63 : undefined
                    };
                }
                var value$64 = value.online_and_in_store_clipboard_heading;
                var tmp$32;
                if (value$64 == null) {
                    tmp$32 = undefined;
                } else {
                    var value$65 = value$64.value;
                    tmp$32 = {
                        __typename: value$64.__typename,
                        value: !(value$65 == null) ? value$65 : undefined
                    };
                }
                var value$66 = value.swap_cards_title;
                var tmp$33;
                if (value$66 == null) {
                    tmp$33 = undefined;
                } else {
                    var value$67 = value$66.value;
                    tmp$33 = {
                        __typename: value$66.__typename,
                        value: !(value$67 == null) ? value$67 : undefined
                    };
                }
                var value$68 = value.swap_card_alt;
                var tmp$34;
                if (value$68 == null) {
                    tmp$34 = undefined;
                } else {
                    var value$69 = value$68.value;
                    tmp$34 = {
                        __typename: value$68.__typename,
                        value: !(value$69 == null) ? value$69 : undefined
                    };
                }
                var value$70 = value.swap_card_original_value_label;
                var tmp$35;
                if (value$70 == null) {
                    tmp$35 = undefined;
                } else {
                    var value$71 = value$70.value;
                    tmp$35 = {
                        __typename: value$70.__typename,
                        value: !(value$71 == null) ? value$71 : undefined
                    };
                }
                var value$72 = value.swap_card_button_style;
                var tmp$36;
                if (value$72 == null) {
                    tmp$36 = undefined;
                } else {
                    var value$73 = value$72.value;
                    tmp$36 = {
                        __typename: value$72.__typename,
                        value: !(value$73 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                                NAME: "CallToActionLinkD6a3d61ContentType",
                                VAL: {
                                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$73) : undefined
                    };
                }
                var value$74 = value.save_in_apple_google_wallet_text;
                var tmp$37;
                if (value$74 == null) {
                    tmp$37 = undefined;
                } else {
                    var value$75 = value$74.value;
                    tmp$37 = {
                        __typename: value$74.__typename,
                        value: !(value$75 == null) ? value$75 : undefined
                    };
                }
                var value$76 = value.save_in_apple_google_wallet_text_colour;
                var tmp$38;
                if (value$76 == null) {
                    tmp$38 = undefined;
                } else {
                    var value$77 = value$76.value;
                    tmp$38 = {
                        __typename: value$76.__typename,
                        value: !(value$77 == null) ? value$77 : undefined
                    };
                }
                var value$78 = value.google_wallet_image_asset;
                var tmp$39;
                if (value$78 == null) {
                    tmp$39 = undefined;
                } else {
                    var value$79 = value$78.value;
                    tmp$39 = {
                        __typename: value$78.__typename,
                        value: !(value$79 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$79) : undefined
                    };
                }
                var value$80 = value.apple_wallet_image_asset;
                var tmp$40;
                if (value$80 == null) {
                    tmp$40 = undefined;
                } else {
                    var value$81 = value$80.value;
                    tmp$40 = {
                        __typename: value$80.__typename,
                        value: !(value$81 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.name;
                            var value$2 = value.description;
                            var value$3 = value.url;
                            var value$4 = value.width;
                            var value$5 = value.height;
                            return {
                                __typename: value.__typename,
                                name: !(value$1 == null) ? value$1 : undefined,
                                description: !(value$2 == null) ? value$2 : undefined,
                                url: !(value$3 == null) ? value$3 : undefined,
                                width: !(value$4 == null) ? value$4 : undefined,
                                height: !(value$5 == null) ? value$5 : undefined
                            };
                        }, value$81) : undefined
                    };
                }
                var value$82 = value.footer_copyright_text;
                var tmp$41;
                if (value$82 == null) {
                    tmp$41 = undefined;
                } else {
                    var value$83 = value$82.value;
                    tmp$41 = {
                        __typename: value$82.__typename,
                        value: !(value$83 == null) ? value$83 : undefined
                    };
                }
                var value$84 = value.footer_download_text;
                var tmp$42;
                if (value$84 == null) {
                    tmp$42 = undefined;
                } else {
                    var value$85 = value$84.value;
                    tmp$42 = {
                        __typename: value$84.__typename,
                        value: !(value$85 == null) ? value$85 : undefined
                    };
                }
                var value$86 = value.app_store_icons;
                var tmp$43;
                if (value$86 == null) {
                    tmp$43 = undefined;
                } else {
                    var value$87 = value$86.value;
                    tmp$43 = {
                        __typename: value$86.__typename,
                        value: !(value$87 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var typename = value["__typename"];
                            var tmp = typename === "AppStoreItemContentType" ? {
                                NAME: "AppStoreItemContentType",
                                VAL: {
                                    appStoreItem: AppStoreItem.verifyArgsAndParse("AppStoreItem", value)
                                }
                            } : {
                                NAME: "UnspecifiedFragment",
                                VAL: typename
                            };
                            return tmp;
                        }, value$87) : undefined
                    };
                }
                var value$88 = value.create_account_modal_title;
                var tmp$44;
                if (value$88 == null) {
                    tmp$44 = undefined;
                } else {
                    var value$89 = value$88.value;
                    tmp$44 = {
                        __typename: value$88.__typename,
                        value: !(value$89 == null) ? value$89 : undefined
                    };
                }
                var value$90 = value.create_account_modal_list;
                var tmp$45;
                if (value$90 == null) {
                    tmp$45 = undefined;
                } else {
                    var value$91 = value$90.value;
                    tmp$45 = {
                        __typename: value$90.__typename,
                        value: !(value$91 == null) ? value$91 : undefined
                    };
                }
                var value$92 = value.create_account_modal_cta_text;
                var tmp$46;
                if (value$92 == null) {
                    tmp$46 = undefined;
                } else {
                    var value$93 = value$92.value;
                    tmp$46 = {
                        __typename: value$92.__typename,
                        value: !(value$93 == null) ? value$93 : undefined
                    };
                }
                tmp = {
                    NAME: "GiftLandingPageContentType",
                    VAL: {
                        __typename: value.__typename,
                        system: {
                            __typename: value$1.__typename,
                            codename: value$1.codename,
                            id: value$1.id
                        },
                        classic_logo_asset: tmp$1,
                        business_logo_asset: tmp$2,
                        sender_message: tmp$3,
                        gift_reveal_cta_text: tmp$4,
                        confetti_lottie: tmp$5,
                        faqs: tmp$6,
                        no_expiry_text: tmp$7,
                        expiry_label: tmp$8,
                        check_balance_text: tmp$9,
                        check_balance_icon_asset: tmp$10,
                        store_in_wallet_cta_title: tmp$11,
                        swap_egift_card_cta_title: tmp$12,
                        optional_gift_card_cta: tmp$13,
                        gift_unwrap_cta_text: tmp$14,
                        gift_unwrap_lottie_segments: tmp$15,
                        classic_gift_unwrap_lottie: tmp$16,
                        business_gift_unwrap_lottie: tmp$17,
                        replay_button_icon_asset: tmp$18,
                        replay_button_text: tmp$19,
                        redeem_online_text: tmp$20,
                        redeem_online_text_colour: tmp$21,
                        redeem_online_button: tmp$22,
                        download_option_text: tmp$23,
                        download_option_text_colour: tmp$24,
                        download_button: tmp$25,
                        spend_it_now_heading: tmp$26,
                        clipboard_item_copy_text: tmp$27,
                        clipboard_item_copied_text: tmp$28,
                        barcode_number_clipboard_heading: tmp$29,
                        in_store_number_clipboard_heading: tmp$30,
                        online_number_clipboard_heading: tmp$31,
                        online_and_in_store_clipboard_heading: tmp$32,
                        swap_cards_title: tmp$33,
                        swap_card_alt: tmp$34,
                        swap_card_original_value_label: tmp$35,
                        swap_card_button_style: tmp$36,
                        save_in_apple_google_wallet_text: tmp$37,
                        save_in_apple_google_wallet_text_colour: tmp$38,
                        google_wallet_image_asset: tmp$39,
                        apple_wallet_image_asset: tmp$40,
                        footer_copyright_text: tmp$41,
                        footer_download_text: tmp$42,
                        app_store_icons: tmp$43,
                        create_account_modal_title: tmp$44,
                        create_account_modal_list: tmp$45,
                        create_account_modal_cta_text: tmp$46
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$4) : undefined
    };
}
function Gql_GlobalConfiguration_Query_bs_serialize(value) {
    var value$1 = value.giftLandingPage;
    var giftLandingPage = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME !== "GiftLandingPageContentType") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.create_account_modal_cta_text;
        var create_account_modal_cta_text;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? value$3 : null;
            var value$5 = value$2.__typename;
            create_account_modal_cta_text = {
                __typename: value$5,
                value: value$4
            };
        } else {
            create_account_modal_cta_text = null;
        }
        var value$6 = value$1.create_account_modal_list;
        var create_account_modal_list;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? value$7 : null;
            var value$9 = value$6.__typename;
            create_account_modal_list = {
                __typename: value$9,
                value: value$8
            };
        } else {
            create_account_modal_list = null;
        }
        var value$10 = value$1.create_account_modal_title;
        var create_account_modal_title;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? value$11 : null;
            var value$13 = value$10.__typename;
            create_account_modal_title = {
                __typename: value$13,
                value: value$12
            };
        } else {
            create_account_modal_title = null;
        }
        var value$14 = value$1.app_store_icons;
        var app_store_icons;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            AppStoreItem.serialize(value.VAL.appStoreItem)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$15) : null;
            var value$17 = value$14.__typename;
            app_store_icons = {
                __typename: value$17,
                value: value$16
            };
        } else {
            app_store_icons = null;
        }
        var value$18 = value$1.footer_download_text;
        var footer_download_text;
        if (value$18 !== undefined) {
            var value$19 = value$18.value;
            var value$20 = value$19 !== undefined ? value$19 : null;
            var value$21 = value$18.__typename;
            footer_download_text = {
                __typename: value$21,
                value: value$20
            };
        } else {
            footer_download_text = null;
        }
        var value$22 = value$1.footer_copyright_text;
        var footer_copyright_text;
        if (value$22 !== undefined) {
            var value$23 = value$22.value;
            var value$24 = value$23 !== undefined ? value$23 : null;
            var value$25 = value$22.__typename;
            footer_copyright_text = {
                __typename: value$25,
                value: value$24
            };
        } else {
            footer_copyright_text = null;
        }
        var value$26 = value$1.apple_wallet_image_asset;
        var apple_wallet_image_asset;
        if (value$26 !== undefined) {
            var value$27 = value$26.value;
            var value$28 = value$27 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$27) : null;
            var value$29 = value$26.__typename;
            apple_wallet_image_asset = {
                __typename: value$29,
                value: value$28
            };
        } else {
            apple_wallet_image_asset = null;
        }
        var value$30 = value$1.google_wallet_image_asset;
        var google_wallet_image_asset;
        if (value$30 !== undefined) {
            var value$31 = value$30.value;
            var value$32 = value$31 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$31) : null;
            var value$33 = value$30.__typename;
            google_wallet_image_asset = {
                __typename: value$33,
                value: value$32
            };
        } else {
            google_wallet_image_asset = null;
        }
        var value$34 = value$1.save_in_apple_google_wallet_text_colour;
        var save_in_apple_google_wallet_text_colour;
        if (value$34 !== undefined) {
            var value$35 = value$34.value;
            var value$36 = value$35 !== undefined ? value$35 : null;
            var value$37 = value$34.__typename;
            save_in_apple_google_wallet_text_colour = {
                __typename: value$37,
                value: value$36
            };
        } else {
            save_in_apple_google_wallet_text_colour = null;
        }
        var value$38 = value$1.save_in_apple_google_wallet_text;
        var save_in_apple_google_wallet_text;
        if (value$38 !== undefined) {
            var value$39 = value$38.value;
            var value$40 = value$39 !== undefined ? value$39 : null;
            var value$41 = value$38.__typename;
            save_in_apple_google_wallet_text = {
                __typename: value$41,
                value: value$40
            };
        } else {
            save_in_apple_google_wallet_text = null;
        }
        var value$42 = value$1.swap_card_button_style;
        var swap_card_button_style;
        if (value$42 !== undefined) {
            var value$43 = value$42.value;
            var value$44 = value$43 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$43) : null;
            var value$45 = value$42.__typename;
            swap_card_button_style = {
                __typename: value$45,
                value: value$44
            };
        } else {
            swap_card_button_style = null;
        }
        var value$46 = value$1.swap_card_original_value_label;
        var swap_card_original_value_label;
        if (value$46 !== undefined) {
            var value$47 = value$46.value;
            var value$48 = value$47 !== undefined ? value$47 : null;
            var value$49 = value$46.__typename;
            swap_card_original_value_label = {
                __typename: value$49,
                value: value$48
            };
        } else {
            swap_card_original_value_label = null;
        }
        var value$50 = value$1.swap_card_alt;
        var swap_card_alt;
        if (value$50 !== undefined) {
            var value$51 = value$50.value;
            var value$52 = value$51 !== undefined ? value$51 : null;
            var value$53 = value$50.__typename;
            swap_card_alt = {
                __typename: value$53,
                value: value$52
            };
        } else {
            swap_card_alt = null;
        }
        var value$54 = value$1.swap_cards_title;
        var swap_cards_title;
        if (value$54 !== undefined) {
            var value$55 = value$54.value;
            var value$56 = value$55 !== undefined ? value$55 : null;
            var value$57 = value$54.__typename;
            swap_cards_title = {
                __typename: value$57,
                value: value$56
            };
        } else {
            swap_cards_title = null;
        }
        var value$58 = value$1.online_and_in_store_clipboard_heading;
        var online_and_in_store_clipboard_heading;
        if (value$58 !== undefined) {
            var value$59 = value$58.value;
            var value$60 = value$59 !== undefined ? value$59 : null;
            var value$61 = value$58.__typename;
            online_and_in_store_clipboard_heading = {
                __typename: value$61,
                value: value$60
            };
        } else {
            online_and_in_store_clipboard_heading = null;
        }
        var value$62 = value$1.online_number_clipboard_heading;
        var online_number_clipboard_heading;
        if (value$62 !== undefined) {
            var value$63 = value$62.value;
            var value$64 = value$63 !== undefined ? value$63 : null;
            var value$65 = value$62.__typename;
            online_number_clipboard_heading = {
                __typename: value$65,
                value: value$64
            };
        } else {
            online_number_clipboard_heading = null;
        }
        var value$66 = value$1.in_store_number_clipboard_heading;
        var in_store_number_clipboard_heading;
        if (value$66 !== undefined) {
            var value$67 = value$66.value;
            var value$68 = value$67 !== undefined ? value$67 : null;
            var value$69 = value$66.__typename;
            in_store_number_clipboard_heading = {
                __typename: value$69,
                value: value$68
            };
        } else {
            in_store_number_clipboard_heading = null;
        }
        var value$70 = value$1.barcode_number_clipboard_heading;
        var barcode_number_clipboard_heading;
        if (value$70 !== undefined) {
            var value$71 = value$70.value;
            var value$72 = value$71 !== undefined ? value$71 : null;
            var value$73 = value$70.__typename;
            barcode_number_clipboard_heading = {
                __typename: value$73,
                value: value$72
            };
        } else {
            barcode_number_clipboard_heading = null;
        }
        var value$74 = value$1.clipboard_item_copied_text;
        var clipboard_item_copied_text;
        if (value$74 !== undefined) {
            var value$75 = value$74.value;
            var value$76 = value$75 !== undefined ? value$75 : null;
            var value$77 = value$74.__typename;
            clipboard_item_copied_text = {
                __typename: value$77,
                value: value$76
            };
        } else {
            clipboard_item_copied_text = null;
        }
        var value$78 = value$1.clipboard_item_copy_text;
        var clipboard_item_copy_text;
        if (value$78 !== undefined) {
            var value$79 = value$78.value;
            var value$80 = value$79 !== undefined ? value$79 : null;
            var value$81 = value$78.__typename;
            clipboard_item_copy_text = {
                __typename: value$81,
                value: value$80
            };
        } else {
            clipboard_item_copy_text = null;
        }
        var value$82 = value$1.spend_it_now_heading;
        var spend_it_now_heading;
        if (value$82 !== undefined) {
            var value$83 = value$82.value;
            var value$84 = value$83 !== undefined ? value$83 : null;
            var value$85 = value$82.__typename;
            spend_it_now_heading = {
                __typename: value$85,
                value: value$84
            };
        } else {
            spend_it_now_heading = null;
        }
        var value$86 = value$1.download_button;
        var download_button;
        if (value$86 !== undefined) {
            var value$87 = value$86.value;
            var value$88 = value$87 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$87) : null;
            var value$89 = value$86.__typename;
            download_button = {
                __typename: value$89,
                value: value$88
            };
        } else {
            download_button = null;
        }
        var value$90 = value$1.download_option_text_colour;
        var download_option_text_colour;
        if (value$90 !== undefined) {
            var value$91 = value$90.value;
            var value$92 = value$91 !== undefined ? value$91 : null;
            var value$93 = value$90.__typename;
            download_option_text_colour = {
                __typename: value$93,
                value: value$92
            };
        } else {
            download_option_text_colour = null;
        }
        var value$94 = value$1.download_option_text;
        var download_option_text;
        if (value$94 !== undefined) {
            var value$95 = value$94.value;
            var value$96 = value$95 !== undefined ? value$95 : null;
            var value$97 = value$94.__typename;
            download_option_text = {
                __typename: value$97,
                value: value$96
            };
        } else {
            download_option_text = null;
        }
        var value$98 = value$1.redeem_online_button;
        var redeem_online_button;
        if (value$98 !== undefined) {
            var value$99 = value$98.value;
            var value$100 = value$99 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$99) : null;
            var value$101 = value$98.__typename;
            redeem_online_button = {
                __typename: value$101,
                value: value$100
            };
        } else {
            redeem_online_button = null;
        }
        var value$102 = value$1.redeem_online_text_colour;
        var redeem_online_text_colour;
        if (value$102 !== undefined) {
            var value$103 = value$102.value;
            var value$104 = value$103 !== undefined ? value$103 : null;
            var value$105 = value$102.__typename;
            redeem_online_text_colour = {
                __typename: value$105,
                value: value$104
            };
        } else {
            redeem_online_text_colour = null;
        }
        var value$106 = value$1.redeem_online_text;
        var redeem_online_text;
        if (value$106 !== undefined) {
            var value$107 = value$106.value;
            var value$108 = value$107 !== undefined ? value$107 : null;
            var value$109 = value$106.__typename;
            redeem_online_text = {
                __typename: value$109,
                value: value$108
            };
        } else {
            redeem_online_text = null;
        }
        var value$110 = value$1.replay_button_text;
        var replay_button_text;
        if (value$110 !== undefined) {
            var value$111 = value$110.value;
            var value$112 = value$111 !== undefined ? value$111 : null;
            var value$113 = value$110.__typename;
            replay_button_text = {
                __typename: value$113,
                value: value$112
            };
        } else {
            replay_button_text = null;
        }
        var value$114 = value$1.replay_button_icon_asset;
        var replay_button_icon_asset;
        if (value$114 !== undefined) {
            var value$115 = value$114.value;
            var value$116 = value$115 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$115) : null;
            var value$117 = value$114.__typename;
            replay_button_icon_asset = {
                __typename: value$117,
                value: value$116
            };
        } else {
            replay_button_icon_asset = null;
        }
        var value$118 = value$1.business_gift_unwrap_lottie;
        var business_gift_unwrap_lottie;
        if (value$118 !== undefined) {
            var value$119 = value$118.value;
            var value$120 = value$119 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$119) : null;
            var value$121 = value$118.__typename;
            business_gift_unwrap_lottie = {
                __typename: value$121,
                value: value$120
            };
        } else {
            business_gift_unwrap_lottie = null;
        }
        var value$122 = value$1.classic_gift_unwrap_lottie;
        var classic_gift_unwrap_lottie;
        if (value$122 !== undefined) {
            var value$123 = value$122.value;
            var value$124 = value$123 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$123) : null;
            var value$125 = value$122.__typename;
            classic_gift_unwrap_lottie = {
                __typename: value$125,
                value: value$124
            };
        } else {
            classic_gift_unwrap_lottie = null;
        }
        var value$126 = value$1.gift_unwrap_lottie_segments;
        var gift_unwrap_lottie_segments;
        if (value$126 !== undefined) {
            var value$127 = value$126.value;
            var value$128 = value$127 !== undefined ? value$127 : null;
            var value$129 = value$126.__typename;
            gift_unwrap_lottie_segments = {
                __typename: value$129,
                value: value$128
            };
        } else {
            gift_unwrap_lottie_segments = null;
        }
        var value$130 = value$1.gift_unwrap_cta_text;
        var gift_unwrap_cta_text;
        if (value$130 !== undefined) {
            var value$131 = value$130.value;
            var value$132 = value$131 !== undefined ? value$131 : null;
            var value$133 = value$130.__typename;
            gift_unwrap_cta_text = {
                __typename: value$133,
                value: value$132
            };
        } else {
            gift_unwrap_cta_text = null;
        }
        var value$134 = value$1.optional_gift_card_cta;
        var optional_gift_card_cta;
        if (value$134 !== undefined) {
            var value$135 = value$134.value;
            var value$136 = value$135 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$135) : null;
            var value$137 = value$134.__typename;
            optional_gift_card_cta = {
                __typename: value$137,
                value: value$136
            };
        } else {
            optional_gift_card_cta = null;
        }
        var value$138 = value$1.swap_egift_card_cta_title;
        var swap_egift_card_cta_title;
        if (value$138 !== undefined) {
            var value$139 = value$138.value;
            var value$140 = value$139 !== undefined ? value$139 : null;
            var value$141 = value$138.__typename;
            swap_egift_card_cta_title = {
                __typename: value$141,
                value: value$140
            };
        } else {
            swap_egift_card_cta_title = null;
        }
        var value$142 = value$1.store_in_wallet_cta_title;
        var store_in_wallet_cta_title;
        if (value$142 !== undefined) {
            var value$143 = value$142.value;
            var value$144 = value$143 !== undefined ? value$143 : null;
            var value$145 = value$142.__typename;
            store_in_wallet_cta_title = {
                __typename: value$145,
                value: value$144
            };
        } else {
            store_in_wallet_cta_title = null;
        }
        var value$146 = value$1.check_balance_icon_asset;
        var check_balance_icon_asset;
        if (value$146 !== undefined) {
            var value$147 = value$146.value;
            var value$148 = value$147 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$147) : null;
            var value$149 = value$146.__typename;
            check_balance_icon_asset = {
                __typename: value$149,
                value: value$148
            };
        } else {
            check_balance_icon_asset = null;
        }
        var value$150 = value$1.check_balance_text;
        var check_balance_text;
        if (value$150 !== undefined) {
            var value$151 = value$150.value;
            var value$152 = value$151 !== undefined ? value$151 : null;
            var value$153 = value$150.__typename;
            check_balance_text = {
                __typename: value$153,
                value: value$152
            };
        } else {
            check_balance_text = null;
        }
        var value$154 = value$1.expiry_label;
        var expiry_label;
        if (value$154 !== undefined) {
            var value$155 = value$154.value;
            var value$156 = value$155 !== undefined ? value$155 : null;
            var value$157 = value$154.__typename;
            expiry_label = {
                __typename: value$157,
                value: value$156
            };
        } else {
            expiry_label = null;
        }
        var value$158 = value$1.no_expiry_text;
        var no_expiry_text;
        if (value$158 !== undefined) {
            var value$159 = value$158.value;
            var value$160 = value$159 !== undefined ? value$159 : null;
            var value$161 = value$158.__typename;
            no_expiry_text = {
                __typename: value$161,
                value: value$160
            };
        } else {
            no_expiry_text = null;
        }
        var value$162 = value$1.faqs;
        var faqs;
        if (value$162 !== undefined) {
            var value$163 = value$162.value;
            var value$164 = value$163 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                }
                var value$1 = value.VAL;
                var value$2 = value$1.include_card_merchant_terms;
                var include_card_merchant_terms;
                if (value$2 !== undefined) {
                    var value$3 = value$2.value;
                    var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                        if (value === undefined) {
                            return null;
                        }
                        var value$1 = value.codename;
                        var codename = value$1 !== undefined ? value$1 : null;
                        var value$2 = value.__typename;
                        return {
                            __typename: value$2,
                            codename: codename
                        };
                    }, value$3) : null;
                    var value$5 = value$2.__typename;
                    include_card_merchant_terms = {
                        __typename: value$5,
                        value: value$4
                    };
                } else {
                    include_card_merchant_terms = null;
                }
                var value$6 = value$1.include_pdf_download;
                var include_pdf_download;
                if (value$6 !== undefined) {
                    var value$7 = value$6.value;
                    var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                        if (value === undefined) {
                            return null;
                        }
                        var value$1 = value.codename;
                        var codename = value$1 !== undefined ? value$1 : null;
                        var value$2 = value.__typename;
                        return {
                            __typename: value$2,
                            codename: codename
                        };
                    }, value$7) : null;
                    var value$9 = value$6.__typename;
                    include_pdf_download = {
                        __typename: value$9,
                        value: value$8
                    };
                } else {
                    include_pdf_download = null;
                }
                var value$10 = value$1.include_how_to_use;
                var include_how_to_use;
                if (value$10 !== undefined) {
                    var value$11 = value$10.value;
                    var value$12 = value$11 !== undefined ? js_array/* map */.UI(function(value) {
                        if (value === undefined) {
                            return null;
                        }
                        var value$1 = value.codename;
                        var codename = value$1 !== undefined ? value$1 : null;
                        var value$2 = value.__typename;
                        return {
                            __typename: value$2,
                            codename: codename
                        };
                    }, value$11) : null;
                    var value$13 = value$10.__typename;
                    include_how_to_use = {
                        __typename: value$13,
                        value: value$12
                    };
                } else {
                    include_how_to_use = null;
                }
                var value$14 = value$1.body_text;
                var body_text;
                if (value$14 !== undefined) {
                    var value$15 = value$14.value;
                    var value$16 = value$15 !== undefined ? value$15 : null;
                    var value$17 = value$14.__typename;
                    body_text = {
                        __typename: value$17,
                        value: value$16
                    };
                } else {
                    body_text = null;
                }
                var value$18 = value$1.title;
                var title;
                if (value$18 !== undefined) {
                    var value$19 = value$18.value;
                    var value$20 = value$19 !== undefined ? value$19 : null;
                    var value$21 = value$18.__typename;
                    title = {
                        __typename: value$21,
                        value: value$20
                    };
                } else {
                    title = null;
                }
                var value$22 = value$1.system;
                var value$23 = value$22.id;
                var value$24 = value$22.codename;
                var value$25 = value$22.__typename;
                var system = {
                    __typename: value$25,
                    codename: value$24,
                    id: value$23
                };
                return {
                    __typename: "GiftLandingPageFaqItemContentType",
                    system: system,
                    title: title,
                    body_text: body_text,
                    include_how_to_use: include_how_to_use,
                    include_pdf_download: include_pdf_download,
                    include_card_merchant_terms: include_card_merchant_terms
                };
            }, value$163) : null;
            var value$165 = value$162.__typename;
            faqs = {
                __typename: value$165,
                value: value$164
            };
        } else {
            faqs = null;
        }
        var value$166 = value$1.confetti_lottie;
        var confetti_lottie;
        if (value$166 !== undefined) {
            var value$167 = value$166.value;
            var value$168 = value$167 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$167) : null;
            var value$169 = value$166.__typename;
            confetti_lottie = {
                __typename: value$169,
                value: value$168
            };
        } else {
            confetti_lottie = null;
        }
        var value$170 = value$1.gift_reveal_cta_text;
        var gift_reveal_cta_text;
        if (value$170 !== undefined) {
            var value$171 = value$170.value;
            var value$172 = value$171 !== undefined ? value$171 : null;
            var value$173 = value$170.__typename;
            gift_reveal_cta_text = {
                __typename: value$173,
                value: value$172
            };
        } else {
            gift_reveal_cta_text = null;
        }
        var value$174 = value$1.sender_message;
        var sender_message;
        if (value$174 !== undefined) {
            var value$175 = value$174.value;
            var value$176 = value$175 !== undefined ? value$175 : null;
            var value$177 = value$174.__typename;
            sender_message = {
                __typename: value$177,
                value: value$176
            };
        } else {
            sender_message = null;
        }
        var value$178 = value$1.business_logo_asset;
        var business_logo_asset;
        if (value$178 !== undefined) {
            var value$179 = value$178.value;
            var value$180 = value$179 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$179) : null;
            var value$181 = value$178.__typename;
            business_logo_asset = {
                __typename: value$181,
                value: value$180
            };
        } else {
            business_logo_asset = null;
        }
        var value$182 = value$1.classic_logo_asset;
        var classic_logo_asset;
        if (value$182 !== undefined) {
            var value$183 = value$182.value;
            var value$184 = value$183 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.height;
                var height = value$1 !== undefined ? value$1 : null;
                var value$2 = value.width;
                var width = value$2 !== undefined ? value$2 : null;
                var value$3 = value.url;
                var url = value$3 !== undefined ? value$3 : null;
                var value$4 = value.description;
                var description = value$4 !== undefined ? value$4 : null;
                var value$5 = value.name;
                var name = value$5 !== undefined ? value$5 : null;
                var value$6 = value.__typename;
                return {
                    __typename: value$6,
                    name: name,
                    description: description,
                    url: url,
                    width: width,
                    height: height
                };
            }, value$183) : null;
            var value$185 = value$182.__typename;
            classic_logo_asset = {
                __typename: value$185,
                value: value$184
            };
        } else {
            classic_logo_asset = null;
        }
        var value$186 = value$1.system;
        var value$187 = value$186.id;
        var value$188 = value$186.codename;
        var value$189 = value$186.__typename;
        var system = {
            __typename: value$189,
            codename: value$188,
            id: value$187
        };
        return {
            __typename: "GiftLandingPageContentType",
            system: system,
            classic_logo_asset: classic_logo_asset,
            business_logo_asset: business_logo_asset,
            sender_message: sender_message,
            gift_reveal_cta_text: gift_reveal_cta_text,
            confetti_lottie: confetti_lottie,
            faqs: faqs,
            no_expiry_text: no_expiry_text,
            expiry_label: expiry_label,
            check_balance_text: check_balance_text,
            check_balance_icon_asset: check_balance_icon_asset,
            store_in_wallet_cta_title: store_in_wallet_cta_title,
            swap_egift_card_cta_title: swap_egift_card_cta_title,
            optional_gift_card_cta: optional_gift_card_cta,
            gift_unwrap_cta_text: gift_unwrap_cta_text,
            gift_unwrap_lottie_segments: gift_unwrap_lottie_segments,
            classic_gift_unwrap_lottie: classic_gift_unwrap_lottie,
            business_gift_unwrap_lottie: business_gift_unwrap_lottie,
            replay_button_icon_asset: replay_button_icon_asset,
            replay_button_text: replay_button_text,
            redeem_online_text: redeem_online_text,
            redeem_online_text_colour: redeem_online_text_colour,
            redeem_online_button: redeem_online_button,
            download_option_text: download_option_text,
            download_option_text_colour: download_option_text_colour,
            download_button: download_button,
            spend_it_now_heading: spend_it_now_heading,
            clipboard_item_copy_text: clipboard_item_copy_text,
            clipboard_item_copied_text: clipboard_item_copied_text,
            barcode_number_clipboard_heading: barcode_number_clipboard_heading,
            in_store_number_clipboard_heading: in_store_number_clipboard_heading,
            online_number_clipboard_heading: online_number_clipboard_heading,
            online_and_in_store_clipboard_heading: online_and_in_store_clipboard_heading,
            swap_cards_title: swap_cards_title,
            swap_card_alt: swap_card_alt,
            swap_card_original_value_label: swap_card_original_value_label,
            swap_card_button_style: swap_card_button_style,
            save_in_apple_google_wallet_text: save_in_apple_google_wallet_text,
            save_in_apple_google_wallet_text_colour: save_in_apple_google_wallet_text_colour,
            google_wallet_image_asset: google_wallet_image_asset,
            apple_wallet_image_asset: apple_wallet_image_asset,
            footer_copyright_text: footer_copyright_text,
            footer_download_text: footer_download_text,
            app_store_icons: app_store_icons,
            create_account_modal_title: create_account_modal_title,
            create_account_modal_list: create_account_modal_list,
            create_account_modal_cta_text: create_account_modal_cta_text
        };
    }, value$1) : null;
    var value$2 = value.locations;
    var locations = value$2 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME === "UnspecifiedFragment") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.region_location;
        var region_location;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                }
                var value$1 = value.VAL;
                var value$2 = value$1.url;
                var url;
                if (value$2 !== undefined) {
                    var value$3 = value$2.value;
                    var value$4 = value$3 !== undefined ? value$3 : null;
                    var value$5 = value$2.__typename;
                    url = {
                        __typename: value$5,
                        value: value$4
                    };
                } else {
                    url = null;
                }
                var value$6 = value$1.country_flag;
                var country_flag;
                if (value$6 !== undefined) {
                    var value$7 = value$6.value;
                    var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                        if (value === undefined) {
                            return null;
                        }
                        var value$1 = value.url;
                        var url = value$1 !== undefined ? value$1 : null;
                        var value$2 = value.name;
                        var name = value$2 !== undefined ? value$2 : null;
                        var value$3 = value.__typename;
                        return {
                            __typename: value$3,
                            name: name,
                            url: url
                        };
                    }, value$7) : null;
                    var value$9 = value$6.__typename;
                    country_flag = {
                        __typename: value$9,
                        value: value$8
                    };
                } else {
                    country_flag = null;
                }
                var value$10 = value$1.country_name;
                var country_name;
                if (value$10 !== undefined) {
                    var value$11 = value$10.value;
                    var value$12 = value$11 !== undefined ? value$11 : null;
                    var value$13 = value$10.__typename;
                    country_name = {
                        __typename: value$13,
                        value: value$12
                    };
                } else {
                    country_name = null;
                }
                var value$14 = value$1.currency;
                var currency;
                if (value$14 !== undefined) {
                    var value$15 = value$14.value;
                    var value$16 = value$15 !== undefined ? value$15 : null;
                    var value$17 = value$14.__typename;
                    currency = {
                        __typename: value$17,
                        value: value$16
                    };
                } else {
                    currency = null;
                }
                var value$18 = value$1.system;
                var value$19 = value$18.codename;
                var value$20 = value$18.id;
                var value$21 = value$18.__typename;
                var system = {
                    __typename: value$21,
                    id: value$20,
                    codename: value$19
                };
                return {
                    __typename: "RegionLocationContentType",
                    system: system,
                    currency: currency,
                    country_name: country_name,
                    country_flag: country_flag,
                    url: url
                };
            }, value$3) : null;
            var value$5 = value$2.__typename;
            region_location = {
                __typename: value$5,
                value: value$4
            };
        } else {
            region_location = null;
        }
        var value$6 = value$1.cta_text;
        var cta_text;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? value$7 : null;
            var value$9 = value$6.__typename;
            cta_text = {
                __typename: value$9,
                value: value$8
            };
        } else {
            cta_text = null;
        }
        var value$10 = value$1.subtitle;
        var subtitle;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? value$11 : null;
            var value$13 = value$10.__typename;
            subtitle = {
                __typename: value$13,
                value: value$12
            };
        } else {
            subtitle = null;
        }
        var value$14 = value$1.title;
        var title;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? value$15 : null;
            var value$17 = value$14.__typename;
            title = {
                __typename: value$17,
                value: value$16
            };
        } else {
            title = null;
        }
        var value$18 = value$1.system;
        var value$19 = value$18.codename;
        var value$20 = value$18.id;
        var value$21 = value$18.__typename;
        var system = {
            __typename: value$21,
            id: value$20,
            codename: value$19
        };
        return {
            __typename: "ModalChangeLocationContentType",
            system: system,
            title: title,
            subtitle: subtitle,
            cta_text: cta_text,
            region_location: region_location
        };
    }, value$2) : null;
    var value$3 = value.dictionaryItems;
    var dictionaryItems = value$3 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME !== "DictionaryItemContentType") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.value;
        var value$3;
        if (value$2 !== undefined) {
            var value$4 = value$2.value;
            var value$5 = value$4 !== undefined ? value$4 : null;
            var value$6 = value$2.__typename;
            value$3 = {
                __typename: value$6,
                value: value$5
            };
        } else {
            value$3 = null;
        }
        var value$7 = value$1.system;
        var value$8 = value$7.codename;
        var value$9 = value$7.id;
        var value$10 = value$7.__typename;
        var system = {
            __typename: value$10,
            id: value$9,
            codename: value$8
        };
        return {
            __typename: "DictionaryItemContentType",
            system: system,
            value: value$3
        };
    }, value$3) : null;
    var value$4 = value.globalConfiguration;
    var globalConfiguration = value$4 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME !== "GlobalConfigurationContentType") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.sold_out_badge_text;
        var sold_out_badge_text;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? value$3 : null;
            var value$5 = value$2.__typename;
            sold_out_badge_text = {
                __typename: value$5,
                value: value$4
            };
        } else {
            sold_out_badge_text = null;
        }
        var value$6 = value$1.no_search_result;
        var no_search_result;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            NoSearchResults.serialize(value.VAL.noSearchResults)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$7) : null;
            var value$9 = value$6.__typename;
            no_search_result = {
                __typename: value$9,
                value: value$8
            };
        } else {
            no_search_result = null;
        }
        var value$10 = value$1.search_bar_placeholder_text;
        var search_bar_placeholder_text;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? value$11 : null;
            var value$13 = value$10.__typename;
            search_bar_placeholder_text = {
                __typename: value$13,
                value: value$12
            };
        } else {
            search_bar_placeholder_text = null;
        }
        var value$14 = value$1.not_logged_in_navbar_menu_items___business;
        var not_logged_in_navbar_menu_items___business;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CallToAction.serialize(value.VAL.callToAction)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$15) : null;
            var value$17 = value$14.__typename;
            not_logged_in_navbar_menu_items___business = {
                __typename: value$17,
                value: value$16
            };
        } else {
            not_logged_in_navbar_menu_items___business = null;
        }
        var value$18 = value$1.not_logged_in_navbar_menu_items___consumer;
        var not_logged_in_navbar_menu_items___consumer;
        if (value$18 !== undefined) {
            var value$19 = value$18.value;
            var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var variant = value.NAME;
                if (variant === "UnspecifiedFragment") {
                    return {};
                } else if (variant === "CallToActionLinkD6a3d61ContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        CallToAction.serialize(value.VAL.callToAction)
                    ]);
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        NavbarSelectCTA.serialize(value.VAL.navbarSelectCTA)
                    ]);
                }
            }, value$19) : null;
            var value$21 = value$18.__typename;
            not_logged_in_navbar_menu_items___consumer = {
                __typename: value$21,
                value: value$20
            };
        } else {
            not_logged_in_navbar_menu_items___consumer = null;
        }
        var value$22 = value$1.header_logo;
        var header_logo;
        if (value$22 !== undefined) {
            var value$23 = value$22.value;
            var value$24 = value$23 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "HeaderLogoContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            HeaderLogo.serialize(value.VAL.headerLogo)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$23) : null;
            var value$25 = value$22.__typename;
            header_logo = {
                __typename: value$25,
                value: value$24
            };
        } else {
            header_logo = null;
        }
        var value$26 = value$1.warnings;
        var warnings;
        if (value$26 !== undefined) {
            var value$27 = value$26.value;
            var value$28 = value$27 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                }
                var value$1 = value.VAL;
                var value$2 = value$1.description;
                var description;
                if (value$2 !== undefined) {
                    var value$3 = value$2.value;
                    var value$4 = value$3 !== undefined ? value$3 : null;
                    var value$5 = value$2.__typename;
                    description = {
                        __typename: value$5,
                        value: value$4
                    };
                } else {
                    description = null;
                }
                var value$6 = value$1.heading;
                var heading;
                if (value$6 !== undefined) {
                    var value$7 = value$6.value;
                    var value$8 = value$7 !== undefined ? value$7 : null;
                    var value$9 = value$6.__typename;
                    heading = {
                        __typename: value$9,
                        value: value$8
                    };
                } else {
                    heading = null;
                }
                var value$10 = value$1.id;
                var id;
                if (value$10 !== undefined) {
                    var value$11 = value$10.value;
                    var value$12 = value$11 !== undefined ? value$11 : null;
                    var value$13 = value$10.__typename;
                    id = {
                        __typename: value$13,
                        value: value$12
                    };
                } else {
                    id = null;
                }
                return {
                    __typename: "WarningContentType",
                    id: id,
                    heading: heading,
                    description: description
                };
            }, value$27) : null;
            var value$29 = value$26.__typename;
            warnings = {
                __typename: value$29,
                value: value$28
            };
        } else {
            warnings = null;
        }
        var value$30 = value$1.register;
        var register;
        if (value$30 !== undefined) {
            var value$31 = value$30.value;
            var value$32 = value$31 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                }
                var value$1 = value.VAL;
                var value$2 = value$1.already_registered_text;
                var already_registered_text;
                if (value$2 !== undefined) {
                    var value$3 = value$2.value;
                    var value$4 = value$3 !== undefined ? value$3 : null;
                    var value$5 = value$2.__typename;
                    already_registered_text = {
                        __typename: value$5,
                        value: value$4
                    };
                } else {
                    already_registered_text = null;
                }
                var value$6 = value$1.sign_up_cta_text;
                var sign_up_cta_text;
                if (value$6 !== undefined) {
                    var value$7 = value$6.value;
                    var value$8 = value$7 !== undefined ? value$7 : null;
                    var value$9 = value$6.__typename;
                    sign_up_cta_text = {
                        __typename: value$9,
                        value: value$8
                    };
                } else {
                    sign_up_cta_text = null;
                }
                var value$10 = value$1.resending_code_text;
                var resending_code_text;
                if (value$10 !== undefined) {
                    var value$11 = value$10.value;
                    var value$12 = value$11 !== undefined ? value$11 : null;
                    var value$13 = value$10.__typename;
                    resending_code_text = {
                        __typename: value$13,
                        value: value$12
                    };
                } else {
                    resending_code_text = null;
                }
                var value$14 = value$1.resend_code_text;
                var resend_code_text;
                if (value$14 !== undefined) {
                    var value$15 = value$14.value;
                    var value$16 = value$15 !== undefined ? value$15 : null;
                    var value$17 = value$14.__typename;
                    resend_code_text = {
                        __typename: value$17,
                        value: value$16
                    };
                } else {
                    resend_code_text = null;
                }
                var value$18 = value$1.step_title___security_code;
                var step_title___security_code;
                if (value$18 !== undefined) {
                    var value$19 = value$18.value;
                    var value$20 = value$19 !== undefined ? value$19 : null;
                    var value$21 = value$18.__typename;
                    step_title___security_code = {
                        __typename: value$21,
                        value: value$20
                    };
                } else {
                    step_title___security_code = null;
                }
                var value$22 = value$1.send_security_code_cta_text;
                var send_security_code_cta_text;
                if (value$22 !== undefined) {
                    var value$23 = value$22.value;
                    var value$24 = value$23 !== undefined ? value$23 : null;
                    var value$25 = value$22.__typename;
                    send_security_code_cta_text = {
                        __typename: value$25,
                        value: value$24
                    };
                } else {
                    send_security_code_cta_text = null;
                }
                var value$26 = value$1.nz_not_prezzy_disclaimer;
                var nz_not_prezzy_disclaimer;
                if (value$26 !== undefined) {
                    var value$27 = value$26.value;
                    var value$28 = value$27 !== undefined ? value$27 : null;
                    var value$29 = value$26.__typename;
                    nz_not_prezzy_disclaimer = {
                        __typename: value$29,
                        value: value$28
                    };
                } else {
                    nz_not_prezzy_disclaimer = null;
                }
                var value$30 = value$1.t_cs_checkbox_label;
                var t_cs_checkbox_label;
                if (value$30 !== undefined) {
                    var value$31 = value$30.value;
                    var value$32 = value$31 !== undefined ? value$31 : null;
                    var value$33 = value$30.__typename;
                    t_cs_checkbox_label = {
                        __typename: value$33,
                        value: value$32
                    };
                } else {
                    t_cs_checkbox_label = null;
                }
                var value$34 = value$1.newsletter_checkbox_label;
                var newsletter_checkbox_label;
                if (value$34 !== undefined) {
                    var value$35 = value$34.value;
                    var value$36 = value$35 !== undefined ? value$35 : null;
                    var value$37 = value$34.__typename;
                    newsletter_checkbox_label = {
                        __typename: value$37,
                        value: value$36
                    };
                } else {
                    newsletter_checkbox_label = null;
                }
                var value$38 = value$1.invalid_phone_number_text;
                var invalid_phone_number_text;
                if (value$38 !== undefined) {
                    var value$39 = value$38.value;
                    var value$40 = value$39 !== undefined ? value$39 : null;
                    var value$41 = value$38.__typename;
                    invalid_phone_number_text = {
                        __typename: value$41,
                        value: value$40
                    };
                } else {
                    invalid_phone_number_text = null;
                }
                var value$42 = value$1.phone_number_required_text;
                var phone_number_required_text;
                if (value$42 !== undefined) {
                    var value$43 = value$42.value;
                    var value$44 = value$43 !== undefined ? value$43 : null;
                    var value$45 = value$42.__typename;
                    phone_number_required_text = {
                        __typename: value$45,
                        value: value$44
                    };
                } else {
                    phone_number_required_text = null;
                }
                var value$46 = value$1.step_title___phone_number;
                var step_title___phone_number;
                if (value$46 !== undefined) {
                    var value$47 = value$46.value;
                    var value$48 = value$47 !== undefined ? value$47 : null;
                    var value$49 = value$46.__typename;
                    step_title___phone_number = {
                        __typename: value$49,
                        value: value$48
                    };
                } else {
                    step_title___phone_number = null;
                }
                var value$50 = value$1.invalid_password_text;
                var invalid_password_text;
                if (value$50 !== undefined) {
                    var value$51 = value$50.value;
                    var value$52 = value$51 !== undefined ? value$51 : null;
                    var value$53 = value$50.__typename;
                    invalid_password_text = {
                        __typename: value$53,
                        value: value$52
                    };
                } else {
                    invalid_password_text = null;
                }
                var value$54 = value$1.password_required_text;
                var password_required_text;
                if (value$54 !== undefined) {
                    var value$55 = value$54.value;
                    var value$56 = value$55 !== undefined ? value$55 : null;
                    var value$57 = value$54.__typename;
                    password_required_text = {
                        __typename: value$57,
                        value: value$56
                    };
                } else {
                    password_required_text = null;
                }
                var value$58 = value$1.password_label;
                var password_label;
                if (value$58 !== undefined) {
                    var value$59 = value$58.value;
                    var value$60 = value$59 !== undefined ? value$59 : null;
                    var value$61 = value$58.__typename;
                    password_label = {
                        __typename: value$61,
                        value: value$60
                    };
                } else {
                    password_label = null;
                }
                var value$62 = value$1.password_requirements;
                var password_requirements;
                if (value$62 !== undefined) {
                    var value$63 = value$62.value;
                    var value$64 = value$63 !== undefined ? value$63 : null;
                    var value$65 = value$62.__typename;
                    password_requirements = {
                        __typename: value$65,
                        value: value$64
                    };
                } else {
                    password_requirements = null;
                }
                var value$66 = value$1.step_title___password;
                var step_title___password;
                if (value$66 !== undefined) {
                    var value$67 = value$66.value;
                    var value$68 = value$67 !== undefined ? value$67 : null;
                    var value$69 = value$66.__typename;
                    step_title___password = {
                        __typename: value$69,
                        value: value$68
                    };
                } else {
                    step_title___password = null;
                }
                var value$70 = value$1.invalid_email_text;
                var invalid_email_text;
                if (value$70 !== undefined) {
                    var value$71 = value$70.value;
                    var value$72 = value$71 !== undefined ? value$71 : null;
                    var value$73 = value$70.__typename;
                    invalid_email_text = {
                        __typename: value$73,
                        value: value$72
                    };
                } else {
                    invalid_email_text = null;
                }
                var value$74 = value$1.email_required_text;
                var email_required_text;
                if (value$74 !== undefined) {
                    var value$75 = value$74.value;
                    var value$76 = value$75 !== undefined ? value$75 : null;
                    var value$77 = value$74.__typename;
                    email_required_text = {
                        __typename: value$77,
                        value: value$76
                    };
                } else {
                    email_required_text = null;
                }
                var value$78 = value$1.email_label;
                var email_label;
                if (value$78 !== undefined) {
                    var value$79 = value$78.value;
                    var value$80 = value$79 !== undefined ? value$79 : null;
                    var value$81 = value$78.__typename;
                    email_label = {
                        __typename: value$81,
                        value: value$80
                    };
                } else {
                    email_label = null;
                }
                var value$82 = value$1.step_title___email;
                var step_title___email;
                if (value$82 !== undefined) {
                    var value$83 = value$82.value;
                    var value$84 = value$83 !== undefined ? value$83 : null;
                    var value$85 = value$82.__typename;
                    step_title___email = {
                        __typename: value$85,
                        value: value$84
                    };
                } else {
                    step_title___email = null;
                }
                var value$86 = value$1.invalid_last_name_text;
                var invalid_last_name_text;
                if (value$86 !== undefined) {
                    var value$87 = value$86.value;
                    var value$88 = value$87 !== undefined ? value$87 : null;
                    var value$89 = value$86.__typename;
                    invalid_last_name_text = {
                        __typename: value$89,
                        value: value$88
                    };
                } else {
                    invalid_last_name_text = null;
                }
                var value$90 = value$1.last_name_required_text;
                var last_name_required_text;
                if (value$90 !== undefined) {
                    var value$91 = value$90.value;
                    var value$92 = value$91 !== undefined ? value$91 : null;
                    var value$93 = value$90.__typename;
                    last_name_required_text = {
                        __typename: value$93,
                        value: value$92
                    };
                } else {
                    last_name_required_text = null;
                }
                var value$94 = value$1.last_name_label;
                var last_name_label;
                if (value$94 !== undefined) {
                    var value$95 = value$94.value;
                    var value$96 = value$95 !== undefined ? value$95 : null;
                    var value$97 = value$94.__typename;
                    last_name_label = {
                        __typename: value$97,
                        value: value$96
                    };
                } else {
                    last_name_label = null;
                }
                var value$98 = value$1.invalid_first_name_text;
                var invalid_first_name_text;
                if (value$98 !== undefined) {
                    var value$99 = value$98.value;
                    var value$100 = value$99 !== undefined ? value$99 : null;
                    var value$101 = value$98.__typename;
                    invalid_first_name_text = {
                        __typename: value$101,
                        value: value$100
                    };
                } else {
                    invalid_first_name_text = null;
                }
                var value$102 = value$1.first_name_required_text;
                var first_name_required_text;
                if (value$102 !== undefined) {
                    var value$103 = value$102.value;
                    var value$104 = value$103 !== undefined ? value$103 : null;
                    var value$105 = value$102.__typename;
                    first_name_required_text = {
                        __typename: value$105,
                        value: value$104
                    };
                } else {
                    first_name_required_text = null;
                }
                var value$106 = value$1.first_name_label;
                var first_name_label;
                if (value$106 !== undefined) {
                    var value$107 = value$106.value;
                    var value$108 = value$107 !== undefined ? value$107 : null;
                    var value$109 = value$106.__typename;
                    first_name_label = {
                        __typename: value$109,
                        value: value$108
                    };
                } else {
                    first_name_label = null;
                }
                var value$110 = value$1.step_title___name;
                var step_title___name;
                if (value$110 !== undefined) {
                    var value$111 = value$110.value;
                    var value$112 = value$111 !== undefined ? value$111 : null;
                    var value$113 = value$110.__typename;
                    step_title___name = {
                        __typename: value$113,
                        value: value$112
                    };
                } else {
                    step_title___name = null;
                }
                var value$114 = value$1.back_button_text;
                var back_button_text;
                if (value$114 !== undefined) {
                    var value$115 = value$114.value;
                    var value$116 = value$115 !== undefined ? value$115 : null;
                    var value$117 = value$114.__typename;
                    back_button_text = {
                        __typename: value$117,
                        value: value$116
                    };
                } else {
                    back_button_text = null;
                }
                var value$118 = value$1.next_button_text;
                var next_button_text;
                if (value$118 !== undefined) {
                    var value$119 = value$118.value;
                    var value$120 = value$119 !== undefined ? value$119 : null;
                    var value$121 = value$118.__typename;
                    next_button_text = {
                        __typename: value$121,
                        value: value$120
                    };
                } else {
                    next_button_text = null;
                }
                var value$122 = value$1.register_subtitle;
                var register_subtitle;
                if (value$122 !== undefined) {
                    var value$123 = value$122.value;
                    var value$124 = value$123 !== undefined ? value$123 : null;
                    var value$125 = value$122.__typename;
                    register_subtitle = {
                        __typename: value$125,
                        value: value$124
                    };
                } else {
                    register_subtitle = null;
                }
                var value$126 = value$1.register_title;
                var register_title;
                if (value$126 !== undefined) {
                    var value$127 = value$126.value;
                    var value$128 = value$127 !== undefined ? value$127 : null;
                    var value$129 = value$126.__typename;
                    register_title = {
                        __typename: value$129,
                        value: value$128
                    };
                } else {
                    register_title = null;
                }
                var value$130 = value$1.system;
                var value$131 = value$130.id;
                var value$132 = value$130.codename;
                var value$133 = value$130.__typename;
                var system = {
                    __typename: value$133,
                    codename: value$132,
                    id: value$131
                };
                return {
                    __typename: "RegisterContentType",
                    system: system,
                    register_title: register_title,
                    register_subtitle: register_subtitle,
                    next_button_text: next_button_text,
                    back_button_text: back_button_text,
                    step_title___name: step_title___name,
                    first_name_label: first_name_label,
                    first_name_required_text: first_name_required_text,
                    invalid_first_name_text: invalid_first_name_text,
                    last_name_label: last_name_label,
                    last_name_required_text: last_name_required_text,
                    invalid_last_name_text: invalid_last_name_text,
                    step_title___email: step_title___email,
                    email_label: email_label,
                    email_required_text: email_required_text,
                    invalid_email_text: invalid_email_text,
                    step_title___password: step_title___password,
                    password_requirements: password_requirements,
                    password_label: password_label,
                    password_required_text: password_required_text,
                    invalid_password_text: invalid_password_text,
                    step_title___phone_number: step_title___phone_number,
                    phone_number_required_text: phone_number_required_text,
                    invalid_phone_number_text: invalid_phone_number_text,
                    newsletter_checkbox_label: newsletter_checkbox_label,
                    t_cs_checkbox_label: t_cs_checkbox_label,
                    nz_not_prezzy_disclaimer: nz_not_prezzy_disclaimer,
                    send_security_code_cta_text: send_security_code_cta_text,
                    step_title___security_code: step_title___security_code,
                    resend_code_text: resend_code_text,
                    resending_code_text: resending_code_text,
                    sign_up_cta_text: sign_up_cta_text,
                    already_registered_text: already_registered_text
                };
            }, value$31) : null;
            var value$33 = value$30.__typename;
            register = {
                __typename: value$33,
                value: value$32
            };
        } else {
            register = null;
        }
        var value$34 = value$1.login;
        var login;
        if (value$34 !== undefined) {
            var value$35 = value$34.value;
            var value$36 = value$35 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                if (value.NAME === "UnspecifiedFragment") {
                    return {};
                }
                var value$1 = value.VAL;
                var value$2 = value$1.forgot_email_text;
                var forgot_email_text;
                if (value$2 !== undefined) {
                    var value$3 = value$2.value;
                    var value$4 = value$3 !== undefined ? value$3 : null;
                    var value$5 = value$2.__typename;
                    forgot_email_text = {
                        __typename: value$5,
                        value: value$4
                    };
                } else {
                    forgot_email_text = null;
                }
                var value$6 = value$1.forgot_password_text;
                var forgot_password_text;
                if (value$6 !== undefined) {
                    var value$7 = value$6.value;
                    var value$8 = value$7 !== undefined ? value$7 : null;
                    var value$9 = value$6.__typename;
                    forgot_password_text = {
                        __typename: value$9,
                        value: value$8
                    };
                } else {
                    forgot_password_text = null;
                }
                var value$10 = value$1.submit_cta_submitting_text;
                var submit_cta_submitting_text;
                if (value$10 !== undefined) {
                    var value$11 = value$10.value;
                    var value$12 = value$11 !== undefined ? value$11 : null;
                    var value$13 = value$10.__typename;
                    submit_cta_submitting_text = {
                        __typename: value$13,
                        value: value$12
                    };
                } else {
                    submit_cta_submitting_text = null;
                }
                var value$14 = value$1.submit_cta_text;
                var submit_cta_text;
                if (value$14 !== undefined) {
                    var value$15 = value$14.value;
                    var value$16 = value$15 !== undefined ? value$15 : null;
                    var value$17 = value$14.__typename;
                    submit_cta_text = {
                        __typename: value$17,
                        value: value$16
                    };
                } else {
                    submit_cta_text = null;
                }
                var value$18 = value$1.invalid_email_text;
                var invalid_email_text;
                if (value$18 !== undefined) {
                    var value$19 = value$18.value;
                    var value$20 = value$19 !== undefined ? value$19 : null;
                    var value$21 = value$18.__typename;
                    invalid_email_text = {
                        __typename: value$21,
                        value: value$20
                    };
                } else {
                    invalid_email_text = null;
                }
                var value$22 = value$1.required_password_text;
                var required_password_text;
                if (value$22 !== undefined) {
                    var value$23 = value$22.value;
                    var value$24 = value$23 !== undefined ? value$23 : null;
                    var value$25 = value$22.__typename;
                    required_password_text = {
                        __typename: value$25,
                        value: value$24
                    };
                } else {
                    required_password_text = null;
                }
                var value$26 = value$1.required_email_text;
                var required_email_text;
                if (value$26 !== undefined) {
                    var value$27 = value$26.value;
                    var value$28 = value$27 !== undefined ? value$27 : null;
                    var value$29 = value$26.__typename;
                    required_email_text = {
                        __typename: value$29,
                        value: value$28
                    };
                } else {
                    required_email_text = null;
                }
                var value$30 = value$1.password_label;
                var password_label;
                if (value$30 !== undefined) {
                    var value$31 = value$30.value;
                    var value$32 = value$31 !== undefined ? value$31 : null;
                    var value$33 = value$30.__typename;
                    password_label = {
                        __typename: value$33,
                        value: value$32
                    };
                } else {
                    password_label = null;
                }
                var value$34 = value$1.email_label;
                var email_label;
                if (value$34 !== undefined) {
                    var value$35 = value$34.value;
                    var value$36 = value$35 !== undefined ? value$35 : null;
                    var value$37 = value$34.__typename;
                    email_label = {
                        __typename: value$37,
                        value: value$36
                    };
                } else {
                    email_label = null;
                }
                var value$38 = value$1.subtitle;
                var subtitle;
                if (value$38 !== undefined) {
                    var value$39 = value$38.value;
                    var value$40 = value$39 !== undefined ? value$39 : null;
                    var value$41 = value$38.__typename;
                    subtitle = {
                        __typename: value$41,
                        value: value$40
                    };
                } else {
                    subtitle = null;
                }
                var value$42 = value$1.title;
                var title;
                if (value$42 !== undefined) {
                    var value$43 = value$42.value;
                    var value$44 = value$43 !== undefined ? value$43 : null;
                    var value$45 = value$42.__typename;
                    title = {
                        __typename: value$45,
                        value: value$44
                    };
                } else {
                    title = null;
                }
                var value$46 = value$1.system;
                var value$47 = value$46.id;
                var value$48 = value$46.codename;
                var value$49 = value$46.__typename;
                var system = {
                    __typename: value$49,
                    codename: value$48,
                    id: value$47
                };
                return {
                    __typename: "LoginContentType",
                    system: system,
                    title: title,
                    subtitle: subtitle,
                    email_label: email_label,
                    password_label: password_label,
                    required_email_text: required_email_text,
                    required_password_text: required_password_text,
                    invalid_email_text: invalid_email_text,
                    submit_cta_text: submit_cta_text,
                    submit_cta_submitting_text: submit_cta_submitting_text,
                    forgot_password_text: forgot_password_text,
                    forgot_email_text: forgot_email_text
                };
            }, value$35) : null;
            var value$37 = value$34.__typename;
            login = {
                __typename: value$37,
                value: value$36
            };
        } else {
            login = null;
        }
        var value$38 = value$1.business_footer;
        var business_footer;
        if (value$38 !== undefined) {
            var value$39 = value$38.value;
            var value$40 = value$39 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "FooterContainerContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_Footer_Fragment_bs_FooterBlock.serialize(value.VAL.footerBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$39) : null;
            var value$41 = value$38.__typename;
            business_footer = {
                __typename: value$41,
                value: value$40
            };
        } else {
            business_footer = null;
        }
        var value$42 = value$1.footer;
        var footer;
        if (value$42 !== undefined) {
            var value$43 = value$42.value;
            var value$44 = value$43 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "FooterContainerContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_Footer_Fragment_bs_FooterBlock.serialize(value.VAL.footerBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$43) : null;
            var value$45 = value$42.__typename;
            footer = {
                __typename: value$45,
                value: value$44
            };
        } else {
            footer = null;
        }
        var value$46 = value$1.mobile_navbar_menu_items;
        var mobile_navbar_menu_items;
        if (value$46 !== undefined) {
            var value$47 = value$46.value;
            var value$48 = value$47 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_NavMenuItems_Fragment_bs_NavMenuBlock.serialize(value.VAL.navMenuBlock)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$47) : null;
            var value$49 = value$46.__typename;
            mobile_navbar_menu_items = {
                __typename: value$49,
                value: value$48
            };
        } else {
            mobile_navbar_menu_items = null;
        }
        var value$50 = value$1.desktop_navbar_menu_items;
        var desktop_navbar_menu_items;
        if (value$50 !== undefined) {
            var value$51 = value$50.value;
            var value$52 = value$51 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            Gql_NavMenuItems_Fragment_bs_NavMenuBlock.serialize(value.VAL.navMenuBlock)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$51) : null;
            var value$53 = value$50.__typename;
            desktop_navbar_menu_items = {
                __typename: value$53,
                value: value$52
            };
        } else {
            desktop_navbar_menu_items = null;
        }
        var value$54 = value$1.business_navigation;
        var business_navigation;
        if (value$54 !== undefined) {
            var value$55 = value$54.value;
            var value$56 = value$55 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var variant = value.NAME;
                if (variant === "PageContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        Gql_Header_Fragment_bs_HeaderBlock.serialize(value.VAL.headerBlock)
                    ]);
                } else if (variant === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        HeaderNavigation.serialize(value.VAL.headerNavigation)
                    ]);
                }
            }, value$55) : null;
            var value$57 = value$54.__typename;
            business_navigation = {
                __typename: value$57,
                value: value$56
            };
        } else {
            business_navigation = null;
        }
        var value$58 = value$1.navigation_root;
        var navigation_root;
        if (value$58 !== undefined) {
            var value$59 = value$58.value;
            var value$60 = value$59 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var variant = value.NAME;
                if (variant === "PageContentType") {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        Gql_Header_Fragment_bs_HeaderBlock.serialize(value.VAL.headerBlock)
                    ]);
                } else if (variant === "UnspecifiedFragment") {
                    return {};
                } else {
                    return js_array/* reduce */.u4(deepMerge, function(prim) {
                        return {};
                    }, [
                        HeaderNavigation.serialize(value.VAL.headerNavigation)
                    ]);
                }
            }, value$59) : null;
            var value$61 = value$58.__typename;
            navigation_root = {
                __typename: value$61,
                value: value$60
            };
        } else {
            navigation_root = null;
        }
        var value$62 = value$1.alert_banner;
        var alert_banner;
        if (value$62 !== undefined) {
            var value$63 = value$62.value;
            var value$64 = value$63 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "UnspecifiedFragment") {
                        return {};
                    } else {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            AlertBannerBlock.serialize(value.VAL.alertBannerBlock)
                        ]);
                    }
                } else {
                    return null;
                }
            }, value$63) : null;
            var value$65 = value$62.__typename;
            alert_banner = {
                __typename: value$65,
                value: value$64
            };
        } else {
            alert_banner = null;
        }
        var value$66 = value$1.gdpr_cookie_popup;
        var gdpr_cookie_popup;
        if (value$66 !== undefined) {
            var value$67 = value$66.value;
            var value$68 = value$67 !== undefined ? js_array/* map */.UI(function(value) {
                if (value !== undefined) {
                    if (value.NAME === "GdprCookiePopupContentType") {
                        return js_array/* reduce */.u4(deepMerge, function(prim) {
                            return {};
                        }, [
                            CookiePopupBlock.serialize(value.VAL.cookiePopupBlock)
                        ]);
                    } else {
                        return {};
                    }
                } else {
                    return null;
                }
            }, value$67) : null;
            var value$69 = value$66.__typename;
            gdpr_cookie_popup = {
                __typename: value$69,
                value: value$68
            };
        } else {
            gdpr_cookie_popup = null;
        }
        return {
            __typename: "GlobalConfigurationContentType",
            gdpr_cookie_popup: gdpr_cookie_popup,
            alert_banner: alert_banner,
            navigation_root: navigation_root,
            business_navigation: business_navigation,
            desktop_navbar_menu_items: desktop_navbar_menu_items,
            mobile_navbar_menu_items: mobile_navbar_menu_items,
            footer: footer,
            business_footer: business_footer,
            login: login,
            register: register,
            warnings: warnings,
            header_logo: header_logo,
            not_logged_in_navbar_menu_items___consumer: not_logged_in_navbar_menu_items___consumer,
            not_logged_in_navbar_menu_items___business: not_logged_in_navbar_menu_items___business,
            search_bar_placeholder_text: search_bar_placeholder_text,
            no_search_result: no_search_result,
            sold_out_badge_text: sold_out_badge_text
        };
    }, value$4) : null;
    return {
        globalConfiguration: globalConfiguration,
        dictionaryItems: dictionaryItems,
        locations: locations,
        giftLandingPage: giftLandingPage
    };
}
function Gql_GlobalConfiguration_Query_bs_serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined
    };
}
function Gql_GlobalConfiguration_Query_bs_makeVariables(language, preview, param) {
    return {
        language: language,
        preview: preview
    };
}
var Gql_GlobalConfiguration_Query_bs_Query_inner = {
    Raw: Gql_GlobalConfiguration_Query_bs_Raw,
    query: Gql_GlobalConfiguration_Query_bs_query,
    parse: Gql_GlobalConfiguration_Query_bs_parse,
    serialize: Gql_GlobalConfiguration_Query_bs_serialize,
    serializeVariables: Gql_GlobalConfiguration_Query_bs_serializeVariables,
    makeVariables: Gql_GlobalConfiguration_Query_bs_makeVariables
};
var Gql_GlobalConfiguration_Query_bs_include = Extend({
    query: Gql_GlobalConfiguration_Query_bs_query,
    Raw: Gql_GlobalConfiguration_Query_bs_Raw,
    parse: Gql_GlobalConfiguration_Query_bs_parse,
    serialize: Gql_GlobalConfiguration_Query_bs_serialize,
    serializeVariables: Gql_GlobalConfiguration_Query_bs_serializeVariables
});
var Gql_GlobalConfiguration_Query_bs_Query_refetchQueryDescription = Gql_GlobalConfiguration_Query_bs_include.refetchQueryDescription;
var Gql_GlobalConfiguration_Query_bs_Query_use = Gql_GlobalConfiguration_Query_bs_include.use;
var Gql_GlobalConfiguration_Query_bs_Query_useLazy = Gql_GlobalConfiguration_Query_bs_include.useLazy;
var Gql_GlobalConfiguration_Query_bs_Query_useLazyWithVariables = Gql_GlobalConfiguration_Query_bs_include.useLazyWithVariables;
var Gql_GlobalConfiguration_Query_bs_Query = {
    Query_inner: Gql_GlobalConfiguration_Query_bs_Query_inner,
    Raw: Gql_GlobalConfiguration_Query_bs_Raw,
    query: Gql_GlobalConfiguration_Query_bs_query,
    parse: Gql_GlobalConfiguration_Query_bs_parse,
    serialize: Gql_GlobalConfiguration_Query_bs_serialize,
    serializeVariables: Gql_GlobalConfiguration_Query_bs_serializeVariables,
    makeVariables: Gql_GlobalConfiguration_Query_bs_makeVariables,
    refetchQueryDescription: Gql_GlobalConfiguration_Query_bs_Query_refetchQueryDescription,
    use: Gql_GlobalConfiguration_Query_bs_Query_use,
    useLazy: Gql_GlobalConfiguration_Query_bs_Query_useLazy,
    useLazyWithVariables: Gql_GlobalConfiguration_Query_bs_Query_useLazyWithVariables
};
var Gql_GlobalConfiguration_Query_bs_AlertBannerBlock;
var Gql_GlobalConfiguration_Query_bs_NavMenuBlock;
var Gql_GlobalConfiguration_Query_bs_HeaderNavigation;
var Gql_GlobalConfiguration_Query_bs_HeaderBlock;
var Gql_GlobalConfiguration_Query_bs_FooterBlock;
var Gql_GlobalConfiguration_Query_bs_$$Image;
var Gql_GlobalConfiguration_Query_bs_AppStoreItem;
var Gql_GlobalConfiguration_Query_bs_CallToAction;
var Gql_GlobalConfiguration_Query_bs_Icon;
var Gql_GlobalConfiguration_Query_bs_CookiePopupBlock;
var Gql_GlobalConfiguration_Query_bs_HeaderLogo;
var Gql_GlobalConfiguration_Query_bs_NavbarSelectCTA;
var Gql_GlobalConfiguration_Query_bs_NoSearchResults;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftLandingPageTheme/Gql__GiftLandingPageTheme__Query.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_GiftLandingPageTheme_Query_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query GiftLandingPageThemeContent($language: String!, $preview: Boolean, $themeId: String!)  {\n    itemsByType(type: "gift_landing_page_theme", limit: 1, depth: 5, language: $language, preview: $preview, filters: [{type: EQUALS, prop: "elements.theme_id", val: $themeId}])  {\n      __typename\n      ...on GiftLandingPageThemeContentType   {\n        __typename\n        theme_id  {\n          __typename\n          value\n        }\n        brand_logo  {\n          __typename\n          value  {\n            __typename\n            description\n            url\n          }\n        }\n        gift_unwrap_lottie  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        gift_unwrap_lottie_mobile_size  {\n          __typename\n          value\n        }\n        gift_unwrap_lottie_segments  {\n          __typename\n          value\n        }\n        confetti_lottie  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        desktop_background_image  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        desktop_background_image_size  {\n          __typename\n          value\n        }\n        mobile_background_image  {\n          __typename\n          value  {\n            __typename\n            url\n          }\n        }\n        mobile_background_image_size  {\n          __typename\n          value\n        }\n      }\n    }\n  }\n'
    ]);
    Gql_GiftLandingPageTheme_Query_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Gql_GiftLandingPageTheme_Query_bs_Raw = {};
var Gql_GiftLandingPageTheme_Query_bs_query = (__webpack_require__(46829).gql)(Gql_GiftLandingPageTheme_Query_bs_templateObject());
function Gql_GiftLandingPageTheme_Query_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp;
            if (typename === "GiftLandingPageThemeContentType") {
                var value$1 = value.theme_id;
                var tmp$1;
                if (value$1 == null) {
                    tmp$1 = undefined;
                } else {
                    var value$2 = value$1.value;
                    tmp$1 = {
                        __typename: value$1.__typename,
                        value: !(value$2 == null) ? value$2 : undefined
                    };
                }
                var value$3 = value.brand_logo;
                var tmp$2;
                if (value$3 == null) {
                    tmp$2 = undefined;
                } else {
                    var value$4 = value$3.value;
                    tmp$2 = {
                        __typename: value$3.__typename,
                        value: !(value$4 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.description;
                            var value$2 = value.url;
                            return {
                                __typename: value.__typename,
                                description: !(value$1 == null) ? value$1 : undefined,
                                url: !(value$2 == null) ? value$2 : undefined
                            };
                        }, value$4) : undefined
                    };
                }
                var value$5 = value.gift_unwrap_lottie;
                var tmp$3;
                if (value$5 == null) {
                    tmp$3 = undefined;
                } else {
                    var value$6 = value$5.value;
                    tmp$3 = {
                        __typename: value$5.__typename,
                        value: !(value$6 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$6) : undefined
                    };
                }
                var value$7 = value.gift_unwrap_lottie_mobile_size;
                var tmp$4;
                if (value$7 == null) {
                    tmp$4 = undefined;
                } else {
                    var value$8 = value$7.value;
                    tmp$4 = {
                        __typename: value$7.__typename,
                        value: !(value$8 == null) ? value$8 : undefined
                    };
                }
                var value$9 = value.gift_unwrap_lottie_segments;
                var tmp$5;
                if (value$9 == null) {
                    tmp$5 = undefined;
                } else {
                    var value$10 = value$9.value;
                    tmp$5 = {
                        __typename: value$9.__typename,
                        value: !(value$10 == null) ? value$10 : undefined
                    };
                }
                var value$11 = value.confetti_lottie;
                var tmp$6;
                if (value$11 == null) {
                    tmp$6 = undefined;
                } else {
                    var value$12 = value$11.value;
                    tmp$6 = {
                        __typename: value$11.__typename,
                        value: !(value$12 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$12) : undefined
                    };
                }
                var value$13 = value.desktop_background_image;
                var tmp$7;
                if (value$13 == null) {
                    tmp$7 = undefined;
                } else {
                    var value$14 = value$13.value;
                    tmp$7 = {
                        __typename: value$13.__typename,
                        value: !(value$14 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$14) : undefined
                    };
                }
                var value$15 = value.desktop_background_image_size;
                var tmp$8;
                if (value$15 == null) {
                    tmp$8 = undefined;
                } else {
                    var value$16 = value$15.value;
                    tmp$8 = {
                        __typename: value$15.__typename,
                        value: !(value$16 == null) ? value$16 : undefined
                    };
                }
                var value$17 = value.mobile_background_image;
                var tmp$9;
                if (value$17 == null) {
                    tmp$9 = undefined;
                } else {
                    var value$18 = value$17.value;
                    tmp$9 = {
                        __typename: value$17.__typename,
                        value: !(value$18 == null) ? js_array/* map */.UI(function(value) {
                            if (value == null) {
                                return;
                            }
                            var value$1 = value.url;
                            return {
                                __typename: value.__typename,
                                url: !(value$1 == null) ? value$1 : undefined
                            };
                        }, value$18) : undefined
                    };
                }
                var value$19 = value.mobile_background_image_size;
                var tmp$10;
                if (value$19 == null) {
                    tmp$10 = undefined;
                } else {
                    var value$20 = value$19.value;
                    tmp$10 = {
                        __typename: value$19.__typename,
                        value: !(value$20 == null) ? value$20 : undefined
                    };
                }
                tmp = {
                    NAME: "GiftLandingPageThemeContentType",
                    VAL: {
                        __typename: value.__typename,
                        theme_id: tmp$1,
                        brand_logo: tmp$2,
                        gift_unwrap_lottie: tmp$3,
                        gift_unwrap_lottie_mobile_size: tmp$4,
                        gift_unwrap_lottie_segments: tmp$5,
                        confetti_lottie: tmp$6,
                        desktop_background_image: tmp$7,
                        desktop_background_image_size: tmp$8,
                        mobile_background_image: tmp$9,
                        mobile_background_image_size: tmp$10
                    }
                };
            } else {
                tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                };
            }
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_GiftLandingPageTheme_Query_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value === undefined) {
            return null;
        }
        if (value.NAME === "UnspecifiedFragment") {
            return {};
        }
        var value$1 = value.VAL;
        var value$2 = value$1.mobile_background_image_size;
        var mobile_background_image_size;
        if (value$2 !== undefined) {
            var value$3 = value$2.value;
            var value$4 = value$3 !== undefined ? value$3 : null;
            var value$5 = value$2.__typename;
            mobile_background_image_size = {
                __typename: value$5,
                value: value$4
            };
        } else {
            mobile_background_image_size = null;
        }
        var value$6 = value$1.mobile_background_image;
        var mobile_background_image;
        if (value$6 !== undefined) {
            var value$7 = value$6.value;
            var value$8 = value$7 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$7) : null;
            var value$9 = value$6.__typename;
            mobile_background_image = {
                __typename: value$9,
                value: value$8
            };
        } else {
            mobile_background_image = null;
        }
        var value$10 = value$1.desktop_background_image_size;
        var desktop_background_image_size;
        if (value$10 !== undefined) {
            var value$11 = value$10.value;
            var value$12 = value$11 !== undefined ? value$11 : null;
            var value$13 = value$10.__typename;
            desktop_background_image_size = {
                __typename: value$13,
                value: value$12
            };
        } else {
            desktop_background_image_size = null;
        }
        var value$14 = value$1.desktop_background_image;
        var desktop_background_image;
        if (value$14 !== undefined) {
            var value$15 = value$14.value;
            var value$16 = value$15 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$15) : null;
            var value$17 = value$14.__typename;
            desktop_background_image = {
                __typename: value$17,
                value: value$16
            };
        } else {
            desktop_background_image = null;
        }
        var value$18 = value$1.confetti_lottie;
        var confetti_lottie;
        if (value$18 !== undefined) {
            var value$19 = value$18.value;
            var value$20 = value$19 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$19) : null;
            var value$21 = value$18.__typename;
            confetti_lottie = {
                __typename: value$21,
                value: value$20
            };
        } else {
            confetti_lottie = null;
        }
        var value$22 = value$1.gift_unwrap_lottie_segments;
        var gift_unwrap_lottie_segments;
        if (value$22 !== undefined) {
            var value$23 = value$22.value;
            var value$24 = value$23 !== undefined ? value$23 : null;
            var value$25 = value$22.__typename;
            gift_unwrap_lottie_segments = {
                __typename: value$25,
                value: value$24
            };
        } else {
            gift_unwrap_lottie_segments = null;
        }
        var value$26 = value$1.gift_unwrap_lottie_mobile_size;
        var gift_unwrap_lottie_mobile_size;
        if (value$26 !== undefined) {
            var value$27 = value$26.value;
            var value$28 = value$27 !== undefined ? value$27 : null;
            var value$29 = value$26.__typename;
            gift_unwrap_lottie_mobile_size = {
                __typename: value$29,
                value: value$28
            };
        } else {
            gift_unwrap_lottie_mobile_size = null;
        }
        var value$30 = value$1.gift_unwrap_lottie;
        var gift_unwrap_lottie;
        if (value$30 !== undefined) {
            var value$31 = value$30.value;
            var value$32 = value$31 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.__typename;
                return {
                    __typename: value$2,
                    url: url
                };
            }, value$31) : null;
            var value$33 = value$30.__typename;
            gift_unwrap_lottie = {
                __typename: value$33,
                value: value$32
            };
        } else {
            gift_unwrap_lottie = null;
        }
        var value$34 = value$1.brand_logo;
        var brand_logo;
        if (value$34 !== undefined) {
            var value$35 = value$34.value;
            var value$36 = value$35 !== undefined ? js_array/* map */.UI(function(value) {
                if (value === undefined) {
                    return null;
                }
                var value$1 = value.url;
                var url = value$1 !== undefined ? value$1 : null;
                var value$2 = value.description;
                var description = value$2 !== undefined ? value$2 : null;
                var value$3 = value.__typename;
                return {
                    __typename: value$3,
                    description: description,
                    url: url
                };
            }, value$35) : null;
            var value$37 = value$34.__typename;
            brand_logo = {
                __typename: value$37,
                value: value$36
            };
        } else {
            brand_logo = null;
        }
        var value$38 = value$1.theme_id;
        var theme_id;
        if (value$38 !== undefined) {
            var value$39 = value$38.value;
            var value$40 = value$39 !== undefined ? value$39 : null;
            var value$41 = value$38.__typename;
            theme_id = {
                __typename: value$41,
                value: value$40
            };
        } else {
            theme_id = null;
        }
        return {
            __typename: "GiftLandingPageThemeContentType",
            theme_id: theme_id,
            brand_logo: brand_logo,
            gift_unwrap_lottie: gift_unwrap_lottie,
            gift_unwrap_lottie_mobile_size: gift_unwrap_lottie_mobile_size,
            gift_unwrap_lottie_segments: gift_unwrap_lottie_segments,
            confetti_lottie: confetti_lottie,
            desktop_background_image: desktop_background_image,
            desktop_background_image_size: desktop_background_image_size,
            mobile_background_image: mobile_background_image,
            mobile_background_image_size: mobile_background_image_size
        };
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function Gql_GiftLandingPageTheme_Query_bs_serializeVariables(inp) {
    var a = inp.preview;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        themeId: inp.themeId
    };
}
function Gql_GiftLandingPageTheme_Query_bs_makeVariables(language, preview, themeId, param) {
    return {
        language: language,
        preview: preview,
        themeId: themeId
    };
}
var Gql_GiftLandingPageTheme_Query_bs_Query_inner = {
    Raw: Gql_GiftLandingPageTheme_Query_bs_Raw,
    query: Gql_GiftLandingPageTheme_Query_bs_query,
    parse: Gql_GiftLandingPageTheme_Query_bs_parse,
    serialize: Gql_GiftLandingPageTheme_Query_bs_serialize,
    serializeVariables: Gql_GiftLandingPageTheme_Query_bs_serializeVariables,
    makeVariables: Gql_GiftLandingPageTheme_Query_bs_makeVariables
};
var Gql_GiftLandingPageTheme_Query_bs_include = Extend({
    query: Gql_GiftLandingPageTheme_Query_bs_query,
    Raw: Gql_GiftLandingPageTheme_Query_bs_Raw,
    parse: Gql_GiftLandingPageTheme_Query_bs_parse,
    serialize: Gql_GiftLandingPageTheme_Query_bs_serialize,
    serializeVariables: Gql_GiftLandingPageTheme_Query_bs_serializeVariables
});
var Gql_GiftLandingPageTheme_Query_bs_Query_refetchQueryDescription = Gql_GiftLandingPageTheme_Query_bs_include.refetchQueryDescription;
var Gql_GiftLandingPageTheme_Query_bs_Query_use = Gql_GiftLandingPageTheme_Query_bs_include.use;
var Gql_GiftLandingPageTheme_Query_bs_Query_useLazy = Gql_GiftLandingPageTheme_Query_bs_include.useLazy;
var Gql_GiftLandingPageTheme_Query_bs_Query_useLazyWithVariables = Gql_GiftLandingPageTheme_Query_bs_include.useLazyWithVariables;
var Gql_GiftLandingPageTheme_Query_bs_Query = {
    Query_inner: Gql_GiftLandingPageTheme_Query_bs_Query_inner,
    Raw: Gql_GiftLandingPageTheme_Query_bs_Raw,
    query: Gql_GiftLandingPageTheme_Query_bs_query,
    parse: Gql_GiftLandingPageTheme_Query_bs_parse,
    serialize: Gql_GiftLandingPageTheme_Query_bs_serialize,
    serializeVariables: Gql_GiftLandingPageTheme_Query_bs_serializeVariables,
    makeVariables: Gql_GiftLandingPageTheme_Query_bs_makeVariables,
    refetchQueryDescription: Gql_GiftLandingPageTheme_Query_bs_Query_refetchQueryDescription,
    use: Gql_GiftLandingPageTheme_Query_bs_Query_use,
    useLazy: Gql_GiftLandingPageTheme_Query_bs_Query_useLazy,
    useLazyWithVariables: Gql_GiftLandingPageTheme_Query_bs_Query_useLazyWithVariables
};
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/Location/Gql__Location__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var Region = {};
function getRegionLocation($$location) {
    if (typeof $$location !== "object") {
        return;
    }
    if ($$location.NAME !== "RegionLocationContentType") {
        return;
    }
    var match = $$location.VAL;
    var system = match.system;
    var currency = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(match.currency, function(c) {
        return c.value;
    }), "");
    var country_name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(match.country_name, function(c) {
        return c.value;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(match.url, function(url) {
        return url.value;
    }), "");
    var smartLink_itemId = system.id;
    var smartLink_codename = system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var country_flag = belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(match.country_flag, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        return f.url;
    }), GqlUtils_bs.id), 0), "");
    var region = {
        name: country_name,
        currency: currency,
        flag: country_flag,
        smartLink: smartLink
    };
    return {
        regionListLine: region,
        url: url
    };
}
function getModalChangeLocation(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "ModalChangeLocationContentType") {
        return;
    }
    var $$location = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS($$location.title, function(title) {
        return title.value;
    }), "");
    var subtitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS($$location.subtitle, function(subtitle) {
        return subtitle.value;
    }), "");
    var ctaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS($$location.cta_text, function(cta_text) {
        return cta_text.value;
    }), "");
    var regions = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS($$location.region_location, function($$location) {
        return $$location.value;
    }), []), GqlUtils_bs.id), getRegionLocation), GqlUtils_bs.id);
    var smartLink_itemId = $$location.system.id;
    var smartLink_codename = $$location.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        regions: regions,
        title: title,
        subtitle: subtitle,
        ctaText: ctaText,
        smartLink: smartLink
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js + 1 modules
var Gql_DictionaryItems_Decoder_bs = __webpack_require__(44623);
;// CONCATENATED MODULE: ./src/api/graphql/AppStoreItem/Gql__AppStoreItem__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_AppStoreItem_Decoder_bs_get(c) {
    var app_store_name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_name, function(c) {
        return c.value;
    }), "");
    var app_store_download_link = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_download_link, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        app_store_name: app_store_name,
        app_store_download_link: app_store_download_link,
        app_store_image: result,
        smartLink: smartLink
    };
}
var Gql_AppStoreItem_Decoder_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftLandingPage/Gql__GiftLandingPage__Decoder__FAQ.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_GiftLandingPage_Decoder_FAQ_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "GiftLandingPageFaqItemContentType") {
        return;
    }
    var c = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var bodyText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.body_text, function(c) {
        return c.value;
    }), "");
    var includeHowToUse = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.include_how_to_use, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        if (v === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var includePdfDownload = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.include_pdf_download, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        if (v === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var includeCardMerchantTerms = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.include_card_merchant_terms, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), false, function(v) {
        if (v === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        bodyText: bodyText,
        includeHowToUse: includeHowToUse,
        includePdfDownload: includePdfDownload,
        includeCardMerchantTerms: includeCardMerchantTerms,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftLandingPage/Gql__GiftLandingPage__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function Gql_GiftLandingPage_Decoder_Block_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    if (c.NAME !== "GiftLandingPageContentType") {
        return;
    }
    var c$1 = c.VAL;
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.classic_logo_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.business_logo_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$1,
        url: url$1,
        width: width$1,
        height: height$1
    };
    var senderMessage = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.sender_message, function(c) {
        return c.value;
    }), "");
    var giftRevealCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_reveal_cta_text, function(c) {
        return c.value;
    }), "");
    var confettiLottie = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.confetti_lottie, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var faqs = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.faqs, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_GiftLandingPage_Decoder_FAQ_bs_get);
    var expiryLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.expiry_label, function(c) {
        return c.value;
    }), "");
    var noExpiryText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.no_expiry_text, function(c) {
        return c.value;
    }), "");
    var checkBalanceText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.check_balance_text, function(c) {
        return c.value;
    }), "");
    var value$2 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.check_balance_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var checkBalanceIcon;
    if (value$2 !== undefined) {
        var name$2 = belt_Option/* getWithDefault */.tj(value$2.name, "");
        var description$2 = belt_Option/* getWithDefault */.tj(value$2.description, "");
        var url$2 = belt_Option/* getWithDefault */.tj(value$2.url, "");
        var width$2 = belt_Option/* getWithDefault */.tj(value$2.width, 0);
        var height$2 = belt_Option/* getWithDefault */.tj(value$2.height, 0);
        checkBalanceIcon = {
            name: name$2,
            description: description$2,
            url: url$2,
            width: width$2,
            height: height$2
        };
    } else {
        checkBalanceIcon = undefined;
    }
    var storeInWalletCtaTitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.store_in_wallet_cta_title, function(c) {
        return c.value;
    }), "");
    var swapCardCtaTitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.swap_egift_card_cta_title, function(c) {
        return c.value;
    }), "");
    var optionalGiftCardCta = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.optional_gift_card_cta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var value$3 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.replay_button_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var replayButtonIcon;
    if (value$3 !== undefined) {
        var name$3 = belt_Option/* getWithDefault */.tj(value$3.name, "");
        var description$3 = belt_Option/* getWithDefault */.tj(value$3.description, "");
        var url$3 = belt_Option/* getWithDefault */.tj(value$3.url, "");
        var width$3 = belt_Option/* getWithDefault */.tj(value$3.width, 0);
        var height$3 = belt_Option/* getWithDefault */.tj(value$3.height, 0);
        replayButtonIcon = {
            name: name$3,
            description: description$3,
            url: url$3,
            width: width$3,
            height: height$3
        };
    } else {
        replayButtonIcon = undefined;
    }
    var replayButtonText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.replay_button_text, function(c) {
        return c.value;
    }), "");
    var redeemOnlineText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.redeem_online_text, function(c) {
        return c.value;
    }), "");
    var redeemOnlineTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.redeem_online_text_colour, function(c) {
        return c.value;
    }), "");
    var redeemOnlineButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.redeem_online_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var downloadOptionText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.download_option_text, function(c) {
        return c.value;
    }), "");
    var downloadOptionTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.download_option_text_colour, function(c) {
        return c.value;
    }), "");
    var downloadButton = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.download_button, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var giftUnwrapCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_unwrap_cta_text, function(c) {
        return c.value;
    }), "");
    var giftUnwrapLottieSegments = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_unwrap_lottie_segments, function(c) {
        return c.value;
    }), "");
    var classicGiftUnwrapLottie = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.classic_gift_unwrap_lottie, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var businessGiftUnwrapLottie = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.business_gift_unwrap_lottie, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var spendItNowHeading = belt_Option/* flatMap */.VS(c$1.spend_it_now_heading, function(c) {
        return c.value;
    });
    var clipboardItemCopyText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.clipboard_item_copy_text, function(c) {
        return c.value;
    }), "");
    var clipboardItemCopiedText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.clipboard_item_copied_text, function(c) {
        return c.value;
    }), "");
    var barcodeNumberClipboardHeading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.barcode_number_clipboard_heading, function(c) {
        return c.value;
    }), "");
    var inStoreNumberClipboardHeading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.in_store_number_clipboard_heading, function(c) {
        return c.value;
    }), "");
    var onlineNumberClipboardHeading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.online_number_clipboard_heading, function(c) {
        return c.value;
    }), "");
    var onlineAndInStoreNumberClipboardHeading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.online_and_in_store_clipboard_heading, function(c) {
        return c.value;
    }), "");
    var swapCardsTitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.swap_cards_title, function(c) {
        return c.value;
    }), "");
    var swapCardAlt = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.swap_card_alt, function(c) {
        return c.value;
    }), "");
    var swapCardOriginalValueLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.swap_card_original_value_label, function(c) {
        return c.value;
    }), "");
    var swapCardButtonStyle = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.swap_card_button_style, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var saveInAppleGoogleWalletText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.save_in_apple_google_wallet_text, function(c) {
        return c.value;
    }), "");
    var saveInAppleGoogleWalletTextColour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.save_in_apple_google_wallet_text_colour, function(c) {
        return c.value;
    }), "");
    var value$4 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.google_wallet_image_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var googleWalletImage;
    if (value$4 !== undefined) {
        var name$4 = belt_Option/* getWithDefault */.tj(value$4.name, "");
        var description$4 = belt_Option/* getWithDefault */.tj(value$4.description, "");
        var url$4 = belt_Option/* getWithDefault */.tj(value$4.url, "");
        var width$4 = belt_Option/* getWithDefault */.tj(value$4.width, 0);
        var height$4 = belt_Option/* getWithDefault */.tj(value$4.height, 0);
        googleWalletImage = {
            name: name$4,
            description: description$4,
            url: url$4,
            width: width$4,
            height: height$4
        };
    } else {
        googleWalletImage = undefined;
    }
    var value$5 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.apple_wallet_image_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var appleWalletImage;
    if (value$5 !== undefined) {
        var name$5 = belt_Option/* getWithDefault */.tj(value$5.name, "");
        var description$5 = belt_Option/* getWithDefault */.tj(value$5.description, "");
        var url$5 = belt_Option/* getWithDefault */.tj(value$5.url, "");
        var width$5 = belt_Option/* getWithDefault */.tj(value$5.width, 0);
        var height$5 = belt_Option/* getWithDefault */.tj(value$5.height, 0);
        appleWalletImage = {
            name: name$5,
            description: description$5,
            url: url$5,
            width: width$5,
            height: height$5
        };
    } else {
        appleWalletImage = undefined;
    }
    var footerCopyrightText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.footer_copyright_text, function(c) {
        return c.value;
    }), "");
    var footerDownloadText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.footer_download_text, function(c) {
        return c.value;
    }), "");
    var appStoreIcons = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.app_store_icons, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(c) {
        if (typeof c === "object" && c.NAME === "AppStoreItemContentType") {
            return Gql_AppStoreItem_Decoder_bs_get(c.VAL.appStoreItem);
        }
    });
    var createAccountModalTitle = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.create_account_modal_title, function(c) {
        return c.value;
    }), "");
    var createAccountModalList = belt_Option/* flatMap */.VS(c$1.create_account_modal_list, function(c) {
        return c.value;
    });
    var createAccountModalCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.create_account_modal_cta_text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c$1.system.id;
    var smartLink_codename = c$1.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        classicLogo: result,
        businessLogo: result$1,
        senderMessage: senderMessage,
        giftRevealCtaText: giftRevealCtaText,
        confettiLottie: confettiLottie,
        faqs: faqs,
        expiryLabel: expiryLabel,
        noExpiryText: noExpiryText,
        checkBalanceText: checkBalanceText,
        checkBalanceIcon: checkBalanceIcon,
        storeInWalletCtaTitle: storeInWalletCtaTitle,
        swapCardCtaTitle: swapCardCtaTitle,
        optionalGiftCardCta: optionalGiftCardCta,
        replayButtonIcon: replayButtonIcon,
        replayButtonText: replayButtonText,
        redeemOnlineText: redeemOnlineText,
        redeemOnlineTextColour: redeemOnlineTextColour,
        redeemOnlineButton: redeemOnlineButton,
        downloadOptionText: downloadOptionText,
        downloadOptionTextColour: downloadOptionTextColour,
        downloadButton: downloadButton,
        giftUnwrapCtaText: giftUnwrapCtaText,
        giftUnwrapLottieSegments: giftUnwrapLottieSegments,
        classicGiftUnwrapLottie: classicGiftUnwrapLottie,
        businessGiftUnwrapLottie: businessGiftUnwrapLottie,
        smartLink: smartLink,
        spendItNowHeading: spendItNowHeading,
        clipboardItemCopyText: clipboardItemCopyText,
        clipboardItemCopiedText: clipboardItemCopiedText,
        barcodeNumberClipboardHeading: barcodeNumberClipboardHeading,
        inStoreNumberClipboardHeading: inStoreNumberClipboardHeading,
        onlineNumberClipboardHeading: onlineNumberClipboardHeading,
        onlineAndInStoreNumberClipboardHeading: onlineAndInStoreNumberClipboardHeading,
        swapCardsTitle: swapCardsTitle,
        swapCardAlt: swapCardAlt,
        swapCardOriginalValueLabel: swapCardOriginalValueLabel,
        swapCardButtonStyle: swapCardButtonStyle,
        saveInAppleGoogleWalletText: saveInAppleGoogleWalletText,
        saveInAppleGoogleWalletTextColour: saveInAppleGoogleWalletTextColour,
        googleWalletImage: googleWalletImage,
        appleWalletImage: appleWalletImage,
        footerCopyrightText: footerCopyrightText,
        footerDownloadText: footerDownloadText,
        appStoreIcons: appStoreIcons,
        createAccountModalTitle: createAccountModalTitle,
        createAccountModalList: createAccountModalList,
        createAccountModalCtaText: createAccountModalCtaText
    };
}
var Gql_GiftLandingPage_Decoder_Block_bs_Icon;
var Gql_GiftLandingPage_Decoder_Block_bs_$$Image;
var Faq;
var Gql_GiftLandingPage_Decoder_Block_bs_AppStoreItem;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Login/Gql__Login__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Login_Decoder_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    if (c.NAME !== "LoginContentType") {
        return;
    }
    var c$1 = c.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* flatMap */.VS(c$1.subtitle, function(c) {
        return c.value;
    });
    var emailLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.email_label, function(c) {
        return c.value;
    }), "");
    var passwordLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.password_label, function(c) {
        return c.value;
    }), "");
    var requiredEmailText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.required_email_text, function(c) {
        return c.value;
    }), "");
    var requiredPasswordText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.required_password_text, function(c) {
        return c.value;
    }), "");
    var invalidEmailText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_email_text, function(c) {
        return c.value;
    }), "");
    var submitCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.submit_cta_text, function(c) {
        return c.value;
    }), "");
    var submitCtaSubmittingText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.submit_cta_submitting_text, function(c) {
        return c.value;
    }), "");
    var forgotPasswordText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.forgot_password_text, function(c) {
        return c.value;
    }), "");
    var forgotEmailText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.forgot_email_text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c$1.system.id;
    var smartLink_codename = c$1.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        subtitle: subtitle,
        emailLabel: emailLabel,
        passwordLabel: passwordLabel,
        requiredEmailText: requiredEmailText,
        requiredPasswordText: requiredPasswordText,
        invalidEmailText: invalidEmailText,
        submitCtaText: submitCtaText,
        submitCtaSubmittingText: submitCtaSubmittingText,
        forgotPasswordText: forgotPasswordText,
        forgotEmailText: forgotEmailText,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Warning/Gql__Warning__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Warning_Decoder_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    if (c.NAME !== "WarningContentType") {
        return;
    }
    var c$1 = c.VAL;
    var id = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.id, function(c) {
        return c.value;
    }), "");
    var heading = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.heading, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.description, function(c) {
        return c.value;
    }), "");
    return {
        id: id,
        heading: heading,
        description: description
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Register/Gql__Register__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Register_Decoder_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    if (c.NAME !== "RegisterContentType") {
        return;
    }
    var c$1 = c.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.register_title, function(c) {
        return c.value;
    }), "");
    var subtitle = belt_Option/* flatMap */.VS(c$1.register_subtitle, function(c) {
        return c.value;
    });
    var nextButtonText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.next_button_text, function(c) {
        return c.value;
    }), "");
    var backButtonText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.back_button_text, function(c) {
        return c.value;
    }), "");
    var stepTitleName = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.step_title___name, function(c) {
        return c.value;
    }), "");
    var firstNameLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.first_name_label, function(c) {
        return c.value;
    }), "");
    var firstNameRequiredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.first_name_required_text, function(c) {
        return c.value;
    }), "");
    var invalidFirstNameText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_first_name_text, function(c) {
        return c.value;
    }), "");
    var lastNameLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.last_name_label, function(c) {
        return c.value;
    }), "");
    var lastNameRequiredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.last_name_required_text, function(c) {
        return c.value;
    }), "");
    var invalidLastNameText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_last_name_text, function(c) {
        return c.value;
    }), "");
    var stepTitleEmail = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.step_title___email, function(c) {
        return c.value;
    }), "");
    var emailLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.email_label, function(c) {
        return c.value;
    }), "");
    var emailRequiredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.email_required_text, function(c) {
        return c.value;
    }), "");
    var invalidEmailText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_email_text, function(c) {
        return c.value;
    }), "");
    var stepTitlePassword = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.step_title___password, function(c) {
        return c.value;
    }), "");
    var passwordRequirements = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.password_requirements, function(c) {
        return c.value;
    }), "");
    var passwordLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.password_label, function(c) {
        return c.value;
    }), "");
    var passwordRequiredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.password_required_text, function(c) {
        return c.value;
    }), "");
    var invalidPasswordText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_password_text, function(c) {
        return c.value;
    }), "");
    var stepTitlePhoneNumber = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.step_title___phone_number, function(c) {
        return c.value;
    }), "");
    var phoneNumberRequiredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.phone_number_required_text, function(c) {
        return c.value;
    }), "");
    var invalidPhoneNumberText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.invalid_phone_number_text, function(c) {
        return c.value;
    }), "");
    var newsletterCheckboxLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.newsletter_checkbox_label, function(c) {
        return c.value;
    }), "");
    var tAndCsCheckboxLabel = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.t_cs_checkbox_label, function(c) {
        return c.value;
    }), "");
    var nzNotPrezzyDisclaimer = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.nz_not_prezzy_disclaimer, function(c) {
        return c.value;
    }), "");
    var sendSecurityCodeCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.send_security_code_cta_text, function(c) {
        return c.value;
    }), "");
    var stepTitleSecurityCode = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.step_title___security_code, function(c) {
        return c.value;
    }), "");
    var resendCodeText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.resend_code_text, function(c) {
        return c.value;
    }), "");
    var resendingCodeText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.resending_code_text, function(c) {
        return c.value;
    }), "");
    var signUpCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.sign_up_cta_text, function(c) {
        return c.value;
    }), "");
    var alreadyRegisteredText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.already_registered_text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = c$1.system.id;
    var smartLink_codename = c$1.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        subtitle: subtitle,
        nextButtonText: nextButtonText,
        backButtonText: backButtonText,
        stepTitleName: stepTitleName,
        firstNameLabel: firstNameLabel,
        firstNameRequiredText: firstNameRequiredText,
        invalidFirstNameText: invalidFirstNameText,
        lastNameLabel: lastNameLabel,
        lastNameRequiredText: lastNameRequiredText,
        invalidLastNameText: invalidLastNameText,
        stepTitleEmail: stepTitleEmail,
        emailLabel: emailLabel,
        emailRequiredText: emailRequiredText,
        invalidEmailText: invalidEmailText,
        stepTitlePassword: stepTitlePassword,
        passwordRequirements: passwordRequirements,
        passwordLabel: passwordLabel,
        passwordRequiredText: passwordRequiredText,
        invalidPasswordText: invalidPasswordText,
        stepTitlePhoneNumber: stepTitlePhoneNumber,
        phoneNumberRequiredText: phoneNumberRequiredText,
        invalidPhoneNumberText: invalidPhoneNumberText,
        newsletterCheckboxLabel: newsletterCheckboxLabel,
        tAndCsCheckboxLabel: tAndCsCheckboxLabel,
        nzNotPrezzyDisclaimer: nzNotPrezzyDisclaimer,
        sendSecurityCodeCtaText: sendSecurityCodeCtaText,
        stepTitleSecurityCode: stepTitleSecurityCode,
        resendCodeText: resendCodeText,
        resendingCodeText: resendingCodeText,
        signUpCtaText: signUpCtaText,
        alreadyRegisteredText: alreadyRegisteredText,
        smartLink: smartLink
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
;// CONCATENATED MODULE: ./src/api/graphql/AlertBanner/Gql__AlertBanner__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function parse_alert_banner_style(style) {
    switch(style){
        case "active_blue":
            return /* Blue */ 0;
        case "green":
            return /* Green */ 1;
        case "orange":
            return /* Orange */ 3;
        case "primary_red":
            return /* Red */ 2;
        case "yellow":
            return /* Yellow */ 4;
        default:
            return /* Green */ 1;
    }
}
function Gql_AlertBanner_Decoder_bs_get(content) {
    var desktopText = belt_Option/* flatMap */.VS(content.desktop_text, function(c) {
        return c.value;
    });
    var mobileText = belt_Option/* flatMap */.VS(content.mobile_text, function(c) {
        return c.value;
    });
    var url = belt_Option/* flatMap */.VS(content.url, function(c) {
        return c.value;
    });
    var backgroundColor = parse_alert_banner_style(belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.background_color, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), "green"));
    var customColor = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.custom_color, function(c) {
        return c.value;
    }), "");
    var bannerColor = customColor === "" ? backgroundColor : /* Custom */ {
        _0: curry._1(BsCss_bs/* style */.oBv, {
            hd: BsCss_bs/* unsafe */.K47("backgroundColor", customColor),
            tl: /* [] */ 0
        })
    };
    var smartLink_itemId = content.system.id;
    var smartLink_codename = content.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        desktopText: desktopText,
        mobileText: mobileText,
        url: url,
        bannerColor: bannerColor,
        smartLink: smartLink
    };
}
 /* BsCss Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CookiePopup/Gql__CookiePopup__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_CookiePopup_Decoder_bs_get(content) {
    var cookieIcon = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.cookie_popup_icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var cookieMessage = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.cookie_popup_text, function(c) {
        return c.value;
    }), "");
    var acceptText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.cookie_popup_accept_button, function(c) {
        return c.value;
    }), "");
    var declineText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(content.cookie_popup_decline_button, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = content.system.id;
    var smartLink_codename = content.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        cookieIcon: cookieIcon,
        cookieMessage: cookieMessage,
        acceptText: acceptText,
        declineText: declineText,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NavMenuItems/Gql__NavMenuItems__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_NavMenuItems_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text, function(c) {
        return c.value;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.url, function(c) {
        return c.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.menu_icon_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var icon;
    if (value !== undefined) {
        var name = belt_Option/* getWithDefault */.tj(value.name, "");
        var description = belt_Option/* getWithDefault */.tj(value.description, "");
        var url$1 = belt_Option/* getWithDefault */.tj(value.url, "");
        var width = belt_Option/* getWithDefault */.tj(value.width, 0);
        var height = belt_Option/* getWithDefault */.tj(value.height, 0);
        icon = {
            name: name,
            description: description,
            url: url$1,
            width: width,
            height: height
        };
    } else {
        icon = undefined;
    }
    var fontawesomeIcon = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.fontawesome_icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "FontAwesomeContentType") {
            return Gql_FontAwesomeIcon_Decoder_bs/* get */.U(f.VAL.fontAwesomeIcon);
        }
    }), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        icon: icon,
        fontawesomeIcon: fontawesomeIcon,
        url: url,
        smartLink: smartLink
    };
}
var Gql_NavMenuItems_Decoder_bs_CardIcon;
var Gql_NavMenuItems_Decoder_bs_FontAwesomeIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NavbarSelectCta/Gql__NavbarSelectCta__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_NavbarSelectCta_Decoder_bs_get(c) {
    var selectCTA = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.select_cta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var optionCTAList = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.option_ctas, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        smartLink: smartLink,
        selectCTA: selectCTA,
        optionCTAList: optionCTAList
    };
}
var Gql_NavbarSelectCta_Decoder_bs_CallToAction;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/NoSearchResults/Gql__NoSearchResults__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_NoSearchResults_Decoder_bs_get(c) {
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title, function(c) {
        return c.value;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description, function(f) {
        return f.value;
    }), "");
    var file = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.icon, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var icon;
    if (file !== undefined) {
        var alt = belt_Option/* getWithDefault */.tj(file.description, "");
        var src = belt_Option/* getWithDefault */.tj(file.url, "");
        var width = belt_Option/* getWithDefault */.tj(file.width, 72);
        var height = belt_Option/* getWithDefault */.tj(file.height, 72);
        icon = {
            src: src,
            alt: alt,
            width: width,
            height: height
        };
    } else {
        icon = undefined;
    }
    var scp_title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.title_scp, function(c) {
        return c.value;
    }), "");
    var scp_description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.description_scp, function(f) {
        return f.value;
    }), "");
    return {
        title: title,
        description: description,
        icon: icon,
        scp_title: scp_title,
        scp_description: scp_description
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeaderNavigation/Gql__HeaderNavigation__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_HeaderNavigation_Decoder_bs_get(header) {
    var subpages = belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(header.subpages_subviews, function(subpagesContent) {
        return subpagesContent.value;
    }), []), GqlUtils_bs.id);
    var subpagesData = belt_Array/* map */.UI(subpages, function(content) {
        if (typeof content === "object") {
            if (content.NAME === "HeaderNavigationContentType") {
                var nav = content.VAL;
                var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(nav.label, function(t) {
                    return t.value;
                }), "");
                var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(nav.url, function(u) {
                    return u.value;
                }), "");
                var smartLink_itemId = nav.system.id;
                var smartLink_codename = nav.system.codename;
                var smartLink = {
                    itemId: smartLink_itemId,
                    codename: smartLink_codename
                };
                return {
                    title: title,
                    url: url,
                    smartLink: smartLink
                };
            }
            throw {
                RE_EXN_ID: "Match_failure",
                _1: [
                    "Gql__HeaderNavigation__Decoder.res",
                    17,
                    4
                ],
                Error: new Error()
            };
        }
        throw {
            RE_EXN_ID: "Match_failure",
            _1: [
                "Gql__HeaderNavigation__Decoder.res",
                17,
                4
            ],
            Error: new Error()
        };
    });
    if (subpagesData.length !== 0) {
        return subpagesData;
    }
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/HeaderLogo/Gql__HeaderLogo__Decoder__Block.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_HeaderLogo_Decoder_Block_bs_get(c) {
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.classic_logo_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var classicLogoWidth = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.classic_logo_width, function(f) {
        return f.value;
    }), 0);
    var value$1 = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.business_logo_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.name;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.description;
    }), "");
    var url$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.url;
    }), "");
    var width$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.width;
    }), 0);
    var height$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value$1, function(f) {
        return f.height;
    }), 0);
    var result$1 = {
        name: name$1,
        description: description$1,
        url: url$1,
        width: width$1,
        height: height$1
    };
    var businessLogoWidth = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.business_logo_width, function(f) {
        return f.value;
    }), 0);
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        classicLogoAsset: result,
        classicLogoWidth: classicLogoWidth,
        businessLogoAsset: result$1,
        businessLogoWidth: businessLogoWidth,
        smartLink: smartLink
    };
}
var Gql_HeaderLogo_Decoder_Block_bs_$$Image;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/GlobalConfiguration/Gql__GlobalConfiguration__Decoder__Config.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

















function Gql_GlobalConfiguration_Decoder_Config_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "GlobalConfigurationContentType") {
        return;
    }
    var c = content.VAL;
    var alertBannerData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.alert_banner, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var alertBanner = alertBannerData !== undefined && typeof alertBannerData === "object" && alertBannerData.NAME === "AlertBannerContentType" ? Gql_AlertBanner_Decoder_bs_get(alertBannerData.VAL.alertBannerBlock) : undefined;
    var cookiePopupData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.gdpr_cookie_popup, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var cookiePopup = cookiePopupData !== undefined && typeof cookiePopupData === "object" && cookiePopupData.NAME === "GdprCookiePopupContentType" ? Gql_CookiePopup_Decoder_bs_get(cookiePopupData.VAL.cookiePopupBlock) : undefined;
    var headerBlockData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.navigation_root, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var headerBlock;
    if (headerBlockData !== undefined && typeof headerBlockData === "object") {
        var variant = headerBlockData.NAME;
        headerBlock = variant === "AppContentType" ? Gql_HeaderNavigation_Decoder_bs_get(headerBlockData.VAL.headerNavigation) : variant === "PageContentType" ? Gql_Header_Decoder_Homepage_bs_get(headerBlockData.VAL.headerBlock) : undefined;
    } else {
        headerBlock = undefined;
    }
    var businessHeaderData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.business_navigation, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var businessHeader;
    if (businessHeaderData !== undefined && typeof businessHeaderData === "object") {
        var variant$1 = businessHeaderData.NAME;
        businessHeader = variant$1 === "AppContentType" ? belt_Option/* flatMap */.VS(Gql_HeaderNavigation_Decoder_bs_get(businessHeaderData.VAL.headerNavigation), function(arr) {
            var copy = arr.slice();
            copy.unshift({
                title: "Home",
                url: "/business/",
                smartLink: SmartLink_bs/* emptySmartLink */.R
            });
            return copy;
        }) : variant$1 === "PageContentType" ? Gql_Header_Decoder_Homepage_bs_get(businessHeaderData.VAL.headerBlock) : undefined;
    } else {
        businessHeader = undefined;
    }
    var mobileNavMenuData = belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.mobile_navbar_menu_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id);
    var mobileNavMenuBlock = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(mobileNavMenuData, function(c) {
        if (typeof c === "object" && c.NAME === "NavbarMenuItemContentType") {
            return Gql_NavMenuItems_Decoder_bs_get(c.VAL.navMenuBlock);
        }
    }), GqlUtils_bs.id);
    var desktopNavMenuData = belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.desktop_navbar_menu_items, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id);
    var desktopNavMenuBlock = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(desktopNavMenuData, function(c) {
        if (typeof c === "object" && c.NAME === "NavbarMenuItemContentType") {
            return Gql_NavMenuItems_Decoder_bs_get(c.VAL.navMenuBlock);
        }
    }), GqlUtils_bs.id);
    var footerBlockData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.footer, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var footerBlock = footerBlockData !== undefined && typeof footerBlockData === "object" && footerBlockData.NAME === "FooterContainerContentType" ? Gql_Footer_Decoder_FooterContainer_bs/* get */.U2(footerBlockData.VAL.footerBlock) : undefined;
    var businessFooterData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.business_footer, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var businessFooter = businessFooterData !== undefined && typeof businessFooterData === "object" && businessFooterData.NAME === "FooterContainerContentType" ? Gql_Footer_Decoder_FooterContainer_bs/* get */.U2(businessFooterData.VAL.footerBlock) : undefined;
    var login = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.login, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), Gql_Login_Decoder_bs_get);
    var register = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.register, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), Gql_Register_Decoder_bs_get);
    var warnings = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.warnings, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_Warning_Decoder_bs_get);
    var headerLogoData = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.header_logo, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var headerLogo = headerLogoData !== undefined && typeof headerLogoData === "object" && headerLogoData.NAME === "HeaderLogoContentType" ? Gql_HeaderLogo_Decoder_Block_bs_get(headerLogoData.VAL.headerLogo) : undefined;
    var classicLoginCtaList = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.not_logged_in_navbar_menu_items___consumer, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f !== "object") {
            return;
        }
        var variant = f.NAME;
        if (variant === "NavbarSelectCtaContentType") {
            return {
                NAME: "NavbarSelectCTA",
                VAL: Gql_NavbarSelectCta_Decoder_bs_get(f.VAL.navbarSelectCTA)
            };
        } else if (variant === "CallToActionLinkD6a3d61ContentType") {
            return {
                NAME: "CallToAction",
                VAL: Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction)
            };
        } else {
            return;
        }
    }), GqlUtils_bs.id);
    var businessLoginCtaList = belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.not_logged_in_navbar_menu_items___business, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    }), GqlUtils_bs.id);
    var searchBarPlaceholder = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.search_bar_placeholder_text, function(c) {
        return c.value;
    }), "");
    var noSearchResults = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.no_search_result, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        if (typeof f === "object" && f.NAME === "NoSearchResultsContentType") {
            return Gql_NoSearchResults_Decoder_bs_get(f.VAL.noSearchResults);
        }
    });
    var soldOutBadgeText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.sold_out_badge_text, function(c) {
        return c.value;
    }), "");
    return {
        alertBanner: alertBanner,
        headerBlock: headerBlock,
        businessHeader: businessHeader,
        mobileNavMenuBlock: mobileNavMenuBlock,
        desktopNavMenuBlock: desktopNavMenuBlock,
        footerBlock: footerBlock,
        businessFooter: businessFooter,
        login: login,
        register: register,
        cookiePopup: cookiePopup,
        warnings: warnings,
        headerLogo: headerLogo,
        classicLoginCtaList: classicLoginCtaList,
        businessLoginCtaList: businessLoginCtaList,
        searchBarPlaceholder: searchBarPlaceholder,
        noSearchResults: noSearchResults,
        soldOutBadgeText: soldOutBadgeText
    };
}
var Gql_GlobalConfiguration_Decoder_Config_bs_HeaderBlock;
var Gql_GlobalConfiguration_Decoder_Config_bs_HeaderNavigation;
var Gql_GlobalConfiguration_Decoder_Config_bs_NavMenuBlock;
var Gql_GlobalConfiguration_Decoder_Config_bs_FooterBlock;
var AlertBanner;
var Login;
var Register;
var CookiePopup;
var Warning;
var Gql_GlobalConfiguration_Decoder_Config_bs_HeaderLogo;
var Gql_GlobalConfiguration_Decoder_Config_bs_CallToAction;
var Gql_GlobalConfiguration_Decoder_Config_bs_NavbarSelectCTA;
var Gql_GlobalConfiguration_Decoder_Config_bs_NoSearchResults;
 /* Gql__AlertBanner__Decoder Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/GlobalConfiguration/Gql__GlobalConfiguration__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








function Gql_GlobalConfiguration_Decoder_bs_decode(gqlQueryResult) {
    var globalConfig = belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.globalConfiguration, []), 0), GqlUtils_bs.id), Gql_GlobalConfiguration_Decoder_Config_bs_get);
    var dictionaryItems = Gql_DictionaryItems_Decoder_bs/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(gqlQueryResult.dictionaryItems, []), GqlUtils_bs.id));
    var locations = belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.locations, []), 0), GqlUtils_bs.id), getModalChangeLocation);
    var giftLandingPage = belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.giftLandingPage, []), 0), GqlUtils_bs.id), Gql_GiftLandingPage_Decoder_Block_bs_get);
    return {
        globalConfig: globalConfig,
        dictionaryItems: dictionaryItems,
        locations: locations,
        giftLandingPage: giftLandingPage
    };
}
function Gql_GlobalConfiguration_Decoder_bs_handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(Gql_GlobalConfiguration_Decoder_bs_decode(result._0.data));
    }
    var logData;
    logData = result.TAG === /* Ok */ 0 ? result._0.data : undefined;
    Pino_bs/* logger.error */.k.error({
        error: result._0,
        type: "Global Config decoder",
        data: JSON.stringify(logData)
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Gql_GlobalConfiguration_Decoder_bs_Decoder = {
    decode: Gql_GlobalConfiguration_Decoder_bs_decode,
    handleResult: Gql_GlobalConfiguration_Decoder_bs_handleResult
};
var GlobalConfiguration;
var DictionaryItems;
var Locations;
var GiftLandingPage;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Query__List.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_SkuPresentation_Query_List_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query PageContent($language: String!, $preview: Boolean, $codenames: [String])  {\n    itemsByType(type: "sku_presentation", depth: 5, language: $language, preview: $preview, filters: [{type: IN_, prop: "system.codename", list: $codenames}])  {\n      __typename\n      ...on SkuPresentationContentType   {\n        ...SkuPresentationFragment\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    Gql_SkuPresentation_Query_List_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Gql_SkuPresentation_Query_List_bs_Raw = {};
var Gql_SkuPresentation_Query_List_bs_query = function(frag_0) {
    return (__webpack_require__(46829).gql)(Gql_SkuPresentation_Query_List_bs_templateObject(), frag_0);
}(SkuPresentationFragment.query);
function Gql_SkuPresentation_Query_List_bs_parse(value) {
    var value$1 = value.itemsByType;
    return {
        itemsByType: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp = typename === "SkuPresentationContentType" ? {
                NAME: "SkuPresentationContentType",
                VAL: {
                    skuPresentationFragment: SkuPresentationFragment.verifyArgsAndParse("SkuPresentationFragment", value)
                }
            } : {
                NAME: "UnspecifiedFragment",
                VAL: typename
            };
            return tmp;
        }, value$1) : undefined
    };
}
function Gql_SkuPresentation_Query_List_bs_serialize(value) {
    var value$1 = value.itemsByType;
    var itemsByType = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value !== undefined) {
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    SkuPresentationFragment.serialize(value.VAL.skuPresentationFragment)
                ]);
            }
        } else {
            return null;
        }
    }, value$1) : null;
    return {
        itemsByType: itemsByType
    };
}
function Gql_SkuPresentation_Query_List_bs_serializeVariables(inp) {
    var a = inp.preview;
    var a$1 = inp.codenames;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        codenames: a$1 !== undefined ? js_array/* map */.UI(function(b) {
            if (b !== undefined) {
                return b;
            }
        }, a$1) : undefined
    };
}
function Gql_SkuPresentation_Query_List_bs_makeVariables(language, preview, codenames, param) {
    return {
        language: language,
        preview: preview,
        codenames: codenames
    };
}
var Gql_SkuPresentation_Query_List_bs_Query_inner = {
    Raw: Gql_SkuPresentation_Query_List_bs_Raw,
    query: Gql_SkuPresentation_Query_List_bs_query,
    parse: Gql_SkuPresentation_Query_List_bs_parse,
    serialize: Gql_SkuPresentation_Query_List_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_List_bs_serializeVariables,
    makeVariables: Gql_SkuPresentation_Query_List_bs_makeVariables
};
var Gql_SkuPresentation_Query_List_bs_include = Extend({
    query: Gql_SkuPresentation_Query_List_bs_query,
    Raw: Gql_SkuPresentation_Query_List_bs_Raw,
    parse: Gql_SkuPresentation_Query_List_bs_parse,
    serialize: Gql_SkuPresentation_Query_List_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_List_bs_serializeVariables
});
var Gql_SkuPresentation_Query_List_bs_Query_refetchQueryDescription = Gql_SkuPresentation_Query_List_bs_include.refetchQueryDescription;
var Gql_SkuPresentation_Query_List_bs_Query_use = Gql_SkuPresentation_Query_List_bs_include.use;
var Gql_SkuPresentation_Query_List_bs_Query_useLazy = Gql_SkuPresentation_Query_List_bs_include.useLazy;
var Gql_SkuPresentation_Query_List_bs_Query_useLazyWithVariables = Gql_SkuPresentation_Query_List_bs_include.useLazyWithVariables;
var Gql_SkuPresentation_Query_List_bs_Query = {
    Query_inner: Gql_SkuPresentation_Query_List_bs_Query_inner,
    Raw: Gql_SkuPresentation_Query_List_bs_Raw,
    query: Gql_SkuPresentation_Query_List_bs_query,
    parse: Gql_SkuPresentation_Query_List_bs_parse,
    serialize: Gql_SkuPresentation_Query_List_bs_serialize,
    serializeVariables: Gql_SkuPresentation_Query_List_bs_serializeVariables,
    makeVariables: Gql_SkuPresentation_Query_List_bs_makeVariables,
    refetchQueryDescription: Gql_SkuPresentation_Query_List_bs_Query_refetchQueryDescription,
    use: Gql_SkuPresentation_Query_List_bs_Query_use,
    useLazy: Gql_SkuPresentation_Query_List_bs_Query_useLazy,
    useLazyWithVariables: Gql_SkuPresentation_Query_List_bs_Query_useLazyWithVariables
};
var Gql_SkuPresentation_Query_List_bs_SkuPresentationFragment;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/GiftLandingPageTheme/Gql__GiftLandingPageTheme__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_GiftLandingPageTheme_Decoder_bs_get(c) {
    if (typeof c !== "object") {
        return;
    }
    if (c.NAME !== "GiftLandingPageThemeContentType") {
        return;
    }
    var c$1 = c.VAL;
    var brandLogo = belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.brand_logo, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), null, function(f) {
        return {
            description: belt_Option/* getWithDefault */.tj(f.description, ""),
            url: belt_Option/* getWithDefault */.tj(f.url, "")
        };
    });
    var giftUnwrapLottie = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_unwrap_lottie, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var giftUnwrapLottieMobileSize = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_unwrap_lottie_mobile_size, function(c) {
        return c.value;
    }), "");
    var giftUnwrapLottieSegments = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.gift_unwrap_lottie_segments, function(c) {
        return c.value;
    }), "");
    var confettiLottie = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.confetti_lottie, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var desktopBackgroundImage = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.desktop_background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var desktopBackgroundImageSize = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.desktop_background_image_size, function(c) {
        return c.value;
    }), "");
    var mobileBackgroundImage = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.mobile_background_image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(f) {
        return f.url;
    }), "");
    var mobileBackgroundImageSize = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c$1.mobile_background_image_size, function(c) {
        return c.value;
    }), "");
    return {
        brandLogo: brandLogo,
        giftUnwrapLottie: giftUnwrapLottie,
        giftUnwrapLottieMobileSize: giftUnwrapLottieMobileSize,
        giftUnwrapLottieSegments: giftUnwrapLottieSegments,
        confettiLottie: confettiLottie,
        desktopBackgroundImage: desktopBackgroundImage,
        desktopBackgroundImageSize: desktopBackgroundImageSize,
        mobileBackgroundImage: mobileBackgroundImage,
        mobileBackgroundImageSize: mobileBackgroundImageSize
    };
}
var GiftLandingPageTheme = {
    get: Gql_GiftLandingPageTheme_Decoder_bs_get
};
function Gql_GiftLandingPageTheme_Decoder_bs_decode(gqlQueryResult) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Option/* getWithDefault */.tj(gqlQueryResult.itemsByType, []), 0), GqlUtils_bs.id), Gql_GiftLandingPageTheme_Decoder_bs_get);
}
function Gql_GiftLandingPageTheme_Decoder_bs_handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(Gql_GiftLandingPageTheme_Decoder_bs_decode(result._0.data));
    }
    Pino_bs/* logger.error */.k.error({
        err: result._0,
        type: "Gift Landing Page Theme decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Gql_GiftLandingPageTheme_Decoder_bs_Decoder = {
    decode: Gql_GiftLandingPageTheme_Decoder_bs_decode,
    handleResult: Gql_GiftLandingPageTheme_Decoder_bs_handleResult
};
 /* Pino Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Decoder__List.bs.js
var Gql_SkuPresentation_Decoder_List_bs = __webpack_require__(1651);
;// CONCATENATED MODULE: ./src/api/graphql/EnrichedTextBlock/Gql__EnrichedTextBlock__Query__Fields.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_EnrichedTextBlock_Query_Fields_bs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  query PageContent($language: String!, $preview: Boolean, $codenames: [String])  {\n    callToActions: itemsByType(type: "call_to_action_link_d6a3d61", depth: 5, language: $language, preview: $preview, filters: [{type: IN_, prop: "system.codename", list: $codenames}])  {\n      __typename\n      ...on CallToActionLinkD6a3d61ContentType   {\n        ...CallToAction\n      }\n    }\n    images: itemsByType(type: "image", depth: 5, language: $language, preview: $preview, filters: [{type: IN_, prop: "system.codename", list: $codenames}])  {\n      __typename\n      ...on ImageContentType   {\n        ...Image\n      }\n    }\n  }\n  ',
        "\n  ",
        "\n"
    ]);
    Gql_EnrichedTextBlock_Query_Fields_bs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Gql_EnrichedTextBlock_Query_Fields_bs_Raw = {};
var Gql_EnrichedTextBlock_Query_Fields_bs_query = function(frag_0, frag_1) {
    return (__webpack_require__(46829).gql)(Gql_EnrichedTextBlock_Query_Fields_bs_templateObject(), frag_0, frag_1);
}(CallToAction.query, $$Image.query);
function Gql_EnrichedTextBlock_Query_Fields_bs_parse(value) {
    var value$1 = value.callToActions;
    var value$2 = value.images;
    return {
        callToActions: !(value$1 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp = typename === "CallToActionLinkD6a3d61ContentType" ? {
                NAME: "CallToActionLinkD6a3d61ContentType",
                VAL: {
                    callToAction: CallToAction.verifyArgsAndParse("CallToAction", value)
                }
            } : {
                NAME: "UnspecifiedFragment",
                VAL: typename
            };
            return tmp;
        }, value$1) : undefined,
        images: !(value$2 == null) ? js_array/* map */.UI(function(value) {
            if (value == null) {
                return;
            }
            var typename = value["__typename"];
            var tmp = typename === "ImageContentType" ? {
                NAME: "ImageContentType",
                VAL: {
                    image: $$Image.verifyArgsAndParse("Image", value)
                }
            } : {
                NAME: "UnspecifiedFragment",
                VAL: typename
            };
            return tmp;
        }, value$2) : undefined
    };
}
function Gql_EnrichedTextBlock_Query_Fields_bs_serialize(value) {
    var value$1 = value.images;
    var images = value$1 !== undefined ? js_array/* map */.UI(function(value) {
        if (value !== undefined) {
            if (value.NAME === "UnspecifiedFragment") {
                return {};
            } else {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    $$Image.serialize(value.VAL.image)
                ]);
            }
        } else {
            return null;
        }
    }, value$1) : null;
    var value$2 = value.callToActions;
    var callToActions = value$2 !== undefined ? js_array/* map */.UI(function(value) {
        if (value !== undefined) {
            if (value.NAME === "CallToActionLinkD6a3d61ContentType") {
                return js_array/* reduce */.u4(deepMerge, function(prim) {
                    return {};
                }, [
                    CallToAction.serialize(value.VAL.callToAction)
                ]);
            } else {
                return {};
            }
        } else {
            return null;
        }
    }, value$2) : null;
    return {
        callToActions: callToActions,
        images: images
    };
}
function Gql_EnrichedTextBlock_Query_Fields_bs_serializeVariables(inp) {
    var a = inp.preview;
    var a$1 = inp.codenames;
    return {
        language: inp.language,
        preview: a !== undefined ? a : undefined,
        codenames: a$1 !== undefined ? js_array/* map */.UI(function(b) {
            if (b !== undefined) {
                return b;
            }
        }, a$1) : undefined
    };
}
function Gql_EnrichedTextBlock_Query_Fields_bs_makeVariables(language, preview, codenames, param) {
    return {
        language: language,
        preview: preview,
        codenames: codenames
    };
}
var Gql_EnrichedTextBlock_Query_Fields_bs_Query_inner = {
    Raw: Gql_EnrichedTextBlock_Query_Fields_bs_Raw,
    query: Gql_EnrichedTextBlock_Query_Fields_bs_query,
    parse: Gql_EnrichedTextBlock_Query_Fields_bs_parse,
    serialize: Gql_EnrichedTextBlock_Query_Fields_bs_serialize,
    serializeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_serializeVariables,
    makeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_makeVariables
};
var Gql_EnrichedTextBlock_Query_Fields_bs_include = Extend({
    query: Gql_EnrichedTextBlock_Query_Fields_bs_query,
    Raw: Gql_EnrichedTextBlock_Query_Fields_bs_Raw,
    parse: Gql_EnrichedTextBlock_Query_Fields_bs_parse,
    serialize: Gql_EnrichedTextBlock_Query_Fields_bs_serialize,
    serializeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_serializeVariables
});
var Gql_EnrichedTextBlock_Query_Fields_bs_Query_refetchQueryDescription = Gql_EnrichedTextBlock_Query_Fields_bs_include.refetchQueryDescription;
var Gql_EnrichedTextBlock_Query_Fields_bs_Query_use = Gql_EnrichedTextBlock_Query_Fields_bs_include.use;
var Gql_EnrichedTextBlock_Query_Fields_bs_Query_useLazy = Gql_EnrichedTextBlock_Query_Fields_bs_include.useLazy;
var Gql_EnrichedTextBlock_Query_Fields_bs_Query_useLazyWithVariables = Gql_EnrichedTextBlock_Query_Fields_bs_include.useLazyWithVariables;
var Gql_EnrichedTextBlock_Query_Fields_bs_Query = {
    Query_inner: Gql_EnrichedTextBlock_Query_Fields_bs_Query_inner,
    Raw: Gql_EnrichedTextBlock_Query_Fields_bs_Raw,
    query: Gql_EnrichedTextBlock_Query_Fields_bs_query,
    parse: Gql_EnrichedTextBlock_Query_Fields_bs_parse,
    serialize: Gql_EnrichedTextBlock_Query_Fields_bs_serialize,
    serializeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_serializeVariables,
    makeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_makeVariables,
    refetchQueryDescription: Gql_EnrichedTextBlock_Query_Fields_bs_Query_refetchQueryDescription,
    use: Gql_EnrichedTextBlock_Query_Fields_bs_Query_use,
    useLazy: Gql_EnrichedTextBlock_Query_Fields_bs_Query_useLazy,
    useLazyWithVariables: Gql_EnrichedTextBlock_Query_Fields_bs_Query_useLazyWithVariables
};
var Gql_EnrichedTextBlock_Query_Fields_bs_$$Image;
var Gql_EnrichedTextBlock_Query_Fields_bs_CallToAction;
 /* query Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/EnrichedTextBlock/Gql__EnrichedTextBlock__Decoder__Fields.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function Gql_EnrichedTextBlock_Decoder_Fields_bs_decode(gqlQueryResult) {
    var callToActionList = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(gqlQueryResult.callToActions, []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "CallToActionLinkD6a3d61ContentType") {
            return Gql_CallToAction_Decoder_bs/* get */.U2(f.VAL.callToAction);
        }
    });
    var imageList = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(gqlQueryResult.images, []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "ImageContentType") {
            return Gql_Image_Decoder_bs/* get */.U(f.VAL.image);
        }
    });
    return {
        callToActionList: callToActionList,
        imageList: imageList
    };
}
function Gql_EnrichedTextBlock_Decoder_Fields_bs_handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(Gql_EnrichedTextBlock_Decoder_Fields_bs_decode(result._0.data));
    }
    Pino_bs/* logger.error */.k.error({
        "error:": result._0,
        type: "Enriched Text decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Gql_EnrichedTextBlock_Decoder_Fields_bs_Decoder = {
    decode: Gql_EnrichedTextBlock_Decoder_Fields_bs_decode,
    handleResult: Gql_EnrichedTextBlock_Decoder_Fields_bs_handleResult
};
var Gql_EnrichedTextBlock_Decoder_Fields_bs_CallToAction;
var Gql_EnrichedTextBlock_Decoder_Fields_bs_$$Image;
 /* Pino Not a pure module */ 

;// CONCATENATED MODULE: ./src/api/graphql/CmsData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


























var KontentData = {};
function getGlobalConfiguration(language, preview) {
    var variables = Gql_GlobalConfiguration_Query_bs_Query.makeVariables(language, preview, undefined);
    return js_promise/* then_ */.k(Gql_GlobalConfiguration_Decoder_bs_Decoder.handleResult, curry._6(client.rescript_query, {
        query: Gql_GlobalConfiguration_Query_bs_Query.query,
        Raw: Gql_GlobalConfiguration_Query_bs_Query.Raw,
        parse: Gql_GlobalConfiguration_Query_bs_Query.parse,
        serialize: Gql_GlobalConfiguration_Query_bs_Query.serialize,
        serializeVariables: Gql_GlobalConfiguration_Query_bs_Query.serializeVariables
    }, caml_option/* some */.G(GqlUtils_bs/* getQueryContext */.Lk(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getStoreCategory(language, preview, codename) {
    var variables = Gql__StoreCategory__Query.Query.makeVariables(language, preview, codename, undefined);
    return Js_promise.then_(Gql__StoreCategory__Decoder.Decoder.handleResult, Curry._6(Apollo.client.rescript_query, {
        query: Gql__StoreCategory__Query.Query.query,
        Raw: Gql__StoreCategory__Query.Query.Raw,
        parse: Gql__StoreCategory__Query.Query.parse,
        serialize: Gql__StoreCategory__Query.Query.serialize,
        serializeVariables: Gql__StoreCategory__Query.Query.serializeVariables
    }, Caml_option.some(GqlUtils.getQueryContext(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getLandingPage(language, preview, url) {
    var variables = Gql_LandingPage_Query_bs_Query.makeVariables(language, preview, url, undefined);
    return js_promise/* then_ */.k(Gql_LandingPage_Decoder_bs_Decoder.handleResult, curry._6(client.rescript_query, {
        query: Gql_LandingPage_Query_bs_Query.query,
        Raw: Gql_LandingPage_Query_bs_Query.Raw,
        parse: Gql_LandingPage_Query_bs_Query.parse,
        serialize: Gql_LandingPage_Query_bs_Query.serialize,
        serializeVariables: Gql_LandingPage_Query_bs_Query.serializeVariables
    }, caml_option/* some */.G(GqlUtils_bs/* getQueryContext */.Lk(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getPageContent(language, preview, url) {
    var variables = Gql_Page_Query_bs_Query.makeVariables(language, preview, url, undefined);
    return js_promise/* then_ */.k(Decoder.handleResult, curry._6(client.rescript_query, {
        query: Gql_Page_Query_bs_Query.query,
        Raw: Gql_Page_Query_bs_Query.Raw,
        parse: Gql_Page_Query_bs_Query.parse,
        serialize: Gql_Page_Query_bs_Query.serialize,
        serializeVariables: Gql_Page_Query_bs_Query.serializeVariables
    }, caml_option/* some */.G(GqlUtils_bs/* getQueryContext */.Lk(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getGiftLandingPageTheme(language, preview, themeId) {
    var variables = Gql_GiftLandingPageTheme_Query_bs_Query.makeVariables(language, preview, themeId, undefined);
    return js_promise/* then_ */.k(Gql_GiftLandingPageTheme_Decoder_bs_Decoder.handleResult, curry._6(client.rescript_query, {
        query: Gql_GiftLandingPageTheme_Query_bs_Query.query,
        Raw: Gql_GiftLandingPageTheme_Query_bs_Query.Raw,
        parse: Gql_GiftLandingPageTheme_Query_bs_Query.parse,
        serialize: Gql_GiftLandingPageTheme_Query_bs_Query.serialize,
        serializeVariables: Gql_GiftLandingPageTheme_Query_bs_Query.serializeVariables
    }, caml_option/* some */.G(GqlUtils_bs/* getQueryContext */.Lk(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getEnrichedTextBlockFields(language, preview, codenames) {
    var variables = Gql_EnrichedTextBlock_Query_Fields_bs_Query.makeVariables(language, preview, codenames, undefined);
    return js_promise/* then_ */.k(Gql_EnrichedTextBlock_Decoder_Fields_bs_Decoder.handleResult, curry._6(client.rescript_query, {
        query: Gql_EnrichedTextBlock_Query_Fields_bs_Query.query,
        Raw: Gql_EnrichedTextBlock_Query_Fields_bs_Query.Raw,
        parse: Gql_EnrichedTextBlock_Query_Fields_bs_Query.parse,
        serialize: Gql_EnrichedTextBlock_Query_Fields_bs_Query.serialize,
        serializeVariables: Gql_EnrichedTextBlock_Query_Fields_bs_Query.serializeVariables
    }, caml_option/* some */.G(GqlUtils_bs/* getQueryContext */.Lk(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function getCmsData(language, preview, isInEditorMode) {
    return js_promise/* then_ */.k(function(res) {
        var globalConfiguration = belt_Option/* flatMap */.VS(res, function(p) {
            return p.globalConfig;
        });
        var dictionaryItems = belt_Option/* flatMap */.VS(res, function(p) {
            return p.dictionaryItems;
        });
        var $$location = belt_Option/* flatMap */.VS(res, function(p) {
            return p.locations;
        });
        var giftLandingPage = belt_Option/* flatMap */.VS(res, function(p) {
            return p.giftLandingPage;
        });
        var login = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.login;
        });
        var register = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.register;
        });
        var footer = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.footerBlock;
        });
        var businessFooter = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.businessFooter;
        });
        var header = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.headerBlock;
        });
        var businessHeader = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.businessHeader;
        });
        var mobileNavMenuBlock = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(c) {
            return c.mobileNavMenuBlock;
        }), []);
        var desktopNavMenuBlock = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(c) {
            return c.desktopNavMenuBlock;
        }), []);
        var alertBanner = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.alertBanner;
        });
        var cookiePopup = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.cookiePopup;
        });
        var warnings = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(c) {
            return c.warnings;
        }), []);
        var headerLogo = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.headerLogo;
        });
        var classicLoginCtaList = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(p) {
            return p.classicLoginCtaList;
        }), []);
        var businessLoginCtaList = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(p) {
            return p.businessLoginCtaList;
        }), []);
        var searchBarPlaceholder = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(p) {
            return p.searchBarPlaceholder;
        }), "");
        var noSearchResults = belt_Option/* flatMap */.VS(globalConfiguration, function(p) {
            return p.noSearchResults;
        });
        var soldOutBadgeText = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(globalConfiguration, function(p) {
            return p.soldOutBadgeText;
        }), "");
        var kontentData = isInEditorMode ? {
            projectId: "7af951a6-2a13-004b-f0eb-a87382a5b2e7",
            languageCodename: language
        } : undefined;
        return Promise.resolve({
            location: $$location,
            footer: footer,
            businessFooter: businessFooter,
            dictionaryItems: dictionaryItems,
            header: header,
            businessHeader: businessHeader,
            mobileNavMenuBlock: mobileNavMenuBlock,
            desktopNavMenuBlock: desktopNavMenuBlock,
            alertBanner: alertBanner,
            kontentData: kontentData,
            giftLandingPage: giftLandingPage,
            login: login,
            register: register,
            cookiePopup: cookiePopup,
            warnings: warnings,
            headerLogo: headerLogo,
            classicLoginCtaList: classicLoginCtaList,
            businessLoginCtaList: businessLoginCtaList,
            searchBarPlaceholder: searchBarPlaceholder,
            noSearchResults: noSearchResults,
            soldOutBadgeText: soldOutBadgeText
        });
    }, getGlobalConfiguration(language, preview));
}
function getSkuPresentation(language, preview, codename) {
    var variables = Gql__SkuPresentation__Query.Query.makeVariables(language, preview, codename, undefined);
    return Js_promise.then_(Gql__SkuPresentation__Decoder.Decoder.handleResult, Curry._6(Apollo.client.rescript_query, {
        query: Gql__SkuPresentation__Query.Query.query,
        Raw: Gql__SkuPresentation__Query.Query.Raw,
        parse: Gql__SkuPresentation__Query.Query.parse,
        serialize: Gql__SkuPresentation__Query.Query.serialize,
        serializeVariables: Gql__SkuPresentation__Query.Query.serializeVariables
    }, Caml_option.some(GqlUtils.getQueryContext(preview)), undefined, /* NoCache */ 3, undefined, variables));
}
function querySkuPresentationList(language, preview, codenames) {
    return Curry._6(Apollo.client.rescript_query, {
        query: Gql__SkuPresentation__Query__List.Query.query,
        Raw: Gql__SkuPresentation__Query__List.Query.Raw,
        parse: Gql__SkuPresentation__Query__List.Query.parse,
        serialize: Gql__SkuPresentation__Query__List.Query.serialize,
        serializeVariables: Gql__SkuPresentation__Query__List.Query.serializeVariables
    }, Caml_option.some(GqlUtils.getQueryContext(preview)), undefined, /* NoCache */ 3, undefined, Gql__SkuPresentation__Query__List.Query.makeVariables(language, preview, codenames, undefined));
}
function getSkuPresentationList(language, preview, codenames) {
    if (codenames.length <= 35) {
        return Js_promise.then_(Gql__SkuPresentation__Decoder__List.Decoder.handleResult, querySkuPresentationList(language, preview, codenames));
    }
    var halfCodenameLength = Js_math.ceil(codenames.length / 2 | 0);
    return Js_promise.then_(function(result) {
        return Js_promise.$$catch(function(error) {
            console.log(error);
            return Promise.resolve([]);
        }, Js_promise.then_(function(listResult) {
            return Promise.resolve(Js_array.concat(Js_option.getExn(listResult[0]), Js_option.getExn(listResult[1])));
        }, Promise.all([
            Gql__SkuPresentation__Decoder__List.Decoder.handleResult(result[0]),
            Gql__SkuPresentation__Decoder__List.Decoder.handleResult(result[1])
        ])));
    }, Promise.all([
        querySkuPresentationList(language, preview, Belt_Array.slice(codenames, 0, halfCodenameLength)),
        querySkuPresentationList(language, preview, Belt_Array.slice(codenames, -halfCodenameLength | 0, codenames.length - halfCodenameLength | 0))
    ]));
}
 /* Apollo Not a pure module */ 


/***/ }),

/***/ 44623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$d": function() { return /* binding */ emptyDictionaryEntry; },
  "U2": function() { return /* binding */ Gql_DictionaryItems_Decoder_bs_get; }
});

// UNUSED EXPORTS: DictionaryItem

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./src/components/library/SmartLink.bs.js
var SmartLink_bs = __webpack_require__(35705);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
;// CONCATENATED MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder__DictionaryItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "DictionaryItemContentType") {
        return;
    }
    var d = content.VAL;
    var id = d.system.id;
    var codename = d.system.codename;
    var value = belt_Option/* flatMap */.VS(d.value, function(v) {
        return v.value;
    });
    var smartLink = {
        itemId: id,
        codename: codename
    };
    return belt_Option/* map */.UI(value, function(value) {
        return {
            codename: codename,
            value: value,
            smartLink: smartLink
        };
    });
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var emptyDictionaryEntry = {
    value: "",
    smartLink: SmartLink_bs/* emptySmartLink */.R
};
function Gql_DictionaryItems_Decoder_bs_get(content) {
    var items = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(content, get), function(v) {
        return [
            v.codename,
            {
                value: v.value,
                smartLink: v.smartLink
            }
        ];
    });
    var map = js_dict/* fromArray */.nI(items);
    return {
        app_copyright: js_dict/* get */.U2(map, "app_copyright"),
        app_cta_login: js_dict/* get */.U2(map, "app_cta_login"),
        app_cta_signup: js_dict/* get */.U2(map, "app_cta_signup"),
        business_cta_signup: js_dict/* get */.U2(map, "business_cta_signup"),
        business_cta_login: js_dict/* get */.U2(map, "business_cta_login"),
        app_menu_hi: js_dict/* get */.U2(map, "app_menu_hi"),
        app_menu_myaccount: js_dict/* get */.U2(map, "app_menu_myaccount"),
        app_menu_mygifts: js_dict/* get */.U2(map, "app_menu_mygifts"),
        app_menu_mywallet: js_dict/* get */.U2(map, "app_menu_mywallet"),
        app_menu_signout: js_dict/* get */.U2(map, "app_menu_signout"),
        app_prezzeeabn: js_dict/* get */.U2(map, "app_prezzeeabn"),
        app_yourcurrentshoppingregion: js_dict/* get */.U2(map, "app_yourcurrentshoppingregion")
    };
}
var DictionaryItem;
 /* No side effect */ 


/***/ }),

/***/ 5290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ get; }
/* harmony export */ });
/* unused harmony export parseRichTextData */
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93717);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
/* harmony import */ var _utils_parseRichTextData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50771);
// Generated by ReScript, PLEASE EDIT WITH CARE




function parseRichTextData(prim) {
    return ParseRichTextData.parseRichTextData(prim);
}
function get(c) {
    var content = _utils_parseRichTextData__WEBPACK_IMPORTED_MODULE_1__/* .parseRichTextData */ .c(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.content, function(f) {
        return f.value;
    }), ""));
    var width = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .mapWithDefault */ .k7(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.width, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), 0), function(c) {
        return c.codename;
    }), "n12columns", function(str) {
        return str;
    });
    var alignment = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .mapWithDefault */ .k7(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.alignment, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), 0), function(c) {
        return c.codename;
    }), "left", function(str) {
        return str;
    });
    var distance_top = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.distance_top, function(c) {
        return c.value;
    });
    var distance_bottom = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(c.distance_bottom, function(c) {
        return c.value;
    });
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        smartLink: smartLink,
        content: content,
        width: width,
        alignment: alignment,
        distance_top: distance_top,
        distance_bottom: distance_bottom
    };
}
 /* ../../../utils/parseRichTextData Not a pure module */ 


/***/ }),

/***/ 58259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ get; }
/* harmony export */ });
/* unused harmony export decodeFontAwesomeStyle */
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93717);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72491);
// Generated by ReScript, PLEASE EDIT WITH CARE



function decodeFontAwesomeStyle(style) {
    switch(style){
        case "brands_style__fab_":
            return "fab";
        case "duotone_style__fad_":
            return "fad";
        case "light_style__fal_":
            return "fal";
        case "regular_style__far_":
            return "far";
        case "solid_style__fas_":
            return "fas";
        default:
            return style;
    }
}
function get(content) {
    var icon = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VS(content.font_awesome_icon_name, function(c) {
        return c.value;
    }), "");
    var style = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .flatMap */ .VS(content.style, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), 0), function(c) {
        return c.codename;
    }), "");
    return {
        icon: icon,
        style: decodeFontAwesomeStyle(style)
    };
}
 /* No side effect */ 


/***/ }),

/***/ 91842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wt": function() { return /* binding */ emptyFooter; },
  "U2": function() { return /* binding */ Gql_Footer_Decoder_FooterContainer_bs_get; }
});

// UNUSED EXPORTS: AppStore, LinkColumn

// EXTERNAL MODULE: ./src/api/graphql/GqlUtils.bs.js
var GqlUtils_bs = __webpack_require__(93717);
// EXTERNAL MODULE: ./src/components/library/SmartLink.bs.js
var SmartLink_bs = __webpack_require__(35705);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/api/graphql/CallToAction/Gql__CallToAction__Decoder.bs.js
var Gql_CallToAction_Decoder_bs = __webpack_require__(93875);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Theme.bs.js
var Footer_Theme_bs = __webpack_require__(38715);
;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__AppStore.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "AppStoreItemContentType") {
        return;
    }
    var c = content.VAL;
    var app_store_name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_name, function(v) {
        return v.value;
    }), "");
    var app_store_download_link = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_download_link, function(v) {
        return v.value;
    }), "");
    var value = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.app_store_asset, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(value, function(f) {
        return f.height;
    }), 0);
    var result = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        app_store_name: app_store_name,
        app_store_download_link: app_store_download_link,
        app_store_image: result,
        smartLink: smartLink
    };
}
var $$Image;
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/graphql/Image/Gql__Image__Decoder.bs.js
var Gql_Image_Decoder_bs = __webpack_require__(46271);
// EXTERNAL MODULE: ./src/api/graphql/FontAwesomeIcon/Gql__FontAwesomeIcon__Decoder.bs.js
var Gql_FontAwesomeIcon_Decoder_bs = __webpack_require__(58259);
;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__LinkItemIcon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function Gql_Footer_Decoder_LinkItemIcon_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    var variant = content.NAME;
    if (variant === "ImageContentType") {
        return {
            TAG: /* Image */ 1,
            _0: Gql_Image_Decoder_bs/* get */.U(content.VAL.image)
        };
    } else if (variant === "FontAwesomeContentType") {
        return {
            TAG: /* FontAwesomeIcon */ 0,
            _0: Gql_FontAwesomeIcon_Decoder_bs/* get */.U(content.VAL.fontAwesomeIcon)
        };
    } else {
        return;
    }
}
var FontAwesomeIconDecoder;
var ImageDecoder;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__LinkItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_Footer_Decoder_LinkItem_bs_get(linkItem) {
    var link_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(linkItem.link_text, function(c) {
        return c.value;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(linkItem.url, function(c) {
        return c.value;
    }), "");
    var open_in_new_window = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(linkItem.open_in_new_window, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), false, function(str) {
        if (str === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var icon = belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(linkItem.links, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), Gql_Footer_Decoder_LinkItemIcon_bs_get);
    var smartLink_itemId = linkItem.system.id;
    var smartLink_codename = linkItem.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        link_text: link_text,
        url: url,
        open_in_new_window: open_in_new_window,
        icon: icon,
        smartLink: smartLink
    };
}
var LinkItemIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__MailtoLink.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Footer_Decoder_MailtoLink_bs_get(mailItem) {
    var smartLink_itemId = mailItem.system.id;
    var smartLink_codename = mailItem.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var link_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(mailItem.link_title, function(c) {
        return c.value;
    }), "");
    var email_address = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(mailItem.email_address, function(c) {
        return c.value;
    }), "");
    return {
        link_text: link_text,
        email_address: email_address,
        smartLink: smartLink
    };
}
var Gql_Footer_Decoder_MailtoLink_bs_LinkItemIcon;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__OnetrustCookieSettingButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function Gql_Footer_Decoder_OnetrustCookieSettingButton_bs_get(linkItem) {
    var text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(linkItem.text, function(c) {
        return c.value;
    }), "");
    var smartLink_itemId = linkItem.system.id;
    var smartLink_codename = linkItem.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        text: text,
        smartLink: smartLink
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__Links.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function Gql_Footer_Decoder_Links_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    var variant = content.NAME;
    if (variant === "LinkItemContentType") {
        return {
            NAME: "LinkItemContentType",
            VAL: Gql_Footer_Decoder_LinkItem_bs_get(content.VAL)
        };
    } else if (variant === "MailtoLinkContentType") {
        return {
            NAME: "MailtoLinkContentType",
            VAL: Gql_Footer_Decoder_MailtoLink_bs_get(content.VAL)
        };
    } else if (variant === "OnetrustCookieSettingButtonContentType") {
        return {
            NAME: "OnetrustCookieSettingButtonContentType",
            VAL: Gql_Footer_Decoder_OnetrustCookieSettingButton_bs_get(content.VAL)
        };
    } else {
        return;
    }
}
var LinkItem;
var MailtoLink;
var Gql_Footer_Decoder_Links_bs_LinkItemIcon;
var CookieSettingButton;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__LinkColumn.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Gql_Footer_Decoder_LinkColumn_bs_get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "LinkColumnContentType") {
        return;
    }
    var column = content.VAL;
    var title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(column.title, function(c) {
        return c.value;
    }), "");
    var links = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(column.links, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_Footer_Decoder_Links_bs_get);
    var smartLink_itemId = column.system.id;
    var smartLink_codename = column.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        title: title,
        links: links,
        smartLink: smartLink
    };
}
var Links;
var Gql_Footer_Decoder_LinkColumn_bs_LinkItem;
var Gql_Footer_Decoder_LinkColumn_bs_MailtoLink;
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/Footer/Gql__Footer__Decoder__FooterContainer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var emptyFooter_link_columns = [];
var emptyFooter_subscribe_cta_style = Gql_CallToAction_Decoder_bs/* parse_cta_style */.vn("primary_regular");
var emptyFooter_app_stores_container = [];
var emptyFooter_theme = Footer_Theme_bs.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
var emptyFooter = {
    link_columns: emptyFooter_link_columns,
    subscribe_title: "",
    subscribe_description: "",
    subscribe_helper_text: "",
    subscribe_cta: "",
    subscribe_cta_style: emptyFooter_subscribe_cta_style,
    region_selector_text: "",
    app_store_title: "",
    app_stores_container: emptyFooter_app_stores_container,
    smartLink: SmartLink_bs/* emptySmartLink */.R,
    theme: emptyFooter_theme,
    disclaimer_level_1: "",
    disclaimer_level_2: ""
};
function Gql_Footer_Decoder_FooterContainer_bs_get(footer) {
    var link_columns = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.link_columns, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), Gql_Footer_Decoder_LinkColumn_bs_get);
    var subscribe_title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.subscribe_title, function(c) {
        return c.value;
    }), "");
    var subscribe_helper_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.subscribe_helper_text, function(c) {
        return c.value;
    }), "");
    var subscribe_cta = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.subscribe_cta, function(c) {
        return c.value;
    }), "");
    var subscribe_cta_style = Gql_CallToAction_Decoder_bs/* parse_cta_style */.vn(belt_Option/* getWithDefault */.tj(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.cta_style__style, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(v) {
        return v.codename;
    }), 0), "primary_regular"));
    var subscribe_description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.subscribe_description, function(c) {
        return c.value;
    }), "");
    var region_selector_text = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.region_selector_text, function(c) {
        return c.value;
    }), "");
    var app_store_title = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.app_store_title, function(c) {
        return c.value;
    }), "");
    var app_stores_container = belt_Array/* keepMap */.fe(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.app_stores_container, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), get);
    var smartLink_itemId = footer.system.id;
    var smartLink_codename = footer.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var background_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.background_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var heading_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.heading_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var body_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.body_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var body_hover_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.body_hover_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var icon_background_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.icon_background_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var icon_hover_background_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.icon_hover_background_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var icon_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.icon_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var icon_hover_color = belt_Option/* map */.UI(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(footer.icon_hover_colour, function(c) {
        return c.value;
    }), GqlUtils_bs/* ifNotEmpty */.Zl), function(c) {
        return {
            NAME: "hex",
            VAL: c
        };
    });
    var disclaimer_level_1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.footer_disclaimer_level_1, function(c) {
        return c.value;
    }), "");
    var disclaimer_level_2 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(footer.footer_disclaimer_level_2, function(c) {
        return c.value;
    }), "");
    var theme = Footer_Theme_bs.t(background_color, heading_color, body_color, body_hover_color, icon_background_color, icon_hover_background_color, icon_color, icon_hover_color, undefined);
    return {
        link_columns: link_columns,
        subscribe_title: subscribe_title,
        subscribe_description: subscribe_description,
        subscribe_helper_text: subscribe_helper_text,
        subscribe_cta: subscribe_cta,
        subscribe_cta_style: subscribe_cta_style,
        region_selector_text: region_selector_text,
        app_store_title: app_store_title,
        app_stores_container: app_stores_container,
        smartLink: smartLink,
        theme: theme,
        disclaimer_level_1: disclaimer_level_1,
        disclaimer_level_2: disclaimer_level_2
    };
}
var LinkColumn;
var AppStore;
 /* emptyFooter Not a pure module */ 


/***/ }),

/***/ 93717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lk": function() { return /* binding */ getQueryContext; },
/* harmony export */   "Zl": function() { return /* binding */ ifNotEmpty; },
/* harmony export */   "id": function() { return /* binding */ id; }
/* harmony export */ });
/* unused harmony export Utils */
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96533);
// Generated by ReScript, PLEASE EDIT WITH CARE

function id(x) {
    return x;
}
function ifNotEmpty(value) {
    if (value === "") {
        return;
    } else {
        return value;
    }
}
function getQueryContext(preview) {
    return JSON.parse(preview ? ' {"headers":{"x-preview-token":1}} ' : " {} ");
}
function flatMap(arr, fn) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .concatMany */ .ID(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI(arr, fn));
}
var $$Array = {
    flatMap: flatMap
};
var Utils = {
    $$Array: $$Array
};
 /* No side effect */ 


/***/ }),

/***/ 46271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ emptyImage; },
/* harmony export */   "U": function() { return /* binding */ get; }
/* harmony export */ });
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93717);
/* harmony import */ var _components_library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35705);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
// Generated by ReScript, PLEASE EDIT WITH CARE




var emptyImage = {
    name: "",
    description: "",
    url: "",
    width: 0,
    height: 0,
    smartLink: _components_library_SmartLink_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .emptySmartLink */ .R,
    maxWidth: ""
};
function get(content) {
    var maxWidth = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.width, function(w) {
        return w.value;
    }), "");
    var file = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.file, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), 0);
    var name = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(file, function(f) {
        return f.name;
    }), "");
    var description = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(file, function(f) {
        return f.description;
    }), "");
    var url = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(file, function(f) {
        return f.url;
    }), "");
    var width = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(file, function(f) {
        return f.width;
    }), 0);
    var height = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(file, function(f) {
        return f.height;
    }), 0);
    var smartLink_itemId = content.system.id;
    var smartLink_codename = content.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    return {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height,
        smartLink: smartLink,
        maxWidth: maxWidth
    };
}
 /* No side effect */ 


/***/ }),

/***/ 39994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ get; }
/* harmony export */ });
/* unused harmony export $$Image */
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93717);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72491);
/* harmony import */ var _Image_Gql_Image_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46271);
// Generated by ReScript, PLEASE EDIT WITH CARE




function get(content) {
    var seoMetaBasicTitle = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__basic__title, function(c) {
        return c.value;
    }), "");
    var seoMetaBasicDescription = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__basic__description, function(c) {
        return c.value;
    }), "");
    var seoMetaOgTitle = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__og__title, function(c) {
        return c.value;
    }), "");
    var seoMetaOgDescription = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__og__description, function(c) {
        return c.value;
    }), "");
    var seoMetaOgImageAsset = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__og__image_asset, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), function(x) {
        if (typeof x === "object" && x.NAME === "ImageContentType") {
            return _Image_Gql_Image_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U(x.VAL.image);
        }
    }), 0);
    var seoMetaOgType = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__og__type, function(c) {
        return c.value;
    }), "");
    var seoMetaOgUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__og__url, function(c) {
        return c.value;
    }), "");
    var seoMetaTwTitle = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__tw__title, function(c) {
        return c.value;
    }), "");
    var seoMetaTwDescription = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__tw__description, function(c) {
        return c.value;
    }), "");
    var seoMetaTwImageAsset = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__tw__image_asset, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_0__.id), function(x) {
        if (typeof x === "object" && x.NAME === "ImageContentType") {
            return _Image_Gql_Image_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .get */ .U(x.VAL.image);
        }
    }), 0);
    var seoMetaTwImageAssetUrl = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_2__/* .flatMap */ .VS(content.seo_meta__tw__image_asset_url, function(c) {
        return c.value;
    }), "");
    return {
        seoMetaBasicTitle: seoMetaBasicTitle,
        seoMetaBasicDescription: seoMetaBasicDescription,
        seoMetaOgTitle: seoMetaOgTitle,
        seoMetaOgDescription: seoMetaOgDescription,
        seoMetaOgImageAsset: seoMetaOgImageAsset,
        seoMetaOgType: seoMetaOgType,
        seoMetaOgUrl: seoMetaOgUrl,
        seoMetaTwTitle: seoMetaTwTitle,
        seoMetaTwDescription: seoMetaTwDescription,
        seoMetaTwImageAsset: seoMetaTwImageAsset,
        seoMetaTwImageAssetUrl: seoMetaTwImageAssetUrl
    };
}
var $$Image;
 /* No side effect */ 


/***/ }),

/***/ 1651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports FragmentDecoder, SkuPresentationList, Decoder */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91574);
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93717);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25400);
/* harmony import */ var _Gql_SkuPresentation_Fragment_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22775);
// Generated by ReScript, PLEASE EDIT WITH CARE







function get(content) {
    if (typeof content === "object" && content.NAME === "SkuPresentationContentType") {
        return _Gql_SkuPresentation_Fragment_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .decode */ .Jx(content.VAL.skuPresentationFragment);
    }
}
var SkuPresentationList = {
    get: get
};
function decode(gqlQueryResult) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_4__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_4__/* .map */ .UI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_4__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(gqlQueryResult.itemsByType, []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id), get), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id);
}
function handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(decode(result._0.data));
    }
    _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error({
        err: result._0,
        type: "SKU Presentation List decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Decoder = {
    decode: decode,
    handleResult: handleResult
};
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(data == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
var FragmentDecoder;
 /* Pino Not a pure module */ 


/***/ }),

/***/ 22775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jx": function() { return /* binding */ decode; }
});

// UNUSED EXPORTS: SeoMetaBlock, SkuTheme, emptyTaxonomy

// EXTERNAL MODULE: ./src/api/graphql/GqlUtils.bs.js
var GqlUtils_bs = __webpack_require__(93717);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/api/graphql/SeoMetaContentType/Gql__SeoMeta__Decoder.bs.js
var Gql_SeoMeta_Decoder_bs = __webpack_require__(39994);
;// CONCATENATED MODULE: ./src/api/graphql/SkuTheme/Gql__SkuTheme__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function get(c) {
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var code = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.code, function(w) {
        return w.value;
    }), "");
    var file = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.image, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0);
    var name = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.name;
    }), "");
    var description = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.description;
    }), "");
    var url = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.url;
    }), "");
    var width = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.width;
    }), 0);
    var height = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(file, function(f) {
        return f.height;
    }), 0);
    var image = {
        name: name,
        description: description,
        url: url,
        width: width,
        height: height
    };
    var key_colour = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.key_colour, function(f) {
        return f.value;
    }), "");
    var description$1 = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(c.text_colour, function(f) {
        return f.value;
    }), "");
    return {
        code: code,
        key_colour: key_colour,
        description: description$1,
        smartLink: smartLink,
        image: image
    };
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/graphql/SkuPresentation/Gql__SkuPresentation__Fragment__Decoder.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var emptyTaxonomy = {
    name: "",
    value: {
        name: "",
        codename: ""
    },
    taxonomyGroup: ""
};
function decode(f) {
    var seo_meta = belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.seo_meta, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "SeoMetaContentType") {
            return {
                NAME: "SeoMetaBlock",
                VAL: Gql_SeoMeta_Decoder_bs/* get */.U(f.VAL.seoMetaBlock)
            };
        }
    }), GqlUtils_bs.id), 0);
    var soldOut = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Array/* get */.U2(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.sold_out, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), 0), function(c) {
        return c.codename;
    }), false, function(str) {
        if (str === "yes") {
            return true;
        } else {
            return false;
        }
    });
    var codename = f.system.codename;
    var themes = belt_Array/* map */.UI(belt_Array/* keepMap */.fe(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.themes, function(c) {
        return c.value;
    }), []), GqlUtils_bs.id), function(f) {
        if (typeof f === "object" && f.NAME === "SkuThemeContentType") {
            return get(f.VAL.skuThemeFragment);
        }
    });
    var audience = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.audience, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var interest = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.interest, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var occasion = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.occasion, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var locationAu = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.location_au, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var locationNz = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.location___nz, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var locationUk = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.location___uk, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    var locationUs = belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(f.location___us, function(c) {
        return c.value;
    }), []), function(f) {
        if (f !== undefined) {
            return {
                name: f.name,
                value: {
                    name: f.name,
                    codename: f.codename
                },
                taxonomyGroup: ""
            };
        } else {
            return emptyTaxonomy;
        }
    });
    return {
        codename: codename,
        seo_meta: seo_meta,
        soldOut: soldOut,
        themes: themes,
        audience: audience,
        interest: interest,
        occasion: occasion,
        locationAu: locationAu,
        locationNz: locationNz,
        locationUk: locationUk,
        locationUs: locationUs
    };
}
var SeoMetaBlock;
var SkuTheme;
 /* No side effect */ 


/***/ }),

/***/ 29160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports SeoMetaBlock, SeoMetaMapper, StoreCategory, Decoder */
/* harmony import */ var _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57687);
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91574);
/* harmony import */ var _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93717);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25400);
/* harmony import */ var _SeoMetaContentType_Gql_SeoMeta_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39994);
/* harmony import */ var _EnrichedTextBlock_Gql_EnrichedTextBlock_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5290);
// Generated by ReScript, PLEASE EDIT WITH CARE








function seoMetaBlockSwitch(content) {
    if (typeof content === "object" && content.NAME === "SeoMetaContentType") {
        return {
            NAME: "SeoMetaBlock",
            VAL: _SeoMetaContentType_Gql_SeoMeta_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .get */ .U(content.VAL.seoMetaBlock)
        };
    }
}
var SeoMetaMapper = {
    seoMetaBlockSwitch: seoMetaBlockSwitch
};
function get(content) {
    if (typeof content !== "object") {
        return;
    }
    if (content.NAME !== "StoreCategoryContentType") {
        return;
    }
    var c = content.VAL;
    var smartLink_itemId = c.system.id;
    var smartLink_codename = c.system.codename;
    var smartLink = {
        itemId: smartLink_itemId,
        codename: smartLink_codename
    };
    var top_content = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .flatMap */ .VS(c.page_top_content, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id), function(f) {
        if (typeof f === "object" && f.NAME === "EnrichedTextBlockContentType") {
            return _EnrichedTextBlock_Gql_EnrichedTextBlock_Decoder_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .get */ .U(f.VAL.enrichedTextBlock);
        }
    }), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id), 0);
    var seo_meta = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .keepMap */ .fe(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .flatMap */ .VS(c.seo_meta, function(c) {
        return c.value;
    }), []), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id), seoMetaBlockSwitch), 0);
    return {
        smartLink: smartLink,
        top_content: top_content,
        seo_meta: seo_meta
    };
}
var StoreCategory = {
    get: get
};
function decode(gqlQueryResult) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .flatMap */ .VS(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .getWithDefault */ .tj(gqlQueryResult.itemsByType, []), 0), _GqlUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__.id), get);
}
function handleResult(result) {
    if (result.TAG === /* Ok */ 0) {
        return Promise.resolve(decode(result._0.data));
    }
    _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error({
        err: result._0,
        type: "Store Category decoder"
    }, "Graphql errors");
    return Promise.resolve(undefined);
}
var Decoder = {
    decode: decode,
    handleResult: handleResult
};
function parse(data) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(data === null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_7__/* .some */ .G(data), _glennsl_bs_json_src_Json_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .parseOrRaise */ .YF);
}
var SeoMetaBlock;
 /* Pino Not a pure module */ 


/***/ }),

/***/ 19700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var common_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50132);



/**
 * A middleware function for handling generic errors in queries.
 * @param response HTTP Response object that needs error handling.
 * @returns Throws new error if passed HTTP response failed else returns response.
 */ var handleErrors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(response) {
        var isJsonContentType, _, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isJsonContentType = response.headers.get("Content-Type") === "application/json";
                    _ = response.status;
                    switch(_){
                        case 200:
                            return [
                                3,
                                1
                            ];
                        case 201:
                            return [
                                3,
                                1
                            ];
                        case 202:
                            return [
                                3,
                                1
                            ];
                        case 204:
                            return [
                                3,
                                1
                            ];
                        case 401:
                            return [
                                3,
                                2
                            ];
                        case 460:
                            return [
                                3,
                                5
                            ];
                        case 461:
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        7
                    ];
                case 1:
                    if (isJsonContentType) {
                        return [
                            2,
                            response.json()
                        ];
                    } else {
                        return [
                            2,
                            response
                        ];
                    }
                    _state.label = 2;
                case 2:
                    if (!isJsonContentType) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    err = _state.sent();
                    throw new Error(err.detail);
                case 4:
                    throw new Error("Unauthorized Error");
                case 5:
                    throw new Error("Server MFA Required Error");
                case 6:
                    throw new Error(common_constants__WEBPACK_IMPORTED_MODULE_0__/* .SERVER_FRAUD_ERROR */ .g5);
                case 7:
                    // Server returns custom errors through error codes 400 - 500 via json.detail
                    if (response.status >= 400 && response.status < 500 && isJsonContentType) {
                        return [
                            2,
                            response.json().then(function(json) {
                                // Check if error type over detail message
                                if (json.error_type) {
                                    throw new Error(json.error_type);
                                } else if (json.detail) {
                                    throw new Error(json.detail);
                                }
                                throw new Error("Could not decode error from the server");
                            })
                        ];
                    } else {
                        throw new Error("Network Error " + response.status);
                    }
                    _state.label = 8;
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleErrors(response) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (handleErrors);


/***/ }),

/***/ 60693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "As": function() { return /* binding */ helpers_createDeliveryClient; },
  "hG": function() { return /* binding */ createRequest; },
  "qB": function() { return /* binding */ getSessionIdToken; }
});

// UNUSED EXPORTS: getUrlFromPath

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/url.helper.js
var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    /**
   * Adds query parameters to given url
   * @param url Url to which options will be added
   * @param options Query parameters to add
   */
    UrlHelper.prototype.addOptionsToUrl = function (url, options) {
        if (options) {
            options.forEach(function (filter) {
                if (url.indexOf('?') > -1) {
                    url += '&';
                }
                else {
                    url += '?';
                }
                url += filter.getParam();
            });
        }
        return url;
    };
    return UrlHelper;
}());

var urlHelper = new UrlHelper();
//# sourceMappingURL=url.helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/header.helper.js
var HeaderHelper = /** @class */ (function () {
    function HeaderHelper() {
        /**
        * Header name for SDK usage
        */
        this.sdkVersionHeader = 'X-KC-SDKID';
    }
    /**
    * Header identifying SDK type & version for internal purposes of Kentico
    */
    HeaderHelper.prototype.getSdkIdHeader = function (info) {
        return {
            header: this.sdkVersionHeader,
            value: "".concat(info.host, ";").concat(info.name, ";").concat(info.version)
        };
    };
    return HeaderHelper;
}());

var headerHelper = new HeaderHelper();
//# sourceMappingURL=header.helper.js.map
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/enum.helper.js

var EnumHelper = /** @class */ (function () {
    function EnumHelper() {
    }
    EnumHelper.prototype.getAllNames = function (T) {
        var enumNames = [];
        for (var key in T) {
            if (T.hasOwnProperty(key)) {
                enumNames.push(key);
            }
        }
        return enumNames;
    };
    EnumHelper.prototype.getAllValues = function (T) {
        var allEnumValues = Object.keys(T).map(function (key) { return T[key]; });
        return allEnumValues;
    };
    EnumHelper.prototype.getEnumFromValue = function (T, value) {
        try {
            if (!value) {
                return undefined;
            }
            // we can map back from index number directly
            if (this.isNumeric(value)) {
                return T[value];
            }
            // for strings, we need to compare each value separately
            var allEnumValues = this.getAllValues(T);
            var result = allEnumValues.find(function (m) { return m.toLowerCase() === value.toString().toLowerCase(); });
            if (!result) {
                return undefined;
            }
            return result;
        }
        catch (err) {
            return undefined;
        }
    };
    EnumHelper.prototype.getEnumFromName = function (T, name) {
        var e_1, _a;
        var allNames = this.getAllNames(T);
        try {
            for (var allNames_1 = (0,tslib_es6.__values)(allNames), allNames_1_1 = allNames_1.next(); !allNames_1_1.done; allNames_1_1 = allNames_1.next()) {
                var enumName = allNames_1_1.value;
                if (enumName.toLowerCase() === name.toLowerCase()) {
                    return T[enumName];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (allNames_1_1 && !allNames_1_1.done && (_a = allNames_1.return)) _a.call(allNames_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return undefined;
    };
    EnumHelper.prototype.isNumeric = function (value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    };
    return EnumHelper;
}());

var enumHelper = new EnumHelper();
//# sourceMappingURL=enum.helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/headers-helper.js

function extractHeadersFromAxiosResponse(response) {
    var e_1, _a;
    var headers = [];
    try {
        for (var _b = (0,tslib_es6.__values)(Object.keys(response.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var headerKey = _c.value;
            headers.push({
                header: headerKey,
                value: response.headers[headerKey]
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return headers;
}
//# sourceMappingURL=headers-helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/retry-helper.js

var RetryHelper = /** @class */ (function () {
    function RetryHelper() {
        var _this = this;
        this.requestCancelledMessagePrefix = 'Request cancelled';
        this.retryAfterHeaderName = 'Retry-After';
        this.defaultRetryStatusCodes = [408, 429, 500, 502, 503, 504];
        this.defaultRetryStrategy = {
            addJitter: true,
            deltaBackoffMs: 1000,
            maxAttempts: 5,
            canRetryError: function (error) { return _this.canRetryErrorDefault(error); }
        };
    }
    RetryHelper.prototype.getRetryErrorResult = function (data) {
        var _a, _b, _c;
        if (data.error && data.error.message) {
            if (data.error.message.startsWith(this.requestCancelledMessagePrefix)) {
                // request was cancelled by user, do not retry it
                return {
                    canRetry: false,
                    retryInMs: 0,
                    maxRetries: 0
                };
            }
        }
        var canRetryError = data.retryStrategy.canRetryError
            ? data.retryStrategy.canRetryError(data.error)
            : this.defaultRetryStrategy.canRetryError(data.error);
        if (!canRetryError) {
            // request cannot be retried
            return {
                canRetry: false,
                retryInMs: 0,
                maxRetries: 0
            };
        }
        var maxRetries = ((_a = data.retryStrategy.maxAttempts) !== null && _a !== void 0 ? _a : this.defaultRetryStrategy.maxAttempts);
        var maxRetriesReached = data.retryAttempt >= maxRetries;
        if (maxRetriesReached) {
            // request cannot be retried anymore due to maximum attempts
            return {
                canRetry: false,
                retryInMs: 0,
                maxRetries: maxRetries
            };
        }
        // get wait time
        var retryResult = this.tryGetRetryAfterInMsFromError(data.error);
        if (retryResult) {
            // retry after header was provided
            return {
                canRetry: true,
                retryInMs: retryResult,
                maxRetries: maxRetries
            };
        }
        // wait time was not provided in header
        var waitTimeMs = this.getNextWaitTimeMs((_b = data.retryStrategy.addJitter) !== null && _b !== void 0 ? _b : this.defaultRetryStrategy.addJitter, (_c = data.retryStrategy.deltaBackoffMs) !== null && _c !== void 0 ? _c : this.defaultRetryStrategy.deltaBackoffMs, data.retryAttempt);
        return {
            canRetry: true,
            retryInMs: waitTimeMs,
            maxRetries: maxRetries
        };
    };
    RetryHelper.prototype.getRetryStrategyFromStrategyOptions = function (retryOptions) {
        if (!retryOptions) {
            return this.defaultRetryStrategy;
        }
        return retryOptions;
    };
    RetryHelper.prototype.canRetryInTime = function (startTime, maxCumulativeWaitTimeMs) {
        var start = startTime.getTime();
        var now = new Date().getTime();
        var differenceInMs = now - start;
        return {
            canRetry: differenceInMs < maxCumulativeWaitTimeMs,
            differenceInMs: differenceInMs
        };
    };
    RetryHelper.prototype.getNextWaitTimeMs = function (addJitter, deltaBackoffMs, retryAttempts) {
        if (!addJitter) {
            return deltaBackoffMs * Math.pow(2, retryAttempts);
        }
        var from = 0.8 * deltaBackoffMs;
        var to = 1.2 * deltaBackoffMs * Math.pow(2, retryAttempts);
        return this.randomNumberFromInterval(from, to);
    };
    RetryHelper.prototype.canRetryErrorDefault = function (error) {
        var axiosError = this.tryGetAxiosError(error);
        if (!axiosError) {
            // by default non-axios errors are not retried
            return false;
        }
        var statusCode = this.getStatusCodeFromError(error);
        var canRetryStatusCode = this.canRetryStatusCode(statusCode, this.defaultRetryStatusCodes);
        if (canRetryStatusCode) {
            return true;
        }
        return false;
    };
    RetryHelper.prototype.tryGetRetryAfterInMsFromError = function (error) {
        var _this = this;
        var axiosError = this.tryGetAxiosError(error);
        if (!axiosError || !axiosError.response) {
            return undefined;
        }
        var headers = extractHeadersFromAxiosResponse(axiosError.response);
        var retryValueHeader = headers.find(function (m) { return m.header.toLowerCase() === _this.retryAfterHeaderName.toLowerCase(); });
        if (!retryValueHeader) {
            return undefined;
        }
        var retryInSeconds = +retryValueHeader.value;
        return retryInSeconds * 1000;
    };
    RetryHelper.prototype.canRetryStatusCode = function (statusCode, useRetryForResponseCodes) {
        return useRetryForResponseCodes.includes(statusCode);
    };
    RetryHelper.prototype.getStatusCodeFromError = function (error) {
        var axiosError = this.tryGetAxiosError(error);
        if (!axiosError || !axiosError.response) {
            return 0;
        }
        return axiosError.response.status;
    };
    RetryHelper.prototype.tryGetAxiosError = function (error) {
        if (!error) {
            return undefined;
        }
        if (error.isAxiosError) {
            return error;
        }
        var originalError = error.originalError;
        if (originalError && originalError.isAxiosError) {
            return originalError;
        }
        return undefined;
    };
    /**
     * min and max included
     */
    RetryHelper.prototype.randomNumberFromInterval = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    return RetryHelper;
}());

var retryHelper = new RetryHelper();
//# sourceMappingURL=retry-helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/helpers/index.js





//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/models/parameters.js
var parameters_Parameters;
(function (Parameters) {
    var CustomParameter = /** @class */ (function () {
        /**
         * Custom parameter
         * @constructor
         * @param {string} name - Name of the parameter
         * @param {string} value - Value of the parameter
         */
        function CustomParameter(name, value) {
            this.name = name;
            this.value = value;
            if (!name) {
                throw Error("Name of the custom parameter is not specified");
            }
        }
        CustomParameter.prototype.getParam = function () {
            return this.name;
        };
        CustomParameter.prototype.getParamValue = function () {
            return this.value;
        };
        return CustomParameter;
    }());
    Parameters.CustomParameter = CustomParameter;
})(parameters_Parameters || (parameters_Parameters = {}));
//# sourceMappingURL=parameters.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/models/index.js



//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@kentico/kontent-core/node_modules/axios/index.js
var axios = __webpack_require__(18225);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/http/http.debugger.js
var HttpDebugger = /** @class */ (function () {
    function HttpDebugger() {
    }
    /*
    Called when http request is started
    */
    HttpDebugger.prototype.debugStartHttpRequest = function () {
    };
    /*
    Called when http request is resolved
    */
    HttpDebugger.prototype.debugSuccessHttpRequest = function () {
    };
    /*
    Called when http request is being retried
    */
    HttpDebugger.prototype.debugRetryHttpRequest = function () {
    };
    return HttpDebugger;
}());

var httpDebugger = new HttpDebugger();
//# sourceMappingURL=http.debugger.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/http/http.functions.js





function getWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return (0,tslib_es6.__generator)(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.get(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function postWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return (0,tslib_es6.__generator)(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.post(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function putWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return (0,tslib_es6.__generator)(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.put(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function patchWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return (0,tslib_es6.__generator)(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.patch(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function deletehWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return (0,tslib_es6.__generator)(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.delete(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
function createCancelToken() {
    var canceler;
    var token = new (axios_default()).CancelToken(function (c) {
        // An executor function receives a cancel function as a parameter
        canceler = c;
    });
    return {
        cancel: function (cancelMessage) {
            return canceler("".concat(retryHelper.requestCancelledMessagePrefix, ": ").concat(cancelMessage !== null && cancelMessage !== void 0 ? cancelMessage : 'User cancel'));
        },
        token: token
    };
}
function runWithRetryAsync(data) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var error_1, retryResult_1;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, data.call(data.retryAttempt)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    retryResult_1 = retryHelper.getRetryErrorResult({
                        error: error_1,
                        retryAttempt: data.retryAttempt,
                        retryStrategy: data.retryStrategy
                    });
                    if (!retryResult_1.canRetry) return [3 /*break*/, 5];
                    httpDebugger.debugRetryHttpRequest();
                    // wait time before retrying
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, retryResult_1.retryInMs); })];
                case 3:
                    // wait time before retrying
                    _a.sent();
                    // retry request
                    console.warn("Retry attempt '".concat(data.retryAttempt + 1, "' from a maximum of '").concat(retryResult_1.maxRetries, "' retries. Request url: '").concat(data.url, "'"));
                    return [4 /*yield*/, runWithRetryAsync({
                            call: data.call,
                            retryStrategy: data.retryStrategy,
                            retryAttempt: data.retryAttempt + 1,
                            url: data.url,
                            functionsConfig: data.functionsConfig
                        })];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    if (data.functionsConfig.logErrorsToConsole) {
                        console.error("Executing '".concat(data.url, "' failed. Request was retried '").concat(data.retryAttempt, "' times. "), error_1);
                    }
                    throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getHeadersJson(headers, addContentTypeHeader) {
    var headerJson = {};
    headers.forEach(function (header) {
        headerJson[header.header] = header.value;
    });
    if (addContentTypeHeader) {
        // add default content type header if not present
        var contentTypeHeader = headers.find(function (m) { return m.header.toLowerCase() === 'Content-Type'.toLowerCase(); });
        if (!contentTypeHeader) {
            headerJson['Content-Type'] = 'application/json';
        }
    }
    return headerJson;
}
//# sourceMappingURL=http.functions.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/http/http.service.js



var HttpService = /** @class */ (function () {
    function HttpService(opts) {
        this.opts = opts;
        this.axiosInstance = axios_default().create(opts === null || opts === void 0 ? void 0 : opts.axiosRequestConfig);
        this.functionsConfig = this.getFunctionsConfig();
    }
    HttpService.prototype.getAsync = function (call, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.postAsync = function (call, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, postWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.putAsync = function (call, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, putWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.patchAsync = function (call, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, patchWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.deleteAsync = function (call, options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deletehWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.createCancelToken = function () {
        return createCancelToken();
    };
    HttpService.prototype.getFunctionsConfig = function () {
        var _a, _b;
        return {
            logErrorsToConsole: (_b = (_a = this.opts) === null || _a === void 0 ? void 0 : _a.logErrorsToConsole) !== null && _b !== void 0 ? _b : true
        };
    };
    return HttpService;
}());

//# sourceMappingURL=http.service.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/http/test-http.service.js
var TestHttpService = /** @class */ (function () {
    function TestHttpService(config) {
        this.response = undefined;
        this.error = undefined;
        Object.assign(this, config);
    }
    TestHttpService.prototype.getAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.postAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.putAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.patchAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.deleteAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.createCancelToken = function () {
        return {
            cancel: function () { },
            token: undefined
        };
    };
    TestHttpService.prototype.resolveTestCall = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            if (_this.response) {
                resolve(_this.response);
            }
            if (_this.error) {
                reject(_this.error);
            }
            throw Error("Missing test data");
        });
        return promise;
    };
    return TestHttpService;
}());

//# sourceMappingURL=test-http.service.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/http/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-core/dist/es5/index.js
/* Public API */



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/common/filters.js
var Filters;
(function (Filters) {
    const valueSeparator = ',';
    const defaultValue = '';
    const getParamValueForSystemFilter = (param) => {
        if (!param) {
            return defaultValue;
        }
        if (Array.isArray(param)) {
            let value = '';
            // use [in] filter
            for (let i = 0; i < param.length; i++) {
                value = value + param[i].toString();
                if (i !== param.length - 1) {
                    // append separator if its not last item
                    value = value + valueSeparator;
                }
            }
            return value;
        }
        // single param was given
        return param.toString();
    };
    class TypeFilter {
        constructor(type) {
            this.type = type;
        }
        getParam() {
            if (Array.isArray(this.type)) {
                // multiple types
                return `system.type[in]=${getParamValueForSystemFilter(this.type)}`;
            }
            // single type
            return `system.type=${getParamValueForSystemFilter(this.type)}`;
        }
    }
    Filters.TypeFilter = TypeFilter;
    class CollectionFilter {
        constructor(collection) {
            this.collection = collection;
        }
        getParam() {
            if (Array.isArray(this.collection)) {
                // multiple collections
                return `system.collection[in]=${getParamValueForSystemFilter(this.collection)}`;
            }
            // single collection
            return `system.collection=${getParamValueForSystemFilter(this.collection)}`;
        }
    }
    Filters.CollectionFilter = CollectionFilter;
    class EmptyFilter {
        constructor(element) {
            this.element = element;
        }
        getParam() {
            return `${this.element.trim()}[empty]`;
        }
    }
    Filters.EmptyFilter = EmptyFilter;
    class NotEmptyFilter {
        constructor(element) {
            this.element = element;
        }
        getParam() {
            return `${this.element.trim()}[nempty]`;
        }
    }
    Filters.NotEmptyFilter = NotEmptyFilter;
    class EqualsFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[eq]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.EqualsFilter = EqualsFilter;
    class NotEqualsFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[neq]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.NotEqualsFilter = NotEqualsFilter;
    class AllFilter {
        constructor(element, values) {
            this.element = element;
            this.values = values;
        }
        getParam() {
            return `${this.element.trim()}[all]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map((m) => m.trim()).join(',');
        }
    }
    Filters.AllFilter = AllFilter;
    class AnyFilter {
        constructor(element, values) {
            this.element = element;
            this.values = values;
        }
        getParam() {
            return `${this.element.trim()}[any]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map((m) => m.trim()).join(',');
        }
    }
    Filters.AnyFilter = AnyFilter;
    class ContainsFilter {
        constructor(element, values) {
            this.element = element;
            this.values = values;
        }
        getParam() {
            return `${this.element.trim()}[contains]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values.map((m) => m.trim()).join(',');
        }
    }
    Filters.ContainsFilter = ContainsFilter;
    class GreaterThanFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[gt]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.GreaterThanFilter = GreaterThanFilter;
    class GreaterThanOrEqualFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[gte]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.GreaterThanOrEqualFilter = GreaterThanOrEqualFilter;
    class InFilter {
        constructor(element, values) {
            this.element = element;
            this.values = values;
        }
        getParam() {
            return `${this.element.trim()}[in]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values
                .map((m) => {
                return m.trim();
            })
                .join(',');
        }
    }
    Filters.InFilter = InFilter;
    class NotInFilter {
        constructor(element, values) {
            this.element = element;
            this.values = values;
        }
        getParam() {
            return `${this.element.trim()}[nin]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.values || !Array.isArray(this.values)) {
                return defaultValue;
            }
            return this.values
                .map((m) => {
                return m.trim();
            })
                .join(',');
        }
    }
    Filters.NotInFilter = NotInFilter;
    class LessThanFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[lt]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.LessThanFilter = LessThanFilter;
    class LessThanOrEqualFilter {
        constructor(element, value) {
            this.element = element;
            this.value = value;
        }
        getParam() {
            return `${this.element.trim()}[lte]=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.value) {
                return defaultValue;
            }
            return this.value;
        }
    }
    Filters.LessThanOrEqualFilter = LessThanOrEqualFilter;
    class RangeFilter {
        constructor(element, lowerValue, higherValue) {
            this.element = element;
            this.lowerValue = lowerValue;
            this.higherValue = higherValue;
        }
        getParam() {
            return `${this.element.trim()}[range]=${this.getParamValue()}`;
        }
        getParamValue() {
            let lowerVal = defaultValue;
            let higherVal = defaultValue;
            if (this.lowerValue) {
                lowerVal = this.lowerValue.toString();
            }
            if (this.higherValue) {
                higherVal = this.higherValue.toString();
            }
            return `${lowerVal},${higherVal}`;
        }
    }
    Filters.RangeFilter = RangeFilter;
})(Filters || (Filters = {}));
//# sourceMappingURL=filters.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/common/parameters.js
var common_parameters_Parameters;
(function (Parameters) {
    const defaultValue = '';
    class QueryParameter {
        /**
         * Parameter
         * @constructor
         * @param {string} name - Name of the parameter
         * @param {string} value - Value of the parameter
         */
        constructor(name, value) {
            this.name = name;
            this.value = value;
            if (!name) {
                throw Error(`Name of the parameter is not specified`);
            }
        }
        getParam() {
            return `${this.name}=${this.value}`;
        }
    }
    Parameters.QueryParameter = QueryParameter;
    class ElementsParameter {
        /**
         * Sets elements (projection) so that only certain elements from a content item are returned
         * @constructor
         * @param {string[]} elementCodenames - Array of element codenames to include in response.
         */
        constructor(elementCodenames) {
            this.elementCodenames = elementCodenames;
        }
        getParam() {
            return `elements=${this.getParamValue()}`;
        }
        getParamValue() {
            if (!this.elementCodenames) {
                return defaultValue;
            }
            return this.elementCodenames
                .map((m) => {
                if (!m) {
                    throw Error(`Codename of 'ElementsParameter' cannot be null or empty`);
                }
                return m.trim();
            })
                .join(',');
        }
    }
    Parameters.ElementsParameter = ElementsParameter;
    class LimitParameter {
        /**
         * Limits the number of items that are returned from response
         * @constructor
         * @param {number} limit - Number of elements that will be returned
         */
        constructor(limit) {
            this.limit = limit;
            if (limit <= 0) {
                throw Error(`'LimitParameter' must specify a positive integer`);
            }
        }
        getParam() {
            return `limit=${this.limit}`;
        }
    }
    Parameters.LimitParameter = LimitParameter;
    class IncludeTotalCountParameter {
        /**
         * Adds 'includeTotalCount' query parameter to query
         * @constructor
         */
        constructor() { }
        getParam() {
            return `includeTotalCount=true`;
        }
    }
    Parameters.IncludeTotalCountParameter = IncludeTotalCountParameter;
    class SkipParameter {
        /**
         * Configures response to skip certain number of items
         * @constructor
         * @param {number} skip - Number of content items that will be skipped
         */
        constructor(skip) {
            this.skip = skip;
            if (skip < 0) {
                throw Error(`'SkipParameter' must specify a positive integer number or zero."`);
            }
        }
        getParam() {
            return `skip=${this.skip}`;
        }
    }
    Parameters.SkipParameter = SkipParameter;
    class OrderParameter {
        /**
         * Sorts the response based on given element.
         * @constructor
         * @param {string} element - Element that will be used for sorting (can be both elements.<elementname> or system.<elementname>)
         * @param {SortOrder} sortOrder - Order type (desc/asc). Defaults to 'asc' if SortOrder is null or invalid.
         */
        constructor(element, sortOrder) {
            this.element = element;
            this.sortOrder = sortOrder;
            if (!element) {
                throw Error(`Element specified in 'OrderParameter' is null or empty`);
            }
        }
        getParam() {
            return `order=${this.getParamValue()}`;
        }
        getParamValue() {
            return `${this.element.trim()}[${this.sortOrder}]`;
        }
    }
    Parameters.OrderParameter = OrderParameter;
    class CustomParameter {
        constructor(param) {
            this.param = param;
        }
        getParam() {
            return this.param;
        }
    }
    Parameters.CustomParameter = CustomParameter;
    class DepthParameter {
        /**
         * Configures the depth of the response. Content items might reference another 'linked items' using the Linked items element.
         * Recursively, these linked items can reference another linked items.
         * By default, only one level of linked content is returned.
         * @constructor
         * @param {number} depth - Depth fo the response
         */
        constructor(depth) {
            this.depth = depth;
            if (depth < 0) {
                throw Error(`'DepthParameter' must specify a positive integer or zero`);
            }
        }
        getParam() {
            return `depth=${this.depth}`;
        }
    }
    Parameters.DepthParameter = DepthParameter;
    class LanguageParameter {
        /**
         * Specifies language version to fetch
         * @constructor
         * @param {string} languageCodename - Codename of the language
         */
        constructor(languageCodename) {
            this.languageCodename = languageCodename;
            if (!languageCodename) {
                throw Error(`'LanguageParameter' must specify codename of the language`);
            }
        }
        getParam() {
            return `language=${this.languageCodename}`;
        }
    }
    Parameters.LanguageParameter = LanguageParameter;
})(common_parameters_Parameters || (common_parameters_Parameters = {}));
//# sourceMappingURL=parameters.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/common/common-models.js
class DeliveryError {
    constructor(data) {
        this.message = data.message;
        this.requestId = data.requestId;
        this.errorCode = data.errorCode;
        this.specificCode = data.specificCode;
    }
}
//# sourceMappingURL=common-models.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/common/headers.js
const continuationTokenHeaderName = 'X-Continuation';
const waitForLoadingNewContentHeader = 'X-KC-Wait-For-Loading-New-Content';
const sdkVersionHeader = 'X-KC-SDKID';
const staleContentHeaderName = 'X-Stale-Content';
//# sourceMappingURL=headers.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/common/index.js







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/models/index.js







//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/common/base-query.class.js

class BaseQuery {
    constructor(config, queryService) {
        this.config = config;
        this.queryService = queryService;
        this.parameters = [];
    }
    /**
     * Adds custom parameter to query
     * @param name Name of parameter
     * @param value Value of parameter
     */
    withCustomParameter(name, value) {
        this.parameters.push(new common_parameters_Parameters.QueryParameter(name, value));
        return this;
    }
    /**
     * Adds parameter to query
     * @param name Name of parameter
     * @param value Value of parameter
     */
    withParameter(parameter) {
        this.parameters.push(parameter);
        return this;
    }
    /**
     * Adds parameters to query
     * @param parameters Array of parameters
     */
    withParameters(parameters) {
        this.parameters.push(...parameters);
        return this;
    }
    /**
     * Gets headers used by this query
     */
    getHeaders() {
        return this.queryService.getHeaders(this._queryConfig, []);
    }
    /**
     * Sets request headers
     */
    withHeaders(headers) {
        var _a;
        const queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
        queryHeaders.push(...headers);
        this._queryConfig.customHeaders = queryHeaders;
        return this;
    }
    /**
     * Sets request header
     */
    withHeader(header) {
        var _a;
        const queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
        queryHeaders.push(header);
        this._queryConfig.customHeaders = queryHeaders;
        return this;
    }
    /**
     * Sets custom URL of request (overrides default URL of the query)
     */
    withCustomUrl(url) {
        this.customUrl = url;
        return this;
    }
    /**
     * Gets all query parameter currently applied to query
     */
    getParameters() {
        return this.parameters;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    queryConfig(queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    }
    resolveUrlInternal(action) {
        var _a;
        // use custom URL if user specified it
        if (this.customUrl) {
            return this.customUrl;
        }
        // use original url
        return this.queryService.getUrl(action, (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {}, this.getParameters());
    }
    processDefaultLanguageParameter() {
        // add default language if none is specified && default language is specified globally
        if (this.config.defaultLanguage) {
            const languageParameter = this.getParameters().find((m) => m.getParam() === 'language');
            if (!languageParameter) {
                // language parameter was not specified in query, use globally defined language
                this.parameters.push(new common_parameters_Parameters.LanguageParameter(this.config.defaultLanguage));
            }
        }
    }
}
//# sourceMappingURL=base-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/element/element-query.class.js

class ElementQuery extends BaseQuery {
    constructor(config, queryService, typeCodename, elementCodename) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this.typeCodename = typeCodename;
        this.elementCodename = elementCodename;
        this._queryConfig = {};
        if (!typeCodename) {
            throw Error(`Codename of the type has to be provided`);
        }
        if (!elementCodename) {
            throw Error(`Codename of the element has to be provided`);
        }
    }
    toPromise() {
        var _a;
        return this.queryService.getElementAsync(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/types/' + this.typeCodename + '/elements/' + this.elementCodename;
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.viewContentTypeElementResponse(json);
    }
}
//# sourceMappingURL=element-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/common/base-listing-query.class.js


class BaseListingQuery extends BaseQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
    }
    /**
     * Empty filter condition
     * @param element Element with empty value
     */
    emptyFilter(element) {
        this.parameters.push(new Filters.EmptyFilter(element));
        return this;
    }
    /**
     * Not empty filter condition
     * @param element Element with non-empty value
     */
    notEmptyFilter(element) {
        this.parameters.push(new Filters.NotEmptyFilter(element));
        return this;
    }
    /**
     * Equals filter condition
     * @param element Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    equalsFilter(element, value) {
        this.parameters.push(new Filters.EqualsFilter(element, value));
        return this;
    }
    /**
     * Not equals filter condition
     * @param element Element to filter. Example: 'elements.movie'
     * @param value Value to match. Example: 'Kingsman'
     */
    notEqualsFilter(element, value) {
        this.parameters.push(new Filters.NotEqualsFilter(element, value));
        return this;
    }
    /**
     * All filter
     * @param element Element to filter.
     * @param values Values
     */
    allFilter(element, values) {
        this.parameters.push(new Filters.AllFilter(element, values));
        return this;
    }
    /**
     * Any filter
     * @param element Element to filter.
     * @param values Values
     */
    anyFilter(element, values) {
        this.parameters.push(new Filters.AnyFilter(element, values));
        return this;
    }
    /**
     * Contains filter
     * @param element Element to filter.
     * @param values Values
     */
    containsFilter(element, values) {
        this.parameters.push(new Filters.ContainsFilter(element, values));
        return this;
    }
    /**
     * Greater then filter
     * @param element Element to filter.
     * @param value Value
     */
    greaterThanFilter(element, value) {
        this.parameters.push(new Filters.GreaterThanFilter(element, value));
        return this;
    }
    /**
     * Greater then or equals filter
     * @param element Element to filter.
     * @param value Value
     */
    greaterThanOrEqualFilter(element, value) {
        this.parameters.push(new Filters.GreaterThanOrEqualFilter(element, value));
        return this;
    }
    /**
     * In filter
     * @param element Element to filter.
     * @param values Values
     */
    inFilter(element, values) {
        this.parameters.push(new Filters.InFilter(element, values));
        return this;
    }
    /**
     * Not in filter
     * @param element Element to filter.
     * @param values Values
     */
    notInFilter(element, values) {
        this.parameters.push(new Filters.NotInFilter(element, values));
        return this;
    }
    /**
     * Less then filter
     * @param element Element to filter.
     * @param value Value
     */
    lessThanFilter(element, value) {
        this.parameters.push(new Filters.LessThanFilter(element, value));
        return this;
    }
    /**
     * @param element Element to filter.
     * @param value Value
     */
    lessThanOrEqualFilter(element, value) {
        this.parameters.push(new Filters.LessThanOrEqualFilter(element, value));
        return this;
    }
    /**
     * @param element Element to filter.
     * @param lowerValue Lower value of range (e.g. 2)
     * @param higherValue Higher value of range (e.g. 10)
     */
    rangeFilter(element, lowerValue, higherValue) {
        this.parameters.push(new Filters.RangeFilter(element, lowerValue, higherValue));
        return this;
    }
    /**
     * Limits the number of items returned by query
     * @param limit Number of items to load
     */
    limitParameter(limit) {
        this.parameters.push(new common_parameters_Parameters.LimitParameter(limit));
        return this;
    }
    /**
     * Orders query based on given element and sort order
     * @param element Element by which to order
     * @param sortOrder Asc/Desc order type
     */
    orderParameter(element, sortOrder) {
        this.parameters.push(new common_parameters_Parameters.OrderParameter(element, sortOrder));
        return this;
    }
    /**
     * Sets descending order on given element
     * @param element Element by which to order
     */
    orderByDescending(element) {
        this.parameters.push(new common_parameters_Parameters.OrderParameter(element, 'desc'));
        return this;
    }
    /**
     * Sets Ascending order on given element
     * @param element Element by which to order
     */
    orderByAscending(element) {
        this.parameters.push(new common_parameters_Parameters.OrderParameter(element, 'asc'));
        return this;
    }
    /**
     * Skips the selected number of items
     * @param skip Number of items to skip
     */
    skipParameter(skip) {
        this.parameters.push(new common_parameters_Parameters.SkipParameter(skip));
        return this;
    }
    /**
     * Sets continuation token header
     */
    withContinuationToken(token) {
        var _a;
        // remove previous continuation token if there is any
        let queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
        queryHeaders = queryHeaders.filter(m => m.header !== continuationTokenHeaderName);
        this._queryConfig.customHeaders = queryHeaders;
        this.withHeaders([
            {
                header: continuationTokenHeaderName,
                value: token
            }
        ]);
        return this;
    }
    /**
     * Query to get all items. Uses paging data and may execute multiple HTTP requests depending on number of items
     */
    toAllPromise(queryAllConfig) {
        return this.queryService.getListAllResponse({
            page: 1,
            listQueryConfig: queryAllConfig,
            allResponseFactory: (items, responses) => {
                const response = this.allResponseFactory(items, responses);
                return {
                    data: response,
                    responses: responses
                };
            },
            getResponse: (nextPageUrl, continuationToken) => {
                let query = this;
                if (nextPageUrl) {
                    query = this.withCustomUrl(nextPageUrl);
                }
                if (continuationToken) {
                    query = this.withContinuationToken(continuationToken);
                }
                return query.toPromise();
            }
        });
    }
}
//# sourceMappingURL=base-listing-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/item/multiple-items-query.class.js


class MultipleItemsQuery extends BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this._queryConfig = {};
    }
    /**
     * Adds information about the total number of content items matching your query.
     * When set to true, the pagination object returned in the API response contains
     * an additional total_count property.
     */
    includeTotalCountParameter() {
        this.parameters.push(new common_parameters_Parameters.IncludeTotalCountParameter());
        return this;
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    type(type) {
        this.parameters.push(new Filters.TypeFilter(type));
        return this;
    }
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    types(types) {
        this.parameters.push(new Filters.TypeFilter(types));
        return this;
    }
    /**
     * Gets only item from given collection
     * @param collection Codename of collection to get
     */
    collection(collection) {
        this.parameters.push(new Filters.CollectionFilter(collection));
        return this;
    }
    /**
     * Gets items from given collections (logical or)
     * I.e. get items of either 'default' or 'christmas-campaign' collection
     * @param collections Collections to get
     */
    collections(collections) {
        this.parameters.push(new Filters.CollectionFilter(collections));
        return this;
    }
    /**
     * Indicates depth of query that affects loading of nested linked items.
     * @param depth Depth of the query (> 0)
     */
    depthParameter(depth) {
        this.parameters.push(new common_parameters_Parameters.DepthParameter(depth));
        return this;
    }
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */
    languageParameter(languageCodename) {
        this.parameters.push(new common_parameters_Parameters.LanguageParameter(languageCodename));
        return this;
    }
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */
    elementsParameter(elementCodenames) {
        this.parameters.push(new common_parameters_Parameters.ElementsParameter(elementCodenames));
        return this;
    }
    toPromise() {
        var _a;
        return this.queryService.getMultipleItems(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/items';
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.listContentItemsResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
//# sourceMappingURL=multiple-items-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/item/single-item-query.class.js


class SingleItemQuery extends BaseQuery {
    constructor(config, queryService, codename) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this.codename = codename;
        this._queryConfig = {};
        if (!codename) {
            throw Error(`'codename' has to be configured for 'SingleItemQuery' query`);
        }
    }
    /**
     * Indicates depth of query that affects loading of nested linked items.
     * @param depth Depth of the query (> 0)
     */
    depthParameter(depth) {
        this.parameters.push(new common_parameters_Parameters.DepthParameter(depth));
        return this;
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    queryConfig(queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    }
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */
    languageParameter(languageCodename) {
        this.parameters.push(new common_parameters_Parameters.LanguageParameter(languageCodename));
        return this;
    }
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */
    elementsParameter(elementCodenames) {
        this.parameters.push(new common_parameters_Parameters.ElementsParameter(elementCodenames));
        return this;
    }
    toPromise() {
        var _a;
        return this.queryService.getSingleItemAsync(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/items/' + this.codename;
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.viewContentItemResponse(json);
    }
}
//# sourceMappingURL=single-item-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/taxonomy/taxonomies-query.class.js


class TaxonomiesQuery extends BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        /**
         * Taxonomies endpoint URL action
         */
        this.taxonomiesEndpoint = 'taxonomies';
        this._queryConfig = {};
    }
    /**
     * Limits the number of taxonomies returned by query
     * @param limit Number of taxonomies to load
     */
    limitParameter(limit) {
        this.parameters.push(new common_parameters_Parameters.LimitParameter(limit));
        return this;
    }
    /**
     * Skips the selected number of taxonomies
     * @param skip Number of taxonomies to skip
     */
    skipParameter(skip) {
        this.parameters.push(new common_parameters_Parameters.SkipParameter(skip));
        return this;
    }
    toPromise() {
        var _a;
        return this.queryService.getTaxonomies(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    /**
     * Sets continuation token header
     */
    withContinuationToken(token) {
        this.withHeaders([
            {
                header: continuationTokenHeaderName,
                value: token
            }
        ]);
        return this;
    }
    getUrl() {
        const action = '/' + this.taxonomiesEndpoint;
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.listTaxonomiesResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
//# sourceMappingURL=taxonomies-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/taxonomy/taxonomy-query.class.js

class TaxonomyQuery extends BaseQuery {
    constructor(config, queryService, taxonomyCodename) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this.taxonomyCodename = taxonomyCodename;
        /**
         * Taxonomies endpoint URL action
         */
        this.taxonomiesEndpoint = 'taxonomies';
        this._queryConfig = {};
        if (!taxonomyCodename) {
            throw Error(`Cannot create taxonomy query without codename of the taxonomy`);
        }
    }
    toPromise() {
        var _a;
        return this.queryService.getTaxonomy(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/' + this.taxonomiesEndpoint + '/' + this.taxonomyCodename;
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.viewTaxonomyResponse(json);
    }
}
//# sourceMappingURL=taxonomy-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/type/multiple-type-query.class.js

class MultipleTypeQuery extends BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this._queryConfig = {};
    }
    toPromise() {
        var _a;
        return this.queryService.getMultipleTypes(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/types';
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.listContentTypesResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
//# sourceMappingURL=multiple-type-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/type/single-type-query.class.js

class SingleTypeQuery extends BaseQuery {
    constructor(config, queryService, typeCodename) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this.typeCodename = typeCodename;
        this._queryConfig = {};
        if (!typeCodename) {
            throw Error(`Cannot create type query without the codename of the type`);
        }
    }
    toPromise() {
        var _a;
        return this.queryService.getSingleType(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/types/' + this.typeCodename;
        return super.resolveUrlInternal(action);
    }
    map(json) {
        return this.queryService.mappingService.viewContentTypeResponse(json);
    }
}
//# sourceMappingURL=single-type-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/items-feed/items-feed-query.class.js


class ItemsFeedQuery extends BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this._queryConfig = {};
    }
    /**
     * Gets only item of given type
     * @param type Codename of type to get
     */
    type(type) {
        this.parameters.push(new Filters.TypeFilter(type));
        return this;
    }
    /**
     * Gets items of given types (logical or)
     * I.e. get items of either 'Actor' or 'Movie' type
     * @param types Types to get
     */
    types(types) {
        this.parameters.push(new Filters.TypeFilter(types));
        return this;
    }
    /**
     * Gets only item from given collection
     * @param collection Codename of collection to get
     */
    collection(collection) {
        this.parameters.push(new Filters.CollectionFilter(collection));
        return this;
    }
    /**
     * Gets items from given collections (logical or)
     * I.e. get items of either 'default' or 'christmas-campaign' collection
     * @param collections Collections to get
     */
    collections(collections) {
        this.parameters.push(new Filters.CollectionFilter(collections));
        return this;
    }
    /**
     * Language codename
     * @param languageCodename Codename of the language
     */
    languageParameter(languageCodename) {
        this.parameters.push(new common_parameters_Parameters.LanguageParameter(languageCodename));
        return this;
    }
    /**
     * Used to limit the number of elements returned by query.
     * @param elementCodenames Array of element codenames to fetch
     */
    elementsParameter(elementCodenames) {
        this.parameters.push(new common_parameters_Parameters.ElementsParameter(elementCodenames));
        return this;
    }
    toPromise() {
        var _a;
        return this.queryService.getItemsFeed(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/items-feed';
        // add default language is necessry
        this.processDefaultLanguageParameter();
        return super.resolveUrlInternal(action);
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    queryConfig(queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    }
    map(json) {
        return this.queryService.mappingService.itemsFeedResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
//# sourceMappingURL=items-feed-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/language/languages-query.class.js


class LanguagesQuery extends BaseListingQuery {
    constructor(config, queryService) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        /**
         * Endpoint
         */
        this.endpoint = 'languages';
        this._queryConfig = {};
    }
    /**
     * Limits the number of taxonomies returned by query
     * @param limit Number of taxonomies to load
     */
    limitParameter(limit) {
        this.parameters.push(new common_parameters_Parameters.LimitParameter(limit));
        return this;
    }
    /**
     * Skips the selected number of taxonomies
     * @param skip Number of taxonomies to skip
     */
    skipParameter(skip) {
        this.parameters.push(new common_parameters_Parameters.SkipParameter(skip));
        return this;
    }
    /**
     * Sets continuation token header
     */
    withContinuationToken(token) {
        this.withHeaders([
            {
                header: continuationTokenHeaderName,
                value: token
            }
        ]);
        return this;
    }
    toPromise() {
        var _a;
        return this.queryService.getLanguages(this.getUrl(), (_a = this._queryConfig) !== null && _a !== void 0 ? _a : {});
    }
    getUrl() {
        const action = '/' + this.endpoint;
        return super.resolveUrlInternal(action);
    }
    /**
     * Used to configure query
     * @param queryConfig Query configuration
     */
    queryConfig(queryConfig) {
        this._queryConfig = queryConfig;
        return this;
    }
    map(json) {
        return this.queryService.mappingService.listLanguagesResponse(json);
    }
    allResponseFactory(items, responses) {
        return {
            items: items,
            responses: responses
        };
    }
}
//# sourceMappingURL=languages-query.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/query/index.js










//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/sdk-info.generated.js
const sdkInfo = {
    host: 'npmjs.com',
    version: '11.13.0',
    name: '@kentico/kontent-delivery'
};
//# sourceMappingURL=sdk-info.generated.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/services/base-delivery-query.service.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class BaseDeliveryQueryService {
    constructor(
    /**
     * Delivery client configuration
     */
    config, 
    /**
     * Http service for fetching data
     */
    httpService, 
    /**
     * Information about the SDK
     */
    sdkInfo, 
    /**
     * Mapping service
     */
    mappingService) {
        this.config = config;
        this.httpService = httpService;
        this.sdkInfo = sdkInfo;
        this.mappingService = mappingService;
        /**
         * Default base Url to Kentico Delivery API
         */
        this.defaultBaseDeliveryApiUrl = 'https://deliver.kontent.ai';
        /**
         * Default preview url to Kentico Delivery API
         */
        this.defaultPreviewDeliveryApiUrl = 'https://preview-deliver.kontent.ai';
    }
    /**
     * Gets url based on the action, query configuration and options (parameters)
     * @param action Action (= url part) that will be hit
     * @param queryConfig Query configuration
     * @param options Query options
     */
    getUrl(action, queryConfig, options) {
        if (!this.config.proxy || !this.config.proxy.advancedProxyUrlResolver) {
            return urlHelper.addOptionsToUrl(this.getBaseUrl(queryConfig) + action, options);
        }
        return this.config.proxy.advancedProxyUrlResolver({
            queryParameters: options ? options : [],
            queryString: urlHelper.addOptionsToUrl('', options),
            action: action,
            domain: this.getDomain(queryConfig),
            queryConfig: queryConfig,
            projectId: this.config.projectId
        });
    }
    /**
     * Gets proper set of headers for given request.
     * @param queryConfig Query configuration
     * @param additionalHeaders Custom headers
     */
    getHeaders(queryConfig, additionalHeaders) {
        const headers = [];
        if (additionalHeaders) {
            headers.push(...additionalHeaders);
        }
        // add SDK Id header for monitoring SDK usage
        headers.push(this.getSdkIdHeader());
        // add headers from global config
        if (this.config.globalHeaders) {
            headers.push(...this.config.globalHeaders(queryConfig));
        }
        // add query / global headers from query config
        headers.push(...this.getQueryHeaders(queryConfig));
        if (this.isPreviewModeEnabled(queryConfig) && this.isSecuredModeEnabled(queryConfig)) {
            throw Error(`Preview & secured modes cannot be used at the same time.`);
        }
        // add preview header is required
        if (this.isPreviewModeEnabled(queryConfig) && this.config.previewApiKey) {
            headers.push(this.getAuthorizationHeader(this.config.previewApiKey));
        }
        // add secured mode header is required
        if (this.isSecuredModeEnabled(queryConfig) && this.config.secureApiKey) {
            headers.push(this.getAuthorizationHeader(this.config.secureApiKey));
        }
        // add 'X-KC-Wait-For-Loading-New-Content' header if required
        if (this.shouldAddWaitForLoadingNewContentHeader(queryConfig)) {
            headers.push({
                header: waitForLoadingNewContentHeader,
                value: 'true'
            });
        }
        return headers;
    }
    /**
     * Http GET response
     * @param url Url of request
     * @param queryConfig Query config configuration
     */
    getResponseAsync(url, queryConfig, serviceConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!queryConfig) {
                queryConfig = {};
            }
            if (!serviceConfig) {
                serviceConfig = {};
            }
            try {
                return yield this.httpService.getAsync({
                    url: url
                }, {
                    cancelToken: queryConfig === null || queryConfig === void 0 ? void 0 : queryConfig.cancelToken,
                    responseType: 'json',
                    retryStrategy: this.config.retryStrategy,
                    headers: this.getHeaders(queryConfig, serviceConfig.headers ? serviceConfig.headers : [])
                });
            }
            catch (error) {
                throw this.mapDeliveryError(error);
            }
        });
    }
    /**
     * Gets base URL of the request including the project Id
     * @param queryConfig Query configuration
     */
    getBaseUrl(queryConfig) {
        return this.getDomain(queryConfig) + '/' + this.config.projectId;
    }
    mapNetworkResponse(data, response) {
        return {
            data: data,
            response: response,
            hasStaleContent: this.getHasStaleContent(response.headers),
            xContinuationToken: this.getContinuationToken(response.headers)
        };
    }
    /**
     * Indicates if current query should use preview mode
     * @param queryConfig Query configuration
     */
    isPreviewModeEnabled(queryConfig) {
        if (queryConfig.usePreviewMode !== undefined) {
            return queryConfig.usePreviewMode;
        }
        if (!this.config.defaultQueryConfig) {
            return false;
        }
        if (this.config.defaultQueryConfig.usePreviewMode === true) {
            return true;
        }
        return false;
    }
    getQueryHeaders(queryConfig) {
        var _a;
        if (queryConfig.customHeaders) {
            return queryConfig.customHeaders;
        }
        if ((_a = this.config.defaultQueryConfig) === null || _a === void 0 ? void 0 : _a.customHeaders) {
            return this.config.defaultQueryConfig.customHeaders;
        }
        return [];
    }
    shouldAddWaitForLoadingNewContentHeader(queryConfig) {
        if (queryConfig.waitForLoadingNewContent !== undefined) {
            return queryConfig.waitForLoadingNewContent;
        }
        if (!this.config.defaultQueryConfig) {
            return false;
        }
        if (this.config.defaultQueryConfig.waitForLoadingNewContent === true) {
            return true;
        }
        return false;
    }
    /**
     * Indicates if current query should use secured mode
     * @param queryConfig Query configuration
     */
    isSecuredModeEnabled(queryConfig) {
        if (queryConfig.useSecuredMode !== undefined) {
            return queryConfig.useSecuredMode;
        }
        if (!this.config.defaultQueryConfig) {
            return false;
        }
        if (this.config.defaultQueryConfig.useSecuredMode === true) {
            return true;
        }
        return false;
    }
    /**
     * Gets preview or standard URL based on client and query configuration
     * @param queryConfig Query configuration
     */
    getDomain(queryConfig) {
        if (this.isPreviewModeEnabled(queryConfig)) {
            if (!this.config.previewApiKey) {
                throw Error(`Preview API key is not configured.`);
            }
            // check custom preview url
            if (this.config.proxy && this.config.proxy.basePreviewUrl) {
                return this.config.proxy.basePreviewUrl;
            }
            // use default preview url
            return this.defaultPreviewDeliveryApiUrl;
        }
        // check custom base url
        if (this.config.proxy && this.config.proxy.baseUrl) {
            return this.config.proxy.baseUrl;
        }
        return this.defaultBaseDeliveryApiUrl;
    }
    /**
     * Gets authorization header. This is used for 'preview' functionality
     */
    getAuthorizationHeader(key) {
        if (!key) {
            throw Error(`Cannot get authorization header because key is invalid`);
        }
        // authorization header required for preview mode
        return {
            header: 'authorization',
            value: `bearer ${key}`
        };
    }
    /**
     * Header identifying SDK type & version for internal purposes of Kentico
     */
    getSdkIdHeader() {
        return {
            header: sdkVersionHeader,
            value: `${this.sdkInfo.host};${this.sdkInfo.name};${this.sdkInfo.version}`
        };
    }
    mapDeliveryError(error) {
        var _a;
        let axiosError;
        if (error.error) {
            axiosError = error.error;
        }
        else {
            axiosError = error;
        }
        if (!axiosError || !axiosError.isAxiosError) {
            return error;
        }
        const deliveryErrorData = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
        if (!deliveryErrorData || !deliveryErrorData.error_code) {
            return error;
        }
        return new DeliveryError({
            errorCode: deliveryErrorData.error_code,
            message: deliveryErrorData.message,
            specificCode: deliveryErrorData.specific_code,
            requestId: deliveryErrorData.request_id
        });
    }
    getHasStaleContent(headers) {
        const hasStaleContentHeader = headers.find((m) => m.header.toLowerCase() === staleContentHeaderName.toLowerCase());
        if (hasStaleContentHeader) {
            if (hasStaleContentHeader.value.toString() === '1') {
                return true;
            }
        }
        return false;
    }
    getContinuationToken(headers) {
        const header = headers.find((m) => m.header.toLowerCase() === continuationTokenHeaderName.toLowerCase());
        return header ? header.value : undefined;
    }
}
//# sourceMappingURL=base-delivery-query.service.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/services/delivery-query.service.js
var delivery_query_service_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class QueryService extends BaseDeliveryQueryService {
    constructor(config, httpService, sdkInfo, mappingService) {
        super(config, httpService, sdkInfo, mappingService);
    }
    /**
     * Gets single item from given url
     * @param url Url used to get single item
     * @param queryConfig Query configuration
     */
    getSingleItemAsync(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.viewContentItemResponse(response.data), response);
        });
    }
    /**
     * Gets single feed response. Might not contain all items in your project.
     * @param url Url
     * @param queryConfig Query configuration
     */
    getItemsFeed(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.itemsFeedResponse(response.data), response);
        });
    }
    /**
     * Gets multiple items from given url
     * @param url Url used to get multiple items
     * @param queryConfig Query configuration
     */
    getMultipleItems(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.listContentItemsResponse(response.data), response);
        });
    }
    /**
     * Gets single content type from given url
     * @param url Url used to get single type
     * @param queryConfig Query configuration
     */
    getSingleType(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.viewContentTypeResponse(response.data), response);
        });
    }
    /**
     * Gets multiple content types from given url
     * @param url Url used to get multiple types
     * @param queryConfig Query configuration
     */
    getMultipleTypes(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.listContentTypesResponse(response.data), response);
        });
    }
    /**
     * Gets languages
     * @param url Url
     * @param queryConfig Query configuration
     */
    getLanguages(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.listLanguagesResponse(response.data), response);
        });
    }
    /**
     * Gets single taxonomy from given url
     * @param url Url used to get single taxonomy
     * @param queryConfig Query configuration
     */
    getTaxonomy(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.viewTaxonomyResponse(response.data), response);
        });
    }
    /**
     * Gets multiple taxonomies from given url
     * @param url Url used to get multiple taxonomies
     * @param queryConfig Query configuration
     */
    getTaxonomies(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.listTaxonomiesResponse(response.data), response);
        });
    }
    /**
     * Gets single content type element from given url
     * @param url Url used to get single content type element
     * @param queryConfig Query configuration
     */
    getElementAsync(url, queryConfig) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResponseAsync(url, queryConfig);
            return this.mapNetworkResponse(this.mappingService.viewContentTypeElementResponse(response.data), response);
        });
    }
    getListAllResponse(data) {
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            const responses = yield this.getListAllResponseInternalAsync({
                page: data.page,
                resolvedResponses: [],
                getResponse: data.getResponse,
                nextPageUrl: undefined,
                continuationToken: undefined,
                listQueryConfig: data.listQueryConfig
            });
            return data.allResponseFactory(responses.reduce((prev, current) => {
                prev.push(...current.data.items);
                return prev;
            }, []), responses);
        });
    }
    getListAllResponseInternalAsync(data) {
        var _a, _b, _c, _d;
        return delivery_query_service_awaiter(this, void 0, void 0, function* () {
            if ((_a = data.listQueryConfig) === null || _a === void 0 ? void 0 : _a.pages) {
                if (data.page > data.listQueryConfig.pages) {
                    // page limit reached, return result
                    return data.resolvedResponses;
                }
            }
            const response = yield data.getResponse(data.nextPageUrl, data.continuationToken);
            if ((_b = data.listQueryConfig) === null || _b === void 0 ? void 0 : _b.delayBetweenRequests) {
                yield this.sleep(data.listQueryConfig.delayBetweenRequests);
            }
            data.resolvedResponses.push(response);
            if ((_c = data.listQueryConfig) === null || _c === void 0 ? void 0 : _c.responseFetched) {
                data.listQueryConfig.responseFetched(response, data.nextPageUrl, data.continuationToken);
            }
            const nextPage = (_d = response.data.pagination) === null || _d === void 0 ? void 0 : _d.nextPage;
            const continuationToken = response.xContinuationToken;
            if (nextPage || continuationToken) {
                // recursively fetch next page data
                return yield this.getListAllResponseInternalAsync({
                    page: data.page + 1,
                    nextPageUrl: nextPage,
                    continuationToken: continuationToken,
                    listQueryConfig: data.listQueryConfig,
                    getResponse: data.getResponse,
                    resolvedResponses: data.resolvedResponses
                });
            }
            return data.resolvedResponses;
        });
    }
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
}
//# sourceMappingURL=delivery-query.service.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/utilities/linked-items.helper.js
class LinkedItemsHelper {
    convertLinkedItemsToArray(linkedItems) {
        const linkedItemsArray = [];
        for (const linkedItemKey of Object.keys(linkedItems)) {
            linkedItemsArray.push(linkedItems[linkedItemKey]);
        }
        return linkedItemsArray;
    }
}
const linkedItemsHelper = new LinkedItemsHelper();
//# sourceMappingURL=linked-items.helper.js.map
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/utilities/guid.helper.js

class GuidHelper {
    genereateGuid() {
        return (0,v4/* default */.Z)();
    }
}
const guid_helper_guidHelper = new GuidHelper();
//# sourceMappingURL=guid.helper.js.map
// EXTERNAL MODULE: ./node_modules/url-parse/index.js
var url_parse = __webpack_require__(84564);
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/utilities/delivery-url.helper.js

class DeliveryUrlHelper {
    replaceAssetDomain(originalAssetUrl, customDomain) {
        const urlPath = this.getUrlPathname(originalAssetUrl);
        return `${customDomain}${urlPath}`;
    }
    getUrlPathname(url) {
        const parsedUrl = url_parse(url);
        return parsedUrl.pathname;
    }
}
const deliveryUrlHelper = new DeliveryUrlHelper();
//# sourceMappingURL=delivery-url.helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/utilities/text-helper.js
class TextHelper {
    getPropertyNameRegex() {
        return /[\&\(\)\?\-\=\'\"\§\!\%\:\_\s.]+(.)?/g;
    }
    removeZeroWidthCharacters(str) {
        return str.replace(/[\u200B-\u200D\uFEFF]/g, '');
    }
    addUnderscoreWhenStarsWithNumber(str) {
        if (this.startsWithNumber(str)) {
            return `_${str}`;
        }
        return str;
    }
    startsWithNumber(str) {
        if (str.match(/^\d/)) {
            return true;
        }
        return false;
    }
}
const text_helper_textHelper = new TextHelper();
//# sourceMappingURL=text-helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/utilities/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/elements/element-type.js
/**
* Represents codename of Kentico Kontent element types
*/
var ElementType;
(function (ElementType) {
    ElementType["Text"] = "text";
    ElementType["Number"] = "number";
    ElementType["ModularContent"] = "modular_content";
    ElementType["Asset"] = "asset";
    ElementType["DateTime"] = "date_time";
    ElementType["RichText"] = "rich_text";
    ElementType["MultipleChoice"] = "multiple_choice";
    ElementType["UrlSlug"] = "url_slug";
    ElementType["Taxonomy"] = "taxonomy";
    ElementType["Custom"] = "custom";
    ElementType["Unknown"] = "unknown";
})(ElementType || (ElementType = {}));
//# sourceMappingURL=element-type.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/elements/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/element.mapper.js



class ElementMapper {
    constructor(config) {
        this.config = config;
    }
    mapElements(data) {
        // return processed item to avoid infinite recursion
        const processedItem = data.processedItems[data.dataToMap.item.system.codename];
        if (processedItem) {
            // item was already resolved
            return {
                item: processedItem,
                processedItems: data.processedItems,
                preparedItems: data.preparedItems,
                processingStartedForCodenames: data.processingStartedForCodenames
            };
        }
        const preparedItem = data.preparedItems[data.dataToMap.item.system.codename];
        const itemInstance = preparedItem === null || preparedItem === void 0 ? void 0 : preparedItem.item;
        if (!itemInstance) {
            // item is not present in response
            return undefined;
        }
        // mapp elements
        const elementCodenames = Object.getOwnPropertyNames(data.dataToMap.rawItem.elements);
        for (const elementCodename of elementCodenames) {
            const elementMap = this.resolveElementMap(itemInstance, elementCodename);
            const elementWrapper = {
                system: data.dataToMap.item.system,
                rawElement: data.dataToMap.rawItem.elements[elementCodename],
                element: elementMap.resolvedName
            };
            if (elementMap.shouldMapElement) {
                const mappedElement = this.mapElement({
                    elementWrapper: elementWrapper,
                    item: itemInstance,
                    preparedItems: data.preparedItems,
                    processingStartedForCodenames: data.processingStartedForCodenames,
                    processedItems: data.processedItems
                });
                // set mapped elements
                itemInstance.elements[elementMap.resolvedName] = mappedElement;
            }
        }
        return {
            item: itemInstance,
            processedItems: data.processedItems,
            preparedItems: data.preparedItems,
            processingStartedForCodenames: data.processingStartedForCodenames
        };
    }
    mapElement(data) {
        const elementType = enumHelper.getEnumFromValue(ElementType, data.elementWrapper.rawElement.type);
        if (elementType) {
            if (elementType === ElementType.ModularContent) {
                return this.mapLinkedItemsElement({
                    elementWrapper: data.elementWrapper,
                    preparedItems: data.preparedItems,
                    processingStartedForCodenames: data.processingStartedForCodenames,
                    processedItems: data.processedItems
                });
            }
            if (elementType === ElementType.Text) {
                return this.mapTextElement(data.elementWrapper);
            }
            if (elementType === ElementType.Asset) {
                return this.mapAssetsElement(data.elementWrapper);
            }
            if (elementType === ElementType.Number) {
                return this.mapNumberElement(data.elementWrapper);
            }
            if (elementType === ElementType.MultipleChoice) {
                return this.mapMultipleChoiceElement(data.elementWrapper);
            }
            if (elementType === ElementType.DateTime) {
                return this.mapDateTimeElement(data.elementWrapper);
            }
            if (elementType === ElementType.RichText) {
                // add to parent items
                return this.mapRichTextElement(data.elementWrapper, data.processedItems, data.processingStartedForCodenames, data.preparedItems);
            }
            if (elementType === ElementType.UrlSlug) {
                return this.mapUrlSlugElement(data.elementWrapper);
            }
            if (elementType === ElementType.Taxonomy) {
                return this.mapTaxonomyElement(data.elementWrapper);
            }
            if (elementType === ElementType.Custom) {
                return this.mapCustomElement(data.elementWrapper);
            }
        }
        console.warn(`Could not map element '${data.elementWrapper.rawElement.name}' of type '${data.elementWrapper.rawElement.type}'. Returning unknown element instead.`);
        return this.mapUnknowElement(data.elementWrapper);
    }
    mapRichTextElement(elementWrapper, processedItems, processingStartedForCodenames, preparedItems) {
        // get all linked items nested in rich text
        const richTextLinkedItems = [];
        const rawElement = elementWrapper.rawElement;
        for (const codename of rawElement.modular_content) {
            // get linked item and check if it exists (it might not be included in response due to 'Depth' parameter)
            const preparedData = preparedItems[codename];
            // first try to get existing item
            if (this.canMapLinkedItems()) {
                const existingLinkedItem = this.getOrSaveLinkedItemForElement(codename, rawElement, processedItems, processingStartedForCodenames, preparedItems);
                if (existingLinkedItem) {
                    // item was found, add it to linked items
                    richTextLinkedItems.push(existingLinkedItem);
                }
                else {
                    // item was not found or not yet resolved
                    if (preparedData) {
                        const mappedLinkedItemResult = this.mapElements({
                            dataToMap: preparedData,
                            preparedItems: preparedItems,
                            processingStartedForCodenames: processingStartedForCodenames,
                            processedItems: processedItems
                        });
                        // add mapped linked item to result
                        if (mappedLinkedItemResult) {
                            richTextLinkedItems.push(mappedLinkedItemResult.item);
                        }
                    }
                }
            }
        }
        // get rich text images
        const richTextImagesResult = this.getRichTextImages(rawElement.images);
        // extract and map links & images
        const links = this.mapRichTextLinks(rawElement.links);
        const images = richTextImagesResult.richTextImages;
        // replace asset urls in html
        const richTextHtml = this.getRichTextHtml(rawElement.value, richTextImagesResult.imageUrlRecords);
        return {
            images: images,
            linkedItemCodenames: rawElement.modular_content,
            linkedItems: richTextLinkedItems,
            links: links,
            name: rawElement.name,
            type: ElementType.RichText,
            value: richTextHtml
        };
    }
    mapDateTimeElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.DateTime, () => elementWrapper.rawElement.value);
    }
    mapMultipleChoiceElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.MultipleChoice, () => elementWrapper.rawElement.value);
    }
    mapNumberElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.Number, () => {
            if (elementWrapper.rawElement.value === 0) {
                return 0;
            }
            else if (elementWrapper.rawElement.value) {
                return +elementWrapper.rawElement.value;
            }
            return null;
        });
    }
    mapTextElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.Text, () => elementWrapper.rawElement.value);
    }
    mapAssetsElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.Asset, () => {
            var _a;
            const assetContracts = elementWrapper.rawElement.value;
            const assets = [];
            for (const assetContract of assetContracts) {
                let renditions = null;
                // get asset url (custom domain may be configured)
                const assetUrl = this.config.assetsDomain
                    ? deliveryUrlHelper.replaceAssetDomain(assetContract.url, this.config.assetsDomain)
                    : assetContract.url;
                if (assetContract.renditions) {
                    renditions = {};
                    for (const renditionPresetKey of Object.keys(assetContract.renditions)) {
                        const rendition = assetContract.renditions[renditionPresetKey];
                        renditions[renditionPresetKey] = Object.assign(Object.assign({}, rendition), { url: `${assetUrl}?${rendition.query}` // enhance rendition with absolute url
                         });
                    }
                }
                const renditionToBeApplied = (this.config.defaultRenditionPreset && (renditions === null || renditions === void 0 ? void 0 : renditions[this.config.defaultRenditionPreset])) || null;
                const finalUrl = (_a = renditionToBeApplied === null || renditionToBeApplied === void 0 ? void 0 : renditionToBeApplied.url) !== null && _a !== void 0 ? _a : assetUrl;
                const asset = Object.assign(Object.assign({}, assetContract), { url: finalUrl, // use custom url of asset which may contain custom domain and applied rendition
                    renditions });
                assets.push(asset);
            }
            return assets;
        });
    }
    mapTaxonomyElement(elementWrapper) {
        var _a;
        return Object.assign(Object.assign({}, this.buildElement(elementWrapper, ElementType.Taxonomy, () => elementWrapper.rawElement.value)), { taxonomyGroup: (_a = elementWrapper.rawElement.taxonomy_group) !== null && _a !== void 0 ? _a : null });
    }
    mapUnknowElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.Unknown, () => elementWrapper.rawElement.value);
    }
    mapCustomElement(elementWrapper) {
        // try to find element resolver
        if (this.config.elementResolver) {
            const elementResolverValue = this.config.elementResolver(elementWrapper);
            if (elementResolverValue) {
                return this.buildElement(elementWrapper, ElementType.Custom, () => elementResolverValue);
            }
        }
        return this.buildElement(elementWrapper, ElementType.Custom, () => elementWrapper.rawElement.value);
    }
    mapUrlSlugElement(elementWrapper) {
        return this.buildElement(elementWrapper, ElementType.UrlSlug, () => elementWrapper.rawElement.value);
    }
    mapLinkedItemsElement(data) {
        // prepare linked items
        const linkedItems = [];
        // value = array of item codenames
        const linkedItemCodenames = data.elementWrapper.rawElement.value;
        for (const codename of linkedItemCodenames) {
            if (this.canMapLinkedItems()) {
                const linkedItem = this.getOrSaveLinkedItemForElement(codename, data.elementWrapper.rawElement, data.processedItems, data.processingStartedForCodenames, data.preparedItems);
                if (linkedItem) {
                    // add item to result
                    linkedItems.push(linkedItem);
                }
            }
        }
        return Object.assign(Object.assign({}, this.buildElement(data.elementWrapper, ElementType.ModularContent, () => linkedItemCodenames)), { linkedItems: linkedItems });
    }
    getOrSaveLinkedItemForElement(codename, element, processedItems, mappingStartedForCodenames, preparedItems) {
        // first check if item was already resolved and return it if it was
        const processedItem = processedItems[codename];
        if (processedItem) {
            // item was already resolved
            return processedItem;
        }
        const preparedItem = preparedItems[codename];
        if (mappingStartedForCodenames.includes(codename)) {
            return preparedItem === null || preparedItem === void 0 ? void 0 : preparedItem.item;
        }
        mappingStartedForCodenames.push(codename);
        // throw error if item is not in response and errors are not skipped
        if (!preparedItem) {
            return undefined;
        }
        let mappedLinkedItem;
        // original resolving if item is still undefined
        const mappedLinkedItemResult = this.mapElements({
            dataToMap: preparedItem,
            preparedItems: preparedItems,
            processingStartedForCodenames: mappingStartedForCodenames,
            processedItems: processedItems
        });
        if (mappedLinkedItemResult) {
            mappedLinkedItem = mappedLinkedItemResult.item;
            // add to processed items
            processedItems[codename] = mappedLinkedItem;
        }
        return mappedLinkedItem;
    }
    mapRichTextLinks(linksJson) {
        const links = [];
        for (const linkId of Object.keys(linksJson)) {
            const linkRaw = linksJson[linkId];
            links.push({
                codename: linkRaw.codename,
                linkId: linkId,
                urlSlug: linkRaw.url_slug,
                type: linkRaw.type
            });
        }
        return links;
    }
    getRichTextHtml(richTextHtml, richTextImageRecords) {
        for (const richTextImageRecord of richTextImageRecords) {
            // replace rich text image url if it differs
            if (richTextImageRecord.newUrl !== richTextImageRecord.originalUrl) {
                richTextHtml = richTextHtml.replace(new RegExp(richTextImageRecord.originalUrl, 'g'), richTextImageRecord.newUrl);
            }
        }
        return richTextHtml;
    }
    getRichTextImages(imagesJson) {
        var _a, _b, _c;
        const images = [];
        const imageUrlRecords = [];
        for (const imageId of Object.keys(imagesJson)) {
            const imageRaw = imagesJson[imageId];
            // image may contain custom asset domain
            const imageUrl = this.config.assetsDomain
                ? deliveryUrlHelper.replaceAssetDomain(imageRaw.url, this.config.assetsDomain)
                : imageRaw.url;
            images.push({
                description: (_a = imageRaw.description) !== null && _a !== void 0 ? _a : null,
                imageId: imageRaw.image_id,
                url: imageUrl,
                height: (_b = imageRaw.height) !== null && _b !== void 0 ? _b : null,
                width: (_c = imageRaw.width) !== null && _c !== void 0 ? _c : null
            });
            imageUrlRecords.push({
                originalUrl: imageRaw.url,
                newUrl: imageUrl
            });
        }
        return {
            imageUrlRecords: imageUrlRecords,
            richTextImages: images
        };
    }
    resolveElementMap(item, originalElementCodename) {
        let resolvedElementPropertyName = undefined;
        if (this.config.propertyNameResolver) {
            resolvedElementPropertyName = this.config.propertyNameResolver(item.system.type, originalElementCodename);
        }
        if (!resolvedElementPropertyName) {
            // use original element codename
            resolvedElementPropertyName = originalElementCodename;
        }
        return {
            resolvedName: resolvedElementPropertyName,
            shouldMapElement: true
        };
    }
    buildElement(elementWrapper, type, valueFactory) {
        return {
            name: elementWrapper.rawElement.name,
            type: type,
            value: valueFactory()
        };
    }
    canMapLinkedItems() {
        if (!this.config.linkedItemsReferenceHandler) {
            return true;
        }
        return this.config.linkedItemsReferenceHandler === 'map';
    }
}
//# sourceMappingURL=element.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/item.mapper.js

class ItemMapper {
    constructor(config) {
        this.config = config;
        this.elementMapper = new ElementMapper(config);
    }
    /**
     * Maps single item to its proper strongly typed model from the given Kontent response
     * @param response Kontent response used to map the item
     * @param queryConfig Query configuration
     */
    mapSingleItemFromResponse(response) {
        const mapResult = this.mapItems({
            mainItems: [response.item],
            linkedItems: Object.values(response.modular_content),
        });
        return {
            item: mapResult.items[0],
            linkedItems: mapResult.linkedItems
        };
    }
    /**
     * Maps multiple items to their strongly typed model from the given Kontent response
     * @param response Kontent response used to map the item
     * @param queryConfig Query configuration
     */
    mapMultipleItemsFromResponse(response) {
        const mapResult = this.mapItems({
            mainItems: response.items,
            linkedItems: Object.values(response.modular_content)
        });
        return mapResult;
    }
    /**
     * Maps item contracts to full models
     */
    mapItems(data) {
        const that = this;
        const processedItems = {};
        const preparedItems = {};
        const processingStartedForCodenames = [];
        const mappedMainItems = [];
        const mappedLinkedItems = {};
        const itemsToResolve = [...data.mainItems, ...data.linkedItems];
        // first prepare reference for all items
        for (const item of itemsToResolve) {
            preparedItems[item.system.codename] = {
                item: this.createContentItem(item),
                rawItem: item
            };
        }
        // then resolve items
        for (const item of data.mainItems) {
            const itemResult = that.mapItem({
                item: preparedItems[item.system.codename],
                processedItems: processedItems,
                preparedItems: preparedItems,
                processingStartedForCodenames: processingStartedForCodenames
            });
            mappedMainItems.push(itemResult.item);
        }
        for (const item of data.linkedItems) {
            const itemResult = that.mapItem({
                item: preparedItems[item.system.codename],
                processedItems: processedItems,
                preparedItems: preparedItems,
                processingStartedForCodenames: processingStartedForCodenames
            });
            mappedLinkedItems[item.system.codename] = itemResult.item;
        }
        return {
            items: mappedMainItems,
            linkedItems: mappedLinkedItems
        };
    }
    /**
     * Maps item contract to full model
     */
    mapItem(data) {
        if (!data.item) {
            throw Error(`Could not map item because its undefined`);
        }
        const result = this.elementMapper.mapElements({
            dataToMap: data.item,
            preparedItems: data.preparedItems,
            processingStartedForCodenames: [],
            processedItems: data.processedItems,
        });
        if (!result) {
            throw Error(`Mapping of content item '${data.item.item.system.codename}' failed`);
        }
        return {
            item: result.item,
            processedItems: result.processedItems,
            preparedItems: result.preparedItems,
            processingStartedForCodenames: result.processingStartedForCodenames
        };
    }
    createContentItem(item) {
        var _a;
        const contentItem = {
            elements: {},
            system: {
                codename: item.system.codename,
                collection: item.system.collection,
                id: item.system.id,
                language: item.system.language,
                lastModified: item.system.last_modified,
                name: item.system.name,
                sitemapLocations: item.system.sitemap_locations,
                type: item.system.type,
                workflowStep: (_a = item.system.workflow_step) !== null && _a !== void 0 ? _a : null
            }
        };
        return contentItem;
    }
}
//# sourceMappingURL=item.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/taxonomy.mapper.js
class TaxonomyMapper {
    mapTaxonomy(taxonomySystem, taxonomyTerms) {
        if (!taxonomySystem) {
            throw Error(`Cannot map taxonomy due to missing 'system' property`);
        }
        if (!taxonomyTerms) {
            throw Error(`Cannot map taxonomy due to missing 'terms' property`);
        }
        if (!Array.isArray(taxonomyTerms)) {
            throw Error(`Cannot map terms because no terms array was provided`);
        }
        const mappedSystemAttributes = {
            name: taxonomySystem.name,
            codename: taxonomySystem.codename,
            id: taxonomySystem.id,
            lastModified: taxonomySystem.last_modified
        };
        const mappedTerms = this.mapTaxonomyTerms(taxonomyTerms);
        return {
            system: mappedSystemAttributes,
            terms: mappedTerms
        };
    }
    mapTaxonomies(taxonomies) {
        if (!taxonomies) {
            throw Error(`Cannot map taxonomy due to missing 'taxonomies' property`);
        }
        if (!Array.isArray(taxonomies)) {
            throw Error(`Cannot map taxonomies because the 'taxonomies' property is not an array `);
        }
        const mappedTaxonomies = [];
        taxonomies.forEach((taxonomy) => {
            mappedTaxonomies.push(this.mapTaxonomy(taxonomy.system, taxonomy.terms));
        });
        return mappedTaxonomies;
    }
    /**
     * Recursively map array of taxonomy terms
     * @param termsArray Terms array to map
     */
    mapTaxonomyTerms(termsArray) {
        if (termsArray.length === 0) {
            return [];
        }
        const mappedTermsArray = [];
        termsArray.forEach((terms) => {
            const mappedTerms = {
                codename: terms.codename,
                name: terms.name,
                terms: this.mapTaxonomyTerms(terms.terms)
            };
            mappedTermsArray.push(mappedTerms);
        });
        return mappedTermsArray;
    }
}
//# sourceMappingURL=taxonomy.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/type.mapper.js
class TypeMapper {
    mapSingleType(response) {
        return this.mapType(response);
    }
    mapMultipleTypes(response) {
        const that = this;
        return response.types.map(function (type) {
            return that.mapType(type);
        });
    }
    mapType(type) {
        if (!type) {
            throw Error(`Cannot map type`);
        }
        if (!type.elements) {
            throw Error(`Cannot map type elements`);
        }
        const system = {
            codename: type.system.codename,
            id: type.system.id,
            name: type.system.name,
            lastModified: type.system.last_modified
        };
        const elements = [];
        const elementNames = Object.getOwnPropertyNames(type.elements);
        elementNames.forEach((elementName) => {
            const typeElement = type.elements[elementName];
            if (!typeElement) {
                throw Error(`Cannot find element '${elementName}' on type '${type}'`);
            }
            // use json property as a codename of the type element
            const elementCodename = elementName;
            // extra properties for certain element types
            const taxonomyGroup = typeElement.taxonomy_group;
            const options = [];
            // some elements can contain options
            const rawOptions = typeElement.options;
            if (rawOptions) {
                if (!Array.isArray(rawOptions)) {
                    throw Error(`Content type 'options' property has to be an array`);
                }
                rawOptions.forEach((rawOption) => {
                    options.push({
                        codename: rawOption.codename,
                        name: rawOption.name
                    });
                });
            }
            elements.push({
                codename: elementCodename,
                taxonomyGroup: taxonomyGroup,
                options: options,
                name: typeElement.name,
                type: typeElement.type
            });
        });
        return {
            elements: elements,
            system: system
        };
    }
}
//# sourceMappingURL=type.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/generic-element.mapper.js
class GenericElementMapper {
    mapElement(response) {
        if (!response) {
            throw Error(`Invalid response for mapping element`);
        }
        return {
            codename: response.codename,
            name: response.name,
            type: response.type,
            options: response.options ? response.options : [],
            taxonomyGroup: response.taxonomy_group
        };
    }
}
//# sourceMappingURL=generic-element.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/language.mapper.js
class LanguageMapper {
    mapMultipleLanguages(response) {
        return response.languages.map((language) => {
            return this.mapLanguage(language);
        });
    }
    mapLanguage(language) {
        if (!language) {
            throw Error(`Cannot map language`);
        }
        return {
            system: language.system
        };
    }
}
//# sourceMappingURL=language.mapper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/mappers/index.js






//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/services/mapping.service.js

class MappingService {
    constructor(config) {
        this.config = config;
        this.typeMapper = new TypeMapper();
        this.languageMapper = new LanguageMapper();
        this.itemMapper = new ItemMapper(config);
        this.taxonomyMapper = new TaxonomyMapper();
        this.genericElementMapper = new GenericElementMapper();
    }
    /**
     * Gets response for list of languages
     * @param data Response data
     */
    listLanguagesResponse(data) {
        return {
            items: this.languageMapper.mapMultipleLanguages(data),
            pagination: this.mapPagination(data.pagination)
        };
    }
    /**
     * Gets response for getting a multiple type
     * @param data Response data
     */
    listContentTypesResponse(data) {
        return {
            items: this.typeMapper.mapMultipleTypes(data),
            pagination: this.mapPagination(data.pagination)
        };
    }
    /**
     * Gets response for single type
     * @param data Response data
     * @param options Options
     */
    viewContentTypeResponse(data) {
        return {
            type: this.typeMapper.mapSingleType(data)
        };
    }
    itemsFeedResponse(data) {
        const itemsResult = this.itemMapper.mapItems({
            linkedItems: Object.values(data.modular_content),
            mainItems: data.items
        });
        return {
            items: itemsResult.items,
            linkedItems: itemsResult.linkedItems
        };
    }
    /**
     * Gets response for getting single item
     * @param data Response data
     * @param queryConfig Query configuration
     */
    viewContentItemResponse(data) {
        const itemResult = this.itemMapper.mapSingleItemFromResponse(data);
        return {
            item: itemResult.item,
            linkedItems: itemResult.linkedItems
        };
    }
    /**
     * Gets response for getting multiple items
     * @param data Response data
     * @param queryConfig Query configuration
     */
    listContentItemsResponse(data) {
        const itemsResult = this.itemMapper.mapMultipleItemsFromResponse(data);
        return {
            items: itemsResult.items,
            pagination: this.mapPagination(data.pagination),
            linkedItems: itemsResult.linkedItems
        };
    }
    /**
     * Gets response for getting single taxonomy item
     * @param data Response data
     */
    viewTaxonomyResponse(data) {
        return {
            taxonomy: this.taxonomyMapper.mapTaxonomy(data.system, data.terms)
        };
    }
    /**
     * Gets response for getting multiples taxonomies
     * @param data Response data
     */
    listTaxonomiesResponse(data) {
        return {
            items: this.taxonomyMapper.mapTaxonomies(data.taxonomies),
            pagination: this.mapPagination(data.pagination)
        };
    }
    /**
     * Gets response for getting single content type element
     * @param data Response data
     */
    viewContentTypeElementResponse(data) {
        return {
            element: this.genericElementMapper.mapElement(data)
        };
    }
    mapPagination(paginationContract) {
        var _a;
        return {
            skip: paginationContract.skip,
            count: paginationContract.count,
            limit: paginationContract.limit,
            nextPage: paginationContract.next_page,
            totalCount: (_a = paginationContract.total_count) !== null && _a !== void 0 ? _a : null
        };
    }
}
//# sourceMappingURL=mapping.service.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/services/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/client/delivery-client.js




class DeliveryClient {
    /**
     * Delivery client used to fetch data from Kentico Kontent
     * @constructor
     * @param {IDeliveryClientConfig} config - The client configuration
     */
    constructor(config) {
        this.config = config;
        if (!config) {
            throw Error(`Delivery client configuration is not set`);
        }
        this.mappingService = new MappingService(config);
        this.queryService = new QueryService(config, config.httpService ? config.httpService : new HttpService(), {
            host: sdkInfo.host,
            name: sdkInfo.name,
            version: sdkInfo.version
        }, this.mappingService);
    }
    /**
     * Gets query for multiple languages
     */
    languages() {
        return new LanguagesQuery(this.config, this.queryService);
    }
    /**
     * Gets query for multiple types
     */
    types() {
        return new MultipleTypeQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single type
     * @param {string} typeCodename - Codename of the type to fetch
     */
    type(typeCodename) {
        return new SingleTypeQuery(this.config, this.queryService, typeCodename);
    }
    /**
     * Gets query for multiple items
     */
    items() {
        return new MultipleItemsQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single item
     * @param {string} codename - Codename of item to fetch
     */
    item(codename) {
        return new SingleItemQuery(this.config, this.queryService, codename);
    }
    /**
     * Gets query for items feed. Executes single HTTP request only. Might not get all items from your Kontent project.
     */
    itemsFeed() {
        return new ItemsFeedQuery(this.config, this.queryService);
    }
    /**
     * Gets query for single taxonomy
     * @param {string} codename - Codename of taxonomy to fetch
     */
    taxonomy(codename) {
        return new TaxonomyQuery(this.config, this.queryService, codename);
    }
    /**
     * Gets query for multiple taxonomies
     */
    taxonomies() {
        return new TaxonomiesQuery(this.config, this.queryService);
    }
    /**
     * Gets query for an element within a type
     * @param {string} typeCodename - Codename of the type
     * @param {string} elementCodename - Codename of the element
     */
    element(typeCodename, elementCodename) {
        return new ElementQuery(this.config, this.queryService, typeCodename, elementCodename);
    }
}
//# sourceMappingURL=delivery-client.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/client/delivery-client.factory.js

function createDeliveryClient(config) {
    return new DeliveryClient(config);
}
//# sourceMappingURL=delivery-client.factory.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/client/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/parser-configuration.js
const parser_configuration_parserConfiguration = {
    linkedItemWrapperElem: 'div',
    modularContentElementData: {
        type: 'application/kenticocloud',
        dataType: 'data-type',
        dataCodename: 'data-codename',
        relAttribute: 'data-rel',
        componentRel: 'component'
    },
    linkElementData: {
        nodeName: 'a',
        dataItemId: 'data-item-id',
    },
    imageElementData: {
        nodeName: 'img',
        dataImageId: 'data-image-id',
        srcAttribute: 'src'
    },
    resolvedLinkedItemIndexAttribute: 'data-sdk-item-index',
    resolvedAttribute: 'data-sdk-resolved'
};
//# sourceMappingURL=parser-configuration.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/parser.helper.js

class ParserHelper {
    constructor() {
        this.sdkResolvedAttributeName = 'data-sdk-resolved';
    }
    getLinkedItem(linkedItems, itemCodename) {
        if (!linkedItems) {
            return undefined;
        }
        return linkedItems.find((m) => m.system.codename === itemCodename);
    }
    tryGetImage(inputElement, linkedItems, imageId) {
        const elementImage = inputElement.images.find((m) => m.imageId === imageId);
        if (elementImage) {
            return elementImage;
        }
        // try to find image in all linked items
        if (linkedItems) {
            for (const linkedItem of linkedItems) {
                for (const elementKey of Object.keys(linkedItem.elements)) {
                    const element = linkedItem.elements[elementKey];
                    if (element.type === ElementType.RichText) {
                        const richTextElement = element;
                        const richTextElementImage = richTextElement.images.find((m) => m.imageId === imageId);
                        if (richTextElementImage) {
                            return richTextElementImage;
                        }
                    }
                }
            }
        }
        return undefined;
    }
    tryGetLink(inputElement, linkedItems, linkId) {
        const elementLink = inputElement.links.find((m) => m.linkId === linkId);
        if (elementLink) {
            return elementLink;
        }
        // try to find link in all linked items
        if (linkedItems) {
            for (const linkedItem of linkedItems) {
                for (const elementKey of Object.keys(linkedItem.elements)) {
                    const element = linkedItem.elements[elementKey];
                    if (element.type === ElementType.RichText) {
                        const richTextElement = element;
                        const richTextElementLink = richTextElement.links.find((m) => m.linkId === linkId);
                        if (richTextElementLink) {
                            return richTextElementLink;
                        }
                    }
                }
            }
        }
        return undefined;
    }
    convertToParserElement(element) {
        const attributes = [];
        for (let i = 0; i < element.attributes.length; i++) {
            const attribute = element.attributes[i];
            attributes.push({
                name: attribute.name,
                value: attribute.value
            });
        }
        return {
            tag: element.tagName,
            setAttribute: (attributeName, attributeValue) => {
                const attribute = element.attributes.getNamedItem(attributeName);
                if (attribute) {
                    attribute.value = attributeValue !== null && attributeValue !== void 0 ? attributeValue : '';
                }
                else {
                    element.setAttribute(attributeName, attributeValue !== null && attributeValue !== void 0 ? attributeValue : '');
                }
            },
            setInnerHtml: (newHtml) => (element.innerHTML = newHtml),
            setOuterHtml: (newHtml) => (element.outerHTML = newHtml),
            html: element.innerHTML,
            text: element.textContent ? element.textContent : undefined,
            attributes: attributes,
            parentElement: element.parentElement ? this.convertToParserElement(element.parentElement) : undefined,
            sourceElement: element
        };
    }
}
const parser_helper_parserHelper = new ParserHelper();
//# sourceMappingURL=parser.helper.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/parse-models.js
/**
 * This class as a wrapper is required so we can pass
 * index as a reference and not a value
 */
class ParsedItemIndexReferenceWrapper {
    constructor(index) {
        this.index = index;
    }
    increment() {
        this.index++;
    }
}
//# sourceMappingURL=parse-models.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/implementation/async-browser-parser.class.js
var async_browser_parser_class_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



class AsyncBrowserParser {
    parseAsync(html, mainRichTextElement, resolvers, linkedItems) {
        return async_browser_parser_class_awaiter(this, void 0, void 0, function* () {
            return yield this.parseInternalAsync(mainRichTextElement, resolvers, html, linkedItems, new ParsedItemIndexReferenceWrapper(0), null);
        });
    }
    parseInternalAsync(mainRichTextElement, resolvers, html, linkedItems, linkedItemIndex, parentElement) {
        return async_browser_parser_class_awaiter(this, void 0, void 0, function* () {
            const rootElement = this.createWrapperElement(html);
            // get all linked items
            const result = yield this.processRichTextElementAsync(mainRichTextElement, resolvers, rootElement.children, {
                links: [],
                linkedItems: [],
                images: []
            }, linkedItems, linkedItemIndex, parentElement);
            return {
                componentCodenames: result.linkedItems.filter((m) => m.itemType === 'component').map((m) => m.dataCodename),
                linkedItemCodenames: result.linkedItems
                    .filter((m) => m.itemType === 'linkedItem')
                    .map((m) => m.dataCodename),
                result: rootElement.innerHTML
            };
        });
    }
    processRichTextElementAsync(mainRichTextElement, resolvers, htmlCollection, result, linkedItems, linkedItemIndex, parentElement) {
        return async_browser_parser_class_awaiter(this, void 0, void 0, function* () {
            if (!htmlCollection || htmlCollection.length === 0) {
                // there are no more nodes
            }
            else {
                // extract objects
                for (let i = 0; i < htmlCollection.length; i++) {
                    const element = htmlCollection[i];
                    resolvers.elementResolverAsync(parser_helper_parserHelper.convertToParserElement(element));
                    const typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined;
                    // process linked items (modular items)
                    if (element.attributes &&
                        typeAttribute &&
                        typeAttribute.value &&
                        typeAttribute.value.toLowerCase() ===
                            parser_configuration_parserConfiguration.modularContentElementData.type.toLowerCase()) {
                        const dataCodenameAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.dataCodename);
                        const dataTypeAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.dataType);
                        if (!dataTypeAttribute) {
                            throw Error('Missing data type attribute. This is likely an error caused by invalid response.');
                        }
                        const relAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.relAttribute);
                        let itemType = 'linkedItem';
                        if (relAttribute &&
                            relAttribute.value === parser_configuration_parserConfiguration.modularContentElementData.componentRel) {
                            itemType = 'component';
                        }
                        // prepare link item object
                        const linkItemContentObject = {
                            dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                            dataType: dataTypeAttribute ? dataTypeAttribute.value : '',
                            itemType: itemType
                        };
                        // replace html
                        const elementParent = element.parentElement;
                        if (!elementParent) {
                            console.warn(`Could not replace linked item '${linkItemContentObject.dataCodename}' of '${linkItemContentObject.dataType}' because parent node is undefined. Please report this error if you are seeing this.`);
                        }
                        else {
                            if (dataTypeAttribute.value === 'item') {
                                // add to result
                                result.linkedItems.push(linkItemContentObject);
                                // resolve linked item
                                yield resolvers.contentItemResolverAsync(parser_helper_parserHelper.convertToParserElement(element), linkItemContentObject.dataCodename, linkedItemIndex.index, parser_helper_parserHelper.getLinkedItem(linkedItems, linkItemContentObject.dataCodename));
                                // increment index
                                linkedItemIndex.increment();
                            }
                            else {
                                console.warn(`Rich text element contains object with unsupported data type '${dataTypeAttribute.value}'`);
                            }
                        }
                    }
                    // process links
                    else if (element.nodeName.toLowerCase() === parser_configuration_parserConfiguration.linkElementData.nodeName.toLowerCase()) {
                        const dataItemIdAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.linkElementData.dataItemId);
                        if (dataItemIdAttribute) {
                            const linkObject = {
                                dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                            };
                            // add to result
                            result.links.push(linkObject);
                            // get original link text (the one inside <a> tag)
                            const linkText = element.innerHTML;
                            yield resolvers.urlResolverAsync(parser_helper_parserHelper.convertToParserElement(element), linkObject.dataItemId, linkText, parser_helper_parserHelper.tryGetLink(mainRichTextElement, linkedItems, linkObject.dataItemId));
                        }
                    }
                    // process images
                    else if (element.nodeName.toLowerCase() === parser_configuration_parserConfiguration.imageElementData.nodeName.toLowerCase()) {
                        const dataImageIdAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.imageElementData.dataImageId);
                        // continue only if data image id is present. There could be regular img tags included
                        if (dataImageIdAttribute) {
                            const imageObj = {
                                imageId: dataImageIdAttribute.value
                            };
                            result.images.push(imageObj);
                            // resolve image
                            yield resolvers.imageResolverAsync(parser_helper_parserHelper.convertToParserElement(element), imageObj.imageId, parser_helper_parserHelper.tryGetImage(mainRichTextElement, linkedItems, imageObj.imageId));
                        }
                    }
                    else {
                        // process generic elements
                        yield resolvers.genericElementResolverAsync(parser_helper_parserHelper.convertToParserElement(element));
                    }
                    // recursively process child nodes
                    if (element.children && element.children.length > 0) {
                        yield this.processRichTextElementAsync(mainRichTextElement, resolvers, element.children, result, linkedItems, linkedItemIndex, parentElement);
                    }
                }
            }
            return result;
        });
    }
    createWrapperElement(html) {
        const element = document.createElement(parser_configuration_parserConfiguration.linkedItemWrapperElem);
        element.innerHTML = html;
        return element;
    }
}
const async_browser_parser_class_asyncBrowserParser = new AsyncBrowserParser();
//# sourceMappingURL=async-browser-parser.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/implementation/browser-parser.class.js



class BrowserParser {
    parse(html, mainRichTextElement, resolvers, linkedItems) {
        return this.parseInternal(mainRichTextElement, resolvers, html, linkedItems, new ParsedItemIndexReferenceWrapper(0), null);
    }
    parseInternal(mainRichTextElement, resolvers, html, linkedItems, linkedItemIndex, parentElement) {
        const rootElement = this.createWrapperElement(html);
        // get all linked items
        const result = this.processRichTextElement(mainRichTextElement, resolvers, rootElement.children, {
            links: [],
            linkedItems: [],
            images: []
        }, linkedItems, linkedItemIndex, parentElement);
        return {
            componentCodenames: result.linkedItems.filter((m) => m.itemType === 'component').map((m) => m.dataCodename),
            linkedItemCodenames: result.linkedItems
                .filter((m) => m.itemType === 'linkedItem')
                .map((m) => m.dataCodename),
            result: rootElement.innerHTML
        };
    }
    processRichTextElement(mainRichTextElement, resolvers, htmlCollection, result, linkedItems, linkedItemIndex, parentElement) {
        if (!htmlCollection || htmlCollection.length === 0) {
            // there are no more nodes
        }
        else {
            // extract objects
            for (let i = 0; i < htmlCollection.length; i++) {
                const element = htmlCollection[i];
                resolvers.elementResolver(parser_helper_parserHelper.convertToParserElement(element));
                const typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined;
                // process linked items (modular items)
                if (element.attributes &&
                    typeAttribute &&
                    typeAttribute.value &&
                    typeAttribute.value.toLowerCase() ===
                        parser_configuration_parserConfiguration.modularContentElementData.type.toLowerCase()) {
                    const dataCodenameAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.dataCodename);
                    const dataTypeAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.dataType);
                    if (!dataTypeAttribute) {
                        throw Error('Missing data type attribute. This is likely an error caused by invalid response.');
                    }
                    const relAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.modularContentElementData.relAttribute);
                    let itemType = 'linkedItem';
                    if (relAttribute &&
                        relAttribute.value === parser_configuration_parserConfiguration.modularContentElementData.componentRel) {
                        itemType = 'component';
                    }
                    // prepare link item object
                    const linkItemContentObject = {
                        dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                        dataType: dataTypeAttribute ? dataTypeAttribute.value : '',
                        itemType: itemType
                    };
                    const elementParent = element.parentElement;
                    if (!elementParent) {
                        console.warn(`Could not replace linked item '${linkItemContentObject.dataCodename}' of '${linkItemContentObject.dataType}' because parent node is undefined. Please report this error if you are seeing this.`);
                    }
                    else {
                        if (dataTypeAttribute.value === 'item') {
                            // add to result
                            result.linkedItems.push(linkItemContentObject);
                            // resolve linked item
                            resolvers.contentItemResolver(parser_helper_parserHelper.convertToParserElement(element), linkItemContentObject.dataCodename, linkedItemIndex.index, parser_helper_parserHelper.getLinkedItem(linkedItems, linkItemContentObject.dataCodename));
                            // increment index
                            linkedItemIndex.increment();
                        }
                        else {
                            console.warn(`Rich text element contains object with unsupported data type '${dataTypeAttribute.value}'`);
                        }
                    }
                }
                // process links
                else if (element.nodeName.toLowerCase() === parser_configuration_parserConfiguration.linkElementData.nodeName.toLowerCase()) {
                    const dataItemIdAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.linkElementData.dataItemId);
                    if (dataItemIdAttribute) {
                        const linkObject = {
                            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                        };
                        // add to result
                        result.links.push(linkObject);
                        // get original link text (the one inside <a> tag)
                        const linkText = element.innerHTML;
                        resolvers.urlResolver(parser_helper_parserHelper.convertToParserElement(element), linkObject.dataItemId, linkText, parser_helper_parserHelper.tryGetLink(mainRichTextElement, linkedItems, linkObject.dataItemId));
                    }
                }
                // process images
                else if (element.nodeName.toLowerCase() === parser_configuration_parserConfiguration.imageElementData.nodeName.toLowerCase()) {
                    const dataImageIdAttribute = element.attributes.getNamedItem(parser_configuration_parserConfiguration.imageElementData.dataImageId);
                    // continue only if data image id is present. There could be regular img tags included
                    if (dataImageIdAttribute) {
                        const imageObj = {
                            imageId: dataImageIdAttribute.value
                        };
                        result.images.push(imageObj);
                        // resolve image
                        resolvers.imageResolver(parser_helper_parserHelper.convertToParserElement(element), imageObj.imageId, parser_helper_parserHelper.tryGetImage(mainRichTextElement, linkedItems, imageObj.imageId));
                    }
                }
                else {
                    // process generic elements
                    resolvers.genericElementResolver(parser_helper_parserHelper.convertToParserElement(element));
                }
                // recursively process child nodes
                if (element.children && element.children.length > 0) {
                    this.processRichTextElement(mainRichTextElement, resolvers, element.children, result, linkedItems, linkedItemIndex, parentElement);
                }
            }
        }
        return result;
    }
    createWrapperElement(html) {
        const element = document.createElement(parser_configuration_parserConfiguration.linkedItemWrapperElem);
        element.innerHTML = html;
        return element;
    }
}
const browser_parser_class_browserParser = new BrowserParser();
//# sourceMappingURL=browser-parser.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/parser/index.js





//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/property-name/camel-case-property-name-resolver.class.js

const camelCasePropertyNameResolver = (contentType, element) => {
    return textHelper.addUnderscoreWhenStarsWithNumber(textHelper.removeZeroWidthCharacters(camelize(element)));
};
function camelize(str) {
    str = str.replace(textHelper.getPropertyNameRegex(), (_, c) => (c ? c.toUpperCase() : ''));
    return str.substring(0, 1).toLowerCase() + str.substring(1);
}
//# sourceMappingURL=camel-case-property-name-resolver.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/property-name/pascal-case-property-name-resolver.class.js

const pascalCasePropertyNameResolver = (contentType, element) => {
    return textHelper.addUnderscoreWhenStarsWithNumber(textHelper.removeZeroWidthCharacters(pascal_case_property_name_resolver_class_camelize(element)));
};
function pascal_case_property_name_resolver_class_camelize(str) {
    str = str.replace(textHelper.getPropertyNameRegex(), (_, c) => (c ? c.toUpperCase() : ''));
    return str.substring(0, 1).toUpperCase() + str.substring(1);
}
//# sourceMappingURL=pascal-case-property-name-resolver.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/property-name/snake-case-property-name-resolver.class.js

const snakeCasePropertyNameResolver = (contentType, element) => {
    return textHelper
        .addUnderscoreWhenStarsWithNumber(textHelper.removeZeroWidthCharacters(toSnakeCase(element)))
        .toLowerCase();
};
function toSnakeCase(str) {
    str = str.replace(textHelper.getPropertyNameRegex(), (_, c) => '_' + (c ? c.toLowerCase() : ''));
    return removeEndUnderscore(removeStartUnderscore(str));
}
function removeStartUnderscore(str) {
    if (!str.startsWith('_')) {
        return str;
    }
    return str.substring(1);
}
function removeEndUnderscore(str) {
    if (!str.endsWith('_')) {
        return str;
    }
    return str.slice(0, -1);
}
//# sourceMappingURL=snake-case-property-name-resolver.class.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/rich-text/sync/rich-text-html-resolver.js


class RichTextHtmlResolver extends (/* unused pure expression or super */ null && (BaseRichTextResolver)) {
    constructor(parser) {
        super(browserParser, parser);
    }
    resolveRichText(input) {
        return this.resolveRichTextInternal(input.element.value, input);
    }
    resolveRichTextInternal(html, input) {
        var _a;
        const parsedResult = super.getParser().parse(html, input.element, {
            elementResolver: (element) => { },
            contentItemResolver: (element, itemCodename, linkedItemIndex, linkedItem) => {
                var _a;
                const parentElement = element.parentElement;
                if (parentElement) {
                    const resolvedItemHtml = input.contentItemResolver
                        ? (_a = input.contentItemResolver(itemCodename, linkedItem).contentItemHtml) !== null && _a !== void 0 ? _a : ''
                        : '';
                    // resursively resolve HTML
                    const innerHtml = this.resolveRichTextInternal(resolvedItemHtml, input).html;
                    // set resolved html
                    if (input.preserveResolvedObjectTags === true) {
                        element.setInnerHtml(innerHtml);
                    }
                    else {
                        element.setOuterHtml(innerHtml);
                    }
                    // set resolved attribute
                    element.setAttribute(parserHelper.sdkResolvedAttributeName, '1');
                }
            },
            genericElementResolver: (element) => {
                // do nothing to generic elements
            },
            imageResolver: (element, imageId, image) => {
                // get image result
                const imageResult = input.imageResolver ? input.imageResolver(imageId, image) : undefined;
                // html has priority over url resolver
                if (imageResult === null || imageResult === void 0 ? void 0 : imageResult.imageHtml) {
                    // replace link html
                    element.setOuterHtml(imageResult.imageHtml);
                }
                else if (imageResult === null || imageResult === void 0 ? void 0 : imageResult.imageUrl) {
                    // set link url only
                    element.setAttribute(parserConfiguration.imageElementData.srcAttribute, imageResult.imageUrl);
                }
            },
            urlResolver: (element, linkId, linkText, link) => {
                if (input.urlResolver) {
                    const urlResult = input.urlResolver(linkId, linkText, link);
                    // html has priority over url resolver
                    if (urlResult === null || urlResult === void 0 ? void 0 : urlResult.linkHtml) {
                        // replace link html
                        element.setOuterHtml(urlResult.linkHtml);
                    }
                    else if (urlResult === null || urlResult === void 0 ? void 0 : urlResult.linkUrl) {
                        // set link url only
                        element.setAttribute('href', urlResult.linkUrl);
                    }
                }
            }
        }, (_a = input.linkedItems) !== null && _a !== void 0 ? _a : []);
        return {
            componentCodenames: parsedResult.componentCodenames,
            linkedItemCodenames: parsedResult.linkedItemCodenames,
            html: parsedResult.result
        };
    }
}
const createRichTextHtmlResolver = (parser) => new RichTextHtmlResolver(parser);
//# sourceMappingURL=rich-text-html-resolver.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/rich-text/sync/rich-text-object-resolver.js



class RichTextObjectResolver extends (/* unused pure expression or super */ null && (BaseRichTextResolver)) {
    constructor(parser) {
        super(browserParser, parser);
        this.sdkIdAttributeName = 'sdk-elem-id';
        this.rootId = 'root';
        this.defaultWrapTag = 'div';
    }
    resolveRichText(input) {
        var _a;
        const result = this.resolveRichTextInternal(input.element.value, input, {
            type: 'root',
            attributes: [],
            children: [],
            data: {},
            tag: (_a = input.wrapperTag) !== null && _a !== void 0 ? _a : this.defaultWrapTag,
            _sdkElemId: this.rootId
        });
        if (input.cleanSdkIds === true) {
            this.cleanSdkIds(result);
        }
        return {
            data: result
        };
    }
    resolveRichTextInternal(html, input, result) {
        var _a;
        super.getParser().parse(html, input.element, {
            elementResolver: (element) => {
                // generate guid for each element
                element.setAttribute(this.sdkIdAttributeName, guidHelper.genereateGuid());
            },
            contentItemResolver: (element, itemCodename, linkedItemIndex, linkedItem) => {
                const data = {
                    codename: itemCodename,
                    item: linkedItem
                };
                const parentSdkId = this.getSdkIdFromElement(element.parentElement);
                const parentItem = this.findItemWithSdkId(parentSdkId, result);
                if (parentItem) {
                    parentItem.children.push({
                        type: 'linkedItem',
                        attributes: this.getAttributes(element),
                        tag: element.tag.toLowerCase(),
                        data: data,
                        children: [],
                        _sdkElemId: this.getSdkIdFromElement(element)
                    });
                }
            },
            genericElementResolver: (element) => {
                var _a, _b;
                const data = {
                    text: (_a = element.text) !== null && _a !== void 0 ? _a : '',
                    html: (_b = element.html) !== null && _b !== void 0 ? _b : ''
                };
                const parentSdkId = this.getSdkIdFromElement(element.parentElement);
                const parentItem = this.findItemWithSdkId(parentSdkId, result);
                if (parentItem) {
                    parentItem.children.push({
                        type: 'htmlElement',
                        attributes: this.getAttributes(element),
                        tag: element.tag.toLowerCase(),
                        data: data,
                        children: [],
                        _sdkElemId: this.getSdkIdFromElement(element)
                    });
                }
            },
            imageResolver: (element, imageId, image) => {
                const data = {
                    imageId: imageId,
                    image: image
                };
                const parentSdkId = this.getSdkIdFromElement(element.parentElement);
                const parentItem = this.findItemWithSdkId(parentSdkId, result);
                if (parentItem) {
                    parentItem.children.push({
                        type: 'image',
                        attributes: this.getAttributes(element),
                        tag: element.tag.toLowerCase(),
                        data: data,
                        children: [],
                        _sdkElemId: this.getSdkIdFromElement(element)
                    });
                }
            },
            urlResolver: (element, linkId, linkText, link) => {
                const data = {
                    linkId: linkId,
                    linkText: linkText,
                    link: link
                };
                const parentSdkId = this.getSdkIdFromElement(element.parentElement);
                const parentItem = this.findItemWithSdkId(parentSdkId, result);
                if (parentItem) {
                    parentItem.children.push({
                        type: 'link',
                        attributes: this.getAttributes(element),
                        tag: element.tag.toLowerCase(),
                        data: data,
                        children: [],
                        _sdkElemId: this.getSdkIdFromElement(element)
                    });
                }
            }
        }, (_a = input.linkedItems) !== null && _a !== void 0 ? _a : []);
        return result;
    }
    findItemWithSdkId(sdkId, item) {
        if (item._sdkElemId === sdkId) {
            return item;
        }
        for (const child of item.children) {
            const foundItem = this.findItemWithSdkId(sdkId, child);
            if (foundItem) {
                return foundItem;
            }
        }
        return undefined;
    }
    getAttributes(element) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.attributes) !== null && _a !== void 0 ? _a : [];
    }
    getSdkIdFromElement(element) {
        var _a, _b;
        if (!element) {
            return this.rootId;
        }
        const value = (_b = (_a = element.attributes.find((m) => m.name === this.sdkIdAttributeName)) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : this.rootId;
        return value;
    }
    cleanSdkIds(item) {
        item.attributes = item.attributes.filter((m) => m.name !== this.sdkIdAttributeName);
        item._sdkElemId = '';
        for (const child of item.children) {
            this.cleanSdkIds(child);
        }
    }
}
const rich_text_object_resolver_createRichTextObjectResolver = (parser) => new RichTextObjectResolver(parser);
//# sourceMappingURL=rich-text-object-resolver.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/rich-text/sync/rich-text-json-resolver.js



class RichTextJsonResolver extends (/* unused pure expression or super */ null && (BaseRichTextResolver)) {
    constructor(parser) {
        super(browserParser, parser);
    }
    resolveRichText(input) {
        const objectResult = createRichTextObjectResolver(this.getParser()).resolveRichText(input).data;
        return {
            json: JSON.stringify(objectResult)
        };
    }
}
const createRichTextJsonResolver = (parser) => new RichTextJsonResolver(parser);
//# sourceMappingURL=rich-text-json-resolver.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/rich-text/async/async-rich-text-html-resolver.js
var async_rich_text_html_resolver_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class AsyncRichTextHtmlResolver extends (/* unused pure expression or super */ null && (BaseAsyncRichTextResolver)) {
    constructor(parser) {
        super(asyncBrowserParser, parser);
    }
    resolveRichTextAsync(input) {
        return async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
            return yield this.resolveRichTextInternalAsync(input.element.value, input);
        });
    }
    resolveRichTextInternalAsync(html, input) {
        const _super = Object.create(null, {
            getAsyncParser: { get: () => super.getAsyncParser }
        });
        var _a;
        return async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
            const parsedResult = yield _super.getAsyncParser.call(this).parseAsync(html, input.element, {
                elementResolverAsync: (element) => async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () { }),
                contentItemResolverAsync: (element, itemCodename, linkedItemIndex, linkedItem) => async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
                    var _b;
                    const parentElement = element.parentElement;
                    if (parentElement) {
                        const resolvedItemHtml = input.contentItemResolverAsync
                            ? (_b = (yield input.contentItemResolverAsync(itemCodename, linkedItem)).contentItemHtml) !== null && _b !== void 0 ? _b : ''
                            : '';
                        // resursively resolve HTML
                        const innerHtml = (yield this.resolveRichTextInternalAsync(resolvedItemHtml, input)).html;
                        // set resolved html
                        if (input.preserveResolvedObjectTags === true) {
                            element.setInnerHtml(innerHtml);
                        }
                        else {
                            element.setOuterHtml(innerHtml);
                        }
                        // set resolved attribute
                        element.setAttribute(parserHelper.sdkResolvedAttributeName, '1');
                    }
                }),
                genericElementResolverAsync: (element) => async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
                    // do nothing to generic elements
                }),
                imageResolverAsync: (element, imageId, image) => async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
                    // get image result
                    const imageResult = input.imageResolverAsync
                        ? yield input.imageResolverAsync(imageId, image)
                        : undefined;
                    // html has priority over url resolver
                    if (imageResult === null || imageResult === void 0 ? void 0 : imageResult.imageHtml) {
                        // replace link html
                        element.setOuterHtml(imageResult.imageHtml);
                    }
                    else if (imageResult === null || imageResult === void 0 ? void 0 : imageResult.imageUrl) {
                        // set link url only
                        element.setAttribute(parserConfiguration.imageElementData.srcAttribute, imageResult.imageUrl);
                    }
                }),
                urlResolverAsync: (element, linkId, linkText, link) => async_rich_text_html_resolver_awaiter(this, void 0, void 0, function* () {
                    if (input.urlResolverAsync) {
                        const urlResult = yield input.urlResolverAsync(linkId, linkText, link);
                        // html has priority over url resolver
                        if (urlResult === null || urlResult === void 0 ? void 0 : urlResult.linkHtml) {
                            // replace link html
                            element.setOuterHtml(urlResult.linkHtml);
                        }
                        else if (urlResult === null || urlResult === void 0 ? void 0 : urlResult.linkUrl) {
                            // set link url only
                            element.setAttribute('href', urlResult.linkUrl);
                        }
                    }
                })
            }, (_a = input.linkedItems) !== null && _a !== void 0 ? _a : []);
            return {
                componentCodenames: parsedResult.componentCodenames,
                linkedItemCodenames: parsedResult.linkedItemCodenames,
                html: parsedResult.result
            };
        });
    }
}
const createAsyncRichTextHtmlResolver = (parser) => new AsyncRichTextHtmlResolver(parser);
//# sourceMappingURL=async-rich-text-html-resolver.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/resolvers/index.js








//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/images/image-url-transformation-builder.js

class image_url_transformation_builder_ImageUrlTransformationBuilder {
    constructor(
    /** Image url */
    imageUrl) {
        this.imageUrl = imageUrl;
        this.queryParams = [];
        this.automaticFormatValue = 'format';
    }
    /**
     * Used to add custom parameters to existing query string
     * @param param Parameter (may or may not include value)
     */
    withCustomParam(param) {
        this.queryParams.push(new Parameters.CustomParameter(param));
        return this;
    }
    /**
     * The dpr transformation is used to serve correctly sized images for devices that expose a device pixel ratio.
     * @param dpr A required DPR value.
     */
    withDpr(dpr) {
        this.queryParams.push(new Parameters.QueryParameter('dpr', dpr.toString()));
        return this;
    }
    /**
     * Applies the crop transformation that removes pixels from an image outside the specified rectangle.
     * @param x Rectangle offset on the X-axis.
     * @param y Rectangle offset on the Y-axis.
     * @param width Rectangle width.
     * @param height Rectangle height.
     */
    withRectangleCrop(x, y, width, height) {
        this.queryParams.push(new Parameters.QueryParameter('rect', [x, y, width, height].join(',')));
        return this;
    }
    /**
     * Applies the crop transformation centered on the specified point.
     * @param x Focal point X coordinate.
     * @param y Focal point Y coordinate.
     * @param z Zoom of the transformation.
     */
    withFocalPointCrop(x, y, z) {
        this.withFitMode('crop');
        this.queryParams.push(new Parameters.QueryParameter('crop', 'focalpoint'));
        this.queryParams.push(new Parameters.QueryParameter('fp-x', x.toString()));
        this.queryParams.push(new Parameters.QueryParameter('fp-y', y.toString()));
        this.queryParams.push(new Parameters.QueryParameter('fp-z', z.toString()));
        return this;
    }
    /**
     * Enables WebP image support.
     * @param compression Specifies the lossy or lossless compression.
     */
    withAutomaticFormat(backupFormat) {
        this.queryParams.push(new Parameters.QueryParameter('auto', this.automaticFormatValue));
        if (backupFormat) {
            this.withFormat(backupFormat);
        }
        return this;
    }
    /**
     * The fit transformation controls how the output image is fit to its target dimensions after resizing.
     * @param fitMode Specifies the mode for the transformation.
     */
    withFitMode(fitMode) {
        this.queryParams.push(new Parameters.QueryParameter('fit', fitMode));
        return this;
    }
    /**
     * Specifies the compression mode for the WebP image transformations.
     * @param compression Specifies the lossy or lossless compression.
     */
    withCompression(compression) {
        this.queryParams.push(new Parameters.QueryParameter('lossless', compression === 'lossless' ? 'true' : 'false'));
        return this;
    }
    /**
     * Applies the quality parameter that enables control over the compression level for lossy file-formatted images.
     * @param quality The required quality of the image.
     */
    withQuality(quality) {
        this.queryParams.push(new Parameters.QueryParameter('q', quality.toString()));
        return this;
    }
    /**
     * The format transformation enables the source image to be converted (a.k.a., "transcoded") from
     * one encoded format to another. This is very useful when the source image has been saved in a sub-optimal
     * file format that hinders performance.
     * @param format Target image file type.
     */
    withFormat(format) {
        this.queryParams.push(new Parameters.QueryParameter('fm', format));
        return this;
    }
    /**
     * The height transformation enables dynamic height resizing based on pixels and percent values.
     * @param height A required image height.
     */
    withHeight(height) {
        this.queryParams.push(new Parameters.QueryParameter('h', height.toString()));
        return this;
    }
    /**
     * The width transformation enables dynamic width resizing based on pixels and percent values.
     * @param width A required image width.
     */
    withWidth(width) {
        this.queryParams.push(new Parameters.QueryParameter('w', width.toString()));
        return this;
    }
    /**
     * Gets params applied to image
     */
    getParams() {
        return this.queryParams;
    }
    /**
     * Gets query string part of the image URL
     */
    getQueryString() {
        let query = '';
        this.queryParams.forEach(filter => {
            if (query.indexOf('?') > -1) {
                query = query + '&' + filter.getParam();
            }
            else {
                query = query + '?' + filter.getParam();
            }
        });
        return query;
    }
    /**
     * Gets full transformed url to image with parameters
     */
    getUrl() {
        return this.imageUrl + this.getQueryString();
    }
}
//# sourceMappingURL=image-url-transformation-builder.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/images/image-url-transformation-builder.factory.js

function transformImageUrl(url) {
    return new ImageUrlTransformationBuilder(url);
}
//# sourceMappingURL=image-url-transformation-builder.factory.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/images/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@kentico/kontent-delivery/dist/es6/index.js
// Public API













//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./src/config/Config.bs.js
var Config_bs = __webpack_require__(43217);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/utils/authUtils.ts
var authUtils = __webpack_require__(89090);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
;// CONCATENATED MODULE: ./src/api/helpers.ts











var getUrlFromPath = function(path) {
    return "".concat("https://www.prezzee.co.nz/").concat(path);
};
/**
 * Creates a new fetch request with correct server URL and headers.
 * @param path Relative api path to create request with.
 * @param optionsParam Default request options object extending custom auth and user agent header options.
 * @returns Generated fetch promise.
 */ var createRequest = function(path, optionsParam) {
    var _ref = optionsParam || {}, _isUrl = _ref.isUrl, isUrl = _isUrl === void 0 ? false : _isUrl, _logRequest = _ref.logRequest, logRequest = _logRequest === void 0 ? false : _logRequest, _withAuth = _ref.withAuth, withAuth = _withAuth === void 0 ? false : _withAuth, _withSecurityToken = _ref.withSecurityToken, withSecurityToken = _withSecurityToken === void 0 ? false : _withSecurityToken, _withMagicUserAgent = _ref.withMagicUserAgent, withMagicUserAgent = _withMagicUserAgent === void 0 ? false : _withMagicUserAgent, _withAuthHeaderFromServer = _ref.withAuthHeaderFromServer, withAuthHeaderFromServer = _withAuthHeaderFromServer === void 0 ? false : _withAuthHeaderFromServer, otherHeaders = _ref.otherHeaders, otherOptions = (0,_object_without_properties/* default */.Z)(_ref, [
        "isUrl",
        "logRequest",
        "withAuth",
        "withSecurityToken",
        "withMagicUserAgent",
        "withAuthHeaderFromServer",
        "otherHeaders"
    ]);
    var headers = {
        "content-type": "application/json",
        accept: "application/json"
    };
    var fingerprint = js_cookie_default().get("fingerprint-pz");
    if (withAuth) {
        var userCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
        var decryptedUser = userCookie ? (0,authUtils/* decryptUserCookie */.x)(userCookie) : undefined;
        var isMasq = decryptedUser === null || decryptedUser === void 0 ? void 0 : decryptedUser.masquerade;
        var tokenType = isMasq ? "Masq" : "Bearer";
        headers["Authorization"] = withAuthHeaderFromServer ? "".concat(tokenType, " ").concat(withAuthHeaderFromServer) : "".concat(tokenType, " ").concat((0,AuthUtils_bs/* getToken */.LP)());
    }
    if (fingerprint) headers["x-device-fingerprint"] = fingerprint;
    if (withMagicUserAgent) headers["User-Agent"] = Config_bs/* magicUserAgentHeader */.YI;
    if (withSecurityToken) {
        var sessionId = getSessionIdToken();
        if (sessionId) headers["X-SECURITY-SESSIONID"] = sessionId;
    }
    headers = (0,_object_spread/* default */.Z)({}, headers, otherHeaders);
    var url = isUrl ? path : getUrlFromPath(path);
    var request = (0,_object_spread/* default */.Z)({
        headers: headers
    }, otherOptions);
    if (logRequest) {
        var headerlessRequest = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, request), {
            headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
                Authorization: ""
            })
        });
        logger/* default.info */.ZP.info({
            message: "Request " + url,
            headerlessRequest: headerlessRequest
        });
    }
    return fetch(url, request).then(function(response) {
        if (logRequest) {
            logger/* default.info */.ZP.info({
                message: "Response " + url,
                response: response
            });
        }
        return response;
    });
};
var waitForWindowObject = function(variablePath) {
    var maxRetries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, checkInterval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    return new Promise(function(resolve, reject) {
        var attempts = 0;
        var intervalId = setInterval(function() {
            attempts++;
            var parts = variablePath.split(".");
            var obj = window;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    obj = obj[part];
                    if (!obj) {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (obj) {
                clearInterval(intervalId);
                resolve(obj);
            } else if (attempts >= maxRetries) {
                clearInterval(intervalId);
                reject(new Error("Object ".concat(variablePath, " not found after ").concat(maxRetries, " attempts.")));
            }
        }, checkInterval);
    });
};
var getSessionIdToken = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _updateConfig = ref.updateConfig, updateConfig = _updateConfig === void 0 ? true : _updateConfig, _resetToken = ref.resetToken, resetToken = _resetToken === void 0 ? false : _resetToken;
    var sessionId = js_cookie_default().get("sessionIdToken");
    if (!sessionId || resetToken) {
        var date = new Date();
        date.setMinutes(date.getMinutes() + 60); // add 30 minutes to the current time
        sessionId = (0,v4/* default */.Z)();
        js_cookie_default().set("sessionIdToken", sessionId, {
            expires: date
        });
        if (updateConfig && "object" !== "undefined") {
            waitForWindowObject("sardineContext").then(function() {
                window.sardineContext.updateConfig({
                    sessionKey: sessionId
                });
            }).catch(function(error) {
                logger/* default.error */.ZP.error({
                    error: error
                }, "Failed to update sardine context with session key");
            });
        }
    }
    return sessionId;
};
var helpers_createDeliveryClient = function(language, isPreview) {
    var deliveryClient = createDeliveryClient((0,_define_property/* default */.Z)({
        projectId: "7af951a6-2a13-004b-f0eb-a87382a5b2e7",
        defaultLanguage: language,
        defaultQueryConfig: (0,_define_property/* default */.Z)({}, isPreview ? "usePreviewMode" : "useSecuredMode", true)
    }, isPreview ? "previewApiKey" : "secureApiKey", isPreview ? "ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogImNjMWI3NTVjMWFlZjQ3NTJhYWQ1ZDNiNmY0MzlmYjcwIiwNCiAgImlhdCI6ICIxNjE2NTYzNDc4IiwNCiAgImV4cCI6ICIxOTYyMTYzNDc4IiwNCiAgInZlciI6ICIxLjAuMCIsDQogICJwcm9qZWN0X2lkIjogIjdhZjk1MWE2MmExMzAwNGJmMGViYTg3MzgyYTViMmU3IiwNCiAgImF1ZCI6ICJwcmV2aWV3LmRlbGl2ZXIua2VudGljb2Nsb3VkLmNvbSINCn0.vsX6XZnK6-3drNTffJhFTcCUPzTt5ASBrUIWanR8p-I" : "ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogImM5YTJiYWI4NDQxMDQwYjViNDQzNTk4NTMwZjg1NTc1IiwNCiAgImlhdCI6ICIxNjE2NjUxOTM4IiwNCiAgImV4cCI6ICIxOTYyMjUxOTM4IiwNCiAgInZlciI6ICIxLjAuMCIsDQogICJwcm9qZWN0X2lkIjogIjdhZjk1MWE2MmExMzAwNGJmMGViYTg3MzgyYTViMmU3IiwNCiAgImF1ZCI6ICJkZWxpdmVyLmtlbnRpY29jbG91ZC5jb20iDQp9.1-Q179jJjnoEa4IjM0PHAxTnM2bjuKY1t_KWR3iO0yA"));
    return deliveryClient;
};


/***/ }),

/***/ 61760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var api_handleErrors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19700);
/* harmony import */ var api_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60693);
/* harmony import */ var js_convert_case__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24417);



/**
 * @secure
 * Request to get account details with provided auth headers.
 * @returns Decoded promise of account details response.
 */ var getAccountDetails = function(headers) {
    return (0,api_helpers__WEBPACK_IMPORTED_MODULE_1__/* .createRequest */ .hG)("api/v3/account/details/", {
        credentials: "same-origin",
        withAuth: true,
        otherHeaders: headers
    }).then(api_handleErrors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).then(function(data) {
        return (0,js_convert_case__WEBPACK_IMPORTED_MODULE_2__.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getAccountDetails);


/***/ }),

/***/ 22638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m1": function() { return /* reexport */ queries_braintreeToken; },
  "Ko": function() { return /* reexport */ queries_claimGift; },
  "QK": function() { return /* reexport */ queries_createDraftOrder; },
  "W6": function() { return /* reexport */ customerDataErrors; },
  "W0": function() { return /* reexport */ queries_edmOptIn; },
  "ke": function() { return /* reexport */ queries_exchangeStore; },
  "cS": function() { return /* reexport */ queries_finaliseOrder; },
  "jg": function() { return /* reexport */ getAccountDetails/* default */.Z; },
  "ck": function() { return /* reexport */ queries_getCustomerData; },
  "Lu": function() { return /* reexport */ queries_getPaymentIntent; },
  "Lr": function() { return /* reexport */ queries_giftOpen; },
  "$t": function() { return /* reexport */ giftOpenCard; },
  "SB": function() { return /* reexport */ giftOpenErrors; },
  "Yg": function() { return /* reexport */ queries_giftPreview; },
  "OJ": function() { return /* reexport */ queries_inventory; },
  "x4": function() { return /* reexport */ queries_login; },
  "XS": function() { return /* reexport */ queries_masquerade; },
  "z2": function() { return /* reexport */ queries_register; },
  "aq": function() { return /* reexport */ registerErrors; },
  "wK": function() { return /* reexport */ queries_requestSecurityCode; },
  "xn": function() { return /* reexport */ queries_resendGift; },
  "w7": function() { return /* reexport */ queries_signOut; },
  "Ag": function() { return /* reexport */ queries_skuBySlug; },
  "mW": function() { return /* reexport */ queries_updateDraftOrder; },
  "Yf": function() { return /* reexport */ validateCustomerEmail/* default */.Z; },
  "wm": function() { return /* reexport */ queries_validateCustomerPassword; },
  "gl": function() { return /* reexport */ queries_validateMfaToken; },
  "a$": function() { return /* reexport */ queries_validatePhone; }
});

// UNUSED EXPORTS: categories, claimGiftErrors, exchange, fetchStoreCategory, giftThemes, loginErrors, modifyStoreCategory, orderStatus, personalisedMessages, resendGiftErrors, validateCustomerEmailErrors, validateMfaTokenErrors, validateSecurityCode, webConfig, zagBuyingPrompt

// EXTERNAL MODULE: ./src/api/queries/orderStatus.ts
var orderStatus = __webpack_require__(95881);
// EXTERNAL MODULE: ./node_modules/js-convert-case/index.js
var js_convert_case = __webpack_require__(24417);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
// EXTERNAL MODULE: ./src/api/handleErrors.ts
var api_handleErrors = __webpack_require__(19700);
;// CONCATENATED MODULE: ./src/api/queries/finaliseOrder.ts



/**
 * Request to finalise order.
 * @param orderUrl - The URL of the order to finalise
 * @param finalisePaymentRequestData - The data to finalise the payment with
 * @returns The response from the finalse order API
 */ var finaliseOrder = function(orderUrl, finalisePaymentRequestData) {
    return (0,helpers/* createRequest */.hG)(orderUrl, {
        body: JSON.stringify((0,js_convert_case.snakeKeys)(finalisePaymentRequestData)),
        isUrl: true,
        logRequest: true,
        method: "PATCH",
        mode: "cors",
        withAuth: true,
        withSecurityToken: true
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_finaliseOrder = (finaliseOrder);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./src/api/queries/createDraftOrder.ts






function getAPIFromPurchaseKindAndType(purchaseKind, purchaseType) {
    var GUEST_CHECKOUT_URL = "api/v3/gifts-guest/";
    var USER_CHECKOUT_FOR_FRIEND_URL = "api/v3/gifts/";
    var USER_CHECKOUT_FOR_SELF_URL = "api/v3/cards/";
    if (purchaseKind === "guest") {
        return GUEST_CHECKOUT_URL;
    } else if (purchaseKind === "user") {
        // might need to add 'anonymous' / 'santa'
        if (purchaseType === "friend") return USER_CHECKOUT_FOR_FRIEND_URL;
        if (purchaseType === "self") return USER_CHECKOUT_FOR_SELF_URL;
    }
    return null;
}
var createDraftOrder = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(payload, purchaseType, purchaseKind, isLayer) {
        var route, params;
        return (0,tslib_es6.__generator)(this, function(_state) {
            route = getAPIFromPurchaseKindAndType(purchaseKind, purchaseType);
            params = {
                body: JSON.stringify((0,_object_spread/* default */.Z)({}, payload, isLayer && {
                    is_layer: true
                })),
                method: "POST",
                mode: "cors",
                logRequest: true,
                withAuth: true,
                withSecurityToken: true
            };
            if (purchaseKind === "user") params.withAuth = true;
            return [
                2,
                (0,helpers/* createRequest */.hG)(route, params).then(api_handleErrors/* default */.Z).then(function(data) {
                    return (0,js_convert_case.camelKeys)(data, {
                        recursive: true,
                        recursiveInArray: true
                    });
                })
            ];
        });
    });
    return function createDraftOrder(payload, purchaseType, purchaseKind, isLayer) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_createDraftOrder = (createDraftOrder);

;// CONCATENATED MODULE: ./src/api/queries/getPaymentIntent.ts



/**
 * Request to get payment intent from Prezzee API.
 * @param url - the url to the api endpoint
 * @param payload - the request body
 * @returns
 */ var getPaymentIntent = function(url, payload) {
    return (0,helpers/* createRequest */.hG)(url, {
        body: JSON.stringify((0,js_convert_case.snakeKeys)(payload)),
        isUrl: true,
        logRequest: true,
        method: "POST",
        mode: "cors",
        withAuth: true,
        withSecurityToken: true
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_getPaymentIntent = (getPaymentIntent);

;// CONCATENATED MODULE: ./src/api/queries/edmOptIn.ts





var edmOptIn = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(email) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,helpers/* createRequest */.hG)("api/v3/subscriptions/", {
                    body: JSON.stringify({
                        email: email
                    }),
                    logRequest: true,
                    method: "POST",
                    mode: "cors"
                }).then(api_handleErrors/* default */.Z).then(function(data) {
                    return (0,js_convert_case.camelKeys)(data, {
                        recursive: true,
                        recursiveInArray: true
                    });
                })
            ];
        });
    });
    return function edmOptIn(email) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_edmOptIn = (edmOptIn);

;// CONCATENATED MODULE: ./src/api/queries/giftOpen.ts




/**
 * All possible errors returned from gift open response.
 */ var giftOpenErrors = {
    claimedNotLoggedIn: "Card is claimed, but you are not logged in",
    invalidPin: "invalid_pin",
    expiredPin: "expired_pin",
    oldStyleUrlExpired: "gift_url_expired",
    oldStyleUrlUsed: "gift_requires_new_style_url_with_pin"
};
/**
 * Request to fetch gift data on gift unwrapping page.
 * @param uid The gift unique identifier.
 * @param blob The gift encrypted blob.
 * @param pin The 4 digit pin code entered at unlock screen.
 * @returns Promise with decoded gift open response.
 */ var giftOpen = function(uid, blob, pin) {
    var route = "api/v3/gift/open/".concat(uid, "/");
    var options = {
        withAuth: true,
        withMagicUserAgent: true
    };
    if (blob) {
        route += "?b=".concat(blob);
    }
    if (pin) {
        options["method"] = "POST";
        options["body"] = JSON.stringify({
            pin: pin
        });
    }
    return (0,helpers/* createRequest */.hG)(route, options).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
var giftOpenCard = function(uid, blob, pin) {
    var route = "api/v3/gift/".concat(uid, "/card/");
    var options = {
        withAuth: true,
        withMagicUserAgent: true,
        method: "POST"
    };
    if (blob) {
        route += "?b=".concat(blob);
    }
    if (pin) {
        options["body"] = JSON.stringify({
            pin: pin
        });
    }
    return (0,helpers/* createRequest */.hG)(route, options).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/**
 * The frontend side needs to handle 2 different special cases respectively for the 401 HTTP response in project butterfly
 * Currently, the error message content used to determine which handler will be used.
 * This checker is for identifying a 401 response case returned by a merchant requires forced sign in
 * TODO: it's a temporary solution, need to revisit to find a better approach by using the error codes or status codes
 *
 * @param error The error thrown by the `handleErrors()`
 * @returns true if HTTP response status code is 401 with credentials error message
 */ var isAuthCredentialsError = function(error) {
    if (_instanceof(error, Error)) {
        return error.message.includes("Authentication credentials were not provided");
    }
    return false;
};
/* harmony default export */ var queries_giftOpen = (giftOpen);

;// CONCATENATED MODULE: ./src/api/queries/claimGift.ts


// TODO: Add all possible claim gift errors.
/**
 * All possible errors returned from gift claim response.
 */ var claimGiftErrors = {};
/**
 * Request to claim gift.
 * @param uid The gift unique identifier.
 * @param blob The gift encrypted blob.
 * @param pin The 4 digit pin code entered at unlock screen.
 * @returns Promise with decoded gift claim response.
 */ var claimGift = function(uid, blob, pin) {
    var type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "single";
    var route = "api/v3/gift/claim/".concat(uid, "/");
    if (type === "tree") {
        route = "/api/v3/gift/claim-tree/".concat(uid, "/");
    }
    var options = {
        withAuth: true
    };
    var body = {};
    if (blob) {
        route += "?b=".concat(blob);
    }
    if (pin) {
        options["method"] = "POST";
        body["pin"] = pin;
    }
    if (Object.keys(body).length > 0) {
        options["body"] = JSON.stringify(body);
    }
    return (0,helpers/* createRequest */.hG)(route, options).then(api_handleErrors/* default */.Z);
};
/* harmony default export */ var queries_claimGift = (claimGift);

;// CONCATENATED MODULE: ./src/api/queries/resendGift.ts



// TODO: Add all possible gift resend errors.
/**
 * All possible errors returned from gift resend response.
 */ var resendGiftErrors = {};
/**
 * Request to resend a gift, with optional blob for gifts that require pin.
 * @param uid The gift unique identifier.
 * @returns Promise with decoded gift resend response.
 */ var resendGift = function(uid) {
    return (0,helpers/* createRequest */.hG)("api/v3/gift/resend-notification/".concat(uid, "/"), {
        method: "POST"
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_resendGift = (resendGift);

// EXTERNAL MODULE: ./src/api/queries/validateCustomerEmail.ts
var validateCustomerEmail = __webpack_require__(84920);
;// CONCATENATED MODULE: ./src/api/queries/validateCustomerPassword.ts





function isPasswordInvalidError(obj) {
    try {
        return typeof obj === "object" && obj.password !== undefined && obj.detail !== undefined;
    } catch (error) {
        return false;
    }
}
/**
 * Request to validate a customers password in our backend validator.
 * @param userData the data user filled in previous steps
 * @returns Promise of decoded validate password response.
 */ var validateCustomerPassword = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(userData) {
        var response, jsonData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,helpers/* createRequest */.hG)("api/v3/customer/validate-password/", {
                            method: "POST",
                            body: JSON.stringify((0,js_convert_case.snakeKeys)(userData)),
                            withMagicUserAgent: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status === 400)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    jsonData = _state.sent();
                    if (isPasswordInvalidError(jsonData)) {
                        return [
                            2,
                            jsonData
                        ];
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        (0,api_handleErrors/* default */.Z)(response)
                    ];
            }
        });
    });
    return function validateCustomerPassword(userData) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_validateCustomerPassword = (validateCustomerPassword);

;// CONCATENATED MODULE: ./src/api/queries/login.ts



var loginErrors = {
    emailPassNotFound: "A user with that email and password could not be found.",
    locked: "Your Prezzee account has been locked for security reasons.\n\n Please contact help@prezzee.com for assistance or try again after 30 minutes."
};
/**
 * @secure
 * Request to login a user via email and password.
 * @param email Email to attempt login with.
 * @param password Password to attempt login with.
 * @returns Decoded promise of login API response.
 */ var login = function(email, password) {
    return (0,helpers/* createRequest */.hG)("api/v3/signin-by-email-password/email/", {
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: JSON.stringify({
            email: email,
            password: password
        })
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_login = (login);

// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
;// CONCATENATED MODULE: ./src/api/queries/getCustomerData.ts




var customerDataErrors = {
    mfaRequired: "Server MFA Required Error",
    detailsNotProvided: "Authentication credentials were not provided.",
    tokenMissing: "No cookie token was found"
};
/**
 * @secure
 * Request to get customer data with provided auth headers.
 * @returns Decoded promise of customer API response.
 */ var getCustomerData = function(headers) {
    var token = (0,AuthUtils_bs/* getToken */.LP)();
    if (!token) {
        throw new Error(customerDataErrors.tokenMissing);
    }
    return (0,helpers/* createRequest */.hG)("api/v3/customer/", {
        credentials: "same-origin",
        withAuth: true,
        logRequest: true,
        otherHeaders: headers
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_getCustomerData = (getCustomerData);

// EXTERNAL MODULE: ./src/api/queries/getAccountDetails.ts
var getAccountDetails = __webpack_require__(61760);
;// CONCATENATED MODULE: ./src/api/queries/validateMfaToken.ts


var validateMfaTokenErrors = {};
/**
 * @secure
 * Request to validate a customers MFA token.
 * @param code Mfa code that requires validating
 * @returns Promise of decoded validate email response.
 */ var validateMfaToken = function(code) {
    return (0,helpers/* createRequest */.hG)("api/v3/customer/securitycode/validate/", {
        method: "POST",
        mode: "cors",
        credentials: "same-origin",
        body: JSON.stringify({
            code: code
        }),
        withAuth: true
    }).then(api_handleErrors/* default */.Z);
};
/* harmony default export */ var queries_validateMfaToken = (validateMfaToken);

// EXTERNAL MODULE: ./src/api/queries/webConfig.ts
var webConfig = __webpack_require__(88486);
// EXTERNAL MODULE: ./src/utils/logger.ts
var utils_logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./src/utils/poll.ts
var utils_poll = __webpack_require__(5490);
;// CONCATENATED MODULE: ./src/api/queries/exchange.ts






/**
 * Request to fetch exchange information about a product.
 * @param uid The product unique identifier.
 * @returns Promise with exchange store response.
 */ var pollOrderWithRetry = function(orderUrl) {
    return poll({
        fn: function() {
            return createRequest(orderUrl, {
                method: "GET",
                isUrl: true,
                withAuth: true,
                withMagicUserAgent: true,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    prefer: "respond-async"
                }
            }).then(handleErrors);
        },
        validate: function(data) {
            return (data === null || data === void 0 ? void 0 : data.status) === "COMPLETED" || (data === null || data === void 0 ? void 0 : data.status) === "FAILED" || (data === null || data === void 0 ? void 0 : data.status) === "PENDING_FULFILLMENT";
        },
        interval: 1500,
        maxAttempts: 10
    });
};
var exchange = function(uid, productCode, productThemeCode) {
    return createRequest("api/v3/exchange/".concat(uid, "/"), {
        method: "POST",
        withAuth: true,
        withMagicUserAgent: true,
        logRequest: true,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Prefer: "respond-async"
        },
        body: JSON.stringify({
            items: [
                {
                    product_code: productCode,
                    product_theme_code: productThemeCode
                }, 
            ]
        })
    }).then(handleErrors).catch(function(error) {
        return Promise.reject(error);
    }).then(function() {
        var _ref = _async_to_generator(function(data) {
            var ref, retryUrl, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        retryUrl = data === null || data === void 0 ? void 0 : (ref = data.headers) === null || ref === void 0 ? void 0 : ref.get("content-location");
                        if (!retryUrl) return [
                            2,
                            Promise.reject("No retry url")
                        ];
                        return [
                            4,
                            pollOrderWithRetry(retryUrl)
                        ];
                    case 1:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }()).catch(function(error) {
        logger.error("Error while exchanging product", error);
        return Promise.reject(error);
    });
};
/* harmony default export */ var queries_exchange = ((/* unused pure expression or super */ null && (exchange)));

;// CONCATENATED MODULE: ./src/api/queries/exchangeStore.ts



/**
 * Request to fetch exchange information about a product.
 * @param uid The product unique identifier.
 * @returns Promise with exchange store response.
 */ var exchangeStore = function(uid) {
    return (0,helpers/* createRequest */.hG)("api/v3/sku/".concat(uid, "/exchange-store/"), {
        withAuth: true,
        withMagicUserAgent: true
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        })["skus"];
    });
};
/* harmony default export */ var queries_exchangeStore = (exchangeStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/api/queries/skuBySlug.ts





/**
 * Request to fetch sku information via sku slug.
 * @param slug The product unique identifier.
 * @returns Promise with decoded sku response.
 */ var skuBySlug = function(slug, authToken) {
    return (0,helpers/* createRequest */.hG)("api/v3/sku/by-slug/".concat(slug, "/"), {
        withAuth: true,
        withMagicUserAgent: true,
        withAuthHeaderFromServer: authToken
    }).then(api_handleErrors/* default */.Z)// layerType is a spoof field to keep layer upgrade functionality, in future this will come from the backend.
    .then(function(data) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        })), {
            layerType: "default"
        });
    });
};
/* harmony default export */ var queries_skuBySlug = (skuBySlug);

;// CONCATENATED MODULE: ./src/api/queries/giftThemes.ts



/**
 * Request to fetch server web configuration.
 * @returns Promise with decoded web config response.
 */ var giftThemes = function(skuCode) {
    var route = "api/v3/giftthemes/";
    if (skuCode) {
        route += "?sku_code=" + skuCode;
    }
    return createRequest(route, {
        withAuth: true,
        withMagicUserAgent: true
    }).then(handleErrors).then(function(data) {
        return camelKeys(data, {
            recursive: true,
            recursiveInArray: true
        })["giftthemes"];
    });
};
/* harmony default export */ var queries_giftThemes = ((/* unused pure expression or super */ null && (giftThemes)));

;// CONCATENATED MODULE: ./src/api/queries/braintreeToken.ts



/**
 * Request to fetch braintree client token.
 * @returns Promise with braintree client token response.
 */ var braintreeToken = function() {
    return (0,helpers/* createRequest */.hG)("api/v3/braintree/client-token/").then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_braintreeToken = (braintreeToken);

;// CONCATENATED MODULE: ./src/api/queries/personalisedMessages.ts



var personalisedMessages = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(language, isPreview) {
        var client, data, filteredOccasions, filteredMessages;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        client.items().type("inspired_messaging").toPromise()
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().data
                    ];
                case 2:
                    data = _state.sent();
                    filteredOccasions = [].concat.apply([], data.items.filter(function(item) {
                        var ref, ref1, ref2;
                        return (ref = item.elements) === null || ref === void 0 ? void 0 : (ref1 = ref.status) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2[0];
                    }).map(function(item) {
                        var ref, ref1;
                        return (ref = item.elements) === null || ref === void 0 ? void 0 : (ref1 = ref.messages) === null || ref1 === void 0 ? void 0 : ref1.value;
                    }));
                    filteredMessages = filteredOccasions.map(function(occasion) {
                        var ref, ref1;
                        return (ref = data.linkedItems[occasion].elements) === null || ref === void 0 ? void 0 : (ref1 = ref.message) === null || ref1 === void 0 ? void 0 : ref1.value;
                    });
                    return [
                        2,
                        filteredMessages.length ? filteredMessages : null
                    ];
            }
        });
    });
    return function personalisedMessages(language, isPreview) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_personalisedMessages = ((/* unused pure expression or super */ null && (personalisedMessages)));

;// CONCATENATED MODULE: ./src/api/queries/inventory.ts



/**
 * Request to fetch inventory.
 * @returns Promise with decoded inventory response.
 */ var inventory = function(authToken) {
    return (0,helpers/* createRequest */.hG)("api/v3/inventory/", {
        withAuth: true,
        withMagicUserAgent: true,
        withAuthHeaderFromServer: authToken
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_inventory = (inventory);

;// CONCATENATED MODULE: ./src/api/queries/categories.ts



/**
 * Request to fetch sku categories.
 * @returns Promise with decoded category response.
 */ var categories = function() {
    return createRequest("api/v3/categories/", {
        withMagicUserAgent: true
    }).then(handleErrors).then(function(data) {
        return camelKeys(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_categories = ((/* unused pure expression or super */ null && (categories)));

// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(13984);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/api/graphql/index.ts
/* provided dependency */ var process = __webpack_require__(34155);




var apolloClient;
var errorLink = (0,error/* onError */.q)(function(param) {
    var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
    if (graphQLErrors) {
        graphQLErrors.forEach(function(error) {
            var message = error.message, locations = error.locations, path = error.path;
            utils_logger/* default.error */.ZP.error({
                err: error,
                locations: locations,
                path: path,
                type: "GraphQL Error"
            }, "error: Graphql error: ".concat(message));
        });
    }
    if (networkError) {
        utils_logger/* default.error */.ZP.error({
            err: networkError,
            type: "GraphQL Network Error"
        }, "error: Graphql Network error: ".concat(networkError.message));
    }
});
function createIsomorphLink() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var url = context.req.url;
    var isPreview = url.includes("preview=true");
    //flag for Kontent development env
    var isDevKontent = url.includes("dev=true");
    var HttpLink = (__webpack_require__(46829).HttpLink);
    //use Kontent development env for stg and local only
    if (isDevKontent && process.env.NEXT_PUBLIC_KONTENT_DEV_ID) {
        return new HttpLink({
            uri: "https://".concat(isPreview ? "preview-" : "", "graphql.kontent.ai/").concat(process.env.NEXT_PUBLIC_KONTENT_DEV_ID),
            headers: {
                Authorization: "Bearer ".concat(isPreview ? process.env.NEXT_PUBLIC_KONTENT_DEV_PREVIEW_KEY : process.env.NEXT_PUBLIC_KONTENT_DEV_SECURE_ACCESS_KEY)
            }
        });
    }
    return new HttpLink({
        uri: "https://".concat(isPreview ? "preview-" : "", "graphql.kontent.ai/").concat("7af951a6-2a13-004b-f0eb-a87382a5b2e7"),
        headers: {
            Authorization: "Bearer ".concat(isPreview ? "ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogImNjMWI3NTVjMWFlZjQ3NTJhYWQ1ZDNiNmY0MzlmYjcwIiwNCiAgImlhdCI6ICIxNjE2NTYzNDc4IiwNCiAgImV4cCI6ICIxOTYyMTYzNDc4IiwNCiAgInZlciI6ICIxLjAuMCIsDQogICJwcm9qZWN0X2lkIjogIjdhZjk1MWE2MmExMzAwNGJmMGViYTg3MzgyYTViMmU3IiwNCiAgImF1ZCI6ICJwcmV2aWV3LmRlbGl2ZXIua2VudGljb2Nsb3VkLmNvbSINCn0.vsX6XZnK6-3drNTffJhFTcCUPzTt5ASBrUIWanR8p-I" : "ew0KICAiYWxnIjogIkhTMjU2IiwNCiAgInR5cCI6ICJKV1QiDQp9.ew0KICAianRpIjogImM5YTJiYWI4NDQxMDQwYjViNDQzNTk4NTMwZjg1NTc1IiwNCiAgImlhdCI6ICIxNjE2NjUxOTM4IiwNCiAgImV4cCI6ICIxOTYyMjUxOTM4IiwNCiAgInZlciI6ICIxLjAuMCIsDQogICJwcm9qZWN0X2lkIjogIjdhZjk1MWE2MmExMzAwNGJmMGViYTg3MzgyYTViMmU3IiwNCiAgImF1ZCI6ICJkZWxpdmVyLmtlbnRpY29jbG91ZC5jb20iDQp9.1-Q179jJjnoEa4IjM0PHAxTnM2bjuKY1t_KWR3iO0yA")
        }
    });
}
function createApolloClient(context) {
    return new core.ApolloClient({
        ssrMode: "object" === "undefined",
        link: errorLink.concat(createIsomorphLink(context)),
        cache: new core.InMemoryCache()
    });
}
function initializeApollo() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, // Pages with Next.js data fetching methods, like `getStaticProps`, can send
    // a custom context which will be used by `SchemaLink` to server render pages
    context = arguments.length > 1 ? arguments[1] : void 0;
    var _apolloClient = apolloClient !== null && apolloClient !== void 0 ? apolloClient : createApolloClient(context);
    // If your page has Next.js data fetching methods that use Apollo Client, the initial state
    // get hydrated here
    if (initialState) {
        _apolloClient.cache.restore(initialState);
    }
    // For SSG and SSR always create a new Apollo Client
    if (false) {}
    // Create the Apollo Client once in the client
    if (!apolloClient) apolloClient = _apolloClient;
    return _apolloClient;
}
function useApollo(initialState) {
    var store = useMemo(function() {
        return initializeApollo(initialState);
    }, [
        initialState
    ]);
    return store;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/api/graphql/modules/Image/fragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ImageFields on Image {\n    _system_ {\n      id\n      codename\n    }\n    file {\n      url\n      name\n      description\n      width\n      height\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var IMAGE = (0,core.gql)(_templateObject());
/* harmony default export */ var fragment = (IMAGE);

;// CONCATENATED MODULE: ./src/api/graphql/modules/CallToActionLink/fragment.ts

function fragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CallToActionFields on CallToActionLinkD6a3d61 {\n    _system_ {\n      id\n      codename\n    }\n    ctaText\n    ctaUrl\n    openInNewWindow {\n      items {\n        _system_ {\n          codename\n        }\n      }\n    }\n    _ctaStyle {\n      style {\n        items {\n          _system_ {\n            codename\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    fragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CALL_TO_ACTION_LINK = (0,core.gql)(fragment_templateObject());
/* harmony default export */ var CallToActionLink_fragment = (CALL_TO_ACTION_LINK);

;// CONCATENATED MODULE: ./src/api/graphql/modules/EnrichedTextBlock/fragment.ts

function EnrichedTextBlock_fragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        "\n\n  fragment EnrichedTextBlockFields on EnrichedTextBlock {\n    _system_ {\n      id\n      codename\n    }\n    alignment {\n      items {\n        _system_ {\n          codename\n        }\n      }\n    }\n    width {\n      items {\n        _system_ {\n          codename\n        }\n      }\n    }\n    content {\n      html\n      linkedItems {\n        items {\n          ... on CallToActionLinkD6a3d61 {\n            ...CallToActionFields\n          }\n          ... on Image {\n            ...ImageFields\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    EnrichedTextBlock_fragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ENRICHED_TEXT_BLOCK = (0,core.gql)(EnrichedTextBlock_fragment_templateObject(), fragment, CallToActionLink_fragment);
/* harmony default export */ var EnrichedTextBlock_fragment = (ENRICHED_TEXT_BLOCK);

;// CONCATENATED MODULE: ./src/api/graphql/modules/StoreCategory/query.ts

function query_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  query StoreCategoryQuery($language: String!, $codename: String!) {\n    storeCategory(codename: $codename, languageFilter: { languageCodename: $language }) {\n      _system_ {\n        codename\n        id\n      }\n      pageTopContent {\n        ... on EnrichedTextBlock {\n          ...EnrichedTextBlockFields\n        }\n      }\n    }\n  }\n"
    ]);
    query_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_STORE_CATEGORY = (0,core.gql)(query_templateObject(), EnrichedTextBlock_fragment);
/* harmony default export */ var query = (GET_STORE_CATEGORY);

// EXTERNAL MODULE: ./src/api/queries/modifyBlocks.ts
var modifyBlocks = __webpack_require__(23328);
;// CONCATENATED MODULE: ./src/api/queries/storeCategory.ts






var fetchStoreCategory = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(codename, context, language) {
        var res, client, error, data, ref, ref1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    client = initializeApollo({}, context);
                    return [
                        4,
                        client.query({
                            query: query,
                            variables: {
                                codename: codename,
                                language: language
                            }
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    utils_logger/* default.error */.ZP.error({
                        err: error,
                        journey: "Page Content"
                    }, "error: fetching store category");
                    return [
                        3,
                        3
                    ];
                case 3:
                    data = undefined;
                    try {
                        ;
                        if ((ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.storeCategory) === null || ref1 === void 0 ? void 0 : ref1.pageTopContent) {
                            data = {
                                top_content: (0,modifyBlocks/* decodeQuery */.MU)(res.data.storeCategory.pageTopContent)
                            };
                        }
                    } catch (error1) {
                        utils_logger/* default.error */.ZP.error({
                            err: error1,
                            journey: "Page Content"
                        }, "error: decoding store category");
                    }
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoreCategory(codename, context, language) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var storeCategory = ((/* unused pure expression or super */ null && (fetchStoreCategory)));

;// CONCATENATED MODULE: ./src/api/queries/requestSecurityCode.ts


/**
 * @secure
 * Request to send a customers MFA token.
 * @param email the customer email
 * @param phone the customer phone number for receiving the code
 * @returns Promise of decoded request security code response.
 */ var requestSecurityCode = function(email, phone) {
    return (0,helpers/* createRequest */.hG)("api/v3/customer/securitycode/request/", {
        method: "POST",
        mode: "cors",
        credentials: "same-origin",
        body: JSON.stringify({
            email: email,
            phone: phone
        })
    }).then(api_handleErrors/* default */.Z);
};
/* harmony default export */ var queries_requestSecurityCode = (requestSecurityCode);

;// CONCATENATED MODULE: ./src/api/queries/validateSecurityCode.ts


var validateSecurityCodeErrors = {};
/**
 * @secure
 * Request to validate a customers MFA token.
 * @param payload the email, phone and code those require validating
 * @returns Promise of decoded validate email response.
 */ var validateSecurityCode = function(payload) {
    return createRequest("api/v3/customer/securitycode/validate/", {
        method: "POST",
        mode: "cors",
        credentials: "same-origin",
        body: JSON.stringify(payload),
        withAuth: true
    }).then(handleErrors);
};
/* harmony default export */ var queries_validateSecurityCode = ((/* unused pure expression or super */ null && (validateSecurityCode)));

;// CONCATENATED MODULE: ./src/api/queries/register.ts



var registerErrors = {
    signUpDisabled: "Sign up is currently disabled. Please sign in using your existing account or contact us at help@prezzee.com.au or +61 2 9093 2777.",
    emailExists: "Sorry, we already have an account registered with that email address.",
    phoneExists: "Sorry, we already have an account registered with that phone number. Please sign in with your existing account or contact us for further assistance.",
    incorrectSecurityCode: "Incorrect PIN. Please check your SMS and try again.",
    commonPw: "This password is too common."
};
/**
 * @secure
 * Request to register a user.
 * @param registerPayload Object containing all required information to register a user
 * @returns Decoded promise of register API response.
 */ var register = function(registerPayload) {
    return (0,helpers/* createRequest */.hG)("api/v3/register-by-email-password/email/", {
        method: "POST",
        mode: "cors",
        credentials: "same-origin",
        withSecurityToken: true,
        body: JSON.stringify((0,js_convert_case.snakeKeys)(registerPayload))
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true
        });
    });
};
/* harmony default export */ var queries_register = (register);

;// CONCATENATED MODULE: ./src/api/queries/signOut.ts





/**
 * @secure
 * Request to sign out current user.
 * @returns Decoded promise of signOut API response.
 */ var signOut = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function() {
        var response, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,helpers/* createRequest */.hG)("api/v3/signout/", {
                            method: "POST",
                            mode: "cors",
                            credentials: "same-origin",
                            withAuth: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        (0,api_handleErrors/* default */.Z)(response)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        (0,js_convert_case.camelKeys)(data, {
                            recursive: true
                        })
                    ];
            }
        });
    });
    return function signOut() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_signOut = (signOut);

;// CONCATENATED MODULE: ./src/api/queries/masquerade.ts



/**
 * Request to masquerade provided user.
 * @arg url masquerade endpoint
 * @arg uid user uid
 * @returns Promise with decoded token response.
 */ var masquerade = function(url, uid) {
    return (0,helpers/* createRequest */.hG)(url, {
        withAuth: true,
        withMagicUserAgent: true,
        method: "POST",
        isUrl: true,
        body: JSON.stringify({
            masq_user: uid
        })
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_masquerade = (masquerade);

;// CONCATENATED MODULE: ./src/api/queries/zagBuyingPrompt.ts



var zagBuyingPrompt = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(language, isPreview) {
        var client, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = (0,helpers/* createDeliveryClient */.As)(language, isPreview);
                    return [
                        4,
                        client.item("zag_buying_prompt").toPromise()
                    ];
                case 1:
                    return [
                        4,
                        _state.sent().data
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function zagBuyingPrompt(language, isPreview) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_zagBuyingPrompt = ((/* unused pure expression or super */ null && (zagBuyingPrompt)));

;// CONCATENATED MODULE: ./src/api/queries/updateDraftOrder.ts






var updateDraftOrder = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var orderUrl, payload, purchaseKind, isLayer, params;
        return (0,tslib_es6.__generator)(this, function(_state) {
            orderUrl = param.orderUrl, payload = param.payload, purchaseKind = param.purchaseKind, isLayer = param.isLayer;
            params = {
                body: JSON.stringify((0,_object_spread/* default */.Z)({}, payload, isLayer && {
                    is_layer: true
                })),
                method: "PUT",
                mode: "cors",
                logRequest: true,
                withAuth: true,
                withSecurityToken: true,
                isUrl: true
            };
            if (purchaseKind === "user") params.withAuth = true;
            return [
                2,
                (0,helpers/* createRequest */.hG)(orderUrl, params).then(api_handleErrors/* default */.Z).then(function(data) {
                    return (0,js_convert_case.camelKeys)(data, {
                        recursive: true,
                        recursiveInArray: true
                    });
                })
            ];
        });
    });
    return function updateDraftOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var queries_updateDraftOrder = (updateDraftOrder);

;// CONCATENATED MODULE: ./src/api/queries/validatePhone.ts



/**
 * Request to validate a phone number
 * @param phone Phone number to validate.
 * @returns Promise with validated phone response.
 */ var validatePhone = function(phone) {
    return (0,helpers/* createRequest */.hG)("api/v3/customer/validate-phone/", {
        method: "POST",
        withAuth: true,
        withMagicUserAgent: true,
        body: JSON.stringify({
            phone: phone
        })
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_validatePhone = (validatePhone);

;// CONCATENATED MODULE: ./src/api/queries/giftPreview.ts



/**
 * Request to get draft order gift preview data (used in preview functionality in purchase flow).
 * @param orderNumber - The order number
 * @param itemNumber - The item number in the order (used for multi purchase orders, starts from 0)
 * @returns The response from the gift preview API
 */ var giftPreview = function(orderNumber) {
    var itemNumber = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return (0,helpers/* createRequest */.hG)("api/v3/gift/preview/".concat(orderNumber, "/").concat(itemNumber, "/"), {
        withMagicUserAgent: true,
        withAuth: true
    }).then(api_handleErrors/* default */.Z).then(function(data) {
        return (0,js_convert_case.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
/* harmony default export */ var queries_giftPreview = (giftPreview);

;// CONCATENATED MODULE: ./src/api/queries/index.ts




































/***/ }),

/***/ 23328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IN": function() { return /* binding */ modifyBlocks; },
/* harmony export */   "MU": function() { return /* binding */ decodeQuery; },
/* harmony export */   "RA": function() { return /* binding */ modifyLandingBlocks; }
/* harmony export */ });
/* unused harmony exports handleObjectType, modifyStoreCategory, modifyStoreContent */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70655);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31611);
/* harmony import */ var utils_parseRichTextData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50771);
/* harmony import */ var _graphql_CmsData_bs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(607);
/* harmony import */ var api_queries_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22638);
/* harmony import */ var models_Models_bs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37698);
/* harmony import */ var common_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42358);








var fetchLinkedItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(language, preview, codenameList) {
        var res, error, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,_graphql_CmsData_bs__WEBPACK_IMPORTED_MODULE_2__/* .getEnrichedTextBlockFields */ .Zi)(language, preview, codenameList)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
                        err: error,
                        journey: "Page Content"
                    }, "error: cannot retrieve data from Kontent");
                    return [
                        3,
                        3
                    ];
                case 3:
                    data = res; // @note: apply the additional business conditional mapper
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchLinkedItems(language, preview, codenameList) {
        return _ref.apply(this, arguments);
    };
}();
var getInventoryData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        api_queries_index__WEBPACK_IMPORTED_MODULE_3__/* .inventory */ .OJ()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    error = _state.sent();
                    utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
                        err: error,
                        source: "Inventory API",
                        journey: "modifyBlocks function"
                    }, "error: Could not retrieve inventory data");
                    throw new Error("Could not retrieve inventory data");
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getInventoryData() {
        return _ref.apply(this, arguments);
    };
}();
var handleObjectType = function(blockFields, codename) {
    var linkedItem = blockFields.callToActionList.find(function(elem) {
        return elem.smartLink.codename === codename;
    });
    if (linkedItem) {
        return {
            tag: "CTA",
            data: JSON.stringify(linkedItem)
        };
    }
    linkedItem = blockFields.imageList.find(function(elem) {
        return elem.smartLink.codename === codename;
    });
    if (linkedItem) {
        return {
            tag: "IMAGE",
            data: JSON.stringify(linkedItem)
        };
    }
    return {
        tag: "OBJECT",
        data: codename
    };
};
var isEnrichedTextBlock = function(jsonString) {
    if (!jsonString) return false;
    return jsonString.includes('"NAME":"EnrichedTextBlock"');
};
var isSkuCarousel = function(jsonString) {
    if (!jsonString) return false;
    return jsonString.includes('"NAME":"SkuCarouselBlock"');
};
var modifyContentBlocks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(contentBlocks, preview, language) {
        var isIndexPage, result;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isIndexPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    return [
                        4,
                        Promise.all(contentBlocks.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(block) {
                                var ref, value, elements, codenames, linkedItems, modifiedElements, inventory, cards, minifiedCards, pinnedSkuList, filteredCards, noOfCards;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(block.NAME === "EnrichedTextBlock")) return [
                                                3,
                                                3
                                            ];
                                            value = block.VAL;
                                            if (!(value === null || value === void 0 ? void 0 : (ref = value.content) === null || ref === void 0 ? void 0 : ref.isObjectItems)) return [
                                                3,
                                                2
                                            ];
                                            elements = value.content.elements;
                                            codenames = elements.filter(function(element) {
                                                return element.tag === "OBJECT";
                                            }).map(function(element) {
                                                return element.data;
                                            });
                                            return [
                                                4,
                                                fetchLinkedItems(language, preview, codenames)
                                            ];
                                        case 1:
                                            linkedItems = _state.sent();
                                            modifiedElements = elements.map(function(element) {
                                                if (element.tag === "OBJECT") {
                                                    var newElement = handleObjectType(linkedItems, element.data);
                                                    return newElement;
                                                }
                                                return element;
                                            });
                                            block.VAL.content.elements = modifiedElements;
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2,
                                                block
                                            ];
                                        case 3:
                                            if (!(block.NAME === "SkuCarouselBlock" && !isIndexPage)) return [
                                                3,
                                                5
                                            ];
                                            return [
                                                4,
                                                getInventoryData()
                                            ];
                                        case 4:
                                            inventory = _state.sent();
                                            cards = inventory.skus.map(function(card) {
                                                return models_Models_bs__WEBPACK_IMPORTED_MODULE_4__/* .Card.skuToCard */ .Zb.skuToCard(card);
                                            });
                                            minifiedCards = cards.map(function(param) {
                                                var uid = param.uid, categories = param.categories, slug = param.slug, themes = param.themes, imgUrl = param.imgUrl, name = param.name, cmsId = param.cmsId, isSwappable = param.isSwappable, tagline = param.tagline, priceRange = param.priceRange, displayName = param.displayName, promos = param.promos;
                                                return {
                                                    uid: uid,
                                                    categories: categories,
                                                    slug: slug,
                                                    themes: themes,
                                                    imgUrl: imgUrl,
                                                    name: name,
                                                    cmsId: cmsId,
                                                    isSwappable: isSwappable,
                                                    tagline: tagline,
                                                    priceRange: priceRange,
                                                    displayName: displayName,
                                                    promos: promos
                                                };
                                            });
                                            pinnedSkuList = block.VAL.skuList !== "" ? block.VAL.skuList.split(",").map(function(str) {
                                                return models_Models_bs__WEBPACK_IMPORTED_MODULE_4__/* .Card.makeSlug */ .Zb.makeSlug(str);
                                            }) : null;
                                            filteredCards = !pinnedSkuList ? minifiedCards.filter(function(card) {
                                                return card.categories.find(function(category) {
                                                    return category.name === "Featured";
                                                });
                                            }) : minifiedCards.filter(function(card) {
                                                return pinnedSkuList.includes(card.slug);
                                            });
                                            noOfCards = cards.filter(function(card) {
                                                if (card.denominations.length) {
                                                    return card.denominations[0].valueCurrency === common_util__WEBPACK_IMPORTED_MODULE_5__/* .envUtil.currencyCode */ .vK.currencyCode;
                                                }
                                            }).length;
                                            block.VAL.inventory = filteredCards;
                                            block.VAL.noOfCards = noOfCards;
                                            return [
                                                2,
                                                block
                                            ];
                                        case 5:
                                            return [
                                                2,
                                                block
                                            ];
                                    }
                                });
                            });
                            return function(block) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function modifyContentBlocks(contentBlocks, preview, language) {
        return _ref.apply(this, arguments);
    };
}();
var decodeQuery = function(data) {
    if (!data) return void 0;
    var content = (0,utils_parseRichTextData__WEBPACK_IMPORTED_MODULE_1__/* .parseRichTextData */ .c)(data.content.html);
    var linkedItems = data.content.linkedItems.items;
    content.elements = content.elements.map(function(element) {
        if (element.tag === "OBJECT") {
            var newElement = handleObjectType(linkedItems, element.data);
            return newElement;
        }
        return element;
    });
    return {
        smartLink: {
            codename: data._system_.codename,
            itemId: data._system_.id
        },
        content: content,
        alignment: data.alignment.items.length ? data.alignment.items[0]._system_.codename : "left",
        width: data.width.items.length ? data.width.items[0]._system_.codename : "n12columns"
    };
};
var modifyStoreCategory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(jsonString, preview, language) {
        var storeCategory, block, elements, codenames, linkedItems, modifiedElements;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    storeCategory = JSON.parse(jsonString);
                    if (!storeCategory.top_content) return [
                        2,
                        jsonString
                    ];
                    block = storeCategory.top_content;
                    if (!block.content.isObjectItems) return [
                        3,
                        2
                    ];
                    elements = block.content.elements;
                    codenames = elements.filter(function(element) {
                        return element.tag === "OBJECT";
                    }).map(function(element) {
                        return element.data;
                    });
                    return [
                        4,
                        fetchLinkedItems(language, preview, codenames)
                    ];
                case 1:
                    linkedItems = _state.sent();
                    modifiedElements = elements.map(function(element) {
                        if (element.tag === "OBJECT") {
                            var newElement = handleObjectType(linkedItems, element.data);
                            return newElement;
                        }
                        return element;
                    });
                    block.content.elements = modifiedElements;
                    storeCategory.top_content = block;
                    return [
                        2,
                        JSON.stringify(storeCategory)
                    ];
                case 2:
                    return [
                        2,
                        jsonString
                    ];
            }
        });
    });
    return function modifyStoreCategory(jsonString, preview, language) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Links the list of OBJECT Content items
 * @param value
 * @param preview
 * @param language
 */ var linkItems = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(value, preview, language) {
        var linkedBlock;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    linkedBlock = {};
                    return [
                        4,
                        Promise.all(Object.keys(value).map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(itemCode) {
                                var ref, contentItem, elements, codenameList, linkedItems;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            contentItem = value[itemCode];
                                            if (!(contentItem === null || contentItem === void 0 ? void 0 : (ref = contentItem.content) === null || ref === void 0 ? void 0 : ref.isObjectItems)) return [
                                                3,
                                                2
                                            ];
                                            elements = contentItem.content.elements;
                                            codenameList = elements.filter(function(element) {
                                                return element.tag === "OBJECT";
                                            }).map(function(element) {
                                                return element.data;
                                            });
                                            return [
                                                4,
                                                fetchLinkedItems(language, preview, codenameList)
                                            ];
                                        case 1:
                                            linkedItems = _state.sent();
                                            contentItem.content.elements = elements.map(function(element) {
                                                return element.tag === "OBJECT" ? handleObjectType(linkedItems, element.data) : element;
                                            });
                                            linkedBlock[itemCode] = contentItem;
                                            _state.label = 2;
                                        case 2:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(itemCode) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        linkedBlock
                    ];
            }
        });
    });
    return function linkItems(value, preview, language) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Maps the Store Content with the mapped default content
 * @param jsonString
 * @param preview
 * @param language
 */ var modifyStoreContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(jsonString, preview, language) {
        var storeContent, _, _1, error, ref;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = JSON.parse;
                    return [
                        4,
                        modifyBlocks(jsonString, preview, language)
                    ];
                case 1:
                    storeContent = _.apply(JSON, [
                        _state.sent()
                    ]);
                    if (!storeContent.store_content) {
                        return [
                            2,
                            jsonString
                        ];
                    }
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    _1 = storeContent.store_content.VAL.content;
                    return [
                        4,
                        linkItems(storeContent.store_content.VAL, preview, language)
                    ];
                case 3:
                    _1.elements = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
                        storeContentValue: storeContent === null || storeContent === void 0 ? void 0 : (ref = storeContent.store_content) === null || ref === void 0 ? void 0 : ref.VAL,
                        err: error,
                        journey: "Page Content",
                        source: "CMS"
                    }, "error: Store Content item exception");
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        JSON.stringify(storeContent)
                    ];
            }
        });
    });
    return function modifyStoreContent(jsonString, preview, language) {
        return _ref.apply(this, arguments);
    };
}();
var modifyBlocks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(jsonString, preview, language) {
        var isIndexPage, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isIndexPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    if (!isEnrichedTextBlock(jsonString) && !isSkuCarousel(jsonString)) {
                        return [
                            2,
                            jsonString
                        ];
                    }
                    data = JSON.parse(jsonString);
                    return [
                        4,
                        modifyContentBlocks(data.content_blocks, preview, language, isIndexPage)
                    ];
                case 1:
                    data.content_blocks = _state.sent();
                    return [
                        2,
                        JSON.stringify(data)
                    ];
            }
        });
    });
    return function modifyBlocks(jsonString, preview, language) {
        return _ref.apply(this, arguments);
    };
}();
var modifyLandingBlocks = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(jsonString, preview, language) {
        var data, _;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isEnrichedTextBlock(jsonString)) {
                        return [
                            2,
                            jsonString
                        ];
                    }
                    data = JSON.parse(jsonString);
                    _ = data.content;
                    return [
                        4,
                        modifyContentBlocks(data.content.content_blocks, preview, language)
                    ];
                case 1:
                    _.content_blocks = _state.sent();
                    return [
                        2,
                        JSON.stringify(data)
                    ];
            }
        });
    });
    return function modifyLandingBlocks(jsonString, preview, language) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 95881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ orderStatusWithRetry; }
/* harmony export */ });
/* harmony import */ var js_convert_case__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24417);
/* harmony import */ var utils_poll__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5490);
/* harmony import */ var api_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60693);
/* harmony import */ var api_handleErrors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19700);




/**
 * Request to check status of an order.
 * @param orderUrl - The URL of the order to check the status of
 * @returns The response from the order status API
 */ var orderStatus = function(orderUrl) {
    return (0,api_helpers__WEBPACK_IMPORTED_MODULE_2__/* .createRequest */ .hG)("".concat(orderUrl, "status"), {
        isUrl: true,
        logRequest: true,
        method: "GET",
        mode: "cors",
        withAuth: true,
        withSecurityToken: true
    }).then(api_handleErrors__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).then(function(data) {
        return (0,js_convert_case__WEBPACK_IMPORTED_MODULE_0__.camelKeys)(data, {
            recursive: true,
            recursiveInArray: true
        });
    });
};
var orderStatusWithRetry = function(orderUrl) {
    return (0,utils_poll__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        fn: function() {
            return orderStatus(orderUrl);
        },
        validate: function(data) {
            var validStatuses = [
                "COMPLETED",
                "CANCELLED",
                "PENDING_DELIVERY",
                "PENDING_FULFILLMENT",
                "PENDING_PAYMENT",
                "FAILED",
                "PENDING_REVIEW", 
            ];
            return validStatuses.includes(data === null || data === void 0 ? void 0 : data.status);
        },
        interval: 1000,
        maxAttempts: 15
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (orderStatus)));


/***/ }),

/***/ 84920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateCustomerEmailErrors */
/* harmony import */ var api_handleErrors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19700);
/* harmony import */ var api_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60693);


var validateCustomerEmailErrors = {
    invalidEmail: "Email: Customer matching query does not exist.",
    blankEmail: "Email: This field may not be blank."
};
/**
 * Request to validate a customers email in our database.
 * @param email Email that requires validating.
 * @returns Promise of decoded validate email response.
 */ var validateCustomerEmail = function(email) {
    return (0,api_helpers__WEBPACK_IMPORTED_MODULE_1__/* .createRequest */ .hG)("api/v3/customer/validate-email/", {
        method: "POST",
        body: JSON.stringify({
            email: email
        }),
        withMagicUserAgent: true
    }).then(api_handleErrors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
};
/* harmony default export */ __webpack_exports__["Z"] = (validateCustomerEmail);


/***/ }),

/***/ 88486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70655);
/* harmony import */ var api_handleErrors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19700);
/* harmony import */ var api_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60693);




/**
 * Request to fetch server web configuration.
 * @returns Promise with decoded web config response.
 */ var webConfig = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var response, res, feature_braintree_payment_option_guest, feature_braintree_payment_option_member, feature_guest_checkout_web, feature_stripe_billing_address, gift_sender_aliases, gift_sender_title, gift_sender_subtitle, default_pc_purchase_flow, feature_classic_switch_for_gif, classic_multi_purchase_max_recipient, feature_classic_multi_purchase_toggle, unwrapping_auth_flow_v2, feature_enhanced_wallet_web, feature_bff_guest_checkout, default_giphy_search_term, feature_layer, feature_layer_for_classic, feature_layer_buying_web, feature_bff_fraud, feature_email_typo_detection;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api_helpers__WEBPACK_IMPORTED_MODULE_1__/* .createRequest */ .hG)("api/v3/config/client/web/", {
                            withMagicUserAgent: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        (0,api_handleErrors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(response)
                    ];
                case 2:
                    res = _state.sent();
                    feature_braintree_payment_option_guest = res.feature_braintree_payment_option_guest, feature_braintree_payment_option_member = res.feature_braintree_payment_option_member, feature_guest_checkout_web = res.feature_guest_checkout_web, feature_stripe_billing_address = res.feature_stripe_billing_address, gift_sender_aliases = res.gift_sender_aliases, gift_sender_title = res.gift_sender_title, gift_sender_subtitle = res.gift_sender_subtitle, default_pc_purchase_flow = res.default_pc_purchase_flow, feature_classic_switch_for_gif = res.feature_classic_switch_for_gif, classic_multi_purchase_max_recipient = res.classic_multi_purchase_max_recipient, feature_classic_multi_purchase_toggle = res.feature_classic_multi_purchase_toggle, unwrapping_auth_flow_v2 = res.unwrapping_auth_flow_v2, feature_enhanced_wallet_web = res.feature_enhanced_wallet_web, feature_bff_guest_checkout = res.feature_bff_guest_checkout, default_giphy_search_term = res.default_giphy_search_term, feature_layer = res.feature_layer, feature_layer_for_classic = res.feature_layer_for_classic, feature_layer_buying_web = res.feature_layer_buying_web, feature_bff_fraud = res.feature_bff_fraud, feature_email_typo_detection = res.feature_email_typo_detection;
                    return [
                        2,
                        {
                            featureBraintreePaymentOptionGuest: feature_braintree_payment_option_guest,
                            featureBraintreePaymentOptionUser: feature_braintree_payment_option_member,
                            featureGuestCheckout: feature_guest_checkout_web,
                            featureStripeBillingAddress: feature_stripe_billing_address,
                            senderAliases: gift_sender_aliases,
                            senderTitle: gift_sender_title !== null && gift_sender_title !== void 0 ? gift_sender_title : "",
                            senderSubtitle: gift_sender_subtitle !== null && gift_sender_subtitle !== void 0 ? gift_sender_subtitle : "",
                            defaultPcPurchaseFlow: default_pc_purchase_flow,
                            featureClassicSwitchForGif: feature_classic_switch_for_gif,
                            classicMultiPurchaseMaxRecipient: parseInt(classic_multi_purchase_max_recipient) || 5,
                            multiPurchaseToggle: feature_classic_multi_purchase_toggle,
                            unwrappingAuthFlowV2: unwrapping_auth_flow_v2,
                            featureEnhancedWalletWeb: feature_enhanced_wallet_web,
                            featureBffGuestCheckout: !!feature_bff_guest_checkout,
                            defaultGiphySearchTerm: default_giphy_search_term,
                            featureLayer: !!feature_layer,
                            featureLayerForClassic: !!feature_layer_for_classic,
                            featureLayerBuyingWeb: !!feature_layer_buying_web,
                            featureBffFraud: !!feature_bff_fraud,
                            featureEmailTypoDetection: !!feature_email_typo_detection
                        }
                    ];
            }
        });
    });
    return function webConfig() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (webConfig);


/***/ }),

/***/ 45603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YN": function() { return /* binding */ cookieName; },
  "yT": function() { return /* binding */ getCookieDomain; },
  "gB": function() { return /* binding */ getFullUserInfo; },
  "LP": function() { return /* binding */ getToken; },
  "GL": function() { return /* binding */ getTokenFromCookie; },
  "bG": function() { return /* binding */ getUserInfo; },
  "iB": function() { return /* binding */ saveTokenCookie; }
});

// UNUSED EXPORTS: appInfo, decrypt, encrypt, getTokenOpt, getTokenOptServer, region

// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json.bs.js
var Json_bs = __webpack_require__(57687);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_exn.js
var js_exn = __webpack_require__(49263);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_List.js
var belt_List = __webpack_require__(84462);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_decode.bs.js
var Json_decode_bs = __webpack_require__(35847);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_encode.bs.js
var Json_encode_bs = __webpack_require__(64221);
;// CONCATENATED MODULE: ./src/auth/user/UserCookie.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function userDetails(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        firstName: Json_decode_bs/* field */.EP("first_name", Json_decode_bs/* string */.Z_, json),
        lastName: Json_decode_bs/* field */.EP("last_name", Json_decode_bs/* string */.Z_, json),
        email: Json_decode_bs/* field */.EP("email", Json_decode_bs/* string */.Z_, json),
        phoneNumber: Json_decode_bs/* field */.EP("phone_number", Json_decode_bs/* string */.Z_, json)
    };
}
function userCookie(json) {
    return {
        userDetails: Json_decode_bs/* field */.EP("user_details", function(param) {
            return Json_decode_bs/* nullable */.AG(userDetails, param);
        }, json),
        token: Json_decode_bs/* field */.EP("token", Json_decode_bs/* string */.Z_, json),
        masquerade: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("masquerade", Json_decode_bs/* bool */.Xg, param);
        }, json)
    };
}
var Decode = {
    userDetails: userDetails,
    userCookie: userCookie
};
function userDetails$1(u) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "uid",
            Json_encode_bs/* nullable */.AG(function(prim) {
                return prim;
            }, caml_option/* null_to_opt */.UA(u.uid))
        ],
        tl: {
            hd: [
                "first_name",
                u.firstName
            ],
            tl: {
                hd: [
                    "last_name",
                    u.lastName
                ],
                tl: {
                    hd: [
                        "email",
                        u.email
                    ],
                    tl: {
                        hd: [
                            "phone_number",
                            u.phoneNumber
                        ],
                        tl: /* [] */ 0
                    }
                }
            }
        }
    });
}
function userCookie$1(c) {
    var masquerade = belt_Option/* mapWithDefault */.k7(c.masquerade, /* [] */ 0, function(masq) {
        return {
            hd: [
                "masquerade",
                masq
            ],
            tl: /* [] */ 0
        };
    });
    return Json_encode_bs/* object_ */.GN(belt_List/* concat */.zo({
        hd: [
            "user_details",
            Json_encode_bs/* nullable */.AG(userDetails$1, caml_option/* null_to_opt */.UA(c.userDetails))
        ],
        tl: {
            hd: [
                "token",
                c.token
            ],
            tl: /* [] */ 0
        }
    }, masquerade));
}
var Encode = {
    userDetails: userDetails$1,
    userCookie: userCookie$1
};
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/crypto-js/aes.js
var aes = __webpack_require__(40452);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__(55743);
;// CONCATENATED MODULE: ./src/auth/user/AuthUtils.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE










var appInfo = "hM23OPzVXo1RgV7nvpE6uJftHk58PzoSyGRayI21Q3dVP1Cu1NtM0bjd1tsKa6oH";
var cookieName = "storage";
var region = "NZ";
function encrypt(data) {
    return aes.encrypt(data, appInfo).toString();
}
function getCookieDomain(param) {
    var hostname = window.location.hostname;
    if (hostname === "localhost") {
        return "localhost";
    }
    switch(region){
        case "AU":
            return ".prezzee.com.au";
        case "CA":
            return ".prezzee.ca";
        case "GB":
            return ".prezzee.uk";
        case "NZ":
            return ".prezzee.co.nz";
        case "US":
            return ".prezzee.com";
        default:
            return js_exn/* raiseError */.KL("Unknown region for cookie domain");
    }
}
function saveTokenCookie(uc) {
    js_cookie.set(cookieName, encrypt(Json_bs/* stringify */.Pz(Encode.userCookie(uc))), {
        expires: 0.5,
        domain: getCookieDomain(undefined)
    });
}
function decrypt(userCookie) {
    try {
        return belt_Option/* map */.UI(Json_bs/* parse */.Qc(aes.decrypt(userCookie, appInfo).toString(enc_utf8)), Decode.userCookie);
    } catch (exn) {
        return;
    }
}
function getTokenFromCookie(param) {
    return belt_Option/* flatMap */.VS(caml_option/* nullable_to_opt */.Tl(js_cookie.get(cookieName)), decrypt);
}
function getUserInfo(param) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(caml_option/* nullable_to_opt */.Tl(js_cookie.get(cookieName)), decrypt), function(userCookie) {
        var infoOpt = userCookie.userDetails;
        return belt_Option/* map */.UI(infoOpt === null ? undefined : caml_option/* some */.G(infoOpt), function(info) {
            return {
                firstName: info.firstName,
                lastName: info.lastName,
                email: info.email,
                phoneNumber: info.phoneNumber
            };
        });
    });
}
function getFullUserInfo(param) {
    return belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(caml_option/* nullable_to_opt */.Tl(js_cookie.get(cookieName)), decrypt), function(userCookie) {
        return caml_option/* null_to_opt */.UA(userCookie.userDetails);
    });
}
function getToken(param) {
    return belt_Option/* mapWithDefault */.k7(getTokenFromCookie(undefined), "", function(x) {
        return x.token;
    });
}
function getTokenOpt(param) {
    return Belt_Option.mapWithDefault(getTokenFromCookie(undefined), "", function(x) {
        return x.token;
    });
}
function getTokenOptServer(cookiesStr) {
    var result;
    try {
        result = Js_dict.get(Cookie.parse(cookiesStr), cookieName);
    } catch (exn) {
        return;
    }
    return Belt_Option.map(Belt_Option.flatMap(result, decrypt), function(x) {
        return x.token;
    });
}
 /* appInfo Not a pure module */ 


/***/ }),

/***/ 81098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UserProvider": function() { return /* binding */ UserProvider; },
/* harmony export */   "context": function() { return /* binding */ context; },
/* harmony export */   "initValue": function() { return /* binding */ initValue; },
/* harmony export */   "isAuthenticated": function() { return /* binding */ isAuthenticated; },
/* harmony export */   "reducer": function() { return /* binding */ reducer; },
/* harmony export */   "useUser": function() { return /* binding */ useUser; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// Generated by ReScript, PLEASE EDIT WITH CARE

function initValue_1(param) {}
var initValue = [
    /* Guest */ 0,
    initValue_1
];
var context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(initValue);
function useUser(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
}
function reducer(state, action) {
    if (typeof action === "number") {
        return /* Guest */ 0;
    }
    if (action.TAG === /* Login */ 0) {
        return /* Authenticated */ {
            _0: action._0
        };
    }
    if (!state) {
        return state;
    }
    var userInfo = state._0;
    return /* Authenticated */ {
        _0: {
            firstName: action._0,
            lastName: action._1,
            email: userInfo.email,
            phoneNumber: userInfo.phoneNumber
        }
    };
}
function makeProps(value, children, param) {
    return {
        value: value,
        children: children
    };
}
var make = context.Provider;
var UserProvider = {
    makeProps: makeProps,
    make: make
};
function isAuthenticated(x) {
    if (x) {
        return true;
    } else {
        return false;
    }
}
 /* context Not a pure module */ 


/***/ }),

/***/ 71863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bBs": function() { return /* binding */ active; },
  "cq$": function() { return /* binding */ alignItems; },
  "uko": function() { return /* binding */ alignSelf; },
  "oQ4": function() { return /* binding */ animation; },
  "d73": function() { return /* binding */ auto; },
  "Oq0": function() { return /* binding */ background; },
  "Czw": function() { return /* binding */ backgroundColor; },
  "NxW": function() { return /* binding */ backgroundImage; },
  "k0m": function() { return /* binding */ backgroundPosition; },
  "FDc": function() { return /* binding */ backgroundRepeat; },
  "G4q": function() { return /* binding */ backgroundSize; },
  "bbn": function() { return /* binding */ before; },
  "CgR": function() { return /* binding */ border; },
  "h$9": function() { return /* binding */ borderBottom; },
  "AGO": function() { return /* binding */ borderBottomLeftRadius; },
  "rfy": function() { return /* binding */ borderBottomRightRadius; },
  "HMX": function() { return /* binding */ borderBottomWidth; },
  "tvt": function() { return /* binding */ borderColor; },
  "sc3": function() { return /* binding */ borderLeft; },
  "VvE": function() { return /* binding */ borderLeftColor; },
  "njC": function() { return /* binding */ borderLeftStyle; },
  "Pxd": function() { return /* binding */ borderLeftWidth; },
  "E0l": function() { return /* binding */ borderRadius; },
  "vQA": function() { return /* binding */ borderRight; },
  "$uf": function() { return /* binding */ borderStyle; },
  "j1L": function() { return /* binding */ borderTop; },
  "SKu": function() { return /* binding */ borderTopColor; },
  "orU": function() { return /* binding */ borderTopLeftRadius; },
  "E$t": function() { return /* binding */ borderTopRightRadius; },
  "$Bc": function() { return /* binding */ borderTopStyle; },
  "fCW": function() { return /* binding */ borderTopWidth; },
  "J4J": function() { return /* binding */ borderWidth; },
  "IaC": function() { return /* binding */ bottom; },
  "Wnp": function() { return /* binding */ boxShadow; },
  "ixg": function() { return /* binding */ boxSizing; },
  "iUc": function() { return /* binding */ child; },
  "pIy": function() { return /* binding */ children; },
  "o6J": function() { return /* binding */ clipPath; },
  "$_Y": function() { return /* binding */ color; },
  "$QP": function() { return /* binding */ column; },
  "ga_": function() { return /* binding */ counterIncrement; },
  "K03": function() { return /* binding */ counterReset; },
  "ocY": function() { return /* binding */ cursor; },
  "OaU": function() { return /* binding */ deg; },
  "jfB": function() { return /* binding */ display; },
  "em": function() { return /* binding */ em; },
  "fUN": function() { return /* binding */ flex; },
  "L9u": function() { return /* binding */ flex3; },
  "P_T": function() { return /* binding */ flexBasis; },
  "Me8": function() { return /* binding */ flexDirection; },
  "H78": function() { return /* binding */ flexGrow; },
  "i4v": function() { return /* binding */ flexShrink; },
  "WOS": function() { return /* binding */ flexWrap; },
  "T_4": function() { return /* binding */ BsCss_bs_focus; },
  "VlP": function() { return /* binding */ fontFamilies; },
  "I85": function() { return /* binding */ fontFamily; },
  "JBY": function() { return /* binding */ fontSize; },
  "p_N": function() { return /* binding */ fontStyle; },
  "Ue2": function() { return /* binding */ fontWeight; },
  "t4e": function() { return /* binding */ gridColumn; },
  "Ccm": function() { return /* binding */ gridGap; },
  "oIx": function() { return /* binding */ gridRow; },
  "K$K": function() { return /* binding */ gridTemplateColumns; },
  "Cb8": function() { return /* binding */ height; },
  "$v1": function() { return /* binding */ hex; },
  "MrM": function() { return /* binding */ hover; },
  "efO": function() { return /* binding */ important; },
  "oXI": function() { return /* binding */ infinite; },
  "KlP": function() { return /* binding */ justifyContent; },
  "eYb": function() { return /* binding */ justifyItems; },
  "F4b": function() { return /* binding */ BsCss_bs_keyframes; },
  "QOo": function() { return /* binding */ lastChild; },
  "t$v": function() { return /* binding */ left; },
  "rXp": function() { return /* binding */ letterSpacing; },
  "Nv8": function() { return /* binding */ lineHeight; },
  "GEo": function() { return /* binding */ linear; },
  "jZR": function() { return /* binding */ listStyleType; },
  "e6$": function() { return /* binding */ margin; },
  "h9x": function() { return /* binding */ margin2; },
  "F86": function() { return /* binding */ margin3; },
  "X0Y": function() { return /* binding */ margin4; },
  "yl7": function() { return /* binding */ marginBottom; },
  "oIA": function() { return /* binding */ marginLeft; },
  "wzR": function() { return /* binding */ marginRight; },
  "E9m": function() { return /* binding */ marginTop; },
  "kCL": function() { return /* binding */ maxHeight; },
  "kkr": function() { return /* binding */ maxWidth; },
  "BC2": function() { return /* binding */ media; },
  "TSy": function() { return /* binding */ BsCss_bs_merge; },
  "jw4": function() { return /* binding */ minHeight; },
  "ihZ": function() { return /* binding */ minWidth; },
  "vvq": function() { return /* binding */ nthChild; },
  "Ohi": function() { return /* binding */ opacity; },
  "vmh": function() { return /* binding */ order; },
  "Kl7": function() { return /* binding */ outline; },
  "bu0": function() { return /* binding */ outlineWidth; },
  "txR": function() { return /* binding */ overflow; },
  "zzh": function() { return /* binding */ overflowX; },
  "pU1": function() { return /* binding */ overflowY; },
  "o3D": function() { return /* binding */ padding; },
  "BLt": function() { return /* binding */ padding2; },
  "OqZ": function() { return /* binding */ padding3; },
  "EtG": function() { return /* binding */ paddingBottom; },
  "rv2": function() { return /* binding */ paddingLeft; },
  "WLm": function() { return /* binding */ paddingRight; },
  "odA": function() { return /* binding */ paddingTop; },
  "hdZ": function() { return /* binding */ pct; },
  "FKU": function() { return /* binding */ position; },
  "px": function() { return /* binding */ px; },
  "hOB": function() { return /* binding */ rem; },
  "SIr": function() { return /* binding */ resize; },
  "B8C": function() { return /* binding */ rgb; },
  "m4f": function() { return /* binding */ rgba; },
  "F2z": function() { return /* binding */ right; },
  "U1s": function() { return /* binding */ rotate; },
  "nZE": function() { return /* binding */ selector; },
  "SQh": function() { return /* binding */ solid; },
  "oBv": function() { return /* binding */ style; },
  "ydu": function() { return /* binding */ textAlign; },
  "QXS": function() { return /* binding */ textDecoration; },
  "wey": function() { return /* binding */ BsCss_bs_top; },
  "vs": function() { return /* binding */ transform; },
  "nVE": function() { return /* binding */ transitionDuration; },
  "n_e": function() { return /* binding */ transitionProperty; },
  "BdG": function() { return /* binding */ transitionTimingFunction; },
  "eCr": function() { return /* binding */ underline; },
  "K47": function() { return /* binding */ unsafe; },
  "HQ2": function() { return /* binding */ url; },
  "vh": function() { return /* binding */ vh; },
  "WDY": function() { return /* binding */ visibility; },
  "Fv": function() { return /* binding */ visited; },
  "vw": function() { return /* binding */ vw; },
  "ixZ": function() { return /* binding */ white; },
  "d8w": function() { return /* binding */ whiteSpace; },
  "bf$": function() { return /* binding */ width; },
  "W5D": function() { return /* binding */ zIndex; },
  "bMI": function() { return /* binding */ zero; }
});

// UNUSED EXPORTS: $$default, $$double, $$float, $$global, $$static, $$super, $$var, Animation, Calc, Make, Nth, SVG, Shadow, Transition, Types, absolute, after, alias, aliceblue, alignContent, all, allScroll, alternate, alternateReverse, animationDelay, animationDirection, animationDuration, animationFillMode, animationIterationCount, animationName, animationPlayState, animationTimingFunction, animationValue, animations, antiquewhite, anyLink, aqua, aquamarine, areas, azure, backdropFilter, backfaceVisibility, backgroundAttachment, backgroundClip, backgroundOrigin, backgroundPosition4, backgroundPositions, backgrounds, backwards, baseline, beige, bevel, bisque, black, blanchedalmond, block, blue, blueviolet, bold, bolder, borderBottomColor, borderBottomStyle, borderBox, borderCollapse, borderRightColor, borderRightStyle, borderRightWidth, borderSpacing, both, boxShadows, breakAll, breakWord, brown, burlywood, butt, cache, cadetblue, capitalize, caretColor, cell, center, ch, chartreuse, checked, chocolate, clear, clip, cm, colResize, columnCount, columnGap, columnReverse, columnWidth, conicGradient, contain, content, contentBox, contentRule, contentRules, contents, contextMenu, copy, coral, cornflowerblue, cornsilk, count, counterSet, countersIncrement, countersReset, countersSet, cover, crimson, crosshair, cubicBezier, currentColor, cyan, darkblue, darkcyan, darkgoldenrod, darkgray, darkgreen, darkgrey, darkkhaki, darkmagenta, darkolivegreen, darkorange, darkorchid, darkred, darksalmon, darkseagreen, darkslateblue, darkslategray, darkslategrey, darkturquoise, darkviolet, dashed, deeppink, deepskyblue, default, defined, dimgray, dimgrey, directSibling, direction, disabled, dodgerblue, dotted, eResize, ease, easeIn, easeInOut, easeOut, ellipsis, empty, enabled, ewResize, ex, extraBold, extraLight, fill, fillBox, filter, firebrick, first, firstChild, firstLetter, firstLine, firstOfType, fitContent, fixed, flexBox, flexEnd, flexStart, floralwhite, focusVisible, focusWithin, fontFace, fontVariant, forestgreen, forwards, fr, fuchsia, gainsboro, gap, gap2, ghostwhite, gold, goldenrod, grab, grabbing, grad, gray, green, greenyellow, grey, grid, gridArea, gridArea2, gridArea3, gridArea4, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumnEnd, gridColumnGap, gridColumnStart, gridRowEnd, gridRowGap, gridRowStart, gridTemplateAreas, gridTemplateRows, help, hidden, honeydew, horizontal, host, hotpink, hsl, hsla, ident, inRange, indeterminate, indianred, indigo, inherit_, initial, inline, inlineBlock, inlineFlex, inlineGrid, inlineTable, insertRule, inside, invalid, isolate, isolation, italic, ivory, justifySelf, keepAll, khaki, label, lang, lastOfType, lavender, lavenderblush, lawngreen, lemonchiffon, light, lightblue, lightcoral, lightcyan, lighter, lightgoldenrodyellow, lightgray, lightgreen, lightgrey, lightpink, lightsalmon, lightseagreen, lightskyblue, lightslategray, lightslategrey, lightsteelblue, lightyellow, lime, limegreen, lineThrough, linearGradient, linen, link, listItem, listStyle, listStyleImage, listStylePosition, local, localUrl, lowercase, ltr, magenta, manipulation, marginBox, maroon, maskImage, maskPosition, maskPositions, maxContent, medium, mediumaquamarine, mediumblue, mediumorchid, mediumpurple, mediumseagreen, mediumslateblue, mediumspringgreen, mediumturquoise, mediumvioletred, merge2, merge3, merge4, middle, midnightblue, minContent, minmax, mintcream, mistyrose, miter, mm, moccasin, move, nResize, navajowhite, navy, neResize, neswResize, noDrop, noRepeat, none, normal, notAllowed, not_, nowrap, nsResize, nthLastChild, nthLastOfType, nthOfType, numIdent, nwResize, nwseResize, objectFit, objectPosition, oblique, oldlace, olive, olivedrab, onlyChild, onlyOfType, optional, orange, orangered, orchid, outOfRange, outlineColor, outlineOffset, outlineStyle, outside, overflowAnchor, overflowWrap, overline, overscrollBehavior, padding4, paddingBox, palegoldenrod, palegreen, paleturquoise, palevioletred, panDown, panLeft, panRight, panUp, panX, panY, papayawhip, paused, peachpuff, perspective, perspectiveOrigin, peru, pinchZoom, pink, placeholder, plum, pointer, pointerEvents, powderblue, progress, pt, purple, pxFloat, rad, radialGradient, readOnly, readWrite, rebeccapurple, red, relative, renderGlobal, renderKeyframes, renderRule, repeat, repeatX, repeatY, repeatingLinearGradient, repeatingRadialGradient, required, reverse, root, rosybrown, rotate3d, rotateX, rotateY, rotateZ, round, row, rowGap, rowResize, rowReverse, royalblue, rtl, runIn, running, sResize, saddlebrown, salmon, sandybrown, scale, scale3d, scaleX, scaleY, scaleZ, scope, scroll, scrollBehavior, seResize, seagreen, seashell, selection, semiBold, siblings, sienna, silver, size, skew, skewX, skewY, skyblue, slateblue, slategray, slategrey, smallCaps, snow, space, spaceAround, spaceBetween, spaceEvenly, springgreen, square, steelblue, stepEnd, stepStart, steps, sticky, stretch, strokeBox, sub, swResize, table, tableCaption, tableCell, tableColumn, tableColumnGroup, tableFooterGroup, tableHeaderGroup, tableLayout, tableRow, tableRowGroup, tan, target, teal, text, textBottom, textDecorationColor, textDecorationLine, textDecorationStyle, textIndent, textOverflow, textShadow, textShadows, textTop, textTransform, thin, thistle, toJson, tomato, touchAction, transformOrigin, transformOrigin3d, transformStyle, transforms, transition, transitionDelay, transitionList, transitionValue, transitions, translate, translate3d, translateX, translateY, translateZ, transparent, turn, turquoise, unset, uppercase, userSelect, valid, varDefault, vertical, verticalAlign, verticalText, viewBox, violet, visible, vmax, vmin, wResize, wait, wavy, wheat, whitesmoke, wordBreak, wordSpacing, wordWrap, wrap, wrapReverse, yellow, yellowgreen, zoomIn, zoomOut

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Colors.bs.js
var Css_Colors_bs = __webpack_require__(77274);
// EXTERNAL MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js + 1 modules
var emotion_css_create_instance_esm = __webpack_require__(32566);
;// CONCATENATED MODULE: ./src/bindings/emotion.js

var ref = (0,emotion_css_create_instance_esm/* default */.Z)({
    key: "consumer"
});
// Basically, emotion does not play nicely with SSR if you have two 'instances' of it, which we do (one here, and one in codebase for the main site).
// This is the work around - essentially, creating our own 'instance' of the Emotion bindings, with their own cache (the cache is the important bit).
var flush = ref.flush, hydrate = ref.hydrate, cx = ref.cx, merge = ref.merge, getRegisteredStyles = ref.getRegisteredStyles, injectGlobal = ref.injectGlobal, keyframes = ref.keyframes, css = ref.css, sheet = ref.sheet, cache = ref.cache;

// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
;// CONCATENATED MODULE: ./src/bindings/BsCss.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var injectRaw = injectGlobal;
function renderRaw(param, css) {
    injectRaw(css);
}
var injectRawRules = injectGlobal;
function injectRules(selector, rules) {
    injectRawRules(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
function renderRules(param, selector, rules) {
    injectRawRules(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
var mergeStyles = cx;
var make = css;
var makeAnimation = keyframes;
function makeKeyframes(frames) {
    return makeAnimation(frames);
}
function renderKeyframes(param, frames) {
    return makeAnimation(frames);
}
var include = Css_Legacy_Core_bs/* Make */.t0D({
    injectRaw: injectRaw,
    renderRaw: renderRaw,
    injectRules: injectRules,
    renderRules: renderRules,
    make: make,
    mergeStyles: mergeStyles,
    makeKeyframes: makeKeyframes,
    renderKeyframes: renderKeyframes
});
var insertRule = include.insertRule;
var BsCss_bs_cache = cache;
function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
    Curry._1(insertRule, Css_Legacy_Core.fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, undefined));
    return fontFamily;
}
var Types = Css_Legacy_Core_bs/* Types */.Yky;
var Make = Css_Legacy_Core_bs/* Make */.t0D;
var toJson = Css_Legacy_Core_bs/* toJson */.QsJ;
var important = Css_Legacy_Core_bs/* important */.efO;
var label = Css_Legacy_Core_bs/* label */.PS9;
var Shadow = Css_Legacy_Core_bs/* Shadow */.jXB;
var unsafe = Css_Legacy_Core_bs/* unsafe */.K47;
var alignContent = Css_Legacy_Core_bs/* alignContent */.Kvj;
var alignItems = Css_Legacy_Core_bs/* alignItems */.cq$;
var alignSelf = Css_Legacy_Core_bs/* alignSelf */.uko;
var animationDelay = Css_Legacy_Core_bs/* animationDelay */.lEu;
var animationDirection = Css_Legacy_Core_bs/* animationDirection */.ZRe;
var animationDuration = Css_Legacy_Core_bs/* animationDuration */.wyN;
var animationFillMode = Css_Legacy_Core_bs/* animationFillMode */.$mx;
var animationIterationCount = Css_Legacy_Core_bs/* animationIterationCount */.EcY;
var animationPlayState = Css_Legacy_Core_bs/* animationPlayState */.dZD;
var animationTimingFunction = Css_Legacy_Core_bs/* animationTimingFunction */.KUN;
var backdropFilter = Css_Legacy_Core_bs/* backdropFilter */.nLE;
var backfaceVisibility = Css_Legacy_Core_bs/* backfaceVisibility */.uhB;
var backgroundAttachment = Css_Legacy_Core_bs/* backgroundAttachment */.Yep;
var backgroundColor = Css_Legacy_Core_bs/* backgroundColor */.Czw;
var backgroundClip = Css_Legacy_Core_bs/* backgroundClip */._cl;
var backgroundImage = Css_Legacy_Core_bs/* backgroundImage */.NxW;
var maskImage = Css_Legacy_Core_bs/* maskImage */.zT3;
var backgroundOrigin = Css_Legacy_Core_bs/* backgroundOrigin */.ezj;
var backgroundPosition = Css_Legacy_Core_bs/* backgroundPosition */.k0m;
var backgroundPositions = Css_Legacy_Core_bs/* backgroundPositions */.bCW;
var backgroundPosition4 = Css_Legacy_Core_bs/* backgroundPosition4 */.Sgw;
var backgroundRepeat = Css_Legacy_Core_bs/* backgroundRepeat */.FDc;
var maskPosition = Css_Legacy_Core_bs/* maskPosition */.tac;
var maskPositions = Css_Legacy_Core_bs/* maskPositions */.otN;
var borderBottom = Css_Legacy_Core_bs/* borderBottom */.h$9;
var borderBottomColor = Css_Legacy_Core_bs/* borderBottomColor */.vSo;
var borderBottomLeftRadius = Css_Legacy_Core_bs/* borderBottomLeftRadius */.AGO;
var borderBottomRightRadius = Css_Legacy_Core_bs/* borderBottomRightRadius */.rfy;
var borderBottomStyle = Css_Legacy_Core_bs/* borderBottomStyle */.qtZ;
var borderBottomWidth = Css_Legacy_Core_bs/* borderBottomWidth */.HMX;
var borderCollapse = Css_Legacy_Core_bs/* borderCollapse */.obx;
var borderColor = Css_Legacy_Core_bs/* borderColor */.tvt;
var borderLeft = Css_Legacy_Core_bs/* borderLeft */.sc3;
var borderLeftColor = Css_Legacy_Core_bs/* borderLeftColor */.VvE;
var borderLeftStyle = Css_Legacy_Core_bs/* borderLeftStyle */.njC;
var borderLeftWidth = Css_Legacy_Core_bs/* borderLeftWidth */.Pxd;
var borderRight = Css_Legacy_Core_bs/* borderRight */.vQA;
var borderRightColor = Css_Legacy_Core_bs/* borderRightColor */.XY7;
var borderRightStyle = Css_Legacy_Core_bs/* borderRightStyle */.SVd;
var borderRightWidth = Css_Legacy_Core_bs/* borderRightWidth */.UY5;
var borderRadius = Css_Legacy_Core_bs/* borderRadius */.E0l;
var borderSpacing = Css_Legacy_Core_bs/* borderSpacing */.hJp;
var borderStyle = Css_Legacy_Core_bs/* borderStyle */.$uf;
var borderTopColor = Css_Legacy_Core_bs/* borderTopColor */.SKu;
var borderTopLeftRadius = Css_Legacy_Core_bs/* borderTopLeftRadius */.orU;
var borderTopRightRadius = Css_Legacy_Core_bs/* borderTopRightRadius */.E$t;
var borderTopStyle = Css_Legacy_Core_bs/* borderTopStyle */.$Bc;
var borderTopWidth = Css_Legacy_Core_bs/* borderTopWidth */.fCW;
var borderWidth = Css_Legacy_Core_bs/* borderWidth */.J4J;
var bottom = Css_Legacy_Core_bs/* bottom */.IaC;
var boxSizing = Css_Legacy_Core_bs/* boxSizing */.ixg;
var boxShadow = Css_Legacy_Core_bs/* boxShadow */.Wnp;
var boxShadows = Css_Legacy_Core_bs/* boxShadows */.LZf;
var clear = Css_Legacy_Core_bs/* clear */.ZHw;
var clipPath = Css_Legacy_Core_bs/* clipPath */.o6J;
var color = Css_Legacy_Core_bs/* color */.$_Y;
var columnCount = Css_Legacy_Core_bs/* columnCount */.J49;
var contentRule = Css_Legacy_Core_bs/* contentRule */.U5V;
var contentRules = Css_Legacy_Core_bs/* contentRules */.jK5;
var counterIncrement = Css_Legacy_Core_bs/* counterIncrement */.ga_;
var countersIncrement = Css_Legacy_Core_bs/* countersIncrement */.$Co;
var counterReset = Css_Legacy_Core_bs/* counterReset */.K03;
var countersReset = Css_Legacy_Core_bs/* countersReset */.Yi5;
var counterSet = Css_Legacy_Core_bs/* counterSet */.nKF;
var countersSet = Css_Legacy_Core_bs/* countersSet */.Eqy;
var cursor = Css_Legacy_Core_bs/* cursor */.ocY;
var direction = Css_Legacy_Core_bs/* direction */.o7V;
var display = Css_Legacy_Core_bs/* display */.jfB;
var flex = Css_Legacy_Core_bs/* flex */.fUN;
var flexBasis = Css_Legacy_Core_bs/* flexBasis */.P_T;
var flexDirection = Css_Legacy_Core_bs/* flexDirection */.Me8;
var flexGrow = Css_Legacy_Core_bs/* flexGrow */.H78;
var flexShrink = Css_Legacy_Core_bs/* flexShrink */.i4v;
var flexWrap = Css_Legacy_Core_bs/* flexWrap */.WOS;
var $$float = Css_Legacy_Core_bs/* $$float */.uwu;
var fontFamily = Css_Legacy_Core_bs/* fontFamily */.I85;
var fontFamilies = Css_Legacy_Core_bs/* fontFamilies */.VlP;
var fontSize = Css_Legacy_Core_bs/* fontSize */.JBY;
var fontStyle = Css_Legacy_Core_bs/* fontStyle */.p_N;
var fontVariant = Css_Legacy_Core_bs/* fontVariant */.xvA;
var fontWeight = Css_Legacy_Core_bs/* fontWeight */.Ue2;
var gridArea = Css_Legacy_Core_bs/* gridArea */.fD_;
var gridArea2 = Css_Legacy_Core_bs/* gridArea2 */.Vy2;
var gridArea3 = Css_Legacy_Core_bs/* gridArea3 */.V8q;
var gridArea4 = Css_Legacy_Core_bs/* gridArea4 */.PUt;
var gridAutoFlow = Css_Legacy_Core_bs/* gridAutoFlow */.BaW;
var gridColumn = Css_Legacy_Core_bs/* gridColumn */.t4e;
var gridColumnEnd = Css_Legacy_Core_bs/* gridColumnEnd */.cod;
var columnGap = Css_Legacy_Core_bs/* columnGap */.e$I;
var scrollBehavior = Css_Legacy_Core_bs/* scrollBehavior */.sCq;
var overscrollBehavior = Css_Legacy_Core_bs/* overscrollBehavior */.jSQ;
var overflowAnchor = Css_Legacy_Core_bs/* overflowAnchor */.PhB;
var columnWidth = Css_Legacy_Core_bs/* columnWidth */.G4A;
var caretColor = Css_Legacy_Core_bs/* caretColor */.OYb;
var rowGap = Css_Legacy_Core_bs/* rowGap */.s2f;
var gridColumnGap = Css_Legacy_Core_bs/* gridColumnGap */.W3B;
var gridColumnStart = Css_Legacy_Core_bs/* gridColumnStart */.ur1;
var gap = Css_Legacy_Core_bs/* gap */.SGp;
var gap2 = Css_Legacy_Core_bs/* gap2 */.rjz;
var gridGap = Css_Legacy_Core_bs/* gridGap */.Ccm;
var gridRow = Css_Legacy_Core_bs/* gridRow */.oIx;
var gridRowEnd = Css_Legacy_Core_bs/* gridRowEnd */.Zys;
var gridRowGap = Css_Legacy_Core_bs/* gridRowGap */.UbJ;
var gridRowStart = Css_Legacy_Core_bs/* gridRowStart */.lpz;
var gridTemplateAreas = Css_Legacy_Core_bs/* gridTemplateAreas */.zIs;
var height = Css_Legacy_Core_bs/* height */.Cb8;
var justifyContent = Css_Legacy_Core_bs/* justifyContent */.KlP;
var justifyItems = Css_Legacy_Core_bs/* justifyItems */.eYb;
var justifySelf = Css_Legacy_Core_bs/* justifySelf */.zoP;
var left = Css_Legacy_Core_bs/* left */.t$v;
var letterSpacing = Css_Legacy_Core_bs/* letterSpacing */.rXp;
var lineHeight = Css_Legacy_Core_bs/* lineHeight */.Nv8;
var listStyle = Css_Legacy_Core_bs/* listStyle */.VXB;
var listStyleImage = Css_Legacy_Core_bs/* listStyleImage */.yOV;
var listStyleType = Css_Legacy_Core_bs/* listStyleType */.jZR;
var listStylePosition = Css_Legacy_Core_bs/* listStylePosition */.xPo;
var margin = Css_Legacy_Core_bs/* margin */.e6$;
var margin2 = Css_Legacy_Core_bs/* margin2 */.h9x;
var margin3 = Css_Legacy_Core_bs/* margin3 */.F86;
var margin4 = Css_Legacy_Core_bs/* margin4 */.X0Y;
var marginLeft = Css_Legacy_Core_bs/* marginLeft */.oIA;
var marginRight = Css_Legacy_Core_bs/* marginRight */.wzR;
var marginTop = Css_Legacy_Core_bs/* marginTop */.E9m;
var marginBottom = Css_Legacy_Core_bs/* marginBottom */.yl7;
var maxHeight = Css_Legacy_Core_bs/* maxHeight */.kCL;
var maxWidth = Css_Legacy_Core_bs/* maxWidth */.kkr;
var minHeight = Css_Legacy_Core_bs/* minHeight */.jw4;
var minWidth = Css_Legacy_Core_bs/* minWidth */.ihZ;
var objectFit = Css_Legacy_Core_bs/* objectFit */.fXf;
var objectPosition = Css_Legacy_Core_bs/* objectPosition */.YP6;
var opacity = Css_Legacy_Core_bs/* opacity */.Ohi;
var order = Css_Legacy_Core_bs/* order */.vmh;
var outline = Css_Legacy_Core_bs/* outline */.Kl7;
var outlineColor = Css_Legacy_Core_bs/* outlineColor */.dxT;
var outlineOffset = Css_Legacy_Core_bs/* outlineOffset */.KL2;
var outlineStyle = Css_Legacy_Core_bs/* outlineStyle */.zuB;
var outlineWidth = Css_Legacy_Core_bs/* outlineWidth */.bu0;
var overflow = Css_Legacy_Core_bs/* overflow */.txR;
var overflowX = Css_Legacy_Core_bs/* overflowX */.zzh;
var overflowY = Css_Legacy_Core_bs/* overflowY */.pU1;
var overflowWrap = Css_Legacy_Core_bs/* overflowWrap */.LIb;
var padding = Css_Legacy_Core_bs/* padding */.o3D;
var padding2 = Css_Legacy_Core_bs/* padding2 */.BLt;
var padding3 = Css_Legacy_Core_bs/* padding3 */.OqZ;
var padding4 = Css_Legacy_Core_bs/* padding4 */._fG;
var paddingLeft = Css_Legacy_Core_bs/* paddingLeft */.rv2;
var paddingRight = Css_Legacy_Core_bs/* paddingRight */.WLm;
var paddingTop = Css_Legacy_Core_bs/* paddingTop */.odA;
var paddingBottom = Css_Legacy_Core_bs/* paddingBottom */.EtG;
var perspective = Css_Legacy_Core_bs/* perspective */.G30;
var perspectiveOrigin = Css_Legacy_Core_bs/* perspectiveOrigin */.gr0;
var pointerEvents = Css_Legacy_Core_bs/* pointerEvents */.kkJ;
var position = Css_Legacy_Core_bs/* position */.FKU;
var isolation = Css_Legacy_Core_bs/* isolation */.BD_;
var resize = Css_Legacy_Core_bs/* resize */.SIr;
var right = Css_Legacy_Core_bs/* right */.F2z;
var tableLayout = Css_Legacy_Core_bs/* tableLayout */.GJu;
var textAlign = Css_Legacy_Core_bs/* textAlign */.ydu;
var textDecorationColor = Css_Legacy_Core_bs/* textDecorationColor */.hrh;
var textDecorationLine = Css_Legacy_Core_bs/* textDecorationLine */.A8G;
var textDecorationStyle = Css_Legacy_Core_bs/* textDecorationStyle */.vo$;
var textIndent = Css_Legacy_Core_bs/* textIndent */.h52;
var textOverflow = Css_Legacy_Core_bs/* textOverflow */._Xt;
var textShadow = Css_Legacy_Core_bs/* textShadow */.XCE;
var textShadows = Css_Legacy_Core_bs/* textShadows */.sg9;
var textTransform = Css_Legacy_Core_bs/* textTransform */.QxZ;
var BsCss_bs_top = Css_Legacy_Core_bs/* top */.wey;
var transform = Css_Legacy_Core_bs/* transform */.vs;
var transforms = Css_Legacy_Core_bs/* transforms */.Lol;
var transformOrigin = Css_Legacy_Core_bs/* transformOrigin */.p22;
var transformOrigin3d = Css_Legacy_Core_bs/* transformOrigin3d */.TRc;
var transitionDelay = Css_Legacy_Core_bs/* transitionDelay */.BFP;
var transitionDuration = Css_Legacy_Core_bs/* transitionDuration */.nVE;
var transitionProperty = Css_Legacy_Core_bs/* transitionProperty */.n_e;
var transformStyle = Css_Legacy_Core_bs/* transformStyle */.V1P;
var transitionTimingFunction = Css_Legacy_Core_bs/* transitionTimingFunction */.BdG;
var userSelect = Css_Legacy_Core_bs/* userSelect */.sih;
var verticalAlign = Css_Legacy_Core_bs/* verticalAlign */.Loy;
var visibility = Css_Legacy_Core_bs/* visibility */.WDY;
var width = Css_Legacy_Core_bs/* width */.bf$;
var whiteSpace = Css_Legacy_Core_bs/* whiteSpace */.d8w;
var wordBreak = Css_Legacy_Core_bs/* wordBreak */.lM7;
var wordSpacing = Css_Legacy_Core_bs/* wordSpacing */.qJL;
var wordWrap = Css_Legacy_Core_bs/* wordWrap */.BWb;
var zIndex = Css_Legacy_Core_bs/* zIndex */.W5D;
var selector = Css_Legacy_Core_bs/* selector */.nZE;
var media = Css_Legacy_Core_bs/* media */.BC2;
var active = Css_Legacy_Core_bs/* active */.bBs;
var checked = Css_Legacy_Core_bs/* checked */.ec_;
var $$default = Css_Legacy_Core_bs/* $$default */.rHv;
var defined = Css_Legacy_Core_bs/* defined */.rif;
var disabled = Css_Legacy_Core_bs/* disabled */.JUm;
var empty = Css_Legacy_Core_bs/* empty */.cSb;
var enabled = Css_Legacy_Core_bs/* enabled */.amh;
var first = Css_Legacy_Core_bs/* first */.PsQ;
var firstChild = Css_Legacy_Core_bs/* firstChild */.mUE;
var firstOfType = Css_Legacy_Core_bs/* firstOfType */.$Sh;
var BsCss_bs_focus = Css_Legacy_Core_bs/* focus */.T_4;
var focusVisible = Css_Legacy_Core_bs/* focusVisible */.bPo;
var focusWithin = Css_Legacy_Core_bs/* focusWithin */.u_l;
var host = Css_Legacy_Core_bs/* host */.ho7;
var hover = Css_Legacy_Core_bs/* hover */.MrM;
var indeterminate = Css_Legacy_Core_bs/* indeterminate */.Nxf;
var inRange = Css_Legacy_Core_bs/* inRange */.Z2v;
var invalid = Css_Legacy_Core_bs/* invalid */.I1x;
var lang = Css_Legacy_Core_bs/* lang */.KQv;
var lastChild = Css_Legacy_Core_bs/* lastChild */.QOo;
var lastOfType = Css_Legacy_Core_bs/* lastOfType */.xBE;
var BsCss_bs_link = Css_Legacy_Core_bs/* link */.p4m;
var not_ = Css_Legacy_Core_bs/* not_ */.YdO;
var Nth = Css_Legacy_Core_bs/* Nth */.eNo;
var nthChild = Css_Legacy_Core_bs/* nthChild */.vvq;
var nthLastChild = Css_Legacy_Core_bs/* nthLastChild */.NXf;
var nthLastOfType = Css_Legacy_Core_bs/* nthLastOfType */.tPj;
var nthOfType = Css_Legacy_Core_bs/* nthOfType */.NOF;
var onlyChild = Css_Legacy_Core_bs/* onlyChild */.Z9P;
var onlyOfType = Css_Legacy_Core_bs/* onlyOfType */.zEV;
var optional = Css_Legacy_Core_bs/* optional */.jtO;
var outOfRange = Css_Legacy_Core_bs/* outOfRange */.ihe;
var readOnly = Css_Legacy_Core_bs/* readOnly */.qtd;
var readWrite = Css_Legacy_Core_bs/* readWrite */.H6;
var required = Css_Legacy_Core_bs/* required */.C1W;
var root = Css_Legacy_Core_bs/* root */.Jz2;
var scope = Css_Legacy_Core_bs/* scope */.eIe;
var target = Css_Legacy_Core_bs/* target */.fA7;
var valid = Css_Legacy_Core_bs/* valid */.QF4;
var visited = Css_Legacy_Core_bs/* visited */.Fv;
var after = Css_Legacy_Core_bs/* after */.e4p;
var before = Css_Legacy_Core_bs/* before */.bbn;
var firstLetter = Css_Legacy_Core_bs/* firstLetter */.i16;
var firstLine = Css_Legacy_Core_bs/* firstLine */.wxz;
var placeholder = Css_Legacy_Core_bs/* placeholder */.W$B;
var selection = Css_Legacy_Core_bs/* selection */.DuZ;
var child = Css_Legacy_Core_bs/* child */.iUc;
var children = Css_Legacy_Core_bs/* children */.pIy;
var directSibling = Css_Legacy_Core_bs/* directSibling */.cOP;
var siblings = Css_Legacy_Core_bs/* siblings */.dxy;
var anyLink = Css_Legacy_Core_bs/* anyLink */.ub3;
var initial = Css_Legacy_Core_bs/* initial */.nnL;
var inherit_ = Css_Legacy_Core_bs/* inherit_ */.atG;
var unset = Css_Legacy_Core_bs/* unset */.zNf;
var $$var = Css_Legacy_Core_bs/* $$var */.epG;
var varDefault = Css_Legacy_Core_bs/* varDefault */.Djg;
var auto = Css_Legacy_Core_bs/* auto */.d73;
var none = Css_Legacy_Core_bs/* none */.YPD;
var BsCss_bs_text = Css_Legacy_Core_bs/* text */.fLW;
var pct = Css_Legacy_Core_bs/* pct */.hdZ;
var ch = Css_Legacy_Core_bs.ch;
var cm = Css_Legacy_Core_bs.cm;
var em = Css_Legacy_Core_bs.em;
var ex = Css_Legacy_Core_bs.ex;
var mm = Css_Legacy_Core_bs.mm;
var pt = Css_Legacy_Core_bs.pt;
var px = Css_Legacy_Core_bs.px;
var pxFloat = Css_Legacy_Core_bs/* pxFloat */.cYj;
var rem = Css_Legacy_Core_bs/* rem */.hOB;
var vh = Css_Legacy_Core_bs.vh;
var vmin = Css_Legacy_Core_bs/* vmin */.v03;
var vmax = Css_Legacy_Core_bs/* vmax */.s8c;
var zero = Css_Legacy_Core_bs/* zero */.bMI;
var deg = Css_Legacy_Core_bs/* deg */.OaU;
var rad = Css_Legacy_Core_bs/* rad */.BJ1;
var grad = Css_Legacy_Core_bs/* grad */.UQy;
var turn = Css_Legacy_Core_bs/* turn */.E2y;
var ltr = Css_Legacy_Core_bs/* ltr */.m6$;
var rtl = Css_Legacy_Core_bs/* rtl */.bd4;
var absolute = Css_Legacy_Core_bs/* absolute */.AGi;
var relative = Css_Legacy_Core_bs/* relative */.Gfm;
var $$static = Css_Legacy_Core_bs/* $$static */.Yum;
var fixed = Css_Legacy_Core_bs/* fixed */.Bdr;
var sticky = Css_Legacy_Core_bs/* sticky */.CAZ;
var isolate = Css_Legacy_Core_bs/* isolate */.KMK;
var horizontal = Css_Legacy_Core_bs/* horizontal */.SlK;
var vertical = Css_Legacy_Core_bs/* vertical */.KRj;
var smallCaps = Css_Legacy_Core_bs/* smallCaps */.jc2;
var italic = Css_Legacy_Core_bs/* italic */.pUw;
var oblique = Css_Legacy_Core_bs/* oblique */.$6v;
var BsCss_bs_hidden = Css_Legacy_Core_bs/* hidden */.alX;
var visible = Css_Legacy_Core_bs/* visible */.oPT;
var BsCss_bs_scroll = Css_Legacy_Core_bs/* scroll */.ARY;
var rgb = Css_Legacy_Core_bs/* rgb */.B8C;
var rgba = Css_Legacy_Core_bs/* rgba */.m4f;
var hsl = Css_Legacy_Core_bs/* hsl */.Ym7;
var hsla = Css_Legacy_Core_bs/* hsla */.Jnk;
var hex = Css_Legacy_Core_bs/* hex */.$v1;
var currentColor = Css_Legacy_Core_bs/* currentColor */.wyo;
var local = Css_Legacy_Core_bs/* local */.I_Q;
var paddingBox = Css_Legacy_Core_bs/* paddingBox */.tD0;
var borderBox = Css_Legacy_Core_bs/* borderBox */.iu7;
var contentBox = Css_Legacy_Core_bs/* contentBox */.fLi;
var noRepeat = Css_Legacy_Core_bs/* noRepeat */.DHQ;
var space = Css_Legacy_Core_bs/* space */.DhX;
var repeat = Css_Legacy_Core_bs/* repeat */.rx1;
var minmax = Css_Legacy_Core_bs/* minmax */.WFv;
var repeatX = Css_Legacy_Core_bs/* repeatX */.pMI;
var repeatY = Css_Legacy_Core_bs/* repeatY */.yEL;
var contain = Css_Legacy_Core_bs/* contain */.XSY;
var cover = Css_Legacy_Core_bs/* cover */.v8j;
var row = Css_Legacy_Core_bs/* row */.O7B;
var rowReverse = Css_Legacy_Core_bs/* rowReverse */.poq;
var column = Css_Legacy_Core_bs/* column */.$QP;
var columnReverse = Css_Legacy_Core_bs/* columnReverse */.Xsx;
var wrap = Css_Legacy_Core_bs/* wrap */.reQ;
var nowrap = Css_Legacy_Core_bs/* nowrap */.P8R;
var wrapReverse = Css_Legacy_Core_bs/* wrapReverse */.g7Q;
var inline = Css_Legacy_Core_bs/* inline */.QoB;
var block = Css_Legacy_Core_bs/* block */.Gew;
var contents = Css_Legacy_Core_bs/* contents */.IQZ;
var flexBox = Css_Legacy_Core_bs/* flexBox */.tPW;
var grid = Css_Legacy_Core_bs/* grid */.eCg;
var inlineBlock = Css_Legacy_Core_bs/* inlineBlock */.vdF;
var inlineFlex = Css_Legacy_Core_bs/* inlineFlex */.z8w;
var inlineGrid = Css_Legacy_Core_bs/* inlineGrid */.tgT;
var inlineTable = Css_Legacy_Core_bs/* inlineTable */.ZHG;
var listItem = Css_Legacy_Core_bs/* listItem */.qbe;
var runIn = Css_Legacy_Core_bs/* runIn */.Jbp;
var table = Css_Legacy_Core_bs/* table */.Kzj;
var tableCaption = Css_Legacy_Core_bs/* tableCaption */.Ppf;
var tableColumnGroup = Css_Legacy_Core_bs/* tableColumnGroup */.yLU;
var tableHeaderGroup = Css_Legacy_Core_bs/* tableHeaderGroup */.a5O;
var tableFooterGroup = Css_Legacy_Core_bs/* tableFooterGroup */.ANm;
var tableRowGroup = Css_Legacy_Core_bs/* tableRowGroup */.NY0;
var tableCell = Css_Legacy_Core_bs/* tableCell */.K5p;
var tableColumn = Css_Legacy_Core_bs/* tableColumn */.ibC;
var tableRow = Css_Legacy_Core_bs/* tableRow */.RLZ;
var flexStart = Css_Legacy_Core_bs/* flexStart */.c4c;
var flexEnd = Css_Legacy_Core_bs/* flexEnd */.QdD;
var center = Css_Legacy_Core_bs/* center */.beQ;
var stretch = Css_Legacy_Core_bs/* stretch */.dy0;
var spaceBetween = Css_Legacy_Core_bs/* spaceBetween */.fHD;
var spaceAround = Css_Legacy_Core_bs/* spaceAround */.hHJ;
var spaceEvenly = Css_Legacy_Core_bs/* spaceEvenly */.isX;
var baseline = Css_Legacy_Core_bs/* baseline */.j96;
var forwards = Css_Legacy_Core_bs/* forwards */.Gho;
var backwards = Css_Legacy_Core_bs/* backwards */.aWF;
var both = Css_Legacy_Core_bs/* both */.HkC;
var infinite = Css_Legacy_Core_bs/* infinite */.oXI;
var count = Css_Legacy_Core_bs/* count */.QXW;
var paused = Css_Legacy_Core_bs/* paused */.K9x;
var running = Css_Legacy_Core_bs/* running */.wCv;
var inside = Css_Legacy_Core_bs/* inside */.Odq;
var outside = Css_Legacy_Core_bs/* outside */.SX6;
var solid = Css_Legacy_Core_bs/* solid */.SQh;
var dotted = Css_Legacy_Core_bs/* dotted */.ftw;
var dashed = Css_Legacy_Core_bs/* dashed */.HA;
var underline = Css_Legacy_Core_bs/* underline */.eCr;
var overline = Css_Legacy_Core_bs/* overline */.I95;
var lineThrough = Css_Legacy_Core_bs/* lineThrough */.jLD;
var clip = Css_Legacy_Core_bs/* clip */.oqW;
var ellipsis = Css_Legacy_Core_bs/* ellipsis */.LHJ;
var wavy = Css_Legacy_Core_bs/* wavy */.Pp4;
var $$double = Css_Legacy_Core_bs/* $$double */.ceD;
var uppercase = Css_Legacy_Core_bs/* uppercase */.PqQ;
var lowercase = Css_Legacy_Core_bs/* lowercase */.wXG;
var capitalize = Css_Legacy_Core_bs/* capitalize */.kC2;
var sub = Css_Legacy_Core_bs/* sub */.luU;
var $$super = Css_Legacy_Core_bs/* $$super */.dkg;
var textTop = Css_Legacy_Core_bs/* textTop */.L8u;
var textBottom = Css_Legacy_Core_bs/* textBottom */.eRF;
var middle = Css_Legacy_Core_bs/* middle */.XNj;
var normal = Css_Legacy_Core_bs/* normal */.mJl;
var breakAll = Css_Legacy_Core_bs/* breakAll */.k$v;
var keepAll = Css_Legacy_Core_bs/* keepAll */.mvd;
var breakWord = Css_Legacy_Core_bs/* breakWord */.kZi;
var reverse = Css_Legacy_Core_bs/* reverse */.GYS;
var alternate = Css_Legacy_Core_bs/* alternate */.J6G;
var alternateReverse = Css_Legacy_Core_bs/* alternateReverse */.XOq;
var fill = Css_Legacy_Core_bs/* fill */.hlL;
var content = Css_Legacy_Core_bs/* content */.kQN;
var maxContent = Css_Legacy_Core_bs/* maxContent */.FHD;
var minContent = Css_Legacy_Core_bs/* minContent */.fxJ;
var fitContent = Css_Legacy_Core_bs/* fitContent */.E0j;
var BsCss_bs_all = Css_Legacy_Core_bs/* all */.$6P;
var round = Css_Legacy_Core_bs/* round */.NMM;
var miter = Css_Legacy_Core_bs/* miter */.mwL;
var bevel = Css_Legacy_Core_bs/* bevel */.aHA;
var butt = Css_Legacy_Core_bs/* butt */.giC;
var square = Css_Legacy_Core_bs/* square */.h62;
var panX = Css_Legacy_Core_bs/* panX */.i36;
var panY = Css_Legacy_Core_bs/* panY */.$hU;
var panLeft = Css_Legacy_Core_bs/* panLeft */.xZz;
var panRight = Css_Legacy_Core_bs/* panRight */.UY0;
var panUp = Css_Legacy_Core_bs/* panUp */.LAG;
var panDown = Css_Legacy_Core_bs/* panDown */.VF7;
var pinchZoom = Css_Legacy_Core_bs/* pinchZoom */.ybA;
var manipulation = Css_Legacy_Core_bs/* manipulation */.WP2;
var thin = Css_Legacy_Core_bs/* thin */.vPS;
var extraLight = Css_Legacy_Core_bs/* extraLight */.ncr;
var light = Css_Legacy_Core_bs/* light */.R29;
var medium = Css_Legacy_Core_bs/* medium */.IV2;
var semiBold = Css_Legacy_Core_bs/* semiBold */.aX$;
var bold = Css_Legacy_Core_bs/* bold */.SeW;
var extraBold = Css_Legacy_Core_bs/* extraBold */.TE9;
var lighter = Css_Legacy_Core_bs/* lighter */.f6n;
var bolder = Css_Legacy_Core_bs/* bolder */.fT5;
var fr = Css_Legacy_Core_bs.fr;
var vw = Css_Legacy_Core_bs.vw;
var localUrl = Css_Legacy_Core_bs/* localUrl */.hGO;
var url = Css_Legacy_Core_bs/* url */.HQ2;
var linear = Css_Legacy_Core_bs/* linear */.GEo;
var ease = Css_Legacy_Core_bs/* ease */.mvv;
var easeIn = Css_Legacy_Core_bs/* easeIn */.YQY;
var easeOut = Css_Legacy_Core_bs/* easeOut */.VvG;
var easeInOut = Css_Legacy_Core_bs/* easeInOut */.mZN;
var stepStart = Css_Legacy_Core_bs/* stepStart */.UrL;
var stepEnd = Css_Legacy_Core_bs/* stepEnd */.gB9;
var steps = Css_Legacy_Core_bs/* steps */.S6;
var cubicBezier = Css_Legacy_Core_bs/* cubicBezier */._s1;
var marginBox = Css_Legacy_Core_bs/* marginBox */.m8E;
var fillBox = Css_Legacy_Core_bs/* fillBox */.Bbi;
var strokeBox = Css_Legacy_Core_bs/* strokeBox */.BKm;
var viewBox = Css_Legacy_Core_bs/* viewBox */.exU;
var translate = Css_Legacy_Core_bs/* translate */.Iue;
var translate3d = Css_Legacy_Core_bs/* translate3d */.z2Y;
var translateX = Css_Legacy_Core_bs/* translateX */.YPe;
var translateY = Css_Legacy_Core_bs/* translateY */.iWO;
var translateZ = Css_Legacy_Core_bs/* translateZ */.hR4;
var scale = Css_Legacy_Core_bs/* scale */.bAd;
var scale3d = Css_Legacy_Core_bs/* scale3d */.C74;
var scaleX = Css_Legacy_Core_bs/* scaleX */.eZH;
var scaleY = Css_Legacy_Core_bs/* scaleY */.$zm;
var scaleZ = Css_Legacy_Core_bs/* scaleZ */.p3g;
var rotate = Css_Legacy_Core_bs/* rotate */.U1s;
var rotate3d = Css_Legacy_Core_bs/* rotate3d */.er3;
var rotateX = Css_Legacy_Core_bs/* rotateX */.lMS;
var rotateY = Css_Legacy_Core_bs/* rotateY */.uDD;
var rotateZ = Css_Legacy_Core_bs/* rotateZ */.jIM;
var skew = Css_Legacy_Core_bs/* skew */.Tm5;
var skewX = Css_Legacy_Core_bs/* skewX */.QkJ;
var skewY = Css_Legacy_Core_bs/* skewY */.FoG;
var linearGradient = Css_Legacy_Core_bs/* linearGradient */.bCQ;
var repeatingLinearGradient = Css_Legacy_Core_bs/* repeatingLinearGradient */.k_P;
var radialGradient = Css_Legacy_Core_bs/* radialGradient */.zso;
var repeatingRadialGradient = Css_Legacy_Core_bs/* repeatingRadialGradient */.Cak;
var conicGradient = Css_Legacy_Core_bs/* conicGradient */.LC$;
var areas = Css_Legacy_Core_bs/* areas */.aku;
var ident = Css_Legacy_Core_bs/* ident */.yRn;
var numIdent = Css_Legacy_Core_bs/* numIdent */.p$S;
var contextMenu = Css_Legacy_Core_bs/* contextMenu */.zCX;
var help = Css_Legacy_Core_bs/* help */.R_2;
var pointer = Css_Legacy_Core_bs/* pointer */.cx$;
var progress = Css_Legacy_Core_bs/* progress */.YD2;
var wait = Css_Legacy_Core_bs/* wait */.Dc1;
var cell = Css_Legacy_Core_bs/* cell */.o4w;
var crosshair = Css_Legacy_Core_bs/* crosshair */.uGs;
var verticalText = Css_Legacy_Core_bs/* verticalText */.eEk;
var alias = Css_Legacy_Core_bs/* alias */.bme;
var copy = Css_Legacy_Core_bs/* copy */.JGK;
var move = Css_Legacy_Core_bs/* move */.pBW;
var noDrop = Css_Legacy_Core_bs/* noDrop */.Kgc;
var notAllowed = Css_Legacy_Core_bs/* notAllowed */.jsT;
var grab = Css_Legacy_Core_bs/* grab */.x2h;
var grabbing = Css_Legacy_Core_bs/* grabbing */.$xc;
var allScroll = Css_Legacy_Core_bs/* allScroll */.fFX;
var colResize = Css_Legacy_Core_bs/* colResize */.QiF;
var rowResize = Css_Legacy_Core_bs/* rowResize */.oJs;
var nResize = Css_Legacy_Core_bs/* nResize */.na1;
var eResize = Css_Legacy_Core_bs/* eResize */.az5;
var sResize = Css_Legacy_Core_bs/* sResize */.voX;
var wResize = Css_Legacy_Core_bs/* wResize */.CvW;
var neResize = Css_Legacy_Core_bs/* neResize */.f7d;
var nwResize = Css_Legacy_Core_bs/* nwResize */.zZK;
var seResize = Css_Legacy_Core_bs/* seResize */._Ef;
var swResize = Css_Legacy_Core_bs/* swResize */.FoQ;
var ewResize = Css_Legacy_Core_bs/* ewResize */.eUF;
var nsResize = Css_Legacy_Core_bs/* nsResize */.Wct;
var neswResize = Css_Legacy_Core_bs/* neswResize */.IQh;
var nwseResize = Css_Legacy_Core_bs/* nwseResize */.xW;
var zoomIn = Css_Legacy_Core_bs/* zoomIn */.krI;
var zoomOut = Css_Legacy_Core_bs/* zoomOut */.vGG;
var flex3 = Css_Legacy_Core_bs/* flex3 */.L9u;
var border = Css_Legacy_Core_bs/* border */.CgR;
var borderTop = Css_Legacy_Core_bs/* borderTop */.j1L;
var backgroundSize = Css_Legacy_Core_bs/* backgroundSize */.G4q;
var textDecoration = Css_Legacy_Core_bs/* textDecoration */.QXS;
var background = Css_Legacy_Core_bs/* background */.Oq0;
var backgrounds = Css_Legacy_Core_bs/* backgrounds */.Fud;
var gridAutoColumns = Css_Legacy_Core_bs/* gridAutoColumns */.aNt;
var gridAutoRows = Css_Legacy_Core_bs/* gridAutoRows */.FWK;
var gridTemplateColumns = Css_Legacy_Core_bs/* gridTemplateColumns */.K$K;
var gridTemplateRows = Css_Legacy_Core_bs/* gridTemplateRows */.RGf;
var Calc = Css_Legacy_Core_bs/* Calc */.zyf;
var size = Css_Legacy_Core_bs/* size */.dpJ;
var filter = Css_Legacy_Core_bs/* filter */.hXT;
var Transition = Css_Legacy_Core_bs/* Transition */.uTP;
var transitionValue = Css_Legacy_Core_bs/* transitionValue */.O3F;
var transitionList = Css_Legacy_Core_bs/* transitionList */.RgW;
var transition = Css_Legacy_Core_bs/* transition */.eRy;
var transitions = Css_Legacy_Core_bs/* transitions */.pBE;
var Animation = Css_Legacy_Core_bs/* Animation */.fwF;
var animationValue = Css_Legacy_Core_bs/* animationValue */.FLd;
var animation = Css_Legacy_Core_bs/* animation */.oQ4;
var animations = Css_Legacy_Core_bs/* animations */.sFT;
var animationName = Css_Legacy_Core_bs/* animationName */.w30;
var SVG = Css_Legacy_Core_bs/* SVG */.Wj1;
var touchAction = Css_Legacy_Core_bs/* touchAction */.JQf;
var aliceblue = Css_Colors_bs/* aliceblue */.$T;
var antiquewhite = Css_Colors_bs/* antiquewhite */.gu;
var aqua = Css_Colors_bs/* aqua */.tb;
var aquamarine = Css_Colors_bs/* aquamarine */.Cn;
var azure = Css_Colors_bs/* azure */.Yd;
var beige = Css_Colors_bs/* beige */.e9;
var bisque = Css_Colors_bs/* bisque */.kh;
var black = Css_Colors_bs/* black */.Sn;
var blanchedalmond = Css_Colors_bs/* blanchedalmond */.Kx;
var blue = Css_Colors_bs/* blue */.iN;
var blueviolet = Css_Colors_bs/* blueviolet */.me;
var brown = Css_Colors_bs/* brown */.P_;
var burlywood = Css_Colors_bs/* burlywood */.I6;
var cadetblue = Css_Colors_bs/* cadetblue */.nN;
var chartreuse = Css_Colors_bs/* chartreuse */.mH;
var chocolate = Css_Colors_bs/* chocolate */.JU;
var coral = Css_Colors_bs/* coral */.ou;
var cornflowerblue = Css_Colors_bs/* cornflowerblue */.yi;
var cornsilk = Css_Colors_bs/* cornsilk */.$s;
var crimson = Css_Colors_bs/* crimson */.Wl;
var cyan = Css_Colors_bs/* cyan */.sl;
var darkblue = Css_Colors_bs/* darkblue */.dR;
var darkcyan = Css_Colors_bs/* darkcyan */.eb;
var darkgoldenrod = Css_Colors_bs/* darkgoldenrod */.zO;
var darkgray = Css_Colors_bs/* darkgray */.eo;
var darkgreen = Css_Colors_bs/* darkgreen */.L9;
var darkgrey = Css_Colors_bs/* darkgrey */.PA;
var darkkhaki = Css_Colors_bs/* darkkhaki */.yu;
var darkmagenta = Css_Colors_bs/* darkmagenta */.dS;
var darkolivegreen = Css_Colors_bs/* darkolivegreen */.ez;
var darkorange = Css_Colors_bs/* darkorange */.Rd;
var darkorchid = Css_Colors_bs/* darkorchid */.nh;
var darkred = Css_Colors_bs/* darkred */.Ec;
var darksalmon = Css_Colors_bs/* darksalmon */.xC;
var darkseagreen = Css_Colors_bs/* darkseagreen */.G4;
var darkslateblue = Css_Colors_bs/* darkslateblue */.GO;
var darkslategray = Css_Colors_bs/* darkslategray */.cz;
var darkslategrey = Css_Colors_bs/* darkslategrey */.KD;
var darkturquoise = Css_Colors_bs/* darkturquoise */.Tj;
var darkviolet = Css_Colors_bs/* darkviolet */.UP;
var deeppink = Css_Colors_bs/* deeppink */.FG;
var deepskyblue = Css_Colors_bs/* deepskyblue */.fK;
var dimgray = Css_Colors_bs/* dimgray */.OQ;
var dimgrey = Css_Colors_bs/* dimgrey */.yS;
var dodgerblue = Css_Colors_bs/* dodgerblue */.H9;
var firebrick = Css_Colors_bs/* firebrick */.IU;
var floralwhite = Css_Colors_bs/* floralwhite */.s9;
var forestgreen = Css_Colors_bs/* forestgreen */.ob;
var fuchsia = Css_Colors_bs/* fuchsia */.zf;
var gainsboro = Css_Colors_bs/* gainsboro */.c7;
var ghostwhite = Css_Colors_bs/* ghostwhite */.my;
var gold = Css_Colors_bs/* gold */.EV;
var goldenrod = Css_Colors_bs/* goldenrod */.Al;
var gray = Css_Colors_bs/* gray */.MA;
var green = Css_Colors_bs/* green */.ek;
var greenyellow = Css_Colors_bs/* greenyellow */.ff;
var grey = Css_Colors_bs/* grey */.BA;
var honeydew = Css_Colors_bs/* honeydew */.Ax;
var hotpink = Css_Colors_bs/* hotpink */.ng;
var indianred = Css_Colors_bs/* indianred */.IP;
var indigo = Css_Colors_bs/* indigo */.QN;
var ivory = Css_Colors_bs/* ivory */.h$;
var khaki = Css_Colors_bs/* khaki */.IK;
var lavender = Css_Colors_bs/* lavender */.N0;
var lavenderblush = Css_Colors_bs/* lavenderblush */.jR;
var lawngreen = Css_Colors_bs/* lawngreen */.ev;
var lemonchiffon = Css_Colors_bs/* lemonchiffon */.Kf;
var lightblue = Css_Colors_bs/* lightblue */.XW;
var lightcoral = Css_Colors_bs/* lightcoral */.qv;
var lightcyan = Css_Colors_bs/* lightcyan */.tO;
var lightgoldenrodyellow = Css_Colors_bs/* lightgoldenrodyellow */.dw;
var lightgray = Css_Colors_bs/* lightgray */.UQ;
var lightgreen = Css_Colors_bs/* lightgreen */.Hj;
var lightgrey = Css_Colors_bs/* lightgrey */.hC;
var lightpink = Css_Colors_bs/* lightpink */.ci;
var lightsalmon = Css_Colors_bs/* lightsalmon */.lY;
var lightseagreen = Css_Colors_bs/* lightseagreen */.mf;
var lightskyblue = Css_Colors_bs/* lightskyblue */.up;
var lightslategray = Css_Colors_bs/* lightslategray */.GV;
var lightslategrey = Css_Colors_bs/* lightslategrey */.As;
var lightsteelblue = Css_Colors_bs/* lightsteelblue */.z1;
var lightyellow = Css_Colors_bs/* lightyellow */.s$;
var lime = Css_Colors_bs/* lime */.LR;
var limegreen = Css_Colors_bs/* limegreen */.bV;
var linen = Css_Colors_bs/* linen */.nu;
var magenta = Css_Colors_bs/* magenta */.Ce;
var maroon = Css_Colors_bs/* maroon */.dm;
var mediumaquamarine = Css_Colors_bs/* mediumaquamarine */.vN;
var mediumblue = Css_Colors_bs/* mediumblue */.Bg;
var mediumorchid = Css_Colors_bs/* mediumorchid */.AV;
var mediumpurple = Css_Colors_bs/* mediumpurple */.og;
var mediumseagreen = Css_Colors_bs/* mediumseagreen */.YL;
var mediumslateblue = Css_Colors_bs/* mediumslateblue */.sf;
var mediumspringgreen = Css_Colors_bs/* mediumspringgreen */.Vl;
var mediumturquoise = Css_Colors_bs/* mediumturquoise */.Su;
var mediumvioletred = Css_Colors_bs/* mediumvioletred */.zR;
var midnightblue = Css_Colors_bs/* midnightblue */.rD;
var mintcream = Css_Colors_bs/* mintcream */.Rh;
var mistyrose = Css_Colors_bs/* mistyrose */.RT;
var moccasin = Css_Colors_bs/* moccasin */.Xw;
var navajowhite = Css_Colors_bs/* navajowhite */.Ii;
var navy = Css_Colors_bs/* navy */.Ih;
var oldlace = Css_Colors_bs/* oldlace */.WV;
var olive = Css_Colors_bs/* olive */.qZ;
var olivedrab = Css_Colors_bs/* olivedrab */.EQ;
var orange = Css_Colors_bs/* orange */.$y;
var orangered = Css_Colors_bs/* orangered */.ve;
var orchid = Css_Colors_bs/* orchid */.XV;
var palegoldenrod = Css_Colors_bs/* palegoldenrod */.mL;
var palegreen = Css_Colors_bs/* palegreen */.Jm;
var paleturquoise = Css_Colors_bs/* paleturquoise */.UM;
var palevioletred = Css_Colors_bs/* palevioletred */.ZP;
var papayawhip = Css_Colors_bs/* papayawhip */.tt;
var peachpuff = Css_Colors_bs/* peachpuff */.Kz;
var peru = Css_Colors_bs/* peru */.zh;
var pink = Css_Colors_bs/* pink */.iQ;
var plum = Css_Colors_bs/* plum */.vd;
var powderblue = Css_Colors_bs/* powderblue */.Fe;
var purple = Css_Colors_bs/* purple */.jk;
var rebeccapurple = Css_Colors_bs/* rebeccapurple */.My;
var red = Css_Colors_bs/* red */.Q6;
var rosybrown = Css_Colors_bs/* rosybrown */.wO;
var royalblue = Css_Colors_bs/* royalblue */.WI;
var saddlebrown = Css_Colors_bs/* saddlebrown */.sN;
var salmon = Css_Colors_bs/* salmon */.kr;
var sandybrown = Css_Colors_bs/* sandybrown */.qb;
var seagreen = Css_Colors_bs/* seagreen */.hR;
var seashell = Css_Colors_bs/* seashell */.qP;
var sienna = Css_Colors_bs/* sienna */.UR;
var silver = Css_Colors_bs/* silver */.l_;
var skyblue = Css_Colors_bs/* skyblue */.OD;
var slateblue = Css_Colors_bs/* slateblue */.Xb;
var slategray = Css_Colors_bs/* slategray */.aL;
var slategrey = Css_Colors_bs/* slategrey */.P2;
var snow = Css_Colors_bs/* snow */.Xr;
var springgreen = Css_Colors_bs/* springgreen */.oe;
var steelblue = Css_Colors_bs/* steelblue */.YP;
var tan = Css_Colors_bs/* tan */.OR;
var teal = Css_Colors_bs/* teal */.$C;
var thistle = Css_Colors_bs/* thistle */.X0;
var tomato = Css_Colors_bs/* tomato */.$p;
var turquoise = Css_Colors_bs/* turquoise */.Mk;
var violet = Css_Colors_bs/* violet */.ht;
var wheat = Css_Colors_bs/* wheat */.tm;
var white = Css_Colors_bs/* white */.ix;
var whitesmoke = Css_Colors_bs/* whitesmoke */.OW;
var yellow = Css_Colors_bs/* yellow */.er;
var yellowgreen = Css_Colors_bs/* yellowgreen */.TY;
var transparent = Css_Colors_bs/* transparent */.Zn;
var renderRule = include.renderRule;
var $$global = include.$$global;
var renderGlobal = include.renderGlobal;
var style = include.style;
var BsCss_bs_merge = include.merge;
var merge2 = include.merge2;
var merge3 = include.merge3;
var merge4 = include.merge4;
var BsCss_bs_keyframes = include.keyframes;
var renderKeyframes$1 = include.renderKeyframes;
 /* include Not a pure module */ 


/***/ }),

/***/ 7280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Logger; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
function requestInfo(arg1, arg2, obj) {
    obj.info(arg1, arg2);
}
function responseInfo(arg1, arg2, obj) {
    obj.info(arg1, arg2);
}
var Logger = {
    requestInfo: requestInfo,
    responseInfo: responseInfo
};
 /* No side effect */ 


/***/ }),

/***/ 7545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QD": function() { return /* binding */ mediaStyles; },
/* harmony export */   "pU": function() { return /* binding */ Media$1; }
/* harmony export */ });
/* unused harmony export MediaContextProvider */
/* harmony import */ var _Media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86265);
// Generated by ReScript, PLEASE EDIT WITH CARE

var mediaStyles = _Media__WEBPACK_IMPORTED_MODULE_0__/* .mediaStyles */ .QD;
var make = _Media__WEBPACK_IMPORTED_MODULE_0__/* .Media */ .pU;
var Media$1 = {
    make: make
};
var make$1 = _Media__WEBPACK_IMPORTED_MODULE_0__/* .MediaContextProvider */ .C1;
var MediaContextProvider = {
    make: make$1
};
 /* mediaStyles Not a pure module */ 


/***/ }),

/***/ 86265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ MediaContextProvider; },
/* harmony export */   "QD": function() { return /* binding */ mediaStyles; },
/* harmony export */   "pU": function() { return /* binding */ Media; }
/* harmony export */ });
/* harmony import */ var _artsy_fresnel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2082);

var AppMedia = (0,_artsy_fresnel__WEBPACK_IMPORTED_MODULE_0__/* .createMedia */ .Wm)({
    breakpoints: {
        sm: 0,
        mobile: 600,
        md: 768,
        lg: 1024,
        xl: 1380,
        tablet: 1288,
        // Ribbon
        rbMobile: 0,
        rbTablet: 425,
        rbSmallScreen: 768,
        rbDesktop: 1024,
        rbLargeDesktop: 1288
    }
});
// Make styles for injection into the header of the page
var mediaStyles = AppMedia.createMediaStyle();
var Media = AppMedia.Media, MediaContextProvider = AppMedia.MediaContextProvider;


/***/ }),

/***/ 91574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _utils_logger_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31611);
// Generated by ReScript, PLEASE EDIT WITH CARE

var logger = _utils_logger_ts__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP;
 /* logger Not a pure module */ 


/***/ }),

/***/ 77103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports validationTypeToJs, validationTypeFromJs, validationErrorExtToJs, validationErrorExtFromJs */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42283);
// Generated by ReScript, PLEASE EDIT WITH CARE




var _map = {
    "required": "required",
    "min": "min",
    "max": "max",
    "noop": "noop",
    "maxLength": "maxLength",
    "pattern": "pattern"
};
var _revMap = {
    "required": "required",
    "min": "min",
    "max": "max",
    "noop": "noop",
    "maxLength": "maxLength",
    "pattern": "pattern"
};
function validationTypeToJs(param) {
    return _map[param];
}
function validationTypeFromJs(param) {
    return _revMap[param];
}
function validationErrorExtToJs(param) {
    return {
        type_: param.type,
        message: param.message
    };
}
function validationErrorExtFromJs(param) {
    return {
        type: param.type_,
        message: param.message
    };
}
function useForm(options, param) {
    var formExt = react_hook_form__WEBPACK_IMPORTED_MODULE_0__/* .useForm */ .cI(options);
    var register = function register(input) {
        return function(ref) {
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__._2(formExt.register, ref, input);
        };
    };
    var errors = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .fromArray */ .nI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .entries */ .qh(formExt.errors), function(param) {
        var err = param[1];
        var match = err.type;
        var validationType;
        switch(match){
            case "max":
                validationType = "max";
                break;
            case "maxLength":
                validationType = "maxLength";
                break;
            case "min":
                validationType = "min";
                break;
            case "required":
                validationType = "required";
                break;
            default:
                validationType = "noop";
        }
        return [
            param[0],
            {
                validationType: validationType,
                message: err.message
            }
        ];
    }));
    return {
        register: register,
        reset: formExt.reset,
        setValue: formExt.setValue,
        handleSubmit: formExt.handleSubmit,
        errors: errors,
        setError: formExt.setError,
        getValues: formExt.getValues,
        formState: formExt.formState,
        trigger: formExt.trigger,
        watch: formExt.watch,
        control: formExt.control
    };
}
 /* react-hook-form Not a pure module */ 


/***/ }),

/***/ 73840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YM": function() { return /* binding */ Registration; },
  "Fb": function() { return /* binding */ businessLeadSubmitted; },
  "wY": function() { return /* binding */ businessStore; },
  "Op": function() { return /* binding */ cardToProduct; },
  "bC": function() { return /* binding */ cardToProductWithIndex; },
  "Zk": function() { return /* binding */ consumerStore; },
  "pA": function() { return /* binding */ customElementInteraction; },
  "GS": function() { return /* binding */ customElementInteractionAsync; },
  "L$": function() { return /* binding */ giftUnwrapped; },
  "Tr": function() { return /* binding */ giftUnwrappedCardViewed; },
  "Fe": function() { return /* binding */ hashPage; },
  "Dx": function() { return /* binding */ identifyWithContext; },
  "ej": function() { return /* binding */ orderCardToProduct; },
  "rC": function() { return /* binding */ productClicked; },
  "ZX": function() { return /* binding */ productListViewed; },
  "l$": function() { return /* binding */ productsSearched; },
  "jv": function() { return /* binding */ reminderSaved; },
  "mc": function() { return /* binding */ Segment_bs_reset; },
  "Cz": function() { return /* binding */ signedOut; },
  "Tz": function() { return /* binding */ signedUp; },
  "AW": function() { return /* binding */ userType; }
});

// UNUSED EXPORTS: Login, brazeAlias, cardToProductNoImageUrl, checkoutStarted, checkoutStepCompleted, checkoutStepViewed, contextE, couponApplied, couponDenied, couponEntered, couponRemoved, customLinkTracking, debug, giftCardViewed, group, hash, hashContext, identify, linuxOrWindows, newsletterSubscribed, niE, orderCompleted, page, productAdded, productRemoved, productViewed, reminderCreated, scriptNotLoaded, setAnonymousId, setContext, signedIn, track, trackAsync, trackWithContext, trackWithContextAsync, versionControl, withGaClientId, writeKey

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
;// CONCATENATED MODULE: ./src/config/GiftConf.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
var giftPaths = [
    "/gift/open/",
    "/gift/open-ndl/",
    "/gift/say-thanks/",
    "/gift/",
    "/exchange/card/",
    "/history/"
];
 /* No side effect */ 

// EXTERNAL MODULE: ./src/bindings/segment.js
var segment = __webpack_require__(91435);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_string.js
var js_string = __webpack_require__(37712);
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/utils/Regex.tsx
var Regex = __webpack_require__(38612);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./src/bindings/Segment.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE












var writeKey = (/* unused pure expression or super */ null && ("NEp8liwMTEA28ZnjAahJHJg8nepBPmz8"));
function scriptNotLoaded(prim) {
    return Segment.scriptNotLoaded();
}
function debug(prim) {
    Segment.debug(prim);
}
function identify(prim0, prim1, prim2) {
    segment/* identify */.yV(prim0, prim1, prim2);
}
function track(prim0, prim1, prim2) {
    segment/* track */.j(prim0, prim1, prim2);
}
function trackAsync(prim0, prim1, prim2) {
    return Segment.trackAsync(prim0, prim1, prim2);
}
function page(prim0, prim1, prim2, prim3) {
    segment/* page */.Md(prim0 !== undefined ? caml_option/* valFromOption */.xt(prim0) : undefined, prim1 !== undefined ? caml_option/* valFromOption */.xt(prim1) : undefined, prim2, prim3);
}
function group(prim0, prim1) {
    Segment.group(prim0, prim1);
}
function Segment_bs_reset(prim) {
    segment/* reset */.mc();
}
function setAnonymousId(prim) {
    Segment.setAnonymousId(prim);
}
function hash(prim) {
    return Segment.hash(prim);
}
function brazeAlias(prim) {
    Segment.brazeAlias();
}
var linuxOrWindows = Regex/* linuxOrWindows */._W;
var contextE = {
    server_region: "NZ"
};
var consumerStore = {
    store: "consumer"
};
var businessStore = {
    store: "business"
};
var userType = {
    user_type: "consumer"
};
var niE = {
    nonInteraction: 1,
    store: "consumer"
};
function withGaClientId(props) {
    return Object.assign(props, {
        ga_clientid: js_string/* sliceToEnd */.lu(6, belt_Option/* getWithDefault */.tj(caml_option/* nullable_to_opt */.Tl(js_cookie.get("_ga")), ""))
    });
}
function setContext(storeTypeOpt, c) {
    var storeType = storeTypeOpt !== undefined ? caml_option/* valFromOption */.xt(storeTypeOpt) : consumerStore;
    var user = AuthUtils_bs/* getFullUserInfo */.gB(undefined);
    var deviceInfo = lib/* parseUserAgent */.rQ(navigator.userAgent);
    var deviceName = deviceInfo.os.name;
    var deviceType = belt_Option/* getWithDefault */.tj(deviceInfo.device.type, "desktop");
    var userTraits = {
        traits: {
            email: belt_Option/* map */.UI(user, function(u) {
                return u.email;
            }),
            phone: belt_Option/* map */.UI(user, function(u) {
                return u.phoneNumber;
            })
        }
    };
    var deviceInfo$1 = {
        device: {
            name: deviceType.concat(" ", deviceName),
            type: deviceType
        }
    };
    var contextStoreRegion = Object.assign(Object.assign({}, contextE), storeType);
    return Object.assign(Object.assign(Object.assign(userTraits, deviceInfo$1), contextStoreRegion), c);
}
function identifyWithContext(userId, props, isPb) {
    var enriched = Object.assign(props, contextE);
    var storeType = isPb ? businessStore : consumerStore;
    var context = setContext(caml_option/* some */.G(storeType), {});
    identify(userId, enriched, context);
}
function trackWithContext($$event, props, ctx) {
    var isPb = document.location.pathname.startsWith(util_bs/* Business.pathname */.e.pathname);
    var currentStoreType = isPb ? businessStore : consumerStore;
    var enriched = Object.assign(Object.assign(props, contextE), currentStoreType);
    var context = setContext(caml_option/* some */.G(currentStoreType), ctx);
    track($$event, enriched, context);
}
function trackWithContextAsync($$event, props, ctx) {
    var isPb = document.location.pathname.startsWith(util_bs/* Business.pathname */.e.pathname);
    var currentStoreType = isPb ? businessStore : consumerStore;
    var enriched = Object.assign(Object.assign(props, contextE), currentStoreType);
    var context = setContext(caml_option/* some */.G(currentStoreType), Object.assign({}, ctx));
    return segment/* trackAsync */.O8($$event, enriched, context);
}
function cardToProduct(card) {
    return {
        product_id: card.uid,
        sku: card.slug,
        categories: belt_Array/* map */.UI(card.categories, function(g) {
            return g.name;
        }),
        category: belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(card.categories, 0), "", function(c) {
            return c.name;
        }),
        name: card.displayName,
        quantity: 1,
        image_url: card.imgUrl
    };
}
function orderCardToProduct(card, pathname) {
    return {
        categories: card.categories,
        category: card.category,
        name: card.skuDisplayName,
        product_id: card.skuUid,
        sku: card.skuSlug,
        url: pathname
    };
}
function cardToProductWithIndex(index, card) {
    return Object.assign(cardToProduct(card), {
        position: index + 1 | 0
    });
}
function cardToProductNoImageUrl(card) {
    return {
        product_id: card.uid,
        sku: card.slug,
        categories: Belt_Array.map(card.categories, function(g) {
            return g.name;
        }),
        category: Belt_Option.mapWithDefault(Belt_Array.get(card.categories, 0), "", function(c) {
            return c.name;
        }),
        name: card.displayName,
        quantity: 1
    };
}
function versionControl(version) {
    return {
        context: {
            protocols: {
                event_version: version
            }
        }
    };
}
function productListViewed(props) {
    var niEnriched = Object.assign(props, niE);
    var versioned = versionControl(2);
    trackWithContext("Product List Viewed", niEnriched, versioned);
}
function productViewed(props) {
    var niEnriched = withGaClientId(Object.assign(props, niE));
    var versioned = versionControl(2);
    trackWithContext("Product Viewed", niEnriched, versioned);
}
function productClicked(props) {
    var versioned = versionControl(2);
    trackWithContext("Product Clicked", withGaClientId(props), versioned);
}
function productsSearched(props) {
    trackWithContext("Products Searched", withGaClientId(props), {});
}
function couponEntered(props) {
    var enriched = Object.assign(props, userType);
    trackWithContext("Coupon Entered", enriched, {});
}
function couponApplied(props) {
    var enriched = Object.assign(props, userType);
    trackWithContext("Coupon Applied", enriched, {});
}
function couponDenied(props) {
    var enriched = Object.assign(props, userType);
    trackWithContext("Coupon Denied", enriched, {});
}
function couponRemoved(props) {
    var enriched = Object.assign(props, userType);
    trackWithContext("Coupon Removed", enriched, {});
}
function signedUp(props) {
    trackWithContext("Signed Up", withGaClientId(props), {});
}
function signedIn(props) {
    trackWithContext("Signed In", withGaClientId(props), {});
}
function signedOut(props) {
    trackWithContext("Signed Out", props, {});
}
function orderCompleted(props, ctx) {
    var versioned = Object.assign(versionControl(2), ctx);
    trackWithContext("Order Completed", withGaClientId(props), versioned);
}
function productAdded(props) {
    var versioned = versionControl(2);
    trackWithContext("Product Added", withGaClientId(props), versioned);
}
function productRemoved(props) {
    var versioned = versionControl(2);
    trackWithContext("Product Removed", props, versioned);
}
function checkoutStarted(props) {
    var versioned = versionControl(2);
    trackWithContext("Checkout Started", props, versioned);
}
function checkoutStepViewed(props) {
    trackWithContext("Checkout Step Viewed", props, {});
}
function checkoutStepCompleted(props) {
    var versioned = versionControl(2);
    trackWithContext("Checkout Step Completed", props, versioned);
}
function customLinkTracking(props) {
    trackWithContext("Custom Link Tracking", props, {});
}
function giftCardViewed(id, ctx) {
    trackWithContext("Gift Card Viewed", {
        gift_id: id
    }, ctx);
}
function newsletterSubscribed(email) {
    trackWithContext("Newsletter Subscribed", {
        email: email
    }, {
        traits: {
            email: email
        }
    });
}
function hashPage(acceptCookieOpt, isPb) {
    var uidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
    var storeType = isPb ? businessStore : consumerStore;
    var ctx = setContext(caml_option/* some */.G(storeType), {});
    var match = giftPaths.find(function(el) {
        return document.location.pathname.startsWith(el);
    });
    if (match === undefined) {
        return page(undefined, undefined, ctx, ctx);
    }
    var uidStartAt = js_string/* search */.yC(uidRegex, document.location.pathname);
    var hashedUid = String(crypto_js.SHA256(document.location.pathname.substring(uidStartAt, document.location.pathname.indexOf("/", uidStartAt))));
    var hashedPath = document.location.pathname.replace(uidRegex, hashedUid);
    var hashedPage = {
        path: hashedPath,
        url: document.location.origin.concat(hashedPath)
    };
    page(undefined, undefined, Object.assign({
        path: hashedPath,
        url: document.location.origin.concat(hashedPath),
        page: hashedPage
    }, ctx), Object.assign({
        page: hashedPage
    }, ctx));
}
function hashContext(param) {
    var uidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
    var uidStartAt = js_string/* search */.yC(uidRegex, document.location.pathname);
    if (uidStartAt === -1) {
        return {};
    }
    var hashedPath = document.location.pathname.replace(uidRegex, String(crypto_js.SHA256(document.location.pathname.substring(uidStartAt, document.location.pathname.indexOf("/", uidStartAt)))));
    return {
        page: {
            path: hashedPath,
            url: document.location.origin.concat(hashedPath)
        }
    };
}
function giftUnwrapped(props) {
    trackWithContext("Gift Unwrapped", props, hashContext(undefined));
}
function giftUnwrappedCardViewed(props) {
    trackWithContext("Gift Card Viewed", props, hashContext(undefined));
}
function businessLeadSubmitted(props) {
    trackWithContext("Lead Submitted", withGaClientId(props), {});
}
function customElementInteraction(props) {
    trackWithContext("Custom Element Interaction", withGaClientId(Object.assign({}, props)), {});
}
function customElementInteractionAsync(props) {
    return trackWithContextAsync("Custom Element Interaction", withGaClientId(Object.assign({}, props)), {});
}
function getFailedAttemptData(path) {
    return {
        element: "login_fail",
        path: path
    };
}
function sendfailedAttempt(path) {
    customElementInteraction(getFailedAttemptData(path));
}
var Login = {
    getFailedAttemptData: getFailedAttemptData,
    sendfailedAttempt: sendfailedAttempt
};
function makeBaseData(element, signupInstanceId, path, signupType) {
    return {
        element: element,
        signup_instance_id: signupInstanceId,
        path: path,
        signup_type: signupType
    };
}
function getSignupTypeAsString(signupTypeValue) {
    switch(signupTypeValue){
        case /* GiftOpen */ 0:
            return "gift_open";
        case /* DuringPurchase */ 1:
            return "during_purchase";
        case /* PostPurchaseForFriend */ 2:
            return "post_purchase_friend";
        case /* PostPurchaseForSelf */ 3:
            return "post_purchase_self";
        case /* SignupPage */ 4:
            return "signup_page";
    }
}
var Registration = {
    makeBaseData: makeBaseData,
    getSignupTypeAsString: getSignupTypeAsString
};
function reminderSaved(props) {
    trackWithContext("Reminder Saved", props, {});
}
function reminderCreated(props) {
    trackWithContext("Reminder Created", props, {});
}
 /* writeKey Not a pure module */ 


/***/ }),

/***/ 91435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Md": function() { return /* binding */ page; },
/* harmony export */   "O8": function() { return /* binding */ trackAsync; },
/* harmony export */   "j": function() { return /* binding */ track; },
/* harmony export */   "mc": function() { return /* binding */ reset; },
/* harmony export */   "pV": function() { return /* binding */ brazeAlias; },
/* harmony export */   "yV": function() { return /* binding */ identify; }
/* harmony export */ });
/* unused harmony exports scriptNotLoaded, debug, group, setAnonymousId, hash */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31611);



var scriptNotLoaded = function() {
    return typeof window.analytics === "undefined" || !window.analytics.invoked;
};
var brazeAlias = function() {
    try {
        if (window.analytics) {
            analytics.ready(function() {
                var ajs_aid = analytics.user().anonymousId();
                if (window.appboy) window.appboy.getUser().addAlias(ajs_aid, "anonymous_id");
            });
        }
    } catch (e) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
            message: "info: could not add Braze alias",
            error: e
        });
    }
};
var debug = function() {
    var enable = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    try {
        analytics.debug(enable);
    } catch (e) {
        logger.info({
            message: "info: could not execute Segment Analytics debug",
            error: e
        });
    }
};
var identify = function(userId, traits, context) {
    try {
        if (userId) {
            traits["id"] = userId;
            analytics.identify(userId, traits, context);
        } else {
            analytics.identify(traits, context);
        }
    } catch (e) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
            message: "info: could not execute Segment Analytics identify",
            error: e
        });
    }
};
var track = function(eventName, eventProperties, eventContext) {
    try {
        analytics.track(eventName, eventProperties, eventContext);
    } catch (e) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
            message: "info: could not execute Segment Analytics track",
            type: "sync",
            error: e
        });
    }
};
var trackAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(eventName, eventProperties, eventContext) {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        analytics.track(eventName, eventProperties, eventContext)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
                        message: "info: could not execute Segment Analytics track",
                        type: "async",
                        error: e
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function trackAsync(eventName, eventProperties, eventContext) {
        return _ref.apply(this, arguments);
    };
}();
var page = function(pageCategory, pageName, pageProperties, pageContext) {
    try {
        analytics.page(pageCategory, pageName, pageProperties, pageContext);
    } catch (e) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
            message: "info: could not execute Segment Analytics page tracking",
            error: e
        });
    }
};
var group = function(groupId, traits) {
    try {
        analytics.group(groupId, traits);
    } catch (e) {
        logger.info({
            message: "info: could not execute Segment Analytics group tracking",
            error: e
        });
    }
};
var reset = function() {
    try {
        analytics.reset();
    } catch (e) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].info */ .ZP.info({
            message: "info: could not execute Segment Analytics group reset",
            error: e
        });
    }
};
var setAnonymousId = function(id) {
    try {
        analytics.setAnonymousId(id);
    } catch (e) {
        logger.info({
            message: "info: could not execute Segment Analytics set anonymous ID",
            error: e
        });
    }
};
function hash(message) {
    return new Promise(function(resolve, reject) {
        function getHash() {
            return _getHash.apply(this, arguments);
        }
        function _getHash() {
            _getHash = _async_to_generator(function() {
                var msgUint8, hashBuffer, hashArray, hashHex, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            if (!crypto.subtle) return [
                                3,
                                2
                            ];
                            msgUint8 = new TextEncoder().encode(message);
                            return [
                                4,
                                crypto.subtle.digest("SHA-256", msgUint8)
                            ];
                        case 1:
                            hashBuffer = _state.sent();
                            hashArray = Array.from(new Uint8Array(hashBuffer));
                            hashHex = hashArray.map(function(b) {
                                return b.toString(16).padStart(2, "0");
                            }).join("");
                            return [
                                2,
                                hashHex
                            ];
                        case 2:
                            return [
                                2,
                                ""
                            ];
                        case 3:
                            e = _state.sent();
                            reject(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _getHash.apply(this, arguments);
        }
        if (window.requestIdleCallback) {
            requestIdleCallback(/*#__PURE__*/ _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getHash()
                            ];
                        case 1:
                            return [
                                2,
                                resolve.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            }));
        } else {
            setTimeout(/*#__PURE__*/ _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getHash()
                            ];
                        case 1:
                            return [
                                2,
                                resolve.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            }), 500);
        }
    });
}



/***/ }),

/***/ 24429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$f": function() { return /* binding */ makeRequest; },
/* harmony export */   "ZB": function() { return /* binding */ checkResponse1; },
/* harmony export */   "bf": function() { return /* binding */ makeUrl; },
/* harmony export */   "kg": function() { return /* binding */ logger; },
/* harmony export */   "mm": function() { return /* binding */ checkResponse; }
/* harmony export */ });
/* unused harmony export isClient */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92592);
/* harmony import */ var bs_fetch_src_Fetch_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90917);
/* harmony import */ var _bindings_Datadog_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7280);
/* harmony import */ var _api_ApiErrors_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44054);
/* harmony import */ var _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45603);
/* harmony import */ var _api_Data_ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77058);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25400);
/* harmony import */ var _datadog_browser_logs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27571);
// Generated by ReScript, PLEASE EDIT WITH CARE










function makeUrl(route) {
    return "https://www.prezzee.co.nz/" + route;
}
var isClient = function() {
    try {
        return window !== undefined;
    } catch (e) {
        return false;
    }
}();
var logger = _datadog_browser_logs__WEBPACK_IMPORTED_MODULE_5__/* .datadogLogs.logger */ .fy.logger;
function checkResponse(response, decoder) {
    var n = response.status;
    var exit = 0;
    if (n >= 401) {
        if (n === 461 || n === 460) {
            if (n >= 461) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: /* ServerFraudError */ 1
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: /* ServerMFARequiredError */ 0
                    }
                });
            }
        }
        if (n >= 402) {
            exit = 1;
        } else {
            js_cookie__WEBPACK_IMPORTED_MODULE_4__.remove(_auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .cookieName */ .YN, {
                domain: _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getCookieDomain */ .yT(undefined)
            });
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ServerError */ 2,
                    _0: /* UnauthorizedError */ 2
                }
            });
        }
    } else {
        exit = n >= 203 ? n !== 204 ? 1 : 2 : n >= 200 ? 2 : 1;
    }
    switch(exit){
        case 1:
            if (n >= 400 && n < 500) {
                return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(json) {
                    var e = _api_Data_ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
                    var tmp;
                    if (e.TAG === /* Ok */ 0) {
                        tmp = e;
                    } else {
                        var match = e._0;
                        switch(match.TAG | 0){
                            case /* NetworkError */ 0:
                            case /* JsonParsingError */ 1:
                                tmp = e;
                                break;
                            case /* ServerError */ 2:
                                var detail = match._0;
                                tmp = typeof detail === "number" || detail.TAG !== /* ServerValidationError */ 0 ? e : {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        TAG: /* ServerError */ 2,
                                        _0: {
                                            TAG: /* ServerValidationError */ 0,
                                            _0: detail._0
                                        }
                                    }
                                };
                                break;
                        }
                    }
                    return Promise.resolve(tmp);
                }, bs_fetch_src_Fetch_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .$$Response.json */ .PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: _api_ApiErrors_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .networkError */ .E(undefined, n)
                });
            }
        case 2:
            return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(json) {
                return Promise.resolve(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_8__._1(decoder, json));
            }, bs_fetch_src_Fetch_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .$$Response.json */ .PX.json(response));
    }
}
function checkResponse1(response, decoder) {
    var n = response.status;
    var exit = 0;
    if (n >= 205) {
        if (n !== 401) {
            if (n === 461) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: /* ServerFraudError */ 1
                    }
                });
            }
            exit = 1;
        } else {
            js_cookie__WEBPACK_IMPORTED_MODULE_4__.remove(_auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .cookieName */ .YN, {
                domain: _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getCookieDomain */ .yT(undefined)
            });
            return Promise.resolve({
                TAG: /* Error */ 1,
                _0: {
                    TAG: /* ServerError */ 2,
                    _0: /* UnauthorizedError */ 2
                }
            });
        }
    } else {
        exit = n !== 200 && n < 204 ? 1 : 2;
    }
    switch(exit){
        case 1:
            if (n >= 400 && n < 500) {
                return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(json) {
                    var e = _api_Data_ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
                    var tmp;
                    if (e.TAG === /* Ok */ 0) {
                        tmp = e;
                    } else {
                        var match = e._0;
                        switch(match.TAG | 0){
                            case /* NetworkError */ 0:
                            case /* JsonParsingError */ 1:
                                tmp = e;
                                break;
                            case /* ServerError */ 2:
                                var detail = match._0;
                                tmp = typeof detail === "number" || detail.TAG !== /* ServerValidationError */ 0 ? e : {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        TAG: /* ServerError */ 2,
                                        _0: {
                                            TAG: /* ServerValidationError */ 0,
                                            _0: detail._0
                                        }
                                    }
                                };
                                break;
                        }
                    }
                    return Promise.resolve(tmp);
                }, bs_fetch_src_Fetch_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .$$Response.json */ .PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: _api_ApiErrors_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .networkError */ .E(undefined, n)
                });
            }
        case 2:
            return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(json) {
                var result = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_8__._1(decoder, json);
                if (result.TAG === /* Ok */ 0) {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .some */ .G(result._0)
                    });
                } else {
                    return Promise.resolve({
                        TAG: /* Ok */ 0,
                        _0: undefined
                    });
                }
            }, bs_fetch_src_Fetch_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .$$Response.json */ .PX.json(response));
    }
}
function makeRequest(url, request, headerlessRequest, callback, logData) {
    var shouldLog = isClient && logData;
    if (shouldLog) {
        _bindings_Datadog_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Logger.requestInfo */ .Y.requestInfo("Request " + url, headerlessRequest, logger);
    }
    return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(response) {
        if (shouldLog) {
            _bindings_Datadog_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Logger.responseInfo */ .Y.responseInfo("Response " + url, response, logger);
        }
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_8__._1(callback, response);
    }, fetch(url, request));
}
 /* isClient Not a pure module */ 


/***/ }),

/***/ 50132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g5": function() { return /* binding */ SERVER_FRAUD_ERROR; },
/* harmony export */   "qQ": function() { return /* binding */ DAILY_LIMIT_ERROR; },
/* harmony export */   "sO": function() { return /* binding */ SESSION_STORAGE_KEYS; }
/* harmony export */ });
/* unused harmony exports SSR_PAGE_CACHE, PRODUCT_SSR_PAGE_CACHE, NO_CACHE */
var DAILY_LIMIT_ERROR = "Error: Sorry, we could not process your order. It is exceeding your daily purchase limit.";
var SERVER_FRAUD_ERROR = "Server Fraud Error";
var SSR_PAGE_CACHE = "public, max-age=600, stale-while-revalidate=300, stale-if-error=1800";
var PRODUCT_SSR_PAGE_CACHE = "public, max-age=90, stale-while-revalidate=300, stale-if-error=1800";
var NO_CACHE = "private, no-cache, no-store, max-age=0, must-revalidate";
var SESSION_STORAGE_KEYS = {
    unwrappingLoginFlowGiftPin: "prezzee.unwrappingLoginFlow.giftPin",
    recipientAuthFlowIsFromDecisionPage: "prezzee.recipientAuthFlow.isFromDecisionPage",
    recipientAuthFlowIsSchemeCard: "prezzee.recipientAuthFlow.isSchemeCard"
};


/***/ }),

/***/ 7667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EB": function() { return /* binding */ EventHelpers; },
/* harmony export */   "br": function() { return /* binding */ SEOUtil; },
/* harmony export */   "e": function() { return /* binding */ Business; },
/* harmony export */   "i3": function() { return /* binding */ EnvUtil; },
/* harmony export */   "iK": function() { return /* binding */ FileUtil; },
/* harmony export */   "le": function() { return /* binding */ CookieUtils; },
/* harmony export */   "oK": function() { return /* binding */ HeadersUtil; },
/* harmony export */   "pH": function() { return /* binding */ JsonUtil; },
/* harmony export */   "p_": function() { return /* binding */ ReactStuff; },
/* harmony export */   "qt": function() { return /* binding */ DefaultBalance; },
/* harmony export */   "uw": function() { return /* binding */ CurrencyUtils; }
/* harmony export */ });
/* unused harmony export getSessionIdToken */
/* harmony import */ var _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74594);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92592);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45603);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46150);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25400);
/* harmony import */ var _api_helpers_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60693);
// Generated by ReScript, PLEASE EDIT WITH CARE












function s(prim) {
    return prim;
}
function ate(prim) {
    return prim;
}
function Util$ReactStuff$Spread(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(props.children, props.props);
}
var Spread = {
    make: Util$ReactStuff$Spread
};
var ReactStuff = {
    s: s,
    ate: ate,
    Spread: Spread
};
function getSessionIdToken(prim) {
    return HelpersTs.getSessionIdToken(prim);
}
function isJsonObject(json) {
    if (typeof json === "object" && !Array.isArray(json)) {
        return json !== null;
    } else {
        return false;
    }
}
var Private = {
    isJsonObject: isJsonObject
};
function toDict(json) {
    if (isJsonObject(json)) {
        return json;
    } else {
        return {};
    }
}
function optionalField(fieldName, decoder, json) {
    var field = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(toDict(json), fieldName);
    if (field !== undefined) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(decoder, _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .valFromOption */ .xt(field)));
    }
}
function optionalWithDefault(fieldName, decoder, json, $$default) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(optionalField(fieldName, decoder, json), $$default);
}
var JsonUtil = {
    Private: Private,
    toDict: toDict,
    optionalField: optionalField,
    optionalWithDefault: optionalWithDefault
};
var countryCode = "NZ";
var currencyCode = "NZD";
var countriesAvailable = [
    /* Australia */ 0,
    /* GreatBritain */ 1,
    /* UnitedStates */ 2,
    /* NewZealand */ 3,
    /* Canada */ 4
];
var gdprCountries = [
    "GB"
];
function getCountry(param) {
    switch(countryCode){
        case "AU":
            return {
                TAG: /* Ok */ 0,
                _0: /* Australia */ 0
            };
        case "CA":
            return {
                TAG: /* Ok */ 0,
                _0: /* Canada */ 4
            };
        case "GB":
            return {
                TAG: /* Ok */ 0,
                _0: /* GreatBritain */ 1
            };
        case "NZ":
            return {
                TAG: /* Ok */ 0,
                _0: /* NewZealand */ 3
            };
        case "US":
            return {
                TAG: /* Ok */ 0,
                _0: /* UnitedStates */ 2
            };
        default:
            return {
                TAG: /* Error */ 1,
                _0: "Invalid country code."
            };
    }
}
function getCountryCode(country) {
    switch(country){
        case /* Australia */ 0:
            return "AU";
        case /* GreatBritain */ 1:
            return "GB";
        case /* UnitedStates */ 2:
            return "US";
        case /* NewZealand */ 3:
            return "NZ";
        case /* Canada */ 4:
            return "CA";
    }
}
function checkGdprCountry(country) {
    return gdprCountries.includes(country);
}
function getDomainPostfix(country) {
    switch(country){
        case /* Australia */ 0:
            return ".com.au";
        case /* GreatBritain */ 1:
            return ".uk";
        case /* UnitedStates */ 2:
            return ".com";
        case /* NewZealand */ 3:
            return ".co.nz";
        case /* Canada */ 4:
            return ".ca";
    }
}
function getEnv(param) {
    var isStg = "https://www.prezzee.co.nz/".includes("stg");
    if (isStg) {
        return /* Staging */ 0;
    } else {
        return /* Production */ 1;
    }
}
function getCurrency(currencyCode) {
    switch(currencyCode){
        case "AUD":
            return {
                TAG: /* Ok */ 0,
                _0: /* AUD */ 0
            };
        case "CAD":
            return {
                TAG: /* Ok */ 0,
                _0: /* CAD */ 4
            };
        case "GBP":
            return {
                TAG: /* Ok */ 0,
                _0: /* GBP */ 1
            };
        case "NZD":
            return {
                TAG: /* Ok */ 0,
                _0: /* NZD */ 3
            };
        case "USD":
            return {
                TAG: /* Ok */ 0,
                _0: /* USD */ 2
            };
        default:
            return {
                TAG: /* Error */ 1,
                _0: "Invalid currency code."
            };
    }
}
function getCurrencyCode(currency) {
    switch(currency){
        case /* AUD */ 0:
            return "AUD";
        case /* GBP */ 1:
            return "GBP";
        case /* USD */ 2:
            return "USD";
        case /* NZD */ 3:
            return "NZD";
        case /* CAD */ 4:
            return "CAD";
    }
}
function getTimezone(country) {
    switch(country){
        case /* Australia */ 0:
            return "Australia/Sydney";
        case /* GreatBritain */ 1:
            return "Europe/London";
        case /* UnitedStates */ 2:
            return "America/New_York";
        case /* NewZealand */ 3:
            return "Pacific/Auckland";
        case /* Canada */ 4:
            return "America/Toronto";
    }
}
var currentCountry = getCountry(countryCode);
var currentCurrency = getCurrency(currencyCode);
function getCmsLanguageFromRegion(param) {
    switch(countryCode){
        case "AU":
            return "en-AU";
        case "CA":
            return "en-CA";
        case "GB":
            return "en-UK";
        case "NZ":
            return "en-NZ";
        case "US":
            return "en-US";
        default:
            return "100-en-US";
    }
}
function getCmsLanguage(lang) {
    var opt = lang == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(lang);
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(opt, getCmsLanguageFromRegion(undefined));
}
var EnvUtil = {
    getEnv: getEnv,
    currentCountry: currentCountry,
    currentCurrency: currentCurrency,
    checkGdprCountry: checkGdprCountry,
    getCountry: getCountry,
    getCurrency: getCurrency,
    getTimezone: getTimezone,
    getCountryCode: getCountryCode,
    getCurrencyCode: getCurrencyCode,
    countriesAvailable: countriesAvailable,
    countryCode: countryCode,
    getDomainPostfix: getDomainPostfix,
    currencyCode: currencyCode,
    getCmsLanguageFromRegion: getCmsLanguageFromRegion,
    getCmsLanguage: getCmsLanguage
};
function getHrefLang(x) {
    switch(x){
        case /* Australia */ 0:
            return "en-au";
        case /* GreatBritain */ 1:
            return "en-gb";
        case /* UnitedStates */ 2:
            return "en-us";
        case /* NewZealand */ 3:
            return "en-nz";
        case /* Canada */ 4:
            return "en-ca";
    }
}
function getBaseHref(x) {
    switch(x){
        case /* Australia */ 0:
            return "https://www.prezzee.com.au";
        case /* GreatBritain */ 1:
            return "https://www.prezzee.uk";
        case /* UnitedStates */ 2:
            return "https://www.prezzee.com";
        case /* NewZealand */ 3:
            return "https://www.prezzee.co.nz";
        case /* Canada */ 4:
            return "https://www.prezzee.ca";
    }
}
function getLanguageAlternates(route) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_9__/* .map */ .UI(countriesAvailable, function(c) {
        return {
            hrefLang: getHrefLang(c),
            href: getBaseHref(c) + route
        };
    });
}
function getCanonicalUrl(route) {
    var path = route.slice(1);
    var pathWithoutQueryString = _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_10__/* .get */ .U2(path.split("?"), 0);
    return "https://www.prezzee.co.nz/" + pathWithoutQueryString;
}
var SEOUtil = {
    getHrefLang: getHrefLang,
    getBaseHref: getBaseHref,
    getLanguageAlternates: getLanguageAlternates,
    getCanonicalUrl: getCanonicalUrl
};
function build(param) {
    var fingerprint = js_cookie__WEBPACK_IMPORTED_MODULE_3__.get("fingerprint-pz");
    if (fingerprint == null) {
        return [];
    } else {
        return [
            [
                "x-device-fingerprint",
                fingerprint
            ]
        ];
    }
}
function withContentTypeJson(headers) {
    return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
        [
            "content-type",
            "application/json"
        ],
        [
            "accept",
            "application/json"
        ]
    ]);
}
function acceptContentTypeJson(headers) {
    return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
        [
            "accept",
            "application/json"
        ]
    ]);
}
function withAuthHeaderIfAvailable(headers) {
    var cookie = _auth_user_AuthUtils_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .getTokenFromCookie */ .GL(undefined);
    if (cookie !== undefined) {
        return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
            [
                "Authorization",
                _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(cookie.masquerade, false) ? "Masq " + cookie.token : "Bearer " + cookie.token
            ]
        ]);
    } else {
        return headers;
    }
}
function withSecurityToken(headers) {
    var fingerprint = _api_helpers_ts__WEBPACK_IMPORTED_MODULE_4__/* .getSessionIdToken */ .qB({
        updateConfig: false,
        resetToken: false
    });
    return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
        [
            "X-SECURITY-SESSIONID",
            fingerprint
        ]
    ]);
}
function withAuthHeaderFromServer(headers, token) {
    if (token !== undefined) {
        return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
            [
                "Authorization",
                "Bearer " + token
            ]
        ]);
    } else {
        return headers;
    }
}
function withPreferRespondAsync(headers) {
    return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3(headers, [
        [
            "Prefer",
            "respond-async"
        ]
    ]);
}
function withMagicUserAgentOnServerOnly(headers) {
    if (true) {
        return headers;
    } else {}
}
function makeWithArray(headers) {
    return headers;
}
var HeadersUtil = {
    build: build,
    withContentTypeJson: withContentTypeJson,
    acceptContentTypeJson: acceptContentTypeJson,
    withAuthHeaderIfAvailable: withAuthHeaderIfAvailable,
    withSecurityToken: withSecurityToken,
    withAuthHeaderFromServer: withAuthHeaderFromServer,
    withPreferRespondAsync: withPreferRespondAsync,
    withMagicUserAgentOnServerOnly: withMagicUserAgentOnServerOnly,
    makeWithArray: makeWithArray
};
var createFormData = function createFormData(data) {
    var formData = new FormData();
    Array.from(data).forEach(function(element) {
        formData.append("files", element);
    });
    return formData;
};
var convertToBlob = function convertToBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for(var i = 0; i < byteString.length; i++){
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([
        ab
    ], {
        type: "image/jpg"
    });
};
var FileUtil = {
    createFormData: createFormData,
    convertToBlob: convertToBlob
};
function getDenominationSymbol(currencyCode) {
    switch(currencyCode){
        case "EUR":
            return "€";
        case "GBP":
            return String.fromCharCode(163);
        case "AUD":
        case "CAD":
        case "NZD":
        case "USD":
            return "$";
        default:
            return "";
    }
}
var CurrencyUtils = {
    getDenominationSymbol: getDenominationSymbol
};
function getDefaultBalance(balance) {
    if (balance !== undefined) {
        return balance;
    } else {
        return "0";
    }
}
var DefaultBalance = {
    getDefaultBalance: getDefaultBalance
};
function isEnterKey(e) {
    var key = e.key;
    var keyCode = e.keyCode;
    if (key === "Enter") {
        return true;
    } else {
        return keyCode === 13;
    }
}
var EventHelpers = {
    isEnterKey: isEnterKey
};
function getUser(param) {
    return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .nullable_to_opt */ .Tl(js_cookie__WEBPACK_IMPORTED_MODULE_3__.get("PB_STORAGE"));
}
var Business = {
    getUser: getUser,
    pathname: "/business"
};
var CookieUtils = {
    acceptCookies: "acceptCookiesPrezzee"
};
 /* countryCode Not a pure module */ 


/***/ }),

/***/ 42358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "si": function() { return /* binding */ COUNTRY; },
  "$8": function() { return /* binding */ NATIONALITY; },
  "L6": function() { return /* binding */ Replacement; },
  "tK": function() { return /* binding */ currencyUtil; },
  "vc": function() { return /* binding */ dateFormat; },
  "vK": function() { return /* binding */ envUtil; },
  "zC": function() { return /* binding */ getCurrency; },
  "qk": function() { return /* binding */ getOrderIdFromUrl; },
  "GI": function() { return /* binding */ isMultiPurchaseFF; }
});

// UNUSED EXPORTS: CURRENCY, READABLE_COUNTRY, cookieConfig, headerUtil, isWebConfigMultipurchase

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
;// CONCATENATED MODULE: ./public/currencies.json
var currencies_namespaceObject = JSON.parse('[{"cc":"AED","symbol":"د.إ;","name":"UAE dirham"},{"cc":"AFN","symbol":"Afs","name":"Afghan afghani"},{"cc":"ALL","symbol":"L","name":"Albanian lek"},{"cc":"AMD","symbol":"AMD","name":"Armenian dram"},{"cc":"ANG","symbol":"NAƒ","name":"Netherlands Antillean gulden"},{"cc":"AOA","symbol":"Kz","name":"Angolan kwanza"},{"cc":"ARS","symbol":"$","name":"Argentine peso"},{"cc":"AUD","symbol":"$","name":"Australian dollar"},{"cc":"AWG","symbol":"ƒ","name":"Aruban florin"},{"cc":"AZN","symbol":"AZN","name":"Azerbaijani manat"},{"cc":"BAM","symbol":"KM","name":"Bosnia and Herzegovina konvertibilna marka"},{"cc":"BBD","symbol":"Bds$","name":"Barbadian dollar"},{"cc":"BDT","symbol":"৳","name":"Bangladeshi taka"},{"cc":"BGN","symbol":"BGN","name":"Bulgarian lev"},{"cc":"BHD","symbol":".د.ب","name":"Bahraini dinar"},{"cc":"BIF","symbol":"FBu","name":"Burundi franc"},{"cc":"BMD","symbol":"BD$","name":"Bermudian dollar"},{"cc":"BND","symbol":"B$","name":"Brunei dollar"},{"cc":"BOB","symbol":"Bs.","name":"Bolivian boliviano"},{"cc":"BRL","symbol":"R$","name":"Brazilian real"},{"cc":"BSD","symbol":"B$","name":"Bahamian dollar"},{"cc":"BTN","symbol":"Nu.","name":"Bhutanese ngultrum"},{"cc":"BWP","symbol":"P","name":"Botswana pula"},{"cc":"BYR","symbol":"Br","name":"Belarusian ruble"},{"cc":"BZD","symbol":"BZ$","name":"Belize dollar"},{"cc":"CAD","symbol":"$","name":"Canadian dollar"},{"cc":"CDF","symbol":"F","name":"Congolese franc"},{"cc":"CHF","symbol":"Fr.","name":"Swiss franc"},{"cc":"CLP","symbol":"$","name":"Chilean peso"},{"cc":"CNY","symbol":"¥","name":"Chinese/Yuan renminbi"},{"cc":"COP","symbol":"Col$","name":"Colombian peso"},{"cc":"CRC","symbol":"₡","name":"Costa Rican colon"},{"cc":"CUC","symbol":"$","name":"Cuban peso"},{"cc":"CVE","symbol":"Esc","name":"Cape Verdean escudo"},{"cc":"CZK","symbol":"Kč","name":"Czech koruna"},{"cc":"DJF","symbol":"Fdj","name":"Djiboutian franc"},{"cc":"DKK","symbol":"Kr","name":"Danish krone"},{"cc":"DOP","symbol":"RD$","name":"Dominican peso"},{"cc":"DZD","symbol":"د.ج","name":"Algerian dinar"},{"cc":"EEK","symbol":"KR","name":"Estonian kroon"},{"cc":"EGP","symbol":"£","name":"Egyptian pound"},{"cc":"ERN","symbol":"Nfa","name":"Eritrean nakfa"},{"cc":"ETB","symbol":"Br","name":"Ethiopian birr"},{"cc":"EUR","symbol":"€","name":"European Euro"},{"cc":"FJD","symbol":"FJ$","name":"Fijian dollar"},{"cc":"FKP","symbol":"£","name":"Falkland Islands pound"},{"cc":"GBP","symbol":"£","name":"British pound"},{"cc":"GEL","symbol":"GEL","name":"Georgian lari"},{"cc":"GHS","symbol":"GH₵","name":"Ghanaian cedi"},{"cc":"GIP","symbol":"£","name":"Gibraltar pound"},{"cc":"GMD","symbol":"D","name":"Gambian dalasi"},{"cc":"GNF","symbol":"FG","name":"Guinean franc"},{"cc":"GQE","symbol":"CFA","name":"Central African CFA franc"},{"cc":"GTQ","symbol":"Q","name":"Guatemalan quetzal"},{"cc":"GYD","symbol":"GY$","name":"Guyanese dollar"},{"cc":"HKD","symbol":"HK$","name":"Hong Kong dollar"},{"cc":"HNL","symbol":"L","name":"Honduran lempira"},{"cc":"HRK","symbol":"kn","name":"Croatian kuna"},{"cc":"HTG","symbol":"G","name":"Haitian gourde"},{"cc":"HUF","symbol":"Ft","name":"Hungarian forint"},{"cc":"IDR","symbol":"Rp","name":"Indonesian rupiah"},{"cc":"ILS","symbol":"₪","name":"Israeli new sheqel"},{"cc":"INR","symbol":"₹","name":"Indian rupee"},{"cc":"IQD","symbol":"د.ع","name":"Iraqi dinar"},{"cc":"IRR","symbol":"IRR","name":"Iranian rial"},{"cc":"ISK","symbol":"kr","name":"Icelandic króna"},{"cc":"JMD","symbol":"J$","name":"Jamaican dollar"},{"cc":"JOD","symbol":"JOD","name":"Jordanian dinar"},{"cc":"JPY","symbol":"¥","name":"Japanese yen"},{"cc":"KES","symbol":"KSh","name":"Kenyan shilling"},{"cc":"KGS","symbol":"сом","name":"Kyrgyzstani som"},{"cc":"KHR","symbol":"៛","name":"Cambodian riel"},{"cc":"KMF","symbol":"KMF","name":"Comorian franc"},{"cc":"KPW","symbol":"W","name":"North Korean won"},{"cc":"KRW","symbol":"W","name":"South Korean won"},{"cc":"KWD","symbol":"KWD","name":"Kuwaiti dinar"},{"cc":"KYD","symbol":"KY$","name":"Cayman Islands dollar"},{"cc":"KZT","symbol":"T","name":"Kazakhstani tenge"},{"cc":"LAK","symbol":"KN","name":"Lao kip"},{"cc":"LBP","symbol":"£","name":"Lebanese lira"},{"cc":"LKR","symbol":"Rs","name":"Sri Lankan rupee"},{"cc":"LRD","symbol":"L$","name":"Liberian dollar"},{"cc":"LSL","symbol":"M","name":"Lesotho loti"},{"cc":"LTL","symbol":"Lt","name":"Lithuanian litas"},{"cc":"LVL","symbol":"Ls","name":"Latvian lats"},{"cc":"LYD","symbol":"LD","name":"Libyan dinar"},{"cc":"MAD","symbol":"MAD","name":"Moroccan dirham"},{"cc":"MDL","symbol":"MDL","name":"Moldovan leu"},{"cc":"MGA","symbol":"FMG","name":"Malagasy ariary"},{"cc":"MKD","symbol":"MKD","name":"Macedonian denar"},{"cc":"MMK","symbol":"K","name":"Myanma kyat"},{"cc":"MNT","symbol":"₮","name":"Mongolian tugrik"},{"cc":"MOP","symbol":"P","name":"Macanese pataca"},{"cc":"MRO","symbol":"UM","name":"Mauritanian ouguiya"},{"cc":"MUR","symbol":"Rs","name":"Mauritian rupee"},{"cc":"MVR","symbol":"Rf","name":"Maldivian rufiyaa"},{"cc":"MWK","symbol":"MK","name":"Malawian kwacha"},{"cc":"MXN","symbol":"$","name":"Mexican peso"},{"cc":"MYR","symbol":"RM","name":"Malaysian ringgit"},{"cc":"MZM","symbol":"MTn","name":"Mozambican metical"},{"cc":"NAD","symbol":"N$","name":"Namibian dollar"},{"cc":"NGN","symbol":"₦","name":"Nigerian naira"},{"cc":"NIO","symbol":"C$","name":"Nicaraguan córdoba"},{"cc":"NOK","symbol":"kr","name":"Norwegian krone"},{"cc":"NPR","symbol":"NRs","name":"Nepalese rupee"},{"cc":"NZD","symbol":"$","name":"New Zealand dollar"},{"cc":"OMR","symbol":"OMR","name":"Omani rial"},{"cc":"PAB","symbol":"B./","name":"Panamanian balboa"},{"cc":"PEN","symbol":"S/.","name":"Peruvian nuevo sol"},{"cc":"PGK","symbol":"K","name":"Papua New Guinean kina"},{"cc":"PHP","symbol":"₱","name":"Philippine peso"},{"cc":"PKR","symbol":"Rs.","name":"Pakistani rupee"},{"cc":"PLN","symbol":"zł","name":"Polish zloty"},{"cc":"PYG","symbol":"₲","name":"Paraguayan guarani"},{"cc":"QAR","symbol":"QR","name":"Qatari riyal"},{"cc":"RON","symbol":"L","name":"Romanian leu"},{"cc":"RSD","symbol":"din.","name":"Serbian dinar"},{"cc":"RUB","symbol":"R","name":"Russian ruble"},{"cc":"SAR","symbol":"SR","name":"Saudi riyal"},{"cc":"SBD","symbol":"SI$","name":"Solomon Islands dollar"},{"cc":"SCR","symbol":"SR","name":"Seychellois rupee"},{"cc":"SDG","symbol":"SDG","name":"Sudanese pound"},{"cc":"SEK","symbol":"kr","name":"Swedish krona"},{"cc":"SGD","symbol":"S$","name":"Singapore dollar"},{"cc":"SHP","symbol":"£","name":"Saint Helena pound"},{"cc":"SLL","symbol":"Le","name":"Sierra Leonean leone"},{"cc":"SOS","symbol":"Sh.","name":"Somali shilling"},{"cc":"SRD","symbol":"$","name":"Surinamese dollar"},{"cc":"SYP","symbol":"LS","name":"Syrian pound"},{"cc":"SZL","symbol":"E","name":"Swazi lilangeni"},{"cc":"THB","symbol":"฿","name":"Thai baht"},{"cc":"TJS","symbol":"TJS","name":"Tajikistani somoni"},{"cc":"TMT","symbol":"m","name":"Turkmen manat"},{"cc":"TND","symbol":"DT","name":"Tunisian dinar"},{"cc":"TRY","symbol":"TRY","name":"Turkish new lira"},{"cc":"TTD","symbol":"TT$","name":"Trinidad and Tobago dollar"},{"cc":"TWD","symbol":"NT$","name":"New Taiwan dollar"},{"cc":"TZS","symbol":"TZS","name":"Tanzanian shilling"},{"cc":"UAH","symbol":"UAH","name":"Ukrainian hryvnia"},{"cc":"UGX","symbol":"USh","name":"Ugandan shilling"},{"cc":"USD","symbol":"$","name":"United States dollar"},{"cc":"UYU","symbol":"$U","name":"Uruguayan peso"},{"cc":"UZS","symbol":"UZS","name":"Uzbekistani som"},{"cc":"VEB","symbol":"Bs","name":"Venezuelan bolivar"},{"cc":"VND","symbol":"₫","name":"Vietnamese dong"},{"cc":"VUV","symbol":"VT","name":"Vanuatu vatu"},{"cc":"WST","symbol":"WS$","name":"Samoan tala"},{"cc":"XAF","symbol":"CFA","name":"Central African CFA franc"},{"cc":"XCD","symbol":"EC$","name":"East Caribbean dollar"},{"cc":"XDR","symbol":"SDR","name":"Special Drawing Rights"},{"cc":"XOF","symbol":"CFA","name":"West African CFA franc"},{"cc":"XPF","symbol":"F","name":"CFP franc"},{"cc":"YER","symbol":"YER","name":"Yemeni rial"},{"cc":"ZAR","symbol":"R","name":"South African rand"},{"cc":"ZMK","symbol":"ZK","name":"Zambian kwacha"},{"cc":"ZWR","symbol":"Z$","name":"Zimbabwean dollar"}]');
;// CONCATENATED MODULE: ./src/models/webConfig.model.ts
var MultiPurchaseToggle;
(function(MultiPurchaseToggle) {
    MultiPurchaseToggle["False"] = "False";
    MultiPurchaseToggle["MemberGuest"] = "member_and_all_guest";
    MultiPurchaseToggle["Member"] = "member";
    MultiPurchaseToggle["Guest"] = "all_guest";
})(MultiPurchaseToggle || (MultiPurchaseToggle = {}));

;// CONCATENATED MODULE: ./src/models/sku.model.ts
var SkuMultiToggleType;
(function(SkuMultiToggleType) {
    SkuMultiToggleType["On"] = "on";
    SkuMultiToggleType["Off"] = "off";
    SkuMultiToggleType["Default"] = "default";
})(SkuMultiToggleType || (SkuMultiToggleType = {}));

// EXTERNAL MODULE: ./src/utils/authUtils.ts
var authUtils = __webpack_require__(89090);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
;// CONCATENATED MODULE: ./src/common/util.ts










var dateFormat = function(d) {
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    var t = new Date(d);
    return "".concat(t.getDate(), " ").concat(monthNames[t.getMonth()], " ").concat(t.getFullYear());
};
var getCurrency = function(currencyCode) {
    var filteredCurrency = currencies_namespaceObject.filter(function(currency) {
        return currency.cc === currencyCode;
    });
    if (filteredCurrency.length) return filteredCurrency[0];
    logger/* default.warn */.ZP.warn("warn: No currency matching passed currency code: ".concat(currencyCode));
    return;
};
var COUNTRY;
(function(COUNTRY) {
    COUNTRY["Australia"] = "Australia";
    COUNTRY["GreatBritain"] = "GreatBritain";
    COUNTRY["UnitedStates"] = "UnitedStates";
    COUNTRY["NewZealand"] = "NewZealand";
})(COUNTRY || (COUNTRY = {}));
var NATIONALITY;
(function(NATIONALITY) {
    NATIONALITY["AU"] = "Australian";
    NATIONALITY["GB"] = "UK";
    NATIONALITY["US"] = "US";
    NATIONALITY["NZ"] = "New Zealand";
})(NATIONALITY || (NATIONALITY = {}));
var READABLE_COUNTRY;
(function(READABLE_COUNTRY) {
    READABLE_COUNTRY["AU"] = "Australia";
    READABLE_COUNTRY["GB"] = "the UK";
    READABLE_COUNTRY["US"] = "the US";
    READABLE_COUNTRY["NZ"] = "New Zealand";
})(READABLE_COUNTRY || (READABLE_COUNTRY = {}));
var CURRENCY;
(function(CURRENCY) {
    CURRENCY["AUD"] = "AUD";
    CURRENCY["GBP"] = "GBP";
    CURRENCY["USD"] = "USD";
    CURRENCY["NZD"] = "NZD";
})(CURRENCY || (CURRENCY = {}));
var Replacement;
(function(Replacement) {
    Replacement["Zero"] = "{0}";
})(Replacement || (Replacement = {}));
var countryCode = "NZ";
var currencyCode = "NZD";
var envUtil = {
    countryCode: countryCode,
    currencyCode: currencyCode,
    getCurrency: function(currencyCode) {
        switch(currencyCode){
            case "AUD":
                return CURRENCY.AUD;
            case "GBP":
                return CURRENCY.GBP;
            case "USD":
                return CURRENCY.USD;
            case "NZD":
                return CURRENCY.NZD;
            default:
                return "Invalid currency code.";
        }
    },
    getCurrencyCode: function(currency) {
        switch(currency){
            case CURRENCY.AUD:
                return "AUD";
            case CURRENCY.GBP:
                return "GBP";
            case CURRENCY.USD:
                return "USD";
            case CURRENCY.NZD:
                return "NZD";
        }
    },
    getCountry: function() {
        switch(countryCode){
            case "AU":
                return COUNTRY.Australia;
            case "GB":
                return COUNTRY.GreatBritain;
            case "US":
                return COUNTRY.UnitedStates;
            case "NZ":
                return COUNTRY.NewZealand;
            default:
                return "Invalid country code.";
        }
    },
    getStoreCodename: function() {
        switch(countryCode){
            case "AU":
                return "prezzee_classic_store_au";
            case "GB":
                return "prezzee_classic_store_uk";
            case "US":
                return "prezzee_classic_store_us";
            case "NZ":
                return "prezzee_classic_store_nz";
            default:
                return "Invalid country code.";
        }
    },
    getNationality: function() {
        return NATIONALITY[countryCode];
    },
    getReadableCountry: function() {
        return READABLE_COUNTRY[countryCode];
    }
};
var currencyUtil = {
    getDenominationSymbol: function(currencyCode) {
        switch(currencyCode){
            case "AUD":
                return "$";
            case "NZD":
                return "$";
            case "GBP":
                return String.fromCharCode(163);
            case "USD":
                return "$";
            case "CAD":
                return "$";
            case "EUR":
                return "€";
            default:
                return "";
        }
    }
};
var headerUtil = {
    withAuthHeaderIfAvailable: function(headers) {
        var userCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
        var decryptedUser = userCookie ? (0,authUtils/* decryptUserCookie */.x)(userCookie) : undefined;
        var isMasq = decryptedUser === null || decryptedUser === void 0 ? void 0 : decryptedUser.masquerade;
        var tokenType = isMasq ? "Masq" : "Bearer";
        return (decryptedUser === null || decryptedUser === void 0 ? void 0 : decryptedUser.token) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            Authorization: "".concat(tokenType, " ").concat(decryptedUser.token),
            "x-device-fingerprint": js_cookie_default().get("fingerprint-pz")
        }) : headers;
    },
    withContentTypeJson: function(headers) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "Content-Type": "application/json",
            accept: "application/json"
        });
    },
    withSecurityToken: function(headers) {
        var sessionId = (0,helpers/* getSessionIdToken */.qB)();
        if (sessionId) headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "X-SECURITY-SESSIONID": sessionId
        });
        return headers;
    }
};
var isWebConfigMultipurchase = function(webConfigMultiPurchase, user) {
    switch(webConfigMultiPurchase){
        case MultiPurchaseToggle.False:
            return false;
        case MultiPurchaseToggle.MemberGuest:
            return true;
        case MultiPurchaseToggle.Member:
            return !!user;
        case MultiPurchaseToggle.Guest:
            return !user && true;
        default:
            return false;
    }
};
var isMultiPurchaseFF = function(skuMultiPurchase, webConfigMultiPurchase, user) {
    switch(skuMultiPurchase){
        case SkuMultiToggleType.On:
            return true;
        case SkuMultiToggleType.Off:
            return false;
        case SkuMultiToggleType.Default:
            return isWebConfigMultipurchase(webConfigMultiPurchase, user);
        default:
            return false;
    }
};
var cookieConfig = {
    acceptCookies: "acceptCookiesPrezzee"
};
var getOrderIdFromUrl = function(url) {
    var regex = /\/orders\/([^/]+)/;
    var match = url.match(regex);
    return match ? match[1] : null;
};


/***/ }),

/***/ 4331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ EMPTY_ELEMENT; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);

var EMPTY_ELEMENT = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});


/***/ }),

/***/ 53782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OC": function() { return /* binding */ COMMA; },
/* harmony export */   "RC": function() { return /* binding */ VERTICAL_LINE_SIGN; },
/* harmony export */   "v6": function() { return /* binding */ EMPTY_STRING; }
/* harmony export */ });
/* unused harmony export SPACE */
var EMPTY_STRING = "";
var COMMA = ",";
var SPACE = " ";
var VERTICAL_LINE_SIGN = "|";


/***/ }),

/***/ 34442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _CmsImage_tsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73450);
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = _CmsImage_tsx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
 /* make Not a pure module */ 


/***/ }),

/***/ 73450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31611);




var isSvg = function(url) {
    return url.endsWith(".svg");
};
var loader = function(param) {
    var src = param.src, width = param.width;
    return "".concat(src, "?fm=png&auto=format&w=").concat(width);
};
var loaderWithParams = function(param) {
    var src = param.src, width = param.width;
    return "".concat(src, "?fm=png&auto=format&w=").concat(width);
};
var loaderSvg = function(param) {
    var src = param.src;
    return src;
};
var paramsRegex = /(?:\?|\&)([\w]+)(?:\=|\&?)([\w+,.-]*)/g;
var CmsImage = function(props) {
    var src = props.src, alt = props.alt, width = props.width, height = props.height, className = props.className, priority = props.priority, sizes = props.sizes, _fill = props.fill, fill = _fill === void 0 ? false : _fill, loading = props.loading;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var currentLoader = loader;
    if (src.match(paramsRegex)) {
        if (isSvg(src.slice(0, src.search(paramsRegex)))) {
            currentLoader = loaderSvg;
        } else {
            currentLoader = loaderWithParams;
        }
    } else if (isSvg(src)) {
        currentLoader = loaderSvg;
    }
    if (!src) {
        _utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"].info */ .ZP.info({
            path: asPath,
            props: props,
            source: "CMS"
        }, "error: Image src is missing");
        //Image requires src
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        loader: currentLoader,
        priority: priority,
        src: src,
        alt: alt,
        width: width,
        height: height,
        className: className,
        sizes: sizes,
        fill: fill,
        loading: loading
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CmsImage);


/***/ }),

/***/ 1223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ make; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/CookieSettingButton.tsx

var CookieSettingButton = function(param) {
    var text = param.text;
    var onClick = function() {
        var ref;
        (ref = window.OneTrust) === null || ref === void 0 ? void 0 : ref.ToggleInfoDisplay();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
        id: "ot-sdk-btn",
        className: "cursor-pointer",
        onClick: onClick,
        children: text
    });
};
/* harmony default export */ var components_CookieSettingButton = (CookieSettingButton);

;// CONCATENATED MODULE: ./src/components/CookieSettingButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = components_CookieSettingButton;
 /* make Not a pure module */ 


/***/ }),

/***/ 30369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _StaticImage_tsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17431);
// Generated by ReScript, PLEASE EDIT WITH CARE

var make = _StaticImage_tsx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
 /* make Not a pure module */ 


/***/ }),

/***/ 17431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_0__);


var StaticImage = function(props) {
    var src = props.src, alt = props.alt, width = props.width, height = props.height, className = props.className, _priority = props.priority, priority = _priority === void 0 ? false : _priority, _fill = props.fill, fill = _fill === void 0 ? false : _fill, loading = props.loading;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_0___default()), {
        priority: priority,
        src: src,
        alt: alt,
        width: width,
        height: height,
        className: className,
        fill: fill,
        loading: loading
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StaticImage);


/***/ }),

/***/ 59037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gx": function() { return /* binding */ redCircleStyle; },
/* harmony export */   "JU": function() { return /* binding */ disabled; },
/* harmony export */   "SN": function() { return /* binding */ grayOutlineStyle; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "Yf": function() { return /* binding */ blueCircleStyle; },
/* harmony export */   "Ze": function() { return /* binding */ secondaryStyle; },
/* harmony export */   "e1": function() { return /* binding */ primaryOutlineStyle; },
/* harmony export */   "rh": function() { return /* binding */ linkBlueCircleStyle; },
/* harmony export */   "vP": function() { return /* binding */ primaryStyle; }
/* harmony export */ });
/* unused harmony exports btnStyle, linkBlueStyle, secondaryOutlineStyle, linkBlueOutlineStyle, grayCircleStyle, whiteCircleStyle */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE

var btnStyle = "bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white rounded py-2 px-4 border-black focus:outline-none";
function Button(props) {
    var className = props.className;
    var disabled = props.disabled;
    var title = props.title;
    var onClick = props.onClick;
    var onClick$1 = onClick !== undefined ? onClick : function onClick$1(param) {};
    var disabled$1 = disabled !== undefined ? disabled : false;
    var className$1 = className !== undefined ? className : btnStyle;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("button", {
        children: title,
        className: className$1,
        title: title,
        disabled: disabled$1,
        onClick: onClick$1
    });
}
var primaryStyle = "text-white rounded-lg bg-prezzee-red focus:outline-none";
var secondaryStyle = "text-white rounded-lg bg-prezzee-blue focus:outline-none";
var linkBlueStyle = "text-white rounded-lg tracking-wider bg-link-blue focus:outline-none";
var primaryOutlineStyle = "bg-transparent hover:text-white hover:bg-prezzee-red rounded-md border text-prezzee-red border-prezzee-red focus:outline-none";
var secondaryOutlineStyle = "bg-transparent hover:text-white hover:bg-prezzee-blue rounded-md border text-prezzee-blue border-prezzee-blue focus:outline-none";
var linkBlueOutlineStyle = "bg-transparent hover:text-white hover:bg-prezzee-blue rounded-md border text-link-blue border-link-blue focus:outline-none";
var grayOutlineStyle = "rounded-md border focus:outline-none";
var disabled = "text-white rounded-lg bg-prezzee-red cursor-not-allowed opacity-25";
var redCircleStyle = "rounded-full bg-prezzee-red focus:outline-none";
var blueCircleStyle = "rounded-full bg-prezzee-blue focus:outline-none";
var grayCircleStyle = "rounded-full bg-gray-300 text-white focus:outline-none";
var whiteCircleStyle = "rounded-full bg-white text-prezzee-red focus:outline-none";
var linkBlueCircleStyle = "rounded-full bg-link-blue text-white focus:outline-none";
var make = Button;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 20025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; },
/* harmony export */   "T": function() { return /* binding */ newsletterInput; }
/* harmony export */ });
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91574);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92592);
/* harmony import */ var _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _bindings_Segment_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73840);
/* harmony import */ var _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27097);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25400);
/* harmony import */ var _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77103);
/* harmony import */ var _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47861);
// Generated by ReScript, PLEASE EDIT WITH CARE










var newsletterInput = {
    required: {
        value: true,
        message: "Your email is required"
    },
    pattern: {
        value: _utils_Regex_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .emailRegex */ .HN,
        message: "Please enter a valid email address"
    }
};
function NewsletterSubscription(props) {
    var store = props.store;
    var store$1 = store !== undefined ? store : "consumer";
    var newsletterInputFormOpt = {
        mode: "onTouched"
    };
    var match = react__WEBPACK_IMPORTED_MODULE_1__.useState(function() {
        return false;
    });
    var setIsSubscribed = match[1];
    var form = _bindings_ReactHookForm_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI(newsletterInputFormOpt, undefined);
    var setError = form.setError;
    var reset = form.reset;
    var subscribeWithBff = function subscribeWithBff(data) {
        return _rescript_std_lib_es6_js_promise_js__WEBPACK_IMPORTED_MODULE_6__/* .then_ */ .k(function(result) {
            if (result.TAG === /* Ok */ 0) {
                return Promise.resolve(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setIsSubscribed, function(param) {
                    return true;
                }));
            }
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(reset, undefined);
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._2(setError, "email_address", {
                type: "server",
                message: "Something went wrong. Please try again."
            });
            _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(setIsSubscribed, function(param) {
                return false;
            });
            _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error({
                err: result._0,
                type: "Newsletter Subscription",
                source: "Subscriptions BFF"
            }, "error: Could not opt in to EDM");
            return Promise.resolve(undefined);
        }, _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_4__.BFFNewsletter.subscribe(data.email_address, "NZ", true, store$1));
    };
    var onSubmit = function onSubmit(data) {
        var bffUrlOpt = "https://consumer-bff.prezzee.co.nz/graphql";
        _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_8__/* .getWithDefault */ .tj(bffUrlOpt == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .some */ .G(bffUrlOpt), "");
        subscribeWithBff(data);
    };
    if (match[0]) {
        return props.successElement;
    } else {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_7__._1(props.formComponent, {
            form: form,
            onSubmit: onSubmit
        });
    }
}
var make = NewsletterSubscription;
 /* Pino Not a pure module */ 


/***/ }),

/***/ 59746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T0": function() { return /* binding */ GenericRegionPicker; },
  "i8": function() { return /* binding */ RegionInline; },
  "Mq": function() { return /* binding */ RegionStrip; }
});

// UNUSED EXPORTS: RegionIndicatorCountryDisplay, RegionIndicatorInline, RegionIndicatorStrip, RegionPicker, isStg, removeTrailingSlash, toStgUrl

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Result.js
var belt_Result = __webpack_require__(70677);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js + 1 modules
var Gql_DictionaryItems_Decoder_bs = __webpack_require__(44623);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionFlag.bs.js
var RegionFlag_bs = __webpack_require__(16755);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicator.bs.js + 4 modules
var RegionIndicator_bs = __webpack_require__(10325);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorFlag.bs.js
var RegionIndicatorFlag_bs = __webpack_require__(15772);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faChevronDown.js
var faChevronDown = __webpack_require__(61437);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorStrip.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE











var border = BsCssJs_bs.px(1);
function headerBar(theme) {
    var match = theme.components;
    var regionStrip = match.regionStrip;
    return BsCssJs_bs/* merge */.TSy([
        Theme_Typography_bs/* Styles.smallBody */.z.smallBody,
        BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* backgroundColor */.Czw(regionStrip.backgroundColor),
            BsCssJs_bs/* color */.$_Y(regionStrip.color)
        ])
    ]);
}
var wrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("flexEnd"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(28))
]);
var flagBlock = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs/* zero */.bMI),
    BsCssJs_bs/* borderLeftWidth */.Pxd(border),
    BsCssJs_bs/* borderRightWidth */.UY5(border),
    BsCssJs_bs/* borderStyle */.$uf("solid"),
    BsCssJs_bs/* borderColor */.tvt({
        NAME: "rgba",
        VAL: [
            255,
            255,
            255,
            {
                NAME: "num",
                VAL: 0.2
            }
        ]
    }),
    BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(6)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100))
]);
var Styles = {
    border: border,
    headerBar: headerBar,
    wrapper: wrapper,
    flagBlock: flagBlock
};
function RegionIndicatorStrip(props) {
    var className = props.className;
    var onChange = props.onChange;
    var onChange$1 = onChange !== undefined ? onChange : function onChange$1(param) {};
    var className$1 = className !== undefined ? className : "";
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    var icon = jsx_runtime.jsx(index_es.FontAwesomeIcon, {
        icon: faChevronDown/* faChevronDown */.pt,
        className: BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(8))
        ])
    });
    var clickableElem = function clickableElem(r) {
        var flag = jsx_runtime.jsx(RegionFlag_bs/* make */.S, {
            src: r.flag,
            size: 18
        });
        return jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx(RegionIndicatorFlag_bs/* make */.S, {
                flag: flag,
                icon: caml_option/* some */.G(icon)
            }),
            className: flagBlock
        });
    };
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx(RegionIndicator_bs/* make */.S, {
                regions: props.regions,
                strings: props.strings,
                selected: props.selected,
                children: props.children,
                clickableElem: clickableElem,
                onChange: onChange$1
            }),
            className: classnames_default()([
                wrapper,
                className$1
            ])
        }),
        className: headerBar(theme)
    });
}
var make = RegionIndicatorStrip;
 /* border Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faChevronRight.js
var faChevronRight = __webpack_require__(40853);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorInline.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var inlineRegionPicker = BsCssJs_bs/* merge */.TSy([
    Theme_Typography_bs/* Styles.smallBody */.z.smallBody,
    BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* alignItems */.cq$("center")
    ])
]);
var flagStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* filter */.hXT([
        {
            NAME: "dropShadow",
            VAL: [
                BsCssJs_bs.px(0),
                BsCssJs_bs.px(4),
                BsCssJs_bs.px(4),
                BsCssJs_bs/* rgba */.m4f(0, 0, 0, {
                    NAME: "num",
                    VAL: 0.25
                })
            ]
        }
    ])
]);
var RegionIndicatorInline_bs_Styles = {
    inlineRegionPicker: inlineRegionPicker,
    flagStyle: flagStyle
};
function RegionIndicatorInline(props) {
    var onChange = props.onChange;
    var onChange$1 = onChange !== undefined ? onChange : function onChange$1(param) {};
    var icon = jsx_runtime.jsx(index_es.FontAwesomeIcon, {
        icon: faChevronRight/* faChevronRight */._t,
        className: BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(14))
        ])
    });
    var clickableElem = function clickableElem(r) {
        var flag = jsx_runtime.jsx(RegionFlag_bs/* make */.S, {
            src: r.flag,
            size: 24,
            className: flagStyle
        });
        return jsx_runtime.jsx(RegionIndicatorFlag_bs/* make */.S, {
            flag: flag,
            icon: caml_option/* some */.G(icon)
        });
    };
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx(RegionIndicator_bs/* make */.S, {
            regions: props.regions,
            strings: props.strings,
            selected: props.selected,
            children: props.children,
            clickableElem: clickableElem,
            onChange: onChange$1
        }),
        className: inlineRegionPicker
    });
}
var RegionIndicatorInline_bs_make = RegionIndicatorInline;
 /* inlineRegionPicker Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionList/RegionListLineContent.bs.js
var RegionListLineContent_bs = __webpack_require__(69422);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorCountryDisplay.bs.js
var RegionIndicatorCountryDisplay_bs = __webpack_require__(75870);
;// CONCATENATED MODULE: ./src/components/library/RegionIndicators.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE















function removeTrailingSlash(url) {
    var slashIndex = url.lastIndexOf("/");
    if (slashIndex === (url.length - 1 | 0)) {
        return url.substring(0, slashIndex);
    } else {
        return url;
    }
}
var isStg = "https://www.prezzee.co.nz/".includes("stg");
function toStgUrl(url) {
    return url.replace("https://www.prezzee", "https://stg.prezzee");
}
function RegionIndicators$RegionInline(props) {
    var selectedRegion = props.selectedRegion;
    var regionListLines = props.regionListLines;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(RegionIndicatorInline_bs_make, {
            regions: regionListLines,
            strings: props.regionPickerStrings,
            selected: selectedRegion,
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(RegionIndicatorCountryDisplay_bs/* make */.S, {
                    text: props.regionIndicatorText,
                    regions: regionListLines,
                    selected: selectedRegion
                }),
                itemId: props.regionIndicatorTextId,
                elementCodename: props.regionIndicatorTextCodename
            }),
            onChange: props.onChange
        }),
        itemId: props.regionModalItemId,
        elementCodename: props.regionModalCodename
    });
}
var RegionInline = {
    make: RegionIndicators$RegionInline
};
function RegionIndicators$RegionStrip(props) {
    var selectedRegion = props.selectedRegion;
    var regionListLines = props.regionListLines;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(make, {
            regions: regionListLines,
            strings: props.regionPickerStrings,
            selected: selectedRegion,
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(RegionIndicatorCountryDisplay_bs/* make */.S, {
                    text: props.regionIndicatorText,
                    regions: regionListLines,
                    selected: selectedRegion
                }),
                itemId: props.regionIndicatorTextId,
                elementCodename: props.regionIndicatorTextCodename
            }),
            onChange: props.onChange,
            className: IndexStyles_bs/* fullWidthSection */.wt
        }),
        itemId: props.regionModalItemId,
        elementCodename: props.regionModalCodename
    });
}
var RegionStrip = {
    make: RegionIndicators$RegionStrip
};
function GenericRegionPicker(Indicator) {
    var RegionIndicators$GenericRegionPicker = function RegionIndicators$GenericRegionPicker(props) {
        var state = LayoutDataContext_bs/* useContext */.qp(undefined);
        var regions = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.regions;
        }), []);
        var domainPostfix = belt_Result/* mapWithDefault */.k7(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), "", function(c) {
            return util_bs/* EnvUtil.getDomainPostfix */.i3.getDomainPostfix(c);
        });
        var regionIndex = belt_Option/* getWithDefault */.tj(belt_Array/* getIndexBy */._n(regions, function(region) {
            return removeTrailingSlash(region.url).endsWith(domainPostfix);
        }), 0);
        var match = react.useState(function() {
            return regionIndex;
        });
        var setSelectedRegion = match[1];
        var onChange = function onChange(selected) {
            curry._1(setSelectedRegion, function(param) {
                return selected;
            });
            var region = belt_Array/* get */.U2(regions, selected);
            var url = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(region, function(r) {
                if (isStg) {
                    return r.url.replace("https://www.prezzee", "https://stg.prezzee");
                } else {
                    return r.url;
                }
            }), "");
            var changeLocation = function cl(url) {
                window.location.assign(url);
            };
            return changeLocation(url);
        };
        var regionIndicator = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(s) {
            return s.dictionaryItems;
        }), function(s) {
            return s.app_yourcurrentshoppingregion;
        }), {
            value: "You're currently shopping in {0}",
            smartLink: Gql_DictionaryItems_Decoder_bs/* emptyDictionaryEntry.smartLink */.$d.smartLink
        }, function(param) {
            var smartLink = param.smartLink;
            var value = param.value;
            if (value === "") {
                return {
                    value: "You're currently shopping in {0}",
                    smartLink: smartLink
                };
            } else {
                return {
                    value: value,
                    smartLink: smartLink
                };
            }
        });
        var regionIndicatorText = regionIndicator.value;
        var match$1 = regionIndicator.smartLink;
        var regionModalItemId = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.smartLink.itemId;
        }), "");
        var regionModalCodename = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.smartLink.codename;
        }), "");
        var regionPickerTitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.title;
        }), "Change location");
        var regionPickerSubtitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.subtitle;
        }), "Want to send gift cards to family and friends in another country? Change your region below.");
        var regionPickerCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
            return r.location;
        }), function(r) {
            return r.ctaText;
        }), "Save location");
        var regionPickerStrings = {
            heading: regionPickerTitle,
            heading_subtext: regionPickerSubtitle,
            cta_button: regionPickerCtaText
        };
        var regionListLines = belt_Array/* map */.UI(regions, function(r) {
            var match = r.regionListLine;
            var smartLink = match.smartLink;
            var flag = match.flag;
            var currency = match.currency;
            var name = match.name;
            var el = jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(RegionListLineContent_bs/* make */.S, {
                    flag: flag,
                    name: name,
                    currency: currency
                }),
                itemId: smartLink.itemId,
                elementCodename: smartLink.codename
            });
            return {
                name: name,
                currency: currency,
                flag: flag,
                el: el
            };
        });
        return jsx_runtime.jsx(Indicator.make, {
            regionModalItemId: regionModalItemId,
            regionModalCodename: regionModalCodename,
            regionListLines: regionListLines,
            regionPickerStrings: regionPickerStrings,
            selectedRegion: match[0],
            regionIndicatorText: regionIndicatorText,
            regionIndicatorTextId: match$1.itemId,
            regionIndicatorTextCodename: match$1.codename,
            onChange: onChange
        });
    };
    return {
        make: RegionIndicators$GenericRegionPicker
    };
}
var RegionPicker;
var RegionIndicators_bs_RegionIndicatorStrip;
var RegionIndicators_bs_RegionIndicatorInline;
var RegionIndicatorCountryDisplay;
 /* isStg Not a pure module */ 


/***/ }),

/***/ 35705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ emptySmartLink; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
var emptySmartLink = {
    itemId: "",
    codename: ""
};
 /* No side effect */ 


/***/ }),

/***/ 35965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20859);
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _library_Button_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59037);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE




function ServerError(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("h1", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("SERVER ERROR"),
                className: "text-left text-3xl font-bold"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("p", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Error 500"),
                className: "text-left py-10 font-semibold"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("p", {
                children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("There's been an error. It's been reported to the site administrators via email and should be fixed shortly. Thank you for your patience. "),
                className: " text-left whitespace-pre-line"
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("a", {
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx("button", {
                    children: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ReactStuff.s */ .p_.s("Home"),
                    className: rescript_classnames_src_Cn_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S([
                        _library_Button_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .primaryStyle */ .vP,
                        "w-40 h-12 my-16"
                    ])
                }),
                className: "text-center",
                href: "/"
            })
        ],
        className: "text-center w-11/12 md:w-2/3 lg:w-1/2 mx-auto my-20"
    });
}
var make = ServerError;
 /* Util Not a pure module */ 


/***/ }),

/***/ 28848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hW": function() { return /* binding */ section_; },
/* harmony export */   "qi": function() { return /* binding */ section; },
/* harmony export */   "wt": function() { return /* binding */ fullWidthSection; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92592);
/* harmony import */ var _prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE



var section__0 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1300));
var section__1 = {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA("auto"),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR("auto"),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .CategoryTiles.tabletOrDesktop */ .KM.tabletOrDesktop, {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
                        tl: {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
                            tl: /* [] */ 0
                        }
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
};
var section_ = {
    hd: section__0,
    tl: section__1
};
var section = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, section_);
var fullWidthSection = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv, {
    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .maxWidth */ .kkr(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(1440)),
    tl: {
        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.375)),
        tl: {
            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.375)),
            tl: {
                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginLeft */ .oIA("auto"),
                tl: {
                    hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .marginRight */ .wzR("auto"),
                    tl: {
                        hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC2(_prezzee_ribbon_src_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .CategoryTiles.tabletOrDesktop */ .KM.tabletOrDesktop, {
                            hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingLeft */ .rv2(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
                            tl: {
                                hd: _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .paddingRight */ .WLm(_bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.875)),
                                tl: /* [] */ 0
                            }
                        }),
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
 /* section_ Not a pure module */ 


/***/ }),

/***/ 26396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25400);
/* harmony import */ var _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37110);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
// Generated by ReScript, PLEASE EDIT WITH CARE





function KontentContextProvider(props) {
    var render = props.render;
    var elementCodename = props.elementCodename;
    var itemId = props.itemId;
    var children = props.children;
    var itemId$1 = itemId !== undefined ? itemId : "";
    var elementCodename$1 = elementCodename !== undefined ? elementCodename : "";
    var render$1 = render !== undefined ? render : true;
    if (!render$1) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(children)
        });
    }
    if (itemId$1 === "") {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(children)
        });
    }
    var state = _utils_LayoutDataContext_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .useContext */ .qp(undefined);
    var kontentData = _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .flatMap */ .VS(state, function(s) {
        return s.kontentData;
    });
    if (kontentData !== undefined) {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_prezzee_ribbon_src_components_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Context.Provider.make */ ._.Provider.make, {
            children: children,
            itemId: itemId$1,
            elementCodename: elementCodename$1
        });
    } else {
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(children)
        });
    }
}
var make = KontentContextProvider;
 /* LayoutDataContext Not a pure module */ 


/***/ }),

/***/ 78788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "I6": function() { return /* binding */ reducer; },
/* harmony export */   "lJ": function() { return /* binding */ MyAccountContextProvider; },
/* harmony export */   "qp": function() { return /* binding */ useContext; }
/* harmony export */ });
/* unused harmony exports initValue, context */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
// Generated by ReScript, PLEASE EDIT WITH CARE

var initValue_0 = {
    notificaitonState: undefined
};
function initValue_1(param) {}
var initValue = [
    initValue_0,
    initValue_1
];
var context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(initValue);
function useContext(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
}
function reducer(param, action) {
    if (typeof action === "number") {
        return {
            notificaitonState: undefined
        };
    }
    if (action.TAG === /* SetSuccessNotification */ 0) {
        var match = action._0;
        return {
            notificaitonState: {
                title: match.title,
                description: match.description,
                notificationType: /* NotificationSuccess */ 2
            }
        };
    }
    var match$1 = action._0;
    return {
        notificaitonState: {
            title: match$1.title,
            description: match$1.description,
            notificationType: /* NotificationError */ 0
        }
    };
}
function makeProps(value, children, param) {
    return {
        value: value,
        children: children
    };
}
var make = context.Provider;
var MyAccountContextProvider = {
    makeProps: makeProps,
    make: make
};
var initialState = {
    notificaitonState: undefined
};
 /* context Not a pure module */ 


/***/ }),

/***/ 20086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ all; },
/* harmony export */   "Dk": function() { return /* binding */ more; },
/* harmony export */   "HK": function() { return /* binding */ categoriesByCountry; },
/* harmony export */   "_v": function() { return /* binding */ catDataToCatConf; },
/* harmony export */   "fj": function() { return /* binding */ getCategoryBySlug; },
/* harmony export */   "lM": function() { return /* binding */ countriesWithCountryCat; }
/* harmony export */ });
/* unused harmony exports usa, nz, uk, au, getScreensForCategory, categoryDataToCategoryConf, toCategoriesConf, slugs, getCategoryCodename */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74594);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_SortArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9618);
// Generated by ReScript, PLEASE EDIT WITH CARE




var usa_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var usa = {
    name: "USA",
    position: 1,
    slug: "us-cards",
    cms_id: "",
    screens: usa_screens,
    img: "/images/categories/usa.png"
};
var nz_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var nz = {
    name: "NZ",
    position: 2,
    slug: "nz-cards",
    cms_id: "",
    screens: nz_screens,
    img: "/images/categories/nz.png"
};
var uk_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var uk = {
    name: "UK",
    position: 3,
    slug: "uk-cards",
    cms_id: "",
    screens: uk_screens,
    img: "/images/categories/uk.png"
};
var au_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var au = {
    name: "AU",
    position: 4,
    slug: "au-cards",
    cms_id: "",
    screens: au_screens,
    img: "/images/categories/au.png"
};
var all_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var all = {
    name: "Show All",
    position: 200,
    slug: "all",
    cms_id: "",
    screens: all_screens,
    img: "/images/icon_all.svg"
};
var more_screens = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
var more = {
    name: "More",
    position: 100,
    slug: "more",
    cms_id: "",
    screens: more_screens,
    img: "/images/categories/more.svg"
};
function getScreensForCategory(position) {
    if ((position + 1 | 0) <= 2) {
        return [
            "sm",
            "md",
            "lg",
            "xl",
            "xxl"
        ];
    } else if ((position + 1 | 0) === 3) {
        return [
            "md",
            "lg",
            "xl",
            "xxl"
        ];
    } else if ((position + 1 | 0) <= 6) {
        return [
            "lg",
            "xl",
            "xxl"
        ];
    } else if ((position + 1 | 0) <= 9) {
        return [
            "xl",
            "xxl"
        ];
    } else {
        return [
            "xxl"
        ];
    }
}
function categoryDataToCategoryConf(cData) {
    return {
        name: cData.name,
        position: cData.position,
        slug: cData.slug,
        cms_id: cData.cms_id,
        screens: getScreensForCategory(cData.position),
        img: cData.image
    };
}
var countriesWithCountryCat = [
    "UK Cards",
    "NZ Cards",
    "US Cards",
    "AU Cards"
];
function catDataToCatConf(cats) {
    var cats$1 = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .keep */ .Cn(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI(cats, categoryDataToCategoryConf), function(c) {
        return !_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .some */ .G(countriesWithCountryCat, function(country) {
            return country === c.name;
        });
    });
    _rescript_std_lib_es6_belt_SortArray_js__WEBPACK_IMPORTED_MODULE_3__/* .stableSortInPlaceBy */ .mC(cats$1, function(x, y) {
        return x.position - y.position | 0;
    });
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .concat */ .zo([
        all
    ], cats$1);
}
function toCategoriesConf(categoriesData) {
    return catDataToCatConf(categoriesData.results);
}
var match = _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.currentCountry */ .i3.currentCountry;
var categoriesByCountry;
if (match.TAG === /* Ok */ 0) {
    switch(match._0){
        case /* GreatBritain */ 1:
            categoriesByCountry = [
                au,
                usa,
                nz
            ];
            break;
        case /* UnitedStates */ 2:
            categoriesByCountry = [
                au,
                uk,
                nz
            ];
            break;
        case /* NewZealand */ 3:
            categoriesByCountry = [
                au,
                usa,
                uk
            ];
            break;
        case /* Australia */ 0:
        case /* Canada */ 4:
            categoriesByCountry = [
                usa,
                nz,
                uk
            ];
            break;
    }
} else {
    categoriesByCountry = [
        usa,
        nz,
        uk
    ];
}
function slugs(categoriesByProductType) {
    return Belt_Array.map(Belt_Array.keep($$Array.append(categoriesByProductType, categoriesByCountry), function(c) {
        return c.slug !== "all";
    }), function(c) {
        return c.slug;
    });
}
function getCategoryBySlug(slug, categoriesByProductType) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .keep */ .Cn(_rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__/* .append */ .R3(categoriesByProductType, categoriesByCountry), function(c) {
        return c.slug === slug;
    }), 0);
}
function getCategoryCodename(categories, slug) {
    var item = getCategoryBySlug(slug, categories);
    if (item !== undefined) {
        return item.cms_id;
    }
}
 /* categoriesByCountry Not a pure module */ 


/***/ }),

/***/ 43217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bm": function() { return /* binding */ buildVersion; },
/* harmony export */   "YI": function() { return /* binding */ magicUserAgentHeader; }
/* harmony export */ });
/* unused harmony export regenerateAfter */
// Generated by ReScript, PLEASE EDIT WITH CARE
var buildVersion = "v2025/11/05_09:18:48_NZ" || 0;
var regenerateAfter = 60;
var magicUserAgentHeader = "Prezzee Frontend 2.0 (FWKNqc0E)";
 /* buildVersion Not a pure module */ 


/***/ }),

/***/ 35248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vo": function() { return /* binding */ AuthContext; },
  "Ho": function() { return /* binding */ AuthProvider; },
  "ZP": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/api/queries/index.ts + 34 modules
var queries = __webpack_require__(22638);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/components/lib/index.js
var lib = __webpack_require__(34906);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/@prezzee/tokens/lib/index.js
var tokens_lib = __webpack_require__(53126);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(42283);
;// CONCATENATED MODULE: ./src/components/MfaDialog.tsx








var style = {
    container: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding:", tokens_lib.spacing.spacing14, " ", tokens_lib.spacing.spacing08, ";text-align:center;& > *{margin-top:", tokens_lib.spacing.spacing05, ";}h4{color:", tokens_lib.colors.red400, ";}"),
    form: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("& > *{margin-top:", tokens_lib.spacing.spacing05, ";}"),
    input: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:75%;"),
    helperText: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("a{text-decoration:underline;&:hover{text-decoration:none;}}")
};
var MfaDialog = function(param) {
    var onSubmit = param.onSubmit, onSignOut = param.onSignOut, isLoading = param.isLoading;
    var ref;
    var error = useAuth().error;
    var form = (0,index_esm/* useForm */.cI)({
        mode: "onBlur",
        reValidateMode: "onBlur"
    });
    var _onSubmit = function(param) {
        var mfaCode = param.mfaCode;
        if (onSubmit) {
            onSubmit(mfaCode);
        }
        form.reset();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Dialog, {
        open: true,
        "aria-labelledby": "mfa-dialog-title",
        "aria-describedby": "mfa-dialog-description",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            className: style.container,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                    align: "center",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Typography, {
                            id: "mfa-dialog-title",
                            variant: "h4",
                            children: "Security Code"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Typography, {
                            id: "mfa-dialog-description",
                            children: "Please enter the security code we've just sent to you via SMS"
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("form", {
                    onSubmit: form.handleSubmit(_onSubmit),
                    className: style.form,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.TextField, {
                                    className: style.input,
                                    name: "mfaCode",
                                    label: "Security code",
                                    error: ((ref = form.errors.mfaCode) === null || ref === void 0 ? void 0 : ref.message) || (error === null || error === void 0 ? void 0 : error.message),
                                    inputRef: form.register({
                                        required: {
                                            value: true,
                                            message: "Please enter a security code."
                                        },
                                        pattern: {
                                            value: new RegExp("^(\\s*\\d{6}\\s*)(,\\s*\\d{6}\\s*)*,?\\s*$"),
                                            message: "Please enter a valid security code."
                                        }
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                    type: "submit",
                                    isLoading: isLoading,
                                    children: "Validate"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                            href: "/logout",
                            prefetch: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                                variant: "text",
                                color: "red.400",
                                onClick: function() {
                                    return onSignOut === null || onSignOut === void 0 ? void 0 : onSignOut();
                                },
                                children: "Sign out"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Row, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(lib.Col, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(lib.Typography, {
                            variant: "body2",
                            className: style.helperText,
                            children: [
                                "Need help? Please contact us at",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                                    href: "mailto:help@prezzee.com?subject=Issue with 2FA on website browser",
                                    children: "help@prezzee.com"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_MfaDialog = (MfaDialog);

// EXTERNAL MODULE: ./src/utils/authUtils.ts
var authUtils = __webpack_require__(89090);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/api/queries/getAccountDetails.ts
var getAccountDetails = __webpack_require__(61760);
;// CONCATENATED MODULE: ./src/hooks/useAccountDetailsQuery.ts



var useAccountDetailsQuery = function(options) {
    return (0,useQuery/* useQuery */.a)((0,_object_spread/* default */.Z)({
        queryKey: [
            "customer",
            "account"
        ],
        queryFn: function() {
            return (0,getAccountDetails/* default */.Z)();
        },
        staleTime: 10000 * 60,
        cacheTime: 10000 * 60,
        retry: false
    }, options));
};

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(31611);
// EXTERNAL MODULE: ./src/api/helpers.ts + 72 modules
var helpers = __webpack_require__(60693);
;// CONCATENATED MODULE: ./src/contexts/AuthContext.tsx

















var getWallet = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var customer;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queries/* getCustomerData */.ck()
                    ];
                case 1:
                    customer = _state.sent();
                    if (!customer) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        customer.wallet
                    ];
            }
        });
    });
    return function getWallet() {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Transforms customer data into user data (Mainly to support old auth context).
 * @param customer customer data from the server
 * @returns user data to be stored in the context
 */ function customerToUser(customer) {
    return {
        uid: (customer === null || customer === void 0 ? void 0 : customer.customerUid) || null,
        firstName: customer === null || customer === void 0 ? void 0 : customer.firstName,
        lastName: customer === null || customer === void 0 ? void 0 : customer.lastName,
        phoneNumber: customer === null || customer === void 0 ? void 0 : customer.phone,
        email: customer === null || customer === void 0 ? void 0 : customer.email
    };
}
var AuthContext = /*#__PURE__*/ (0,react.createContext)({});
function AuthProvider(param) {
    var children = param.children;
    var ref = (0,useSegment/* default */.Z)(), signedIn = ref.signedIn, signedUp = ref.signedUp;
    var ref1 = (0,react.useState)(), user = ref1[0], setUser = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)({
        required: false,
        callback: undefined,
        loading: false
    }), mfa = ref4[0], setMfa = ref4[1];
    var ref5 = (0,react.useState)(null), accessToken = ref5[0], setAccessToken = ref5[1];
    var ref6 = (0,react.useState)(undefined), callbackState = ref6[0], setCallback = ref6[1];
    var ref7 = useAccountDetailsQuery({
        enabled: !!accessToken,
        retry: false
    }), data = ref7.data, status = ref7.status, customerError = ref7.error;
    var client = (0,QueryClientProvider/* useQueryClient */.NL)();
    var countRef = (0,react.useRef)(0);
    var cachedData = null;
    var getCustomerWallet = function() {
        return getWallet().then(function(wallet) {
            return wallet;
        });
    };
    (0,react.useEffect)(function() {
        var userCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
        if (status === "success") {
            setLoading(false);
            if (data) {
                var ref;
                logger/* default.info */.ZP.info({
                    message: "Customer data fetched successfully",
                    context: "AuthContext"
                }, null, [
                    "local",
                    "development",
                    "staging"
                ]);
                var decryptedUser = (0,authUtils/* decryptUserCookie */.x)(userCookie);
                if (!user && !(decryptedUser === null || decryptedUser === void 0 ? void 0 : (ref = decryptedUser.userDetails) === null || ref === void 0 ? void 0 : ref.uid)) {
                    var userDetails = customerToUser(data);
                    setUser(userDetails);
                    (0,AuthUtils_bs/* saveTokenCookie */.iB)({
                        userDetails: userDetails,
                        token: accessToken,
                        masquerade: false
                    });
                    setError(null);
                }
                if (callbackState) {
                    logger/* default.info */.ZP.info({
                        message: "Customer data fetched successfully and callback is run",
                        context: "AuthContext"
                    }, null, [
                        "local",
                        "development",
                        "staging"
                    ]);
                    callbackState(data);
                    setCallback(undefined);
                }
            }
        }
    }, [
        data,
        status,
        callbackState
    ]);
    (0,react.useEffect)(function() {
        var timeout = null;
        if (customerError) {
            if (customerError.message === queries/* customerDataErrors.mfaRequired */.W6.mfaRequired) {
                setMfa(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        required: true
                    });
                });
            } else if (customerError.message === queries/* customerDataErrors.tokenMissing */.W6.tokenMissing) {
                //AccessToken exists but may not be set on the cookie yet. This is in place to handle that unlikely race conditions
                if (accessToken && countRef.current < 3) {
                    logger/* default.info */.ZP.info({
                        context: "AuthContext",
                        retries: countRef.current,
                        message: "Access token exists in state but no cookie. Retrying..."
                    });
                    countRef.current++;
                    timeout = setTimeout(function() {
                        //Timeout used to give time for the cookie to be set
                        client.resetQueries({
                            queryKey: [
                                "customer"
                            ]
                        });
                    }, 1000);
                } else {
                    //No access token exists or exceeded number of retries
                    logger/* default.info */.ZP.info({
                        context: "AuthContext",
                        retries: countRef.current,
                        message: "Access token exists in state but no cookie. Retry Failed"
                    });
                    reset();
                    setError(customerError);
                }
            } else {
                reset();
                setError(customerError);
                logger/* default.error */.ZP.error({
                    message: "Customer API error",
                    err: customerError,
                    context: "AuthContext"
                });
            }
            setLoading(false);
        }
        return function() {
            if (timeout) clearTimeout(timeout);
        };
    }, [
        customerError
    ]);
    (0,react.useEffect)(function() {
        if (accessToken === undefined) {
            logger/* default.info */.ZP.info({
                context: "AuthContext",
                message: "Access token is undefined. Resetting queries"
            }, null, [
                "local",
                "development",
                "staging"
            ]);
            client.resetQueries({
                queryKey: [
                    "customer"
                ]
            });
        }
    }, [
        accessToken
    ]);
    var userSignIn = function(accessToken, callback) {
        if (accessToken) {
            (0,AuthUtils_bs/* saveTokenCookie */.iB)({
                userDetails: null,
                token: accessToken,
                masquerade: false
            });
            //This checks for MFA and sets the callback if needed. Ideally this is removed once MFA is checked on account details.
            queries/* getAccountDetails */.jg().then(function() {
                setCallback(function() {
                    return callback;
                });
                setAccessToken(accessToken);
            }).catch(function(error) {
                if (error.message == queries/* customerDataErrors.mfaRequired */.W6.mfaRequired) {
                    setMfa({
                        required: true,
                        callback: callback
                    });
                } else {
                    throw error;
                }
            });
        } else {
            reset();
            setError(new Error("Missing token on sign in"));
            logger/* default.error */.ZP.error({
                message: "error: missing token on sign in",
                context: "AuthContext"
            });
        }
    };
    var login = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(email, password, callback) {
            var loginRes, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setMfa({
                            required: false,
                            callback: callback
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            queries/* login */.x4(email, password)
                        ];
                    case 2:
                        loginRes = _state.sent();
                        if (!(loginRes === null || loginRes === void 0 ? void 0 : loginRes.accessToken)) {
                            throw new Error("Access token not found on login response");
                        }
                        userSignIn(loginRes === null || loginRes === void 0 ? void 0 : loginRes.accessToken, function(customer) {
                            var ref;
                            callback ? callback(customer) : null;
                            Segment_bs/* identifyWithContext */.Dx(customer === null || customer === void 0 ? void 0 : customer.customerUid, {
                                user_type: "consumer",
                                first_name: customer === null || customer === void 0 ? void 0 : customer.firstName,
                                last_name: customer === null || customer === void 0 ? void 0 : customer.lastName,
                                phone: customer === null || customer === void 0 ? void 0 : customer.phone,
                                email: customer === null || customer === void 0 ? void 0 : customer.email,
                                id: customer === null || customer === void 0 ? void 0 : customer.customerUid,
                                username: customer === null || customer === void 0 ? void 0 : customer.email
                            });
                            signedIn({
                                username: customer === null || customer === void 0 ? void 0 : customer.email,
                                signin_type: "gift_open"
                            });
                            (ref = window.sardineContext) === null || ref === void 0 ? void 0 : ref.updateConfig({
                                userIdHash: customer === null || customer === void 0 ? void 0 : customer.customerUid,
                                flow: "user_login"
                            });
                        });
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        logger/* default.error */.ZP.error({
                            message: "Login error",
                            err: err,
                            context: "AuthContext"
                        });
                        throw err;
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function login(email, password, callback) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMfaSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(code) {
            var userCookie, decryptedUser, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setMfa(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                loading: true
                            });
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            queries/* validateMfaToken */.gl(code)
                        ];
                    case 2:
                        _state.sent();
                        client.invalidateQueries({
                            queryKey: [
                                "customer"
                            ]
                        });
                        userCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
                        if (userCookie) {
                            decryptedUser = (0,authUtils/* decryptUserCookie */.x)(userCookie);
                            userSignIn(decryptedUser.token, function(customer) {
                                mfa.callback(customer);
                                Segment_bs/* identifyWithContext */.Dx(customer === null || customer === void 0 ? void 0 : customer.customerUid, {
                                    user_type: "consumer",
                                    first_name: customer === null || customer === void 0 ? void 0 : customer.firstName,
                                    last_name: customer === null || customer === void 0 ? void 0 : customer.lastName,
                                    phone: customer === null || customer === void 0 ? void 0 : customer.phone,
                                    email: customer === null || customer === void 0 ? void 0 : customer.email,
                                    id: customer === null || customer === void 0 ? void 0 : customer.customerUid,
                                    username: customer === null || customer === void 0 ? void 0 : customer.email
                                });
                                setMfa({
                                    required: false,
                                    callback: undefined,
                                    loading: false
                                });
                            });
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        setMfa(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                loading: false
                            });
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMfaSubmit(code) {
            return _ref.apply(this, arguments);
        };
    }();
    var signUp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload, signUpInstanceId, emailSubscription) {
            var signUpResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            queries/* register */.z2(payload)
                        ];
                    case 1:
                        signUpResponse = _state.sent();
                        userSignIn(signUpResponse.accessToken, function(customer) {
                            Segment_bs/* identifyWithContext */.Dx(customer === null || customer === void 0 ? void 0 : customer.customerUid, {
                                user_type: "consumer",
                                signup_type: "gift_open",
                                first_name: customer === null || customer === void 0 ? void 0 : customer.firstName,
                                last_name: customer === null || customer === void 0 ? void 0 : customer.lastName,
                                phone: customer === null || customer === void 0 ? void 0 : customer.phone,
                                email: customer === null || customer === void 0 ? void 0 : customer.email,
                                id: customer === null || customer === void 0 ? void 0 : customer.customerUid,
                                username: customer === null || customer === void 0 ? void 0 : customer.email,
                                email_subscription_braze: emailSubscription ? "subscribed" : "unsubscribed"
                            });
                            signedUp({
                                created_at: new Date().toISOString(),
                                user_type: "consumer",
                                signup_type: "gift_open",
                                signup_instance_id: signUpInstanceId,
                                first_name: customer === null || customer === void 0 ? void 0 : customer.firstName,
                                last_name: customer === null || customer === void 0 ? void 0 : customer.lastName,
                                phone: customer === null || customer === void 0 ? void 0 : customer.phone,
                                email: customer === null || customer === void 0 ? void 0 : customer.email,
                                username: customer === null || customer === void 0 ? void 0 : customer.email
                            });
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function signUp(payload, signUpInstanceId, emailSubscription) {
            return _ref.apply(this, arguments);
        };
    }();
    var reset = function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _resetAnalytics = ref.resetAnalytics, resetAnalytics = _resetAnalytics === void 0 ? false : _resetAnalytics;
        var ref1;
        js_cookie_default().remove(AuthUtils_bs/* cookieName */.YN, {
            domain: (0,AuthUtils_bs/* getCookieDomain */.yT)()
        });
        js_cookie_default().remove("masquerade", {
            domain: (0,AuthUtils_bs/* getCookieDomain */.yT)()
        });
        js_cookie_default().remove("sessionid", {
            domain: (0,AuthUtils_bs/* getCookieDomain */.yT)()
        });
        if (resetAnalytics) Segment_bs/* reset */.mc(undefined);
        setAccessToken(undefined);
        setUser(undefined);
        setError(null);
        setLoading(false);
        client.resetQueries({
            queryKey: [
                "customer"
            ]
        });
        var sessionId = (0,helpers/* getSessionIdToken */.qB)({
            updateConfig: false,
            resetToken: true
        });
        (ref1 = window.sardineContext) === null || ref1 === void 0 ? void 0 : ref1.updateConfig({
            sessionKey: sessionId,
            userIdHash: null,
            flow: "user_logout"
        });
        countRef.current = 0;
    };
    function logout() {
        return _logout.apply(this, arguments);
    }
    function _logout() {
        _logout = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            queries/* signOut */.w7()
                        ];
                    case 1:
                        _state.sent();
                        reset();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        logger/* default.error */.ZP.error({
                            message: "error: unable to sign out user",
                            err: error,
                            journey: "Sign Out",
                            context: "AuthContext"
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _logout.apply(this, arguments);
    }
    var authenticateUser = (0,react.useCallback)(function() {
        var userCookie = js_cookie_default().get(AuthUtils_bs/* cookieName */.YN);
        if (userCookie) {
            var decryptedUser = (0,authUtils/* decryptUserCookie */.x)(userCookie);
            if (decryptedUser === null || decryptedUser === void 0 ? void 0 : decryptedUser.token) {
                setAccessToken(decryptedUser.token);
                setUser(decryptedUser.userDetails);
            } else {
                reset();
            }
        } else {
            reset();
        }
    }, []);
    (0,react.useEffect)(function() {
        authenticateUser();
    }, [
        authenticateUser
    ]);
    var memoedValue = (0,react.useMemo)(function() {
        return {
            user: user,
            loading: loading,
            error: error,
            login: login,
            signUp: signUp,
            logout: logout,
            reset: reset,
            mfa: mfa,
            updateMfa: setMfa,
            getWallet: getCustomerWallet,
            authenticateUser: authenticateUser
        };
    }, [
        user,
        loading,
        error,
        login,
        mfa
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AuthContext.Provider, {
        value: memoedValue,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(react.Fragment, {
            children: [
                children,
                mfa.required && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(components_MfaDialog, {
                    onSubmit: handleMfaSubmit,
                    onSignOut: function() {
                        return setMfa({
                            required: false,
                            callback: undefined
                        });
                    },
                    isLoading: mfa.loading
                })
            ]
        })
    });
}
function useAuth() {
    return (0,react.useContext)(AuthContext);
}


/***/ }),

/***/ 33162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZR": function() { return /* binding */ useConfig; },
/* harmony export */   "iV": function() { return /* binding */ ConfigProvider; }
/* harmony export */ });
/* unused harmony export ConfigContext */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var ConfigContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var ConfigProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfigContext.Provider, {
        value: value,
        children: children
    });
};
var useConfig = function() {
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ConfigContext);
    return ctx;
};


/***/ }),

/***/ 5641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ ConsumerFeaturesProvider; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/GrowthBookContext.tsx + 6 modules
var GrowthBookContext = __webpack_require__(14872);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/contexts/AuthContext.tsx + 2 modules
var AuthContext = __webpack_require__(35248);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./src/hooks/useHashedValue.tsx



// https://stackoverflow.com/a/48161723
var sha256 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(message) {
        var msgBuffer, hashBuffer, hashArray, hashHex;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!crypto) return [
                        2
                    ];
                    msgBuffer = new TextEncoder().encode(message);
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", msgBuffer)
                    ];
                case 1:
                    hashBuffer = _state.sent();
                    hashArray = Array.from(new Uint8Array(hashBuffer));
                    hashHex = hashArray.map(function(b) {
                        return b.toString(16).padStart(2, "0");
                    }).join("");
                    return [
                        2,
                        hashHex
                    ];
            }
        });
    });
    return function sha256(message) {
        return _ref.apply(this, arguments);
    };
}();
var useHashedValue = function(value) {
    var ref = (0,react.useState)(), hash = ref[0], setHash = ref[1];
    (0,react.useEffect)(function() {
        if (value == undefined || "object" === "undefined" || hash) return;
        sha256(value).then(function(v) {
            setHash(v);
        });
    }, [
        value
    ]);
    return hash;
};
/* harmony default export */ var hooks_useHashedValue = (useHashedValue);

;// CONCATENATED MODULE: ./src/contexts/ConsumerFeaturesProvider.tsx
/* provided dependency */ var process = __webpack_require__(34155);






var ConsumerFeaturesProvider = function(param) {
    var children = param.children;
    var ref;
    var auth = (0,AuthContext/* default */.ZP)();
    var featureDefinitions = useFeatureDefinitions();
    var deviceId = js_cookie_default().get("fingerprint-pz");
    var country = "NZ";
    var emailHash = hooks_useHashedValue((ref = auth.user) === null || ref === void 0 ? void 0 : ref.email.toLowerCase());
    var attributes = (0,react.useMemo)(function() {
        return {
            emailHashed: emailHash === null || emailHash === void 0 ? void 0 : emailHash.slice(0, 16),
            deviceId: deviceId,
            country: country
        };
    }, [
        deviceId,
        country,
        emailHash
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GrowthBookContext/* GrowthbookFeatureProvider */.mY, {
        enableDevMode: process.env.NEXT_PUBLIC_GROWTHBOOK_DEV_MODE === "true",
        features: featureDefinitions,
        attributes: attributes,
        children: children
    });
};
var useFeatureDefinitions = function() {
    var ref = (0,react.useState)(), featureDefinitions = ref[0], setFeatureDefinitions = ref[1];
    var growthbookUrl =  false ? 0 : "https://features.prezzeeapis.com/features/production-general" || 0; // As we're unable to uses branch level variables hardcoding staging for
    (0,react.useEffect)(function() {
        fetch(growthbookUrl).then(function(response) {
            return response.json();
        }).then(function(param) {
            var features = param.features;
            setFeatureDefinitions(features);
        });
    }, []);
    return featureDefinitions;
};


/***/ }),

/***/ 80602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_b": function() { return /* binding */ useErrorModal; },
/* harmony export */   "ao": function() { return /* binding */ ErrorModalProvider; }
/* harmony export */ });
/* unused harmony export ErrorCodes */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var ErrorCodes;
(function(ErrorCodes) {
    ErrorCodes["DEFAULT"] = "000";
    ErrorCodes["ERR_OUT_OF_STOCK"] = "532";
    ErrorCodes["ERR_OUT_OF_STOCK_KEEP_LOWER"] = "532-Keep";
    ErrorCodes["ERR_OUT_OF_STOCK_SWAP_LOWER"] = "532-Swap";
})(ErrorCodes || (ErrorCodes = {}));
var ErrorModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
function useErrorModal() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ErrorModalContext);
    if (!context) {
        throw new Error("useErrorModal must be used within an ErrorModalProvider");
    }
    return context;
}
function ErrorModalProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), errorMessage = ref[0], setErrorMessage = ref[1];
    var _obj;
    var errorMessages = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ErrorCodes.ERR_OUT_OF_STOCK, {
        title: "This brand is temporarily unavailable",
        message: "Go back and try again tomorrow or, alternatively, swap it for another brand of your choice.",
        primaryButtonText: "Choose another brand",
        secondaryButtonText: "Go back"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ErrorCodes.ERR_OUT_OF_STOCK_KEEP_LOWER, {
        title: "Card value is currently unavailable",
        message: "You can keep a smaller amount of it, swap it for another brand card or close this window and try again later.",
        primaryButtonText: "Swap it for another brand ",
        secondaryButtonText: "Keep a smaller amount"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ErrorCodes.ERR_OUT_OF_STOCK_SWAP_LOWER, {
        title: "Card value isn’t available",
        message: "This brand card is only available at a lower value. You can swap a smaller amount and keep the remaining balance on your original card, or choose another brand.",
        primaryButtonText: "Swap it for another brand ",
        secondaryButtonText: "Swap a smaller amount"
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ErrorCodes.DEFAULT, {
        title: "We couldn’t complete your swap",
        message: "Try swapping your card for another brand, or, alternatively, go back and try again later.",
        primaryButtonText: "Choose another brand",
        secondaryButtonText: "Go back"
    }), _obj);
    var showErrorModal = function(error) {
        var message = errorMessages[ErrorCodes.DEFAULT];
        if (error.errorCode && error.errorCode in errorMessages) {
            message = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, errorMessages[error.errorCode], error.message);
        } else if (error["message"]) {
            message = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, message, error.message);
        }
        setErrorMessage(message);
    };
    var hideErrorModal = function() {
        setErrorMessage(null);
    };
    var value = {
        errorMessage: errorMessage,
        showErrorModal: showErrorModal,
        hideErrorModal: hideErrorModal
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ErrorModalContext.Provider, {
        value: value,
        children: children
    });
}


/***/ }),

/***/ 14872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mY": function() { return /* binding */ GrowthbookFeatureProvider; },
  "$x": function() { return /* binding */ useGrowthBookReady; },
  "ej": function() { return /* binding */ useGrowthbookFeatureValue; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/node_modules/dom-mutator/dist/dom-mutator.esm.js
var validAttributeName = /^[a-zA-Z:_][a-zA-Z0-9:_.-]*$/;
var nullController = {
  revert: function revert() {}
};
var dom_mutator_esm_elements = /*#__PURE__*/new Map();
var mutations = /*#__PURE__*/new Set();

function getObserverInit(attr) {
  return attr === 'html' ? {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true
  } : {
    childList: false,
    subtree: false,
    attributes: true,
    attributeFilter: [attr]
  };
}

function getElementRecord(element) {
  var record = dom_mutator_esm_elements.get(element);

  if (!record) {
    record = {
      element: element,
      attributes: {}
    };
    dom_mutator_esm_elements.set(element, record);
  }

  return record;
}

function createElementPropertyRecord(el, attr, getCurrentValue, setValue, mutationRunner) {
  var currentValue = getCurrentValue(el);
  var record = {
    isDirty: false,
    originalValue: currentValue,
    virtualValue: currentValue,
    mutations: [],
    el: el,
    observer: new MutationObserver(function () {
      var currentValue = getCurrentValue(el);
      if (currentValue === record.virtualValue) return;
      record.originalValue = currentValue;
      mutationRunner(record);
    }),
    mutationRunner: mutationRunner,
    setValue: setValue,
    getCurrentValue: getCurrentValue
  };
  record.observer.observe(el, getObserverInit(attr));
  return record;
}

function queueIfNeeded(val, record) {
  var currentVal = record.getCurrentValue(record.el);
  record.virtualValue = val;

  if (val && typeof val !== 'string') {
    if (!currentVal || val.parentNode !== currentVal.parentNode || val.insertBeforeNode !== currentVal.insertBeforeNode) {
      record.isDirty = true;
      queueDOMUpdates();
    }
  } else if (val !== currentVal) {
    record.isDirty = true;
    queueDOMUpdates();
  }
}

function htmlMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(getTransformedHTML(val), record);
}

function classMutationRunner(record) {
  var val = new Set(record.originalValue.split(/\s+/).filter(Boolean));
  record.mutations.forEach(function (m) {
    return m.mutate(val);
  });
  queueIfNeeded(Array.from(val).filter(Boolean).join(' '), record);
}

function attrMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    return val = m.mutate(val);
  });
  queueIfNeeded(val, record);
}

function _loadDOMNodes(_ref) {
  var parentSelector = _ref.parentSelector,
      insertBeforeSelector = _ref.insertBeforeSelector;
  var parentNode = document.querySelector(parentSelector);
  if (!parentNode) return null;
  var insertBeforeNode = insertBeforeSelector ? document.querySelector(insertBeforeSelector) : null;
  if (insertBeforeSelector && !insertBeforeNode) return null;
  return {
    parentNode: parentNode,
    insertBeforeNode: insertBeforeNode
  };
}

function positionMutationRunner(record) {
  var val = record.originalValue;
  record.mutations.forEach(function (m) {
    var selectors = m.mutate();

    var newNodes = _loadDOMNodes(selectors);

    val = newNodes || val;
  });
  queueIfNeeded(val, record);
}

var getHTMLValue = function getHTMLValue(el) {
  return el.innerHTML;
};

var setHTMLValue = function setHTMLValue(el, value) {
  return el.innerHTML = value;
};

function getElementHTMLRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.html) {
    elementRecord.html = createElementPropertyRecord(element, 'html', getHTMLValue, setHTMLValue, htmlMutationRunner);
  }

  return elementRecord.html;
}

var getElementPosition = function getElementPosition(el) {
  return {
    parentNode: el.parentElement,
    insertBeforeNode: el.nextElementSibling
  };
};

var setElementPosition = function setElementPosition(el, value) {
  value.parentNode.insertBefore(el, value.insertBeforeNode);
};

function getElementPositionRecord(element) {
  var elementRecord = getElementRecord(element);

  if (!elementRecord.position) {
    elementRecord.position = createElementPropertyRecord(element, 'position', getElementPosition, setElementPosition, positionMutationRunner);
  }

  return elementRecord.position;
}

var setClassValue = function setClassValue(el, val) {
  return val ? el.className = val : el.removeAttribute('class');
};

var getClassValue = function getClassValue(el) {
  return el.className;
};

function getElementClassRecord(el) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.classes) {
    elementRecord.classes = createElementPropertyRecord(el, 'class', getClassValue, setClassValue, classMutationRunner);
  }

  return elementRecord.classes;
}

var getAttrValue = function getAttrValue(attrName) {
  return function (el) {
    var _el$getAttribute;

    return (_el$getAttribute = el.getAttribute(attrName)) != null ? _el$getAttribute : null;
  };
};

var setAttrValue = function setAttrValue(attrName) {
  return function (el, val) {
    return val !== null ? el.setAttribute(attrName, val) : el.removeAttribute(attrName);
  };
};

function getElementAttributeRecord(el, attr) {
  var elementRecord = getElementRecord(el);

  if (!elementRecord.attributes[attr]) {
    elementRecord.attributes[attr] = createElementPropertyRecord(el, attr, getAttrValue(attr), setAttrValue(attr), attrMutationRunner);
  }

  return elementRecord.attributes[attr];
}

function deleteElementPropertyRecord(el, attr) {
  var element = dom_mutator_esm_elements.get(el);
  if (!element) return;

  if (attr === 'html') {
    var _element$html, _element$html$observe;

    (_element$html = element.html) == null ? void 0 : (_element$html$observe = _element$html.observer) == null ? void 0 : _element$html$observe.disconnect();
    delete element.html;
  } else if (attr === 'class') {
    var _element$classes, _element$classes$obse;

    (_element$classes = element.classes) == null ? void 0 : (_element$classes$obse = _element$classes.observer) == null ? void 0 : _element$classes$obse.disconnect();
    delete element.classes;
  } else if (attr === 'position') {
    var _element$position, _element$position$obs;

    (_element$position = element.position) == null ? void 0 : (_element$position$obs = _element$position.observer) == null ? void 0 : _element$position$obs.disconnect();
    delete element.position;
  } else {
    var _element$attributes, _element$attributes$a, _element$attributes$a2;

    (_element$attributes = element.attributes) == null ? void 0 : (_element$attributes$a = _element$attributes[attr]) == null ? void 0 : (_element$attributes$a2 = _element$attributes$a.observer) == null ? void 0 : _element$attributes$a2.disconnect();
    delete element.attributes[attr];
  }
}

var transformContainer;

function getTransformedHTML(html) {
  if (!transformContainer) {
    transformContainer = document.createElement('div');
  }

  transformContainer.innerHTML = html;
  return transformContainer.innerHTML;
}

function setPropertyValue(el, attr, m) {
  if (!m.isDirty) return;
  m.isDirty = false;
  var val = m.virtualValue;

  if (!m.mutations.length) {
    deleteElementPropertyRecord(el, attr);
  }

  m.setValue(el, val);
}

var raf = false;

function setValue(m, el) {
  m.html && setPropertyValue(el, 'html', m.html);
  m.classes && setPropertyValue(el, 'class', m.classes);
  m.position && setPropertyValue(el, 'position', m.position);
  Object.keys(m.attributes).forEach(function (attr) {
    setPropertyValue(el, attr, m.attributes[attr]);
  });
}

function setValues() {
  raf = false;
  dom_mutator_esm_elements.forEach(setValue);
}

function queueDOMUpdates() {
  if (!raf) {
    raf = true;
    requestAnimationFrame(setValues);
  }
} // find or create ElementPropertyRecord, add mutation to it, then run


function startMutating(mutation, element) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(element);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(element);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(element, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(element);
  }

  if (!record) return;
  record.mutations.push(mutation);
  record.mutationRunner(record);
} // get (existing) ElementPropertyRecord, remove mutation from it, then run


function stopMutating(mutation, el) {
  var record = null;

  if (mutation.kind === 'html') {
    record = getElementHTMLRecord(el);
  } else if (mutation.kind === 'class') {
    record = getElementClassRecord(el);
  } else if (mutation.kind === 'attribute') {
    record = getElementAttributeRecord(el, mutation.attribute);
  } else if (mutation.kind === 'position') {
    record = getElementPositionRecord(el);
  }

  if (!record) return;
  var index = record.mutations.indexOf(mutation);
  if (index !== -1) record.mutations.splice(index, 1);
  record.mutationRunner(record);
} // maintain list of elements associated with mutation


function refreshElementsSet(mutation) {
  var existingElements = new Set(mutation.elements);
  var newElements = new Set();
  var matchingElements = document.querySelectorAll(mutation.selector);
  matchingElements.forEach(function (el) {
    newElements.add(el);

    if (!existingElements.has(el)) {
      mutation.elements.add(el);
      startMutating(mutation, el);
    }
  });
  existingElements.forEach(function (el) {
    if (!newElements.has(el)) {
      mutation.elements["delete"](el);
      stopMutating(mutation, el);
    }
  });
}

function revertMutation(mutation) {
  mutation.elements.forEach(function (el) {
    return stopMutating(mutation, el);
  });
  mutation.elements.clear();
  mutations["delete"](mutation);
}

function refreshAllElementSets() {
  mutations.forEach(refreshElementsSet);
} // Observer for elements that don't exist in the DOM yet


var observer;
function disconnectGlobalObserver() {
  observer && observer.disconnect();
}
function connectGlobalObserver() {
  if (typeof document === 'undefined') return;

  if (!observer) {
    observer = new MutationObserver(function () {
      refreshAllElementSets();
    });
  }

  refreshAllElementSets();
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
} // run on init

connectGlobalObserver();

function newMutation(m) {
  // Not in a browser
  if (typeof document === 'undefined') return nullController; // add to global index of mutations

  mutations.add(m); // run refresh on init to establish list of elements associated w/ mutation

  refreshElementsSet(m);
  return {
    revert: function revert() {
      revertMutation(m);
    }
  };
}

function html(selector, mutate) {
  return newMutation({
    kind: 'html',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function position(selector, mutate) {
  return newMutation({
    kind: 'position',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function classes(selector, mutate) {
  return newMutation({
    kind: 'class',
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function attribute(selector, attribute, mutate) {
  if (!validAttributeName.test(attribute)) return nullController;

  if (attribute === 'class' || attribute === 'className') {
    return classes(selector, function (classnames) {
      var mutatedClassnames = mutate(Array.from(classnames).join(' '));
      classnames.clear();
      if (!mutatedClassnames) return;
      mutatedClassnames.split(/\s+/g).filter(Boolean).forEach(function (c) {
        return classnames.add(c);
      });
    });
  }

  return newMutation({
    kind: 'attribute',
    attribute: attribute,
    elements: new Set(),
    mutate: mutate,
    selector: selector
  });
}

function declarative(_ref2) {
  var selector = _ref2.selector,
      action = _ref2.action,
      value = _ref2.value,
      attr = _ref2.attribute,
      parentSelector = _ref2.parentSelector,
      insertBeforeSelector = _ref2.insertBeforeSelector;

  if (attr === 'html') {
    if (action === 'append') {
      return html(selector, function (val) {
        return val + (value != null ? value : '');
      });
    } else if (action === 'set') {
      return html(selector, function () {
        return value != null ? value : '';
      });
    }
  } else if (attr === 'class') {
    if (action === 'append') {
      return classes(selector, function (val) {
        if (value) val.add(value);
      });
    } else if (action === 'remove') {
      return classes(selector, function (val) {
        if (value) val["delete"](value);
      });
    } else if (action === 'set') {
      return classes(selector, function (val) {
        val.clear();
        if (value) val.add(value);
      });
    }
  } else if (attr === 'position') {
    if (action === 'set' && parentSelector) {
      return position(selector, function () {
        return {
          insertBeforeSelector: insertBeforeSelector,
          parentSelector: parentSelector
        };
      });
    }
  } else {
    if (action === 'append') {
      return attribute(selector, attr, function (val) {
        return val !== null ? val + (value != null ? value : '') : value != null ? value : '';
      });
    } else if (action === 'set') {
      return attribute(selector, attr, function () {
        return value != null ? value : '';
      });
    } else if (action === 'remove') {
      return attribute(selector, attr, function () {
        return null;
      });
    }
  }

  return nullController;
}

var index = {
  html: html,
  classes: classes,
  attribute: attribute,
  position: position,
  declarative: declarative
};

/* harmony default export */ var dom_mutator_esm = (index);

//# sourceMappingURL=dom-mutator.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/node_modules/@growthbook/growthbook/dist/esm/util.js
function hashFnv32a(str) {
  let hval = 0x811c9dc5;
  const l = str.length;
  for (let i = 0; i < l; i++) {
    hval ^= str.charCodeAt(i);
    hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
  }
  return hval >>> 0;
}
function hash(seed, value, version) {
  // New unbiased hashing algorithm
  if (version === 2) {
    return hashFnv32a(hashFnv32a(seed + value) + "") % 10000 / 10000;
  }
  // Original biased hashing algorithm (keep for backwards compatibility)
  if (version === 1) {
    return hashFnv32a(value + seed) % 1000 / 1000;
  }

  // Unknown hash version
  return null;
}
function getEqualWeights(n) {
  if (n <= 0) return [];
  return new Array(n).fill(1 / n);
}
function inRange(n, range) {
  return n >= range[0] && n < range[1];
}
function inNamespace(hashValue, namespace) {
  const n = hash("__" + namespace[0], hashValue, 1);
  if (n === null) return false;
  return n >= namespace[1] && n < namespace[2];
}
function chooseVariation(n, ranges) {
  for (let i = 0; i < ranges.length; i++) {
    if (inRange(n, ranges[i])) {
      return i;
    }
  }
  return -1;
}
function getUrlRegExp(regexString) {
  try {
    const escaped = regexString.replace(/([^\\])\//g, "$1\\/");
    return new RegExp(escaped);
  } catch (e) {
    console.error(e);
    return undefined;
  }
}
function isURLTargeted(url, targets) {
  if (!targets.length) return false;
  let hasIncludeRules = false;
  let isIncluded = false;
  for (let i = 0; i < targets.length; i++) {
    const match = _evalURLTarget(url, targets[i].type, targets[i].pattern);
    if (targets[i].include === false) {
      if (match) return false;
    } else {
      hasIncludeRules = true;
      if (match) isIncluded = true;
    }
  }
  return isIncluded || !hasIncludeRules;
}
function _evalSimpleUrlPart(actual, pattern, isPath) {
  try {
    // Escape special regex characters and change wildcard `_____` to `.*`
    let escaped = pattern.replace(/[*.+?^${}()|[\]\\]/g, "\\$&").replace(/_____/g, ".*");
    if (isPath) {
      // When matching pathname, make leading/trailing slashes optional
      escaped = "\\/?" + escaped.replace(/(^\/|\/$)/g, "") + "\\/?";
    }
    const regex = new RegExp("^" + escaped + "$", "i");
    return regex.test(actual);
  } catch (e) {
    return false;
  }
}
function _evalSimpleUrlTarget(actual, pattern) {
  try {
    // If a protocol is missing, but a host is specified, add `https://` to the front
    // Use "_____" as the wildcard since `*` is not a valid hostname in some browsers
    const expected = new URL(pattern.replace(/^([^:/?]*)\./i, "https://$1.").replace(/\*/g, "_____"), "https://_____");

    // Compare each part of the URL separately
    const comps = [[actual.host, expected.host, false], [actual.pathname, expected.pathname, true]];
    // We only want to compare hashes if it's explicitly being targeted
    if (expected.hash) {
      comps.push([actual.hash, expected.hash, false]);
    }
    expected.searchParams.forEach((v, k) => {
      comps.push([actual.searchParams.get(k) || "", v, false]);
    });

    // If any comparisons fail, the whole thing fails
    return !comps.some(data => !_evalSimpleUrlPart(data[0], data[1], data[2]));
  } catch (e) {
    return false;
  }
}
function _evalURLTarget(url, type, pattern) {
  try {
    const parsed = new URL(url, "https://_");
    if (type === "regex") {
      const regex = getUrlRegExp(pattern);
      if (!regex) return false;
      return regex.test(parsed.href) || regex.test(parsed.href.substring(parsed.origin.length));
    } else if (type === "simple") {
      return _evalSimpleUrlTarget(parsed, pattern);
    }
    return false;
  } catch (e) {
    return false;
  }
}
function getBucketRanges(numVariations, coverage, weights) {
  coverage = coverage === undefined ? 1 : coverage;

  // Make sure coverage is within bounds
  if (coverage < 0) {
    if (false) {}
    coverage = 0;
  } else if (coverage > 1) {
    if (false) {}
    coverage = 1;
  }

  // Default to equal weights if missing or invalid
  const equal = getEqualWeights(numVariations);
  weights = weights || equal;
  if (weights.length !== numVariations) {
    if (false) {}
    weights = equal;
  }

  // If weights don't add up to 1 (or close to it), default to equal weights
  const totalWeight = weights.reduce((w, sum) => sum + w, 0);
  if (totalWeight < 0.99 || totalWeight > 1.01) {
    if (false) {}
    weights = equal;
  }

  // Covert weights to ranges
  let cumulative = 0;
  return weights.map(w => {
    const start = cumulative;
    cumulative += w;
    return [start, start + coverage * w];
  });
}
function getQueryStringOverride(id, url, numVariations) {
  if (!url) {
    return null;
  }
  const search = url.split("?")[1];
  if (!search) {
    return null;
  }
  const match = search.replace(/#.*/, "") // Get rid of anchor
  .split("&") // Split into key/value pairs
  .map(kv => kv.split("=", 2)).filter(_ref => {
    let [k] = _ref;
    return k === id;
  }) // Look for key that matches the experiment id
  .map(_ref2 => {
    let [, v] = _ref2;
    return parseInt(v);
  }); // Parse the value into an integer

  if (match.length > 0 && match[0] >= 0 && match[0] < numVariations) return match[0];
  return null;
}
function isIncluded(include) {
  try {
    return include();
  } catch (e) {
    console.error(e);
    return false;
  }
}
const base64ToBuf = b => Uint8Array.from(atob(b), c => c.charCodeAt(0));
async function decrypt(encryptedString, decryptionKey, subtle) {
  decryptionKey = decryptionKey || "";
  subtle = subtle || globalThis.crypto && globalThis.crypto.subtle;
  if (!subtle) {
    throw new Error("No SubtleCrypto implementation found");
  }
  try {
    const key = await subtle.importKey("raw", base64ToBuf(decryptionKey), {
      name: "AES-CBC",
      length: 128
    }, true, ["encrypt", "decrypt"]);
    const [iv, cipherText] = encryptedString.split(".");
    const plainTextBuffer = await subtle.decrypt({
      name: "AES-CBC",
      iv: base64ToBuf(iv)
    }, key, base64ToBuf(cipherText));
    return new TextDecoder().decode(plainTextBuffer);
  } catch (e) {
    throw new Error("Failed to decrypt");
  }
}
function paddedVersionString(input) {
  // Remove build info and leading `v` if any
  // Split version into parts (both core version numbers and pre-release tags)
  // "v1.2.3-rc.1+build123" -> ["1","2","3","rc","1"]
  const parts = input.replace(/(^v|\+.*$)/g, "").split(/[-.]/);

  // If it's SemVer without a pre-release, add `~` to the end
  // ["1","0","0"] -> ["1","0","0","~"]
  // "~" is the largest ASCII character, so this will make "1.0.0" greater than "1.0.0-beta" for example
  if (parts.length === 3) {
    parts.push("~");
  }

  // Left pad each numeric part with spaces so string comparisons will work ("9">"10", but " 9"<"10")
  // Then, join back together into a single string
  return parts.map(v => v.match(/^[0-9]+$/) ? v.padStart(5, " ") : v).join("-");
}
//# sourceMappingURL=util.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/node_modules/@growthbook/growthbook/dist/esm/mongrule.js
/* eslint-disable @typescript-eslint/no-explicit-any */


const _regexCache = {};

// The top-level condition evaluation function
function evalCondition(obj, condition) {
  // Recursive condition
  if ("$or" in condition) {
    return evalOr(obj, condition["$or"]);
  }
  if ("$nor" in condition) {
    return !evalOr(obj, condition["$nor"]);
  }
  if ("$and" in condition) {
    return evalAnd(obj, condition["$and"]);
  }
  if ("$not" in condition) {
    return !evalCondition(obj, condition["$not"]);
  }

  // Condition is an object, keys are object paths, values are the condition for that path
  for (const [k, v] of Object.entries(condition)) {
    if (!evalConditionValue(v, getPath(obj, k))) return false;
  }
  return true;
}

// Return value at dot-separated path of an object
function getPath(obj, path) {
  const parts = path.split(".");
  let current = obj;
  for (let i = 0; i < parts.length; i++) {
    if (current && typeof current === "object" && parts[i] in current) {
      current = current[parts[i]];
    } else {
      return null;
    }
  }
  return current;
}

// Transform a regex string into a real RegExp object
function getRegex(regex) {
  if (!_regexCache[regex]) {
    _regexCache[regex] = new RegExp(regex.replace(/([^\\])\//g, "$1\\/"));
  }
  return _regexCache[regex];
}

// Evaluate a single value against a condition
function evalConditionValue(condition, value) {
  // Simple equality comparisons
  if (typeof condition === "string") {
    return value + "" === condition;
  }
  if (typeof condition === "number") {
    return value * 1 === condition;
  }
  if (typeof condition === "boolean") {
    return !!value === condition;
  }
  if (condition === null) {
    return value === null;
  }
  if (Array.isArray(condition) || !isOperatorObject(condition)) {
    return JSON.stringify(value) === JSON.stringify(condition);
  }

  // This is a special operator condition and we should evaluate each one separately
  for (const op in condition) {
    if (!evalOperatorCondition(op, value, condition[op])) {
      return false;
    }
  }
  return true;
}

// If the object has only keys that start with '$'
function isOperatorObject(obj) {
  const keys = Object.keys(obj);
  return keys.length > 0 && keys.filter(k => k[0] === "$").length === keys.length;
}

// Return the data type of a value
function getType(v) {
  if (v === null) return "null";
  if (Array.isArray(v)) return "array";
  const t = typeof v;
  if (["string", "number", "boolean", "object", "undefined"].includes(t)) {
    return t;
  }
  return "unknown";
}

// At least one element of actual must match the expected condition/value
function elemMatch(actual, expected) {
  if (!Array.isArray(actual)) return false;
  const check = isOperatorObject(expected) ? v => evalConditionValue(expected, v) : v => evalCondition(v, expected);
  for (let i = 0; i < actual.length; i++) {
    if (actual[i] && check(actual[i])) {
      return true;
    }
  }
  return false;
}
function isIn(actual, expected) {
  // Do an intersection is attribute is an array
  if (Array.isArray(actual)) {
    return actual.some(el => expected.includes(el));
  }
  return expected.includes(actual);
}

// Evaluate a single operator condition
function evalOperatorCondition(operator, actual, expected) {
  switch (operator) {
    case "$veq":
      return paddedVersionString(actual) === paddedVersionString(expected);
    case "$vne":
      return paddedVersionString(actual) !== paddedVersionString(expected);
    case "$vgt":
      return paddedVersionString(actual) > paddedVersionString(expected);
    case "$vgte":
      return paddedVersionString(actual) >= paddedVersionString(expected);
    case "$vlt":
      return paddedVersionString(actual) < paddedVersionString(expected);
    case "$vlte":
      return paddedVersionString(actual) <= paddedVersionString(expected);
    case "$eq":
      return actual === expected;
    case "$ne":
      return actual !== expected;
    case "$lt":
      return actual < expected;
    case "$lte":
      return actual <= expected;
    case "$gt":
      return actual > expected;
    case "$gte":
      return actual >= expected;
    case "$exists":
      return expected ? actual !== null : actual === null;
    case "$in":
      if (!Array.isArray(expected)) return false;
      return isIn(actual, expected);
    case "$nin":
      if (!Array.isArray(expected)) return false;
      return !isIn(actual, expected);
    case "$not":
      return !evalConditionValue(expected, actual);
    case "$size":
      if (!Array.isArray(actual)) return false;
      return evalConditionValue(expected, actual.length);
    case "$elemMatch":
      return elemMatch(actual, expected);
    case "$all":
      if (!Array.isArray(actual)) return false;
      for (let i = 0; i < expected.length; i++) {
        let passed = false;
        for (let j = 0; j < actual.length; j++) {
          if (evalConditionValue(expected[i], actual[j])) {
            passed = true;
            break;
          }
        }
        if (!passed) return false;
      }
      return true;
    case "$regex":
      try {
        return getRegex(expected).test(actual);
      } catch (e) {
        return false;
      }
    case "$type":
      return getType(actual) === expected;
    default:
      console.error("Unknown operator: " + operator);
      return false;
  }
}

// Recursive $or rule
function evalOr(obj, conditions) {
  if (!conditions.length) return true;
  for (let i = 0; i < conditions.length; i++) {
    if (evalCondition(obj, conditions[i])) {
      return true;
    }
  }
  return false;
}

// Recursive $and rule
function evalAnd(obj, conditions) {
  for (let i = 0; i < conditions.length; i++) {
    if (!evalCondition(obj, conditions[i])) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=mongrule.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/node_modules/@growthbook/growthbook/dist/esm/feature-repository.js
// Config settings
const cacheSettings = {
  // Consider a fetch stale after 1 minute
  staleTTL: 1000 * 60,
  cacheKey: "gbFeaturesCache",
  backgroundSync: true
};
const polyfills = {
  fetch: globalThis.fetch ? globalThis.fetch.bind(globalThis) : undefined,
  SubtleCrypto: globalThis.crypto ? globalThis.crypto.subtle : undefined,
  EventSource: globalThis.EventSource
};
try {
  if (globalThis.localStorage) {
    polyfills.localStorage = globalThis.localStorage;
  }
} catch (e) {
  // Ignore localStorage errors
}

// Global state
const subscribedInstances = new Map();
let cacheInitialized = false;
const cache = new Map();
const activeFetches = new Map();
const streams = new Map();
const supportsSSE = new Set();

// Public functions
function setPolyfills(overrides) {
  Object.assign(polyfills, overrides);
}
function configureCache(overrides) {
  Object.assign(cacheSettings, overrides);
  if (!cacheSettings.backgroundSync) {
    clearAutoRefresh();
  }
}
async function clearCache() {
  cache.clear();
  activeFetches.clear();
  clearAutoRefresh();
  cacheInitialized = false;
  await updatePersistentCache();
}
async function refreshFeatures(instance, timeout, skipCache, allowStale, updateInstance, backgroundSync) {
  if (!backgroundSync) {
    cacheSettings.backgroundSync = false;
  }
  const data = await fetchFeaturesWithCache(instance, allowStale, timeout, skipCache);
  updateInstance && data && (await refreshInstance(instance, data));
}

// Subscribe a GrowthBook instance to feature changes
function subscribe(instance) {
  const [key] = getKey(instance);
  const subs = subscribedInstances.get(key) || new Set();
  subs.add(instance);
  subscribedInstances.set(key, subs);
}
function unsubscribe(instance) {
  subscribedInstances.forEach(s => s.delete(instance));
}

// Private functions
async function updatePersistentCache() {
  try {
    if (!polyfills.localStorage) return;
    await polyfills.localStorage.setItem(cacheSettings.cacheKey, JSON.stringify(Array.from(cache.entries())));
  } catch (e) {
    // Ignore localStorage errors
  }
}
async function fetchFeaturesWithCache(instance, allowStale, timeout, skipCache) {
  const [key] = getKey(instance);
  const now = new Date();
  await initializeCache();
  const existing = cache.get(key);
  if (existing && !skipCache && (allowStale || existing.staleAt > now)) {
    // Restore from cache whether or not SSE is supported
    if (existing.sse) supportsSSE.add(key);

    // Reload features in the backgroud if stale
    if (existing.staleAt < now) {
      fetchFeatures(instance);
    }
    // Otherwise, if we don't need to refresh now, start a background sync
    else {
      startAutoRefresh(instance);
    }
    return existing.data;
  } else {
    const data = await promiseTimeout(fetchFeatures(instance), timeout);
    return data;
  }
}
function getKey(instance) {
  const [apiHost, clientKey] = instance.getApiInfo();
  return ["".concat(apiHost, "||").concat(clientKey), apiHost, clientKey];
}

// Guarantee the promise always resolves within {timeout} ms
// Resolved value will be `null` when there's an error or it takes too long
// Note: The promise will continue running in the background, even if the timeout is hit
function promiseTimeout(promise, timeout) {
  return new Promise(resolve => {
    let resolved = false;
    let timer;
    const finish = data => {
      if (resolved) return;
      resolved = true;
      timer && clearTimeout(timer);
      resolve(data || null);
    };
    if (timeout) {
      timer = setTimeout(() => finish(), timeout);
    }
    promise.then(data => finish(data)).catch(() => finish());
  });
}

// Populate cache from localStorage (if available)
async function initializeCache() {
  if (cacheInitialized) return;
  cacheInitialized = true;
  try {
    if (polyfills.localStorage) {
      const value = await polyfills.localStorage.getItem(cacheSettings.cacheKey);
      if (value) {
        const parsed = JSON.parse(value);
        if (parsed && Array.isArray(parsed)) {
          parsed.forEach(_ref => {
            let [key, data] = _ref;
            cache.set(key, {
              ...data,
              staleAt: new Date(data.staleAt)
            });
          });
        }
      }
    }
  } catch (e) {
    // Ignore localStorage errors
  }
}

// Called whenever new features are fetched from the API
function onNewFeatureData(key, data) {
  // If contents haven't changed, ignore the update, extend the stale TTL
  const version = data.dateUpdated || "";
  const staleAt = new Date(Date.now() + cacheSettings.staleTTL);
  const existing = cache.get(key);
  if (existing && version && existing.version === version) {
    existing.staleAt = staleAt;
    updatePersistentCache();
    return;
  }

  // Update in-memory cache
  cache.set(key, {
    data,
    version,
    staleAt,
    sse: supportsSSE.has(key)
  });
  // Update local storage (don't await this, just update asynchronously)
  updatePersistentCache();

  // Update features for all subscribed GrowthBook instances
  const instances = subscribedInstances.get(key);
  instances && instances.forEach(instance => refreshInstance(instance, data));
}
async function refreshInstance(instance, data) {
  await (data.encryptedExperiments ? instance.setEncryptedExperiments(data.encryptedExperiments, undefined, polyfills.SubtleCrypto) : instance.setExperiments(data.experiments || instance.getExperiments()));
  await (data.encryptedFeatures ? instance.setEncryptedFeatures(data.encryptedFeatures, undefined, polyfills.SubtleCrypto) : instance.setFeatures(data.features || instance.getFeatures()));
}
async function fetchFeatures(instance) {
  const [key, apiHost, clientKey] = getKey(instance);
  const endpoint = apiHost + "/api/features/" + clientKey;
  let promise = activeFetches.get(key);
  if (!promise) {
    promise = polyfills.fetch(endpoint)
    // TODO: auto-retry if status code indicates a temporary error
    .then(res => {
      if (res.headers.get("x-sse-support") === "enabled") {
        supportsSSE.add(key);
      }
      return res.json();
    }).then(data => {
      onNewFeatureData(key, data);
      startAutoRefresh(instance);
      activeFetches.delete(key);
      return data;
    }).catch(e => {
       false && 0;
      activeFetches.delete(key);
      return Promise.resolve({});
    });
    activeFetches.set(key, promise);
  }
  return await promise;
}

// Watch a feature endpoint for changes
// Will prefer SSE if enabled, otherwise fall back to cron
function startAutoRefresh(instance) {
  const [key, apiHost, clientKey] = getKey(instance);
  if (cacheSettings.backgroundSync && supportsSSE.has(key) && polyfills.EventSource) {
    if (streams.has(key)) return;
    const channel = {
      src: null,
      cb: event => {
        try {
          const json = JSON.parse(event.data);
          onNewFeatureData(key, json);
          // Reset error count on success
          channel.errors = 0;
        } catch (e) {
           false && 0;
          onSSEError(channel, apiHost, clientKey);
        }
      },
      errors: 0
    };
    streams.set(key, channel);
    enableChannel(channel, apiHost, clientKey);
  }
}
function onSSEError(channel, apiHost, clientKey) {
  channel.errors++;
  if (channel.errors > 3 || channel.src && channel.src.readyState === 2) {
    // exponential backoff after 4 errors, with jitter
    const delay = Math.pow(3, channel.errors - 3) * (1000 + Math.random() * 1000);
    disableChannel(channel);
    setTimeout(() => {
      enableChannel(channel, apiHost, clientKey);
    }, Math.min(delay, 300000)); // 5 minutes max
  }
}

function disableChannel(channel) {
  if (!channel.src) return;
  channel.src.onopen = null;
  channel.src.onerror = null;
  channel.src.close();
  channel.src = null;
}
function enableChannel(channel, apiHost, clientKey) {
  channel.src = new polyfills.EventSource("".concat(apiHost, "/sub/").concat(clientKey));
  channel.src.addEventListener("features", channel.cb);
  channel.src.onerror = () => {
    onSSEError(channel, apiHost, clientKey);
  };
  channel.src.onopen = () => {
    channel.errors = 0;
  };
}
function destroyChannel(channel, key) {
  disableChannel(channel);
  streams.delete(key);
}
function clearAutoRefresh() {
  // Clear list of which keys are auto-updated
  supportsSSE.clear();

  // Stop listening for any SSE events
  streams.forEach(destroyChannel);

  // Remove all references to GrowthBook instances
  subscribedInstances.clear();
}
//# sourceMappingURL=feature-repository.js.map
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/node_modules/@growthbook/growthbook/dist/esm/GrowthBook.js




const isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
class GrowthBook_GrowthBook {
  // context is technically private, but some tools depend on it so we can't mangle the name
  // _ctx below is a clone of this property that we use internally

  // Properties and methods that start with "_" are mangled by Terser (saves ~150 bytes)

  // eslint-disable-next-line

  constructor(context) {
    context = context || {};
    // These properties are all initialized in the constructor instead of above
    // This saves ~80 bytes in the final output
    this._ctx = this.context = context;
    this._renderer = null;
    this._trackedExperiments = new Set();
    this._trackedFeatures = {};
    this.debug = false;
    this._subscriptions = new Set();
    this._rtQueue = [];
    this._rtTimer = 0;
    this.ready = false;
    this._assigned = new Map();
    this._forcedFeatureValues = new Map();
    this._attributeOverrides = {};
    this._activeAutoExperiments = new Map();
    if (context.features) {
      this.ready = true;
    }
    if (isBrowser && context.enableDevMode) {
      window._growthbook = this;
      document.dispatchEvent(new Event("gbloaded"));
    }
    if (context.experiments) {
      this.ready = true;
      this._updateAllAutoExperiments();
    }
    if (context.clientKey) {
      this._refresh({}, true, false);
    }
  }
  async loadFeatures(options) {
    await this._refresh(options, true, true);
    if (this._ctx.backgroundSync !== false && (this._ctx.subscribeToChanges || options && options.autoRefresh)) {
      subscribe(this);
    }
  }
  async refreshFeatures(options) {
    await this._refresh(options, false, true);
  }
  getApiInfo() {
    return [(this._ctx.apiHost || "https://cdn.growthbook.io").replace(/\/*$/, ""), this._ctx.clientKey || ""];
  }
  async _refresh(options, allowStale, updateInstance) {
    options = options || {};
    if (!this._ctx.clientKey) {
      throw new Error("Missing clientKey");
    }
    await refreshFeatures(this, options.timeout, options.skipCache || this._ctx.enableDevMode, allowStale, updateInstance, this._ctx.backgroundSync !== false);
  }
  _render() {
    if (this._renderer) {
      this._renderer();
    }
  }
  setFeatures(features) {
    this._ctx.features = features;
    this.ready = true;
    this._render();
  }
  async setEncryptedFeatures(encryptedString, decryptionKey, subtle) {
    const featuresJSON = await decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
    this.setFeatures(JSON.parse(featuresJSON));
  }
  setExperiments(experiments) {
    this._ctx.experiments = experiments;
    this.ready = true;
    this._updateAllAutoExperiments();
  }
  async setEncryptedExperiments(encryptedString, decryptionKey, subtle) {
    const experimentsJSON = await decrypt(encryptedString, decryptionKey || this._ctx.decryptionKey, subtle);
    this.setExperiments(JSON.parse(experimentsJSON));
  }
  setAttributes(attributes) {
    this._ctx.attributes = attributes;
    this._render();
    this._updateAllAutoExperiments();
  }
  setAttributeOverrides(overrides) {
    this._attributeOverrides = overrides;
    this._render();
    this._updateAllAutoExperiments();
  }
  setForcedVariations(vars) {
    this._ctx.forcedVariations = vars || {};
    this._render();
    this._updateAllAutoExperiments();
  }
  // eslint-disable-next-line
  setForcedFeatures(map) {
    this._forcedFeatureValues = map;
    this._render();
  }
  setURL(url) {
    this._ctx.url = url;
    this._updateAllAutoExperiments(true);
  }
  getAttributes() {
    return {
      ...this._ctx.attributes,
      ...this._attributeOverrides
    };
  }
  getFeatures() {
    return this._ctx.features || {};
  }
  getExperiments() {
    return this._ctx.experiments || [];
  }
  subscribe(cb) {
    this._subscriptions.add(cb);
    return () => {
      this._subscriptions.delete(cb);
    };
  }
  getAllResults() {
    return new Map(this._assigned);
  }
  destroy() {
    // Release references to save memory
    this._subscriptions.clear();
    this._assigned.clear();
    this._trackedExperiments.clear();
    this._trackedFeatures = {};
    this._rtQueue = [];
    if (this._rtTimer) {
      clearTimeout(this._rtTimer);
    }
    unsubscribe(this);
    if (isBrowser && window._growthbook === this) {
      delete window._growthbook;
    }

    // Undo any active auto experiments
    this._activeAutoExperiments.forEach(exp => {
      exp.undo();
    });
    this._activeAutoExperiments.clear();
  }
  setRenderer(renderer) {
    this._renderer = renderer;
  }
  forceVariation(key, variation) {
    this._ctx.forcedVariations = this._ctx.forcedVariations || {};
    this._ctx.forcedVariations[key] = variation;
    this._render();
  }
  run(experiment) {
    const result = this._run(experiment, null);
    this._fireSubscriptions(experiment, result);
    return result;
  }
  triggerExperiment(key) {
    if (!this._ctx.experiments) return null;
    const exp = this._ctx.experiments.find(exp => exp.key === key);
    if (!exp || !exp.manual) return null;
    return this._runAutoExperiment(exp, true);
  }
  _runAutoExperiment(experiment, forceManual, forceRerun) {
    const key = experiment.key;
    const existing = this._activeAutoExperiments.get(key);

    // If this is a manual experiment and it's not already running, skip
    if (experiment.manual && !forceManual && !existing) return null;

    // Run the experiment
    const result = this.run(experiment);

    // A hash to quickly tell if the assigned value changed
    const valueHash = JSON.stringify(result.value);

    // If the changes are already active, no need to re-apply them
    if (!forceRerun && result.inExperiment && existing && existing.valueHash === valueHash) {
      return result;
    }

    // Undo any existing changes
    if (existing) this._undoActiveAutoExperiment(key);

    // Apply new changes
    if (result.inExperiment) {
      const undo = this._applyDOMChanges(result.value);
      if (undo) {
        this._activeAutoExperiments.set(experiment.key, {
          undo,
          valueHash
        });
      }
    }
    return result;
  }
  _undoActiveAutoExperiment(key) {
    const exp = this._activeAutoExperiments.get(key);
    if (exp) {
      exp.undo();
      this._activeAutoExperiments.delete(key);
    }
  }
  _updateAllAutoExperiments(forceRerun) {
    const experiments = this._ctx.experiments || [];

    // Stop any experiments that are no longer defined
    const keys = new Set(experiments.map(e => e.key));
    this._activeAutoExperiments.forEach((v, k) => {
      if (!keys.has(k)) {
        v.undo();
        this._activeAutoExperiments.delete(k);
      }
    });

    // Re-run all new/updated experiments
    experiments.forEach(exp => {
      this._runAutoExperiment(exp, false, forceRerun);
    });
  }
  _fireSubscriptions(experiment, result) {
    const key = experiment.key;

    // If assigned variation has changed, fire subscriptions
    const prev = this._assigned.get(key);
    // TODO: what if the experiment definition has changed?
    if (!prev || prev.result.inExperiment !== result.inExperiment || prev.result.variationId !== result.variationId) {
      this._assigned.set(key, {
        experiment,
        result
      });
      this._subscriptions.forEach(cb => {
        try {
          cb(experiment, result);
        } catch (e) {
          console.error(e);
        }
      });
    }
  }
  _trackFeatureUsage(key, res) {
    // Don't track feature usage that was forced via an override
    if (res.source === "override") return;

    // Only track a feature once, unless the assigned value changed
    const stringifiedValue = JSON.stringify(res.value);
    if (this._trackedFeatures[key] === stringifiedValue) return;
    this._trackedFeatures[key] = stringifiedValue;

    // Fire user-supplied callback
    if (this._ctx.onFeatureUsage) {
      try {
        this._ctx.onFeatureUsage(key, res);
      } catch (e) {
        // Ignore feature usage callback errors
      }
    }

    // In browser environments, queue up feature usage to be tracked in batches
    if (!isBrowser || !window.fetch) return;
    this._rtQueue.push({
      key,
      on: res.on
    });
    if (!this._rtTimer) {
      this._rtTimer = window.setTimeout(() => {
        // Reset the queue
        this._rtTimer = 0;
        const q = [...this._rtQueue];
        this._rtQueue = [];

        // Skip logging if a real-time usage key is not configured
        if (!this._ctx.realtimeKey) return;
        window.fetch("https://rt.growthbook.io/?key=".concat(this._ctx.realtimeKey, "&events=").concat(encodeURIComponent(JSON.stringify(q))), {
          cache: "no-cache",
          mode: "no-cors"
        }).catch(() => {
          // TODO: retry in case of network errors?
        });
      }, this._ctx.realtimeInterval || 2000);
    }
  }
  _getFeatureResult(key, value, source, ruleId, experiment, result) {
    const ret = {
      value,
      on: !!value,
      off: !value,
      source,
      ruleId: ruleId || ""
    };
    if (experiment) ret.experiment = experiment;
    if (result) ret.experimentResult = result;

    // Track the usage of this feature in real-time
    this._trackFeatureUsage(key, ret);
    return ret;
  }
  isOn(key) {
    return this.evalFeature(key).on;
  }
  isOff(key) {
    return this.evalFeature(key).off;
  }
  getFeatureValue(key, defaultValue) {
    const value = this.evalFeature(key).value;
    return value === null ? defaultValue : value;
  }

  /**
   * @deprecated Use {@link evalFeature}
   * @param id
   */
  // eslint-disable-next-line
  feature(id) {
    return this.evalFeature(id);
  }
  evalFeature(id) {
    // Global override
    if (this._forcedFeatureValues.has(id)) {
       false && 0;
      return this._getFeatureResult(id, this._forcedFeatureValues.get(id), "override");
    }

    // Unknown feature id
    if (!this._ctx.features || !this._ctx.features[id]) {
       false && 0;
      return this._getFeatureResult(id, null, "unknownFeature");
    }

    // Get the feature
    const feature = this._ctx.features[id];

    // Loop through the rules
    if (feature.rules) {
      for (const rule of feature.rules) {
        // If it's a conditional rule, skip if the condition doesn't pass
        if (rule.condition && !this._conditionPasses(rule.condition)) {
           false && 0;
          continue;
        }
        // If there are filters for who is included (e.g. namespaces)
        if (rule.filters && this._isFilteredOut(rule.filters)) {
           false && 0;
          continue;
        }

        // Feature value is being forced
        if ("force" in rule) {
          // If this is a percentage rollout, skip if not included
          if (!this._isIncludedInRollout(rule.seed || id, rule.hashAttribute, rule.range, rule.coverage, rule.hashVersion)) {
             false && 0;
            continue;
          }
           false && 0;

          // If this was a remotely evaluated experiment, fire the tracking callbacks
          if (rule.tracks) {
            rule.tracks.forEach(t => {
              this._track(t.experiment, t.result);
            });
          }
          return this._getFeatureResult(id, rule.force, "force", rule.id);
        }
        if (!rule.variations) {
           false && 0;
          continue;
        }
        // For experiment rules, run an experiment
        const exp = {
          variations: rule.variations,
          key: rule.key || id
        };
        if ("coverage" in rule) exp.coverage = rule.coverage;
        if (rule.weights) exp.weights = rule.weights;
        if (rule.hashAttribute) exp.hashAttribute = rule.hashAttribute;
        if (rule.namespace) exp.namespace = rule.namespace;
        if (rule.meta) exp.meta = rule.meta;
        if (rule.ranges) exp.ranges = rule.ranges;
        if (rule.name) exp.name = rule.name;
        if (rule.phase) exp.phase = rule.phase;
        if (rule.seed) exp.seed = rule.seed;
        if (rule.hashVersion) exp.hashVersion = rule.hashVersion;
        if (rule.filters) exp.filters = rule.filters;

        // Only return a value if the user is part of the experiment
        const res = this._run(exp, id);
        this._fireSubscriptions(exp, res);
        if (res.inExperiment && !res.passthrough) {
          return this._getFeatureResult(id, res.value, "experiment", rule.id, exp, res);
        }
      }
    }
     false && 0;

    // Fall back to using the default value
    return this._getFeatureResult(id, feature.defaultValue === undefined ? null : feature.defaultValue, "defaultValue");
  }
  _isIncludedInRollout(seed, hashAttribute, range, coverage, hashVersion) {
    if (!range && coverage === undefined) return true;
    const {
      hashValue
    } = this._getHashAttribute(hashAttribute);
    if (!hashValue) {
      return false;
    }
    const n = hash(seed, hashValue, hashVersion || 1);
    if (n === null) return false;
    return range ? inRange(n, range) : coverage !== undefined ? n <= coverage : true;
  }
  _conditionPasses(condition) {
    return evalCondition(this.getAttributes(), condition);
  }
  _isFilteredOut(filters) {
    return filters.some(filter => {
      const {
        hashValue
      } = this._getHashAttribute(filter.attribute);
      if (!hashValue) return true;
      const n = hash(filter.seed, hashValue, filter.hashVersion || 2);
      if (n === null) return true;
      return !filter.ranges.some(r => inRange(n, r));
    });
  }
  _run(experiment, featureId) {
    const key = experiment.key;
    const numVariations = experiment.variations.length;

    // 1. If experiment has less than 2 variations, return immediately
    if (numVariations < 2) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 2. If the context is disabled, return immediately
    if (this._ctx.enabled === false) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 2.5. Merge in experiment overrides from the context
    experiment = this._mergeOverrides(experiment);

    // 3. If a variation is forced from a querystring, return the forced variation
    const qsOverride = getQueryStringOverride(key, this._getContextUrl(), numVariations);
    if (qsOverride !== null) {
       false && 0;
      return this._getResult(experiment, qsOverride, false, featureId);
    }

    // 4. If a variation is forced in the context, return the forced variation
    if (this._ctx.forcedVariations && key in this._ctx.forcedVariations) {
      const variation = this._ctx.forcedVariations[key];
       false && 0;
      return this._getResult(experiment, variation, false, featureId);
    }

    // 5. Exclude if a draft experiment or not active
    if (experiment.status === "draft" || experiment.active === false) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 6. Get the hash attribute and return if empty
    const {
      hashValue
    } = this._getHashAttribute(experiment.hashAttribute);
    if (!hashValue) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 7. Exclude if user is filtered out (used to be called "namespace")
    if (experiment.filters) {
      if (this._isFilteredOut(experiment.filters)) {
         false && 0;
        return this._getResult(experiment, -1, false, featureId);
      }
    } else if (experiment.namespace && !inNamespace(hashValue, experiment.namespace)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 7.5. Exclude if experiment.include returns false or throws
    if (experiment.include && !isIncluded(experiment.include)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8. Exclude if condition is false
    if (experiment.condition && !this._conditionPasses(experiment.condition)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.1. Exclude if user is not in a required group
    if (experiment.groups && !this._hasGroupOverlap(experiment.groups)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.2. Old style URL targeting
    if (experiment.url && !this._urlIsValid(experiment.url)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 8.3. New, more powerful URL targeting
    if (experiment.urlPatterns && !isURLTargeted(this._getContextUrl(), experiment.urlPatterns)) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 9. Get bucket ranges and choose variation
    const n = hash(experiment.seed || key, hashValue, experiment.hashVersion || 1);
    if (n === null) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }
    const ranges = experiment.ranges || getBucketRanges(numVariations, experiment.coverage === undefined ? 1 : experiment.coverage, experiment.weights);
    const assigned = chooseVariation(n, ranges);

    // 10. Return if not in experiment
    if (assigned < 0) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 11. Experiment has a forced variation
    if ("force" in experiment) {
       false && 0;
      return this._getResult(experiment, experiment.force === undefined ? -1 : experiment.force, false, featureId);
    }

    // 12. Exclude if in QA mode
    if (this._ctx.qaMode) {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 12.5. Exclude if experiment is stopped
    if (experiment.status === "stopped") {
       false && 0;
      return this._getResult(experiment, -1, false, featureId);
    }

    // 13. Build the result object
    const result = this._getResult(experiment, assigned, true, featureId, n);

    // 14. Fire the tracking callback
    this._track(experiment, result);

    // 15. Return the result
     false && 0;
    return result;
  }
  log(msg, ctx) {
    if (!this.debug) return;
    if (this._ctx.log) this._ctx.log(msg, ctx);else console.log(msg, ctx);
  }
  _track(experiment, result) {
    if (!this._ctx.trackingCallback) return;
    const key = experiment.key;

    // Make sure a tracking callback is only fired once per unique experiment
    const k = result.hashAttribute + result.hashValue + key + result.variationId;
    if (this._trackedExperiments.has(k)) return;
    this._trackedExperiments.add(k);
    try {
      this._ctx.trackingCallback(experiment, result);
    } catch (e) {
      console.error(e);
    }
  }
  _mergeOverrides(experiment) {
    const key = experiment.key;
    const o = this._ctx.overrides;
    if (o && o[key]) {
      experiment = Object.assign({}, experiment, o[key]);
      if (typeof experiment.url === "string") {
        experiment.url = getUrlRegExp(
        // eslint-disable-next-line
        experiment.url);
      }
    }
    return experiment;
  }
  _getHashAttribute(attr) {
    const hashAttribute = attr || "id";
    let hashValue = "";
    if (this._attributeOverrides[hashAttribute]) {
      hashValue = this._attributeOverrides[hashAttribute];
    } else if (this._ctx.attributes) {
      hashValue = this._ctx.attributes[hashAttribute] || "";
    } else if (this._ctx.user) {
      hashValue = this._ctx.user[hashAttribute] || "";
    }
    return {
      hashAttribute,
      hashValue
    };
  }
  _getResult(experiment, variationIndex, hashUsed, featureId, bucket) {
    let inExperiment = true;
    // If assigned variation is not valid, use the baseline and mark the user as not in the experiment
    if (variationIndex < 0 || variationIndex >= experiment.variations.length) {
      variationIndex = 0;
      inExperiment = false;
    }
    const {
      hashAttribute,
      hashValue
    } = this._getHashAttribute(experiment.hashAttribute);
    const meta = experiment.meta ? experiment.meta[variationIndex] : {};
    const res = {
      key: meta.key || "" + variationIndex,
      featureId,
      inExperiment,
      hashUsed,
      variationId: variationIndex,
      value: experiment.variations[variationIndex],
      hashAttribute,
      hashValue
    };
    if (meta.name) res.name = meta.name;
    if (bucket !== undefined) res.bucket = bucket;
    if (meta.passthrough) res.passthrough = meta.passthrough;
    return res;
  }
  _getContextUrl() {
    return this._ctx.url || (isBrowser ? window.location.href : "");
  }
  _urlIsValid(urlRegex) {
    const url = this._getContextUrl();
    if (!url) return false;
    const pathOnly = url.replace(/^https?:\/\//, "").replace(/^[^/]*\//, "/");
    if (urlRegex.test(url)) return true;
    if (urlRegex.test(pathOnly)) return true;
    return false;
  }
  _hasGroupOverlap(expGroups) {
    const groups = this._ctx.groups || {};
    for (let i = 0; i < expGroups.length; i++) {
      if (groups[expGroups[i]]) return true;
    }
    return false;
  }
  _applyDOMChanges(changes) {
    if (!isBrowser) return;
    const undo = [];
    if (changes.css) {
      const s = document.createElement("style");
      s.innerHTML = changes.css;
      document.head.appendChild(s);
      undo.push(() => s.remove());
    }
    if (changes.js) {
      const script = document.createElement("script");
      script.innerHTML = changes.js;
      document.body.appendChild(script);
      undo.push(() => script.remove());
    }
    if (changes.domMutations) {
      changes.domMutations.forEach(mutation => {
        undo.push(dom_mutator_esm.declarative(mutation).revert);
      });
    }
    return () => {
      undo.forEach(fn => fn());
    };
  }
}
//# sourceMappingURL=GrowthBook.js.map
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js




function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

const GrowthBookContext = /*#__PURE__*/react.createContext({});
function run(exp, growthbook) {
  if (!growthbook) {
    return {
      featureId: null,
      value: exp.variations[0],
      variationId: 0,
      inExperiment: false,
      hashUsed: false,
      hashAttribute: exp.hashAttribute || "id",
      hashValue: "",
      key: ""
    };
  }
  return growthbook.run(exp);
}
function feature(id, growthbook) {
  if (!growthbook) {
    return {
      value: null,
      on: false,
      off: true,
      source: "unknownFeature",
      ruleId: ""
    };
  }
  return growthbook.evalFeature(id);
}

// Get features from API and targeting attributes during SSR
async function getGrowthBookSSRData(context) {
  // Server-side GrowthBook instance
  const gb = new GrowthBook({
    ...context
  });

  // Load feature flags from network if needed
  if (context.clientKey) {
    await gb.loadFeatures();
  }
  const data = {
    attributes: gb.getAttributes(),
    features: gb.getFeatures()
  };
  gb.destroy();
  return data;
}

// Populate the GrowthBook instance in context from the SSR props
function useGrowthBookSSR(data) {
  const gb = useGrowthBook();

  // Only do this once to avoid infinite loops
  const isFirst = React.useRef(true);
  if (gb && isFirst.current) {
    gb.setFeatures(data.features);
    gb.setAttributes(data.attributes);
    isFirst.current = false;
  }
}
function useExperiment(exp) {
  const {
    growthbook
  } = React.useContext(GrowthBookContext);
  return run(exp, growthbook);
}
function useFeature(id) {
  const growthbook = useGrowthBook();
  return feature(id, growthbook);
}
function useFeatureIsOn(id) {
  const growthbook = useGrowthBook();
  return growthbook ? growthbook.isOn(id) : false;
}
function useFeatureValue(id, fallback) {
  const growthbook = useGrowthBook();
  return growthbook ? growthbook.getFeatureValue(id, fallback) : fallback;
}
function useGrowthBook() {
  const {
    growthbook
  } = react.useContext(GrowthBookContext);
  return growthbook;
}
function FeaturesReady({
  children,
  timeout,
  fallback
}) {
  const gb = useGrowthBook();
  const [hitTimeout, setHitTimeout] = React.useState(false);
  const ready = gb ? gb.ready : false;
  React.useEffect(() => {
    if (timeout && !ready) {
      const timer = setTimeout(() => {
        gb && gb.log("FeaturesReady timed out waiting for features to load", {
          timeout
        });
        setHitTimeout(true);
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [timeout, ready, gb]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ready || hitTimeout ? children : fallback || null);
}
function IfFeatureEnabled({
  children,
  feature
}) {
  return useFeature(feature).on ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
}
function FeatureString(props) {
  const value = useFeature(props.feature).value;
  if (value !== null) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.default);
}
const withRunExperiment = Component => {
  // eslint-disable-next-line
  const withRunExperimentWrapper = props => /*#__PURE__*/react.createElement(GrowthBookContext.Consumer, null, ({
    growthbook
  }) => {
    return /*#__PURE__*/react.createElement(Component, _extends({}, props, {
      runExperiment: exp => run(exp, growthbook)
    }));
  });
  return withRunExperimentWrapper;
};
withRunExperiment.displayName = "WithRunExperiment";
const GrowthBookProvider = ({
  children,
  growthbook
}) => {
  // Tell growthbook how to re-render our app (for dev mode integration)
  // eslint-disable-next-line
  const [_, setRenderCount] = react.useState(0);
  react.useEffect(() => {
    if (!growthbook || !growthbook.setRenderer) return;
    growthbook.setRenderer(() => {
      setRenderCount(v => v + 1);
    });
    return () => {
      growthbook.setRenderer(() => {
        // do nothing
      });
    };
  }, [growthbook]);
  return /*#__PURE__*/react.createElement(GrowthBookContext.Provider, {
    value: {
      growthbook
    }
  }, children);
};


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./src/contexts/GrowthBookContext.tsx






var defaultValues = {
    "pplus-odd-denom": false,
    "account-deletion": false,
    "business-campaign-redeem-code-cta": false,
    "claim-tree-gift": false,
    "ch-2479-auth-mfe-enabled": false,
    "ch-2480-recipient-mfe-enabled-FE": false,
    "ch-2561-customer-mfe-enabled": false,
    "ch-3234-gift-card-slugs": false
};
var GrowthbookFeatureProvider = function(_param) {
    var children = _param.children, features = _param.features, attributes = _param.attributes, growthbookOptions = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "features",
        "attributes"
    ]);
    var growthbook = (0,react.useMemo)(function() {
        return new GrowthBook_GrowthBook((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, growthbookOptions), {
            features: features,
            attributes: attributes,
            trackingCallback: function(experiment, result) {
                analytics.track("Experiment Viewed", {
                    experimentId: experiment.key,
                    variationId: result.key
                });
            }
        }));
    }, []);
    (0,react.useEffect)(function() {
        if (growthbook.getFeatures() !== features && features) {
            growthbook.setFeatures(features);
        }
    }, [
        features
    ]);
    (0,react.useEffect)(function() {
        if (growthbook.getAttributes() !== attributes && attributes) {
            growthbook.setAttributes(attributes);
        }
    }, [
        attributes
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(GrowthBookProvider, {
        growthbook: growthbook,
        children: children
    });
};
var useGrowthbookFeatureValue = function(key) {
    var defaultValue = defaultValues[key];
    return useFeatureValue(key, defaultValue);
};
var useGrowthBookReady = function() {
    var gb = useGrowthBook();
    return !!(gb === null || gb === void 0 ? void 0 : gb.ready);
};



/***/ }),

/***/ 25149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ LayoutDataContext; },
/* harmony export */   "Q": function() { return /* binding */ useLayoutData; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// TODO: Add correct type in here. Type is coming from ReasonML and will need to drill genType to get it which isn't ideal.
var LayoutDataContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useLayoutData = function() {
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LayoutDataContext);
    if (!ctx) throw new Error("useLayoutData must be used within a LayoutDataContext.Provider");
    return ctx;
};


/***/ }),

/***/ 28750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K3": function() { return /* binding */ useNavVisibilty; },
/* harmony export */   "iu": function() { return /* binding */ NavVisibilityProvider; }
/* harmony export */ });
/* unused harmony export NavVisibilityConsumer */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _prezzee_ribbon_ui_lib_hooks_useBreakpointValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75117);
/* harmony import */ var utils_debounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60752);




var NavVisibilityContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(false);
var NavVisibilityProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isVisible = ref[0], setIsVisible = ref[1];
    var hasScrollListener = (0,_prezzee_ribbon_ui_lib_hooks_useBreakpointValue__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        base: true,
        xl: false
    }, "xl");
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var lastScrollTop = 0;
        var handleScroll = (0,utils_debounce__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var currentScrollTop = window.pageYOffset;
            if (currentScrollTop <= 0) {
                setIsVisible(true);
            } else if (currentScrollTop > lastScrollTop && currentScrollTop > 75) {
                setIsVisible(false);
            } else if (currentScrollTop < lastScrollTop && Math.abs(lastScrollTop - currentScrollTop) >= 75) {
                setIsVisible(true);
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        }, 100);
        if (hasScrollListener) {
            window.addEventListener("scroll", handleScroll);
        }
        return function() {
            if (hasScrollListener) {
                window.removeEventListener("scroll", handleScroll);
            }
        };
    }, [
        hasScrollListener
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NavVisibilityContext.Provider, {
        value: isVisible,
        children: children
    });
};
var NavVisibilityConsumer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(NavVisibilityContext.Consumer, {
        children: children
    });
};
var useNavVisibilty = function() {
    var ctx = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(NavVisibilityContext);
    if (typeof ctx === "undefined") throw new Error("useNavVisibilty must be used within the NavVisibilityProvider");
    return ctx;
};


/***/ }),

/***/ 93802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": function() { return /* binding */ Color; },
/* harmony export */   "ZT": function() { return /* binding */ Typography; }
/* harmony export */ });
/* unused harmony export Spacing */
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
// Generated by ReScript, PLEASE EDIT WITH CARE

var prezzeeRed = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("E30B17");
var charcoal = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("313E49");
var activeBlue = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("3E77B0");
var darkGrey = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("444444");
var midGrey = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("767676");
var lightGrey = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("A9AAA9");
var errorRed = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FF747C");
var paleGrey = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F8F8F8");
var backgroundGrey = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("E5E5E5");
var green = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("25AE88");
var orange = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("DC5800");
var yellow = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FAA731");
var purple700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("2B0840");
var purple600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("32064C");
var purple500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("410861");
var purple400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("48096C");
var purple300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("6D3A89");
var purple200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("916BA7");
var purple100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("DACEE2");
var purple50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("EDE6F0");
var red700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("480610");
var red600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("900C20");
var red500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("BE1807");
var red400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("ED1E09");
var red300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F1453A");
var red200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F4736B");
var red100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FABCB5");
var red50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FDE9E6");
var pink700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("CC7970");
var pink600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FF978C");
var pink500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFB6AF");
var pink400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFD2BD");
var pink300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFE0D1");
var pink200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFE9DE");
var pink100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFF6F2");
var pink50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFFBF8");
var lilac700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("A09EB0");
var lilac600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("B7B5C9");
var lilac500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("CECBE2");
var lilac400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("E5E2FB");
var lilac300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("EAE8FC");
var lilac200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("EDEBFC7");
var lilac100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F7F5FD");
var lilac50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F6F7F9");
var blue700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("102C60");
var blue600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("174291");
var blue500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("1E54B7");
var blue400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("276EF1");
var blue300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("5B91F5");
var blue200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("A0BFF8");
var blue100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("D4E2FC");
var blue50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("EFF3FE");
var green700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("0B3429");
var green600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("166852");
var green500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("1E8B6D");
var green400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("25AE88");
var green300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("51BEA0");
var green200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("7CCEB8");
var green100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("A8DFCF");
var green50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("E9F7F3");
var yellow700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("806022");
var yellow600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("B3862F");
var yellow500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("CC9A36");
var yellow400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFC043");
var yellow300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFCF70");
var yellow200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFE3AC");
var yellow100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFF2D9");
var yellow50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFFAF0");
var orange700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("7D2714");
var orange600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("AE371C");
var orange500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("CC492C");
var orange400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FF6937");
var orange300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FA9269");
var orange200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FABDA5");
var orange100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFE1D6");
var orange50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFF3EF");
var black = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("000000");
var gray800 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("1E1E1E");
var gray700 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("302F2F");
var gray600 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("4B4B4B");
var gray500 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("787878");
var gray400 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("A0A0A0");
var gray300 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("C7C3C3");
var gray200 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("E0DEDE");
var gray100 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F0EDED");
var gray50 = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("F8F8F8");
var white = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFFFFF");
var accentPink = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("FFC5EE");
var accentYellow = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("C7C3C3");
var accentBlue = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .hex */ .$v1("C7C3C3");
var Color = {
    prezzeeRed: prezzeeRed,
    charcoal: charcoal,
    activeBlue: activeBlue,
    darkGrey: darkGrey,
    midGrey: midGrey,
    lightGrey: lightGrey,
    errorRed: errorRed,
    paleGrey: paleGrey,
    backgroundGrey: backgroundGrey,
    green: green,
    orange: orange,
    yellow: yellow,
    purple700: purple700,
    purple600: purple600,
    purple500: purple500,
    purple400: purple400,
    purple300: purple300,
    purple200: purple200,
    purple100: purple100,
    purple50: purple50,
    red700: red700,
    red600: red600,
    red500: red500,
    red400: red400,
    red300: red300,
    red200: red200,
    red100: red100,
    red50: red50,
    pink700: pink700,
    pink600: pink600,
    pink500: pink500,
    pink400: pink400,
    pink300: pink300,
    pink200: pink200,
    pink100: pink100,
    pink50: pink50,
    lilac700: lilac700,
    lilac600: lilac600,
    lilac500: lilac500,
    lilac400: lilac400,
    lilac300: lilac300,
    lilac200: lilac200,
    lilac100: lilac100,
    lilac50: lilac50,
    blue700: blue700,
    blue600: blue600,
    blue500: blue500,
    blue400: blue400,
    blue300: blue300,
    blue200: blue200,
    blue100: blue100,
    blue50: blue50,
    green700: green700,
    green600: green600,
    green500: green500,
    green400: green400,
    green300: green300,
    green200: green200,
    green100: green100,
    green50: green50,
    yellow700: yellow700,
    yellow600: yellow600,
    yellow500: yellow500,
    yellow400: yellow400,
    yellow300: yellow300,
    yellow200: yellow200,
    yellow100: yellow100,
    yellow50: yellow50,
    orange700: orange700,
    orange600: orange600,
    orange500: orange500,
    orange400: orange400,
    orange300: orange300,
    orange200: orange200,
    orange100: orange100,
    orange50: orange50,
    black: black,
    gray800: gray800,
    gray700: gray700,
    gray600: gray600,
    gray500: gray500,
    gray400: gray400,
    gray300: gray300,
    gray200: gray200,
    gray100: gray100,
    gray50: gray50,
    white: white,
    accentPink: accentPink,
    accentYellow: accentYellow,
    accentBlue: accentBlue
};
var defaultFonts = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontFamilies */ .VlP({
    hd: {
        NAME: "custom",
        VAL: "sofia-pro"
    },
    tl: {
        hd: {
            NAME: "custom",
            VAL: "-apple-system"
        },
        tl: {
            hd: {
                NAME: "custom",
                VAL: "BlinkMacSystemFont"
            },
            tl: {
                hd: {
                    NAME: "custom",
                    VAL: "Helvetica Neue"
                },
                tl: {
                    hd: {
                        NAME: "custom",
                        VAL: "Arial"
                    },
                    tl: {
                        hd: "sansSerif",
                        tl: /* [] */ 0
                    }
                }
            }
        }
    }
});
var Typography = {
    defaultFonts: defaultFonts
};
var small = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16);
var medium = _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24);
var Spacing = {
    small: small,
    medium: medium
};
 /* prezzeeRed Not a pure module */ 


/***/ }),

/***/ 86167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ personal; },
/* harmony export */   "k": function() { return /* binding */ business; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71863);
/* harmony import */ var _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93802);
/* harmony import */ var _prezzee_ribbon_src_components_common_Tag_Tag_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71112);
/* harmony import */ var _prezzee_ribbon_src_components_common_Footer_Footer_Theme_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38715);
/* harmony import */ var _prezzee_ribbon_src_components_common_Tagline_Tagline_Theme_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27471);
/* harmony import */ var _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Theme_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38177);
/* harmony import */ var _prezzee_ribbon_src_components_personal_RegionPicker_RegionPicker_Theme_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3738);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1997);
/* harmony import */ var _prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Theme_bs_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(18178);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Components_bs_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23191);
/* harmony import */ var _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Theme_bs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15628);
// Generated by ReScript, PLEASE EDIT WITH CARE











var personal = _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_7__.t({
    default: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.red400 */ .Il.red400,
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.red500 */ .Il.red500,
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, {
    default: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple400 */ .Il.purple400,
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple600 */ .Il.purple600,
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, {
    default: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray700 */ .Il.gray700,
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800,
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, [
    {
        NAME: "custom",
        VAL: "DM Serif Display"
    },
    {
        NAME: "custom",
        VAL: "sofia-pro"
    },
    {
        NAME: "custom",
        VAL: "-apple-system"
    },
    {
        NAME: "custom",
        VAL: "BlinkMacSystemFont"
    },
    {
        NAME: "custom",
        VAL: "Helvetica Neue"
    },
    {
        NAME: "custom",
        VAL: "Arial"
    },
    "sansSerif"
], undefined, undefined, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4), _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Components_bs_js__WEBPACK_IMPORTED_MODULE_8__.t(undefined, undefined, undefined, undefined, undefined, _prezzee_ribbon_src_components_common_Tag_Tag_Theme_bs_js__WEBPACK_IMPORTED_MODULE_2__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple50 */ .Il.purple50, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple400 */ .Il.purple400, undefined), _prezzee_ribbon_src_components_common_Tagline_Tagline_Theme_bs_js__WEBPACK_IMPORTED_MODULE_4__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.red400 */ .Il.red400, undefined), undefined, _prezzee_ribbon_src_components_common_VideoTextPromoBlock_VideoTextPromoBlock_Theme_bs_js__WEBPACK_IMPORTED_MODULE_9__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.lilac50 */ .Il.lilac50, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray600 */ .Il.gray600, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.blue400 */ .Il.blue400, undefined), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined);
var business = _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_7__.t({
    default: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple400 */ .Il.purple400,
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple600 */ .Il.purple600,
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, {
    default: {
        NAME: "hex",
        VAL: "F93C28"
    },
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: {
        NAME: "hex",
        VAL: "900C20"
    },
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, {
    default: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray700 */ .Il.gray700,
    defaultText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white,
    hover: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800,
    hoverText: _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white
}, undefined, undefined, undefined, _bindings_BsCss_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4), _prezzee_ribbon_src_context_ThemeContext_ThemeContext_Components_bs_js__WEBPACK_IMPORTED_MODULE_8__.t(_prezzee_ribbon_src_components_common_FullWidthCarousel_FullWidthCarousel_Theme_bs_js__WEBPACK_IMPORTED_MODULE_10__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray300 */ .Il.gray300, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple400 */ .Il.purple400, undefined), undefined, undefined, undefined, _prezzee_ribbon_src_components_personal_RegionPicker_RegionPicker_Theme_bs_js__WEBPACK_IMPORTED_MODULE_6__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray600 */ .Il.gray600, undefined, undefined, undefined, undefined, undefined), undefined, undefined, undefined, undefined, _prezzee_ribbon_src_components_common_Footer_Footer_Theme_bs_js__WEBPACK_IMPORTED_MODULE_3__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.purple600 */ .Il.purple600, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray300 */ .Il.gray300, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.white */ .Il.white, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray300 */ .Il.gray300, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800, _Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.gray800 */ .Il.gray800, undefined), undefined, _prezzee_ribbon_src_components_personal_EmailSignUp_EmailSignUp_Theme_bs_js__WEBPACK_IMPORTED_MODULE_5__.t(_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Color.lilac400 */ .Il.lilac400, undefined, undefined, undefined), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined);
 /* personal Not a pure module */ 


/***/ }),

/***/ 55374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Il": function() { return /* binding */ Color; },
/* harmony export */   "oo": function() { return /* binding */ hexToRgb; },
/* harmony export */   "z0": function() { return /* binding */ Styles; }
/* harmony export */ });
var Color;
(function(Color) {
    Color["Error"] = "#E30B17";
    Color["BorderGray"] = "#767676";
    Color["DarkGray"] = "#313E49";
    Color["LightGray"] = "#A9AAA9";
    Color["BackgroundGray"] = "#E5E5E5";
    Color["InactiveGray"] = "#a9a9a9";
    Color["PrimaryBlue"] = "#3E77B0";
    Color["LightBlue"] = "#ECF1F7";
    Color["Primary"] = "#E30B17";
    Color["White"] = "#FFFFFF";
    Color["Purple700"] = "#2B0840";
    Color["Purple600"] = "#32064C";
    Color["Purple500"] = "#410861";
    Color["Purple400"] = "#48096C";
    Color["Purple300"] = "#6D3A89";
    Color["Purple200"] = "#916BA7";
    Color["Purple100"] = "#DACEE2";
    Color["Purple50"] = "#EDE6F0";
    Color["Red700"] = "#480610";
    Color["Red600"] = "#900C20";
    Color["Red500"] = "#BE1807";
    Color["Red400"] = "#ED1E09";
    Color["Red300"] = "#F1453A";
    Color["Red200"] = "#F4736B";
    Color["Red100"] = "#FABCB5";
    Color["Red50"] = "#FDE9E6";
    Color["Pink700"] = "#CC7970";
    Color["Pink600"] = "#FF978C";
    Color["Pink500"] = "#FFB6AF";
    Color["Pink400"] = "#FFD2BD";
    Color["Pink300"] = "#FFE0D1";
    Color["Pink200"] = "#FFE9DE";
    Color["Pink100"] = "#FFF6F2";
    Color["Pink50"] = "#FFFBF8";
    Color["Lilac700"] = "#A09EB0";
    Color["Lilac600"] = "#B7B5C9";
    Color["Lilac500"] = "#CECBE2";
    Color["Lilac400"] = "#E5E2FB";
    Color["Lilac300"] = "#EAE8FC";
    Color["Lilac200"] = "#EDEBFC7";
    Color["Lilac100"] = "#F7F5FD";
    Color["Lilac50"] = "#F6F7F9";
    Color["Blue700"] = "#102C60";
    Color["Blue600"] = "#174291";
    Color["Blue500"] = "#1E54B7";
    Color["Blue400"] = "#276EF1";
    Color["Blue300"] = "#5B91F5";
    Color["Blue200"] = "#A0BFF8";
    Color["Blue100"] = "#D4E2FC";
    Color["Blue50"] = "#EFF3FE";
    Color["Green700"] = "#0B3429";
    Color["Green600"] = "#166852";
    Color["Green500"] = "#1E8B6D";
    Color["Green400"] = "#25AE88";
    Color["Green300"] = "#51BEA0";
    Color["Green200"] = "#7CCEB8";
    Color["Green100"] = "#A8DFCF";
    Color["Green50"] = "#E9F7F3";
    Color["Yellow700"] = "#806022";
    Color["Yellow600"] = "#B3862F";
    Color["Yellow500"] = "#CC9A36";
    Color["Yellow400"] = "#FFC043";
    Color["Yellow300"] = "#FFCF70";
    Color["Yellow200"] = "#FFE3AC";
    Color["Yellow100"] = "#FFF2D9";
    Color["Yellow50"] = "#FFFAF0";
    Color["Orange700"] = "#7D2714";
    Color["Orange600"] = "#AE371C";
    Color["Orange500"] = "#CC492C";
    Color["Orange400"] = "#FF6937";
    Color["Orange300"] = "#FA9269";
    Color["Orange200"] = "#FABDA5";
    Color["Orange100"] = "#FFE1D6";
    Color["Orange50"] = "#FFF3EF";
    Color["Black"] = "#000000";
    Color["Gray800"] = "#1E1E1E";
    Color["Gray700"] = "#302F2F";
    Color["Gray600"] = "#4B4B4B";
    Color["Gray500"] = "#787878";
    Color["Gray400"] = "#A0A0A0";
    Color["Gray300"] = "#C7C3C3";
    Color["Gray200"] = "#E0DEDE";
    Color["Gray100"] = "#F0EDED";
    Color["Gray50"] = "#F8F8F8";
    Color["AccentPink"] = "#FFC5EE";
    Color["AccentYellow"] = "#C7C3C3";
    Color["AccentBlue"] = "#C7C3C3";
})(Color || (Color = {}));
var Styles = {
    BorderRadius: "10px"
};
//https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var hexValue = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexValue);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ].join(",") : null;
}


/***/ }),

/***/ 59945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70655);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31611);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35248);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85518);
/* harmony import */ var common_utils_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53782);










/**
 * Handles all segment events.
 */ var useSegment = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var user = (0,contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)().user;
    var deviceInfo = (0,react_device_detect__WEBPACK_IMPORTED_MODULE_4__/* .parseUserAgent */ .rQ)( true ? window.navigator.userAgent : 0);
    var deviceType = (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.device.type) || "desktop";
    var deviceName = "".concat(deviceType, " ").concat(deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.os.name);
    var isPb = router.pathname.startsWith("/business");
    var getGaClientId = function() {
        var id = js_cookie__WEBPACK_IMPORTED_MODULE_3___default().get("_ga") || common_utils_string__WEBPACK_IMPORTED_MODULE_5__/* .EMPTY_STRING */ .v6;
        return id.slice(6);
    };
    /**
   * @private Adds base context to all segment event calls.
   * @param payload The payload of the event.
   * @param event The name of the event.
   * @param version The event version.
   */ var trackWithContext = function(payload, event, version) {
        var baseContext = {
            store: isPb ? "business" : "consumer",
            server_region: "NZ",
            traits: user ? {
                email: user === null || user === void 0 ? void 0 : user.email,
                phone: user === null || user === void 0 ? void 0 : user.phoneNumber
            } : {}
        };
        var context = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, baseContext), {
            device: {
                name: deviceName,
                type: deviceType
            }
        });
        if (version) {
            context.protocols = {
                event_version: version
            };
        }
        var payloadWithBaseContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload, baseContext);
        try {
            analytics.track(event, payloadWithBaseContext, {
                context: context
            });
        } catch (error) {
            utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
                err: error,
                source: "External API - Segment"
            }, "error: unable to forward to segment");
        }
    };
    /**
   * @private Adds base context to all segment event calls.
   * @param payload The payload of the event.
   * @param event The name of the event.
   * @param version The event version.
   */ var trackWithContextAsync = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(payload, event, version) {
            var baseContext, context, payloadWithBaseContext, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        baseContext = {
                            store: isPb ? "business" : "consumer",
                            server_region: "NZ",
                            traits: user ? {
                                email: user === null || user === void 0 ? void 0 : user.email,
                                phone: user === null || user === void 0 ? void 0 : user.phoneNumber
                            } : {}
                        };
                        context = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, baseContext), {
                            device: {
                                name: deviceName,
                                type: deviceType
                            }
                        });
                        if (version) {
                            context.protocols = {
                                event_version: version
                            };
                        }
                        payloadWithBaseContext = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload, baseContext);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            analytics.track(event, payloadWithBaseContext, {
                                context: context
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
                            err: error,
                            source: "External API - Segment"
                        }, "error: unable to forward to segment");
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function trackWithContextAsync(payload, event, version) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
   * @public Tracks a product viewed event.
   * @param sku The Sku that was viewed.
   * @param purchaseInstanceId The generated purchase instance ID of the viewed product.
   */ var productViewed = function(sku, purchaseInstanceId) {
        var ref, ref1, ref2, ref3;
        var payload = {
            categories: sku.categories.map(function(category) {
                return category.name;
            }),
            category: ((ref = sku.categories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
            image_url: ((ref2 = sku.themes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.image) || "",
            name: sku.displayName,
            nonInteraction: 1,
            product_id: sku.uid,
            purchase_instance_id: purchaseInstanceId,
            quantity: 1,
            sku: sku.slug,
            ga_clientid: getGaClientId()
        };
        return trackWithContext(payload, "Product Viewed", 2);
    };
    /**
   * @public Tracks coupon/promo entered event
   * @param payload The payload of the event.
   */ var couponEntered = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            user_type: "consumer"
        }), "Coupon Entered");
    };
    /**
   * @public Tracks coupon/promo removed event
   * @param payload The payload of the event.
   */ var couponRemoved = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            user_type: "consumer"
        }), "Coupon Removed");
    };
    /**
   * @public Tracks coupon/promo applied event
   * @param payload The payload of the event.
   */ var couponApplied = function(payload) {
        return trackWithContext(payload, "Coupon Applied");
    };
    /**
   * @public Tracks coupon/promo applied event
   * @param payload The payload of the event.
   */ var couponDenied = function(payload) {
        return trackWithContext(payload, "Coupon Denied");
    };
    /**
   * @public Tracks a product clicked event
   * @param payload The payload of the event.
   */ var productClicked = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Product Clicked", 2);
    };
    /**
   * @public Tracks a product added event
   * @param payload The payload of the event.
   */ var productAdded = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            url: window.location.href,
            ga_clientid: getGaClientId()
        }), "Product Added", 2);
    };
    /**
   * @public Tracks a product added event
   * @param payload The payload of the event.
   */ var productRemoved = function(payload) {
        return trackWithContext(payload, "Product Removed", 2);
    };
    /**
   * @public Tracks a search of products event
   * @param payload The payload of the event.
   */ var productsSearched = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Products Searched");
    };
    /**
   * @public Tracks a checkout step completed event (ie. pick/wrap/deliver/pay section).
   * @param payload The payload of the event.
   */ var checkoutStepCompleted = function(payload) {
        return trackWithContext(payload, "Checkout Step Completed", 2);
    };
    /**
   * @public Tracks a custom element interaction event (ie. purchase type selected - myself/for someone else)
   * @param payload The payload of the event.
   */ var customElementInteraction = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Custom Element Interaction");
    };
    /**
   * @public Tracks a custom element interaction event (ie. purchase type selected - myself/for someone else)
   * @param payload The payload of the event.
   */ var filterSortApplied = function(payload) {
        return trackWithContext(payload, "Filter Sort Applied");
    };
    /**
   * @public Tracks a custom element interaction event (ie. purchase type selected - myself/for someone else)
   * @param payload The payload of the event.
   */ var customElementInteractionAsync = function(payload) {
        return trackWithContextAsync((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Custom Element Interaction");
    };
    /**
   * @public Tracks a checkout step viewed event (ie. pick/wrap/deliver/pay section).
   * @param payload The payload of the event.
   */ var checkoutStepViewed = function(payload) {
        return trackWithContext(payload, "Checkout Step Viewed");
    };
    /**
   * @public Tracks a completed order event after the user pays
   * @param payload The payload of the event.
   */ var orderCompleted = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            affiliation: isPb ? "business" : "consumer",
            ga_clientid: getGaClientId()
        }), "Order Completed", 3);
    };
    /**
   * @public Tracks a failed order event
   * @param payload The payload of the event.
   */ var orderFailed = function(sku, purchaseInstanceId, formValues, cardCustomisationState, failReason, total, paymentMethodId, order //optional as order may not exist yet
    ) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
        var customTheme = cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref = cardCustomisationState.customThemeDesigns) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image;
        var selectedCardDesign = (cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref2 = cardCustomisationState.selectedCardDesign) === null || ref2 === void 0 ? void 0 : ref2.isTemplate) && customTheme ? customTheme : cardCustomisationState === null || cardCustomisationState === void 0 ? void 0 : (ref3 = cardCustomisationState.selectedCardDesign) === null || ref3 === void 0 ? void 0 : ref3.imageUrl;
        var payload = {
            affiliation: isPb ? "business" : "consumer",
            buy_for: formValues === null || formValues === void 0 ? void 0 : formValues.purchaseType,
            coupon: (formValues === null || formValues === void 0 ? void 0 : (ref4 = formValues.promo) === null || ref4 === void 0 ? void 0 : ref4.promoCode) || "",
            currency: "NZD",
            delivery_method: (formValues === null || formValues === void 0 ? void 0 : formValues.scheduledDeliveryAt) ? "scheduled" : "now",
            fail_reason: failReason,
            order_number: (order === null || order === void 0 ? void 0 : order.orderNumber) || "",
            payment_method: paymentMethodId || "",
            purchase_instance_id: purchaseInstanceId,
            total: total,
            video_message: (formValues === null || formValues === void 0 ? void 0 : (ref5 = formValues.giftMedia) === null || ref5 === void 0 ? void 0 : ref5.videoId) ? true : false,
            recipient_count: formValues.purchaseType === "friend" ? (formValues === null || formValues === void 0 ? void 0 : (ref6 = formValues.recipients) === null || ref6 === void 0 ? void 0 : ref6.length) || 1 : 1,
            products: [
                {
                    categories: sku === null || sku === void 0 ? void 0 : sku.categories.map(function(categories) {
                        return categories.name;
                    }),
                    category: (sku === null || sku === void 0 ? void 0 : sku.categories.length) > 0 && (sku === null || sku === void 0 ? void 0 : sku.categories[0].name),
                    image_url: selectedCardDesign || (sku === null || sku === void 0 ? void 0 : (ref7 = sku.themes) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.image),
                    name: (sku === null || sku === void 0 ? void 0 : sku.displayName) || "",
                    price: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.value),
                    product_id: sku === null || sku === void 0 ? void 0 : sku.uid,
                    quantity: 1,
                    sku: (sku === null || sku === void 0 ? void 0 : sku.slug) || "",
                    url: window.location.href
                }, 
            ]
        };
        return trackWithContext(payload, "Order Failed", 2);
    };
    /**
   * @public Tracks a gifs searched event.
   * @param payload The payload of the event.
   */ var gifSearched = function(payload) {
        return trackWithContext(payload, "Gif Searched");
    };
    /**
   * @public Tracks a sign in event.
   * @param payload The payload of the event.
   */ var signedIn = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Signed In");
    };
    /**
   * @public Tracks a sign up event.
   * @param payload The payload of the event.
   */ var signedUp = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Signed Up");
    };
    /**
   * @public Tracks a lead submitted event.
   * @param payload The payload of the event.
   */ var businessLeadSubmitted = function(payload) {
        return trackWithContext((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, payload), {
            ga_clientid: getGaClientId()
        }), "Lead Submitted");
    };
    return {
        productViewed: productViewed,
        checkoutStepCompleted: checkoutStepCompleted,
        customElementInteraction: customElementInteraction,
        customElementInteractionAsync: customElementInteractionAsync,
        checkoutStepViewed: checkoutStepViewed,
        productAdded: productAdded,
        productRemoved: productRemoved,
        productsSearched: productsSearched,
        orderCompleted: orderCompleted,
        orderFailed: orderFailed,
        couponApplied: couponApplied,
        couponDenied: couponDenied,
        gifSearched: gifSearched,
        couponEntered: couponEntered,
        couponRemoved: couponRemoved,
        signedIn: signedIn,
        signedUp: signedUp,
        filterSortApplied: filterSortApplied,
        productClicked: productClicked,
        businessLeadSubmitted: businessLeadSubmitted
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSegment);


/***/ }),

/***/ 12427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var contexts_LayoutDataContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25149);

var useSmartLink = function(elem) {
    var layoutData = (0,contexts_LayoutDataContext__WEBPACK_IMPORTED_MODULE_0__/* .useLayoutData */ .Q)();
    var elemId = elem.id || elem.itemId;
    // kontentData field is present when ?editor-mode=inline argument is present
    if (layoutData.kontentData) {
        var dataProps = {};
        if (elem.codename) {
            dataProps["data-kontent-element-codename"] = elem.codename;
        }
        if (elemId) {
            dataProps["data-kontent-item-id"] = elemId;
        }
        if (elem.button) {
            dataProps["data-kontent-add-button"] = true;
            if (elem.insertPosition) {
                dataProps["data-kontent-add-button-insert-position"] = elem.insertPosition;
            }
            if (elem.renderPosition) {
                dataProps["data-kontent-add-button-render-position"] = elem.renderPosition;
            }
        }
        return dataProps;
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (useSmartLink);


/***/ }),

/***/ 96547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ make$1; }
});

// UNUSED EXPORTS: AppStoreBadges, Footer, FooterContainer, Kontent, NewsletterForm, PrezzeeCampaignActivateButton, RegionIndicatorCountryDisplay, RegionIndicatorTextual, RegionPicker, Styles, ThemeContext, appStores, columns, cookieSettingItem, isStg, linkItem, linkList, linkListIcon, mailtoItem, removeTrailingSlash, toStgUrl

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/Config.bs.js
var Config_bs = __webpack_require__(43217);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_array.js
var js_array = __webpack_require__(32867);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Result.js
var belt_Result = __webpack_require__(70677);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/utils/FormHelpers.bs.js
var FormHelpers_bs = __webpack_require__(43243);
// EXTERNAL MODULE: ./src/components/pages/index/IndexStyles.bs.js
var IndexStyles_bs = __webpack_require__(28848);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/CookieSettingButton.bs.js + 1 modules
var CookieSettingButton_bs = __webpack_require__(1223);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer.bs.js
var Footer_bs = __webpack_require__(56473);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
// EXTERNAL MODULE: ./src/components/library/NewsletterSubscription.bs.js
var NewsletterSubscription_bs = __webpack_require__(20025);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js + 1 modules
var TextField_bs = __webpack_require__(98923);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Link.bs.js
var Footer_Link_bs = __webpack_require__(24798);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Theme.bs.js
var Footer_Theme_bs = __webpack_require__(38715);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/AppStoreBadges/AppStoreBadges.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function badgesWrapper(size) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* flexWrap */.WOS("wrap"),
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(size)),
        BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs.em(0.25)),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.em(0.25))
    ]);
}
var Styles = {
    badgesWrapper: badgesWrapper
};
function AppStoreBadges(props) {
    var height = props.height;
    var height$1 = height !== undefined ? height : 40;
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: badgesWrapper(height$1)
    });
}
var Single;
var make = AppStoreBadges;
 /* react/jsx-runtime Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Column.bs.js
var Footer_Column_bs = __webpack_require__(50574);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Heading.bs.js
var Footer_Heading_bs = __webpack_require__(92426);
// EXTERNAL MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js + 1 modules
var Gql_DictionaryItems_Decoder_bs = __webpack_require__(44623);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__LinkList.bs.js
var Footer_LinkList_bs = __webpack_require__(48778);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Copyright.bs.js
var Footer_Copyright_bs = __webpack_require__(57787);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Responsive.bs.js
var Footer_Responsive_bs = __webpack_require__(42465);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__SocialIcon.bs.js + 1 modules
var Footer_SocialIcon_bs = __webpack_require__(70966);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorFlag.bs.js
var RegionIndicatorFlag_bs = __webpack_require__(15772);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Button/index.js
var Button = __webpack_require__(43515);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Stack/index.js
var Stack = __webpack_require__(72406);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Typography/index.js
var Typography = __webpack_require__(43543);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/LockKeyholeIcon.js
var LockKeyholeIcon = __webpack_require__(24290);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/icons/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(29306);
// EXTERNAL MODULE: ./src/contexts/GrowthBookContext.tsx + 6 modules
var GrowthBookContext = __webpack_require__(14872);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
;// CONCATENATED MODULE: ./src/layouts/PrezzeeCampaignActivateButton.tsx










// Pages we exclude from pesenting the Activate CTA Button
var EXCLUDED_PATHNAMES = [
    "/wallet",
    "/my-details",
    "/reminders",
    "/orders",
    "/login",
    "/register"
];
var PrezzeeCampaignActivateButton = function(param) {
    var displayWhen = param.displayWhen;
    var businessCampaignRedeemCodeCtaEnabled = (0,GrowthBookContext/* useGrowthbookFeatureValue */.ej)("business-campaign-redeem-code-cta");
    var customElementInteraction = (0,useSegment/* default */.Z)().customElementInteraction;
    var router = (0,next_router.useRouter)();
    if (!businessCampaignRedeemCodeCtaEnabled) return null;
    if (EXCLUDED_PATHNAMES.some(function(path) {
        return router.pathname.startsWith(path);
    })) return null;
    var onClickCta = function() {
        customElementInteraction({
            journey: "campaign_redeem_code",
            element: "campaign_activate_cta",
            user_type: "consumer"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Box["default"], {
        as: Stack.VStack,
        alignItems: "flex-start",
        mt: "6",
        gap: "3",
        gridColumn: "1/-1",
        sx: {
            "@media (max-width: 720px)": {
                display: displayWhen === "mobile" ? "flex" : "none"
            },
            "@media (min-width: 728px)": {
                display: displayWhen === "tabletOrDesktop" ? "flex" : "none"
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Typography["default"], {
                variant: "body1",
                fontWeight: "normal",
                textColor: "gray.800",
                children: "Looking for me?"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("a", {
                href: "/code",
                target: "_blank",
                onClick: onClickCta,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button["default"], {
                    variant: "secondary",
                    leftIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LockKeyholeIcon/* default */.Z, {}),
                    rightIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ArrowRightIcon/* default */.Z, {}),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
                        as: "span",
                        mr: "1",
                        mb: "0.5",
                        children: "Activate my gift"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var layouts_PrezzeeCampaignActivateButton = (PrezzeeCampaignActivateButton);

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/AppStoreBadges/AppStoreBadge__Single.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


var badgeWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.em(0.25)),
    BsCssJs_bs/* selector */.nZE("img", [
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.em(1.0)),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* auto */.d73)
    ])
]);
var AppStoreBadge_Single_bs_Styles = {
    badgeWrapper: badgeWrapper
};
function AppStoreBadge__Single(props) {
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: badgeWrapper
    });
}
var AppStoreBadge_Single_bs_make = AppStoreBadge__Single;
 /* badgeWrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionList/RegionListLineContent.bs.js
var RegionListLineContent_bs = __webpack_require__(69422);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorTextual.bs.js
var RegionIndicatorTextual_bs = __webpack_require__(80176);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorCountryDisplay.bs.js
var RegionIndicatorCountryDisplay_bs = __webpack_require__(75870);
;// CONCATENATED MODULE: ./src/layouts/Footer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













































var Footer_bs_make = layouts_PrezzeeCampaignActivateButton;
var Footer_bs_PrezzeeCampaignActivateButton = {
    make: Footer_bs_make
};
var footer = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* position */.FKU("relative"),
    tl: /* [] */ 0
});
var subscribeColumn = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* mobile */.ai, {
        hd: Css_bs/* gridRowStart */.lpz(1),
        tl: /* [] */ 0
    }),
    tl: {
        hd: Css_bs/* media */.BC2(Footer_Responsive_bs/* tablet */.Mq, {
            hd: Css_bs/* important */.efO(Css_bs/* unsafe */.K47("gridColumn", "span 3")),
            tl: /* [] */ 0
        }),
        tl: /* [] */ 0
    }
});
var successText = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* fontSize */.JBY(Css_bs.px(18)),
    tl: {
        hd: Css_bs/* lineHeight */.Nv8(Css_bs.px(24)),
        tl: {
            hd: Css_bs/* backgroundColor */.Czw(Css_bs/* rgba */.m4f(255, 255, 255, {
                NAME: "num",
                VAL: 0.1
            })),
            tl: {
                hd: Css_bs/* borderRadius */.E0l(Css_bs.px(100)),
                tl: {
                    hd: Css_bs/* width */.bf$(Css_bs.px(250)),
                    tl: {
                        hd: Css_bs/* height */.Cb8(Css_bs.px(38)),
                        tl: {
                            hd: Css_bs/* display */.jfB("flex"),
                            tl: {
                                hd: Css_bs/* justifyContent */.KlP("center"),
                                tl: {
                                    hd: Css_bs/* alignItems */.cq$("center"),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var emailField = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* marginRight */.wzR(Css_bs.px(10)),
    tl: {
        hd: Css_bs/* flexGrow */.H78(1),
        tl: {
            hd: Css_bs/* flexShrink */.i4v(1),
            tl: {
                hd: Css_bs/* marginBottom */.yl7(Css_bs.px(25)),
                tl: /* [] */ 0
            }
        }
    }
});
var regionChange = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* selector */.nZE("." + RegionIndicatorFlag_bs/* Styles.flagBlock */.z.flagBlock, {
        hd: Css_bs/* color */.$_Y(Theme_bs/* Color.blue400 */.Il.blue400),
        tl: /* [] */ 0
    }),
    tl: /* [] */ 0
});
var Footer_bs_Styles = {
    footer: footer,
    subscribeColumn: subscribeColumn,
    successText: successText,
    emailField: emailField,
    regionChange: regionChange
};
function linkListIcon(lli) {
    if (lli.TAG !== /* FontAwesomeIcon */ 0) {
        return null;
    }
    var fa = lli._0;
    return jsx_runtime.jsx(Footer_SocialIcon_bs/* make */.S, {
        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
            icon: [
                fa.style,
                fa.icon
            ]
        })
    });
}
function linkItem(ll) {
    var router = next_router.useRouter();
    var icon = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(ll.icon, linkListIcon), null);
    var match = ll.smartLink;
    var codename = match.codename;
    var itemId = match.itemId;
    var href = ll.url;
    var target = ll.open_in_new_window ? "_blank" : "_self";
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsxs("a", {
                children: [
                    icon,
                    ll.link_text
                ],
                className: "cursor-pointer",
                onClick: function onClick(param) {
                    if (js_array/* includes */.q9(codename, [
                        "footer_link___faqs",
                        "faqs_8e9b029",
                        "footer_link___faqs_991e620",
                        "footer_link___faqs_1d1815d"
                    ])) {
                        js_promise/* $$catch */.y(function(param) {
                            return Promise.resolve((window.open(href, target), undefined));
                        }, js_promise/* then_ */.k(function(param) {
                            return Promise.resolve((window.open(href, target), undefined));
                        }, Segment_bs/* customElementInteractionAsync */.GS({
                            element: "bottomnav_faqs",
                            path: router.asPath
                        })));
                    } else if (js_array/* includes */.q9(codename, [
                        "footer_link___contact_us"
                    ])) {
                        js_promise/* $$catch */.y(function(param) {
                            return Promise.resolve((window.open(href, target), undefined));
                        }, js_promise/* then_ */.k(function(param) {
                            return Promise.resolve((window.open(href, target), undefined));
                        }, Segment_bs/* customElementInteractionAsync */.GS({
                            element: "bottomnav_contact_us",
                            path: router.asPath
                        })));
                    } else {
                        window.open(href, target);
                    }
                }
            })
        }),
        itemId: itemId,
        elementCodename: codename
    }, itemId);
}
function mailtoItem(ll) {
    var match = ll.smartLink;
    var itemId = match.itemId;
    var href = "mailto:" + ll.email_address;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsx("a", {
                children: ll.link_text,
                href: href
            })
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function cookieSettingItem(ll) {
    var match = ll.smartLink;
    var itemId = match.itemId;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Footer_Link_bs/* make */.S, {
            children: jsx_runtime.jsx(CookieSettingButton_bs/* make */.S, {
                text: ll.text
            })
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function linkList(ll) {
    var variant = ll.NAME;
    if (variant === "MailtoLinkContentType") {
        return mailtoItem(ll.VAL);
    } else if (variant === "OnetrustCookieSettingButtonContentType") {
        return cookieSettingItem(ll.VAL);
    } else {
        return linkItem(ll.VAL);
    }
}
function columns(col) {
    var match = col.smartLink;
    var itemId = match.itemId;
    return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsxs(Footer_Column_bs/* make */.S, {
            children: [
                jsx_runtime.jsx(Kontent_bs/* Context.Provider.make */._.Provider.make, {
                    children: jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                        children: col.title
                    }),
                    elementCodename: "title"
                }),
                jsx_runtime.jsx(Footer_LinkList_bs/* make */.S, {
                    children: belt_Array/* map */.UI(col.links, linkList)
                })
            ]
        }),
        itemId: itemId,
        elementCodename: match.codename
    }, itemId);
}
function appStores(stores) {
    var badges = function badges(s) {
        var match = s.smartLink;
        var match$1 = s.app_store_image;
        var description = match$1.description;
        return jsx_runtime.jsx(AppStoreBadge_Single_bs_make, {
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                    children: jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                            src: match$1.url,
                            alt: description !== "" ? description : s.app_store_name,
                            width: match$1.width,
                            height: match$1.height
                        }),
                        href: s.app_store_download_link
                    })
                }),
                itemId: match.itemId,
                elementCodename: match.codename
            })
        }, s.app_store_name);
    };
    return jsx_runtime.jsx(make, {
        children: belt_Array/* map */.UI(stores, badges)
    });
}
function removeTrailingSlash(url) {
    var slashIndex = url.lastIndexOf("/");
    if (slashIndex === (url.length - 1 | 0)) {
        return url.substring(0, slashIndex);
    } else {
        return url;
    }
}
var isStg = "https://www.prezzee.co.nz/".includes("stg");
function toStgUrl(url) {
    return url.replace("https://www.prezzee", "https://stg.prezzee");
}
function Footer$NewsletterForm(props) {
    var form = props.form;
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var footer = belt_Option/* flatMap */.VS(state, function(s) {
        return s.footer;
    });
    var subscribe_helper_text = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.subscribe_helper_text;
    }), "");
    var subscribe_cta = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer, function(f) {
        return f.subscribe_cta;
    }), "");
    var match = belt_Option/* mapWithDefault */.k7(footer, [
        /* Regular */ 0,
        /* Primary */ 5,
        /* Contained */ 0
    ], function(f) {
        return f.subscribe_cta_style;
    });
    return jsx_runtime.jsx("form", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx(TextField_bs/* make */.Sy, {
                    className: emailField,
                    label: subscribe_helper_text,
                    name: "email_address",
                    theme: /* Light */ 0,
                    type_: "email",
                    error: belt_Option/* isSome */.pC(FormHelpers_bs/* getFieldError */.zQ(form.errors, "email_address")),
                    helperText: FormHelpers_bs/* getFieldError */.zQ(form.errors, "email_address"),
                    inputRef: caml_option/* some */.G(curry._1(form.register, NewsletterSubscription_bs/* newsletterInput */.T))
                }),
                jsx_runtime.jsx(Button_bs.make, {
                    children: jsx_runtime.jsx("button", {
                        children: util_bs/* ReactStuff.s */.p_.s(subscribe_cta),
                        disabled: form.formState.isSubmitted,
                        type: "submit"
                    }),
                    fill: match[2],
                    colour: match[1],
                    variant: match[0]
                })
            ],
            className: "flex flex-wrap"
        }),
        onSubmit: curry._2(form.handleSubmit, props.onSubmit, FormHelpers_bs/* onError */.qQ)
    });
}
var NewsletterForm = {
    make: Footer$NewsletterForm
};
function Footer(props) {
    var data = props.data;
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var footer$1 = data !== undefined ? data : belt_Option/* flatMap */.VS(state, function(s) {
        return s.footer;
    });
    var footerItemId = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.smartLink.itemId;
    }), "");
    var footerCodename = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.smartLink.codename;
    }), "");
    var subscribe_title = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.subscribe_title;
    }), "");
    var region_selector_text = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.region_selector_text;
    }), "CHANGE");
    var currentYear = (new Date().getFullYear() | 0).toString();
    var disclaimer_level_1 = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.disclaimer_level_1;
    }), "").replace("{0}", currentYear);
    var disclaimer_level_2 = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.disclaimer_level_2;
    }), "").replace("{0}", currentYear);
    var app_store_title = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return util_bs/* ReactStuff.s */.p_.s(f.app_store_title);
    }), null);
    var app_stores = appStores(belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
        return f.app_stores_container;
    }), []));
    var footerTheme = belt_Option/* mapWithDefault */.k7(footer$1, Footer_Theme_bs.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), function(x) {
        return x.theme;
    });
    var currentTheme = ThemeContext_bs/* useTheme */.Fg(undefined);
    var init = currentTheme.components;
    var newTheme_primary = currentTheme.primary;
    var newTheme_secondary = currentTheme.secondary;
    var newTheme_tertiary = currentTheme.tertiary;
    var newTheme_displayFont = currentTheme.displayFont;
    var newTheme_headingFont = currentTheme.headingFont;
    var newTheme_bodyFont = currentTheme.bodyFont;
    var newTheme_borderRadius = currentTheme.borderRadius;
    var newTheme_components = {
        fullWidthCarousel: init.fullWidthCarousel,
        iconCard: init.iconCard,
        contentCard: init.contentCard,
        regionStrip: init.regionStrip,
        regionPicker: init.regionPicker,
        tag: init.tag,
        tagline: init.tagline,
        uniqueSellingPoints: init.uniqueSellingPoints,
        videoTextPromoBlock: init.videoTextPromoBlock,
        footer: footerTheme,
        textField: init.textField,
        emailSignUp: init.emailSignUp,
        smallHeroTile: init.smallHeroTile,
        largeHeroTile: init.largeHeroTile,
        categoryTile: init.categoryTile,
        downloadAppsBanner: init.downloadAppsBanner,
        promoTiles: init.promoTiles,
        customerCareBanner: init.customerCareBanner,
        customerCareCallUs: init.customerCareCallUs
    };
    var newTheme = {
        primary: newTheme_primary,
        secondary: newTheme_secondary,
        tertiary: newTheme_tertiary,
        displayFont: newTheme_displayFont,
        headingFont: newTheme_headingFont,
        bodyFont: newTheme_bodyFont,
        borderRadius: newTheme_borderRadius,
        components: newTheme_components
    };
    var regions = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.regions;
    }), []);
    var domainPostfix = belt_Result/* mapWithDefault */.k7(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), "", function(c) {
        return util_bs/* EnvUtil.getDomainPostfix */.i3.getDomainPostfix(c);
    });
    var regionIndex = belt_Option/* getWithDefault */.tj(belt_Array/* getIndexBy */._n(regions, function(region) {
        return removeTrailingSlash(region.url).endsWith(domainPostfix);
    }), 0);
    var match = react.useState(function() {
        return regionIndex;
    });
    var setSelectedRegion = match[1];
    var selectedRegion = match[0];
    var onChange = function onChange(selected) {
        curry._1(setSelectedRegion, function(param) {
            return selected;
        });
        var region = belt_Array/* get */.U2(regions, selected);
        var url = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(region, function(r) {
            if (isStg) {
                return r.url.replace("https://www.prezzee", "https://stg.prezzee");
            } else {
                return r.url;
            }
        }), "");
        var changeLocation = function cl(url) {
            window.location.assign(url);
        };
        return changeLocation(url);
    };
    var newsletterSuccess = jsx_runtime.jsx("p", {
        children: util_bs/* ReactStuff.s */.p_.s("Woohoo! You're on the list."),
        className: successText
    });
    var regionIndicator = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(s) {
        return s.dictionaryItems;
    }), function(s) {
        return s.app_yourcurrentshoppingregion;
    }), {
        value: "You're currently shopping in {0}",
        smartLink: Gql_DictionaryItems_Decoder_bs/* emptyDictionaryEntry.smartLink */.$d.smartLink
    }, function(param) {
        var smartLink = param.smartLink;
        var value = param.value;
        if (value === "") {
            return {
                value: "You're currently shopping in {0}",
                smartLink: smartLink
            };
        } else {
            return {
                value: value,
                smartLink: smartLink
            };
        }
    });
    var regionIndicatorText = regionIndicator.value;
    var match$1 = regionIndicator.smartLink;
    var regionModalItemId = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.smartLink.itemId;
    }), "");
    var regionModalCodename = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.smartLink.codename;
    }), "");
    var regionPickerTitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.title;
    }), "Change location");
    var regionPickerSubtitle = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.subtitle;
    }), "Want to send gift cards to family and friends in another country? Change your region below.");
    var regionPickerCtaText = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(belt_Option/* flatMap */.VS(state, function(r) {
        return r.location;
    }), function(r) {
        return r.ctaText;
    }), "Save location");
    var regionPickerStrings = {
        heading: regionPickerTitle,
        heading_subtext: regionPickerSubtitle,
        cta_button: regionPickerCtaText
    };
    var regionListLines = belt_Array/* map */.UI(regions, function(r) {
        var match = r.regionListLine;
        var smartLink = match.smartLink;
        var flag = match.flag;
        var currency = match.currency;
        var name = match.name;
        var el = jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(RegionListLineContent_bs/* make */.S, {
                flag: flag,
                name: name,
                currency: currency
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
        return {
            name: name,
            currency: currency,
            flag: flag,
            el: el
        };
    });
    return jsx_runtime.jsxs(ThemeContext_bs/* Provider.make */.zt.make, {
        value: newTheme,
        children: [
            jsx_runtime.jsxs(Footer_bs/* make */.Sy, {
                children: [
                    belt_Array/* map */.UI(belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(footer$1, function(f) {
                        return f.link_columns;
                    }), []), columns),
                    jsx_runtime.jsxs(Footer_Column_bs/* make */.S, {
                        children: [
                            jsx_runtime.jsxs(KontentContextProvider_bs/* make */.S, {
                                children: [
                                    jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                                        children: util_bs/* ReactStuff.s */.p_.s(subscribe_title)
                                    }),
                                    jsx_runtime.jsx(NewsletterSubscription_bs/* make */.S, {
                                        formComponent: Footer$NewsletterForm,
                                        successElement: newsletterSuccess
                                    })
                                ],
                                itemId: footerItemId,
                                elementCodename: footerCodename
                            }),
                            jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                                children: jsx_runtime.jsx("div", {
                                    children: jsx_runtime.jsx(RegionIndicatorTextual_bs/* make */.S, {
                                        regions: regionListLines,
                                        strings: regionPickerStrings,
                                        selected: selectedRegion,
                                        children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                                            children: jsx_runtime.jsx(RegionIndicatorCountryDisplay_bs/* make */.S, {
                                                text: regionIndicatorText,
                                                regions: regionListLines,
                                                selected: selectedRegion
                                            }),
                                            itemId: match$1.itemId,
                                            elementCodename: match$1.codename
                                        }),
                                        onChange: onChange,
                                        text: region_selector_text
                                    }),
                                    className: regionChange
                                }),
                                itemId: regionModalItemId,
                                elementCodename: regionModalCodename
                            }),
                            jsx_runtime.jsxs(KontentContextProvider_bs/* make */.S, {
                                children: [
                                    jsx_runtime.jsx(Footer_Heading_bs/* make */.S, {
                                        children: app_store_title
                                    }),
                                    app_stores
                                ],
                                itemId: footerItemId,
                                elementCodename: footerCodename
                            }),
                            jsx_runtime.jsx(Footer_bs_make, {
                                displayWhen: "tabletOrDesktop"
                            })
                        ],
                        colWidth: 2,
                        className: subscribeColumn
                    }),
                    jsx_runtime.jsx(Footer_bs_make, {
                        displayWhen: "mobile"
                    }),
                    jsx_runtime.jsxs(Footer_Copyright_bs/* make */.S, {
                        children: [
                            disclaimer_level_1 !== "" ? jsx_runtime.jsx("div", {
                                children: disclaimer_level_1
                            }) : null,
                            disclaimer_level_2 !== "" ? jsx_runtime.jsx("div", {
                                children: disclaimer_level_2
                            }) : null
                        ]
                    })
                ],
                className: Cn_bs/* make */.S([
                    IndexStyles_bs/* section */.qi,
                    footer
                ])
            }),
            jsx_runtime.jsx("div", {
                children: util_bs/* ReactStuff.s */.p_.s(Config_bs/* buildVersion */.Bm),
                className: "hidden"
            })
        ]
    });
}
var Kontent;
var Footer$1;
var RegionIndicatorTextual;
var RegionIndicatorCountryDisplay;
var RegionPicker;
var Footer_bs_AppStoreBadges;
var FooterContainer;
var ThemeContext;
var make$1 = Footer;
 /* make Not a pure module */ 


/***/ }),

/***/ 19638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z0": function() { return /* binding */ Page_bs_Styles; },
  "Sy": function() { return /* binding */ make$2; }
});

// UNUSED EXPORTS: BusinessTopNavigationBar, ConsumerNavigation, Head, HeaderContainer, KontentContextConsumer, Link, Navigation, NavigationItem, RegionIndicatorCountryDisplay, RegionIndicatorInline, RegionIndicatorStrip, RegionPicker, RegionPickerInline, RegionStrip, StaticBackground, StickyBar, TopNavigationBar, TopNavigationBarAuthContainer, TopNavigationBarNavLinks, flexibleContainer, isMenuOpen, myAccountRoutes

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layouts/Footer.bs.js + 3 modules
var Footer_bs = __webpack_require__(96547);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/auth/user/UserContext.bs.js
var UserContext_bs = __webpack_require__(81098);
;// CONCATENATED MODULE: ./src/layouts/HeaderStyles.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function navBarLinksContainer(isOpen) {
    var containerStyle = "lg:flex lg:justify-between sm:py-0 bg-white lg:h-full lg:my-auto z-50 w-full";
    return Cn_bs/* make */.S([
        containerStyle,
        isOpen ? "block" : "hidden",
        containerStyle
    ]);
}
var responsiveLeftButton = "block lg:hidden w-5 h-5 rounded hover:border-gray-400 hover:text-prezzee-red focus:outline-none";
var responsiveRightButton = "block w-8 rounded hover:border-prezzee-red hover:text-prezzee-red focus:outline-none";
var navBarLink = "text-mid-gray lg:border-t-3 border-white hover:text-prezzee-red hover:border-prezzee-red flex items-center justify-between focus:text-prezzee-red focus:border-prezzee-red active:text-prezzee-red active:border-prezzee-red h-11 lg:h-full transition-all duration-500 ease-in-out bg-white px-4 lg:px-0 md:text-sm xl:text-base";
var linkText = "";
var grayLine = " border-gray-200 border-b w-full lg:hidden";
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/library/NavBarLinks.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








function NavBarLinks(props) {
    var setVisible = props.setVisible;
    var visible = props.visible;
    var match = UserContext_bs.useUser(undefined);
    var user = match[0];
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx((link_default()), {
                href: "/store",
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("Buy eGift Cards"),
                            className: linkText
                        }),
                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: "lg:hidden"
                        })
                    ],
                    className: navBarLink,
                    title: "Buy eGift Cards"
                })
            }),
            jsx_runtime.jsx("hr", {
                className: grayLine
            }),
            user ? jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx((link_default()), {
                        href: "/wallet",
                        prefetch: false,
                        children: jsx_runtime.jsxs("a", {
                            children: [
                                util_bs/* ReactStuff.s */.p_.s("My Wallet"),
                                jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "angle-right"
                                    ],
                                    className: "lg:hidden"
                                })
                            ],
                            className: Cn_bs/* make */.S([
                                navBarLink,
                                "h-11 lg:h-full"
                            ]),
                            title: "wallet",
                            onClick: function onClick(param) {
                                curry._1(setVisible, function(param) {
                                    return false;
                                });
                            }
                        })
                    }),
                    jsx_runtime.jsx("hr", {
                        className: grayLine
                    })
                ]
            }) : null,
            jsx_runtime.jsx((link_default()), {
                href: "/business",
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("eGift Cards for Business"),
                            className: linkText
                        }),
                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: "lg:hidden"
                        })
                    ],
                    className: navBarLink,
                    title: "eGift Cards for Business",
                    onClick: function onClick(param) {
                        curry._1(setVisible, function(param) {
                            return false;
                        });
                    }
                })
            }),
            jsx_runtime.jsx("hr", {
                className: grayLine
            }),
            jsx_runtime.jsx((link_default()), {
                href: "/international",
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("International eGift Cards"),
                            className: linkText
                        }),
                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: "lg:hidden"
                        })
                    ],
                    className: navBarLink,
                    title: "International eGift Cards",
                    onClick: function onClick(param) {
                        curry._1(setVisible, function(param) {
                            return false;
                        });
                    }
                })
            }),
            jsx_runtime.jsx("hr", {
                className: grayLine
            }),
            jsx_runtime.jsx((link_default()), {
                href: "/contact",
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("Customer Care"),
                            className: linkText
                        }),
                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: "lg:hidden"
                        })
                    ],
                    className: navBarLink,
                    title: "Customer Care",
                    onClick: function onClick(param) {
                        curry._1(setVisible, function(param) {
                            return false;
                        });
                    }
                })
            }),
            jsx_runtime.jsx("hr", {
                className: grayLine
            }),
            jsx_runtime.jsx((link_default()), {
                href: "/about",
                prefetch: false,
                children: jsx_runtime.jsxs("a", {
                    children: [
                        jsx_runtime.jsx("p", {
                            children: util_bs/* ReactStuff.s */.p_.s("About Us"),
                            className: linkText
                        }),
                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: "lg:hidden"
                        })
                    ],
                    className: navBarLink,
                    title: "About Us",
                    onClick: function onClick(param) {
                        curry._1(setVisible, function(param) {
                            return false;
                        });
                    }
                })
            }),
            jsx_runtime.jsx("hr", {
                className: grayLine
            }),
            user ? jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx((link_default()), {
                                href: "/my-details",
                                prefetch: false,
                                children: jsx_runtime.jsxs("a", {
                                    children: [
                                        util_bs/* ReactStuff.s */.p_.s("My Account"),
                                        jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                            icon: [
                                                "fas",
                                                "angle-right"
                                            ],
                                            className: "lg:hidden"
                                        })
                                    ],
                                    className: Cn_bs/* make */.S([
                                        navBarLink,
                                        "lg:hidden"
                                    ]),
                                    title: "account",
                                    onClick: function onClick(param) {
                                        curry._1(setVisible, function(param) {
                                            return false;
                                        });
                                    }
                                })
                            }),
                            jsx_runtime.jsx("hr", {
                                className: grayLine
                            })
                        ]
                    }),
                    jsx_runtime.jsx((link_default()), {
                        href: "/logout",
                        prefetch: false,
                        children: jsx_runtime.jsx("div", {
                            children: jsx_runtime.jsx("button", {
                                children: util_bs/* ReactStuff.s */.p_.s("Sign Out"),
                                "aria-label": "Logout Button",
                                className: "mt-20 mb-20 lg:hidden w-full mx-auto text-prezzee-red"
                            }),
                            className: "bg-white shadow-2xl rounded-b-lg"
                        })
                    })
                ]
            }) : jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx((link_default()), {
                        href: "/login",
                        prefetch: false,
                        children: jsx_runtime.jsxs("a", {
                            children: [
                                util_bs/* ReactStuff.s */.p_.s("Log In"),
                                jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "angle-right"
                                    ],
                                    className: "lg:hidden"
                                })
                            ],
                            className: Cn_bs/* make */.S([
                                navBarLink,
                                "lg:hidden"
                            ]),
                            title: "Log In",
                            onClick: function onClick(param) {
                                curry._1(setVisible, function(param) {
                                    return false;
                                });
                            }
                        })
                    }),
                    jsx_runtime.jsx("hr", {
                        className: grayLine
                    }),
                    jsx_runtime.jsx((link_default()), {
                        href: "/register",
                        prefetch: false,
                        children: jsx_runtime.jsxs("a", {
                            children: [
                                util_bs/* ReactStuff.s */.p_.s("Sign up"),
                                jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "angle-right"
                                    ],
                                    className: "lg:hidden"
                                })
                            ],
                            className: Cn_bs/* make */.S([
                                navBarLink,
                                "lg:hidden"
                            ]),
                            title: "register",
                            onClick: function onClick(param) {
                                curry._1(setVisible, function(param) {
                                    return false;
                                });
                            }
                        })
                    }),
                    jsx_runtime.jsx("hr", {
                        className: grayLine
                    })
                ],
                className: "lg:hidden"
            })
        ],
        className: navBarLinksContainer(visible),
        onClick: function onClick(param) {
            curry._1(setVisible, function(param) {
                return !visible;
            });
        }
    });
}
var Link$1;
var make = NavBarLinks;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./src/components/library/Button.bs.js
var Button_bs = __webpack_require__(59037);
;// CONCATENATED MODULE: ./src/components/library/NavBarUserModal.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function visibilityContainer(v) {
    return Cn_bs/* make */.S([
        v ? "visible animate__animated animate__fadeIn" : "invisible"
    ]);
}
function visibilityModal(v) {
    return Cn_bs/* make */.S([
        v ? "visible animate__animated animate__fadeIn" : "invisible"
    ]);
}
var liStyle = "flex items-center py-1";
var iconStyle = "mr-4 text-prezzee-red h-2 w-2";
function NavBarUserModal(props) {
    var setVisible = props.setVisible;
    var visible = props.visible;
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("span", {
                        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ]
                        }),
                        className: Cn_bs/* make */.S([
                            "hidden lg:flex items-center justify-center h-8 w-8 overflow-visible rounded-full bg-prezzee-red fill-current text-white cursor-pointer relative -ml-3 z-40 transition-colors duration-300 ease-in-out hover:shadow-md",
                            visibilityContainer(visible)
                        ]),
                        onClick: function onClick(e) {
                            e.preventDefault();
                            curry._1(setVisible, function(param) {
                                return false;
                            });
                        }
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx((link_default()), {
                                href: "/register",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Create my account"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryStyle */.vP,
                                        "block mx-auto w-56 mt-12 text-white text-center shadow-md border-2 py-3 border-prezzee-red hover:text-prezzee-red hover:bg-white hover:border-prezzee-red focus:text-prezzee-red focus:bg-white focus:border-prezzee-red transition-colors duration-300 ease-in-out"
                                    ]),
                                    onClick: function onClick(param) {
                                        curry._1(setVisible, function(param) {
                                            return false;
                                        });
                                    }
                                })
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx("img", {
                                    className: "block ml-auto",
                                    alt: "Why create an account",
                                    src: __webpack_require__(34076)
                                }),
                                className: "w-1/2 my-2"
                            }),
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("strong", {
                                        children: util_bs/* ReactStuff.s */.p_.s("WHY?"),
                                        className: "leading-normal font-bold"
                                    }),
                                    jsx_runtime.jsxs("ul", {
                                        children: [
                                            jsx_runtime.jsxs("li", {
                                                children: [
                                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                        icon: [
                                                            "fas",
                                                            "circle"
                                                        ],
                                                        className: iconStyle
                                                    }),
                                                    util_bs/* ReactStuff.s */.p_.s("Keep all my gift cards in one place")
                                                ],
                                                className: liStyle
                                            }),
                                            jsx_runtime.jsxs("li", {
                                                children: [
                                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                        icon: [
                                                            "fas",
                                                            "circle"
                                                        ],
                                                        className: iconStyle
                                                    }),
                                                    util_bs/* ReactStuff.s */.p_.s("Fast access from my phone while I shop")
                                                ],
                                                className: liStyle
                                            }),
                                            jsx_runtime.jsxs("li", {
                                                children: [
                                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                        icon: [
                                                            "fas",
                                                            "circle"
                                                        ],
                                                        className: iconStyle
                                                    }),
                                                    util_bs/* ReactStuff.s */.p_.s("Secure digital wallet")
                                                ],
                                                className: liStyle
                                            }),
                                            jsx_runtime.jsxs("li", {
                                                children: [
                                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                        icon: [
                                                            "fas",
                                                            "circle"
                                                        ],
                                                        className: iconStyle
                                                    }),
                                                    util_bs/* ReactStuff.s */.p_.s("Get offers")
                                                ],
                                                className: liStyle
                                            }),
                                            jsx_runtime.jsxs("li", {
                                                children: [
                                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                        icon: [
                                                            "fas",
                                                            "circle"
                                                        ],
                                                        className: iconStyle
                                                    }),
                                                    util_bs/* ReactStuff.s */.p_.s("Send gift cards even faster")
                                                ],
                                                className: liStyle
                                            })
                                        ],
                                        className: "mt-4"
                                    })
                                ],
                                className: "w-9/12 mx-auto"
                            }),
                            jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("hr", {
                                        className: "border-solid border-light-gray border-b w-1/3 mr-3"
                                    }),
                                    util_bs/* ReactStuff.s */.p_.s(" or "),
                                    jsx_runtime.jsx("hr", {
                                        className: "border-solid border-light-gray border-b w-1/3 ml-3"
                                    })
                                ],
                                className: "flex items-center text-light-gray justify-center my-10"
                            }),
                            jsx_runtime.jsx((link_default()), {
                                href: "/login",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Log in"),
                                    className: Cn_bs/* make */.S([
                                        Button_bs/* primaryOutlineStyle */.e1,
                                        "mt-4 block mx-auto w-56 text-center text-white shadow-md border-2 py-3 border-prezzee-red focus:bg-prezzee-red focus:text-white transition-colors duration-300 ease-in-out"
                                    ]),
                                    onClick: function onClick(param) {
                                        curry._1(setVisible, function(param) {
                                            return false;
                                        });
                                    }
                                })
                            }),
                            jsx_runtime.jsx("span", {
                                children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "times"
                                    ]
                                }),
                                className: "absolute flex items-center justify-center left-0 top-0 ml-2 mt-2 h-6 w-6 rounded-full text-gray-500 cursor-pointer lg:hidden",
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    curry._1(setVisible, function(param) {
                                        return false;
                                    });
                                }
                            })
                        ],
                        className: Cn_bs/* make */.S([
                            "fixed right-0 inset-y-0 bg-white w-full md:w-7/12 lg:w-1/2 xl:w-4/12 overflow-auto mt-18",
                            visibilityModal(visible)
                        ]),
                        onClick: function onClick(e) {
                            e.preventDefault();
                        }
                    })
                ],
                className: "fixed flex items-center w-full md:w-7/12 lg:w-1/2 xl:w-4/12 h-full right-0"
            }),
            className: Cn_bs/* make */.S([
                "fixed z-40 inset-0 flex bg-smoke-light",
                visibilityContainer(visible)
            ]),
            tabIndex: -1,
            onClick: function onClick(e) {
                e.preventDefault();
                curry._1(setVisible, function(param) {
                    return false;
                });
            }
        })
    });
}
var NavBarUserModal_bs_Link$1;
var NavBarUserModal_bs_make = NavBarUserModal;
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/NavBarLinksMobileStyles.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function NavBarLinksMobileStyles_bs_navBarLinksContainer(isOpen) {
    var containerStyle = "fixed left-0 right-0 bottom-0 top-0 mt-18 bg-white z-50";
    return Cn_bs/* make */.S([
        containerStyle,
        isOpen ? "block" : "hidden",
        containerStyle
    ]);
}
var NavBarLinksMobileStyles_bs_responsiveLeftButton = "block w-5 rounded hover:border-gray-400 hover:text-prezzee-red focus:outline-none";
var NavBarLinksMobileStyles_bs_responsiveRightButton = "block w-5 rounded hover:border-gray-400 hover:text-prezzee-red focus:outline-none";
var NavBarLinksMobileStyles_bs_navBarLink = "block text-mid-gray border-white hover:text-prezzee-red hover:border-prezzee-red flex items-center justify-between focus:text-prezzee-red focus:border-prezzee-red active:text-prezzee-red active:border-prezzee-red h-11 transition-all duration-500 ease-in-out bg-white px-4";
var NavBarLinksMobileStyles_bs_linkText = "";
var NavBarLinksMobileStyles_bs_grayLine = " border-gray-200 border-b w-full";
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/components/library/NavBarLinksMobile.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








function NavBarLinksMobile(props) {
    var setVisible = props.setVisible;
    var visible = props.visible;
    var match = UserContext_bs.useUser(undefined);
    var user = match[0];
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx((link_default()), {
                    href: "/store",
                    prefetch: false,
                    children: jsx_runtime.jsxs("a", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Buy eGift Cards"),
                                className: NavBarLinksMobileStyles_bs_linkText
                            }),
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "angle-right"
                                ],
                                className: "lg:hidden"
                            })
                        ],
                        className: NavBarLinksMobileStyles_bs_navBarLink,
                        title: "Buy eGift Cards"
                    })
                }),
                jsx_runtime.jsx("hr", {
                    className: NavBarLinksMobileStyles_bs_grayLine
                }),
                user ? jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx((link_default()), {
                            href: "/wallet",
                            prefetch: false,
                            children: jsx_runtime.jsxs("a", {
                                children: [
                                    util_bs/* ReactStuff.s */.p_.s("My Wallet"),
                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "fas",
                                            "angle-right"
                                        ],
                                        className: "lg:hidden"
                                    })
                                ],
                                className: Cn_bs/* make */.S([
                                    NavBarLinksMobileStyles_bs_navBarLink,
                                    "h-11 lg:h-full"
                                ]),
                                title: "wallet",
                                onClick: function onClick(param) {
                                    curry._1(setVisible, function(param) {
                                        return false;
                                    });
                                }
                            })
                        }),
                        jsx_runtime.jsx("hr", {
                            className: NavBarLinksMobileStyles_bs_grayLine
                        })
                    ]
                }) : null,
                jsx_runtime.jsx((link_default()), {
                    href: "/business",
                    prefetch: false,
                    children: jsx_runtime.jsxs("a", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("eGift Cards for Business"),
                                className: NavBarLinksMobileStyles_bs_linkText
                            }),
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "angle-right"
                                ],
                                className: "lg:hidden"
                            })
                        ],
                        className: NavBarLinksMobileStyles_bs_navBarLink,
                        title: "eGift Cards for Business",
                        onClick: function onClick(param) {
                            curry._1(setVisible, function(param) {
                                return false;
                            });
                        }
                    })
                }),
                jsx_runtime.jsx("hr", {
                    className: NavBarLinksMobileStyles_bs_grayLine
                }),
                jsx_runtime.jsx((link_default()), {
                    href: "/international",
                    prefetch: false,
                    children: jsx_runtime.jsxs("a", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("International eGift Cards"),
                                className: NavBarLinksMobileStyles_bs_linkText
                            }),
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "angle-right"
                                ],
                                className: "lg:hidden"
                            })
                        ],
                        className: NavBarLinksMobileStyles_bs_navBarLink,
                        title: "International eGift Cards",
                        onClick: function onClick(param) {
                            curry._1(setVisible, function(param) {
                                return false;
                            });
                        }
                    })
                }),
                jsx_runtime.jsx("hr", {
                    className: NavBarLinksMobileStyles_bs_grayLine
                }),
                jsx_runtime.jsx((link_default()), {
                    href: "/contact",
                    prefetch: false,
                    children: jsx_runtime.jsxs("a", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("Customer Care"),
                                className: NavBarLinksMobileStyles_bs_linkText
                            }),
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "angle-right"
                                ],
                                className: "lg:hidden"
                            })
                        ],
                        className: NavBarLinksMobileStyles_bs_navBarLink,
                        title: "Customer Care",
                        onClick: function onClick(param) {
                            curry._1(setVisible, function(param) {
                                return false;
                            });
                        }
                    })
                }),
                jsx_runtime.jsx("hr", {
                    className: NavBarLinksMobileStyles_bs_grayLine
                }),
                jsx_runtime.jsx((link_default()), {
                    href: "/about",
                    prefetch: false,
                    children: jsx_runtime.jsxs("a", {
                        children: [
                            jsx_runtime.jsx("p", {
                                children: util_bs/* ReactStuff.s */.p_.s("About Us"),
                                className: NavBarLinksMobileStyles_bs_linkText
                            }),
                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                icon: [
                                    "fas",
                                    "angle-right"
                                ],
                                className: "lg:hidden"
                            })
                        ],
                        className: NavBarLinksMobileStyles_bs_navBarLink,
                        title: "About Us",
                        onClick: function onClick(param) {
                            curry._1(setVisible, function(param) {
                                return false;
                            });
                        }
                    })
                }),
                jsx_runtime.jsx("hr", {
                    className: NavBarLinksMobileStyles_bs_grayLine
                }),
                user ? jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx((link_default()), {
                                    href: "/my-details",
                                    prefetch: false,
                                    children: jsx_runtime.jsxs("a", {
                                        children: [
                                            util_bs/* ReactStuff.s */.p_.s("My Account"),
                                            jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                                icon: [
                                                    "fas",
                                                    "angle-right"
                                                ],
                                                className: "lg:hidden"
                                            })
                                        ],
                                        className: Cn_bs/* make */.S([
                                            NavBarLinksMobileStyles_bs_navBarLink,
                                            "lg:hidden"
                                        ]),
                                        title: "account",
                                        onClick: function onClick(param) {
                                            curry._1(setVisible, function(param) {
                                                return false;
                                            });
                                        }
                                    })
                                }),
                                jsx_runtime.jsx("hr", {
                                    className: NavBarLinksMobileStyles_bs_grayLine
                                })
                            ]
                        }),
                        jsx_runtime.jsx((link_default()), {
                            href: "/logout",
                            prefetch: false,
                            children: jsx_runtime.jsx("a", {
                                children: util_bs/* ReactStuff.s */.p_.s("Sign Out"),
                                "aria-label": "Logout Button",
                                className: "block text-center mt-20 mb-20 lg:hidden w-full mx-auto text-prezzee-red focus:outline-none"
                            })
                        })
                    ]
                }) : jsx_runtime.jsxs("div", {
                    children: [
                        jsx_runtime.jsx((link_default()), {
                            href: "/login",
                            prefetch: false,
                            children: jsx_runtime.jsxs("a", {
                                children: [
                                    util_bs/* ReactStuff.s */.p_.s("Log In"),
                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "fas",
                                            "angle-right"
                                        ],
                                        className: "lg:hidden"
                                    })
                                ],
                                className: Cn_bs/* make */.S([
                                    NavBarLinksMobileStyles_bs_navBarLink,
                                    "lg:hidden"
                                ]),
                                title: "Log In",
                                onClick: function onClick(param) {
                                    curry._1(setVisible, function(param) {
                                        return false;
                                    });
                                }
                            })
                        }),
                        jsx_runtime.jsx("hr", {
                            className: NavBarLinksMobileStyles_bs_grayLine
                        }),
                        jsx_runtime.jsx((link_default()), {
                            href: "/register",
                            prefetch: false,
                            children: jsx_runtime.jsxs("a", {
                                children: [
                                    util_bs/* ReactStuff.s */.p_.s("Sign up"),
                                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "fas",
                                            "angle-right"
                                        ],
                                        className: "lg:hidden"
                                    })
                                ],
                                className: Cn_bs/* make */.S([
                                    NavBarLinksMobileStyles_bs_navBarLink,
                                    "lg:hidden"
                                ]),
                                title: "register",
                                onClick: function onClick(param) {
                                    curry._1(setVisible, function(param) {
                                        return false;
                                    });
                                }
                            })
                        }),
                        jsx_runtime.jsx("hr", {
                            className: NavBarLinksMobileStyles_bs_grayLine
                        })
                    ],
                    className: "lg:hidden"
                })
            ],
            className: NavBarLinksMobileStyles_bs_navBarLinksContainer(visible),
            onClick: function onClick(param) {
                curry._1(setVisible, function(param) {
                    return !visible;
                });
            }
        }),
        className: "h-screen"
    });
}
var NavBarLinksMobile_bs_Link$1;
var NavBarLinksMobile_bs_make = NavBarLinksMobile;
 /* Util Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/NavBarUserDropdown.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







function NavBarUserDropdown(props) {
    var match = react.useState(function() {
        return false;
    });
    var setIsOpen = match[1];
    var isOpen = match[0];
    var match$1 = UserContext_bs.useUser(undefined);
    var user = match$1[0];
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs("button", {
                children: [
                    user ? util_bs/* ReactStuff.s */.p_.s("Hi " + user._0.firstName) : null,
                    jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                        icon: [
                            "fas",
                            "ellipsis-v"
                        ],
                        className: "ml-1"
                    })
                ],
                "aria-label": "Logout Button",
                className: "relative z-10 block text-sm text-prezzee-red hover:text-prezzee-blue focus:outline-none mr-3 lg:mr-5 xl:mr-8",
                onClick: function onClick(param) {
                    curry._1(setIsOpen, function(param) {
                        return !isOpen;
                    });
                }
            }),
            isOpen ? jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("button", {
                        className: "fixed inset-0 w-full h-full cursor-default",
                        tabIndex: -1,
                        onClick: function onClick(param) {
                            curry._1(setIsOpen, function(param) {
                                return false;
                            });
                        }
                    }),
                    jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx((link_default()), {
                                href: "/my-details",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("My Account"),
                                    className: "block px-4 py-2 text-dark-gray hover:bg-prezzee-blue hover:text-white text-sm",
                                    title: "My Account"
                                })
                            }),
                            jsx_runtime.jsx("hr", {
                                className: "border-solid border-smoke-light border-b w-full"
                            }),
                            jsx_runtime.jsx((link_default()), {
                                href: "/forgot-password",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Change Password"),
                                    className: "block px-4 py-2 text-dark-gray hover:bg-prezzee-blue hover:text-white text-sm",
                                    title: "Change Password"
                                })
                            }),
                            jsx_runtime.jsx("hr", {
                                className: "border-solid border-smoke-light border-b w-full"
                            }),
                            jsx_runtime.jsx((link_default()), {
                                href: "/logout",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: util_bs/* ReactStuff.s */.p_.s("Sign Out"),
                                    className: "block px-4 py-2 text-dark-gray hover:bg-prezzee-blue hover:text-white text-sm",
                                    title: "Sign Out"
                                })
                            })
                        ],
                        className: "bg-white rounded-lg py-1 w-48 mt-2 shadow-xl absolute right-0 border"
                    })
                ]
            }) : null
        ],
        className: "relative"
    });
}
var NavBarUserDropdown_bs_Link$1;
var NavBarUserDropdown_bs_make = NavBarUserDropdown;
 /* Util Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/components/Box/index.js
var Box = __webpack_require__(18636);
// EXTERNAL MODULE: ./src/contexts/NavVisibilityContext.tsx
var NavVisibilityContext = __webpack_require__(28750);
;// CONCATENATED MODULE: ./src/components/library/HeaderContainer.tsx




var HeaderContainer = function(param) {
    var children = param.children, isMenuOpen = param.isMenuOpen;
    var isVisible = (0,NavVisibilityContext/* useNavVisibilty */.K3)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Box["default"], {
        as: "header",
        position: "sticky",
        top: "0px",
        left: "0px",
        right: "0px",
        backgroundColor: "white",
        borderBottom: "1px",
        borderBottomColor: "gray.100",
        zIndex: "50",
        transition: {
            base: "transform 400ms ease",
            xl: "unset"
        },
        transform: {
            base: isVisible || isMenuOpen.contents ? "translateY(0%)" : "translateY(-100%)",
            xl: "unset"
        },
        children: children
    });
};
/* harmony default export */ var library_HeaderContainer = (HeaderContainer);

;// CONCATENATED MODULE: ./src/layouts/Header.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













var Header_bs_make = library_HeaderContainer;
var Header_bs_HeaderContainer = {
    make: Header_bs_make
};
var isMenuOpen = {
    contents: false
};
function Header(props) {
    var match = react.useState(function() {
        return false;
    });
    var setIsOpen = match[1];
    var isOpen = match[0];
    var match$1 = react.useState(function() {
        return false;
    });
    var setModalVisible = match$1[1];
    var isModalVisible = match$1[0];
    var match$2 = UserContext_bs.useUser(undefined);
    var disableWindowScroll = function disableWindowScroll(isDisabled) {
        document.documentElement.style.setProperty("touch-action", isDisabled ? "none" : "");
        document.documentElement.style.setProperty("overflow", isDisabled ? "hidden" : "");
    };
    react.useEffect(function() {
        disableWindowScroll(isOpen || isModalVisible);
    }, [
        isOpen,
        isModalVisible
    ]);
    isMenuOpen.contents = isOpen || isModalVisible;
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(Header_bs_make, {
                children: jsx_runtime.jsx("nav", {
                    children: jsx_runtime.jsxs("div", {
                        children: [
                            jsx_runtime.jsx("button", {
                                children: isOpen ? jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "times"
                                    ],
                                    className: "w-5 h-5 fill-current"
                                }) : jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "bars"
                                    ],
                                    className: "w-5 h-5 fill-current"
                                }),
                                "aria-label": "Navigation menu toggle",
                                className: responsiveLeftButton,
                                onClick: function onClick(param) {
                                    curry._1(setIsOpen, function(param) {
                                        return !isOpen;
                                    });
                                }
                            }),
                            jsx_runtime.jsx((link_default()), {
                                href: "/",
                                prefetch: false,
                                children: jsx_runtime.jsx("a", {
                                    children: jsx_runtime.jsx("img", {
                                        className: "w-7",
                                        alt: "Prezzee Logo",
                                        src: __webpack_require__(56393)
                                    }),
                                    title: "Homepage"
                                })
                            }),
                            jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx(make, {
                                    visible: isOpen,
                                    setVisible: setIsOpen
                                }),
                                className: "hidden lg:block h-full w-11/12 lg:w-9/12 xl:w-8/12"
                            }),
                            match$2[0] ? jsx_runtime.jsxs("div", {
                                children: [
                                    jsx_runtime.jsx("div", {
                                        children: jsx_runtime.jsx(NavBarUserDropdown_bs_make, {}),
                                        className: "hidden lg:block"
                                    }),
                                    jsx_runtime.jsx("div", {
                                        className: "w-1/3"
                                    })
                                ]
                            }) : jsx_runtime.jsx("div", {
                                children: jsx_runtime.jsx("button", {
                                    children: jsx_runtime.jsx("img", {
                                        className: "h-4 w-4",
                                        alt: "user icon",
                                        src: __webpack_require__(49031)
                                    }),
                                    "aria-label": "Login Button",
                                    className: Cn_bs/* make */.S([
                                        "h-12 w-12 border-1 rounded-full flex items-center justify-center lg:mr-5 xl:mr-8 transition-all duration-300 ease-in-out focus:outline-none",
                                        isModalVisible ? "border-prezzee-red shadow-md bg-white-smoke" : "hover:border-prezzee-red hover:shadow-md hover:bg-white-smoke"
                                    ]),
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        curry._1(setModalVisible, function(param) {
                                            return !isModalVisible;
                                        });
                                    }
                                })
                            })
                        ],
                        className: "flex items-center justify-between h-full px-5 lg:p-0 w-full"
                    }),
                    className: "inset-x-0 z-50 bg-white w-full lg:flex lg:justify-between lg:items-center lg:pl-10 h-18 border-b relative"
                }),
                isMenuOpen: isMenuOpen
            }),
            jsx_runtime.jsx("div", {
                children: isOpen ? jsx_runtime.jsx(NavBarLinksMobile_bs_make, {
                    visible: isOpen,
                    setVisible: setIsOpen
                }) : null,
                className: "lg:hidden"
            }),
            jsx_runtime.jsx(NavBarUserModal_bs_make, {
                visible: isModalVisible,
                setVisible: setModalVisible
            })
        ]
    });
}
var Header_bs_Link$1;
var make$1 = Header;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./src/layouts/Shared.bs.js
var Shared_bs = __webpack_require__(53827);
// EXTERNAL MODULE: ./src/css/Themes.bs.js
var Themes_bs = __webpack_require__(86167);
// EXTERNAL MODULE: ./src/bindings/Fresnel.bs.js
var Fresnel_bs = __webpack_require__(7545);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_obj.js
var caml_obj = __webpack_require__(84445);
// EXTERNAL MODULE: ./src/components/CmsImage.bs.js
var CmsImage_bs = __webpack_require__(34442);
;// CONCATENATED MODULE: ./src/api/graphql/AssetType.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
var emptyAsset = {
    name: "",
    description: "",
    url: "",
    width: 0,
    height: 0
};
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js
var emotion_css_esm = __webpack_require__(97133);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon-ui/lib/theme/foundations/colors.js
var colors = __webpack_require__(85171);
// EXTERNAL MODULE: ./src/hooks/useSmartLink.tsx
var useSmartLink = __webpack_require__(12427);
;// CONCATENATED MODULE: ./src/components/library/MenuPopup.tsx









var Styles = {
    popup: function(isOpen, isRight) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:block;position:absolute;top:100%;opacity:", isOpen ? 1 : 0, ";visibility:", isOpen ? "visible" : "hidden", ";transition:visibility 200ms linear,opacity 150ms linear;padding:8px;background:#ffffff;box-shadow:0px 20px 56px rgba(0,0,0,0.29);border-radius:8px;transform:translate(", isRight ? "0" : "50%", ",8px);right:", isRight ? "0" : "calc(50% - 5px)", ";");
    },
    linkArrow: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:absolute;top:50%;transform:translateY(-50%);right:16px;opacity:0;transition:right 200ms ease-in,opacity 200ms ease-in;"),
    link: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:block;padding:18px 47px 18px 12px;border-radius:4px;white-space:nowrap;position:relative;transition:background-color 200ms ease-in;&:hover,&:focus{background-color:", colors["default"].gray[100], ";svg{opacity:1;right:12px;}}"),
    button: function(isOpen) {
        return /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("position:relative;&::after{content:'';width:12px;height:12px;position:absolute;top:calc(100% + 10px);left:50%;transform-origin:center;transform:rotate(45deg) translate(-50%,0);border:8px solid transparent;border-top:6px solid #ffffff;border-left:6px solid #ffffff;z-index:20;visibility:", isOpen ? "visible" : "hidden", ";}");
    }
};
var MenuPopup = function(param) {
    var buttonLabel = param.buttonLabel, links = param.links, isPopupRight = param.isPopupRight, smartLink = param.smartLink;
    var ref = (0,react.useState)(false), isOpen = ref[0], setOpen = ref[1];
    var wrapperRef = (0,react.useRef)(null);
    var spotlightProps = (0,useSmartLink/* default */.Z)(smartLink);
    var closeOnOutsideClick = (0,react.useCallback)(function(e) {
        if (wrapperRef.current && wrapperRef.current !== e.target && !wrapperRef.current.contains(e.target)) {
            setOpen(false);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (isOpen) {
            document.addEventListener("click", closeOnOutsideClick);
        } else {
            document.removeEventListener("click", closeOnOutsideClick);
        }
        return function() {
            document.removeEventListener("click", closeOnOutsideClick);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: wrapperRef
    }, spotlightProps), {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                onClick: function() {
                    return setOpen(!isOpen);
                },
                className: Styles.button(isOpen),
                children: buttonLabel
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                className: Styles.popup(isOpen, isPopupRight),
                children: links.map(function(param, index) {
                    var text = param.text, url = param.url;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)((link_default()), {
                        href: url,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", {
                            role: "button",
                            className: Styles.link,
                            onClick: function() {
                                setOpen(false);
                            },
                            onKeyPress: function(e) {
                                if (e.key === "Enter") {
                                    setOpen(false);
                                }
                            },
                            tabIndex: index + 1,
                            children: [
                                text,
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "far",
                                        "arrow-right"
                                    ],
                                    color: colors["default"].purple[400],
                                    className: Styles.linkArrow,
                                    size: "sm"
                                })
                            ]
                        })
                    }, url);
                })
            })
        ]
    }));
};
/* harmony default export */ var library_MenuPopup = (MenuPopup);

;// CONCATENATED MODULE: ./src/components/library/MenuPopup.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var MenuPopup_bs_make = library_MenuPopup;
 /* make Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/LayoutDataContext.bs.js
var LayoutDataContext_bs = __webpack_require__(37110);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Auth/Auth.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var Auth_bs_Styles = {};
function Auth(props) {
    return belt_Option/* mapWithDefault */.k7(props.user, props.signedOut, props.signedIn);
}
var ProfileMenuPopover;
var SignedIn;
var SignedOut;
var SignedInMenuItem;
var BusinessSignedOut;
var Auth_bs_make = Auth;
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Layout.bs.js
var Theme_Layout_bs = __webpack_require__(51222);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Card/Card.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var card = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* borderRadius */.E0l(Theme_Layout_bs/* Personal.borderRadius */.R.borderRadius),
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* filter */.hXT([
        {
            NAME: "dropShadow",
            VAL: [
                BsCssJs_bs.px(0),
                BsCssJs_bs.px(4),
                BsCssJs_bs.px(12),
                BsCssJs_bs/* rgba */.m4f(0, 0, 0, {
                    NAME: "num",
                    VAL: 0.1
                })
            ]
        }
    ])
]);
var Card_bs_Styles = {
    card: card
};
function Card(props) {
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: card
    });
}
var Card_bs_make = Card;
 /* card Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./src/utils/routeUtils.ts
var routeUtils = __webpack_require__(64438);
// EXTERNAL MODULE: ./src/components/pages/index/KontentContextProvider.bs.js
var KontentContextProvider_bs = __webpack_require__(26396);
;// CONCATENATED MODULE: ./src/contexts/PaginatedDrawerContext.tsx


var DEFAULT_PAGE = {
    code: "default",
    parent: void 0
};
var PaginatedDrawerContext = /*#__PURE__*/ (0,react.createContext)({
    page: DEFAULT_PAGE,
    setPage: function() {
        return void 0;
    }
});
var PaginatedDrawerProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(DEFAULT_PAGE), page = ref[0], setPage = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PaginatedDrawerContext.Provider, {
        value: {
            page: page,
            setPage: setPage
        },
        children: children
    });
};
var usePaginatedDrawer = function() {
    var ctx = (0,react.useContext)(PaginatedDrawerContext);
    if (!ctx) throw new Error("usePaginationDrawer must be used within a PaginatedDrawerProvider");
    return ctx;
};

;// CONCATENATED MODULE: ./src/utils/PaginatedDrawerContext.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function useContext(prim) {
    return usePaginatedDrawer();
}
var defaultPage = DEFAULT_PAGE;
var PaginatedDrawerContext_bs_make = PaginatedDrawerProvider;
var PaginatedDrawerContext_bs_PaginatedDrawerProvider = {
    make: PaginatedDrawerContext_bs_make
};
 /* defaultPage Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/ReactResponsive/ReactResponsive.bs.js
var ReactResponsive_bs = __webpack_require__(36499);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/bindings/ReactResponsive/MediaQuery.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function MediaQuery(props) {
    var matches = ReactResponsive_bs/* useMediaQuery */.a(props.query);
    if (matches) {
        return props.children;
    } else {
        return null;
    }
}
var MediaQuery_bs_make = MediaQuery;
 /* ReactResponsive-PrezzeeRibbon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/ProfileMenu/ProfileMenu.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var menuBlock = BsCssJs_bs/* merge */.TSy([
    Theme_Typography_bs/* Styles.body */.z.body,
    BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.charcoal */.RL.charcoal)
    ])
]);
var ProfileMenu_bs_Styles = {
    menuBlock: menuBlock
};
function ProfileMenu(props) {
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: menuBlock
    });
}
var Line;
var Section;
var HiLine;
var ProfileMenu_bs_make = ProfileMenu;
 /* menuBlock Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/CallToAction/Gql__CallToAction__Decoder.bs.js
var Gql_CallToAction_Decoder_bs = __webpack_require__(93875);
// EXTERNAL MODULE: ./src/utils/useWindowSize.ts
var useWindowSize = __webpack_require__(55047);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Fresnel/Fresnel.bs.js + 1 modules
var Fresnel_Fresnel_bs = __webpack_require__(17847);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Animation.bs.js
var Theme_Animation_bs = __webpack_require__(78029);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Auth/Auth__SignedIn.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var icon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(14)),
    BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(7)),
    BsCssJs_bs/* transitionProperty */.n_e("transform"),
    BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* regular */.oN),
    BsCssJs_bs/* transitionTimingFunction */.BdG(BsCssJs_bs/* cubicBezier */._s1(0.4, 0, 0.2, 1)),
    BsCssJs_bs/* transitionDelay */.BFP(0),
    BsCssJs_bs/* transform */.vs(BsCssJs_bs/* rotate */.U1s(BsCssJs_bs/* deg */.OaU(0)))
]);
var iconExpanded = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* transform */.vs(BsCssJs_bs/* rotate */.U1s(BsCssJs_bs/* deg */.OaU(180)))
]);
var menuButtonContainer = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* flexDirection */.Me8("row"),
    BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(20)),
    BsCssJs_bs/* selector */.nZE("a", [
        BsCssJs_bs/* textDecoration */.QXS("none")
    ]),
    BsCssJs_bs/* children */.pIy([
        BsCssJs_bs/* firstChild */.mUE([
            BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.px(10))
        ])
    ])
]);
var Auth_SignedIn_bs_Styles = {
    icon: icon,
    iconExpanded: iconExpanded,
    menuButtonContainer: menuButtonContainer
};
function Auth__SignedIn(props) {
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(Fresnel_Fresnel_bs/* Media.make */.pU.make, {
                greaterThanOrEqual: "rbLargeDesktop",
                children: jsx_runtime.jsx("div", {
                    children: props.children,
                    className: menuButtonContainer
                })
            }),
            jsx_runtime.jsx(Fresnel_Fresnel_bs/* Media.make */.pU.make, {
                lessThan: "rbLargeDesktop",
                children: props.menuCard
            })
        ]
    });
}
var Auth_SignedIn_bs_ProfileMenuPopover;
var Auth_SignedIn_bs_make = Auth__SignedIn;
 /* icon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Auth/Auth__SignedOut.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var authButton = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* flexWrap */.WOS("wrap"),
    BsCssJs_bs/* flexBasis */.P_T(BsCssJs_bs/* pct */.hdZ(100)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, [
        BsCssJs_bs/* selector */.nZE("button", [
            BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(10)),
            BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(18)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(18)),
            BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(125)),
            BsCssJs_bs/* whiteSpace */.d8w("nowrap")
        ])
    ]),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
        BsCssJs_bs/* nthChild */.vvq({
            NAME: "add",
            VAL: [
                1,
                2
            ]
        }, [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(12)))
        ]),
        BsCssJs_bs/* selector */.nZE("button", [
            BsCssJs_bs/* flexBasis */.P_T(BsCssJs_bs/* pct */.hdZ(100))
        ])
    ])
]);
var Auth_SignedOut_bs_Styles = {
    authButton: authButton
};
function Auth__SignedOut(props) {
    return JsxRuntime.jsxs(React.Fragment, {
        children: [
            JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                children: props.signUpButton,
                variant: /* Small */ 1,
                className: authButton
            }),
            JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                children: props.signInButton,
                fill: /* Outlined */ 1,
                colour: /* Secondary */ 6,
                variant: /* Small */ 1,
                className: authButton
            })
        ]
    });
}
var Auth_SignedOut_bs_make = (/* unused pure expression or super */ null && (Auth__SignedOut));
 /* authButton Not a pure module */ 

// EXTERNAL MODULE: ./src/api/graphql/DictionaryItems/Gql__DictionaryItems__Decoder.bs.js + 1 modules
var Gql_DictionaryItems_Decoder_bs = __webpack_require__(44623);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faArrowRight.js
var faArrowRight = __webpack_require__(25215);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/ProfileMenu/ProfileMenu__Line.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var arrowRight = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y("transparent"),
    BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* fast */.q3),
    BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
    BsCssJs_bs/* transitionProperty */.n_e("color")
]);
var iconLine = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* cursor */.ocY("pointer"),
    BsCssJs_bs/* padding2 */.BLt(BsCssJs_bs.px(12), BsCssJs_bs.px(14)),
    BsCssJs_bs/* borderRadius */.E0l(Theme_Layout_bs/* Personal.borderRadius */.R.borderRadius),
    BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* fast */.q3),
    BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
    BsCssJs_bs/* transitionProperty */.n_e("background-color, color"),
    BsCssJs_bs/* hover */.MrM([
        BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey),
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.activeBlue */.RL.activeBlue),
        BsCssJs_bs/* selector */.nZE("." + arrowRight, [
            BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.activeBlue */.RL.activeBlue)
        ])
    ])
]);
var menuIcon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(18)),
    BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.px(16)),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* rem */.hOB(10)),
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* alignItems */.cq$("center")
]);
var childrenWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* flexGrow */.H78(1)
]);
var ProfileMenu_Line_bs_Styles = {
    arrowRight: arrowRight,
    iconLine: iconLine,
    menuIcon: menuIcon,
    childrenWrapper: childrenWrapper
};
function ProfileMenu__Line(props) {
    var arrowRight$1 = jsx_runtime.jsx(index_es.FontAwesomeIcon, {
        icon: faArrowRight.faArrowRight
    });
    return jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("div", {
                    children: props.icon,
                    className: menuIcon
                }),
                jsx_runtime.jsx("div", {
                    children: props.children,
                    className: childrenWrapper
                }),
                jsx_runtime.jsx("div", {
                    children: arrowRight$1,
                    className: arrowRight
                })
            ],
            className: iconLine,
            onClick: props.onClick
        })
    });
}
var ProfileMenu_Line_bs_make = ProfileMenu__Line;
 /* arrowRight Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/ProfileMenu/ProfileMenu__HiLine.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var hiLine = BsCssJs_bs/* merge */.TSy([
    Theme_Typography_bs/* Styles.smallBody */.z.smallBody,
    BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed),
        BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.px(14)),
        BsCssJs_bs/* padding2 */.BLt(BsCssJs_bs.px(12), BsCssJs_bs.px(14))
    ])
]);
var ProfileMenu_HiLine_bs_Styles = {
    hiLine: hiLine
};
function ProfileMenu__HiLine(props) {
    return jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
        children: jsx_runtime.jsx("div", {
            children: props.children,
            className: hiLine
        })
    });
}
var ProfileMenu_HiLine_bs_make = ProfileMenu__HiLine;
 /* hiLine Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/ProfileMenu/ProfileMenu__Section.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



var profileMenuSection = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs/* zero */.bMI),
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs.px(7)),
    BsCssJs_bs/* nthChild */.vvq({
        NAME: "add",
        VAL: [
            1,
            2
        ]
    }, [
        BsCssJs_bs/* borderTopWidth */.fCW(BsCssJs_bs.px(1)),
        BsCssJs_bs/* borderStyle */.$uf(BsCssJs_bs/* solid */.SQh),
        BsCssJs_bs/* borderTopColor */.SKu(Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey)
    ])
]);
var ProfileMenu_Section_bs_Styles = {
    profileMenuSection: profileMenuSection
};
function ProfileMenu__Section(props) {
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: profileMenuSection
    });
}
var ProfileMenu_Section_bs_make = ProfileMenu__Section;
 /* profileMenuSection Not a pure module */ 

// EXTERNAL MODULE: ./src/contexts/GrowthBookContext.tsx + 6 modules
var GrowthBookContext = __webpack_require__(14872);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Fonts.bs.js
var Theme_Fonts_bs = __webpack_require__(1476);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Auth/Auth__SignedInMenuItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var itemContainer = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("spaceEvenly"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(1000)),
    BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(125)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(32)),
    BsCssJs_bs/* hover */.MrM([
        BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.activeBluePaleBg */.RL.activeBluePaleBg),
        BsCssJs_bs/* children */.pIy([
            BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.activeBlue */.RL.activeBlue)
        ]),
        BsCssJs_bs/* cursor */.ocY("pointer")
    ])
]);
var title = BsCssJs_bs/* style */.oBv([
    Theme_Fonts_bs/* SofiaPro.family */.t.family,
    BsCssJs_bs/* fontWeight */.Ue2({
        NAME: "num",
        VAL: 400
    }),
    BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.px(22)),
    BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(3))
]);
var blueContainer = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.activeBluePaleBg */.RL.activeBluePaleBg)
]);
var grayContainer = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey)
]);
var activeBlueTheme = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.activeBlue */.RL.activeBlue)
]);
var darkTheme = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey)
]);
var Auth_SignedInMenuItem_bs_Styles = {
    itemContainer: itemContainer,
    title: title,
    blueContainer: blueContainer,
    grayContainer: grayContainer,
    activeBlueTheme: activeBlueTheme,
    darkTheme: darkTheme
};
function Auth__SignedInMenuItem(props) {
    var activeState = props.activeState;
    var colourContainerClass = activeState ? blueContainer : grayContainer;
    var iconTextColour = activeState ? activeBlueTheme : darkTheme;
    var itemContainer$1 = classnames_default()([
        itemContainer,
        colourContainerClass
    ]);
    var titleClass = classnames_default()([
        title,
        iconTextColour
    ]);
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: props.icon,
                className: iconTextColour
            }),
            jsx_runtime.jsx("div", {
                children: props.title,
                className: titleClass
            })
        ],
        className: itemContainer$1
    });
}
var Auth_SignedInMenuItem_bs_make = Auth__SignedInMenuItem;
 /* itemContainer Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Auth/Auth__Business__SignedOut.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var Auth_Business_SignedOut_bs_authButton = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* flexWrap */.WOS("wrap"),
    BsCssJs_bs/* flexBasis */.P_T(BsCssJs_bs/* pct */.hdZ(100)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, [
        BsCssJs_bs/* selector */.nZE("button", [
            BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(10)),
            BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(18)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(18)),
            BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(125)),
            BsCssJs_bs/* whiteSpace */.d8w("nowrap")
        ])
    ]),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
        BsCssJs_bs/* nthChild */.vvq({
            NAME: "add",
            VAL: [
                1,
                2
            ]
        }, [
            BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(12))
        ]),
        BsCssJs_bs/* selector */.nZE("button", [
            BsCssJs_bs/* flexBasis */.P_T(BsCssJs_bs/* pct */.hdZ(100)),
            BsCssJs_bs/* whiteSpace */.d8w("nowrap")
        ])
    ])
]);
var Auth_Business_SignedOut_bs_Styles = {
    authButton: Auth_Business_SignedOut_bs_authButton
};
var buttonColour_0 = Theme_Color_bs/* Common.prezzeeRed */.Gn.prezzeeRed;
var buttonColour_1 = Theme_Color_bs/* Business.white */.e.white;
var buttonColour_2 = Theme_Color_bs/* Common.darkRed */.Gn.darkRed;
var buttonColour = (0,_define_property/* default */.Z)({
    _0: buttonColour_0,
    _1: buttonColour_1,
    _2: buttonColour_2
}, Symbol.for("name"), "Custom");
function Auth__Business__SignedOut(props) {
    return JsxRuntime.jsxs(React.Fragment, {
        children: [
            JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                children: props.signInButton,
                fill: /* None */ 2,
                colour: buttonColour,
                className: Auth_Business_SignedOut_bs_authButton
            }),
            JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                children: props.signUpButton,
                colour: /* BusinessPurple */ 3,
                variant: /* Small */ 1,
                className: Auth_Business_SignedOut_bs_authButton
            })
        ]
    });
}
var Auth_Business_SignedOut_bs_make = (/* unused pure expression or super */ null && (Auth__Business__SignedOut));
 /* authButton Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/MenuCard.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




































function MenuCard_bs_useWindowSize(prim) {
    return UseWindowSizeTs(prim);
}
var customKontentEditSignInBtn = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* transform */.vs({
        NAME: "translateX",
        VAL: BsCss_bs.px(-40)
    }),
    tl: /* [] */ 0
});
var customKontentEditSignOutBtn = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(1)),
    tl: {
        hd: BsCss_bs/* transform */.vs({
            NAME: "translateY",
            VAL: BsCss_bs.px(-61)
        }),
        tl: /* [] */ 0
    }
});
var customKontentEditInlineName = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* height */.Cb8(BsCss_bs.px(1)),
    tl: {
        hd: BsCss_bs/* transform */.vs({
            NAME: "translateY",
            VAL: BsCss_bs.px(-33)
        }),
        tl: /* [] */ 0
    }
});
var signOutAnchor = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: {
        hd: BsCss_bs/* flexBasis */.P_T(BsCss_bs/* pct */.hdZ(100.0)),
        tl: /* [] */ 0
    }
});
var MenuCard_bs_icon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs.em(1)),
    tl: /* [] */ 0
});
var MenuCard_bs_Styles = {
    customKontentEditSignInBtn: customKontentEditSignInBtn,
    customKontentEditSignOutBtn: customKontentEditSignOutBtn,
    customKontentEditInlineName: customKontentEditInlineName,
    signOutAnchor: signOutAnchor,
    icon: MenuCard_bs_icon
};
function MenuCard$MenuCard(props) {
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var router = next_router.useRouter();
    var navMenuItems = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(state, function(s) {
        return s.mobileNavMenuBlock;
    }), []);
    var dictItems = belt_Option/* flatMap */.VS(state, function(s) {
        return s.dictionaryItems;
    });
    var hiLine = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(dictItems, function(s) {
        return s.app_menu_hi;
    }), {
        value: "Hi, {0}",
        smartLink: Gql_DictionaryItems_Decoder_bs/* emptyDictionaryEntry.smartLink */.$d.smartLink
    }, function(param) {
        var smartLink = param.smartLink;
        var value = param.value;
        if (value === "") {
            return {
                value: "Hi, {0}",
                smartLink: smartLink
            };
        } else {
            return {
                value: value,
                smartLink: smartLink
            };
        }
    });
    var hiLineText = hiLine.value.replace("{0}", props.name);
    var match = hiLine.smartLink;
    var menuItems = belt_Array/* mapWithIndex */.Su(navMenuItems, function(idx, param) {
        var smartLink = param.smartLink;
        var url = param.url;
        var icon = param.icon;
        var profileLine = icon !== undefined ? jsx_runtime.jsx(ProfileMenu_Line_bs_make, {
            icon: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                src: icon.url,
                alt: icon.description,
                width: icon.width,
                height: icon.height
            }),
            children: param.title,
            onClick: function onClick(param) {
                router.push(url);
            }
        }) : null;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: profileLine,
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        }, String(idx));
    });
    return jsx_runtime.jsx(Card_bs_make, {
        children: jsx_runtime.jsx(ProfileMenu_bs_make, {
            children: jsx_runtime.jsxs(ProfileMenu_Section_bs_make, {
                children: [
                    jsx_runtime.jsx(MediaQuery_bs_make, {
                        query: Theme_Responsive_bs/* belowLargeScreen */.Qo,
                        children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                            children: jsx_runtime.jsx(ProfileMenu_HiLine_bs_make, {
                                children: hiLineText
                            }),
                            itemId: match.itemId,
                            elementCodename: match.codename
                        })
                    }),
                    menuItems
                ]
            })
        })
    });
}
var MenuCard = {
    make: MenuCard$MenuCard
};
function MenuCard$SignedIn(props) {
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var router = next_router.useRouter();
    var menuCard = jsx_runtime.jsx(MenuCard$MenuCard, {
        name: props.user
    });
    var navMenuData = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(state, function(n) {
        return n.desktopNavMenuBlock;
    }), []);
    var activeState = function activeState(url) {
        if (router.pathname.includes(url)) {
            return true;
        } else {
            return false;
        }
    };
    var menuButtons = belt_Array/* mapWithIndex */.Su(navMenuData, function(i, item) {
        var match = item.fontawesomeIcon;
        if (match !== undefined) {
            return jsx_runtime.jsx((link_default()), {
                href: item.url,
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsx(Auth_SignedInMenuItem_bs_make, {
                        title: item.title,
                        icon: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                match.style,
                                match.icon
                            ]
                        }),
                        activeState: activeState(item.url)
                    })
                })
            }, String(i));
        } else {
            return null;
        }
    });
    return jsx_runtime.jsx(Auth_SignedIn_bs_make, {
        menuCard: menuCard,
        children: menuButtons
    });
}
var MenuCard_bs_SignedIn = {
    make: MenuCard$SignedIn
};
function MenuCard$BusinessSignedIn(props) {
    var menuCard = jsx_runtime.jsx(MenuCard$MenuCard, {
        name: props.user
    });
    var navMenuData = [
        {
            title: "Dashboard",
            icon: emptyAsset,
            fontawesomeIcon: undefined,
            url: "/business/home/",
            smartLink: {
                itemId: "",
                codename: ""
            }
        }
    ];
    var menuButtons = belt_Array/* mapWithIndex */.Su(navMenuData, function(i, item) {
        var match = item.icon;
        if (match !== undefined) {
            return jsx_runtime.jsx((link_default()), {
                href: item.url,
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsx(Auth_SignedInMenuItem_bs_make, {
                        title: item.title,
                        icon: jsx_runtime.jsx(CmsImage_bs/* make */.S, {
                            src: match.url,
                            alt: match.description,
                            width: match.width,
                            height: match.height,
                            className: MenuCard_bs_icon
                        }),
                        activeState: false
                    })
                })
            }, String(i));
        } else {
            return null;
        }
    });
    return jsx_runtime.jsx(Auth_SignedIn_bs_make, {
        menuCard: menuCard,
        children: menuButtons
    });
}
var BusinessSignedIn = {
    make: MenuCard$BusinessSignedIn
};
function generateAuthMfeUrl(prim0, prim1) {
    return RouteUtils.generateAuthMfeUrl(prim0, prim1);
}
function MenuCard$SignedOut(props) {
    var newAuthMfeEnabledFlag = GrowthBookContext/* useGrowthbookFeatureValue */.ej("ch-2479-auth-mfe-enabled");
    var growthBookIsReady = GrowthBookContext/* useGrowthBookReady */.$x();
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var match = (0,useWindowSize/* default */.Z)(undefined);
    var width = match.width;
    var buttonList = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(state, function(s) {
        return s.classicLoginCtaList;
    }), []);
    var buttonElements = belt_Array/* mapWithIndex */.Su(buttonList, function(index, v) {
        var match = width > Theme_Responsive_bs/* largeScreenBreakpoint */.Rf;
        if (v.NAME === "CallToAction") {
            var block = v.VAL;
            var smartLink = block.smartLink;
            var cta_url = block.cta_url;
            var target = block.open_in_new_window ? "_blank" : "";
            return jsx_runtime.jsx(Button_Button_bs.make, {
                children: jsx_runtime.jsx((link_default()), {
                    href: cta_url,
                    prefetch: false,
                    children: jsx_runtime.jsx("a", {
                        children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                                children: jsx_runtime.jsx("button", {
                                    children: block.cta_text
                                })
                            }),
                            itemId: smartLink.itemId,
                            elementCodename: smartLink.codename
                        }, cta_url),
                        className: signOutAnchor,
                        target: target
                    })
                }),
                fill: block.fill,
                colour: block.colour,
                variant: block.variant,
                className: Auth_SignedOut_bs_Styles.authButton
            }, String(index));
        }
        var block$1 = v.VAL;
        if (match) {
            var match$1 = belt_Option/* getWithDefault */.tj(block$1.selectCTA, Gql_CallToAction_Decoder_bs/* emptyButton */.tq);
            var isLastItem = (index + 1 | 0) === buttonList.length;
            var links = belt_Array/* map */.UI(block$1.optionCTAList, function(cta) {
                if (cta === undefined) {
                    return;
                }
                var url;
                if (growthBookIsReady && newAuthMfeEnabledFlag) {
                    var match = cta.cta_url;
                    switch(match){
                        case "/login/":
                            url = routeUtils/* generateAuthMfeUrl */.Cb("login", {});
                            break;
                        case "/register/":
                            url = routeUtils/* generateAuthMfeUrl */.Cb("register", {});
                            break;
                        default:
                            url = cta.cta_url;
                    }
                } else {
                    url = cta.cta_url;
                }
                return {
                    text: cta.cta_text,
                    url: url
                };
            });
            return jsx_runtime.jsx(Button_Button_bs.make, {
                children: jsx_runtime.jsx(MenuPopup_bs_make, {
                    buttonLabel: match$1.cta_text,
                    isPopupRight: isLastItem,
                    links: links,
                    smartLink: block$1.smartLink
                }),
                fill: match$1.fill,
                colour: match$1.colour,
                variant: match$1.variant,
                className: Auth_SignedOut_bs_Styles.authButton
            }, String(index));
        }
        var match$2 = useContext(undefined);
        var smartLink$1 = block$1.smartLink;
        var setPage = match$2.setPage;
        var match$3 = belt_Option/* getWithDefault */.tj(block$1.selectCTA, Gql_CallToAction_Decoder_bs/* emptyButton */.tq);
        var codename = smartLink$1.codename;
        return jsx_runtime.jsx(Button_Button_bs.make, {
            children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                    children: jsx_runtime.jsx("button", {
                        children: match$3.cta_text,
                        className: signOutAnchor,
                        onClick: function onClick(param) {
                            curry._1(setPage, {
                                code: codename,
                                parent: defaultPage
                            });
                        }
                    })
                }),
                itemId: smartLink$1.itemId,
                elementCodename: codename
            }, match$3.cta_url),
            fill: match$3.fill,
            colour: match$3.colour,
            variant: match$3.variant,
            className: Auth_Business_SignedOut_bs_Styles.authButton
        }, String(index));
    });
    return jsx_runtime.jsx(react.Fragment, {
        children: buttonElements
    });
}
var MenuCard_bs_SignedOut = {
    make: MenuCard$SignedOut
};
function MenuCard$BusinessSignedOut(props) {
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var buttonElements = belt_Array/* mapWithIndex */.Su(belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(state, function(s) {
        return s.businessLoginCtaList;
    }), []), function(index, param) {
        var smartLink = param.smartLink;
        var target = param.open_in_new_window ? "_blank" : "";
        return jsx_runtime.jsx(Button_Button_bs.make, {
            children: jsx_runtime.jsx((link_default()), {
                href: param.cta_url,
                prefetch: false,
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
                        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                            children: jsx_runtime.jsx("button", {
                                children: param.cta_text
                            })
                        }),
                        itemId: smartLink.itemId,
                        elementCodename: smartLink.codename
                    }),
                    className: signOutAnchor,
                    target: target
                })
            }),
            fill: param.fill,
            colour: param.colour,
            variant: param.variant,
            className: Auth_Business_SignedOut_bs_Styles.authButton
        }, String(index));
    });
    return jsx_runtime.jsx(react.Fragment, {
        children: buttonElements
    });
}
var MenuCard_bs_BusinessSignedOut = {
    make: MenuCard$BusinessSignedOut
};
function MenuCard$AuthMenu(props) {
    var match = UserContext_bs.useUser(undefined);
    var userCtx = match[0];
    var user = userCtx ? userCtx._0.firstName : undefined;
    var signedOut = jsx_runtime.jsx(MenuCard$SignedOut, {});
    var signedIn = function signedIn(u) {
        return jsx_runtime.jsx(MenuCard$SignedIn, {
            user: u
        });
    };
    return jsx_runtime.jsx(Auth_bs_make, {
        user: user,
        signedIn: signedIn,
        signedOut: signedOut
    });
}
var AuthMenu = {
    make: MenuCard$AuthMenu
};
function MenuCard$BusinessAuthMenu(props) {
    var user = belt_Option/* map */.UI(util_bs/* Business.getUser */.e.getUser(undefined), function(param) {
        return "";
    });
    var signedOut = jsx_runtime.jsx(MenuCard$BusinessSignedOut, {});
    var signedIn = function signedIn(u) {
        return jsx_runtime.jsx(MenuCard$BusinessSignedIn, {
            user: u
        });
    };
    return jsx_runtime.jsx(Auth_bs_make, {
        user: user,
        signedIn: signedIn,
        signedOut: signedOut
    });
}
var BusinessAuthMenu = {
    make: MenuCard$BusinessAuthMenu
};
var CardIcon;
var MenuIcon;
var MenuCard_bs_Link$1;
 /* customKontentEditSignInBtn Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_List.js
var belt_List = __webpack_require__(84462);
// EXTERNAL MODULE: ./src/components/library/SmartLink.bs.js
var SmartLink_bs = __webpack_require__(35705);
// EXTERNAL MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js + 7 modules
var Css_bs = __webpack_require__(90289);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/AlertBanner/AlertBanner.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var alertBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.white */.RL.white),
    Theme_Fonts_bs/* SofiaPro.family */.t.family,
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("center"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* textAlign */.ydu("center"),
    BsCssJs_bs/* minHeight */.jw4(BsCssJs_bs.px(35))
]);
var blueBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.activeBlue */.RL.activeBlue)
]);
var yellowBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.yellow */.RL.yellow)
]);
var orangeBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.orange */.RL.orange)
]);
var greenBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.green */.RL.green)
]);
var redBanner = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed)
]);
function customHexBanner(customColor) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw({
            NAME: "hex",
            VAL: customColor
        })
    ]);
}
function customRGBBanner(a, b, c) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw(BsCssJs_bs/* rgb */.B8C(a, b, c))
    ]);
}
function customRGBABanner(a, b, c, d) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw(BsCssJs_bs/* rgba */.m4f(a, b, c, {
            NAME: "num",
            VAL: d
        }))
    ]);
}
var AlertBanner_bs_Styles = {
    alertBanner: alertBanner,
    blueBanner: blueBanner,
    yellowBanner: yellowBanner,
    orangeBanner: orangeBanner,
    greenBanner: greenBanner,
    redBanner: redBanner,
    customHexBanner: customHexBanner,
    customRGBBanner: customRGBBanner,
    customRGBABanner: customRGBABanner
};
function AlertBanner(props) {
    var optionalStyles = props.optionalStyles;
    var alertColour = props.alertColour;
    var optionalStyles$1 = optionalStyles !== undefined ? optionalStyles : "";
    var alertColourClassName;
    if (typeof alertColour === "number") {
        switch(alertColour){
            case /* Blue */ 0:
                alertColourClassName = blueBanner;
                break;
            case /* Green */ 1:
                alertColourClassName = greenBanner;
                break;
            case /* Red */ 2:
                alertColourClassName = redBanner;
                break;
            case /* Orange */ 3:
                alertColourClassName = orangeBanner;
                break;
            case /* Yellow */ 4:
                alertColourClassName = yellowBanner;
                break;
        }
    } else {
        alertColourClassName = alertColour._0;
    }
    var className = classnames_default()([
        alertBanner,
        alertColourClassName,
        optionalStyles$1
    ]);
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: className
    });
}
var AlertBanner_bs_make = AlertBanner;
 /* alertBanner Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/AlertBanner/AlertBanner__Text.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var textStyle = BsCssJs_bs/* style */.oBv([
    Theme_Fonts_bs/* SofiaPro.family */.t.family,
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(3)),
    BsCssJs_bs/* fontWeight */.Ue2({
        NAME: "num",
        VAL: 400
    }),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(16)),
    BsCssJs_bs/* margin2 */.h9x(BsCssJs_bs.px(5), BsCssJs_bs.px(20))
]);
var linkStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* textDecoration */.QXS("underline"),
    BsCssJs_bs/* textDecorationColor */.hrh({
        NAME: "hex",
        VAL: "FFFFFF"
    })
]);
var AlertBanner_Text_bs_Styles = {
    textStyle: textStyle,
    linkStyle: linkStyle
};
function AlertBanner__Text(props) {
    var optionalStyles = props.optionalStyles;
    var link = props.link;
    var mobileText = props.mobileText;
    var desktopText = props.desktopText;
    var link$1 = link !== undefined ? link : false;
    var optionalStyles$1 = optionalStyles !== undefined ? optionalStyles : "";
    var className = link$1 ? classnames_default()([
        textStyle,
        linkStyle,
        optionalStyles$1
    ]) : classnames_default()([
        textStyle,
        optionalStyles$1
    ]);
    var displayText = mobileText !== undefined ? mobileText : desktopText;
    return jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(Fresnel_Fresnel_bs/* Media.make */.pU.make, {
                greaterThan: "rbMobile",
                children: jsx_runtime.jsx("p", {
                    children: desktopText,
                    className: className
                })
            }),
            jsx_runtime.jsx(Fresnel_Fresnel_bs/* Media.make */.pU.make, {
                at: "rbMobile",
                children: jsx_runtime.jsx("p", {
                    children: displayText,
                    className: className
                })
            })
        ]
    });
}
var AlertBanner_Text_bs_make = AlertBanner__Text;
 /* textStyle Not a pure module */ 

;// CONCATENATED MODULE: ./src/layouts/AlertBanner.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE














var iconColor = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* color */.$_Y(Theme_bs/* Color.white */.Il.white),
    tl: /* [] */ 0
});
var buttonWrapper = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* width */.bf$(Css_bs.px(44)),
    tl: {
        hd: Css_bs/* height */.Cb8(Css_bs.px(44)),
        tl: {
            hd: Css_bs/* position */.FKU("absolute"),
            tl: {
                hd: Css_bs/* top */.wey(Css_bs.px(0)),
                tl: {
                    hd: Css_bs/* right */.F2z(Css_bs.px(0)),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var AlertBanner_bs_alertBanner = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* position */.FKU("relative"),
    tl: {
        hd: Css_bs/* important */.efO(Css_bs/* minHeight */.jw4(Css_bs.px(44))),
        tl: /* [] */ 0
    }
});
var alertBannerText = curry._1(Css_bs/* style */.oBv, {
    hd: Css_bs/* important */.efO(Css_bs/* fontSize */.JBY(Css_bs.px(14))),
    tl: {
        hd: Css_bs/* important */.efO(Css_bs/* marginRight */.wzR(Css_bs.px(44))),
        tl: {
            hd: Css_bs/* important */.efO(Css_bs/* marginLeft */.oIA(Css_bs.px(44))),
            tl: /* [] */ 0
        }
    }
});
var layouts_AlertBanner_bs_Styles = {
    iconColor: iconColor,
    buttonWrapper: buttonWrapper,
    alertBanner: AlertBanner_bs_alertBanner,
    alertBannerText: alertBannerText
};
function AlertBanner_bs_AlertBanner(props) {
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var match = react.useState(function() {
        return true;
    });
    var setBannerVisibility = match[1];
    var bannerData = belt_Option/* flatMap */.VS(state, function(s) {
        return s.alertBanner;
    });
    var alertColour = belt_Option/* getWithDefault */.tj(belt_Option/* map */.UI(bannerData, function(s) {
        return s.bannerColor;
    }), /* Green */ 1);
    var href = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(bannerData, function(s) {
        return s.url;
    }), "");
    var desktopText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(bannerData, function(s) {
        return s.desktopText;
    }), "");
    var mobileText = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(bannerData, function(s) {
        return s.mobileText;
    }), "");
    var match$1 = belt_Option/* mapWithDefault */.k7(bannerData, SmartLink_bs/* emptySmartLink */.R, function(s) {
        return s.smartLink;
    });
    var elementCodename = match$1.codename;
    var itemId = match$1.itemId;
    var onHideBanner = function onHideBanner(e) {
        e.preventDefault();
        curry._1(setBannerVisibility, function(param) {
            return false;
        });
    };
    var displayBanner = href === "" ? jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs(AlertBanner_bs_make, {
                    children: [
                        jsx_runtime.jsx(AlertBanner_Text_bs_make, {
                            desktopText: desktopText,
                            mobileText: mobileText,
                            link: true,
                            optionalStyles: alertBannerText
                        }),
                        jsx_runtime.jsx(Button_Button_bs.make, {
                            children: jsx_runtime.jsx("button", {
                                children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "fas",
                                        "times"
                                    ]
                                }),
                                className: "w-full h-full bg-transparent",
                                onClick: onHideBanner
                            }),
                            variant: /* Icon */ 2,
                            className: buttonWrapper
                        })
                    ],
                    alertColour: alertColour,
                    optionalStyles: AlertBanner_bs_alertBanner
                })
            })
        }),
        itemId: itemId,
        elementCodename: elementCodename
    }) : jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
        children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx("a", {
                    children: jsx_runtime.jsxs(AlertBanner_bs_make, {
                        children: [
                            jsx_runtime.jsx(AlertBanner_Text_bs_make, {
                                desktopText: desktopText,
                                mobileText: mobileText,
                                link: true,
                                optionalStyles: alertBannerText
                            }),
                            jsx_runtime.jsx(Button_Button_bs.make, {
                                children: jsx_runtime.jsx("button", {
                                    children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                                        icon: [
                                            "fas",
                                            "times"
                                        ],
                                        className: "flex-1"
                                    }),
                                    "aria-label": "Dismiss alert",
                                    className: "w-full h-full bg-transparent",
                                    title: "Dismiss alert",
                                    onClick: onHideBanner
                                }),
                                variant: /* Icon */ 2,
                                className: buttonWrapper
                            })
                        ],
                        alertColour: alertColour,
                        optionalStyles: AlertBanner_bs_alertBanner
                    }),
                    href: href
                })
            })
        }),
        itemId: itemId,
        elementCodename: elementCodename
    });
    if (belt_Option/* isSome */.pC(bannerData) && match[0]) {
        return displayBanner;
    } else {
        return null;
    }
}
var AlertBanner$1;
var Button;
var $$Text;
var Link;
var KontentContextConsumer;
var layouts_AlertBanner_bs_make = AlertBanner_bs_AlertBanner;
 /* iconColor Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./src/utils/SegmentUtils.bs.js
var SegmentUtils_bs = __webpack_require__(25235);
// EXTERNAL MODULE: ./src/components/pages/myAccount/MyAccountContext.bs.js
var MyAccountContext_bs = __webpack_require__(78788);
// EXTERNAL MODULE: ./src/components/library/RegionIndicators.bs.js + 2 modules
var RegionIndicators_bs = __webpack_require__(59746);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
;// CONCATENATED MODULE: ./src/components/NZDisclaimerAlert.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var flagName = "nzDisclaimer";
var overlay = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* zIndex */.W5D(55),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100.0)),
        tl: {
            hd: BsCss_bs/* height */.Cb8(BsCss_bs/* pct */.hdZ(100.0)),
            tl: {
                hd: BsCss_bs/* position */.FKU("fixed"),
                tl: /* [] */ 0
            }
        }
    }
});
var content = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(BsCss_bs/* white */.ixZ),
    tl: {
        hd: BsCss_bs/* boxShadow */.Wnp(Css_Legacy_Core_bs/* Shadow.box */.jXB.box(BsCss_bs.px(0), BsCss_bs.px(0), BsCss_bs.px(25), undefined, undefined, BsCss_bs/* rgba */.m4f(0, 0, 0, BsCss_bs/* pct */.hdZ(25.0)))),
        tl: {
            hd: BsCss_bs/* background */.Oq0(BsCss_bs/* rgba */.m4f(49, 62, 73, BsCss_bs/* pct */.hdZ(95.0))),
            tl: {
                hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs/* rem */.hOB(0.5)),
                tl: {
                    hd: BsCss_bs/* display */.jfB("flex"),
                    tl: {
                        hd: BsCss_bs/* flexDirection */.Me8("column"),
                        tl: {
                            hd: BsCss_bs/* alignItems */.cq$("center"),
                            tl: {
                                hd: BsCss_bs/* paddingTop */.odA(BsCss_bs/* rem */.hOB(2.5)),
                                tl: {
                                    hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(2.5)),
                                    tl: {
                                        hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(2.0)),
                                        tl: {
                                            hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(2.0)),
                                            tl: {
                                                hd: BsCss_bs/* right */.F2z(BsCss_bs/* rem */.hOB(1.0)),
                                                tl: {
                                                    hd: BsCss_bs/* position */.FKU("absolute"),
                                                    tl: {
                                                        hd: BsCss_bs/* left */.t$v(BsCss_bs/* rem */.hOB(1.0)),
                                                        tl: {
                                                            hd: BsCss_bs/* top */.wey(BsCss_bs/* rem */.hOB(7.5)),
                                                            tl: /* [] */ 0
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var contentBottom = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* bottom */.IaC(BsCss_bs/* rem */.hOB(1.0)),
    tl: {
        hd: BsCss_bs/* top */.wey("auto"),
        tl: /* [] */ 0
    }
});
var textBox = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs/* rem */.hOB(58.0)),
    tl: {
        hd: BsCss_bs/* textAlign */.ydu("center"),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs/* rem */.hOB(1.5)),
            tl: /* [] */ 0
        }
    }
});
var NZDisclaimerAlert_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* rem */.hOB(10.0)),
    tl: {
        hd: BsCss_bs/* paddingTop */.odA(BsCss_bs/* rem */.hOB(0.75)),
        tl: {
            hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(0.75)),
            tl: /* [] */ 0
        }
    }
});
var warningText = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.errorRed */.Il.errorRed),
    tl: {
        hd: BsCss_bs/* marginTop */.E9m(BsCss_bs/* rem */.hOB(0.5)),
        tl: {
            hd: BsCss_bs/* textAlign */.ydu("center"),
            tl: {
                hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs/* rem */.hOB(-2.0)),
                tl: /* [] */ 0
            }
        }
    }
});
var NZDisclaimerAlert_bs_Styles = {
    overlay: overlay,
    content: content,
    contentBottom: contentBottom,
    textBox: textBox,
    button: NZDisclaimerAlert_bs_button,
    warningText: warningText
};
function NZDisclaimerAlert(props) {
    var alertFooter = props.alertFooter;
    var alertFooter$1 = alertFooter !== undefined ? alertFooter : false;
    var match = react.useState(function() {
        return false;
    });
    var setIsShown = match[1];
    var match$1 = react.useState(function() {
        return false;
    });
    var setDisplayWarning = match$1[1];
    react.useEffect(function() {
        var match = localStorage.getItem(flagName);
        if (match == null) {
            curry._1(setIsShown, function(param) {
                return true;
            });
        } else {
            curry._1(setIsShown, function(param) {
                return false;
            });
        }
    }, []);
    if (match[0]) {
        return jsx_runtime.jsx("div", {
            children: jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsxs("div", {
                        children: [
                            util_bs/* ReactStuff.s */.p_.s('I acknowledge and understand that "Prezzee" is not affiliated or associated in any way with "PREZZY'),
                            util_bs/* ReactStuff.s */.p_.s("\xae"),
                            util_bs/* ReactStuff.s */.p_.s('", "PREZZY'),
                            util_bs/* ReactStuff.s */.p_.s("\xae"),
                            util_bs/* ReactStuff.s */.p_.s(' Card" or EPAY NEW ZEALAND LIMITED (NZBN 9429036203420) and PREZZY'),
                            util_bs/* ReactStuff.s */.p_.s("\xae"),
                            util_bs/* ReactStuff.s */.p_.s(" is a registered trade mark of Epay New Zealand Limited, and agree to Prezzee's Privacy Policy and Terms and Conditions.")
                        ],
                        className: textBox
                    }),
                    jsx_runtime.jsx(Button_bs/* make */.Sy, {
                        onClick: function onClick(param) {
                            localStorage.setItem(flagName, "shown");
                            curry._1(setIsShown, function(param) {
                                return false;
                            });
                        },
                        title: "Accept",
                        className: Cn_bs/* make */.S([
                            Button_bs/* primaryStyle */.vP,
                            NZDisclaimerAlert_bs_button
                        ])
                    }),
                    match$1[0] ? jsx_runtime.jsx("span", {
                        children: util_bs/* ReactStuff.s */.p_.s("Please make sure you have accepted the terms."),
                        className: warningText
                    }) : null
                ],
                className: Cn_bs/* make */.S([
                    content,
                    alertFooter$1 ? contentBottom : ""
                ])
            }),
            className: overlay,
            onClick: function onClick(param) {
                curry._1(setDisplayWarning, function(param) {
                    return true;
                });
            }
        });
    } else {
        return null;
    }
}
var NZDisclaimerAlert_bs_make = NZDisclaimerAlert;
 /* overlay Not a pure module */ 

// EXTERNAL MODULE: ./src/css/theme.ts
var theme = __webpack_require__(55374);
;// CONCATENATED MODULE: ./src/components/library/MobileNavPage.tsx





var styles = {
    back: {
        root: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:row;justify-content:flex-start;align-items:center;padding:20px 0 16px;"),
        icon: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("font-size:24px;margin-top:2px;"),
        button: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("padding-left:8px;")
    },
    list: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("display:flex;flex-direction:column;"),
    link: /*#__PURE__*/ (0,emotion_css_esm/* css */.iv)("width:100%;display:flex;justify-content:space-between;align-items:center;padding:20px 0 16px;border-bottom:1px solid ", theme/* Color.Gray100 */.Il.Gray100, ";cursor:pointer;")
};
var MobileNavPage = function(param) {
    var links = param.links;
    var setPage = usePaginatedDrawer().setPage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                className: styles.back.root,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                        className: styles.back.icon,
                        icon: [
                            "far",
                            "angle-left"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("button", {
                        className: styles.back.button,
                        onClick: function() {
                            return setPage(DEFAULT_PAGE);
                        },
                        children: "Back"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("ul", {
                className: styles.list,
                children: links.map(function(el, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("a", {
                            className: styles.link,
                            href: el.url,
                            children: [
                                el.text,
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(index_es.FontAwesomeIcon, {
                                    icon: [
                                        "far",
                                        "arrow-right"
                                    ],
                                    color: theme/* Color.Purple400 */.Il.Purple400,
                                    size: "sm"
                                })
                            ]
                        })
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var library_MobileNavPage = (MobileNavPage);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TopNavigationBar/TopNavigationBar__Personal.bs.js
var TopNavigationBar_Personal_bs = __webpack_require__(66841);
// EXTERNAL MODULE: ./src/contexts/LayoutDataContext.ts
var LayoutDataContext = __webpack_require__(25149);
// EXTERNAL MODULE: ./src/common/utils/react.tsx
var utils_react = __webpack_require__(4331);
;// CONCATENATED MODULE: ./src/layouts/ConsumerNavigation.tsx













var ConsumerNavigation = function(param) {
    var logo = param.logo, navigationBlock = param.navigationBlock, regionPicker = param.regionPicker, closeMenuObservable = param.closeMenuObservable, isLoggedIn = param.isLoggedIn, onLogoutClick = param.onLogoutClick, isMenuOpen = param.isMenuOpen;
    var ref = usePaginatedDrawer(), page = ref.page, setPage = ref.setPage;
    var classicLoginCtaList = (0,LayoutDataContext/* useLayoutData */.Q)().classicLoginCtaList;
    var width = (0,useWindowSize/* default */.Z)().width;
    var isGrowthbookReady = (0,GrowthBookContext/* useGrowthBookReady */.$x)();
    var newAuthMfeEnabled = (0,GrowthBookContext/* useGrowthbookFeatureValue */.ej)("ch-2479-auth-mfe-enabled");
    var getAuthUrl = function(path) {
        if (!isGrowthbookReady || !newAuthMfeEnabled) return path;
        if (path === "/login/") return (0,routeUtils/* generateAuthMfeUrl */.Cb)("login").toString();
        if (path === "/register/") return (0,routeUtils/* generateAuthMfeUrl */.Cb)("register").toString();
        return path;
    };
    var optionLinks = (0,react.useMemo)(function() {
        var ref;
        return (ref = classicLoginCtaList.map(function(el) {
            return el.VAL;
        }).find(function(el) {
            return el.smartLink.codename === page.code;
        })) === null || ref === void 0 ? void 0 : ref.optionCTAList.map(function(el) {
            return {
                text: el.cta_text,
                url: getAuthUrl(el.cta_url)
            };
        });
    }, [
        page.code
    ]);
    var onMenuChange = function(menuState) {
        // NOTE: ref(bool) JS polyfill
        isMenuOpen.contents = menuState;
        setPage(DEFAULT_PAGE);
    };
    var topNavProps = {
        logo: logo,
        navigationBlock: navigationBlock,
        regionPicker: regionPicker,
        closeMenuObservable: closeMenuObservable,
        isLoggedIn: isLoggedIn,
        onLogoutClick: onLogoutClick,
        onMenuChange: onMenuChange
    };
    var configuredProps = page.code !== "default" ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topNavProps), {
        regionPicker: utils_react/* EMPTY_ELEMENT */.O,
        navigationBlock: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(library_MobileNavPage, {
            links: optionLinks
        })
    }) : topNavProps;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: width > Theme_Responsive_bs/* largeScreenBreakpoint */.Rf ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TopNavigationBar_Personal_bs/* make */.Sy, (0,_object_spread/* default */.Z)({}, topNavProps)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TopNavigationBar_Personal_bs/* make */.Sy, (0,_object_spread/* default */.Z)({}, configuredProps))
    });
};
/* harmony default export */ var layouts_ConsumerNavigation = (ConsumerNavigation);

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Navigation/Navigation__Personal.bs.js + 3 modules
var Navigation_Personal_bs = __webpack_require__(84369);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar.bs.js + 1 modules
var TopNavigationBar_bs = __webpack_require__(48825);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TopNavigationBar/TopNavigationBar__Theme__Business.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var backgroundColor = Theme_Color_bs/* Business.stone */.e.stone;
var Theme_logoBlockMargin = {
    NAME: "rem",
    VAL: 3
};
var Theme = {
    backgroundColor: backgroundColor,
    logoPosition: "flexStart",
    logoBlockMargin: Theme_logoBlockMargin
};
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/business/TopNavigationBar/TopNavigationBar__Business.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


var include = TopNavigationBar_bs/* Component */.w(Theme);
var Background = include.Background;
var StaticBackground = include.StaticBackground;
var FadeBackground = include.FadeBackground;
var TopNavigationBar_Business_bs_Styles = include.Styles;
var TopNavigationBar_Business_bs_make = include.make;
 /* include Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar__Navlinks.bs.js
var TopNavigationBar_Navlinks_bs = __webpack_require__(65164);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar__AuthContainer.bs.js
var TopNavigationBar_AuthContainer_bs = __webpack_require__(73340);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TopNavigationBar/TopNavigationBar__Background__Personal.bs.js
var TopNavigationBar_Background_Personal_bs = __webpack_require__(96805);
;// CONCATENATED MODULE: ./src/layouts/Page.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







































var Page_bs_make = layouts_ConsumerNavigation;
var Page_bs_ConsumerNavigation = {
    make: Page_bs_make
};
var Page_bs_make$1 = library_HeaderContainer;
var Page_bs_HeaderContainer = {
    make: Page_bs_make$1
};
var sharedStyle_0 = BsCss_bs/* position */.FKU("relative");
var sharedStyle_1 = {
    hd: BsCss_bs/* flex */.fUN({
        NAME: "num",
        VAL: 1
    }),
    tl: {
        hd: BsCss_bs/* flexGrow */.H78(1),
        tl: {
            hd: BsCss_bs/* flexShrink */.i4v(1),
            tl: {
                hd: BsCss_bs/* flexBasis */.P_T(BsCss_bs/* pct */.hdZ(0)),
                tl: /* [] */ 0
            }
        }
    }
};
var sharedStyle = {
    hd: sharedStyle_0,
    tl: sharedStyle_1
};
var mainContainer = curry._1(BsCss_bs/* style */.oBv, sharedStyle);
var fullHeightMainContainer = curry._1(BsCss_bs/* style */.oBv, belt_List/* concat */.zo(sharedStyle, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: /* [] */ 0
}));
var navContainerBase = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("center"),
            tl: {
                hd: BsCss_bs/* borderBottom */.h$9(BsCss_bs.px(1), "solid", Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey),
                tl: /* [] */ 0
            }
        }
    }
});
var businessContainer = Cn_bs/* make */.S([
    navContainerBase,
    curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_Color_bs/* Business.stone */.e.stone),
        tl: /* [] */ 0
    })
]);
var consumerContainer = Cn_bs/* make */.S([
    navContainerBase,
    curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_Color_bs/* Personal.white */.RL.white),
        tl: /* [] */ 0
    })
]);
var navInnerContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs.px(1440)),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100)),
        tl: /* [] */ 0
    }
});
function logoImg(imgWidth) {
    return curry._1(BsCss_bs/* style */.oBv, {
        hd: BsCss_bs/* width */.bf$(BsCss_bs.px(imgWidth)),
        tl: {
            hd: BsCss_bs/* maxWidth */.kkr("unset"),
            tl: /* [] */ 0
        }
    });
}
var Page_bs_Styles = {
    sharedStyle: sharedStyle,
    mainContainer: mainContainer,
    fullHeightMainContainer: fullHeightMainContainer,
    navContainerBase: navContainerBase,
    businessContainer: businessContainer,
    consumerContainer: consumerContainer,
    navInnerContainer: navInnerContainer,
    logoImg: logoImg
};
var flexibleContainer = "flex flex-col min-h-screen";
var myAccountRoutes = [
    "my-details",
    "orders"
];
var RegionStrip = RegionIndicators_bs/* GenericRegionPicker */.T0(RegionIndicators_bs/* RegionStrip */.Mq);
var RegionPickerInline = RegionIndicators_bs/* GenericRegionPicker */.T0(RegionIndicators_bs/* RegionInline */.i8);
var Page_bs_isMenuOpen = {
    contents: false
};
function Page(props) {
    var theme = props.theme;
    var isBusinessContainer = props.isBusinessContainer;
    var showRegionStrip = props.showRegionStrip;
    var alertFooter = props.alertFooter;
    var footerInFlexibleContainer = props.footerInFlexibleContainer;
    var alertBanner = props.alertBanner;
    var footer = props.footer;
    var header = props.header;
    var mainClassName = props.mainClassName;
    var children = props.children;
    var mainClassName$1 = mainClassName !== undefined ? mainClassName : "";
    var header$1 = header !== undefined ? caml_option/* valFromOption */.xt(header) : jsx_runtime.jsx(make$1, {});
    var footer$1 = footer !== undefined ? caml_option/* valFromOption */.xt(footer) : jsx_runtime.jsx(Footer_bs/* make */.Sy, {});
    var alertBanner$1 = alertBanner !== undefined ? caml_option/* valFromOption */.xt(alertBanner) : jsx_runtime.jsx(layouts_AlertBanner_bs_make, {});
    var footerInFlexibleContainer$1 = footerInFlexibleContainer !== undefined ? footerInFlexibleContainer : true;
    var alertFooter$1 = alertFooter !== undefined ? alertFooter : false;
    var showRegionStrip$1 = showRegionStrip !== undefined ? showRegionStrip : true;
    var isBusinessContainer$1 = isBusinessContainer !== undefined ? isBusinessContainer : false;
    var theme$1 = theme !== undefined ? theme : Themes_bs/* personal */.H;
    var state = LayoutDataContext_bs/* useContext */.qp(undefined);
    var match = react.useReducer(MyAccountContext_bs/* reducer */.I6, MyAccountContext_bs/* initialState */.E3);
    var router = next_router.useRouter();
    var match$1 = react.useState(function() {
        return false;
    });
    var setMenuOpen = match$1[1];
    var match$2 = UserContext_bs.useUser(undefined);
    var isLoggedIn = match$2[0] ? true : false;
    var onMenuChange = function onMenuChange(menuState) {
        Page_bs_isMenuOpen.contents = menuState;
        curry._1(setMenuOpen, function(param) {
            return menuState;
        });
    };
    var menuItemsData = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(state, function(d) {
        if (isBusinessContainer$1) {
            return d.businessHeader;
        } else {
            return d.header;
        }
    }), []);
    var classicLogoUrl = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(f) {
        return f.headerLogo;
    }), function(d) {
        return d.classicLogoAsset;
    }), function(d) {
        return d.url;
    }), __webpack_require__(56393));
    var classicLogoWidth = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(f) {
        return f.headerLogo;
    }), function(d) {
        return d.classicLogoWidth;
    }), 0);
    var businessLogoUrl = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(f) {
        return f.headerLogo;
    }), function(d) {
        return d.businessLogoAsset;
    }), function(d) {
        return d.url;
    }), __webpack_require__(74932));
    var businessLogoWidth = belt_Option/* getWithDefault */.tj(belt_Option/* flatMap */.VS(belt_Option/* flatMap */.VS(state, function(f) {
        return f.headerLogo;
    }), function(d) {
        return d.businessLogoWidth;
    }), 0);
    var menuItems = belt_Array/* map */.UI(menuItemsData, function(param) {
        var smartLink = param.smartLink;
        var itemId = smartLink.itemId;
        var url = param.url;
        var title = param.title;
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Navigation_Personal_bs/* Item.make */.ck.make, {
                children: jsx_runtime.jsx((link_default()), {
                    href: url,
                    children: jsx_runtime.jsx("a", {
                        children: title,
                        onClick: function onClick(param) {
                            if (url === "/contact/") {
                                return Segment_bs/* customElementInteraction */.pA({
                                    element: SegmentUtils_bs/* SegmentUtils.mapElement */.I.mapElement(title, "topnav", undefined),
                                    path: router.asPath
                                });
                            }
                        }
                    })
                })
            }),
            itemId: itemId,
            elementCodename: smartLink.codename
        }, itemId);
    });
    var navigation = jsx_runtime.jsx(Navigation_Personal_bs/* make */.Sy, {
        children: menuItems
    });
    var regionStrip = jsx_runtime.jsx(RegionStrip.make, {});
    var regionPicker = jsx_runtime.jsx(RegionPickerInline.make, {});
    var navigationBlock = jsx_runtime.jsxs(jsx_runtime.Fragment, {
        children: [
            jsx_runtime.jsx(TopNavigationBar_Navlinks_bs/* make */.S, {
                children: navigation
            }),
            jsx_runtime.jsx(TopNavigationBar_AuthContainer_bs/* make */.S, {
                authMenu: isBusinessContainer$1 ? jsx_runtime.jsx(BusinessAuthMenu.make, {}) : jsx_runtime.jsx(AuthMenu.make, {}),
                authMenuLowerBreakpoint: "rbLargeDesktop"
            })
        ]
    });
    var closeMenuObservable_subscribe = function closeMenuObservable_subscribe(fn) {
        router.events.on("routeChangeComplete", function(param) {
            curry._1(fn, undefined);
        });
    };
    var closeMenuObservable_unsubscribe = function closeMenuObservable_unsubscribe(fn) {
        router.events.off("routeChangeComplete", function(param) {
            curry._1(fn, undefined);
        });
    };
    var closeMenuObservable = {
        subscribe: closeMenuObservable_subscribe,
        unsubscribe: closeMenuObservable_unsubscribe
    };
    var logo = react.useMemo(function() {
        var smartLink = belt_Option/* mapWithDefault */.k7(belt_Option/* flatMap */.VS(state, function(c) {
            return c.headerLogo;
        }), SmartLink_bs/* emptySmartLink */.R, function(logo) {
            return logo.smartLink;
        });
        var logoImg$1 = isBusinessContainer$1 ? jsx_runtime.jsx("a", {
            children: jsx_runtime.jsx("img", {
                className: logoImg(businessLogoWidth),
                alt: "Prezzee Logo",
                src: businessLogoUrl
            }),
            title: "Homepage",
            href: "/"
        }) : jsx_runtime.jsx("a", {
            children: jsx_runtime.jsx("img", {
                className: logoImg(classicLogoWidth),
                alt: "Prezzee Logo",
                src: classicLogoUrl
            }),
            title: "Homepage",
            href: "/"
        });
        return jsx_runtime.jsx(KontentContextProvider_bs/* make */.S, {
            children: jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
                children: jsx_runtime.jsx("div", {
                    children: logoImg$1
                })
            }),
            itemId: smartLink.itemId,
            elementCodename: smartLink.codename
        });
    }, [
        isBusinessContainer$1
    ]);
    return jsx_runtime.jsxs(Shared_bs/* make */.Sy, {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx(Page_bs_make$1, {
                        children: jsx_runtime.jsx(PaginatedDrawerContext_bs_PaginatedDrawerProvider.make, {
                            children: showRegionStrip$1 ? jsx_runtime.jsxs(jsx_runtime.Fragment, {
                                children: [
                                    jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                                        greaterThanOrEqual: "tablet",
                                        children: regionStrip
                                    }),
                                    isBusinessContainer$1 ? null : alertBanner$1,
                                    jsx_runtime.jsx("div", {
                                        children: jsx_runtime.jsx("div", {
                                            children: jsx_runtime.jsx(TopNavigationBar_Background_Personal_bs/* StaticBackground.make */.DS.make, {
                                                children: isBusinessContainer$1 ? jsx_runtime.jsx(TopNavigationBar_Business_bs_make, {
                                                    logo: logo,
                                                    navigationBlock: navigationBlock,
                                                    regionPicker: regionPicker,
                                                    closeMenuObservable: closeMenuObservable,
                                                    onLogoutClick: function onLogoutClick(param) {
                                                        router.push("/logout");
                                                    },
                                                    isLoggedIn: isLoggedIn,
                                                    onMenuChange: onMenuChange
                                                }) : jsx_runtime.jsx(Page_bs_make, {
                                                    logo: logo,
                                                    navigationBlock: navigationBlock,
                                                    regionPicker: regionPicker,
                                                    closeMenuObservable: closeMenuObservable,
                                                    onLogoutClick: function onLogoutClick(param) {
                                                        router.push("/logout");
                                                    },
                                                    isLoggedIn: isLoggedIn,
                                                    isMenuOpen: Page_bs_isMenuOpen
                                                })
                                            }),
                                            className: navInnerContainer
                                        }),
                                        className: isBusinessContainer$1 ? businessContainer : consumerContainer
                                    })
                                ]
                            }) : header$1
                        }),
                        isMenuOpen: Page_bs_isMenuOpen
                    }),
                    jsx_runtime.jsx("main", {
                        children: !isBusinessContainer$1 && belt_Array/* some */.G(myAccountRoutes, function(myAccountRoute) {
                            return router.pathname.includes(myAccountRoute);
                        }) ? jsx_runtime.jsx(MyAccountContext_bs/* MyAccountContextProvider.make */.lJ.make, {
                            value: [
                                match[0],
                                match[1]
                            ],
                            children: children
                        }) : children,
                        className: Cn_bs/* make */.S([
                            mainContainer,
                            mainClassName$1
                        ])
                    }),
                    footerInFlexibleContainer$1 ? footer$1 : null,
                    caml_obj/* equal */.Dg(util_bs/* EnvUtil.getCountry */.i3.getCountry(undefined), {
                        TAG: /* Ok */ 0,
                        _0: /* NewZealand */ 3
                    }) ? jsx_runtime.jsx(NZDisclaimerAlert_bs_make, {
                        alertFooter: alertFooter$1
                    }) : null
                ],
                className: flexibleContainer
            }),
            footerInFlexibleContainer$1 ? null : footer$1
        ],
        theme: theme$1
    });
}
var Head;
var Page_bs_Link$1;
var RegionPicker;
var RegionIndicatorStrip;
var RegionIndicatorInline;
var RegionIndicatorCountryDisplay;
var TopNavigationBar;
var BusinessTopNavigationBar;
var TopNavigationBarNavLinks;
var TopNavigationBarAuthContainer;
var Navigation;
var NavigationItem;
var StickyBar;
var Page_bs_StaticBackground;
var Page_bs_KontentContextConsumer;
var make$2 = Page;
 /* make Not a pure module */ 


/***/ }),

/***/ 53827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Head, Script, serverUrl, domain */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _css_Themes_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86167);
/* harmony import */ var _bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7545);
/* harmony import */ var _rescript_std_lib_es6_caml_obj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84445);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
/* harmony import */ var _prezzee_ribbon_src_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17847);
/* harmony import */ var _prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28522);
// Generated by ReScript, PLEASE EDIT WITH CARE









var serverUrl = "https://www.prezzee.co.nz/";
var domain = serverUrl.replace("https://", "") + "api";
function Shared(props) {
    var theme = props.theme;
    var theme$1 = theme !== undefined ? theme : _css_Themes_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .personal */ .H;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx(_prezzee_ribbon_src_context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_7__/* .Provider.make */ .zt.make, {
        value: theme$1,
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                    children: [
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("meta", {
                            content: "width=device-width, initial-scale=1, shrink-to-fit=no, viewport-fit=cover",
                            name: "viewport"
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("meta", {
                            content: domain,
                            name: "prezzee-server-url"
                        }),
                        _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getEnv */ .i3.getEnv(undefined) === /* Production */ 1 && _rescript_std_lib_es6_caml_obj_js__WEBPACK_IMPORTED_MODULE_8__/* .equal */ .Dg(_common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .EnvUtil.getCountry */ .i3.getCountry(undefined), {
                            TAG: /* Ok */ 0,
                            _0: /* UnitedStates */ 2
                        }) ? react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("meta", {
                            content: "04d7c9e0243ba060794077b781890d65",
                            name: "p:domain_verify"
                        }) : null,
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("style", {
                            type: "text/css",
                            dangerouslySetInnerHTML: {
                                __html: _bindings_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .mediaStyles */ .QD
                            }
                        }),
                        react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx("style", {
                            type: "text/css",
                            dangerouslySetInnerHTML: {
                                __html: _prezzee_ribbon_src_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .mediaStyles */ .QD
                            }
                        })
                    ]
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx((next_script__WEBPACK_IMPORTED_MODULE_4___default()), {
                    id: "datadomeScript",
                    type_: "text/javascript",
                    src: "/scripts/datadome.js"
                }),
                props.children
            ]
        })
    });
}
var Head$1;
var Script$1;
var make = Shared;
 /* serverUrl Not a pure module */ 


/***/ }),

/***/ 37698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "as": function() { return /* binding */ WalletCard; },
/* harmony export */   "hY": function() { return /* binding */ GiftCard; }
/* harmony export */ });
/* unused harmony exports HomePageSlide, SideBar, $$Notification, ProductDescription, BoardMember, AboutSlide, Exchange, CustomTheme, Signup */
/* harmony import */ var _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7667);
/* harmony import */ var _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74594);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46150);
/* harmony import */ var _rescript_std_lib_es6_pervasives_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60702);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25400);
/* harmony import */ var _rescript_std_lib_es6_belt_SortArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9618);
/* harmony import */ var _config_CategoriesConf_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20086);
// Generated by ReScript, PLEASE EDIT WITH CARE











function sortCardsByDenominations(d1, d2) {
    var match = _rescript_std_lib_es6_pervasives_js__WEBPACK_IMPORTED_MODULE_3__/* .float_of_string_opt */ .aY(d1.value);
    var match$1 = _rescript_std_lib_es6_pervasives_js__WEBPACK_IMPORTED_MODULE_3__/* .float_of_string_opt */ .aY(d2.value);
    if (match !== undefined && match$1 !== undefined && match > match$1) {
        return 1;
    } else {
        return 0;
    }
}
function getDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency);
}
function getPriceDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.priceCurrency);
}
function getPriceRange(sortedArray) {
    var getValueAndCurrency = function getValueAndCurrency(i) {
        return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2(sortedArray, i), function(d) {
            return d.valueCurrency + (" " + (d.denominationSymbol + String(Number(d.value))));
        }), "");
    };
    var n = sortedArray.length;
    if (n !== 0) {
        if (n !== 1) {
            return getValueAndCurrency(0) + (" - " + getValueAndCurrency(n - 1 | 0));
        } else {
            return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .get */ .U2(sortedArray, 0), function(d) {
                return d.valueCurrency + (" " + (d.denominationSymbol + String(Number(d.value))));
            }), "");
        }
    } else {
        return "";
    }
}
function skuDenToCardDen(d) {
    return {
        code: d.code,
        value: d.value,
        valueCurrency: d.valueCurrency,
        denominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency),
        price: d.price,
        priceCurrency: d.priceCurrency,
        priceDenominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.priceCurrency)
    };
}
function makeCategory(c) {
    return {
        name: c.name,
        slug: c.slug,
        position: c.position,
        order: c.order,
        skuPosition: c.skuPosition
    };
}
function fixCategories(categories) {
    _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .reduce */ .u4(categories, false, function(hasCountry, cat) {
        if (hasCountry) {
            return true;
        } else {
            return _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__/* .mem */ .$p(cat.name, _config_CategoriesConf_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .countriesWithCountryCat */ .lM);
        }
    });
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(categories, makeCategory);
}
function makeAlert(a) {
    return {
        title: a.title,
        messageMarkdown: a.messageMarkdown,
        level: a.level,
        priority: a.priority
    };
}
function fixAlerts(alerts) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(alerts, makeAlert);
}
function makeTheme(t) {
    return {
        uid: t.uid,
        code: t.code,
        image: t.image
    };
}
function fixThemes(themes) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(themes, makeTheme);
}
function makeTemplate(t) {
    return {
        uid: t.uid,
        imageFrame: t.imageFrame,
        imagePreview: t.imagePreview
    };
}
function fixTemplates(templates) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(templates, makeTemplate);
}
function makePromo(p) {
    return {
        uid: p.uid,
        title: p.title,
        enabled: p.enabled,
        promoText: p.promoText,
        terms: p.terms
    };
}
function fixPromos(promos) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(promos, makePromo);
}
function makeSlug(backendSlug) {
    return _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__/* .lowercase_ascii */ .uq(backendSlug) + "-gift-card";
}
function makeMerchant(m) {
    return {
        terms: m.terms
    };
}
function makeImage(themes) {
    if (themes.length !== 0) {
        return _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_7__/* .get */ .U2(themes, 0).image;
    } else {
        return "";
    }
}
var emptyPresentation = {
    codename: "",
    themes: [],
    audience: [],
    interest: [],
    occasion: [],
    locationAu: [],
    locationNz: [],
    locationUk: [],
    locationUs: []
};
function skuToCard(sku) {
    var sortedPrices = _rescript_std_lib_es6_belt_SortArray_js__WEBPACK_IMPORTED_MODULE_8__/* .stableSortBy */ .Yf(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(sku.denominations, skuDenToCardDen), sortCardsByDenominations);
    return {
        uid: sku.uid,
        imgUrl: makeImage(sku.themes),
        name: sku.name,
        searchableTerms: sku.searchableTerms,
        similarTerms: sku.similarTerms,
        displayName: sku.displayName,
        priceRange: getPriceRange(sortedPrices),
        denominations: sortedPrices,
        templates: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(sku.templates, makeTemplate),
        themes: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(sku.themes, makeTheme),
        promos: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(sku.promos, makePromo),
        description: sku.description,
        longDescription: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(sku.longDescription), ""),
        tagline: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(sku.tagline), ""),
        descriptionMarkdown: sku.descriptionMarkdown,
        isSwappable: sku.isSwappable,
        slug: _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__/* .lowercase_ascii */ .uq(sku.slug) + "-gift-card",
        code: sku.code,
        categories: fixCategories(sku.categories),
        expiryTermDisplay: sku.expiryTermDisplay,
        alerts: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(sku.alerts, makeAlert),
        isPbCategoryHidden: sku.isPbCategoryHidden,
        isPcCategoryHidden: sku.isPcCategoryHidden,
        layerEnabled: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(sku.layerEnabled), false),
        merchant: {
            terms: sku.merchant.terms
        },
        cmsId: sku.cmsId,
        createdAt: sku.createdAt,
        presentation: {
            codename: sku.cmsId,
            themes: [],
            audience: [],
            interest: [],
            occasion: [],
            locationAu: [],
            locationNz: [],
            locationUk: [],
            locationUs: []
        }
    };
}
var emptyCard_denominations = [];
var emptyCard_templates = [];
var emptyCard_themes = [];
var emptyCard_promos = [];
var emptyCard_categories = [];
var emptyCard_alerts = [];
var emptyCard_merchant = {
    terms: ""
};
var emptyCard = {
    uid: "",
    imgUrl: "",
    name: "",
    searchableTerms: "",
    similarTerms: "",
    displayName: "",
    priceRange: "",
    denominations: emptyCard_denominations,
    templates: emptyCard_templates,
    themes: emptyCard_themes,
    promos: emptyCard_promos,
    description: "",
    longDescription: "",
    tagline: "",
    descriptionMarkdown: "",
    isSwappable: false,
    slug: "",
    code: "",
    categories: emptyCard_categories,
    expiryTermDisplay: "",
    alerts: emptyCard_alerts,
    isPbCategoryHidden: false,
    isPcCategoryHidden: false,
    layerEnabled: false,
    merchant: emptyCard_merchant,
    cmsId: "",
    createdAt: "",
    presentation: emptyPresentation
};
var Card = {
    sortCardsByDenominations: sortCardsByDenominations,
    getDenominationSymbol: getDenominationSymbol,
    getPriceDenominationSymbol: getPriceDenominationSymbol,
    getPriceRange: getPriceRange,
    skuDenToCardDen: skuDenToCardDen,
    makeCategory: makeCategory,
    fixCategories: fixCategories,
    makeAlert: makeAlert,
    fixAlerts: fixAlerts,
    makeTheme: makeTheme,
    fixThemes: fixThemes,
    makeTemplate: makeTemplate,
    fixTemplates: fixTemplates,
    makePromo: makePromo,
    fixPromos: fixPromos,
    makeSlug: makeSlug,
    makeMerchant: makeMerchant,
    makeImage: makeImage,
    emptyPresentation: emptyPresentation,
    skuToCard: skuToCard,
    emptyCard: emptyCard
};
function rewriteUrl(url) {
    return _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_10__/* .replaceByRe */ .jt(/https:\/\/((?!go\.).)*prezzee.(com|co|uk).*?\//g, "https://www.prezzee.co.nz/", url);
}
function bannerDataToBanner(b) {
    return {
        uid: b.uid,
        name: b.name,
        url: rewriteUrl(b.url),
        text: b.text,
        textColour: b.textColour,
        backgroundColour: b.backgroundColour,
        buttonText: b.buttonText,
        prefixText: b.prefixText,
        fontawesomeIconClass: b.fontawesomeIconClass
    };
}
function slideDataToSlide(s) {
    return {
        uid: s.uid,
        name: s.name,
        buttonBackgroundColour: s.buttonBackgroundColour,
        buttonBorderColour: s.buttonBorderColour,
        buttonTextColour: s.buttonTextColour,
        buttonBackgroundColourHover: s.buttonBackgroundColourHover,
        buttonBorderColourHover: s.buttonBorderColourHover,
        buttonTextColourHover: s.buttonTextColourHover,
        backgroundImage: s.backgroundImage,
        leftImage: s.leftImage,
        centeredImage: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(s.centeredImage),
        titleColour: s.titleColour,
        titleShadowColour: s.titleShadowColour,
        enableTitleShadow: s.enableTitleShadow,
        title: s.title,
        subtitle: s.subtitle,
        subtitleColour: s.subtitleColour,
        buttonVimeoVideoId: s.buttonVimeoVideoId,
        buttonShowVideoPopup: s.buttonShowVideoPopup,
        buttonUrl: rewriteUrl(s.buttonUrl),
        buttonLabel: s.buttonLabel
    };
}
function homePageDataToHomePageSlide(h) {
    return {
        banner: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(h.banner), bannerDataToBanner),
        slides: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(h.slides, slideDataToSlide)
    };
}
var HomePageSlide = {
    rewriteUrl: rewriteUrl,
    bannerDataToBanner: bannerDataToBanner,
    slideDataToSlide: slideDataToSlide,
    homePageDataToHomePageSlide: homePageDataToHomePageSlide
};
var MenuItem = {};
var SideBar = {
    MenuItem: MenuItem
};
var $$Notification = {};
var ProductDescription = {};
function toOpt(prim) {
    if (prim === null) {
        return;
    } else {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .some */ .G(prim);
    }
}
function getCardDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency);
}
function getCardOriginalBalanceDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.originalBalanceCurrency);
}
function getCardBalanceDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.balanceCurrency);
}
function getCardDefaultBalance(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DefaultBalance.getDefaultBalance */ .qt.getDefaultBalance(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(d.balance));
}
function giftDataMediaProviderDetails(t) {
    return {
        videoId: t.videoId,
        accountId: t.accountId,
        playerId: t.playerId
    };
}
function giftDataMediaToMedia(t) {
    return {
        uid: t.uid,
        mediaType: t.mediaType,
        provider: t.provider,
        providerDetails: giftDataMediaProviderDetails(t.providerDetails)
    };
}
function optionGiftToWalletGift(giftOpt) {
    if (giftOpt === undefined) {
        return;
    }
    if (giftOpt.TAG === /* CardId */ 0) {
        return;
    }
    var g = giftOpt._0;
    return {
        uid: g.uid,
        status: g.status,
        regifted: g.regifted,
        message: g.message,
        recipientName: g.recipientName,
        recipientEmail: g.recipientEmail,
        unwrappingAuthFlowV2: g.unwrappingAuthFlowV2,
        senderName: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(g.senderName),
        senderEmail: g.senderEmail,
        senderLogoUrl: g.senderLogoUrl,
        theme: {
            uid: g.theme.uid,
            thumbImage: g.theme.thumbImage,
            squareIcon: g.theme.squareIcon,
            textureImage: g.theme.textureImage,
            keyColour: g.theme.keyColour,
            textColour: g.theme.textColour
        },
        media: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(g.media, giftDataMediaToMedia)
    };
}
function cardDataToWalletCard(c) {
    return {
        themeUid: c.themeUid,
        themeImage: c.themeImage,
        themekeyColour: c.themekeyColour,
        themeTextColour: c.themeTextColour,
        value: c.value,
        originalBalance: c.originalBalance,
        valueCurrency: c.valueCurrency,
        denominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.valueCurrency),
        originalBalanceCurrency: c.originalBalanceCurrency,
        originalBalanceDenominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.originalBalanceCurrency),
        balance: getCardDefaultBalance(c),
        balanceCurrency: c.balanceCurrency,
        balanceDenominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.balanceCurrency),
        expiry: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.expiry),
        isExpired: c.isExpired,
        balanceUpdatedAt: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.balanceUpdatedAt),
        notes: c.notes,
        uid: c.uid,
        productType: c.productType,
        cardLabel: c.cardLabel,
        cardPin: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.cardPin),
        cardId: c.cardId,
        number: c.number,
        barcodeNumber: c.barcodeNumber,
        instoreNumber: c.instoreNumber,
        onlineNumber: c.onlineNumber,
        pin: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.pin),
        pinFieldName: c.pinFieldName,
        cardBarcodeFormat: c.cardBarcodeFormat,
        cardLogo: c.cardLogo,
        merchantTerms: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.merchantTerms),
        status: c.status,
        subtype: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.subtype),
        updatedAt: c.updatedAt,
        activatedAt: c.activatedAt,
        createdAt: c.createdAt,
        receivedAt: c.receivedAt,
        gift: undefined,
        isSwapCard: c.isSwapCard,
        isSchemeCard: c.isSchemeCard,
        swapCard: c.swapCard,
        donation: c.donation,
        supportsRegift: c.supportsRegift,
        supportsBalanceCheck: c.supportsBalanceCheck,
        supportsAppleWalletExport: c.supportsAppleWalletExport,
        supportsGoogleWalletExport: c.supportsGoogleWalletExport,
        receiptText: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.receiptText),
        receiptLogoTop: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.receiptLogoTop),
        redemptionUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.redemptionUrl),
        balanceCheckUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.balanceCheckUrl),
        howToUse: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.howToUse),
        skuDisplayName: c.skuDisplayName,
        skuUid: c.skuUid,
        pdfUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.pdfUrl),
        defaultProductCode: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultProductCode),
        defaultProductThemeCode: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultProductThemeCode),
        defaultSkuUid: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultSkuUid)
    };
}
var WalletCard = {
    toOpt: toOpt,
    getCardDenominationSymbol: getCardDenominationSymbol,
    getCardOriginalBalanceDenominationSymbol: getCardOriginalBalanceDenominationSymbol,
    getCardBalanceDenominationSymbol: getCardBalanceDenominationSymbol,
    getCardDefaultBalance: getCardDefaultBalance,
    giftDataMediaProviderDetails: giftDataMediaProviderDetails,
    giftDataMediaToMedia: giftDataMediaToMedia,
    optionGiftToWalletGift: optionGiftToWalletGift,
    cardDataToWalletCard: cardDataToWalletCard
};
var BoardMember = {};
var AboutSlide = {};
function toOpt$1(prim) {
    if (prim === null) {
        return;
    } else {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .some */ .G(prim);
    }
}
function getDenominationSymbol$1(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency);
}
function getDenominationSymbolForHistoryCard(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency);
}
function getDenominationSymbolForFailedCard(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.valueCurrency);
}
function getOriginalBalanceDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.originalBalanceCurrency);
}
function getBalanceDenominationSymbol(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(d.balanceCurrency);
}
function getDefaultBalance(d) {
    return _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DefaultBalance.getDefaultBalance */ .qt.getDefaultBalance(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(d.balance));
}
function giftDataToCard(c) {
    return {
        themeUid: c.themeUid,
        themeImage: c.themeImage,
        themekeyColour: c.themekeyColour,
        themeTextColour: c.themeTextColour,
        value: c.value,
        originalBalance: c.originalBalance,
        valueCurrency: c.valueCurrency,
        denominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.valueCurrency),
        originalBalanceCurrency: c.originalBalanceCurrency,
        originalBalanceDenominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.originalBalanceCurrency),
        balance: getDefaultBalance(c),
        balanceCurrency: c.balanceCurrency,
        balanceDenominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.balanceCurrency),
        expiry: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.expiry),
        isExpired: c.isExpired,
        balanceUpdatedAt: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.balanceUpdatedAt),
        notes: c.notes,
        uid: c.uid,
        productType: c.productType,
        cardLabel: c.cardLabel,
        cardPin: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.cardPin),
        cardId: c.cardId,
        number: c.number,
        barcodeNumber: c.barcodeNumber,
        barcodeLabel: c.barcodeLabel,
        instoreNumber: c.instoreNumber,
        onlineNumber: c.onlineNumber,
        pin: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.pin),
        pinFieldName: c.pinFieldName,
        cardBarcodeFormat: c.cardBarcodeFormat,
        cardLogo: c.cardLogo,
        merchantTerms: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.merchantTerms),
        status: c.status,
        updatedAt: c.updatedAt,
        activatedAt: c.activatedAt,
        createdAt: c.createdAt,
        receivedAt: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .getWithDefault */ .tj(_rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.receivedAt), ""),
        gift: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.gift),
        isSwapCard: c.isSwapCard,
        isSchemeCard: c.isSchemeCard,
        subtype: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.subtype),
        swapCard: c.swapCard,
        donation: c.donation,
        supportsRegift: c.supportsRegift,
        supportsBalanceCheck: c.supportsBalanceCheck,
        supportsAppleWalletExport: c.supportsAppleWalletExport,
        supportsGoogleWalletExport: c.supportsGoogleWalletExport,
        receiptText: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.receiptText),
        receiptLogoTop: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.receiptLogoTop),
        redemptionUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.redemptionUrl),
        balanceCheckUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.balanceCheckUrl),
        howToUse: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.howToUse),
        skuDisplayName: c.skuDisplayName,
        skuUid: c.skuUid,
        pdfUrl: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.pdfUrl),
        defaultProductCode: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultProductCode),
        defaultProductThemeCode: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultProductThemeCode),
        defaultSkuUid: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(c.defaultSkuUid)
    };
}
function giftDataThemeToTheme(t) {
    return {
        uid: t.uid,
        thumbImage: t.thumbImage,
        squareIcon: t.squareIcon,
        textureImage: t.textureImage,
        keyColour: t.keyColour,
        textColour: t.textColour
    };
}
function giftDataMediaProviderDetails$1(t) {
    return {
        videoId: t.videoId,
        accountId: t.accountId,
        playerId: t.playerId
    };
}
function giftDataMediaToMedia$1(t) {
    return {
        uid: t.uid,
        mediaType: t.mediaType,
        provider: t.provider,
        providerDetails: giftDataMediaProviderDetails$1(t.providerDetails)
    };
}
function giftDataToHistoryCard(c) {
    return {
        cardLabel: c.cardLabel,
        themeImage: c.themeImage,
        balance: c.balance,
        balanceCurrency: c.balanceCurrency,
        value: c.value,
        valueCurrency: c.valueCurrency,
        denominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.valueCurrency),
        originalBalance: c.originalBalance,
        originalBalanceCurrency: c.originalBalanceCurrency
    };
}
function giftDataToHistoryGiftCard(t) {
    return {
        uid: t.uid,
        status: t.status,
        card: giftDataToHistoryCard(t.card),
        theme: giftDataThemeToTheme(t.theme)
    };
}
function giftDataSkuThemeToSkuTheme(t) {
    return {
        uid: t.uid,
        code: t.code,
        image: t.image,
        keyColour: t.keyColour,
        textColour: t.textColour
    };
}
function giftDataToFailedCard(c) {
    return {
        orderNumber: c.orderNumber,
        value: c.value,
        valueCurrency: c.valueCurrency,
        denominationSymbol: _common_util_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyUtils.getDenominationSymbol */ .uw.getDenominationSymbol(c.valueCurrency),
        skuTheme: giftDataSkuThemeToSkuTheme(c.skuTheme),
        skuDisplayName: c.skuDisplayName,
        uid: c.uid
    };
}
function giftDataToGiftCard(t) {
    return {
        uid: t.uid,
        status: t.status,
        regifted: t.regifted,
        message: t.message,
        recipientName: t.recipientName,
        recipientEmail: t.recipientEmail,
        senderName: _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_9__/* .null_to_opt */ .UA(t.senderName),
        senderEmail: t.senderEmail,
        senderType: t.senderType,
        senderLogoUrl: t.senderLogoUrl,
        card: giftDataToCard(t.card),
        theme: giftDataThemeToTheme(t.theme),
        media: _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(t.media, giftDataMediaToMedia$1),
        exchangeHistory: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(t.exchangeHistory, function(h) {
            return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(h, giftDataToHistoryGiftCard);
        }),
        exchangeHistoryFailure: _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_5__/* .map */ .UI(t.exchangeHistoryFailure, function(h) {
            return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_6__/* .map */ .UI(h, giftDataToFailedCard);
        }),
        giphyId: t.giphyId,
        giphyUrl: t.giphyUrl,
        canAddToWallet: t.canAddToWallet,
        unwrappedAt: t.unwrappedAt,
        pinStatus: t.pinStatus,
        unwrappingAuthFlowV2: t.unwrappingAuthFlowV2,
        forcedSignIn: t.forcedSignIn
    };
}
var GiftCard = {
    toOpt: toOpt$1,
    getDenominationSymbol: getDenominationSymbol$1,
    getDenominationSymbolForHistoryCard: getDenominationSymbolForHistoryCard,
    getDenominationSymbolForFailedCard: getDenominationSymbolForFailedCard,
    getOriginalBalanceDenominationSymbol: getOriginalBalanceDenominationSymbol,
    getBalanceDenominationSymbol: getBalanceDenominationSymbol,
    getDefaultBalance: getDefaultBalance,
    giftDataToCard: giftDataToCard,
    giftDataThemeToTheme: giftDataThemeToTheme,
    giftDataMediaProviderDetails: giftDataMediaProviderDetails$1,
    giftDataMediaToMedia: giftDataMediaToMedia$1,
    giftDataToHistoryCard: giftDataToHistoryCard,
    giftDataToHistoryGiftCard: giftDataToHistoryGiftCard,
    giftDataSkuThemeToSkuTheme: giftDataSkuThemeToSkuTheme,
    giftDataToFailedCard: giftDataToFailedCard,
    giftDataToGiftCard: giftDataToGiftCard
};
var Exchange = {};
var CustomTheme = {};
var Signup = {};
 /* Util Not a pure module */ 


/***/ }),

/***/ 43243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$$": function() { return /* binding */ getFieldErrorWithDefault; },
/* harmony export */   "NA": function() { return /* binding */ getValue; },
/* harmony export */   "V8": function() { return /* binding */ getPhoneControllerOptions; },
/* harmony export */   "WP": function() { return /* binding */ getPhoneError; },
/* harmony export */   "by": function() { return /* binding */ getError; },
/* harmony export */   "ly": function() { return /* binding */ getPhoneNumber; },
/* harmony export */   "qQ": function() { return /* binding */ onError; },
/* harmony export */   "xw": function() { return /* binding */ getTouchedError; },
/* harmony export */   "zQ": function() { return /* binding */ getFieldError; }
/* harmony export */ });
/* unused harmony exports hasError, getCountryCode, getPhoneTouchedError */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70655);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72491);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25400);
/* harmony import */ var _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47861);
// Generated by ReScript, PLEASE EDIT WITH CARE






function getFieldError(errors, name) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(_rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(errors, name), function(err) {
        return err.message;
    });
}
function getFieldErrorWithDefault(errors, name, defaultMsg) {
    var error = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(errors, name);
    if (error !== undefined) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(defaultMsg);
    }
}
function getValue(value) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .getWithDefault */ .tj(value == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(value), "");
}
function onError(param) {}
function getError(touched, fieldName, errors) {
    if (touched == null) {
        return;
    }
    var tt = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(touched, fieldName);
    if (_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .isSome */ .pC(tt)) {
        return getFieldError(errors, fieldName);
    }
}
function hasError(error) {
    return Belt_Option.getWithDefault(error, "") !== "";
}
function getPhoneControllerOptions(control, name, isRequired) {
    return {
        name: name,
        control: control,
        rules: {
            validate: function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(value) {
                    var match, response, exn;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (value == null) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                match = value.number.trim();
                                if (match === "") {
                                    return [
                                        2,
                                        !isRequired
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _api_PrezzeePublicClient_bs_js__WEBPACK_IMPORTED_MODULE_0__.validatePhoneNumber(match)
                                ];
                            case 2:
                                response = _state.sent();
                                if (response.TAG === /* Ok */ 0) {
                                    return [
                                        2,
                                        true
                                    ];
                                } else {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                exn = _state.sent();
                                return [
                                    2,
                                    false
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(value) {
                    return _ref.apply(this, arguments);
                };
            }()
        },
        defaultValue: null
    };
}
function getCountryCode(value) {
    return Belt_Option.mapWithDefault(value == null ? undefined : Caml_option.some(value), "", function(a) {
        return a.countryCode;
    });
}
function getPhoneNumber(value) {
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .mapWithDefault */ .k7(value == null ? undefined : _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_3__/* .some */ .G(value), "", function(a) {
        return a.number;
    });
}
function getTouchedError(form, name) {
    var touched = form.formState.touched;
    if (touched == null) {
        return;
    }
    var t = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(touched, name);
    if (!_rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .isSome */ .pC(t)) {
        return;
    }
    var err = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(form.errors, name);
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(err, function(e) {
        return e.message;
    });
}
function getPhoneError(errors, value) {
    var err = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(errors, "phoneNumber");
    return _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(err, function(param) {
        if (getPhoneNumber(value) === "") {
            return "Phone number is required";
        } else {
            return "Please enter a valid mobile number";
        }
    });
}
function getPhoneTouchedError(form, value) {
    var err = getTouchedError(form, "phoneNumber");
    return Belt_Option.map(err, function(param) {
        if (getPhoneNumber(value) === "") {
            return "Phone number is required";
        } else {
            return "Please enter a valid mobile number";
        }
    });
}
 /* PrezzeePublicClient Not a pure module */ 


/***/ }),

/***/ 37110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qp": function() { return /* binding */ useContext; }
/* harmony export */ });
/* unused harmony exports initContext, context, useLayoutData */
/* harmony import */ var _contexts_LayoutDataContext_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25149);
// Generated by ReScript, PLEASE EDIT WITH CARE

var context = _contexts_LayoutDataContext_ts__WEBPACK_IMPORTED_MODULE_0__/* .LayoutDataContext */ .N;
function useLayoutData(prim) {
    return _contexts_LayoutDataContext_ts__WEBPACK_IMPORTED_MODULE_0__/* .useLayoutData */ .Q();
}
var initContext;
var useContext = useLayoutData;
 /* context Not a pure module */ 


/***/ }),

/***/ 7618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ specialRegex; },
/* harmony export */   "BV": function() { return /* binding */ passwordRegex; },
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "J4": function() { return /* binding */ spaceRegex; },
/* harmony export */   "Uo": function() { return /* binding */ phoneNumberRegex; },
/* harmony export */   "bI": function() { return /* binding */ htmlCommentRegex; },
/* harmony export */   "pE": function() { return /* binding */ vimeoRegex; },
/* harmony export */   "qc": function() { return /* binding */ notOnlySpaceRegex; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var notOnlySpaceRegex = /.*[^ ].*/;
var passwordRegex = /^((?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,100})$/;
var phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
var vimeoRegex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/;
var specialRegex = /[$&+,:;=?@#|'<>.^*()\[|\]%!-]/g;
var htmlCommentRegex = /<!--(.*?)-->/g;
var spaceRegex = / /g;
 /* No side effect */ 


/***/ }),

/***/ 38612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ specialRegex; },
/* harmony export */   "Co": function() { return /* binding */ containsDigitRegex; },
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "HX": function() { return /* binding */ recipientNameRegex; },
/* harmony export */   "ZE": function() { return /* binding */ containsUpperCaseRegex; },
/* harmony export */   "_W": function() { return /* binding */ linuxOrWindows; },
/* harmony export */   "k1": function() { return /* binding */ htmlTag; },
/* harmony export */   "vL": function() { return /* binding */ curlyBrackets; },
/* harmony export */   "yk": function() { return /* binding */ containsLowerCaseRegex; }
/* harmony export */ });
// From https://emailregex.com/ Javascript
var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var recipientNameRegex = /^[A-Za-z]+[A-Za-z\s]*$/;
var containsLowerCaseRegex = /(?=.*?[a-z]).*/;
var containsUpperCaseRegex = /(?=.*?[A-Z]).*/;
var containsDigitRegex = /\d/;
var linuxOrWindows = new RegExp(/(Windows|Linux)/);
var curlyBrackets = /{.*\}/;
var specialRegex = /[$&+,:;=?@#|\\\/'<>.^*()%!-]/;
var htmlTag = /<(.|\n)*?>/;


/***/ }),

/***/ 25235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SegmentUtils; }
/* harmony export */ });
/* harmony import */ var _Regex_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7618);
/* harmony import */ var _rescript_std_lib_es6_js_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32867);
// Generated by ReScript, PLEASE EDIT WITH CARE


function mapElement(text, prefix, param) {
    var spaceRegex = /\s+/g;
    var elemPrefix = prefix !== undefined ? [
        prefix
    ] : [];
    return _rescript_std_lib_es6_js_array_js__WEBPACK_IMPORTED_MODULE_0__/* .concat */ .zo(text.toLowerCase().replace(_Regex_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .specialRegex */ .$I, "").split(spaceRegex), elemPrefix).join("_");
}
var SegmentUtils = {
    mapElement: mapElement
};
 /* No side effect */ 


/***/ }),

/***/ 89090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ generateUniqueSignupId; },
/* harmony export */   "x": function() { return /* binding */ decryptUserCookie; }
/* harmony export */ });
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31611);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25934);
/* harmony import */ var crypto_js_aes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40452);
/* harmony import */ var crypto_js_aes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(crypto_js_aes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var crypto_js_enc_utf8__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55743);
/* harmony import */ var crypto_js_enc_utf8__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto_js_enc_utf8__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var js_convert_case__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24417);





/**
 * Decrypts the user details from the auth cookie
 * @param cookie - the cookie to decrypt
 * @returns the decrypted user or throws an error
 */ function decryptUserCookie(cookie) {
    try {
        return (0,js_convert_case__WEBPACK_IMPORTED_MODULE_3__.camelKeys)(JSON.parse(crypto_js_aes__WEBPACK_IMPORTED_MODULE_1___default().decrypt(cookie, "hM23OPzVXo1RgV7nvpE6uJftHk58PzoSyGRayI21Q3dVP1Cu1NtM0bjd1tsKa6oH").toString((crypto_js_enc_utf8__WEBPACK_IMPORTED_MODULE_2___default()))), {
            recursive: true,
            recursiveInArray: true
        });
    } catch (err) {
        utils_logger__WEBPACK_IMPORTED_MODULE_0__/* ["default"].error */ .ZP.error({
            err: err,
            journey: "Authentication"
        }, "error: unable to decrypt user cookie");
    }
}
/**
 * Generates the unique signup ID
 */ function generateUniqueSignupId() {
    var timeStamp = Date.now().toString();
    return timeStamp.concat((0,uuid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)());
}


/***/ }),

/***/ 60752:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var debounce = function(fn) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var timeoutId;
    return function debounce() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _this = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (debounce);


/***/ }),

/***/ 31611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports redactionsList, logger */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var pino__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36559);
/* harmony import */ var pino__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pino__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _datadog_browser_logs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27571);



var redactionsList = [
    "access_token",
    "data.access_token",
    "data.*.access_token",
    "accessToken",
    "data.accessToken",
    "data.*.accessToken",
    "email",
    "data.email",
    "data.*.email",
    "hostname",
    "jwt",
    "data.jwt",
    "data.*.jwt",
    "JWT",
    "data.JWT",
    "data.*.JWT",
    "params", 
];
var isBrowser = "object" !== "undefined";
var pinoLogger = pino__WEBPACK_IMPORTED_MODULE_0___default()({
    level: "info",
    redact: redactionsList,
    mixin: function mixin() {
        var _NEXT_PUBLIC_BUILD_VERSION;
        // not supported by browser API - https://github.com/pinojs/pino/issues/765
        return {
            buildVersion: (_NEXT_PUBLIC_BUILD_VERSION = "v2025/11/05_09:18:48_NZ") !== null && _NEXT_PUBLIC_BUILD_VERSION !== void 0 ? _NEXT_PUBLIC_BUILD_VERSION : "unknown"
        };
    }
});
var getMethodNameByLevel = function(level) {
    if (level === "debug") return "debug";
    if (level === "error") return "error";
    if (level === "info") return "info";
    if (level === "warn") return "warn";
};
function log(level, messageOrContext, msg) {
    var env = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
        "local",
        "development",
        "staging",
        "production"
    ];
    if (!env.includes("production")) return;
    var methodName = getMethodNameByLevel(level);
    var baseContext = {
        countryCode: "NZ"
    };
    var context = typeof messageOrContext === "string" ? baseContext : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, baseContext, messageOrContext);
    var message = typeof messageOrContext === "string" ? messageOrContext : msg !== null && msg !== void 0 ? msg : "".concat(methodName.toUpperCase, " without message");
    if (window["DD_LOGS"]) {
        var ref, ref1;
        (ref = _datadog_browser_logs__WEBPACK_IMPORTED_MODULE_1__/* .datadogLogs.logger */ .fy.logger) === null || ref === void 0 ? void 0 : (ref1 = ref[methodName]) === null || ref1 === void 0 ? void 0 : ref1.call(ref, message, context);
    }
    pinoLogger[methodName](context, message);
}
var browserLogger = {
    debug: function(messageOrContext, msg, env) {
        return log("debug", messageOrContext, msg, env);
    },
    error: function(messageOrContext, msg, env) {
        return log("error", messageOrContext, msg, env);
    },
    info: function(messageOrContext, msg, env) {
        return log("info", messageOrContext, msg, env);
    },
    warn: function(messageOrContext, msg, env) {
        return log("warn", messageOrContext, msg, env);
    }
};
var logger = isBrowser ? browserLogger : pinoLogger;
/* harmony default export */ __webpack_exports__["ZP"] = (logger);


/***/ }),

/***/ 50771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ parseList; },
  "c": function() { return /* binding */ parseRichTextData; }
});

// EXTERNAL MODULE: ./node_modules/node-html-parser/dist/index.js
var dist = __webpack_require__(90698);
;// CONCATENATED MODULE: ./node_modules/node-html-parser/esm/index.js


const CommentNode = dist.CommentNode;
const HTMLElement = dist.HTMLElement;
const parse = dist.parse;
const valid = dist.valid;
const Node = dist.Node;
const TextNode = dist.TextNode;
const NodeType = dist.NodeType;

/* harmony default export */ var esm = ((/* unused pure expression or super */ null && (nhp)));
;// CONCATENATED MODULE: ./src/utils/parseRichTextData.ts

var parseList = function(str) {
    var htmlDoc = parse(str);
    return htmlDoc.childNodes.filter(function(el) {
        return el.nodeType === 1 && el.tagName === "LI";
    }).map(function(el) {
        return el.innerHTML;
    });
};
var parseRichTextData = function(str) {
    var htmlDoc = parse(str);
    var items = htmlDoc.childNodes.filter(function(param) {
        var nodeType = param.nodeType;
        return nodeType === 1;
    });
    var isObjectItems = false;
    var elements = items.map(function(element) {
        var el = element;
        var tagName = el.tagName;
        switch(tagName){
            case "OBJECT":
                isObjectItems = true;
                return {
                    tag: "OBJECT",
                    data: el.getAttribute("data-codename")
                };
            default:
                return {
                    tag: tagName,
                    data: el.innerHTML
                };
        }
    });
    return {
        elements: elements,
        isObjectItems: isObjectItems
    };
};


/***/ }),

/***/ 5490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);


var poll = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(param) {
        var fn, validate, interval, maxAttempts, attempts, executePoll;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            fn = param.fn, validate = param.validate, interval = param.interval, maxAttempts = param.maxAttempts;
            attempts = 0;
            executePoll = function() {
                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(resolve, reject) {
                    var result;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fn()
                                ];
                            case 1:
                                result = _state.sent();
                                attempts++;
                                if (validate(result)) {
                                    return [
                                        2,
                                        resolve(result)
                                    ];
                                } else if (maxAttempts && attempts === maxAttempts) {
                                    return [
                                        2,
                                        reject(new Error("Exceeded max attempts"))
                                    ];
                                } else {
                                    setTimeout(executePoll, interval, resolve, reject);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function executePoll(resolve, reject) {
                    return _ref.apply(this, arguments);
                };
            }();
            return [
                2,
                new Promise(executePoll)
            ];
        });
    });
    return function poll(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (poll);


/***/ }),

/***/ 64438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cb": function() { return /* binding */ generateAuthMfeUrl; },
/* harmony export */   "_0": function() { return /* binding */ generateCustomerMfeUrl; },
/* harmony export */   "bh": function() { return /* binding */ generateRecipientMfeUrl; },
/* harmony export */   "mw": function() { return /* binding */ generateRevampedAuthPath; }
/* harmony export */ });
/**
 * generate a revamped auth path in format `/gift/open/[uid]/auth/
 *
 * @param pathType the type of auth path
 * @param giftUid the gift card uid
 * @param blob optional, the `b` value
 * @returns a new auth path
 */ var generateRevampedAuthPath = function(pathType, giftUid, blob) {
    var newPath = "/gift/open/".concat(giftUid, "/").concat(pathType, "/");
    if (blob) {
        newPath = "".concat(newPath, "?b=").concat(blob);
    }
    return newPath;
};
var generateAuthMfeUrl = function(path, searchParams) {
    var authMfeUrl = "https://auth.prezzee.co.nz/en-nz" || 0;
    if (!authMfeUrl) {
        throw new Error("NEXT_PUBLIC_AUTH_MFE_URL is not defined");
    }
    return makeUrl(authMfeUrl, path, searchParams);
};
var generateRecipientMfeUrl = function(path, searchParams) {
    var recipientMfeUrl = "https://open.prezzee.co.nz/en-nz/nz" || 0;
    if (!recipientMfeUrl) {
        throw new Error("NEXT_PUBLIC_RECIPIENT_MFE_URL is not defined");
    }
    return makeUrl(recipientMfeUrl, path, searchParams);
};
var generateCustomerMfeUrl = function(path, searchParams) {
    var customerMfeUrl = "https://my.prezzee.co.nz/en-nz" || 0;
    if (!customerMfeUrl) {
        throw new Error("NEXT_PUBLIC_CUSTOMER_MFE_URL is not defined");
    }
    return makeUrl(customerMfeUrl, path, searchParams);
};
var makeUrl = function(baseUrl, path, searchParams) {
    var url = new URL("".concat(baseUrl, "/").concat(path));
    if (searchParams) {
        Object.entries(searchParams).forEach(function(entry) {
            url.searchParams.append(entry[0], entry[1]);
        });
    }
    return url;
};


/***/ }),

/***/ 55047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: undefined,
        height: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, []);
    return windowSize;
}


/***/ }),

/***/ 57687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pz": function() { return /* binding */ stringify; },
/* harmony export */   "Qc": function() { return /* binding */ parse; },
/* harmony export */   "YF": function() { return /* binding */ parseOrRaise; }
/* harmony export */ });
/* unused harmony exports Decode, Encode, ParseError */
/* harmony import */ var _rescript_std_lib_es6_js_exn_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49263);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25400);
/* harmony import */ var _rescript_std_lib_es6_caml_exceptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86592);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37082);




var ParseError = /* @__PURE__ */ _rescript_std_lib_es6_caml_exceptions_js__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue("Json.ParseError");
function parse(s) {
    try {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .some */ .G(JSON.parse(s));
    } catch (exn) {
        return;
    }
}
function parseOrRaise(s) {
    try {
        return JSON.parse(s);
    } catch (raw_e) {
        var e = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_1__/* .internalToOCamlException */ .UW(raw_e);
        if (e.RE_EXN_ID === _rescript_std_lib_es6_js_exn_js__WEBPACK_IMPORTED_MODULE_3__/* .$$Error */ .lC) {
            var m = e._1.message;
            var message = m !== undefined ? m : "Unknown error";
            throw {
                RE_EXN_ID: ParseError,
                _1: message,
                Error: new Error()
            };
        }
        throw e;
    }
}
var Decode;
var Encode;
function stringify(prim) {
    return JSON.stringify(prim);
}
 /* No side effect */ 


/***/ }),

/***/ 35847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ nullable; },
/* harmony export */   "EP": function() { return /* binding */ field; },
/* harmony export */   "G6": function() { return /* binding */ $$int; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Wc": function() { return /* binding */ withDefault; },
/* harmony export */   "Xg": function() { return /* binding */ bool; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "_9": function() { return /* binding */ DecodeError; },
/* harmony export */   "jt": function() { return /* binding */ optional; }
/* harmony export */ });
/* unused harmony exports id, $$float, $$char, date, nullAs, list, pair, tuple2, tuple3, tuple4, dict, at, oneOf, either, andThen */
/* harmony import */ var _rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62494);
/* harmony import */ var _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74594);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25400);
/* harmony import */ var _rescript_std_lib_es6_caml_exceptions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86592);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37082);









function _isInteger(value) {
    if (Number.isFinite(value)) {
        return Math.floor(value) === value;
    } else {
        return false;
    }
}
var DecodeError = /* @__PURE__ */ _rescript_std_lib_es6_caml_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .create */ .Ue("Json_decode.DecodeError");
function id(json) {
    return json;
}
function bool(json) {
    if (typeof json === "boolean") {
        return json;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected boolean, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function $$float(json) {
    if (typeof json === "number") {
        return json;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected number, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function $$int(json) {
    var f = $$float(json);
    if (_isInteger(f)) {
        return f;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected integer, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function string(json) {
    if (typeof json === "string") {
        return json;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected string, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function $$char(json) {
    var s = string(json);
    if (s.length === 1) {
        return Caml_string.get(s, 0);
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected single-character string, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function date(json) {
    return new Date(string(json));
}
function nullable(decode, json) {
    if (json === null) {
        return null;
    } else {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, json);
    }
}
function nullAs(value, json) {
    if (json === null) {
        return value;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected null, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function array(decode, json) {
    if (Array.isArray(json)) {
        var length = json.length;
        var target = new Array(length);
        for(var i = 0; i < length; ++i){
            var value;
            try {
                value = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, json[i]);
            } catch (raw_msg) {
                var msg = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + ("\n	in array at index " + String(i)),
                        Error: new Error()
                    };
                }
                throw msg;
            }
            target[i] = value;
        }
        return target;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected array, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function list(decode, json) {
    return $$Array.to_list(array(decode, json));
}
function pair(decodeA, decodeB, json) {
    if (Array.isArray(json)) {
        var length = json.length;
        if (length === 2) {
            try {
                return [
                    Curry._1(decodeA, json[0]),
                    Curry._1(decodeB, json[1])
                ];
            } catch (raw_msg) {
                var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + "\n	in pair/tuple2",
                        Error: new Error()
                    };
                }
                throw msg;
            }
        } else {
            throw {
                RE_EXN_ID: DecodeError,
                _1: "Expected array of length 2, got array of length " + length,
                Error: new Error()
            };
        }
    } else {
        throw {
            RE_EXN_ID: DecodeError,
            _1: "Expected array, got " + JSON.stringify(json),
            Error: new Error()
        };
    }
}
function tuple3(decodeA, decodeB, decodeC, json) {
    if (Array.isArray(json)) {
        var length = json.length;
        if (length === 3) {
            try {
                return [
                    Curry._1(decodeA, json[0]),
                    Curry._1(decodeB, json[1]),
                    Curry._1(decodeC, json[2])
                ];
            } catch (raw_msg) {
                var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + "\n	in tuple3",
                        Error: new Error()
                    };
                }
                throw msg;
            }
        } else {
            throw {
                RE_EXN_ID: DecodeError,
                _1: "Expected array of length 3, got array of length " + length,
                Error: new Error()
            };
        }
    } else {
        throw {
            RE_EXN_ID: DecodeError,
            _1: "Expected array, got " + JSON.stringify(json),
            Error: new Error()
        };
    }
}
function tuple4(decodeA, decodeB, decodeC, decodeD, json) {
    if (Array.isArray(json)) {
        var length = json.length;
        if (length === 4) {
            try {
                return [
                    Curry._1(decodeA, json[0]),
                    Curry._1(decodeB, json[1]),
                    Curry._1(decodeC, json[2]),
                    Curry._1(decodeD, json[3])
                ];
            } catch (raw_msg) {
                var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + "\n	in tuple4",
                        Error: new Error()
                    };
                }
                throw msg;
            }
        } else {
            throw {
                RE_EXN_ID: DecodeError,
                _1: "Expected array of length 4, got array of length " + length,
                Error: new Error()
            };
        }
    } else {
        throw {
            RE_EXN_ID: DecodeError,
            _1: "Expected array, got " + JSON.stringify(json),
            Error: new Error()
        };
    }
}
function dict(decode, json) {
    if (typeof json === "object" && !Array.isArray(json) && json !== null) {
        var keys = Object.keys(json);
        var l = keys.length;
        var target = {};
        for(var i = 0; i < l; ++i){
            var key = keys[i];
            var value;
            try {
                value = Curry._1(decode, json[key]);
            } catch (raw_msg) {
                var msg = Caml_js_exceptions.internalToOCamlException(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + "\n	in dict",
                        Error: new Error()
                    };
                }
                throw msg;
            }
            target[key] = value;
        }
        return target;
    }
    throw {
        RE_EXN_ID: DecodeError,
        _1: "Expected object, got " + JSON.stringify(json),
        Error: new Error()
    };
}
function field(key, decode, json) {
    if (typeof json === "object" && !Array.isArray(json) && json !== null) {
        var value = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .get */ .U2(json, key);
        if (value !== undefined) {
            try {
                return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .valFromOption */ .xt(value));
            } catch (raw_msg) {
                var msg = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_msg);
                if (msg.RE_EXN_ID === DecodeError) {
                    throw {
                        RE_EXN_ID: DecodeError,
                        _1: msg._1 + ("\n	at field '" + (key + "'")),
                        Error: new Error()
                    };
                }
                throw msg;
            }
        } else {
            throw {
                RE_EXN_ID: DecodeError,
                _1: "Expected field '" + key + "'",
                Error: new Error()
            };
        }
    } else {
        throw {
            RE_EXN_ID: DecodeError,
            _1: "Expected object, got " + JSON.stringify(json),
            Error: new Error()
        };
    }
}
function at(key_path, decoder) {
    if (key_path) {
        var rest = key_path.tl;
        var key = key_path.hd;
        if (!rest) {
            return function(param) {
                return field(key, decoder, param);
            };
        }
        var partial_arg = at(rest, decoder);
        return function(param) {
            return field(key, partial_arg, param);
        };
    }
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Expected key_path to contain at least one element",
        Error: new Error()
    };
}
function optional(decode, json) {
    try {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_6__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, json));
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === DecodeError) {
            return;
        }
        throw exn;
    }
}
function oneOf(decoders, json) {
    var _decoders = decoders;
    var _errors = /* [] */ 0;
    while(true){
        var errors = _errors;
        var decoders$1 = _decoders;
        if (decoders$1) {
            try {
                return Curry._1(decoders$1.hd, json);
            } catch (raw_e) {
                var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                if (e.RE_EXN_ID === DecodeError) {
                    _errors = {
                        hd: e._1,
                        tl: errors
                    };
                    _decoders = decoders$1.tl;
                    continue;
                }
                throw e;
            }
        } else {
            var formattedErrors = "\n- " + Js_array.joinWith("\n- ", $$Array.of_list(List.rev(errors)));
            throw {
                RE_EXN_ID: DecodeError,
                _1: "All decoders given to oneOf failed. Here are all the errors: " + formattedErrors + "\nAnd the JSON being decoded: " + JSON.stringify(json),
                Error: new Error()
            };
        }
    }
    ;
}
function either(a, b) {
    var partial_arg_1 = {
        hd: b,
        tl: /* [] */ 0
    };
    var partial_arg = {
        hd: a,
        tl: partial_arg_1
    };
    return function(param) {
        return oneOf(partial_arg, param);
    };
}
function withDefault($$default, decode, json) {
    try {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === DecodeError) {
            return $$default;
        }
        throw exn;
    }
}
function map(f, decode, json) {
    return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(f, _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(decode, json));
}
function andThen(b, a, json) {
    return Curry._2(b, Curry._1(a, json), json);
}
var tuple2 = (/* unused pure expression or super */ null && (pair));
 /* No side effect */ 


/***/ }),

/***/ 64221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ nullable; },
/* harmony export */   "GN": function() { return /* binding */ object_; },
/* harmony export */   "pb": function() { return /* binding */ list; }
/* harmony export */ });
/* unused harmony exports $$char, date, withDefault, pair, tuple2, tuple3, tuple4, dict, array */
/* harmony import */ var _rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62494);
/* harmony import */ var _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74594);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43437);
/* harmony import */ var _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46150);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25400);







function $$char(c) {
    return $$String.make(1, c);
}
function date(d) {
    return d.toJSON();
}
function nullable(encode, v) {
    if (v !== undefined) {
        return _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(encode, _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_4__/* .valFromOption */ .xt(v));
    } else {
        return null;
    }
}
function withDefault(d, encode, v) {
    if (v !== undefined) {
        return Curry._1(encode, Caml_option.valFromOption(v));
    } else {
        return d;
    }
}
function dict(encode, d) {
    var pairs = Js_dict.entries(d);
    return Js_dict.fromArray($$Array.map(function(param) {
        return [
            param[0],
            Curry._1(encode, param[1])
        ];
    }, pairs));
}
var object_ = _rescript_std_lib_es6_js_dict_js__WEBPACK_IMPORTED_MODULE_5__/* .fromList */ .hy;
var array = _rescript_std_lib_es6_array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI;
function list(encode, l) {
    if (!l) {
        return [];
    }
    var a = _rescript_std_lib_es6_caml_array_js__WEBPACK_IMPORTED_MODULE_6__/* .make */ .Sy(_rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__/* .length */ .kE(l), _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(encode, l.hd));
    var _i = 1;
    var _param = l.tl;
    while(true){
        var param = _param;
        var i = _i;
        if (!param) {
            return a;
        }
        a[i] = _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_3__._1(encode, param.hd);
        _param = param.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function pair(encodeA, encodeB, param) {
    return [
        Curry._1(encodeA, param[0]),
        Curry._1(encodeB, param[1])
    ];
}
function tuple3(encodeA, encodeB, encodeC, param) {
    return [
        Curry._1(encodeA, param[0]),
        Curry._1(encodeB, param[1]),
        Curry._1(encodeC, param[2])
    ];
}
function tuple4(encodeA, encodeB, encodeC, encodeD, param) {
    return [
        Curry._1(encodeA, param[0]),
        Curry._1(encodeB, param[1]),
        Curry._1(encodeC, param[2]),
        Curry._1(encodeD, param[3])
    ];
}
var tuple2 = (/* unused pure expression or super */ null && (pair));
 /* No side effect */ 


/***/ }),

/***/ 56631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var react_1 = __webpack_require__(67294);
__webpack_require__(35202);
var provider_1 = __webpack_require__(35735);
var system_1 = __webpack_require__(26812);
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return system_1.useTheme;
    }
});
var Toast_1 = __webpack_require__(29072);
var theme_1 = __importDefault(__webpack_require__(19818));
var extend_theme_1 = __webpack_require__(47101);
function ThemeProvider(_a) {
    var children = _a.children, themeOverrides = _a.theme, rest = __rest(_a, [
        "children",
        "theme"
    ]);
    var theme = themeOverrides ? (0, extend_theme_1.extendTheme)(theme_1.default, themeOverrides) : theme_1.default;
    var ToastContainer = (0, react_1.useMemo)(function() {
        return (0, Toast_1.createStandaloneToast)({
            theme: theme
        }).ToastContainer;
    }, [
        theme
    ]);
    return (0, jsx_runtime_1.jsxs)(provider_1.ChakraProvider, Object.assign({
        theme: theme
    }, rest, {
        children: [
            ToastContainer && (0, jsx_runtime_1.jsx)(ToastContainer, {}),
            children
        ]
    }));
}
exports.ZP = ThemeProvider;


/***/ }),

/***/ 7689:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var anatomy_1 = __webpack_require__(64657);
var utils_1 = __webpack_require__(46141);
var alertAnatomy = anatomy_1.alertAnatomy.extend("close");
var LIGHT_STATUS_STYLE_MAPPING = {
    info: {
        backgroundColor: "blue.50",
        borderColor: "notification.blue",
        titleColor: "blue.600",
        iconColor: "notification.blue"
    },
    warning: {
        backgroundColor: "yellow.50",
        borderColor: "yellow.400",
        titleColor: "yellow.700",
        iconColor: "yellow.500"
    },
    success: {
        backgroundColor: "green.50",
        borderColor: "green.400",
        titleColor: "green.600",
        iconColor: "green.400"
    },
    error: {
        backgroundColor: "red.50",
        borderColor: "red.400",
        titleColor: "red.600",
        iconColor: "red.400"
    },
    loading: {
        backgroundColor: "blue.50",
        borderColor: "notification.blue",
        titleColor: "blue.600",
        iconColor: "notification.blue"
    }
};
var variantLight = function(props) {
    var _status = props.status, status = _status === void 0 ? "info" : _status;
    var _status1 = LIGHT_STATUS_STYLE_MAPPING[status], backgroundColor = _status1.backgroundColor, borderColor = _status1.borderColor, iconColor = _status1.iconColor, titleColor = _status1.titleColor;
    return (0, utils_1.mergeWith)({}, props.theme.components.Alert.variants.subtle(props), {
        container: {
            backgroundColor: backgroundColor,
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: borderColor
        },
        icon: {
            color: iconColor
        },
        title: {
            color: titleColor
        },
        description: {
            color: "gray.800"
        },
        close: {
            _hover: {
                bg: "blackAlpha.100"
            },
            _active: {
                bg: "blackAlpha.200"
            }
        }
    });
};
var DARK_BACKGROUND_COLOR_MAPPING = {
    info: "blue.500",
    warning: "purple.400",
    success: "green.600",
    error: "red.500",
    loading: "blue.500"
};
var variantDark = function(props) {
    var _status = props.status, status = _status === void 0 ? "info" : _status;
    var backgroundColor = DARK_BACKGROUND_COLOR_MAPPING[status];
    return (0, utils_1.mergeWith)({}, props.theme.components.Alert.variants.solid(props), {
        container: {
            backgroundColor: backgroundColor,
            color: "white",
            borderStyle: "solid",
            borderWidth: 1,
            borderColor: backgroundColor
        },
        close: {
            color: "white",
            _hover: {
                bg: "whiteAlpha.100"
            },
            _active: {
                bg: "whiteAlpha.200"
            }
        }
    });
};
var baseStyle = {
    container: {
        alignItems: "flex-start",
        borderRadius: "md"
    },
    title: {
        fontWeight: "semibold",
        lineHeight: "base"
    },
    description: {
        lineHeight: "short",
        fontWeight: "normal"
    },
    close: {
        bg: "transparent",
        borderRadius: "md",
        color: "gray.800"
    }
};
var sizes = {
    sm: {
        container: {
            padding: 3
        },
        title: {
            fontSize: "sm"
        },
        description: {
            fontSize: "sm"
        }
    },
    lg: {
        container: {
            padding: 4
        },
        title: {
            fontSize: "md"
        },
        description: {
            fontSize: "md"
        }
    }
};
var variants = {
    light: variantLight,
    dark: variantDark
};
var defaultProps = {
    size: "sm",
    variant: "light"
};
var AlertStyles = {
    baseStyle: baseStyle,
    sizes: sizes,
    variants: variants,
    defaultProps: defaultProps
};
exports["default"] = AlertStyles;


/***/ }),

/***/ 18636:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var layout_1 = __webpack_require__(33559);
exports["default"] = layout_1.Box;


/***/ }),

/***/ 43515:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.ButtonGroup = void 0;
var jsx_runtime_1 = __webpack_require__(85893);
var button_1 = __webpack_require__(76844);
var system_1 = __webpack_require__(26812);
var button_2 = __webpack_require__(76844);
Object.defineProperty(exports, "ButtonGroup", ({
    enumerable: true,
    get: function get() {
        return button_2.ButtonGroup;
    }
}));
var Button = (0, system_1.forwardRef)(function(_a, ref) {
    var fullWidth = _a.fullWidth, props = __rest(_a, [
        "fullWidth"
    ]);
    var width = fullWidth ? "100%" : "auto";
    return (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({
        ref: ref,
        width: width
    }, props));
});
exports["default"] = Button;


/***/ }),

/***/ 11413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var utils_1 = __webpack_require__(46141);
var variantPrimary = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.solid(props), {
        color: "white",
        background: "primary.400",
        _hover: {
            background: "primary.500",
            _disabled: {
                background: "gray.400"
            }
        },
        _active: {
            background: "primary.700"
        },
        _disabled: {
            background: "gray.400"
        }
    });
};
var variantPrimaryInverted = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.solid(props), {
        color: "purple.400",
        background: "white",
        _hover: {
            background: "gray.200",
            _disabled: {
                color: "white",
                background: "gray.400"
            }
        },
        _active: {
            background: "gray.300"
        },
        _disabled: {
            color: "white",
            background: "gray.400"
        }
    });
};
var variantSecondary = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.outline(props), {
        color: "secondary.400",
        borderColor: "secondary.400",
        _hover: {
            color: "white",
            background: "secondary.400",
            _disabled: {
                borderColor: "gray.400",
                color: "gray.400",
                background: "gray.100"
            }
        },
        _active: {
            color: "white",
            borderColor: "secondary.700",
            background: "secondary.700"
        },
        _disabled: {
            borderColor: "gray.400",
            color: "gray.400",
            background: "gray.100"
        }
    });
};
var variantSecondaryInverted = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.outline(props), {
        color: "white",
        borderColor: "white",
        _hover: {
            color: "purple.400",
            background: "white",
            _disabled: {
                borderColor: "white",
                color: "gray.400",
                background: "gray.100"
            }
        },
        _active: {
            color: "purple.400",
            borderColor: "gray.100",
            background: "gray.100"
        },
        _disabled: {
            borderColor: "gray.400",
            color: "gray.400",
            background: "gray.100"
        }
    });
};
var variantTertiary = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.ghost(props), {
        color: "purple.400",
        _hover: {
            background: "lilac.100",
            _disabled: {
                color: "white",
                background: "gray.400"
            }
        },
        _active: {
            background: "purple.50"
        },
        _disabled: {
            color: "white",
            background: "gray.400"
        }
    });
};
var variantTertiaryInverted = function(props) {
    return (0, utils_1.mergeWith)({}, props.theme.components.Button.variants.ghost(props), {
        color: "white",
        _hover: {
            color: "purple.400",
            background: "lilac.100",
            _disabled: {
                color: "white",
                background: "gray.400"
            }
        },
        _active: {
            color: "purple.400",
            background: "gray.100"
        },
        _disabled: {
            color: "white",
            background: "gray.400"
        }
    });
};
var variantLink = {
    color: "blue.500",
    _hover: {
        color: "blue.600",
        _disabled: {
            color: "gray.300"
        }
    },
    _active: {
        color: "blue.700"
    },
    _disabled: {
        color: "gray.500"
    }
};
var variantLinkInverted = {
    color: "white",
    textDecoration: "underline",
    _hover: {
        color: "#F0EDED",
        _disabled: {
            color: "gray.300",
            textDecoration: "underline"
        }
    },
    _active: {
        color: "gray.300"
    },
    _disabled: {
        color: "gray.300",
        textDecoration: "underline"
    }
};
var baseStyle = {
    fontWeight: "semibold",
    borderRadius: "base"
};
var sizes = {
    sm: {
        height: 9,
        lineHeight: "22px"
    },
    md: {
        height: "42px",
        paddingX: 4
    },
    lg: {
        height: 12,
        paddingX: 8,
        fontSize: "md"
    }
};
var defaultProps = {
    variant: "primary",
    size: "md"
};
var variants = {
    primary: variantPrimary,
    secondary: variantSecondary,
    tertiary: variantTertiary,
    primaryInverted: variantPrimaryInverted,
    secondaryInverted: variantSecondaryInverted,
    tertiaryInverted: variantTertiaryInverted,
    link: variantLink,
    linkInverted: variantLinkInverted
};
var ButtonStyle = {
    baseStyle: baseStyle,
    defaultProps: defaultProps,
    variants: variants,
    sizes: sizes
};
exports["default"] = ButtonStyle;


/***/ }),

/***/ 17326:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    paddingY: 6,
    paddingX: {
        base: 6,
        md: 4
    },
    borderRadius: "sm",
    background: "white",
    shadow: "sm"
};
var CardStyle = {
    baseStyle: baseStyle
};
exports["default"] = CardStyle;


/***/ }),

/***/ 45161:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var CheckboxStyle = {
    baseStyle: {
        control: {
            borderColor: "gray.600",
            _hover: {
                borderColor: "purple.400"
            },
            _focus: {
                borderColor: "purple.400"
            },
            _disabled: {
                borderColor: "gray.300",
                background: "white",
                _hover: {
                    borderColor: "gray.300"
                }
            },
            _checked: {
                background: "purple.400",
                borderColor: "purple.400",
                _hover: {
                    background: "purple.400",
                    borderColor: "purple.400"
                },
                _focus: {
                    background: "purple.400",
                    borderColor: "purple.400"
                }
            },
            _invalid: {
                borderColor: "red.400",
                _hover: {
                    borderColor: "purple.400"
                },
                _focus: {
                    borderColor: "purple.400"
                },
                _checked: {
                    borderColor: "purple.400"
                }
            },
            marginTop: "0.3rem"
        },
        label: {},
        display: "flex",
        alignItems: "flex-start"
    }
};
exports["default"] = CheckboxStyle;


/***/ }),

/***/ 69221:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    color: "gray.800",
    borderRadius: "full",
    backgroundColor: "gray.100",
    _disabled: {
        backgroundColor: "gray.50"
    },
    _hover: {
        backgroundColor: "gray.200"
    },
    _active: {
        backgroundColor: "gray.300"
    }
};
var CloseButtonStyle = {
    baseStyle: baseStyle
};
exports["default"] = CloseButtonStyle;


/***/ }),

/***/ 51093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(94941)/* ["default"] */ .Z);
var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.FormError = exports.Form = void 0;
var styles_1 = __importDefault(__webpack_require__(46918));
var activeLabelStyles = {
    transform: "scale(0.85) translateY(-24px)"
};
var formVariants = {
    floating: {
        container: {
            _focusWithin: {
                label: Object.assign(Object.assign({}, activeLabelStyles), {
                    color: "gray.600"
                })
            },
            "input:not(:placeholder-shown) + label, .chakra-select__wrapper + label": Object.assign({}, activeLabelStyles),
            label: {
                top: 0,
                left: 0,
                zIndex: 2,
                position: "absolute",
                backgroundColor: "white",
                pointerEvents: "none",
                textColor: "gray.800",
                mx: 3,
                px: 1,
                my: 1.5,
                py: 1.5,
                transformOrigin: "left top"
            }
        }
    }
};
var FormStyle = {
    variants: formVariants
};
exports.Form = FormStyle;
var formErrorVariants = Object.fromEntries(Object.entries(styles_1.default.variants).map(function(param) {
    var _param = _slicedToArray(param, 2), variant = _param[0], styles = _param[1];
    return [
        variant,
        {
            text: styles
        }
    ];
}));
var FormErrorStyle = {
    baseStyle: {
        text: Object.assign(Object.assign({}, styles_1.default.baseStyle), {
            fontWeight: "400",
            color: "red.400",
            mt: 0.5
        })
    },
    variants: formErrorVariants,
    defaultProps: {
        variant: "body3"
    }
};
exports.FormError = FormErrorStyle;


/***/ }),

/***/ 70598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    inputRightElement: {
        position: "absolute",
        height: "100%",
        top: "auto",
        bottom: "0"
    }
};
var variants = {
    unstyled: {
        _focus: {
            boxShadow: "none"
        },
        size: "sm",
        pr: 2
    }
};
var FormInputPasswordStyle = {
    variants: variants,
    baseStyle: baseStyle
};
exports["default"] = FormInputPasswordStyle;


/***/ }),

/***/ 13274:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var FormInputPhoneNumberStyle = {
    baseStyle: {
        group: {
            width: "auto"
        },
        leftElement: {
            cursor: "pointer",
            width: "96px",
            borderRight: "1px solid",
            borderColor: "gray.400",
            alignItems: "center",
            display: "flex",
            flexDirection: "row",
            paddingLeft: "10px",
            paddingRight: "3px"
        },
        dialCode: {
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "24px",
            marginLeft: "8px",
            marginRight: "auto"
        },
        input: {
            paddingLeft: "108px",
            fontSize: "16px",
            borderColor: "gray.400",
            _invalid: {
                borderColor: "red.400"
            },
            _focus: {
                borderColor: "notification.blue"
            }
        },
        error: {
            color: "red.400",
            fontWeight: "400"
        },
        searchOnListBox: {
            maxH: "xs",
            bg: "white",
            width: "195px",
            zIndex: "999",
            height: "auto",
            overflow: "auto",
            borderRadius: "lg",
            position: "absolute",
            boxShadow: "0px 1px 30px rgba(0, 0, 0, 0.1)"
        },
        searchOnListListItem: {
            padding: "3",
            height: "40px",
            width: "193px",
            fontSize: "16px",
            fontWeight: "400",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            _hover: {
                backgroundColor: "lilac.50"
            }
        },
        label: {}
    }
};
exports["default"] = FormInputPhoneNumberStyle;


/***/ }),

/***/ 62228:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var FormInputPinStyle = {
    parts: [
        "appendix",
        "button",
        "buttonContainer",
        "container",
        "pinInputContainer",
        "pinInputField",
        "pinInputValid"
    ],
    baseStyle: {
        appendix: {
            width: "0",
            minWidth: "100%",
            gap: 10
        },
        button: {
            fontSize: "sm",
            fontWeight: "normal",
            textDecorationLine: "underline",
            _hover: {
                color: "blue.600",
                _disabled: {
                    color: "blue.500"
                }
            },
            _disabled: {
                opacity: 0.35,
                cursor: "not-allowed"
            }
        },
        buttonContainer: {
            marginLeft: "auto"
        },
        container: {
            gap: 3
        },
        pinInputContainer: {
            justifyContent: "space-between",
            gap: 2.5
        },
        pinInputField: {
            fontWeight: "normal",
            borderColor: "gray.300",
            lineHeight: {
                base: "2.3rem",
                "2xs": "2.3rem",
                xs: "2.3rem",
                sm: "2.3rem",
                md: "2.3rem",
                lg: "2.6rem",
                xl: "2.6rem",
                "2xl": "2.6rem"
            },
            fontSize: {
                base: "2xl",
                md: "2xl",
                lg: "3xl"
            },
            width: {
                base: "3rem",
                "2xs": "3rem",
                xs: "3rem",
                sm: "3rem",
                md: "3rem",
                lg: "3.75rem",
                xl: "3.75rem",
                "2xl": "3.75rem"
            },
            height: "3.75rem",
            _focus: {
                borderColor: "notification.blue"
            },
            "&[aria-invalid=true]": {
                borderColor: "red.400",
                boxShadow: "none"
            }
        },
        pinInputValid: {
            borderColor: "green.400",
            boxShadow: "none"
        }
    }
};
exports["default"] = FormInputPinStyle;


/***/ }),

/***/ 9832:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    select: {},
    _disabled: {
        textColor: "gray.400 !important"
    }
};
var FormInputSelectStyle = {
    baseStyle: baseStyle
};
exports["default"] = FormInputSelectStyle;


/***/ }),

/***/ 25986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    field: {
        borderWidth: "1px"
    }
};
var baseVariantFieldStyle = {
    _invalid: {
        boxShadow: "none"
    },
    _focus: {
        boxShadow: "none"
    }
};
var size = {
    lg: {
        borderRadius: "base",
        fontSize: "md"
    },
    md: {
        borderRadius: "base"
    }
};
var sizes = {
    lg: {
        field: size.lg,
        addon: size.lg
    },
    md: {
        field: size.md,
        addon: size.md
    }
};
var variants = {
    outline: {
        field: Object.assign({
            borderColor: "gray.400"
        }, baseVariantFieldStyle)
    },
    filled: {
        field: baseVariantFieldStyle
    },
    flushed: {
        field: baseVariantFieldStyle
    }
};
var InputStyle = {
    variants: variants,
    baseStyle: baseStyle,
    sizes: sizes,
    defaultProps: {
        size: "lg",
        errorBorderColor: "red.400",
        focusBorderColor: "notification.blue"
    }
};
exports["default"] = InputStyle;


/***/ }),

/***/ 71417:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var LinkStyle = {
    baseStyle: {
        color: "blue.500",
        textDecoration: "underline",
        _hover: {
            color: "blue.600"
        },
        _active: {
            color: "blue.700"
        }
    }
};
exports["default"] = LinkStyle;


/***/ }),

/***/ 15115:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.ol = exports.fe = exports.mz = exports.xB = exports.hz = exports.ZA = exports.u_ = void 0;
var modal_1 = __webpack_require__(8394);
Object.defineProperty(exports, "u_", ({
    enumerable: true,
    get: function get() {
        return modal_1.Modal;
    }
}));
Object.defineProperty(exports, "ZA", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalOverlay;
    }
}));
Object.defineProperty(exports, "hz", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalContent;
    }
}));
Object.defineProperty(exports, "xB", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalHeader;
    }
}));
Object.defineProperty(exports, "mz", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalFooter;
    }
}));
Object.defineProperty(exports, "fe", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalBody;
    }
}));
Object.defineProperty(exports, "ol", ({
    enumerable: true,
    get: function get() {
        return modal_1.ModalCloseButton;
    }
}));


/***/ }),

/***/ 88434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var styles_1 = __importDefault(__webpack_require__(25986));
var SelectStyle = styles_1.default;
exports["default"] = SelectStyle;


/***/ }),

/***/ 5615:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    maxH: 280,
    maxW: 452,
    borderRadius: "md"
};
var SkuImageStyle = {
    baseStyle: baseStyle
};
exports["default"] = SkuImageStyle;


/***/ }),

/***/ 15197:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var SliderStyle = {
    baseStyle: {
        thumb: {
            backgroundColor: "primary.400"
        },
        filledTrack: {
            backgroundColor: "gray.400"
        }
    }
};
exports["default"] = SliderStyle;


/***/ }),

/***/ 72406:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.HStack = exports.VStack = exports.Stack = void 0;
var layout_1 = __webpack_require__(33559);
Object.defineProperty(exports, "Stack", ({
    enumerable: true,
    get: function get() {
        return layout_1.Stack;
    }
}));
Object.defineProperty(exports, "VStack", ({
    enumerable: true,
    get: function get() {
        return layout_1.VStack;
    }
}));
Object.defineProperty(exports, "HStack", ({
    enumerable: true,
    get: function get() {
        return layout_1.HStack;
    }
}));


/***/ }),

/***/ 44539:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var theme_tools_1 = __webpack_require__(60723);
var baseStyle = function(props) {
    return {
        track: {
            _checked: {
                bg: (0, theme_tools_1.mode)("".concat(props.colorScheme, ".400"), "".concat(props.colorScheme, ".200"))(props)
            }
        }
    };
};
var defaultProps = {
    colorScheme: "green"
};
var SwitchStyle = {
    baseStyle: baseStyle,
    defaultProps: defaultProps
};
exports["default"] = SwitchStyle;


/***/ }),

/***/ 68776:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var baseStyle = {
    th: {
        fontFamily: "body",
        fontWeight: "semibold",
        textTransform: "none",
        color: "gray.800"
    },
    td: {
        fontFamily: "body",
        fontWeight: "normal"
    }
};
var variantSimple = {
    th: {
        borderColor: "gray.800",
        backgroundColor: "lilac.100",
        borderBottomColor: "gray.300",
        _last: {
            borderLeftColor: "gray.200",
            borderLeftWidth: "1px",
            textAlign: "right"
        }
    },
    td: {
        borderBottomColor: "gray.300",
        _last: {
            borderLeftColor: "gray.200",
            borderLeftWidth: "1px",
            textAlign: "right"
        }
    }
};
var sizes = {
    sm: {
        th: {
            px: "4",
            py: "1",
            fontSize: "xs",
            height: "28px"
        },
        td: {
            px: "4",
            py: "1",
            fontSize: "xs",
            height: "28px"
        }
    },
    md: {
        th: {
            px: "4",
            py: "2",
            fontSize: "sm",
            height: "44px"
        },
        td: {
            px: "4",
            py: "2",
            fontSize: "sm",
            height: "48px"
        }
    },
    lg: {
        th: {
            px: "8",
            py: "4",
            fontSize: "md",
            height: "56px"
        },
        td: {
            px: "8",
            py: "4",
            fontSize: "md",
            height: "64px"
        }
    }
};
var TableStyle = {
    variants: {
        simple: variantSimple
    },
    sizes: sizes,
    baseStyle: baseStyle
};
exports["default"] = TableStyle;


/***/ }),

/***/ 5092:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var variantEnclosedColored = function(props) {
    var c = props.colorScheme;
    return {
        tab: {
            backgroundColor: "lilac.50",
            color: "gray.600",
            fontWeight: "600",
            borderColor: "lilac.50",
            borderTopRadius: "md",
            clipPath: "inset(-20px -20px 0px -20px)",
            _selected: {
                color: "blue.400",
                backgroundColor: "white",
                borderColor: "white",
                borderTopColor: "white",
                boxShadow: "4px 0px 20px rgba(68, 68, 68, 0.201295)",
                _focus: {
                    boxShadow: "4px 0px 20px rgba(68, 68, 68, 0.201295)",
                    backgroundColor: "".concat(c, ".400"),
                    color: "white",
                    borderColor: "".concat(c, ".400")
                }
            },
            _hover: {
                backgroundColor: "".concat(c, ".400"),
                color: "white",
                borderColor: "".concat(c, ".400")
            }
        }
    };
};
var variants = {
    "enclosed-colored": variantEnclosedColored
};
var defaultProps = {
    size: "md",
    variant: "enclosed-colored",
    colorScheme: "purple"
};
var TabsStyles = {
    variants: variants,
    defaultProps: defaultProps
};
exports["default"] = TabsStyles;


/***/ }),

/***/ 29072:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.createStandaloneToast = exports.useToast = void 0;
var toast_1 = __webpack_require__(95224);
Object.defineProperty(exports, "useToast", ({
    enumerable: true,
    get: function get() {
        return toast_1.useToast;
    }
}));
Object.defineProperty(exports, "createStandaloneToast", ({
    enumerable: true,
    get: function get() {
        return toast_1.createStandaloneToast;
    }
}));


/***/ }),

/***/ 52389:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var theme_tools_1 = __webpack_require__(60723);
var utils_1 = __webpack_require__(46141);
var $bg = (0, theme_tools_1.cssVar)("tooltip-bg");
var $color = (0, theme_tools_1.cssVar)("tooltip-color");
var $arrowBg = (0, theme_tools_1.cssVar)("popper-arrow-bg");
var baseStyle = function() {
    var bg = "purple.400";
    var color = "white";
    var _obj;
    return _obj = {}, _defineProperty(_obj, $bg.variable, "colors.".concat(bg)), _defineProperty(_obj, "px", "8px"), _defineProperty(_obj, "py", "2px"), _defineProperty(_obj, "bg", [
        $bg.reference
    ]), _defineProperty(_obj, $arrowBg.variable, [
        $bg.reference
    ]), _defineProperty(_obj, "color", color), _defineProperty(_obj, "borderRadius", "sm"), _defineProperty(_obj, "fontWeight", "medium"), _defineProperty(_obj, "fontSize", "sm"), _defineProperty(_obj, "boxShadow", "2xl"), _defineProperty(_obj, "maxW", "320px"), _defineProperty(_obj, "zIndex", "tooltip"), _obj;
};
var variantLight = function(props) {
    var _obj;
    return (0, utils_1.mergeWith)({}, props.theme.components.Tooltip.variants.light, (_obj = {}, _defineProperty(_obj, $bg.variable, "colors.lilac.50"), _defineProperty(_obj, $color.variable, "colors.purple.400"), _defineProperty(_obj, "bg", [
        $bg.reference
    ]), _defineProperty(_obj, "color", [
        $color.reference
    ]), _defineProperty(_obj, $arrowBg.variable, [
        $bg.reference
    ]), _defineProperty(_obj, "borderRadius", 4), _defineProperty(_obj, "p", 4), _defineProperty(_obj, "pointerEvents", "all"), _defineProperty(_obj, "position", "relative"), _obj));
};
var variantDark = function(props) {
    var _obj;
    return (0, utils_1.mergeWith)({}, props.theme.components.Tooltip.variants.dark, (_obj = {}, _defineProperty(_obj, $bg.variable, "colors.purple.400"), _defineProperty(_obj, "bg", [
        $bg.reference
    ]), _defineProperty(_obj, $arrowBg.variable, [
        $bg.reference
    ]), _defineProperty(_obj, "borderRadius", 4), _defineProperty(_obj, "p", 4), _defineProperty(_obj, "pointerEvents", "all"), _defineProperty(_obj, "position", "relative"), _obj));
};
var variants = {
    light: variantLight,
    dark: variantDark
};
var defaultProps = {
    variant: "dark"
};
var TooltipStyles = {
    baseStyle: baseStyle,
    variants: variants,
    defaultProps: defaultProps
};
exports["default"] = TooltipStyles;


/***/ }),

/***/ 43543:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var jsx_runtime_1 = __webpack_require__(85893);
var system_1 = __webpack_require__(26812);
var utils_1 = __webpack_require__(46141);
var VARIANT_MAPPING = {
    display1: "h1",
    display2: "h1",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "p",
    subtitle2: "p",
    subtitle3: "p",
    body1: "p",
    body2: "p",
    body3: "p",
    caption: "span"
};
var Typography = (0, system_1.forwardRef)(function(_a, ref) {
    var _variant = _a.variant, variant = _variant === void 0 ? "h2" : _variant, as = _a.as, props = __rest(_a, [
        "variant",
        "as"
    ]);
    var styles = (0, system_1.useStyleConfig)("Typography", {
        variant: variant
    });
    var component = as || VARIANT_MAPPING[variant];
    var _b = (0, system_1.omitThemingProps)(props), className = _b.className, align = _b.align, decoration = _b.decoration, casing = _b.casing, baseProps = __rest(_b, [
        "className",
        "align",
        "decoration",
        "casing"
    ]);
    var aliasedProps = (0, utils_1.filterUndefined)({
        textAlign: align,
        textDecoration: decoration,
        textTransform: casing
    });
    return (0, jsx_runtime_1.jsx)(system_1.chakra.p, Object.assign({
        as: component,
        ref: ref,
        className: (0, utils_1.cx)("chakra-typography", className),
        __css: styles
    }, aliasedProps, baseProps));
});
exports["default"] = Typography;


/***/ }),

/***/ 46918:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var TypographyStyle = {
    baseStyle: {
        fontWeight: "semibold",
        fontFamily: "heading"
    },
    variants: {
        display1: {
            fontSize: {
                base: "46px",
                lg: "62px"
            },
            lineHeight: {
                base: "56px",
                lg: "72px"
            }
        },
        display2: {
            fontSize: {
                base: "42px",
                lg: "52px"
            },
            lineHeight: {
                base: "42px",
                lg: "52px"
            }
        },
        h1: {
            fontSize: {
                base: "36px",
                lg: "42px"
            },
            lineHeight: {
                base: "44px",
                lg: "50px"
            }
        },
        h2: {
            fontSize: {
                base: "32px",
                lg: "36px"
            },
            lineHeight: {
                base: "40px",
                lg: "44px"
            }
        },
        h3: {
            fontSize: {
                base: "28px",
                lg: "32px"
            },
            lineHeight: {
                base: "36px",
                lg: "40px"
            }
        },
        h4: {
            fontSize: "24px",
            lineHeight: "32px"
        },
        h5: {
            fontSize: "22px",
            lineHeight: "30px"
        },
        h6: {
            fontSize: "20px",
            lineHeight: "28px"
        },
        subtitle1: {
            fontSize: "18px",
            lineHeight: "26px",
            fontFamily: "body"
        },
        subtitle2: {
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "body"
        },
        subtitle3: {
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "body"
        },
        body1: {
            fontSize: "18px",
            lineHeight: "26px",
            fontFamily: "body"
        },
        body2: {
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "body"
        },
        body3: {
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "body"
        },
        caption: {
            fontSize: "12px",
            lineHeight: "20px",
            fontFamily: "body"
        }
    },
    defaultProps: {
        variant: "h2"
    }
};
exports["default"] = TypographyStyle;


/***/ }),

/***/ 29306:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
__webpack_unused_export__ = ({
    value: true
});
var faArrowRight_1 = __webpack_require__(62488);
var faArrowRight_2 = __webpack_require__(25215);
var faArrowRight_3 = __webpack_require__(19824);
var createIcon_1 = __importDefault(__webpack_require__(75541));
var ArrowRightIcon = (0, createIcon_1.default)({
    displayName: "ArrowRightIcon",
    title: "Arrow right icon",
    icon: faArrowRight_1.faArrowRight,
    variantIcons: {
        light: faArrowRight_1.faArrowRight,
        regular: faArrowRight_2.faArrowRight,
        solid: faArrowRight_3.faArrowRight
    }
});
exports.Z = ArrowRightIcon;


/***/ }),

/***/ 24290:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
__webpack_unused_export__ = ({
    value: true
});
var faLockKeyhole_1 = __webpack_require__(69238);
var createIcon_1 = __importDefault(__webpack_require__(75541));
var LockKeyholeIcon = (0, createIcon_1.default)({
    displayName: "LockKeyhole",
    title: "Lock Keyhole icon",
    icon: faLockKeyhole_1.faLockKeyhole
});
exports.Z = LockKeyholeIcon;


/***/ }),

/***/ 75541:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __rest = (void 0) && (void 0).__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var jsx_runtime_1 = __webpack_require__(85893);
var icon_1 = __webpack_require__(21354);
var react_fontawesome_1 = __webpack_require__(67814);
function createIcon(param) {
    var displayName = param.displayName, icon = param.icon, variantIcons = param.variantIcons, defaultTitle = param.title;
    var FAIcon = function(_a) {
        var _title = _a.title, title = _title === void 0 ? defaultTitle : _title, variant = _a.variant, props = __rest(_a, [
            "title",
            "variant"
        ]);
        return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({
            icon: variant && (variantIcons === null || variantIcons === void 0 ? void 0 : variantIcons[variant]) || icon,
            title: title
        }, props));
    };
    FAIcon.displayName = displayName;
    var WrappedIcon = function(props) {
        return (0, jsx_runtime_1.jsx)(icon_1.Icon, Object.assign({
            as: FAIcon
        }, props));
    };
    WrappedIcon.displayName = displayName;
    return WrappedIcon;
}
exports["default"] = createIcon;


/***/ }),

/***/ 75117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = void 0;
var media_query_1 = __webpack_require__(40261);
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function get() {
        return media_query_1.useBreakpointValue;
    }
}));


/***/ }),

/***/ 47101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.mergeThemeOverride = exports.extendTheme = void 0;
var theme_1 = __webpack_require__(60);
var utils_1 = __webpack_require__(46141);
function extendTheme() {
    for(var _len = arguments.length, extensions = new Array(_len), _key = 0; _key < _len; _key++){
        extensions[_key] = arguments[_key];
    }
    var overrides = _toConsumableArray(extensions);
    var baseTheme = extensions[extensions.length - 1];
    if ((0, theme_1.isChakraTheme)(baseTheme) && overrides.length > 1) {
        overrides = overrides.slice(0, overrides.length - 1);
    } else {
        baseTheme = theme_1.theme;
    }
    return (0, utils_1.pipe).apply(this, _toConsumableArray(overrides.map(function(extension) {
        return function(prevTheme) {
            return (0, utils_1.isFunction)(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension);
        };
    })))(baseTheme);
}
exports.extendTheme = extendTheme;
function mergeThemeOverride() {
    for(var _len = arguments.length, overrides = new Array(_len), _key = 0; _key < _len; _key++){
        overrides[_key] = arguments[_key];
    }
    return (0, utils_1.mergeWith).apply(this, [
        {}
    ].concat(_toConsumableArray(overrides), [
        mergeThemeCustomizer
    ]));
}
exports.mergeThemeOverride = mergeThemeOverride;
function mergeThemeCustomizer(source, override, key, object) {
    if (((0, utils_1.isFunction)(source) || (0, utils_1.isFunction)(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sourceValue = (0, utils_1.isFunction)(source) ? source.apply(void 0, _toConsumableArray(args)) : source;
            var overrideValue = (0, utils_1.isFunction)(override) ? override.apply(void 0, _toConsumableArray(args)) : override;
            return (0, utils_1.mergeWith)({}, sourceValue, overrideValue, mergeThemeCustomizer);
        };
    }
    return undefined;
}


/***/ }),

/***/ 72486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var breakpoints = {
    base: "0px",
    "2xs": "320px",
    xs: "375px",
    sm: "425px",
    md: "786px",
    lg: "1024px",
    xl: "1440px",
    "2xl": "2560px"
};
exports["default"] = breakpoints;


/***/ }),

/***/ 85171:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var purple = {
    50: "#EDE6F0",
    100: "#DACEE2",
    200: "#916BA7",
    300: "#6D3A89",
    400: "#48096C",
    500: "#410861",
    600: "#32064C",
    700: "#2B0840"
};
var red = {
    50: "#FDE9E6",
    100: "#FABCB5",
    200: "#F4736B",
    300: "#F1453A",
    400: "#ED0B09",
    500: "#BE1807",
    600: "#900C20",
    700: "#480610"
};
var colors = {
    primary: red,
    secondary: purple,
    accent: {
        blue: "#88FDFF",
        pink: "#FFC5EE",
        yellow: "#F9FF4E"
    },
    notification: {
        blue: "#276EF1"
    },
    purple: purple,
    red: red,
    pink: {
        50: "#FFFBF8",
        100: "#FFF6F2",
        200: "#FFE9DE",
        300: "#FFE0D1",
        400: "#FFD2BD",
        500: "#FFB6AF",
        600: "#FF978C",
        700: "#CC7970"
    },
    lilac: {
        50: "#F6F7F9",
        100: "#F7F5FD",
        200: "#F3F1FF",
        300: "#EAE8FC",
        400: "#E5E2FB",
        500: "#CECBE2",
        600: "#B7B5C9",
        700: "#A09EB0"
    },
    blue: {
        50: "#EFF3FE",
        100: "#D4E2FC",
        200: "#A0BFF8",
        300: "#5B91F5",
        400: "#1A65F0",
        500: "#1E54B7",
        600: "#174291",
        700: "#102C60"
    },
    green: {
        50: "#E9F7F3",
        100: "#A8DFCF",
        200: "#7CCEB8",
        300: "#51BEA0",
        400: "#25AE88",
        500: "#1E8B6D",
        600: "#166852",
        700: "#0B3429"
    },
    yellow: {
        50: "#FFFAF0",
        100: "#FFF2D9",
        200: "#FFE3AC",
        300: "#FFCF70",
        400: "#FFC043",
        500: "#CC9A36",
        600: "#B3862F",
        700: "#806022"
    },
    orange: {
        50: "#FFF3EF",
        100: "#FFE1D6",
        200: "#FABDA5",
        300: "#FA9269",
        400: "#FF6937",
        500: "#CC492C",
        600: "#AE371C",
        700: "#7D2714"
    },
    gray: {
        50: "#F8F8F8",
        100: "#F0EDED",
        200: "#E0DEDE",
        300: "#C7C3C3",
        400: "#A0A0A0",
        500: "#787878",
        600: "#4B4B4B",
        700: "#302F2F",
        800: "#1E1E1E"
    }
};
exports["default"] = colors;


/***/ }),

/***/ 60096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var fonts = {
    heading: "sofia-pro, sans-serif",
    body: "sofia-pro, sans-serif"
};
exports["default"] = fonts;


/***/ }),

/***/ 34882:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var sizes = {
    container: {
        xs: "375px",
        sm: "780px",
        md: "1200px",
        lg: "1440px",
        xl: "1920px"
    }
};
exports.Z = sizes;


/***/ }),

/***/ 19818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (void 0) && (void 0).__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var breakpoints_1 = __importDefault(__webpack_require__(72486));
var colors_1 = __importDefault(__webpack_require__(85171));
var fonts_1 = __importDefault(__webpack_require__(60096));
var styles_1 = __importDefault(__webpack_require__(7689));
var styles_2 = __importDefault(__webpack_require__(11413));
var styles_3 = __importDefault(__webpack_require__(17326));
var styles_4 = __importDefault(__webpack_require__(45161));
var styles_5 = __importDefault(__webpack_require__(69221));
var styles_6 = __webpack_require__(51093);
var styles_7 = __importDefault(__webpack_require__(70598));
var styles_8 = __importDefault(__webpack_require__(13274));
var styles_9 = __importDefault(__webpack_require__(62228));
var styles_10 = __importDefault(__webpack_require__(9832));
var styles_11 = __importDefault(__webpack_require__(25986));
var styles_12 = __importDefault(__webpack_require__(71417));
var styles_13 = __importDefault(__webpack_require__(88434));
var styles_14 = __importDefault(__webpack_require__(5615));
var styles_15 = __importDefault(__webpack_require__(15197));
var styles_16 = __importDefault(__webpack_require__(44539));
var styles_17 = __importDefault(__webpack_require__(68776));
var styles_18 = __importDefault(__webpack_require__(5092));
var styles_19 = __importDefault(__webpack_require__(52389));
var styles_20 = __importDefault(__webpack_require__(46918));
var extend_theme_1 = __webpack_require__(47101);
var theme = (0, extend_theme_1.extendTheme)({
    colors: colors_1.default,
    fonts: fonts_1.default,
    breakpoints: breakpoints_1.default,
    components: {
        Alert: styles_1.default,
        Button: styles_2.default,
        Card: styles_3.default,
        Checkbox: styles_4.default,
        CloseButton: styles_5.default,
        Link: styles_12.default,
        SkuImage: styles_14.default,
        Switch: styles_16.default,
        Tabs: styles_18.default,
        Typography: styles_20.default,
        FormError: styles_6.FormError,
        Input: styles_11.default,
        Form: styles_6.Form,
        FormInputPhoneNumber: styles_8.default,
        FormInputSelect: styles_10.default,
        FormInputPassword: styles_7.default,
        FormInputPin: styles_9.default,
        Select: styles_13.default,
        Slider: styles_15.default,
        Table: styles_17.default,
        Tooltip: styles_19.default
    }
});
exports["default"] = theme;


/***/ }),

/***/ 36585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AGi": function() { return /* binding */ absolute; },
  "e4p": function() { return /* binding */ after; },
  "Kvj": function() { return /* binding */ alignContent; },
  "cq$": function() { return /* binding */ alignItems; },
  "uko": function() { return /* binding */ alignSelf; },
  "oQ4": function() { return /* binding */ animation; },
  "d73": function() { return /* binding */ auto; },
  "Oq0": function() { return /* binding */ background; },
  "Czw": function() { return /* binding */ backgroundColor; },
  "NxW": function() { return /* binding */ backgroundImage; },
  "k0m": function() { return /* binding */ backgroundPosition; },
  "FDc": function() { return /* binding */ backgroundRepeat; },
  "G4q": function() { return /* binding */ backgroundSize; },
  "bbn": function() { return /* binding */ before; },
  "CgR": function() { return /* binding */ border; },
  "h$9": function() { return /* binding */ borderBottom; },
  "vSo": function() { return /* binding */ borderBottomColor; },
  "AGO": function() { return /* binding */ borderBottomLeftRadius; },
  "rfy": function() { return /* binding */ borderBottomRightRadius; },
  "qtZ": function() { return /* binding */ borderBottomStyle; },
  "HMX": function() { return /* binding */ borderBottomWidth; },
  "tvt": function() { return /* binding */ borderColor; },
  "sc3": function() { return /* binding */ borderLeft; },
  "VvE": function() { return /* binding */ borderLeftColor; },
  "Pxd": function() { return /* binding */ borderLeftWidth; },
  "E0l": function() { return /* binding */ borderRadius; },
  "XY7": function() { return /* binding */ borderRightColor; },
  "UY5": function() { return /* binding */ borderRightWidth; },
  "$uf": function() { return /* binding */ borderStyle; },
  "SKu": function() { return /* binding */ borderTopColor; },
  "orU": function() { return /* binding */ borderTopLeftRadius; },
  "E$t": function() { return /* binding */ borderTopRightRadius; },
  "$Bc": function() { return /* binding */ borderTopStyle; },
  "fCW": function() { return /* binding */ borderTopWidth; },
  "J4J": function() { return /* binding */ borderWidth; },
  "IaC": function() { return /* binding */ bottom; },
  "Wnp": function() { return /* binding */ boxShadow; },
  "LZf": function() { return /* binding */ boxShadows; },
  "ixg": function() { return /* binding */ boxSizing; },
  "pIy": function() { return /* binding */ children; },
  "$_Y": function() { return /* binding */ color; },
  "$QP": function() { return /* binding */ column; },
  "e$I": function() { return /* binding */ columnGap; },
  "U5V": function() { return /* binding */ contentRule; },
  "v8j": function() { return /* binding */ cover; },
  "_s1": function() { return /* binding */ cubicBezier; },
  "ocY": function() { return /* binding */ cursor; },
  "OaU": function() { return /* binding */ deg; },
  "JUm": function() { return /* binding */ disabled; },
  "jfB": function() { return /* binding */ display; },
  "em": function() { return /* binding */ em; },
  "hXT": function() { return /* binding */ filter; },
  "mUE": function() { return /* binding */ firstChild; },
  "fUN": function() { return /* binding */ flex; },
  "L9u": function() { return /* binding */ flex3; },
  "P_T": function() { return /* binding */ flexBasis; },
  "Me8": function() { return /* binding */ flexDirection; },
  "H78": function() { return /* binding */ flexGrow; },
  "i4v": function() { return /* binding */ flexShrink; },
  "WOS": function() { return /* binding */ flexWrap; },
  "T_4": function() { return /* binding */ BsCssJs_bs_focus; },
  "u_l": function() { return /* binding */ focusWithin; },
  "VlP": function() { return /* binding */ fontFamilies; },
  "JBY": function() { return /* binding */ fontSize; },
  "p_N": function() { return /* binding */ fontStyle; },
  "Ue2": function() { return /* binding */ fontWeight; },
  "fr": function() { return /* binding */ fr; },
  "fD_": function() { return /* binding */ gridArea; },
  "t4e": function() { return /* binding */ gridColumn; },
  "W3B": function() { return /* binding */ gridColumnGap; },
  "ur1": function() { return /* binding */ gridColumnStart; },
  "Ccm": function() { return /* binding */ gridGap; },
  "zIs": function() { return /* binding */ gridTemplateAreas; },
  "K$K": function() { return /* binding */ gridTemplateColumns; },
  "RGf": function() { return /* binding */ gridTemplateRows; },
  "Cb8": function() { return /* binding */ height; },
  "$v1": function() { return /* binding */ hex; },
  "MrM": function() { return /* binding */ hover; },
  "efO": function() { return /* binding */ important; },
  "KlP": function() { return /* binding */ justifyContent; },
  "eYb": function() { return /* binding */ justifyItems; },
  "zoP": function() { return /* binding */ justifySelf; },
  "F4b": function() { return /* binding */ BsCssJs_bs_keyframes; },
  "QOo": function() { return /* binding */ lastChild; },
  "t$v": function() { return /* binding */ left; },
  "rXp": function() { return /* binding */ letterSpacing; },
  "R29": function() { return /* binding */ light; },
  "Nv8": function() { return /* binding */ lineHeight; },
  "jZR": function() { return /* binding */ listStyleType; },
  "e6$": function() { return /* binding */ margin; },
  "h9x": function() { return /* binding */ margin2; },
  "F86": function() { return /* binding */ margin3; },
  "yl7": function() { return /* binding */ marginBottom; },
  "oIA": function() { return /* binding */ marginLeft; },
  "wzR": function() { return /* binding */ marginRight; },
  "E9m": function() { return /* binding */ marginTop; },
  "kCL": function() { return /* binding */ maxHeight; },
  "kkr": function() { return /* binding */ maxWidth; },
  "BC2": function() { return /* binding */ media; },
  "TSy": function() { return /* binding */ BsCssJs_bs_merge; },
  "jw4": function() { return /* binding */ minHeight; },
  "ihZ": function() { return /* binding */ minWidth; },
  "YPD": function() { return /* binding */ none; },
  "vvq": function() { return /* binding */ nthChild; },
  "fXf": function() { return /* binding */ objectFit; },
  "YP6": function() { return /* binding */ objectPosition; },
  "Ohi": function() { return /* binding */ opacity; },
  "vmh": function() { return /* binding */ order; },
  "Kl7": function() { return /* binding */ outline; },
  "zuB": function() { return /* binding */ outlineStyle; },
  "bu0": function() { return /* binding */ outlineWidth; },
  "txR": function() { return /* binding */ overflow; },
  "pU1": function() { return /* binding */ overflowY; },
  "o3D": function() { return /* binding */ padding; },
  "BLt": function() { return /* binding */ padding2; },
  "OqZ": function() { return /* binding */ padding3; },
  "_fG": function() { return /* binding */ padding4; },
  "EtG": function() { return /* binding */ paddingBottom; },
  "rv2": function() { return /* binding */ paddingLeft; },
  "WLm": function() { return /* binding */ paddingRight; },
  "odA": function() { return /* binding */ paddingTop; },
  "hdZ": function() { return /* binding */ pct; },
  "W$B": function() { return /* binding */ placeholder; },
  "kkJ": function() { return /* binding */ pointerEvents; },
  "FKU": function() { return /* binding */ position; },
  "px": function() { return /* binding */ px; },
  "cYj": function() { return /* binding */ pxFloat; },
  "Gfm": function() { return /* binding */ relative; },
  "hOB": function() { return /* binding */ rem; },
  "B8C": function() { return /* binding */ rgb; },
  "m4f": function() { return /* binding */ rgba; },
  "F2z": function() { return /* binding */ right; },
  "U1s": function() { return /* binding */ rotate; },
  "O7B": function() { return /* binding */ row; },
  "s2f": function() { return /* binding */ rowGap; },
  "nZE": function() { return /* binding */ selector; },
  "aX$": function() { return /* binding */ semiBold; },
  "SQh": function() { return /* binding */ solid; },
  "dy0": function() { return /* binding */ stretch; },
  "oBv": function() { return /* binding */ style; },
  "ydu": function() { return /* binding */ textAlign; },
  "QXS": function() { return /* binding */ textDecoration; },
  "hrh": function() { return /* binding */ textDecorationColor; },
  "QxZ": function() { return /* binding */ textTransform; },
  "wey": function() { return /* binding */ BsCssJs_bs_top; },
  "vs": function() { return /* binding */ transform; },
  "p22": function() { return /* binding */ transformOrigin; },
  "Lol": function() { return /* binding */ transforms; },
  "eRy": function() { return /* binding */ transition; },
  "BFP": function() { return /* binding */ transitionDelay; },
  "nVE": function() { return /* binding */ transitionDuration; },
  "n_e": function() { return /* binding */ transitionProperty; },
  "BdG": function() { return /* binding */ transitionTimingFunction; },
  "pBE": function() { return /* binding */ transitions; },
  "Iue": function() { return /* binding */ translate; },
  "YPe": function() { return /* binding */ translateX; },
  "iWO": function() { return /* binding */ translateY; },
  "hR4": function() { return /* binding */ translateZ; },
  "eCr": function() { return /* binding */ underline; },
  "K47": function() { return /* binding */ unsafe; },
  "Loy": function() { return /* binding */ verticalAlign; },
  "vh": function() { return /* binding */ vh; },
  "WDY": function() { return /* binding */ visibility; },
  "vw": function() { return /* binding */ vw; },
  "d8w": function() { return /* binding */ whiteSpace; },
  "bf$": function() { return /* binding */ width; },
  "W5D": function() { return /* binding */ zIndex; },
  "bMI": function() { return /* binding */ zero; }
});

// UNUSED EXPORTS: $$default, $$double, $$float, $$global, $$static, $$super, $$var, Animation, Calc, Make, Nth, SVG, Shadow, Transition, Types, active, alias, aliceblue, all, allScroll, alternate, alternateReverse, animationDelay, animationDirection, animationDuration, animationFillMode, animationIterationCount, animationName, animationPlayState, animationTimingFunction, animationValue, animations, antiquewhite, anyLink, aqua, aquamarine, areas, azure, backdropFilter, backfaceVisibility, backgroundAttachment, backgroundClip, backgroundOrigin, backgroundPosition4, backgroundPositions, backgrounds, backwards, baseline, beige, bevel, bisque, black, blanchedalmond, block, blue, blueviolet, bold, bolder, borderBox, borderCollapse, borderLeftStyle, borderRadius4, borderRight, borderRightStyle, borderSpacing, borderTop, both, breakAll, breakWord, brown, burlywood, butt, cache, cadetblue, capitalize, caretColor, cell, center, ch, chartreuse, checked, child, chocolate, clear, clip, clipPath, cm, colResize, columnCount, columnReverse, columnWidth, conicGradient, contain, content, contentBox, contentRules, contents, contextMenu, copy, coral, cornflowerblue, cornsilk, count, counterIncrement, counterReset, counterSet, countersIncrement, countersReset, countersSet, crimson, crosshair, currentColor, cyan, darkblue, darkcyan, darkgoldenrod, darkgray, darkgreen, darkgrey, darkkhaki, darkmagenta, darkolivegreen, darkorange, darkorchid, darkred, darksalmon, darkseagreen, darkslateblue, darkslategray, darkslategrey, darkturquoise, darkviolet, dashed, deeppink, deepskyblue, default, defined, dimgray, dimgrey, directSibling, direction, dodgerblue, dotted, eResize, ease, easeIn, easeInOut, easeOut, ellipsis, empty, enabled, ewResize, ex, extraBold, extraLight, fill, fillBox, firebrick, first, firstLetter, firstLine, firstOfType, fitContent, fixed, flexBox, flexEnd, flexStart, floralwhite, focusVisible, fontFace, fontFamily, fontVariant, forestgreen, forwards, fuchsia, gainsboro, gap, gap2, ghostwhite, gold, goldenrod, grab, grabbing, grad, gray, green, greenyellow, grey, grid, gridArea2, gridArea3, gridArea4, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumnEnd, gridRow, gridRowEnd, gridRowGap, gridRowStart, help, hidden, honeydew, horizontal, host, hotpink, hsl, hsla, ident, inRange, indeterminate, indianred, indigo, infinite, inherit_, initial, inline, inlineBlock, inlineFlex, inlineGrid, inlineTable, insertRule, inside, invalid, isolate, isolation, italic, ivory, keepAll, khaki, label, lang, lastOfType, lavender, lavenderblush, lawngreen, lemonchiffon, lightblue, lightcoral, lightcyan, lighter, lightgoldenrodyellow, lightgray, lightgreen, lightgrey, lightpink, lightsalmon, lightseagreen, lightskyblue, lightslategray, lightslategrey, lightsteelblue, lightyellow, lime, limegreen, lineThrough, linear, linearGradient, linen, link, listItem, listStyle, listStyleImage, listStylePosition, local, localUrl, lowercase, ltr, magenta, manipulation, margin4, marginBox, maroon, maskImage, maskPosition, maskPositions, maxContent, medium, mediumaquamarine, mediumblue, mediumorchid, mediumpurple, mediumseagreen, mediumslateblue, mediumspringgreen, mediumturquoise, mediumvioletred, merge2, merge3, merge4, middle, midnightblue, minContent, minmax, mintcream, mistyrose, miter, mm, moccasin, move, nResize, navajowhite, navy, neResize, neswResize, noDrop, noRepeat, normal, notAllowed, not_, nowrap, nsResize, nthLastChild, nthLastOfType, nthOfType, numIdent, nwResize, nwseResize, oblique, oldlace, olive, olivedrab, onlyChild, onlyOfType, optional, orange, orangered, orchid, outOfRange, outlineColor, outlineOffset, outside, overflowAnchor, overflowWrap, overflowX, overline, overscrollBehavior, paddingBox, palegoldenrod, palegreen, paleturquoise, palevioletred, panDown, panLeft, panRight, panUp, panX, panY, papayawhip, paused, peachpuff, perspective, perspectiveOrigin, peru, pinchZoom, pink, plum, pointer, powderblue, progress, pt, purple, rad, radialGradient, readOnly, readWrite, rebeccapurple, red, renderGlobal, renderKeyframes, renderRule, repeat, repeatX, repeatY, repeatingLinearGradient, repeatingRadialGradient, required, resize, reverse, root, rosybrown, rotate3d, rotateX, rotateY, rotateZ, round, rowResize, rowReverse, royalblue, rtl, runIn, running, sResize, saddlebrown, salmon, sandybrown, scale, scale3d, scaleX, scaleY, scaleZ, scope, scroll, scrollBehavior, seResize, seagreen, seashell, selection, siblings, sienna, silver, size, skew, skewX, skewY, skyblue, slateblue, slategray, slategrey, smallCaps, snow, space, spaceAround, spaceBetween, spaceEvenly, springgreen, square, steelblue, stepEnd, stepStart, steps, sticky, strokeBox, sub, swResize, table, tableCaption, tableCell, tableColumn, tableColumnGroup, tableFooterGroup, tableHeaderGroup, tableLayout, tableRow, tableRowGroup, tan, target, teal, text, textBottom, textDecorationLine, textDecorationStyle, textIndent, textOverflow, textShadow, textShadows, textTop, thin, thistle, toJson, tomato, touchAction, transformOrigin3d, transformStyle, transitionList, transitionValue, translate3d, transparent, turn, turquoise, unset, uppercase, url, userSelect, valid, varDefault, vertical, verticalText, viewBox, violet, visible, visited, vmax, vmin, wResize, wait, wavy, wheat, white, whitesmoke, wordBreak, wordSpacing, wordWrap, wrap, wrapReverse, yellow, yellowgreen, zoomIn, zoomOut

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Colors.bs.js
var Css_Colors_bs = __webpack_require__(77274);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js + 1 modules
var emotion_css_create_instance_esm = __webpack_require__(32566);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/ribbonEmotion.js

var ref = (0,emotion_css_create_instance_esm/* default */.Z)({
    key: "rb"
});
// Basically, emotion does not play nicely with SSR if you have two 'instances' of it, which we do (one here, and one in codebase for the main site).
// This is the work around - essentially, creating our own 'instance' of the Emotion bindings, with their own cache (the cache is the important bit).
var flush = ref.flush, hydrate = ref.hydrate, cx = ref.cx, merge = ref.merge, getRegisteredStyles = ref.getRegisteredStyles, injectGlobal = ref.injectGlobal, keyframes = ref.keyframes, css = ref.css, sheet = ref.sheet, cache = ref.cache;

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var injectRaw = injectGlobal;
function renderRaw(param, css) {
    injectRaw(css);
}
var injectRawRules = injectGlobal;
function injectRules(selector, rules) {
    injectRawRules(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
function renderRules(param, selector, rules) {
    injectRawRules(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
var mergeStyles = cx;
var make = css;
var makeAnimation = keyframes;
function makeKeyframes(frames) {
    return makeAnimation(frames);
}
function renderKeyframes(param, frames) {
    return makeAnimation(frames);
}
var include = Css_Js_Core_bs/* Make */.t0D({
    injectRaw: injectRaw,
    renderRaw: renderRaw,
    injectRules: injectRules,
    renderRules: renderRules,
    make: make,
    mergeStyles: mergeStyles,
    makeKeyframes: makeKeyframes,
    renderKeyframes: renderKeyframes
});
var insertRule = include.insertRule;
var BsCssJs_bs_cache = cache;
function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
    insertRule(Css_Js_Core.fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, undefined));
    return fontFamily;
}
var Types = Css_Js_Core_bs/* Types */.Yky;
var Make = Css_Js_Core_bs/* Make */.t0D;
var toJson = Css_Js_Core_bs/* toJson */.QsJ;
var important = Css_Js_Core_bs/* important */.efO;
var label = Css_Js_Core_bs/* label */.PS9;
var Shadow = Css_Js_Core_bs/* Shadow */.jXB;
var unsafe = Css_Js_Core_bs/* unsafe */.K47;
var alignContent = Css_Js_Core_bs/* alignContent */.Kvj;
var alignItems = Css_Js_Core_bs/* alignItems */.cq$;
var alignSelf = Css_Js_Core_bs/* alignSelf */.uko;
var animationDelay = Css_Js_Core_bs/* animationDelay */.lEu;
var animationDirection = Css_Js_Core_bs/* animationDirection */.ZRe;
var animationDuration = Css_Js_Core_bs/* animationDuration */.wyN;
var animationFillMode = Css_Js_Core_bs/* animationFillMode */.$mx;
var animationIterationCount = Css_Js_Core_bs/* animationIterationCount */.EcY;
var animationPlayState = Css_Js_Core_bs/* animationPlayState */.dZD;
var animationTimingFunction = Css_Js_Core_bs/* animationTimingFunction */.KUN;
var backdropFilter = Css_Js_Core_bs/* backdropFilter */.nLE;
var backfaceVisibility = Css_Js_Core_bs/* backfaceVisibility */.uhB;
var backgroundAttachment = Css_Js_Core_bs/* backgroundAttachment */.Yep;
var backgroundColor = Css_Js_Core_bs/* backgroundColor */.Czw;
var backgroundClip = Css_Js_Core_bs/* backgroundClip */._cl;
var backgroundImage = Css_Js_Core_bs/* backgroundImage */.NxW;
var maskImage = Css_Js_Core_bs/* maskImage */.zT3;
var backgroundOrigin = Css_Js_Core_bs/* backgroundOrigin */.ezj;
var backgroundPosition = Css_Js_Core_bs/* backgroundPosition */.k0m;
var backgroundPositions = Css_Js_Core_bs/* backgroundPositions */.bCW;
var backgroundPosition4 = Css_Js_Core_bs/* backgroundPosition4 */.Sgw;
var maskPosition = Css_Js_Core_bs/* maskPosition */.tac;
var maskPositions = Css_Js_Core_bs/* maskPositions */.otN;
var backgroundRepeat = Css_Js_Core_bs/* backgroundRepeat */.FDc;
var borderBottom = Css_Js_Core_bs/* borderBottom */.h$9;
var borderBottomColor = Css_Js_Core_bs/* borderBottomColor */.vSo;
var borderBottomLeftRadius = Css_Js_Core_bs/* borderBottomLeftRadius */.AGO;
var borderBottomRightRadius = Css_Js_Core_bs/* borderBottomRightRadius */.rfy;
var borderBottomStyle = Css_Js_Core_bs/* borderBottomStyle */.qtZ;
var borderBottomWidth = Css_Js_Core_bs/* borderBottomWidth */.HMX;
var borderCollapse = Css_Js_Core_bs/* borderCollapse */.obx;
var borderColor = Css_Js_Core_bs/* borderColor */.tvt;
var borderLeft = Css_Js_Core_bs/* borderLeft */.sc3;
var borderLeftColor = Css_Js_Core_bs/* borderLeftColor */.VvE;
var borderLeftStyle = Css_Js_Core_bs/* borderLeftStyle */.njC;
var borderLeftWidth = Css_Js_Core_bs/* borderLeftWidth */.Pxd;
var borderRight = Css_Js_Core_bs/* borderRight */.vQA;
var borderRightColor = Css_Js_Core_bs/* borderRightColor */.XY7;
var borderRightStyle = Css_Js_Core_bs/* borderRightStyle */.SVd;
var borderRightWidth = Css_Js_Core_bs/* borderRightWidth */.UY5;
var borderRadius = Css_Js_Core_bs/* borderRadius */.E0l;
var borderRadius4 = Css_Js_Core_bs/* borderRadius4 */.L5e;
var borderSpacing = Css_Js_Core_bs/* borderSpacing */.hJp;
var borderStyle = Css_Js_Core_bs/* borderStyle */.$uf;
var borderTopColor = Css_Js_Core_bs/* borderTopColor */.SKu;
var borderTopLeftRadius = Css_Js_Core_bs/* borderTopLeftRadius */.orU;
var borderTopRightRadius = Css_Js_Core_bs/* borderTopRightRadius */.E$t;
var borderTopStyle = Css_Js_Core_bs/* borderTopStyle */.$Bc;
var borderTopWidth = Css_Js_Core_bs/* borderTopWidth */.fCW;
var borderWidth = Css_Js_Core_bs/* borderWidth */.J4J;
var bottom = Css_Js_Core_bs/* bottom */.IaC;
var boxSizing = Css_Js_Core_bs/* boxSizing */.ixg;
var boxShadow = Css_Js_Core_bs/* boxShadow */.Wnp;
var boxShadows = Css_Js_Core_bs/* boxShadows */.LZf;
var clear = Css_Js_Core_bs/* clear */.ZHw;
var clipPath = Css_Js_Core_bs/* clipPath */.o6J;
var color = Css_Js_Core_bs/* color */.$_Y;
var columnCount = Css_Js_Core_bs/* columnCount */.J49;
var contentRule = Css_Js_Core_bs/* contentRule */.U5V;
var contentRules = Css_Js_Core_bs/* contentRules */.jK5;
var counterIncrement = Css_Js_Core_bs/* counterIncrement */.ga_;
var countersIncrement = Css_Js_Core_bs/* countersIncrement */.$Co;
var counterReset = Css_Js_Core_bs/* counterReset */.K03;
var countersReset = Css_Js_Core_bs/* countersReset */.Yi5;
var counterSet = Css_Js_Core_bs/* counterSet */.nKF;
var countersSet = Css_Js_Core_bs/* countersSet */.Eqy;
var cursor = Css_Js_Core_bs/* cursor */.ocY;
var direction = Css_Js_Core_bs/* direction */.o7V;
var display = Css_Js_Core_bs/* display */.jfB;
var flex = Css_Js_Core_bs/* flex */.fUN;
var flexBasis = Css_Js_Core_bs/* flexBasis */.P_T;
var flexDirection = Css_Js_Core_bs/* flexDirection */.Me8;
var flexGrow = Css_Js_Core_bs/* flexGrow */.H78;
var flexShrink = Css_Js_Core_bs/* flexShrink */.i4v;
var flexWrap = Css_Js_Core_bs/* flexWrap */.WOS;
var $$float = Css_Js_Core_bs/* $$float */.uwu;
var fontFamily = Css_Js_Core_bs/* fontFamily */.I85;
var fontFamilies = Css_Js_Core_bs/* fontFamilies */.VlP;
var fontSize = Css_Js_Core_bs/* fontSize */.JBY;
var fontStyle = Css_Js_Core_bs/* fontStyle */.p_N;
var fontVariant = Css_Js_Core_bs/* fontVariant */.xvA;
var fontWeight = Css_Js_Core_bs/* fontWeight */.Ue2;
var gridArea = Css_Js_Core_bs/* gridArea */.fD_;
var gridArea2 = Css_Js_Core_bs/* gridArea2 */.Vy2;
var gridArea3 = Css_Js_Core_bs/* gridArea3 */.V8q;
var gridArea4 = Css_Js_Core_bs/* gridArea4 */.PUt;
var gridAutoFlow = Css_Js_Core_bs/* gridAutoFlow */.BaW;
var gridColumn = Css_Js_Core_bs/* gridColumn */.t4e;
var gridColumnEnd = Css_Js_Core_bs/* gridColumnEnd */.cod;
var columnGap = Css_Js_Core_bs/* columnGap */.e$I;
var scrollBehavior = Css_Js_Core_bs/* scrollBehavior */.sCq;
var overscrollBehavior = Css_Js_Core_bs/* overscrollBehavior */.jSQ;
var overflowAnchor = Css_Js_Core_bs/* overflowAnchor */.PhB;
var columnWidth = Css_Js_Core_bs/* columnWidth */.G4A;
var caretColor = Css_Js_Core_bs/* caretColor */.OYb;
var gridColumnGap = Css_Js_Core_bs/* gridColumnGap */.W3B;
var gridColumnStart = Css_Js_Core_bs/* gridColumnStart */.ur1;
var gap = Css_Js_Core_bs/* gap */.SGp;
var gap2 = Css_Js_Core_bs/* gap2 */.rjz;
var gridGap = Css_Js_Core_bs/* gridGap */.Ccm;
var gridRow = Css_Js_Core_bs/* gridRow */.oIx;
var gridRowEnd = Css_Js_Core_bs/* gridRowEnd */.Zys;
var gridRowGap = Css_Js_Core_bs/* gridRowGap */.UbJ;
var rowGap = Css_Js_Core_bs/* rowGap */.s2f;
var gridRowStart = Css_Js_Core_bs/* gridRowStart */.lpz;
var gridTemplateAreas = Css_Js_Core_bs/* gridTemplateAreas */.zIs;
var height = Css_Js_Core_bs/* height */.Cb8;
var justifyContent = Css_Js_Core_bs/* justifyContent */.KlP;
var justifyItems = Css_Js_Core_bs/* justifyItems */.eYb;
var justifySelf = Css_Js_Core_bs/* justifySelf */.zoP;
var left = Css_Js_Core_bs/* left */.t$v;
var letterSpacing = Css_Js_Core_bs/* letterSpacing */.rXp;
var lineHeight = Css_Js_Core_bs/* lineHeight */.Nv8;
var listStyle = Css_Js_Core_bs/* listStyle */.VXB;
var listStyleImage = Css_Js_Core_bs/* listStyleImage */.yOV;
var listStyleType = Css_Js_Core_bs/* listStyleType */.jZR;
var listStylePosition = Css_Js_Core_bs/* listStylePosition */.xPo;
var margin = Css_Js_Core_bs/* margin */.e6$;
var margin2 = Css_Js_Core_bs/* margin2 */.h9x;
var margin3 = Css_Js_Core_bs/* margin3 */.F86;
var margin4 = Css_Js_Core_bs/* margin4 */.X0Y;
var marginLeft = Css_Js_Core_bs/* marginLeft */.oIA;
var marginRight = Css_Js_Core_bs/* marginRight */.wzR;
var marginTop = Css_Js_Core_bs/* marginTop */.E9m;
var marginBottom = Css_Js_Core_bs/* marginBottom */.yl7;
var maxHeight = Css_Js_Core_bs/* maxHeight */.kCL;
var maxWidth = Css_Js_Core_bs/* maxWidth */.kkr;
var minHeight = Css_Js_Core_bs/* minHeight */.jw4;
var minWidth = Css_Js_Core_bs/* minWidth */.ihZ;
var objectFit = Css_Js_Core_bs/* objectFit */.fXf;
var objectPosition = Css_Js_Core_bs/* objectPosition */.YP6;
var opacity = Css_Js_Core_bs/* opacity */.Ohi;
var order = Css_Js_Core_bs/* order */.vmh;
var outline = Css_Js_Core_bs/* outline */.Kl7;
var outlineColor = Css_Js_Core_bs/* outlineColor */.dxT;
var outlineOffset = Css_Js_Core_bs/* outlineOffset */.KL2;
var outlineStyle = Css_Js_Core_bs/* outlineStyle */.zuB;
var outlineWidth = Css_Js_Core_bs/* outlineWidth */.bu0;
var overflow = Css_Js_Core_bs/* overflow */.txR;
var overflowX = Css_Js_Core_bs/* overflowX */.zzh;
var overflowY = Css_Js_Core_bs/* overflowY */.pU1;
var overflowWrap = Css_Js_Core_bs/* overflowWrap */.LIb;
var padding = Css_Js_Core_bs/* padding */.o3D;
var padding2 = Css_Js_Core_bs/* padding2 */.BLt;
var padding3 = Css_Js_Core_bs/* padding3 */.OqZ;
var padding4 = Css_Js_Core_bs/* padding4 */._fG;
var paddingLeft = Css_Js_Core_bs/* paddingLeft */.rv2;
var paddingRight = Css_Js_Core_bs/* paddingRight */.WLm;
var paddingTop = Css_Js_Core_bs/* paddingTop */.odA;
var paddingBottom = Css_Js_Core_bs/* paddingBottom */.EtG;
var perspective = Css_Js_Core_bs/* perspective */.G30;
var perspectiveOrigin = Css_Js_Core_bs/* perspectiveOrigin */.gr0;
var pointerEvents = Css_Js_Core_bs/* pointerEvents */.kkJ;
var position = Css_Js_Core_bs/* position */.FKU;
var isolation = Css_Js_Core_bs/* isolation */.BD_;
var resize = Css_Js_Core_bs/* resize */.SIr;
var right = Css_Js_Core_bs/* right */.F2z;
var tableLayout = Css_Js_Core_bs/* tableLayout */.GJu;
var textAlign = Css_Js_Core_bs/* textAlign */.ydu;
var textDecorationColor = Css_Js_Core_bs/* textDecorationColor */.hrh;
var textDecorationLine = Css_Js_Core_bs/* textDecorationLine */.A8G;
var textDecorationStyle = Css_Js_Core_bs/* textDecorationStyle */.vo$;
var textIndent = Css_Js_Core_bs/* textIndent */.h52;
var textOverflow = Css_Js_Core_bs/* textOverflow */._Xt;
var textShadow = Css_Js_Core_bs/* textShadow */.XCE;
var textShadows = Css_Js_Core_bs/* textShadows */.sg9;
var textTransform = Css_Js_Core_bs/* textTransform */.QxZ;
var BsCssJs_bs_top = Css_Js_Core_bs/* top */.wey;
var transform = Css_Js_Core_bs/* transform */.vs;
var transforms = Css_Js_Core_bs/* transforms */.Lol;
var transformOrigin = Css_Js_Core_bs/* transformOrigin */.p22;
var transformOrigin3d = Css_Js_Core_bs/* transformOrigin3d */.TRc;
var transitionDelay = Css_Js_Core_bs/* transitionDelay */.BFP;
var transitionDuration = Css_Js_Core_bs/* transitionDuration */.nVE;
var transitionProperty = Css_Js_Core_bs/* transitionProperty */.n_e;
var transformStyle = Css_Js_Core_bs/* transformStyle */.V1P;
var transitionTimingFunction = Css_Js_Core_bs/* transitionTimingFunction */.BdG;
var userSelect = Css_Js_Core_bs/* userSelect */.sih;
var verticalAlign = Css_Js_Core_bs/* verticalAlign */.Loy;
var visibility = Css_Js_Core_bs/* visibility */.WDY;
var width = Css_Js_Core_bs/* width */.bf$;
var whiteSpace = Css_Js_Core_bs/* whiteSpace */.d8w;
var wordBreak = Css_Js_Core_bs/* wordBreak */.lM7;
var wordSpacing = Css_Js_Core_bs/* wordSpacing */.qJL;
var wordWrap = Css_Js_Core_bs/* wordWrap */.BWb;
var zIndex = Css_Js_Core_bs/* zIndex */.W5D;
var selector = Css_Js_Core_bs/* selector */.nZE;
var media = Css_Js_Core_bs/* media */.BC2;
var active = Css_Js_Core_bs/* active */.bBs;
var checked = Css_Js_Core_bs/* checked */.ec_;
var $$default = Css_Js_Core_bs/* $$default */.rHv;
var defined = Css_Js_Core_bs/* defined */.rif;
var disabled = Css_Js_Core_bs/* disabled */.JUm;
var empty = Css_Js_Core_bs/* empty */.cSb;
var enabled = Css_Js_Core_bs/* enabled */.amh;
var first = Css_Js_Core_bs/* first */.PsQ;
var firstChild = Css_Js_Core_bs/* firstChild */.mUE;
var firstOfType = Css_Js_Core_bs/* firstOfType */.$Sh;
var BsCssJs_bs_focus = Css_Js_Core_bs/* focus */.T_4;
var focusVisible = Css_Js_Core_bs/* focusVisible */.bPo;
var focusWithin = Css_Js_Core_bs/* focusWithin */.u_l;
var host = Css_Js_Core_bs/* host */.ho7;
var hover = Css_Js_Core_bs/* hover */.MrM;
var indeterminate = Css_Js_Core_bs/* indeterminate */.Nxf;
var inRange = Css_Js_Core_bs/* inRange */.Z2v;
var invalid = Css_Js_Core_bs/* invalid */.I1x;
var lang = Css_Js_Core_bs/* lang */.KQv;
var lastChild = Css_Js_Core_bs/* lastChild */.QOo;
var lastOfType = Css_Js_Core_bs/* lastOfType */.xBE;
var BsCssJs_bs_link = Css_Js_Core_bs/* link */.p4m;
var not_ = Css_Js_Core_bs/* not_ */.YdO;
var Nth = Css_Js_Core_bs/* Nth */.eNo;
var nthChild = Css_Js_Core_bs/* nthChild */.vvq;
var nthLastChild = Css_Js_Core_bs/* nthLastChild */.NXf;
var nthLastOfType = Css_Js_Core_bs/* nthLastOfType */.tPj;
var nthOfType = Css_Js_Core_bs/* nthOfType */.NOF;
var onlyChild = Css_Js_Core_bs/* onlyChild */.Z9P;
var onlyOfType = Css_Js_Core_bs/* onlyOfType */.zEV;
var optional = Css_Js_Core_bs/* optional */.jtO;
var outOfRange = Css_Js_Core_bs/* outOfRange */.ihe;
var readOnly = Css_Js_Core_bs/* readOnly */.qtd;
var readWrite = Css_Js_Core_bs/* readWrite */.H6;
var required = Css_Js_Core_bs/* required */.C1W;
var root = Css_Js_Core_bs/* root */.Jz2;
var scope = Css_Js_Core_bs/* scope */.eIe;
var target = Css_Js_Core_bs/* target */.fA7;
var valid = Css_Js_Core_bs/* valid */.QF4;
var visited = Css_Js_Core_bs/* visited */.Fv;
var after = Css_Js_Core_bs/* after */.e4p;
var before = Css_Js_Core_bs/* before */.bbn;
var firstLetter = Css_Js_Core_bs/* firstLetter */.i16;
var firstLine = Css_Js_Core_bs/* firstLine */.wxz;
var placeholder = Css_Js_Core_bs/* placeholder */.W$B;
var selection = Css_Js_Core_bs/* selection */.DuZ;
var child = Css_Js_Core_bs/* child */.iUc;
var children = Css_Js_Core_bs/* children */.pIy;
var directSibling = Css_Js_Core_bs/* directSibling */.cOP;
var siblings = Css_Js_Core_bs/* siblings */.dxy;
var anyLink = Css_Js_Core_bs/* anyLink */.ub3;
var initial = Css_Js_Core_bs/* initial */.nnL;
var inherit_ = Css_Js_Core_bs/* inherit_ */.atG;
var unset = Css_Js_Core_bs/* unset */.zNf;
var $$var = Css_Js_Core_bs/* $$var */.epG;
var varDefault = Css_Js_Core_bs/* varDefault */.Djg;
var auto = Css_Js_Core_bs/* auto */.d73;
var none = Css_Js_Core_bs/* none */.YPD;
var BsCssJs_bs_text = Css_Js_Core_bs/* text */.fLW;
var pct = Css_Js_Core_bs/* pct */.hdZ;
var ch = Css_Js_Core_bs.ch;
var cm = Css_Js_Core_bs.cm;
var em = Css_Js_Core_bs.em;
var ex = Css_Js_Core_bs.ex;
var mm = Css_Js_Core_bs.mm;
var pt = Css_Js_Core_bs.pt;
var px = Css_Js_Core_bs.px;
var pxFloat = Css_Js_Core_bs/* pxFloat */.cYj;
var rem = Css_Js_Core_bs/* rem */.hOB;
var vh = Css_Js_Core_bs.vh;
var vmin = Css_Js_Core_bs/* vmin */.v03;
var vmax = Css_Js_Core_bs/* vmax */.s8c;
var zero = Css_Js_Core_bs/* zero */.bMI;
var deg = Css_Js_Core_bs/* deg */.OaU;
var rad = Css_Js_Core_bs/* rad */.BJ1;
var grad = Css_Js_Core_bs/* grad */.UQy;
var turn = Css_Js_Core_bs/* turn */.E2y;
var ltr = Css_Js_Core_bs/* ltr */.m6$;
var rtl = Css_Js_Core_bs/* rtl */.bd4;
var absolute = Css_Js_Core_bs/* absolute */.AGi;
var relative = Css_Js_Core_bs/* relative */.Gfm;
var $$static = Css_Js_Core_bs/* $$static */.Yum;
var fixed = Css_Js_Core_bs/* fixed */.Bdr;
var sticky = Css_Js_Core_bs/* sticky */.CAZ;
var isolate = Css_Js_Core_bs/* isolate */.KMK;
var horizontal = Css_Js_Core_bs/* horizontal */.SlK;
var vertical = Css_Js_Core_bs/* vertical */.KRj;
var smallCaps = Css_Js_Core_bs/* smallCaps */.jc2;
var italic = Css_Js_Core_bs/* italic */.pUw;
var oblique = Css_Js_Core_bs/* oblique */.$6v;
var BsCssJs_bs_hidden = Css_Js_Core_bs/* hidden */.alX;
var visible = Css_Js_Core_bs/* visible */.oPT;
var BsCssJs_bs_scroll = Css_Js_Core_bs/* scroll */.ARY;
var rgb = Css_Js_Core_bs/* rgb */.B8C;
var rgba = Css_Js_Core_bs/* rgba */.m4f;
var hsl = Css_Js_Core_bs/* hsl */.Ym7;
var hsla = Css_Js_Core_bs/* hsla */.Jnk;
var hex = Css_Js_Core_bs/* hex */.$v1;
var currentColor = Css_Js_Core_bs/* currentColor */.wyo;
var local = Css_Js_Core_bs/* local */.I_Q;
var paddingBox = Css_Js_Core_bs/* paddingBox */.tD0;
var borderBox = Css_Js_Core_bs/* borderBox */.iu7;
var contentBox = Css_Js_Core_bs/* contentBox */.fLi;
var noRepeat = Css_Js_Core_bs/* noRepeat */.DHQ;
var space = Css_Js_Core_bs/* space */.DhX;
var repeat = Css_Js_Core_bs/* repeat */.rx1;
var minmax = Css_Js_Core_bs/* minmax */.WFv;
var repeatX = Css_Js_Core_bs/* repeatX */.pMI;
var repeatY = Css_Js_Core_bs/* repeatY */.yEL;
var contain = Css_Js_Core_bs/* contain */.XSY;
var cover = Css_Js_Core_bs/* cover */.v8j;
var row = Css_Js_Core_bs/* row */.O7B;
var rowReverse = Css_Js_Core_bs/* rowReverse */.poq;
var column = Css_Js_Core_bs/* column */.$QP;
var columnReverse = Css_Js_Core_bs/* columnReverse */.Xsx;
var wrap = Css_Js_Core_bs/* wrap */.reQ;
var nowrap = Css_Js_Core_bs/* nowrap */.P8R;
var wrapReverse = Css_Js_Core_bs/* wrapReverse */.g7Q;
var inline = Css_Js_Core_bs/* inline */.QoB;
var block = Css_Js_Core_bs/* block */.Gew;
var contents = Css_Js_Core_bs/* contents */.IQZ;
var flexBox = Css_Js_Core_bs/* flexBox */.tPW;
var grid = Css_Js_Core_bs/* grid */.eCg;
var inlineBlock = Css_Js_Core_bs/* inlineBlock */.vdF;
var inlineFlex = Css_Js_Core_bs/* inlineFlex */.z8w;
var inlineGrid = Css_Js_Core_bs/* inlineGrid */.tgT;
var inlineTable = Css_Js_Core_bs/* inlineTable */.ZHG;
var listItem = Css_Js_Core_bs/* listItem */.qbe;
var runIn = Css_Js_Core_bs/* runIn */.Jbp;
var table = Css_Js_Core_bs/* table */.Kzj;
var tableCaption = Css_Js_Core_bs/* tableCaption */.Ppf;
var tableColumnGroup = Css_Js_Core_bs/* tableColumnGroup */.yLU;
var tableHeaderGroup = Css_Js_Core_bs/* tableHeaderGroup */.a5O;
var tableFooterGroup = Css_Js_Core_bs/* tableFooterGroup */.ANm;
var tableRowGroup = Css_Js_Core_bs/* tableRowGroup */.NY0;
var tableCell = Css_Js_Core_bs/* tableCell */.K5p;
var tableColumn = Css_Js_Core_bs/* tableColumn */.ibC;
var tableRow = Css_Js_Core_bs/* tableRow */.RLZ;
var flexStart = Css_Js_Core_bs/* flexStart */.c4c;
var flexEnd = Css_Js_Core_bs/* flexEnd */.QdD;
var center = Css_Js_Core_bs/* center */.beQ;
var stretch = Css_Js_Core_bs/* stretch */.dy0;
var spaceBetween = Css_Js_Core_bs/* spaceBetween */.fHD;
var spaceAround = Css_Js_Core_bs/* spaceAround */.hHJ;
var spaceEvenly = Css_Js_Core_bs/* spaceEvenly */.isX;
var baseline = Css_Js_Core_bs/* baseline */.j96;
var forwards = Css_Js_Core_bs/* forwards */.Gho;
var backwards = Css_Js_Core_bs/* backwards */.aWF;
var both = Css_Js_Core_bs/* both */.HkC;
var infinite = Css_Js_Core_bs/* infinite */.oXI;
var count = Css_Js_Core_bs/* count */.QXW;
var paused = Css_Js_Core_bs/* paused */.K9x;
var running = Css_Js_Core_bs/* running */.wCv;
var inside = Css_Js_Core_bs/* inside */.Odq;
var outside = Css_Js_Core_bs/* outside */.SX6;
var solid = Css_Js_Core_bs/* solid */.SQh;
var dotted = Css_Js_Core_bs/* dotted */.ftw;
var dashed = Css_Js_Core_bs/* dashed */.HA;
var underline = Css_Js_Core_bs/* underline */.eCr;
var overline = Css_Js_Core_bs/* overline */.I95;
var lineThrough = Css_Js_Core_bs/* lineThrough */.jLD;
var clip = Css_Js_Core_bs/* clip */.oqW;
var ellipsis = Css_Js_Core_bs/* ellipsis */.LHJ;
var wavy = Css_Js_Core_bs/* wavy */.Pp4;
var $$double = Css_Js_Core_bs/* $$double */.ceD;
var uppercase = Css_Js_Core_bs/* uppercase */.PqQ;
var lowercase = Css_Js_Core_bs/* lowercase */.wXG;
var capitalize = Css_Js_Core_bs/* capitalize */.kC2;
var sub = Css_Js_Core_bs/* sub */.luU;
var $$super = Css_Js_Core_bs/* $$super */.dkg;
var textTop = Css_Js_Core_bs/* textTop */.L8u;
var textBottom = Css_Js_Core_bs/* textBottom */.eRF;
var middle = Css_Js_Core_bs/* middle */.XNj;
var normal = Css_Js_Core_bs/* normal */.mJl;
var breakAll = Css_Js_Core_bs/* breakAll */.k$v;
var keepAll = Css_Js_Core_bs/* keepAll */.mvd;
var breakWord = Css_Js_Core_bs/* breakWord */.kZi;
var reverse = Css_Js_Core_bs/* reverse */.GYS;
var alternate = Css_Js_Core_bs/* alternate */.J6G;
var alternateReverse = Css_Js_Core_bs/* alternateReverse */.XOq;
var fill = Css_Js_Core_bs/* fill */.hlL;
var content = Css_Js_Core_bs/* content */.kQN;
var maxContent = Css_Js_Core_bs/* maxContent */.FHD;
var minContent = Css_Js_Core_bs/* minContent */.fxJ;
var fitContent = Css_Js_Core_bs/* fitContent */.E0j;
var BsCssJs_bs_all = Css_Js_Core_bs/* all */.$6P;
var round = Css_Js_Core_bs/* round */.NMM;
var miter = Css_Js_Core_bs/* miter */.mwL;
var bevel = Css_Js_Core_bs/* bevel */.aHA;
var butt = Css_Js_Core_bs/* butt */.giC;
var square = Css_Js_Core_bs/* square */.h62;
var panX = Css_Js_Core_bs/* panX */.i36;
var panY = Css_Js_Core_bs/* panY */.$hU;
var panLeft = Css_Js_Core_bs/* panLeft */.xZz;
var panRight = Css_Js_Core_bs/* panRight */.UY0;
var panUp = Css_Js_Core_bs/* panUp */.LAG;
var panDown = Css_Js_Core_bs/* panDown */.VF7;
var pinchZoom = Css_Js_Core_bs/* pinchZoom */.ybA;
var manipulation = Css_Js_Core_bs/* manipulation */.WP2;
var thin = Css_Js_Core_bs/* thin */.vPS;
var extraLight = Css_Js_Core_bs/* extraLight */.ncr;
var light = Css_Js_Core_bs/* light */.R29;
var medium = Css_Js_Core_bs/* medium */.IV2;
var semiBold = Css_Js_Core_bs/* semiBold */.aX$;
var bold = Css_Js_Core_bs/* bold */.SeW;
var extraBold = Css_Js_Core_bs/* extraBold */.TE9;
var lighter = Css_Js_Core_bs/* lighter */.f6n;
var bolder = Css_Js_Core_bs/* bolder */.fT5;
var fr = Css_Js_Core_bs.fr;
var vw = Css_Js_Core_bs.vw;
var localUrl = Css_Js_Core_bs/* localUrl */.hGO;
var url = Css_Js_Core_bs/* url */.HQ2;
var linear = Css_Js_Core_bs/* linear */.GEo;
var ease = Css_Js_Core_bs/* ease */.mvv;
var easeIn = Css_Js_Core_bs/* easeIn */.YQY;
var easeOut = Css_Js_Core_bs/* easeOut */.VvG;
var easeInOut = Css_Js_Core_bs/* easeInOut */.mZN;
var stepStart = Css_Js_Core_bs/* stepStart */.UrL;
var stepEnd = Css_Js_Core_bs/* stepEnd */.gB9;
var steps = Css_Js_Core_bs/* steps */.S6;
var cubicBezier = Css_Js_Core_bs/* cubicBezier */._s1;
var marginBox = Css_Js_Core_bs/* marginBox */.m8E;
var fillBox = Css_Js_Core_bs/* fillBox */.Bbi;
var strokeBox = Css_Js_Core_bs/* strokeBox */.BKm;
var viewBox = Css_Js_Core_bs/* viewBox */.exU;
var translate = Css_Js_Core_bs/* translate */.Iue;
var translate3d = Css_Js_Core_bs/* translate3d */.z2Y;
var translateX = Css_Js_Core_bs/* translateX */.YPe;
var translateY = Css_Js_Core_bs/* translateY */.iWO;
var translateZ = Css_Js_Core_bs/* translateZ */.hR4;
var scale = Css_Js_Core_bs/* scale */.bAd;
var scale3d = Css_Js_Core_bs/* scale3d */.C74;
var scaleX = Css_Js_Core_bs/* scaleX */.eZH;
var scaleY = Css_Js_Core_bs/* scaleY */.$zm;
var scaleZ = Css_Js_Core_bs/* scaleZ */.p3g;
var rotate = Css_Js_Core_bs/* rotate */.U1s;
var rotate3d = Css_Js_Core_bs/* rotate3d */.er3;
var rotateX = Css_Js_Core_bs/* rotateX */.lMS;
var rotateY = Css_Js_Core_bs/* rotateY */.uDD;
var rotateZ = Css_Js_Core_bs/* rotateZ */.jIM;
var skew = Css_Js_Core_bs/* skew */.Tm5;
var skewX = Css_Js_Core_bs/* skewX */.QkJ;
var skewY = Css_Js_Core_bs/* skewY */.FoG;
var linearGradient = Css_Js_Core_bs/* linearGradient */.bCQ;
var repeatingLinearGradient = Css_Js_Core_bs/* repeatingLinearGradient */.k_P;
var radialGradient = Css_Js_Core_bs/* radialGradient */.zso;
var repeatingRadialGradient = Css_Js_Core_bs/* repeatingRadialGradient */.Cak;
var conicGradient = Css_Js_Core_bs/* conicGradient */.LC$;
var areas = Css_Js_Core_bs/* areas */.aku;
var ident = Css_Js_Core_bs/* ident */.yRn;
var numIdent = Css_Js_Core_bs/* numIdent */.p$S;
var contextMenu = Css_Js_Core_bs/* contextMenu */.zCX;
var help = Css_Js_Core_bs/* help */.R_2;
var pointer = Css_Js_Core_bs/* pointer */.cx$;
var progress = Css_Js_Core_bs/* progress */.YD2;
var wait = Css_Js_Core_bs/* wait */.Dc1;
var cell = Css_Js_Core_bs/* cell */.o4w;
var crosshair = Css_Js_Core_bs/* crosshair */.uGs;
var verticalText = Css_Js_Core_bs/* verticalText */.eEk;
var alias = Css_Js_Core_bs/* alias */.bme;
var copy = Css_Js_Core_bs/* copy */.JGK;
var move = Css_Js_Core_bs/* move */.pBW;
var noDrop = Css_Js_Core_bs/* noDrop */.Kgc;
var notAllowed = Css_Js_Core_bs/* notAllowed */.jsT;
var grab = Css_Js_Core_bs/* grab */.x2h;
var grabbing = Css_Js_Core_bs/* grabbing */.$xc;
var allScroll = Css_Js_Core_bs/* allScroll */.fFX;
var colResize = Css_Js_Core_bs/* colResize */.QiF;
var rowResize = Css_Js_Core_bs/* rowResize */.oJs;
var nResize = Css_Js_Core_bs/* nResize */.na1;
var eResize = Css_Js_Core_bs/* eResize */.az5;
var sResize = Css_Js_Core_bs/* sResize */.voX;
var wResize = Css_Js_Core_bs/* wResize */.CvW;
var neResize = Css_Js_Core_bs/* neResize */.f7d;
var nwResize = Css_Js_Core_bs/* nwResize */.zZK;
var seResize = Css_Js_Core_bs/* seResize */._Ef;
var swResize = Css_Js_Core_bs/* swResize */.FoQ;
var ewResize = Css_Js_Core_bs/* ewResize */.eUF;
var nsResize = Css_Js_Core_bs/* nsResize */.Wct;
var neswResize = Css_Js_Core_bs/* neswResize */.IQh;
var nwseResize = Css_Js_Core_bs/* nwseResize */.xW;
var zoomIn = Css_Js_Core_bs/* zoomIn */.krI;
var zoomOut = Css_Js_Core_bs/* zoomOut */.vGG;
var flex3 = Css_Js_Core_bs/* flex3 */.L9u;
var border = Css_Js_Core_bs/* border */.CgR;
var borderTop = Css_Js_Core_bs/* borderTop */.j1L;
var backgroundSize = Css_Js_Core_bs/* backgroundSize */.G4q;
var textDecoration = Css_Js_Core_bs/* textDecoration */.QXS;
var background = Css_Js_Core_bs/* background */.Oq0;
var backgrounds = Css_Js_Core_bs/* backgrounds */.Fud;
var gridAutoColumns = Css_Js_Core_bs/* gridAutoColumns */.aNt;
var gridAutoRows = Css_Js_Core_bs/* gridAutoRows */.FWK;
var gridTemplateColumns = Css_Js_Core_bs/* gridTemplateColumns */.K$K;
var gridTemplateRows = Css_Js_Core_bs/* gridTemplateRows */.RGf;
var Calc = Css_Js_Core_bs/* Calc */.zyf;
var size = Css_Js_Core_bs/* size */.dpJ;
var filter = Css_Js_Core_bs/* filter */.hXT;
var Transition = Css_Js_Core_bs/* Transition */.uTP;
var transitionValue = Css_Js_Core_bs/* transitionValue */.O3F;
var transitionList = Css_Js_Core_bs/* transitionList */.RgW;
var transition = Css_Js_Core_bs/* transition */.eRy;
var transitions = Css_Js_Core_bs/* transitions */.pBE;
var Animation = Css_Js_Core_bs/* Animation */.fwF;
var animationValue = Css_Js_Core_bs/* animationValue */.FLd;
var animation = Css_Js_Core_bs/* animation */.oQ4;
var animations = Css_Js_Core_bs/* animations */.sFT;
var animationName = Css_Js_Core_bs/* animationName */.w30;
var SVG = Css_Js_Core_bs/* SVG */.Wj1;
var touchAction = Css_Js_Core_bs/* touchAction */.JQf;
var aliceblue = Css_Colors_bs/* aliceblue */.$T;
var antiquewhite = Css_Colors_bs/* antiquewhite */.gu;
var aqua = Css_Colors_bs/* aqua */.tb;
var aquamarine = Css_Colors_bs/* aquamarine */.Cn;
var azure = Css_Colors_bs/* azure */.Yd;
var beige = Css_Colors_bs/* beige */.e9;
var bisque = Css_Colors_bs/* bisque */.kh;
var black = Css_Colors_bs/* black */.Sn;
var blanchedalmond = Css_Colors_bs/* blanchedalmond */.Kx;
var blue = Css_Colors_bs/* blue */.iN;
var blueviolet = Css_Colors_bs/* blueviolet */.me;
var brown = Css_Colors_bs/* brown */.P_;
var burlywood = Css_Colors_bs/* burlywood */.I6;
var cadetblue = Css_Colors_bs/* cadetblue */.nN;
var chartreuse = Css_Colors_bs/* chartreuse */.mH;
var chocolate = Css_Colors_bs/* chocolate */.JU;
var coral = Css_Colors_bs/* coral */.ou;
var cornflowerblue = Css_Colors_bs/* cornflowerblue */.yi;
var cornsilk = Css_Colors_bs/* cornsilk */.$s;
var crimson = Css_Colors_bs/* crimson */.Wl;
var cyan = Css_Colors_bs/* cyan */.sl;
var darkblue = Css_Colors_bs/* darkblue */.dR;
var darkcyan = Css_Colors_bs/* darkcyan */.eb;
var darkgoldenrod = Css_Colors_bs/* darkgoldenrod */.zO;
var darkgray = Css_Colors_bs/* darkgray */.eo;
var darkgreen = Css_Colors_bs/* darkgreen */.L9;
var darkgrey = Css_Colors_bs/* darkgrey */.PA;
var darkkhaki = Css_Colors_bs/* darkkhaki */.yu;
var darkmagenta = Css_Colors_bs/* darkmagenta */.dS;
var darkolivegreen = Css_Colors_bs/* darkolivegreen */.ez;
var darkorange = Css_Colors_bs/* darkorange */.Rd;
var darkorchid = Css_Colors_bs/* darkorchid */.nh;
var darkred = Css_Colors_bs/* darkred */.Ec;
var darksalmon = Css_Colors_bs/* darksalmon */.xC;
var darkseagreen = Css_Colors_bs/* darkseagreen */.G4;
var darkslateblue = Css_Colors_bs/* darkslateblue */.GO;
var darkslategray = Css_Colors_bs/* darkslategray */.cz;
var darkslategrey = Css_Colors_bs/* darkslategrey */.KD;
var darkturquoise = Css_Colors_bs/* darkturquoise */.Tj;
var darkviolet = Css_Colors_bs/* darkviolet */.UP;
var deeppink = Css_Colors_bs/* deeppink */.FG;
var deepskyblue = Css_Colors_bs/* deepskyblue */.fK;
var dimgray = Css_Colors_bs/* dimgray */.OQ;
var dimgrey = Css_Colors_bs/* dimgrey */.yS;
var dodgerblue = Css_Colors_bs/* dodgerblue */.H9;
var firebrick = Css_Colors_bs/* firebrick */.IU;
var floralwhite = Css_Colors_bs/* floralwhite */.s9;
var forestgreen = Css_Colors_bs/* forestgreen */.ob;
var fuchsia = Css_Colors_bs/* fuchsia */.zf;
var gainsboro = Css_Colors_bs/* gainsboro */.c7;
var ghostwhite = Css_Colors_bs/* ghostwhite */.my;
var gold = Css_Colors_bs/* gold */.EV;
var goldenrod = Css_Colors_bs/* goldenrod */.Al;
var gray = Css_Colors_bs/* gray */.MA;
var green = Css_Colors_bs/* green */.ek;
var greenyellow = Css_Colors_bs/* greenyellow */.ff;
var grey = Css_Colors_bs/* grey */.BA;
var honeydew = Css_Colors_bs/* honeydew */.Ax;
var hotpink = Css_Colors_bs/* hotpink */.ng;
var indianred = Css_Colors_bs/* indianred */.IP;
var indigo = Css_Colors_bs/* indigo */.QN;
var ivory = Css_Colors_bs/* ivory */.h$;
var khaki = Css_Colors_bs/* khaki */.IK;
var lavender = Css_Colors_bs/* lavender */.N0;
var lavenderblush = Css_Colors_bs/* lavenderblush */.jR;
var lawngreen = Css_Colors_bs/* lawngreen */.ev;
var lemonchiffon = Css_Colors_bs/* lemonchiffon */.Kf;
var lightblue = Css_Colors_bs/* lightblue */.XW;
var lightcoral = Css_Colors_bs/* lightcoral */.qv;
var lightcyan = Css_Colors_bs/* lightcyan */.tO;
var lightgoldenrodyellow = Css_Colors_bs/* lightgoldenrodyellow */.dw;
var lightgray = Css_Colors_bs/* lightgray */.UQ;
var lightgreen = Css_Colors_bs/* lightgreen */.Hj;
var lightgrey = Css_Colors_bs/* lightgrey */.hC;
var lightpink = Css_Colors_bs/* lightpink */.ci;
var lightsalmon = Css_Colors_bs/* lightsalmon */.lY;
var lightseagreen = Css_Colors_bs/* lightseagreen */.mf;
var lightskyblue = Css_Colors_bs/* lightskyblue */.up;
var lightslategray = Css_Colors_bs/* lightslategray */.GV;
var lightslategrey = Css_Colors_bs/* lightslategrey */.As;
var lightsteelblue = Css_Colors_bs/* lightsteelblue */.z1;
var lightyellow = Css_Colors_bs/* lightyellow */.s$;
var lime = Css_Colors_bs/* lime */.LR;
var limegreen = Css_Colors_bs/* limegreen */.bV;
var linen = Css_Colors_bs/* linen */.nu;
var magenta = Css_Colors_bs/* magenta */.Ce;
var maroon = Css_Colors_bs/* maroon */.dm;
var mediumaquamarine = Css_Colors_bs/* mediumaquamarine */.vN;
var mediumblue = Css_Colors_bs/* mediumblue */.Bg;
var mediumorchid = Css_Colors_bs/* mediumorchid */.AV;
var mediumpurple = Css_Colors_bs/* mediumpurple */.og;
var mediumseagreen = Css_Colors_bs/* mediumseagreen */.YL;
var mediumslateblue = Css_Colors_bs/* mediumslateblue */.sf;
var mediumspringgreen = Css_Colors_bs/* mediumspringgreen */.Vl;
var mediumturquoise = Css_Colors_bs/* mediumturquoise */.Su;
var mediumvioletred = Css_Colors_bs/* mediumvioletred */.zR;
var midnightblue = Css_Colors_bs/* midnightblue */.rD;
var mintcream = Css_Colors_bs/* mintcream */.Rh;
var mistyrose = Css_Colors_bs/* mistyrose */.RT;
var moccasin = Css_Colors_bs/* moccasin */.Xw;
var navajowhite = Css_Colors_bs/* navajowhite */.Ii;
var navy = Css_Colors_bs/* navy */.Ih;
var oldlace = Css_Colors_bs/* oldlace */.WV;
var olive = Css_Colors_bs/* olive */.qZ;
var olivedrab = Css_Colors_bs/* olivedrab */.EQ;
var orange = Css_Colors_bs/* orange */.$y;
var orangered = Css_Colors_bs/* orangered */.ve;
var orchid = Css_Colors_bs/* orchid */.XV;
var palegoldenrod = Css_Colors_bs/* palegoldenrod */.mL;
var palegreen = Css_Colors_bs/* palegreen */.Jm;
var paleturquoise = Css_Colors_bs/* paleturquoise */.UM;
var palevioletred = Css_Colors_bs/* palevioletred */.ZP;
var papayawhip = Css_Colors_bs/* papayawhip */.tt;
var peachpuff = Css_Colors_bs/* peachpuff */.Kz;
var peru = Css_Colors_bs/* peru */.zh;
var pink = Css_Colors_bs/* pink */.iQ;
var plum = Css_Colors_bs/* plum */.vd;
var powderblue = Css_Colors_bs/* powderblue */.Fe;
var purple = Css_Colors_bs/* purple */.jk;
var rebeccapurple = Css_Colors_bs/* rebeccapurple */.My;
var red = Css_Colors_bs/* red */.Q6;
var rosybrown = Css_Colors_bs/* rosybrown */.wO;
var royalblue = Css_Colors_bs/* royalblue */.WI;
var saddlebrown = Css_Colors_bs/* saddlebrown */.sN;
var salmon = Css_Colors_bs/* salmon */.kr;
var sandybrown = Css_Colors_bs/* sandybrown */.qb;
var seagreen = Css_Colors_bs/* seagreen */.hR;
var seashell = Css_Colors_bs/* seashell */.qP;
var sienna = Css_Colors_bs/* sienna */.UR;
var silver = Css_Colors_bs/* silver */.l_;
var skyblue = Css_Colors_bs/* skyblue */.OD;
var slateblue = Css_Colors_bs/* slateblue */.Xb;
var slategray = Css_Colors_bs/* slategray */.aL;
var slategrey = Css_Colors_bs/* slategrey */.P2;
var snow = Css_Colors_bs/* snow */.Xr;
var springgreen = Css_Colors_bs/* springgreen */.oe;
var steelblue = Css_Colors_bs/* steelblue */.YP;
var tan = Css_Colors_bs/* tan */.OR;
var teal = Css_Colors_bs/* teal */.$C;
var thistle = Css_Colors_bs/* thistle */.X0;
var tomato = Css_Colors_bs/* tomato */.$p;
var turquoise = Css_Colors_bs/* turquoise */.Mk;
var violet = Css_Colors_bs/* violet */.ht;
var wheat = Css_Colors_bs/* wheat */.tm;
var white = Css_Colors_bs/* white */.ix;
var whitesmoke = Css_Colors_bs/* whitesmoke */.OW;
var yellow = Css_Colors_bs/* yellow */.er;
var yellowgreen = Css_Colors_bs/* yellowgreen */.TY;
var transparent = Css_Colors_bs/* transparent */.Zn;
var renderRule = include.renderRule;
var $$global = include.$$global;
var renderGlobal = include.renderGlobal;
var style = include.style;
var BsCssJs_bs_merge = include.merge;
var merge2 = include.merge2;
var merge3 = include.merge3;
var merge4 = include.merge4;
var BsCssJs_bs_keyframes = include.keyframes;
var renderKeyframes$1 = include.renderKeyframes;
 /* include Not a pure module */ 


/***/ }),

/***/ 17847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pU": function() { return /* binding */ Media$1; },
  "QD": function() { return /* binding */ Fresnel_bs_mediaStyles; }
});

// UNUSED EXPORTS: MediaContextProvider

// EXTERNAL MODULE: ./node_modules/@artsy/fresnel/dist/index.js
var dist = __webpack_require__(2082);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Fresnel/Media.js


var AppMedia = (0,dist/* createMedia */.Wm)({
    breakpoints: {
        rbMobile: 0,
        rbTablet: Theme_Responsive_bs/* mobileBreakpoint */.Il,
        rbSmallScreen: Theme_Responsive_bs/* smallScreenBreakpoint */.j9,
        rbDesktop: Theme_Responsive_bs/* tabletBreakpoint */.ub,
        rbLargeDesktop: Theme_Responsive_bs/* largeScreenBreakpoint */.Rf //1288px
    }
});
// Make styles for injection into the header of the page
var mediaStyles = AppMedia.createMediaStyle();
var Media = AppMedia.Media, MediaContextProvider = AppMedia.MediaContextProvider;

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Fresnel/Fresnel.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var Fresnel_bs_mediaStyles = mediaStyles;
var make = Media;
var Media$1 = {
    make: make
};
var make$1 = MediaContextProvider;
var Fresnel_bs_MediaContextProvider = {
    make: make$1
};
 /* mediaStyles Not a pure module */ 


/***/ }),

/***/ 36499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_0__);
// Generated by ReScript, PLEASE EDIT WITH CARE

function useMediaQuery(s) {
    return react_responsive__WEBPACK_IMPORTED_MODULE_0__.useMediaQuery({
        query: s
    });
}
 /* react-responsive Not a pure module */ 


/***/ }),

/***/ 56473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "z0": function() { return /* binding */ Styles; }
/* harmony export */ });
/* unused harmony exports SocialIcon, Link, LinkList, Column, Heading, Copyright, Responsive */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72721);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28522);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32567);
/* harmony import */ var _Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42465);
// Generated by ReScript, PLEASE EDIT WITH CARE







function footerBlock(theme) {
    var match = theme.components;
    var footer = match.footer;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .TSy([
        _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .Styles.style5 */ .z.style5,
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .backgroundColor */ .Czw(footer.backgroundColor),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_Y(footer.color),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .desktop */ .gv, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(22)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(13))
            ]),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .tablet */ .Mq, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(36)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(36))
            ]),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .mobile */ .ai, [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingBottom */ .EtG(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16))
            ])
        ])
    ]);
}
var footerGrid = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("grid"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 5
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ])
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .tablet */ .Mq, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "minmax",
                VAL: [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(200),
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            },
            {
                NAME: "minmax",
                VAL: [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(200),
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            },
            {
                NAME: "minmax",
                VAL: [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(200),
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            },
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
        ])
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_6__/* .mobile */ .ai, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .gridTemplateColumns */ .K$K([
            {
                NAME: "repeat",
                VAL: [
                    {
                        NAME: "num",
                        VAL: 1
                    },
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.fr(1)
                ]
            }
        ])
    ])
]);
var Styles = {
    footerBlock: footerBlock,
    footerGrid: footerGrid
};
function Footer(props) {
    var outerClassName = props.outerClassName;
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var outerClassName$1 = outerClassName !== undefined ? outerClassName : "";
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("footer", {
            children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                children: props.children,
                className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
                    footerGrid,
                    className$1
                ])
            }),
            className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
                footerBlock(theme),
                outerClassName$1
            ])
        })
    });
}
var SocialIcon;
var Link;
var LinkList;
var Column;
var Heading;
var Copyright;
var Responsive;
var make = Footer;
 /* footerGrid Not a pure module */ 


/***/ }),

/***/ 50574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
/* harmony import */ var _Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42465);
// Generated by ReScript, PLEASE EDIT WITH CARE




function column(colWidth) {
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletOrDesktop */ .ab, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .unsafe */ .K47("gridColumn", "span " + String(colWidth))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .mobile */ .ai, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .gridColumnStart */ .ur1(1)
        ])
    ]);
}
var Styles = {
    column: column
};
function Footer__Column(props) {
    var className = props.className;
    var colWidth = props.colWidth;
    var colWidth$1 = colWidth !== undefined ? colWidth : 1;
    var className$1 = className !== undefined ? className : "";
    var col = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .merge */ .TSy([
        column(colWidth$1),
        className$1
    ]);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: props.children,
            className: col
        })
    });
}
var make = Footer__Column;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 57787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
/* harmony import */ var _Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42465);
// Generated by ReScript, PLEASE EDIT WITH CARE




var copyright = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .gridColumn */ .t4e(1, -1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textAlign */ .ydu("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(12)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(20)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .desktop */ .gv, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(50))
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .tabletOrMobile */ .k$, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(30))
    ])
]);
var Styles = {
    copyright: copyright
};
function Footer__Copyright(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: props.children,
            className: copyright
        })
    });
}
var make = Footer__Copyright;
 /* copyright Not a pure module */ 


/***/ }),

/***/ 92426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28522);
/* harmony import */ var _Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42465);
// Generated by ReScript, PLEASE EDIT WITH CARE





function columnHeading(theme) {
    var match = theme.components;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(18)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hOB(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginBottom */ .yl7(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(19)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(match.footer.headingColor),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .desktop */ .gv, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(19))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .tablet */ .Mq, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(24))
        ]),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .media */ .BC2(_Footer_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .mobile */ .ai, [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(30))
        ])
    ]);
}
var Styles = {
    columnHeading: columnHeading
};
function Footer__Heading(props) {
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: props.children,
            className: columnHeading(theme)
        })
    });
}
var make = Footer__Heading;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 24798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
/* harmony import */ var _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28522);
/* harmony import */ var _theme_Theme_Animation_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78029);
/* harmony import */ var _Footer_SocialIcon_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70966);
// Generated by ReScript, PLEASE EDIT WITH CARE






function styling(theme) {
    var match = theme.components;
    var footer = match.footer;
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("span, a", [
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionDuration */ .nVE(_theme_Theme_Animation_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .fast */ .q3),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionTimingFunction */ .BdG("easeInOut"),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionProperty */ .n_e("all"),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textDecoration */ .QXS(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .underline */ .eCr),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textDecorationColor */ .hrh("transparent"),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("." + _Footer_SocialIcon_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Styles.socialIcon */ .z.socialIcon(theme), [
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionDuration */ .nVE(_theme_Theme_Animation_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .fast */ .q3),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionTimingFunction */ .BdG("easeInOut"),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .transitionProperty */ .n_e("all")
            ]),
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .hover */ .MrM([
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(footer.hoverColor),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .textDecorationColor */ .hrh(footer.hoverColor),
                _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .selector */ .nZE("." + _Footer_SocialIcon_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Styles.socialIcon */ .z.socialIcon(theme), [
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .backgroundColor */ .Czw(footer.iconHoverBackgroundColor)),
                    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .important */ .efO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_Y(footer.iconHoverColor))
                ])
            ])
        ])
    ]);
}
var Styles_white70 = {
    NAME: "hex",
    VAL: "FFFFFFB2"
};
var Styles = {
    white70: Styles_white70,
    styling: styling
};
function Footer__Link(props) {
    var theme = _context_ThemeContext_ThemeContext_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg(undefined);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("li", {
            children: props.children,
            className: styling(theme)
        })
    });
}
var make = Footer__Link;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 48778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
// Generated by ReScript, PLEASE EDIT WITH CARE



var listStyling = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .listStyleType */ .jZR("none"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .padding */ .o3D(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(15)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.em(2)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue2("normal")
]);
var Styles = {
    listStyling: listStyling
};
function Footer__LinkList(props) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_personal_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("ul", {
            children: props.children,
            className: listStyling
        })
    });
}
var make = Footer__LinkList;
 /* listStyling Not a pure module */ 


/***/ }),

/***/ 42465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mq": function() { return /* binding */ tablet; },
/* harmony export */   "ab": function() { return /* binding */ tabletOrDesktop; },
/* harmony export */   "ai": function() { return /* binding */ mobile; },
/* harmony export */   "gv": function() { return /* binding */ desktop; },
/* harmony export */   "k$": function() { return /* binding */ tabletOrMobile; }
/* harmony export */ });
/* unused harmony exports mobileBreakpoint, tabletBreakpoint */
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE

var mobile = _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .mediaMax */ .w4(720);
var tabletOrDesktop = _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .mediaMin */ .A3(720);
var tablet = _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .mediaRange */ .ae(720, 1261);
var desktop = _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .mediaMin */ .A3(1261);
var tabletOrMobile = _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .mediaMax */ .w4(1261);
var mobileBreakpoint = 720;
var tabletBreakpoint = 1261;
 /* mobile Not a pure module */ 


/***/ }),

/***/ 70966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Footer_SocialIcon_bs_Styles; },
  "S": function() { return /* binding */ Footer_SocialIcon_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/CircleIcon/CircleIcon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var circle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs/* rem */.hOB(100)),
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("center"),
    BsCssJs_bs/* alignItems */.cq$("center"),
    BsCssJs_bs/* boxSizing */.ixg("borderBox")
]);
var circleSm = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* width */.bf$(BsCssJs_bs.px(24)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(24))
]);
var circleMd = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* width */.bf$(BsCssJs_bs/* rem */.hOB(2.5)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(2.5)),
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs/* rem */.hOB(0.5)),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs/* rem */.hOB(1)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* rem */.hOB(3.5)),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* rem */.hOB(3.5)),
        BsCssJs_bs/* padding */.o3D(BsCssJs_bs/* rem */.hOB(0.25)),
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs/* rem */.hOB(1.75))
    ]),
    BsCssJs_bs/* selector */.nZE("*", [
        BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* maxHeight */.kCL(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* width */.bf$("auto"),
        BsCssJs_bs/* height */.Cb8("auto")
    ])
]);
var Styles = {
    circle: circle,
    circleSm: circleSm,
    circleMd: circleMd
};
function CircleIcon(props) {
    var size = props.size;
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var size$1 = size !== undefined ? size : /* Small */ 0;
    var circleClass = size$1 ? circleMd : circleSm;
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: classnames_default()([
            circle,
            circleClass,
            className$1
        ])
    });
}
var make = CircleIcon;
 /* circle Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__SocialIcon.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function socialIcon(theme) {
    var match = theme.components;
    var footer = match.footer;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(footer.iconColor),
        BsCssJs_bs/* backgroundColor */.Czw(footer.iconBackgroundColor),
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(12)),
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* display */.jfB("inlineFlex")),
        BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.px(6))
    ]);
}
var Footer_SocialIcon_bs_Styles = {
    socialIcon: socialIcon
};
function Footer__SocialIcon(props) {
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    return jsx_runtime.jsx(make, {
        children: props.children,
        className: socialIcon(theme)
    });
}
var Footer_SocialIcon_bs_make = Footer__SocialIcon;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 38715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(backgroundColorOpt, headingColorOpt, colorOpt, hoverColorOpt, iconBackgroundColorOpt, iconHoverBackgroundColorOpt, iconColorOpt, iconHoverColorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lilac50 */ .wD;
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP;
    var color = colorOpt !== undefined ? colorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA;
    var hoverColor = hoverColorOpt !== undefined ? hoverColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA;
    var iconBackgroundColor = iconBackgroundColorOpt !== undefined ? iconBackgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .purple400 */ .F0;
    var iconHoverBackgroundColor = iconHoverBackgroundColorOpt !== undefined ? iconHoverBackgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .purple400 */ .F0;
    var iconColor = iconColorOpt !== undefined ? iconColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix;
    var iconHoverColor = iconHoverColorOpt !== undefined ? iconHoverColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix;
    return {
        backgroundColor: backgroundColor,
        headingColor: headingColor,
        color: color,
        hoverColor: hoverColor,
        iconBackgroundColor: iconBackgroundColor,
        iconHoverBackgroundColor: iconHoverBackgroundColor,
        iconColor: iconColor,
        iconHoverColor: iconHoverColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 18178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
function t(paginationColourOpt, activePaginationColourOpt, param) {
    var paginationColour = paginationColourOpt !== undefined ? paginationColourOpt : {
        NAME: "hex",
        VAL: "C7C3C3"
    };
    var activePaginationColour = activePaginationColourOpt !== undefined ? activePaginationColourOpt : {
        NAME: "hex",
        VAL: "ED1E09"
    };
    return {
        paginationColour: paginationColour,
        activePaginationColour: activePaginationColour
    };
}
 /* No side effect */ 


/***/ }),

/***/ 4436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Layout_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51222);
// Generated by ReScript, PLEASE EDIT WITH CARE


function t(darkOpt, lightOpt, param) {
    var dark = darkOpt !== undefined ? darkOpt : {
        bodyColour: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.white */ .e.white,
        headingColour: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.white */ .e.white,
        backgroundColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.midPurple */ .e.midPurple,
        borderRadius: _theme_Theme_Layout_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Business.borderRadius */ .e.borderRadius,
        svgColour: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.white */ .e.white
    };
    var light = lightOpt !== undefined ? lightOpt : {
        bodyColour: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.bodyTextGrey */ .e.bodyTextGrey,
        headingColour: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.charcoal */ .e.charcoal,
        backgroundColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Business.veryLightGrey */ .e.veryLightGrey,
        borderRadius: _theme_Theme_Layout_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Business.borderRadius */ .e.borderRadius,
        svgColour: {
            NAME: "hex",
            VAL: "E8EEEF"
        }
    };
    return {
        dark: dark,
        light: light
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 71112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(backgroundColorOpt, colorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .purple50 */ .Ep;
    var color = colorOpt !== undefined ? colorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .purple400 */ .F0;
    return {
        backgroundColor: backgroundColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 27471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(colorOpt, param) {
    var color = colorOpt !== undefined ? colorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .red400 */ .kl;
    return {
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 48825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ Component; }
});

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/Fresnel/Fresnel.bs.js + 1 modules
var Fresnel_bs = __webpack_require__(17847);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/MenuToggle/MenuToggle.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




var baseIcon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.charcoal */.RL.charcoal),
    BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(23)),
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* left */.t$v(BsCssJs_bs/* zero */.bMI),
    BsCssJs_bs/* top */.wey(BsCssJs_bs/* pct */.hdZ(50)),
    BsCssJs_bs/* transform */.vs(BsCssJs_bs/* translateY */.iWO(BsCssJs_bs/* pct */.hdZ(-50)))
]);
var hamburger = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* outlineWidth */.bu0(BsCssJs_bs.px(0)),
    BsCssJs_bs/* display */.jfB("inlineBlock"),
    BsCssJs_bs/* overflow */.txR("visible"),
    BsCssJs_bs/* cursor */.ocY("pointer"),
    BsCssJs_bs/* transition */.eRy(150, undefined, "linear", "opacity,filter"),
    BsCssJs_bs/* textTransform */.QxZ("none"),
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* black */.Sn),
    BsCssJs_bs/* backgroundColor */.Czw("transparent"),
    BsCssJs_bs/* unsafe */.K47("height", "calc(" + 2..toString() + "px * 3 + " + 5..toString() + "px * 2)")
]);
var hamburgerBox = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* position */.FKU("relative"),
    BsCssJs_bs/* display */.jfB("inlineBlock"),
    BsCssJs_bs/* width */.bf$(BsCssJs_bs.px(24)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100))
]);
function hamburgerInner(isOpen) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* position */.FKU("absolute"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(2)),
        BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(4)),
        BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* black */.Sn),
        BsCssJs_bs/* top */.wey(BsCssJs_bs/* pct */.hdZ(50)),
        BsCssJs_bs/* display */.jfB("block"),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(-2)),
        BsCssJs_bs/* transitionProperty */.n_e("transform"),
        BsCssJs_bs/* transitionTimingFunction */.BdG(isOpen ? {
            NAME: "cubicBezier",
            VAL: [
                0.215,
                0.61,
                0.355,
                1
            ]
        } : {
            NAME: "cubicBezier",
            VAL: [
                0.55,
                0.055,
                0.675,
                0.19
            ]
        }),
        BsCssJs_bs/* transitionDuration */.nVE(75),
        BsCssJs_bs/* transitionDelay */.BFP(isOpen ? 120 : 0),
        BsCssJs_bs/* transform */.vs({
            NAME: "rotate",
            VAL: isOpen ? BsCssJs_bs/* deg */.OaU(45) : BsCssJs_bs/* deg */.OaU(0)
        }),
        BsCssJs_bs/* before */.bbn([
            BsCssJs_bs/* position */.FKU("absolute"),
            BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
            BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(2)),
            BsCssJs_bs/* transitions */.pBE(isOpen ? [
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, undefined, "ease", "top"),
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, 120, "ease", "opacity")
            ] : [
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, undefined, "ease", "opacity"),
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, 120, "ease", "top")
            ]),
            BsCssJs_bs/* opacity */.Ohi(isOpen ? 0 : 1),
            BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(4)),
            BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* black */.Sn),
            BsCssJs_bs/* contentRule */.U5V({
                NAME: "text",
                VAL: ""
            }),
            BsCssJs_bs/* top */.wey(isOpen ? BsCssJs_bs/* zero */.bMI : BsCssJs_bs.px(-6))
        ]),
        BsCssJs_bs/* after */.e4p([
            BsCssJs_bs/* position */.FKU("absolute"),
            BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
            BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(2)),
            BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(4)),
            BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* black */.Sn),
            BsCssJs_bs/* contentRule */.U5V({
                NAME: "text",
                VAL: ""
            }),
            BsCssJs_bs/* bottom */.IaC(isOpen ? BsCssJs_bs/* zero */.bMI : BsCssJs_bs.px(-6)),
            BsCssJs_bs/* transform */.vs({
                NAME: "rotate",
                VAL: isOpen ? BsCssJs_bs/* deg */.OaU(-90) : BsCssJs_bs/* deg */.OaU(0)
            }),
            BsCssJs_bs/* transitions */.pBE(isOpen ? [
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, undefined, "ease", "bottom"),
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, 120, {
                    NAME: "cubicBezier",
                    VAL: [
                        0.215,
                        0.61,
                        0.355,
                        1
                    ]
                }, "transform")
            ] : [
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, undefined, {
                    NAME: "cubicBezier",
                    VAL: [
                        0.55,
                        0.055,
                        0.675,
                        0.19
                    ]
                }, "transform"),
                Css_Js_Core_bs/* Transition.shorthand */.uTP.shorthand(75, 120, "ease", "bottom")
            ])
        ])
    ]);
}
var Styles = {
    baseIcon: baseIcon,
    hamburgerLineHeight: 2,
    hamburgerLineGap: 5,
    hamburger: hamburger,
    hamburgerBox: hamburgerBox,
    hamburgerInner: hamburgerInner
};
function MenuToggle(props) {
    return jsx_runtime.jsx("div", {
        children: jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx("div", {
                className: hamburgerInner(props.isOpen)
            }),
            className: hamburgerBox
        }),
        className: hamburger,
        onClick: props.onClick
    });
}
var make = MenuToggle;
 /* baseIcon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Fonts.bs.js
var Theme_Fonts_bs = __webpack_require__(1476);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/ReactResponsive/ReactResponsive.bs.js
var ReactResponsive_bs = __webpack_require__(36499);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar__Background.bs.js + 1 modules
var TopNavigationBar_Background_bs = __webpack_require__(77013);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE













function Component(T) {
    var Background = TopNavigationBar_Background_bs/* Component */.w(T);
    var slideIn = BsCssJs_bs/* keyframes */.F4b([
        [
            100,
            [
                BsCssJs_bs/* left */.t$v(BsCssJs_bs.px(0))
            ]
        ]
    ]);
    var slideOut = BsCssJs_bs/* keyframes */.F4b([
        [
            0,
            [
                BsCssJs_bs/* left */.t$v(BsCssJs_bs/* pct */.hdZ(-50))
            ]
        ]
    ]);
    var slideAnimation = function slideAnimation(menuOpen) {
        return BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* position */.FKU("absolute"),
            BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(16)),
            BsCssJs_bs/* left */.t$v(BsCssJs_bs/* pct */.hdZ(-50)),
            BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
            menuOpen ? BsCssJs_bs/* animation */.oQ4(500, undefined, undefined, undefined, "forwards", undefined, undefined, slideIn) : BsCssJs_bs/* animation */.oQ4(500, undefined, undefined, undefined, "backwards", undefined, undefined, slideOut)
        ]);
    };
    var navWrapper = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw(T.backgroundColor),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(30)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(30))
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(20)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(20))
        ])
    ]);
    var navBar = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* flexDirection */.Me8(BsCssJs_bs/* column */.$QP)
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* flexDirection */.Me8(BsCssJs_bs/* row */.O7B),
            BsCssJs_bs/* alignItems */.cq$("stretch")
        ])
    ]);
    var menuToggle = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(0)),
        BsCssJs_bs/* maxHeight */.kCL(BsCssJs_bs.px(16))
    ]);
    var logoMenuBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* flexGrow */.H78(0),
        BsCssJs_bs/* minHeight */.jw4(BsCssJs_bs.px(66)),
        BsCssJs_bs/* alignItems */.cq$("center"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* position */.FKU("relative")
        ])
    ]);
    var logoAuthBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* justifyContent */.KlP("spaceBetween"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* flexGrow */.H78(0),
        BsCssJs_bs/* minHeight */.jw4(BsCssJs_bs.px(66)),
        BsCssJs_bs/* alignItems */.cq$("center"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* position */.FKU("relative"),
            BsCssJs_bs/* marginLeft */.oIA(T.logoBlockMargin)
        ])
    ]);
    var prezzeeLogo = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* flexGrow */.H78(1),
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* justifyContent */.KlP(T.logoPosition),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* mobile */.ai, [
            BsCssJs_bs/* justifyContent */.KlP("center")
        ])
    ]);
    var navigationAuthBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs/* pct */.hdZ(100))
    ]);
    var menuBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("none"),
        BsCssJs_bs/* justifyContent */.KlP("flexStart"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* flexGrow */.H78(1),
            BsCssJs_bs/* display */.jfB("flex")
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(16))
        ])
    ]);
    var menuBlockWrapper = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("block"),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* overflow */.txR("auto"),
        BsCssJs_bs/* position */.FKU("relative")
    ]);
    var authBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("none"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* flexGrow */.H78(0),
            BsCssJs_bs/* display */.jfB("flex"),
            BsCssJs_bs/* alignItems */.cq$("center")
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* flexWrap */.WOS("wrap"),
            BsCssJs_bs/* justifyContent */.KlP("flexStart"),
            BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs.px(16)),
            BsCssJs_bs/* borderTopWidth */.fCW(BsCssJs_bs.px(1)),
            BsCssJs_bs/* borderTopStyle */.$Bc("solid"),
            BsCssJs_bs/* borderTopColor */.SKu(Theme_Color_bs/* Personal.paleDivider */.RL.paleDivider),
            BsCssJs_bs/* children */.pIy([
                BsCssJs_bs/* flexGrow */.H78(1)
            ])
        ])
    ]);
    var loggedInBorder = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* borderLeft */.sc3(BsCssJs_bs.px(1), "solid", Theme_Color_bs/* Personal.paleGrey */.RL.paleGrey)
    ]);
    var regionPickerBlock = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* flexGrow */.H78(1),
        BsCssJs_bs/* flexBasis */.P_T(BsCssJs_bs/* pct */.hdZ(100)),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(28)),
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.charcoal */.RL.charcoal),
        BsCssJs_bs/* display */.jfB("none")
    ]);
    var displayVisible = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* display */.jfB("block"))
    ]);
    var fullHeight = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* position */.FKU(BsCssJs_bs/* relative */.Gfm),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.vh(100))
    ]);
    var mobileAndTabletOnly = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* display */.jfB("none"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* display */.jfB("block")),
            BsCssJs_bs/* zIndex */.W5D(10)
        ])
    ]);
    var mobileLogout = BsCssJs_bs/* style */.oBv([
        Theme_Fonts_bs/* SofiaPro.family */.t.family,
        BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed),
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* justifyContent */.KlP("center"),
        BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(20)),
        BsCssJs_bs/* textDecoration */.QXS("underline"),
        BsCssJs_bs/* cursor */.ocY("pointer")
    ]);
    var Styles = {
        slideIn: slideIn,
        slideOut: slideOut,
        slideAnimation: slideAnimation,
        navWrapper: navWrapper,
        navBar: navBar,
        menuToggle: menuToggle,
        logoMenuBlock: logoMenuBlock,
        logoAuthBlock: logoAuthBlock,
        prezzeeLogo: prezzeeLogo,
        navigationAuthBlock: navigationAuthBlock,
        menuBlock: menuBlock,
        menuBlockWrapper: menuBlockWrapper,
        authBlock: authBlock,
        loggedInBorder: loggedInBorder,
        regionPickerBlock: regionPickerBlock,
        displayVisible: displayVisible,
        fullHeight: fullHeight,
        mobileAndTabletOnly: mobileAndTabletOnly,
        mobileLogout: mobileLogout
    };
    var TopNavigationBar$Component = function TopNavigationBar$Component(props) {
        var onMenuChange = props.onMenuChange;
        var className = props.className;
        var closeMenuObservable = props.closeMenuObservable;
        var authBlock = props.authBlock;
        var className$1 = className !== undefined ? className : "";
        var tabletOrMobile = ReactResponsive_bs/* useMediaQuery */.a(Theme_Responsive_bs/* belowLargeScreen */.Qo);
        var match = react.useState(function() {
            return false;
        });
        var setMenuOpen = match[1];
        var menuOpen = match[0];
        var display = menuOpen ? displayVisible : "";
        var fullHeight$1 = menuOpen ? fullHeight : "";
        var disableWindowScroll = function disableWindowScroll(isDisabled) {
            document.documentElement.style.setProperty("touch-action", isDisabled ? "none" : "");
            document.documentElement.style.setProperty("overflow", isDisabled ? "hidden" : "");
        };
        var onMenuClick = function onMenuClick(param) {
            if (onMenuChange !== undefined) {
                curry._1(onMenuChange, !menuOpen);
            }
            curry._1(setMenuOpen, function(param) {
                return !menuOpen;
            });
        };
        var closeMenu = function closeMenu(param) {
            if (onMenuChange !== undefined) {
                curry._1(onMenuChange, false);
            }
            curry._1(setMenuOpen, function(param) {
                return false;
            });
        };
        var logoutButton = props.isLoggedIn ? jsx_runtime.jsx("div", {
            children: "Log out",
            className: mobileLogout,
            onClick: props.onLogoutClick
        }) : null;
        var authMenu = authBlock !== undefined ? caml_option/* valFromOption */.xt(authBlock) : null;
        var navigationAuthBlock$1 = jsx_runtime.jsxs(jsx_runtime.Fragment, {
            children: [
                jsx_runtime.jsx("div", {
                    children: props.navigationBlock,
                    className: classnames_default()([
                        menuBlock,
                        display
                    ])
                }),
                jsx_runtime.jsxs(Fresnel_bs/* Media.make */.pU.make, {
                    lessThan: "rbLargeDesktop",
                    children: [
                        props.regionPicker,
                        logoutButton
                    ],
                    className: classnames_default()([
                        regionPickerBlock,
                        display
                    ])
                })
            ]
        });
        react.useEffect(function() {
            curry._1(closeMenuObservable.subscribe, closeMenu);
            return function(param) {
                curry._1(closeMenuObservable.unsubscribe, closeMenu);
            };
        }, []);
        react.useEffect(function() {
            if (menuOpen && !tabletOrMobile) {
                curry._1(setMenuOpen, function(param) {
                    return false;
                });
            }
        }, [
            tabletOrMobile
        ]);
        react.useEffect(function() {
            disableWindowScroll(menuOpen);
        }, [
            menuOpen
        ]);
        return jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx("div", {
                children: jsx_runtime.jsxs(jsx_runtime.Fragment, {
                    children: [
                        jsx_runtime.jsxs("div", {
                            children: [
                                jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                                    lessThan: "rbLargeDesktop",
                                    children: jsx_runtime.jsx(make, {
                                        isOpen: menuOpen,
                                        onClick: onMenuClick
                                    }),
                                    className: classnames_default()([
                                        mobileAndTabletOnly,
                                        menuToggle
                                    ])
                                }),
                                jsx_runtime.jsxs("div", {
                                    children: [
                                        jsx_runtime.jsx("div", {
                                            children: props.logo,
                                            className: prezzeeLogo
                                        }),
                                        authMenu
                                    ],
                                    className: logoAuthBlock
                                })
                            ],
                            className: logoMenuBlock
                        }),
                        jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                            lessThan: "rbLargeDesktop",
                            children: jsx_runtime.jsx("div", {
                                children: navigationAuthBlock$1,
                                className: slideAnimation(menuOpen)
                            }),
                            className: classnames_default()([
                                menuBlockWrapper
                            ])
                        }),
                        jsx_runtime.jsx(Fresnel_bs/* Media.make */.pU.make, {
                            greaterThanOrEqual: "rbLargeDesktop",
                            children: navigationAuthBlock$1,
                            className: navigationAuthBlock
                        })
                    ]
                }),
                className: classnames_default()([
                    navBar,
                    fullHeight$1
                ]),
                style: {
                    maxHeight: "100dvh"
                }
            }),
            className: classnames_default()([
                navWrapper,
                className$1
            ])
        });
    };
    return {
        Background: Background,
        StaticBackground: undefined,
        FadeBackground: undefined,
        Styles: Styles,
        make: TopNavigationBar$Component
    };
}
 /* react Not a pure module */ 


/***/ }),

/***/ 73340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17847);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17845);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE






var authContainer = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("center")
]);
var flatAuthBlock = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexDirection */ .Me8("row"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .important */ .efO(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(0)))
    ])
]);
var stackedAuthBlock = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .belowLargeScreen */ .Qo, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexWrap */ .WOS("wrap"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("flexStart"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .paddingTop */ .odA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderTopWidth */ .fCW(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(1)),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderTopStyle */ .$Bc("solid"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .borderTopColor */ .SKu(_theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Personal.paleDivider */ .RL.paleDivider),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .children */ .pIy([
            _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexGrow */ .H78(1)
        ])
    ])
]);
var headerAuth = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .belowLargeScreen */ .Qo, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("none")
    ])
]);
var Styles = {
    authContainer: authContainer,
    flatAuthBlock: flatAuthBlock,
    stackedAuthBlock: stackedAuthBlock,
    headerAuth: headerAuth
};
function TopNavigationBar__AuthContainer(props) {
    var className = props.className;
    var authMenu = props.authMenu;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Media.make */ .pU.make, {
                greaterThanOrEqual: "rbLargeDesktop",
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: authMenu,
                    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
                        flatAuthBlock,
                        headerAuth
                    ])
                }),
                className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
                    authContainer,
                    className$1
                ])
            }),
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx(_bindings_Fresnel_Fresnel_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .Media.make */ .pU.make, {
                lessThan: props.authMenuLowerBreakpoint,
                children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
                    children: authMenu,
                    className: stackedAuthBlock
                })
            })
        ]
    });
}
var make = TopNavigationBar__AuthContainer;
 /* authContainer Not a pure module */ 


/***/ }),

/***/ 77013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ Component; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react-use-scroll-position/index.js
var react_use_scroll_position = __webpack_require__(56445);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/abstracts/BackgroundScrollFade.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function boundFloat(upper, lower, arg) {
    return Math.max(lower, Math.min(upper, arg));
}
function useBackgroundScrollFade(fadeStyleFn, fadeDistancePx, fadeDirection) {
    var y = react_use_scroll_position/* useScrollYPosition */.ey();
    var pos = y;
    var calc = pos / fadeDistancePx;
    var directedCalc = fadeDirection ? 1 - calc : calc;
    return curry._1(fadeStyleFn, boundFloat(1, 0, directedCalc));
}
 /* react-use-scroll-position Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/TopNavigationBar/TopNavigationBar__Background.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function Component(T) {
    var staticBackground = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw(T.backgroundColor)
    ]);
    var dynamicBackground = function dynamicBackground(alpha) {
        var c = Theme_Color_bs/* colourToRgba */.H8(T.backgroundColor, alpha);
        return BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* backgroundColor */.Czw(c),
            BsCssJs_bs/* transition */.eRy(200, 0, "easeInOut", "background-color")
        ]);
    };
    var Styles = {
        staticBackground: staticBackground,
        dynamicBackground: dynamicBackground
    };
    var TopNavigationBar__Background$Component$FadeBackground = function TopNavigationBar__Background$Component$FadeBackground(props) {
        var className = props.className;
        var className$1 = className !== undefined ? className : "";
        var background = useBackgroundScrollFade(dynamicBackground, 20, props.fade);
        return jsx_runtime.jsx("div", {
            children: props.children,
            className: classnames_default()([
                background,
                className$1
            ])
        });
    };
    var FadeBackground = {
        make: TopNavigationBar__Background$Component$FadeBackground
    };
    var TopNavigationBar__Background$Component$StaticBackground = function TopNavigationBar__Background$Component$StaticBackground(props) {
        var className = props.className;
        var className$1 = className !== undefined ? className : "";
        return jsx_runtime.jsx("div", {
            children: props.children,
            className: classnames_default()([
                staticBackground,
                className$1
            ])
        });
    };
    var StaticBackground = {
        make: TopNavigationBar__Background$Component$StaticBackground
    };
    return {
        Styles: Styles,
        FadeBackground: FadeBackground,
        StaticBackground: StaticBackground
    };
}
 /* classnames Not a pure module */ 


/***/ }),

/***/ 65164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70965);
// Generated by ReScript, PLEASE EDIT WITH CARE




var menuBlock = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .justifyContent */ .KlP("flexStart"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .largeScreen */ .M6, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .flexGrow */ .H78(1),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .display */ .jfB("flex")
    ]),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .media */ .BC2(_theme_Theme_Responsive_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .belowLargeScreen */ .Qo, [
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .marginTop */ .E9m(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__.px(16))
    ])
]);
var Styles = {
    menuBlock: menuBlock
};
function TopNavigationBar__Navlinks(props) {
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx("div", {
        children: props.children,
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([
            menuBlock,
            className$1
        ])
    });
}
var make = TopNavigationBar__Navlinks;
 /* menuBlock Not a pure module */ 


/***/ }),

/***/ 15628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(backgroundColorOpt, headingColorOpt, colorOpt, hyperlinkColorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lilac50 */ .wD;
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP;
    var color = colorOpt !== undefined ? colorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA;
    var hyperlinkColor = hyperlinkColorOpt !== undefined ? hyperlinkColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .blue400 */ .ZM;
    return {
        backgroundColor: backgroundColor,
        headingColor: headingColor,
        color: color,
        hyperlinkColor: hyperlinkColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 10573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Colour": function() { return /* binding */ Colour; },
  "Fill": function() { return /* binding */ Fill; },
  "Shadows": function() { return /* binding */ Shadows; },
  "Styles": function() { return /* binding */ Styles; },
  "Universal": function() { return /* binding */ Universal; },
  "Variant": function() { return /* binding */ Variant; },
  "allowedTags": function() { return /* binding */ allowedTags; },
  "make": function() { return /* binding */ make; }
});

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Js_Core.bs.js
var Css_Js_Core_bs = __webpack_require__(32885);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Input.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function InputStyles(V, F, C, S, U) {
    var variantCss = function variantCss(v) {
        switch(v){
            case /* Regular */ 0:
                return V.regular;
            case /* Small */ 1:
                return V.small;
            case /* Icon */ 2:
                return V.icon;
        }
    };
    var fillCss = function fillCss(f) {
        switch(f){
            case /* Contained */ 0:
                return F.contained;
            case /* Outlined */ 1:
                return F.outlined;
            case /* None */ 2:
                return F.none;
        }
    };
    var colourCss = function colourCss(c, f, t) {
        var fillFn;
        switch(f){
            case /* Contained */ 0:
                fillFn = C.containedColours;
                break;
            case /* Outlined */ 1:
                fillFn = C.outlinedColours;
                break;
            case /* None */ 2:
                fillFn = C.noneColours;
                break;
        }
        if (typeof c !== "number") {
            return curry._3(fillFn, c._0, c._1, c._2);
        }
        switch(c){
            case /* Red */ 0:
                return curry._3(fillFn, Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed, Theme_Color_bs/* Personal.white */.RL.white, Theme_Color_bs/* Personal.primaryRedHover */.RL.primaryRedHover);
            case /* Charcoal */ 1:
                return curry._3(fillFn, Theme_Color_bs/* Personal.charcoal */.RL.charcoal, Theme_Color_bs/* Personal.white */.RL.white, Theme_Color_bs/* Personal.charcoalHover */.RL.charcoalHover);
            case /* White */ 2:
                return curry._3(fillFn, Theme_Color_bs/* Personal.white */.RL.white, Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey, Theme_Color_bs/* Personal.whiteHover */.RL.whiteHover);
            case /* BusinessPurple */ 3:
                return curry._3(fillFn, Theme_Color_bs/* Business.prezzeePurple */.e.prezzeePurple, Theme_Color_bs/* Business.white */.e.white, Theme_Color_bs/* Business.darkPurple */.e.darkPurple);
            case /* BusinessCharcoal */ 4:
                return curry._3(fillFn, Theme_Color_bs/* Business.charcoal */.e.charcoal, Theme_Color_bs/* Business.white */.e.white, Theme_Color_bs/* Business.charcoal */.e.charcoal);
            case /* Primary */ 5:
                return curry._3(fillFn, t.primary.default, t.primary.defaultText, t.primary.hover);
            case /* Secondary */ 6:
                return curry._3(fillFn, t.secondary.default, t.secondary.defaultText, t.secondary.hover);
            case /* Tertiary */ 7:
                return curry._3(fillFn, t.tertiary.default, t.tertiary.defaultText, t.tertiary.hover);
        }
    };
    var shadowCss = function shadowCss(s) {
        if (s) {
            return S.normal;
        } else {
            return S.none;
        }
    };
    var inputCss = function inputCss(c, f, v, s, t) {
        return [
            curry._1(U.universal, t.borderRadius),
            colourCss(c, f, t),
            fillCss(f),
            variantCss(v),
            s ? S.normal : S.none
        ];
    };
    return {
        variantCss: variantCss,
        fillCss: fillCss,
        colourCss: colourCss,
        shadowCss: shadowCss,
        inputCss: inputCss
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Animation.bs.js
var Theme_Animation_bs = __webpack_require__(78029);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var allowedTags = "button";
var regular = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(150)),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(50)),
        BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(30)),
        BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(30)),
        BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(5))
    ])
]);
var small = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(45)),
        BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(22)),
        BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(22)),
        BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(3))
    ])
]);
var icon = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* padding */.o3D(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(38)),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs.px(38)),
        BsCssJs_bs/* boxSizing */.ixg("contentBox")
    ])
]);
var Variant = {
    regular: regular,
    small: small,
    icon: icon
};
var contained = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* borderStyle */.$uf("none"),
        BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs/* zero */.bMI)
    ])
]);
var outlined = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs.px(2)),
        BsCssJs_bs/* borderStyle */.$uf("solid")
    ])
]);
var none = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* borderStyle */.$uf("none"),
        BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs/* zero */.bMI)
    ])
]);
var Fill = {
    contained: contained,
    outlined: outlined,
    none: none
};
function containedColours(main, secondary, mainHover) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* selector */.nZE(allowedTags, [
            BsCssJs_bs/* color */.$_Y(secondary),
            BsCssJs_bs/* backgroundColor */.Czw(main),
            BsCssJs_bs/* borderColor */.tvt(main),
            BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* fast */.q3),
            BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
            BsCssJs_bs/* transitionProperty */.n_e("background-color, border-color"),
            BsCssJs_bs/* hover */.MrM([
                BsCssJs_bs/* backgroundColor */.Czw(mainHover),
                BsCssJs_bs/* borderColor */.tvt(mainHover),
                BsCssJs_bs/* disabled */.JUm([
                    BsCssJs_bs/* color */.$_Y(secondary),
                    BsCssJs_bs/* backgroundColor */.Czw(main)
                ])
            ])
        ])
    ]);
}
function outlinedColours(main, secondary, _mainHover) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* selector */.nZE(allowedTags, [
            BsCssJs_bs/* color */.$_Y(main),
            BsCssJs_bs/* backgroundColor */.Czw("transparent"),
            BsCssJs_bs/* borderColor */.tvt(main),
            BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* fast */.q3),
            BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
            BsCssJs_bs/* transitionProperty */.n_e("background-color, color"),
            BsCssJs_bs/* hover */.MrM([
                BsCssJs_bs/* color */.$_Y(secondary),
                BsCssJs_bs/* backgroundColor */.Czw(main),
                BsCssJs_bs/* disabled */.JUm([
                    BsCssJs_bs/* color */.$_Y(main),
                    BsCssJs_bs/* backgroundColor */.Czw("transparent")
                ])
            ])
        ])
    ]);
}
function noneColours(main, _secondary, mainHover) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* selector */.nZE(allowedTags, [
            BsCssJs_bs/* color */.$_Y(main),
            BsCssJs_bs/* backgroundColor */.Czw("transparent"),
            BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* fast */.q3),
            BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
            BsCssJs_bs/* transitionProperty */.n_e("background-color, color"),
            BsCssJs_bs/* hover */.MrM([
                BsCssJs_bs/* color */.$_Y(mainHover),
                BsCssJs_bs/* disabled */.JUm([
                    BsCssJs_bs/* color */.$_Y(main)
                ])
            ])
        ])
    ]);
}
var Colour = {
    containedColours: containedColours,
    outlinedColours: outlinedColours,
    noneColours: noneColours
};
var normal = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, [
        BsCssJs_bs/* boxShadows */.LZf([
            Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(4), BsCssJs_bs.px(4), BsCssJs_bs.px(30), undefined, undefined, BsCssJs_bs/* rgba */.m4f(0, 0, 0, BsCssJs_bs/* pct */.hdZ(24.0))),
            Css_Js_Core_bs/* Shadow.box */.jXB.box(BsCssJs_bs.px(2), BsCssJs_bs.px(2), BsCssJs_bs.px(6), undefined, undefined, BsCssJs_bs/* rgba */.m4f(0, 0, 0, BsCssJs_bs/* pct */.hdZ(10.0)))
        ])
    ])
]);
var Shadows = {
    none: "",
    normal: normal
};
function universal(borderRadius_) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* selector */.nZE(allowedTags, [
            BsCssJs_bs/* display */.jfB("inlineFlex"),
            BsCssJs_bs/* justifyContent */.KlP("center"),
            BsCssJs_bs/* alignItems */.cq$("center"),
            BsCssJs_bs/* outlineWidth */.bu0(BsCssJs_bs/* zero */.bMI),
            BsCssJs_bs/* borderRadius */.E0l(borderRadius_),
            BsCssJs_bs/* cursor */.ocY("pointer"),
            BsCssJs_bs/* boxSizing */.ixg("borderBox"),
            BsCssJs_bs/* disabled */.JUm([
                BsCssJs_bs/* opacity */.Ohi(0.5),
                BsCssJs_bs/* hover */.MrM([
                    BsCssJs_bs/* cursor */.ocY("notAllowed")
                ])
            ])
        ]),
        BsCssJs_bs/* selector */.nZE("a", [
            BsCssJs_bs/* textDecoration */.QXS("none")
        ])
    ]);
}
var Universal = {
    universal: universal
};
var partial_arg = InputStyles;
function partial_arg$1(param, param$1) {
    return partial_arg(Variant, Fill, Colour, param, param$1);
}
var Input = partial_arg$1(Shadows, Universal);
var styling = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* selector */.nZE(allowedTags, Theme_Typography_bs/* Styles.style5Btn_ */.z.style5Btn_)
]);
var Styles = {
    Input: Input,
    styling: styling
};
function Button(props) {
    var className = props.className;
    var shadow = props.shadow;
    var variant = props.variant;
    var colour = props.colour;
    var fill = props.fill;
    var fill$1 = fill !== undefined ? fill : /* Contained */ 0;
    var colour$1 = colour !== undefined ? colour : /* Primary */ 5;
    var variant$1 = variant !== undefined ? variant : /* Regular */ 0;
    var shadow$1 = shadow !== undefined ? shadow : /* Nothing */ 0;
    var className$1 = className !== undefined ? className : "";
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    var inputStyling = curry._5(Input.inputCss, colour$1, fill$1, variant$1, shadow$1, theme);
    var className$2 = BsCssJs_bs/* merge */.TSy(belt_Array/* concat */.zo(inputStyling, [
        styling,
        className$1
    ]));
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: className$2
    });
}
var make = Button;
 /* regular Not a pure module */ 


/***/ }),

/***/ 38177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(backgroundColorOpt, headingColorOpt, colorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .pink400 */ .lp;
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP;
    var color = colorOpt !== undefined ? colorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA;
    return {
        backgroundColor: backgroundColor,
        headingColor: headingColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 72721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Consumer; },
/* harmony export */   "_": function() { return /* binding */ Context; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _rescript_std_lib_es6_js_null_undefined_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11236);
// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultContent = {
    itemId: undefined,
    elementCodename: undefined,
    componentId: undefined
};
var context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultContent);
var provider = context.Provider;
function Kontent$Context$Provider(props) {
    var value_itemId = props.itemId;
    var value_elementCodename = props.elementCodename;
    var value_componentId = props.componentId;
    var value = {
        itemId: value_itemId,
        elementCodename: value_elementCodename,
        componentId: value_componentId
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(provider, {
        value: value,
        children: props.children
    });
}
var Provider = {
    provider: provider,
    make: Kontent$Context$Provider
};
var Context = {
    defaultContent: defaultContent,
    context: context,
    Provider: Provider
};
function Kontent$Consumer(props) {
    var match = react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
    var attrs = {
        "data-kontent-item-id": _rescript_std_lib_es6_js_null_undefined_js__WEBPACK_IMPORTED_MODULE_1__/* .fromOption */ .Yo(match.itemId),
        "data-kontent-element-codename": _rescript_std_lib_es6_js_null_undefined_js__WEBPACK_IMPORTED_MODULE_1__/* .fromOption */ .Yo(match.elementCodename),
        "data-kontent-component-id": _rescript_std_lib_es6_js_null_undefined_js__WEBPACK_IMPORTED_MODULE_1__/* .fromOption */ .Yo(match.componentId)
    };
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.children, attrs);
}
var Consumer = {
    make: Kontent$Consumer
};
 /* context Not a pure module */ 


/***/ }),

/***/ 50952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Close": function() { return /* binding */ Close; },
/* harmony export */   "Container": function() { return /* binding */ Container; },
/* harmony export */   "Trigger": function() { return /* binding */ Trigger; },
/* harmony export */   "make": function() { return /* binding */ make; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
function Modal(props) {
    return props.children;
}
var Close;
var Container;
var Trigger;
var make = Modal;
 /* No side effect */ 


/***/ }),

/***/ 95157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Styles": function() { return /* binding */ Styles; },
  "make": function() { return /* binding */ Modal_Container_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(15764);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/ClientOnly/ClientOnly.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


function ClientOnly(props) {
    var match = react.useState(function() {
        return false;
    });
    var setIsBrowser = match[1];
    react.useEffect(function() {
        curry._1(setIsBrowser, function(param) {
            return true;
        });
    }, []);
    if (match[0]) {
        return props.children;
    } else {
        return null;
    }
}
var make = ClientOnly;
 /* react Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Layout.bs.js
var Theme_Layout_bs = __webpack_require__(51222);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Animation.bs.js
var Theme_Animation_bs = __webpack_require__(78029);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Container.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var fadeIn = BsCssJs_bs/* keyframes */.F4b([
    [
        0,
        [
            BsCssJs_bs/* opacity */.Ohi(0.0)
        ]
    ],
    [
        100,
        [
            BsCssJs_bs/* opacity */.Ohi(1.0)
        ]
    ]
]);
var fadeUp = BsCssJs_bs/* keyframes */.F4b([
    [
        0,
        [
            BsCssJs_bs/* opacity */.Ohi(0.0),
            BsCssJs_bs/* transform */.vs({
                NAME: "translate",
                VAL: [
                    BsCssJs_bs/* pct */.hdZ(-50),
                    {
                        NAME: "calc",
                        VAL: [
                            "sub",
                            BsCssJs_bs/* pct */.hdZ(-50),
                            BsCssJs_bs.px(-50)
                        ]
                    }
                ]
            })
        ]
    ],
    [
        100,
        [
            BsCssJs_bs/* opacity */.Ohi(1.0),
            BsCssJs_bs/* transform */.vs({
                NAME: "translate",
                VAL: [
                    BsCssJs_bs/* pct */.hdZ(-50),
                    BsCssJs_bs/* pct */.hdZ(-50)
                ]
            })
        ]
    ]
]);
function modalOverlay(isOpen) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* position */.FKU("fixed"),
        BsCssJs_bs/* top */.wey(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* left */.t$v(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* right */.F2z(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* bottom */.IaC(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* backgroundColor */.Czw({
            NAME: "rgba",
            VAL: [
                0,
                0,
                0,
                {
                    NAME: "num",
                    VAL: 0.5
                }
            ]
        }),
        BsCssJs_bs/* animation */.oQ4(Theme_Animation_bs/* slow */.Yu, undefined, undefined, "easeOut", undefined, undefined, undefined, fadeIn),
        BsCssJs_bs/* transition */.eRy(Theme_Animation_bs/* slow */.Yu, undefined, "easeOut", "opacity"),
        BsCssJs_bs/* opacity */.Ohi(isOpen ? 1 : 0),
        BsCssJs_bs/* zIndex */.W5D(9999)
    ]);
}
function modalContainer(isOpen) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* position */.FKU("absolute"),
        BsCssJs_bs/* top */.wey(BsCssJs_bs/* pct */.hdZ(50)),
        BsCssJs_bs/* left */.t$v(BsCssJs_bs/* pct */.hdZ(50)),
        BsCssJs_bs/* transform */.vs({
            NAME: "translate",
            VAL: [
                BsCssJs_bs/* pct */.hdZ(-50),
                isOpen ? BsCssJs_bs/* pct */.hdZ(-50) : {
                    NAME: "calc",
                    VAL: [
                        "sub",
                        BsCssJs_bs/* pct */.hdZ(-50),
                        BsCssJs_bs.px(-50)
                    ]
                }
            ]
        }),
        BsCssJs_bs/* animation */.oQ4(Theme_Animation_bs/* slow */.Yu, undefined, undefined, "easeOut", undefined, undefined, undefined, fadeUp),
        BsCssJs_bs/* transition */.eRy(Theme_Animation_bs/* slow */.Yu, undefined, "easeOut", "all"),
        BsCssJs_bs/* maxHeight */.kCL(BsCssJs_bs.vh(90)),
        BsCssJs_bs/* width */.bf$(BsCssJs_bs.vw(80)),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, [
            BsCssJs_bs/* width */.bf$(BsCssJs_bs.vw(60))
        ])
    ]);
}
var borderStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* background */.Oq0(Theme_Color_bs/* Personal.white */.RL.white),
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs.px(20)),
    BsCssJs_bs/* borderRadius */.E0l(Theme_Layout_bs/* Personal.borderRadius */.R.borderRadius)
]);
var borderlessStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* background */.Oq0(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey)
]);
var modalContent = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* overflow */.txR("auto")
]);
var Styles = {
    fadeIn: fadeIn,
    fadeUp: fadeUp,
    modalOverlay: modalOverlay,
    modalContainer: modalContainer,
    borderStyle: borderStyle,
    borderlessStyle: borderlessStyle,
    modalContent: modalContent
};
function Modal__Container(props) {
    var className = props.className;
    var borderless = props.borderless;
    var isOpen = props.isOpen;
    var borderless$1 = borderless !== undefined ? borderless : false;
    var className$1 = className !== undefined ? className : "";
    return jsx_runtime.jsx(make, {
        children: jsx_runtime.jsx((lib_default()), {
            isOpen: isOpen,
            children: jsx_runtime.jsx("div", {
                children: props.children,
                className: modalContent
            }),
            onAfterOpen: props.onAfterOpen,
            onAfterClose: props.onAfterClose,
            onRequestClose: props.onRequestClose,
            closeTimeoutMS: Theme_Animation_bs/* slow */.Yu,
            contentLabel: props.contentLabel,
            overlayClassName: modalOverlay(isOpen),
            className: classnames_default()([
                modalContainer(isOpen),
                borderless$1 ? borderlessStyle : borderStyle,
                className$1
            ]),
            id: props.id
        })
    });
}
var Modal_Container_bs_make = Modal__Container;
 /* fadeIn Not a pure module */ 


/***/ }),

/***/ 84369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ck": function() { return /* binding */ Item; },
  "Sy": function() { return /* binding */ make; }
});

// UNUSED EXPORTS: Styles

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Animation.bs.js
var Theme_Animation_bs = __webpack_require__(78029);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Navigation/Navigation__Item.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function Component(T) {
    var desktopStyling = [
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(16)),
        BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.px(16)),
        BsCssJs_bs/* display */.jfB("inlineBlock"),
        BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(32)),
        BsCssJs_bs/* lastChild */.QOo([
            BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.px(32))
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* display */.jfB("flex"),
            BsCssJs_bs/* alignItems */.cq$("stretch"),
            BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100)),
            BsCssJs_bs/* borderBottomStyle */.qtZ(BsCssJs_bs/* solid */.SQh),
            BsCssJs_bs/* borderBottomWidth */.HMX(BsCssJs_bs.px(3)),
            BsCssJs_bs/* borderColor */.tvt("transparent"),
            BsCssJs_bs/* boxSizing */.ixg("borderBox"),
            BsCssJs_bs/* hover */.MrM([
                BsCssJs_bs/* borderBottomColor */.vSo(T.hoverColour)
            ])
        ])
    ];
    var mobileStyling = [
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(22)),
        BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.px(30)),
        BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs.px(12)),
        BsCssJs_bs/* fontWeight */.Ue2("normal")
    ];
    var navigationItem = BsCssJs_bs/* merge */.TSy([
        Theme_Typography_bs/* Styles.style5 */.z.style5,
        BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* regular */.oN),
            BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
            BsCssJs_bs/* transitionProperty */.n_e("border-color"),
            BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, desktopStyling),
            BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, mobileStyling),
            BsCssJs_bs/* selector */.nZE("a", [
                BsCssJs_bs/* color */.$_Y(T.linkColour),
                BsCssJs_bs/* textDecoration */.QXS(BsCssJs_bs/* none */.YPD),
                BsCssJs_bs/* transitionDuration */.nVE(Theme_Animation_bs/* regular */.oN),
                BsCssJs_bs/* transitionTimingFunction */.BdG("easeInOut"),
                BsCssJs_bs/* transitionProperty */.n_e("color"),
                BsCssJs_bs/* hover */.MrM([
                    BsCssJs_bs/* color */.$_Y(T.hoverColour)
                ]),
                BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* desktop */.gv, [
                    BsCssJs_bs/* display */.jfB("flex"),
                    BsCssJs_bs/* alignItems */.cq$("center")
                ])
            ])
        ])
    ]);
    var Styles = {
        desktopStyling: desktopStyling,
        mobileStyling: mobileStyling,
        navigationItem: navigationItem
    };
    var Navigation__Item$Component = function Navigation__Item$Component(props) {
        return jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
            children: jsx_runtime.jsx("li", {
                children: props.children,
                className: navigationItem
            })
        });
    };
    return {
        Styles: Styles,
        make: Navigation__Item$Component
    };
}
 /* react/jsx-runtime Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Navigation/Navigation.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function Navigation_bs_Component(T) {
    var styling = BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* listStyleType */.jZR("none"),
        BsCssJs_bs/* margin */.e6$(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* padding */.o3D(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* display */.jfB("flex"),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* largeScreen */.M6, [
            BsCssJs_bs/* alignItems */.cq$(BsCssJs_bs/* stretch */.dy0),
            BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100))
        ]),
        BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* belowLargeScreen */.Qo, [
            BsCssJs_bs/* flexDirection */.Me8("column"),
            BsCssJs_bs/* alignItems */.cq$("flexStart")
        ])
    ]);
    var Styles = {
        styling: styling
    };
    var Item = Component(T);
    var Navigation$Component = function Navigation$Component(props) {
        return jsx_runtime.jsx("nav", {
            children: jsx_runtime.jsx("ul", {
                children: props.children,
                className: styling
            })
        });
    };
    return {
        Styles: Styles,
        Item: Item,
        make: Navigation$Component
    };
}
 /* react/jsx-runtime Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Navigation/Navigation__Theme__Personal.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

var hoverColour = Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed;
var linkColour = Theme_Color_bs/* Personal.charcoal */.RL.charcoal;
var Theme = {
    hoverColour: hoverColour,
    linkColour: linkColour
};
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Navigation/Navigation__Personal.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE


var include = Navigation_bs_Component(Theme);
var Styles = include.Styles;
var Item = include.Item;
var make = include.make;
 /* include Not a pure module */ 


/***/ }),

/***/ 16755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
// Generated by ReScript, PLEASE EDIT WITH CARE

function RegionFlag(props) {
    var sizeStr = String(props.size);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("img", {
        className: props.className,
        alt: props.alt,
        height: sizeStr,
        src: props.src,
        width: sizeStr
    });
}
var make = RegionFlag;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 10325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ RegionIndicator_bs_make; }
});

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal.bs.js
var Modal_bs = __webpack_require__(50952);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Button/Button.bs.js + 1 modules
var Button_bs = __webpack_require__(10573);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Kontent/Kontent.bs.js
var Kontent_bs = __webpack_require__(72721);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Typography.bs.js
var Theme_Typography_bs = __webpack_require__(32567);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionList/RegionListLine.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function lineWrapper(theme) {
    var match = theme.components;
    return BsCssJs_bs/* merge */.TSy([
        Theme_Typography_bs/* Styles.body */.z.body,
        BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* padding */.o3D(BsCssJs_bs.px(3)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(20)),
            BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(100)),
            BsCssJs_bs/* color */.$_Y(match.regionPicker.deselectedColor)
        ])
    ]);
}
function selected(theme) {
    var match = theme.components;
    var regionPicker = match.regionPicker;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* backgroundColor */.Czw(regionPicker.selectedBackgroundColor),
        BsCssJs_bs/* color */.$_Y(regionPicker.selectedTextColor),
        BsCssJs_bs/* fontWeight */.Ue2("semiBold"),
        BsCssJs_bs/* selector */.nZE("img", [
            BsCssJs_bs/* borderColor */.tvt(regionPicker.selectedIconBorderColor),
            BsCssJs_bs/* borderRadius */.E0l(BsCssJs_bs.px(100))
        ])
    ]);
}
var Styles = {
    lineWrapper: lineWrapper,
    selected: selected
};
function RegionListLine(props) {
    var onClick = props.onClick;
    var selected$1 = props.selected;
    var selected$2 = selected$1 !== undefined ? selected$1 : false;
    var onClick$1 = onClick !== undefined ? onClick : function onClick$1(param) {};
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    var wrapperClassName = BsCssJs_bs/* merge */.TSy(selected$2 ? [
        lineWrapper(theme),
        selected(theme)
    ] : [
        lineWrapper(theme)
    ]);
    return jsx_runtime.jsx("div", {
        children: props.region.el,
        className: wrapperClassName,
        onClick: onClick$1
    });
}
var make = RegionListLine;
 /* react/jsx-runtime Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionList/RegionList.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






var listWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs.px(12)),
    BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(12)),
    BsCssJs_bs/* cursor */.ocY("pointer"),
    BsCssJs_bs/* nthChild */.vvq({
        NAME: "add",
        VAL: [
            1,
            2
        ]
    }, [
        BsCssJs_bs/* borderTopWidth */.fCW(BsCssJs_bs.px(1)),
        BsCssJs_bs/* borderTopColor */.SKu(Theme_Color_bs/* Personal.paleDivider */.RL.paleDivider),
        BsCssJs_bs/* borderTopStyle */.$Bc("solid")
    ])
]);
var RegionList_bs_Styles = {
    listWrapper: listWrapper
};
function RegionList(props) {
    var onChange = props.onChange;
    var selected = props.selected;
    var selected$1 = selected !== undefined ? selected : 0;
    var onChange$1 = onChange !== undefined ? onChange : function onChange$1(param) {};
    var regionLines = belt_Array/* mapWithIndex */.Su(props.regions, function(i, region) {
        return jsx_runtime.jsx("div", {
            children: jsx_runtime.jsx(make, {
                region: region,
                selected: selected$1 === i
            }),
            className: listWrapper,
            onClick: function onClick(param) {
                curry._1(onChange$1, i);
            }
        }, String(i));
    });
    return jsx_runtime.jsx("div", {
        children: regionLines
    });
}
var RegionList_bs_make = RegionList;
 /* listWrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Responsive.bs.js
var Theme_Responsive_bs = __webpack_require__(70965);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionPicker/RegionPicker.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE











var wrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.charcoal */.RL.charcoal)
]);
function heading(theme) {
    var match = theme.components;
    return BsCssJs_bs/* merge */.TSy([
        Theme_Typography_bs/* Styles.h4 */.z.h4,
        BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs.px(10)),
            BsCssJs_bs/* color */.$_Y(match.regionPicker.headingColor)
        ])
    ]);
}
function subText(theme) {
    var match = theme.components;
    return BsCssJs_bs/* merge */.TSy([
        Theme_Typography_bs/* Styles.body */.z.body,
        BsCssJs_bs/* style */.oBv([
            BsCssJs_bs/* marginBottom */.yl7(BsCssJs_bs.px(5)),
            BsCssJs_bs/* color */.$_Y(match.regionPicker.descriptionColor)
        ])
    ]);
}
var buttonWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("flex"),
    BsCssJs_bs/* justifyContent */.KlP("center"),
    BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(18))
]);
var saveButton = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(12)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* tabletOrDesktop */.ab, [
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* minWidth */.ihZ(BsCssJs_bs.px(180)))
    ]),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* mobile */.ai, [
        BsCssJs_bs/* flexGrow */.H78(1)
    ])
]);
var RegionPicker_bs_Styles = {
    wrapper: wrapper,
    heading: heading,
    subText: subText,
    buttonWrapper: buttonWrapper,
    saveButton: saveButton
};
function RegionPicker(props) {
    var onSave = props.onSave;
    var selected = props.selected;
    var strings = props.strings;
    var selected$1 = selected !== undefined ? selected : 0;
    var onSave$1 = onSave !== undefined ? onSave : function onSave$1(param) {};
    var match = react.useState(function() {
        return selected$1;
    });
    var setSelected = match[1];
    var _selected = match[0];
    var theme = ThemeContext_bs/* useTheme */.Fg(undefined);
    return jsx_runtime.jsx(Kontent_bs/* Consumer.make */.$.make, {
        children: jsx_runtime.jsxs("div", {
            children: [
                jsx_runtime.jsx("h4", {
                    children: strings.heading,
                    className: heading(theme)
                }),
                jsx_runtime.jsx("p", {
                    children: strings.heading_subtext,
                    className: subText(theme)
                }),
                jsx_runtime.jsx(RegionList_bs_make, {
                    regions: props.regions,
                    selected: _selected,
                    onChange: function onChange(i) {
                        curry._1(setSelected, function(param) {
                            return i;
                        });
                    }
                }),
                jsx_runtime.jsx(Button_bs.make, {
                    children: jsx_runtime.jsx("button", {
                        children: strings.cta_button,
                        className: saveButton,
                        onClick: function onClick(param) {
                            curry._1(onSave$1, _selected);
                        }
                    }),
                    className: buttonWrapper
                })
            ],
            className: wrapper
        })
    });
}
var RegionPicker_bs_make = RegionPicker;
 /* wrapper Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Layout.bs.js
var Theme_Layout_bs = __webpack_require__(51222);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/Modal/Modal__Container.bs.js + 1 modules
var Modal_Container_bs = __webpack_require__(95157);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/faTimes.js
var faTimes = __webpack_require__(95780);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionPicker/RegionPickerDialog.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE












var RegionPickerDialog_bs_wrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs.px(30)),
    BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs.px(470)),
    BsCssJs_bs/* media */.BC2(Theme_Responsive_bs/* mobile */.ai, [
        BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs/* pct */.hdZ(100))
    ])
]);
var closeButton = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.charcoal */.RL.charcoal),
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* top */.wey(BsCssJs_bs.px(30)),
    BsCssJs_bs/* right */.F2z(BsCssJs_bs.px(20)),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(26)),
    BsCssJs_bs/* fontWeight */.Ue2({
        NAME: "num",
        VAL: 300
    })
]);
var paper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* important */.efO(BsCssJs_bs/* borderRadius */.E0l(Theme_Layout_bs/* Personal.borderRadius */.R.borderRadius)),
    BsCssJs_bs/* important */.efO(BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(20))),
    BsCssJs_bs/* important */.efO(BsCssJs_bs/* marginRight */.wzR(BsCssJs_bs.px(20)))
]);
var backdrop = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* important */.efO(BsCssJs_bs/* backgroundColor */.Czw(BsCssJs_bs/* rgba */.m4f(49, 62, 73, {
        NAME: "num",
        VAL: 0.9
    })))
]);
var RegionPickerDialog_bs_Styles = {
    wrapper: RegionPickerDialog_bs_wrapper,
    closeButton: closeButton,
    paper: paper,
    backdrop: backdrop
};
function RegionPickerDialog(props) {
    var onClose = props.onClose;
    var onSave = props.onSave;
    var isOpen = props.isOpen;
    var selected = props.selected;
    var selected$1 = selected !== undefined ? selected : 0;
    var isOpen$1 = isOpen !== undefined ? isOpen : false;
    var onSave$1 = onSave !== undefined ? onSave : function onSave$1(param) {};
    var onClose$1 = onClose !== undefined ? onClose : function onClose$1(param) {};
    var match = react.useState(function() {
        return false;
    });
    var setModalOpen = match[1];
    var onRequestClose = function onRequestClose(param) {
        curry._1(setModalOpen, function(param) {
            return false;
        });
    };
    return jsx_runtime.jsx(Modal_bs.make, {
        children: jsx_runtime.jsxs(Modal_Container_bs.make, {
            id: "modal-reigon",
            isOpen: isOpen$1,
            onRequestClose: onRequestClose,
            children: [
                jsx_runtime.jsx(RegionPicker_bs_make, {
                    regions: props.regions,
                    strings: props.strings,
                    selected: selected$1,
                    onSave: onSave$1
                }),
                jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                    icon: faTimes/* faTimes */.NB,
                    className: closeButton,
                    onClick: function onClick(param) {
                        curry._1(onClose$1, undefined);
                    }
                })
            ],
            borderless: false,
            className: RegionPickerDialog_bs_wrapper
        })
    });
}
var RegionPickerDialog_bs_make = RegionPickerDialog;
 /* wrapper Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicator.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE






function RegionIndicator(props) {
    var onChange = props.onChange;
    var selected = props.selected;
    var regions = props.regions;
    var onChange$1 = onChange !== undefined ? onChange : function onChange$1(param) {};
    var match = react.useState(function() {
        return false;
    });
    var setIsOpen = match[1];
    var onClose = function onClose(param) {
        curry._1(setIsOpen, function(param) {
            return false;
        });
    };
    var openModal = function openModal(param) {
        curry._1(setIsOpen, function(param) {
            return true;
        });
    };
    var onSave = function onSave(selected) {
        curry._1(onChange$1, selected);
        curry._1(setIsOpen, function(param) {
            return false;
        });
    };
    var r = belt_Array/* get */.U2(regions, selected);
    if (r !== undefined) {
        return jsx_runtime.jsxs(react.Fragment, {
            children: [
                props.children,
                jsx_runtime.jsx("div", {
                    children: curry._1(props.clickableElem, r),
                    className: BsCssJs_bs/* style */.oBv([
                        BsCssJs_bs/* height */.Cb8(BsCssJs_bs/* pct */.hdZ(100))
                    ]),
                    onClick: openModal
                }),
                jsx_runtime.jsx(RegionPickerDialog_bs_make, {
                    regions: regions,
                    strings: props.strings,
                    selected: selected,
                    isOpen: match[0],
                    onSave: onSave,
                    onClose: onClose
                })
            ]
        });
    } else {
        return null;
    }
}
var RegionIndicator_bs_make = RegionIndicator;
 /* react Not a pure module */ 


/***/ }),

/***/ 75870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96533);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72721);
// Generated by ReScript, PLEASE EDIT WITH CARE



function RegionIndicatorCountryDisplay(props) {
    var r = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .get */ .U2(props.regions, props.selected);
    if (r === undefined) {
        return null;
    }
    var countryText = props.text.replace("{0}", r.name);
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
            children: countryText
        })
    });
}
var make = RegionIndicatorCountryDisplay;
 /* react/jsx-runtime Not a pure module */ 


/***/ }),

/***/ 15772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; },
/* harmony export */   "z": function() { return /* binding */ Styles; }
/* harmony export */ });
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25400);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var padding = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10);
var flagBlock = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .cursor */ .ocY("pointer"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingLeft */ .rv2(padding),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .paddingRight */ .WLm(padding),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .height */ .Cb8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .pct */ .hdZ(100))
]);
var spacing = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginRight */ .wzR(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center")
]);
var Styles = {
    padding: padding,
    flagBlock: flagBlock,
    spacing: spacing
};
function RegionIndicatorFlag(props) {
    var text = props.text;
    var icon = props.icon;
    var icon$1 = icon !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_2__/* .valFromOption */ .xt(icon) : null;
    var text$1 = text !== undefined ? text : "";
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("div", {
        children: [
            react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
                children: props.flag,
                className: spacing
            }),
            icon$1,
            text$1
        ],
        className: flagBlock
    });
}
var make = RegionIndicatorFlag;
 /* padding Not a pure module */ 


/***/ }),

/***/ 80176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _RegionFlag_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16755);
/* harmony import */ var _RegionIndicator_bs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10325);
/* harmony import */ var _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32567);
/* harmony import */ var _RegionIndicatorFlag_bs_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15772);
// Generated by ReScript, PLEASE EDIT WITH CARE






var inlineRegionPicker = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .merge */ .TSy([
    _theme_Theme_Typography_bs_js__WEBPACK_IMPORTED_MODULE_4__/* .Styles.smallBody */ .z.smallBody,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
        _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center")
    ])
]);
var Styles = {
    inlineRegionPicker: inlineRegionPicker
};
function RegionIndicatorTextual(props) {
    var text = props.text;
    var onChange = props.onChange;
    var onChange$1 = onChange !== undefined ? onChange : function onChange$1(param) {};
    var clickableElem = function clickableElem(r) {
        var flag = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_RegionFlag_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .S, {
            src: r.flag,
            size: 24
        });
        return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_RegionIndicatorFlag_bs_js__WEBPACK_IMPORTED_MODULE_5__/* .make */ .S, {
            flag: flag,
            text: text
        });
    };
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_RegionIndicator_bs_js__WEBPACK_IMPORTED_MODULE_3__/* .make */ .S, {
            regions: props.regions,
            strings: props.strings,
            selected: props.selected,
            children: props.children,
            clickableElem: clickableElem,
            onChange: onChange$1
        }),
        className: inlineRegionPicker
    });
}
var make = RegionIndicatorTextual;
 /* inlineRegionPicker Not a pure module */ 


/***/ }),

/***/ 69422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony export Styles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36585);
/* harmony import */ var _Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72721);
// Generated by ReScript, PLEASE EDIT WITH CARE



var container = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .display */ .jfB("flex"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .alignItems */ .cq$("center")
]);
var country = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .flexGrow */ .H78(1),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .marginLeft */ .oIA(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(10))
]);
var flag = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .style */ .oBv([
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .width */ .bf$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(38)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderColor */ .tvt("transparent"),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderWidth */ .J4J(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__.px(1)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .borderStyle */ .$uf("solid")
]);
var Styles = {
    container: container,
    country: country,
    flag: flag
};
function RegionListLineContent(props) {
    var name = props.name;
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_Kontent_Kontent_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Consumer.make */ .$.make, {
        children: react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs("div", {
            children: [
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("img", {
                    className: flag,
                    alt: name,
                    src: props.flag
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
                    children: name,
                    className: country
                }),
                react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx("div", {
                    children: props.currency
                })
            ],
            className: container
        })
    });
}
var make = RegionListLineContent;
 /* container Not a pure module */ 


/***/ }),

/***/ 3738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(headingColorOpt, descriptionColorOpt, deselectedColorOpt, selectedTextColorOpt, selectedBackgroundColorOpt, selectedIconBorderColorOpt, param) {
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP;
    var descriptionColor = descriptionColorOpt !== undefined ? descriptionColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA;
    var deselectedColor = deselectedColorOpt !== undefined ? deselectedColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP;
    var selectedTextColor = selectedTextColorOpt !== undefined ? selectedTextColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .blue400 */ .ZM;
    var selectedBackgroundColor = selectedBackgroundColorOpt !== undefined ? selectedBackgroundColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .blue50 */ .WV;
    var selectedIconBorderColor = selectedIconBorderColorOpt !== undefined ? selectedIconBorderColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .blue400 */ .ZM;
    return {
        headingColor: headingColor,
        descriptionColor: descriptionColor,
        deselectedColor: deselectedColor,
        selectedTextColor: selectedTextColor,
        selectedBackgroundColor: selectedBackgroundColor,
        selectedIconBorderColor: selectedIconBorderColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 98923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ TextField_bs_make; }
});

// UNUSED EXPORTS: DarkStyles, HelperText, LightStyles, Styles, callOption, cssClass, filledLabelSelector, filledLegendSelector, invalidFieldsetSelector

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/bindings/BsCss/BsCssJs.bs.js + 1 modules
var BsCssJs_bs = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext.bs.js
var ThemeContext_bs = __webpack_require__(28522);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Fonts.bs.js
var Theme_Fonts_bs = __webpack_require__(1476);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField__Theme.bs.js
var TextField_Theme_bs = __webpack_require__(80812);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField__HelperText.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





var universal = BsCssJs_bs/* style */.oBv([
    Theme_Fonts_bs/* SofiaPro.family */.t.family,
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs/* rem */.hOB(0.875)),
    BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs/* rem */.hOB(1.25)),
    BsCssJs_bs/* marginTop */.E9m(BsCssJs_bs.px(6))
]);
var lightStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.darkGrey */.RL.darkGrey)
]);
var darkStyle = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.white */.RL.white)
]);
var error = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* important */.efO(BsCssJs_bs/* color */.$_Y(Theme_Color_bs/* Personal.primaryRed */.RL.primaryRed))
]);
var Styles = {
    universal: universal,
    lightStyle: lightStyle,
    darkStyle: darkStyle,
    error: error
};
function TextField__HelperText(props) {
    var className = props.className;
    var error$1 = props.error;
    var theme = props.theme;
    var theme$1 = theme !== undefined ? theme : /* Light */ 0;
    var error$2 = error$1 !== undefined ? error$1 : false;
    var className$1 = className !== undefined ? className : "";
    var errorStyle = error$2 ? error : "";
    var themeStyle = theme$1 ? darkStyle : lightStyle;
    var className$2 = classnames_default()([
        universal,
        themeStyle,
        errorStyle,
        className$1
    ]);
    return jsx_runtime.jsx("div", {
        children: props.children,
        className: className$2
    });
}
var make = TextField__HelperText;
 /* universal Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE











function cssClass(s) {
    return "." + s + "";
}
var filledLabelSelector = ":not(:placeholder-shown) ~ label";
var filledLegendSelector = ":not(:placeholder-shown) ~ fieldset > legend";
var invalidFieldsetSelector = ":invalid ~ fieldset";
var translateLabel = BsCssJs_bs/* transforms */.Lol([
    {
        NAME: "translate",
        VAL: [
            BsCssJs_bs.px(7 + TextField_Theme_bs/* legendOffset */.Hw | 0),
            BsCssJs_bs.px(-13)
        ]
    },
    {
        NAME: "scale",
        VAL: [
            TextField_Theme_bs/* scaling */.w9,
            TextField_Theme_bs/* scaling */.w9
        ]
    }
]);
var legendMaxWidth = BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs.px(1000));
var label = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* position */.FKU("absolute"),
    BsCssJs_bs/* transformOrigin */.p22(BsCssJs_bs/* zero */.bMI, BsCssJs_bs/* zero */.bMI),
    BsCssJs_bs/* transform */.vs({
        NAME: "translate",
        VAL: [
            BsCssJs_bs.px(TextField_Theme_bs/* horizontalP */.Vi),
            BsCssJs_bs.px(TextField_Theme_bs/* vertP */.Dm)
        ]
    }),
    BsCssJs_bs/* transition */.eRy(200, 0, {
        NAME: "cubicBezier",
        VAL: [
            0,
            0,
            0.2,
            1
        ]
    }, "transform"),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(TextField_Theme_bs/* fontS */.hK)),
    BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.em(1)),
    BsCssJs_bs/* pointerEvents */.kkJ("none"),
    BsCssJs_bs/* zIndex */.W5D(1),
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs.px(4))
]);
var legend = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* position */.FKU("relative"),
    BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs/* pxFloat */.cYj(0.01)),
    BsCssJs_bs/* visibility */.WDY("hidden"),
    BsCssJs_bs/* padding */.o3D(BsCssJs_bs/* zero */.bMI),
    BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(5)),
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.em(TextField_Theme_bs/* scaling */.w9)),
    BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(11)),
    BsCssJs_bs/* display */.jfB("block")
]);
function fieldset(theme) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* position */.FKU("absolute"),
        BsCssJs_bs/* top */.wey(BsCssJs_bs.px(-5)),
        BsCssJs_bs/* left */.t$v(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* right */.F2z(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* bottom */.IaC(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* overflow */.txR("hidden"),
        BsCssJs_bs/* borderWidth */.J4J(BsCssJs_bs.px(1)),
        BsCssJs_bs/* borderStyle */.$uf("solid"),
        BsCssJs_bs/* pointerEvents */.kkJ("none"),
        BsCssJs_bs/* margin */.e6$(BsCssJs_bs/* zero */.bMI),
        BsCssJs_bs/* padding2 */.BLt(BsCssJs_bs/* zero */.bMI, BsCssJs_bs.px(8)),
        BsCssJs_bs/* borderRadius */.E0l(theme.borderRadius),
        BsCssJs_bs/* boxSizing */.ixg("borderBox")
    ]);
}
function fieldsetError(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* borderColor */.tvt(match.textField.errorColor))
    ]);
}
function input(theme) {
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* borderStyle */.$uf("none"),
        BsCssJs_bs/* background */.Oq0("none"),
        BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.em(1)),
        BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.em(1)),
        BsCssJs_bs/* paddingTop */.odA(BsCssJs_bs.px(TextField_Theme_bs/* vertP */.Dm)),
        BsCssJs_bs/* paddingBottom */.EtG(BsCssJs_bs.px(15)),
        BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(TextField_Theme_bs/* horizontalP */.Vi)),
        BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(TextField_Theme_bs/* horizontalP */.Vi)),
        BsCssJs_bs/* height */.Cb8(BsCssJs_bs.px(50)),
        BsCssJs_bs/* outline */.Kl7(BsCssJs_bs.px(0), "solid", "transparent"),
        BsCssJs_bs/* boxSizing */.ixg("borderBox"),
        BsCssJs_bs/* borderRadius */.E0l(theme.borderRadius),
        BsCssJs_bs/* selector */.nZE(filledLabelSelector, [
            translateLabel
        ]),
        BsCssJs_bs/* selector */.nZE(":disabled, :disabled ~ *", [
            BsCssJs_bs/* opacity */.Ohi(0.5),
            BsCssJs_bs/* hover */.MrM([
                BsCssJs_bs/* cursor */.ocY("notAllowed")
            ])
        ])
    ]);
}
function inputInvalidFieldset(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* selector */.nZE(invalidFieldsetSelector, [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* borderColor */.tvt(match.textField.errorColor))
        ])
    ]);
}
var inputWithLabel = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* placeholder */.W$B([
        BsCssJs_bs/* color */.$_Y("transparent")
    ]),
    BsCssJs_bs/* selector */.nZE("~ fieldset > legend", [
        BsCssJs_bs/* children */.pIy([
            BsCssJs_bs/* paddingLeft */.rv2(BsCssJs_bs.px(TextField_Theme_bs/* legendOffset */.Hw)),
            BsCssJs_bs/* paddingRight */.WLm(BsCssJs_bs.px(TextField_Theme_bs/* legendOffset */.Hw))
        ])
    ]),
    BsCssJs_bs/* selector */.nZE(filledLegendSelector, [
        BsCssJs_bs/* maxWidth */.kkr(BsCssJs_bs.px(1000))
    ])
]);
var innerWrapper = BsCssJs_bs/* style */.oBv([
    Theme_Fonts_bs/* SofiaPro.family */.t.family,
    BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs.px(TextField_Theme_bs/* fontS */.hK)),
    BsCssJs_bs/* lineHeight */.Nv8(BsCssJs_bs.em(1)),
    BsCssJs_bs/* position */.FKU("relative"),
    BsCssJs_bs/* display */.jfB("inlineFlex"),
    BsCssJs_bs/* flexDirection */.Me8("column"),
    BsCssJs_bs/* verticalAlign */.Loy("top"),
    BsCssJs_bs/* focusWithin */.u_l([
        BsCssJs_bs/* selector */.nZE(cssClass(legend), [
            legendMaxWidth
        ]),
        BsCssJs_bs/* selector */.nZE(cssClass(label), [
            translateLabel
        ])
    ])
]);
var outerWrapper = BsCssJs_bs/* style */.oBv([
    BsCssJs_bs/* display */.jfB("inlineFlex"),
    BsCssJs_bs/* flexDirection */.Me8("column")
]);
var TextField_bs_Styles = {
    translateLabel: translateLabel,
    legendMaxWidth: legendMaxWidth,
    label: label,
    legend: legend,
    fieldset: fieldset,
    fieldsetError: fieldsetError,
    input: input,
    inputInvalidFieldset: inputInvalidFieldset,
    inputWithLabel: inputWithLabel,
    innerWrapper: innerWrapper,
    outerWrapper: outerWrapper
};
function innerWrapper$1(theme) {
    var match = theme.components;
    var light = match.textField.light;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* hover */.MrM([
            BsCssJs_bs/* selector */.nZE(cssClass(fieldset(theme)), [
                BsCssJs_bs/* borderColor */.tvt(light.hoverBorderColor)
            ])
        ]),
        BsCssJs_bs/* focusWithin */.u_l([
            BsCssJs_bs/* selector */.nZE(cssClass(fieldset(theme)), [
                BsCssJs_bs/* border */.CgR(BsCssJs_bs.px(1), "solid", light.focusBorderColor)
            ])
        ])
    ]);
}
function input$1(theme) {
    var match = theme.components;
    var light = match.textField.light;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(light.color),
        BsCssJs_bs/* important */.efO(BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* white */.ix)),
        BsCssJs_bs/* placeholder */.W$B([
            BsCssJs_bs/* color */.$_Y(light.placeholderColor)
        ]),
        BsCssJs_bs/* focus */.T_4([
            BsCssJs_bs/* color */.$_Y(light.color)
        ]),
        BsCssJs_bs/* selector */.nZE(":disabled ~ fieldset", [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* borderColor */.tvt(light.borderColor))
        ]),
        BsCssJs_bs/* selector */.nZE(":disabled + label", [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* backgroundColor */.Czw("transparent"))
        ])
    ]);
}
function fieldset$1(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* borderColor */.tvt(match.textField.light.borderColor),
        BsCssJs_bs/* selector */.nZE("legend", [
            BsCssJs_bs/* fontSize */.JBY(BsCssJs_bs/* zero */.bMI),
            BsCssJs_bs/* marginLeft */.oIA(BsCssJs_bs.px(8))
        ])
    ]);
}
function label$1(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(match.textField.light.placeholderColor),
        BsCssJs_bs/* backgroundColor */.Czw(Theme_Color_bs/* white */.ix)
    ]);
}
var LightStyles = {
    innerWrapper: innerWrapper$1,
    input: input$1,
    fieldset: fieldset$1,
    label: label$1
};
var transparentWhite = BsCssJs_bs/* rgba */.m4f(255, 255, 255, {
    NAME: "num",
    VAL: 0.7
});
function innerWrapper$2(theme) {
    var match = theme.components;
    var dark = match.textField.dark;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* hover */.MrM([
            BsCssJs_bs/* selector */.nZE(cssClass(fieldset(theme)), [
                BsCssJs_bs/* borderColor */.tvt(dark.hoverBorderColor)
            ])
        ]),
        BsCssJs_bs/* focusWithin */.u_l([
            BsCssJs_bs/* selector */.nZE(cssClass(fieldset(theme)), [
                BsCssJs_bs/* border */.CgR(BsCssJs_bs.px(1), "solid", dark.focusBorderColor),
                BsCssJs_bs/* filter */.hXT([
                    {
                        NAME: "dropShadow",
                        VAL: [
                            BsCssJs_bs.px(0),
                            BsCssJs_bs.px(0),
                            BsCssJs_bs.px(4),
                            {
                                NAME: "rgba",
                                VAL: [
                                    255,
                                    255,
                                    255,
                                    {
                                        NAME: "num",
                                        VAL: 0.25
                                    }
                                ]
                            }
                        ]
                    }
                ])
            ])
        ])
    ]);
}
function input$2(theme) {
    var match = theme.components;
    var dark = match.textField.dark;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(dark.color),
        BsCssJs_bs/* placeholder */.W$B([
            BsCssJs_bs/* color */.$_Y(dark.placeholderColor)
        ]),
        BsCssJs_bs/* focus */.T_4([
            BsCssJs_bs/* color */.$_Y(dark.color)
        ]),
        BsCssJs_bs/* selector */.nZE(":disabled ~ fieldset", [
            BsCssJs_bs/* important */.efO(BsCssJs_bs/* borderColor */.tvt(dark.borderColor))
        ])
    ]);
}
function fieldset$2(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* borderColor */.tvt(match.textField.dark.borderColor)
    ]);
}
function label$2(theme) {
    var match = theme.components;
    return BsCssJs_bs/* style */.oBv([
        BsCssJs_bs/* color */.$_Y(match.textField.dark.placeholderColor)
    ]);
}
var DarkStyles = {
    transparentWhite: transparentWhite,
    innerWrapper: innerWrapper$2,
    input: input$2,
    fieldset: fieldset$2,
    label: label$2
};
function callOption(opt, arg) {
    if (opt !== undefined) {
        return curry._1(opt, arg);
    }
}
function TextField(props) {
    var helperText = props.helperText;
    var error = props.error;
    var type_ = props.type_;
    var theme = props.theme;
    var onFocus = props.onFocus;
    var onBlur = props.onBlur;
    var label$3 = props.label;
    var id = props.id;
    var className = props.className;
    var className$1 = className !== undefined ? className : "";
    var label$4 = label$3 !== undefined ? label$3 : "";
    var theme$1 = theme !== undefined ? theme : /* Light */ 0;
    var type_$1 = type_ !== undefined ? type_ : "text";
    var error$1 = error !== undefined ? error : false;
    var theme_ = ThemeContext_bs/* useTheme */.Fg(undefined);
    var hasLabel = label$4 !== "";
    var placeholderLocal = belt_Option/* getWithDefault */.tj(props.placeholder, " ");
    var match = react.useState(function() {
        return false;
    });
    var setDirty = match[1];
    var match$1 = react.useState(function() {
        return false;
    });
    var setBlurred = match$1[1];
    var wrapperStyles = theme$1 ? classnames_default()([
        innerWrapper,
        innerWrapper$2(theme_)
    ]) : classnames_default()([
        innerWrapper,
        innerWrapper$1(theme_)
    ]);
    var hasLabelStyle = hasLabel ? inputWithLabel : "";
    var invalidStyle = match[0] && match$1[0] ? inputInvalidFieldset(theme_) : "";
    var inputStyles = theme$1 ? classnames_default()([
        input(theme_),
        hasLabelStyle,
        input$2(theme_),
        invalidStyle
    ]) : classnames_default()([
        input(theme_),
        hasLabelStyle,
        input$1(theme_),
        invalidStyle
    ]);
    var labelStyles = theme$1 ? classnames_default()([
        label,
        label$2(theme_)
    ]) : classnames_default()([
        label,
        label$1(theme_)
    ]);
    var fieldsetErrorStyle = error$1 ? fieldsetError(theme_) : "";
    var fieldsetStyles = theme$1 ? classnames_default()([
        fieldset(theme_),
        fieldset$2(theme_),
        fieldsetErrorStyle
    ]) : classnames_default()([
        fieldset(theme_),
        fieldset$1(theme_),
        fieldsetErrorStyle
    ]);
    var onFocusLocal = function onFocusLocal(e) {
        curry._1(setDirty, function(param) {
            return true;
        });
        callOption(onFocus, e);
    };
    var onBlurLocal = function onBlurLocal(e) {
        curry._1(setBlurred, function(param) {
            return true;
        });
        callOption(onBlur, e);
    };
    var helperTextElem = helperText !== undefined ? jsx_runtime.jsx(make, {
        children: helperText,
        theme: theme$1,
        error: error$1
    }) : null;
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsxs("div", {
                children: [
                    jsx_runtime.jsx("input", {
                        ref: props.inputRef,
                        defaultValue: props.defaultValue,
                        className: inputStyles,
                        id: id,
                        autoComplete: props.autoComplete,
                        autoFocus: props.autoFocus,
                        disabled: props.disabled,
                        form: props.form,
                        maxLength: props.maxLength,
                        minLength: props.minLength,
                        name: props.name,
                        pattern: props.pattern,
                        placeholder: placeholderLocal,
                        readOnly: props.readOnly,
                        required: props.required,
                        size: props.size,
                        type: type_$1,
                        value: props.value,
                        onKeyDown: props.onKeyDown,
                        onKeyUp: props.onKeyUp,
                        onFocus: onFocusLocal,
                        onBlur: onBlurLocal,
                        onChange: props.onChange
                    }),
                    hasLabel ? jsx_runtime.jsx("label", {
                        children: label$4,
                        className: labelStyles,
                        htmlFor: id
                    }) : null,
                    jsx_runtime.jsx("fieldset", {
                        children: jsx_runtime.jsx("legend", {
                            children: hasLabel ? jsx_runtime.jsx("span", {
                                children: label$4
                            }) : null,
                            className: legend
                        }),
                        "aria-hidden": true,
                        className: fieldsetStyles
                    })
                ],
                className: wrapperStyles
            }),
            helperTextElem
        ],
        className: classnames_default()([
            outerWrapper,
            className$1
        ])
    });
}
var HelperText;
var TextField_bs_make = TextField;
 /* translateLabel Not a pure module */ 


/***/ }),

/***/ 80812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dm": function() { return /* binding */ vertP; },
/* harmony export */   "Hw": function() { return /* binding */ legendOffset; },
/* harmony export */   "Vi": function() { return /* binding */ horizontalP; },
/* harmony export */   "hK": function() { return /* binding */ fontS; },
/* harmony export */   "t": function() { return /* binding */ t; },
/* harmony export */   "w9": function() { return /* binding */ scaling; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

var scaling = 16 / 17;
function t(lightOpt, darkOpt, errorColorOpt, param) {
    var light = lightOpt !== undefined ? lightOpt : {
        borderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray400 */ .de,
        hoverBorderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA,
        focusBorderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .blue400 */ .ZM,
        color: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray800 */ .pP,
        placeholderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .gray600 */ .RA
    };
    var dark = darkOpt !== undefined ? darkOpt : {
        borderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix,
        hoverBorderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix,
        focusBorderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix,
        color: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix,
        placeholderColor: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .white */ .ix
    };
    var errorColor = errorColorOpt !== undefined ? errorColorOpt : _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .red400 */ .kl;
    return {
        light: light,
        dark: dark,
        errorColor: errorColor
    };
}
var vertP = 12;
var horizontalP = 16;
var legendOffset = 5;
var fontS = 17;
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 96805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DS": function() { return /* binding */ StaticBackground; }
/* harmony export */ });
/* unused harmony exports Styles, FadeBackground */
/* harmony import */ var _common_TopNavigationBar_TopNavigationBar_Background_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77013);
/* harmony import */ var _TopNavigationBar_Theme_Personal_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17502);
// Generated by ReScript, PLEASE EDIT WITH CARE


var include = _common_TopNavigationBar_TopNavigationBar_Background_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .w(_TopNavigationBar_Theme_Personal_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Theme */ .Q);
var Styles = include.Styles;
var FadeBackground = include.FadeBackground;
var StaticBackground = include.StaticBackground;
 /* include Not a pure module */ 


/***/ }),

/***/ 66841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; }
/* harmony export */ });
/* unused harmony exports Background, StaticBackground, FadeBackground, Styles */
/* harmony import */ var _common_TopNavigationBar_TopNavigationBar_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48825);
/* harmony import */ var _TopNavigationBar_Theme_Personal_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17502);
// Generated by ReScript, PLEASE EDIT WITH CARE


var include = _common_TopNavigationBar_TopNavigationBar_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .w(_TopNavigationBar_Theme_Personal_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Theme */ .Q);
var Background = include.Background;
var StaticBackground = include.StaticBackground;
var FadeBackground = include.FadeBackground;
var Styles = include.Styles;
var make = include.make;
 /* include Not a pure module */ 


/***/ }),

/***/ 17502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Theme; }
/* harmony export */ });
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17845);
// Generated by ReScript, PLEASE EDIT WITH CARE

var backgroundColor = _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Personal.white */ .RL.white;
var Theme_logoBlockMargin = {
    NAME: "rem",
    VAL: 0
};
var Theme = {
    backgroundColor: backgroundColor,
    logoPosition: "center",
    logoBlockMargin: Theme_logoBlockMargin
};
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 28522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ useTheme; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony exports Theme, Components, defaultTheme, context */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1997);
// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultTheme = _ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
var context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(defaultTheme);
function useTheme(param) {
    return react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
}
var provider = context.Provider;
function ThemeContext$Provider(props) {
    var value = props.value;
    var initValue = value !== undefined ? value : _ThemeContext_Theme_bs_js__WEBPACK_IMPORTED_MODULE_1__.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(provider, {
        value: initValue,
        children: props.children
    });
}
var Provider = {
    provider: provider,
    make: ThemeContext$Provider
};
var Theme;
var Components;
 /* defaultTheme Not a pure module */ 


/***/ }),

/***/ 23191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ ThemeContext_Components_bs_t; }
});

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Tag/Tag__Theme.bs.js
var Tag_Theme_bs = __webpack_require__(71112);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Footer/Footer__Theme.bs.js
var Footer_Theme_bs = __webpack_require__(38715);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/Tagline/Tagline__Theme.bs.js
var Tagline_Theme_bs = __webpack_require__(27471);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/IconCard/IconCard__Theme.bs.js
var IconCard_Theme_bs = __webpack_require__(4436);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/TextField/TextField__Theme.bs.js
var TextField_Theme_bs = __webpack_require__(80812);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/theme/Theme__Color.bs.js
var Theme_Color_bs = __webpack_require__(17845);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/PromoTiles/PromoTiles__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function t(backgroundColorOpt, colorOpt, iconColorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme_Color_bs/* lilac400 */._b;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* purple400 */.F0;
    var iconColor = iconColorOpt !== undefined ? iconColorOpt : Theme_Color_bs/* purple400 */.F0;
    return {
        backgroundColor: backgroundColor,
        color: color,
        iconColor: iconColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/ContentCard/ContentCard__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
function ContentCard_Theme_bs_t(titleColorOpt, descriptionColorOpt, param) {
    var titleColor = titleColorOpt !== undefined ? titleColorOpt : {
        NAME: "hex",
        VAL: "313E49"
    };
    var descriptionColor = descriptionColorOpt !== undefined ? descriptionColorOpt : {
        NAME: "hex",
        VAL: "4B4B4B"
    };
    return {
        titleColor: titleColor,
        descriptionColor: descriptionColor
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/EmailSignUp/EmailSignUp__Theme.bs.js
var EmailSignUp_Theme_bs = __webpack_require__(38177);
// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionPicker/RegionPicker__Theme.bs.js
var RegionPicker_Theme_bs = __webpack_require__(3738);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/CategoryTiles/CategoryTiles__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function CategoryTiles_Theme_bs_t(overlayColorOpt, decoColorOpt, colorOpt, param) {
    var overlayColor = overlayColorOpt !== undefined ? overlayColorOpt : Theme_Color_bs/* purple700 */.$9;
    var decoColor = decoColorOpt !== undefined ? decoColorOpt : Theme_Color_bs/* purple400 */.F0;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* white */.ix;
    return {
        overlayColor: overlayColor,
        decoColor: decoColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/LargeHeroTile/LargeHeroTile__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function LargeHeroTile_Theme_bs_t(headingColorOpt, colorOpt, param) {
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme_Color_bs/* gray800 */.pP;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* gray600 */.RA;
    return {
        headingColor: headingColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/SmallHeroTile/SmallHeroTile__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function SmallHeroTile_Theme_bs_t(headingColorOpt, colorOpt, param) {
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme_Color_bs/* gray800 */.pP;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* gray600 */.RA;
    return {
        headingColor: headingColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/FullWidthCarousel/FullWidthCarousel__Theme.bs.js
var FullWidthCarousel_Theme_bs = __webpack_require__(18178);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/CustomerCareBanner/CustomerCareBanner__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function CustomerCareBanner_Theme_bs_t(headingColorOpt, colorOpt, backgroundColorOpt, param) {
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme_Color_bs/* gray800 */.pP;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* gray600 */.RA;
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme_Color_bs/* lilac400 */._b;
    return {
        headingColor: headingColor,
        color: color,
        backgroundColor: backgroundColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/CustomerCareCallUs/CustomerCareCallUs__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function CustomerCareCallUs_Theme_bs_t(backgroundColorOpt, headingColorOpt, colorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme_Color_bs/* purple500 */.lh;
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme_Color_bs/* white */.ix;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* white */.ix;
    return {
        backgroundColor: backgroundColor,
        headingColor: headingColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/DownloadAppsBanner/DownloadAppsBanner__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function DownloadAppsBanner_Theme_bs_t(backgroundColorOpt, headingColorOpt, colorOpt, blockBackgroundColorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme_Color_bs/* lilac400 */._b;
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : Theme_Color_bs/* gray800 */.pP;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* gray600 */.RA;
    var blockBackgroundColor = blockBackgroundColorOpt !== undefined ? blockBackgroundColorOpt : Theme_Color_bs/* lilac100 */.ry;
    return {
        backgroundColor: backgroundColor,
        headingColor: headingColor,
        color: color,
        blockBackgroundColor: blockBackgroundColor
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/common/UniqueSellingPoints/UniqueSellingPoints__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
function UniqueSellingPoints_Theme_bs_t(headingColorOpt, colorOpt, iconColorOpt, param) {
    var headingColor = headingColorOpt !== undefined ? headingColorOpt : {
        NAME: "hex",
        VAL: "1E1E1E"
    };
    var color = colorOpt !== undefined ? colorOpt : {
        NAME: "hex",
        VAL: "4B4B4B"
    };
    var iconColor = iconColorOpt !== undefined ? iconColorOpt : {
        NAME: "hex",
        VAL: "48096C"
    };
    return {
        headingColor: headingColor,
        color: color,
        iconColor: iconColor
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@prezzee/ribbon/src/components/common/VideoTextPromoBlock/VideoTextPromoBlock__Theme.bs.js
var VideoTextPromoBlock_Theme_bs = __webpack_require__(15628);
;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/components/personal/RegionIndicator/RegionIndicatorStrip__Theme.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function RegionIndicatorStrip_Theme_bs_t(backgroundColorOpt, colorOpt, param) {
    var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme_Color_bs/* purple700 */.$9;
    var color = colorOpt !== undefined ? colorOpt : Theme_Color_bs/* white */.ix;
    return {
        backgroundColor: backgroundColor,
        color: color
    };
}
 /* Theme__Color-PrezzeeRibbon Not a pure module */ 

;// CONCATENATED MODULE: ./node_modules/@prezzee/ribbon/src/context/ThemeContext/ThemeContext__Components.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



















function ThemeContext_Components_bs_t(fullWidthCarouselOpt, iconCardOpt, contentCardOpt, regionStripOpt, regionPickerOpt, tagOpt, taglineOpt, uniqueSellingPointsOpt, videoTextPromoBlockOpt, footerOpt, textFieldOpt, emailSignUpOpt, smallHeroTileOpt, largeHeroTileOpt, categoryTileOpt, downloadAppsBannerOpt, promoTilesOpt, customerCareBannerOpt, customerCareCallUsOpt, param) {
    var fullWidthCarousel = fullWidthCarouselOpt !== undefined ? fullWidthCarouselOpt : FullWidthCarousel_Theme_bs.t(undefined, undefined, undefined);
    var iconCard = iconCardOpt !== undefined ? iconCardOpt : IconCard_Theme_bs.t(undefined, undefined, undefined);
    var contentCard = contentCardOpt !== undefined ? contentCardOpt : ContentCard_Theme_bs_t(undefined, undefined, undefined);
    var regionStrip = regionStripOpt !== undefined ? regionStripOpt : RegionIndicatorStrip_Theme_bs_t(undefined, undefined, undefined);
    var regionPicker = regionPickerOpt !== undefined ? regionPickerOpt : RegionPicker_Theme_bs.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    var tag = tagOpt !== undefined ? tagOpt : Tag_Theme_bs.t(undefined, undefined, undefined);
    var tagline = taglineOpt !== undefined ? taglineOpt : Tagline_Theme_bs.t(undefined, undefined);
    var uniqueSellingPoints = uniqueSellingPointsOpt !== undefined ? uniqueSellingPointsOpt : UniqueSellingPoints_Theme_bs_t(undefined, undefined, undefined, undefined);
    var videoTextPromoBlock = videoTextPromoBlockOpt !== undefined ? videoTextPromoBlockOpt : VideoTextPromoBlock_Theme_bs.t(undefined, undefined, undefined, undefined, undefined);
    var footer = footerOpt !== undefined ? footerOpt : Footer_Theme_bs.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    var textField = textFieldOpt !== undefined ? textFieldOpt : TextField_Theme_bs.t(undefined, undefined, undefined, undefined);
    var emailSignUp = emailSignUpOpt !== undefined ? emailSignUpOpt : EmailSignUp_Theme_bs.t(undefined, undefined, undefined, undefined);
    var smallHeroTile = smallHeroTileOpt !== undefined ? smallHeroTileOpt : SmallHeroTile_Theme_bs_t(undefined, undefined, undefined);
    var largeHeroTile = largeHeroTileOpt !== undefined ? largeHeroTileOpt : LargeHeroTile_Theme_bs_t(undefined, undefined, undefined);
    var categoryTile = categoryTileOpt !== undefined ? categoryTileOpt : CategoryTiles_Theme_bs_t(undefined, undefined, undefined, undefined);
    var downloadAppsBanner = downloadAppsBannerOpt !== undefined ? downloadAppsBannerOpt : DownloadAppsBanner_Theme_bs_t(undefined, undefined, undefined, undefined, undefined);
    var promoTiles = promoTilesOpt !== undefined ? promoTilesOpt : t(undefined, undefined, undefined, undefined);
    var customerCareBanner = customerCareBannerOpt !== undefined ? customerCareBannerOpt : CustomerCareBanner_Theme_bs_t(undefined, undefined, undefined, undefined);
    var customerCareCallUs = customerCareCallUsOpt !== undefined ? customerCareCallUsOpt : CustomerCareCallUs_Theme_bs_t(undefined, undefined, undefined, undefined);
    return {
        fullWidthCarousel: fullWidthCarousel,
        iconCard: iconCard,
        contentCard: contentCard,
        regionStrip: regionStrip,
        regionPicker: regionPicker,
        tag: tag,
        tagline: tagline,
        uniqueSellingPoints: uniqueSellingPoints,
        videoTextPromoBlock: videoTextPromoBlock,
        footer: footer,
        textField: textField,
        emailSignUp: emailSignUp,
        smallHeroTile: smallHeroTile,
        largeHeroTile: largeHeroTile,
        categoryTile: categoryTile,
        downloadAppsBanner: downloadAppsBanner,
        promoTiles: promoTiles,
        customerCareBanner: customerCareBanner,
        customerCareCallUs: customerCareCallUs
    };
}
 /* Tag__Theme-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 1997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36585);
/* harmony import */ var _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17845);
/* harmony import */ var _ThemeContext_Components_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23191);
// Generated by ReScript, PLEASE EDIT WITH CARE



function t(primaryOpt, secondaryOpt, tertiaryOpt, displayFontOpt, headingFontOpt, bodyFontOpt, borderRadiusOpt, componentsOpt, param) {
    var primary = primaryOpt !== undefined ? primaryOpt : {
        default: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .red400 */ .kl,
        defaultText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix,
        hover: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .red500 */ .Zo,
        hoverText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix
    };
    var secondary = secondaryOpt !== undefined ? secondaryOpt : {
        default: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .purple400 */ .F0,
        defaultText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix,
        hover: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .purple600 */ .jq,
        hoverText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix
    };
    var tertiary = tertiaryOpt !== undefined ? tertiaryOpt : {
        default: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .gray700 */ .Xc,
        defaultText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix,
        hover: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .gray800 */ .pP,
        hoverText: _theme_Theme_Color_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .white */ .ix
    };
    var displayFont = displayFontOpt !== undefined ? displayFontOpt : [
        {
            NAME: "custom",
            VAL: "DM Serif Display"
        },
        {
            NAME: "custom",
            VAL: "sofia-pro"
        },
        "sansSerif"
    ];
    var headingFont = headingFontOpt !== undefined ? headingFontOpt : [
        {
            NAME: "custom",
            VAL: "sofia-pro"
        },
        "sansSerif"
    ];
    var bodyFont = bodyFontOpt !== undefined ? bodyFontOpt : [
        {
            NAME: "custom",
            VAL: "sofia-pro"
        },
        "sansSerif"
    ];
    var borderRadius = borderRadiusOpt !== undefined ? borderRadiusOpt : _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4);
    var components = componentsOpt !== undefined ? componentsOpt : _ThemeContext_Components_bs_js__WEBPACK_IMPORTED_MODULE_2__.t(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    return {
        primary: primary,
        secondary: secondary,
        tertiary: tertiary,
        displayFont: displayFont,
        headingFont: headingFont,
        bodyFont: bodyFont,
        borderRadius: borderRadius,
        components: components
    };
}
 /* BsCssJs-PrezzeeRibbon Not a pure module */ 


/***/ }),

/***/ 78029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ extraSlow; },
/* harmony export */   "Yu": function() { return /* binding */ slow; },
/* harmony export */   "oN": function() { return /* binding */ regular; },
/* harmony export */   "q3": function() { return /* binding */ fast; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
var fast = 80;
var regular = 150;
var slow = 300;
var extraSlow = 2500;
 /* No side effect */ 


/***/ }),

/***/ 17845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ purple700; },
/* harmony export */   "Ep": function() { return /* binding */ purple50; },
/* harmony export */   "F0": function() { return /* binding */ purple400; },
/* harmony export */   "Gn": function() { return /* binding */ Common; },
/* harmony export */   "H5": function() { return /* binding */ accentBlue; },
/* harmony export */   "H8": function() { return /* binding */ colourToRgba; },
/* harmony export */   "ME": function() { return /* binding */ pink300; },
/* harmony export */   "RA": function() { return /* binding */ gray600; },
/* harmony export */   "RL": function() { return /* binding */ Personal; },
/* harmony export */   "Sn": function() { return /* binding */ black$1; },
/* harmony export */   "WV": function() { return /* binding */ blue50; },
/* harmony export */   "Xc": function() { return /* binding */ gray700; },
/* harmony export */   "ZM": function() { return /* binding */ blue400; },
/* harmony export */   "Zo": function() { return /* binding */ red500; },
/* harmony export */   "_b": function() { return /* binding */ lilac400; },
/* harmony export */   "d1": function() { return /* binding */ gray50; },
/* harmony export */   "de": function() { return /* binding */ gray400; },
/* harmony export */   "e": function() { return /* binding */ Business; },
/* harmony export */   "ix": function() { return /* binding */ white$1; },
/* harmony export */   "jq": function() { return /* binding */ purple600; },
/* harmony export */   "kl": function() { return /* binding */ red400; },
/* harmony export */   "lh": function() { return /* binding */ purple500; },
/* harmony export */   "lp": function() { return /* binding */ pink400; },
/* harmony export */   "pP": function() { return /* binding */ gray800; },
/* harmony export */   "ry": function() { return /* binding */ lilac100; },
/* harmony export */   "wD": function() { return /* binding */ lilac50; }
/* harmony export */ });
/* unused harmony exports purple300, purple200, purple100, red700, red600, red300, red200, red100, red50, pink700, pink600, pink500, pink200, pink100, pink50, lilac700, lilac600, lilac500, lilac300, lilac200, blue700, blue600, blue500, blue300, blue200, blue100, green700, green600, green500, green400, green300, green200, green100, green50, yellow700, yellow600, yellow500, yellow400, yellow300, yellow200, yellow100, yellow50, orange700, orange600, orange500, orange400, orange300, orange200, orange100, orange50, gray500, gray300, gray200, gray100, accentPink, accentYellow */
/* harmony import */ var bs_css_src_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48891);
/* harmony import */ var css_color_converter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20890);
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE



var black = {
    NAME: "hex",
    VAL: "000000"
};
var white = {
    NAME: "hex",
    VAL: "FFFFFF"
};
var Common_prezzeeRed = {
    NAME: "hex",
    VAL: "F93C28"
};
var Common_darkRed = {
    NAME: "hex",
    VAL: "900C20"
};
var Common_peach = {
    NAME: "hex",
    VAL: "FDF6F3"
};
var Common_tangerine = {
    NAME: "hex",
    VAL: "FF978C"
};
var Common_textSecondary = {
    NAME: "hex",
    VAL: "4B4B4B"
};
var Common_lilac400 = {
    NAME: "hex",
    VAL: "E5E2FB"
};
var Common = {
    black: black,
    white: white,
    inherit_: "currentColor",
    prezzeeRed: Common_prezzeeRed,
    darkRed: Common_darkRed,
    peach: Common_peach,
    tangerine: Common_tangerine,
    textSecondary: Common_textSecondary,
    lilac400: Common_lilac400
};
var Personal_primaryRed = {
    NAME: "hex",
    VAL: "E30B17"
};
var Personal_primaryRedHover = {
    NAME: "hex",
    VAL: "A70A13"
};
var Personal_primaryRedPaleBg = {
    NAME: "hex",
    VAL: "FCE7E8"
};
var Personal_primaryActive = {
    NAME: "hex",
    VAL: "1E2530"
};
var Personal_primaryDisabled = {
    NAME: "hex",
    VAL: "AAB6CA"
};
var Personal_primaryDisabledText = {
    NAME: "hex",
    VAL: "4c5d79"
};
var Personal_whiteHover = {
    NAME: "hex",
    VAL: "E7E7E9"
};
var Personal_darkGrey = {
    NAME: "hex",
    VAL: "444444"
};
var Personal_divider = {
    NAME: "hex",
    VAL: "E9E9E9"
};
var Personal_errorText = {
    NAME: "hex",
    VAL: "87202F"
};
var Personal_activeBlue = {
    NAME: "hex",
    VAL: "3E77B0"
};
var Personal_activeBluePaleBg = {
    NAME: "hex",
    VAL: "ECF1F7"
};
var Personal_charcoal = {
    NAME: "hex",
    VAL: "313E49"
};
var Personal_charcoalHover = {
    NAME: "hex",
    VAL: "20282F"
};
var Personal_darkCharcoal = {
    NAME: "hex",
    VAL: "28323B"
};
var Personal_midGrey = {
    NAME: "hex",
    VAL: "767676"
};
var Personal_lightGrey = {
    NAME: "hex",
    VAL: "A9AAA9"
};
var Personal_lightGreyBackground = {
    NAME: "hex",
    VAL: "ECF2F6"
};
var Personal_paleGrey = {
    NAME: "hex",
    VAL: "F8F8F8"
};
var Personal_paleGreyBackground = {
    NAME: "hex",
    VAL: "E8EEEF"
};
var Personal_lightBlueBackground = {
    NAME: "hex",
    VAL: "F7FBFE"
};
var Personal_paleDivider = {
    NAME: "hex",
    VAL: "EFEFEF"
};
var Personal_green = {
    NAME: "hex",
    VAL: "25AE88"
};
var Personal_orange = {
    NAME: "hex",
    VAL: "DC5800"
};
var Personal_yellow = {
    NAME: "hex",
    VAL: "FAA731"
};
var Personal_yellowPaleBg = {
    NAME: "hex",
    VAL: "FEF7EB"
};
var Personal_orangeBrown = {
    NAME: "hex",
    VAL: "DD5F0A"
};
var Personal_orangeBrownPaleBg = {
    NAME: "hex",
    VAL: "FBEEE6"
};
var Personal_blueIcon = {
    NAME: "hex",
    VAL: "6DB6FF"
};
var Personal_whiteFilledButtonText = {
    NAME: "hex",
    VAL: "33333A"
};
var Personal_darkFieldText = {
    NAME: "hex",
    VAL: "DEDEDE"
};
var Personal_footerDarkBackground = {
    NAME: "hex",
    VAL: "273139"
};
var Personal_mobileHeroBackground = {
    NAME: "hex",
    VAL: "ECF1F6"
};
var Personal_mobilePersonalizeGradient = {
    NAME: "hex",
    VAL: "F6F9FC"
};
var Personal_yetAnotherLightGrey = {
    NAME: "hex",
    VAL: "E7EEF1"
};
var Personal_pureRed = {
    NAME: "hex",
    VAL: "FF0000"
};
var Personal_skyBlue = {
    NAME: "hex",
    VAL: "F6F9FC"
};
var Personal_anchorBlue = {
    NAME: "hex",
    VAL: "2877B5"
};
var Personal = {
    black: black,
    white: white,
    primaryRed: Personal_primaryRed,
    primaryRedHover: Personal_primaryRedHover,
    primaryRedPaleBg: Personal_primaryRedPaleBg,
    primaryActive: Personal_primaryActive,
    primaryDisabled: Personal_primaryDisabled,
    primaryDisabledText: Personal_primaryDisabledText,
    whiteHover: Personal_whiteHover,
    darkGrey: Personal_darkGrey,
    divider: Personal_divider,
    errorText: Personal_errorText,
    activeBlue: Personal_activeBlue,
    activeBluePaleBg: Personal_activeBluePaleBg,
    charcoal: Personal_charcoal,
    charcoalHover: Personal_charcoalHover,
    darkCharcoal: Personal_darkCharcoal,
    midGrey: Personal_midGrey,
    lightGrey: Personal_lightGrey,
    lightGreyBackground: Personal_lightGreyBackground,
    paleGrey: Personal_paleGrey,
    paleGreyBackground: Personal_paleGreyBackground,
    lightBlueBackground: Personal_lightBlueBackground,
    paleDivider: Personal_paleDivider,
    green: Personal_green,
    orange: Personal_orange,
    yellow: Personal_yellow,
    yellowPaleBg: Personal_yellowPaleBg,
    orangeBrown: Personal_orangeBrown,
    orangeBrownPaleBg: Personal_orangeBrownPaleBg,
    blueIcon: Personal_blueIcon,
    whiteFilledButtonText: Personal_whiteFilledButtonText,
    darkFieldText: Personal_darkFieldText,
    footerDarkBackground: Personal_footerDarkBackground,
    mobileHeroBackground: Personal_mobileHeroBackground,
    mobilePersonalizeGradient: Personal_mobilePersonalizeGradient,
    yetAnotherLightGrey: Personal_yetAnotherLightGrey,
    pureRed: Personal_pureRed,
    skyBlue: Personal_skyBlue,
    anchorBlue: Personal_anchorBlue
};
var Business_primary = {
    NAME: "hex",
    VAL: "2D9CDB"
};
var Business_secondary = {
    NAME: "hex",
    VAL: "263557"
};
var Business_primaryBlue = {
    NAME: "hex",
    VAL: "55B6EA"
};
var Business_offWhite = {
    NAME: "hex",
    VAL: "E7EAEE"
};
var Business_cream = {
    NAME: "hex",
    VAL: "FCEFE8"
};
var Business_navy = {
    NAME: "hex",
    VAL: "1D263A"
};
var Business_darkPurple = {
    NAME: "hex",
    VAL: "2B0840"
};
var Business_midPurple = {
    NAME: "hex",
    VAL: "3D085C"
};
var Business_prezzeePurple = {
    NAME: "hex",
    VAL: "48096C"
};
var Business_charcoal = {
    NAME: "hex",
    VAL: "1E1E1E"
};
var Business_stone = {
    NAME: "hex",
    VAL: "F2F1F2"
};
var Business_bodyTextGrey = {
    NAME: "hex",
    VAL: "515151"
};
var Business_spaceGrey = {
    NAME: "hex",
    VAL: "787878"
};
var Business_veryLightGrey = {
    NAME: "hex",
    VAL: "FCFCFD"
};
var Business_shadowGrey = {
    NAME: "hex",
    VAL: "A0A0A0"
};
var Business = {
    black: black,
    white: white,
    primary: Business_primary,
    secondary: Business_secondary,
    primaryBlue: Business_primaryBlue,
    offWhite: Business_offWhite,
    cream: Business_cream,
    navy: Business_navy,
    darkPurple: Business_darkPurple,
    midPurple: Business_midPurple,
    prezzeePurple: Business_prezzeePurple,
    charcoal: Business_charcoal,
    stone: Business_stone,
    bodyTextGrey: Business_bodyTextGrey,
    spaceGrey: Business_spaceGrey,
    veryLightGrey: Business_veryLightGrey,
    shadowGrey: Business_shadowGrey
};
function colourToRgba(c, alpha) {
    var match = css_color_converter__WEBPACK_IMPORTED_MODULE_1__/* .fromString */ .mL(bs_css_src_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(c)).toRgbaArray();
    return _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .rgba */ .m4f(match[0], match[1], match[2], {
        NAME: "num",
        VAL: alpha
    });
}
var purple700 = {
    NAME: "hex",
    VAL: "2B0840"
};
var purple600 = {
    NAME: "hex",
    VAL: "32064C"
};
var purple500 = {
    NAME: "hex",
    VAL: "410861"
};
var purple400 = {
    NAME: "hex",
    VAL: "48096C"
};
var purple300 = {
    NAME: "hex",
    VAL: "6D3A89"
};
var purple200 = {
    NAME: "hex",
    VAL: "916BA7"
};
var purple100 = {
    NAME: "hex",
    VAL: "DACEE2"
};
var purple50 = {
    NAME: "hex",
    VAL: "EDE6F0"
};
var red700 = {
    NAME: "hex",
    VAL: "480610"
};
var red600 = {
    NAME: "hex",
    VAL: "900C20"
};
var red500 = {
    NAME: "hex",
    VAL: "BE1807"
};
var red400 = {
    NAME: "hex",
    VAL: "ED1E09"
};
var red300 = {
    NAME: "hex",
    VAL: "F1453A"
};
var red200 = {
    NAME: "hex",
    VAL: "F4736B"
};
var red100 = {
    NAME: "hex",
    VAL: "FABCB5"
};
var red50 = {
    NAME: "hex",
    VAL: "FDE9E6"
};
var pink700 = {
    NAME: "hex",
    VAL: "CC7970"
};
var pink600 = {
    NAME: "hex",
    VAL: "FF978C"
};
var pink500 = {
    NAME: "hex",
    VAL: "FFB6AF"
};
var pink400 = {
    NAME: "hex",
    VAL: "FFD2BD"
};
var pink300 = {
    NAME: "hex",
    VAL: "FFE0D1"
};
var pink200 = {
    NAME: "hex",
    VAL: "FFE9DE"
};
var pink100 = {
    NAME: "hex",
    VAL: "FFF6F2"
};
var pink50 = {
    NAME: "hex",
    VAL: "FFFBF8"
};
var lilac700 = {
    NAME: "hex",
    VAL: "A09EB0"
};
var lilac600 = {
    NAME: "hex",
    VAL: "B7B5C9"
};
var lilac500 = {
    NAME: "hex",
    VAL: "CECBE2"
};
var lilac400 = {
    NAME: "hex",
    VAL: "E5E2FB"
};
var lilac300 = {
    NAME: "hex",
    VAL: "EAE8FC"
};
var lilac200 = {
    NAME: "hex",
    VAL: "EDEBFC7"
};
var lilac100 = {
    NAME: "hex",
    VAL: "F7F5FD"
};
var lilac50 = {
    NAME: "hex",
    VAL: "F6F7F9"
};
var blue700 = {
    NAME: "hex",
    VAL: "102C60"
};
var blue600 = {
    NAME: "hex",
    VAL: "174291"
};
var blue500 = {
    NAME: "hex",
    VAL: "1E54B7"
};
var blue400 = {
    NAME: "hex",
    VAL: "276EF1"
};
var blue300 = {
    NAME: "hex",
    VAL: "5B91F5"
};
var blue200 = {
    NAME: "hex",
    VAL: "A0BFF8"
};
var blue100 = {
    NAME: "hex",
    VAL: "D4E2FC"
};
var blue50 = {
    NAME: "hex",
    VAL: "EFF3FE"
};
var green700 = {
    NAME: "hex",
    VAL: "0B3429"
};
var green600 = {
    NAME: "hex",
    VAL: "166852"
};
var green500 = {
    NAME: "hex",
    VAL: "1E8B6D"
};
var green400 = {
    NAME: "hex",
    VAL: "25AE88"
};
var green300 = {
    NAME: "hex",
    VAL: "51BEA0"
};
var green200 = {
    NAME: "hex",
    VAL: "7CCEB8"
};
var green100 = {
    NAME: "hex",
    VAL: "A8DFCF"
};
var green50 = {
    NAME: "hex",
    VAL: "E9F7F3"
};
var yellow700 = {
    NAME: "hex",
    VAL: "806022"
};
var yellow600 = {
    NAME: "hex",
    VAL: "B3862F"
};
var yellow500 = {
    NAME: "hex",
    VAL: "CC9A36"
};
var yellow400 = {
    NAME: "hex",
    VAL: "FFC043"
};
var yellow300 = {
    NAME: "hex",
    VAL: "FFCF70"
};
var yellow200 = {
    NAME: "hex",
    VAL: "FFE3AC"
};
var yellow100 = {
    NAME: "hex",
    VAL: "FFF2D9"
};
var yellow50 = {
    NAME: "hex",
    VAL: "FFFAF0"
};
var orange700 = {
    NAME: "hex",
    VAL: "7D2714"
};
var orange600 = {
    NAME: "hex",
    VAL: "AE371C"
};
var orange500 = {
    NAME: "hex",
    VAL: "CC492C"
};
var orange400 = {
    NAME: "hex",
    VAL: "FF6937"
};
var orange300 = {
    NAME: "hex",
    VAL: "FA9269"
};
var orange200 = {
    NAME: "hex",
    VAL: "FABDA5"
};
var orange100 = {
    NAME: "hex",
    VAL: "FFE1D6"
};
var orange50 = {
    NAME: "hex",
    VAL: "FFF3EF"
};
var black$1 = {
    NAME: "hex",
    VAL: "000000"
};
var gray800 = {
    NAME: "hex",
    VAL: "1E1E1E"
};
var gray700 = {
    NAME: "hex",
    VAL: "302F2F"
};
var gray600 = {
    NAME: "hex",
    VAL: "4B4B4B"
};
var gray500 = {
    NAME: "hex",
    VAL: "787878"
};
var gray400 = {
    NAME: "hex",
    VAL: "A0A0A0"
};
var gray300 = {
    NAME: "hex",
    VAL: "C7C3C3"
};
var gray200 = {
    NAME: "hex",
    VAL: "E0DEDE"
};
var gray100 = {
    NAME: "hex",
    VAL: "F0EDED"
};
var gray50 = {
    NAME: "hex",
    VAL: "F8F8F8"
};
var white$1 = {
    NAME: "hex",
    VAL: "FFFFFF"
};
var accentPink = {
    NAME: "hex",
    VAL: "FFC5EE"
};
var accentYellow = {
    NAME: "hex",
    VAL: "F9FF4E"
};
var accentBlue = {
    NAME: "hex",
    VAL: "88FDFF"
};
 /* css-color-converter Not a pure module */ 


/***/ }),

/***/ 1476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ SofiaPro; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE

var family = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontFamilies */ .VlP([
    {
        NAME: "custom",
        VAL: "sofia-pro"
    },
    "sansSerif"
]);
var SofiaPro = {
    family: family
};
 /* family Not a pure module */ 


/***/ }),

/***/ 51222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Personal; },
/* harmony export */   "e": function() { return /* binding */ Business; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36585);
// Generated by ReScript, PLEASE EDIT WITH CARE

var borderRadius = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(10);
var Personal = {
    borderRadius: borderRadius
};
var borderRadius$1 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(4);
var Business = {
    borderRadius: borderRadius$1
};
 /* borderRadius Not a pure module */ 


/***/ }),

/***/ 70965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ mediaMin; },
/* harmony export */   "FV": function() { return /* binding */ tabletSm; },
/* harmony export */   "HH": function() { return /* binding */ smallScreenOrMobile; },
/* harmony export */   "Il": function() { return /* binding */ mobileBreakpoint; },
/* harmony export */   "KM": function() { return /* binding */ CategoryTiles; },
/* harmony export */   "Ku": function() { return /* binding */ tabletSmOrTablet; },
/* harmony export */   "M6": function() { return /* binding */ largeScreen; },
/* harmony export */   "Mq": function() { return /* binding */ tablet; },
/* harmony export */   "Qm": function() { return /* binding */ mobileUp; },
/* harmony export */   "Qo": function() { return /* binding */ belowLargeScreen; },
/* harmony export */   "Rf": function() { return /* binding */ largeScreenBreakpoint; },
/* harmony export */   "Uv": function() { return /* binding */ tabletSmUp; },
/* harmony export */   "ab": function() { return /* binding */ tabletOrDesktop; },
/* harmony export */   "ae": function() { return /* binding */ mediaRange; },
/* harmony export */   "ai": function() { return /* binding */ mobile; },
/* harmony export */   "gv": function() { return /* binding */ desktop; },
/* harmony export */   "j9": function() { return /* binding */ smallScreenBreakpoint; },
/* harmony export */   "k$": function() { return /* binding */ tabletOrMobile; },
/* harmony export */   "mE": function() { return /* binding */ tabletSmBreakpoint; },
/* harmony export */   "ub": function() { return /* binding */ tabletBreakpoint; },
/* harmony export */   "w4": function() { return /* binding */ mediaMax; },
/* harmony export */   "xC": function() { return /* binding */ smallScreen; },
/* harmony export */   "xT": function() { return /* binding */ mediaMaxHeight; }
/* harmony export */ });
/* unused harmony exports mediaMinHeight, mediaOr, mobileOrTabletSm, tabletToLargeScreen */
// Generated by ReScript, PLEASE EDIT WITH CARE
function mediaMax(bound) {
    return "(max-width: " + String(bound - 1 | 0) + "px)";
}
function mediaMin(bound) {
    return "(min-width: " + String(bound) + "px)";
}
function mediaRange(bound1, bound2) {
    var mx = bound1 > bound2 ? bound1 : bound2;
    var mn = bound1 < bound2 ? bound1 : bound2;
    return "" + mediaMax(mx) + " and " + mediaMin(mn) + "";
}
function mediaMaxHeight(bound) {
    return "(max-height: " + String(bound - 1 | 0) + "px)";
}
function mediaMinHeight(bound) {
    return "(max-height: " + String(bound - 1 | 0) + "px)";
}
function mediaOr(range1, range2) {
    return "" + range1 + ", " + range2 + "";
}
var mobile = mediaMax(425);
var mobileUp = mediaMin(425);
var tabletSm = mediaMax(690);
var tabletSmUp = mediaMin(690);
var mobileOrTabletSm = mediaRange(425, 690);
var tabletSmOrTablet = mediaRange(690, 1024);
var tabletOrDesktop = mediaMin(425);
var tablet = mediaRange(425, 1024);
var desktop = mediaMin(1024);
var tabletOrMobile = mediaMax(1024);
var smallScreen = mediaRange(425, 768);
var smallScreenOrMobile = mediaMax(768);
var largeScreen = mediaMin(1288);
var belowLargeScreen = mediaMax(1288);
var tabletToLargeScreen = mediaRange(425, 1288);
var mobile$1 = mediaMax(690);
var tabletOrDesktop$1 = mediaMin(690);
var tablet$1 = mediaRange(690, 1288);
var desktop$1 = mediaMin(1288);
var tabletOrMobile$1 = mediaMax(1288);
var CategoryTiles = {
    mobileBreakpoint: 690,
    mobile: mobile$1,
    tabletOrDesktop: tabletOrDesktop$1,
    tablet: tablet$1,
    desktop: desktop$1,
    tabletOrMobile: tabletOrMobile$1
};
var mobileBreakpoint = 425;
var tabletSmBreakpoint = 690;
var smallScreenBreakpoint = 768;
var tabletBreakpoint = 1024;
var largeScreenBreakpoint = 1288;
 /* mobile Not a pure module */ 


/***/ }),

/***/ 32567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Styles; }
/* harmony export */ });
/* harmony import */ var _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36585);
/* harmony import */ var _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1476);
// Generated by ReScript, PLEASE EDIT WITH CARE


var style1_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(56)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("bold")
];
var style1 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style1_);
var style2_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(40)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("bold")
];
var style2 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style2_);
var style3_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(32)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("medium")
];
var style3 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style3_);
var style4_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("medium")
];
var style4 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style4_);
var style5_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(18)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var style5 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style5_);
var style5Btn_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(18)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var style5Btn = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style5Btn_);
var style6_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(14)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var style6 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style6_);
var style7_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(12)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(20)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var style7 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(style7_);
var h1_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.5)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(50)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var h1 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h1_);
var h2_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(2.0)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(42)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("bold")
];
var h2 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h2_);
var h3_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.5)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(34)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var h3 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h3_);
var h4_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.375)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(30)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var h4 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h4_);
var h5_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.25)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var h5 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h5_);
var h6_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(1.125)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(28)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("semiBold")
];
var h6 = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(h6_);
var body_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(16)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(24)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var body = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(body_);
var smallBody_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.875)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(22)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var smallBody = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(smallBody_);
var tiny_ = [
    _Theme_Fonts_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .SofiaPro.family */ .t.family,
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontSize */ .JBY(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .rem */ .hOB(0.75)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .lineHeight */ .Nv8(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__.px(18)),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .margin */ .e6$(_bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .zero */ .bMI),
    _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .fontWeight */ .Ue2("normal")
];
var tiny = _bindings_BsCss_BsCssJs_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .style */ .oBv(tiny_);
var Styles = {
    style1_: style1_,
    style1: style1,
    style2_: style2_,
    style2: style2,
    style3_: style3_,
    style3: style3,
    style4_: style4_,
    style4: style4,
    style5_: style5_,
    style5: style5,
    style5Btn_: style5Btn_,
    style5Btn: style5Btn,
    style6_: style6_,
    style6: style6,
    style7_: style7_,
    style7: style7,
    h1_: h1_,
    h1: h1,
    h2_: h2_,
    h2: h2,
    h3_: h3_,
    h3: h3,
    h4_: h4_,
    h4: h4,
    h5_: h5_,
    h5: h5,
    h6_: h6_,
    h6: h6,
    body_: body_,
    body: body,
    smallBody_: smallBody_,
    smallBody: smallBody,
    tiny_: tiny_,
    tiny: tiny
};
 /* style1_ Not a pure module */ 


/***/ }),

/***/ 74594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ mem; },
/* harmony export */   "R3": function() { return /* binding */ append; },
/* harmony export */   "UI": function() { return /* binding */ map; }
/* harmony export */ });
/* unused harmony exports make_float, init, make_matrix, create_matrix, concat, sub, copy, fill, blit, to_list, of_list, iter, iteri, mapi, fold_left, fold_right, iter2, map2, for_all, exists, memq, sort, stable_sort, fast_sort, Floatarray */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92592);
/* harmony import */ var _caml_obj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84445);
/* harmony import */ var _caml_array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46150);
/* harmony import */ var _caml_exceptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86592);
/* harmony import */ var _caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37082);





var make_float = _caml_array_js__WEBPACK_IMPORTED_MODULE_2__/* .make_float */ .wC;
var Floatarray = {};
function init(l, f) {
    if (l === 0) {
        return [];
    }
    if (l < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.init",
            Error: new Error()
        };
    }
    var res = Caml_array.make(l, Curry._1(f, 0));
    for(var i = 1; i < l; ++i){
        res[i] = Curry._1(f, i);
    }
    return res;
}
function make_matrix(sx, sy, init) {
    var res = Caml_array.make(sx, []);
    for(var x = 0; x < sx; ++x){
        res[x] = Caml_array.make(sy, init);
    }
    return res;
}
function copy(a) {
    var l = a.length;
    if (l === 0) {
        return [];
    } else {
        return _caml_array_js__WEBPACK_IMPORTED_MODULE_2__/* .sub */ .lu(a, 0, l);
    }
}
function append(a1, a2) {
    var l1 = a1.length;
    if (l1 === 0) {
        return copy(a2);
    } else if (a2.length === 0) {
        return _caml_array_js__WEBPACK_IMPORTED_MODULE_2__/* .sub */ .lu(a1, 0, l1);
    } else {
        return a1.concat(a2);
    }
}
function sub(a, ofs, len) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.sub",
            Error: new Error()
        };
    }
    return Caml_array.sub(a, ofs, len);
}
function fill(a, ofs, len, v) {
    if (ofs < 0 || len < 0 || ofs > (a.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.fill",
            Error: new Error()
        };
    }
    for(var i = ofs, i_finish = ofs + len | 0; i < i_finish; ++i){
        a[i] = v;
    }
}
function blit(a1, ofs1, a2, ofs2, len) {
    if (len < 0 || ofs1 < 0 || ofs1 > (a1.length - len | 0) || ofs2 < 0 || ofs2 > (a2.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.blit",
            Error: new Error()
        };
    }
    Caml_array.blit(a1, ofs1, a2, ofs2, len);
}
function iter(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        Curry._1(f, a[i]);
    }
}
function iter2(f, a, b) {
    if (a.length !== b.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.iter2: arrays must have the same length",
            Error: new Error()
        };
    }
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        Curry._2(f, a[i], b[i]);
    }
}
function map(f, a) {
    var l = a.length;
    if (l === 0) {
        return [];
    }
    var r = _caml_array_js__WEBPACK_IMPORTED_MODULE_2__/* .make */ .Sy(l, _curry_js__WEBPACK_IMPORTED_MODULE_3__._1(f, a[0]));
    for(var i = 1; i < l; ++i){
        r[i] = _curry_js__WEBPACK_IMPORTED_MODULE_3__._1(f, a[i]);
    }
    return r;
}
function map2(f, a, b) {
    var la = a.length;
    var lb = b.length;
    if (la !== lb) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Array.map2: arrays must have the same length",
            Error: new Error()
        };
    }
    if (la === 0) {
        return [];
    }
    var r = Caml_array.make(la, Curry._2(f, a[0], b[0]));
    for(var i = 1; i < la; ++i){
        r[i] = Curry._2(f, a[i], b[i]);
    }
    return r;
}
function iteri(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        Curry._2(f, i, a[i]);
    }
}
function mapi(f, a) {
    var l = a.length;
    if (l === 0) {
        return [];
    }
    var r = Caml_array.make(l, Curry._2(f, 0, a[0]));
    for(var i = 1; i < l; ++i){
        r[i] = Curry._2(f, i, a[i]);
    }
    return r;
}
function to_list(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) {
            return res;
        }
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function list_length(_accu, _param) {
    while(true){
        var param = _param;
        var accu = _accu;
        if (!param) {
            return accu;
        }
        _param = param.tl;
        _accu = accu + 1 | 0;
        continue;
    }
    ;
}
function of_list(l) {
    if (!l) {
        return [];
    }
    var a = Caml_array.make(list_length(0, l), l.hd);
    var _i = 1;
    var _param = l.tl;
    while(true){
        var param = _param;
        var i = _i;
        if (!param) {
            return a;
        }
        a[i] = param.hd;
        _param = param.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function fold_left(f, x, a) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        r = Curry._2(f, r, a[i]);
    }
    return r;
}
function fold_right(f, a, x) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i){
        r = Curry._2(f, a[i], r);
    }
    return r;
}
function exists(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) {
            return false;
        }
        if (Curry._1(p, a[i])) {
            return true;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function for_all(p, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) {
            return true;
        }
        if (!Curry._1(p, a[i])) {
            return false;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function mem(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) {
            return false;
        }
        if (_caml_obj_js__WEBPACK_IMPORTED_MODULE_4__/* .equal */ .Dg(a[i], x)) {
            return true;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function memq(x, a) {
    var n = a.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === n) {
            return false;
        }
        if (x === a[i]) {
            return true;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
var Bottom = /* @__PURE__ */ (/* unused pure expression or super */ null && (Caml_exceptions.create("Array.Bottom")));
function sort(cmp, a) {
    var maxson = function maxson(l, i) {
        var i31 = ((i + i | 0) + i | 0) + 1 | 0;
        var x = i31;
        if ((i31 + 2 | 0) < l) {
            if (Curry._2(cmp, Caml_array.get(a, i31), Caml_array.get(a, i31 + 1 | 0)) < 0) {
                x = i31 + 1 | 0;
            }
            if (Curry._2(cmp, Caml_array.get(a, x), Caml_array.get(a, i31 + 2 | 0)) < 0) {
                x = i31 + 2 | 0;
            }
            return x;
        }
        if ((i31 + 1 | 0) < l && Curry._2(cmp, Caml_array.get(a, i31), Caml_array.get(a, i31 + 1 | 0)) < 0) {
            return i31 + 1 | 0;
        }
        if (i31 < l) {
            return i31;
        }
        throw {
            RE_EXN_ID: Bottom,
            _1: i,
            Error: new Error()
        };
    };
    var trickle = function trickle(l, i, e) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                if (Curry._2(cmp, Caml_array.get(a, j), e) <= 0) {
                    return Caml_array.set(a, i$1, e);
                }
                Caml_array.set(a, i$1, Caml_array.get(a, j));
                _i = j;
                continue;
            }
            ;
        } catch (raw_i) {
            var i$2 = Caml_js_exceptions.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === Bottom) {
                return Caml_array.set(a, i$2._1, e);
            }
            throw i$2;
        }
    };
    var bubble = function bubble(l, i) {
        try {
            var _i = i;
            while(true){
                var i$1 = _i;
                var j = maxson(l, i$1);
                Caml_array.set(a, i$1, Caml_array.get(a, j));
                _i = j;
                continue;
            }
            ;
        } catch (raw_i) {
            var i$2 = Caml_js_exceptions.internalToOCamlException(raw_i);
            if (i$2.RE_EXN_ID === Bottom) {
                return i$2._1;
            }
            throw i$2;
        }
    };
    var trickleup = function trickleup(_i, e) {
        while(true){
            var i = _i;
            var father = (i - 1 | 0) / 3 | 0;
            if (i === father) {
                throw {
                    RE_EXN_ID: "Assert_failure",
                    _1: [
                        "array.ml",
                        236,
                        4
                    ],
                    Error: new Error()
                };
            }
            if (Curry._2(cmp, Caml_array.get(a, father), e) >= 0) {
                return Caml_array.set(a, i, e);
            }
            Caml_array.set(a, i, Caml_array.get(a, father));
            if (father <= 0) {
                return Caml_array.set(a, 0, e);
            }
            _i = father;
            continue;
        }
        ;
    };
    var l = a.length;
    for(var i = ((l + 1 | 0) / 3 | 0) - 1 | 0; i >= 0; --i){
        trickle(l, i, Caml_array.get(a, i));
    }
    for(var i$1 = l - 1 | 0; i$1 >= 2; --i$1){
        var e = Caml_array.get(a, i$1);
        Caml_array.set(a, i$1, Caml_array.get(a, 0));
        trickleup(bubble(i$1, 0), e);
    }
    if (l <= 1) {
        return;
    }
    var e$1 = Caml_array.get(a, 1);
    Caml_array.set(a, 1, Caml_array.get(a, 0));
    Caml_array.set(a, 0, e$1);
}
function stable_sort(cmp, a) {
    var merge = function merge(src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs) {
        var src1r = src1ofs + src1len | 0;
        var src2r = src2ofs + src2len | 0;
        var _i1 = src1ofs;
        var _s1 = Caml_array.get(a, src1ofs);
        var _i2 = src2ofs;
        var _s2 = Caml_array.get(src2, src2ofs);
        var _d = dstofs;
        while(true){
            var d = _d;
            var s2 = _s2;
            var i2 = _i2;
            var s1 = _s1;
            var i1 = _i1;
            if (Curry._2(cmp, s1, s2) <= 0) {
                Caml_array.set(dst, d, s1);
                var i1$1 = i1 + 1 | 0;
                if (i1$1 >= src1r) {
                    return blit(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
                }
                _d = d + 1 | 0;
                _s1 = Caml_array.get(a, i1$1);
                _i1 = i1$1;
                continue;
            }
            Caml_array.set(dst, d, s2);
            var i2$1 = i2 + 1 | 0;
            if (i2$1 >= src2r) {
                return blit(a, i1, dst, d + 1 | 0, src1r - i1 | 0);
            }
            _d = d + 1 | 0;
            _s2 = Caml_array.get(src2, i2$1);
            _i2 = i2$1;
            continue;
        }
        ;
    };
    var isortto = function isortto(srcofs, dst, dstofs, len) {
        for(var i = 0; i < len; ++i){
            var e = Caml_array.get(a, srcofs + i | 0);
            var j = (dstofs + i | 0) - 1 | 0;
            while(j >= dstofs && Curry._2(cmp, Caml_array.get(dst, j), e) > 0){
                Caml_array.set(dst, j + 1 | 0, Caml_array.get(dst, j));
                j = j - 1 | 0;
            }
            ;
            Caml_array.set(dst, j + 1 | 0, e);
        }
    };
    var sortto = function(srcofs, dst, dstofs, len) {
        if (len <= 5) {
            return isortto(srcofs, dst, dstofs, len);
        }
        var l1 = len / 2 | 0;
        var l2 = len - l1 | 0;
        sortto(srcofs + l1 | 0, dst, dstofs + l1 | 0, l2);
        sortto(srcofs, a, srcofs + l2 | 0, l1);
        merge(srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs);
    };
    var l = a.length;
    if (l <= 5) {
        return isortto(0, a, 0, l);
    }
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = Caml_array.make(l2, Caml_array.get(a, 0));
    sortto(l1, t, 0, l2);
    sortto(0, a, l2, l1);
    merge(l2, l1, t, 0, l2, a, 0);
}
var create_matrix = (/* unused pure expression or super */ null && (make_matrix));
var concat = _caml_array_js__WEBPACK_IMPORTED_MODULE_2__/* .concat */ .zo;
var fast_sort = (/* unused pure expression or super */ null && (stable_sort));
 /* No side effect */ 


/***/ }),

/***/ 96533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ keep; },
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "ID": function() { return /* binding */ concatMany; },
/* harmony export */   "KB": function() { return /* binding */ makeBy; },
/* harmony export */   "KK": function() { return /* binding */ mapWithIndexU; },
/* harmony export */   "Ox": function() { return /* binding */ reduceU; },
/* harmony export */   "Su": function() { return /* binding */ mapWithIndex; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "_n": function() { return /* binding */ getIndexBy; },
/* harmony export */   "bP": function() { return /* binding */ keepMapU; },
/* harmony export */   "fe": function() { return /* binding */ keepMap; },
/* harmony export */   "gT": function() { return /* binding */ mapU; },
/* harmony export */   "i1": function() { return /* binding */ blitUnsafe; },
/* harmony export */   "iK": function() { return /* binding */ reduceWithIndexU; },
/* harmony export */   "ih": function() { return /* binding */ getBy; },
/* harmony export */   "rD": function() { return /* binding */ forEachWithIndexU; },
/* harmony export */   "tP": function() { return /* binding */ slice; },
/* harmony export */   "u4": function() { return /* binding */ reduce; },
/* harmony export */   "vX": function() { return /* binding */ joinWith; },
/* harmony export */   "w6": function() { return /* binding */ range; },
/* harmony export */   "yW": function() { return /* binding */ every; },
/* harmony export */   "zo": function() { return /* binding */ concat; }
/* harmony export */ });
/* unused harmony exports getExn, set, setExn, shuffleInPlace, shuffle, reverseInPlace, reverse, make, rangeBy, makeByU, makeByAndShuffleU, makeByAndShuffle, zip, zipByU, zipBy, unzip, sliceToEnd, fill, blit, forEachU, flatMapU, flatMap, getByU, getIndexByU, keepU, keepWithIndexU, keepWithIndex, forEachWithIndex, partitionU, partition, reduceReverseU, reduceReverse, reduceReverse2U, reduceReverse2, reduceWithIndex, joinWithU, someU, everyU, every2U, every2, some2U, some2, cmpU, cmp, eqU, eq, initU, init */
/* harmony import */ var _caml_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55658);
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);




function get(arr, i) {
    if (i >= 0 && i < arr.length) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(arr[i]);
    }
}
function getExn(arr, i) {
    if (!(i >= 0 && i < arr.length)) {
        throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
                "belt_Array.ml",
                35,
                2
            ],
            Error: new Error()
        };
    }
    return arr[i];
}
function set(arr, i, v) {
    if (i >= 0 && i < arr.length) {
        arr[i] = v;
        return true;
    } else {
        return false;
    }
}
function setExn(arr, i, v) {
    if (!(i >= 0 && i < arr.length)) {
        throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
                "belt_Array.ml",
                45,
                2
            ],
            Error: new Error()
        };
    }
    arr[i] = v;
}
function swapUnsafe(xs, i, j) {
    var tmp = xs[i];
    xs[i] = xs[j];
    xs[j] = tmp;
}
function shuffleInPlace(xs) {
    var len = xs.length;
    for(var i = 0; i < len; ++i){
        swapUnsafe(xs, i, Js_math.random_int(i, len));
    }
}
function shuffle(xs) {
    var result = xs.slice(0);
    shuffleInPlace(result);
    return result;
}
function reverseInPlace(xs) {
    var len = xs.length;
    var ofs = 0;
    for(var i = 0, i_finish = len / 2 | 0; i < i_finish; ++i){
        swapUnsafe(xs, ofs + i | 0, ((ofs + len | 0) - i | 0) - 1 | 0);
    }
}
function reverse(xs) {
    var len = xs.length;
    var result = new Array(len);
    for(var i = 0; i < len; ++i){
        result[i] = xs[(len - 1 | 0) - i | 0];
    }
    return result;
}
function make(l, f) {
    if (l <= 0) {
        return [];
    }
    var res = new Array(l);
    for(var i = 0; i < l; ++i){
        res[i] = f;
    }
    return res;
}
function makeByU(l, f) {
    if (l <= 0) {
        return [];
    }
    var res = new Array(l);
    for(var i = 0; i < l; ++i){
        res[i] = f(i);
    }
    return res;
}
function makeBy(l, f) {
    return makeByU(l, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function makeByAndShuffleU(l, f) {
    var u = makeByU(l, f);
    shuffleInPlace(u);
    return u;
}
function makeByAndShuffle(l, f) {
    return makeByAndShuffleU(l, Curry.__1(f));
}
function range(start, finish) {
    var cut = finish - start | 0;
    if (cut < 0) {
        return [];
    }
    var arr = new Array(cut + 1 | 0);
    for(var i = 0; i <= cut; ++i){
        arr[i] = start + i | 0;
    }
    return arr;
}
function rangeBy(start, finish, step) {
    var cut = finish - start | 0;
    if (cut < 0 || step <= 0) {
        return [];
    }
    var nb = (cut / step | 0) + 1 | 0;
    var arr = new Array(nb);
    var cur = start;
    for(var i = 0; i < nb; ++i){
        arr[i] = cur;
        cur = cur + step | 0;
    }
    return arr;
}
function zip(xs, ys) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i){
        s[i] = [
            xs[i],
            ys[i]
        ];
    }
    return s;
}
function zipByU(xs, ys, f) {
    var lenx = xs.length;
    var leny = ys.length;
    var len = lenx < leny ? lenx : leny;
    var s = new Array(len);
    for(var i = 0; i < len; ++i){
        s[i] = f(xs[i], ys[i]);
    }
    return s;
}
function zipBy(xs, ys, f) {
    return zipByU(xs, ys, Curry.__2(f));
}
function concat(a1, a2) {
    var l1 = a1.length;
    var l2 = a2.length;
    var a1a2 = new Array(l1 + l2 | 0);
    for(var i = 0; i < l1; ++i){
        a1a2[i] = a1[i];
    }
    for(var i$1 = 0; i$1 < l2; ++i$1){
        a1a2[l1 + i$1 | 0] = a2[i$1];
    }
    return a1a2;
}
function concatMany(arrs) {
    var lenArrs = arrs.length;
    var totalLen = 0;
    for(var i = 0; i < lenArrs; ++i){
        totalLen = totalLen + arrs[i].length | 0;
    }
    var result = new Array(totalLen);
    totalLen = 0;
    for(var j = 0; j < lenArrs; ++j){
        var cur = arrs[j];
        for(var k = 0, k_finish = cur.length; k < k_finish; ++k){
            result[totalLen] = cur[k];
            totalLen = totalLen + 1 | 0;
        }
    }
    return result;
}
function slice(a, offset, len) {
    if (len <= 0) {
        return [];
    }
    var lena = a.length;
    var ofs = offset < 0 ? _caml_js__WEBPACK_IMPORTED_MODULE_2__/* .int_max */ .ib(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var copyLength = hasLen < len ? hasLen : len;
    if (copyLength <= 0) {
        return [];
    }
    var result = new Array(copyLength);
    for(var i = 0; i < copyLength; ++i){
        result[i] = a[ofs + i | 0];
    }
    return result;
}
function sliceToEnd(a, offset) {
    var lena = a.length;
    var ofs = offset < 0 ? Caml.int_max(lena + offset | 0, 0) : offset;
    var len = lena > ofs ? lena - ofs | 0 : 0;
    var result = new Array(len);
    for(var i = 0; i < len; ++i){
        result[i] = a[ofs + i | 0];
    }
    return result;
}
function fill(a, offset, len, v) {
    if (len <= 0) {
        return;
    }
    var lena = a.length;
    var ofs = offset < 0 ? Caml.int_max(lena + offset | 0, 0) : offset;
    var hasLen = lena - ofs | 0;
    var fillLength = hasLen < len ? hasLen : len;
    if (fillLength <= 0) {
        return;
    }
    for(var i = ofs, i_finish = ofs + fillLength | 0; i < i_finish; ++i){
        a[i] = v;
    }
}
function blitUnsafe(a1, srcofs1, a2, srcofs2, blitLength) {
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j){
            a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        }
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1){
        a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
    }
}
function blit(a1, ofs1, a2, ofs2, len) {
    var lena1 = a1.length;
    var lena2 = a2.length;
    var srcofs1 = ofs1 < 0 ? Caml.int_max(lena1 + ofs1 | 0, 0) : ofs1;
    var srcofs2 = ofs2 < 0 ? Caml.int_max(lena2 + ofs2 | 0, 0) : ofs2;
    var blitLength = Caml.int_min(len, Caml.int_min(lena1 - srcofs1 | 0, lena2 - srcofs2 | 0));
    if (srcofs2 <= srcofs1) {
        for(var j = 0; j < blitLength; ++j){
            a2[j + srcofs2 | 0] = a1[j + srcofs1 | 0];
        }
        return;
    }
    for(var j$1 = blitLength - 1 | 0; j$1 >= 0; --j$1){
        a2[j$1 + srcofs2 | 0] = a1[j$1 + srcofs1 | 0];
    }
}
function forEachU(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        f(a[i]);
    }
}
function forEach(a, f) {
    forEachU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function mapU(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i){
        r[i] = f(a[i]);
    }
    return r;
}
function map(a, f) {
    return mapU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function flatMapU(a, f) {
    return concatMany(mapU(a, f));
}
function flatMap(a, f) {
    return concatMany(mapU(a, Curry.__1(f)));
}
function getByU(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) {
            r = _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(v);
        }
        i = i + 1 | 0;
    }
    ;
    return r;
}
function getBy(a, p) {
    return getByU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(p));
}
function getIndexByU(a, p) {
    var l = a.length;
    var i = 0;
    var r;
    while(r === undefined && i < l){
        var v = a[i];
        if (p(v)) {
            r = i;
        }
        i = i + 1 | 0;
    }
    ;
    return r;
}
function getIndexBy(a, p) {
    return getIndexByU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(p));
}
function keepU(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function keep(a, f) {
    return keepU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function keepWithIndexU(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        if (f(v, i)) {
            r[j] = v;
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function keepWithIndex(a, f) {
    return keepWithIndexU(a, Curry.__2(f));
}
function keepMapU(a, f) {
    var l = a.length;
    var r = new Array(l);
    var j = 0;
    for(var i = 0; i < l; ++i){
        var v = a[i];
        var v$1 = f(v);
        if (v$1 !== undefined) {
            r[j] = _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(v$1);
            j = j + 1 | 0;
        }
    }
    r.length = j;
    return r;
}
function keepMap(a, f) {
    return keepMapU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function forEachWithIndexU(a, f) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        f(i, a[i]);
    }
}
function forEachWithIndex(a, f) {
    forEachWithIndexU(a, Curry.__2(f));
}
function mapWithIndexU(a, f) {
    var l = a.length;
    var r = new Array(l);
    for(var i = 0; i < l; ++i){
        r[i] = f(i, a[i]);
    }
    return r;
}
function mapWithIndex(a, f) {
    return mapWithIndexU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__2(f));
}
function reduceU(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        r = f(r, a[i]);
    }
    return r;
}
function reduce(a, x, f) {
    return reduceU(a, x, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__2(f));
}
function reduceReverseU(a, x, f) {
    var r = x;
    for(var i = a.length - 1 | 0; i >= 0; --i){
        r = f(r, a[i]);
    }
    return r;
}
function reduceReverse(a, x, f) {
    return reduceReverseU(a, x, Curry.__2(f));
}
function reduceReverse2U(a, b, x, f) {
    var r = x;
    var len = Caml.int_min(a.length, b.length);
    for(var i = len - 1 | 0; i >= 0; --i){
        r = f(r, a[i], b[i]);
    }
    return r;
}
function reduceReverse2(a, b, x, f) {
    return reduceReverse2U(a, b, x, Curry.__3(f));
}
function reduceWithIndexU(a, x, f) {
    var r = x;
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        r = f(r, a[i], i);
    }
    return r;
}
function reduceWithIndex(a, x, f) {
    return reduceWithIndexU(a, x, Curry.__3(f));
}
function everyU(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) {
            return true;
        }
        if (!b(arr[i])) {
            return false;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function every(arr, f) {
    return everyU(arr, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function someU(arr, b) {
    var len = arr.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i === len) {
            return false;
        }
        if (b(arr[i])) {
            return true;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function some(arr, f) {
    return someU(arr, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function everyAux2(arr1, arr2, _i, b, len) {
    while(true){
        var i = _i;
        if (i === len) {
            return true;
        }
        if (!b(arr1[i], arr2[i])) {
            return false;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function every2U(a, b, p) {
    return everyAux2(a, b, 0, p, Caml.int_min(a.length, b.length));
}
function every2(a, b, p) {
    return every2U(a, b, Curry.__2(p));
}
function some2U(a, b, p) {
    var _i = 0;
    var len = Caml.int_min(a.length, b.length);
    while(true){
        var i = _i;
        if (i === len) {
            return false;
        }
        if (p(a[i], b[i])) {
            return true;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function some2(a, b, p) {
    return some2U(a, b, Curry.__2(p));
}
function eqU(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena === lenb) {
        return everyAux2(a, b, 0, p, lena);
    } else {
        return false;
    }
}
function eq(a, b, p) {
    return eqU(a, b, Curry.__2(p));
}
function cmpU(a, b, p) {
    var lena = a.length;
    var lenb = b.length;
    if (lena > lenb) {
        return 1;
    } else if (lena < lenb) {
        return -1;
    } else {
        var _i = 0;
        while(true){
            var i = _i;
            if (i === lena) {
                return 0;
            }
            var c = p(a[i], b[i]);
            if (c !== 0) {
                return c;
            }
            _i = i + 1 | 0;
            continue;
        }
        ;
    }
}
function cmp(a, b, p) {
    return cmpU(a, b, Curry.__2(p));
}
function partitionU(a, f) {
    var l = a.length;
    var i = 0;
    var j = 0;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var ii = 0; ii < l; ++ii){
        var v = a[ii];
        if (f(v)) {
            a1[i] = v;
            i = i + 1 | 0;
        } else {
            a2[j] = v;
            j = j + 1 | 0;
        }
    }
    a1.length = i;
    a2.length = j;
    return [
        a1,
        a2
    ];
}
function partition(a, f) {
    return partitionU(a, Curry.__1(f));
}
function unzip(a) {
    var l = a.length;
    var a1 = new Array(l);
    var a2 = new Array(l);
    for(var i = 0; i < l; ++i){
        var match = a[i];
        a1[i] = match[0];
        a2[i] = match[1];
    }
    return [
        a1,
        a2
    ];
}
function joinWithU(a, sep, toString) {
    var l = a.length;
    if (l === 0) {
        return "";
    }
    var lastIndex = l - 1 | 0;
    var _i = 0;
    var _res = "";
    while(true){
        var res = _res;
        var i = _i;
        if (i === lastIndex) {
            return res + toString(a[i]);
        }
        _res = res + (toString(a[i]) + sep);
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function joinWith(a, sep, toString) {
    return joinWithU(a, sep, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(toString));
}
function initU(n, f) {
    var v = new Array(n);
    for(var i = 0; i < n; ++i){
        v[i] = f(i);
    }
    return v;
}
function init(n, f) {
    return initU(n, Curry.__1(f));
}
 /* No side effect */ 


/***/ }),

/***/ 84462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cn": function() { return /* binding */ keep; },
/* harmony export */   "GY": function() { return /* binding */ reverse; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "kE": function() { return /* binding */ length; },
/* harmony export */   "qo": function() { return /* binding */ toArray; },
/* harmony export */   "u4": function() { return /* binding */ reduce; },
/* harmony export */   "zo": function() { return /* binding */ concat; }
/* harmony export */ });
/* unused harmony exports size, head, headExn, tail, tailExn, add, get, getExn, make, makeByU, makeBy, shuffle, drop, take, splitAt, concatMany, reverseConcat, flatten, mapU, zip, zipByU, zipBy, mapWithIndexU, mapWithIndex, fromArray, mapReverseU, mapReverse, forEachU, forEach, forEachWithIndexU, forEachWithIndex, reduceU, reduceWithIndexU, reduceWithIndex, reduceReverseU, reduceReverse, mapReverse2U, mapReverse2, forEach2U, forEach2, reduce2U, reduce2, reduceReverse2U, reduceReverse2, everyU, every, someU, some, every2U, every2, some2U, some2, cmpByLength, cmpU, cmp, eqU, eq, hasU, has, getByU, getBy, keepU, filter, keepWithIndexU, keepWithIndex, filterWithIndex, keepMapU, keepMap, partitionU, partition, unzip, getAssocU, getAssoc, hasAssocU, hasAssoc, removeAssocU, removeAssoc, setAssocU, setAssoc, sortU, sort */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92592);




function head(x) {
    if (x) {
        return Caml_option.some(x.hd);
    }
}
function headExn(x) {
    if (x) {
        return x.hd;
    }
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function tail(x) {
    if (x) {
        return x.tl;
    }
}
function tailExn(x) {
    if (x) {
        return x.tl;
    }
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function add(xs, x) {
    return {
        hd: x,
        tl: xs
    };
}
function get(x, n) {
    if (n < 0) {
        return;
    } else {
        var _x = x;
        var _n = n;
        while(true){
            var n$1 = _n;
            var x$1 = _x;
            if (!x$1) {
                return;
            }
            if (n$1 === 0) {
                return Caml_option.some(x$1.hd);
            }
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
        ;
    }
}
function getExn(x, n) {
    if (n < 0) {
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    var _x = x;
    var _n = n;
    while(true){
        var n$1 = _n;
        var x$1 = _x;
        if (x$1) {
            if (n$1 === 0) {
                return x$1.hd;
            }
            _n = n$1 - 1 | 0;
            _x = x$1.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    ;
}
function partitionAux(p, _cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) {
            return;
        }
        var t = cell.tl;
        var h = cell.hd;
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        if (p(h)) {
            precX.tl = next;
            _precX = next;
            _cell = t;
            continue;
        }
        precY.tl = next;
        _precY = next;
        _cell = t;
        continue;
    }
    ;
}
function splitAux(_cell, _precX, _precY) {
    while(true){
        var precY = _precY;
        var precX = _precX;
        var cell = _cell;
        if (!cell) {
            return;
        }
        var match = cell.hd;
        var nextA = {
            hd: match[0],
            tl: /* [] */ 0
        };
        var nextB = {
            hd: match[1],
            tl: /* [] */ 0
        };
        precX.tl = nextA;
        precY.tl = nextB;
        _precY = nextB;
        _precX = nextA;
        _cell = cell.tl;
        continue;
    }
    ;
}
function copyAuxCont(_cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return prec;
        }
        var next = {
            hd: cellX.hd,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
    ;
}
function copyAuxWitFilter(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
    ;
}
function copyAuxWithFilterIndex(f, _cellX, _prec, _i) {
    while(true){
        var i = _i;
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h, i)) {
            var next = {
                hd: h,
                tl: /* [] */ 0
            };
            prec.tl = next;
            _i = i + 1 | 0;
            _prec = next;
            _cellX = t;
            continue;
        }
        _i = i + 1 | 0;
        _cellX = t;
        continue;
    }
    ;
}
function copyAuxWitFilterMap(f, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        var t = cellX.tl;
        var h = f(cellX.hd);
        if (h !== undefined) {
            var next = {
                hd: Caml_option.valFromOption(h),
                tl: /* [] */ 0
            };
            prec.tl = next;
            _prec = next;
            _cellX = t;
            continue;
        }
        _cellX = t;
        continue;
    }
    ;
}
function removeAssocAuxWithMap(_cellX, x, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return false;
        }
        var t = cellX.tl;
        var h = cellX.hd;
        if (f(h[0], x)) {
            prec.tl = t;
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
    ;
}
function setAssocAuxWithMap(_cellX, x, k, _prec, eq) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return false;
        }
        var t = cellX.tl;
        var h = cellX.hd;
        if (eq(h[0], x)) {
            prec.tl = {
                hd: [
                    x,
                    k
                ],
                tl: t
            };
            return true;
        }
        var next = {
            hd: h,
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = t;
        continue;
    }
    ;
}
function copyAuxWithMap(_cellX, _prec, f) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        var next = {
            hd: f(cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        continue;
    }
    ;
}
function zipAux(_cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        if (!cellY) {
            return;
        }
        var next = {
            hd: [
                cellX.hd,
                cellY.hd
            ],
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
    ;
}
function copyAuxWithMap2(f, _cellX, _cellY, _prec) {
    while(true){
        var prec = _prec;
        var cellY = _cellY;
        var cellX = _cellX;
        if (!cellX) {
            return;
        }
        if (!cellY) {
            return;
        }
        var next = {
            hd: f(cellX.hd, cellY.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellY = cellY.tl;
        _cellX = cellX.tl;
        continue;
    }
    ;
}
function copyAuxWithMapI(f, _i, _cellX, _prec) {
    while(true){
        var prec = _prec;
        var cellX = _cellX;
        var i = _i;
        if (!cellX) {
            return;
        }
        var next = {
            hd: f(i, cellX.hd),
            tl: /* [] */ 0
        };
        prec.tl = next;
        _prec = next;
        _cellX = cellX.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function takeAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) {
            return true;
        }
        if (!cell) {
            return false;
        }
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
    ;
}
function splitAtAux(_n, _cell, _prec) {
    while(true){
        var prec = _prec;
        var cell = _cell;
        var n = _n;
        if (n === 0) {
            return cell;
        }
        if (!cell) {
            return;
        }
        var cell$1 = {
            hd: cell.hd,
            tl: /* [] */ 0
        };
        prec.tl = cell$1;
        _prec = cell$1;
        _cell = cell.tl;
        _n = n - 1 | 0;
        continue;
    }
    ;
}
function take(lst, n) {
    if (n < 0) {
        return;
    }
    if (n === 0) {
        return /* [] */ 0;
    }
    if (!lst) {
        return;
    }
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var has = takeAux(n - 1 | 0, lst.tl, cell);
    if (has) {
        return cell;
    }
}
function drop(lst, n) {
    if (n < 0) {
        return;
    } else {
        var _l = lst;
        var _n = n;
        while(true){
            var n$1 = _n;
            var l = _l;
            if (n$1 === 0) {
                return l;
            }
            if (!l) {
                return;
            }
            _n = n$1 - 1 | 0;
            _l = l.tl;
            continue;
        }
        ;
    }
}
function splitAt(lst, n) {
    if (n < 0) {
        return;
    }
    if (n === 0) {
        return [
            /* [] */ 0,
            lst
        ];
    }
    if (!lst) {
        return;
    }
    var cell = {
        hd: lst.hd,
        tl: /* [] */ 0
    };
    var rest = splitAtAux(n - 1 | 0, lst.tl, cell);
    if (rest !== undefined) {
        return [
            cell,
            rest
        ];
    }
}
function concat(xs, ys) {
    if (!xs) {
        return ys;
    }
    var cell = {
        hd: xs.hd,
        tl: /* [] */ 0
    };
    copyAuxCont(xs.tl, cell).tl = ys;
    return cell;
}
function mapU(xs, f) {
    if (!xs) {
        return /* [] */ 0;
    }
    var cell = {
        hd: f(xs.hd),
        tl: /* [] */ 0
    };
    copyAuxWithMap(xs.tl, cell, f);
    return cell;
}
function map(xs, f) {
    return mapU(xs, _curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(f));
}
function zipByU(l1, l2, f) {
    if (!l1) {
        return /* [] */ 0;
    }
    if (!l2) {
        return /* [] */ 0;
    }
    var cell = {
        hd: f(l1.hd, l2.hd),
        tl: /* [] */ 0
    };
    copyAuxWithMap2(f, l1.tl, l2.tl, cell);
    return cell;
}
function zipBy(l1, l2, f) {
    return zipByU(l1, l2, Curry.__2(f));
}
function mapWithIndexU(xs, f) {
    if (!xs) {
        return /* [] */ 0;
    }
    var cell = {
        hd: f(0, xs.hd),
        tl: /* [] */ 0
    };
    copyAuxWithMapI(f, 1, xs.tl, cell);
    return cell;
}
function mapWithIndex(xs, f) {
    return mapWithIndexU(xs, Curry.__2(f));
}
function makeByU(n, f) {
    if (n <= 0) {
        return /* [] */ 0;
    }
    var headX = {
        hd: f(0),
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v = {
            hd: f(i),
            tl: /* [] */ 0
        };
        cur.tl = v;
        cur = v;
        i = i + 1 | 0;
    }
    ;
    return headX;
}
function makeBy(n, f) {
    return makeByU(n, Curry.__1(f));
}
function make(n, v) {
    if (n <= 0) {
        return /* [] */ 0;
    }
    var headX = {
        hd: v,
        tl: /* [] */ 0
    };
    var cur = headX;
    var i = 1;
    while(i < n){
        var v$1 = {
            hd: v,
            tl: /* [] */ 0
        };
        cur.tl = v$1;
        cur = v$1;
        i = i + 1 | 0;
    }
    ;
    return headX;
}
function length(xs) {
    var _x = xs;
    var _acc = 0;
    while(true){
        var acc = _acc;
        var x = _x;
        if (!x) {
            return acc;
        }
        _acc = acc + 1 | 0;
        _x = x.tl;
        continue;
    }
    ;
}
function fillAux(arr, _i, _x) {
    while(true){
        var x = _x;
        var i = _i;
        if (!x) {
            return;
        }
        arr[i] = x.hd;
        _x = x.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function fromArray(a) {
    var _i = a.length - 1 | 0;
    var _res = /* [] */ 0;
    while(true){
        var res = _res;
        var i = _i;
        if (i < 0) {
            return res;
        }
        _res = {
            hd: a[i],
            tl: res
        };
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function toArray(x) {
    var len = length(x);
    var arr = new Array(len);
    fillAux(arr, 0, x);
    return arr;
}
function shuffle(xs) {
    var v = toArray(xs);
    Belt_Array.shuffleInPlace(v);
    return fromArray(v);
}
function reverseConcat(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return l2;
        }
        _l2 = {
            hd: l1.hd,
            tl: l2
        };
        _l1 = l1.tl;
        continue;
    }
    ;
}
function reverse(l) {
    return reverseConcat(l, /* [] */ 0);
}
function flattenAux(_prec, _xs) {
    while(true){
        var xs = _xs;
        var prec = _prec;
        if (xs) {
            _xs = xs.tl;
            _prec = copyAuxCont(xs.hd, prec);
            continue;
        }
        prec.tl = /* [] */ 0;
        return;
    }
    ;
}
function flatten(_xs) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return /* [] */ 0;
        }
        var match = xs.hd;
        if (match) {
            var cell = {
                hd: match.hd,
                tl: /* [] */ 0
            };
            flattenAux(copyAuxCont(match.tl, cell), xs.tl);
            return cell;
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function concatMany(xs) {
    var len = xs.length;
    if (len === 1) {
        return xs[0];
    }
    if (len === 0) {
        return /* [] */ 0;
    }
    var len$1 = xs.length;
    var v = xs[len$1 - 1 | 0];
    for(var i = len$1 - 2 | 0; i >= 0; --i){
        v = concat(xs[i], v);
    }
    return v;
}
function mapReverseU(l, f) {
    var _accu = /* [] */ 0;
    var _xs = l;
    while(true){
        var xs = _xs;
        var accu = _accu;
        if (!xs) {
            return accu;
        }
        _xs = xs.tl;
        _accu = {
            hd: f(xs.hd),
            tl: accu
        };
        continue;
    }
    ;
}
function mapReverse(l, f) {
    return mapReverseU(l, Curry.__1(f));
}
function forEachU(_xs, f) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return;
        }
        f(xs.hd);
        _xs = xs.tl;
        continue;
    }
    ;
}
function forEach(xs, f) {
    forEachU(xs, Curry.__1(f));
}
function forEachWithIndexU(l, f) {
    var _xs = l;
    var _i = 0;
    while(true){
        var i = _i;
        var xs = _xs;
        if (!xs) {
            return;
        }
        f(i, xs.hd);
        _i = i + 1 | 0;
        _xs = xs.tl;
        continue;
    }
    ;
}
function forEachWithIndex(l, f) {
    forEachWithIndexU(l, Curry.__2(f));
}
function reduceU(_l, _accu, f) {
    while(true){
        var accu = _accu;
        var l = _l;
        if (!l) {
            return accu;
        }
        _accu = f(accu, l.hd);
        _l = l.tl;
        continue;
    }
    ;
}
function reduce(l, accu, f) {
    return reduceU(l, accu, _curry_js__WEBPACK_IMPORTED_MODULE_0__.__2(f));
}
function reduceReverseUnsafeU(l, accu, f) {
    if (l) {
        return f(reduceReverseUnsafeU(l.tl, accu, f), l.hd);
    } else {
        return accu;
    }
}
function reduceReverseU(l, acc, f) {
    var len = length(l);
    if (len < 1000) {
        return reduceReverseUnsafeU(l, acc, f);
    } else {
        return Belt_Array.reduceReverseU(toArray(l), acc, f);
    }
}
function reduceReverse(l, accu, f) {
    return reduceReverseU(l, accu, Curry.__2(f));
}
function reduceWithIndexU(l, acc, f) {
    var _l = l;
    var _acc = acc;
    var _i = 0;
    while(true){
        var i = _i;
        var acc$1 = _acc;
        var l$1 = _l;
        if (!l$1) {
            return acc$1;
        }
        _i = i + 1 | 0;
        _acc = f(acc$1, l$1.hd, i);
        _l = l$1.tl;
        continue;
    }
    ;
}
function reduceWithIndex(l, acc, f) {
    return reduceWithIndexU(l, acc, Curry.__3(f));
}
function mapReverse2U(l1, l2, f) {
    var _l1 = l1;
    var _l2 = l2;
    var _accu = /* [] */ 0;
    while(true){
        var accu = _accu;
        var l2$1 = _l2;
        var l1$1 = _l1;
        if (!l1$1) {
            return accu;
        }
        if (!l2$1) {
            return accu;
        }
        _accu = {
            hd: f(l1$1.hd, l2$1.hd),
            tl: accu
        };
        _l2 = l2$1.tl;
        _l1 = l1$1.tl;
        continue;
    }
    ;
}
function mapReverse2(l1, l2, f) {
    return mapReverse2U(l1, l2, Curry.__2(f));
}
function forEach2U(_l1, _l2, f) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return;
        }
        if (!l2) {
            return;
        }
        f(l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function forEach2(l1, l2, f) {
    forEach2U(l1, l2, Curry.__2(f));
}
function reduce2U(_l1, _l2, _accu, f) {
    while(true){
        var accu = _accu;
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return accu;
        }
        if (!l2) {
            return accu;
        }
        _accu = f(accu, l1.hd, l2.hd);
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function reduce2(l1, l2, acc, f) {
    return reduce2U(l1, l2, acc, Curry.__3(f));
}
function reduceReverse2UnsafeU(l1, l2, accu, f) {
    if (l1 && l2) {
        return f(reduceReverse2UnsafeU(l1.tl, l2.tl, accu, f), l1.hd, l2.hd);
    } else {
        return accu;
    }
}
function reduceReverse2U(l1, l2, acc, f) {
    var len = length(l1);
    if (len < 1000) {
        return reduceReverse2UnsafeU(l1, l2, acc, f);
    } else {
        return Belt_Array.reduceReverse2U(toArray(l1), toArray(l2), acc, f);
    }
}
function reduceReverse2(l1, l2, acc, f) {
    return reduceReverse2U(l1, l2, acc, Curry.__3(f));
}
function everyU(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return true;
        }
        if (!p(xs.hd)) {
            return false;
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function every(xs, p) {
    return everyU(xs, Curry.__1(p));
}
function someU(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return false;
        }
        if (p(xs.hd)) {
            return true;
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function some(xs, p) {
    return someU(xs, Curry.__1(p));
}
function every2U(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return true;
        }
        if (!l2) {
            return true;
        }
        if (!p(l1.hd, l2.hd)) {
            return false;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function every2(l1, l2, p) {
    return every2U(l1, l2, Curry.__2(p));
}
function cmpByLength(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) {
                return -1;
            } else {
                return 0;
            }
        }
        if (!l2) {
            return 1;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function cmpU(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) {
                return -1;
            } else {
                return 0;
            }
        }
        if (!l2) {
            return 1;
        }
        var c = p(l1.hd, l2.hd);
        if (c !== 0) {
            return c;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function cmp(l1, l2, f) {
    return cmpU(l1, l2, Curry.__2(f));
}
function eqU(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) {
                return false;
            } else {
                return true;
            }
        }
        if (!l2) {
            return false;
        }
        if (!p(l1.hd, l2.hd)) {
            return false;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function eq(l1, l2, f) {
    return eqU(l1, l2, Curry.__2(f));
}
function some2U(_l1, _l2, p) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return false;
        }
        if (!l2) {
            return false;
        }
        if (p(l1.hd, l2.hd)) {
            return true;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function some2(l1, l2, p) {
    return some2U(l1, l2, Curry.__2(p));
}
function hasU(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return false;
        }
        if (eq(xs.hd, x)) {
            return true;
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function has(xs, x, eq) {
    return hasU(xs, x, Curry.__2(eq));
}
function getAssocU(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return;
        }
        var match = xs.hd;
        if (eq(match[0], x)) {
            return Caml_option.some(match[1]);
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function getAssoc(xs, x, eq) {
    return getAssocU(xs, x, Curry.__2(eq));
}
function hasAssocU(_xs, x, eq) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return false;
        }
        if (eq(xs.hd[0], x)) {
            return true;
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function hasAssoc(xs, x, eq) {
    return hasAssocU(xs, x, Curry.__2(eq));
}
function removeAssocU(xs, x, eq) {
    if (!xs) {
        return /* [] */ 0;
    }
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) {
        return l;
    }
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var removed = removeAssocAuxWithMap(l, x, cell, eq);
    if (removed) {
        return cell;
    } else {
        return xs;
    }
}
function removeAssoc(xs, x, eq) {
    return removeAssocU(xs, x, Curry.__2(eq));
}
function setAssocU(xs, x, k, eq) {
    if (!xs) {
        return {
            hd: [
                x,
                k
            ],
            tl: /* [] */ 0
        };
    }
    var l = xs.tl;
    var pair = xs.hd;
    if (eq(pair[0], x)) {
        return {
            hd: [
                x,
                k
            ],
            tl: l
        };
    }
    var cell = {
        hd: pair,
        tl: /* [] */ 0
    };
    var replaced = setAssocAuxWithMap(l, x, k, cell, eq);
    if (replaced) {
        return cell;
    } else {
        return {
            hd: [
                x,
                k
            ],
            tl: xs
        };
    }
}
function setAssoc(xs, x, k, eq) {
    return setAssocU(xs, x, k, Curry.__2(eq));
}
function sortU(xs, cmp) {
    var arr = toArray(xs);
    Belt_SortArray.stableSortInPlaceByU(arr, cmp);
    return fromArray(arr);
}
function sort(xs, cmp) {
    return sortU(xs, Curry.__2(cmp));
}
function getByU(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return;
        }
        var x = xs.hd;
        if (p(x)) {
            return Caml_option.some(x);
        }
        _xs = xs.tl;
        continue;
    }
    ;
}
function getBy(xs, p) {
    return getByU(xs, Curry.__1(p));
}
function keepU(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return /* [] */ 0;
        }
        var t = xs.tl;
        var h = xs.hd;
        if (p(h)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            copyAuxWitFilter(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
    ;
}
function keep(xs, p) {
    return keepU(xs, _curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(p));
}
function keepWithIndexU(xs, p) {
    var _xs = xs;
    var _i = 0;
    while(true){
        var i = _i;
        var xs$1 = _xs;
        if (!xs$1) {
            return /* [] */ 0;
        }
        var t = xs$1.tl;
        var h = xs$1.hd;
        if (p(h, i)) {
            var cell = {
                hd: h,
                tl: /* [] */ 0
            };
            copyAuxWithFilterIndex(p, t, cell, i + 1 | 0);
            return cell;
        }
        _i = i + 1 | 0;
        _xs = t;
        continue;
    }
    ;
}
function keepWithIndex(xs, p) {
    return keepWithIndexU(xs, Curry.__2(p));
}
function keepMapU(_xs, p) {
    while(true){
        var xs = _xs;
        if (!xs) {
            return /* [] */ 0;
        }
        var t = xs.tl;
        var h = p(xs.hd);
        if (h !== undefined) {
            var cell = {
                hd: Caml_option.valFromOption(h),
                tl: /* [] */ 0
            };
            copyAuxWitFilterMap(p, t, cell);
            return cell;
        }
        _xs = t;
        continue;
    }
    ;
}
function keepMap(xs, p) {
    return keepMapU(xs, Curry.__1(p));
}
function partitionU(l, p) {
    if (!l) {
        return [
            /* [] */ 0,
            /* [] */ 0
        ];
    }
    var h = l.hd;
    var nextX = {
        hd: h,
        tl: /* [] */ 0
    };
    var nextY = {
        hd: h,
        tl: /* [] */ 0
    };
    var b = p(h);
    partitionAux(p, l.tl, nextX, nextY);
    if (b) {
        return [
            nextX,
            nextY.tl
        ];
    } else {
        return [
            nextX.tl,
            nextY
        ];
    }
}
function partition(l, p) {
    return partitionU(l, Curry.__1(p));
}
function unzip(xs) {
    if (!xs) {
        return [
            /* [] */ 0,
            /* [] */ 0
        ];
    }
    var match = xs.hd;
    var cellX = {
        hd: match[0],
        tl: /* [] */ 0
    };
    var cellY = {
        hd: match[1],
        tl: /* [] */ 0
    };
    splitAux(xs.tl, cellX, cellY);
    return [
        cellX,
        cellY
    ];
}
function zip(l1, l2) {
    if (!l1) {
        return /* [] */ 0;
    }
    if (!l2) {
        return /* [] */ 0;
    }
    var cell = {
        hd: [
            l1.hd,
            l2.hd
        ],
        tl: /* [] */ 0
    };
    zipAux(l1.tl, l2.tl, cell);
    return cell;
}
var size = (/* unused pure expression or super */ null && (length));
var filter = (/* unused pure expression or super */ null && (keep));
var filterWithIndex = (/* unused pure expression or super */ null && (keepWithIndex));
 /* No side effect */ 


/***/ }),

/***/ 72491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VS": function() { return /* binding */ flatMap; },
/* harmony export */   "Wi": function() { return /* binding */ isNone; },
/* harmony export */   "k7": function() { return /* binding */ mapWithDefault; },
/* harmony export */   "pC": function() { return /* binding */ isSome; },
/* harmony export */   "tj": function() { return /* binding */ getWithDefault; }
/* harmony export */ });
/* unused harmony exports keepU, keep, forEachU, getExn, mapWithDefaultU, mapU, flatMapU, orElse, eqU, eq, cmpU, cmp */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);


function keepU(opt, p) {
    if (opt !== undefined && p(Caml_option.valFromOption(opt))) {
        return opt;
    }
}
function keep(opt, p) {
    return keepU(opt, Curry.__1(p));
}
function forEachU(opt, f) {
    if (opt !== undefined) {
        return f(_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(opt));
    }
}
function forEach(opt, f) {
    forEachU(opt, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function getExn(x) {
    if (x !== undefined) {
        return Caml_option.valFromOption(x);
    }
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function mapWithDefaultU(opt, $$default, f) {
    if (opt !== undefined) {
        return f(_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(opt));
    } else {
        return $$default;
    }
}
function mapWithDefault(opt, $$default, f) {
    return mapWithDefaultU(opt, $$default, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function mapU(opt, f) {
    if (opt !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(f(_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(opt)));
    }
}
function map(opt, f) {
    return mapU(opt, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function flatMapU(opt, f) {
    if (opt !== undefined) {
        return f(_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(opt));
    }
}
function flatMap(opt, f) {
    return flatMapU(opt, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__1(f));
}
function getWithDefault(opt, $$default) {
    if (opt !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(opt);
    } else {
        return $$default;
    }
}
function orElse(opt, other) {
    if (opt !== undefined) {
        return opt;
    } else {
        return other;
    }
}
function isSome(param) {
    return param !== undefined;
}
function isNone(x) {
    return x === undefined;
}
function eqU(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) {
            return f(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
        } else {
            return false;
        }
    } else {
        return b === undefined;
    }
}
function eq(a, b, f) {
    return eqU(a, b, Curry.__2(f));
}
function cmpU(a, b, f) {
    if (a !== undefined) {
        if (b !== undefined) {
            return f(Caml_option.valFromOption(a), Caml_option.valFromOption(b));
        } else {
            return 1;
        }
    } else if (b !== undefined) {
        return -1;
    } else {
        return 0;
    }
}
function cmp(a, b, f) {
    return cmpU(a, b, Curry.__2(f));
}
 /* No side effect */ 


/***/ }),

/***/ 70677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k7": function() { return /* binding */ mapWithDefault; }
/* harmony export */ });
/* unused harmony exports getExn, mapWithDefaultU, mapU, map, flatMapU, flatMap, getWithDefault, isOk, isError, eqU, eq, cmpU, cmp */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92592);

function getExn(x) {
    if (x.TAG === /* Ok */ 0) {
        return x._0;
    }
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
function mapWithDefaultU(opt, $$default, f) {
    if (opt.TAG === /* Ok */ 0) {
        return f(opt._0);
    } else {
        return $$default;
    }
}
function mapWithDefault(opt, $$default, f) {
    return mapWithDefaultU(opt, $$default, _curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(f));
}
function mapU(opt, f) {
    if (opt.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: f(opt._0)
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: opt._0
        };
    }
}
function map(opt, f) {
    return mapU(opt, Curry.__1(f));
}
function flatMapU(opt, f) {
    if (opt.TAG === /* Ok */ 0) {
        return f(opt._0);
    } else {
        return {
            TAG: /* Error */ 1,
            _0: opt._0
        };
    }
}
function flatMap(opt, f) {
    return flatMapU(opt, Curry.__1(f));
}
function getWithDefault(opt, $$default) {
    if (opt.TAG === /* Ok */ 0) {
        return opt._0;
    } else {
        return $$default;
    }
}
function isOk(param) {
    if (param.TAG === /* Ok */ 0) {
        return true;
    } else {
        return false;
    }
}
function isError(param) {
    if (param.TAG === /* Ok */ 0) {
        return false;
    } else {
        return true;
    }
}
function eqU(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) {
            return f(a._0, b._0);
        } else {
            return false;
        }
    } else if (b.TAG === /* Ok */ 0) {
        return false;
    } else {
        return true;
    }
}
function eq(a, b, f) {
    return eqU(a, b, Curry.__2(f));
}
function cmpU(a, b, f) {
    if (a.TAG === /* Ok */ 0) {
        if (b.TAG === /* Ok */ 0) {
            return f(a._0, b._0);
        } else {
            return 1;
        }
    } else if (b.TAG === /* Ok */ 0) {
        return -1;
    } else {
        return 0;
    }
}
function cmp(a, b, f) {
    return cmpU(a, b, Curry.__2(f));
}
 /* No side effect */ 


/***/ }),

/***/ 9618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yf": function() { return /* binding */ stableSortBy; },
/* harmony export */   "eP": function() { return /* binding */ strictlySortedLengthU; },
/* harmony export */   "mC": function() { return /* binding */ stableSortInPlaceBy; }
/* harmony export */ });
/* unused harmony exports Int, $$String, strictlySortedLength, isSortedU, isSorted, stableSortInPlaceByU, stableSortByU, binarySearchByU, binarySearchBy, unionU, union, intersectU, intersect, diffU, diff */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _belt_Array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96533);


function sortedLengthAuxMore(xs, _prec, _acc, len, lt) {
    while(true){
        var acc = _acc;
        var prec = _prec;
        if (acc >= len) {
            return acc;
        }
        var v = xs[acc];
        if (!lt(v, prec)) {
            return acc;
        }
        _acc = acc + 1 | 0;
        _prec = v;
        continue;
    }
    ;
}
function strictlySortedLengthU(xs, lt) {
    var len = xs.length;
    if (len === 0 || len === 1) {
        return len;
    }
    var x0 = xs[0];
    var x1 = xs[1];
    if (lt(x0, x1)) {
        var _prec = x1;
        var _acc = 2;
        while(true){
            var acc = _acc;
            var prec = _prec;
            if (acc >= len) {
                return acc;
            }
            var v = xs[acc];
            if (!lt(prec, v)) {
                return acc;
            }
            _acc = acc + 1 | 0;
            _prec = v;
            continue;
        }
        ;
    } else if (lt(x1, x0)) {
        return -sortedLengthAuxMore(xs, x1, 2, len, lt) | 0;
    } else {
        return 1;
    }
}
function strictlySortedLength(xs, lt) {
    return strictlySortedLengthU(xs, Curry.__2(lt));
}
function isSortedU(a, cmp) {
    var len = a.length;
    if (len === 0) {
        return true;
    } else {
        var _i = 0;
        var last_bound = len - 1 | 0;
        while(true){
            var i = _i;
            if (i === last_bound) {
                return true;
            }
            if (cmp(a[i], a[i + 1 | 0]) > 0) {
                return false;
            }
            _i = i + 1 | 0;
            continue;
        }
        ;
    }
}
function isSorted(a, cmp) {
    return isSortedU(a, Curry.__2(cmp));
}
function merge(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        if (cmp(s1, s2) <= 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) {
                return _belt_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .blitUnsafe */ .i1(src2, i2, dst, d + 1 | 0, src2r - i2 | 0);
            }
            _d = d + 1 | 0;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        dst[d] = s2;
        var i2$1 = i2 + 1 | 0;
        if (i2$1 >= src2r) {
            return _belt_Array_js__WEBPACK_IMPORTED_MODULE_0__/* .blitUnsafe */ .i1(src, i1, dst, d + 1 | 0, src1r - i1 | 0);
        }
        _d = d + 1 | 0;
        _s2 = src2[i2$1];
        _i2 = i2$1;
        continue;
    }
    ;
}
function unionU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var i1$1 = i1 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (i1$1 < src1r) {
                _d = d$1;
                _s1 = src[i1$1];
                _i1 = i1$1;
                continue;
            }
            Belt_Array.blitUnsafe(src2, i2, dst, d$1, src2r - i2 | 0);
            return (d$1 + src2r | 0) - i2 | 0;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$2 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) {
                    Belt_Array.blitUnsafe(src2, i2$1, dst, d$2, src2r - i2$1 | 0);
                    return (d$2 + src2r | 0) - i2$1 | 0;
                } else {
                    Belt_Array.blitUnsafe(src, i1$2, dst, d$2, src1r - i1$2 | 0);
                    return (d$2 + src1r | 0) - i1$2 | 0;
                }
            }
            _d = d$2;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        dst[d] = s2;
        var i2$2 = i2 + 1 | 0;
        var d$3 = d + 1 | 0;
        if (i2$2 < src2r) {
            _d = d$3;
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        Belt_Array.blitUnsafe(src, i1, dst, d$3, src1r - i1 | 0);
        return (d$3 + src1r | 0) - i1 | 0;
    }
    ;
}
function union(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return unionU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}
function intersectU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) {
                return d;
            }
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            dst[d] = s1;
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            var d$1 = d + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                return d$1;
            }
            _d = d$1;
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 >= src2r) {
            return d;
        }
        _s2 = src2[i2$2];
        _i2 = i2$2;
        continue;
    }
    ;
}
function intersect(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return intersectU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}
function diffU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    var src1r = src1ofs + src1len | 0;
    var src2r = src2ofs + src2len | 0;
    var _i1 = src1ofs;
    var _s1 = src[src1ofs];
    var _i2 = src2ofs;
    var _s2 = src2[src2ofs];
    var _d = dstofs;
    while(true){
        var d = _d;
        var s2 = _s2;
        var i2 = _i2;
        var s1 = _s1;
        var i1 = _i1;
        var c = cmp(s1, s2);
        if (c < 0) {
            dst[d] = s1;
            var d$1 = d + 1 | 0;
            var i1$1 = i1 + 1 | 0;
            if (i1$1 >= src1r) {
                return d$1;
            }
            _d = d$1;
            _s1 = src[i1$1];
            _i1 = i1$1;
            continue;
        }
        if (c === 0) {
            var i1$2 = i1 + 1 | 0;
            var i2$1 = i2 + 1 | 0;
            if (!(i1$2 < src1r && i2$1 < src2r)) {
                if (i1$2 === src1r) {
                    return d;
                } else {
                    Belt_Array.blitUnsafe(src, i1$2, dst, d, src1r - i1$2 | 0);
                    return (d + src1r | 0) - i1$2 | 0;
                }
            }
            _s2 = src2[i2$1];
            _i2 = i2$1;
            _s1 = src[i1$2];
            _i1 = i1$2;
            continue;
        }
        var i2$2 = i2 + 1 | 0;
        if (i2$2 < src2r) {
            _s2 = src2[i2$2];
            _i2 = i2$2;
            continue;
        }
        Belt_Array.blitUnsafe(src, i1, dst, d, src1r - i1 | 0);
        return (d + src1r | 0) - i1 | 0;
    }
    ;
}
function diff(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, cmp) {
    return diffU(src, src1ofs, src1len, src2, src2ofs, src2len, dst, dstofs, Curry.__2(cmp));
}
function insertionSort(src, srcofs, dst, dstofs, len, cmp) {
    for(var i = 0; i < len; ++i){
        var e = src[srcofs + i | 0];
        var j = (dstofs + i | 0) - 1 | 0;
        while(j >= dstofs && cmp(dst[j], e) > 0){
            dst[j + 1 | 0] = dst[j];
            j = j - 1 | 0;
        }
        ;
        dst[j + 1 | 0] = e;
    }
}
function sortTo(src, srcofs, dst, dstofs, len, cmp) {
    if (len <= 5) {
        return insertionSort(src, srcofs, dst, dstofs, len, cmp);
    }
    var l1 = len / 2 | 0;
    var l2 = len - l1 | 0;
    sortTo(src, srcofs + l1 | 0, dst, dstofs + l1 | 0, l2, cmp);
    sortTo(src, srcofs, src, srcofs + l2 | 0, l1, cmp);
    merge(src, srcofs + l2 | 0, l1, dst, dstofs + l1 | 0, l2, dst, dstofs, cmp);
}
function stableSortInPlaceByU(a, cmp) {
    var l = a.length;
    if (l <= 5) {
        return insertionSort(a, 0, a, 0, l, cmp);
    }
    var l1 = l / 2 | 0;
    var l2 = l - l1 | 0;
    var t = new Array(l2);
    sortTo(a, l1, t, 0, l2, cmp);
    sortTo(a, 0, a, l2, l1, cmp);
    merge(a, l2, l1, t, 0, l2, a, 0, cmp);
}
function stableSortInPlaceBy(a, cmp) {
    stableSortInPlaceByU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__2(cmp));
}
function stableSortByU(a, cmp) {
    var b = a.slice(0);
    stableSortInPlaceByU(b, cmp);
    return b;
}
function stableSortBy(a, cmp) {
    return stableSortByU(a, _curry_js__WEBPACK_IMPORTED_MODULE_1__.__2(cmp));
}
function binarySearchByU(sorted, key, cmp) {
    var len = sorted.length;
    if (len === 0) {
        return -1;
    }
    var lo = sorted[0];
    var c = cmp(key, lo);
    if (c < 0) {
        return -1;
    }
    var hi = sorted[len - 1 | 0];
    var c2 = cmp(key, hi);
    if (c2 > 0) {
        return -(len + 1 | 0) | 0;
    } else {
        var _lo = 0;
        var _hi = len - 1 | 0;
        while(true){
            var hi$1 = _hi;
            var lo$1 = _lo;
            var mid = (lo$1 + hi$1 | 0) / 2 | 0;
            var midVal = sorted[mid];
            var c$1 = cmp(key, midVal);
            if (c$1 === 0) {
                return mid;
            }
            if (c$1 < 0) {
                if (hi$1 === mid) {
                    if (cmp(sorted[lo$1], key) === 0) {
                        return lo$1;
                    } else {
                        return -(hi$1 + 1 | 0) | 0;
                    }
                }
                _hi = mid;
                continue;
            }
            if (lo$1 === mid) {
                if (cmp(sorted[hi$1], key) === 0) {
                    return hi$1;
                } else {
                    return -(hi$1 + 1 | 0) | 0;
                }
            }
            _lo = mid;
            continue;
        }
        ;
    }
}
function binarySearchBy(sorted, key, cmp) {
    return binarySearchByU(sorted, key, Curry.__2(cmp));
}
var Int;
var $$String;
 /* No side effect */ 


/***/ }),

/***/ 55658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ string_compare; },
/* harmony export */   "ib": function() { return /* binding */ int_max; }
/* harmony export */ });
/* unused harmony exports int_compare, bool_compare, float_compare, bool_min, int_min, float_min, string_min, bool_max, float_max, string_max, i64_eq, i64_neq, i64_lt, i64_gt, i64_le, i64_ge, i64_min, i64_max */
function int_compare(x, y) {
    if (x < y) {
        return -1;
    } else if (x === y) {
        return 0;
    } else {
        return 1;
    }
}
function bool_compare(x, y) {
    if (x) {
        if (y) {
            return 0;
        } else {
            return 1;
        }
    } else if (y) {
        return -1;
    } else {
        return 0;
    }
}
function float_compare(x, y) {
    if (x === y) {
        return 0;
    } else if (x < y) {
        return -1;
    } else if (x > y || x === x) {
        return 1;
    } else if (y === y) {
        return -1;
    } else {
        return 0;
    }
}
function string_compare(s1, s2) {
    if (s1 === s2) {
        return 0;
    } else if (s1 < s2) {
        return -1;
    } else {
        return 1;
    }
}
function bool_min(x, y) {
    if (x) {
        return y;
    } else {
        return x;
    }
}
function int_min(x, y) {
    if (x < y) {
        return x;
    } else {
        return y;
    }
}
function float_min(x, y) {
    if (x < y) {
        return x;
    } else {
        return y;
    }
}
function string_min(x, y) {
    if (x < y) {
        return x;
    } else {
        return y;
    }
}
function bool_max(x, y) {
    if (x) {
        return x;
    } else {
        return y;
    }
}
function int_max(x, y) {
    if (x > y) {
        return x;
    } else {
        return y;
    }
}
function float_max(x, y) {
    if (x > y) {
        return x;
    } else {
        return y;
    }
}
function string_max(x, y) {
    if (x > y) {
        return x;
    } else {
        return y;
    }
}
function i64_eq(x, y) {
    if (x[1] === y[1]) {
        return x[0] === y[0];
    } else {
        return false;
    }
}
function i64_ge(param, param$1) {
    var other_hi = param$1[0];
    var hi = param[0];
    if (hi > other_hi) {
        return true;
    } else if (hi < other_hi) {
        return false;
    } else {
        return param[1] >= param$1[1];
    }
}
function i64_neq(x, y) {
    return !i64_eq(x, y);
}
function i64_lt(x, y) {
    return !i64_ge(x, y);
}
function i64_gt(x, y) {
    if (x[0] > y[0]) {
        return true;
    } else if (x[0] < y[0]) {
        return false;
    } else {
        return x[1] > y[1];
    }
}
function i64_le(x, y) {
    return !i64_gt(x, y);
}
function i64_min(x, y) {
    if (i64_ge(x, y)) {
        return y;
    } else {
        return x;
    }
}
function i64_max(x, y) {
    if (i64_gt(x, y)) {
        return x;
    } else {
        return y;
    }
}
 /* No side effect */ 


/***/ }),

/***/ 46150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "lu": function() { return /* binding */ sub; },
/* harmony export */   "wC": function() { return /* binding */ make_float; },
/* harmony export */   "zo": function() { return /* binding */ concat; }
/* harmony export */ });
/* unused harmony exports dup, blit, set */
function sub(x, offset, len) {
    var result = new Array(len);
    var j = 0;
    var i = offset;
    while(j < len){
        result[j] = x[i];
        j = j + 1 | 0;
        i = i + 1 | 0;
    }
    ;
    return result;
}
function len(_acc, _l) {
    while(true){
        var l = _l;
        var acc = _acc;
        if (!l) {
            return acc;
        }
        _l = l.tl;
        _acc = l.hd.length + acc | 0;
        continue;
    }
    ;
}
function fill(arr, _i, _l) {
    while(true){
        var l = _l;
        var i = _i;
        if (!l) {
            return;
        }
        var x = l.hd;
        var l$1 = x.length;
        var k = i;
        var j = 0;
        while(j < l$1){
            arr[k] = x[j];
            k = k + 1 | 0;
            j = j + 1 | 0;
        }
        ;
        _l = l.tl;
        _i = k;
        continue;
    }
    ;
}
function concat(l) {
    var v = len(0, l);
    var result = new Array(v);
    fill(result, 0, l);
    return result;
}
function set(xs, index, newval) {
    if (index < 0 || index >= xs.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "index out of bounds",
            Error: new Error()
        };
    }
    xs[index] = newval;
}
function get(xs, index) {
    if (index < 0 || index >= xs.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "index out of bounds",
            Error: new Error()
        };
    }
    return xs[index];
}
function make(len, init) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i){
        b[i] = init;
    }
    return b;
}
function make_float(len) {
    var b = new Array(len);
    for(var i = 0; i < len; ++i){
        b[i] = 0;
    }
    return b;
}
function blit(a1, i1, a2, i2, len) {
    if (i2 <= i1) {
        for(var j = 0; j < len; ++j){
            a2[j + i2 | 0] = a1[j + i1 | 0];
        }
        return;
    }
    for(var j$1 = len - 1 | 0; j$1 >= 0; --j$1){
        a2[j$1 + i2 | 0] = a1[j$1 + i1 | 0];
    }
}
function dup(prim) {
    return prim.slice(0);
}
 /* No side effect */ 


/***/ }),

/***/ 86592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ue": function() { return /* binding */ create; },
/* harmony export */   "VR": function() { return /* binding */ is_extension; }
/* harmony export */ });
/* unused harmony exports id, exn_slot_name */
var id = {
    contents: 0
};
function create(str) {
    id.contents = id.contents + 1 | 0;
    return str + ("/" + id.contents);
}
function is_extension(e) {
    if (e == null) {
        return false;
    } else {
        return typeof e.RE_EXN_ID === "string";
    }
}
function exn_slot_name(x) {
    return x.RE_EXN_ID;
}
 /* No side effect */ 


/***/ }),

/***/ 11331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "di": function() { return /* binding */ int_of_string; },
/* harmony export */   "mx": function() { return /* binding */ float_of_string$1; }
/* harmony export */ });
/* unused harmony exports format_float, hexstring_of_float, format_int, int64_format, int64_of_string */


function parse_digit(c) {
    if (c >= 65) {
        if (c >= 97) {
            if (c >= 123) {
                return -1;
            } else {
                return c - 87 | 0;
            }
        } else if (c >= 91) {
            return -1;
        } else {
            return c - 55 | 0;
        }
    } else if (c > 57 || c < 48) {
        return -1;
    } else {
        return c - /* '0' */ 48 | 0;
    }
}
function int_of_string_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
        case /* Bin */ 3:
            return 2;
    }
}
function parse_sign_and_base(s) {
    var sign = 1;
    var base = /* Dec */ 2;
    var i = 0;
    var match = s.codePointAt(i);
    switch(match){
        case 43:
            i = i + 1 | 0;
            break;
        case 44:
            break;
        case 45:
            sign = -1;
            i = i + 1 | 0;
            break;
        default:
    }
    if (s.codePointAt(i) === /* '0' */ 48) {
        var match$1 = s.codePointAt(i + 1 | 0);
        if (match$1 >= 89) {
            if (match$1 >= 111) {
                if (match$1 < 121) {
                    switch(match$1){
                        case 111:
                            base = /* Oct */ 0;
                            i = i + 2 | 0;
                            break;
                        case 117:
                            i = i + 2 | 0;
                            break;
                        case 112:
                        case 113:
                        case 114:
                        case 115:
                        case 116:
                        case 118:
                        case 119:
                            break;
                        case 120:
                            base = /* Hex */ 1;
                            i = i + 2 | 0;
                            break;
                    }
                }
            } else if (match$1 === 98) {
                base = /* Bin */ 3;
                i = i + 2 | 0;
            }
        } else if (match$1 !== 66) {
            if (match$1 >= 79) {
                switch(match$1){
                    case 79:
                        base = /* Oct */ 0;
                        i = i + 2 | 0;
                        break;
                    case 85:
                        i = i + 2 | 0;
                        break;
                    case 80:
                    case 81:
                    case 82:
                    case 83:
                    case 84:
                    case 86:
                    case 87:
                        break;
                    case 88:
                        base = /* Hex */ 1;
                        i = i + 2 | 0;
                        break;
                }
            }
        } else {
            base = /* Bin */ 3;
            i = i + 2 | 0;
        }
    }
    return [
        i,
        sign,
        base
    ];
}
function int_of_string(s) {
    var match = parse_sign_and_base(s);
    var i = match[0];
    var base = int_of_string_base(match[2]);
    var threshold = 4294967295;
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = parse_digit(c);
    if (d < 0 || d >= base) {
        throw {
            RE_EXN_ID: "Failure",
            _1: "int_of_string",
            Error: new Error()
        };
    }
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) {
                return acc;
            }
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = parse_digit(a);
            if (v < 0 || v >= base) {
                throw {
                    RE_EXN_ID: "Failure",
                    _1: "int_of_string",
                    Error: new Error()
                };
            }
            var acc$1 = base * acc + v;
            if (acc$1 > threshold) {
                throw {
                    RE_EXN_ID: "Failure",
                    _1: "int_of_string",
                    Error: new Error()
                };
            }
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
        ;
    };
    var res = match[1] * aux(d, i + 1 | 0);
    var or_res = res | 0;
    if (base === 10 && res !== or_res) {
        throw {
            RE_EXN_ID: "Failure",
            _1: "int_of_string",
            Error: new Error()
        };
    }
    return or_res;
}
function int64_of_string(s) {
    var match = parse_sign_and_base(s);
    var hbase = match[2];
    var i = match[0];
    var base = Caml_int64.of_int32(int_of_string_base(hbase));
    var sign = Caml_int64.of_int32(match[1]);
    var threshold;
    switch(hbase){
        case /* Oct */ 0:
            threshold = [
                536870911,
                4294967295
            ];
            break;
        case /* Hex */ 1:
            threshold = [
                268435455,
                4294967295
            ];
            break;
        case /* Dec */ 2:
            threshold = [
                429496729,
                2576980377
            ];
            break;
        case /* Bin */ 3:
            threshold = Caml_int64.max_int;
            break;
    }
    var len = s.length;
    var c = i < len ? s.codePointAt(i) : /* '\000' */ 0;
    var d = Caml_int64.of_int32(parse_digit(c));
    if (Caml.i64_lt(d, Caml_int64.zero) || Caml.i64_ge(d, base)) {
        throw {
            RE_EXN_ID: "Failure",
            _1: "int64_of_string",
            Error: new Error()
        };
    }
    var aux = function aux(_acc, _k) {
        while(true){
            var k = _k;
            var acc = _acc;
            if (k === len) {
                return acc;
            }
            var a = s.codePointAt(k);
            if (a === /* '_' */ 95) {
                _k = k + 1 | 0;
                continue;
            }
            var v = Caml_int64.of_int32(parse_digit(a));
            if (Caml.i64_lt(v, Caml_int64.zero) || Caml.i64_ge(v, base) || Caml.i64_gt(acc, threshold)) {
                throw {
                    RE_EXN_ID: "Failure",
                    _1: "int64_of_string",
                    Error: new Error()
                };
            }
            var acc$1 = Caml_int64.add(Caml_int64.mul(base, acc), v);
            _k = k + 1 | 0;
            _acc = acc$1;
            continue;
        }
        ;
    };
    var res = Caml_int64.mul(sign, aux(d, i + 1 | 0));
    var or_res = Caml_int64.or_(res, Caml_int64.zero);
    if (Caml.i64_eq(base, [
        0,
        10
    ]) && Caml.i64_neq(res, or_res)) {
        throw {
            RE_EXN_ID: "Failure",
            _1: "int64_of_string",
            Error: new Error()
        };
    }
    return or_res;
}
function int_of_base(param) {
    switch(param){
        case /* Oct */ 0:
            return 8;
        case /* Hex */ 1:
            return 16;
        case /* Dec */ 2:
            return 10;
    }
}
function lowercase(c) {
    if (c >= /* 'A' */ 65 && c <= /* 'Z' */ 90 || c >= /* '\192' */ 192 && c <= /* '\214' */ 214 || c >= /* '\216' */ 216 && c <= /* '\222' */ 222) {
        return c + 32 | 0;
    } else {
        return c;
    }
}
function parse_format(fmt) {
    var len = fmt.length;
    if (len > 31) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "format_int: format too long",
            Error: new Error()
        };
    }
    var f = {
        justify: "+",
        signstyle: "-",
        filter: " ",
        alternate: false,
        base: /* Dec */ 2,
        signedconv: false,
        width: 0,
        uppercase: false,
        sign: 1,
        prec: -1,
        conv: "f"
    };
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= len) {
            return f;
        }
        var c = fmt.codePointAt(i);
        var exit = 0;
        if (c >= 69) {
            if (c >= 88) {
                if (c >= 121) {
                    exit = 1;
                } else {
                    switch(c){
                        case 88:
                            f.base = /* Hex */ 1;
                            f.uppercase = true;
                            _i = i + 1 | 0;
                            continue;
                        case 101:
                        case 102:
                        case 103:
                            exit = 5;
                            break;
                        case 100:
                        case 105:
                            exit = 4;
                            break;
                        case 111:
                            f.base = /* Oct */ 0;
                            _i = i + 1 | 0;
                            continue;
                        case 117:
                            f.base = /* Dec */ 2;
                            _i = i + 1 | 0;
                            continue;
                        case 89:
                        case 90:
                        case 91:
                        case 92:
                        case 93:
                        case 94:
                        case 95:
                        case 96:
                        case 97:
                        case 98:
                        case 99:
                        case 104:
                        case 106:
                        case 107:
                        case 108:
                        case 109:
                        case 110:
                        case 112:
                        case 113:
                        case 114:
                        case 115:
                        case 116:
                        case 118:
                        case 119:
                            exit = 1;
                            break;
                        case 120:
                            f.base = /* Hex */ 1;
                            _i = i + 1 | 0;
                            continue;
                    }
                }
            } else if (c >= 72) {
                exit = 1;
            } else {
                f.signedconv = true;
                f.uppercase = true;
                f.conv = String.fromCharCode(lowercase(c));
                _i = i + 1 | 0;
                continue;
            }
        } else {
            switch(c){
                case 35:
                    f.alternate = true;
                    _i = i + 1 | 0;
                    continue;
                case 32:
                case 43:
                    exit = 2;
                    break;
                case 45:
                    f.justify = "-";
                    _i = i + 1 | 0;
                    continue;
                case 46:
                    f.prec = 0;
                    var j = i + 1 | 0;
                    while((function(j) {
                        return function() {
                            var w = fmt.codePointAt(j) - /* '0' */ 48 | 0;
                            return w >= 0 && w <= 9;
                        };
                    })(j)()){
                        f.prec = (Math.imul(f.prec, 10) + fmt.codePointAt(j) | 0) - /* '0' */ 48 | 0;
                        j = j + 1 | 0;
                    }
                    ;
                    _i = j;
                    continue;
                case 33:
                case 34:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 44:
                case 47:
                    exit = 1;
                    break;
                case 48:
                    f.filter = "0";
                    _i = i + 1 | 0;
                    continue;
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    exit = 3;
                    break;
                default:
                    exit = 1;
            }
        }
        switch(exit){
            case 1:
                _i = i + 1 | 0;
                continue;
            case 2:
                f.signstyle = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
            case 3:
                f.width = 0;
                var j$1 = i;
                while((function(j$1) {
                    return function() {
                        var w = fmt.codePointAt(j$1) - /* '0' */ 48 | 0;
                        return w >= 0 && w <= 9;
                    };
                })(j$1)()){
                    f.width = (Math.imul(f.width, 10) + fmt.codePointAt(j$1) | 0) - /* '0' */ 48 | 0;
                    j$1 = j$1 + 1 | 0;
                }
                ;
                _i = j$1;
                continue;
            case 4:
                f.signedconv = true;
                f.base = /* Dec */ 2;
                _i = i + 1 | 0;
                continue;
            case 5:
                f.signedconv = true;
                f.conv = String.fromCharCode(c);
                _i = i + 1 | 0;
                continue;
        }
    }
    ;
}
function finish_formatting(config, rawbuffer) {
    var justify = config.justify;
    var signstyle = config.signstyle;
    var filter = config.filter;
    var alternate = config.alternate;
    var base = config.base;
    var signedconv = config.signedconv;
    var width = config.width;
    var uppercase = config.uppercase;
    var sign = config.sign;
    var len = rawbuffer.length;
    if (signedconv && (sign < 0 || signstyle !== "-")) {
        len = len + 1 | 0;
    }
    if (alternate) {
        if (base === /* Oct */ 0) {
            len = len + 1 | 0;
        } else if (base === /* Hex */ 1) {
            len = len + 2 | 0;
        }
    }
    var buffer = "";
    if (justify === "+" && filter === " ") {
        for(var _for = len; _for < width; ++_for){
            buffer = buffer + filter;
        }
    }
    if (signedconv) {
        if (sign < 0) {
            buffer = buffer + "-";
        } else if (signstyle !== "-") {
            buffer = buffer + signstyle;
        }
    }
    if (alternate && base === /* Oct */ 0) {
        buffer = buffer + "0";
    }
    if (alternate && base === /* Hex */ 1) {
        buffer = buffer + "0x";
    }
    if (justify === "+" && filter === "0") {
        for(var _for$1 = len; _for$1 < width; ++_for$1){
            buffer = buffer + filter;
        }
    }
    buffer = uppercase ? buffer + rawbuffer.toUpperCase() : buffer + rawbuffer;
    if (justify === "-") {
        for(var _for$2 = len; _for$2 < width; ++_for$2){
            buffer = buffer + " ";
        }
    }
    return buffer;
}
function format_int(fmt, i) {
    if (fmt === "%d") {
        return String(i);
    }
    var f = parse_format(fmt);
    var i$1 = i < 0 ? f.signedconv ? (f.sign = -1, -i >>> 0) : i >>> 0 : i;
    var s = i$1.toString(int_of_base(f.base));
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        if (n > 0) {
            s = "0".repeat(n) + s;
        }
    }
    return finish_formatting(f, s);
}
function dec_of_pos_int64(x) {
    if (!Caml.i64_lt(x, Caml_int64.zero)) {
        return Caml_int64.to_string(x);
    }
    var wbase = [
        0,
        10
    ];
    var y = Caml_int64.discard_sign(x);
    var match = Caml_int64.div_mod(y, wbase);
    var match$1 = Caml_int64.div_mod(Caml_int64.add([
        0,
        8
    ], match[1]), wbase);
    var quotient = Caml_int64.add(Caml_int64.add([
        214748364,
        3435973836
    ], match[0]), match$1[0]);
    return Caml_int64.to_string(quotient) + "0123456789"[Caml_int64.to_int32(match$1[1])];
}
function oct_of_int64(x) {
    var s = "";
    var wbase = [
        0,
        8
    ];
    var cvtbl = "01234567";
    if (Caml.i64_lt(x, Caml_int64.zero)) {
        var y = Caml_int64.discard_sign(x);
        var match = Caml_int64.div_mod(y, wbase);
        var quotient = Caml_int64.add([
            268435456,
            0
        ], match[0]);
        var modulus = match[1];
        s = cvtbl[Caml_int64.to_int32(modulus)] + s;
        while(Caml.i64_neq(quotient, Caml_int64.zero)){
            var match$1 = Caml_int64.div_mod(quotient, wbase);
            quotient = match$1[0];
            modulus = match$1[1];
            s = cvtbl[Caml_int64.to_int32(modulus)] + s;
        }
        ;
    } else {
        var match$2 = Caml_int64.div_mod(x, wbase);
        var quotient$1 = match$2[0];
        var modulus$1 = match$2[1];
        s = cvtbl[Caml_int64.to_int32(modulus$1)] + s;
        while(Caml.i64_neq(quotient$1, Caml_int64.zero)){
            var match$3 = Caml_int64.div_mod(quotient$1, wbase);
            quotient$1 = match$3[0];
            modulus$1 = match$3[1];
            s = cvtbl[Caml_int64.to_int32(modulus$1)] + s;
        }
        ;
    }
    return s;
}
function int64_format(fmt, x) {
    if (fmt === "%d") {
        return Caml_int64.to_string(x);
    }
    var f = parse_format(fmt);
    var x$1 = f.signedconv && Caml.i64_lt(x, Caml_int64.zero) ? (f.sign = -1, Caml_int64.neg(x)) : x;
    var match = f.base;
    var s;
    switch(match){
        case /* Oct */ 0:
            s = oct_of_int64(x$1);
            break;
        case /* Hex */ 1:
            s = Caml_int64.to_hex(x$1);
            break;
        case /* Dec */ 2:
            s = dec_of_pos_int64(x$1);
            break;
    }
    var fill_s;
    if (f.prec >= 0) {
        f.filter = " ";
        var n = f.prec - s.length | 0;
        fill_s = n > 0 ? "0".repeat(n) + s : s;
    } else {
        fill_s = s;
    }
    return finish_formatting(f, fill_s);
}
function format_float(fmt, x) {
    var f = parse_format(fmt);
    var prec = f.prec < 0 ? 6 : f.prec;
    var x$1 = x < 0 ? (f.sign = -1, -x) : x;
    var s = "";
    if (isNaN(x$1)) {
        s = "nan";
        f.filter = " ";
    } else if (isFinite(x$1)) {
        var match = f.conv;
        switch(match){
            case "e":
                s = x$1.toExponential(prec);
                var i = s.length;
                if (s.codePointAt(i - 3 | 0) === /* 'e' */ 101) {
                    s = s.slice(0, i - 1 | 0) + ("0" + s.slice(i - 1 | 0));
                }
                break;
            case "f":
                s = x$1.toFixed(prec);
                break;
            case "g":
                var prec$1 = prec !== 0 ? prec : 1;
                s = x$1.toExponential(prec$1 - 1 | 0);
                var j = s.indexOf("e");
                var exp = Number(s.slice(j + 1 | 0)) | 0;
                if (exp < -4 || x$1 >= 1e21 || x$1.toFixed().length > prec$1) {
                    var i$1 = j - 1 | 0;
                    while(s.codePointAt(i$1) === /* '0' */ 48){
                        i$1 = i$1 - 1 | 0;
                    }
                    ;
                    if (s.codePointAt(i$1) === /* '.' */ 46) {
                        i$1 = i$1 - 1 | 0;
                    }
                    s = s.slice(0, i$1 + 1 | 0) + s.slice(j);
                    var i$2 = s.length;
                    if (s.codePointAt(i$2 - 3 | 0) === /* 'e' */ 101) {
                        s = s.slice(0, i$2 - 1 | 0) + ("0" + s.slice(i$2 - 1 | 0));
                    }
                } else {
                    var p = prec$1;
                    if (exp < 0) {
                        p = p - (exp + 1 | 0) | 0;
                        s = x$1.toFixed(p);
                    } else {
                        while(function() {
                            s = x$1.toFixed(p);
                            return s.length > (prec$1 + 1 | 0);
                        }()){
                            p = p - 1 | 0;
                        }
                        ;
                    }
                    if (p !== 0) {
                        var k = s.length - 1 | 0;
                        while(s.codePointAt(k) === /* '0' */ 48){
                            k = k - 1 | 0;
                        }
                        ;
                        if (s.codePointAt(k) === /* '.' */ 46) {
                            k = k - 1 | 0;
                        }
                        s = s.slice(0, k + 1 | 0);
                    }
                }
                break;
            default:
        }
    } else {
        s = "inf";
        f.filter = " ";
    }
    return finish_formatting(f, s);
}
var hexstring_of_float = function hexstring_of_float(x, prec, style) {
    if (!isFinite(x)) {
        if (isNaN(x)) return "nan";
        return x > 0 ? "infinity" : "-infinity";
    }
    var sign = x == 0 && 1 / x == -Infinity ? 1 : x >= 0 ? 0 : 1;
    if (sign) x = -x;
    var exp = 0;
    if (x == 0) {} else if (x < 1) {
        while(x < 1 && exp > -1022){
            x *= 2;
            exp--;
        }
    } else {
        while(x >= 2){
            x /= 2;
            exp++;
        }
    }
    var exp_sign = exp < 0 ? "" : "+";
    var sign_str = "";
    if (sign) sign_str = "-";
    else {
        switch(style){
            case 43 /* '+' */ :
                sign_str = "+";
                break;
            case 32 /* ' ' */ :
                sign_str = " ";
                break;
            default:
                break;
        }
    }
    if (prec >= 0 && prec < 13) {
        /* If a precision is given, and is small, round mantissa accordingly */ var cst = Math.pow(2, prec * 4);
        x = Math.round(x * cst) / cst;
    }
    var x_str = x.toString(16);
    if (prec >= 0) {
        var idx = x_str.indexOf(".");
        if (idx < 0) {
            x_str += "." + "0".repeat(prec);
        } else {
            var size = idx + 1 + prec;
            if (x_str.length < size) x_str += "0".repeat(size - x_str.length);
            else x_str = x_str.substr(0, size);
        }
    }
    return sign_str + "0x" + x_str + "p" + exp_sign + exp.toString(10);
};
var float_of_string = function float_of_string(s, exn) {
    var res = +s;
    if (s.length > 0 && res === res) return res;
    s = s.replace(/_/g, "");
    res = +s;
    if (s.length > 0 && res === res || /^[+-]?nan$/i.test(s)) {
        return res;
    }
    ;
    var m = /^ *([+-]?)0x([0-9a-f]+)\.?([0-9a-f]*)p([+-]?[0-9]+)/i.exec(s);
    //            1        2             3           4
    if (m) {
        var m3 = m[3].replace(/0+$/, "");
        var mantissa = parseInt(m[1] + m[2] + m3, 16);
        var exponent = (m[4] | 0) - 4 * m3.length;
        res = mantissa * Math.pow(2, exponent);
        return res;
    }
    if (/^\+?inf(inity)?$/i.test(s)) return Infinity;
    if (/^-inf(inity)?$/i.test(s)) return -Infinity;
    throw exn;
};
function float_of_string$1(s) {
    return float_of_string(s, {
        RE_EXN_ID: "Failure",
        _1: "float_of_string"
    });
}
 /* No side effect */ 


/***/ }),

/***/ 37082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UW": function() { return /* binding */ internalToOCamlException; }
/* harmony export */ });
/* unused harmony exports $$Error, as_js_exn */
/* harmony import */ var _caml_exceptions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86592);


var $$Error = "JsError";
function internalToOCamlException(e) {
    if (_caml_exceptions_js__WEBPACK_IMPORTED_MODULE_0__/* .is_extension */ .VR(e)) {
        return e;
    } else {
        return {
            RE_EXN_ID: "JsError",
            _1: e
        };
    }
}
function as_js_exn(exn) {
    if (exn.RE_EXN_ID === $$Error) {
        return Caml_option.some(exn._1);
    }
}
 /* No side effect */ 


/***/ }),

/***/ 84445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ notequal; },
/* harmony export */   "Dg": function() { return /* binding */ equal; },
/* harmony export */   "Ik": function() { return /* binding */ obj_dup; }
/* harmony export */ });
/* unused harmony exports update_dummy, compare, equal_null, equal_undefined, equal_nullable, greaterequal, greaterthan, lessthan, lessequal, min, max */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82222);



var for_in = function for_in(o, foo) {
    for(var x in o){
        foo(x);
    }
};
var obj_dup = function obj_dup(x) {
    if (Array.isArray(x)) {
        var len = x.length;
        var v = new Array(len);
        for(var i = 0; i < len; ++i){
            v[i] = x[i];
        }
        if (x.TAG !== undefined) {
            v.TAG = x.TAG // TODO this can be removed eventually
            ;
        }
        return v;
    }
    return Object.assign({}, x);
};
var update_dummy = function update_dummy(x, y) {
    var k;
    if (Array.isArray(y)) {
        for(k = 0; k < y.length; ++k){
            x[k] = y[k];
        }
        if (y.TAG !== undefined) {
            x.TAG = y.TAG;
        }
    } else {
        for(var k in y){
            x[k] = y[k];
        }
    }
};
function compare(a, b) {
    if (a === b) {
        return 0;
    }
    var a_type = typeof a === "undefined" ? "undefined" : _type_of(a);
    var b_type = typeof b === "undefined" ? "undefined" : _type_of(b);
    switch(a_type){
        case "boolean":
            if (b_type === "boolean") {
                return Caml.bool_compare(a, b);
            }
            break;
        case "function":
            if (b_type === "function") {
                throw {
                    RE_EXN_ID: "Invalid_argument",
                    _1: "compare: functional value",
                    Error: new Error()
                };
            }
            break;
        case "number":
            if (b_type === "number") {
                return Caml.float_compare(a, b);
            }
            break;
        case "string":
            if (b_type === "string") {
                return Caml.string_compare(a, b);
            } else {
                return 1;
            }
        case "undefined":
            return -1;
        default:
    }
    switch(b_type){
        case "string":
            return -1;
        case "undefined":
            return 1;
        default:
            if (a_type === "boolean") {
                return 1;
            }
            if (b_type === "boolean") {
                return -1;
            }
            if (a_type === "function") {
                return 1;
            }
            if (b_type === "function") {
                return -1;
            }
            if (a_type === "number") {
                if (b === null || b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                    return 1;
                } else {
                    return -1;
                }
            }
            if (b_type === "number") {
                if (a === null || a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                    return -1;
                } else {
                    return 1;
                }
            }
            if (a === null) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                    return 1;
                } else {
                    return -1;
                }
            }
            if (b === null) {
                if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                    return -1;
                } else {
                    return 1;
                }
            }
            if (a.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                if (b.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
                    return aux_obj_compare(a, b);
                } else {
                    return -1;
                }
            }
            var tag_a = a.TAG | 0;
            var tag_b = b.TAG | 0;
            if (tag_a === 248) {
                return Caml.int_compare(a[1], b[1]);
            }
            if (tag_a === 251) {
                throw {
                    RE_EXN_ID: "Invalid_argument",
                    _1: "equal: abstract value",
                    Error: new Error()
                };
            }
            if (tag_a !== tag_b) {
                if (tag_a < tag_b) {
                    return -1;
                } else {
                    return 1;
                }
            }
            var len_a = a.length | 0;
            var len_b = b.length | 0;
            if (len_a === len_b) {
                if (Array.isArray(a)) {
                    var _i = 0;
                    while(true){
                        var i = _i;
                        if (i === len_a) {
                            return 0;
                        }
                        var res = compare(a[i], b[i]);
                        if (res !== 0) {
                            return res;
                        }
                        _i = i + 1 | 0;
                        continue;
                    }
                    ;
                } else if (_instanceof(a, Date) && _instanceof(b, Date)) {
                    return a - b;
                } else {
                    return aux_obj_compare(a, b);
                }
            } else if (len_a < len_b) {
                var _i$1 = 0;
                while(true){
                    var i$1 = _i$1;
                    if (i$1 === len_a) {
                        return -1;
                    }
                    var res$1 = compare(a[i$1], b[i$1]);
                    if (res$1 !== 0) {
                        return res$1;
                    }
                    _i$1 = i$1 + 1 | 0;
                    continue;
                }
                ;
            } else {
                var _i$2 = 0;
                while(true){
                    var i$2 = _i$2;
                    if (i$2 === len_b) {
                        return 1;
                    }
                    var res$2 = compare(a[i$2], b[i$2]);
                    if (res$2 !== 0) {
                        return res$2;
                    }
                    _i$2 = i$2 + 1 | 0;
                    continue;
                }
                ;
            }
    }
}
function aux_obj_compare(a, b) {
    var min_key_lhs = {
        contents: undefined
    };
    var min_key_rhs = {
        contents: undefined
    };
    var do_key = function do_key(param, key) {
        var min_key = param[2];
        var _$b = param[1];
        if (!(!Object.prototype.hasOwnProperty.call(_$b, key) || compare(param[0][key], _$b[key]) > 0)) {
            return;
        }
        var mk = min_key.contents;
        if (mk !== undefined && key >= mk) {
            return;
        } else {
            min_key.contents = key;
            return;
        }
    };
    var partial_arg = [
        a,
        b,
        min_key_rhs
    ];
    var do_key_a = function do_key_a(param) {
        return do_key(partial_arg, param);
    };
    var partial_arg$1 = [
        b,
        a,
        min_key_lhs
    ];
    var do_key_b = function do_key_b(param) {
        return do_key(partial_arg$1, param);
    };
    for_in(a, do_key_a);
    for_in(b, do_key_b);
    var match = min_key_lhs.contents;
    var match$1 = min_key_rhs.contents;
    if (match !== undefined) {
        if (match$1 !== undefined) {
            return Caml.string_compare(match, match$1);
        } else {
            return -1;
        }
    } else if (match$1 !== undefined) {
        return 1;
    } else {
        return 0;
    }
}
function equal(a, b) {
    if (a === b) {
        return true;
    }
    var a_type = typeof a === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(a);
    if (a_type === "string" || a_type === "number" || a_type === "boolean" || a_type === "undefined" || a === null) {
        return false;
    }
    var b_type = typeof b === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(b);
    if (a_type === "function" || b_type === "function") {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "equal: functional value",
            Error: new Error()
        };
    }
    if (b_type === "number" || b_type === "undefined" || b === null) {
        return false;
    }
    var tag_a = a.TAG | 0;
    var tag_b = b.TAG | 0;
    if (tag_a === 248) {
        return a[1] === b[1];
    }
    if (tag_a === 251) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "equal: abstract value",
            Error: new Error()
        };
    }
    if (tag_a !== tag_b) {
        return false;
    }
    var len_a = a.length | 0;
    var len_b = b.length | 0;
    if (len_a === len_b) {
        if (Array.isArray(a)) {
            var _i = 0;
            while(true){
                var i = _i;
                if (i === len_a) {
                    return true;
                }
                if (!equal(a[i], b[i])) {
                    return false;
                }
                _i = i + 1 | 0;
                continue;
            }
            ;
        } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(a, Date) && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(b, Date)) {
            return !(a > b || a < b);
        } else {
            var result = {
                contents: true
            };
            var do_key_a = function do_key_a(key) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    result.contents = false;
                    return;
                }
            };
            var do_key_b = function do_key_b(key) {
                if (!Object.prototype.hasOwnProperty.call(a, key) || !equal(b[key], a[key])) {
                    result.contents = false;
                    return;
                }
            };
            for_in(a, do_key_a);
            if (result.contents) {
                for_in(b, do_key_b);
            }
            return result.contents;
        }
    } else {
        return false;
    }
}
function equal_null(x, y) {
    if (y !== null) {
        return equal(x, y);
    } else {
        return x === y;
    }
}
function equal_undefined(x, y) {
    if (y !== undefined) {
        return equal(x, y);
    } else {
        return x === y;
    }
}
function equal_nullable(x, y) {
    if (y == null) {
        return x === y;
    } else {
        return equal(x, y);
    }
}
function notequal(a, b) {
    if (typeof a === "number" && typeof b === "number") {
        return a !== b;
    } else {
        return !equal(a, b);
    }
}
function greaterequal(a, b) {
    if (typeof a === "number" && typeof b === "number") {
        return a >= b;
    } else {
        return compare(a, b) >= 0;
    }
}
function greaterthan(a, b) {
    if (typeof a === "number" && typeof b === "number") {
        return a > b;
    } else {
        return compare(a, b) > 0;
    }
}
function lessequal(a, b) {
    if (typeof a === "number" && typeof b === "number") {
        return a <= b;
    } else {
        return compare(a, b) <= 0;
    }
}
function lessthan(a, b) {
    if (typeof a === "number" && typeof b === "number") {
        return a < b;
    } else {
        return compare(a, b) < 0;
    }
}
function min(x, y) {
    if (compare(x, y) <= 0) {
        return x;
    } else {
        return y;
    }
}
function max(x, y) {
    if (compare(x, y) >= 0) {
        return x;
    } else {
        return y;
    }
}
 /* No side effect */ 


/***/ }),

/***/ 25400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ some; },
/* harmony export */   "Tl": function() { return /* binding */ nullable_to_opt; },
/* harmony export */   "UA": function() { return /* binding */ null_to_opt; },
/* harmony export */   "xt": function() { return /* binding */ valFromOption; }
/* harmony export */ });
/* unused harmony exports undefined_to_opt, isNested, option_get, option_unwrap */
function isNested(x) {
    return x.BS_PRIVATE_NESTED_SOME_NONE !== undefined;
}
function some(x) {
    if (x === undefined) {
        return {
            BS_PRIVATE_NESTED_SOME_NONE: 0
        };
    } else if (x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined) {
        return {
            BS_PRIVATE_NESTED_SOME_NONE: x.BS_PRIVATE_NESTED_SOME_NONE + 1 | 0
        };
    } else {
        return x;
    }
}
function nullable_to_opt(x) {
    if (x == null) {
        return;
    } else {
        return some(x);
    }
}
function undefined_to_opt(x) {
    if (x === undefined) {
        return;
    } else {
        return some(x);
    }
}
function null_to_opt(x) {
    if (x === null) {
        return;
    } else {
        return some(x);
    }
}
function valFromOption(x) {
    if (!(x !== null && x.BS_PRIVATE_NESTED_SOME_NONE !== undefined)) {
        return x;
    }
    var depth = x.BS_PRIVATE_NESTED_SOME_NONE;
    if (depth === 0) {
        return;
    } else {
        return {
            BS_PRIVATE_NESTED_SOME_NONE: depth - 1 | 0
        };
    }
}
function option_get(x) {
    if (x === undefined) {
        return;
    } else {
        return valFromOption(x);
    }
}
function option_unwrap(x) {
    if (x !== undefined) {
        return x.VAL;
    } else {
        return x;
    }
}
 /* No side effect */ 


/***/ }),

/***/ 92592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_1": function() { return /* binding */ _1; },
/* harmony export */   "_2": function() { return /* binding */ _2; },
/* harmony export */   "_3": function() { return /* binding */ _3; },
/* harmony export */   "_4": function() { return /* binding */ _4; },
/* harmony export */   "_5": function() { return /* binding */ _5; },
/* harmony export */   "_6": function() { return /* binding */ _6; },
/* harmony export */   "_7": function() { return /* binding */ _7; },
/* harmony export */   "_8": function() { return /* binding */ _8; },
/* harmony export */   "__1": function() { return /* binding */ __1; },
/* harmony export */   "__2": function() { return /* binding */ __2; },
/* harmony export */   "__3": function() { return /* binding */ __3; },
/* harmony export */   "__4": function() { return /* binding */ __4; },
/* harmony export */   "__5": function() { return /* binding */ __5; },
/* harmony export */   "__6": function() { return /* binding */ __6; },
/* harmony export */   "__7": function() { return /* binding */ __7; },
/* harmony export */   "__8": function() { return /* binding */ __8; },
/* harmony export */   "app": function() { return /* binding */ app; }
/* harmony export */ });
/* harmony import */ var _caml_array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46150);

function app(_f, _args) {
    while(true){
        var args = _args;
        var f = _f;
        var init_arity = f.length;
        var arity = init_arity === 0 ? 1 : init_arity;
        var len = args.length;
        var d = arity - len | 0;
        if (d === 0) {
            return f.apply(null, args);
        }
        if (d >= 0) {
            return function(f, args) {
                return function(x) {
                    return app(f, args.concat([
                        x
                    ]));
                };
            }(f, args);
        }
        _args = _caml_array_js__WEBPACK_IMPORTED_MODULE_0__/* .sub */ .lu(args, arity, -d | 0);
        _f = f.apply(null, _caml_array_js__WEBPACK_IMPORTED_MODULE_0__/* .sub */ .lu(args, 0, arity));
        continue;
    }
    ;
}
function _1(o, a0) {
    var arity = o.length;
    if (arity === 1) {
        return o(a0);
    } else {
        switch(arity){
            case 1:
                return o(a0);
            case 2:
                return function(param) {
                    return o(a0, param);
                };
            case 3:
                return function(param, param$1) {
                    return o(a0, param, param$1);
                };
            case 4:
                return function(param, param$1, param$2) {
                    return o(a0, param, param$1, param$2);
                };
            case 5:
                return function(param, param$1, param$2, param$3) {
                    return o(a0, param, param$1, param$2, param$3);
                };
            case 6:
                return function(param, param$1, param$2, param$3, param$4) {
                    return o(a0, param, param$1, param$2, param$3, param$4);
                };
            case 7:
                return function(param, param$1, param$2, param$3, param$4, param$5) {
                    return o(a0, param, param$1, param$2, param$3, param$4, param$5);
                };
            default:
                return app(o, [
                    a0
                ]);
        }
    }
}
function __1(o) {
    var arity = o.length;
    if (arity === 1) {
        return o;
    } else {
        return function(a0) {
            return _1(o, a0);
        };
    }
}
function _2(o, a0, a1) {
    var arity = o.length;
    if (arity === 2) {
        return o(a0, a1);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1
                ]);
            case 2:
                return o(a0, a1);
            case 3:
                return function(param) {
                    return o(a0, a1, param);
                };
            case 4:
                return function(param, param$1) {
                    return o(a0, a1, param, param$1);
                };
            case 5:
                return function(param, param$1, param$2) {
                    return o(a0, a1, param, param$1, param$2);
                };
            case 6:
                return function(param, param$1, param$2, param$3) {
                    return o(a0, a1, param, param$1, param$2, param$3);
                };
            case 7:
                return function(param, param$1, param$2, param$3, param$4) {
                    return o(a0, a1, param, param$1, param$2, param$3, param$4);
                };
            default:
                return app(o, [
                    a0,
                    a1
                ]);
        }
    }
}
function __2(o) {
    var arity = o.length;
    if (arity === 2) {
        return o;
    } else {
        return function(a0, a1) {
            return _2(o, a0, a1);
        };
    }
}
function _3(o, a0, a1, a2) {
    var arity = o.length;
    if (arity === 3) {
        return o(a0, a1, a2);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2
                ]);
            case 3:
                return o(a0, a1, a2);
            case 4:
                return function(param) {
                    return o(a0, a1, a2, param);
                };
            case 5:
                return function(param, param$1) {
                    return o(a0, a1, a2, param, param$1);
                };
            case 6:
                return function(param, param$1, param$2) {
                    return o(a0, a1, a2, param, param$1, param$2);
                };
            case 7:
                return function(param, param$1, param$2, param$3) {
                    return o(a0, a1, a2, param, param$1, param$2, param$3);
                };
            default:
                return app(o, [
                    a0,
                    a1,
                    a2
                ]);
        }
    }
}
function __3(o) {
    var arity = o.length;
    if (arity === 3) {
        return o;
    } else {
        return function(a0, a1, a2) {
            return _3(o, a0, a1, a2);
        };
    }
}
function _4(o, a0, a1, a2, a3) {
    var arity = o.length;
    if (arity === 4) {
        return o(a0, a1, a2, a3);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2,
                    a3
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2,
                    a3
                ]);
            case 3:
                return app(o(a0, a1, a2), [
                    a3
                ]);
            case 4:
                return o(a0, a1, a2, a3);
            case 5:
                return function(param) {
                    return o(a0, a1, a2, a3, param);
                };
            case 6:
                return function(param, param$1) {
                    return o(a0, a1, a2, a3, param, param$1);
                };
            case 7:
                return function(param, param$1, param$2) {
                    return o(a0, a1, a2, a3, param, param$1, param$2);
                };
            default:
                return app(o, [
                    a0,
                    a1,
                    a2,
                    a3
                ]);
        }
    }
}
function __4(o) {
    var arity = o.length;
    if (arity === 4) {
        return o;
    } else {
        return function(a0, a1, a2, a3) {
            return _4(o, a0, a1, a2, a3);
        };
    }
}
function _5(o, a0, a1, a2, a3, a4) {
    var arity = o.length;
    if (arity === 5) {
        return o(a0, a1, a2, a3, a4);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2,
                    a3,
                    a4
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2,
                    a3,
                    a4
                ]);
            case 3:
                return app(o(a0, a1, a2), [
                    a3,
                    a4
                ]);
            case 4:
                return app(o(a0, a1, a2, a3), [
                    a4
                ]);
            case 5:
                return o(a0, a1, a2, a3, a4);
            case 6:
                return function(param) {
                    return o(a0, a1, a2, a3, a4, param);
                };
            case 7:
                return function(param, param$1) {
                    return o(a0, a1, a2, a3, a4, param, param$1);
                };
            default:
                return app(o, [
                    a0,
                    a1,
                    a2,
                    a3,
                    a4
                ]);
        }
    }
}
function __5(o) {
    var arity = o.length;
    if (arity === 5) {
        return o;
    } else {
        return function(a0, a1, a2, a3, a4) {
            return _5(o, a0, a1, a2, a3, a4);
        };
    }
}
function _6(o, a0, a1, a2, a3, a4, a5) {
    var arity = o.length;
    if (arity === 6) {
        return o(a0, a1, a2, a3, a4, a5);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2,
                    a3,
                    a4,
                    a5
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2,
                    a3,
                    a4,
                    a5
                ]);
            case 3:
                return app(o(a0, a1, a2), [
                    a3,
                    a4,
                    a5
                ]);
            case 4:
                return app(o(a0, a1, a2, a3), [
                    a4,
                    a5
                ]);
            case 5:
                return app(o(a0, a1, a2, a3, a4), [
                    a5
                ]);
            case 6:
                return o(a0, a1, a2, a3, a4, a5);
            case 7:
                return function(param) {
                    return o(a0, a1, a2, a3, a4, a5, param);
                };
            default:
                return app(o, [
                    a0,
                    a1,
                    a2,
                    a3,
                    a4,
                    a5
                ]);
        }
    }
}
function __6(o) {
    var arity = o.length;
    if (arity === 6) {
        return o;
    } else {
        return function(a0, a1, a2, a3, a4, a5) {
            return _6(o, a0, a1, a2, a3, a4, a5);
        };
    }
}
function _7(o, a0, a1, a2, a3, a4, a5, a6) {
    var arity = o.length;
    if (arity === 7) {
        return o(a0, a1, a2, a3, a4, a5, a6);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2,
                    a3,
                    a4,
                    a5,
                    a6
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2,
                    a3,
                    a4,
                    a5,
                    a6
                ]);
            case 3:
                return app(o(a0, a1, a2), [
                    a3,
                    a4,
                    a5,
                    a6
                ]);
            case 4:
                return app(o(a0, a1, a2, a3), [
                    a4,
                    a5,
                    a6
                ]);
            case 5:
                return app(o(a0, a1, a2, a3, a4), [
                    a5,
                    a6
                ]);
            case 6:
                return app(o(a0, a1, a2, a3, a4, a5), [
                    a6
                ]);
            case 7:
                return o(a0, a1, a2, a3, a4, a5, a6);
            default:
                return app(o, [
                    a0,
                    a1,
                    a2,
                    a3,
                    a4,
                    a5,
                    a6
                ]);
        }
    }
}
function __7(o) {
    var arity = o.length;
    if (arity === 7) {
        return o;
    } else {
        return function(a0, a1, a2, a3, a4, a5, a6) {
            return _7(o, a0, a1, a2, a3, a4, a5, a6);
        };
    }
}
function _8(o, a0, a1, a2, a3, a4, a5, a6, a7) {
    var arity = o.length;
    if (arity === 8) {
        return o(a0, a1, a2, a3, a4, a5, a6, a7);
    } else {
        switch(arity){
            case 1:
                return app(o(a0), [
                    a1,
                    a2,
                    a3,
                    a4,
                    a5,
                    a6,
                    a7
                ]);
            case 2:
                return app(o(a0, a1), [
                    a2,
                    a3,
                    a4,
                    a5,
                    a6,
                    a7
                ]);
            case 3:
                return app(o(a0, a1, a2), [
                    a3,
                    a4,
                    a5,
                    a6,
                    a7
                ]);
            case 4:
                return app(o(a0, a1, a2, a3), [
                    a4,
                    a5,
                    a6,
                    a7
                ]);
            case 5:
                return app(o(a0, a1, a2, a3, a4), [
                    a5,
                    a6,
                    a7
                ]);
            case 6:
                return app(o(a0, a1, a2, a3, a4, a5), [
                    a6,
                    a7
                ]);
            case 7:
                return app(o(a0, a1, a2, a3, a4, a5, a6), [
                    a7
                ]);
            default:
                return app(o, [
                    a0,
                    a1,
                    a2,
                    a3,
                    a4,
                    a5,
                    a6,
                    a7
                ]);
        }
    }
}
function __8(o) {
    var arity = o.length;
    if (arity === 8) {
        return o;
    } else {
        return function(a0, a1, a2, a3, a4, a5, a6, a7) {
            return _8(o, a0, a1, a2, a3, a4, a5, a6, a7);
        };
    }
}
 /* No side effect */ 


/***/ }),

/***/ 32867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "q9": function() { return /* binding */ includes; },
/* harmony export */   "u4": function() { return /* binding */ reduce; },
/* harmony export */   "x1": function() { return /* binding */ mapi; },
/* harmony export */   "zo": function() { return /* binding */ concat; }
/* harmony export */ });
/* unused harmony exports copyWithin, copyWithinFrom, copyWithinFromRange, fillInPlace, fillFromInPlace, fillRangeInPlace, push, pushMany, sortInPlaceWith, spliceInPlace, removeFromInPlace, removeCountInPlace, unshift, unshiftMany, concatMany, indexOf, indexOfFrom, joinWith, lastIndexOf, lastIndexOfFrom, slice, sliceFrom, every, everyi, filter, filteri, find, findi, findIndex, findIndexi, forEachi, reducei, reduceRight, reduceRighti, some, somei */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92592);



function copyWithin(to_, obj) {
    return obj.copyWithin(to_);
}
function copyWithinFrom(to_, from, obj) {
    return obj.copyWithin(to_, from);
}
function copyWithinFromRange(to_, start, end_, obj) {
    return obj.copyWithin(to_, start, end_);
}
function fillInPlace(arg1, obj) {
    return obj.fill(arg1);
}
function fillFromInPlace(arg1, from, obj) {
    return obj.fill(arg1, from);
}
function fillRangeInPlace(arg1, start, end_, obj) {
    return obj.fill(arg1, start, end_);
}
function push(arg1, obj) {
    return obj.push(arg1);
}
function pushMany(arg1, obj) {
    return Caml_splice_call.spliceObjApply(obj, "push", [
        arg1
    ]);
}
function sortInPlaceWith(arg1, obj) {
    return obj.sort(Curry.__2(arg1));
}
function spliceInPlace(pos, remove, add, obj) {
    return Caml_splice_call.spliceObjApply(obj, "splice", [
        pos,
        remove,
        add
    ]);
}
function removeFromInPlace(pos, obj) {
    return obj.splice(pos);
}
function removeCountInPlace(pos, count, obj) {
    return obj.splice(pos, count);
}
function unshift(arg1, obj) {
    return obj.unshift(arg1);
}
function unshiftMany(arg1, obj) {
    return Caml_splice_call.spliceObjApply(obj, "unshift", [
        arg1
    ]);
}
function concat(arg1, obj) {
    return obj.concat(arg1);
}
function concatMany(arg1, obj) {
    return Caml_splice_call.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function includes(arg1, obj) {
    return obj.includes(arg1);
}
function indexOf(arg1, obj) {
    return obj.indexOf(arg1);
}
function indexOfFrom(arg1, from, obj) {
    return obj.indexOf(arg1, from);
}
function joinWith(arg1, obj) {
    return obj.join(arg1);
}
function lastIndexOf(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function lastIndexOfFrom(arg1, from, obj) {
    return obj.lastIndexOf(arg1, from);
}
function slice(start, end_, obj) {
    return obj.slice(start, end_);
}
function sliceFrom(arg1, obj) {
    return obj.slice(arg1);
}
function every(arg1, obj) {
    return obj.every(Curry.__1(arg1));
}
function everyi(arg1, obj) {
    return obj.every(Curry.__2(arg1));
}
function filter(arg1, obj) {
    return obj.filter(Curry.__1(arg1));
}
function filteri(arg1, obj) {
    return obj.filter(Curry.__2(arg1));
}
function find(arg1, obj) {
    return Caml_option.undefined_to_opt(obj.find(Curry.__1(arg1)));
}
function findi(arg1, obj) {
    return Caml_option.undefined_to_opt(obj.find(Curry.__2(arg1)));
}
function findIndex(arg1, obj) {
    return obj.findIndex(Curry.__1(arg1));
}
function findIndexi(arg1, obj) {
    return obj.findIndex(Curry.__2(arg1));
}
function forEach(arg1, obj) {
    obj.forEach(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(arg1));
}
function forEachi(arg1, obj) {
    obj.forEach(Curry.__2(arg1));
}
function map(arg1, obj) {
    return obj.map(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(arg1));
}
function mapi(arg1, obj) {
    return obj.map(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__2(arg1));
}
function reduce(arg1, arg2, obj) {
    return obj.reduce(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__2(arg1), arg2);
}
function reducei(arg1, arg2, obj) {
    return obj.reduce(Curry.__3(arg1), arg2);
}
function reduceRight(arg1, arg2, obj) {
    return obj.reduceRight(Curry.__2(arg1), arg2);
}
function reduceRighti(arg1, arg2, obj) {
    return obj.reduceRight(Curry.__3(arg1), arg2);
}
function some(arg1, obj) {
    return obj.some(Curry.__1(arg1));
}
function somei(arg1, obj) {
    return obj.some(Curry.__2(arg1));
}
 /* No side effect */ 


/***/ }),

/***/ 43437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U2": function() { return /* binding */ get; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "hy": function() { return /* binding */ fromList; },
/* harmony export */   "nI": function() { return /* binding */ fromArray; },
/* harmony export */   "qh": function() { return /* binding */ entries; }
/* harmony export */ });
/* unused harmony exports unsafeDeleteKey, values */
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);

function get(dict, k) {
    if (k in dict) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(dict[k]);
    }
}
var unsafeDeleteKey = function unsafeDeleteKey(dict, key) {
    delete dict[key];
};
function entries(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values = new Array(l);
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        values[i] = [
            key,
            dict[key]
        ];
    }
    return values;
}
function values(dict) {
    var keys = Object.keys(dict);
    var l = keys.length;
    var values$1 = new Array(l);
    for(var i = 0; i < l; ++i){
        values$1[i] = dict[keys[i]];
    }
    return values$1;
}
function fromList(entries) {
    var dict = {};
    var _param = entries;
    while(true){
        var param = _param;
        if (!param) {
            return dict;
        }
        var match = param.hd;
        dict[match[0]] = match[1];
        _param = param.tl;
        continue;
    }
    ;
}
function fromArray(entries) {
    var dict = {};
    var l = entries.length;
    for(var i = 0; i < l; ++i){
        var match = entries[i];
        dict[match[0]] = match[1];
    }
    return dict;
}
function map(f, source) {
    var target = {};
    var keys = Object.keys(source);
    var l = keys.length;
    for(var i = 0; i < l; ++i){
        var key = keys[i];
        target[key] = f(source[key]);
    }
    return target;
}
 /* No side effect */ 


/***/ }),

/***/ 49263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KL": function() { return /* binding */ raiseError; },
/* harmony export */   "lC": function() { return /* binding */ $$Error$1; }
/* harmony export */ });
/* unused harmony exports raiseEvalError, raiseRangeError, raiseReferenceError, raiseSyntaxError, raiseTypeError, raiseUriError */
function raiseError(str) {
    throw new Error(str);
}
function raiseEvalError(str) {
    throw new EvalError(str);
}
function raiseRangeError(str) {
    throw new RangeError(str);
}
function raiseReferenceError(str) {
    throw new ReferenceError(str);
}
function raiseSyntaxError(str) {
    throw new SyntaxError(str);
}
function raiseTypeError(str) {
    throw new TypeError(str);
}
function raiseUriError(str) {
    throw new URIError(str);
}
var $$Error$1 = "JsError";
 /* No side effect */ 


/***/ }),

/***/ 94518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yo": function() { return /* binding */ fromOption; }
/* harmony export */ });
/* unused harmony exports test, getExn, bind, iter, from_opt */
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);

function test(x) {
    return x === null;
}
function getExn(f) {
    if (f !== null) {
        return f;
    }
    throw new Error("Js.Null.getExn");
}
function bind(x, f) {
    if (x !== null) {
        return f(x);
    } else {
        return null;
    }
}
function iter(x, f) {
    if (x !== null) {
        return f(x);
    }
}
function fromOption(x) {
    if (x !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(x);
    } else {
        return null;
    }
}
var from_opt = (/* unused pure expression or super */ null && (fromOption));
 /* No side effect */ 


/***/ }),

/***/ 11236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yo": function() { return /* binding */ fromOption; },
/* harmony export */   "he": function() { return /* binding */ iter; }
/* harmony export */ });
/* unused harmony exports bind, from_opt */
/* harmony import */ var _caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);

function bind(x, f) {
    if (x == null) {
        return x;
    } else {
        return f(x);
    }
}
function iter(x, f) {
    if (!(x == null)) {
        return f(x);
    }
}
function fromOption(x) {
    if (x !== undefined) {
        return _caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(x);
    }
}
var from_opt = (/* unused pure expression or super */ null && (fromOption));
 /* No side effect */ 


/***/ }),

/***/ 27097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ then_; },
/* harmony export */   "y": function() { return /* binding */ $$catch; }
/* harmony export */ });
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92592);

function then_(arg1, obj) {
    return obj.then(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(arg1));
}
function $$catch(arg1, obj) {
    return obj.catch(_curry_js__WEBPACK_IMPORTED_MODULE_0__.__1(arg1));
}
 /* No side effect */ 


/***/ }),

/***/ 37712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M4": function() { return /* binding */ splitByRe; },
/* harmony export */   "Ny": function() { return /* binding */ startsWith; },
/* harmony export */   "Vl": function() { return /* binding */ split; },
/* harmony export */   "jt": function() { return /* binding */ replaceByRe; },
/* harmony export */   "lu": function() { return /* binding */ sliceToEnd; },
/* harmony export */   "yC": function() { return /* binding */ search; },
/* harmony export */   "zo": function() { return /* binding */ concat; }
/* harmony export */ });
/* unused harmony exports charAt, charCodeAt, codePointAt, concatMany, endsWith, endsWithFrom, includes, includesFrom, indexOf, indexOfFrom, lastIndexOf, lastIndexOfFrom, localeCompare, match_, normalizeByForm, repeat, replace, unsafeReplaceBy0, unsafeReplaceBy1, unsafeReplaceBy2, unsafeReplaceBy3, slice, splitAtMost, splitByReAtMost, startsWithFrom, substr, substrAtMost, substring, substringToEnd, anchor, link */



function charAt(arg1, obj) {
    return obj.charAt(arg1);
}
function charCodeAt(arg1, obj) {
    return obj.charCodeAt(arg1);
}
function codePointAt(arg1, obj) {
    return obj.codePointAt(arg1);
}
function concat(arg1, obj) {
    return obj.concat(arg1);
}
function concatMany(arg1, obj) {
    return Caml_splice_call.spliceObjApply(obj, "concat", [
        arg1
    ]);
}
function endsWith(arg1, obj) {
    return obj.endsWith(arg1);
}
function endsWithFrom(arg1, arg2, obj) {
    return obj.endsWith(arg1, arg2);
}
function includes(arg1, obj) {
    return obj.includes(arg1);
}
function includesFrom(arg1, arg2, obj) {
    return obj.includes(arg1, arg2);
}
function indexOf(arg1, obj) {
    return obj.indexOf(arg1);
}
function indexOfFrom(arg1, arg2, obj) {
    return obj.indexOf(arg1, arg2);
}
function lastIndexOf(arg1, obj) {
    return obj.lastIndexOf(arg1);
}
function lastIndexOfFrom(arg1, arg2, obj) {
    return obj.lastIndexOf(arg1, arg2);
}
function localeCompare(arg1, obj) {
    return obj.localeCompare(arg1);
}
function match_(arg1, obj) {
    return Caml_option.null_to_opt(obj.match(arg1));
}
function normalizeByForm(arg1, obj) {
    return obj.normalize(arg1);
}
function repeat(arg1, obj) {
    return obj.repeat(arg1);
}
function replace(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function replaceByRe(arg1, arg2, obj) {
    return obj.replace(arg1, arg2);
}
function unsafeReplaceBy0(arg1, arg2, obj) {
    return obj.replace(arg1, Curry.__3(arg2));
}
function unsafeReplaceBy1(arg1, arg2, obj) {
    return obj.replace(arg1, Curry.__4(arg2));
}
function unsafeReplaceBy2(arg1, arg2, obj) {
    return obj.replace(arg1, Curry.__5(arg2));
}
function unsafeReplaceBy3(arg1, arg2, obj) {
    return obj.replace(arg1, Curry.__6(arg2));
}
function search(arg1, obj) {
    return obj.search(arg1);
}
function slice(from, to_, obj) {
    return obj.slice(from, to_);
}
function sliceToEnd(from, obj) {
    return obj.slice(from);
}
function split(arg1, obj) {
    return obj.split(arg1);
}
function splitAtMost(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function splitByRe(arg1, obj) {
    return obj.split(arg1);
}
function splitByReAtMost(arg1, limit, obj) {
    return obj.split(arg1, limit);
}
function startsWith(arg1, obj) {
    return obj.startsWith(arg1);
}
function startsWithFrom(arg1, arg2, obj) {
    return obj.startsWith(arg1, arg2);
}
function substr(from, obj) {
    return obj.substr(from);
}
function substrAtMost(from, length, obj) {
    return obj.substr(from, length);
}
function substring(from, to_, obj) {
    return obj.substring(from, to_);
}
function substringToEnd(from, obj) {
    return obj.substring(from);
}
function anchor(arg1, obj) {
    return obj.anchor(arg1);
}
function link(arg1, obj) {
    return obj.link(arg1);
}
 /* No side effect */ 


/***/ }),

/***/ 62494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "gv": function() { return /* binding */ fold_left; },
/* harmony export */   "kE": function() { return /* binding */ length; },
/* harmony export */   "yG": function() { return /* binding */ assoc; }
/* harmony export */ });
/* unused harmony exports compare_lengths, compare_length_with, cons, hd, tl, nth, nth_opt, rev, init, append, rev_append, concat, flatten, iter, iteri, mapi, rev_map, fold_right, iter2, map2, rev_map2, fold_left2, fold_right2, for_all, exists, for_all2, exists2, mem, memq, find, find_opt, filter, find_all, partition, assoc_opt, assq, assq_opt, mem_assoc, mem_assq, remove_assoc, remove_assq, split, combine, sort, stable_sort, fast_sort, sort_uniq, merge */
/* harmony import */ var _curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _caml_obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84445);
/* harmony import */ var _pervasives_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60702);




function length(l) {
    var _len = 0;
    var _param = l;
    while(true){
        var param = _param;
        var len = _len;
        if (!param) {
            return len;
        }
        _param = param.tl;
        _len = len + 1 | 0;
        continue;
    }
    ;
}
function cons(a, l) {
    return {
        hd: a,
        tl: l
    };
}
function hd(param) {
    if (param) {
        return param.hd;
    }
    throw {
        RE_EXN_ID: "Failure",
        _1: "hd",
        Error: new Error()
    };
}
function tl(param) {
    if (param) {
        return param.tl;
    }
    throw {
        RE_EXN_ID: "Failure",
        _1: "tl",
        Error: new Error()
    };
}
function nth(l, n) {
    if (n < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.nth",
            Error: new Error()
        };
    }
    var _l = l;
    var _n = n;
    while(true){
        var n$1 = _n;
        var l$1 = _l;
        if (l$1) {
            if (n$1 === 0) {
                return l$1.hd;
            }
            _n = n$1 - 1 | 0;
            _l = l$1.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Failure",
            _1: "nth",
            Error: new Error()
        };
    }
    ;
}
function nth_opt(l, n) {
    if (n < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.nth",
            Error: new Error()
        };
    }
    var _l = l;
    var _n = n;
    while(true){
        var n$1 = _n;
        var l$1 = _l;
        if (!l$1) {
            return;
        }
        if (n$1 === 0) {
            return Caml_option.some(l$1.hd);
        }
        _n = n$1 - 1 | 0;
        _l = l$1.tl;
        continue;
    }
    ;
}
function rev_append(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            return l2;
        }
        _l2 = {
            hd: l1.hd,
            tl: l2
        };
        _l1 = l1.tl;
        continue;
    }
    ;
}
function rev(l) {
    return rev_append(l, /* [] */ 0);
}
function init_tailrec_aux(_acc, _i, n, f) {
    while(true){
        var i = _i;
        var acc = _acc;
        if (i >= n) {
            return acc;
        }
        _i = i + 1 | 0;
        _acc = {
            hd: Curry._1(f, i),
            tl: acc
        };
        continue;
    }
    ;
}
function init_aux(i, n, f) {
    if (i >= n) {
        return /* [] */ 0;
    }
    var r = Curry._1(f, i);
    return {
        hd: r,
        tl: init_aux(i + 1 | 0, n, f)
    };
}
function init(len, f) {
    if (len < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.init",
            Error: new Error()
        };
    }
    if (len > 10000) {
        return rev_append(init_tailrec_aux(/* [] */ 0, 0, len, f), /* [] */ 0);
    } else {
        return init_aux(0, len, f);
    }
}
function flatten(param) {
    if (param) {
        return Pervasives.$at(param.hd, flatten(param.tl));
    } else {
        return /* [] */ 0;
    }
}
function map(f, param) {
    if (!param) {
        return /* [] */ 0;
    }
    var r = _curry_js__WEBPACK_IMPORTED_MODULE_1__._1(f, param.hd);
    return {
        hd: r,
        tl: map(f, param.tl)
    };
}
function mapi(i, f, param) {
    if (!param) {
        return /* [] */ 0;
    }
    var r = Curry._2(f, i, param.hd);
    return {
        hd: r,
        tl: mapi(i + 1 | 0, f, param.tl)
    };
}
function mapi$1(f, l) {
    return mapi(0, f, l);
}
function rev_map(f, l) {
    var _accu = /* [] */ 0;
    var _param = l;
    while(true){
        var param = _param;
        var accu = _accu;
        if (!param) {
            return accu;
        }
        _param = param.tl;
        _accu = {
            hd: Curry._1(f, param.hd),
            tl: accu
        };
        continue;
    }
    ;
}
function iter(f, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return;
        }
        Curry._1(f, param.hd);
        _param = param.tl;
        continue;
    }
    ;
}
function iteri(f, l) {
    var _i = 0;
    var _param = l;
    while(true){
        var param = _param;
        var i = _i;
        if (!param) {
            return;
        }
        Curry._2(f, i, param.hd);
        _param = param.tl;
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function fold_left(f, _accu, _l) {
    while(true){
        var l = _l;
        var accu = _accu;
        if (!l) {
            return accu;
        }
        _l = l.tl;
        _accu = _curry_js__WEBPACK_IMPORTED_MODULE_1__._2(f, accu, l.hd);
        continue;
    }
    ;
}
function fold_right(f, l, accu) {
    if (l) {
        return Curry._2(f, l.hd, fold_right(f, l.tl, accu));
    } else {
        return accu;
    }
}
function map2(f, l1, l2) {
    if (l1) {
        if (l2) {
            var r = Curry._2(f, l1.hd, l2.hd);
            return {
                hd: r,
                tl: map2(f, l1.tl, l2.tl)
            };
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.map2",
            Error: new Error()
        };
    }
    if (!l2) {
        return /* [] */ 0;
    }
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "List.map2",
        Error: new Error()
    };
}
function rev_map2(f, l1, l2) {
    var _accu = /* [] */ 0;
    var _l1 = l1;
    var _l2 = l2;
    while(true){
        var l2$1 = _l2;
        var l1$1 = _l1;
        var accu = _accu;
        if (l1$1) {
            if (l2$1) {
                _l2 = l2$1.tl;
                _l1 = l1$1.tl;
                _accu = {
                    hd: Curry._2(f, l1$1.hd, l2$1.hd),
                    tl: accu
                };
                continue;
            }
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.rev_map2",
                Error: new Error()
            };
        }
        if (l2$1) {
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.rev_map2",
                Error: new Error()
            };
        }
        return accu;
    }
    ;
}
function iter2(f, _l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (l1) {
            if (l2) {
                Curry._2(f, l1.hd, l2.hd);
                _l2 = l2.tl;
                _l1 = l1.tl;
                continue;
            }
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.iter2",
                Error: new Error()
            };
        }
        if (!l2) {
            return;
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.iter2",
            Error: new Error()
        };
    }
    ;
}
function fold_left2(f, _accu, _l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        var accu = _accu;
        if (l1) {
            if (l2) {
                _l2 = l2.tl;
                _l1 = l1.tl;
                _accu = Curry._3(f, accu, l1.hd, l2.hd);
                continue;
            }
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.fold_left2",
                Error: new Error()
            };
        }
        if (l2) {
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.fold_left2",
                Error: new Error()
            };
        }
        return accu;
    }
    ;
}
function fold_right2(f, l1, l2, accu) {
    if (l1) {
        if (l2) {
            return Curry._3(f, l1.hd, l2.hd, fold_right2(f, l1.tl, l2.tl, accu));
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.fold_right2",
            Error: new Error()
        };
    }
    if (l2) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.fold_right2",
            Error: new Error()
        };
    }
    return accu;
}
function for_all(p, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return true;
        }
        if (!Curry._1(p, param.hd)) {
            return false;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function exists(p, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return false;
        }
        if (Curry._1(p, param.hd)) {
            return true;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function for_all2(p, _l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (l1) {
            if (l2) {
                if (!Curry._2(p, l1.hd, l2.hd)) {
                    return false;
                }
                _l2 = l2.tl;
                _l1 = l1.tl;
                continue;
            }
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.for_all2",
                Error: new Error()
            };
        }
        if (!l2) {
            return true;
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.for_all2",
            Error: new Error()
        };
    }
    ;
}
function exists2(p, _l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (l1) {
            if (l2) {
                if (Curry._2(p, l1.hd, l2.hd)) {
                    return true;
                }
                _l2 = l2.tl;
                _l1 = l1.tl;
                continue;
            }
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "List.exists2",
                Error: new Error()
            };
        }
        if (!l2) {
            return false;
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.exists2",
            Error: new Error()
        };
    }
    ;
}
function mem(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return false;
        }
        if (Caml_obj.equal(param.hd, x)) {
            return true;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function memq(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return false;
        }
        if (param.hd === x) {
            return true;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function assoc(x, _param) {
    while(true){
        var param = _param;
        if (param) {
            var match = param.hd;
            if (_caml_obj_js__WEBPACK_IMPORTED_MODULE_2__/* .equal */ .Dg(match[0], x)) {
                return match[1];
            }
            _param = param.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    ;
}
function assoc_opt(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return;
        }
        var match = param.hd;
        if (Caml_obj.equal(match[0], x)) {
            return Caml_option.some(match[1]);
        }
        _param = param.tl;
        continue;
    }
    ;
}
function assq(x, _param) {
    while(true){
        var param = _param;
        if (param) {
            var match = param.hd;
            if (match[0] === x) {
                return match[1];
            }
            _param = param.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    ;
}
function assq_opt(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return;
        }
        var match = param.hd;
        if (match[0] === x) {
            return Caml_option.some(match[1]);
        }
        _param = param.tl;
        continue;
    }
    ;
}
function mem_assoc(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return false;
        }
        if (Caml_obj.equal(param.hd[0], x)) {
            return true;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function mem_assq(x, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return false;
        }
        if (param.hd[0] === x) {
            return true;
        }
        _param = param.tl;
        continue;
    }
    ;
}
function remove_assoc(x, param) {
    if (!param) {
        return /* [] */ 0;
    }
    var l = param.tl;
    var pair = param.hd;
    if (Caml_obj.equal(pair[0], x)) {
        return l;
    } else {
        return {
            hd: pair,
            tl: remove_assoc(x, l)
        };
    }
}
function remove_assq(x, param) {
    if (!param) {
        return /* [] */ 0;
    }
    var l = param.tl;
    var pair = param.hd;
    if (pair[0] === x) {
        return l;
    } else {
        return {
            hd: pair,
            tl: remove_assq(x, l)
        };
    }
}
function find(p, _param) {
    while(true){
        var param = _param;
        if (param) {
            var x = param.hd;
            if (Curry._1(p, x)) {
                return x;
            }
            _param = param.tl;
            continue;
        }
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    ;
}
function find_opt(p, _param) {
    while(true){
        var param = _param;
        if (!param) {
            return;
        }
        var x = param.hd;
        if (Curry._1(p, x)) {
            return Caml_option.some(x);
        }
        _param = param.tl;
        continue;
    }
    ;
}
function find_all(p) {
    return function(param) {
        var _accu = /* [] */ 0;
        var _param = param;
        while(true){
            var param$1 = _param;
            var accu = _accu;
            if (!param$1) {
                return rev_append(accu, /* [] */ 0);
            }
            var l = param$1.tl;
            var x = param$1.hd;
            if (Curry._1(p, x)) {
                _param = l;
                _accu = {
                    hd: x,
                    tl: accu
                };
                continue;
            }
            _param = l;
            continue;
        }
        ;
    };
}
function partition(p, l) {
    var _yes = /* [] */ 0;
    var _no = /* [] */ 0;
    var _param = l;
    while(true){
        var param = _param;
        var no = _no;
        var yes = _yes;
        if (!param) {
            return [
                rev_append(yes, /* [] */ 0),
                rev_append(no, /* [] */ 0)
            ];
        }
        var l$1 = param.tl;
        var x = param.hd;
        if (Curry._1(p, x)) {
            _param = l$1;
            _yes = {
                hd: x,
                tl: yes
            };
            continue;
        }
        _param = l$1;
        _no = {
            hd: x,
            tl: no
        };
        continue;
    }
    ;
}
function split(param) {
    if (!param) {
        return [
            /* [] */ 0,
            /* [] */ 0
        ];
    }
    var match = param.hd;
    var match$1 = split(param.tl);
    return [
        {
            hd: match[0],
            tl: match$1[0]
        },
        {
            hd: match[1],
            tl: match$1[1]
        }
    ];
}
function combine(l1, l2) {
    if (l1) {
        if (l2) {
            return {
                hd: [
                    l1.hd,
                    l2.hd
                ],
                tl: combine(l1.tl, l2.tl)
            };
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "List.combine",
            Error: new Error()
        };
    }
    if (!l2) {
        return /* [] */ 0;
    }
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "List.combine",
        Error: new Error()
    };
}
function merge(cmp, l1, l2) {
    if (!l1) {
        return l2;
    }
    if (!l2) {
        return l1;
    }
    var h2 = l2.hd;
    var h1 = l1.hd;
    if (Curry._2(cmp, h1, h2) <= 0) {
        return {
            hd: h1,
            tl: merge(cmp, l1.tl, l2)
        };
    } else {
        return {
            hd: h2,
            tl: merge(cmp, l1, l2.tl)
        };
    }
}
function chop(_k, _l) {
    while(true){
        var l = _l;
        var k = _k;
        if (k === 0) {
            return l;
        }
        if (l) {
            _l = l.tl;
            _k = k - 1 | 0;
            continue;
        }
        throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
                "list.ml",
                262,
                11
            ],
            Error: new Error()
        };
    }
    ;
}
function stable_sort(cmp, l) {
    var sort = function sort(n, l) {
        if (n !== 2) {
            if (n === 3 && l) {
                var match = l.tl;
                if (match) {
                    var match$1 = match.tl;
                    if (match$1) {
                        var x3 = match$1.hd;
                        var x2 = match.hd;
                        var x1 = l.hd;
                        if (Curry._2(cmp, x1, x2) <= 0) {
                            if (Curry._2(cmp, x2, x3) <= 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: {
                                            hd: x3,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else if (Curry._2(cmp, x1, x3) <= 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                        } else if (Curry._2(cmp, x1, x3) <= 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else if (Curry._2(cmp, x2, x3) <= 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else {
                            return {
                                hd: x3,
                                tl: {
                                    hd: x2,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                    }
                }
            }
        } else if (l) {
            var match$2 = l.tl;
            if (match$2) {
                var x2$1 = match$2.hd;
                var x1$1 = l.hd;
                if (Curry._2(cmp, x1$1, x2$1) <= 0) {
                    return {
                        hd: x1$1,
                        tl: {
                            hd: x2$1,
                            tl: /* [] */ 0
                        }
                    };
                } else {
                    return {
                        hd: x2$1,
                        tl: {
                            hd: x1$1,
                            tl: /* [] */ 0
                        }
                    };
                }
            }
        }
        var n1 = n >> 1;
        var n2 = n - n1 | 0;
        var l2 = chop(n1, l);
        var s1 = rev_sort(n1, l);
        var s2 = rev_sort(n2, l2);
        var _l1 = s1;
        var _l2 = s2;
        var _accu = /* [] */ 0;
        while(true){
            var accu = _accu;
            var l2$1 = _l2;
            var l1 = _l1;
            if (!l1) {
                return rev_append(l2$1, accu);
            }
            if (!l2$1) {
                return rev_append(l1, accu);
            }
            var h2 = l2$1.hd;
            var h1 = l1.hd;
            if (Curry._2(cmp, h1, h2) > 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l1 = l1.tl;
                continue;
            }
            _accu = {
                hd: h2,
                tl: accu
            };
            _l2 = l2$1.tl;
            continue;
        }
        ;
    };
    var rev_sort = function rev_sort(n, l) {
        if (n !== 2) {
            if (n === 3 && l) {
                var match = l.tl;
                if (match) {
                    var match$1 = match.tl;
                    if (match$1) {
                        var x3 = match$1.hd;
                        var x2 = match.hd;
                        var x1 = l.hd;
                        if (Curry._2(cmp, x1, x2) > 0) {
                            if (Curry._2(cmp, x2, x3) > 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: {
                                            hd: x3,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else if (Curry._2(cmp, x1, x3) > 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                        } else if (Curry._2(cmp, x1, x3) > 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else if (Curry._2(cmp, x2, x3) > 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else {
                            return {
                                hd: x3,
                                tl: {
                                    hd: x2,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                    }
                }
            }
        } else if (l) {
            var match$2 = l.tl;
            if (match$2) {
                var x2$1 = match$2.hd;
                var x1$1 = l.hd;
                if (Curry._2(cmp, x1$1, x2$1) > 0) {
                    return {
                        hd: x1$1,
                        tl: {
                            hd: x2$1,
                            tl: /* [] */ 0
                        }
                    };
                } else {
                    return {
                        hd: x2$1,
                        tl: {
                            hd: x1$1,
                            tl: /* [] */ 0
                        }
                    };
                }
            }
        }
        var n1 = n >> 1;
        var n2 = n - n1 | 0;
        var l2 = chop(n1, l);
        var s1 = sort(n1, l);
        var s2 = sort(n2, l2);
        var _l1 = s1;
        var _l2 = s2;
        var _accu = /* [] */ 0;
        while(true){
            var accu = _accu;
            var l2$1 = _l2;
            var l1 = _l1;
            if (!l1) {
                return rev_append(l2$1, accu);
            }
            if (!l2$1) {
                return rev_append(l1, accu);
            }
            var h2 = l2$1.hd;
            var h1 = l1.hd;
            if (Curry._2(cmp, h1, h2) <= 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l1 = l1.tl;
                continue;
            }
            _accu = {
                hd: h2,
                tl: accu
            };
            _l2 = l2$1.tl;
            continue;
        }
        ;
    };
    var len = length(l);
    if (len < 2) {
        return l;
    } else {
        return sort(len, l);
    }
}
function sort_uniq(cmp, l) {
    var sort = function sort(n, l) {
        if (n !== 2) {
            if (n === 3 && l) {
                var match = l.tl;
                if (match) {
                    var match$1 = match.tl;
                    if (match$1) {
                        var x3 = match$1.hd;
                        var x2 = match.hd;
                        var x1 = l.hd;
                        var c = Curry._2(cmp, x1, x2);
                        if (c === 0) {
                            var c$1 = Curry._2(cmp, x2, x3);
                            if (c$1 === 0) {
                                return {
                                    hd: x2,
                                    tl: /* [] */ 0
                                };
                            } else if (c$1 < 0) {
                                return {
                                    hd: x2,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            }
                        }
                        if (c < 0) {
                            var c$2 = Curry._2(cmp, x2, x3);
                            if (c$2 === 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            }
                            if (c$2 < 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: {
                                            hd: x3,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                            var c$3 = Curry._2(cmp, x1, x3);
                            if (c$3 === 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            } else if (c$3 < 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                        }
                        var c$4 = Curry._2(cmp, x1, x3);
                        if (c$4 === 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: /* [] */ 0
                                }
                            };
                        }
                        if (c$4 < 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                        var c$5 = Curry._2(cmp, x2, x3);
                        if (c$5 === 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: /* [] */ 0
                                }
                            };
                        } else if (c$5 < 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else {
                            return {
                                hd: x3,
                                tl: {
                                    hd: x2,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                    }
                }
            }
        } else if (l) {
            var match$2 = l.tl;
            if (match$2) {
                var x2$1 = match$2.hd;
                var x1$1 = l.hd;
                var c$6 = Curry._2(cmp, x1$1, x2$1);
                if (c$6 === 0) {
                    return {
                        hd: x1$1,
                        tl: /* [] */ 0
                    };
                } else if (c$6 < 0) {
                    return {
                        hd: x1$1,
                        tl: {
                            hd: x2$1,
                            tl: /* [] */ 0
                        }
                    };
                } else {
                    return {
                        hd: x2$1,
                        tl: {
                            hd: x1$1,
                            tl: /* [] */ 0
                        }
                    };
                }
            }
        }
        var n1 = n >> 1;
        var n2 = n - n1 | 0;
        var l2 = chop(n1, l);
        var s1 = rev_sort(n1, l);
        var s2 = rev_sort(n2, l2);
        var _l1 = s1;
        var _l2 = s2;
        var _accu = /* [] */ 0;
        while(true){
            var accu = _accu;
            var l2$1 = _l2;
            var l1 = _l1;
            if (!l1) {
                return rev_append(l2$1, accu);
            }
            if (!l2$1) {
                return rev_append(l1, accu);
            }
            var t2 = l2$1.tl;
            var h2 = l2$1.hd;
            var t1 = l1.tl;
            var h1 = l1.hd;
            var c$7 = Curry._2(cmp, h1, h2);
            if (c$7 === 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l2 = t2;
                _l1 = t1;
                continue;
            }
            if (c$7 > 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l1 = t1;
                continue;
            }
            _accu = {
                hd: h2,
                tl: accu
            };
            _l2 = t2;
            continue;
        }
        ;
    };
    var rev_sort = function rev_sort(n, l) {
        if (n !== 2) {
            if (n === 3 && l) {
                var match = l.tl;
                if (match) {
                    var match$1 = match.tl;
                    if (match$1) {
                        var x3 = match$1.hd;
                        var x2 = match.hd;
                        var x1 = l.hd;
                        var c = Curry._2(cmp, x1, x2);
                        if (c === 0) {
                            var c$1 = Curry._2(cmp, x2, x3);
                            if (c$1 === 0) {
                                return {
                                    hd: x2,
                                    tl: /* [] */ 0
                                };
                            } else if (c$1 > 0) {
                                return {
                                    hd: x2,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            }
                        }
                        if (c > 0) {
                            var c$2 = Curry._2(cmp, x2, x3);
                            if (c$2 === 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            }
                            if (c$2 > 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: {
                                            hd: x3,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                            var c$3 = Curry._2(cmp, x1, x3);
                            if (c$3 === 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x2,
                                        tl: /* [] */ 0
                                    }
                                };
                            } else if (c$3 > 0) {
                                return {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            } else {
                                return {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: {
                                            hd: x2,
                                            tl: /* [] */ 0
                                        }
                                    }
                                };
                            }
                        }
                        var c$4 = Curry._2(cmp, x1, x3);
                        if (c$4 === 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: /* [] */ 0
                                }
                            };
                        }
                        if (c$4 > 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: {
                                        hd: x3,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                        var c$5 = Curry._2(cmp, x2, x3);
                        if (c$5 === 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x1,
                                    tl: /* [] */ 0
                                }
                            };
                        } else if (c$5 > 0) {
                            return {
                                hd: x2,
                                tl: {
                                    hd: x3,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        } else {
                            return {
                                hd: x3,
                                tl: {
                                    hd: x2,
                                    tl: {
                                        hd: x1,
                                        tl: /* [] */ 0
                                    }
                                }
                            };
                        }
                    }
                }
            }
        } else if (l) {
            var match$2 = l.tl;
            if (match$2) {
                var x2$1 = match$2.hd;
                var x1$1 = l.hd;
                var c$6 = Curry._2(cmp, x1$1, x2$1);
                if (c$6 === 0) {
                    return {
                        hd: x1$1,
                        tl: /* [] */ 0
                    };
                } else if (c$6 > 0) {
                    return {
                        hd: x1$1,
                        tl: {
                            hd: x2$1,
                            tl: /* [] */ 0
                        }
                    };
                } else {
                    return {
                        hd: x2$1,
                        tl: {
                            hd: x1$1,
                            tl: /* [] */ 0
                        }
                    };
                }
            }
        }
        var n1 = n >> 1;
        var n2 = n - n1 | 0;
        var l2 = chop(n1, l);
        var s1 = sort(n1, l);
        var s2 = sort(n2, l2);
        var _l1 = s1;
        var _l2 = s2;
        var _accu = /* [] */ 0;
        while(true){
            var accu = _accu;
            var l2$1 = _l2;
            var l1 = _l1;
            if (!l1) {
                return rev_append(l2$1, accu);
            }
            if (!l2$1) {
                return rev_append(l1, accu);
            }
            var t2 = l2$1.tl;
            var h2 = l2$1.hd;
            var t1 = l1.tl;
            var h1 = l1.hd;
            var c$7 = Curry._2(cmp, h1, h2);
            if (c$7 === 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l2 = t2;
                _l1 = t1;
                continue;
            }
            if (c$7 < 0) {
                _accu = {
                    hd: h1,
                    tl: accu
                };
                _l1 = t1;
                continue;
            }
            _accu = {
                hd: h2,
                tl: accu
            };
            _l2 = t2;
            continue;
        }
        ;
    };
    var len = length(l);
    if (len < 2) {
        return l;
    } else {
        return sort(len, l);
    }
}
function compare_lengths(_l1, _l2) {
    while(true){
        var l2 = _l2;
        var l1 = _l1;
        if (!l1) {
            if (l2) {
                return -1;
            } else {
                return 0;
            }
        }
        if (!l2) {
            return 1;
        }
        _l2 = l2.tl;
        _l1 = l1.tl;
        continue;
    }
    ;
}
function compare_length_with(_l, _n) {
    while(true){
        var n = _n;
        var l = _l;
        if (!l) {
            if (n === 0) {
                return 0;
            } else if (n > 0) {
                return -1;
            } else {
                return 1;
            }
        }
        if (n <= 0) {
            return 1;
        }
        _n = n - 1 | 0;
        _l = l.tl;
        continue;
    }
    ;
}
var append = _pervasives_js__WEBPACK_IMPORTED_MODULE_0__/* .$at */ .vh;
var concat = (/* unused pure expression or super */ null && (flatten));
var filter = (/* unused pure expression or super */ null && (find_all));
var sort = (/* unused pure expression or super */ null && (stable_sort));
var fast_sort = (/* unused pure expression or super */ null && (stable_sort));
 /* No side effect */ 


/***/ }),

/***/ 60702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vh": function() { return /* binding */ $at; },
  "aY": function() { return /* binding */ float_of_string_opt; },
  "zy": function() { return /* binding */ int_of_string_opt; },
  "ln": function() { return /* binding */ string_of_bool; }
});

// UNUSED EXPORTS: Exit, abs, at_exit, bool_of_string, bool_of_string_opt, char_of_int, classify_float, epsilon_float, exit, failwith, infinity, invalid_arg, lnot, max_float, max_int, min_float, min_int, neg_infinity, prerr_newline, print_float, print_int, print_newline, print_string, string_of_float, valid_float_lexem

;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/caml_sys.js
/* provided dependency */ var process = __webpack_require__(34155);
function sys_getenv(s) {
    if (typeof process === "undefined" || process.env === undefined) {
        throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
        };
    }
    var x = process.env[s];
    if (x !== undefined) {
        return x;
    }
    throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
    };
}
var os_type = function os_type(_) {
    if (typeof process !== "undefined" && process.platform === "win32") {
        return "Win32";
    } else {
        return "Unix";
    }
};
function sys_time(param) {
    if (typeof process === "undefined" || process.uptime === undefined) {
        return -1;
    } else {
        return process.uptime();
    }
}
var sys_getcwd = function sys_getcwd(param) {
    if (typeof process === "undefined" || process.cwd === undefined) {
        return "/";
    }
    return process.cwd();
};
function sys_get_argv(param) {
    if (typeof process === "undefined") {
        return [
            "",
            [
                ""
            ]
        ];
    }
    var argv = process.argv;
    if (argv == null) {
        return [
            "",
            [
                ""
            ]
        ];
    } else {
        return [
            argv[0],
            argv
        ];
    }
}
function sys_exit(exit_code) {
    if (typeof process !== "undefined") {
        return process.exit(exit_code);
    }
}
function sys_is_directory(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_is_directory not implemented",
        Error: new Error()
    };
}
function sys_file_exists(_s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: "sys_file_exists not implemented",
        Error: new Error()
    };
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_format.js
var caml_format = __webpack_require__(11331);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_exceptions.js
var caml_exceptions = __webpack_require__(86592);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_js_exceptions.js
var caml_js_exceptions = __webpack_require__(37082);
;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/pervasives.js






function failwith(s) {
    throw {
        RE_EXN_ID: "Failure",
        _1: s,
        Error: new Error()
    };
}
function invalid_arg(s) {
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: s,
        Error: new Error()
    };
}
var Exit = /* @__PURE__ */ (/* unused pure expression or super */ null && (Caml_exceptions.create("Pervasives.Exit")));
function abs(x) {
    if (x >= 0) {
        return x;
    } else {
        return -x | 0;
    }
}
function lnot(x) {
    return x ^ -1;
}
var min_int = (/* unused pure expression or super */ null && (-2147483648));
function classify_float(x) {
    if (isFinite(x)) {
        if (Math.abs(x) >= 2.22507385850720138e-308) {
            return /* FP_normal */ 0;
        } else if (x !== 0) {
            return /* FP_subnormal */ 1;
        } else {
            return /* FP_zero */ 2;
        }
    } else if (isNaN(x)) {
        return /* FP_nan */ 4;
    } else {
        return /* FP_infinite */ 3;
    }
}
function char_of_int(n) {
    if (n < 0 || n > 255) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "char_of_int",
            Error: new Error()
        };
    }
    return n;
}
function string_of_bool(b) {
    if (b) {
        return "true";
    } else {
        return "false";
    }
}
function bool_of_string(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            throw {
                RE_EXN_ID: "Invalid_argument",
                _1: "bool_of_string",
                Error: new Error()
            };
    }
}
function bool_of_string_opt(param) {
    switch(param){
        case "false":
            return false;
        case "true":
            return true;
        default:
            return;
    }
}
function int_of_string_opt(s) {
    try {
        return caml_format/* int_of_string */.di(s);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === "Failure") {
            return;
        }
        throw exn;
    }
}
function valid_float_lexem(s) {
    var l = s.length;
    var _i = 0;
    while(true){
        var i = _i;
        if (i >= l) {
            return s + ".";
        }
        var match = Caml_string.get(s, i);
        if (match >= 48) {
            if (match >= 58) {
                return s;
            }
            _i = i + 1 | 0;
            continue;
        }
        if (match !== 45) {
            return s;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function string_of_float(f) {
    return valid_float_lexem(Caml_format.format_float("%.12g", f));
}
function float_of_string_opt(s) {
    try {
        return caml_format/* float_of_string */.mx(s);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === "Failure") {
            return;
        }
        throw exn;
    }
}
function $at(l1, l2) {
    if (l1) {
        return {
            hd: l1.hd,
            tl: $at(l1.tl, l2)
        };
    } else {
        return l2;
    }
}
function print_newline(param) {
    console.log("");
}
function prerr_newline(param) {
    console.error("");
}
function print_int(i) {
    console.log(String(i));
}
function print_float(i) {
    console.log(valid_float_lexem(Caml_format.format_float("%.12g", i)));
}
function print_string(prim) {
    console.log(prim);
}
var exit_function = {
    contents: function contents(prim) {}
};
function at_exit(f) {
    var g = exit_function.contents;
    exit_function.contents = function(param) {
        Curry._1(f, undefined);
        Curry._1(g, undefined);
    };
}
function exit(retcode) {
    Curry._1(exit_function.contents, undefined);
    return Caml_sys.sys_exit(retcode);
}
var max_int = 2147483647;
var infinity = Infinity;
var neg_infinity = -Infinity;
var max_float = 1.79769313486231571e+308;
var min_float = 2.22507385850720138e-308;
var epsilon_float = 2.22044604925031308e-16;
 /* No side effect */ 


/***/ }),

/***/ 99813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zo": function() { return /* binding */ string_concat; },
  "uq": function() { return /* binding */ string_lowercase_ascii; },
  "UK": function() { return /* binding */ split_on_char; },
  "fy": function() { return /* binding */ string_trim; }
});

// UNUSED EXPORTS: blit, capitalize_ascii, compare, contains, contains_from, equal, escaped, index, index_from, index_from_opt, index_opt, init, iter, iteri, make, map, mapi, rcontains_from, rindex, rindex_from, rindex_from_opt, rindex_opt, sub, uncapitalize_ascii, uppercase_ascii

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml.js
var caml = __webpack_require__(55658);
;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/char.js

function chr(n) {
    if (n < 0 || n > 255) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Char.chr",
            Error: new Error()
        };
    }
    return n;
}
function escaped(c) {
    var exit = 0;
    if (c >= 40) {
        if (c === 92) {
            return "\\\\";
        }
        exit = c >= 127 ? 1 : 2;
    } else if (c >= 32) {
        if (c >= 39) {
            return "\\'";
        }
        exit = 2;
    } else if (c >= 14) {
        exit = 1;
    } else {
        switch(c){
            case 8:
                return "\\b";
            case 9:
                return "\\t";
            case 10:
                return "\\n";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 11:
            case 12:
                exit = 1;
                break;
            case 13:
                return "\\r";
        }
    }
    switch(exit){
        case 1:
            var s = [
                0,
                0,
                0,
                0
            ];
            s[0] = /* '\\' */ 92;
            s[1] = 48 + (c / 100 | 0) | 0;
            s[2] = 48 + (c / 10 | 0) % 10 | 0;
            s[3] = 48 + c % 10 | 0;
            return Bytes.to_string(s);
        case 2:
            var s$1 = [
                0
            ];
            s$1[0] = c;
            return Bytes.to_string(s$1);
    }
}
function lowercase(c) {
    if (c >= /* 'A' */ 65 && c <= /* 'Z' */ 90 || c >= /* '\192' */ 192 && c <= /* '\214' */ 214 || c >= /* '\216' */ 216 && c <= /* '\222' */ 222) {
        return c + 32 | 0;
    } else {
        return c;
    }
}
function uppercase(c) {
    if (c >= /* 'a' */ 97 && c <= /* 'z' */ 122 || c >= /* '\224' */ 224 && c <= /* '\246' */ 246 || c >= /* '\248' */ 248 && c <= /* '\254' */ 254) {
        return c - 32 | 0;
    } else {
        return c;
    }
}
function lowercase_ascii(c) {
    if (c >= /* 'A' */ 65 && c <= /* 'Z' */ 90) {
        return c + 32 | 0;
    } else {
        return c;
    }
}
function uppercase_ascii(c) {
    if (c >= /* 'a' */ 97 && c <= /* 'z' */ 122) {
        return c - 32 | 0;
    } else {
        return c;
    }
}
function compare(c1, c2) {
    return c1 - c2 | 0;
}
function equal(c1, c2) {
    return (c1 - c2 | 0) === 0;
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/caml_bytes.js
function set(s, i, ch) {
    if (i < 0 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "index out of bounds",
            Error: new Error()
        };
    }
    s[i] = ch;
}
function get(s, i) {
    if (i < 0 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "index out of bounds",
            Error: new Error()
        };
    }
    return s[i];
}
function create(len) {
    if (len < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.create",
            Error: new Error()
        };
    }
    var result = new Array(len);
    for(var i = 0; i < len; ++i){
        result[i] = /* '\000' */ 0;
    }
    return result;
}
function bytes_compare_aux(s1, s2, _off, len, def) {
    while(true){
        var off = _off;
        if (off >= len) {
            return def;
        }
        var a = s1[off];
        var b = s2[off];
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        _off = off + 1 | 0;
        continue;
    }
    ;
}
function bytes_compare(s1, s2) {
    var len1 = s1.length;
    var len2 = s2.length;
    if (len1 === len2) {
        return bytes_compare_aux(s1, s2, 0, len1, 0);
    } else if (len1 < len2) {
        return bytes_compare_aux(s1, s2, 0, len1, -1);
    } else {
        return bytes_compare_aux(s1, s2, 0, len2, 1);
    }
}
function bytes_equal(s1, s2) {
    var len1 = s1.length;
    var len2 = s2.length;
    if (len1 === len2) {
        var _off = 0;
        while(true){
            var off = _off;
            if (off === len1) {
                return true;
            }
            var a = s1[off];
            var b = s2[off];
            if (a !== b) {
                return false;
            }
            _off = off + 1 | 0;
            continue;
        }
        ;
    } else {
        return false;
    }
}
function bytes_greaterthan(s1, s2) {
    return bytes_compare(s1, s2) > 0;
}
function bytes_greaterequal(s1, s2) {
    return bytes_compare(s1, s2) >= 0;
}
function bytes_lessthan(s1, s2) {
    return bytes_compare(s1, s2) < 0;
}
function bytes_lessequal(s1, s2) {
    return bytes_compare(s1, s2) <= 0;
}
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_js_exceptions.js
var caml_js_exceptions = __webpack_require__(37082);
;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/bytes.js





function unsafe_fill(s, i, l, c) {
    if (l <= 0) {
        return;
    }
    for(var k = i, k_finish = l + i | 0; k < k_finish; ++k){
        s[k] = c;
    }
}
function unsafe_blit(s1, i1, s2, i2, len) {
    if (len <= 0) {
        return;
    }
    if (s1 === s2) {
        if (i1 < i2) {
            var range_a = (s1.length - i2 | 0) - 1 | 0;
            var range_b = len - 1 | 0;
            var range = range_a > range_b ? range_b : range_a;
            for(var j = range; j >= 0; --j){
                s1[i2 + j | 0] = s1[i1 + j | 0];
            }
            return;
        }
        if (i1 <= i2) {
            return;
        }
        var range_a$1 = (s1.length - i1 | 0) - 1 | 0;
        var range_b$1 = len - 1 | 0;
        var range$1 = range_a$1 > range_b$1 ? range_b$1 : range_a$1;
        for(var k = 0; k <= range$1; ++k){
            s1[i2 + k | 0] = s1[i1 + k | 0];
        }
        return;
    }
    var off1 = s1.length - i1 | 0;
    if (len <= off1) {
        for(var i = 0; i < len; ++i){
            s2[i2 + i | 0] = s1[i1 + i | 0];
        }
        return;
    }
    for(var i$1 = 0; i$1 < off1; ++i$1){
        s2[i2 + i$1 | 0] = s1[i1 + i$1 | 0];
    }
    for(var i$2 = off1; i$2 < len; ++i$2){
        s2[i2 + i$2 | 0] = /* '\000' */ 0;
    }
}
function make(n, c) {
    var s = Caml_bytes.create(n);
    unsafe_fill(s, 0, n, c);
    return s;
}
function init(n, f) {
    var s = Caml_bytes.create(n);
    for(var i = 0; i < n; ++i){
        s[i] = Curry._1(f, i);
    }
    return s;
}
var empty = [];
function copy(s) {
    var len = s.length;
    var r = Caml_bytes.create(len);
    unsafe_blit(s, 0, r, 0, len);
    return r;
}
function to_string(a) {
    var i = 0;
    var len = a.length;
    var s = "";
    var s_len = len;
    if (i === 0 && len <= 4096 && len === a.length) {
        return String.fromCharCode.apply(null, a);
    }
    var offset = 0;
    while(s_len > 0){
        var next = s_len < 1024 ? s_len : 1024;
        var tmp_bytes = new Array(next);
        for(var k = 0; k < next; ++k){
            tmp_bytes[k] = a[k + offset | 0];
        }
        s = s + String.fromCharCode.apply(null, tmp_bytes);
        s_len = s_len - next | 0;
        offset = offset + next | 0;
    }
    ;
    return s;
}
function of_string(s) {
    var len = s.length;
    var res = new Array(len);
    for(var i = 0; i < len; ++i){
        res[i] = s.codePointAt(i);
    }
    return res;
}
function sub(s, ofs, len) {
    if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.sub / Bytes.sub",
            Error: new Error()
        };
    }
    var r = create(len);
    unsafe_blit(s, ofs, r, 0, len);
    return r;
}
function sub_string(b, ofs, len) {
    return to_string(sub(b, ofs, len));
}
function $plus$plus(a, b) {
    var c = a + b | 0;
    var match = a < 0;
    var match$1 = b < 0;
    var match$2 = c < 0;
    if (match) {
        if (!match$1) {
            return c;
        }
        if (match$2) {
            return c;
        }
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Bytes.extend",
            Error: new Error()
        };
    }
    if (match$1) {
        return c;
    }
    if (match$2) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Bytes.extend",
            Error: new Error()
        };
    }
    return c;
}
function extend(s, left, right) {
    var len = $plus$plus($plus$plus(s.length, left), right);
    var r = Caml_bytes.create(len);
    var match = left < 0 ? [
        -left | 0,
        0
    ] : [
        0,
        left
    ];
    var dstoff = match[1];
    var srcoff = match[0];
    var cpylen = Caml.int_min(s.length - srcoff | 0, len - dstoff | 0);
    if (cpylen > 0) {
        unsafe_blit(s, srcoff, r, dstoff, cpylen);
    }
    return r;
}
function fill(s, ofs, len, c) {
    if (ofs < 0 || len < 0 || ofs > (s.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.fill / Bytes.fill",
            Error: new Error()
        };
    }
    unsafe_fill(s, ofs, len, c);
}
function blit(s1, ofs1, s2, ofs2, len) {
    if (len < 0 || ofs1 < 0 || ofs1 > (s1.length - len | 0) || ofs2 < 0 || ofs2 > (s2.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "Bytes.blit",
            Error: new Error()
        };
    }
    unsafe_blit(s1, ofs1, s2, ofs2, len);
}
function blit_string(s1, ofs1, s2, ofs2, len) {
    if (len < 0 || ofs1 < 0 || ofs1 > (s1.length - len | 0) || ofs2 < 0 || ofs2 > (s2.length - len | 0)) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.blit / Bytes.blit_string",
            Error: new Error()
        };
    }
    if (len <= 0) {
        return;
    }
    var off1 = s1.length - ofs1 | 0;
    if (len <= off1) {
        for(var i = 0; i < len; ++i){
            s2[ofs2 + i | 0] = s1.codePointAt(ofs1 + i | 0);
        }
        return;
    }
    for(var i$1 = 0; i$1 < off1; ++i$1){
        s2[ofs2 + i$1 | 0] = s1.codePointAt(ofs1 + i$1 | 0);
    }
    for(var i$2 = off1; i$2 < len; ++i$2){
        s2[ofs2 + i$2 | 0] = /* '\000' */ 0;
    }
}
function iter(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        Curry._1(f, a[i]);
    }
}
function iteri(f, a) {
    for(var i = 0, i_finish = a.length; i < i_finish; ++i){
        Curry._2(f, i, a[i]);
    }
}
function ensure_ge(x, y) {
    if (x >= y) {
        return x;
    }
    throw {
        RE_EXN_ID: "Invalid_argument",
        _1: "Bytes.concat",
        Error: new Error()
    };
}
function sum_lengths(_acc, seplen, _param) {
    while(true){
        var param = _param;
        var acc = _acc;
        if (!param) {
            return acc;
        }
        var tl = param.tl;
        var hd = param.hd;
        if (!tl) {
            return hd.length + acc | 0;
        }
        _param = tl;
        _acc = ensure_ge((hd.length + seplen | 0) + acc | 0, acc);
        continue;
    }
    ;
}
function concat(sep, l) {
    if (!l) {
        return empty;
    }
    var seplen = sep.length;
    var dst = Caml_bytes.create(sum_lengths(0, seplen, l));
    var _pos = 0;
    var _param = l;
    while(true){
        var param = _param;
        var pos = _pos;
        if (!param) {
            return dst;
        }
        var tl = param.tl;
        var hd = param.hd;
        if (tl) {
            unsafe_blit(hd, 0, dst, pos, hd.length);
            unsafe_blit(sep, 0, dst, pos + hd.length | 0, seplen);
            _param = tl;
            _pos = (pos + hd.length | 0) + seplen | 0;
            continue;
        }
        unsafe_blit(hd, 0, dst, pos, hd.length);
        return dst;
    }
    ;
}
function cat(s1, s2) {
    var l1 = s1.length;
    var l2 = s2.length;
    var r = Caml_bytes.create(l1 + l2 | 0);
    unsafe_blit(s1, 0, r, 0, l1);
    unsafe_blit(s2, 0, r, l1, l2);
    return r;
}
function is_space(param) {
    if (param > 13 || param < 9) {
        return param === 32;
    } else {
        return param !== 11;
    }
}
function trim(s) {
    var len = s.length;
    var i = 0;
    while(i < len && is_space(s[i])){
        i = i + 1 | 0;
    }
    ;
    var j = len - 1 | 0;
    while(j >= i && is_space(s[j])){
        j = j - 1 | 0;
    }
    ;
    if (j >= i) {
        return sub(s, i, (j - i | 0) + 1 | 0);
    } else {
        return empty;
    }
}
function bytes_escaped(s) {
    var n = 0;
    for(var i = 0, i_finish = s.length; i < i_finish; ++i){
        var match = s[i];
        n = n + (match >= 32 ? match > 92 || match < 34 ? match >= 127 ? 4 : 1 : match > 91 || match < 35 ? 2 : 1 : match >= 11 ? match !== 13 ? 4 : 2 : match >= 8 ? 2 : 4) | 0;
    }
    if (n === s.length) {
        return copy(s);
    }
    var s$p = Caml_bytes.create(n);
    n = 0;
    for(var i$1 = 0, i_finish$1 = s.length; i$1 < i_finish$1; ++i$1){
        var c = s[i$1];
        var exit = 0;
        if (c >= 35) {
            if (c !== 92) {
                if (c >= 127) {
                    exit = 1;
                } else {
                    s$p[n] = c;
                }
            } else {
                exit = 2;
            }
        } else if (c >= 32) {
            if (c >= 34) {
                exit = 2;
            } else {
                s$p[n] = c;
            }
        } else if (c >= 14) {
            exit = 1;
        } else {
            switch(c){
                case 8:
                    s$p[n] = /* '\\' */ 92;
                    n = n + 1 | 0;
                    s$p[n] = /* 'b' */ 98;
                    break;
                case 9:
                    s$p[n] = /* '\\' */ 92;
                    n = n + 1 | 0;
                    s$p[n] = /* 't' */ 116;
                    break;
                case 10:
                    s$p[n] = /* '\\' */ 92;
                    n = n + 1 | 0;
                    s$p[n] = /* 'n' */ 110;
                    break;
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 11:
                case 12:
                    exit = 1;
                    break;
                case 13:
                    s$p[n] = /* '\\' */ 92;
                    n = n + 1 | 0;
                    s$p[n] = /* 'r' */ 114;
                    break;
            }
        }
        switch(exit){
            case 1:
                s$p[n] = /* '\\' */ 92;
                n = n + 1 | 0;
                s$p[n] = 48 + (c / 100 | 0) | 0;
                n = n + 1 | 0;
                s$p[n] = 48 + (c / 10 | 0) % 10 | 0;
                n = n + 1 | 0;
                s$p[n] = 48 + c % 10 | 0;
                break;
            case 2:
                s$p[n] = /* '\\' */ 92;
                n = n + 1 | 0;
                s$p[n] = c;
                break;
        }
        n = n + 1 | 0;
    }
    return s$p;
}
function map(f, s) {
    var l = s.length;
    if (l === 0) {
        return s;
    }
    var r = create(l);
    for(var i = 0; i < l; ++i){
        r[i] = curry._1(f, s[i]);
    }
    return r;
}
function mapi(f, s) {
    var l = s.length;
    if (l === 0) {
        return s;
    }
    var r = Caml_bytes.create(l);
    for(var i = 0; i < l; ++i){
        r[i] = Curry._2(f, i, s[i]);
    }
    return r;
}
function bytes_uppercase_ascii(s) {
    return map(Char.uppercase_ascii, s);
}
function bytes_lowercase_ascii(s) {
    return map(lowercase_ascii, s);
}
function apply1(f, s) {
    if (s.length === 0) {
        return s;
    }
    var r = copy(s);
    r[0] = Curry._1(f, s[0]);
    return r;
}
function capitalize_ascii(s) {
    return apply1(Char.uppercase_ascii, s);
}
function uncapitalize_ascii(s) {
    return apply1(Char.lowercase_ascii, s);
}
function index_rec(s, lim, _i, c) {
    while(true){
        var i = _i;
        if (i >= lim) {
            throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
            };
        }
        if (s[i] === c) {
            return i;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function index(s, c) {
    return index_rec(s, s.length, 0, c);
}
function index_rec_opt(s, lim, _i, c) {
    while(true){
        var i = _i;
        if (i >= lim) {
            return;
        }
        if (s[i] === c) {
            return i;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function index_opt(s, c) {
    return index_rec_opt(s, s.length, 0, c);
}
function index_from(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.index_from / Bytes.index_from",
            Error: new Error()
        };
    }
    return index_rec(s, l, i, c);
}
function index_from_opt(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.index_from_opt / Bytes.index_from_opt",
            Error: new Error()
        };
    }
    return index_rec_opt(s, l, i, c);
}
function rindex_rec(s, _i, c) {
    while(true){
        var i = _i;
        if (i < 0) {
            throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
            };
        }
        if (s[i] === c) {
            return i;
        }
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function rindex(s, c) {
    return rindex_rec(s, s.length - 1 | 0, c);
}
function rindex_from(s, i, c) {
    if (i < -1 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rindex_from / Bytes.rindex_from",
            Error: new Error()
        };
    }
    return rindex_rec(s, i, c);
}
function rindex_rec_opt(s, _i, c) {
    while(true){
        var i = _i;
        if (i < 0) {
            return;
        }
        if (s[i] === c) {
            return i;
        }
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function rindex_opt(s, c) {
    return rindex_rec_opt(s, s.length - 1 | 0, c);
}
function rindex_from_opt(s, i, c) {
    if (i < -1 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rindex_from_opt / Bytes.rindex_from_opt",
            Error: new Error()
        };
    }
    return rindex_rec_opt(s, i, c);
}
function contains_from(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.contains_from / Bytes.contains_from",
            Error: new Error()
        };
    }
    try {
        index_rec(s, l, i, c);
        return true;
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Not_found") {
            return false;
        }
        throw exn;
    }
}
function contains(s, c) {
    return contains_from(s, 0, c);
}
function rcontains_from(s, i, c) {
    if (i < 0 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rcontains_from / Bytes.rcontains_from",
            Error: new Error()
        };
    }
    try {
        rindex_rec(s, i, c);
        return true;
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Not_found") {
            return false;
        }
        throw exn;
    }
}
var es6_bytes_compare = bytes_compare;
var es6_bytes_equal = bytes_equal;
var unsafe_to_string = to_string;
var unsafe_of_string = of_string;
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_List.js
var belt_List = __webpack_require__(84462);
;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/caml_string.js
function caml_string_get(s, i) {
    if (i >= s.length || i < 0) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "index out of bounds",
            Error: new Error()
        };
    }
    return s.codePointAt(i);
}
function caml_string_make(n, ch) {
    return String.fromCharCode(ch).repeat(n);
}
 /* No side effect */ 

;// CONCATENATED MODULE: ./node_modules/@rescript/std/lib/es6/string.js






function string_init(n, f) {
    return Bytes.unsafe_to_string(Bytes.init(n, f));
}
function string_sub(s, ofs, len) {
    return unsafe_to_string(sub(unsafe_of_string(s), ofs, len));
}
function string_concat(sep, xs) {
    return belt_List/* toArray */.qo(xs).join(sep);
}
function string_iter(f, s) {
    for(var i = 0, i_finish = s.length; i < i_finish; ++i){
        Curry._1(f, s.codePointAt(i));
    }
}
function string_iteri(f, s) {
    for(var i = 0, i_finish = s.length; i < i_finish; ++i){
        Curry._2(f, i, s.codePointAt(i));
    }
}
function string_map(f, s) {
    return Bytes.unsafe_to_string(Bytes.map(f, Bytes.unsafe_of_string(s)));
}
function string_mapi(f, s) {
    return Bytes.unsafe_to_string(Bytes.mapi(f, Bytes.unsafe_of_string(s)));
}
function string_is_space(param) {
    if (param > 13 || param < 9) {
        return param === 32;
    } else {
        return param !== 11;
    }
}
function string_trim(s) {
    if (s === "" || !(string_is_space(s.codePointAt(0)) || string_is_space(s.codePointAt(s.length - 1 | 0)))) {
        return s;
    } else {
        return unsafe_to_string(trim(unsafe_of_string(s)));
    }
}
function string_escaped(s) {
    var needs_escape = function needs_escape(_i) {
        while(true){
            var i = _i;
            if (i >= s.length) {
                return false;
            }
            var match = s.codePointAt(i);
            if (match < 32) {
                return true;
            }
            if (match > 92 || match < 34) {
                if (match >= 127) {
                    return true;
                }
                _i = i + 1 | 0;
                continue;
            }
            if (match > 91 || match < 35) {
                return true;
            }
            _i = i + 1 | 0;
            continue;
        }
        ;
    };
    if (needs_escape(0)) {
        return Bytes.unsafe_to_string(Bytes.escaped(Bytes.unsafe_of_string(s)));
    } else {
        return s;
    }
}
function string_index_rec(s, lim, _i, c) {
    while(true){
        var i = _i;
        if (i >= lim) {
            throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
            };
        }
        if (s.codePointAt(i) === c) {
            return i;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function string_index(s, c) {
    return string_index_rec(s, s.length, 0, c);
}
function string_index_rec_opt(s, lim, _i, c) {
    while(true){
        var i = _i;
        if (i >= lim) {
            return;
        }
        if (s.codePointAt(i) === c) {
            return i;
        }
        _i = i + 1 | 0;
        continue;
    }
    ;
}
function string_index_opt(s, c) {
    return string_index_rec_opt(s, s.length, 0, c);
}
function string_index_from(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.index_from / Bytes.index_from",
            Error: new Error()
        };
    }
    return string_index_rec(s, l, i, c);
}
function string_index_from_opt(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.index_from_opt / Bytes.index_from_opt",
            Error: new Error()
        };
    }
    return string_index_rec_opt(s, l, i, c);
}
function string_rindex_rec(s, _i, c) {
    while(true){
        var i = _i;
        if (i < 0) {
            throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
            };
        }
        if (s.codePointAt(i) === c) {
            return i;
        }
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function string_rindex(s, c) {
    return string_rindex_rec(s, s.length - 1 | 0, c);
}
function string_rindex_from(s, i, c) {
    if (i < -1 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rindex_from / Bytes.rindex_from",
            Error: new Error()
        };
    }
    return string_rindex_rec(s, i, c);
}
function string_rindex_rec_opt(s, _i, c) {
    while(true){
        var i = _i;
        if (i < 0) {
            return;
        }
        if (s.codePointAt(i) === c) {
            return i;
        }
        _i = i - 1 | 0;
        continue;
    }
    ;
}
function string_rindex_opt(s, c) {
    return string_rindex_rec_opt(s, s.length - 1 | 0, c);
}
function string_rindex_from_opt(s, i, c) {
    if (i < -1 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rindex_from_opt / Bytes.rindex_from_opt",
            Error: new Error()
        };
    }
    return string_rindex_rec_opt(s, i, c);
}
function string_contains_from(s, i, c) {
    var l = s.length;
    if (i < 0 || i > l) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.contains_from / Bytes.contains_from",
            Error: new Error()
        };
    }
    try {
        string_index_rec(s, l, i, c);
        return true;
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Not_found") {
            return false;
        }
        throw exn;
    }
}
function string_contains(s, c) {
    return string_contains_from(s, 0, c);
}
function string_rcontains_from(s, i, c) {
    if (i < 0 || i >= s.length) {
        throw {
            RE_EXN_ID: "Invalid_argument",
            _1: "String.rcontains_from / Bytes.rcontains_from",
            Error: new Error()
        };
    }
    try {
        string_rindex_rec(s, i, c);
        return true;
    } catch (raw_exn) {
        var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
        if (exn.RE_EXN_ID === "Not_found") {
            return false;
        }
        throw exn;
    }
}
function string_uppercase_ascii(s) {
    return Bytes.unsafe_to_string(Bytes.uppercase_ascii(Bytes.unsafe_of_string(s)));
}
function string_lowercase_ascii(s) {
    return unsafe_to_string(bytes_lowercase_ascii(unsafe_of_string(s)));
}
function string_capitalize_ascii(s) {
    return Bytes.unsafe_to_string(Bytes.capitalize_ascii(Bytes.unsafe_of_string(s)));
}
function string_uncapitalize_ascii(s) {
    return Bytes.unsafe_to_string(Bytes.uncapitalize_ascii(Bytes.unsafe_of_string(s)));
}
var string_compare = caml/* string_compare */.E2;
function string_equal(a, b) {
    return a === b;
}
function split_on_char(sep, s) {
    var r = /* [] */ 0;
    var j = s.length;
    for(var i = s.length - 1 | 0; i >= 0; --i){
        if (s.codePointAt(i) === sep) {
            r = {
                hd: string_sub(s, i + 1 | 0, (j - i | 0) - 1 | 0),
                tl: r
            };
            j = i;
        }
    }
    return {
        hd: string_sub(s, 0, j),
        tl: r
    };
}
var string_make = caml_string_make;
var string_blit = blit_string;
 /* No side effect */ 


/***/ }),

/***/ 90289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uwu": function() { return /* binding */ $$float; },
  "bBs": function() { return /* binding */ active; },
  "cq$": function() { return /* binding */ alignItems; },
  "Czw": function() { return /* binding */ backgroundColor; },
  "SeW": function() { return /* binding */ bold; },
  "tvt": function() { return /* binding */ borderColor; },
  "E0l": function() { return /* binding */ borderRadius; },
  "$uf": function() { return /* binding */ borderStyle; },
  "J4J": function() { return /* binding */ borderWidth; },
  "ixg": function() { return /* binding */ boxSizing; },
  "pIy": function() { return /* binding */ children; },
  "$_Y": function() { return /* binding */ color; },
  "jfB": function() { return /* binding */ display; },
  "fUN": function() { return /* binding */ flex; },
  "Me8": function() { return /* binding */ flexDirection; },
  "H78": function() { return /* binding */ flexGrow; },
  "i4v": function() { return /* binding */ flexShrink; },
  "T_4": function() { return /* binding */ Css_bs_focus; },
  "JBY": function() { return /* binding */ fontSize; },
  "Ue2": function() { return /* binding */ fontWeight; },
  "fD_": function() { return /* binding */ gridArea; },
  "W3B": function() { return /* binding */ gridColumnGap; },
  "lpz": function() { return /* binding */ gridRowStart; },
  "K$K": function() { return /* binding */ gridTemplateColumns; },
  "Cb8": function() { return /* binding */ height; },
  "$v1": function() { return /* binding */ hex; },
  "MrM": function() { return /* binding */ hover; },
  "efO": function() { return /* binding */ important; },
  "KlP": function() { return /* binding */ justifyContent; },
  "QOo": function() { return /* binding */ lastChild; },
  "Nv8": function() { return /* binding */ lineHeight; },
  "e6$": function() { return /* binding */ margin; },
  "yl7": function() { return /* binding */ marginBottom; },
  "oIA": function() { return /* binding */ marginLeft; },
  "wzR": function() { return /* binding */ marginRight; },
  "E9m": function() { return /* binding */ marginTop; },
  "kkr": function() { return /* binding */ maxWidth; },
  "BC2": function() { return /* binding */ media; },
  "jw4": function() { return /* binding */ minHeight; },
  "ihZ": function() { return /* binding */ minWidth; },
  "mJl": function() { return /* binding */ normal; },
  "Kl7": function() { return /* binding */ outline; },
  "o3D": function() { return /* binding */ padding; },
  "EtG": function() { return /* binding */ paddingBottom; },
  "rv2": function() { return /* binding */ paddingLeft; },
  "WLm": function() { return /* binding */ paddingRight; },
  "odA": function() { return /* binding */ paddingTop; },
  "hdZ": function() { return /* binding */ pct; },
  "FKU": function() { return /* binding */ position; },
  "px": function() { return /* binding */ px; },
  "hOB": function() { return /* binding */ rem; },
  "m4f": function() { return /* binding */ rgba; },
  "F2z": function() { return /* binding */ right; },
  "nZE": function() { return /* binding */ selector; },
  "oBv": function() { return /* binding */ style; },
  "ydu": function() { return /* binding */ textAlign; },
  "QXS": function() { return /* binding */ textDecoration; },
  "wey": function() { return /* binding */ Css_bs_top; },
  "K47": function() { return /* binding */ unsafe; },
  "Fv": function() { return /* binding */ visited; },
  "d8w": function() { return /* binding */ whiteSpace; },
  "bf$": function() { return /* binding */ width; },
  "bMI": function() { return /* binding */ zero; }
});

// UNUSED EXPORTS: $$default, $$double, $$global, $$static, $$super, $$var, Animation, Calc, Make, Nth, SVG, Shadow, Transition, Types, absolute, after, alias, aliceblue, alignContent, alignSelf, all, allScroll, alternate, alternateReverse, animation, animationDelay, animationDirection, animationDuration, animationFillMode, animationIterationCount, animationName, animationPlayState, animationTimingFunction, animationValue, animations, antiquewhite, anyLink, aqua, aquamarine, areas, auto, azure, backdropFilter, backfaceVisibility, background, backgroundAttachment, backgroundClip, backgroundImage, backgroundOrigin, backgroundPosition, backgroundPosition4, backgroundPositions, backgroundRepeat, backgroundSize, backgrounds, backwards, baseline, before, beige, bevel, bisque, black, blanchedalmond, block, blue, blueviolet, bolder, border, borderBottom, borderBottomColor, borderBottomLeftRadius, borderBottomRightRadius, borderBottomStyle, borderBottomWidth, borderBox, borderCollapse, borderLeft, borderLeftColor, borderLeftStyle, borderLeftWidth, borderRight, borderRightColor, borderRightStyle, borderRightWidth, borderSpacing, borderTop, borderTopColor, borderTopLeftRadius, borderTopRightRadius, borderTopStyle, borderTopWidth, both, bottom, boxShadow, boxShadows, breakAll, breakWord, brown, burlywood, butt, cadetblue, capitalize, caretColor, cell, center, ch, chartreuse, checked, child, chocolate, clear, clip, clipPath, cm, colResize, column, columnCount, columnGap, columnReverse, columnWidth, conicGradient, contain, content, contentBox, contentRule, contentRules, contents, contextMenu, copy, coral, cornflowerblue, cornsilk, count, counterIncrement, counterReset, counterSet, countersIncrement, countersReset, countersSet, cover, crimson, crosshair, cubicBezier, currentColor, cursor, cyan, darkblue, darkcyan, darkgoldenrod, darkgray, darkgreen, darkgrey, darkkhaki, darkmagenta, darkolivegreen, darkorange, darkorchid, darkred, darksalmon, darkseagreen, darkslateblue, darkslategray, darkslategrey, darkturquoise, darkviolet, dashed, deeppink, deepskyblue, default, defined, deg, dimgray, dimgrey, directSibling, direction, disabled, dodgerblue, dotted, eResize, ease, easeIn, easeInOut, easeOut, ellipsis, em, empty, enabled, ewResize, ex, extraBold, extraLight, fill, fillBox, filter, firebrick, first, firstChild, firstLetter, firstLine, firstOfType, fitContent, fixed, flex3, flexBasis, flexBox, flexEnd, flexStart, flexWrap, floralwhite, focusVisible, focusWithin, fontFace, fontFamilies, fontFamily, fontStyle, fontVariant, forestgreen, forwards, fr, fuchsia, gainsboro, gap, gap2, ghostwhite, gold, goldenrod, grab, grabbing, grad, gray, green, greenyellow, grey, grid, gridArea2, gridArea3, gridArea4, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridColumnEnd, gridColumnStart, gridGap, gridRow, gridRowEnd, gridRowGap, gridTemplateAreas, gridTemplateRows, help, hidden, honeydew, horizontal, host, hotpink, hsl, hsla, ident, inRange, indeterminate, indianred, indigo, infinite, inherit_, initial, inline, inlineBlock, inlineFlex, inlineGrid, inlineTable, insertRule, inside, invalid, isolate, isolation, italic, ivory, justifyItems, justifySelf, keepAll, keyframes, khaki, label, lang, lastOfType, lavender, lavenderblush, lawngreen, left, lemonchiffon, letterSpacing, light, lightblue, lightcoral, lightcyan, lighter, lightgoldenrodyellow, lightgray, lightgreen, lightgrey, lightpink, lightsalmon, lightseagreen, lightskyblue, lightslategray, lightslategrey, lightsteelblue, lightyellow, lime, limegreen, lineThrough, linear, linearGradient, linen, link, listItem, listStyle, listStyleImage, listStylePosition, listStyleType, local, localUrl, lowercase, ltr, magenta, manipulation, margin2, margin3, margin4, marginBox, maroon, maskImage, maskPosition, maskPositions, maxContent, maxHeight, medium, mediumaquamarine, mediumblue, mediumorchid, mediumpurple, mediumseagreen, mediumslateblue, mediumspringgreen, mediumturquoise, mediumvioletred, merge, merge2, merge3, merge4, middle, midnightblue, minContent, minmax, mintcream, mistyrose, miter, mm, moccasin, move, nResize, navajowhite, navy, neResize, neswResize, noDrop, noRepeat, none, notAllowed, not_, nowrap, nsResize, nthChild, nthLastChild, nthLastOfType, nthOfType, numIdent, nwResize, nwseResize, objectFit, objectPosition, oblique, oldlace, olive, olivedrab, onlyChild, onlyOfType, opacity, optional, orange, orangered, orchid, order, outOfRange, outlineColor, outlineOffset, outlineStyle, outlineWidth, outside, overflow, overflowAnchor, overflowWrap, overflowX, overflowY, overline, overscrollBehavior, padding2, padding3, padding4, paddingBox, palegoldenrod, palegreen, paleturquoise, palevioletred, panDown, panLeft, panRight, panUp, panX, panY, papayawhip, paused, peachpuff, perspective, perspectiveOrigin, peru, pinchZoom, pink, placeholder, plum, pointer, pointerEvents, powderblue, progress, pt, purple, pxFloat, rad, radialGradient, readOnly, readWrite, rebeccapurple, red, relative, renderGlobal, renderKeyframes, renderRule, repeat, repeatX, repeatY, repeatingLinearGradient, repeatingRadialGradient, required, resize, reverse, rgb, root, rosybrown, rotate, rotate3d, rotateX, rotateY, rotateZ, round, row, rowGap, rowResize, rowReverse, royalblue, rtl, runIn, running, sResize, saddlebrown, salmon, sandybrown, scale, scale3d, scaleX, scaleY, scaleZ, scope, scroll, scrollBehavior, seResize, seagreen, seashell, selection, semiBold, siblings, sienna, silver, size, skew, skewX, skewY, skyblue, slateblue, slategray, slategrey, smallCaps, snow, solid, space, spaceAround, spaceBetween, spaceEvenly, springgreen, square, steelblue, stepEnd, stepStart, steps, sticky, stretch, strokeBox, sub, swResize, table, tableCaption, tableCell, tableColumn, tableColumnGroup, tableFooterGroup, tableHeaderGroup, tableLayout, tableRow, tableRowGroup, tan, target, teal, text, textBottom, textDecorationColor, textDecorationLine, textDecorationStyle, textIndent, textOverflow, textShadow, textShadows, textTop, textTransform, thin, thistle, toJson, tomato, touchAction, transform, transformOrigin, transformOrigin3d, transformStyle, transforms, transition, transitionDelay, transitionDuration, transitionList, transitionProperty, transitionTimingFunction, transitionValue, transitions, translate, translate3d, translateX, translateY, translateZ, transparent, turn, turquoise, underline, unset, uppercase, url, userSelect, valid, varDefault, vertical, verticalAlign, verticalText, vh, viewBox, violet, visibility, visible, vmax, vmin, vw, wResize, wait, wavy, wheat, white, whitesmoke, wordBreak, wordSpacing, wordWrap, wrap, wrapReverse, yellow, yellowgreen, zIndex, zoomIn, zoomOut

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Colors.bs.js
var Css_Colors_bs = __webpack_require__(77274);
;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/css/node_modules/@emotion/sheet/dist/emotion-sheet.browser.esm.js
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (false) { var isImportRule; }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {}
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if (false) {}
  };

  return StyleSheet;
}();



// EXTERNAL MODULE: ./node_modules/stylis/src/Tokenizer.js
var Tokenizer = __webpack_require__(46411);
// EXTERNAL MODULE: ./node_modules/stylis/src/Utility.js
var Utility = __webpack_require__(26686);
// EXTERNAL MODULE: ./node_modules/stylis/src/Middleware.js + 1 modules
var Middleware = __webpack_require__(94582);
// EXTERNAL MODULE: ./node_modules/stylis/src/Serializer.js
var Serializer = __webpack_require__(20211);
// EXTERNAL MODULE: ./node_modules/stylis/src/Parser.js
var Parser = __webpack_require__(92190);
;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/css/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
}; // based on https://github.com/thysultan/stylis.js/blob/e6843c373ebcbbfade25ebcc23f540ed8508da0a/src/Tokenizer.js#L239-L244


var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = (0,Tokenizer/* peek */.fj)(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if ((0,Tokenizer/* token */.r)(character)) {
      break;
    }

    (0,Tokenizer/* next */.lp)();
  }

  return (0,Tokenizer/* slice */.tP)(begin, Tokenizer/* position */.FK);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch ((0,Tokenizer/* token */.r)(character)) {
      case 0:
        // &\f
        if (character === 38 && (0,Tokenizer/* peek */.fj)() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(Tokenizer/* position */.FK - 1, points, index);
        break;

      case 2:
        parsed[index] += (0,Tokenizer/* delimit */.iF)(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = (0,Tokenizer/* peek */.fj)() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += (0,Utility/* from */.Dp)(character);
    }
  } while (character = (0,Tokenizer/* next */.lp)());

  return parsed;
};

var getRules = function getRules(value, points) {
  return (0,Tokenizer/* dealloc */.cE)(toRules((0,Tokenizer/* alloc */.un)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [Middleware/* prefixer */.Ji];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [Serializer/* stringify */.P,  false ? 0 : (0,Middleware/* rulesheet */.cD)(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = (0,Middleware/* middleware */.qR)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return (0,Serializer/* serialize */.q)((0,Parser/* compile */.MY)(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

/* harmony default export */ var emotion_cache_browser_esm = (createCache);

// EXTERNAL MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
var emotion_hash_esm = __webpack_require__(66292);
// EXTERNAL MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var emotion_unitless_esm = __webpack_require__(94371);
;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/serialize/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ var emotion_memoize_esm = (memoize);

;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.js




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */emotion_memoize_esm(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (emotion_unitless_esm/* default */.Z[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) { var hyphenatedCache, hyphenPattern, msPattern, oldProcessStyleValue, contentValues, contentValuePattern; }

var noComponentSelectorMessage = (/* unused pure expression or super */ null && ('Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.'));

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {}

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {}

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if (false) {}

        break;
      }

    case 'string':
      if (false) { var replaced, matched; }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {}

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if (false) {} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (false) {}

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if (false) {}

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {} // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = (0,emotion_hash_esm/* default */.Z)(styles) + identifierName;

  if (false) {}

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};



;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/css/node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};



;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = emotion_cache_browser_esm(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {}

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered, undefined);
    insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

/* harmony default export */ var emotion_css_create_instance_esm = (createEmotion);

;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/node_modules/@emotion/css/dist/emotion-css.esm.js





var _createEmotion = emotion_css_create_instance_esm({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    emotion_css_esm_merge = _createEmotion.merge,
    emotion_css_esm_getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;



// EXTERNAL MODULE: ./node_modules/bs-css/src/Css_Legacy_Core.bs.js
var Css_Legacy_Core_bs = __webpack_require__(68364);
;// CONCATENATED MODULE: ./node_modules/bs-css-emotion/src/Css.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE





function renderRaw(param, css) {
    injectGlobal(css);
}
function injectRules(selector, rules) {
    injectGlobal(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
function renderRules(param, selector, rules) {
    injectGlobal(js_dict/* fromArray */.nI([
        [
            selector,
            rules
        ]
    ]));
}
function makeKeyframes(frames) {
    return keyframes(frames);
}
function renderKeyframes(param, frames) {
    return keyframes(frames);
}
var include = Css_Legacy_Core_bs/* Make */.t0D({
    injectRaw: injectGlobal,
    renderRaw: renderRaw,
    injectRules: injectRules,
    renderRules: renderRules,
    make: css,
    mergeStyles: cx,
    makeKeyframes: makeKeyframes,
    renderKeyframes: renderKeyframes
});
var insertRule = include.insertRule;
function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
    var asString = Css_Legacy_Core.fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, undefined);
    Curry._1(insertRule, asString);
    return fontFamily;
}
var Types = Css_Legacy_Core_bs/* Types */.Yky;
var Make = Css_Legacy_Core_bs/* Make */.t0D;
var toJson = Css_Legacy_Core_bs/* toJson */.QsJ;
var important = Css_Legacy_Core_bs/* important */.efO;
var label = Css_Legacy_Core_bs/* label */.PS9;
var Shadow = Css_Legacy_Core_bs/* Shadow */.jXB;
var unsafe = Css_Legacy_Core_bs/* unsafe */.K47;
var alignContent = Css_Legacy_Core_bs/* alignContent */.Kvj;
var alignItems = Css_Legacy_Core_bs/* alignItems */.cq$;
var alignSelf = Css_Legacy_Core_bs/* alignSelf */.uko;
var animationDelay = Css_Legacy_Core_bs/* animationDelay */.lEu;
var animationDirection = Css_Legacy_Core_bs/* animationDirection */.ZRe;
var animationDuration = Css_Legacy_Core_bs/* animationDuration */.wyN;
var animationFillMode = Css_Legacy_Core_bs/* animationFillMode */.$mx;
var animationIterationCount = Css_Legacy_Core_bs/* animationIterationCount */.EcY;
var animationPlayState = Css_Legacy_Core_bs/* animationPlayState */.dZD;
var animationTimingFunction = Css_Legacy_Core_bs/* animationTimingFunction */.KUN;
var backdropFilter = Css_Legacy_Core_bs/* backdropFilter */.nLE;
var backfaceVisibility = Css_Legacy_Core_bs/* backfaceVisibility */.uhB;
var backgroundAttachment = Css_Legacy_Core_bs/* backgroundAttachment */.Yep;
var backgroundColor = Css_Legacy_Core_bs/* backgroundColor */.Czw;
var backgroundClip = Css_Legacy_Core_bs/* backgroundClip */._cl;
var backgroundImage = Css_Legacy_Core_bs/* backgroundImage */.NxW;
var maskImage = Css_Legacy_Core_bs/* maskImage */.zT3;
var backgroundOrigin = Css_Legacy_Core_bs/* backgroundOrigin */.ezj;
var backgroundPosition = Css_Legacy_Core_bs/* backgroundPosition */.k0m;
var backgroundPositions = Css_Legacy_Core_bs/* backgroundPositions */.bCW;
var backgroundPosition4 = Css_Legacy_Core_bs/* backgroundPosition4 */.Sgw;
var backgroundRepeat = Css_Legacy_Core_bs/* backgroundRepeat */.FDc;
var maskPosition = Css_Legacy_Core_bs/* maskPosition */.tac;
var maskPositions = Css_Legacy_Core_bs/* maskPositions */.otN;
var borderBottom = Css_Legacy_Core_bs/* borderBottom */.h$9;
var borderBottomColor = Css_Legacy_Core_bs/* borderBottomColor */.vSo;
var borderBottomLeftRadius = Css_Legacy_Core_bs/* borderBottomLeftRadius */.AGO;
var borderBottomRightRadius = Css_Legacy_Core_bs/* borderBottomRightRadius */.rfy;
var borderBottomStyle = Css_Legacy_Core_bs/* borderBottomStyle */.qtZ;
var borderBottomWidth = Css_Legacy_Core_bs/* borderBottomWidth */.HMX;
var borderCollapse = Css_Legacy_Core_bs/* borderCollapse */.obx;
var borderColor = Css_Legacy_Core_bs/* borderColor */.tvt;
var borderLeft = Css_Legacy_Core_bs/* borderLeft */.sc3;
var borderLeftColor = Css_Legacy_Core_bs/* borderLeftColor */.VvE;
var borderLeftStyle = Css_Legacy_Core_bs/* borderLeftStyle */.njC;
var borderLeftWidth = Css_Legacy_Core_bs/* borderLeftWidth */.Pxd;
var borderRight = Css_Legacy_Core_bs/* borderRight */.vQA;
var borderRightColor = Css_Legacy_Core_bs/* borderRightColor */.XY7;
var borderRightStyle = Css_Legacy_Core_bs/* borderRightStyle */.SVd;
var borderRightWidth = Css_Legacy_Core_bs/* borderRightWidth */.UY5;
var borderRadius = Css_Legacy_Core_bs/* borderRadius */.E0l;
var borderSpacing = Css_Legacy_Core_bs/* borderSpacing */.hJp;
var borderStyle = Css_Legacy_Core_bs/* borderStyle */.$uf;
var borderTopColor = Css_Legacy_Core_bs/* borderTopColor */.SKu;
var borderTopLeftRadius = Css_Legacy_Core_bs/* borderTopLeftRadius */.orU;
var borderTopRightRadius = Css_Legacy_Core_bs/* borderTopRightRadius */.E$t;
var borderTopStyle = Css_Legacy_Core_bs/* borderTopStyle */.$Bc;
var borderTopWidth = Css_Legacy_Core_bs/* borderTopWidth */.fCW;
var borderWidth = Css_Legacy_Core_bs/* borderWidth */.J4J;
var bottom = Css_Legacy_Core_bs/* bottom */.IaC;
var boxSizing = Css_Legacy_Core_bs/* boxSizing */.ixg;
var boxShadow = Css_Legacy_Core_bs/* boxShadow */.Wnp;
var boxShadows = Css_Legacy_Core_bs/* boxShadows */.LZf;
var clear = Css_Legacy_Core_bs/* clear */.ZHw;
var clipPath = Css_Legacy_Core_bs/* clipPath */.o6J;
var color = Css_Legacy_Core_bs/* color */.$_Y;
var columnCount = Css_Legacy_Core_bs/* columnCount */.J49;
var contentRule = Css_Legacy_Core_bs/* contentRule */.U5V;
var contentRules = Css_Legacy_Core_bs/* contentRules */.jK5;
var counterIncrement = Css_Legacy_Core_bs/* counterIncrement */.ga_;
var countersIncrement = Css_Legacy_Core_bs/* countersIncrement */.$Co;
var counterReset = Css_Legacy_Core_bs/* counterReset */.K03;
var countersReset = Css_Legacy_Core_bs/* countersReset */.Yi5;
var counterSet = Css_Legacy_Core_bs/* counterSet */.nKF;
var countersSet = Css_Legacy_Core_bs/* countersSet */.Eqy;
var Css_bs_cursor = Css_Legacy_Core_bs/* cursor */.ocY;
var direction = Css_Legacy_Core_bs/* direction */.o7V;
var display = Css_Legacy_Core_bs/* display */.jfB;
var flex = Css_Legacy_Core_bs/* flex */.fUN;
var flexBasis = Css_Legacy_Core_bs/* flexBasis */.P_T;
var flexDirection = Css_Legacy_Core_bs/* flexDirection */.Me8;
var flexGrow = Css_Legacy_Core_bs/* flexGrow */.H78;
var flexShrink = Css_Legacy_Core_bs/* flexShrink */.i4v;
var flexWrap = Css_Legacy_Core_bs/* flexWrap */.WOS;
var $$float = Css_Legacy_Core_bs/* $$float */.uwu;
var fontFamily = Css_Legacy_Core_bs/* fontFamily */.I85;
var fontFamilies = Css_Legacy_Core_bs/* fontFamilies */.VlP;
var fontSize = Css_Legacy_Core_bs/* fontSize */.JBY;
var fontStyle = Css_Legacy_Core_bs/* fontStyle */.p_N;
var fontVariant = Css_Legacy_Core_bs/* fontVariant */.xvA;
var fontWeight = Css_Legacy_Core_bs/* fontWeight */.Ue2;
var gridArea = Css_Legacy_Core_bs/* gridArea */.fD_;
var gridArea2 = Css_Legacy_Core_bs/* gridArea2 */.Vy2;
var gridArea3 = Css_Legacy_Core_bs/* gridArea3 */.V8q;
var gridArea4 = Css_Legacy_Core_bs/* gridArea4 */.PUt;
var gridAutoFlow = Css_Legacy_Core_bs/* gridAutoFlow */.BaW;
var gridColumn = Css_Legacy_Core_bs/* gridColumn */.t4e;
var gridColumnEnd = Css_Legacy_Core_bs/* gridColumnEnd */.cod;
var columnGap = Css_Legacy_Core_bs/* columnGap */.e$I;
var scrollBehavior = Css_Legacy_Core_bs/* scrollBehavior */.sCq;
var overscrollBehavior = Css_Legacy_Core_bs/* overscrollBehavior */.jSQ;
var overflowAnchor = Css_Legacy_Core_bs/* overflowAnchor */.PhB;
var columnWidth = Css_Legacy_Core_bs/* columnWidth */.G4A;
var caretColor = Css_Legacy_Core_bs/* caretColor */.OYb;
var rowGap = Css_Legacy_Core_bs/* rowGap */.s2f;
var gridColumnGap = Css_Legacy_Core_bs/* gridColumnGap */.W3B;
var gridColumnStart = Css_Legacy_Core_bs/* gridColumnStart */.ur1;
var gap = Css_Legacy_Core_bs/* gap */.SGp;
var gap2 = Css_Legacy_Core_bs/* gap2 */.rjz;
var gridGap = Css_Legacy_Core_bs/* gridGap */.Ccm;
var gridRow = Css_Legacy_Core_bs/* gridRow */.oIx;
var gridRowEnd = Css_Legacy_Core_bs/* gridRowEnd */.Zys;
var gridRowGap = Css_Legacy_Core_bs/* gridRowGap */.UbJ;
var gridRowStart = Css_Legacy_Core_bs/* gridRowStart */.lpz;
var gridTemplateAreas = Css_Legacy_Core_bs/* gridTemplateAreas */.zIs;
var height = Css_Legacy_Core_bs/* height */.Cb8;
var justifyContent = Css_Legacy_Core_bs/* justifyContent */.KlP;
var justifyItems = Css_Legacy_Core_bs/* justifyItems */.eYb;
var justifySelf = Css_Legacy_Core_bs/* justifySelf */.zoP;
var left = Css_Legacy_Core_bs/* left */.t$v;
var letterSpacing = Css_Legacy_Core_bs/* letterSpacing */.rXp;
var lineHeight = Css_Legacy_Core_bs/* lineHeight */.Nv8;
var listStyle = Css_Legacy_Core_bs/* listStyle */.VXB;
var listStyleImage = Css_Legacy_Core_bs/* listStyleImage */.yOV;
var listStyleType = Css_Legacy_Core_bs/* listStyleType */.jZR;
var listStylePosition = Css_Legacy_Core_bs/* listStylePosition */.xPo;
var margin = Css_Legacy_Core_bs/* margin */.e6$;
var margin2 = Css_Legacy_Core_bs/* margin2 */.h9x;
var margin3 = Css_Legacy_Core_bs/* margin3 */.F86;
var margin4 = Css_Legacy_Core_bs/* margin4 */.X0Y;
var marginLeft = Css_Legacy_Core_bs/* marginLeft */.oIA;
var marginRight = Css_Legacy_Core_bs/* marginRight */.wzR;
var marginTop = Css_Legacy_Core_bs/* marginTop */.E9m;
var marginBottom = Css_Legacy_Core_bs/* marginBottom */.yl7;
var maxHeight = Css_Legacy_Core_bs/* maxHeight */.kCL;
var maxWidth = Css_Legacy_Core_bs/* maxWidth */.kkr;
var minHeight = Css_Legacy_Core_bs/* minHeight */.jw4;
var minWidth = Css_Legacy_Core_bs/* minWidth */.ihZ;
var objectFit = Css_Legacy_Core_bs/* objectFit */.fXf;
var objectPosition = Css_Legacy_Core_bs/* objectPosition */.YP6;
var opacity = Css_Legacy_Core_bs/* opacity */.Ohi;
var order = Css_Legacy_Core_bs/* order */.vmh;
var outline = Css_Legacy_Core_bs/* outline */.Kl7;
var outlineColor = Css_Legacy_Core_bs/* outlineColor */.dxT;
var outlineOffset = Css_Legacy_Core_bs/* outlineOffset */.KL2;
var outlineStyle = Css_Legacy_Core_bs/* outlineStyle */.zuB;
var outlineWidth = Css_Legacy_Core_bs/* outlineWidth */.bu0;
var overflow = Css_Legacy_Core_bs/* overflow */.txR;
var overflowX = Css_Legacy_Core_bs/* overflowX */.zzh;
var overflowY = Css_Legacy_Core_bs/* overflowY */.pU1;
var overflowWrap = Css_Legacy_Core_bs/* overflowWrap */.LIb;
var padding = Css_Legacy_Core_bs/* padding */.o3D;
var padding2 = Css_Legacy_Core_bs/* padding2 */.BLt;
var padding3 = Css_Legacy_Core_bs/* padding3 */.OqZ;
var padding4 = Css_Legacy_Core_bs/* padding4 */._fG;
var paddingLeft = Css_Legacy_Core_bs/* paddingLeft */.rv2;
var paddingRight = Css_Legacy_Core_bs/* paddingRight */.WLm;
var paddingTop = Css_Legacy_Core_bs/* paddingTop */.odA;
var paddingBottom = Css_Legacy_Core_bs/* paddingBottom */.EtG;
var perspective = Css_Legacy_Core_bs/* perspective */.G30;
var perspectiveOrigin = Css_Legacy_Core_bs/* perspectiveOrigin */.gr0;
var pointerEvents = Css_Legacy_Core_bs/* pointerEvents */.kkJ;
var position = Css_Legacy_Core_bs/* position */.FKU;
var isolation = Css_Legacy_Core_bs/* isolation */.BD_;
var resize = Css_Legacy_Core_bs/* resize */.SIr;
var right = Css_Legacy_Core_bs/* right */.F2z;
var tableLayout = Css_Legacy_Core_bs/* tableLayout */.GJu;
var textAlign = Css_Legacy_Core_bs/* textAlign */.ydu;
var textDecorationColor = Css_Legacy_Core_bs/* textDecorationColor */.hrh;
var textDecorationLine = Css_Legacy_Core_bs/* textDecorationLine */.A8G;
var textDecorationStyle = Css_Legacy_Core_bs/* textDecorationStyle */.vo$;
var textIndent = Css_Legacy_Core_bs/* textIndent */.h52;
var textOverflow = Css_Legacy_Core_bs/* textOverflow */._Xt;
var textShadow = Css_Legacy_Core_bs/* textShadow */.XCE;
var textShadows = Css_Legacy_Core_bs/* textShadows */.sg9;
var textTransform = Css_Legacy_Core_bs/* textTransform */.QxZ;
var Css_bs_top = Css_Legacy_Core_bs/* top */.wey;
var transform = Css_Legacy_Core_bs/* transform */.vs;
var transforms = Css_Legacy_Core_bs/* transforms */.Lol;
var transformOrigin = Css_Legacy_Core_bs/* transformOrigin */.p22;
var transformOrigin3d = Css_Legacy_Core_bs/* transformOrigin3d */.TRc;
var transitionDelay = Css_Legacy_Core_bs/* transitionDelay */.BFP;
var transitionDuration = Css_Legacy_Core_bs/* transitionDuration */.nVE;
var transitionProperty = Css_Legacy_Core_bs/* transitionProperty */.n_e;
var transformStyle = Css_Legacy_Core_bs/* transformStyle */.V1P;
var transitionTimingFunction = Css_Legacy_Core_bs/* transitionTimingFunction */.BdG;
var userSelect = Css_Legacy_Core_bs/* userSelect */.sih;
var verticalAlign = Css_Legacy_Core_bs/* verticalAlign */.Loy;
var visibility = Css_Legacy_Core_bs/* visibility */.WDY;
var width = Css_Legacy_Core_bs/* width */.bf$;
var whiteSpace = Css_Legacy_Core_bs/* whiteSpace */.d8w;
var wordBreak = Css_Legacy_Core_bs/* wordBreak */.lM7;
var wordSpacing = Css_Legacy_Core_bs/* wordSpacing */.qJL;
var wordWrap = Css_Legacy_Core_bs/* wordWrap */.BWb;
var zIndex = Css_Legacy_Core_bs/* zIndex */.W5D;
var selector = Css_Legacy_Core_bs/* selector */.nZE;
var media = Css_Legacy_Core_bs/* media */.BC2;
var active = Css_Legacy_Core_bs/* active */.bBs;
var checked = Css_Legacy_Core_bs/* checked */.ec_;
var $$default = Css_Legacy_Core_bs/* $$default */.rHv;
var defined = Css_Legacy_Core_bs/* defined */.rif;
var disabled = Css_Legacy_Core_bs/* disabled */.JUm;
var empty = Css_Legacy_Core_bs/* empty */.cSb;
var enabled = Css_Legacy_Core_bs/* enabled */.amh;
var first = Css_Legacy_Core_bs/* first */.PsQ;
var firstChild = Css_Legacy_Core_bs/* firstChild */.mUE;
var firstOfType = Css_Legacy_Core_bs/* firstOfType */.$Sh;
var Css_bs_focus = Css_Legacy_Core_bs/* focus */.T_4;
var focusVisible = Css_Legacy_Core_bs/* focusVisible */.bPo;
var focusWithin = Css_Legacy_Core_bs/* focusWithin */.u_l;
var host = Css_Legacy_Core_bs/* host */.ho7;
var hover = Css_Legacy_Core_bs/* hover */.MrM;
var indeterminate = Css_Legacy_Core_bs/* indeterminate */.Nxf;
var inRange = Css_Legacy_Core_bs/* inRange */.Z2v;
var invalid = Css_Legacy_Core_bs/* invalid */.I1x;
var lang = Css_Legacy_Core_bs/* lang */.KQv;
var lastChild = Css_Legacy_Core_bs/* lastChild */.QOo;
var lastOfType = Css_Legacy_Core_bs/* lastOfType */.xBE;
var Css_bs_link = Css_Legacy_Core_bs/* link */.p4m;
var not_ = Css_Legacy_Core_bs/* not_ */.YdO;
var Nth = Css_Legacy_Core_bs/* Nth */.eNo;
var nthChild = Css_Legacy_Core_bs/* nthChild */.vvq;
var nthLastChild = Css_Legacy_Core_bs/* nthLastChild */.NXf;
var nthLastOfType = Css_Legacy_Core_bs/* nthLastOfType */.tPj;
var nthOfType = Css_Legacy_Core_bs/* nthOfType */.NOF;
var onlyChild = Css_Legacy_Core_bs/* onlyChild */.Z9P;
var onlyOfType = Css_Legacy_Core_bs/* onlyOfType */.zEV;
var optional = Css_Legacy_Core_bs/* optional */.jtO;
var outOfRange = Css_Legacy_Core_bs/* outOfRange */.ihe;
var readOnly = Css_Legacy_Core_bs/* readOnly */.qtd;
var readWrite = Css_Legacy_Core_bs/* readWrite */.H6;
var required = Css_Legacy_Core_bs/* required */.C1W;
var root = Css_Legacy_Core_bs/* root */.Jz2;
var scope = Css_Legacy_Core_bs/* scope */.eIe;
var target = Css_Legacy_Core_bs/* target */.fA7;
var valid = Css_Legacy_Core_bs/* valid */.QF4;
var visited = Css_Legacy_Core_bs/* visited */.Fv;
var after = Css_Legacy_Core_bs/* after */.e4p;
var before = Css_Legacy_Core_bs/* before */.bbn;
var firstLetter = Css_Legacy_Core_bs/* firstLetter */.i16;
var firstLine = Css_Legacy_Core_bs/* firstLine */.wxz;
var placeholder = Css_Legacy_Core_bs/* placeholder */.W$B;
var selection = Css_Legacy_Core_bs/* selection */.DuZ;
var child = Css_Legacy_Core_bs/* child */.iUc;
var children = Css_Legacy_Core_bs/* children */.pIy;
var directSibling = Css_Legacy_Core_bs/* directSibling */.cOP;
var siblings = Css_Legacy_Core_bs/* siblings */.dxy;
var anyLink = Css_Legacy_Core_bs/* anyLink */.ub3;
var initial = Css_Legacy_Core_bs/* initial */.nnL;
var inherit_ = Css_Legacy_Core_bs/* inherit_ */.atG;
var unset = Css_Legacy_Core_bs/* unset */.zNf;
var $$var = Css_Legacy_Core_bs/* $$var */.epG;
var varDefault = Css_Legacy_Core_bs/* varDefault */.Djg;
var auto = Css_Legacy_Core_bs/* auto */.d73;
var none = Css_Legacy_Core_bs/* none */.YPD;
var Css_bs_text = Css_Legacy_Core_bs/* text */.fLW;
var pct = Css_Legacy_Core_bs/* pct */.hdZ;
var ch = Css_Legacy_Core_bs.ch;
var cm = Css_Legacy_Core_bs.cm;
var em = Css_Legacy_Core_bs.em;
var ex = Css_Legacy_Core_bs.ex;
var mm = Css_Legacy_Core_bs.mm;
var pt = Css_Legacy_Core_bs.pt;
var px = Css_Legacy_Core_bs.px;
var pxFloat = Css_Legacy_Core_bs/* pxFloat */.cYj;
var rem = Css_Legacy_Core_bs/* rem */.hOB;
var vh = Css_Legacy_Core_bs.vh;
var vmin = Css_Legacy_Core_bs/* vmin */.v03;
var vmax = Css_Legacy_Core_bs/* vmax */.s8c;
var zero = Css_Legacy_Core_bs/* zero */.bMI;
var deg = Css_Legacy_Core_bs/* deg */.OaU;
var rad = Css_Legacy_Core_bs/* rad */.BJ1;
var grad = Css_Legacy_Core_bs/* grad */.UQy;
var turn = Css_Legacy_Core_bs/* turn */.E2y;
var ltr = Css_Legacy_Core_bs/* ltr */.m6$;
var rtl = Css_Legacy_Core_bs/* rtl */.bd4;
var absolute = Css_Legacy_Core_bs/* absolute */.AGi;
var relative = Css_Legacy_Core_bs/* relative */.Gfm;
var $$static = Css_Legacy_Core_bs/* $$static */.Yum;
var fixed = Css_Legacy_Core_bs/* fixed */.Bdr;
var sticky = Css_Legacy_Core_bs/* sticky */.CAZ;
var isolate = Css_Legacy_Core_bs/* isolate */.KMK;
var horizontal = Css_Legacy_Core_bs/* horizontal */.SlK;
var vertical = Css_Legacy_Core_bs/* vertical */.KRj;
var smallCaps = Css_Legacy_Core_bs/* smallCaps */.jc2;
var italic = Css_Legacy_Core_bs/* italic */.pUw;
var oblique = Css_Legacy_Core_bs/* oblique */.$6v;
var Css_bs_hidden = Css_Legacy_Core_bs/* hidden */.alX;
var visible = Css_Legacy_Core_bs/* visible */.oPT;
var Css_bs_scroll = Css_Legacy_Core_bs/* scroll */.ARY;
var rgb = Css_Legacy_Core_bs/* rgb */.B8C;
var rgba = Css_Legacy_Core_bs/* rgba */.m4f;
var hsl = Css_Legacy_Core_bs/* hsl */.Ym7;
var hsla = Css_Legacy_Core_bs/* hsla */.Jnk;
var hex = Css_Legacy_Core_bs/* hex */.$v1;
var currentColor = Css_Legacy_Core_bs/* currentColor */.wyo;
var local = Css_Legacy_Core_bs/* local */.I_Q;
var paddingBox = Css_Legacy_Core_bs/* paddingBox */.tD0;
var borderBox = Css_Legacy_Core_bs/* borderBox */.iu7;
var contentBox = Css_Legacy_Core_bs/* contentBox */.fLi;
var noRepeat = Css_Legacy_Core_bs/* noRepeat */.DHQ;
var space = Css_Legacy_Core_bs/* space */.DhX;
var repeat = Css_Legacy_Core_bs/* repeat */.rx1;
var minmax = Css_Legacy_Core_bs/* minmax */.WFv;
var repeatX = Css_Legacy_Core_bs/* repeatX */.pMI;
var repeatY = Css_Legacy_Core_bs/* repeatY */.yEL;
var contain = Css_Legacy_Core_bs/* contain */.XSY;
var cover = Css_Legacy_Core_bs/* cover */.v8j;
var row = Css_Legacy_Core_bs/* row */.O7B;
var rowReverse = Css_Legacy_Core_bs/* rowReverse */.poq;
var column = Css_Legacy_Core_bs/* column */.$QP;
var columnReverse = Css_Legacy_Core_bs/* columnReverse */.Xsx;
var wrap = Css_Legacy_Core_bs/* wrap */.reQ;
var nowrap = Css_Legacy_Core_bs/* nowrap */.P8R;
var wrapReverse = Css_Legacy_Core_bs/* wrapReverse */.g7Q;
var inline = Css_Legacy_Core_bs/* inline */.QoB;
var block = Css_Legacy_Core_bs/* block */.Gew;
var contents = Css_Legacy_Core_bs/* contents */.IQZ;
var flexBox = Css_Legacy_Core_bs/* flexBox */.tPW;
var grid = Css_Legacy_Core_bs/* grid */.eCg;
var inlineBlock = Css_Legacy_Core_bs/* inlineBlock */.vdF;
var inlineFlex = Css_Legacy_Core_bs/* inlineFlex */.z8w;
var inlineGrid = Css_Legacy_Core_bs/* inlineGrid */.tgT;
var inlineTable = Css_Legacy_Core_bs/* inlineTable */.ZHG;
var listItem = Css_Legacy_Core_bs/* listItem */.qbe;
var runIn = Css_Legacy_Core_bs/* runIn */.Jbp;
var table = Css_Legacy_Core_bs/* table */.Kzj;
var tableCaption = Css_Legacy_Core_bs/* tableCaption */.Ppf;
var tableColumnGroup = Css_Legacy_Core_bs/* tableColumnGroup */.yLU;
var tableHeaderGroup = Css_Legacy_Core_bs/* tableHeaderGroup */.a5O;
var tableFooterGroup = Css_Legacy_Core_bs/* tableFooterGroup */.ANm;
var tableRowGroup = Css_Legacy_Core_bs/* tableRowGroup */.NY0;
var tableCell = Css_Legacy_Core_bs/* tableCell */.K5p;
var tableColumn = Css_Legacy_Core_bs/* tableColumn */.ibC;
var tableRow = Css_Legacy_Core_bs/* tableRow */.RLZ;
var flexStart = Css_Legacy_Core_bs/* flexStart */.c4c;
var flexEnd = Css_Legacy_Core_bs/* flexEnd */.QdD;
var center = Css_Legacy_Core_bs/* center */.beQ;
var stretch = Css_Legacy_Core_bs/* stretch */.dy0;
var spaceBetween = Css_Legacy_Core_bs/* spaceBetween */.fHD;
var spaceAround = Css_Legacy_Core_bs/* spaceAround */.hHJ;
var spaceEvenly = Css_Legacy_Core_bs/* spaceEvenly */.isX;
var baseline = Css_Legacy_Core_bs/* baseline */.j96;
var forwards = Css_Legacy_Core_bs/* forwards */.Gho;
var backwards = Css_Legacy_Core_bs/* backwards */.aWF;
var both = Css_Legacy_Core_bs/* both */.HkC;
var infinite = Css_Legacy_Core_bs/* infinite */.oXI;
var count = Css_Legacy_Core_bs/* count */.QXW;
var paused = Css_Legacy_Core_bs/* paused */.K9x;
var running = Css_Legacy_Core_bs/* running */.wCv;
var inside = Css_Legacy_Core_bs/* inside */.Odq;
var outside = Css_Legacy_Core_bs/* outside */.SX6;
var solid = Css_Legacy_Core_bs/* solid */.SQh;
var dotted = Css_Legacy_Core_bs/* dotted */.ftw;
var dashed = Css_Legacy_Core_bs/* dashed */.HA;
var underline = Css_Legacy_Core_bs/* underline */.eCr;
var overline = Css_Legacy_Core_bs/* overline */.I95;
var lineThrough = Css_Legacy_Core_bs/* lineThrough */.jLD;
var clip = Css_Legacy_Core_bs/* clip */.oqW;
var ellipsis = Css_Legacy_Core_bs/* ellipsis */.LHJ;
var wavy = Css_Legacy_Core_bs/* wavy */.Pp4;
var $$double = Css_Legacy_Core_bs/* $$double */.ceD;
var uppercase = Css_Legacy_Core_bs/* uppercase */.PqQ;
var lowercase = Css_Legacy_Core_bs/* lowercase */.wXG;
var capitalize = Css_Legacy_Core_bs/* capitalize */.kC2;
var sub = Css_Legacy_Core_bs/* sub */.luU;
var $$super = Css_Legacy_Core_bs/* $$super */.dkg;
var textTop = Css_Legacy_Core_bs/* textTop */.L8u;
var textBottom = Css_Legacy_Core_bs/* textBottom */.eRF;
var middle = Css_Legacy_Core_bs/* middle */.XNj;
var normal = Css_Legacy_Core_bs/* normal */.mJl;
var breakAll = Css_Legacy_Core_bs/* breakAll */.k$v;
var keepAll = Css_Legacy_Core_bs/* keepAll */.mvd;
var breakWord = Css_Legacy_Core_bs/* breakWord */.kZi;
var reverse = Css_Legacy_Core_bs/* reverse */.GYS;
var alternate = Css_Legacy_Core_bs/* alternate */.J6G;
var alternateReverse = Css_Legacy_Core_bs/* alternateReverse */.XOq;
var fill = Css_Legacy_Core_bs/* fill */.hlL;
var content = Css_Legacy_Core_bs/* content */.kQN;
var maxContent = Css_Legacy_Core_bs/* maxContent */.FHD;
var minContent = Css_Legacy_Core_bs/* minContent */.fxJ;
var fitContent = Css_Legacy_Core_bs/* fitContent */.E0j;
var Css_bs_all = Css_Legacy_Core_bs/* all */.$6P;
var round = Css_Legacy_Core_bs/* round */.NMM;
var miter = Css_Legacy_Core_bs/* miter */.mwL;
var bevel = Css_Legacy_Core_bs/* bevel */.aHA;
var butt = Css_Legacy_Core_bs/* butt */.giC;
var square = Css_Legacy_Core_bs/* square */.h62;
var panX = Css_Legacy_Core_bs/* panX */.i36;
var panY = Css_Legacy_Core_bs/* panY */.$hU;
var panLeft = Css_Legacy_Core_bs/* panLeft */.xZz;
var panRight = Css_Legacy_Core_bs/* panRight */.UY0;
var panUp = Css_Legacy_Core_bs/* panUp */.LAG;
var panDown = Css_Legacy_Core_bs/* panDown */.VF7;
var pinchZoom = Css_Legacy_Core_bs/* pinchZoom */.ybA;
var manipulation = Css_Legacy_Core_bs/* manipulation */.WP2;
var thin = Css_Legacy_Core_bs/* thin */.vPS;
var extraLight = Css_Legacy_Core_bs/* extraLight */.ncr;
var light = Css_Legacy_Core_bs/* light */.R29;
var medium = Css_Legacy_Core_bs/* medium */.IV2;
var semiBold = Css_Legacy_Core_bs/* semiBold */.aX$;
var bold = Css_Legacy_Core_bs/* bold */.SeW;
var extraBold = Css_Legacy_Core_bs/* extraBold */.TE9;
var lighter = Css_Legacy_Core_bs/* lighter */.f6n;
var bolder = Css_Legacy_Core_bs/* bolder */.fT5;
var fr = Css_Legacy_Core_bs.fr;
var vw = Css_Legacy_Core_bs.vw;
var localUrl = Css_Legacy_Core_bs/* localUrl */.hGO;
var url = Css_Legacy_Core_bs/* url */.HQ2;
var linear = Css_Legacy_Core_bs/* linear */.GEo;
var ease = Css_Legacy_Core_bs/* ease */.mvv;
var easeIn = Css_Legacy_Core_bs/* easeIn */.YQY;
var easeOut = Css_Legacy_Core_bs/* easeOut */.VvG;
var easeInOut = Css_Legacy_Core_bs/* easeInOut */.mZN;
var stepStart = Css_Legacy_Core_bs/* stepStart */.UrL;
var stepEnd = Css_Legacy_Core_bs/* stepEnd */.gB9;
var steps = Css_Legacy_Core_bs/* steps */.S6;
var cubicBezier = Css_Legacy_Core_bs/* cubicBezier */._s1;
var marginBox = Css_Legacy_Core_bs/* marginBox */.m8E;
var fillBox = Css_Legacy_Core_bs/* fillBox */.Bbi;
var strokeBox = Css_Legacy_Core_bs/* strokeBox */.BKm;
var viewBox = Css_Legacy_Core_bs/* viewBox */.exU;
var translate = Css_Legacy_Core_bs/* translate */.Iue;
var translate3d = Css_Legacy_Core_bs/* translate3d */.z2Y;
var translateX = Css_Legacy_Core_bs/* translateX */.YPe;
var translateY = Css_Legacy_Core_bs/* translateY */.iWO;
var translateZ = Css_Legacy_Core_bs/* translateZ */.hR4;
var scale = Css_Legacy_Core_bs/* scale */.bAd;
var scale3d = Css_Legacy_Core_bs/* scale3d */.C74;
var scaleX = Css_Legacy_Core_bs/* scaleX */.eZH;
var scaleY = Css_Legacy_Core_bs/* scaleY */.$zm;
var scaleZ = Css_Legacy_Core_bs/* scaleZ */.p3g;
var rotate = Css_Legacy_Core_bs/* rotate */.U1s;
var rotate3d = Css_Legacy_Core_bs/* rotate3d */.er3;
var rotateX = Css_Legacy_Core_bs/* rotateX */.lMS;
var rotateY = Css_Legacy_Core_bs/* rotateY */.uDD;
var rotateZ = Css_Legacy_Core_bs/* rotateZ */.jIM;
var skew = Css_Legacy_Core_bs/* skew */.Tm5;
var skewX = Css_Legacy_Core_bs/* skewX */.QkJ;
var skewY = Css_Legacy_Core_bs/* skewY */.FoG;
var linearGradient = Css_Legacy_Core_bs/* linearGradient */.bCQ;
var repeatingLinearGradient = Css_Legacy_Core_bs/* repeatingLinearGradient */.k_P;
var radialGradient = Css_Legacy_Core_bs/* radialGradient */.zso;
var repeatingRadialGradient = Css_Legacy_Core_bs/* repeatingRadialGradient */.Cak;
var conicGradient = Css_Legacy_Core_bs/* conicGradient */.LC$;
var areas = Css_Legacy_Core_bs/* areas */.aku;
var ident = Css_Legacy_Core_bs/* ident */.yRn;
var numIdent = Css_Legacy_Core_bs/* numIdent */.p$S;
var contextMenu = Css_Legacy_Core_bs/* contextMenu */.zCX;
var help = Css_Legacy_Core_bs/* help */.R_2;
var pointer = Css_Legacy_Core_bs/* pointer */.cx$;
var progress = Css_Legacy_Core_bs/* progress */.YD2;
var wait = Css_Legacy_Core_bs/* wait */.Dc1;
var cell = Css_Legacy_Core_bs/* cell */.o4w;
var crosshair = Css_Legacy_Core_bs/* crosshair */.uGs;
var verticalText = Css_Legacy_Core_bs/* verticalText */.eEk;
var alias = Css_Legacy_Core_bs/* alias */.bme;
var copy = Css_Legacy_Core_bs/* copy */.JGK;
var move = Css_Legacy_Core_bs/* move */.pBW;
var noDrop = Css_Legacy_Core_bs/* noDrop */.Kgc;
var notAllowed = Css_Legacy_Core_bs/* notAllowed */.jsT;
var grab = Css_Legacy_Core_bs/* grab */.x2h;
var grabbing = Css_Legacy_Core_bs/* grabbing */.$xc;
var allScroll = Css_Legacy_Core_bs/* allScroll */.fFX;
var colResize = Css_Legacy_Core_bs/* colResize */.QiF;
var rowResize = Css_Legacy_Core_bs/* rowResize */.oJs;
var nResize = Css_Legacy_Core_bs/* nResize */.na1;
var eResize = Css_Legacy_Core_bs/* eResize */.az5;
var sResize = Css_Legacy_Core_bs/* sResize */.voX;
var wResize = Css_Legacy_Core_bs/* wResize */.CvW;
var neResize = Css_Legacy_Core_bs/* neResize */.f7d;
var nwResize = Css_Legacy_Core_bs/* nwResize */.zZK;
var seResize = Css_Legacy_Core_bs/* seResize */._Ef;
var swResize = Css_Legacy_Core_bs/* swResize */.FoQ;
var ewResize = Css_Legacy_Core_bs/* ewResize */.eUF;
var nsResize = Css_Legacy_Core_bs/* nsResize */.Wct;
var neswResize = Css_Legacy_Core_bs/* neswResize */.IQh;
var nwseResize = Css_Legacy_Core_bs/* nwseResize */.xW;
var zoomIn = Css_Legacy_Core_bs/* zoomIn */.krI;
var zoomOut = Css_Legacy_Core_bs/* zoomOut */.vGG;
var flex3 = Css_Legacy_Core_bs/* flex3 */.L9u;
var border = Css_Legacy_Core_bs/* border */.CgR;
var borderTop = Css_Legacy_Core_bs/* borderTop */.j1L;
var backgroundSize = Css_Legacy_Core_bs/* backgroundSize */.G4q;
var textDecoration = Css_Legacy_Core_bs/* textDecoration */.QXS;
var background = Css_Legacy_Core_bs/* background */.Oq0;
var backgrounds = Css_Legacy_Core_bs/* backgrounds */.Fud;
var gridAutoColumns = Css_Legacy_Core_bs/* gridAutoColumns */.aNt;
var gridAutoRows = Css_Legacy_Core_bs/* gridAutoRows */.FWK;
var gridTemplateColumns = Css_Legacy_Core_bs/* gridTemplateColumns */.K$K;
var gridTemplateRows = Css_Legacy_Core_bs/* gridTemplateRows */.RGf;
var Calc = Css_Legacy_Core_bs/* Calc */.zyf;
var size = Css_Legacy_Core_bs/* size */.dpJ;
var filter = Css_Legacy_Core_bs/* filter */.hXT;
var Transition = Css_Legacy_Core_bs/* Transition */.uTP;
var transitionValue = Css_Legacy_Core_bs/* transitionValue */.O3F;
var transitionList = Css_Legacy_Core_bs/* transitionList */.RgW;
var transition = Css_Legacy_Core_bs/* transition */.eRy;
var transitions = Css_Legacy_Core_bs/* transitions */.pBE;
var Animation = Css_Legacy_Core_bs/* Animation */.fwF;
var animationValue = Css_Legacy_Core_bs/* animationValue */.FLd;
var animation = Css_Legacy_Core_bs/* animation */.oQ4;
var animations = Css_Legacy_Core_bs/* animations */.sFT;
var animationName = Css_Legacy_Core_bs/* animationName */.w30;
var SVG = Css_Legacy_Core_bs/* SVG */.Wj1;
var touchAction = Css_Legacy_Core_bs/* touchAction */.JQf;
var aliceblue = Css_Colors_bs/* aliceblue */.$T;
var antiquewhite = Css_Colors_bs/* antiquewhite */.gu;
var aqua = Css_Colors_bs/* aqua */.tb;
var aquamarine = Css_Colors_bs/* aquamarine */.Cn;
var azure = Css_Colors_bs/* azure */.Yd;
var beige = Css_Colors_bs/* beige */.e9;
var bisque = Css_Colors_bs/* bisque */.kh;
var black = Css_Colors_bs/* black */.Sn;
var blanchedalmond = Css_Colors_bs/* blanchedalmond */.Kx;
var blue = Css_Colors_bs/* blue */.iN;
var blueviolet = Css_Colors_bs/* blueviolet */.me;
var brown = Css_Colors_bs/* brown */.P_;
var burlywood = Css_Colors_bs/* burlywood */.I6;
var cadetblue = Css_Colors_bs/* cadetblue */.nN;
var chartreuse = Css_Colors_bs/* chartreuse */.mH;
var chocolate = Css_Colors_bs/* chocolate */.JU;
var coral = Css_Colors_bs/* coral */.ou;
var cornflowerblue = Css_Colors_bs/* cornflowerblue */.yi;
var cornsilk = Css_Colors_bs/* cornsilk */.$s;
var crimson = Css_Colors_bs/* crimson */.Wl;
var cyan = Css_Colors_bs/* cyan */.sl;
var darkblue = Css_Colors_bs/* darkblue */.dR;
var darkcyan = Css_Colors_bs/* darkcyan */.eb;
var darkgoldenrod = Css_Colors_bs/* darkgoldenrod */.zO;
var darkgray = Css_Colors_bs/* darkgray */.eo;
var darkgreen = Css_Colors_bs/* darkgreen */.L9;
var darkgrey = Css_Colors_bs/* darkgrey */.PA;
var darkkhaki = Css_Colors_bs/* darkkhaki */.yu;
var darkmagenta = Css_Colors_bs/* darkmagenta */.dS;
var darkolivegreen = Css_Colors_bs/* darkolivegreen */.ez;
var darkorange = Css_Colors_bs/* darkorange */.Rd;
var darkorchid = Css_Colors_bs/* darkorchid */.nh;
var darkred = Css_Colors_bs/* darkred */.Ec;
var darksalmon = Css_Colors_bs/* darksalmon */.xC;
var darkseagreen = Css_Colors_bs/* darkseagreen */.G4;
var darkslateblue = Css_Colors_bs/* darkslateblue */.GO;
var darkslategray = Css_Colors_bs/* darkslategray */.cz;
var darkslategrey = Css_Colors_bs/* darkslategrey */.KD;
var darkturquoise = Css_Colors_bs/* darkturquoise */.Tj;
var darkviolet = Css_Colors_bs/* darkviolet */.UP;
var deeppink = Css_Colors_bs/* deeppink */.FG;
var deepskyblue = Css_Colors_bs/* deepskyblue */.fK;
var dimgray = Css_Colors_bs/* dimgray */.OQ;
var dimgrey = Css_Colors_bs/* dimgrey */.yS;
var dodgerblue = Css_Colors_bs/* dodgerblue */.H9;
var firebrick = Css_Colors_bs/* firebrick */.IU;
var floralwhite = Css_Colors_bs/* floralwhite */.s9;
var forestgreen = Css_Colors_bs/* forestgreen */.ob;
var fuchsia = Css_Colors_bs/* fuchsia */.zf;
var gainsboro = Css_Colors_bs/* gainsboro */.c7;
var ghostwhite = Css_Colors_bs/* ghostwhite */.my;
var gold = Css_Colors_bs/* gold */.EV;
var goldenrod = Css_Colors_bs/* goldenrod */.Al;
var gray = Css_Colors_bs/* gray */.MA;
var green = Css_Colors_bs/* green */.ek;
var greenyellow = Css_Colors_bs/* greenyellow */.ff;
var grey = Css_Colors_bs/* grey */.BA;
var honeydew = Css_Colors_bs/* honeydew */.Ax;
var hotpink = Css_Colors_bs/* hotpink */.ng;
var indianred = Css_Colors_bs/* indianred */.IP;
var indigo = Css_Colors_bs/* indigo */.QN;
var ivory = Css_Colors_bs/* ivory */.h$;
var khaki = Css_Colors_bs/* khaki */.IK;
var lavender = Css_Colors_bs/* lavender */.N0;
var lavenderblush = Css_Colors_bs/* lavenderblush */.jR;
var lawngreen = Css_Colors_bs/* lawngreen */.ev;
var lemonchiffon = Css_Colors_bs/* lemonchiffon */.Kf;
var lightblue = Css_Colors_bs/* lightblue */.XW;
var lightcoral = Css_Colors_bs/* lightcoral */.qv;
var lightcyan = Css_Colors_bs/* lightcyan */.tO;
var lightgoldenrodyellow = Css_Colors_bs/* lightgoldenrodyellow */.dw;
var lightgray = Css_Colors_bs/* lightgray */.UQ;
var lightgreen = Css_Colors_bs/* lightgreen */.Hj;
var lightgrey = Css_Colors_bs/* lightgrey */.hC;
var lightpink = Css_Colors_bs/* lightpink */.ci;
var lightsalmon = Css_Colors_bs/* lightsalmon */.lY;
var lightseagreen = Css_Colors_bs/* lightseagreen */.mf;
var lightskyblue = Css_Colors_bs/* lightskyblue */.up;
var lightslategray = Css_Colors_bs/* lightslategray */.GV;
var lightslategrey = Css_Colors_bs/* lightslategrey */.As;
var lightsteelblue = Css_Colors_bs/* lightsteelblue */.z1;
var lightyellow = Css_Colors_bs/* lightyellow */.s$;
var lime = Css_Colors_bs/* lime */.LR;
var limegreen = Css_Colors_bs/* limegreen */.bV;
var linen = Css_Colors_bs/* linen */.nu;
var magenta = Css_Colors_bs/* magenta */.Ce;
var maroon = Css_Colors_bs/* maroon */.dm;
var mediumaquamarine = Css_Colors_bs/* mediumaquamarine */.vN;
var mediumblue = Css_Colors_bs/* mediumblue */.Bg;
var mediumorchid = Css_Colors_bs/* mediumorchid */.AV;
var mediumpurple = Css_Colors_bs/* mediumpurple */.og;
var mediumseagreen = Css_Colors_bs/* mediumseagreen */.YL;
var mediumslateblue = Css_Colors_bs/* mediumslateblue */.sf;
var mediumspringgreen = Css_Colors_bs/* mediumspringgreen */.Vl;
var mediumturquoise = Css_Colors_bs/* mediumturquoise */.Su;
var mediumvioletred = Css_Colors_bs/* mediumvioletred */.zR;
var midnightblue = Css_Colors_bs/* midnightblue */.rD;
var mintcream = Css_Colors_bs/* mintcream */.Rh;
var mistyrose = Css_Colors_bs/* mistyrose */.RT;
var moccasin = Css_Colors_bs/* moccasin */.Xw;
var navajowhite = Css_Colors_bs/* navajowhite */.Ii;
var navy = Css_Colors_bs/* navy */.Ih;
var oldlace = Css_Colors_bs/* oldlace */.WV;
var olive = Css_Colors_bs/* olive */.qZ;
var olivedrab = Css_Colors_bs/* olivedrab */.EQ;
var orange = Css_Colors_bs/* orange */.$y;
var orangered = Css_Colors_bs/* orangered */.ve;
var orchid = Css_Colors_bs/* orchid */.XV;
var palegoldenrod = Css_Colors_bs/* palegoldenrod */.mL;
var palegreen = Css_Colors_bs/* palegreen */.Jm;
var paleturquoise = Css_Colors_bs/* paleturquoise */.UM;
var palevioletred = Css_Colors_bs/* palevioletred */.ZP;
var papayawhip = Css_Colors_bs/* papayawhip */.tt;
var peachpuff = Css_Colors_bs/* peachpuff */.Kz;
var peru = Css_Colors_bs/* peru */.zh;
var pink = Css_Colors_bs/* pink */.iQ;
var plum = Css_Colors_bs/* plum */.vd;
var powderblue = Css_Colors_bs/* powderblue */.Fe;
var purple = Css_Colors_bs/* purple */.jk;
var rebeccapurple = Css_Colors_bs/* rebeccapurple */.My;
var red = Css_Colors_bs/* red */.Q6;
var rosybrown = Css_Colors_bs/* rosybrown */.wO;
var royalblue = Css_Colors_bs/* royalblue */.WI;
var saddlebrown = Css_Colors_bs/* saddlebrown */.sN;
var salmon = Css_Colors_bs/* salmon */.kr;
var sandybrown = Css_Colors_bs/* sandybrown */.qb;
var seagreen = Css_Colors_bs/* seagreen */.hR;
var seashell = Css_Colors_bs/* seashell */.qP;
var sienna = Css_Colors_bs/* sienna */.UR;
var silver = Css_Colors_bs/* silver */.l_;
var skyblue = Css_Colors_bs/* skyblue */.OD;
var slateblue = Css_Colors_bs/* slateblue */.Xb;
var slategray = Css_Colors_bs/* slategray */.aL;
var slategrey = Css_Colors_bs/* slategrey */.P2;
var snow = Css_Colors_bs/* snow */.Xr;
var springgreen = Css_Colors_bs/* springgreen */.oe;
var steelblue = Css_Colors_bs/* steelblue */.YP;
var tan = Css_Colors_bs/* tan */.OR;
var teal = Css_Colors_bs/* teal */.$C;
var thistle = Css_Colors_bs/* thistle */.X0;
var tomato = Css_Colors_bs/* tomato */.$p;
var turquoise = Css_Colors_bs/* turquoise */.Mk;
var violet = Css_Colors_bs/* violet */.ht;
var wheat = Css_Colors_bs/* wheat */.tm;
var white = Css_Colors_bs/* white */.ix;
var whitesmoke = Css_Colors_bs/* whitesmoke */.OW;
var yellow = Css_Colors_bs/* yellow */.er;
var yellowgreen = Css_Colors_bs/* yellowgreen */.TY;
var transparent = Css_Colors_bs/* transparent */.Zn;
var renderRule = include.renderRule;
var $$global = include.$$global;
var renderGlobal = include.renderGlobal;
var style = include.style;
var Css_bs_merge = include.merge;
var merge2 = include.merge2;
var merge3 = include.merge3;
var merge4 = include.merge4;
var Css_bs_keyframes = include.keyframes;
var renderKeyframes$1 = include.renderKeyframes;
 /* include Not a pure module */ 


/***/ }),

/***/ 48891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$7": function() { return /* binding */ GridTemplateAreas; },
/* harmony export */   "$t": function() { return /* binding */ Percentage; },
/* harmony export */   "AG": function() { return /* binding */ MaskPosition; },
/* harmony export */   "AT": function() { return /* binding */ Counter; },
/* harmony export */   "BF": function() { return /* binding */ TextDecorationLine; },
/* harmony export */   "CB": function() { return /* binding */ OverscrollBehavior; },
/* harmony export */   "CF": function() { return /* binding */ Cursor; },
/* harmony export */   "EE": function() { return /* binding */ Visibility; },
/* harmony export */   "En": function() { return /* binding */ MaxHeight; },
/* harmony export */   "Ex": function() { return /* binding */ ColumnCount; },
/* harmony export */   "F": function() { return /* binding */ PositionalAlignment; },
/* harmony export */   "GY": function() { return /* binding */ NormalAlignment; },
/* harmony export */   "Gy": function() { return /* binding */ Length; },
/* harmony export */   "H3": function() { return /* binding */ DistributedAlignment; },
/* harmony export */   "HD": function() { return /* binding */ DisplayBox; },
/* harmony export */   "HS": function() { return /* binding */ FontVariant; },
/* harmony export */   "Hd": function() { return /* binding */ FontStyle; },
/* harmony export */   "I5": function() { return /* binding */ WordBreak; },
/* harmony export */   "IN": function() { return /* binding */ ClipPath; },
/* harmony export */   "Il": function() { return /* binding */ Color; },
/* harmony export */   "JT": function() { return /* binding */ ScrollBehavior; },
/* harmony export */   "L3": function() { return /* binding */ LineHeight; },
/* harmony export */   "LE": function() { return /* binding */ ListStyleType; },
/* harmony export */   "LG": function() { return /* binding */ BoxSizing; },
/* harmony export */   "LK": function() { return /* binding */ LetterSpacing; },
/* harmony export */   "Lo": function() { return /* binding */ AnimationPlayState; },
/* harmony export */   "Lu": function() { return /* binding */ Width; },
/* harmony export */   "Ly": function() { return /* binding */ Position; },
/* harmony export */   "MT": function() { return /* binding */ AlignSelf; },
/* harmony export */   "Ms": function() { return /* binding */ TimingFunction; },
/* harmony export */   "N4": function() { return /* binding */ BorderStyle; },
/* harmony export */   "NB": function() { return /* binding */ FontFamilyName; },
/* harmony export */   "NP": function() { return /* binding */ ListStyleImage; },
/* harmony export */   "Nl": function() { return /* binding */ TouchAction; },
/* harmony export */   "Nm": function() { return /* binding */ Direction; },
/* harmony export */   "O$": function() { return /* binding */ MinWidth; },
/* harmony export */   "Ox": function() { return /* binding */ PointerEvents; },
/* harmony export */   "PH": function() { return /* binding */ TextAlign; },
/* harmony export */   "Pm": function() { return /* binding */ MaxWidth; },
/* harmony export */   "Qb": function() { return /* binding */ FlexDirection; },
/* harmony export */   "R9": function() { return /* binding */ Url; },
/* harmony export */   "RZ": function() { return /* binding */ Angle; },
/* harmony export */   "Sb": function() { return /* binding */ FlexBasis; },
/* harmony export */   "TA": function() { return /* binding */ MaskImage; },
/* harmony export */   "U9": function() { return /* binding */ FontWeight; },
/* harmony export */   "UM": function() { return /* binding */ Isolation; },
/* harmony export */   "UZ": function() { return /* binding */ Clear; },
/* harmony export */   "V4": function() { return /* binding */ Float; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W5": function() { return /* binding */ BackgroundRepeat; },
/* harmony export */   "WJ": function() { return /* binding */ CounterSet; },
/* harmony export */   "Wj": function() { return /* binding */ SVG; },
/* harmony export */   "X4": function() { return /* binding */ TextDecorationStyle; },
/* harmony export */   "XS": function() { return /* binding */ Perspective; },
/* harmony export */   "Xd": function() { return /* binding */ BackgroundImage; },
/* harmony export */   "YO": function() { return /* binding */ BackfaceVisibility; },
/* harmony export */   "Zt": function() { return /* binding */ Margin; },
/* harmony export */   "Zv": function() { return /* binding */ Gap; },
/* harmony export */   "_5": function() { return /* binding */ OutlineStyle; },
/* harmony export */   "_S": function() { return /* binding */ BackgroundPosition; },
/* harmony export */   "aB": function() { return /* binding */ ColumnWidth; },
/* harmony export */   "au": function() { return /* binding */ DisplayInside; },
/* harmony export */   "b4": function() { return /* binding */ BaselineAlignment; },
/* harmony export */   "bv": function() { return /* binding */ DisplayOutside; },
/* harmony export */   "cA": function() { return /* binding */ DisplayListItem; },
/* harmony export */   "dU": function() { return /* binding */ RepeatValue; },
/* harmony export */   "df": function() { return /* binding */ TableLayout; },
/* harmony export */   "fS": function() { return /* binding */ CounterIncrement; },
/* harmony export */   "fd": function() { return /* binding */ CounterReset; },
/* harmony export */   "g$": function() { return /* binding */ VerticalAlign; },
/* harmony export */   "g1": function() { return /* binding */ AlignItems; },
/* harmony export */   "gC": function() { return /* binding */ GridAutoFlow; },
/* harmony export */   "gP": function() { return /* binding */ FlexWrap; },
/* harmony export */   "gg": function() { return /* binding */ LegacyAlignment; },
/* harmony export */   "gt": function() { return /* binding */ BackgroundAttachment; },
/* harmony export */   "h$": function() { return /* binding */ ObjectFit; },
/* harmony export */   "k7": function() { return /* binding */ BorderCollapse; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l5": function() { return /* binding */ BackdropFilter; },
/* harmony export */   "lG": function() { return /* binding */ TextOverflow; },
/* harmony export */   "lf": function() { return /* binding */ GeometryBox; },
/* harmony export */   "lo": function() { return /* binding */ JustifySelf; },
/* harmony export */   "mn": function() { return /* binding */ OverflowWrap; },
/* harmony export */   "nP": function() { return /* binding */ Overflow; },
/* harmony export */   "nZ": function() { return /* binding */ WhiteSpace; },
/* harmony export */   "nd": function() { return /* binding */ Var; },
/* harmony export */   "oF": function() { return /* binding */ UserSelect; },
/* harmony export */   "oU": function() { return /* binding */ Height; },
/* harmony export */   "ph": function() { return /* binding */ Gradient; },
/* harmony export */   "qX": function() { return /* binding */ AnimationIterationCount; },
/* harmony export */   "qb": function() { return /* binding */ WordSpacing; },
/* harmony export */   "rL": function() { return /* binding */ OverflowAlignment; },
/* harmony export */   "rY": function() { return /* binding */ DisplayInternal; },
/* harmony export */   "s2": function() { return /* binding */ OverflowAnchor; },
/* harmony export */   "sc": function() { return /* binding */ AnimationDirection; },
/* harmony export */   "t": function() { return /* binding */ ListStylePosition; },
/* harmony export */   "t$": function() { return /* binding */ Resize; },
/* harmony export */   "tk": function() { return /* binding */ AlignContent; },
/* harmony export */   "ty": function() { return /* binding */ TextTransform; },
/* harmony export */   "v7": function() { return /* binding */ DisplayLegacy; },
/* harmony export */   "vC": function() { return /* binding */ CaretColor; },
/* harmony export */   "wJ": function() { return /* binding */ TransformStyle; },
/* harmony export */   "wx": function() { return /* binding */ Transform; },
/* harmony export */   "x6": function() { return /* binding */ BackgroundClip; },
/* harmony export */   "x9": function() { return /* binding */ Cascading; },
/* harmony export */   "xv": function() { return /* binding */ Counters; },
/* harmony export */   "y5": function() { return /* binding */ GridArea; },
/* harmony export */   "yW": function() { return /* binding */ BackgroundOrigin; },
/* harmony export */   "yy": function() { return /* binding */ AnimationFillMode; },
/* harmony export */   "z6": function() { return /* binding */ MinHeight; }
/* harmony export */ });
/* unused harmony exports Time, RowGap, ColumnGap, TextDecorationThickness, TransformBox, FontDisplay, CounterStyleType */
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37712);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96533);
// Generated by ReScript, PLEASE EDIT WITH CARE



function toString(x) {
    if (x === "inherit_") {
        return "inherit";
    } else if (x === "unset") {
        return "unset";
    } else {
        return "initial";
    }
}
var Cascading = {
    initial: "initial",
    inherit_: "inherit_",
    unset: "unset",
    toString: toString
};
function $$var(x) {
    return {
        NAME: "var",
        VAL: x
    };
}
function varDefault(x, $$default) {
    return {
        NAME: "varDefault",
        VAL: [
            x,
            $$default
        ]
    };
}
function prefix(x) {
    if (_rescript_std_lib_es6_js_string_js__WEBPACK_IMPORTED_MODULE_1__/* .startsWith */ .Ny("--", x)) {
        return x;
    } else {
        return "--" + x;
    }
}
function toString$1(x) {
    if (x.NAME === "var") {
        return "var(" + prefix(x.VAL) + ")";
    }
    var match = x.VAL;
    return "var(" + prefix(match[0]) + "," + match[1] + ")";
}
function s(x) {
    return {
        NAME: "s",
        VAL: x
    };
}
function ms(x) {
    return {
        NAME: "ms",
        VAL: x
    };
}
function toString$2(x) {
    if (x.NAME === "ms") {
        return x.VAL.toString() + "ms";
    } else {
        return x.VAL.toString() + "s";
    }
}
var Time = {
    s: s,
    ms: ms,
    toString: toString$2
};
function pct(x) {
    return {
        NAME: "percent",
        VAL: x
    };
}
function toString$3(x) {
    return x.VAL.toString() + "%";
}
var Percentage = {
    pct: pct,
    toString: toString$3
};
function toString$4(x) {
    return "url(" + x.VAL + ")";
}
var Url = {
    toString: toString$4
};
function ch(x) {
    return {
        NAME: "ch",
        VAL: x
    };
}
function em(x) {
    return {
        NAME: "em",
        VAL: x
    };
}
function ex(x) {
    return {
        NAME: "ex",
        VAL: x
    };
}
function rem(x) {
    return {
        NAME: "rem",
        VAL: x
    };
}
function vh(x) {
    return {
        NAME: "vh",
        VAL: x
    };
}
function vw(x) {
    return {
        NAME: "vw",
        VAL: x
    };
}
function vmin(x) {
    return {
        NAME: "vmin",
        VAL: x
    };
}
function vmax(x) {
    return {
        NAME: "vmax",
        VAL: x
    };
}
function px(x) {
    return {
        NAME: "px",
        VAL: x
    };
}
function pxFloat(x) {
    return {
        NAME: "pxFloat",
        VAL: x
    };
}
function cm(x) {
    return {
        NAME: "cm",
        VAL: x
    };
}
function mm(x) {
    return {
        NAME: "mm",
        VAL: x
    };
}
function inch(x) {
    return {
        NAME: "inch",
        VAL: x
    };
}
function pc(x) {
    return {
        NAME: "pc",
        VAL: x
    };
}
function pt(x) {
    return {
        NAME: "pt",
        VAL: x
    };
}
function toString$5(x) {
    if (typeof x !== "object") {
        return "0";
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    var match = x.VAL;
    var match$1 = match[0];
    if (match$1 === "add") {
        return "calc(" + toString$5(match[1]) + " + " + toString$5(match[2]) + ")";
    } else if (match$1 === "sub") {
        return "calc(" + toString$5(match[1]) + " - " + toString$5(match[2]) + ")";
    } else {
        return "calc(" + toString$5(match[1]) + " * " + toString$5(match[2]) + ")";
    }
}
var Length = {
    ch: ch,
    em: em,
    ex: ex,
    rem: rem,
    vh: vh,
    vw: vw,
    vmin: vmin,
    vmax: vmax,
    px: px,
    pxFloat: pxFloat,
    cm: cm,
    mm: mm,
    inch: inch,
    pc: pc,
    pt: pt,
    zero: "zero",
    toString: toString$5
};
function deg(x) {
    return {
        NAME: "deg",
        VAL: x
    };
}
function rad(x) {
    return {
        NAME: "rad",
        VAL: x
    };
}
function grad(x) {
    return {
        NAME: "grad",
        VAL: x
    };
}
function turn(x) {
    return {
        NAME: "turn",
        VAL: x
    };
}
function toString$6(x) {
    var variant = x.NAME;
    if (variant === "turn") {
        return x.VAL.toString() + "turn";
    } else if (variant === "deg") {
        return x.VAL.toString() + "deg";
    } else if (variant === "rad") {
        return x.VAL.toString() + "rad";
    } else {
        return x.VAL.toString() + "grad";
    }
}
var Angle = {
    deg: deg,
    rad: rad,
    grad: grad,
    turn: turn,
    toString: toString$6
};
function toString$7(x) {
    if (x === "rtl") {
        return "rtl";
    } else {
        return "ltr";
    }
}
var Direction = {
    ltr: "ltr",
    rtl: "rtl",
    toString: toString$7
};
function toString$8(x) {
    if (x === "fixed") {
        return "fixed";
    } else if (x === "static") {
        return "static";
    } else if (x === "sticky") {
        return "sticky";
    } else if (x === "relative") {
        return "relative";
    } else {
        return "absolute";
    }
}
var Position = {
    absolute: "absolute",
    relative: "relative",
    $$static: "static",
    fixed: "fixed",
    sticky: "sticky",
    toString: toString$8
};
function toString$9(x) {
    if (x === "isolate") {
        return "isolate";
    } else {
        return "auto";
    }
}
var Isolation = {
    toString: toString$9
};
function toString$10(x) {
    if (x === "none") {
        return "none";
    } else if (x === "vertical") {
        return "vertical";
    } else if (x === "horizontal") {
        return "horizontal";
    } else if (x === "inline") {
        return "inline";
    } else if (x === "block") {
        return "block";
    } else {
        return "both";
    }
}
var Resize = {
    none: "none",
    both: "both",
    horizontal: "horizontal",
    vertical: "vertical",
    block: "block",
    inline: "inline",
    toString: toString$10
};
function toString$11(x) {
    if (x === "normal") {
        return "normal";
    } else {
        return "smallCaps";
    }
}
var FontVariant = {
    normal: "normal",
    smallCaps: "smallCaps",
    toString: toString$11
};
function toString$12(x) {
    if (x === "oblique") {
        return "oblique";
    } else if (x === "normal") {
        return "normal";
    } else {
        return "italic";
    }
}
var FontStyle = {
    normal: "normal",
    italic: "italic",
    oblique: "oblique",
    toString: toString$12
};
function toString$13(x) {
    if (x === "fill") {
        return "fill";
    } else if (x === "minContent") {
        return "min-content";
    } else if (x === "fitContent") {
        return "fit-content";
    } else if (x === "maxContent") {
        return "max-content";
    } else if (x === "content") {
        return "content";
    } else {
        return "auto";
    }
}
var FlexBasis = {
    fill: "fill",
    content: "content",
    maxContent: "maxContent",
    minContent: "minContent",
    fitContent: "fitContent",
    toString: toString$13
};
function toString$14(x) {
    if (x === "clip") {
        return "clip";
    } else if (x === "scroll") {
        return "scroll";
    } else if (x === "hidden") {
        return "hidden";
    } else if (x === "visible") {
        return "visible";
    } else {
        return "auto";
    }
}
var Overflow = {
    hidden: "hidden",
    visible: "visible",
    scroll: "scroll",
    auto: "auto",
    clip: "clip",
    toString: toString$14
};
function toString$15(x) {
    return "auto";
}
var Margin = {
    auto: "auto",
    toString: toString$15
};
function toString$16(x) {
    if (x === "columnDense") {
        return "column dense";
    } else if (x === "rowDense") {
        return "row dense";
    } else if (x === "row") {
        return "row";
    } else {
        return "column";
    }
}
var GridAutoFlow = {
    toString: toString$16
};
function toString$17(x) {
    return "normal";
}
var Gap = {
    toString: toString$17
};
function toString$18(x) {
    if (x === "smooth") {
        return "smooth";
    } else {
        return "auto";
    }
}
var ScrollBehavior = {
    toString: toString$18
};
function toString$19(x) {
    if (x === "none") {
        return "none";
    } else if (x === "contain") {
        return "contain";
    } else {
        return "auto";
    }
}
var OverscrollBehavior = {
    toString: toString$19
};
function toString$20(x) {
    if (x === "none") {
        return "none";
    } else {
        return "auto";
    }
}
var OverflowAnchor = {
    toString: toString$20
};
function toString$21(x) {
    return "auto";
}
var ColumnWidth = {
    toString: toString$21
};
function toString$22(x) {
    return "auto";
}
var CaretColor = {
    toString: toString$22
};
function toString$23(x) {
    if (x === "bottom") {
        return "bottom";
    } else if (x === "sub") {
        return "sub";
    } else if (x === "top") {
        return "top";
    } else if (x === "super") {
        return "super";
    } else if (x === "baseline") {
        return "baseline";
    } else if (x === "textBottom") {
        return "text-bottom";
    } else if (x === "textTop") {
        return "text-top";
    } else {
        return "middle";
    }
}
var VerticalAlign = {
    toString: toString$23
};
function steps(i, dir) {
    return {
        NAME: "steps",
        VAL: [
            i,
            dir
        ]
    };
}
function cubicBezier(a, b, c, d) {
    return {
        NAME: "cubicBezier",
        VAL: [
            a,
            b,
            c,
            d
        ]
    };
}
function toString$24(x) {
    if (typeof x !== "object") {
        if (x === "easeInOut") {
            return "ease-in-out";
        } else if (x === "linear") {
            return "linear";
        } else if (x === "jumpBoth") {
            return "jump-both";
        } else if (x === "stepStart") {
            return "step-start";
        } else if (x === "jumpNone") {
            return "jump-none";
        } else if (x === "stepEnd") {
            return "step-end";
        } else if (x === "easeIn") {
            return "ease-in";
        } else if (x === "jumpEnd") {
            return "jump-end";
        } else if (x === "jumpStart") {
            return "jump-start";
        } else if (x === "easeOut") {
            return "ease-out";
        } else {
            return "ease";
        }
    }
    if (x.NAME === "steps") {
        var match = x.VAL;
        var i = match[0];
        if (match[1] === "start") {
            return "steps(" + i.toString() + ", start)";
        } else {
            return "steps(" + i.toString() + ", end)";
        }
    }
    var match$1 = x.VAL;
    return "cubic-bezier(" + match$1[0].toString() + ", " + match$1[1].toString() + ", " + match$1[2].toString() + ", " + match$1[3].toString() + ")";
}
function toString$25(x) {
    if (typeof x === "object") {
        return x.VAL.toString();
    } else if (x === "autoFill") {
        return "auto-fill";
    } else {
        return "auto-fit";
    }
}
var RepeatValue = {
    toString: toString$25
};
function toString$26(x) {
    if (x === "none") {
        return "none";
    } else if (x === "circle") {
        return "circle";
    } else if (x === "lowerGreek") {
        return "lower-greek";
    } else if (x === "square") {
        return "square";
    } else if (x === "lowerAlpha") {
        return "lower-alpha";
    } else if (x === "upperAlpha") {
        return "upper-alpha";
    } else if (x === "decimal") {
        return "decimal";
    } else if (x === "lowerRoman") {
        return "lower-roman";
    } else if (x === "lowerLatin") {
        return "lower-latin";
    } else if (x === "upperRoman") {
        return "upper-roman";
    } else if (x === "upperLatin") {
        return "upper-latin";
    } else {
        return "disc";
    }
}
var ListStyleType = {
    toString: toString$26
};
function toString$27(x) {
    if (x === "inside") {
        return "inside";
    } else {
        return "outside";
    }
}
var ListStylePosition = {
    toString: toString$27
};
function toString$28(x) {
    if (x === "hidden") {
        return "hidden";
    } else if (x === "ridge") {
        return "ridge";
    } else if (x === "solid") {
        return "solid";
    } else if (x === "outset") {
        return "outset";
    } else if (x === "groove") {
        return "grove";
    } else if (x === "dashed") {
        return "dashed";
    } else if (x === "dotted") {
        return "dotted";
    } else if (x === "double") {
        return "double";
    } else if (x === "inset") {
        return "inset";
    } else {
        return "none";
    }
}
var OutlineStyle = {
    toString: toString$28
};
function toString$29(x) {
    if (typeof x === "object") {
        return x.VAL.toString();
    } else if (x === "thin") {
        return "100";
    } else if (x === "semiBold") {
        return "600";
    } else if (x === "bolder") {
        return "bolder";
    } else if (x === "light") {
        return "300";
    } else if (x === "extraBold") {
        return "800";
    } else if (x === "extraLight") {
        return "200";
    } else if (x === "medium") {
        return "500";
    } else if (x === "lighter") {
        return "lighter";
    } else if (x === "normal") {
        return "400";
    } else if (x === "black") {
        return "900";
    } else {
        return "700";
    }
}
var FontWeight = {
    thin: "thin",
    extraLight: "extraLight",
    light: "light",
    medium: "medium",
    semiBold: "semiBold",
    bold: "bold",
    extraBold: "extraBold",
    lighter: "lighter",
    bolder: "bolder",
    toString: toString$29
};
function translate(x, y) {
    return {
        NAME: "translate",
        VAL: [
            x,
            y
        ]
    };
}
function translate3d(x, y, z) {
    return {
        NAME: "translate3d",
        VAL: [
            x,
            y,
            z
        ]
    };
}
function translateX(x) {
    return {
        NAME: "translateX",
        VAL: x
    };
}
function translateY(y) {
    return {
        NAME: "translateY",
        VAL: y
    };
}
function translateZ(z) {
    return {
        NAME: "translateZ",
        VAL: z
    };
}
function scale(x, y) {
    return {
        NAME: "scale",
        VAL: [
            x,
            y
        ]
    };
}
function scale3d(x, y, z) {
    return {
        NAME: "scale3d",
        VAL: [
            x,
            y,
            z
        ]
    };
}
function scaleX(x) {
    return {
        NAME: "scaleX",
        VAL: x
    };
}
function scaleY(x) {
    return {
        NAME: "scaleY",
        VAL: x
    };
}
function scaleZ(x) {
    return {
        NAME: "scaleZ",
        VAL: x
    };
}
function rotate(a) {
    return {
        NAME: "rotate",
        VAL: a
    };
}
function rotate3d(x, y, z, a) {
    return {
        NAME: "rotate3d",
        VAL: [
            x,
            y,
            z,
            a
        ]
    };
}
function rotateX(a) {
    return {
        NAME: "rotateX",
        VAL: a
    };
}
function rotateY(a) {
    return {
        NAME: "rotateY",
        VAL: a
    };
}
function rotateZ(a) {
    return {
        NAME: "rotateZ",
        VAL: a
    };
}
function skew(a, a$p) {
    return {
        NAME: "skew",
        VAL: [
            a,
            a$p
        ]
    };
}
function skewX(a) {
    return {
        NAME: "skewX",
        VAL: a
    };
}
function skewY(a) {
    return {
        NAME: "skewY",
        VAL: a
    };
}
function toString$30(x) {
    var variant = x.NAME;
    if (variant === "translate") {
        var match = x.VAL;
        return "translate(" + toString$5(match[0]) + ", " + toString$5(match[1]) + ")";
    }
    if (variant === "rotate") {
        return "rotate(" + toString$6(x.VAL) + ")";
    }
    if (variant === "skew") {
        var match$1 = x.VAL;
        return "skew(" + toString$6(match$1[0]) + ", " + toString$6(match$1[1]) + ")";
    }
    if (variant === "scale3d") {
        var match$2 = x.VAL;
        return "scale3d(" + match$2[0].toString() + ", " + match$2[1].toString() + ", " + match$2[2].toString() + ")";
    }
    if (variant === "rotateX") {
        return "rotateX(" + toString$6(x.VAL) + ")";
    }
    if (variant === "rotateY") {
        return "rotateY(" + toString$6(x.VAL) + ")";
    }
    if (variant === "rotateZ") {
        return "rotateZ(" + toString$6(x.VAL) + ")";
    }
    if (variant === "scale") {
        var match$3 = x.VAL;
        var x$1 = match$3[0];
        var y = match$3[1];
        return "scale(" + x$1.toString() + ", " + y.toString() + ")";
    }
    if (variant === "skewX") {
        return "skewX(" + toString$6(x.VAL) + ")";
    }
    if (variant === "skewY") {
        return "skewY(" + toString$6(x.VAL) + ")";
    }
    if (variant === "translateX") {
        return "translateX(" + toString$5(x.VAL) + ")";
    }
    if (variant === "translateY") {
        return "translateY(" + toString$5(x.VAL) + ")";
    }
    if (variant === "translateZ") {
        return "translateZ(" + toString$5(x.VAL) + ")";
    }
    if (variant === "rotate3d") {
        var match$4 = x.VAL;
        return "rotate3d(" + match$4[0].toString() + ", " + match$4[1].toString() + ", " + match$4[2].toString() + ", " + toString$6(match$4[3]) + ")";
    }
    if (variant !== "translate3d") {
        if (variant === "scaleX") {
            return "scaleX(" + x.VAL.toString() + ")";
        } else if (variant === "scaleY") {
            return "scaleY(" + x.VAL.toString() + ")";
        } else if (variant === "scaleZ") {
            return "scaleZ(" + x.VAL.toString() + ")";
        } else {
            return "perspective(" + x.VAL.toString() + ")";
        }
    }
    var match$5 = x.VAL;
    var x$2 = match$5[0];
    var y$1 = match$5[1];
    var z = match$5[2];
    return "translate3d(" + toString$5(x$2) + ", " + toString$5(y$1) + ", " + toString$5(z) + ")";
}
function toString$31(x) {
    if (x === "alternateReverse") {
        return "alternate-reverse";
    } else if (x === "normal") {
        return "normal";
    } else if (x === "alternate") {
        return "alternate";
    } else {
        return "reverse";
    }
}
var AnimationDirection = {
    toString: toString$31
};
function toString$32(x) {
    if (x === "none") {
        return "none";
    } else if (x === "backwards") {
        return "backwards";
    } else if (x === "forwards") {
        return "forwards";
    } else {
        return "both";
    }
}
var AnimationFillMode = {
    toString: toString$32
};
function toString$33(x) {
    if (typeof x === "object") {
        return x.VAL.toString();
    } else {
        return "infinite";
    }
}
var AnimationIterationCount = {
    toString: toString$33
};
function toString$34(x) {
    if (x === "paused") {
        return "paused";
    } else {
        return "running";
    }
}
var AnimationPlayState = {
    toString: toString$34
};
function toString$35(x) {
    if (x === "cell") {
        return "cell";
    } else if (x === "copy") {
        return "copy";
    } else if (x === "swResize") {
        return "sw-resize";
    } else if (x === "grab") {
        return "grab";
    } else if (x === "help") {
        return "help";
    } else if (x === "move") {
        return "move";
    } else if (x === "none") {
        return "none";
    } else if (x === "text") {
        return "text";
    } else if (x === "rowResize") {
        return "row-resize";
    } else if (x === "wait") {
        return "wait";
    } else if (x === "pointer") {
        return "pointer";
    } else if (x === "seResize") {
        return "se-resize";
    } else if (x === "zoomOut") {
        return "zoom-out";
    } else if (x === "sResize") {
        return "s-resize";
    } else if (x === "zoomIn") {
        return "zoom-in";
    } else if (x === "grabbing") {
        return "grabbing";
    } else if (x === "nsResize") {
        return "ns-resize";
    } else if (x === "nwseResize") {
        return "nwse-resize";
    } else if (x === "progress") {
        return "progress";
    } else if (x === "crosshair") {
        return "crosshair";
    } else if (x === "wResize") {
        return "w-resize";
    } else if (x === "noDrop") {
        return "no-drop";
    } else if (x === "allScroll") {
        return "all-scroll";
    } else if (x === "verticalText") {
        return "vertical-text";
    } else if (x === "nResize") {
        return "n-resize";
    } else if (x === "default") {
        return "default";
    } else if (x === "neswResize") {
        return "nesw-resize";
    } else if (x === "alias") {
        return "alias";
    } else if (x === "ewResize") {
        return "ew-resize";
    } else if (x === "eResize") {
        return "e-resize";
    } else if (x === "nwResize") {
        return "nw-resize";
    } else if (x === "contextMenu") {
        return "context-menu";
    } else if (x === "colResize") {
        return "col-resize";
    } else if (x === "notAllowed") {
        return "not-allowed";
    } else if (x === "neResize") {
        return "ne-resize";
    } else {
        return "auto";
    }
}
var Cursor = {
    auto: "auto",
    $$default: "default",
    none: "none",
    contextMenu: "contextMenu",
    help: "help",
    pointer: "pointer",
    progress: "progress",
    wait: "wait",
    cell: "cell",
    crosshair: "crosshair",
    text: "text",
    verticalText: "verticalText",
    alias: "alias",
    copy: "copy",
    move: "move",
    noDrop: "noDrop",
    notAllowed: "notAllowed",
    grab: "grab",
    grabbing: "grabbing",
    allScroll: "allScroll",
    colResize: "colResize",
    rowResize: "rowResize",
    nResize: "nResize",
    eResize: "eResize",
    sResize: "sResize",
    wResize: "wResize",
    neResize: "neResize",
    nwResize: "nwResize",
    seResize: "seResize",
    swResize: "swResize",
    ewResize: "ewResize",
    nsResize: "nsResize",
    neswResize: "neswResize",
    nwseResize: "nwseResize",
    zoomIn: "zoomIn",
    zoomOut: "zoomOut",
    toString: toString$35
};
function rgb(r, g, b) {
    return {
        NAME: "rgb",
        VAL: [
            r,
            g,
            b
        ]
    };
}
function rgba(r, g, b, a) {
    return {
        NAME: "rgba",
        VAL: [
            r,
            g,
            b,
            a
        ]
    };
}
function hsl(h, s, l) {
    return {
        NAME: "hsl",
        VAL: [
            h,
            s,
            l
        ]
    };
}
function hsla(h, s, l, a) {
    return {
        NAME: "hsla",
        VAL: [
            h,
            s,
            l,
            a
        ]
    };
}
function hex(x) {
    return {
        NAME: "hex",
        VAL: x
    };
}
function string_of_alpha(x) {
    if (x.NAME === "num") {
        return x.VAL.toString();
    } else {
        return toString$3(x);
    }
}
function toString$36(x) {
    if (typeof x !== "object") {
        if (x === "transparent") {
            return "transparent";
        } else {
            return "currentColor";
        }
    }
    var variant = x.NAME;
    if (variant === "rgba") {
        var match = x.VAL;
        return "rgba(" + match[0].toString() + ", " + match[1].toString() + ", " + match[2].toString() + ", " + string_of_alpha(match[3]) + ")";
    }
    if (variant === "hex") {
        return "#" + x.VAL;
    }
    if (variant === "hsl") {
        var match$1 = x.VAL;
        return "hsl(" + toString$6(match$1[0]) + ", " + toString$3(match$1[1]) + ", " + toString$3(match$1[2]) + ")";
    }
    if (variant === "rgb") {
        var match$2 = x.VAL;
        return "rgb(" + match$2[0].toString() + ", " + match$2[1].toString() + ", " + match$2[2].toString() + ")";
    }
    var match$3 = x.VAL;
    return "hsla(" + toString$6(match$3[0]) + ", " + toString$3(match$3[1]) + ", " + toString$3(match$3[2]) + ", " + string_of_alpha(match$3[3]) + ")";
}
function toString$37(x) {
    if (x === "hidden") {
        return "hidden";
    } else if (x === "ridge") {
        return "ridge";
    } else if (x === "solid") {
        return "solid";
    } else if (x === "outset") {
        return "outset";
    } else if (x === "groove") {
        return "groove";
    } else if (x === "dashed") {
        return "dashed";
    } else if (x === "dotted") {
        return "dotted";
    } else if (x === "double") {
        return "double";
    } else if (x === "inset") {
        return "inset";
    } else {
        return "none";
    }
}
var BorderStyle = {
    toString: toString$37
};
function toString$38(x) {
    if (x === "none") {
        return "none";
    } else {
        return "auto";
    }
}
var PointerEvents = {
    toString: toString$38
};
function toString$39(x) {
    return "none";
}
var Perspective = {
    toString: toString$39
};
function toString$40(x) {
    return "normal";
}
var LetterSpacing = {
    normal: "normal",
    toString: toString$40
};
function toString$41(x) {
    if (typeof x === "object") {
        return x.VAL.toString();
    } else {
        return "normal";
    }
}
var LineHeight = {
    toString: toString$41
};
function toString$42(x) {
    return "normal";
}
var WordSpacing = {
    toString: toString$42
};
function toString$43(x) {
    if (x === "inline") {
        return "inline";
    } else if (x === "block") {
        return "block";
    } else {
        return "run-in";
    }
}
var DisplayOutside = {
    toString: toString$43
};
function toString$44(x) {
    if (x === "grid") {
        return "grid";
    } else if (x === "table") {
        return "table";
    } else {
        return "flex";
    }
}
var DisplayInside = {
    toString: toString$44
};
function toString$45(x) {
    return "list-item";
}
var DisplayListItem = {
    toString: toString$45
};
function toString$46(x) {
    if (x === "tableRow") {
        return "table-row";
    } else if (x === "tableRowGroup") {
        return "table-row-group";
    } else if (x === "tableColumn") {
        return "table-column";
    } else if (x === "tableHeaderGroup") {
        return "table-header-group";
    } else if (x === "tableCell") {
        return "table-cell";
    } else if (x === "tableColumnGroup") {
        return "table-column-group";
    } else if (x === "tableCaption") {
        return "table-caption";
    } else {
        return "table-footer-group";
    }
}
var DisplayInternal = {
    toString: toString$46
};
function toString$47(x) {
    if (x === "contents") {
        return "contents";
    } else {
        return "none";
    }
}
var DisplayBox = {
    toString: toString$47
};
function toString$48(x) {
    if (x === "inlineBlock") {
        return "inline-block";
    } else if (x === "inlineFlex") {
        return "inline-flex";
    } else if (x === "inlineGrid") {
        return "inline-grid";
    } else {
        return "inline-table";
    }
}
var DisplayLegacy = {
    toString: toString$48
};
function toString$49(x) {
    if (x === "stretch") {
        return "stretch";
    } else if (x === "normal") {
        return "normal";
    } else {
        return "auto";
    }
}
var JustifySelf = {
    toString: toString$49
};
function toString$50(x) {
    if (x === "left") {
        return "left";
    } else if (x === "right") {
        return "right";
    } else if (x === "selfEnd") {
        return "self-end";
    } else if (x === "start") {
        return "start";
    } else if (x === "center") {
        return "center";
    } else if (x === "flexStart") {
        return "flex-start";
    } else if (x === "flexEnd") {
        return "flex-end";
    } else if (x === "selfStart") {
        return "self-start";
    } else {
        return "end";
    }
}
var PositionalAlignment = {
    toString: toString$50
};
function toString$51(x) {
    if (x.NAME === "unsafe") {
        return "unsafe " + toString$50(x.VAL);
    } else {
        return "safe " + toString$50(x.VAL);
    }
}
var OverflowAlignment = {
    toString: toString$51
};
function toString$52(x) {
    if (x === "firstBaseline") {
        return "first baseline";
    } else if (x === "baseline") {
        return "baseline";
    } else {
        return "last baseline";
    }
}
var BaselineAlignment = {
    toString: toString$52
};
function toString$53(x) {
    return "normal";
}
var NormalAlignment = {
    toString: toString$53
};
function toString$54(x) {
    if (x === "spaceAround") {
        return "space-around";
    } else if (x === "stretch") {
        return "stretch";
    } else if (x === "spaceBetween") {
        return "space-between";
    } else {
        return "space-evenly";
    }
}
var DistributedAlignment = {
    toString: toString$54
};
function toString$55(x) {
    if (x === "legacyLeft") {
        return "legacy left";
    } else if (x === "legacy") {
        return "legacy";
    } else if (x === "legacyRight") {
        return "legacy right";
    } else {
        return "legacy center";
    }
}
var LegacyAlignment = {
    toString: toString$55
};
function toString$56(x) {
    if (x === "right") {
        return "right";
    } else if (x === "justify") {
        return "justify";
    } else if (x === "start") {
        return "start";
    } else if (x === "center") {
        return "center";
    } else {
        return "left";
    }
}
var TextAlign = {
    toString: toString$56
};
function toString$57(x) {
    if (x === "normal") {
        return "normal";
    } else if (x === "keepAll") {
        return "keep-all";
    } else {
        return "break-all";
    }
}
var WordBreak = {
    toString: toString$57
};
function toString$58(x) {
    if (x === "preLine") {
        return "pre-line";
    } else if (x === "preWrap") {
        return "pre-wrap";
    } else if (x === "breakSpaces") {
        return "break-spaces";
    } else if (x === "normal") {
        return "normal";
    } else if (x === "nowrap") {
        return "nowrap";
    } else {
        return "pre";
    }
}
var WhiteSpace = {
    toString: toString$58
};
function toString$59(x) {
    if (x === "normal") {
        return "normal";
    } else {
        return "stretch";
    }
}
var AlignItems = {
    toString: toString$59
};
function toString$60(x) {
    if (x === "stretch") {
        return "stretch";
    } else if (x === "normal") {
        return "normal";
    } else {
        return "auto";
    }
}
var AlignSelf = {
    toString: toString$60
};
function toString$61(x) {
    if (x === "start") {
        return "start";
    } else if (x === "center") {
        return "center";
    } else if (x === "flexStart") {
        return "flex-start";
    } else if (x === "flexEnd") {
        return "flex-end";
    } else {
        return "end";
    }
}
var AlignContent = {
    toString: toString$61
};
function toString$62(x) {
    if (x === "none") {
        return "none";
    } else if (x === "cover") {
        return "cover";
    } else if (x === "contain") {
        return "contain";
    } else if (x === "scaleDown") {
        return "scale-down";
    } else {
        return "fill";
    }
}
var ObjectFit = {
    toString: toString$62
};
function toString$63(x) {
    if (x === "inlineStart") {
        return "inline-start";
    } else if (x === "left") {
        return "left";
    } else if (x === "none") {
        return "none";
    } else if (x === "right") {
        return "right";
    } else if (x === "inlineEnd") {
        return "inline-end";
    } else {
        return "both";
    }
}
var Clear = {
    toString: toString$63
};
function toString$64(x) {
    if (x === "left") {
        return "left";
    } else if (x === "none") {
        return "none";
    } else if (x === "right") {
        return "right";
    } else if (x === "inlineEnd") {
        return "inline-end";
    } else {
        return "inline-start";
    }
}
var Float = {
    toString: toString$64
};
function toString$65(x) {
    if (x === "hidden") {
        return "hidden";
    } else if (x === "visible") {
        return "visible";
    } else {
        return "collapse";
    }
}
var Visibility = {
    toString: toString$65
};
function toString$66(x) {
    if (x === "fixed") {
        return "fixed";
    } else {
        return "auto";
    }
}
var TableLayout = {
    toString: toString$66
};
function toString$67(x) {
    if (x === "separate") {
        return "separate";
    } else {
        return "collapse";
    }
}
var BorderCollapse = {
    toString: toString$67
};
function toString$68(x) {
    if (x === "wrapReverse") {
        return "wrap-reverse";
    } else if (x === "nowrap") {
        return "nowrap";
    } else {
        return "wrap";
    }
}
var FlexWrap = {
    toString: toString$68
};
function toString$69(x) {
    if (x === "row") {
        return "row";
    } else if (x === "columnReverse") {
        return "column-reverse";
    } else if (x === "rowReverse") {
        return "row-reverse";
    } else {
        return "column";
    }
}
var FlexDirection = {
    toString: toString$69
};
function toString$70(x) {
    if (x === "borderBox") {
        return "border-box";
    } else {
        return "content-box";
    }
}
var BoxSizing = {
    toString: toString$70
};
function toString$71(x) {
    if (typeof x === "object") {
        return x.VAL.toString();
    } else {
        return "auto";
    }
}
var ColumnCount = {
    toString: toString$71
};
function toString$72(x) {
    if (x === "none") {
        return "none";
    } else if (x === "text") {
        return "text";
    } else if (x === "all") {
        return "all";
    } else if (x === "contain") {
        return "contain";
    } else {
        return "auto";
    }
}
var UserSelect = {
    toString: toString$72
};
function toString$73(x) {
    if (x === "capitalize") {
        return "capitalize";
    } else if (x === "lowercase") {
        return "lowercase";
    } else if (x === "uppercase") {
        return "uppercase";
    } else {
        return "none";
    }
}
var TextTransform = {
    toString: toString$73
};
function areas(x) {
    return {
        NAME: "areas",
        VAL: x
    };
}
function toString$74(x) {
    if (typeof x === "object") {
        return _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .fy(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .reduceU */ .Ox(x.VAL, "", function(carry, item) {
            return carry + "'" + item + "' ";
        }));
    } else {
        return "none";
    }
}
var GridTemplateAreas = {
    areas: areas,
    toString: toString$74
};
function ident(x) {
    return {
        NAME: "ident",
        VAL: x
    };
}
function num(x) {
    return {
        NAME: "num",
        VAL: x
    };
}
function numIdent(x, y) {
    return {
        NAME: "numIdent",
        VAL: [
            x,
            y
        ]
    };
}
function span(x) {
    return {
        NAME: "span",
        VAL: x
    };
}
function toString$75(t) {
    if (typeof t !== "object") {
        return "auto";
    }
    var variant = t.NAME;
    if (variant === "numIdent") {
        var match = t.VAL;
        return String(match[0]) + " " + match[1];
    }
    if (variant === "num") {
        return String(t.VAL);
    }
    if (variant === "ident") {
        return t.VAL;
    }
    var e = t.VAL;
    return "span " + (e.NAME === "ident" ? e.VAL : String(e.VAL));
}
var GridArea = {
    auto: "auto",
    ident: ident,
    num: num,
    numIdent: numIdent,
    span: span,
    toString: toString$75
};
function toString$76(x) {
    if (typeof x !== "object") {
        return "none";
    }
    var variant = x.NAME;
    if (variant === "dropShadow") {
        var match = x.VAL;
        if (match.NAME === "num") {
            return "drop-shadow(" + String(match.VAL) + ")";
        } else {
            return "drop-shadow(" + (match.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "brightness") {
        var match$1 = x.VAL;
        if (match$1.NAME === "num") {
            return "brightness(" + String(match$1.VAL) + ")";
        } else {
            return "brightness(" + (match$1.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "opacity") {
        var match$2 = x.VAL;
        if (match$2.NAME === "num") {
            return "opacity(" + String(match$2.VAL) + ")";
        } else {
            return "opacity(" + (match$2.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "grayscale") {
        var match$3 = x.VAL;
        if (match$3.NAME === "num") {
            return "grayscale(" + String(match$3.VAL) + ")";
        } else {
            return "grayscale(" + (match$3.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "sepia") {
        var match$4 = x.VAL;
        if (match$4.NAME === "num") {
            return "sepia(" + String(match$4.VAL) + ")";
        } else {
            return "sepia(" + (match$4.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "saturate") {
        var match$5 = x.VAL;
        if (match$5.NAME === "num") {
            return "saturate(" + String(match$5.VAL) + ")";
        } else {
            return "saturate(" + (match$5.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "invert") {
        var match$6 = x.VAL;
        if (match$6.NAME === "num") {
            return "invert(" + String(match$6.VAL) + ")";
        } else {
            return "invert(" + (match$6.VAL.toString() + "%") + ")";
        }
    }
    if (variant === "contrast") {
        var match$7 = x.VAL;
        if (match$7.NAME === "num") {
            return "contrast(" + String(match$7.VAL) + ")";
        } else {
            return "contrast(" + (match$7.VAL.toString() + "%") + ")";
        }
    }
    if (variant !== "hueRotate") {
        return "blur(" + toString$5(x.VAL) + ")";
    }
    var h = x.VAL;
    if (typeof h === "object") {
        return "hue-rotate(" + toString$6(h) + ")";
    } else {
        return "hue-rotate(0deg)";
    }
}
function toString$77(x) {
    if (x === "local") {
        return "local";
    } else if (x === "fixed") {
        return "fixed";
    } else {
        return "scroll";
    }
}
var BackgroundAttachment = {
    toString: toString$77
};
function toString$78(x) {
    if (x === "borderBox") {
        return "border-box";
    } else if (x === "paddingBox") {
        return "padding-box";
    } else {
        return "content-box";
    }
}
var BackgroundClip = {
    toString: toString$78
};
function toString$79(x) {
    if (x === "borderBox") {
        return "border-box";
    } else if (x === "paddingBox") {
        return "padding-box";
    } else {
        return "content-box";
    }
}
var BackgroundOrigin = {
    toString: toString$79
};
function toString$80(x) {
    if (x === "right") {
        return "right";
    } else if (x === "center") {
        return "center";
    } else {
        return "left";
    }
}
var X = {
    toString: toString$80
};
function toString$81(x) {
    if (x === "top") {
        return "top";
    } else if (x === "center") {
        return "center";
    } else {
        return "bottom";
    }
}
var Y = {
    toString: toString$81
};
function toString$82(x) {
    if (x === "bottom") {
        return "bottom";
    } else if (x === "right") {
        return "right";
    } else if (x === "top") {
        return "top";
    } else if (x === "center") {
        return "center";
    } else {
        return "left";
    }
}
var BackgroundPosition = {
    X: X,
    Y: Y,
    toString: toString$82
};
function toString$83(x) {
    if (x === "right") {
        return "right";
    } else if (x === "center") {
        return "center";
    } else {
        return "left";
    }
}
var X$1 = {
    toString: toString$83
};
function toString$84(x) {
    if (x === "top") {
        return "top";
    } else if (x === "center") {
        return "center";
    } else {
        return "bottom";
    }
}
var Y$1 = {
    toString: toString$84
};
function toString$85(x) {
    if (x === "bottom") {
        return "bottom";
    } else if (x === "right") {
        return "right";
    } else if (x === "top") {
        return "top";
    } else if (x === "center") {
        return "center";
    } else {
        return "left";
    }
}
var MaskPosition = {
    X: X$1,
    Y: Y$1,
    toString: toString$85
};
function toString$86(x) {
    if (x === "round") {
        return "round";
    } else if (x === "space") {
        return "space";
    } else if (x === "repeat") {
        return "repeat";
    } else if (x === "repeatX") {
        return "repeat-x";
    } else if (x === "repeatY") {
        return "repeat-y";
    } else {
        return "no-repeat";
    }
}
var BackgroundRepeat = {
    toString: toString$86
};
function toString$87(x) {
    if (typeof x === "object") {
        return x.VAL;
    } else if (x === "ellipsis") {
        return "ellipsis";
    } else {
        return "clip";
    }
}
var TextOverflow = {
    toString: toString$87
};
function toString$88(x) {
    if (x === "none") {
        return "none";
    } else if (x === "underline") {
        return "underline";
    } else if (x === "lineThrough") {
        return "line-through";
    } else if (x === "blink") {
        return "blink";
    } else {
        return "overline";
    }
}
var TextDecorationLine = {
    toString: toString$88
};
function toString$89(x) {
    if (x === "solid") {
        return "solid";
    } else if (x === "dashed") {
        return "dashed";
    } else if (x === "dotted") {
        return "dotted";
    } else if (x === "double") {
        return "double";
    } else {
        return "wavy";
    }
}
var TextDecorationStyle = {
    toString: toString$89
};
function toString$90(x) {
    if (x === "fromFont") {
        return "from-font";
    } else {
        return "auto";
    }
}
var TextDecorationThickness = {
    toString: toString$90
};
function toString$91(x) {
    if (x === "minContent") {
        return "min-content";
    } else if (x === "fitContent") {
        return "fit-content";
    } else if (x === "maxContent") {
        return "max-content";
    } else {
        return "auto";
    }
}
var Width = {
    toString: toString$91
};
function toString$92(x) {
    return "none";
}
var None = {
    toString: toString$92
};
function toString$93(x) {
    if (x === "minContent") {
        return "min-content";
    } else if (x === "fitContent") {
        return "fit-content";
    } else if (x === "maxContent") {
        return "max-content";
    } else {
        return "auto";
    }
}
var Height = {
    toString: toString$93
};
function toString$94(x) {
    if (x === "anywhere") {
        return "anywhere";
    } else if (x === "breakWord") {
        return "break-word";
    } else {
        return "normal";
    }
}
var OverflowWrap = {
    toString: toString$94
};
function linearGradient(angle, stops) {
    return {
        NAME: "linearGradient",
        VAL: [
            angle,
            stops
        ]
    };
}
function repeatingLinearGradient(angle, stops) {
    return {
        NAME: "repeatingLinearGradient",
        VAL: [
            angle,
            stops
        ]
    };
}
function radialGradient(stops) {
    return {
        NAME: "radialGradient",
        VAL: stops
    };
}
function repeatingRadialGradient(stops) {
    return {
        NAME: "repeatingRadialGradient",
        VAL: stops
    };
}
function conicGradient(angle, stops) {
    return {
        NAME: "conicGradient",
        VAL: [
            angle,
            stops
        ]
    };
}
function string_of_color(x) {
    if (typeof x !== "object") {
        return toString$36(x);
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return toString$1(x);
    } else {
        return toString$36(x);
    }
}
function string_of_stops(stops) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_2__/* .map */ .UI(stops, function(param) {
        return string_of_color(param[1]) + " " + toString$5(param[0]);
    }).join(", ");
}
function toString$95(x) {
    var variant = x.NAME;
    if (variant === "repeatingRadialGradient") {
        return "repeating-radial-gradient(" + string_of_stops(x.VAL) + ")";
    }
    if (variant === "repeatingLinearGradient") {
        var match = x.VAL;
        return "repeating-linear-gradient(" + toString$6(match[0]) + ", " + string_of_stops(match[1]) + ")";
    }
    if (variant === "radialGradient") {
        return "radial-gradient(" + string_of_stops(x.VAL) + ")";
    }
    if (variant === "linearGradient") {
        var match$1 = x.VAL;
        return "linear-gradient(" + toString$6(match$1[0]) + ", " + string_of_stops(match$1[1]) + ")";
    }
    var match$2 = x.VAL;
    return "conic-gradient(from " + toString$6(match$2[0]) + ", " + string_of_stops(match$2[1]) + ")";
}
function toString$96(x) {
    return "none";
}
var BackgroundImage = {
    toString: toString$96
};
function toString$97(x) {
    return "none";
}
var MaskImage = {
    toString: toString$97
};
function toString$98(x) {
    if (x === "marginBox") {
        return "margin-box";
    } else if (x === "strokeBox") {
        return "stroke-box";
    } else if (x === "borderBox") {
        return "border-box";
    } else if (x === "fillBox") {
        return "fill-box";
    } else if (x === "viewBox") {
        return "view-box";
    } else if (x === "paddingBox") {
        return "padding-box";
    } else {
        return "content-box";
    }
}
var GeometryBox = {
    marginBox: "marginBox",
    borderBox: "borderBox",
    paddingBox: "paddingBox",
    contentBox: "contentBox",
    fillBox: "fillBox",
    strokeBox: "strokeBox",
    viewBox: "viewBox",
    toString: toString$98
};
function toString$99(x) {
    return "none";
}
var ClipPath = {
    toString: toString$99
};
function toString$100(x) {
    if (x === "visible") {
        return "visible";
    } else {
        return "hidden";
    }
}
var BackfaceVisibility = {
    toString: toString$100
};
function toString$101(x) {
    if (x === "none") {
        return "none";
    } else if (x === "initial") {
        return "initial";
    } else {
        return "auto";
    }
}
var Flex = {
    toString: toString$101
};
function toString$102(x) {
    if (x === "preserve3d") {
        return "preserve-3d";
    } else {
        return "flat";
    }
}
var TransformStyle = {
    toString: toString$102
};
function toString$103(x) {
    if (x === "strokeBox") {
        return "stroke-box";
    } else if (x === "borderBox") {
        return "border-box";
    } else if (x === "fillBox") {
        return "fill-box";
    } else if (x === "viewBox") {
        return "view-box";
    } else {
        return "content-box";
    }
}
var TransformBox = {
    toString: toString$103
};
function toString$104(x) {
    return "none";
}
var ListStyleImage = {
    toString: toString$104
};
function toString$105(x) {
    if (typeof x === "object") {
        return x.VAL;
    } else if (x === "cursive") {
        return "cursive";
    } else if (x === "sansSerif") {
        return "sans-serif";
    } else if (x === "monospace") {
        return "monospace";
    } else if (x === "systemUi") {
        return "system-ui";
    } else if (x === "emoji") {
        return "emoji";
    } else if (x === "serif") {
        return "serif";
    } else if (x === "fantasy") {
        return "fantasy";
    } else if (x === "fangsong") {
        return "fangsong";
    } else {
        return "math";
    }
}
function toString$106(x) {
    if (x === "swap") {
        return "swap";
    } else if (x === "optional") {
        return "optional";
    } else if (x === "fallback") {
        return "fallback";
    } else if (x === "block") {
        return "block";
    } else {
        return "auto";
    }
}
var toString$107 = toString$26;
var CounterStyleType = {
    toString: toString$107
};
function counter(styleOpt, name) {
    var style = styleOpt !== undefined ? styleOpt : "unset";
    return {
        NAME: "counter",
        VAL: [
            name,
            style
        ]
    };
}
function toString$108(x) {
    var match = x.VAL;
    var style = match[1];
    var _$counter = match[0];
    if (style === "unset") {
        return "counter(" + _$counter + ")";
    } else {
        return "counter(" + _$counter + "," + toString$26(style) + ")";
    }
}
var Counter = {
    counter: counter,
    toString: toString$108
};
function counters(styleOpt, separatorOpt, name) {
    var style = styleOpt !== undefined ? styleOpt : "unset";
    var separator = separatorOpt !== undefined ? separatorOpt : "";
    return {
        NAME: "counters",
        VAL: [
            name,
            separator,
            style
        ]
    };
}
function toString$109(x) {
    var match = x.VAL;
    var style = match[2];
    var separator = match[1];
    var name = match[0];
    if (style === "unset") {
        return "counters(" + name + ',"' + separator + '")';
    } else {
        return "counters(" + name + ',"' + separator + '",' + toString$26(style) + ")";
    }
}
var Counters = {
    counters: counters,
    toString: toString$109
};
function increment(valueOpt, name) {
    var value = valueOpt !== undefined ? valueOpt : 1;
    return {
        NAME: "increment",
        VAL: [
            name,
            value
        ]
    };
}
function toString$110(x) {
    if (typeof x !== "object") {
        return "none";
    }
    var match = x.VAL;
    return match[0] + " " + String(match[1]);
}
var CounterIncrement = {
    increment: increment,
    toString: toString$110
};
function reset(valueOpt, name) {
    var value = valueOpt !== undefined ? valueOpt : 0;
    return {
        NAME: "reset",
        VAL: [
            name,
            value
        ]
    };
}
function toString$111(x) {
    if (typeof x !== "object") {
        return "none";
    }
    var match = x.VAL;
    return match[0] + " " + String(match[1]);
}
var CounterReset = {
    reset: reset,
    toString: toString$111
};
function set(valueOpt, name) {
    var value = valueOpt !== undefined ? valueOpt : 0;
    return {
        NAME: "set",
        VAL: [
            name,
            value
        ]
    };
}
function toString$112(x) {
    if (typeof x !== "object") {
        return "none";
    }
    var match = x.VAL;
    return match[0] + " " + String(match[1]);
}
var CounterSet = {
    set: set,
    toString: toString$112
};
function toString$113(x) {
    if (typeof x === "object") {
        if (x.NAME === "text") {
            return x.VAL;
        } else {
            return "attr(" + x.VAL + ")";
        }
    } else if (x === "none") {
        return "none";
    } else if (x === "openQuote") {
        return "open-quote";
    } else if (x === "closeQuote") {
        return "close-quote";
    } else if (x === "normal") {
        return "normal";
    } else if (x === "noOpenQuote") {
        return "no-open-quote";
    } else {
        return "no-close-quote";
    }
}
var Content = {
    toString: toString$113
};
function toString$114(x) {
    if (x === "contextFill") {
        return "context-fill";
    } else if (x === "contextStroke") {
        return "context-stroke";
    } else {
        return "none";
    }
}
var Fill = {
    contextFill: "contextFill",
    contextStroke: "contextStroke",
    toString: toString$114
};
var SVG = {
    Fill: Fill
};
function toString$115(x) {
    if (x === "none") {
        return "none";
    } else if (x === "panX") {
        return "pan-x";
    } else if (x === "panY") {
        return "pan-y";
    } else if (x === "pinchZoom") {
        return "pinch-zoom";
    } else if (x === "manipulation") {
        return "manipulation";
    } else if (x === "panDown") {
        return "pan-down";
    } else if (x === "panLeft") {
        return "pan-left";
    } else if (x === "panUp") {
        return "pan-up";
    } else if (x === "panRight") {
        return "pan-right";
    } else {
        return "auto";
    }
}
var TouchAction = {
    toString: toString$115
};
var Var = {
    $$var: $$var,
    varDefault: varDefault,
    toString: toString$1
};
var RowGap;
var ColumnGap;
var TimingFunction = {
    linear: "linear",
    ease: "ease",
    easeIn: "easeIn",
    easeOut: "easeOut",
    easeInOut: "easeInOut",
    stepStart: "stepStart",
    stepEnd: "stepEnd",
    steps: steps,
    cubicBezier: cubicBezier,
    jumpStart: "jumpStart",
    jumpEnd: "jumpEnd",
    jumpNone: "jumpNone",
    jumpBoth: "jumpBoth",
    toString: toString$24
};
var Transform = {
    translate: translate,
    translate3d: translate3d,
    translateX: translateX,
    translateY: translateY,
    translateZ: translateZ,
    scale: scale,
    scale3d: scale3d,
    scaleX: scaleX,
    scaleY: scaleY,
    scaleZ: scaleZ,
    rotate: rotate,
    rotate3d: rotate3d,
    rotateX: rotateX,
    rotateY: rotateY,
    rotateZ: rotateZ,
    skew: skew,
    skewX: skewX,
    skewY: skewY,
    toString: toString$30
};
var Color = {
    rgb: rgb,
    rgba: rgba,
    hsl: hsl,
    hsla: hsla,
    hex: hex,
    transparent: "transparent",
    currentColor: "currentColor",
    toString: toString$36
};
var BackdropFilter = {
    toString: toString$76
};
var MaxWidth = None;
var MinWidth = None;
var MaxHeight = None;
var MinHeight = None;
var Gradient = {
    linearGradient: linearGradient,
    radialGradient: radialGradient,
    repeatingLinearGradient: repeatingLinearGradient,
    repeatingRadialGradient: repeatingRadialGradient,
    conicGradient: conicGradient,
    toString: toString$95
};
var FontFamilyName = {
    toString: toString$105
};
var FontDisplay = {
    toString: toString$106
};
 /* No side effect */ 


/***/ }),

/***/ 77274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ teal; },
/* harmony export */   "$T": function() { return /* binding */ aliceblue; },
/* harmony export */   "$p": function() { return /* binding */ tomato; },
/* harmony export */   "$s": function() { return /* binding */ cornsilk; },
/* harmony export */   "$y": function() { return /* binding */ orange; },
/* harmony export */   "AV": function() { return /* binding */ mediumorchid; },
/* harmony export */   "Al": function() { return /* binding */ goldenrod; },
/* harmony export */   "As": function() { return /* binding */ lightslategrey; },
/* harmony export */   "Ax": function() { return /* binding */ honeydew; },
/* harmony export */   "BA": function() { return /* binding */ grey; },
/* harmony export */   "Bg": function() { return /* binding */ mediumblue; },
/* harmony export */   "Ce": function() { return /* binding */ magenta; },
/* harmony export */   "Cn": function() { return /* binding */ aquamarine; },
/* harmony export */   "EQ": function() { return /* binding */ olivedrab; },
/* harmony export */   "EV": function() { return /* binding */ gold; },
/* harmony export */   "Ec": function() { return /* binding */ darkred; },
/* harmony export */   "FG": function() { return /* binding */ deeppink; },
/* harmony export */   "Fe": function() { return /* binding */ powderblue; },
/* harmony export */   "G4": function() { return /* binding */ darkseagreen; },
/* harmony export */   "GO": function() { return /* binding */ darkslateblue; },
/* harmony export */   "GV": function() { return /* binding */ lightslategray; },
/* harmony export */   "H9": function() { return /* binding */ dodgerblue; },
/* harmony export */   "Hj": function() { return /* binding */ lightgreen; },
/* harmony export */   "I6": function() { return /* binding */ burlywood; },
/* harmony export */   "IK": function() { return /* binding */ khaki; },
/* harmony export */   "IP": function() { return /* binding */ indianred; },
/* harmony export */   "IU": function() { return /* binding */ firebrick; },
/* harmony export */   "Ih": function() { return /* binding */ navy; },
/* harmony export */   "Ii": function() { return /* binding */ navajowhite; },
/* harmony export */   "JU": function() { return /* binding */ chocolate; },
/* harmony export */   "Jm": function() { return /* binding */ palegreen; },
/* harmony export */   "KD": function() { return /* binding */ darkslategrey; },
/* harmony export */   "Kf": function() { return /* binding */ lemonchiffon; },
/* harmony export */   "Kx": function() { return /* binding */ blanchedalmond; },
/* harmony export */   "Kz": function() { return /* binding */ peachpuff; },
/* harmony export */   "L9": function() { return /* binding */ darkgreen; },
/* harmony export */   "LR": function() { return /* binding */ lime; },
/* harmony export */   "MA": function() { return /* binding */ gray; },
/* harmony export */   "Mk": function() { return /* binding */ turquoise; },
/* harmony export */   "My": function() { return /* binding */ rebeccapurple; },
/* harmony export */   "N0": function() { return /* binding */ lavender; },
/* harmony export */   "OD": function() { return /* binding */ skyblue; },
/* harmony export */   "OQ": function() { return /* binding */ dimgray; },
/* harmony export */   "OR": function() { return /* binding */ tan; },
/* harmony export */   "OW": function() { return /* binding */ whitesmoke; },
/* harmony export */   "P2": function() { return /* binding */ slategrey; },
/* harmony export */   "PA": function() { return /* binding */ darkgrey; },
/* harmony export */   "P_": function() { return /* binding */ brown; },
/* harmony export */   "Q6": function() { return /* binding */ red; },
/* harmony export */   "QN": function() { return /* binding */ indigo; },
/* harmony export */   "RT": function() { return /* binding */ mistyrose; },
/* harmony export */   "Rd": function() { return /* binding */ darkorange; },
/* harmony export */   "Rh": function() { return /* binding */ mintcream; },
/* harmony export */   "Sn": function() { return /* binding */ black; },
/* harmony export */   "Su": function() { return /* binding */ mediumturquoise; },
/* harmony export */   "TY": function() { return /* binding */ yellowgreen; },
/* harmony export */   "Tj": function() { return /* binding */ darkturquoise; },
/* harmony export */   "UM": function() { return /* binding */ paleturquoise; },
/* harmony export */   "UP": function() { return /* binding */ darkviolet; },
/* harmony export */   "UQ": function() { return /* binding */ lightgray; },
/* harmony export */   "UR": function() { return /* binding */ sienna; },
/* harmony export */   "Vl": function() { return /* binding */ mediumspringgreen; },
/* harmony export */   "WI": function() { return /* binding */ royalblue; },
/* harmony export */   "WV": function() { return /* binding */ oldlace; },
/* harmony export */   "Wl": function() { return /* binding */ crimson; },
/* harmony export */   "X0": function() { return /* binding */ thistle; },
/* harmony export */   "XV": function() { return /* binding */ orchid; },
/* harmony export */   "XW": function() { return /* binding */ lightblue; },
/* harmony export */   "Xb": function() { return /* binding */ slateblue; },
/* harmony export */   "Xr": function() { return /* binding */ snow; },
/* harmony export */   "Xw": function() { return /* binding */ moccasin; },
/* harmony export */   "YL": function() { return /* binding */ mediumseagreen; },
/* harmony export */   "YP": function() { return /* binding */ steelblue; },
/* harmony export */   "Yd": function() { return /* binding */ azure; },
/* harmony export */   "ZP": function() { return /* binding */ palevioletred; },
/* harmony export */   "Zn": function() { return /* binding */ transparent; },
/* harmony export */   "aL": function() { return /* binding */ slategray; },
/* harmony export */   "bV": function() { return /* binding */ limegreen; },
/* harmony export */   "c7": function() { return /* binding */ gainsboro; },
/* harmony export */   "ci": function() { return /* binding */ lightpink; },
/* harmony export */   "cz": function() { return /* binding */ darkslategray; },
/* harmony export */   "dR": function() { return /* binding */ darkblue; },
/* harmony export */   "dS": function() { return /* binding */ darkmagenta; },
/* harmony export */   "dm": function() { return /* binding */ maroon; },
/* harmony export */   "dw": function() { return /* binding */ lightgoldenrodyellow; },
/* harmony export */   "e9": function() { return /* binding */ beige; },
/* harmony export */   "eb": function() { return /* binding */ darkcyan; },
/* harmony export */   "ek": function() { return /* binding */ green; },
/* harmony export */   "eo": function() { return /* binding */ darkgray; },
/* harmony export */   "er": function() { return /* binding */ yellow; },
/* harmony export */   "ev": function() { return /* binding */ lawngreen; },
/* harmony export */   "ez": function() { return /* binding */ darkolivegreen; },
/* harmony export */   "fK": function() { return /* binding */ deepskyblue; },
/* harmony export */   "ff": function() { return /* binding */ greenyellow; },
/* harmony export */   "gu": function() { return /* binding */ antiquewhite; },
/* harmony export */   "h$": function() { return /* binding */ ivory; },
/* harmony export */   "hC": function() { return /* binding */ lightgrey; },
/* harmony export */   "hR": function() { return /* binding */ seagreen; },
/* harmony export */   "ht": function() { return /* binding */ violet; },
/* harmony export */   "iN": function() { return /* binding */ blue; },
/* harmony export */   "iQ": function() { return /* binding */ pink; },
/* harmony export */   "ix": function() { return /* binding */ white; },
/* harmony export */   "jR": function() { return /* binding */ lavenderblush; },
/* harmony export */   "jk": function() { return /* binding */ purple; },
/* harmony export */   "kh": function() { return /* binding */ bisque; },
/* harmony export */   "kr": function() { return /* binding */ salmon; },
/* harmony export */   "lY": function() { return /* binding */ lightsalmon; },
/* harmony export */   "l_": function() { return /* binding */ silver; },
/* harmony export */   "mH": function() { return /* binding */ chartreuse; },
/* harmony export */   "mL": function() { return /* binding */ palegoldenrod; },
/* harmony export */   "me": function() { return /* binding */ blueviolet; },
/* harmony export */   "mf": function() { return /* binding */ lightseagreen; },
/* harmony export */   "my": function() { return /* binding */ ghostwhite; },
/* harmony export */   "nN": function() { return /* binding */ cadetblue; },
/* harmony export */   "ng": function() { return /* binding */ hotpink; },
/* harmony export */   "nh": function() { return /* binding */ darkorchid; },
/* harmony export */   "nu": function() { return /* binding */ linen; },
/* harmony export */   "ob": function() { return /* binding */ forestgreen; },
/* harmony export */   "oe": function() { return /* binding */ springgreen; },
/* harmony export */   "og": function() { return /* binding */ mediumpurple; },
/* harmony export */   "ou": function() { return /* binding */ coral; },
/* harmony export */   "qP": function() { return /* binding */ seashell; },
/* harmony export */   "qZ": function() { return /* binding */ olive; },
/* harmony export */   "qb": function() { return /* binding */ sandybrown; },
/* harmony export */   "qv": function() { return /* binding */ lightcoral; },
/* harmony export */   "rD": function() { return /* binding */ midnightblue; },
/* harmony export */   "s$": function() { return /* binding */ lightyellow; },
/* harmony export */   "s9": function() { return /* binding */ floralwhite; },
/* harmony export */   "sN": function() { return /* binding */ saddlebrown; },
/* harmony export */   "sf": function() { return /* binding */ mediumslateblue; },
/* harmony export */   "sl": function() { return /* binding */ cyan; },
/* harmony export */   "tO": function() { return /* binding */ lightcyan; },
/* harmony export */   "tb": function() { return /* binding */ aqua; },
/* harmony export */   "tm": function() { return /* binding */ wheat; },
/* harmony export */   "tt": function() { return /* binding */ papayawhip; },
/* harmony export */   "up": function() { return /* binding */ lightskyblue; },
/* harmony export */   "vN": function() { return /* binding */ mediumaquamarine; },
/* harmony export */   "vd": function() { return /* binding */ plum; },
/* harmony export */   "ve": function() { return /* binding */ orangered; },
/* harmony export */   "wO": function() { return /* binding */ rosybrown; },
/* harmony export */   "xC": function() { return /* binding */ darksalmon; },
/* harmony export */   "yS": function() { return /* binding */ dimgrey; },
/* harmony export */   "yi": function() { return /* binding */ cornflowerblue; },
/* harmony export */   "yu": function() { return /* binding */ darkkhaki; },
/* harmony export */   "z1": function() { return /* binding */ lightsteelblue; },
/* harmony export */   "zO": function() { return /* binding */ darkgoldenrod; },
/* harmony export */   "zR": function() { return /* binding */ mediumvioletred; },
/* harmony export */   "zf": function() { return /* binding */ fuchsia; },
/* harmony export */   "zh": function() { return /* binding */ peru; }
/* harmony export */ });
/* harmony import */ var _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48891);
// Generated by ReScript, PLEASE EDIT WITH CARE

var aliceblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F0F8FF");
var antiquewhite = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FAEBD7");
var aqua = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00FFFF");
var aquamarine = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("7FFFD4");
var azure = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F0FFFF");
var beige = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F5F5DC");
var bisque = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFE4C4");
var black = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("000000");
var blanchedalmond = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFEBCD");
var blue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("0000FF");
var blueviolet = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("8A2BE2");
var brown = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("A52A2A");
var burlywood = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DEB887");
var cadetblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("5F9EA0");
var chartreuse = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("7FFF00");
var chocolate = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("D2691E");
var coral = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF7F50");
var cornflowerblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("6495ED");
var cornsilk = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFF8DC");
var crimson = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DC143C");
var cyan = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00FFFF");
var darkblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00008B");
var darkcyan = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("008B8B");
var darkgoldenrod = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("B8860B");
var darkgray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("A9A9A9");
var darkgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("006400");
var darkgrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("A9A9A9");
var darkkhaki = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("BDB76B");
var darkmagenta = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("8B008B");
var darkolivegreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("556B2F");
var darkorange = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF8C00");
var darkorchid = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("9932CC");
var darkred = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("8B0000");
var darksalmon = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("E9967A");
var darkseagreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("8FBC8F");
var darkslateblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("483D8B");
var darkslategray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("2F4F4F");
var darkslategrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("2F4F4F");
var darkturquoise = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00CED1");
var darkviolet = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("9400D3");
var deeppink = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF1493");
var deepskyblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00BFFF");
var dimgray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("696969");
var dimgrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("696969");
var dodgerblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("1E90FF");
var firebrick = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("B22222");
var floralwhite = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFAF0");
var forestgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("228B22");
var fuchsia = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF00FF");
var gainsboro = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DCDCDC");
var ghostwhite = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F8F8FF");
var gold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFD700");
var goldenrod = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DAA520");
var gray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("808080");
var green = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("008000");
var greenyellow = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("ADFF2F");
var grey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("808080");
var honeydew = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F0FFF0");
var hotpink = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF69B4");
var indianred = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("CD5C5C");
var indigo = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("4B0082");
var ivory = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFFF0");
var khaki = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F0E68C");
var lavender = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("E6E6FA");
var lavenderblush = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFF0F5");
var lawngreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("7CFC00");
var lemonchiffon = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFACD");
var lightblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("ADD8E6");
var lightcoral = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F08080");
var lightcyan = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("E0FFFF");
var lightgoldenrodyellow = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FAFAD2");
var lightgray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("D3D3D3");
var lightgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("90EE90");
var lightgrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("D3D3D3");
var lightpink = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFB6C1");
var lightsalmon = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFA07A");
var lightseagreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("20B2AA");
var lightskyblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("87CEFA");
var lightslategray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("778899");
var lightslategrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("778899");
var lightsteelblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("B0C4DE");
var lightyellow = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFFE0");
var lime = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00FF00");
var limegreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("32CD32");
var linen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FAF0E6");
var magenta = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF00FF");
var maroon = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("800000");
var mediumaquamarine = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("66CDAA");
var mediumblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("0000CD");
var mediumorchid = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("BA55D3");
var mediumpurple = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("9370DB");
var mediumseagreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("3CB371");
var mediumslateblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("7B68EE");
var mediumspringgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00FA9A");
var mediumturquoise = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("48D1CC");
var mediumvioletred = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("C71585");
var midnightblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("191970");
var mintcream = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F5FFFA");
var mistyrose = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFE4E1");
var moccasin = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFE4B5");
var navajowhite = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFDEAD");
var navy = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("000080");
var oldlace = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FDF5E6");
var olive = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("808000");
var olivedrab = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("6B8E23");
var orange = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFA500");
var orangered = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF4500");
var orchid = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DA70D6");
var palegoldenrod = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("EEE8AA");
var palegreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("98FB98");
var paleturquoise = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("AFEEEE");
var palevioletred = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DB7093");
var papayawhip = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFEFD5");
var peachpuff = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFDAB9");
var peru = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("CD853F");
var pink = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFC0CB");
var plum = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("DDA0DD");
var powderblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("B0E0E6");
var purple = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("800080");
var rebeccapurple = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("663399");
var red = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF0000");
var rosybrown = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("BC8F8F");
var royalblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("4169E1");
var saddlebrown = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("8B4513");
var salmon = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FA8072");
var sandybrown = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F4A460");
var seagreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("2E8B57");
var seashell = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFF5EE");
var sienna = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("A0522D");
var silver = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("C0C0C0");
var skyblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("87CEEB");
var slateblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("6A5ACD");
var slategray = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("708090");
var slategrey = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("708090");
var snow = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFAFA");
var springgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("00FF7F");
var steelblue = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("4682B4");
var tan = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("D2B48C");
var teal = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("008080");
var thistle = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("D8BFD8");
var tomato = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FF6347");
var turquoise = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("40E0D0");
var violet = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("EE82EE");
var wheat = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F5DEB3");
var white = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFFFF");
var whitesmoke = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("F5F5F5");
var yellow = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("FFFF00");
var yellowgreen = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex("9ACD32");
var transparent = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.transparent */ .Il.transparent;
 /* aliceblue Not a pure module */ 


/***/ }),

/***/ 32885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6P": function() { return /* binding */ all; },
/* harmony export */   "$6v": function() { return /* binding */ oblique; },
/* harmony export */   "$Bc": function() { return /* binding */ borderTopStyle; },
/* harmony export */   "$Co": function() { return /* binding */ countersIncrement; },
/* harmony export */   "$QP": function() { return /* binding */ column; },
/* harmony export */   "$Sh": function() { return /* binding */ firstOfType; },
/* harmony export */   "$_Y": function() { return /* binding */ color; },
/* harmony export */   "$hU": function() { return /* binding */ panY; },
/* harmony export */   "$mx": function() { return /* binding */ animationFillMode; },
/* harmony export */   "$uf": function() { return /* binding */ borderStyle; },
/* harmony export */   "$v1": function() { return /* binding */ hex; },
/* harmony export */   "$xc": function() { return /* binding */ grabbing; },
/* harmony export */   "$zm": function() { return /* binding */ scaleY; },
/* harmony export */   "A8G": function() { return /* binding */ textDecorationLine; },
/* harmony export */   "AGO": function() { return /* binding */ borderBottomLeftRadius; },
/* harmony export */   "AGi": function() { return /* binding */ absolute; },
/* harmony export */   "ANm": function() { return /* binding */ tableFooterGroup; },
/* harmony export */   "ARY": function() { return /* binding */ scroll; },
/* harmony export */   "B8C": function() { return /* binding */ rgb; },
/* harmony export */   "BC2": function() { return /* binding */ media; },
/* harmony export */   "BD_": function() { return /* binding */ isolation; },
/* harmony export */   "BFP": function() { return /* binding */ transitionDelay; },
/* harmony export */   "BJ1": function() { return /* binding */ rad; },
/* harmony export */   "BKm": function() { return /* binding */ strokeBox; },
/* harmony export */   "BLt": function() { return /* binding */ padding2; },
/* harmony export */   "BWb": function() { return /* binding */ wordWrap; },
/* harmony export */   "BaW": function() { return /* binding */ gridAutoFlow; },
/* harmony export */   "Bbi": function() { return /* binding */ fillBox; },
/* harmony export */   "BdG": function() { return /* binding */ transitionTimingFunction; },
/* harmony export */   "Bdr": function() { return /* binding */ fixed; },
/* harmony export */   "C1W": function() { return /* binding */ required; },
/* harmony export */   "C74": function() { return /* binding */ scale3d; },
/* harmony export */   "CAZ": function() { return /* binding */ sticky; },
/* harmony export */   "Cak": function() { return /* binding */ repeatingRadialGradient; },
/* harmony export */   "Cb8": function() { return /* binding */ height; },
/* harmony export */   "Ccm": function() { return /* binding */ gridGap; },
/* harmony export */   "CgR": function() { return /* binding */ border; },
/* harmony export */   "CvW": function() { return /* binding */ wResize; },
/* harmony export */   "Czw": function() { return /* binding */ backgroundColor; },
/* harmony export */   "DHQ": function() { return /* binding */ noRepeat; },
/* harmony export */   "Dc1": function() { return /* binding */ wait; },
/* harmony export */   "DhX": function() { return /* binding */ space; },
/* harmony export */   "Djg": function() { return /* binding */ varDefault; },
/* harmony export */   "DuZ": function() { return /* binding */ selection; },
/* harmony export */   "E$t": function() { return /* binding */ borderTopRightRadius; },
/* harmony export */   "E0j": function() { return /* binding */ fitContent; },
/* harmony export */   "E0l": function() { return /* binding */ borderRadius; },
/* harmony export */   "E2y": function() { return /* binding */ turn; },
/* harmony export */   "E9m": function() { return /* binding */ marginTop; },
/* harmony export */   "EcY": function() { return /* binding */ animationIterationCount; },
/* harmony export */   "Eqy": function() { return /* binding */ countersSet; },
/* harmony export */   "EtG": function() { return /* binding */ paddingBottom; },
/* harmony export */   "F2z": function() { return /* binding */ right; },
/* harmony export */   "F86": function() { return /* binding */ margin3; },
/* harmony export */   "FDc": function() { return /* binding */ backgroundRepeat; },
/* harmony export */   "FHD": function() { return /* binding */ maxContent; },
/* harmony export */   "FKU": function() { return /* binding */ position; },
/* harmony export */   "FLd": function() { return /* binding */ animationValue; },
/* harmony export */   "FWK": function() { return /* binding */ gridAutoRows; },
/* harmony export */   "FoG": function() { return /* binding */ skewY; },
/* harmony export */   "FoQ": function() { return /* binding */ swResize; },
/* harmony export */   "Fud": function() { return /* binding */ backgrounds; },
/* harmony export */   "Fv": function() { return /* binding */ visited; },
/* harmony export */   "G30": function() { return /* binding */ perspective; },
/* harmony export */   "G4A": function() { return /* binding */ columnWidth; },
/* harmony export */   "G4q": function() { return /* binding */ backgroundSize; },
/* harmony export */   "GEo": function() { return /* binding */ linear; },
/* harmony export */   "GJu": function() { return /* binding */ tableLayout; },
/* harmony export */   "GYS": function() { return /* binding */ reverse; },
/* harmony export */   "Gew": function() { return /* binding */ block; },
/* harmony export */   "Gfm": function() { return /* binding */ relative; },
/* harmony export */   "Gho": function() { return /* binding */ forwards; },
/* harmony export */   "H6": function() { return /* binding */ readWrite; },
/* harmony export */   "H78": function() { return /* binding */ flexGrow; },
/* harmony export */   "HA": function() { return /* binding */ dashed; },
/* harmony export */   "HMX": function() { return /* binding */ borderBottomWidth; },
/* harmony export */   "HQ2": function() { return /* binding */ url; },
/* harmony export */   "HkC": function() { return /* binding */ both; },
/* harmony export */   "I1x": function() { return /* binding */ invalid; },
/* harmony export */   "I85": function() { return /* binding */ fontFamily; },
/* harmony export */   "I95": function() { return /* binding */ overline; },
/* harmony export */   "IQZ": function() { return /* binding */ contents; },
/* harmony export */   "IQh": function() { return /* binding */ neswResize; },
/* harmony export */   "IV2": function() { return /* binding */ medium; },
/* harmony export */   "I_Q": function() { return /* binding */ local; },
/* harmony export */   "IaC": function() { return /* binding */ bottom; },
/* harmony export */   "Iue": function() { return /* binding */ translate; },
/* harmony export */   "J49": function() { return /* binding */ columnCount; },
/* harmony export */   "J4J": function() { return /* binding */ borderWidth; },
/* harmony export */   "J6G": function() { return /* binding */ alternate; },
/* harmony export */   "JBY": function() { return /* binding */ fontSize; },
/* harmony export */   "JGK": function() { return /* binding */ copy; },
/* harmony export */   "JQf": function() { return /* binding */ touchAction; },
/* harmony export */   "JUm": function() { return /* binding */ disabled; },
/* harmony export */   "Jbp": function() { return /* binding */ runIn; },
/* harmony export */   "Jnk": function() { return /* binding */ hsla; },
/* harmony export */   "Jz2": function() { return /* binding */ root; },
/* harmony export */   "K$K": function() { return /* binding */ gridTemplateColumns; },
/* harmony export */   "K03": function() { return /* binding */ counterReset; },
/* harmony export */   "K47": function() { return /* binding */ unsafe; },
/* harmony export */   "K5p": function() { return /* binding */ tableCell; },
/* harmony export */   "K9x": function() { return /* binding */ paused; },
/* harmony export */   "KL2": function() { return /* binding */ outlineOffset; },
/* harmony export */   "KMK": function() { return /* binding */ isolate; },
/* harmony export */   "KQv": function() { return /* binding */ lang; },
/* harmony export */   "KRj": function() { return /* binding */ vertical; },
/* harmony export */   "KUN": function() { return /* binding */ animationTimingFunction; },
/* harmony export */   "Kgc": function() { return /* binding */ noDrop; },
/* harmony export */   "Kl7": function() { return /* binding */ outline; },
/* harmony export */   "KlP": function() { return /* binding */ justifyContent; },
/* harmony export */   "Kvj": function() { return /* binding */ alignContent; },
/* harmony export */   "Kzj": function() { return /* binding */ table; },
/* harmony export */   "L5e": function() { return /* binding */ borderRadius4; },
/* harmony export */   "L8u": function() { return /* binding */ textTop; },
/* harmony export */   "L9u": function() { return /* binding */ flex3; },
/* harmony export */   "LAG": function() { return /* binding */ panUp; },
/* harmony export */   "LC$": function() { return /* binding */ conicGradient; },
/* harmony export */   "LHJ": function() { return /* binding */ ellipsis; },
/* harmony export */   "LIb": function() { return /* binding */ overflowWrap; },
/* harmony export */   "LZf": function() { return /* binding */ boxShadows; },
/* harmony export */   "Lol": function() { return /* binding */ transforms; },
/* harmony export */   "Loy": function() { return /* binding */ verticalAlign; },
/* harmony export */   "Me8": function() { return /* binding */ flexDirection; },
/* harmony export */   "MrM": function() { return /* binding */ hover; },
/* harmony export */   "NMM": function() { return /* binding */ round; },
/* harmony export */   "NOF": function() { return /* binding */ nthOfType; },
/* harmony export */   "NXf": function() { return /* binding */ nthLastChild; },
/* harmony export */   "NY0": function() { return /* binding */ tableRowGroup; },
/* harmony export */   "Nv8": function() { return /* binding */ lineHeight; },
/* harmony export */   "NxW": function() { return /* binding */ backgroundImage; },
/* harmony export */   "Nxf": function() { return /* binding */ indeterminate; },
/* harmony export */   "O3F": function() { return /* binding */ transitionValue; },
/* harmony export */   "O7B": function() { return /* binding */ row; },
/* harmony export */   "OYb": function() { return /* binding */ caretColor; },
/* harmony export */   "OaU": function() { return /* binding */ deg; },
/* harmony export */   "Odq": function() { return /* binding */ inside; },
/* harmony export */   "Ohi": function() { return /* binding */ opacity; },
/* harmony export */   "Oq0": function() { return /* binding */ background; },
/* harmony export */   "OqZ": function() { return /* binding */ padding3; },
/* harmony export */   "P8R": function() { return /* binding */ nowrap; },
/* harmony export */   "PS9": function() { return /* binding */ label; },
/* harmony export */   "PUt": function() { return /* binding */ gridArea4; },
/* harmony export */   "P_T": function() { return /* binding */ flexBasis; },
/* harmony export */   "PhB": function() { return /* binding */ overflowAnchor; },
/* harmony export */   "Pp4": function() { return /* binding */ wavy; },
/* harmony export */   "Ppf": function() { return /* binding */ tableCaption; },
/* harmony export */   "PqQ": function() { return /* binding */ uppercase; },
/* harmony export */   "PsQ": function() { return /* binding */ first; },
/* harmony export */   "Pxd": function() { return /* binding */ borderLeftWidth; },
/* harmony export */   "QF4": function() { return /* binding */ valid; },
/* harmony export */   "QOo": function() { return /* binding */ lastChild; },
/* harmony export */   "QXS": function() { return /* binding */ textDecoration; },
/* harmony export */   "QXW": function() { return /* binding */ count; },
/* harmony export */   "QdD": function() { return /* binding */ flexEnd; },
/* harmony export */   "QiF": function() { return /* binding */ colResize; },
/* harmony export */   "QkJ": function() { return /* binding */ skewX; },
/* harmony export */   "QoB": function() { return /* binding */ inline; },
/* harmony export */   "QsJ": function() { return /* binding */ toJson; },
/* harmony export */   "QxZ": function() { return /* binding */ textTransform; },
/* harmony export */   "R29": function() { return /* binding */ light; },
/* harmony export */   "RGf": function() { return /* binding */ gridTemplateRows; },
/* harmony export */   "RLZ": function() { return /* binding */ tableRow; },
/* harmony export */   "R_2": function() { return /* binding */ help; },
/* harmony export */   "RgW": function() { return /* binding */ transitionList; },
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "SGp": function() { return /* binding */ gap; },
/* harmony export */   "SIr": function() { return /* binding */ resize; },
/* harmony export */   "SKu": function() { return /* binding */ borderTopColor; },
/* harmony export */   "SQh": function() { return /* binding */ solid; },
/* harmony export */   "SVd": function() { return /* binding */ borderRightStyle; },
/* harmony export */   "SX6": function() { return /* binding */ outside; },
/* harmony export */   "SeW": function() { return /* binding */ bold; },
/* harmony export */   "Sgw": function() { return /* binding */ backgroundPosition4; },
/* harmony export */   "SlK": function() { return /* binding */ horizontal; },
/* harmony export */   "TE9": function() { return /* binding */ extraBold; },
/* harmony export */   "TRc": function() { return /* binding */ transformOrigin3d; },
/* harmony export */   "T_4": function() { return /* binding */ focus; },
/* harmony export */   "Tm5": function() { return /* binding */ skew; },
/* harmony export */   "U1s": function() { return /* binding */ rotate; },
/* harmony export */   "U5V": function() { return /* binding */ contentRule; },
/* harmony export */   "UQy": function() { return /* binding */ grad; },
/* harmony export */   "UY0": function() { return /* binding */ panRight; },
/* harmony export */   "UY5": function() { return /* binding */ borderRightWidth; },
/* harmony export */   "UbJ": function() { return /* binding */ gridRowGap; },
/* harmony export */   "Ue2": function() { return /* binding */ fontWeight; },
/* harmony export */   "UrL": function() { return /* binding */ stepStart; },
/* harmony export */   "V1P": function() { return /* binding */ transformStyle; },
/* harmony export */   "V8q": function() { return /* binding */ gridArea3; },
/* harmony export */   "VF7": function() { return /* binding */ panDown; },
/* harmony export */   "VXB": function() { return /* binding */ listStyle; },
/* harmony export */   "VlP": function() { return /* binding */ fontFamilies; },
/* harmony export */   "VvE": function() { return /* binding */ borderLeftColor; },
/* harmony export */   "VvG": function() { return /* binding */ easeOut; },
/* harmony export */   "Vy2": function() { return /* binding */ gridArea2; },
/* harmony export */   "W$B": function() { return /* binding */ placeholder; },
/* harmony export */   "W3B": function() { return /* binding */ gridColumnGap; },
/* harmony export */   "W5D": function() { return /* binding */ zIndex; },
/* harmony export */   "WDY": function() { return /* binding */ visibility; },
/* harmony export */   "WFv": function() { return /* binding */ minmax; },
/* harmony export */   "WLm": function() { return /* binding */ paddingRight; },
/* harmony export */   "WOS": function() { return /* binding */ flexWrap; },
/* harmony export */   "WP2": function() { return /* binding */ manipulation; },
/* harmony export */   "Wct": function() { return /* binding */ nsResize; },
/* harmony export */   "Wj1": function() { return /* binding */ SVG; },
/* harmony export */   "Wnp": function() { return /* binding */ boxShadow; },
/* harmony export */   "X0Y": function() { return /* binding */ margin4; },
/* harmony export */   "XCE": function() { return /* binding */ textShadow; },
/* harmony export */   "XNj": function() { return /* binding */ middle; },
/* harmony export */   "XOq": function() { return /* binding */ alternateReverse; },
/* harmony export */   "XSY": function() { return /* binding */ contain; },
/* harmony export */   "XY7": function() { return /* binding */ borderRightColor; },
/* harmony export */   "Xsx": function() { return /* binding */ columnReverse; },
/* harmony export */   "YD2": function() { return /* binding */ progress; },
/* harmony export */   "YP6": function() { return /* binding */ objectPosition; },
/* harmony export */   "YPD": function() { return /* binding */ none; },
/* harmony export */   "YPe": function() { return /* binding */ translateX; },
/* harmony export */   "YQY": function() { return /* binding */ easeIn; },
/* harmony export */   "YdO": function() { return /* binding */ not_; },
/* harmony export */   "Yep": function() { return /* binding */ backgroundAttachment; },
/* harmony export */   "Yi5": function() { return /* binding */ countersReset; },
/* harmony export */   "Yky": function() { return /* binding */ Types; },
/* harmony export */   "Ym7": function() { return /* binding */ hsl; },
/* harmony export */   "Yum": function() { return /* binding */ $$static; },
/* harmony export */   "Z2v": function() { return /* binding */ inRange; },
/* harmony export */   "Z9P": function() { return /* binding */ onlyChild; },
/* harmony export */   "ZHG": function() { return /* binding */ inlineTable; },
/* harmony export */   "ZHw": function() { return /* binding */ clear; },
/* harmony export */   "ZRe": function() { return /* binding */ animationDirection; },
/* harmony export */   "Zys": function() { return /* binding */ gridRowEnd; },
/* harmony export */   "_Ef": function() { return /* binding */ seResize; },
/* harmony export */   "_Xt": function() { return /* binding */ textOverflow; },
/* harmony export */   "_cl": function() { return /* binding */ backgroundClip; },
/* harmony export */   "_fG": function() { return /* binding */ padding4; },
/* harmony export */   "_s1": function() { return /* binding */ cubicBezier; },
/* harmony export */   "a5O": function() { return /* binding */ tableHeaderGroup; },
/* harmony export */   "aHA": function() { return /* binding */ bevel; },
/* harmony export */   "aNt": function() { return /* binding */ gridAutoColumns; },
/* harmony export */   "aWF": function() { return /* binding */ backwards; },
/* harmony export */   "aX$": function() { return /* binding */ semiBold; },
/* harmony export */   "aku": function() { return /* binding */ areas; },
/* harmony export */   "alX": function() { return /* binding */ hidden; },
/* harmony export */   "amh": function() { return /* binding */ enabled; },
/* harmony export */   "atG": function() { return /* binding */ inherit_; },
/* harmony export */   "az5": function() { return /* binding */ eResize; },
/* harmony export */   "bAd": function() { return /* binding */ scale; },
/* harmony export */   "bBs": function() { return /* binding */ active; },
/* harmony export */   "bCQ": function() { return /* binding */ linearGradient; },
/* harmony export */   "bCW": function() { return /* binding */ backgroundPositions; },
/* harmony export */   "bMI": function() { return /* binding */ zero; },
/* harmony export */   "bPo": function() { return /* binding */ focusVisible; },
/* harmony export */   "bbn": function() { return /* binding */ before; },
/* harmony export */   "bd4": function() { return /* binding */ rtl; },
/* harmony export */   "beQ": function() { return /* binding */ center; },
/* harmony export */   "bf$": function() { return /* binding */ width; },
/* harmony export */   "bme": function() { return /* binding */ alias; },
/* harmony export */   "bu0": function() { return /* binding */ outlineWidth; },
/* harmony export */   "c4c": function() { return /* binding */ flexStart; },
/* harmony export */   "cOP": function() { return /* binding */ directSibling; },
/* harmony export */   "cSb": function() { return /* binding */ empty; },
/* harmony export */   "cYj": function() { return /* binding */ pxFloat; },
/* harmony export */   "ceD": function() { return /* binding */ $$double; },
/* harmony export */   "ch": function() { return /* binding */ ch; },
/* harmony export */   "cm": function() { return /* binding */ cm; },
/* harmony export */   "cod": function() { return /* binding */ gridColumnEnd; },
/* harmony export */   "cq$": function() { return /* binding */ alignItems; },
/* harmony export */   "cx$": function() { return /* binding */ pointer; },
/* harmony export */   "d73": function() { return /* binding */ auto; },
/* harmony export */   "d8w": function() { return /* binding */ whiteSpace; },
/* harmony export */   "dZD": function() { return /* binding */ animationPlayState; },
/* harmony export */   "dkg": function() { return /* binding */ $$super; },
/* harmony export */   "dpJ": function() { return /* binding */ size; },
/* harmony export */   "dxT": function() { return /* binding */ outlineColor; },
/* harmony export */   "dxy": function() { return /* binding */ siblings; },
/* harmony export */   "dy0": function() { return /* binding */ stretch; },
/* harmony export */   "e$I": function() { return /* binding */ columnGap; },
/* harmony export */   "e4p": function() { return /* binding */ after; },
/* harmony export */   "e6$": function() { return /* binding */ margin; },
/* harmony export */   "eCg": function() { return /* binding */ grid; },
/* harmony export */   "eCr": function() { return /* binding */ underline; },
/* harmony export */   "eEk": function() { return /* binding */ verticalText; },
/* harmony export */   "eIe": function() { return /* binding */ scope; },
/* harmony export */   "eNo": function() { return /* binding */ Nth; },
/* harmony export */   "eRF": function() { return /* binding */ textBottom; },
/* harmony export */   "eRy": function() { return /* binding */ transition; },
/* harmony export */   "eUF": function() { return /* binding */ ewResize; },
/* harmony export */   "eYb": function() { return /* binding */ justifyItems; },
/* harmony export */   "eZH": function() { return /* binding */ scaleX; },
/* harmony export */   "ec_": function() { return /* binding */ checked; },
/* harmony export */   "efO": function() { return /* binding */ important; },
/* harmony export */   "em": function() { return /* binding */ em; },
/* harmony export */   "epG": function() { return /* binding */ $$var; },
/* harmony export */   "er3": function() { return /* binding */ rotate3d; },
/* harmony export */   "ex": function() { return /* binding */ ex; },
/* harmony export */   "exU": function() { return /* binding */ viewBox; },
/* harmony export */   "ezj": function() { return /* binding */ backgroundOrigin; },
/* harmony export */   "f6n": function() { return /* binding */ lighter; },
/* harmony export */   "f7d": function() { return /* binding */ neResize; },
/* harmony export */   "fA7": function() { return /* binding */ target; },
/* harmony export */   "fCW": function() { return /* binding */ borderTopWidth; },
/* harmony export */   "fD_": function() { return /* binding */ gridArea; },
/* harmony export */   "fFX": function() { return /* binding */ allScroll; },
/* harmony export */   "fHD": function() { return /* binding */ spaceBetween; },
/* harmony export */   "fLW": function() { return /* binding */ text$1; },
/* harmony export */   "fLi": function() { return /* binding */ contentBox; },
/* harmony export */   "fT5": function() { return /* binding */ bolder; },
/* harmony export */   "fUN": function() { return /* binding */ flex; },
/* harmony export */   "fXf": function() { return /* binding */ objectFit; },
/* harmony export */   "fr": function() { return /* binding */ fr; },
/* harmony export */   "ftw": function() { return /* binding */ dotted; },
/* harmony export */   "fwF": function() { return /* binding */ Animation; },
/* harmony export */   "fxJ": function() { return /* binding */ minContent; },
/* harmony export */   "g7Q": function() { return /* binding */ wrapReverse; },
/* harmony export */   "gB9": function() { return /* binding */ stepEnd; },
/* harmony export */   "ga_": function() { return /* binding */ counterIncrement; },
/* harmony export */   "giC": function() { return /* binding */ butt; },
/* harmony export */   "gr0": function() { return /* binding */ perspectiveOrigin; },
/* harmony export */   "h$9": function() { return /* binding */ borderBottom; },
/* harmony export */   "h52": function() { return /* binding */ textIndent; },
/* harmony export */   "h62": function() { return /* binding */ square; },
/* harmony export */   "h9x": function() { return /* binding */ margin2; },
/* harmony export */   "hGO": function() { return /* binding */ localUrl; },
/* harmony export */   "hHJ": function() { return /* binding */ spaceAround; },
/* harmony export */   "hJp": function() { return /* binding */ borderSpacing; },
/* harmony export */   "hOB": function() { return /* binding */ rem; },
/* harmony export */   "hR4": function() { return /* binding */ translateZ; },
/* harmony export */   "hXT": function() { return /* binding */ filter; },
/* harmony export */   "hdZ": function() { return /* binding */ pct; },
/* harmony export */   "hlL": function() { return /* binding */ fill$1; },
/* harmony export */   "ho7": function() { return /* binding */ host; },
/* harmony export */   "hrh": function() { return /* binding */ textDecorationColor; },
/* harmony export */   "i16": function() { return /* binding */ firstLetter; },
/* harmony export */   "i36": function() { return /* binding */ panX; },
/* harmony export */   "i4v": function() { return /* binding */ flexShrink; },
/* harmony export */   "iUc": function() { return /* binding */ child; },
/* harmony export */   "iWO": function() { return /* binding */ translateY; },
/* harmony export */   "ibC": function() { return /* binding */ tableColumn; },
/* harmony export */   "ihZ": function() { return /* binding */ minWidth; },
/* harmony export */   "ihe": function() { return /* binding */ outOfRange; },
/* harmony export */   "isX": function() { return /* binding */ spaceEvenly; },
/* harmony export */   "iu7": function() { return /* binding */ borderBox; },
/* harmony export */   "ixg": function() { return /* binding */ boxSizing; },
/* harmony export */   "j1L": function() { return /* binding */ borderTop; },
/* harmony export */   "j96": function() { return /* binding */ baseline; },
/* harmony export */   "jIM": function() { return /* binding */ rotateZ; },
/* harmony export */   "jK5": function() { return /* binding */ contentRules; },
/* harmony export */   "jLD": function() { return /* binding */ lineThrough; },
/* harmony export */   "jSQ": function() { return /* binding */ overscrollBehavior; },
/* harmony export */   "jXB": function() { return /* binding */ Shadow; },
/* harmony export */   "jZR": function() { return /* binding */ listStyleType; },
/* harmony export */   "jc2": function() { return /* binding */ smallCaps; },
/* harmony export */   "jfB": function() { return /* binding */ display; },
/* harmony export */   "jsT": function() { return /* binding */ notAllowed; },
/* harmony export */   "jtO": function() { return /* binding */ optional; },
/* harmony export */   "jw4": function() { return /* binding */ minHeight; },
/* harmony export */   "k$v": function() { return /* binding */ breakAll; },
/* harmony export */   "k0m": function() { return /* binding */ backgroundPosition; },
/* harmony export */   "kC2": function() { return /* binding */ capitalize; },
/* harmony export */   "kCL": function() { return /* binding */ maxHeight; },
/* harmony export */   "kQN": function() { return /* binding */ content; },
/* harmony export */   "kZi": function() { return /* binding */ breakWord; },
/* harmony export */   "k_P": function() { return /* binding */ repeatingLinearGradient; },
/* harmony export */   "kkJ": function() { return /* binding */ pointerEvents; },
/* harmony export */   "kkr": function() { return /* binding */ maxWidth; },
/* harmony export */   "krI": function() { return /* binding */ zoomIn; },
/* harmony export */   "lEu": function() { return /* binding */ animationDelay; },
/* harmony export */   "lM7": function() { return /* binding */ wordBreak; },
/* harmony export */   "lMS": function() { return /* binding */ rotateX; },
/* harmony export */   "lpz": function() { return /* binding */ gridRowStart; },
/* harmony export */   "luU": function() { return /* binding */ sub; },
/* harmony export */   "m4f": function() { return /* binding */ rgba; },
/* harmony export */   "m6$": function() { return /* binding */ ltr; },
/* harmony export */   "m8E": function() { return /* binding */ marginBox; },
/* harmony export */   "mJl": function() { return /* binding */ normal; },
/* harmony export */   "mUE": function() { return /* binding */ firstChild; },
/* harmony export */   "mZN": function() { return /* binding */ easeInOut; },
/* harmony export */   "mm": function() { return /* binding */ mm; },
/* harmony export */   "mvd": function() { return /* binding */ keepAll; },
/* harmony export */   "mvv": function() { return /* binding */ ease; },
/* harmony export */   "mwL": function() { return /* binding */ miter; },
/* harmony export */   "nKF": function() { return /* binding */ counterSet; },
/* harmony export */   "nLE": function() { return /* binding */ backdropFilter; },
/* harmony export */   "nVE": function() { return /* binding */ transitionDuration; },
/* harmony export */   "nZE": function() { return /* binding */ selector; },
/* harmony export */   "n_e": function() { return /* binding */ transitionProperty; },
/* harmony export */   "na1": function() { return /* binding */ nResize; },
/* harmony export */   "ncr": function() { return /* binding */ extraLight; },
/* harmony export */   "njC": function() { return /* binding */ borderLeftStyle; },
/* harmony export */   "nnL": function() { return /* binding */ initial; },
/* harmony export */   "o3D": function() { return /* binding */ padding; },
/* harmony export */   "o4w": function() { return /* binding */ cell; },
/* harmony export */   "o6J": function() { return /* binding */ clipPath; },
/* harmony export */   "o7V": function() { return /* binding */ direction; },
/* harmony export */   "oIA": function() { return /* binding */ marginLeft; },
/* harmony export */   "oIx": function() { return /* binding */ gridRow; },
/* harmony export */   "oJs": function() { return /* binding */ rowResize; },
/* harmony export */   "oPT": function() { return /* binding */ visible; },
/* harmony export */   "oQ4": function() { return /* binding */ animation; },
/* harmony export */   "oXI": function() { return /* binding */ infinite; },
/* harmony export */   "obx": function() { return /* binding */ borderCollapse; },
/* harmony export */   "ocY": function() { return /* binding */ cursor; },
/* harmony export */   "odA": function() { return /* binding */ paddingTop; },
/* harmony export */   "oqW": function() { return /* binding */ clip; },
/* harmony export */   "orU": function() { return /* binding */ borderTopLeftRadius; },
/* harmony export */   "otN": function() { return /* binding */ maskPositions; },
/* harmony export */   "p$S": function() { return /* binding */ numIdent; },
/* harmony export */   "p22": function() { return /* binding */ transformOrigin; },
/* harmony export */   "p3g": function() { return /* binding */ scaleZ; },
/* harmony export */   "p4m": function() { return /* binding */ link; },
/* harmony export */   "pBE": function() { return /* binding */ transitions; },
/* harmony export */   "pBW": function() { return /* binding */ move; },
/* harmony export */   "pIy": function() { return /* binding */ children; },
/* harmony export */   "pMI": function() { return /* binding */ repeatX; },
/* harmony export */   "pU1": function() { return /* binding */ overflowY; },
/* harmony export */   "pUw": function() { return /* binding */ italic; },
/* harmony export */   "p_N": function() { return /* binding */ fontStyle; },
/* harmony export */   "poq": function() { return /* binding */ rowReverse; },
/* harmony export */   "pt": function() { return /* binding */ pt; },
/* harmony export */   "px": function() { return /* binding */ px; },
/* harmony export */   "qJL": function() { return /* binding */ wordSpacing; },
/* harmony export */   "qbe": function() { return /* binding */ listItem; },
/* harmony export */   "qtZ": function() { return /* binding */ borderBottomStyle; },
/* harmony export */   "qtd": function() { return /* binding */ readOnly; },
/* harmony export */   "rHv": function() { return /* binding */ $$default; },
/* harmony export */   "rXp": function() { return /* binding */ letterSpacing; },
/* harmony export */   "reQ": function() { return /* binding */ wrap; },
/* harmony export */   "rfy": function() { return /* binding */ borderBottomRightRadius; },
/* harmony export */   "rif": function() { return /* binding */ defined; },
/* harmony export */   "rjz": function() { return /* binding */ gap2; },
/* harmony export */   "rv2": function() { return /* binding */ paddingLeft; },
/* harmony export */   "rx1": function() { return /* binding */ repeat; },
/* harmony export */   "s2f": function() { return /* binding */ rowGap; },
/* harmony export */   "s8c": function() { return /* binding */ vmax; },
/* harmony export */   "sCq": function() { return /* binding */ scrollBehavior; },
/* harmony export */   "sFT": function() { return /* binding */ animations; },
/* harmony export */   "sc3": function() { return /* binding */ borderLeft; },
/* harmony export */   "sg9": function() { return /* binding */ textShadows; },
/* harmony export */   "sih": function() { return /* binding */ userSelect; },
/* harmony export */   "t$v": function() { return /* binding */ left; },
/* harmony export */   "t0D": function() { return /* binding */ Make; },
/* harmony export */   "t4e": function() { return /* binding */ gridColumn; },
/* harmony export */   "tD0": function() { return /* binding */ paddingBox; },
/* harmony export */   "tPW": function() { return /* binding */ flexBox; },
/* harmony export */   "tPj": function() { return /* binding */ nthLastOfType; },
/* harmony export */   "tac": function() { return /* binding */ maskPosition; },
/* harmony export */   "tgT": function() { return /* binding */ inlineGrid; },
/* harmony export */   "tvt": function() { return /* binding */ borderColor; },
/* harmony export */   "txR": function() { return /* binding */ overflow; },
/* harmony export */   "uDD": function() { return /* binding */ rotateY; },
/* harmony export */   "uGs": function() { return /* binding */ crosshair; },
/* harmony export */   "uTP": function() { return /* binding */ Transition; },
/* harmony export */   "u_l": function() { return /* binding */ focusWithin; },
/* harmony export */   "ub3": function() { return /* binding */ anyLink; },
/* harmony export */   "uhB": function() { return /* binding */ backfaceVisibility; },
/* harmony export */   "uko": function() { return /* binding */ alignSelf; },
/* harmony export */   "ur1": function() { return /* binding */ gridColumnStart; },
/* harmony export */   "uwu": function() { return /* binding */ $$float; },
/* harmony export */   "v03": function() { return /* binding */ vmin; },
/* harmony export */   "v8j": function() { return /* binding */ cover; },
/* harmony export */   "vGG": function() { return /* binding */ zoomOut; },
/* harmony export */   "vPS": function() { return /* binding */ thin; },
/* harmony export */   "vQA": function() { return /* binding */ borderRight; },
/* harmony export */   "vSo": function() { return /* binding */ borderBottomColor; },
/* harmony export */   "vdF": function() { return /* binding */ inlineBlock; },
/* harmony export */   "vh": function() { return /* binding */ vh; },
/* harmony export */   "vmh": function() { return /* binding */ order; },
/* harmony export */   "vo$": function() { return /* binding */ textDecorationStyle; },
/* harmony export */   "voX": function() { return /* binding */ sResize; },
/* harmony export */   "vs": function() { return /* binding */ transform; },
/* harmony export */   "vvq": function() { return /* binding */ nthChild; },
/* harmony export */   "vw": function() { return /* binding */ vw; },
/* harmony export */   "w30": function() { return /* binding */ animationName; },
/* harmony export */   "wCv": function() { return /* binding */ running; },
/* harmony export */   "wXG": function() { return /* binding */ lowercase; },
/* harmony export */   "wey": function() { return /* binding */ top; },
/* harmony export */   "wxz": function() { return /* binding */ firstLine; },
/* harmony export */   "wyN": function() { return /* binding */ animationDuration; },
/* harmony export */   "wyo": function() { return /* binding */ currentColor; },
/* harmony export */   "wzR": function() { return /* binding */ marginRight; },
/* harmony export */   "x2h": function() { return /* binding */ grab; },
/* harmony export */   "xBE": function() { return /* binding */ lastOfType; },
/* harmony export */   "xPo": function() { return /* binding */ listStylePosition; },
/* harmony export */   "xW": function() { return /* binding */ nwseResize; },
/* harmony export */   "xZz": function() { return /* binding */ panLeft; },
/* harmony export */   "xvA": function() { return /* binding */ fontVariant; },
/* harmony export */   "yEL": function() { return /* binding */ repeatY; },
/* harmony export */   "yLU": function() { return /* binding */ tableColumnGroup; },
/* harmony export */   "yOV": function() { return /* binding */ listStyleImage; },
/* harmony export */   "yRn": function() { return /* binding */ ident; },
/* harmony export */   "ybA": function() { return /* binding */ pinchZoom; },
/* harmony export */   "ydu": function() { return /* binding */ textAlign; },
/* harmony export */   "yl7": function() { return /* binding */ marginBottom; },
/* harmony export */   "z2Y": function() { return /* binding */ translate3d; },
/* harmony export */   "z8w": function() { return /* binding */ inlineFlex; },
/* harmony export */   "zCX": function() { return /* binding */ contextMenu; },
/* harmony export */   "zEV": function() { return /* binding */ onlyOfType; },
/* harmony export */   "zIs": function() { return /* binding */ gridTemplateAreas; },
/* harmony export */   "zNf": function() { return /* binding */ unset; },
/* harmony export */   "zT3": function() { return /* binding */ maskImage; },
/* harmony export */   "zZK": function() { return /* binding */ nwResize; },
/* harmony export */   "zoP": function() { return /* binding */ justifySelf; },
/* harmony export */   "zso": function() { return /* binding */ radialGradient; },
/* harmony export */   "zuB": function() { return /* binding */ outlineStyle; },
/* harmony export */   "zyf": function() { return /* binding */ Calc; },
/* harmony export */   "zzh": function() { return /* binding */ overflowX; }
/* harmony export */ });
/* unused harmony exports default, transparent, fontFace */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96533);
/* harmony import */ var _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48891);
// Generated by ReScript, PLEASE EDIT WITH CARE





function ruleToDict(dict, rule) {
    switch(rule.TAG | 0){
        case /* D */ 0:
            var value = rule._1;
            var name = rule._0;
            if (name === "content") {
                dict[name] = value === "" ? '""' : value;
            } else {
                dict[name] = value;
            }
            break;
        case /* S */ 1:
            dict[rule._0] = toJson(rule._1);
            break;
        case /* PseudoClass */ 2:
            dict[":" + rule._0] = toJson(rule._1);
            break;
        case /* PseudoClassParam */ 3:
            dict[":" + (rule._0 + ("(" + (rule._1 + ")")))] = toJson(rule._2);
            break;
    }
    return dict;
}
function toJson(rules) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .reduceU */ .Ox(rules, {}, ruleToDict);
}
function Make(CssImpl) {
    var insertRule = function insertRule(css) {
        CssImpl.injectRaw(css);
    };
    var renderRule = function renderRule(renderer, css) {
        CssImpl.renderRaw(renderer, css);
    };
    var $$global = function $$global(selector, rules) {
        CssImpl.injectRules(selector, toJson(rules));
    };
    var renderGlobal = function renderGlobal(renderer, selector, rules) {
        CssImpl.renderRules(renderer, selector, toJson(rules));
    };
    var style = function style(rules) {
        return CssImpl.make(toJson(rules));
    };
    var merge = function merge(styles) {
        return CssImpl.mergeStyles(styles);
    };
    var merge2 = function merge2(s, s2) {
        return merge([
            s,
            s2
        ]);
    };
    var merge3 = function merge3(s, s2, s3) {
        return merge([
            s,
            s2,
            s3
        ]);
    };
    var merge4 = function merge4(s, s2, s3, s4) {
        return merge([
            s,
            s2,
            s3,
            s4
        ]);
    };
    var framesToDict = function framesToDict(frames) {
        return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .reduceU */ .Ox(frames, {}, function(dict, param) {
            dict[param[0].toString() + "%"] = toJson(param[1]);
            return dict;
        });
    };
    var keyframes = function keyframes(frames) {
        return CssImpl.makeKeyframes(framesToDict(frames));
    };
    var renderKeyframes = function renderKeyframes(renderer, frames) {
        return CssImpl.renderKeyframes(renderer, framesToDict(frames));
    };
    return {
        insertRule: insertRule,
        renderRule: renderRule,
        $$global: $$global,
        renderGlobal: renderGlobal,
        style: style,
        merge: merge,
        merge2: merge2,
        merge3: merge3,
        merge4: merge4,
        keyframes: keyframes,
        renderKeyframes: renderKeyframes
    };
}
function join(strings, separator) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .reduceWithIndexU */ .iK(strings, "", function(acc, item, index) {
        if (index === 0) {
            return item;
        } else {
            return acc + (separator + item);
        }
    });
}
function string_of_content(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Content.toString */ .VY.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.toString */ .ph.toString(x);
    } else if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "url") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x);
    } else if (variant === "counters") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Counters.toString */ .xv.toString(x);
    } else if (variant === "counter") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Counter.toString */ .AT.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Content.toString */ .VY.toString(x);
    }
}
function string_of_counter_increment(x) {
    if (typeof x === "object") {
        if (x.NAME === "increment") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterIncrement.toString */ .fS.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
        }
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterIncrement.toString */ .fS.toString(x);
    }
}
function string_of_counter_reset(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterReset.toString */ .fd.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterReset.toString */ .fd.toString(x);
    }
}
function string_of_counter_set(x) {
    if (typeof x === "object") {
        if (x.NAME === "set") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterSet.toString */ .WJ.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
        }
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CounterSet.toString */ .WJ.toString(x);
    }
}
function string_of_column_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_row_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_position(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_color(x) {
    if (typeof x !== "object") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    }
}
function string_of_dasharray(x) {
    if (typeof x === "object" && x.NAME === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function important(v) {
    if (v.TAG === /* D */ 0) {
        return {
            TAG: /* D */ 0,
            _0: v._0,
            _1: v._1 + " !important"
        };
    } else {
        return v;
    }
}
function label(label$1) {
    return {
        TAG: /* D */ 0,
        _0: "label",
        _1: label$1
    };
}
function alignContent(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignContent",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DistributedAlignment.toString */ .H3.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AlignContent.toString */ .tk.toString(x)
    };
}
function alignItems(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignItems",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" || x === "stretch" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AlignItems.toString */ .g1.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PositionalAlignment.toString */ .F.toString(x)
    };
}
function alignSelf(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignSelf",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PositionalAlignment.toString */ .F.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BaselineAlignment.toString */ .b4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AlignSelf.toString */ .MT.toString(x)
    };
}
function animationDelay(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDelay",
        _1: x.toString() + "ms"
    };
}
function animationDirection(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDirection",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationDirection.toString */ .sc.toString(x)
    };
}
function animationDuration(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDuration",
        _1: x.toString() + "ms"
    };
}
function animationFillMode(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationFillMode",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationFillMode.toString */ .yy.toString(x)
    };
}
function animationIterationCount(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationIterationCount",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationIterationCount.toString */ .qX.toString(x)
    };
}
function animationPlayState(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationPlayState",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationPlayState.toString */ .Lo.toString(x)
    };
}
function animationTimingFunction(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationTimingFunction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.toString */ .Ms.toString(x)
    };
}
function backfaceVisibility(x) {
    return {
        TAG: /* D */ 0,
        _0: "backfaceVisibility",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "visible" || x === "hidden" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackfaceVisibility.toString */ .YO.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function backdropFilter(x) {
    return {
        TAG: /* D */ 0,
        _0: "backdropFilter",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackdropFilter.toString */ .l5.toString), ", ")
    };
}
function backgroundAttachment(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundAttachment",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundAttachment.toString */ .gt.toString(x)
    };
}
function backgroundColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundColor",
        _1: string_of_color(x)
    };
}
function backgroundClip(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundClip",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundClip.toString */ .x6.toString(x)
    };
}
function backgroundImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.toString */ .ph.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundImage.toString */ .Xd.toString(x)
    };
}
function maskImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "maskImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.toString */ .ph.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaskImage.toString */ .TA.toString(x)
    };
}
function backgroundOrigin(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundOrigin",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundOrigin.toString */ .yW.toString(x)
    };
}
function string_of_backgroundposition(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundPosition.toString */ ._S.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    }
    if (variant !== "hv") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
    var match = x.VAL;
    var v = match[1];
    var h = match[0];
    return (typeof h === "object" || h === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(h) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundPosition.X.toString */ ._S.X.toString, h)) + (" " + (typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(v) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundPosition.Y.toString */ ._S.Y.toString, v)));
}
function backgroundPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: string_of_backgroundposition(x)
    };
}
function backgroundPositions(bp) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(bp, string_of_backgroundposition), ", ")
    };
}
function backgroundPosition4(x, offsetX, y, offsetY) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundPosition.X.toString */ ._S.X.toString, x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(offsetX) + (" " + (_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundPosition.Y.toString */ ._S.Y.toString, y) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(offsetY))))))
    };
}
function backgroundRepeat(x) {
    var tmp;
    if (typeof x === "object") {
        if (x.NAME === "hv") {
            var match = x.VAL;
            tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundRepeat.toString */ .W5.toString(match[0]) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundRepeat.toString */ .W5.toString(match[1]));
        } else {
            tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
        }
    } else {
        tmp = x === "repeatY" || x === "repeatX" || x === "repeat" || x === "space" || x === "round" || x === "noRepeat" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BackgroundRepeat.toString */ .W5.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "backgroundRepeat",
        _1: tmp
    };
}
function string_of_maskposition(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaskPosition.toString */ .AG.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    }
    if (variant !== "hv") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
    var match = x.VAL;
    var v = match[1];
    var h = match[0];
    return (typeof h === "object" || h === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(h) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaskPosition.X.toString */ .AG.X.toString, h)) + (" " + (typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(v) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaskPosition.Y.toString */ .AG.Y.toString, v)));
}
function maskPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "maskPosition",
        _1: string_of_maskposition(x)
    };
}
function maskPositions(mp) {
    return {
        TAG: /* D */ 0,
        _0: "maskPosition",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(mp, string_of_maskposition), ", ")
    };
}
function borderBottomColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomColor",
        _1: string_of_color(x)
    };
}
function borderBottomLeftRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomLeftRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderBottomRightRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomRightRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderBottomWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderCollapse(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderCollapse",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BorderCollapse.toString */ .k7.toString(x)
    };
}
function borderColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderColor",
        _1: string_of_color(x)
    };
}
function borderLeftColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftColor",
        _1: string_of_color(x)
    };
}
function borderLeftWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderSpacing(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderSpacing",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderRadius4(topLeft, topRight, bottomLeft, bottomRight) {
    return {
        TAG: /* D */ 0,
        _0: "borderRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(topLeft) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(topRight) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(bottomLeft) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(bottomRight))))))
    };
}
function borderRightColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightColor",
        _1: string_of_color(x)
    };
}
function borderRightWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopColor",
        _1: string_of_color(x)
    };
}
function borderTopLeftRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopLeftRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopRightRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopRightRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function bottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "bottom",
        _1: string_of_position(x)
    };
}
function boxSizing(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxSizing",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BoxSizing.toString */ .LG.toString(x)
    };
}
function clear(x) {
    return {
        TAG: /* D */ 0,
        _0: "clear",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Clear.toString */ .UZ.toString(x)
    };
}
function clipPath(x) {
    return {
        TAG: /* D */ 0,
        _0: "clipPath",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ClipPath.toString */ .IN.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GeometryBox.toString */ .lf.toString(x)
    };
}
function color(x) {
    return {
        TAG: /* D */ 0,
        _0: "color",
        _1: string_of_color(x)
    };
}
function columnCount(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ColumnCount.toString */ .Ex.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ColumnCount.toString */ .Ex.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "columnCount",
        _1: tmp
    };
}
function columnGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "columnGap",
        _1: string_of_column_gap(x)
    };
}
function contentRule(x) {
    return {
        TAG: /* D */ 0,
        _0: "content",
        _1: string_of_content(x)
    };
}
function contentRules(xs) {
    return {
        TAG: /* D */ 0,
        _0: "content",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(xs, string_of_content), " ")
    };
}
function counterIncrement(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterIncrement",
        _1: string_of_counter_increment(x)
    };
}
function countersIncrement(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterIncrement",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(xs, string_of_counter_increment), " ")
    };
}
function counterReset(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterReset",
        _1: string_of_counter_reset(x)
    };
}
function countersReset(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterReset",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(xs, string_of_counter_reset), " ")
    };
}
function counterSet(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterSet",
        _1: string_of_counter_set(x)
    };
}
function countersSet(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterSet",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(xs, string_of_counter_set), " ")
    };
}
function cursor(x) {
    return {
        TAG: /* D */ 0,
        _0: "cursor",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.toString */ .CF.toString(x)
    };
}
function direction(x) {
    return {
        TAG: /* D */ 0,
        _0: "direction",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "rtl" || x === "ltr" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Direction.toString */ .Nm.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function display(x) {
    return {
        TAG: /* D */ 0,
        _0: "display",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "table" || x === "grid" || x === "flex" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayInside.toString */ .au.toString(x) : x === "contents" || x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayBox.toString */ .HD.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "inlineGrid" || x === "inlineFlex" || x === "inlineBlock" || x === "inlineTable" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayLegacy.toString */ .v7.toString(x) : x === "block" || x === "inline" || x === "runIn" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayOutside.toString */ .bv.toString(x) : x === "listItem" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayListItem.toString */ .cA.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DisplayInternal.toString */ .rY.toString(x)
    };
}
function flex(x) {
    return {
        TAG: /* D */ 0,
        _0: "flex",
        _1: typeof x === "object" ? x.VAL.toString() : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Flex.toString */ .kC.toString(x)
    };
}
function flexDirection(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexDirection",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FlexDirection.toString */ .Qb.toString(x)
    };
}
function flexGrow(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexGrow",
        _1: x.toString()
    };
}
function flexShrink(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexShrink",
        _1: x.toString()
    };
}
function flexWrap(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexWrap",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "nowrap" || x === "wrapReverse" || x === "wrap" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FlexWrap.toString */ .gP.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function $$float(x) {
    return {
        TAG: /* D */ 0,
        _0: "float",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Float.toString */ .V4.toString(x)
    };
}
function fontFamily(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontFamily",
        _1: typeof x === "object" ? x.NAME === "custom" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontFamilyName.toString */ .NB.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontFamilyName.toString */ .NB.toString(x)
    };
}
function fontFamilies(xs) {
    return {
        TAG: /* D */ 0,
        _0: "fontFamily",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(xs, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontFamilyName.toString */ .NB.toString), ", ")
    };
}
function fontSize(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "fontSize",
        _1: tmp
    };
}
function fontStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "normal" || x === "oblique" || x === "italic" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontStyle.toString */ .Hd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function fontVariant(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontVariant",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "normal" || x === "smallCaps" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontVariant.toString */ .HS.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function fontWeight(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontWeight",
        _1: typeof x === "object" ? x.NAME === "num" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.toString */ .U9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.toString */ .U9.toString(x)
    };
}
function gridAutoFlow(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoFlow",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridAutoFlow.toString */ .gC.toString(x)
    };
}
function gridColumn(start, end$p) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumn",
        _1: start.toString() + (" / " + end$p.toString())
    };
}
function gridColumnGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnGap",
        _1: string_of_column_gap(x)
    };
}
function gridColumnStart(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnStart",
        _1: n.toString()
    };
}
function gridColumnEnd(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnEnd",
        _1: n.toString()
    };
}
function gridRow(start, end$p) {
    return {
        TAG: /* D */ 0,
        _0: "gridRow",
        _1: start.toString() + (" / " + end$p.toString())
    };
}
function gap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gap",
        _1: string_of_gap(x)
    };
}
function gridGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridGap",
        _1: string_of_gap(x)
    };
}
function gap2(rowGap, columnGap) {
    return {
        TAG: /* D */ 0,
        _0: "gap",
        _1: string_of_gap(rowGap) + (" " + string_of_gap(columnGap))
    };
}
function rowGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "rowGap",
        _1: string_of_row_gap(x)
    };
}
function gridRowGap(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "gridRowGap",
        _1: tmp
    };
}
function gridRowEnd(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridRowEnd",
        _1: n.toString()
    };
}
function gridRowStart(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridRowStart",
        _1: n.toString()
    };
}
function height(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "height",
        _1: tmp
    };
}
function justifyContent(x) {
    return {
        TAG: /* D */ 0,
        _0: "justifyContent",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .DistributedAlignment.toString */ .H3.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PositionalAlignment.toString */ .F.toString(x)
    };
}
function justifyItems(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OverflowAlignment.toString */ .rL.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "legacyRight" || x === "legacy" || x === "legacyLeft" || x === "legacyCenter" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .LegacyAlignment.toString */ .gg.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PositionalAlignment.toString */ .F.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "justifyItems",
        _1: tmp
    };
}
function left(x) {
    return {
        TAG: /* D */ 0,
        _0: "left",
        _1: string_of_position(x)
    };
}
function letterSpacing(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .LetterSpacing.toString */ .LK.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "letterSpacing",
        _1: tmp
    };
}
function lineHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "abs" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .LineHeight.toString */ .L3.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .LineHeight.toString */ .L3.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "lineHeight",
        _1: tmp
    };
}
function listStyle(style, position, image) {
    return {
        TAG: /* D */ 0,
        _0: "listStyle",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStyleType.toString */ .LE.toString(style) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStylePosition.toString */ .t.toString(position) + (" " + (typeof image === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(image) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStyleImage.toString */ .NP.toString(image)))))
    };
}
function listStyleImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStyleImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStyleImage.toString */ .NP.toString(x)
    };
}
function listStyleType(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStyleType",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStyleType.toString */ .LE.toString(x)
    };
}
function listStylePosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStylePosition",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "inside" || x === "outside" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ListStylePosition.toString */ .t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function marginToString(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Margin.toString */ .Zt.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    }
}
function margin(x) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(x)
    };
}
function margin2(v, h) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(v) + (" " + marginToString(h))
    };
}
function margin3(top, h, bottom) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(top) + (" " + (marginToString(h) + (" " + marginToString(bottom))))
    };
}
function margin4(top, right, bottom, left) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(top) + (" " + (marginToString(right) + (" " + (marginToString(bottom) + (" " + marginToString(left))))))
    };
}
function marginLeft(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginLeft",
        _1: marginToString(x)
    };
}
function marginRight(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginRight",
        _1: marginToString(x)
    };
}
function marginTop(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginTop",
        _1: marginToString(x)
    };
}
function marginBottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginBottom",
        _1: marginToString(x)
    };
}
function maxHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaxHeight.toString */ .En.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "maxHeight",
        _1: tmp
    };
}
function maxWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MaxWidth.toString */ .Pm.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "maxWidth",
        _1: tmp
    };
}
function minHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MinHeight.toString */ .z6.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "minHeight",
        _1: tmp
    };
}
function minWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .MinWidth.toString */ .O$.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "minWidth",
        _1: tmp
    };
}
function objectFit(x) {
    return {
        TAG: /* D */ 0,
        _0: "objectFit",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ObjectFit.toString */ .h$.toString(x)
    };
}
function objectPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "objectPosition",
        _1: string_of_backgroundposition(x)
    };
}
function opacity(x) {
    return {
        TAG: /* D */ 0,
        _0: "opacity",
        _1: x.toString()
    };
}
function outline(size, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "outline",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(size) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OutlineStyle.toString */ ._5.toString(style) + (" " + string_of_color(color))))
    };
}
function outlineColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineColor",
        _1: string_of_color(x)
    };
}
function outlineOffset(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineOffset",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function outlineStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineStyle",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OutlineStyle.toString */ ._5.toString(x)
    };
}
function outlineWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function overflow(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflow",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowX(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowX",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowY(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowY",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowWrap(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowWrap",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "breakWord" || x === "anywhere" || x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OverflowWrap.toString */ .mn.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function padding(x) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function padding2(v, h) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(v) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(h))
    };
}
function padding3(top, h, bottom) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(top) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(h) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(bottom))))
    };
}
function padding4(top, right, bottom, left) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(top) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(right) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(bottom) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(left))))))
    };
}
function paddingBottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingBottom",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingLeft(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingLeft",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingRight(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingRight",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingTop(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingTop",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function perspective(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Perspective.toString */ .XS.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "perspective",
        _1: tmp
    };
}
function perspectiveOrigin(x, y) {
    return {
        TAG: /* D */ 0,
        _0: "perspectiveOrigin",
        _1: (typeof x === "object" || x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Perspective.toString */ .XS.toString(x)) + (" " + (typeof y === "object" || y === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(y) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Perspective.toString */ .XS.toString(y)))
    };
}
function pointerEvents(x) {
    return {
        TAG: /* D */ 0,
        _0: "pointerEvents",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PointerEvents.toString */ .Ox.toString(x)
    };
}
function position(x) {
    return {
        TAG: /* D */ 0,
        _0: "position",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Position.toString */ .Ly.toString(x)
    };
}
function isolation(x) {
    return {
        TAG: /* D */ 0,
        _0: "isolation",
        _1: x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Isolation.toString */ .UM.toString(x)
    };
}
function justifySelf(x) {
    return {
        TAG: /* D */ 0,
        _0: "justifySelf",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .PositionalAlignment.toString */ .F.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BaselineAlignment.toString */ .b4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .JustifySelf.toString */ .lo.toString(x)
    };
}
function resize(x) {
    return {
        TAG: /* D */ 0,
        _0: "resize",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Resize.toString */ .t$.toString(x)
    };
}
function right(x) {
    return {
        TAG: /* D */ 0,
        _0: "right",
        _1: string_of_position(x)
    };
}
function tableLayout(x) {
    return {
        TAG: /* D */ 0,
        _0: "tableLayout",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TableLayout.toString */ .df.toString(x)
    };
}
function textAlign(x) {
    return {
        TAG: /* D */ 0,
        _0: "textAlign",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextAlign.toString */ .PH.toString(x)
    };
}
function textDecorationColor(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "textDecorationColor",
        _1: tmp
    };
}
function textDecorationLine(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecorationLine",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextDecorationLine.toString */ .BF.toString(x)
    };
}
function textDecorationStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecorationStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "double" || x === "dotted" || x === "dashed" || x === "solid" || x === "wavy" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextDecorationStyle.toString */ .X4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function textIndent(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "textIndent",
        _1: tmp
    };
}
function textOverflow(x) {
    return {
        TAG: /* D */ 0,
        _0: "textOverflow",
        _1: typeof x === "object" ? x.NAME === "string" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextOverflow.toString */ .lG.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextOverflow.toString */ .lG.toString(x)
    };
}
function textTransform(x) {
    return {
        TAG: /* D */ 0,
        _0: "textTransform",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TextTransform.toString */ .ty.toString(x)
    };
}
function top(x) {
    return {
        TAG: /* D */ 0,
        _0: "top",
        _1: string_of_position(x)
    };
}
function transform(x) {
    return {
        TAG: /* D */ 0,
        _0: "transform",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.toString */ .wx.toString(x) : "none"
    };
}
function transforms(x) {
    return {
        TAG: /* D */ 0,
        _0: "transform",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.toString */ .wx.toString), " ")
    };
}
function transformOrigin(x, y) {
    return {
        TAG: /* D */ 0,
        _0: "transformOrigin",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(y))
    };
}
function transformOrigin3d(x, y, z) {
    return {
        TAG: /* D */ 0,
        _0: "transformOrigin",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(y) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(z) + " "))))
    };
}
function unsafe(property, value) {
    return {
        TAG: /* D */ 0,
        _0: property,
        _1: value
    };
}
function userSelect(x) {
    return {
        TAG: /* D */ 0,
        _0: "userSelect",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .UserSelect.toString */ .oF.toString(x)
    };
}
function verticalAlign(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "textTop" || x === "textBottom" || x === "baseline" || x === "super" || x === "top" || x === "sub" || x === "bottom" || x === "middle" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .VerticalAlign.toString */ .g$.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "verticalAlign",
        _1: tmp
    };
}
function visibility(x) {
    return {
        TAG: /* D */ 0,
        _0: "visibility",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Visibility.toString */ .EE.toString(x)
    };
}
function scrollBehavior(x) {
    return {
        TAG: /* D */ 0,
        _0: "scrollBehavior",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ScrollBehavior.toString */ .JT.toString(x)
    };
}
function overscrollBehavior(x) {
    return {
        TAG: /* D */ 0,
        _0: "overscrollBehavior",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OverscrollBehavior.toString */ .CB.toString(x)
    };
}
function overflowAnchor(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowAnchor",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .OverflowAnchor.toString */ .s2.toString(x)
    };
}
function columnWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .ColumnWidth.toString */ .aB.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "columnWidth",
        _1: tmp
    };
}
function caretColor(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .CaretColor.toString */ .vC.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "caretColor",
        _1: tmp
    };
}
function width(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "width",
        _1: tmp
    };
}
function whiteSpace(x) {
    return {
        TAG: /* D */ 0,
        _0: "whiteSpace",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "nowrap" || x === "normal" || x === "breakSpaces" || x === "preWrap" || x === "preLine" || x === "pre" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .WhiteSpace.toString */ .nZ.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function wordBreak(x) {
    return {
        TAG: /* D */ 0,
        _0: "wordBreak",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "keepAll" || x === "normal" || x === "breakAll" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .WordBreak.toString */ .I5.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x)
    };
}
function wordSpacing(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .WordSpacing.toString */ .qb.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "wordSpacing",
        _1: tmp
    };
}
function zIndex(x) {
    return {
        TAG: /* D */ 0,
        _0: "zIndex",
        _1: x.toString()
    };
}
function media(query, rules) {
    return {
        TAG: /* S */ 1,
        _0: "@media " + query,
        _1: rules
    };
}
function selector(selector$1, rules) {
    return {
        TAG: /* S */ 1,
        _0: selector$1,
        _1: rules
    };
}
function active(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "active",
        _1: param
    };
}
function checked(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "checked",
        _1: param
    };
}
function $$default(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "default",
        _1: param
    };
}
function defined(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "defined",
        _1: param
    };
}
function disabled(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "disabled",
        _1: param
    };
}
function empty(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "empty",
        _1: param
    };
}
function enabled(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "enabled",
        _1: param
    };
}
function first(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first",
        _1: param
    };
}
function firstChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first-child",
        _1: param
    };
}
function firstOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first-of-type",
        _1: param
    };
}
function focus(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus",
        _1: param
    };
}
function focusVisible(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus-visible",
        _1: param
    };
}
function focusWithin(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus-within",
        _1: param
    };
}
function host(selector, rules) {
    if (selector !== undefined) {
        return {
            TAG: /* PseudoClassParam */ 3,
            _0: "host",
            _1: selector,
            _2: rules
        };
    } else {
        return {
            TAG: /* PseudoClass */ 2,
            _0: "host",
            _1: rules
        };
    }
}
function hover(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "hover",
        _1: param
    };
}
function indeterminate(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "indeterminate",
        _1: param
    };
}
function inRange(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "in-range",
        _1: param
    };
}
function invalid(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "invalid",
        _1: param
    };
}
function lang(code, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "lang",
        _1: code,
        _2: rules
    };
}
function lastChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "last-child",
        _1: param
    };
}
function lastOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "last-of-type",
        _1: param
    };
}
function link(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "link",
        _1: param
    };
}
function not_(selector, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "not",
        _1: selector,
        _2: rules
    };
}
function toString(x) {
    if (typeof x !== "object") {
        if (x === "odd") {
            return "odd";
        } else {
            return "even";
        }
    }
    if (x.NAME !== "add") {
        return x.VAL.toString() + "n";
    }
    var match = x.VAL;
    return match[0].toString() + ("n+" + match[1].toString());
}
var Nth = {
    toString: toString
};
function nthChild(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-child",
        _1: toString(x),
        _2: rules
    };
}
function nthLastChild(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-last-child",
        _1: toString(x),
        _2: rules
    };
}
function nthLastOfType(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-last-of-type",
        _1: toString(x),
        _2: rules
    };
}
function nthOfType(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-of-type",
        _1: toString(x),
        _2: rules
    };
}
function onlyChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "only-child",
        _1: param
    };
}
function onlyOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "only-of-type",
        _1: param
    };
}
function optional(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "optional",
        _1: param
    };
}
function outOfRange(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "out-of-range",
        _1: param
    };
}
function readOnly(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "read-only",
        _1: param
    };
}
function readWrite(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "read-write",
        _1: param
    };
}
function required(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "required",
        _1: param
    };
}
function root(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "root",
        _1: param
    };
}
function scope(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "scope",
        _1: param
    };
}
function target(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "target",
        _1: param
    };
}
function valid(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "valid",
        _1: param
    };
}
function visited(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "visited",
        _1: param
    };
}
function after(__x) {
    return selector("::after", __x);
}
function before(__x) {
    return selector("::before", __x);
}
function firstLetter(__x) {
    return selector("::first-letter", __x);
}
function firstLine(__x) {
    return selector("::first-line", __x);
}
function selection(__x) {
    return selector("::selection", __x);
}
function child(x, __x) {
    return selector(" > " + x, __x);
}
function children(__x) {
    return selector(" > *", __x);
}
function directSibling(__x) {
    return selector(" + ", __x);
}
function placeholder(__x) {
    return selector("::placeholder", __x);
}
function siblings(__x) {
    return selector(" ~ ", __x);
}
function anyLink(__x) {
    return selector(":any-link", __x);
}
var initial = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.initial */ .x9.initial;
var inherit_ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.inherit_ */ .x9.inherit_;
var unset = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.unset */ .x9.unset;
var $$var = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.$$var */ .nd.$$var;
var varDefault = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.varDefault */ .nd.varDefault;
var pct = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Percentage.pct */ .$t.pct;
var ch = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.ch */ .Gy.ch;
var cm = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.cm */ .Gy.cm;
var em = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.em */ .Gy.em;
var ex = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.ex */ .Gy.ex;
var mm = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.mm */ .Gy.mm;
var pt = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.pt */ .Gy.pt;
var px = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.px */ .Gy.px;
var pxFloat = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.pxFloat */ .Gy.pxFloat;
var rem = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.rem */ .Gy.rem;
var vh = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.vh */ .Gy.vh;
var vmin = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.vmin */ .Gy.vmin;
var vmax = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.vmax */ .Gy.vmax;
var zero = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.zero */ .Gy.zero;
var deg = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Angle.deg */ .RZ.deg;
var rad = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Angle.rad */ .RZ.rad;
var grad = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Angle.grad */ .RZ.grad;
var turn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Angle.turn */ .RZ.turn;
var ltr = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Direction.ltr */ .Nm.ltr;
var rtl = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Direction.rtl */ .Nm.rtl;
var absolute = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Position.absolute */ .Ly.absolute;
var relative = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Position.relative */ .Ly.relative;
var $$static = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Position.$$static */ .Ly.$$static;
var sticky = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Position.sticky */ .Ly.sticky;
var horizontal = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Resize.horizontal */ .t$.horizontal;
var vertical = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Resize.vertical */ .t$.vertical;
var smallCaps = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontVariant.smallCaps */ .HS.smallCaps;
var italic = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontStyle.italic */ .Hd.italic;
var oblique = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontStyle.oblique */ .Hd.oblique;
var rgb = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.rgb */ .Il.rgb;
var rgba = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.rgba */ .Il.rgba;
var hsl = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hsl */ .Il.hsl;
var hsla = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hsla */ .Il.hsla;
var hex = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.hex */ .Il.hex;
var currentColor = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.currentColor */ .Il.currentColor;
var transparent = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.transparent */ .Il.transparent;
var linear = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.linear */ .Ms.linear;
var ease = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.ease */ .Ms.ease;
var easeIn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.easeIn */ .Ms.easeIn;
var easeInOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.easeInOut */ .Ms.easeInOut;
var easeOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.easeOut */ .Ms.easeOut;
var stepStart = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.stepStart */ .Ms.stepStart;
var stepEnd = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.stepEnd */ .Ms.stepEnd;
var steps = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.steps */ .Ms.steps;
var cubicBezier = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.cubicBezier */ .Ms.cubicBezier;
var marginBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GeometryBox.marginBox */ .lf.marginBox;
var fillBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GeometryBox.fillBox */ .lf.fillBox;
var strokeBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GeometryBox.strokeBox */ .lf.strokeBox;
var viewBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GeometryBox.viewBox */ .lf.viewBox;
var translate = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.translate */ .wx.translate;
var translate3d = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.translate3d */ .wx.translate3d;
var translateX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.translateX */ .wx.translateX;
var translateY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.translateY */ .wx.translateY;
var translateZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.translateZ */ .wx.translateZ;
var scaleX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.scaleX */ .wx.scaleX;
var scaleY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.scaleY */ .wx.scaleY;
var scaleZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.scaleZ */ .wx.scaleZ;
var rotateX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.rotateX */ .wx.rotateX;
var rotateY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.rotateY */ .wx.rotateY;
var rotateZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.rotateZ */ .wx.rotateZ;
var scale = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.scale */ .wx.scale;
var scale3d = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.scale3d */ .wx.scale3d;
var skew = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.skew */ .wx.skew;
var skewX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.skewX */ .wx.skewX;
var skewY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Transform.skewY */ .wx.skewY;
var thin = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.thin */ .U9.thin;
var extraLight = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.extraLight */ .U9.extraLight;
var light = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.light */ .U9.light;
var medium = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.medium */ .U9.medium;
var semiBold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.semiBold */ .U9.semiBold;
var bold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.bold */ .U9.bold;
var extraBold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.extraBold */ .U9.extraBold;
var lighter = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.lighter */ .U9.lighter;
var bolder = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.bolder */ .U9.bolder;
var linearGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.linearGradient */ .ph.linearGradient;
var repeatingLinearGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.repeatingLinearGradient */ .ph.repeatingLinearGradient;
var radialGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.radialGradient */ .ph.radialGradient;
var repeatingRadialGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.repeatingRadialGradient */ .ph.repeatingRadialGradient;
var conicGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.conicGradient */ .ph.conicGradient;
var areas = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridTemplateAreas.areas */ .$7.areas;
var ident = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.ident */ .y5.ident;
var numIdent = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.numIdent */ .y5.numIdent;
var contextMenu = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.contextMenu */ .CF.contextMenu;
var help = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.help */ .CF.help;
var pointer = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.pointer */ .CF.pointer;
var progress = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.progress */ .CF.progress;
var wait = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.wait */ .CF.wait;
var cell = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.cell */ .CF.cell;
var crosshair = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.crosshair */ .CF.crosshair;
var verticalText = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.verticalText */ .CF.verticalText;
var alias = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.alias */ .CF.alias;
var copy = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.copy */ .CF.copy;
var move = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.move */ .CF.move;
var noDrop = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.noDrop */ .CF.noDrop;
var notAllowed = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.notAllowed */ .CF.notAllowed;
var grab = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.grab */ .CF.grab;
var grabbing = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.grabbing */ .CF.grabbing;
var allScroll = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.allScroll */ .CF.allScroll;
var colResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.colResize */ .CF.colResize;
var rowResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.rowResize */ .CF.rowResize;
var nResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.nResize */ .CF.nResize;
var eResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.eResize */ .CF.eResize;
var sResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.sResize */ .CF.sResize;
var wResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.wResize */ .CF.wResize;
var neResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.neResize */ .CF.neResize;
var nwResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.nwResize */ .CF.nwResize;
var seResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.seResize */ .CF.seResize;
var swResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.swResize */ .CF.swResize;
var ewResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.ewResize */ .CF.ewResize;
var nsResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.nsResize */ .CF.nsResize;
var neswResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.neswResize */ .CF.neswResize;
var nwseResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.nwseResize */ .CF.nwseResize;
var zoomIn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.zoomIn */ .CF.zoomIn;
var zoomOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cursor.zoomOut */ .CF.zoomOut;
function vw(x) {
    return {
        NAME: "vw",
        VAL: x
    };
}
function fr(x) {
    return {
        NAME: "fr",
        VAL: x
    };
}
function $neg(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "sub",
            a,
            b
        ]
    };
}
function $plus(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "add",
            a,
            b
        ]
    };
}
function $star(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "mult",
            a,
            b
        ]
    };
}
var Calc = {
    $neg: $neg,
    $plus: $plus,
    $star: $star
};
function size(x, y) {
    return {
        NAME: "size",
        VAL: [
            x,
            y
        ]
    };
}
function count(x) {
    return {
        NAME: "count",
        VAL: x
    };
}
function localUrl(x) {
    return {
        NAME: "localUrl",
        VAL: x
    };
}
function rotate(a) {
    return {
        NAME: "rotate",
        VAL: a
    };
}
function rotate3d(x, y, z, a) {
    return {
        NAME: "rotate3d",
        VAL: [
            x,
            y,
            z,
            a
        ]
    };
}
function url(x) {
    return {
        NAME: "url",
        VAL: x
    };
}
function flex3(grow, shrink, basis) {
    return {
        TAG: /* D */ 0,
        _0: "flex",
        _1: grow.toString() + (" " + (shrink.toString() + (" " + (typeof basis === "object" || basis === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(basis) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FlexBasis.toString */ .Sb.toString(basis)))))
    };
}
function flexBasis(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexBasis",
        _1: typeof x === "object" || x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .FlexBasis.toString */ .Sb.toString(x)
    };
}
function order(x) {
    return {
        TAG: /* D */ 0,
        _0: "order",
        _1: x.toString()
    };
}
function string_of_minmax(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    var match = x.VAL;
    var match$1 = match[0];
    if (match$1 === "add") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[1]) + (" + " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[2]) + ")")));
    } else if (match$1 === "sub") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[1]) + (" - " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[2]) + ")")));
    } else {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[1]) + " * " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[2]) + ")";
    }
}
function string_of_dimension(x) {
    if (typeof x !== "object") {
        if (x === "none") {
            return "none";
        } else if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "fitContent") {
            return "fit-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "minmax") {
        var match = x.VAL;
        return "minmax(" + string_of_minmax(match[0]) + "," + string_of_minmax(match[1]) + ")";
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    var match$1 = x.VAL;
    var match$2 = match$1[0];
    if (match$2 === "add") {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[1]) + " + " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[2]) + ")";
    } else if (match$2 === "sub") {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[1]) + " - " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[2]) + ")";
    } else {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[1]) + " * " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$1[2]) + ")";
    }
}
function gridLengthToJs(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "minmax") {
        var match = x.VAL;
        return "minmax(" + string_of_minmax(match[0]) + "," + string_of_minmax(match[1]) + ")";
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    if (variant === "repeat") {
        var match$1 = x.VAL;
        return "repeat(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .RepeatValue.toString */ .dU.toString(match$1[0]) + ", " + string_of_dimension(match$1[1]) + ")";
    }
    var match$2 = x.VAL;
    var match$3 = match$2[0];
    if (match$3 === "add") {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[1]) + " + " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[2]) + ")";
    } else if (match$3 === "sub") {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[1]) + " - " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[2]) + ")";
    } else {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[1]) + " * " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match$2[2]) + ")";
    }
}
function string_of_dimensions(dimensions) {
    return join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(dimensions, gridLengthToJs), " ");
}
function gridTemplateColumns(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateColumns",
        _1: string_of_dimensions(dimensions)
    };
}
function gridTemplateRows(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateRows",
        _1: string_of_dimensions(dimensions)
    };
}
function gridAutoColumns(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoColumns",
        _1: string_of_dimension(dimensions)
    };
}
function gridAutoRows(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoRows",
        _1: string_of_dimension(dimensions)
    };
}
function gridArea(s) {
    var tmp;
    if (typeof s === "object") {
        var variant = s.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(s) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s);
    } else {
        tmp = s === "unset" || s === "inherit_" || s === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(s) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s);
    }
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: tmp
    };
}
function gridArea2(s, s2) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s2)
    };
}
function gridArea3(s, s2, s3) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s2) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s3)
    };
}
function gridArea4(s, s2, s3, s4) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s2) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s3) + " / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridArea.toString */ .y5.toString(s4)
    };
}
function gridTemplateAreas(l) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateAreas",
        _1: typeof l === "object" ? l.NAME === "areas" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridTemplateAreas.toString */ .$7.toString(l) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(l) : l === "unset" || l === "inherit_" || l === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(l) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .GridTemplateAreas.toString */ .$7.toString(l)
    };
}
function string_of_filter(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return "none";
        }
    }
    var variant = x.NAME;
    if (variant !== "dropShadow") {
        if (variant === "brightness") {
            return "brightness(" + x.VAL.toString() + "%)";
        } else if (variant === "opacity") {
            return "opacity(" + x.VAL.toString() + "%)";
        } else if (variant === "var" || variant === "varDefault") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
        } else if (variant === "grayscale") {
            return "grayscale(" + x.VAL.toString() + "%)";
        } else if (variant === "sepia") {
            return "sepia(" + x.VAL.toString() + "%)";
        } else if (variant === "saturate") {
            return "saturate(" + x.VAL.toString() + "%)";
        } else if (variant === "url") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x);
        } else if (variant === "invert") {
            return "invert(" + x.VAL.toString() + "%)";
        } else if (variant === "contrast") {
            return "contrast(" + x.VAL.toString() + "%)";
        } else if (variant === "hueRotate") {
            return "hue-rotate(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Angle.toString */ .RZ.toString(x.VAL) + ")";
        } else {
            return "blur(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x.VAL) + ")";
        }
    }
    var match = x.VAL;
    return "drop-shadow(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[0]) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[1]) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[2]) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(match[3]) + ")";
}
function filter(x) {
    return {
        TAG: /* D */ 0,
        _0: "filter",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, string_of_filter), " ")
    };
}
function box(xOpt, yOpt, blurOpt, spreadOpt, insetOpt, color) {
    var x = xOpt !== undefined ? xOpt : zero;
    var y = yOpt !== undefined ? yOpt : zero;
    var blur = blurOpt !== undefined ? blurOpt : zero;
    var spread = spreadOpt !== undefined ? spreadOpt : zero;
    var inset = insetOpt !== undefined ? insetOpt : false;
    return {
        NAME: "shadow",
        VAL: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(y) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(blur) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(spread) + " " + string_of_color(color) + (inset ? " inset" : "")
    };
}
function text(xOpt, yOpt, blurOpt, color) {
    var x = xOpt !== undefined ? xOpt : zero;
    var y = yOpt !== undefined ? yOpt : zero;
    var blur = blurOpt !== undefined ? blurOpt : zero;
    return {
        NAME: "shadow",
        VAL: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(y) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(blur) + " " + string_of_color(color)
    };
}
function toString$1(x) {
    if (typeof x === "object") {
        return x.VAL;
    } else {
        return "none";
    }
}
var Shadow = {
    box: box,
    text: text,
    toString: toString$1
};
function boxShadow(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxShadow",
        _1: typeof x === "object" ? x.NAME === "shadow" ? toString$1(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : toString$1(x)
    };
}
function boxShadows(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxShadow",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, toString$1), ", ")
    };
}
function string_of_borderstyle(x) {
    if (typeof x === "object") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x);
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .BorderStyle.toString */ .N4.toString(x);
    }
}
function border(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "border",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(px) + " " + string_of_borderstyle(style) + " " + string_of_color(color)
    };
}
function borderStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderLeft(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeft",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(px) + " " + string_of_borderstyle(style) + " " + string_of_color(color)
    };
}
function borderLeftStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderRight(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderRight",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(px) + " " + string_of_borderstyle(style) + " " + string_of_color(color)
    };
}
function borderRightStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderTop(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderTop",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(px) + " " + string_of_borderstyle(style) + " " + string_of_color(color)
    };
}
function borderTopStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderBottom(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottom",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(px) + " " + string_of_borderstyle(style) + " " + string_of_color(color)
    };
}
function borderBottomStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomStyle",
        _1: string_of_borderstyle(x)
    };
}
function background(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.toString */ .ph.toString(x) : variant === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x) : "none";
    }
    return {
        TAG: /* D */ 0,
        _0: "background",
        _1: tmp
    };
}
function backgrounds(x) {
    return {
        TAG: /* D */ 0,
        _0: "background",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, function(item) {
            if (typeof item !== "object") {
                if (item === "transparent" || item === "currentColor") {
                    return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(item);
                } else {
                    return "none";
                }
            }
            var variant = item.NAME;
            if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Gradient.toString */ .ph.toString(item);
            } else if (variant === "url") {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(item);
            } else {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(item);
            }
        }), ", ")
    };
}
function backgroundSize(x) {
    var tmp;
    if (typeof x === "object") {
        var match = x.VAL;
        tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[0]) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(match[1]);
    } else {
        tmp = x === "cover" ? "cover" : x === "contain" ? "contain" : "auto";
    }
    return {
        TAG: /* D */ 0,
        _0: "backgroundSize",
        _1: tmp
    };
}
function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
    var fontStyle$1 = Js_option.map(function(value) {
        return Css_AtomicTypes.FontStyle.toString(value);
    }, fontStyle);
    var src$1 = join(Belt_Array.map(src, function(x) {
        if (x.NAME === "url") {
            return 'url("' + x.VAL + '")';
        } else {
            return 'local("' + x.VAL + '")';
        }
    }), ", ");
    var fontStyle$2 = Belt_Option.mapWithDefault(fontStyle$1, "", function(s) {
        return "font-style: " + s + ";";
    });
    var fontWeight$1 = Belt_Option.mapWithDefault(fontWeight, "", function(w) {
        return "font-weight: " + (typeof w === "object" ? w.NAME === "num" ? Css_AtomicTypes.FontWeight.toString(w) : Css_AtomicTypes.Var.toString(w) : w === "unset" || w === "inherit_" || w === "initial" ? Css_AtomicTypes.Cascading.toString(w) : Css_AtomicTypes.FontWeight.toString(w)) + ";";
    });
    var fontDisplay$1 = Belt_Option.mapWithDefault(fontDisplay, "", function(f) {
        return "font-display: " + Css_AtomicTypes.FontDisplay.toString(f) + ";";
    });
    return "@font-face {\r\n     font-family: " + fontFamily + ";\r\n     src: " + src$1 + ";\r\n     " + fontStyle$2 + "\r\n     " + fontWeight$1 + "\r\n     " + fontDisplay$1 + "\r\n   }";
}
function textDecoration(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecoration",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "none" ? "none" : x === "initial" ? "initial" : x === "inherit_" ? "inherit" : x === "underline" ? "underline" : x === "lineThrough" ? "line-through" : x === "unset" ? "unset" : "overline"
    };
}
function textShadow(x) {
    return {
        TAG: /* D */ 0,
        _0: "textShadow",
        _1: typeof x === "object" ? x.NAME === "shadow" ? toString$1(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : toString$1(x)
    };
}
function textShadows(x) {
    return {
        TAG: /* D */ 0,
        _0: "textShadow",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, toString$1), ", ")
    };
}
function transformStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "transformStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TransformStyle.toString */ .wJ.toString(x)
    };
}
function shorthand(durationOpt, delayOpt, timingFunctionOpt, property) {
    var duration = durationOpt !== undefined ? durationOpt : 0;
    var delay = delayOpt !== undefined ? delayOpt : 0;
    var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
    return {
        NAME: "value",
        VAL: duration.toString() + "ms " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.toString */ .Ms.toString(timingFunction) + " " + (delay.toString() + "ms") + " " + property
    };
}
function toString$2(x) {
    return x.VAL;
}
var Transition = {
    shorthand: shorthand,
    toString: toString$2
};
function transitionValue(x) {
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: x.VAL
    };
}
function transitionList(x) {
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, toString$2), ", ")
    };
}
function transition(duration, delay, timingFunction, property) {
    var x = shorthand(duration, delay, timingFunction, property);
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: x.VAL
    };
}
function transitionDelay(i) {
    return {
        TAG: /* D */ 0,
        _0: "transitionDelay",
        _1: i.toString() + "ms"
    };
}
function transitionDuration(i) {
    return {
        TAG: /* D */ 0,
        _0: "transitionDuration",
        _1: i.toString() + "ms"
    };
}
function transitionTimingFunction(x) {
    return {
        TAG: /* D */ 0,
        _0: "transitionTimingFunction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.toString */ .Ms.toString(x)
    };
}
function transitionProperty(x) {
    return {
        TAG: /* D */ 0,
        _0: "transitionProperty",
        _1: x
    };
}
function shorthand$1(durationOpt, delayOpt, directionOpt, timingFunctionOpt, fillModeOpt, playStateOpt, iterationCountOpt, name) {
    var duration = durationOpt !== undefined ? durationOpt : 0;
    var delay = delayOpt !== undefined ? delayOpt : 0;
    var direction = directionOpt !== undefined ? directionOpt : "normal";
    var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
    var fillMode = fillModeOpt !== undefined ? fillModeOpt : "none";
    var playState = playStateOpt !== undefined ? playStateOpt : "running";
    var iterationCount = iterationCountOpt !== undefined ? iterationCountOpt : {
        NAME: "count",
        VAL: 1
    };
    return {
        NAME: "value",
        VAL: name + " " + (duration.toString() + "ms") + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TimingFunction.toString */ .Ms.toString(timingFunction) + " " + (delay.toString() + "ms") + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationIterationCount.toString */ .qX.toString(iterationCount) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationDirection.toString */ .sc.toString(direction) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationFillMode.toString */ .yy.toString(fillMode) + " " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .AnimationPlayState.toString */ .Lo.toString(playState)
    };
}
function toString$3(x) {
    return x.VAL;
}
var Animation = {
    shorthand: shorthand$1,
    toString: toString$3
};
function animationValue(x) {
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: x.VAL
    };
}
function animation(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name) {
    var x = shorthand$1(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name);
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: x.VAL
    };
}
function animations(x) {
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x, toString$3), ", ")
    };
}
function animationName(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationName",
        _1: x
    };
}
function fill(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Var.toString */ .nd.toString(x) : variant === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Color.toString */ .Il.toString(x) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_2__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .SVG.Fill.toString */ .Wj.Fill.toString, x);
    }
    return {
        TAG: /* D */ 0,
        _0: "fill",
        _1: tmp
    };
}
function fillOpacity(opacity) {
    return {
        TAG: /* D */ 0,
        _0: "fillOpacity",
        _1: opacity.toString()
    };
}
function fillRule(x) {
    return {
        TAG: /* D */ 0,
        _0: "fillRule",
        _1: x === "evenodd" ? "evenodd" : "nonzero"
    };
}
function stroke(x) {
    return {
        TAG: /* D */ 0,
        _0: "stroke",
        _1: string_of_color(x)
    };
}
function strokeDasharray(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeDasharray",
        _1: typeof x === "object" ? join(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(x.VAL, string_of_dasharray), " ") : "none"
    };
}
function strokeWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Length.toString */ .Gy.toString(x)
    };
}
function strokeOpacity(opacity) {
    return {
        TAG: /* D */ 0,
        _0: "strokeOpacity",
        _1: opacity.toString()
    };
}
function strokeMiterlimit(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeMiterlimit",
        _1: x.toString()
    };
}
function strokeLinecap(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeLinecap",
        _1: x === "square" ? "square" : x === "round" ? "round" : "butt"
    };
}
function strokeLinejoin(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeLinejoin",
        _1: x === "miter" ? "miter" : x === "bevel" ? "bevel" : "round"
    };
}
function stopColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "stopColor",
        _1: string_of_color(x)
    };
}
function stopOpacity(x) {
    return {
        TAG: /* D */ 0,
        _0: "stopOpacity",
        _1: x.toString()
    };
}
function touchAction(x) {
    return {
        TAG: /* D */ 0,
        _0: "touchAction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .TouchAction.toString */ .Nl.toString(x)
    };
}
var Types;
var wordWrap = overflowWrap;
var auto = "auto";
var none = "none";
var text$1 = "text";
var fixed = "fixed";
var isolate = "isolate";
var hidden = "hidden";
var visible = "visible";
var scroll = "scroll";
var local = "local";
var paddingBox = "paddingBox";
var borderBox = "borderBox";
var contentBox = "contentBox";
var noRepeat = "noRepeat";
var space = "space";
var repeat = "repeat";
var minmax = "minmax";
var repeatX = "repeatX";
var repeatY = "repeatY";
var contain = "contain";
var cover = "cover";
var row = "row";
var rowReverse = "rowReverse";
var column = "column";
var columnReverse = "columnReverse";
var wrap = "wrap";
var nowrap = "nowrap";
var wrapReverse = "wrapReverse";
var inline = "inline";
var block = "block";
var contents = "contents";
var flexBox = "flex";
var grid = "grid";
var inlineBlock = "inlineBlock";
var inlineFlex = "inlineFlex";
var inlineGrid = "inlineGrid";
var inlineTable = "inlineTable";
var listItem = "listItem";
var runIn = "runIn";
var table = "table";
var tableCaption = "tableCaption";
var tableColumnGroup = "tableColumnGroup";
var tableHeaderGroup = "tableHeaderGroup";
var tableFooterGroup = "tableFooterGroup";
var tableRowGroup = "tableRowGroup";
var tableCell = "tableCell";
var tableColumn = "tableColumn";
var tableRow = "tableRow";
var flexStart = "flexStart";
var flexEnd = "flexEnd";
var center = "center";
var stretch = "stretch";
var spaceBetween = "spaceBetween";
var spaceAround = "spaceAround";
var spaceEvenly = "spaceEvenly";
var baseline = "baseline";
var forwards = "forwards";
var backwards = "backwards";
var both = "both";
var infinite = "infinite";
var paused = "paused";
var running = "running";
var inside = "inside";
var outside = "outside";
var solid = "solid";
var dotted = "dotted";
var dashed = "dashed";
var underline = "underline";
var overline = "overline";
var lineThrough = "lineThrough";
var clip = "clip";
var ellipsis = "ellipsis";
var wavy = "wavy";
var $$double = "double";
var uppercase = "uppercase";
var lowercase = "lowercase";
var capitalize = "capitalize";
var sub = "sub";
var $$super = "super";
var textTop = "textTop";
var textBottom = "textBottom";
var middle = "middle";
var normal = "normal";
var breakAll = "breakAll";
var keepAll = "keepAll";
var breakWord = "breakWord";
var reverse = "reverse";
var alternate = "alternate";
var alternateReverse = "alternateReverse";
var fill$1 = "fill";
var content = "content";
var maxContent = "maxContent";
var minContent = "minContent";
var fitContent = "fitContent";
var all = "all";
var round = "round";
var miter = "miter";
var bevel = "bevel";
var butt = "butt";
var square = "square";
var panX = "panX";
var panY = "panY";
var panLeft = "panLeft";
var panRight = "panRight";
var panUp = "panUp";
var panDown = "panDown";
var pinchZoom = "pinchZoom";
var manipulation = "manipulation";
var transitions = transitionList;
var SVG = {
    fill: fill,
    fillRule: fillRule,
    fillOpacity: fillOpacity,
    stroke: stroke,
    strokeDasharray: strokeDasharray,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeMiterlimit: strokeMiterlimit,
    strokeWidth: strokeWidth,
    strokeOpacity: strokeOpacity,
    stopColor: stopColor,
    stopOpacity: stopOpacity
};
 /* No side effect */ 


/***/ }),

/***/ 68364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6P": function() { return /* binding */ all; },
/* harmony export */   "$6v": function() { return /* binding */ oblique; },
/* harmony export */   "$Bc": function() { return /* binding */ borderTopStyle; },
/* harmony export */   "$Co": function() { return /* binding */ countersIncrement; },
/* harmony export */   "$QP": function() { return /* binding */ column; },
/* harmony export */   "$Sh": function() { return /* binding */ firstOfType; },
/* harmony export */   "$_Y": function() { return /* binding */ color; },
/* harmony export */   "$hU": function() { return /* binding */ panY; },
/* harmony export */   "$mx": function() { return /* binding */ animationFillMode; },
/* harmony export */   "$uf": function() { return /* binding */ borderStyle; },
/* harmony export */   "$v1": function() { return /* binding */ hex; },
/* harmony export */   "$xc": function() { return /* binding */ grabbing; },
/* harmony export */   "$zm": function() { return /* binding */ scaleY; },
/* harmony export */   "A8G": function() { return /* binding */ textDecorationLine; },
/* harmony export */   "AGO": function() { return /* binding */ borderBottomLeftRadius; },
/* harmony export */   "AGi": function() { return /* binding */ absolute; },
/* harmony export */   "ANm": function() { return /* binding */ tableFooterGroup; },
/* harmony export */   "ARY": function() { return /* binding */ scroll; },
/* harmony export */   "B8C": function() { return /* binding */ rgb; },
/* harmony export */   "BC2": function() { return /* binding */ media; },
/* harmony export */   "BD_": function() { return /* binding */ isolation; },
/* harmony export */   "BFP": function() { return /* binding */ transitionDelay; },
/* harmony export */   "BJ1": function() { return /* binding */ rad; },
/* harmony export */   "BKm": function() { return /* binding */ strokeBox; },
/* harmony export */   "BLt": function() { return /* binding */ padding2; },
/* harmony export */   "BWb": function() { return /* binding */ wordWrap; },
/* harmony export */   "BaW": function() { return /* binding */ gridAutoFlow; },
/* harmony export */   "Bbi": function() { return /* binding */ fillBox; },
/* harmony export */   "BdG": function() { return /* binding */ transitionTimingFunction; },
/* harmony export */   "Bdr": function() { return /* binding */ fixed; },
/* harmony export */   "C1W": function() { return /* binding */ required; },
/* harmony export */   "C74": function() { return /* binding */ scale3d; },
/* harmony export */   "CAZ": function() { return /* binding */ sticky; },
/* harmony export */   "Cak": function() { return /* binding */ repeatingRadialGradient; },
/* harmony export */   "Cb8": function() { return /* binding */ height; },
/* harmony export */   "Ccm": function() { return /* binding */ gridGap; },
/* harmony export */   "CgR": function() { return /* binding */ border; },
/* harmony export */   "CvW": function() { return /* binding */ wResize; },
/* harmony export */   "Czw": function() { return /* binding */ backgroundColor; },
/* harmony export */   "DHQ": function() { return /* binding */ noRepeat; },
/* harmony export */   "Dc1": function() { return /* binding */ wait; },
/* harmony export */   "DhX": function() { return /* binding */ space; },
/* harmony export */   "Djg": function() { return /* binding */ varDefault; },
/* harmony export */   "DuZ": function() { return /* binding */ selection; },
/* harmony export */   "E$t": function() { return /* binding */ borderTopRightRadius; },
/* harmony export */   "E0j": function() { return /* binding */ fitContent; },
/* harmony export */   "E0l": function() { return /* binding */ borderRadius; },
/* harmony export */   "E2y": function() { return /* binding */ turn; },
/* harmony export */   "E9m": function() { return /* binding */ marginTop; },
/* harmony export */   "EcY": function() { return /* binding */ animationIterationCount; },
/* harmony export */   "Eqy": function() { return /* binding */ countersSet; },
/* harmony export */   "EtG": function() { return /* binding */ paddingBottom; },
/* harmony export */   "F2z": function() { return /* binding */ right; },
/* harmony export */   "F86": function() { return /* binding */ margin3; },
/* harmony export */   "FDc": function() { return /* binding */ backgroundRepeat; },
/* harmony export */   "FHD": function() { return /* binding */ maxContent; },
/* harmony export */   "FKU": function() { return /* binding */ position; },
/* harmony export */   "FLd": function() { return /* binding */ animationValue; },
/* harmony export */   "FWK": function() { return /* binding */ gridAutoRows; },
/* harmony export */   "FoG": function() { return /* binding */ skewY; },
/* harmony export */   "FoQ": function() { return /* binding */ swResize; },
/* harmony export */   "Fud": function() { return /* binding */ backgrounds; },
/* harmony export */   "Fv": function() { return /* binding */ visited; },
/* harmony export */   "G30": function() { return /* binding */ perspective; },
/* harmony export */   "G4A": function() { return /* binding */ columnWidth; },
/* harmony export */   "G4q": function() { return /* binding */ backgroundSize; },
/* harmony export */   "GEo": function() { return /* binding */ linear; },
/* harmony export */   "GJu": function() { return /* binding */ tableLayout; },
/* harmony export */   "GYS": function() { return /* binding */ reverse; },
/* harmony export */   "Gew": function() { return /* binding */ block; },
/* harmony export */   "Gfm": function() { return /* binding */ relative; },
/* harmony export */   "Gho": function() { return /* binding */ forwards; },
/* harmony export */   "H6": function() { return /* binding */ readWrite; },
/* harmony export */   "H78": function() { return /* binding */ flexGrow; },
/* harmony export */   "HA": function() { return /* binding */ dashed; },
/* harmony export */   "HMX": function() { return /* binding */ borderBottomWidth; },
/* harmony export */   "HQ2": function() { return /* binding */ url; },
/* harmony export */   "HkC": function() { return /* binding */ both; },
/* harmony export */   "I1x": function() { return /* binding */ invalid; },
/* harmony export */   "I85": function() { return /* binding */ fontFamily; },
/* harmony export */   "I95": function() { return /* binding */ overline; },
/* harmony export */   "IQZ": function() { return /* binding */ contents; },
/* harmony export */   "IQh": function() { return /* binding */ neswResize; },
/* harmony export */   "IV2": function() { return /* binding */ medium; },
/* harmony export */   "I_Q": function() { return /* binding */ local; },
/* harmony export */   "IaC": function() { return /* binding */ bottom; },
/* harmony export */   "Iue": function() { return /* binding */ translate; },
/* harmony export */   "J49": function() { return /* binding */ columnCount; },
/* harmony export */   "J4J": function() { return /* binding */ borderWidth; },
/* harmony export */   "J6G": function() { return /* binding */ alternate; },
/* harmony export */   "JBY": function() { return /* binding */ fontSize; },
/* harmony export */   "JGK": function() { return /* binding */ copy; },
/* harmony export */   "JQf": function() { return /* binding */ touchAction; },
/* harmony export */   "JUm": function() { return /* binding */ disabled; },
/* harmony export */   "Jbp": function() { return /* binding */ runIn; },
/* harmony export */   "Jnk": function() { return /* binding */ hsla; },
/* harmony export */   "Jz2": function() { return /* binding */ root; },
/* harmony export */   "K$K": function() { return /* binding */ gridTemplateColumns; },
/* harmony export */   "K03": function() { return /* binding */ counterReset; },
/* harmony export */   "K47": function() { return /* binding */ unsafe; },
/* harmony export */   "K5p": function() { return /* binding */ tableCell; },
/* harmony export */   "K9x": function() { return /* binding */ paused; },
/* harmony export */   "KL2": function() { return /* binding */ outlineOffset; },
/* harmony export */   "KMK": function() { return /* binding */ isolate; },
/* harmony export */   "KQv": function() { return /* binding */ lang; },
/* harmony export */   "KRj": function() { return /* binding */ vertical; },
/* harmony export */   "KUN": function() { return /* binding */ animationTimingFunction; },
/* harmony export */   "Kgc": function() { return /* binding */ noDrop; },
/* harmony export */   "Kl7": function() { return /* binding */ outline; },
/* harmony export */   "KlP": function() { return /* binding */ justifyContent; },
/* harmony export */   "Kvj": function() { return /* binding */ alignContent; },
/* harmony export */   "Kzj": function() { return /* binding */ table; },
/* harmony export */   "L8u": function() { return /* binding */ textTop; },
/* harmony export */   "L9u": function() { return /* binding */ flex3; },
/* harmony export */   "LAG": function() { return /* binding */ panUp; },
/* harmony export */   "LC$": function() { return /* binding */ conicGradient; },
/* harmony export */   "LHJ": function() { return /* binding */ ellipsis; },
/* harmony export */   "LIb": function() { return /* binding */ overflowWrap; },
/* harmony export */   "LZf": function() { return /* binding */ boxShadows; },
/* harmony export */   "Lol": function() { return /* binding */ transforms; },
/* harmony export */   "Loy": function() { return /* binding */ verticalAlign; },
/* harmony export */   "Me8": function() { return /* binding */ flexDirection; },
/* harmony export */   "MrM": function() { return /* binding */ hover; },
/* harmony export */   "NMM": function() { return /* binding */ round; },
/* harmony export */   "NOF": function() { return /* binding */ nthOfType; },
/* harmony export */   "NXf": function() { return /* binding */ nthLastChild; },
/* harmony export */   "NY0": function() { return /* binding */ tableRowGroup; },
/* harmony export */   "Nv8": function() { return /* binding */ lineHeight; },
/* harmony export */   "NxW": function() { return /* binding */ backgroundImage; },
/* harmony export */   "Nxf": function() { return /* binding */ indeterminate; },
/* harmony export */   "O3F": function() { return /* binding */ transitionValue; },
/* harmony export */   "O7B": function() { return /* binding */ row; },
/* harmony export */   "OYb": function() { return /* binding */ caretColor; },
/* harmony export */   "OaU": function() { return /* binding */ deg; },
/* harmony export */   "Odq": function() { return /* binding */ inside; },
/* harmony export */   "Ohi": function() { return /* binding */ opacity; },
/* harmony export */   "Oq0": function() { return /* binding */ background; },
/* harmony export */   "OqZ": function() { return /* binding */ padding3; },
/* harmony export */   "P8R": function() { return /* binding */ nowrap; },
/* harmony export */   "PS9": function() { return /* binding */ label; },
/* harmony export */   "PUt": function() { return /* binding */ gridArea4; },
/* harmony export */   "P_T": function() { return /* binding */ flexBasis; },
/* harmony export */   "PhB": function() { return /* binding */ overflowAnchor; },
/* harmony export */   "Pp4": function() { return /* binding */ wavy; },
/* harmony export */   "Ppf": function() { return /* binding */ tableCaption; },
/* harmony export */   "PqQ": function() { return /* binding */ uppercase; },
/* harmony export */   "PsQ": function() { return /* binding */ first; },
/* harmony export */   "Pxd": function() { return /* binding */ borderLeftWidth; },
/* harmony export */   "QF4": function() { return /* binding */ valid; },
/* harmony export */   "QOo": function() { return /* binding */ lastChild; },
/* harmony export */   "QXS": function() { return /* binding */ textDecoration; },
/* harmony export */   "QXW": function() { return /* binding */ count; },
/* harmony export */   "QdD": function() { return /* binding */ flexEnd; },
/* harmony export */   "QiF": function() { return /* binding */ colResize; },
/* harmony export */   "QkJ": function() { return /* binding */ skewX; },
/* harmony export */   "QoB": function() { return /* binding */ inline; },
/* harmony export */   "QsJ": function() { return /* binding */ toJson; },
/* harmony export */   "QxZ": function() { return /* binding */ textTransform; },
/* harmony export */   "R29": function() { return /* binding */ light; },
/* harmony export */   "RGf": function() { return /* binding */ gridTemplateRows; },
/* harmony export */   "RLZ": function() { return /* binding */ tableRow; },
/* harmony export */   "R_2": function() { return /* binding */ help; },
/* harmony export */   "RgW": function() { return /* binding */ transitionList; },
/* harmony export */   "S6": function() { return /* binding */ steps; },
/* harmony export */   "SGp": function() { return /* binding */ gap; },
/* harmony export */   "SIr": function() { return /* binding */ resize; },
/* harmony export */   "SKu": function() { return /* binding */ borderTopColor; },
/* harmony export */   "SQh": function() { return /* binding */ solid; },
/* harmony export */   "SVd": function() { return /* binding */ borderRightStyle; },
/* harmony export */   "SX6": function() { return /* binding */ outside; },
/* harmony export */   "SeW": function() { return /* binding */ bold; },
/* harmony export */   "Sgw": function() { return /* binding */ backgroundPosition4; },
/* harmony export */   "SlK": function() { return /* binding */ horizontal; },
/* harmony export */   "TE9": function() { return /* binding */ extraBold; },
/* harmony export */   "TRc": function() { return /* binding */ transformOrigin3d; },
/* harmony export */   "T_4": function() { return /* binding */ focus; },
/* harmony export */   "Tm5": function() { return /* binding */ skew; },
/* harmony export */   "U1s": function() { return /* binding */ rotate; },
/* harmony export */   "U5V": function() { return /* binding */ contentRule; },
/* harmony export */   "UQy": function() { return /* binding */ grad; },
/* harmony export */   "UY0": function() { return /* binding */ panRight; },
/* harmony export */   "UY5": function() { return /* binding */ borderRightWidth; },
/* harmony export */   "UbJ": function() { return /* binding */ gridRowGap; },
/* harmony export */   "Ue2": function() { return /* binding */ fontWeight; },
/* harmony export */   "UrL": function() { return /* binding */ stepStart; },
/* harmony export */   "V1P": function() { return /* binding */ transformStyle; },
/* harmony export */   "V8q": function() { return /* binding */ gridArea3; },
/* harmony export */   "VF7": function() { return /* binding */ panDown; },
/* harmony export */   "VXB": function() { return /* binding */ listStyle; },
/* harmony export */   "VlP": function() { return /* binding */ fontFamilies; },
/* harmony export */   "VvE": function() { return /* binding */ borderLeftColor; },
/* harmony export */   "VvG": function() { return /* binding */ easeOut; },
/* harmony export */   "Vy2": function() { return /* binding */ gridArea2; },
/* harmony export */   "W$B": function() { return /* binding */ placeholder; },
/* harmony export */   "W3B": function() { return /* binding */ gridColumnGap; },
/* harmony export */   "W5D": function() { return /* binding */ zIndex; },
/* harmony export */   "WDY": function() { return /* binding */ visibility; },
/* harmony export */   "WFv": function() { return /* binding */ minmax; },
/* harmony export */   "WLm": function() { return /* binding */ paddingRight; },
/* harmony export */   "WOS": function() { return /* binding */ flexWrap; },
/* harmony export */   "WP2": function() { return /* binding */ manipulation; },
/* harmony export */   "Wct": function() { return /* binding */ nsResize; },
/* harmony export */   "Wj1": function() { return /* binding */ SVG; },
/* harmony export */   "Wnp": function() { return /* binding */ boxShadow; },
/* harmony export */   "X0Y": function() { return /* binding */ margin4; },
/* harmony export */   "XCE": function() { return /* binding */ textShadow; },
/* harmony export */   "XNj": function() { return /* binding */ middle; },
/* harmony export */   "XOq": function() { return /* binding */ alternateReverse; },
/* harmony export */   "XSY": function() { return /* binding */ contain; },
/* harmony export */   "XY7": function() { return /* binding */ borderRightColor; },
/* harmony export */   "Xsx": function() { return /* binding */ columnReverse; },
/* harmony export */   "YD2": function() { return /* binding */ progress; },
/* harmony export */   "YP6": function() { return /* binding */ objectPosition; },
/* harmony export */   "YPD": function() { return /* binding */ none; },
/* harmony export */   "YPe": function() { return /* binding */ translateX; },
/* harmony export */   "YQY": function() { return /* binding */ easeIn; },
/* harmony export */   "YdO": function() { return /* binding */ not_; },
/* harmony export */   "Yep": function() { return /* binding */ backgroundAttachment; },
/* harmony export */   "Yi5": function() { return /* binding */ countersReset; },
/* harmony export */   "Yky": function() { return /* binding */ Types; },
/* harmony export */   "Ym7": function() { return /* binding */ hsl; },
/* harmony export */   "Yum": function() { return /* binding */ $$static; },
/* harmony export */   "Z2v": function() { return /* binding */ inRange; },
/* harmony export */   "Z9P": function() { return /* binding */ onlyChild; },
/* harmony export */   "ZHG": function() { return /* binding */ inlineTable; },
/* harmony export */   "ZHw": function() { return /* binding */ clear; },
/* harmony export */   "ZRe": function() { return /* binding */ animationDirection; },
/* harmony export */   "Zys": function() { return /* binding */ gridRowEnd; },
/* harmony export */   "_Ef": function() { return /* binding */ seResize; },
/* harmony export */   "_Xt": function() { return /* binding */ textOverflow; },
/* harmony export */   "_cl": function() { return /* binding */ backgroundClip; },
/* harmony export */   "_fG": function() { return /* binding */ padding4; },
/* harmony export */   "_s1": function() { return /* binding */ cubicBezier; },
/* harmony export */   "a5O": function() { return /* binding */ tableHeaderGroup; },
/* harmony export */   "aHA": function() { return /* binding */ bevel; },
/* harmony export */   "aNt": function() { return /* binding */ gridAutoColumns; },
/* harmony export */   "aWF": function() { return /* binding */ backwards; },
/* harmony export */   "aX$": function() { return /* binding */ semiBold; },
/* harmony export */   "aku": function() { return /* binding */ areas; },
/* harmony export */   "alX": function() { return /* binding */ hidden; },
/* harmony export */   "amh": function() { return /* binding */ enabled; },
/* harmony export */   "atG": function() { return /* binding */ inherit_; },
/* harmony export */   "az5": function() { return /* binding */ eResize; },
/* harmony export */   "bAd": function() { return /* binding */ scale; },
/* harmony export */   "bBs": function() { return /* binding */ active; },
/* harmony export */   "bCQ": function() { return /* binding */ linearGradient; },
/* harmony export */   "bCW": function() { return /* binding */ backgroundPositions; },
/* harmony export */   "bMI": function() { return /* binding */ zero; },
/* harmony export */   "bPo": function() { return /* binding */ focusVisible; },
/* harmony export */   "bbn": function() { return /* binding */ before; },
/* harmony export */   "bd4": function() { return /* binding */ rtl; },
/* harmony export */   "beQ": function() { return /* binding */ center; },
/* harmony export */   "bf$": function() { return /* binding */ width; },
/* harmony export */   "bme": function() { return /* binding */ alias; },
/* harmony export */   "bu0": function() { return /* binding */ outlineWidth; },
/* harmony export */   "c4c": function() { return /* binding */ flexStart; },
/* harmony export */   "cOP": function() { return /* binding */ directSibling; },
/* harmony export */   "cSb": function() { return /* binding */ empty; },
/* harmony export */   "cYj": function() { return /* binding */ pxFloat; },
/* harmony export */   "ceD": function() { return /* binding */ $$double; },
/* harmony export */   "ch": function() { return /* binding */ ch; },
/* harmony export */   "cm": function() { return /* binding */ cm; },
/* harmony export */   "cod": function() { return /* binding */ gridColumnEnd; },
/* harmony export */   "cq$": function() { return /* binding */ alignItems; },
/* harmony export */   "cx$": function() { return /* binding */ pointer; },
/* harmony export */   "d73": function() { return /* binding */ auto; },
/* harmony export */   "d8w": function() { return /* binding */ whiteSpace; },
/* harmony export */   "dZD": function() { return /* binding */ animationPlayState; },
/* harmony export */   "dkg": function() { return /* binding */ $$super; },
/* harmony export */   "dpJ": function() { return /* binding */ size; },
/* harmony export */   "dxT": function() { return /* binding */ outlineColor; },
/* harmony export */   "dxy": function() { return /* binding */ siblings; },
/* harmony export */   "dy0": function() { return /* binding */ stretch; },
/* harmony export */   "e$I": function() { return /* binding */ columnGap; },
/* harmony export */   "e4p": function() { return /* binding */ after; },
/* harmony export */   "e6$": function() { return /* binding */ margin; },
/* harmony export */   "eCg": function() { return /* binding */ grid; },
/* harmony export */   "eCr": function() { return /* binding */ underline; },
/* harmony export */   "eEk": function() { return /* binding */ verticalText; },
/* harmony export */   "eIe": function() { return /* binding */ scope; },
/* harmony export */   "eNo": function() { return /* binding */ Nth; },
/* harmony export */   "eRF": function() { return /* binding */ textBottom; },
/* harmony export */   "eRy": function() { return /* binding */ transition; },
/* harmony export */   "eUF": function() { return /* binding */ ewResize; },
/* harmony export */   "eYb": function() { return /* binding */ justifyItems; },
/* harmony export */   "eZH": function() { return /* binding */ scaleX; },
/* harmony export */   "ec_": function() { return /* binding */ checked; },
/* harmony export */   "efO": function() { return /* binding */ important; },
/* harmony export */   "em": function() { return /* binding */ em; },
/* harmony export */   "epG": function() { return /* binding */ $$var; },
/* harmony export */   "er3": function() { return /* binding */ rotate3d; },
/* harmony export */   "ex": function() { return /* binding */ ex; },
/* harmony export */   "exU": function() { return /* binding */ viewBox; },
/* harmony export */   "ezj": function() { return /* binding */ backgroundOrigin; },
/* harmony export */   "f6n": function() { return /* binding */ lighter; },
/* harmony export */   "f7d": function() { return /* binding */ neResize; },
/* harmony export */   "fA7": function() { return /* binding */ target; },
/* harmony export */   "fCW": function() { return /* binding */ borderTopWidth; },
/* harmony export */   "fD_": function() { return /* binding */ gridArea; },
/* harmony export */   "fFX": function() { return /* binding */ allScroll; },
/* harmony export */   "fHD": function() { return /* binding */ spaceBetween; },
/* harmony export */   "fLW": function() { return /* binding */ text$1; },
/* harmony export */   "fLi": function() { return /* binding */ contentBox; },
/* harmony export */   "fT5": function() { return /* binding */ bolder; },
/* harmony export */   "fUN": function() { return /* binding */ flex; },
/* harmony export */   "fXf": function() { return /* binding */ objectFit; },
/* harmony export */   "fr": function() { return /* binding */ fr; },
/* harmony export */   "ftw": function() { return /* binding */ dotted; },
/* harmony export */   "fwF": function() { return /* binding */ Animation; },
/* harmony export */   "fxJ": function() { return /* binding */ minContent; },
/* harmony export */   "g7Q": function() { return /* binding */ wrapReverse; },
/* harmony export */   "gB9": function() { return /* binding */ stepEnd; },
/* harmony export */   "ga_": function() { return /* binding */ counterIncrement; },
/* harmony export */   "giC": function() { return /* binding */ butt; },
/* harmony export */   "gr0": function() { return /* binding */ perspectiveOrigin; },
/* harmony export */   "h$9": function() { return /* binding */ borderBottom; },
/* harmony export */   "h52": function() { return /* binding */ textIndent; },
/* harmony export */   "h62": function() { return /* binding */ square; },
/* harmony export */   "h9x": function() { return /* binding */ margin2; },
/* harmony export */   "hGO": function() { return /* binding */ localUrl; },
/* harmony export */   "hHJ": function() { return /* binding */ spaceAround; },
/* harmony export */   "hJp": function() { return /* binding */ borderSpacing; },
/* harmony export */   "hOB": function() { return /* binding */ rem; },
/* harmony export */   "hR4": function() { return /* binding */ translateZ; },
/* harmony export */   "hXT": function() { return /* binding */ filter; },
/* harmony export */   "hdZ": function() { return /* binding */ pct; },
/* harmony export */   "hlL": function() { return /* binding */ fill$1; },
/* harmony export */   "ho7": function() { return /* binding */ host; },
/* harmony export */   "hrh": function() { return /* binding */ textDecorationColor; },
/* harmony export */   "i16": function() { return /* binding */ firstLetter; },
/* harmony export */   "i36": function() { return /* binding */ panX; },
/* harmony export */   "i4v": function() { return /* binding */ flexShrink; },
/* harmony export */   "iUc": function() { return /* binding */ child; },
/* harmony export */   "iWO": function() { return /* binding */ translateY; },
/* harmony export */   "ibC": function() { return /* binding */ tableColumn; },
/* harmony export */   "ihZ": function() { return /* binding */ minWidth; },
/* harmony export */   "ihe": function() { return /* binding */ outOfRange; },
/* harmony export */   "isX": function() { return /* binding */ spaceEvenly; },
/* harmony export */   "iu7": function() { return /* binding */ borderBox; },
/* harmony export */   "ixg": function() { return /* binding */ boxSizing; },
/* harmony export */   "j1L": function() { return /* binding */ borderTop; },
/* harmony export */   "j96": function() { return /* binding */ baseline; },
/* harmony export */   "jIM": function() { return /* binding */ rotateZ; },
/* harmony export */   "jK5": function() { return /* binding */ contentRules; },
/* harmony export */   "jLD": function() { return /* binding */ lineThrough; },
/* harmony export */   "jSQ": function() { return /* binding */ overscrollBehavior; },
/* harmony export */   "jXB": function() { return /* binding */ Shadow; },
/* harmony export */   "jZR": function() { return /* binding */ listStyleType; },
/* harmony export */   "jc2": function() { return /* binding */ smallCaps; },
/* harmony export */   "jfB": function() { return /* binding */ display; },
/* harmony export */   "jsT": function() { return /* binding */ notAllowed; },
/* harmony export */   "jtO": function() { return /* binding */ optional; },
/* harmony export */   "jw4": function() { return /* binding */ minHeight; },
/* harmony export */   "k$v": function() { return /* binding */ breakAll; },
/* harmony export */   "k0m": function() { return /* binding */ backgroundPosition; },
/* harmony export */   "kC2": function() { return /* binding */ capitalize; },
/* harmony export */   "kCL": function() { return /* binding */ maxHeight; },
/* harmony export */   "kQN": function() { return /* binding */ content; },
/* harmony export */   "kZi": function() { return /* binding */ breakWord; },
/* harmony export */   "k_P": function() { return /* binding */ repeatingLinearGradient; },
/* harmony export */   "kkJ": function() { return /* binding */ pointerEvents; },
/* harmony export */   "kkr": function() { return /* binding */ maxWidth; },
/* harmony export */   "krI": function() { return /* binding */ zoomIn; },
/* harmony export */   "lEu": function() { return /* binding */ animationDelay; },
/* harmony export */   "lM7": function() { return /* binding */ wordBreak; },
/* harmony export */   "lMS": function() { return /* binding */ rotateX; },
/* harmony export */   "lpz": function() { return /* binding */ gridRowStart; },
/* harmony export */   "luU": function() { return /* binding */ sub; },
/* harmony export */   "m4f": function() { return /* binding */ rgba; },
/* harmony export */   "m6$": function() { return /* binding */ ltr; },
/* harmony export */   "m8E": function() { return /* binding */ marginBox; },
/* harmony export */   "mJl": function() { return /* binding */ normal; },
/* harmony export */   "mUE": function() { return /* binding */ firstChild; },
/* harmony export */   "mZN": function() { return /* binding */ easeInOut; },
/* harmony export */   "mm": function() { return /* binding */ mm; },
/* harmony export */   "mvd": function() { return /* binding */ keepAll; },
/* harmony export */   "mvv": function() { return /* binding */ ease; },
/* harmony export */   "mwL": function() { return /* binding */ miter; },
/* harmony export */   "nKF": function() { return /* binding */ counterSet; },
/* harmony export */   "nLE": function() { return /* binding */ backdropFilter; },
/* harmony export */   "nVE": function() { return /* binding */ transitionDuration; },
/* harmony export */   "nZE": function() { return /* binding */ selector; },
/* harmony export */   "n_e": function() { return /* binding */ transitionProperty; },
/* harmony export */   "na1": function() { return /* binding */ nResize; },
/* harmony export */   "ncr": function() { return /* binding */ extraLight; },
/* harmony export */   "njC": function() { return /* binding */ borderLeftStyle; },
/* harmony export */   "nnL": function() { return /* binding */ initial; },
/* harmony export */   "o3D": function() { return /* binding */ padding; },
/* harmony export */   "o4w": function() { return /* binding */ cell; },
/* harmony export */   "o6J": function() { return /* binding */ clipPath; },
/* harmony export */   "o7V": function() { return /* binding */ direction; },
/* harmony export */   "oIA": function() { return /* binding */ marginLeft; },
/* harmony export */   "oIx": function() { return /* binding */ gridRow; },
/* harmony export */   "oJs": function() { return /* binding */ rowResize; },
/* harmony export */   "oPT": function() { return /* binding */ visible; },
/* harmony export */   "oQ4": function() { return /* binding */ animation; },
/* harmony export */   "oXI": function() { return /* binding */ infinite; },
/* harmony export */   "obx": function() { return /* binding */ borderCollapse; },
/* harmony export */   "ocY": function() { return /* binding */ cursor; },
/* harmony export */   "odA": function() { return /* binding */ paddingTop; },
/* harmony export */   "oqW": function() { return /* binding */ clip; },
/* harmony export */   "orU": function() { return /* binding */ borderTopLeftRadius; },
/* harmony export */   "otN": function() { return /* binding */ maskPositions; },
/* harmony export */   "p$S": function() { return /* binding */ numIdent; },
/* harmony export */   "p22": function() { return /* binding */ transformOrigin; },
/* harmony export */   "p3g": function() { return /* binding */ scaleZ; },
/* harmony export */   "p4m": function() { return /* binding */ link; },
/* harmony export */   "pBE": function() { return /* binding */ transitions; },
/* harmony export */   "pBW": function() { return /* binding */ move; },
/* harmony export */   "pIy": function() { return /* binding */ children; },
/* harmony export */   "pMI": function() { return /* binding */ repeatX; },
/* harmony export */   "pU1": function() { return /* binding */ overflowY; },
/* harmony export */   "pUw": function() { return /* binding */ italic; },
/* harmony export */   "p_N": function() { return /* binding */ fontStyle; },
/* harmony export */   "poq": function() { return /* binding */ rowReverse; },
/* harmony export */   "pt": function() { return /* binding */ pt; },
/* harmony export */   "px": function() { return /* binding */ px; },
/* harmony export */   "qJL": function() { return /* binding */ wordSpacing; },
/* harmony export */   "qbe": function() { return /* binding */ listItem; },
/* harmony export */   "qtZ": function() { return /* binding */ borderBottomStyle; },
/* harmony export */   "qtd": function() { return /* binding */ readOnly; },
/* harmony export */   "rHv": function() { return /* binding */ $$default; },
/* harmony export */   "rXp": function() { return /* binding */ letterSpacing; },
/* harmony export */   "reQ": function() { return /* binding */ wrap; },
/* harmony export */   "rfy": function() { return /* binding */ borderBottomRightRadius; },
/* harmony export */   "rif": function() { return /* binding */ defined; },
/* harmony export */   "rjz": function() { return /* binding */ gap2; },
/* harmony export */   "rv2": function() { return /* binding */ paddingLeft; },
/* harmony export */   "rx1": function() { return /* binding */ repeat; },
/* harmony export */   "s2f": function() { return /* binding */ rowGap; },
/* harmony export */   "s8c": function() { return /* binding */ vmax; },
/* harmony export */   "sCq": function() { return /* binding */ scrollBehavior; },
/* harmony export */   "sFT": function() { return /* binding */ animations; },
/* harmony export */   "sc3": function() { return /* binding */ borderLeft; },
/* harmony export */   "sg9": function() { return /* binding */ textShadows; },
/* harmony export */   "sih": function() { return /* binding */ userSelect; },
/* harmony export */   "t$v": function() { return /* binding */ left; },
/* harmony export */   "t0D": function() { return /* binding */ Make; },
/* harmony export */   "t4e": function() { return /* binding */ gridColumn; },
/* harmony export */   "tD0": function() { return /* binding */ paddingBox; },
/* harmony export */   "tPW": function() { return /* binding */ flexBox; },
/* harmony export */   "tPj": function() { return /* binding */ nthLastOfType; },
/* harmony export */   "tac": function() { return /* binding */ maskPosition; },
/* harmony export */   "tgT": function() { return /* binding */ inlineGrid; },
/* harmony export */   "tvt": function() { return /* binding */ borderColor; },
/* harmony export */   "txR": function() { return /* binding */ overflow; },
/* harmony export */   "uDD": function() { return /* binding */ rotateY; },
/* harmony export */   "uGs": function() { return /* binding */ crosshair; },
/* harmony export */   "uTP": function() { return /* binding */ Transition; },
/* harmony export */   "u_l": function() { return /* binding */ focusWithin; },
/* harmony export */   "ub3": function() { return /* binding */ anyLink; },
/* harmony export */   "uhB": function() { return /* binding */ backfaceVisibility; },
/* harmony export */   "uko": function() { return /* binding */ alignSelf; },
/* harmony export */   "ur1": function() { return /* binding */ gridColumnStart; },
/* harmony export */   "uwu": function() { return /* binding */ $$float; },
/* harmony export */   "v03": function() { return /* binding */ vmin; },
/* harmony export */   "v8j": function() { return /* binding */ cover; },
/* harmony export */   "vGG": function() { return /* binding */ zoomOut; },
/* harmony export */   "vPS": function() { return /* binding */ thin; },
/* harmony export */   "vQA": function() { return /* binding */ borderRight; },
/* harmony export */   "vSo": function() { return /* binding */ borderBottomColor; },
/* harmony export */   "vdF": function() { return /* binding */ inlineBlock; },
/* harmony export */   "vh": function() { return /* binding */ vh; },
/* harmony export */   "vmh": function() { return /* binding */ order; },
/* harmony export */   "vo$": function() { return /* binding */ textDecorationStyle; },
/* harmony export */   "voX": function() { return /* binding */ sResize; },
/* harmony export */   "vs": function() { return /* binding */ transform; },
/* harmony export */   "vvq": function() { return /* binding */ nthChild; },
/* harmony export */   "vw": function() { return /* binding */ vw; },
/* harmony export */   "w30": function() { return /* binding */ animationName; },
/* harmony export */   "wCv": function() { return /* binding */ running; },
/* harmony export */   "wXG": function() { return /* binding */ lowercase; },
/* harmony export */   "wey": function() { return /* binding */ top; },
/* harmony export */   "wxz": function() { return /* binding */ firstLine; },
/* harmony export */   "wyN": function() { return /* binding */ animationDuration; },
/* harmony export */   "wyo": function() { return /* binding */ currentColor; },
/* harmony export */   "wzR": function() { return /* binding */ marginRight; },
/* harmony export */   "x2h": function() { return /* binding */ grab; },
/* harmony export */   "xBE": function() { return /* binding */ lastOfType; },
/* harmony export */   "xPo": function() { return /* binding */ listStylePosition; },
/* harmony export */   "xW": function() { return /* binding */ nwseResize; },
/* harmony export */   "xZz": function() { return /* binding */ panLeft; },
/* harmony export */   "xvA": function() { return /* binding */ fontVariant; },
/* harmony export */   "yEL": function() { return /* binding */ repeatY; },
/* harmony export */   "yLU": function() { return /* binding */ tableColumnGroup; },
/* harmony export */   "yOV": function() { return /* binding */ listStyleImage; },
/* harmony export */   "yRn": function() { return /* binding */ ident; },
/* harmony export */   "ybA": function() { return /* binding */ pinchZoom; },
/* harmony export */   "ydu": function() { return /* binding */ textAlign; },
/* harmony export */   "yl7": function() { return /* binding */ marginBottom; },
/* harmony export */   "z2Y": function() { return /* binding */ translate3d; },
/* harmony export */   "z8w": function() { return /* binding */ inlineFlex; },
/* harmony export */   "zCX": function() { return /* binding */ contextMenu; },
/* harmony export */   "zEV": function() { return /* binding */ onlyOfType; },
/* harmony export */   "zIs": function() { return /* binding */ gridTemplateAreas; },
/* harmony export */   "zNf": function() { return /* binding */ unset; },
/* harmony export */   "zT3": function() { return /* binding */ maskImage; },
/* harmony export */   "zZK": function() { return /* binding */ nwResize; },
/* harmony export */   "zoP": function() { return /* binding */ justifySelf; },
/* harmony export */   "zso": function() { return /* binding */ radialGradient; },
/* harmony export */   "zuB": function() { return /* binding */ outlineStyle; },
/* harmony export */   "zyf": function() { return /* binding */ Calc; },
/* harmony export */   "zzh": function() { return /* binding */ overflowX; }
/* harmony export */ });
/* unused harmony exports default, transparent, fontFace */
/* harmony import */ var _rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62494);
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99813);
/* harmony import */ var _rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84462);
/* harmony import */ var _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48891);
// Generated by ReScript, PLEASE EDIT WITH CARE







function ruleToDict(dict, rule) {
    switch(rule.TAG | 0){
        case /* D */ 0:
            var value = rule._1;
            var name = rule._0;
            if (name === "content") {
                dict[name] = value === "" ? '""' : value;
            } else {
                dict[name] = value;
            }
            break;
        case /* S */ 1:
            dict[rule._0] = toJson(rule._1);
            break;
        case /* PseudoClass */ 2:
            dict[":" + rule._0] = toJson(rule._1);
            break;
        case /* PseudoClassParam */ 3:
            dict[":" + (rule._0 + ("(" + (rule._1 + ")")))] = toJson(rule._2);
            break;
    }
    return dict;
}
function toJson(rules) {
    return _rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .reduce */ .u4(rules, {}, ruleToDict);
}
function addStop(dict, param) {
    dict[param[0].toString() + "%"] = toJson(param[1]);
    return dict;
}
function Make(CssImpl) {
    var insertRule = function insertRule(css) {
        CssImpl.injectRaw(css);
    };
    var renderRule = function renderRule(renderer, css) {
        CssImpl.renderRaw(renderer, css);
    };
    var $$global = function $$global(selector, rules) {
        CssImpl.injectRules(selector, toJson(rules));
    };
    var renderGlobal = function renderGlobal(renderer, selector, rules) {
        CssImpl.renderRules(renderer, selector, toJson(rules));
    };
    var style = function style(rules) {
        return CssImpl.make(toJson(rules));
    };
    var merge = function merge(styles) {
        return CssImpl.mergeStyles(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .toArray */ .qo(styles));
    };
    var merge2 = function merge2(s, s2) {
        return CssImpl.mergeStyles(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .toArray */ .qo({
            hd: s,
            tl: {
                hd: s2,
                tl: /* [] */ 0
            }
        }));
    };
    var merge3 = function merge3(s, s2, s3) {
        return CssImpl.mergeStyles(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .toArray */ .qo({
            hd: s,
            tl: {
                hd: s2,
                tl: {
                    hd: s3,
                    tl: /* [] */ 0
                }
            }
        }));
    };
    var merge4 = function merge4(s, s2, s3, s4) {
        return CssImpl.mergeStyles(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .toArray */ .qo({
            hd: s,
            tl: {
                hd: s2,
                tl: {
                    hd: s3,
                    tl: {
                        hd: s4,
                        tl: /* [] */ 0
                    }
                }
            }
        }));
    };
    var keyframes = function keyframes(frames) {
        return CssImpl.makeKeyframes(_rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__/* .fold_left */ .gv(addStop, {}, frames));
    };
    var renderKeyframes = function renderKeyframes(renderer, frames) {
        return CssImpl.renderKeyframes(renderer, _rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__/* .fold_left */ .gv(addStop, {}, frames));
    };
    return {
        insertRule: insertRule,
        renderRule: renderRule,
        $$global: $$global,
        renderGlobal: renderGlobal,
        style: style,
        merge: merge,
        merge2: merge2,
        merge3: merge3,
        merge4: merge4,
        keyframes: keyframes,
        renderKeyframes: renderKeyframes
    };
}
function join(strings, separator) {
    var _strings = strings;
    var _acc = "";
    while(true){
        var acc = _acc;
        var strings$1 = _strings;
        if (!strings$1) {
            return acc;
        }
        var xs = strings$1.tl;
        var x = strings$1.hd;
        if (!xs) {
            return acc + x;
        }
        _acc = acc + (x + separator);
        _strings = xs;
        continue;
    }
    ;
}
function string_of_content(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Content.toString */ .VY.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.toString */ .ph.toString(x);
    } else if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "url") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x);
    } else if (variant === "counters") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Counters.toString */ .xv.toString(x);
    } else if (variant === "counter") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Counter.toString */ .AT.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Content.toString */ .VY.toString(x);
    }
}
function string_of_counter_increment(x) {
    if (typeof x === "object") {
        if (x.NAME === "increment") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterIncrement.toString */ .fS.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
        }
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterIncrement.toString */ .fS.toString(x);
    }
}
function string_of_counter_reset(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterReset.toString */ .fd.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterReset.toString */ .fd.toString(x);
    }
}
function string_of_counter_set(x) {
    if (typeof x === "object") {
        if (x.NAME === "set") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterSet.toString */ .WJ.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
        }
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CounterSet.toString */ .WJ.toString(x);
    }
}
function string_of_column_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_row_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_gap(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else if (x === "normal") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gap.toString */ .Zv.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else if (variant === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_position(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function string_of_color(x) {
    if (typeof x !== "object") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    }
}
function string_of_dasharray(x) {
    if (typeof x === "object" && x.NAME === "percent") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function important(v) {
    if (v.TAG === /* D */ 0) {
        return {
            TAG: /* D */ 0,
            _0: v._0,
            _1: v._1 + " !important"
        };
    } else {
        return v;
    }
}
function label(label$1) {
    return {
        TAG: /* D */ 0,
        _0: "label",
        _1: label$1
    };
}
function alignContent(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignContent",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DistributedAlignment.toString */ .H3.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AlignContent.toString */ .tk.toString(x)
    };
}
function alignItems(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignItems",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" || x === "stretch" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AlignItems.toString */ .g1.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PositionalAlignment.toString */ .F.toString(x)
    };
}
function alignSelf(x) {
    return {
        TAG: /* D */ 0,
        _0: "alignSelf",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PositionalAlignment.toString */ .F.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BaselineAlignment.toString */ .b4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AlignSelf.toString */ .MT.toString(x)
    };
}
function animationDelay(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDelay",
        _1: x.toString() + "ms"
    };
}
function animationDirection(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDirection",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationDirection.toString */ .sc.toString(x)
    };
}
function animationDuration(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationDuration",
        _1: x.toString() + "ms"
    };
}
function animationFillMode(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationFillMode",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationFillMode.toString */ .yy.toString(x)
    };
}
function animationIterationCount(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationIterationCount",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationIterationCount.toString */ .qX.toString(x)
    };
}
function animationPlayState(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationPlayState",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationPlayState.toString */ .Lo.toString(x)
    };
}
function animationTimingFunction(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationTimingFunction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.toString */ .Ms.toString(x)
    };
}
function backfaceVisibility(x) {
    return {
        TAG: /* D */ 0,
        _0: "backfaceVisibility",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "visible" || x === "hidden" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackfaceVisibility.toString */ .YO.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function backdropFilter(x) {
    return {
        TAG: /* D */ 0,
        _0: "backdropFilter",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackdropFilter.toString */ .l5.toString), ", ")
    };
}
function backgroundAttachment(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundAttachment",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundAttachment.toString */ .gt.toString(x)
    };
}
function backgroundColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundColor",
        _1: string_of_color(x)
    };
}
function backgroundClip(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundClip",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundClip.toString */ .x6.toString(x)
    };
}
function backgroundImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.toString */ .ph.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundImage.toString */ .Xd.toString(x)
    };
}
function maskImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "maskImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.toString */ .ph.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaskImage.toString */ .TA.toString(x)
    };
}
function backgroundOrigin(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundOrigin",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundOrigin.toString */ .yW.toString(x)
    };
}
function string_of_backgroundposition(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundPosition.toString */ ._S.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    }
    if (variant !== "hv") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
    var match = x.VAL;
    var v = match[1];
    var h = match[0];
    return (typeof h === "object" || h === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(h) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundPosition.X.toString */ ._S.X.toString, h)) + (" " + (typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(v) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundPosition.Y.toString */ ._S.Y.toString, v)));
}
function backgroundPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: string_of_backgroundposition(x)
    };
}
function backgroundPositions(bp) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(bp, string_of_backgroundposition), ", ")
    };
}
function backgroundPosition4(x, offsetX, y, offsetY) {
    return {
        TAG: /* D */ 0,
        _0: "backgroundPosition",
        _1: _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundPosition.X.toString */ ._S.X.toString, x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(offsetX) + (" " + (_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundPosition.Y.toString */ ._S.Y.toString, y) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(offsetY))))))
    };
}
function backgroundRepeat(x) {
    var tmp;
    if (typeof x === "object") {
        if (x.NAME === "hv") {
            var match = x.VAL;
            tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundRepeat.toString */ .W5.toString(match[0]) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundRepeat.toString */ .W5.toString(match[1]));
        } else {
            tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
        }
    } else {
        tmp = x === "repeatY" || x === "repeatX" || x === "repeat" || x === "space" || x === "round" || x === "noRepeat" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundRepeat.toString */ .W5.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "backgroundRepeat",
        _1: tmp
    };
}
function string_of_maskposition(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaskPosition.toString */ .AG.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    }
    if (variant !== "hv") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
    var match = x.VAL;
    var v = match[1];
    var h = match[0];
    return (typeof h === "object" || h === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(h) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaskPosition.X.toString */ .AG.X.toString, h)) + (" " + (typeof v === "object" || !(v === "center" || v === "top" || v === "bottom") ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(v) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaskPosition.Y.toString */ .AG.Y.toString, v)));
}
function maskPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "maskPosition",
        _1: string_of_maskposition(x)
    };
}
function maskPositions(mp) {
    return {
        TAG: /* D */ 0,
        _0: "maskPosition",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(mp, string_of_maskposition), ", ")
    };
}
function borderBottomColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomColor",
        _1: string_of_color(x)
    };
}
function borderBottomLeftRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomLeftRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderBottomRightRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomRightRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderBottomWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderCollapse(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderCollapse",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BorderCollapse.toString */ .k7.toString(x)
    };
}
function borderColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderColor",
        _1: string_of_color(x)
    };
}
function borderLeftColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftColor",
        _1: string_of_color(x)
    };
}
function borderLeftWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderSpacing(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderSpacing",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderRightColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightColor",
        _1: string_of_color(x)
    };
}
function borderRightWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopColor",
        _1: string_of_color(x)
    };
}
function borderTopLeftRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopLeftRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopRightRadius(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopRightRadius",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderTopWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderTopWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function borderWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function bottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "bottom",
        _1: string_of_position(x)
    };
}
function boxSizing(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxSizing",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BoxSizing.toString */ .LG.toString(x)
    };
}
function clear(x) {
    return {
        TAG: /* D */ 0,
        _0: "clear",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Clear.toString */ .UZ.toString(x)
    };
}
function clipPath(x) {
    return {
        TAG: /* D */ 0,
        _0: "clipPath",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ClipPath.toString */ .IN.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GeometryBox.toString */ .lf.toString(x)
    };
}
function color(x) {
    return {
        TAG: /* D */ 0,
        _0: "color",
        _1: string_of_color(x)
    };
}
function columnCount(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ColumnCount.toString */ .Ex.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ColumnCount.toString */ .Ex.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "columnCount",
        _1: tmp
    };
}
function columnGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "columnGap",
        _1: string_of_column_gap(x)
    };
}
function rowGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "rowGap",
        _1: string_of_row_gap(x)
    };
}
function contentRule(x) {
    return {
        TAG: /* D */ 0,
        _0: "content",
        _1: string_of_content(x)
    };
}
function contentRules(xs) {
    return {
        TAG: /* D */ 0,
        _0: "content",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(xs, string_of_content), " ")
    };
}
function counterIncrement(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterIncrement",
        _1: string_of_counter_increment(x)
    };
}
function countersIncrement(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterIncrement",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(xs, string_of_counter_increment), " ")
    };
}
function counterReset(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterReset",
        _1: string_of_counter_reset(x)
    };
}
function countersReset(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterReset",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(xs, string_of_counter_reset), " ")
    };
}
function counterSet(x) {
    return {
        TAG: /* D */ 0,
        _0: "counterSet",
        _1: string_of_counter_set(x)
    };
}
function countersSet(xs) {
    return {
        TAG: /* D */ 0,
        _0: "counterSet",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(xs, string_of_counter_set), " ")
    };
}
function cursor(x) {
    return {
        TAG: /* D */ 0,
        _0: "cursor",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.toString */ .CF.toString(x)
    };
}
function direction(x) {
    return {
        TAG: /* D */ 0,
        _0: "direction",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "rtl" || x === "ltr" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Direction.toString */ .Nm.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function display(x) {
    return {
        TAG: /* D */ 0,
        _0: "display",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "table" || x === "grid" || x === "flex" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayInside.toString */ .au.toString(x) : x === "contents" || x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayBox.toString */ .HD.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "inlineGrid" || x === "inlineFlex" || x === "inlineBlock" || x === "inlineTable" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayLegacy.toString */ .v7.toString(x) : x === "block" || x === "inline" || x === "runIn" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayOutside.toString */ .bv.toString(x) : x === "listItem" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayListItem.toString */ .cA.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DisplayInternal.toString */ .rY.toString(x)
    };
}
function flex(x) {
    return {
        TAG: /* D */ 0,
        _0: "flex",
        _1: typeof x === "object" ? x.VAL.toString() : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Flex.toString */ .kC.toString(x)
    };
}
function flexDirection(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexDirection",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FlexDirection.toString */ .Qb.toString(x)
    };
}
function flexGrow(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexGrow",
        _1: x.toString()
    };
}
function flexShrink(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexShrink",
        _1: x.toString()
    };
}
function flexWrap(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexWrap",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "nowrap" || x === "wrapReverse" || x === "wrap" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FlexWrap.toString */ .gP.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function $$float(x) {
    return {
        TAG: /* D */ 0,
        _0: "float",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Float.toString */ .V4.toString(x)
    };
}
function fontFamily(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontFamily",
        _1: typeof x === "object" ? x.NAME === "custom" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontFamilyName.toString */ .NB.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontFamilyName.toString */ .NB.toString(x)
    };
}
function fontFamilies(xs) {
    return {
        TAG: /* D */ 0,
        _0: "fontFamily",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(xs, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontFamilyName.toString */ .NB.toString), ", ")
    };
}
function fontSize(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "fontSize",
        _1: tmp
    };
}
function fontStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "normal" || x === "oblique" || x === "italic" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontStyle.toString */ .Hd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function fontVariant(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontVariant",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "normal" || x === "smallCaps" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontVariant.toString */ .HS.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function fontWeight(x) {
    return {
        TAG: /* D */ 0,
        _0: "fontWeight",
        _1: typeof x === "object" ? x.NAME === "num" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.toString */ .U9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.toString */ .U9.toString(x)
    };
}
function gridAutoFlow(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoFlow",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridAutoFlow.toString */ .gC.toString(x)
    };
}
function gridColumn(start, end$p) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumn",
        _1: start.toString() + (" / " + end$p.toString())
    };
}
function gridColumnGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnGap",
        _1: string_of_column_gap(x)
    };
}
function gridColumnStart(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnStart",
        _1: n.toString()
    };
}
function gridColumnEnd(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridColumnEnd",
        _1: n.toString()
    };
}
function gridRow(start, end$p) {
    return {
        TAG: /* D */ 0,
        _0: "gridRow",
        _1: start.toString() + (" / " + end$p.toString())
    };
}
function gap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gap",
        _1: string_of_gap(x)
    };
}
function gridGap(x) {
    return {
        TAG: /* D */ 0,
        _0: "gridGap",
        _1: string_of_gap(x)
    };
}
function gap2(rowGap, columnGap) {
    return {
        TAG: /* D */ 0,
        _0: "gap",
        _1: string_of_gap(rowGap) + (" " + string_of_gap(columnGap))
    };
}
function gridRowGap(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "gridRowGap",
        _1: tmp
    };
}
function gridRowEnd(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridRowEnd",
        _1: n.toString()
    };
}
function gridRowStart(n) {
    return {
        TAG: /* D */ 0,
        _0: "gridRowStart",
        _1: n.toString()
    };
}
function height(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "height",
        _1: tmp
    };
}
function justifyContent(x) {
    return {
        TAG: /* D */ 0,
        _0: "justifyContent",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "spaceBetween" || x === "stretch" || x === "spaceAround" || x === "spaceEvenly" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DistributedAlignment.toString */ .H3.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PositionalAlignment.toString */ .F.toString(x)
    };
}
function justifyItems(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OverflowAlignment.toString */ .rL.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "legacyRight" || x === "legacy" || x === "legacyLeft" || x === "legacyCenter" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .LegacyAlignment.toString */ .gg.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BaselineAlignment.toString */ .b4.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .NormalAlignment.toString */ .GY.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PositionalAlignment.toString */ .F.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "justifyItems",
        _1: tmp
    };
}
function left(x) {
    return {
        TAG: /* D */ 0,
        _0: "left",
        _1: string_of_position(x)
    };
}
function letterSpacing(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .LetterSpacing.toString */ .LK.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "letterSpacing",
        _1: tmp
    };
}
function lineHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "abs" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .LineHeight.toString */ .L3.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .LineHeight.toString */ .L3.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "lineHeight",
        _1: tmp
    };
}
function listStyle(style, position, image) {
    return {
        TAG: /* D */ 0,
        _0: "listStyle",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStyleType.toString */ .LE.toString(style) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStylePosition.toString */ .t.toString(position) + (" " + (typeof image === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(image) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStyleImage.toString */ .NP.toString(image)))))
    };
}
function listStyleImage(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStyleImage",
        _1: typeof x === "object" ? x.NAME === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStyleImage.toString */ .NP.toString(x)
    };
}
function listStyleType(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStyleType",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStyleType.toString */ .LE.toString(x)
    };
}
function listStylePosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "listStylePosition",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "inside" || x === "outside" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ListStylePosition.toString */ .t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function marginToString(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else if (x === "zero") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
        } else {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Margin.toString */ .Zt.toString(x);
        }
    }
    var variant = x.NAME;
    if (variant === "var" || variant === "varDefault") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    }
}
function margin(x) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(x)
    };
}
function margin2(v, h) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(v) + (" " + marginToString(h))
    };
}
function margin3(top, h, bottom) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(top) + (" " + (marginToString(h) + (" " + marginToString(bottom))))
    };
}
function margin4(top, right, bottom, left) {
    return {
        TAG: /* D */ 0,
        _0: "margin",
        _1: marginToString(top) + (" " + (marginToString(right) + (" " + (marginToString(bottom) + (" " + marginToString(left))))))
    };
}
function marginLeft(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginLeft",
        _1: marginToString(x)
    };
}
function marginRight(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginRight",
        _1: marginToString(x)
    };
}
function marginTop(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginTop",
        _1: marginToString(x)
    };
}
function marginBottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "marginBottom",
        _1: marginToString(x)
    };
}
function maxHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaxHeight.toString */ .En.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "maxHeight",
        _1: tmp
    };
}
function maxWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MaxWidth.toString */ .Pm.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "maxWidth",
        _1: tmp
    };
}
function minHeight(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MinHeight.toString */ .z6.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Height.toString */ .oU.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "minHeight",
        _1: tmp
    };
}
function minWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "none" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .MinWidth.toString */ .O$.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "minWidth",
        _1: tmp
    };
}
function objectFit(x) {
    return {
        TAG: /* D */ 0,
        _0: "objectFit",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ObjectFit.toString */ .h$.toString(x)
    };
}
function objectPosition(x) {
    return {
        TAG: /* D */ 0,
        _0: "objectPosition",
        _1: string_of_backgroundposition(x)
    };
}
function opacity(x) {
    return {
        TAG: /* D */ 0,
        _0: "opacity",
        _1: x.toString()
    };
}
function outline(size, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "outline",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(size) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OutlineStyle.toString */ ._5.toString(style) + (" " + string_of_color(color))))
    };
}
function outlineColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineColor",
        _1: string_of_color(x)
    };
}
function outlineOffset(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineOffset",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function outlineStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineStyle",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OutlineStyle.toString */ ._5.toString(x)
    };
}
function outlineWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "outlineWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function overflow(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflow",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowX(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowX",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowY(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowY",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Overflow.toString */ .nP.toString(x)
    };
}
function overflowWrap(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowWrap",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "breakWord" || x === "anywhere" || x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OverflowWrap.toString */ .mn.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function padding(x) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function padding2(v, h) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(v) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(h))
    };
}
function padding3(top, h, bottom) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(top) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(h) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(bottom))))
    };
}
function padding4(top, right, bottom, left) {
    return {
        TAG: /* D */ 0,
        _0: "padding",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(top) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(right) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(bottom) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(left))))))
    };
}
function paddingBottom(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingBottom",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingLeft(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingLeft",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingRight(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingRight",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function paddingTop(x) {
    return {
        TAG: /* D */ 0,
        _0: "paddingTop",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function perspective(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Perspective.toString */ .XS.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "perspective",
        _1: tmp
    };
}
function perspectiveOrigin(x, y) {
    return {
        TAG: /* D */ 0,
        _0: "perspectiveOrigin",
        _1: (typeof x === "object" || x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Perspective.toString */ .XS.toString(x)) + (" " + (typeof y === "object" || y === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(y) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Perspective.toString */ .XS.toString(y)))
    };
}
function pointerEvents(x) {
    return {
        TAG: /* D */ 0,
        _0: "pointerEvents",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PointerEvents.toString */ .Ox.toString(x)
    };
}
function position(x) {
    return {
        TAG: /* D */ 0,
        _0: "position",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Position.toString */ .Ly.toString(x)
    };
}
function isolation(x) {
    return {
        TAG: /* D */ 0,
        _0: "isolation",
        _1: x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Isolation.toString */ .UM.toString(x)
    };
}
function justifySelf(x) {
    return {
        TAG: /* D */ 0,
        _0: "justifySelf",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "selfStart" || x === "flexEnd" || x === "flexStart" || x === "center" || x === "start" || x === "selfEnd" || x === "right" || x === "left" || x === "end_" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .PositionalAlignment.toString */ .F.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "baseline" || x === "firstBaseline" || x === "lastBaseline" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BaselineAlignment.toString */ .b4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .JustifySelf.toString */ .lo.toString(x)
    };
}
function resize(x) {
    return {
        TAG: /* D */ 0,
        _0: "resize",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Resize.toString */ .t$.toString(x)
    };
}
function right(x) {
    return {
        TAG: /* D */ 0,
        _0: "right",
        _1: string_of_position(x)
    };
}
function tableLayout(x) {
    return {
        TAG: /* D */ 0,
        _0: "tableLayout",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TableLayout.toString */ .df.toString(x)
    };
}
function textAlign(x) {
    return {
        TAG: /* D */ 0,
        _0: "textAlign",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextAlign.toString */ .PH.toString(x)
    };
}
function textDecorationColor(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "textDecorationColor",
        _1: tmp
    };
}
function textDecorationLine(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecorationLine",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextDecorationLine.toString */ .BF.toString(x)
    };
}
function textDecorationStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecorationStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "double" || x === "dotted" || x === "dashed" || x === "solid" || x === "wavy" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextDecorationStyle.toString */ .X4.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function textIndent(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "textIndent",
        _1: tmp
    };
}
function textOverflow(x) {
    return {
        TAG: /* D */ 0,
        _0: "textOverflow",
        _1: typeof x === "object" ? x.NAME === "string" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextOverflow.toString */ .lG.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextOverflow.toString */ .lG.toString(x)
    };
}
function textTransform(x) {
    return {
        TAG: /* D */ 0,
        _0: "textTransform",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TextTransform.toString */ .ty.toString(x)
    };
}
function top(x) {
    return {
        TAG: /* D */ 0,
        _0: "top",
        _1: string_of_position(x)
    };
}
function transform(x) {
    return {
        TAG: /* D */ 0,
        _0: "transform",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.toString */ .wx.toString(x) : "none"
    };
}
function transforms(x) {
    return {
        TAG: /* D */ 0,
        _0: "transform",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.toString */ .wx.toString), " ")
    };
}
function transformOrigin(x, y) {
    return {
        TAG: /* D */ 0,
        _0: "transformOrigin",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(y))
    };
}
function transformOrigin3d(x, y, z) {
    return {
        TAG: /* D */ 0,
        _0: "transformOrigin",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(y) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(z) + " "))))
    };
}
function unsafe(property, value) {
    return {
        TAG: /* D */ 0,
        _0: property,
        _1: value
    };
}
function userSelect(x) {
    return {
        TAG: /* D */ 0,
        _0: "userSelect",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .UserSelect.toString */ .oF.toString(x)
    };
}
function verticalAlign(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "textTop" || x === "textBottom" || x === "baseline" || x === "super" || x === "top" || x === "sub" || x === "bottom" || x === "middle" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .VerticalAlign.toString */ .g$.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "verticalAlign",
        _1: tmp
    };
}
function visibility(x) {
    return {
        TAG: /* D */ 0,
        _0: "visibility",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Visibility.toString */ .EE.toString(x)
    };
}
function scrollBehavior(x) {
    return {
        TAG: /* D */ 0,
        _0: "scrollBehavior",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ScrollBehavior.toString */ .JT.toString(x)
    };
}
function overscrollBehavior(x) {
    return {
        TAG: /* D */ 0,
        _0: "overscrollBehavior",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OverscrollBehavior.toString */ .CB.toString(x)
    };
}
function overflowAnchor(x) {
    return {
        TAG: /* D */ 0,
        _0: "overflowAnchor",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .OverflowAnchor.toString */ .s2.toString(x)
    };
}
function columnWidth(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .ColumnWidth.toString */ .aB.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "columnWidth",
        _1: tmp
    };
}
function caretColor(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .CaretColor.toString */ .vC.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "caretColor",
        _1: tmp
    };
}
function width(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Width.toString */ .Lu.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "width",
        _1: tmp
    };
}
function whiteSpace(x) {
    return {
        TAG: /* D */ 0,
        _0: "whiteSpace",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "nowrap" || x === "normal" || x === "breakSpaces" || x === "preWrap" || x === "preLine" || x === "pre" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .WhiteSpace.toString */ .nZ.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function wordBreak(x) {
    return {
        TAG: /* D */ 0,
        _0: "wordBreak",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "keepAll" || x === "normal" || x === "breakAll" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .WordBreak.toString */ .I5.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x)
    };
}
function wordSpacing(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "percent" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.toString */ .$t.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x);
    } else {
        tmp = x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : x === "normal" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .WordSpacing.toString */ .qb.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    }
    return {
        TAG: /* D */ 0,
        _0: "wordSpacing",
        _1: tmp
    };
}
function zIndex(x) {
    return {
        TAG: /* D */ 0,
        _0: "zIndex",
        _1: x.toString()
    };
}
function media(query, rules) {
    return {
        TAG: /* S */ 1,
        _0: "@media " + query,
        _1: rules
    };
}
function selector(selector$1, rules) {
    return {
        TAG: /* S */ 1,
        _0: selector$1,
        _1: rules
    };
}
function active(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "active",
        _1: param
    };
}
function checked(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "checked",
        _1: param
    };
}
function $$default(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "default",
        _1: param
    };
}
function defined(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "defined",
        _1: param
    };
}
function disabled(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "disabled",
        _1: param
    };
}
function empty(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "empty",
        _1: param
    };
}
function enabled(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "enabled",
        _1: param
    };
}
function first(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first",
        _1: param
    };
}
function firstChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first-child",
        _1: param
    };
}
function firstOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "first-of-type",
        _1: param
    };
}
function focus(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus",
        _1: param
    };
}
function focusVisible(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus-visible",
        _1: param
    };
}
function focusWithin(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "focus-within",
        _1: param
    };
}
function host(selector, rules) {
    if (selector !== undefined) {
        return {
            TAG: /* PseudoClassParam */ 3,
            _0: "host",
            _1: selector,
            _2: rules
        };
    } else {
        return {
            TAG: /* PseudoClass */ 2,
            _0: "host",
            _1: rules
        };
    }
}
function hover(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "hover",
        _1: param
    };
}
function indeterminate(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "indeterminate",
        _1: param
    };
}
function inRange(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "in-range",
        _1: param
    };
}
function invalid(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "invalid",
        _1: param
    };
}
function lang(code, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "lang",
        _1: code,
        _2: rules
    };
}
function lastChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "last-child",
        _1: param
    };
}
function lastOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "last-of-type",
        _1: param
    };
}
function link(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "link",
        _1: param
    };
}
function not_(selector, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "not",
        _1: selector,
        _2: rules
    };
}
function toString(x) {
    if (typeof x !== "object") {
        if (x === "odd") {
            return "odd";
        } else {
            return "even";
        }
    }
    if (x.NAME !== "add") {
        return x.VAL.toString() + "n";
    }
    var match = x.VAL;
    return match[0].toString() + ("n+" + match[1].toString());
}
var Nth = {
    toString: toString
};
function nthChild(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-child",
        _1: toString(x),
        _2: rules
    };
}
function nthLastChild(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-last-child",
        _1: toString(x),
        _2: rules
    };
}
function nthLastOfType(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-last-of-type",
        _1: toString(x),
        _2: rules
    };
}
function nthOfType(x, rules) {
    return {
        TAG: /* PseudoClassParam */ 3,
        _0: "nth-of-type",
        _1: toString(x),
        _2: rules
    };
}
function onlyChild(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "only-child",
        _1: param
    };
}
function onlyOfType(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "only-of-type",
        _1: param
    };
}
function optional(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "optional",
        _1: param
    };
}
function outOfRange(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "out-of-range",
        _1: param
    };
}
function readOnly(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "read-only",
        _1: param
    };
}
function readWrite(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "read-write",
        _1: param
    };
}
function required(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "required",
        _1: param
    };
}
function root(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "root",
        _1: param
    };
}
function scope(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "scope",
        _1: param
    };
}
function target(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "target",
        _1: param
    };
}
function valid(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "valid",
        _1: param
    };
}
function visited(param) {
    return {
        TAG: /* PseudoClass */ 2,
        _0: "visited",
        _1: param
    };
}
function after(param) {
    return {
        TAG: /* S */ 1,
        _0: "::after",
        _1: param
    };
}
function before(param) {
    return {
        TAG: /* S */ 1,
        _0: "::before",
        _1: param
    };
}
function firstLetter(param) {
    return {
        TAG: /* S */ 1,
        _0: "::first-letter",
        _1: param
    };
}
function firstLine(param) {
    return {
        TAG: /* S */ 1,
        _0: "::first-line",
        _1: param
    };
}
function selection(param) {
    return {
        TAG: /* S */ 1,
        _0: "::selection",
        _1: param
    };
}
function child(x) {
    var partial_arg = " > " + x;
    return function(param) {
        return {
            TAG: /* S */ 1,
            _0: partial_arg,
            _1: param
        };
    };
}
function children(param) {
    return {
        TAG: /* S */ 1,
        _0: " > *",
        _1: param
    };
}
function directSibling(param) {
    return {
        TAG: /* S */ 1,
        _0: " + ",
        _1: param
    };
}
function placeholder(param) {
    return {
        TAG: /* S */ 1,
        _0: "::placeholder",
        _1: param
    };
}
function siblings(param) {
    return {
        TAG: /* S */ 1,
        _0: " ~ ",
        _1: param
    };
}
function anyLink(param) {
    return {
        TAG: /* S */ 1,
        _0: ":any-link",
        _1: param
    };
}
var initial = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.initial */ .x9.initial;
var inherit_ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.inherit_ */ .x9.inherit_;
var unset = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.unset */ .x9.unset;
var $$var = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.$$var */ .nd.$$var;
var varDefault = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.varDefault */ .nd.varDefault;
var pct = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Percentage.pct */ .$t.pct;
var ch = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.ch */ .Gy.ch;
var cm = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.cm */ .Gy.cm;
var em = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.em */ .Gy.em;
var ex = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.ex */ .Gy.ex;
var mm = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.mm */ .Gy.mm;
var pt = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.pt */ .Gy.pt;
var px = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.px */ .Gy.px;
var pxFloat = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.pxFloat */ .Gy.pxFloat;
var rem = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.rem */ .Gy.rem;
var vh = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.vh */ .Gy.vh;
var vmin = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.vmin */ .Gy.vmin;
var vmax = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.vmax */ .Gy.vmax;
var zero = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.zero */ .Gy.zero;
var deg = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Angle.deg */ .RZ.deg;
var rad = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Angle.rad */ .RZ.rad;
var grad = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Angle.grad */ .RZ.grad;
var turn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Angle.turn */ .RZ.turn;
var ltr = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Direction.ltr */ .Nm.ltr;
var rtl = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Direction.rtl */ .Nm.rtl;
var absolute = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Position.absolute */ .Ly.absolute;
var relative = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Position.relative */ .Ly.relative;
var $$static = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Position.$$static */ .Ly.$$static;
var sticky = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Position.sticky */ .Ly.sticky;
var horizontal = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Resize.horizontal */ .t$.horizontal;
var vertical = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Resize.vertical */ .t$.vertical;
var smallCaps = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontVariant.smallCaps */ .HS.smallCaps;
var italic = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontStyle.italic */ .Hd.italic;
var oblique = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontStyle.oblique */ .Hd.oblique;
var rgb = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.rgb */ .Il.rgb;
var rgba = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.rgba */ .Il.rgba;
var hsl = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.hsl */ .Il.hsl;
var hsla = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.hsla */ .Il.hsla;
var hex = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.hex */ .Il.hex;
var currentColor = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.currentColor */ .Il.currentColor;
var transparent = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.transparent */ .Il.transparent;
var linear = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.linear */ .Ms.linear;
var ease = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.ease */ .Ms.ease;
var easeIn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.easeIn */ .Ms.easeIn;
var easeInOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.easeInOut */ .Ms.easeInOut;
var easeOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.easeOut */ .Ms.easeOut;
var stepStart = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.stepStart */ .Ms.stepStart;
var stepEnd = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.stepEnd */ .Ms.stepEnd;
var steps = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.steps */ .Ms.steps;
var cubicBezier = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.cubicBezier */ .Ms.cubicBezier;
var marginBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GeometryBox.marginBox */ .lf.marginBox;
var fillBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GeometryBox.fillBox */ .lf.fillBox;
var strokeBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GeometryBox.strokeBox */ .lf.strokeBox;
var viewBox = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GeometryBox.viewBox */ .lf.viewBox;
var translate = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.translate */ .wx.translate;
var translate3d = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.translate3d */ .wx.translate3d;
var translateX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.translateX */ .wx.translateX;
var translateY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.translateY */ .wx.translateY;
var translateZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.translateZ */ .wx.translateZ;
var scaleX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.scaleX */ .wx.scaleX;
var scaleY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.scaleY */ .wx.scaleY;
var scaleZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.scaleZ */ .wx.scaleZ;
var rotateX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.rotateX */ .wx.rotateX;
var rotateY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.rotateY */ .wx.rotateY;
var rotateZ = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.rotateZ */ .wx.rotateZ;
var scale = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.scale */ .wx.scale;
var scale3d = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.scale3d */ .wx.scale3d;
var skew = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.skew */ .wx.skew;
var skewX = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.skewX */ .wx.skewX;
var skewY = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Transform.skewY */ .wx.skewY;
var thin = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.thin */ .U9.thin;
var extraLight = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.extraLight */ .U9.extraLight;
var light = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.light */ .U9.light;
var medium = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.medium */ .U9.medium;
var semiBold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.semiBold */ .U9.semiBold;
var bold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.bold */ .U9.bold;
var extraBold = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.extraBold */ .U9.extraBold;
var lighter = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.lighter */ .U9.lighter;
var bolder = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FontWeight.bolder */ .U9.bolder;
var linearGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.linearGradient */ .ph.linearGradient;
var repeatingLinearGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.repeatingLinearGradient */ .ph.repeatingLinearGradient;
var radialGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.radialGradient */ .ph.radialGradient;
var repeatingRadialGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.repeatingRadialGradient */ .ph.repeatingRadialGradient;
var conicGradient = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.conicGradient */ .ph.conicGradient;
function areas(items) {
    return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridTemplateAreas.areas */ .$7.areas(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .toArray */ .qo(items));
}
var ident = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.ident */ .y5.ident;
var numIdent = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.numIdent */ .y5.numIdent;
var contextMenu = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.contextMenu */ .CF.contextMenu;
var help = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.help */ .CF.help;
var pointer = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.pointer */ .CF.pointer;
var progress = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.progress */ .CF.progress;
var wait = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.wait */ .CF.wait;
var cell = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.cell */ .CF.cell;
var crosshair = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.crosshair */ .CF.crosshair;
var verticalText = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.verticalText */ .CF.verticalText;
var alias = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.alias */ .CF.alias;
var copy = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.copy */ .CF.copy;
var move = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.move */ .CF.move;
var noDrop = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.noDrop */ .CF.noDrop;
var notAllowed = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.notAllowed */ .CF.notAllowed;
var grab = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.grab */ .CF.grab;
var grabbing = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.grabbing */ .CF.grabbing;
var allScroll = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.allScroll */ .CF.allScroll;
var colResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.colResize */ .CF.colResize;
var rowResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.rowResize */ .CF.rowResize;
var nResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.nResize */ .CF.nResize;
var eResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.eResize */ .CF.eResize;
var sResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.sResize */ .CF.sResize;
var wResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.wResize */ .CF.wResize;
var neResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.neResize */ .CF.neResize;
var nwResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.nwResize */ .CF.nwResize;
var seResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.seResize */ .CF.seResize;
var swResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.swResize */ .CF.swResize;
var ewResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.ewResize */ .CF.ewResize;
var nsResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.nsResize */ .CF.nsResize;
var neswResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.neswResize */ .CF.neswResize;
var nwseResize = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.nwseResize */ .CF.nwseResize;
var zoomIn = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.zoomIn */ .CF.zoomIn;
var zoomOut = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cursor.zoomOut */ .CF.zoomOut;
function vw(x) {
    return {
        NAME: "vw",
        VAL: x
    };
}
function fr(x) {
    return {
        NAME: "fr",
        VAL: x
    };
}
function $neg(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "sub",
            a,
            b
        ]
    };
}
function $plus(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "add",
            a,
            b
        ]
    };
}
function $star(a, b) {
    return {
        NAME: "calc",
        VAL: [
            "mult",
            a,
            b
        ]
    };
}
var Calc = {
    $neg: $neg,
    $plus: $plus,
    $star: $star
};
function size(x, y) {
    return {
        NAME: "size",
        VAL: [
            x,
            y
        ]
    };
}
function count(x) {
    return {
        NAME: "count",
        VAL: x
    };
}
function localUrl(x) {
    return {
        NAME: "localUrl",
        VAL: x
    };
}
function rotate(a) {
    return {
        NAME: "rotate",
        VAL: a
    };
}
function rotate3d(x, y, z, a) {
    return {
        NAME: "rotate3d",
        VAL: [
            x,
            y,
            z,
            a
        ]
    };
}
function url(x) {
    return {
        NAME: "url",
        VAL: x
    };
}
function flex3(grow, shrink, basis) {
    return {
        TAG: /* D */ 0,
        _0: "flex",
        _1: grow.toString() + (" " + (shrink.toString() + (" " + (typeof basis === "object" || basis === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(basis) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FlexBasis.toString */ .Sb.toString(basis)))))
    };
}
function flexBasis(x) {
    return {
        TAG: /* D */ 0,
        _0: "flexBasis",
        _1: typeof x === "object" || x === "zero" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .FlexBasis.toString */ .Sb.toString(x)
    };
}
function order(x) {
    return {
        TAG: /* D */ 0,
        _0: "order",
        _1: x.toString()
    };
}
function string_of_minmax(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    var match = x.VAL;
    var match$1 = match[0];
    if (match$1 === "add") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[1]) + (" + " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[2]) + ")")));
    } else if (match$1 === "sub") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[1]) + (" - " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[2]) + ")")));
    } else {
        return "calc(" + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[1]) + " * " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[2]) + ")";
    }
}
function string_of_dimension(x) {
    if (typeof x !== "object") {
        if (x === "none") {
            return "none";
        } else if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "fitContent") {
            return "fit-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "minmax") {
        var match = x.VAL;
        return "minmax(" + (string_of_minmax(match[0]) + ("," + (string_of_minmax(match[1]) + ")")));
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    var match$1 = x.VAL;
    var match$2 = match$1[0];
    if (match$2 === "add") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[1]) + (" + " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[2]) + ")")));
    } else if (match$2 === "sub") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[1]) + (" - " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[2]) + ")")));
    } else {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[1]) + (" * " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$1[2]) + ")")));
    }
}
function gridLengthToJs(x) {
    if (typeof x !== "object") {
        if (x === "zero") {
            return "0";
        } else if (x === "minContent") {
            return "min-content";
        } else if (x === "maxContent") {
            return "max-content";
        } else {
            return "auto";
        }
    }
    var variant = x.NAME;
    if (variant === "pxFloat") {
        return x.VAL.toString() + "px";
    }
    if (variant === "inch") {
        return x.VAL.toString() + "in";
    }
    if (variant === "vmax") {
        return x.VAL.toString() + "vmax";
    }
    if (variant === "vmin") {
        return x.VAL.toString() + "vmin";
    }
    if (variant === "minmax") {
        var match = x.VAL;
        return "minmax(" + (string_of_minmax(match[0]) + ("," + (string_of_minmax(match[1]) + ")")));
    }
    if (variant === "percent") {
        return x.VAL.toString() + "%";
    }
    if (variant === "ch") {
        return x.VAL.toString() + "ch";
    }
    if (variant === "cm") {
        return x.VAL.toString() + "cm";
    }
    if (variant === "em") {
        return x.VAL.toString() + "em";
    }
    if (variant === "ex") {
        return x.VAL.toString() + "ex";
    }
    if (variant === "fr") {
        return x.VAL.toString() + "fr";
    }
    if (variant === "mm") {
        return x.VAL.toString() + "mm";
    }
    if (variant === "pc") {
        return x.VAL.toString() + "pc";
    }
    if (variant === "pt") {
        return x.VAL.toString() + "pt";
    }
    if (variant === "px") {
        return x.VAL.toString() + "px";
    }
    if (variant === "vh") {
        return x.VAL.toString() + "vh";
    }
    if (variant === "vw") {
        return x.VAL.toString() + "vw";
    }
    if (variant === "rem") {
        return x.VAL.toString() + "rem";
    }
    if (variant === "repeat") {
        var match$1 = x.VAL;
        return "repeat(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .RepeatValue.toString */ .dU.toString(match$1[0]) + (", " + (string_of_dimension(match$1[1]) + ")")));
    }
    var match$2 = x.VAL;
    var match$3 = match$2[0];
    if (match$3 === "add") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[1]) + (" + " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[2]) + ")")));
    } else if (match$3 === "sub") {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[1]) + (" - " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[2]) + ")")));
    } else {
        return "calc(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[1]) + (" * " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match$2[2]) + ")")));
    }
}
function string_of_dimensions(dimensions) {
    return _rescript_std_lib_es6_string_js__WEBPACK_IMPORTED_MODULE_1__/* .concat */ .zo(" ", _rescript_std_lib_es6_list_js__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI(gridLengthToJs, dimensions));
}
function gridTemplateColumns(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateColumns",
        _1: string_of_dimensions(dimensions)
    };
}
function gridTemplateRows(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateRows",
        _1: string_of_dimensions(dimensions)
    };
}
function gridAutoColumns(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoColumns",
        _1: string_of_dimension(dimensions)
    };
}
function gridAutoRows(dimensions) {
    return {
        TAG: /* D */ 0,
        _0: "gridAutoRows",
        _1: string_of_dimension(dimensions)
    };
}
function gridArea(s) {
    var tmp;
    if (typeof s === "object") {
        var variant = s.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(s) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s);
    } else {
        tmp = s === "unset" || s === "inherit_" || s === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(s) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s);
    }
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: tmp
    };
}
function gridArea2(s, s2) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s) + (" / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s2))
    };
}
function gridArea3(s, s2, s3) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s) + (" / " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s2) + (" / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s3))))
    };
}
function gridArea4(s, s2, s3, s4) {
    return {
        TAG: /* D */ 0,
        _0: "gridArea",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s) + (" / " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s2) + (" / " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s3) + (" / " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridArea.toString */ .y5.toString(s4))))))
    };
}
function gridTemplateAreas(l) {
    return {
        TAG: /* D */ 0,
        _0: "gridTemplateAreas",
        _1: typeof l === "object" ? l.NAME === "areas" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridTemplateAreas.toString */ .$7.toString(l) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(l) : l === "unset" || l === "inherit_" || l === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(l) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .GridTemplateAreas.toString */ .$7.toString(l)
    };
}
function string_of_filter(x) {
    if (typeof x !== "object") {
        if (x === "unset" || x === "inherit_" || x === "initial") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
        } else {
            return "none";
        }
    }
    var variant = x.NAME;
    if (variant !== "dropShadow") {
        if (variant === "brightness") {
            return "brightness(" + (x.VAL.toString() + "%)");
        } else if (variant === "opacity") {
            return "opacity(" + (x.VAL.toString() + "%)");
        } else if (variant === "var" || variant === "varDefault") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
        } else if (variant === "grayscale") {
            return "grayscale(" + (x.VAL.toString() + "%)");
        } else if (variant === "sepia") {
            return "sepia(" + (x.VAL.toString() + "%)");
        } else if (variant === "saturate") {
            return "saturate(" + (x.VAL.toString() + "%)");
        } else if (variant === "url") {
            return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x);
        } else if (variant === "invert") {
            return "invert(" + (x.VAL.toString() + "%)");
        } else if (variant === "contrast") {
            return "contrast(" + (x.VAL.toString() + "%)");
        } else if (variant === "hueRotate") {
            return "hue-rotate(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Angle.toString */ .RZ.toString(x.VAL) + ")");
        } else {
            return "blur(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x.VAL) + ")");
        }
    }
    var match = x.VAL;
    return "drop-shadow(" + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[0]) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[1]) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[2]) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(match[3]) + ")")))))));
}
function filter(x) {
    return {
        TAG: /* D */ 0,
        _0: "filter",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, string_of_filter), " ")
    };
}
function box(xOpt, yOpt, blurOpt, spreadOpt, insetOpt, color) {
    var x = xOpt !== undefined ? xOpt : zero;
    var y = yOpt !== undefined ? yOpt : zero;
    var blur = blurOpt !== undefined ? blurOpt : zero;
    var spread = spreadOpt !== undefined ? spreadOpt : zero;
    var inset = insetOpt !== undefined ? insetOpt : false;
    return {
        NAME: "shadow",
        VAL: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(y) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(blur) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(spread) + (" " + (string_of_color(color) + (inset ? " inset" : "")))))))))
    };
}
function text(xOpt, yOpt, blurOpt, color) {
    var x = xOpt !== undefined ? xOpt : zero;
    var y = yOpt !== undefined ? yOpt : zero;
    var blur = blurOpt !== undefined ? blurOpt : zero;
    return {
        NAME: "shadow",
        VAL: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(y) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(blur) + (" " + string_of_color(color))))))
    };
}
function toString$1(x) {
    if (typeof x === "object") {
        return x.VAL;
    } else {
        return "none";
    }
}
var Shadow = {
    box: box,
    text: text,
    toString: toString$1
};
function boxShadow(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxShadow",
        _1: typeof x === "object" ? x.NAME === "shadow" ? toString$1(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : toString$1(x)
    };
}
function boxShadows(x) {
    return {
        TAG: /* D */ 0,
        _0: "boxShadow",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, toString$1), ", ")
    };
}
function string_of_borderstyle(x) {
    if (typeof x === "object") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x);
    } else if (x === "unset" || x === "inherit_" || x === "initial") {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x);
    } else {
        return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .BorderStyle.toString */ .N4.toString(x);
    }
}
function border(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "border",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
    };
}
function borderStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderLeft(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeft",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
    };
}
function borderLeftStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderLeftStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderRight(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderRight",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
    };
}
function borderRightStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderRightStyle",
        _1: string_of_borderstyle(x)
    };
}
function borderTop(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderTop",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
    };
}
function borderTopStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: " ",
        _1: string_of_borderstyle(x)
    };
}
function borderBottom(px, style, color) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottom",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(px) + (" " + (string_of_borderstyle(style) + (" " + string_of_color(color))))
    };
}
function borderBottomStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "borderBottomStyle",
        _1: string_of_borderstyle(x)
    };
}
function background(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.toString */ .ph.toString(x) : variant === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x) : "none";
    }
    return {
        TAG: /* D */ 0,
        _0: "background",
        _1: tmp
    };
}
function backgrounds(x) {
    return {
        TAG: /* D */ 0,
        _0: "background",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, function(item) {
            if (typeof item !== "object") {
                if (item === "transparent" || item === "currentColor") {
                    return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(item);
                } else {
                    return "none";
                }
            }
            var variant = item.NAME;
            if (variant === "linearGradient" || variant === "radialGradient" || variant === "repeatingLinearGradient" || variant === "repeatingRadialGradient" || variant === "conicGradient") {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Gradient.toString */ .ph.toString(item);
            } else if (variant === "url") {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(item);
            } else {
                return _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(item);
            }
        }), ", ")
    };
}
function backgroundSize(x) {
    var tmp;
    if (typeof x === "object") {
        var match = x.VAL;
        tmp = _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[0]) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(match[1]));
    } else {
        tmp = x === "cover" ? "cover" : x === "contain" ? "contain" : "auto";
    }
    return {
        TAG: /* D */ 0,
        _0: "backgroundSize",
        _1: tmp
    };
}
function fontFace(fontFamily, src, fontStyle, fontWeight, fontDisplay, param) {
    var fontStyle$1 = Js_option.map(function(value) {
        return Css_AtomicTypes.FontStyle.toString(value);
    }, fontStyle);
    var src$1 = $$String.concat(", ", List.map(function(x) {
        if (x.NAME === "url") {
            return 'url("' + x.VAL + '")';
        } else {
            return 'local("' + x.VAL + '")';
        }
    }, src));
    var fontStyle$2 = Belt_Option.mapWithDefault(fontStyle$1, "", function(s) {
        return "font-style: " + (s + ";");
    });
    var fontWeight$1 = Belt_Option.mapWithDefault(fontWeight, "", function(w) {
        return "font-weight: " + ((typeof w === "object" ? w.NAME === "num" ? Css_AtomicTypes.FontWeight.toString(w) : Css_AtomicTypes.Var.toString(w) : w === "unset" || w === "inherit_" || w === "initial" ? Css_AtomicTypes.Cascading.toString(w) : Css_AtomicTypes.FontWeight.toString(w)) + ";");
    });
    var fontDisplay$1 = Belt_Option.mapWithDefault(fontDisplay, "", function(f) {
        return "font-display: " + (Css_AtomicTypes.FontDisplay.toString(f) + ";");
    });
    return "@font-face {\r\n     font-family: " + fontFamily + ";\r\n     src: " + src$1 + ";\r\n     " + fontStyle$2 + "\r\n     " + fontWeight$1 + "\r\n     " + fontDisplay$1 + "\r\n   }";
}
function textDecoration(x) {
    return {
        TAG: /* D */ 0,
        _0: "textDecoration",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "none" ? "none" : x === "initial" ? "initial" : x === "inherit_" ? "inherit" : x === "underline" ? "underline" : x === "lineThrough" ? "line-through" : x === "unset" ? "unset" : "overline"
    };
}
function textShadow(x) {
    return {
        TAG: /* D */ 0,
        _0: "textShadow",
        _1: typeof x === "object" ? x.NAME === "shadow" ? toString$1(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : toString$1(x)
    };
}
function textShadows(x) {
    return {
        TAG: /* D */ 0,
        _0: "textShadow",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, toString$1), ", ")
    };
}
function transformStyle(x) {
    return {
        TAG: /* D */ 0,
        _0: "transformStyle",
        _1: typeof x === "object" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : x === "unset" || x === "inherit_" || x === "initial" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Cascading.toString */ .x9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TransformStyle.toString */ .wJ.toString(x)
    };
}
function shorthand(durationOpt, delayOpt, timingFunctionOpt, property) {
    var duration = durationOpt !== undefined ? durationOpt : 0;
    var delay = delayOpt !== undefined ? delayOpt : 0;
    var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
    return {
        NAME: "value",
        VAL: duration.toString() + "ms " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.toString */ .Ms.toString(timingFunction) + (" " + (delay.toString() + "ms " + property)))
    };
}
function toString$2(x) {
    return x.VAL;
}
var Transition = {
    shorthand: shorthand,
    toString: toString$2
};
function transitionValue(x) {
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: x.VAL
    };
}
function transitionList(x) {
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, toString$2), ", ")
    };
}
function transition(duration, delay, timingFunction, property) {
    var x = shorthand(duration, delay, timingFunction, property);
    return {
        TAG: /* D */ 0,
        _0: "transition",
        _1: x.VAL
    };
}
function transitionDelay(i) {
    return {
        TAG: /* D */ 0,
        _0: "transitionDelay",
        _1: i.toString() + "ms"
    };
}
function transitionDuration(i) {
    return {
        TAG: /* D */ 0,
        _0: "transitionDuration",
        _1: i.toString() + "ms"
    };
}
function transitionTimingFunction(x) {
    return {
        TAG: /* D */ 0,
        _0: "transitionTimingFunction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.toString */ .Ms.toString(x)
    };
}
function transitionProperty(x) {
    return {
        TAG: /* D */ 0,
        _0: "transitionProperty",
        _1: x
    };
}
function shorthand$1(durationOpt, delayOpt, directionOpt, timingFunctionOpt, fillModeOpt, playStateOpt, iterationCountOpt, name) {
    var duration = durationOpt !== undefined ? durationOpt : 0;
    var delay = delayOpt !== undefined ? delayOpt : 0;
    var direction = directionOpt !== undefined ? directionOpt : "normal";
    var timingFunction = timingFunctionOpt !== undefined ? timingFunctionOpt : "ease";
    var fillMode = fillModeOpt !== undefined ? fillModeOpt : "none";
    var playState = playStateOpt !== undefined ? playStateOpt : "running";
    var iterationCount = iterationCountOpt !== undefined ? iterationCountOpt : {
        NAME: "count",
        VAL: 1
    };
    return {
        NAME: "value",
        VAL: name + (" " + (duration.toString() + "ms " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TimingFunction.toString */ .Ms.toString(timingFunction) + (" " + (delay.toString() + "ms " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationIterationCount.toString */ .qX.toString(iterationCount) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationDirection.toString */ .sc.toString(direction) + (" " + (_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationFillMode.toString */ .yy.toString(fillMode) + (" " + _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .AnimationPlayState.toString */ .Lo.toString(playState))))))))))))
    };
}
function toString$3(x) {
    return x.VAL;
}
var Animation = {
    shorthand: shorthand$1,
    toString: toString$3
};
function animationValue(x) {
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: x.VAL
    };
}
function animation(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name) {
    var x = shorthand$1(duration, delay, direction, timingFunction, fillMode, playState, iterationCount, name);
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: x.VAL
    };
}
function animations(x) {
    return {
        TAG: /* D */ 0,
        _0: "animation",
        _1: join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x, toString$3), ", ")
    };
}
function animationName(x) {
    return {
        TAG: /* D */ 0,
        _0: "animationName",
        _1: x
    };
}
function fill(x) {
    var tmp;
    if (typeof x === "object") {
        var variant = x.NAME;
        tmp = variant === "var" || variant === "varDefault" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Var.toString */ .nd.toString(x) : variant === "url" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Url.toString */ .R9.toString(x) : _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x);
    } else {
        tmp = x === "transparent" || x === "currentColor" ? _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Color.toString */ .Il.toString(x) : _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_4__._1(_Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .SVG.Fill.toString */ .Wj.Fill.toString, x);
    }
    return {
        TAG: /* D */ 0,
        _0: "fill",
        _1: tmp
    };
}
function fillOpacity(opacity) {
    return {
        TAG: /* D */ 0,
        _0: "fillOpacity",
        _1: opacity.toString()
    };
}
function fillRule(x) {
    return {
        TAG: /* D */ 0,
        _0: "fillRule",
        _1: x === "evenodd" ? "evenodd" : "nonzero"
    };
}
function stroke(x) {
    return {
        TAG: /* D */ 0,
        _0: "stroke",
        _1: string_of_color(x)
    };
}
function strokeDasharray(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeDasharray",
        _1: typeof x === "object" ? join(_rescript_std_lib_es6_belt_List_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(x.VAL, string_of_dasharray), " ") : "none"
    };
}
function strokeWidth(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeWidth",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .Length.toString */ .Gy.toString(x)
    };
}
function strokeOpacity(opacity) {
    return {
        TAG: /* D */ 0,
        _0: "strokeOpacity",
        _1: opacity.toString()
    };
}
function strokeMiterlimit(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeMiterlimit",
        _1: x.toString()
    };
}
function strokeLinecap(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeLinecap",
        _1: x === "square" ? "square" : x === "round" ? "round" : "butt"
    };
}
function strokeLinejoin(x) {
    return {
        TAG: /* D */ 0,
        _0: "strokeLinejoin",
        _1: x === "miter" ? "miter" : x === "bevel" ? "bevel" : "round"
    };
}
function stopColor(x) {
    return {
        TAG: /* D */ 0,
        _0: "stopColor",
        _1: string_of_color(x)
    };
}
function stopOpacity(x) {
    return {
        TAG: /* D */ 0,
        _0: "stopOpacity",
        _1: x.toString()
    };
}
function touchAction(x) {
    return {
        TAG: /* D */ 0,
        _0: "touchAction",
        _1: _Css_AtomicTypes_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .TouchAction.toString */ .Nl.toString(x)
    };
}
var Types;
var wordWrap = overflowWrap;
var auto = "auto";
var none = "none";
var text$1 = "text";
var fixed = "fixed";
var isolate = "isolate";
var hidden = "hidden";
var visible = "visible";
var scroll = "scroll";
var local = "local";
var paddingBox = "paddingBox";
var borderBox = "borderBox";
var contentBox = "contentBox";
var noRepeat = "noRepeat";
var space = "space";
var repeat = "repeat";
var minmax = "minmax";
var repeatX = "repeatX";
var repeatY = "repeatY";
var contain = "contain";
var cover = "cover";
var row = "row";
var rowReverse = "rowReverse";
var column = "column";
var columnReverse = "columnReverse";
var wrap = "wrap";
var nowrap = "nowrap";
var wrapReverse = "wrapReverse";
var inline = "inline";
var block = "block";
var contents = "contents";
var flexBox = "flex";
var grid = "grid";
var inlineBlock = "inlineBlock";
var inlineFlex = "inlineFlex";
var inlineGrid = "inlineGrid";
var inlineTable = "inlineTable";
var listItem = "listItem";
var runIn = "runIn";
var table = "table";
var tableCaption = "tableCaption";
var tableColumnGroup = "tableColumnGroup";
var tableHeaderGroup = "tableHeaderGroup";
var tableFooterGroup = "tableFooterGroup";
var tableRowGroup = "tableRowGroup";
var tableCell = "tableCell";
var tableColumn = "tableColumn";
var tableRow = "tableRow";
var flexStart = "flexStart";
var flexEnd = "flexEnd";
var center = "center";
var stretch = "stretch";
var spaceBetween = "spaceBetween";
var spaceAround = "spaceAround";
var spaceEvenly = "spaceEvenly";
var baseline = "baseline";
var forwards = "forwards";
var backwards = "backwards";
var both = "both";
var infinite = "infinite";
var paused = "paused";
var running = "running";
var inside = "inside";
var outside = "outside";
var solid = "solid";
var dotted = "dotted";
var dashed = "dashed";
var underline = "underline";
var overline = "overline";
var lineThrough = "lineThrough";
var clip = "clip";
var ellipsis = "ellipsis";
var wavy = "wavy";
var $$double = "double";
var uppercase = "uppercase";
var lowercase = "lowercase";
var capitalize = "capitalize";
var sub = "sub";
var $$super = "super";
var textTop = "textTop";
var textBottom = "textBottom";
var middle = "middle";
var normal = "normal";
var breakAll = "breakAll";
var keepAll = "keepAll";
var breakWord = "breakWord";
var reverse = "reverse";
var alternate = "alternate";
var alternateReverse = "alternateReverse";
var fill$1 = "fill";
var content = "content";
var maxContent = "maxContent";
var minContent = "minContent";
var fitContent = "fitContent";
var all = "all";
var round = "round";
var miter = "miter";
var bevel = "bevel";
var butt = "butt";
var square = "square";
var panX = "panX";
var panY = "panY";
var panLeft = "panLeft";
var panRight = "panRight";
var panUp = "panUp";
var panDown = "panDown";
var pinchZoom = "pinchZoom";
var manipulation = "manipulation";
var transitions = transitionList;
var SVG = {
    fill: fill,
    fillRule: fillRule,
    fillOpacity: fillOpacity,
    stroke: stroke,
    strokeDasharray: strokeDasharray,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin,
    strokeMiterlimit: strokeMiterlimit,
    strokeWidth: strokeWidth,
    strokeOpacity: strokeOpacity,
    stopColor: stopColor,
    stopOpacity: stopOpacity
};
 /* No side effect */ 


/***/ }),

/***/ 90917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PX": function() { return /* binding */ $$Response; },
/* harmony export */   "qv": function() { return /* binding */ RequestInit; },
/* harmony export */   "rL": function() { return /* binding */ $$FormData; },
/* harmony export */   "ye": function() { return /* binding */ $$Headers; }
/* harmony export */ });
/* unused harmony exports $$AbortController, HeadersInit, BodyInit, Body, $$Request */
/* harmony import */ var _rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92592);
/* harmony import */ var _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25400);


function encodeRequestMethod(method_) {
    if (typeof method_ !== "number") {
        return method_._0;
    }
    switch(method_){
        case /* Get */ 0:
            return "GET";
        case /* Head */ 1:
            return "HEAD";
        case /* Post */ 2:
            return "POST";
        case /* Put */ 3:
            return "PUT";
        case /* Delete */ 4:
            return "DELETE";
        case /* Connect */ 5:
            return "CONNECT";
        case /* Options */ 6:
            return "OPTIONS";
        case /* Trace */ 7:
            return "TRACE";
        case /* Patch */ 8:
            return "PATCH";
    }
}
function encodeReferrerPolicy(param) {
    switch(param){
        case /* None */ 0:
            return "";
        case /* NoReferrer */ 1:
            return "no-referrer";
        case /* NoReferrerWhenDowngrade */ 2:
            return "no-referrer-when-downgrade";
        case /* SameOrigin */ 3:
            return "same-origin";
        case /* Origin */ 4:
            return "origin";
        case /* StrictOrigin */ 5:
            return "strict-origin";
        case /* OriginWhenCrossOrigin */ 6:
            return "origin-when-cross-origin";
        case /* StrictOriginWhenCrossOrigin */ 7:
            return "strict-origin-when-cross-origin";
        case /* UnsafeUrl */ 8:
            return "unsafe-url";
    }
}
function encodeRequestMode(param) {
    switch(param){
        case /* Navigate */ 0:
            return "navigate";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* NoCORS */ 2:
            return "no-cors";
        case /* CORS */ 3:
            return "cors";
    }
}
function encodeRequestCredentials(param) {
    switch(param){
        case /* Omit */ 0:
            return "omit";
        case /* SameOrigin */ 1:
            return "same-origin";
        case /* Include */ 2:
            return "include";
    }
}
function encodeRequestCache(param) {
    switch(param){
        case /* Default */ 0:
            return "default";
        case /* NoStore */ 1:
            return "no-store";
        case /* Reload */ 2:
            return "reload";
        case /* NoCache */ 3:
            return "no-cache";
        case /* ForceCache */ 4:
            return "force-cache";
        case /* OnlyIfCached */ 5:
            return "only-if-cached";
    }
}
function encodeRequestRedirect(param) {
    switch(param){
        case /* Follow */ 0:
            return "follow";
        case /* Error */ 1:
            return "error";
        case /* Manual */ 2:
            return "manual";
    }
}
var HeadersInit = {};
function append(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $$delete(arg1, obj) {
    obj.delete(arg1);
}
function get(arg1, obj) {
    return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .null_to_opt */ .UA(obj.get(arg1));
}
function has(arg1, obj) {
    return obj.has(arg1);
}
function set(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
var $$Headers = {
    append: append,
    $$delete: $$delete,
    get: get,
    has: has,
    set: set
};
var BodyInit = {};
function map(f, v) {
    if (v !== undefined) {
        return _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .some */ .G(_rescript_std_lib_es6_curry_js__WEBPACK_IMPORTED_MODULE_1__._1(f, _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(v)));
    }
}
function make(method_, headers, body, referrer, referrerPolicyOpt, mode, credentials, cache, redirect, integrityOpt, keepalive, signal) {
    var _$referrerPolicy = referrerPolicyOpt !== undefined ? referrerPolicyOpt : /* None */ 0;
    var integrity = integrityOpt !== undefined ? integrityOpt : "";
    var partial_arg = integrity;
    var partial_arg$1 = map(encodeRequestRedirect, redirect);
    var partial_arg$2 = map(encodeRequestCache, cache);
    var partial_arg$3 = map(encodeRequestCredentials, credentials);
    var partial_arg$4 = map(encodeRequestMode, mode);
    var partial_arg$5 = encodeReferrerPolicy(_$referrerPolicy);
    var partial_arg$6 = map(encodeRequestMethod, method_);
    return function(param) {
        var tmp = {};
        if (partial_arg$6 !== undefined) {
            tmp.method = partial_arg$6;
        }
        if (headers !== undefined) {
            tmp.headers = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(headers);
        }
        if (body !== undefined) {
            tmp.body = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(body);
        }
        if (referrer !== undefined) {
            tmp.referrer = referrer;
        }
        if (partial_arg$5 !== undefined) {
            tmp.referrerPolicy = partial_arg$5;
        }
        if (partial_arg$4 !== undefined) {
            tmp.mode = partial_arg$4;
        }
        if (partial_arg$3 !== undefined) {
            tmp.credentials = partial_arg$3;
        }
        if (partial_arg$2 !== undefined) {
            tmp.cache = partial_arg$2;
        }
        if (partial_arg$1 !== undefined) {
            tmp.redirect = partial_arg$1;
        }
        if (partial_arg !== undefined) {
            tmp.integrity = partial_arg;
        }
        if (keepalive !== undefined) {
            tmp.keepalive = keepalive;
        }
        if (signal !== undefined) {
            tmp.signal = _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(signal);
        }
        return tmp;
    };
}
function method_(self) {
    var method_$1 = self.method;
    switch(method_$1){
        case "CONNECT":
            return /* Connect */ 5;
        case "DELETE":
            return /* Delete */ 4;
        case "GET":
            return /* Get */ 0;
        case "HEAD":
            return /* Head */ 1;
        case "OPTIONS":
            return /* Options */ 6;
        case "PATCH":
            return /* Patch */ 8;
        case "POST":
            return /* Post */ 2;
        case "PUT":
            return /* Put */ 3;
        case "TRACE":
            return /* Trace */ 7;
        default:
            return /* Other */ {
                _0: method_$1
            };
    }
}
function type_(self) {
    var e = self.type;
    switch(e){
        case "":
            return /* None */ 0;
        case "audio":
            return /* Audio */ 1;
        case "font":
            return /* Font */ 2;
        case "image":
            return /* Image */ 3;
        case "script":
            return /* Script */ 4;
        case "style":
            return /* Style */ 5;
        case "track":
            return /* Track */ 6;
        case "video":
            return /* Video */ 7;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestType: " + e,
                Error: new Error()
            };
    }
}
function destination(self) {
    var e = self.destination;
    switch(e){
        case "":
            return /* None */ 0;
        case "document":
            return /* Document */ 1;
        case "embed":
            return /* Embed */ 2;
        case "font":
            return /* Font */ 3;
        case "image":
            return /* Image */ 4;
        case "manifest":
            return /* Manifest */ 5;
        case "media":
            return /* Media */ 6;
        case "object":
            return /* Object */ 7;
        case "report":
            return /* Report */ 8;
        case "script":
            return /* Script */ 9;
        case "serviceworker":
            return /* ServiceWorker */ 10;
        case "sharedworder":
            return /* SharedWorker */ 11;
        case "style":
            return /* Style */ 12;
        case "worker":
            return /* Worker */ 13;
        case "xslt":
            return /* Xslt */ 14;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestDestination: " + e,
                Error: new Error()
            };
    }
}
function referrerPolicy(self) {
    var e = self.referrerPolicy;
    switch(e){
        case "":
            return /* None */ 0;
        case "no-referrer":
            return /* NoReferrer */ 1;
        case "no-referrer-when-downgrade":
            return /* NoReferrerWhenDowngrade */ 2;
        case "origin":
            return /* Origin */ 4;
        case "origin-when-cross-origin":
            return /* OriginWhenCrossOrigin */ 6;
        case "same-origin":
            return /* SameOrigin */ 3;
        case "strict-origin":
            return /* StrictOrigin */ 5;
        case "strict-origin-when-cross-origin":
            return /* StrictOriginWhenCrossOrigin */ 7;
        case "unsafe-url":
            return /* UnsafeUrl */ 8;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown referrerPolicy: " + e,
                Error: new Error()
            };
    }
}
function mode(self) {
    var e = self.mode;
    switch(e){
        case "cors":
            return /* CORS */ 3;
        case "navigate":
            return /* Navigate */ 0;
        case "no-cors":
            return /* NoCORS */ 2;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestMode: " + e,
                Error: new Error()
            };
    }
}
function credentials(self) {
    var e = self.credentials;
    switch(e){
        case "include":
            return /* Include */ 2;
        case "omit":
            return /* Omit */ 0;
        case "same-origin":
            return /* SameOrigin */ 1;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCredentials: " + e,
                Error: new Error()
            };
    }
}
function cache(self) {
    var e = self.cache;
    switch(e){
        case "default":
            return /* Default */ 0;
        case "force-cache":
            return /* ForceCache */ 4;
        case "no-cache":
            return /* NoCache */ 3;
        case "no-store":
            return /* NoStore */ 1;
        case "only-if-cached":
            return /* OnlyIfCached */ 5;
        case "reload":
            return /* Reload */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestCache: " + e,
                Error: new Error()
            };
    }
}
function redirect(self) {
    var e = self.redirect;
    switch(e){
        case "error":
            return /* Error */ 1;
        case "follow":
            return /* Follow */ 0;
        case "manual":
            return /* Manual */ 2;
        default:
            throw {
                RE_EXN_ID: "Failure",
                _1: "Unknown requestRedirect: " + e,
                Error: new Error()
            };
    }
}
function classify(t) {
    if (typeof t === "string") {
        return {
            NAME: "String",
            VAL: t
        };
    } else {
        return {
            NAME: "File",
            VAL: t
        };
    }
}
var EntryValue = {
    classify: classify
};
function append$1(arg1, arg2, obj) {
    obj.append(arg1, arg2);
}
function $$delete$1(arg1, obj) {
    obj.delete(arg1);
}
function get$1(arg1, obj) {
    return obj.get(arg1);
}
function getAll(arg1, obj) {
    return obj.getAll(arg1);
}
function set$1(arg1, arg2, obj) {
    obj.set(arg1, arg2);
}
function has$1(arg1, obj) {
    return obj.has(arg1);
}
function appendObject(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
function appendBlob(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
function appendFile(arg1, arg2, filename, obj) {
    obj.append(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
function setObject(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
function setBlob(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
function setFile(arg1, arg2, filename, obj) {
    obj.set(arg1, arg2, filename !== undefined ? _rescript_std_lib_es6_caml_option_js__WEBPACK_IMPORTED_MODULE_0__/* .valFromOption */ .xt(filename) : undefined);
}
var $$FormData = {
    EntryValue: EntryValue,
    Iterator: undefined,
    append: append$1,
    $$delete: $$delete$1,
    get: get$1,
    getAll: getAll,
    set: set$1,
    has: has$1,
    appendObject: appendObject,
    appendBlob: appendBlob,
    appendFile: appendFile,
    setObject: setObject,
    setBlob: setBlob,
    setFile: setFile
};
var $$AbortController = {
    abort: function abort(prim) {
        prim.abort();
    }
};
function Body_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function Body_blob(prim) {
    return prim.blob();
}
function Body_formData(prim) {
    return prim.formData();
}
function Body_json(prim) {
    return prim.json();
}
function Body_text(prim) {
    return prim.text();
}
var Body = {
    arrayBuffer: Body_arrayBuffer,
    blob: Body_blob,
    formData: Body_formData,
    json: Body_json,
    text: Body_text
};
var RequestInit = {
    make: make
};
function Request_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function Request_blob(prim) {
    return prim.blob();
}
function Request_formData(prim) {
    return prim.formData();
}
function Request_json(prim) {
    return prim.json();
}
function Request_text(prim) {
    return prim.text();
}
var $$Request = {
    method_: method_,
    type_: type_,
    destination: destination,
    referrerPolicy: referrerPolicy,
    mode: mode,
    credentials: credentials,
    cache: cache,
    redirect: redirect,
    arrayBuffer: Request_arrayBuffer,
    blob: Request_blob,
    formData: Request_formData,
    json: Request_json,
    text: Request_text
};
function Response_clone(prim) {
    return prim.clone();
}
function Response_arrayBuffer(prim) {
    return prim.arrayBuffer();
}
function Response_blob(prim) {
    return prim.blob();
}
function Response_formData(prim) {
    return prim.formData();
}
function Response_json(prim) {
    return prim.json();
}
function Response_text(prim) {
    return prim.text();
}
var $$Response = {
    clone: Response_clone,
    arrayBuffer: Response_arrayBuffer,
    blob: Response_blob,
    formData: Response_formData,
    json: Response_json,
    text: Response_text
};
 /* No side effect */ 


/***/ }),

/***/ 20859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ make; }
/* harmony export */ });
// Generated by ReScript, PLEASE EDIT WITH CARE
function make(arr) {
    var result = "";
    for(var i = 0, i_finish = arr.length; i < i_finish; ++i){
        var name = arr[i];
        if (name !== "") {
            result = result === "" ? name : result + " " + name;
        }
    }
    return result;
}
 /* No side effect */ 


/***/ }),

/***/ 77720:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13627:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40893:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 33212:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 18698:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 86408:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 94375:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25194:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 36483:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 61608:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(98461)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 38701:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function arr_back(arr) {
    return arr[arr.length - 1];
}
exports["default"] = arr_back;


/***/ }),

/***/ 90698:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NodeType = exports.TextNode = exports.Node = exports.valid = exports["default"] = exports.parse = exports.HTMLElement = exports.CommentNode = void 0;
var comment_1 = __webpack_require__(91271);
Object.defineProperty(exports, "CommentNode", ({ enumerable: true, get: function () { return __importDefault(comment_1).default; } }));
var html_1 = __webpack_require__(24382);
Object.defineProperty(exports, "HTMLElement", ({ enumerable: true, get: function () { return __importDefault(html_1).default; } }));
var parse_1 = __webpack_require__(18821);
Object.defineProperty(exports, "parse", ({ enumerable: true, get: function () { return __importDefault(parse_1).default; } }));
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(parse_1).default; } }));
var valid_1 = __webpack_require__(56389);
Object.defineProperty(exports, "valid", ({ enumerable: true, get: function () { return __importDefault(valid_1).default; } }));
var node_1 = __webpack_require__(54936);
Object.defineProperty(exports, "Node", ({ enumerable: true, get: function () { return __importDefault(node_1).default; } }));
var text_1 = __webpack_require__(47923);
Object.defineProperty(exports, "TextNode", ({ enumerable: true, get: function () { return __importDefault(text_1).default; } }));
var type_1 = __webpack_require__(29979);
Object.defineProperty(exports, "NodeType", ({ enumerable: true, get: function () { return __importDefault(type_1).default; } }));


/***/ }),

/***/ 20080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var type_1 = __importDefault(__webpack_require__(29979));
function isTag(node) {
    return node && node.nodeType === type_1.default.ELEMENT_NODE;
}
function getAttributeValue(elem, name) {
    return isTag(elem) ? elem.getAttribute(name) : undefined;
}
function getName(elem) {
    return ((elem && elem.rawTagName) || '').toLowerCase();
}
function getChildren(node) {
    return node && node.childNodes;
}
function getParent(node) {
    return node ? node.parentNode : null;
}
function getText(node) {
    return node.text;
}
function removeSubsets(nodes) {
    var idx = nodes.length;
    var node;
    var ancestor;
    var replace;
    // Check if each node (or one of its ancestors) is already contained in the
    // array.
    while (--idx > -1) {
        node = ancestor = nodes[idx];
        // Temporarily remove the node under consideration
        nodes[idx] = null;
        replace = true;
        while (ancestor) {
            if (nodes.indexOf(ancestor) > -1) {
                replace = false;
                nodes.splice(idx, 1);
                break;
            }
            ancestor = getParent(ancestor);
        }
        // If the node has been found to be unique, re-insert it.
        if (replace) {
            nodes[idx] = node;
        }
    }
    return nodes;
}
function existsOne(test, elems) {
    return elems.some(function (elem) {
        return isTag(elem) ? test(elem) || existsOne(test, getChildren(elem)) : false;
    });
}
function getSiblings(node) {
    var parent = getParent(node);
    return parent && getChildren(parent);
}
function hasAttrib(elem, name) {
    return getAttributeValue(elem, name) !== undefined;
}
function findOne(test, elems) {
    var elem = null;
    for (var i = 0, l = elems.length; i < l && !elem; i++) {
        var el = elems[i];
        if (test(el)) {
            elem = el;
        }
        else {
            var childs = getChildren(el);
            if (childs && childs.length > 0) {
                elem = findOne(test, childs);
            }
        }
    }
    return elem;
}
function findAll(test, nodes) {
    var result = [];
    for (var i = 0, j = nodes.length; i < j; i++) {
        if (!isTag(nodes[i]))
            continue;
        if (test(nodes[i]))
            result.push(nodes[i]);
        var childs = getChildren(nodes[i]);
        if (childs)
            result = result.concat(findAll(test, childs));
    }
    return result;
}
exports["default"] = {
    isTag: isTag,
    getAttributeValue: getAttributeValue,
    getName: getName,
    getChildren: getChildren,
    getParent: getParent,
    getText: getText,
    removeSubsets: removeSubsets,
    existsOne: existsOne,
    getSiblings: getSiblings,
    hasAttrib: hasAttrib,
    findOne: findOne,
    findAll: findAll
};


/***/ }),

/***/ 91271:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var node_1 = __importDefault(__webpack_require__(54936));
var type_1 = __importDefault(__webpack_require__(29979));
var CommentNode = /** @class */ (function (_super) {
    __extends(CommentNode, _super);
    function CommentNode(rawText, parentNode, range) {
        var _this = _super.call(this, parentNode, range) || this;
        _this.rawText = rawText;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        _this.nodeType = type_1.default.COMMENT_NODE;
        return _this;
    }
    CommentNode.prototype.clone = function () {
        return new CommentNode(this.rawText, null);
    };
    Object.defineProperty(CommentNode.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return this.rawText;
        },
        enumerable: false,
        configurable: true
    });
    CommentNode.prototype.toString = function () {
        return "<!--".concat(this.rawText, "-->");
    };
    return CommentNode;
}(node_1.default));
exports["default"] = CommentNode;


/***/ }),

/***/ 24382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = exports.base_parse = void 0;
var css_select_1 = __webpack_require__(75366);
var he_1 = __importDefault(__webpack_require__(86492));
var back_1 = __importDefault(__webpack_require__(38701));
var matcher_1 = __importDefault(__webpack_require__(20080));
var comment_1 = __importDefault(__webpack_require__(91271));
var node_1 = __importDefault(__webpack_require__(54936));
var text_1 = __importDefault(__webpack_require__(47923));
var type_1 = __importDefault(__webpack_require__(29979));
var voidTags = new Set(['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
function decode(val) {
    // clone string
    return JSON.parse(JSON.stringify(he_1.default.decode(val)));
}
// https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
var Htags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup'];
var Dtags = ['details', 'dialog', 'dd', 'div', 'dt'];
var Ftags = ['fieldset', 'figcaption', 'figure', 'footer', 'form'];
var tableTags = ['table', 'td', 'tr'];
var htmlTags = ['address', 'article', 'aside', 'blockquote', 'br', 'hr', 'li', 'main', 'nav', 'ol', 'p', 'pre', 'section', 'ul'];
var kBlockElements = new Set();
function addToKBlockElement() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var addToSet = function (array) {
        for (var index = 0; index < array.length; index++) {
            var element = array[index];
            kBlockElements.add(element);
            kBlockElements.add(element.toUpperCase());
        }
    };
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var arg = args_1[_a];
        addToSet(arg);
    }
}
addToKBlockElement(Htags, Dtags, Ftags, tableTags, htmlTags);
var DOMTokenList = /** @class */ (function () {
    function DOMTokenList(valuesInit, afterUpdate) {
        if (valuesInit === void 0) { valuesInit = []; }
        if (afterUpdate === void 0) { afterUpdate = function () { return null; }; }
        this._set = new Set(valuesInit);
        this._afterUpdate = afterUpdate;
    }
    DOMTokenList.prototype._validate = function (c) {
        if (/\s/.test(c)) {
            throw new Error("DOMException in DOMTokenList.add: The token '".concat(c, "' contains HTML space characters, which are not valid in tokens."));
        }
    };
    DOMTokenList.prototype.add = function (c) {
        this._validate(c);
        this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.replace = function (c1, c2) {
        this._validate(c2);
        this._set.delete(c1);
        this._set.add(c2);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.remove = function (c) {
        this._set.delete(c) && this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.toggle = function (c) {
        this._validate(c);
        if (this._set.has(c))
            this._set.delete(c);
        else
            this._set.add(c);
        this._afterUpdate(this); // eslint-disable-line @typescript-eslint/no-unsafe-call
    };
    DOMTokenList.prototype.contains = function (c) {
        return this._set.has(c);
    };
    Object.defineProperty(DOMTokenList.prototype, "length", {
        get: function () {
            return this._set.size;
        },
        enumerable: false,
        configurable: true
    });
    DOMTokenList.prototype.values = function () {
        return this._set.values();
    };
    Object.defineProperty(DOMTokenList.prototype, "value", {
        get: function () {
            return Array.from(this._set.values());
        },
        enumerable: false,
        configurable: true
    });
    DOMTokenList.prototype.toString = function () {
        return Array.from(this._set.values()).join(' ');
    };
    return DOMTokenList;
}());
/**
 * HTMLElement, which contains a set of children.
 *
 * Note: this is a minimalist implementation, no complete tree
 *   structure provided (no parentNode, nextSibling,
 *   previousSibling etc).
 * @class HTMLElement
 * @extends {Node}
 */
var HTMLElement = /** @class */ (function (_super) {
    __extends(HTMLElement, _super);
    /**
     * Creates an instance of HTMLElement.
     * @param keyAttrs	id and class attribute
     * @param [rawAttrs]	attributes in string
     *
     * @memberof HTMLElement
     */
    function HTMLElement(tagName, keyAttrs, rawAttrs, parentNode, range) {
        if (rawAttrs === void 0) { rawAttrs = ''; }
        var _this = _super.call(this, parentNode, range) || this;
        _this.rawAttrs = rawAttrs;
        /**
         * Node Type declaration.
         */
        _this.nodeType = type_1.default.ELEMENT_NODE;
        _this.rawTagName = tagName;
        _this.rawAttrs = rawAttrs || '';
        _this.id = keyAttrs.id || '';
        _this.childNodes = [];
        _this.classList = new DOMTokenList(keyAttrs.class ? keyAttrs.class.split(/\s+/) : [], function (classList) { return _this.setAttribute('class', classList.toString()); } // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        );
        if (keyAttrs.id) {
            if (!rawAttrs) {
                _this.rawAttrs = "id=\"".concat(keyAttrs.id, "\"");
            }
        }
        if (keyAttrs.class) {
            if (!rawAttrs) {
                var cls = "class=\"".concat(_this.classList.toString(), "\"");
                if (_this.rawAttrs) {
                    _this.rawAttrs += " ".concat(cls);
                }
                else {
                    _this.rawAttrs = cls;
                }
            }
        }
        return _this;
    }
    /**
     * Quote attribute values
     * @param attr attribute value
     * @returns {string} quoted value
     */
    HTMLElement.prototype.quoteAttribute = function (attr) {
        if (attr == null) {
            return 'null';
        }
        return JSON.stringify(attr.replace(/"/g, '&quot;'));
    };
    /**
     * Remove Child element from childNodes array
     * @param {HTMLElement} node     node to remove
     */
    HTMLElement.prototype.removeChild = function (node) {
        this.childNodes = this.childNodes.filter(function (child) {
            return child !== node;
        });
        return this;
    };
    /**
     * Exchanges given child with new child
     * @param {HTMLElement} oldNode     node to exchange
     * @param {HTMLElement} newNode     new node
     */
    HTMLElement.prototype.exchangeChild = function (oldNode, newNode) {
        var children = this.childNodes;
        this.childNodes = children.map(function (child) {
            if (child === oldNode) {
                return newNode;
            }
            return child;
        });
        return this;
    };
    Object.defineProperty(HTMLElement.prototype, "tagName", {
        get: function () {
            return this.rawTagName ? this.rawTagName.toUpperCase() : this.rawTagName;
        },
        set: function (newname) {
            this.rawTagName = newname.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "localName", {
        get: function () {
            return this.rawTagName.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "isVoidElement", {
        get: function () {
            return voidTags.has(this.localName);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "rawText", {
        /**
         * Get escpaed (as-it) text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return this.childNodes.reduce(function (pre, cur) {
                return (pre += cur.rawText);
            }, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "textContent", {
        get: function () {
            return decode(this.rawText);
        },
        set: function (val) {
            var content = [new text_1.default(val, this)];
            this.childNodes = content;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return decode(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "structuredText", {
        /**
         * Get structured Text (with '\n' etc.)
         * @return {string} structured text
         */
        get: function () {
            var currentBlock = [];
            var blocks = [currentBlock];
            function dfs(node) {
                if (node.nodeType === type_1.default.ELEMENT_NODE) {
                    if (kBlockElements.has(node.rawTagName)) {
                        if (currentBlock.length > 0) {
                            blocks.push((currentBlock = []));
                        }
                        node.childNodes.forEach(dfs);
                        if (currentBlock.length > 0) {
                            blocks.push((currentBlock = []));
                        }
                    }
                    else {
                        node.childNodes.forEach(dfs);
                    }
                }
                else if (node.nodeType === type_1.default.TEXT_NODE) {
                    if (node.isWhitespace) {
                        // Whitespace node, postponed output
                        currentBlock.prependWhitespace = true;
                    }
                    else {
                        var text = node.trimmedText;
                        if (currentBlock.prependWhitespace) {
                            text = " ".concat(text);
                            currentBlock.prependWhitespace = false;
                        }
                        currentBlock.push(text);
                    }
                }
            }
            dfs(this);
            return blocks
                .map(function (block) {
                return block.join('').replace(/\s{2,}/g, ' '); // Normalize each line's whitespace
            })
                .join('\n')
                .replace(/\s+$/, ''); // trimRight;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.toString = function () {
        var tag = this.rawTagName;
        if (tag) {
            var attrs = this.rawAttrs ? " ".concat(this.rawAttrs) : '';
            return this.isVoidElement ? "<".concat(tag).concat(attrs, ">") : "<".concat(tag).concat(attrs, ">").concat(this.innerHTML, "</").concat(tag, ">");
        }
        return this.innerHTML;
    };
    Object.defineProperty(HTMLElement.prototype, "innerHTML", {
        get: function () {
            return this.childNodes
                .map(function (child) {
                return child.toString();
            })
                .join('');
        },
        set: function (content) {
            //const r = parse(content, global.options); // TODO global.options ?
            var r = parse(content);
            var nodes = r.childNodes.length ? r.childNodes : [new text_1.default(content, this)];
            resetParent(nodes, this);
            resetParent(this.childNodes, null);
            this.childNodes = nodes;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.set_content = function (content, options) {
        if (options === void 0) { options = {}; }
        if (content instanceof node_1.default) {
            content = [content];
        }
        else if (typeof content == 'string') {
            var r = parse(content, options);
            content = r.childNodes.length ? r.childNodes : [new text_1.default(content, this)];
        }
        resetParent(this.childNodes, null);
        resetParent(content, this);
        this.childNodes = content;
        return this;
    };
    HTMLElement.prototype.replaceWith = function () {
        var _this = this;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        var parent = this.parentNode;
        var content = nodes
            .map(function (node) {
            if (node instanceof node_1.default) {
                return [node];
            }
            else if (typeof node == 'string') {
                // const r = parse(content, global.options); // TODO global.options ?
                var r = parse(node);
                return r.childNodes.length ? r.childNodes : [new text_1.default(node, _this)];
            }
            return [];
        })
            .flat();
        var idx = parent.childNodes.findIndex(function (child) {
            return child === _this;
        });
        resetParent([this], null);
        parent.childNodes = __spreadArray(__spreadArray(__spreadArray([], parent.childNodes.slice(0, idx), true), resetParent(content, parent), true), parent.childNodes.slice(idx + 1), true);
    };
    Object.defineProperty(HTMLElement.prototype, "outerHTML", {
        get: function () {
            return this.toString();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Trim element from right (in block) after seeing pattern in a TextNode.
     * @param  {RegExp} pattern pattern to find
     * @return {HTMLElement}    reference to current node
     */
    HTMLElement.prototype.trimRight = function (pattern) {
        for (var i = 0; i < this.childNodes.length; i++) {
            var childNode = this.childNodes[i];
            if (childNode.nodeType === type_1.default.ELEMENT_NODE) {
                childNode.trimRight(pattern);
            }
            else {
                var index = childNode.rawText.search(pattern);
                if (index > -1) {
                    childNode.rawText = childNode.rawText.substr(0, index);
                    // trim all following nodes.
                    this.childNodes.length = i + 1;
                }
            }
        }
        return this;
    };
    Object.defineProperty(HTMLElement.prototype, "structure", {
        /**
         * Get DOM structure
         * @return {string} strucutre
         */
        get: function () {
            var res = [];
            var indention = 0;
            function write(str) {
                res.push('  '.repeat(indention) + str);
            }
            function dfs(node) {
                var idStr = node.id ? "#".concat(node.id) : '';
                var classStr = node.classList.length ? ".".concat(node.classList.value.join('.')) : ''; // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-call
                write("".concat(node.rawTagName).concat(idStr).concat(classStr));
                indention++;
                node.childNodes.forEach(function (childNode) {
                    if (childNode.nodeType === type_1.default.ELEMENT_NODE) {
                        dfs(childNode);
                    }
                    else if (childNode.nodeType === type_1.default.TEXT_NODE) {
                        if (!childNode.isWhitespace) {
                            write('#text');
                        }
                    }
                });
                indention--;
            }
            dfs(this);
            return res.join('\n');
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Remove whitespaces in this sub tree.
     * @return {HTMLElement} pointer to this
     */
    HTMLElement.prototype.removeWhitespace = function () {
        var _this = this;
        var o = 0;
        this.childNodes.forEach(function (node) {
            if (node.nodeType === type_1.default.TEXT_NODE) {
                if (node.isWhitespace) {
                    return;
                }
                node.rawText = node.trimmedRawText;
            }
            else if (node.nodeType === type_1.default.ELEMENT_NODE) {
                node.removeWhitespace();
            }
            _this.childNodes[o++] = node;
        });
        this.childNodes.length = o;
        return this;
    };
    /**
     * Query CSS selector to find matching nodes.
     * @param  {string}         selector Simplified CSS selector
     * @return {HTMLElement[]}  matching elements
     */
    HTMLElement.prototype.querySelectorAll = function (selector) {
        return (0, css_select_1.selectAll)(selector, this, {
            xmlMode: true,
            adapter: matcher_1.default,
        });
    };
    /**
     * Query CSS Selector to find matching node.
     * @param  {string}         selector Simplified CSS selector
     * @return {(HTMLElement|null)}    matching node
     */
    HTMLElement.prototype.querySelector = function (selector) {
        return (0, css_select_1.selectOne)(selector, this, {
            xmlMode: true,
            adapter: matcher_1.default,
        });
    };
    /**
     * find elements by their tagName
     * @param {string} tagName the tagName of the elements to select
     */
    HTMLElement.prototype.getElementsByTagName = function (tagName) {
        var upperCasedTagName = tagName.toUpperCase();
        var re = [];
        var stack = [];
        var currentNodeReference = this;
        var index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while (index !== undefined) {
            var child = void 0;
            // make it work with sparse arrays
            do {
                child = currentNodeReference.childNodes[index++];
            } while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === type_1.default.ELEMENT_NODE) {
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByTagName#syntax
                if (tagName === '*' || child.tagName === upperCasedTagName)
                    re.push(child);
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return re;
    };
    /**
     * find element by it's id
     * @param {string} id the id of the element to select
     */
    HTMLElement.prototype.getElementById = function (id) {
        var stack = [];
        var currentNodeReference = this;
        var index = 0;
        // index turns to undefined once the stack is empty and the first condition occurs
        // which happens once all relevant children are searched through
        while (index !== undefined) {
            var child = void 0;
            // make it work with sparse arrays
            do {
                child = currentNodeReference.childNodes[index++];
            } while (index < currentNodeReference.childNodes.length && child === undefined);
            // if the child does not exist we move on with the last provided index (which belongs to the parentNode)
            if (child === undefined) {
                currentNodeReference = currentNodeReference.parentNode;
                index = stack.pop();
                continue;
            }
            if (child.nodeType === type_1.default.ELEMENT_NODE) {
                if (child.id === id) {
                    return child;
                }
                ;
                // if children are existing push the current status to the stack and keep searching for elements in the level below
                if (child.childNodes.length > 0) {
                    stack.push(index);
                    currentNodeReference = child;
                    index = 0;
                }
            }
        }
        return null;
    };
    /**
     * traverses the Element and its parents (heading toward the document root) until it finds a node that matches the provided selector string. Will return itself or the matching ancestor. If no such element exists, it returns null.
     * @param selector a DOMString containing a selector list
     */
    HTMLElement.prototype.closest = function (selector) {
        var mapChild = new Map();
        var el = this;
        var old = null;
        function findOne(test, elems) {
            var elem = null;
            for (var i = 0, l = elems.length; i < l && !elem; i++) {
                var el_1 = elems[i];
                if (test(el_1)) {
                    elem = el_1;
                }
                else {
                    var child = mapChild.get(el_1);
                    if (child) {
                        elem = findOne(test, [child]);
                    }
                }
            }
            return elem;
        }
        while (el) {
            mapChild.set(el, old);
            old = el;
            el = el.parentNode;
        }
        el = this;
        while (el) {
            var e = (0, css_select_1.selectOne)(selector, el, {
                xmlMode: true,
                adapter: __assign(__assign({}, matcher_1.default), { getChildren: function (node) {
                        var child = mapChild.get(node);
                        return child && [child];
                    }, getSiblings: function (node) {
                        return [node];
                    }, findOne: findOne, findAll: function () {
                        return [];
                    } }),
            });
            if (e) {
                return e;
            }
            el = el.parentNode;
        }
        return null;
    };
    /**
     * Append a child node to childNodes
     * @param  {Node} node node to append
     * @return {Node}      node appended
     */
    HTMLElement.prototype.appendChild = function (node) {
        // remove the node from it's parent
        node.remove();
        this.childNodes.push(node);
        node.parentNode = this;
        return node;
    };
    Object.defineProperty(HTMLElement.prototype, "firstChild", {
        /**
         * Get first child node
         * @return {Node} first child node
         */
        get: function () {
            return this.childNodes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "lastChild", {
        /**
         * Get last child node
         * @return {Node} last child node
         */
        get: function () {
            return (0, back_1.default)(this.childNodes);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "attrs", {
        /**
         * Get attributes
         * @access private
         * @return {Object} parsed and unescaped attributes
         */
        get: function () {
            if (this._attrs) {
                return this._attrs;
            }
            this._attrs = {};
            var attrs = this.rawAttributes;
            for (var key in attrs) {
                var val = attrs[key] || '';
                this._attrs[key.toLowerCase()] = decode(val);
            }
            return this._attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "attributes", {
        get: function () {
            var ret_attrs = {};
            var attrs = this.rawAttributes;
            for (var key in attrs) {
                var val = attrs[key] || '';
                ret_attrs[key] = decode(val);
            }
            return ret_attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "rawAttributes", {
        /**
         * Get escaped (as-is) attributes
         * @return {Object} parsed attributes
         */
        get: function () {
            if (this._rawAttrs) {
                return this._rawAttrs;
            }
            var attrs = {};
            if (this.rawAttrs) {
                var re = /([a-zA-Z()#][a-zA-Z0-9-_:()#]*)(?:\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+))?/g;
                var match = void 0;
                while ((match = re.exec(this.rawAttrs))) {
                    var key = match[1];
                    var val = match[2] || null;
                    if (val && (val[0] === "'" || val[0] === "\""))
                        val = val.slice(1, val.length - 1);
                    attrs[key] = val;
                }
            }
            this._rawAttrs = attrs;
            return attrs;
        },
        enumerable: false,
        configurable: true
    });
    HTMLElement.prototype.removeAttribute = function (key) {
        var attrs = this.rawAttributes;
        delete attrs[key];
        // Update this.attribute
        if (this._attrs) {
            delete this._attrs[key];
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs)
            .map(function (name) {
            var val = JSON.stringify(attrs[name]);
            if (val === undefined || val === 'null') {
                return name;
            }
            return "".concat(name, "=").concat(val);
        })
            .join(' ');
        // Update this.id
        if (key === 'id') {
            this.id = '';
        }
        return this;
    };
    HTMLElement.prototype.hasAttribute = function (key) {
        return key.toLowerCase() in this.attrs;
    };
    /**
     * Get an attribute
     * @return {string} value of the attribute
     */
    HTMLElement.prototype.getAttribute = function (key) {
        return this.attrs[key.toLowerCase()];
    };
    /**
     * Set an attribute value to the HTMLElement
     * @param {string} key The attribute name
     * @param {string} value The value to set, or null / undefined to remove an attribute
     */
    HTMLElement.prototype.setAttribute = function (key, value) {
        var _this = this;
        if (arguments.length < 2) {
            throw new Error("Failed to execute 'setAttribute' on 'Element'");
        }
        var k2 = key.toLowerCase();
        var attrs = this.rawAttributes;
        for (var k in attrs) {
            if (k.toLowerCase() === k2) {
                key = k;
                break;
            }
        }
        attrs[key] = String(value);
        // update this.attrs
        if (this._attrs) {
            this._attrs[k2] = decode(attrs[key]);
        }
        // Update rawString
        this.rawAttrs = Object.keys(attrs)
            .map(function (name) {
            var val = _this.quoteAttribute(attrs[name]);
            if (val === 'null' || val === '""')
                return name;
            return "".concat(name, "=").concat(val);
        })
            .join(' ');
        // Update this.id
        if (key === 'id') {
            this.id = value;
        }
    };
    /**
     * Replace all the attributes of the HTMLElement by the provided attributes
     * @param {Attributes} attributes the new attribute set
     */
    HTMLElement.prototype.setAttributes = function (attributes) {
        var _this = this;
        // Invalidate current this.attributes
        if (this._attrs) {
            delete this._attrs;
        }
        // Invalidate current this.rawAttributes
        if (this._rawAttrs) {
            delete this._rawAttrs;
        }
        // Update rawString
        this.rawAttrs = Object.keys(attributes)
            .map(function (name) {
            var val = attributes[name];
            if (val === 'null' || val === '""')
                return name;
            return "".concat(name, "=").concat(_this.quoteAttribute(String(val)));
        })
            .join(' ');
        return this;
    };
    HTMLElement.prototype.insertAdjacentHTML = function (where, html) {
        var _a, _b, _c;
        var _this = this;
        if (arguments.length < 2) {
            throw new Error('2 arguments required');
        }
        var p = parse(html);
        if (where === 'afterend') {
            var idx = this.parentNode.childNodes.findIndex(function (child) {
                return child === _this;
            });
            resetParent(p.childNodes, this.parentNode);
            (_a = this.parentNode.childNodes).splice.apply(_a, __spreadArray([idx + 1, 0], p.childNodes, false));
        }
        else if (where === 'afterbegin') {
            resetParent(p.childNodes, this);
            (_b = this.childNodes).unshift.apply(_b, p.childNodes);
        }
        else if (where === 'beforeend') {
            p.childNodes.forEach(function (n) {
                _this.appendChild(n);
            });
        }
        else if (where === 'beforebegin') {
            var idx = this.parentNode.childNodes.findIndex(function (child) {
                return child === _this;
            });
            resetParent(p.childNodes, this.parentNode);
            (_c = this.parentNode.childNodes).splice.apply(_c, __spreadArray([idx, 0], p.childNodes, false));
        }
        else {
            throw new Error("The value provided ('".concat(where, "') is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'"));
        }
        return this;
        // if (!where || html === undefined || html === null) {
        // 	return;
        // }
    };
    Object.defineProperty(HTMLElement.prototype, "nextSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = 0;
                while (i < children.length) {
                    var child = children[i++];
                    if (this === child)
                        return children[i] || null;
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "nextElementSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = 0;
                var find = false;
                while (i < children.length) {
                    var child = children[i++];
                    if (find) {
                        if (child instanceof HTMLElement) {
                            return child || null;
                        }
                    }
                    else if (this === child) {
                        find = true;
                    }
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "previousSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = children.length;
                while (i > 0) {
                    var child = children[--i];
                    if (this === child)
                        return children[i - 1] || null;
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "previousElementSibling", {
        get: function () {
            if (this.parentNode) {
                var children = this.parentNode.childNodes;
                var i = children.length;
                var find = false;
                while (i > 0) {
                    var child = children[--i];
                    if (find) {
                        if (child instanceof HTMLElement) {
                            return child || null;
                        }
                    }
                    else if (this === child) {
                        find = true;
                    }
                }
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HTMLElement.prototype, "classNames", {
        get: function () {
            return this.classList.toString();
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this Node
     */
    HTMLElement.prototype.clone = function () {
        return parse(this.toString()).firstChild;
    };
    return HTMLElement;
}(node_1.default));
exports["default"] = HTMLElement;
// https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
var kMarkupPattern = /<!--[\s\S]*?-->|<(\/?)([a-zA-Z][-.:0-9_a-zA-Z]*)((?:\s+[^>]*?(?:(?:'[^']*')|(?:"[^"]*"))?)*)\s*(\/?)>/g;
var kAttributePattern = /(?:^|\s)(id|class)\s*=\s*((?:'[^']*')|(?:"[^"]*")|\S+)/gi;
var kSelfClosingElements = {
    area: true,
    AREA: true,
    base: true,
    BASE: true,
    br: true,
    BR: true,
    col: true,
    COL: true,
    hr: true,
    HR: true,
    img: true,
    IMG: true,
    input: true,
    INPUT: true,
    link: true,
    LINK: true,
    meta: true,
    META: true,
    source: true,
    SOURCE: true,
    embed: true,
    EMBED: true,
    param: true,
    PARAM: true,
    track: true,
    TRACK: true,
    wbr: true,
    WBR: true,
};
var kElementsClosedByOpening = {
    li: { li: true, LI: true },
    LI: { li: true, LI: true },
    p: { p: true, div: true, P: true, DIV: true },
    P: { p: true, div: true, P: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    td: { td: true, th: true, TD: true, TH: true },
    TD: { td: true, th: true, TD: true, TH: true },
    th: { td: true, th: true, TD: true, TH: true },
    TH: { td: true, th: true, TD: true, TH: true },
    h1: { h1: true, H1: true },
    H1: { h1: true, H1: true },
    h2: { h2: true, H2: true },
    H2: { h2: true, H2: true },
    h3: { h3: true, H3: true },
    H3: { h3: true, H3: true },
    h4: { h4: true, H4: true },
    H4: { h4: true, H4: true },
    h5: { h5: true, H5: true },
    H5: { h5: true, H5: true },
    h6: { h6: true, H6: true },
    H6: { h6: true, H6: true },
};
var kElementsClosedByClosing = {
    li: { ul: true, ol: true, UL: true, OL: true },
    LI: { ul: true, ol: true, UL: true, OL: true },
    a: { div: true, DIV: true },
    A: { div: true, DIV: true },
    b: { div: true, DIV: true },
    B: { div: true, DIV: true },
    i: { div: true, DIV: true },
    I: { div: true, DIV: true },
    p: { div: true, DIV: true },
    P: { div: true, DIV: true },
    td: { tr: true, table: true, TR: true, TABLE: true },
    TD: { tr: true, table: true, TR: true, TABLE: true },
    th: { tr: true, table: true, TR: true, TABLE: true },
    TH: { tr: true, table: true, TR: true, TABLE: true },
};
var frameflag = 'documentfragmentcontainer';
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 * @param  {string} data      html
 * @return {HTMLElement}      root element
 */
function base_parse(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var elements = options.blockTextElements || {
        script: true,
        noscript: true,
        style: true,
        pre: true,
    };
    var element_names = Object.keys(elements);
    var kBlockTextElements = element_names.map(function (it) { return new RegExp("^".concat(it, "$"), 'i'); });
    var kIgnoreElements = element_names.filter(function (it) { return elements[it]; }).map(function (it) { return new RegExp("^".concat(it, "$"), 'i'); });
    function element_should_be_ignore(tag) {
        return kIgnoreElements.some(function (it) { return it.test(tag); });
    }
    function is_block_text_element(tag) {
        return kBlockTextElements.some(function (it) { return it.test(tag); });
    }
    var createRange = function (startPos, endPos) { return [startPos - frameFlagOffset, endPos - frameFlagOffset]; };
    var root = new HTMLElement(null, {}, '', null, [0, data.length]);
    var currentParent = root;
    var stack = [root];
    var lastTextPos = -1;
    var noNestedTagIndex = undefined;
    var match;
    // https://github.com/taoqf/node-html-parser/issues/38
    data = "<".concat(frameflag, ">").concat(data, "</").concat(frameflag, ">");
    var lowerCaseTagName = options.lowerCaseTagName;
    var dataEndPos = data.length - (frameflag.length + 2);
    var frameFlagOffset = frameflag.length + 2;
    while ((match = kMarkupPattern.exec(data))) {
        // Note: Object destructuring here consistently tests as higher performance than array destructuring
        // eslint-disable-next-line prefer-const
        var matchText = match[0], leadingSlash = match[1], tagName = match[2], attributes = match[3], closingSlash = match[4];
        var matchLength = matchText.length;
        var tagStartPos = kMarkupPattern.lastIndex - matchLength;
        var tagEndPos = kMarkupPattern.lastIndex;
        // Add TextNode if content
        if (lastTextPos > -1) {
            if (lastTextPos + matchLength < tagEndPos) {
                var text = data.substring(lastTextPos, tagStartPos);
                currentParent.appendChild(new text_1.default(text, currentParent, createRange(lastTextPos, tagStartPos)));
            }
        }
        lastTextPos = kMarkupPattern.lastIndex;
        // https://github.com/taoqf/node-html-parser/issues/38
        // Skip frameflag node
        if (tagName === frameflag)
            continue;
        // Handle comments
        if (matchText[1] === '!') {
            if (options.comment) {
                // Only keep what is in between <!-- and -->
                var text = data.substring(tagStartPos + 4, tagEndPos - 3);
                currentParent.appendChild(new comment_1.default(text, currentParent, createRange(tagStartPos, tagEndPos)));
            }
            continue;
        }
        /* -- Handle tag matching -- */
        // Fix tag casing if necessary
        if (lowerCaseTagName)
            tagName = tagName.toLowerCase();
        // Handle opening tags (ie. <this> not </that>)
        if (!leadingSlash) {
            /* Populate attributes */
            var attrs = {};
            for (var attMatch = void 0; (attMatch = kAttributePattern.exec(attributes));) {
                var key = attMatch[1], val = attMatch[2];
                var isQuoted = val[0] === "'" || val[0] === "\"";
                attrs[key.toLowerCase()] = isQuoted ? val.slice(1, val.length - 1) : val;
            }
            var parentTagName = currentParent.rawTagName;
            if (!closingSlash && kElementsClosedByOpening[parentTagName]) {
                if (kElementsClosedByOpening[parentTagName][tagName]) {
                    stack.pop();
                    currentParent = (0, back_1.default)(stack);
                }
            }
            // Prevent nested A tags by terminating the last A and starting a new one : see issue #144
            if (tagName === 'a' || tagName === 'A') {
                if (noNestedTagIndex !== undefined) {
                    stack.splice(noNestedTagIndex);
                    currentParent = (0, back_1.default)(stack);
                }
                noNestedTagIndex = stack.length;
            }
            var tagEndPos_1 = kMarkupPattern.lastIndex;
            var tagStartPos_1 = tagEndPos_1 - matchLength;
            currentParent = currentParent.appendChild(
            // Initialize range (end position updated later for closed tags)
            new HTMLElement(tagName, attrs, attributes.slice(1), null, createRange(tagStartPos_1, tagEndPos_1)));
            stack.push(currentParent);
            if (is_block_text_element(tagName)) {
                // Find closing tag
                var closeMarkup = "</".concat(tagName, ">");
                var closeIndex = lowerCaseTagName
                    ? data.toLocaleLowerCase().indexOf(closeMarkup, kMarkupPattern.lastIndex)
                    : data.indexOf(closeMarkup, kMarkupPattern.lastIndex);
                var textEndPos = closeIndex === -1 ? dataEndPos : closeIndex;
                if (element_should_be_ignore(tagName)) {
                    var text = data.substring(tagEndPos_1, textEndPos);
                    if (text.length > 0 && /\S/.test(text)) {
                        currentParent.appendChild(new text_1.default(text, currentParent, createRange(tagEndPos_1, textEndPos)));
                    }
                }
                if (closeIndex === -1) {
                    lastTextPos = kMarkupPattern.lastIndex = data.length + 1;
                }
                else {
                    lastTextPos = kMarkupPattern.lastIndex = closeIndex + closeMarkup.length;
                    // Cause to be treated as self-closing, because no close found
                    leadingSlash = '/';
                }
            }
        }
        // Handle closing tags or self-closed elements (ie </tag> or <br>)
        if (leadingSlash || closingSlash || kSelfClosingElements[tagName]) {
            while (true) {
                if (tagName === 'a' || tagName === 'A')
                    noNestedTagIndex = undefined;
                if (currentParent.rawTagName === tagName) {
                    // Update range end for closed tag
                    currentParent.range[1] = createRange(-1, Math.max(lastTextPos, tagEndPos))[1];
                    stack.pop();
                    currentParent = (0, back_1.default)(stack);
                    break;
                }
                else {
                    var parentTagName = currentParent.tagName;
                    // Trying to close current tag, and move on
                    if (kElementsClosedByClosing[parentTagName]) {
                        if (kElementsClosedByClosing[parentTagName][tagName]) {
                            stack.pop();
                            currentParent = (0, back_1.default)(stack);
                            continue;
                        }
                    }
                    // Use aggressive strategy to handle unmatching markups.
                    break;
                }
            }
        }
    }
    return stack;
}
exports.base_parse = base_parse;
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function parse(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var stack = base_parse(data, options);
    var root = stack[0];
    var _loop_1 = function () {
        // Handle each error elements.
        var last = stack.pop();
        var oneBefore = (0, back_1.default)(stack);
        if (last.parentNode && last.parentNode.parentNode) {
            if (last.parentNode === oneBefore && last.tagName === oneBefore.tagName) {
                // Pair error case <h3> <h3> handle : Fixes to <h3> </h3>
                // this is wrong, becouse this will put the H3 outside the current right position which should be inside the current Html Element, see issue 152 for more info
                if (options.parseNoneClosedTags !== true) {
                    oneBefore.removeChild(last);
                    last.childNodes.forEach(function (child) {
                        oneBefore.parentNode.appendChild(child);
                    });
                    stack.pop();
                }
            }
            else {
                // Single error  <div> <h3> </div> handle: Just removes <h3>
                // Why remove? this is already a HtmlElement and the missing <H3> is already added in this case. see issue 152 for more info
                // eslint-disable-next-line no-lonely-if
                if (options.parseNoneClosedTags !== true) {
                    oneBefore.removeChild(last);
                    last.childNodes.forEach(function (child) {
                        oneBefore.appendChild(child);
                    });
                }
            }
        }
        else {
            // If it's final element just skip.
        }
    };
    while (stack.length > 1) {
        _loop_1();
    }
    // response.childNodes.forEach((node) => {
    // 	if (node instanceof HTMLElement) {
    // 		node.parentNode = null;
    // 	}
    // });
    return root;
}
exports.parse = parse;
function resetParent(nodes, parent) {
    return nodes.map(function (node) {
        node.parentNode = parent;
        return node;
    });
}


/***/ }),

/***/ 54936:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var he_1 = __webpack_require__(86492);
/**
 * Node Class as base class for TextNode and HTMLElement.
 */
var Node = /** @class */ (function () {
    function Node(parentNode, range) {
        if (parentNode === void 0) { parentNode = null; }
        this.parentNode = parentNode;
        this.childNodes = [];
        Object.defineProperty(this, 'range', {
            enumerable: false,
            writable: true,
            configurable: true,
            value: range !== null && range !== void 0 ? range : [-1, -1]
        });
    }
    /**
     * Remove current node
     */
    Node.prototype.remove = function () {
        var _this = this;
        if (this.parentNode) {
            var children = this.parentNode.childNodes;
            this.parentNode.childNodes = children.filter(function (child) {
                return _this !== child;
            });
            this.parentNode = null;
        }
        return this;
    };
    Object.defineProperty(Node.prototype, "innerText", {
        get: function () {
            return this.rawText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "textContent", {
        get: function () {
            return (0, he_1.decode)(this.rawText);
        },
        set: function (val) {
            this.rawText = (0, he_1.encode)(val);
        },
        enumerable: false,
        configurable: true
    });
    return Node;
}());
exports["default"] = Node;


/***/ }),

/***/ 47923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var he_1 = __webpack_require__(86492);
var node_1 = __importDefault(__webpack_require__(54936));
var type_1 = __importDefault(__webpack_require__(29979));
/**
 * TextNode to contain a text element in DOM tree.
 * @param {string} value [description]
 */
var TextNode = /** @class */ (function (_super) {
    __extends(TextNode, _super);
    function TextNode(rawText, parentNode, range) {
        var _this = _super.call(this, parentNode, range) || this;
        /**
         * Node Type declaration.
         * @type {Number}
         */
        _this.nodeType = type_1.default.TEXT_NODE;
        _this._rawText = rawText;
        return _this;
    }
    TextNode.prototype.clone = function () {
        return new TextNode(this._rawText, null);
    };
    Object.defineProperty(TextNode.prototype, "rawText", {
        get: function () {
            return this._rawText;
        },
        /**
         * Set rawText and invalidate trimmed caches
         */
        set: function (text) {
            this._rawText = text;
            this._trimmedRawText = void 0;
            this._trimmedText = void 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "trimmedRawText", {
        /**
         * Returns raw text with all whitespace trimmed except single leading/trailing non-breaking space
         */
        get: function () {
            if (this._trimmedRawText !== undefined)
                return this._trimmedRawText;
            this._trimmedRawText = trimText(this.rawText);
            return this._trimmedRawText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "trimmedText", {
        /**
         * Returns text with all whitespace trimmed except single leading/trailing non-breaking space
         */
        get: function () {
            if (this._trimmedText !== undefined)
                return this._trimmedText;
            this._trimmedText = trimText(this.text);
            return this._trimmedText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "text", {
        /**
         * Get unescaped text value of current node and its children.
         * @return {string} text content
         */
        get: function () {
            return (0, he_1.decode)(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextNode.prototype, "isWhitespace", {
        /**
         * Detect if the node contains only white space.
         * @return {boolean}
         */
        get: function () {
            return /^(\s|&nbsp;)*$/.test(this.rawText);
        },
        enumerable: false,
        configurable: true
    });
    TextNode.prototype.toString = function () {
        return this.rawText;
    };
    return TextNode;
}(node_1.default));
exports["default"] = TextNode;
/**
 * Trim whitespace except single leading/trailing non-breaking space
 */
function trimText(text) {
    var i = 0;
    var startPos;
    var endPos;
    while (i >= 0 && i < text.length) {
        if (/\S/.test(text[i])) {
            if (startPos === undefined) {
                startPos = i;
                i = text.length;
            }
            else {
                endPos = i;
                i = void 0;
            }
        }
        if (startPos === undefined)
            i++;
        else
            i--;
    }
    if (startPos === undefined)
        startPos = 0;
    if (endPos === undefined)
        endPos = text.length - 1;
    var hasLeadingSpace = startPos > 0 && /[^\S\r\n]/.test(text[startPos - 1]);
    var hasTrailingSpace = endPos < (text.length - 1) && /[^\S\r\n]/.test(text[endPos + 1]);
    return (hasLeadingSpace ? ' ' : '') + text.slice(startPos, endPos + 1) + (hasTrailingSpace ? ' ' : '');
}


/***/ }),

/***/ 29979:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var NodeType;
(function (NodeType) {
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["COMMENT_NODE"] = 8] = "COMMENT_NODE";
})(NodeType || (NodeType = {}));
exports["default"] = NodeType;


/***/ }),

/***/ 18821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var html_1 = __webpack_require__(24382);
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return html_1.parse; } }));


/***/ }),

/***/ 56389:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var html_1 = __webpack_require__(24382);
/**
 * Parses HTML and returns a root element
 * Parse a chuck of HTML source.
 */
function valid(data, options) {
    if (options === void 0) { options = { lowerCaseTagName: false, comment: false }; }
    var stack = (0, html_1.base_parse)(data, options);
    return Boolean(stack.length === 1);
}
exports["default"] = valid;


/***/ }),

/***/ 69769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generate = exports.compile = void 0;
var boolbase_1 = __importDefault(__webpack_require__(11073));
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 *
 * ```js
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 * ```
 */
function compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */
    if (b < 0 && a <= 0)
        return boolbase_1.default.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1)
        return function (index) { return index <= b; };
    if (a === 0)
        return function (index) { return index === b; };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1)
        return b < 0 ? boolbase_1.default.trueFunc : function (index) { return index >= b; };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */
    var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = ((b % absA) + absA) % absA;
    return a > 1
        ? function (index) { return index >= b && index % absA === bMod; }
        : function (index) { return index <= b && index % absA === bMod; };
}
exports.compile = compile;
/**
 * Returns a function that produces a monotonously increasing sequence of indices.
 *
 * If the sequence has an end, the returned function will return `null` after
 * the last index in the sequence.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing (2n+3)</caption>
 *
 * ```js
 * const gen = nthCheck.generate([2, 3])
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value (-2n+10)</caption>
 *
 * ```js
 *
 * const gen = nthCheck.generate([-2, 5]);
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function generate(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    var n = 0;
    // Make sure to always return an increasing sequence
    if (a < 0) {
        var aPos_1 = -a;
        // Get `b mod a`
        var minValue_1 = ((b % aPos_1) + aPos_1) % aPos_1;
        return function () {
            var val = minValue_1 + aPos_1 * n++;
            return val > b ? null : val;
        };
    }
    if (a === 0)
        return b < 0
            ? // There are no result — always return `null`
                function () { return null; }
            : // Return `b` exactly once
                function () { return (n++ === 0 ? b : null); };
    if (b < 0) {
        b += a * Math.ceil(-b / a);
    }
    return function () { return a * n++ + b; };
}
exports.generate = generate;
//# sourceMappingURL=compile.js.map

/***/ }),

/***/ 97540:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sequence = exports.generate = exports.compile = exports.parse = void 0;
var parse_js_1 = __webpack_require__(7766);
Object.defineProperty(exports, "parse", ({ enumerable: true, get: function () { return parse_js_1.parse; } }));
var compile_js_1 = __webpack_require__(69769);
Object.defineProperty(exports, "compile", ({ enumerable: true, get: function () { return compile_js_1.compile; } }));
Object.defineProperty(exports, "generate", ({ enumerable: true, get: function () { return compile_js_1.generate; } }));
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of {@link parse} and {@link compile}.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */
function nthCheck(formula) {
    return (0, compile_js_1.compile)((0, parse_js_1.parse)(formula));
}
exports["default"] = nthCheck;
/**
 * Parses and compiles a formula to a generator that produces a sequence of indices.
 * Combination of {@link parse} and {@link generate}.
 *
 * @param formula The formula to compile.
 * @returns A function that produces a sequence of indices.
 * @example <caption>Always increasing</caption>
 *
 * ```js
 * const gen = nthCheck.sequence('2n+3')
 *
 * gen() // `1`
 * gen() // `3`
 * gen() // `5`
 * gen() // `8`
 * gen() // `11`
 * ```
 *
 * @example <caption>With end value</caption>
 *
 * ```js
 *
 * const gen = nthCheck.sequence('-2n+5');
 *
 * gen() // 0
 * gen() // 2
 * gen() // 4
 * gen() // null
 * ```
 */
function sequence(formula) {
    return (0, compile_js_1.generate)((0, parse_js_1.parse)(formula));
}
exports.sequence = sequence;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7766:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var whitespace = new Set([9, 10, 12, 13, 32]);
var ZERO = "0".charCodeAt(0);
var NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */
function parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") {
        return [2, 0];
    }
    else if (formula === "odd") {
        return [2, 1];
    }
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        }
        else {
            sign = number = 0;
        }
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) {
        throw new Error("n-th rule couldn't be parsed ('".concat(formula, "')"));
    }
    return [a, sign * number];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") {
            idx++;
        }
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while (idx < formula.length &&
            formula.charCodeAt(idx) >= ZERO &&
            formula.charCodeAt(idx) <= NINE) {
            value = value * 10 + (formula.charCodeAt(idx) - ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while (idx < formula.length &&
            whitespace.has(formula.charCodeAt(idx))) {
            idx++;
        }
    }
}
exports.parse = parse;
//# sourceMappingURL=parse.js.map

/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 57129:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */
function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?#&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encode(key);
      value = encode(value);

      //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //
      if (key === null || value === null) continue;
      pairs.push(key +'='+ value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ 85346:
/***/ (function(module) {

"use strict";

function tryStringify (o) {
  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
}

module.exports = format

function format(f, args, opts) {
  var ss = (opts && opts.stringify) || tryStringify
  var offset = 1
  if (typeof f === 'object' && f !== null) {
    var len = args.length + offset
    if (len === 1) return f
    var objects = new Array(len)
    objects[0] = ss(f)
    for (var index = 1; index < len; index++) {
      objects[index] = ss(args[index])
    }
    return objects.join(' ')
  }
  if (typeof f !== 'string') {
    return f
  }
  var argLen = args.length
  if (argLen === 0) return f
  var str = ''
  var a = 1 - offset
  var lastPos = -1
  var flen = (f && f.length) || 0
  for (var i = 0; i < flen;) {
    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
      lastPos = lastPos > -1 ? lastPos : 0
      switch (f.charCodeAt(i + 1)) {
        case 100: // 'd'
        case 102: // 'f'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Number(args[a])
          lastPos = i + 2
          i++
          break
        case 105: // 'i'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Math.floor(Number(args[a]))
          lastPos = i + 2
          i++
          break
        case 79: // 'O'
        case 111: // 'o'
        case 106: // 'j'
          if (a >= argLen)
            break
          if (args[a] === undefined) break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          var type = typeof args[a]
          if (type === 'string') {
            str += '\'' + args[a] + '\''
            lastPos = i + 2
            i++
            break
          }
          if (type === 'function') {
            str += args[a].name || '<anonymous>'
            lastPos = i + 2
            i++
            break
          }
          str += ss(args[a])
          lastPos = i + 2
          i++
          break
        case 115: // 's'
          if (a >= argLen)
            break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += String(args[a])
          lastPos = i + 2
          i++
          break
        case 37: // '%'
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += '%'
          lastPos = i + 2
          i++
          a--
          break
      }
      ++a
    }
    ++i
  }
  if (lastPos === -1)
    return f
  else if (lastPos < flen) {
    str += f.slice(lastPos)
  }

  return str
}


/***/ }),

/***/ 85518:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(67294);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(23451);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

__webpack_unused_export__ = AndroidView;
__webpack_unused_export__ = BrowserTypes;
__webpack_unused_export__ = BrowserView;
__webpack_unused_export__ = ConsoleView;
__webpack_unused_export__ = CustomView;
__webpack_unused_export__ = IEView;
__webpack_unused_export__ = IOSView;
__webpack_unused_export__ = MobileOnlyView;
__webpack_unused_export__ = MobileView;
__webpack_unused_export__ = OsTypes;
__webpack_unused_export__ = SmartTVView;
__webpack_unused_export__ = TabletView;
__webpack_unused_export__ = WearableView;
__webpack_unused_export__ = WinPhoneView;
__webpack_unused_export__ = browserName;
__webpack_unused_export__ = browserVersion;
__webpack_unused_export__ = deviceDetect;
__webpack_unused_export__ = deviceType;
__webpack_unused_export__ = engineName;
__webpack_unused_export__ = engineVersion;
__webpack_unused_export__ = fullBrowserVersion;
__webpack_unused_export__ = getSelectorsByUserAgent;
__webpack_unused_export__ = getUA;
__webpack_unused_export__ = isAndroid;
__webpack_unused_export__ = isBrowser;
exports.i7 = isChrome;
__webpack_unused_export__ = isChromium;
__webpack_unused_export__ = isConsole;
__webpack_unused_export__ = isDesktop;
__webpack_unused_export__ = isEdge;
__webpack_unused_export__ = isEdgeChromium;
__webpack_unused_export__ = isElectron;
__webpack_unused_export__ = isEmbedded;
__webpack_unused_export__ = isFirefox;
__webpack_unused_export__ = isIE;
__webpack_unused_export__ = isIOS;
__webpack_unused_export__ = isIOS13;
__webpack_unused_export__ = isIPad13;
__webpack_unused_export__ = isIPhone13;
__webpack_unused_export__ = isIPod13;
__webpack_unused_export__ = isLegacyEdge;
__webpack_unused_export__ = isMIUI;
__webpack_unused_export__ = isMacOs;
__webpack_unused_export__ = isMobile;
__webpack_unused_export__ = isMobileOnly;
exports.TL = isMobileSafari;
__webpack_unused_export__ = isOpera;
exports.G6 = isSafari;
__webpack_unused_export__ = isSamsungBrowser;
__webpack_unused_export__ = isSmartTV;
__webpack_unused_export__ = isTablet;
__webpack_unused_export__ = isWearable;
__webpack_unused_export__ = isWinPhone;
__webpack_unused_export__ = isWindows;
__webpack_unused_export__ = isYandex;
__webpack_unused_export__ = mobileModel;
__webpack_unused_export__ = mobileVendor;
__webpack_unused_export__ = osName;
__webpack_unused_export__ = osVersion;
exports.rQ = parseUserAgent;
__webpack_unused_export__ = setUserAgent;
__webpack_unused_export__ = useDeviceData;
__webpack_unused_export__ = useDeviceSelectors;
__webpack_unused_export__ = useMobileOrientation;
__webpack_unused_export__ = withOrientationChange;


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 37096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AutoFocusInside": function() { return /* reexport */ es2015_AutoFocusInside; },
  "FocusLockUI": function() { return /* reexport */ Lock; },
  "FreeFocusInside": function() { return /* reexport */ es2015_FreeFocusInside; },
  "InFocusGuard": function() { return /* reexport */ FocusGuard; },
  "MoveFocusInside": function() { return /* reexport */ es2015_MoveFocusInside; },
  "default": function() { return /* binding */ dist_es2015; },
  "useFocusInside": function() { return /* reexport */ useFocusInside; }
});

;// CONCATENATED MODULE: ./node_modules/react-focus-lock/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/constants.js
/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

// EXTERNAL MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js + 2 modules
var useMergeRef = __webpack_require__(99495);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/FocusGuard.js


var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /*#__PURE__*/react.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};

InFocusGuard.propTypes =  false ? 0 : {};
InFocusGuard.defaultProps = {
  children: null
};
/* harmony default export */ var FocusGuard = (InFocusGuard);
// EXTERNAL MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js
var medium = __webpack_require__(87122);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/medium.js

var mediumFocus = (0,medium/* createMedium */.s)({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = (0,medium/* createMedium */.s)();
var mediumEffect = (0,medium/* createMedium */.s)();
var mediumSidecar = (0,medium/* createSidecarMedium */._)({
  async: true // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,

});
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/Lock.js








var emptyArray = [];
var FocusLock = /*#__PURE__*/react.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;

  var _React$useState = react.useState(),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = react.useRef();
  var isActive = react.useRef(false);
  var originalFocusedElement = react.useRef(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = react.useState({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = react.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = react.useCallback(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  (0,react.useEffect)(function () {
    if (!disabled) {
      // cleanup return focus on trap deactivation
      // sideEffect/returnFocus should happen by this time
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = react.useCallback(function (allowDefer) {
    var returnFocusTo = originalFocusedElement.current;

    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;

      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;

        if (allowDefer) {
          // React might return focus after update
          // it's safer to defer the action
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = react.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = react.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (false) {}

  var lockProps = _extends((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = (0,useMergeRef/* useMergeRefs */.q)([parentRef, setObserveNode]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  // nearest focus guard
  react.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // first tabbed element guard
  hasPositiveIndices ? /*#__PURE__*/react.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/react.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/react.createElement(Container, _extends({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/react.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes =  false ? 0 : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  focusOptions: undefined,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: undefined,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
/* harmony default export */ var Lock = (FocusLock);
;// CONCATENATED MODULE: ./node_modules/react-clientside-effect/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/react-clientside-effect/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/react-clientside-effect/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
;// CONCATENATED MODULE: ./node_modules/react-clientside-effect/lib/index.es.js




function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (false) {}

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (false) {}

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/react.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(react.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/* harmony default export */ var index_es = (withSideEffect);

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/array.js
/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/is.js

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/tabOrder.js

var tabSort = function (a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) {
            return 1;
        }
        if (!b.tabIndex) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) { return ({
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : node.tabIndex,
    }); })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/tabbables.js
/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/tabUtils.js



var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/DOMutils.js




/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * only tabbable ones
 * (but with guards which would be ignored)
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * actually anything "focusable", not only tabbable
 * (without guards, as long as they are not expected to be focused)
 */
var getAllTabbableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains = function (scope, element) {
    if (scope.shadowRoot) {
        return contains(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains(iframeBody, element);
                }
                return false;
            }
            return contains(child, element);
        });
    }
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
/**
 * returns active element from document or from nested shadowdoms
 */

var getActiveElement = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement(activeElement.contentWindow.document)
            : activeElement);
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/focusIsHidden.js




/**
 * focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains(node, activeElement); });
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/all-affected.js


/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node
 * @returns {T}
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/focusInside.js




var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/correctFocus.js

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/firstFocus.js

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/solver.js



var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/auto-focus.js



var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/utils/parenting.js



var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/focusMerge.js








var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * given top node(s) and the last active element return the element to be focused next
 * @param topNode
 * @param lastNode
 */
var getFocusMerge = function (topNode, lastNode) {
    var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getAllTabbableNodes(entries, visibilityCache);
    var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) {
            return undefined;
        }
    }
    var outerNodes = getAllTabbableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/setFocus.js

var focusOn = function (target, focusOptions) {
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};
var guardCount = 0;
var lockDisabled = false;
/**
 * Sets focus at a given node. The last focused element will help to determine which element(first or last) should be focused.
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @param topNode
 * @param lastNode
 * @param options
 */
var setFocus = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = getFocusMerge(topNode, lastNode);
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        if (guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/index.js











/* harmony default export */ var es2015 = (setFocus);
//

;// CONCATENATED MODULE: ./node_modules/focus-lock/dist/es2015/focusables.js




/**
 * return list of focusable elements inside a given top node
 * @deprecated use {@link getFocusableIn}. Yep, there is typo in the function name
 */
var getFocusabledIn = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
    var innerElements = getTabbableNodes(entries, visibilityCache)
        .filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    })
        .map(function (_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};
/**
 * return list of focusable elements inside a given top node
 */
var getFocusableIn = (/* unused pure expression or super */ null && (getFocusabledIn));

;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
      setImmediate = _window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var inlineProp = function inlineProp(name, value) {
  var obj = {};
  obj[name] = value;
  return obj;
};
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/Trap.js
/* eslint-disable no-mixed-operators */







var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var checkInHost = function checkInHost(check, el, boundary) {
  return el && ( // find host equal to active element and check nested active element
  el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) // dive up
  || el.parentNode && checkInHost(check, el.parentNode, boundary));
};

var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !( // active element is "inside" working area
          focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = es2015(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = getFocusabledIn(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/react.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};

FocusTrap.propTypes =  false ? 0 : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  setTimeout(function () {
    focusWasOutsideWindow = 'meanwhile';
  }, 0);
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: es2015,
    focusInside: focusInside
  });
});
/* harmony default export */ var Trap = (index_es(reducePropsToState, handleStateChangeOnClient)(FocusWatcher));
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/Combination.js





/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/react.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/react.createElement(Lock, _extends({
    sideCar: Trap,
    ref: ref
  }, props));
});

var _ref = Lock.propTypes || {},
    sideCar = _ref.sideCar,
    propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);

FocusLockCombination.propTypes =  false ? 0 : {};
/* harmony default export */ var Combination = (FocusLockCombination);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js


/* eslint-disable react/require-default-props */





var AutoFocusInside = function AutoFocusInside(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className;
  return /*#__PURE__*/react.createElement("div", _extends({}, inlineProp(FOCUS_AUTO, !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? 0 : {};
/* harmony default export */ var es2015_AutoFocusInside = (AutoFocusInside);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/MoveFocusInside.js






var useFocusInside = function useFocusInside(observedRef) {
  react.useEffect(function () {
    var enabled = true;
    mediumEffect.useMedium(function (car) {
      var observed = observedRef && observedRef.current;

      if (enabled && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
    return function () {
      enabled = false;
    };
  }, [observedRef]);
};

function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = react.useRef(null);
  useFocusInside(isDisabled ? undefined : ref);
  return /*#__PURE__*/react.createElement("div", _extends({}, inlineProp(FOCUS_AUTO, !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes =  false ? 0 : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ var es2015_MoveFocusInside = (MoveFocusInside);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/FreeFocusInside.js






var FreeFocusInside = function FreeFocusInside(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/react.createElement("div", _extends({}, inlineProp(FOCUS_ALLOW, true), {
    className: className
  }), children);
};

FreeFocusInside.propTypes =  false ? 0 : {};
FreeFocusInside.defaultProps = {
  className: undefined
};
/* harmony default export */ var es2015_FreeFocusInside = (FreeFocusInside);
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/UI.js






/* harmony default export */ var UI = ((/* unused pure expression or super */ null && (FocusLockUI)));
;// CONCATENATED MODULE: ./node_modules/react-focus-lock/dist/es2015/index.js


/* harmony default export */ var dist_es2015 = (Combination);

/***/ }),

/***/ 42283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": function() { return /* binding */ useFieldArray; },
/* harmony export */   "Gc": function() { return /* binding */ useFormContext; },
/* harmony export */   "Qr": function() { return /* binding */ Controller; },
/* harmony export */   "RV": function() { return /* binding */ FormProvider; },
/* harmony export */   "bc": function() { return /* binding */ useController; },
/* harmony export */   "cI": function() { return /* binding */ useForm; },
/* harmony export */   "qo": function() { return /* binding */ useWatch; }
/* harmony export */ });
/* unused harmony exports appendErrors, get, transformToNestObject */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var isHTMLElement = (value) => value instanceof HTMLElement;

const EVENTS = {
    BLUR: 'blur',
    CHANGE: 'change',
    INPUT: 'input',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const SELECT = 'select';
const UNDEFINED = 'undefined';
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

function attachEventListeners({ ref }, shouldAttachChangeEvent, handleChange) {
    if (isHTMLElement(ref) && handleChange) {
        ref.addEventListener(shouldAttachChangeEvent ? EVENTS.CHANGE : EVENTS.INPUT, handleChange);
        ref.addEventListener(EVENTS.BLUR, handleChange);
    }
}

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !(value instanceof Date);

var isKey = (value) => /^\w*$/.test(value);

var compact = (value) => value.filter(Boolean);

var stringToPath = (input) => compact(input
    .replace(/["|']/g, '')
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.'));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

var transformToNestObject = (data, value = {}) => {
    for (const key in data) {
        !isKey(key) ? set(value, key, data[key]) : (value[key] = data[key]);
    }
    return value;
};

var isUndefined = (val) => val === undefined;

var get = (obj = {}, path, defaultValue) => {
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => (isNullOrUndefined(result) ? result : result[key]), obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

var focusOnErrorField = (fields, fieldErrors) => {
    for (const key in fields) {
        if (get(fieldErrors, key)) {
            const field = fields[key];
            if (field) {
                if (field.ref.focus && isUndefined(field.ref.focus())) {
                    break;
                }
                else if (field.options) {
                    field.options[0].ref.focus();
                    break;
                }
            }
        }
    }
};

var removeAllEventListeners = (ref, validateWithStateUpdate) => {
    if (isHTMLElement(ref) && ref.removeEventListener) {
        ref.removeEventListener(EVENTS.INPUT, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.CHANGE, validateWithStateUpdate);
        ref.removeEventListener(EVENTS.BLUR, validateWithStateUpdate);
    }
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.ref.checked
        ? {
            isValid: true,
            value: option.ref.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

var getMultipleSelectValue = (options) => [...options]
    .filter(({ selected }) => selected)
    .map(({ value }) => value);

var isRadioInput = (element) => element.type === 'radio';

var isFileInput = (element) => element.type === 'file';

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isMultipleSelect = (element) => element.type === `${SELECT}-multiple`;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.ref.checked)
                .map(({ ref: { value } }) => value);
            return { value: values, isValid: !!values.length };
        }
        const { checked, value, attributes } = options[0].ref;
        return checked
            ? attributes && !isUndefined(attributes.value)
                ? isUndefined(value) || value === ''
                    ? validResult
                    : { value: value, isValid: true }
                : validResult
            : defaultResult;
    }
    return defaultResult;
};

function getFieldValue(fieldsRef, name, shallowFieldsStateRef, excludeDisabled, shouldKeepRawValue) {
    const field = fieldsRef.current[name];
    if (field) {
        const { ref: { value, disabled }, ref, valueAsNumber, valueAsDate, setValueAs, } = field;
        if (disabled && excludeDisabled) {
            return;
        }
        if (isFileInput(ref)) {
            return ref.files;
        }
        if (isRadioInput(ref)) {
            return getRadioValue(field.options).value;
        }
        if (isMultipleSelect(ref)) {
            return getMultipleSelectValue(ref.options);
        }
        if (isCheckBoxInput(ref)) {
            return getCheckboxValue(field.options).value;
        }
        return shouldKeepRawValue
            ? value
            : valueAsNumber
                ? value === ''
                    ? NaN
                    : +value
                : valueAsDate
                    ? ref.valueAsDate
                    : setValueAs
                        ? setValueAs(value)
                        : value;
    }
    if (shallowFieldsStateRef) {
        return get(shallowFieldsStateRef.current, name);
    }
}

function isDetached(element) {
    if (!element) {
        return true;
    }
    if (!(element instanceof HTMLElement) ||
        element.nodeType === Node.DOCUMENT_NODE) {
        return false;
    }
    return isDetached(element.parentNode);
}

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var isBoolean = (value) => typeof value === 'boolean';

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function unset(object, path) {
    const updatePath = isKey(path) ? [path] : stringToPath(path);
    const childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
    const key = updatePath[updatePath.length - 1];
    let previousObjRef;
    if (childObject) {
        delete childObject[key];
    }
    for (let k = 0; k < updatePath.slice(0, -1).length; k++) {
        let index = -1;
        let objectRef;
        const currentPaths = updatePath.slice(0, -(k + 1));
        const currentPathsLength = currentPaths.length - 1;
        if (k > 0) {
            previousObjRef = object;
        }
        while (++index < currentPaths.length) {
            const item = currentPaths[index];
            objectRef = objectRef ? objectRef[item] : object[item];
            if (currentPathsLength === index &&
                ((isObject(objectRef) && isEmptyObject(objectRef)) ||
                    (Array.isArray(objectRef) &&
                        !objectRef.filter((data) => (isObject(data) && !isEmptyObject(data)) || isBoolean(data)).length))) {
                previousObjRef ? delete previousObjRef[item] : delete object[item];
            }
            previousObjRef = objectRef;
        }
    }
    return object;
}

const isSameRef = (fieldValue, ref) => fieldValue && fieldValue.ref === ref;
function findRemovedFieldAndRemoveListener(fieldsRef, handleChange, field, shallowFieldsStateRef, shouldUnregister, forceDelete) {
    const { ref, ref: { name }, } = field;
    const fieldRef = fieldsRef.current[name];
    if (!shouldUnregister) {
        const value = getFieldValue(fieldsRef, name, shallowFieldsStateRef);
        !isUndefined(value) && set(shallowFieldsStateRef.current, name, value);
    }
    if (!ref.type || !fieldRef) {
        delete fieldsRef.current[name];
        return;
    }
    if (isRadioInput(ref) || isCheckBoxInput(ref)) {
        if (Array.isArray(fieldRef.options) && fieldRef.options.length) {
            compact(fieldRef.options).forEach((option = {}, index) => {
                if ((isDetached(option.ref) && isSameRef(option, option.ref)) ||
                    forceDelete) {
                    removeAllEventListeners(option.ref, handleChange);
                    unset(fieldRef.options, `[${index}]`);
                }
            });
            if (fieldRef.options && !compact(fieldRef.options).length) {
                delete fieldsRef.current[name];
            }
        }
        else {
            delete fieldsRef.current[name];
        }
    }
    else if ((isDetached(ref) && isSameRef(fieldRef, ref)) || forceDelete) {
        removeAllEventListeners(ref, handleChange);
        delete fieldsRef.current[name];
    }
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepMerge(target, source) {
    if (isPrimitive(target) || isPrimitive(source)) {
        return source;
    }
    for (const key in source) {
        const targetValue = target[key];
        const sourceValue = source[key];
        try {
            target[key] =
                (isObject(targetValue) && isObject(sourceValue)) ||
                    (Array.isArray(targetValue) && Array.isArray(sourceValue))
                    ? deepMerge(targetValue, sourceValue)
                    : sourceValue;
        }
        catch (_a) { }
    }
    return target;
}

function deepEqual(object1, object2, isErrorObject) {
    if (isPrimitive(object1) ||
        isPrimitive(object2) ||
        object1 instanceof Date ||
        object2 instanceof Date) {
        return object1 === object2;
    }
    if (!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(object1)) {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = object1[key];
            if (!(isErrorObject && key === 'ref')) {
                const val2 = object2[key];
                if ((isObject(val1) || Array.isArray(val1)) &&
                    (isObject(val2) || Array.isArray(val2))
                    ? !deepEqual(val1, val2, isErrorObject)
                    : val1 !== val2) {
                    return false;
                }
            }
        }
    }
    return true;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
    let index = -1;
    while (++index < values.length) {
        for (const key in values[index]) {
            if (Array.isArray(values[index][key])) {
                !dirtyFields[index] && (dirtyFields[index] = {});
                dirtyFields[index][key] = [];
                setDirtyFields(values[index][key], get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
            }
            else {
                deepEqual(get(defaultValues[index] || {}, key), values[index][key])
                    ? set(dirtyFields[index] || {}, key)
                    : (dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), { [key]: true }));
            }
        }
        parentNode &&
            !dirtyFields.length &&
            delete parentNode[parentName];
    }
    return dirtyFields;
}
var setFieldArrayDirtyFields = (values, defaultValues, dirtyFields) => deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));

var isString = (value) => typeof value === 'string';

var getFieldsValues = (fieldsRef, shallowFieldsState, shouldUnregister, excludeDisabled, search) => {
    const output = {};
    for (const name in fieldsRef.current) {
        if (isUndefined(search) ||
            (isString(search)
                ? name.startsWith(search)
                : Array.isArray(search) && search.find((data) => name.startsWith(data)))) {
            output[name] = getFieldValue(fieldsRef, name, undefined, excludeDisabled);
        }
    }
    return shouldUnregister
        ? transformToNestObject(output)
        : deepMerge(shallowFieldsState, transformToNestObject(output));
};

var isErrorStateChanged = ({ errors, name, error, validFields, fieldsWithValidation, }) => {
    const isValid = isUndefined(error);
    const previousError = get(errors, name);
    return ((isValid && !!previousError) ||
        (!isValid && !deepEqual(previousError, error, true)) ||
        (isValid && get(fieldsWithValidation, name) && !get(validFields, name)));
};

var isRegex = (value) => value instanceof RegExp;

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var isFunction = (value) => typeof value === 'function';

var isMessage = (value) => isString(value) || (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(value);

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) || (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? Object.assign(Object.assign({}, errors[name]), { types: Object.assign(Object.assign({}, (errors[name] && errors[name].types ? errors[name].types : {})), { [type]: message || true }) }) : {};

var validateField = async (fieldsRef, validateAllFieldCriteria, { ref, ref: { value }, options, required, maxLength, minLength, min, max, pattern, validate, }, shallowFieldsStateRef) => {
    const name = ref.name;
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = value === '';
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = Object.assign({ type: exceedMax ? maxType : minType, message,
            ref }, (exceedMax
            ? appendErrorsCurry(maxType, message)
            : appendErrorsCurry(minType, message)));
    };
    if (required &&
        ((!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(value))) ||
            (isBoolean(value) && !value) ||
            (isCheckBox && !getCheckboxValue(options).isValid) ||
            (isRadio && !getRadioValue(options).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.required, message, ref: isRadioOrCheckbox
                    ? ((fieldsRef.current[name].options || [])[0] || {}).ref
                    : ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if ((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && value !== '') {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNaN(value)) {
            const valueNumber = ref.valueAsNumber || parseFloat(value);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(value);
            if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(value) && !isEmpty && (maxLength || minLength)) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            value.length > maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            value.length < minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (isString(value) && pattern && !isEmpty) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !patternValue.test(value)) {
            error[name] = Object.assign({ type: INPUT_VALIDATION_RULES.pattern, message,
                ref }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                return error;
            }
        }
    }
    if (validate) {
        const fieldValue = getFieldValue(fieldsRef, name, shallowFieldsStateRef, false, true);
        const validateRef = isRadioOrCheckbox && options ? options[0].ref : ref;
        if (isFunction(validate)) {
            const result = await validate(fieldValue);
            const validateError = getValidateError(result, validateRef);
            if (validateError) {
                error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const [key, validateFunction] of Object.entries(validate)) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateResult = await validateFunction(fieldValue);
                const validateError = getValidateError(validateResult, validateRef, key);
                if (validateError) {
                    validationResult = Object.assign(Object.assign({}, validateError), appendErrorsCurry(key, validateError.message));
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = Object.assign({ ref: validateRef }, validationResult);
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    return error;
};

const getPath = (rootPath, values, paths = []) => {
    for (const property in values) {
        const rootName = (rootPath +
            (isObject(values)
                ? `.${property}`
                : `[${property}]`));
        isPrimitive(values[property])
            ? paths.push(rootName)
            : getPath(rootName, values[property], paths);
    }
    return paths;
};

var assignWatchFields = (fieldValues, fieldName, watchFields, inputValue, isSingleField) => {
    let value = undefined;
    watchFields.add(fieldName);
    if (!isEmptyObject(fieldValues)) {
        value = get(fieldValues, fieldName);
        if (isObject(value) || Array.isArray(value)) {
            getPath(fieldName, value).forEach((name) => watchFields.add(name));
        }
    }
    return isUndefined(value)
        ? isSingleField
            ? inputValue
            : get(inputValue, fieldName)
        : value;
};

var skipValidation = ({ isOnBlur, isOnChange, isOnTouch, isTouched, isReValidateOnBlur, isReValidateOnChange, isBlurEvent, isSubmitted, isOnAll, }) => {
    if (isOnAll) {
        return false;
    }
    else if (!isSubmitted && isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? isReValidateOnChange : isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var getFieldArrayParentName = (name) => name.substring(0, name.indexOf('['));

const isMatchFieldArrayName = (name, searchName) => RegExp(`^${searchName}([|.)\\d+`.replace(/\[/g, '\\[').replace(/\]/g, '\\]')).test(name);
var isNameInFieldArray = (names, name) => [...names].some((current) => isMatchFieldArrayName(name, current));

var isSelectInput = (element) => element.type === `${SELECT}-one`;

function onDomRemove(fieldsRef, removeFieldEventListenerAndRef) {
    const observer = new MutationObserver(() => {
        for (const field of Object.values(fieldsRef.current)) {
            if (field && field.options) {
                for (const option of field.options) {
                    if (option && option.ref && isDetached(option.ref)) {
                        removeFieldEventListenerAndRef(field);
                    }
                }
            }
            else if (field && isDetached(field.ref)) {
                removeFieldEventListenerAndRef(field);
            }
        }
    });
    observer.observe(window.document, {
        childList: true,
        subtree: true,
    });
    return observer;
}

var isWeb = typeof window !== UNDEFINED && typeof document !== UNDEFINED;

function cloneObject(data) {
    var _a;
    let copy;
    if (isPrimitive(data) ||
        (isWeb && (data instanceof File || isHTMLElement(data)))) {
        return data;
    }
    if (!['Set', 'Map', 'Object', 'Date', 'Array'].includes((_a = data.constructor) === null || _a === void 0 ? void 0 : _a.name)) {
        return data;
    }
    if (data instanceof Date) {
        copy = new Date(data.getTime());
        return copy;
    }
    if (data instanceof Set) {
        copy = new Set();
        for (const item of data) {
            copy.add(item);
        }
        return copy;
    }
    if (data instanceof Map) {
        copy = new Map();
        for (const key of data.keys()) {
            copy.set(key, cloneObject(data.get(key)));
        }
        return copy;
    }
    copy = Array.isArray(data) ? [] : {};
    for (const key in data) {
        copy[key] = cloneObject(data[key]);
    }
    return copy;
}

var modeChecker = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isRadioOrCheckboxFunction = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

const isWindowUndefined = typeof window === UNDEFINED;
const isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;
function useForm({ mode = VALIDATION_MODE.onSubmit, reValidateMode = VALIDATION_MODE.onChange, resolver, context, defaultValues = {}, shouldFocusError = true, shouldUnregister = true, criteriaMode, } = {}) {
    const fieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldArrayDefaultValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldArrayValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const watchFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    const useWatchFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const useWatchRenderFunctionsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const fieldsWithValidationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const validFieldsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const defaultValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(defaultValues);
    const isUnMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const isWatchAllRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const handleChangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const shallowFieldsStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const resetFieldArrayFunctionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({});
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    const resolverRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(resolver);
    const fieldArrayNamesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    const modeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(modeChecker(mode));
    const { isOnSubmit, isOnTouch } = modeRef.current;
    const isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;
    const [formState, setFormState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        isDirty: false,
        isValidating: false,
        dirtyFields: {},
        isSubmitted: false,
        submitCount: 0,
        touched: {},
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: !isOnSubmit,
        errors: {},
    });
    const readFormStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        isDirty: !isProxyEnabled,
        dirtyFields: !isProxyEnabled,
        touched: !isProxyEnabled || isOnTouch,
        isValidating: !isProxyEnabled,
        isSubmitting: !isProxyEnabled,
        isValid: !isProxyEnabled,
    });
    const formStateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(formState);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const { isOnBlur: isReValidateOnBlur, isOnChange: isReValidateOnChange, } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(modeChecker(reValidateMode)).current;
    contextRef.current = context;
    resolverRef.current = resolver;
    formStateRef.current = formState;
    shallowFieldsStateRef.current = shouldUnregister
        ? {}
        : isEmptyObject(shallowFieldsStateRef.current)
            ? cloneObject(defaultValues)
            : shallowFieldsStateRef.current;
    const updateFormState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((state = {}) => {
        if (!isUnMount.current) {
            formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), state);
            setFormState(formStateRef.current);
        }
    }, []);
    const updateIsValidating = () => readFormStateRef.current.isValidating &&
        updateFormState({
            isValidating: true,
        });
    const shouldRenderBaseOnError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, error, shouldRender = false, state = {}, isValid) => {
        let shouldReRender = shouldRender ||
            isErrorStateChanged({
                errors: formStateRef.current.errors,
                error,
                name,
                validFields: validFieldsRef.current,
                fieldsWithValidation: fieldsWithValidationRef.current,
            });
        const previousError = get(formStateRef.current.errors, name);
        if (error) {
            unset(validFieldsRef.current, name);
            shouldReRender =
                shouldReRender ||
                    !previousError ||
                    !deepEqual(previousError, error, true);
            set(formStateRef.current.errors, name, error);
        }
        else {
            if (get(fieldsWithValidationRef.current, name) || resolverRef.current) {
                set(validFieldsRef.current, name, true);
                shouldReRender = shouldReRender || previousError;
            }
            unset(formStateRef.current.errors, name);
        }
        if ((shouldReRender && !isNullOrUndefined(shouldRender)) ||
            !isEmptyObject(state) ||
            readFormStateRef.current.isValidating) {
            updateFormState(Object.assign(Object.assign(Object.assign({}, state), (resolverRef.current ? { isValid: !!isValid } : {})), { isValidating: false }));
        }
    }, []);
    const setFieldValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, rawValue) => {
        const { ref, options } = fieldsRef.current[name];
        const value = isWeb && isHTMLElement(ref) && isNullOrUndefined(rawValue)
            ? ''
            : rawValue;
        if (isRadioInput(ref)) {
            (options || []).forEach(({ ref: radioRef }) => (radioRef.checked = radioRef.value === value));
        }
        else if (isFileInput(ref) && !isString(value)) {
            ref.files = value;
        }
        else if (isMultipleSelect(ref)) {
            [...ref.options].forEach((selectRef) => (selectRef.selected = value.includes(selectRef.value)));
        }
        else if (isCheckBoxInput(ref) && options) {
            options.length > 1
                ? options.forEach(({ ref: checkboxRef }) => (checkboxRef.checked = Array.isArray(value)
                    ? !!value.find((data) => data === checkboxRef.value)
                    : value === checkboxRef.value))
                : (options[0].ref.checked = !!value);
        }
        else {
            ref.value = value;
        }
    }, []);
    const isFormDirty = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, data) => {
        if (readFormStateRef.current.isDirty) {
            const formValues = getValues();
            name && data && set(formValues, name, data);
            return !deepEqual(formValues, defaultValuesRef.current);
        }
        return false;
    }, []);
    const updateAndGetDirtyState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, shouldRender = true) => {
        if (readFormStateRef.current.isDirty ||
            readFormStateRef.current.dirtyFields) {
            const isFieldDirty = !deepEqual(get(defaultValuesRef.current, name), getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            const isDirtyFieldExist = get(formStateRef.current.dirtyFields, name);
            const previousIsDirty = formStateRef.current.isDirty;
            isFieldDirty
                ? set(formStateRef.current.dirtyFields, name, true)
                : unset(formStateRef.current.dirtyFields, name);
            const state = {
                isDirty: isFormDirty(),
                dirtyFields: formStateRef.current.dirtyFields,
            };
            const isChanged = (readFormStateRef.current.isDirty &&
                previousIsDirty !== state.isDirty) ||
                (readFormStateRef.current.dirtyFields &&
                    isDirtyFieldExist !== get(formStateRef.current.dirtyFields, name));
            isChanged && shouldRender && updateFormState(state);
            return isChanged ? state : {};
        }
        return {};
    }, []);
    const executeValidation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (name, skipReRender) => {
        if (false) {}
        const error = (await validateField(fieldsRef, isValidateAllFieldCriteria, fieldsRef.current[name], shallowFieldsStateRef))[name];
        shouldRenderBaseOnError(name, error, skipReRender);
        return isUndefined(error);
    }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    const executeSchemaOrResolverValidation = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (names) => {
        const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
        const previousFormIsValid = formStateRef.current.isValid;
        if (Array.isArray(names)) {
            const isInputsValid = names
                .map((name) => {
                const error = get(errors, name);
                error
                    ? set(formStateRef.current.errors, name, error)
                    : unset(formStateRef.current.errors, name);
                return !error;
            })
                .every(Boolean);
            updateFormState({
                isValid: isEmptyObject(errors),
                isValidating: false,
            });
            return isInputsValid;
        }
        else {
            const error = get(errors, names);
            shouldRenderBaseOnError(names, error, previousFormIsValid !== isEmptyObject(errors), {}, isEmptyObject(errors));
            return !error;
        }
    }, [shouldRenderBaseOnError, isValidateAllFieldCriteria]);
    const trigger = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (name) => {
        const fields = name || Object.keys(fieldsRef.current);
        updateIsValidating();
        if (resolverRef.current) {
            return executeSchemaOrResolverValidation(fields);
        }
        if (Array.isArray(fields)) {
            !name && (formStateRef.current.errors = {});
            const result = await Promise.all(fields.map(async (data) => await executeValidation(data, null)));
            updateFormState({
                isValidating: false,
            });
            return result.every(Boolean);
        }
        return await executeValidation(fields);
    }, [executeSchemaOrResolverValidation, executeValidation]);
    const setInternalValues = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, value, { shouldDirty, shouldValidate }) => {
        const data = {};
        set(data, name, value);
        for (const fieldName of getPath(name, value)) {
            if (fieldsRef.current[fieldName]) {
                setFieldValue(fieldName, get(data, fieldName));
                shouldDirty && updateAndGetDirtyState(fieldName);
                shouldValidate && trigger(fieldName);
            }
        }
    }, [trigger, setFieldValue, updateAndGetDirtyState]);
    const setInternalValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name, value, config) => {
        !shouldUnregister &&
            !isPrimitive(value) &&
            set(shallowFieldsStateRef.current, name, Array.isArray(value) ? [...value] : Object.assign({}, value));
        if (fieldsRef.current[name]) {
            setFieldValue(name, value);
            config.shouldDirty && updateAndGetDirtyState(name);
            config.shouldValidate && trigger(name);
        }
        else if (!isPrimitive(value)) {
            setInternalValues(name, value, config);
            if (fieldArrayNamesRef.current.has(name)) {
                const parentName = getFieldArrayParentName(name) || name;
                set(fieldArrayDefaultValuesRef.current, name, value);
                resetFieldArrayFunctionRef.current[parentName]({
                    [parentName]: get(fieldArrayDefaultValuesRef.current, parentName),
                });
                if ((readFormStateRef.current.isDirty ||
                    readFormStateRef.current.dirtyFields) &&
                    config.shouldDirty) {
                    set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
                    updateFormState({
                        isDirty: !deepEqual(Object.assign(Object.assign({}, getValues()), { [name]: value }), defaultValuesRef.current),
                    });
                }
            }
        }
        !shouldUnregister && set(shallowFieldsStateRef.current, name, value);
    }, [updateAndGetDirtyState, setFieldValue, setInternalValues]);
    const isFieldWatched = (name) => isWatchAllRef.current ||
        watchFieldsRef.current.has(name) ||
        watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
    const renderWatchedInputs = (name) => {
        let found = true;
        if (!isEmptyObject(useWatchFieldsRef.current)) {
            for (const key in useWatchFieldsRef.current) {
                if (!name ||
                    !useWatchFieldsRef.current[key].size ||
                    useWatchFieldsRef.current[key].has(name) ||
                    useWatchFieldsRef.current[key].has(getFieldArrayParentName(name))) {
                    useWatchRenderFunctionsRef.current[key]();
                    found = false;
                }
            }
        }
        return found;
    };
    function setValue(name, value, config) {
        setInternalValue(name, value, config || {});
        isFieldWatched(name) && updateFormState();
        renderWatchedInputs(name);
    }
    handleChangeRef.current = handleChangeRef.current
        ? handleChangeRef.current
        : async ({ type, target }) => {
            let name = target.name;
            const field = fieldsRef.current[name];
            let error;
            let isValid;
            if (field) {
                const isBlurEvent = type === EVENTS.BLUR;
                const shouldSkipValidation = skipValidation(Object.assign({ isBlurEvent,
                    isReValidateOnChange,
                    isReValidateOnBlur, isTouched: !!get(formStateRef.current.touched, name), isSubmitted: formStateRef.current.isSubmitted }, modeRef.current));
                let state = updateAndGetDirtyState(name, false);
                let shouldRender = !isEmptyObject(state) ||
                    (!isBlurEvent && isFieldWatched(name));
                if (isBlurEvent &&
                    !get(formStateRef.current.touched, name) &&
                    readFormStateRef.current.touched) {
                    set(formStateRef.current.touched, name, true);
                    state = Object.assign(Object.assign({}, state), { touched: formStateRef.current.touched });
                }
                if (!shouldUnregister && isCheckBoxInput(target)) {
                    set(shallowFieldsStateRef.current, name, getFieldValue(fieldsRef, name));
                }
                if (shouldSkipValidation) {
                    !isBlurEvent && renderWatchedInputs(name);
                    return ((!isEmptyObject(state) ||
                        (shouldRender && isEmptyObject(state))) &&
                        updateFormState(state));
                }
                updateIsValidating();
                if (resolverRef.current) {
                    const { errors } = await resolverRef.current(getValues(), contextRef.current, isValidateAllFieldCriteria);
                    const previousFormIsValid = formStateRef.current.isValid;
                    error = get(errors, name);
                    if (isCheckBoxInput(target) &&
                        !error &&
                        resolverRef.current) {
                        const parentNodeName = getFieldArrayParentName(name);
                        const currentError = get(errors, parentNodeName, {});
                        currentError.type &&
                            currentError.message &&
                            (error = currentError);
                        if (parentNodeName &&
                            (currentError ||
                                get(formStateRef.current.errors, parentNodeName))) {
                            name = parentNodeName;
                        }
                    }
                    isValid = isEmptyObject(errors);
                    previousFormIsValid !== isValid && (shouldRender = true);
                }
                else {
                    error = (await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef))[name];
                }
                !isBlurEvent && renderWatchedInputs(name);
                shouldRenderBaseOnError(name, error, shouldRender, state, isValid);
            }
        };
    function setFieldArrayDefaultValues(data) {
        if (!shouldUnregister) {
            let copy = cloneObject(data);
            for (const value of fieldArrayNamesRef.current) {
                if (isKey(value) && !copy[value]) {
                    copy = Object.assign(Object.assign({}, copy), { [value]: [] });
                }
            }
            return copy;
        }
        return data;
    }
    function getValues(payload) {
        if (isString(payload)) {
            return getFieldValue(fieldsRef, payload, shallowFieldsStateRef);
        }
        if (Array.isArray(payload)) {
            const data = {};
            for (const name of payload) {
                set(data, name, getFieldValue(fieldsRef, name, shallowFieldsStateRef));
            }
            return data;
        }
        return setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister));
    }
    const validateResolver = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (values = {}) => {
        const newDefaultValues = isEmptyObject(fieldsRef.current)
            ? defaultValuesRef.current
            : {};
        const { errors } = (await resolverRef.current(Object.assign(Object.assign(Object.assign({}, newDefaultValues), getValues()), values), contextRef.current, isValidateAllFieldCriteria)) || {};
        const isValid = isEmptyObject(errors);
        formStateRef.current.isValid !== isValid &&
            updateFormState({
                isValid,
            });
    }, [isValidateAllFieldCriteria]);
    const removeFieldEventListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((field, forceDelete) => {
        findRemovedFieldAndRemoveListener(fieldsRef, handleChangeRef.current, field, shallowFieldsStateRef, shouldUnregister, forceDelete);
        if (shouldUnregister) {
            unset(validFieldsRef.current, field.ref.name);
            unset(fieldsWithValidationRef.current, field.ref.name);
        }
    }, [shouldUnregister]);
    const updateWatchedValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((name) => {
        if (isWatchAllRef.current) {
            updateFormState();
        }
        else {
            for (const watchField of watchFieldsRef.current) {
                if (watchField.startsWith(name)) {
                    updateFormState();
                    break;
                }
            }
            renderWatchedInputs(name);
        }
    }, []);
    const removeFieldEventListenerAndRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((field, forceDelete) => {
        if (field) {
            removeFieldEventListener(field, forceDelete);
            if (shouldUnregister && !compact(field.options || []).length) {
                unset(formStateRef.current.errors, field.ref.name);
                set(formStateRef.current.dirtyFields, field.ref.name, true);
                updateFormState({
                    isDirty: isFormDirty(),
                });
                readFormStateRef.current.isValid &&
                    resolverRef.current &&
                    validateResolver();
                updateWatchedValue(field.ref.name);
            }
        }
    }, [validateResolver, removeFieldEventListener]);
    function clearErrors(name) {
        name &&
            (Array.isArray(name) ? name : [name]).forEach((inputName) => fieldsRef.current[inputName] && isKey(inputName)
                ? delete formStateRef.current.errors[inputName]
                : unset(formStateRef.current.errors, inputName));
        updateFormState({
            errors: name ? formStateRef.current.errors : {},
        });
    }
    function setError(name, error) {
        const ref = (fieldsRef.current[name] || {}).ref;
        set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), { ref }));
        updateFormState({
            isValid: false,
        });
        error.shouldFocus && ref && ref.focus && ref.focus();
    }
    const watchInternal = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((fieldNames, defaultValue, watchId) => {
        const watchFields = watchId
            ? useWatchFieldsRef.current[watchId]
            : watchFieldsRef.current;
        let fieldValues = getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, false, fieldNames);
        if (isString(fieldNames)) {
            const parentNodeName = getFieldArrayParentName(fieldNames) || fieldNames;
            if (fieldArrayNamesRef.current.has(parentNodeName)) {
                fieldValues = Object.assign(Object.assign({}, fieldArrayValuesRef.current), fieldValues);
            }
            return assignWatchFields(fieldValues, fieldNames, watchFields, isUndefined(get(defaultValuesRef.current, fieldNames))
                ? defaultValue
                : get(defaultValuesRef.current, fieldNames), true);
        }
        const combinedDefaultValues = isUndefined(defaultValue)
            ? defaultValuesRef.current
            : defaultValue;
        if (Array.isArray(fieldNames)) {
            return fieldNames.reduce((previous, name) => (Object.assign(Object.assign({}, previous), { [name]: assignWatchFields(fieldValues, name, watchFields, combinedDefaultValues) })), {});
        }
        isWatchAllRef.current = isUndefined(watchId);
        return transformToNestObject((!isEmptyObject(fieldValues) && fieldValues) ||
            combinedDefaultValues);
    }, []);
    function watch(fieldNames, defaultValue) {
        return watchInternal(fieldNames, defaultValue);
    }
    function unregister(name) {
        for (const fieldName of Array.isArray(name) ? name : [name]) {
            removeFieldEventListenerAndRef(fieldsRef.current[fieldName], true);
        }
    }
    function registerFieldRef(ref, options = {}) {
        if (false) {}
        const { name, type, value } = ref;
        const fieldRefAndValidationOptions = Object.assign({ ref }, options);
        const fields = fieldsRef.current;
        const isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);
        const isFieldArray = isNameInFieldArray(fieldArrayNamesRef.current, name);
        const compareRef = (currentRef) => isWeb && (!isHTMLElement(ref) || currentRef === ref);
        let field = fields[name];
        let isEmptyDefaultValue = true;
        let defaultValue;
        if (field &&
            (isRadioOrCheckbox
                ? Array.isArray(field.options) &&
                    compact(field.options).find((option) => {
                        return value === option.ref.value && compareRef(option.ref);
                    })
                : compareRef(field.ref))) {
            fields[name] = Object.assign(Object.assign({}, field), options);
            return;
        }
        if (type) {
            field = isRadioOrCheckbox
                ? Object.assign({ options: [
                        ...compact((field && field.options) || []),
                        {
                            ref,
                        },
                    ], ref: { type, name } }, options) : Object.assign({}, fieldRefAndValidationOptions);
        }
        else {
            field = fieldRefAndValidationOptions;
        }
        fields[name] = field;
        const isEmptyUnmountFields = isUndefined(get(shallowFieldsStateRef.current, name));
        if (!isEmptyObject(defaultValuesRef.current) || !isEmptyUnmountFields) {
            defaultValue = get(isEmptyUnmountFields
                ? defaultValuesRef.current
                : shallowFieldsStateRef.current, name);
            isEmptyDefaultValue = isUndefined(defaultValue);
            if (!isEmptyDefaultValue && !isFieldArray) {
                setFieldValue(name, defaultValue);
            }
        }
        if (!isEmptyObject(options)) {
            set(fieldsWithValidationRef.current, name, true);
            if (!isOnSubmit && readFormStateRef.current.isValid) {
                validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef).then((error) => {
                    const previousFormIsValid = formStateRef.current.isValid;
                    isEmptyObject(error)
                        ? set(validFieldsRef.current, name, true)
                        : unset(validFieldsRef.current, name);
                    previousFormIsValid !== isEmptyObject(error) && updateFormState();
                });
            }
        }
        if (shouldUnregister && !(isFieldArray && isEmptyDefaultValue)) {
            !isFieldArray && unset(formStateRef.current.dirtyFields, name);
        }
        if (type) {
            attachEventListeners(isRadioOrCheckbox && field.options
                ? field.options[field.options.length - 1]
                : field, isRadioOrCheckbox || isSelectInput(ref), handleChangeRef.current);
        }
    }
    function register(refOrRegisterOptions, options) {
        if (!isWindowUndefined) {
            if (isString(refOrRegisterOptions)) {
                registerFieldRef({ name: refOrRegisterOptions }, options);
            }
            else if (isObject(refOrRegisterOptions) &&
                'name' in refOrRegisterOptions) {
                registerFieldRef(refOrRegisterOptions, options);
            }
            else {
                return (ref) => ref && registerFieldRef(ref, refOrRegisterOptions);
            }
        }
    }
    const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((onValid, onInvalid) => async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.persist();
        }
        let fieldErrors = {};
        let fieldValues = setFieldArrayDefaultValues(getFieldsValues(fieldsRef, cloneObject(shallowFieldsStateRef.current), shouldUnregister, true));
        readFormStateRef.current.isSubmitting &&
            updateFormState({
                isSubmitting: true,
            });
        try {
            if (resolverRef.current) {
                const { errors, values } = await resolverRef.current(fieldValues, contextRef.current, isValidateAllFieldCriteria);
                formStateRef.current.errors = fieldErrors = errors;
                fieldValues = values;
            }
            else {
                for (const field of Object.values(fieldsRef.current)) {
                    if (field) {
                        const { name } = field.ref;
                        const fieldError = await validateField(fieldsRef, isValidateAllFieldCriteria, field, shallowFieldsStateRef);
                        if (fieldError[name]) {
                            set(fieldErrors, name, fieldError[name]);
                            unset(validFieldsRef.current, name);
                        }
                        else if (get(fieldsWithValidationRef.current, name)) {
                            unset(formStateRef.current.errors, name);
                            set(validFieldsRef.current, name, true);
                        }
                    }
                }
            }
            if (isEmptyObject(fieldErrors) &&
                Object.keys(formStateRef.current.errors).every((name) => name in fieldsRef.current)) {
                updateFormState({
                    errors: {},
                    isSubmitting: true,
                });
                await onValid(fieldValues, e);
            }
            else {
                formStateRef.current.errors = Object.assign(Object.assign({}, formStateRef.current.errors), fieldErrors);
                onInvalid && (await onInvalid(formStateRef.current.errors, e));
                shouldFocusError &&
                    focusOnErrorField(fieldsRef.current, formStateRef.current.errors);
            }
        }
        finally {
            formStateRef.current.isSubmitting = false;
            updateFormState({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                submitCount: formStateRef.current.submitCount + 1,
            });
        }
    }, [shouldFocusError, isValidateAllFieldCriteria]);
    const resetRefs = ({ errors, isDirty, isSubmitted, touched, isValid, submitCount, dirtyFields, }) => {
        if (!isValid) {
            validFieldsRef.current = {};
            fieldsWithValidationRef.current = {};
        }
        fieldArrayDefaultValuesRef.current = {};
        watchFieldsRef.current = new Set();
        isWatchAllRef.current = false;
        updateFormState({
            submitCount: submitCount ? formStateRef.current.submitCount : 0,
            isDirty: isDirty ? formStateRef.current.isDirty : false,
            isSubmitted: isSubmitted ? formStateRef.current.isSubmitted : false,
            isValid: isValid ? formStateRef.current.isValid : false,
            dirtyFields: dirtyFields ? formStateRef.current.dirtyFields : {},
            touched: touched ? formStateRef.current.touched : {},
            errors: errors ? formStateRef.current.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (values, omitResetState = {}) => {
        if (isWeb) {
            for (const field of Object.values(fieldsRef.current)) {
                if (field) {
                    const { ref, options } = field;
                    const inputRef = isRadioOrCheckboxFunction(ref) && Array.isArray(options)
                        ? options[0].ref
                        : ref;
                    if (isHTMLElement(inputRef)) {
                        try {
                            inputRef.closest('form').reset();
                            break;
                        }
                        catch (_a) { }
                    }
                }
            }
        }
        fieldsRef.current = {};
        defaultValuesRef.current = Object.assign({}, (values || defaultValuesRef.current));
        values && renderWatchedInputs('');
        Object.values(resetFieldArrayFunctionRef.current).forEach((resetFieldArray) => isFunction(resetFieldArray) && resetFieldArray());
        shallowFieldsStateRef.current = shouldUnregister
            ? {}
            : cloneObject(values || defaultValuesRef.current);
        resetRefs(omitResetState);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        resolver && readFormStateRef.current.isValid && validateResolver();
        observerRef.current =
            observerRef.current || !isWeb
                ? observerRef.current
                : onDomRemove(fieldsRef, removeFieldEventListenerAndRef);
    }, [removeFieldEventListenerAndRef, defaultValuesRef.current]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => {
        observerRef.current && observerRef.current.disconnect();
        isUnMount.current = true;
        if (false) {}
        Object.values(fieldsRef.current).forEach((field) => removeFieldEventListenerAndRef(field, true));
    }, []);
    if (!resolver && readFormStateRef.current.isValid) {
        formState.isValid =
            deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) &&
                isEmptyObject(formStateRef.current.errors);
    }
    const commonProps = {
        trigger,
        setValue: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(setValue, [setInternalValue, trigger]),
        getValues: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(getValues, []),
        register: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(register, [defaultValuesRef.current]),
        unregister: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(unregister, []),
        formState: isProxyEnabled
            ? new Proxy(formState, {
                get: (obj, prop) => {
                    if (false) {}
                    if (prop in obj) {
                        readFormStateRef.current[prop] = true;
                        return obj[prop];
                    }
                    return undefined;
                },
            })
            : formState,
    };
    const control = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => (Object.assign({ isFormDirty,
        updateWatchedValue,
        shouldUnregister,
        updateFormState,
        removeFieldEventListener,
        watchInternal, mode: modeRef.current, reValidateMode: {
            isReValidateOnBlur,
            isReValidateOnChange,
        }, validateResolver: resolver ? validateResolver : undefined, fieldsRef,
        resetFieldArrayFunctionRef,
        useWatchFieldsRef,
        useWatchRenderFunctionsRef,
        fieldArrayDefaultValuesRef,
        validFieldsRef,
        fieldsWithValidationRef,
        fieldArrayNamesRef,
        readFormStateRef,
        formStateRef,
        defaultValuesRef,
        shallowFieldsStateRef,
        fieldArrayValuesRef }, commonProps)), [
        defaultValuesRef.current,
        updateWatchedValue,
        shouldUnregister,
        removeFieldEventListener,
        watchInternal,
    ]);
    return Object.assign({ watch,
        control,
        handleSubmit, reset: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(reset, []), clearErrors: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(clearErrors, []), setError: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(setError, []), errors: formState.errors }, commonProps);
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const FormContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
FormContext.displayName = 'RHFContext';
const useFormContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(FormContext);
const FormProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FormContext.Provider, { value: Object.assign({}, props) }, children));
};

var generateId = () => {
    const d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort((a, b) => a - b));

var moveArrayAt = (data, from, to) => {
    if (Array.isArray(data)) {
        if (isUndefined(data[to])) {
            data[to] = undefined;
        }
        data.splice(to, 0, data.splice(from, 1)[0]);
        return data;
    }
    return [];
};

var swapArrayAt = (data, indexA, indexB) => {
    const temp = [data[indexB], data[indexA]];
    data[indexA] = temp[0];
    data[indexB] = temp[1];
};

function prepend(data, value) {
    return [...(Array.isArray(value) ? value : [value || undefined]), ...data];
}

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...(Array.isArray(value) ? value : [value || undefined]),
        ...data.slice(index),
    ];
}

var fillEmptyArray = (value) => Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;

var fillBooleanArray = (value) => (Array.isArray(value) ? value : [value]).map((data) => {
    if (isObject(data)) {
        const object = {};
        for (const key in data) {
            object[key] = true;
        }
        return object;
    }
    return true;
});

const mapIds = (values = [], keyName, skipWarn) => {
    if (false) {}
    return values.map((value) => (Object.assign({ [keyName]: value[keyName] || generateId() }, value)));
};
const useFieldArray = ({ control, name, keyName = 'id', }) => {
    const methods = useFormContext();
    if (false) {}
    const focusIndexRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(-1);
    const isUnMount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const { isFormDirty, updateWatchedValue, resetFieldArrayFunctionRef, fieldArrayNamesRef, fieldsRef, defaultValuesRef, removeFieldEventListener, formStateRef, shallowFieldsStateRef, updateFormState, readFormStateRef, validFieldsRef, fieldsWithValidationRef, fieldArrayDefaultValuesRef, validateResolver, getValues, shouldUnregister, fieldArrayValuesRef, } = control || methods.control;
    const getDefaultValues = (values) => get(shouldUnregister ? values : shallowFieldsStateRef.current, name, []);
    const fieldArrayParentName = getFieldArrayParentName(name);
    const memoizedDefaultValues = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)([
        ...(get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)
            ? getDefaultValues(fieldArrayDefaultValuesRef.current)
            : getDefaultValues(defaultValuesRef.current)),
    ]);
    const [fields, setFields] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(mapIds(memoizedDefaultValues.current, keyName));
    set(fieldArrayValuesRef.current, name, compact(fields));
    const omitKey = (fields) => fields.map((_a = {}) => {
        var _b = keyName, omitted = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return rest;
    });
    fieldArrayNamesRef.current.add(name);
    const getFieldArrayValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => get(fieldArrayValuesRef.current, name, []), [name]);
    const getCurrentFieldsValues = () => mapIds(get(getValues(), name, getFieldArrayValue()).map((item, index) => (Object.assign(Object.assign({}, getFieldArrayValue()[index]), item))), keyName, true);
    fieldArrayNamesRef.current.add(name);
    if (fieldArrayParentName &&
        !get(fieldArrayDefaultValuesRef.current, fieldArrayParentName)) {
        set(fieldArrayDefaultValuesRef.current, fieldArrayParentName, cloneObject(get(defaultValuesRef.current, fieldArrayParentName)));
    }
    const setFieldAndValidState = (fieldsValues) => {
        setFields(fieldsValues);
        set(fieldArrayValuesRef.current, name, fieldsValues);
        if (readFormStateRef.current.isValid && validateResolver) {
            const values = getValues();
            set(values, name, fieldsValues);
            validateResolver(values);
        }
    };
    const resetFields = () => {
        for (const key in fieldsRef.current) {
            if (isMatchFieldArrayName(key, name)) {
                removeFieldEventListener(fieldsRef.current[key], true);
                delete fieldsRef.current[key];
            }
        }
    };
    const cleanup = (ref) => !compact(get(ref, name, [])).length && unset(ref, name);
    const updateDirtyFieldsWithDefaultValues = (updatedFieldArrayValues) => {
        if (updatedFieldArrayValues) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
        }
    };
    const batchStateUpdate = (method, args, updatedFieldValues, updatedFormValues = [], shouldSet = true, shouldUpdateValid = false) => {
        if (get(shallowFieldsStateRef.current, name)) {
            const output = method(get(shallowFieldsStateRef.current, name), args.argA, args.argB);
            shouldSet && set(shallowFieldsStateRef.current, name, output);
        }
        if (get(fieldArrayDefaultValuesRef.current, name)) {
            const output = method(get(fieldArrayDefaultValuesRef.current, name), args.argA, args.argB);
            shouldSet && set(fieldArrayDefaultValuesRef.current, name, output);
        }
        if (Array.isArray(get(formStateRef.current.errors, name))) {
            const output = method(get(formStateRef.current.errors, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.errors, name, output);
            cleanup(formStateRef.current.errors);
        }
        if (readFormStateRef.current.touched &&
            get(formStateRef.current.touched, name)) {
            const output = method(get(formStateRef.current.touched, name), args.argA, args.argB);
            shouldSet && set(formStateRef.current.touched, name, output);
            cleanup(formStateRef.current.touched);
        }
        if (readFormStateRef.current.dirtyFields ||
            readFormStateRef.current.isDirty) {
            set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFormValues), get(defaultValuesRef.current, name, []), get(formStateRef.current.dirtyFields, name, [])));
            updateDirtyFieldsWithDefaultValues(updatedFieldValues);
            cleanup(formStateRef.current.dirtyFields);
        }
        if (shouldUpdateValid &&
            readFormStateRef.current.isValid &&
            !validateResolver) {
            set(validFieldsRef.current, name, method(get(validFieldsRef.current, name, []), args.argA));
            cleanup(validFieldsRef.current);
            set(fieldsWithValidationRef.current, name, method(get(fieldsWithValidationRef.current, name, []), args.argA));
            cleanup(fieldsWithValidationRef.current);
        }
        if (!isUnMount.current && readFormStateRef.current.isDirty) {
            updateFormState({
                isDirty: isFormDirty(name, omitKey(updatedFormValues)),
            });
        }
    };
    const append = (value, shouldFocus = true) => {
        const appendValue = Array.isArray(value) ? value : [value];
        const updateFormValues = [
            ...getCurrentFieldsValues(),
            ...mapIds(appendValue, keyName),
        ];
        setFieldAndValidState(updateFormValues);
        if (readFormStateRef.current.dirtyFields ||
            readFormStateRef.current.isDirty) {
            updateDirtyFieldsWithDefaultValues(updateFormValues);
            updateFormState({
                isDirty: true,
                dirtyFields: formStateRef.current.dirtyFields,
            });
        }
        !shouldUnregister &&
            set(shallowFieldsStateRef.current, name, [
                ...(get(shallowFieldsStateRef.current, name) || []),
                ...cloneObject(appendValue),
            ]);
        focusIndexRef.current = shouldFocus
            ? get(fieldArrayValuesRef.current, name).length - 1
            : -1;
    };
    const prepend$1 = (value, shouldFocus = true) => {
        const emptyArray = fillEmptyArray(value);
        const updatedFieldArrayValues = prepend(getCurrentFieldsValues(), mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(prepend, {
            argA: emptyArray,
            argC: fillBooleanArray(value),
        }, updatedFieldArrayValues);
        focusIndexRef.current = shouldFocus ? 0 : -1;
    };
    const remove = (index) => {
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldValues = removeArrayAt(fieldValues, index);
        setFieldAndValidState(updatedFieldValues);
        resetFields();
        batchStateUpdate(removeArrayAt, {
            argA: index,
            argC: index,
        }, updatedFieldValues, removeArrayAt(fieldValues, index), true, true);
    };
    const insert$1 = (index, value, shouldFocus = true) => {
        const emptyArray = fillEmptyArray(value);
        const fieldValues = getCurrentFieldsValues();
        const updatedFieldArrayValues = insert(fieldValues, index, mapIds(Array.isArray(value) ? value : [value], keyName));
        setFieldAndValidState(updatedFieldArrayValues);
        resetFields();
        batchStateUpdate(insert, {
            argA: index,
            argB: emptyArray,
            argC: index,
            argD: fillBooleanArray(value),
        }, updatedFieldArrayValues, insert(fieldValues, index));
        focusIndexRef.current = shouldFocus ? index : -1;
    };
    const swap = (indexA, indexB) => {
        const fieldValues = getCurrentFieldsValues();
        swapArrayAt(fieldValues, indexA, indexB);
        resetFields();
        setFieldAndValidState([...fieldValues]);
        batchStateUpdate(swapArrayAt, {
            argA: indexA,
            argB: indexB,
            argC: indexA,
            argD: indexB,
        }, undefined, fieldValues, false);
    };
    const move = (from, to) => {
        const fieldValues = getCurrentFieldsValues();
        moveArrayAt(fieldValues, from, to);
        resetFields();
        setFieldAndValidState([...fieldValues]);
        batchStateUpdate(moveArrayAt, {
            argA: from,
            argB: to,
            argC: from,
            argD: to,
        }, undefined, fieldValues, false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (false) {}
        const defaultValues = get(fieldArrayDefaultValuesRef.current, name);
        if (defaultValues && fields.length < defaultValues.length) {
            set(fieldArrayDefaultValuesRef.current, name, defaultValues.slice(1));
        }
        updateWatchedValue(name);
        if (focusIndexRef.current > -1) {
            for (const key in fieldsRef.current) {
                const field = fieldsRef.current[key];
                if (key.startsWith(`${name}[${focusIndexRef.current}]`) &&
                    field.ref.focus) {
                    field.ref.focus();
                    break;
                }
            }
        }
        focusIndexRef.current = -1;
    }, [fields, name]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const resetFunctions = resetFieldArrayFunctionRef.current;
        const fieldArrayNames = fieldArrayNamesRef.current;
        if (!getFieldArrayParentName(name)) {
            resetFunctions[name] = (data) => {
                resetFields();
                !data && unset(fieldArrayDefaultValuesRef.current, name);
                unset(shallowFieldsStateRef.current, name);
                memoizedDefaultValues.current = get(data || defaultValuesRef.current, name);
                if (!isUnMount.current) {
                    setFields(mapIds(memoizedDefaultValues.current, keyName));
                }
            };
        }
        return () => {
            isUnMount.current = true;
            shouldUnregister && remove();
            resetFields();
            delete resetFunctions[name];
            unset(fieldArrayValuesRef.current, name);
            fieldArrayNames.delete(name);
        };
    }, []);
    return {
        swap: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(swap, [name]),
        move: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(move, [name]),
        prepend: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(prepend$1, [name]),
        append: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(append, [name]),
        remove: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(remove, [name]),
        insert: (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(insert$1, [name]),
        fields: compact(fields),
    };
};

var getInputValue = (event) => isPrimitive(event) ||
    !isObject(event.target) ||
    (isObject(event.target) && !event.type)
    ? event
    : isUndefined(event.target.value)
        ? event.target.checked
        : event.target.value;

function useController({ name, rules, defaultValue, control, onFocus, }) {
    const methods = useFormContext();
    if (false) {}
    const { defaultValuesRef, setValue, register, unregister, trigger, mode, reValidateMode: { isReValidateOnBlur, isReValidateOnChange }, formState, formStateRef: { current: { isSubmitted, touched, errors }, }, updateFormState, readFormStateRef, fieldsRef, fieldArrayNamesRef, shallowFieldsStateRef, } = control || methods.control;
    const isNotFieldArray = !isNameInFieldArray(fieldArrayNamesRef.current, name);
    const getInitialValue = () => !isUndefined(get(shallowFieldsStateRef.current, name)) && isNotFieldArray
        ? get(shallowFieldsStateRef.current, name)
        : isUndefined(defaultValue)
            ? get(defaultValuesRef.current, name)
            : defaultValue;
    const [value, setInputStateValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialValue());
    const valueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        focus: () => null,
    });
    const onFocusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onFocus ||
        (() => {
            if (isFunction(ref.current.focus)) {
                ref.current.focus();
            }
            if (false) {}
        }));
    const shouldValidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((isBlurEvent) => !skipValidation(Object.assign({ isBlurEvent,
        isReValidateOnBlur,
        isReValidateOnChange,
        isSubmitted, isTouched: !!get(touched, name) }, mode)), [
        isReValidateOnBlur,
        isReValidateOnChange,
        isSubmitted,
        touched,
        name,
        mode,
    ]);
    const commonTask = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(([event]) => {
        const data = getInputValue(event);
        setInputStateValue(data);
        valueRef.current = data;
        return data;
    }, []);
    const registerField = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((shouldUpdateValue) => {
        if (false) {}
        if (fieldsRef.current[name]) {
            fieldsRef.current[name] = Object.assign({ ref: fieldsRef.current[name].ref }, rules);
        }
        else {
            register(Object.defineProperties({
                name,
                focus: onFocusRef.current,
            }, {
                value: {
                    set(data) {
                        setInputStateValue(data);
                        valueRef.current = data;
                    },
                    get() {
                        return valueRef.current;
                    },
                },
            }), rules);
            shouldUpdateValue = isUndefined(get(defaultValuesRef.current, name));
        }
        shouldUpdateValue &&
            isNotFieldArray &&
            setInputStateValue(getInitialValue());
    }, [rules, name, register]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => () => unregister(name), [name]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (false) {}
        registerField();
    }, [registerField]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        !fieldsRef.current[name] && registerField(true);
    });
    const onBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
        if (readFormStateRef.current.touched && !get(touched, name)) {
            set(touched, name, true);
            updateFormState({
                touched,
            });
        }
        shouldValidate(true) && trigger(name);
    }, [name, updateFormState, shouldValidate, trigger, readFormStateRef]);
    const onChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...event) => setValue(name, commonTask(event), {
        shouldValidate: shouldValidate(),
        shouldDirty: true,
    }), [setValue, name, shouldValidate]);
    return {
        field: {
            onChange,
            onBlur,
            name,
            value,
            ref,
        },
        meta: Object.defineProperties({
            invalid: !!get(errors, name),
        }, {
            isDirty: {
                get() {
                    return !!get(formState.dirtyFields, name);
                },
            },
            isTouched: {
                get() {
                    return !!get(formState.touched, name);
                },
            },
        }),
    };
}

function useWatch({ control, name, defaultValue, }) {
    const methods = useFormContext();
    if (false) {}
    const { useWatchFieldsRef, useWatchRenderFunctionsRef, watchInternal, defaultValuesRef, } = control || methods.control;
    const updateValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)()[1];
    const idRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    const defaultValueRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(defaultValue);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (false) {}
        const id = (idRef.current = generateId());
        const watchFieldsHookRender = useWatchRenderFunctionsRef.current;
        const watchFieldsHook = useWatchFieldsRef.current;
        watchFieldsHook[id] = new Set();
        watchFieldsHookRender[id] = () => updateValue({});
        watchInternal(name, defaultValueRef.current, id);
        return () => {
            delete watchFieldsHook[id];
            delete watchFieldsHookRender[id];
        };
    }, [
        name,
        useWatchRenderFunctionsRef,
        useWatchFieldsRef,
        watchInternal,
        defaultValueRef,
    ]);
    return idRef.current
        ? watchInternal(name, defaultValueRef.current, idRef.current)
        : isUndefined(defaultValue)
            ? isString(name)
                ? get(defaultValuesRef.current, name)
                : Array.isArray(name)
                    ? name.reduce((previous, inputName) => (Object.assign(Object.assign({}, previous), { [inputName]: get(defaultValuesRef.current, inputName) })), {})
                    : defaultValuesRef.current
            : defaultValue;
}

const Controller = (props) => {
    const { rules, as, render, defaultValue, control, onFocus } = props, rest = __rest(props, ["rules", "as", "render", "defaultValue", "control", "onFocus"]);
    const { field, meta } = useController(props);
    const componentProps = Object.assign(Object.assign({}, rest), field);
    return as
        ? (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(as)
            ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(as, componentProps)
            : (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, componentProps)
        : render
            ? render(field, meta)
            : null;
};


//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 46871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 29983:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(73935);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(99545);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(28747);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(46871);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports["default"] = Modal;

/***/ }),

/***/ 28747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _propTypes = __webpack_require__(99545);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(99685);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(88338);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(57149);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(32409);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(51112);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(35063);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 57149:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(42473);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(51112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),

/***/ 35063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _portalOpenInstances = __webpack_require__(89623);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 32409:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) { var _x, x, buffer, classes; }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 99685:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 89623:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports["default"] = portalOpenInstances;
module.exports = exports["default"];

/***/ }),

/***/ 51112:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(58875);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 88338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(37845);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 37845:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 83253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(29983);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 61118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(55344);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 99545:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(61118)();
}


/***/ }),

/***/ 55344:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 80846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RemoveScroll": function() { return /* reexport */ Combination; }
});

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

// EXTERNAL MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js + 2 modules
var useMergeRef = __webpack_require__(99495);
// EXTERNAL MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js
var medium = __webpack_require__(87122);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = (0,medium/* createSidecarMedium */._)();

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
    var ref = react.useRef(null);
    var _a = react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing,
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
    var SideCar = sideCar;
    var containerRef = (0,useMergeRef/* useMergeRefs */.q)([ref, parentRef]);
    var containerProps = __assign(__assign({}, rest), callbacks);
    return (react.createElement(react.Fragment, null,
        enabled && (react.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode: gapMode })),
        forwardProps ? (react.cloneElement(react.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (react.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false,
};
RemoveScroll.classNames = {
    fullWidth: fullWidthClassName,
    zeroRight: zeroRightClassName,
};


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
    var sideCar = _a.sideCar, rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
    if (!sideCar) {
        throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    }
    var Target = sideCar.read();
    if (!Target) {
        throw new Error('Sidecar medium not found');
    }
    return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
    currentNonce = nonce;
};
var getNonce = function () {
    if (currentNonce) {
        return currentNonce;
    }
    if (true) {
        return __webpack_require__.nc;
    }
    return undefined;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
    if (!document)
        return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = getNonce();
    if (nonce) {
        tag.setAttribute('nonce', nonce);
    }
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) {
        // @ts-ignore
        tag.styleSheet.cssText = css;
    }
    else {
        tag.appendChild(document.createTextNode(css));
    }
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function () {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function (style) {
            if (counter == 0) {
                if ((stylesheet = makeStyleTag())) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function () {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
    var sheet = stylesheetSingleton();
    return function (styles, isDynamic) {
        react.useEffect(function () {
            sheet.add(styles);
            return function () {
                sheet.remove();
            };
        }, [styles && isDynamic]);
    };
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
    var useStyle = styleHookSingleton();
    var Sheet = function (_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0,
};
var parse = function (x) { return parseInt(x || '', 10) || 0; };
var getOffset = function (gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
    if (gapMode === void 0) { gapMode = 'margin'; }
    if (typeof window === 'undefined') {
        return zeroGap;
    }
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
    };
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) { gapMode = 'margin'; }
    return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' &&
            "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
    ]
        .filter(Boolean)
        .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? 'margin' : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */
    var gap = react.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
    return react.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/index.js





;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
var nonPassive = passiveSupported ? { passive: false } : false;

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
    var styles = window.getComputedStyle(node);
    return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
        // contains scroll inside self
        !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
var locationCouldBeScrolled = function (axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
            current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) {
                return true;
            }
        }
        current = current.parentNode;
    } while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function (_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight,
    ];
};
var getHScrollVariables = function (_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth,
    ];
};
var elementCouldBeScrolled = function (axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */
    return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    } while (
    // portaled content
    (!targetInLock && target !== document.body) ||
        // self content
        (targetInLock && (endTarget.contains(target) || endTarget === target)));
    if (isDeltaPositive && ((noOverscroll && availableScroll === 0) || (!noOverscroll && delta > availableScroll))) {
        shouldCancelScroll = true;
    }
    else if (!isDeltaPositive &&
        ((noOverscroll && availableScrollTop === 0) || (!noOverscroll && -delta > availableScrollTop))) {
        shouldCancelScroll = true;
    }
    return shouldCancelScroll;
};

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
    return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
var extractRef = function (ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = react.useRef([]);
    var touchStartRef = react.useRef([0, 0]);
    var activeAxis = react.useRef();
    var id = react.useState(idCounter++)[0];
    var Style = react.useState(styleSingleton)[0];
    var lastProps = react.useRef(props);
    react.useEffect(function () {
        lastProps.current = props;
    }, [props]);
    react.useEffect(function () {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
            return function () {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
            };
        }
        return;
    }, [props.inert, props.lockRef.current, props.shards]);
    var shouldCancelEvent = react.useCallback(function (event, parent) {
        if ('touches' in event && event.touches.length === 2) {
            return !lastProps.current.allowPinchZoom;
        }
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
            return false;
        }
        var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
        if (!canBeScrolledInMainDirection) {
            return true;
        }
        if (canBeScrolledInMainDirection) {
            currentAxis = moveDirection;
        }
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
            // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) {
            return false;
        }
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
            activeAxis.current = currentAxis;
        }
        if (!currentAxis) {
            return true;
        }
        var cancelingAxis = activeAxis.current || currentAxis;
        return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = react.useCallback(function (_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
            // not the last active
            return;
        }
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta); })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) {
                event.preventDefault();
            }
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || [])
                .map(extractRef)
                .filter(Boolean)
                .filter(function (node) { return node.contains(event.target); });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) {
                    event.preventDefault();
                }
            }
        }
    }, []);
    var shouldCancel = react.useCallback(function (name, delta, target, should) {
        var event = { name: name, delta: delta, target: target, should: should };
        shouldPreventQueue.current.push(event);
        setTimeout(function () {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
        }, 1);
    }, []);
    var scrollTouchStart = react.useCallback(function (event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = react.useCallback(function (event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = react.useCallback(function (event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    react.useEffect(function () {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove,
        });
        document.addEventListener('wheel', shouldPrevent, nonPassive);
        document.addEventListener('touchmove', shouldPrevent, nonPassive);
        document.addEventListener('touchstart', scrollTouchStart, nonPassive);
        return function () {
            lockStack = lockStack.filter(function (inst) { return inst !== Style; });
            document.removeEventListener('wheel', shouldPrevent, nonPassive);
            document.removeEventListener('touchmove', shouldPrevent, nonPassive);
            document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return (react.createElement(react.Fragment, null,
        inert ? react.createElement(Style, { styles: generateStyle(id) }) : null,
        removeScrollBar ? react.createElement(RemoveScrollBar, { gapMode: props.gapMode }) : null));
}

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) { return (react.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: sidecar }))); });
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);

;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/index.js




/***/ }),

/***/ 1852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(67294)) : 0;
}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
    return function(modules) {
        function __nested_webpack_require_451__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_451__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __nested_webpack_require_451__.m = modules, __nested_webpack_require_451__.c = installedModules, 
        __nested_webpack_require_451__.d = function(exports, name, getter) {
            __nested_webpack_require_451__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __nested_webpack_require_451__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __nested_webpack_require_451__.d(getter, "a", getter), getter;
        }, __nested_webpack_require_451__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __nested_webpack_require_451__.p = "", __nested_webpack_require_451__(__nested_webpack_require_451__.s = 7);
    }([ function(module, __webpack_exports__, __nested_webpack_require_1860__) {
        "use strict";
        function _slicedToArray(arr, i) {
            return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
        }
        function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o, minLen) {
            if (o) {
                if ("string" == typeof o) return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                return "Object" === n && o.constructor && (n = o.constructor.name), "Map" === n || "Set" === n ? Array.from(o) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(o, minLen) : void 0;
            }
        }
        function _arrayLikeToArray(arr, len) {
            (null == len || len > arr.length) && (len = arr.length);
            for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
            return arr2;
        }
        function _iterableToArrayLimit(arr, i) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(arr)) {
                var _arr = [], _n = !0, _d = !1, _e = void 0;
                try {
                    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                    !i || _arr.length !== i); _n = !0) ;
                } catch (err) {
                    _d = !0, _e = err;
                } finally {
                    try {
                        _n || null == _i.return || _i.return();
                    } finally {
                        if (_d) throw _e;
                    }
                }
                return _arr;
            }
        }
        function _arrayWithHoles(arr) {
            if (Array.isArray(arr)) return arr;
        }
        var __WEBPACK_IMPORTED_MODULE_0_react__ = __nested_webpack_require_1860__(1), __WEBPACK_IMPORTED_MODULE_0_react___default = __nested_webpack_require_1860__.n(__WEBPACK_IMPORTED_MODULE_0_react__), __WEBPACK_IMPORTED_MODULE_1_matchmediaquery__ = __nested_webpack_require_1860__(8), __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default = __nested_webpack_require_1860__.n(__WEBPACK_IMPORTED_MODULE_1_matchmediaquery__), __WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__ = __nested_webpack_require_1860__(2), __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__ = __nested_webpack_require_1860__(10), __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default = __nested_webpack_require_1860__.n(__WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects__), __WEBPACK_IMPORTED_MODULE_4__toQuery__ = __nested_webpack_require_1860__(3), __WEBPACK_IMPORTED_MODULE_5__Context__ = __nested_webpack_require_1860__(6), makeQuery = function(settings) {
            return settings.query || Object(__WEBPACK_IMPORTED_MODULE_4__toQuery__.a)(settings);
        }, hyphenateKeys = function(obj) {
            if (!obj) return null;
            var keys = Object.keys(obj);
            return 0 === keys.length ? null : keys.reduce(function(result, key) {
                return result[Object(__WEBPACK_IMPORTED_MODULE_2_hyphenate_style_name__.a)(key)] = obj[key], 
                result;
            }, {});
        }, useIsUpdate = function() {
            var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(!1);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                ref.current = !0;
            }, []), ref.current;
        }, useDevice = function(deviceFromProps) {
            var deviceFromContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_5__Context__.a), getDevice = function() {
                return hyphenateKeys(deviceFromProps) || hyphenateKeys(deviceFromContext);
            }, _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getDevice), _React$useState2 = _slicedToArray(_React$useState, 2), device = _React$useState2[0], setDevice = _React$useState2[1];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                var newDevice = getDevice();
                __WEBPACK_IMPORTED_MODULE_3_shallow_equal_objects___default()(device, newDevice) || setDevice(newDevice);
            }, [ deviceFromProps, deviceFromContext ]), device;
        }, useQuery = function(settings) {
            var getQuery = function() {
                return makeQuery(settings);
            }, _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getQuery), _React$useState4 = _slicedToArray(_React$useState3, 2), query = _React$useState4[0], setQuery = _React$useState4[1];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                var newQuery = getQuery();
                query !== newQuery && setQuery(newQuery);
            }, [ settings ]), query;
        }, useMatchMedia = function(query, device) {
            var getMatchMedia = function() {
                return __WEBPACK_IMPORTED_MODULE_1_matchmediaquery___default()(query, device || {}, !!device);
            }, _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(getMatchMedia), _React$useState6 = _slicedToArray(_React$useState5, 2), mq = _React$useState6[0], setMq = _React$useState6[1], isUpdate = useIsUpdate();
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                return isUpdate && setMq(getMatchMedia()), function() {
                    mq.dispose();
                };
            }, [ query, device ]), mq;
        }, useMatches = function(mediaQuery) {
            var _React$useState7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(mediaQuery.matches), _React$useState8 = _slicedToArray(_React$useState7, 2), matches = _React$useState8[0], setMatches = _React$useState8[1];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                var updateMatches = function() {
                    setMatches(mediaQuery.matches);
                };
                return mediaQuery.addListener(updateMatches), updateMatches(), function() {
                    mediaQuery.removeListener(updateMatches);
                };
            }, [ mediaQuery ]), matches;
        }, useMediaQuery = function(settings, device, onChange) {
            var deviceSettings = useDevice(device), query = useQuery(settings);
            if (!query) throw new Error("Invalid or missing MediaQuery!");
            var mq = useMatchMedia(query, deviceSettings), matches = useMatches(mq), isUpdate = useIsUpdate();
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function() {
                isUpdate && onChange && onChange(matches);
            }, [ matches ]), matches;
        };
        __webpack_exports__.a = useMediaQuery;
    }, function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        function toHyphenLower(match) {
            return "-" + match.toLowerCase();
        }
        function hyphenateStyleName(name) {
            if (cache.hasOwnProperty(name)) return cache[name];
            var hName = name.replace(uppercasePattern, toHyphenLower);
            return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
        }
        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
        __webpack_exports__.a = hyphenateStyleName;
    }, function(module, __webpack_exports__, __nested_webpack_require_9551__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __nested_webpack_require_9551__(2), __WEBPACK_IMPORTED_MODULE_1__mediaQuery__ = __nested_webpack_require_9551__(11), negate = function(cond) {
            return "not ".concat(cond);
        }, keyVal = function(k, v) {
            var realKey = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__.a)(k);
            return "number" == typeof v && (v = "".concat(v, "px")), !0 === v ? realKey : !1 === v ? negate(realKey) : "(".concat(realKey, ": ").concat(v, ")");
        }, join = function(conds) {
            return conds.join(" and ");
        }, toQuery = function(obj) {
            var rules = [];
            return Object.keys(__WEBPACK_IMPORTED_MODULE_1__mediaQuery__.a.all).forEach(function(k) {
                var v = obj[k];
                null != v && rules.push(keyVal(k, v));
            }), join(rules);
        };
        __webpack_exports__.a = toQuery;
    }, function(module, exports, __nested_webpack_require_10553__) {
        "use strict";
        module.exports = __nested_webpack_require_10553__(13);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(module, __webpack_exports__, __nested_webpack_require_10844__) {
        "use strict";
        var __WEBPACK_IMPORTED_MODULE_0_react__ = __nested_webpack_require_10844__(1), __WEBPACK_IMPORTED_MODULE_0_react___default = __nested_webpack_require_10844__.n(__WEBPACK_IMPORTED_MODULE_0_react__), Context = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
        __webpack_exports__.a = Context;
    }, function(module, __webpack_exports__, __nested_webpack_require_11228__) {
        "use strict";
        Object.defineProperty(__webpack_exports__, "__esModule", {
            value: !0
        });
        var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __nested_webpack_require_11228__(0), __WEBPACK_IMPORTED_MODULE_1__Component__ = __nested_webpack_require_11228__(17), __WEBPACK_IMPORTED_MODULE_2__toQuery__ = __nested_webpack_require_11228__(3), __WEBPACK_IMPORTED_MODULE_3__Context__ = __nested_webpack_require_11228__(6);
        __nested_webpack_require_11228__.d(__webpack_exports__, "default", function() {
            return __WEBPACK_IMPORTED_MODULE_1__Component__.a;
        }), __nested_webpack_require_11228__.d(__webpack_exports__, "useMediaQuery", function() {
            return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a;
        }), __nested_webpack_require_11228__.d(__webpack_exports__, "toQuery", function() {
            return __WEBPACK_IMPORTED_MODULE_2__toQuery__.a;
        }), __nested_webpack_require_11228__.d(__webpack_exports__, "Context", function() {
            return __WEBPACK_IMPORTED_MODULE_3__Context__.a;
        });
    }, function(module, exports, __nested_webpack_require_12270__) {
        "use strict";
        function Mql(query, values, forceStatic) {
            function addListener(listener) {
                mql && mql.addListener(listener);
            }
            function removeListener(listener) {
                mql && mql.removeListener(listener);
            }
            function update(evt) {
                self.matches = evt.matches, self.media = evt.media;
            }
            function dispose() {
                mql && mql.removeListener(update);
            }
            var self = this;
            if (dynamicMatch && !forceStatic) {
                var mql = dynamicMatch.call(window, query);
                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
            } else this.matches = staticMatch(query, values), this.media = query;
            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
        }
        function matchMedia(query, values, forceStatic) {
            return new Mql(query, values, forceStatic);
        }
        var staticMatch = __nested_webpack_require_12270__(9).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
        module.exports = matchMedia;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function matchQuery(mediaQuery, values) {
            return parseQuery(mediaQuery).some(function(query) {
                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                var expressionsMatch = query.expressions.every(function(expression) {
                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                    if (!value) return !1;
                    switch (feature) {
                      case "orientation":
                      case "scan":
                        return value.toLowerCase() === expValue.toLowerCase();

                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        expValue = toPx(expValue), value = toPx(value);
                        break;

                      case "resolution":
                        expValue = toDpi(expValue), value = toDpi(value);
                        break;

                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case "device-pixel-ratio":
                        expValue = toDecimal(expValue), value = toDecimal(value);
                        break;

                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                    }
                    switch (modifier) {
                      case "min":
                        return value >= expValue;

                      case "max":
                        return value <= expValue;

                      default:
                        return value === expValue;
                    }
                });
                return expressionsMatch && !inverse || !expressionsMatch && inverse;
            });
        }
        function parseQuery(mediaQuery) {
            return mediaQuery.split(",").map(function(query) {
                query = query.trim();
                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                    return {
                        modifier: feature[1],
                        feature: feature[2],
                        value: captures[2]
                    };
                }), parsed;
            });
        }
        function toDecimal(ratio) {
            var numbers, decimal = Number(ratio);
            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
            decimal;
        }
        function toDpi(resolution) {
            var value = parseFloat(resolution);
            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
              case "dpcm":
                return value / 2.54;

              case "dppx":
                return 96 * value;

              default:
                return value;
            }
        }
        function toPx(length) {
            var value = parseFloat(length);
            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
              case "em":
              case "rem":
                return 16 * value;

              case "cm":
                return 96 * value / 2.54;

              case "mm":
                return 96 * value / 2.54 / 10;

              case "in":
                return 96 * value;

              case "pt":
                return 72 * value;

              case "pc":
                return 72 * value / 12;

              default:
                return value;
            }
        }
        exports.match = matchQuery, exports.parse = parseQuery;
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function shallowEqualObjects(objA, objB) {
            if (objA === objB) return !0;
            if (!objA || !objB) return !1;
            var aKeys = Object.keys(objA), bKeys = Object.keys(objB), len = aKeys.length;
            if (bKeys.length !== len) return !1;
            for (var i = 0; i < len; i++) {
                var key = aKeys[i];
                if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return !1;
            }
            return !0;
        }
        module.exports = shallowEqualObjects;
    }, function(module, __webpack_exports__, __nested_webpack_require_18935__) {
        "use strict";
        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                enumerableOnly && (symbols = symbols.filter(function(sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                })), keys.push.apply(keys, symbols);
            }
            return keys;
        }
        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                    _defineProperty(target, key, source[key]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                });
            }
            return target;
        }
        function _defineProperty(obj, key, value) {
            return key in obj ? Object.defineProperty(obj, key, {
                value: value,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : obj[key] = value, obj;
        }
        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __nested_webpack_require_18935__(12), __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __nested_webpack_require_18935__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__), stringOrNumber = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([ __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number ]), matchers = {
            orientation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "portrait", "landscape" ]),
            scan: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf([ "progressive", "interlace" ]),
            aspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            deviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            height: stringOrNumber,
            deviceHeight: stringOrNumber,
            width: stringOrNumber,
            deviceWidth: stringOrNumber,
            color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            colorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            monochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            resolution: stringOrNumber
        }, features = _objectSpread({
            minAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            maxDeviceAspectRatio: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            minHeight: stringOrNumber,
            maxHeight: stringOrNumber,
            minDeviceHeight: stringOrNumber,
            maxDeviceHeight: stringOrNumber,
            minWidth: stringOrNumber,
            maxWidth: stringOrNumber,
            minDeviceWidth: stringOrNumber,
            maxDeviceWidth: stringOrNumber,
            minColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxColorIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            maxMonochrome: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            minResolution: stringOrNumber,
            maxResolution: stringOrNumber
        }, matchers), types = {
            all: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            grid: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            aural: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            braille: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            handheld: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            print: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            projection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            screen: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tty: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            tv: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
            embossed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
        }, all = _objectSpread(_objectSpread({}, types), features);
        matchers.type = Object.keys(types), __webpack_exports__.a = {
            all: all,
            types: types,
            matchers: matchers,
            features: features
        };
    }, function(module, exports, __nested_webpack_require_24129__) {
        var ReactIs = __nested_webpack_require_24129__(4);
        module.exports = __nested_webpack_require_24129__(14)(ReactIs.isElement, !0);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        !function() {
            function isValidElementType(type) {
                return "string" == typeof type || "function" == typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" == typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
            }
            function typeOf(object) {
                if ("object" == typeof object && null !== object) {
                    var $$typeof = object.$$typeof;
                    switch ($$typeof) {
                      case REACT_ELEMENT_TYPE:
                        var type = object.type;
                        switch (type) {
                          case REACT_ASYNC_MODE_TYPE:
                          case REACT_CONCURRENT_MODE_TYPE:
                          case REACT_FRAGMENT_TYPE:
                          case REACT_PROFILER_TYPE:
                          case REACT_STRICT_MODE_TYPE:
                          case REACT_SUSPENSE_TYPE:
                            return type;

                          default:
                            var $$typeofType = type && type.$$typeof;
                            switch ($$typeofType) {
                              case REACT_CONTEXT_TYPE:
                              case REACT_FORWARD_REF_TYPE:
                              case REACT_LAZY_TYPE:
                              case REACT_MEMO_TYPE:
                              case REACT_PROVIDER_TYPE:
                                return $$typeofType;

                              default:
                                return $$typeof;
                            }
                        }

                      case REACT_PORTAL_TYPE:
                        return $$typeof;
                    }
                }
            }
            function isAsyncMode(object) {
                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, 
                console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), 
                isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            var hasSymbol = "function" == typeof Symbol && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121, REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117, REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118, REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119, AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
            exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, 
            exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, 
            exports.Fragment = Fragment, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, 
            exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, 
            exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, 
            exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, 
            exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, 
            exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, 
            exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense, exports.isValidElementType = isValidElementType, 
            exports.typeOf = typeOf;
        }();
    }, function(module, exports, __nested_webpack_require_31508__) {
        "use strict";
        function emptyFunctionThatReturnsNull() {
            return null;
        }
        var ReactIs = __nested_webpack_require_31508__(4), assign = __nested_webpack_require_31508__(15), ReactPropTypesSecret = __nested_webpack_require_31508__(5), checkPropTypes = __nested_webpack_require_31508__(16), has = Function.call.bind(Object.prototype.hasOwnProperty), printWarning = function() {};
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, module.exports = function(isValidElement, throwOnDirectAccess) {
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if ("function" == typeof iteratorFn) return iteratorFn;
            }
            function is(x, y) {
                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
            }
            function PropTypeError(message) {
                this.message = message, this.stack = "";
            }
            function createChainableTypeChecker(validate) {
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
                    secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            throw err.name = "Invariant Violation", err;
                        }
                        if ("undefined" != typeof console) {
                            var cacheKey = componentName + ":" + propName;
                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                        }
                    }
                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                }
                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
            }
            function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                    }
                    for (var i = 0; i < propValue.length; i++) {
                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
                    var valuesString = JSON.stringify(expectedValues, function(key, value) {
                        return "symbol" === getPreciseType(value) ? String(value) : value;
                    });
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` supplied to `" + componentName + "`, expected one of " + valuesString + ".");
                }
                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), 
                emptyFunctionThatReturnsNull);
            }
            function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                    for (var key in propValue) if (has(propValue, key)) {
                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                    }
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                }
                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
                emptyFunctionThatReturnsNull;
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
                    emptyFunctionThatReturnsNull;
                }
                return createChainableTypeChecker(validate);
            }
            function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    for (var key in shapeTypes) {
                        var checker = shapeTypes[key];
                        if (checker) {
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for (var key in allKeys) {
                        var checker = shapeTypes[key];
                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
                switch (typeof propValue) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;

                  case "boolean":
                    return !propValue;

                  case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (null === propValue || isValidElement(propValue)) return !0;
                    var iteratorFn = getIteratorFn(propValue);
                    if (!iteratorFn) return !1;
                    var step, iterator = iteratorFn.call(propValue);
                    if (iteratorFn !== propValue.entries) {
                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
                    } else for (;!(step = iterator.next()).done; ) {
                        var entry = step.value;
                        if (entry && !isNode(entry[1])) return !1;
                    }
                    return !0;

                  default:
                    return !1;
                }
            }
            function isSymbol(propType, propValue) {
                return "symbol" === propType || !!propValue && ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
            }
            function getPropType(propValue) {
                var propType = typeof propValue;
                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
            }
            function getPreciseType(propValue) {
                if (void 0 === propValue || null === propValue) return "" + propValue;
                var propType = getPropType(propValue);
                if ("object" === propType) {
                    if (propValue instanceof Date) return "date";
                    if (propValue instanceof RegExp) return "regexp";
                }
                return propType;
            }
            function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch (type) {
                  case "array":
                  case "object":
                    return "an " + type;

                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + type;

                  default:
                    return type;
                }
            }
            function getClassName(propValue) {
                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
            }
            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: function() {
                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }(),
                arrayOf: createArrayOfTypeChecker,
                element: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                elementType: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!ReactIs.isValidElementType(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement type.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                instanceOf: createInstanceTypeChecker,
                node: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                    }
                    return createChainableTypeChecker(validate);
                }(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
            ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache, ReactPropTypes.PropTypes = ReactPropTypes, 
            ReactPropTypes;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function toObject(val) {
            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module.exports = function() {
            try {
                if (!Object.assign) return !1;
                var test1 = new String("abc");
                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                }).join("")) return !1;
                var test3 = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
            } catch (err) {
                return !1;
            }
        }() ? Object.assign : function(target, source) {
            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
                from = Object(arguments[s]);
                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                }
            }
            return to;
        };
    }, function(module, exports, __nested_webpack_require_50834__) {
        "use strict";
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            for (var typeSpecName in typeSpecs) if (has(typeSpecs, typeSpecName)) {
                var error;
                try {
                    if ("function" != typeof typeSpecs[typeSpecName]) {
                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                        throw err.name = "Invariant Violation", err;
                    }
                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                    error = ex;
                }
                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
                error instanceof Error && !(error.message in loggedTypeFailures)) {
                    loggedTypeFailures[error.message] = !0;
                    var stack = getStack ? getStack() : "";
                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                }
            }
        }
        var printWarning = function() {}, ReactPropTypesSecret = __nested_webpack_require_50834__(5), loggedTypeFailures = {}, has = Function.call.bind(Object.prototype.hasOwnProperty);
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, checkPropTypes.resetWarningCache = function() {
            loggedTypeFailures = {};
        }, module.exports = checkPropTypes;
    }, function(module, __webpack_exports__, __nested_webpack_require_53126__) {
        "use strict";
        function _objectWithoutProperties(source, excluded) {
            if (null == source) return {};
            var key, i, target = _objectWithoutPropertiesLoose(source, excluded);
            if (Object.getOwnPropertySymbols) {
                var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
                for (i = 0; i < sourceSymbolKeys.length; i++) key = sourceSymbolKeys[i], excluded.indexOf(key) >= 0 || Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }
        function _objectWithoutPropertiesLoose(source, excluded) {
            if (null == source) return {};
            var key, i, target = {}, sourceKeys = Object.keys(source);
            for (i = 0; i < sourceKeys.length; i++) key = sourceKeys[i], excluded.indexOf(key) >= 0 || (target[key] = source[key]);
            return target;
        }
        function MediaQuery(_ref) {
            var children = _ref.children, device = _ref.device, onChange = _ref.onChange, settings = _objectWithoutProperties(_ref, [ "children", "device", "onChange" ]), matches = Object(__WEBPACK_IMPORTED_MODULE_0__useMediaQuery__.a)(settings, device, onChange);
            return "function" == typeof children ? children(matches) : matches ? children : null;
        }
        __webpack_exports__.a = MediaQuery;
        var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __nested_webpack_require_53126__(0);
    } ]);
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 45989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28673);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Transition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96630);
/* harmony import */ var _TransitionGroupContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(oldChildren) && react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERED */ .cn, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(_Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERED */ .cn, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        in: true
      }));
    })
  }), react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: _Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERED */ .cn,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === _Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0 && props.mode === modes.in) {
      return {
        status: _Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: _Transition__WEBPACK_IMPORTED_MODULE_2__/* .EXITING */ .Ix
      };
    }

    return {
      current: react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case _Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERING */ .d0:
        component = enterRenders[mode](data);
        break;

      case _Transition__WEBPACK_IMPORTED_MODULE_2__/* .EXITING */ .Ix:
        component = leaveRenders[mode](data);
        break;

      case _Transition__WEBPACK_IMPORTED_MODULE_2__/* .ENTERED */ .cn:
        component = current;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TransitionGroupContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Provider */ .Z.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

SwitchTransition.propTypes =  false ? 0 : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ __webpack_exports__["Z"] = (SwitchTransition);

/***/ }),

/***/ 96630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ix": function() { return /* binding */ EXITING; },
/* harmony export */   "cn": function() { return /* binding */ ENTERED; },
/* harmony export */   "d0": function() { return /* binding */ ENTERING; }
/* harmony export */ });
/* unused harmony exports UNMOUNTED, EXITED */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43992);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28673);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6035);
/* harmony import */ var _TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(220);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom__WEBPACK_IMPORTED_MODULE_2__.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || _config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].disabled */ .Z.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : react_dom__WEBPACK_IMPORTED_MODULE_2__.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || _config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].disabled */ .Z.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom__WEBPACK_IMPORTED_MODULE_2__.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      react__WEBPACK_IMPORTED_MODULE_1__.createElement(_TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Provider */ .Z.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children), childProps))
    );
  };

  return Transition;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

Transition.contextType = _TransitionGroupContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
Transition.propTypes =  false ? 0 : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["ZP"] = (Transition);

/***/ }),

/***/ 220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));

/***/ }),

/***/ 6035:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
  disabled: false
});

/***/ }),

/***/ 78472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CSSTransition": function() { return /* reexport */ esm_CSSTransition; },
  "ReplaceTransition": function() { return /* reexport */ esm_ReplaceTransition; },
  "SwitchTransition": function() { return /* reexport */ SwitchTransition/* default */.Z; },
  "Transition": function() { return /* reexport */ Transition/* default */.ZP; },
  "TransitionGroup": function() { return /* reexport */ esm_TransitionGroup; },
  "config": function() { return /* reexport */ config/* default */.Z; }
});

;// CONCATENATED MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(43992);
// EXTERNAL MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js + 1 modules
var inheritsLoose = __webpack_require__(28673);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/hasClass.js
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/addClass.js

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass_addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}
;// CONCATENATED MODULE: ./node_modules/dom-helpers/esm/removeClass.js
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass_removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js
var Transition = __webpack_require__(96630);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass_addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass_removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["classNames"]);

    return /*#__PURE__*/react.createElement(Transition/* default */.ZP, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(react.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_CSSTransition = (CSSTransition);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(220);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/utils/ChildMapping.js

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0,react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0,react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0,react.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0,react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0,react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/react.createElement(TransitionGroupContext/* default.Provider */.Z.Provider, {
      value: contextValue
    }, /*#__PURE__*/react.createElement(Component, props, children));
  };

  return TransitionGroup;
}(react.Component);

TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/ReplaceTransition.js






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = react.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : react_dom.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props, ["children", "in"]);

    var _React$Children$toArr = react.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/react.createElement(esm_TransitionGroup, props, inProp ? react.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : react.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(react.Component);

ReplaceTransition.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_ReplaceTransition = (ReplaceTransition);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/SwitchTransition.js
var SwitchTransition = __webpack_require__(45989);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/config.js
var config = __webpack_require__(6035);
;// CONCATENATED MODULE: ./node_modules/react-transition-group/esm/index.js







/***/ }),

/***/ 43412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UID": function() { return /* reexport */ UID; },
  "UIDConsumer": function() { return /* reexport */ UIDConsumer; },
  "UIDFork": function() { return /* reexport */ UIDFork; },
  "UIDReset": function() { return /* reexport */ UIDReset; },
  "generateUID": function() { return /* reexport */ generateUID; },
  "uid": function() { return /* reexport */ uid; },
  "useUID": function() { return /* reexport */ useUID; },
  "useUIDSeed": function() { return /* reexport */ useUIDSeed; }
});

;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/uid.js
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */
var generateUID = function () {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */
    var uid = function (item, index) {
        if (typeof item === 'number' ||
            typeof item === 'string') {
            return index ? "idx-" + index : "val-" + item;
        }
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
/**
 * @name uid
 * returns an UID associated with {item}
 * @param {Object} item - object to generate UID for
 * @param {Number} index, a fallback index
 * @example
 * uid(object) == 1;
 * uid(object) == 1;
 * uid(anotherObject) == 2;
 * uid("not object", 42) == 42
 *
 * @see {@link useUID}
 */
var uid = generateUID();

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/context.js


var createSource = function (prefix) {
    if (prefix === void 0) { prefix = ''; }
    return ({
        value: 1,
        prefix: prefix,
        uid: generateUID()
    });
};
var counter = createSource();
var source = react.createContext(createSource());
var getId = function (source) { return source.value++; };
var getPrefix = function (source) { return source ? source.prefix : ''; };

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/UIDComponent.js



// --------------------------------------------
var prefixId = function (id, prefix, name) {
    var uid = (prefix + id);
    return String(name ? name(uid) : uid);
};
/**
 * @deprecated
 * UID in form of renderProps (not SSR friendly)
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UID>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UID>
 *
 * // get uid to generate uid for a keys in a list
 * <UID>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UID>
 */
var UID = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(UID, _super);
    function UID() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            quartz: _this.props.idSource || counter,
            prefix: getPrefix(_this.props.idSource),
            id: getId(_this.props.idSource || counter)
        };
        _this.uid = function (item) { return prefixId(_this.state.id + '-' + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name); };
        return _this;
    }
    UID.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name;
        var _b = this.state, id = _b.id, prefix = _b.prefix;
        return children(prefixId(id, prefix, name), this.uid);
    };
    return UID;
}(react.Component));


;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/Control.js



/**
 * UID isolation component, required for SSR and testing.
 * Wrap your application with it to guarantee UID consistency between SSR and CSR.
 * @param {String} [prefix] - prefix for all generated ids
 * @example
 * <UIDReset>
 *    <App />
 * </UIDReset/>
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 */
var UIDReset = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (react.createElement(source.Provider, { value: createSource(prefix) }, children));
};
/**
 * Creates a sub-ids for nested components, isolating from inside a branch.
 * Useful for self-contained elements or code splitting
 * @see https://github.com/thearnica/react-uid#code-splitting
 */
var UIDFork = function (_a) {
    var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? '' : _b;
    return (react.createElement(UIDConsumer, null, function (id) { return (react.createElement(source.Provider, { value: createSource(id + '-' + prefix) }, children)); }));
};
/**
 * UID in form of renderProps. Supports nesting and SSR. Prefer {@link useUID} hook version if possible.
 * @see https://github.com/thearnica/react-uid#server-side-friendly-uid
 * @see https://github.com/thearnica/react-uid#react-components
 * @example
 * // get UID to connect label to input
 * <UIDConsumer>
 *   {(id)} => <label htmlFor={id}><input id={id}/>}
 * </UIDConsumer>
 *
 * // get uid to generate uid for a keys in a list
 * <UIDConsumer>
 *   {(, uid)} => items.map(item => <li key={uid(item) />)}
 * </UIDConsumer>
 *
 * @see {@link useUID} - a hook version of this component
 * @see {@link UID} - not SSR compatible version
 */
var UIDConsumer = function (_a) {
    var name = _a.name, children = _a.children;
    return (react.createElement(source.Consumer, null, function (value) { return (react.createElement(UID, { name: name, idSource: value, children: children })); }));
};

;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/hooks.js


var hooks_generateUID = function (context) {
    var quartz = context || counter;
    var prefix = getPrefix(quartz);
    var id = getId(quartz);
    var uid = prefix + id;
    var gen = function (item) { return uid + quartz.uid(item); };
    return { uid: uid, gen: gen };
};
var useUIDState = function () {
    if (false) {}
    // @ts-ignore
    return react.useState(hooks_generateUID(react.useContext(source)));
};
/**
 * returns and unique id. SSR friendly
 * returns {String}
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const id = useUID();
 * id == 1; // for example
 */
var useUID = function () {
    var uid = useUIDState()[0].uid;
    return uid;
};
/**
 * returns an uid generator
 * @see {@link UIDConsumer}
 * @see https://github.com/thearnica/react-uid#hooks-168
 * @example
 * const uid = useUIDSeed();
 * return (
 *  <>
 *    <label for={seed('email')}>Email: </label>
 *    <input id={seed('email')} name="email" />
 *    {data.map(item => <div key={seed(item)}>...</div>
 *  </>
 * )
 */
var useUIDSeed = function () {
    var gen = useUIDState()[0].gen;
    return gen;
};

;// CONCATENATED MODULE: ./node_modules/react-uid/dist/es2015/index.js







/***/ }),

/***/ 56445:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var react_1 = __webpack_require__(67294);
var isBrowser = typeof window !== "undefined";
function getScrollPosition() {
    return isBrowser ? { x: window.pageXOffset, y: window.pageYOffset } : { x: 0, y: 0 };
}
function useScrollPosition() {
    var _a = react_1.useState(getScrollPosition()), position = _a[0], setScrollPosition = _a[1];
    react_1.useEffect(function () {
        var requestRunning = null;
        function handleScroll() {
            if (isBrowser && requestRunning === null) {
                requestRunning = window.requestAnimationFrame(function () {
                    setScrollPosition(getScrollPosition());
                    requestRunning = null;
                });
            }
        }
        if (isBrowser) {
            window.addEventListener('scroll', handleScroll);
            return function () { return window.removeEventListener('scroll', handleScroll); };
        }
    }, []);
    return position;
}
__webpack_unused_export__ = useScrollPosition;
function useScrollXPosition() {
    var x = useScrollPosition().x;
    return x;
}
__webpack_unused_export__ = useScrollXPosition;
function useScrollYPosition() {
    var y = useScrollPosition().y;
    return y;
}
exports.ey = useScrollYPosition;


/***/ }),

/***/ 47418:
/***/ (function(module) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ 98123:
/***/ (function(module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: default

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/ponyfill.js
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {

			// This just needs to be something that won't trample other user's Symbol.for use
			// It also will guide people to the source of their issues, if this is problematic.
			// META: It's a resource locator!
			result = Symbol.for('https://github.com/benlesh/symbol-observable');
			try {
				Symbol.observable = result;
			} catch (err) {
				// Do nothing. In some environments, users have frozen `Symbol` for security reasons,
				// if it is frozen assigning to it will throw. In this case, we don't care, because
				// they will need to use the returned value from the ponyfill.
			}
		}
	} else {
		result = '@@observable';
	}

	return result;
};

;// CONCATENATED MODULE: ./node_modules/symbol-observable/es/index.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof __webpack_require__.g !== 'undefined') {
  root = __webpack_require__.g;
} else if (true) {
  root = module;
} else {}

var result = symbolObservablePonyfill(root);
/* harmony default export */ var es = ((/* unused pure expression or super */ null && (result)));


/***/ }),

/***/ 10212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ej": function() { return /* binding */ InvariantError; },
  "kG": function() { return /* binding */ invariant; },
  "U6": function() { return /* binding */ setVerbosity; }
});

// UNUSED EXPORTS: default, process, processStub

;// CONCATENATED MODULE: ./node_modules/ts-invariant/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

;// CONCATENATED MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
/* provided dependency */ var process = __webpack_require__(34155);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    __extends(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(method) {
    return function () {
        if (verbosityLevels.indexOf(method) >= verbosityLevel) {
            return console[method].apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also export processStub, so you can import { invariant, processStub } from
// "ts-invariant" and assign processStub to a local variable named process.
var processStub = (typeof process === "object" &&
    typeof process.env === "object") ? process : { env: {} };
var invariant$1 = (/* unused pure expression or super */ null && (invariant));

/* harmony default export */ var invariant_esm = ((/* unused pure expression or super */ null && (invariant$1)));

//# sourceMappingURL=invariant.esm.js.map


/***/ }),

/***/ 23451:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.35",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=350;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HUAWEI="Huawei",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",OPERA="Opera",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",VIERA="Viera",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,/(ba?idubrowser)[\/ ]?([\w\.]+)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,/(heytap|ovi)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i],[VERSION,[NAME,"WeChat(Win) Desktop"]],[/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI "+BROWSER]],[/fxios\/([-\w\.]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihu|(qi?ho?o?|360)browser/i],[[NAME,"360 "+BROWSER]],[/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 "+BROWSER],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i],[NAME,VERSION],[/(metasr)[\/ ]?([\w\.]+)/i,/(lbbrowser)/i,/\[(linkedin)app\]/i],[NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(chromium|instagram)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/(links) \(([\w\.]+)/i,/panasonic;(viera)/i],[NAME,VERSION],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?8e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/windows (ce|mobile); ppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]([-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei|honor)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/\b(poco[\w ]+)(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,"OPPO"],[TYPE,MOBILE]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[12]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+)/i,/lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+)/i,/nokia[-_ ]?([-\w\.]*)/i],[[MODEL,/_/g," "],[VENDOR,"Nokia"],[TYPE,MOBILE]],[/(pixel c)\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,/(hp) ([\w ]+\w)/i,/(asus)-?(\w+)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w]+)/i,/(jolla)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/(shield[\w ]+) b/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mitv-\w{5}) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield) bui/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation [345portablevi]+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/((pebble))app/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/(quest( 2| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/(android[-\w\. ]{0,9});.+buil/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows) nt 6\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,/(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,strMapper,windowsVersionMap]],[/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,/ios;fbsv\/([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,/(blackberry)\w*\/([\w\.]*)/i,/(tizen|kaios)[\/ ]([\w\.]+)/i,/\((series40);/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux) ?([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if("object"!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__.amdO){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),

/***/ 74932:
/***/ (function(module) {

module.exports = "/_next/static/images/PrezzeeBusinessLogo-2b19b1fe88797514e88e26c1678862f2.svg";

/***/ }),

/***/ 34076:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMxIiBoZWlnaHQ9IjM3IiB2aWV3Qm94PSIwIDAgMTMxIDM3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyNy4wMSA2Ljk3Nzk3QzEyNC42NjkgMTEuNTI3OSAxMjIuNTI3IDE2LjU1NjkgMTE3LjcwOSAyMC4wNjI3QzEwOS44NTMgMjUuNzc4MyA5OS45NjA4IDIyLjE1IDkyLjI2MzcgMTguNjgxMUM4MC45MzQgMTMuNTczMiA3MC44NDMxIDYuNDk2NDEgNTcuNDYyNSA0LjQzMjIyQzM0LjA2MDcgMC44MjI1NDEgOS42NzI4MyAxMi42NTY4IDQuODYxOSAzMC4zMzk3QzQuMTUzNzIgMjguMzI4NSAzLjY0MjkgMjYuMjgyMyAzLjA1OTA5IDI0LjE5NjhDMi44Mzk4OSAyMy40MTI1IDEuMjY3MjIgMjMuNzEzMiAxLjI2NDM0IDI0LjQ2MDlDMS4yNTA3MiAyOC4wOTY2IDIuNTg1OTggMzEuNzQ3NyAzLjg3NzE3IDM1LjE5NDdDNC4xNTk1OSAzNS45NDk5IDUuNjk2NDcgMzYuMjYyMSA2LjM4MzYzIDM1LjU3NjdDOS43MDM1MyAzMi4yNjQxIDEzLjQ5NjMgMjkuMjE1MyAxNi43OTY1IDI1LjkxMzdDMTcuOTY5OSAyNC43Mzg5IDE2LjA4ODggMjMuNDkxNCAxNC42MzYzIDI0LjQzNjJDMTEuNTg1IDI2LjQyMTQgOC44NzkwNSAyOC45NzQxIDYuNDc0MDggMzEuNTU0OEMxMC41MTQ2IDIwLjQyNDcgMjAuNjI4NCAxMC45NTY5IDM1LjgwNSA3LjQ5MTI5QzUyLjI4NjkgMy43Mjc5NSA2Ni4zMzE4IDguNDE1NDggNzkuNTI1MyAxNS4xOTdDODguMzMwMSAxOS43MjE2IDEwMC4zNDUgMjcuNTAwNSAxMTIuMDg2IDI1LjIxODlDMTIyLjExMiAyMy4yNzE2IDEyNy4zMTEgMTQuNDkzMiAxMjkuNTc1IDcuNjY2NTdDMTI5Ljk0NCA2LjU0ODg0IDEyNy41OTMgNS44NDU2NyAxMjcuMDEgNi45Nzc5N1oiIGZpbGw9IiMyRjMyMzEiIGZpbGwtb3BhY2l0eT0iMC4yNSIvPgo8L3N2Zz4K"

/***/ }),

/***/ 49031:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 56393:
/***/ (function(module) {

module.exports = "/_next/static/images/prezzee_logo-ceb34219a54086df47fcf0165a24caa3.svg";

/***/ }),

/***/ 84564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var required = __webpack_require__(47418)
  , qs = __webpack_require__(57129)
  , controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/
  , CRHTLF = /[\n\r\t]/g
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//
  , port = /:\d+$/
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i
  , windowsDriveLetter = /^[a-zA-Z]:/;

/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */
function trimLeft(str) {
  return (str ? str : '').toString().replace(controlOrWhitespace, '');
}

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address, url) {     // Sanitize what is left of the address
    return isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d*)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof __webpack_require__.g !== 'undefined') globalVar = __webpack_require__.g;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */
function isSpecial(scheme) {
  return (
    scheme === 'file:' ||
    scheme === 'ftp:' ||
    scheme === 'http:' ||
    scheme === 'https:' ||
    scheme === 'ws:' ||
    scheme === 'wss:'
  );
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address, location) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, '');
  location = location || {};

  var match = protocolre.exec(address);
  var protocol = match[1] ? match[1].toLowerCase() : '';
  var forwardSlashes = !!match[2];
  var otherSlashes = !!match[3];
  var slashesCount = 0;
  var rest;

  if (forwardSlashes) {
    if (otherSlashes) {
      rest = match[2] + match[3] + match[4];
      slashesCount = match[2].length + match[3].length;
    } else {
      rest = match[2] + match[4];
      slashesCount = match[2].length;
    }
  } else {
    if (otherSlashes) {
      rest = match[3] + match[4];
      slashesCount = match[3].length;
    } else {
      rest = match[4]
    }
  }

  if (protocol === 'file:') {
    if (slashesCount >= 2) {
      rest = rest.slice(2);
    }
  } else if (isSpecial(protocol)) {
    rest = match[4];
  } else if (protocol) {
    if (forwardSlashes) {
      rest = rest.slice(2);
    }
  } else if (slashesCount >= 2 && isSpecial(location.protocol)) {
    rest = match[4];
  }

  return {
    protocol: protocol,
    slashes: forwardSlashes || isSpecial(protocol),
    slashesCount: slashesCount,
    rest: rest
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  if (relative === '') return base;

  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  address = trimLeft(address);
  address = address.replace(CRHTLF, '');

  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '', location);
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (
    extracted.protocol === 'file:' && (
      extracted.slashesCount !== 2 || windowsDriveLetter.test(address)) ||
    (!extracted.slashes &&
      (extracted.protocol ||
        extracted.slashesCount < 2 ||
        !isSpecial(url.protocol)))
  ) {
    instructions[3] = [/(.*)/, 'pathname'];
  }

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address, url);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      index = parse === '@'
        ? address.lastIndexOf(parse)
        : address.indexOf(parse);

      if (~index) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // Default to a / for pathname if none exists. This normalizes the URL
  // to always have a /
  //
  if (url.pathname.charAt(0) !== '/' && isSpecial(url.protocol)) {
    url.pathname = '/' + url.pathname;
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';

  if (url.auth) {
    index = url.auth.indexOf(':');

    if (~index) {
      url.username = url.auth.slice(0, index);
      url.username = encodeURIComponent(decodeURIComponent(url.username));

      url.password = url.auth.slice(index + 1);
      url.password = encodeURIComponent(decodeURIComponent(url.password))
    } else {
      url.username = encodeURIComponent(decodeURIComponent(url.auth));
    }

    url.auth = url.password ? url.username +':'+ url.password : url.username;
  }

  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (port.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    case 'username':
    case 'password':
      url[part] = encodeURIComponent(value);
      break;

    case 'auth':
      var index = value.indexOf(':');

      if (~index) {
        url.username = value.slice(0, index);
        url.username = encodeURIComponent(decodeURIComponent(url.username));

        url.password = value.slice(index + 1);
        url.password = encodeURIComponent(decodeURIComponent(url.password));
      } else {
        url.username = encodeURIComponent(decodeURIComponent(value));
      }
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.auth = url.password ? url.username +':'+ url.password : url.username;

  url.origin = url.protocol !== 'file:' && isSpecial(url.protocol) && url.host
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , host = url.host
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result =
    protocol +
    ((url.protocol && url.slashes) || isSpecial(url.protocol) ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  } else if (url.password) {
    result += ':'+ url.password;
    result += '@';
  } else if (
    url.protocol !== 'file:' &&
    isSpecial(url.protocol) &&
    !host &&
    url.pathname !== '/'
  ) {
    //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
  }

  //
  // Trailing colon is removed from `url.host` when it is parsed. If it still
  // ends with a colon, then add back the trailing colon that was removed. This
  // prevents an invalid URL from being transformed into a valid one.
  //
  if (host[host.length - 1] === ':' || (port.test(url.hostname) && !url.port)) {
    host += ':';
  }

  result += host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;

module.exports = Url;


/***/ }),

/***/ 99495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ useMergeRefs; }
});

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = (0,react.useState)(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue || null, function (newValue) { return refs.forEach(function (ref) { return assignRef(ref, newValue); }); });
}


/***/ }),

/***/ 87122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ createSidecarMedium; },
/* harmony export */   "s": function() { return /* binding */ createMedium; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({ async: true, ssr: false }, options);
    return medium;
}


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 42473:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 49329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(60516).Observable;


/***/ }),

/***/ 60516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// this is needed to ensure webpack does not attempt to tree shake unused modules. Since these should always come from host
__webpack_require__(67294);
__webpack_require__(73935);
__webpack_require__(41664);
__webpack_require__(11163);
__webpack_require__(9008);
__webpack_require__(4298);
__webpack_require__(5152);
__webpack_require__(89967);
__webpack_require__(60357);
if (false) {}
module.exports = {};
//# sourceMappingURL=include-defaults.js.map

/***/ }),

/***/ 36559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


const format = __webpack_require__(85346)

module.exports = pino

const _console = pfGlobalThisOrFallback().console || {}
const stdSerializers = {
  mapHttpRequest: mock,
  mapHttpResponse: mock,
  wrapRequestSerializer: passthrough,
  wrapResponseSerializer: passthrough,
  wrapErrorSerializer: passthrough,
  req: mock,
  res: mock,
  err: asErrValue
}

function shouldSerialize (serialize, serializers) {
  if (Array.isArray(serialize)) {
    const hasToFilter = serialize.filter(function (k) {
      return k !== '!stdSerializers.err'
    })
    return hasToFilter
  } else if (serialize === true) {
    return Object.keys(serializers)
  }

  return false
}

function pino (opts) {
  opts = opts || {}
  opts.browser = opts.browser || {}

  const transmit = opts.browser.transmit
  if (transmit && typeof transmit.send !== 'function') { throw Error('pino: transmit option must have a send function') }

  const proto = opts.browser.write || _console
  if (opts.browser.write) opts.browser.asObject = true
  const serializers = opts.serializers || {}
  const serialize = shouldSerialize(opts.browser.serialize, serializers)
  let stdErrSerialize = opts.browser.serialize

  if (
    Array.isArray(opts.browser.serialize) &&
    opts.browser.serialize.indexOf('!stdSerializers.err') > -1
  ) stdErrSerialize = false

  const levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace']

  if (typeof proto === 'function') {
    proto.error = proto.fatal = proto.warn =
    proto.info = proto.debug = proto.trace = proto
  }
  if (opts.enabled === false) opts.level = 'silent'
  const level = opts.level || 'info'
  const logger = Object.create(proto)
  if (!logger.log) logger.log = noop

  Object.defineProperty(logger, 'levelVal', {
    get: getLevelVal
  })
  Object.defineProperty(logger, 'level', {
    get: getLevel,
    set: setLevel
  })

  const setOpts = {
    transmit,
    serialize,
    asObject: opts.browser.asObject,
    levels,
    timestamp: getTimeFunction(opts)
  }
  logger.levels = pino.levels
  logger.level = level

  logger.setMaxListeners = logger.getMaxListeners =
  logger.emit = logger.addListener = logger.on =
  logger.prependListener = logger.once =
  logger.prependOnceListener = logger.removeListener =
  logger.removeAllListeners = logger.listeners =
  logger.listenerCount = logger.eventNames =
  logger.write = logger.flush = noop
  logger.serializers = serializers
  logger._serialize = serialize
  logger._stdErrSerialize = stdErrSerialize
  logger.child = child

  if (transmit) logger._logEvent = createLogEventShape()

  function getLevelVal () {
    return this.level === 'silent'
      ? Infinity
      : this.levels.values[this.level]
  }

  function getLevel () {
    return this._level
  }
  function setLevel (level) {
    if (level !== 'silent' && !this.levels.values[level]) {
      throw Error('unknown level ' + level)
    }
    this._level = level

    set(setOpts, logger, 'error', 'log') // <-- must stay first
    set(setOpts, logger, 'fatal', 'error')
    set(setOpts, logger, 'warn', 'error')
    set(setOpts, logger, 'info', 'log')
    set(setOpts, logger, 'debug', 'log')
    set(setOpts, logger, 'trace', 'log')
  }

  function child (bindings, childOptions) {
    if (!bindings) {
      throw new Error('missing bindings for child Pino')
    }
    childOptions = childOptions || {}
    if (serialize && bindings.serializers) {
      childOptions.serializers = bindings.serializers
    }
    const childOptionsSerializers = childOptions.serializers
    if (serialize && childOptionsSerializers) {
      var childSerializers = Object.assign({}, serializers, childOptionsSerializers)
      var childSerialize = opts.browser.serialize === true
        ? Object.keys(childSerializers)
        : serialize
      delete bindings.serializers
      applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize)
    }
    function Child (parent) {
      this._childLevel = (parent._childLevel | 0) + 1
      this.error = bind(parent, bindings, 'error')
      this.fatal = bind(parent, bindings, 'fatal')
      this.warn = bind(parent, bindings, 'warn')
      this.info = bind(parent, bindings, 'info')
      this.debug = bind(parent, bindings, 'debug')
      this.trace = bind(parent, bindings, 'trace')
      if (childSerializers) {
        this.serializers = childSerializers
        this._serialize = childSerialize
      }
      if (transmit) {
        this._logEvent = createLogEventShape(
          [].concat(parent._logEvent.bindings, bindings)
        )
      }
    }
    Child.prototype = this
    return new Child(this)
  }
  return logger
}

pino.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: 'trace',
    20: 'debug',
    30: 'info',
    40: 'warn',
    50: 'error',
    60: 'fatal'
  }
}

pino.stdSerializers = stdSerializers
pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime })

function set (opts, logger, level, fallback) {
  const proto = Object.getPrototypeOf(logger)
  logger[level] = logger.levelVal > logger.levels.values[level]
    ? noop
    : (proto[level] ? proto[level] : (_console[level] || _console[fallback] || noop))

  wrap(opts, logger, level)
}

function wrap (opts, logger, level) {
  if (!opts.transmit && logger[level] === noop) return

  logger[level] = (function (write) {
    return function LOG () {
      const ts = opts.timestamp()
      const args = new Array(arguments.length)
      const proto = (Object.getPrototypeOf && Object.getPrototypeOf(this) === _console) ? _console : this
      for (var i = 0; i < args.length; i++) args[i] = arguments[i]

      if (opts.serialize && !opts.asObject) {
        applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize)
      }
      if (opts.asObject) write.call(proto, asObject(this, level, args, ts))
      else write.apply(proto, args)

      if (opts.transmit) {
        const transmitLevel = opts.transmit.level || logger.level
        const transmitValue = pino.levels.values[transmitLevel]
        const methodValue = pino.levels.values[level]
        if (methodValue < transmitValue) return
        transmit(this, {
          ts,
          methodLevel: level,
          methodValue,
          transmitLevel,
          transmitValue: pino.levels.values[opts.transmit.level || logger.level],
          send: opts.transmit.send,
          val: logger.levelVal
        }, args)
      }
    }
  })(logger[level])
}

function asObject (logger, level, args, ts) {
  if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize)
  const argsCloned = args.slice()
  let msg = argsCloned[0]
  const o = {}
  if (ts) {
    o.time = ts
  }
  o.level = pino.levels.values[level]
  let lvl = (logger._childLevel | 0) + 1
  if (lvl < 1) lvl = 1
  // deliberate, catching objects, arrays
  if (msg !== null && typeof msg === 'object') {
    while (lvl-- && typeof argsCloned[0] === 'object') {
      Object.assign(o, argsCloned.shift())
    }
    msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined
  } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned)
  if (msg !== undefined) o.msg = msg
  return o
}

function applySerializers (args, serialize, serializers, stdErrSerialize) {
  for (const i in args) {
    if (stdErrSerialize && args[i] instanceof Error) {
      args[i] = pino.stdSerializers.err(args[i])
    } else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
      for (const k in args[i]) {
        if (serialize && serialize.indexOf(k) > -1 && k in serializers) {
          args[i][k] = serializers[k](args[i][k])
        }
      }
    }
  }
}

function bind (parent, bindings, level) {
  return function () {
    const args = new Array(1 + arguments.length)
    args[0] = bindings
    for (var i = 1; i < args.length; i++) {
      args[i] = arguments[i - 1]
    }
    return parent[level].apply(this, args)
  }
}

function transmit (logger, opts, args) {
  const send = opts.send
  const ts = opts.ts
  const methodLevel = opts.methodLevel
  const methodValue = opts.methodValue
  const val = opts.val
  const bindings = logger._logEvent.bindings

  applySerializers(
    args,
    logger._serialize || Object.keys(logger.serializers),
    logger.serializers,
    logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize
  )
  logger._logEvent.ts = ts
  logger._logEvent.messages = args.filter(function (arg) {
    // bindings can only be objects, so reference equality check via indexOf is fine
    return bindings.indexOf(arg) === -1
  })

  logger._logEvent.level.label = methodLevel
  logger._logEvent.level.value = methodValue

  send(methodLevel, logger._logEvent, val)

  logger._logEvent = createLogEventShape(bindings)
}

function createLogEventShape (bindings) {
  return {
    ts: 0,
    messages: [],
    bindings: bindings || [],
    level: { label: '', value: 0 }
  }
}

function asErrValue (err) {
  const obj = {
    type: err.constructor.name,
    msg: err.message,
    stack: err.stack
  }
  for (const key in err) {
    if (obj[key] === undefined) {
      obj[key] = err[key]
    }
  }
  return obj
}

function getTimeFunction (opts) {
  if (typeof opts.timestamp === 'function') {
    return opts.timestamp
  }
  if (opts.timestamp === false) {
    return nullTime
  }
  return epochTime
}

function mock () { return {} }
function passthrough (a) { return a }
function noop () {}

function nullTime () { return false }
function epochTime () { return Date.now() }
function unixTime () { return Math.round(Date.now() / 1000.0) }
function isoTime () { return new Date(Date.now()).toISOString() } // using Date.now() for testability

/* eslint-disable */
/* istanbul ignore next */
function pfGlobalThisOrFallback () {
  function defd (o) { return typeof o !== 'undefined' && o }
  try {
    if (typeof globalThis !== 'undefined') return globalThis
    Object.defineProperty(Object.prototype, 'globalThis', {
      get: function () {
        delete Object.prototype.globalThis
        return (this.globalThis = this)
      },
      configurable: true
    })
    return globalThis
  } catch (e) {
    return defd(self) || defd(window) || defd(this) || {}
  }
}
/* eslint-enable */


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 92066:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "If": function() { return /* binding */ useColorMode; }
/* harmony export */ });
/* unused harmony exports ColorModeContext, useColorModeValue */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'

// src/color-mode-context.ts
;
var ColorModeContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
ColorModeContext.displayName = "ColorModeContext";
function useColorMode() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ColorModeContext);
  if (context === void 0) {
    throw new Error("useColorMode must be used within a ColorModeProvider");
  }
  return context;
}
function useColorModeValue(light, dark) {
  const { colorMode } = useColorMode();
  return colorMode === "dark" ? dark : light;
}


//# sourceMappingURL=chunk-UQDW7KKV.mjs.map

/***/ }),

/***/ 14000:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ Text; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZJJGQIVY.mjs
var chunk_ZJJGQIVY = __webpack_require__(16554);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-TKWR62NH.mjs + 2 modules
var chunk_TKWR62NH = __webpack_require__(12575);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var dist = __webpack_require__(33179);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs + 2 modules
var chunk_ZHQNHOQS = __webpack_require__(48618);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/shared-utils/dist/index.mjs
var shared_utils_dist = __webpack_require__(25432);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/object-utils/dist/chunk-R3DH46PF.mjs
// src/compact.ts
function compact(object) {
  const clone = Object.assign({}, object);
  for (let key in clone) {
    if (clone[key] === void 0)
      delete clone[key];
  }
  return clone;
}



// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
'use client'

// src/text.tsx
;



var Text = (0,chunk_ZJJGQIVY/* forwardRef */.G)(function Text2(props, ref) {
  const styles = (0,chunk_TKWR62NH/* useStyleConfig */.mq)("Text", props);
  const { className, align, decoration, casing, ...rest } = (0,dist/* omitThemingProps */.Lr)(props);
  const aliasedProps = compact({
    textAlign: props.align,
    textDecoration: props.decoration,
    textTransform: props.casing
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    chunk_ZHQNHOQS/* chakra.p */.m.p,
    {
      ref,
      className: (0,shared_utils_dist.cx)("chakra-text", props.className),
      ...aliasedProps,
      ...rest,
      __css: styles
    }
  );
});
Text.displayName = "Text";


//# sourceMappingURL=chunk-2OOHT3W5.mjs.map

/***/ }),

/***/ 31009:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ assignAfter; }
/* harmony export */ });
// src/assign-after.ts
function assignAfter(target, ...sources) {
  if (target == null) {
    throw new TypeError("Cannot convert undefined or null to object");
  }
  const result = { ...target };
  for (const nextSource of sources) {
    if (nextSource == null)
      continue;
    for (const nextKey in nextSource) {
      if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey))
        continue;
      if (nextKey in result)
        delete result[nextKey];
      result[nextKey] = nextSource[nextKey];
    }
  }
  return result;
}




/***/ }),

/***/ 25432:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kn": function() { return /* binding */ isObject; },
/* harmony export */   "PB": function() { return /* binding */ dataAttr; },
/* harmony export */   "PP": function() { return /* binding */ callAll; },
/* harmony export */   "Pu": function() { return /* binding */ runIfFn; },
/* harmony export */   "cx": function() { return /* binding */ cx; },
/* harmony export */   "v0": function() { return /* binding */ callAllHandlers; }
/* harmony export */ });
/* unused harmony exports ariaAttr, warn */
// src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
var isFunction = (value) => typeof value === "function";
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}



/***/ }),

/***/ 33179:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lr": function() { return /* binding */ omitThemingProps; },
/* harmony export */   "Ud": function() { return /* binding */ resolveStyleConfig; },
/* harmony export */   "ZR": function() { return /* binding */ isStyleProp; },
/* harmony export */   "cC": function() { return /* binding */ propNames; },
/* harmony export */   "iv": function() { return /* binding */ css; }
/* harmony export */ });
/* unused harmony exports addPrefix, background, border, calc, color, createMultiStyleConfigHelpers, cssVar, defineCssVars, defineStyle, defineStyleConfig, effect, filter, flattenTokens, flexbox, getCSSVar, getCss, grid, interactivity, layout, layoutPropNames, list, others, position, pseudoPropNames, pseudoSelectors, ring, scroll, space, systemProps, textDecoration, toCSSVar, toVarDefinition, toVarReference, tokenToCSSVar, transform, transition, typography */
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25432);
/* harmony import */ var lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38554);
// src/utils/create-transform.ts

var isImportant = (value) => /!(important)?$/.test(value);
var withoutImportant = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
var tokenToCSSVar = (scale, value) => (theme) => {
  const valueStr = String(value);
  const important = isImportant(valueStr);
  const valueWithoutImportant = withoutImportant(valueStr);
  const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
  let transformed = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
  transformed = withoutImportant(transformed);
  return important ? `${transformed} !important` : transformed;
};
function createTransform(options) {
  const { scale, transform: transform2, compose } = options;
  const fn = (value, theme) => {
    var _a;
    const _value = tokenToCSSVar(scale, value)(theme);
    let result = (_a = transform2 == null ? void 0 : transform2(_value, theme)) != null ? _a : _value;
    if (compose) {
      result = compose(result, theme);
    }
    return result;
  };
  return fn;
}

// src/utils/pipe.ts
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);

// src/utils/prop-config.ts
function toConfig(scale, transform2) {
  return (property) => {
    const result = { property, scale };
    result.transform = createTransform({
      scale,
      transform: transform2
    });
    return result;
  };
}
var getRtl = ({ rtl, ltr }) => (theme) => theme.direction === "rtl" ? rtl : ltr;
function logical(options) {
  const { property, scale, transform: transform2 } = options;
  return {
    scale,
    property: getRtl(property),
    transform: scale ? createTransform({
      scale,
      compose: transform2
    }) : transform2
  };
}

// src/utils/templates.ts
var transformTemplate = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function getTransformTemplate() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...transformTemplate
  ].join(" ");
}
function getTransformGpuTemplate() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...transformTemplate
  ].join(" ");
}
var filterTemplate = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
};
var backdropFilterTemplate = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function getRingTemplate(value) {
  return {
    "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
    "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
    "--chakra-ring-width": value,
    boxShadow: [
      `var(--chakra-ring-offset-shadow)`,
      `var(--chakra-ring-shadow)`,
      `var(--chakra-shadow, 0 0 #0000)`
    ].join(", ")
  };
}
var flexDirectionTemplate = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
};

// src/utils/parse-gradient.ts
var directionMap = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
};
var valueSet = new Set(Object.values(directionMap));
var globalSet = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]);
var trimSpace = (str) => str.trim();
function parseGradient(value, theme) {
  if (value == null || globalSet.has(value))
    return value;
  const prevent = isCSSFunction(value) || globalSet.has(value);
  if (!prevent)
    return `url('${value}')`;
  const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
  const results = regex.exec(value);
  const type = results == null ? void 0 : results[1];
  const values = results == null ? void 0 : results[2];
  if (!type || !values)
    return value;
  const _type = type.includes("-gradient") ? type : `${type}-gradient`;
  const [maybeDirection, ...stops] = values.split(",").map(trimSpace).filter(Boolean);
  if ((stops == null ? void 0 : stops.length) === 0)
    return value;
  const direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
  stops.unshift(direction);
  const _values = stops.map((stop) => {
    if (valueSet.has(stop))
      return stop;
    const firstStop = stop.indexOf(" ");
    const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
    const _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
    const key = `colors.${_color}`;
    const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
    return _stopOrFunc ? [
      color2,
      ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
    ].join(" ") : color2;
  });
  return `${_type}(${_values.join(", ")})`;
}
var isCSSFunction = (value) => {
  return typeof value === "string" && value.includes("(") && value.includes(")");
};
var gradientTransform = (value, theme) => parseGradient(value, theme != null ? theme : {});

// src/utils/transform-functions.ts
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
var analyzeCSSValue = (value) => {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
};
var wrap = (str) => (value) => `${str}(${value})`;
var transformFunctions = {
  filter(value) {
    return value !== "auto" ? value : filterTemplate;
  },
  backdropFilter(value) {
    return value !== "auto" ? value : backdropFilterTemplate;
  },
  ring(value) {
    return getRingTemplate(transformFunctions.px(value));
  },
  bgClip(value) {
    return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
  },
  transform(value) {
    if (value === "auto")
      return getTransformTemplate();
    if (value === "auto-gpu")
      return getTransformGpuTemplate();
    return value;
  },
  vh(value) {
    return value === "$100vh" ? "var(--chakra-vh)" : value;
  },
  px(value) {
    if (value == null)
      return value;
    const { unitless } = analyzeCSSValue(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
  },
  fraction(value) {
    return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
  },
  float(value, theme) {
    const map = { left: "right", right: "left" };
    return theme.direction === "rtl" ? map[value] : value;
  },
  degree(value) {
    if (isCssVar(value) || value == null)
      return value;
    const unitless = typeof value === "string" && !value.endsWith("deg");
    return typeof value === "number" || unitless ? `${value}deg` : value;
  },
  gradient: gradientTransform,
  blur: wrap("blur"),
  opacity: wrap("opacity"),
  brightness: wrap("brightness"),
  contrast: wrap("contrast"),
  dropShadow: wrap("drop-shadow"),
  grayscale: wrap("grayscale"),
  hueRotate: wrap("hue-rotate"),
  invert: wrap("invert"),
  saturate: wrap("saturate"),
  sepia: wrap("sepia"),
  bgImage(value) {
    if (value == null)
      return value;
    const prevent = isCSSFunction(value) || globalSet.has(value);
    return !prevent ? `url(${value})` : value;
  },
  outline(value) {
    const isNoneOrZero = String(value) === "0" || String(value) === "none";
    return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
  },
  flexDirection(value) {
    var _a;
    const { space: space2, divide: divide2 } = (_a = flexDirectionTemplate[value]) != null ? _a : {};
    const result = { flexDirection: value };
    if (space2)
      result[space2] = 1;
    if (divide2)
      result[divide2] = 1;
    return result;
  }
};

// src/utils/index.ts
var t = {
  borderWidths: toConfig("borderWidths"),
  borderStyles: toConfig("borderStyles"),
  colors: toConfig("colors"),
  borders: toConfig("borders"),
  gradients: toConfig("gradients", transformFunctions.gradient),
  radii: toConfig("radii", transformFunctions.px),
  space: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  spaceT: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
  degreeT(property) {
    return { property, transform: transformFunctions.degree };
  },
  prop(property, scale, transform2) {
    return {
      property,
      scale,
      ...scale && {
        transform: createTransform({ scale, transform: transform2 })
      }
    };
  },
  propT(property, transform2) {
    return { property, transform: transform2 };
  },
  sizes: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.px)),
  sizesT: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.fraction)),
  shadows: toConfig("shadows"),
  logical,
  blur: toConfig("blur", transformFunctions.blur)
};

// src/config/background.ts
var background = {
  background: t.colors("background"),
  backgroundColor: t.colors("backgroundColor"),
  backgroundImage: t.gradients("backgroundImage"),
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true,
  backgroundAttachment: true,
  backgroundClip: { transform: transformFunctions.bgClip },
  bgSize: t.prop("backgroundSize"),
  bgPosition: t.prop("backgroundPosition"),
  bg: t.colors("background"),
  bgColor: t.colors("backgroundColor"),
  bgPos: t.prop("backgroundPosition"),
  bgRepeat: t.prop("backgroundRepeat"),
  bgAttachment: t.prop("backgroundAttachment"),
  bgGradient: t.gradients("backgroundImage"),
  bgClip: { transform: transformFunctions.bgClip }
};
Object.assign(background, {
  bgImage: background.backgroundImage,
  bgImg: background.backgroundImage
});

// src/config/border.ts
var border = {
  border: t.borders("border"),
  borderWidth: t.borderWidths("borderWidth"),
  borderStyle: t.borderStyles("borderStyle"),
  borderColor: t.colors("borderColor"),
  borderRadius: t.radii("borderRadius"),
  borderTop: t.borders("borderTop"),
  borderBlockStart: t.borders("borderBlockStart"),
  borderTopLeftRadius: t.radii("borderTopLeftRadius"),
  borderStartStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: t.radii("borderTopRightRadius"),
  borderStartEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: t.borders("borderRight"),
  borderInlineEnd: t.borders("borderInlineEnd"),
  borderBottom: t.borders("borderBottom"),
  borderBlockEnd: t.borders("borderBlockEnd"),
  borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: t.radii("borderBottomRightRadius"),
  borderLeft: t.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: t.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: t.borders(["borderLeft", "borderRight"]),
  borderInline: t.borders("borderInline"),
  borderY: t.borders(["borderTop", "borderBottom"]),
  borderBlock: t.borders("borderBlock"),
  borderTopWidth: t.borderWidths("borderTopWidth"),
  borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
  borderTopColor: t.colors("borderTopColor"),
  borderBlockStartColor: t.colors("borderBlockStartColor"),
  borderTopStyle: t.borderStyles("borderTopStyle"),
  borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: t.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
  borderBottomColor: t.colors("borderBottomColor"),
  borderBlockEndColor: t.colors("borderBlockEndColor"),
  borderBottomStyle: t.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: t.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
  borderLeftColor: t.colors("borderLeftColor"),
  borderInlineStartColor: t.colors("borderInlineStartColor"),
  borderLeftStyle: t.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
  borderRightWidth: t.borderWidths("borderRightWidth"),
  borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
  borderRightColor: t.colors("borderRightColor"),
  borderInlineEndColor: t.colors("borderInlineEndColor"),
  borderRightStyle: t.borderStyles("borderRightStyle"),
  borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
  borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: t.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: t.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(border, {
  rounded: border.borderRadius,
  roundedTop: border.borderTopRadius,
  roundedTopLeft: border.borderTopLeftRadius,
  roundedTopRight: border.borderTopRightRadius,
  roundedTopStart: border.borderStartStartRadius,
  roundedTopEnd: border.borderStartEndRadius,
  roundedBottom: border.borderBottomRadius,
  roundedBottomLeft: border.borderBottomLeftRadius,
  roundedBottomRight: border.borderBottomRightRadius,
  roundedBottomStart: border.borderEndStartRadius,
  roundedBottomEnd: border.borderEndEndRadius,
  roundedLeft: border.borderLeftRadius,
  roundedRight: border.borderRightRadius,
  roundedStart: border.borderInlineStartRadius,
  roundedEnd: border.borderInlineEndRadius,
  borderStart: border.borderInlineStart,
  borderEnd: border.borderInlineEnd,
  borderTopStartRadius: border.borderStartStartRadius,
  borderTopEndRadius: border.borderStartEndRadius,
  borderBottomStartRadius: border.borderEndStartRadius,
  borderBottomEndRadius: border.borderEndEndRadius,
  borderStartRadius: border.borderInlineStartRadius,
  borderEndRadius: border.borderInlineEndRadius,
  borderStartWidth: border.borderInlineStartWidth,
  borderEndWidth: border.borderInlineEndWidth,
  borderStartColor: border.borderInlineStartColor,
  borderEndColor: border.borderInlineEndColor,
  borderStartStyle: border.borderInlineStartStyle,
  borderEndStyle: border.borderInlineEndStyle
});

// src/config/color.ts
var color = {
  color: t.colors("color"),
  textColor: t.colors("color"),
  fill: t.colors("fill"),
  stroke: t.colors("stroke")
};

// src/config/effect.ts
var effect = {
  boxShadow: t.shadows("boxShadow"),
  mixBlendMode: true,
  blendMode: t.prop("mixBlendMode"),
  backgroundBlendMode: true,
  bgBlendMode: t.prop("backgroundBlendMode"),
  opacity: true
};
Object.assign(effect, {
  shadow: effect.boxShadow
});

// src/config/filter.ts
var filter = {
  filter: { transform: transformFunctions.filter },
  blur: t.blur("--chakra-blur"),
  brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
  contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
  hueRotate: t.degreeT("--chakra-hue-rotate"),
  invert: t.propT("--chakra-invert", transformFunctions.invert),
  saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
  dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
  backdropFilter: { transform: transformFunctions.backdropFilter },
  backdropBlur: t.blur("--chakra-backdrop-blur"),
  backdropBrightness: t.propT(
    "--chakra-backdrop-brightness",
    transformFunctions.brightness
  ),
  backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
  backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
  backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
};

// src/config/flexbox.ts
var flexbox = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: { transform: transformFunctions.flexDirection },
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: t.sizes("flexBasis"),
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true,
  gap: t.space("gap"),
  rowGap: t.space("rowGap"),
  columnGap: t.space("columnGap")
};
Object.assign(flexbox, {
  flexDir: flexbox.flexDirection
});

// src/config/grid.ts
var grid = {
  gridGap: t.space("gridGap"),
  gridColumnGap: t.space("gridColumnGap"),
  gridRowGap: t.space("gridRowGap"),
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridColumnStart: true,
  gridColumnEnd: true,
  gridRowStart: true,
  gridRowEnd: true,
  gridAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};

// src/config/interactivity.ts
var interactivity = {
  appearance: true,
  cursor: true,
  resize: true,
  userSelect: true,
  pointerEvents: true,
  outline: { transform: transformFunctions.outline },
  outlineOffset: true,
  outlineColor: t.colors("outlineColor")
};

// src/config/layout.ts
var layout = {
  width: t.sizesT("width"),
  inlineSize: t.sizesT("inlineSize"),
  height: t.sizes("height"),
  blockSize: t.sizes("blockSize"),
  boxSize: t.sizes(["width", "height"]),
  minWidth: t.sizes("minWidth"),
  minInlineSize: t.sizes("minInlineSize"),
  minHeight: t.sizes("minHeight"),
  minBlockSize: t.sizes("minBlockSize"),
  maxWidth: t.sizes("maxWidth"),
  maxInlineSize: t.sizes("maxInlineSize"),
  maxHeight: t.sizes("maxHeight"),
  maxBlockSize: t.sizes("maxBlockSize"),
  overflow: true,
  overflowX: true,
  overflowY: true,
  overscrollBehavior: true,
  overscrollBehaviorX: true,
  overscrollBehaviorY: true,
  display: true,
  aspectRatio: true,
  hideFrom: {
    scale: "breakpoints",
    transform: (value, theme) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b.minW) != null ? _c : value;
      const mq = `@media screen and (min-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (value, theme) => {
      var _a, _b, _c;
      const breakpoint = (_c = (_b = (_a = theme.__breakpoints) == null ? void 0 : _a.get(value)) == null ? void 0 : _b._minW) != null ? _c : value;
      const mq = `@media screen and (max-width: ${breakpoint})`;
      return { [mq]: { display: "none" } };
    }
  },
  verticalAlign: true,
  boxSizing: true,
  boxDecorationBreak: true,
  float: t.propT("float", transformFunctions.float),
  objectFit: true,
  objectPosition: true,
  visibility: true,
  isolation: true
};
Object.assign(layout, {
  w: layout.width,
  h: layout.height,
  minW: layout.minWidth,
  maxW: layout.maxWidth,
  minH: layout.minHeight,
  maxH: layout.maxHeight,
  overscroll: layout.overscrollBehavior,
  overscrollX: layout.overscrollBehaviorX,
  overscrollY: layout.overscrollBehaviorY
});

// src/config/list.ts
var list = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: t.prop("listStylePosition"),
  listStyleImage: true,
  listStyleImg: t.prop("listStyleImage")
};

// src/get.ts
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);

// src/config/others.ts
var srOnly = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
var srFocusable = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
};
var getWithPriority = (theme, key, styles) => {
  const result = {};
  const obj = memoizedGet(theme, key, {});
  for (const prop in obj) {
    const isInStyles = prop in styles && styles[prop] != null;
    if (!isInStyles)
      result[prop] = obj[prop];
  }
  return result;
};
var others = {
  srOnly: {
    transform(value) {
      if (value === true)
        return srOnly;
      if (value === "focusable")
        return srFocusable;
      return {};
    }
  },
  layerStyle: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, `layerStyles.${value}`, styles)
  },
  textStyle: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, `textStyles.${value}`, styles)
  },
  apply: {
    processResult: true,
    transform: (value, theme, styles) => getWithPriority(theme, value, styles)
  }
};

// src/config/position.ts
var position = {
  position: true,
  pos: t.prop("position"),
  zIndex: t.prop("zIndex", "zIndices"),
  inset: t.spaceT("inset"),
  insetX: t.spaceT(["left", "right"]),
  insetInline: t.spaceT("insetInline"),
  insetY: t.spaceT(["top", "bottom"]),
  insetBlock: t.spaceT("insetBlock"),
  top: t.spaceT("top"),
  insetBlockStart: t.spaceT("insetBlockStart"),
  bottom: t.spaceT("bottom"),
  insetBlockEnd: t.spaceT("insetBlockEnd"),
  left: t.spaceT("left"),
  insetInlineStart: t.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: t.spaceT("right"),
  insetInlineEnd: t.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(position, {
  insetStart: position.insetInlineStart,
  insetEnd: position.insetInlineEnd
});

// src/config/ring.ts
var ring = {
  ring: { transform: transformFunctions.ring },
  ringColor: t.colors("--chakra-ring-color"),
  ringOffset: t.prop("--chakra-ring-offset-width"),
  ringOffsetColor: t.colors("--chakra-ring-offset-color"),
  ringInset: t.prop("--chakra-ring-inset")
};

// src/config/space.ts
var space = {
  margin: t.spaceT("margin"),
  marginTop: t.spaceT("marginTop"),
  marginBlockStart: t.spaceT("marginBlockStart"),
  marginRight: t.spaceT("marginRight"),
  marginInlineEnd: t.spaceT("marginInlineEnd"),
  marginBottom: t.spaceT("marginBottom"),
  marginBlockEnd: t.spaceT("marginBlockEnd"),
  marginLeft: t.spaceT("marginLeft"),
  marginInlineStart: t.spaceT("marginInlineStart"),
  marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: t.spaceT("marginInline"),
  marginY: t.spaceT(["marginTop", "marginBottom"]),
  marginBlock: t.spaceT("marginBlock"),
  padding: t.space("padding"),
  paddingTop: t.space("paddingTop"),
  paddingBlockStart: t.space("paddingBlockStart"),
  paddingRight: t.space("paddingRight"),
  paddingBottom: t.space("paddingBottom"),
  paddingBlockEnd: t.space("paddingBlockEnd"),
  paddingLeft: t.space("paddingLeft"),
  paddingInlineStart: t.space("paddingInlineStart"),
  paddingInlineEnd: t.space("paddingInlineEnd"),
  paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: t.space("paddingInline"),
  paddingY: t.space(["paddingTop", "paddingBottom"]),
  paddingBlock: t.space("paddingBlock")
};
Object.assign(space, {
  m: space.margin,
  mt: space.marginTop,
  mr: space.marginRight,
  me: space.marginInlineEnd,
  marginEnd: space.marginInlineEnd,
  mb: space.marginBottom,
  ml: space.marginLeft,
  ms: space.marginInlineStart,
  marginStart: space.marginInlineStart,
  mx: space.marginX,
  my: space.marginY,
  p: space.padding,
  pt: space.paddingTop,
  py: space.paddingY,
  px: space.paddingX,
  pb: space.paddingBottom,
  pl: space.paddingLeft,
  ps: space.paddingInlineStart,
  paddingStart: space.paddingInlineStart,
  pr: space.paddingRight,
  pe: space.paddingInlineEnd,
  paddingEnd: space.paddingInlineEnd
});

// src/config/text-decoration.ts
var textDecoration = {
  textDecorationColor: t.colors("textDecorationColor"),
  textDecoration: true,
  textDecor: { property: "textDecoration" },
  textDecorationLine: true,
  textDecorationStyle: true,
  textDecorationThickness: true,
  textUnderlineOffset: true,
  textShadow: t.shadows("textShadow")
};

// src/config/transform.ts
var transform = {
  clipPath: true,
  transform: t.propT("transform", transformFunctions.transform),
  transformOrigin: true,
  translateX: t.spaceT("--chakra-translate-x"),
  translateY: t.spaceT("--chakra-translate-y"),
  skewX: t.degreeT("--chakra-skew-x"),
  skewY: t.degreeT("--chakra-skew-y"),
  scaleX: t.prop("--chakra-scale-x"),
  scaleY: t.prop("--chakra-scale-y"),
  scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: t.degreeT("--chakra-rotate")
};

// src/config/transition.ts
var transition = {
  transition: true,
  transitionDelay: true,
  animation: true,
  willChange: true,
  transitionDuration: t.prop("transitionDuration", "transition.duration"),
  transitionProperty: t.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: t.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
};

// src/config/typography.ts
var typography = {
  fontFamily: t.prop("fontFamily", "fonts"),
  fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
  fontWeight: t.prop("fontWeight", "fontWeights"),
  lineHeight: t.prop("lineHeight", "lineHeights"),
  letterSpacing: t.prop("letterSpacing", "letterSpacings"),
  textAlign: true,
  fontStyle: true,
  textIndent: true,
  wordBreak: true,
  overflowWrap: true,
  textOverflow: true,
  textTransform: true,
  whiteSpace: true,
  isTruncated: {
    transform(value) {
      if (value === true) {
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
      }
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
};

// src/config/scroll.ts
var scroll = {
  scrollBehavior: true,
  scrollSnapAlign: true,
  scrollSnapStop: true,
  scrollSnapType: true,
  scrollMargin: t.spaceT("scrollMargin"),
  scrollMarginTop: t.spaceT("scrollMarginTop"),
  scrollMarginBottom: t.spaceT("scrollMarginBottom"),
  scrollMarginLeft: t.spaceT("scrollMarginLeft"),
  scrollMarginRight: t.spaceT("scrollMarginRight"),
  scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  scrollPadding: t.spaceT("scrollPadding"),
  scrollPaddingTop: t.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: t.spaceT("scrollPaddingRight"),
  scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};

// src/create-theme-vars/calc.ts

function resolveReference(operand) {
  if ((0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(operand) && operand.reference) {
    return operand.reference;
  }
  return String(operand);
}
var toExpression = (operator, ...operands) => operands.map(resolveReference).join(` ${operator} `).replace(/calc/g, "");
var add = (...operands) => `calc(${toExpression("+", ...operands)})`;
var subtract = (...operands) => `calc(${toExpression("-", ...operands)})`;
var multiply = (...operands) => `calc(${toExpression("*", ...operands)})`;
var divide = (...operands) => `calc(${toExpression("/", ...operands)})`;
var negate = (x) => {
  const value = resolveReference(x);
  if (value != null && !Number.isNaN(parseFloat(value))) {
    return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
  }
  return multiply(value, -1);
};
var calc = Object.assign(
  (x) => ({
    add: (...operands) => calc(add(x, ...operands)),
    subtract: (...operands) => calc(subtract(x, ...operands)),
    multiply: (...operands) => calc(multiply(x, ...operands)),
    divide: (...operands) => calc(divide(x, ...operands)),
    negate: () => calc(negate(x)),
    toString: () => x.toString()
  }),
  {
    add,
    subtract,
    multiply,
    divide,
    negate
  }
);

// src/create-theme-vars/css-var.ts
function replaceWhiteSpace(value, replaceValue = "-") {
  return value.replace(/\s+/g, replaceValue);
}
function escape(value) {
  const valueStr = replaceWhiteSpace(value.toString());
  return escapeSymbol(escapeDot(valueStr));
}
function escapeDot(value) {
  if (value.includes("\\."))
    return value;
  const isDecimal = !Number.isInteger(parseFloat(value.toString()));
  return isDecimal ? value.replace(".", `\\.`) : value;
}
function escapeSymbol(value) {
  return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
}
function addPrefix(value, prefix = "") {
  return [prefix, value].filter(Boolean).join("-");
}
function toVarReference(name, fallback) {
  return `var(${name}${fallback ? `, ${fallback}` : ""})`;
}
function toVarDefinition(value, prefix = "") {
  return escape(`--${addPrefix(value, prefix)}`);
}
function cssVar(name, fallback, cssVarPrefix) {
  const cssVariable = toVarDefinition(name, cssVarPrefix);
  return {
    variable: cssVariable,
    reference: toVarReference(cssVariable, fallback)
  };
}
function defineCssVars(scope, keys2) {
  const vars = {};
  for (const key of keys2) {
    if (Array.isArray(key)) {
      const [name, fallback] = key;
      vars[name] = cssVar(`${scope}-${name}`, fallback);
      continue;
    }
    vars[key] = cssVar(`${scope}-${key}`);
  }
  return vars;
}

// ../../utilities/breakpoint-utils/src/breakpoint.ts

function getLastItem(array) {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : void 0;
}
function analyzeCSSValue2(value) {
  const num = parseFloat(value.toString());
  const unit = value.toString().replace(String(num), "");
  return { unitless: !unit, value: num, unit };
}
function px(value) {
  if (value == null)
    return value;
  const { unitless } = analyzeCSSValue2(value);
  return unitless || typeof value === "number" ? `${value}px` : value;
}
var sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
var sortBps = (breakpoints) => Object.fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
function normalize(breakpoints) {
  const sorted = sortBps(breakpoints);
  return Object.assign(Object.values(sorted), sorted);
}
function keys(breakpoints) {
  const value = Object.keys(sortBps(breakpoints));
  return new Set(value);
}
function subtract2(value) {
  var _a;
  if (!value)
    return value;
  value = (_a = px(value)) != null ? _a : value;
  const OFFSET = -0.02;
  return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + OFFSET}`);
}
function toMediaQueryString(min, max) {
  const query = ["@media screen"];
  if (min)
    query.push("and", `(min-width: ${px(min)})`);
  if (max)
    query.push("and", `(max-width: ${px(max)})`);
  return query.join(" ");
}
function analyzeBreakpoints(breakpoints) {
  var _a;
  if (!breakpoints)
    return null;
  breakpoints.base = (_a = breakpoints.base) != null ? _a : "0px";
  const normalized = normalize(breakpoints);
  const queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
    var _a2;
    let [, maxW] = (_a2 = entry[index + 1]) != null ? _a2 : [];
    maxW = parseFloat(maxW) > 0 ? subtract2(maxW) : void 0;
    return {
      _minW: subtract2(minW),
      breakpoint,
      minW,
      maxW,
      maxWQuery: toMediaQueryString(null, maxW),
      minWQuery: toMediaQueryString(minW),
      minMaxQuery: toMediaQueryString(minW, maxW)
    };
  });
  const _keys = keys(breakpoints);
  const _keysArr = Array.from(_keys.values());
  return {
    keys: _keys,
    normalized,
    isResponsive(test) {
      const keys2 = Object.keys(test);
      return keys2.length > 0 && keys2.every((key) => _keys.has(key));
    },
    asObject: sortBps(breakpoints),
    asArray: normalize(breakpoints),
    details: queries,
    get(key) {
      return queries.find((q) => q.breakpoint === key);
    },
    media: [
      null,
      ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
    ],
    toArrayValue(test) {
      if (!isObject3(test)) {
        throw new Error("toArrayValue: value must be an object");
      }
      const result = _keysArr.map((bp) => {
        var _a2;
        return (_a2 = test[bp]) != null ? _a2 : null;
      });
      while (getLastItem(result) === null) {
        result.pop();
      }
      return result;
    },
    toObjectValue(test) {
      if (!Array.isArray(test)) {
        throw new Error("toObjectValue: value must be an array");
      }
      return test.reduce((acc, value, index) => {
        const key = _keysArr[index];
        if (key != null && value != null)
          acc[key] = value;
        return acc;
      }, {});
    }
  };
}

// src/create-theme-vars/create-theme-vars.ts


// src/pseudos.ts
var state = {
  hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
  focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
  focusVisible: (str, post) => `${str}:focus-visible ${post}`,
  focusWithin: (str, post) => `${str}:focus-within ${post}`,
  active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
  disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
  invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
  checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
  indeterminate: (str, post) => `${str}:indeterminate ${post}, ${str}[aria-checked=mixed] ${post}, ${str}[data-indeterminate] ${post}`,
  readOnly: (str, post) => `${str}:read-only ${post}, ${str}[readonly] ${post}, ${str}[data-read-only] ${post}`,
  expanded: (str, post) => `${str}:read-only ${post}, ${str}[aria-expanded=true] ${post}, ${str}[data-expanded] ${post}`,
  placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
};
var toGroup = (fn) => merge((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
var toPeer = (fn) => merge((v) => fn(v, "~ &"), "[data-peer]", ".peer");
var merge = (fn, ...selectors) => selectors.map(fn).join(", ");
var pseudoSelectors = {
  _hover: "&:hover, &[data-hover]",
  _active: "&:active, &[data-active]",
  _focus: "&:focus, &[data-focus]",
  _highlighted: "&[data-highlighted]",
  _focusWithin: "&:focus-within",
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  _before: "&::before",
  _after: "&::after",
  _empty: "&:empty",
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  _checked: "&[aria-checked=true], &[data-checked]",
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  _valid: "&[data-valid], &[data-state=valid]",
  _loading: "&[data-loading], &[aria-busy=true]",
  _selected: "&[aria-selected=true], &[data-selected]",
  _hidden: "&[hidden], &[data-hidden]",
  _autofill: "&:-webkit-autofill",
  _even: "&:nth-of-type(even)",
  _odd: "&:nth-of-type(odd)",
  _first: "&:first-of-type",
  _firstLetter: "&::first-letter",
  _last: "&:last-of-type",
  _notFirst: "&:not(:first-of-type)",
  _notLast: "&:not(:last-of-type)",
  _visited: "&:visited",
  _activeLink: "&[aria-current=page]",
  _activeStep: "&[aria-current=step]",
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  _groupHover: toGroup(state.hover),
  _peerHover: toPeer(state.hover),
  _groupFocus: toGroup(state.focus),
  _peerFocus: toPeer(state.focus),
  _groupFocusVisible: toGroup(state.focusVisible),
  _peerFocusVisible: toPeer(state.focusVisible),
  _groupActive: toGroup(state.active),
  _peerActive: toPeer(state.active),
  _groupDisabled: toGroup(state.disabled),
  _peerDisabled: toPeer(state.disabled),
  _groupInvalid: toGroup(state.invalid),
  _peerInvalid: toPeer(state.invalid),
  _groupChecked: toGroup(state.checked),
  _peerChecked: toPeer(state.checked),
  _groupFocusWithin: toGroup(state.focusWithin),
  _peerFocusWithin: toPeer(state.focusWithin),
  _peerPlaceholderShown: toPeer(state.placeholderShown),
  _placeholder: "&::placeholder",
  _placeholderShown: "&:placeholder-shown",
  _fullScreen: "&:fullscreen",
  _selection: "&::selection",
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  _mediaDark: "@media (prefers-color-scheme: dark)",
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  _horizontal: "&[data-orientation=horizontal]",
  _vertical: "&[data-orientation=vertical]"
};
var pseudoPropNames = Object.keys(
  pseudoSelectors
);

// src/create-theme-vars/create-theme-vars.ts

function tokenToCssVar(token, prefix) {
  return cssVar(String(token).replace(/\./g, "-"), void 0, prefix);
}
function createThemeVars(flatTokens, options) {
  let cssVars = {};
  const cssMap = {};
  for (const [token, tokenValue] of Object.entries(flatTokens)) {
    const { isSemantic, value } = tokenValue;
    const { variable, reference } = tokenToCssVar(token, options == null ? void 0 : options.cssVarPrefix);
    if (!isSemantic) {
      if (token.startsWith("space")) {
        const keys2 = token.split(".");
        const [firstKey, ...referenceKeys] = keys2;
        const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
        const negativeValue = calc.negate(value);
        const negatedReference = calc.negate(reference);
        cssMap[negativeLookupKey] = {
          value: negativeValue,
          var: variable,
          varRef: negatedReference
        };
      }
      cssVars[variable] = value;
      cssMap[token] = {
        value,
        var: variable,
        varRef: reference
      };
      continue;
    }
    const lookupToken = (maybeToken) => {
      const scale = String(token).split(".")[0];
      const withScale = [scale, maybeToken].join(".");
      const resolvedTokenValue = flatTokens[withScale];
      if (!resolvedTokenValue)
        return maybeToken;
      const { reference: reference2 } = tokenToCssVar(withScale, options == null ? void 0 : options.cssVarPrefix);
      return reference2;
    };
    const normalizedValue = isObject4(value) ? value : { default: value };
    cssVars = mergeWith(
      cssVars,
      Object.entries(normalizedValue).reduce(
        (acc, [conditionAlias, conditionValue]) => {
          var _a, _b;
          if (!conditionValue)
            return acc;
          const tokenReference = lookupToken(`${conditionValue}`);
          if (conditionAlias === "default") {
            acc[variable] = tokenReference;
            return acc;
          }
          const conditionSelector = (_b = (_a = pseudoSelectors) == null ? void 0 : _a[conditionAlias]) != null ? _b : conditionAlias;
          acc[conditionSelector] = { [variable]: tokenReference };
          return acc;
        },
        {}
      )
    );
    cssMap[token] = {
      value: reference,
      var: variable,
      varRef: reference
    };
  }
  return {
    cssVars,
    cssMap
  };
}

// ../../utilities/object-utils/src/omit.ts
function omit(object, keysToOmit = []) {
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}

// ../../utilities/object-utils/src/pick.ts
function pick(object, keysToPick) {
  const result = {};
  for (const key of keysToPick) {
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

// ../../utilities/object-utils/src/walk-object.ts
function isObject5(value) {
  return typeof value === "object" && value != null && !Array.isArray(value);
}
function walkObject(target, predicate, options = {}) {
  const { stop, getKey } = options;
  function inner(value, path = []) {
    var _a;
    if (isObject5(value) || Array.isArray(value)) {
      const result = {};
      for (const [prop, child] of Object.entries(value)) {
        const key = (_a = getKey == null ? void 0 : getKey(prop)) != null ? _a : prop;
        const childPath = [...path, key];
        if (stop == null ? void 0 : stop(value, childPath)) {
          return predicate(value, path);
        }
        result[key] = inner(child, childPath);
      }
      return result;
    }
    return predicate(value, path);
  }
  return inner(target);
}

// src/create-theme-vars/theme-tokens.ts
var tokens = (/* unused pure expression or super */ null && ([
  "colors",
  "borders",
  "borderWidths",
  "borderStyles",
  "fonts",
  "fontSizes",
  "fontWeights",
  "gradients",
  "letterSpacings",
  "lineHeights",
  "radii",
  "space",
  "shadows",
  "sizes",
  "zIndices",
  "transition",
  "blur",
  "breakpoints"
]));
function extractTokens(theme) {
  const _tokens = tokens;
  return pick(theme, _tokens);
}
function extractSemanticTokens(theme) {
  return theme.semanticTokens;
}
function omitVars(rawTheme) {
  const { __cssMap, __cssVars, __breakpoints, ...cleanTheme } = rawTheme;
  return cleanTheme;
}

// src/create-theme-vars/flatten-tokens.ts
var isSemanticCondition = (key) => pseudoPropNames.includes(key) || "default" === key;
function flattenTokens({
  tokens: tokens2,
  semanticTokens
}) {
  const result = {};
  walkObject(tokens2, (value, path) => {
    if (value == null)
      return;
    result[path.join(".")] = { isSemantic: false, value };
  });
  walkObject(
    semanticTokens,
    (value, path) => {
      if (value == null)
        return;
      result[path.join(".")] = { isSemantic: true, value };
    },
    {
      stop: (value) => Object.keys(value).every(isSemanticCondition)
    }
  );
  return result;
}

// src/create-theme-vars/to-css-var.ts
function toCSSVar(rawTheme) {
  var _a;
  const theme = omitVars(rawTheme);
  const tokens2 = extractTokens(theme);
  const semanticTokens = extractSemanticTokens(theme);
  const flatTokens = flattenTokens({ tokens: tokens2, semanticTokens });
  const cssVarPrefix = (_a = theme.config) == null ? void 0 : _a.cssVarPrefix;
  const {
    cssMap,
    cssVars
  } = createThemeVars(flatTokens, { cssVarPrefix });
  const defaultCssVars = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  Object.assign(theme, {
    __cssVars: { ...defaultCssVars, ...cssVars },
    __cssMap: cssMap,
    __breakpoints: analyzeBreakpoints(theme.breakpoints)
  });
  return theme;
}

// src/css.ts



// src/system.ts

var systemProps = lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__(
  {},
  background,
  border,
  color,
  flexbox,
  layout,
  filter,
  ring,
  interactivity,
  grid,
  others,
  position,
  effect,
  space,
  scroll,
  typography,
  textDecoration,
  transform,
  list,
  transition
);
var layoutSystem = Object.assign({}, space, layout, flexbox, grid, position);
var layoutPropNames = Object.keys(
  layoutSystem
);
var propNames = [...Object.keys(systemProps), ...pseudoPropNames];
var styleProps = { ...systemProps, ...pseudoSelectors };
var isStyleProp = (prop) => prop in styleProps;

// src/utils/expand-responsive.ts

var expandResponsive = (styles) => (theme) => {
  if (!theme.__breakpoints)
    return styles;
  const { isResponsive, toArrayValue, media: medias } = theme.__breakpoints;
  const computedStyles = {};
  for (const key in styles) {
    let value = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)(styles[key], theme);
    if (value == null)
      continue;
    value = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(value) && isResponsive(value) ? toArrayValue(value) : value;
    if (!Array.isArray(value)) {
      computedStyles[key] = value;
      continue;
    }
    const queries = value.slice(0, medias.length).length;
    for (let index = 0; index < queries; index += 1) {
      const media = medias == null ? void 0 : medias[index];
      if (!media) {
        computedStyles[key] = value[index];
        continue;
      }
      computedStyles[media] = computedStyles[media] || {};
      if (value[index] == null) {
        continue;
      }
      computedStyles[media][key] = value[index];
    }
  }
  return computedStyles;
};

// src/utils/split-by-comma.ts
function splitByComma(value) {
  const chunks = [];
  let chunk = "";
  let inParens = false;
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (char === "(") {
      inParens = true;
      chunk += char;
    } else if (char === ")") {
      inParens = false;
      chunk += char;
    } else if (char === "," && !inParens) {
      chunks.push(chunk);
      chunk = "";
    } else {
      chunk += char;
    }
  }
  chunk = chunk.trim();
  if (chunk) {
    chunks.push(chunk);
  }
  return chunks;
}

// src/css.ts
function isCssVar2(value) {
  return /^var\(--.+\)$/.test(value);
}
var isCSSVariableTokenValue = (key, value) => key.startsWith("--") && typeof value === "string" && !isCssVar2(value);
var resolveTokenValue = (theme, value) => {
  var _a, _b;
  if (value == null)
    return value;
  const getVar = (val) => {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.varRef;
  };
  const getValue = (val) => {
    var _a2;
    return (_a2 = getVar(val)) != null ? _a2 : val;
  };
  const [tokenValue, fallbackValue] = splitByComma(value);
  value = (_b = (_a = getVar(tokenValue)) != null ? _a : getValue(fallbackValue)) != null ? _b : getValue(value);
  return value;
};
function getCss(options) {
  const { configs = {}, pseudos = {}, theme } = options;
  const css2 = (stylesOrFn, nested = false) => {
    var _a, _b, _c;
    const _styles = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)(stylesOrFn, theme);
    const styles = expandResponsive(_styles)(theme);
    let computedStyles = {};
    for (let key in styles) {
      const valueOrFn = styles[key];
      let value = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)(valueOrFn, theme);
      if (key in pseudos) {
        key = pseudos[key];
      }
      if (isCSSVariableTokenValue(key, value)) {
        value = resolveTokenValue(theme, value);
      }
      let config = configs[key];
      if (config === true) {
        config = { property: key };
      }
      if ((0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(value)) {
        computedStyles[key] = (_a = computedStyles[key]) != null ? _a : {};
        computedStyles[key] = lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__(
          {},
          computedStyles[key],
          css2(value, true)
        );
        continue;
      }
      let rawValue = (_c = (_b = config == null ? void 0 : config.transform) == null ? void 0 : _b.call(config, value, theme, _styles)) != null ? _c : value;
      rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
      const configProperty = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)(config == null ? void 0 : config.property, theme);
      if (!nested && (config == null ? void 0 : config.static)) {
        const staticStyles = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)(config.static, theme);
        computedStyles = lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__({}, computedStyles, staticStyles);
      }
      if (configProperty && Array.isArray(configProperty)) {
        for (const property of configProperty) {
          computedStyles[property] = rawValue;
        }
        continue;
      }
      if (configProperty) {
        if (configProperty === "&" && (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(rawValue)) {
          computedStyles = lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__({}, computedStyles, rawValue);
        } else {
          computedStyles[configProperty] = rawValue;
        }
        continue;
      }
      if ((0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(rawValue)) {
        computedStyles = lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__({}, computedStyles, rawValue);
        continue;
      }
      computedStyles[key] = rawValue;
    }
    return computedStyles;
  };
  return css2;
}
var css = (styles) => (theme) => {
  const cssFn = getCss({
    theme,
    pseudos: pseudoSelectors,
    configs: systemProps
  });
  return cssFn(styles);
};

// src/define-styles.ts
function defineStyle(styles) {
  return styles;
}
function defineStyleConfig(config) {
  return config;
}
function createMultiStyleConfigHelpers(parts) {
  return {
    definePartsStyle(config) {
      return config;
    },
    defineMultiStyleConfig(config) {
      return { parts, ...config };
    }
  };
}

// src/style-config.ts


function normalize2(value, toArray) {
  if (Array.isArray(value))
    return value;
  if ((0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .isObject */ .Kn)(value))
    return toArray(value);
  if (value != null)
    return [value];
}
function getNextIndex(values, i) {
  for (let j = i + 1; j < values.length; j++) {
    if (values[j] != null)
      return j;
  }
  return -1;
}
function createResolver(theme) {
  const breakpointUtil = theme.__breakpoints;
  return function resolver(config, prop, value, props) {
    var _a, _b;
    if (!breakpointUtil)
      return;
    const result = {};
    const normalized = normalize2(value, breakpointUtil.toArrayValue);
    if (!normalized)
      return result;
    const len = normalized.length;
    const isSingle = len === 1;
    const isMultipart = !!config.parts;
    for (let i = 0; i < len; i++) {
      const key = breakpointUtil.details[i];
      const nextKey = breakpointUtil.details[getNextIndex(normalized, i)];
      const query = toMediaQueryString(key.minW, nextKey == null ? void 0 : nextKey._minW);
      const styles = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)((_a = config[prop]) == null ? void 0 : _a[normalized[i]], props);
      if (!styles)
        continue;
      if (isMultipart) {
        (_b = config.parts) == null ? void 0 : _b.forEach((part) => {
          lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__(result, {
            [part]: isSingle ? styles[part] : { [query]: styles[part] }
          });
        });
        continue;
      }
      if (!isMultipart) {
        if (isSingle)
          lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__(result, styles);
        else
          result[query] = styles;
        continue;
      }
      result[query] = styles;
    }
    return result;
  };
}
function resolveStyleConfig(config) {
  return (props) => {
    var _a;
    const { variant, size, theme } = props;
    const recipe = createResolver(theme);
    return lodash_mergewith__WEBPACK_IMPORTED_MODULE_1__(
      {},
      (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_0__/* .runIfFn */ .Pu)((_a = config.baseStyle) != null ? _a : {}, props),
      recipe(config, "sizes", size, props),
      recipe(config, "variants", variant, props)
    );
  };
}

// src/get-css-var.ts
function getCSSVar(theme, scale, value) {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
}

// src/theming-props.ts
function omitThemingProps(props) {
  return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
}



/***/ }),

/***/ 12575:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jC": function() { return /* binding */ useMultiStyleConfig; },
  "mq": function() { return /* binding */ useStyleConfig; }
});

// UNUSED EXPORTS: useComponentStyles__unstable

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-699e6908.browser.esm.js + 2 modules
var emotion_element_699e6908_browser_esm = __webpack_require__(65706);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-UIGT7YZF.mjs
'use client'

// src/use-theme.ts
;

function chunk_UIGT7YZF_useTheme() {
  const theme = (0,react.useContext)(
    emotion_element_699e6908_browser_esm.T
  );
  if (!theme) {
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  }
  return theme;
}


//# sourceMappingURL=chunk-UIGT7YZF.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chunk-UQDW7KKV.mjs
var chunk_UQDW7KKV = __webpack_require__(92066);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-WNDUHNHH.mjs
'use client'
;

// src/hooks.ts

function chunk_WNDUHNHH_useChakra() {
  const colorModeResult = (0,chunk_UQDW7KKV/* useColorMode */.If)();
  const theme = chunk_UIGT7YZF_useTheme();
  return { ...colorModeResult, theme };
}
function getBreakpointValue(theme, value, fallback) {
  var _a, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__breakpoints) == null ? void 0 : _a2.asArray) == null ? void 0 : _b2[val];
  };
  return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _a, _b;
  if (value == null)
    return value;
  const getValue = (val) => {
    var _a2, _b2;
    return (_b2 = (_a2 = theme.__cssMap) == null ? void 0 : _a2[val]) == null ? void 0 : _b2.value;
  };
  return (_b = (_a = getValue(value)) != null ? _a : getValue(fallback)) != null ? _b : fallback;
}
function useToken(scale, token, fallback) {
  const theme = useTheme();
  return getToken(scale, token, fallback)(theme);
}
function getToken(scale, token, fallback) {
  const _token = Array.isArray(token) ? token : [token];
  const _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return (theme) => {
    const fallbackArr = _fallback.filter(Boolean);
    const result = _token.map((token2, index) => {
      var _a, _b;
      if (scale === "breakpoints") {
        return getBreakpointValue(theme, token2, (_a = fallbackArr[index]) != null ? _a : token2);
      }
      const path = `${scale}.${token2}`;
      return getTokenValue(theme, path, (_b = fallbackArr[index]) != null ? _b : token2);
    });
    return Array.isArray(token) ? result : result[0];
  };
}


//# sourceMappingURL=chunk-WNDUHNHH.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var dist = __webpack_require__(33179);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-YTQ3XZ3T.mjs
var chunk_YTQ3XZ3T = __webpack_require__(21759);
// EXTERNAL MODULE: ./node_modules/lodash.mergewith/index.js
var lodash_mergewith = __webpack_require__(38554);
// EXTERNAL MODULE: ./node_modules/react-fast-compare/index.js
var react_fast_compare = __webpack_require__(69590);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-TKWR62NH.mjs
'use client'
;

// src/use-style-config.ts





function useStyleConfigImpl(themeKey, props = {}) {
  var _a;
  const { styleConfig: styleConfigProp, ...rest } = props;
  const { theme, colorMode } = chunk_WNDUHNHH_useChakra();
  const themeStyleConfig = themeKey ? (0,chunk_YTQ3XZ3T/* memoizedGet */.Wf)(theme, `components.${themeKey}`) : void 0;
  const styleConfig = styleConfigProp || themeStyleConfig;
  const mergedProps = lodash_mergewith(
    { theme, colorMode },
    (_a = styleConfig == null ? void 0 : styleConfig.defaultProps) != null ? _a : {},
    (0,chunk_YTQ3XZ3T/* filterUndefined */.YU)((0,chunk_YTQ3XZ3T/* omit */.CE)(rest, ["children"]))
  );
  const stylesRef = (0,react.useRef)({});
  if (styleConfig) {
    const getStyles = (0,dist/* resolveStyleConfig */.Ud)(styleConfig);
    const styles = getStyles(mergedProps);
    const isStyleEqual = react_fast_compare(stylesRef.current, styles);
    if (!isStyleEqual) {
      stylesRef.current = styles;
    }
  }
  return stylesRef.current;
}
function useStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useMultiStyleConfig(themeKey, props = {}) {
  return useStyleConfigImpl(themeKey, props);
}
function useComponentStyles__unstable(themeKey, props) {
  var _a;
  const { baseConfig, ...restProps } = props;
  const { theme } = useChakra();
  const overrides = (_a = theme.components) == null ? void 0 : _a[themeKey];
  const styleConfig = overrides ? mergeThemeOverride(overrides, baseConfig) : baseConfig;
  return useStyleConfigImpl(null, {
    ...restProps,
    styleConfig
  });
}


//# sourceMappingURL=chunk-TKWR62NH.mjs.map

/***/ }),

/***/ 48618:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ chakra; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.mjs
var dist = __webpack_require__(33179);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-FDQH4LQI.mjs
'use client'

// src/should-forward-prop.ts
;
var allPropNames = /* @__PURE__ */ new Set([
  ...dist/* propNames */.cC,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]);
var validHTMLProps = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function shouldForwardProp(prop) {
  return validHTMLProps.has(prop) || !allPropNames.has(prop);
}


//# sourceMappingURL=chunk-FDQH4LQI.mjs.map
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chunk-UQDW7KKV.mjs
var chunk_UQDW7KKV = __webpack_require__(92066);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-YTQ3XZ3T.mjs
var chunk_YTQ3XZ3T = __webpack_require__(21759);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-M3TFMUOL.mjs + 1 modules
var chunk_M3TFMUOL = __webpack_require__(36597);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/object-utils/dist/chunk-OLTBUDV5.mjs
var chunk_OLTBUDV5 = __webpack_require__(31009);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(6029);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-5PL47M24.mjs
'use client'
;

// src/system.ts






var _a;
var emotion_styled = (_a = emotion_styled_browser_esm["default"]["default"]) != null ? _a : emotion_styled_browser_esm["default"];
var toCSSObject = ({ baseStyle }) => (props) => {
  const { theme, css: cssProp, __css, sx, ...rest } = props;
  const styleProps = (0,chunk_YTQ3XZ3T/* objectFilter */.lw)(rest, (_, prop) => (0,dist/* isStyleProp */.ZR)(prop));
  const finalBaseStyle = (0,chunk_M3TFMUOL/* runIfFn */.Pu)(baseStyle, props);
  const finalStyles = (0,chunk_OLTBUDV5/* assignAfter */.V)(
    {},
    __css,
    finalBaseStyle,
    (0,chunk_YTQ3XZ3T/* filterUndefined */.YU)(styleProps),
    sx
  );
  const computedCSS = (0,dist/* css */.iv)(finalStyles)(props.theme);
  return cssProp ? [computedCSS, cssProp] : computedCSS;
};
function styled(component, options) {
  const { baseStyle, ...styledOptions } = options != null ? options : {};
  if (!styledOptions.shouldForwardProp) {
    styledOptions.shouldForwardProp = shouldForwardProp;
  }
  const styleObject = toCSSObject({ baseStyle });
  const Component = emotion_styled(
    component,
    styledOptions
  )(styleObject);
  const chakraComponent = react.forwardRef(function ChakraComponent(props, ref) {
    const { colorMode, forced } = (0,chunk_UQDW7KKV/* useColorMode */.If)();
    return react.createElement(Component, {
      ref,
      "data-theme": forced ? colorMode : void 0,
      ...props
    });
  });
  return chakraComponent;
}


//# sourceMappingURL=chunk-5PL47M24.mjs.map
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/system/dist/chunk-ZHQNHOQS.mjs
'use client'
;

// src/factory.ts
function factory() {
  const cache = /* @__PURE__ */ new Map();
  return new Proxy(styled, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(target, thisArg, argArray) {
      return styled(...argArray);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();


//# sourceMappingURL=chunk-ZHQNHOQS.mjs.map

/***/ }),

/***/ 16554:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ forwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client'

// src/forward-ref.tsx
;
function forwardRef(component) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(component);
}


//# sourceMappingURL=chunk-ZJJGQIVY.mjs.map

/***/ }),

/***/ 36597:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v0": function() { return /* binding */ callAllHandlers; },
  "Pu": function() { return /* binding */ runIfFn; }
});

// UNUSED EXPORTS: callAll, compose, distance, error, noop, once, pipe, warn

;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-Y5FGD7DM.mjs
// src/assertion.ts
function chunk_Y5FGD7DM_isNumber(value) {
  return typeof value === "number";
}
function isNotNumber(value) {
  return typeof value !== "number" || Number.isNaN(value) || !Number.isFinite(value);
}
function isNumeric(value) {
  return value != null && value - parseFloat(value) + 1 >= 0;
}
function isArray(value) {
  return Array.isArray(value);
}
function isEmptyArray(value) {
  return isArray(value) && value.length === 0;
}
function isFunction(value) {
  return typeof value === "function";
}
function isDefined(value) {
  return typeof value !== "undefined" && value !== void 0;
}
function isUndefined(value) {
  return typeof value === "undefined" || value === void 0;
}
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !isArray(value);
}
function isEmptyObject(value) {
  return isObject(value) && Object.keys(value).length === 0;
}
function isNotEmptyObject(value) {
  return value && !isEmptyObject(value);
}
function isNull(value) {
  return value == null;
}
function isString(value) {
  return Object.prototype.toString.call(value) === "[object String]";
}
function isCssVar(value) {
  return /^var\(--.+\)$/.test(value);
}
function isEmpty(value) {
  if (isArray(value))
    return isEmptyArray(value);
  if (isObject(value))
    return isEmptyObject(value);
  if (value == null || value === "")
    return true;
  return false;
}
var chunk_Y5FGD7DM_DEV_ = (/* unused pure expression or super */ null && ("production" !== "production"));
var __TEST__ = (/* unused pure expression or super */ null && ("production" === "test"));
function isRefObject(val) {
  return "current" in val;
}
function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
}



;// CONCATENATED MODULE: ./node_modules/@chakra-ui/utils/dist/chunk-M3TFMUOL.mjs


// src/function.ts
function runIfFn(valueOrFn, ...args) {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
function callAll(...fns) {
  return function mergedFn(arg) {
    fns.forEach((fn) => {
      fn == null ? void 0 : fn(arg);
    });
  };
}
var compose = (fn1, ...fns) => fns.reduce(
  (f1, f2) => (...args) => f1(f2(...args)),
  fn1
);
function once(fn) {
  let result;
  return function func(...args) {
    if (fn) {
      result = fn.apply(this, args);
      fn = null;
    }
    return result;
  };
}
var noop = () => {
};
var warn = /* @__PURE__ */ (/* unused pure expression or super */ null && (once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.warn(message);
  }
})));
var error = /* @__PURE__ */ (/* unused pure expression or super */ null && (once((options) => () => {
  const { condition, message } = options;
  if (condition && __DEV__) {
    console.error(message);
  }
})));
var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);
var distance1D = (a, b) => Math.abs(a - b);
var isPoint = (point) => "x" in point && "y" in point;
function distance(a, b) {
  if (isNumber(a) && isNumber(b)) {
    return distance1D(a, b);
  }
  if (isPoint(a) && isPoint(b)) {
    const xDelta = distance1D(a.x, b.x);
    const yDelta = distance1D(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
  }
  return 0;
}




/***/ }),

/***/ 21759:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "Wf": function() { return /* binding */ memoizedGet; },
/* harmony export */   "YU": function() { return /* binding */ filterUndefined; },
/* harmony export */   "lw": function() { return /* binding */ objectFilter; }
/* harmony export */ });
/* unused harmony exports pick, split, get, memoize, getWithDefault, objectKeys, fromEntries, getCSSVar */
/* harmony import */ var lodash_mergewith__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38554);
// src/object.ts

function omit(object, keys) {
  const result = {};
  Object.keys(object).forEach((key) => {
    if (keys.includes(key))
      return;
    result[key] = object[key];
  });
  return result;
}
function pick(object, keys) {
  const result = {};
  keys.forEach((key) => {
    if (key in object) {
      result[key] = object[key];
    }
  });
  return result;
}
function split(object, keys) {
  const picked = {};
  const omitted = {};
  Object.keys(object).forEach((key) => {
    if (keys.includes(key)) {
      picked[key] = object[key];
    } else {
      omitted[key] = object[key];
    }
  });
  return [picked, omitted];
}
function get(obj, path, fallback, index) {
  const key = typeof path === "string" ? path.split(".") : [path];
  for (index = 0; index < key.length; index += 1) {
    if (!obj)
      break;
    obj = obj[key[index]];
  }
  return obj === void 0 ? fallback : obj;
}
var memoize = (fn) => {
  const cache = /* @__PURE__ */ new WeakMap();
  const memoizedFn = (obj, path, fallback, index) => {
    if (typeof obj === "undefined") {
      return fn(obj, path, fallback);
    }
    if (!cache.has(obj)) {
      cache.set(obj, /* @__PURE__ */ new Map());
    }
    const map = cache.get(obj);
    if (map.has(path)) {
      return map.get(path);
    }
    const value = fn(obj, path, fallback, index);
    map.set(path, value);
    return value;
  };
  return memoizedFn;
};
var memoizedGet = memoize(get);
function getWithDefault(path, scale) {
  return memoizedGet(scale, path, path);
}
function objectFilter(object, fn) {
  const result = {};
  Object.keys(object).forEach((key) => {
    const value = object[key];
    const shouldPass = fn(value, key, object);
    if (shouldPass) {
      result[key] = value;
    }
  });
  return result;
}
var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);
var objectKeys = (obj) => Object.keys(obj);
var fromEntries = (entries) => entries.reduce((carry, [key, value]) => {
  carry[key] = value;
  return carry;
}, {});
var getCSSVar = (theme, scale, value) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme.__cssMap) == null ? void 0 : _a[`${scale}.${value}`]) == null ? void 0 : _b.varRef) != null ? _c : value;
};




/***/ }),

/***/ 23636:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse$1; },
/* harmony export */   "qv": function() { return /* binding */ icon; },
/* harmony export */   "vI": function() { return /* binding */ library$1; }
/* harmony export */ });
/* unused harmony exports noAuto, config, dom, findIconDefinition, toHtml, layer, text, counter, api */
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}

const noop = () => {};
let _WINDOW = {};
let _DOCUMENT = {};
let _MUTATION_OBSERVER = null;
let _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}
const {
  userAgent = ''
} = _WINDOW.navigator || {};
const WINDOW = _WINDOW;
const DOCUMENT = _DOCUMENT;
const MUTATION_OBSERVER = _MUTATION_OBSERVER;
const PERFORMANCE = _PERFORMANCE;
const IS_BROWSER = !!WINDOW.document;
const IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
const IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var p = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/,
  g = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
var S = {
    classic: {
      fa: "solid",
      fas: "solid",
      "fa-solid": "solid",
      far: "regular",
      "fa-regular": "regular",
      fal: "light",
      "fa-light": "light",
      fat: "thin",
      "fa-thin": "thin",
      fab: "brands",
      "fa-brands": "brands"
    },
    duotone: {
      fa: "solid",
      fad: "solid",
      "fa-solid": "solid",
      "fa-duotone": "solid",
      fadr: "regular",
      "fa-regular": "regular",
      fadl: "light",
      "fa-light": "light",
      fadt: "thin",
      "fa-thin": "thin"
    },
    sharp: {
      fa: "solid",
      fass: "solid",
      "fa-solid": "solid",
      fasr: "regular",
      "fa-regular": "regular",
      fasl: "light",
      "fa-light": "light",
      fast: "thin",
      "fa-thin": "thin"
    },
    "sharp-duotone": {
      fa: "solid",
      fasds: "solid",
      "fa-solid": "solid",
      fasdr: "regular",
      "fa-regular": "regular",
      fasdl: "light",
      "fa-light": "light",
      fasdt: "thin",
      "fa-thin": "thin"
    }
  },
  A = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  P = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"];
var s = "classic",
  t = "duotone",
  r = "sharp",
  o = "sharp-duotone",
  L = [s, t, r, o];
var G = {
    classic: {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal",
      100: "fat"
    },
    duotone: {
      900: "fad",
      400: "fadr",
      300: "fadl",
      100: "fadt"
    },
    sharp: {
      900: "fass",
      400: "fasr",
      300: "fasl",
      100: "fast"
    },
    "sharp-duotone": {
      900: "fasds",
      400: "fasdr",
      300: "fasdl",
      100: "fasdt"
    }
  };
var lt = {
    "Font Awesome 6 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 6 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal",
      100: "fat"
    },
    "Font Awesome 6 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 6 Duotone": {
      900: "fad",
      400: "fadr",
      normal: "fadr",
      300: "fadl",
      100: "fadt"
    },
    "Font Awesome 6 Sharp": {
      900: "fass",
      400: "fasr",
      normal: "fasr",
      300: "fasl",
      100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
      900: "fasds",
      400: "fasdr",
      normal: "fasdr",
      300: "fasdl",
      100: "fasdt"
    }
  };
var pt = new Map([["classic", {
    defaultShortPrefixId: "fas",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin", "brands"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp", {
    defaultShortPrefixId: "fass",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["duotone", {
    defaultShortPrefixId: "fad",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }], ["sharp-duotone", {
    defaultShortPrefixId: "fasds",
    defaultStyleId: "solid",
    styleIds: ["solid", "regular", "light", "thin"],
    futureStyleIds: [],
    defaultFontWeight: 900
  }]]),
  xt = {
    classic: {
      solid: "fas",
      regular: "far",
      light: "fal",
      thin: "fat",
      brands: "fab"
    },
    duotone: {
      solid: "fad",
      regular: "fadr",
      light: "fadl",
      thin: "fadt"
    },
    sharp: {
      solid: "fass",
      regular: "fasr",
      light: "fasl",
      thin: "fast"
    },
    "sharp-duotone": {
      solid: "fasds",
      regular: "fasdr",
      light: "fasdl",
      thin: "fasdt"
    }
  };
var Ft = ["fak", "fa-kit", "fakd", "fa-kit-duotone"],
  St = {
    kit: {
      fak: "kit",
      "fa-kit": "kit"
    },
    "kit-duotone": {
      fakd: "kit-duotone",
      "fa-kit-duotone": "kit-duotone"
    }
  },
  At = ["kit"];
var Ct = {
  kit: {
    "fa-kit": "fak"
  },
  "kit-duotone": {
    "fa-kit-duotone": "fakd"
  }
};
var Lt = ["fak", "fakd"],
  Wt = {
    kit: {
      fak: "fa-kit"
    },
    "kit-duotone": {
      fakd: "fa-kit-duotone"
    }
  };
var Et = {
    kit: {
      kit: "fak"
    },
    "kit-duotone": {
      "kit-duotone": "fakd"
    }
  };

var t$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
  },
  r$1 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"];
var bt$1 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"];
var Yt = {
    "Font Awesome Kit": {
      400: "fak",
      normal: "fak"
    },
    "Font Awesome Kit Duotone": {
      400: "fakd",
      normal: "fakd"
    }
  };
var ua = {
    classic: {
      "fa-brands": "fab",
      "fa-duotone": "fad",
      "fa-light": "fal",
      "fa-regular": "far",
      "fa-solid": "fas",
      "fa-thin": "fat"
    },
    duotone: {
      "fa-regular": "fadr",
      "fa-light": "fadl",
      "fa-thin": "fadt"
    },
    sharp: {
      "fa-solid": "fass",
      "fa-regular": "fasr",
      "fa-light": "fasl",
      "fa-thin": "fast"
    },
    "sharp-duotone": {
      "fa-solid": "fasds",
      "fa-regular": "fasdr",
      "fa-light": "fasdl",
      "fa-thin": "fasdt"
    }
  },
  I$1 = {
    classic: ["fas", "far", "fal", "fat", "fad"],
    duotone: ["fadr", "fadl", "fadt"],
    sharp: ["fass", "fasr", "fasl", "fast"],
    "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
  },
  ga = {
    classic: {
      fab: "fa-brands",
      fad: "fa-duotone",
      fal: "fa-light",
      far: "fa-regular",
      fas: "fa-solid",
      fat: "fa-thin"
    },
    duotone: {
      fadr: "fa-regular",
      fadl: "fa-light",
      fadt: "fa-thin"
    },
    sharp: {
      fass: "fa-solid",
      fasr: "fa-regular",
      fasl: "fa-light",
      fast: "fa-thin"
    },
    "sharp-duotone": {
      fasds: "fa-solid",
      fasdr: "fa-regular",
      fasdl: "fa-light",
      fasdt: "fa-thin"
    }
  },
  x = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"],
  Ia = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...r$1, ...x],
  m$1 = ["solid", "regular", "light", "thin", "duotone", "brands"],
  c$1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  F$1 = c$1.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
  ma = [...Object.keys(I$1), ...m$1, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", t$1.GROUP, t$1.SWAP_OPACITY, t$1.PRIMARY, t$1.SECONDARY].concat(c$1.map(a => "".concat(a, "x"))).concat(F$1.map(a => "w-".concat(a)));
var wa = {
    "Font Awesome 5 Free": {
      900: "fas",
      400: "far"
    },
    "Font Awesome 5 Pro": {
      900: "fas",
      400: "far",
      normal: "far",
      300: "fal"
    },
    "Font Awesome 5 Brands": {
      400: "fab",
      normal: "fab"
    },
    "Font Awesome 5 Duotone": {
      900: "fad"
    }
  };

const NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
const UNITS_IN_GRID = 16;
const DEFAULT_CSS_PREFIX = 'fa';
const DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
const DATA_FA_I2SVG = 'data-fa-i2svg';
const DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
const DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
const DATA_PREFIX = 'data-prefix';
const DATA_ICON = 'data-icon';
const HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
const MUTATION_APPROACH_ASYNC = 'async';
const TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
const PRODUCTION = (() => {
  try {
    return "production" === 'production';
  } catch (e$$1) {
    return false;
  }
})();
function familyProxy(obj) {
  // Defaults to the classic family if family is not available
  return new Proxy(obj, {
    get(target, prop) {
      return prop in target ? target[prop] : target[s];
    }
  });
}
const _PREFIX_TO_STYLE = _objectSpread2({}, S);

// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
_PREFIX_TO_STYLE[s] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
  'fa-duotone': 'duotone'
}), S[s]), St['kit']), St['kit-duotone']);
const PREFIX_TO_STYLE = familyProxy(_PREFIX_TO_STYLE);
const _STYLE_TO_PREFIX = _objectSpread2({}, xt);

// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
_STYLE_TO_PREFIX[s] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
  duotone: 'fad'
}), _STYLE_TO_PREFIX[s]), Et['kit']), Et['kit-duotone']);
const STYLE_TO_PREFIX = familyProxy(_STYLE_TO_PREFIX);
const _PREFIX_TO_LONG_STYLE = _objectSpread2({}, ga);
_PREFIX_TO_LONG_STYLE[s] = _objectSpread2(_objectSpread2({}, _PREFIX_TO_LONG_STYLE[s]), Wt['kit']);
const PREFIX_TO_LONG_STYLE = familyProxy(_PREFIX_TO_LONG_STYLE);
const _LONG_STYLE_TO_PREFIX = _objectSpread2({}, ua);
_LONG_STYLE_TO_PREFIX[s] = _objectSpread2(_objectSpread2({}, _LONG_STYLE_TO_PREFIX[s]), Ct['kit']);
const LONG_STYLE_TO_PREFIX = familyProxy(_LONG_STYLE_TO_PREFIX);
const ICON_SELECTION_SYNTAX_PATTERN = p; // eslint-disable-line no-useless-escape

const LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
const FONT_FAMILY_PATTERN = g;
const _FONT_WEIGHT_TO_PREFIX = _objectSpread2({}, G);
const FONT_WEIGHT_TO_PREFIX = familyProxy(_FONT_WEIGHT_TO_PREFIX);
const ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
const DUOTONE_CLASSES = A;
const RESERVED_CLASSES = [...At, ...ma];

const initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  const attrs = [['data-family-prefix', 'familyPrefix'], ['data-css-prefix', 'cssPrefix'], ['data-family-default', 'familyDefault'], ['data-style-default', 'styleDefault'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(_ref => {
    let [attr, key] = _ref;
    const val = coerce(getAttrConfig(attr));
    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}
const _default = {
  styleDefault: 'solid',
  familyDefault: s,
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

// familyPrefix is deprecated but we must still support it if present
if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}
const _config = _objectSpread2(_objectSpread2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
const config = {};
Object.keys(_default).forEach(key => {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function (val) {
      _config[key] = val;
      _onChangeCb.forEach(cb => cb(config));
    },
    get: function () {
      return _config[key];
    }
  });
});

// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty(config, 'familyPrefix', {
  enumerable: true,
  set: function (val) {
    _config.cssPrefix = val;
    _onChangeCb.forEach(cb => cb(config));
  },
  get: function () {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
const _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);
  return () => {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}

const d$2 = UNITS_IN_GRID;
const meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }
  const style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  const headChildren = DOCUMENT.head.childNodes;
  let beforeChild = null;
  for (let i = headChildren.length - 1; i > -1; i--) {
    const child = headChildren[i];
    const tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
const idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  let size = 12;
  let id = '';
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function toArray(obj) {
  const array = [];
  for (let i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }
  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(i => i);
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce((acc, attributeName) => {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce((acc, styleName) => {
    return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  let {
    transform,
    containerWidth,
    iconWidth
  } = _ref;
  const outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  const inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  const path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path
  };
}
function transformForCss(_ref2) {
  let {
    transform,
    width = UNITS_IN_GRID,
    height = UNITS_IN_GRID,
    startCentered = false
  } = _ref2;
  let val = '';
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d$2 - width / 2, "em, ").concat(transform.y / d$2 - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d$2, "em), calc(-50% + ").concat(transform.y / d$2, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d$2, "em, ").concat(transform.y / d$2, "em) ");
  }
  val += "scale(".concat(transform.size / d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d$2 * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}

var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 6 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 6 Sharp Duotone\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}";

function css() {
  const dcp = DEFAULT_CSS_PREFIX;
  const drc = DEFAULT_REPLACEMENT_CLASS;
  const fp = config.cssPrefix;
  const rc = config.replacementClass;
  let s = baseStyles;
  if (fp !== dcp || rc !== drc) {
    const dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
    const customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
    const rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s;
}
let _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg() {
        ensureCss();
      }
    };
  }
};

const w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

const functions = [];
const listener = function () {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(fn => fn());
};
let loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}
function domready (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}

function toHtml(abstractNodes) {
  const {
    tag,
    attributes = {},
    children = []
  } = abstractNodes;
  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */
var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
    length = keys.length,
    iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
    i,
    key,
    result;
  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }
  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};

/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

function ucs2decode(string) {
  const output = [];
  let counter = 0;
  const length = string.length;
  while (counter < length) {
    const value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      const extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) {
        // eslint-disable-line eqeqeq
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  const decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
  const size = string.length;
  let first = string.charCodeAt(index);
  let second;
  if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
    second = string.charCodeAt(index + 1);
    if (second >= 0xDC00 && second <= 0xDFFF) {
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }
  return first;
}

function normalizeIcons(icons) {
  return Object.keys(icons).reduce((acc, iconName) => {
    const icon = icons[iconName];
    const expanded = !!icon.icon;
    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});
}
function defineIcons(prefix, icons) {
  let params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    skipHooks = false
  } = params;
  const normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }

  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */
  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

const duotonePathRe = [/*#__PURE__*/_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
  d1: 1,
  d2: 2
}), /*#__PURE__*/_wrapRegExp(/path class="([^"]+)".*d="([^"]+)".*path class="([^"]+)".*d="([^"]+)"/, {
  cls1: 1,
  d1: 2,
  cls2: 3,
  d2: 4
}), /*#__PURE__*/_wrapRegExp(/path class="([^"]+)".*d="([^"]+)"/, {
  cls1: 1,
  d1: 2
})];

const {
  styles,
  shims
} = namespace;
const FAMILY_NAMES = Object.keys(PREFIX_TO_LONG_STYLE);
const PREFIXES_FOR_FAMILY = FAMILY_NAMES.reduce((acc, familyId) => {
  acc[familyId] = Object.keys(PREFIX_TO_LONG_STYLE[familyId]);
  return acc;
}, {});
let _defaultUsablePrefix = null;
let _byUnicode = {};
let _byLigature = {};
let _byOldName = {};
let _byOldUnicode = {};
let _byAlias = {};
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(cssPrefix, cls) {
  const parts = cls.split('-');
  const prefix = parts[0];
  const iconName = parts.slice(1).join('-');
  if (prefix === cssPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
const build = () => {
  const lookup = reducer => {
    return reduce(styles, (o$$1, style, prefix) => {
      o$$1[prefix] = reduce(style, reducer, {});
      return o$$1;
    }, {});
  };
  _byUnicode = lookup((acc, icon, iconName) => {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }
    if (icon[2]) {
      const aliases = icon[2].filter(a$$1 => {
        return typeof a$$1 === 'number';
      });
      aliases.forEach(alias => {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup((acc, icon, iconName) => {
    acc[iconName] = iconName;
    if (icon[2]) {
      const aliases = icon[2].filter(a$$1 => {
        return typeof a$$1 === 'string';
      });
      aliases.forEach(alias => {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup((acc, icon, iconName) => {
    const aliases = icon[2];
    acc[iconName] = iconName;
    aliases.forEach(alias => {
      acc[alias] = iconName;
    });
    return acc;
  });

  // If we have a Kit, we can't determine if regular is available since we
  // could be auto-fetching it. We'll have to assume that it is available.
  const hasRegular = 'far' in styles || config.autoFetchSvg;
  const shimLookups = reduce(shims, (acc, shim) => {
    const maybeNameMaybeUnicode = shim[0];
    let prefix = shim[1];
    const iconName = shim[2];
    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }
    if (typeof maybeNameMaybeUnicode === 'string') {
      acc.names[maybeNameMaybeUnicode] = {
        prefix,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === 'number') {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(c$$1 => {
  _defaultUsablePrefix = getCanonicalPrefix(c$$1.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  const oldUnicode = _byOldUnicode[unicode];
  const newUnicode = byUnicode('fas', unicode);
  return oldUnicode || (newUnicode ? {
    prefix: 'fas',
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
const emptyCanonicalIcon = () => {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getFamilyId(values) {
  let family = s;
  const famProps = FAMILY_NAMES.reduce((acc, familyId) => {
    acc[familyId] = "".concat(config.cssPrefix, "-").concat(familyId);
    return acc;
  }, {});
  L.forEach(familyId => {
    if (values.includes(famProps[familyId]) || values.some(v$$1 => PREFIXES_FOR_FAMILY[familyId].includes(v$$1))) {
      family = familyId;
    }
  });
  return family;
}
function getCanonicalPrefix(styleOrPrefix) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    family = s
  } = params;
  const style = PREFIX_TO_STYLE[family][styleOrPrefix];

  // handles the exception of passing in only a family of 'duotone' with no style
  if (family === t && !styleOrPrefix) {
    return 'fad';
  }
  const prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  const defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  const result = prefix || defined || null;
  return result;
}
function moveNonFaClassesToRest(classNames) {
  let rest = [];
  let iconName = null;
  classNames.forEach(cls => {
    const result = getIconName(config.cssPrefix, cls);
    if (result) {
      iconName = result;
    } else if (cls) {
      rest.push(cls);
    }
  });
  return {
    iconName,
    rest
  };
}
function sortedUniqueValues(arr) {
  return arr.sort().filter((value, index, arr) => {
    return arr.indexOf(value) === index;
  });
}
function getCanonicalIcon(values) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    skipLookups = false
  } = params;
  let givenPrefix = null;
  const faCombinedClasses = Ia.concat(bt$1);
  const faStyleOrFamilyClasses = sortedUniqueValues(values.filter(cls => faCombinedClasses.includes(cls)));
  const nonStyleOrFamilyClasses = sortedUniqueValues(values.filter(cls => !Ia.includes(cls)));
  const faStyles = faStyleOrFamilyClasses.filter(cls => {
    givenPrefix = cls;
    return !P.includes(cls);
  });
  const [styleFromValues = null] = faStyles;
  const family = getFamilyId(faStyleOrFamilyClasses);
  const canonical = _objectSpread2(_objectSpread2({}, moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
    prefix: getCanonicalPrefix(styleFromValues, {
      family
    })
  });
  return _objectSpread2(_objectSpread2(_objectSpread2({}, canonical), getDefaultCanonicalPrefix({
    values,
    family,
    styles,
    config,
    canonical,
    givenPrefix
  })), applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function applyShimAndAlias(skipLookups, givenPrefix, canonical) {
  let {
    prefix,
    iconName
  } = canonical;
  if (skipLookups || !prefix || !iconName) {
    return {
      prefix,
      iconName
    };
  }
  const shim = givenPrefix === 'fa' ? byOldName(iconName) : {};
  const aliasIconName = byAlias(prefix, iconName);
  iconName = shim.iconName || aliasIconName || iconName;
  prefix = shim.prefix || prefix;
  if (prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) {
    // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
  }
  return {
    prefix,
    iconName
  };
}
const newCanonicalFamilies = L.filter(familyId => {
  return familyId !== s || familyId !== t;
});
const newCanonicalStyles = Object.keys(ga).filter(key => key !== s).map(key => Object.keys(ga[key])).flat();
function getDefaultCanonicalPrefix(prefixOptions) {
  const {
    values,
    family,
    canonical,
    givenPrefix = '',
    styles = {},
    config: config$$1 = {}
  } = prefixOptions;
  const isDuotoneFamily = family === t;
  const valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
  const defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
  const canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
  if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) {
    canonical.prefix = 'fad';
  }
  if (values.includes('fa-brands') || values.includes('fab')) {
    canonical.prefix = 'fab';
  }
  if (!canonical.prefix && newCanonicalFamilies.includes(family)) {
    const validPrefix = Object.keys(styles).find(key => newCanonicalStyles.includes(key));
    if (validPrefix || config$$1.autoFetchSvg) {
      const defaultPrefix = pt.get(family).defaultShortPrefixId;
      canonical.prefix = defaultPrefix;
      canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
  }
  if (canonical.prefix === 'fa' || givenPrefix === 'fa') {
    // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
  }
  return canonical;
}

class Library {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
      definitions[_key] = arguments[_key];
    }
    const additions = definitions.reduce(this._pullDefinitions, {});
    Object.keys(additions).forEach(key => {
      this.definitions[key] = _objectSpread2(_objectSpread2({}, this.definitions[key] || {}), additions[key]);
      defineIcons(key, additions[key]);

      // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
      const longPrefix = PREFIX_TO_LONG_STYLE[s][key];
      if (longPrefix) defineIcons(longPrefix, additions[key]);
      build();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(additions, definition) {
    const normalized = definition.prefix && definition.iconName && definition.icon ? {
      0: definition
    } : definition;
    Object.keys(normalized).map(key => {
      const {
        prefix,
        iconName,
        icon
      } = normalized[key];
      const aliases = icon[2];
      if (!additions[prefix]) additions[prefix] = {};
      if (aliases.length > 0) {
        aliases.forEach(alias => {
          if (typeof alias === 'string') {
            additions[prefix][alias] = icon;
          }
        });
      }
      additions[prefix][iconName] = icon;
    });
    return additions;
  }
}

let _plugins = [];
let _hooks = {};
const providers = {};
const defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
  let {
    mixoutsTo: obj
  } = _ref;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(k => {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });
  _plugins.forEach(plugin => {
    const mixout = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout).forEach(tk => {
      if (typeof mixout[tk] === 'function') {
        obj[tk] = mixout[tk];
      }
      if (typeof mixout[tk] === 'object') {
        Object.keys(mixout[tk]).forEach(sk => {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      const hooks = plugin.hooks();
      Object.keys(hooks).forEach(hook => {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }
        _hooks[hook].push(hooks[hook]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  const hookFns = _hooks[hook] || [];
  hookFns.forEach(hookFn => {
    accumulator = hookFn.apply(null, [accumulator, ...args]); // eslint-disable-line no-useless-call
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  const hookFns = _hooks[hook] || [];
  hookFns.forEach(hookFn => {
    hookFn.apply(null, args);
  });
  return undefined;
}
function callProvided() {
  const hook = arguments[0];
  const args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : undefined;
}

function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === 'fa') {
    iconLookup.prefix = 'fas';
  }
  let {
    iconName
  } = iconLookup;
  const prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
const library = new Library();
const noAuto = () => {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks('noAuto');
};
const dom = {
  i2svg: function () {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (IS_DOM) {
      callHooks('beforeI2svg', params);
      callProvided('pseudoElements2svg', params);
      return callProvided('i2svg', params);
    } else {
      return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    }
  },
  watch: function () {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      autoReplaceSvgRoot
    } = params;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(() => {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks('watch', params);
    });
  }
};
const parse = {
  icon: icon => {
    if (icon === null) {
      return null;
    }
    if (typeof icon === 'object' && icon.prefix && icon.iconName) {
      return {
        prefix: icon.prefix,
        iconName: byAlias(icon.prefix, icon.iconName) || icon.iconName
      };
    }
    if (Array.isArray(icon) && icon.length === 2) {
      const iconName = icon[1].indexOf('fa-') === 0 ? icon[1].slice(3) : icon[1];
      const prefix = getCanonicalPrefix(icon[0]);
      return {
        prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }
    if (typeof icon === 'string' && (icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      const canonicalIcon = getCanonicalIcon(icon.split(' '), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof icon === 'string') {
      const prefix = getDefaultUsablePrefix();
      return {
        prefix,
        iconName: byAlias(prefix, icon) || icon
      };
    }
  }
};
const api = {
  noAuto,
  config,
  dom,
  parse,
  library,
  findIconDefinition,
  toHtml
};
const autoReplace = function () {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    autoReplaceSvgRoot = DOCUMENT
  } = params;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};

function domVariants(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function () {
      return val.abstract.map(a => toHtml(a));
    }
  });
  Object.defineProperty(val, 'node', {
    get: function () {
      if (!IS_DOM) return;
      const container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function asIcon (_ref) {
  let {
    children,
    main,
    mask,
    attributes,
    styles,
    transform
  } = _ref;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    const {
      width,
      height
    } = main;
    const offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: 'svg',
    attributes,
    children
  }];
}

function asSymbol (_ref) {
  let {
    prefix,
    iconName,
    children,
    attributes,
    symbol
  } = _ref;
  const id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id
      }),
      children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  const {
    icons: {
      main,
      mask
    },
    prefix,
    iconName,
    transform,
    symbol,
    title,
    maskId,
    titleId,
    extra,
    watchable = false
  } = params;
  const {
    width,
    height
  } = mask.found ? mask : main;
  const isUploadedIcon = Lt.includes(prefix);
  const attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ''].filter(c$$1 => extra.classes.indexOf(c$$1) === -1).filter(c$$1 => c$$1 !== '' || !!c$$1).concat(extra.classes).join(' ');
  let content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  const uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }
  if (title) {
    content.children.push({
      tag: 'title',
      attributes: {
        id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }
  const args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix,
    iconName,
    main,
    mask,
    maskId,
    transform,
    symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });
  const {
    children,
    attributes
  } = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
    children: [],
    attributes: {}
  } : callProvided('generateAbstractIcon', args) || {
    children: [],
    attributes: {}
  };
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  const {
    content,
    width,
    height,
    transform,
    title,
    extra,
    watchable = false
  } = params;
  const attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }
  const styles = _objectSpread2({}, extra.styles);
  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({
      transform,
      startCentered: true,
      width,
      height
    });
    styles['-webkit-transform'] = styles['transform'];
  }
  const styleString = joinStyles(styles);
  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }
  const val = [];
  val.push({
    tag: 'span',
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  const {
    content,
    title,
    extra
  } = params;
  const attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    'title': title
  } : {}), {}, {
    'class': extra.classes.join(' ')
  });
  const styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }
  const val = [];
  val.push({
    tag: 'span',
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: 'span',
      attributes: {
        class: 'sr-only'
      },
      children: [title]
    });
  }
  return val;
}

const {
  styles: styles$1
} = namespace;
function asFoundIcon(icon) {
  const width = icon[0];
  const height = icon[1];
  const [vectorData] = icon.slice(4);
  let element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
const missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
  }
}
function findIcon(iconName, prefix) {
  let givenPrefix = prefix;
  if (prefix === 'fa' && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }
  return new Promise((resolve, reject) => {
    if (givenPrefix === 'fa') {
      const shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }
    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      const icon = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon));
    }
    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
    }));
  });
}

const noop$1 = () => {};
const p$2 = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
const preamble = "FA \"6.7.2\"";
const begin = name => {
  p$2.mark("".concat(preamble, " ").concat(name, " begins"));
  return () => end(name);
};
const end = name => {
  p$2.mark("".concat(preamble, " ").concat(name, " ends"));
  p$2.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};

const noop$2 = () => {};
function isWatched(node) {
  const i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg === 'string';
}
function hasPrefixAndIcon(node) {
  const prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  const icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon;
}
function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  const mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function createElement(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    ceFn = abstractObj.tag === 'svg' ? createElementNS : createElement
  } = params;
  if (typeof abstractObj === 'string') {
    return DOCUMENT.createTextNode(abstractObj);
  }
  const tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function (key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  const children = abstractObj.children || [];
  children.forEach(function (child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node) {
  let comment = " ".concat(node.outerHTML, " ");
  /* BEGIN.ATTRIBUTION */
  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  /* END.ATTRIBUTION */
  return comment;
}
const mutators = {
  replace: function (mutation) {
    const node = mutation[0];
    if (node.parentNode) {
      mutation[1].forEach(abstract => {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });
      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        let comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function (mutation) {
    const node = mutation[0];
    const abstract = mutation[1];

    // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    const forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete abstract[0].attributes.id;
    if (abstract[0].attributes.class) {
      const splitClasses = abstract[0].attributes.class.split(' ').reduce((acc, cls) => {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(' ');
      if (splitClasses.toNode.length === 0) {
        node.removeAttribute('class');
      } else {
        node.setAttribute('class', splitClasses.toNode.join(' '));
      }
    }
    const newInnerHTML = abstract.map(a => toHtml(a)).join('\n');
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback) {
  const callbackFunction = typeof callback === 'function' ? callback : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    let frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(() => {
      const mutator = getMutator();
      const mark = perf.begin('mutate');
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
let disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
let mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  const {
    treeCallback = noop$2,
    nodeCallback = noop$2,
    pseudoElementsCallback = noop$2,
    observeMutationsRoot = DOCUMENT
  } = options;
  mo = new MUTATION_OBSERVER(objects => {
    if (disabled) return;
    const defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(mutationRecord => {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
          const {
            prefix,
            iconName
          } = getCanonicalIcon(classArray(mutationRecord.target));
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}

function styleParser (node) {
  const style = node.getAttribute('style');
  let val = [];
  if (style) {
    val = style.split(';').reduce((acc, style) => {
      const styles = style.split(':');
      const prop = styles[0];
      const value = styles.slice(1);
      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }
      return acc;
    }, {});
  }
  return val;
}

function classParser (node) {
  const existingPrefix = node.getAttribute('data-prefix');
  const existingIconName = node.getAttribute('data-icon');
  const innerText = node.innerText !== undefined ? node.innerText.trim() : '';
  let val = getCanonicalIcon(classArray(node));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }
  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }
  return val;
}

function attributesParser (node) {
  const extraAttributes = toArray(node.attributes).reduce((acc, attr) => {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  const title = node.getAttribute('title');
  const titleId = node.getAttribute('data-fa-title-id');
  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes['aria-hidden'] = 'true';
      extraAttributes['focusable'] = 'false';
    }
  }
  return extraAttributes;
}

function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  let parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    styleParser: true
  };
  const {
    iconName,
    prefix,
    rest: extraClasses
  } = classParser(node);
  const extraAttributes = attributesParser(node);
  const pluginMeta = chainHooks('parseNodeAttributes', {}, node);
  let extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName,
    title: node.getAttribute('title'),
    titleId: node.getAttribute('data-fa-title-id'),
    prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}

const {
  styles: styles$2
} = namespace;
function generateMutation(node) {
  const nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided('generateLayersText', node, nodeMeta);
  } else {
    return callProvided('generateSvgReplacementMutation', node, nodeMeta);
  }
}
function getKnownPrefixes() {
  return [...Ft, ...Ia];
}
function onTree(root) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  const htmlClassList = DOCUMENT.documentElement.classList;
  const hclAdd = suffix => htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  const hclRemove = suffix => htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  const prefixes = config.autoFetchSvg ? getKnownPrefixes() : P.concat(Object.keys(styles$2));
  if (!prefixes.includes('fa')) {
    prefixes.push('fa');
  }
  const prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(p$$1 => ".".concat(p$$1, ":not([").concat(DATA_FA_I2SVG, "])"))).join(', ');
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  let candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e$$1) {
    // noop
  }
  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return Promise.resolve();
  }
  const mark = perf.begin('onTree');
  const mutations = candidates.reduce((acc, node) => {
    try {
      const mutation = generateMutation(node);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e$$1) {
      if (!PRODUCTION) {
        if (e$$1.name === 'MissingIcon') {
          console.error(e$$1);
        }
      }
    }
    return acc;
  }, []);
  return new Promise((resolve, reject) => {
    Promise.all(mutations).then(resolvedMutations => {
      perform(resolvedMutations, () => {
        hclAdd('active');
        hclAdd('complete');
        hclRemove('pending');
        if (typeof callback === 'function') callback();
        mark();
        resolve();
      });
    }).catch(e$$1 => {
      mark();
      reject(e$$1);
    });
  });
}
function onNode(node) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  generateMutation(node).then(mutation => {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}
function resolveIcons(next) {
  return function (maybeIconDefinition) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    let {
      mask
    } = params;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask
    }));
  };
}
const render = function (iconDefinition) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    transform = meaninglessTransform,
    symbol = false,
    mask = null,
    maskId = null,
    title = null,
    titleId = null,
    classes = [],
    attributes = {},
    styles = {}
  } = params;
  if (!iconDefinition) return;
  const {
    prefix,
    iconName,
    icon
  } = iconDefinition;
  return domVariants(_objectSpread2({
    type: 'icon'
  }, iconDefinition), () => {
    callHooks('beforeDOMElementCreation', {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol,
      title,
      maskId,
      titleId,
      extra: {
        attributes,
        styles,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides(providers$$1) {
    providers$$1.i2svg = function (params) {
      const {
        node = DOCUMENT,
        callback = () => {}
      } = params;
      return onTree(node, callback);
    };
    providers$$1.generateSvgReplacementMutation = function (node, nodeMeta) {
      const {
        iconName,
        title,
        titleId,
        prefix,
        transform,
        symbol,
        mask,
        maskId,
        extra
      } = nodeMeta;
      return new Promise((resolve, reject) => {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(_ref => {
          let [main, mask] = _ref;
          resolve([node, makeInlineSvgAbstract({
            icons: {
              main,
              mask
            },
            prefix,
            iconName,
            transform,
            symbol,
            maskId,
            title,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };
    providers$$1.generateAbstractIcon = function (_ref2) {
      let {
        children,
        attributes,
        main,
        transform,
        styles
      } = _ref2;
      const styleString = joinStyles(styles);
      if (styleString.length > 0) {
        attributes['style'] = styleString;
      }
      let nextChild;
      if (transformIsMeaningful(transform)) {
        nextChild = callProvided('generateAbstractTransformGrouping', {
          main,
          transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};

var Layers = {
  mixout() {
    return {
      layer(assembler) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          classes = []
        } = params;
        return domVariants({
          type: 'layer'
        }, () => {
          callHooks('beforeDOMElementCreation', {
            assembler,
            params
          });
          let children = [];
          assembler(args => {
            Array.isArray(args) ? args.map(a => {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: 'span',
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers"), ...classes].join(' ')
            },
            children
          }];
        });
      }
    };
  }
};

var LayersCounter = {
  mixout() {
    return {
      counter(content) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          title = null,
          classes = [],
          attributes = {},
          styles = {}
        } = params;
        return domVariants({
          type: 'counter',
          content
        }, () => {
          callHooks('beforeDOMElementCreation', {
            content,
            params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title,
            extra: {
              attributes,
              styles,
              classes: ["".concat(config.cssPrefix, "-layers-counter"), ...classes]
            }
          });
        });
      }
    };
  }
};

var LayersText = {
  mixout() {
    return {
      text(content) {
        let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          transform = meaninglessTransform,
          title = null,
          classes = [],
          attributes = {},
          styles = {}
        } = params;
        return domVariants({
          type: 'text',
          content
        }, () => {
          callHooks('beforeDOMElementCreation', {
            content,
            params
          });
          return makeLayersTextAbstract({
            content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title,
            extra: {
              attributes,
              styles,
              classes: ["".concat(config.cssPrefix, "-layers-text"), ...classes]
            }
          });
        });
      }
    };
  },
  provides(providers$$1) {
    providers$$1.generateLayersText = function (node, nodeMeta) {
      const {
        title,
        transform,
        extra
      } = nodeMeta;
      let width = null;
      let height = null;
      if (IS_IE) {
        const computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        const boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title) {
        extra.attributes['aria-hidden'] = 'true';
      }
      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width,
        height,
        transform,
        title,
        extra,
        watchable: true
      })]);
    };
  }
};

const CLEAN_CONTENT_PATTERN = new RegExp('\u{22}', 'ug');
const SECONDARY_UNICODE_RANGE = [1105920, 1112319];
const _FONT_FAMILY_WEIGHT_TO_PREFIX = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
  FontAwesome: {
    normal: 'fas',
    400: 'fas'
  }
}), lt), wa), Yt);
const FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys(_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, key) => {
  acc[key.toLowerCase()] = _FONT_FAMILY_WEIGHT_TO_PREFIX[key];
  return acc;
}, {});
const FONT_FAMILY_WEIGHT_FALLBACK = Object.keys(FONT_FAMILY_WEIGHT_TO_PREFIX).reduce((acc, fontFamily) => {
  const weights = FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
  acc[fontFamily] = weights[900] || [...Object.entries(weights)][0][1];
  return acc;
}, {});
function hexValueFromContent(content) {
  const cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
  const codePoint = codePointAt(cleaned, 0);
  const isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  const isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function getPrefix(fontFamily, fontWeight) {
  const fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
  const fontWeightInteger = parseInt(fontWeight);
  const fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
  return (FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function replaceForPosition(node, position) {
  const pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
  return new Promise((resolve, reject) => {
    if (node.getAttribute(pendingAttribute) !== null) {
      // This node is already being processed
      return resolve();
    }
    const children = toArray(node.children);
    const alreadyProcessedPseudoElement = children.filter(c$$1 => c$$1.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position)[0];
    const styles = WINDOW.getComputedStyle(node, position);
    const fontFamily = styles.getPropertyValue('font-family');
    const fontFamilyMatch = fontFamily.match(FONT_FAMILY_PATTERN);
    const fontWeight = styles.getPropertyValue('font-weight');
    const content = styles.getPropertyValue('content');
    if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
      // If we've already processed it but the current computed style does not result in a font-family,
      // that probably means that a class name that was previously present to make the icon has been
      // removed. So we now should delete the icon.
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamilyMatch && content !== 'none' && content !== '') {
      const content = styles.getPropertyValue('content');
      let prefix = getPrefix(fontFamily, fontWeight);
      const {
        value: hexValue,
        isSecondary
      } = hexValueFromContent(content);
      const isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
      let iconName = byUnicode(prefix, hexValue);
      let iconIdentifier = iconName;
      if (isV4) {
        const iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      }

      // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
      // already done so with the same prefix and iconName
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          // Delete the old one, since we're replacing it with a new one
          node.removeChild(alreadyProcessedPseudoElement);
        }
        const meta = blankMeta();
        const {
          extra
        } = meta;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(main => {
          const abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          const element = DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
          if (position === '::before') {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }
          element.outerHTML = abstract.map(a$$1 => toHtml(a$$1)).join('\n');
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace(node) {
  return Promise.all([replaceForPosition(node, '::before'), replaceForPosition(node, '::after')]);
}
function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise((resolve, reject) => {
    const operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
    const end = perf.begin('searchPseudoElements');
    disableObservation();
    Promise.all(operations).then(() => {
      end();
      enableObservation();
      resolve();
    }).catch(() => {
      end();
      enableObservation();
      reject();
    });
  });
}
var PseudoElements = {
  hooks() {
    return {
      mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.pseudoElements2svg = function (params) {
      const {
        node = DOCUMENT
      } = params;
      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};

let _unwatched = false;
var MutationObserver$1 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        observe(chainHooks('mutationObserverCallbacks', {}));
      },
      noAuto() {
        disconnect();
      },
      watch(params) {
        const {
          observeMutationsRoot
        } = params;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks('mutationObserverCallbacks', {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};

const parseTransformString = transformString => {
  let transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(' ').reduce((acc, n) => {
    const parts = n.toLowerCase().split('-');
    const first = parts[0];
    let rest = parts.slice(1).join('-');
    if (first && rest === 'h') {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === 'v') {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case 'grow':
        acc.size = acc.size + rest;
        break;
      case 'shrink':
        acc.size = acc.size - rest;
        break;
      case 'left':
        acc.x = acc.x - rest;
        break;
      case 'right':
        acc.x = acc.x + rest;
        break;
      case 'up':
        acc.y = acc.y - rest;
        break;
      case 'down':
        acc.y = acc.y + rest;
        break;
      case 'rotate':
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout() {
    return {
      parse: {
        transform: transformString => {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const transformString = node.getAttribute('data-fa-transform');
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.generateAbstractTransformGrouping = function (_ref) {
      let {
        main,
        transform,
        containerWidth,
        iconWidth
      } = _ref;
      const outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      const innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      const innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      const innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      const inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      const path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      const operations = {
        outer,
        inner,
        path
      };
      return {
        tag: 'g',
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: 'g',
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};

const ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};
function fillBlack(abstract) {
  let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}
var Masks = {
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const maskData = node.getAttribute('data-fa-mask');
        const mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(i => i.trim()));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute('data-fa-mask-id');
        return accumulator;
      }
    };
  },
  provides(providers) {
    providers.generateAbstractMask = function (_ref) {
      let {
        children,
        attributes,
        main,
        mask,
        maskId: explicitMaskId,
        transform
      } = _ref;
      const {
        width: mainWidth,
        icon: mainPath
      } = main;
      const {
        width: maskWidth,
        icon: maskPath
      } = mask;
      const trans = transformForSvg({
        transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      const maskRect = {
        tag: 'rect',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: 'white'
        })
      };
      const maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      const maskInnerGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      const maskOuterGroup = {
        tag: 'g',
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      const maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      const clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      const maskTag = {
        tag: 'mask',
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: 'userSpaceOnUse',
          maskContentUnits: 'userSpaceOnUse'
        }),
        children: [maskRect, maskOuterGroup]
      };
      const defs = {
        tag: 'defs',
        children: [{
          tag: 'clipPath',
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: 'rect',
        attributes: _objectSpread2({
          fill: 'currentColor',
          'clip-path': "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};

var MissingIconIndicator = {
  provides(providers) {
    let reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    providers.missingIconAbstract = function () {
      const gChildren = [];
      const FILL = {
        fill: 'currentColor'
      };
      const ANIMATION_BASE = {
        attributeType: 'XML',
        repeatCount: 'indefinite',
        dur: '2s'
      };

      // Ring
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
        })
      });
      const OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: 'opacity'
      });
      const dot = {
        tag: 'circle',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: '256',
          cy: '364',
          r: '28'
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: 'r',
            values: '28;14;28;28;14;28;'
          })
        }, {
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;1;1;0;1;'
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: 'path',
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: '1',
          d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
        }),
        children: reduceMotion ? [] : [{
          tag: 'animate',
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: '1;0;0;0;0;1;'
          })
        }]
      });
      if (!reduceMotion) {
        // Exclamation
        gChildren.push({
          tag: 'path',
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: '0',
            d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
          }),
          children: [{
            tag: 'animate',
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: '0;0;1;1;0;0;'
            })
          }]
        });
      }
      return {
        tag: 'g',
        attributes: {
          'class': 'missing'
        },
        children: gChildren
      };
    };
  }
};

var SvgSymbols = {
  hooks() {
    return {
      parseNodeAttributes(accumulator, node) {
        const symbolData = node.getAttribute('data-fa-symbol');
        const symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
        accumulator['symbol'] = symbol;
        return accumulator;
      }
    };
  }
};

var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];

registerPlugins(plugins, {
  mixoutsTo: api
});
const noAuto$1 = api.noAuto;
const config$1 = api.config;
const library$1 = api.library;
const dom$1 = api.dom;
const parse$1 = api.parse;
const findIconDefinition$1 = api.findIconDefinition;
const toHtml$1 = api.toHtml;
const icon = api.icon;
const layer = api.layer;
const text = api.text;
const counter = api.counter;




/***/ }),

/***/ 68779:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MUh": function() { return /* binding */ faSlidersH; },
/* harmony export */   "WA2": function() { return /* binding */ faCircleXmark; },
/* harmony export */   "wn1": function() { return /* binding */ faSearch; },
/* harmony export */   "xHz": function() { return /* binding */ faCircleExclamation; }
/* harmony export */ });
/* unused harmony exports far, prefix, fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faFillDrip, faArrowsToCircle, faCircleChevronRight, faChevronCircleRight, faWagonCovered, faLineHeight, faBagel, faTransporter7, faAt, faRectanglesMixed, faPhoneArrowUpRight, faPhoneArrowUp, faPhoneOutgoing, faTrashCan, faTrashAlt, faCircleL, faHeadSideGoggles, faHeadVr, faTextHeight, faUserXmark, faUserTimes, faFaceHandYawn, faGaugeSimpleMin, faTachometerSlowest, faStethoscope, faCoffin, faMessage, faCommentAlt, faSalad, faBowlSalad, faInfo, faRobotAstromech, faRingDiamond, faFonduePot, faTheta, faFaceHandPeeking, faSquareUser, faDownLeftAndUpRightToCenter, faCompressAlt, faExplosion, faFileLines, faFileAlt, faFileText, faWaveSquare, faRing, faBuildingUn, faDiceThree, faTirePressureWarning, faWifiFair, faWifi2, faCalendarDays, faCalendarAlt, faMp3Player, faAnchorCircleCheck, faTally4, faRectangleHistory, faBuildingCircleArrowRight, faVolleyball, faVolleyballBall, faSunHaze, faTextSize, faUfo, faFork, faUtensilFork, faArrowsUpToLine, faMobileSignal, faBarcodeScan, faSortDown, faSortDesc, faFolderArrowDown, faFolderDownload, faCircleMinus, faMinusCircle, faFaceIcicles, faShovel, faDoorOpen, faFilms, faRightFromBracket, faSignOutAlt, faFaceGlasses, faNfc, faAtom, faSoap, faIcons, faHeartMusicCameraBolt, faMicrophoneLinesSlash, faMicrophoneAltSlash, faClosedCaptioningSlash, faCalculatorSimple, faCalculatorAlt, faBridgeCircleCheck, faSlidersUp, faSlidersV, faLocationMinus, faMapMarkerMinus, faPumpMedical, faFingerprint, faSkiBoot, faStandardDefinition, faRectangleSd, faH1, faHandPointRight, faMagnifyingGlassLocation, faSearchLocation, faMessageBot, faForwardStep, faStepForward, faFaceSmileBeam, faSmileBeam, faLightCeiling, faMessageExclamation, faCommentAltExclamation, faBowlScoop, faBowlShavedIce, faSquareX, faBuildingMemo, faUtilityPoleDouble, faFlagCheckered, faChevronsUp, faChevronDoubleUp, faFootball, faFootballBall, faUserVneck, faSchoolCircleExclamation, faCrop, faAnglesDown, faAngleDoubleDown, faUsersRectangle, faPeopleRoof, faSquareArrowRight, faArrowSquareRight, faLocationPlus, faMapMarkerPlus, faLightbulbExclamationOn, faPeopleLine, faBeerMugEmpty, faBeer, faCarpool, faCarPeople, faCrateEmpty, faDiagramPredecessor, faTransporter, faCalendarCircleUser, faArrowUpLong, faLongArrowUp, faPersonCarryBox, faPersonCarry, faFireFlameSimple, faBurn, faPerson, faMale, faLaptop, faFileCsv, faMenorah, faUnion, faChevronsLeft, faChevronDoubleLeft, faCircleHeart, faHeartCircle, faTruckPlane, faRecordVinyl, faBringForward, faSquareP, faFaceGrinStars, faGrinStars, faSigma, faCameraMovie, faBong, faClarinet, faTruckFlatbed, faSpaghettiMonsterFlying, faPastafarianism, faArrowDownUpAcrossLine, faArrowsRotateReverse, faLeafHeart, faHouseBuilding, faCheeseSwiss, faSpoon, faUtensilSpoon, faJarWheat, faEnvelopesBulk, faMailBulk, faFileCircleExclamation, faBowArrow, faCartXmark, faHexagonXmark, faTimesHexagon, faXmarkHexagon, faCircleH, faHospitalSymbol, faMerge, faPager, faCartMinus, faAddressBook, faContactBook, faPanFrying, faGrid, faGrid3, faFootballHelmet, faHandLove, faTrees, faStrikethrough, faPage, faK, faDiagramPrevious, faGaugeMin, faTachometerAltSlowest, faFolderGrid, faEggplant, faExcavator, faRam, faLandmarkFlag, faLips, faPencil, faPencilAlt, faBackward, faCaretRight, faComments, faPaste, faFileClipboard, faDesktopArrowDown, faCodePullRequest, faPumpkin, faClipboardList, faPenField, faChartSine, faBlueberries, faTruckRampBox, faTruckLoading, faNote, faArrowDownToSquare, faUserCheck, faCloudXmark, faVialVirus, faBookBlank, faBookAlt, faGolfFlagHole, faMessageArrowDown, faCommentAltArrowDown, faFaceUnamused, faSheetPlastic, faCircle9, faBlog, faUserNinja, faPencilSlash, faBowlingPins, faPersonArrowUpFromLine, faDownRight, faScrollTorah, faTorah, faWebhook, faBlindsOpen, faFence, faUp, faArrowAltUp, faBroomBall, faQuidditch, faQuidditchBroomBall, faDrumstick, faSquareV, faFaceAwesome, faGaveDandy, faDialOff, faToggleOff, faFaceSmileHorns, faBoxArchive, faArchive, faGrapes, faPersonDrowning, faDialMax, faCircleM, faCalendarImage, faCircleCaretDown, faCaretCircleDown, faArrowDown91, faSortNumericDesc, faSortNumericDownAlt, faFaceGrinTongueSquint, faGrinTongueSquint, faShishKebab, faSprayCan, faAlarmSnooze, faScarecrow, faTruckMonster, faGiftCard, faW, faCodePullRequestDraft, faSquareB, faElephant, faEarthAfrica, faGlobeAfrica, faRainbow, faCircleNotch, faTabletScreenButton, faTabletAlt, faPaw, faMessageQuestion, faCloud, faTrowelBricks, faSquare3, faFaceFlushed, faFlushed, faHospitalUser, faMicrowave, faChfSign, faTentArrowLeftRight, faCartCircleArrowUp, faTrashClock, faReflectBoth, faGavel, faLegal, faSprinklerCeiling, faBrowsers, faTrillium, faTableCellsUnlock, faMusicSlash, faTruckRamp, faBinoculars, faMicrophoneSlash, faBoxTissue, faCircleC, faStarChristmas, faChartBullet, faMotorcycle, faTreeChristmas, faTireFlat, faSunglasses, faBadge, faMessagePen, faCommentAltEdit, faMessageEdit, faBellConcierge, faConciergeBell, faPenRuler, faPencilRuler, faFileMp3, faArrowProgress, faChessRookPiece, faChessRookAlt, faSquareRoot, faAlbumCollectionCirclePlus, faPeopleArrows, faPeopleArrowsLeftRight, faSignPost, faFaceAngryHorns, faMarsAndVenusBurst, faTombstone, faSquareCaretRight, faCaretSquareRight, faScissors, faCut, faListMusic, faSunPlantWilt, faToiletsPortable, faHockeyPuck, faMustache, faHyphen, faTable, faUserChef, faMessageImage, faCommentAltImage, faUsersMedical, faSensorTriangleExclamation, faSensorAlert, faMagnifyingGlassArrowRight, faTachographDigital, faDigitalTachograph, faFaceMask, faPickleball, faStarSharpHalf, faUsersSlash, faClover, faMeat, faReply, faMailReply, faStarAndCrescent, faEmptySet, faHouseFire, faSquareMinus, faMinusSquare, faHelicopter, faBird, faCompass, faSquareCaretDown, faCaretSquareDown, faHeartHalfStroke, faHeartHalfAlt, faFileCircleQuestion, faTruckUtensils, faLaptopCode, faJoystick, faGrillFire, faRectangleVerticalHistory, faSwatchbook, faPrescriptionBottle, faBars, faNavicon, faKeyboardLeft, faPeopleGroup, faHourglassEnd, faHourglass3, faHeartCrack, faHeartBroken, faFaceBeamHandOverMouth, faDropletPercent, faHumidity, faSquareUpRight, faExternalLinkSquareAlt, faFaceKissBeam, faKissBeam, faCorn, faRollerCoaster, faPhotoFilmMusic, faRadar, faSickle, faFilm, faCoconut, faRulerHorizontal, faShieldCross, faCassetteTape, faSquareTerminal, faPeopleRobbery, faLightbulb, faCaretLeft, faCommentMiddle, faTrashCanList, faBlock, faExclamationCircle, faSchoolCircleXmark, faArrowRightFromBracket, faSignOut, faFaceFrownSlight, faCircleChevronDown, faChevronCircleDown, faSidebarFlip, faUnlockKeyhole, faUnlockAlt, faTemperatureList, faCloudShowersHeavy, faHeadphonesSimple, faHeadphonesAlt, faSitemap, faPipeSection, faSpaceStationMoonConstruction, faSpaceStationMoonAlt, faCircleDollarToSlot, faDonate, faMemory, faFaceSleeping, faRoadSpikes, faFireBurner, faSquirrel, faArrowUpToLine, faArrowToTop, faFlag, faFaceCowboyHat, faHanukiah, faChartScatter3d, faDisplayChartUp, faSquareCode, faFeather, faVolumeLow, faVolumeDown, faXmarkToSlot, faTimesToSlot, faVoteNay, faBoxTaped, faBoxAlt, faCommentSlash, faSwords, faCloudSunRain, faAlbum, faCircleN, faCompress, faWheatAwn, faWheatAlt, faAnkh, faHandsHoldingChild, faAsterisk, faKeySkeletonLeftRight, faCommentLines, faLuchadorMask, faLuchador, faMaskLuchador, faSquareCheck, faCheckSquare, faShredder, faBookOpenCover, faBookOpenAlt, faSandwich, faPesetaSign, faSquareParkingSlash, faParkingSlash, faTrainTunnel, faHeading, faHeader, faGhost, faFaceAnguished, faHockeySticks, faAbacus, faFilmSimple, faFilmAlt, faList, faListSquares, faTreePalm, faSquarePhoneFlip, faPhoneSquareAlt, faUserBeardBolt, faCartPlus, faGamepad, faBorderCenterV, faCircleDot, faDotCircle, faClipboardMedical, faFaceDizzy, faDizzy, faEgg, faUpToLine, faArrowAltToTop, faHouseMedicalCircleXmark, faWatchFitness, faClockNineThirty, faCampground, faFolderPlus, faJug, faFutbol, faFutbolBall, faSoccerBall, faSnowBlowing, faPaintbrush, faPaintBrush, faLock, faArrowDownFromLine, faArrowFromTop, faGasPump, faSignalBarsSlash, faSignalAltSlash, faMonkey, faRectanglePro, faPro, faHouseNight, faHotTubPerson, faHotTub, faGlobePointer, faBlanket, faMapLocation, faMapMarked, faHouseFloodWater, faCommentsQuestionCheck, faTree, faArrowsCross, faBackpack, faSquareSmall, faFolderArrowUp, faFolderUpload, faBridgeLock, faCrosshairsSimple, faSackDollar, faPenToSquare, faEdit, faSquareSliders, faSlidersHSquare, faCarSide, faMessageMiddleTop, faCommentMiddleTopAlt, faLightbulbOn, faKnife, faUtensilKnife, faShareNodes, faShareAlt, faDisplayChartUpCircleDollar, faWaveSine, faHeartCircleMinus, faCircleW, faCircleCalendar, faCalendarCircle, faHourglassHalf, faHourglass2, faMicroscope, faSunset, faSink, faCalendarExclamation, faTruckContainerEmpty, faHandHeart, faBagShopping, faShoppingBag, faArrowDownZA, faSortAlphaDesc, faSortAlphaDownAlt, faMitten, faReplyClock, faReplyTime, faPersonRays, faRight, faArrowAltRight, faCircleF, faUsers, faFacePleading, faEyeSlash, faFlaskVial, faPoliceBox, faCucumber, faHeadSideBrain, faHand, faHandPaper, faPersonBikingMountain, faBikingMountain, faUtensilsSlash, faPrintMagnifyingGlass, faPrintSearch, faTurnRight, faFolderBookmark, faArrowTurnLeftDown, faOm, faPi, faFlaskRoundPotion, faFlaskPotion, faFaceShush, faWorm, faHouseCircleXmark, faPlug, faCalendarCircleExclamation, faSquareI, faChevronUp, faFaceSaluting, faGaugeSimpleLow, faTachometerSlow, faFacePersevering, faCircleCamera, faCameraCircle, faHandSpock, faSpiderWeb, faCircleMicrophone, faMicrophoneCircle, faBookArrowUp, faPopsicle, faCommand, faBlinds, faStopwatch, faSaxophone, faSquare2, faFieldHockeyStickBall, faFieldHockey, faArrowUpSquareTriangle, faSortShapesUpAlt, faFaceScream, faSquareM, faCameraWeb, faWebcam, faCommentArrowDown, faLightbulbCfl, faWindowFrameOpen, faFaceKiss, faKiss, faBridgeCircleXmark, faPeriod, faFaceGrinTongue, faGrinTongue, faUpToDottedLine, faThoughtBubble, faSkeletonRibs, faRaygun, faFlute, faAcorn, faVideoArrowUpRight, faGrateDroplet, faSealExclamation, faChessBishop, faMessageSms, faCoffeeBeans, faHatWitch, faFaceGrinWink, faGrinWink, faClockThreeThirty, faEarDeaf, faDeaf, faDeafness, faHardOfHearing, faAlarmClock, faEclipse, faFaceRelieved, faRoadCircleCheck, faDiceFive, faOctagonMinus, faMinusOctagon, faSquareRss, faRssSquare, faFaceZany, faTricycle, faLandMineOn, faSquareArrowUpLeft, faICursor, faChartMixedUpCircleDollar, faSaltShaker, faStamp, faFilePlus, faDrawSquare, faToiletPaperUnderSlash, faToiletPaperReverseSlash, faStairs, faDroneFront, faDroneAlt, faGlassEmpty, faDialHigh, faUserHelmetSafety, faUserConstruction, faUserHardHat, faI, faHryvniaSign, faHryvnia, faArrowDownLeftAndArrowUpRightToCenter, faPills, faFaceGrinWide, faGrinAlt, faTooth, faBasketballHoop, faObjectsAlignBottom, faV, faSparkles, faSquid, faLeafyGreen, faCircleArrowUpRight, faCalendars, faBangladeshiTakaSign, faBicycle, faHammerWar, faCircleD, faSpiderBlackWidow, faStaffSnake, faRodAsclepius, faRodSnake, faStaffAesculapius, faPear, faHeadSideCoughSlash, faFileMov, faTriangle, faApartment, faTruckMedical, faAmbulance, faPepper, faPiano, faGunSquirt, faWheatAwnCircleExclamation, faSnowman, faUserAlien, faShieldCheck, faMortarPestle, faRoadBarrier, faChartCandlestick, faBriefcaseBlank, faSchool, faIgloo, faBracketRound, faParenthesis, faJoint, faHorseSaddle, faMugMarshmallows, faFilters, faBellOn, faAngleRight, faDialMed, faHorse, faQ, faMonitorWaveform, faMonitorHeartRate, faLinkSimple, faWhistle, faG, faWineGlassCrack, faFragile, faSlotMachine, faNotesMedical, faCarWash, faEscalator, faCommentImage, faTemperatureHalf, faTemperature2, faThermometer2, faThermometerHalf, faDongSign, faDonut, faDoughnut, faCapsules, faPooStorm, faPooBolt, faTally1, faFileVector, faFaceFrownOpen, faFrownOpen, faSquareDashed, faBagShoppingPlus, faSquareJ, faHandPointUp, faMoneyBill, faArrowUpBigSmall, faSortSizeUp, faBarcodeRead, faBaguette, faBowlSoftServe, faFaceHoldingBackTears, faSquareUp, faArrowAltSquareUp, faTrainSubwayTunnel, faSubwayTunnel, faSquareExclamation, faExclamationSquare, faSemicolon, faBookmark, faFanTable, faAlignJustify, faBatteryLow, faBattery1, faCreditCardFront, faBrainArrowCurvedRight, faMindShare, faUmbrellaBeach, faHelmetUn, faLocationSmile, faMapMarkerSmile, faArrowLeftToLine, faArrowToLeft, faBullseye, faSushi, faNigiri, faMessageCaptions, faCommentAltCaptions, faTrashList, faBacon, faOption, faRaccoon, faHandPointDown, faArrowUpFromBracket, faHeadSideGear, faTrashPlus, faFileCad, faObjectsAlignTop, faFolder, faFolderBlank, faFaceAnxiousSweat, faCreditCardBlank, faFileWaveform, faFileMedicalAlt, faMicrochipAi, faMug, faPlaneUpSlash, faRadiation, faPenCircle, faBagSeedling, faChartSimple, faCrutches, faCircleParking, faParkingCircle, faMarsStroke, faLeafOak, faSquareBolt, faVial, faGauge, faDashboard, faGaugeMed, faTachometerAltAverage, faWandMagicSparkles, faMagicWandSparkles, faLambda, faE, faPizza, faBowlChopsticksNoodles, faH3, faPenClip, faPenAlt, faBridgeCircleExclamation, faBadgePercent, faRotateReverse, faUser, faSensor, faComma, faSchoolCircleCheck, faToiletPaperUnder, faToiletPaperReverse, faLightEmergency, faArrowDownToArc, faDumpster, faVanShuttle, faShuttleVan, faBuildingUser, faLightSwitch, faSquareCaretLeft, faCaretSquareLeft, faHighlighter, faWavePulse, faHeartRate, faKey, faArrowLeftToBracket, faHatSanta, faTamale, faBoxCheck, faBullhorn, faSteak, faLocationCrosshairsSlash, faLocationSlash, faPersonDolly, faGlobe, faSynagogue, faFileChartColumn, faFileChartLine, faPersonHalfDress, faFolderImage, faCalendarPen, faCalendarEdit, faRoadBridge, faFaceSmileTear, faMessagePlus, faCommentAltPlus, faLocationArrow, faC, faTabletButton, faPersonDressFairy, faRectangleHistoryCircleUser, faBuildingLock, faChartLineUp, faMailbox, faSignPosts, faTruckBolt, faPizzaSlice, faMoneyBillWave, faChartArea, faAreaChart, faHouseFlag, faCircleThreeQuartersStroke, faPersonCircleMinus, faScalpel, faBan, faCancel, faBellExclamation, faCircleBookmark, faBookmarkCircle, faEggFried, faFaceWeary, faUniformMartialArts, faCameraRotate, faSunDust, faCommentText, faSprayCanSparkles, faAirFreshener, faSignalBars, faSignalAlt, faSignalAlt4, faSignalBarsStrong, faDiamondExclamation, faStar, faDialMin, faRepeat, faCross, faPageCaretDown, faFileCaretDown, faBox, faVenusMars, faClockSevenThirty, faArrowPointer, faMousePointer, faClockFourThirty, faSignalBarsGood, faSignalAlt3, faCactus, faLightbulbGear, faMaximize, faExpandArrowsAlt, faChargingStation, faShapes, faTriangleCircleSquare, faPlaneTail, faGaugeSimpleMax, faTachometerFastest, faCircleU, faShieldSlash, faSquarePhoneHangup, faPhoneSquareDown, faArrowUpLeft, faTransporter1, faPeanuts, faShuffle, faRandom, faPersonRunning, faRunning, faMobileRetro, faGripLinesVertical, faBinBottlesRecycle, faArrowUpFromSquare, faFileDashedLine, faPageBreak, faBracketCurlyRight, faSpider, faClockThree, faHandsBound, faScalpelLineDashed, faScalpelPath, faFileInvoiceDollar, faPipeSmoking, faFaceAstonished, faWindow, faPlaneCircleExclamation, faEar, faFileLock, faDiagramVenn, faArrowDownFromBracket, faXRay, faGoalNet, faCoffinCross, faOctopus, faSpellCheck, faLocationXmark, faMapMarkerTimes, faMapMarkerXmark, faCircleQuarterStroke, faLasso, faSlash, faPersonToPortal, faPortalEnter, faCalendarStar, faComputerMouse, faMouse, faArrowRightToBracket, faSignIn, faPegasus, faFilesMedical, faCannon, faNfcLock, faPersonSkiLift, faSkiLift, faSquare6, faShopSlash, faStoreAltSlash, faWindTurbine, faSlidersSimple, faGridRound, faBadgeSheriff, faServer, faVirusCovidSlash, faIntersection, faShopLock, faFamily, faHourglassStart, faHourglass1, faUserHairBuns, faBlenderPhone, faHourglassClock, faPersonSeatReclined, faPaperPlaneTop, faPaperPlaneAlt, faSend, faMessageArrowUp, faCommentAltArrowUp, faLightbulbExclamation, faLayerMinus, faLayerGroupMinus, faChartPieSimpleCircleCurrency, faCircleE, faBuildingWheat, faGaugeMax, faTachometerAltFastest, faPersonBreastfeeding, faApostrophe, faFilePng, faFireHydrant, faRightToBracket, faSignInAlt, faVideoPlus, faSquareRight, faArrowAltSquareRight, faCommentSmile, faVenus, faPassport, faThumbtackSlash, faThumbTackSlash, faInboxIn, faInboxArrowDown, faHeartPulse, faHeartbeat, faCircle8, faCloudsMoon, faClockTenThirty, faPeopleCarryBox, faPeopleCarry, faFolderUser, faTrashCanXmark, faTemperatureHigh, faMicrochip, faLeftLongToLine, faCrown, faWeightHanging, faXmarksLines, faFilePrescription, faTableCellsLock, faCalendarRange, faFlowerDaffodil, faHandBackPointUp, faWeightScale, faWeight, faArrowUpToArc, faStarExclamation, faBooks, faUserGroup, faUserFriends, faArrowUpAZ, faSortAlphaUp, faLayerPlus, faLayerGroupPlus, faPlayPause, faBlockQuestion, faSnooze, faZzz, faScannerImage, faTvRetro, faSquareT, faFarm, faBarnSilo, faChessKnight, faBarsSort, faPalletBoxes, faPaletteBoxes, faPalletAlt, faFaceLaughSquint, faLaughSquint, faCodeSimple, faBoltSlash, faPanelFire, faBinaryCircleCheck, faCommentMinus, faBurrito, faViolin, faObjectsColumn, faSquareChevronDown, faChevronSquareDown, faCommentPlus, faTriangleInstrument, faTriangleMusic, faWheelchair, faUserPilotTie, faPianoKeyboard, faBedEmpty, faCircleArrowUp, faArrowCircleUp, faToggleOn, faRectangleVertical, faRectanglePortrait, faPersonWalking, faWalking, faL, faSignalStream, faDownToBracket, faCircleZ, faStars, faFire, faBedPulse, faProcedures, faHouseDay, faShuttleSpace, faSpaceShuttle, faShirtLongSleeve, faChartPieSimple, faChartPieAlt, faFaceLaugh, faLaugh, faFolderOpen, faAlbumCollectionCircleUser, faCandy, faBowlHot, faSoup, faFlatbread, faHeartCirclePlus, faCodeFork, faCity, faSignalBarsWeak, faSignalAlt1, faMicrophoneLines, faMicrophoneAlt, faClockTwelve, faPepperHot, faCitrusSlice, faSheep, faUnlock, faColonSign, faHeadset, faBadgerHoney, faH4, faStoreSlash, faRoadCircleXmark, faSignalSlash, faUserMinus, faMarsStrokeUp, faMarsStrokeV, faChampagneGlasses, faGlassCheers, faTaco, faHexagonPlus, faPlusHexagon, faClipboard, faHouseCircleExclamation, faFileArrowUp, faFileUpload, faWifi, faWifi3, faWifiStrong, faMessages, faCommentsAlt, faBath, faBathtub, faUmbrellaSimple, faUmbrellaAlt, faRectangleHistoryCirclePlus, faUnderline, faPrescriptionBottlePill, faUserPen, faUserEdit, faBinarySlash, faSquareO, faCaduceus, faSignature, faStroopwafel, faBold, faAnchorLock, faBuildingNgo, faTransporter3, faEngineWarning, faEngineExclamation, faCircleDownRight, faSquareK, faManatSign, faMoneyCheckPen, faMoneyCheckEdit, faNotEqual, faBorderTopLeft, faBorderStyle, faMapLocationDot, faMapMarkedAlt, faTilde, faJedi, faSquarePollVertical, faPoll, faArrowDownSquareTriangle, faSortShapesDownAlt, faMugHot, faDogLeashed, faCarBattery, faBatteryCar, faFaceDowncastSweat, faMailboxFlagUp, faMemoCircleInfo, faGift, faDiceTwo, faVolume, faVolumeMedium, faTransporter5, faGaugeCircleBolt, faCoinFront, faFileSlash, faMessageArrowUpRight, faTreasureChest, faChessQueen, faPaintbrushFine, faPaintBrushAlt, faPaintBrushFine, faPaintbrushAlt, faGlasses, faHoodCloak, faSquareQuote, faUpLeft, faBringFront, faChessBoard, faBurgerCheese, faCheeseburger, faBuildingCircleCheck, faRepeat1, faArrowDownToLine, faArrowToBottom, faGrid5, faSwapArrows, faRightLongToLine, faPersonChalkboard, faMarsStrokeRight, faMarsStrokeH, faHandBackFist, faHandRock, faGridRound5, faTally, faTally5, faSquareCaretUp, faCaretSquareUp, faCloudShowersWater, faChartBar, faBarChart, faHandsBubbles, faHandsWash, faLessThanEqual, faTrain, faUpFromDottedLine, faEyeLowVision, faLowVision, faTrafficLightGo, faFaceExhaling, faSensorFire, faUserUnlock, faHexagonDivide, fa00, faCrow, faCassetteBetamax, faBetamax, faSailboat, faWindowRestore, faNfcMagnifyingGlass, faFileBinary, faCircleV, faSquarePlus, faPlusSquare, faBowlScoops, faMistletoe, faCustard, faLacrosseStick, faHockeyMask, faSunrise, faSubtitles, faPanelEws, faToriiGate, faCloudExclamation, faMessageLines, faCommentAltLines, faFrog, faBucket, faFloppyDiskPen, faImage, faWindowFrame, faMicrophone, faCow, faFileZip, faSquareRing, faDownFromLine, faArrowAltFromTop, faCaretUp, faShieldXmark, faShieldTimes, faScrewdriver, faCircleSortDown, faSortCircleDown, faFolderClosed, faHouseTsunami, faSquareNfi, faForklift, faArrowUpFromGroundWater, faBracketSquareRight, faMartiniGlass, faGlassMartiniAlt, faSquareBinary, faRotateLeft, faRotateBack, faRotateBackward, faUndoAlt, faTableColumns, faColumns, faSquareA, faTick, faLemon, faHeadSideMask, faHandshake, faGem, faDolly, faDollyBox, faSmoking, faMinimize, faCompressArrowsAlt, faRefrigerator, faMonument, faOctagonXmark, faTimesOctagon, faXmarkOctagon, faAlignSlash, faSnowplow, faAnglesRight, faAngleDoubleRight, faTruckRampCouch, faTruckCouch, faCannabis, faCirclePlay, faPlayCircle, faArrowUpRightAndArrowDownLeftFromCenter, faLocationArrowUp, faTablets, fa360Degrees, faEthernet, faEuroSign, faEur, faEuro, faChair, faCircleCheck, faCheckCircle, faSquareDashedCirclePlus, faHandHoldingCircleDollar, faMoneySimpleFromBracket, faBat, faCircleStop, faStopCircle, faHeadSideHeadphones, faPhoneRotary, faArrowUpToBracket, faCompassDrafting, faDraftingCompass, faPlateWheat, faCalendarCircleMinus, faChopsticks, faCarWrench, faCarMechanic, faIcicles, faPersonShelter, faNeuter, faIdBadge, faKazoo, faMarker, faBinBottles, faFaceLaughBeam, faLaughBeam, faSquareArrowDownLeft, faBatteryBolt, faTreeLarge, faHelicopterSymbol, faAperture, faUniversalAccess, faGearComplex, faFileMagnifyingGlass, faFileSearch, faUpRight, faCircleChevronUp, faChevronCircleUp, faUserPolice, faLariSign, faVolcano, faTeddyBear, faStocking, faPersonWalkingDashedLineArrowRight, faImageSlash, faMaskSnorkel, faSmoke, faSterlingSign, faGbp, faPoundSign, faBatteryExclamation, faViruses, faSquarePersonConfined, faUserTie, faUpToBracket, faArrowDownLong, faLongArrowDown, faTentArrowDownToLine, faCertificate, faCrystalBall, faReplyAll, faMailReplyAll, faSuitcase, faPersonSkating, faSkating, faStarShooting, faBinaryLock, faFilterCircleDollar, faFunnelDollar, faCameraRetro, faCircleArrowDown, faArrowCircleDown, faCommentPen, faCommentEdit, faFileImport, faArrowRightToFile, faBanjo, faSquareArrowUpRight, faExternalLinkSquare, faLightEmergencyOn, faKerning, faBoxOpen, faSquareF, faScroll, faSpa, faArrowLeftFromLine, faArrowFromRight, faStrawberry, faLocationPinLock, faPause, faClockEightThirty, faPlaneEngines, faPlaneAlt, faHillAvalanche, faTemperatureEmpty, faTemperature0, faThermometer0, faThermometerEmpty, faBomb, faGaugeLow, faTachometerAltSlow, faRegistered, faTrashCanPlus, faAddressCard, faContactCard, faVcard, faChartFft, faScaleUnbalancedFlip, faBalanceScaleRight, faGlobeSnow, faSubscript, faDiamondTurnRight, faDirections, faIntegral, faBurst, faHouseLaptop, faLaptopHouse, faFaceTired, faTired, faMoneyBills, faBlindsRaised, faSmog, faUfoBeam, faHydra, faCircleCaretUp, faCaretCircleUp, faUserVneckHairLong, faSquareALock, faCrutch, faGasPumpSlash, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faCloudArrowUp, faCloudUpload, faCloudUploadAlt, faPalette, faTransporter4, faChartMixedUpCircleCurrency, faObjectsAlignRight, faArrowsTurnRight, faVest, faPig, faInboxFull, faCircleEnvelope, faEnvelopeCircle, faTrianglePersonDigging, faConstruction, faFerry, faBullseyeArrow, faArrowsDownToPeople, faSeedling, faSprout, faClockSeven, faLeftRight, faArrowsAltH, faBoxesPacking, faCircleArrowLeft, faArrowCircleLeft, faFlashlight, faFileJpg, faGroupArrowsRotate, faBowlFood, faSquare9, faCandyCane, faArrowDownWideShort, faSortAmountAsc, faSortAmountDown, faSquareDollar, faDollarSquare, faUsdSquare, faPhoneArrowRight, faHandHoldingSeedling, faMessageCheck, faCommentAltCheck, faCloudBolt, faThunderstorm, faChartLineUpDown, faTextSlash, faRemoveFormat, faWatch, faCircleDownLeft, faText, faProjector, faFaceSmileWink, faSmileWink, faTombstoneBlank, faTombstoneAlt, faChessKingPiece, faChessKingAlt, faCircle6, faWavesSine, faLeft, faArrowAltLeft, faFileWord, faFilePowerpoint, faSquareDown, faArrowAltSquareDown, faObjectsAlignCenterVertical, faArrowsLeftRight, faArrowsH, faHouseLock, faCloudArrowDown, faCloudDownload, faCloudDownloadAlt, faWreath, faChildren, faMeterDroplet, faChalkboard, faBlackboard, faUserLargeSlash, faUserAltSlash, faSignalStrong, faSignal4, faLollipop, faLollypop, faListTree, faEnvelopeOpen, faDrawCircle, faCatSpace, faHandshakeSimpleSlash, faHandshakeAltSlash, faRabbitRunning, faRabbitFast, faMemoPad, faMattressPillow, faAlarmPlus, faAlicorn, faCommentQuestion, faGingerbreadMan, faGuaraniSign, faBurgerFries, faMugTea, faBorderTop, faArrowsRotate, faRefresh, faSync, faCircleBookOpen, faBookCircle, faArrowsToDottedLine, faFireExtinguisher, faMagnifyingGlassArrowsRotate, faGarageOpen, faShelvesEmpty, faCruzeiroSign, faWatchApple, faWatchCalculator, faListDropdown, faCabinetFiling, faBurgerSoda, faSquareArrowUp, faArrowSquareUp, faGreaterThanEqual, faPalletBox, faFaceConfounded, faShieldHalved, faShieldAlt, faTruckPlow, faBookAtlas, faAtlas, faVirus, faGridRound2, faCommentMiddleTop, faWave, faEnvelopeCircleCheck, faLayerGroup, faRestroomSimple, faArrowsToDot, faBorderOuter, faHashtagLock, faClockTwoThirty, faArchway, faHeartCircleCheck, faHouseChimneyCrack, faHouseDamage, faFileZipper, faFileArchive, faTicketPerforated, faHeartHalf, faCommentCheck, faSquare, faMemo, faMartiniGlassEmpty, faGlassMartini, faCouch, faCediSign, faItalic, faGlassCitrus, faCalendarLinesPen, faTableCellsColumnLock, faChurch, faPersonSnowmobiling, faSnowmobile, faFaceHushed, faCommentsDollar, faTicketsSimple, faPickaxe, faLinkSimpleSlash, faDemocrat, faFaceConfused, faPinball, faZ, faPersonSkiing, faSkiing, faDeer, faInputPipe, faRoadLock, faA, faBookmarkSlash, faTemperatureArrowDown, faTemperatureDown, faMace, faFeatherPointed, faFeatherAlt, faSausage, faTrashCanClock, faP, faBroomWide, faSnowflake, faStomach, faNewspaper, faRectangleAd, faAd, faGuitarElectric, faArrowTurnDownRight, faMoonCloud, faBreadSliceButter, faCircleArrowRight, faArrowCircleRight, faUserGroupCrown, faUsersCrown, faCircleI, faToiletPaperCheck, faFilterCircleXmark, faLocust, faSort, faUnsorted, faListOl, faList12, faListNumeric, faChartWaterfall, faSparkle, faFaceParty, faKidneys, faWifiExclamation, faChartNetwork, faPersonDressBurst, faDiceD4, faMoneyCheckDollar, faMoneyCheckAlt, faVectorSquare, faBreadSlice, faLanguage, faWheatAwnSlash, faFaceKissWinkHeart, faKissWinkHeart, faDagger, faPodium, faDiamonds4, faMemoCircleCheck, faRouteHighway, faDownToLine, faArrowAltToBottom, faFilter, faSquareG, faCirclePhone, faPhoneCircle, faClipboardPrescription, faUserNurseHair, faQuestion, faFileSignature, faToggleLargeOn, faUpDownLeftRight, faArrowsAlt, faDryerHeat, faDryerAlt, faHouseChimneyUser, faHandHoldingHeart, faArrowUpSmallBig, faSortSizeUpAlt, faTrainTrack, faPuzzlePiece, faMoneyCheck, faStarHalfStroke, faStarHalfAlt, faFileExclamation, faCode, faWhiskeyGlass, faGlassWhiskey, faMoonStars, faBuildingCircleExclamation, faClothesHanger, faMobileNotch, faMobileIphone, faMagnifyingGlassChart, faArrowUpRightFromSquare, faExternalLink, faCubesStacked, faImagesUser, faWonSign, faKrw, faWon, faImagePolaroidUser, faVirusCovid, faSquareEllipsis, faPie, faChessKnightPiece, faChessKnightAlt, faAustralSign, faCloudPlus, faF, faLeaf, faBedBunk, faRoad, faTaxi, faCab, faPersonCirclePlus, faChartPie, faPieChart, faBoltLightning, faClockEight, faSackXmark, faFileXls, faFileExcel, faFileContract, faFishFins, faCircleQ, faBuildingFlag, faFaceGrinBeam, faGrinBeam, faObjectUngroup, faFaceDisguise, faCircleArrowDownRight, faAlien8bit, faAlienMonster, faHandPointRibbon, faPoop, faObjectExclude, faTelescope, faLocationPin, faMapMarker, faSquareList, faKaaba, faToiletPaper, faHelmetSafety, faHardHat, faHatHard, faCommentCode, faSimCards, faStarship, faEject, faCircleRight, faArrowAltCircleRight, faPlaneCircleCheck, faSeal, faUserCowboy, faHexagonVerticalNft, faFaceRollingEyes, faMehRollingEyes, faBreadLoaf, faRingsWedding, faObjectGroup, faFrenchFries, faChartLine, faLineChart, faCalendarArrowDown, faCalendarDownload, faSendBack, faMaskVentilator, faTickets, faSignatureLock, faArrowRight, faSignsPost, faMapSigns, faOctagonPlus, faPlusOctagon, faCashRegister, faPersonCircleQuestion, faMelonSlice, faSpaceStationMoon, faMessageSmile, faCommentAltSmile, faCupStraw, faLeftFromLine, faArrowAltFromRight, faH, faBasketShoppingSimple, faShoppingBasketAlt, faHandsHoldingHeart, faHandsHeart, faClockNine, faHammerBrush, faTarp, faFaceSleepy, faHandHorns, faScrewdriverWrench, faTools, faArrowsToEye, faCircleThreeQuarters, faTrophyStar, faTrophyAlt, faPlugCircleBolt, faFaceThermometer, faGridRound4, faSignPostsWrench, faShirtRunning, faBookCircleArrowUp, faFaceNauseated, faHeart, faFileChartPie, faMarsAndVenus, faHouseUser, faHomeUser, faCircleArrowDownLeft, faDumpsterFire, faHexagonMinus, faMinusHexagon, faLeftToLine, faArrowAltToLeft, faHouseCrack, faPawSimple, faPawAlt, faArrowLeftLongToLine, faBracketsRound, faParentheses, faMartiniGlassCitrus, faCocktail, faUserShakespeare, faArrowRightToArc, faFaceSurprise, faSurprise, faBottleWater, faCirclePause, faPauseCircle, faGaugeCirclePlus, faFolders, faAngel, faValueAbsolute, faRabbit, faToiletPaperSlash, faCircleEuro, faAppleWhole, faAppleAlt, faKitchenSet, faDiamondHalf, faLockKeyhole, faLockAlt, faR, faTemperatureQuarter, faTemperature1, faThermometer1, faThermometerQuarter, faSquareInfo, faInfoSquare, faWifiSlash, faToiletPaperXmark, faHandsHoldingDollar, faHandsUsd, faCube, faArrowDownTriangleSquare, faSortShapesDown, faBitcoinSign, faShutters, faShieldDog, faSolarPanel, faLockOpen, faTableTree, faHouseChimneyHeart, faTally3, faElevator, faMoneyBillTransfer, faMoneyBillTrendUp, faHouseFloodWaterCircleArrowRight, faSquarePollHorizontal, faPollH, faCircle, faLeftToBracket, faCartCircleExclamation, faSword, faBackwardFast, faFastBackward, faRecycle, faUserAstronaut, faInterrobang, faPlaneSlash, faCircleDashed, faTrademark, faBasketball, faBasketballBall, faForkKnife, faUtensilsAlt, faSatelliteDish, faBadgeCheck, faCircleUp, faArrowAltCircleUp, faSlider, faMobileScreenButton, faMobileAlt, faClockOneThirty, faInboxOut, faInboxArrowUp, faCloudSlash, faVolumeHigh, faVolumeUp, faUsersRays, faWallet, faOctagonCheck, faFlatbreadStuffed, faClipboardCheck, faCartCirclePlus, faTruckClock, faShippingTimed, faPool8Ball, faFileAudio, faTurnDownLeft, faLockHashtag, faChartRadar, faStaff, faBurger, faHamburger, faUtilityPole, faTransporter6, faArrowTurnLeft, faWrench, faBugs, faVectorPolygon, faDiagramNested, faRupeeSign, faRupee, faFileImage, faCircleQuestion, faQuestionCircle, faTicketsPerforated, faImageUser, faBuoy, faPlaneDeparture, faHandshakeSlash, faBookBookmark, faBorderCenterH, faCanFood, faTypewriter, faArrowRightFromArc, faCircleK, faFaceHandOverMouth, faPopcorn, faHouseWater, faHouseFlood, faObjectSubtract, faCodeBranch, faWarehouseFull, faWarehouseAlt, faHatCowboy, faBridge, faPhoneFlip, faPhoneAlt, faArrowDownFromDottedLine, faFileDoc, faSquareQuarters, faTruckFront, faCat, faTrashXmark, faCircleCaretLeft, faCaretCircleLeft, faFiles, faAnchorCircleExclamation, faFaceClouds, faUserCrown, faBasketShoppingPlus, faTruckField, faRoute, faCartCircleCheck, faClipboardQuestion, faPanorama, faCommentMedical, faTeethOpen, faUserTieHairLong, faFileCircleMinus, faHeadSideMedical, faArrowTurnRight, faTags, faWineGlass, faForwardFast, faFastForward, faFaceMehBlank, faMehBlank, faUserRobot, faSquareParking, faParking, faCardDiamond, faFaceZipper, faFaceRaisedEyebrow, faHouseSignal, faSquareChevronUp, faChevronSquareUp, faNfcSymbol, faBarsProgress, faTasksAlt, faFaucetDrip, faArrowsToLine, faDolphin, faArrowUpRight, faCircleR, faCartFlatbed, faDollyFlatbed, faBanSmoking, faSmokingBan, faCircleSortUp, faSortCircleUp, faTerminal, faMobileButton, faHouseMedicalFlag, faBasketShopping, faShoppingBasket, faTape, faChestnut, faBusSimple, faBusAlt, faEye, faFaceSadCry, faSadCry, faHeat, faTicketAirline, faTicketPerforatedPlane, faTicketPlane, faBootHeeled, faArrowsMinimize, faCompressArrows, faAudioDescription, faPersonMilitaryToPerson, faFileShield, faHexagon, faManhole, faUserSlash, faPen, faTowerObservation, faFloppyDisks, faToiletPaperBlankUnder, faToiletPaperReverseAlt, faFileCode, faSignal, faSignal5, faSignalPerfect, faPump, faBus, faHeartCircleXmark, faArrowUpLeftFromCircle, faHouseChimney, faHomeLg, faWindowMaximize, faDryer, faFaceFrown, faFrown, faChessBishopPiece, faChessBishopAlt, faShirtTankTop, faDiploma, faScrollRibbon, faScreencast, faWalker, faPrescription, faShop, faStoreAlt, faFloppyDisk, faSave, faVihara, faFaceKissClosedEyes, faScaleUnbalanced, faBalanceScaleLeft, faFileUser, faUserPoliceTie, faFaceTongueMoney, faTennisBall, faSquareL, faSortUp, faSortAsc, faCalendarArrowUp, faCalendarUpload, faCommentDots, faCommenting, faPlantWilt, faScarf, faAlbumCirclePlus, faUserNurseHairLong, faDiamond, faSquareLeft, faArrowAltSquareLeft, faFaceGrinSquint, faGrinSquint, faCircleEllipsisVertical, faHandHoldingDollar, faHandHoldingUsd, faGridDividers, faChartDiagram, faBacterium, faHandPointer, faDrumSteelpan, faHandScissors, faHandsPraying, faPrayingHands, faFacePensive, faUserMusic, faArrowRotateRight, faArrowRightRotate, faArrowRotateForward, faRedo, faMessagesDollar, faCommentsAltDollar, faSensorOn, faBalloon, faWebAwesome, faBiohazard, faChessQueenPiece, faChessQueenAlt, faLocationCrosshairs, faLocation, faMarsDouble, faLeftFromBracket, faHousePersonLeave, faHouseLeave, faHousePersonDepart, faRulerTriangle, faCardClub, faChildDress, faUsersBetweenLines, faLungsVirus, faSpinnerThird, faFaceGrinTears, faGrinTears, faPhone, faComputerMouseScrollwheel, faMouseAlt, faCalendarXmark, faCalendarTimes, faChildReaching, faTableLayout, faNarwhal, faRampLoading, faCalendarCirclePlus, faToothbrush, faBorderInner, faPawClaws, faKiwiFruit, faTrafficLightSlow, faRectangleCode, faHeadSideVirus, faKeyboardBrightness, faBooksMedical, faLightbulbSlash, faHouseBlank, faHomeBlank, faSquare5, faSquareHeart, faHeartSquare, faPuzzle, faUserGear, faUserCog, faPipeCircleCheck, faArrowUp19, faSortNumericUp, faOctagonExclamation, faDialLow, faDoorClosed, faLaptopMobile, faPhoneLaptop, faConveyorBeltBoxes, faConveyorBeltAlt, faShieldVirus, faStarfighterTwinIonEngineAdvanced, faStarfighterAltAdvanced, faDiceSix, faStarfighterTwinIonEngine, faStarfighterAlt, faRocketLaunch, faMosquitoNet, faFileFragment, faVentDamper, faBridgeWater, faBanBug, faDebug, faPersonBooth, faTextWidth, faGarageCar, faSquareKanban, faHatWizard, faChartKanban, faPenFancy, faCoffeePot, faMouseField, faPersonDigging, faDigging, faShowerDown, faShowerAlt, faBoxCircleCheck, faBrightness, faCarSideBolt, faFileXml, faOrnament, faPhoneArrowDownLeft, faPhoneArrowDown, faPhoneIncoming, faCloudWord, faHandFingersCrossed, faTrash, faGaugeSimple, faGaugeSimpleMed, faTachometerAverage, faArrowDownSmallBig, faSortSizeDownAlt, faBookMedical, faFaceMelting, faPoo, faPenClipSlash, faPenAltSlash, faQuoteRight, faQuoteRightAlt, faScrollOld, faGuitars, faPhoneXmark, faHose, faClockSix, faShirt, faTShirt, faTshirt, faBillboard, faSquareR, faCubes, faEnvelopeOpenDollar, faDivide, faSunCloud, faLampFloor, faSquare7, faTengeSign, faTenge, faHeadphones, faHandsHolding, faCampfire, faCircleAmpersand, faSnowflakes, faHandsClapping, faRepublican, faLeafMaple, faArrowLeft, faPersonCircleXmark, faRuler, faArrowLeftFromBracket, faCupStrawSwoosh, faTemperatureSun, faTemperatureHot, faAlignLeft, faDiceD6, faRestroom, faHighDefinition, faRectangleHd, faJ, faGalaxy, faUsersViewfinder, faFileVideo, faCherries, faUpRightFromSquare, faExternalLinkAlt, faCircleSort, faSortCircle, faTableCells, faTh, faBagShoppingMinus, faFilePdf, faSiren, faArrowUpToDottedLine, faImageLandscape, faLandscape, faTankWater, faCurlingStone, faCurling, faGamepadModern, faGamepadAlt, faMessagesQuestion, faBookBible, faBible, faO, faSuitcaseMedical, faMedkit, faBriefcaseArrowRight, faExpandWide, faClockElevenThirty, faRv, faUserSecret, faOtter, faDreidel, faPersonDress, faFemale, faCommentDollar, faBusinessTime, faBriefcaseClock, faFlowerTulip, faPeoplePantsSimple, faCloudDrizzle, faTableCellsLarge, faThLarge, faBookTanakh, faTanakh, faSolarSystem, faSealQuestion, faPhoneVolume, faVolumeControlPhone, faDiscDrive, faHatCowboySide, faTableRows, faRows, faLocationExclamation, faMapMarkerExclamation, faFaceFearful, faClipboardUser, faBusSchool, faFilmSlash, faSquareArrowDownRight, faBookSparkles, faBookSpells, faWashingMachine, faWasher, faChild, faLiraSign, faUserVisor, faFilePlusMinus, faChessClockFlip, faChessClockAlt, faSatellite, faTruckFire, faPlaneLock, faSteeringWheel, faTag, faStretcher, faBookSection, faBookLaw, faInboxes, faCoffeeBean, faCircleYen, faBracketsCurly, faEllipsisStrokeVertical, faEllipsisVAlt, faComment, faSquare1, faCakeCandles, faBirthdayCake, faCake, faHeadSide, faTruckLadder, faEnvelope, faDollyEmpty, faFaceTissue, faAnglesUp, faAngleDoubleUp, faBinRecycle, faPaperclip, faChartLineDown, faArrowRightToCity, faLockA, faRibbon, faLungs, faPersonPinball, faArrowUp91, faSortNumericUpAlt, faAppleCore, faCircleY, faH6, faLitecoinSign, faBottleBaby, faCircleSmall, faBorderNone, faArrowTurnDownLeft, faCircleWifiCircleWifi, faCircleWifiGroup, faCircleNodes, faParachuteBox, faReflectHorizontal, faMessageMedical, faCommentAltMedical, faRugbyBall, faCommentMusic, faIndent, faTreeDeciduous, faTreeAlt, faPuzzlePieceSimple, faPuzzlePieceAlt, faTruckFieldUn, faNfcTrash, faHourglass, faHourglassEmpty, faMountain, faFileXmark, faFileTimes, faHouseHeart, faHomeHeart, faHouseChimneyBlank, faMeterBolt, faUserDoctor, faUserMd, faSlashBack, faCircleInfo, faInfoCircle, faFishingRod, faHammerCrash, faMessageHeart, faCloudMeatball, faCameraPolaroid, faCamera, faCameraAlt, faSquareVirus, faCartArrowUp, faMeteor, faCarOn, faSleigh, faArrowDown19, faSortNumericAsc, faSortNumericDown, faBuoyMooring, faSquare4, faHandHoldingDroplet, faHandHoldingWater, faFileEps, faTricycleAdult, faWaveform, faWater, faStarSharpHalfStroke, faStarSharpHalfAlt, faNfcSignal, faPlaneProp, faCalendarCheck, faClockDesk, faCalendarClock, faCalendarTime, faBraille, faPrescriptionBottleMedical, faPrescriptionBottleAlt, faPlateUtensils, faFamilyPants, faHoseReel, faHouseWindow, faLandmark, faTruck, faMusicMagnifyingGlass, faCrosshairs, faCloudRainbow, faPersonCane, faAlien, faTent, faLaptopBinary, faVestPatches, faPeopleDressSimple, faCheckDouble, faArrowDownAZ, faSortAlphaAsc, faSortAlphaDown, faBowlingBallPin, faBellSchoolSlash, faPlusLarge, faMoneyBillWheat, faCameraViewfinder, faScreenshot, faMessageMusic, faCommentAltMusic, faCarBuilding, faBorderBottomRight, faBorderStyleAlt, faOctagon, faCommentArrowUpRight, faOctagonDivide, faCookie, faArrowRotateLeft, faArrowLeftRotate, faArrowRotateBack, faArrowRotateBackward, faUndo, faTvMusic, faHardDrive, faHdd, faReel, faFaceGrinSquintTears, faGrinSquintTears, faDumbbell, faRectangleList, faListAlt, faTarpDroplet, faAlarmExclamation, faHouseMedicalCircleCheck, faTrafficCone, faGrate, faArrowDownRight, faPersonSkiingNordic, faSkiingNordic, faCalendarPlus, faPersonFromPortal, faPortalExit, faPlaneArrival, faCowbellCirclePlus, faCowbellMore, faCircleLeft, faArrowAltCircleLeft, faDistributeSpacingVertical, faSignalBarsFair, faSignalAlt2, faSportsball, faGameConsoleHandheldCrank, faTrainSubway, faSubway, faChartGantt, faFaceSmileUpsideDown, faBallPile, faBadgeDollar, faMoneyBillsSimple, faMoneyBillsAlt, faListTimeline, faIndianRupeeSign, faIndianRupee, faInr, faCropSimple, faCropAlt, faMoneyBill1, faMoneyBillAlt, faLeftLong, faLongArrowAltLeft, faKeyboardDown, faCircleUpRight, faCloudBoltMoon, faThunderstormMoon, faTurnLeftUp, faDna, faVirusSlash, faBracketRoundRight, faCircleSterling, faCircle5, faMinus, faSubtract, faFireFlame, faFlame, faRightToLine, faArrowAltToRight, faGif, faChess, faTrashSlash, faArrowLeftLong, faLongArrowLeft, faPlugCircleCheck, faFontCase, faStreetView, faArrowDownLeft, faFrancSign, faFlaskRoundPoison, faFlaskPoison, faVolumeOff, faBookCircleArrowRight, faChartUser, faUserChart, faHandsAslInterpreting, faAmericanSignLanguageInterpreting, faAslInterpreting, faHandsAmericanSignLanguageInterpreting, faPresentationScreen, faPresentation, faCircleBolt, faFaceSmileHalo, faCartCircleArrowDown, faHousePersonReturn, faHousePersonArrive, faHouseReturn, faMessageXmark, faCommentAltTimes, faMessageTimes, faFileCertificate, faFileAward, faUserDoctorHairLong, faCameraSecurity, faCameraHome, faGear, faCog, faDropletSlash, faTintSlash, faBookHeart, faMosque, faDuck, faMosquito, faStarOfDavid, faFlagSwallowtail, faFlagAlt, faPersonMilitaryRifle, faCarGarage, faCartShopping, faShoppingCart, faBookFont, faShieldPlus, faVials, faEyeDropperFull, faDistributeSpacingHorizontal, faTabletRugged, faTemperatureSnow, faTemperatureFrigid, faMoped, faFaceSmilePlus, faSmilePlus, faRadioTuner, faRadioAlt, faFaceSwear, faWaterArrowDown, faWaterLower, faScannerTouchscreen, faCircle7, faPlugCirclePlus, faPersonSkiJumping, faSkiJump, faPlaceOfWorship, faWaterArrowUp, faWaterRise, faWaveformLines, faWaveformPath, faSplit, faFilmCanister, faFilmCannister, faFolderXmark, faFolderTimes, faToiletPaperBlank, faToiletPaperAlt, faTabletScreen, faTabletAndroidAlt, faHexagonVerticalNftSlanted, faFolderMusic, faDisplayMedical, faDesktopMedical, faShareAll, faPeapod, faChessClock, faAxe, faSquareD, faGripVertical, faMobileSignalOut, faHexagonNodes, faArrowTurnUp, faLevelUp, faU, faArrowUpFromDottedLine, faSquareRootVariable, faSquareRootAlt, faLightSwitchOn, faArrowDownArrowUp, faSortAlt, faRaindrops, faDash, faMinusLarge, faClock, faClockFour, faInputNumeric, faTruckTow, faBackwardStep, faStepBackward, faPallet, faCarBolt, faArrowsMaximize, faExpandArrows, faFaucet, faCloudSleet, faLampStreet, faListRadio, faPenNibSlash, faBaseballBatBall, faSquareUpLeft, faOverline, faS, faTimeline, faKeyboard, faArrowsFromDottedLine, faUsbDrive, faBallot, faCaretDown, faLocationDotSlash, faMapMarkerAltSlash, faCards, faHouseChimneyMedical, faClinicMedical, faBoxingGlove, faGloveBoxing, faTemperatureThreeQuarters, faTemperature3, faThermometer3, faThermometerThreeQuarters, faBellSchool, faMobileScreen, faMobileAndroidAlt, faPlaneUp, faFolderHeart, faCircleLocationArrow, faLocationCircle, faFaceHeadBandage, faSushiRoll, faMakiRoll, faMakizushi, faCarBump, faPiggyBank, faRacquet, faCarMirrors, faIndustryWindows, faIndustryAlt, faBoltAuto, faBatteryHalf, faBattery3, faFluxCapacitor, faMountainCity, faCoins, faHoneyPot, faOlive, faKhanda, faFilterList, faOutlet, faSliders, faCauldron, faPeople, faFolderTree, faNetworkWired, faCroissant, faMapPin, faHamsa, faCentSign, faSwordsLaser, faFlask, faPersonPregnant, faSquareU, faWandSparkles, faRouter, faEllipsisVertical, faEllipsisV, faSwordLaserAlt, faTicket, faPowerOff, faCoin, faLaptopSlash, faRightLong, faLongArrowAltRight, faCircleB, faPersonDressSimple, faPipeCollar, faLightsHoliday, faCitrus, faFlagUsa, faLaptopFile, faTty, faTeletype, faChartTreeMap, faDiagramNext, faPersonRifle, faClockFiveThirty, faPipeValve, faLightbulbMessage, faArrowUpFromArc, faFaceSpiralEyes, faCompressWide, faCirclePhoneHangup, faPhoneCircleDown, faGearComplexCode, faHouseMedicalCircleExclamation, faBadminton, faClosedCaptioning, faPersonHiking, faHiking, faRightFromLine, faArrowAltFromLeft, faVenusDouble, faImages, faCalculator, faShuttlecock, faUserHair, faEyeEvil, faPeoplePulling, faN, faSwap, faGarage, faCableCar, faTram, faShovelSnow, faCloudRain, faFaceLying, faSprinkler, faBuildingCircleXmark, faPersonSledding, faSledding, faGameConsoleHandheld, faShip, faClockSixThirty, faBatterySlash, faTugrikSign, faArrowsDownToLine, faDownload, faAnglesUpDown, faShelves, faInventory, faCloudSnow, faFaceGrin, faGrin, faDeleteLeft, faBackspace, faOven, faCloudBinary, faEyeDropper, faEyeDropperEmpty, faEyedropper, faCommentCaptions, faCommentsQuestion, faScribble, faRotateExclamation, faFileCircleCheck, faGlass, faLoader, faForward, faUserPilot, faMobile, faMobileAndroid, faMobilePhone, faCodePullRequestClosed, faFaceMeh, faMeh, faAlignCenter, faBookSkull, faBookDead, faIdCard, faDriversLicense, faFaceDotted, faFaceWorried, faOutdent, faDedent, faCourtSport, faHeartCircleExclamation, faHouse, faHome, faHomeAlt, faHomeLgAlt, faVectorCircle, faCarCircleBolt, faCalendarWeek, faFlyingDisc, faLaptopMedical, faSquareDownRight, faB, faSeatAirline, faMoonOverSun, faEclipseAlt, faPipe, faFileMedical, faPotato, faDiceOne, faCircleA, faHelmetBattle, faButter, faBlanketFire, faKiwiBird, faCastle, faGolfClub, faArrowRightArrowLeft, faExchange, faRotateRight, faRedoAlt, faRotateForward, faUtensils, faCutlery, faArrowUpWideShort, faSortAmountUp, faChartPieSimpleCircleDollar, faBalloons, faMillSign, faBowlRice, faTimelineArrow, faSkull, faGameBoardSimple, faGameBoardAlt, faCircleVideo, faVideoCircle, faChartScatterBubble, faHouseTurret, faBanana, faHandHoldingSkull, faPeopleDress, faLoveseat, faCouchSmall, faTowerBroadcast, faBroadcastTower, faTruckPickup, faBlockQuote, faUpLong, faLongArrowAltUp, faStop, faCodeMerge, faMoneyCheckDollarPen, faMoneyCheckEditAlt, faUpFromLine, faArrowAltFromBottom, faUpload, faHurricane, faGridRound2Plus, faPeoplePants, faMound, faWindsock, faCircleHalf, faBrakeWarning, faToiletPortable, faCompactDisc, faFileArrowDown, faFileDownload, faSaxophoneFire, faSaxHot, faCameraWebSlash, faWebcamSlash, faFolderMedical, faFolderGear, faFolderCog, faHandWave, faArrowUpArrowDown, faSortUpDown, faCaravan, faShieldCat, faMessageSlash, faCommentAltSlash, faBolt, faZap, faTrashCanCheck, faGlassWater, faOilWell, faTableCellsColumnUnlock, faPersonSimple, faArrowTurnLeftUp, faVault, faMars, faToilet, faPlaneCircleXmark, faYenSign, faCny, faJpy, faRmb, faYen, faGearCode, faNotes, faRubleSign, faRouble, faRub, faRuble, faTrashUndo, faTrashArrowTurnLeft, faChampagneGlass, faGlassChampagne, faObjectsAlignCenterHorizontal, faSun, faTrashCanSlash, faTrashAltSlash, faScreenUsers, faUsersClass, faGuitar, faSquareArrowLeft, faArrowSquareLeft, faSquare8, faFaceSmileHearts, faBracketsSquare, faBrackets, faLaptopArrowDown, faHockeyStickPuck, faHouseTree, faSignalFair, faSignal2, faFaceLaughWink, faLaughWink, faCircleDollar, faDollarCircle, faUsdCircle, faHorseHead, faArrowsRepeat, faRepeatAlt, faBoreHole, faIndustry, faImagePolaroid, faWaveTriangle, faTurnLeftDown, faPersonRunningFast, faCircleDown, faArrowAltCircleDown, faGrill, faArrowsTurnToDots, faChartMixed, faAnalytics, faFlorinSign, faArrowDownShortWide, faSortAmountDesc, faSortAmountDownAlt, faLessThan, faDisplayCode, faDesktopCode, faFaceDrooling, faOilTemperature, faOilTemp, faSquareQuestion, faQuestionSquare, faAirConditioner, faAngleDown, faMountains, faOmega, faCarTunnel, faPersonDollyEmpty, faPanFood, faHeadSideCough, faGripLines, faThumbsDown, faUserLock, faArrowRightLong, faLongArrowRight, faTicketsAirline, faTicketsPerforatedPlane, faTicketsPlane, faTentDoublePeak, faAnchorCircleXmark, faEllipsis, faEllipsisH, faNfcSlash, faChessPawn, faKitMedical, faFirstAid, faGrid2Plus, faBells, faPersonThroughWindow, faToolbox, faGlobeWifi, faEnvelopeDot, faEnvelopeBadge, faMagnifyingGlassWaveform, faHandsHoldingCircle, faBug, faBowlChopsticks, faCreditCard, faCreditCardAlt, faCircleS, faBoxBallot, faCar, faAutomobile, faHandHoldingHand, faUserTieHair, faPodiumStar, faUserHairMullet, faBusinessFront, faPartyBack, faTrianBalbot, faMicrophoneStand, faBookOpenReader, faBookReader, faFamilyDress, faCircleX, faCabin, faMountainSun, faChartSimpleHorizontal, faBluetooth, faArrowsLeftRightToLine, faHandBackPointLeft, faMessageDots, faCommentAltDots, faMessaging, faFileHeart, faBeerMug, faBeerFoam, faDiceD20, faDrone, faTruckDroplet, faFileCircleXmark, faTemperatureArrowUp, faTemperatureUp, faMedal, faPersonFairy, faBed, faBookCopy, faSquareH, faHSquare, faSquareC, faClockTwo, faSquareEllipsisVertical, faCalendarUsers, faPodcast, faBee, faTemperatureFull, faTemperature4, faThermometer4, faThermometerFull, faBell, faCandyBar, faChocolateBar, faXmarkLarge, faPinata, faFilePpt, faArrowsFromLine, faSuperscript, faBowlSpoon, faHexagonCheck, faPlugCircleXmark, faStarOfLife, faPhoneSlash, faTrafficLightStop, faPaintRoller, faAccentGrave, faHandshakeAngle, faHandsHelping, faCircle0, faDialMedLow, faLocationDot, faMapMarkerAlt, faCrab, faBoxOpenFull, faBoxFull, faFile, faGreaterThan, faQuotes, faPretzel, faTRex, faPersonSwimming, faSwimmer, faArrowDown, faUserRobotXmarks, faMessageQuote, faCommentAltQuote, faCandyCorn, faFolderMagnifyingGlass, faFolderSearch, faNotebook, faCircleWifi, faDroplet, faTint, faBullseyePointer, faEraser, faHexagonImage, faEarthAmericas, faEarth, faEarthAmerica, faGlobeAmericas, faFileSvg, faCrateApple, faAppleCrate, faPersonBurst, faGameBoard, faHatChef, faHandBackPointRight, faDove, faSnowflakeDroplets, faBatteryEmpty, faBattery0, faGrid4, faSocks, faFaceSunglasses, faInbox, faSquare0, faSection, faSquareThisWayUp, faBoxUp, faGaugeHigh, faTachometerAlt, faTachometerAltFast, faSquareAmpersand, faEnvelopeOpenText, faLampDesk, faHospital, faHospitalAlt, faHospitalWide, faPollPeople, faWhiskeyGlassIce, faGlassWhiskeyRocks, faWineBottle, faChessRook, faUserBountyHunter, faBarsStaggered, faReorder, faStream, faDiagramSankey, faCloudHailMixed, faCircleUpLeft, faDharmachakra, faObjectsAlignLeft, faOilCanDrip, faFaceSmilingHands, faBroccoli, faRouteInterstate, faEarMuffs, faHotdog, faTransporterEmpty, faPersonWalkingWithCane, faBlind, faAngle90, faRectangleTerminal, faKite, faDrum, faScrubber, faIceCream, faHeartCircleBolt, faFishBones, faDeerRudolph, faFax, faParagraph, faHeadSideHeart, faSquareE, faMeterFire, faCloudHail, faCheckToSlot, faVoteYea, faMoneyFromBracket, faStarHalf, faCarBus, faSpeaker, faTimer, faBoxesStacked, faBoxes, faBoxesAlt, faLandmarkMagnifyingGlass, faGrillHot, faBallotCheck, faLink, faChain, faEarListen, faAssistiveListeningSystems, faFileMinus, faTreeCity, faPlay, faFont, faCupTogo, faCoffeeTogo, faSquareDownLeft, faBurgerLettuce, faTableCellsRowLock, faRupiahSign, faMagnifyingGlass, faTableTennisPaddleBall, faPingPongPaddleBall, faTableTennis, faPersonDotsFromLine, faDiagnoses, faChevronsDown, faChevronDoubleDown, faTrashCanArrowUp, faTrashRestoreAlt, faSignalGood, faSignal3, faLocationQuestion, faMapMarkerQuestion, faFloppyDiskCircleXmark, faFloppyDiskTimes, faSaveCircleXmark, faSaveTimes, faNairaSign, faPeach, faCirclesOverlap3, faPronoun, faTaxiBus, faBracketCurly, faBracketCurlyLeft, faLobster, faCartFlatbedEmpty, faDollyFlatbedEmpty, faColon, faCartArrowDown, faWand, faWalkieTalkie, faFilePen, faFileEdit, faReceipt, faTablePicnic, faSquarePen, faPenSquare, faPencilSquare, faCircleMicrophoneLines, faMicrophoneCircleAlt, faDisplaySlash, faDesktopSlash, faSuitcaseRolling, faPersonCircleExclamation, faTransporter2, faUserHoodie, faHandsHoldingDiamond, faHandReceiving, faMoneyBillSimpleWave, faChevronDown, faBatteryFull, faBattery, faBattery5, faBellPlus, faBookArrowRight, faHospitals, faClub, faSkullCrossbones, faDropletDegree, faDewpoint, faCodeCompare, faListUl, faListDots, faHandHoldingMagic, faWatermelonSlice, faCircleEllipsis, faSchoolLock, faTowerCell, faSdCards, faJugBottle, faDownLong, faLongArrowAltDown, faEnvelopes, faPhoneOffice, faRankingStar, faChessKing, faNfcPen, faPersonHarassing, faMagnifyingGlassPlay, faHatWinter, faBrazilianRealSign, faLandmarkDome, faLandmarkAlt, faBoneBreak, faArrowUp, faDownFromDottedLine, faTv, faTelevision, faTvAlt, faBorderLeft, faCircleDivide, faShrimp, faListCheck, faTasks, faDiagramSubtask, faJugDetergent, faCircleUser, faUserCircle, faSquareY, faUserDoctorHair, faPlanetRinged, faMushroom, faUserShield, faMegaphone, faWreathLaurel, faCircleExclamationCheck, faWind, faBoxDollar, faBoxUsd, faCarBurst, faCarCrash, faY, faUserHeadset, faArrowsRetweet, faRetweetAlt, faPersonSnowboarding, faSnowboarding, faSquareChevronRight, faChevronSquareRight, faLacrosseStickBall, faTruckFast, faShippingFast, faUserMagnifyingGlass, faStarSharp, faCommentHeart, faCircle1, faCircleStar, faStarCircle, faFish, faCloudFog, faFog, faWaffle, faMusicNote, faMusicAlt, faHexagonExclamation, faCartShoppingFast, faObjectUnion, faUserGraduate, faStarfighter, faCircleHalfStroke, faAdjust, faArrowRightLongToLine, faSquareArrowDown, faArrowSquareDown, faDiamondHalfStroke, faClapperboard, faSquareChevronLeft, faChevronSquareLeft, faPhoneIntercom, faLinkHorizontal, faChainHorizontal, faMango, faMusicNoteSlash, faMusicAltSlash, faCircleRadiation, faRadiationAlt, faFaceTongueSweat, faGlobeStand, faBaseball, faBaseballBall, faCircleP, faAwardSimple, faJetFighterUp, faDiagramProject, faProjectDiagram, faPedestal, faChartPyramid, faSidebar, faSnowmanHead, faFrostyHead, faCopy, faBurgerGlass, faVolumeXmark, faVolumeMute, faVolumeTimes, faHandSparkles, faBarsFilter, faPaintbrushPencil, faPartyBell, faUserVneckHair, faJackOLantern, faGrip, faGripHorizontal, faShareFromSquare, faShareSquare, faKeynote, faChildCombatant, faChildRifle, faGun, faSquarePhone, faPhoneSquare, faHatBeach, faPlus, faAdd, faExpand, faComputer, faFort, faCloudCheck, faXmark, faClose, faMultiply, faRemove, faTimes, faFaceSmirking, faArrowsUpDownLeftRight, faArrows, faChalkboardUser, faChalkboardTeacher, faRhombus, faClawMarks, faPesoSign, faFaceSmileTongue, faCartCircleXmark, faBuildingShield, faCirclePhoneFlip, faPhoneCircleAlt, faBaby, faUsersLine, faQuoteLeft, faQuoteLeftAlt, faTractor, faDownFromBracket, faKeySkeleton, faTrashArrowUp, faTrashRestore, faArrowDownUpLock, faArrowDownToBracket, faLinesLeaning, faSquareQ, faRulerCombined, faSymbols, faIconsAlt, faCopyright, faFlaskGear, faHighlighterLine, faBracketSquare, faBracket, faBracketLeft, faIslandTropical, faIslandTreePalm, faArrowRightFromLine, faArrowFromLeft, faH2, faEquals, faCakeSlice, faShortcake, faBuildingMagnifyingGlass, faPeanut, faWrenchSimple, faBlender, faTeeth, faTally2, faShekelSign, faIls, faShekel, faSheqel, faSheqelSign, faCars, faAxeBattle, faUserHairLong, faMap, faArrowLeftFromArc, faFileCircleInfo, faFaceDisappointed, faLassoSparkles, faClockEleven, faRocket, faSirenOn, faClockTen, faCandleHolder, faVideoArrowDownLeft, faPhotoFilm, faPhotoVideo, faFloppyDiskCircleArrowRight, faSaveCircleArrowRight, faFolderMinus, faHexagonNodesBolt, faPlanetMoon, faFaceEyesXmarks, faChartScatter, faCircleGf, faDisplayArrowDown, faStore, faArrowTrendUp, faPlugCircleMinus, faOliveBranch, faAngle, faVacuumRobot, faSignHanging, faSign, faSquareDivide, faFolderCheck, faSignalStreamSlash, faBezierCurve, faEyeDropperHalf, faStoreLock, faBellSlash, faCloudBoltSun, faThunderstormSun, faCameraSlash, faCommentQuote, faTablet, faTabletAndroid, faSchoolFlag, faMessageCode, faGlassHalf, faGlassHalfEmpty, faGlassHalfFull, faFill, faMessageMinus, faCommentAltMinus, faAngleUp, faDinosaur, faDrumstickBite, faLinkHorizontalSlash, faChainHorizontalSlash, faHollyBerry, faNose, faArrowLeftToArc, faChevronLeft, faBacteria, faClouds, faMoneyBillSimple, faHandLizard, faTablePivot, faFilterSlash, faTrashCanUndo, faTrashCanArrowTurnLeft, faTrashUndoAlt, faNotdef, faDisease, faPersonToDoor, faTurntable, faBriefcaseMedical, faGenderless, faChevronRight, faSignalWeak, faSignal1, faClockFive, faRetweet, faCarRear, faCarAlt, faPumpSoap, faComputerClassic, faFrame, faVideoSlash, faBatteryQuarter, faBattery2, faEllipsisStroke, faEllipsisHAlt, faRadio, faBabyCarriage, faCarriageBaby, faFaceExpressionless, faDownToDottedLine, faCloudMusic, faTrafficLight, faCloudMinus, faThermometer, faShieldMinus, faVrCardboard, faCarTilt, faGaugeCircleMinus, faBrightnessLow, faHandMiddleFinger, faPercent, faPercentage, faTruckMoving, faGlassWaterDroplet, faConveyorBelt, faLocationCheck, faMapMarkerCheck, faCoinVertical, faDisplay, faPersonSign, faFaceSmile, faSmile, faPhoneHangup, faSignatureSlash, faThumbtack, faThumbTack, faWheatSlash, faTrophy, faCloudsSun, faPersonPraying, faPray, faHammer, faFaceVomit, faSpeakers, faTtyAnswer, faTeletypeAnswer, faMugTeaSaucer, faDiagramLeanCanvas, faAlt, faDial, faDialMedHigh, faHandPeace, faCircleTrash, faTrashCircle, faRotate, faSyncAlt, faCircleQuarters, faSpinner, faTowerControl, faArrowUpTriangleSquare, faSortShapesUp, faWhale, faRobot, faPeace, faPartyHorn, faGears, faCogs, faSunBright, faSunAlt, faWarehouse, faConveyorBeltArm, faLockKeyholeOpen, faLockOpenAlt, faSquareFragile, faBoxFragile, faSquareWineGlassCrack, faArrowUpRightDots, faSquareN, faSplotch, faFaceGrinHearts, faGrinHearts, faMeter, faMandolin, faDiceFour, faSimCard, faTransgender, faTransgenderAlt, faMercury, faUpFromBracket, faKnifeKitchen, faBorderRight, faArrowTurnDown, faLevelDown, faSpade, faCardSpade, faLineColumns, faAnt, faArrowRightToLine, faArrowToRight, faPersonFallingBurst, faFlagPennant, faPennant, faConveyorBeltEmpty, faUserGroupSimple, faAward, faTicketSimple, faTicketAlt, faBuilding, faAnglesLeft, faAngleDoubleLeft, faCamcorder, faVideoHandheld, faPancakes, faAlbumCircleUser, faSubtitlesSlash, faQrcode, faDiceD10, faFireplace, faBrowser, faPenPaintbrush, faPencilPaintbrush, faFishCooked, faChairOffice, faMagnifyingGlassMusic, faNestingDolls, faClockRotateLeft, faHistory, faTrumpet, faFaceGrinBeamSweat, faGrinBeamSweat, faFireSmoke, faPhoneMissed, faFileExport, faArrowRightFromFile, faShield, faShieldBlank, faArrowUpShortWide, faSortAmountUpAlt, faArrowsRepeat1, faRepeat1Alt, faGunSlash, faAvocado, faBinary, faCommentNodes, faGlassesRound, faGlassesAlt, faPhonePlus, faDitto, faPersonSeat, faHouseMedical, faGolfBallTee, faGolfBall, faCircleChevronLeft, faChevronCircleLeft, faHouseChimneyWindow, faScythe, faPenNib, faBanParking, faParkingCircleSlash, faTentArrowTurnLeft, faFaceDiagonalMouth, faDiagramCells, faCricketBatBall, faCricket, faTents, faWandMagic, faMagic, faDog, faPenLine, faAtomSimple, faAtomAlt, faAmpersand, faCarrot, faArrowUpFromLine, faArrowFromBottom, faMoon, faPenSlash, faWineGlassEmpty, faWineGlassAlt, faSquareStar, faCheese, faSendBackward, faYinYang, faMusic, faCompassSlash, faClockOne, faFileMusic, faCodeCommit, faTemperatureLow, faPersonBiking, faBiking, faDisplayChartUpCircleCurrency, faSkeleton, faCircleG, faCircleArrowUpLeft, faCoinBlank, faBroom, faVacuum, faShieldHeart, faCardHeart, faLightbulbCflOn, faMelon, faGopuram, faEarthOceania, faGlobeOceania, faContainerStorage, faFacePouting, faSquareXmark, faTimesSquare, faXmarkSquare, faFaceExplode, faExplodingHead, faHashtag, faUpRightAndDownLeftFromCenter, faExpandAlt, faOilCan, faT, faTransformerBolt, faHippo, faChartColumn, faCassetteVhs, faVhs, faInfinity, faVialCircleCheck, faChimney, faObjectIntersect, faPersonArrowDownToLine, faVoicemail, faBlockBrick, faWallBrick, faFan, faBagsShopping, faParagraphLeft, faParagraphRtl, faPersonWalkingLuggage, faCaravanSimple, faCaravanAlt, faTurtle, faPencilMechanical, faUpDown, faArrowsAltV, faCloudMoonRain, faBoothCurtain, faCalendar, faBoxHeart, faTrailer, faUserDoctorMessage, faUserMdChat, faBahai, faHaykal, faLighthouse, faAmpGuitar, faSdCard, faVolumeSlash, faBorderBottom, faWifiWeak, faWifi1, faDragon, faShoePrints, faCirclePlus, faPlusCircle, faFaceGrinTongueWink, faGrinTongueWink, faHandHolding, faPlugCircleExclamation, faLinkSlash, faChainBroken, faChainSlash, faUnlink, faClone, faPersonWalkingArrowLoopLeft, faArrowUpZA, faSortAlphaUpAlt, faFireFlameCurved, faFireAlt, faTornado, faFileCirclePlus, faDeleteRight, faBookQuran, faQuran, faCircleQuarter, faAnchor, faBorderAll, faFunction, faFaceAngry, faAngry, faPeopleSimple, faCookieBite, faArrowTrendDown, faRss, faFeed, faFaceMonocle, faDrawPolygon, faScaleBalanced, faBalanceScale, faCalendarLines, faCalendarNote, faArrowDownBigSmall, faSortSizeDown, faGaugeSimpleHigh, faTachometer, faTachometerFast, faDoNotEnter, faShower, faDiceD8, faDesktop, faDesktopAlt, faM, faSpinnerScale, faGripDotsVertical, faFaceViewfinder, faSoftServe, faCreemee, faH5, faHandBackPointDown, faTableList, faThList, faBasketShoppingMinus, faCommentSms, faSms, faRectangle, faRectangleLandscape, faClipboardListCheck, faTurkey, faBook, faUserPlus, faIceSkate, faCheck, faBatteryThreeQuarters, faBattery4, faTomato, faSwordLaser, faHouseCircleCheck, faBuildings, faAngleLeft, faCartFlatbedBoxes, faDollyFlatbedAlt, faDiagramSuccessor, faTruckArrowRight, faSquareW, faArrowsSplitUpAndLeft, faLamp, faAirplay, faHandFist, faFistRaised, faShieldQuartered, faSlashForward, faLocationPen, faMapMarkerEdit, faCloudMoon, faPotFood, faBriefcase, faPersonFalling, faImagePortrait, faPortrait, faUserTag, faRug, faPrintSlash, faEarthEurope, faGlobeEurope, faCartFlatbedSuitcase, faLuggageCart, faHandBackPointRibbon, faRectangleXmark, faRectangleTimes, faTimesRectangle, faWindowClose, faTireRugged, faLightbulbDollar, faCowbell, faBahtSign, faCorner, faChevronsRight, faChevronDoubleRight, faBookOpen, faBookJournalWhills, faJournalWhills, faInhaler, faHandcuffs, faSnake, faTriangleExclamation, faExclamationTriangle, faWarning, faNoteMedical, faDatabase, faDownLeft, faShare, faMailForward, faFaceThinking, faTurnDownRight, faBottleDroplet, faMaskFace, faHillRockslide, faScannerKeyboard, faCircleO, faGridHorizontal, faMessageDollar, faCommentAltDollar, faRightLeft, faExchangeAlt, faColumns3, faPaperPlane, faRoadCircleExclamation, faDungeon, faHandHoldingBox, faInputText, faWindowFlip, faWindowAlt, faAlignRight, faScannerGun, faScanner, faTire, faEngine, faMoneyBill1Wave, faMoneyBillWaveAlt, faLifeRing, faHands, faSignLanguage, faSigning, faCircleCaretRight, faCaretCircleRight, faTurnLeft, faWheat, faFileSpreadsheet, faAudioDescriptionSlash, faBellRing, faCalendarDay, faWaterLadder, faLadderWater, faSwimmingPool, faArrowsUpDown, faArrowsV, faChessPawnPiece, faChessPawnAlt, faFaceGrimace, faGrimace, faWheelchairMove, faWheelchairAlt, faTurnDown, faLevelDownAlt, faSquareS, faRectangleBarcode, faBarcodeAlt, faPersonWalkingArrowRight, faSquareEnvelope, faEnvelopeSquare, faDice, faUnicorn, faBowlingBall, faPompebled, faBrain, faWatchSmart, faBookUser, faSensorCloud, faSensorSmoke, faClapperboardPlay, faBandage, faBandAid, faCalendarMinus, faTimesCircle, faXmarkCircle, faCircle4, faGifts, faAlbumCollection, faHotel, faEarthAsia, faGlobeAsia, faIdCardClip, faIdCardAlt, faMagnifyingGlassPlus, faSearchPlus, faThumbsUp, faCloudShowers, faUserClock, faOnion, faClockTwelveThirty, faArrowDownToDottedLine, faHandDots, faAllergies, faFileInvoice, faWindowMinimize, faRectangleWide, faCommentArrowUp, faGarlic, faMugSaucer, faCoffee, faBrush, faFileHalfDashed, faTreeDecorated, faMask, faCalendarHeart, faMagnifyingGlassMinus, faSearchMinus, faFlower, faArrowDownFromArc, faRightLeftLarge, faRulerVertical, faCirclesOverlap, faUserLarge, faUserAlt, faStarshipFreighter, faTrainTram, faBridgeSuspension, faTrashCheck, faUserNurse, faBoombox, faSyringe, faCloudSun, faShieldExclamation, faStopwatch20, faSquareFull, faGripDots, faCommentExclamation, faPenSwirl, faFalafel, faCircle2, faMagnet, faJar, faGramophone, faDiceD12, faNoteSticky, faStickyNote, faDown, faArrowAltDown, faHundredPoints, fa100, faPaperclipVertical, faWindWarning, faWindCircleExclamation, faLocationPinSlash, faMapMarkerSlash, faFaceSadSweat, faBugSlash, faCupcake, faLightSwitchOff, faToggleLargeOff, faPenFancySlash, faTruckContainer, faBoot, faArrowUpFromWaterPump, faFileCheck, faBone, faCardsBlank, faCircle3, faBenchTree, faKeyboardBrightnessLow, faSkiBootSki, faBrainCircuit, faTableCellsRowUnlock, faUserInjured, faBlockBrickFire, faFirewall, faFaceSadTear, faSadTear, faPlane, faTentArrowsDown, faExclamation, faArrowsSpin, faFaceSmileRelaxed, faCommentXmark, faCommentTimes, faPrint, faTurkishLiraSign, faTry, faTurkishLira, faFaceNoseSteam, faCircleWaveformLines, faWaveformCircle, faDollarSign, faDollar, faUsd, faFerrisWheel, faComputerSpeaker, faSkullCow, faX, faMagnifyingGlassDollar, faSearchDollar, faUsersGear, faUsersCog, faPersonMilitaryPointing, faBuildingColumns, faBank, faInstitution, faMuseum, faUniversity, faCircleT, faSack, faGrid2, faCameraCctv, faCctv, faUmbrella, faTrowel, faHorizontalRule, faBedFront, faBedAlt, faD, faStapler, faMasksTheater, faTheaterMasks, faFileGif, faKipSign, faFaceWoozy, faCloudQuestion, faPineapple, faHandPointLeft, faGalleryThumbnails, faCircleJ, faEyes, faHandshakeSimple, faHandshakeAlt, faPageCaretUp, faFileCaretUp, faJetFighter, faFighterJet, faComet, faSquareShareNodes, faShareAltSquare, faReflectVertical, faShieldKeyhole, faFileMp4, faBarcode, faBulldozer, faPlusMinus, faSquareSlidersVertical, faSlidersVSquare, faVideo, faVideoCamera, faMessageMiddle, faCommentMiddleAlt, faGraduationCap, faMortarBoard, faHandHoldingMedical, faPersonCircleCheck, faSquareZ, faMessageText, faCommentAltText, faTurnUp, faLevelUpAlt */
/*!
 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const prefix = "far";
const fa0 = {
  prefix: 'far',
  iconName: '0',
  icon: [320, 512, [], "30", "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 80C98.1 80 48 130.1 48 192l0 128c0 61.9 50.1 112 112 112s112-50.1 112-112l0-128c0-61.9-50.1-112-112-112z"]
};
const fa1 = {
  prefix: 'far',
  iconName: '1',
  icon: [256, 512, [], "31", "M152 56c0-8.7-4.7-16.7-12.3-21s-16.9-4-24.3 .5l-104 64c-11.3 6.9-14.8 21.7-7.9 33s21.7 14.8 33 7.9L104 98.9 104 432l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-376z"]
};
const fa2 = {
  prefix: 'far',
  iconName: '2',
  icon: [320, 512, [], "32", "M147.6 80c-26.6 0-52.2 10.6-71 29.4L41 145c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L42.6 75.5C70.4 47.6 108.2 32 147.6 32l7.3 0C232.8 32 296 95.2 296 173.2c0 39.1-16.2 76.4-44.7 103.1L84.8 432 296 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-9.9 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L218.5 241.2c18.8-17.6 29.5-42.2 29.5-68c0-51.5-41.7-93.2-93.2-93.2l-7.3 0z"]
};
const fa3 = {
  prefix: 'far',
  iconName: '3',
  icon: [320, 512, [], "33", "M0 56C0 42.7 10.7 32 24 32l256 0c9.8 0 18.6 6 22.3 15.1s1.4 19.5-5.7 26.3L147.7 216l40.3 0c72.9 0 132 59.1 132 132s-59.1 132-132 132l-90.6 0c-39.4 0-75.4-22.3-93-57.5l-1.9-3.8c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l1.9 3.8c9.5 19 28.9 31 50.1 31l90.6 0c46.4 0 84-37.6 84-84s-37.6-84-84-84L88 264c-9.8 0-18.6-6-22.3-15.1s-1.4-19.5 5.7-26.3L220.3 80 24 80C10.7 80 0 69.3 0 56z"]
};
const fa4 = {
  prefix: 'far',
  iconName: '4',
  icon: [384, 512, [], "34", "M189.2 67.2c6.2-11.7 1.7-26.2-10-32.4s-26.2-1.7-32.4 10l-144 272c-3.9 7.4-3.7 16.4 .6 23.6S15.6 352 24 352l248 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152L63.9 304 189.2 67.2z"]
};
const fa5 = {
  prefix: 'far',
  iconName: '5',
  icon: [320, 512, [], "35", "M32.4 51.9C34.4 40.4 44.3 32 56 32l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L76.2 80 52.5 216 188 216c72.9 0 132 59.1 132 132s-59.1 132-132 132l-95.5 0c-36.4 0-69.6-20.5-85.9-53.1l-4.1-8.2c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l4.1 8.2C57.7 421.7 74.3 432 92.5 432l95.5 0c46.4 0 84-37.6 84-84s-37.6-84-84-84L24 264c-7.1 0-13.8-3.1-18.4-8.6S-.9 242.9 .4 235.9l32-184z"]
};
const fa6 = {
  prefix: 'far',
  iconName: '6',
  icon: [320, 512, [], "36", "M272 320c0-61.9-50.1-112-112-112c-32.3 0-61.5 13.7-81.9 35.6l-5.1 6.3C56.8 269.7 48 294.5 48 320c0 61.9 50.1 112 112 112s112-50.1 112-112zM145.7 160.6c4.7-.4 9.5-.6 14.3-.6c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-41.5 15.8-79.4 41.8-107.8L181.4 40.8c8.4-10.3 23.5-11.8 33.8-3.4s11.8 23.5 3.4 33.8l-72.9 89.5z"]
};
const fa7 = {
  prefix: 'far',
  iconName: '7',
  icon: [320, 512, [], "37", "M0 56C0 42.7 10.7 32 24 32l272 0c8.6 0 16.6 4.7 20.9 12.2s4.1 16.8-.3 24.2l-240 400c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9L253.6 80 24 80C10.7 80 0 69.3 0 56z"]
};
const fa8 = {
  prefix: 'far',
  iconName: '8',
  icon: [320, 512, [], "38", "M304 156c0-68.5-55.5-124-124-124l-40 0C71.5 32 16 87.5 16 156c0 37.7 16.8 71.4 43.3 94.2C23.7 272 0 311.2 0 356c0 68.5 55.5 124 124 124l72 0c68.5 0 124-55.5 124-124c0-44.8-23.7-84-59.3-105.8C287.2 227.4 304 193.7 304 156zM180.1 280l15.9 0c42 0 76 34 76 76s-34 76-76 76l-72 0c-42 0-76-34-76-76s34-76 76-76l15.9 0c0 0 0 0 .1 0l40 0c0 0 0 0 .1 0zm0-48c0 0 0 0 0 0l-40 0c0 0 0 0 0 0c-42 0-76-34-76-76c0-42 34-76 76-76l40 0c42 0 76 34 76 76c0 42-34 76-76 76z"]
};
const fa9 = {
  prefix: 'far',
  iconName: '9',
  icon: [320, 512, [], "39", "M48 192c0 61.9 50.1 112 112 112c32.3 0 61.5-13.7 81.9-35.6l5.1-6.3C263.2 242.3 272 217.5 272 192c0-61.9-50.1-112-112-112S48 130.1 48 192zM174.3 351.4c-4.7 .4-9.5 .6-14.3 .6C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 41.5-15.8 79.4-41.8 107.8L138.6 471.2c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l72.9-89.5z"]
};
const faFillDrip = {
  prefix: 'far',
  iconName: 'fill-drip',
  icon: [576, 512, [], "f576", "M39 7C48.4-2.3 63.6-2.3 73 7l89.4 89.4 58.7-58.7c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l97.8-97.8L39 41C29.7 31.6 29.7 16.4 39 7zM231 233l-68.7-68.7L64.6 262.1c-7.3 7.3-11.8 16.4-13.4 25.9l358.2 0 31-31c9.4-9.4 9.4-24.6 0-33.9L289 71.6c-9.4-9.4-24.6-9.4-33.9 0l-58.7 58.7L265 199c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"]
};
const faArrowsToCircle = {
  prefix: 'far',
  iconName: 'arrows-to-circle',
  icon: [640, 512, [], "e4bd", "M7 7C16.4-2.3 31.6-2.3 41 7l119 119L160 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l38.1 0L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-119 119 38.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 38.1L599 7c9.4-9.4 24.6-9.4 33.9 0zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM432 424l0-96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-38.1 0L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119 0 38.1c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-224 0c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-38.1L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119L88 352c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 96z"]
};
const faCircleChevronRight = {
  prefix: 'far',
  iconName: 'circle-chevron-right',
  icon: [512, 512, ["chevron-circle-right"], "f138", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377L345 273c9.4-9.4 9.4-24.6 0-33.9L241 135c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
const faChevronCircleRight = faCircleChevronRight;
const faWagonCovered = {
  prefix: 'far',
  iconName: 'wagon-covered',
  icon: [640, 512, [], "f8ee", "M569.8 4.1c45.9-3.1 79.9 41.8 64.6 85.2L567.8 278c5 4.4 8.2 10.9 8.2 18c0 12.9-10.2 23.5-23 24c0 0 0 0 0 0l-10.6 0c20.7 20.3 33.6 48.7 33.6 80c0 61.9-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96l-66.3 0c-7.8 54.3-54.4 96-110.9 96c-61.9 0-112-50.1-112-112c0-31.3 12.9-59.7 33.6-80L87 320s0 0 0 0c-12.8-.5-23-11.1-23-24c0-7.2 3.2-13.6 8.2-18L5.6 89.3C-9.7 45.9 24.3 1 70.2 4.1l119.7 8c21.6 1.4 41 10.6 55.5 24.7C258.4 23.9 276.3 16 296 16l48 0c19.7 0 37.6 7.9 50.6 20.8c14.5-14.1 33.9-23.3 55.5-24.7l119.7-8zM519 272L589.2 73.3C593 62.4 584.5 51.2 573 52L453.3 60c-21 1.4-37.3 18.9-37.3 39.9L416 272l103 0zM186.7 60L67 52c-11.5-.8-20 10.5-16.2 21.3L121 272l103 0 0-172.1c0-21.1-16.3-38.5-37.3-39.9zM368 272l0-184c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 11.9L272 272l96 0zM160 416l-46 0c5.8 22.5 23.5 40.2 46 46l0-46zm0-32l0-46c-22.5 5.8-40.2 23.5-46 46l46 0zm32 78c22.5-5.8 40.2-23.5 46-46l-46 0 0 46zm0-124l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zM448 462l0-46-46 0c5.8 22.5 23.5 40.2 46 46zm-46-78l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm124 32l-46 0 0 46c22.5-5.8 40.2-23.5 46-46zm0-32c-5.8-22.5-23.5-40.2-46-46l0 46 46 0z"]
};
const faLineHeight = {
  prefix: 'far',
  iconName: 'line-height',
  icon: [576, 512, [], "f871", "M113.8 39.9c-4.6-5.1-11-7.9-17.8-7.9s-13.3 2.9-17.8 7.9l-72 80c-8.9 9.9-8.1 25 1.8 33.9s25 8.1 33.9-1.8L72 118.5l0 274.9L41.8 359.9c-8.9-9.9-24-10.7-33.9-1.8s-10.7 24-1.8 33.9l72 80c4.6 5.1 11 7.9 17.8 7.9s13.3-2.9 17.8-7.9l72-80c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L120 393.5l0-274.9 30.2 33.5c8.9 9.9 24 10.7 33.9 1.8s10.7-24 1.8-33.9l-72-80zM248 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L248 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM224 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24z"]
};
const faBagel = {
  prefix: 'far',
  iconName: 'bagel',
  icon: [640, 512, [129391], "e3d7", "M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c6.5-12.3 12-25.3 16.3-38.8c4.7-.7 9.3-2.5 13.3-5.3L471 357.3c5.1-3.5 11-5.4 17.2-5.6l25.3-.7c13.2-.4 24.8-8.8 29.3-21.3l8.5-23.9c2.1-5.8 5.8-10.9 10.6-14.6L582 275.8c10.5-8.1 14.9-21.7 11.2-34.4L586 217c-1.7-5.9-1.7-12.2 0-18.1l7.2-24.3c3.7-12.7-.7-26.3-11.2-34.4l-20.1-15.5c-4.9-3.8-8.6-8.8-10.6-14.6l-8.5-23.9c-4.4-12.5-16.1-20.9-29.3-21.3l-25.3-.7c-6.2-.2-12.1-2.1-17.2-5.6L450.1 44.4c-10.9-7.5-25.3-7.5-36.2 0L393 58.7c-5.1 3.5-11 5.4-17.2 5.6L350.5 65c-13.2 .4-24.8 8.8-29.3 21.3l-1.8 5.1c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zM48 304a160 160 0 1 0 320 0A160 160 0 1 0 48 304zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm144-96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm160 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 368a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm16 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"]
};
const faTransporter7 = {
  prefix: 'far',
  iconName: 'transporter-7',
  icon: [512, 512, [], "e2a8", "M480 64l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 64l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 96l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 96l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 64zM64 288l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 288 6.6 295.3C2.7 296.4 0 299.9 0 304s2.7 7.6 6.6 8.7L32 320l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 320l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 288zm56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z"]
};
const faAt = {
  prefix: 'far',
  iconName: 'at',
  icon: [512, 512, [61946], "40", "M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c13.3 0 24 10.7 24 24s-10.7 24-24 24C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 28c0 50.8-41.2 92-92 92c-31.1 0-58.7-15.5-75.3-39.2C322.7 360.9 291.1 376 256 376c-66.3 0-120-53.7-120-120s53.7-120 120-120c28.8 0 55.2 10.1 75.8 27c4.3-6.6 11.7-11 20.2-11c13.3 0 24 10.7 24 24l0 80 0 28c0 24.3 19.7 44 44 44s44-19.7 44-44l0-28c0-114.9-93.1-208-208-208zm72 208a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"]
};
const faRectanglesMixed = {
  prefix: 'far',
  iconName: 'rectangles-mixed',
  icon: [576, 512, [], "e323", "M256 80c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L64 208c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16l192 0zM64 32C28.7 32 0 60.7 0 96l0 96c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64L64 32zM512 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l64 0zM448 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0zM128 352l144 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-144 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM64 368l0 48c0 35.3 28.7 64 64 64l144 0c35.3 0 64-28.7 64-64l0-48c0-35.3-28.7-64-64-64l-144 0c-35.3 0-64 28.7-64 64z"]
};
const faPhoneArrowUpRight = {
  prefix: 'far',
  iconName: 'phone-arrow-up-right',
  icon: [512, 512, ["phone-arrow-up", "phone-outgoing"], "e224", "M295 183l135-135L376 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L329 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm34 103.6c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z"]
};
const faPhoneArrowUp = faPhoneArrowUpRight;
const faPhoneOutgoing = faPhoneArrowUpRight;
const faTrashCan = {
  prefix: 'far',
  iconName: 'trash-can',
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faTrashAlt = faTrashCan;
const faCircleL = {
  prefix: 'far',
  iconName: 'circle-l',
  icon: [512, 512, [], "e114", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-184z"]
};
const faHeadSideGoggles = {
  prefix: 'far',
  iconName: 'head-side-goggles',
  icon: [512, 512, ["head-vr"], "f6ea", "M.6 240C3.9 287.4 22 330.8 50.3 365.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C66 308.7 52 275.9 48.7 240L.6 240zM122.8 80C151.4 59.8 186.3 48 224 48l24 0 1.5 0L288 48c-28.4 0-54 12.4-71.6 32l-93.7 0zM51.4 81.2C22.1 87.1 0 113 0 144c0 35.3 28.7 64 64 64l152.4 0c17.6 19.6 43.1 32 71.6 32l96 0 24 0 24 0 32 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-32 0-24 0-24 0-5.5 0C342.8 18.1 296.6 0 248 0L224 0C154.5 0 92.5 31.6 51.4 81.2zM464 272.4c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6l0-.4-48 0 0 .4zM64 128l129.3 0c-.9 5.2-1.3 10.5-1.3 16s.5 10.8 1.3 16L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zM384 96l0 96-96 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l96 0zm48 0l32 0 0 96-32 0 0-96z"]
};
const faHeadVr = faHeadSideGoggles;
const faTextHeight = {
  prefix: 'far',
  iconName: 'text-height',
  icon: [576, 512, [], "f034", "M48 128l0-48 88 0 0 352-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-352 88 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24zM497 39c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 0 284.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-284.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L497 39z"]
};
const faUserXmark = {
  prefix: 'far',
  iconName: 'user-xmark',
  icon: [640, 512, ["user-times"], "f235", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112l91.4 0zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304L224 304l-45.7 0zM455 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faUserTimes = faUserXmark;
const faFaceHandYawn = {
  prefix: 'far',
  iconName: 'face-hand-yawn',
  icon: [512, 512, [], "e379", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59.4-24.9 113-64.9 150.9c2.9 15.1-1.5 31.3-13.2 43l-49 49C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-10.7C72.6 368.2 48 315 48 256zm208-48c-44.2 0-81.3 29.8-92.5 70.4l.5 0c17.9 0 33.6 9 43 22.7l47.1-47.1c18.7-18.7 49.1-18.7 67.9 0c1 1 2 2.1 3 3.2c4.7-1.1 9.5-1.5 14.3-1.2C322.6 227.4 291.6 208 256 208zM226.7 105c-8.3-10.4-23.4-12-33.7-3.7l-80 64c-10.4 8.3-12 23.4-3.7 33.7s23.4 12 33.7 3.7l80-64c10.4-8.3 12-23.4 3.7-33.7zM289 138.7l80 64c10.3 8.3 25.5 6.6 33.7-3.7s6.6-25.5-3.8-33.7l-80-64c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7zm10.3 137.9c-6.2-6.2-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L289.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L257.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faGaugeSimpleMin = {
  prefix: 'far',
  iconName: 'gauge-simple-min',
  icon: [512, 512, ["tachometer-slowest"], "f62d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-30.9-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
const faTachometerSlowest = faGaugeSimpleMin;
const faStethoscope = {
  prefix: 'far',
  iconName: 'stethoscope',
  icon: [576, 512, [129658], "f0f1", "M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5L80 200c0 57.4 46.6 104 104 104l8 0 8 0c57.4 0 104-46.6 104-104l0-129.8c0-3.3-2.1-6.3-5.2-7.5L255.6 46.5c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2C337.5 25.9 352 46.8 352 70.2L352 200c0 78.5-59.5 143.1-135.8 151.1C219.9 414.1 272.1 464 336 464c66.3 0 120-53.7 120-120l0-75.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 75.7c0 92.8-75.2 168-168 168c-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200L32 70.2c0-23.3 14.5-44.2 36.3-52.4L111.6 1.5c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faCoffin = {
  prefix: 'far',
  iconName: 'coffin',
  icon: [384, 512, [9904], "f6c6", "M48.2 145.8L133.8 48l116.4 0 85.6 97.8L243.9 464l-103.8 0L48.2 145.8zM102.4 10.9l-91 104C4.1 123.3 0 134.2 0 145.4c0 4.4 .6 8.7 1.8 12.9L97.3 488.9c4 13.7 16.5 23.1 30.7 23.1l127.9 0c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9c0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0l-131 0c-9.2 0-18 4-24.1 10.9z"]
};
const faMessage = {
  prefix: 'far',
  iconName: 'message',
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"]
};
const faCommentAlt = faMessage;
const faSalad = {
  prefix: 'far',
  iconName: 'salad',
  icon: [512, 512, [129367, "bowl-salad"], "f81e", "M416 96c-70.7 0-128 57.3-128 128c0 11 1.4 21.8 4 32l-52 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 137.4L107.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 96 256c-53 0-96-43-96-96s43-96 96-96c8.7 0 17.2 1.2 25.3 3.4C138.5 27.7 178 0 224 0s85.5 27.7 102.7 67.4c8-2.2 16.5-3.4 25.3-3.4c28.5 0 54.2 12.5 71.8 32.2c-2.6-.2-5.2-.2-7.8-.2zM117.9 422.3c12.9 5.7 22.7 16.7 26.8 30.3c2 6.6 8.2 11.4 15.3 11.4l192 0c7.2 0 13.4-4.8 15.3-11.4c4-13.5 13.8-24.6 26.8-30.3c35.2-15.4 61.2-47.6 68.1-86.3L49.8 336c6.9 38.7 32.9 70.9 68.1 86.3zM0 315.4C0 300.3 12.3 288 27.4 288l457.1 0c15.1 0 27.4 12.3 27.4 27.4c0 67.4-40.6 125.4-98.6 150.8C405.5 492.7 381 512 352 512l-192 0c-29 0-53.5-19.3-61.4-45.7C40.6 440.8 0 382.9 0 315.4zM464 224c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 12.3 4.6 23.5 12.2 32l-54.8 0c-3.5-10-5.5-20.8-5.5-32c0-53 43-96 96-96s96 43 96 96c0 11.2-1.9 22-5.5 32l-54.8 0c7.6-8.5 12.2-19.7 12.2-32z"]
};
const faBowlSalad = faSalad;
const faInfo = {
  prefix: 'far',
  iconName: 'info',
  icon: [192, 512, [], "f129", "M56 72a40 40 0 1 1 80 0A40 40 0 1 1 56 72zM16 200c0-13.3 10.7-24 24-24l56 0c13.3 0 24 10.7 24 24l0 264 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-240-32 0c-13.3 0-24-10.7-24-24z"]
};
const faRobotAstromech = {
  prefix: 'far',
  iconName: 'robot-astromech',
  icon: [512, 512, [], "e2d2", "M256 0C185.3 0 128 57.3 128 128l0 16-40 0c-30.9 0-56 25.1-56 56l0 210.9L2.1 478.3c-3.3 7.4-2.6 16 1.8 22.8S15.9 512 24 512l112 0c13.3 0 24-10.7 24-24l0-72.9 22.1 24.8c4.6 5.1 11.1 8.1 17.9 8.1l112 0c6.9 0 13.4-2.9 17.9-8.1L352 415.1l0 72.9c0 13.3 10.7 24 24 24l112 0c8.1 0 15.7-4.1 20.1-10.9s5.1-15.4 1.8-22.8L480 410.9 480 200c0-30.9-25.1-56-56-56l-40 0 0-16C384 57.3 326.7 0 256 0zM192 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM88 192l24 0 0 160 0 112-51.1 0 17-38.3c1.4-3.1 2.1-6.4 2.1-9.7l0-216c0-4.4 3.6-8 8-8zm72 0l192 0 0 150.9L301.2 400l-90.4 0L160 342.9 160 192zm240 0l24 0c4.4 0 8 3.6 8 8l0 216c0 3.4 .7 6.7 2.1 9.7l17 38.3L400 464l0-112 0-160zM208 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"]
};
const faRingDiamond = {
  prefix: 'far',
  iconName: 'ring-diamond',
  icon: [384, 512, [], "e5ab", "M144 0c-8 0-15.5 4-20 10.7l-32 48c-5 7.5-5.4 17.1-1 25l31.8 57.2C51 168.6 0 238.4 0 320C0 426 86 512 192 512s192-86 192-192c0-81.6-51-151.4-122.8-179.1L293 83.7c4.4-7.9 4-17.5-1-25l-32-48C255.5 4 248 0 240 0L144 0zm68.8 129.1C206 128.4 199 128 192 128s-14 .4-20.8 1.1l-31.1-56L156.8 48l70.3 0 16.8 25.1-31.1 56zM48 320a144 144 0 1 1 288 0A144 144 0 1 1 48 320z"]
};
const faFonduePot = {
  prefix: 'far',
  iconName: 'fondue-pot',
  icon: [512, 512, [129749], "e40d", "M319 39.8l-24 96c-2.9 11.5-11.6 20-22.2 23L264.5 192l-33 0 10.2-41c-7.9-7.7-11.7-19.3-8.8-30.8l24-96C261.2 7.1 278.6-3.3 295.8 1s27.6 21.7 23.3 38.8zm62.9 120.2L360.6 192l-38.5 0 33.2-49.8c-4.9-9.9-4.5-22.1 2.1-31.9l64-96C431.2-.5 451-4.4 465.8 5.4s18.7 29.7 8.9 44.4l-64 96c-6.6 9.9-17.7 14.9-28.7 14.2zM48 320c0 61.9 50.1 112 112 112l128 0c61.9 0 112-50.1 112-112l0-48-208 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-32 0 0 48zM0 256c0-17.7 14.3-32 32-32l368 0 16 0 32 0 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 48c0 52.3-25.1 98.8-64 128l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-15.3c-15.2 4.8-31.3 7.3-48 7.3l-128 0c-16.7 0-32.8-2.6-48-7.3l0 15.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40C25.1 418.8 0 372.3 0 320l0-64z"]
};
const faTheta = {
  prefix: 'far',
  iconName: 'theta',
  icon: [384, 512, [], "f69e", "M56 256c0-55 16.6-103.9 42.1-138.4S157.2 64 192 64s68.3 19 93.9 53.6S328 201 328 256s-16.6 103.9-42.1 138.5S226.8 448 192 448s-68.3-19-93.9-53.5S56 311 56 256zM192 16C138.4 16 91.9 45.4 59.6 89S8 191.7 8 256s19.3 123.4 51.6 167s78.9 73 132.4 73s100.1-29.4 132.4-73S376 320.3 376 256s-19.3-123.4-51.6-167S245.6 16 192 16zM120 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faFaceHandPeeking = {
  prefix: 'far',
  iconName: 'face-hand-peeking',
  icon: [640, 512, [129763], "e481", "M496.4 145.7c.4-.5 .9-1 1.4-1.4c12.9-12.9 31.8-16.1 47.7-9.6C502.2 54.5 417.5 0 320 0C248.5 0 183.8 29.3 137.3 76.6c7.7 1.8 14.9 5.7 20.9 11.7c6.6 6.6 10.6 14.7 12.2 23.2C208.2 72.3 261.3 48 320 48c74.4 0 139.6 39 176.4 97.7zm40.7 246c-5.4 .7-10.8 1.1-16.3 1.1l-44.2 0C438.5 436.5 382.5 464 320 464c-79.9 0-149.3-45-184.1-111.1l-16.7 0c-13.3 0-26.4-2.2-38.8-6.5C117 443.2 210.4 512 320 512c91.5 0 171.8-48 217.1-120.2zM352.8 264c-10.4-10.2-16.8-24.3-16.8-40c0-28.5 21.2-52 48.7-55.5c1-5.5 3.3-10.9 6.7-15.7c5.1-7.1 12.1-12.1 19.7-14.6c-6.2-1.4-12.6-2.1-19.2-2.1c-48.6 0-88 39.4-88 88c0 40.3 27.1 74.3 64.1 84.7c.1-1.4 .3-2.8 .6-4.2C358.6 297.3 352 285.4 352 272c0-2.7 .3-5.4 .8-8zM320 432c35.3 0 64-21.5 64-48s-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48zm90.3-192c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 6.1 2.3 11.8 6.1 16l35.8 0zM248 192c0-8.8-7.2-16-16-16l-113.8 0c-7.1 0-10.7-8.6-5.7-13.7l28.8-28.8c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L51.9 166.4l-.8 .8C14.7 204.4 15 264.1 51.9 301c17.9 17.9 42.1 27.9 67.3 27.9l64.8 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-14 0c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5l62 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-62.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l78.4 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-78.4 0c-2.2 0-4-1.8-4-4s1.8-4 4-4l62.4 0c8.8 0 16-7.2 16-16zm163-25.3c-5.1 7.2-3.5 17.2 3.7 22.3l59.7 42.6c3.5 2.5 5.6 6.6 5.6 10.9c0 7.4-6 13.4-13.4 13.4L392 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l84 0c2.2 0 4 1.8 4 4s-1.8 4-4 4l-68 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l67.5 0c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5l-19.5 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64.8 0c25.2 0 49.5-10 67.3-27.9c36.9-36.9 37.2-96.6 .8-133.8l-.8-.8L543 161.3c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3l14.8 14.8c6.6 6.6 2.7 18-6.6 19c-2.8 .3-5.6-.4-7.8-2L433.3 163c-7.2-5.1-17.2-3.5-22.3 3.7z"]
};
const faSquareUser = {
  prefix: 'far',
  iconName: 'square-user',
  icon: [448, 512, [], "e283", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-1 0c-7.9-63.1-61.7-112-127-112l-64 0c-65.3 0-119.1 48.9-127 112l-1 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM334.4 432l-220.8 0c7.4-36.5 39.7-64 78.4-64l64 0c38.7 0 71 27.5 78.4 64zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 240a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
};
const faDownLeftAndUpRightToCenter = {
  prefix: 'far',
  iconName: 'down-left-and-up-right-to-center',
  icon: [512, 512, ["compress-alt"], "f422", "M296 256l148.7 0c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L441.9 168 496 113.9c18.7-18.7 18.7-49.1 0-67.9L465.9 16c-18.7-18.7-49.1-18.7-67.9 0L344 70.1 316.3 42.3c-6.6-6.6-15.6-10.3-25-10.3C271.8 32 256 47.8 256 67.3L256 216c0 22.1 17.9 40 40 40zm95-71l23 23L304 208l0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0l71-71L462.1 80l-71 71c-9.4 9.4-9.4 24.6 0 33.9zM67.3 256C47.8 256 32 271.8 32 291.3c0 9.4 3.7 18.3 10.3 25L70.1 344 16 398.1c-18.7 18.7-18.7 49.1 0 67.9L46.1 496c18.7 18.7 49.1 18.7 67.9 0L168 441.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3L256 296c0-22.1-17.9-40-40-40L67.3 256zM121 327l-23-23L208 304l0 110.1-23-23c-9.4-9.4-24.6-9.4-33.9 0l-71 71L49.9 432l71-71c9.4-9.4 9.4-24.6 0-33.9z"]
};
const faCompressAlt = faDownLeftAndUpRightToCenter;
const faExplosion = {
  prefix: 'far',
  iconName: 'explosion',
  icon: [576, 512, [], "e4e9", "M543.2 30.2c3.1-11.6-2.8-23.7-13.9-28.3s-23.9-.4-30 9.9L344.7 274.1 311.2 145.9C308.5 135.4 298.9 128 288 128s-20.5 7.4-23.2 17.9L227.4 289.4 145 207c-7.6-7.6-19.4-9.2-28.8-3.9s-14.1 16.2-11.5 26.7l23.9 95.7-70.8-5.4c-9.2-.7-18 4-22.7 12s-4.2 18 1.1 25.6L87.7 432l58.4 0-41.7-60.2 53.7 4.1c7.7 .6 15.2-2.6 20.2-8.4s6.8-13.8 4.9-21.3l-11-43.9L223 353c6.1 6.1 15 8.4 23.3 6.2s14.8-8.8 16.9-17.1l24.8-95 24.8 95c2.4 9.4 10.3 16.4 19.9 17.7s19.1-3.2 24-11.6L451.2 188 408.8 345.8c-2 7.6-.2 15.7 4.8 21.7s12.7 9.2 20.5 8.4l36.9-3.4L429.9 432l58.4 0 51.5-74.3c5.3-7.7 5.7-17.7 1-25.8s-13.6-12.7-22.9-11.8L464.1 325 543.2 30.2zM465.9 464l-35.8 0s0 0 0 0l-40.9 0c-10.8-45.9-52-80-101.2-80s-90.4 34.1-101.2 80l-40.9 0s0 0 0 0l-35.8 0s0 0 0 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0s0 0 0 0zm-228.5 0c9-18.9 28.3-32 50.6-32s41.6 13.1 50.6 32l-101.2 0zM312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z"]
};
const faFileLines = {
  prefix: 'far',
  iconName: 'file-lines',
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faFileAlt = faFileLines;
const faFileText = faFileLines;
const faWaveSquare = {
  prefix: 'far',
  iconName: 'wave-square',
  icon: [640, 512, [], "f83e", "M136 56c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24l0 376 112 0 0-176c0-13.3 10.7-24 24-24l136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 176c0 13.3-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24l0-376L184 80l0 176c0 13.3-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-176z"]
};
const faRing = {
  prefix: 'far',
  iconName: 'ring',
  icon: [512, 512, [], "f70b", "M59.7 168c8.9-9.4 22.9-19 42.1-27.6C140 123.2 194.5 112 256 112s116 11.2 154.2 28.4c19.1 8.6 33.2 18.2 42.1 27.6c8.8 9.3 11.7 17.4 11.7 24s-2.9 14.7-11.7 24c-.8 .9-1.7 1.7-2.5 2.6C402.4 191.8 332.2 176 256 176s-146.4 15.8-193.8 42.6c-.9-.9-1.7-1.7-2.5-2.6C50.9 206.7 48 198.6 48 192s2.9-14.7 11.7-24zM464 268.6l0 51.4c0 6.6-2.9 14.7-11.7 24c-8.9 9.4-22.9 19-42.1 27.6C372 388.8 317.5 400 256 400s-116-11.2-154.2-28.4c-19.1-8.6-33.2-18.2-42.1-27.6C50.9 334.7 48 326.6 48 320l0-51.4c10.3 7.1 21.8 13.3 34.1 18.9C127.9 307.9 189.4 320 256 320s128.1-12.1 173.9-32.6c12.4-5.5 23.9-11.8 34.1-18.9zM0 192L0 320c0 22.1 10.1 41.4 24.8 57c14.6 15.4 34.5 28.2 57.4 38.5C127.9 435.9 189.4 448 256 448s128.1-12.1 173.9-32.6c22.8-10.2 42.8-23 57.4-38.5c14.7-15.6 24.8-34.9 24.8-57l0-128c0-22.1-10.1-41.4-24.8-57c-14.6-15.4-34.5-28.2-57.4-38.5C384.1 76.1 322.6 64 256 64S127.9 76.1 82.1 96.6C59.3 106.8 39.3 119.6 24.8 135C10.1 150.6 0 169.9 0 192zm256 80c-56.1 0-106.4-9.3-143.8-24c37.1-14.5 87.3-24 143.8-24s106.7 9.5 143.8 24c-37.4 14.7-87.7 24-143.8 24z"]
};
const faBuildingUn = {
  prefix: 'far',
  iconName: 'building-un',
  icon: [384, 512, [], "e4d9", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM104 248l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM237.3 87.1l34.7 52L272 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 96l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faDiceThree = {
  prefix: 'far',
  iconName: 'dice-three',
  icon: [448, 512, [9858], "f527", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faTirePressureWarning = {
  prefix: 'far',
  iconName: 'tire-pressure-warning',
  icon: [512, 512, [], "f633", "M424 0c-13.3 0-24 10.7-24 24l0 30.5c0 30.1 4.9 60 14.4 88.5l2.5 7.4c6.1 18.4 14.4 35.6 22.2 51.5c15 30.5 26.3 66.3 22 105.3c-4 36.7-22.3 79.2-70.5 124.8l-269.3 0c-48.2-45.6-66.4-88.1-70.5-124.8c-4.3-39 7-74.8 22-105.3c7.8-15.8 16.1-33 22.2-51.5l2.5-7.4c9.5-28.6 14.4-58.4 14.4-88.5L112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 30.5c0 24.9-4 49.7-11.9 73.4l-2.5 7.4c-5 15-11.9 29.6-19.7 45.4C12.7 215.5-2.5 260.9 3.2 312.4c5.5 49.7 30 102.1 84.8 154.1L88 496c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16 48 0 0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-29.5c54.8-51.9 79.3-104.3 84.8-154.1c5.7-51.5-9.5-96.9-26.7-131.8c-7.8-15.8-14.7-30.4-19.7-45.4l-2.5-7.4C452 104.2 448 79.4 448 54.5L448 24c0-13.3-10.7-24-24-24zM256 96c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faWifiFair = {
  prefix: 'far',
  iconName: 'wifi-fair',
  icon: [640, 512, ["wifi-2"], "f6ab", "M152.4 321.2C196.5 280.7 255.4 256 320 256s123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5zM320 480a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]
};
const faWifi2 = faWifiFair;
const faCalendarDays = {
  prefix: 'far',
  iconName: 'calendar-days',
  icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l80 0 0 56-80 0 0-56zm0 104l80 0 0 64-80 0 0-64zm128 0l96 0 0 64-96 0 0-64zm144 0l80 0 0 64-80 0 0-64zm80-48l-80 0 0-56 80 0 0 56zm0 160l0 40c0 8.8-7.2 16-16 16l-64 0 0-56 80 0zm-128 0l0 56-96 0 0-56 96 0zm-144 0l0 56-64 0c-8.8 0-16-7.2-16-16l0-40 80 0zM272 248l-96 0 0-56 96 0 0 56z"]
};
const faCalendarAlt = faCalendarDays;
const faMp3Player = {
  prefix: 'far',
  iconName: 'mp3-player',
  icon: [384, 512, [], "f8ce", "M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM192 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM112 80c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32L112 80z"]
};
const faAnchorCircleCheck = {
  prefix: 'far',
  iconName: 'anchor-circle-check',
  icon: [640, 512, [], "e4aa", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faTally4 = {
  prefix: 'far',
  iconName: 'tally-4',
  icon: [640, 512, [], "e297", "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zM384 40c-13.3 0-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384c0-13.3-10.7-24-24-24zM536 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384z"]
};
const faRectangleHistory = {
  prefix: 'far',
  iconName: 'rectangle-history',
  icon: [512, 512, [], "e4a2", "M464 224c0-8.8-7.2-16-16-16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224zm-16-64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0zm-8-80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0z"]
};
const faBuildingCircleArrowRight = {
  prefix: 'far',
  iconName: 'building-circle-arrow-right',
  icon: [640, 512, [], "e4d1", "M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
const faVolleyball = {
  prefix: 'far',
  iconName: 'volleyball',
  icon: [512, 512, [127952, "volleyball-ball"], "f45f", "M371.5 429c-71.4 7-145.1-8.2-210-47.1c-8.8 14.8-16.2 30.3-22.3 46.3C172.5 450.8 212.7 464 256 464c42.7 0 82.5-12.9 115.5-35zm60.1-61.5c9.2-14.4 16.6-30.1 22.1-46.7c-65.9 7.3-134.5-4.3-197.1-37.1c-25.9 16.5-48.4 36.5-67.2 58.9c75.2 43.8 163.6 51 242.3 24.9zm31.8-96.4c.4-5 .5-10 .5-15.1c0-77.9-42.8-145.8-106.3-181.5c35.6 58.4 54.2 127.7 49.6 200.3c18.8 .5 37.6-.7 56.1-3.8zM101 394.7C127.6 334 172 280.5 231.7 242.7c-1.3-30-7.1-58.9-16.8-85.9C140.2 189.5 85.7 249.6 58.1 320.3c9 27.9 23.8 53.1 42.9 74.5zm-52-159.9C84.1 182.9 133.8 140 195.2 113c-8.7-15.7-18.7-30.4-29.9-44.2C101.9 99.6 56.5 161.6 49.1 234.8zM213.3 52.4c39.3 53.4 63.5 118.6 66.4 189.2c25.7 13.4 52.6 22.6 79.9 27.9c4.6-84.1-26.8-163-81.5-220.4c-7.2-.8-14.6-1.2-22.1-1.2c-14.6 0-28.9 1.5-42.7 4.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faVolleyballBall = faVolleyball;
const faSunHaze = {
  prefix: 'far',
  iconName: 'sun-haze',
  icon: [640, 512, [], "f765", "M439.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L320 61.1 237.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L83.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L125.1 256s0 0 0 0l53.2 0c0-4.8-1.4-9.5-4.2-13.6l-45.2-65.6 78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L306.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L466 242.4c-2.8 4.1-4.2 8.9-4.2 13.6l53.2 0s0 0 0 0l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L439.7 19.7zM432 256c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 0 0 0 0 0l48 0s0 0 0 0c0-35.3 28.7-64 64-64s64 28.7 64 64c0 0 0 0 0 0l48 0s0 0 0 0zm184 32l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-208 0L88 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM576 400c0-13.3-10.7-24-24-24L24 376c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24zM88 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464zm208 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0z"]
};
const faTextSize = {
  prefix: 'far',
  iconName: 'text-size',
  icon: [640, 512, [], "f894", "M48 128l0-48 120 0 0 352-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-352 120 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24zM360 296l0-24 96 0 0 160-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-160 88 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-22.1-17.9-40-40-40l-248 0c-22.1 0-40 17.9-40 40l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faUfo = {
  prefix: 'far',
  iconName: 'ufo',
  icon: [640, 512, [128760], "e047", "M176.6 246.3c-17.5 16.4-17.5 16.4-17.5 16.5s0 0 0 0c0 0 0 0 0 .1l.1 .1 .3 .3c.2 .2 .4 .4 .7 .7c.6 .5 1.3 1.2 2.2 2.1c1.8 1.6 4.3 3.7 7.6 6.2c6.6 4.8 16.1 10.9 29.1 16.8c26.1 11.9 65.3 23 120.8 23s94.7-11.1 120.8-23c13-5.9 22.6-12 29.1-16.8c3.3-2.4 5.8-4.5 7.6-6.2c.9-.8 1.6-1.5 2.2-2.1c.3-.3 .5-.5 .7-.7l.3-.3 .1-.1c0 0 0 0 0-.1c0 0 0 0 0 0l-17.5-16.5 17.5 16.4c3.7-3.9 6-9 6.4-14.4c.5-5.8 .7-11.6 .6-17.2c30 8.9 54.6 19.9 72.5 31.8c24.1 16.2 31.5 30.9 31.5 41.6c0 7.9-3.8 17.7-15.8 29.1c-12 11.5-30.8 23-55.8 33.1C470.3 387 399.4 400 320 400s-150.3-13-200.3-33.2c-25.1-10.1-43.8-21.6-55.8-33.1C51.8 322.2 48 312.4 48 304.5c0-10.7 7.4-25.4 31.5-41.6c17.9-12 42.4-23 72.5-31.8c-.1 5.7 .1 11.4 .6 17.2c.5 5.4 2.7 10.5 6.4 14.4l17.5-16.4zm302.8-67.2C456.8 110.9 392.6 64 320 64s-136.8 46.9-159.4 115.1c-42.7 10.5-80 25.4-107.8 44C23.4 242.9 0 270.2 0 304.5c0 25.1 12.7 46.7 30.7 63.9c17.9 17.1 42.6 31.4 71 42.9C158.8 434.3 236 448 320 448s161.2-13.7 218.3-36.7c28.5-11.5 53.1-25.8 71-42.9c18-17.1 30.7-38.7 30.7-63.9c0-34.3-23.4-61.7-52.8-81.4c-27.8-18.6-65.1-33.5-107.8-44zM440 234.6c-4.1 2.9-10.4 6.8-19.1 10.8c-19.6 8.9-52 18.7-100.9 18.7s-81.3-9.7-100.9-18.7c-8.7-4-15-7.9-19.1-10.8C199.2 164.7 255 112 320 112s120.8 52.7 120 122.6zM152 312a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFork = {
  prefix: 'far',
  iconName: 'fork',
  icon: [512, 512, ["utensil-fork"], "f2e3", "M398.4 43.2c10.6-8 12.8-23 4.8-33.6s-23-12.8-33.6-4.8l-122.7 92c-4.4 3.3-8.6 7-12.6 10.9l-1.9 1.9c-20.8 20.8-32.5 49-32.5 78.4c0 24.5 8.1 48.1 22.8 67.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L256.7 289.2C275.9 303.9 299.5 312 324 312c29.4 0 57.6-11.7 78.4-32.5l1.9-1.9c3.9-3.9 7.6-8.1 10.9-12.6l92-122.7c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8l-92 122.7c-2 2.6-4.1 5.1-6.4 7.4l-1.9 1.9C356.7 257.4 340.7 264 324 264s-32.7-6.6-44.5-18.4l-6.5-6.5c0 0 0 0 0 0s0 0 0 0l-6.5-6.5C254.6 220.7 248 204.7 248 188s6.6-32.7 18.4-44.5l1.9-1.9c2.3-2.3 4.8-4.5 7.4-6.4l122.7-92zM457 89c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L307 171c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L457 89z"]
};
const faUtensilFork = faFork;
const faArrowsUpToLine = {
  prefix: 'far',
  iconName: 'arrows-up-to-line',
  icon: [576, 512, [], "e4c2", "M24 80l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80zM7 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 135c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7L7 239zM327 273c9.4 9.4 24.6 9.4 33.9 0l63-63L424 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 135c-9.4-9.4-24.6-9.4-33.9 0L327 239c-9.4 9.4-9.4 24.6 0 33.9z"]
};
const faMobileSignal = {
  prefix: 'far',
  iconName: 'mobile-signal',
  icon: [512, 512, [], "e1ef", "M64 48l224 0c8.8 0 16 7.2 16 16l0 234.7c14.5-14.1 30.6-26.5 48-37L352 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l160 0 0-24c0-8.1 .4-16.1 1.1-24L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM488 256c-128.1 0-232 103.9-232 232c0 13.3 10.7 24 24 24s24-10.7 24-24c0-101.6 82.4-184 184-184c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-136c0-13.3-10.7-24-24-24c-75.1 0-136 60.9-136 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88c13.3 0 24-10.7 24-24z"]
};
const faBarcodeScan = {
  prefix: 'far',
  iconName: 'barcode-scan',
  icon: [640, 512, [], "f465", "M88 32C74.7 32 64 42.7 64 56l0 136 48 0 0-136c0-13.3-10.7-24-24-24zM64 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm96 8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm64-8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM336 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM464 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144-32 0 0 144zm0-416l0 144 32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 408c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0 0 136zm0-400l0 136 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM160 192l32 0 0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144zM0 256c0 13.3 10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24z"]
};
const faSortDown = {
  prefix: 'far',
  iconName: 'sort-down',
  icon: [320, 512, ["sort-desc"], "f0dd", "M160 425.4L70.6 336l178.7 0L160 425.4zm-22.6 45.3c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
};
const faSortDesc = faSortDown;
const faFolderArrowDown = {
  prefix: 'far',
  iconName: 'folder-arrow-down',
  icon: [512, 512, ["folder-download"], "e053", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM280 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 200z"]
};
const faFolderDownload = faFolderArrowDown;
const faCircleMinus = {
  prefix: 'far',
  iconName: 'circle-minus',
  icon: [512, 512, ["minus-circle"], "f056", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faMinusCircle = faCircleMinus;
const faFaceIcicles = {
  prefix: 'far',
  iconName: 'face-icicles',
  icon: [512, 512, [], "e37c", "M256 48C141.1 48 48 141.1 48 256c0 1.4-.1 2.7-.3 4l-15 180c-.4 4.5-4.1 8-8.7 8s-8.3-3.5-8.7-8L.3 260c-.2-1.3-.3-2.6-.3-4C0 114.6 114.6 0 256 0S512 114.6 512 256c0 1-.1 2-.2 3L496.5 504c-.3 4.5-4 8-8.5 8s-8.2-3.5-8.5-8L464.2 259c-.1-1-.2-2-.2-3c0-114.9-93.1-208-208-208zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40l-8.9 86.7c-.5 5.3-5 9.3-10.3 9.3s-9.7-4-10.3-9.3l-7.3-70.8c-.8 0-1.6 .1-2.5 .1l-26.7 0-6.5 38.8c-.9 5.3-5.5 9.2-10.9 9.2s-10-3.9-10.9-9.2L282.7 400 168 400c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 512c-75.5 0-143.3-32.7-190.2-84.6L72 353.1C106.9 419.1 176.2 464 256 464c3.5 0 6.9-.1 10.3-.3c7.9 10 20.2 16.3 33.7 16.3c7.9 0 15.4-2.2 21.9-6c1 10.1 5.6 19.1 12.4 25.8c-24.7 7.9-51 12.2-78.3 12.2zm151.3-49.5l7.4-72c8.9-10.5 16.8-21.9 23.5-34.1l4.7 74.6c-10.8 11.6-22.8 22.2-35.6 31.6z"]
};
const faShovel = {
  prefix: 'far',
  iconName: 'shovel',
  icon: [512, 512, [], "f713", "M375 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9l-44.1 44.1c-17.2 17.2-40.6 26.9-65 26.9c-16.7 0-32.3-4.4-45.8-12.2L241 305l56.4 56.4c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9L32 512c-17.7 0-32-14.3-32-32l0-93.7c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0L207 271 316.2 161.9c-7.8-13.5-12.2-29.1-12.2-45.8c0-24.4 9.7-47.7 26.9-65L375 7zm17 50.9L364.9 85.1c-8.2 8.2-12.9 19.4-12.9 31c0 24.2 19.6 43.9 43.9 43.9c11.6 0 22.8-4.6 31-12.9L454.1 120 392 57.9zM125.7 464c29.7 0 58.2-11.8 79.2-32.8L252.1 384 128 259.9 80.8 307.1c-21 21-32.8 49.5-32.8 79.2L48 464l77.7 0z"]
};
const faDoorOpen = {
  prefix: 'far',
  iconName: 'door-open',
  icon: [576, 512, [], "f52b", "M272 49.7L272 464l-160 0 0-371.2L272 49.7zM320 464l0-421.6C320 19 301 0 277.6 0c-3.7 0-7.4 .5-11 1.5L99.5 46.4C78.6 52.1 64 71.1 64 92.8L64 464l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 32 0 16 0 160 0 48 0 0-48zM224 288c13.2 0 24-14.4 24-32s-10.8-32-24-32s-24 14.4-24 32s10.7 32 24 32zM352 112l104 0c4.4 0 8 3.6 8 8l0 368c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-344c0-30.9-25.1-56-56-56L352 64l0 48z"]
};
const faFilms = {
  prefix: 'far',
  iconName: 'films',
  icon: [576, 512, [], "e17a", "M256 264l0-32 160 0 0 32 0 72-160 0 0-72zm0-80l0-32 0-72 160 0 0 72 0 32-160 0zM440 32l-24 0L256 32l-24 0-24 0-48 0c-35.3 0-64 28.7-64 64l0 32 0 24 0 24 0 64 0 24 0 24 0 32c0 35.3 28.7 64 64 64l48 0 24 0 24 0 160 0 24 0 24 0 48 0c35.3 0 64-28.7 64-64l0-32 0-24 0-24 0-64 0-24 0-24 0-32c0-35.3-28.7-64-64-64l-48 0-24 0zM160 80l48 0 0 48-64 0 0-32c0-8.8 7.2-16 16-16zm-16 96l64 0 0 32 0 32-64 0 0-64zm0 112l64 0 0 48-48 0c-8.8 0-16-7.2-16-16l0-32zm368 48l-48 0 0-48 64 0 0 32c0 8.8-7.2 16-16 16zm16-96l-64 0 0-32 0-32 64 0 0 64zm0-112l-64 0 0-48 48 0c8.8 0 16 7.2 16 16l0 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"]
};
const faRightFromBracket = {
  prefix: 'far',
  iconName: 'right-from-bracket',
  icon: [512, 512, ["sign-out-alt"], "f2f5", "M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
};
const faSignOutAlt = faRightFromBracket;
const faFaceGlasses = {
  prefix: 'far',
  iconName: 'face-glasses',
  icon: [512, 512, [], "e377", "M256 464C141.1 464 48 370.9 48 256c0-1.8 0-3.5 .1-5.3C49.5 280.4 74 304 104 304l80 0c30.9 0 56-25.1 56-56l0-48c0-2.7-.2-5.4-.6-8l33.1 0c-.4 2.6-.6 5.3-.6 8l0 48c0 30.9 25.1 56 56 56l80 0c30 0 54.5-23.6 55.9-53.3c0 1.8 .1 3.5 .1 5.3c0 114.9-93.1 208-208 208zM224 160.8c-10.2-10.4-24.3-16.8-40-16.8l-80 0c-10.1 0-19.6 2.7-27.8 7.4C112.2 89.6 179.3 48 256 48s143.8 41.6 179.8 103.4c-8.2-4.7-17.7-7.4-27.8-7.4l-80 0c-15.7 0-29.8 6.4-40 16.8l0-.8-64 0 0 .8zM256 512c141.4 0 256-114.6 256-256c0-22.8-3-44.8-8.5-65.8c5.1-2.7 8.5-8 8.5-14.2c0-8.8-7.2-16-16-16l-2.6 0C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160L16 160c-8.8 0-16 7.2-16 16c0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256C0 397.4 114.6 512 256 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM304 200c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48zM104 176l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm88.4 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faNfc = {
  prefix: 'far',
  iconName: 'nfc',
  icon: [448, 512, [], "e1f7", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256c0-17.8-9.7-33.3-24-41.6l0-54.4 72 0 0 192-192 0 0-192 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40l208 0c22.1 0 40-17.9 40-40l0-208c0-22.1-17.9-40-40-40l-88 0c-22.1 0-40 17.9-40 40l0 62.4c-14.3 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48z"]
};
const faAtom = {
  prefix: 'far',
  iconName: 'atom',
  icon: [512, 512, [9883], "f5d2", "M306.3 417.2c-16.3-4.7-33.1-10.9-50.3-18.4c-17.1 7.5-34 13.6-50.3 18.4C224.1 455.5 243.1 464 256 464s31.9-8.5 50.3-46.8zM293 325.7c14.8-8.9 28.7-18.1 41.4-27.6c1-13.5 1.6-27.6 1.6-42.1s-.5-28.6-1.6-42.1c-12.8-9.4-26.6-18.7-41.4-27.6c-12.5-7.5-24.9-14.2-37-20.2c-12.1 6-24.5 12.7-37 20.2c-14.8 8.9-28.7 18.1-41.4 27.6c-1 13.5-1.6 27.6-1.6 42.1s.5 28.6 1.6 42.1c12.8 9.4 26.6 18.7 41.4 27.6c12.5 7.5 24.9 14.2 37 20.2c12.1-6 24.5-12.7 37-20.2zm120.5-32.2c-10.2 10.2-21.3 20.2-33.4 29.9c-2.4 20.1-5.8 39.2-10.3 57c37.2 2.2 51.9-9.1 57.8-19.7c6.5-11.7 8.2-32.8-14.1-67.2zM469.6 128c20.7 37.1 9.4 82.8-23.6 128c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2zM84.4 360.7c5.9 10.6 20.6 22 57.8 19.7c-4.5-17.8-7.9-36.9-10.3-57c-12-9.7-23.2-19.8-33.4-29.9C76.2 327.8 77.8 349 84.4 360.7zM98.5 218.5c10.2-10.2 21.3-20.2 33.4-29.9c2.4-20.1 5.8-39.2 10.3-57c-37.2-2.3-51.9 9.1-57.8 19.7c-6.5 11.7-8.2 32.8 14.1 67.2zM256 113.2c17.1-7.5 34-13.6 50.3-18.4C287.9 56.5 268.9 48 256 48s-31.9 8.5-50.3 46.8c16.3 4.7 33.1 10.9 50.3 18.4zm124.2 75.4c12 9.7 23.2 19.8 33.4 29.9c22.3-34.3 20.6-55.5 14.1-67.2c-5.9-10.6-20.6-22-57.8-19.7c4.5 17.8 7.9 36.9 10.3 57zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSoap = {
  prefix: 'far',
  iconName: 'soap',
  icon: [512, 512, [129532], "e06e", "M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM96 192l113.1 0c2.5 17.7 9.2 34 18.9 48L96 240c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-4.1 0c9.6-13.7 16.1-29.6 18.8-46.9c46 7.1 81.3 46.9 81.3 94.9l0 128c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 288c0-53 43-96 96-96zm224 96l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l160 0zM144 352c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16zM320 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faIcons = {
  prefix: 'far',
  iconName: 'icons',
  icon: [512, 512, ["heart-music-camera-bolt"], "f86d", "M59.6 54.4c11.1-9.4 30.8-8.7 43.5 3.7l8 8.1 17.5 17.8 17.1-18.3L153 58c12.5-12 31.7-13.1 43.8-3.4c14.2 12.1 14.8 33.3 2 46.2c0 0 0 0 0 0l-70.7 70.8-71-70.8s0 0 0 0C44.3 87.9 44.9 66.6 59.5 54.5c0 0 0 0 0 0l.1-.1zM28.8 17.6C-7.7 47.9-9.4 102 23.1 134.6c0 0 0 0 0 0L101.7 213c14.7 15.1 38.3 14.1 52.5 .4c0 0 0 0 0 0l.3-.3 78.3-78.5s0 0 0 0C265.4 102 263.6 48 227.6 17.7c0 0 0 0 0 0l-.3-.3c-29.9-24.3-71-21.9-99.3-1C99.7-4.4 58.2-7 28.8 17.6zM512 24c0-7.2-3.2-14-8.8-18.6s-12.9-6.4-19.9-5l-160 32C312.1 34.7 304 44.6 304 56l0 105.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-132.3L464 53.3l0 76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-152zM106.9 309.5l2.7-5.5 68.7 0 2.7 5.5c8.1 16.3 24.8 26.5 42.9 26.5c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16c18.2 0 34.8-10.3 42.9-26.5zM224 288l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-88.4 0c-12.1 0-23.2 6.8-28.6 17.7L64 288c-35.3 0-64 28.7-64 64l0 96c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64zM192 392a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM473.4 259.1c-6-4.4-14.3-4-19.9 .9l-128 112c-5 4.4-6.8 11.4-4.4 17.7s8.3 10.4 15 10.4l55.7 0-38.4 89.7c-2.9 6.9-.7 14.9 5.3 19.2s14.3 4 19.9-.9l128-112c5-4.4 6.8-11.4 4.4-17.7s-8.3-10.4-15-10.4l-55.7 0 38.4-89.7c2.9-6.9 .7-14.9-5.3-19.2z"]
};
const faHeartMusicCameraBolt = faIcons;
const faMicrophoneLinesSlash = {
  prefix: 'far',
  iconName: 'microphone-lines-slash',
  icon: [640, 512, ["microphone-alt-slash"], "f539", "M472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5l0-160c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7zM272 187.9L272 96c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 64c0 2.3-.2 4.6-.5 6.8L272 187.9zm86.2 190.3C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9z"]
};
const faMicrophoneAltSlash = faMicrophoneLinesSlash;
const faClosedCaptioningSlash = {
  prefix: 'far',
  iconName: 'closed-captioning-slash',
  icon: [640, 512, [], "e135", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6-92.1-72.2c10.5-5.4 19.9-12.7 27.7-21.4c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-1.4 0-2.7-.1-4.1-.2l-41.4-32.5c-1.6-4.8-2.5-10-2.5-15.4c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-45.4 0-83.4 31.5-93.4 73.8l-22.4-17.5c2.9-8.1 1.5-17.4-4.7-24.3c-16.6-18.5-40.4-30.6-67-31.9L134.4 80zm353 400l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM295 328.4l-39.1-30.8c-7 4.1-15.2 6.4-23.9 6.4c-26.5 0-48-21.5-48-48c0-4.7 .7-9.2 1.9-13.5l-39.1-30.8C139.9 224.9 136 240 136 256c0 53 43 96 96 96c24.1 0 46.2-8.9 63-23.6z"]
};
const faCalculatorSimple = {
  prefix: 'far',
  iconName: 'calculator-simple',
  icon: [512, 512, ["calculator-alt"], "f64c", "M256 0c13.3 0 24 10.7 24 24l0 208 208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-208c0-13.3 10.7-24 24-24zM400 32c13.3 0 24 10.7 24 24l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24zM55.4 343.4c9.4-9.4 24.6-9.4 33.9 0L112 366.1l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L145.9 400l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L112 433.9 89.4 456.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L78.1 400 55.4 377.4c-9.4-9.4-9.4-24.6 0-33.9zM64 88l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM352 336l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCalculatorAlt = faCalculatorSimple;
const faBridgeCircleCheck = {
  prefix: 'far',
  iconName: 'bridge-circle-check',
  icon: [640, 512, [], "e4c9", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
const faSlidersUp = {
  prefix: 'far',
  iconName: 'sliders-up',
  icon: [512, 512, ["sliders-v"], "f3f1", "M96 0c13.3 0 24 10.7 24 24l0 59.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3L120 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-251.7C39.5 226.1 16 195.8 16 160s23.5-66.1 56-76.3L72 24C72 10.7 82.7 0 96 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 59.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-59.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 251.7c32.5 10.2 56 40.5 56 76.3zM448 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8 76.3L440 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-219.7c-32.5-10.2-56-40.5-56-76.3s23.5-66.1 56-76.3L392 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.7c32.5 10.2 56 40.5 56 76.3s-23.5 66.1-56 76.3z"]
};
const faSlidersV = faSlidersUp;
const faLocationMinus = {
  prefix: 'far',
  iconName: 'location-minus',
  icon: [384, 512, ["map-marker-minus"], "f609", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM120 168l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMapMarkerMinus = faLocationMinus;
const faPumpMedical = {
  prefix: 'far',
  iconName: 'pump-medical',
  icon: [448, 512, [], "e06a", "M168 0l48 0c25.4 0 46.8 16.9 53.7 40l46.4 0c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7L272 88l0 40-48 0 0-72c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 72-48 0 0-72c0-30.9 25.1-56 56-56zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464l186.4 0c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7l-149.1 0c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zM216 296l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faFingerprint = {
  prefix: 'far',
  iconName: 'fingerprint',
  icon: [512, 512, [], "f577", "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256l0 24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1l0-24.9zm-96-24c-13.3 0-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9c0-13.3-10.7-24-24-24z"]
};
const faSkiBoot = {
  prefix: 'far',
  iconName: 'ski-boot',
  icon: [512, 512, [], "e3cc", "M364.1 .3c13.1 2.2 21.8 14.6 19.6 27.7l-45 262.4L449 345.7c19 9.5 31 28.9 31 50.1l0 68.2 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L63.2 512c-35.4 0-61.9-32.5-54.9-67.2L88.5 51.2C90.8 40 100.6 32 112 32l222.3 0 2.1-12.1C338.6 6.9 351-1.9 364.1 .3zM202.4 80l-70.8 0L97.7 246.4c37.7-27.1 79.9-76.4 104.7-166.4zm33.1 0C203.5 204.3 140 262.5 88.9 289.4l-33.6 165c-1 5 2.8 9.6 7.8 9.6L432 464l0-68.2c0-3-1.7-5.8-4.4-7.2L301.3 325.5c-2.8-1.4-5.2-3.3-7.2-5.5L224 320c-8.8 0-16-7.2-16-16s7.2-16 16-16l66.4 0 11-64L256 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l50.8 0L326.1 80l-90.5 0z"]
};
const faStandardDefinition = {
  prefix: 'far',
  iconName: 'standard-definition',
  icon: [576, 512, ["rectangle-sd"], "e28a", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 184l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm48 24l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96zm-189.8 4.5c.7-.7 2.1-1.9 5.4-2.9c7.1-2.3 18.8-2.9 35.5-.6c5.1 .7 21 3.3 25.6 4.4c12.9 2.9 25.8-5.1 28.7-18.1s-5.1-25.8-18.1-28.7c-6.6-1.5-24.1-4.4-29.9-5.2c-19-2.5-39.3-3.1-56.7 2.5c-19.2 6.2-34.9 20.3-39.6 43.5c-.1 .4-.2 .9-.2 1.3c-1.7 11.7-.3 23 5.2 33.2c5.3 9.9 13.3 16.7 21.1 21.3c13.9 8.3 32 12.5 45.5 15.6l1.8 .4c16.1 3.8 26.9 6.5 33.6 10.5c1.4 .8 2.2 1.5 2.7 2c.5 .4 .6 .7 .6 .7c0 0 .1 .1 .1 .5c.1 .4 .1 1.4-.1 3.2c-.4 2.4-1 3.2-1.3 3.5c-.4 .5-1.8 1.6-5.1 2.7c-7.3 2.3-19.5 2.8-36.2 .6c-7.2-1-20-4.7-31.1-8c0 0 0 0 0 0s0 0 0 0c-2.6-.7-5-1.5-7.3-2.1c-12.7-3.6-26 3.7-29.7 16.5s3.7 26 16.5 29.7c1.4 .4 3.2 .9 5.3 1.5c10.8 3.2 28.6 8.4 39.7 9.9l.1 0c19 2.5 39.6 3.2 57.1-2.4c9.1-2.9 18.2-7.7 25.6-15.6c7.6-8.1 12.1-18.1 13.8-29.3c1.7-11.7 .3-23-5.2-33.2c-5.3-9.9-13.3-16.7-21.1-21.3c-13.9-8.3-32-12.5-45.5-15.6l-1.8-.4c-16.1-3.8-26.9-6.5-33.6-10.5c-1.4-.8-2.2-1.5-2.7-2c-.5-.4-.6-.7-.6-.7c0 0 0 0 0 0c0 0-.1-.1-.1-.5s-.1-1.2 0-2.5c.5-2.3 1.3-3.3 1.8-3.8z"]
};
const faRectangleSd = faStandardDefinition;
const faH1 = {
  prefix: 'far',
  iconName: 'h1',
  icon: [576, 512, [], "f313", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8 456 400l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-312z"]
};
const faHandPointRight = {
  prefix: 'far',
  iconName: 'hand-point-right',
  icon: [512, 512, [], "f0a4", "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"]
};
const faMagnifyingGlassLocation = {
  prefix: 'far',
  iconName: 'magnifying-glass-location',
  icon: [512, 512, ["search-location"], "f689", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm80-240c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSearchLocation = faMagnifyingGlassLocation;
const faMessageBot = {
  prefix: 'far',
  iconName: 'message-bot',
  icon: [640, 512, [], "e3b8", "M272 368l-48 0-64 0c-8.8 0-16-7.2-16-16l0-160 0-128c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 128 0 160c0 8.8-7.2 16-16 16l-106.7 0-16 0-12.8 9.6L272 432l0-16 0-48zM96 208l0 144c0 35.3 28.7 64 64 64l16 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76L480 416c35.3 0 64-28.7 64-64l0-144 36.3 0c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16L544 176l0-112c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 112-36.3 0c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16L96 208zm80-80l0 128c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L208 96c-17.7 0-32 14.3-32 32zm32 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faForwardStep = {
  prefix: 'far',
  iconName: 'forward-step',
  icon: [320, 512, ["step-forward"], "f051", "M240 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 138.7 0 58.6L288 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-105.1L63.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C29.5 448 16 434.5 16 417.9L16 94.1C16 77.5 29.5 64 46.1 64c6.2 0 12.2 1.9 17.3 5.4L240 193.1 240 88zm0 172.3l0-8.6L64 128.5l0 255L240 260.3z"]
};
const faStepForward = faForwardStep;
const faFaceSmileBeam = {
  prefix: 'far',
  iconName: 'face-smile-beam',
  icon: [512, 512, [128522, "smile-beam"], "f5b8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faSmileBeam = faFaceSmileBeam;
const faLightCeiling = {
  prefix: 'far',
  iconName: 'light-ceiling',
  icon: [512, 512, [], "e016", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 137.1C112.4 172.2 16.7 265.6 2 384.1C-.2 401.6 14.3 416 32 416l448 0c17.7 0 32.2-14.4 30-31.9c-14.7-118.5-110.5-211.8-230-223L280 24zM458.4 368L53.6 368C75.2 276.3 157.7 208 256 208s180.8 68.3 202.4 160zM256 512c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z"]
};
const faMessageExclamation = {
  prefix: 'far',
  iconName: 'message-exclamation',
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM256 80c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCommentAltExclamation = faMessageExclamation;
const faBowlScoop = {
  prefix: 'far',
  iconName: 'bowl-scoop',
  icon: [448, 512, [127847, "bowl-shaved-ice"], "e3de", "M32 224l384 0c0-106-86-192-192-192S32 118 32 224zM173.8 368l-2.2 0L145 368c-41.4 0-77.2-26.3-90.5-64l339.1 0c-13.3 37.7-49.1 64-90.5 64l-26.7 0-2.2 0-100.3 0zm36.9 78.7L224 430.8l13.3 15.9L251.7 464l-55.4 0 14.4-17.3zm92.3 3.9L274.2 416l28.8 0c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3l28.8 0L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2l19.2 0 8.5 0 .6 0 135.4 0 .6 0 8.5 0 19.2 0c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z"]
};
const faBowlShavedIce = faBowlScoop;
const faSquareX = {
  prefix: 'far',
  iconName: 'square-x',
  icon: [448, 512, [], "e286", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.3 40.5L224 218.8l69.7-82.3c8.6-10.1 23.7-11.4 33.8-2.8s11.4 23.7 2.8 33.8L255.4 256l74.9 88.5c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8L224 293.2l-69.7 82.3c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8L192.6 256l-74.9-88.5c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8z"]
};
const faBuildingMemo = {
  prefix: 'far',
  iconName: 'building-memo',
  icon: [640, 512, [], "e61e", "M64 48l256 0c8.8 0 16 7.2 16 16l0 9.6c12-6.1 25.6-9.6 40-9.6l8 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l244.1 0c-11-13.3-18.1-29.8-19.8-48L240 464l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm232 56c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c2.9 0 5.6-.8 8-2.1l0-13.9c0-13.1 2.9-25.5 8-36.7l0-11.3zM280 216l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c2.9 0 5.6-.8 8-2.1l0-75.7c-2.4-1.4-5.1-2.1-8-2.1zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm0 128l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM384 96c-35.3 0-64 28.7-64 64l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L384 96zm16 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM376 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm64-168c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm16 80l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM464 400c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16z"]
};
const faUtilityPoleDouble = {
  prefix: 'far',
  iconName: 'utility-pole-double',
  icon: [512, 512, [], "e2c4", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56L128 80l0-24c0-13.3-10.7-24-24-24S80 42.7 80 56l0 24L64.2 80c-.2 0-.3 0-.5 0L48 80l0-24c0-13.3-10.7-24-24-24S0 42.7 0 56L0 88c0 22.1 17.9 40 40 40l43.2 0L232 227.2l0 44.8-104 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L48 272l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 22.1 17.9 40 40 40l43.2 0L232 419.2l0 68.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-68.8L428.8 320l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 272l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-104 0 0-44.8L428.8 128l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 80l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L280 80l0-56zm91.2 104L280 188.8l0-60.8 91.2 0zM232 188.8L140.8 128l91.2 0 0 60.8zM371.2 320L280 380.8l0-60.8 91.2 0zM232 380.8L140.8 320l91.2 0 0 60.8z"]
};
const faFlagCheckered = {
  prefix: 'far',
  iconName: 'flag-checkered',
  icon: [448, 512, [127937], "f11e", "M24 0C37.3 0 48 10.7 48 24l0 28 85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 388l0 100c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88 0-49.5L0 64 0 24C0 10.7 10.7 0 24 0zM48 150.7l80-17.4 0-51.9-80 20 0 49.3zm0 49.1l0 46.9 80-17.4 0-46.9L48 199.9zm0 96l0 42.7 68.6-17.2c3.8-.9 7.6-1.8 11.4-2.5l0-40.4L48 295.9zm128 18.8c33.1 .7 65.9 8.7 96 23.7l0-49.8-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6l0 46zm144 37c18.7 1.5 37.7-1.1 55.6-7.8l24.4-9.1 0-46.7L374.3 294c-17.9 4.1-36.1 5.5-54.3 4.3l0 53.5zm80-113l0-46.7L374.3 198c-17.9 4.1-36.1 5.5-54.3 4.3l0 47.8c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zm0-96l0-49.8c-25.6 10.4-52.8 15.6-80 15.6l0 45.5c14.5 1.4 29.2 .4 43.5-2.9l36.5-8.4zM272 103.1c-16.1-3.7-31.9-9.4-47-16.9c-15.3-7.7-32.1-11.8-49-12.3l0 50.6c18.2-1.3 36.5 .6 54.1 5.8L272 142.5l0-39.4zm0 89.5l-55.4-16.3c-13.2-3.9-27-5.1-40.6-3.6l0 47.8c18.2-1.3 36.5 .6 54.1 5.8L272 238.5l0-46z"]
};
const faChevronsUp = {
  prefix: 'far',
  iconName: 'chevrons-up',
  icon: [512, 512, ["chevron-double-up"], "f325", "M273 47c-9.4-9.4-24.6-9.4-33.9 0L47 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 47zM465 431L273 239c-9.4-9.4-24.6-9.4-33.9 0L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l175-175L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
const faChevronDoubleUp = faChevronsUp;
const faFootball = {
  prefix: 'far',
  iconName: 'football',
  icon: [512, 512, [127944, "football-ball"], "f44e", "M442.6 69.4c-32.9-5-63.1-7.4-90.7-7.4l98 98c.5-32.1-2.4-63.1-7.3-90.6zm-217 12.7c-55.4 20.5-93.3 55.2-118.6 96.5c-20.6 33.7-33 72-39.5 110.9L223.6 445.6c23.2-3.4 44.1-8.8 62.8-15.8c55.4-20.5 93.3-55.2 118.6-96.5c20.6-33.7 33-72 39.5-110.9L288.4 66.4c-23.2 3.4-44.1 8.8-62.8 15.8zM62.1 352c-.5 32.1 2.4 63.1 7.3 90.6c32.9 5 63.1 7.4 90.7 7.4l-98-98zm4-198.4c30.6-50 76.8-92 142.9-116.5C274.4 12.8 357.6 6.5 461.5 23.8c13 2.2 23.4 12.1 26.1 25.1c17.5 84.8 18.6 211.3-41.6 309.5c-30.6 50-76.8 92-142.9 116.5c-65.6 24.3-148.7 30.7-252.6 13.3c-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6zM297 151l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm-56 56l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faFootballBall = faFootball;
const faUserVneck = {
  prefix: 'far',
  iconName: 'user-vneck',
  icon: [448, 512, [], "e461", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM48.3 464l351.5 0c-3.1-47.3-33.7-87.3-76-103.8L274 422.4c-25.6 32-74.3 32-100 0l-49.7-62.2C82 376.7 51.4 416.7 48.3 464zm85-156.4c5.6-1.2 11.3 1.1 14.9 5.6l63.4 79.2c6.4 8 18.6 8 25 0l63.4-79.2c3.6-4.5 9.3-6.7 14.9-5.6C390.9 323.6 448 391.1 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.9 57.1-148.4 133.3-164.4z"]
};
const faSchoolCircleExclamation = {
  prefix: 'far',
  iconName: 'school-circle-exclamation',
  icon: [640, 512, [], "e56c", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faCrop = {
  prefix: 'far',
  iconName: 'crop',
  icon: [512, 512, [], "f125", "M80 24C80 10.7 90.7 0 104 0s24 10.7 24 24l0 326.1L350.1 128 160 128l0-48 238.1 0L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-73 73L432 384l56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-326.1L161.9 384 352 384l0 48-216 0c-30.9 0-56-25.1-56-56l0-248-56 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l56 0 0-56z"]
};
const faAnglesDown = {
  prefix: 'far',
  iconName: 'angles-down',
  icon: [448, 512, ["angle-double-down"], "f103", "M401 113L241 273c-9.4 9.4-24.6 9.4-33.9 0L47 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 79c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm0 192L241 465c-9.4 9.4-24.6 9.4-33.9 0L47 305c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faAngleDoubleDown = faAnglesDown;
const faUsersRectangle = {
  prefix: 'far',
  iconName: 'users-rectangle',
  icon: [640, 512, [], "e594", "M88 0C39.4 0 0 39.4 0 88L0 424c0 48.6 39.4 88 88 88l464 0c48.6 0 88-39.4 88-88l0-336c0-48.6-39.4-88-88-88L88 0zM48 88c0-22.1 17.9-40 40-40l464 0c22.1 0 40 17.9 40 40l0 336c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40L48 88zm272 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM268.4 274c-1.1 .2-2.2 .5-3.3 .7c-25.7 6.3-47.4 22.9-60.3 45.3c-8.2 14.1-12.8 30.5-12.8 48c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32c0-17.5-4.7-33.9-12.8-48c-1.1-1.8-2.2-3.6-3.3-5.4c-13.1-19.6-33.3-34.1-56.9-39.9c-1.1-.3-2.2-.5-3.3-.7c-6.3-1.3-12.9-2-19.6-2l-32 0-32 0c-6.7 0-13.3 .7-19.6 2zm7-49.5a72 72 0 1 0 89.2-113.1A72 72 0 1 0 275.4 224.5zM397.3 352l-154.5 0c6.6-18.6 24.4-32 45.3-32l64 0c20.9 0 38.7 13.4 45.3 32zM223.8 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 293.3c0 14.7 11.9 26.7 26.7 26.7l46.6 0c13.7-33.9 41.5-60.6 76.2-72.8c-7.9-4.6-17-7.2-26.8-7.2l-69.3 0C119.9 240 96 263.9 96 293.3zM470.7 320l46.6 0c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3l-69.3 0c-9.8 0-18.9 2.6-26.8 7.2c34.6 12.2 62.5 38.9 76.2 72.8zM512 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faPeopleRoof = {
  prefix: 'far',
  iconName: 'people-roof',
  icon: [640, 512, [], "e537", "M332.3 3.4l296 176c11.4 6.8 15.1 21.5 8.4 32.9s-21.5 15.1-32.9 8.4L320 51.9 36.3 220.6c-11.4 6.8-26.1 3-32.9-8.4s-3-26.1 8.4-32.9l296-176c7.6-4.5 17-4.5 24.5 0zM496 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5zm98.9 27.4l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35 0 39.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-39.7-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5l0 79.5 32 0 0-79.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5z"]
};
const faSquareArrowRight = {
  prefix: 'far',
  iconName: 'square-arrow-right',
  icon: [448, 512, ["arrow-square-right"], "f33b", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM361 273l-88 88c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L104 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9z"]
};
const faArrowSquareRight = faSquareArrowRight;
const faLocationPlus = {
  prefix: 'far',
  iconName: 'location-plus',
  icon: [384, 512, ["map-marker-plus"], "f60a", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM168 280l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faMapMarkerPlus = faLocationPlus;
const faLightbulbExclamationOn = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation-on',
  icon: [640, 512, [], "e1ca", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM425.2 248.9C439.6 228.3 448 203.2 448 176c0-70.7-57.3-128-128-128s-128 57.3-128 128c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L237 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16 160 0 0 16zM336 128l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPeopleLine = {
  prefix: 'far',
  iconName: 'people-line',
  icon: [640, 512, [], "e534", "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM304 176.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 79.5-32 0 0-79.5zm80 55.8l18.9 35c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35 0 23.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-23.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.4-28.5-45.1-46.3-77.5-46.3l-19.5 0c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.4-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35L80 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-23.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8l18.9-35 0 39.7c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-39.7zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM480 336l0-63.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 63.5-32 0zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM128 336l0-63.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 63.5-32 0z"]
};
const faBeerMugEmpty = {
  prefix: 'far',
  iconName: 'beer-mug-empty',
  icon: [512, 512, ["beer"], "f0fc", "M80 80l0 336c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-47.4c0-.4 0-.7 0-1.1L336 80 80 80zM384 383.7l0 32.3c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64L32 64c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 32 59.2 0c38 0 68.8 30.8 68.8 68.8l0 117.9c0 27.3-16.2 52.1-41.2 63l-86.8 38zM384 144l0 187.3 67.5-29.5c7.6-3.3 12.5-10.8 12.5-19.1l0-117.9c0-11.5-9.3-20.8-20.8-20.8L384 144zM144 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16z"]
};
const faBeer = faBeerMugEmpty;
const faCarpool = {
  prefix: 'far',
  iconName: 'carpool',
  icon: [512, 512, ["car-people"], "e69c", "M160.2 80l191.7 0c26.2 0 49 18.2 54.7 43.9l22.4 101c-4.2-.6-8.6-.9-12.9-.9l-22.4 0c-8.3-14.3-23.8-24-41.6-24l-32 0c-17.8 0-33.3 9.7-41.6 24l-44.8 0c-8.3-14.3-23.8-24-41.6-24l-32 0c-17.8 0-33.3 9.7-41.6 24L96 224c-4.4 0-8.7 .3-12.9 .9l22.4-101C111.2 98.2 133.9 80 160.2 80zM484.2 252.5l-30.9-139C442.8 65.9 400.6 32 351.8 32L160.2 32c-48.7 0-90.9 33.9-101.5 81.4l-30.9 139C10.6 269.8 0 293.7 0 320l0 64 0 16 0 32 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 416 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-32 0-16 0-64c0-26.3-10.6-50.2-27.8-67.5zM176 184a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm160 0a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM96 272l320 0c26.5 0 48 21.5 48 48l0 64L48 384l0-64c0-26.5 21.5-48 48-48zm48 56a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCarPeople = faCarpool;
const faCrateEmpty = {
  prefix: 'far',
  iconName: 'crate-empty',
  icon: [512, 512, [], "e151", "M56 272c-4.4 0-8 3.6-8 8l0 64 416 0 0-64c0-4.4-3.6-8-8-8L56 272zM48 392l0 64c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-64L48 392zM0 280c0-30.9 25.1-56 56-56l400 0c30.9 0 56 25.1 56 56l0 176c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 280zm400 24a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faDiagramPredecessor = {
  prefix: 'far',
  iconName: 'diagram-predecessor',
  icon: [512, 512, [], "e477", "M464 416l0-64c0-8.8-7.2-16-16-16L64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16zm-16 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c39.8 0 72 32.2 72 72l0 38.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23 0-38.1c0-13.3-10.7-24-24-24l-82 0c1.3 5.1 2 10.5 2 16l0 64z"]
};
const faTransporter = {
  prefix: 'far',
  iconName: 'transporter',
  icon: [512, 512, [], "e042", "M472.7 6.6L480 32l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 64l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 64l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 32l7.3-25.4C456.4 2.7 459.9 0 464 0s7.6 2.7 8.7 6.6zm-416 64L64 96l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 128l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 128 6.6 120.7C2.7 119.6 0 116.1 0 112s2.7-7.6 6.6-8.7L32 96l7.3-25.4C40.4 66.7 43.9 64 48 64s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24zM208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 272l0 112-48 0 0-223.2-52.9 69.7c-8 10.6-23.1 12.6-33.6 4.6s-12.6-23.1-4.6-33.6l65.7-86.7c16.6-21.9 42.6-34.8 70.1-34.8l38.6 0c27.5 0 53.5 12.9 70.1 34.8l65.7 86.7c8 10.6 5.9 25.6-4.6 33.6s-25.6 5.9-33.6-4.6L320 208.8 320 432l-48 0 0-112-32 0zm0-48l32 0 0-96-32 0 0 96z"]
};
const faCalendarCircleUser = {
  prefix: 'far',
  iconName: 'calendar-circle-user',
  icon: [576, 512, [], "e471", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C374.5 468.1 401.8 480 432 480s57.5-11.9 77.7-31.3zM480 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faArrowUpLong = {
  prefix: 'far',
  iconName: 'arrow-up-long',
  icon: [384, 512, ["long-arrow-up"], "f176", "M209 7c-9.4-9.4-24.6-9.4-33.9 0L39 143c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l95-95L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-406.1 95 95c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7z"]
};
const faLongArrowUp = faArrowUpLong;
const faPersonCarryBox = {
  prefix: 'far',
  iconName: 'person-carry-box',
  icon: [384, 512, ["person-carry"], "f4cf", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM59.2 176C53 176 48 181 48 187.2l0 85.3c0 2.5 1.1 4.8 3.1 6.3L72 295.2 72 179c-3.9-1.9-8.3-3-12.8-3zM120 246.2l0 86.7 25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4l0-85.3C0 154.5 26.5 128 59.2 128c26.1 0 50.5 13.3 64.6 35.3L173.1 240l18.9 0 0-112c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-120 0-8 0-55.3 0c-13.6 0-26.3-6.9-33.6-18.4L120 246.2zM240 240l96 0 0-96-96 0 0 96z"]
};
const faPersonCarry = faPersonCarryBox;
const faFireFlameSimple = {
  prefix: 'far',
  iconName: 'fire-flame-simple',
  icon: [384, 512, ["burn"], "f46a", "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zm72.6 281.4c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"]
};
const faBurn = faFireFlameSimple;
const faPerson = {
  prefix: 'far',
  iconName: 'person',
  icon: [320, 512, [129485, "male"], "f183", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0z"]
};
const faMale = faPerson;
const faLaptop = {
  prefix: 'far',
  iconName: 'laptop',
  icon: [640, 512, [128187], "f109", "M512 80L128 80c-8.8 0-16 7.2-16 16l0 224-48 0L64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 224-48 0 0-224c0-8.8-7.2-16-16-16zM96 432l448 0c20.9 0 38.7-13.4 45.3-32L50.7 400c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96L96 480c-53 0-96-43-96-96z"]
};
const faFileCsv = {
  prefix: 'far',
  iconName: 'file-csv',
  icon: [512, 512, [], "f6dd", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm133.1 0l34.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l42.9 0c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z"]
};
const faMenorah = {
  prefix: 'far',
  iconName: 'menorah',
  icon: [640, 512, [], "f676", "M2.7 49.7L20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1L64 64c0 17.7-14.3 32-32 32S0 81.7 0 64l0-1.2c0-4.5 .9-8.9 2.7-13.1zm96 0L116.8 7.4C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L212.8 7.4zm77.8 42.4L308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L404.8 7.4zm77.8 42.4L500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L596.8 7.4zM24 128c13.3 0 24 10.7 24 24l0 128c0 22.1 17.9 40 40 40l208 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168 208 0c22.1 0 40-17.9 40-40l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128c0 48.6-39.4 88-88 88l-208 0 0 96 144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-168 0-168 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0 0-96L88 368c-48.6 0-88-39.4-88-88L0 152c0-13.3 10.7-24 24-24zm128 24l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm192 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112 0 24-48 0 0-24 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faUnion = {
  prefix: 'far',
  iconName: 'union',
  icon: [384, 512, [8899], "f6a2", "M24 32c13.3 0 24 10.7 24 24l0 232c0 79.5 64.5 144 144 144s144-64.5 144-144l0-232c0-13.3 10.7-24 24-24s24 10.7 24 24l0 232c0 106-86 192-192 192S0 394 0 288L0 56C0 42.7 10.7 32 24 32z"]
};
const faChevronsLeft = {
  prefix: 'far',
  iconName: 'chevrons-left',
  icon: [512, 512, ["chevron-double-left"], "f323", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L239 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 273 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM431 47L239 239c-9.4 9.4-9.4 24.6 0 33.9L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-175-175L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
const faChevronDoubleLeft = faChevronsLeft;
const faCircleHeart = {
  prefix: 'far',
  iconName: 'circle-heart',
  icon: [512, 512, ["heart-circle"], "f4c7", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9L233.5 384.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L380.1 280.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0l-17.7 18-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108z"]
};
const faHeartCircle = faCircleHeart;
const faTruckPlane = {
  prefix: 'far',
  iconName: 'truck-plane',
  icon: [640, 512, [], "e58f", "M183.3 18.7C192.9 8.8 206.6 0 224 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9c7.8 17.9 13 38.3 15.3 56c-23.5 14.1-40.5 37.9-45.3 65.9c-.9-2.6-1.4-5.3-1.4-8.1l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 7.3-3.3 14.2-9 18.8L53.7 289.3c-.7 .5-1.3 1-2 1.5c-2.3 1.5-3.7 4-3.7 6.7l0 28.7 111-44.8c7.4-3 15.8-2.1 22.4 2.4s10.6 11.9 10.6 19.9l0 72.3c0 7.6-3.6 14.7-9.6 19.2L128 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c9.1 2.8 21.9 6.7 35.5 10.8c5.4 10.5 12.7 19.9 21.4 27.7l0 16.5c0 4.4 .5 8.7 1.5 12.9l-7.6-2.3c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C97 512 80 495 80 474.1L80 432c0-12.6 5.9-24.4 16-32l48-36 0-24.8L53.9 375.6c-.5 .2-1.1 .4-1.7 .6C26.4 384.4 0 365.2 0 338.1l0-40.6c0-18.6 9.2-36 24.6-46.4L144 155.8l0-27.8c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM288 192c0-16.2 6-31.1 16-42.3c11.7-13.3 28.9-21.7 48-21.7l224 0c35.3 0 64 28.7 64 64l0 184 0 24c0 23.7-12.9 44.4-32 55.4l0 32.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-192 0 0 10.1 0 13.9c0 13.3-10.7 24-24 24c-2.1 0-4.2-.3-6.1-.8c-4.9-1.3-9.2-4.1-12.3-7.9c0 0 0 0 0 0c-3.4-4.2-5.5-9.5-5.5-15.3l0-28.1 0-4.5c-15.5-9-26.9-24.3-30.7-42.4c-.9-4.2-1.3-8.5-1.3-13l0-24 0-94.9 0-76.6 0-12.5zM400 304l11.2 0 6.4 0 16.8 0 13.6 0 45.6 0 23.2 0 27.2 0-11.9-37c-2.5-6.5-8.4-11-15.3-11l-87.2 0-18.4 0c-6.9 0-12.9 4.5-15.3 11l-1.6 5-4.4 13.8L384 304l16 0zm-50.3-50.3l.5-1.4 .4-1.2 .5-1.2c.2-.6 .5-1.2 .7-1.8c3.6-8.7 9.2-16.7 16.3-23.3c3.5-3.3 7.5-6.2 11.7-8.6c9.1-5.2 19.8-8.3 31.5-8.3l105.6 0c28.8 0 51.4 18.7 60.2 41.9l.5 1.2 .4 1.2 11.9 37 2.3 7.2L592 192c0-8.8-7.2-16-16-16l-224 0c-5.7 0-10.6 2.9-13.5 7.4c-1.6 2.5-2.5 5.4-2.5 8.6l0 20.5 0 30.3 0 53.7 2.3-7.2 11.4-35.6zM445.5 352L422 352l-38 0-8 0-16 0c-5.1 0-9.8 1.6-13.7 4.3c-6.2 4.3-10.3 11.5-10.3 19.7l0 12 0 12c0 8.3 6.3 15.1 14.4 15.9c.5 .1 1.1 .1 1.6 .1l12.7 0L576 416c8.8 0 16-7.2 16-16l0-24c0-13.3-10.7-24-24-24l-24 0-98.5 0zM368 406.6a24 24 0 1 1 16-45.3 24 24 0 1 1 -16 45.3zM552 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faRecordVinyl = {
  prefix: 'far',
  iconName: 'record-vinyl',
  icon: [512, 512, [], "f8d9", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm120 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBringForward = {
  prefix: 'far',
  iconName: 'bring-forward',
  icon: [512, 512, [], "f856", "M224 464l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-64 0 0-48 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-64 48 0 0 64c0 8.8 7.2 16 16 16zm64-112L64 352c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64z"]
};
const faSquareP = {
  prefix: 'far',
  iconName: 'square-p',
  icon: [448, 512, [], "e279", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-136c0-13.3 10.7-24 24-24zm92 136c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88 68 0z"]
};
const faFaceGrinStars = {
  prefix: 'far',
  iconName: 'face-grin-stars',
  icon: [512, 512, [129321, "grin-stars"], "f587", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"]
};
const faGrinStars = faFaceGrinStars;
const faSigma = {
  prefix: 'far',
  iconName: 'sigma',
  icon: [384, 512, [8721], "f68b", "M1.8 46.8C5.5 37.8 14.3 32 24 32l304 0c30.9 0 56 25.1 56 56l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-4.4-3.6-8-8-8L81.9 80 241 239c9.4 9.4 9.4 24.6 0 33.9L81.9 432 328 432c4.4 0 8-3.6 8-8l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 30.9-25.1 56-56 56L24 480c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l183-183L7 73C.2 66.1-1.9 55.8 1.8 46.8z"]
};
const faCameraMovie = {
  prefix: 'far',
  iconName: 'camera-movie',
  icon: [576, 512, [127909, 127910], "f8a9", "M224 120A72 72 0 1 0 80 120a72 72 0 1 0 144 0zM344 240l-192 0C85.7 240 32 186.3 32 120S85.7 0 152 0c39.3 0 74.1 18.8 96 48c21.9-29.1 56.7-48 96-48c66.3 0 120 53.7 120 120s-53.7 120-120 120zM272 120a72 72 0 1 0 144 0 72 72 0 1 0 -144 0zM112 336l0 112c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-208 0-16 0c-8.8 0-16 7.2-16 16zm32-64l208 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-112c0-5.5 .7-10.9 2-16l-42 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0 16 0zm384 36.6l-80 36 0-52.6 75.6-34c2.9-1.3 6-2.2 9.1-2.8c22.6-3.8 43.3 13.7 43.3 36.6l0 180.6c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L448 476l0-52.6 80 36 0-150.7z"]
};
const faBong = {
  prefix: 'far',
  iconName: 'bong',
  icon: [448, 512, [], "f55c", "M144 208.5c0 23.3-12.4 43.2-29.9 54.4C92.3 276.9 74.5 296.7 63 320L321 320c-11.6-23.3-29.3-43.1-51.2-57.2c-17.4-11.2-29.9-31.1-29.9-54.4L240 48l-96 0 0 160.5zM288 48l0 160.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5L76.1 512c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14L96 48l-8 0C74.7 48 64 37.3 64 24S74.7 0 88 0l24 0L272 0l24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z"]
};
const faClarinet = {
  prefix: 'far',
  iconName: 'clarinet',
  icon: [640, 512, [], "f8ad", "M224 112c0-8.8 7.2-16 16-16l32 0 96 0 96 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 32 44.6 0c7.9 0 15.6-2.3 22.2-6.7L602.7 116c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136l0 240c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7l-411.2 0c-8.6 0-17.1-1.3-25.3-3.7L17.1 327C7 323.9 0 314.6 0 304l0-96c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7L256 160l0-32-16 0c-8.8 0-16-7.2-16-16zm64 48l64 0 0-32-64 0 0 32zm96 0l64 0 0-32-64 0 0 32zM248 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm133.4-62.8C559 202.9 542 208 524.6 208l-411.2 0c-3.9 0-7.8 .6-11.5 1.7L48 225.9l0 60.3 53.9 16.2c3.7 1.1 7.6 1.7 11.5 1.7l411.2 0c17.4 0 34.4 5.1 48.8 14.8L592 331.2l0-150.3-18.6 12.4z"]
};
const faTruckFlatbed = {
  prefix: 'far',
  iconName: 'truck-flatbed',
  icon: [640, 512, [], "e2b6", "M368 120c0-13.3 10.7-24 24-24l66.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96s-96-43-96-96l-8 0-120 0c0 53-43 96-96 96s-96-43-96-96l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L368 368l0-248zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faSpaghettiMonsterFlying = {
  prefix: 'far',
  iconName: 'spaghetti-monster-flying',
  icon: [640, 512, ["pastafarianism"], "f67b", "M192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 58.3c10-11.3 16-26.1 16-42.3c0-35.3-28.7-64-64-64s-64 28.7-64 64s28.7 64 64 64c1.7 0 3.4-.1 5.1-.2L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200c-13.3 0-24 10.7-24 24s10.7 24 24 24c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-2.4 7.1-4.5 14.2-6.5 20.6L151 331c-3.4 11.2-6.4 20.3-9.8 27.8c-3.5 7.5-6.6 11.5-9.4 13.8c-2.3 1.8-5.5 3.4-11.7 3.4c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8c-13.3 0-24 10.7-24 24s10.7 24 24 24c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7c0 0 0 0 0 0C80.1 414 98.6 424 120 424c16.2 0 30.2-4.8 41.7-13.9c10.9-8.7 18-20.2 23-31.1c5-10.9 8.8-22.9 12.2-34l.8-2.7c16.4 12.2 36.1 23.6 58.9 31.3c-5.6 16.6-13.8 37.5-24.6 55.5C217.2 454 203.2 464 192 464c-13.3 0-24 10.7-24 24s10.7 24 24 24c39.1 0 65.6-32 81.2-58.2c14.5-24.2 24.6-51.4 30.7-70.4c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c6.1 19 16.3 46.3 30.7 70.4C382.4 480 408.9 512 448 512c13.3 0 24-10.7 24-24s-10.7-24-24-24c-11.2 0-25.2-10-40-34.8c-10.8-18-19-39-24.6-55.5c22.8-7.7 42.5-19 58.9-31.3l.8 2.7c3.4 11 7.2 23.1 12.2 34c5.1 10.9 12.1 22.4 23 31.1c11.5 9.1 25.5 13.9 41.7 13.9c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2c13.3 0 24-10.7 24-24s-10.7-24-24-24c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.3 0-9.5-1.6-11.7-3.4c-2.8-2.2-6-6.3-9.4-13.8c-3.5-7.5-6.4-16.6-9.8-27.8l-1.3-4.2c-2-6.5-4.1-13.5-6.5-20.6c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c1.7 .1 3.4 .2 5.1 .2c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 16.2 6 31.1 16 42.3l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3zM459.4 256.3c-.4 .6-.9 1.3-1.4 2c-6.3 8.8-15.8 20.5-28.3 32.2C404.5 313.8 368 336 320 336s-84.5-22.2-109.7-45.6c-12.6-11.7-22-23.4-28.3-32.2c-.5-.7-1-1.3-1.4-2c5.4-6.9 10.8-13.8 16.7-20.7c26.4-31 60.4-59.6 122.7-59.6s96.3 28.6 122.7 59.6c5.9 6.9 11.3 13.8 16.7 20.7zM448 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faPastafarianism = faSpaghettiMonsterFlying;
const faArrowDownUpAcrossLine = {
  prefix: 'far',
  iconName: 'arrow-down-up-across-line',
  icon: [576, 512, [], "e4af", "M143 505c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 280l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-150.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L392 232l-208 0-48 0L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0 0 150.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm-7-313l48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136zM440 320l-48 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136z"]
};
const faArrowsRotateReverse = {
  prefix: 'far',
  iconName: 'arrows-rotate-reverse',
  icon: [512, 512, [], "e630", "M418 187.1C391.2 124.1 328.7 80 256 80c-39.7 0-77.8 15.8-105.9 43.9L97.9 176l54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 224c-13.3 0-24-10.7-24-24L16 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1 52.1-52.1C153.2 52.8 203.5 32 256 32c92.6 0 172.1 56.2 206.2 136.3c5.2 12.2-.5 26.3-12.7 31.5s-26.3-.5-31.5-12.7zM50 344.1c-5.2-12.2 .4-26.3 12.6-31.5s26.3 .4 31.5 12.6C121 388.1 183.4 432 256 432c39.7 0 77.8-15.8 105.9-43.9L414.1 336 360 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-52.1 52.1C358.8 459.2 308.5 480 256 480c-92.5 0-171.8-56-206-135.9z"]
};
const faLeafHeart = {
  prefix: 'far',
  iconName: 'leaf-heart',
  icon: [512, 512, [], "f4cb", "M272 144l104 0c31.6 0 61-9.1 85.7-24.9c1.5 12.2 2.3 24.7 2.3 37.5c0 143.2-93.8 242.9-191.2 243.4c0 0 0 0-.1 0l-.8 0c0 0 0 0-.1 0C201.3 400 144 342.7 144 272c0-70.7 57.3-128 128-128zM450.6 67.5C430.8 85.2 404.7 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-48.6 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-26.4-2.9-51.9-8.3-76.2c-.4-1.9-.9-3.8-1.3-5.6c-2.2-9.3-4.8-18.3-7.8-27.2c-1.2-3.6-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1c-1.4 2.7-3 5.3-4.6 7.8c-4.9 7.7-10.8 14.7-17.4 20.9c-.7 .7-1.4 1.3-2.1 1.9zM189.7 242.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z"]
};
const faHouseBuilding = {
  prefix: 'far',
  iconName: 'house-building',
  icon: [640, 512, [], "e1b1", "M352 48l224 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c0 18-6 34.6-16 48l176 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L352 0c-35.3 0-64 28.7-64 64l0 60.6 48 44L336 64c0-8.8 7.2-16 16-16zm61.2 208l18.8 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 4.6 6.1 5.6c11.2 10.3 19.2 23.4 23.1 37.9zm2.8 96l16 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-16 0 0 64zm64-144l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM400 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faCheeseSwiss = {
  prefix: 'far',
  iconName: 'cheese-swiss',
  icon: [512, 512, [129472], "f7f0", "M464 256l0-15.8C464 151.7 392.3 80 303.8 80c-.8 0-1.6 .2-2.3 .7l-35 23.3c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48c-23.4 0-42.9-16.7-47.1-38.9L53.3 246.2C50 248.4 48 252.1 48 256l274.7 0c6.6-18.6 24.4-32 45.3-32s38.7 13.4 45.3 32l50.7 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-60.2 0c-8.8 9.8-21.6 16-35.8 16s-27-6.2-35.8-16L48 304zm464-63.8l0 15.8 0 160c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 256c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zM176 320a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faSpoon = {
  prefix: 'far',
  iconName: 'spoon',
  icon: [512, 512, [129348, 61873, "utensil-spoon"], "f2e5", "M286.1 193.9l32 32c9.3 9.4 21.5 14 33.8 14.1c21.1 0 48.8-13.5 73.2-42.7C449 168.6 464 131.2 464 96c0-26.5-21.5-48-48-48c-35.2 0-72.6 15-101.3 38.9C285.5 111.3 272 139 272 160.1c0 12.3 4.7 24.5 14.1 33.8zm-34.9 33c-18.1-18.6-27.1-42.6-27.2-66.7C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-24.1 0-48.2-9.1-66.7-27.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L251.2 226.9z"]
};
const faUtensilSpoon = faSpoon;
const faJarWheat = {
  prefix: 'far',
  iconName: 'jar-wheat',
  icon: [320, 512, [], "e517", "M32 24c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16l0 304c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-304c0-8.8 7.2-16 16-16l192 0zM64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64L64 80zm192 85.8c0-3.2-2.6-5.8-5.8-5.8L208 160c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2zM250.2 256L208 256c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320l21.8 0 32 0 21.8 0c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8zM256 357.8c0-3.2-2.6-5.8-5.8-5.8L208 352c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416l21.8 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 21.8 0c32.1 0 58.2-26 58.2-58.2z"]
};
const faEnvelopesBulk = {
  prefix: 'far',
  iconName: 'envelopes-bulk',
  icon: [640, 512, ["mail-bulk"], "f674", "M112 48l320 0 0 48 48 0 0-48c0-26.5-21.5-48-48-48L112 0C85.5 0 64 21.5 64 48l0 144 48 0 0-144zM48 272l288 0 0 6.9L192.1 385.4c0 0-.1 0-.1 0s-.1 0-.1 0L48 278.9l0-6.9zm0 66.6L163.3 424c8.3 6.2 18.4 9.5 28.7 9.5s20.4-3.3 28.7-9.5L336 338.6 336 464 48 464l0-125.4zM0 272L0 464c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48L48 224c-26.5 0-48 21.5-48 48zm272-80l0-16 320 0 0 192-176 0 0 48 176 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-320 0c-26.5 0-48 21.5-48 48l0 16 48 0zm240 16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z"]
};
const faMailBulk = faEnvelopesBulk;
const faFileCircleExclamation = {
  prefix: 'far',
  iconName: 'file-circle-exclamation',
  icon: [576, 512, [], "e4eb", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faBowArrow = {
  prefix: 'far',
  iconName: 'bow-arrow',
  icon: [512, 512, [127993], "f6b9", "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1 .3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16l35 35L144.6 333.4 93.8 320.7c-8.2-2-16.8 .4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-12.7-50.8L425.7 120.3l35 35c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zM132.2 379.8l9.2 36.8L117 441.1l-5.7-22.9c-2.1-8.6-8.9-15.3-17.5-17.5L70.9 395l24.4-24.4 36.8 9.2zm-79.5-265L49 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L151.4 281.4l33.9-33.9-98-98c61.2-37.6 138.2-39.2 200.8-4.9l35.1-35.1c-82.8-51.7-189.4-50-270.6 5.2zm314.7 109c34.3 62.6 32.7 139.6-4.9 200.8l-98-98-33.9 33.9L367 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-3.7-3.7c55.2-81.2 57-187.8 5.2-270.6l-35.1 35.1z"]
};
const faCartXmark = {
  prefix: 'far',
  iconName: 'cart-xmark',
  icon: [576, 512, [], "e0dd", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3L575.2 62.2c3.4-12.8-4.1-26-16.9-29.4s-26 4.1-29.4 16.9L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8l-297.6 0-37-194.5C119.5 19.1 96.4 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257.8 65.8c-9.4 9.4-9.4 24.6 0 33.9L286.1 128l-28.3 28.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L320 161.9l28.3 28.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L353.9 128l28.3-28.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L320 94.1 291.7 65.8c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faHexagonXmark = {
  prefix: 'far',
  iconName: 'hexagon-xmark',
  icon: [512, 512, ["times-hexagon", "xmark-hexagon"], "f2ee", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faTimesHexagon = faHexagonXmark;
const faXmarkHexagon = faHexagonXmark;
const faCircleH = {
  prefix: 'far',
  iconName: 'circle-h',
  icon: [512, 512, [9405, "hospital-symbol"], "f47e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80-128 0 0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80 128 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-104z"]
};
const faHospitalSymbol = faCircleH;
const faMerge = {
  prefix: 'far',
  iconName: 'merge',
  icon: [512, 512, [], "e526", "M0 88C0 74.7 10.7 64 24 64l72 0 48.2 0c17.5 0 34 8.2 44.5 22.1L297.5 228.8c1.5 2 3.9 3.2 6.4 3.2l126.2 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-126.2 0c-2.5 0-4.9 1.2-6.4 3.2L188.7 425.9c-10.6 13.9-27.1 22.1-44.5 22.1L96 448l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 48.2 0c2.5 0 4.9-1.2 6.4-3.2L257.8 256 150.5 115.2c-1.5-2-3.9-3.2-6.4-3.2L96 112l-72 0C10.7 112 0 101.3 0 88z"]
};
const faPager = {
  prefix: 'far',
  iconName: 'pager',
  icon: [512, 512, [128223], "f815", "M448 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM96 192l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32zm16 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"]
};
const faCartMinus = {
  prefix: 'far',
  iconName: 'cart-minus',
  icon: [576, 512, [], "e0db", "M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM256 96l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faAddressBook = {
  prefix: 'far',
  iconName: 'address-book',
  icon: [512, 512, [62138, "contact-book"], "f2b9", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"]
};
const faContactBook = faAddressBook;
const faPanFrying = {
  prefix: 'far',
  iconName: 'pan-frying',
  icon: [576, 512, [127859], "e42c", "M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM364.8 398.3C326.3 429.4 277.3 448 224 448C100.3 448 0 347.7 0 224S100.3 0 224 0S448 100.3 448 224c0 33.4-7.3 65.1-20.4 93.6l123.7 79.9C566.7 409.2 576 427.1 576 448c0 35.3-28.7 64-64 64c-15.2 0-28.3-4.6-39.3-13.5L364.8 398.3zM528 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM272 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faGrid = {
  prefix: 'far',
  iconName: 'grid',
  icon: [448, 512, ["grid-3"], "e195", "M88 72l0 48-48 0 0-48 48 0zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32zM88 232l0 48-48 0 0-48 48 0zM40 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zM0 392l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM248 72l0 48-48 0 0-48 48 0zM200 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM360 72l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z"]
};
const faGrid3 = faGrid;
const faFootballHelmet = {
  prefix: 'far',
  iconName: 'football-helmet',
  icon: [512, 512, [], "f44f", "M434.6 185.3L275.1 205.2c-38.3 4.8-67.1 37.4-67.1 76c0 11.9 2.8 23.6 8.1 34.3L254.3 392c1.1 2.2 1.7 4.7 1.7 7.2l0 .9c0 8.8-7.2 16-16 16l-2.9 0c-2.2 0-4.3-.4-6.3-1.3l-93.9-40.2c-10-4.3-20.7-6.5-31.5-6.5l-5.4 0c-22.7-31.5-36-70.1-36-112C64 150 150 64 256 64c81 0 150.4 50.2 178.6 121.3zm27.9 44.9c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16C123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1c5.7 7.1 14.4 10.9 23.5 10.9l14 0c4.3 0 8.6 .9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2l2.9 0c35.3 0 64-28.7 64-64l0-.9c0-9.9-2.3-19.7-6.8-28.6L288 352l39.7 0 9.6 50.9c10.1 54 57.2 93.1 112.1 93.1l17 0c25.2 0 45.6-20.4 45.6-45.6l0-50.4 0-32c0-26.5-21.5-48-48-48l-109.7 0-14-74.5 122.2-15.3zM321.7 320L272 320l-13-26c-2-4-3-8.4-3-12.8c0-14.4 10.7-26.6 25.1-28.4l27.4-3.4L321.7 320zm44.6 64l-6-32L464 352c8.8 0 16 7.2 16 16l0 16-113.7 0zM480 416l0 34.4c0 7.5-6.1 13.6-13.6 13.6l-17 0c-32.7 0-61.6-19.3-74.7-48L480 416zM176 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHandLove = {
  prefix: 'far',
  iconName: 'hand-love',
  icon: [512, 512, [], "e1a5", "M176 48c8.8 0 16 7.2 16 16l0 15.9 0 .1 0 127.8 0 .2 0 96c0 35.3 28.7 64 64 64c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64l0-48 0-16 0-24s0 0 0 0l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16l0 209.9c-.3 1.2-.5 2.5-.7 3.7c-6.6 66.5-61.1 118.9-128.5 122.2c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 64c0-8.8 7.2-16 16-16zM352 256l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16zm0-104l0 26c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2l0-82c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 197.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c87.6-5.9 158.3-72.9 169.9-158.8c1.1-2.7 1.7-5.7 1.7-8.8l0-216c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 23.9 0 .1zM240 216l0-8.2c.1-8.8 7.2-15.8 16-15.8c8.8 0 16 7.2 16 16l0 32 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88s0 0 0 0z"]
};
const faTrees = {
  prefix: 'far',
  iconName: 'trees',
  icon: [640, 512, [], "f724", "M177.4 15.1c16-19 45.2-19 61.2 0L354.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9l-14.1 0 64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6l-25.7 0 62.1 88 3.6 0 0-184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 113.7 0-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13l22.1 0-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6l12.4 0L432 53.3l-59.9 71.1L339.9 88.1l61.5-73c16-19 45.2-19 61.2 0L578.4 152.5c6 7.1 7.3 17.1 3.4 25.6s-12.4 13.9-21.8 13.9l-14.1 0 64.8 81c5.8 7.2 6.9 17.1 2.9 25.4s-12.4 13.6-21.6 13.6l-25.7 0 69.3 98.2c5.2 7.3 5.8 16.9 1.7 24.9s-12.3 13-21.3 13l-160 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-16 0-24 0-112 0-24 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0L24 448c-9 0-17.2-5-21.3-13s-3.5-17.6 1.7-24.9L73.7 312 48 312c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64.8-81L80 192c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L177.4 15.1zM256 400l89.7 0-69.3-98.2c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13l22.1 0-64.8-81c-5.8-7.2-6.9-17.1-2.9-25.4s12.4-13.6 21.6-13.6l12.4 0L208 53.3 131.6 144l12.4 0c9.2 0 17.6 5.3 21.6 13.6s2.9 18.2-2.9 25.4L97.9 264l22.1 0c9 0 17.2 5 21.3 13s3.5 17.6-1.7 24.9L70.3 400l73.7 0 40 0 0-184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184 24 0z"]
};
const faStrikethrough = {
  prefix: 'far',
  iconName: 'strikethrough',
  icon: [512, 512, [], "f0cc", "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7L24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192.2 0c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6c0 0 0 0 0 0s0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7l-57.2 0c5.7 5.3 9.7 11 12.3 17.1z"]
};
const faPage = {
  prefix: 'far',
  iconName: 'page',
  icon: [384, 512, [], "e428", "M64 464l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm256 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64z"]
};
const faK = {
  prefix: 'far',
  iconName: 'k',
  icon: [320, 512, [107], "4b", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 328 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-118.1 79.6-79.6L276.4 469.8c7.6 10.8 22.6 13.5 33.4 5.8s13.4-22.6 5.8-33.4L162.1 223.9 313 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 270.1 48 56z"]
};
const faDiagramPrevious = {
  prefix: 'far',
  iconName: 'diagram-previous',
  icon: [512, 512, [], "e478", "M464 416c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 64zm48-64c0-35.3-28.7-64-64-64l-168 0 0-86.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 0 86.1L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64zM64 224l74.3 0c-5.7-19.1-1-40.5 14.1-55.6l64-64c21.9-21.9 57.3-21.9 79.2 0l64 64c15 15 19.7 36.5 14.1 55.6l74.3 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64z"]
};
const faGaugeMin = {
  prefix: 'far',
  iconName: 'gauge-min',
  icon: [512, 512, ["tachometer-alt-slowest"], "f628", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56s-25.1-56-56-56c-10.3 0-19.9 2.8-28.2 7.6L117.6 228.2c-10.9-7.5-25.9-4.7-33.4 6.3s-4.7 25.9 6.3 33.4l110.2 75.4c-.4 2.9-.7 5.8-.7 8.8c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAltSlowest = faGaugeMin;
const faFolderGrid = {
  prefix: 'far',
  iconName: 'folder-grid',
  icon: [512, 512, [], "e188", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM104 240c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]
};
const faEggplant = {
  prefix: 'far',
  iconName: 'eggplant',
  icon: [512, 512, [], "e16c", "M505 7c9.4 9.4 9.4 24.6 0 33.9l-9 9L496 192c0 8.8-7.2 16-16 16c-26.5 0-48-21.5-48-48c0-5.8-4-10.7-9.4-12.7c-13.3-4.8-25.4-13-35.1-22.8c-9.7-9.8-17.9-21.9-22.8-35.2c-2-5.4-6.9-9.4-12.6-9.4c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l141.9 0 9-9c9.4-9.4 24.6-9.4 33.9 0zM169.9 139.3c40.3-19.6 81-39.3 113.4-66.6c8.4 14.1 20.9 25.5 36 32.3c-19.3 17.1-40.4 31-61.2 42.9c-21.5 12.3-47 24.8-70.4 36.2c0 0 0 0 0 0c-13.9 6.8-27 13.2-38 18.9c-33.6 17.6-59 34.3-76.1 54.5c-15.7 18.5-26.2 42-25.6 77.9c1 70 59 128.7 128.5 128.7c59 .1 115.4-40.1 163.9-107c33.3-46 59.2-99.9 76.2-148.5c10.2 13.3 24.4 23.3 40.8 28.2C410.6 362.7 311.1 512.2 176.4 512C79.9 511.9 1.4 431.3 0 336C-1.6 222.5 83.4 181.3 169.9 139.3z"]
};
const faExcavator = {
  prefix: 'far',
  iconName: 'excavator',
  icon: [640, 512, [], "e656", "M144 48l102.9 0c2.7 0 5.2 1.3 6.7 3.6L325.8 160 144 160l0-112zM384 224l0-16 0-25.5c0-14.2-4.2-28.1-12.1-39.9L293.5 24.9C283.1 9.4 265.6 0 246.9 0L136 0C113.9 0 96 17.9 96 40l0 120-48 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-48zm-48-16l0 16 0 48L48 272l0-64 288 0zM80 400l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L80 352c-44.2 0-80 35.8-80 80zm457.9 22.1c-6.4 6.4-9.9 15-9.9 24c0 18.7 15.2 33.9 33.9 33.9l78.1 0c44.2 0 80-35.8 80-80l0-48 0-48 0-16 0-176 0-97.4c0-2.7-.2-5.3-.7-7.8c-3.7-22-22.9-38.8-46-38.8c-11.2 0-22.1 4-30.5 11.4L416 138.7l0 63.5L592 49.7l0 30.6-31.6 27.7L416 234.2l0 63.8L544 186l48-42 0 63.8L592 320 457.9 454.1z"]
};
const faRam = {
  prefix: 'far',
  iconName: 'ram',
  icon: [640, 512, [128015], "f70a", "M336 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24.4c-6.8 6.1-12.8 13.2-17.6 21l-47.8 20.5c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2 0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-47.8-20.5c-4.9-7.8-10.8-14.9-17.6-21L544 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 1.3c-5.2-.9-10.5-1.3-16-1.3s-10.8 .5-16 1.3l0-1.3c0-35.3-28.7-64-64-64s-64 28.7-64 64zM306.5 88.7c-8-10.3-19-18-31.8-21.9C268.8 65 262.5 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L456 352c-14.2 0-27.7-2.8-40.1-8c-.9 0-1.7-.1-2.4-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.3 0 10 2.5 13 6.7c8.6 11.9 22 19.2 36.6 19.9c2.5-10 7.7-19.3 15.2-26.6c-6.5-6.4-11.5-14.3-14.3-23.3zM464 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faLandmarkFlag = {
  prefix: 'far',
  iconName: 'landmark-flag',
  icon: [512, 512, [], "e51c", "M272 0L256 0c-8.8 0-16 7.2-16 16l0 112L48 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0 0-32 80 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L272 0zM112 208l-48 0 0 176-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-176-48 0 0 176-64 0 0-176-48 0 0 176-64 0 0-176-48 0 0 176-64 0 0-176zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z"]
};
const faLips = {
  prefix: 'far',
  iconName: 'lips',
  icon: [576, 512, [128068, 128482], "f600", "M258.2 138.9c-22.5-17.8-42-26.9-58.2-26.9c-10.5 0-24.3 4.1-41.7 13.7c-17.2 9.5-34 22.1-50.5 34.9c-17.5 13.6-33.2 27.9-44.4 40.5c-6 6.8-10.3 12.2-13 17C48.3 222 48 223.8 48 224c0 .4 .1 1.7 .6 4.1s1.3 5.2 2.3 8.3c9.8 29.5 28.4 58.7 51.2 85.1C138.4 363.6 190.4 400 256 400l64 0c65.6 0 117.6-36.4 153.9-78.5c18.1-20.9 31.8-42.8 41-61.2c9.2-18.5 13-29.2 13.1-36.3c0-.2-.2-2-2.5-5.9c-2.7-4.8-6.9-10.2-13-17c-11.2-12.6-26.9-26.9-44.4-40.5c-16.5-12.8-33.3-25.4-50.5-34.9C400.3 116.1 386.5 112 376 112c-16.2 0-35.7 9.1-58.2 26.9c-17.5 13.8-42.1 13.8-59.5 0zm239.4-16.2c19.1 14.8 37.1 31.2 50.8 46.5c13.4 15 27.6 33.7 27.6 54.8c0 20-9.4 40.3-18.1 57.8c-10.8 21.7-26.8 46.9-47.7 71.1C468.8 400.9 404.7 448 320 448l-64 0c-84.7 0-148.8-47.1-190.2-95.1C40.3 323.4 17.7 288.8 5.3 251.5C2.6 243.1 0 233.2 0 224c0-21.1 14.2-39.7 27.6-54.8c13.6-15.3 31.7-31.7 50.8-46.5C111.5 97 156 64 200 64c32.7 0 63 17.5 88 37.3C313 81.5 343.3 64 376 64c44 0 88.5 33 121.6 58.7zM96 236c0-6.7 39.4-27.1 118.1-28c3.5 0 7 .5 10.3 1.6c11.8 3.7 42 12.4 63.6 12.4s51.7-8.7 63.6-12.4c3.3-1 6.8-1.6 10.3-1.6c78.7 .9 118.1 21.2 118.1 28c0 6.9-68.6 84-192 84s-192-77.1-192-84z"]
};
const faPencil = {
  prefix: 'far',
  iconName: 'pencil',
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
};
const faPencilAlt = faPencil;
const faBackward = {
  prefix: 'far',
  iconName: 'backward',
  icon: [512, 512, [9194], "f04a", "M288 94c0-16.6-13.5-30-30-30c-6.3 0-12.5 2-17.6 5.7L9.9 236.6C3.7 241.1 0 248.3 0 256s3.7 14.9 9.9 19.4L240.3 442.3c5.1 3.7 11.3 5.7 17.6 5.7c16.6 0 30-13.4 30-30l0-99.1L464.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1l0-323.8C512 77.5 498.5 64 481.9 64c-6.2 0-12.2 1.9-17.3 5.4L288 193.1 288 94zm0 157.7L464 128.5l0 255L288 260.3l0-8.6zM64.9 256L240 129.2l0 253.6L64.9 256z"]
};
const faCaretRight = {
  prefix: 'far',
  iconName: 'caret-right',
  icon: [256, 512, [], "f0da", "M201.4 256L112 166.6l0 178.7L201.4 256zm45.3-22.6c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-256c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128z"]
};
const faComments = {
  prefix: 'far',
  iconName: 'comments',
  icon: [640, 512, [128490, 61670], "f086", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"]
};
const faPaste = {
  prefix: 'far',
  iconName: 'paste',
  icon: [512, 512, ["file-clipboard"], "f0ea", "M104.6 48L64 48C28.7 48 0 76.7 0 112L0 384c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-272c0-8.8 7.2-16 16-16l16 0c0 17.7 14.3 32 32 32l72.4 0C202 108.4 227.6 96 256 96l62 0c-7.1-27.6-32.2-48-62-48l-40.6 0C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48zM144 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM448 464l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L464 243.9 464 448c0 8.8-7.2 16-16 16zM256 512l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L256 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64z"]
};
const faFileClipboard = faPaste;
const faDesktopArrowDown = {
  prefix: 'far',
  iconName: 'desktop-arrow-down',
  icon: [576, 512, [], "e155", "M64 0L224 0l0 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16L352 48l0-48L512 0c35.3 0 64 28.7 64 64l0 192 0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48zM312 24l0 118.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faCodePullRequest = {
  prefix: 'far',
  iconName: 'code-pull-request',
  icon: [512, 512, [], "e13c", "M305.8 2.1C314.4 5.9 320 14.5 320 24l0 48 16 0c66.3 0 120 53.7 120 120l0 163.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L408 192c0-39.8-32.2-72-72-72l-16 0 0 48c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM112 80A32 32 0 1 0 48 80a32 32 0 1 0 64 0zm-8 76.3l0 199.3c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-199.3C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3zM112 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faPumpkin = {
  prefix: 'far',
  iconName: 'pumpkin',
  icon: [576, 512, [], "f707", "M352 118.1l0-82.7c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4L229.4 115.7c-27.3 11.4-50.6 30.6-67 54.7c-7.5 11-4.6 25.9 6.3 33.3s25.9 4.6 33.3-6.3C220.8 170 252.3 152 288 152s67.2 18 86 45.5c7.5 11 22.4 13.8 33.3 6.3s13.8-22.4 6.3-33.3c-15.4-22.5-36.7-40.7-61.7-52.4zM141.3 144.9c12.8-16.9 28.5-31.5 46.4-43.2C176.4 98 164.4 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-12.4 0-24.4 2-35.8 5.7c17.9 11.6 33.6 26.3 46.4 43.2c21.7 3.5 42.9 17.9 60.1 42.7c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4c17.3-24.8 38.5-39.2 60.2-42.7z"]
};
const faClipboardList = {
  prefix: 'far',
  iconName: 'clipboard-list',
  icon: [384, 512, [], "f46d", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faPenField = {
  prefix: 'far',
  iconName: 'pen-field',
  icon: [640, 512, [], "e211", "M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l432 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 128zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faChartSine = {
  prefix: 'far',
  iconName: 'chart-sine',
  icon: [512, 512, [], "e69d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM154.6 215.4c2.2-8 5.7-18.5 10.8-28.7C176.3 165 190.2 152 208 152c15.4 0 24.8 6.4 33.2 19.2c9.6 14.6 16.1 35 23.8 59.9l.5 1.8c7 22.7 15.3 49.5 29.1 70.3C310 326.4 333.1 344 368 344c46.2 0 72.3-35 85.5-61.3c6.9-13.8 11.4-27.4 14.2-37.3c3.3-12 4-17.4 4-17.4c0 0 0 0 0 0c2.2-13.1-6.7-25.4-19.7-27.6c-21.4-3.6-26.8 16.2-30.6 32.2c-2.2 8-5.7 18.5-10.8 28.7C399.7 283 385.8 296 368 296c-15.4 0-24.8-6.4-33.2-19.2c-9.6-14.6-16.1-35-23.8-59.9l-.5-1.8c-7-22.7-15.3-49.5-29.1-70.3C266.1 121.6 242.9 104 208 104c-46.2 0-72.3 35-85.5 61.3c-6.9 13.8-11.4 27.4-14.2 37.3c-4.8 17.4-4 17.5-4 17.5c-2.2 13.1 6.7 25.4 19.7 27.6s25.4-6.6 27.6-19.7c0 0 .3-3 3-12.5z"]
};
const faBlueberries = {
  prefix: 'far',
  iconName: 'blueberries',
  icon: [512, 512, [], "e2e8", "M512 176C512 78.8 433.2 0 336 0C255.4 0 187.4 54.2 166.6 128.2c3.1-.1 6.3-.2 9.4-.2c114.9 0 208 93.1 208 208c0 3.2-.1 6.3-.2 9.4C457.8 324.6 512 256.6 512 176zM384 64l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-32z"]
};
const faTruckRampBox = {
  prefix: 'far',
  iconName: 'truck-ramp-box',
  icon: [640, 512, ["truck-loading"], "f4de", "M352 88c0-48.6 39.4-88 88-88L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 48c-22.1 0-40 17.9-40 40l0 272.7 25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8 352 88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"]
};
const faTruckLoading = faTruckRampBox;
const faNote = {
  prefix: 'far',
  iconName: 'note',
  icon: [448, 512, [], "e1ff", "M384 80c8.8 0 16 7.2 16 16l0 224-80 0c-17.7 0-32 14.3-32 32l0 80L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 480l224 0 5.5 0c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3l0-5.5 0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64zm64-120a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 128a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faArrowDownToSquare = {
  prefix: 'far',
  iconName: 'arrow-down-to-square',
  icon: [512, 512, [], "e096", "M385 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-71 71L280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1-71-71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 345c9.4 9.4 24.6 9.4 33.9 0L385 233zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-336c0-39.8-32.2-72-72-72l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faUserCheck = {
  prefix: 'far',
  iconName: 'user-check',
  icon: [640, 512, [], "f4fc", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM625 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 177z"]
};
const faCloudXmark = {
  prefix: 'far',
  iconName: 'cloud-xmark',
  icon: [640, 512, [], "e35f", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM239 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faVialVirus = {
  prefix: 'far',
  iconName: 'vial-virus',
  icon: [512, 512, [], "e597", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 304c0 53 43 96 96 96c28 0 53.3-12 70.8-31.2c-.2-14.6 5.2-29.3 16.4-40.5c.2-.2 .2-.3 .3-.3c0 0 0 0 0 0c0-.1 0-.3-.1-.6s-.2-.4-.3-.5c0 0 0 0-.1 0c-.1 0-.2 0-.4 0c-15.2 0-29-6.1-39.1-15.9c-3.4 23.2-23.4 41-47.5 41c-26.5 0-48-21.5-48-48l0-144 96 0 0 70.3c10-9.6 23.6-15.4 38.6-15.4c.2 0 .4 0 .4 0c0 0 0 0 .1 0c.1-.1 .2-.2 .3-.5s.1-.5 .1-.6c0 0 0 0 0 0c0-.1-.1-.2-.3-.3c-21.9-21.9-21.9-57.3 0-79.2c2.7-2.7 5.7-5.1 8.8-7.2L224 80l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 32 32 32l-8 0zM80 192L80 80l96 0 0 112-96 0zm271.8-2.3c-13.3 0-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1c13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2c0-13.3-10.7-24-24-24zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faBookBlank = {
  prefix: 'far',
  iconName: 'book-blank',
  icon: [448, 512, [128213, 128215, 128216, 128217, "book-alt"], "f5d9", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8L80 352z"]
};
const faBookAlt = faBookBlank;
const faGolfFlagHole = {
  prefix: 'far',
  iconName: 'golf-flag-hole',
  icon: [512, 512, [], "e3ac", "M162.7 2.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 15.7 128 24l0 136 0 64 0 8 0 55.1 0 49.8 0 47.1c0 .7 0 1.5 .1 2.2c-.1 .6-.1 1.2-.1 1.8c0 19.9 35.8 36 80 36s80-16.1 80-36s-35.8-36-80-36c-11.4 0-22.2 1.1-32 3l0-28.8c24.6-3.9 51.5-6.2 80-6.2c61.7 0 116.4 10.4 154.9 26.3c19.3 8 33.3 16.9 42.1 25.5c8.7 8.6 11 15.4 11 20.2s-2.3 11.7-11 20.2c-8.8 8.6-22.8 17.5-42.1 25.5C372.4 453.6 317.7 464 256 464s-116.4-10.4-154.9-26.3c-19.3-8-33.3-16.9-42.1-25.5c-8.7-8.6-11-15.4-11-20.2s2.3-11.7 11-20.2c8-7.9 20.3-15.9 37-23.3l0-51.6c-4.5 1.6-9 3.3-13.2 5.1c-22.7 9.4-42.7 21.2-57.3 35.5C10.7 351.9 0 370.3 0 392s10.7 40.1 25.4 54.5c14.7 14.3 34.6 26.1 57.3 35.5C128.3 500.9 189.6 512 256 512s127.7-11.1 173.2-29.9c22.7-9.4 42.7-21.2 57.3-35.5C501.3 432.1 512 413.7 512 392s-10.7-40.1-25.4-54.5c-14.6-14.3-34.6-26.1-57.3-35.5C383.7 283.1 322.4 272 256 272c-27.8 0-54.8 1.9-80 5.6l0-30.8 194.7-97.4c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-208-104zM176 193.2l0-130.3L306.3 128 176 193.2z"]
};
const faMessageArrowDown = {
  prefix: 'far',
  iconName: 'message-arrow-down',
  icon: [512, 512, ["comment-alt-arrow-down"], "e1db", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 120z"]
};
const faCommentAltArrowDown = faMessageArrowDown;
const faFaceUnamused = {
  prefix: 'far',
  iconName: 'face-unamused',
  icon: [512, 512, [], "e39f", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 392.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 344.3 221.4 328 256 328s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z"]
};
const faSheetPlastic = {
  prefix: 'far',
  iconName: 'sheet-plastic',
  icon: [384, 512, [], "e571", "M320 48c8.8 0 16 7.2 16 16l0 288-80 0c-17.7 0-32 14.3-32 32l0 80L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM0 448c0 35.3 28.7 64 64 64l172.1 0c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zM203.3 84.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"]
};
const faCircle9 = {
  prefix: 'far',
  iconName: 'circle-9',
  icon: [512, 512, [], "e0f6", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-80a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM230 316.4c-40.4-11.4-70-48.4-70-92.4c0-53 43-96 96-96s96 43 96 96c0 32.4-14.2 63.2-38.8 84.3l-81.6 70c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8L230 316.4z"]
};
const faBlog = {
  prefix: 'far',
  iconName: 'blog',
  icon: [512, 512, [], "f781", "M216 0C379.5 0 512 132.5 512 296c0 13.3-10.7 24-24 24s-24-10.7-24-24C464 159 353 48 216 48c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24l0 248c0 53 43 96 96 96s96-43 96-96s-43-96-96-96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368L0 120c0-13.3 10.7-24 24-24zm168 24c0-13.3 10.7-24 24-24c110.5 0 200 89.5 200 200c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-83.9-68.1-152-152-152c-13.3 0-24-10.7-24-24z"]
};
const faUserNinja = {
  prefix: 'far',
  iconName: 'user-ninja',
  icon: [448, 512, [129399], "f504", "M352 128c0 70.7-57.3 128-128 128c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128zM144 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96c-8.8 0-16 7.2-16 16zM49.3 464l163.1 0-6.5-7.7c-.2-.2-.4-.4-.6-.7l-78.4-93.1C85.9 380.1 55.7 418.3 49.3 464zm206.1-23.5L275.2 464l123.6 0c-6.4-45.7-36.6-83.9-77.7-101.5l-65.7 78zM418.3 512l-154.1 0-.3 0L29.7 512C13.3 512 0 498.7 0 482.3c0-83.7 57.6-153.9 135.4-173.1c5.6-1.4 11.4 .7 15.1 5.1l61.3 71.6c6.4 7.4 17.9 7.4 24.3 0l61.3-71.6c3.7-4.4 9.5-6.4 15.1-5.1C390.4 328.4 448 398.6 448 482.3c0 16.4-13.3 29.7-29.7 29.7z"]
};
const faPencilSlash = {
  prefix: 'far',
  iconName: 'pencil-slash',
  icon: [640, 512, [], "e215", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.3 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zm.9 123.2l-41.7 41.7-49.6-12.4-12.4-49.6 34.4-34.4-38-29.9-73.2 73.2c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6-38-29.9zM161 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1l11.1-7.4z"]
};
const faBowlingPins = {
  prefix: 'far',
  iconName: 'bowling-pins',
  icon: [512, 512, [], "f437", "M128 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM102.3 230.2L74 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L95.5 464l65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM48 80C48 35.8 83.8 0 128 0s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L227 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L200 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.5 0-23.9-7.3-29.1-18.8L34.4 445.6C22.3 419 16 390.1 16 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5l0-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7L48 80zM384 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM358.3 230.2L330 305.7c-6.6 17.6-10 36.3-10 55.1c0 22.4 4.8 44.5 14.1 64.9L351.5 464l65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM304 80c0-44.2 35.8-80 80-80s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L483 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L456 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.6 0-23.9-7.3-29.1-18.8l-21.7-47.6C278.3 419 272 390.1 272 360.8c0-24.6 4.4-48.9 13-72l28.3-75.5c4.4-11.7 6.6-24 6.6-36.5l0-1c0-8.5-1-17-3.1-25.2l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7l0-4.4z"]
};
const faPersonArrowUpFromLine = {
  prefix: 'far',
  iconName: 'person-arrow-up-from-line',
  icon: [640, 512, [], "e539", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L208 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 464l0-112 32 0 0 112-32 0zm-48 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 80 0 384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-360 0 0-240.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 464zM600.1 118.2l-88-80c-9.2-8.3-23.1-8.3-32.3 0l-88 80c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6L472 110.3 472 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-281.7 47.9 43.5c9.8 8.9 25 8.2 33.9-1.6s8.2-25-1.6-33.9z"]
};
const faDownRight = {
  prefix: 'far',
  iconName: 'down-right',
  icon: [384, 512, [], "e16b", "M320 384l0-193.4c0-1.7-.8-3.2-2.1-4.2c-2.1-1.6-5-1.4-6.9 .5L257 241c-9.4 9.4-24.6 9.4-33.9 0L98.3 116.3c-2.7-2.7-6.5-4.3-10.3-4.3s-7.6 1.5-10.3 4.3L52.3 141.7c-2.7 2.7-4.3 6.5-4.3 10.3s1.5 7.6 4.3 10.3L177 287c9.4 9.4 9.4 24.6 0 33.9L122.9 375c-1.8 1.8-2.1 4.8-.5 6.9c1 1.3 2.5 2.1 4.2 2.1L320 384zm48 8c0 22.1-17.9 40-40 40l-201.4 0c-16.8 0-32.5-7.9-42.6-21.3c-15.9-21.2-13.8-50.9 4.9-69.6L126.1 304 18.3 196.3C6.6 184.5 0 168.6 0 152s6.6-32.5 18.3-44.3L43.7 82.4C55.5 70.6 71.4 64 88 64s32.5 6.6 44.3 18.3L240 190.1 277.1 153c18.7-18.7 48.4-20.8 69.6-5c13.4 10.1 21.3 25.8 21.3 42.6L368 392z"]
};
const faScrollTorah = {
  prefix: 'far',
  iconName: 'scroll-torah',
  icon: [640, 512, ["torah"], "f6a0", "M80 48C62.3 48 48 62.3 48 80l0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 0-320 0-16c0-17.7-14.3-32-32-32zm73.3 416C141 492.3 112.8 512 80 512c-44.2 0-80-35.8-80-80L0 80C0 35.8 35.8 0 80 0c32.8 0 61 19.7 73.3 48l6.7 0 320 0 6.7 0C499 19.7 527.2 0 560 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80c-32.8 0-61-19.7-73.3-48l-6.7 0-320 0-6.7 0zm6.7-48l320 0 0-320L160 96l0 320zm368 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 0 320 0 16zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3l56.7 0 31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180l56.7 0c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3L369 332l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332l-56.7 0c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332l-42.4 0L320 368.4zM254.5 256l30.3 52 70.4 0 30.3-52-30.3-52-70.4 0-30.3 52zm144.9 23.8L383 308l32.8 0-16.4-28.2zM415.8 204L383 204l16.4 28.2L415.8 204zM320 143.6L298.8 180l42.4 0L320 143.6zM224.2 204l16.4 28.2L257 204l-32.8 0zM257 308l-16.4-28.2L224.2 308l32.8 0z"]
};
const faTorah = faScrollTorah;
const faWebhook = {
  prefix: 'far',
  iconName: 'webhook',
  icon: [576, 512, [], "e5d5", "M306 50.1c41.1 9.5 67.5 49.2 61.1 90.2c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20C424.8 82 382.6 18.5 316.8 3.3c-68.9-15.9-137.6 27-153.5 95.9c-10.7 46.3 5.2 92.6 37.7 122.7L129.7 336c-.6 0-1.1 0-1.7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l82.8-132.5c3.4-5.4 4.5-11.9 3-18.1s-5.3-11.6-10.7-15c-28.2-17.6-43.4-51.7-35.5-85.9C220 67 262.9 40.1 306 50.1zM288 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm42.4 38.5c3.6-6.7 5.6-14.4 5.6-22.5c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c.6 0 1.1 0 1.7 0l82.8 132.5c3.4 5.4 8.8 9.2 15 10.7s12.7 .3 18.1-3c30.9-19.3 72.1-15.5 99 11.3c31.2 31.2 31.2 81.9 0 113.1c-26.8 26.8-68.1 30.6-99 11.3c-11.2-7-26-3.6-33.1 7.6s-3.6 26 7.6 33.1c49.4 31 115.4 25 158.4-18c50-50 50-131 0-181c-37-37-91-46.6-136.8-28.9L330.4 150.5zM112 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm320 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0c0-26.5-21.5-48-48-48c-17.8 0-33.3 9.7-41.6 24L232 360c-6.4 0-12.5 2.5-17 7s-7 10.6-7 17c0 36.4-25 69.4-62 77.9c-43.1 9.9-86-16.9-95.9-60c-8.9-38.6 11.7-77.1 47.1-91.8c12.2-5.1 18-19.1 12.9-31.4s-19.1-18-31.4-12.9C22.1 289.4-11 351 3.3 412.8c15.9 68.9 84.6 111.8 153.5 95.9c51-11.8 87.7-52.5 97-100.7l152.7 0c8.3 14.3 23.8 24 41.6 24c26.5 0 48-21.5 48-48z"]
};
const faBlindsOpen = {
  prefix: 'far',
  iconName: 'blinds-open',
  icon: [512, 512, [], "f8fc", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l120 0 0 112 0 48 0 36.1C116 254 96 280.7 96 312c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.3-20-58-48-67.9l0-36.1 0-48 0-112 296 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM144 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM64.3 320L24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l56.3 0c-9-14.1-14.7-30.4-16-48zm191.3 48L488 368c13.3 0 24-10.7 24-24s-10.7-24-24-24l-216.3 0c-1.3 17.6-7 33.9-16 48zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0-48-88 0zm200 48l264 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-264 0 0 48z"]
};
const faFence = {
  prefix: 'far',
  iconName: 'fence',
  icon: [512, 512, [], "e303", "M64 32c7.8 0 15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 48 64 0 0-48c0-5 1.6-9.9 4.5-13.9l40-56C241 35.7 248.2 32 256 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 48 64 0 0-48c0-5 1.6-9.9 4.5-13.9l40-56C433 35.7 440.2 32 448 32s15 3.7 19.5 10.1l40 56c2.9 4.1 4.5 8.9 4.5 13.9l0 336c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-48-64 0 0 48c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-48-64 0 0 48c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32L0 112c0-5 1.6-9.9 4.5-13.9l40-56C49 35.7 56.2 32 64 32zM320 352l64 0 0-144-64 0 0 144zM192 208l-64 0 0 144 64 0 0-144zM48 119.7L48 432l32 0 0-312.3L64 97.3 48 119.7zm192 0L240 432l32 0 0-312.3L256 97.3l-16 22.4zM432 432l32 0 0-312.3L448 97.3l-16 22.4L432 432z"]
};
const faUp = {
  prefix: 'far',
  iconName: 'up',
  icon: [384, 512, ["arrow-alt-up"], "f357", "M192 82.4L334.7 232.3c.8 .8 1.3 2 1.3 3.2c0 2.5-2 4.6-4.6 4.6L248 240c-13.3 0-24 10.7-24 24l0 168-64 0 0-168c0-13.3-10.7-24-24-24l-83.4 0c-2.5 0-4.6-2-4.6-4.6c0-1.2 .5-2.3 1.3-3.2L192 82.4zm192 153c0-13.5-5.2-26.5-14.5-36.3L222.9 45.2C214.8 36.8 203.7 32 192 32s-22.8 4.8-30.9 13.2L14.5 199.2C5.2 208.9 0 221.9 0 235.4c0 29 23.5 52.6 52.6 52.6l59.4 0 0 144c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-144 59.4 0c29 0 52.6-23.5 52.6-52.6z"]
};
const faArrowAltUp = faUp;
const faBroomBall = {
  prefix: 'far',
  iconName: 'broom-ball',
  icon: [576, 512, ["quidditch", "quidditch-broom-ball"], "f458", "M569 7c9.4 9.4 9.4 24.6 0 33.9L369 241l39 39c5.1 5.1 8 12.1 8 19.4c0 12.2-8.1 23-19.9 26.3l-55.6 15.9 .1 .6c7.1 46.4-8.3 93.4-41.5 126.7C271.5 496.5 234 512 194.9 512L22.3 512C10 512 0 502 0 489.7c0-6.2 2.6-12.1 7.2-16.4l49.9-46.1 24.3-22.4L104 384l-22.7 0c-9.6 0-17.3-7.8-17.3-17.3c0-3.9 .2-7.8 .6-11.6c2.7-25.6 14-49.7 32.4-68l10.2-10.2c33.2-33.2 80.2-48.6 126.7-41.5l.6 .1 15.9-55.6c3.4-11.8 14.1-19.9 26.3-19.9c7.3 0 14.2 2.9 19.4 8l39 39L535 7c9.4-9.4 24.6-9.4 33.9 0zM321.2 297.2l28.1-8-62.4-62.4-8 28.1 42.3 42.3zm-84.9-12.9l-9.8-1.5c-31.3-4.8-63 5.6-85.4 28l-10.2 10.2c-5.1 5.1-9.3 11-12.4 17.3c13.5 4.3 24.8 14.5 30.1 28.3c7.2 18.4 2.4 39.3-12.1 52.7L88.1 464l106.8 0c26.4 0 51.7-10.5 70.3-29.1c22.4-22.4 32.8-54.1 28-85.4l-1.5-9.8-55.4-55.4zM528 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
const faQuidditch = faBroomBall;
const faQuidditchBroomBall = faBroomBall;
const faDrumstick = {
  prefix: 'far',
  iconName: 'drumstick',
  icon: [512, 512, [127831], "f6d6", "M240 304c-17.7 0-32-14.3-32-32l0-96c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128l-96 0zm-37.5 78c10.2-14.4 23.9-30 41.5-30l92 0c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176l0 92c0 17.7-15.6 31.3-30 41.5c-2.4 1.7-4.6 3.6-6.8 5.7c-12 12-31.5 11.1-47.9 6.8c-4.9-1.3-10-2-15.4-2c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5.3-.7-10.5-2-15.4c-4.3-16.4-5.2-35.9 6.8-47.9c2.1-2.1 4-4.4 5.7-6.7z"]
};
const faSquareV = {
  prefix: 'far',
  iconName: 'square-v',
  icon: [448, 512, [], "e284", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm141.5 53.3L224 314.3l82.5-165.1c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2l-104 208c-4.1 8.1-12.4 13.3-21.5 13.3s-17.4-5.1-21.5-13.3l-104-208c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7z"]
};
const faFaceAwesome = {
  prefix: 'far',
  iconName: 'face-awesome',
  icon: [512, 512, ["gave-dandy"], "e409", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-32l0-24c0-2-.1-3.9-.4-5.8c-4.2 3.6-9.6 5.8-15.6 5.8c-13.3 0-24-10.7-24-24c0-6 2.2-11.4 5.8-15.6c-1.9-.3-3.8-.4-5.8-.4c-22.1 0-40 17.9-40 40l0 24 80 0zm-40-96c39.8 0 72 32.2 72 72l0 24c0 17.7-14.3 32-32 32l-80 0c-17.7 0-32-14.3-32-32l0-24c0-39.8 32.2-72 72-72zm216 72c-13.3 0-24-10.7-24-24c0-5.4 1.8-10.3 4.7-14.3c-4.1-1.1-8.3-1.7-12.7-1.7c-26.5 0-48 21.5-48 48l0 16 96 0 0-16c0-4.4-.6-8.7-1.7-12.7c-4 3-8.9 4.7-14.3 4.7zm-32-72c44.2 0 80 35.8 80 80l0 17.9c0 16.6-13.5 30.1-30.1 30.1l-99.8 0c-16.6 0-30.1-13.5-30.1-30.1l0-17.9c0-44.2 35.8-80 80-80zM100.4 307.8c-2.3-10.2 5.5-19.8 15.9-19.8c0 0 0 0 0 0l279.4 0s0 0 0 0c10.4 0 18.1 9.6 15.9 19.8c-3.9 17.4-10.6 33.6-19.5 48.2c0 0 0 0 0 0c-28.2 45.9-78.9 75.6-134.9 76l-1.1 0c-4.6 0-9.3-.2-13.8-.6c-68.5-5.9-126.7-55.6-141.8-123.6zm263.8 32.4c-8.2-2.7-16.9-4.2-25.9-4.2c-39.2 0-71.9 27.3-80.2 64c44.1-.7 83.8-24.1 106.2-59.8z"]
};
const faGaveDandy = faFaceAwesome;
const faDialOff = {
  prefix: 'far',
  iconName: 'dial-off',
  icon: [576, 512, [], "e162", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM264 288l0 109.4c-50.3-11-88-55.8-88-109.4c0-61.9 50.1-112 112-112s112 50.1 112 112c0 53.6-37.7 98.4-88 109.4L312 288c0-13.3-10.7-24-24-24s-24 10.7-24 24zm24 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faToggleOff = {
  prefix: 'far',
  iconName: 'toggle-off',
  icon: [576, 512, [], "f204", "M384 112c79.5 0 144 64.5 144 144s-64.5 144-144 144l-192 0c-79.5 0-144-64.5-144-144s64.5-144 144-144l192 0zM576 256c0-106-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192zm-336 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 256a96 96 0 1 0 192 0A96 96 0 1 0 96 256z"]
};
const faFaceSmileHorns = {
  prefix: 'far',
  iconName: 'face-smile-horns',
  icon: [640, 512, [], "e391", "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zM207.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 350.5 357.2 368 320 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
const faBoxArchive = {
  prefix: 'far',
  iconName: 'box-archive',
  icon: [512, 512, ["archive"], "f187", "M48 80l0 48 416 0 0-48L48 80zM32 32l448 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM32 416l0-208 48 0 0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208 48 0 0 208c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64z"]
};
const faArchive = faBoxArchive;
const faGrapes = {
  prefix: 'far',
  iconName: 'grapes',
  icon: [512, 512, [], "e306", "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM408 264c0-44.2-35.8-80-80-80c0-44.2-35.8-80-80-80c-28 0-52.6 14.4-66.9 36.1C167 127.6 148.4 120 128 120c-44.2 0-80 35.8-80 80c0 18 6 34.6 16 48c-19.4 14.6-32 37.8-32 64c0 17.6 5.7 33.8 15.2 47C19.4 371.5 0 399.5 0 432c0 44.2 35.8 80 80 80c32.5 0 60.5-19.4 73-47.2c13.2 9.6 29.4 15.2 47 15.2c26.2 0 49.4-12.6 64-32c13.4 10 30 16 48 16c44.2 0 80-35.8 80-80c0-20.4-7.6-39-20.1-53.1C393.6 316.6 408 292 408 264zM248 144a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM72 312a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm8 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm80 8a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm152-56a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM184 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm144-64a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faPersonDrowning = {
  prefix: 'far',
  iconName: 'person-drowning',
  icon: [576, 512, [], "e545", "M152 32c13.3 0 24 10.7 24 24l0 36.6c0 58 37.9 109.1 93.4 126c43.9 13.4 90.7 14.3 135.1 2.7l109.5-28.6c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3L416.5 267.8c-14.3 3.7-28.9 6.4-43.5 7.9L355.7 379.6c-10.6-3.5-21.2-8.8-30.9-15.5c-4.4-3.1-9.1-5.6-14-7.4l13.3-79.8c-23.2-1.4-46.3-5.5-68.8-12.3c-4.6-1.4-9-2.9-13.4-4.7L220.6 379.6c-9.2 3.1-18.9 4.9-28.6 4.9c-6.6 0-13.5-.9-20.6-2.7l26.3-147c-43-33.3-69.7-85.3-69.7-142.1L128 56c0-13.3 10.7-24 24-24zm112 96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faDialMax = {
  prefix: 'far',
  iconName: 'dial-max',
  icon: [576, 512, [], "e15e", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 305l77.4 77.4c-43.4 27.8-101.7 22.8-139.6-15.1c-43.7-43.7-43.7-114.7 0-158.4s114.7-43.7 158.4 0c37.9 37.9 43 96.2 15.1 139.6L305 271c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm130.1 96.2A160 160 0 1 0 174.9 174.9 160 160 0 1 0 401.1 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCircleM = {
  prefix: 'far',
  iconName: 'circle-m',
  icon: [512, 512, [], "e115", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM171.5 137.9c-6.1-8.4-16.9-12-26.8-8.8s-16.6 12.4-16.6 22.8l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-133.8 60.5 83.8c4.5 6.2 11.7 9.9 19.5 9.9s14.9-3.7 19.5-9.9L336 226.2 336 360c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.8L256 255 171.5 137.9z"]
};
const faCalendarImage = {
  prefix: 'far',
  iconName: 'calendar-image',
  icon: [448, 512, [], "e0d4", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm99.2 136.7L99.8 390.2c-8.1 10.5-.6 25.8 12.7 25.8l226.4 0c12.6 0 20.3-13.9 13.5-24.6L268.9 260.3c-6.1-9.7-20.1-9.9-26.7-.5L184 344l-11.4-15.1c-6.4-8.5-19-8.5-25.5-.2zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCircleCaretDown = {
  prefix: 'far',
  iconName: 'circle-caret-down',
  icon: [512, 512, ["caret-circle-down"], "f32d", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm0 368c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-208 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z"]
};
const faCaretCircleDown = faCircleCaretDown;
const faArrowDown91 = {
  prefix: 'far',
  iconName: 'arrow-down-9-1',
  icon: [576, 512, ["sort-numeric-desc", "sort-numeric-down-alt"], "f886", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm409-65c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16c-12.6 4.2-19.4 17.8-15.2 30.4s17.8 19.4 30.4 15.2l16.4-5.5 0 86.7-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-120zM424 160a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm88-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.1 29.6 77.3 69.1 86l-15.6 18.7c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1l64.6-77.6c13-15.6 20.3-35.1 20.9-55.3c0-.8 0-1.6 0-2.5z"]
};
const faSortNumericDesc = faArrowDown91;
const faSortNumericDownAlt = faArrowDown91;
const faFaceGrinTongueSquint = {
  prefix: 'far',
  iconName: 'face-grin-tongue-squint',
  icon: [512, 512, [128541, "grin-tongue-squint"], "f58a", "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-23.3c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6l0 22.9c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faGrinTongueSquint = faFaceGrinTongueSquint;
const faShishKebab = {
  prefix: 'far',
  iconName: 'shish-kebab',
  icon: [512, 512, [], "f821", "M416 48c-26.5 0-48 21.5-48 48c0 5.7 1 11.1 2.7 16.1c6.8 19.2 11.3 51.8-11.3 74.5L337 209l24.4 24.4C375.9 247.9 384 267.5 384 288s-8.1 40.1-22.6 54.6l-18.7 18.7C328.1 375.9 308.5 384 288 384c0 20.5-8.1 40.1-22.6 54.6l-18.7 18.7C232.1 471.9 212.5 480 192 480s-40.1-8.1-54.6-22.6L113 433 41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72L54.6 374.6C40.1 360.1 32 340.5 32 320s8.1-40.1 22.6-54.6l18.7-18.7C87.9 232.1 107.5 224 128 224c0-20.5 8.1-40.1 22.6-54.6l18.7-18.7C183.9 136.1 203.5 128 224 128s40.1 8.1 54.6 22.6L303 175l22.5-22.5c1.1-1.1 2.5-3.3 2.8-7.8c.3-4.7-.6-10.6-2.7-16.6C321.9 118 320 107.2 320 96c0-53 43-96 96-96s96 43 96 96c0 19.7-6 38.1-16.2 53.4c-7.4 11-22.3 14-33.3 6.6s-14-22.3-6.6-33.3c5.1-7.6 8.1-16.8 8.1-26.7c0-26.5-21.5-48-48-48zM88.6 340.7l82.7 82.7c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6L88.6 299.3C83.1 304.8 80 312.2 80 320s3.1 15.2 8.6 20.7zm178.7-13.3c5.5 5.5 12.9 8.6 20.7 8.6s15.2-3.1 20.7-8.6l18.7-18.7c5.5-5.5 8.6-12.9 8.6-20.7s-3.1-15.2-8.6-20.7l-82.7-82.7c-5.5-5.5-12.9-8.6-20.7-8.6s-15.2 3.1-20.7 8.6l-18.7 18.7c-5.5 5.5-8.6 12.9-8.6 20.7s3.1 15.2 8.6 20.7l82.7 82.7z"]
};
const faSprayCan = {
  prefix: 'far',
  iconName: 'spray-can',
  icon: [512, 512, [], "f5bd", "M128 0C110.3 0 96 14.3 96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0zm96 208c26.5 0 48 21.5 48 48l0 184c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-184c0-26.5 21.5-48 48-48l128 0zM96 160c-53 0-96 43-96 96L0 440c0 39.8 32.2 72 72 72l176 0c39.8 0 72-32.2 72-72l0-184c0-53-43-96-96-96L96 160zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0zM320 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM512 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faAlarmSnooze = {
  prefix: 'far',
  iconName: 'alarm-snooze',
  icon: [512, 512, [], "f845", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM200 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.9 0L181.1 345.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-62.9 0 81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5l-112 0z"]
};
const faScarecrow = {
  prefix: 'far',
  iconName: 'scarecrow',
  icon: [448, 512, [], "f70d", "M168 104a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm131 72l69 0 0 32-45.4 0c-24.5 0-43.2 21.7-39.6 45.9l13.9 92.7-13-7.4c-7.9-4.5-17.7-4.2-25.2 .9L224 363.2 189.3 340c-7.6-5-17.3-5.4-25.2-.9l-13 7.4L165 253.9c3.6-24.2-15.1-45.9-39.6-45.9L80 208l0-32 69 0c18.9 19.7 45.6 32 75 32s56.1-12.3 75-32zM120 104c0 8.3 1 16.3 2.8 24L64 128l-8 0-24 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5 .8 16.4l7.6 11.4L6.4 179.2C2.4 182.2 0 187 0 192s2.4 9.8 6.4 12.8l19.9 14.9-7.6 11.4c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l24 0 8 0 52.1 0L96.3 388.4c-1.4 9.1 2.6 18.2 10.2 23.4s17.5 5.6 25.5 1L175 388.2 210.7 412c8.1 5.4 18.6 5.4 26.6 0L273 388.2l43.1 24.6c8 4.6 17.9 4.2 25.5-1s11.5-14.3 10.2-23.4L331.9 256l52.1 0 8 0 24 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-7.6-11.4 19.9-14.9c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-19.9-14.9 7.6-11.4c3.3-4.9 3.6-11.2 .8-16.4s-8.2-8.5-14.1-8.5l-24 0-8 0-58.8 0c1.8-7.7 2.8-15.7 2.8-24C328 46.6 281.4 0 224 0S120 46.6 120 104zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-45.4c-15.2 7.2-32.8 7.2-48 0l0 45.4z"]
};
const faTruckMonster = {
  prefix: 'far',
  iconName: 'truck-monster',
  icon: [640, 512, [], "f63b", "M280 48l88.2 0c2.5 0 4.8 1.2 6.3 3.1L421.4 112 272 112l0-56c0-4.4 3.6-8 8-8zm202 64L412.6 21.9C402 8.1 385.6 0 368.2 0L280 0c-30.9 0-56 25.1-56 56l0 56-104 0c-48.6 0-88 39.4-88 88l0 30.3c-6.1 5.1-12 10.6-17.5 16.4c-9.1 9.6-8.7 24.8 1 33.9s24.8 8.7 33.9-1C77.2 250.3 116.4 232 160 232c53.3 0 100.3 27.5 127.4 69.1c4.4 6.8 12 10.9 20.1 10.9l24.9 0c8.1 0 15.7-4.1 20.1-10.9C379.7 259.5 426.7 232 480 232c43.6 0 82.8 18.3 110.5 47.7c9.1 9.6 24.3 10.1 33.9 1s10.1-24.3 1-33.9c-5.5-5.8-11.3-11.3-17.5-16.4l0-30.3c0-48.6-39.4-88-88-88l-38 0zm78 88.6c-24.5-10.7-51.6-16.6-80-16.6c-65.4 0-123.5 31.5-160 80c-36.5-48.5-94.5-80-160-80c-28.4 0-55.5 5.9-80 16.6l0-.6c0-22.1 17.9-40 40-40l400 0c22.1 0 40 17.9 40 40l0 .6zM152 256c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3L63.8 299.1c-8.6 8.6-9.3 21.9-2.3 31.3c-3.7 6.9-6.8 14.1-9 21.8C40.9 353.9 32 363.9 32 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.7-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.3-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.8-3.7-14.1-6.8-21.7-9C190.1 264.9 180.1 256 168 256l-16 0zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm312-80c-12.1 0-22.1 8.9-23.8 20.6c-7.6 2.2-14.9 5.3-21.7 9c-9.4-7.1-22.8-6.3-31.3 2.3l-11.3 11.3c-8.6 8.6-9.3 21.9-2.2 31.3c-3.7 6.9-6.8 14.1-9 21.8C360.9 353.9 352 363.9 352 376l0 16c0 12.1 8.9 22.1 20.6 23.8c2.2 7.6 5.3 14.9 9 21.8c-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2c6.8 3.7 14.1 6.8 21.7 9c1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6c7.6-2.2 14.9-5.3 21.8-9c9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3c3.7-6.8 6.8-14.1 9-21.7c11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8c-2.2-7.6-5.3-14.9-9-21.7c7-9.4 6.3-22.8-2.2-31.3l-11.3-11.3c-8.6-8.6-21.9-9.3-31.3-2.3c-6.9-3.7-14.1-6.8-21.8-9C510.1 264.9 500.1 256 488 256l-16 0zm8 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faGiftCard = {
  prefix: 'far',
  iconName: 'gift-card',
  icon: [576, 512, [], "f663", "M353.5 68.8L318.7 128l1.3 0 72 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176 184 176 64 176c-8.8 0-16 7.2-16 16l0 128 480 0 0-128c0-8.8-7.2-16-16-16l-120 0-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384l0 64c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-64L48 384zM256 128l1.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l72 0zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40l41.6 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l41.6 0C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4z"]
};
const faW = {
  prefix: 'far',
  iconName: 'w',
  icon: [576, 512, [119], "57", "M15.9 33.4c12.5-4.5 26.2 2 30.7 14.5L165.9 379.4 265 49.1C268.1 39 277.4 32 288 32s19.9 7 23 17.1l99.1 330.3L529.4 47.9c4.5-12.5 18.2-18.9 30.7-14.5s18.9 18.2 14.5 30.7l-144 400c-3.5 9.7-12.9 16.1-23.2 15.9s-19.4-7.2-22.3-17.1L288 139.5 191 462.9c-3 9.9-12 16.8-22.3 17.1s-19.7-6.1-23.2-15.9L1.4 64.1c-4.5-12.5 2-26.2 14.5-30.7z"]
};
const faCodePullRequestDraft = {
  prefix: 'far',
  iconName: 'code-pull-request-draft',
  icon: [448, 512, [], "e3fa", "M48 80a32 32 0 1 1 64 0A32 32 0 1 1 48 80zm56 76.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3l0 199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-199.3zM48 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM416 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faSquareB = {
  prefix: 'far',
  iconName: 'square-b',
  icon: [448, 512, [], "e264", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 56c0-13.3 10.7-24 24-24l92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0c-13.3 0-24-10.7-24-24l0-104 0-104zm144 52c0-15.5-12.5-28-28-28l-68 0 0 56 68 0c15.5 0 28-12.5 28-28zM176 336l84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0 0 56z"]
};
const faElephant = {
  prefix: 'far',
  iconName: 'elephant',
  icon: [640, 512, [128024], "f6da", "M299.8 48c-33 0-59.8 26.8-59.8 59.8l0 4.2c0 35.3 28.7 64 64 64l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0c-61.9 0-112-50.1-112-112l0-4.2c0-6.4 .6-12.7 1.6-18.9C127.5 111.6 80 174.2 80 248l0 19c0 15.5-1.5 31-4.6 46.3c-3.3 16.3-10.1 31.7-20.1 44.9L43.2 374.4c-8 10.6-23 12.8-33.6 4.8s-12.8-23-4.8-33.6l12.1-16.2c5.7-7.6 9.6-16.3 11.4-25.6C30.8 291.7 32 279.4 32 267l0-19C32 137.6 114.8 46.6 221.6 33.6C241.3 12.9 269.1 0 299.8 0c30.8 0 59 12.1 79.8 32l4.4 0c88.4 0 160 71.6 160 160l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-52.6-36.3-96.8-85.3-108.8c2.1 7.3 3.5 14.9 4.2 22.7l1 12.1c1.1 13.2-8.7 24.8-21.9 25.9s-24.8-8.7-25.9-21.9l-1-12.1c-2.9-35-32.1-61.9-67.2-61.9zM528 381l0 18.7c0 17.8 14.5 32.3 32.3 32.3c15.8 0 29.3-11.4 31.9-27l.2-1c2.2-13.1 14.5-21.9 27.6-19.7s21.9 14.5 19.7 27.6l-.2 1c-6.5 38.7-40 67.1-79.2 67.1C516 480 480 444 480 399.7l0-18.9c-24-4.1-45.9-13.9-64-28.1L416 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-52.3c-21.2 2.8-42.8 2.8-64 0l0 52.3c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 48 0 0-80c0-7 3-13.6 8.3-18.1s12.2-6.6 19.1-5.6l24.3 3.5c18.8 2.7 37.8 2.7 56.6 0l24.3-3.5c6.9-1 13.9 1.1 19.1 5.6S320 377 320 384l0 80 48 0 0-152c0-13.3 10.7-24 24-24c11.2 0 20.6 7.6 23.2 18c18.7 26.7 51.6 44.9 89.5 44.9c30.1 0 57.1-11.4 76.3-29.6c6.4-6.1 16.5-5.8 22.6 .6s5.8 16.5-.6 22.6c-19.9 18.9-46 31.9-75 36.5zM432 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faEarthAfrica = {
  prefix: 'far',
  iconName: 'earth-africa',
  icon: [512, 512, [127757, "globe-africa"], "f57c", "M464 256c0-19.4-2.6-38.1-7.6-55.9L429 194.6c-7.7-1.5-15.4 2.3-18.9 9.2c-5.8 11.6-19.2 17.1-31.5 13l-14.1-4.7c-7.7-2.6-16.1-.6-21.8 5.1c-3.7 3.7-3.7 9.7 0 13.4l33.5 33.5c5 5 7.8 11.8 7.8 18.9c0 12.3-8.4 23-20.3 26l-5.3 1.3c-3.8 .9-6.4 4.3-6.4 8.2l0 12.1c0 13.8-4.5 27.3-12.8 38.4l-25.6 34.1c-6 8.1-15.5 12.8-25.6 12.8c-17.7 0-32-14.3-32-32l0-48c0-8.8-7.2-16-16-16l-32 0c-26.5 0-48-21.5-48-48l0-28c0-12.6 5.9-24.4 16-32l39.4-29.5c5.6-4.2 12.4-6.5 19.4-6.5c3.5 0 6.9 .6 10.2 1.7l32 10.7c7.2 2.4 15 2.7 22.4 .9l35.4-8.8c10.2-2.5 17.3-11.7 17.3-22.2c0-8.7-4.9-16.6-12.6-20.5l-29.2-14.6c-3.7-1.8-8.1-1.1-11 1.8l-3.9 3.9c-4.6 4.6-10.9 7.2-17.4 7.2c-3.8 0-7.6-.9-11-2.6l-15.2-7.6c-6.7-3.4-14.9-1.6-19.6 4.3l-13.6 17c-5.5 6.9-15.8 7.4-22 1.2c-2.8-2.8-4.3-6.5-4.3-10.4l0-41.4c0-5.6-1.5-11-4.2-15.9l-10-17.4C101.7 94.1 48 168.8 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faGlobeAfrica = faEarthAfrica;
const faRainbow = {
  prefix: 'far',
  iconName: 'rainbow',
  icon: [640, 512, [127752], "f75b", "M320 88C169.8 88 48 209.8 48 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C0 183.3 143.3 40 320 40s320 143.3 320 320l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96C592 209.8 470.2 88 320 88zm0 224c-26.5 0-48 21.5-48 48l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-53 43-96 96-96s96 43 96 96l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-26.5-21.5-48-48-48zM160 360l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-114.9 93.1-208 208-208s208 93.1 208 208l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-88.4-71.6-160-160-160s-160 71.6-160 160z"]
};
const faCircleNotch = {
  prefix: 'far',
  iconName: 'circle-notch',
  icon: [512, 512, [], "f1ce", "M215.1 26.3c3.6 12.7-3.7 26-16.5 29.7C111.6 80.9 48 161.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208c0-94.9-63.6-175.1-150.6-200c-12.7-3.6-20.1-16.9-16.5-29.7s16.9-20.1 29.7-16.5C433.6 40.5 512 139.1 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 139.1 78.4 40.5 185.4 9.9c12.7-3.6 26 3.7 29.7 16.5z"]
};
const faTabletScreenButton = {
  prefix: 'far',
  iconName: 'tablet-screen-button',
  icon: [448, 512, ["tablet-alt"], "f3fa", "M48 448c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-80L48 368l0 80zm0-128l352 0 0-256c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 256zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faTabletAlt = faTabletScreenButton;
const faPaw = {
  prefix: 'far',
  iconName: 'paw',
  icon: [512, 512, [], "f1b0", "M193.9 189.7c-32.3 10.6-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5s-.3 86.2-32.6 96.8zm217.7 8.9c18.9-32.4 54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3s-29.1-51.7-10.2-84.1zm-311.3 0c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM277.5 92.9c14.3-42.9 52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5s-46.9-53.9-32.6-96.8zM114.3 409.7c-1.4 3.7-2.3 8.5-2.3 14.2c0 4.5 3.6 8.1 8.1 8.1l3.4 0c2.2 0 4.3-.4 6.3-1.2l72.7-29.1c34.3-13.7 72.6-13.7 107 0l72.7 29.1c2 .8 4.2 1.2 6.3 1.2l3.4 0c4.5 0 8.1-3.6 8.1-8.1c0-5.7-.9-10.4-2.3-14.2C352.1 287.4 276.6 272 256 272s-96.1 15.4-141.7 137.7zM69.3 393C121.7 252.4 214.8 224 256 224s134.3 28.4 186.7 169c3.7 9.9 5.3 20.4 5.3 31c0 31-25.1 56.1-56.1 56.1l-3.4 0c-8.3 0-16.5-1.6-24.2-4.7l-72.7-29.1c-22.9-9.2-48.4-9.2-71.3 0l-72.7 29.1c-7.7 3.1-15.9 4.7-24.2 4.7l-3.4 0c-31 0-56.1-25.1-56.1-56.1c0-10.5 1.6-21.1 5.3-31z"]
};
const faMessageQuestion = {
  prefix: 'far',
  iconName: 'message-question',
  icon: [512, 512, [], "e1e3", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCloud = {
  prefix: 'far',
  iconName: 'cloud',
  icon: [640, 512, [9729], "f0c2", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8z"]
};
const faTrowelBricks = {
  prefix: 'far',
  iconName: 'trowel-bricks',
  icon: [512, 512, [], "e58a", "M240.8 4.8c-9.4-5.8-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4s15.2-16.1 15.2-27.2l0-72 89 0c3.6 13.8 16.1 24 31 24l88 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-88 0c-14.9 0-27.4 10.2-31 24l-89 0 0-72c0-11.1-5.7-21.4-15.2-27.2zM288 384l16 0 32 0 128 0 0 80-208 0 0-80 32 0zm-80 0l0 80L48 464l0-80 160 0zm256-48l-128 0 0-64 128 0 0 64zM288 272l0 16 0 48-48 0L48 336c-26.5 0-48 21.5-48 48l0 80c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-80c0-1.3-.1-2.7-.2-4c.1-1.3 .2-2.7 .2-4l0-104c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z"]
};
const faSquare3 = {
  prefix: 'far',
  iconName: 'square-3',
  icon: [448, 512, [], "e258", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l128 0c9.9 0 18.8 6.1 22.4 15.3s1.1 19.7-6.2 26.4l-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2L208 384c-30.1 0-58.1-15.6-73.9-41.2l-2.6-4.2c-7-11.3-3.5-26.1 7.8-33s26.1-3.5 33 7.8l2.6 4.2c7.1 11.5 19.6 18.4 33 18.4l27.8 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3c-9.9 .1-18.9-6-22.5-15.2s-1.2-19.8 6.1-26.5L218.3 176 152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faFaceFlushed = {
  prefix: 'far',
  iconName: 'face-flushed',
  icon: [512, 512, [128563, "flushed"], "f579", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faFlushed = faFaceFlushed;
const faHospitalUser = {
  prefix: 'far',
  iconName: 'hospital-user',
  icon: [576, 512, [], "f80d", "M64 48l192 0c8.8 0 16 7.2 16 16l0 351.7c11.3-20 27.9-36.7 48-47.9l0-95.9L320 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0L64 464c-8.8 0-16-7.2-16-16l0-32 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-48 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0L48 64c0-8.8 7.2-16 16-16zm72 64l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"]
};
const faMicrowave = {
  prefix: 'far',
  iconName: 'microwave',
  icon: [576, 512, [], "e01b", "M512 80c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 352 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 32zM432 136l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-240 0z"]
};
const faChfSign = {
  prefix: 'far',
  iconName: 'chf-sign',
  icon: [640, 512, [], "e602", "M0 115.3C0 69 38.2 32 83.9 32c30.9 0 59.6 17.4 73.6 45.3c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7C108.9 87.4 96.9 80 83.9 80C64.1 80 48 96.1 48 115.3l0 281.3C48 415.9 64.1 432 83.9 432c13 0 25-7.4 30.6-18.7c5.9-11.9 20.3-16.7 32.2-10.7s16.7 20.3 10.7 32.2C143.5 462.6 114.7 480 83.9 480C38.2 480 0 443 0 396.7L0 115.3zM216 32c13.3 0 24 10.7 24 24l0 168 128 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-184-128 0 0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM448 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L496 80l0 144 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400z"]
};
const faTentArrowLeftRight = {
  prefix: 'far',
  iconName: 'tent-arrow-left-right',
  icon: [576, 512, [], "e57f", "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z"]
};
const faCartCircleArrowUp = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-up',
  icon: [640, 512, [], "e3f0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
const faTrashClock = {
  prefix: 'far',
  iconName: 'trash-clock',
  icon: [576, 512, [], "e2b0", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c2 0 3.9-.1 5.8-.3c-18.2-12.9-33.8-29.1-45.9-47.7l-161 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0-5.9 80.1c15.3-7.1 31.9-12 49.2-14.4l4.9-65.7 11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"]
};
const faReflectBoth = {
  prefix: 'far',
  iconName: 'reflect-both',
  icon: [512, 512, [], "e66f", "M345.4 48L256 137.4 166.6 48l178.7 0zM384 0L128 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S396.9 0 384 0zM137.4 256L48 345.4l0-178.7L137.4 256zM19.8 98.4C7.8 103.4 0 115.1 0 128L0 384c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9zM374.6 256L464 166.6l0 178.7L374.6 256zM492.2 98.4c-12-5-25.7-2.2-34.9 6.9l-128 128c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6zM256 374.6L345.4 464l-178.7 0L256 374.6zM413.6 492.2c5-12 2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8z"]
};
const faGavel = {
  prefix: 'far',
  iconName: 'gavel',
  icon: [512, 512, ["legal"], "f0e3", "M313 7c9.3 9.3 9.4 24.3 .2 33.7L471.3 198.8c9.4-9.2 24.4-9.1 33.7 .2c9.4 9.4 9.4 24.6 0 33.9l-16.7 16.8L393 345l-16 16c-9.4 9.4-24.6 9.4-33.9 0c-9-9-9.4-23.5-.9-32.9L184 169.9c-9.4 8.4-23.9 8.1-32.9-.9c-9.4-9.4-9.4-24.6 0-33.9l16-16 95.2-95.3L279 7c9.4-9.4 24.6-9.4 33.9 0zM279.2 74.7L217.9 136 376 294.1l61.3-61.3L279.2 74.7zM223.4 254.6l33.9 33.9-49.8 49.8 7 7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112c12.5-12.5 32.8-12.5 45.3 0l7 7 49.8-49.8zm-79.4 88L54.6 432 80 457.4 169.4 368 144 342.6z"]
};
const faLegal = faGavel;
const faSprinklerCeiling = {
  prefix: 'far',
  iconName: 'sprinkler-ceiling',
  icon: [384, 512, [], "e44c", "M0 0L0 96c0 11.5 8.2 21.4 19.5 23.6L128 140.2l0-48.9L48 76.1 48 0 0 0zM256 91.4l0 48.9 108.5-20.7C375.8 117.4 384 107.5 384 96l0-96L336 0l0 76.1L256 91.4zM160 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-48 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 496a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM272 344a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-80 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-152z"]
};
const faBrowsers = {
  prefix: 'far',
  iconName: 'browsers',
  icon: [576, 512, [], "e0cb", "M144 352l0-224 384 0 0 224c0 8.8-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16zM160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-256z"]
};
const faTrillium = {
  prefix: 'far',
  iconName: 'trillium',
  icon: [448, 512, [], "e588", "M203.3 16.2c11.8-11 29.8-11 41.5 0c12.1 11.3 33.1 32.5 51.2 58.8c17.9 26 34.2 58.9 34.2 93.4c0 7.3-.8 14.5-2.2 21.5c7.3 2.3 14.4 5.3 21.2 9.3c0 0 0 0 0 0c29.9 17.2 50.4 47.6 64.2 75.9c13.9 28.7 21.9 57.3 25.7 73.5c3.8 15.8-5.4 31.5-20.9 36.1c-16 4.8-44.9 12.2-76.8 14.6c-31.5 2.3-68.3-.1-98.2-17.2c-7-4-13.4-8.7-19.1-14c-5.7 5.3-12.1 10-19.1 14c-29.9 17.2-66.7 19.6-98.2 17.2c-31.9-2.4-60.9-9.8-76.8-14.6C14.3 380 5.1 364.4 8.8 348.5c3.8-16.2 11.8-44.8 25.7-73.5c13.7-28.3 34.2-58.8 64.2-75.9c0 0 0 0 0 0c6.9-3.9 14-7 21.3-9.3c-1.4-6.9-2.2-14.1-2.2-21.4c0-34.4 16.4-67.4 34.2-93.4c18.1-26.3 39.1-47.5 51.2-58.8zm122 224.5s0 0 0 0c-6.9-4-14.2-6.3-21.6-7.3c-9.9-1.3-18.6-7-23.6-15.6s-5.8-19-2-28.2c2.7-6.6 4.1-13.7 4.1-21.3c0 0 0 0 0 0c0-20.1-10-43.2-25.8-66.2C245.9 86.9 234 73.4 224 63.1c-9.9 10.2-21.9 23.8-32.4 39.1c-15.8 23-25.8 46.1-25.8 66.2c0 7.6 1.5 14.7 4.1 21.3c3.7 9.2 3 19.6-2 28.2s-13.8 14.3-23.6 15.6c-7.4 .9-14.8 3.3-21.7 7.3C105 250.9 89.8 271.1 77.7 296c-8 16.6-13.9 33.5-17.8 47.1c13.9 3.4 31.7 6.9 50.3 8.3c27.9 2.1 53.1-.9 70.8-11c7.1-4.1 12.9-9.3 17.4-15.4c6-8 15.5-12.8 25.6-12.8s19.5 4.7 25.6 12.8c4.5 6 10.4 11.3 17.4 15.4c17.6 10.1 42.9 13.1 70.8 11c18.6-1.4 36.4-4.9 50.3-8.3c-4-13.6-9.8-30.5-17.8-47.1c-12.1-25-27.3-45.1-44.9-55.2zM100.8 123.4c-3 11.8-4.8 24.1-4.8 36.6c0 6.2 .4 12.3 1.3 18.3c-7.8 2.7-15.4 6.1-22.7 10.3c-9.9 5.7-18.8 12.6-26.9 20.2C19 182.7 5.6 157.6 0 144.3c-5.8-13.8 3-29.1 17.9-31c14.7-1.9 44.4-2.8 83 10zm249.9 55c.9-6 1.3-12.1 1.3-18.4c0-12.5-1.8-24.8-4.8-36.6c38.6-12.8 68.2-11.9 83-10c14.9 1.9 23.7 17.1 17.9 31c-5.6 13.3-19 38.4-47.7 64.6c-8.1-7.7-17.1-14.6-27-20.3c-7.3-4.2-14.9-7.6-22.6-10.3zM205.1 497.1c-8.3-12.6-22.8-38.2-31-74.3c9.8-3.1 19.4-7.2 28.5-12.5c7.8-4.5 14.9-9.7 21.4-15.4c6.5 5.8 13.6 11 21.4 15.4c9.2 5.3 18.8 9.4 28.6 12.5c-8.2 36.1-22.6 61.6-31 74.2c-9.1 13.7-28.8 13.7-37.9 0zM184 240a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faTableCellsUnlock = {
  prefix: 'far',
  iconName: 'table-cells-unlock',
  icon: [640, 512, [], "e692", "M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l24 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 56 0 0 .6c-16.9 9.8-29 27.1-31.5 47.4L360 344l0 88zM200 296l112 0 0-80-112 0 0 80zm296-24l0 48 32 0 32 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faMusicSlash = {
  prefix: 'far',
  iconName: 'music-slash',
  icon: [640, 512, [], "f8d1", "M545 0c17.1 0 31 13.9 31 31l0 112.5c0 .4 0 .7 0 1.1L576 368c0 16.7-6.2 32.2-16.7 45.1l71.5 56c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L208 137.7l0-17.7c0-10.5 6.9-19.8 16.9-22.9l311-95.7c3-.9 6-1.4 9.1-1.4zM256 175.3l31.7 24.9L528 126.3 528 54 256 137.7l0 37.6zm77.7 60.9l87.4 68.5C437.4 294.3 457.8 288 480 288c17.5 0 33.9 3.9 48 10.7l0-122.2L333.7 236.3zM463.4 337.9l58 45.4c4.6-5.6 6.6-11.4 6.6-15.3c0-9.8-12.9-32-48-32c-6.2 0-11.7 .7-16.6 1.9zM208 259.9l48 37.8L256 432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c17.5 0 33.9 3.9 48 10.7l0-102.8zM160 400c-35.1 0-48 22.2-48 32s12.9 32 48 32s48-22.2 48-32s-12.9-32-48-32z"]
};
const faTruckRamp = {
  prefix: 'far',
  iconName: 'truck-ramp',
  icon: [640, 512, [], "f4e0", "M440 0c-48.6 0-88 39.4-88 88l0 285.8L17.7 464.8C4.9 468.3-2.6 481.5 .8 494.3s16.7 20.3 29.5 16.8L416.2 406c3.1 59.1 52 106 111.8 106c61.9 0 112-50.1 112-112s-50.1-112-112-112c-45.3 0-84.3 26.9-102 65.6l-.4 .1-25.7 7L400 88c0-22.1 17.9-40 40-40l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L440 0zm88 336a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faBinoculars = {
  prefix: 'far',
  iconName: 'binoculars',
  icon: [512, 512, [], "f1e5", "M96 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 16L96 80l0-16zM59.6 158c4.8-26.6 28-46 55.1-46l85.3 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24c0-13.3 10.7-24 24-24l85.3 0c27.1 0 50.3 19.4 55.1 46l5 27.3c3.6 19.9 10.8 39 21.2 56.4l2.6 4.4c20.1 33.6 30.8 72 30.8 111.1l0 66.8c0 30.9-25.1 56-56 56l-112 0c-30.9 0-56-25.1-56-56l0-136-64 0 0 136c0 30.9-25.1 56-56 56L56 480c-30.9 0-56-25.1-56-56l0-66.8C0 318 10.6 279.6 30.8 246l2.6-4.4c10.4-17.4 17.6-36.5 21.2-56.4l5-27.3zm55.1 2c-3.9 0-7.2 2.8-7.9 6.6l-5 27.3C97.2 219.5 88 244 74.6 266.4l-2.6 4.4C56.3 296.9 48 326.7 48 357.2L48 424c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-264-61.3 0zm282.6 0L336 160l0 264c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-66.8c0-30.4-8.3-60.3-23.9-86.4l-2.6-4.4c-13.4-22.3-22.6-46.9-27.3-72.5l-5-27.3c-.7-3.8-4-6.6-7.9-6.6zM352 32l32 0c17.7 0 32 14.3 32 32l0 16-96 0 0-16c0-17.7 14.3-32 32-32z"]
};
const faMicrophoneSlash = {
  prefix: 'far',
  iconName: 'microphone-slash',
  icon: [640, 512, [], "f131", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 21.2-5.1 41.1-14.2 58.7L408 294.5c5.2-11.8 8-24.8 8-38.5l0-160c0-53-43-96-96-96s-96 43-96 96l0 54.3L38.8 5.1zM272 187.9L272 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 2.3-.2 4.6-.5 6.8L272 187.9zm-80 59.4L144.7 210c-.5 1.9-.7 3.9-.7 6l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7z"]
};
const faBoxTissue = {
  prefix: 'far',
  iconName: 'box-tissue',
  icon: [512, 512, [], "e05b", "M208 48l-90.5 0 57.1 228.4 2.9 11.6 154.8 0 7.1-17.8L389.9 144 336 144c-31.1 0-56.2-9.9-75.5-28.2c-15.8-15-25.1-33.7-30.5-44.6l-.9-1.8C222.3 56 219.8 52 217.5 49.8c-.5-.5-.8-.6-1.3-.8c-.7-.3-3-1-8.2-1zM384 288l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0-8-32-12-48L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0L208 0c40 0 52 24 64 48s24 48 64 48l85.2 0C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L416 208l-19.2 48L384 288zM75 208l12 48-39 0 0 112 416 0 0-112-32.7 0 19.2-48 13.5 0c26.5 0 48 21.5 48 48l0 208c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 256c0-26.5 21.5-48 48-48l27 0zM48 416l0 48 416 0 0-48L48 416z"]
};
const faCircleC = {
  prefix: 'far',
  iconName: 'circle-c',
  icon: [512, 512, [], "e101", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"]
};
const faStarChristmas = {
  prefix: 'far',
  iconName: 'star-christmas',
  icon: [512, 512, [], "f7d4", "M279.2 17.9C276.5 7.4 266.9 0 256 0s-20.5 7.4-23.2 17.9L188.3 188.3 17.9 232.8C7.4 235.5 0 245.1 0 256s7.4 20.5 17.9 23.2l170.4 44.4 44.4 170.4c2.8 10.6 12.3 17.9 23.2 17.9s20.5-7.4 23.2-17.9l44.4-170.4 170.4-44.4c10.6-2.8 17.9-12.3 17.9-23.2s-7.4-20.5-17.9-23.2L323.7 188.3 279.2 17.9zm-48 196.1l24.8-95 24.8 95c2.2 8.4 8.8 15 17.2 17.2l95 24.8-95 24.8c-8.4 2.2-15 8.8-17.2 17.2l-24.8 95-24.8-95c-2.2-8.4-8.8-15-17.2-17.2l-95-24.8 95-24.8c8.4-2.2 15-8.8 17.2-17.2zM71 71c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L105 71c-9.4-9.4-24.6-9.4-33.9 0zM441 71c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9zm0 336l-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM71 441c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 407c-9.4 9.4-9.4 24.6 0 33.9z"]
};
const faChartBullet = {
  prefix: 'far',
  iconName: 'chart-bullet',
  icon: [512, 512, [], "e0e1", "M264 32c13.3 0 24 10.7 24 24l0 8 176 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-176 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 224c-26.5 0-48-21.5-48-48l0-64C0 85.5 21.5 64 48 64l192 0 0-8c0-13.3 10.7-24 24-24zM160 112l0 64 80 0 0-64-80 0zm128 0l0 64 176 0 0-64-176 0zm-176 0l-64 0 0 64 64 0 0-64zM360 256c13.3 0 24 10.7 24 24l0 8 80 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-80 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 448c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l288 0 0-8c0-13.3 10.7-24 24-24zM224 336l0 64 112 0 0-64-112 0zm160 0l0 64 80 0 0-64-80 0zm-208 0L48 336l0 64 128 0 0-64z"]
};
const faMotorcycle = {
  prefix: 'far',
  iconName: 'motorcycle',
  icon: [640, 512, [127949], "f21c", "M292.5 224.7c11.1 14.3 20.4 30.2 27.5 47.2c15.3-36.5 40.6-67.8 72.6-90.2l-15.3-28.2-84.9 71.3zM304 384l-16 0 0-32c0-88.4-71.6-160-160-160l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c49.6 0 95.1 17.3 130.8 46.3l95.2-80L337.7 80 280 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l62.5 0c14.7 0 28.2 8.1 35.2 21l13.9 25.8 46.7-39.3c5.8-4.8 13.1-7.5 20.6-7.5L480 32c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-61.8 0 55.1 102c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128c0-40 18.4-75.7 47.1-99.2l-15.4-28.6C377 253.4 352 299.8 352 352l0 32-48 0s0 0 0 0zm128-32c0 44.2 35.8 80 80 80s80-35.8 80-80s-35.8-80-80-80c-5.2 0-10.3 .5-15.2 1.4l36.3 67.1c6.3 11.7 2 26.2-9.7 32.5s-26.2 2-32.5-9.7l-36.3-67.1c-14 14.4-22.6 34.1-22.6 55.7zM204.3 328c-10.2-32.5-40.5-56-76.3-56c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56l-55.2 0c-5.6 5-13.1 8-21.2 8c-17.7 0-32-14.3-32-32s14.3-32 32-32c8.1 0 15.5 3 21.2 8l55.2 0zM128 224a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
const faTreeChristmas = {
  prefix: 'far',
  iconName: 'tree-christmas',
  icon: [448, 512, [127876], "f7db", "M150.2 71l47.1-17.7L215 6.2c1.4-3.8 5-6.2 9-6.2s7.6 2.5 9 6.2l17.7 47.1L297.8 71c3.8 1.4 6.2 5 6.2 9s-2.5 7.6-6.2 9l-47.1 17.7L233 153.8c-1.4 3.8-5 6.2-9 6.2s-7.6-2.5-9-6.2l-17.7-47.1L150.2 89c-3.8-1.4-6.2-5-6.2-9s2.5-7.6 6.2-9zm125.3 60.5l15.8-5.9 122 193.1c4.7 7.4 4.9 16.7 .7 24.4s-12.3 12.4-21 12.4l-25.3 0 76.5 119.5c4.7 7.4 5 16.8 .8 24.5s-12.3 12.5-21.1 12.5L24 512c-8.8 0-16.8-4.8-21.1-12.5s-3.9-17.1 .8-24.5L80.3 355.5l-25.3 0c-8.7 0-16.8-4.8-21-12.4s-3.9-17 .7-24.4l122-193.1 15.8 5.9L185 165c.4 1.2 .9 2.3 1.4 3.4L98.6 307.5l25.6 0c8.8 0 16.8 4.8 21.1 12.5s3.9 17.1-.8 24.5L67.9 464l312.3 0L303.6 344.5c-4.7-7.4-5.1-16.8-.8-24.5s12.3-12.5 21.1-12.5l25.6 0L261.5 168.4c.5-1.1 1-2.2 1.4-3.4l12.6-33.5zM160 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faTireFlat = {
  prefix: 'far',
  iconName: 'tire-flat',
  icon: [512, 512, [], "f632", "M464 288c0-114.9-93.1-208-208-208S48 173.1 48 288c0 31 6.8 60.3 18.8 86.7c6.9 15.1 7 33-.8 48.5L48.4 458.5c-.3 .5-.4 1.1-.4 1.7c0 2.1 1.7 3.8 3.8 3.8l80.2 0L380 464l80.2 0c2.1 0 3.8-1.7 3.8-3.8c0-.6-.1-1.2-.4-1.7l-17.7-35.3c-7.8-15.6-7.7-33.4-.8-48.5C457.2 348.3 464 319 464 288zm48 0c0 38.1-8.3 74.2-23.2 106.7c-1 2.2-1 4.8 .1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2c0 28.6-23.2 51.8-51.8 51.8L380 512 132 512l-80.2 0C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8 .1-7C8.3 362.2 0 326.1 0 288C0 146.6 114.6 32 256 32s256 114.6 256 256zm-136 0c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5l0 .9 39.2 12.8c.5-4.5 .8-9 .8-13.6zm-54.9 46.5c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 364.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3l0-41.3zM136 288c0 4.6 .3 9.2 .8 13.6L176 288.9l0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 228.4 136 256.8 136 288zm120-80c8.9 0 17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 210l1.6 2.2c8-2.7 16.6-4.2 25.6-4.2zM88 288a168 168 0 1 1 336 0A168 168 0 1 1 88 288zm200 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faSunglasses = {
  prefix: 'far',
  iconName: 'sunglasses',
  icon: [576, 512, [128374], "f892", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2 0 1.5 0 41.3 0 .6 0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 2.6 .2 5.2 .5 7.8l144.4-72.2c-18.8-5-38.3-7.6-57.2-7.6c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c0 .8 .1 1.7 .2 2.5l141-70.5c-18.6-4.9-38-7.5-56.7-7.5z"]
};
const faBadge = {
  prefix: 'far',
  iconName: 'badge',
  icon: [512, 512, [], "f335", "M256 48c-24.1 0-45.1 13.5-55.7 33.5C194.9 91.7 183 96.6 172 93.2c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172c3.4 11-1.5 22.9-11.7 28.2C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7C91.7 317.1 96.6 329 93.2 340c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7c11-3.4 22.9 1.5 28.2 11.7c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5c5.4-10.2 17.2-15.1 28.2-11.7c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1c-3.4-11 1.5-22.9 11.7-28.2c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7c-10.2-5.4-15.1-17.2-11.7-28.2c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2c-11 3.4-22.9-1.5-28.3-11.7C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z"]
};
const faMessagePen = {
  prefix: 'far',
  iconName: 'message-pen',
  icon: [512, 512, ["comment-alt-edit", "message-edit"], "f4a4", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM340.8 123c-14.7-14.7-38.6-14.7-53.3 0L272.6 138l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 232.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 284c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 160.6l-71.9 71.9z"]
};
const faCommentAltEdit = faMessagePen;
const faMessageEdit = faMessagePen;
const faBellConcierge = {
  prefix: 'far',
  iconName: 'bell-concierge',
  icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C119.6 157.2 32 252.4 32 368l48 0c0-97.2 78.8-176 176-176s176 78.8 176 176l48 0c0-115.6-87.6-210.8-200-222.7l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0-40 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z"]
};
const faConciergeBell = faBellConcierge;
const faPenRuler = {
  prefix: 'far',
  iconName: 'pen-ruler',
  icon: [512, 512, ["pencil-ruler"], "f5ae", "M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM173.3 27.3l65.2 65.2-33.9 33.9-26.2-26.2-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23L139.3 61.3c-6.2-6.2-16.4-6.2-22.6 0L61.3 116.7c-6.2 6.2-6.2 16.4 0 22.6l65.2 65.2L92.5 238.5 27.3 173.3c-25-25-25-65.5 0-90.5L82.7 27.3c25-25 65.5-25 90.5 0zM372.7 450.7c6.2 6.2 16.4 6.2 22.6 0l55.4-55.4c6.2-6.2 6.2-16.4 0-22.6l-16.4-16.4-23 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23-26.2-26.2 33.9-33.9 65.2 65.2c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0l-65.2-65.2 33.9-33.9 65.2 65.2z"]
};
const faPencilRuler = faPenRuler;
const faFileMp3 = {
  prefix: 'far',
  iconName: 'file-mp3',
  icon: [512, 512, [], "e648", "M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm75.7-111.4c6.9-1.9 14.3 1 18 7.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4zM288 368c0-8.8 7.2-16 16-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48zm144 80l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0c-8.8 0-16-7.2-16-16c0-.6 0-1.1 .1-1.6c.8-8.1 7.6-14.4 15.9-14.4l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 12.3-4.6 23.5-12.2 32c7.6 8.5 12.2 19.7 12.2 32c0 26.5-21.5 48-48 48z"]
};
const faArrowProgress = {
  prefix: 'far',
  iconName: 'arrow-progress',
  icon: [512, 512, [], "e5df", "M472 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64zM0 160C0 93.7 53.7 40 120 40l136 0 0-22.1C256 8 264 0 273.9 0c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9L256 88 120 88c-39.8 0-72 32.2-72 72s32.2 72 72 72l272 0c66.3 0 120 53.7 120 120c0 59.5-43.3 108.8-100 118.3c-9.1 24.3-32.5 41.7-60 41.7c-35.3 0-64-28.7-64-64s28.7-64 64-64c25.9 0 48.3 15.4 58.3 37.6c30.9-8.1 53.7-36.2 53.7-69.6c0-39.8-32.2-72-72-72l-272 0C53.7 280 0 226.3 0 160zM123.3 424l36.7 0 0-22.1c0-9.9 8-17.9 17.9-17.9c4 0 7.8 1.3 11 3.8l60.8 47.3c4 3.1 6.3 7.9 6.3 12.9s-2.3 9.8-6.3 12.9l-60.8 47.3c-3.1 2.4-7 3.8-11 3.8c-9.9 0-17.9-8-17.9-17.9l0-22.1-36.7 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40zM88 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm264 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faChessRookPiece = {
  prefix: 'far',
  iconName: 'chess-rook-piece',
  icon: [320, 512, ["chess-rook-alt"], "f448", "M16 120c0-13.3 10.7-24 24-24l240 0c13.3 0 24 10.7 24 24l0 104c0 5.6-2 11.1-5.6 15.4l-33.9 40.7 4.2 71.9-48.1 0L216 273.4c-.4-6.1 1.6-12.1 5.5-16.8L256 215.3l0-71.3-40 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-40 0 0 71.3 34.4 41.3c3.9 4.7 5.9 10.7 5.5 16.8L99.3 352l-48.1 0 4.2-71.9L21.6 239.4C18 235.1 16 229.6 16 224l0-104zM136 280.9l0-32.9c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32.9c0 3.9-3.2 7.1-7.1 7.1l-33.8 0c-3.9 0-7.1-3.2-7.1-7.1zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z"]
};
const faChessRookAlt = faChessRookPiece;
const faSquareRoot = {
  prefix: 'far',
  iconName: 'square-root',
  icon: [576, 512, [8730], "f697", "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.9 0c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L344.3 80z"]
};
const faAlbumCollectionCirclePlus = {
  prefix: 'far',
  iconName: 'album-collection-circle-plus',
  icon: [640, 512, [], "e48e", "M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16l-353 0c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l249.4 0c12.3 18.8 28 35.1 46.3 48L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faPeopleArrows = {
  prefix: 'far',
  iconName: 'people-arrows',
  icon: [640, 512, ["people-arrows-left-right"], "e068", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 40 0c0 14.3 5.5 28.7 16.4 39.6L192 391.2l0 96.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c27 0 51 13.4 65.5 34.1c-2.6 1.8-5.2 4-7.5 6.3l-28.1 28.1c-4.6-12.1-16.3-20.5-29.9-20.5l-44.8 0zM448 488l0-96.8 47.6-47.6C506.5 332.7 512 318.3 512 304l40 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C564.9 220.8 551 208 534.4 208l-44.8 0c-13.5 0-25.2 8.4-29.9 20.5l-28.1-28.1c-2.4-2.4-4.9-4.5-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24zm0-424a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM265 257l-23 23 156.1 0-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-156.1 0 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faPeopleArrowsLeftRight = faPeopleArrows;
const faSignPost = {
  prefix: 'far',
  iconName: 'sign-post',
  icon: [512, 512, [], "e624", "M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 137 0c9.5 0 18.5 4.2 24.6 11.5l61.9 74.2c4.9 5.9 4.9 14.6 0 20.5l-61.9 74.2c-6.1 7.3-15.1 11.5-24.6 11.5l-137 0 0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232L80 256c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l152 0 0-40zM449.5 160l-40-48L80 112l0 96 329.5 0 40-48z"]
};
const faFaceAngryHorns = {
  prefix: 'far',
  iconName: 'face-angry-horns',
  icon: [640, 512, [], "e368", "M320 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464c141.4 0 256-114.6 256-256c0-24.6-3.5-48.4-9.9-70.9c44.3-59.4 67.4-135 73.6-166c1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1c-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5C73.4 26.9 44.2 15.5 24.9 2.7C19.5-.9 12.5-.9 7.1 2.7S-1 12.8 .3 19.1c6.2 31 29.3 106.6 73.6 166C67.5 207.6 64 231.4 64 256c0 141.4 114.6 256 256 256zm72.4-102.5c9.7-9 10.2-24.2 1.2-33.9C379.3 360.3 354.6 344 320 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM240.4 288c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
const faMarsAndVenusBurst = {
  prefix: 'far',
  iconName: 'mars-and-venus-burst',
  icon: [640, 512, [], "e523", "M520 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0-54.2 54.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59 146.6 136 158.2l0 33.8-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-33.8c77-11.6 136-78 136-158.2c0-31.4-9-60.7-24.7-85.4L592 81.9l0 30.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88c0-13.3-10.7-24-24-24L520 0zM288 224a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM176 8c-8.9 0-17 4.9-21.2 12.7L124.7 77.5 61.6 65.6c-8.7-1.6-17.6 1.7-23.2 8.6s-6.8 16.4-3.3 24.5l25.6 58.9-48.6 42c-6.7 5.8-9.7 14.8-7.7 23.5s8.6 15.5 17.1 17.8l62 16.7 2.5 64.2c.3 8.9 5.6 16.8 13.6 20.7s17.5 3 24.6-2.3l51.7-38 51.7 38c6.4 4.7 14.7 5.9 22.1 3.3c-16.9-21.2-29.4-46.1-36.2-73.3l-23.4-17.2c-8.5-6.2-20-6.2-28.4 0l-29.5 21.7-1.4-36.6c-.4-10.5-7.6-19.5-17.7-22.2l-35.4-9.6 27.7-24c7.9-6.9 10.5-18.1 6.3-27.7L97.2 121.1l36 6.7c10.3 1.9 20.7-3.1 25.6-12.3L176 83.2l17.2 32.4c4.9 9.3 15.3 14.3 25.6 12.3l16.8-3.1c14.3-23.6 33.4-43.8 56.1-59.3c-.4 .1-.9 .1-1.3 .2L227.3 77.5 197.2 20.7C193 12.9 184.9 8 176 8z"]
};
const faTombstone = {
  prefix: 'far',
  iconName: 'tombstone',
  icon: [448, 512, [], "f720", "M368 432l0-240c0-79.5-64.5-144-144-144S80 112.5 80 192l0 240-48 0 0-240C32 86 118 0 224 0S416 86 416 192l0 240-48 0zM0 488c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM248 152l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSquareCaretRight = {
  prefix: 'far',
  iconName: 'square-caret-right',
  icon: [448, 512, ["caret-square-right"], "f152", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"]
};
const faCaretSquareRight = faSquareCaretRight;
const faScissors = {
  prefix: 'far',
  iconName: 'scissors',
  icon: [512, 512, [9984, 9986, 9988, "cut"], "f0c4", "M506.4 439.4c-8.5 10.2-23.7 11.5-33.8 3L312.4 308.2l37.4-31.3L503.4 405.6c10.2 8.5 11.5 23.7 3 33.8zM112 48a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0-48c61.9 0 112 50.1 112 112c0 17.9-4.2 34.8-11.6 49.8l75.1 62.9L472.6 69.6c10.2-8.5 25.3-7.2 33.8 3s7.2 25.3-3 33.8l-291 243.8c7.4 15 11.6 31.9 11.6 49.8c0 61.9-50.1 112-112 112S0 461.9 0 400s50.1-112 112-112c26.6 0 51.1 9.3 70.3 24.8L250.1 256l-67.8-56.8C163.1 214.7 138.6 224 112 224C50.1 224 0 173.9 0 112S50.1 0 112 0zm64 400A64 64 0 1 0 48 400a64 64 0 1 0 128 0z"]
};
const faCut = faScissors;
const faListMusic = {
  prefix: 'far',
  iconName: 'list-music',
  icon: [512, 512, [], "f8c9", "M481.1 0C498.2 0 512 13.8 512 30.9L512 136c0 10.4-6.7 19.6-16.6 22.8L384 194.7 384 432c0 44.2-50.1 80-112 80s-112-35.8-112-80s50.1-80 112-80c23.8 0 45.9 5.3 64 14.3L336 64c0-10.3 6.6-19.5 16.4-22.8L471.4 1.6c3.1-1 6.4-1.6 9.8-1.6zM323.3 414.5c-11.2-8-29.2-14.5-51.3-14.5s-40.1 6.5-51.3 14.5C209.4 422.6 208 429.4 208 432s1.4 9.4 12.7 17.5c11.2 8 29.2 14.5 51.3 14.5s40.1-6.5 51.3-14.5c11.3-8.1 12.7-14.9 12.7-17.5s-1.4-9.4-12.7-17.5zM384 144.3l80-25.8 0-63.9L384 81.3l0 63zM24 48l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 96C10.7 96 0 85.3 0 72S10.7 48 24 48zm0 128l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 352c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faSunPlantWilt = {
  prefix: 'far',
  iconName: 'sun-plant-wilt',
  icon: [640, 512, [], "e57a", "M160-.2c-8.4 0-16.2 4.4-20.5 11.6L115.2 51.7 69.6 40.4c-8.2-2-16.8 .4-22.7 6.3s-8.3 14.6-6.3 22.7l11.3 45.6L11.6 139.4C4.4 143.7 0 151.5 0 159.9s4.4 16.2 11.6 20.5l40.2 24.3L40.5 250.4c-2 8.2 .4 16.8 6.3 22.7s14.6 8.3 22.7 6.3l45.6-11.3 24.3 40.2c4.3 7.2 12.1 11.6 20.5 11.6s16.2-4.4 20.5-11.6l24.3-40.2 45.6 11.3c8.2 2 16.8-.4 22.7-6.3s8.3-14.6 6.3-22.7l-11.3-45.6 40.2-24.3c7.2-4.3 11.6-12.1 11.6-20.5s-4.4-16.2-11.6-20.5l-40.2-24.3 11.3-45.6c2-8.2-.4-16.8-6.3-22.7s-14.6-8.3-22.7-6.3L204.9 51.7 180.6 11.4C176.2 4.2 168.5-.2 160-.2zm0 70.4l12.9 21.3c5.4 9 16.1 13.4 26.3 10.9l24.2-6-6 24.2c-2.5 10.2 1.9 20.9 10.9 26.3l21.3 12.9-21.3 12.9c-9 5.4-13.4 16.1-10.9 26.3l6 24.2-24.2-6c-10.2-2.5-20.9 1.9-26.3 10.9L160 249.6l-12.9-21.3c-5.4-9-16.1-13.4-26.3-10.9l-24.2 6 6-24.2c2.5-10.2-1.9-20.9-10.9-26.3L70.4 159.9 91.8 147c9-5.4 13.4-16.1 10.9-26.3l-6-24.2 24.2 6c10.2 2.5 20.9-1.9 26.3-10.9L160 70.3zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274.1c0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338.1c0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 8 0 184L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-184 0-8 0-96z"]
};
const faToiletsPortable = {
  prefix: 'far',
  iconName: 'toilets-portable',
  icon: [576, 512, [], "e584", "M72 48l112 0c13.3 0 24 10.7 24 24l0 24L48 96l0-24c0-13.3 10.7-24 24-24zM48 432l0-288 160 0 0 80-24 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l24 0 0 112L48 432zm0 56l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-416c0-39.8-32.2-72-72-72L72 0C32.2 0 0 32.2 0 72L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM392 48l112 0c13.3 0 24 10.7 24 24l0 24L368 96l0-24c0-13.3 10.7-24 24-24zM368 432l0-288 160 0 0 80-24 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l24 0 0 112-160 0zm0 56l0-8 160 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-416c0-39.8-32.2-72-72-72L392 0c-39.8 0-72 32.2-72 72l0 416c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faHockeyPuck = {
  prefix: 'far',
  iconName: 'hockey-puck',
  icon: [512, 512, [], "f453", "M48 184c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 245.6 194.3 256 256 256s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2s-2.3-11.7-11-20.2c-8.8-8.6-22.8-17.5-42.1-25.5C372.4 122.4 317.7 112 256 112s-116.4 10.4-154.9 26.3c-19.3 8-33.3 16.9-42.1 25.5c-8.7 8.6-11 15.4-11 20.2zM0 184c0-21.7 10.7-40.1 25.4-54.5c14.7-14.3 34.6-26.1 57.3-35.5C128.3 75.1 189.6 64 256 64s127.7 11.1 173.2 29.9c22.7 9.4 42.7 21.2 57.3 35.5C501.3 143.9 512 162.3 512 184l0 144c0 21.7-10.7 40.1-25.4 54.5c-14.6 14.3-34.6 26.1-57.3 35.5C383.7 436.9 322.4 448 256 448s-127.7-11.1-173.2-29.9c-22.7-9.4-42.7-21.2-57.3-35.5C10.7 368.1 0 349.7 0 328L0 184zm464 72.2c-10.5 6.7-22.2 12.6-34.8 17.9C383.7 292.9 322.4 304 256 304s-127.7-11.1-173.2-29.9c-12.6-5.2-24.3-11.1-34.8-17.9L48 328c0 4.8 2.3 11.7 11 20.2c8.8 8.6 22.8 17.5 42.1 25.5C139.6 389.6 194.3 400 256 400s116.4-10.4 154.9-26.3c19.3-8 33.3-16.9 42.1-25.5c8.7-8.6 11-15.4 11-20.2l0-71.8z"]
};
const faMustache = {
  prefix: 'far',
  iconName: 'mustache',
  icon: [640, 512, [], "e5bc", "M233.4 112c-32.9 0-64.4 13.1-87.7 36.3c-28.5 28.5-74.2 29.8-104.3 3.1l-1.5-1.3c-2.7-2.4-5.8-4.1-9-5c-1.3-.4-2.7-.7-4.1-.9c-1.1-.1-2.2-.2-3.3-.2c-3.6 .1-7 .9-10.1 2.4c-2.2 1-4.2 2.4-6 4.2C2.9 154.9 0 161.1 0 168l0 34C0 311.4 88.6 400 198 400c42.8 0 84.5-13.9 118.8-39.6L320 358l3.2 2.4c34.3 25.7 76 39.6 118.8 39.6c109.4 0 198-88.6 198-198l0-34c0-6.9-2.9-13.1-7.5-17.4c-4.2-4-9.8-6.5-16.1-6.6c-.4 0-.9 0-1.3 0c-2.4 .1-4.8 .5-7.1 1.3c-2.9 1-5.6 2.6-8 4.7l-1.5 1.3c-30.1 26.7-75.8 25.4-104.3-3.1C471 125.1 439.5 112 406.6 112l-1.2 0c-29.7 0-58.5 10.4-81.3 29.5l-4 3.3-4-3.3c-22.8-19-51.6-29.5-81.3-29.5l-1.2 0zm358.3 98.7C587.3 289.5 521.9 352 442 352c-32.5 0-64-10.5-90-30l-17.6-13.2c-8.5-6.4-20.3-6.4-28.8 0L288 322c-26 19.5-57.5 30-90 30c-79.9 0-145.3-62.5-149.8-141.3c44.3 16.7 96 7 131.4-28.4C193.9 168 213.3 160 233.4 160l1.2 0c18.5 0 36.4 6.5 50.6 18.3l19.3 16.1c8.9 7.4 21.8 7.4 30.7 0l19.3-16.1c14.2-11.8 32.1-18.3 50.6-18.3l1.2 0c20.2 0 39.5 8 53.8 22.3c35.4 35.4 87.1 45.1 131.4 28.4z"]
};
const faHyphen = {
  prefix: 'far',
  iconName: 'hyphen',
  icon: [320, 512, [], "2d", "M0 256c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z"]
};
const faTable = {
  prefix: 'far',
  iconName: 'table',
  icon: [512, 512, [], "f0ce", "M48 264l0-104 184 0 0 104L48 264zm0 48l184 0 0 120L64 432c-8.8 0-16-7.2-16-16l0-104zM280 432l0-120 184 0 0 104c0 8.8-7.2 16-16 16l-168 0zM464 264l-184 0 0-104 184 0 0 104zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faUserChef = {
  prefix: 'far',
  iconName: 'user-chef',
  icon: [448, 512, [], "e3d2", "M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 64c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-64 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM304 176l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM169.4 438c-5.7 2.6-9.4 8.3-9.4 14.6l0 11.4 237.1 0c-7.7-28.9-30.1-51.9-58.8-60.4L304 393.4l0-14.3-13.1 3.8L169.4 438zM128 452.6c0-18.8 11-35.9 28.1-43.7l35.6-16.2L144 379.1l0 14.3-34.3 10.2c-28.6 8.5-51 31.5-58.8 60.4l77.1 0 0-11.4zM0 486.4c0-60.9 40.5-112.3 96-128.8L96 334c0-7.8 6.3-14 14-14c1.3 0 2.6 .2 3.9 .5L224 352l110.1-31.5c1.3-.4 2.6-.5 3.9-.5c7.8 0 14 6.3 14 14l0 23.5c55.5 16.5 96 68 96 128.8c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4zM272 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faMessageImage = {
  prefix: 'far',
  iconName: 'message-image',
  icon: [512, 512, ["comment-alt-image"], "e1e0", "M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492zm88-348c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-128 0-48 0-48 0c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCommentAltImage = faMessageImage;
const faUsersMedical = {
  prefix: 'far',
  iconName: 'users-medical',
  icon: [640, 512, [], "f830", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-13.4 0c-6.6-18.6-24.4-32-45.3-32l-32 0c-20.9 0-38.7 13.4-45.3 32l-77.4 0zm-26.7 32c19.3 0 37.6 4.1 54.2 11.5C422.5 372.3 416 385.4 416 400l0 8.6c-11.3-5.5-23.9-8.6-37.3-8.6l-117.3 0c-39.8 0-73.2 27.2-82.6 64l249.5 0c8.8 9.8 21.6 16 35.8 16l16 0 0 16c0 5.6 1 11 2.7 16l-328.1 0c-14.7 0-26.7-11.9-26.7-26.7C128 411.7 187.7 352 261.3 352l117.3 0zM320 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM512 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faSensorTriangleExclamation = {
  prefix: 'far',
  iconName: 'sensor-triangle-exclamation',
  icon: [640, 512, ["sensor-alert"], "e029", "M64 80l320 0c8.8 0 16 7.2 16 16l0 49.9c13.1-11.4 30.1-17.9 48-17.9l0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l161 0c-.6-4-1-8.1-1-12.3c0-12.5 3-24.7 8.9-35.7L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm21.8 293.8c-3.8 6.7-5.8 14.2-5.8 21.9c0 24.5 19.8 44.3 44.3 44.3l295.4 0c24.5 0 44.3-19.8 44.3-44.3c0-7.7-2-15.2-5.8-21.9l-150.4-265C476.5 168 462.8 160 448 160s-28.5 8-35.8 20.9l-150.4 265zM464 272l0 88c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-88c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSensorAlert = faSensorTriangleExclamation;
const faMagnifyingGlassArrowRight = {
  prefix: 'far',
  iconName: 'magnifying-glass-arrow-right',
  icon: [512, 512, [], "e521", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm33-289c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L128 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
const faTachographDigital = {
  prefix: 'far',
  iconName: 'tachograph-digital',
  icon: [640, 512, ["digital-tachograph"], "f566", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm112 16l224 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zM80 352c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 368c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zM96 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faDigitalTachograph = faTachographDigital;
const faFaceMask = {
  prefix: 'far',
  iconName: 'face-mask',
  icon: [576, 512, [], "e37f", "M128 388.9c-27.6-33.2-45.1-75.1-47.7-121l50.1 26.7c-1.6 5.5-2.4 11.4-2.4 17.4l0 76.9zM36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9c-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7c0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6c-3.6-6.8-11.4-9.9-18.5-7.9C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6zm45 23.6C93.2 128.5 181.2 48 288 48s194.8 80.5 206.7 184.2L429.5 267c-11.6-11.7-27.7-19-45.5-19l-192 0c-17.8 0-33.9 7.2-45.5 19L81.3 232.2zm414.3 35.7c-2.6 45.9-20.1 87.8-47.7 121l0-76.9c0-6-.8-11.9-2.4-17.4l50.1-26.7zM170.4 207.4c4.8-5.7 26.7-23.4 61.6-23.4c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.4 0-85.4 25-98.4 40.6c-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.1 33.8-3.1zM176 312c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16l0 8-224 0 0-8zm0 40l224 0 0 32-224 0 0-32zm0 64l224 0c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24zM344 184c36.4 0 58.7 15.3 63 19.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-13.5-13.5-48.1-33.7-97-33.7c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faPickleball = {
  prefix: 'far',
  iconName: 'pickleball',
  icon: [576, 512, [], "e435", "M284.3 61.9c18.8-18.7 49.2-18.7 68 0L465.9 175.2c14.8 14.8 17.9 36.9 9.3 54.7c15.7 4.4 30.4 11.1 43.8 19.8c16.6-35.5 10.3-79.1-19.1-108.4L386.3 28C348.8-9.4 287.9-9.4 250.4 28L92.5 185.5c-22.9 22.9-29.8 57.3-17.3 87.2l18.3 43.8c5 12 2.2 25.7-6.9 34.9L34.8 402.9c-25 24.9-25 65.4 0 90.4s65.6 25 90.7 0l52-51.8c9.1-9.1 22.9-11.8 34.8-7l42.5 17.4c11.4 4.7 23.4 6.6 35.2 5.8c-8-15.3-13.6-32.1-16.2-49.9c-.3-.1-.5-.2-.8-.3l-42.5-17.4c-29.9-12.2-64.2-5.4-87.1 17.4l-52 51.8c-6.3 6.2-16.4 6.2-22.7 0c-6.3-6.2-6.2-16.3 0-22.6l51.7-51.5c23-22.9 29.8-57.3 17.3-87.2l-18.3-43.8c-4.5-10.9-2.7-23.3 4.6-32.3l148.4 148c1.7-19 6.6-37 14.3-53.5L158 187.9l126.3-126zM560 384a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM368 368a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM464 304a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z"]
};
const faStarSharpHalf = {
  prefix: 'far',
  iconName: 'star-sharp-half',
  icon: [576, 512, [], "e28c", "M291.7 .3C303.4 2.1 312 12.2 312 24l0 352c0 7.4-3.4 14.4-9.3 18.9l-144 112c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176l158.5 0L265.1 16.7C268.7 5.4 280-1.5 291.7 .3zM264 178.6l-9.1 28.7c-3.2 10-12.4 16.7-22.9 16.7L126 224l88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6 264 364.3l0-185.7z"]
};
const faUsersSlash = {
  prefix: 'far',
  iconName: 'users-slash',
  icon: [640, 512, [], "e073", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320l178.1 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM281.5 195.3c8.8-11.7 22.7-19.3 38.5-19.3c26.5 0 48 21.5 48 48c0 11.6-4.1 22.2-11 30.5l-75.5-59.2zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192l-15.2 0zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c10.5 0 19.5-6 23.9-14.8l-49.7-39.1c.7 1.9 1.2 3.9 1.8 5.9l-282.6 0c9.5-36.8 42.9-64 82.6-64l117.3 0c2.6 0 5.1 .1 7.6 .3L324.9 352l-63.6 0zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"]
};
const faClover = {
  prefix: 'far',
  iconName: 'clover',
  icon: [448, 512, [], "e139", "M174.4 80c-14.4 0-26 11.7-26 26c0 6.6 1.7 13.2 5 18.9l35.6 63.2c5.3 9.4 3.7 21.1-3.9 28.8s-19.4 9.2-28.8 3.9L93 185.3c-5.8-3.3-12.3-5-18.9-5c-14.4 0-26 11.7-26 26l0 2.6c0 7.6 3 14.9 8.4 20.3l9.8 9.8c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-9.8 9.8C51 288.2 48 295.4 48 303l0 2.6c0 14.4 11.7 26 26 26c6.6 0 13.2-1.7 18.9-5l63.2-35.6c9.4-5.3 21.1-3.7 28.8 3.9s9.2 19.4 3.9 28.8L153.3 387c-3.3 5.8-5 12.3-5 18.9c0 14.4 11.7 26 26 26l2.6 0c7.6 0 14.9-3 20.3-8.4l9.8-9.8c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l9.8 9.8c5.4 5.4 12.7 8.4 20.3 8.4l2.6 0c14.4 0 26-11.7 26-26c0-6.6-1.7-13.2-5-18.9l-35.6-63.2c-5.3-9.4-3.7-21.1 3.9-28.8s19.4-9.2 28.8-3.9L355 326.7c5.8 3.3 12.3 5 18.9 5c14.4 0 26-11.7 26-26l0-2.6c0-7.6-3-14.9-8.4-20.3l-9.8-9.8c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l9.8-9.8c5.4-5.4 8.4-12.7 8.4-20.3l0-2.8c0-14.3-11.6-25.9-25.9-25.9c-6.7 0-13.3 1.7-19.1 5.1l-61.9 35.5c-9.3 5.3-21.1 3.8-28.7-3.7s-9.4-19.2-4.2-28.7l34.7-63.4c3.1-5.7 4.8-12.2 4.8-18.7c0-14.6-11.8-26.4-26.4-26.4L271 80c-7.6 0-14.9 3-20.3 8.4L241 98.2c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-9.8-9.8C191.8 83 184.6 80 177 80l-2.6 0zm173.3 26.4c0 11.1-2.1 22.1-6.3 32.4c10.3-4.2 21.4-6.4 32.7-6.4c40.8 0 73.9 33.1 73.9 73.9l0 2.8c0 17.1-5.7 33.7-16.1 47c10.4 13.4 16.1 29.9 16.1 47l0 2.6c0 40.9-33.2 74-74 74c-11.2 0-22.3-2.2-32.7-6.4c4.2 10.3 6.4 21.4 6.4 32.7c0 40.9-33.2 74-74 74l-2.6 0c-17.1 0-33.7-5.7-47-16.1c-13.4 10.4-29.9 16.1-47 16.1l-2.6 0c-40.9 0-74-33.2-74-74c0-11.2 2.2-22.3 6.4-32.7c-10.3 4.2-21.4 6.4-32.7 6.4c-40.9 0-74-33.2-74-74L0 303c0-17.1 5.7-33.7 16.1-47C5.7 242.6 0 226.1 0 209l0-2.6c0-40.9 33.2-74 74-74c11.2 0 22.3 2.2 32.7 6.4c-4.2-10.3-6.4-21.4-6.4-32.7c0-40.9 33.2-74 74-74l2.6 0c17.1 0 33.7 5.7 47 16.1C237.4 37.7 253.9 32 271 32l2.3 0c41.1 0 74.4 33.3 74.4 74.4z"]
};
const faMeat = {
  prefix: 'far',
  iconName: 'meat',
  icon: [512, 512, [127830], "f814", "M443.2 138.7c8.1 13.4 13.9 26.9 17.3 39.8c.5 1.9 .9 3.8 1.3 5.7c2.4 11.6 2.8 22.5 .9 32.1c-1.9 10.1-6.2 18.8-13 25.6l-.2 .2c-29 28.7-92.5 11.9-142-37.6C258 154.8 241.2 91.1 270.2 62.2c1.8-1.8 3.7-3.4 5.8-4.8c.7-.5 1.3-.9 2-1.3c3-1.9 6.3-3.5 9.8-4.7c.6-.2 1.2-.4 1.9-.6c32.7-10.1 82.4 8.5 122.8 48.9c12.4 12.4 22.8 25.7 30.8 39.1zM388.8 302.1C363 323.9 330.1 336 296 336l-88 0c-17.7 0-32-14.3-32-32l0-88c0-34.1 12.1-67 33.9-92.8c.8 5 1.9 9.9 3.1 14.6c9.3 35.3 30.9 70.9 60.6 100.6s65.3 51.4 100.6 60.6c4.7 1.2 9.6 2.3 14.6 3.1zM212.6 384l83.4 0c50.9 0 99.8-20.2 135.8-56.2L483.5 276l.3-.3c23.7-23.7 29.9-54.3 27.8-82.5c-.7-9.4-2.3-18.5-4.6-27c-5.8-22-16.4-44.1-30.7-64.8c-8.7-12.5-18.7-24.6-30-35.8C416.6 35.9 381.1 14.3 345.8 5c-34-8.9-78-8.3-109.5 23.2l-52 52c-36 36-56.2 84.8-56.2 135.8l0 83.4c0 7.1-2.8 13.9-7.8 18.9c-10.3 10.3-26.9 9.7-40.7 5C73.4 321.1 66.8 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-6.8-1.1-13.4-3.2-19.5c-4.7-13.8-5.3-30.4 5-40.7c5-5 11.8-7.8 18.9-7.8zm175-204.4c8.9-8.9 3.8-28.5-11.5-43.8s-34.9-20.4-43.8-11.5s-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5z"]
};
const faReply = {
  prefix: 'far',
  iconName: 'reply',
  icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 240l96 0c66.2 0 122 44.7 138.8 105.5c3.3-12.4 5.2-26.2 5.2-41.5c0-70.7-57.3-128-128-128l-112 0-24 0c-13.3 0-24-10.7-24-24l0-24 0-28.1L55.9 208 176 316.1l0-28.1 0-24c0-13.3 10.7-24 24-24l24 0zm0 48l0 48 0 16c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2l0 16 0 48 48 0 64 0c97.2 0 176 78.8 176 176c0 78-38.6 126.2-68.7 152.1c-4.1 3.5-8.1 6.6-11.7 9.3c-3.2 2.4-6.2 4.4-8.9 6.2c-4.5 3-8.3 5.1-10.8 6.5c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-6.8 3.6-13.2 8.3-18.1c.5-.5 .9-.9 1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6c1.7-2.3 3.4-5 5-7.9c5.3-9.7 9.5-22.9 9.5-40.2c0-53-43-96-96-96l-48 0-48 0z"]
};
const faMailReply = faReply;
const faStarAndCrescent = {
  prefix: 'far',
  iconName: 'star-and-crescent',
  icon: [512, 512, [9770], "f699", "M40 256c0 95.9 62.5 177.2 149 205.4C123.2 416.8 80 341.4 80 256s43.2-160.8 109-205.4C102.5 78.8 40 160.1 40 256zM256 0c22.2 0 43.7 2.8 64.2 8.1c2.6 .7 5.2 1.4 7.8 2.1c1.4 .4 2.8 .8 4.2 1.3c4.3 1.3 8.5 2.8 12.7 4.3c1.6 .6 3.1 1.2 4.7 1.8c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-1.7-.1-3.4-.2-5-.3c-3.2-.1-6.4-.2-9.6-.2c-.9 0-1.7 0-2.6 0c-3.2 0-6.5 .2-9.7 .3C206.6 54.7 120 145.2 120 256s86.6 201.3 195.7 207.6c3.2 .2 6.4 .3 9.7 .3c.9 0 1.7 0 2.6 0c3.2 0 6.4-.1 9.6-.2c1.7-.1 3.4-.2 5-.3c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4c-1.6 .6-3.1 1.2-4.7 1.8c-4.2 1.6-8.4 3-12.7 4.3c-1.4 .4-2.8 .8-4.2 1.3c-2.6 .8-5.2 1.5-7.8 2.1c-20.5 5.3-42 8.1-64.2 8.1C114.6 512 0 397.4 0 256S114.6 0 256 0zM357.2 174.2l1.7-3.4 10.9-22.2 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 10.9 22.2 1.7 3.4 13.3 27c1.4 2.8 4.1 4.8 7.2 5.3l29.8 4.3 3.7 .5 24.5 3.6 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-17.7 17.3-2.7 2.6-21.6 21c-2.3 2.2-3.3 5.4-2.8 8.5l5.1 29.7 .6 3.7 4.2 24.4 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-21.9-11.5-3.3-1.7-26.6-14c-2.8-1.5-6.1-1.5-8.9 0l-26.6 14-3.3 1.7-21.9 11.5-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 4.2-24.4 .6-3.7 5.1-29.7c.5-3.1-.5-6.3-2.8-8.5l-21.6-21-2.7-2.6-17.7-17.3-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 24.5-3.6 3.7-.5 29.8-4.3c3.1-.5 5.8-2.4 7.2-5.3l13.3-27zm-7.7 78.6a36.3 36.3 0 1 0 69 22.4 36.3 36.3 0 1 0 -69-22.4z"]
};
const faEmptySet = {
  prefix: 'far',
  iconName: 'empty-set',
  icon: [512, 512, [8709, 216], "f656", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5L505 41zM362.3 115.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z"]
};
const faHouseFire = {
  prefix: 'far',
  iconName: 'house-fire',
  icon: [640, 512, [], "e50c", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L447.9 128.2c-12.5-1.1-25.5 2.8-35.4 11.7c-4.1 3.6-8 7.3-12 11L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l77 0c-7.7 15.7-13.8 32-17.4 48L240 320l0 144 84.8 0c13.5 18.8 30.3 35.1 49.6 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM480 512c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C624.5 268 640 320.2 640 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faSquareMinus = {
  prefix: 'far',
  iconName: 'square-minus',
  icon: [448, 512, [61767, "minus-square"], "f146", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM152 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMinusSquare = faSquareMinus;
const faHelicopter = {
  prefix: 'far',
  iconName: 'helicopter',
  icon: [640, 512, [128641], "f533", "M152 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l184 0 0 80-198.1 0L86.7 76.8C78.5 68.6 67.4 64 55.9 64C28.4 64 7.8 89.2 13.2 116.1l16.1 80.3c3.6 17.8 15.6 32.8 32.2 40.2l124.8 55.5 77.4 77.4c19.5 19.5 46 30.5 73.5 30.5L504 400c39.8 0 72-32.2 72-72l0-48c0-83.9-68.1-152-152-152l-40 0 0-80 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L152 0zM128 176l208 0 0 176c-14.4-.3-28.2-6.2-38.5-16.4L217 255c-2.1-2.1-4.5-3.8-7.2-5L80.9 192.8c-2.4-1.1-4.1-3.2-4.6-5.7L63.1 121 111 169c4.5 4.5 10.6 7 17 7zM504 352l-120 0 0-176 40 0c57.4 0 104 46.6 104 104l0 48c0 13.3-10.7 24-24 24zM631 474.7c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-26.9 21.5c-4.3 3.4-9.5 5.3-15 5.3L248 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l311.2 0c16.3 0 32.2-5.6 45-15.8L631 474.7z"]
};
const faBird = {
  prefix: 'far',
  iconName: 'bird',
  icon: [512, 512, [], "e469", "M48.7 208L192 208c44.2 0 80-35.8 80-80l0-16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80c0 97.2-78.8 176-176 176c-91.8 0-167.2-70.3-175.3-160zM0 188.4L0 192C0 294.3 68.5 380.5 162.1 407.4l48.6 91.9c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4L221 416c1 0 2 0 3 0c12.6 0 25-1 37.1-3.1l45.7 86.3c6.2 11.7 20.7 16.2 32.4 10s16.2-20.7 10-32.4l-40.9-77.2C390.3 366.3 448 285.9 448 192l0-16.5 56.2-33.7c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7l-61.7-37C427.9 32.4 385.7 0 336 0C274.1 0 224 50.1 224 112l0 16c0 17.7-14.3 32-32 32L28.4 160C12.7 160 0 172.7 0 188.4zM336 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faCompass = {
  prefix: 'far',
  iconName: 'compass',
  icon: [512, 512, [129517], "f14e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faSquareCaretDown = {
  prefix: 'far',
  iconName: 'square-caret-down',
  icon: [448, 512, ["caret-square-down"], "f150", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"]
};
const faCaretSquareDown = faSquareCaretDown;
const faHeartHalfStroke = {
  prefix: 'far',
  iconName: 'heart-half-stroke',
  icon: [512, 512, ["heart-half-alt"], "e1ac", "M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4l0-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6c0 0 0 0 0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5l0 3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zM256 430.7L256 152c6.4 0 12.4-2.5 16.9-7c.4-.3 .7-.7 1-1.1l17.8-20c0 0 0 0 .1-.1s0 0 .1-.1c23.1-25.9 58-37.7 92-31.2c46.5 8.9 80.1 49.5 80.1 96.9l0 3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7z"]
};
const faHeartHalfAlt = faHeartHalfStroke;
const faFileCircleQuestion = {
  prefix: 'far',
  iconName: 'file-circle-question',
  icon: [576, 512, [], "e4ef", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"]
};
const faTruckUtensils = {
  prefix: 'far',
  iconName: 'truck-utensils',
  icon: [640, 512, [], "e628", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 174.9l9.5-81.4c.7-5.9 5.6-10.3 11.6-10.3c6.2 0 11.3 4.8 11.6 11l4.4 75.5c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.8c.3-6 5.3-10.6 11.3-10.6s10.9 4.7 11.3 10.6l4.4 75.8c.2 3 2.6 5.3 5.6 5.3s5.5-2.3 5.6-5.3l4.4-75.5c.4-6.2 5.5-11 11.6-11c5.9 0 10.9 4.4 11.6 10.3l9.5 81.4c0 29.4-20.5 54-48 60.3l0 36.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-36.8c-27.5-6.3-48-30.9-48-60.3zM272 304l0-64c-17.7 0-32-14.3-32-32l0-37c0-63.1 41.3-86 50.3-90.2c1.1-.5 2.3-.8 3.6-.8c5.6 0 10.1 4.5 10.1 10.1l0 37.9 0 112 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
const faLaptopCode = {
  prefix: 'far',
  iconName: 'laptop-code',
  icon: [640, 512, [], "f5fc", "M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM281 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM393 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
const faJoystick = {
  prefix: 'far',
  iconName: 'joystick',
  icon: [448, 512, [128377], "f8c5", "M224 48a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 173.4c50.3-11 88-55.8 88-109.4C336 50.1 285.9 0 224 0S112 50.1 112 112c0 53.6 37.7 98.4 88 109.4l0 98.6 48 0 0-98.6zM96 320c-17.7 0-32 14.3-32 32c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-256 0c0-17.7-14.3-32-32-32zm0 80l288 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0z"]
};
const faGrillFire = {
  prefix: 'far',
  iconName: 'grill-fire',
  icon: [576, 512, [], "e5a4", "M48 80l0 16c0 97.2 78.8 176 176 176c7.3 0 14.5-.4 21.6-1.3c-8 16.2-14.3 32.8-18.1 49.3c-1.2 0-2.4 0-3.6 0c-16.9 0-33.4-1.9-49.3-5.4L151.8 368l73 0c1.5 16.6 5.2 32.7 10.7 48L160 416c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8L129.2 299C52.9 263.3 0 185.8 0 96L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 24c0 24.1-3.8 47.3-10.9 69.1c-8.5-8.6-17.2-17-26.2-25.1c-4.3-3.9-9.3-6.9-14.5-8.9C398.8 119.8 400 108 400 96l0-16L48 80zm72 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm296 96c-88.4 0-160-71.6-160-160c0-76.7 62.5-144.7 107.2-179.4c5-3.9 10.9-5.8 16.8-5.8c7.9-.1 16 3.1 22 9.2l46 46 11.3-11.3c11.7-11.7 30.6-12.7 42.3-1C560.5 268 576 320.2 576 352c0 88.4-71.6 160-160 160zm64-111.8c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C389 327.1 352 363.6 352 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faRectangleVerticalHistory = {
  prefix: 'far',
  iconName: 'rectangle-vertical-history',
  icon: [576, 512, [], "e237", "M256 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L256 48zM192 64c0-35.3 28.7-64 64-64L512 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-384zM96 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24L96 72zM0 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 120z"]
};
const faSwatchbook = {
  prefix: 'far',
  iconName: 'swatchbook',
  icon: [512, 512, [], "f5c3", "M0 400c0 61.9 50.1 112 112 112l336 0c35.3 0 64-28.7 64-64l0-96c0-35.3-28.7-64-64-64l-62.1 0 50.7-50.7c25-25 25-65.5 0-90.5L365.3 75.3c-25-25-65.5-25-90.5 0L224 126.1 224 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 400zm448 64l-238.1 0 128-128L448 336c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16zM402.7 203.3L224 382.1l0-188.1 84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64l0-96 128 0 0 96c0 35.3-28.7 64-64 64zM48 256l0-80 128 0 0 80L48 256zm0-128l0-64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16l0 64L48 128zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faPrescriptionBottle = {
  prefix: 'far',
  iconName: 'prescription-bottle',
  icon: [384, 512, [], "f485", "M48 48l288 0 0 32L48 80l0-32zM40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l304 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-48 0 0 288c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-16-48 0z"]
};
const faBars = {
  prefix: 'far',
  iconName: 'bars',
  icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z"]
};
const faNavicon = faBars;
const faKeyboardLeft = {
  prefix: 'far',
  iconName: 'keyboard-left',
  icon: [640, 512, [], "e1c3", "M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-352 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l352 0zM224 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L224 64zm80 272l0 16c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm48-104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM248 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16-96c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm72 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zm72 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm16 64c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM416 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM121 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 63-63z"]
};
const faPeopleGroup = {
  prefix: 'far',
  iconName: 'people-group',
  icon: [640, 512, [], "e533", "M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2L64 416c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-32 0 0-16 0-48 0-128 32 0c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160l-32 0zM64 229.7l0 84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208l32 0 0 128 0 48 0 16-32 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-42.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3l0-84.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2l0 58.8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-58.8c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112l-32 0zm0 224l0-48 0-128 32 0 0 128 0 48 0 32-32 0 0-32zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3l0 84.7zm128 0l0-84.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z"]
};
const faHourglassEnd = {
  prefix: 'far',
  iconName: 'hourglass-end',
  icon: [384, 512, [8987, "hourglass-3"], "f253", "M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM273.5 140.5C293 121 304 94.6 304 67l0-19L80 48l0 19c0 27.6 11 54 30.5 73.5L192 222.1l81.5-81.5z"]
};
const faHourglass3 = faHourglassEnd;
const faHeartCrack = {
  prefix: 'far',
  iconName: 'heart-crack',
  icon: [512, 512, [128148, "heart-broken"], "f7a9", "M223.3 465.9l2.5 2.3c8.2 7.6 19 11.9 30.2 11.9s22-4.2 30.2-11.9l2.5-2.3L463.9 303.2c30.7-28.5 48.1-68.5 48.1-110.4l0-3.3c0-70.4-50-130.8-119.2-144C353.4 37.9 313.1 47 281 69.6c0 0 0 0 0 0c-4 2.8-7.8 5.8-11.5 9c-4.7 4.1-9.3 8.5-13.5 13.3c-7.5-8.4-15.9-15.9-25-22.3C198.9 47 158.6 37.9 119.2 45.4C50 58.6 0 119.1 0 189.5l0 3.3c0 41.9 17.4 81.9 48.1 110.4L223.3 465.9zm6.6-331.1l-67.6 67.6c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-59.7-97L316 158.9c3.6-2.1 5-6.6 3.2-10.3l-16.6-35.1c22.4-18.5 52.2-26.4 81.3-20.9c46.5 8.9 80.1 49.5 80.1 96.9l0 3.3c0 28.5-11.9 55.8-32.8 75.2L256 430.7 80.8 268C59.9 248.6 48 221.3 48 192.8l0-3.3c0-47.3 33.6-88 80.1-96.9c34-6.5 69 5.4 92 31.2c0 0 0 0 0 0l.1 .1 9.6 10.8z"]
};
const faHeartBroken = faHeartCrack;
const faFaceBeamHandOverMouth = {
  prefix: 'far',
  iconName: 'face-beam-hand-over-mouth',
  icon: [512, 512, [129325], "e47c", "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1l0 10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm-78.3 47.9c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faDropletPercent = {
  prefix: 'far',
  iconName: 'droplet-percent',
  icon: [384, 512, ["humidity"], "f750", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-75.3c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6zM136 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHumidity = faDropletPercent;
const faSquareUpRight = {
  prefix: 'far',
  iconName: 'square-up-right',
  icon: [448, 512, [8599, "external-link-square-alt"], "f360", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 313.4L320 176c0-8.8-7.2-16-16-16l-137.4 0c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"]
};
const faExternalLinkSquareAlt = faSquareUpRight;
const faFaceKissBeam = {
  prefix: 'far',
  iconName: 'face-kiss-beam',
  icon: [512, 512, [128537, "kiss-beam"], "f597", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faKissBeam = faFaceKissBeam;
const faCorn = {
  prefix: 'far',
  iconName: 'corn',
  icon: [512, 512, [127805], "f6c7", "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-20.4 0-38.5 9.5-50.2 24.3c-1.9-.2-3.9-.3-5.8-.3c-19.9 0-37.7 9.1-49.4 23.4l3.6 3.6c11.8 11.8 21.9 25.1 30 39.5c0-.3 0-.7-.1-1c0-.5-.1-.9-.1-1.4c0-8.8 7.2-16 16-16c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c2.6 0 5 .6 7.1 1.7c6.3 3.1 13.7 3.3 20.1 .6s11.4-8.2 13.5-15c2-6.5 8.1-11.3 15.3-11.3c4.6 0 8.7 1.9 11.6 5c5.3 5.5 12.8 8.3 20.4 7.3s14.3-5.4 18-12.1c2.8-5 8-8.2 14-8.2c8.8 0 16 7.2 16 16c0 6-3.3 11.2-8.2 14c-6.7 3.7-11.2 10.4-12.1 18s1.8 15.2 7.3 20.4c3.1 2.9 5 7 5 11.6c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7.2-4.7 13.3-11.3 15.3c-6.7 2.1-12.2 7-15 13.5s-2.6 13.8 .6 20.1c1 2.1 1.7 4.5 1.7 7.1c0 7-4.5 12.9-10.7 15.1c7.2 4.8 14.2 10.2 20.7 16.1L435.5 287c12.6-11.7 20.5-28.4 20.5-47c0-2-.1-3.9-.3-5.8C470.5 222.5 480 204.4 480 184c0-2-.1-3.9-.3-5.8C494.5 166.5 504 148.4 504 128c0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM169 71c-6.1-6.1-15-8.5-23.4-6.2s-14.8 8.9-16.9 17.3l-21.9 87.4c-.4 1.4-1.1 2.7-2.1 3.7L41.9 236.1C15.1 263 0 299.4 0 337.4c0 36 13.6 70.7 38 97.1L66.1 465c27.6 30 66.6 47 107.3 47c38.7 0 75.9-15.4 103.3-42.8l62.9-62.9c.9-.9 1.9-1.5 3.1-1.9l88.8-29.6c8.1-2.7 14.2-9.5 15.9-17.9s-1.1-17-7.4-22.7l-28.5-25.7C374 274.7 325.3 256 274.8 256c-9 0-17.9 .6-26.8 1.8l0-44.7c0-40.3-16-79-44.5-107.5L169 71zm31 142l0 57.1c-25.9 10.2-49.7 25.7-69.8 45.7L60.9 385.2C52.5 370.8 48 354.3 48 337.4c0-25.3 10-49.5 27.9-67.3l62.8-62.8c7.2-7.2 12.3-16.2 14.7-26L165 134.9l4.5 4.5C189 159 200 185.4 200 213zM101.4 432.5l-9.6-10.3 72.3-72.3c29.3-29.3 69.1-45.8 110.6-45.8c37.7 0 74.1 13.6 102.5 38.3l-49.7 16.6c-8.2 2.7-15.7 7.4-21.9 13.5l-62.9 62.9c-18.4 18.4-43.3 28.7-69.3 28.7c-27.4 0-53.5-11.4-72.1-31.5z"]
};
const faRollerCoaster = {
  prefix: 'far',
  iconName: 'roller-coaster',
  icon: [640, 512, [], "e324", "M48 184c0-40.1 22.7-74.9 56-92.3L104 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-376 5.1 0c15 0 29.6 3.2 42.9 9.3L200 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-323.4 48 69.1L296 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-185.1 14.9 21.5c9.4 13.6 20.6 25.6 33.1 35.8L392 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-99.9c15.3 5.9 31.4 9.7 48 11.2l0 88.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-90.2c20.9-4 40-13 56-25.8L592 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 0-8c0-75.1-60.9-136-136-136l-8.1 0c-30.4 0-60.3 8.3-86.4 23.9L358 150.8l58 83.5 0-62.3 18.1-10.9c14.1-8.4 29.7-13.9 45.9-16L480 264c0 13.3 10.7 24 24 24s24-10.7 24-24l0-116.7c36.9 10.4 64 44.4 64 84.7l0 8c0 44.2-35.8 80-80 80l-8.5 0c-41.9 0-81.2-20.5-105.1-55L281.9 97.3C253.5 56.4 206.9 32 157.1 32L152 32C68.1 32 0 100.1 0 184L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272z"]
};
const faPhotoFilmMusic = {
  prefix: 'far',
  iconName: 'photo-film-music',
  icon: [640, 512, [], "e228", "M576 48L256 48c-8.8 0-16 7.2-16 16l0 192c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 200.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9l30.5 46.7L406.3 195c-22.9 7.6-38.3 29-38.3 53.1l0 71.9-112 0c-35.3 0-64-28.7-64-64l0-192c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-6.3 2.1L592 64c0-8.8-7.2-16-16-16zM289.9 448L160 448l-24 0-24 0-48 0c-35.3 0-64-28.7-64-64L0 176c0-35.3 28.7-64 64-64l48 0 24 0 24 0 0 48 0 72 0 88 0 8 0 72 166.3 0c-2.3 1.4-4.6 3-6.7 4.6c-13.8 10.3-25.2 25.2-29.6 43.4zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 208l0-48-48 0c-8.8 0-16 7.2-16 16l0 32 64 0zm0 144l-64 0 0 32c0 8.8 7.2 16 16 16l48 0 0-48zm0-48l0-48-64 0 0 48 64 0zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
const faRadar = {
  prefix: 'far',
  iconName: 'radar',
  icon: [512, 512, [], "e024", "M316.4 161.7C299 150.5 278.2 144 256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112s112-50.1 112-112l48 0c0 78.2-56.1 143.3-130.3 157.2c-7.3-8.1-17.9-13.2-29.7-13.2s-22.4 5.1-29.7 13.2c-64.5-12.1-115.4-63-127.5-127.5c8.1-7.3 13.2-17.9 13.2-29.7s-5.1-22.4-13.2-29.7C112.7 152.1 177.8 96 256 96c35.5 0 68.3 11.6 94.9 31.2l34.2-34.2C349.7 64.8 304.8 48 256 48C152.7 48 66.9 123.4 50.7 222.1C39.5 229.2 32 241.7 32 256s7.5 26.8 18.7 33.9c14.4 87.7 83.6 157 171.4 171.4c7.1 11.3 19.6 18.7 33.9 18.7s26.8-7.5 33.9-18.7C388.6 445.1 464 359.3 464 256l48 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0c62.1 0 118.9 22.1 163.3 58.8L463 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-182 182c3.3 7.7 5.1 16.1 5.1 25c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c8.9 0 17.3 1.8 25 5.1l35.4-35.4z"]
};
const faSickle = {
  prefix: 'far',
  iconName: 'sickle',
  icon: [512, 512, [], "f822", "M218.2 90.2c56.2-56.2 147.4-56.2 203.6 0c2.3 2.3 4.5 4.7 6.7 7.1c-16.4-6-34-9.3-52.5-9.3c-83.9 0-152 68.1-152 152c0 17.8 3.1 35 8.7 50.9l-8.7 8.7-5.8-5.8c-56.2-56.2-56.2-147.4 0-203.6zM455.8 56.2c-75-75-196.5-75-271.5 0s-75 196.5 0 271.5L207 350.6c9.4 9.4 24.6 9.4 33.9 0l37.1-37.1c7.3-7.3 9.1-18.4 4.6-27.6C275.8 272.1 272 256.5 272 240c0-57.4 46.6-104 104-104c38.7 0 72.5 21.1 90.5 52.6c5.6 9.8 17.3 14.4 28 11s17.7-13.8 16.7-25.1c-3.9-43.2-22.4-85.3-55.4-118.4zM121 311c-9.4-9.4-24.6-9.4-33.9 0L71 327c-9.4 9.4-9.4 24.6 0 33.9l7 7L7 439c-9.4 9.4-9.4 24.6 0 33.9l32 32c9.4 9.4 24.6 9.4 33.9 0l71-71 7 7c9.4 9.4 24.6 9.4 33.9 0l16-16c9.4-9.4 9.4-24.6 0-33.9l-24-24-32-32-24-24z"]
};
const faFilm = {
  prefix: 'far',
  iconName: 'film',
  icon: [512, 512, [127902], "f008", "M352 432l-192 0 0-112 0-40 192 0 0 40 0 112zm0-200l-192 0 0-40 0-112 192 0 0 112 0 40zM64 80l48 0 0 88-64 0 0-72c0-8.8 7.2-16 16-16zM48 216l64 0 0 80-64 0 0-80zm64 216l-48 0c-8.8 0-16-7.2-16-16l0-72 64 0 0 88zM400 168l0-88 48 0c8.8 0 16 7.2 16 16l0 72-64 0zm0 48l64 0 0 80-64 0 0-80zm0 128l64 0 0 72c0 8.8-7.2 16-16 16l-48 0 0-88zM448 32L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64z"]
};
const faCoconut = {
  prefix: 'far',
  iconName: 'coconut',
  icon: [512, 512, [], "e2f6", "M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.2 28.9C361.5-4.8 309.6-5.7 260.4 9.5C210 25 155.3 59.1 107.2 107.2S25 210 9.5 260.4C-5.7 309.6-4.8 361.5 28.9 395.2l41 41C118.4 484.7 184.3 512 253 512C396 512 512 396 512 253c0-68.7-27.3-134.6-75.9-183.2L395.2 28.9zm27.4 98.5c23.7 32 37.9 70.2 40.9 110.1L457 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l35.6 35.6c-7.2 31.1-21.2 59.6-40.4 83.7L377 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l41.2 41.2c-24.2 19.2-52.6 33.3-83.7 40.4L265 423c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l6.5 6.5c-39.9-2.9-78.1-17.2-110.1-40.9c12.1-1.5 24.2-4.3 36.3-8c50.4-15.5 105-49.7 153.1-97.8s82.2-102.7 97.8-153.1c3.7-12 6.5-24.2 8-36.3zM256 256c62.5-62.5 92.9-133.4 67.9-158.4s-95.9 5.4-158.4 67.9S72.6 298.9 97.6 323.9s95.9-5.4 158.4-67.9z"]
};
const faRulerHorizontal = {
  prefix: 'far',
  iconName: 'ruler-horizontal',
  icon: [640, 512, [], "f547", "M48 320c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-64 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16 7.2-16 16l0 128zm16 64c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 384z"]
};
const faShieldCross = {
  prefix: 'far',
  iconName: 'shield-cross',
  icon: [512, 512, [9960], "f712", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48z"]
};
const faCassetteTape = {
  prefix: 'far',
  iconName: 'cassette-tape',
  icon: [576, 512, [128429], "f8ab", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-40 0-25.6-61.5c-8.7-20.9-29.1-34.5-51.7-34.5l-213.3 0c-22.6 0-43 13.6-51.7 34.5L104 432l-40 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM420 432l-264 0 17.9-43.1c1.2-3 4.2-4.9 7.4-4.9l213.3 0c3.2 0 6.1 1.9 7.4 4.9L420 432zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM176 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16c0-5.5-.7-10.9-2-16l100 0c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16l-100 0c1.3-5.1 2-10.5 2-16zm224 0c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l224 0c35.3 0 64-28.7 64-64zm-80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faSquareTerminal = {
  prefix: 'far',
  iconName: 'square-terminal',
  icon: [448, 512, [], "e32a", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faPeopleRobbery = {
  prefix: 'far',
  iconName: 'people-robbery',
  icon: [576, 512, [], "e536", "M504.5 53.3C493.1 101.7 449.8 136 400 136s-93.1-34.3-104.5-82.7l-8.2-34.8c-3-12.9-16-20.9-28.9-17.9s-20.9 16-17.9 28.9l8.2 34.8c11.3 48.1 44.3 86.5 87.2 106L336 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-317.8c42.9-19.4 75.9-57.8 87.2-105.9l8.2-34.8c3-12.9-5-25.8-17.9-28.9s-25.8 5-28.9 17.9l-8.2 34.8zM416 183.2L416 304l-32 0 0-120.8c5.3 .5 10.6 .8 16 .8s10.7-.3 16-.8zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM16 204.5L16 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0 0-99.5C64 188.8 76.8 176 92.5 176c9.4 0 18.1 4.6 23.4 12.3l56.3 81.4c4.5 6.5 11.9 10.3 19.7 10.3l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-35.4 0-49.2-71c-14.3-20.6-37.8-33-62.9-33C50.2 128 16 162.2 16 204.5z"]
};
const faLightbulb = {
  prefix: 'far',
  iconName: 'lightbulb',
  icon: [384, 512, [128161], "f0eb", "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"]
};
const faCaretLeft = {
  prefix: 'far',
  iconName: 'caret-left',
  icon: [256, 512, [], "f0d9", "M54.6 256L144 166.6l0 178.7L54.6 256zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-256c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-128 128z"]
};
const faCommentMiddle = {
  prefix: 'far',
  iconName: 'comment-middle',
  icon: [512, 512, [], "e149", "M231.3 387.2L256 436.7l24.7-49.5c6.5-12.9 18.4-22.3 32.5-25.4C407 341 464 274.7 464 208c0-79.5-83.3-160-208-160S48 128.5 48 208c0 66.7 57 133 150.7 153.8c14.1 3.1 26.1 12.5 32.5 25.4zm92.4 21.5l-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208C0 93.1 114.6 0 256 0S512 93.1 512 208c0 95.8-79.8 176.5-188.3 200.7z"]
};
const faTrashCanList = {
  prefix: 'far',
  iconName: 'trash-can-list',
  icon: [640, 512, [], "e2ab", "M161.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM338.2 80L301.5 24.9C291.1 9.4 273.6 0 254.9 0L161.1 0c-18.7 0-36.2 9.4-46.6 24.9L77.8 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l8 0 0 304c0 44.2 35.8 80 80 80l192 0c44.2 0 80-35.8 80-80l0-304 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-45.8 0zM336 128l0 304c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-304 256 0zM160 176c-8.8 0-16 7.2-16 16l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-8.8-7.2-16-16-16zm216-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zM448 408c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faBlock = {
  prefix: 'far',
  iconName: 'block',
  icon: [448, 512, [], "e46a", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm48 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faCircleExclamation = {
  prefix: 'far',
  iconName: 'circle-exclamation',
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faExclamationCircle = faCircleExclamation;
const faSchoolCircleXmark = {
  prefix: 'far',
  iconName: 'school-circle-xmark',
  icon: [640, 512, [], "e56d", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
const faArrowRightFromBracket = {
  prefix: 'far',
  iconName: 'arrow-right-from-bracket',
  icon: [512, 512, ["sign-out"], "f08b", "M505 273c9.4-9.4 9.4-24.6 0-33.9L377 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z"]
};
const faSignOut = faArrowRightFromBracket;
const faFaceFrownSlight = {
  prefix: 'far',
  iconName: 'face-frown-slight',
  icon: [512, 512, [], "e376", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM334.4 385.9C319.2 369.5 293.2 352 256 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4s91.7 25.5 113.6 49.4c9 9.7 8.4 24.9-1.4 33.9s-24.9 8.4-33.9-1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleChevronDown = {
  prefix: 'far',
  iconName: 'circle-chevron-down',
  icon: [512, 512, ["chevron-circle-down"], "f13a", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241L239 345c9.4 9.4 24.6 9.4 33.9 0L377 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87-87-87c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
const faChevronCircleDown = faCircleChevronDown;
const faSidebarFlip = {
  prefix: 'far',
  iconName: 'sidebar-flip',
  icon: [512, 512, [], "e24f", "M288 80l0 352L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l224 0zM512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320zm-64 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24zm-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0zm24 120c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z"]
};
const faUnlockKeyhole = {
  prefix: 'far',
  iconName: 'unlock-keyhole',
  icon: [448, 512, ["unlock-alt"], "f13e", "M224 48c-44.2 0-80 35.8-80 80l0 64 240 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0 0-64C96 57.3 153.3 0 224 0c57 0 105.2 37.2 121.8 88.6c4.1 12.6-2.8 26.1-15.5 30.2s-26.1-2.8-30.2-15.5C289.8 71.2 259.6 48 224 48zM64 240c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240zM256 376l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faUnlockAlt = faUnlockKeyhole;
const faTemperatureList = {
  prefix: 'far',
  iconName: 'temperature-list',
  icon: [512, 512, [], "e299", "M80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 176c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 146.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM344 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L344 32zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm32 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faCloudShowersHeavy = {
  prefix: 'far',
  iconName: 'cloud-showers-heavy',
  icon: [512, 512, [], "f740", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm244.6 31.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112zM313.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5z"]
};
const faHeadphonesSimple = {
  prefix: 'far',
  iconName: 'headphones-simple',
  icon: [512, 512, ["headphones-alt"], "f58f", "M256 80C141.1 80 48 173.1 48 288l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288C0 146.6 114.6 32 256 32s256 114.6 256 256l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-114.9-93.1-208-208-208zM160 432l0-112c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm0-160l16 0c17.7 0 32 14.3 32 32l0 144c0 17.7-14.3 32-32 32l-16 0c-44.2 0-80-35.8-80-80l0-48c0-44.2 35.8-80 80-80zm192 48l0 112c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32zm80 32l0 48c0 44.2-35.8 80-80 80l-16 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32l16 0c44.2 0 80 35.8 80 80z"]
};
const faHeadphonesAlt = faHeadphonesSimple;
const faSitemap = {
  prefix: 'far',
  iconName: 'sitemap',
  icon: [576, 512, [], "f0e8", "M320 80l0 64-64 0 0-64 64 0zM256 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l8 0 0 40-152 0c-30.9 0-56 25.1-56 56l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-4.4 3.6-8 8-8l152 0 0 40-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-40 152 0c4.4 0 8 3.6 8 8l0 32-8 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8 0 0-32c0-30.9-25.1-56-56-56l-152 0 0-40 8 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0zM48 368l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64zm208 0l64 0 0 64-64 0 0-64z"]
};
const faPipeSection = {
  prefix: 'far',
  iconName: 'pipe-section',
  icon: [640, 512, [], "e438", "M48 120c0-13.3-10.7-24-24-24S0 106.7 0 120l0 32L0 360l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 544 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-208 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-272 0L48 128l0-8zm0 56l272 0 272 0 0 160L48 336l0-160z"]
};
const faSpaceStationMoonConstruction = {
  prefix: 'far',
  iconName: 'space-station-moon-construction',
  icon: [512, 512, ["space-station-moon-alt"], "e034", "M208.2 53.5C223.5 49.9 239.5 48 256 48c54.9 0 104.8 21.2 142 56l-30 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l81.5 0c8.8 0 17-4.9 21.1-12.6s3.7-17.2-1.1-24.6C423.7 45.6 345.2 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c81.4 0 153.9-38 200.7-97.1c8.2-10.4 6.5-25.5-3.9-33.7s-25.5-6.5-33.7 3.9C381 433.2 322.1 464 256 464c-80.8 0-150.8-46.1-185.3-113.3C109.9 362.7 168.9 376 256 376c116.9 0 183.2-23.9 218.9-36.8c0 0 0 0 0 0c4.8-1.7 9-3.2 12.7-4.5c7.5-2.5 13.3-8.6 15.5-16.2l.6-2.1c5.5-19.3 8.3-39.3 8.3-59.3l0-1.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.1c0 12.3-1.3 24.5-4 36.5l-.8 .3C424.3 306.5 364.4 328 256 328s-168.3-21.5-203.2-34.1l-1.5-.5C49.1 281.2 48 268.8 48 256c0-40.8 11.7-78.8 32-110.9c.6 52.5 43.3 94.9 96 94.9c53 0 96-43 96-96c0-41.7-26.6-77.2-63.8-90.5zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm248 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"]
};
const faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
const faCircleDollarToSlot = {
  prefix: 'far',
  iconName: 'circle-dollar-to-slot',
  icon: [512, 512, ["donate"], "f4b9", "M256 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368A208 208 0 1 0 256 0a208 208 0 1 0 0 416zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.6-64-64-64c-13.6 18.2-29.8 34.3-48 48l48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0c-18.2-13.7-34.3-29.8-48-48zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
};
const faDonate = faCircleDollarToSlot;
const faMemory = {
  prefix: 'far',
  iconName: 'memory',
  icon: [576, 512, [], "f538", "M64 112l448 0c8.8 0 16 7.2 16 16l0 8.4c-19.6 17.5-32 43.1-32 71.6s12.4 54 32 71.6l0 24.4L48 304l0-24.4C67.6 262 80 236.5 80 208s-12.4-54-32-71.6l0-8.4c0-8.8 7.2-16 16-16zM528 352l0 48-56 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-32 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l-56 0 0-48 480 0zM64 64C28.7 64 0 92.7 0 128l0 23.4c0 6.8 4.4 12.6 10.1 16.3C23.3 176.3 32 191.1 32 208s-8.7 31.7-21.9 40.3C4.4 252 0 257.8 0 264.6L0 416c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-151.4c0-6.8-4.4-12.6-10.1-16.3C552.7 239.7 544 224.9 544 208s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-23.4c0-35.3-28.7-64-64-64L64 64zm104 80c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm120 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z"]
};
const faFaceSleeping = {
  prefix: 'far',
  iconName: 'face-sleeping',
  icon: [512, 512, [], "e38d", "M48 256C48 141.1 141.1 48 256 48c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C329.6 8.2 293.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-37.7-8.2-73.6-22.9-105.9c-5.5-12.1-19.7-17.4-31.8-11.9s-17.4 19.7-11.9 31.8C457.3 196.1 464 225.3 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm64-296l25.4 0-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zM416 16c0 8.8 7.2 16 16 16l25.4 0L420.7 68.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-25.4 0 36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0L432 0c-8.8 0-16 7.2-16 16zM351.6 252c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7z"]
};
const faRoadSpikes = {
  prefix: 'far',
  iconName: 'road-spikes',
  icon: [640, 512, [], "e568", "M192 352l-80 0-48 0 0-48 0-153.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L112 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L240 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L368 136l80 120 0-105.5 0-5.8 0-17.2 0-10.7c0-15.8 20.5-22 29.3-8.9l5.9 8.9 9.6 14.3L496 136 606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7L512 352l-16 0-41.7 0-6.3 0-64 0-16 0-41.7 0-6.3 0-64 0-16 0-41.7 0-6.3 0zm-25.7-48L112 222.5l0 81.5 54.3 0zM0 424c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24zM240 222.5l0 81.5 54.3 0L240 222.5zM422.3 304L368 222.5l0 81.5 54.3 0zM496 222.5l0 81.5 54.3 0L496 222.5z"]
};
const faFireBurner = {
  prefix: 'far',
  iconName: 'fire-burner',
  icon: [640, 512, [], "e4f1", "M345.7 48.3L358 34.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C469 131.2 480 162.2 480 192.2C480 280.8 408.7 352 320 352c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2C273.4 2.3 280.7-.2 288 0c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM384 240.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C293 167.1 256 203.6 256 240.2c0 35.3 28.7 64 64 64s64-28.7 64-64zM32 280c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 80 480 0 0-80-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 104c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-104zM48 464l116.3 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16L48 432l0 32zm176-16c0 5.8-1.6 11.3-4.3 16l72.6 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16l-72.6 0c2.7 4.7 4.3 10.2 4.3 16zm128 0c0 5.8-1.6 11.3-4.3 16l72.6 0c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16l-72.6 0c2.7 4.7 4.3 10.2 4.3 16zm240 16l0-32-116.3 0c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16L592 464z"]
};
const faSquirrel = {
  prefix: 'far',
  iconName: 'squirrel',
  icon: [512, 512, [], "f71a", "M147.7 48C92.7 48 48 92.7 48 147.7s44.7 99.7 99.7 99.7c22.4 0 40 19.2 38 41.5l-.7 7.7c-1 11-5.9 20.4-12 27.3c-13.1 14.9-21.1 34.4-21.1 55.8c0 39.1 26.6 72 62.8 81.5c-14.3-20-22.8-44.4-22.8-70.9c0-25 7.7-49.3 22-69.8l35-49.9C284.8 219.5 304 158.5 304 96l0-20.8C304 69 309 64 315.2 64c15.2 0 28.7 7.6 36.8 19.2C360.1 71.6 373.6 64 388.8 64C395 64 400 69 400 75.2L400 96l7.6 0c53.4 0 98.2 40.5 103.5 93.7l.8 8c.5 4.5-.4 9.1-2.4 13.1l-4.1 8.2c-14.4 28.8-42 48.1-73.4 52.3l0 54.8c24.3 19 40 48.7 40 82c0 20.6-6 39.8-16.3 56l33.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L368 512l-16 0-38.3 0-77.4 0c-73 0-132.3-59.2-132.3-132.3c0-32.3 11.6-61.9 30.8-84.8C59.3 288.3 0 225 0 147.7C0 66.1 66.1 0 147.7 0C207.3 0 258.6 35.3 282 86c5.5 12 .3 26.3-11.8 31.8s-26.3 .3-31.8-11.8c-15.8-34.3-50.5-58-90.6-58zM352 464l16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56c-5.9 0-11.5 .9-16.8 2.6c-12.6 4-26.1-3.1-30.1-15.7s3.1-26.1 15.7-30.1c9.9-3.1 20.4-4.8 31.2-4.8c5.4 0 10.8 .4 16 1.2l0-57.2c0-13.3 10.7-24 24-24l11.5 0c18.2 0 34.8-10.3 42.9-26.5l1-2-.1-1.1c-2.9-28.6-27-50.4-55.7-50.4l-7.6 0-48 0-3.3 0c-7.6 55.2-28.2 108.1-60.4 154.2l-35 49.9c-8.7 12.4-13.3 27.1-13.3 42.2c0 40.7 33 73.7 73.7 73.7l38.3 0zm32-288a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faArrowUpToLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-line',
  icon: [384, 512, ["arrow-to-top"], "f341", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM209.5 167.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 244.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"]
};
const faArrowToTop = faArrowUpToLine;
const faFlag = {
  prefix: 'far',
  iconName: 'flag',
  icon: [448, 512, [127988, 61725], "f024", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 64 0 350.5 0 400l0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-279.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z"]
};
const faFaceCowboyHat = {
  prefix: 'far',
  iconName: 'face-cowboy-hat',
  icon: [512, 512, [], "e36e", "M216 0c-36.8 0-67.4 64.9-82.4 109.8C100 99.3 70 84.6 45.1 66.8C42.6 65 39.7 64 36.7 64C27.7 64 21 72.3 23.8 80.7C50.8 163.2 144.5 224 256 224s205.2-60.8 232.2-143.3C491 72.3 484.3 64 475.3 64c-3 0-6 1-8.4 2.8C442 84.6 412 99.3 378.4 109.8C363.4 64.9 332.8 0 296 0c-9.1 0-17.9 4-26.1 10.7c-7.9 6.5-19.8 6.5-27.7 0C233.9 4 225.1 0 216 0zM75.8 200C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104c-12.8 9.3-26.6 17.5-41.2 24.6c13.4 23.4 21 50.5 21 79.3c0 88.4-71.6 160-160 160s-160-71.6-160-160c0-28.9 7.6-55.9 21-79.3c-14.6-7.1-28.4-15.4-41.2-24.6zM366.4 367.5c5.7-11.5-6.2-22.2-18.6-18.8c-27.9 7.8-59 12.2-91.6 12.2s-63.7-4.3-91.6-12.2c-12.4-3.5-24.3 7.3-18.6 18.8C166.2 408.1 208 436 256.2 436s90-27.9 110.2-68.6zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faHanukiah = {
  prefix: 'far',
  iconName: 'hanukiah',
  icon: [640, 512, [128334], "f6e6", "M296 56c0-19.4 13.1-43.9 18.2-52.7C315.4 1.2 317.6 0 320 0s4.6 1.2 5.8 3.3C330.9 12.1 344 36.6 344 56c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 104C0 84.6 13.1 60.1 18.2 51.3C19.4 49.2 21.6 48 24 48s4.6 1.2 5.8 3.3C34.9 60.1 48 84.6 48 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM106.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C122.9 60.1 136 84.6 136 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM152 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C186.9 60.1 200 84.6 200 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C250.9 60.1 264 84.6 264 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM376 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C410.9 60.1 424 84.6 424 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zm82.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C474.9 60.1 488 84.6 488 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM504 104c0-19.4 13.1-43.9 18.2-52.7c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C538.9 60.1 552 84.6 552 104c0 13.3-10.7 24-24 24s-24-10.7-24-24zM610.2 51.3c1.2-2.1 3.4-3.3 5.8-3.3s4.6 1.2 5.8 3.3C626.9 60.1 640 84.6 640 104c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-19.4 13.1-43.9 18.2-52.7zM320 112c13.3 0 24 10.7 24 24l0 200 208 0c22.1 0 40-17.9 40-40l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 48.6-39.4 88-88 88l-208 0 0 80 152 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l152 0 0-80L88 384c-48.6 0-88-39.4-88-88L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 22.1 17.9 40 40 40l208 0 0-200c0-13.3 10.7-24 24-24zM112 160c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16l0 112 0 16-32 0 0-16 0-112c0-8.8 7.2-16 16-16z"]
};
const faChartScatter3d = {
  prefix: 'far',
  iconName: 'chart-scatter-3d',
  icon: [512, 512, [], "e0e8", "M32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 220.8L40.6 437.6c-10.1 8.5-11.5 23.7-2.9 33.8s23.7 11.5 33.8 2.9L256 319.3l184.6 155c10.2 8.5 25.3 7.2 33.8-2.9s7.2-25.3-2.9-33.8L280 276.8 280 56zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faDisplayChartUp = {
  prefix: 'far',
  iconName: 'display-chart-up',
  icon: [576, 512, [], "e5e3", "M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM376 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0z"]
};
const faSquareCode = {
  prefix: 'far',
  iconName: 'square-code',
  icon: [448, 512, [], "e267", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM255 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM193 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L95 239c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
const faFeather = {
  prefix: 'far',
  iconName: 'feather',
  icon: [512, 512, [129718], "f52d", "M311.9 166.1L112 366.1l0-36c0-55.2 21.9-108.1 60.9-147.1L276.7 79.2c20-20 47.1-31.2 75.3-31.2s55.3 11.2 75.3 31.2l5.5 5.5c20 20 31.2 47.1 31.2 75.3c0 16.8-4 33.3-11.4 48l-114.6 0 7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zm-22 89.9l122.2 0-48 48-122.2 0 48-48zm24.9 96c-37.2 30.9-84.2 48-132.9 48l-36 0 48-48 120.9 0zM64 330l0 84L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 84 0c67.9 0 133-27 181-75L466.7 269.3c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330z"]
};
const faVolumeLow = {
  prefix: 'far',
  iconName: 'volume-low',
  icon: [448, 512, [128264, "volume-down"], "f027", "M159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM412.6 181.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5z"]
};
const faVolumeDown = faVolumeLow;
const faXmarkToSlot = {
  prefix: 'far',
  iconName: 'xmark-to-slot',
  icon: [576, 512, ["times-to-slot", "vote-nay"], "f771", "M144 80l0 280 288 0 0-280L144 80zM96 360L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 280c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-288 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288l0 48-16 0 0 96 480 0 0-96-16 0 0-48 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0zM207 135c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faTimesToSlot = faXmarkToSlot;
const faVoteNay = faXmarkToSlot;
const faBoxTaped = {
  prefix: 'far',
  iconName: 'box-taped',
  icon: [448, 512, ["box-alt"], "f49a", "M261.3 80l81.1 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 288 160 261.3 80zm-74.7 0L160 160 59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5l81.1 0zM160 208l0 48c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-48 112 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208 112 0zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70z"]
};
const faBoxAlt = faBoxTaped;
const faCommentSlash = {
  prefix: 'far',
  iconName: 'comment-slash',
  icon: [640, 512, [], "f4b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM184.2 119C219.3 95.2 265.7 80 320 80c124.7 0 208 80.5 208 160c0 38.4-19.4 77-53.5 106.6L184.2 119zM424.1 430.1l-46-36.3c-18.1 4-37.5 6.2-58 6.2c-31.6 0-61.3-5.5-87.8-15.1c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C124.4 302.8 112 272 112 240c0-16.2 3.4-32.4 10-47.9l-39-30.8C70.7 185.6 64 212.2 64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104.1-17.9z"]
};
const faSwords = {
  prefix: 'far',
  iconName: 'swords',
  icon: [512, 512, [9876], "f71d", "M347.3 199.4l33.9 33.9L491.1 123.5c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6L418.1 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l33.9 33.9L422.4 54.8l38.2-3.5-3.5 38.2L347.3 199.4zM233.4 381.3l-33.9-33.9-42.7 42.7-34.7-34.7 42.7-42.7-33.9-33.9L88 321.4 75.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-4.7 4.7-6 11.8-3.3 17.8l27.5 62L4.7 460.7c-6.2 6.2-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2 62 27.5c6 2.7 13.1 1.4 17.8-3.3l16-16c6.2-6.2 6.2-16.4 0-22.6L190.6 424l42.7-42.7zM54.8 89.6L51.3 51.3l38.2 3.5L367.4 332.7l33.9-33.9L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4 .1C12.7-.4 8 1.3 4.7 4.7S-.4 12.7 .1 17.4L7 93.9c1 11.2 5.9 21.7 13.9 29.6L298.7 401.4l33.9-33.9L54.8 89.6zM459.3 308.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6l16 16c4.7 4.7 11.8 6 17.8 3.3l62-27.5 56.2 56.2c6.2 6.2 16.4 6.2 22.6 0l24-24c6.2-6.2 6.2-16.4 0-22.6l-56.2-56.2 27.5-62c2.7-6.1 1.4-13.1-3.3-17.8l-16-16z"]
};
const faCloudSunRain = {
  prefix: 'far',
  iconName: 'cloud-sun-rain',
  icon: [640, 512, [127782], "f743", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zM320.1 192c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
const faAlbum = {
  prefix: 'far',
  iconName: 'album',
  icon: [448, 512, [128189], "f89f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM80 256a144 144 0 1 1 288 0A144 144 0 1 1 80 256zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCircleN = {
  prefix: 'far',
  iconName: 'circle-n',
  icon: [512, 512, [], "e118", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM203.7 138.3c-6-8.6-16.9-12.4-26.9-9.2s-16.8 12.4-16.8 22.9l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-131.2L308.3 373.7c6 8.6 16.9 12.4 26.9 9.2s16.8-12.4 16.8-22.9l0-208c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 131.2L203.7 138.3z"]
};
const faCompress = {
  prefix: 'far',
  iconName: 'compress',
  icon: [448, 512, [], "f066", "M160 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112zM24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L24 320zM336 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-88zM312 320c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faWheatAwn = {
  prefix: 'far',
  iconName: 'wheat-awn',
  icon: [512, 512, ["wheat-alt"], "e2cd", "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm135.7-22.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm79.2-79.2c25 25 65.5 25 90.5 0C381.2 223 339 219.7 307.9 240.2l10.1 10.1z"]
};
const faWheatAlt = faWheatAwn;
const faAnkh = {
  prefix: 'far',
  iconName: 'ankh',
  icon: [320, 512, [9765], "f644", "M80 128c0 42.3 22.6 78.9 50.5 107.6c10.3 10.6 20.6 19.4 29.5 26.3c8.9-6.9 19.3-15.7 29.5-26.3C217.4 206.9 240 170.3 240 128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM98.9 272C66 238.9 32 189.8 32 128C32 57.3 89.3 0 160 0s128 57.3 128 128c0 61.8-34 110.9-66.9 144l74.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168L24 320c-13.3 0-24-10.7-24-24s10.7-24 24-24l74.9 0z"]
};
const faHandsHoldingChild = {
  prefix: 'far',
  iconName: 'hands-holding-child',
  icon: [640, 512, [], "e4fa", "M320 80a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm44.7 84.3L384.5 181c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-27.9-23.6C368.7 104.8 344.7 96 320 96s-48.7 8.8-67.6 24.7l-27.9 23.6c-10.1 8.6-11.4 23.7-2.8 33.8s23.7 11.4 33.8 2.8l19.8-16.7L264.2 253c-1.6 13.2 7.7 25.1 20.8 26.8s25.1-7.7 26.8-20.8l4.4-35 7.6 0 4.4 35c1.6 13.2 13.6 22.5 26.8 20.8s22.5-13.6 20.8-26.8l-11.1-88.8zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z"]
};
const faAsterisk = {
  prefix: 'far',
  iconName: 'asterisk',
  icon: [384, 512, [10033, 61545], "2a", "M192 32c13.3 0 24 10.7 24 24l0 156.9 131.4-81.3c11.3-7 26.1-3.5 33 7.8s3.5 26.1-7.8 33L237.6 256l135 83.6c11.3 7 14.7 21.8 7.8 33s-21.8 14.7-33 7.8L216 299.1 216 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-156.9L36.6 380.4c-11.3 7-26.1 3.5-33-7.8s-3.5-26.1 7.8-33l135-83.6-135-83.6c-11.3-7-14.8-21.8-7.8-33s21.8-14.8 33-7.8L168 212.9 168 56c0-13.3 10.7-24 24-24z"]
};
const faKeySkeletonLeftRight = {
  prefix: 'far',
  iconName: 'key-skeleton-left-right',
  icon: [640, 512, [], "e3b4", "M592 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm48 0c0 70.7-57.3 128-128 128c-62.5 0-114.5-44.8-125.8-104L304 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-13.3 10.7-24 24-24l202.2 0C397.5 44.8 449.5 0 512 0c70.7 0 128 57.3 128 128zM48 384a80 80 0 1 0 160 0A80 80 0 1 0 48 384zM0 384c0-70.7 57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l82.2 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48 48 0 0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72c0 13.3-10.7 24-24 24l-202.2 0C242.5 467.2 190.5 512 128 512C57.3 512 0 454.7 0 384z"]
};
const faCommentLines = {
  prefix: 'far',
  iconName: 'comment-lines',
  icon: [512, 512, [], "f4b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faLuchadorMask = {
  prefix: 'far',
  iconName: 'luchador-mask',
  icon: [448, 512, ["luchador", "mask-luchador"], "f455", "M288 464l-128 0C98.1 464 48 413.9 48 352l0-128c0-97.2 78.8-176 176-176s176 78.8 176 176l0 128c0 61.9-50.1 112-112 112zM224 0C100.3 0 0 100.3 0 224L0 352c0 88.4 71.6 160 160 160l128 0c88.4 0 160-71.6 160-160l0-128C448 100.3 347.7 0 224 0zM160 352l35.3 0 57.4 0 35.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-33.2-25.2-60.5-57.6-63.7c1-3.7 1.6-7.6 1.6-11.6c0-7.3-1.8-14.4-5.3-20.7l13.3 0c44.2 0 80-35.8 80-80c0-26.5-21.5-48-48-48l-32 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-32 0c-26.5 0-48 21.5-48 48c0 44.2 35.8 80 80 80l13.3 0c-3.4 6.3-5.3 13.4-5.3 20.7c0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8l8-8 4.2-4.2 .4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4 .4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8c0 6.2-5.1 11.3-11.3 11.3l-11.3 0-6 0-.6 0-21.5 0-.6 0-6 0-11.3 0zM96 208c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48c0 8.8-7.2 16-16 16l-32 0c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16c0-26.5 21.5-48 48-48l32 0z"]
};
const faLuchador = faLuchadorMask;
const faMaskLuchador = faLuchadorMask;
const faSquareCheck = {
  prefix: 'far',
  iconName: 'square-check',
  icon: [448, 512, [9745, 9989, 61510, "check-square"], "f14a", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faCheckSquare = faSquareCheck;
const faShredder = {
  prefix: 'far',
  iconName: 'shredder',
  icon: [512, 512, [], "f68a", "M112 192l0-128c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3L400 192l-288 0zM64 64l0 128c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64l0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64zM448 240c8.8 0 16 7.2 16 16l0 80L48 336l0-80c0-8.8 7.2-16 16-16l384 0zM40 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72zm96 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72-48 0 0 72z"]
};
const faBookOpenCover = {
  prefix: 'far',
  iconName: 'book-open-cover',
  icon: [640, 512, ["book-open-alt"], "e0c0", "M512 337.2l0-284.8L344 77l0 296 168-35.8zM296 373l0-296L128 52.4l0 284.8L296 373zM523.4 2.2C542.7-.7 560 14.3 560 33.8l0 316.3c0 15.1-10.6 28.1-25.3 31.3l-201.3 43c-8.8 1.9-17.9 1.9-26.7 0l-201.3-43C90.6 378.3 80 365.2 80 350.1L80 33.8C80 14.3 97.3-.7 116.6 2.2L320 32 523.4 2.2zM38.3 23.7l10.2 2c-.3 2.7-.5 5.4-.5 8.1l0 40.7 0 267.6 0 66.7 265.8 54.5c2 .4 4.1 .6 6.2 .6s4.2-.2 6.2-.6L592 408.8l0-66.7 0-267.6 0-40.7c0-2.8-.2-5.5-.5-8.1l10.2-2C621.5 19.7 640 34.8 640 55l0 366.9c0 15.2-10.7 28.3-25.6 31.3L335.8 510.4c-5.2 1.1-10.5 1.6-15.8 1.6s-10.6-.5-15.8-1.6L25.6 453.2C10.7 450.2 0 437.1 0 421.9L0 55C0 34.8 18.5 19.7 38.3 23.7z"]
};
const faBookOpenAlt = faBookOpenCover;
const faSandwich = {
  prefix: 'far',
  iconName: 'sandwich',
  icon: [512, 512, [129386], "f81f", "M48 112l416 0 0 32L48 144l0-32zM32 64C14.3 64 0 78.3 0 96l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 64zM48 368l416 0 0 32L48 400l0-32zM32 320c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 320zm-8-24c11.8 0 23.1-2.9 33.1-6.3c8.8-3 17.8-6.8 26.1-10.3c0 0 0 0 0 0l3.1-1.3c19.6-8.3 35.3-14.1 49.7-14.1c18.2 0 30.9 5.7 48.7 13.8C202.6 286 224.7 296 256 296s53.4-10 71.3-18.2c17.8-8.1 30.5-13.8 48.7-13.8c14.4 0 30.1 5.9 49.7 14.1l3.1 1.3s0 0 0 0c8.3 3.5 17.3 7.3 26.1 10.3c9.9 3.4 21.3 6.3 33.1 6.3c13.3 0 24-10.7 24-24s-10.7-24-24-24c-4.2 0-9.9-1.1-17.7-3.7c-7-2.4-14.3-5.5-22.8-9.1c0 0 0 0 0 0l-3.1-1.3C425.9 226.1 401.6 216 376 216c-28.8 0-49.9 9.6-66.9 17.4l-1.7 .8C290.1 242 276.2 248 256 248s-34.1-6-51.4-13.8l-1.7-.8c-17-7.8-38.1-17.4-66.9-17.4c-25.6 0-49.9 10.1-68.3 17.9l-3.2 1.3s0 0 0 0c-8.5 3.6-15.9 6.7-22.8 9.1C33.9 246.9 28.2 248 24 248c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faPesetaSign = {
  prefix: 'far',
  iconName: 'peseta-sign',
  icon: [384, 512, [], "e221", "M93.9 32C68.6 32 48 52.6 48 77.9L48 176l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 104 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 96 0c77.4 0 142-55 156.8-128l11.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8.8 0C343.2 95.1 275 32 192 32L93.9 32zM302.9 176L96 176l0-96 96 0c56.4 0 103.1 41.7 110.9 96zM96 224l203.4 0c-13.8 46.3-56.6 80-107.4 80l-96 0 0-80z"]
};
const faSquareParkingSlash = {
  prefix: 'far',
  iconName: 'square-parking-slash',
  icon: [640, 512, ["parking-slash"], "f617", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9l320 0c8.8 0 16 7.2 16 16l0 267.5L408.6 295c19.3-17.6 31.4-42.9 31.4-71c0-53-43-96-96-96l-80 0c-16.5 0-30.2 12.6-31.8 28.7L145.7 88.9zM369.8 264.5L280 194.2l0-18.2 64 0c26.5 0 48 21.5 48 48c0 17-8.9 32-22.2 40.5zM426.5 432L160 432c-8.8 0-16-7.2-16-16l0-206.5L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4L426.5 432zM232 278.8l0 17.2 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-32 0-3.4-48-37.8z"]
};
const faParkingSlash = faSquareParkingSlash;
const faTrainTunnel = {
  prefix: 'far',
  iconName: 'train-tunnel',
  icon: [512, 512, [], "e454", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232C512 114.6 397.4 0 256 0S0 114.6 0 256L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232zm304-48l0 48-192 0 0-48c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32zM160 368l0-64 192 0 0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32zm32-240c-44.2 0-80 35.8-80 80l0 160c0 27.7 14.1 52.2 35.5 66.5L111 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 108.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-36.5-36.5C385.9 420.2 400 395.7 400 368l0-160c0-44.2-35.8-80-80-80l-128 0zm96 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faHeading = {
  prefix: 'far',
  iconName: 'heading',
  icon: [448, 512, ["header"], "f1dc", "M0 56C0 42.7 10.7 32 24 32l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 144 240 0 0-144-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 168 0 184 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-160-240 0 0 160 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-184L56 80 24 80C10.7 80 0 69.3 0 56z"]
};
const faHeader = faHeading;
const faGhost = {
  prefix: 'far',
  iconName: 'ghost',
  icon: [384, 512, [128123], "f6e2", "M48 192l0 223.5c26.3-4.9 54.6 3.7 73.6 25.5l6.4 7.3 3.8-4.3c31.9-36.4 88.5-36.4 120.4 0l3.8 4.3 6.4-7.3c19.1-21.8 47.3-30.4 73.6-25.5L336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zM256 512c-5.1 0-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L85.5 472.5c-11.6-13.3-32.1-14-44.5-1.5l-2.3 2.3c-4.2 4.2-10 6.6-16 6.6C10.1 480 0 469.9 0 457.4L0 192C0 86 86 0 192 0S384 86 384 192l0 265.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6l-2.3-2.3c-12.5-12.5-32.9-11.8-44.5 1.5L269.3 506c-3.3 3.8-8.2 6-13.3 6zM96 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faFaceAnguished = {
  prefix: 'far',
  iconName: 'face-anguished',
  icon: [512, 512, [], "e369", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faHockeySticks = {
  prefix: 'far',
  iconName: 'hockey-sticks',
  icon: [640, 512, [], "f454", "M173.3 13L302 261.7 288.4 288l-26.9 0L130.7 35C124.6 23.3 129.2 8.8 141 2.7s26.3-1.5 32.3 10.3zM373.1 368l24.8-48L576 320c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-154.8 0c-26.9 0-51.6-15-64-38.9L338 435.9l27-52.2L399.9 451c4.1 8 12.3 13 21.3 13l74.8 0 0-96-122.9 0zM544 368l0 96 32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l240 0c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368l-139 0 0 96 74.8 0c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0 0-96-32 0z"]
};
const faAbacus = {
  prefix: 'far',
  iconName: 'abacus',
  icon: [576, 512, [129518], "f640", "M512 80c8.8 0 16 7.2 16 16l0 112-80 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 64 0zm-96 48l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-128 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 128 0 0 48zm-160 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-96 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 96 0 0 48zm-128 0l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-80 0L48 96c0-8.8 7.2-16 16-16l64 0 0 48zM48 416l0-176 80 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-64 0c-8.8 0-16-7.2-16-16zm112-32l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 96 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 24-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-96 0 0-48zm128-72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24 128 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 48-128 0 0-48 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24zm160 72l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 80 0 0 176c0 8.8-7.2 16-16 16l-64 0 0-48zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faFilmSimple = {
  prefix: 'far',
  iconName: 'film-simple',
  icon: [512, 512, ["film-alt"], "f3a0", "M160 432l192 0 0-112 0-128 0-112L160 80l0 112 0 128 0 112zM112 80L64 80c-8.8 0-16 7.2-16 16l0 72 64 0 0-88zm0 136l-64 0 0 80 64 0 0-80zm0 128l-64 0 0 72c0 8.8 7.2 16 16 16l48 0 0-88zM400 80l0 88 64 0 0-72c0-8.8-7.2-16-16-16l-48 0zm64 136l-64 0 0 80 64 0 0-80zm0 128l-64 0 0 88 48 0c8.8 0 16-7.2 16-16l0-72zM64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z"]
};
const faFilmAlt = faFilmSimple;
const faList = {
  prefix: 'far',
  iconName: 'list',
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]
};
const faListSquares = faList;
const faTreePalm = {
  prefix: 'far',
  iconName: 'tree-palm',
  icon: [576, 512, [127796], "f82b", "M102.9 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2c-71 71-60.2 151-32.7 191.3c5 7.3 15.2 7.3 21.4 1L236 219.3c2.3 9.3 4.3 20.3 5.6 32.9c4.9 46.6 .5 115.1-26.4 208.3c-7.3 25.3 11.3 51.5 38.5 51.5l84.1 0c20 0 37.6-15 39.6-35.7c9.2-95.5-5.9-202-34.3-284.3l103.5 0c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4.1 3.9 6.9 3.9l46.7 0c8.8 0 16.1-7.2 14.4-15.9C565.3 128.2 516.4 64 416 64c-43.7 0-77.6 12.2-102.8 29.8C296.5 49.4 248 0 160 0C59.6 0 10.7 64.2 1.6 112.1C-.1 120.8 7.2 128 16 128l46.7 0c2.8 0 5.4-1.5 6.9-3.9L89.1 91.4c3.1-5.2 10.6-5.2 13.7 0zM292 192c28.6 74.1 46 177.9 38.3 272l-66.2 0c25.8-92.9 30.7-164.5 25.2-216.8c-2.2-21.5-6.2-39.9-11.4-55.2l14.1 0z"]
};
const faSquarePhoneFlip = {
  prefix: 'far',
  iconName: 'square-phone-flip',
  icon: [448, 512, ["phone-square-alt"], "f87b", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM293.3 128.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"]
};
const faPhoneSquareAlt = faSquarePhoneFlip;
const faUserBeardBolt = {
  prefix: 'far',
  iconName: 'user-beard-bolt',
  icon: [576, 512, [], "e689", "M198.9 0L224 0l25.1 0C305.9 0 352 46.1 352 102.9c0 6 1 12 3.1 17.6l25.2 69.3c2.4 6.7 3.7 13.8 3.7 21c0 24.6-14.6 46-35.7 55.7c2.4 6.7 3.7 14 3.7 21.5c0 15.2-5.3 29.3-14.2 40.2C326 342.7 308.1 352 288 352c-6.3 0-12.4-.9-18.2-2.6c-.8-.2-1.6-.5-2.4-.8c-3.4 7.1-8.4 13.2-14.7 17.9c-.7 .5-1.4 1-2.2 1.5c-7.6 5.1-16.7 8-26.5 8s-18.9-2.9-26.5-8c-7.2-4.8-13.1-11.5-16.8-19.4c-6.5 2.2-13.4 3.4-20.6 3.4c-19.9 0-37.6-9.1-49.4-23.3l-.4-.5c-8.9-11-14.2-25-14.2-40.2c0-7.5 1.3-14.8 3.7-21.5c-21.1-9.7-35.7-31-35.7-55.7c0-7.1 1.2-14.3 3.7-21l25.2-69.3c2-5.6 3.1-11.6 3.1-17.6C96 46.1 142.1 0 198.9 0zm98.4 96L280 96c-24.1 0-45.1-13.3-56-33c-10.9 19.7-31.9 33-56 33l-17.3 0c-4.3 9.8-6.7 20.6-6.7 32l0 16c0 12.5 2.9 24.4 8 35c.9-.5 1.8-1.1 2.6-1.8l.6-.6c18.2-18.2 43-28.5 68.8-28.5s50.5 10.2 68.8 28.5l.6 .6c.8 .8 1.6 1.4 2.6 1.8c5.1-10.6 8-22.4 8-35l0-16c0-11.4-2.4-22.2-6.7-32zM269.8 209.6c-1.6-1.3-3.2-2.7-4.7-4.2l-.6-.6C253.7 194 239.2 188 224 188s-29.7 6-40.5 16.8l-.6 .6c-1.5 1.5-3.1 2.9-4.7 4.2c2.6 1.8 5.2 3.4 8 4.9c11.3 6.1 24.2 9.5 37.9 9.5s26.6-3.4 37.9-9.5c2.8-1.5 5.4-3.1 8-4.9zm268.2 18c5.8 4.7 7.6 12.9 4.2 19.6L489.9 352l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L438.1 384 368 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1zM362.3 464l-5.3 10.5c-6 12-6.5 25.5-2.3 37.5l-324 0C13.8 512 0 498.2 0 481.3c0-59.6 32.3-111.7 80.4-139.6c9.9 14.7 23.8 26.5 40.1 33.8c-37.3 14.4-65 47.9-71.2 88.5l313 0z"]
};
const faCartPlus = {
  prefix: 'far',
  iconName: 'cart-plus',
  icon: [576, 512, [], "f217", "M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 48l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faGamepad = {
  prefix: 'far',
  iconName: 'gamepad',
  icon: [640, 512, [], "f11b", "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144l256 0c79.5 0 144-64.5 144-144s-64.5-144-144-144l-256 0zM0 256C0 150 86 64 192 64l256 0c106 0 192 86 192 192s-86 192-192 192l-256 0C86 448 0 362 0 256zm232-56l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faBorderCenterV = {
  prefix: 'far',
  iconName: 'border-center-v',
  icon: [448, 512, [], "f89d", "M448 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 352A32 32 0 1 0 0 352a32 32 0 1 0 64 0zM384 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 160A32 32 0 1 0 0 160a32 32 0 1 0 64 0zm320 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 256A32 32 0 1 0 0 256a32 32 0 1 0 64 0zM384 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64zM64 448A32 32 0 1 0 0 448a32 32 0 1 0 64 0zM288 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM288 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 64A32 32 0 1 0 96 64a32 32 0 1 0 64 0zM96 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm40 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400z"]
};
const faCircleDot = {
  prefix: 'far',
  iconName: 'circle-dot',
  icon: [512, 512, [128280, "dot-circle"], "f192", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faDotCircle = faCircleDot;
const faClipboardMedical = {
  prefix: 'far',
  iconName: 'clipboard-medical',
  icon: [384, 512, [], "e133", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 160l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faFaceDizzy = {
  prefix: 'far',
  iconName: 'face-dizzy',
  icon: [512, 512, ["dizzy"], "f567", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faDizzy = faFaceDizzy;
const faEgg = {
  prefix: 'far',
  iconName: 'egg',
  icon: [384, 512, [129370], "f7fb", "M192 448c-74.7 0-144-75.4-144-160c0-48.3 14.1-107.7 41.3-153.5C116.4 88.8 151.1 64 192 64s75.6 24.8 102.7 70.5C321.9 180.3 336 239.7 336 288c0 84.6-69.3 160-144 160zM0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zM170.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"]
};
const faUpToLine = {
  prefix: 'far',
  iconName: 'up-to-line',
  icon: [384, 512, ["arrow-alt-to-top"], "f34d", "M82.2 288L192 178 301.8 288 248 288c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM192 128c-11.5 0-22.5 4.6-30.6 12.7L45.6 256.8C36.9 265.5 32 277.3 32 289.6C32 315.2 52.8 336 78.4 336l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM24 80l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80z"]
};
const faArrowAltToTop = faUpToLine;
const faHouseMedicalCircleXmark = {
  prefix: 'far',
  iconName: 'house-medical-circle-xmark',
  icon: [640, 512, [], "e513", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"]
};
const faWatchFitness = {
  prefix: 'far',
  iconName: 'watch-fitness',
  icon: [384, 512, [], "f63e", "M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM93.7 226.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z"]
};
const faClockNineThirty = {
  prefix: 'far',
  iconName: 'clock-nine-thirty',
  icon: [512, 512, [], "e34d", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-13.3-10.7-24-24-24l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faCampground = {
  prefix: 'far',
  iconName: 'campground',
  icon: [576, 512, [9978], "f6bb", "M375.4 5.6c10.2 8.5 11.5 23.6 3 33.8l-59.1 70.7L555 392.1c8.4 10.1 13 22.8 13 35.9l0 28c0 30.9-25.1 56-56 56l-224 0L64 512c-30.9 0-56-25.1-56-56l0-28c0-13.1 4.6-25.8 13-35.9L256.7 110.1 197.6 39.4c-8.5-10.2-7.1-25.3 3-33.8s25.3-7.1 33.8 3L288 72.7 341.6 8.6c8.5-10.2 23.6-11.5 33.8-3zM57.9 422.8c-1.2 1.4-1.9 3.3-1.9 5.1l0 28c0 4.4 3.6 8 8 8l62 0L269.1 281.2c4.5-5.8 11.5-9.2 18.9-9.2s14.4 3.4 18.9 9.2L450 464l62 0c4.4 0 8-3.6 8-8l0-28c0-1.9-.7-3.7-1.9-5.1L288 147.5 57.9 422.8zM187 464l101 0 101 0L288 334.9 187 464z"]
};
const faFolderPlus = {
  prefix: 'far',
  iconName: 'folder-plus',
  icon: [512, 512, [], "f65e", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faJug = {
  prefix: 'far',
  iconName: 'jug',
  icon: [448, 512, [], "f8c6", "M192 77.5c0 17.1-5.5 33.7-15.6 47.5L95.6 234.6C85.5 248.4 80 265 80 282.1l0 5.9 288 0 0-5.9c0-17.1-5.5-33.7-15.6-47.5L271.6 124.9C261.5 111.2 256 94.6 256 77.5L256 48l-64 0 0 29.5zM80 416l0 32c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-32L80 416zM304 48l0 29.5c0 6.8 2.2 13.5 6.2 19l15 20.4C338.3 104 356.2 96 376 96c39.8 0 72 32.2 72 72c0 28.9-17.1 53.9-41.6 65.3c6.3 15.4 9.6 31.9 9.6 48.8L416 448c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-165.9c0-27.3 8.7-53.9 25-75.9L137.8 96.5c4.1-5.5 6.2-12.2 6.2-19L144 48c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 64 0 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm50.7 108.9l25.6 34.8c11.2-2 19.7-11.8 19.7-23.6c0-13.3-10.7-24-24-24c-9.2 0-17.2 5.2-21.3 12.9z"]
};
const faFutbol = {
  prefix: 'far',
  iconName: 'futbol',
  icon: [512, 512, [9917, "futbol-ball", "soccer-ball"], "f1e3", "M435.4 361.4l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.2zM256 48l.9 0-1.8 0 .9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.6 2-4 2.9l4-2.9zm75.2-226.7l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"]
};
const faFutbolBall = faFutbol;
const faSoccerBall = faFutbol;
const faSnowBlowing = {
  prefix: 'far',
  iconName: 'snow-blowing',
  icon: [640, 512, [], "f761", "M176 64c13.3 0 24 10.7 24 24l0 25.4 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L200 158.6l0 55.8 48.3-27.9 12.9-48.2c2.3-8.5 11.1-13.6 19.6-11.3s13.6 11.1 11.3 19.6l-4.6 17.3 22-12.7c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8l-22 12.7 17.3 4.6c8.5 2.3 13.6 11.1 11.3 19.6s-11.1 13.6-19.6 11.3l-48.2-12.9L224 256l48.3 27.9L320.6 271c8.5-2.3 17.3 2.8 19.6 11.3s-2.8 17.3-11.3 19.6l-17.3 4.6 22 12.7c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8l-22-12.7 4.6 17.3c2.3 8.5-2.8 17.3-11.3 19.6s-17.3-2.8-19.6-11.3l-12.9-48.2L200 297.6l0 55.8 35.3 35.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L200 398.6l0 25.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.4-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L152 353.4l0-55.8-48.3 27.9L90.7 373.7c-2.3 8.5-11.1 13.6-19.6 11.3s-13.6-11.1-11.3-19.6l4.6-17.3-22 12.7C31 367.4 16.4 363.5 9.7 352s-2.7-26.2 8.8-32.8l22-12.7-17.3-4.6c-8.5-2.3-13.6-11.1-11.3-19.6s11.1-13.6 19.6-11.3l48.2 12.9L128 256 79.7 228.1 31.4 241c-8.5 2.3-17.3-2.8-19.6-11.3s2.8-17.3 11.3-19.6l17.3-4.6-22-12.7C7 186.2 3.1 171.5 9.7 160s21.3-15.4 32.8-8.8l22 12.7-4.6-17.3c-2.3-8.5 2.8-17.3 11.3-19.6s17.3 2.8 19.6 11.3l12.9 48.2L152 214.4l0-55.8-35.3-35.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L152 113.4 152 88c0-13.3 10.7-24 24-24zM480 424c0-13.3 10.7-24 24-24l48 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-48 0c-13.3 0-24-10.7-24-24zM504 64l48 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faPaintbrush = {
  prefix: 'far',
  iconName: 'paintbrush',
  icon: [576, 512, [128396, "paint-brush"], "f1fc", "M278 219.5L356.5 298 524.7 73.6c4.8-6.4 4.1-15.3-1.5-20.9s-14.5-6.3-20.9-1.5L278 219.5zM199.1 321.6c-4.9-1-9.9-1.6-15.1-1.6c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9 85.6 0c39.8 0 72-32.2 72-72c0-5.2-.5-10.2-1.6-15.1l-55.4-55.4zM384 341.3c-19.1 25.5-48.6 41.1-80.3 42.6c.2 2.7 .3 5.4 .3 8.1c0 66.3-53.7 120-120 120L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6 0c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c2.7 0 5.4 .1 8.1 .3c1.5-31.7 17-61.1 42.5-80.3L473.5 12.8C499-6.3 534.6-3.8 557.2 18.7s25.1 58.2 6 83.7L384 341.3z"]
};
const faPaintBrush = faPaintbrush;
const faLock = {
  prefix: 'far',
  iconName: 'lock',
  icon: [448, 512, [128274], "f023", "M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z"]
};
const faArrowDownFromLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-line',
  icon: [384, 512, [8615, "arrow-from-top"], "f345", "M174.5 472.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 395.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 303.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136zM360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0z"]
};
const faArrowFromTop = faArrowDownFromLine;
const faGasPump = {
  prefix: 'far',
  iconName: 'gas-pump',
  icon: [512, 512, [9981], "f52f", "M256 48c8.8 0 16 7.2 16 16l0 128L80 192 80 64c0-8.8 7.2-16 16-16l160 0zm16 192l0 224L80 464l0-224 192 0zM32 64l0 400-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 48 0 192 0 48 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160 8 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-220.1c0-19.1-7.6-37.4-21.1-50.9L417 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33 0 62.1c0 29.8 20.4 54.9 48 62l0 154c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-8 0 0-192c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64z"]
};
const faSignalBarsSlash = {
  prefix: 'far',
  iconName: 'signal-bars-slash',
  icon: [640, 512, ["signal-alt-slash"], "f694", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-22.9-17.9c.1-1 .1-2.1 .1-3.2l0-384c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 286.9-24-18.8L456 192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 39.8L38.8 5.1zM376 269.4l0-77.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 102.5-32-25.1zM528 388.5L528 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 349.6-32-25.1zM544.4 512l-.4 0s0 0 0 0l.4 0zM408 417.5l0 30.5c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.8-48-37.8 0 93.6c0 35.3 28.7 64 64 64c33 0 60.1-25 63.6-57L408 417.5zM211.5 262.7C190.5 273.1 176 294.9 176 320l0 128c0 35.3 28.7 64 64 64s64-28.7 64-64l0-112.5-92.5-72.9zM256 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128zm-144 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
const faSignalAltSlash = faSignalBarsSlash;
const faMonkey = {
  prefix: 'far',
  iconName: 'monkey',
  icon: [576, 512, [128018], "f6fb", "M160 416c0-91.5 54.8-170.2 133.5-204.9c7.3 15.1 17.2 28.6 29.3 39.9C255.7 275.8 208 340.4 208 416l0 48 192 0 0-24c0-39.8-32.2-72-72-72l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c27 0 51.9 8.9 72 24l0-24 0-32.9c5.2 .6 10.6 .9 16 .9c11 0 21.7-1.3 32-3.8l0 1.8 83.5 83.5C560 398 576 436.7 576 477l0 11c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11c0-27.6-11-54-30.5-73.5L448 353.9l0 86.1 0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-192 0-48 0-8 0C68.1 512 0 443.9 0 360L0 120C0 53.7 53.7 0 120 0l8 0c53 0 96 43 96 96s-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-8 0c-39.8 0-72 32.2-72 72l0 240c0 57.4 46.6 104 104 104l8 0 0-48zM448 251c-10.1 3.3-20.8 5-32 5c-5.4 0-10.8-.4-16-1.2c-13.5-2.1-26.1-6.8-37.4-13.5c-16.4-9.8-29.9-24.1-38.8-41.1c-1.4-2.7-2.7-5.4-3.8-8.2c-35.3 0-64-28.7-64-64s28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64s-28.6 64-64 64c-11.6 27.9-35 49.6-64 59zM384 64c-26.5 0-48 21.5-48 48c0 20.8 13.2 38.4 31.6 45.1c4.7 1.7 8.4 5.9 8.4 10.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-5 3.7-9.2 8.4-10.9c18.5-6.7 31.6-24.4 31.6-45.1c0-26.5-21.5-48-48-48l-64 0zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faRectanglePro = {
  prefix: 'far',
  iconName: 'rectangle-pro',
  icon: [640, 512, ["pro"], "e235", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm104 64l56 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80c0-13.3 10.7-24 24-24zm56 80c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32 32 0zm80-56c0-13.3 10.7-24 24-24l56 0c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.7 52.7l24.1 38.5c7 11.2 3.6 26-7.6 33.1s-26 3.6-33.1-7.6l-33-52.7L288 288l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-80zm48 56l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 32zm200-80c48.6 0 88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16c0-48.6 39.4-88 88-88zm-40 88l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z"]
};
const faPro = faRectanglePro;
const faHouseNight = {
  prefix: 'far',
  iconName: 'house-night',
  icon: [640, 512, [], "e010", "M125.2 16.1c6.2-4.4 5.4-14.8-2.2-15.6c-3.6-.4-7.3-.5-11-.5C50.1 0 0 50.1 0 112s50.1 112 112 112c32.1 0 61.1-13.5 81.5-35.2c5.2-5.6-1-14-8.6-13.2c-2.9 .3-5.9 .4-9 .4c-48.6 0-88-39.4-88-88c0-29.7 14.7-55.9 37.2-71.9zm289.9 85.3c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4 224 456c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-161.6 24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3L528 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-200.7L400 151 528 255.3zM352 312l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM248.5 12.3L236.6 44.6 204.3 56.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15L275.4 44.6 263.5 12.3c-2.6-7-12.4-7-15 0zm-145 320c-2.6-7-12.4-7-15 0L76.6 364.6 44.3 376.5c-7 2.6-7 12.4 0 15l32.3 11.9 11.9 32.3c2.6 7 12.4 7 15 0l11.9-32.3 32.3-11.9c7-2.6 7-12.4 0-15l-32.3-11.9-11.9-32.3z"]
};
const faHotTubPerson = {
  prefix: 'far',
  iconName: 'hot-tub-person',
  icon: [512, 512, ["hot-tub"], "f593", "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336l0 112c0 8.8 7.2 16 16 16l48 0 0-160-64 0 0 16 0 16zM160 464l72 0 0-160-72 0 0 160zm120 0l72 0 0-160-72 0 0 160zm-2.7-208l98.7 0 24 0 48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 336l0-16 0-40 0-24c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256l88 0 40 0-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6c-26.5 0-48 21.5-48 48zm352 48l0 160 48 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-48 0zM272 24l0 5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2l0 13.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2l0-5.2c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2l0 13.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.2c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2l0-5.2c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHotTub = faHotTubPerson;
const faGlobePointer = {
  prefix: 'far',
  iconName: 'globe-pointer',
  icon: [512, 512, [], "e60e", "M303.6 415.6C283 456.8 263.4 464 256 464c-3.1 0-8.3-1.3-14.8-5.7l-15.3 52c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 10.2 .6 20.2 1.8 30.1l46.9-13.8c-.4-5.4-.6-10.8-.6-16.3c0-16.5 1.9-32.6 5.6-48l76.7 0c-1.3 13.3-2 27-2.2 41l48.4-14.2c.4-9.1 1.1-18 2-26.7l155 0c1.6 15.3 2.5 31.4 2.5 48s-.9 32.7-2.5 48l-47 0-14.1 48 53.2 0c-5.6 24.4-13.2 45.9-22 63.6zM208.4 96.4C229 55.2 248.6 48 256 48s27 7.2 47.6 48.4c8.8 17.7 16.4 39.2 22 63.6l-139.2 0c5.6-24.4 13.2-45.9 22-63.6zM384 256c0-16.4-.8-32.5-2.2-48l76.7 0c3.6 15.4 5.6 31.5 5.6 48s-1.9 32.6-5.6 48l-76.7 0c1.5-15.5 2.2-31.6 2.2-48zm-9.3-96c-7.3-35.9-18.5-67.7-32.6-93.4c42.3 19.3 77 52.3 98.4 93.4l-65.9 0zM71.4 160c21.4-41.1 56.1-74.1 98.4-93.4c-14.1 25.6-25.3 57.5-32.6 93.4l-65.9 0zM374.7 352l65.9 0c-21.4 41.1-56.1 74.1-98.4 93.4c14.1-25.6 25.3-57.5 32.6-93.4zM39 308.5c-13.9 4.1-15.6 23.2-2.6 29.7l57.3 28.7c1.3 .7 2.6 1.5 3.7 2.5l-88 88c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l88-88c1 1.1 1.9 2.3 2.5 3.7l28.7 57.3c6.5 13 25.6 11.3 29.7-2.6l60.2-204.8c3.6-12.1-7.7-23.4-19.9-19.9L39 308.5z"]
};
const faBlanket = {
  prefix: 'far',
  iconName: 'blanket',
  icon: [448, 512, [], "f498", "M48 144l0 132.1C66.1 263.4 88.2 256 112 256l268 0c7 0 13.7 1 20 3l0-115c0-35.3-28.7-64-64-64L112 80c-35.3 0-64 28.7-64 64zM0 368L0 144C0 82.1 50.1 32 112 32l224 0c61.9 0 112 50.1 112 112l0 176-.1 0c.1 1.3 .1 2.7 .1 4c0 37.6-30.4 68-68 68l-260 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l260 0c11 0 20-9 20-20s-9-20-20-20l-268 0c-35.3 0-64 28.7-64 64s28.7 64 64 64l312 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-312 0C50.1 480 0 429.9 0 368z"]
};
const faMapLocation = {
  prefix: 'far',
  iconName: 'map-location',
  icon: [576, 512, ["map-marked"], "f59f", "M403 148.6c3.2-10.3 5-20 5-28.6C408 53.7 354.3 0 288 0C226.4 0 175.6 46.4 168.8 106.2c-.5 4.5-.8 9.1-.8 13.8c0 10.3 2.6 22 7 34.6c.7 2.1 1.5 4.2 2.3 6.3c10.4 27 28.3 57.1 46.7 84.4c18.1 26.9 36.7 51.1 49.2 66.6c7.7 9.6 22 9.6 29.6 0c12.4-15.5 31.1-39.7 49.2-66.6c.1-.2 .3-.4 .4-.6c4.6-6.8 9.1-13.7 13.5-20.8c3.3-5.3 6.5-10.7 9.6-16l.1-.2c11.8-20.4 21.8-40.8 27.4-59.2zm-8.3 89.6c-13.9 22.5-29.1 44.2-42.7 62.4l0 153.1L224 407.2l0-106.6c-13.5-18.2-28.8-39.9-42.7-62.4c-1.8-2.9-3.6-5.8-5.3-8.8l0 177.7L48 453.7l0-252.9 96.9-35.2c-5.2-14.9-8.9-30.5-8.9-45.6c0-.8 0-1.5 0-2.3L15.8 161.4C6.3 164.9 0 173.9 0 184L0 488c0 7.8 3.8 15.2 10.2 19.7s14.6 5.6 22 2.9l167.8-61 167.8 61c5.3 1.9 11.1 1.9 16.4 0l176-64c9.5-3.4 15.8-12.5 15.8-22.6l0-304c0-7.8-3.8-15.2-10.2-19.7s-14.6-5.6-22-2.9l-105 38.2c-2.2 15-7.3 30.2-13.2 44.2c-2 4.6-4.1 9.3-6.3 14L528 154.3l0 252.9L400 453.7l0-224.3c-1.8 3-3.5 5.9-5.3 8.8z"]
};
const faMapMarked = faMapLocation;
const faHouseFloodWater = {
  prefix: 'far',
  iconName: 'house-flood-water',
  icon: [576, 512, [], "e50e", "M301.9 4.4c-8.3-5.9-19.4-5.9-27.7 0l-192 136c-10.8 7.7-13.4 22.6-5.7 33.5s22.6 13.4 33.5 5.7l2.1-1.5 0 80.4c7.3 1.9 14.4 5.1 20.9 9.6c8.4 5.8 17.7 10.6 27.1 14.1l0-138.1L288 53.4l128 90.7 0 138.1c9.5-3.5 18.8-8.3 27.2-14.1c6.5-4.5 13.5-7.8 20.8-9.6l0-80.4 2.1 1.5c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5l-192-136zM80 318.1C62.8 333 41 344.8 18.8 349.8C5.9 352.7-2.3 365.5 .6 378.5s15.7 21.1 28.7 18.2C58 390.2 81.6 376.2 96 366.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm31.9 112c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faCommentsQuestionCheck = {
  prefix: 'far',
  iconName: 'comments-question-check',
  icon: [640, 512, [], "e14f", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.8 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480zM184.3 86.3c-16.4 0-31 10.3-36.4 25.7l-.3 .9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4l41.3 0c6.5 0 11.7 5.3 11.7 11.7c0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9l0 9.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-.3L247.4 168c13.6-7.8 22-22.3 22-37.9c0-24.2-19.6-43.7-43.7-43.7l-41.3 0zM208 266.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3zm331.3 22c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L431.4 374c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3z"]
};
const faTree = {
  prefix: 'far',
  iconName: 'tree',
  icon: [448, 512, [127794], "f1bb", "M241.8 7.9C237.3 2.9 230.8 0 224 0s-13.3 2.9-17.8 7.9l-144 160c-6.3 7-7.9 17.2-4.1 25.8S70.5 208 80 208l11.8 0-62 72.4c-6.1 7.1-7.5 17.1-3.6 25.6s12.4 14 21.8 14l24 0L4.8 409.6c-5.5 7.3-6.3 17-2.3 25.1S14.9 448 24 448l136 0 40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0 136 0c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1L376 320l24 0c9.4 0 17.9-5.5 21.8-14s2.5-18.5-3.6-25.6l-62-72.4 11.8 0c9.5 0 18.1-5.6 21.9-14.2s2.3-18.8-4.1-25.8l-144-160zM248 400l0-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 184-40 0-88 0 67.2-89.6c5.5-7.3 6.3-17 2.3-25.1s-12.4-13.3-21.5-13.3l-19.8 0 62-72.4c6.1-7.1 7.5-17.1 3.6-25.6s-12.4-14-21.8-14l-10.1 0L224 59.9 314.1 160 304 160c-9.4 0-17.9 5.5-21.8 14s-2.5 18.5 3.6 25.6l62 72.4L328 272c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1L376 400l-88 0-40 0z"]
};
const faArrowsCross = {
  prefix: 'far',
  iconName: 'arrows-cross',
  icon: [448, 512, [], "e0a2", "M296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.1 0L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l359-359 0 70.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24L296 32zM41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73L167.4 233.4l33.9-33.9L41 39zM246.6 312.6L366.1 432 296 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.1L280.6 278.6l-33.9 33.9z"]
};
const faBackpack = {
  prefix: 'far',
  iconName: 'backpack',
  icon: [448, 512, [127890], "f5d4", "M192 48l64 0c4.4 0 8 3.6 8 8l0 24-80 0 0-24c0-4.4 3.6-8 8-8zm-56 8l0 24-8 0C57.3 80 0 137.3 0 208L0 448c0 35.3 28.7 64 64 64l40 0 240 0 40 0c35.3 0 64-28.7 64-64l0-240c0-70.7-57.3-128-128-128l-8 0 0-24c0-30.9-25.1-56-56-56L192 0c-30.9 0-56 25.1-56 56zM368 464l0-88 0-64c0-39.8-32.2-72-72-72l-144 0c-39.8 0-72 32.2-72 72l0 64 0 88-16 0c-8.8 0-16-7.2-16-16l0-240c0-44.2 35.8-80 80-80l32 0 128 0 32 0c44.2 0 80 35.8 80 80l0 240c0 8.8-7.2 16-16 16l-16 0zm-240 0l0-64 192 0 0 64-192 0zm16-304c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0zM320 352l-192 0 0-40c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 40z"]
};
const faSquareSmall = {
  prefix: 'far',
  iconName: 'square-small',
  icon: [320, 512, [], "e27e", "M256 144c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l192 0zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L64 96z"]
};
const faFolderArrowUp = {
  prefix: 'far',
  iconName: 'folder-arrow-up',
  icon: [512, 512, ["folder-upload"], "e054", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM280 376l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faFolderUpload = faFolderArrowUp;
const faBridgeLock = {
  prefix: 'far',
  iconName: 'bridge-lock',
  icon: [640, 512, [], "e4cc", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 193.6 0c20.2-19.8 47.9-32 78.4-32c27.3 0 52.4 9.8 71.8 26.1c5-4.4 8.2-10.9 8.2-18.1c0-13.3-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c24.9 0 45.9 16.2 53.2 38.6c5.5-12.6 14.9-23.2 26.8-30l0-19c-19.1-22.9-47.8-37.5-80-37.5zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faCrosshairsSimple = {
  prefix: 'far',
  iconName: 'crosshairs-simple',
  icon: [512, 512, [], "e59f", "M462.6 232L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.6 0c-11 95.7-86.9 171.6-182.6 182.6l0-70.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.6C136.3 451.6 60.4 375.7 49.4 280l70.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-70.6 0C60.4 136.3 136.3 60.4 232 49.4l0 70.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-70.6c95.7 11 171.6 86.9 182.6 182.6zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256z"]
};
const faSackDollar = {
  prefix: 'far',
  iconName: 'sack-dollar',
  icon: [512, 512, [128176], "f81d", "M218.7 152l74.6 0 13.8 8.8C361.1 195.4 464 277 464 416c0 26.5-21.5 48-48 48L96 464c-26.5 0-48-21.5-48-48c0-139 102.9-220.6 156.9-255.2l13.8-8.8zM286 104l-60 0-7.5-10.8L187.4 48l137.2 0L293.5 93.2 286 104zM150.8 139.9C89.4 185.5 0 274.8 0 416c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-141.2-89.4-230.5-150.8-276.1c-10.4-7.7-20-14.2-28.2-19.4l27.3-39.5 29.8-43.2C401 21.7 389.6 0 370.3 0L141.7 0C122.4 0 111 21.7 121.9 37.6l29.8 43.2L179 120.4c-8.2 5.3-17.8 11.7-28.2 19.4zM276 216c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
};
const faPenToSquare = {
  prefix: 'far',
  iconName: 'pen-to-square',
  icon: [512, 512, ["edit"], "f044", "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"]
};
const faEdit = faPenToSquare;
const faSquareSliders = {
  prefix: 'far',
  iconName: 'square-sliders',
  icon: [448, 512, ["sliders-h-square"], "f3f0", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 80c0-13.3 10.7-24 24-24l32 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24zm24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l128 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-128 0z"]
};
const faSlidersHSquare = faSquareSliders;
const faCarSide = {
  prefix: 'far',
  iconName: 'car-side',
  icon: [640, 512, [128663], "f5e4", "M171.3 80L224 80l0 16 0 80 0 16L99.4 192l34.7-86.9C140.3 90 155 80 171.3 80zM272 192l0-16 0-80 0-16 81.2 0c12.2 0 23.6 5.5 31.2 15l77.6 97L272 192zm252 .6L422 65c-16.7-20.9-42-33-68.7-33L171.3 32c-36 0-68.3 21.9-81.7 55.3l-42.8 107C19.8 201.8 0 226.6 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-66.7-50.9-121.4-116-127.4zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zm135.8-16c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-138.9 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64L48 352l0-96c0-8.8 7.2-16 16-16l448 0c44.2 0 80 35.8 80 80l0 32-21.5 0zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faMessageMiddleTop = {
  prefix: 'far',
  iconName: 'message-middle-top',
  icon: [512, 512, ["comment-middle-top-alt"], "e1e2", "M343.5 144L448 144c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l104.5 0c14.2 0 27.8-6.3 36.9-17.3L256 66l50.6 60.7c9.1 10.9 22.6 17.3 36.9 17.3zm-175-48L64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L343.5 96 268.3 5.8C265.3 2.1 260.7 0 256 0s-9.3 2.1-12.3 5.8L168.5 96z"]
};
const faCommentMiddleTopAlt = faMessageMiddleTop;
const faLightbulbOn = {
  prefix: 'far',
  iconName: 'lightbulb-on',
  icon: [640, 512, [], "f672", "M69.3 4C58.3-3.3 43.4-.3 36 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L69.3 4zM597.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM117.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm432-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM400 432l0-16-160 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80z"]
};
const faKnife = {
  prefix: 'far',
  iconName: 'knife',
  icon: [512, 512, ["utensil-knife"], "f2e4", "M451.4 10.8C458.1 3.9 467.2 0 476.8 0C496.2 0 512 15.8 512 35.2l0 48.4c0 65.5-25.9 128.4-72.1 174.9l-70.2 70.6c-31.2 31.4-82 31.5-113.3 .2L233.1 306 41.3 504.7c-9.2 9.5-24.4 9.8-33.9 .6s-9.8-24.4-.6-33.9L215.5 255.1 451.4 10.8zm-185 260.7l23.8 23.8c12.5 12.5 32.8 12.5 45.3-.1l70.2-70.6c37.3-37.5 58.2-88.2 58.2-141l0-16.8L266.4 271.5z"]
};
const faUtensilKnife = faKnife;
const faShareNodes = {
  prefix: 'far',
  iconName: 'share-nodes',
  icon: [448, 512, ["share-alt"], "f1e0", "M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faShareAlt = faShareNodes;
const faDisplayChartUpCircleDollar = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-dollar',
  icon: [640, 512, [], "e5e6", "M64 48l448 0c8.8 0 16 7.2 16 16l0 130.9c17 3.1 33.1 8.7 48 16.3L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 42.8 0c-18.3-12.9-34.1-29.2-46.3-48l-24.8 0L288 464l-35.7 0 8-48 27.7 0 27.7 0 11 0c-4.3-15.3-6.6-31.4-6.6-48l-79.6 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM480 192.7l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM472.8 335.4c-.4 .7-.9 1.6-.8 3.6c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4z"]
};
const faWaveSine = {
  prefix: 'far',
  iconName: 'wave-sine',
  icon: [640, 512, [8767], "f899", "M47.3 237.8s0 0 0 0s0 0 0 0l.1-.2 .3-1.1c.3-1 .7-2.5 1.3-4.5c1.2-4 3-9.8 5.6-16.8c5.2-14.1 13.1-32.6 24-50.9C101.2 126.6 132.9 96 176 96c33.3 0 55.6 16.4 74.1 46.2c19.5 31.3 32.6 73.9 46.9 120.8l.6 1.9c13.6 44.6 28.3 93.1 51.5 130.3C373.6 434.4 409.3 464 464 464c68.9 0 113.2-49.4 138.6-91.7c13-21.7 22.1-43.1 28-59.1c2.9-8 5.1-14.7 6.5-19.5c.7-2.4 1.3-4.3 1.6-5.6c.2-.7 .3-1.2 .4-1.6l.1-.5 0-.1c0 0 0 0 0-.1c0 0 0 0 0 0L616 280l23.3 5.8c3.2-12.9-4.6-25.9-17.5-29.1s-25.9 4.6-29.1 17.4c0 0 0 0 0 0s0 0 0 0l-.1 .2-.3 1.1c-.3 1-.7 2.5-1.3 4.5c-1.2 4-3 9.8-5.6 16.8c-5.2 14.1-13 32.6-24 50.9C538.8 385.4 507.1 416 464 416c-33.3 0-55.6-16.4-74.1-46.2C370.4 338.5 357.2 295.9 343 249l-.6-1.9C328.8 202.5 314 154 290.9 116.8C266.4 77.6 230.7 48 176 48C107.1 48 62.8 97.4 37.4 139.7c-13 21.7-22.1 43.1-28 59.1c-2.9 8-5.1 14.7-6.5 19.5c-.7 2.4-1.3 4.3-1.6 5.6c-.2 .7-.3 1.2-.4 1.6l-.1 .5 0 .1c0 0 0 0 0 .1c0 0 0 0 0 0L24 232 .7 226.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.4z"]
};
const faHeartCircleMinus = {
  prefix: 'far',
  iconName: 'heart-circle-minus',
  icon: [576, 512, [], "e4ff", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
const faCircleW = {
  prefix: 'far',
  iconName: 'circle-w',
  icon: [512, 512, [], "e12c", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM150.9 168.7c-4-12.6-17.5-19.6-30.2-15.5s-19.6 17.5-15.5 30.2l64 200c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7L256 254.7l41.1 128.6c3.2 9.9 12.4 16.7 22.9 16.7s19.7-6.7 22.9-16.7l64-200c4-12.6-2.9-26.1-15.5-30.2s-26.1 2.9-30.2 15.5L320 297.3 278.9 168.7c-3.2-9.9-12.4-16.7-22.9-16.7s-19.7 6.7-22.9 16.7L192 297.3 150.9 168.7z"]
};
const faCircleCalendar = {
  prefix: 'far',
  iconName: 'circle-calendar',
  icon: [512, 512, ["calendar-circle"], "e102", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 112c8.8 0 16 7.2 16 16l0 16 64 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c26.5 0 48 21.5 48 48l0 32 0 96c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-96 0-32c0-26.5 21.5-48 48-48l16 0 0-16c0-8.8 7.2-16 16-16zM176 320l160 0 0-96-160 0 0 96z"]
};
const faCalendarCircle = faCircleCalendar;
const faHourglassHalf = {
  prefix: 'far',
  iconName: 'hourglass-half',
  icon: [384, 512, ["hourglass-2"], "f252", "M0 24C0 10.7 10.7 0 24 0L360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445l0 19 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-19c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67l0-19-8 0C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5l184.4 0c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67l0-19L80 48l0 19c0 22.1 7 43.4 19.8 61l184.4 0z"]
};
const faHourglass2 = faHourglassHalf;
const faMicroscope = {
  prefix: 'far',
  iconName: 'microscope',
  icon: [512, 512, [128300], "f610", "M192 0c-17.7 0-32 14.3-32 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32c0-17.7-14.3-32-32-32L192 0zM176 272l0-192 64 0 0 192-64 0zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l296 0 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41 0c39.9-35.2 65-86.7 65-144c0-106-86-192-192-192c0 0 0 0 0 0l0 48s0 0 0 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c0 0 0 0 0 0L24 464zm72-56c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z"]
};
const faSunset = {
  prefix: 'far',
  iconName: 'sunset',
  icon: [576, 512, [127751], "f767", "M305 217c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80zm88.3 8.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464l58.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l58.1 0L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464l36.7 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l36.7 0 43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48l124 0z"]
};
const faSink = {
  prefix: 'far',
  iconName: 'sink',
  icon: [512, 512, [], "e06d", "M280 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24c0-48.6-39.4-88-88-88s-88 39.4-88 88l0 200-72 0 0-24c0-30.9-25.1-56-56-56l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 24-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l232 0 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-24c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 24-72 0 0-200zM32 368l0 24c0 66.3 53.7 120 120 120l208 0c66.3 0 120-53.7 120-120l0-24-48 0 0 24c0 39.8-32.2 72-72 72l-208 0c-39.8 0-72-32.2-72-72l0-24-48 0z"]
};
const faCalendarExclamation = {
  prefix: 'far',
  iconName: 'calendar-exclamation',
  icon: [448, 512, [], "f334", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zM256 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z"]
};
const faTruckContainerEmpty = {
  prefix: 'far',
  iconName: 'truck-container-empty',
  icon: [640, 512, [], "e2b5", "M432 168c0-13.3 10.7-24 24-24l72.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l-16 0-144 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-96 0-88zm103 26.9c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faHandHeart = {
  prefix: 'far',
  iconName: 'hand-heart',
  icon: [512, 512, [], "f4bc", "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 176c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L112 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9L432 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L352 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L240 232zm-32 96.8c0-22.6 18.3-40.8 40.8-40.8c10.8 0 21.2 4.3 28.9 12l5 5 5-5c7.7-7.7 18-12 28.9-12c22.6 0 40.8 18.3 40.8 40.8c0 10.8-4.3 21.2-12 28.9l-55.2 55.2c-4.2 4.2-10.9 4.2-15.1 0L220 357.7c-7.7-7.7-12-18-12-28.9z"]
};
const faBagShopping = {
  prefix: 'far',
  iconName: 'bag-shopping',
  icon: [448, 512, ["shopping-bag"], "f290", "M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96l-64 0 0 208c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208-64 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-128 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zm0-48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0z"]
};
const faShoppingBag = faBagShopping;
const faArrowDownZA = {
  prefix: 'far',
  iconName: 'arrow-down-z-a',
  icon: [576, 512, ["sort-alpha-desc", "sort-alpha-down-alt"], "f881", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM352 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l74.6 0L334.1 184.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 224 352 224l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-74.6 0L497.9 71.9c6.3-7.1 7.8-17.2 4-25.8S489.4 32 480 32L352 32zm64 240c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 440l85.2 0c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160c-4.1-8.1-12.4-13.3-21.5-13.3zM394.8 392L416 349.7 437.2 392l-42.3 0z"]
};
const faSortAlphaDesc = faArrowDownZA;
const faSortAlphaDownAlt = faArrowDownZA;
const faMitten = {
  prefix: 'far',
  iconName: 'mitten',
  icon: [448, 512, [], "f7b5", "M0 142.6C0 63.8 63.8 0 142.6 0c63.7 0 119.6 42.2 137.1 103.4l21.4 75c15.7-11.8 35-18.4 55.2-18.4l4.5 0c48.2 0 87.3 39.1 87.3 87.3c0 21.9-8.3 43.1-23.1 59.2L353.3 384 304 384l0-8c0-6 2.3-11.8 6.4-16.3l79.2-85.8c6.7-7.3 10.4-16.8 10.4-26.6c0-21.7-17.6-39.3-39.3-39.3l-4.5 0c-14.6 0-28.3 7.3-36.4 19.5l-9.5 14.2c-5.2 7.8-14.4 11.8-23.7 10.4s-16.8-8.1-19.4-17.1L233.5 116.6C221.9 76 184.8 48 142.6 48C90.3 48 48 90.3 48 142.6l0 2.5c0 7.9 1 15.8 2.9 23.5l52.4 209.5c.5 1.9 .7 3.9 .7 5.8l-48.7 0L4.3 180.3C1.5 168.8 0 157 0 145.1l0-2.5zM64 416l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"]
};
const faReplyClock = {
  prefix: 'far',
  iconName: 'reply-clock',
  icon: [640, 512, ["reply-time"], "e239", "M640 144a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 64c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm16 272c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-11.4 0-22.6-1.1-33.4-3.2c.9 6.2 1.4 12.6 1.4 19.2c0 15.3-1.9 29.1-5.2 41.5C442 316.7 386.2 272 320 272l-96 0-24 0c-13.3 0-24 10.7-24 24l0 24 0 28.1L55.9 240 176 131.9l0 28.1 0 24c0 13.3 10.7 24 24 24l24 0 108 0c-5.9-15.1-9.8-31.2-11.3-48L272 160l-48 0 0-48 0-16c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-16 0-48 48 0 48 0c53 0 96 43 96 96c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C473.4 462.2 512 413.9 512 336z"]
};
const faReplyTime = faReplyClock;
const faPersonRays = {
  prefix: 'far',
  iconName: 'person-rays',
  icon: [512, 512, [], "e54d", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L272 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM240 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L346.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L107.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L192 223.6 192 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM7 7C-2.3 16.4-2.3 31.6 7 41l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7C31.6-2.3 16.4-2.3 7 7zM505 7c-9.4-9.4-24.6-9.4-33.9 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9zM41 505l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm464 0c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0z"]
};
const faRight = {
  prefix: 'far',
  iconName: 'right',
  icon: [448, 512, [11157, "arrow-alt-right"], "f356", "M397.6 256L247.7 398.7c-.8 .8-2 1.3-3.2 1.3c-2.5 0-4.6-2-4.6-4.6l0-83.4c0-13.3-10.7-24-24-24L48 288l0-64 168 0c13.3 0 24-10.7 24-24l0-83.4c0-2.5 2-4.6 4.6-4.6c1.2 0 2.3 .5 3.2 1.3L397.6 256zm-153 192c13.5 0 26.5-5.2 36.3-14.5L434.8 286.9c8.5-8.1 13.2-19.2 13.2-30.9s-4.8-22.8-13.2-30.9L280.8 78.5C271.1 69.2 258.1 64 244.6 64c-29 0-52.6 23.5-52.6 52.6l0 59.4L48 176c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l144 0 0 59.4c0 29 23.5 52.6 52.6 52.6z"]
};
const faArrowAltRight = faRight;
const faCircleF = {
  prefix: 'far',
  iconName: 'circle-f',
  icon: [512, 512, [], "e10e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-64 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faUsers = {
  prefix: 'far',
  iconName: 'users',
  icon: [640, 512, [], "f0c0", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM405.3 320l213.3 0c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80l117.3 0c39.8 0 73.2 27.2 82.6 64l-282.6 0c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l330.7 0c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352l-117.3 0z"]
};
const faFacePleading = {
  prefix: 'far',
  iconName: 'face-pleading',
  icon: [512, 512, [], "e386", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM266.5 412.4c-2-2.1-5.3-4.4-10.5-4.4s-8.5 2.3-10.5 4.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9c8.9-9.5 24.2-19.6 45.5-19.6s36.7 10.1 45.5 19.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 32c-44.2 0-80-35.8-80-80c0-18 6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80zm240-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 0c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48zm-304 0c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
const faEyeSlash = {
  prefix: 'far',
  iconName: 'eye-slash',
  icon: [640, 512, [], "f070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"]
};
const faFlaskVial = {
  prefix: 'far',
  iconName: 'flask-vial',
  icon: [640, 512, [], "e4f3", "M175 389.4l49-79.6L224 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0L176 0 80 0 32 0 24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 304c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5c0-18.7 5.2-37.1 15-53.1zM80 48l96 0 0 112-96 0L80 48zm0 160l96 0 0 144c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-144zM312 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 169.2L202 408.9c-6.6 10.7-10 22.9-10 35.5c0 37.4 30.3 67.6 67.6 67.6l312.7 0c37.4 0 67.6-30.3 67.6-67.6c0-12.5-3.5-24.8-10-35.5L512 217.2 512 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 0zM464 48l0 176c0 4.4 1.2 8.8 3.6 12.6L518.9 320l-205.8 0 51.3-83.4c2.3-3.8 3.6-8.1 3.6-12.6l0-176 96 0zM242.9 434.1L283.6 368l264.9 0 40.6 66.1c1.9 3.1 2.9 6.7 2.9 10.3c0 10.8-8.8 19.6-19.6 19.6l-312.7 0c-10.9 0-19.6-8.8-19.6-19.6c0-3.6 1-7.2 2.9-10.3z"]
};
const faPoliceBox = {
  prefix: 'far',
  iconName: 'police-box',
  icon: [384, 512, [], "e021", "M192 0c8.8 0 16 7.2 16 16l0 16 80 0c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32l0 368 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0L64 512l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 96c0-17.7 14.3-32 32-32c0-17.7 14.3-32 32-32l80 0 0-16c0-8.8 7.2-16 16-16zM80 464l224 0 0-352L80 112l0 352zm24-320c0-4.4 3.6-8 8-8l24 0 0 32-32 0 0-24zm0 40l32 0 0 32-24 0c-4.4 0-8-3.6-8-8l0-24zm72-48c4.4 0 8 3.6 8 8l0 24-32 0 0-32 24 0zm-24 48l32 0 0 24c0 4.4-3.6 8-8 8l-24 0 0-32zm56-48l24 0 0 32-32 0 0-24c0-4.4 3.6-8 8-8zm24 48l0 32-24 0c-4.4 0-8-3.6-8-8l0-24 32 0zm16-48l24 0c4.4 0 8 3.6 8 8l0 24-32 0 0-32zm32 48l0 24c0 4.4-3.6 8-8 8l-24 0 0-32 32 0zM104 248c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48z"]
};
const faCucumber = {
  prefix: 'far',
  iconName: 'cucumber',
  icon: [512, 512, [129362], "e401", "M71.4 440.6c-31.2-31.2-31.2-81.9 0-113.1l256-256c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-63 63c-4.4-4.7-10.6-7.6-17.5-7.6c-13.3 0-24 10.7-24 24c0 6.9 2.9 13.1 7.6 17.5l-159 159c-31.2 31.2-81.9 31.2-113.1 0zM37.5 474.5c47.8 47.8 124 49.9 174.3 6.3c12.6 10.3 31.1 9.6 42.9-2.2c11.6-11.6 12.4-30 2.4-42.6L436 257c12.6 10.1 31 9.3 42.6-2.4c11.7-11.7 12.5-30.3 2.2-42.9c43.6-50.3 41.5-126.5-6.3-174.3c-50-50-131-50-181 0L172 159c-12.6-10.1-31-9.3-42.6 2.4s-12.4 30-2.4 42.6L37.5 293.5c-50 50-50 131 0 181zM352 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM184 320a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faHeadSideBrain = {
  prefix: 'far',
  iconName: 'head-side-brain',
  icon: [512, 512, [], "f808", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm264-32c22.1 0 40-17.9 40-40s-17.9-40-40-40c-2 0-3.9 .1-5.8 .4C299.8 102.5 288.7 96 276 96c-6.2 0-12.1 1.6-17.2 4.3C252 88.2 238.9 80 224 80s-28 8.2-34.8 20.3C184.1 97.6 178.2 96 172 96c-18.5 0-33.8 14-35.8 32l-.2 0c-22.1 0-40 17.9-40 40c0 16.5 9.9 30.6 24.1 36.7c-.1 1.1-.1 2.2-.1 3.3c0 22.1 17.9 40 40 40c5.7 0 11.1-1.2 16-3.3l0 51.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48.8c2.6 .5 5.3 .8 8 .8c22.1 0 40-17.9 40-40c0-5.7-1.2-11.1-3.3-16l43.3 0z"]
};
const faHand = {
  prefix: 'far',
  iconName: 'hand',
  icon: [512, 512, [129306, 9995, "hand-paper"], "f256", "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64l0 165.5-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75l8.5 0 8 0c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5l0-176c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1l0-.1 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.9 0 .1 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 55.9c0 0 0 .1 0 .1l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-71.9c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16l0 172.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2l-4.9 0-8.5 0c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2L160 96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9L192 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-135.9z"]
};
const faHandPaper = faHand;
const faPersonBikingMountain = {
  prefix: 'far',
  iconName: 'person-biking-mountain',
  icon: [640, 512, [128693, "biking-mountain"], "f84b", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm.5 103c-2.7-3.4-7.5-4-11-1.4l-74.6 55c-9.6 7.1-8.4 21.8 2.3 27.2l69.6 34.8c8.1 4.1 13.3 12.4 13.3 21.5l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-113.2-56.3-28.1c-42.8-21.4-47.8-80.4-9.3-108.8l74.6-55C337.2 93.1 371.2 97.5 390 121l37.6 47 52.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-7.3 0-14.2-3.3-18.7-9l-44.8-56zM188.4 166.7c-6.9 5.2-16.7 3.9-22.1-2.8l-44-55c-5.6-7.1-4.3-17.4 2.9-22.8l65.2-48.9c27.7-20.7 66.8-15.8 88.4 11.2l14.9 18.7c5.6 7.1 4.3 17.4-2.9 22.8L188.4 166.7zM120 256l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C158.1 503.1 148.1 512 136 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L31.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C8.9 414.1 0 404.1 0 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9C97.9 264.9 107.9 256 120 256zm8 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM480.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6l16 0c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8l0 16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C542.1 503.1 532.1 512 520 512l-16 0c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C392.9 414.1 384 404.1 384 392l0-16c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM576 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faBikingMountain = faPersonBikingMountain;
const faUtensilsSlash = {
  prefix: 'far',
  iconName: 'utensils-slash',
  icon: [640, 512, [], "e464", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l76.5 59.9 4.9-43.7C121.6 8.2 133.5-1.3 146.7 .1s22.7 13.3 21.2 26.5l-8.1 73.2L200 131.5 200 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 .4 0 .7 0 1.1L291.2 203c3-5.6 4.8-12.1 4.8-19l0-14.7L280.1 26.7c-1.5-13.2 8-25 21.2-26.5s25 8 26.5 21.2l16 144 .1 1.3 0 1.3 0 16c0 18-5.4 34.8-14.7 48.8L384 275.7l0-99.7C384 32 496 0 512 0c17.7 0 32 14.3 32 32l0 216 0 56 0 48 0 49.1 86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM104 184l0-6.1L248 291.4 248 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-216-8 0c-48.6 0-88-39.4-88-88zM519.7 512l.6 0-.3 0-.3 0zM432 176l0 112c0 8.8 7.2 16 16 16l48 0 0-56 0-192.9c-7.1 3.6-14.9 8.5-22.6 15.2C453.7 87.4 432 118.3 432 176z"]
};
const faPrintMagnifyingGlass = {
  prefix: 'far',
  iconName: 'print-magnifying-glass',
  icon: [640, 512, ["print-search"], "f81a", "M176 160l-48 0 0-96c0-35.3 28.7-64 64-64L421.5 0c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3l0 69.5-48 0 0-69.5c0-4.2-1.7-8.3-4.7-11.3L432.8 52.7c-3-3-7.1-4.7-11.3-4.7L192 48c-8.8 0-16 7.2-16 16l0 96zm16 208l0 96 186.2 0c21.1 10.2 44.8 16 69.8 16c16.7 0 32.8-2.6 48-7.3l0 7.3c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-80-48 0c-17.7 0-32-14.3-32-32l0-112c0-35.3 28.7-64 64-64l224 0c-17.2 12.9-31.7 29.3-42.6 48L128 240c-8.8 0-16 7.2-16 16l0 96 32 0c0-17.7 14.3-32 32-32l112 0c0 16.7 2.6 32.8 7.3 48L192 368zm256 32.2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
const faPrintSearch = faPrintMagnifyingGlass;
const faTurnRight = {
  prefix: 'far',
  iconName: 'turn-right',
  icon: [512, 512, [], "e639", "M505.5 240.4c8.7-9.2 8.7-23.7 0-32.9L384.1 78.6c-8.8-9.3-21-14.6-33.7-14.6C324.7 64 304 84.7 304 110.3l0 41.7-144 0C71.6 152 0 223.6 0 312L0 424c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l152 0 0 41.7c0 25.6 20.7 46.3 46.3 46.3c12.8 0 25-5.3 33.7-14.6l121.4-129zM352 333.5l0-61.5c0-13.3-10.7-24-24-24l-176 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-112c0-61.9 50.1-112 112-112l168 0c13.3 0 24-10.7 24-24l0-61.5L455 224 352 333.5z"]
};
const faFolderBookmark = {
  prefix: 'far',
  iconName: 'folder-bookmark',
  icon: [512, 512, [], "e186", "M251.7 127.6s0 0 0 0c1.4 1.4 2.8 2.7 4.3 3.9L256 304c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L336 276l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.3 8.8-14.3l0-160 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z"]
};
const faArrowTurnLeftDown = {
  prefix: 'far',
  iconName: 'arrow-turn-left-down',
  icon: [384, 512, [], "e633", "M337 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-87 87L216 88c0-22.1 17.9-40 40-40l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L256 0c-48.6 0-88 39.4-88 88l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505c9.4 9.4 24.6 9.4 33.9 0L337 377z"]
};
const faOm = {
  prefix: 'far',
  iconName: 'om',
  icon: [512, 512, [128329], "f679", "M356.7 4.7c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6l16-16zM144 152c-12.6 0-24.2 4.2-33.6 11.2c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6C99 111.7 120.6 104 144 104c57.4 0 104 46.6 104 104c0 20.6-6 39.8-16.3 56l.3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0c14.8 0 29-5.9 39.5-16.4l20.7-20.7c17.2-17.2 40.6-26.9 65-26.9c50.7 0 91.9 41.1 91.9 91.9l0 96.1c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-4c0-13.3 10.7-24 24-24s24 10.7 24 24l0 4c0 24.3 19.7 44 44 44s44-19.7 44-44l0-96.1c0-24.2-19.6-43.9-43.9-43.9c-11.6 0-22.8 4.6-31 12.9l-20.7 20.7C348.9 301 322.5 312 294.9 312l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.1 0c17.2 20.8 27.6 47 27.6 76c0 70.2-60.9 124-132 124S16 458.2 16 388c0-13.3 10.7-24 24-24s24 10.7 24 24c0 40.3 35.8 76 84 76s84-35.7 84-76s-35.8-76-84-76l-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0c0 0 0 0-.1 0l-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l.3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0c30.9 0 56-25.1 56-56s-25.1-56-56-56zM298.8 65.1C313.1 83.1 338.2 96 368 96s54.9-12.9 69.2-30.9c8.2-10.4 23.3-12.1 33.7-3.9s12.1 23.3 3.9 33.7C450.8 125.2 411.4 144 368 144s-82.8-18.8-106.8-49.1c-8.2-10.4-6.5-25.5 3.9-33.7s25.5-6.5 33.7 3.9z"]
};
const faPi = {
  prefix: 'far',
  iconName: 'pi',
  icon: [448, 512, [], "f67e", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l88 0 0 165.4c0 44.9-11.4 89-33.2 128.2L75 412.3c-6.4 11.6-2.3 26.2 9.3 32.6s26.2 2.3 32.6-9.3l3.8-6.8c25.8-46.4 39.3-98.5 39.3-151.5L160 112l144 0 0 262.6c0 40.6 32.9 73.4 73.4 73.4c27.8 0 53.2-15.7 65.7-40.6l2.3-4.7c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.3 4.7c-4.3 8.6-13.1 14.1-22.8 14.1c-14.1 0-25.4-11.4-25.4-25.4L352 112l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 64z"]
};
const faFlaskRoundPotion = {
  prefix: 'far',
  iconName: 'flask-round-potion',
  icon: [448, 512, ["flask-potion"], "f6e1", "M176 48l96 0 0 109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 351.9c-64.4-.9-94.8-12.3-122.5-22.7c-23.8-9-45.7-17.2-85.5-17.2c-55.8 0-92.3 16.1-111.5 27.9c4-53.9 34.8-100.4 79.2-126.3c18.8-11 32.3-31.6 32.3-55.9L176 48zM320 157.7L320 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L304 0 144 0 120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l8 0 0 109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4z"]
};
const faFlaskPotion = faFlaskRoundPotion;
const faFaceShush = {
  prefix: 'far',
  iconName: 'face-shush',
  icon: [512, 512, [], "e38c", "M48 256c0 73.6 38.3 138.3 96 175.3l0 .7 0 24c0 11.8 2.3 23.1 6.5 33.3C61.8 449.1 0 359.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 82.2-38.8 155.4-99 202.3c6.4-18.5 2.7-39.4-10.4-54.7C440.5 365.9 464 313.7 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256zm299.3-4.7c-8.7 8.7-20.5 17.7-35.3 24.6l0-27.9c0-2.8-.2-5.6-.6-8.4c5.2-3.5 9.6-7.3 13.3-10.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM200 248l0 27.9c-14.8-6.9-26.6-15.9-35.3-24.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c3.7 3.7 8.1 7.4 13.3 10.9c-.4 2.7-.6 5.5-.6 8.4zM176.4 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM280 248l0 72-48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 408l0 11.5L287.6 464l10 0c7.1 0 13.9-3.2 18.4-8.6l25.6-30.7c8.5-10.2 23.6-11.6 33.8-3.1s11.6 23.6 3.1 33.8l-25.6 30.7c-13.7 16.4-33.9 25.9-55.3 25.9L280 512l-48 0c-30.9 0-56-25.1-56-56l0-24 0-24c0-30.9 25.1-56 56-56l32 0c30.9 0 56 25.1 56 56l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8z"]
};
const faWorm = {
  prefix: 'far',
  iconName: 'worm',
  icon: [512, 512, [], "e599", "M400 192l0 176c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-48c0-53-43-96-96-96s-96 43-96 96l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48c0 53 43 96 96 96s96-43 96-96l0-176 0-72 0-24c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l16 0 48 0 0 48zM176 176c15.9 0 31.2 2.6 45.5 7.3c27.7 9.2 51.7 26.6 69 49.3c5.1 6.7 9.6 13.8 13.5 21.3c10.2 19.8 16 42.2 16 66l0 20.3 0 27.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-27.7 0-20.3 0-76.9 0-3.1 0-48-16 0c-6.3 0-12.5-.6-18.5-1.8c-27.6-5.4-51-22.6-64.7-46.2c-8.2-14.1-12.8-30.5-12.8-48c0-53 43-96 96-96l48 0c53 0 96 43 96 96l0 24 0 72 0 176c0 79.5-64.5 144-144 144c-55.7 0-104.1-31.7-128-78c-10.2-19.8-16-42.2-16-66l0-20.3 0-27.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 27.7 0 20.3 0 76.9 0 3.1c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-79.5 64.5-144 144-144zM376 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHouseCircleXmark = {
  prefix: 'far',
  iconName: 'house-circle-xmark',
  icon: [640, 512, [], "e50b", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
const faPlug = {
  prefix: 'far',
  iconName: 'plug',
  icon: [384, 512, [128268], "f1e6", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c77-11.6 136-78 136-158.2l0-64 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 64c0 61.9-50.1 112-112 112z"]
};
const faCalendarCircleExclamation = {
  prefix: 'far',
  iconName: 'calendar-circle-exclamation',
  icon: [576, 512, [], "e46e", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faSquareI = {
  prefix: 'far',
  iconName: 'square-i',
  icon: [448, 512, [], "e272", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l72 0 72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 160 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-160-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faChevronUp = {
  prefix: 'far',
  iconName: 'chevron-up',
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
};
const faFaceSaluting = {
  prefix: 'far',
  iconName: 'face-saluting',
  icon: [640, 512, [129761], "e484", "M266.6 14C256.7-.6 236.8-4.4 222.2 5.5L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9c14.3-10.4 17.5-30.4 7.1-44.7s-30.4-17.5-44.7-7.1l-3.3 2.4s0 0 0 0l-9.9 7.2-14.2 10.4L128 185.8l0-39.1L258.1 58.5c14.6-9.9 18.4-29.8 8.5-44.4zm31.8-8.4c7.2 15.7 7.4 33.4 1.6 48.9c16.6-4.3 34-6.5 52-6.5c114.9 0 208 93.1 208 208s-93.1 208-208 208c-103 0-188.6-74.9-205.1-173.2c-13.8 9.9-29.2 16.3-45.2 19.2C126.5 425.5 229.2 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-18.4 0-36.3 1.9-53.5 5.6zM256 180.5c-.4 13.7-5.1 27.1-13.8 38.2c4.4 12.4 16.2 21.4 30.2 21.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-6 0-11.6 1.6-16.3 4.5zm13.4 152.6c-11-7.4-25.9-4.6-33.3 6.4s-4.6 25.9 6.4 33.3C265 388.1 301.7 403 352 403s87-14.9 109.5-30.2c11-7.4 13.8-22.4 6.4-33.3s-22.4-13.8-33.3-6.4C419.9 343 392.6 355 352 355s-67.9-12-82.5-21.9zM432.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faGaugeSimpleLow = {
  prefix: 'far',
  iconName: 'gauge-simple-low',
  icon: [512, 512, ["tachometer-slow"], "f62c", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56s-56-25.1-56-56z"]
};
const faTachometerSlow = faGaugeSimpleLow;
const faFacePersevering = {
  prefix: 'far',
  iconName: 'face-persevering',
  icon: [512, 512, [], "e385", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM133.5 210.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 221.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
const faCircleCamera = {
  prefix: 'far',
  iconName: 'circle-camera',
  icon: [512, 512, ["camera-circle"], "e103", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm196-96l6.2-16.4c3.5-9.4 12.5-15.6 22.5-15.6l62.7 0c10 0 19 6.2 22.5 15.6L316 160l36 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l36 0zm108 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faCameraCircle = faCircleCamera;
const faHandSpock = {
  prefix: 'far',
  iconName: 'hand-spock',
  icon: [576, 512, [128406], "f259", "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512l-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8l33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"]
};
const faSpiderWeb = {
  prefix: 'far',
  iconName: 'spider-web',
  icon: [576, 512, [128376], "f719", "M137.5 23.6C141.6 12.7 153 6.3 164.4 8.4l69 12.9c36.1 6.8 73 6.8 109.1 0l69-12.9c11.5-2.1 22.8 4.2 26.9 15.2l28.9 77.2c11.7 31.1 28.5 60 49.8 85.6l45.3 54.3c7.4 8.9 7.4 21.8 0 30.7l-45.3 54.3c-21.3 25.5-38.1 54.5-49.8 85.6l-28.9 77.2c-4.1 10.9-15.4 17.3-26.9 15.2l-69-12.9c-36.1-6.8-73-6.8-109.1 0l-69 12.9c-11.5 2.1-22.8-4.2-26.9-15.2l-28.9-77.2c-11.7-31.1-28.5-60-49.8-85.6L13.6 271.4c-7.4-8.9-7.4-21.8 0-30.7l45.3-54.3c21.3-25.5 38.1-54.5 49.8-85.6l28.9-77.2zm27 64.7l-11 29.3c-13.6 36.2-33.1 69.8-57.8 99.4L83.2 232l49.8 0c23.5-27.6 41.7-59.2 53.7-93.4l2.5-7L164.5 88.3zm42.1-23.1l24 41.9c37.7 9.5 77.2 9.5 114.9 0l24-41.9-18 3.4c-41.9 7.9-84.9 7.9-126.8 0l-18-3.4zM411.5 88.3l-24.8 43.3 2.5 7c12.1 34.2 30.3 65.8 53.8 93.4l49.8 0-12.5-14.9c-24.7-29.7-44.3-63.3-57.8-99.4l-11-29.3zM492.8 280L443 280c-23.6 28.1-41.8 60.4-53.6 95.3l-2.1 6.1 24.2 42.4 11-29.3c13.6-36.2 33.1-69.8 57.8-99.4L492.8 280zM369.4 446.8l-22.1-38.7c-37.9-11.7-78.3-12.8-116.7-3.2l-24 41.9 18-3.4c41.9-7.9 84.9-7.9 126.8 0l18 3.4zM164.5 423.7l24.8-43.3-2.5-7c-12.1-34.2-30.3-65.8-53.7-93.4l-49.8 0 12.5 14.9c24.7 29.7 44.3 63.3 57.8 99.4l11 29.3zM193.2 280c10.1 15 18.9 30.7 26.5 47.1L246.6 280l-53.4 0zm67.9 71.4c18.1-1.5 36.3-1.2 54.3 1L288 304.4l-26.9 47zm95.5-23.7c7.6-16.6 16.4-32.5 26.5-47.7l-53.8 0 27.3 47.7zM382.8 232c-10.1-15-18.9-30.7-26.5-47.1L329.4 232l53.4 0zm-68.1-71c-17.7 1.7-35.6 1.7-53.3 0L288 207.6 314.7 161zm-94.9 23.9c-7.6 16.4-16.5 32.1-26.5 47.1l53.4 0-26.9-47.1z"]
};
const faCircleMicrophone = {
  prefix: 'far',
  iconName: 'circle-microphone',
  icon: [512, 512, ["microphone-circle"], "e116", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 144c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112zm-56 88c13.3 0 24 10.7 24 24c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3 10.7-24 24-24s24 10.7 24 24c0 62.5-44.8 114.5-104 125.8l0 10.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.2C172.8 370.5 128 318.5 128 256c0-13.3 10.7-24 24-24z"]
};
const faMicrophoneCircle = faCircleMicrophone;
const faBookArrowUp = {
  prefix: 'far',
  iconName: 'book-arrow-up',
  icon: [448, 512, [], "e0ba", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l96 0 0-48-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-48-96 0c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8l-88 0 0 48 64 0 0 64-64 0 0 48 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zm55 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L216 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-278.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
const faPopsicle = {
  prefix: 'far',
  iconName: 'popsicle',
  icon: [320, 512, [], "e43e", "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160l0 176 88 0 0-152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 152 88 0 0-176zM136 384l-88 0c-26.5 0-48-21.5-48-48L0 160C0 71.6 71.6 0 160 0s160 71.6 160 160l0 176c0 26.5-21.5 48-48 48l-88 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z"]
};
const faCommand = {
  prefix: 'far',
  iconName: 'command',
  icon: [512, 512, [], "e142", "M0 92C0 41.2 41.2 0 92 0s92 41.2 92 92l0 44 144 0 0-44c0-50.8 41.2-92 92-92s92 41.2 92 92l0 4c0 53-43 96-96 96l-40 0 0 128 40 0c53 0 96 43 96 96l0 4c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-44-144 0 0 44c0 50.8-41.2 92-92 92s-92-41.2-92-92l0-4c0-53 43-96 96-96l40 0 0-128-40 0C43 192 0 149 0 96l0-4zm136 52l0-8 0-44c0-24.3-19.7-44-44-44S48 67.7 48 92l0 4c0 26.5 21.5 48 48 48l40 0zm48 176l0 8 144 0 0-8 0-128 0-8-144 0 0 8 0 128zm-48 48l-40 0c-26.5 0-48 21.5-48 48l0 4c0 24.3 19.7 44 44 44s44-19.7 44-44l0-44 0-8zm240 8l0 44c0 24.3 19.7 44 44 44s44-19.7 44-44l0-4c0-26.5-21.5-48-48-48l-40 0 0 8zm0-232l40 0c26.5 0 48-21.5 48-48l0-4c0-24.3-19.7-44-44-44s-44 19.7-44 44l0 44 0 8z"]
};
const faBlinds = {
  prefix: 'far',
  iconName: 'blinds',
  icon: [512, 512, [], "f8fb", "M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24c0 8.6-4.5 16.2-11.4 20.4l11 57.6c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L224 128l0-48 234.6 0-6.1-32L192 48l0 116.1c28 9.9 48 36.6 48 67.9c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-31.3 20-58 48-67.9L144 48 59.5 48 53.4 80 112 80l0 48-90.1 0C9.8 128 0 118.2 0 106.1c0-1.4 .1-2.8 .4-4.1l11-57.6C4.5 40.2 0 32.6 0 24zM66.8 208C65 215.7 64 223.7 64 232s1 16.3 2.8 24l-44.9 0C9.8 256 0 246.2 0 234.1c0-1.4 .1-2.8 .4-4.1l13.3-70 48.9 0-9.1 48 13.3 0zm202.4 48c1.8-7.7 2.8-15.7 2.8-24s-1-16.3-2.8-24l189.3 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9l-220.9 0zM168 336l290.6 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L21.9 384C9.8 384 0 374.2 0 362.1c0-1.4 .1-2.8 .4-4.1l13.3-70 48.9 0-9.1 48L168 336zM13.7 416l48.9 0-9.1 48 405.1 0-9.1-48 48.9 0 13.3 70c.3 1.4 .4 2.7 .4 4.1c0 12.1-9.8 21.9-21.9 21.9L21.9 512C9.8 512 0 502.2 0 490.1c0-1.4 .1-2.8 .4-4.1l13.3-70zM168 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faStopwatch = {
  prefix: 'far',
  iconName: 'stopwatch',
  icon: [448, 512, [9201], "f2f2", "M144 24c0-13.3 10.7-24 24-24L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 49.4c43.4 5 82.8 23.3 113.8 50.9L391 119c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31c24 33.9 38.1 75.3 38.1 120c0 114.9-93.1 208-208 208S16 418.9 16 304C16 197.2 96.4 109.3 200 97.4L200 48l-32 0c-13.3 0-24-10.7-24-24zm80 440a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm24-248l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSaxophone = {
  prefix: 'far',
  iconName: 'saxophone',
  icon: [640, 512, [127927], "f8dc", "M514.5 32c-23.3 0-45.7 9.3-62.2 25.8L448 62.1l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L400 110l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7L352 158l-7-7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-90.6 90.6L265 176c12.8-.5 23-11.1 23-24c0-13.3-10.7-24-24-24l-16 0L56 128l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l2.1 0L4 275.3c-2.7 12-4 24.2-4 36.5C0 404.7 75.3 480 168.2 480l9.1 0c51.9 0 101.2-22.7 134.9-62.2l224.5-263c1.5-1.8 3.7-2.8 6.1-2.8l50.6 0c25.8 0 46.6-20.9 46.6-46.6c0-12.4-4.9-24.2-13.7-33L611.7 57.8C595.2 41.3 572.8 32 549.5 32l-35 0zM75.3 176l138.8 0L178.5 276.7c-1.7 4.7-2.5 9.7-2.5 14.8c0 24.5 19.9 44.4 44.4 44.4l2.3 0c12.4 0 24.2-4.9 33-13.6l112.1-112c.4-.4 .9-.8 1.3-1.2s.8-.8 1.2-1.3L416 161.9c.3-.3 .7-.6 1-1s.6-.7 1-1l46.4-46.3c.2-.2 .5-.4 .7-.7s.4-.4 .6-.7l20.6-20.6c7.5-7.5 17.7-11.7 28.3-11.7l35 0c10.6 0 20.8 4.2 28.3 11.7L590.1 104l-47.3 0c-16.4 0-32 7.2-42.6 19.6l-224.5 263c-24.6 28.8-60.5 45.4-98.3 45.4l-9.1 0C101.8 432 48 378.2 48 311.8c0-8.8 1-17.5 2.9-26.1L75.3 176zM136 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-8-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faSquare2 = {
  prefix: 'far',
  iconName: 'square-2',
  icon: [448, 512, [], "e257", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm190.7 88.7l-24.2 18.4c-10.5 8-25.6 6-33.6-4.5s-6-25.6 4.5-33.6l24.2-18.4c15.8-12 35.2-18.4 55.1-18.1l3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1L212.7 336l83.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-9.8 0-18.7-6-22.3-15.2s-1.3-19.6 5.9-26.3L244.3 240.6c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1l-3.4-.1c-9.1-.1-18 2.8-25.3 8.3z"]
};
const faFieldHockeyStickBall = {
  prefix: 'far',
  iconName: 'field-hockey-stick-ball',
  icon: [512, 512, [127953, "field-hockey"], "f44c", "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4c-5.3 0-10.5-4.7-10.5-11c0-1.6 .4-3.1 .9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1 .3-84.4 32.7l-17 38.5C4.8 334 .7 352.9 .6 371.8C0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7L500.3 100.9zM398.1 162.6L213 425.4c-16.9 24-44.4 38.3-73.7 38.4c-50.5 .1-91.1-41.4-90.7-91.6c.1-12.4 2.7-24.8 7.8-36.1l17-38.5c3.6-8.1 13-11.7 21.1-8.2s11.7 13 8.2 21.1l-17 38.5c-3.2 7.3-5 15.4-5 23.5c-.3 32.7 26.2 59.5 58.6 59.4c19-.1 36.7-9.3 47.6-24.8L372.5 143.4l25.6 19.2zM432 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faFieldHockey = faFieldHockeyStickBall;
const faArrowUpSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-up-square-triangle',
  icon: [576, 512, ["sort-shapes-up-alt"], "f88b", "M528 454.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9l84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9zM368 80l0 96 96 0 0-96-96 0zm94.4 352L416 354.6 369.6 432l92.8 0zM320 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"]
};
const faSortShapesUpAlt = faArrowUpSquareTriangle;
const faFaceScream = {
  prefix: 'far',
  iconName: 'face-scream',
  icon: [640, 512, [], "e38b", "M528 256c0 15.2-1.6 30-4.7 44.3c14.9-9.7 33-13.9 50.7-11.7c1.4-10.7 2.1-21.5 2.1-32.5C576 114.6 461.4 0 320 0S64 114.6 64 256c0 11 .7 21.9 2.1 32.6c17.7-2.2 35.7 2 50.7 11.7C113.6 286 112 271.2 112 256c0-114.9 93.1-208 208-208s208 93.1 208 208zM320 464c-41.6 0-80.4-12.2-112.9-33.3c6.9 20.3 11.7 41.1 14.8 61.8C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c3.1-20.7 7.9-41.5 14.8-61.8C400.5 451.8 361.7 464 320 464zM536.7 330.1C482.8 375 455 443.6 448 512l109.8 0c-.4-50.5 16.7-85.7 43.2-125.7c13.1-19.8 7.6-46.3-12.4-59.3c-16.4-10.6-37.6-8.8-51.8 3.1zM183.3 282.7c27.3 14.9 67.6-2.9 90.1-39.8s18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7zM320 304c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48zm46.6-61c22.5 36.9 62.8 54.7 90.1 39.8s31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7zM103.4 330.1C89.1 318.2 68 316.4 51.6 327c-20 13-25.6 39.5-12.4 59.3c26.4 40 43.6 75.3 43.2 125.7L192 512c-7-68.4-34.8-137-88.7-181.9z"]
};
const faSquareM = {
  prefix: 'far',
  iconName: 'square-m',
  icon: [448, 512, [], "e276", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm139.5 41.9L224 255l84.5-117.1c6.1-8.4 16.9-12 26.8-8.8s16.6 12.4 16.6 22.8l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-133.8-60.5 83.8c-4.5 6.2-11.7 9.9-19.5 9.9s-14.9-3.7-19.5-9.9L144 226.2 144 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.4 6.7-19.6 16.6-22.8s20.7 .3 26.8 8.8z"]
};
const faCameraWeb = {
  prefix: 'far',
  iconName: 'camera-web',
  icon: [448, 512, ["webcam"], "f832", "M224 384a168 168 0 1 0 0-336 168 168 0 1 0 0 336zm0 48c-29.1 0-56.9-5.8-82.2-16.2L104.7 464l238.5 0-37.1-48.2C280.9 426.2 253.1 432 224 432zM440 216c0 72.8-36 137.2-91.3 176.4l62.3 81c5.6 7.2 6.5 17 2.5 25.2s-12.4 13.4-21.5 13.4L56 512c-9.1 0-17.5-5.2-21.5-13.4s-3.1-18 2.5-25.2l62.3-81C44 353.2 8 288.8 8 216C8 96.7 104.7 0 224 0S440 96.7 440 216zm-144 0a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-192 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z"]
};
const faWebcam = faCameraWeb;
const faCommentArrowDown = {
  prefix: 'far',
  iconName: 'comment-arrow-down',
  icon: [512, 512, [], "e143", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 110.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 152z"]
};
const faLightbulbCfl = {
  prefix: 'far',
  iconName: 'lightbulb-cfl',
  icon: [320, 512, [], "e5a6", "M165.8 47.3l-128 32C25 82.5 11.9 74.7 8.7 61.8S13.3 35.9 26.2 32.7l128-32c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1zM311.3 82.2c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zm0 96c3.2 12.9-4.6 25.9-17.5 29.1l-256 64c-12.9 3.2-25.9-4.6-29.1-17.5s4.6-25.9 17.5-29.1l256-64c12.9-3.2 25.9 4.6 29.1 17.5zM144 384l80 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-40 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-40 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l0-77.8 48-12 0 89.8zM311.3 274.2c3.2 12.9-4.6 25.9-17.5 29.1l-64 16-5.8 1.5 0 63.3-48 0 0-81.4c-.3-11 7.1-21.1 18.2-23.9l8-2s0 0 0 0l16-4 64-16c12.9-3.2 25.9 4.6 29.1 17.5z"]
};
const faWindowFrameOpen = {
  prefix: 'far',
  iconName: 'window-frame-open',
  icon: [512, 512, [], "e050", "M432 240l-152 0 0-192 136 0c8.8 0 16 7.2 16 16l0 176zm-200 0L80 240 80 64c0-8.8 7.2-16 16-16l136 0 0 192zm248 48l0-48 0-176c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 176 0 48 48 0 352 0 48 0zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 400 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-144-48 0 0 144L80 464l0-144-48 0 0 144-8 0z"]
};
const faFaceKiss = {
  prefix: 'far',
  iconName: 'face-kiss',
  icon: [512, 512, [128535, "kiss"], "f596", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faKiss = faFaceKiss;
const faBridgeCircleXmark = {
  prefix: 'far',
  iconName: 'bridge-circle-xmark',
  icon: [640, 512, [], "e4cb", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faPeriod = {
  prefix: 'far',
  iconName: 'period',
  icon: [192, 512, [], "2e", "M96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
};
const faFaceGrinTongue = {
  prefix: 'far',
  iconName: 'face-grin-tongue',
  icon: [512, 512, [128539, "grin-tongue"], "f589", "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4l0-52.4c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27l0 52.5c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faGrinTongue = faFaceGrinTongue;
const faUpToDottedLine = {
  prefix: 'far',
  iconName: 'up-to-dotted-line',
  icon: [448, 512, [], "e457", "M114.2 288L224 178 333.8 288 280 288c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 128c-11.5 0-22.5 4.6-30.6 12.7L77.6 256.8C68.9 265.5 64 277.3 64 289.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 140.7c-8.1-8.1-19.1-12.7-30.6-12.7zM416 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM128 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM0 64a32 32 0 1 0 64 0A32 32 0 1 0 0 64z"]
};
const faThoughtBubble = {
  prefix: 'far',
  iconName: 'thought-bubble',
  icon: [512, 512, [], "e32e", "M256 0c-48.7 0-91.4 25.6-115.4 64C62.6 65.9 0 129.6 0 208c0 79.5 64.5 144 144 144c9.4 0 18.7-.9 27.6-2.7C193.3 370.7 223.1 384 256 384s62.7-13.3 84.4-34.7c9 1.7 18.2 2.7 27.6 2.7c79.5 0 144-64.5 144-144c0-78.4-62.6-142.1-140.6-144C347.4 25.6 304.7 0 256 0zM176.3 98.7C190.4 68.7 220.8 48 256 48s65.6 20.7 79.7 50.7c4.3 9.1 13.8 14.6 23.8 13.7c2.8-.2 5.6-.4 8.5-.4c53 0 96 43 96 96s-43 96-96 96c-10 0-19.7-1.5-28.7-4.4c-9.6-3-20 .3-26.2 8.3C299.9 325 279.2 336 256 336s-43.9-11-57.1-28.1c-6.1-8-16.6-11.3-26.2-8.3c-9 2.8-18.7 4.4-28.7 4.4c-53 0-96-43-96-96s43-96 96-96c2.9 0 5.7 .1 8.5 .4c10 .9 19.5-4.6 23.8-13.7zM192 432a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 480A32 32 0 1 0 0 480a32 32 0 1 0 64 0z"]
};
const faSkeletonRibs = {
  prefix: 'far',
  iconName: 'skeleton-ribs',
  icon: [640, 512, [], "e5cb", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-42 0c-32.1 0-62.3 17.5-76.7 47.4c-14.1 29.2-34.2 74.3-50.9 124.3C109.8 285.3 96 341.4 96 392l0 11.7c0 42.1 34.2 76.3 76.3 76.3c11.2 0 22.3-2.5 32.5-7.3l70.9-33.4c6.6-3.1 13.4-5.4 20.3-7.1l0 55.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-55.7c6.9 1.6 13.7 4 20.3 7.1l70.9 33.4c10.2 4.8 21.3 7.3 32.5 7.3c42.1 0 76.3-34.2 76.3-76.3l0-11.7c0-50.6-13.8-106.7-30.3-156.3c-16.7-50-36.9-95.1-50.9-124.3C448.3 81.5 418.1 64 386 64l-42 0 0-40zm-48 88l0 60.3L193.6 192.8c9.7-23.7 19.3-44.6 27-60.6c5.9-12.3 18.7-20.2 33.5-20.2l42 0zM173.6 245.8L296 221.3l0 56.7L152.7 319.8c4.9-22.8 11.6-46.1 19.2-68.9c.6-1.7 1.2-3.5 1.8-5.2zM144.8 372.1L296 328l0 55.4c-14 2.2-27.7 6.4-40.7 12.6l-70.9 33.4c-3.8 1.8-7.9 2.7-12.1 2.7c-15.6 0-28.3-12.7-28.3-28.3l0-11.7c0-6.5 .3-13.1 .8-19.9zM344 383.4l0-55.4 151.2 44.1c.5 6.8 .8 13.4 .8 19.9l0 11.7c0 15.6-12.7 28.3-28.3 28.3c-4.2 0-8.3-.9-12.1-2.7l-70.9-33.4c-13.1-6.1-26.8-10.3-40.7-12.6zm143.3-63.6L344 278l0-56.7 122.4 24.5c.6 1.7 1.2 3.5 1.8 5.2c7.6 22.7 14.3 46 19.2 68.9zm-40.9-127L344 172.3l0-60.3 42 0c14.8 0 27.5 7.9 33.5 20.2c7.7 16 17.3 36.9 27 60.6zM0 128L0 232 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256c0-6.5 3.4-12.4 8.9-15.8L94 194c21.1-12.6 34-35.4 34-60l0-6c0-35.3-28.7-64-64-64S0 92.7 0 128zm48 37.6L48 128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 6c0 7.7-4 14.9-10.7 18.8L48 165.6zM576 64c-35.3 0-64 28.7-64 64l0 6c0 24.6 12.9 47.4 34 60l37.1 22.3c5.5 3.3 8.9 9.3 8.9 15.8l0 256c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256 0-104c0-35.3-28.7-64-64-64zm-5.3 88.8c-6.6-4-10.7-11.1-10.7-18.8l0-6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 37.6-21.3-12.8z"]
};
const faRaygun = {
  prefix: 'far',
  iconName: 'raygun',
  icon: [576, 512, [], "e025", "M288 64l-96 0L102.2 4.1C98.2 1.4 93.4 0 88.6 0C75 0 64 11 64 24.6l0 50.2C26.2 92.8 0 131.3 0 176c0 59.3 46.1 107.8 104.4 111.7l-69 137.9c-7.9 15.8-1.5 35 14.3 42.9l80 40c15.8 7.9 35 1.5 42.9-14.3l103-206 .2-.3 12.2 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-48 0-128 0-48 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8zM112 112l176 0 0 128-176 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zM392 64c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 60.9 0 77.1 30.9c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2l0-96c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L476.9 144 416 144l0-56c0-13.3-10.7-24-24-24zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM222 288.3L136.8 458.5 85.5 432.8l72.3-144.5 64.2 0z"]
};
const faFlute = {
  prefix: 'far',
  iconName: 'flute',
  icon: [640, 512, [], "f8b9", "M144 304l432 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-432 0 0 96zm-48 0l0-96-32 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0zM64 160l32 0 24 0 24 0 432 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-432 0-24 0-24 0-32 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faAcorn = {
  prefix: 'far',
  iconName: 'acorn',
  icon: [448, 512, [], "f6ae", "M267.2 38.4c8-10.6 5.8-25.6-4.8-33.6s-25.6-5.8-33.6 4.8L224 16c-10.7 14.3-18 30.7-21.6 48L96 64C43 64 0 107 0 160l0 16c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-16c0-53-43-96-96-96l-99.9 0c2.4-6.8 5.9-13.3 10.3-19.2l4.8-6.4zM400 160L48 160c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM48.4 240c4.1 78.1 39 189.3 165.5 236.4c6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240l-48.1 0c-3.9 65.7-32.7 150.2-127.5 188.9C129.2 390.2 100.3 305.7 96.5 240l-48.1 0z"]
};
const faVideoArrowUpRight = {
  prefix: 'far',
  iconName: 'video-arrow-up-right',
  icon: [576, 512, [], "e2c9", "M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM152 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0L103 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l103-103 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z"]
};
const faGrateDroplet = {
  prefix: 'far',
  iconName: 'grate-droplet',
  icon: [576, 512, [], "e194", "M0 88C0 57.1 25.1 32 56 32l72 0 96 0 96 0 72 0c30.9 0 56 25.1 56 56l0 74.2c-15.1 4.3-28.2 14.6-35.8 28.8L400 214l0-126c0-4.4-3.6-8-8-8l-48 0 0 152 46.4 0L336.9 332.2C325.8 353.1 320 376.4 320 400c0 29.6 8.9 57.1 24.2 80L320 480l-96 0-96 0-72 0c-30.9 0-56-25.1-56-56L0 256 0 88zm56-8c-4.4 0-8 3.6-8 8l0 144 56 0 0-152L56 80zM48 424c0 4.4 3.6 8 8 8l48 0 0-152-56 0 0 144zm152 8l0-152-48 0 0 152 48 0zm96 0l0-152-48 0 0 152 48 0zM248 80l0 152 48 0 0-152-48 0zM200 232l0-152-48 0 0 152 48 0zm240.5-25.9c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
const faSealExclamation = {
  prefix: 'far',
  iconName: 'seal-exclamation',
  icon: [512, 512, [], "e242", "M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1l64 0 0 64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9l0 64.9-64.9 0c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1L112 400l0-64.9c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9l0-64 64 0zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64l-64 0c-26.5 0-48 21.5-48 48l0 64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1 64 400c0 26.5 21.5 48 48 48l64.9 0 45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448l64.9 0c26.5 0 48-21.5 48-48l0-64.9 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L289.9 17.9zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faChessBishop = {
  prefix: 'far',
  iconName: 'chess-bishop',
  icon: [320, 512, [9821], "f43a", "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8L48 352l48 0 0-27c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3l0 27 48 0 0-13.3c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24L160 0 104 0zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
const faMessageSms = {
  prefix: 'far',
  iconName: 'message-sms',
  icon: [512, 512, [], "e1e5", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM372.8 144c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9z"]
};
const faCoffeeBeans = {
  prefix: 'far',
  iconName: 'coffee-beans',
  icon: [512, 512, [], "e13f", "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8s-39.9 141.2 22.6 203.6S426.8 308 476.8 258zm-46.6-46.7c3.5 4.1 7 9.2 10.4 14.9c-25.8 22.7-83.8 25-133.5-24.7c-28-28-39.5-58.7-40.1-84.8c27.8 29.1 60 40.6 87.3 50.3l1.4 .5c30.2 10.8 54.3 19.8 74.6 43.8zm-10-123c28 28 39.5 58.7 40.1 84.8c-27.8-29.1-60-40.6-87.3-50.3l-1.4-.5c-30.2-10.8-54.3-19.8-74.6-43.8c-3.5-4.1-7-9.2-10.4-14.9c25.8-22.7 83.8-25 133.5 24.7zM128.1 446c-.4 5.4-1.6 11.5-3.1 17.9C90.7 461.7 48 422.3 48 352c0-39.7 13.6-69.5 31.6-88.3c-.9 40.2 13.7 71.1 26.1 97.3l.6 1.3c13.7 29 24.4 52.4 21.8 83.7zM208 352c0 39.7-13.6 69.5-31.6 88.3c.9-40.2-13.7-71.1-26.1-97.3l-.6-1.3c-13.7-29-24.4-52.4-21.8-83.7c.4-5.4 1.6-11.5 3.1-17.9C165.3 242.3 208 281.7 208 352zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"]
};
const faHatWitch = {
  prefix: 'far',
  iconName: 'hat-witch',
  icon: [576, 512, [], "f6e7", "M148.4 384L96 384l85.9-196.3C198.8 149 228 116.9 265 96.5l170.4-94c3-1.7 6.4-2.5 9.9-2.5c7 0 13.7 2.4 19.1 6.7L564 86.4c7.6 6.1 12 15.3 12 25l0 9.6c0 4.6-1 9.2-2.9 13.4l-39.1 84.7c-3.6 7.9-11.5 12.9-20.1 12.9c-10.4 0-19.4-7.2-21.7-17.4l-8-35.9C481.7 167.8 472 160 460.8 160c-8 0-15.5 4-19.9 10.7l-19.5 29.3c-3.5 5.3-5.4 11.5-5.4 17.8c0 4.1 .8 8.2 2.3 11.9L480 384l-51.7 0L373.7 247.5s0 0 0 0c-3.8-9.5-5.7-19.7-5.7-29.8c0-15.7 4.6-31.2 13.4-44.5L401 144c13.3-20 35.8-32 59.8-32c22.8 0 43.6 10.7 56.9 27.9l9.8-21.2L444.6 52.3 288.2 138.6c-27.7 15.3-49.7 39.3-62.4 68.4L148.4 384zM240 336c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 48-96 0 0-48zm313.4 80c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.7-6.9 15.6C550.1 470.3 493.4 512 416 512l-256 0C82.6 512 25.9 470.3 6.9 454.2C2.4 450.4 0 444.6 0 438.6C0 426.1 10.1 416 22.6 416l530.7 0z"]
};
const faFaceGrinWink = {
  prefix: 'far',
  iconName: 'face-grin-wink',
  icon: [512, 512, ["grin-wink"], "f58c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
const faGrinWink = faFaceGrinWink;
const faClockThreeThirty = {
  prefix: 'far',
  iconName: 'clock-three-thirty',
  icon: [512, 512, [], "e357", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-136c0-13.3 10.7-24 24-24l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faEarDeaf = {
  prefix: 'far',
  iconName: 'ear-deaf',
  icon: [512, 512, ["deaf", "deafness", "hard-of-hearing"], "f2a4", "M505 41l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM185 361L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L151 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm55-249c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40z"]
};
const faDeaf = faEarDeaf;
const faDeafness = faEarDeaf;
const faHardOfHearing = faEarDeaf;
const faAlarmClock = {
  prefix: 'far',
  iconName: 'alarm-clock',
  icon: [512, 512, [9200], "f34e", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 0-94.1z"]
};
const faEclipse = {
  prefix: 'far',
  iconName: 'eclipse',
  icon: [640, 512, [], "f749", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-15.8-6.6-30.6-15.1-44.2-25.2l-4.5 24.4L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 4.5 24.4C353.2 79.1 368 70.6 383.9 64l-8.2-44.3zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c10.4 0 20.5-1.4 30.1-4.1c-8.4-13.9-15.3-28.9-20.3-44.6c-3.2 .5-6.5 .7-9.8 .7c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.3 0 6.6 .3 9.8 .7c5-15.8 11.9-30.7 20.3-44.6c-9.6-2.7-19.7-4.1-30.1-4.1zm80 112a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0a176 176 0 1 0 -352 0 176 176 0 1 0 352 0z"]
};
const faFaceRelieved = {
  prefix: 'far',
  iconName: 'face-relieved',
  icon: [512, 512, [], "e389", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm193 87c11.8 11.8 32.7 25 63 25s51.2-13.1 63-25c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-19.1 19.1-51.6 39-97 39s-77.9-19.9-97-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm158.7-91c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 285.2 371 292 351.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 285.2 179 292 159.6 292s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zm73-135.4c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zm107.8 20.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L379 173.4c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"]
};
const faRoadCircleCheck = {
  prefix: 'far',
  iconName: 'road-circle-check',
  icon: [640, 512, [], "e564", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faDiceFive = {
  prefix: 'far',
  iconName: 'dice-five',
  icon: [448, 512, [9860], "f523", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faOctagonMinus = {
  prefix: 'far',
  iconName: 'octagon-minus',
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMinusOctagon = faOctagonMinus;
const faSquareRss = {
  prefix: 'far',
  iconName: 'square-rss',
  icon: [448, 512, ["rss-square"], "f143", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 40c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faRssSquare = faSquareRss;
const faFaceZany = {
  prefix: 'far',
  iconName: 'face-zany',
  icon: [512, 512, [], "e3a4", "M436.1 152C378.7 52.5 251.5 18.4 152 75.9S18.4 260.5 75.9 360c25 43.3 63.2 74.2 106.5 90.6c-4.1-10.7-6.4-22.4-6.4-34.6l0-7.8c-10.4-6.2-20.1-13.7-28.9-22.2c-10.2-9.9-6.6-26.3 5.7-33.4L391.2 214.9c12.3-7.1 28.3-2 31.8 11.8c15.2 59.4-5.9 124.1-55 165l0 24.3c0 5.5-.5 10.9-1.4 16.1C461 373 492.3 249.2 436.1 152zM384 477.7c-27.9 16.1-57.5 26.3-87.5 31.1c-7.8 2.1-16 3.2-24.5 3.2c-1.9 0-3.7-.1-5.6-.2c-92 3.7-182.9-42.6-232.1-127.8C-36.4 261.6 5.6 105 128 34.3S407 5.6 477.7 128s28.7 279-93.7 349.7zM296.4 160c-11.1 0-20.4-7.5-23.2-17.7c-.8 3.1-1.2 6.4-1.2 9.7c0 22.1 17.9 40 40 40s40-17.9 40-40s-17.9-40-40-40c-3 0-6 .3-8.8 1c9.9 2.9 17.2 12.1 17.2 23c0 13.3-10.7 24-24 24zM312 80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM176 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0A64 64 0 1 1 80 224zm48 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM336 416l0-37.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 37.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faTricycle = {
  prefix: 'far',
  iconName: 'tricycle',
  icon: [512, 512, [], "e5c3", "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l73.6 0c7.9 0 14.4 6.4 14.4 14.4c0 4.2-1.8 8.2-5 10.9l-42.6 36.5c-.8 .7-1.6 1.4-2.3 2.2l-10.9 0c-58.8 0-114 23.9-154.1 64.6L133.6 176l2.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l21.6 0 44 73.4c-1.3 2.2-2.6 4.5-3.9 6.7c-1.9-.1-3.9-.1-5.8-.1C50.1 256 0 306.1 0 368s50.1 112 112 112s112-50.1 112-112c0-42.4-23.6-79.4-58.4-98.4c30.7-48.1 84-77.6 141.6-77.6l12.1 0 11 43.8C286.4 256.1 256 300.5 256 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-2.4 0-4.8 .1-7.2 .2l-13.9-55.6 31.3-26.9C408 129.9 416 112.6 416 94.4C416 59.9 388.1 32 353.6 32L280 32zm62.2 251.8l18.5 74c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1l-18.5-74c42 2.5 75.2 37.3 75.2 79.9c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-28.9 15.3-54.2 38.2-68.2zM112 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faLandMineOn = {
  prefix: 'far',
  iconName: 'land-mine-on',
  icon: [640, 512, [], "e51b", "M344 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 336c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 16 31.5 0c19.6 0 37.3 11.9 44.6 30.2l34.4 85.9c8.4 21-7.1 43.9-29.7 43.9l-417.5 0c-22.6 0-38.1-22.9-29.7-43.9l34.4-85.9c7.3-18.2 24.9-30.2 44.6-30.2l31.5 0 0-16zM505.1 464l-25.6-64-319 0-25.6 64 370.2 0zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"]
};
const faSquareArrowUpLeft = {
  prefix: 'far',
  iconName: 'square-arrow-up-left',
  icon: [448, 512, [], "e263", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm288 48c13.3 0 24 10.7 24 24s-10.7 24-24 24l-94.1 0L329 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-135-135L160 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24l152 0z"]
};
const faICursor = {
  prefix: 'far',
  iconName: 'i-cursor',
  icon: [256, 512, [], "f246", "M.1 22.2c-1 13.2 8.9 24.8 22.1 25.8l15.4 1.2C75 52 104 83.3 104 120.9L104 232l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 111.1c0 37.6-29 68.9-66.5 71.8l-15.4 1.2C8.9 465.1-.9 476.6 .1 489.8s12.6 23.1 25.8 22.1l15.4-1.2c35.7-2.7 66.7-20.9 86.8-47.6c20.1 26.7 51.1 44.9 86.8 47.6l15.4 1.2c13.2 1 24.8-8.9 25.8-22.1s-8.9-24.8-22.1-25.8l-15.4-1.2C181 460 152 428.7 152 391.1L152 280l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-111.1c0-37.6 29-68.9 66.5-71.8l15.4-1.2c13.2-1 23.1-12.6 22.1-25.8S243.4-.9 230.2 .1L214.8 1.3C179.1 4 148.1 22.2 128 48.9C107.9 22.2 76.9 4 41.2 1.3L25.8 .1C12.6-.9 1.1 8.9 .1 22.2z"]
};
const faChartMixedUpCircleDollar = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-dollar',
  icon: [576, 512, [], "e5d9", "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.5 0L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7l0 55.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L408 0zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.4-1.1-5-1.6c-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5c0-8.8 7.2-16 16-16s16 7.2 16 16l0 9.4c6.3 .9 12.3 2.3 17.9 3.7c8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z"]
};
const faSaltShaker = {
  prefix: 'far',
  iconName: 'salt-shaker',
  icon: [384, 512, [129474], "e446", "M325.2 464L58.8 464c-6 0-10.8-4.8-10.8-10.8c0-.6 .1-1.3 .2-1.9L94.5 192l195.1 0 46.3 259.3c.1 .6 .2 1.3 .2 1.9c0 6-4.8 10.8-10.8 10.8zM58.8 512l266.4 0c32.5 0 58.8-26.3 58.8-58.8c0-3.5-.3-6.9-.9-10.3L323.7 110.3C312.3 46.5 256.8 0 192 0S71.7 46.5 60.3 110.3L.9 442.9c-.6 3.4-.9 6.9-.9 10.3C0 485.7 26.3 512 58.8 512zM192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM128 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM240 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faStamp = {
  prefix: 'far',
  iconName: 'stamp',
  icon: [512, 512, [], "f5bf", "M299.3 116.7c3-6.2 4.7-13.2 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 7.5 1.7 14.5 4.7 20.7l.3 .6c7 14.6 19 39.6 19 68.7c0 65.2-52.8 118-118 118l-18 0c-26.5 0-48 21.5-48 48l0 8c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-8c0-26.5-21.5-48-48-48l-18 0c-65.2 0-118-52.8-118-118c0-29 12-54.1 19-68.6c0 0 0 0 0 0l.3-.6zm43.3 20.8C335.2 152.9 328 168.9 328 186c0 38.7 31.4 70 70 70l18 0c53 0 96 43 96 96l0 8c0 30.9-25.1 56-56 56L56 416c-30.9 0-56-25.1-56-56l0-8c0-53 43-96 96-96l18 0c38.7 0 70-31.3 70-70c0-17.1-7.2-33.1-14.6-48.5c-6-12.6-9.4-26.6-9.4-41.5c0-53 43-96 96-96s96 43 96 96c0 14.9-3.4 28.9-9.4 41.5zM32 480c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32z"]
};
const faFilePlus = {
  prefix: 'far',
  iconName: 'file-plus',
  icon: [384, 512, [], "f319", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM192 208c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"]
};
const faDrawSquare = {
  prefix: 'far',
  iconName: 'draw-square',
  icon: [448, 512, [], "f5ef", "M64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm24 43.3l0 201.3c16 6.5 28.9 19.3 35.3 35.3l201.3 0c6.5-16 19.3-28.9 35.3-35.3l0-201.3c-16-6.5-28.9-19.3-35.3-35.3l-201.3 0c-6.5 16-19.3 28.9-35.3 35.3zM123.3 440c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-201.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40l201.3 0c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64c0 26.9-16.5 49.9-40 59.3l0 201.3c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40l-201.3 0zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm320 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faToiletPaperUnderSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-under-slash',
  icon: [640, 512, ["toilet-paper-reverse-slash"], "e2a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 192c0-49.5-10.5-95.4-28.5-129.9C530 28.7 501.7 0 464 0L176 0c-33.8 0-60 23-77.6 51.8L38.8 5.1zm97.7 76.6c14-25.4 29-33.7 39.5-33.7l212.7 0c-3 4.5-5.7 9.3-8.2 14.1C362.5 96.6 352 142.5 352 192c0 22 2.1 43.3 6 63.3L136.5 81.7zM460.6 335.7l-30.2-23.7c-2.5-3.6-5-7.7-7.4-12.4c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C437.4 56.9 453.1 48 464 48s26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3c-1.1 0-2.2-.1-3.4-.3zm45.1 35.3c8.2-5.4 15.6-12.2 22.3-20l0 37.5-22.3-17.5zm21.7 140.5L467.1 464 280 464c-4.4 0-8-3.6-8-8l0-40-48 0 0 40c0 30.9 25.1 56 56 56l240 0c2.5 0 5-.2 7.4-.5zM304.6 336L176 336c-10.9 0-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7c0-2.6 0-5.1 .1-7.7L66.8 148.6c-1.8 14-2.8 28.6-2.8 43.4c0 49.5 10.5 95.4 28.5 129.9C110 355.3 138.3 384 176 384l189.5 0-60.9-48zM488 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z"]
};
const faToiletPaperReverseSlash = faToiletPaperUnderSlash;
const faStairs = {
  prefix: 'far',
  iconName: 'stairs',
  icon: [576, 512, [], "e289", "M384 56c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L432 80l0 120c0 13.3-10.7 24-24 24l-104 0 0 104c0 13.3-10.7 24-24 24l-104 0 0 104c0 13.3-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l104 0 0-104c0-13.3 10.7-24 24-24l104 0 0-104c0-13.3 10.7-24 24-24l104 0 0-120z"]
};
const faDroneFront = {
  prefix: 'far',
  iconName: 'drone-front',
  icon: [640, 512, ["drone-alt"], "f860", "M136 96c10.4 0 19.3 6.7 22.6 16L264 112c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 160c-13.3 0-24-10.7-24-24s10.7-24 24-24l89.4 0c3.3-9.3 12.2-16 22.6-16zm345.4 16c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16l89.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l105.4 0zM112 256l0-64 48 0 0 49.6 10.8 5.7 47.7-27.8c30.8-18 65.9-27.5 101.6-27.5s70.7 9.5 101.6 27.5l47.7 27.8 10.8-5.7 0-49.6 48 0 0 64c0 8.9-4.9 17.1-12.8 21.2l-51.6 27.3 4.5 5.4c18 21.6 27.8 48.8 27.8 76.8l0 5.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-5.2c0-16.8-5.9-33.2-16.7-46.1l-11-13.2-41.1 21.7c-3.5 1.8-7.3 2.8-11.2 2.8l-96 0c-3.9 0-7.8-1-11.2-2.8l-41.1-21.7-11 13.2c-10.8 12.9-16.7 29.3-16.7 46.1l0 5.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-5.2c0-28.1 9.8-55.3 27.8-76.8l4.5-5.4-51.6-27.3c-7.9-4.2-12.8-12.3-12.8-21.2zm307.3 17.7l-21.9-12.8C373.9 247.2 347.2 240 320 240s-53.9 7.2-77.4 20.9l-21.9 12.8L278 304l84.1 0 57.2-30.3z"]
};
const faDroneAlt = faDroneFront;
const faGlassEmpty = {
  prefix: 'far',
  iconName: 'glass-empty',
  icon: [384, 512, [], "e191", "M6.3 7.8C10.9 2.8 17.3 0 24 0L360 0c6.7 0 13.1 2.8 17.7 7.8s6.8 11.6 6.2 18.3L347.7 446.2C344.5 483.4 313.3 512 276 512L108 512c-37.4 0-68.5-28.6-71.7-65.8L.1 26.1C-.5 19.4 1.8 12.7 6.3 7.8zM50.2 48l34 394.1C85.2 454.5 95.6 464 108 464L276 464c12.5 0 22.8-9.5 23.9-21.9L333.8 48 50.2 48z"]
};
const faDialHigh = {
  prefix: 'far',
  iconName: 'dial-high',
  icon: [576, 512, [], "e15c", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 248l109.4 0c-11 50.3-55.8 88-109.4 88c-61.9 0-112-50.1-112-112s50.1-112 112-112c53.6 0 98.4 37.7 109.4 88L288 264c-13.3 0-24 10.7-24 24s10.7 24 24 24zm160-24a160 160 0 1 0 -320 0 160 160 0 1 0 320 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faUserHelmetSafety = {
  prefix: 'far',
  iconName: 'user-helmet-safety',
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M216 0l16 0c13.3 0 24 10.7 24 24l0 56 28.4-56.9c38 20.4 64.5 59.4 67.3 104.9l.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L96 176c-13.3 0-24-10.7-24-24s10.7-24 24-24l.2 0C99 82.6 125.6 43.5 163.6 23.1L192 80l0-56c0-13.3 10.7-24 24-24zM162 304c-34.9-19.4-59.8-54.6-65-96l48.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l48.6 0c-5.2 41.4-30.1 76.6-65 96c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16zm-11.4 48l73.4 0 73.4 0 16.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0zM397.1 464c-9.9-36.9-43.5-64-83.5-64l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0z"]
};
const faUserConstruction = faUserHelmetSafety;
const faUserHardHat = faUserHelmetSafety;
const faI = {
  prefix: 'far',
  iconName: 'i',
  icon: [320, 512, [105], "49", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l112 0 0 352L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0 0-352 112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L160 32 24 32z"]
};
const faHryvniaSign = {
  prefix: 'far',
  iconName: 'hryvnia-sign',
  icon: [384, 512, [8372, "hryvnia"], "f6f2", "M105.7 104.6C125.6 88.7 150.3 80 175.8 80L227 80c33.7 0 61 27.3 61 61c0 20.7-10.5 39.8-27.5 51L24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l147 0-65.3 34.8c-7 3.7-13.5 8.2-19.4 13.2L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l29.8 0C50 347.1 48 358.9 48 371c0 60.2 48.8 109 109 109l51.2 0c36.4 0 71.7-12.4 100.1-35.1l2.7-2.2c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-2.7 2.2c-19.9 15.9-44.6 24.6-70.1 24.6L157 432c-33.7 0-61-27.3-61-61c0-12.8 4-24.9 11-35l253 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-177 0 90-48 87 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-36.7 0c8.2-15.4 12.7-32.9 12.7-51c0-60.2-48.8-109-109-109l-51.2 0c-36.4 0-71.7 12.4-100.1 35.1L73 69.3C62.7 77.5 61 92.6 69.3 103s23.4 12 33.7 3.7l2.7-2.2z"]
};
const faHryvnia = faHryvniaSign;
const faArrowDownLeftAndArrowUpRightToCenter = {
  prefix: 'far',
  iconName: 'arrow-down-left-and-arrow-up-right-to-center',
  icon: [512, 512, [], "e092", "M489 57c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L320 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0L489 57zM23 455c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L72 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L23 455z"]
};
const faPills = {
  prefix: 'far',
  iconName: 'pills',
  icon: [576, 512, [], "f484", "M112 80c35.3 0 64 28.7 64 64l0 112L48 256l0-112c0-35.3 28.7-64 64-64zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-224c0-61.9-50.1-112-112-112S0 82.1 0 144zM416 432c-61.9 0-112-50.1-112-112c0-22.2 6.5-43 17.7-60.4L476.4 414.3C459 425.5 438.2 432 416 432zM355.6 225.7C373 214.5 393.8 208 416 208c61.9 0 112 50.1 112 112c0 22.2-6.5 43-17.7 60.4L355.6 225.7zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"]
};
const faFaceGrinWide = {
  prefix: 'far',
  iconName: 'face-grin-wide',
  icon: [512, 512, [128515, "grin-alt"], "f581", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"]
};
const faGrinAlt = faFaceGrinWide;
const faTooth = {
  prefix: 'far',
  iconName: 'tooth',
  icon: [448, 512, [129463], "f5c9", "M64 143.3c0 12.5 2.9 24.9 8.5 36.1l17.1 34.2c8.8 17.7 15.2 36.4 18.9 55.8L139.6 431c.1 .6 .6 1 1.2 1c.5 0 1-.4 1.2-.9l28.4-102.4C177.1 304.6 199 288 224 288s46.9 16.6 53.5 40.7L306 431.1c.1 .5 .6 .9 1.2 .9c.6 0 1.1-.4 1.2-1l31.1-161.6c3.7-19.4 10.1-38.2 18.9-55.8l15.1-30.2c6.9-13.9 10.6-29.2 10.6-44.8c0-32.4-26.3-58.7-58.7-58.7l-10.7 0C298 80 282 85.9 269.4 96.7l-7 6 8.1 6c10.6 8 12.8 23 4.8 33.6s-23 12.8-33.6 4.8l-32-24-32-24-8-6C158.2 84.6 144.3 80 130 80l-2.7 0C92.3 80 64 108.3 64 143.3zm159-70l15.1-13C259.4 42 286.5 32 314.6 32l10.7 0C384.2 32 432 79.8 432 138.7c0 23-5.4 45.7-15.6 66.2l-15.1 30.2c-6.9 13.7-11.8 28.3-14.7 43.4L355.5 440.1C351 463.3 330.8 480 307.2 480c-22.1 0-41.5-14.7-47.4-36L231.3 341.5c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.3-7.3 5.5L188.3 444c-5.9 21.3-25.3 36-47.4 36c-23.6 0-43.9-16.7-48.3-39.9L61.4 278.5c-2.9-15.1-7.8-29.7-14.7-43.4L29.6 200.8C20.7 183 16 163.3 16 143.3C16 81.8 65.8 32 127.3 32l2.7 0c24.7 0 48.7 8 68.4 22.8l8 6L223 73.2z"]
};
const faBasketballHoop = {
  prefix: 'far',
  iconName: 'basketball-hoop',
  icon: [640, 512, [], "f435", "M49.2 209.4C64.9 179.7 144.6 48 320 48s255.1 131.7 270.8 161.4c.7 1.4 1.2 3.1 1.2 5.5l0 116.3c0 6.3-3.7 12.1-9.5 14.6l-60.3 26.8-8 56.1 87.8-39c23.1-10.3 38-33.2 38-58.5l0-116.3c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187C1.8 196.3 0 206 0 214.9L0 331.2c0 25.3 14.9 48.2 38 58.5l87.8 39-8-56.1L57.5 345.8c-5.8-2.6-9.5-8.3-9.5-14.6l0-116.3c0-2.4 .5-4.2 1.2-5.5zM142.1 288l7.3 50.8s0 0 0 0l0 .1 22.9 152c1.1 7.5 6.4 13.8 13.7 16.1s15.2 .3 20.5-5.2l48.7-50.6 50.7 50.9c3.8 3.8 8.8 5.9 14.2 5.9s10.4-2.1 14.2-5.9l50.7-50.9 48.7 50.6c5.3 5.5 13.2 7.5 20.5 5.2s12.6-8.6 13.7-16.1l22.9-152s0 0 0 0l0-.1 7.3-50.8 6.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0-48 0-224 0-48 0-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l6.1 0zm315.4 0l-4.1 28.9L418.6 288l37.4 0 1.5 0zM356 288l.5 .4L320 326.2l-36.4-37.8 .5-.4 71.9 0zm-134.5 0l-34.8 28.9L182.5 288l1.5 0 37.4 0zm61.5 134.4L320 383.9l37.1 38.5L320 459.7l-37.1-37.2zm9.3-67.4l-37.6 39-44.5-44.7L252.7 314l39.5 41.1zM198.1 394l28.8 28.9-21.2 22L198.1 394zm149.7-38.9L387.3 314l42.6 35.4-44.5 44.7-37.6-39zM441.9 394l-7.7 50.9-21.2-22L441.9 394zM208 176l224 0 0 32 48 0 0-40c0-22.1-17.9-40-40-40l-240 0c-22.1 0-40 17.9-40 40l0 40 48 0 0-32z"]
};
const faObjectsAlignBottom = {
  prefix: 'far',
  iconName: 'objects-align-bottom',
  icon: [512, 512, [], "e3bb", "M24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512zM176 336l0-288-64 0 0 288 64 0zm-64 48c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0l64 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-64 0zm288-48l0-160-64 0 0 160 64 0zm-64 48c-26.5 0-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-64 0z"]
};
const faV = {
  prefix: 'far',
  iconName: 'v',
  icon: [384, 512, [118], "56", "M14.7 33.9c12.2-5.1 26.3 .6 31.4 12.8L192 394 337.9 46.7c5.1-12.2 19.2-18 31.4-12.8s18 19.2 12.8 31.4l-168 400c-3.7 8.9-12.5 14.7-22.1 14.7s-18.4-5.8-22.1-14.7L1.9 65.3C-3.3 53.1 2.5 39 14.7 33.9z"]
};
const faSparkles = {
  prefix: 'far',
  iconName: 'sparkles',
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
};
const faSquid = {
  prefix: 'far',
  iconName: 'squid',
  icon: [512, 512, [129425], "e450", "M261.5 4.8C265.3 .9 270.7-.8 276 .3L392.2 23.5C422.3 14.4 455.9 6.5 493.4 .2c5.1-.8 10.3 .8 13.9 4.5s5.3 8.8 4.5 13.9c-6.2 37.1-14 70.4-23 100.3l22.9 118c1 5.3-.7 10.8-4.6 14.5s-9.4 5.3-14.6 4.1l-58.6-13.1c-46 71.9-101.3 103.4-147.8 110.6l16 16 .1 .1 22.5 22.5c6.2 6.2 16.4 6.2 22.6 0l56.2-56.2c19-19 49.8-18.7 68.5 .6l35.5 36.7c6 6.2 6 16.2-.1 22.3l-2.3 2.4c-33.7 34.2-87.4 33.7-120.7 2.4L370 414.4c-18.7 18.7-49.1 18.7-67.9 0L273.7 386c-9.4-9.2-24.4-9.2-33.7 0l-.1 .1-.1 .1c-9.2 9.4-9.2 24.4 0 33.8l.1 .1 5.7 5.7 9.9 9.9c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6l2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-9.9-9.8-.1-.1-22.4-22.4-.1-.1c-10.2-10.1-27-9-35.8 2.3l-15.6 20c-2.7 3.5-4.2 7.7-4.2 12.1c0 10.9 8.8 19.7 19.7 19.7l12.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-12.3 0c-28.6 0-51.7-23.2-51.7-51.7c0-11.5 3.8-22.7 10.9-31.8l21.9-28.2c7.3-9.4 6.5-22.8-1.9-31.2s-21.8-9.3-31.2-1.9L84.4 389.1C75.3 396.2 64.1 400 52.6 400C24.1 400 .9 376.8 .9 348.3L.9 336c0-8.8 7.2-16 16-16s16 7.2 16 16l0 12.3c0 10.9 8.8 19.7 19.7 19.7c4.4 0 8.7-1.5 12.1-4.2l20-15.6c11.3-8.8 12.4-25.5 2.4-35.8L64.6 289.9l-.2-.2L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3L27.6 283c-6.1 6.4-16.2 6.7-22.6 .6s-6.7-16.2-.6-22.6l3.3-3.5c18.6-19.6 49.7-20 68.7-.9L93 273.1c9.4 9.2 24.4 9.1 33.8-.2c9.4-9.4 9.4-24.5 0-33.9c0 0 0 0 0 0l-5.7-5.7c0 0 0 0 0 0L98.5 210.7c-18.7-18.7-18.7-49.1 0-67.9l14.3-14.3C81.4 95.2 80.5 41.4 114.3 7.1l2.3-2.4c6.2-6.2 16.2-6.4 22.5-.3l37.6 36.4c19.3 18.6 19.6 49.5 .6 68.5l-56.2 56.2c-6.2 6.2-6.2 16.4 0 22.6l22.6 22.6 2 2 13.9 13.9c7.1-46.7 38.5-102.5 110.6-148.7l-13-58.5c-1.2-5.3 .4-10.8 4.2-14.7zM184.9 296a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM432.3 62C266.7 103.7 228.1 174.4 222.4 215.4c-1.9 13.9 6 30.8 25.1 49.9s36 27 49.9 25.1c41-5.6 111.8-44.3 153.5-209.8c2.8-11.3-7.3-21.5-18.6-18.6z"]
};
const faLeafyGreen = {
  prefix: 'far',
  iconName: 'leafy-green',
  icon: [576, 512, [129388], "e41d", "M233.8 27c-38-36.5-98.4-36-135.8 1.5C92 34.4 87 40.8 83 47.7C70 69.6 50.6 89.9 30.9 105.9c-2.3 1.8-4.4 3.8-6.5 5.9C-1.4 137.6-6.8 176.2 8.5 207.2c5.7 11.7 11 24.1 11 37.1l0 35.7c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2l0 12.9c0 2.9 .2 5.8 .7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6l0-45.7c0-25.5 10.1-49.9 28.1-67.9l10.5-10.5c6-6 9.4-14.1 9.4-22.6l0-43c0-25.5 10.1-49.9 28.1-67.9l29.1-29.1c5-5 8.8-12.9 13.7-27c4.4-12.9 10.8-24.8 18.9-35.5zM526 128c-9.1 35.4-9.7 73.9-6.3 106.9c.2 1.7 .3 3.4 .3 5.1c0 21-13.5 38.9-32.4 45.4c-14.5 5-38.5 13.6-57.7 32.8l-29.1 29.1c-3 3-7.1 4.7-11.3 4.7l-43 0c-29.7 0-58.2 11.8-79.2 32.8l-10.5 10.5c-3 3-7.1 4.7-11.3 4.7l-35.5 0L313 297l41-41 86.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 71-71c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L327 215l-7 7 0-38.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-96 96 0-35.5c0-4.2 1.7-8.3 4.7-11.3l10.5-10.5c21-21 32.8-49.5 32.8-79.2l0-43c0-4.2 1.7-8.3 4.7-11.3l29.1-29.1c19.2-19.2 27.8-43.2 32.8-57.7C297.1 69.5 315 56 336 56c1.7 0 3.5 .1 5.1 .3c33 3.5 71.4 2.8 106.9-6.3c5.1-1.3 10.4-2 16-2c35.3 0 64 28.7 64 64c0 5.6-.7 10.9-2 16zM105 505l38.2-38.2c12-12 28.3-18.7 45.3-18.7l57 0c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7l43 0c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3C540.9 317.9 568 282.1 568 240c0-3.4-.2-6.8-.5-10.1c-3.1-29.1-2.3-61.5 5-89.9c2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5c-28.4 7.3-60.8 8.1-89.9 5c-3.3-.3-6.7-.5-10.1-.5c-42.1 0-77.9 27.1-90.8 64.9c-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3l0 43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3l0 57c0 17-6.7 33.3-18.7 45.3L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
const faCircleArrowUpRight = {
  prefix: 'far',
  iconName: 'circle-arrow-up-right',
  icon: [512, 512, [], "e0fc", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM192 144l152 0c13.3 0 24 10.7 24 24l0 160c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l135-135L192 192c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCalendars = {
  prefix: 'far',
  iconName: 'calendars',
  icon: [512, 512, [], "e0d7", "M224 0c13.3 0 24 10.7 24 24l0 40 112 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 48 0 16 0 160c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-160 0-16 0-48c0-35.3 28.7-64 64-64l40 0 0-40c0-13.3 10.7-24 24-24zM144 192l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160-320 0zm-96-8l0 208c0 39.8 32.2 72 72 72l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0C53.7 512 0 458.3 0 392L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faBangladeshiTakaSign = {
  prefix: 'far',
  iconName: 'bangladeshi-taka-sign',
  icon: [384, 512, [], "e2e6", "M26.4 32.1C13.2 30.8 1.4 40.4 .1 53.6s8.3 25 21.5 26.3L44 82.1c20.4 2 36 19.3 36 39.8L80 176l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 168c0 48.6 39.4 88 88 88l32 0c101.6 0 184-82.4 184-184l0-32c0-48.6-39.4-88-88-88l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c22.1 0 40 17.9 40 40l0 32c0 75.1-60.9 136-136 136l-32 0c-22.1 0-40-17.9-40-40l0-168 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-54.1c0-45.2-34.3-83.1-79.2-87.6L26.4 32.1z"]
};
const faBicycle = {
  prefix: 'far',
  iconName: 'bicycle',
  icon: [640, 512, [128690], "f206", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l25.7 0 34.6 64-149.4 0-27.4-38C191 99.7 183.7 96 176 96l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.7 0 22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112l49 0c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32L312 32zM454.6 296.3l36.3 67.1c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-36.3-67.1c4.9-.9 10-1.4 15.2-1.4c44.2 0 80 35.8 80 80s-35.8 80-80 80s-80-35.8-80-80c0-21.7 8.6-41.3 22.6-55.7zM136.9 272.5l-28.1 56.1c-9 18.1 4.1 39.4 24.3 39.4l73.2 0c-7.4 36.5-39.7 64-78.4 64c-44.2 0-80-35.8-80-80s35.8-80 80-80c3 0 6 .2 8.9 .5zM166.8 320l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z"]
};
const faHammerWar = {
  prefix: 'far',
  iconName: 'hammer-war',
  icon: [384, 512, [], "f6e4", "M216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 28L36.7 32.4C17.7 29.5 0 44.7 0 64L0 256c0 19.3 17.7 34.5 36.7 31.6l150.5-22.6c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6l0-192c0-19.3-17.7-34.5-36.7-31.6L216 52l0-28zm0 276.3l-24-3.6-24 3.6L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-187.7zm-35.9-82.7L48 237.4 48 82.6l132.1 19.8c7.9 1.2 15.9 1.2 23.7 0L336 82.6l0 154.8L203.9 217.6c-7.9-1.2-15.9-1.2-23.7 0z"]
};
const faCircleD = {
  prefix: 'far',
  iconName: 'circle-d',
  icon: [512, 512, [], "e104", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l72 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-72 0zm72 208l-48 0 0-160 48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
const faSpiderBlackWidow = {
  prefix: 'far',
  iconName: 'spider-black-widow',
  icon: [512, 512, [], "f718", "M144.6 1.6c12.4 4.8 18.5 18.6 13.8 31l-32.5 84.6c-1.1 3-.4 6.3 1.8 8.5L160 158.1c.6-32.8 17.8-61.6 43.3-78.4c5.8-3.8 13.1-4.9 19.8-3s12.3 6.7 15.2 13L256 128.1l17.7-38.3c2.9-6.3 8.5-11.1 15.2-13s13.9-.8 19.8 3c25.6 16.8 42.7 45.5 43.3 78.4l32.3-32.3c2.2-2.2 2.9-5.6 1.8-8.5L353.6 32.6c-4.8-12.4 1.4-26.3 13.8-31s26.3 1.4 31 13.8L430.9 100c7.9 20.7 3 44.1-12.7 59.7l-57.4 57.4 80.4-26.8c2.4-.8 4.3-2.7 5.1-5.1l18.9-56.8c4.2-12.6 17.8-19.4 30.4-15.2s19.4 17.8 15.2 30.4l-18.9 56.8c-5.6 16.7-18.7 29.8-35.4 35.4L395.9 256l60.5 20.2c16.7 5.6 29.8 18.7 35.4 35.4l18.9 56.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-18.9-56.8c-.8-2.4-2.7-4.3-5.1-5.1l-68.8-22.9c.8 3.2 1.5 6.4 2 9.7l43.8 43.8c15.6 15.6 20.6 39 12.7 59.7l-32.5 84.6c-4.8 12.4-18.6 18.5-31 13.8s-18.5-18.6-13.8-31l32.5-84.6c1.1-3 .4-6.3-1.8-8.5l-12.1-12.1C358.8 425.8 311.9 464 256 464s-102.8-38.2-116.2-89.9l-12.1 12.1c-2.2 2.2-2.9 5.6-1.8 8.5l32.5 84.6c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8L81.1 412c-7.9-20.7-3-44.1 12.7-59.7l43.8-43.8c.5-3.3 1.2-6.5 2-9.7L70.8 321.7c-2.4 .8-4.3 2.7-5.1 5.1L46.8 383.6C42.6 396.2 29 403 16.4 398.8S-3 381 1.2 368.4l18.9-56.8c5.6-16.7 18.7-29.8 35.4-35.4L116.1 256 55.6 235.8c-16.7-5.6-29.8-18.7-35.4-35.4L1.2 143.6C-3 131 3.8 117.4 16.4 113.2s26.2 2.6 30.4 15.2l18.9 56.8c.8 2.4 2.7 4.3 5.1 5.1l80.4 26.8L93.7 159.7C78.1 144 73.1 120.6 81.1 100l32.5-84.6c4.8-12.4 18.6-18.5 31-13.8zm66 142.7c-1.7 4.9-2.6 10.2-2.6 15.7l0 88c0 3.4 .4 6.7 1 9.9c1.6 7.6-.6 15.5-5.9 21.2C191.2 292 184 309.1 184 328l0 16c0 39.8 32.2 72 72 72s72-32.2 72-72l0-16c0-18.9-7.2-36-19.1-48.9c-5.3-5.7-7.5-13.6-5.9-21.2c.7-3.2 1-6.5 1-9.9l0-88c0-5.5-.9-10.8-2.6-15.7l-15.6 33.8c-3.9 8.5-12.4 13.9-21.8 13.9l-16 0c-9.4 0-17.9-5.4-21.8-13.9l-15.6-33.8zm7.8 162.9c-1.6-2.1-2.4-4.6-2.4-7.2c0-6.6 5.4-12 12-12l56 0c6.6 0 12 5.4 12 12c0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2c0 6.6-5.4 12-12 12l-56 0c-6.6 0-12-5.4-12-12c0-2.6 .8-5.1 2.4-7.2L240 336l-21.6-28.8z"]
};
const faStaffSnake = {
  prefix: 'far',
  iconName: 'staff-snake',
  icon: [384, 512, ["rod-asclepius", "rod-snake", "staff-aesculapius"], "e579", "M222.6 43.2l-.1 4.8L296 48c48.6 0 88 39.4 88 88s-39.4 88-88 88l-48 0 0-48 48 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-75 0-6 192 25 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l0-48c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.5 0-3.6 115.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1.4-43.5L174 448l-54 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.5 0-2-64L144 336c-44.2 0-80-35.8-80-80c0-41.5 31.6-75.6 72-79.6l0 48.6c-13.8 3.6-24 16.1-24 31c0 17.7 14.3 32 32 32l25 0L163 96l-35.6 0c.4 2.6 .6 5.3 .6 8c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56S25.1 48 56 48l8 0 8 0 89.5 0-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faRodAsclepius = faStaffSnake;
const faRodSnake = faStaffSnake;
const faStaffAesculapius = faStaffSnake;
const faPear = {
  prefix: 'far',
  iconName: 'pear',
  icon: [512, 512, [], "e20c", "M505 7c9.4 9.4 9.4 24.6 0 33.9L457.9 88.1c14 20.5 22.1 45.3 22.1 71.9c0 30.7-10.8 58.9-28.9 81c-29.9 36.5-61.4 81.8-73.3 127.4c-8.3 32-25 62.3-50.1 87.3c-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1c45.7-11.8 90.9-43.4 127.4-73.3c22.1-18 50.3-28.9 81-28.9c26.7 0 51.4 8.2 71.9 22.1L471 7c9.4-9.4 24.6-9.4 33.9 0zM367 111l22-22c-11.1-5.8-23.7-9.1-37-9.1c-19.2 0-36.8 6.7-50.6 18C264 128.6 212 166 155.6 180.6c-23.9 6.2-46.6 18.7-65.5 37.5c-56.2 56.2-56.2 147.4 0 203.6s147.4 56.2 203.6 0c18.9-18.9 31.3-41.5 37.5-65.5C346 300 383.4 248 414 210.6c11.3-13.8 18-31.3 18-50.6c0-13.4-3.3-25.9-9.1-37l-22 22c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM288 320c0 53-43 96-96 96c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faHeadSideCoughSlash = {
  prefix: 'far',
  iconName: 'head-side-cough-slash',
  icon: [640, 512, [], "e062", "M129 75.8C156.4 58.2 189 48 224 48l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-6.3 0-12 2.4-16.2 6.3L129 75.8zM459.7 335c29.7-5.3 52.3-31.3 52.3-62.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C173.5 0 127 16.7 89.5 44.8L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459.7 335zM27 117.3C9.8 149 0 185.4 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224c0-27.4 6.3-53.3 17.4-76.4L27 117.3zM339.2 363.2l-1.3 .3c-10.5 2.6-17.8 12-17.8 22.8c0 12.2 9.4 22.4 21.6 23.4l58.4 4.9 0 9.3 0 8c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24c10.4 0 19.3-6.7 22.6-16l65.4 0c30 0 55.2-20.6 62.1-48.5l-107-84.3zM640 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faFileMov = {
  prefix: 'far',
  iconName: 'file-mov',
  icon: [512, 512, [], "e647", "M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm93.7-104.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM448 368l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
const faTriangle = {
  prefix: 'far',
  iconName: 'triangle',
  icon: [512, 512, [9650], "f2ec", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3z"]
};
const faApartment = {
  prefix: 'far',
  iconName: 'apartment',
  icon: [576, 512, [], "e468", "M176 96l0-32c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16l0 128c0 26.5 21.5 48 48 48l64 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-128 0-32 0-32 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48zm16 416l64 0 64 0 32 0 32 0 128 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-16 0-48 0 0-48 0-80c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 32L80 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l128 0zM352 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm144 80l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM128 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16 80l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112-80c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM368 96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32zM256 80l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM368 224l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM480 336c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM144 224l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm112 16c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0z"]
};
const faTruckMedical = {
  prefix: 'far',
  iconName: 'truck-medical',
  icon: [640, 512, [128657, "ambulance"], "f0f9", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faAmbulance = faTruckMedical;
const faPepper = {
  prefix: 'far',
  iconName: 'pepper',
  icon: [512, 512, [129745], "e432", "M252.6 11.7C245.8 .3 231-3.4 219.7 3.4s-15.1 21.6-8.2 32.9l10.3 17.2c6.7 11.2 10.3 24 10.3 37l0 10.9c-17.1-6.1-36.2-7.4-55.1-2.7l-.2 0c-10.5 2.6-20.1 6.9-28.7 12.4C126.5 97.5 99.5 92.2 72.7 98.9C21.3 111.7-10 163.8 2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c10.5-2.6 20.1-6.9 28.7-12.4c5.7 3.6 11.8 6.7 18.3 9.2c10.6 4 22 6.1 33.7 6.1c0 0 0 0 0 0l0-24 0 24s0 0 0 0c11.7 0 23.1-2.1 33.7-6.1c6.5-2.4 12.6-5.5 18.3-9.2c8.6 5.5 18.3 9.8 28.7 12.4c51.4 12.9 103.6-18.4 116.4-69.8l56-224c12.9-51.4-18.4-103.6-69.9-116.4c-26.8-6.7-53.8-1.4-75.3 12.4c-8.6-5.6-18.3-9.8-28.7-12.4c-19-4.8-38.1-3.5-55.3 2.6l0-10.9c0-21.7-5.9-43.1-17.1-61.7L252.6 11.7zM84.4 145.4c10.5-2.6 21.1-1.6 30.4 2.4c-10.4 20-13.8 43.8-7.9 67.5l33.6 134.4c3.2 12.9 16.2 20.7 29.1 17.5s20.7-16.2 17.5-29.1L153.4 203.6c-6.2-25 8.3-50.3 32.7-57.6c.7-.2 1.5-.4 2.2-.6c18.7-4.7 37.6 2.3 49 16.4c4.6 5.6 11.4 8.9 18.7 8.9s14.1-3.3 18.7-8.9c11.4-14.1 30.3-21.1 49-16.4c9.2 2.3 17 7 23 13.3c4.5 4.7 10.8 7.4 17.3 7.4s12.8-2.7 17.3-7.4c11.6-12.1 29-17.7 46.3-13.4c25.7 6.4 41.4 32.5 34.9 58.2l-56 224c-6.4 25.7-32.5 41.4-58.2 34.9c-9.2-2.3-17-7-23-13.3c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-.2 .2-.5 .5-.7 .7c0 0 0 0 0 0c-4.7 4.7-10.5 8.5-17.1 11c0 0 0 0 0 0c-5.3 2-11 3.1-16.8 3.1c0 0 0 0 0 0c-5.8 0-11.5-1.1-16.8-3.1c0 0 0 0 0 0c-6.6-2.5-12.3-6.2-17-10.9c0 0 0 0 0 0c-.2-.2-.5-.5-.7-.8c-4.5-4.7-10.8-7.4-17.3-7.4s-12.8 2.7-17.3 7.4c-6 6.3-13.9 11-23 13.3c-25.7 6.4-51.8-9.2-58.2-34.9l-56-224c-6.4-25.7 9.2-51.8 34.9-58.2z"]
};
const faPiano = {
  prefix: 'far',
  iconName: 'piano',
  icon: [512, 512, [], "f8d4", "M432 384l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-96 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64-32 0zM48 336l416 0 0-8.4c0-6.1-3.4-11.6-8.8-14.3L396.8 284c-37.2-18.6-60.8-56.7-60.8-98.3C336 109.7 274.3 48 198.3 48L192 48C112.5 48 48 112.5 48 192l0 144zm464-8.4l0 8.4 0 24 0 24 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64 0-24 0-24L0 192C0 86 86 0 192 0l6.3 0C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"]
};
const faGunSquirt = {
  prefix: 'far',
  iconName: 'gun-squirt',
  icon: [576, 512, [], "e19d", "M104 32c13.3 0 24 10.7 24 24l0 8 320 0c41.8 0 77.4 26.7 90.5 64l13.5 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24l-13.5 0c-13.2 37.3-48.7 64-90.5 64l-199 0-18 72 41 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-53 0L199 455.8C195.5 470 182.7 480 168 480L64 480c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5L79.4 254.6C34.3 246.7 0 207.3 0 160c0-47.6 34.6-87.1 80-94.7L80 56c0-13.3 10.7-24 24-24zm24.5 224l-44 176 71 0 44-176-71 0zM448 208c26.5 0 48-21.5 48-48s-21.5-48-48-48l-344 0-8 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l115.5 0 49.5 0 187 0zM96 144l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faWheatAwnCircleExclamation = {
  prefix: 'far',
  iconName: 'wheat-awn-circle-exclamation',
  icon: [640, 512, [], "e598", "M504.7 7.2c9.4 9.4 9.4 24.6 0 33.9L366.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L471 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63.7 63.7c-21.6 7.1-41.4 18.2-58.4 32.5c-24.3-10.1-52.5-7.8-75 7l10.1 10.1c9.4 9.4 21 15.3 33.1 17.6c-11.9 17.2-20.9 36.7-26.1 57.7c-27.3-23.7-66.9-25.8-96.4-6.2l10.1 10.1c23 23 59.1 24.8 84.2 5.5c-2 10.7-3.1 21.7-3.1 32.9c0 7.4 .5 14.8 1.4 21.9c-5.8 2-11.8 3.6-17.8 4.7c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L41 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0L69.3 386.1c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L375 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L470.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM261.5 103.3c-25 25-25 65.5 0 90.5L271.7 204c20.5-31 17.2-73.3-10.2-100.6zm-79.2 79.2c-25 25-25 65.5 0 90.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6zM159.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faSnowman = {
  prefix: 'far',
  iconName: 'snowman',
  icon: [512, 512, [9731, 9924], "f7d0", "M256 0C189.7 0 136 53.7 136 120c0 19 4.4 37 12.3 53c-7.2 9.3-13.2 19.6-17.8 30.6L104 192.2l0-40.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 19.6-22.5-9.7c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l56 24 49.5 21.2c-.1 1.6-.1 3.1-.1 4.7c0 12.5 1.7 24.7 4.9 36.3C106.7 318.2 96 349.9 96 384c0 39.2 14.1 75.1 37.5 102.9c15.6 18.6 38.4 25.1 58.3 25.1l128.5 0c19.8 0 42.7-6.5 58.3-25.1C401.9 459.1 416 423.2 416 384c0-34.1-10.7-65.8-28.9-91.7c3.2-11.6 4.9-23.7 4.9-36.3c0-1.6 0-3.1-.1-4.7l49.5-21.2 56-24c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L456 171.6l0-19.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40.2-26.5 11.4c-4.6-11-10.6-21.3-17.8-30.6c7.9-16 12.3-34 12.3-53C376 53.7 322.3 0 256 0zM184 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 15.6-5 30-13.4 41.8c-6.9 9.6-5.7 22.9 2.8 31.1c16.4 16 26.6 38.3 26.6 63c0 11.3-2.1 22.1-6 32c-3.2 8.2-1.7 17.4 3.9 24.1C358.2 331.6 368 356.6 368 384c0 27.5-9.8 52.5-26.2 72c-3.8 4.6-11.1 8-21.5 8l-128.5 0c-10.4 0-17.7-3.4-21.5-8c-16.4-19.5-26.2-44.6-26.2-72c0-27.4 9.8-52.4 26.1-71.8c5.6-6.7 7.1-16 3.9-24.1c-3.9-9.9-6-20.7-6-32c0-24.7 10.2-47 26.6-63c8.5-8.3 9.7-21.5 2.8-31.1C189 150 184 135.6 184 120zm56-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24l0 3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9l0-3.2c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faUserAlien = {
  prefix: 'far',
  iconName: 'user-alien',
  icon: [448, 512, [], "e04a", "M112 167c0-67.7 52.1-119 112-119s112 51.3 112 119c0 33.9-18.3 69.4-46.1 102.4c-23.3 27.7-49.6 49.4-65.9 61.6c-16.3-12.2-42.6-34-65.9-61.6C130.3 236.4 112 201 112 167zM224 0C135.6 0 64 74.8 64 167c0 101 106.6 185 139.2 208.3c6.1 4.3 13.4 6.5 20.8 6.5s14.7-2.1 20.8-6.5C277.4 352 384 268.1 384 167C384 74.8 312.4 0 224 0zM0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-71.4-55.7-129.8-126.1-134.1c-22.6 22.1-44 38.6-56.7 47.7l48.3 0c40 0 73.6 27.1 83.5 64L50.9 464c9.9-36.9 43.5-64 83.5-64l48.3 0c-12.7-9.2-34-25.6-56.7-47.7C55.7 356.6 0 415 0 486.4zM208 222.9c0-30.3-24.6-54.9-54.9-54.9l-16 0c-5 0-9.1 4.1-9.1 9.1c0 30.3 24.6 54.9 54.9 54.9l16 0c5 0 9.1-4.1 9.1-9.1zM294.9 168c-30.3 0-54.9 24.6-54.9 54.9c0 5 4.1 9.1 9.1 9.1l16 0c30.3 0 54.9-24.6 54.9-54.9c0-5-4.1-9.1-9.1-9.1l-16 0z"]
};
const faShieldCheck = {
  prefix: 'far',
  iconName: 'shield-check',
  icon: [512, 512, [], "f2f7", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
const faMortarPestle = {
  prefix: 'far',
  iconName: 'mortar-pestle',
  icon: [512, 512, [], "f5a7", "M504.3 11.1c10.9 12.7 10.2 31.7-1.6 43.5L397.3 160l-144.9 0L461 6.2c13.5-9.9 32.3-7.8 43.2 4.9zM80 240l0 16c0 62.9 31.3 109.5 91.9 131c14.6 5.2 25.8 17.1 30.1 32.1s1 31-8.6 43.1c-.5 .6-1 1.2-1.4 1.8l128 0c-.5-.6-.9-1.2-1.4-1.8c-9.7-12.1-12.9-28.2-8.6-43.1s15.5-26.9 30.1-32.1c60.7-21.6 91.9-68.1 91.9-131l0-16L80 240zm432-24c0 13.3-10.7 24-24 24l-8 0 0 16c0 66-27.8 120.8-80 154.8c-13.1 8.5-27.7 15.7-43.9 21.5c10 12.6 17.7 27.1 22.5 42.9c.5 1.7 1 3.5 1.4 5.2c4.4 17.1-10.4 31.7-28.1 31.7l-192 0c-17.7 0-32.4-14.6-28.1-31.7c.4-1.8 .9-3.5 1.4-5.2c4.7-15.8 12.5-30.3 22.5-42.9c-16.1-5.7-30.8-12.9-43.9-21.5C59.8 376.8 32 322 32 256l0-16-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 448 0 8 0c13.3 0 24 10.7 24 24z"]
};
const faRoadBarrier = {
  prefix: 'far',
  iconName: 'road-barrier',
  icon: [640, 512, [], "e562", "M24 32c13.3 0 24 10.7 24 24l0 24 544 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 0 48 0 128 0 48 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152L48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32zM592 256l0-128-21.2 0-64 128 85.2 0zM48 256l21.2 0 64-128L48 128l0 128zM389.2 128l-74.3 0-64 128 74.3 0 64-128zM378.8 256l74.3 0 64-128-74.3 0-64 128zm-192-128l-64 128 74.3 0 64-128-74.3 0z"]
};
const faChartCandlestick = {
  prefix: 'far',
  iconName: 'chart-candlestick',
  icon: [512, 512, [], "e0e2", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zm272-8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l0-48zm64 176l0 64c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c-17.7 0-32 14.3-32 32zM160 128c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48z"]
};
const faBriefcaseBlank = {
  prefix: 'far',
  iconName: 'briefcase-blank',
  icon: [512, 512, [], "e0c8", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm232 48l-208 0-88 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-88 0z"]
};
const faSchool = {
  prefix: 'far',
  iconName: 'school',
  icon: [640, 512, [127979], "f549", "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92L568 96c39.8 0 72 32.2 72 72l0 272c0 39.8-32.2 72-72 72l-184 0-128 0L72 512c-39.8 0-72-32.2-72-72L0 168c0-39.8 32.2-72 72-72l96.7 0 138-92zM568 464c13.3 0 24-10.7 24-24l0-272c0-13.3-10.7-24-24-24l-104 0c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4L72 144c-13.3 0-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l184 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 184 0zM112 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM112 320l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm368 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-8.8-7.2-16-16-16z"]
};
const faIgloo = {
  prefix: 'far',
  iconName: 'igloo',
  icon: [576, 512, [], "f7ae", "M512 432l-112 0 0-64 128 0 0 48c0 8.8-7.2 16-16 16zM395.4 320c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80L144 320l0-128 288 0 0 128-36.6 0zm95.7-128c23.4 37 36.9 80.9 36.9 128l-48 0 0-128 11.1 0zM96 192l0 128-48 0c0-47.1 13.5-91 36.9-128L96 192zM288 80c5.4 0 10.7 .2 16 .5l0 63.5-179.2 0C167.7 104.3 225 80 288 80zm64 64l0-55.4c37.6 10.4 71.4 29.6 99.2 55.4L352 144zM176 368l0 64L64 432c-8.8 0-16-7.2-16-16l0-48 128 0zM64 480l112 0 224 0 112 0c35.3 0 64-28.7 64-64l0-96C576 160.9 447.1 32 288 32S0 160.9 0 320l0 96c0 35.3 28.7 64 64 64zM288 288c35.3 0 64 28.7 64 64l0 80-128 0 0-80c0-35.3 28.7-64 64-64z"]
};
const faBracketRound = {
  prefix: 'far',
  iconName: 'bracket-round',
  icon: [192, 512, ["parenthesis"], "28", "M156.6 43.7c6.8 11.4 3 26.1-8.3 32.9C115.3 96.3 48 160.7 48 256s67.3 159.7 100.3 179.4c11.4 6.8 15.1 21.5 8.3 32.9s-21.5 15.1-32.9 8.3C82 451.8 0 374.1 0 256S82 60.2 123.7 35.4c11.4-6.8 26.1-3 32.9 8.3z"]
};
const faParenthesis = faBracketRound;
const faJoint = {
  prefix: 'far',
  iconName: 'joint',
  icon: [640, 512, [], "f595", "M464 24l0 19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24zM592 264l0-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24zM120.2 436.8C171.7 450.7 235.2 464 288 464l27.4 0-52.6-63.1c-47 3.2-99.1 14.6-142.6 26.3c-5.8 1.6-11.7 3.2-17.5 4.8c5.8 1.7 11.6 3.3 17.5 4.8zM324.6 400l53.3 64 97.5 0-53.3-64-97.5 0zm160 0l53.3 64 54.1 0 0-64-107.4 0zM15.8 409.5c30.1-11 61.1-20.3 92-28.6C160.3 366.7 228.8 352 288 352l312 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-312 0c-59.2 0-127.7-14.7-180.2-28.8c-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"]
};
const faHorseSaddle = {
  prefix: 'far',
  iconName: 'horse-saddle',
  icon: [576, 512, [], "f8c3", "M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 32 0 .5 0c2.5 0 5 .1 7.5 .3l0-.3 56 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c5.4 9.4 9.1 20 10.7 31.3l9.9 69.2c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1l22.6 0 33.1 0 61.3 0C309.8 51.5 362.6 6.1 426.8 .6zM416 239l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-32 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-.2 1.4-.4 2.7-.8 3.9c0 .4 0 .7 0 1.1l0 32c0 40.3-27.1 74.2-64 84.7l0 49.1 38.7 11.3c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM288 160l-56 0-24 0 0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16zm-128 2.1c-27.6 7.2-48 32.3-48 62.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l1.3 .4 0-35.1c-36.9-10.4-64-44.4-64-84.7l0-13.9zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faMugMarshmallows = {
  prefix: 'far',
  iconName: 'mug-marshmallows',
  icon: [512, 512, [], "f7b7", "M197.7 125.7C194 122 192 117.1 192 112s2-10 5.7-13.7l60.7-60.7C262 34 266.9 32 272 32s10 2 13.7 5.7l60.7 60.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L344 128l-144 0-2.3-2.3zM32 64c0-17.7 14.3-32 32-32l128 0c7.5 0 14.4 2.6 19.8 6.9L175 75.7c-9.6 9.6-15 22.7-15 36.3c0 5.5 .9 10.9 2.6 16L32 128l0-64zM48 384c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-176-184 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0 0 176zM0 192c0-17.7 14.3-32 32-32l320 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 192zM384 336l16 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-16 0 0 128z"]
};
const faFilters = {
  prefix: 'far',
  iconName: 'filters',
  icon: [640, 512, [], "e17e", "M233.8 32C210.7 32 192 50.7 192 73.8c0 9.3 3.1 18.4 8.9 25.8L336 272.3l0 63.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-143.3L631.1 99.6c5.8-7.4 8.9-16.4 8.9-25.8C640 50.7 621.3 32 598.2 32L233.8 32zM378.9 249.2L246.5 80l339 0L453.1 249.2c-3.3 4.2-5.1 9.4-5.1 14.8l0 118.6-64-50.3 0-68.3c0-5.4-1.8-10.6-5.1-14.8zM163.4 96L41.8 96C18.7 96 0 114.7 0 137.8c0 9.3 3.1 18.4 8.9 25.8L144 336.3l0 31.9c0 12.3 5.6 23.9 15.3 31.5l92.9 73c21 16.5 51.8 1.5 51.8-25.2l0-111.3c0 0 0 0 0-.1l0-52.9-9.7-12.5-33.2 42.4c-3.3 4.2-5.1 9.4-5.1 14.8l0 86.6-64-50.3 0-36.3c0-5.4-1.8-10.6-5.1-14.8L54.5 144 195 144l-19.3-24.6c-5.5-7-9.6-15-12.3-23.4z"]
};
const faBellOn = {
  prefix: 'far',
  iconName: 'bell-on',
  icon: [640, 512, [128365], "f8fa", "M320 0c-17.7 0-32 14.3-32 32l0 17.9C215.5 61.4 160 124.2 160 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6l-303.4 0c25.8-40 39.7-86.7 39.7-134.6l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM0 200c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm536-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM597.5 21.3c-5.9-11.9-20.3-16.7-32.2-10.7l-64 32c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l64-32c11.9-5.9 16.7-20.3 10.7-32.2zM53.3 53.5l64 32c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-64-32C62.9 4.6 48.5 9.4 42.5 21.3s-1.1 26.3 10.7 32.2z"]
};
const faAngleRight = {
  prefix: 'far',
  iconName: 'angle-right',
  icon: [320, 512, [8250], "f105", "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"]
};
const faDialMed = {
  prefix: 'far',
  iconName: 'dial-med',
  icon: [576, 512, [], "e15f", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 288c0-53.6 37.7-98.4 88-109.4L264 288c0 13.3 10.7 24 24 24s24-10.7 24-24l0-109.4c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112zM288 128a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faHorse = {
  prefix: 'far',
  iconName: 'horse',
  icon: [576, 512, [128014], "f6f0", "M432 0c-1.8 0-3.5 .2-5.2 .6c-64.2 5.5-117 51-133.5 111.4L232 112l-33.1 0-22.6 0c-38.1 0-71.8 19-92.1 48.1C37.3 162.1 0 200.7 0 248l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2l49.8 0c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5l0 99.5c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-136.2c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7 0-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24L480 0l0 .3c-2.5-.2-5-.3-7.5-.3L472 0 440 0l-8 0zM416 240.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2L384 464l-48 0 0-117.8c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464l-49.8 0-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-35.5 28.8-64.2 64.2-64.2l22.6 0 33.1 0 81 0c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2l4.6 0 32 0 .5 0c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6l0 55c0 .5 0 1 0 1.5zM480 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faQ = {
  prefix: 'far',
  iconName: 'q',
  icon: [448, 512, [113], "51", "M48 256c0 97.2 78.8 176 176 176c35.7 0 69-10.6 96.7-28.9l-91-107.6c-8.6-10.1-7.3-25.3 2.8-33.8s25.3-7.3 33.8 2.8l90.5 107C383.7 340.6 400 300.2 400 256c0-97.2-78.8-176-176-176S48 158.8 48 256zM351.9 439.9C315.6 465.2 271.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 58.9-22.7 112.5-59.9 152.4l54.2 64.1c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-53.8-63.6z"]
};
const faMonitorWaveform = {
  prefix: 'far',
  iconName: 'monitor-waveform',
  icon: [576, 512, ["monitor-heart-rate"], "f611", "M64 80c-8.8 0-16 7.2-16 16l0 144 128 0c8.4 0 16.2 4.4 20.6 11.7l25.5 42.5 60.4-120.9c3.9-7.8 11.8-12.9 20.5-13.2s17 4.1 21.5 11.6l41 68.3 58.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-8.4 0-16.2-4.4-20.6-11.7l-25.5-42.5L245.5 354.7c-3.9 7.8-11.8 12.9-20.5 13.2s-17-4.1-21.5-11.6l-41-68.3L48 288l0 128c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faMonitorHeartRate = faMonitorWaveform;
const faLinkSimple = {
  prefix: 'far',
  iconName: 'link-simple',
  icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C98.1 144 48 194.1 48 256s50.1 112 112 112l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c88.4 0 160 71.6 160 160zM184 232l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faWhistle = {
  prefix: 'far',
  iconName: 'whistle',
  icon: [640, 512, [], "f460", "M119 95.2C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192c64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6l2 0c9 0 17.6-3.8 23.7-10.5l63.3-69.6c4.6-5.1 7.2-11.7 7.2-18.5c0-8.4-3.9-16.4-10.5-21.6L352.5 108.7C315.9 79.7 270.6 64 224 64c-38.8 0-74.8 11.5-105 31.2zM68.5 143.4c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c-4 4.6-7.9 9.4-11.5 14.3zM402.9 324.4c-21.3-11.1-47.5-4.8-61.4 14.8C315.4 376.1 272.5 400 224 400c-79.5 0-144-64.5-144-144s64.5-144 144-144c35.8 0 70.6 12.1 98.7 34.3l70 55.4-11.9 15.9c-8 10.6-5.8 25.6 4.8 33.6s25.6 5.8 33.6-4.8l11.2-14.9L582.6 351.8l-40.9 45L402.9 324.4zM224 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faG = {
  prefix: 'far',
  iconName: 'g',
  icon: [448, 512, [103], "47", "M224 80C126.8 80 48 158.8 48 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152l-149 0c-13.3 0-24-10.7-24-24s10.7-24 24-24L408 232c21.6 0 41.2 17.9 39.3 41.9C438.2 389.3 341.7 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C310.2 96.9 269.1 80 224 80z"]
};
const faWineGlassCrack = {
  prefix: 'far',
  iconName: 'wine-glass-crack',
  icon: [320, 512, ["fragile"], "f4bb", "M184 464l0-114c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0L264 0 194.9 0l-29 0L56 0 48.2 0c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350l0 114-64 0c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0 88 0 88 0c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0-64 0zM163.3 48c-.4 3.4-2 6.7-4.6 9.3l-52.3 52.3c-5.9 5.9-6.3 15.3-.9 21.6l76 89.8c1.6 1.9 3.9 3 6.4 3c5.8 0 9.9-5.9 7.8-11.3l-30.9-80.4c-2.8-7.2 0-15.3 6.5-19.3l43.4-27.1c5.6-3.5 8.5-10.2 7.2-16.7L217.6 48l24.2 0L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L78.2 48l85.1 0z"]
};
const faFragile = faWineGlassCrack;
const faSlotMachine = {
  prefix: 'far',
  iconName: 'slot-machine',
  icon: [640, 512, [], "e3ce", "M400 416l-288 0 0 32c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-32zm48 32c0 5.5-.7 10.9-2 16l82 0c22.1 0 40-17.9 40-40l0-206.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6L616 424c0 48.6-39.4 88-88 88l-144 0-256 0c-35.3 0-64-28.7-64-64l0-32c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l0-32C64 28.7 92.7 0 128 0L384 0c35.3 0 64 28.7 64 64l0 32c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l0 32zM400 96l0-32c0-8.8-7.2-16-16-16L128 48c-8.8 0-16 7.2-16 16l0 32 288 0zm48 48L64 144c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM112 176l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L133.9 224 112 224c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96 24c0-13.3 10.7-24 24-24l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L253.9 224 232 224c-13.3 0-24-10.7-24-24zm144-24l56 0c7.8 0 15.1 3.8 19.6 10.2s5.6 14.5 3 21.9l-40 112c-4.5 12.5-18.2 19-30.7 14.5s-19-18.2-14.5-30.7L373.9 224 352 224c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faNotesMedical = {
  prefix: 'far',
  iconName: 'notes-medical',
  icon: [512, 512, [], "f481", "M144 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 197.5c0 4.2-1.7 8.3-4.7 11.3l-58.5 58.5c-3 3-7.1 4.7-11.3 4.7L160 368c-8.8 0-16-7.2-16-16l0-256zM96 96l0 256c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm176 32c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0zm24 336l-160 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 376c0 75.1 60.9 136 136 136l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
const faCarWash = {
  prefix: 'far',
  iconName: 'car-wash',
  icon: [448, 512, [], "f5e6", "M224 128c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48zm-70.2 80l140.3 0c10.1 0 19.2 6.4 22.6 15.9L333.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM57.4 287.9c-.2 .5-.3 .9-.5 1.4C32.2 306.7 16 335.5 16 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.6c-.1-.5-.3-.9-.5-1.4L362 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L57.4 287.9zM384 368l0 32L64 400l0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48zM128 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM112 80c0-22.2-23-52-37.2-68.2C69 5.1 59 5.1 53.2 11.8C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48s48-16 48-48zm272 48c26.5 0 48-16 48-48c0-22.2-23-52-37.2-68.2c-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48z"]
};
const faEscalator = {
  prefix: 'far',
  iconName: 'escalator',
  icon: [640, 512, [], "e171", "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm182.1 85.8c16-14 36.6-21.8 57.9-21.8l104 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-70.9 0L249.9 490.2c-16 14-36.6 21.8-57.9 21.8L88 512c-48.6 0-88-39.4-88-88s39.4-88 88-88l70.9 0L390.1 133.8zM448 160c-9.7 0-19 3.5-26.3 9.9L183.8 378.1c-4.4 3.8-10 5.9-15.8 5.9l-80 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l104 0c9.7 0 19-3.5 26.3-9.9L456.2 245.9c4.4-3.8 10-5.9 15.8-5.9l80 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-104 0zM256 128c23.7 0 44.4 12.9 55.5 32L192 264.5l0-72.5c0-35.3 28.7-64 64-64z"]
};
const faCommentImage = {
  prefix: 'far',
  iconName: 'comment-image',
  icon: [512, 512, [], "e148", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9l-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5zM296 160c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6l-128 0-48 0-48 0c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8l48-64c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l9.6 12.8 52.4-76.3c3-4.3 7.9-6.9 13.2-6.9zM176 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faTemperatureHalf = {
  prefix: 'far',
  iconName: 'temperature-half',
  icon: [320, 512, [127777, "temperature-2", "thermometer-2", "thermometer-half"], "f2c9", "M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 200c0-8.8 7.2-16 16-16s16 7.2 16 16l0 122.7c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature2 = faTemperatureHalf;
const faThermometer2 = faTemperatureHalf;
const faThermometerHalf = faTemperatureHalf;
const faDongSign = {
  prefix: 'far',
  iconName: 'dong-sign',
  icon: [384, 512, [], "e169", "M296 32c-13.3 0-24 10.7-24 24l0 8-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 76.1c-21.9-17.6-49.7-28.1-80-28.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c30.3 0 58.1-10.5 80-28.1l0 4.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-176 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24zM112 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM24 448c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 448z"]
};
const faDonut = {
  prefix: 'far',
  iconName: 'donut',
  icon: [512, 512, [127849, "doughnut"], "e406", "M48 289.9c7.7 5 14.4 11.5 19.5 19.2c9.4 13 22 23.4 36.5 30.2c14.7 6.8 30.8 9.7 46.9 8.4l.6 0 .6 0c17.7-.2 35.3 3.3 51.7 10.1l.1 0c16.4 7 34.1 10.5 51.9 10.3l.3 0s0 0 0 0c17.8 .2 35.5-3.3 51.9-10.3l.1 0s0 0 0 0c16.4-6.8 34-10.2 51.7-10.1l.6 0 .6 0c16.1 1.3 32.2-1.5 46.9-8.3c14.6-6.7 27.1-17.1 36.5-30.1c5.1-7.8 11.8-14.3 19.5-19.3l0 14c0 21.7-14.2 48.5-52.4 72.4C374 399.9 319.1 416 256 416s-118-16.1-155.6-39.6C62.2 352.5 48 325.7 48 304l0-14.1zM256 48C114.6 48 0 119.6 0 208l0 96c0 88.4 114.6 160 256 160s256-71.6 256-160l0-96c0-88.4-114.6-160-256-160zm64 144c0 17.7-28.7 32-64 32s-64-14.3-64-32s28.7-32 64-32s64 14.3 64 32zM283.3 84.7c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zm-112 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm224 9.4l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 192l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm331.3 36.7l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-240 16l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm176 38.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faDoughnut = faDonut;
const faCapsules = {
  prefix: 'far',
  iconName: 'capsules',
  icon: [576, 512, [], "f46b", "M48 144c0-35.3 28.7-64 64-64s64 28.7 64 64l0 112L48 256l0-112zM0 144L0 368c0 61.9 50.1 112 112 112s112-50.1 112-112l0-178.4c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83l0-24.2c0-61.9-50.1-112-112-112S0 82.1 0 144zm283.4 73.3c-20.9-30.4-13.3-72.2 15.8-93c28.5-20.4 68-13.7 88.5 16.2l66.9 97.5L348.5 312.2l-65.1-94.9z"]
};
const faPooStorm = {
  prefix: 'far',
  iconName: 'poo-storm',
  icon: [448, 512, ["poo-bolt"], "f75a", "M175.3 10.1C179.8 3.8 187 0 194.8 0c58.8 0 132.5 41.8 140.5 121.2C364.2 135.7 384 165.5 384 200c0 2.2-.1 4.4-.2 6.6C421.3 221 448 257.4 448 300c0 55.2-44.8 100-100 100l-8.2 0c11.5-12.9 15.4-31.2 9.5-47.9l0-.1c28.1-.7 50.7-23.7 50.7-52c0-27-20.7-49.3-47-51.8c-7.6-.7-14.4-5-18.3-11.5s-4.5-14.5-1.7-21.5c1.9-4.7 3-9.8 3-15.2c0-18.6-12.7-34.3-30-38.7c-10.9-2.8-18.4-12.8-18-24.1c0-.5 0-1 0-1.5c0-40.2-26.7-68.8-58.4-81c1.3 5.6 2.4 11.6 2.4 16.8c0 38-19.6 61-39 73.6c-9.3 6-18.5 9.6-25.2 11.7c-3.4 1.1-6.3 1.8-8.4 2.2l-.4 .1c-2.2 .7-4.5 1-6.9 1l-.1 0c-22.1 0-40 17.9-40 40c0 5.4 1.1 10.5 3 15.2c2.9 7 2.3 15-1.7 21.5s-10.7 10.8-18.3 11.5C68.7 250.7 48 273 48 300c0 18 9.1 33.8 22.9 43.1c-7.3 12-9.1 27-4.2 40.8c1.6 4.6 3.8 8.8 6.6 12.5C31 384.7 0 346 0 300c0-42.6 26.7-79 64.2-93.4c-.2-2.2-.2-4.4-.2-6.6c0-47.6 37.8-86.3 84.9-87.9l.5-.1c.9-.2 2.4-.6 4.3-1.1c3.8-1.2 8.6-3.1 13.3-6.1c8.6-5.5 17-14.7 17-33.3l0 0c0-.3-.2-1.5-.7-4c-.6-2.8-1.5-6.1-2.6-9.9c-2.2-7.5-5-15.3-7.1-21.3c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1c-.5-1.6-1.1-3.1-1.5-4.3c-2.5-7.3-1.3-15.4 3.2-21.7zM282.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L233.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L182.1 384 112 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
const faPooBolt = faPooStorm;
const faTally1 = {
  prefix: 'far',
  iconName: 'tally-1',
  icon: [640, 512, [], "e294", "M128 40c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24z"]
};
const faFileVector = {
  prefix: 'far',
  iconName: 'file-vector',
  icon: [384, 512, [], "e64c", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM240 224l-96 0c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l0 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l96 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l0-96c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 368l0-96 96 0 0 96-96 0z"]
};
const faFaceFrownOpen = {
  prefix: 'far',
  iconName: 'face-frown-open',
  icon: [512, 512, [128550, "frown-open"], "f57a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFrownOpen = faFaceFrownOpen;
const faSquareDashed = {
  prefix: 'far',
  iconName: 'square-dashed',
  icon: [448, 512, [], "e269", "M88 32l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 80c-22.1 0-40 17.9-40 40l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16C0 71.4 39.4 32 88 32zM24 192c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm400 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm0-32c-13.3 0-24-10.7-24-24l0-16c0-22.1-17.9-40-40-40l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c48.6 0 88 39.4 88 88l0 16c0 13.3-10.7 24-24 24zm24 216l0 16c0 48.6-39.4 88-88 88l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c22.1 0 40-17.9 40-40l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zM48 376l0 16c0 22.1 17.9 40 40 40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-48.6 0-88-39.4-88-88l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24zM184 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0zM160 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z"]
};
const faBagShoppingPlus = {
  prefix: 'far',
  iconName: 'bag-shopping-plus',
  icon: [448, 512, [], "e651", "M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0zM48 416c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208L48 208l0 208zm72-80c0-13.3 10.7-24 24-24l56 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24z"]
};
const faSquareJ = {
  prefix: 'far',
  iconName: 'square-j',
  icon: [448, 512, [], "e273", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm304 56l0 136c0 53-43 96-96 96s-96-43-96-96l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHandPointUp = {
  prefix: 'far',
  iconName: 'hand-point-up',
  icon: [384, 512, [9757], "f0a6", "M64 64l0 177.6c5.2-1 10.5-1.6 16-1.6l16 0 0-32L96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0l0 24c0 66.3 53.7 120 120 120l48 0c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0-40 0zM0 320s0 0 0 0c0-18 6-34.6 16-48L16 64C16 28.7 44.7 0 80 0s64 28.7 64 64l0 82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64l0 64 0 24c0 92.8-75.2 168-168 168l-48 0C75.2 512 0 436.8 0 344l0-24zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM160 240c5.5 0 10.9 .7 16 2l0-2 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 16 0zm64 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24z"]
};
const faMoneyBill = {
  prefix: 'far',
  iconName: 'money-bill',
  icon: [576, 512, [], "f0d6", "M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faArrowUpBigSmall = {
  prefix: 'far',
  iconName: 'arrow-up-big-small',
  icon: [576, 512, ["sort-size-up"], "f88e", "M368 208l0-128 128 0 0 128-128 0zm-48 0c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L368 32c-26.5 0-48 21.5-48 48l0 128zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 368l64 0 0 64-64 0 0-64zm-48 0l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z"]
};
const faSortSizeUp = faArrowUpBigSmall;
const faBarcodeRead = {
  prefix: 'far',
  iconName: 'barcode-read',
  icon: [576, 512, [], "f464", "M56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48zm64 80c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm56 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm272 0c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224zm-208 8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm152-24c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zM528 56c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM56 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 4.4 3.6 8 8 8zm472-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8z"]
};
const faBaguette = {
  prefix: 'far',
  iconName: 'baguette',
  icon: [640, 512, [129366], "e3d8", "M578.6 83.6c-24.5-36.8-74.2-46.7-110.9-22.2l-69.7 46.5L433 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-41.9-41.9-74.5 49.6L321 223c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.1-45.1-74.5 49.6L209 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48.3-48.3L83.6 317.4c-36.8 24.5-46.7 74.2-22.2 110.9s74.2 46.7 110.9 22.2l384-256c36.8-24.5 46.7-74.2 22.2-110.9zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"]
};
const faBowlSoftServe = {
  prefix: 'far',
  iconName: 'bowl-soft-serve',
  icon: [512, 512, [], "e46b", "M256 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L172 64c-42 0-76 34-76 76c0 4.7 .4 9.3 1.2 13.8C51 162.5 16 203.2 16 252c0 29 12.3 55.1 32 73.3L48 344c0 57.4 46.6 104 104 104l30.1 0-20.4 40.8c-1.1 2.3-1.7 4.7-1.7 7.2c0 2.9 .8 5.8 2.4 8.4c2.9 4.7 8.1 7.6 13.6 7.6l160 0c5.5 0 10.7-2.9 13.6-7.6c1.6-2.6 2.4-5.5 2.4-8.4c0-2.4-.6-4.9-1.7-7.2L329.9 448l30.1 0c57.4 0 104-46.6 104-104l0-18.7c19.7-18.3 32-44.4 32-73.3c0-49.1-35.3-89.9-82-98.4c1.3-5.7 2-11.6 2-17.6C416 60.9 355.1 0 280 0L256 0zM396 304l-280 0c-28.7 0-52-23.3-52-52s23.3-52 52-52l12 0 6.5 0 33.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-21.3 0c-1.7-3.6-2.7-7.7-2.7-12c0-15.5 12.5-28 28-28l69.3 0c30.2 0 54.7-24.5 54.7-54.7c0-2.7-.2-5.3-.6-8C336.7 56.6 368 92.7 368 136c0 5.8-1.5 11.3-4.3 16L280 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l95.2 0 8.8 0 12 0c28.7 0 52 23.3 52 52s-23.3 52-52 52z"]
};
const faFaceHoldingBackTears = {
  prefix: 'far',
  iconName: 'face-holding-back-tears',
  icon: [512, 512, [129401], "e482", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 32l0 16 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7l0 6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14c-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6l0 32zm112 16a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm64 0l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6c-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9c-1 8.1-7.9 14-15.9 14c10 13.4 16 30 16 48s-6 34.6-16 48zM310.4 362.5c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9C328.3 413.8 298.3 434 256 434s-72.3-20.2-89.6-38.9c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4C212.1 373.9 230.1 386 256 386s43.9-12.1 54.4-23.5zM128 240c17.7 0 32-14.3 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32c17.7 0 32-14.3 32-32z"]
};
const faSquareUp = {
  prefix: 'far',
  iconName: 'square-up',
  icon: [448, 512, [11014, "arrow-alt-square-up"], "f353", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM119.2 217.4l91-84c3.8-3.5 8.7-5.4 13.9-5.4s10.1 1.9 13.9 5.4l91 84c4.6 4.2 7.2 10.1 7.2 16.4c0 12.3-10 22.3-22.3 22.3L272 256l0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-41.7 0C122 256 112 246 112 233.7c0-6.2 2.6-12.1 7.2-16.4z"]
};
const faArrowAltSquareUp = faSquareUp;
const faTrainSubwayTunnel = {
  prefix: 'far',
  iconName: 'train-subway-tunnel',
  icon: [512, 512, ["subway-tunnel"], "e2a3", "M256 48C141.1 48 48 141.1 48 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-114.9-93.1-208-208-208zm24 128l0 80 72 0 0-48c0-17.7-14.3-32-32-32l-40 0zm-48 0l-40 0c-17.7 0-32 14.3-32 32l0 48 72 0 0-80zM160 304l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64-192 0zm-48-96c0-44.2 35.8-80 80-80l128 0c44.2 0 80 35.8 80 80l0 160c0 27.7-14.1 52.2-35.5 66.5L401 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-57-57-108.1 0-57 57c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l36.5-36.5C126.1 420.2 112 395.7 112 368l0-160zm64 144a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm136-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSubwayTunnel = faTrainSubwayTunnel;
const faSquareExclamation = {
  prefix: 'far',
  iconName: 'square-exclamation',
  icon: [448, 512, ["exclamation-square"], "f321", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faExclamationSquare = faSquareExclamation;
const faSemicolon = {
  prefix: 'far',
  iconName: 'semicolon',
  icon: [192, 512, [], "3b", "M72 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 24 128a72 72 0 1 0 144 0zM84.4 347c1.4-6.4 7.1-11 13.6-11c7.3 0 13.9 6.2 13.9 14.3c0 2.7-.8 5.4-2.1 7.6L67.1 428l17.3-81zm-.7 145.8L150.8 383c6-9.8 9.2-21.2 9.2-32.7c0-34.2-27.7-62.3-61.9-62.3c-29.2 0-54.4 20.4-60.6 49L10.4 463.6C5 488.5 24 512 49.5 512c14 0 26.9-7.3 34.2-19.2z"]
};
const faBookmark = {
  prefix: 'far',
  iconName: 'bookmark',
  icon: [384, 512, [128278, 61591], "f02e", "M0 48C0 21.5 21.5 0 48 0l0 48 0 393.4 130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4 336 48 48 48 48 0 336 0c26.5 0 48 21.5 48 48l0 440c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488L0 48z"]
};
const faFanTable = {
  prefix: 'far',
  iconName: 'fan-table',
  icon: [448, 512, [], "e004", "M224 400a176 176 0 1 0 0-352 176 176 0 1 0 0 352zM448 224c0 115.6-87.6 210.8-200 222.7l0 17.3 112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-136 0L88 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-17.3C87.6 434.8 0 339.6 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM118.4 197.6c-16.6-41 3.2-87.6 44.2-104.1c12.3-5 26.3 1 31.2 13.3l29.2 72.2c16.7-23.7 45.8-37.5 76.6-33.2c43.8 6.1 74.2 46.6 68.1 90.4c-1.8 13.1-14 22.3-27.1 20.4l-77.1-10.8c12.2 26.4 9.6 58.4-9.6 82.9c-27.2 34.8-77.5 41-112.3 13.8c-10.4-8.2-12.3-23.2-4.1-33.7l47.9-61.4c-28.9-2.6-55.4-21-67-49.7zM224 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faAlignJustify = {
  prefix: 'far',
  iconName: 'align-justify',
  icon: [448, 512, [], "f039", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z"]
};
const faBatteryLow = {
  prefix: 'far',
  iconName: 'battery-low',
  icon: [576, 512, ["battery-1"], "e0b1", "M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm80 96l-64 0 0 128 64 0 0-128z"]
};
const faBattery1 = faBatteryLow;
const faCreditCardFront = {
  prefix: 'far',
  iconName: 'credit-card-front',
  icon: [576, 512, [], "f38a", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM96 280c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24zM376 128l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"]
};
const faBrainArrowCurvedRight = {
  prefix: 'far',
  iconName: 'brain-arrow-curved-right',
  icon: [640, 512, ["mind-share"], "f677", "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44l0-332c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c1.3 1.5 2.6 3.1 3.8 4.8c-5.7 8-9 17.7-9 28l0 16-20.6 0c-3.8-9.4-9.8-17.8-17.4-24.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40l0 332c0 19.8 13.1 36.5 31 42.1c6.5 20.5 16.6 36.8 26.4 49c-4.4 .6-8.8 1-13.4 1c-26.9 0-51.2-11.6-68-30zM539.3 244.7l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-4.6 4.6-11.5 5.9-17.4 3.5s-9.9-8.3-9.9-14.8l0-48-48 0c-35.3 0-64 28.7-64 64l0 35.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.7-2.2c-10.5-8.2-45-39.5-45-93.8c0-61.9 50.1-112 112-112l64 0 0-48c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5z"]
};
const faMindShare = faBrainArrowCurvedRight;
const faUmbrellaBeach = {
  prefix: 'far',
  iconName: 'umbrella-beach',
  icon: [576, 512, [127958], "f5ca", "M399.7 18.8c0 0 0 0 0 0c1.3 .5 2.6 .9 4 1.4c4.1 1.5 8.1 3 12 4.7c0 0 0 0 0 0C519.4 68.6 580.3 173.8 571.4 281.8c-1.6 19.2-21.5 30-39.6 23.4L349.7 239l-45.1-16.4L122.5 156.3c-18.1-6.6-26.4-27.7-15.3-43.4c64.2-90.8 182.8-132 292.6-94zM288.8 54.6c-48 6.4-92.7 29.5-125.8 65.4l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM413.3 211.1c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9c-3-1.2-6-2.4-9-3.5c-1-.4-2-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84l136.3 49.6zm45.2 16.4L524 251.3c-2.2-47-20.3-91.9-51-127.2c.4 35-4.5 69.8-14.5 103.3zM552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l192.7 0 76.9-211.4L338.7 269l-71 195L552 464z"]
};
const faHelmetUn = {
  prefix: 'far',
  iconName: 'helmet-un',
  icon: [512, 512, [], "e503", "M240 48c106 0 192 86 192 192l-176 0c-9.4 0-18 5.5-21.8 14.1L196.9 336 82.4 336c-19 0-34.4-15.4-34.4-34.4L48 240C48 134 134 48 240 48zm80 372.7l-77.7-68.6L271.5 288l48.5 0 0 132.7zm48 42.4L368 288l120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0C480 107.5 372.5 0 240 0S0 107.5 0 240l0 61.6C0 347.1 36.9 384 82.4 384l123.4 0 2.3 2 136 120c4.4 3.9 10 6 15.9 6l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.9 0-1.1-.9zM285.3 103.1c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-43.2 34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 43.2-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64z"]
};
const faLocationSmile = {
  prefix: 'far',
  iconName: 'location-smile',
  icon: [384, 512, ["map-marker-smile"], "f60d", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM136 128a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-79.4 76.9c4.5 6.7 21.6 23.1 47.4 23.1s42.9-16.4 47.4-23.1c6.1-9.2 18.5-11.7 27.7-5.5s11.7 18.5 5.5 27.7C262.9 265.7 234.5 292 192 292s-70.9-26.3-80.6-40.9c-6.1-9.2-3.6-21.6 5.5-27.7s21.6-3.6 27.7 5.5z"]
};
const faMapMarkerSmile = faLocationSmile;
const faArrowLeftToLine = {
  prefix: 'far',
  iconName: 'arrow-left-to-line',
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"]
};
const faArrowToLeft = faArrowLeftToLine;
const faBullseye = {
  prefix: 'far',
  iconName: 'bullseye',
  icon: [512, 512, [], "f140", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-272a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faSushi = {
  prefix: 'far',
  iconName: 'sushi',
  icon: [576, 512, [127843, "nigiri"], "e48a", "M524.5 302.9c23.1 7.7 46-12.3 41.5-36.3l-8.6-46c-7.1-37.7-24.8-71-49.8-97.2L421.7 268.8l102.8 34.1zM393.7 65.6L296.5 230.2c9 1 17.9 2.9 26.6 5.8l67.5 22.4 92.5-156.6C457.4 82.7 426.7 70 393.7 65.6zM357.5 64L246.6 64 119.9 278.4l120.9-41.9c5.7-2 11.6-3.6 17.5-4.7L357.5 64zM207.3 64C115 64 35.7 129.8 18.6 220.6l-8.5 45.2C5.6 290 28.9 310 52.1 302l21.1-7.3L209.5 64l-2.1 0zM32 336.7L32 352c0 53 43 96 96 96c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c18.8 0 36.4-5.4 51.2-14.8c2.9-1.8 6.6-1.8 9.5 0c14.8 9.4 32.4 14.8 51.2 14.8c17.3 0 33.6-4.6 47.6-12.6c2.7-1.6 6.1-1.6 8.8 0c14 8 30.3 12.6 47.6 12.6c53 0 96-43 96-96l0-14.6c-8.5 .8-17.4-.1-26.2-3.1L496 327.1l0 24.9c0 26.5-21.5 48-48 48c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-9.5 0-18.2-2.7-25.6-7.4c-18.6-11.7-42.3-11.7-60.8 0c-7.4 4.7-16.1 7.4-25.6 7.4c-8.7 0-16.8-2.3-23.8-6.3c-17.5-10-39-10-56.5 0c-7 4-15 6.3-23.8 6.3c-26.5 0-48-21.5-48-48l0-25.9-20.9 7.2c-9.1 3.2-18.3 4.2-27.1 3.3z"]
};
const faNigiri = faSushi;
const faMessageCaptions = {
  prefix: 'far',
  iconName: 'message-captions',
  icon: [512, 512, ["comment-alt-captions"], "e1de", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM120 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faCommentAltCaptions = faMessageCaptions;
const faTrashList = {
  prefix: 'far',
  iconName: 'trash-list',
  icon: [640, 512, [], "e2b1", "M170.5 51.6L151.5 80l113 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-61.7 0c-2.7 0-5.2 1.3-6.7 3.6zm115-26.6L322.2 80l13.7 0L384 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L356.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-169.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l61.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l169.1 0c8.4 0 15.3-6.5 16-14.8L332.3 128 83.7 128zM472 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM448 408c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z"]
};
const faBacon = {
  prefix: 'far',
  iconName: 'bacon',
  icon: [576, 512, [129363], "f7e5", "M441.7 216c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8c11.2-3.2 23.2-.1 31.4 8.1l96 96c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2zM262.9 196.4s0 0 0 0c-41.7 60.7-89.2 129.6-204.1 191.7l24.3 24.3C197.6 352.8 242.8 287 284.5 226.3l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L443.4 50.1c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 53-69.9 85.1c0 0 0 0 0 0l-2.3 3.4zM106.8 436.1l24.3 24.3c114.5-59.7 159.8-125.5 201.3-186l.2-.3s0 0 0 0l2.2-3.2s0 0 0 0c21.9-31.9 43.9-63.5 75.1-90.9c26.6-23.5 59.5-43.6 104.2-59.3L491.4 98c-49 15.1-82.4 35.1-108.3 58c-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3C269.3 304.9 221.9 374 106.8 436.1z"]
};
const faOption = {
  prefix: 'far',
  iconName: 'option',
  icon: [640, 512, [], "e318", "M172.1 120.4c-4.6-5.3-11.2-8.4-18.2-8.4L24 112C10.7 112 0 101.3 0 88S10.7 64 24 64l129.9 0c21 0 41 9.2 54.7 25.1L467.9 391.6c4.6 5.3 11.2 8.4 18.2 8.4L616 400c13.3 0 24 10.7 24 24s-10.7 24-24 24l-129.9 0c-21 0-41-9.2-54.7-25.1L172.1 120.4zM616 64c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0z"]
};
const faRaccoon = {
  prefix: 'far',
  iconName: 'raccoon',
  icon: [512, 512, [], "e613", "M336 93.1c12.7-16.1 33.6-24.3 54.1-20.6C376.5 57 356.8 48 336 48s-40.5 9-54.1 24.5c20.5-3.6 41.4 4.5 54.1 20.6zm0 69.5c-2.6 3.4-5.7 6.5-9.1 9.2l-35.8 28.6c3.4 1.9 6.8 4 10.1 6.2l10.9 7.3c1.1-12.3 11.4-21.9 23.9-21.9s22.8 9.6 23.9 21.9l10.9-7.3c3.3-2.2 6.7-4.2 10.1-6.2l-35.8-28.6c-3.4-2.7-6.5-5.8-9.1-9.2zm78.8 23.9l31.9-9.6c5.6-1.7 9.4-6.8 9.4-12.6c0-2.8-.9-5.6-2.6-7.9l-17.8-23.7-42.9-25.7c-14.4-8.6-32.9-.4-36.2 16c-1.8 8.9 1.5 18 8.6 23.7l49.6 39.7zM306.9 146.8c7.1-5.7 10.4-14.8 8.6-23.7c-3.3-16.4-21.9-24.7-36.2-16l-42.9 25.7-17.7 23.7c-1.7 2.3-2.6 5-2.6 7.9c0 5.8 3.8 10.9 9.4 12.6l31.9 9.6 49.6-39.7zM206.2 93.1L194.2 57.3c-1.5-4.4-2.2-9.1-2.2-13.8C192 19.5 211.5 0 235.5 0l1.3 0c3.3 0 6.5 .4 9.7 1.1l41 9.1C302.7 3.6 319.1 0 336 0s33.3 3.6 48.4 10.2l41-9.1c3.2-.7 6.5-1.1 9.7-1.1l1.3 0c24 0 43.5 19.5 43.5 43.5c0 4.7-.8 9.3-2.2 13.8L465.8 93.1l25.9 34.6c7.9 10.6 12.2 23.5 12.2 36.7c0 27-17.7 50.8-43.6 58.5l-35.3 10.6c-9.8 2.9-19.2 7.3-27.7 13l-18.8 12.6C366 267.5 351.2 272 336 272s-30-4.5-42.6-12.9l-18.8-12.6c-8.5-5.7-17.9-10.1-27.7-13l-35.3-10.6c-25.9-7.8-43.6-31.6-43.6-58.5c0-13.2 4.3-26.1 12.2-36.7l25.9-34.6zM144 241.9c4.7-4.5 9.6-8.8 14.6-12.8c11.3 10.9 25.2 19.2 40.9 24l6 1.8C159.1 282.9 128 333.8 128 392c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-10.9 .8-21.6 2.4-32L48 360l0 32c0 39.8 32.2 72 72 72l184 0 0-8c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c39.8 0 72 32.2 72 72l0 8 80 0 0-8c0-13.3-10.7-24-24-24s-24-10.7-24-24s10.7-24 24-24c39.8 0 72 32.2 72 72l0 32c0 13.3-10.7 24-24 24l-336 0C53.7 512 0 458.3 0 392L0 224 0 104C0 64.2 32.2 32 72 32s72 32.2 72 72l0 137.9zm-48 70L96 264l-48 0 0 48 47.9 0 .1-.1zM96 216l0-48-48 0 0 48 48 0zM307.3 364.4l-64-40c-11.2-7-14.7-21.8-7.6-33.1s21.8-14.7 33.1-7.6l64 40c11.2 7 14.7 21.8 7.6 33.1s-21.8 14.7-33.1 7.6zm56.4-7.6c-7-11.2-3.6-26 7.6-33.1l64-40c11.2-7 26-3.6 33.1 7.6s3.6 26-7.6 33.1l-64 40c-11.2 7-26 3.6-33.1-7.6zM48 120l48 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16zm240-8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faHandPointDown = {
  prefix: 'far',
  iconName: 'hand-point-down',
  icon: [384, 512, [], "f0a7", "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"]
};
const faArrowUpFromBracket = {
  prefix: 'far',
  iconName: 'arrow-up-from-bracket',
  icon: [448, 512, [], "e09a", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L79 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
};
const faHeadSideGear = {
  prefix: 'far',
  iconName: 'head-side-gear',
  icon: [512, 512, [], "e611", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288.6-28.1c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1l0-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 18l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 18c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3.1 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1l0 3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-3.4c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-18l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM184 224a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faTrashPlus = {
  prefix: 'far',
  iconName: 'trash-plus',
  icon: [448, 512, [], "e2b2", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zM204 376l0-68-68 0c-11 0-20-9-20-20s9-20 20-20l68 0 0-68c0-11 9-20 20-20s20 9 20 20l0 68 68 0c11 0 20 9 20 20s-9 20-20 20l-68 0 0 68c0 11-9 20-20 20s-20-9-20-20z"]
};
const faFileCad = {
  prefix: 'far',
  iconName: 'file-cad',
  icon: [512, 512, [], "e672", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM200 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm232 0l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 32l0 96 16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0zm-160 8c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 56 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-56zm32 0l0 40 32 0 0-40c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"]
};
const faObjectsAlignTop = {
  prefix: 'far',
  iconName: 'objects-align-top',
  icon: [512, 512, [], "e3c0", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM176 176l0 288-64 0 0-288 64 0zm-64-48c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-64 0zm288 48l0 160-64 0 0-160 64 0zm-64-48c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0z"]
};
const faFolder = {
  prefix: 'far',
  iconName: 'folder',
  icon: [512, 512, [128193, 128447, 61716, "folder-blank"], "f07b", "M0 96C0 60.7 28.7 32 64 32l132.1 0c19.1 0 37.4 7.6 50.9 21.1L289.9 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-161.4 0c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7L64 80z"]
};
const faFolderBlank = faFolder;
const faFaceAnxiousSweat = {
  prefix: 'far',
  iconName: 'face-anxious-sweat',
  icon: [576, 512, [], "e36a", "M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM48 416c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47zM335.6 272a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM288 320c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80z"]
};
const faCreditCardBlank = {
  prefix: 'far',
  iconName: 'credit-card-blank',
  icon: [576, 512, [], "f389", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24z"]
};
const faFileWaveform = {
  prefix: 'far',
  iconName: 'file-waveform',
  icon: [448, 512, ["file-medical-alt"], "f478", "M384 464l-256 0c-8.8 0-16-7.2-16-16l0-96-48 0 0 96c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L338.7 18.7C326.7 6.7 310.5 0 293.5 0L128 0C92.7 0 64 28.7 64 64l0 176 48 0 0-176c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM276.8 228.1c-4.4-7.7-12.7-12.3-21.5-12.1s-16.8 5.3-20.8 13.3l-45.5 91L164 282.7C159.5 276 152 272 144 272L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l107.2 0L172 381.3c4.7 7.1 12.9 11.2 21.5 10.6s16.1-5.6 20-13.2l43.9-87.9 9.8 17.1c4.3 7.5 12.2 12.1 20.8 12.1l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-26.1 0-25.1-43.9z"]
};
const faFileMedicalAlt = faFileWaveform;
const faMicrochipAi = {
  prefix: 'far',
  iconName: 'microchip-ai',
  icon: [512, 512, [], "e1ec", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-8 0c-35.3 0-64 28.7-64 64l0 8-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 8c0 35.3 28.7 64 64 64l8 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c35.3 0 64-28.7 64-64l0-8 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-8c0-35.3-28.7-64-64-64l-8 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40zM112 128c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256zm224 44c-11 0-20 9-20 20l0 128c0 11 9 20 20 20s20-9 20-20l0-128c0-11-9-20-20-20zM234.3 184c-3.2-7.3-10.4-12-18.3-12s-15.1 4.7-18.3 12l-56 128c-4.4 10.1 .2 21.9 10.3 26.3s21.9-.2 26.3-10.3l5.3-12 64.8 0 5.3 12c4.4 10.1 16.2 14.7 26.3 10.3s14.7-16.2 10.3-26.3l-56-128zM216 241.9L230.9 276l-29.8 0L216 241.9z"]
};
const faMug = {
  prefix: 'far',
  iconName: 'mug',
  icon: [576, 512, [], "f874", "M80 352c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-240L80 112l0 240zM32 96c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L32 96zM416 272l32 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-32 0 0 160z"]
};
const faPlaneUpSlash = {
  prefix: 'far',
  iconName: 'plane-up-slash',
  icon: [640, 512, [], "e22e", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L38.8 5.1zM576 338.1l0-40.6c0-19.1-9.7-36.9-25.8-47.2L400 154.2l0-26.2c0-20.6-5.8-49.8-16.5-74.4c-5.4-12.4-12.7-25-22.4-34.9C351.2 8.6 337.4 0 320 0c-17.4 0-31.1 8.8-40.7 18.7c-9.6 9.9-16.9 22.4-22.4 34.8C250 69.2 245 86.8 242.3 102.9L288 139l0-11c0-13.4 4.4-36.1 12.8-55.1c4.2-9.4 8.7-16.4 12.9-20.7c4.1-4.2 6.1-4.2 6.3-4.2c0 0 0 0 0 0c.6 0 2.8 .1 6.8 4.2c4.2 4.3 8.6 11.2 12.7 20.6C347.8 91.7 352 114.4 352 128l0 39.4c0 8.2 4.2 15.8 11.1 20.2L524.3 290.8c2.3 1.5 3.7 4 3.7 6.7l0 29.6-2.9-.9 43.8 34.6c4.4-6.4 7.1-14.2 7.1-22.7zM148.8 212.6l-59 37.8 12.9 20.2L89.8 250.3C73.7 260.6 64 278.4 64 297.5l0 40.6c0 27.1 26.4 46.4 52.2 38.1L240 336.6l0 27.4-48 36c-10.1 7.6-16 19.4-16 32l0 42.1c0 20.9 17 37.9 37.9 37.9c2.3 0 4.6-.3 6.9-1l-6.9-23 6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 0 .6-.2 2.4-.7 8.9-2.7c7.5-2.2 17.8-5.4 29.2-8.8c19.5-5.9 42-12.6 57.8-17.5l95 29.2c24 7.4 49.1-10.7 49.1-36.2l0-12.7-48-37.9 0 12.5 0 12 0 12.4-88.9-27.4c-4.6-1.4-9.5-1.4-14.1 0c-15.5 4.8-42 12.8-64.6 19.6c-9.1 2.7-17.5 5.3-24.3 7.3l0-23.9 54.4-40.8c6-4.5 9.6-11.6 9.6-19.2l0-53.5-46.6-36.8L112 327.1l0-29.6c0-2.7 1.4-5.3 3.7-6.7l73-46.7-39.9-31.5z"]
};
const faRadiation = {
  prefix: 'far',
  iconName: 'radiation',
  icon: [512, 512, [], "f7b9", "M113.2 104.7l41.9 72.5c-7.3 9.3-13.3 19.6-17.8 30.8l-83.8 0c9.5-40.1 30.6-75.8 59.7-103.3zm83.1 350.6l41.9-72.6c5.8 .8 11.8 1.2 17.8 1.2s11.9-.4 17.8-1.2l41.9 72.6C296.8 461 276.8 464 256 464s-40.8-3-59.7-8.7zM398.8 104.7c29.1 27.5 50.2 63.1 59.7 103.3l-83.8 0c-4.5-11.1-10.5-21.5-17.8-30.8l41.9-72.5zM160 256c8.8 0 15.8-7.2 17.6-15.9c3.5-17.4 12.7-32.8 25.5-44.1c6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1C-.2 241.6 14.3 256 32 256l128 0zm48 83.2L144 450.1c-8.8 15.3-3.7 35.1 12.6 41.9c30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9L304 339.2c-4.4-7.7-14.2-10.1-22.6-7.3c-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9l128 0c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10L304 172.9c-4.4 7.6-1.7 17.3 5 23.2c12.8 11.3 22 26.7 25.5 44.1zM256 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faPenCircle = {
  prefix: 'far',
  iconName: 'pen-circle',
  icon: [512, 512, [], "e20e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM357.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM151.9 289L257.1 183.8l71 71L222.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faBagSeedling = {
  prefix: 'far',
  iconName: 'bag-seedling',
  icon: [512, 512, [], "e5f2", "M91.9 150.1C84 181.9 80 214.4 80 247.2l0 17.7c0 32.7 4 65.3 11.9 97L97.5 384l317 0 5.5-22.1c7.9-31.7 11.9-64.3 11.9-97l0-17.7c0-32.7-4-65.3-11.9-97L414.5 128l-317 0-5.5 22.1zM427.5 48L84.5 48 98.7 80l314.5 0 14.2-32zM83.7 464l344.6 0-12.8-32-319 0L83.7 464zM55 99.8L35.4 55.7C33.2 50.6 32 45.1 32 39.6C32 17.7 49.7 0 71.6 0L440.4 0C462.3 0 480 17.7 480 39.6c0 5.5-1.2 11-3.4 16.1L457 99.8l9.7 38.7c8.9 35.5 13.4 72 13.4 108.7l0 17.7c0 36.6-4.5 73.1-13.4 108.7l-8.8 35.1 19.3 48.2c1.9 4.8 2.9 9.8 2.9 14.9c0 22.2-18 40.2-40.2 40.2L72.2 512C50 512 32 494 32 471.8c0-5.1 1-10.2 2.9-14.9l19.3-48.2-8.8-35.1C36.5 338 32 301.5 32 264.8l0-17.7c0-36.6 4.5-73.1 13.4-108.7L55 99.8zM144 160l2 0c47.3 0 88.4 26 110 64.5C277.6 186 318.7 160 366 160l2 0c8.8 0 16 7.2 16 16c0 59.2-45.9 107.6-104 111.7l0 40.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.3c-58.1-4.1-104-52.6-104-111.7c0-8.8 7.2-16 16-16z"]
};
const faChartSimple = {
  prefix: 'far',
  iconName: 'chart-simple',
  icon: [448, 512, [], "e473", "M240 80l0 352-32 0 0-352 32 0zM208 32c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0zM80 272l0 160-32 0 0-160 32 0zM48 224c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0zm320-80l32 0 0 288-32 0 0-288zm-48 0l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48z"]
};
const faCrutches = {
  prefix: 'far',
  iconName: 'crutches',
  icon: [640, 512, [], "f7f8", "M183 7L7 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15L201.9 347.8c1.9 1.9 3.8 3.6 5.8 5.3l3.5-3.5c1.1-1.1 1.8-2.4 2.2-3.9l9.9-44.4L89.9 168 168 89.9l95.7 95.7c1.9-2.2 3.9-4.3 5.9-6.4l27.8-27.8L201.9 56l15-15c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM402 402.7l-27.2 6L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.2-77.2c-8.2 3.9-16.8 6.9-25.8 8.9zM423 7c-9.4 9.4-9.4 24.6 0 33.9L599 217c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L457 7c-9.4-9.4-24.6-9.4-33.9 0zm-7.6 71.6L292.2 201.9c-11.8 11.8-20 26.8-23.7 43.1L244.6 352.6c-1.7 7.4-5.4 14.2-10.8 19.6L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l98.8-98.8c5.4-5.4 12.2-9.1 19.6-10.8L395 371.5c16.3-3.6 31.3-11.8 43.1-23.7L561.4 224.6l-33.9-33.9L456 262.1 377.9 184l71.4-71.4L415.4 78.6zM326.2 235.8L344 217.9 422.1 296l-17.8 17.9c-5.4 5.4-12.2 9.1-19.6 10.8l-89 19.8 19.8-89c1.7-7.4 5.4-14.2 10.8-19.6z"]
};
const faCircleParking = {
  prefix: 'far',
  iconName: 'circle-parking',
  icon: [512, 512, ["parking-circle"], "f615", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216 16l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-64 0 0 96zm64 48l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-136c0-17.7 14.3-32 32-32l80 0c53 0 96 43 96 96s-43 96-96 96z"]
};
const faParkingCircle = faCircleParking;
const faMarsStroke = {
  prefix: 'far',
  iconName: 'mars-stroke',
  icon: [512, 512, [9894], "f229", "M352 24c0-13.3 10.7-24 24-24L488 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1L409.9 136l31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31-27.7 27.7C370.7 227.2 384 264.1 384 304c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L342.1 136l-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31L430.1 48 376 48c-13.3 0-24-10.7-24-24zM208 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
const faLeafOak = {
  prefix: 'far',
  iconName: 'leaf-oak',
  icon: [512, 512, [], "f6f7", "M302 0c-33.4 0-62.4 22.7-70.5 55.1l-1.9 7.5c-25.2-23.7-64.8-23.2-89.4 1.4c-14.3 14.3-21 34.5-18.2 54.6l5.4 37.6c-20.5-2-41.6 5-57 20.4l-3.2 3.2c-23.2 23.2-29 58.7-14.3 88.1l12.4 24.7c7.2 14.4 11 30.4 11 46.5l0 62.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72.4-72.4 56.3 0c16.1 0 32.1 3.8 46.5 11l24.7 12.4c29.4 14.7 64.9 8.9 88.1-14.3l3.2-3.2c15.4-15.4 22.4-36.5 20.4-57l37.6 5.4c20 2.9 40.2-3.9 54.6-18.2c24.6-24.6 25.1-64.2 1.4-89.4l7.5-1.9c32.4-8.1 55.1-37.2 55.1-70.5c0-24.3-12.2-47-32.4-60.5l-7-4.6 2.8-11.3c6.6-26.4-1.1-54.3-20.3-73.5s-47.1-26.9-73.5-20.4l-11.3 2.8-4.6-7C349 12.1 326.3 0 302 0zM161.3 384.6L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L124.1 353.9l0-14.8c0-23.6-5.5-46.9-16-68L95.7 246.4c-5.4-10.9-3.3-24.1 5.3-32.7l3.2-3.2c7.7-7.7 19.7-8.8 28.7-2.8c21.5 14.3 49.7-3.5 46.1-29l-9.5-66.8c-.7-5.1 1-10.2 4.6-13.8c6.4-6.4 16.7-6.4 23 0l18.5 18.5c17.6 17.6 47.6 9.3 53.7-14.9L278 66.7c2.7-11 12.6-18.7 24-18.7c8.3 0 16 4.1 20.6 11l7.8 11.7c9.4 14.1 26.6 20.7 43 16.6L390 83.1c10-2.5 20.6 .4 27.9 7.7s10.2 17.9 7.7 27.9l-4.2 16.7c-4.1 16.4 2.6 33.6 16.6 43l11.7 7.8c6.9 4.6 11 12.3 11 20.6c0 11.3-7.7 21.2-18.7 24l-34.9 8.7c-24.1 6-32.5 36.1-14.9 53.7l18.5 18.5c6.4 6.4 6.4 16.7 0 23c-3.6 3.6-8.7 5.3-13.8 4.6l-66.8-9.5c-25.5-3.6-43.4 24.6-29 46.1c6 9 4.8 21-2.8 28.7l-3.2 3.2c-8.6 8.6-21.8 10.7-32.7 5.3l-24.7-12.4c-21.1-10.6-44.4-16-68-16l-8.3 0z"]
};
const faSquareBolt = {
  prefix: 'far',
  iconName: 'square-bolt',
  icon: [448, 512, [], "e265", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm298.1 19.6c5.8 4.7 7.6 12.9 4.3 19.6L249.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L198.1 272 128 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
const faVial = {
  prefix: 'far',
  iconName: 'vial',
  icon: [512, 512, [129514], "f492", "M329 7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15L30.2 335.8C10.9 355.2 0 381.4 0 408.8C0 465.8 46.2 512 103.2 512c27.4 0 53.6-10.9 73-30.2L456 201.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-32-32L361 39 329 7zm-151 249L344 89.9 422.1 168l-88 88-156.1 0z"]
};
const faGauge = {
  prefix: 'far',
  iconName: 'gauge',
  icon: [512, 512, ["dashboard", "gauge-med", "tachometer-alt-average"], "f624", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 181.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56zM160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faDashboard = faGauge;
const faGaugeMed = faGauge;
const faTachometerAltAverage = faGauge;
const faWandMagicSparkles = {
  prefix: 'far',
  iconName: 'wand-magic-sparkles',
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM461.4 48L496 82.6 386.2 192.3l-34.6-34.6L461.4 48zM80 429.4L317.7 191.7l34.6 34.6L114.6 464 80 429.4zM427.4 14.1L46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
};
const faMagicWandSparkles = faWandMagicSparkles;
const faLambda = {
  prefix: 'far',
  iconName: 'lambda',
  icon: [448, 512, [], "f66e", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l108.6 0c3 0 5.7 1.7 7.1 4.3l10.2 19.6L2 446.5c-5.3 12.2 .4 26.3 12.5 31.5s26.3-.3 31.5-12.5L178.4 158.9l151.3 291c9.6 18.5 28.8 30.2 49.7 30.2l44.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-44.6 0c-3 0-5.7-1.7-7.1-4.3L182.3 62.2C172.6 43.6 153.5 32 132.6 32L24 32z"]
};
const faE = {
  prefix: 'far',
  iconName: 'e',
  icon: [320, 512, [101], "45", "M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 432c-4.4 0-8-3.6-8-8l0-152 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 224 48 88c0-4.4 3.6-8 8-8l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32z"]
};
const faPizza = {
  prefix: 'far',
  iconName: 'pizza',
  icon: [576, 512, [127829], "f817", "M254.2 322.1c-8.4 3.8-14.2 12.2-14.2 21.9c0 13.3 10.7 24 24 24c9.8 0 18.2-5.8 21.9-14.2L318.1 386c-18.8 9-39.8 14-62.1 14c-79.5 0-144-64.5-144-144s64.5-144 144-144c22.2 0 43.3 5 62.1 14l-84.7 84.7c-25 25-25 65.5 0 90.5l20.8 20.8zm87.6 87.6l23.4 23.4C333.5 452.7 296.1 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c40.1 0 77.5 11.3 109.2 30.9l-23.4 23.4C316.4 88.1 287.1 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c31.1 0 60.4-8.1 85.8-22.3zM425.4 448c6.6-5.8 6.6-16 .3-22.3L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6L425.7 86.3C432 80 432 69.9 425.4 64C380.2 24.2 320.9 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c64.9 0 124.2-24.2 169.4-64zm71.7-82.8l-23.4-23.4C487.9 316.4 496 287.1 496 256s-8.1-60.4-22.3-85.8l23.4-23.4C516.7 178.5 528 215.9 528 256s-11.3 77.5-30.9 109.2zM464 256c0 22.2-5 43.3-14 62.1L387.9 256 450 193.9c9 18.8 14 39.8 14 62.1zm48 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6L489.7 425.7c6.2 6.2 16.4 6.3 22.3-.3zM216 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBowlChopsticksNoodles = {
  prefix: 'far',
  iconName: 'bowl-chopsticks-noodles',
  icon: [512, 512, [], "e2ea", "M13.1 93.6L128 72l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7 0 37.5 0 38 0 37.5 0 48s0 0 0 0l32 0s0 0 0 0l0-48 0-38.5 0-42L208 57l0-17c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 40 0 48 0 40 0 48s0 0 0 0l32 0s0 0 0 0l176 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272c0-26.5 21.5-48 48-48l80 0 0-48L16.2 176C7.3 176 0 168.7 0 159.7c0-8.8 7-16 15.7-16.2L128 140l0-32L18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6zM488.4 176L288 176l0-41 199.6-6.2C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6zm3.9-124.9L288 83l0-41L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5z"]
};
const faH3 = {
  prefix: 'far',
  iconName: 'h3',
  icon: [640, 512, [], "f315", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l142.1 0L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l88 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-72.6 0c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8l72.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-30.1 0L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64L400 64z"]
};
const faPenClip = {
  prefix: 'far',
  iconName: 'pen-clip',
  icon: [512, 512, ["pen-alt"], "f305", "M320 62.1l42.7-42.7c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L286.1 96 273 82.9c-9.4-9.4-24.6-9.4-33.9 0L137 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L205.1 49c28.1-28.1 73.7-28.1 101.8 0L320 62.1zm0 67.9L133.5 316.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L382.1 192 320 129.9z"]
};
const faPenAlt = faPenClip;
const faBridgeCircleExclamation = {
  prefix: 'far',
  iconName: 'bridge-circle-exclamation',
  icon: [640, 512, [], "e4ca", "M56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 240 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zM339.1 288.1c8-15.7 18.3-30 30.4-42.5C359 241.9 347.8 240 336 240l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c1.1 0 2.1 0 3.1 .1zM488 80l0 64-80 0 0-64 80 0zM360 80l0 64-80 0 0-64 80 0zM232 80l0 64-80 0 0-64 80 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faBadgePercent = {
  prefix: 'far',
  iconName: 'badge-percent',
  icon: [512, 512, [], "f646", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM192 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM337 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L175 303c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L337 209z"]
};
const faRotateReverse = {
  prefix: 'far',
  iconName: 'rotate-reverse',
  icon: [512, 512, [], "e631", "M418 187.1C391.2 124.1 328.7 80 256 80c-39.7 0-77.8 15.8-105.9 43.9l-4.1 4.1 35.7 35.7c6.6 6.6 10.3 15.6 10.3 25c0 19.5-15.8 35.3-35.3 35.3L40 224c-13.3 0-24-10.7-24-24L16 83.3C16 63.8 31.8 48 51.3 48c9.4 0 18.3 3.7 25 10.3L112 94.1l4.1-4.1C153.2 52.8 203.5 32 256 32c92.6 0 172.1 56.2 206.2 136.3c5.2 12.2-.5 26.3-12.7 31.5s-26.3-.5-31.5-12.7zM50 344.1c-5.2-12.2 .4-26.3 12.6-31.5s26.3 .4 31.5 12.6C121 388.1 183.4 432 256 432c39.7 0 77.8-15.8 105.9-43.9l4.1-4.1-35.7-35.7c-6.6-6.6-10.3-15.6-10.3-25c0-19.5 15.8-35.3 35.3-35.3L472 288c13.3 0 24 10.7 24 24l0 116.7c0 19.5-15.8 35.3-35.3 35.3c-9.4 0-18.3-3.7-25-10.3L400 417.9l-4.1 4.1C358.8 459.2 308.5 480 256 480c-92.5 0-171.8-56-206-135.9zM64 176l62.1 0L64 113.9 64 176zM448 336l-62.1 0L448 398.1l0-62.1z"]
};
const faUser = {
  prefix: 'far',
  iconName: 'user',
  icon: [448, 512, [128100, 62144], "f007", "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"]
};
const faSensor = {
  prefix: 'far',
  iconName: 'sensor',
  icon: [448, 512, [], "e028", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 56l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm96 0l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faComma = {
  prefix: 'far',
  iconName: 'comma',
  icon: [192, 512, [], "2c", "M120 353.4c0-9.6-7.8-17.4-17.4-17.4c-8.4 0-15.6 6-17.1 14.3L66.7 453.6l50.4-85.7c1.9-3.3 2.9-7 2.9-10.7l0-3.8zm48 0l0 3.8c0 12.3-3.3 24.4-9.5 35.1l-57.2 97.2C93.1 503.4 78 512 61.8 512L60 512c-24.3 0-44-19.7-44-44c0-2.6 .2-5.3 .7-7.9L38.2 341.7C43.9 310.6 71 288 102.6 288c36.1 0 65.4 29.3 65.4 65.4z"]
};
const faSchoolCircleCheck = {
  prefix: 'far',
  iconName: 'school-circle-check',
  icon: [640, 512, [], "e56b", "M333.3 4c-8.1-5.4-18.6-5.4-26.6 0l-138 92L72 96C32.2 96 0 128.2 0 168L0 440c0 39.8 32.2 72 72 72l184 0 128 0 10.8 0C349.5 480.1 320 427.5 320 368c0-16.5 2.3-32.5 6.5-47.7c-2.1-.2-4.3-.3-6.5-.3c-35.3 0-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24l104 0c4.7 0 9.4-1.4 13.3-4L320 52.8 450.7 140c3.9 2.6 8.6 4 13.3 4l104 0c13.3 0 24 10.7 24 24l0 52.5c18.8 12.3 35.1 28 48 46.3l0-98.8c0-39.8-32.2-72-72-72l-96.7 0L333.3 4zm20.2 260.6c10.9-15 24.1-28.2 39.1-39.1c4.7-10.2 7.3-21.5 7.3-33.5c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c12 0 23.3-2.6 33.5-7.3zM96 208l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0zM320 144c8.8 0 16 7.2 16 16l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
const faToiletPaperUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-under',
  icon: [512, 512, ["toilet-paper-reverse"], "e2a0", "M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3l212.7 0c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1L112 48c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456l0-104.9c-16.6 19.3-38.1 32.9-64 32.9l-288 0c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0L400 0c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192l0 264c0 30.9-25.1 56-56 56l-240 0c-30.9 0-56-25.1-56-56l0-40 48 0 0 40c0 4.4 3.6 8 8 8l240 0c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM112 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faToiletPaperReverse = faToiletPaperUnder;
const faLightEmergency = {
  prefix: 'far',
  iconName: 'light-emergency',
  icon: [448, 512, [], "e41f", "M352 304l0-96c0-70.7-57.3-128-128-128S96 137.3 96 208l0 96-48 0 0-96c0-97.2 78.8-176 176-176s176 78.8 176 176l0 96-48 0zM48 384l0 48 352 0 0-48L48 384zm0-48l352 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48zM160 208c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96c8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"]
};
const faArrowDownToArc = {
  prefix: 'far',
  iconName: 'arrow-down-to-arc',
  icon: [512, 512, [], "e4ae", "M256 464c114.9 0 208-93.1 208-208c0-13.3 10.7-24 24-24s24 10.7 24 24c0 141.4-114.6 256-256 256S0 397.4 0 256c0-13.3 10.7-24 24-24s24 10.7 24 24c0 114.9 93.1 208 208 208zM377.6 232.3l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 266.9 232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9z"]
};
const faDumpster = {
  prefix: 'far',
  iconName: 'dumpster',
  icon: [576, 512, [], "f793", "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160l94 0L140.5 32 49.7 32zM272 160l0-128-98.9 0L147.5 160 272 160zm32 0l124.5 0L402.9 32 304 32l0 128zm157.1 0l94 0c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32l-90.8 0 25.6 128zM86.4 240l403.3 0-20 160-363.3 0-20-160zM112 448l352 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 22-176 18 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0 4-32-48.4 0L80.4 192 32 192l4 32-12 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l18 0L64 448l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8z"]
};
const faVanShuttle = {
  prefix: 'far',
  iconName: 'van-shuttle',
  icon: [640, 512, [128656, "shuttle-van"], "f5b6", "M48 96l0 96 128 0 0-112L64 80c-8.8 0-16 7.2-16 16zm0 144l0 80c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l153.7 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l12.8 0c8.8 0 16-7.2 16-16l0-80-232 0-160 0L48 240zm176-48l112 0 0-112L224 80l0 112zm160 0l180.1 0L471.3 82.8c-1.5-1.8-3.7-2.8-6.1-2.8L384 80l0 112zM640 320c0 35.3-28.7 64-64 64c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l136 0 160 0 105.2 0c16.4 0 32 7.2 42.7 19.7L626.7 191.5c8.6 10.1 13.3 23 13.3 36.3l0 92.2zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faShuttleVan = faVanShuttle;
const faBuildingUser = {
  prefix: 'far',
  iconName: 'building-user',
  icon: [640, 512, [], "e4da", "M64 48l256 0c8.8 0 16 7.2 16 16l0 351.7c11.3-20 27.9-36.7 48-47.9l0-95.9L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.2 0 6.4-.2 9.5-.7c-6-10-9.5-21.8-9.5-34.4c0-4.4 .2-8.7 .7-13c-.2 0-.4 0-.7 0l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm344 56a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9l218.2 0c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1l-101.8 0c-51.4 0-93.1 41.7-93.1 93.1z"]
};
const faLightSwitch = {
  prefix: 'far',
  iconName: 'light-switch',
  icon: [384, 512, [], "e017", "M192 64c-10.4 0-19.3-6.7-22.6-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l105.4 0c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16L320 464c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L214.6 48c-3.3 9.3-12.2 16-22.6 16zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM144 368l96 0 0-88-96 0 0 88zm0-224l0 88 96 0 0-88-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-224z"]
};
const faSquareCaretLeft = {
  prefix: 'far',
  iconName: 'square-caret-left',
  icon: [448, 512, ["caret-square-left"], "f191", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"]
};
const faCaretSquareLeft = faSquareCaretLeft;
const faHighlighter = {
  prefix: 'far',
  iconName: 'highlighter',
  icon: [576, 512, [], "f591", "M184 296.6l0-48 22.5-16.2 113 113L303.4 368l-48 0c-12.7 0-24.9 5.1-33.9 14.1l-38.1 38.1-51.5-51.5 38.1-38.1c9-9 14.1-21.2 14.1-33.9zM502.8 90.2L347.9 306 246 204.1 461.8 49.2c1.1-.8 2.4-1.2 3.7-1.2c1.7 0 3.3 .7 4.5 1.9L502.1 82c1.2 1.2 1.9 2.8 1.9 4.5c0 1.3-.4 2.6-1.2 3.7zM255.4 416l48 0c15.5 0 30-7.4 39-20L541.8 118.2C548.4 109 552 97.9 552 86.5c0-14.4-5.7-28.2-15.9-38.4L503.9 15.9C493.7 5.7 479.9 0 465.5 0C454.1 0 443 3.6 433.8 10.2L156 209.6c-12.6 9-20 23.5-20 39l0 48L92.3 340.3c-10.7 10.7-14.1 26-10.1 39.5L9.4 452.7c-6 6-9.4 14.1-9.4 22.6L0 480c0 17.7 14.3 32 32 32l84.7 0c8.5 0 16.6-3.4 22.6-9.4l32.8-32.8c13.6 4 28.8 .6 39.5-10.1L255.4 416zM134.7 439.3L110.1 464l-44.1 0 46.7-46.7 22.1 22.1z"]
};
const faWavePulse = {
  prefix: 'far',
  iconName: 'wave-pulse',
  icon: [640, 512, ["heart-rate"], "f5f8", "M319.4 0c11.1-.3 21 7.1 23.8 17.9l79.3 303.9 27.1-57.7c9.2-19.6 29-32.2 50.7-32.2L616 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-115.7 0c-3.1 0-5.9 1.8-7.2 4.6L437.7 402.2c-4.3 9.1-13.9 14.6-23.9 13.7s-18.5-8.1-21-17.8L322.7 129.4 247.5 492.9c-2.2 10.9-11.6 18.8-22.7 19.1s-21-6.9-23.9-17.6L143.3 285.9c-1-3.5-4.1-5.9-7.7-5.9L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l111.6 0c25.2 0 47.3 16.8 54 41.1l31 112.6L296.5 19.1C298.8 8.2 308.2 .3 319.4 0z"]
};
const faHeartRate = faWavePulse;
const faKey = {
  prefix: 'far',
  iconName: 'key',
  icon: [512, 512, [128273], "f084", "M208 176c0-70.7 57.3-128 128-128s128 57.3 128 128s-57.3 128-128 128c-10.4 0-20.5-1.2-30.1-3.6c-8.1-2-16.7 .4-22.6 6.4L254.1 336 200 336c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24l0 40-64 0 0-78.1L205.2 228.7c5.9-5.9 8.3-14.5 6.4-22.6c-2.3-9.6-3.6-19.7-3.6-30.1zM336 0C238.8 0 160 78.8 160 176c0 9.5 .7 18.8 2.2 27.9L7 359c-4.5 4.5-7 10.6-7 17L0 488c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l27.2-27.2c9.1 1.4 18.4 2.2 27.9 2.2c97.2 0 176-78.8 176-176S433.2 0 336 0zm32 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faArrowLeftToBracket = {
  prefix: 'far',
  iconName: 'arrow-left-to-bracket',
  icon: [512, 512, [], "e669", "M295 401L167 273c-9.4-9.4-9.4-24.6 0-33.9L295 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-246.1 0 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0zM168 80L88 80c-22.1 0-40 17.9-40 40l0 272c0 22.1 17.9 40 40 40l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-48.6 0-88-39.4-88-88L0 120C0 71.4 39.4 32 88 32l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faHatSanta = {
  prefix: 'far',
  iconName: 'hat-santa',
  icon: [640, 512, [], "f7a7", "M64 352l51.7 0 78.6-196.4C212.5 109.9 256.8 80 305.9 80c35.4 0 69 15.6 91.8 42.6l19 22.5c-4-.7-8-1.1-12-1.1l-1.2 0c-37.3 0-67.6 30.3-67.6 67.6c0 10 2.2 19.8 6.4 28.8L395 352l53 0L385.9 220c-1.2-2.6-1.9-5.5-1.9-8.4c0-10.8 8.8-19.6 19.6-19.6l1.2 0c2.1 0 4.2 .3 6.3 1l47.1 14.9c1.9-2.7 4-5.1 6.3-7.4c0-14.3 5.5-28.7 16.4-39.6c2.2-2.2 4.6-4.2 7.1-6L434.4 91.6c-32-37.8-79-59.6-128.5-59.6c-68.8 0-130.7 41.9-156.3 105.8L64 352zM583.9 182.2C583 169.8 572.7 160 560 160s-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C489.8 217 480 227.3 480 240s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C537 310.2 547.3 320 560 320s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C630.2 263 640 252.7 640 240s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2zM0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 384c-26.5 0-48 21.5-48 48z"]
};
const faTamale = {
  prefix: 'far',
  iconName: 'tamale',
  icon: [320, 512, [129748], "e451", "M319.6 69.3L296.4 208l-.4 0-48.2 0L270.7 70.3c-6.4-4.6-14.9-8.8-25.4-12.1L229.2 208l-32.2 0L213.8 51.3c-12.5-1.8-25.3-2.7-37.8-3L176 208l-16 0-16 0 0-159.8c-12.5 .4-25.4 1.3-37.8 3L122.9 208l-32.2 0L74.7 58.2c-10.6 3.4-19 7.5-25.4 12.1L72.2 208 24 208l-.4 0L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM296 304l.4 0 23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512s-114-5-150.6-41.3c-7.3-7.3-10.7-17.7-9-27.9L23.6 304l.4 0 42.7 0c-3.7 10.5-3.6 22 .1 32.3L49.3 441.7c6.4 4.6 14.9 8.8 25.4 12.1l10.1-94.3c9.5 6.5 20.6 9.2 31.3 8.3l-10 92.9c12.5 1.8 25.3 2.6 37.8 3l0-108c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8c1.9 2.6 4.1 4.9 6.4 7l0 108c12.5-.4 25.4-1.3 37.8-3l-10-92.9c10.7 .9 21.8-1.7 31.3-8.3l10.1 94.3c10.6-3.4 19-7.5 25.4-12.1L253.2 336.3c3.7-10.3 3.8-21.7 .1-32.3l42.7 0zM24 240l136 0 136 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-104 0 28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272 24 272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faBoxCheck = {
  prefix: 'far',
  iconName: 'box-check',
  icon: [448, 512, [], "f467", "M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zM48 208l352 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm152-48L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM337 265c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L337 265z"]
};
const faBullhorn = {
  prefix: 'far',
  iconName: 'bullhorn',
  icon: [512, 512, [128226, 128363], "f0a1", "M432 73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9c0 0 0 .1 0 .1l0 128s0 0 0 0c0 0 0 .1 0 .1c80.1 1.9 156.5 34.5 213.3 91.3L432 406.1l0-332.1zM160 128l40.7 0c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3l0 144.3c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4l0 144.3c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2L208 456c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-104c-35.3 0-64-28.7-64-64l0-96c0-35.3 28.7-64 64-64l96 0zM112 352l0 104c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-104-48 0zM64 176c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16c0 0 0 0 0 0l48 0 48 0 0-128-96 0z"]
};
const faSteak = {
  prefix: 'far',
  iconName: 'steak',
  icon: [576, 512, [129385], "f824", "M301.5 72.6c-15.9 14.8-25.5 34.1-32.8 50.6c-4.2 9.6-7.7 18-10.9 25.7l-1.3 3.2c-9.3 22.5-18.4 44.6-39.1 65.3c-26.6 26.6-56.8 42.7-81.6 55.3c-2.8 1.4-5.5 2.8-8.1 4.1c0 0 0 0 0 0c-22.4 11.4-39.6 20.1-55.1 32.5C57.7 321.2 48 337.8 48 360c0 50 42.8 75.3 77.6 87.3C162.2 459.8 206.1 464 240 464c70.2 0 140.7-26.7 194-66.3c52.5-39.1 94-95.4 94-157.7c0-48.1-19-95-47-130c-27.6-34.5-67.9-62-113-62c-27.4 0-49.4 8.6-66.5 24.6zM268.8 37.4C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80c33.9 42.4 57.5 99.6 57.5 160c0 83.9-55.1 152.8-113.4 196.2C402.1 481.2 321.7 512 240 512c-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1c19.6-15.8 41.4-26.8 63.3-37.8c27.3-13.8 54.6-27.6 77.7-50.7c13.8-13.8 19.7-27.9 30-52.9c3.2-7.7 6.8-16.5 11.2-26.6c7.7-17.6 20.6-44.7 44.1-66.5zm36.8 122c2.5-6 4.8-11.8 7.1-17c6.9-15.7 13.3-27.1 21.5-34.7c7.5-7 17.5-11.7 33.9-11.7c25.4 0 53.3 16.2 75.5 44c22 27.5 36.5 64.1 36.5 100c0 40.8-28.3 84.6-74.7 119.2C359.4 393.4 298.6 416 240 416c-31 0-69.1-3.9-98.8-14.1C110.1 391.2 96 376.7 96 360c0-9 2.6-13.2 6.9-16.9c5.8-5 15-9.1 30.2-15.5l1.2-.5c29.3-12.4 71.2-30 117-75.8c28.6-28.6 42.9-63.7 54.3-91.9zM416 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faLocationCrosshairsSlash = {
  prefix: 'far',
  iconName: 'location-crosshairs-slash',
  icon: [640, 512, ["location-slash"], "f603", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-146-114.5c13.4-22.3 22.4-47.6 25.8-74.6l41.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-41.5 0C499.7 145.2 430.8 76.3 344 65.5L344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 41.5c-43.1 5.4-81.8 25-111.1 54.1L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-22 0-42.2 7.4-58.4 19.8l-38.6-30.2zM367.5 262.8l-65.5-51.3c5.5-2.2 11.6-3.5 17.9-3.5c26.5 0 48 21.5 48 48c0 2.3-.2 4.6-.5 6.8zm47.4 160.2l-41.9-33c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2l-41.9-33c-2.7 9.5-4.7 19.2-6 29.3L88 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l41.5 0c10.8 86.8 79.7 155.7 166.5 166.5l0 41.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-41.5c25.5-3.2 49.5-11.4 70.9-23.6z"]
};
const faLocationSlash = faLocationCrosshairsSlash;
const faPersonDolly = {
  prefix: 'far',
  iconName: 'person-dolly',
  icon: [512, 512, [], "f4d0", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM0 340.3L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-109.9L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3zM48 187.2C48 181 53 176 59.2 176c4.5 0 8.9 1.1 12.8 3l0 116.2L51.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3l0-85.3zm72 145.7l0-86.7 15.1 23.5c7.4 11.4 20 18.4 33.6 18.4l54.5 0 27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L339.7 410.3c-10-13.7-25.3-23.3-42.8-25.7L247.3 186.2c-3.2-12.9-16.2-20.7-29.1-17.5s-20.7 16.2-17.5 29.1L211.3 240l-38.2 0-49.3-76.7c-14.1-22-38.5-35.3-64.6-35.3C26.5 128 0 154.5 0 187.2l0 85.3c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L160.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L120 332.9zM288 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm69.4-55.8L449 353.4c17.1-4.3 27.6-21.7 23.3-38.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8L318.6 353c4.3 17.1 21.7 27.6 38.8 23.3z"]
};
const faGlobe = {
  prefix: 'far',
  iconName: 'globe',
  icon: [512, 512, [127760], "f0ac", "M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6l-139.2 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304l155 0c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4l-65.9 0c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"]
};
const faSynagogue = {
  prefix: 'far',
  iconName: 'synagogue',
  icon: [640, 512, [128333], "f69b", "M305.1 5.2c8.7-6.9 21-6.9 29.7 0L462.5 105.9C483.7 122.6 496 148.1 496 175l0 63 31-31c9.4-9.4 24.6-9.4 33.9 0l62.6 62.6c10.5 10.5 16.4 24.7 16.4 39.6L640 440c0 39.8-32.2 72-72 72l-96 0-88 0-128 0-88 0-96 0c-39.8 0-72-32.2-72-72L0 309.3c0-14.9 5.9-29.1 16.4-39.6L79 207c9.4-9.4 24.6-9.4 33.9 0l31 31 0-63c0-26.9 12.3-52.4 33.5-69.1L305.1 5.2zM496 464l72 0c13.3 0 24-10.7 24-24l0-130.7c0-2.1-.8-4.2-2.3-5.7L544 257.9l-45.7 45.7c-1.5 1.5-2.3 3.5-2.3 5.7L496 464zM448 175c0-12.2-5.6-23.8-15.2-31.4L320 54.6l-112.8 89c-9.6 7.6-15.2 19.2-15.2 31.4l0 134.2L192 464l64 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 64 0 0-154.7L448 175zM144 309.3c0-2.1-.8-4.2-2.3-5.7L96 257.9 50.3 303.6c-1.5 1.5-2.3 3.5-2.3 5.7L48 440c0 13.3 10.7 24 24 24l72 0 0-154.7zM327 124.3l15.9 28.1 32.3-.3c6.2-.1 10.1 6.7 7 12.1L365.7 192l16.4 27.8c3.2 5.4-.7 12.1-7 12.1l-32.3-.3L327 259.7c-3.1 5.4-10.9 5.4-13.9 0l-15.9-28.1-32.3 .3c-6.2 .1-10.1-6.7-7-12.1L274.3 192l-16.4-27.8c-3.2-5.4 .7-12.1 7-12.1l32.3 .3L313 124.3c3.1-5.4 10.9-5.4 13.9 0z"]
};
const faFileChartColumn = {
  prefix: 'far',
  iconName: 'file-chart-column',
  icon: [384, 512, ["file-chart-line"], "f659", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128zm88 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96zM128 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z"]
};
const faFileChartLine = faFileChartColumn;
const faPersonHalfDress = {
  prefix: 'far',
  iconName: 'person-half-dress',
  icon: [320, 512, [], "e548", "M154 .4A48 48 0 1 1 166 95.6 48 48 0 1 1 154 .4zM176 352l0-48s0 0 0 0l0-127.9s0 0 0 0l0-48c30.8 .8 59.1 17.7 74.3 44.6l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136s0 0 0 0zM62.9 184.6c17.1-30.3 47.2-50.6 81.1-55.5l0 108.6L113.3 336l30.7 0 0 48s0 0 0 0l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.2 0c-10.8 0-18.5-10.5-15.3-20.8l46.3-148L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5z"]
};
const faFolderImage = {
  prefix: 'far',
  iconName: 'folder-image',
  icon: [512, 512, [], "e18a", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM160 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm155.2 9.6c-4.5-6-11.6-9.6-19.2-9.6s-14.7 3.6-19.2 9.6l-54.2 72.2L202.7 265c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l80 0 48 0 144 0c9.1 0 17.4-5.1 21.5-13.3s3.2-17.9-2.3-25.1l-96-128z"]
};
const faCalendarPen = {
  prefix: 'far',
  iconName: 'calendar-pen',
  icon: [448, 512, ["calendar-edit"], "f333", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-91.2 51c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L240.6 258 255.5 243c14.7-14.7 38.6-14.7 53.3 0zM146.1 352.5L218 280.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.6c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faCalendarEdit = faCalendarPen;
const faRoadBridge = {
  prefix: 'far',
  iconName: 'road-bridge',
  icon: [640, 512, [], "e563", "M576 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-72 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-72 0c-8.8 0-16-7.2-16-16l0-384c0-8.8 7.2-16 16-16l72 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 72 0zm0-48L384 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64zM480 192c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zM24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 64 0 0-48-40 0 0-64 40 0 0-48L24 96zM272 304c-57.4 0-104 46.6-104 104l0 56-48 0 0-64c0-53-43-96-96-96c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 72c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-64c0-30.9 25.1-56 56-56l16 0 0-48-16 0zM200 144l0 64-80 0 0-64 80 0z"]
};
const faFaceSmileTear = {
  prefix: 'far',
  iconName: 'face-smile-tear',
  icon: [512, 512, [], "e393", "M338.7 446.9c4.3 .7 8.8 1.1 13.3 1.1c43.4 0 80-34.6 80-79c0-.7 0-1.4 0-2c20.3-32.1 32-70.2 32-111c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c29.4 0 57.4-6.1 82.7-17.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm136.3 61.9c10-8.7 25.2-7.6 33.9 2.4C187 339.8 215.5 360 256 360c13.3 0 24 10.7 24 24s-10.7 24-24 24c-58 0-98.8-29.4-122.1-56.3c-8.7-10-7.6-25.2 2.4-33.9zM352 416c-26.5 0-48-21-48-47c0-20 28.4-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C371.4 308.6 400 349 400 369c0 26-21.5 47-48 47zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faMessagePlus = {
  prefix: 'far',
  iconName: 'message-plus',
  icon: [512, 512, ["comment-alt-plus"], "f4a8", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM232 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faCommentAltPlus = faMessagePlus;
const faLocationArrow = {
  prefix: 'far',
  iconName: 'location-arrow',
  icon: [448, 512, [], "f124", "M224 208l-94.6 0 241.4-98.7L272 350.6l0-94.6c0-26.5-21.5-48-48-48zm-48 48l48 0 0 48 0 128c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l128 0z"]
};
const faC = {
  prefix: 'far',
  iconName: 'c',
  icon: [384, 512, [99], "43", "M343.5 131.7C275.8 63 166 63 98.3 131.7s-67.7 180 0 248.7s177.5 68.7 245.2 0c9.3-9.4 24.4-9.4 33.7 0s9.3 24.7 0 34.2c-86.3 87.5-226.3 87.5-312.6 0s-86.3-229.5 0-317S290.9 10 377.2 97.5c9.3 9.4 9.3 24.7 0 34.2s-24.4 9.4-33.7 0z"]
};
const faTabletButton = {
  prefix: 'far',
  iconName: 'tablet-button',
  icon: [448, 512, [], "f10a", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM224 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPersonDressFairy = {
  prefix: 'far',
  iconName: 'person-dress-fairy',
  icon: [640, 512, [], "e607", "M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm48.3 144c-7.1 0-13.4 4.7-15.4 11.6L255.6 336l128.7 0L351.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.5 0zm0-48l31.5 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L384 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4c-14.1 8-26.1 19.5-34.7 33.5C181.6 120.7 119 85.2 48 80.5L48 112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c32.1-.2 61.9-9.7 87-26.2c7.2 4.6 15.4 7.9 24.3 9.3l0 32.1C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM417.6 173.9c-8.6-14-20.6-25.5-34.7-33.5C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-32.1c8.9-1.4 17.1-4.7 24.3-9.3c25 16.4 54.9 26 87 26.2c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112l0-31.5c-71 4.7-133.6 40.2-174.4 93.3z"]
};
const faRectangleHistoryCircleUser = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-user',
  icon: [640, 512, [], "e4a4", "M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faBuildingLock = {
  prefix: 'far',
  iconName: 'building-lock',
  icon: [576, 512, [], "e4d6", "M64 48l256 0c8.8 0 16 7.2 16 16l0 245.7c4.6-5.2 10-9.6 16-13.1l0-24.6c0-30.5 12.2-58.2 32-78.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5l0-16-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm232 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faChartLineUp = {
  prefix: 'far',
  iconName: 'chart-line-up',
  icon: [512, 512, [], "e0e5", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zm272 96c0 13.3 10.7 24 24 24l54.1 0L304 270.1l-79-79c-9.4-9.4-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 79 79c9.4 9.4 24.6 9.4 33.9 0l111-111 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z"]
};
const faMailbox = {
  prefix: 'far',
  iconName: 'mailbox',
  icon: [576, 512, [128234], "f813", "M48 208c0-53 43-96 96-96s96 43 96 96l0 192L64 400c-8.8 0-16-7.2-16-16l0-176zM240 448l48 0 224 0c35.3 0 64-28.7 64-64l0-176c0-79.5-64.5-144-144-144L144 64C64.5 64 0 128.5 0 208L0 384c0 35.3 28.7 64 64 64l176 0zm48-240c0-36.9-13.9-70.5-36.7-96L432 112c53 0 96 43 96 96l0 176c0 8.8-7.2 16-16 16l-224 0 0-192zM104 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm256 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 24c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-16 0-80 0z"]
};
const faSignPosts = {
  prefix: 'far',
  iconName: 'sign-posts',
  icon: [576, 512, [], "e625", "M64 24l0 8L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l16 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 352 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 16 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L112 32l0-8c0-13.3-10.7-24-24-24S64 10.7 64 24zM528 80l0 288L48 368 48 80l480 0z"]
};
const faTruckBolt = {
  prefix: 'far',
  iconName: 'truck-bolt',
  icon: [640, 512, [], "e3d0", "M352 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-32 0-76.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l288 0zm32 368c0 53 43 96 96 96s96-43 96-96l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-122.7c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l64 0 32 0 24 0 8 0zM557.7 239.6c.1 .1 .3 .3 .4 .4l-142 0 0-96 42.7 0c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.2 84.6c-5.3-5.2-13.4-6.1-19.7-2.2l-128 80c-6.1 3.8-8.9 11.1-6.9 18s8.2 11.6 15.4 11.6l51.7 0-33.5 55.8c-3.8 6.3-2.8 14.5 2.5 19.6s13.4 6.1 19.7 2.2l128-80c6.1-3.8 8.9-11.1 6.9-18s-8.2-11.6-15.4-11.6l-51.7 0 33.5-55.8c3.8-6.3 2.8-14.5-2.5-19.6z"]
};
const faPizzaSlice = {
  prefix: 'far',
  iconName: 'pizza-slice',
  icon: [512, 512, [], "f818", "M122.2 35.6L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L476.4 389.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9c-22.8-1.6-41.9 14-47.5 34.7zM144.6 138C264.3 152.7 359.3 247.7 374 367.4L61.2 450.8 144.6 138zm12.5-46.8l11.3-42.3C325.6 60.7 451.3 186.4 463.1 343.7l-42.3 11.3c-19.7-136.2-127.5-244-263.7-263.7zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faMoneyBillWave = {
  prefix: 'far',
  iconName: 'money-bill-wave',
  icon: [576, 512, [], "f53a", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7l0-176c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192l0 176c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
const faChartArea = {
  prefix: 'far',
  iconName: 'chart-area',
  icon: [512, 512, ["area-chart"], "f1fe", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM286.1 225.9c9 9 21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1l27.3-27.3L432 257.8l0 78.2-288 0 0-92.1 80-80 62.1 62.1zM320 192l-33.9-33.9-39.4-39.4c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9L96 352c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-5.6 5.6L320 192z"]
};
const faAreaChart = faChartArea;
const faHouseFlag = {
  prefix: 'far',
  iconName: 'house-flag',
  icon: [640, 512, [], "e50d", "M472 0c-13.3 0-24 10.7-24 24l0 8 0 160 0 320 48 0 0-320 128 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L496 32l0-8c0-13.3-10.7-24-24-24zM416 133L286.3 36.7c-8.5-6.3-20.1-6.3-28.6 0l-248 184c-10.6 7.9-12.9 22.9-5 33.6s22.9 12.9 33.6 5L64 240.2 64 432c0 44.2 35.8 80 80 80l256 0c5.5 0 10.8-.6 16-1.6l0-50.7c-4.7 2.7-10.2 4.3-16 4.3l-48 0 0-120c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 120-48 0c-17.7 0-32-14.3-32-32l0-227.4L272 85.9 416 192.7l0-59.8zM304 352l0 112-64 0 0-112 64 0z"]
};
const faCircleThreeQuartersStroke = {
  prefix: 'far',
  iconName: 'circle-three-quarters-stroke',
  icon: [512, 512, [], "e5d4", "M256 48l0 176c0 17.7 14.3 32 32 32l176 0c0-114.9-93.1-208-208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faPersonCircleMinus = {
  prefix: 'far',
  iconName: 'person-circle-minus',
  icon: [576, 512, [], "e540", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
const faScalpel = {
  prefix: 'far',
  iconName: 'scalpel',
  icon: [512, 512, [], "f61d", "M421.4 59.2c5.1-6.1 13-9.2 20.9-8.5C454.6 52 464 62.4 464 74.7c0 5.9-2.2 11.6-6.1 16L325.1 240l-56.3 0L421.4 59.2zM227.7 288l.7 0 96.8 0c13.7 0 26.8-5.9 35.9-16.1L493.8 122.6C505.5 109.4 512 92.3 512 74.7c0-37-28.1-68-64.9-71.7c-23.7-2.4-47 7.1-62.4 25.3L206.1 240l-.4 .5-5.6 6.7-12.2 14.5c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l19 0 8.8 0zm-63 36.7l-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0-4.7 4.7z"]
};
const faBan = {
  prefix: 'far',
  iconName: 'ban',
  icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faCancel = faBan;
const faBellExclamation = {
  prefix: 'far',
  iconName: 'bell-exclamation',
  icon: [448, 512, [], "f848", "M224 0c-17.7 0-32 14.3-32 32l0 17.9C119.5 61.4 64 124.2 64 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L256 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM256 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80z"]
};
const faCircleBookmark = {
  prefix: 'far',
  iconName: 'circle-bookmark',
  icon: [512, 512, ["bookmark-circle"], "e100", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 176l0 192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4l0-192c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z"]
};
const faBookmarkCircle = faCircleBookmark;
const faEggFried = {
  prefix: 'far',
  iconName: 'egg-fried',
  icon: [512, 512, [], "f7fc", "M403.9 162.5c-26.9-6.9-56.4-20.3-82.6-35.6s-52.4-34.3-71.6-54.3c-30.6-31.9-81.3-32.9-113.1-2.2c-14.5 14-22.6 32-24.3 50.6C107.7 173.6 92.7 244.5 63 296c-30.9 53.6-12.6 122.1 41 153s122.1 12.6 153-41c14.7-25.4 38.1-45.6 61.1-59.7c23.3-14.3 50.6-25.3 77.1-29c12.7-1.8 25.3-6.7 36.4-15c35.5-26.3 42.9-76.4 16.6-111.9c-11.4-15.4-27.2-25.4-44.4-29.8zM284.3 39.3c30.4 31.6 89.1 65.9 131.5 76.7c27.5 7 52.8 23.2 71 47.8c42.1 56.8 30.2 137-26.6 179.1c-17.8 13.2-37.9 21.1-58.4 24c-37.2 5.2-84.5 32.7-103.3 65.2c-44.2 76.5-142 102.7-218.6 58.6S-22.7 348.5 21.4 272c24.8-42.9 38.7-105.9 43.1-155.2C67.1 87 80.1 58 103.3 35.7c51-49 132-47.4 181 3.6zM112 240a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112-32c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72c0 8.8 7.2 16 16 16s16-7.2 16-16c0-22.1 17.9-40 40-40z"]
};
const faFaceWeary = {
  prefix: 'far',
  iconName: 'face-weary',
  icon: [512, 512, [], "e3a1", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm34.8-155.6c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
const faUniformMartialArts = {
  prefix: 'far',
  iconName: 'uniform-martial-arts',
  icon: [640, 512, [], "e3d1", "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4V392c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V248.4c0-13.6 4.5-27.2 9.7-39c5.4-12.1 12.5-24.4 19.7-35.8c12.1-19.2 26.5-37.4 37.5-57.3c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2V288H160V209.2c-6.7 11.3-16 25.7-16 39.2V392c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2C104.3 23.8 144.6 0 188.4 0H240c9 0 17.2 5 21.3 13L320 127.1 378.7 13C382.8 5 391 0 400 0h51.6c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5V392c0 30.9-25.1 56-56 56H552c-30.9 0-56-25.1-56-56V248.4c0-13.5-9.3-27.9-16-39.2V288H432V128c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7c11 19.9 25.4 38.1 37.5 57.3c7.2 11.4 14.4 23.7 19.7 35.8c5.2 11.8 9.7 25.4 9.7 39V392c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V248.4c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48h-37L291.2 288h-54L293 179.6 225.4 48h-37zM160 384h48v64c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V384zm0-64v32H290.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H480V320H160z"]
};
const faCameraRotate = {
  prefix: 'far',
  iconName: 'camera-rotate',
  icon: [640, 512, [], "e0d8", "M263.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L201.4 96 128 96c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C422.4 47.4 401 32 376.9 32L263.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-384 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM362.4 237.6l-15 15c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l60.7 0c8.8 0 16-7.2 16-16l0-60.7c0-6.2-5.1-11.3-11.3-11.3c-3 0-5.9 1.2-8 3.3l-16.1 16.1C375.1 185.8 348 176 320 176c-32 0-62.6 12.7-85.3 35.3L231 215c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l3.7-3.7C282.3 231.6 300.8 224 320 224c15.3 0 30.1 4.8 42.4 13.6zM208 380.7c0 6.2 5.1 11.3 11.3 11.3c3 0 5.9-1.2 8-3.3l16.1-16.1C264.9 390.2 292 400 320 400c32 0 62.6-12.7 85.3-35.3L409 361c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-3.7 3.7C357.7 344.4 339.2 352 320 352c-15.3 0-30.1-4.8-42.4-13.6l15-15c2.1-2.1 3.3-5 3.3-8c0-6.2-5.1-11.3-11.3-11.3L224 304c-8.8 0-16 7.2-16 16l0 60.7z"]
};
const faSunDust = {
  prefix: 'far',
  iconName: 'sun-dust',
  icon: [512, 512, [], "f764", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1s0 0 0 0l37.6-37.6c-3.4-3.4-7.7-5.7-12.6-6.6L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c.9 4.9 3.3 9.3 6.6 12.6l37.6-37.6s0 0 0 0L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112c0 30.9 12.5 58.9 32.8 79.2l33.9-33.9C199.2 289.7 192 273.7 192 256c0-35.3 28.7-64 64-64c17.7 0 33.7 7.2 45.3 18.7l33.9-33.9C314.9 156.5 286.9 144 256 144zm256 16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCommentText = {
  prefix: 'far',
  iconName: 'comment-text',
  icon: [512, 512, [], "e14d", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-72 0z"]
};
const faSprayCanSparkles = {
  prefix: 'far',
  iconName: 'spray-can-sparkles',
  icon: [512, 512, ["air-freshener"], "f5d0", "M381.8 51.6C383 51 384 49.4 384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4zM448 64l12.4 29.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64zm32 160l-12.4-29.8c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224zm-34.2-76.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4zM128 0C110.3 0 96 14.3 96 32l0 96 128 0 0-96c0-17.7-14.3-32-32-32L128 0zm96 208c26.5 0 48 21.5 48 48l0 184c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-184c0-26.5 21.5-48 48-48l128 0zM96 160c-53 0-96 43-96 96L0 440c0 39.8 32.2 72 72 72l176 0c39.8 0 72-32.2 72-72l0-184c0-53-43-96-96-96L96 160zM224 336A64 64 0 1 0 96 336a64 64 0 1 0 128 0z"]
};
const faAirFreshener = faSprayCanSparkles;
const faSignalBars = {
  prefix: 'far',
  iconName: 'signal-bars',
  icon: [640, 512, ["signal-alt", "signal-alt-4", "signal-bars-strong"], "f690", "M576 448l0-384c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16s16-7.2 16-16zM496 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 384c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-384zM416 448l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16zM336 192c0-35.3 28.7-64 64-64s64 28.7 64 64l0 256c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-256zM240 464c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16zm0-208c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64zM80 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 16 448a64 64 0 1 1 128 0z"]
};
const faSignalAlt = faSignalBars;
const faSignalAlt4 = faSignalBars;
const faSignalBarsStrong = faSignalBars;
const faDiamondExclamation = {
  prefix: 'far',
  iconName: 'diamond-exclamation',
  icon: [512, 512, [], "e405", "M51.3 256L256 51.3 460.7 256 256 460.7 51.3 256zm233-244.3c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faStar = {
  prefix: 'far',
  iconName: 'star',
  icon: [576, 512, [11088, 61446], "f005", "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"]
};
const faDialMin = {
  prefix: 'far',
  iconName: 'dial-min',
  icon: [576, 512, [], "e161", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM271 271l-77.4 77.4c-27.8-43.4-22.8-101.7 15.1-139.6c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4c-37.9 37.9-96.2 43-139.6 15.1L305 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM174.9 401.1A160 160 0 1 0 401.1 174.9 160 160 0 1 0 174.9 401.1zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faRepeat = {
  prefix: 'far',
  iconName: 'repeat',
  icon: [512, 512, [128257], "f363", "M22.8 280C9.6 279.3-.6 268 0 254.8l.4-8C5.3 148.9 86.2 72 184.2 72L304 72l0-36.4C304 15.9 319.9 0 339.6 0c8.8 0 17.3 3.3 23.8 9.1l76.7 69c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-76.7 69c-6.5 5.9-15 9.1-23.8 9.1c-19.6 0-35.6-15.9-35.6-35.6l0-36.4-119.8 0C111.7 120 52 176.8 48.4 249.2l-.4 8C47.3 270.4 36 280.6 22.8 280zM352 128.5L388.1 96 352 63.5l0 65zM489.2 232c13.2 .7 23.4 11.9 22.8 25.2l-.4 8C506.7 363.1 425.8 440 327.8 440L208 440l0 36.4c0 19.6-15.9 35.6-35.6 35.6c-8.8 0-17.3-3.3-23.8-9.1l-76.7-69c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l76.7-69c6.5-5.9 15-9.1 23.8-9.1c19.6 0 35.6 15.9 35.6 35.6l0 36.4 119.8 0c72.5 0 132.2-56.8 135.8-129.2l.4-8c.7-13.2 11.9-23.4 25.2-22.8zM160 383.5L123.9 416 160 448.5l0-65z"]
};
const faCross = {
  prefix: 'far',
  iconName: 'cross',
  icon: [384, 512, [128327, 10013], "f654", "M112 48c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64 64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0 0 192c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-192-64 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l64 0 0-64zm112 0l-64 0 0 88c0 13.3-10.7 24-24 24l-88 0 0 64 88 0c13.3 0 24 10.7 24 24l0 216 64 0 0-216c0-13.3 10.7-24 24-24l88 0 0-64-88 0c-13.3 0-24-10.7-24-24l0-88z"]
};
const faPageCaretDown = {
  prefix: 'far',
  iconName: 'page-caret-down',
  icon: [384, 512, ["file-caret-down"], "e429", "M48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384zm272 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64zM192 352c-4.5 0-8.8-1.9-11.8-5.2l-75.7-82.6c-14.1-15.4-3.2-40.2 17.7-40.2l139.6 0c20.9 0 31.8 24.8 17.7 40.2l-75.7 82.6c-3 3.3-7.3 5.2-11.8 5.2z"]
};
const faFileCaretDown = faPageCaretDown;
const faBox = {
  prefix: 'far',
  iconName: 'box',
  icon: [448, 512, [128230], "f466", "M342.4 80L248 80l0 80 140.4 0L357 89.5c-2.6-5.8-8.3-9.5-14.6-9.5zM400 208L48 208l0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208zM59.6 160L200 160l0-80-94.4 0c-6.3 0-12.1 3.7-14.6 9.5L59.6 160zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38l236.8 0z"]
};
const faVenusMars = {
  prefix: 'far',
  iconName: 'venus-mars',
  icon: [640, 512, [9892], "f228", "M176 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM352 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6C66.2 338.7 0 265.1 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c14.6-7.6 28.1-16.8 40.4-27.5C335.2 354.8 366 368 400 368c70.7 0 128-57.3 128-128s-57.3-128-128-128c-8.6 0-17.1 .9-25.2 2.5c-4.9-15.8-11.6-30.7-19.9-44.7C369.3 66 384.4 64 400 64c39.9 0 76.8 13.3 106.3 35.7L558.1 48 504 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L616 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-51.7 51.7C562.7 163.2 576 200.1 576 240c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"]
};
const faClockSevenThirty = {
  prefix: 'far',
  iconName: 'clock-seven-thirty',
  icon: [512, 512, [], "e351", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-56.7-20 30c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l64-96c5.9-8.8 16.8-12.7 26.9-9.7s17 12.4 17 23l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faArrowPointer = {
  prefix: 'far',
  iconName: 'arrow-pointer',
  icon: [320, 512, ["mouse-pointer"], "f245", "M144 272l85.8 0L48 110.4l0 246.4 59.9-68.4C117 278 130.2 272 144 272zM0 426L0 55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5c0 12.2-9.9 22.1-22.1 22.1l-127.4 0 59.1 126.8c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L126.7 339.7 38.6 440.5C34.4 445.3 28.4 448 22 448c-12.2 0-22-9.9-22-22z"]
};
const faMousePointer = faArrowPointer;
const faClockFourThirty = {
  prefix: 'far',
  iconName: 'clock-four-thirty',
  icon: [512, 512, [], "e34b", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-91.2L338.7 340c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-96-64c-7.4-4.9-16.8-5.4-24.6-1.2S232 247.1 232 256l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faSignalBarsGood = {
  prefix: 'far',
  iconName: 'signal-bars-good',
  icon: [640, 512, ["signal-alt-3"], "f693", "M416 192l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16-64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64s64-28.7 64-64l0-256c0-35.3-28.7-64-64-64zM240 464c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 8.8-7.2 16-16 16zm0-208c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64s64-28.7 64-64l0-128c0-35.3-28.7-64-64-64zM80 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM16 448a64 64 0 1 0 128 0A64 64 0 1 0 16 448z"]
};
const faSignalAlt3 = faSignalBarsGood;
const faCactus = {
  prefix: 'far',
  iconName: 'cactus',
  icon: [512, 512, [127797], "f8a7", "M304 448c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-352c0-26.5 21.5-48 48-48s48 21.5 48 48l0 352zM256 0c-53 0-96 43-96 96l0 128-48 0c-8.8 0-16-7.2-16-16l0-64c0-26.5-21.5-48-48-48S0 117.5 0 144l0 64c0 61.9 50.1 112 112 112l48 0 0 128c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l48 0c61.9 0 112-50.1 112-112l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64c0 8.8-7.2 16-16 16l-48 0 0-256c0-53-43-96-96-96zm0 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faLightbulbGear = {
  prefix: 'far',
  iconName: 'lightbulb-gear',
  icon: [576, 512, [], "e5fd", "M314.4 213.6c3.6-11.9 5.6-24.5 5.6-37.6c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0c97 0 175.6 78.4 176 175.3c-17.8 7.7-28 25.6-28 43.3l0 .9c-7.7-4.3-16.7-6.4-25.6-5.9zM245.6 416c3.5 9.2 7.7 18.3 12.8 27c2.9 5 6 9.9 9.4 14.6C257.1 489.2 227.2 512 192 512c-44.2 0-80-35.8-80-80l0-16 133.6 0zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm228 42.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 17.7c0 7.8 4.8 14.8 11.6 18.7c6.8 3.9 15.1 4.5 21.8 .6l13.8-7.9c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-14.4 8.3c-6.5 3.7-10 10.9-10 18.4s3.5 14.7 10 18.4l14.4 8.3c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-13.8-7.9c-6.7-3.9-15.1-3.3-21.8 .6c-6.8 3.9-11.6 10.9-11.6 18.7l0 17.7c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-17.4c0-7.9-4.9-14.9-11.7-18.9c-6.8-3.9-15.2-4.5-22-.6l-13.5 7.8c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l14-8.1c6.5-3.8 10.1-11.1 10.1-18.6s-3.5-14.8-10.1-18.6l-14-8.1c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l13.6 7.8c6.8 3.9 15.2 3.3 22-.6c6.9-3.9 11.7-11 11.7-18.9l0-17.4zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
const faMaximize = {
  prefix: 'far',
  iconName: 'maximize',
  icon: [512, 512, ["expand-arrows-alt"], "f31e", "M156.1 80L80 80l0 76.1L156.1 80zM32 192L32 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 2.7c0 8.5-3.4 16.6-9.4 22.6L169 135l87 87 87-87L297.4 89.4c-6-6-9.4-14.1-9.4-22.6l0-2.7c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-2.7 0c-8.5 0-16.6-3.4-22.6-9.4L377 169l-87 87 87 87 45.7-45.7c6-6 14.1-9.4 22.6-9.4l2.7 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-2.7c0-8.5 3.4-16.6 9.4-22.6L343 377l-87-87-87 87 45.7 45.7c6 6 9.4 14.1 9.4 22.6l0 2.7c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l2.7 0c8.5 0 16.6 3.4 22.6 9.4L135 343l87-87-87-87L89.4 214.6c-6 6-14.1 9.4-22.6 9.4L64 224c-17.7 0-32-14.3-32-32zM355.9 432l76.1 0 0-76.1L355.9 432zM80 355.9L80 432l76.1 0L80 355.9zM355.9 80L432 156.1 432 80l-76.1 0z"]
};
const faExpandArrowsAlt = faMaximize;
const faChargingStation = {
  prefix: 'far',
  iconName: 'charging-station',
  icon: [576, 512, [], "f5e7", "M96 48c-8.8 0-16 7.2-16 16l0 400 192 0 0-400c0-8.8-7.2-16-16-16L96 48zM32 464L32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 28c0 15.5 12.5 28 28 28s28-12.5 28-28l0-103.7c-32.5-10.2-56-40.5-56-76.3l0-40c0-13.3 10.7-24 24-24l8 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 8 0c13.3 0 24 10.7 24 24l0 40c0 35.8-23.5 66.1-56 76.3L520 372c0 42-34 76-76 76s-76-34-76-76l0-28c0-22.1-17.9-40-40-40l-8 0 0 160 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zM464 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16-64 0 0 16zM222.9 117.9L199.6 176l40.4 0c6.7 0 12.8 4.2 15 10.6s.4 13.4-4.8 17.7l-96 80c-5.6 4.7-13.7 5-19.6 .7s-8.2-12.1-5.5-18.9L152.4 208 112 208c-6.7 0-12.8-4.2-15-10.6s-.4-13.4 4.8-17.7l96-80c5.6-4.7 13.7-5 19.6-.7s8.2 12.1 5.5 18.9z"]
};
const faShapes = {
  prefix: 'far',
  iconName: 'shapes',
  icon: [512, 512, ["triangle-circle-square"], "f61f", "M288 63.1L220.3 176l135.5 0L288 63.1zM411.4 175.5c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM464 320l-128 0 0 128 128 0 0-128zM328 272l144 0c22.1 0 40 17.9 40 40l0 144c0 22.1-17.9 40-40 40l-144 0c-22.1 0-40-17.9-40-40l0-144c0-22.1 17.9-40 40-40zM208 384A80 80 0 1 0 48 384a80 80 0 1 0 160 0zM0 384a128 128 0 1 1 256 0A128 128 0 1 1 0 384z"]
};
const faTriangleCircleSquare = faShapes;
const faPlaneTail = {
  prefix: 'far',
  iconName: 'plane-tail',
  icon: [512, 512, [], "e22c", "M.8 39L61.5 308.8l-15.5 4.3C18.8 320.5 0 345.2 0 373.4c0 26 16.1 49.3 40.4 58.5l196.1 74.4c10 3.8 20.5 5.7 31.2 5.7L488 512c13.3 0 24-10.7 24-24s-10.7-24-24-24l-220.3 0c-4.8 0-9.7-.9-14.2-2.6L57.4 387c-5.7-2.1-9.4-7.6-9.4-13.6c0-6.6 4.4-12.3 10.7-14.1L254 305.4c3.5-1 7-1.4 10.6-1.4L488 304c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0L154.9 19.5C142.8 7 126.2 0 108.9 0L32 0C11.5 0-3.7 19 .8 39zM216 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faGaugeSimpleMax = {
  prefix: 'far',
  iconName: 'gauge-simple-max',
  icon: [512, 512, ["tachometer-fastest"], "f62b", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM200 352c0-30.9 25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56s-56-25.1-56-56z"]
};
const faTachometerFastest = faGaugeSimpleMax;
const faCircleU = {
  prefix: 'far',
  iconName: 'circle-u',
  icon: [512, 512, [], "e127", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120c0 61.9 50.1 112 112 112s112-50.1 112-112l0-120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-120z"]
};
const faShieldSlash = {
  prefix: 'far',
  iconName: 'shield-slash',
  icon: [640, 512, [], "e24b", "M174.2 111.2L320 49.4 503 127c5.9 2.5 9.1 7.8 9 12.8c-.3 52.8-13 127.8-52.2 195.3L174.2 111.2zM497.9 365c47.4-78.8 61.8-166.3 62.1-225c.1-26.2-16.3-47.9-38.3-57.2L333.4 2.9C329.2 1 324.7 0 320 0s-9.2 1-13.4 2.9L131 77.4 38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L497.9 365zM80.6 159.5c5.5 102 51.5 266.3 213.1 343.7c16.7 8 36.1 8 52.8 0c35.7-17.1 65.8-38.5 91.1-62.5l-38.2-30.1c-20.8 18.9-45.1 35.7-73.5 49.3c-3.6 1.7-7.8 1.7-11.3 0C195.8 403.1 147.9 290.6 133.3 201L80.6 159.5z"]
};
const faSquarePhoneHangup = {
  prefix: 'far',
  iconName: 'square-phone-hangup',
  icon: [448, 512, ["phone-square-down"], "e27a", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM345.9 303.3c-4.8 7.6-15.1 10.7-24 7.4l-41.6-15.4c-7.9-2.9-12.7-10.1-11.8-17.7l2.6-23.3c-30.4-9.5-63.7-9.5-94.1 0l2.6 23.3c.8 7.6-4 14.8-11.8 17.7l-41.6 15.4c-8.9 3.3-19.2 .1-24-7.4L82.5 272.4c-4.3-6.8-3-15.3 3.1-20.8c76.4-68.8 200.3-68.8 276.7 0c6.1 5.5 7.4 14.1 3.1 20.8l-19.6 30.8z"]
};
const faPhoneSquareDown = faSquarePhoneHangup;
const faArrowUpLeft = {
  prefix: 'far',
  iconName: 'arrow-up-left',
  icon: [384, 512, [], "e09d", "M56 96c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-231-231L296 144c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 96z"]
};
const faTransporter1 = {
  prefix: 'far',
  iconName: 'transporter-1',
  icon: [512, 512, [], "e043", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 288l48 0 0-112 32 0 0 112 48 0 0-79.2 52.9 69.7c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-65.7-86.7c-16.6-21.9-42.6-34.8-70.1-34.8l-38.6 0c-27.5 0-53.5 12.9-70.1 34.8l-65.7 86.7c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6L192 208.8l0 79.2zM480 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L448 160l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 160zM64 352l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 352 6.6 359.3C2.7 360.4 0 363.9 0 368s2.7 7.6 6.6 8.7L32 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 352zm56 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm56-144c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"]
};
const faPeanuts = {
  prefix: 'far',
  iconName: 'peanuts',
  icon: [640, 512, [129372], "e431", "M123 504.9c-16.8-19.6-27-45-27-72.9c0-5.2-.1-10.6-.1-16.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-.6-55.4-1.3-125.1 52.8-179.2c26.5-26.5 59-43.2 94.7-49.8c22.9-4.6 39.5-10.9 50-21.5s16.9-27.1 21.5-50c1.6-8.9 3.9-17.5 6.7-26L299.2 38.9C284.4 5.8 245.7-9 212.6 5.7L161.7 28.3c-15 6.7-28 16.1-38.7 27.3c-10.6 11.2-19.3 24.6-25.2 39.9l-.2 .5c-5.8 15.3-8.3 31-7.9 46.4c.2 8.5 1.3 17 3.4 25.4c4.5 19.9 6.9 41-.4 60s-23.1 33.1-39.8 44.9c-7.2 4.9-13.7 10.5-19.5 16.6C22.7 300.5 14 314 8.1 329.4C2.2 344.7-.4 360.6 0 376c.4 15.5 3.8 31.1 10.5 46.2l22.7 50.9c14.7 33.1 53.5 48 86.6 33.2l3.2-1.4zM563 218.4l-.6 .6s0 0 0 0c-9.6 9.5-20.5 16.6-32.2 21.4c0 0 0 0 0 0c-6.4 2.7-13.2 4.7-20.2 5.9l-.4 .1-.4 .1c-26.6 5.3-63.2 15.3-91.3 43.4s-38.2 64.7-43.4 91.3l-.1 .4-.1 .4c-1.3 7-3.3 13.8-5.9 20.2c0 0 0 0 0 0c-4.8 11.5-11.8 22.3-21.1 31.9c0 0 0 0 0 0c-.2 .2-.5 .5-.7 .7c-.1 .1-.3 .3-.4 .4l32.7 33.2-32.7-33.2C328.1 453.1 303.4 464 276 464l-68 0c-17.7 0-32-14.3-32-32l0-68c0-13.6 2.7-26.5 7.6-38.3c0 0 0 0 0 0c4.9-11.7 12.1-22.8 21.7-32.4c9.7-9.7 20.7-16.9 32.5-21.7c0 0 0 0 0 0c6.4-2.7 13.2-4.7 20.2-5.9l.4-.1 .4-.1c26.6-5.3 63.2-15.3 91.3-43.4s38.2-64.7 43.4-91.3l.1-.4 .1-.4c1.3-7 3.3-13.8 5.9-20.2c0 0 0 0 0 0c4.8-11.7 12-22.6 21.5-32.2c0 0 0 0 0 0l.3-.3c9.6-9.6 20.6-16.8 32.3-21.6c0 0 0 0 0 0C465.5 50.7 478.4 48 492 48l68 0c17.7 0 32 14.3 32 32l0 68c0 27.5-11 52.3-29 70.4c0 0 0 0 0 0zm34.1 33.8C623.6 225.4 640 188.6 640 148l0-68c0-44.2-35.8-80-80-80L492 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364l0 68c0 44.2 35.8 80 80 80l68 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9zm-77.1-97a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-192 192a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 392a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zM520 219.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM347.2 328a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z"]
};
const faShuffle = {
  prefix: 'far',
  iconName: 'shuffle',
  icon: [512, 512, [128256, "random"], "f074", "M425 31l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L352 152c-12.6 0-24.4 5.9-32 16l-46 61.3-30-40 37.6-50.1C298.2 117 324.3 104 352 104l78.1 0L391 65c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM204 322.7l-37.6 50.1C149.8 395 123.7 408 96 408l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c12.6 0 24.4-5.9 32-16l46-61.3 30 40zM391 287c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L352 408c-27.7 0-53.8-13-70.4-35.2L128 168c-7.6-10.1-19.4-16-32-16l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c27.7 0 53.8 13 70.4 35.2L320 344c7.6 10.1 19.4 16 32 16l78.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faRandom = faShuffle;
const faPersonRunning = {
  prefix: 'far',
  iconName: 'person-running',
  icon: [448, 512, [127939, "running"], "f70c", "M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-85.3 60.6c14-3.5 28.7-3.5 42.7 0l95 23.7c19 4.8 34.2 19.1 39.9 37.9L336 234.4c1 3.4 4.1 5.6 7.6 5.6l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0c-24.6 0-46.3-16-53.5-39.5l-5.6-18.2-28.1 84.4 32.1 18c16.5 9.3 24.2 28.8 18.6 46.8L270.9 495.2c-4 12.7-17.4 19.7-30.1 15.8s-19.7-17.4-15.7-30.1l34.2-109.5-88-49.5c-23.4-13.2-34.2-41.1-25.7-66.5l32.7-98-8.6-2.1c-6.4-1.6-13-1.6-19.4 0l-1.8 .5c-6 1.5-11.6 4.4-16.3 8.4L87.6 202.2c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l44.5-38.2c10.4-8.9 22.7-15.2 35.9-18.6l1.8-.5zm75.1 182.1l38.3-115L225 169 191.1 270.5c-1.2 3.6 .3 7.6 3.7 9.5l19 10.7zM103.4 368l19.1-50.9c7.7 13.3 18.9 24.7 33 32.6l4.9 2.8-14.1 37.6c-5.9 15.6-20.8 25.9-37.4 25.9L24 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l79.4 0z"]
};
const faRunning = faPersonRunning;
const faMobileRetro = {
  prefix: 'far',
  iconName: 'mobile-retro',
  icon: [320, 512, [], "e527", "M256 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l192 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 160l0 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM96 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0z"]
};
const faGripLinesVertical = {
  prefix: 'far',
  iconName: 'grip-lines-vertical',
  icon: [192, 512, [], "f7a5", "M32 32C18.7 32 8 42.7 8 56L8 456c0 13.3 10.7 24 24 24s24-10.7 24-24L56 56c0-13.3-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24z"]
};
const faBinBottlesRecycle = {
  prefix: 'far',
  iconName: 'bin-bottles-recycle',
  icon: [640, 512, [], "e5f6", "M152 0l80 0c13.3 0 24 10.7 24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192l32 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7l0-42.1c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 42.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5l32.9 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7l-369.7 0c-40.6 0-74.7-30.4-79.5-70.7L32 240l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm48.3 48l23 195.7c1.9 16.1 15.6 28.3 31.8 28.3l369.7 0c16.2 0 29.9-12.1 31.8-28.3l23-195.7L80.3 240zm228.1 70.1l-7.6 11.4c-4.8 7.2-14.5 9.3-21.8 4.7c-7.6-4.8-9.8-14.9-4.8-22.4l7.6-11.4c8.5-12.7 22.8-20.4 38.1-20.4c15.4 0 29.8 7.7 38.2 20.6l8.5 12.9c4.9 7.5 2.7 17.6-4.9 22.4c-7.4 4.6-17.1 2.5-21.8-4.8l-8.5-12.9c-2.6-3.9-6.9-6.2-11.5-6.2c-4.6 0-8.9 2.3-11.5 6.1zm-43.1 64.7l-7.9 11.9c-.9 1.4-1.4 3.1-1.4 4.7c0 4.7 3.8 8.6 8.6 8.6l25.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-25.2 0c-22.4 0-40.6-18.2-40.6-40.6c0-8 2.4-15.8 6.8-22.5l7.9-11.9c4.8-7.2 14.5-9.3 21.8-4.7c7.6 4.8 9.8 14.9 4.8 22.4zM353.7 400l20.9 0c4.8 0 8.6-3.9 8.6-8.6c0-1.7-.5-3.3-1.4-4.7l-6.6-10.1c-4.9-7.5-2.7-17.6 4.9-22.4c7.4-4.6 17.1-2.5 21.8 4.8l6.6 10.1c4.4 6.6 6.7 14.4 6.7 22.4c0 22.4-18.2 40.6-40.6 40.6l-20.9 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faArrowUpFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-from-square',
  icon: [512, 512, [], "e09c", "M273 7c-9.4-9.4-24.6-9.4-33.9 0L127 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l71-71L232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 71 71c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-336c0-39.8-32.2-72-72-72l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0z"]
};
const faFileDashedLine = {
  prefix: 'far',
  iconName: 'file-dashed-line',
  icon: [640, 512, ["page-break"], "f877", "M448 464l-256 0c-8.8 0-16-7.2-16-16l0-80-48 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-48 0 0 80c0 8.8-7.2 16-16 16zm16-304l0 96 48 0 0-101.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 192 48 0 0-192c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0zM56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 288zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faPageBreak = faFileDashedLine;
const faBracketCurlyRight = {
  prefix: 'far',
  iconName: 'bracket-curly-right',
  icon: [256, 512, [], "7d", "M192 120c0-48.6-39.4-88-88-88L56 32C42.7 32 32 42.7 32 56s10.7 24 24 24l48 0c22.1 0 40 17.9 40 40l0 45.5c0 23.3 9.3 45.7 25.8 62.2L198.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2l0 45.5c0 22.1-17.9 40-40 40l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c48.6 0 88-39.4 88-88l0-45.5c0-10.6 4.2-20.8 11.7-28.3L249 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3l0-45.5z"]
};
const faSpider = {
  prefix: 'far',
  iconName: 'spider',
  icon: [512, 512, [128375], "f717", "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l68.8-22.9c-.8 3.2-1.5 6.4-2 9.7L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5l12.1-12.1C153.2 425.8 200.1 464 256 464s102.8-38.2 116.2-89.9l12.1 12.1c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-43.8-43.8c-.5-3.3-1.2-6.5-2-9.7l68.8 22.9c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L352 158.1c-.6-32.8-17.8-61.6-43.3-78.4c-5.8-3.8-13.1-4.9-19.8-3s-12.3 6.7-15.2 13L256 128.1 238.3 89.7c-2.9-6.3-8.5-11.1-15.2-13s-13.9-.8-19.8 3c-25.6 16.8-42.7 45.5-43.3 78.4l-32.3-32.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6zM208 160c0-5.5 .9-10.8 2.6-15.7l15.6 33.8c3.9 8.5 12.4 13.9 21.8 13.9l16 0c9.4 0 17.9-5.4 21.8-13.9l15.6-33.8c1.7 4.9 2.6 10.2 2.6 15.7l0 88c0 3.4-.4 6.7-1 9.9c-1.6 7.6 .6 15.5 5.9 21.2C320.8 292 328 309.1 328 328l0 16c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-16c0-18.9 7.2-36 19.1-48.9c5.3-5.7 7.5-13.6 5.9-21.2c-.7-3.2-1-6.5-1-9.9l0-88z"]
};
const faClockThree = {
  prefix: 'far',
  iconName: 'clock-three',
  icon: [512, 512, [], "e356", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 13.3 10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faHandsBound = {
  prefix: 'far',
  iconName: 'hands-bound',
  icon: [640, 512, [], "e4f9", "M16 72l0 134.6c0 22.2 7.4 43.7 21.1 61.2l69.2 88.6C100 360.7 96 367.9 96 376c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24c0-8.1-4-15.3-10.2-19.7l69.2-88.6c13.7-17.5 21.1-39 21.1-61.2L624 72c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 66.3c-.5-.5-1-.9-1.6-1.4c-29.8-25.2-74.3-22-100.2 7.2l-46.7 52.5c-4.2 4.7-8 9.7-11.5 14.8c-3.5-5.2-7.3-10.1-11.5-14.8l-46.7-52.5c-25.9-29.2-70.4-32.4-100.2-7.2c-.5 .5-1.1 .9-1.6 1.4L160 72c0-39.8-32.2-72-72-72S16 32.2 16 72zM163.8 352L74.9 238.2C67.8 229.2 64 218 64 206.6L64 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 107.4 71.5 95.3c.1 .2 .3 .4 .4 .6c7.5 9.4 20.9 11.6 31 5c11.4-7.4 14.1-22.9 6-33.7c-.1-.2-.3-.4-.4-.6L189.3 207c-2.7-3.3-4.3-7.2-5-11.2c-1.3-8.1 1.6-16.6 8.2-22.2c9.9-8.4 24.8-7.3 33.4 2.4l46.7 52.5c15.1 16.9 23.4 38.8 23.4 61.5l0 61.9-132.2 0zM344 352l0-61.9c0-22.7 8.3-44.6 23.4-61.5l46.7-52.5c8.6-9.7 23.5-10.8 33.4-2.4c6.7 5.6 9.5 14.1 8.2 22.2c-.6 4-2.3 7.8-5 11.2l-31.3 39.1c-.2 .2-.3 .4-.4 .6c-8.1 10.8-5.4 26.3 6 33.7c10.1 6.6 23.5 4.3 31-5c.2-.2 .3-.4 .4-.6L528 179.4 528 72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 134.6c0 11.5-3.8 22.6-10.9 31.7L476.2 352 344 352zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 120 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 120 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0z"]
};
const faScalpelLineDashed = {
  prefix: 'far',
  iconName: 'scalpel-line-dashed',
  icon: [576, 512, ["scalpel-path"], "f61e", "M493.8 122.6C505.5 109.4 512 92.3 512 74.7c0-37-28.1-68-64.9-71.7c-23.7-2.4-47 7.1-62.4 25.3L206.1 240l-.4 .5-5.6 6.7-12.2 14.5c-4 4.8-4.9 11.4-2.3 17.1s8.3 9.3 14.5 9.3l19 0 8.8 0 .7 0 96.8 0c13.7 0 26.8-5.9 35.9-16.1L493.8 122.6zM268.9 240L421.4 59.2c5.1-6.1 13-9.2 20.9-8.5C454.6 52 464 62.4 464 74.7c0 5.9-2.2 11.6-6.1 16L325.1 240l-56.3 0zm-99.5 80l-4.7 4.7-160 160c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9c18.1 0 84.1-8.4 145.9-33.1C222.5 454.6 288 410.9 288 336l0-16-16 0-96 0-6.6 0zM248 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"]
};
const faScalpelPath = faScalpelLineDashed;
const faFileInvoiceDollar = {
  prefix: 'far',
  iconName: 'file-invoice-dollar',
  icon: [384, 512, [], "f571", "M336 448l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 215.6c11 0 20 9 20 20l0 10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8l0 10.1c0 11-9 20-20 20s-20-9-20-20l0-10.8c-10-1.9-19.3-4.8-27.5-7.3c0 0 0 0 0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2c0 0 0 0 0 0s0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3l0-10.3c0-11 9-20 20-20zM96 96l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faPipeSmoking = {
  prefix: 'far',
  iconName: 'pipe-smoking',
  icon: [640, 512, [], "e3c4", "M586.8 48c-36.4 0-70.1 19-89 50.2L412.1 239.8c13 16 14.6 39.3 2.4 57.2L318.7 438.3c-31.3 46.1-83.3 73.7-139 73.7L168 512C75.2 512 0 436.8 0 344L0 232c0-30.9 25.1-56 56-56l160 0c30.9 0 56 25.1 56 56l0 9.4 23-29.9c12.3-16 32.9-22.2 51.4-16.9l111.2-138C486.4 20.8 529.9 0 575.9 0l10.9 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-29.2 0zM56 224c-4.4 0-8 3.6-8 8l0 112c0 66.3 53.7 120 120 120l11.7 0c39.8 0 77-19.7 99.3-52.6l95.9-141.3L333 240.8l-66 85.8c-6.3 8.1-17 11.4-26.8 8.1s-16.3-12.4-16.3-22.7l0-80c0-4.4-3.6-8-8-8L56 224z"]
};
const faFaceAstonished = {
  prefix: 'far',
  iconName: 'face-astonished',
  icon: [512, 512, [], "e36b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 48c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48zM144.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 144c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faWindow = {
  prefix: 'far',
  iconName: 'window',
  icon: [512, 512, [], "f40e", "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64 0 48 0 16 0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224l0-16 0-48L0 96zM464 224L48 224l0 192c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-192zM96 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faPlaneCircleExclamation = {
  prefix: 'far',
  iconName: 'plane-circle-exclamation',
  icon: [640, 512, [], "e556", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faEar = {
  prefix: 'far',
  iconName: 'ear',
  icon: [384, 512, [128066], "f5f0", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192l0 176c0 53 43 96 96 96s96-43 96-96c0-21.7 10.9-42.6 29.8-54.8C309.7 287.5 336 242.8 336 192zm48 0c0 67.8-35.1 127.4-88.2 161.5c-4.9 3.2-7.8 8.6-7.8 14.5c0 79.5-64.5 144-144 144S0 447.5 0 368L0 192C0 86 86 0 192 0S384 86 384 192zm-256 0l0 20.2c0 3 1.7 5.8 4.4 7.2l14 7c18.1 9.1 29.5 27.6 29.5 47.8c0 15.9-7 30.9-19.2 41.1l-37.4 31.2c-10.2 8.5-25.3 7.1-33.8-3.1s-7.1-25.3 3.1-33.8L126 278.4c1.2-1 2-2.6 2-4.2c0-2.1-1.2-4-3-4.9l-14-7c-19-9.5-31-28.9-31-50.1L80 192c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64z"]
};
const faFileLock = {
  prefix: 'far',
  iconName: 'file-lock',
  icon: [576, 512, [], "e3a6", "M320 464L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 149.7c4.6-5.2 10-9.6 16-13.1l0-24.6c0-30.5 12.2-58.2 32-78.4l0-39.1c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c2.8 0 5.6-.2 8.3-.5c-5.3-9.3-8.3-20-8.3-31.5l0-16zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faDiagramVenn = {
  prefix: 'far',
  iconName: 'diagram-venn',
  icon: [640, 512, [], "e15a", "M270 425.9c-47.8-41.1-78-102-78-169.9s30.3-128.8 78-169.9c-14.7-4-30.1-6.1-46-6.1C126.8 80 48 158.8 48 256s78.8 176 176 176c15.9 0 31.4-2.1 46-6.1zM252 320l136 0c5.9-15.1 9.8-31.2 11.3-48l-158.6 0c1.5 16.8 5.4 32.9 11.3 48zm16.5 32c13.4 20.6 31 38.1 51.5 51.5c20.6-13.4 38.1-31 51.5-51.5l-103.1 0zM252 192c-5.9 15.1-9.8 31.2-11.3 48l158.6 0c-1.5-16.8-5.4-32.9-11.3-48l-136 0zm119.5-32c-13.4-20.6-31-38.1-51.5-51.5c-20.6 13.4-38.1 31-51.5 51.5l103.1 0zM320 458.4c-29.1 13.8-61.6 21.6-96 21.6C100.3 480 0 379.7 0 256S100.3 32 224 32c34.4 0 66.9 7.7 96 21.6C349.1 39.7 381.6 32 416 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-34.4 0-66.9-7.7-96-21.6z"]
};
const faArrowDownFromBracket = {
  prefix: 'far',
  iconName: 'arrow-down-from-bracket',
  icon: [448, 512, [], "e667", "M241 505c-9.4 9.4-24.6 9.4-33.9 0L79 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L200 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 246.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 505zM48 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L360 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88l0 80z"]
};
const faXRay = {
  prefix: 'far',
  iconName: 'x-ray',
  icon: [512, 512, [], "f497", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 352-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 400 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-352 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 32 24 32zM80 432L80 80l352 0 0 352L80 432zM256 96c-8.8 0-16 7.2-16 16l0 32-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0 0 32-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0 0 54.6L189.1 275c-5.2-2-10.6-3-16.2-3l-2.1 0c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6l120.8 0c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8l-2.2 0c-5.5 0-11 1-16.2 3L272 294.6l0-54.6 96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0 0-32 64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0 0-32c0-8.8-7.2-16-16-16zM208 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faGoalNet = {
  prefix: 'far',
  iconName: 'goal-net',
  icon: [640, 512, [], "e3ab", "M48 120c0-22.1 17.9-40 40-40l464 0c22.1 0 40 17.9 40 40l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-48.6-39.4-88-88-88L88 32C39.4 32 0 71.4 0 120L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zm128 8c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 64 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-64 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0 0-48c0-8.8-7.2-16-16-16zm80 256l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64z"]
};
const faCoffinCross = {
  prefix: 'far',
  iconName: 'coffin-cross',
  icon: [384, 512, [], "e051", "M140.1 464l103.8 0 91.9-318.2L250.2 48 133.8 48 48.2 145.8 140.1 464zM11.5 114.9l91-104C108.5 4 117.3 0 126.5 0l131 0c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6c0 4.4-.6 8.7-1.8 12.9L286.7 488.9c-4 13.7-16.5 23.1-30.7 23.1l-127.9 0c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM216 120l0 40 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faOctopus = {
  prefix: 'far',
  iconName: 'octopus',
  icon: [640, 512, [], "e688", "M208 160l0 3.4c0 6.9 .6 13.8 1.9 20.6c0 0 0 0 0 0L229 289.6l9 49.7c1.3 7 1.9 14.2 1.9 21.4l0 2.5c0 10.1-1.3 19.9-3.7 29.3l12.2-6.5c22-11.7 46.6-17.9 71.5-17.9s49.5 6.1 71.5 17.9l12.2 6.5c-2.4-9.4-3.7-19.2-3.7-29.3l0-2.5c0-7.2 .6-14.3 1.9-21.4l9-49.6c0 0 0 0 0-.1l19.2-105.5c0 0 0 0 0-.1s0 0 0 0c1.2-6.8 1.8-13.7 1.8-20.6l0-3.4c0-61.9-50.1-112-112-112s-112 50.1-112 112zM448.1 367.2c2.1 36.2 32.1 64.8 68.8 64.8c32.5 0 60.6-22.7 67.4-54.5l8.3-38.6c2.8-13 15.5-21.2 28.5-18.4s21.2 15.5 18.4 28.5l-8.3 38.6C619.7 441.5 572 480 516.9 480l-.2 0c-33.4 0-66.2-8.3-95.6-24l-52.1-27.8c-15.1-8-31.9-12.2-48.9-12.2s-33.9 4.2-48.9 12.2L218.9 456c-29.5 15.7-62.4 24-95.8 24C68 480 20.3 441.5 8.8 387.6L.5 349c-2.8-13 5.5-25.7 18.4-28.5s25.7 5.5 28.5 18.4l8.3 38.6c6.8 31.8 34.9 54.5 67.4 54.5c36.7 0 66.7-28.7 68.8-64.8c-10.3 5.6-22.2 8.8-35 8.8c-32.5 0-61.2-21.4-70.3-52.6L72.8 276.5C66.4 254.9 46.6 240 24 240c-13.3 0-24-10.7-24-24s10.7-24 24-24c43.8 0 82.5 28.9 94.8 71l13.8 46.9c3.2 10.8 13.1 18.2 24.3 18.2c15.8 0 27.7-14.3 24.9-29.8c0 0 0 0 0 0L162.6 192.7s0 0 0 0s0 0 0 0c-1.7-9.6-2.6-19.4-2.6-29.1c0 0 0 0 0-.1l0-3.4C160 71.6 231.6 0 320 0s160 71.6 160 160l0 3.4c0 0 0 0 0 .1c0 9.8-.9 19.5-2.6 29.1c0 0 0 0 0 0s0 0 0 0L458.2 298.2s0 0 0 0c-2.8 15.5 9.1 29.8 24.9 29.8c11.2 0 21.1-7.4 24.3-18.2L521.2 263c12.4-42.1 51-71 94.8-71c13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.6 0-42.4 14.9-48.8 36.5l-13.8 46.9c-9.2 31.2-37.8 52.6-70.3 52.6c-12.8 0-24.6-3.2-35-8.8zM256 268a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm108-20a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"]
};
const faSpellCheck = {
  prefix: 'far',
  iconName: 'spell-check',
  icon: [576, 512, [], "f891", "M134.1 14.6C130.3 5.8 121.6 0 112 0s-18.3 5.8-22.1 14.6l-88 208c-5.2 12.2 .5 26.3 12.8 31.5s26.3-.5 31.5-12.8L56.8 216l110.3 0 10.7 25.4c5.2 12.2 19.2 17.9 31.5 12.8s17.9-19.2 12.8-31.5l-88-208zM146.9 168l-69.7 0L112 85.6 146.9 168zM256 24l0 104 0 104c0 13.3 10.7 24 24 24l92 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3C426.9 107.3 432 92.2 432 76c0-42-34-76-76-76L280 0c-13.3 0-24 10.7-24 24zm100 80l-52 0 0-56 52 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-52 48l52 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-68 0 0-56zM568.6 313.3c9.6-9.2 9.9-24.4 .7-33.9s-24.4-9.9-33.9-.7l-183 175.7L265 367c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L335 505c9.2 9.2 24.2 9.4 33.6 .3l200-192z"]
};
const faLocationXmark = {
  prefix: 'far',
  iconName: 'location-xmark',
  icon: [384, 512, ["map-marker-times", "map-marker-xmark"], "f60e", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM111 111c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faMapMarkerTimes = faLocationXmark;
const faMapMarkerXmark = faLocationXmark;
const faCircleQuarterStroke = {
  prefix: 'far',
  iconName: 'circle-quarter-stroke',
  icon: [512, 512, [], "e5d3", "M464 256c0-114.9-93.1-208-208-208c-1.4 0-2.9 0-4.3 0c2.7 4.6 4.3 10.1 4.3 16l0 160c0 17.7-14.3 32-32 32L64 256c-5.8 0-11.3-1.6-16-4.3c0 1.4 0 2.9 0 4.3c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faLasso = {
  prefix: 'far',
  iconName: 'lasso',
  icon: [576, 512, [], "f8c8", "M576 176c0 97.2-128.9 176-288 176c-14.9 0-29.6-.7-43.9-2c7.7 15.3 11.9 32.4 11.9 50.2C256 461.9 205.9 512 144.2 512L56 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l88.2 0c35.2 0 63.8-28.6 63.8-63.8c0-24.9-14.5-47.5-37.1-57.9l-44.3-20.5C50.2 290.1 0 236.6 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 304c132.5 0 240-57.3 240-128s-107.5-128-240-128S48 105.3 48 176s107.5 128 240 128z"]
};
const faSlash = {
  prefix: 'far',
  iconName: 'slash',
  icon: [640, 512, [], "f715", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]
};
const faPersonToPortal = {
  prefix: 'far',
  iconName: 'person-to-portal',
  icon: [512, 512, ["portal-enter"], "e022", "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5l8.4 0 16.5 0 23.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-23.9 0c1.2-82.9 11.4-134.5 24.1-164c12.4-28.7 22.4-28.1 23.7-28l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180s-10.7 148.6-24.2 180c-12.4 28.7-22.4 28.1-23.7 28l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28c-10.1-23.4-18.6-60.5-22.2-116l-18 0-30.1 0c8.8 140.7 47.6 192 94.1 192c53 0 96-66.6 96-256S469 0 416 0c-46.2 0-84.8 50.6-93.9 189.1l-5.8-18.9c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6z"]
};
const faPortalEnter = faPersonToPortal;
const faCalendarStar = {
  prefix: 'far',
  iconName: 'calendar-star',
  icon: [448, 512, [], "f736", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM233.3 242.9l23.6 47.8 52.7 7.7c8.5 1.2 11.9 11.7 5.8 17.7l-38.2 37.2 9 52.5c1.5 8.5-7.5 15-15.1 11L224 392l-47.2 24.8c-7.6 4-16.5-2.5-15.1-11l9-52.5-38.2-37.2c-6.2-6-2.8-16.5 5.8-17.7l52.7-7.7 23.6-47.8c3.8-7.7 14.8-7.7 18.7 0z"]
};
const faComputerMouse = {
  prefix: 'far',
  iconName: 'computer-mouse',
  icon: [384, 512, [128433, "mouse"], "f8cc", "M192 224L48 224l0 128c0 61.9 50.1 112 112 112l64 0c61.9 0 112-50.1 112-112l0-128-144 0zm192-48l0 24 0 24 0 128c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 224l0-24 0-24 0-16C0 71.6 71.6 0 160 0l8 0 24 0 24 0 8 0c88.4 0 160 71.6 160 160l0 16zM216 48l0 128 120 0 0-16c0-61.9-50.1-112-112-112l-8 0zm-48 0l-8 0C98.1 48 48 98.1 48 160l0 16 120 0 0-128z"]
};
const faMouse = faComputerMouse;
const faArrowRightToBracket = {
  prefix: 'far',
  iconName: 'arrow-right-to-bracket',
  icon: [512, 512, ["sign-in"], "f090", "M217 401L345 273c9.4-9.4 9.4-24.6 0-33.9L217 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l246.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM344 80l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faSignIn = faArrowRightToBracket;
const faPegasus = {
  prefix: 'far',
  iconName: 'pegasus',
  icon: [576, 512, [], "f703", "M432 0c-1.8 0-3.5 .2-5.2 .6C366.3 5.8 316 46.3 296.6 101.5L162.7 34.5c-7.4-3.7-16.3-3.3-23.4 1.1S128 47.7 128 56c0 81 33.4 133.2 67.7 164.8c16.9 15.6 33.8 26 46.6 32.5c6.4 3.3 11.8 5.6 15.7 7.2c2 .8 3.6 1.4 4.7 1.8c.5 .2 1 .3 1.3 .5c2.5 .9 5.1 1.3 7.9 1.3c13.3 0 24-10.7 24-24c0-10.8-7.2-20-17-23l-.4-.1c-.6-.2-1.6-.6-2.9-1.1c-2.6-1-6.6-2.8-11.5-5.2c-9.8-5-22.9-13.1-35.9-25.1c-19.9-18.3-40.3-46.4-48.5-88.8l121.5 60.8c3.6 1.8 7.4 2.6 11.2 2.5l.5 0c12.1 0 22.3-9 23.8-21c6.1-49.1 46.6-87.7 96.6-90.8c.7 0 1.3-.1 2-.2l4.6 0 24 0 8 0 .5 0c19.9 0 36.8 14.6 39.6 34.3l9.9 69.2c2.1 14.8-6.2 29.1-20 34.7c-13.3 5.3-28.4 1.3-37.3-9.8l-5.9-7.3c-6.4-8-17.1-11-26.7-7.7s-16.1 12.5-16.1 22.6l0 55c0 .5 0 1 0 1.5c0 .6 0 1.2 0 1.7c0 23.5-9.6 44.1-24.7 58.8c-4.6 4.5-7.3 10.7-7.3 17.2L384 464l-48 0 0-117.8c0-11.3-7.9-21.1-19-23.5c-2.1-.4-4.2-1-6.3-1.6l-88-25.7c-7.3-2.1-15.3-.7-21.3 4s-9.6 11.9-9.4 19.5c0 .4 0 .9 0 1.3c0 8-1.4 16-4.3 23.5L175.6 376c-4.2 11.1-4.7 23.2-1.5 34.6L188.9 464l-49.8 0-11.2-40.5c-5.9-21.2-4.9-43.7 2.8-64.4l8.2-21.7c4.2-11.2 4.1-23.6-.4-34.7l-21.9-54.6c-3-7.6-4.6-15.7-4.6-23.9c0-15.5 5.5-29.7 14.6-40.8c-7.7-14.2-14.5-30.1-19.6-47.6c-8.8 6.9-16.5 15-22.9 24.2C37.3 162.1 0 200.7 0 248l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.2 6.4-25 16.3-32.2c-.2 2.8-.3 5.6-.3 8.5c0 14.3 2.7 28.4 8 41.7l21.9 54.6-8.2 21.7c-11.3 30.1-12.7 63.1-4.1 94.1l11.2 40.5c5.8 20.8 24.7 35.2 46.2 35.2l49.8 0c31.7 0 54.7-30.3 46.2-60.8l-14.8-53.3c-.5-1.6-.4-3.4 .2-5l12.1-32.3c1.4-3.7 2.6-7.4 3.6-11.2L288 364.5l0 99.5c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-136.2c19.8-22.6 32-52.3 32-85.5l0-1.6 0-.7 0-7.8c17.7 6 37.5 5.8 55.8-1.5c34.4-13.8 55-49.3 49.7-86l-9.9-69.2c-1.6-11.3-5.3-21.9-10.7-31.3C555.6 40 560 32.5 560 24c0-13.3-10.7-24-24-24L472.5 0 472 0l-8 0L440 0l-8 0zm48 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faFilesMedical = {
  prefix: 'far',
  iconName: 'files-medical',
  icon: [448, 512, [], "f7fd", "M384 368l-224 0c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l160 0 0 48c0 17.7 14.3 32 32 32l48 0 0 224c0 8.8-7.2 16-16 16zM160 416l224 0c35.3 0 64-28.7 64-64l0-229.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L160 0C124.7 0 96 28.7 96 64l0 288c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 376c0 75.1 60.9 136 136 136l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-192 0c-48.6 0-88-39.4-88-88l0-256zm197.3 72l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z"]
};
const faCannon = {
  prefix: 'far',
  iconName: 'cannon',
  icon: [640, 512, [], "e642", "M261.2 406.7c-11.5 6.9-20.5 12.2-26.6 15.3c-47.4 23.5-104.9 4.3-128.5-43s-4.6-104.9 42.7-128.7c22.2-10.7 90.8-36.6 170.7-65.6C398.3 156.1 484.4 125.8 538 107c7.3-2.6 15.6 .6 19.2 8l30.7 61.4c3.7 7.3 1.3 15.8-5.2 20.2c-24.3 16.3-56.1 37.5-90.8 60.6c12.4 10.3 23.1 22.8 31.5 36.7c32.9-21.9 62.9-41.9 86-57.4c26.7-17.9 35.7-52.7 21.4-81.5L600.2 93.5c-14.4-28.7-47.7-42.4-78-31.8C414.8 99.3 177.1 183.2 127.6 207.2c-56.1 28-85.9 87.7-78.5 146.6L26.5 365.1C2.8 376.9-6.8 405.8 5.1 429.5s40.7 33.3 64.4 21.5L92 439.7c42.7 41.2 108.3 53.2 164.4 25.1c6.1-3.2 14.8-8.1 25.4-14.5c-9.2-13.1-16.2-27.8-20.6-43.6zM400 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 176a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
const faNfcLock = {
  prefix: 'far',
  iconName: 'nfc-lock',
  icon: [576, 512, [], "e1f8", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 65.1c-17.7 2.5-34 9.2-48 18.9L400 96c0-8.8-7.2-16-16-16zm-16 72l0 62.3c-10.2 16.9-16 36.6-16 57.7l0 24.6c-19.1 11.1-32 31.7-32 55.4l0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM128 352l192 0 0 48-200 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faPersonSkiLift = {
  prefix: 'far',
  iconName: 'person-ski-lift',
  icon: [512, 512, ["ski-lift"], "f7c8", "M240 0c8.8 0 16 7.2 16 16l0 191.9-32 7.5L224 16c0-8.8 7.2-16 16-16zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM13.6 178.3c12-5.7 26.3-.7 32 11.3l65 135.8c8.3 17.4 28 26.4 46.6 21.3l36.5-9.9c12.8-3.5 26 4.1 29.5 16.8s-4.1 26-16.8 29.5l-36.5 9.9c-41 11.2-84.2-8.6-102.5-46.9L2.3 210.4c-5.7-12-.7-26.3 11.3-32zM488 288c13.3 0 24 10.7 24 24l0 1c0 33.5-20.9 63.4-52.3 75L128.3 510.5c-12.4 4.6-26.2-1.8-30.8-14.2s1.8-26.2 14.2-30.8L272 406.2l0-119.9-94.2 22.2c-18 4.2-36.6-4.5-44.9-21L90.3 202.3C78.8 179.2 95.5 152 121.4 152c13.2 0 25.2 7.4 31.1 19.2l42 84L280.7 235c20.1-4.7 39.3 10.5 39.3 31.1l0 122.4L443.1 343c12.6-4.6 20.9-16.6 20.9-30l0-1c0-13.3 10.7-24 24-24z"]
};
const faSkiLift = faPersonSkiLift;
const faSquare6 = {
  prefix: 'far',
  iconName: 'square-6',
  icon: [448, 512, [], "e25b", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-96 48c0 53 43 96 96 96s96-43 96-96c0-44-29.6-81.1-70-92.4l29.6-25.4c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6l-81.6 70C142.2 224.8 128 255.6 128 288z"]
};
const faShopSlash = {
  prefix: 'far',
  iconName: 'shop-slash',
  icon: [640, 512, ["store-alt-slash"], "e070", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43L576 224l25.8 0c21.1 0 38.2-17.1 38.2-38.2c0-6.4-1.6-12.7-4.7-18.3L557.6 25C549.2 9.6 533.1 0 515.5 0l-391 0C106.9 0 90.8 9.6 82.4 25L76.9 35 38.8 5.1zM115.2 65l9.3-17 391 0 69.8 128-328.5 0L115.2 65zM318.1 224L528 224l0 164.5L318.1 224zM0 185.8C0 206.9 17.1 224 38.2 224L64 224l0 248c0 22.1 17.9 40 40 40l240 0c22.1 0 40-17.9 40-40l0-73.5L284.3 320 112 320l0-96 50.5 0-60.9-48-46.9 0 14.1-25.8L30.5 120 4.7 167.4C1.6 173.1 0 179.4 0 185.8zM112 464l0-96 224 0 0 96-224 0z"]
};
const faStoreAltSlash = faShopSlash;
const faWindTurbine = {
  prefix: 'far',
  iconName: 'wind-turbine',
  icon: [512, 512, [], "f89b", "M315.7 414.8c9.1 14.8 32 6.5 29.5-10.7L316.9 212c-.5-3.4 .1-6.9 1.8-9.9L411 31.2c8.3-15.3-10.4-31-24-20.1L234.7 131.7c-2.7 2.1-6 3.4-9.5 3.5L31.1 140.6C13.7 141 9.5 165 25.7 171.4l180.6 71.5c3.2 1.3 5.9 3.5 7.7 6.5L315.7 414.8zM232 339.8L232 464l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-46.2-48-78zM256 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSlidersSimple = {
  prefix: 'far',
  iconName: 'sliders-simple',
  icon: [512, 512, [], "e253", "M80 336a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm76.3 8L488 344c13.3 0 24 10.7 24 24s-10.7 24-24 24l-331.7 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 56zM400 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-44.3-24c10.2-32.5 40.5-56 76.3-56c44.2 0 80 35.8 80 80s-35.8 80-80 80c-35.8 0-66.1-23.5-76.3-56L24 168c-13.3 0-24-10.7-24-24s10.7-24 24-24l331.7 0z"]
};
const faGridRound = {
  prefix: 'far',
  iconName: 'grid-round',
  icon: [448, 512, [], "e5da", "M88 96A24 24 0 1 1 40 96a24 24 0 1 1 48 0zM64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM88 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96zm88 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 24a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z"]
};
const faBadgeSheriff = {
  prefix: 'far',
  iconName: 'badge-sheriff',
  icon: [448, 512, [], "f8a2", "M256.1 63.9c5-6.7 7.9-14.9 7.9-23.9c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 9 2.9 17.2 7.9 23.9c-.9 1.2-1.7 2.4-2.5 3.8l-37.3 64-74 .3c-1.2 0-2.3 .1-3.5 .2c-6.9-12-19.9-20-34.7-20c-22.1 0-40 17.9-40 40s17.9 40 40 40c1.2 0 2.4-.1 3.6-.2L80.4 256 43.6 320.2c-1.2-.1-2.4-.2-3.6-.2c-22.1 0-40 17.9-40 40s17.9 40 40 40c14.8 0 27.8-8.1 34.7-20c1.1 .1 2.3 .2 3.5 .2l74 .3 37.3 64c.8 1.3 1.6 2.6 2.5 3.8c-5 6.7-7.9 14.9-7.9 23.9c0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.9c.9-1.2 1.7-2.4 2.5-3.8l37.3-64 74-.3c1.2 0 2.3-.1 3.5-.2c6.9 12 19.9 20 34.7 20c22.1 0 40-17.9 40-40s-17.9-40-40-40c-1.2 0-2.4 .1-3.6 .2L367.6 256l36.7-64.2c1.2 .1 2.4 .2 3.6 .2c22.1 0 40-17.9 40-40s-17.9-40-40-40c-14.8 0-27.8 8.1-34.7 20c-1.1-.1-2.3-.2-3.5-.2l-74-.3-37.3-64c-.8-1.3-1.6-2.6-2.5-3.8zM272 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-80.7-96.3l32.7-56 32.7 56c7.1 12.2 20.2 19.8 34.4 19.9l64.9 .3-32.2 56.3c-7 12.3-7 27.4 0 39.7l32.2 56.3-64.9 .3c-14.2 .1-27.3 7.6-34.4 19.9l-32.7 56-32.7-56c-7.1-12.2-20.2-19.8-34.4-19.9l-64.9-.3 32.2-56.3c7-12.3 7-27.4 0-39.7L92.1 179.8l64.9-.3c14.2-.1 27.3-7.6 34.4-19.9z"]
};
const faServer = {
  prefix: 'far',
  iconName: 'server',
  icon: [512, 512, [], "f233", "M64 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96zM64 336c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16L64 336zM0 352c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64zm392 32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM328 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faVirusCovidSlash = {
  prefix: 'far',
  iconName: 'virus-covid-slash',
  icon: [640, 512, [], "e4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6L344 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zm197 154.4C258.3 139.9 287.8 128 320 128c70.7 0 128 57.3 128 128c0 21.2-5.1 41.1-14.2 58.7L235.8 159.5zM145.6 232L112 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-43.1-34c-1.5 6-2.7 12.2-3.5 18.5z"]
};
const faIntersection = {
  prefix: 'far',
  iconName: 'intersection',
  icon: [384, 512, [8898], "f668", "M24 480c13.3 0 24-10.7 24-24l0-232c0-79.5 64.5-144 144-144s144 64.5 144 144l0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232c0-106-86-192-192-192S0 118 0 224L0 456c0 13.3 10.7 24 24 24z"]
};
const faShopLock = {
  prefix: 'far',
  iconName: 'shop-lock',
  icon: [640, 512, [], "e4a5", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 12.4-5.9 23.3-14.9 30.3c-9.6-16.7-23.4-30.6-39.9-40.4L515.5 48l-391 0L54.7 176l415.6 0c-18.8 11.3-34 28-43.5 48L384 224l0 248c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-248-25.8 0C17.1 224 0 206.9 0 185.8zM112 224l0 96 224 0 0-96-224 0zm0 240l224 0 0-96-224 0 0 96zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faFamily = {
  prefix: 'far',
  iconName: 'family',
  icon: [512, 512, [], "e300", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM105.6 208l22.4 0 22.4 0 32.3 0c-4.3-9.8-6.7-20.6-6.7-32c0-3.9 .3-7.8 .8-11.5c-8.3-2.9-17.2-4.5-26.4-4.5l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 32 0 0-16c0-11.1 1.6-21.9 4.6-32L88 304l-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3C75.1 220.8 89 208 105.6 208zM336 176c0 11.4-2.4 22.2-6.7 32l38.9 0 15.7 0 15.7 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336 368 336l0 16c0 11.2-1.9 22-5.5 32l37.5 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112l0 16c0 8.8-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"]
};
const faHourglassStart = {
  prefix: 'far',
  iconName: 'hourglass-start',
  icon: [384, 512, ["hourglass-1"], "f251", "M0 488c0 13.3 10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24zM84.1 96C81.4 86.7 80 76.9 80 67l0-19 224 0 0 19c0 9.9-1.4 19.7-4.1 29L84.1 96zM273.5 371.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9l81.5 81.5z"]
};
const faHourglass1 = faHourglassStart;
const faUserHairBuns = {
  prefix: 'far',
  iconName: 'user-hair-buns',
  icon: [448, 512, [], "e3d3", "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l14.4 0c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32l14.4 0c1 5.2 1.6 10.5 1.6 16zM84 192c7 0 13.7-1.6 19.6-4.6c17.8 49.3 65 84.6 120.4 84.6s102.7-35.3 120.4-84.6c5.9 2.9 12.5 4.6 19.6 4.6c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44c-9.3 0-17.9 2.9-25 7.8C318.2 29.3 274.5 0 224 0s-94.2 29.3-115 71.8C101.9 66.9 93.3 64 84 64c-24.3 0-44 19.7-44 44l0 40c0 24.3 19.7 44 44 44zM49.3 464c8.3-54.4 55.3-96 112-96l125.4 0c56.7 0 103.7 41.6 112 96L49.3 464zM0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7C448 392.2 375.8 320 286.7 320l-125.4 0C72.2 320 0 392.2 0 481.3z"]
};
const faBlenderPhone = {
  prefix: 'far',
  iconName: 'blender-phone',
  icon: [576, 512, [], "f6b6", "M158.1 64.1c4.7-12.4 .2-26.7-10.6-33.4l-44-27.2c-9.7-6-21.9-4.2-29.8 4.3C-24.6 114-24.6 286 73.7 392.2c7.9 8.5 20.1 10.3 29.8 4.3l44-27.2c10.8-6.7 15.3-21 10.6-33.4l-22-57.8c-4.2-10.9-14.5-17.6-25.3-16.4l-33.3 3.6c-13.6-42.2-13.6-88.4 0-130.7l33.3 3.6c10.9 1.2 21.2-5.5 25.3-16.4l22-57.8zM268.2 336l174.4 0 28-112L368 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l110.5 0 16-64L368 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l134.5 0 12-48L244.2 48l24 288zM566.1 39.8L489.6 345.5C521.8 361 544 393.9 544 432l0 16c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-16c0-40.5 25.1-75.1 60.6-89.2L196.3 52C194 24 216.1 0 244.2 0L535 0c20.8 0 36.1 19.6 31 39.8zM208 432l0 16c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-16c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48zm144-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHourglassClock = {
  prefix: 'far',
  iconName: 'hourglass-clock',
  icon: [576, 512, [], "e41b", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l306.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9l64.5 64.5c1.5-19.3 6-37.7 13.2-54.7L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 222.1l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"]
};
const faPersonSeatReclined = {
  prefix: 'far',
  iconName: 'person-seat-reclined',
  icon: [512, 512, [], "e21f", "M176 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16.9 189.6l16.9 76.2c.8 3.7 4.1 6.3 7.8 6.3l16.4 0-19.4-87.3c-1.1-5.1-5.7-8.7-10.9-8.7c-7.1 0-12.4 6.6-10.9 13.6zm68.6-15.2l.4 1.7 66.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-55.4 0 10.7 48 35.5 0c30 0 56.9 18.6 67.4 46.7l28.5 76.1 34.7-9.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-56 16c-12 3.4-24.7-2.9-29.1-14.6l-36.3-96.9c-3.5-9.4-12.5-15.6-22.5-15.6l-54.3 0c-.3 0-.7 0-1 0l-45.8 0c-26.2 0-49-18.2-54.7-43.9L146.1 232c-8.2-36.9 19.9-72 57.7-72c27.7 0 51.7 19.3 57.7 46.3zM79.6 147.8l34 192.7c6.1 34.4 36 59.5 70.9 59.5l95.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-95.5 0c-58.2 0-108.1-41.8-118.2-99.1l-34-192.7c-2.3-13.1 6.4-25.5 19.5-27.8s25.5 6.4 27.8 19.5z"]
};
const faPaperPlaneTop = {
  prefix: 'far',
  iconName: 'paper-plane-top',
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M133.9 232L65.8 95.9 383.4 232l-249.5 0zm0 48l249.5 0L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z"]
};
const faPaperPlaneAlt = faPaperPlaneTop;
const faSend = faPaperPlaneTop;
const faMessageArrowUp = {
  prefix: 'far',
  iconName: 'message-arrow-up',
  icon: [512, 512, ["comment-alt-arrow-up"], "e1dc", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM280 296l0-118.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 296c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faCommentAltArrowUp = faMessageArrowUp;
const faLightbulbExclamation = {
  prefix: 'far',
  iconName: 'lightbulb-exclamation',
  icon: [384, 512, [], "f671", "M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zm0-400c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zm24 168a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faLayerMinus = {
  prefix: 'far',
  iconName: 'layer-minus',
  icon: [576, 512, ["layer-group-minus"], "f5fe", "M408 60l112 0c11 0 20 9 20 20s-9 20-20 20l-112 0c-11 0-20-9-20-20s9-20 20-20zM263.2 133.1c7.8-3.4 16.3-5.1 24.8-5.1s17 1.7 24.8 5.1l209.3 89.7c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 378.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 289.2C40.6 283.5 32 270.5 32 256s8.6-27.5 21.9-33.2l209.3-89.7zM288 176c-2 0-4 .4-5.9 1.2L98.3 256l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 256 293.9 177.2c-1.9-.8-3.9-1.2-5.9-1.2zM53.9 350.8l31.2-13.4L146 363.5 98.3 384l183.8 78.8c1.9 .8 3.9 1.2 5.9 1.2s4-.4 5.9-1.2L477.7 384 430 363.5l60.9-26.1 31.2 13.4c13.3 5.7 21.9 18.8 21.9 33.2s-8.6 27.5-21.9 33.2L312.8 506.9c-7.8 3.4-16.3 5.1-24.8 5.1s-17-1.7-24.8-5.1L53.9 417.2C40.6 411.5 32 398.5 32 384s8.6-27.5 21.9-33.2z"]
};
const faLayerGroupMinus = faLayerMinus;
const faChartPieSimpleCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-currency',
  icon: [640, 512, [], "e604", "M496 192c-46.8 0-89.3 18.2-120.8 48L272 240l0-223.4c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288l67.2 0c-7.6 14.9-13.2 31-16.3 48L224 336c-26.5 0-48-21.5-48-48l0-197.1C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 240l0 48 48 0zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM531.3 426l17.3 17.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L554 403.3c13.2-21.6 13.2-49.1 0-70.7l17.3-17.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L531.3 310c-21.6-13.2-49.1-13.2-70.7 0l-17.3-17.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L438 332.7c-13.2 21.6-13.2 49.1 0 70.7l-17.3 17.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L460.7 426c21.6 13.2 49.1 13.2 70.7 0z"]
};
const faCircleE = {
  prefix: 'far',
  iconName: 'circle-e',
  icon: [512, 512, [], "e109", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 104 0 104c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-56 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-56 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faBuildingWheat = {
  prefix: 'far',
  iconName: 'building-wheat',
  icon: [640, 512, [], "e4db", "M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm40 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM104 216c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm112 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm424-40l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zm0 128l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zm0 112l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zM512 496c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zm0-128c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zM528 32c-13.3 0-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-13.3-10.7-24-24-24zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zM456 72c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24z"]
};
const faGaugeMax = {
  prefix: 'far',
  iconName: 'gauge-max',
  icon: [512, 512, ["tachometer-alt-fastest"], "f626", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56s25.1-56 56-56c10.3 0 19.9 2.8 28.2 7.6l110.2-75.4c10.9-7.5 25.9-4.7 33.4 6.3s4.7 25.9-6.3 33.4L311.3 343.2c.4 2.9 .7 5.8 .7 8.8c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM112 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faTachometerAltFastest = faGaugeMax;
const faPersonBreastfeeding = {
  prefix: 'far',
  iconName: 'person-breastfeeding',
  icon: [448, 512, [], "e53a", "M192 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 144 80a80 80 0 1 0 160 0zM116.9 282.2c19.6-26.5 50.6-42.2 83.6-42.2l58.3 0c27.6 0 54.1 11 73.7 30.6l55.2 55.3c12 12 12.5 31.3 1.2 43.9L326.1 440c-8.8 9.9-8 25.1 1.9 33.9s25.1 8 33.9-1.9l62.8-70.2c28.3-31.6 27-79.8-3-109.8l-55.2-55.3C338 208.1 299.3 192 258.9 192l-58.3 0c-48.2 0-93.6 22.9-122.2 61.7l-56 75.7C-8.1 370.6 7.5 429.5 54.5 450.2L190.3 510c12.1 5.3 26.3-.2 31.6-12.3s-.2-26.3-12.3-31.6L73.8 406.2c-18.8-8.3-25-31.8-12.8-48.3l56-75.7zM192 328c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 43.4c0 7.5 2.1 14.8 6.1 21.2C177.8 437 226.5 464 278.9 464l1.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.1 0c-35.1 0-67.7-17.7-86.9-46.9l0-41.1zm80 56a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faApostrophe = {
  prefix: 'far',
  iconName: 'apostrophe',
  icon: [192, 512, [], "27", "M128 176c8.8 0 16-7.2 16-16l0-32 0-32c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0zm16 46c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10z"]
};
const faFilePng = {
  prefix: 'far',
  iconName: 'file-png',
  icon: [512, 512, [], "e666", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM318.3 360.8L352 428.2l0-60.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128c0 7.4-5.1 13.9-12.3 15.6s-14.7-1.8-18-8.4L320 435.8l0 60.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.4 5.1-13.9 12.3-15.6s14.7 1.8 18 8.4zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z"]
};
const faFireHydrant = {
  prefix: 'far',
  iconName: 'fire-hydrant',
  icon: [384, 512, [], "e17f", "M192 0c-17.7 0-32 14.3-32 32l0 4c-45 11.6-80.4 47-92 92l-12 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-12 0c-11.6-45-47-80.4-92-92l0-4c0-17.7-14.3-32-32-32zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-80 16 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-16 0 0-48-48 0 0 256-160 0 0-256-48 0 0 48-16 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l16 0 0 80-8 0zM248 320a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
const faRightToBracket = {
  prefix: 'far',
  iconName: 'right-to-bracket',
  icon: [512, 512, ["sign-in-alt"], "f2f6", "M192 365.8L302 256 192 146.2l0 53.8c0 13.3-10.7 24-24 24L48 224l0 64 120 0c13.3 0 24 10.7 24 24l0 53.8zM352 256c0 11.5-4.6 22.5-12.7 30.6L223.2 402.4c-8.7 8.7-20.5 13.6-32.8 13.6c-25.6 0-46.4-20.8-46.4-46.4l0-33.6-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l96 0 0-33.6c0-25.6 20.8-46.4 46.4-46.4c12.3 0 24.1 4.9 32.8 13.6L339.3 225.4c8.1 8.1 12.7 19.1 12.7 30.6zm-8 176l80 0c22.1 0 40-17.9 40-40l0-272c0-22.1-17.9-40-40-40l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faSignInAlt = faRightToBracket;
const faVideoPlus = {
  prefix: 'far',
  iconName: 'video-plus',
  icon: [576, 512, [], "f4e1", "M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM216 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48z"]
};
const faSquareRight = {
  prefix: 'far',
  iconName: 'square-right',
  icon: [448, 512, [10145, "arrow-alt-square-right"], "f352", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM262.6 151.2l84 91c3.5 3.8 5.4 8.7 5.4 13.9s-1.9 10.1-5.4 13.9l-84 91c-4.2 4.6-10.1 7.2-16.4 7.2C234 368 224 358 224 345.7l0-41.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-41.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.4 7.2z"]
};
const faArrowAltSquareRight = faSquareRight;
const faCommentSmile = {
  prefix: 'far',
  iconName: 'comment-smile',
  icon: [512, 512, [], "f4b4", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM192 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 270.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
const faVenus = {
  prefix: 'far',
  iconName: 'venus',
  icon: [384, 512, [9792], "f221", "M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4l0 49.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-49.6z"]
};
const faPassport = {
  prefix: 'far',
  iconName: 'passport',
  icon: [448, 512, [], "f5ab", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 400c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm33.3-176l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zM224 304l-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.3 0zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0zm0-32l-39.1 0c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8zM224 112l.3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.3 0zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"]
};
const faThumbtackSlash = {
  prefix: 'far',
  iconName: 'thumbtack-slash',
  icon: [640, 512, ["thumb-tack-slash"], "e68f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352c9.4-.4 18.1-4.9 23.9-12.3c6.1-7.8 8.2-17.9 5.8-27.5l-6.2-25c-10.3-41.3-35.4-75.7-68.7-98.3L428.9 96l-3.7-48L456 48c4.4 0 8.6-1.2 12.2-3.3C475.2 40.5 480 32.8 480 24c0-13.3-10.7-24-24-24L425.2 0 214.8 0 184 0c-13.3 0-24 10.7-24 24c0 8.8 4.8 16.5 11.8 20.7c3.6 2.1 7.7 3.3 12.2 3.3l30.8 0-3.7 48-3.2 41.6L38.8 5.1zM253.3 173.2l9.3-121.5c.1-1.2 .1-2.5 .1-3.7l114.5 0c0 1.2 0 2.5 .1 3.7l10.8 140.9c1.1 14.6 8.8 27.8 20.9 36c23.9 16.2 41.7 40.8 49.1 70.2l1.3 5.1-39.4 0L344 244.3l0-28.3c0-13.3-10.7-24-24-24c-10.4 0-19.2 6.6-22.6 15.8l-44.2-34.6zM344 367l-80-63-83.5 0 1.3-5.1c4-16.1 11.2-30.7 20.7-43.3l-37.7-29.7c-13.7 17.8-23.9 38.6-29.6 61.4l-6.2 25c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3l136 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-121z"]
};
const faThumbTackSlash = faThumbtackSlash;
const faInboxIn = {
  prefix: 'far',
  iconName: 'inbox-in',
  icon: [512, 512, [128229, "inbox-arrow-down"], "f310", "M280 24l0 206.1 63-63c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 305c-9.4 9.4-24.6 9.4-33.9 0L135 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l63 63L232 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM149.1 405.5L130.3 368 48 368l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 421.7 338.2 432 320 432l-128 0c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l82.3 0c18.2 0 34.8 10.3 42.9 26.5z"]
};
const faInboxArrowDown = faInboxIn;
const faHeartPulse = {
  prefix: 'far',
  iconName: 'heart-pulse',
  icon: [512, 512, ["heartbeat"], "f21e", "M256 163.9L222.1 130l-12-12c-21.7-21.7-52.5-31.6-82.7-26.5C81.6 99.1 48 138.7 48 185.1l0 5.8c0 23.9 8.4 46.9 23.5 65.1l51.1 0c6.5 0 12.3-3.9 14.8-9.8l31.8-76.3c2.5-5.9 8.2-9.8 14.5-9.8s12.2 3.6 14.8 9.4l58.2 129.3 48.9-97.9c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8l68.7 0c15.1-18.2 23.5-41.2 23.5-65.1l0-5.8c0-46.4-33.6-86-79.3-93.6c-30.2-5-61.1 4.8-82.7 26.5l-12 12L256 163.9zM456 288l-48.6 0-35.6 0c-18.2 0-34.8-10.3-42.9-26.5L320 243.8l-49.7 99.4c-2.8 5.5-8.5 9-14.6 8.8s-11.7-3.8-14.3-9.4L184.6 216.2 167 258.5C159.5 276.3 142 288 122.7 288l-18 0L56 288l-20.3 0C12.8 261.1 0 226.7 0 190.9l0-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84c0 0 0 0 0 0l12 12 12-12s0 0 0 0c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1l0 5.8c0 35.8-12.8 70.1-35.7 97.1L456 288zM68.6 320l70.3 0L256 429.3 373.1 320l70.3 0L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L68.6 320z"]
};
const faHeartbeat = faHeartPulse;
const faCircle8 = {
  prefix: 'far',
  iconName: 'circle-8',
  icon: [512, 512, [], "e0f5", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM264 128c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72l16 0zm-16 96s0 0 0 0l16 0s0 0 0 0c13.2 0 24-10.8 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm16 48l-16 0-8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0z"]
};
const faCloudsMoon = {
  prefix: 'far',
  iconName: 'clouds-moon',
  icon: [640, 512, [], "f745", "M352 160c0 11.5 1.2 22.7 3.5 33.4c53.7 8.2 96.5 49.8 106.4 103c14.2 5.5 27.2 13.4 38.5 23.2c3.7 .3 7.4 .4 11.2 .4c43.2 0 82.5-17.3 111.2-45.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7c-64.3 0-116.5-52.3-116.5-116.9c0-43.7 23.9-81.8 59.3-101.9c6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1 .6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160zM335.8 272c26.5 0 48 21.5 48 48c0 .8 0 1.7 .1 2.5l2 23.8c1.1 13.2 12.7 23 25.9 21.9c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48c-.6 0-1.3 0-1.9 0c-.3 0-.6 0-.9 0l-266.9 0c-.3 0-.6 0-1 0c-.4 0-.9 0-1.3 0c-17.7 0-32-14.3-32-32s14.3-32 32-32c1.6 0 3.1 .1 4.6 .3c6.9 1 13.9-1.1 19.1-5.6s8.3-11.2 8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c.1-.6 .2-1.1 .3-1.7c2.5-19.6 19.3-34.8 39.7-34.8c12.6 0 23.8 5.8 31.1 14.9c5.8 7.1 15.1 10.4 24.1 8.3s15.9-9.1 18-18c4.9-21.3 24-37.2 46.8-37.2zm96 46.8c-.6-52.5-43.4-94.8-96-94.8c-33 0-62 16.6-79.3 41.9c-12.2-6.3-26-9.9-40.6-9.9c-43 0-78.8 30.9-86.5 71.7c-1 2.6-1.5 5.4-1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80c.9 0 1.8 0 2.7 0l266 0c1.1 0 2.1 .1 3.2 .1c53 0 96-43 96-96c0-47.5-34.5-86.9-79.8-94.6l-.2-2.5zM320 192.1s0 0 0 0c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72s32.2 72 72 72c0 0 0 0 0 0l34.8 0c9.4-19.9 24.6-36.6 43.4-48l-76.4 0c-.6 0-1.2 0-1.7 0c-13.2 0-24-10.7-24-24s10.7-24 24-24c1.1 0 2.2 .1 3.2 .2c25.1 3.3 48.5-13.5 53.4-38.4c2.9-14.7 15.9-25.8 31.4-25.8c13.6 0 25.3 8.5 29.9 20.6c9.2 24.3 36.2 36.9 60.8 28.2c1.6-.6 3.4-.9 5.3-.9c8.8 0 16 7.2 16 16l0 .9c-.1 6.6-1.6 12.9-4.1 18.6c15.5-9.7 33.2-16.3 52.1-18.7l0-.9z"]
};
const faClockTenThirty = {
  prefix: 'far',
  iconName: 'clock-ten-thirty',
  icon: [512, 512, [], "e355", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-8-4-15.5-10.7-20l-96-64c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3L232 268.8 232 392c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faPeopleCarryBox = {
  prefix: 'far',
  iconName: 'people-carry-box',
  icon: [640, 512, ["people-carry"], "f4ce", "M176 48A48 48 0 1 0 80 48a48 48 0 1 0 96 0zM53 344.3L1.6 479.5c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L92.6 375.4 53 344.3zM96 187.5c0-6.4 5.2-11.5 11.5-11.5c4.4 0 8.6 1 12.5 2.8l0 116.4L99.1 278.7c-1.9-1.5-3.1-3.8-3.1-6.3l0-84.9zm72 145.4l0-89.6 26 39.1c3.3 4.9 7.6 9.1 12.7 12.1l26.1 15.7c5.6 5.9 13.5 9.6 22.3 9.9c.4 0 .9 0 1.3 0l127.2 0c.4 0 .9 0 1.3 0c8.7-.2 16.6-4 22.2-9.9l26.1-15.7c5.1-3 9.4-7.2 12.7-12.1l26-39.1 0 89.6-25.8 20.3c-8.1 6.4-13.4 15.6-14.9 25.8L416.2 484.6c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l14.6-102.5 92.2-72.4c13.5-10.6 21.4-26.9 21.4-44l0-84.9c0-32.9-26.6-59.5-59.5-59.5c-25.8 0-50 12.9-64.3 34.4L416 240.7l0-80.7c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 80.7-52.2-78.3c-14.3-21.5-38.5-34.4-64.3-34.4C74.6 128 48 154.6 48 187.5l0 84.9c0 17.2 7.9 33.4 21.4 44l92.2 72.4 14.6 102.5c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2L208.7 379c-1.5-10.2-6.8-19.4-14.9-25.8L168 332.9zM272 176l96 0 0 96-96 0 0-96zM512 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM638.4 479.5L587 344.3l-39.5 31.1 46.2 121.2c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31zM532.5 176c6.4 0 11.5 5.2 11.5 11.5l0 84.9c0 2.5-1.1 4.8-3.1 6.3L520 295.2l0-116.4c3.9-1.8 8.1-2.8 12.5-2.8z"]
};
const faPeopleCarry = faPeopleCarryBox;
const faFolderUser = {
  prefix: 'far',
  iconName: 'folder-user',
  icon: [512, 512, [], "e18e", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-80 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-80 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM320 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faTrashCanXmark = {
  prefix: 'far',
  iconName: 'trash-can-xmark',
  icon: [448, 512, [], "e2ae", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm63 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faTemperatureHigh = {
  prefix: 'far',
  iconName: 'temperature-high',
  icon: [512, 512, [], "f769", "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faMicrochip = {
  prefix: 'far',
  iconName: 'microchip',
  icon: [512, 512, [], "f2db", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-8 0c-35.3 0-64 28.7-64 64l0 8-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 8c0 35.3 28.7 64 64 64l8 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c35.3 0 64-28.7 64-64l0-8 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-8c0-35.3-28.7-64-64-64l-8 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40zM400 128l0 256c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16zM192 160c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-128 0zm16 48l96 0 0 96-96 0 0-96z"]
};
const faLeftLongToLine = {
  prefix: 'far',
  iconName: 'left-long-to-line',
  icon: [640, 512, [], "e41e", "M0 88C0 74.7 10.7 64 24 64s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88zM134.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6l-121.4-129zM288 200l0-53.5L185 256 288 365.5l0-53.5c0-6.4 2.5-12.5 7-17s10.6-7 17-7l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-13.3 0-24-10.7-24-24z"]
};
const faCrown = {
  prefix: 'far',
  iconName: 'crown',
  icon: [576, 512, [128081], "f521", "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7l-72-57.6L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6l41.4-227.5 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-72 57.6c-15.9 12.7-39.5 7.5-48.6-10.7L314.8 117.7 309 106zM133.7 418.9L102.2 245.6l28.9 23.1c39.8 31.8 98.8 18.9 121.5-26.7L288 171.3l35.4 70.7c22.8 45.6 81.8 58.5 121.5 26.7l28.9-23.1L442.3 418.9c-1.4 7.6-8 13.1-15.7 13.1l-277.2 0c-7.7 0-14.4-5.5-15.7-13.1z"]
};
const faWeightHanging = {
  prefix: 'far',
  iconName: 'weight-hanging',
  icon: [512, 512, [], "f5cd", "M216 88a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm118.4 40c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 14.4 3.5 28 9.6 40L120 128c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512l416 0c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128l-57.6 0zM256 176l136 0 72 288L48 464l72-288 136 0z"]
};
const faXmarksLines = {
  prefix: 'far',
  iconName: 'xmarks-lines',
  icon: [640, 512, [], "e59a", "M24 32l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56S10.7 32 24 32zm0 400l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24zM41 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55L7 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm224 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM455 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faFilePrescription = {
  prefix: 'far',
  iconName: 'file-prescription',
  icon: [384, 512, [], "f572", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm40 192c-13.3 0-24 10.7-24 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 22.1 0c.3 .3 .6 .7 .9 1l55 55-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23-31.1-31.1C227.5 299.7 240 279.3 240 256c0-35.3-28.7-64-64-64l-72 0zm72 80l-48 0 0-32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
const faTableCellsLock = {
  prefix: 'far',
  iconName: 'table-cells-lock',
  icon: [640, 512, [], "e679", "M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l24 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 65.1c-34.7 5-64.2 25.8-81 54.9l-71 0 0 80 56 0 0 .6c-16.9 9.8-29 27.1-31.5 47.4L360 344l0 88zM200 296l112 0 0-80-112 0 0 80zm328-56c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faCalendarRange = {
  prefix: 'far',
  iconName: 'calendar-range',
  icon: [448, 512, [], "e0d6", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm48 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm224 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 288c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zm40 72l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
const faFlowerDaffodil = {
  prefix: 'far',
  iconName: 'flower-daffodil',
  icon: [512, 512, [9880], "f800", "M112 88c0-48.6 39.4-88 88-88c21.3 0 40.8 7.6 56 20.1C271.2 7.6 290.7 0 312 0c48.6 0 88 39.4 88 88c0 21.3-7.6 40.8-20.1 56c12.6 15.2 20.1 34.7 20.1 56c0 48.6-39.4 88-88 88c-11.3 0-22.1-2.1-32-6l0 91.4c41-52 104.6-85.4 176-85.4l28 0c15.5 0 28 12.5 28 28c0 108.2-87.8 196-196 196l-36 0-48 0-36 0C87.8 512 0 424.2 0 316c0-15.5 12.5-28 28-28l28 0c71.4 0 135 33.4 176 85.4l0-91.4c-9.9 3.9-20.7 6-32 6c-48.6 0-88-39.4-88-88c0-21.3 7.6-40.8 20.1-56C119.6 128.8 112 109.3 112 88zm88-40c-22.1 0-40 17.9-40 40c0 15 8.3 28.2 20.6 35c7.6 4.2 12.4 12.3 12.4 21s-4.7 16.8-12.4 21c-12.4 6.9-20.6 20-20.6 35c0 22.1 17.9 40 40 40c15 0 28.2-8.3 35-20.6c4.2-7.6 12.3-12.4 21-12.4s16.8 4.7 21 12.4c6.9 12.4 20 20.6 35 20.6c22.1 0 40-17.9 40-40c0-15-8.3-28.2-20.6-35c-7.6-4.2-12.4-12.3-12.4-21s4.7-16.8 12.4-21c12.4-6.9 20.6-20 20.6-35c0-22.1-17.9-40-40-40c-15 0-28.2 8.3-35 20.6C272.8 76.3 264.7 81 256 81s-16.8-4.7-21-12.4C228.2 56.3 215 48 200 48zM49.3 336C59.1 408.3 121 464 196 464l29.4 0C204.5 390.1 136.6 336 56 336l-6.7 0zm413.3 0l-6.7 0c-80.6 0-148.5 54.1-169.4 128l29.4 0c75 0 136.9-55.7 146.7-128zM256 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHandBackPointUp = {
  prefix: 'far',
  iconName: 'hand-back-point-up',
  icon: [448, 512, [], "e1a2", "M144 0C108.7 0 80 28.7 80 64l0 188.8c-5.2 3.6-10.2 7.6-14.9 11.9L44.8 283.2C26.5 299.9 16 323.5 16 348.3l0 10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7L296 512c66.3 0 120-53.7 120-120l0-8 0-96c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5c-11-19.4-31.8-32.5-55.7-32.5c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5L208 64c0-35.3-28.7-64-64-64zM128 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 96 0 8c0 39.8-32.2 72-72 72l-125.4 0c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C83.6 429.7 64 395.5 64 358.5l0-10.2c0-11.3 4.8-22 13.1-29.6L96 301.5 96 344c0 8.8 7.2 16 16 16s16-7.2 16-16l0-78 0-2 0-200z"]
};
const faWeightScale = {
  prefix: 'far',
  iconName: 'weight-scale',
  icon: [512, 512, ["weight"], "f496", "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm304 0c0-22.6-4.3-44.2-12-64l28 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l28 0c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-56.2 0zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
const faWeight = faWeightScale;
const faArrowUpToArc = {
  prefix: 'far',
  iconName: 'arrow-up-to-arc',
  icon: [512, 512, [], "e617", "M256 48c114.9 0 208 93.1 208 208c0 13.3 10.7 24 24 24s24-10.7 24-24C512 114.6 397.4 0 256 0S0 114.6 0 256c0 13.3 10.7 24 24 24s24-10.7 24-24C48 141.1 141.1 48 256 48zM377.6 279.7l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7s-13 2.8-17.6 7.7l-104 112c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 245.1 232 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9z"]
};
const faStarExclamation = {
  prefix: 'far',
  iconName: 'star-exclamation',
  icon: [576, 512, [], "f2f3", "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM235.4 187.2L287.9 79l52.6 108.2c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-7.1-3.8-15.6-3.8-22.6 0L171.4 443.7l20.2-119.6c1.3-7.7-1.2-15.5-6.8-21L99 217.9l118.3-17.5c7.8-1.2 14.6-6.1 18.1-13.3zM288 168c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24zm32 168a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faBooks = {
  prefix: 'far',
  iconName: 'books',
  icon: [512, 512, [128218], "f5db", "M48 416l0 48 64 0 0-48-64 0zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4l-64 0c-26.5 0-48-21.5-48-48l0-48 0-24 0-24L0 144l0-24L0 96 0 48C0 21.5 21.5 0 48 0l64 0c8.7 0 16.9 2.3 24 6.4C143.1 2.3 151.3 0 160 0l64 0c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L349.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L275.6 145.9 272 132.2l0 11.8 0 224 0 24 0 24 0 48c0 26.5-21.5 48-48 48l-64 0c-8.7 0-16.9-2.3-24-6.4zM160 464l64 0 0-48-64 0 0 48zM112 48L48 48l0 48 64 0 0-48zm0 96l-64 0 0 224 64 0 0-224zm48-48l64 0 0-48-64 0 0 48zm64 272l0-224-64 0 0 224 64 0zm216.1-12.3l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L464 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L360.4 48.5 304 64.1c0 .1 0 .2 0 .4l11.7 45.2z"]
};
const faUserGroup = {
  prefix: 'far',
  iconName: 'user-group',
  icon: [640, 512, [128101, "user-friends"], "f500", "M1.5 458.7c6-45.5 29.2-85.6 62.8-113.6C95.3 319.4 135 304 178.3 304l45.7 0 45.7 0c43.3 0 83 15.4 113.9 41.1c33.6 28 56.8 68.1 62.8 113.6c1 7.7 1.5 15.6 1.5 23.6c0 16.4-13.3 29.7-29.7 29.7l-19.6 0L49.3 512l-19.6 0C13.3 512 0 498.7 0 482.3c0-8 .5-15.9 1.5-23.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zm208 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM178.3 352c-47.8 0-89.5 25.7-112.2 64c-8.6 14.4-14.4 30.7-16.8 48L98 464 350 464l48.8 0c-.4-2.7-.8-5.3-1.4-8c-2.9-14.3-8.2-27.8-15.5-40c-22.7-38.3-64.4-64-112.2-64l-91.4 0zm431 160l-136.9 0c4.9-8.8 7.6-18.9 7.6-29.7c0-65-29.5-123.2-75.9-161.8c4.3-.4 8.7-.5 13.2-.5l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"]
};
const faUserFriends = faUserGroup;
const faArrowUpAZ = {
  prefix: 'far',
  iconName: 'arrow-up-a-z',
  icon: [576, 512, ["sort-alpha-up"], "f15e", "M416 32c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5l-85.2 0-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160C398.6 37.1 406.9 32 416 32zM394.8 152l42.3 0L416 109.7 394.8 152zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM352 288l128 0c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 432l74.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 336 352 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faSortAlphaUp = faArrowUpAZ;
const faLayerPlus = {
  prefix: 'far',
  iconName: 'layer-plus',
  icon: [576, 512, ["layer-group-plus"], "f5ff", "M464 4c-11 0-20 9-20 20l0 36-36 0c-11 0-20 9-20 20s9 20 20 20l36 0 0 36c0 11 9 20 20 20s20-9 20-20l0-36 36 0c11 0 20-9 20-20s-9-20-20-20l-36 0 0-36c0-11-9-20-20-20zM288 128c-8.5 0-17 1.7-24.8 5.1L53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 133.1c-7.8-3.4-16.3-5.1-24.8-5.1zm-5.9 49.2c1.9-.8 3.9-1.2 5.9-1.2s4 .4 5.9 1.2L477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256l183.8-78.8zM85.1 337.4L53.9 350.8C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4z"]
};
const faLayerGroupPlus = faLayerPlus;
const faPlayPause = {
  prefix: 'far',
  iconName: 'play-pause',
  icon: [640, 512, [], "e22f", "M432 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zm144 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM112 381.8l0-251.7L263 256 112 381.8zm4.5-310.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96l0 320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"]
};
const faBlockQuestion = {
  prefix: 'far',
  iconName: 'block-question',
  icon: [448, 512, [], "e3dd", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm137.8 77.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 272.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 360a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM360 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 392a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm296-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSnooze = {
  prefix: 'far',
  iconName: 'snooze',
  icon: [448, 512, [128164, "zzz"], "f880", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l59.1 0-77.2 88.2c-6.2 7.1-7.7 17.1-3.8 25.7S174.6 176 184 176l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.1 0 77.2-88.2c6.2-7.1 7.7-17.1 3.8-25.7S305.4 0 296 0L184 0zM312 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.9 0L293.1 377.3c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-62.9 0 81.9-105.3c5.6-7.2 6.6-17 2.6-25.3s-12.4-13.5-21.6-13.5l-112 0zM24 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l128.6 0L4.6 473.8c-5.3 7.3-6.1 17-2.1 25S15 512 24 512l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L71.4 464l148-201.8c5.3-7.3 6.1-17 2.1-25S209 224 200 224L24 224z"]
};
const faZzz = faSnooze;
const faScannerImage = {
  prefix: 'far',
  iconName: 'scanner-image',
  icon: [576, 512, [], "f8f3", "M66.7 34.5c-11.9-5.9-26.3-1.1-32.2 10.7s-1.1 26.3 10.7 32.2L466.3 288 64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-32 0-32 0-8.4c0-33.3-18.8-63.8-48.6-78.7L66.7 34.5zM528 352l0 32 0 32c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16zM120 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faTvRetro = {
  prefix: 'far',
  iconName: 'tv-retro',
  icon: [512, 512, [128250], "f401", "M135 7c9.4-9.4 24.6-9.4 33.9 0l87 87L343 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55L432 96c44.2 0 80 35.8 80 80l0 256c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l110.1 0L135 41c-9.4-9.4-9.4-24.6 0-33.9zM80 144c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32L80 144zm336 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM144 192l160 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z"]
};
const faSquareT = {
  prefix: 'far',
  iconName: 'square-t',
  icon: [448, 512, [], "e280", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm120 48l104 0 104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faFarm = {
  prefix: 'far',
  iconName: 'farm',
  icon: [576, 512, ["barn-silo"], "f864", "M48 464l0-288 115.3 0 23.4-50.2c7.2-15.5 19.8-27.9 35.3-35C212.1 39.1 166.6 0 112 0C50.1 0 0 50.1 0 112L0 464c0 26.5 21.5 48 48 48l100.1 0c-11-13.3-18.1-29.8-19.8-48L48 464zM176 128L48 128l0-16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 16zm81.9 34.4L368 114.2l110.1 48.2 49.9 107L528 456c0 4.4-3.6 8-8 8l-88 0 0-56c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 56-88 0c-4.4 0-8-3.6-8-8l0-186.7 49.9-107zM384 68.8c-10.2-4.5-21.8-4.5-32.1 0L235.9 119.6c-8.9 3.9-16.1 10.9-20.2 19.7L163.8 250.6c-2.5 5.3-3.8 11.1-3.8 16.9L160 456c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56l0-188.5c0-5.8-1.3-11.6-3.8-16.9L520.3 139.3c-4.1-8.8-11.3-15.8-20.2-19.7L384 68.8zM320 248l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faBarnSilo = faFarm;
const faChessKnight = {
  prefix: 'far',
  iconName: 'chess-knight',
  icon: [448, 512, [9822], "f441", "M226.6 48L117.3 48l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1l-50.7 0c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0L226.6 0C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352l-48.8 0 24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464l310.7 0-16.6-32L85.2 432zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L56.8 512C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384l297 0c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"]
};
const faBarsSort = {
  prefix: 'far',
  iconName: 'bars-sort',
  icon: [448, 512, [], "e0ae", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 272c-13.3 0-24-10.7-24-24zM192 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24z"]
};
const faPalletBoxes = {
  prefix: 'far',
  iconName: 'pallet-boxes',
  icon: [640, 512, [57863, "palette-boxes", "pallet-alt"], "f483", "M272 48L112 48l0 160 160 0 0-160zM112 0L272 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48L64 48C64 21.5 85.5 0 112 0zM528 112l-96 0 0 96 96 0 0-96zM432 64l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z"]
};
const faPaletteBoxes = faPalletBoxes;
const faPalletAlt = faPalletBoxes;
const faFaceLaughSquint = {
  prefix: 'far',
  iconName: 'face-laugh-squint',
  icon: [512, 512, ["laugh-squint"], "f59b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
const faLaughSquint = faFaceLaughSquint;
const faCodeSimple = {
  prefix: 'far',
  iconName: 'code-simple',
  icon: [576, 512, [], "e13d", "M216.6 105.4c9.6-9.2 9.9-24.3 .8-33.9s-24.3-9.9-33.9-.8l-176 168C2.7 243.2 0 249.4 0 256s2.7 12.8 7.4 17.4l176 168c9.6 9.2 24.8 8.8 33.9-.8s8.8-24.8-.8-33.9L58.8 256 216.6 105.4zm142.9 0L517.2 256 359.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z"]
};
const faBoltSlash = {
  prefix: 'far',
  iconName: 'bolt-slash',
  icon: [640, 512, [], "e0b8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L450.2 327.6l49.5-42c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9l-85.2 0L445.4 36.6C450.6 18.3 436.8 0 417.7 0c-6.8 0-13.5 2.4-18.7 6.9L227.9 153.3 38.8 5.1zM266.4 183.5L381.6 85 337.5 239.3l-71.1-55.7zM379.3 272l62.2 0-29.8 25.3L379.3 272zm-4.4 119.4l-38.5-30.3-78.2 66.4L288.1 323l-40.7-32.1L194.6 475.4c-5.2 18.4 8.5 36.6 27.6 36.6c6.8 0 13.4-2.4 18.6-6.8L374.9 391.4zM153.5 216.9l-13.7 11.7c-7.5 6.4-11.8 15.8-11.8 25.6c0 18.6 15.1 33.7 33.7 33.7l82 0-90.2-71.1z"]
};
const faPanelFire = {
  prefix: 'far',
  iconName: 'panel-fire',
  icon: [640, 512, [], "e42f", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l242.1 0c8.1 17.5 18.8 33.7 31.5 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 32.2c-12.6-1.2-25.5 2.7-35.5 11.7c-4.2 3.8-8.4 7.6-12.5 11.5L400 96c0-8.8-7.2-16-16-16zM293.8 311.3c-1.8 .5-3.8 .7-5.8 .7c-13.3 0-24-10.7-24-24s10.7-24 24-24c8.2 0 15.5 4.1 19.8 10.4c-5.8 12.1-10.6 24.5-14 36.9zM96 160c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-32zm32 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm321.7-79.9L518 194.3c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.1 640 322 640 352c0 88.7-71.3 159.8-160 159.8c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327 416 363.5 416 400c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faBinaryCircleCheck = {
  prefix: 'far',
  iconName: 'binary-circle-check',
  icon: [640, 512, [], "e33c", "M318 4.5C324.3 9 328 16.3 328 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5zM94 292.5c6.3 4.5 10 11.8 10 19.5l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3zM72 0l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72L0 72C0 32.2 32.2 0 72 0zM48 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L72 48C58.7 48 48 58.7 48 72zM192 360c0-39.8 32.2-72 72-72l48 0c8.8 0 17.2 1.6 25 4.5c-6.8 14.4-11.8 29.8-14.5 45.9c-3.2-1.5-6.7-2.4-10.5-2.4l-48 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l48 0c0 0 .1 0 .1 0l36.4 0c5.4 8.2 11.4 15.9 18 23.1C353.2 502.4 333.7 512 312 512l-48 0c-39.8 0-72-32.2-72-72l0-80zm160 8a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faCommentMinus = {
  prefix: 'far',
  iconName: 'comment-minus',
  icon: [512, 512, [], "f4b1", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM184 216c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faBurrito = {
  prefix: 'far',
  iconName: 'burrito',
  icon: [512, 512, [127791], "f7ed", "M67.9 304c-4.4 4.4-8.1 9.4-11.2 14.7c17.3 6 35.9 9.3 55.3 9.3c75.6 0 139.5-49.9 160.6-118.6c4.8-15.6 7.4-32.2 7.4-49.4c0-20.3-3.6-39.8-10.2-57.9L67.9 304zm-53.8-7.4s0 0 0 0c5.3-9.7 11.9-18.6 19.8-26.5L242 62c8.2-35.5 40-62 78-62c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c2.7 6.1 4.6 12.7 5.7 19.6c6.6 41.7-20.4 81-61 90.4L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9L112 444.1c12.7 12.7 30 19.9 48 19.9s35.3-7.2 48-19.9L409.9 242.2c-18-6.6-37.5-10.2-57.9-10.2c-13 0-25.7 1.5-37.9 4.3C283.3 317.9 204.5 376 112 376c-21.7 0-42.6-3.2-62.4-9.1c2.8 12.5 9.1 24 18.2 33.1L112 444.1 78.1 478.1 33.9 433.9C12.2 412.2 0 382.7 0 352c0-2.4 .1-4.8 .2-7.1c0 0 0 0 0 0c1-17 5.8-33.5 13.9-48.3z"]
};
const faViolin = {
  prefix: 'far',
  iconName: 'violin',
  icon: [640, 512, [127931], "f8ed", "M496 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM345 41L41 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L311 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM198.4 403.2c6.4-4.8 15.3-4.1 20.9 1.5l16 16c5.6 5.6 6.3 14.5 1.5 20.9l-5.3 7.1c16.6 9.7 35.9 15.3 56.5 15.3c25.2 0 48.3-8.2 67-22.2c-2-8.3-3-17-3-25.8c0-60 47.3-109.1 106.6-111.9c8.2-19.7 8.4-46.6-12.7-76.1L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L412 194.1c-29.5-21-56.4-20.8-76.1-12.7C333.1 240.8 284 288 224 288c-8.8 0-17.5-1-25.8-3c-14 18.7-22.2 41.8-22.2 67c0 20.6 5.6 39.9 15.3 56.5l7.1-5.3zm-45.7 34.3c-15.7-24.7-24.7-54-24.7-85.5c0-41.2 15.5-78.7 41.1-107c9.7-10.7 25.8-10.1 39.8-6.7c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64c0-11.6 2.6-24 12.4-30.1c39.3-24.7 94.3-26.4 145.8 14L599 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L480.2 193.8c40.3 51.5 38.6 106.5 14 145.8C488 349.4 475.6 352 464 352c-35.3 0-64 28.7-64 64c0 5.2 .6 10.2 1.8 15.1c3.4 14.1 4 30.2-6.7 39.8C366.7 496.5 329.2 512 288 512c-31.4 0-60.7-9.1-85.5-24.7l-13.7 18.3c-2.8 3.7-7 6-11.7 6.4s-9.2-1.4-12.4-4.6l-32-32c-3.3-3.3-5-7.8-4.6-12.4s2.6-8.9 6.4-11.7l18.3-13.7zM448 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faObjectsColumn = {
  prefix: 'far',
  iconName: 'objects-column',
  icon: [448, 512, [], "e3c1", "M48 80l0 160 96 0 0-160L48 80zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM304 272l0 160 96 0 0-160-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM144 368l-96 0 0 64 96 0 0-64zM48 320l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zM304 80l0 64 96 0 0-64-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64z"]
};
const faSquareChevronDown = {
  prefix: 'far',
  iconName: 'square-chevron-down',
  icon: [448, 512, ["chevron-square-down"], "f329", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 345L103 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 345c-9.4 9.4-24.6 9.4-33.9 0z"]
};
const faChevronSquareDown = faSquareChevronDown;
const faCommentPlus = {
  prefix: 'far',
  iconName: 'comment-plus',
  icon: [512, 512, [], "f4b2", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faTriangleInstrument = {
  prefix: 'far',
  iconName: 'triangle-instrument',
  icon: [576, 512, ["triangle-music"], "f8e2", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 43.3c-21.3 5.9-40 19.5-52.1 38.7L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94L450 512c51.9 0 94-42.1 94-94c0-17.8-5-35.2-14.5-50.2L448.2 239l-34.8 34.8 75.5 119.5c4.6 7.4 7.1 15.9 7.1 24.6c0 25.4-20.6 46-46 46L126 464c-25.4 0-46-20.6-46-46c0-8.7 2.5-17.2 7.1-24.6L252.4 131.6c7.7-12.2 21.1-19.6 35.6-19.6s27.9 7.4 35.6 19.6l46 72.9-62.8 62.8c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8l55.1-55.1 34.8-34.8L537 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-98.6 98.6L364.1 106C352 86.8 333.3 73.2 312 67.3L312 24z"]
};
const faTriangleMusic = faTriangleInstrument;
const faWheelchair = {
  prefix: 'far',
  iconName: 'wheelchair',
  icon: [512, 512, [], "f193", "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.5 247.2C78.1 263.2 48 304.1 48 352c0 61.9 50.1 112 112 112c42.8 0 80-24 98.9-59.3c6.2-11.7 20.8-16.1 32.5-9.9s16.1 20.8 9.9 32.5C274.3 477.7 221.2 512 160 512C71.6 512 0 440.4 0 352c0-68.5 43.1-126.9 103.5-149.7c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9zm67.2-118.8c13-2.4 25.5 6.3 27.9 19.3l5.1 28.3L344 176c13.3 0 24 10.7 24 24s-10.7 24-24 24l-114.5 0 13.4 73.4c.7 3.8 4 6.6 7.9 6.6l122.8 0c15.9 0 30.3 9.4 36.6 24l43 98.3 27.2-9.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-48 16c-11.8 3.9-24.6-1.8-29.6-13.1L368.3 352l-117.6 0c-27.1 0-50.3-19.4-55.1-46L168.4 156.3c-2.4-13 6.3-25.5 19.3-27.9z"]
};
const faUserPilotTie = {
  prefix: 'far',
  iconName: 'user-pilot-tie',
  icon: [448, 512, [], "e2c1", "M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM183.2 65.7L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9c0 0 0 0 0 0l-.5-.9s0 0 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L168 512s0 0 0 0l1 0 21.2 0 1.7 0s0 0 0 0l64 0s0 0 0 0l1.7 0 21.2 0 1 0s0 0 0 0l142.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464s0 0 0 0l-.5 .9c0 0 0 0 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464l-88.3 0c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0l-88.3 0 35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"]
};
const faPianoKeyboard = {
  prefix: 'far',
  iconName: 'piano-keyboard',
  icon: [576, 512, [127929], "f8d5", "M528 224l0 160c0 8.8-7.2 16-16 16l-80 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 80 0zM400 400l-96 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zm-128 0l-96 0 0-84.3c9.6-5.5 16-15.9 16-27.7l0-64 64 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zm-128 0l-80 0c-8.8 0-16-7.2-16-16l0-160 80 0 0 64c0 11.8 6.4 22.2 16 27.7l0 84.3zM528 176l-112 0-128 0-128 0L48 176l0-48c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 48zm48 0l0-48c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128l0 48 0 24 0 24L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-160 0-24 0-24z"]
};
const faBedEmpty = {
  prefix: 'far',
  iconName: 'bed-empty',
  icon: [640, 512, [128719], "f8f9", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 184 0 360l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 544 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 0-80c0-66.3-53.7-120-120-120L48 160 48 56zM592 336L48 336l0-128 472 0c39.8 0 72 32.2 72 72l0 56z"]
};
const faCircleArrowUp = {
  prefix: 'far',
  iconName: 'circle-arrow-up',
  icon: [512, 512, ["arrow-circle-up"], "f0aa", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 207l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
const faArrowCircleUp = faCircleArrowUp;
const faToggleOn = {
  prefix: 'far',
  iconName: 'toggle-on',
  icon: [576, 512, [], "f205", "M192 112c-79.5 0-144 64.5-144 144s64.5 144 144 144l192 0c79.5 0 144-64.5 144-144s-64.5-144-144-144l-192 0zM0 256C0 150 86 64 192 64l192 0c106 0 192 86 192 192s-86 192-192 192l-192 0C86 448 0 362 0 256zm384-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faRectangleVertical = {
  prefix: 'far',
  iconName: 'rectangle-vertical',
  icon: [384, 512, ["rectangle-portrait"], "f2fb", "M336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 384zM384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384z"]
};
const faRectanglePortrait = faRectangleVertical;
const faPersonWalking = {
  prefix: 'far',
  iconName: 'person-walking',
  icon: [320, 512, [128694, "walking"], "f554", "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm11.7 128.8l-29.9 89.8c-1.1 3.2 0 6.6 2.5 8.7l16.4 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1zm57.6 53.1l-28.5 91.3 50.1 40.7c6.9 5.6 11.7 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L114 312.6C96 297.9 88.9 273.5 96.2 251.4L119 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7L19.5 217c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L313 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L250 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7zM75.5 402.5l24.1-60.4 39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5z"]
};
const faWalking = faPersonWalking;
const faL = {
  prefix: 'far',
  iconName: 'l',
  icon: [320, 512, [108], "4c", "M56 32c13.3 0 24 10.7 24 24l0 376 216 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 480c-13.3 0-24-10.7-24-24L32 56c0-13.3 10.7-24 24-24z"]
};
const faSignalStream = {
  prefix: 'far',
  iconName: 'signal-stream',
  icon: [576, 512, [], "f8dd", "M99.8 69.4c10.2 8.4 11.6 23.6 3.2 33.8C68.6 144.7 48 197.9 48 256s20.6 111.3 55 152.8c8.4 10.2 7 25.3-3.2 33.8s-25.3 7-33.8-3.2C24.8 389.6 0 325.7 0 256S24.8 122.4 66 72.6c8.4-10.2 23.6-11.6 33.8-3.2zm376.5 0c10.2-8.4 25.3-7 33.8 3.2c41.2 49.8 66 113.8 66 183.4s-24.8 133.6-66 183.4c-8.4 10.2-23.6 11.6-33.8 3.2s-11.6-23.6-3.2-33.8c34.3-41.5 55-94.7 55-152.8s-20.6-111.3-55-152.8c-8.4-10.2-7-25.3 3.2-33.8zM248 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-61.1-78.5C170 199.2 160 226.4 160 256s10 56.8 26.9 78.5c8.1 10.5 6.3 25.5-4.2 33.7s-25.5 6.3-33.7-4.2c-23.2-29.8-37-67.3-37-108s13.8-78.2 37-108c8.1-10.5 23.2-12.3 33.7-4.2s12.3 23.2 4.2 33.7zM427 148c23.2 29.8 37 67.3 37 108s-13.8 78.2-37 108c-8.1 10.5-23.2 12.3-33.7 4.2s-12.3-23.2-4.2-33.7C406 312.8 416 285.6 416 256s-10-56.8-26.9-78.5c-8.1-10.5-6.3-25.5 4.2-33.7s25.5-6.3 33.7 4.2z"]
};
const faDownToBracket = {
  prefix: 'far',
  iconName: 'down-to-bracket',
  icon: [448, 512, [], "e4e7", "M114.2 192L224 302 333.8 192 280 192c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 352c-11.5 0-22.5-4.6-30.6-12.7L77.6 223.2C68.9 214.5 64 202.7 64 190.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 339.3c-8.1 8.1-19.1 12.7-30.6 12.7zM48 344l0 80c0 22.1 17.9 40 40 40l272 0c22.1 0 40-17.9 40-40l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faCircleZ = {
  prefix: 'far',
  iconName: 'circle-z',
  icon: [512, 512, [], "e130", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l98.2 0L164.3 346.3c-5.1 7.3-5.7 16.9-1.5 24.8S175.1 384 184 384l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-98.2 0L347.7 165.7c5.1-7.3 5.7-16.9 1.5-24.8S336.9 128 328 128l-144 0z"]
};
const faStars = {
  prefix: 'far',
  iconName: 'stars',
  icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
};
const faFire = {
  prefix: 'far',
  iconName: 'fire',
  icon: [448, 512, [128293], "f06d", "M89.3 156.3C113 115 143.2 77 170.5 50.4c18.7 18.7 40.9 47.2 60.1 71.7c3.8 4.8 7.4 9.5 10.9 13.9c4.6 5.8 11.7 9.2 19.1 9.1s14.4-3.6 18.9-9.5c3.3-4.3 7.7-10.8 12.3-17.4c2.6-3.8 5.3-7.6 7.8-11.2c5.6-7.9 10.5-14.5 14.4-19.1c20 20.8 41 53 57.4 88.4c17.7 38.2 28.6 77 28.6 106.3c0 103-78.8 181.4-176 181.4c-98.3 0-176-78.4-176-181.4c0-37.5 16.2-82.4 41.3-126.2zM199.5 11.6C183.3-3.8 158-3.9 141.8 11.5c-32 30.1-67 73.6-94.1 121C20.7 179.5 0 233 0 282.6C0 410.9 98.1 512 224 512c124.6 0 224-100.9 224-229.4c0-39.1-13.9-85.2-33.1-126.5C395.7 114.6 369.8 74.9 343 49c-16.3-15.8-42-15.8-58.3-.1c-7.9 7.6-17 20-24.3 30.3l-1.1 1.6C240.6 57 218.4 29.5 199.5 11.6zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"]
};
const faBedPulse = {
  prefix: 'far',
  iconName: 'bed-pulse',
  icon: [640, 512, ["procedures"], "f487", "M483.2 9.6L524 64l92 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112 216 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM288 216c0-27.3 19.5-50 45.4-55l20 30.1c4.7 7 10.8 12.7 17.8 16.9L344 208c-4.4 0-8 3.6-8 8l0 152 256 0 0-88c0-39.8-32.2-72-72-72l-91.2 0c9.3-5.6 17-13.9 21.8-24.2L461.9 160l58.1 0c66.3 0 120 53.7 120 120l0 112 0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-280 0L48 416l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96L0 88C0 74.7 10.7 64 24 64s24 10.7 24 24l0 280 240 0 0-152zm-80 32a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM80 248a88 88 0 1 1 176 0A88 88 0 1 1 80 248z"]
};
const faProcedures = faBedPulse;
const faHouseDay = {
  prefix: 'far',
  iconName: 'house-day',
  icon: [640, 512, [], "e00e", "M174.2 8.3C171.4 3.2 166-.1 160.1-.1s-11.3 3.2-14.1 8.4L118.4 59.5 62.8 42.8c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9l16.7 55.7L8.3 146c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51.2 27.6L42.8 257.4c-1.7 5.6-.1 11.7 4 15.9s10.3 5.7 15.9 4l55.7-16.7 6.2 11.5 24-19.6 14.5-11.8c-1 0-2.1 .1-3.1 .1c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 6.6-.8 13-2.3 19.2l54.6-44.5-31.7-17.1 16.7-55.7c1.7-5.6 .1-11.7-4-15.9s-10.3-5.7-15.9-4L201.8 59.5 174.2 8.3zM208 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm207.2-58.6c-8.8-7.2-21.5-7.2-30.3 0l-216 176c-10.3 8.4-11.8 23.5-3.4 33.8s23.5 11.8 33.8 3.4L224 294.4 224 456c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-161.6 24.8 20.2c10.3 8.4 25.4 6.8 33.8-3.4s6.8-25.4-3.4-33.8l-216-176zM528 255.3L528 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-200.7L400 151 528 255.3zM352 312l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faShuttleSpace = {
  prefix: 'far',
  iconName: 'shuttle-space',
  icon: [640, 512, ["space-shuttle"], "f197", "M32 384l-8 0c-13.3 0-24-10.7-24-24l0-32L0 184l0-32c0-13.3 10.7-24 24-24l8 0 0-48c0-26.5 21.5-48 48-48l50 0c40.6 0 80.4 11 115.2 31.9L405.3 160l50.7 0c69.3 0 135 22.7 179.2 81.6c6.4 8.5 6.4 20.3 0 28.8C591 329.3 525.3 352 456 352l-50.7 0L245.2 448.1C210.4 469 170.6 480 130 480l-50 0c-26.5 0-48-21.5-48-48l0-48zm280-32l-144 0c-9.9 13.2-23.9 23.3-40 28.3l0 51.7 2 0c31.9 0 63.2-8.7 90.6-25.1L312 352zm0-192l-91.5-54.9C193.2 88.7 161.9 80 130 80l-2 0 0 51.7c16.1 5.1 30.1 15.1 40 28.3l144 0zM48 184l0 144 0 8 56 0c12.7 0 23.8-7.4 28.9-18.3c4-8.4 12.4-13.7 21.7-13.7L456 304c32.6 0 62.4-5.8 88-18.5l0-59.1c-25.6-12.6-55.4-18.5-88-18.5l-301.4 0c-9.3 0-17.7-5.3-21.7-13.7C127.8 183.4 116.7 176 104 176l-56 0 0 8zm416 40c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
};
const faSpaceShuttle = faShuttleSpace;
const faShirtLongSleeve = {
  prefix: 'far',
  iconName: 'shirt-long-sleeve',
  icon: [640, 512, [], "e3c7", "M188.4 48c-26.3 0-50.4 14.3-63.1 37.3L58.9 206C51.7 219 48 233.6 48 248.4L48 400l48 0 0-151.6c0-13.6 4.5-27.2 9.7-39c5.4-12.1 12.5-24.4 19.7-35.8c6.1-9.6 12.6-19.2 18.4-27.8c1.1-1.6 2.2-3.2 3.2-4.7c6.9-10.2 12.3-18.4 15.9-24.8c5.3-9.6 16.4-14.4 27-11.7s18 12.3 18 23.2l0 320c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-320c0-11 7.4-20.5 18-23.2s21.7 2.1 27 11.7c3.5 6.4 9 14.7 15.9 24.8c1 1.5 2.1 3.1 3.2 4.7c5.9 8.6 12.3 18.2 18.4 27.8c7.2 11.4 14.4 23.7 19.7 35.8c5.2 11.8 9.7 25.4 9.7 39L544 400l48 0 0-151.6c0-14.8-3.7-29.4-10.9-42.4L514.7 85.3C502.1 62.3 477.9 48 451.6 48L444 48c-.4 0-.9 0-1.3 0c-1 .1-2 0-3 0l-18.5 0c-10.8 45.9-52 80-101.2 80s-90.4-34.1-101.2-80l-18.5 0c-1 .1-2 .1-3 0c-.4 0-.9 0-1.3 0l-7.6 0zM83.2 62.2C104.3 23.8 144.6 0 188.4 0L196 0c.8 0 1.5 0 2.3 0c.6 0 1.1 0 1.7 0l24 0c23 0 37.7 18.2 41.1 35.2C270.3 60.7 292.9 80 320 80s49.7-19.3 54.9-44.8C378.3 18.2 393 0 416 0l24 0c.6 0 1.1 0 1.7 0c.8 0 1.5 0 2.3 0l7.6 0c43.8 0 84.1 23.8 105.1 62.2l66.4 120.7c11 20.1 16.8 42.6 16.8 65.5L640 424c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-175.6c0-3.7-1.4-10.1-5.6-19.4c-2.7-6.2-6.3-12.8-10.4-19.8L480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-238.8c-4.1 7-7.7 13.6-10.4 19.8c-4.2 9.4-5.6 15.7-5.6 19.4L144 424c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24L0 248.4c0-22.9 5.8-45.5 16.8-65.5L83.2 62.2z"]
};
const faChartPieSimple = {
  prefix: 'far',
  iconName: 'chart-pie-simple',
  icon: [512, 512, ["chart-pie-alt"], "f64e", "M495.4 240c9 0 16.6-7 16.6-16C512 100.3 411.7 0 288 0c-9 0-16 7.6-16 16.6L272 240l223.4 0zM176 288c0 26.5 21.5 48 48 48l197.1 0C394.7 410.6 323.6 464 240 464C134 464 48 378 48 272c0-83.6 53.4-154.7 128-181.1L176 288zM224 66.7c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272C0 404.6 107.5 512 240 512c115.5 0 211.9-81.5 234.8-190.2c3.8-18.1-11-33.8-29.5-33.8L272 288l-48 0 0-48 0-173.3z"]
};
const faChartPieAlt = faChartPieSimple;
const faFaceLaugh = {
  prefix: 'far',
  iconName: 'face-laugh',
  icon: [512, 512, ["laugh"], "f599", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faLaugh = faFaceLaugh;
const faFolderOpen = {
  prefix: 'far',
  iconName: 'folder-open',
  icon: [576, 512, [128194, 128449, 61717], "f07c", "M384 480l48 0c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224l-400 0c-11.4 0-21.9 6-27.6 15.9L48 357.1 48 96c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L416 144c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L298.5 96c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l23.7 0L384 480z"]
};
const faAlbumCollectionCircleUser = {
  prefix: 'far',
  iconName: 'album-collection-circle-user',
  icon: [640, 512, [], "e48f", "M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c23.9 0 44.4 13 55.4 32l-1.8 0c-26.2 0-51.1 5.7-73.4 16l-353 0c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l249.4 0c12.3 18.8 28 35.1 46.3 48L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM256 232c38.9 0 74.2 11.1 100.1 29.2C333.4 290.8 320 327.8 320 368c0 20.1 3.4 39.4 9.6 57.4C308 434.7 282.9 440 256 440c-79.5 0-144-46.6-144-104s64.5-104 144-104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24zm96 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm221.7 80.7c-6.2-19-24-32.7-45.1-32.7l-65.2 0c-21 0-38.9 13.7-45.1 32.7C438.5 468.1 465.8 480 496 480s57.5-11.9 77.7-31.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faCandy = {
  prefix: 'far',
  iconName: 'candy',
  icon: [640, 512, [127852], "e3e7", "M309 399.6L198.5 178.7C184.3 201 176 227.5 176 256c0 75.8 58.6 137.9 133 143.6zM233.3 141L360 394.4c17.1-4.9 32.8-12.9 46.7-23.4L280 117.6c-17.1 4.9-32.8 12.9-46.7 23.4zM331 112.4L441.5 333.3C455.7 311 464 284.5 464 256c0-75.8-58.6-137.9-133-143.6zM320 64c88 0 162.1 59.1 184.8 139.8l91.9-49c10.5-5.6 23.5-2.7 30.6 6.9s6.1 22.9-2.3 31.3l-29.6 29.6 29.1 10.9C633.8 237 640 246 640 256s-6.2 19-15.6 22.5l-29.1 10.9L625 319c8.4 8.4 9.4 21.7 2.3 31.3s-20.1 12.5-30.6 6.9l-91.9-49C482.1 388.9 408 448 320 448s-162.1-59.1-184.8-139.8l-91.9 49c-10.5 5.6-23.5 2.7-30.6-6.9S6.6 327.4 15 319l29.6-29.6L15.6 278.5C6.2 275 0 266 0 256s6.2-19 15.6-22.5l29.1-10.9L15 193c-8.4-8.4-9.4-21.7-2.3-31.3s20.1-12.5 30.6-6.9l91.9 49C157.9 123.1 232 64 320 64z"]
};
const faBowlHot = {
  prefix: 'far',
  iconName: 'bowl-hot',
  icon: [512, 512, ["soup"], "f823", "M152 0c13.3 0 24 10.7 24 24l0 8c0 17.6 8.3 34.2 22.4 44.8C224.6 96.4 240 127.3 240 160l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-17.6-8.3-34.2-22.4-44.8C143.4 95.6 128 64.7 128 32l0-8c0-13.3 10.7-24 24-24zm-.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272zM304 24l0 8c0 17.6 8.3 34.2 22.4 44.8C352.6 96.4 368 127.3 368 160l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-17.6-8.3-34.2-22.4-44.8C271.4 95.6 256 64.7 256 32l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSoup = faBowlHot;
const faFlatbread = {
  prefix: 'far',
  iconName: 'flatbread',
  icon: [512, 512, [129747], "e40b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm361-71L185 361c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM241 111c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0zM401 305l-96 96c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faHeartCirclePlus = {
  prefix: 'far',
  iconName: 'heart-circle-plus',
  icon: [576, 512, [], "e500", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faCodeFork = {
  prefix: 'far',
  iconName: 'code-fork',
  icon: [448, 512, [], "e13b", "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 35.7c0 22.1 17.9 40 40 40l160 0c22.1 0 40-17.9 40-40l0-35.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 35.7c0 48.6-39.4 88-88 88l-56 0 0 75.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-75.7-56 0c-48.6 0-88-39.4-88-88l0-35.7C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCity = {
  prefix: 'far',
  iconName: 'city',
  icon: [640, 512, [127961], "f64f", "M104 0C90.7 0 80 10.7 80 24l0 40-8 0C32.2 64 0 96.2 0 136L0 440c0 39.8 32.2 72 72 72l168 0c-10-13.4-16-30-16-48L72 464c-13.3 0-24-10.7-24-24l0-304c0-13.3 10.7-24 24-24l8 0 48 0 48 0 48 0 0-48 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24zM464 160c0 26.5 21.5 48 48 48l64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-128 0-128 0c-8.8 0-16-7.2-16-16l0-224 0-160c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 96zm48-48l0-48c0-35.3-28.7-64-64-64L320 0c-35.3 0-64 28.7-64 64l0 160 0 224c0 35.3 28.7 64 64 64l128 0 128 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-16 0-48 0 0-48zM352 336c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM368 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 240c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM496 416l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16zM480 304c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM112 320l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16zM96 400c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zm16-176l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16z"]
};
const faSignalBarsWeak = {
  prefix: 'far',
  iconName: 'signal-bars-weak',
  icon: [640, 512, ["signal-alt-1"], "f691", "M96 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM80 384a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]
};
const faSignalAlt1 = faSignalBarsWeak;
const faMicrophoneLines = {
  prefix: 'far',
  iconName: 'microphone-lines',
  icon: [384, 512, [127897, "microphone-alt"], "f3c9", "M240 128l0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0 0 32-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l32 0zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"]
};
const faMicrophoneAlt = faMicrophoneLines;
const faClockTwelve = {
  prefix: 'far',
  iconName: 'clock-twelve',
  icon: [512, 512, [], "e358", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faPepperHot = {
  prefix: 'far',
  iconName: 'pepper-hot',
  icon: [512, 512, [127798], "f816", "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3L360 256c-13.3 0-24-10.7-24-24l0-80c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm-256 302.7L261.7 160l42.3 0 0 22.8-90.7 148c-24.9 40.7-65.3 69.5-111.9 79.8L66 418.5c-10.5 2.3-18 11.7-18 22.5c0 12.7 10.3 23 23 23l32.1 0c133.7 0 254.1-68.7 323.6-176l1.4 0 23.9 47.8C372.3 443.9 244.3 512 103.2 512L71 512c-39.2 0-71-31.8-71-71c0-33.3 23.1-62.1 55.6-69.3L91 363.8c33.9-7.5 63.2-28.5 81.4-58.1z"]
};
const faCitrusSlice = {
  prefix: 'far',
  iconName: 'citrus-slice',
  icon: [512, 512, [], "e2f5", "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L7 391zm384.3 .3c-91.1 91.1-235.2 96.2-332.6 15.8l22.4-22.4C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6zm-40.8-276c13.3 17.8 23.2 38.3 28.7 60.6l-89.3 0 60.6-60.6zM272 208l111.8 0c.1 2.7 .2 5.3 .2 8c0 40.6-14.4 77.9-38.4 106.9l-82.4-82.4c5.9-10 8.9-21.3 8.9-32.5zm-31.5 55.1l82.4 82.4C293.9 369.6 256.6 384 216 384c-2.7 0-5.3-.1-8-.2L208 272c11.3 0 22.5-3 32.5-8.9zM115.4 350.6L176 289.9l0 89.3c-22.3-5.4-42.8-15.3-60.6-28.7z"]
};
const faSheep = {
  prefix: 'far',
  iconName: 'sheep',
  icon: [640, 512, [128017], "f711", "M384 135.8l0 72.2c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-72.2 14.5 6.2c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5L561.6 77.4C544.7 50.2 514.5 32 480 32s-64.7 18.2-81.6 45.4L350.5 97.9c-12.2 5.2-17.8 19.3-12.6 31.5s19.3 17.8 31.5 12.6l14.5-6.2zm80-7.8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-203.1-1l-.4-.9c-6.9-16.1-5.7-33.5 1.8-47.9c-7.4-11.8-18.5-21-31.7-26C271.6 65.5 264 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256s13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0l17.6 93.9c2.8 15.1 16.1 26.1 31.5 26.1l29.4 0c17.7 0 32-14.3 32-32l0-53.7c11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7l0 53.7c0 17.7 14.3 32 32 32l29.4 0c15.4 0 28.6-11 31.4-26.1L414.5 392c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L464 320c-11.8 0-23.2-1.8-33.8-5.2c.2 3.1 .6 6.2 1.4 9.3c.3 1.2 .5 2.5 .5 3.9c0 8.8-7.2 16-16 16c-.9 0-1.7-.1-2.5-.2c-24.6-3.8-48 11.9-53.9 36c-1.7 7-8.1 12.1-15.5 12.1c-3.8 0-7.2-1.3-9.9-3.4c-20.1-16-49.1-13.3-66 6c-3 3.4-7.3 5.5-12.1 5.5s-9.1-2.1-12.1-5.5c-16.9-19.3-45.9-21.9-66-6c-2.7 2.2-6.1 3.4-9.9 3.4c-7.5 0-13.8-5.1-15.5-12.1c-5.9-24.2-29.3-39.8-53.9-36c-.8 .1-1.6 .2-2.5 .2c-8.8 0-16-7.2-16-16c0-1.4 .2-2.7 .5-3.9c5.3-21.3-4.6-43.6-24-53.9C51.3 267.4 48 262 48 256s3.3-11.4 8.5-14.2c19.4-10.4 29.3-32.6 24-53.9c-.3-1.2-.5-2.5-.5-3.9c0-8.8 7.2-16 16-16c.9 0 1.7 .1 2.5 .2c24.6 3.8 48-11.9 53.9-36c1.7-7 8.1-12.1 15.5-12.1c3.8 0 7.2 1.3 9.9 3.5c20.1 16 49.1 13.3 66-6c3-3.4 7.3-5.5 12.1-5.5c5.8 0 10.9 3 13.7 7.8c8 13.3 22 21.9 37.4 23.1c.6 0 1.2 .1 1.7 .1z"]
};
const faUnlock = {
  prefix: 'far',
  iconName: 'unlock',
  icon: [448, 512, [128275], "f09c", "M144 128c0-44.2 35.8-80 80-80c35.6 0 65.8 23.2 76.1 55.4c4.1 12.6 17.6 19.5 30.2 15.5s19.5-17.6 15.5-30.2C329.2 37.2 281 0 224 0C153.3 0 96 57.3 96 128l0 64-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-240 0 0-64zM48 256c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192z"]
};
const faColonSign = {
  prefix: 'far',
  iconName: 'colon-sign',
  icon: [384, 512, [], "e140", "M255.3 29.6c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7l-13.5 56C103.6 88.3 32 163.2 32 256c0 63 33 117.8 82.9 150.8L96.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L159 428.7c9.3 3.2 18.9 5.8 28.8 7.7l-11.1 46c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7l13-53.9c39.3-2 75.7-15.1 105.5-36.1c10.8-7.7 13.4-22.6 5.7-33.5s-22.6-13.4-33.5-5.7c-18.8 13.3-41.3 22.5-65.9 26l59.6-247c2.1 1.3 4.2 2.7 6.3 4.2c10.8 7.7 25.8 5.1 33.5-5.7s5.1-25.8-5.7-33.5c-7.1-5-14.5-9.5-22.3-13.6l15.7-65.2c3.1-12.9-4.8-25.9-17.7-29s-25.9 4.8-29 17.7L274.3 77.8c-9.6-2.3-19.4-4-29.4-4.9l10.4-43.2zm-72.7 96.4l-55.5 230C98 331 80 295.1 80 256c0-60.1 42.5-112.6 102.7-129.9zM170.3 381.8l63.2-261.6c10.2 .5 20.1 1.9 29.6 4.2L199 389.7c-10-1.7-19.6-4.4-28.7-7.9z"]
};
const faHeadset = {
  prefix: 'far',
  iconName: 'headset',
  icon: [512, 512, [], "f590", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208l0 144.1c0 22.1-17.9 40-40 40L313.6 440c-8.3-14.4-23.8-24-41.6-24l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l32 0c17.8 0 33.3-9.7 41.6-24l110.4 .1c48.6 0 88.1-39.4 88.1-88L512 256C512 114.6 397.4 0 256 0S0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm112-32l0 112c-17.7 0-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zM80 256l0 48c0 44.2 35.8 80 80 80l16 0c17.7 0 32-14.3 32-32l0-144c0-17.7-14.3-32-32-32l-16 0c-44.2 0-80 35.8-80 80zm272-32c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32l0-112zm80 32c0-44.2-35.8-80-80-80l-16 0c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0c44.2 0 80-35.8 80-80l0-48z"]
};
const faBadgerHoney = {
  prefix: 'far',
  iconName: 'badger-honey',
  icon: [640, 512, [129441], "f6b4", "M465 112c16.9 0 33.6 3.7 49 10.9L559.2 144l-72.3 0c-49.3 0-97.7 13.4-139.9 38.8l-69.4 41.7c-17 10.2-36.4 15.6-56.2 15.6c-55.4 0-101.1-41.2-108.3-94.6c4.9-.9 9.9-1.4 15-1.4l204.2 0c27.3 0 54.1-6.3 78.5-18.5l2.5-1.2c16.1-8 33.8-12.2 51.8-12.2zm126.8 64c-.6 4.7-2.8 9-6.1 12.4L583 191l16.4 16.4L583 191c-5.5 5.5-13.8 9.2-23.9 10.1c-67.9 6.4-128.1 37.5-169.4 67.9c-7.8 5.7-11.4 15.6-9.1 25c0 .2 .1 .4 .1 .6c0 0 0 0 0 0l21.3 128c.8 4.9-2.9 9.3-7.9 9.3l-31.1 0c-3.9 0-7.2-2.8-7.9-6.7L338.3 324.1c-1.9-11.6-11.9-20.1-23.7-20.1l-110.1 0c-9.6 0-18.3 5.7-22.1 14.5l-16 37.3c-5.2 12.1-5.9 25.6-2.2 38.2l8.3 27.7c1.5 5.1-2.3 10.3-7.7 10.3l-29.2 0c-3.5 0-6.6-2.3-7.7-5.7L115 382.6c-1.3-4.4-1.3-9.1-.1-13.5l10.7-37.6c1.8-6.2 1-13-2.3-18.6s-8.6-9.7-14.9-11.3C73.7 292.9 48 261.4 48 224c0-27.3 13.7-51.5 34.7-65.9C95.4 223 152.6 272 221.3 272c25.6 0 50.7-7 72.7-20.1l69.4-41.7c33.2-19.9 70.6-31.5 109.1-33.8c2 8.9 10 15.6 19.5 15.6c9.7 0 17.7-6.9 19.6-16l80.2 0zM48 323.9c7.8 6.2 16.3 11.6 25.4 15.9l-4.6 16.1c-3.8 13.2-3.7 27.3 .3 40.5l13.1 43.7c7.1 23.7 28.9 39.9 53.6 39.9l29.2 0c37.5 0 64.4-36.2 53.6-72.1l-8.3-27.7c-.5-1.8-.4-3.7 .3-5.4l9.8-22.8 73.9 0 13.5 81.2c4.5 27 27.9 46.8 55.2 46.8l31.1 0c34.6 0 60.9-31.1 55.2-65.2L430.2 299.3c28.6-19.1 64.3-36.8 103.4-45.6l19.6 31.4c3.1 5 10.4 5 13.6 0l27.8-44.5c8.1-3.8 15.7-9 22.4-15.7l2.6-2.6c13.1-13.1 20.4-30.8 20.4-49.3c0-27.1-15.7-51.7-40.2-63.1L534.2 79.4C512.6 69.2 488.9 64 465 64c-25.4 0-50.5 5.9-73.2 17.3l-2.5 1.2C371.6 91.4 352 96 332.2 96L128 96C57.3 96 0 153.3 0 224L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-4.1z"]
};
const faH4 = {
  prefix: 'far',
  iconName: 'h4',
  icon: [640, 512, [], "f86a", "M455.5 92.9L421.5 256 592 256l0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-200 0c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24l0 136 224 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152L48 272l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 248 0 88C0 74.7 10.7 64 24 64z"]
};
const faStoreSlash = {
  prefix: 'far',
  iconName: 'store-slash',
  icon: [640, 512, [], "e071", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68 0-17.1 0-48 0-83.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6l0 81.6-35 0L301.2 210.7c1.9-1.2 3.7-2.4 5.5-3.7c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0L141.6 0c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm94.1 73.7L152.4 48l335.2 0 51.5 81.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-6.9 7.6-16.5 12.5-27.5 13.1L132.9 78.9zm-84 55.7c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5zM365.5 384l-60.9-48L144 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L96 336l0 48 0 64c0 35.3 28.7 64 64 64l320 0c12.9 0 24.8-3.8 34.9-10.3L467.1 464 160 464c-8.8 0-16-7.2-16-16l0-64 221.5 0z"]
};
const faRoadCircleXmark = {
  prefix: 'far',
  iconName: 'road-circle-xmark',
  icon: [640, 512, [], "e566", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"]
};
const faSignalSlash = {
  prefix: 'far',
  iconName: 'signal-slash',
  icon: [640, 512, [], "f695", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L600 445l0-421c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 383.3-80-62.7L472 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 187-80-62.7 0-28.3c0-13.3-10.7-24-24-24c-10.4 0-19.2 6.6-22.6 15.8L38.8 5.1zM576 512l-.2 0 .5 0-.2 0zM472 488l0-20.1-48-37.8 0 57.9c0 13.3 10.7 24 24 24s24-10.7 24-24zM344 367l-48-37.8L296 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-121zM192 288c-13.3 0-24 10.7-24 24l0 176c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24zM64 384c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z"]
};
const faUserMinus = {
  prefix: 'far',
  iconName: 'user-minus',
  icon: [640, 512, [], "f503", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM472 200c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faMarsStrokeUp = {
  prefix: 'far',
  iconName: 'mars-stroke-up',
  icon: [320, 512, [9896, "mars-stroke-v"], "f22a", "M175.6 5.8c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.4-14 0 51.8-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 17.8C59 205.4 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59-146.6-136-158.2l0-17.8 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-51.8 16.4 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48zM160 240a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
};
const faMarsStrokeV = faMarsStrokeUp;
const faChampagneGlasses = {
  prefix: 'far',
  iconName: 'champagne-glasses',
  icon: [640, 512, [129346, "glass-cheers"], "f79f", "M159.2 12.6c5.7-10.5 18.1-15.2 29.3-11.1L320 49.3 451.5 1.5c11.2-4.1 23.7 .7 29.3 11.1l81.6 151c32.4 60.1 10.6 133.3-45.6 167L552.6 429l55.2-20.1c12.5-4.5 26.2 1.9 30.8 14.3s-1.9 26.2-14.3 30.8l-77.8 28.3-77.8 28.3c-12.5 4.5-26.2-1.9-30.8-14.3s1.9-26.2 14.3-30.8l55.2-20.1-35.8-98.5c-61.2 9.4-121.7-29.6-136.3-92.5L320 188.6l-15.3 65.8c-14.6 62.9-75.1 101.9-136.3 92.5l-35.8 98.5 55.2 20.1c12.5 4.5 18.9 18.3 14.3 30.8s-18.3 18.9-30.8 14.3L93.6 482.3 15.8 454C3.3 449.4-3.1 435.7 1.5 423.2s18.3-18.9 30.8-14.3L87.4 429l35.8-98.4c-56.2-33.7-78.1-106.9-45.6-167l81.6-151zm32.4 41L156.8 118 277 161.7l16.5-71L191.6 53.6zM119.8 186.4c-22.4 41.5-2.8 93.3 41.6 109.4c41.3 15 86.5-9.4 96.5-52.3l8.1-34.7L133.7 160.7l-13.9 25.7zM448.4 53.6L346.5 90.7l16.5 71L483.2 118 448.4 53.6zm71.7 132.7l-13.9-25.7L374 208.8l8.1 34.7c10 42.9 55.2 67.3 96.5 52.3c44.3-16.1 64-67.9 41.6-109.4z"]
};
const faGlassCheers = faChampagneGlasses;
const faTaco = {
  prefix: 'far',
  iconName: 'taco',
  icon: [512, 512, [127790], "f826", "M274.8 38.4c-11-8.6-26.5-8.6-37.5 0L193.1 72.6c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1L71.7 152.9c-2 6.8-6.3 12.8-12.2 16.8L13.4 201C1.9 208.9-2.9 223.6 1.8 236.7l17.1 47.7C70.9 209.2 157.7 160 256 160s185.1 49.2 237.1 124.4l17.1-47.7c4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8L424.7 99.3c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1 .2-14.1-2-19.7-6.4L274.8 38.4zM256 240c109.5 0 199.2 84.6 207.4 192L48.6 432C56.8 324.6 146.5 240 256 240zM32 480l448 0c17.7 0 32-14.3 32-32c0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zM168 368a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHexagonPlus = {
  prefix: 'far',
  iconName: 'hexagon-plus',
  icon: [512, 512, ["plus-hexagon"], "f300", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faPlusHexagon = faHexagonPlus;
const faClipboard = {
  prefix: 'far',
  iconName: 'clipboard',
  icon: [384, 512, [128203], "f328", "M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHouseCircleExclamation = {
  prefix: 'far',
  iconName: 'house-circle-exclamation',
  icon: [640, 512, [], "e50a", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faFileArrowUp = {
  prefix: 'far',
  iconName: 'file-arrow-up',
  icon: [384, 512, ["file-upload"], "f574", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 408l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L168 408c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faFileUpload = faFileArrowUp;
const faWifi = {
  prefix: 'far',
  iconName: 'wifi',
  icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
const faWifi3 = faWifi;
const faWifiStrong = faWifi;
const faMessages = {
  prefix: 'far',
  iconName: 'messages',
  icon: [640, 512, ["comments-alt"], "f4b6", "M48 72c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24l-128 0c-4.7 0-9.4 1.4-13.3 4L144 315.2l0-19.2c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24-10.7-24-24L48 72zM72 0C32.2 0 0 32.2 0 72L0 248c0 39.8 32.2 72 72 72l24 0 0 40c0 8.9 4.9 17 12.7 21.2s17.3 3.7 24.6-1.2l90-60L344 320c39.8 0 72-32.2 72-72l0-176c0-39.8-32.2-72-72-72L72 0zM256 376c0 39.8 32.2 72 72 72l88.7 0 90 60c7.4 4.9 16.8 5.4 24.6 1.2S544 496.9 544 488l0-40 24 0c39.8 0 72-32.2 72-72l0-176c0-39.8-32.2-72-72-72l-120 0 0 48 120 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24 10.7-24 24l0 19.2L437.3 404c-3.9-2.6-8.6-4-13.3-4l-96 0c-13.3 0-24-10.7-24-24l0-24-48 0 0 24z"]
};
const faCommentsAlt = faMessages;
const faBath = {
  prefix: 'far',
  iconName: 'bath',
  icon: [512, 512, [128705, "bathtub"], "f2cd", "M101.3 48C89.5 48 80 57.5 80 69.3L80 256l352 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 304l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1c23.9 0 45.4 10.5 60.1 27.2c9.2-5.3 21.1-4 28.9 3.9c9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0c-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336l48 0 0 32c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-32 48 0 0 32c0 28.4-12.4 54-32 71.6l0 48.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.3c-5.2 .9-10.5 1.3-16 1.3l-256 0c-5.5 0-10.8-.5-16-1.3l0 25.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48.4C44.4 422 32 396.4 32 368l0-32zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z"]
};
const faBathtub = faBath;
const faUmbrellaSimple = {
  prefix: 'far',
  iconName: 'umbrella-simple',
  icon: [512, 512, ["umbrella-alt"], "e2bc", "M256 0c13.3 0 24 10.7 24 24l0 9.1c119.6 11.1 215.3 104.5 230 223c2.2 17.5-12.4 31.9-30 31.9L32 288C14.3 288-.2 273.6 2 256.1C16.7 137.6 112.4 44.2 232 33.1l0-9.1c0-13.3 10.7-24 24-24zM458.4 240C436.8 148.3 354.3 80 256 80S75.2 148.3 53.6 240l404.9 0zM280 438.6c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4L232 320l48 0 0 118.6z"]
};
const faUmbrellaAlt = faUmbrellaSimple;
const faRectangleHistoryCirclePlus = {
  prefix: 'far',
  iconName: 'rectangle-history-circle-plus',
  icon: [640, 512, [], "e4a3", "M64 464l284.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l384 0c23.8 0 44.5 12.9 55.5 32.2c-2.5-.1-5-.2-7.5-.2c-26.2 0-51.1 5.7-73.4 16L64 208c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM440 80c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0zM392 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L120 48c-13.3 0-24-10.7-24-24s10.7-24 24-24L392 0zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faUnderline = {
  prefix: 'far',
  iconName: 'underline',
  icon: [448, 512, [], "f0cd", "M16 56c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 144c0 61.9 50.1 112 112 112s112-50.1 112-112l0-144-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 144c0 88.4-71.6 160-160 160s-160-71.6-160-160L64 80 40 80C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24z"]
};
const faPrescriptionBottlePill = {
  prefix: 'far',
  iconName: 'prescription-bottle-pill',
  icon: [576, 512, [], "e5c0", "M48 48l288 0 0 32L48 80l0-32zM40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l304 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 0zM32 160l0 288c0 35.3 28.7 64 64 64l192 0c11.6 0 22.4-3.1 31.8-8.4c-13.7-11.3-25.6-24.7-35.3-39.6L96 464c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-16-48 0zm320 0l-48 0 0 87.2c13.8-14.6 30-26.8 48-36l0-51.2zm80 112a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM383 319c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faUserPen = {
  prefix: 'far',
  iconName: 'user-pen',
  icon: [640, 512, ["user-edit"], "f4ff", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l277.2 0-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c48.1 0 91.8 19.1 123.9 50.1L359.6 388c-23.4-22.3-55.1-36-89.9-36l-91.4 0c-65.7 0-120.1 48.7-129 112zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faUserEdit = faUserPen;
const faBinarySlash = {
  prefix: 'far',
  iconName: 'binary-slash',
  icon: [640, 512, [], "e33e", "M456 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C379 67 365.4 60.2 361.2 47.6S363.8 21.4 376.4 17.2l48-16C431.7-1.2 439.8 0 446 4.5S456 16.3 456 24zM232 312l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM128 72c0-39.8 32.2-72 72-72l48 0c39.8 0 72 32.2 72 72l0 80c0 21.6-9.5 41-24.6 54.2L399.7 288l40.3 0c39.8 0 72 32.2 72 72l0 16 118.8 93.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L128 75l0-3zm48 40.6l79.4 62.2C265 171.7 272 162.7 272 152l0-80c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l0 40.6zM320 360c0-3.8 .3-7.5 .9-11.2L368 385.9l0 54.1c0 13.3 10.7 24 24 24l48 0c6.9 0 13.1-2.9 17.5-7.6l37.8 29.7C482 502 462.2 512 440 512l-48 0c-39.8 0-72-32.2-72-72l0-80z"]
};
const faSquareO = {
  prefix: 'far',
  iconName: 'square-o',
  icon: [448, 512, [], "e278", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"]
};
const faCaduceus = {
  prefix: 'far',
  iconName: 'caduceus',
  icon: [512, 512, [], "e681", "M280 89.6c14.3-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.8 9.7 33.3 24 41.6l0 12.6L183.4 73.9c-11.1-6.5-23.7-9.9-36.5-9.9c-18.2 0-35.7 6.9-49.1 19.2L11.3 163.1C4.1 169.7 0 179.1 0 188.9C0 208.3 15.7 224 35.1 224l111 0c30 0 59.5-7.3 85.9-21.3l0 127.7-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 0 40.8 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-40.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4l0-127.7c26.4 13.9 55.9 21.3 85.9 21.3l111 0c19.4 0 35.1-15.7 35.1-35.1c0-9.8-4.1-19.2-11.3-25.8L414.2 83.2C400.8 70.9 383.3 64 365.1 64c-12.8 0-25.4 3.4-36.5 9.9L280 102.2l0-12.6zM130.4 118.5c4.5-4.2 10.4-6.5 16.5-6.5c4.3 0 8.6 1.1 12.3 3.3l63.6 37.1-4.6 2.9c-21.6 13.5-46.6 20.7-72.1 20.7l-78.1 0 62.3-57.5zM365.1 112c6.1 0 12 2.3 16.5 6.5L443.9 176l-78.1 0c-25.5 0-50.5-7.2-72.1-20.7l-4.6-2.9 63.6-37.1c3.7-2.2 8-3.3 12.3-3.3z"]
};
const faSignature = {
  prefix: 'far',
  iconName: 'signature',
  icon: [640, 512, [], "f5b7", "M176 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm-3.8 169l80.9-25c-11.7 43.2-29.4 84.5-52.4 123l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42zm216.8 48L616 416c13.3 0 24-10.7 24-24s-10.7-24-24-24l-311.9 0c-7 16.3-14.8 32.4-23.3 48z"]
};
const faStroopwafel = {
  prefix: 'far',
  iconName: 'stroopwafel',
  icon: [512, 512, [], "f551", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm97.6-45.3l22.6 22.6 45.3-45.3-22.6-22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3L210.7 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256 437 278.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3L97.6 301.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm90.5 0L142.9 256l45.3 45.3L233.4 256l-45.3-45.3zM256 233.4l45.3-45.3L256 142.9l-45.3 45.3L256 233.4zM278.6 256l45.3 45.3L369.1 256l-45.3-45.3L278.6 256zM256 278.6l-45.3 45.3L256 369.1l45.3-45.3L256 278.6z"]
};
const faBold = {
  prefix: 'far',
  iconName: 'bold',
  icon: [384, 512, [], "f032", "M0 56C0 42.7 10.7 32 24 32l48 0 16 0 124 0c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124L88 480l-16 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-176L48 80 24 80C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76L96 80l0 152 116 0zM96 280l0 152 148 0c42 0 76-34 76-76s-34-76-76-76l-32 0L96 280z"]
};
const faAnchorLock = {
  prefix: 'far',
  iconName: 'anchor-lock',
  icon: [640, 512, [], "e4ad", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c18.3 0 36.1-2.7 52.8-7.7c-3.1-7.5-4.8-15.7-4.8-24.3l0-24.7c-14.9 5.6-31.1 8.7-48 8.7l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faBuildingNgo = {
  prefix: 'far',
  iconName: 'building-ngo',
  icon: [384, 512, [], "e4d7", "M320 48L64 48 2 48C9.1 20.4 34.2 0 64 0L320 0c29.8 0 54.9 20.4 62 48l-62 0zm16 192l48 0 0 208c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 240l48 0 0 208c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-208zM168 80l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-88c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM61.3 87.1l34.7 52L96 96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8 64 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM88 264c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
};
const faTransporter3 = {
  prefix: 'far',
  iconName: 'transporter-3',
  icon: [512, 512, [], "e045", "M480 32L472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32zM64 128l-7.3-25.4C55.6 98.7 52.1 96 48 96s-7.6 2.7-8.7 6.6L32 128 6.6 135.3C2.7 136.4 0 139.9 0 144s2.7 7.6 6.6 8.7L32 160l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 160l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 128zm56 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"]
};
const faEngineWarning = {
  prefix: 'far',
  iconName: 'engine-warning',
  icon: [640, 512, ["engine-exclamation"], "f5f2", "M424 88c0 13.3-10.7 24-24 24l-72 0 0 32 68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-35.3 0-64-28.7-64-64l0-40-32 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 32 0 0-24c0-35.3 28.7-64 64-64l16 0 32 0 88 0 0-32-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c13.3 0 24 10.7 24 24zM210.3 354l32 40c3 3.8 7.6 6 12.5 6L448 400c8.8 0 16-7.2 16-16l0-141.7c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7L192 192l-32 0-16 0c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l28.8 0c14.6 0 28.4 6.6 37.5 18zM544 224c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192zM304 212c11 0 20 9 20 20l0 56c0 11-9 20-20 20s-20-9-20-20l0-56c0-11 9-20 20-20zM280 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faEngineExclamation = faEngineWarning;
const faCircleDownRight = {
  prefix: 'far',
  iconName: 'circle-down-right',
  icon: [512, 512, [], "e108", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zm96 198.6c0-12.5-10.1-22.6-22.6-22.6c-6 0-11.8 2.4-16 6.6L280 216l-66.3-66.3C210 146 205.1 144 200 144s-10 2-13.7 5.7l-36.7 36.7C146 190 144 194.9 144 200s2 10 5.7 13.7L216 280l-33.4 33.4c-4.2 4.2-6.6 10-6.6 16c0 12.5 10.1 22.6 22.6 22.6L336 352c8.8 0 16-7.2 16-16l0-137.4z"]
};
const faSquareK = {
  prefix: 'far',
  iconName: 'square-k',
  icon: [448, 512, [], "e274", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm313.1 72.8l-73 74.3 75.3 102.7c7.8 10.7 5.5 25.7-5.2 33.5s-25.7 5.5-33.5-5.2L206 277.8l-30 30.5 0 51.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-61.5L128 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 87.8L278.9 135.2c9.3-9.5 24.5-9.6 33.9-.3s9.6 24.5 .3 33.9z"]
};
const faManatSign = {
  prefix: 'far',
  iconName: 'manat-sign',
  icon: [384, 512, [], "e1d5", "M192 32c-13.3 0-24 10.7-24 24l0 41.5C73.3 109.3 0 190.1 0 288L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-71.4 51.9-130.6 120-142l0 310c0 13.3 10.7 24 24 24s24-10.7 24-24l0-310c68.1 11.4 120 70.7 120 142l0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-97.9-73.3-178.7-168-190.5L216 56c0-13.3-10.7-24-24-24z"]
};
const faMoneyCheckPen = {
  prefix: 'far',
  iconName: 'money-check-pen',
  icon: [640, 512, ["money-check-edit"], "f872", "M64 112l448 0c8.8 0 16 7.2 16 16l0 91.6 6.6-6.6c11.6-11.6 26.3-18.5 41.4-20.5l0-64.6c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l266.5 0 6-23.9c2.2-8.8 6.2-17 11.8-24.1L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16zm56 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zM96 200c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm517.8 35.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
};
const faMoneyCheckEdit = faMoneyCheckPen;
const faNotEqual = {
  prefix: 'far',
  iconName: 'not-equal',
  icon: [448, 512, [], "f53e", "M373.5 36.2c11 7.5 13.8 22.4 6.3 33.3L329.2 144l78.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-111.5 0-87 128L408 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-231.1 0-69 101.5c-7.5 11-22.4 13.8-33.3 6.3s-13.8-22.4-6.4-33.3L118.8 368 40 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l111.5 0 87-128L40 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l231.1 0 69-101.5c7.5-11 22.4-13.8 33.3-6.4z"]
};
const faBorderTopLeft = {
  prefix: 'far',
  iconName: 'border-top-left',
  icon: [448, 512, ["border-style"], "f853", "M0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-352c0-13.3 10.7-24 24-24l352 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32C32.2 32 0 64.2 0 104L0 456zm128-40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-96 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBorderStyle = faBorderTopLeft;
const faMapLocationDot = {
  prefix: 'far',
  iconName: 'map-location-dot',
  icon: [576, 512, ["map-marked-alt"], "f5a0", "M408 120c0 8.6-1.8 18.3-5 28.6c-5.7 18.4-15.6 38.8-27.4 59.2l-.1 .2c-3.1 5.4-6.3 10.7-9.6 16c-4.4 7-8.9 14-13.5 20.8l-.4 .6c-18.1 26.9-36.7 51.1-49.2 66.6c-7.7 9.6-22 9.6-29.6 0c-12.4-15.5-31.1-39.7-49.2-66.6c-18.4-27.3-36.3-57.5-46.7-84.4c-.8-2.1-1.6-4.2-2.3-6.3c-4.4-12.6-7-24.4-7-34.6c0-4.7 .3-9.3 .8-13.8C175.6 46.4 226.4 0 288 0c66.3 0 120 53.7 120 120zM352 300.6c13.5-18.2 28.8-39.9 42.7-62.4c1.8-2.9 3.6-5.8 5.3-8.8l0 224.3 128-46.5 0-252.9L419.3 193.8c2.2-4.7 4.4-9.3 6.3-14c5.9-14 11-29.2 13.2-44.2l105-38.2c7.4-2.7 15.6-1.6 22 2.9s10.2 11.8 10.2 19.7l0 304c0 10.1-6.3 19.1-15.8 22.6l-176 64c-5.3 1.9-11.1 1.9-16.4 0L200 449.5l-167.8 61c-7.4 2.7-15.6 1.6-22-2.9S0 495.8 0 488L0 184c0-10.1 6.3-19.1 15.8-22.6L136 117.7c0 .8 0 1.5 0 2.3c0 15.1 3.7 30.7 8.9 45.6L48 200.8l0 252.9 128-46.5 0-177.7c1.8 3 3.5 5.9 5.3 8.8c13.9 22.5 29.1 44.2 42.7 62.4l0 106.6 128 46.5 0-153.1zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
const faMapMarkedAlt = faMapLocationDot;
const faTilde = {
  prefix: 'far',
  iconName: 'tilde',
  icon: [448, 512, [63135], "7e", "M100.5 176c-29 0-52.5 23.5-52.5 52.5L48 320c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-91.5C0 173 45 128 100.5 128c29.6 0 57.6 13 76.7 35.6L307.4 317.4c10 11.8 24.6 18.6 40.1 18.6c29 0 52.5-23.5 52.5-52.5l0-91.5c0-13.3 10.7-24 24-24s24 10.7 24 24l0 91.5C448 339 403 384 347.5 384c-29.6 0-57.6-13-76.7-35.6L140.6 194.6c-10-11.8-24.6-18.6-40.1-18.6z"]
};
const faJedi = {
  prefix: 'far',
  iconName: 'jedi',
  icon: [576, 512, [], "f669", "M224.8 267.9L246 299.7c1.3 1.9 .2 4.5-2 4.9l-37.6 7.5c-3.7 .7-6.4 4-6.4 7.8s2.7 7.1 6.4 7.8l37.6 7.5c2.2 .4 3.3 3 2 4.9l-21.2 31.9c-2.1 3.2-1.7 7.4 1 10.1s6.9 3.1 10.1 1l26.9-17.9c2.2-1.4 5.1 .2 5 2.8l-2.1 61.7C214.5 419.4 176 374.2 176 320c0-29.6 11.5-56.5 30.2-76.5c4.5-4.8 6.8-11.2 6.4-17.7s-3.3-12.6-8.3-16.9C177.2 185.4 160 150.7 160 112c0-26.9 8.3-51.9 22.5-72.5c6.4-9.3 5.5-21.7-2.2-30s-20-10-29.7-4.4C70.1 52.4 16 139.9 16 240c0 150.2 121.8 272 272 272s272-121.8 272-272C560 139.9 505.9 52.4 425.4 5.2c-9.7-5.7-22.1-3.9-29.7 4.4s-8.6 20.7-2.2 30C407.7 60.1 416 85.1 416 112c0 38.7-17.2 73.4-44.4 96.9c-4.9 4.3-7.9 10.4-8.3 16.9s2 12.9 6.4 17.7c18.8 20 30.2 46.9 30.2 76.5c0 54.2-38.5 99.4-89.7 109.8l-2.1-61.7c-.1-2.6 2.8-4.2 5-2.8l26.9 17.9c3.2 2.1 7.4 1.7 10.1-1s3.1-6.9 1-10.1L330 340.3c-1.3-1.9-.2-4.5 2-4.9l37.5-7.5c3.7-.7 6.4-4 6.4-7.8s-2.7-7.1-6.4-7.8L332 304.6c-2.2-.4-3.3-3-2-4.9l21.2-31.9c2.1-3.2 1.7-7.4-1-10.1s-6.9-3.1-10.1-1l-30 20c-2.1 1.4-4.9 0-5-2.6L296.3 8c-.1-4.5-3.8-8-8.3-8s-8.1 3.5-8.3 8l-8.9 266.2c-.1 2.5-2.9 3.9-5 2.6l-30-20c-3.2-2.1-7.4-1.7-10.1 1s-3.1 6.9-1 10.1zM64.1 233.5c.3-10.7 1.4-21.3 3.1-31.6l17.5 17.5c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L76.5 165.9c8.3-23.7 20.5-45.6 35.8-64.9c-.2 3.6-.3 7.3-.3 11c0 44.9 16.8 85.8 44.4 116.9C138.5 254.8 128 286.2 128 320c0 44.5 18.1 84.7 47.4 113.7c-54.9-32-94.9-86.6-107.4-151l16.6 16.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L64.1 233.5zm447.8 0l-43.2 43.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16.6-16.6c-12.4 64.4-52.5 119.1-107.4 151c29.3-29 47.4-69.2 47.4-113.7c0-33.8-10.5-65.2-28.4-91.1c27.6-31.1 44.4-72 44.4-116.9c0-3.7-.1-7.4-.3-11c15.3 19.3 27.5 41.2 35.8 64.9l-30.8 30.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17.5-17.5c1.8 10.3 2.8 20.9 3.1 31.6z"]
};
const faSquarePollVertical = {
  prefix: 'far',
  iconName: 'square-poll-vertical',
  icon: [448, 512, ["poll"], "f681", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 224c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zm72-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zM320 288c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"]
};
const faPoll = faSquarePollVertical;
const faArrowDownSquareTriangle = {
  prefix: 'far',
  iconName: 'arrow-down-square-triangle',
  icon: [576, 512, ["sort-shapes-down-alt"], "f889", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm481 78c0-4.5-1.2-9-3.6-12.9L440.2 301.7c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1zM368 80l96 0 0 96-96 0 0-96zm94.4 352l-92.8 0L416 354.6 462.4 432zM320 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z"]
};
const faSortShapesDownAlt = faArrowDownSquareTriangle;
const faMugHot = {
  prefix: 'far',
  iconName: 'mug-hot',
  icon: [512, 512, [9749], "f7b6", "M88 0c13.3 0 24 10.7 24 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C152.6 76.6 176 97.1 176 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C87.4 83.4 64 62.9 64 24C64 10.7 74.7 0 88 0zM48 416c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-176L48 240l0 176zM0 224c0-17.7 14.3-32 32-32l320 0 48 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-16 0c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 224zM384 368l16 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-16 0 0 128zM224 24c0 16.1 7.5 23.7 23.8 37.9l1.1 1C264.6 76.6 288 97.1 288 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-16.1-7.5-23.7-23.8-37.9l-1.1-1C199.4 83.4 176 62.9 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faDogLeashed = {
  prefix: 'far',
  iconName: 'dog-leashed',
  icon: [576, 512, [129454], "f6d4", "M69.6 8.6C78.2-1.6 93.3-2.9 103.4 5.6L292.6 164.5 313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32l76.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 32c0 53-43 96-96 96l-45.3 0L432 256l0 192c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-19.4 0-48.9c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2l0 48.9 0 19.4c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-224c0-1.3 .1-2.6 .2-3.8c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5c0 0 0 0 0 0l3.9 15.5C55.6 163.5 71.6 176 90 176l54 0 87.6 0L72.6 42.4C62.4 33.9 61.1 18.7 69.6 8.6zM318 342.2c11.4 9.1 18 22.9 18 37.4l0 68.4c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-173.2-96-48 0 104.8c10.8 0 21.4 3.7 30 10.6zm-78-6.4L240 224l-96 0-31.9 0-.1 .8L112 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c7 1.5 14.2 2.6 21.6 3zm94.2-139.5l55.3 27.6c6.7-18.8 24.6-31.9 45.2-31.9l45.3 0c26.5 0 48-21.5 48-48l0-32-32 0c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.7 4.4-2 8.5-3.8 12.4zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faCarBattery = {
  prefix: 'far',
  iconName: 'car-battery',
  icon: [512, 512, ["battery-car"], "f5df", "M80 96c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l16 0zM64 144c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L64 144zm304 32c8.8 0 16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16zM96 224l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faBatteryCar = faCarBattery;
const faFaceDowncastSweat = {
  prefix: 'far',
  iconName: 'face-downcast-sweat',
  icon: [512, 512, [], "e371", "M35.2 126.3C14.9 120.8 0 102.7 0 81C0 61 28.6 20.6 41.6 3.3c3.2-4.4 9.6-4.4 12.8 0c9.5 12.6 27.1 37.2 36 57.5c.3 .7 .6 1.4 .9 2.1C94.2 69.7 96 76 96 81c0 26-21.5 47-48 47c-4.4 0-8.7-.6-12.8-1.7zm81.4-85.1C156.7 15.2 204.6 0 256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-35.8 7.3-69.9 20.6-100.8c8.6 3.1 17.8 4.8 27.4 4.8c8.9 0 17.6-1.5 25.7-4.2C57.3 185.5 48 219.7 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208s-93.1-208-208-208c-48.7 0-93.4 16.7-128.9 44.7c.6-3.8 .9-7.7 .9-11.7c0-11.4-3.8-22.4-7.1-30.5c-1.3-3.1-2.7-6.2-4.3-9.3zM96 272c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm208-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM183.6 409.5c-9.7-9-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2z"]
};
const faMailboxFlagUp = {
  prefix: 'far',
  iconName: 'mailbox-flag-up',
  icon: [576, 512, [], "e5bb", "M376 224c-13.3 0-24-10.7-24-24l0-112 0-32c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-40 0 0 88c0 13.3-10.7 24-24 24zM144 112c-53 0-96 43-96 96l0 176c0 8.8 7.2 16 16 16l176 0 0-192c0-53-43-96-96-96zm107.3 0c22.8 25.5 36.7 59.1 36.7 96l0 192 224 0c8.8 0 16-7.2 16-16l0-176c0-34.9-18.7-65.5-46.6-82.3c9.1-9.9 14.6-23.2 14.6-37.7l0-9c47.4 23.6 80 72.5 80 129l0 176c0 35.3-28.7 64-64 64l-224 0-48 0L64 448c-35.3 0-64-28.7-64-64L0 208C0 128.5 64.5 64 144 64l176 0 0 24 0 24-68.7 0zM104 192l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMemoCircleInfo = {
  prefix: 'far',
  iconName: 'memo-circle-info',
  icon: [576, 512, [], "e49a", "M320 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 134.6c-17.2 4.9-33.4 12.3-48 21.8L336 64c0-8.8-7.2-16-16-16zM96 152c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm312-96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faGift = {
  prefix: 'far',
  iconName: 'gift',
  icon: [512, 512, [127873], "f06b", "M231.9 44.4C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40L48 128c-26.5 0-48 21.5-48 48l0 64c0 20.9 13.4 38.7 32 45.3l0 2.7 0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160 0-2.7c18.6-6.6 32-24.4 32-45.3l0-64c0-26.5-21.5-48-48-48l-25.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176l0 64-32 0-144 0 0-64 72 0 104 0zm-240 0l0 64L80 240l-32 0 0-64 104 0 72 0zm0 112l0 176L96 464c-8.8 0-16-7.2-16-16l0-160 144 0zm64 176l0-176 144 0 0 160c0 8.8-7.2 16-16 16l-128 0zm72-336l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0l-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8L225.3 128l-1.3 0z"]
};
const faDiceTwo = {
  prefix: 'far',
  iconName: 'dice-two',
  icon: [448, 512, [9857], "f528", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faVolume = {
  prefix: 'far',
  iconName: 'volume',
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M191.9 201.9L304 102.3l0 307.3L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160 88 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C352 45.3 338.7 32 322.2 32zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C466.1 312.9 480 286.1 480 256s-13.9-56.9-35.4-74.5z"]
};
const faVolumeMedium = faVolume;
const faTransporter5 = {
  prefix: 'far',
  iconName: 'transporter-5',
  icon: [512, 512, [], "e2a6", "M224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L224 0zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zM112 256c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0zm64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0zm-56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM64 160l-7.3-25.4c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L32 160 6.6 167.3C2.7 168.4 0 171.9 0 176s2.7 7.6 6.6 8.7L32 192l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L64 192l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L64 160zM472.7 6.6C471.6 2.7 468.1 0 464 0s-7.6 2.7-8.7 6.6L448 32l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L448 64l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L480 64l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L480 32 472.7 6.6z"]
};
const faGaugeCircleBolt = {
  prefix: 'far',
  iconName: 'gauge-circle-bolt',
  icon: [640, 512, [], "e496", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.7 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
const faCoinFront = {
  prefix: 'far',
  iconName: 'coin-front',
  icon: [512, 512, [], "e3fc", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm24-248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z"]
};
const faFileSlash = {
  prefix: 'far',
  iconName: 'file-slash',
  icon: [640, 512, [], "e3a7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-221.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM176 112.6L176 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 178.4L176 112.6zM448 464l-256 0c-8.8 0-16-7.2-16-16l0-213.3-48-37.8L128 448c0 35.3 28.7 64 64 64l256 0c20.1 0 38.1-9.3 49.8-23.8l-37.7-29.7c-2.9 3.4-7.3 5.5-12.1 5.5z"]
};
const faMessageArrowUpRight = {
  prefix: 'far',
  iconName: 'message-arrow-up-right',
  icon: [512, 512, [], "e1dd", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM216 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z"]
};
const faTreasureChest = {
  prefix: 'far',
  iconName: 'treasure-chest',
  icon: [576, 512, [], "f723", "M160 80l256 0 0 160-64 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16-64 0 0-160zM48 160c0-38.7 27.5-71 64-78.4L112 240l-64 0 0-80zm0 272l0-144 64 0 0 144-64 0zM416 288l0 144-256 0 0-144 64 0 0 32c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-32 64 0zM528 432l-64 0 0-144 64 0 0 144zm0-272l0 80-64 0 0-158.4c36.5 7.4 64 39.7 64 78.4zM128 32C57.3 32 0 89.3 0 160L0 432c0 26.5 21.5 48 48 48l480 0c26.5 0 48-21.5 48-48l0-272c0-70.7-57.3-128-128-128L128 32zM304 256l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faChessQueen = {
  prefix: 'far',
  iconName: 'chess-queen',
  icon: [512, 512, [9819], "f445", "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352l55.4 0-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352l55.4 0 93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432l245.6 0 16.6 32-278.7 0 16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"]
};
const faPaintbrushFine = {
  prefix: 'far',
  iconName: 'paintbrush-fine',
  icon: [576, 512, ["paint-brush-alt", "paint-brush-fine", "paintbrush-alt"], "f5a9", "M489 57L306.2 239.7l30.1 30.1L519 87c8.3-8.3 8.3-21.8 0-30.1s-21.8-8.3-30.1 0zM210.5 325c-8.2-3.3-17.2-5-26.5-5c-39.8 0-72 32.2-72 72c0 3.8 .3 7.5 .8 11.1c3.3 21.4-2.2 43.1-13.8 60l-.7 .9 85.6 0c39.8 0 72-32.2 72-72c0-9.4-1.8-18.3-5-26.5L210.5 325zm-6.2-51.3L455 23c27-27 70.9-27 97.9 0s27 70.9 0 97.9L302.3 371.7c1.1 6.6 1.7 13.4 1.7 20.3c0 66.3-53.7 120-120 120L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l6 0c18.1 0 30.1-19.8 27.4-37.6c-.9-6-1.4-12.1-1.4-18.4c0-66.3 53.7-120 120-120c6.9 0 13.7 .6 20.3 1.7z"]
};
const faPaintBrushAlt = faPaintbrushFine;
const faPaintBrushFine = faPaintbrushFine;
const faPaintbrushAlt = faPaintbrushFine;
const faGlasses = {
  prefix: 'far',
  iconName: 'glasses',
  icon: [576, 512, [], "f530", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2c0 .5 0 1 0 1.5l0 41.3c0 .2 0 .4 0 .6l0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 35.3 28.7 64 64 64l44.3 0c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z"]
};
const faHoodCloak = {
  prefix: 'far',
  iconName: 'hood-cloak',
  icon: [576, 512, [], "f6ef", "M454.4 15.3c3 7.7 1.8 16.2-2.9 22.7c-1 1.3-2.1 2.6-3.3 3.7l-32 29c11.4 10.2 22.6 21.8 33.1 34.8C484.5 149.1 512 208.6 512 288c0 58.5 14.6 101.6 28.6 129.7c7 14.1 14 24.5 19 31.1c2.5 3.3 4.5 5.7 5.7 7.1c.6 .7 1.1 1.2 1.3 1.4l.1 .1s0 0 0 0s0 0 0 0s0 0 0 0c9 9.2 11.7 22.8 6.8 34.7c-5 12-16.6 19.8-29.6 19.8L32 512c-12.9 0-24.6-7.8-29.6-19.8c-4.9-11.9-2.2-25.6 6.8-34.7l.2-.2c.2-.2 .7-.7 1.3-1.4c1.3-1.4 3.2-3.8 5.7-7.1c5-6.6 11.9-17 19-31.1C49.4 389.6 64 346.5 64 288C64 151.8 111.4 76.9 167.7 37.7C222 0 278.2 0 288 0c0 0 0 0 0 0L432 0c9.9 0 18.8 6.1 22.4 15.3zm43.3 423.8c-17-34-33.7-84.4-33.7-151.2c0-86.7-38.5-144.2-79.9-181.5c-10.1-9.1-15.9-22-15.9-35.6c0-8.1 2-16 5.8-22.9l-86 0s0 0 0 0c-7.2 0-51 0-92.8 29.1C154.3 105.5 112 164 112 288c0 66.8-16.7 117.2-33.7 151.2c-4.8 9.6-9.6 17.9-14.1 24.8l95.8 0 0-128c0-70.7 57.3-128 128-128s128 57.3 128 128l0 128 95.8 0c-4.5-7-9.3-15.2-14.1-24.8zM208 464l160 0 0-128c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 128z"]
};
const faSquareQuote = {
  prefix: 'far',
  iconName: 'square-quote',
  icon: [448, 512, [], "e329", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 240l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3zm144 39.3l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71z"]
};
const faUpLeft = {
  prefix: 'far',
  iconName: 'up-left',
  icon: [384, 512, [], "e2bd", "M64 128l0 193.4c0 1.7 .8 3.2 2.1 4.2c2.1 1.6 5 1.4 6.9-.5L127 271c9.4-9.4 24.6-9.4 33.9 0L285.7 395.7c2.7 2.7 6.5 4.3 10.3 4.3s7.6-1.5 10.3-4.3l25.4-25.4c2.7-2.7 4.3-6.5 4.3-10.3s-1.5-7.6-4.3-10.3L207 225c-9.4-9.4-9.4-24.6 0-33.9L261.1 137c1.8-1.8 2.1-4.8 .5-6.9c-1-1.3-2.5-2.1-4.2-2.1L64 128zm-48-8c0-22.1 17.9-40 40-40l201.4 0c16.8 0 32.5 7.9 42.6 21.3c15.9 21.2 13.8 50.9-4.9 69.6L257.9 208 365.7 315.7C377.4 327.5 384 343.4 384 360s-6.6 32.5-18.3 44.3l-25.4 25.4C328.5 441.4 312.6 448 296 448s-32.5-6.6-44.3-18.3L144 321.9 106.9 359c-18.7 18.7-48.4 20.8-69.6 5C23.9 353.9 16 338.1 16 321.4L16 120z"]
};
const faBringFront = {
  prefix: 'far',
  iconName: 'bring-front',
  icon: [640, 512, [], "f857", "M64 48l128 0c8.8 0 16 7.2 16 16l48 0c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l64 0 0-48-64 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM448 512l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l-48 0c0 35.3 28.7 64 64 64zM224 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L224 96z"]
};
const faChessBoard = {
  prefix: 'far',
  iconName: 'chess-board',
  icon: [448, 512, [], "f43c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 0l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"]
};
const faBurgerCheese = {
  prefix: 'far',
  iconName: 'burger-cheese',
  icon: [512, 512, [127828, "cheeseburger"], "f7f1", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zM253.5 262.8l52.2 26.1c9 4.5 19.6 4.5 28.6 0l52.2-26.1c8.9-4.4 18.7-6.8 28.6-6.8l16.9 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 320c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 16.9 0c9.9 0 19.7 2.3 28.6 6.8z"]
};
const faCheeseburger = faBurgerCheese;
const faBuildingCircleCheck = {
  prefix: 'far',
  iconName: 'building-circle-check',
  icon: [640, 512, [], "e4d2", "M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faRepeat1 = {
  prefix: 'far',
  iconName: 'repeat-1',
  icon: [512, 512, [128258], "f365", "M0 254.8C-.6 268 9.6 279.3 22.8 280s24.5-9.5 25.2-22.8l.4-8C52 176.8 111.7 120 184.2 120L304 120l0 36.4c0 19.6 15.9 35.6 35.6 35.6c8.8 0 17.3-3.3 23.8-9.1l76.7-69c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-76.7-69c-6.5-5.9-15-9.1-23.8-9.1C319.9 0 304 15.9 304 35.6L304 72 184.2 72C86.2 72 5.3 148.9 .4 246.8l-.4 8zM388.1 96L352 128.5l0-65L388.1 96zM512 257.2c.7-13.2-9.5-24.5-22.8-25.2s-24.5 9.5-25.2 22.8l-.4 8C460 335.2 400.3 392 327.8 392L208 392l0-36.4c0-19.6-15.9-35.6-35.6-35.6c-8.8 0-17.3 3.3-23.8 9.1l-76.7 69c-5.1 4.6-7.9 11-7.9 17.8s2.9 13.3 7.9 17.8l76.7 69c6.5 5.9 15 9.1 23.8 9.1c19.6 0 35.6-15.9 35.6-35.6l0-36.4 119.8 0c98 0 178.9-76.9 183.8-174.8l.4-8zM123.9 416L160 383.5l0 65L123.9 416zM288 208c0-9.1-5.1-17.4-13.3-21.5s-17.9-3.2-25.1 2.3l-32 24c-10.6 8-12.8 23-4.8 33.6c6.5 8.6 17.6 11.6 27.2 8.2l0 49.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z"]
};
const faArrowDownToLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-line',
  icon: [384, 512, ["arrow-to-bottom"], "f33d", "M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 267.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 175.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z"]
};
const faArrowToBottom = faArrowDownToLine;
const faGrid5 = {
  prefix: 'far',
  iconName: 'grid-5',
  icon: [448, 512, [], "e199", "M0 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80L0 48zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM0 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM192 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 32l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 144c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM384 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
};
const faSwapArrows = {
  prefix: 'far',
  iconName: 'swap-arrows',
  icon: [640, 512, [], "e60a", "M111 7c9.4-9.4 24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47L152 360c0 39.8 32.2 72 72 72s72-32.2 72-72l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 278.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L488 152c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-278.1L57 129c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L111 7z"]
};
const faRightLongToLine = {
  prefix: 'far',
  iconName: 'right-long-to-line',
  icon: [640, 512, [], "e444", "M640 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM505.5 272.4c8.7-9.2 8.7-23.7 0-32.9l-121.4-129c-8.8-9.3-21-14.6-33.7-14.6c-25.6 0-46.3 20.7-46.3 46.3l0 33.7L56 176c-30.9 0-56 25.1-56 56l0 48c0 30.9 25.1 56 56 56l248 0 0 33.7c0 25.6 20.7 46.3 46.3 46.3c12.8 0 25-5.3 33.7-14.6l121.4-129zM352 200l0-53.5L455 256 352 365.5l0-53.5c0-6.4-2.5-12.5-7-17s-10.6-7-17-7L56 288c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8l272 0c13.3 0 24-10.7 24-24z"]
};
const faPersonChalkboard = {
  prefix: 'far',
  iconName: 'person-chalkboard',
  icon: [640, 512, [], "e53d", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l29.8 0 0 128-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-312 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-80 224 0 0 224-224 0 0-48-48 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 80-76.9 0-64.8 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faMarsStrokeRight = {
  prefix: 'far',
  iconName: 'mars-stroke-right',
  icon: [640, 512, [9897, "mars-stroke-h"], "f22b", "M80 256a128 128 0 1 1 256 0A128 128 0 1 1 80 256zm302.4-24C370.7 146.2 297.1 80 208 80C110.8 80 32 158.8 32 256s78.8 176 176 176c89.1 0 162.7-66.2 174.4-152l33.6 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 78.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L464 232l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-33.6 0z"]
};
const faMarsStrokeH = faMarsStrokeRight;
const faHandBackFist = {
  prefix: 'far',
  iconName: 'hand-back-fist',
  icon: [448, 512, ["hand-rock"], "f255", "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16l0 104c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.8c38-20.1 64-60.1 64-106.2l0-104c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64l0 64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6l0 12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3L128 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128.1c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4l0-12.8c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6l0 32.3c0 8.8 7.2 16 16 16s16-7.2 16-16l0-65.7 0-14.3 0-64z"]
};
const faHandRock = faHandBackFist;
const faGridRound5 = {
  prefix: 'far',
  iconName: 'grid-round-5',
  icon: [448, 512, [], "e5de", "M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 96A32 32 0 1 1 0 160a32 32 0 1 1 64 0zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64A32 32 0 1 1 0 352a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 64A32 32 0 1 1 96 64a32 32 0 1 1 64 0zM128 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM320 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faTally = {
  prefix: 'far',
  iconName: 'tally',
  icon: [640, 512, ["tally-5"], "f69c", "M128 40c13.3 0 24 10.7 24 24l0 222.7L232 260l0-196c0-13.3 10.7-24 24-24s24 10.7 24 24l0 180 80-26.7L360 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 137.4 80-26.7L488 64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 94.7 64.4-21.5c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4L536 209.3 536 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-222.7L408 252l0 196c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-180-80 26.7L280 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.4-80 26.7L152 448c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.7L39.6 374.8C27 379 13.4 372.2 9.2 359.6S11.8 333.4 24.4 329.2L104 302.7 104 64c0-13.3 10.7-24 24-24z"]
};
const faTally5 = faTally;
const faSquareCaretUp = {
  prefix: 'far',
  iconName: 'square-caret-up',
  icon: [448, 512, ["caret-square-up"], "f151", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"]
};
const faCaretSquareUp = faSquareCaretUp;
const faCloudShowersWater = {
  prefix: 'far',
  iconName: 'cloud-showers-water',
  icon: [576, 512, [], "e4e4", "M184.1 107.8C186.3 74.4 214.1 48 248 48c23.4 0 43.9 12.6 55.1 31.5c3.4 5.7 9 9.8 15.5 11.2s13.3 .1 18.8-3.7c6.4-4.4 14.2-7 22.6-7c19.1 0 35.2 13.4 39.1 31.4c2.4 11 12.2 18.9 23.4 18.9l10.6 0c17 0 30.9 13.8 30.9 30.9s-13.8 30.9-30.9 30.9l-290.3 0c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9l17.3 0c12.7 0 23.1-9.8 24-22.5zM248 0c-51.6 0-95 34.9-108 82.3c-42.2 1.5-76 36.2-76 78.8c0 43.6 35.3 78.9 78.9 78.9l290.3 0c43.6 0 78.9-35.3 78.9-78.9c0-41.4-31.8-75.3-72.4-78.6C425.6 52.7 395.2 32 360 32c-10.1 0-19.9 1.7-28.9 4.9C310.6 14.3 281 0 248 0zM132.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm327.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM244.6 308.3c6.8-11.4 3.1-26.1-8.2-32.9s-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80zm103.8-32.9c-11.4-6.8-26.1-3.1-32.9 8.2l-48 80c-6.8 11.4-3.1 26.1 8.2 32.9s26.1 3.1 32.9-8.2l48-80c6.8-11.4 3.1-26.1-8.2-32.9zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faChartBar = {
  prefix: 'far',
  iconName: 'chart-bar',
  icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faBarChart = faChartBar;
const faHandsBubbles = {
  prefix: 'far',
  iconName: 'hands-bubbles',
  icon: [576, 512, ["hands-wash"], "e05e", "M416 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM528 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM144 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM48 143.8l0 84.6c0 39.8 16 77.3 43.4 104.7c-14.4 7.6-26.9 18.3-36.6 31.2C20.1 328.3 0 279.8 0 228.4l0-84.6c0-35.3 28.7-64 64-64c22.6 0 42.5 11.7 53.9 29.4L164.7 28C180.2 1.2 214.4-8 241.2 7.5c3.8 2.2 7.2 4.8 10.3 7.6c17.4-12.7 41.3-14.8 61.1-3.3s30 33.2 27.7 54.6c4 1.2 8 2.9 11.7 5.1c12.4 7.2 21.1 18.4 25.2 31c-21.4-8.7-46.2-9.1-69 1l-53 23.5 20.2-35c0 0 0 0 0-.1l16-27.7c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9l-8 13.8c0 0 0 0 0 .1l-8 13.9-31.5 54.5c-19.1 9.6-36.4 21.8-51.5 36.1c-9.8-7.1-12.9-20.7-6.7-31.4l48-83.1c0 0 0 0 0-.1c2.2-3.8 .9-8.7-2.9-10.9s-8.7-.9-10.9 2.9L124.8 193.2c-5.4 9.4-16.5 14-27 11.2S80 192.1 80 181.2l0-37.4c0-8.8-7.2-16-16-16s-16 7.2-16 16zM326.1 512c-31.3 0-60.7-7.9-86.4-21.8c8.4-13.8 13.9-29.5 15.7-46.4c20.5 12.8 44.7 20.1 70.7 20.1L456 464c4.4 0 8-3.6 8-8c0-4.4-3.5-7.9-7.9-8L392 448c-13.3 0-24-10.7-24-24s10.7-24 24-24l63.9 0 .2 0 31.9 0c4.4 0 8-3.6 8-8c0-4.4-3.5-8-7.9-8L392 384c-13.3 0-24-10.7-24-24s10.7-24 24-24l95.8 0 .2 0 32 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-15.8 0-.2 0-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l95.8 0 .2 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-152.1 0c-11.2 0-21-7.8-23.4-18.8s3-22.2 13.2-27l25.1-11.8c8-3.8 11.4-13.3 7.7-21.3s-13.3-11.4-21.3-7.7l-56.4 26.5c-27.6 13-50.1 33.5-65.5 58.4c-.2 .2-.3 .5-.5 .7c-14.6 21.7-22.8 47.6-22.8 74.8l0 .9c-14.5-6.9-30.7-10.7-47.7-10.8c1.8-33.2 12.6-64.6 30.4-91.3c20.2-32.4 49.6-59.2 85.7-76.1l56.4-26.5c32-15.1 70.1-1.3 85.2 30.7c7.9 16.8 7.9 35.3 1.4 51.3l84.7 0c30.9 0 56 25.1 56 56c0 4.4-.5 8.6-1.5 12.7c19.7 8.7 33.5 28.4 33.5 51.3s-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 22.9-13.8 42.6-33.5 51.3c1 4.1 1.5 8.3 1.5 12.7c0 30.9-25.1 56-56 56l-129.9 0z"]
};
const faHandsWash = faHandsBubbles;
const faLessThanEqual = {
  prefix: 'far',
  iconName: 'less-than-equal',
  icon: [448, 512, [], "f537", "M401 78.2c12.3-5 18.2-19 13.2-31.3s-19-18.2-31.3-13.2L47 169.8c-9.1 3.7-15 12.5-15 22.2s5.9 18.6 15 22.2l336 136c12.3 5 26.3-1 31.3-13.2s-1-26.3-13.2-31.3L120 192 401 78.2zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faTrain = {
  prefix: 'far',
  iconName: 'train',
  icon: [448, 512, [128646], "f238", "M352 48c26.5 0 48 21.5 48 48l0 96L48 192l0-96c0-26.5 21.5-48 48-48l256 0zM48 352l0-112 352 0 0 112c0 26.5-21.5 48-48 48L96 400c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96L0 352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 188.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352l0-256c0-53-43-96-96-96L96 0zM224 360a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
};
const faUpFromDottedLine = {
  prefix: 'far',
  iconName: 'up-from-dotted-line',
  icon: [448, 512, [], "e456", "M114.2 192L224 82 333.8 192 280 192c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 32c-11.5 0-22.5 4.6-30.6 12.7L77.6 160.8C68.9 169.5 64 181.3 64 193.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 44.7C246.5 36.6 235.5 32 224 32zM32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faEyeLowVision = {
  prefix: 'far',
  iconName: 'eye-low-vision',
  icon: [640, 512, ["low-vision"], "f2a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2l-74-58c-36.7-11.8-68.5-32.9-95-57.5c-18.3-17-34-35.6-46.8-53.6L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"]
};
const faLowVision = faEyeLowVision;
const faTrafficLightGo = {
  prefix: 'far',
  iconName: 'traffic-light-go',
  icon: [320, 512, [], "f638", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-184a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faFaceExhaling = {
  prefix: 'far',
  iconName: 'face-exhaling',
  icon: [576, 512, [], "e480", "M48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 7-.3 13.9-1 20.7c11.6-8 25.6-12.7 40.8-12.7c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-7.7-2.3c-34.1 24.5-76 39-121.3 39C141.1 464 48 370.9 48 256zM256 424a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm95.6-172c-10.6 0-19.9-3.8-25.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7zm-217.4-9.7c-7.6-8.1-20.2-8.5-28.3-.9s-8.5 20.2-.9 28.3c14.5 15.5 35.2 22.3 54.6 22.3s40.1-6.8 54.6-22.3c7.6-8.1 7.1-20.7-.9-28.3s-20.7-7.1-28.3 .9c-5.5 5.8-14.8 9.7-25.4 9.7s-19.9-3.8-25.4-9.7zm409.2 96.2c.1-.8 .1-1.7 .1-2.5c0-22.1-17.9-40-39.9-40c-16.9 0-31.4 10.5-37.2 25.4c-3.3-.9-6.9-1.4-10.5-1.4c-20.7 0-37.7 15.8-39.7 35.9l-72.3 18.1c-4.6 1.1-7.8 5.2-7.8 9.9s3.2 8.8 7.8 9.9L416.1 412c-.1 1.3-.2 2.6-.2 4c0 22.1 17.9 40 39.9 40c4.9 0 9.6-.9 14-2.5c7.1 11.1 19.5 18.5 33.7 18.5c22.1 0 39.9-17.9 39.9-40c0-.8 0-1.7-.1-2.5c19-6.4 32.6-24.4 32.6-45.5s-13.6-39.1-32.6-45.5z"]
};
const faSensorFire = {
  prefix: 'far',
  iconName: 'sensor-fire',
  icon: [640, 512, [], "e02a", "M64 80l320 0c8.8 0 16 7.2 16 16l0 55.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l273.6 0c-12.7-14.3-23.4-30.5-31.5-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm265.7 56.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z"]
};
const faUserUnlock = {
  prefix: 'far',
  iconName: 'user-unlock',
  icon: [640, 512, [], "e058", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464L384 464l0 16c0 11.7 3.1 22.6 8.6 32L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c43.6 0 83.6 15.7 114.6 41.7c-.2 2.1-.3 4.2-.3 6.3l0 67.7C361.9 379.3 319 352 269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112zM496 272l0 48 16 0 48 0 48 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
};
const faHexagonDivide = {
  prefix: 'far',
  iconName: 'hexagon-divide',
  icon: [512, 512, [], "e1ad", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const fa00 = {
  prefix: 'far',
  iconName: '00',
  icon: [640, 512, [], "e467", "M144 32C64.5 32 0 96.5 0 176L0 336c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM48 176c0-53 43-96 96-96s96 43 96 96l0 160c0 53-43 96-96 96s-96-43-96-96l0-160zM496 32c-79.5 0-144 64.5-144 144l0 160c0 79.5 64.5 144 144 144s144-64.5 144-144l0-160c0-79.5-64.5-144-144-144zM400 176c0-53 43-96 96-96s96 43 96 96l0 160c0 53-43 96-96 96s-96-43-96-96l0-160z"]
};
const faCrow = {
  prefix: 'far',
  iconName: 'crow',
  icon: [640, 512, [], "f520", "M39.2 442.6l72-58.6 148.1 0 46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384l40.9 0c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192l0-64 0-8 96-24c-9.4-37.6-43.2-64-82-64l-43 0C496.1 12.3 469.5 0 440 0C382.6 0 336 46.6 336 104l0 35.1L94.1 336 80.9 346.8l-72 58.6s0 0 0 0s0 0 0 0C-1.4 413.8-3 428.9 5.4 439.2s23.5 11.8 33.8 3.5c0 0 0 0 0 0zM195.4 315.4L333.1 203.4c-10.9 51.4-51 93.1-104 104.7l-33.7 7.4zM384 161.9s0 0 0 0l0-22.8 0-35.1c0-30.9 25.1-56 56-56s56 25.1 56 56l0 24 0 64c0 79.5-64.5 144-144 144l-62.5 0c57.1-31.8 94.5-92.7 94.5-160.8l0-13.3zM464 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCassetteBetamax = {
  prefix: 'far',
  iconName: 'cassette-betamax',
  icon: [576, 512, ["betamax"], "f8a4", "M48 416l0-256 480 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM368 256l80 0 0 80-80 0 0-80zm-48-16l0 112c0 17.7 14.3 32 32 32l112 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32l-112 0c-17.7 0-32 14.3-32 32zm-136 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160a104 104 0 1 0 0-208 104 104 0 1 0 0 208zm0-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faBetamax = faCassetteBetamax;
const faSailboat = {
  prefix: 'far',
  iconName: 'sailboat',
  icon: [576, 512, [], "e445", "M284.6 6.2c-4.2-5.4-11.4-7.5-17.8-5.3S256 9.2 256 16l0 288c0 8.8 7.2 16 16 16l224 0c6.1 0 11.7-3.5 14.4-9s2-12-1.7-16.9l-224-288zm-72 90.5c-6.7-2-14 .6-17.9 6.4l-128 192c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l128 0c8.8 0 16-7.2 16-16l0-192c0-7.1-4.6-13.3-11.4-15.3zM60 400l456 0-.4 1.6c-8.2 36.5-40.6 62.4-78 62.4l-299.2 0c-37.4 0-69.8-25.9-78-62.4L60 400zM20 352c-10.3 0-17.9 9.5-15.6 19.5l9.1 40.6c13.1 58.4 65 99.9 124.9 99.9l299.2 0c59.9 0 111.7-41.5 124.9-99.9l9.1-40.6c2.2-10-5.4-19.5-15.6-19.5L20 352z"]
};
const faWindowRestore = {
  prefix: 'far',
  iconName: 'window-restore',
  icon: [512, 512, [], "f2d2", "M432 48L208 48c-17.7 0-32 14.3-32 32l0 16-48 0 0-16c0-44.2 35.8-80 80-80L432 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-16 0 0-48 16 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192L48 256l0 192zM64 128l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64z"]
};
const faNfcMagnifyingGlass = {
  prefix: 'far',
  iconName: 'nfc-magnifying-glass',
  icon: [640, 512, [], "e1f9", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l269.7 0c20.2 20.6 46 35.8 74.8 43.1c-7.6 3.2-15.9 4.9-24.6 4.9L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 64c-16.7 0-32.8 2.6-48 7.3L400 96c0-8.8-7.2-16-16-16zm-16 72l0 29.4c-18.7 10.8-35.1 25.4-48 42.6l0-64-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM309.4 400L120 400c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 163.2 0c3.5 17.2 9.7 33.3 18.2 48zm138.6 .2a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 48c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9L633 471.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L519.9 426c-20.5 14-45.3 22.1-71.9 22.1z"]
};
const faFileBinary = {
  prefix: 'far',
  iconName: 'file-binary',
  icon: [384, 512, [], "e175", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm64 240c-30.9 0-56 25.1-56 56l0 64c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56l0-64c0-30.9-25.1-56-56-56l-16 0zm-8 56c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 64c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-64zm120-56c-13.3 0-24 10.7-24 24s10.7 24 24 24l0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l0-104c0-13.3-10.7-24-24-24l-24 0z"]
};
const faCircleV = {
  prefix: 'far',
  iconName: 'circle-v',
  icon: [512, 512, [], "e12a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM173.5 157.3c-5.9-11.9-20.3-16.7-32.2-10.7s-16.7 20.3-10.7 32.2l104 208c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l104-208c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L256 322.3 173.5 157.3z"]
};
const faSquarePlus = {
  prefix: 'far',
  iconName: 'square-plus',
  icon: [448, 512, [61846, "plus-square"], "f0fe", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faPlusSquare = faSquarePlus;
const faBowlScoops = {
  prefix: 'far',
  iconName: 'bowl-scoops',
  icon: [448, 512, [127813], "e3df", "M224 208c0 5.4 .4 10.8 1.1 16l221.7 0c.7-5.2 1.1-10.6 1.1-16c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208zM0 208c0 5.4 .4 10.8 1.1 16l191.7 0c-.6-5.3-.9-10.6-.9-16c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208zM325.4 64.4C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1zM173.8 368l-2.2 0L145 368c-41.4 0-77.2-26.3-90.5-64l339.1 0c-13.3 37.7-49.1 64-90.5 64l-26.7 0-2.2 0-100.3 0zm36.9 78.7L224 430.8l13.3 15.9L251.7 464l-55.4 0 14.4-17.3zm92.3 3.9L274.2 416l28.8 0c10.6 0 20.9-1.1 30.9-3.3c58.5-12.8 104.3-61.2 112-122.8l2-15.9c.6-4.6-.8-9.1-3.9-12.6s-7.4-5.4-12-5.4L16 256c-4.6 0-9 2-12 5.4s-4.5 8-3.9 12.6l2 15.9c7.7 61.6 53.5 110 112 122.8c10 2.2 20.3 3.3 30.9 3.3l28.8 0L145 450.6l-10.9 13.1-.3 .3-.4 .5L128 471l-12.3 14.7c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2l19.2 0 8.5 0 .6 0 135.4 0 .6 0 8.5 0 19.2 0c6.2 0 11.9-3.6 14.5-9.2s1.8-12.3-2.2-17L320 471l-5.5-6.5-.4-.5-.3-.3L303 450.6z"]
};
const faMistletoe = {
  prefix: 'far',
  iconName: 'mistletoe',
  icon: [576, 512, [], "f7b4", "M288 0c13.3 0 24 10.7 24 24l0 62.1 98 98 8.7 1.7 65.9 12.7C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75c-54 0-100.3-38.3-110.5-91.3l-12.7-65.9-1.7-8.7L312 153.9 312 288l6 8 46.8 62.4C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6L258 296l6-8 0-134.1L199.9 218l-1.4 7.4c3-.9 6.2-1.4 9.5-1.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-7.6 0-14.7-2.7-20.2-7.2l-2.3 11.9C175.4 345.7 129 384 75 384c-41.4 0-75-33.6-75-75c0-54 38.3-100.3 91.3-110.5l65.9-12.7 8.7-1.7 98-98L264 24c0-13.3 10.7-24 24-24zM100.4 245.6C70 251.4 48 278 48 309c0 14.9 12.1 27 27 27c30.9 0 57.5-22 63.4-52.4l9.1-47.1-47.1 9.1zm328.2-9.1l9.1 47.1C443.4 314 470 336 501 336c14.9 0 27-12.1 27-27c0-30.9-22-57.5-52.4-63.4l-47.1-9.1zM249.6 387.2c-6.2 8.3-9.6 18.4-9.6 28.8c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L288 336l-38.4 51.2zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCustard = {
  prefix: 'far',
  iconName: 'custard',
  icon: [576, 512, [127854], "e403", "M116.1 112.8L53.7 368l49.4 0 33.6-137.6c14.1-3.8 27.9-6.4 39.3-6.4c16.7 0 28.8 5.6 45.6 13.6l1 .5C238.9 246 259.8 256 288 256s49.1-10 65.4-17.9l1-.5c16.8-8.1 28.9-13.6 45.6-13.6c11.4 0 25.2 2.6 39.3 6.4L472.9 368l49.4 0L459.9 112.8c-7-28.6-32.7-48.8-62.2-48.8L178.2 64c-29.5 0-55.2 20.2-62.2 48.8zm310.5 65.6c-9-1.5-18-2.4-26.6-2.4c-28.2 0-49.1 10-65.4 17.9l-1 .5C316.8 202.4 304.7 208 288 208s-28.8-5.6-45.6-13.6l-1-.5C225.1 186 204.2 176 176 176c-8.6 0-17.6 .9-26.6 2.4l13.3-54.2c1.8-7.2 8.2-12.2 15.5-12.2l219.5 0c7.4 0 13.8 5 15.5 12.2l13.3 54.2zM0 424c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400c-13.3 0-24 10.7-24 24z"]
};
const faLacrosseStick = {
  prefix: 'far',
  iconName: 'lacrosse-stick',
  icon: [512, 512, [], "e3b5", "M261.5 107.5l-6.6 19.7c-6.3 18.9-16 36.5-28.6 51.9l-34.4 42c-10.3 12.6-15.9 28.3-15.9 44.5c0 38.8 31.5 70.3 70.3 70.3c16.2 0 32-5.6 44.5-15.9l42-34.4c15.4-12.6 33-22.3 51.9-28.6l19.7-6.6C440 238.7 464 205.4 464 168c0 0 0 0 0 0l0-.3c0-22.9-15.2-53-40.9-78.8S367.2 48 344.3 48l-.3 0s0 0 0 0c-37.4 0-70.7 24-82.5 59.5zM344 0s0 0 0 0l.3 0C385.1 0 426.8 24.8 457 55s55 71.9 55 112.7l0 .3s0 0 0 0c0 58.1-37.2 109.7-92.3 128.1L400 302.6c-13.4 4.5-25.8 11.3-36.7 20.2l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7c-24 0-46.3-7.1-65-19.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L147.4 330.6c-12.3-18.6-19.4-41-19.4-65c0-27.3 9.5-53.8 26.7-74.9l34.4-42c8.9-10.9 15.8-23.3 20.2-36.7l6.6-19.7C234.3 37.2 285.9 0 344 0z"]
};
const faHockeyMask = {
  prefix: 'far',
  iconName: 'hockey-mask',
  icon: [448, 512, [], "f6ee", "M48 240c0-57.4 14.3-105.3 41.1-137.9C114.7 70.9 156.1 48 224 48s109.3 22.9 134.9 54.1C385.7 134.7 400 182.6 400 240c0 95.1-12.6 148.4-36 178.6C343.4 445.3 306 464 224 464s-119.4-18.7-140-45.4C60.6 388.4 48 335.1 48 240zM224 0C64 0 0 111 0 240C0 432 48 512 224 512s224-80 224-272C448 111 384 0 224 0zM200 208c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64s64-28.7 64-64zm112 64c35.3 0 64-28.7 64-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32c0 35.3 28.7 64 64 64zM176 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM288 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faSunrise = {
  prefix: 'far',
  iconName: 'sunrise',
  icon: [576, 512, [127749], "f766", "M271 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L312 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L271 7zM393.3 225.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L493.9 464l58.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l58.1 0L36.2 397.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-13 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L288 285.1l82.5-56.9c6.7-4.6 15.3-5.5 22.8-2.4zM140.4 464l36.7 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l36.7 0 43.6-63.2-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3l-14.4-78.3L301.6 334c-8.2 5.7-19 5.7-27.2 0l-65.6-45.2-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L96.8 400.8 140.4 464zM350 464c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48l124 0z"]
};
const faSubtitles = {
  prefix: 'far',
  iconName: 'subtitles',
  icon: [576, 512, [], "e60f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM120 240l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM120 336l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 0l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faPanelEws = {
  prefix: 'far',
  iconName: 'panel-ews',
  icon: [512, 512, [], "e42e", "M64 48c-8.8 0-16 7.2-16 16l0 230.7C76.3 307 96 335.2 96 368l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-14.2-6.2-27-16-35.8L48 448c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM112 96l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 160l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96l64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"]
};
const faToriiGate = {
  prefix: 'far',
  iconName: 'torii-gate',
  icon: [512, 512, [9961], "f6a1", "M48 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-47.5-1.6 .6C437.9 75 411.6 80 385.2 80L126.8 80c-26.5 0-52.7-5-77.2-14.9L48 64.5 48 112zM0 112L0 13.4C0 6 6 0 13.4 0c1.7 0 3.4 .3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32l258.4 0c20.4 0 40.5-3.9 59.4-11.4L493.6 1c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4l0 98.6c0 35.3-28.7 64-64 64l0 64 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-200-144 0-144 0 0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-200-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-64c-35.3 0-64-28.7-64-64zM112 240l120 0 0-64-120 0 0 64zm168-64l0 64 120 0 0-64-120 0z"]
};
const faCloudExclamation = {
  prefix: 'far',
  iconName: 'cloud-exclamation',
  icon: [640, 512, [], "e491", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM320 144c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faMessageLines = {
  prefix: 'far',
  iconName: 'message-lines',
  icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faCommentAltLines = faMessageLines;
const faFrog = {
  prefix: 'far',
  iconName: 'frog',
  icon: [576, 512, [], "f52e", "M322.4 113c-5.9 17.8-21.6 30.6-40.2 32.7C150.4 160.5 48 272.3 48 408l0 16c0 4.4 3.6 8 8 8l182.1 0c.3-.3 .6-.7 .9-1l56.8-56.8c10.4-10.3 16.2-24.4 16.2-39c0-30.5-24.7-55.2-55.2-55.2c-14.6 0-28.7 5.8-39 16.2L169 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48.8-48.8c19.4-19.4 45.6-30.2 73-30.2c50.2 0 92 35.8 101.3 83.2c3-6.3 7.4-11.9 12.9-16.4c4.6-3.8 9.5-7.3 14.5-10.5l135.9-86.5c4.1-2.6 6.5-7.1 6.5-11.9c0-6.2-4-11.7-10-13.5l-70-21.5c-16.8-5.2-29.5-19.1-32.9-36.4C410.6 96.5 391.2 80 368 80c-21.2 0-39.3 13.8-45.6 33zM434.1 371.3l54 58.1c1.5 1.6 3.6 2.6 5.9 2.6l58 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-58 0c-15.6 0-30.4-6.5-41-17.9l-23.5-25.3-28.7-31-16.4-17.6-16.4-17.6L355.4 384l-20.3 21.8L310.9 432l48.6 0 .5 0c4.7 0 9.2 1.4 12.9 3.7C379.6 440 384 447.5 384 456c0 .8 0 1.5-.1 2.3C382.7 470.5 372.5 480 360 480l-49.1 0L56 480c-30.9 0-56-25.1-56-56l0-16C0 247.6 121.1 115.5 276.8 98c12.6-38.3 48.7-66 91.2-66c46.5 0 85.3 33.1 94.1 77l70 21.5c26.1 8 43.9 32.1 43.9 59.4c0 21.2-10.9 41-28.8 52.4L442 309.3l-30.7 19.6c-3.5 2.2-6.8 4.6-9.9 7.2l1.7 1.9c0 0 0 0 0 0l31 33.4zM368 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faBucket = {
  prefix: 'far',
  iconName: 'bucket',
  icon: [448, 512, [], "e4cf", "M96 152l0 8-48 0 0-8C48 68.1 116.1 0 200 0l48 0c83.9 0 152 68.1 152 152l0 8-48 0 0-8c0-57.4-46.6-104-104-104l-48 0C142.6 48 96 94.6 96 152zM0 216c0-13.3 10.7-24 24-24l48.4 0 303.3 0 48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-6 0L389.3 470c-3 24-23.4 42-47.6 42l-235.3 0c-24.2 0-44.6-18-47.6-42L30 240l-6 0c-13.3 0-24-10.7-24-24zm78.4 24l28 224 235.3 0 28-224L78.4 240z"]
};
const faFloppyDiskPen = {
  prefix: 'far',
  iconName: 'floppy-disk-pen',
  icon: [576, 512, [], "e182", "M48 96l0 320c0 8.8 7.2 16 16 16l206.5 0-12 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 65.1-48 48 0-113.1c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM128 80l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm389.8-84.2l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417.1L441.1 287.9l71 71L382.9 488.1c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faImage = {
  prefix: 'far',
  iconName: 'image',
  icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faWindowFrame = {
  prefix: 'far',
  iconName: 'window-frame',
  icon: [512, 512, [129695], "e04f", "M80 464l152 0 0-192L80 272l0 192zm-48 0L32 64C32 28.7 60.7 0 96 0L416 0c35.3 0 64 28.7 64 64l0 400 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm400 0l0-192-152 0 0 192 152 0zM80 224l152 0 0-176L96 48c-8.8 0-16 7.2-16 16l0 160zm200 0l152 0 0-160c0-8.8-7.2-16-16-16L280 48l0 176z"]
};
const faMicrophone = {
  prefix: 'far',
  iconName: 'microphone',
  icon: [384, 512, [], "f130", "M240 96l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160c0-26.5 21.5-48 48-48s48 21.5 48 48zM96 96l0 160c0 53 43 96 96 96s96-43 96-96l0-160c0-53-43-96-96-96S96 43 96 96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40z"]
};
const faCow = {
  prefix: 'far',
  iconName: 'cow',
  icon: [640, 512, [128004], "f6c8", "M72 184c0-23 10.7-43.4 27.5-56.6C97.2 135.2 96 143.5 96 152l0 248c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-21.4c2.5 .6 5.2 1.2 8 1.7l0 11.6c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.1c2.6 .1 5.3 .1 8 .1s5.4 0 8-.1l0 8.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-11.6c2.8-.5 5.5-1.1 8-1.7l0 21.4c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-128.9 16 18 0 46.9c0 4.6 1.3 9 3.8 12.9l42.3 66.5C523 435.7 545.4 448 569.5 448c38.9 0 70.5-31.6 70.5-70.5l0-102.6c0-12.4-4.1-24.4-11.7-34.2l-4.3-5.6 0-67.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5-48.2-62.4C505.1 81.2 470 64 432.9 64L256 64l-72 0-40 0C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4l0-6.4 0-32 0-40zm91.2-66.1c3.6 12.3 10.3 23.6 19.5 32.8l7.4 7.4C211.8 179.8 241.3 192 272 192s60.2-12.2 81.9-33.9l7.4-7.4c10.7-10.7 17.9-24.1 21-38.6l50.5 0c22.3 0 43.3 10.3 57 28L590.3 270c1.1 1.4 1.7 3.1 1.7 4.9l0 102.6c0 12.4-10.1 22.5-22.5 22.5c-7.7 0-14.8-3.9-19-10.4L512 329l0-49c0-5.9-2.2-11.6-6.1-15.9l-64-72c-6.6-7.4-17.2-10-26.5-6.5S400 198 400 208l0 192-32 0 0-48 0-8 0-8c0-53-43-96-96-96s-96 43-96 96l0 8 0 8 0 48-32 0 0-248c0-14.5 7.7-27.1 19.2-34.1zm62.4 211.4l-1.1-.4C228 305.7 247.9 288 272 288s44 17.7 47.5 40.9l-1.1 .4c-9.7 3.2-25.1 6.8-46.4 6.8s-36.7-3.5-46.4-6.8zM576 320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faFileZip = {
  prefix: 'far',
  iconName: 'file-zip',
  icon: [512, 512, [], "e5ee", "M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z"]
};
const faSquareRing = {
  prefix: 'far',
  iconName: 'square-ring',
  icon: [448, 512, [], "e44f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM304 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 256a128 128 0 1 1 256 0A128 128 0 1 1 96 256z"]
};
const faDownFromLine = {
  prefix: 'far',
  iconName: 'down-from-line',
  icon: [384, 512, ["arrow-alt-from-top"], "f349", "M82.2 320L192 430 301.8 320 248 320c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM192 480c-11.5 0-22.5-4.6-30.6-12.7L45.6 351.2C36.9 342.5 32 330.7 32 318.4C32 292.8 52.8 272 78.4 272l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 80C10.7 80 0 69.3 0 56S10.7 32 24 32l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80z"]
};
const faArrowAltFromTop = faDownFromLine;
const faCaretUp = {
  prefix: 'far',
  iconName: 'caret-up',
  icon: [320, 512, [], "f0d8", "M160 182.6L70.6 272l178.7 0L160 182.6zm-22.6-45.3c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 320c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
const faShieldXmark = {
  prefix: 'far',
  iconName: 'shield-xmark',
  icon: [512, 512, ["shield-times"], "e24c", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faShieldTimes = faShieldXmark;
const faScrewdriver = {
  prefix: 'far',
  iconName: 'screwdriver',
  icon: [512, 512, [129691], "f54a", "M445.9 55.9l10.2 10.2L396.2 144 368 144l0-28.2 77.9-59.9zM507 78.6c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19l0 54.1-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192l54.1 0c7.5 0 14.5-3.5 19-9.4l80-104zM155.3 315.3c11.4-11.4 29.9-11.4 41.4 0s11.4 29.9 0 41.4L96 457.4 54.6 416 155.3 315.3zm75.3-33.9c-30.2-30.2-79.1-30.2-109.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3z"]
};
const faCircleSortDown = {
  prefix: 'far',
  iconName: 'circle-sort-down',
  icon: [512, 512, ["sort-circle-down"], "e031", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM267.3 411.3l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-192 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96c6.2 6.2 16.4 6.2 22.6 0zm0-310.6c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l192 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-96-96zM313.4 192l-114.7 0L256 134.6 313.4 192z"]
};
const faSortCircleDown = faCircleSortDown;
const faFolderClosed = {
  prefix: 'far',
  iconName: 'folder-closed',
  icon: [512, 512, [], "e185", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 32L48 192l0-96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240l416 0 0 176c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-176zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3z"]
};
const faHouseTsunami = {
  prefix: 'far',
  iconName: 'house-tsunami',
  icon: [576, 512, [], "e515", "M50 176.4C62 104.5 127.8 48 209.4 48c18.8 0 36.7 3 53.4 8.5c12.6 4.2 26.2-2.7 30.3-15.3s-2.7-26.2-15.3-30.3C256.4 3.8 233.4 0 209.4 0C95 0 0 88.4 0 200c0 93.2 54.7 174 144.8 194.8c12.7 3.4 26 5.2 39.7 5.2c.6 0 1.2 0 1.8-.1c1.8 0 3.6 .1 5.4 .1c.1 0 .3 0 .4 0c0 0 0 0 0 0c34.6 0 67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9c0 0 0 0 0 0c-.1 0-.3 0-.4 0c-12.9 0-25.2-1.4-36.7-4.2c-43.4-12.7-75-52.6-75-99.8c0-57.4 46.7-104 104.4-104c15.9 0 30.9 3.5 44.3 9.8c12 5.6 26.3 .4 31.9-11.6s.4-26.3-11.6-31.9C229.4 101.1 207.5 96 184.4 96C126.3 96 75.6 128.5 50 176.4zM368 286.8L368 152l79.9-60L527.5 152l.3 124.4c9.4 6.4 20.2 11.3 30.8 13.7c6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5L467.2 46.5c-11.4-8.6-27.1-8.6-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6l0 121c1.7 1 3.3 2 4.8 3.1c13.4 9.3 28.4 15.9 43.2 18.7zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faSquareNfi = {
  prefix: 'far',
  iconName: 'square-nfi',
  icon: [448, 512, [], "e576", "M64 80l320 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 32 48 0 0-32c0-8.8 7.2-16 16-16zM48 384L0 384l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-32zm1-223c-10.1 3.1-17 12.4-17 23l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64.7 52 78c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64.7-52-78C70.1 161.9 59.2 158 49 161zm167 23l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24zm200 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144z"]
};
const faForklift = {
  prefix: 'far',
  iconName: 'forklift',
  icon: [640, 512, [], "f47a", "M80 160l16 0L96 40c0-22.1 17.9-40 40-40L293 0c16.6 0 31.5 10.3 37.4 25.8l83 218.9c1.7 4.5 2.6 9.3 2.6 14.2l0 13.1 0 72.4c19.6 17.6 32 43.1 32 71.6c0 53-43 96-96 96s-96-43-96-96l-64 0c0 53-43 96-96 96s-96-43-96-96l0-48L0 240c0-44.2 35.8-80 80-80zm160 80l120.3 0L287.4 48 144 48l0 123.4L240 240zm0 48c-10 0-19.8-3.1-27.9-8.9L112.6 208 80 208c-17.7 0-32 14.3-32 32l0 92.8C62.1 324.7 78.5 320 96 320c35.5 0 66.6 19.3 83.2 48l89.7 0c16.6-28.7 47.6-48 83.2-48c5.5 0 10.8 .5 16 1.3l0-33.3-128 0zM96 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm256 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 24l0 376 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faArrowUpFromGroundWater = {
  prefix: 'far',
  iconName: 'arrow-up-from-ground-water',
  icon: [576, 512, [], "e4b5", "M288 352c13.3 0 24-10.7 24-24l0-246.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L305 7c-9.4-9.4-24.6-9.4-33.9 0L191 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L264 328c0 13.3 10.7 24 24 24zM80 430.1C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM192 192L64 192c-35.3 0-64 28.7-64 64L0 425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5L48 256c0-8.8 7.2-16 16-16l128 0 0-48zm384 64c0-35.3-28.7-64-64-64l-128 0 0 48 128 0c8.8 0 16 7.2 16 16l0 148.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9l0-169z"]
};
const faBracketSquareRight = {
  prefix: 'far',
  iconName: 'bracket-square-right',
  icon: [192, 512, [], "5d", "M192 88c0-30.9-25.1-56-56-56L72 32C58.7 32 48 42.7 48 56s10.7 24 24 24l64 0c4.4 0 8 3.6 8 8l0 336c0 4.4-3.6 8-8 8l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c30.9 0 56-25.1 56-56l0-336z"]
};
const faMartiniGlass = {
  prefix: 'far',
  iconName: 'martini-glass',
  icon: [512, 512, [127864, "glass-martini-alt"], "f57b", "M35.3 0C15.8 0 0 15.8 0 35.3c0 9.4 3.7 18.3 10.3 25L232 281.9 232 464l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-182.1L501.7 60.3c6.6-6.6 10.3-15.6 10.3-25C512 15.8 496.2 0 476.7 0L35.3 0zM318.1 176L256 238.1 193.9 176l124.1 0zm48-48l-220.1 0-80-80 380.1 0-80 80z"]
};
const faGlassMartiniAlt = faMartiniGlass;
const faSquareBinary = {
  prefix: 'far',
  iconName: 'square-binary',
  icon: [448, 512, [], "e69b", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 76c-24.3 0-44 19.7-44 44l0 40c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44l-32 0zm-4 44c0-2.2 1.8-4 4-4l32 0c2.2 0 4 1.8 4 4l0 40c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-40zm140-44c-11 0-20 9-20 20c0 9.7 6.9 17.7 16 19.6l0 68.4c0 11 9 20 20 20s20-9 20-20l0-88c0-11-9-20-20-20l-16 0zM132 296c0 9.7 6.9 17.7 16 19.6l0 68.4c0 11 9 20 20 20s20-9 20-20l0-88c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zm96 24l0 40c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-40c0-24.3-19.7-44-44-44l-32 0c-24.3 0-44 19.7-44 44zm44-4l32 0c2.2 0 4 1.8 4 4l0 40c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-40c0-2.2 1.8-4 4-4z"]
};
const faRotateLeft = {
  prefix: 'far',
  iconName: 'rotate-left',
  icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48C31.8 48 16 63.8 16 83.3L16 200c0 13.3 10.7 24 24 24l116.7 0c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L126.1 176 64 176l0-62.1z"]
};
const faRotateBack = faRotateLeft;
const faRotateBackward = faRotateLeft;
const faUndoAlt = faRotateLeft;
const faTableColumns = {
  prefix: 'far',
  iconName: 'table-columns',
  icon: [512, 512, ["columns"], "f0db", "M48 416l0-256 184 0 0 272L64 432c-8.8 0-16-7.2-16-16zm232 16l0-272 184 0 0 256c0 8.8-7.2 16-16 16l-168 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faColumns = faTableColumns;
const faSquareA = {
  prefix: 'far',
  iconName: 'square-a',
  icon: [448, 512, [], "e25f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c9.1 0 17.4 5.1 21.5 13.3l104 208c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 336l-130.3 0-17.4 34.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l104-208c4.1-8.1 12.4-13.3 21.5-13.3zm0 77.7L182.8 288l82.3 0L224 205.7z"]
};
const faTick = {
  prefix: 'far',
  iconName: 'tick',
  icon: [192, 512, [], "e32f", "M72 104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 1.9c0 1.4-.1 2.8-.4 4.3c0 0 0 0 0 0L96 252 72.4 110.1c-.2-1.4-.4-2.8-.4-4.3l0-1.9zm95 14c.7-4 1-8.1 1-12.1l0-1.9c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 1.9c0 4.1 .3 8.1 1 12.1L49.4 264.5C53.2 287.3 72.9 304 96 304s42.8-16.7 46.6-39.5L167 118z"]
};
const faLemon = {
  prefix: 'far',
  iconName: 'lemon',
  icon: [448, 512, [127819], "f094", "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"]
};
const faHeadSideMask = {
  prefix: 'far',
  iconName: 'head-side-mask',
  icon: [576, 512, [], "e063", "M80 224c0-8 .5-15.8 1.5-23.4L256 316.8l0 3.2 0 160c0 17.7 14.3 32 32 32l143.7 0c28.6 0 53.7-18.9 61.5-46.4L534.9 320l4.7-16.6c1.5-5.1 2.6-10.4 3.3-15.6c.7-3.1 1.1-6.2 1.1-9.5c0-.8 0-1.6-.1-2.3c0-1.3 .1-2.6 .1-3.9l-.5 0c-1.1-7.2-4.1-14.1-8.7-19.9l-18-22.5c-11.5-14.4-20.1-31.5-28-50.9c-3.7-8.9-7.1-18-10.6-27.5l-1-2.6c-3.9-10.3-7.9-21-12.4-31.6C435.6 48.3 367.5 0 288 0L256 0C132.3 0 32 100.3 32 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L96 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C94.8 304.8 80 266.2 80 224zm195.3 48L95.3 152C122.8 90.7 184.4 48 256 48l32 0c59.5 0 110.7 36.2 132.6 87.8c4 9.5 7.8 19.3 11.6 29.7l1 2.6s0 0 0 0c3.5 9.4 7.2 19.2 11.1 28.8c8.6 21.1 19.3 43.1 35 62.7l9.9 12.4L456 272l-.6 0L304 272l-28.7 0zM368 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm63.7 240L304 464l0-144 180.9 0-6.9 24L368 344c-8.8 0-16 7.2-16 16s7.2 16 16 16l100.9 0-9.1 32L368 408c-8.8 0-16 7.2-16 16s7.2 16 16 16l82.6 0-3.5 12.4c-2 6.9-8.2 11.6-15.4 11.6z"]
};
const faHandshake = {
  prefix: 'far',
  iconName: 'handshake',
  icon: [640, 512, [], "f2b5", "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faGem = {
  prefix: 'far',
  iconName: 'gem',
  icon: [512, 512, [128142], "f3a5", "M168.5 72L256 165l87.5-93-175 0zM383.9 99.1L311.5 176l129 0L383.9 99.1zm50 124.9L256 224 78.1 224 256 420.3 433.9 224zM71.5 176l129 0L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"]
};
const faDolly = {
  prefix: 'far',
  iconName: 'dolly',
  icon: [576, 512, ["dolly-box"], "f472", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l80.8 0c3.5 0 6.5 2.2 7.6 5.5l91.9 281.6C177.7 352.1 160 382 160 416c0 53 43 96 96 96s96-43 96-96c0-2.8-.1-5.5-.3-8.2L560 334.6c12.5-4.4 19.1-18.1 14.7-30.6s-18.1-19.1-30.6-14.7L335.8 362.5C318.5 336.9 289.2 320 256 320c-2 0-4 .1-6 .2L158 38.6C150.5 15.6 129 0 104.8 0L24 0zM256 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM457.4 117.3c-10.6-28.7-42.2-43.7-71.1-33.5L224.9 140.5l14.9 45.6 57.5-20.2 24.1 66.3c4.5 12.5 18.3 18.9 30.8 14.4s18.9-18.3 14.4-30.8L342.6 150l59.6-20.9c4.1-1.4 8.7 .7 10.2 4.8L467 282.5l45.3-15.9L457.4 117.3z"]
};
const faDollyBox = faDolly;
const faSmoking = {
  prefix: 'far',
  iconName: 'smoking',
  icon: [640, 512, [128684], "f48d", "M440 0c13.3 0 24 10.7 24 24l0 19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43l0-19c0-13.3 10.7-24 24-24zM616 288c-13.3 0-24-10.7-24-24l0-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8l0 19c0 13.3-10.7 24-24 24zm-56 88l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24zM224 464l208 0 0-64-208 0 0 64zM0 416c0-35.3 28.7-64 64-64l384 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L64 512c-35.3 0-64-28.7-64-64l0-32z"]
};
const faMinimize = {
  prefix: 'far',
  iconName: 'minimize',
  icon: [512, 512, ["compress-arrows-alt"], "f78c", "M7 7C-2.3 16.4-2.3 31.6 7 41l80 80L41.4 166.6c-6 6-9.4 14.1-9.4 22.6l0 2.7c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-2.7 0c-8.5 0-16.6 3.4-22.6 9.4L121 87 41 7C31.6-2.3 16.4-2.3 7 7zM505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L391 87 345.4 41.4c-6-6-14.1-9.4-22.6-9.4L320 32c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-2.7c0-8.5-3.4-16.6-9.4-22.6L425 121l80-80zM505 471l-80-80 45.7-45.7c6-6 9.4-14.1 9.4-22.6l0-2.7c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l2.7 0c8.5 0 16.6-3.4 22.6-9.4L391 425l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80 45.7 45.7c6 6 14.1 9.4 22.6 9.4l2.7 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L64 288c-17.7 0-32 14.3-32 32l0 2.7c0 8.5 3.4 16.6 9.4 22.6L87 391 7 471zM412.1 176L336 176l0-76.1L412.1 176zM336 412.1l0-76.1 76.1 0L336 412.1zM99.9 176L176 99.9l0 76.1-76.1 0zM176 412.1L99.9 336l76.1 0 0 76.1z"]
};
const faCompressArrowsAlt = faMinimize;
const faRefrigerator = {
  prefix: 'far',
  iconName: 'refrigerator',
  icon: [384, 512, [], "e026", "M288 48c26.5 0 48 21.5 48 48l0 64-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L48 160l0-64c0-26.5 21.5-48 48-48l192 0zM240 208l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 48 0 0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-240 192 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0z"]
};
const faMonument = {
  prefix: 'far',
  iconName: 'monument',
  icon: [384, 512, [], "f5a6", "M175 7c9.4-9.4 24.6-9.4 33.9 0l80 80c3.8 3.8 6.2 8.7 6.8 14l41.4 331-48.4 0L249.2 115.1 192 57.9l-57.2 57.2L95.2 432l-48.4 0L88.2 101c.7-5.3 3.1-10.2 6.8-14L175 7zM42.8 464l48.4 0 201.6 0 48.4 0 18.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0L64 512l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l18.8 0zM144 312c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24z"]
};
const faOctagonXmark = {
  prefix: 'far',
  iconName: 'octagon-xmark',
  icon: [512, 512, ["times-octagon", "xmark-octagon"], "f2f0", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faTimesOctagon = faOctagonXmark;
const faXmarkOctagon = faOctagonXmark;
const faAlignSlash = {
  prefix: 'far',
  iconName: 'align-slash',
  icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344l48.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-110.1 0L307.9 216 520 216c13.3 0 24-10.7 24-24s-10.7-24-24-24l-273.4 0L144.6 88 520 88c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 40c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24l32.3 0zM314.8 344l-60.9-48L120 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l194.8 0zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l357.2 0-60.9-48L120 424z"]
};
const faSnowplow = {
  prefix: 'far',
  iconName: 'snowplow',
  icon: [640, 512, [], "f7d2", "M298.8 48c3.2 0 6.1 1.9 7.4 4.9L371.8 208l-152.3 0-56.8-71-2.7-3.4L160 48l138.8 0zM429 220.3c-.4-1.2-.9-2.4-1.4-3.6L350.4 34.2C341.6 13.5 321.3 0 298.8 0L152 0c-22.1 0-40 17.9-40 40l0 88-16 0c-26.5 0-48 21.5-48 48l0 132.1C19 328.3 0 361.9 0 400c0 61.9 50.1 112 112 112l256 0c61.9 0 112-50.1 112-112c0-20.4-5.5-39.5-15-56l47 0 0 56c0 6 2.2 11.7 6.2 16.1l80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 390.7l0-141.4 73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1l0 56-80 0 0-57.5 0-6.5c0-4.2-1.1-8.2-3-11.7zm-45 68.8c-5.2-.7-10.6-1.1-16-1.1l-256 0c-5.4 0-10.8 .4-16 1.1L96 176l36.5 0 56.8 71c4.6 5.7 11.4 9 18.7 9l176 0 0 33.1zM112 336l256 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zm32 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faAnglesRight = {
  prefix: 'far',
  iconName: 'angles-right',
  icon: [512, 512, [187, "angle-double-right"], "f101", "M113 433L273 273c9.4-9.4 9.4-24.6 0-33.9L113 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L79 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm192 0L465 273c9.4-9.4 9.4-24.6 0-33.9L305 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l143 143L271 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
const faAngleDoubleRight = faAnglesRight;
const faTruckRampCouch = {
  prefix: 'far',
  iconName: 'truck-ramp-couch',
  icon: [640, 512, ["truck-couch"], "f4dd", "M352 88c0-48.6 39.4-88 88-88L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 48c-22.1 0-40 17.9-40 40l0 272.7 25.7-7 .4-.1c17.6-38.7 56.7-65.6 102-65.6c61.9 0 112 50.1 112 112s-50.1 112-112 112c-59.8 0-108.7-46.9-111.8-106L30.3 511.2c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5L352 373.8 352 88zM592 400a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM294.5 209.2c8.7-2.3 17.4-2.1 25.5 .2l0 125.5-38.7 10.4L126.7 386.6 64.9 403.2c-17.1 4.6-34.6-5.6-39.2-22.6L13.3 334.2c-6.9-25.6 8.3-51.9 33.9-58.8s51.9 8.3 58.8 33.9l4.1 15.5 154.5-41.4-4.1-15.5c-6.9-25.6 8.3-51.9 33.9-58.8zM8 252.8c-9.1-34.1 11.1-69.2 45.3-78.4l185.5-49.7c34.1-9.1 69.2 11.1 78.4 45.3l1.7 6.4c-10.6-1.6-21.6-1.1-32.6 1.9c-37.4 10-61.5 44.9-59.2 82.1L131.2 286c-16.6-33.4-54.9-51.5-92.3-41.5c-11 2.9-20.8 8-29.2 14.7L8 252.8z"]
};
const faTruckCouch = faTruckRampCouch;
const faCannabis = {
  prefix: 'far',
  iconName: 'cannabis',
  icon: [512, 512, [], "f55f", "M275.9 10.6C271.5 4 264 0 256 0s-15.5 4-19.9 10.6c-16.1 24.1-36.5 67.2-49.2 115.1c-6.8 25.8-11.7 54.2-12 82.5c-15-10.3-30.7-19-45.9-26.4c-34.5-16.7-68.6-27-92.3-31.7c-7.9-1.6-16 .9-21.7 6.6s-8.1 13.8-6.5 21.7c6.9 34.4 26.5 93.6 62.3 143.2c-21.3 8.1-39.3 17.5-50.5 23.7C12.7 349.5 8 357.6 8 366.3s4.7 16.8 12.4 21c14.6 8.1 40.5 21.5 70.1 30.4c17.6 5.3 37.8 9.5 58.5 9.3l-5.8 23.2c-2.3 9.1 .9 18.7 8.2 24.5s17.3 7 25.7 2.8L232 450.2l0 37.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-37.8 54.9 27.3c8.4 4.2 18.4 3.1 25.7-2.8s10.5-15.5 8.2-24.5L363.1 427c20.6 .2 40.8-4 58.5-9.3c29.6-8.9 55.6-22.3 70.1-30.4c7.6-4.2 12.4-12.3 12.4-21s-4.7-16.8-12.4-21c-11.1-6.2-29.1-15.6-50.5-23.7C477 272.2 496.6 213 503.5 178.4c1.6-7.9-.9-16-6.5-21.7s-13.8-8.2-21.7-6.6c-23.7 4.7-57.7 15-92.3 31.7c-15.3 7.4-30.9 16.1-45.9 26.4c-.3-28.3-5.2-56.7-12-82.5c-12.6-47.9-33-91.1-49.2-115.1zM280 396.6l0-52.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 52.6-29.6 14.7 2-7.8c2.2-8.6-.6-17.6-7.1-23.6s-15.8-7.8-24.1-4.9c-19 6.7-43.3 4.3-68.7-3.3c-5.5-1.6-10.8-3.5-16-5.4c9.3-3.5 19.2-6.7 29.3-9c8.5-1.9 15.2-8.3 17.7-16.6s.3-17.3-5.8-23.5c-30.1-31-50.9-73.8-63.1-109.2c13.1 4.5 27.3 10.1 41.7 17.1C139 240 168.8 260 189.6 285c7.4 9 20.2 11.3 30.3 5.5s14.7-17.9 10.8-28.9c-12.4-34.8-8.9-79.8 2.6-123.7c6.2-23.5 14.4-45.4 22.7-63.6c8.3 18.2 16.5 40.2 22.7 63.6c11.6 43.8 15 88.8 2.6 123.7c-3.9 11 .6 23.1 10.8 28.9s22.9 3.4 30.3-5.5c20.8-25.1 50.6-45 81.5-59.9c14.3-6.9 28.6-12.6 41.7-17.1c-11.1 32-29.2 70.2-55 100.3c-2.6 3.1-5.3 6-8.1 8.9c-6 6.2-8.2 15.2-5.8 23.5s9.2 14.6 17.7 16.6c10.1 2.3 20 5.5 29.3 9c-5.2 2-10.5 3.8-16 5.4c-25.4 7.7-49.7 10-68.7 3.3c-8.3-2.9-17.6-1.1-24.1 4.9s-9.3 15-7.1 23.6l2 7.8L280 396.6z"]
};
const faCirclePlay = {
  prefix: 'far',
  iconName: 'circle-play',
  icon: [512, 512, [61469, "play-circle"], "f144", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"]
};
const faPlayCircle = faCirclePlay;
const faArrowUpRightAndArrowDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'arrow-up-right-and-arrow-down-left-from-center',
  icon: [512, 512, [], "e0a0", "M295 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L344 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L295 183zM217 329c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 430.1 48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 488c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0L217 329z"]
};
const faLocationArrowUp = {
  prefix: 'far',
  iconName: 'location-arrow-up',
  icon: [448, 512, [], "e63a", "M224 98.5L87.2 420l122.1-95c8.7-6.7 20.8-6.7 29.5 0l122.1 95L224 98.5zM190.8 54c5.7-13.3 18.7-22 33.2-22s27.5 8.6 33.2 22L412.5 418.9c2.3 5.4 3.5 11.3 3.5 17.2l0 2.1c0 23.1-18.7 41.9-41.9 41.9c-9.3 0-18.4-3.1-25.7-8.8L224 374.4 99.6 471.2c-7.3 5.7-16.4 8.8-25.7 8.8C50.7 480 32 461.3 32 438.1l0-2.1c0-5.9 1.2-11.8 3.5-17.2L190.8 54z"]
};
const faTablets = {
  prefix: 'far',
  iconName: 'tablets',
  icon: [640, 512, [], "f490", "M608.8 254.9c-4.7 6.4-9.9 12.5-15.7 18.2s-11.9 11-18.2 15.7c-62.6 46.2-151.3 41-208-15.7s-62-145.4-15.7-208c4.7-6.4 9.9-12.5 15.7-18.2s11.9-11 18.2-15.7c62.6-46.2 151.3-41 208 15.7s62 145.4 15.7 208zM559.2 80.8c-37.9-37.9-96.2-43-139.6-15.1L574.3 220.4c27.8-43.4 22.8-101.7-15.1-139.6zM540.4 254.3L385.7 99.6c-27.8 43.4-22.8 101.7 15.1 139.6s96.2 43 139.6 15.1zM318.2 328c1.2 7.8 1.8 15.8 1.8 24s-.6 16.2-1.8 24c-11.6 77-78 136-158.2 136S13.4 453 1.8 376C.6 368.2 0 360.2 0 352s.6-16.2 1.8-24c11.6-77 78-136 158.2-136s146.6 59 158.2 136zM160 240c-53.6 0-98.4 37.7-109.4 88l218.8 0c-11-50.3-55.8-88-109.4-88zm0 224c53.6 0 98.4-37.7 109.4-88L50.6 376c11 50.3 55.8 88 109.4 88z"]
};
const fa360Degrees = {
  prefix: 'far',
  iconName: '360-degrees',
  icon: [640, 512, [], "e2dc", "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l83.2 0L36 218.7c-4.9 7.4-5.4 16.8-1.2 24.6S47.1 256 56 256l32 0c30.9 0 56 25.1 56 56l0 40c0 26.5-21.5 48-48 48l-1.5 0c-16 0-31-8-39.9-21.4L44 362.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l10.6 15.9C32.5 432 62.4 448 94.5 448l1.5 0c53 0 96-43 96-96l0-40c0-53.3-40-97.2-91.6-103.3L172 101.3c4.9-7.4 5.4-16.8 1.2-24.6S160.9 64 152 64L24 64zm440 80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224zM576 368l0-224c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80s80-35.8 80-80zM272 160c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96l0 128 0 .2 0 79.8c0 44.2 35.8 80 80 80s80-35.8 80-80l0-96c0-44.2-35.8-80-80-80c-11.4 0-22.2 2.4-32 6.7l0-38.7zm32 80c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32z"]
};
const faEthernet = {
  prefix: 'far',
  iconName: 'ethernet',
  icon: [512, 512, [], "f796", "M128 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-80 0-96 0-96 0-96 0-80 0c-17.7 0-32-14.3-32-32L0 224c0-17.7 14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32l32 0 0-32zm48 16l0 40c0 13.3-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24l-40 0 0 160 40 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 40 0 0-160-40 0c-13.3 0-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24l0-40-160 0z"]
};
const faEuroSign = {
  prefix: 'far',
  iconName: 'euro-sign',
  icon: [320, 512, [8364, "eur", "euro"], "f153", "M48.6 240c-.4 5.3-.6 10.6-.6 16s.2 10.7 .6 16L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l33.3 0C84.8 412.5 170.5 480 272 480l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0c-74.6 0-138.4-46.4-164-112l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96.7 272c-.5-5.3-.7-10.6-.7-16s.2-10.7 .7-16L264 240c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c25.6-65.6 89.4-112 164-112l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0C170.5 32 84.8 99.5 57.3 192L24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.6 0z"]
};
const faEur = faEuroSign;
const faEuro = faEuroSign;
const faChair = {
  prefix: 'far',
  iconName: 'chair',
  icon: [448, 512, [129681], "f6c0", "M248 48l-48 0 0 176-48 0 0-165.3c-23.9 13.8-40 39.7-40 69.3l0 96-48 0 0-96C64 57.3 121.3 0 192 0l64 0c70.7 0 128 57.3 128 128l0 96-48 0 0-96c0-29.6-16.1-55.5-40-69.3L296 224l-48 0 0-176zM67.1 304l-18 48 349.8 0-18-48L67.1 304zM22.1 287.1c7-18.7 24.9-31.1 44.9-31.1l313.8 0c20 0 37.9 12.4 44.9 31.1l19.2 51.3c1.9 5.1 2.9 10.5 2.9 16c0 20.4-13.5 37.7-32 43.5l0 90c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88L80 400l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-90c-18.5-5.8-32-23.1-32-43.5c0-5.5 1-10.9 2.9-16l19.2-51.3z"]
};
const faCircleCheck = {
  prefix: 'far',
  iconName: 'circle-check',
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
const faCheckCircle = faCircleCheck;
const faSquareDashedCirclePlus = {
  prefix: 'far',
  iconName: 'square-dashed-circle-plus',
  icon: [576, 512, [], "e5c2", "M104 32L88 32C39.4 32 0 71.4 0 120l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1 17.9-40 40-40l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zM0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80zm24 56c-13.3 0-24 10.7-24 24l0 16c0 48.6 39.4 88 88 88l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-22.1 0-40-17.9-40-40l0-16c0-13.3-10.7-24-24-24zM424 192c13.3 0 24-10.7 24-24l0-48c0-48.6-39.4-88-88-88l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c22.1 0 40 17.9 40 40l0 48c0 13.3 10.7 24 24 24zM256 456c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24zm8-376c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faHandHoldingCircleDollar = {
  prefix: 'far',
  iconName: 'hand-holding-circle-dollar',
  icon: [576, 512, [], "e621", "M128 144a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faMoneySimpleFromBracket = {
  prefix: 'far',
  iconName: 'money-simple-from-bracket',
  icon: [640, 512, [], "e313", "M48 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L552 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88zm416 8l48 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352 48 0 0 352c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-352zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z"]
};
const faBat = {
  prefix: 'far',
  iconName: 'bat',
  icon: [576, 512, [], "f6b5", "M356.3 187.3c-13.3-6.8-22.7-19.3-25.4-33.9l-6.5-34.9c-11.1 6.2-23.6 9.5-36.4 9.5s-25.3-3.3-36.4-9.5l-6.5 34.9c-2.7 14.6-12.1 27.2-25.4 33.9s-28.9 7-42.4 .6l-68.7-32.7C70.1 202.4 48.7 261.3 48 322.3l13.3-6.6c29.9-15 66.3-4.4 83.5 24.3l8.7 14.6 7.6-7.6c27.3-27.3 72.4-24.4 96 6.2L288 393.3l30.8-40.1c23.6-30.6 68.7-33.6 96-6.2l7.6 7.6 8.7-14.6c17.2-28.7 53.6-39.3 83.5-24.3l13.3 6.6c-.6-61-22-120-60.6-167.2l-68.7 32.7c-13.5 6.4-29.1 6.2-42.4-.6zM576 346.3s0 0 0 0l0 2 0 28.5c0 10.6-11.2 17.5-20.6 12.8l-25.5-12.8L528 376s0 0 0 0l-34.7-17.4c-7.5-3.7-16.6-1.1-20.9 6.1l-29.8 49.7c-5.4 8.9-17.7 10.4-25 3.1l-36.6-36.6c-6.8-6.8-18.1-6.1-24 1.6l-56.2 73.1c-6.4 8.3-19 8.3-25.4 0l-56.2-73.1c-5.9-7.7-17.2-8.4-24-1.6l-36.6 36.6c-7.4 7.4-19.7 5.8-25-3.1l-29.8-49.7c-4.3-7.2-13.4-9.8-20.9-6.1L48 376s0 0 0 0l-1.8 .9L20.7 389.7C11.2 394.4 0 387.5 0 376.9l0-28.5 0-2s0 0 0 0l0-21.1C0 249.6 27.1 176.4 76.3 119c11.6-13.6 30.9-17.7 47.1-10l29.7 14.1 44.8 21.3 9.2-48.8 6.8-36.2c1.3-6.7 7.1-11.5 13.9-11.5c2.8 0 5.5 .8 7.8 2.4l37.8 25.2c4.3 2.9 9.4 4.4 14.7 4.4s10.3-1.5 14.7-4.4l37.8-25.2c2.3-1.5 5-2.4 7.8-2.4c6.8 0 12.6 4.8 13.9 11.5l6.8 36.2 9.2 48.8 44.8-21.3L452.6 109c16.2-7.7 35.5-3.6 47.1 10C548.9 176.4 576 249.6 576 325.2l0 21.1z"]
};
const faCircleStop = {
  prefix: 'far',
  iconName: 'circle-stop',
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"]
};
const faStopCircle = faCircleStop;
const faHeadSideHeadphones = {
  prefix: 'far',
  iconName: 'head-side-headphones',
  icon: [512, 512, [], "f8c2", "M184 52.6C106.1 70.7 48 140.5 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4l0 89.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0l24 0c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6l-.4 0 0 48c0 35.3-28.7 64-64 64l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24l88 0c8.8 0 16-7.2 16-16l0-72c0-13.3 10.7-24 24-24l24.4 0c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48l-16 0 0 50.6c50.3 11 88 55.8 88 109.4c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-53.6 37.7-98.4 88-109.4l0-46zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faPhoneRotary = {
  prefix: 'far',
  iconName: 'phone-rotary',
  icon: [512, 512, [9742], "f8d3", "M0 176l0-34.7c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1l0 34.7c0 17.7-14.3 32-32 32l-42.3 0c-13.1 0-24.9-8-29.7-20.1l-19.4-48.6c-2.9-7.3-8.4-13.2-15.7-16c-18.6-7-59.5-19.3-116.8-19.3s-98.2 12.3-116.8 19.3c-7.3 2.8-12.8 8.7-15.7 16L104 187.9C99.2 200 87.4 208 74.3 208L32 208c-17.7 0-32-14.3-32-32zM80 401l0 31 352 0 0-31c0-2.8-.7-5.5-2.1-7.9l-101.1-177c-2.8-5-8.2-8.1-13.9-8.1l-117.7 0c-5.7 0-11 3.1-13.9 8.1L82.1 393.1c-1.4 2.4-2.1 5.2-2.1 7.9zm61.6-208.7C153 172.3 174.2 160 197.1 160l117.7 0c23 0 44.2 12.3 55.6 32.2l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8l0 31c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-31c0-11.1 2.9-22.1 8.4-31.8l101.1-177zM256 256a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faArrowUpToBracket = {
  prefix: 'far',
  iconName: 'arrow-up-to-bracket',
  icon: [448, 512, [], "e66a", "M369 295L241 167c-9.4-9.4-24.6-9.4-33.9 0L79 295c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-246.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9zM48 168l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faCompassDrafting = {
  prefix: 'far',
  iconName: 'compass-drafting',
  icon: [512, 512, ["drafting-compass"], "f568", "M304 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-19.6 91.7c-9 2.8-18.5 4.3-28.4 4.3s-19.4-1.5-28.4-4.3L158.1 306.4C187.9 320.3 221 328 256 328c85.8 0 160.8-46.6 201-116c6.6-11.5 21.3-15.4 32.8-8.8s15.4 21.3 8.8 32.8C450.2 319.6 359.7 376 256 376c-43.8 0-85.3-10.1-122.2-28L44.7 500.1c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9L92.6 323.4C60.4 300.2 33.4 270.4 13.5 236c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c15.8 27.2 36.9 51 61.9 69.7l69.8-119.2C170.2 145.2 160 121.8 160 96c0-53 43-96 96-96s96 43 96 96c0 25.8-10.2 49.2-26.7 66.5l53.5 91.4c-12.6 9.8-26.4 18.1-41.1 24.7l-53.2-90.9zM508.7 475.9c6.7 11.4 2.9 26.1-8.6 32.8s-26.1 2.9-32.8-8.6L394.4 375.7c14.4-7.1 28.2-15.4 41.2-24.6l73 124.8z"]
};
const faDraftingCompass = faCompassDrafting;
const faPlateWheat = {
  prefix: 'far',
  iconName: 'plate-wheat',
  icon: [512, 512, [], "e55a", "M176 32c-8.8 0-16 7.2-16 16l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80zM56 64C42.7 64 32 74.7 32 88s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 64zM24 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 136zm8 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM272 48l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 32c-8.8 0-16 7.2-16 16l0 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16l0-16c0-44.2-35.8-80-80-80zm80 160c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16zM352 176c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80l0-16zM130 423.7c-7.3-13.2-20.4-22.2-35.3-24.3C76 396.8 60.3 384.6 52.8 368l406.4 0c-7.5 16.6-23.2 28.8-41.9 31.5c-14.9 2.1-28 11.1-35.3 24.3c-2.8 5-8.1 8.3-14 8.3l-224 0c-6 0-11.2-3.2-14-8.3zM25.6 320C11.5 320 0 331.5 0 345.6C0 397.3 38.3 440 88 447c10.9 19.7 31.9 33 56 33l224 0c24.1 0 45.1-13.3 56-33c49.7-7 88-49.7 88-101.4c0-14.1-11.5-25.6-25.6-25.6L25.6 320z"]
};
const faCalendarCircleMinus = {
  prefix: 'far',
  iconName: 'calendar-circle-minus',
  icon: [576, 512, [], "e46f", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
const faChopsticks = {
  prefix: 'far',
  iconName: 'chopsticks',
  icon: [640, 512, [], "e3f7", "M144.9 332.9L332.9 54.7c3.5-4.3 8.4-6.7 13.6-6.7c9.2 0 18.1 8 18.1 19.5c0 4.6-1.4 8.7-3.8 11.9L144.9 332.9zM346.5 0c-21.4 0-40.3 10.4-52.2 26.1l-.4 .5-.4 .6L7.4 450.7c-12 16.4-9.2 39.8 6.8 52.8C30.8 517 54.7 514 67.7 497.6L397.9 109.9l.4-.5 .4-.5c8.7-11.5 13.9-25.9 13.9-41.4C412.6 31 383.7 0 346.5 0zm-37 356.7L561.1 116.2c3.2-2.6 7.3-4.2 11.9-4.2c10.4 0 18.9 8.4 18.9 18.9c0 5.5-2.4 10.5-6.2 14L309.5 356.7zM573 64c-16.6 0-31.8 6.1-43.5 16.1l-.5 .4-.5 .4-381 364.2c-15.5 13.8-17.1 37.6-3.5 53.5s37.3 17.9 53.4 4.7L615.5 182.4l.5-.4 .5-.4c14.3-12.2 23.3-30.4 23.3-50.8C639.9 93.9 609.9 64 573 64z"]
};
const faCarWrench = {
  prefix: 'far',
  iconName: 'car-wrench',
  icon: [512, 512, ["car-mechanic"], "f5e3", "M468.9 104L456 104l-.5 0c-.7 0-1.4-.1-2.1-.1C441.3 102.5 432 92.4 432 80s9.3-22.5 21.3-23.9c.7-.1 1.4-.1 2.1-.1l.5 0 12.9 0 17.6 0c10.8 0 18.4-10.6 12.5-19.6c-3.6-5.5-7.8-10.5-12.5-14.9c-4.2-3.9-8.8-7.4-13.8-10.3C470.8 10 468.9 9 466.9 8C456.4 2.9 444.5 0 432 0c-29.1 0-54.5 15.5-68.5 38.7c-3.3 5.4-8.9 9.3-15.3 9.3L163.8 48c-6.4 0-12-3.8-15.3-9.3C134.5 15.5 109.1 0 80 0C67.5 0 55.6 2.9 45.1 8c-2 1-3.9 2-5.8 3.1c-5 2.9-9.6 6.4-13.8 10.3c-4.7 4.4-9 9.4-12.5 14.9C7 45.4 14.7 56 25.5 56l17.6 0L56 56l.5 0c.7 0 1.4 .1 2.1 .1C70.7 57.5 80 67.6 80 80s-9.3 22.5-21.3 23.9c-.7 .1-1.4 .1-2.1 .1l-.5 0-12.9 0-17.6 0C14.7 104 7 114.6 12.9 123.6c3.6 5.5 7.8 10.5 12.5 14.9c4.2 3.9 8.8 7.4 13.8 10.3c1.9 1.1 3.8 2.2 5.8 3.1c10.6 5.1 22.4 8 34.9 8c29.1 0 54.5-15.5 68.5-38.7c3.3-5.4 8.9-9.3 15.3-9.3l184.4 0c6.4 0 12 3.8 15.3 9.3c14 23.2 39.5 38.7 68.5 38.7c12.5 0 24.4-2.9 34.9-8c2-1 3.9-2 5.8-3.1c5-2.9 9.6-6.4 13.8-10.3c4.7-4.4 9-9.4 12.5-14.9c5.9-9-1.7-19.6-12.5-19.6l-17.6 0zM185.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L365.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM368 320c26.5 0 48 21.5 48 48l0 32L96 400l0-32c0-26.5 21.5-48 48-48l224 0zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCarMechanic = faCarWrench;
const faIcicles = {
  prefix: 'far',
  iconName: 'icicles',
  icon: [512, 512, [], "f7ad", "M5.2 9.1C9.7 3.4 16.7 0 24 0L488 0c6.9 0 13.5 3 18.1 8.2s6.6 12.2 5.7 19L448.9 483c-2.3 16.6-16.5 29-33.2 29c-15.8 0-29.4-11-32.8-26.4L332.6 256.5l-11.2 38.2c-4.4 15-18.1 25.2-33.7 25.2c-14.5 0-27.6-9-32.8-22.5l-9.4-24.6-20.2 84.9C221.5 373.1 207.8 384 192 384s-29.5-10.9-33.2-26.2l-20.2-84.9-9.5 24.8C123.9 311.1 111 320 96.6 320c-16.2 0-30.2-11.1-33.9-26.8L.6 29.5C-1 22.4 .6 14.8 5.2 9.1zM54.3 48L99.6 240.6l22-57.2c3.8-9.8 13.5-16 24-15.3s19.3 8.2 21.7 18.4L192 290l24.7-103.5c2.4-10.2 11.3-17.7 21.7-18.4s20.2 5.5 24 15.3L286 244.8 313 153.2c3.1-10.5 12.9-17.6 23.9-17.2s20.3 8.1 22.6 18.8l53 241.4L460.5 48 54.3 48z"]
};
const faPersonShelter = {
  prefix: 'far',
  iconName: 'person-shelter',
  icon: [512, 512, [], "e54f", "M268.1 3.3c-7.5-4.4-16.8-4.4-24.3 0l-232 136C4.5 143.6 0 151.5 0 160L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-314.2L256 51.8 464 173.8 464 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-328c0-8.5-4.5-16.4-11.9-20.7l-232-136zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-16 64.5c2-.3 4.1-.5 6.2-.5l19.5 0c2.1 0 4.2 .2 6.2 .5l0 95.5-32 0 0-95.5zM240 416l32 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-159.7 18.9 35c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3l-19.5 0c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l18.9-35L192 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72z"]
};
const faNeuter = {
  prefix: 'far',
  iconName: 'neuter',
  icon: [384, 512, [9906], "f22c", "M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4L168 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-137.6z"]
};
const faIdBadge = {
  prefix: 'far',
  iconName: 'id-badge',
  icon: [384, 512, [], "f2c1", "M256 48l0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16l-64 0zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 320l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16L96 416c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faKazoo = {
  prefix: 'far',
  iconName: 'kazoo',
  icon: [640, 512, [], "f8c7", "M560 256c0 29.6-8.9 57.1-24.2 80l40.2 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-40.2 0c15.3 22.9 24.2 50.4 24.2 80zm16 128l-94 0c-19.8 10.2-42.2 16-66 16s-46.3-5.8-66-16l-108.2 0c-11.8 0-23.4-1.6-34.7-4.8c-39.3-11.1-136.7-38.7-184-52.5C9.4 322.7 0 310.2 0 296l0-80c0-14.2 9.4-26.7 23-30.7c47.3-13.8 144.7-41.4 184-52.5c11.3-3.2 23-4.8 34.7-4.8L350 128c19.8-10.2 42.2-16 66-16s46.3 5.8 66 16l94 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64zM241.7 336l54.5 0c-15.3-22.9-24.2-50.4-24.2-80s8.9-57.1 24.2-80l-54.5 0c-7.4 0-14.6 1-21.7 3C183.7 189.3 97.9 213.6 48 228l0 56c49.9 14.5 135.7 38.7 172.1 49c7 2 14.3 3 21.7 3zM416 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM398.1 209.9L416 227.7l17.9-17.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L444.3 256l17.9 17.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L416 284.3l-17.9 17.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L387.7 256l-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
const faMarker = {
  prefix: 'far',
  iconName: 'marker',
  icon: [512, 512, [], "f5a1", "M336 113.9L225.9 224 288 286.1 447 127c17.1-17.1 17.1-44.9 0-62.1s-44.9-17.1-62.1 0l-15 15L336 113.9zm-144 144l-58.5 58.5c-38.8 38.8-66 87.5-78.6 140.7c53.2-12.7 101.9-39.9 140.7-78.6L254.1 320 192 257.9zM232.4 23.7c27.9-18.4 65.9-15.4 90.5 9.2c0 0 0 0 0 0L336 46.1l15-15s0 0 0 0C386.9-4.8 445.1-4.8 481 31c35.9 35.9 35.9 94.1 0 129.9L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8l80-80L199 183l69.1-69.1 6.2-6.2L285.1 97l17-17L289 66.9s0 0 0 0c-9.4-9.4-24.6-9.3-33.9 0L169 153c-4.1 4.1-9.3 6.4-14.7 6.9c-6.9 .7-14-1.7-19.3-6.9c-9.4-9.4-9.4-24.6 0-33.9L221.1 33c3.5-3.5 7.3-6.6 11.3-9.2z"]
};
const faBinBottles = {
  prefix: 'far',
  iconName: 'bin-bottles',
  icon: [640, 512, [], "e5f5", "M152 0l80 0c13.3 0 24 10.7 24 24l0 8c8.8 0 16 7.2 16 16s-7.2 16-16 16L128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16l0-8c0-13.3 10.7-24 24-24zM32 192c0-53 43-96 96-96l128 0c24.9 0 47.6 9.5 64.6 25c1.1 1 2.2 2 3.2 3.1C341.3 141.5 352 165.5 352 192l32 0c0-40.7-19-76.9-48.6-100.4c5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c5.3-2.5 10.8-4.4 16.4-5.7l0-42.1c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 42.1c5.6 1.3 11.1 3.2 16.4 5.7L541.2 78c21 9.9 34.4 31 34.4 54.2c0 12.3-3.7 23.8-10.1 33.3c5 7.8 8.4 16.9 9.6 26.5l32.9 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0L584.3 441.3c-4.7 40.3-38.9 70.7-79.5 70.7l-369.7 0c-40.6 0-74.7-30.4-79.5-70.7L32 240l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0zm71.4 243.7c1.9 16.1 15.6 28.3 31.8 28.3l369.7 0c16.2 0 29.9-12.1 31.8-28.3l23-195.7L80.3 240l23 195.7z"]
};
const faFaceLaughBeam = {
  prefix: 'far',
  iconName: 'face-laugh-beam',
  icon: [512, 512, [128513, "laugh-beam"], "f59a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faLaughBeam = faFaceLaughBeam;
const faSquareArrowDownLeft = {
  prefix: 'far',
  iconName: 'square-arrow-down-left',
  icon: [448, 512, [], "e261", "M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24l-94.1 0L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135L160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24l152 0z"]
};
const faBatteryBolt = {
  prefix: 'far',
  iconName: 'battery-bolt',
  icon: [576, 512, [], "f376", "M80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l92.2 0c-11.6-13-15.3-31.5-9.5-48L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l159.2 0 60-48L80 96zM464 368l-159.2 0-60 48L464 416c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80l-92.2 0c11.6 13 15.3 31.5 9.5 48l82.7 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32zM346.1 115.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L193.7 376.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
const faTreeLarge = {
  prefix: 'far',
  iconName: 'tree-large',
  icon: [448, 512, [], "f7dd", "M224 0c7.4 0 14.4 3.4 18.9 9.3L381.2 186.9c5.6 7.2 6.6 17 2.6 25.3s-12.4 13.5-21.6 13.5l-16.5 0 67.2 100.6c4.9 7.4 5.4 16.8 1.2 24.6s-12.3 12.7-21.2 12.7l-24 0 74.9 111.1c5 7.4 5.5 16.9 1.3 24.7S432.9 512 424 512L24 512c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.3-24.7L79 363.5l-24 0c-8.9 0-17-4.9-21.2-12.7s-3.7-17.3 1.2-24.6l67.2-100.6-16.5 0c-9.2 0-17.5-5.2-21.6-13.5s-3-18 2.6-25.3L205.1 9.3C209.6 3.4 216.6 0 224 0zM134.9 177.6l12.3 0c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.2 24.6L99.9 315.5l24.2 0c8.9 0 17 4.9 21.2 12.7s3.7 17.3-1.3 24.7L69.1 464l309.7 0L303.9 352.9c-5-7.4-5.5-16.9-1.3-24.7s12.3-12.7 21.2-12.7l24.2 0L280.8 214.9c-4.9-7.4-5.4-16.8-1.2-24.6s12.3-12.7 21.2-12.7l12.3 0L224 63.1 134.9 177.6z"]
};
const faHelicopterSymbol = {
  prefix: 'far',
  iconName: 'helicopter-symbol',
  icon: [512, 512, [], "e502", "M461.6 224l48.5 0C495.6 108.2 403.8 16.4 288 2l0 48.5C377.3 64.2 447.8 134.7 461.6 224zM510 288l-48.5 0C447.8 377.3 377.3 447.8 288 461.6l0 48.5c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-48.5C134.7 447.8 64.2 377.3 50.4 288L2 288zm0-64l48.5 0C64.2 134.7 134.7 64.2 224 50.4L224 2C108.2 16.4 16.4 108.2 2 224zm190-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 128 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-128 0 0-72z"]
};
const faAperture = {
  prefix: 'far',
  iconName: 'aperture',
  icon: [512, 512, [], "e2df", "M256 464l67-116 13.8-23.8c0-.1 .1-.1 .1-.2l11.5-20 56.3 97.5C366.9 440.1 314.2 464 256 464zM163.6 208l-56.3-97.5C145.1 71.9 197.8 48 256 48L189 164l-13.9 24-11.5 20zm87.8-56l56.3-97.5c54.8 14 100.9 49.8 128.5 97.5l-134 0-27.5 0-.3 0-23.1 0zm104.1 68.3c-.1-.1-.1-.2-.2-.3l-11.5-20 112.6 0c5 17.8 7.6 36.6 7.6 56c0 37.9-10.1 73.4-27.8 104l-67-116-13.7-23.7zM48 256c0-37.9 10.1-73.4 27.8-104l67 116 25.4 44L55.6 312c-5-17.8-7.6-36.6-7.6-56zM204.3 457.5c-54.8-14-100.9-49.8-128.5-97.5l134 0 50.8 0-56.3 97.5zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216.7 212c4.3-7.4 12.1-11.9 20.6-12l37.3 0c8.5 .1 16.3 4.6 20.5 11.8l18.7 32.3c4.2 7.4 4.2 16.4 0 23.8l-.1 .1-18.5 32 0 .1c-4.3 7.4-12.2 11.9-20.7 11.9l-36.9 0c-8.6 0-16.5-4.6-20.8-12l-18.5-32c-4.3-7.4-4.3-16.6 0-24l18.5-32z"]
};
const faUniversalAccess = {
  prefix: 'far',
  iconName: 'universal-access',
  icon: [512, 512, [], "f29a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1l11.9 5.1c26.1 11.2 54.2 17 82.7 17s56.5-5.8 82.7-17l11.9-5.1c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-11.9 5.1c-17.3 7.4-35.2 12.9-53.6 16.3l0 50.1c0 4.3 .7 8.6 2.1 12.6l28.7 86.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2l-24.4-73.2c-1.3-3.8-4.8-6.4-8.8-6.4s-7.6 2.6-8.8 6.4l-24.4 73.2c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l28.7-86.1c1.4-4.1 2.1-8.3 2.1-12.6l0-50.1c-18.4-3.5-36.3-8.9-53.6-16.3l-11.9-5.1c-12.2-5.2-17.8-19.3-12.6-31.5s19.3-17.8 31.5-12.6zM256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faGearComplex = {
  prefix: 'far',
  iconName: 'gear-complex',
  icon: [512, 512, [], "e5e9", "M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm48 96a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM234.9 0c-22.2 0-41.5 15.2-46.7 36.7L180 71l-1.1 .4L148.9 53c-18.9-11.6-43.3-8.7-59 7L60.1 89.9c-15.7 15.7-18.6 40.1-7 59l18.4 30L71 180l-34.2 8.3C15.2 193.4 0 212.7 0 234.9l0 42.2c0 22.2 15.2 41.5 36.7 46.7L71 332l.4 1.1L53 363.1c-11.6 18.9-8.7 43.3 7 59l29.8 29.8c15.7 15.7 40.1 18.6 59 7l30-18.4 1.1 .4 8.3 34.2c5.2 21.6 24.5 36.7 46.7 36.7l42.2 0c22.2 0 41.5-15.2 46.7-36.7L332 441l1.1-.4 30 18.4c18.9 11.6 43.3 8.7 59-7l29.8-29.8c15.7-15.7 18.6-40.1 7-59l-18.4-30 .4-1.1 34.2-8.3c21.6-5.2 36.7-24.5 36.7-46.7l0-42.2c0-22.2-15.2-41.5-36.7-46.7L441 180l-.4-1.1 18.4-30c11.6-18.9 8.7-43.3-7-59L422.1 60.1c-15.7-15.7-40.1-18.6-59-7l-30 18.4L332 71l-8.3-34.2C318.6 15.2 299.3 0 277.1 0L234.9 0zm0 48l42.2 0 11.3 46.6c1.9 8 7.9 14.5 15.7 17.1c6.8 2.3 13.5 5 19.9 8.2c7.4 3.7 16.2 3.3 23.3-1l40.9-25L418 123.8l-25 40.9c-4.3 7.1-4.7 15.9-1 23.3c3.2 6.4 6 13 8.2 19.9c2.6 7.9 9.1 13.8 17.1 15.7L464 234.9l0 42.2-46.6 11.3c-8 1.9-14.5 7.9-17.1 15.7c-2.3 6.8-5 13.5-8.2 19.9c-3.7 7.4-3.3 16.2 1 23.3l25 40.9L388.2 418l-40.9-25c-7.1-4.3-15.9-4.7-23.3-1c-6.4 3.2-13 6-19.9 8.2c-7.9 2.6-13.8 9.1-15.7 17.1L277.1 464l-42.2 0-11.3-46.6c-1.9-8-7.9-14.5-15.7-17.1c-6.8-2.3-13.5-5-19.9-8.2c-7.4-3.7-16.2-3.3-23.3 1l-40.9 25L94 388.2l25-40.9c4.3-7.1 4.7-15.9 1-23.3c-3.2-6.4-6-13-8.2-19.9c-2.6-7.9-9.1-13.8-17.1-15.7L48 277.1l0-42.2 46.6-11.3c8-1.9 14.5-7.9 17.1-15.7c2.3-6.8 5-13.5 8.2-19.9c3.7-7.4 3.3-16.2-1-23.3L94 123.8 123.8 94l40.9 25c7.1 4.3 15.9 4.7 23.3 1c6.4-3.2 13-6 19.9-8.2c7.9-2.6 13.8-9.1 15.7-17.1L234.9 48z"]
};
const faFileMagnifyingGlass = {
  prefix: 'far',
  iconName: 'file-magnifying-glass',
  icon: [384, 512, ["file-search"], "f865", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM272 304c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faFileSearch = faFileMagnifyingGlass;
const faUpRight = {
  prefix: 'far',
  iconName: 'up-right',
  icon: [384, 512, [], "e2be", "M320 128l0 193.4c0 1.7-.8 3.2-2.1 4.2c-2.1 1.6-5 1.4-6.9-.5L257 271c-9.4-9.4-24.6-9.4-33.9 0L98.3 395.7c-2.7 2.7-6.5 4.3-10.3 4.3s-7.6-1.5-10.3-4.3L52.3 370.3c-2.7-2.7-4.3-6.5-4.3-10.3s1.5-7.6 4.3-10.3L177 225c9.4-9.4 9.4-24.6 0-33.9L122.9 137c-1.8-1.8-2.1-4.8-.5-6.9c1-1.3 2.5-2.1 4.2-2.1L320 128zm48-8c0-22.1-17.9-40-40-40L126.6 80c-16.8 0-32.5 7.9-42.6 21.3c-15.9 21.2-13.8 50.9 4.9 69.6L126.1 208 18.3 315.7C6.6 327.5 0 343.4 0 360s6.6 32.5 18.3 44.3l25.4 25.4C55.5 441.4 71.4 448 88 448s32.5-6.6 44.3-18.3L240 321.9 277.1 359c18.7 18.7 48.4 20.8 69.6 5c13.4-10.1 21.3-25.8 21.3-42.6L368 120z"]
};
const faCircleChevronUp = {
  prefix: 'far',
  iconName: 'circle-chevron-up',
  icon: [512, 512, ["chevron-circle-up"], "f139", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271L273 167c-9.4-9.4-24.6-9.4-33.9 0L135 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
const faChevronCircleUp = faCircleChevronUp;
const faUserPolice = {
  prefix: 'far',
  iconName: 'user-police',
  icon: [448, 512, [], "e333", "M230.1 .8c-4-1.1-8.2-1.1-12.2 0l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40zM227 48.6l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8c1.9-.8 4-.8 5.9 0zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm20.6 209.8l65.2 57.1c2.1 1.9 4.3 3.6 6.6 5.1L50.9 464c8.4-31.2 33.8-55.5 65.7-62.2zM358.4 464l4.7-3.4c2.8-2 4-5.7 2.9-9s-4.2-5.5-7.6-5.5l-17.4 0-5.4-16.6c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5L315 446.2l-17.4 0c-3.5 0-6.6 2.2-7.6 5.5s.1 6.9 2.9 9l4.7 3.4-38.1 0c2.3-1.5 4.5-3.2 6.6-5.1l65.2-57.1c31.9 6.7 57.3 30.9 65.7 62.2l-38.6 0zM137.2 356.1c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4C0 500.5 11.5 512 25.6 512l396.8 0c14.1 0 25.6-11.5 25.6-25.6c0-71.6-55.9-130.1-126.5-134.2c-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0l-76.3-66.7z"]
};
const faLariSign = {
  prefix: 'far',
  iconName: 'lari-sign',
  icon: [384, 512, [], "e1c8", "M144 32c13.3 0 24 10.7 24 24l0 41.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5L216 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54c58.9 23.8 103.2 76 116.2 139.7c2.6 13-5.8 25.7-18.7 28.3s-25.7-5.8-28.3-18.7c-8.3-41-34-75.6-69.1-95.9L264 264c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118c-7.8-1.3-15.8-2-24-2s-16.2 .7-24 2l0 118c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-100.7C77 188.2 48 234.7 48 288c0 79.5 64.5 144 144 144l168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-168 0L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l41 0C25.1 396.8 0 345.3 0 288c0-80.6 49.6-149.6 120-178l0-54c0-13.3 10.7-24 24-24z"]
};
const faVolcano = {
  prefix: 'far',
  iconName: 'volcano',
  icon: [512, 512, [127755], "f770", "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM48 459.8c0 2.3 1.9 4.2 4.2 4.2l407.7 0c2.3 0 4.2-1.9 4.2-4.2c0-1-.4-2-1.1-2.8L361.3 342.7l-15 15c-6.6 6.6-15.5 10.3-24.8 10.3c-11 0-21.4-5.2-28-14l-18-24c-12.3-16.4-31.5-26-52-26c-15.2 0-29.9 5.3-41.6 15.1l-39.4 32.8L49.1 457.1c-.7 .8-1.1 1.7-1.1 2.8zM163.4 256.2c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"]
};
const faTeddyBear = {
  prefix: 'far',
  iconName: 'teddy-bear',
  icon: [576, 512, [], "e3cf", "M144 80c0-17.7 14.3-32 32-32c14 0 25.9 9 30.3 21.5c4 11.5 15.9 18.2 27.8 15.6c16-3.5 34.2-5.1 54-5.1s38 1.7 54 5.1c11.9 2.6 23.8-4.1 27.8-15.6C374.1 57 386 48 400 48c17.7 0 32 14.3 32 32c0 11.5-6.1 21.7-15.4 27.3c-9 5.5-13.3 16.2-10.8 26.4c1.3 5.3 2.1 11.3 2.1 18.3c0 54.9-51 104-120 104s-120-49.1-120-104c0-6.9 .8-13 2.1-18.3c2.6-10.2-1.8-20.9-10.8-26.4C150.1 101.7 144 91.5 144 80zM176 0C131.8 0 96 35.8 96 80c0 22.8 9.5 43.3 24.7 57.9c-.4 3.4-.6 6.8-.7 10.3c-25.2-16.9-59.5-16.5-84.6 3.3c-31.2 24.6-36.6 69.9-12 101.1l25.8 32.7c5.5 6.9 11.2 13.6 17.1 19.9C28.6 311.7 0 344.5 0 384c0 3.9 .3 7.7 .8 11.4c.1 .8 .3 1.5 .4 2.3l13 53.3c8 33 35.8 56.9 68.9 60.6c1.6 .3 3.2 .5 4.8 .5l4 0 28 0 336 0 28 0 4 0c1.6 0 3.3-.2 4.8-.5c33.1-3.6 60.9-27.6 68.9-60.6l13-53.3c.2-.8 .3-1.5 .4-2.3c.5-3.7 .8-7.5 .8-11.4c0-39.5-28.6-72.3-66.3-78.8c5.9-6.3 11.6-13 17.1-19.9l25.8-32.7c24.6-31.2 19.2-76.5-12-101.1c-25.1-19.8-59.4-20.2-84.6-3.3c-.1-3.5-.3-6.9-.7-10.3C470.5 123.3 480 102.8 480 80c0-44.2-35.8-80-80-80c-27.5 0-51.8 13.9-66.1 35c-14.7-2.1-30.2-3-45.9-3s-31.1 .9-45.9 3C227.8 13.9 203.5 0 176 0zM92 464l-1.4 0c-.3 0-.6-.1-.9-.1c-13.8-1-25.5-10.7-28.8-24.3l-12.7-52c-.1-1.2-.2-2.4-.2-3.6c0-17.7 14.3-32 32-32c16.1 0 29.5 11.9 31.7 27.4c1.7 11.8 11.8 20.6 23.8 20.6l.6 0c13.3 0 24-10.7 24-24l0-43.5c0-8.1-4.1-15.7-11-20.1c-22.9-14.8-44-33.7-62.1-56.8L61.1 222.9c-8.2-10.4-6.4-25.5 4-33.7s25.5-6.4 33.7 4l25.8 32.7c83.3 105.7 243.5 105.7 326.8 0l25.8-32.7c8.2-10.4 23.3-12.2 33.7-4s12.2 23.3 4 33.7l-25.8 32.7c-18.1 23-39.2 41.9-62.1 56.8c-6.8 4.4-11 12-11 20.1l0 43.5c0 13.3 10.7 24 24 24l.6 0c11.9 0 22.1-8.8 23.8-20.6c2.2-15.5 15.6-27.4 31.7-27.4c17.7 0 32 14.3 32 32c0 1.2-.1 2.4-.2 3.6l-12.7 52c-3.3 13.6-15 23.4-28.8 24.3c-.3 0-.6 0-.9 .1l-1.4 0-28 0-80 0 0-48c0-44.2-35.8-80-80-80l-16 0c-44.2 0-80 35.8-80 80l0 48-80 0-28 0zm156 0l0-48c0-17.7 14.3-32 32-32l16 0c17.7 0 32 14.3 32 32l0 48-80 0zm8-320a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 32c0-13.3-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24s32-10.7 32-24z"]
};
const faStocking = {
  prefix: 'far',
  iconName: 'stocking',
  icon: [384, 512, [], "f7d5", "M96 0C78.3 0 64 14.3 64 32l0 32c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 0zm48 238.9L144 128l-48 0 0 110.9c0 10.7-5.3 20.7-14.2 26.6L55.7 282.9C20.9 306.1 0 345.1 0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5L352 128l-48 0 0 187.5c0 26.7-13.4 51.7-35.6 66.6L164.3 451.4C152 459.6 137.6 464 122.8 464C81.5 464 48 430.5 48 389.2l0-2.2c0-25.8 12.9-49.8 34.3-64.1l26.1-17.4c22.3-14.8 35.6-39.8 35.6-66.6z"]
};
const faPersonWalkingDashedLineArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-dashed-line-arrow-right',
  icon: [640, 512, [], "e553", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80zM392 128c-13.3 0-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-13.3-10.7-24-24-24zm24 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16zm-24 72c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24z"]
};
const faImageSlash = {
  prefix: 'far',
  iconName: 'image-slash',
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-320c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM134.4 80L512 80c8.8 0 16 7.2 16 16l0 292.5-53.4-41.9L387 233.3c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3l-7.2 9.3L256 175.3c-.4-26.2-21.7-47.3-48-47.3c-3.7 0-7.4 .4-10.8 1.2L134.4 80zm353 400L282.9 318.9 266 340.7l-30.5-42.7C231 291.7 223.8 288 216 288s-15 3.7-19.5 10.1l-80 112-4.5 6.3 0-.3 0-231.8L64 146.4 64 416c0 35.3 28.7 64 64 64l359.4 0z"]
};
const faMaskSnorkel = {
  prefix: 'far',
  iconName: 'mask-snorkel',
  icon: [576, 512, [], "e3b7", "M552 32c13.3 0 24 10.7 24 24l0 104-48 0 0-104c0-13.3 10.7-24 24-24zM528 376.6L528 192l48 0 0 184.6C576 451.4 515.4 512 440.6 512c-67.4 0-124.5-49.5-134-116.2l-2.3-16.4c-1.9-13.1 7.2-25.3 20.4-27.2s25.3 7.2 27.2 20.4l2.3 16.4c6.2 43.1 43 75 86.5 75c48.3 0 87.4-39.1 87.4-87.4zM64 112c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l79.7 0c7.1 0 13.4-4.7 15.4-11.6l3.4-11.7c17.7-61.9 105.4-61.9 123.1 0l3.4 11.7c2 6.9 8.2 11.6 15.4 11.6l79.7 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 112zM304.3 288c-22.3 0-42.4-11.5-54-29.6c-.7-1-1.3-2.1-1.9-3.2c-.3-.5-.6-1-.8-1.5c-2-3.8-3.6-7.8-4.8-12.1l-.6-2.2-2.7-9.6c-4.4-15.5-26.3-15.5-30.8 0l-2.7 9.6-.6 2.2c-1.2 4.2-2.8 8.3-4.8 12.1c-.3 .5-.5 1-.8 1.5c-.6 1.1-1.2 2.2-1.9 3.2c-11.5 18.1-31.7 29.6-54 29.6L64 288c-35.3 0-64-28.7-64-64l0-96C0 92.7 28.7 64 64 64l320 0c35.3 0 64 28.7 64 64l0 96c0 35.3-28.7 64-64 64l-79.7 0z"]
};
const faSmoke = {
  prefix: 'far',
  iconName: 'smoke',
  icon: [640, 512, [], "f760", "M80 128c0-44.2 35.8-80 80-80c31.1 0 58 17.7 71.3 43.7c3.3 6.5 9.5 11.2 16.7 12.6s14.7-.5 20.2-5.3c14-11.9 32-19 51.8-19c24.3 0 46.1 10.8 60.7 27.9c4.9 2 9.7 4.3 14.4 6.8c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-21.9 0-42.6 5.5-60.7 15.3C235.9 18.5 200.1 0 160 0C89.3 0 32 57.3 32 128c0 32 11.7 61.2 31.1 83.6c16.1-8.3 33.6-14.3 52.2-17.3C94 180 80 155.6 80 128zm512 96c0 27.5-13.8 51.7-34.9 66.1c12.3 10.4 22.8 22.9 31 36.8C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.6 0-87.3 24.8-109.7 62c-22.2-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4c10.7 3.9 20.9 8.7 30.5 14.5c7.9-5 16.2-9.4 25-13C273.9 186.8 295.7 176 320 176c24.3 0 46.1 10.8 60.7 27.9c13.7 5.6 26.5 13.1 38 22.2c7.5-3 13.1-9.6 14.7-17.7c7.2-36.7 39.7-64.4 78.5-64.4c44.2 0 80 35.8 80 80zM48 368c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64l-320 0c-53 0-96-43-96-96zm96-144C64.5 224 0 288.5 0 368s64.5 144 144 144l320 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.7 0-62.5 12.2-85.1 32.3C210.2 236.1 178.5 224 144 224z"]
};
const faSterlingSign = {
  prefix: 'far',
  iconName: 'sterling-sign',
  icon: [320, 512, [163, "gbp", "pound-sign"], "f154", "M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2L48 224l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 63.4c0 17.4-4.4 34.5-12.7 49.8L2.9 444.5c-4.1 7.4-3.9 16.5 .4 23.7S15.5 480 24 480l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64.4 432l13-23.9C89.6 385.8 96 360.8 96 335.4L96 272l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 224l0-64.8z"]
};
const faGbp = faSterlingSign;
const faPoundSign = faSterlingSign;
const faBatteryExclamation = {
  prefix: 'far',
  iconName: 'battery-exclamation',
  icon: [576, 512, [], "e0b0", "M208 96l0 48L80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l113.6 0c-1 5.2-1.6 10.5-1.6 16c0 11.4 2.4 22.2 6.7 32L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l128 0zM464 416l-118.7 0c4.3-9.8 6.7-20.6 6.7-32c0-5.5-.6-10.8-1.6-16L464 368c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-128 0 0-48 128 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80zM272 96c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM240 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faViruses = {
  prefix: 'far',
  iconName: 'viruses',
  icon: [640, 512, [], "e076", "M327.8 293.8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5l0 13.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-13.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.5 0c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 34 0l9.5 9.5C124.9 91 168 73.1 168 37.5L168 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 13.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168l13.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-13.5 0c-35.6 0-53.5 43.1-28.3 68.3c0 0 0 0 0 0l9.5 9.5zM285.8 192c-17.9-17.2-28-41.6-27.5-66.4c-11.1 .2-22.1-1.7-32.4-5.5c-12.7-4.7-24.4-12.2-33.9-22c-17.2 17.9-41.6 28-66.4 27.5c.5 24.8-9.6 49.2-27.5 66.4c17.9 17.2 28 41.6 27.5 66.4c24.8-.5 49.2 9.6 66.4 27.5c17.2-17.9 41.6-28 66.4-27.5c-.5-24.8 9.6-49.2 27.5-66.4zM512 240c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM152 176a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm72 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faSquarePersonConfined = {
  prefix: 'far',
  iconName: 'square-person-confined',
  icon: [448, 512, [], "e577", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM292 200c33.1 0 60 26.9 60 60l0 88c0 31.8-24.7 57.8-56 59.9l0 .1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L232 309l0-49c0-33.1 26.9-60 60-60zm-4.2 159.2c1.8 .3 3.7 .6 5.6 .7c6-.7 10.6-5.8 10.6-11.9l0-88c0-6.6-5.4-12-12-12s-12 5.4-12 12l0 88c0 5.2 3.2 9.5 7.8 11.2zM208 112a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faUserTie = {
  prefix: 'far',
  iconName: 'user-tie',
  icon: [448, 512, [], "f508", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm128-80A128 128 0 1 1 96 128a128 128 0 1 1 256 0zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2 43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2zm-90.6 17.1C82.3 391.1 55.4 424.2 49.3 464l113 0-43.8-87.7zM285.7 464l113 0c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"]
};
const faUpToBracket = {
  prefix: 'far',
  iconName: 'up-to-bracket',
  icon: [448, 512, [], "e66e", "M114.2 320L224 210 333.8 320 280 320c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 160c-11.5 0-22.5 4.6-30.6 12.7L77.6 288.8C68.9 297.5 64 309.3 64 321.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 172.7c-8.1-8.1-19.1-12.7-30.6-12.7zM48 168l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faArrowDownLong = {
  prefix: 'far',
  iconName: 'arrow-down-long',
  icon: [384, 512, ["long-arrow-down"], "f175", "M175 505c9.4 9.4 24.6 9.4 33.9 0L345 369c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L216 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 406.1L73 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 505z"]
};
const faLongArrowDown = faArrowDownLong;
const faTentArrowDownToLine = {
  prefix: 'far',
  iconName: 'tent-arrow-down-to-line',
  icon: [640, 512, [], "e57e", "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zM369.3 133c8.6-6.7 20.7-6.7 29.4 0L565.2 261.7c10.7 8.3 18 20.1 20.7 33.3l33.9 169.3C631.2 466.1 640 476 640 488c0 13.3-10.7 24-24 24l-16 0-432 0L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l124.3 0 33.8-169c2.6-13.2 10-25.1 20.7-33.3L369.3 133zm-172 331L360 464l0-263.1L232.1 299.7c-1.5 1.2-2.6 2.9-3 4.8L197.3 464zM472 464l98.7 0L538.8 304.4c-.4-1.9-1.4-3.6-3-4.8L408 200.9 408 336l64 128z"]
};
const faCertificate = {
  prefix: 'far',
  iconName: 'certificate',
  icon: [512, 512, [], "f0a3", "M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zM222.5 19.1L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-4 15.9L154.7 80.6 108.5 67.5 92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2L34.1 166.5l-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256 19.1 289.5 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8L67.5 403.5l-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L222.5 493 256 458.5 289.5 493 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256 493 222.5 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5L357.3 80.6 345.5 34.1l-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L289.5 19.1 256 53.5 222.5 19.1z"]
};
const faCrystalBall = {
  prefix: 'far',
  iconName: 'crystal-ball',
  icon: [448, 512, [], "e362", "M400 224c0 71-42 132.2-102.6 160l83.3 0c41.5-40.7 67.2-97.3 67.2-160C448 100.3 347.7 0 224 0S0 100.3 0 224c0 62.7 25.7 119.3 67.2 160l83.3 0C90 356.2 48 295 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zM167.5 100.3c-2.6-7-12.4-7-15 0l-9.8 26.4-26.4 9.8c-7 2.6-7 12.4 0 15l26.4 9.8 9.8 26.4c2.6 7 12.4 7 15 0l9.8-26.4 26.4-9.8c7-2.6 7-12.4 0-15l-26.4-9.8-9.8-26.4zm113 48l-18.4 49.8-49.8 18.4c-7 2.6-7 12.4 0 15l49.8 18.4 18.4 49.8c2.6 7 12.4 7 15 0l18.4-49.8 49.8-18.4c7-2.6 7-12.4 0-15l-49.8-18.4-18.4-49.8c-2.6-7-12.4-7-15 0zM20.3 474.2c-5.1 7.3-5.8 16.9-1.6 24.8S31.1 512 40 512l368 0c8.9 0 17.2-5 21.3-12.9s3.5-17.5-1.6-24.8L386.9 416 61.1 416 20.3 474.2z"]
};
const faReplyAll = {
  prefix: 'far',
  iconName: 'reply-all',
  icon: [576, 512, ["mail-reply-all"], "f122", "M208.5 73.4c9.6-9.1 10-24.3 .9-33.9s-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4zM352 240c0 0 0 0 0 0l-24 0c-13.3 0-24 10.7-24 24l0 24 0 28.1L183.9 208 304 99.9l0 28.1 0 24c0 13.3 10.7 24 24 24l24 0 48 0c70.7 0 128 57.3 128 128c0 15.3-1.9 29.1-5.2 41.5C506 284.7 450.2 240 384 240l-32 0zm0 96l0-48 32 0c5.5 0 10.8 .5 16 1.3c45.4 7.6 80 47.1 80 94.7c0 17.3-4.2 30.5-9.5 40.2c-1.6 2.9-3.3 5.5-5 7.9c-2.6 3.5-5.3 6.4-7.7 8.6c-.5 .5-1 .9-1.4 1.4c-4.8 4.9-8.3 11.3-8.3 18.1c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9c2.6-1.4 6.3-3.5 10.8-6.5c2.7-1.8 5.7-3.8 8.9-6.2c3.7-2.7 7.6-5.8 11.7-9.3C537.4 430.2 576 382 576 304c0-97.2-78.8-176-176-176l-48 0 0-48 0-16c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2l0-16z"]
};
const faMailReplyAll = faReplyAll;
const faSuitcase = {
  prefix: 'far',
  iconName: 'suitcase',
  icon: [512, 512, [129523], "f0f2", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm232 48l-208 0-8 0 0 288 224 0 0-288-8 0zM64 144c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l32 0 0-288-32 0zM448 432c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-32 0 0 288 32 0z"]
};
const faPersonSkating = {
  prefix: 'far',
  iconName: 'person-skating',
  icon: [448, 512, ["skating"], "f7c5", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 120c0-13.3 10.7-24 24-24l169.4 0c35.6 0 53.5 43.1 28.3 68.3L268.9 245l69.3 60c8.8 7.6 13.8 18.6 13.8 30.2l0 88.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-85-85.3-74c-24.8-21.5-26-59.7-1.9-82.5c11.9-11.2 26.8-25.1 41.6-38.5L152 144c-13.3 0-24-10.7-24-24zM79 367L179.4 266.6c4.8 8.5 11.2 16.4 19 23.2l13.7 11.9L113 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zm324.9 81.4c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L272 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"]
};
const faSkating = faPersonSkating;
const faStarShooting = {
  prefix: 'far',
  iconName: 'star-shooting',
  icon: [512, 512, [127776], "e036", "M313 41L265 89c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L279 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM129.5 388.7L120 444l49.5-26.1c14-7.4 30.7-7.4 44.7 0L263.8 444l-9.5-55.4c-2.7-15.6 2.5-31.4 13.8-42.4L308.3 307l-55.5-8.1c-15.6-2.3-29.2-12.1-36.1-26.3l-24.8-50.3-24.8 50.3c-7 14.2-20.5 24-36.1 26.3L75.5 307l40.2 39.2c11.3 11 16.4 26.9 13.8 42.4zm-5.4-137.3l46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1zM505 199c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0zM505 41L361 185c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faBinaryLock = {
  prefix: 'far',
  iconName: 'binary-lock',
  icon: [640, 512, [], "e33d", "M318 4.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C235.8 21.4 229 35 233.2 47.6S251 67 263.6 62.8L280 57.3 280 176l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-152c0-7.7-3.7-15-10-19.5zM94 292.5c-6.3-4.5-14.3-5.7-21.6-3.3l-48 16C11.8 309.4 5 323 9.2 335.6S27 355 39.6 350.8L56 345.3 56 464l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-152c0-7.7-3.7-15-10-19.5zM72 0C32.2 0 0 32.2 0 72l0 80c0 39.8 32.2 72 72 72l48 0c39.8 0 72-32.2 72-72l0-80c0-39.8-32.2-72-72-72L72 0zM48 72c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-80zM192 360l0 80c0 39.8 32.2 72 72 72l48 0c39.8 0 72-32.2 72-72l0-80c0-39.8-32.2-72-72-72l-48 0c-39.8 0-72 32.2-72 72zm72-24l48 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm264-96c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faFilterCircleDollar = {
  prefix: 'far',
  iconName: 'filter-circle-dollar',
  icon: [576, 512, ["funnel-dollar"], "f662", "M0 41.7C0 18.7 18.7 0 41.7 0L469.9 0C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48 55 48 218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 68C3.3 60.6 0 51.3 0 41.7zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
const faFunnelDollar = faFilterCircleDollar;
const faCameraRetro = {
  prefix: 'far',
  iconName: 'camera-retro',
  icon: [512, 512, [128247], "f083", "M192 112L64 112c-8.8 0-16 7.2-16 16l0 64 108.1 0c23.5-29.3 59.5-48 99.9-48s76.5 18.7 99.9 48L464 192l0-96c0-8.8-7.2-16-16-16L271.1 80c-2.5 0-4.9 .6-7.2 1.7l-50.5 25.2c-6.7 3.3-14 5.1-21.5 5.1zM48 240l0 176c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-176-84 0c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32l-84 0zM0 416L0 128C0 92.7 28.7 64 64 64l0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16 32 0 50.5-25.2c8.9-4.4 18.7-6.8 28.6-6.8L448 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM336 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faCircleArrowDown = {
  prefix: 'far',
  iconName: 'circle-arrow-down',
  icon: [512, 512, ["arrow-circle-down"], "f0ab", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faArrowCircleDown = faCircleArrowDown;
const faCommentPen = {
  prefix: 'far',
  iconName: 'comment-pen',
  icon: [512, 512, ["comment-edit"], "f4ae", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM340.8 155c-14.7-14.7-38.6-14.7-53.3 0L272.6 170l53.3 53.3 14.9-14.9c14.7-14.7 14.7-38.6 0-53.3zM178.1 264.5c-4.1 4.1-7 9.2-8.4 14.9L160.5 316c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l36.6-9.2c5.6-1.4 10.8-4.3 14.9-8.4l71.9-71.9L250 192.6l-71.9 71.9z"]
};
const faCommentEdit = faCommentPen;
const faFileImport = {
  prefix: 'far',
  iconName: 'file-import',
  icon: [512, 512, ["arrow-right-to-file"], "f56f", "M448 464l-256 0c-8.8 0-16-7.2-16-16l0-80-48 0 0 80c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 192 48 0 0-192c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM297 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
const faArrowRightToFile = faFileImport;
const faBanjo = {
  prefix: 'far',
  iconName: 'banjo',
  icon: [512, 512, [129685], "f8a3", "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-22.2 59.1-61.5 61.5-1.2 1.2c-22-16.5-48.2-27.7-76.6-31.7l0-1.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.7c-28.5 4.1-54.6 15.3-76.6 31.7l-1.2-1.2c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l1.2 1.2C41 241.4 29.8 267.5 25.7 296L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l1.7 0c4.1 28.5 15.3 54.6 31.7 76.6l-1.2 1.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l1.2-1.2c22 16.5 48.2 27.7 76.6 31.7l0 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-1.7c28.5-4.1 54.6-15.3 76.6-31.7l1.2 1.2c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-1.2-1.2c16.5-22 27.7-48.2 31.7-76.6l1.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-1.7 0c-4.1-28.5-15.3-54.6-31.7-76.6l1.2-1.2s0 0 0 0l61.5-61.5 59.1-22.2c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM153 311c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-48-48z"]
};
const faSquareArrowUpRight = {
  prefix: 'far',
  iconName: 'square-arrow-up-right',
  icon: [448, 512, ["external-link-square"], "f14c", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zm64 16c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.1 0L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135L288 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24l-152 0z"]
};
const faExternalLinkSquare = faSquareArrowUpRight;
const faLightEmergencyOn = {
  prefix: 'far',
  iconName: 'light-emergency-on',
  icon: [640, 512, [], "e420", "M69.3 36c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32zM597.3 76c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm544 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM448 208l0 96 48 0 0-96c0-97.2-78.8-176-176-176s-176 78.8-176 176l0 96 48 0 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128zM144 432l0-48 352 0 0 48-352 0zM96 384l0 48c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48l-352 0c-26.5 0-48 21.5-48 48zM320 144c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"]
};
const faKerning = {
  prefix: 'far',
  iconName: 'kerning',
  icon: [640, 512, [], "f86f", "M453.8 34.1c5.6-12 .4-26.3-11.6-31.9s-26.3-.4-31.9 11.6l-216 464c-5.6 12-.4 26.3 11.6 31.9s26.3 .4 31.9-11.6l216-464zM45.5 109.3C39.5 97.4 25.1 92.6 13.3 98.5S-3.4 118.9 2.5 130.7l136 272c4.1 8.1 12.4 13.3 21.5 13.3s17.4-5.1 21.5-13.3l136-272c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L160 338.3 45.5 109.3zm328.3 293L397.4 352l165.3 0 23.6 50.2c5.6 12 19.9 17.1 31.9 11.5s17.1-19.9 11.5-31.9l-128-272c-4-8.4-12.4-13.8-21.7-13.8s-17.8 5.4-21.7 13.8l-128 272c-5.6 12-.5 26.3 11.5 31.9s26.3 .5 31.9-11.5zM480 176.4L540.1 304l-120.1 0L480 176.4z"]
};
const faBoxOpen = {
  prefix: 'far',
  iconName: 'box-open',
  icon: [640, 512, [], "f49e", "M17.2 125.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 64 75.2 33.4c-6.7-.8-13.3 2.7-16.3 8.7L17.2 125.5zM320 64l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1L581.1 42.1c-3-6.1-9.6-9.6-16.3-8.7L320 64zm-1.1 64l2.2 0s0 0 0 0l-2.2 0s0 0 0 0zM528 225.3l0 153.2-184 46L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240.5-184-46 0-153.2L64 211.6l0 167c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-167-48 13.7z"]
};
const faSquareF = {
  prefix: 'far',
  iconName: 'square-f',
  icon: [448, 512, [], "e270", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 64 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24z"]
};
const faScroll = {
  prefix: 'far',
  iconName: 'scroll',
  icon: [576, 512, [128220], "f70e", "M48 112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 288c0 44.2 35.8 80 80 80l304 0c44.2 0 80-35.8 80-80l0-48c0-26.5-21.5-48-48-48l-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0c-26.5 0-48 21.5-48 48l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-288c0-11.4-2.4-22.2-6.7-32L400 80c17.7 0 32 14.3 32 32l0 160 48 0 0-160c0-44.2-35.8-80-80-80L80 32C35.8 32 0 67.8 0 112l0 48c0 26.5 21.5 48 48 48l32 0 0-48-32 0 0-48zM496 432l-230.7 0c4.3-9.8 6.7-20.6 6.7-32l0-48s0 0 0 0l.6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0s0 0 0 0l0 48c0 17.7-14.3 32-32 32z"]
};
const faSpa = {
  prefix: 'far',
  iconName: 'spa',
  icon: [576, 512, [], "f5bb", "M288 92.1c21.2 24.9 52.1 69.7 68.6 134.5c13.3-10.3 27.4-19.5 42.2-27.6c-27.3-91.6-79.3-145.6-96.8-161.8c-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.5 16.2-69.5 70.1-96.8 161.8c14.8 8.1 28.9 17.3 42.2 27.6c16.5-64.8 47.3-109.7 68.6-134.5zm-96 377c22.9 6.7 47 10.5 72 10.9l48 0c25-.4 49.1-4.1 72-10.9c111-32.7 192-135.4 192-257c0-11.1-9-20.1-20.1-20.1c-61.7 0-121.7 17.9-171.9 54.1c-41.8 30-75.1 71-96 118.7c-20.9-47.7-54.2-88.6-96-118.7C141.8 209.9 81.8 192 20.1 192C9 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-50.5C116.8 390.9 60.8 323.2 49.9 241.4c55.1 5.9 104.6 30.5 142.1 67.2c33.5 32.9 57.4 75.5 67.2 123.2c-23.5-.9-46.1-5.5-67.2-13.3zm192 0c-21.1 7.7-43.6 12.4-67.2 13.3c9.7-47.8 33.7-90.4 67.2-123.2c37.5-36.8 87-61.3 142.1-67.2C515.2 323.2 459.2 390.9 384 418.5z"]
};
const faArrowLeftFromLine = {
  prefix: 'far',
  iconName: 'arrow-left-from-line',
  icon: [448, 512, [8612, "arrow-from-right"], "f344", "M7.6 238.5C2.7 243.1 0 249.4 0 256s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L84.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128zM400 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336z"]
};
const faArrowFromRight = faArrowLeftFromLine;
const faStrawberry = {
  prefix: 'far',
  iconName: 'strawberry',
  icon: [512, 512, [], "e32b", "M494.1 33.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C439.7 38.4 420.3 61.8 402 80c-.7 .7-1.4 1.4-2 2c0-.7 0-1.4 0-2.1c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-10.8-8.6-35.4-24.9-68.2-26.6c19.4-19.7 42.9-47.5 56.3-78.7zM192.2 112c20.5 0 40.8 7.8 56.4 23.4l128 128c15.6 15.6 23.4 36 23.4 56.6c0 59.2-62.9 144-224 144c-60 0-87.8-11.7-102.1-25.9S48 396 48 336c0-161 84.9-224 144.2-224zm0-48C96.2 64 0 160 0 336C0 464 48 512 176 512c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64zm-2.8 90.5c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm47.3 98.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-32 80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm96.7-66.3c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm24-80c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3zm55.3 90.3c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-192-80c11.9-11.9 14.6-28.3 8.7-34.3s-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7zm-23.3 53.7c-5.9-5.9-22.4-3.2-34.3 8.7s-14.6 28.3-8.7 34.3s22.4 3.2 34.3-8.7s14.6-28.3 8.7-34.3z"]
};
const faLocationPinLock = {
  prefix: 'far',
  iconName: 'location-pin-lock',
  icon: [512, 512, [], "e51f", "M192 451.7c18.5-23.7 41.6-54.7 64-88.1l0 83.2c-15.3 20.6-29.3 38.6-40.3 52.3c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0c95.7 0 175 70 189.6 161.5c-16.9 2.8-32.6 9.4-46.1 18.9C329.6 106.3 267.6 48 192 48C112.5 48 48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm288 48c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faPause = {
  prefix: 'far',
  iconName: 'pause',
  icon: [320, 512, [9208], "f04c", "M48 112l0 288 48 0 0-288-48 0zM0 112C0 85.5 21.5 64 48 64l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48L0 112zm224 0l0 288 48 0 0-288-48 0zm-48 0c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-288z"]
};
const faClockEightThirty = {
  prefix: 'far',
  iconName: 'clock-eight-thirty',
  icon: [512, 512, [], "e346", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-91.2L173.3 340c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64c7.4-4.9 16.8-5.4 24.6-1.2S280 247.1 280 256l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faPlaneEngines = {
  prefix: 'far',
  iconName: 'plane-engines',
  icon: [576, 512, [9992, "plane-alt"], "f3de", "M576 256c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C498 182.1 468.7 176 448 176l-66.2 0-32.5-50.9C360.3 120.1 368 109 368 96c0-17.7-14.3-32-32-32l-25.9 0L285.7 25.8C275.4 9.7 257.6 0 238.5 0L197.9 0c-27.1 0-46.4 26.4-38.1 52.2L199.4 176 148 176l-36-48c-7.6-10.1-19.4-16-32-16l-42.1 0C17 112 0 129 0 149.9c0 3.8 .6 7.5 1.7 11.1c0 0 0 0 0 0l19.9 64.7C9 230.1 0 242 0 256s9 25.9 21.6 30.3L1.7 350.9s0 0 0 0C.6 354.6 0 358.3 0 362.1C0 383 17 400 37.9 400L80 400c12.6 0 24.4-5.9 32-16L92.8 369.6 112 384l36-48 51.4 0L159.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8L310.1 448l25.9 0c17.7 0 32-14.3 32-32c0-13-7.7-24.1-18.8-29.1L381.8 336l66.2 0c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1zM448 224c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3c0 0 0 0 0 0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C484.3 283.8 461.6 288 448 288l-79.4 0c-8.2 0-15.8 4.2-20.2 11.1L245.2 460.3c-1.5 2.3-4 3.7-6.7 3.7l-29.6 0 46.3-144.7c2.3-7.3 1-15.3-3.5-21.5s-11.7-9.8-19.4-9.8L136 288c-7.6 0-14.7 3.6-19.2 9.6L76 352l-24.4 0 27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L51.6 160 76 160l40.8 54.4c4.5 6 11.6 9.6 19.2 9.6l96.3 0c7.7 0 14.9-3.7 19.4-9.8s5.8-14.2 3.5-21.5L208.9 48l29.6 0c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L245.2 51.7 348.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0z"]
};
const faPlaneAlt = faPlaneEngines;
const faHillAvalanche = {
  prefix: 'far',
  iconName: 'hill-avalanche',
  icon: [576, 512, [], "e507", "M551.1 391.1c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8zM448 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM48 440l0-294.1L366.1 464 72 464c-13.3 0-24-10.7-24-24zM68.3 98.3C43.1 73.1 0 91 0 126.6L0 440c0 39.8 32.2 72 72 72l313.4 0c35.6 0 53.5-43.1 28.3-68.3L68.3 98.3z"]
};
const faTemperatureEmpty = {
  prefix: 'far',
  iconName: 'temperature-empty',
  icon: [320, 512, ["temperature-0", "thermometer-0", "thermometer-empty"], "f2cb", "M96 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C90.3 301 96 288.4 96 273.9L96 112zM160 0C98.1 0 48 50.2 48 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C26.7 305.7 16 335.7 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L272 112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faTemperature0 = faTemperatureEmpty;
const faThermometer0 = faTemperatureEmpty;
const faThermometerEmpty = faTemperatureEmpty;
const faBomb = {
  prefix: 'far',
  iconName: 'bomb',
  icon: [512, 512, [128163], "f1e2", "M459.1 52.4l45.7 16.8c4.3 1.6 7.3 5.9 7.2 10.4c0 4.5-3 8.7-7.2 10.2l-45.7 16.8-16.5 45.8c-1.5 4.4-5.8 7.5-10.4 7.5s-8.9-3.1-10.4-7.5l-16.8-45.8L359.2 89.8c-4.2-1.5-7.2-5.7-7.2-10.2c0-4.6 3-8.9 7.2-10.4l46-16.8L421.7 6.5c1.9-3.9 6.1-6.5 10.4-6.5s8.5 2.6 10.4 6.5l16.5 45.8zM302.9 149.6c-12.1 7.2-27.1 8.8-40.7 3.8c-16.9-6.1-35.1-9.4-54.2-9.4c-88.4 0-160 71.6-160 160s71.6 160 160 160s160-71.6 160-160c0-19.1-3.3-37.4-9.4-54.2c-4.9-13.7-3.3-28.6 3.8-40.7l-59.5-59.5zm-24.4-41.3l2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 224c-39.8 0-72 32.2-72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3 53.7-120 120-120c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faGaugeLow = {
  prefix: 'far',
  iconName: 'gauge-low',
  icon: [512, 512, ["tachometer-alt-slow"], "f627", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM256 408c-30.9 0-56-25.1-56-56c0-14 5.1-26.8 13.7-36.6L146 161.7c-5.3-12.1 .2-26.3 12.3-31.6s26.3 .2 31.6 12.3L257.6 296c30.2 .8 54.4 25.6 54.4 56c0 30.9-25.1 56-56 56zM384 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faTachometerAltSlow = faGaugeLow;
const faRegistered = {
  prefix: 'far',
  iconName: 'registered',
  icon: [512, 512, [174], "f25d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 60.9 0 37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80l-88 0c-13.3 0-24 10.7-24 24zm48 88l0-64 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0z"]
};
const faTrashCanPlus = {
  prefix: 'far',
  iconName: 'trash-can-plus',
  icon: [448, 512, [], "e2ac", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zM200 376l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faAddressCard = {
  prefix: 'far',
  iconName: 'address-card',
  icon: [576, 512, [62140, "contact-card", "vcard"], "f2bb", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
};
const faContactCard = faAddressCard;
const faVcard = faAddressCard;
const faChartFft = {
  prefix: 'far',
  iconName: 'chart-fft',
  icon: [512, 512, [], "e69e", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM277.7 85.8c-4.2-8.8-13.3-14.3-23-13.7s-18.2 6.9-21.4 16.1L158.9 304 120 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c10.2 0 19.4-6.5 22.7-16.2l60.7-176.2 38.9 82.6c4 8.4 12.4 13.8 21.7 13.8l66.2 0 49.1 84.1c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-56-96c-4.3-7.4-12.2-11.9-20.7-11.9l-64.8 0L277.7 85.8z"]
};
const faScaleUnbalancedFlip = {
  prefix: 'far',
  iconName: 'scale-unbalanced-flip',
  icon: [640, 512, ["balance-scale-right"], "f516", "M97.1 16.7c-4 12.6 2.9 26.1 15.5 30.2L240.4 87.7c3.1 32.4 25.5 59.2 55.6 68.6L296 464l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0c13.3 0 24-10.7 24-24l0-331.7c14.2-4.5 26.8-12.8 36.4-23.8l132.3 42.3c12.6 4 26.1-2.9 30.2-15.5s-2.9-26.1-15.5-30.2L399.6 88.3c.3-2.7 .4-5.5 .4-8.3c0-44.2-35.8-80-80-80c-29.8 0-55.8 16.3-69.6 40.5L127.3 1.1c-12.6-4-26.1 2.9-30.2 15.5zM128 163.8L200.4 288 55.6 288 128 163.8zM254 305.1c2.6-11-1-22.3-6.7-32.1L152.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 273.1C3 282.8-.6 294.1 2 305.1C12.8 350 65.1 384 128 384s115.2-34 126-78.9zM583.3 416l-144.9 0 72.4-124.2L583.3 416zm-72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 401.1c-5.7 9.8-9.3 21.1-6.7 32.1C395.7 478 448 512 510.8 512zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBalanceScaleRight = faScaleUnbalancedFlip;
const faGlobeSnow = {
  prefix: 'far',
  iconName: 'globe-snow',
  icon: [448, 512, [], "f7a3", "M297.4 384C358 356.2 400 295 400 224c0-97.2-78.8-176-176-176S48 126.8 48 224c0 71 42 132.2 102.6 160l-83.3 0C25.7 343.3 0 286.7 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 62.7-25.7 119.3-67.2 160l-83.3 0zM232 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.3 84.7l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-16.5 0 44.8 53.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2l-56 0 0 48-48 0 0-48-56 0c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17L176.5 256 160 256c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64c6.2-6.2 16.4-6.2 22.6 0zM328 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM80 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM20.3 474.2L61.1 416l325.8 0 40.8 58.2c5.1 7.3 5.8 16.9 1.6 24.8S416.9 512 408 512L40 512c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8z"]
};
const faSubscript = {
  prefix: 'far',
  iconName: 'subscript',
  icon: [512, 512, [], "f12c", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l27.2 0 96 144-96 144L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-27.2 0-96-144 96-144 27.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64L24 64zM472 312c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8L424 464l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-152z"]
};
const faDiamondTurnRight = {
  prefix: 'far',
  iconName: 'diamond-turn-right',
  icon: [512, 512, ["directions"], "f5eb", "M50.9 249L249 50.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9s-5.2-1-7-2.9L50.9 263c-1.9-1.9-2.9-4.4-2.9-7s1-5.2 2.9-7zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zM315.3 148.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8l0 40-48 0c-35.3 0-64 28.7-64 64l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-8.8 7.2-16 16-16l48 0 0 40c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"]
};
const faDirections = faDiamondTurnRight;
const faIntegral = {
  prefix: 'far',
  iconName: 'integral',
  icon: [320, 512, [], "f667", "M216 48c-17.7 0-32 14.3-32 32l0 352c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-17.7-14.3-32-32-32z"]
};
const faBurst = {
  prefix: 'far',
  iconName: 'burst',
  icon: [512, 512, [], "e4dc", "M161.7 216.4c4.9-14.3 2.7-30.1-5.9-42.6l-39.2-57.1 57.1 39.2c12.5 8.6 28.3 10.7 42.6 5.9s25.5-16.2 30.2-30.6l9.4-29.1 11.7 36c4 12.4 12.9 22.6 24.6 28.3s25.2 6.4 37.5 2l22-8-8 22.1c-4.5 12.2-3.8 25.8 2 37.5s15.9 20.6 28.3 24.6l36 11.7-32.6 10.6c-13.5 4.4-24.3 14.5-29.7 27.6s-4.6 27.9 2 40.4l17 32.2-32.2-17c-12.5-6.6-27.3-7.3-40.4-2s-23.2 16.2-27.6 29.7L256 410.1l-10.6-32.6c-4.4-13.5-14.5-24.3-27.6-29.7s-27.9-4.6-40.4 2l-32.2 17 16.9-32.2c6.6-12.5 7.3-27.3 2-40.4s-16.2-23.2-29.7-27.6L101.9 256l29.1-9.4c14.4-4.7 25.8-15.9 30.6-30.2zm-2-128.5L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l83.7 122 28.3 41.3L68.6 216.3l-52 16.8C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l56.7 18.4 46.3 15L97 355.3 66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3L156.7 415l43.1-22.7 15 46.3 18.4 56.7c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l18.4-56.7 15-46.3L355.3 415l57.5 30.2c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L415 355.3l-22.7-43.1 46.3-15 56.7-18.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-60.8-19.7-45.7-14.8 16.4-45.1 9.2-25.3c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-25.3 9.2-45.1 16.4L298.5 77.4 278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-16.8 52-15.4 47.6L159.6 87.9z"]
};
const faHouseLaptop = {
  prefix: 'far',
  iconName: 'house-laptop',
  icon: [640, 512, ["laptop-house"], "e066", "M224.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L416 198.4l0 41.6-48 0 0-80.7L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l152 0 0 48-152 0c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM288 216l0 45.7c-6 6.8-10.6 14.9-13.3 23.8c-3.2 1.6-6.9 2.5-10.7 2.5l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24zm64 104l0 144 192 0 0-144-192 0zm-48-16c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 160 36 0c6.6 0 12 5.4 12 12c0 19.9-16.1 36-36 36l-12 0-48 0-192 0-48 0-12 0c-19.9 0-36-16.1-36-36c0-6.6 5.4-12 12-12l36 0 0-160z"]
};
const faLaptopHouse = faHouseLaptop;
const faFaceTired = {
  prefix: 'far',
  iconName: 'face-tired',
  icon: [512, 512, [128555, "tired"], "f5c8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
const faTired = faFaceTired;
const faMoneyBills = {
  prefix: 'far',
  iconName: 'money-bills',
  icon: [640, 512, [], "e1f3", "M528 80c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
};
const faBlindsRaised = {
  prefix: 'far',
  iconName: 'blinds-raised',
  icon: [512, 512, [], "f8fd", "M24 0C10.7 0 0 10.7 0 24C0 34.6 6.9 43.6 16.4 46.8l-15 45C.5 94.6 0 97.5 0 100.5C0 115.7 12.3 128 27.5 128l84.5 0 0-48L55.9 80 66.6 48 112 48l32 0 0 32 0 48 0 80 0 48 0 116.1C116 382 96 408.6 96 440c0 39.8 32.2 72 72 72s72-32.2 72-72c0-31.4-20-58-48-67.9L192 256l0-48 0-80 0-48 0-32 32 0 221.4 0 10.7 32L224 80l0 48 260.5 0c15.2 0 27.5-12.3 27.5-27.5c0-3-.5-5.9-1.4-8.7l-15-45C505.1 43.6 512 34.6 512 24c0-13.3-10.7-24-24-24l-8 0L192 0 144 0 32 0 24 0zM144 440a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM112 208l-56.5 0 15.4-48-50.4 0L1.3 219.9c-.9 2.7-1.3 5.6-1.3 8.4C0 243.6 12.4 256 27.7 256l84.3 0 0-48zm112 48l260.3 0c15.3 0 27.7-12.4 27.7-27.7c0-2.9-.4-5.7-1.3-8.4L491.5 160l-50.4 0 15.4 48L224 208l0 48z"]
};
const faSmog = {
  prefix: 'far',
  iconName: 'smog',
  icon: [640, 512, [], "f75f", "M80 144c0-53 43-96 96-96c29.5 0 55.9 13.3 73.5 34.3c4.7 5.6 11.8 8.8 19.2 8.5s14.2-3.9 18.6-9.9c14.6-20 38.1-33 64.7-33c36.6 0 67.5 24.6 77 58.2c2 7.1 7.2 12.9 14.1 15.7s14.6 2.3 21-1.4c9.4-5.4 20.2-8.5 31.9-8.5c35.3 0 64 28.7 64 64s-28.7 64-64 64l-37 0c-6.5 0-12.8 2.7-17.3 7.4c-14.6 15.2-35 24.6-57.7 24.6s-43.1-9.4-57.7-24.6c-4.5-4.7-10.8-7.4-17.3-7.4l-133 0c-53 0-96-43-96-96zM176 0C96.5 0 32 64.5 32 144s64.5 144 144 144l123.3 0c22.5 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM552 464l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm280-72c0-13.3-10.7-24-24-24l-336 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24zM200 368L96 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
const faUfoBeam = {
  prefix: 'far',
  iconName: 'ufo-beam',
  icon: [576, 512, [], "e048", "M152.5 163.3l-16.9 17c-4-4-6.5-9.2-7-14.9c-.6-7-.8-14-.5-20.7c-22 6.7-40.3 14.6-53.9 23C52.5 181.2 48 192.2 48 197.9c0 4.1 2.2 11 12.6 20.2c10.4 9.1 26.8 18.4 49.1 26.7C154.2 261.3 217.2 272 288 272s133.8-10.7 178.3-27.2c22.3-8.3 38.7-17.6 49.1-26.7c10.4-9.2 12.6-16 12.6-20.2c0-5.7-4.5-16.7-26.2-30.1c-13.7-8.4-31.9-16.3-53.9-23c.3 6.8 .1 13.7-.5 20.7c-.5 5.6-3 10.9-7 14.9l-16.9-17c16.9 17 16.9 17 16.9 17.1s0 0 0 0c0 0 0 0 0 0l-.1 .1-.3 .3c-.2 .2-.4 .4-.7 .7c-.6 .5-1.3 1.1-2.1 1.9c-1.8 1.5-4.2 3.3-7.3 5.5c-6.3 4.3-15.4 9.7-27.7 14.9C377.4 214.2 340.3 224 288 224s-89.4-9.8-114.1-20.2c-12.3-5.2-21.4-10.6-27.7-14.9c-3.1-2.2-5.6-4-7.3-5.5c-.9-.7-1.6-1.4-2.1-1.9c-.3-.3-.5-.5-.7-.7l-.3-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0l16.9-17.1zM49 126.9c24-14.8 55.6-26.7 91.7-35.2C165.7 36.3 224.3 0 288 0s122.3 36.3 147.3 91.7c36.1 8.6 67.8 20.4 91.7 35.2c26.1 16.1 49 39.7 49 70.9c0 23-12.6 41.9-28.9 56.2c-16.3 14.4-38.6 26.2-64.1 35.7C432 308.7 363 320 288 320s-144-11.3-195-30.2c-25.4-9.5-47.7-21.3-64.1-35.7C12.6 239.8 0 220.8 0 197.9c0-31.2 22.9-54.8 49-70.9zm351 24c-.5-57.5-50.3-103-112-103s-111.4 45.5-112 103c3.8 2.4 9.3 5.5 16.7 8.6c18.4 7.8 49.1 16.4 95.3 16.4s76.9-8.6 95.3-16.4c7.4-3.1 12.9-6.2 16.7-8.6zM117.2 363.2l-72 136c-6.2 11.7-20.7 16.2-32.4 10S-3.4 488.5 2.8 476.8l72-136c6.2-11.7 20.7-16.2 32.4-10s16.2 20.7 10 32.4zm384-22.5l72 136c6.2 11.7 1.7 26.2-10 32.4s-26.2 1.7-32.4-10l-72-136c-6.2-11.7-1.7-26.2 10-32.4s26.2-1.7 32.4 10z"]
};
const faHydra = {
  prefix: 'far',
  iconName: 'hydra',
  icon: [640, 512, [], "e686", "M450.1 48c8.9 0 17.6 2.6 25 7.4l17.6 11.5c2 1.3 3.2 3.6 3.2 6c0 3.9-3.2 7.1-7.1 7.1l-15.3 0c-27.9 0-49.7 24-47 51.7l7.7 80.1c2.7 28-1.7 56.3-12.7 82.2l-3.6 8.5c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7l3.6-8.5c14.2-33.3 19.8-69.6 16.3-105.6L474.4 128l14.5 0c30.4 0 55.1-24.7 55.1-55.1c0-18.6-9.4-36-25.1-46.2L501.3 15.2C486.1 5.3 468.3 0 450.1 0l-1 0C395.5 0 352 43.5 352 97.1l0 66c0 24.8-20.1 44.8-44.8 44.8l-8.6 0c-49.7 0-95.9 25.3-122.8 67L156.6 305c-6 9.4-16.4 15-27.5 15c-25 0-40.8-27-28.5-48.8l24.2-43c.5-.8 .9-1.7 1.3-2.6c1.4-3.2 2-6.6 2-9.9s-.8-6.7-2.3-9.9c-1.2-2.6-2.9-4.9-4.9-7c-2.1-2.1-4.6-3.7-7.2-4.9c-3.2-1.4-6.6-2-9.9-2s-6.7 .8-9.8 2.3c-.9 .4-1.7 .9-2.6 1.4l-30 18C23.3 236.5 0 277.5 0 321.8C0 391.5 56.5 448 126.2 448l17.8 0 0 24c0 22.1 17.9 40 40 40l49.9 0c20.2 0 37.2-15 39.7-35l3.6-29 53.6 0 3.6 29c2.5 20 19.5 35 39.7 35l49.9 0c22.1 0 40-17.9 40-40l0-26.1c54.7-10.4 96-58.5 96-116.2l0-25.7 24.3 0c30.8 0 55.7-24.9 55.7-55.7c0-18-8.7-34.9-23.3-45.3l-24.1-17.2C576.4 174.2 557 168 537.1 168c-8.5 0-17 1.1-25.1 3.4l0 51.8c7.5-4.7 16.2-7.2 25.1-7.2c9.9 0 19.6 3.1 27.6 8.8l24.1 17.2c2 1.4 3.2 3.8 3.2 6.3c0 4.2-3.4 7.7-7.7 7.7L552 256c-22.1 0-40 17.9-40 40l0 33.7c0 38.8-31.5 70.3-70.3 70.3c-14.2 0-25.7 11.5-25.7 25.7l0 38.3-34.8 0-5.4-43c-1.5-12-11.7-21-23.8-21l-96 0c-12.1 0-22.3 9-23.8 21l-5.4 43L192 464l0-40c0-13.3-10.7-24-24-24l-41.8 0C83 400 48 365 48 321.8c0-6 .7-11.9 2-17.6c7.7 35 38.4 63.8 79 63.8c27.5 0 53.1-14 67.9-37.1L216.2 301c18-28 49.1-45 82.4-45l8.6 0c51.3 0 92.8-41.6 92.8-92.8l0-66C400 70 422 48 449.1 48l1 0zM250.4 176l48.2 0 1.4 0-1-6.3c-3.7-24-24.3-41.7-48.6-41.7l-19.3 0c-3.9 0-7.1-3.2-7.1-7.1c0-2.4 1.2-4.7 3.2-6l17.6-11.5c7.5-4.9 16.2-7.4 25-7.4l8.4 0c15.2 0 29.7 4.7 41.7 12.9l0-11.7c0-13.7 2.1-27 6.1-39.4c-14.8-6.3-31.1-9.8-47.8-9.8l-8.4 0c-18.2 0-36 5.3-51.2 15.2L201.1 74.7C185.4 84.8 176 102.2 176 120.9c0 30.4 24.7 55.1 55.1 55.1l19.3 0z"]
};
const faCircleCaretUp = {
  prefix: 'far',
  iconName: 'circle-caret-up',
  icon: [512, 512, ["caret-circle-up"], "f331", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c-6.7 0-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9s12.5 14.4 22 14.4l208 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112c-4.5-4.9-10.9-7.7-17.6-7.7z"]
};
const faCaretCircleUp = faCircleCaretUp;
const faUserVneckHairLong = {
  prefix: 'far',
  iconName: 'user-vneck-hair-long',
  icon: [448, 512, [], "e463", "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM48.3 461.9l351.5 0c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9c-41.4 16.9-71.3 56.4-74.4 103.1zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 322.2 448 389.5 448 469.9l0 8c0 17.7-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
const faSquareALock = {
  prefix: 'far',
  iconName: 'square-a-lock',
  icon: [576, 512, [], "e44d", "M64 80l320 0c8.8 0 16 7.2 16 16l0 84.1c14-9.8 30.3-16.4 48-18.9L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l256 0 0-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm181.8 61.9c-3.9-8.5-12.4-13.9-21.8-13.9s-17.9 5.4-21.8 13.9l-96 208c-5.6 12-.3 26.3 11.7 31.8s26.3 .3 31.8-11.7l12-26.1 124.4 0 12 26.1c4 8.8 12.7 13.9 21.8 13.9l0-32c0-11.4 3-22.1 8.2-31.4L245.8 141.9zM224 209.3L264 296l-80 0 40-86.7zM464 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faCrutch = {
  prefix: 'far',
  iconName: 'crutch',
  icon: [512, 512, [], "f7f7", "M329 7L505 183c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L295 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM164.2 201.9L287.4 78.6l33.9 33.9L249.9 184 328 262.1l71.4-71.4 33.9 33.9L310.1 347.8c-11.8 11.8-26.8 20-43.1 23.7L159.4 395.4c-7.4 1.7-14.2 5.4-19.6 10.8L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l98.8-98.8c5.4-5.4 9.1-12.2 10.8-19.6L140.5 245c3.6-16.3 11.8-31.3 23.7-43.1zM216 217.9l-17.9 17.9c-5.4 5.4-9.1 12.2-10.8 19.6l-19.8 89 89-19.8c7.4-1.7 14.2-5.4 19.6-10.8L294.1 296 216 217.9z"]
};
const faGasPumpSlash = {
  prefix: 'far',
  iconName: 'gas-pump-slash',
  icon: [640, 512, [], "f5f4", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-67.2-52.7C571.4 404.9 576 391 576 376l0-220.1c0-19.1-7.6-37.4-21.1-50.9L481 31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33 33 0 62.1c0 29.8 20.4 54.9 48 62l0 154c0 3.8-.9 7.4-2.5 10.6L384 275.7 384 64c0-35.3-28.7-64-64-64L160 0c-30.9 0-56.7 21.9-62.7 51L38.8 5.1zM144 87.6L144 64c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 174L144 87.6zM144 464l0-254.5L96 171.6 96 464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 48 0 192 0 48 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-65.5-48-37.8L336 464l-192 0z"]
};
const faFontAwesome = {
  prefix: 'far',
  iconName: 'font-awesome',
  icon: [512, 512, [62501, 62694, "font-awesome-flag", "font-awesome-logo-full"], "f2b4", "M91.7 96C106.3 86.8 116 70.5 116 52C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 3 0 48 0 256 0 48 0 64 48 0 0-64 389.6 0c14.6 0 26.4-11.8 26.4-26.4c0-3.7-.8-7.3-2.3-10.7L432 272l61.7-138.9c1.5-3.4 2.3-7 2.3-10.7c0-14.6-11.8-26.4-26.4-26.4L91.7 96zM80 400l0-256 356.4 0L388.1 252.5c-5.5 12.4-5.5 26.6 0 39L436.4 400 80 400z"]
};
const faFontAwesomeFlag = faFontAwesome;
const faFontAwesomeLogoFull = faFontAwesome;
const faCloudArrowUp = {
  prefix: 'far',
  iconName: 'cloud-arrow-up',
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
};
const faCloudUpload = faCloudArrowUp;
const faCloudUploadAlt = faCloudArrowUp;
const faPalette = {
  prefix: 'far',
  iconName: 'palette',
  icon: [512, 512, [127912], "f53f", "M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8L344 272c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6c0 0 0 0 0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTransporter4 = {
  prefix: 'far',
  iconName: 'transporter-4',
  icon: [512, 512, [], "e2a5", "M224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 64l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM472.7 134.6L480 160l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 192l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 192l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 160l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm-416 224L64 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L64 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L32 416 6.6 408.7C2.7 407.6 0 404.1 0 400s2.7-7.6 6.6-8.7L32 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24z"]
};
const faChartMixedUpCircleCurrency = {
  prefix: 'far',
  iconName: 'chart-mixed-up-circle-currency',
  icon: [576, 512, [], "e5d8", "M408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.5 0L320.2 168.2 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2L496 80.7l0 55.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L408 0zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L396.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z"]
};
const faObjectsAlignRight = {
  prefix: 'far',
  iconName: 'objects-align-right',
  icon: [512, 512, [], "e3bf", "M512 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464zM336 176L48 176l0-64 288 0 0 64zm48-64c0-26.5-21.5-48-48-48L48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-64zM336 400l-160 0 0-64 160 0 0 64zm48-64c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64z"]
};
const faArrowsTurnRight = {
  prefix: 'far',
  iconName: 'arrows-turn-right',
  icon: [448, 512, [], "e4c0", "M294.4 7.7c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L362.9 152 120 152c-39.8 0-72 32.2-72 72l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-66.3 53.7-120 120-120l242.9 0L295.7 41.6c-9.7-9-10.3-24.2-1.3-33.9zm-96 256c9-9.7 24.2-10.3 33.9-1.3l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 408 88 408c-22.1 0-40 17.9-40 40l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-48.6 39.4-88 88-88l178.9 0-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9z"]
};
const faVest = {
  prefix: 'far',
  iconName: 'vest',
  icon: [448, 512, [], "e085", "M104 0l8.3 0 5 0c19.4 0 35.2 10 45.5 19.2C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8C295.5 10 311.3 0 330.7 0l5 0L344 0c1.9 0 3.8 .1 5.7 .3C378 3.2 400 27 400 56l0 72 0 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37L448 456c0 30.9-25.1 56-56 56l-128 0c-30.9 0-56-25.1-56-56l0-160.9c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5l28.8 95-25.1 82.8L119.9 53.7c-1-3.4-4.1-5.7-7.7-5.7L104 48c-4.4 0-8 3.6-8 8l0 72 0 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3l0 104.8 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L51.4 462.5c1.3 .9 2.9 1.5 4.6 1.5l120.4 0c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1L56 512c-30.9 0-56-25.1-56-56L0 293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3L48 128l0-72C48 25.1 73.1 0 104 0zM352 56c0-4.4-3.6-8-8-8c0 0 0 0 0 0l-8.3 0c-3.5 0-6.6 2.3-7.7 5.7L257 288.2c-.7 2.3-1 4.6-1 7L256 456c0 4.4 3.6 8 8 8l128 0c1.7 0 3.3-.5 4.6-1.5L311 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55 0-104.8c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37l0-58.7 0-72z"]
};
const faPig = {
  prefix: 'far',
  iconName: 'pig',
  icon: [640, 512, [128022], "f706", "M475 32c-4 0-7.9 .5-11.8 1.5L417.1 45c-21.1 5.3-38.6 18-50.2 35L240 80C162.6 80 98 135 83.2 208l-35.8 0c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240L80 240l0 16c0 55.8 31.8 104.2 78.1 128.1l22.3 68.3c5.4 16.5 20.7 27.6 38 27.6l45.5 0c22.1 0 40-17.9 40-40l0-24 16 0 32 0 0 24c0 22.1 17.9 40 40 40l45.5 0c17.3 0 32.7-11.1 38-27.6l13.7-42.1c26.1-7.5 49.6-22.2 67.8-42.4l34.9 0c26.5 0 48-21.5 48-48l0-80c0-26.5-21.5-48-48-48l-8.7 0c-6.7-4.7-12.5-10.5-17.2-17.3c0 0 0 0 0 0c21-14.9 33.9-39.3 33.9-65.6C600 93 587 80 570.9 80L552 80l0 29.1c0 12.2-6.9 23.4-17.8 28.9c-4.1-3.8-8.4-7.4-12.7-10.8c4.2-10.3 6.5-21.5 6.5-33.2l0-11.7C528 54.5 505.5 32 477.7 32L475 32zm-.1 48c0 0 .1 0 .1 0c0 0 0 0 0 0l2.6 0c1.3 0 2.3 1 2.3 2.3L480 94c0 9.4-3.3 18.2-8.9 25.1c-4.3 5.3-6.1 12.2-5 19s5.1 12.7 10.9 16.4c19.3 12.2 36.3 28.2 49.7 47.6c8.8 12.8 20.1 23.6 33.1 31.9c6.7 4.3 14.1 6 20.9 6l11.3 0 0 80-38.2 0c-12.8 0-23.8 6.1-31.1 14.5c-14.5 16.7-34.3 28.1-56.3 32c-8.7 1.6-15.8 7.8-18.6 16.2L431.7 432 400 432l0-40c0-13.3-10.7-24-24-24l-56 0-40 0c-13.3 0-24 10.7-24 24l0 40-31.7 0-23.7-72.7c-2.2-6.6-7.1-12-13.6-14.7c-34.7-14.5-59-48.8-59-88.6l0-16c0-61.9 50.1-112 112-112l141 0c9.6 0 18.3-5.7 22.1-14.5c4.6-10.7 13.9-19 25.7-21.9L474.9 80zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
const faInboxFull = {
  prefix: 'far',
  iconName: 'inbox-full',
  icon: [512, 512, [], "e1ba", "M48 416c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80-81.2 0-20.9 41.9c-6.8 13.6-20.6 22.1-35.8 22.1l-140.2 0c-15.2 0-29-8.6-35.8-22.1L129.2 336 48 336l0 80zM405.6 92.1C403.8 85 397.4 80 390 80L122 80c-7.3 0-13.7 5-15.5 12.1L57.5 288l76.6 0c15.2 0 29 8.6 35.8 22.1L190.8 352l130.3 0 20.9-41.9c6.8-13.6 20.6-22.1 35.8-22.1l76.6 0-49-195.9zM0 416l0-88.1c0-5.2 .6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32L390 32c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5l0 88.1c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM184 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-32 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCircleEnvelope = {
  prefix: 'far',
  iconName: 'circle-envelope',
  icon: [512, 512, ["envelope-circle"], "e10c", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-7.3-256.4c2.2 1.2 4.7 1.9 7.3 1.9s5.1-.6 7.3-1.9l120.6-66.4C382.5 172.9 368.7 160 352 160l-192 0c-16.7 0-30.5 12.9-31.9 29.3l120.6 66.4zm30 28c-7 3.8-14.8 5.8-22.7 5.8s-15.8-2-22.7-5.8L128 225.7l0 94.3c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.3L278.7 283.6z"]
};
const faEnvelopeCircle = faCircleEnvelope;
const faTrianglePersonDigging = {
  prefix: 'far',
  iconName: 'triangle-person-digging',
  icon: [640, 512, ["construction"], "f85d", "M70.3 464L320 55.3 570.2 464 70.3 464zM285.9 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512l528.5 0c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm36.5 100.1l-19.7-49.2c-8.4-21.1-28.9-34.9-51.6-34.9c-18.6 0-35.9 9.3-46.3 24.8l-4.2 6.4c-2.5 3.7-3.3 8.2-2.3 12.5s3.8 8 7.6 10.2l153.5 88.6-15.2 25.4c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1l96 0c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8L402 355l-53.5-30.9zm-131.6-3.4l-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2L272 392.9l0 23.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8z"]
};
const faConstruction = faTrianglePersonDigging;
const faFerry = {
  prefix: 'far',
  iconName: 'ferry',
  icon: [576, 512, [], "e4ea", "M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l68 0c17.1 0 28.7 17.4 22.2 33.2L468 80l4 0c30.9 0 56 25.1 56 56l0 157.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L463.5 320 424 320l-272 0-39.5 0 35.2 50.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L58.1 326C51.5 316.6 48 305.4 48 293.9L48 136c0-30.9 25.1-56 56-56l4 0-6.2-14.8C95.3 49.4 106.9 32 124 32l68 0zM480 272l0-136c0-4.4-3.6-8-8-8l-24 0-320 0-24 0c-4.4 0-8 3.6-8 8l0 136 32 0 0-88c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24l0 88 32 0zM176 208l0 64 224 0 0-64-224 0zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faBullseyeArrow = {
  prefix: 'far',
  iconName: 'bullseye-arrow',
  icon: [512, 512, [127919], "f648", "M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zm-93.9-29.4l50.7 8.4c10.2 1.7 20.6-1.6 27.9-8.9l51.2-51.2c8.1-8.1 5.3-21.9-5.4-26.2L432 80 409 22.5c-4.3-10.7-18-13.5-26.2-5.4L331.6 68.4c-7.3 7.3-10.6 17.7-8.9 27.9l8.4 50.7L239 239c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l92.1-92.1z"]
};
const faArrowsDownToPeople = {
  prefix: 'far',
  iconName: 'arrows-down-to-people',
  icon: [640, 512, [], "e4b9", "M120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0L63 153c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L120 24zm295 95c9.4-9.4 24.6-9.4 33.9 0l23 23L472 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 118.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm81 137a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM480 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5zm98.9 27.4l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8l-18.9-35 0 39.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-39.7-18.9 35c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8l-18.9-35 0 23.7c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-23.7-18.9 35c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3l19.5 0c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6l19.5 0c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8zM280 200a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm24 104.5l0 79.5 32 0 0-79.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM128 464l32 0 0-63.5c-2-.3-4.1-.5-6.2-.5l-19.5 0c-2.1 0-4.2 .2-6.2 .5l0 63.5z"]
};
const faSeedling = {
  prefix: 'far',
  iconName: 'seedling',
  icon: [512, 512, [127793, "sprout"], "f4d8", "M307.3 207c82.9-9.1 148.4-75.6 156-159L456 48c-76.7 0-142 49.1-166.1 117.5c-8.8-16.8-19.4-32.6-31.6-47.1C296.1 48 370.5 0 456 0l24 0c17.7 0 32 14.3 32 32c0 113.6-84.6 207.4-194.2 222c-2.1-16.2-5.6-31.9-10.5-47.1zM48 112l0 16c0 97.2 78.8 176 176 176l8 0 0-16c0 0 0 0 0 0c0-97.2-78.8-176-176-176l-8 0zM280 288l0 16 0 48 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-8 0C100.3 352 0 251.7 0 128L0 96C0 78.3 14.3 64 32 64l24 0c123.7 0 224 100.3 224 224z"]
};
const faSprout = faSeedling;
const faClockSeven = {
  prefix: 'far',
  iconName: 'clock-seven',
  icon: [512, 512, [], "e350", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 128.7-60 90c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l64-96c2.6-3.9 4-8.6 4-13.3l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faLeftRight = {
  prefix: 'far',
  iconName: 'left-right',
  icon: [512, 512, [8596, "arrows-alt-h"], "f337", "M505.6 239.7c8.5 9.2 8.5 23.4 0 32.6l-89.4 96.8c-8.8 9.5-21.1 14.9-34 14.9c-25.5 0-46.3-20.7-46.3-46.3l0-9.7-160 0 0 9.7c0 25.5-20.7 46.3-46.3 46.3c-12.9 0-25.2-5.4-34-14.9L6.4 272.3c-8.5-9.2-8.5-23.4 0-32.6l89.4-96.8c8.8-9.5 21.1-14.9 34-14.9c25.5 0 46.3 20.7 46.3 46.3l0 9.7 160 0 0-9.7c0-25.5 20.7-46.3 46.3-46.3c12.9 0 25.2 5.4 34 14.9l89.4 96.8zM384 178.7l0 29.3c0 13.3-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24l0-29.3L56.7 256 128 333.3l0-29.3c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24l0 29.3L455.3 256 384 178.7zm-253-3.3s0 0 0 0l-1.3-1.2 1.3 1.2s0 0 0 0z"]
};
const faArrowsAltH = faLeftRight;
const faBoxesPacking = {
  prefix: 'far',
  iconName: 'boxes-packing',
  icon: [640, 512, [], "e4c7", "M592 48L304 48l0 80-48 0 0-80c0-26.5 21.5-48 48-48L592 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-210.7 0c1.8-5 2.7-10.4 2.7-16l0-32 208 0 0-416zM561 311c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 70.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l64-64c9.4-9.4 24.6-9.4 33.9 0l64 64zM48 208l0 48 32 0 224 0 32 0 0-48L48 208zM0 272l0-80c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32l0 176c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-176c-17.7 0-32-14.3-32-32zm80 32l0 160 224 0 0-160L80 304zm72 32l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCircleArrowLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-left',
  icon: [512, 512, ["arrow-circle-left"], "f0a8", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM207 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L376 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-182.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
const faArrowCircleLeft = faCircleArrowLeft;
const faFlashlight = {
  prefix: 'far',
  iconName: 'flashlight',
  icon: [640, 512, [128294], "f8b8", "M384 304L48 304l0-96 336 0c11.6 0 22.9-4.2 31.7-11.9l.1-.1c.2-.2 .7-.6 1.4-1.2c1.5-1.2 3.9-3.1 7.4-5.4c6.9-4.8 17.5-11.4 31.4-18.2c15-7.3 33.9-14.6 56.1-19.8l0 209.3c-22.2-5.2-41-12.5-56.1-19.8c-14-6.8-24.5-13.4-31.4-18.2c-3.4-2.4-5.9-4.3-7.4-5.4c-.7-.6-1.2-1-1.4-1.2l-.1-.1c-8.8-7.7-20-11.9-31.6-11.9zm192 64c-5.5 0-10.8-.2-16-.4l0-223.1c5.2-.3 10.5-.4 16-.4l16 0 0 224-16 0zM384 160L48 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l336 0s72 64 192 64l32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0c-120 0-192 64-192 64zM248 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"]
};
const faFileJpg = {
  prefix: 'far',
  iconName: 'file-jpg',
  icon: [512, 512, [], "e646", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm144 48c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 26.5-21.5 48-48 48zm96-160l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm80-40c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80z"]
};
const faGroupArrowsRotate = {
  prefix: 'far',
  iconName: 'group-arrows-rotate',
  icon: [512, 512, [], "e4f6", "M215 34.4c3.8 12.7-3.5 26.1-16.2 29.8c-14.2 4.2-27.8 10-40.5 17.1C159.4 86.1 160 91 160 96c0 35.3-28.7 64-64 64c-5 0-9.9-.6-14.6-1.7c-7.1 12.7-12.9 26.3-17.1 40.5c-3.8 12.7-17.1 19.9-29.8 16.2s-19.9-17.1-16.2-29.8c5.7-19.3 13.8-37.7 23.8-54.7C35.7 120.5 32 108.7 32 96c0-35.3 28.7-64 64-64c12.7 0 24.5 3.7 34.5 10.1c17-10 35.4-18 54.7-23.8c12.7-3.8 26.1 3.5 29.8 16.2zm82 0c3.8-12.7 17.1-19.9 29.8-16.2c19.3 5.7 37.7 13.8 54.7 23.8C391.5 35.7 403.3 32 416 32c35.3 0 64 28.7 64 64c0 12.7-3.7 24.5-10.1 34.5c10 17 18 35.4 23.8 54.7c3.8 12.7-3.5 26.1-16.2 29.8s-26.1-3.5-29.8-16.2c-4.2-14.2-10-27.8-17.1-40.5c-4.7 1.1-9.6 1.7-14.6 1.7c-35.3 0-64-28.7-64-64c0-5 .6-9.9 1.7-14.6c-12.7-7.1-26.3-12.9-40.5-17.1c-12.7-3.8-19.9-17.1-16.2-29.8zM34.4 297c12.7-3.8 26.1 3.5 29.8 16.2c4.2 14.2 10 27.8 17.1 40.5C86.1 352.6 91 352 96 352c35.3 0 64 28.7 64 64c0 5-.6 9.9-1.7 14.6c12.7 7.1 26.3 12.9 40.5 17.1c12.7 3.8 19.9 17.1 16.2 29.8s-17.1 19.9-29.8 16.2c-19.3-5.8-37.7-13.8-54.7-23.8c-10 6.4-21.8 10.1-34.5 10.1c-35.3 0-64-28.7-64-64c0-12.7 3.7-24.5 10.1-34.5c-10-17-18-35.4-23.8-54.7c-3.8-12.7 3.5-26.1 16.2-29.8zm443.1 0c12.7 3.8 19.9 17.1 16.2 29.8c-5.8 19.3-13.8 37.7-23.8 54.7c6.4 10 10.1 21.8 10.1 34.5c0 35.3-28.7 64-64 64c-12.7 0-24.5-3.7-34.5-10.1c-17 10-35.4 18-54.7 23.8c-12.7 3.8-26.1-3.5-29.8-16.2s3.5-26.1 16.2-29.8c14.2-4.2 27.8-10 40.5-17.1c-1.1-4.7-1.7-9.6-1.7-14.6c0-35.3 28.7-64 64-64c5 0 9.9 .6 14.6 1.7c7.1-12.7 12.9-26.3 17.1-40.5c3.8-12.7 17.1-19.9 29.8-16.2zM112 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zM96 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192.8 256.8c0 24.8 14.1 46.4 34.9 57c11.8 6 16.5 20.5 10.4 32.3s-20.5 16.5-32.3 10.4c-36.2-18.5-61.1-56.2-61.1-99.8c0-28.9 11-55.2 28.9-75.1l-11.2-11.2c-6.6-6.6-1.9-17.8 7.4-17.8l60.5 0c5.7 0 10.4 4.7 10.4 10.4l0 60.5c0 9.3-11.2 13.9-17.8 7.4l-15.3-15.3c-9.3 11.1-14.9 25.4-14.9 41.1zm93.1-58.6c-11.8-6-16.5-20.5-10.4-32.3s20.5-16.5 32.3-10.4c36.2 18.5 61.1 56.2 61.1 99.8c0 28.9-11 55.2-28.9 75.1L351 341.5c6.6 6.6 1.9 17.8-7.4 17.8l-60.5 0c-5.7 0-10.4-4.7-10.4-10.4l0-60.5c0-9.3 11.2-13.9 17.8-7.4l15.3 15.3c9.3-11.1 14.9-25.4 14.9-41.1c0-24.8-14.1-46.4-34.9-57z"]
};
const faBowlFood = {
  prefix: 'far',
  iconName: 'bowl-food',
  icon: [512, 512, [], "e4c6", "M0 192c0 11.7 3.1 22.6 8.6 32l494.9 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64c-.5 0-1.1 0-1.6 0C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64zM144.7 420.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304l412.4 0c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4l-192 0c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256z"]
};
const faSquare9 = {
  prefix: 'far',
  iconName: 'square-9',
  icon: [448, 512, [], "e25e", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 272a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-26 44.4l-29.6 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l81.6-70C305.8 287.2 320 256.4 320 224c0-53-43-96-96-96s-96 43-96 96c0 44 29.6 81.1 70 92.4z"]
};
const faCandyCane = {
  prefix: 'far',
  iconName: 'candy-cane',
  icon: [512, 512, [], "f786", "M343 82.3c5.8-1.5 11.9-2.3 18-2.3c13.8 0 26.7 3.9 37.6 10.8l23-23C404.6 55.3 383.6 48 361 48c-9.6 0-19 1.3-28.1 3.9L343 82.3zm78.3 31.1c6.8 10.9 10.8 23.8 10.8 37.6l0 5.6c0 3.5-.2 6.9-.7 10.3l30.7 10.2c1.3-6.7 1.9-13.6 1.9-20.5l0-5.6c0-22.7-7.3-43.6-19.7-60.7l-23 23zm30.2 93.9L420.5 197c-6.1 9.8-14.4 18.3-24.5 24.6l-51.2 32L375 272.5l37.9-23.7c16.5-10.3 29.7-24.7 38.5-41.4zm-106.6 84l-30.2-18.9-77 48.1 30.2 18.9 77-48.1zm-107.2 67l-30.2-18.9-73 45.6L164.6 404l73-45.6zM134.4 422.9L104.2 404 55.5 434.4c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l61.9-38.7zM303.6 65.4l-24.1 15c-7.5 4.7-9.8 14.6-5.1 22s14.6 9.8 22 5.1l17.5-11L303.6 65.4zM361 128c-4.3 0-8.6 1.2-12.2 3.5l-26.8 16.8c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23C304.9 8 332.7 0 361 0c83.4 0 151 67.6 151 151l0 5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L370.5 180.9c8.4-5.2 13.5-14.4 13.5-24.3l0-5.6c0-12.7-10.3-23-23-23z"]
};
const faArrowDownWideShort = {
  prefix: 'far',
  iconName: 'arrow-down-wide-short',
  icon: [576, 512, ["sort-amount-asc", "sort-amount-down"], "f160", "M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 480l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zm0-128l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faSortAmountAsc = faArrowDownWideShort;
const faSortAmountDown = faArrowDownWideShort;
const faSquareDollar = {
  prefix: 'far',
  iconName: 'square-dollar',
  icon: [448, 512, ["dollar-square", "usd-square"], "f2e9", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm244.8 37.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
const faDollarSquare = faSquareDollar;
const faUsdSquare = faSquareDollar;
const faPhoneArrowRight = {
  prefix: 'far',
  iconName: 'phone-arrow-right',
  icon: [512, 512, [], "e5be", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM425 7l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L312 128c-13.3 0-24-10.7-24-24s10.7-24 24-24l118.1 0L391 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faHandHoldingSeedling = {
  prefix: 'far',
  iconName: 'hand-holding-seedling',
  icon: [576, 512, [], "f4bf", "M115.6 0C96 0 80 16 80 35.6C80 113.2 142.8 176 220.4 176l43.6 0 0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104C312 68.1 243.9 0 160 0L115.6 0zM160 48c49.2 0 90.4 34.1 101.2 80l-40.9 0c-46.8 0-85.5-34.8-91.5-80L160 48zm5.2 310.7c6.6-4.4 14.3-6.7 22.2-6.7L344 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 24 0 48 0c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9l7.4 0c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l363.7 0c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3l-7.4 0c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64l-156.6 0c-17.4 0-34.4 5.1-48.8 14.8L64.7 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.7 0 9.4-1.4 13.3-4l79.9-53.3zM355.6 176C433.2 176 496 113.2 496 35.6C496 16 480 0 460.4 0L416 0c-41.7 0-79.5 16.8-107 44c10 13.8 18.1 29 24 45.2C352 64.2 382.1 48 416 48l31.2 0c-6 45.2-44.7 80-91.5 80l-13.2 0c1 7.9 1.6 15.9 1.6 24l0 24 11.6 0z"]
};
const faMessageCheck = {
  prefix: 'far',
  iconName: 'message-check',
  icon: [512, 512, ["comment-alt-check"], "f4a2", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM369 153c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 153z"]
};
const faCommentAltCheck = faMessageCheck;
const faCloudBolt = {
  prefix: 'far',
  iconName: 'cloud-bolt',
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M184 48c-39.8 0-72 32.2-72 72c0 2.6 .1 5.2 .4 7.7c1.3 12-6.6 23.1-18.3 25.9C67.6 159.9 48 183.7 48 212c0 32.2 25.3 58.4 57.1 59.9c.3 0 .7 0 1 .1l1.9 0 95.2 0-60 48L108 320l-4 0c-1.2 0-2.4-.1-3.5-.3C44.3 315.9 0 269.1 0 212c0-44.1 26.4-81.9 64.2-98.7C67.7 50.1 120 0 184 0c33.9 0 64.5 14.1 86.3 36.6C285.1 28.6 302 24 320 24c46.9 0 86.5 31 99.5 73.7C472.1 106.9 512 152.8 512 208c0 61.9-50.1 112-112 112l-48 0-18.3 0 24-48 42.3 0c35.3 0 64-28.7 64-64s-28.6-64-64-64c0 0 0 0 0 0l-.3 0c-12.4 0-22.7-9.3-23.9-21.6C372.9 94.1 349 72 320 72c-14.7 0-28.1 5.7-38.1 15c-5.3 4.9-12.4 7.2-19.5 6.2s-13.4-5-17.2-11.1C232.5 61.6 209.8 48 184 48zM330.1 227.6c5.8 4.7 7.6 12.9 4.3 19.6L281.9 352l70.1 0c6.8 0 12.8 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 384 160 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
const faThunderstorm = faCloudBolt;
const faChartLineUpDown = {
  prefix: 'far',
  iconName: 'chart-line-up-down',
  icon: [512, 512, [], "e5d7", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zm352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-22.1L305 273c-9.4 9.4-24.6 9.4-33.9 0l-63-63-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l63 63L398.1 112 376 112zm0 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.1 0-47-47L385 255l47 47 0-22.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 6.4-2.5 12.5-7 17s-10.6 7-17 7l-80 0z"]
};
const faTextSlash = {
  prefix: 'far',
  iconName: 'text-slash',
  icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80l124.8 0-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1C576.6 56.5 557.5 32 531.5 32l-335 0c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zM191.5 124.8L202.7 80l143.8 0L308.1 216.2 191.5 124.8zm57.4 300.7l-1.8 6.5L192 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.1 0 23.6-83.5-40.8-32.1L248.9 425.5z"]
};
const faRemoveFormat = faTextSlash;
const faWatch = {
  prefix: 'far',
  iconName: 'watch',
  icon: [384, 512, [8986], "f2e1", "M112 0C85.5 0 64 21.5 64 48l0 64 1 0C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144l-1 0 0 64c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-64-1 0c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144l1 0 0-64c0-26.5-21.5-48-48-48L112 0zM48 256a144 144 0 1 1 288 0A144 144 0 1 1 48 256zm168-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 8 4 15.5 10.7 20l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L216 243.2l0-67.2z"]
};
const faCircleDownLeft = {
  prefix: 'far',
  iconName: 'circle-down-left',
  icon: [512, 512, [], "e107", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM160 198.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6L232 216l66.3-66.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7l36.7 36.7c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7L296 280l33.4 33.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L176 352c-8.8 0-16-7.2-16-16l0-137.4z"]
};
const faText = {
  prefix: 'far',
  iconName: 'text',
  icon: [448, 512, [], "f893", "M48 80l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 72C0 49.9 17.9 32 40 32l368 0c22.1 0 40 17.9 40 40l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48L248 80l0 352 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-352L48 80z"]
};
const faProjector = {
  prefix: 'far',
  iconName: 'projector',
  icon: [640, 512, [], "f8d6", "M424 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM265 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L265 39zM569 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L479 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56-56zM288 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm272 0c0-29.1-7.8-56.5-21.4-80l37.4 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-37.4 0c13.6-23.5 21.4-50.9 21.4-80zM400 480c36 0 69.3-11.9 96-32l16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-80 0c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32L64 192c-35.3 0-64 28.7-64 64L0 384c0 35.3 28.7 64 64 64l16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 176 0c26.7 20.1 60 32 96 32zM240 320c0 29.1 7.8 56.5 21.4 80L64 400c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l197.4 0c-13.6 23.5-21.4 50.9-21.4 80zm-112 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFaceSmileWink = {
  prefix: 'far',
  iconName: 'face-smile-wink',
  icon: [512, 512, [128521, "smile-wink"], "f4da", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
const faSmileWink = faFaceSmileWink;
const faTombstoneBlank = {
  prefix: 'far',
  iconName: 'tombstone-blank',
  icon: [448, 512, [129702, "tombstone-alt"], "f721", "M368 192l0 240 48 0 0-240C416 86 330 0 224 0S32 86 32 192l0 240 48 0 0-240c0-79.5 64.5-144 144-144s144 64.5 144 144zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z"]
};
const faTombstoneAlt = faTombstoneBlank;
const faChessKingPiece = {
  prefix: 'far',
  iconName: 'chess-king-piece',
  icon: [256, 512, ["chess-king-alt"], "f440", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L66.9 96C43.2 96 24 115.2 24 138.9c0 4.7 .8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352l48 0 2.1-96 57.6 0 2.1 96 48 0-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5c0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8c0-23.7-19.2-42.9-42.9-42.9L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm16.2 192l-64.4 0L74 144l108 0-21.8 64zm-91 224l117.6 0 16.6 32L52.7 464l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l174.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3l-137 0z"]
};
const faChessKingAlt = faChessKingPiece;
const faCircle6 = {
  prefix: 'far',
  iconName: 'circle-6',
  icon: [512, 512, [], "e0f3", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-96-48c0-32.4 14.2-63.2 38.8-84.3l81.6-70c10.1-8.6 25.2-7.5 33.8 2.6s7.5 25.2-2.6 33.8L282 195.6c40.4 11.4 70 48.4 70 92.4c0 53-43 96-96 96s-96-43-96-96z"]
};
const faWavesSine = {
  prefix: 'far',
  iconName: 'waves-sine',
  icon: [640, 512, [], "e65d", "M95.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C112.4 446.8 77.2 480 24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24c29 0 51.3-16.8 71.9-50.9zM248.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C231.6 65.2 266.8 32 320 32s88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7c0 0 0 0 0 0s0 0 0 0l.6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C564.7 415.2 587 432 616 432c13.3 0 24 10.7 24 24s-10.7 24-24 24c-53.2 0-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C371.3 96.8 349 80 320 80s-51.3 16.8-71.9 50.9zM391.9 381.1c12.7-21.1 23.5-46.7 33.7-75c7.4 22 15.6 44.7 24.9 66.4c-5.4 11.8-11.2 23-17.5 33.4C408.4 446.8 373.2 480 320 480s-88.4-33.2-113-74.1c-24-39.8-41.2-91.9-57.2-140.7l-.6-1.7c-16.7-50.8-32.4-97.9-53.3-132.6C75.3 96.8 53 80 24 80C10.7 80 0 69.3 0 56S10.7 32 24 32c53.2 0 88.4 33.2 113 74.1c24 39.8 41.2 91.9 57.2 140.7l.6 1.7c16.7 50.8 32.4 97.9 53.3 132.6C268.7 415.2 291 432 320 432s51.3-16.8 71.9-50.9zM544.1 130.9c-12.7 21.1-23.5 46.7-33.7 75c-7.4-22-15.6-44.7-24.9-66.4c5.4-11.8 11.2-23 17.5-33.4C527.6 65.2 562.8 32 616 32c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29 0-51.3 16.8-71.9 50.9z"]
};
const faLeft = {
  prefix: 'far',
  iconName: 'left',
  icon: [448, 512, ["arrow-alt-left"], "f355", "M50.4 256L200.3 113.3c.8-.8 2-1.3 3.2-1.3c2.5 0 4.6 2 4.6 4.6l0 83.4c0 13.3 10.7 24 24 24l168 0 0 64-168 0c-13.3 0-24 10.7-24 24l0 83.4c0 2.5-2 4.6-4.6 4.6c-1.2 0-2.3-.5-3.2-1.3L50.4 256zm153-192c-13.5 0-26.5 5.2-36.3 14.5L13.2 225.1C4.8 233.2 0 244.3 0 256s4.8 22.8 13.2 30.9L167.2 433.5c9.8 9.3 22.8 14.5 36.3 14.5c29 0 52.6-23.5 52.6-52.6l0-59.4 144 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-144 0 0-59.4c0-29-23.5-52.6-52.6-52.6z"]
};
const faArrowAltLeft = faLeft;
const faFileWord = {
  prefix: 'far',
  iconName: 'file-word',
  icon: [384, 512, [], "f1c2", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"]
};
const faFilePowerpoint = {
  prefix: 'far',
  iconName: 'file-powerpoint',
  icon: [384, 512, [], "f1c4", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z"]
};
const faSquareDown = {
  prefix: 'far',
  iconName: 'square-down',
  icon: [448, 512, [11015, "arrow-alt-square-down"], "f350", "M400 416l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16zm48 0c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM328.8 294.6l-91 84c-3.8 3.5-8.7 5.4-13.9 5.4s-10.1-1.9-13.9-5.4l-91-84c-4.6-4.2-7.2-10.1-7.2-16.4c0-12.3 10-22.3 22.3-22.3l41.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 41.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.2 16.4z"]
};
const faArrowAltSquareDown = faSquareDown;
const faObjectsAlignCenterVertical = {
  prefix: 'far',
  iconName: 'objects-align-center-vertical',
  icon: [512, 512, [], "e3bd", "M112 80l0 352 64 0 0-352-64 0zM64 80c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 152 64 0 0-88c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 88 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 88c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-88-64 0 0 152c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-152-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L64 80zm272 64l0 224 64 0 0-224-64 0z"]
};
const faArrowsLeftRight = {
  prefix: 'far',
  iconName: 'arrows-left-right',
  icon: [512, 512, ["arrows-h"], "f07e", "M505 273c9.4-9.4 9.4-24.6 0-33.9l-96-96c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L81.9 232l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 348.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"]
};
const faArrowsH = faArrowsLeftRight;
const faHouseLock = {
  prefix: 'far',
  iconName: 'house-lock',
  icon: [640, 512, [], "e510", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L492.2 165.8c-16.3 5.5-31 14.7-43 26.5L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 152s0 0 0 0l0 16c0 11.7 3.1 22.6 8.6 32L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM240 464l96 0 0-144-96 0 0 144zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faCloudArrowDown = {
  prefix: 'far',
  iconName: 'cloud-arrow-down',
  icon: [640, 512, [62337, "cloud-download", "cloud-download-alt"], "f0ed", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM223 313l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39L344 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 134.1-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
const faCloudDownload = faCloudArrowDown;
const faCloudDownloadAlt = faCloudArrowDown;
const faWreath = {
  prefix: 'far',
  iconName: 'wreath',
  icon: [448, 512, [], "f7e2", "M339.4 88.7c-24.5 7.3-50.4-5.9-58.9-30c-2.2-6.3-8.2-10.7-15.1-10.7c-4 0-7.5 1.4-10.3 3.8c-17.9 15.2-44.2 15.2-62.1 0c-2.8-2.4-6.3-3.8-10.3-3.8c-6.9 0-12.9 4.4-15.1 10.7c-8.5 24.1-34.4 37.3-58.9 30c-1.4-.4-2.9-.7-4.6-.7c-8.8 0-16 7.2-16 16c0 1.7 .2 3.2 .7 4.6c7.3 24.5-5.9 50.4-30 58.9c-6.3 2.2-10.7 8.2-10.7 15.1c0 4 1.4 7.5 3.8 10.3c15.2 17.9 15.2 44.2 0 62.2c-2.4 2.8-3.8 6.3-3.8 10.3c0 6.9 4.4 12.9 10.7 15.1c24.1 8.5 37.3 34.4 30 58.9c-.4 1.4-.7 2.9-.7 4.6c0 8.8 7.2 16 16 16c1.7 0 3.2-.2 4.6-.7c5.4-1.6 10.8-2.2 16.1-1.9c-17 8.5-28.7 26.1-28.7 46.4l0 3.7c-31.6-3.9-56-30.9-56-63.5c0-6.3 .9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3C40.9 116.5 40 110.3 40 104c0-35.3 28.7-64 64-64c6.3 0 12.5 .9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6c5.8-1.7 11.9-2.6 18.2-2.6c35.3 0 64 28.7 64 64c0 6.3-.9 12.5-2.6 18.2c24.8 8.8 42.6 32.5 42.6 60.3c0 15.8-5.7 30.2-15.2 41.4c9.5 11.2 15.2 25.6 15.2 41.4c0 27.9-17.8 51.6-42.6 60.3c1.7 5.8 2.6 11.9 2.6 18.2c0 32.6-24.4 59.6-56 63.5l0-3.7c0-20.3-11.7-37.9-28.7-46.4c5.3-.3 10.8 .3 16.1 1.9c1.4 .4 2.9 .7 4.6 .7c8.8 0 16-7.2 16-16c0-1.7-.2-3.2-.7-4.6c-7.3-24.5 5.9-50.4 30-58.9c6.3-2.2 10.7-8.2 10.7-15.1c0-4-1.4-7.5-3.8-10.3c-15.2-17.9-15.2-44.2 0-62.2c2.4-2.8 3.8-6.3 3.8-10.3c0-6.9-4.4-12.9-10.7-15.1c-24.1-8.5-37.3-34.4-30-58.9c.4-1.4 .7-2.9 .7-4.6c0-8.8-7.2-16-16-16c-1.7 0-3.2 .2-4.6 .7zM128 492.2l0-88.4c0-10.9 8.9-19.8 19.8-19.8c2.8 0 5.5 .6 8 1.7L224 416l68.2-30.3c2.5-1.1 5.3-1.7 8-1.7c10.9 0 19.8 8.9 19.8 19.8l0 88.4c0 10.9-8.9 19.8-19.8 19.8c-2.8 0-5.5-.6-8-1.7L224 480l-68.2 30.3c-2.5 1.1-5.3 1.7-8 1.7c-10.9 0-19.8-8.9-19.8-19.8zm69.9-294.3c-2 9.3-5.6 18.2-10.8 26.1c5.2 8 8.9 16.8 10.8 26.1c9.3 2 18.2 5.6 26.1 10.8c8-5.2 16.8-8.9 26.1-10.8c2-9.3 5.6-18.2 10.8-26.1c-5.2-8-8.9-16.8-10.8-26.1c-4.7-1-9.3-2.4-13.7-4.2c-4.3-1.8-8.5-4-12.4-6.6c-8 5.2-16.8 8.9-26.1 10.8zm5.2-55.5c11.3-12.1 30.6-12.1 41.9 0c5.7 6 13.6 9.4 21.9 9.1c16.6-.6 30.2 13 29.6 29.6c-.3 8.3 3 16.3 9.1 21.9c12.1 11.3 12.1 30.6 0 41.9c-6 5.7-9.4 13.6-9.1 21.9c.6 16.6-13 30.2-29.6 29.6c-8.3-.3-16.3 3-21.9 9.1c-11.3 12.1-30.6 12.1-41.9 0c-5.7-6-13.6-9.4-21.9-9.1c-16.6 .6-30.2-13-29.6-29.6c.3-8.3-3-16.3-9.1-21.9c-12.1-11.3-12.1-30.6 0-41.9c6-5.7 9.4-13.6 9.1-21.9c-.6-16.6 13-30.2 29.6-29.6c8.3 .3 16.3-3 21.9-9.1z"]
};
const faChildren = {
  prefix: 'far',
  iconName: 'children',
  icon: [640, 512, [], "e4e1", "M160 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 160 0a72 72 0 1 0 0 144zm0 16c-34.6 0-67.3 16.2-88.2 43.8L12.9 281.5c-8 10.6-5.9 25.6 4.6 33.6s25.6 5.9 33.6-4.6l45.3-59.8L57.2 368.4c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 32 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 16 0c7.7 0 15-3.7 19.5-10s5.7-14.3 3.3-21.6L223.5 250.7l45.3 59.8c8 10.6 23.1 12.6 33.6 4.6s12.6-23.1 4.6-33.6l-58.9-77.7C227.3 176.2 194.7 160 160 160zM113.3 352L160 211.9 206.7 352l-93.4 0zM456 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm96 0A72 72 0 1 0 408 72a72 72 0 1 0 144 0zM480 208c5.5 0 10.9 .9 16 2.6L496 336l-32 0 0-125.4c5.1-1.7 10.5-2.6 16-2.6zM464 488l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-223.2 27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C545.8 177.5 514.1 160 480 160s-65.8 17.5-83.9 46.3l-48.4 76.9c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44L416 488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faMeterDroplet = {
  prefix: 'far',
  iconName: 'meter-droplet',
  icon: [640, 512, [], "e1ea", "M256 464c48.8 0 93.8-16.8 129.2-45c2.3 17.2 7.6 33.5 15.4 48.3C359.5 495.5 309.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C366.8 0 461.2 70.4 496.8 169c-8.5 5.3-15.7 12.9-20.6 22.1l-15.4 28.8C443.8 122.2 358.6 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zM192 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm136.5 54.1c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7l75.3-141.2z"]
};
const faChalkboard = {
  prefix: 'far',
  iconName: 'chalkboard',
  icon: [576, 512, ["blackboard"], "f51b", "M80 88c0-4.4 3.6-8 8-8l400 0c4.4 0 8 3.6 8 8l0 312 48 0 0-312c0-30.9-25.1-56-56-56L88 32C57.1 32 32 57.1 32 88l0 312 48 0L80 88zM224 408l0 24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0 24 0 144 0 24 0 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0 0-24c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56zm144 0l0 24-96 0 0-24c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8z"]
};
const faBlackboard = faChalkboard;
const faUserLargeSlash = {
  prefix: 'far',
  iconName: 'user-large-slash',
  icon: [640, 512, ["user-alt-slash"], "f4fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM224.2 150.4c-.1-2.1-.2-4.3-.2-6.4c0-53 43-96 96-96s96 43 96 96c0 47.3-34.3 86.7-79.3 94.6L224.2 150.4zM545.5 512L528 512l-60.9-48-353.8 0c8.3-54.4 55.3-96 112-96l119.9 0-60.9-48-59 0C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7l450.6 0 .3 0z"]
};
const faUserAltSlash = faUserLargeSlash;
const faSignalStrong = {
  prefix: 'far',
  iconName: 'signal-strong',
  icon: [640, 512, ["signal-4"], "f68f", "M448 96c13.3 0 24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faSignal4 = faSignalStrong;
const faLollipop = {
  prefix: 'far',
  iconName: 'lollipop',
  icon: [512, 512, [127853, "lollypop"], "e424", "M210.8 334.8C265.3 314.2 304 261.6 304 200l0-8c0-61.9-50.1-112-112-112S80 130.1 80 192c0 39.8 32.2 72 72 72s72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-35.3 28.7-64 64-64s64 28.7 64 64l0 8c0 53-43 96-96 96l-8 0C94.6 296 48 249.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 73.2-54.6 133.6-125.2 142.8zM0 192C0 298 86 384 192 384c44.4 0 85.2-15 117.7-40.3L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L343.7 309.7C369 277.2 384 236.4 384 192C384 86 298 0 192 0S0 86 0 192z"]
};
const faLollypop = faLollipop;
const faListTree = {
  prefix: 'far',
  iconName: 'list-tree',
  icon: [512, 512, [], "e1d2", "M24 48C10.7 48 0 58.7 0 72l0 48c0 13.3 10.7 24 24 24l0 112 0 128c0 30.9 25.1 56 56 56l48 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-48 0c-4.4 0-8-3.6-8-8l0-104 56 0c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24l-56 0 0-88c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L24 48zM160 96c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72c-13.3 0-24 10.7-24 24zM288 256c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm0 160c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z"]
};
const faEnvelopeOpen = {
  prefix: 'far',
  iconName: 'envelope-open',
  icon: [512, 512, [62135], "f2b6", "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5l0 13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1l0-13.6c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2 464 456c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8l0-179.8zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-255.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"]
};
const faDrawCircle = {
  prefix: 'far',
  iconName: 'draw-circle',
  icon: [512, 512, [], "f5ed", "M256 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm54.8 17.1C299.6 115.6 279.2 128 256 128s-43.6-12.4-54.8-30.9c-48.7 16.8-87.3 55.4-104.1 104.1C115.6 212.4 128 232.8 128 256s-12.4 43.6-30.9 54.8c16.8 48.7 55.4 87.3 104.1 104.1C212.4 396.4 232.8 384 256 384s43.6 12.4 54.8 30.9c48.7-16.8 87.3-55.4 104.1-104.1C396.4 299.6 384 279.2 384 256s12.4-43.6 30.9-54.8c-16.8-48.7-55.4-87.3-104.1-104.1zm152.1 96.6c28.2 6.7 49.1 32 49.1 62.3s-20.9 55.5-49.1 62.3c-20.8 69.2-75.4 123.8-144.6 144.6c-6.7 28.2-32 49.1-62.3 49.1s-55.5-20.9-62.3-49.1C124.5 442.1 69.9 387.5 49.1 318.3C20.9 311.5 0 286.2 0 256s20.9-55.5 49.1-62.3C69.9 124.5 124.5 69.9 193.7 49.1C200.5 20.9 225.8 0 256 0s55.5 20.9 62.3 49.1c69.2 20.8 123.8 75.4 144.6 144.6zM256 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faCatSpace = {
  prefix: 'far',
  iconName: 'cat-space',
  icon: [640, 512, [], "e001", "M464 304c70.7 0 128-57.3 128-128c0-32.5-12.1-62.1-32-84.7l0 84.7c0 53-43 96-96 96s-96-43-96-96l0-84.7c-19.9 22.6-32 52.2-32 84.7c0 70.7 57.3 128 128 128zM397.8 66.4l29.4 39.2c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l29.4-39.2C510.9 54.7 488.2 48 464 48s-46.9 6.7-66.2 18.4zM464 352l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-98.9c-10.4 1.9-21.1 2.9-32 2.9zM640 176c0 68.4-39 127.7-96 156.8L544 448c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-54L336 441l0 23 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-48.6 0-88-39.4-88-88c0 0 0-.1 0-.1l0-239.4c0-20.2-15-37.2-35-39.7l-7.9-1c-13.2-1.6-22.5-13.6-20.8-26.8S45.8 94.5 59 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3l0 94.5c34.5-46.4 85.2-80.1 144.3-92.7c-.2-3.4-.3-6.9-.3-10.3C288 78.8 366.8 0 464 0s176 78.8 176 176zM144 423.9c0 0 0 .1 0 .1c0 22.1 17.9 40 40 40l104 0 0-64c0-17.7-14.3-32-32-32l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c39.4 0 72.2 28.5 78.8 66l73.3-43.1c-51.7-17.3-92.7-58-110.5-109.5C209 252.6 144 331.2 144 423.9zM231.5 12.3l10.7 28.8c.8 2.2 2.5 3.9 4.7 4.7l28.8 10.7c7 2.6 7 12.4 0 15L246.9 82.2c-2.2 .8-3.9 2.5-4.7 4.7l-10.7 28.8c-2.6 7-12.4 7-15 0L205.8 86.9c-.8-2.2-2.5-3.9-4.7-4.7L172.3 71.5c-7-2.6-7-12.4 0-15l28.8-10.7c2.2-.8 3.9-2.5 4.7-4.7l10.7-28.8c2.6-7 12.4-7 15 0zM432 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faHandshakeSimpleSlash = {
  prefix: 'far',
  iconName: 'handshake-simple-slash',
  icon: [640, 512, ["handshake-alt-slash"], "e05f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368l82.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-15.4 0-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5 44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-78.9 0L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM388.9 402.4l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4L56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l37.7 0c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5zM101.5 176L44.4 131C37 135.1 32 143 32 152c0 13.3 10.7 24 24 24l45.5 0z"]
};
const faHandshakeAltSlash = faHandshakeSimpleSlash;
const faRabbitRunning = {
  prefix: 'far',
  iconName: 'rabbit-running',
  icon: [576, 512, ["rabbit-fast"], "f709", "M501.8 167.8c-8.6-5.9-17.8-10.8-27.4-14.6C457.7 98.3 413.9 55 358 39.7l-2-.6c-13-3.6-26.9-1.8-38.5 5c-20.2 11.7-29.8 35.7-23.1 58.1l7.8 26.3c1.2 4 2.5 8 4 11.9l-57.1-20.8c-13.8-5-28.4-7.6-43.1-7.6l-12.3 0c-30.1 0-57.5 11.7-77.9 30.9C103.7 133.5 88.5 128 72 128c-39.8 0-72 32.2-72 72s32.2 72 72 72c5.9 0 11.5-.7 17-2c6 14.1 14.8 27 26.1 37.8l37.7 36.1-28.3 18.9c-29.4 19.6-37.4 59.3-17.8 88.8s59.3 37.4 88.8 17.8l52.1-34.7 5.3 5.1C269.2 455.3 291 464 313.7 464L416 464c35.3 0 64-28.7 64-64c0-19.1-8.4-36.3-21.7-48l33.4 0c46.5 0 84.3-37.7 84.3-84.3c0-25.3-11.4-49.3-31-65.3l-18.9-15.4c13.8-52.7-1.7-108.8-40.6-147l-1.4-1.4c-5.7-5.6-13.8-8-21.6-6.5l-1.6 .3c-8.8 1.7-16 8.3-18.4 16.9c-.8 2.8-1.5 5.5-2.1 8.3c28.7 25.3 49.7 59 59.4 97.4c1.1 4.2 1.7 8.5 2 12.7zM88.5 182.5c-5.1 12.4-8.1 25.9-8.4 40.1c-2.5 .9-5.2 1.4-8 1.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.4 0 12.2 2.5 16.5 6.5zm62.7 220.1l37.2-24.8L212 400.5l-43.2 28.8c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2zm190.3-317c.6-.3 1.2-.4 1.9-.2l2 .6c41.5 11.4 74 44.6 84.6 86.5c.3 10.6 7.6 19.7 17.8 22.4c11.7 3.1 22.8 8.7 32.3 16.5l34.6 28.2c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3L392 304c-6.4 0-12.5 2.5-17 7l-9.9 9.9c-9.7-43.6-43.3-79.2-88-90.4l-23.3-5.8c-12.9-3.2-25.9 4.6-29.1 17.5s4.6 25.9 17.5 29.1l23.3 5.8c32.1 8 54.5 36.8 54.5 69.8l0 13c0 13.3 10.7 24 24 24l40 0 .1 0 31.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-102.3 0c-10.3 0-20.2-4-27.6-11.1L148.3 273.1c-13-12.4-20.3-29.5-20.3-47.5c0-36.3 29.4-65.7 65.7-65.7l12.3 0c9.1 0 18.1 1.6 26.7 4.7l129.4 47.1c11 4 23.3-.5 29.1-10.7s3.4-23.1-5.7-30.5c-17.6-14.3-30.7-33.7-37.3-55.8l-7.8-26.3c-.3-1.1 .1-2.2 1.1-2.8zM480 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faRabbitFast = faRabbitRunning;
const faMemoPad = {
  prefix: 'far',
  iconName: 'memo-pad',
  icon: [448, 512, [], "e1da", "M400 128l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320 352 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 200c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm0 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24z"]
};
const faMattressPillow = {
  prefix: 'far',
  iconName: 'mattress-pillow',
  icon: [640, 512, [], "e525", "M240 112l0 288L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l176 0zm48 0l288 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-288 0 0-288zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM80 176l0 160c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32z"]
};
const faAlarmPlus = {
  prefix: 'far',
  iconName: 'alarm-plus',
  icon: [512, 512, [], "f844", "M160 25.4C143 9.6 120.2 0 95.2 0C42.6 0 0 42.6 0 95.2c0 18.8 5.5 36.3 14.9 51.1L160 25.4zM256 112a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400c53.2 0 102.1-18.6 140.5-49.5L439 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-42.5-42.5c31-38.4 49.5-87.3 49.5-140.5C480 164.3 379.7 64 256 64S32 164.3 32 288c0 53.2 18.6 102.1 49.5 140.5L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l42.5-42.5c38.4 31 87.3 49.5 140.5 49.5zM497.1 146.4C506.5 131.6 512 114 512 95.2C512 42.6 469.4 0 416.8 0C391.8 0 369 9.6 352 25.4L497.1 146.4zM256 176c-13.3 0-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24z"]
};
const faAlicorn = {
  prefix: 'far',
  iconName: 'alicorn',
  icon: [640, 512, [], "f6b0", "M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 24 0 8 0 .5 0L536 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c3.5 6.1 6.3 12.7 8.3 19.7l73.5 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c6.4-9.1 14.1-17.3 22.9-24.2c5.1 17.5 11.8 33.3 19.6 47.6c-9.1 11.1-14.6 25.3-14.6 40.8c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-8 0-24 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-1.5 12-11.7 21-23.8 21l-.5 0c-3.8 .1-7.6-.7-11.2-2.5L179.7 96.7c8.2 42.4 28.6 70.5 48.5 88.8c13.1 12 26.2 20.1 35.9 25.1c4.9 2.5 8.8 4.2 11.5 5.2c1.3 .5 2.3 .9 2.9 1.1l.4 .1c9.9 3 17 12.1 17 23c0 13.3-10.7 24-24 24c-2.8 0-5.4-.5-7.9-1.3c-.4-.1-.8-.3-1.3-.5c-1.2-.4-2.8-1-4.7-1.8c-3.9-1.6-9.3-3.9-15.7-7.2c-12.7-6.5-29.6-16.9-46.6-32.5C161.4 189.2 128 137 128 56c0-8.3 4.3-16 11.4-20.4s15.9-4.8 23.4-1.1l133.9 66.9C316 46.3 366.3 5.8 426.8 .6zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faCommentQuestion = {
  prefix: 'far',
  iconName: 'comment-question',
  icon: [512, 512, [], "e14b", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM169.8 149.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 336a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faGingerbreadMan = {
  prefix: 'far',
  iconName: 'gingerbread-man',
  icon: [448, 512, [], "f79d", "M152 120c0-39.8 32.2-72 72-72s72 32.2 72 72c0 9.5-1.8 18.4-5.1 26.6c-7.6 19 4.4 45.4 30.1 45.4l39 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-7 0c-39.2 0-60.7 45.6-35.8 75.9l41.7 50.7c14 17.1 11.6 42.3-5.5 56.3s-42.3 11.6-56.3-5.5l-37.3-45.3c-18.6-22.6-53.1-22.6-71.7 0l-37.3 45.3c-14 17.1-39.2 19.5-56.3 5.5s-19.5-39.2-5.5-56.3l41.7-50.7C155.7 317.6 134.2 272 95 272l-7 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l39 0c25.7 0 37.7-26.4 30.1-45.4c-3.3-8.2-5.1-17.2-5.1-26.6zM224 0C157.7 0 104 53.7 104 120c0 8.2 .8 16.2 2.4 24L88 144c-48.6 0-88 39.4-88 88s39.4 88 88 88l3.6 0L52 368.1c-30.9 37.5-25.5 93 12 123.9l14.5-17.6L64.1 492c37.5 30.9 93 25.5 123.9-12l36-43.8 36 43.8c30.9 37.5 86.3 42.9 123.9 12s42.9-86.3 12-123.9L356.4 320l3.6 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-18.4 0c1.6-7.8 2.4-15.8 2.4-24C344 53.7 290.3 0 224 0zm0 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM208 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM240 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faGuaraniSign = {
  prefix: 'far',
  iconName: 'guarani-sign',
  icon: [384, 512, [], "e19a", "M192 0c-13.3 0-24 10.7-24 24l0 41.5C73.3 77.3 0 158.1 0 256s73.3 178.7 168 190.5l0 41.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-41.5c94.7-11.8 168-92.6 168-190.5c0-13.3-10.7-24-24-24l-144 0 0-118c29.7 5 56.2 19 76.8 39.2c9.5 9.3 24.7 9.1 33.9-.3s9.1-24.7-.3-33.9C297.2 90.2 258.8 70.8 216 65.5L216 24c0-13.3-10.7-24-24-24zM168 114l0 284C99.9 386.6 48 327.4 48 256s51.9-130.6 120-142zm48 284l0-118 118 0c-10.1 60.3-57.7 107.9-118 118z"]
};
const faBurgerFries = {
  prefix: 'far',
  iconName: 'burger-fries',
  icon: [640, 512, [], "e0cd", "M167.6 2.4C162.9 5.3 160 10.5 160 16l0 190.7s0 0 0 0l0 63.2c9.2 1.4 19.8 2.2 32 2.2s22.8-.8 32-2.2l0-238c-.1-6-3.5-11.4-8.8-14.1l-32-16c-5-2.5-10.8-2.2-15.6 .7zM128 261l0-246.3-.2-1.3c-.8-5-4-9.3-8.5-11.6s-9.9-2.3-14.4-.1l-32 16c-6.3 3.1-9.8 10-8.6 16.9l32 192c.5 1.2 .9 2.3 1.2 3.4c2 6.3 6.7 15.9 18.7 24.3c3.2 2.2 7.1 4.5 11.8 6.6zM58.2 193L40.3 85.6 19.9 80.5c-5.3-1.3-10.8 .1-14.8 3.8S-.7 93.4 .2 98.8l16.5 93.4c1.6-.1 3.1-.2 4.7-.2L48 192c3.6 0 7 .4 10.2 1zm312-17.5l13.5-76.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8L346.2 85l-19 107.8c2.5-.4 5.1-.7 7.9-.8c10.4-6.1 22.1-11.7 35.1-16.4zM286.6 230c.7-2.3 1.7-4.7 2.8-7L319.8 50.8c.9-5.3-.9-10.8-4.8-14.5s-9.5-5.1-14.8-3.8l-32 8C262 42 257.3 47 256.2 53.2l-.2 1.4L256 261c4.8-2.1 8.7-4.4 11.8-6.6c2.1-1.5 4-3 5.7-4.5c3.2-4.9 7-10 11.4-15.4c.7-1.6 1.3-3.1 1.7-4.5zM192 304c-91.7 0-117.7-41-125.1-64.3C64.3 231.2 56.8 224 48 224l-26.6 0C9.6 224 0 233.6 0 245.4c0 1.7 .2 3.4 .6 5.1l57.5 237C61.5 501.9 74.4 512 89.2 512l204.9 0c-14-13.1-24.9-29.5-31.3-48l-161 0L66.1 316.8c1.4 1.1 2.8 2.1 4.3 3.1C99.3 340.1 139.1 352 192 352c26.8 0 50.3-3.1 70.6-8.7c-4.3-11.8-6.6-24.6-6.6-37.8c0-3.2 .1-6.7 .5-10.5c-16.7 5.5-37.8 9-64.5 9zm257.9-63.8c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.4 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
const faMugTea = {
  prefix: 'far',
  iconName: 'mug-tea',
  icon: [576, 512, [], "f875", "M80 112l72 0 0 10.7c0 8.5-3.4 16.6-9.4 22.6l-21.3 21.3c-6 6-9.4 14.1-9.4 22.6l0 66.7c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-66.7c0-8.5-3.4-16.6-9.4-22.6l-21.3-21.3c-6-6-9.4-14.1-9.4-22.6l0-10.7 184 0 0 240c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-240zM64 64C46.3 64 32 78.3 32 96l0 256c0 53 43 96 96 96l192 0c53 0 96-43 96-96l0-32 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L64 64zM448 272l-32 0 0-160 32 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"]
};
const faBorderTop = {
  prefix: 'far',
  iconName: 'border-top',
  icon: [448, 512, [], "f855", "M0 56C0 42.7 10.7 32 24 32l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM64 160A32 32 0 1 1 0 160a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 352a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm320 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm448 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-256 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faArrowsRotate = {
  prefix: 'far',
  iconName: 'arrows-rotate',
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176 360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336l54.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-54.1 52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9z"]
};
const faRefresh = faArrowsRotate;
const faSync = faArrowsRotate;
const faCircleBookOpen = {
  prefix: 'far',
  iconName: 'circle-book-open',
  icon: [512, 512, ["book-circle"], "e0ff", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 336c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9l0-160.7c0-5.8-3.1-11.1-8.3-13.5C221.2 167.1 202.5 160 184 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5l0 160.7c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C143 347.1 160.9 336 184 336zm144 0c23.1 0 41 11.1 46.3 14.8c1.1 .8 2.4 1.2 3.7 1.2c3.3 0 5.9-2.7 5.9-5.9l0-160.7c0-5.8-3.1-11.1-8.3-13.5C365.2 167.1 346.5 160 328 160s-37.2 7.1-47.7 11.9c-5.2 2.4-8.3 7.7-8.3 13.5l0 160.7c0 3.3 2.7 5.9 5.9 5.9c1.3 0 2.6-.4 3.7-1.2C287 347.1 304.9 336 328 336z"]
};
const faBookCircle = faCircleBookOpen;
const faArrowsToDottedLine = {
  prefix: 'far',
  iconName: 'arrows-to-dotted-line',
  icon: [448, 512, [], "e0a6", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM313 399l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
const faFireExtinguisher = {
  prefix: 'far',
  iconName: 'fire-extinguisher',
  icon: [512, 512, [129519], "f134", "M500.3 7.3C507.7 13.3 512 22.4 512 32l0 96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104l-89 0 0 26.6c50.3 11 88 55.8 88 109.4l0 208c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64l0-208c0-53.6 37.7-98.4 88-109.4l0-25.6c-46.9 5.5-86.5 34.8-106.3 75.6c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C30.1 102.8 86.1 62.4 152 56.7L152 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 89 0c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM112 416l0 32c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-32-128 0zm0-48l128 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128z"]
};
const faMagnifyingGlassArrowsRotate = {
  prefix: 'far',
  iconName: 'magnifying-glass-arrows-rotate',
  icon: [512, 512, [], "e65e", "M208 48c39.6 0 75.9 14.4 103.8 38.2L279 119c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l96 0c13.3 0 24-10.7 24-24l0-96c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L345.8 52.2C309.1 19.7 260.9 0 208 0C108.6 0 25.6 69.7 4.9 162.8c-2.9 12.9 5.3 25.8 18.2 28.6c1.4 .3 2.7 .5 4.1 .5l2.3 0c10.5-.5 19.9-8 22.2-18.8C67.7 101.6 131.6 48 208 48zM386 224c-10.4 .7-19.4 8.1-21.8 18.8C348.4 314.4 284.4 368 208 368c-39.6 0-75.9-14.4-103.8-38.2L137 297c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8l-96 0c-13.3 0-24 10.7-24 24l0 96c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l29.2-29.2c36.7 32.5 85 52.2 137.8 52.2c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1c19.2-24.2 33.1-52.8 40-84c2.9-12.9-5.3-25.8-18.2-28.6c-1.2-.3-2.4-.4-3.6-.5l-3.2 0z"]
};
const faGarageOpen = {
  prefix: 'far',
  iconName: 'garage-open',
  icon: [640, 512, [], "e00b", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 320l0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168-352 0zm0-48l352 0 0-32-352 0 0 32zm88 144l0 16 176 0 0-16c0-8.8-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16zm0 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-35.3 28.7-64 64-64l144 0c35.3 0 64 28.7 64 64l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-176 0z"]
};
const faShelvesEmpty = {
  prefix: 'far',
  iconName: 'shelves-empty',
  icon: [640, 512, [], "e246", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 184 0 440l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 544 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 0-256 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 160 48 24zm0 184l544 0 0 208L48 416l0-208z"]
};
const faCruzeiroSign = {
  prefix: 'far',
  iconName: 'cruzeiro-sign',
  icon: [448, 512, [], "e152", "M80 256c0-97 79.3-176 177.6-176c45.6 0 87 17 118.5 44.9c9.9 8.8 25.1 7.9 33.9-2s7.9-25.1-2-33.9C368 53.5 315.3 32 257.6 32C133.2 32 32 132.1 32 256s101.2 224 225.6 224c57.7 0 110.4-21.5 150.3-57c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2C344.6 415 303.2 432 257.6 432c-6.3 0-12.5-.3-18.6-1c.7-2.2 1-4.6 1-7l0-104 0-1.8c0-21.1 17.1-38.2 38.2-38.2c10.1 0 19.9 4 27 11.2L311 297c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-5.8-5.8c-16.2-16.2-38.1-25.3-61-25.3c-14.1 0-27.4 3.4-39.2 9.4C236.2 231.3 227 224 216 224c-13.3 0-24 10.7-24 24l0 70.2 0 1.8 0 99.6C126.3 393.7 80 330.1 80 256z"]
};
const faWatchApple = {
  prefix: 'far',
  iconName: 'watch-apple',
  icon: [384, 512, [], "e2cb", "M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM192 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 184a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM152 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-8 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faWatchCalculator = {
  prefix: 'far',
  iconName: 'watch-calculator',
  icon: [384, 512, [], "f8f0", "M112.3 0C85.6 0 64 21.6 64 48.3l0 17.3C27.5 73 0 105.3 0 144L0 368c0 38.7 27.5 71 64 78.4L64 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-17.6c36.5-7.4 64-39.7 64-78.4l0-224c0-38.7-27.5-71-64-78.4l0-17.3C320 21.6 298.4 0 271.7 0L112.3 0zM304 112c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32L80 400c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l224 0zM104 160c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-176 0zM88 272a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM112 312a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm104-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
const faListDropdown = {
  prefix: 'far',
  iconName: 'list-dropdown',
  icon: [512, 512, [], "e1cf", "M48 192l0 224c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-224L48 192zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm436.7 0l-73.4 0c-7.1 0-10.7 8.6-5.7 13.7l36.7 36.7c3.1 3.1 8.2 3.1 11.3 0l36.7-36.7c5-5 1.5-13.7-5.7-13.7zM128 232l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCabinetFiling = {
  prefix: 'far',
  iconName: 'cabinet-filing',
  icon: [448, 512, [128452], "f64b", "M400 232L48 232 48 64c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 168zM0 256l0 24L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-168 0-24 0-24 0-168c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 232l0 24zM400 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-168 352 0 0 168zM160 152l0-8 128 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1-17.9-40-40-40L152 96c-22.1 0-40 17.9-40 40l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24zm-8 184c-22.1 0-40 17.9-40 40l0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 128 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16c0-22.1-17.9-40-40-40l-144 0z"]
};
const faBurgerSoda = {
  prefix: 'far',
  iconName: 'burger-soda',
  icon: [640, 512, [], "f858", "M249.3 0c-26 0-48.6 17.9-54.5 43.2l-20 84.8-94.7 0L32 128l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12 0 48.2 0 89.9 0 35.8 0 89.9 0 48.2 0 12 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.2 0-79.6 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0zM60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c5.4 0 10.7-.9 15.5-2.6c-12.7-12.7-22.6-28.1-28.7-45.4l-154.5 0L86.8 208l-48.2 0L60.3 468zM449.9 240.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
const faSquareArrowUp = {
  prefix: 'far',
  iconName: 'square-arrow-up',
  icon: [448, 512, ["arrow-square-up"], "f33c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm241 23l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47L248 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l88-88c9.4-9.4 24.6-9.4 33.9 0z"]
};
const faArrowSquareUp = faSquareArrowUp;
const faGreaterThanEqual = {
  prefix: 'far',
  iconName: 'greater-than-equal',
  icon: [448, 512, [], "f532", "M47 78.2c-12.3-5-18.2-19-13.2-31.3s19-18.2 31.3-13.2l336 136c9.1 3.7 15 12.5 15 22.2s-5.9 18.6-15 22.2L65 350.2c-12.3 5-26.3-1-31.3-13.2s1-26.3 13.2-31.3L328 192 47 78.2zM424 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0z"]
};
const faPalletBox = {
  prefix: 'far',
  iconName: 'pallet-box',
  icon: [640, 512, [], "e208", "M384 48l0 80c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L320 115.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-80-80 0 0 192 288 0 0-192-80 0zM128 48c0-26.5 21.5-48 48-48L464 0c26.5 0 48 21.5 48 48l0 192c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-192zM0 344c0-13.3 10.7-24 24-24l64 0 232 0 232 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 96 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-232 0L88 512l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-96-40 0c-13.3 0-24-10.7-24-24zM112 464l184 0 0-96-184 0 0 96zm232 0l184 0 0-96-184 0 0 96z"]
};
const faFaceConfounded = {
  prefix: 'far',
  iconName: 'face-confounded',
  icon: [512, 512, [], "e36c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm231 77.3l25 20 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 343c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.8 7-21.2 7-30 0l-26.3-21L181.3 404c-9.5 6.3-22.2 5.1-30.3-3l-24-24c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l10.1 10.1L202.7 332c8.7-5.8 20.1-5.3 28.3 1.2zM133.5 178.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 189.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
const faShieldHalved = {
  prefix: 'far',
  iconName: 'shield-halved',
  icon: [512, 512, ["shield-alt"], "f3ed", "M232 59.6l0 390.7C99.2 375.7 64.4 227.3 64 139.7c0-5 3.1-10.2 9-12.8L232 59.6zm48 390.8l0-390.8L439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 87.5-35.2 236-168 310.6zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2z"]
};
const faShieldAlt = faShieldHalved;
const faTruckPlow = {
  prefix: 'far',
  iconName: 'truck-plow',
  icon: [640, 512, [], "f7de", "M184 80l86.1 0c2.8 0 5.4 1.5 6.8 3.8L343 192l-167 0 0-104c0-4.4 3.6-8 8-8zM398.6 192c-.6-1.5-1.3-3.1-2.2-4.5L317.8 58.8C307.7 42.2 289.6 32 270.1 32L184 32c-30.9 0-56 25.1-56 56l0 104-72 0c-30.9 0-56 25.1-56 56l0 96c0 19.4 13.7 35.5 32 39.2l0 .8c0 53 43 96 96 96s96-43 96-96l48 0c0 53 43 96 96 96s96-43 96-96l54.1 0 .1 .1 80 88c8.9 9.8 24.1 10.5 33.9 1.6s10.5-24.1 1.6-33.9L560 358.7l0-141.4 73.8-81.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6l-80 88c-4 4.4-6.2 10.2-6.2 16.1l0 128-32 0 0-88c0-30.9-25.1-56-56-56l-25.4 0zM432 312.4c-17-15.2-39.4-24.4-64-24.4c-35.5 0-66.6 19.3-83.2 48l-73.7 0c-16.6-28.7-47.6-48-83.2-48c-33.4 0-62.8 17-80 42.9L48 248c0-4.4 3.6-8 8-8l368 0c4.4 0 8 3.6 8 8l0 64.4zM80 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm288-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faBookAtlas = {
  prefix: 'far',
  iconName: 'book-atlas',
  icon: [448, 512, ["atlas"], "f558", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM176.5 216l-31 0c4.8 26.1 21.1 48.2 43.5 60.8c-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8c-22.4 12.6-38.7 34.7-43.5 60.8l31 0zM112 200a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm206.5 16l-31 0c-1.4 22.9-5.9 43.8-12.5 60.8c22.4-12.6 38.7-34.7 43.5-60.8zM275 123.2c6.6 16.9 11 37.8 12.5 60.8l31 0c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 216l-46.9 0c1.6 22.6 6.5 41.8 12.8 55.3c4.7 10.1 8.6 14.2 10.6 15.8c2-1.6 5.9-5.7 10.6-15.8c6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32l46.9 0c-1.6-22.6-6.5-41.8-12.8-55.3c-4.7-10.1-8.6-14.2-10.6-15.8c-2 1.6-5.9 5.7-10.6 15.8c-6.3 13.5-11.2 32.7-12.8 55.3z"]
};
const faAtlas = faBookAtlas;
const faVirus = {
  prefix: 'far',
  iconName: 'virus',
  icon: [512, 512, [], "e074", "M75 75c12.5-12.5 32.8-12.5 45.3 0l8.2 8.2C163.7 118.4 224 93.4 224 43.5L224 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 11.5c0 49.9 60.3 74.9 95.6 39.6l8.2-8.2c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-8.2 8.2c-35.3 35.3-10.3 95.6 39.6 95.6l11.5 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-11.5 0c-49.9 0-74.9 60.3-39.6 95.6l8.2 8.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-8.2-8.2c-35.3-35.3-95.6-10.3-95.6 39.6l0 11.5c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-11.5c0-49.9-60.3-74.9-95.6-39.6l-8.2 8.2c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l8.2-8.2C118.4 348.3 93.4 288 43.5 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l11.5 0c49.9 0 74.9-60.3 39.6-95.6L75 120.2C62.5 107.7 62.5 87.5 75 75zM256 99.6c-23.3 36.4-68.4 55.1-110.6 45.8c9.3 42.2-9.4 87.3-45.8 110.6c36.4 23.3 55.1 68.4 45.8 110.6c42.2-9.3 87.3 9.4 110.6 45.8c23.3-36.4 68.4-55.1 110.6-45.8c-9.3-42.2 9.4-87.3 45.8-110.6c-36.4-23.3-55.1-68.4-45.8-110.6c-21.2 4.7-43.1 2.3-62.6-5.8c-19.4-8.1-36.4-21.8-48-40zM192 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faGridRound2 = {
  prefix: 'far',
  iconName: 'grid-round-2',
  icon: [512, 512, [], "e5db", "M128 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 128a96 96 0 1 1 192 0zM128 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM336 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z"]
};
const faCommentMiddleTop = {
  prefix: 'far',
  iconName: 'comment-middle-top',
  icon: [512, 512, [], "e14a", "M231.3 124.8L256 75.3l24.7 49.5c6.5 12.9 18.4 22.3 32.5 25.4C407 171 464 237.3 464 304c0 79.5-83.3 160-208 160S48 383.5 48 304c0-66.7 57-133 150.7-153.8c14.1-3.1 26.1-12.5 32.5-25.4zm92.4-21.5l-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304C0 418.9 114.6 512 256 512s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"]
};
const faWave = {
  prefix: 'far',
  iconName: 'wave',
  icon: [576, 512, [], "e65b", "M304 80c-83.9 0-152 68.1-152 152c0 66.3-53.7 120-120 120c-13.3 0-24-10.7-24-24s10.7-24 24-24c39.8 0 72-32.2 72-72c0-110.5 89.5-200 200-200c67.7 0 127.5 33.6 163.6 85c6.3 8.9 5.8 20.9-1.3 29.3s-18.8 10.9-28.6 6.2C426.3 147 413.5 144 400 144c-48.6 0-88 39.4-88 88c0 39.8 32.2 72 72 72c28.8 0 58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8c-66.3 0-120-53.7-120-120c0-66.9 48.3-122.6 112-133.9C354.6 86.6 330.1 80 304 80zM80 398.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z"]
};
const faEnvelopeCircleCheck = {
  prefix: 'far',
  iconName: 'envelope-circle-check',
  icon: [640, 512, [], "e4e8", "M64 112l384 0c8.8 0 16 7.2 16 16l0 22.1-22.6 18.5C458.6 163 477 160 496 160c5.4 0 10.7 .2 16 .7l0-32.7c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l296.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 400c-8.8 0-16-7.2-16-16l0-171.8L190 328.8c37.7 31 91.8 31.5 130.1 1.5c.9-29.2 8.9-56.5 22.4-80.4l-50.9 41.8c-20.7 17-50.4 17-71.1 0L48 150.1 48 128c0-8.8 7.2-16 16-16zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faLayerGroup = {
  prefix: 'far',
  iconName: 'layer-group',
  icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
};
const faRestroomSimple = {
  prefix: 'far',
  iconName: 'restroom-simple',
  icon: [640, 512, [], "e23a", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208l44.8 0c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3l-2.4 0-80 0-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352l32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136zM320 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM576 64A64 64 0 1 0 448 64a64 64 0 1 0 128 0zM496.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L576.4 336l-128.7 0 33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L395.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L589.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z"]
};
const faArrowsToDot = {
  prefix: 'far',
  iconName: 'arrows-to-dot',
  icon: [512, 512, [], "e4be", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L201 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 24zM433 345c9.4-9.4 9.4-24.6 0-33.9l-31-31 86.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0 31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM113 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L79 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72zM167 433c9.4 9.4 24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9z"]
};
const faBorderOuter = {
  prefix: 'far',
  iconName: 'border-outer',
  icon: [448, 512, [], "f851", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm128-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faHashtagLock = {
  prefix: 'far',
  iconName: 'hashtag-lock',
  icon: [576, 512, [], "e415", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136l111 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136l71.5 0c13.3 0 24 10.7 24 24c0 .4 0 .8 0 1.1c-19.9 2.9-38.2 11-53.3 22.9l-51.8 0L287.5 460.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144L56 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l87.5 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144-111 0zM464 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faClockTwoThirty = {
  prefix: 'far',
  iconName: 'clock-two-thirty',
  icon: [512, 512, [], "e35b", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-136c0-8 4-15.5 10.7-20l96-64c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3L280 268.8 280 392c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faArchway = {
  prefix: 'far',
  iconName: 'archway',
  icon: [512, 512, [], "f557", "M0 56C0 42.7 10.7 32 24 32l32 0 400 0 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 352 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-32 0-64 0c-13.3 0-24-10.7-24-24l0-120c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 120c0 13.3-10.7 24-24 24l-64 0-32 0-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 32 352 0 0-32L80 80zm0 80l0 272 8 0 40 0 0-96c0-70.7 57.3-128 128-128s128 57.3 128 128l0 96 40 0 8 0 0-272L80 160z"]
};
const faHeartCircleCheck = {
  prefix: 'far',
  iconName: 'heart-circle-check',
  icon: [576, 512, [], "e4fd", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faHouseChimneyCrack = {
  prefix: 'far',
  iconName: 'house-chimney-crack',
  icon: [576, 512, ["house-damage"], "f6f1", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l85.9 0-30.3-48.1c-4.4-6.9-2.8-16 3.6-21.1L288 327.6l-58.1-76.1c-11.3-14.8 7.4-33.6 22.3-22.5l115.2 86.2c8.4 6.3 8.6 18.8 .4 25.3L288 403.8 325.9 464 432 464c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8z"]
};
const faHouseDamage = faHouseChimneyCrack;
const faFileZipper = {
  prefix: 'far',
  iconName: 'file-zipper',
  icon: [384, 512, ["file-archive"], "f1c6", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l48 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l48 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm48 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8l-14.8 0c-14.5 0-27.2 9.7-30.9 23.8zM128 336l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faFileArchive = faFileZipper;
const faTicketPerforated = {
  prefix: 'far',
  iconName: 'ticket-perforated',
  icon: [640, 512, [], "e63e", "M48 128c0-8.8 7.2-16 16-16l512 0c8.8 0 16 7.2 16 16l0 35c-41.4 10.7-72 48.2-72 93s30.6 82.3 72 93l0 35c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-61.3c0-11.2-12.8-18.7-24-18.7c-26.5 0-48-21.5-48-48s21.5-48 48-48c11.2 0 24-7.5 24-18.7l0-61.3c0-35.3-28.7-64-64-64L64 64zm384 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faHeartHalf = {
  prefix: 'far',
  iconName: 'heart-half',
  icon: [512, 512, [], "e1ab", "M236.7 476.9c2.1 2 4.9 3.1 7.8 3.1c6.3 0 11.5-5.1 11.5-11.5l0-12.3 0-22.4 0-4.6L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1l0 5.8c0 41.5 17.2 81.2 47.6 109.5L208 450.1l3.3 3.1 16.4 15.3 9 8.4zM208 384.5L80.3 265.3C59.7 246.1 48 219.1 48 190.9l0-5.8c0-46.4 33.6-86 79.3-93.6c29.3-4.9 59.1 4.2 80.7 24.5l0 268.5z"]
};
const faCommentCheck = {
  prefix: 'far',
  iconName: 'comment-check',
  icon: [512, 512, [], "f4ac", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM369 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 193z"]
};
const faSquare = {
  prefix: 'far',
  iconName: 'square',
  icon: [448, 512, [9632, 9723, 9724, 61590], "f0c8", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faMemo = {
  prefix: 'far',
  iconName: 'memo',
  icon: [384, 512, [], "e1d8", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm120 64l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMartiniGlassEmpty = {
  prefix: 'far',
  iconName: 'martini-glass-empty',
  icon: [512, 512, ["glass-martini"], "f000", "M0 35.3C0 15.8 15.8 0 35.3 0L476.7 0C496.2 0 512 15.8 512 35.3c0 9.4-3.7 18.3-10.3 25L280 281.9 280 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-182.1L10.3 60.3C3.7 53.7 0 44.7 0 35.3zM256 238.1L446.1 48 65.9 48 256 238.1z"]
};
const faGlassMartini = faMartiniGlassEmpty;
const faCouch = {
  prefix: 'far',
  iconName: 'couch',
  icon: [640, 512, [], "f4b8", "M448 80L192 80c-44.2 0-80 35.8-80 80l0 40c-12.3-5.1-25.8-8-40-8c-2.7 0-5.4 .1-8 .3L64 160C64 89.3 121.3 32 192 32l256 0c70.7 0 128 57.3 128 128l0 32.3c-2.6-.2-5.3-.3-8-.3c-14.2 0-27.7 2.8-40 8l0-40c0-44.2-35.8-80-80-80zM568 224c2.7 0 5.4 .1 8 .4c36 4 64 34.5 64 71.6l0 136c0 26.5-21.5 48-48 48l-48 0c-20.9 0-38.7-13.4-45.3-32l-357.5 0c-6.6 18.6-24.4 32-45.3 32l-48 0c-26.5 0-48-21.5-48-48L0 296c0-37.1 28-67.6 64-71.6c2.6-.3 5.3-.4 8-.4c15.2 0 29.4 4.7 41 12.8c16.7 11.6 28.2 30 30.5 51.2l352.9 0c2.3-21.2 13.9-39.6 30.5-51.2c11.6-8.1 25.8-12.8 41-12.8zm-24 72l0 40 0 64 0 32 48 0 0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24zM496 400l0-64-352 0 0 64 352 0zM96 400l0-64 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136 48 0 0-32z"]
};
const faCediSign = {
  prefix: 'far',
  iconName: 'cedi-sign',
  icon: [384, 512, [], "e0df", "M216 0c13.3 0 24 10.7 24 24l0 48.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7c-20.9-14.8-46.3-24.5-74.1-27l0 270.8c27.8-2.5 53.2-12.2 74.1-27c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5l0 48.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-50.8C102 422 32 347.7 32 256s70-166 160-181.2L192 24c0-13.3 10.7-24 24-24zM80 256c0 63.2 47 117.9 112 132.3l0-264.6C127 138.1 80 192.8 80 256z"]
};
const faItalic = {
  prefix: 'far',
  iconName: 'italic',
  icon: [384, 512, [], "f033", "M128 56c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-68.7 0L144.7 432l87.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l68.7 0L239.3 80 152 80c-13.3 0-24-10.7-24-24z"]
};
const faGlassCitrus = {
  prefix: 'far',
  iconName: 'glass-citrus',
  icon: [512, 512, [], "f869", "M464 144c0-53-43-96-96-96c-35.5 0-66.6 19.3-83.2 48l-52.6 0C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144c0 78.4-62.7 142.2-140.7 144l4.6-48.3c49.3-4 88.1-45.3 88.1-95.7zM6.2 135.9c4.5-5 11-7.9 17.8-7.9l304 0c6.8 0 13.2 2.9 17.8 7.9s6.8 11.7 6.1 18.4l-29.2 307c-2.7 28.7-26.9 50.7-55.7 50.7L85.1 512c-28.9 0-53-21.9-55.7-50.7L.1 154.3c-.6-6.7 1.6-13.4 6.1-18.4zM62.6 304L77.1 456.8c.4 4.1 3.8 7.2 8 7.2l181.8 0c4.1 0 7.6-3.1 8-7.2L289.4 304 62.6 304zM58 256l236 0 7.6-80L50.4 176 58 256z"]
};
const faCalendarLinesPen = {
  prefix: 'far',
  iconName: 'calendar-lines-pen',
  icon: [576, 512, [], "e472", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-48 0-16 0L48 192l0 256c0 8.8 7.2 16 16 16l198.5 0-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zm-8 256l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 376c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faTableCellsColumnLock = {
  prefix: 'far',
  iconName: 'table-cells-column-lock',
  icon: [640, 512, [], "e678", "M448 80c8.8 0 16 7.2 16 16l0 72-104 0 0-88 88 0zM200 80l112 0 0 88-112 0 0-88zM312 432l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 296l0-80 112 0 0 80-112 0zm328-56c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faChurch = {
  prefix: 'far',
  iconName: 'church',
  icon: [640, 512, [9962], "f51d", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 26.9L192.9 189.7c-20.5 13.3-32.9 36-32.9 60.4L160 464l-88 0c-13.3 0-24-10.7-24-24l0-69.9c0-8.1 4.1-15.7 11-20.2l69-44.7 0-57.2L32.9 309.7C12.4 322.9 0 345.7 0 370.1L0 440c0 39.8 32.2 72 72 72l120 0s0 0 0 0l256 0 8 0 112 0c39.8 0 72-32.2 72-72l0-69.9c0-24.4-12.4-47.2-32.9-60.4L512 248.1l0 57.2L581 350c6.8 4.4 11 12 11 20.1l0 69.9c0 13.3-10.7 24-24 24l-88 0 0-213.9c0-24.4-12.4-47.2-32.9-60.4L344 122.9 344 96l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM320 164.6L421 230c6.8 4.4 11 12 11 20.1L432 464l-64 0 0-96c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96-64 0 0-213.9c0-8.1 4.1-15.7 11-20.1l101-65.4z"]
};
const faPersonSnowmobiling = {
  prefix: 'far',
  iconName: 'person-snowmobiling',
  icon: [640, 512, ["snowmobile"], "f7d1", "M240 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm99.7 75.4c11.4-6.8 26.1-3.1 32.9 8.2l46.8 78.1 138.9 69.4c10.8 5.4 17.7 16.5 17.7 28.6l0 59.1c0 10.7-5.3 20.7-14.2 26.6L492 392l54 72 20.1 0 33-33c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-40 40c-4.5 4.5-10.6 7-17 7l-136 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l46 0-48-64-124.7 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64l8-16 31.2-62.3C76.6 278.8 87.7 272 99.8 272L288 272l24-32-32 0c-7.6 0-14.7-3.6-19.2-9.6l-33.4-44.5c-4.7-6.2-12-9.9-19.8-9.9c-9.8 0-18.6 5.7-22.6 14.7l-19.1 43.1c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l19.1-43.1c11.7-26.3 37.7-43.2 66.4-43.2c22.9 0 44.4 10.8 58.2 29.1L292 192l56 0 18.7-24.9-35.3-58.8c-6.8-11.4-3.1-26.1 8.2-32.9zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 400zm160-48l225.5 0L528 310.3l0-40.6L398.4 204.8l-72 96L312 320l-24 0-178.3 0-16 32L240 352z"]
};
const faSnowmobile = faPersonSnowmobiling;
const faFaceHushed = {
  prefix: 'far',
  iconName: 'face-hushed',
  icon: [512, 512, [], "e37b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9zM256 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faCommentsDollar = {
  prefix: 'far',
  iconName: 'comments-dollar',
  icon: [640, 512, [], "f653", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM224 83.6l0 13.8c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.2 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2s0 0 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8l0 13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-14.3c-9.7-1.9-18.8-5-26.7-7.7c0 0 0 0 0 0s0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2c0 0 0 0 0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4s0 0 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6l0-13.9c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faTicketsSimple = {
  prefix: 'far',
  iconName: 'tickets-simple',
  icon: [640, 512, [], "e659", "M144 96c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16l0 38.2c-24 15.7-40 42.8-40 73.8s16 58.1 40 73.8l0 38.2c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-38.2c24-15.7 40-42.8 40-73.8s-16-58.1-40-73.8L144 96zM96 96l0 56c0 8.8 7.4 15.7 15.6 19.1c14.4 6.1 24.4 20.3 24.4 36.9s-10.1 30.8-24.4 36.9C103.4 248.3 96 255.2 96 264l0 56c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
};
const faPickaxe = {
  prefix: 'far',
  iconName: 'pickaxe',
  icon: [512, 512, [], "e5bf", "M460.3 112.6c47.6 66.4 63.4 152.5 42 231.5c-.3 .9-.5 1.9-.8 2.8c-1.3 4.4-2.6 8.9-4.1 13.2l-.2 .6c-1.5 4.5-3.2 8.9-5 13.3c-5.4 13.3-24.9 13-29.8-.5c-1.8-4.6-3.6-9.3-5.6-13.9c-1.6-3.7-3.2-7.4-4.9-11.1l-.8-1.7c-28.4-62.2-70.9-119.9-118.5-167.6C285.3 131.9 227.5 88.9 165.3 60.8l-1.7-.8c-3.7-1.7-7.5-3.3-11.3-4.9c-4.6-1.9-9.2-3.7-13.8-5.5c-13.4-5-13.7-24.5-.5-29.8c4.4-1.8 8.8-3.4 13.3-5l.2-.1c4.5-1.5 9-2.9 13.5-4.2c1-.3 2-.5 2.9-.8c78.9-21.3 165-5.5 231.3 42.1l9.5-9.9c6-6.2 14.2-9.7 22.8-9.8s16.9 3.3 22.9 9.4l16 16c6.1 6.1 9.5 14.3 9.4 22.9s-3.6 16.8-9.8 22.8l-9.9 9.5zm-62.2 .7C357 72.3 301 49.8 244.2 48.4c45.4 27.7 86.9 61.4 122.4 97c35.9 35.9 69.4 77.5 97 122.8c-1.3-57.2-24.1-113.6-65.5-154.8zM8.9 457.8l272-282.9c9.7 8.4 19.5 17.4 29.1 27s18.6 19.4 27 29.1L54.2 503.1c-12.6 12.1-32.5 11.9-44.8-.4S-3.1 470.4 8.9 457.8z"]
};
const faLinkSimpleSlash = {
  prefix: 'far',
  iconName: 'link-simple-slash',
  icon: [640, 512, [], "e1ce", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136c0-88.4-71.6-160-160-160l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0c61.9 0 112 50.1 112 112c0 46.6-28.5 86.6-69.1 103.5L389.5 280l34.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-95.7 0L216 144l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zm69.6 176.3L70.7 151.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-61.9 0-112-50.1-112-112c0-28.6 10.7-54.8 28.4-74.6z"]
};
const faDemocrat = {
  prefix: 'far',
  iconName: 'democrat',
  icon: [640, 512, [], "f747", "M102.2 4.7C99.8 11.1 96 23.1 96 32c0 12.7 5 22.8 11.1 30.5c-5.3 3.6-10.2 7.9-14.7 12.6l-70.6 76C7.8 166.2 0 186.1 0 206.6C0 251.4 36.2 288 81.2 288c13.8 0 27.4-3.5 39.4-10.2L157 257.5l35 75.7L192 456c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-24 96 0 0 24c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-128 0-112c0-1.4 0-2.8-.1-4.2c5.5 5.7 9.9 11.1 13.2 15.4c2.2 2.9 3.9 5.4 5 7c.5 .8 .9 1.4 1.1 1.8l.2 .3s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c6.8 11.3 21.5 15.1 32.9 8.3c11.4-6.8 15.1-21.5 8.4-32.9L616 224c20.6-12.3 20.6-12.3 20.6-12.3s0 0 0 0s0 0 0 0l-.1-.1-.2-.3-.5-.8c-.4-.7-1-1.6-1.8-2.8c-1.5-2.3-3.8-5.5-6.6-9.3c-5.7-7.6-14.2-17.7-25.1-27.9c-21.5-20-55.1-42.4-98.3-42.4c-1.9 0-3.7 .2-5.5 .6c-3.5-.4-7-.6-10.5-.6l-196.9 0c-1.8 0-3.5-.6-5-1.7L209.9 66.1c7.3-8 14.1-19.3 14.1-34.1c0-8.9-3.8-20.9-6.2-27.3C216.8 1.8 214 0 211 0c-1.9 0-3.8 .7-5.2 2.1L160 45.7 114.2 2.1C112.8 .7 110.9 0 109 0c-3 0-5.8 1.8-6.8 4.7zM240 352l288 0 0 104c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-48c0-13.3-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24l0 48c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-104zm288-48l-296.6 0-41.6-90.1c-2.8-6.1-8-10.7-14.3-12.8s-13.3-1.4-19.1 1.8l-59 32.8c-4.9 2.7-10.5 4.2-16.1 4.2C63 240 48 225.1 48 206.6c0-8.5 3.2-16.7 8.9-22.8l70.6-76c7.1-7.7 17.1-12.2 27.5-12.4c9.1-.2 17.9 2.7 25 8.3L256.4 164c9.9 7.8 22.1 12 34.7 12L488 176c22.1 0 40 17.9 40 40l0 88zM379.3 210.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4zM279.5 208c-1.6 0-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4c-.7-1.4-2.2-2.3-3.8-2.3zm195.8 2.3c-.7-1.4-2.2-2.3-3.8-2.3s-3.1 .9-3.8 2.3l-8.4 16.4-18.8 2.6c-1.6 .2-2.9 1.3-3.4 2.8s-.1 3.1 1.1 4.2l13.6 12.8-3.2 18.1c-.3 1.5 .4 3.1 1.7 4s3.1 1 4.5 .3l16.8-8.5 16.8 8.5c1.4 .7 3.2 .6 4.5-.3s2-2.5 1.7-4l-3.2-18.1 13.6-12.8c1.2-1.1 1.6-2.7 1.1-4.2s-1.8-2.6-3.4-2.8l-18.8-2.6-8.4-16.4z"]
};
const faFaceConfused = {
  prefix: 'far',
  iconName: 'face-confused',
  icon: [512, 512, [], "e36d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM203.2 385.6l-12.8 9.6c-10.6 8-25.6 5.8-33.6-4.8s-5.8-25.6 4.8-33.6l12.8-9.6c37.4-28 82.9-43.2 129.6-43.2l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-36.4 0-71.7 11.8-100.8 33.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPinball = {
  prefix: 'far',
  iconName: 'pinball',
  icon: [448, 512, [], "e229", "M352 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM312 408L126.8 251.2c-20.3-17-50.5-14.3-67.6 6s-14.4 50.6 6 67.7c4.5 3.8 9.8 6.8 15.9 8.8c0 0 0 0 .1 0L312 408zM66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3c12.6 9.8 15.8 27.1 8.4 40.6c-7.2 13.2-23.1 19.9-37.9 15L66.3 379.3zM96 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faZ = {
  prefix: 'far',
  iconName: 'z',
  icon: [384, 512, [122], "5a", "M0 56C0 42.7 10.7 32 24 32l336 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.4-3.4 25.6L75.5 432 360 432c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.4 3.4-25.6L308.5 80 24 80C10.7 80 0 69.3 0 56z"]
};
const faPersonSkiing = {
  prefix: 'far',
  iconName: 'person-skiing',
  icon: [512, 512, [9975, "skiing"], "f7c9", "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L239.8 365l49.6-74.5-82.7-87.9c-9.5-10.1-14.4-22.4-15.1-34.9l87.7 42 49.4 52.5c12.8 13.6 14.5 34.1 4.2 49.6l-50.2 75.4 135.8 70.5c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 55.5 26.6c1.7-.9 3.5-1.7 5.4-2.5l80.9-32.4c32.4-13 68.6 6.5 75.6 40.7l12.3 59.7 62.9 30.1c12 5.7 17 20 11.3 32s-20 17-32 11.3l-54.2-25.9c-1-.3-1.9-.6-2.8-1l-229.1-110-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5zm217.3 64.7c-1-4.9-6.2-7.7-10.8-5.8l-45.7 18.3 65.5 31.5-9-43.9z"]
};
const faSkiing = faPersonSkiing;
const faDeer = {
  prefix: 'far',
  iconName: 'deer',
  icon: [512, 512, [129420], "f78e", "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 30.9 25.1 56 56 56l8 0 8 0 24 0-50.4 12.6c-8 2-13.6 9.2-13.6 17.4c0 9.9 8 18 18 18l28.2 0L295 168l-191 0c-36.5 0-68.3 20.4-84.5 50.4c-9.2 13.7-15.1 30-16.2 47.6L0 319c-.6 8.8 6.2 16.4 15 17c8.5 .5 15.9-5.7 16.9-14.1l1.1 1.1c4.5 4.5 7 10.6 7 17l0 4.3c0 2.6-.4 5.1-1.2 7.6l-8.2 24.7c-5.1 15.4-4.9 32.1 .6 47.4l22.5 61.8C59.4 501.5 74.4 512 91.2 512l46 0c27.8 0 47.1-27.6 37.6-53.7L157 409.5l6.5-4.3c15.2-10.1 25.6-25.4 29.9-42.4c20 8.7 41.7 13.3 63.8 13.3l6.8 0 0 96c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-160.2c0-2.6 .4-5.1 1.2-7.6L409.3 256l42.3 0c37.8 0 68.4-30.6 68.4-68.4c0-19.3-8.1-37.6-22.4-50.6L444.1 88.4C460.8 78.7 472 60.7 472 40l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-29.9 0-39.5 0c3.5-7.3 5.4-15.4 5.4-24l0-24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zm130.1 96c8.1 0 15.9 3 21.9 8.5l57.3 52.1c4.2 3.9 6.7 9.3 6.7 15.1c0 11.3-9.1 20.4-20.4 20.4L392 208c-10.3 0-19.5 6.6-22.8 16.4L347.7 289c-2.4 7.3-3.7 15-3.7 22.8L344 464l-32 0 0-112c0-13.3-10.7-24-24-24l-30.8 0c-22.1 0-43.7-6.5-62.1-18.8L181.3 300c-8-5.3-18.3-5.4-26.3-.2s-12.2 14.7-10.6 24.1l2.9 17.4c1.6 9.3-2.5 18.7-10.4 23.9L114.7 380c-9.2 6.1-13 17.8-9.2 28.2L125.7 464l-28.9 0L76.3 407.5c-1.9-5.1-1.9-10.7-.2-15.8L84.3 367c2.4-7.3 3.7-15 3.7-22.8l0-4.3c0-19.1-7.6-37.4-21.1-50.9L63 285.1c-4.5-4.5-7-10.6-7-17l0-4.1c0-26.5 21.5-48 48-48l208.9 0c10.6 0 20-7 23-17.1l19-63.6c4.1-13.8 16.8-23.2 31.2-23.2zM416 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faInputPipe = {
  prefix: 'far',
  iconName: 'input-pipe',
  icon: [640, 512, [], "e1be", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm144 56l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faRoadLock = {
  prefix: 'far',
  iconName: 'road-lock',
  icon: [640, 512, [], "e567", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480L384 480l0-48-40 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l28.3 78.5c13.8-7.8 29.4-12.7 46-14L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM344 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm184 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faA = {
  prefix: 'far',
  iconName: 'a',
  icon: [384, 512, [97], "41", "M214.1 46.7C210.4 37.8 201.7 32 192 32s-18.4 5.8-22.1 14.7l-168 400c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L80.3 384l223.5 0 34.1 81.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4l-168-400zM283.6 336l-183.1 0L192 118l91.6 218z"]
};
const faBookmarkSlash = {
  prefix: 'far',
  iconName: 'bookmark-slash',
  icon: [640, 512, [], "e0c2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-328c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48l0 27L38.8 5.1zM176 112.6L176 48l288 0 0 290.4L176 112.6zM509.9 497.8L315.3 344.5c-3.3 .6-6.5 2-9.3 4L176 441.4l0-206.7-48-37.8L128 488c0 9 5 17.2 13 21.3s17.6 3.4 24.9-1.8L320 397.5l154.1 110c7.3 5.2 16.9 5.9 24.9 1.8c4.9-2.5 8.8-6.7 10.9-11.6z"]
};
const faTemperatureArrowDown = {
  prefix: 'far',
  iconName: 'temperature-arrow-down',
  icon: [576, 512, ["temperature-down"], "e03f", "M176 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L240 112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L64 112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3zM448 480c-6.8 0-13.3-2.9-17.8-7.9l-72-80c-8.9-9.9-8.1-25 1.8-33.9s25-8.1 33.9 1.8L424 393.5 424 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 337.5 30.2-33.5c8.9-9.9 24-10.7 33.9-1.8s10.7 24 1.8 33.9l-72 80c-4.6 5.1-11 7.9-17.8 7.9z"]
};
const faTemperatureDown = faTemperatureArrowDown;
const faMace = {
  prefix: 'far',
  iconName: 'mace',
  icon: [512, 512, [], "f6f8", "M244.8 95l28-84.1C275 4.4 281.1 0 288 0s13 4.4 15.2 10.9l28 84.1c40.4 13.5 72.3 45.4 85.8 85.8l84.1 28c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-84.1 28c-13.5 40.4-45.4 72.3-85.8 85.8l-28 84.1C301 443.6 294.9 448 288 448s-13-4.4-15.2-10.9l-28-84.1c-12.4-4.1-24-10-34.5-17.4L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L176.4 301.7c-7.3-10.5-13.2-22.1-17.4-34.5l-84.1-28C68.4 237 64 230.9 64 224s4.4-13 10.9-15.2l84.1-28c13.5-40.4 45.4-72.3 85.8-85.8zM288 312a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm-32-88a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faFeatherPointed = {
  prefix: 'far',
  iconName: 'feather-pointed',
  icon: [512, 512, ["feather-alt"], "f56b", "M117.7 343.9c-11.2-41.4-11.7-113 53.7-178.3c38.1-38.1 93.7-66.3 152.8-85.7c50.6-16.7 100.7-26 138.3-30.3c-4.3 37.6-13.6 87.7-30.3 138.3c-2.2 6.8-4.6 13.5-7 20.1l-87.2 0 7.9-7.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L122.8 355.2c-2.6-4.1-4.2-7.9-5.1-11.3zm4.6 79.7c10 7.6 21 13.7 33.3 17c54.1 14.6 144.7 14 224.8-66.1C471.5 283.5 505 120.5 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c3.3 12.2 9.4 23.2 17 33.3L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l81.3-81.3zm34.5-34.5L193.9 352l140.4 0c-61.9 53.9-127.3 52.9-166.2 42.3c-3.5-.9-7.2-2.6-11.3-5.2zm220-85.2l-134.8 0 48-48 114.7 0c-8.4 17-17.7 33.2-27.9 48z"]
};
const faFeatherAlt = faFeatherPointed;
const faSausage = {
  prefix: 'far',
  iconName: 'sausage',
  icon: [512, 512, [], "f820", "M447.5 69.3l15.2-41.9c.8-2.2 1.2-4.6 1.2-7C464 9.1 454.9 0 443.6 0L388.4 0C377.1 0 368 9.1 368 20.4c0 2.4 .4 4.7 1.2 7l15.2 41.9C346.9 82.3 320 118 320 160c0 88.4-71.6 160-160 160c-42 0-77.7 26.9-90.7 64.5L27.4 369.2c-2.2-.8-4.6-1.2-7-1.2C9.1 368 0 377.1 0 388.4l0 55.2C0 454.9 9.1 464 20.4 464c2.4 0 4.7-.4 7-1.2l41.9-15.2C82.3 485.1 118 512 160 512c194.4 0 352-157.6 352-352c0-42-26.9-77.7-64.5-90.7zM112 416c0-26.5 21.5-48 48-48c114.9 0 208-93.1 208-208c0-26.5 21.5-48 48-48s48 21.5 48 48c0 167.9-136.1 304-304 304c-26.5 0-48-21.5-48-48z"]
};
const faTrashCanClock = {
  prefix: 'far',
  iconName: 'trash-can-clock',
  icon: [576, 512, [], "e2aa", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 64.7c-16.8 1.5-32.9 5.4-48 11.3l0-76L80 128l0 304c0 17.7 14.3 32 32 32l172.5 0c12.3 18.8 28 35.1 46.3 48L112 512c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM320 192l0 40.2c-12.1 10-22.9 21.7-32 34.6l0-74.8c0-8.8 7.2-16 16-16s16 7.2 16 16zm-160 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm48 176a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"]
};
const faP = {
  prefix: 'far',
  iconName: 'p',
  icon: [320, 512, [112], "50", "M56 80l112 0c57.4 0 104 46.6 104 104s-46.6 104-104 104L48 288 48 88c0-4.4 3.6-8 8-8zM48 336l120 0c83.9 0 152-68.1 152-152s-68.1-152-152-152L56 32C25.1 32 0 57.1 0 88L0 312 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120z"]
};
const faBroomWide = {
  prefix: 'far',
  iconName: 'broom-wide',
  icon: [512, 512, [], "e5d1", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 143l-12.9-12.9c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4L392.6 266.2c13.9-25 9.5-56.1-10.7-76.3L369 177 505 41zM323.6 291.6l-90 162.1L137 357.1l18-53.9c2.1-6.3-3.9-12.2-10.1-10.1L90.9 311 58.4 278.5l162.1-90L323.6 291.6z"]
};
const faSnowflake = {
  prefix: 'far',
  iconName: 'snowflake',
  icon: [448, 512, [10052, 10054], "f2dc", "M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24z"]
};
const faStomach = {
  prefix: 'far',
  iconName: 'stomach',
  icon: [512, 512, [], "f623", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72c0 66.3 53.7 120 120 120l.2 0c-.2 2.6-.2 5.3-.2 8l0 64c0 39.8-32.2 72-72 72l-64 0C53.7 360 0 413.7 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-35.3 28.7-64 64-64c9.6 0 19 3.5 30.6 11.1c8.8 5.7 17.1 12.6 26.9 20.7c4.2 3.4 8.6 7.1 13.5 11C214.6 484 255.9 512 320 512c106 0 192-86 192-192l0-96c0-70.7-57.3-128-128-128c-50.6 0-94.4 29.4-115.1 72L256 168c-39.8 0-72-32.2-72-72l0-72zm18 388.3c-2-1.6-4-3.3-6-4.9c46.2-4.6 84.6-35.4 100.4-77.3c12.2-6.9 22.6-8 32.7-6.6c12.4 1.7 24.9 7.1 41.1 14.4l1.2 .6c14.8 6.6 33.1 14.8 53 17.6c11.5 1.6 23.3 1.3 35.4-1.5C444.4 417.4 387.6 464 320 464c-47.9 0-78.6-20-107-42.7c-3.5-2.8-7.2-5.8-10.9-8.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0zM464 301.6c-12.4 7.1-22.9 8.2-33.1 6.8c-12.4-1.7-24.9-7.1-41.1-14.4l-1.2-.6c-14.8-6.6-33.1-14.8-53-17.6c-10.3-1.4-20.8-1.4-31.6 .7l0-52.7c0-44.2 35.8-80 80-80s80 35.8 80 80l0 77.6z"]
};
const faNewspaper = {
  prefix: 'far',
  iconName: 'newspaper',
  icon: [512, 512, [128240], "f1ea", "M168 80c-13.3 0-24 10.7-24 24l0 304c0 8.4-1.4 16.5-4.1 24L440 432c13.3 0 24-10.7 24-24l0-304c0-13.3-10.7-24-24-24L168 80zM72 480c-39.8 0-72-32.2-72-72L0 112C0 98.7 10.7 88 24 88s24 10.7 24 24l0 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-39.8 32.2-72 72-72l272 0c39.8 0 72 32.2 72 72l0 304c0 39.8-32.2 72-72 72L72 480zM176 136c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-80zm200-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faRectangleAd = {
  prefix: 'far',
  iconName: 'rectangle-ad',
  icon: [576, 512, ["ad"], "f641", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm229.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328l-90.3 0-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280l42.3 0L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9l0-28.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96 0 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"]
};
const faAd = faRectangleAd;
const faGuitarElectric = {
  prefix: 'far',
  iconName: 'guitar-electric',
  icon: [512, 512, [127928], "f8be", "M352 126.1l0-44.9c0-10.7 5.3-20.7 14.2-26.6L435.6 8.3C443.7 2.9 453.2 0 462.9 0L464 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-14.1 0L314.4 231.6c9.1 8.1 13.8 8.4 14.9 8.4c2.6 .1 4.3-.6 10.9-3.5l3.7-1.6c13.2-5.6 36-8.3 52.3 8.2c15.8 15.9 15.8 41.7 0 57.6l-21.6 21.8c-12.2 12.3-28.2 18.8-38.7 23l-2.1 .8c-5.5 2.2-12.7 6.3-20.3 14c-17.3 17.5-23.7 39.4-30.6 63.5c-.9 3-1.7 6-2.6 9.1c-5.2 17.5-14.1 35-28.1 49.2c-39.4 39.9-103.5 39.9-142.9 0L29.5 401.3c-39.3-39.7-39.3-104 0-143.7c14.1-14.2 31.4-23.3 48.8-28.5c2.9-.9 5.7-1.7 8.6-2.6c0 0 0 0 0 0c23.9-7.1 45.6-13.5 63-31.1c6.3-6.3 10.1-12.4 12.5-17.5c.8-1.8 1.8-3.8 2.8-6c5.4-11.9 13.1-29.1 25.6-41.7l29.9-30.2c15.9-16.1 41.8-16.1 57.7 0c16.1 16.3 14.2 39.7 5.2 54.6c-1.1 1.8-2.1 3.4-3 4.9c0 0 0 0 0 0c-4.9 8-7.8 12.7-8.8 18.2c-.6 3.2-1 9.2 8.7 19.8L352 126.1zM167 263c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zM242.4 129.8s0 0 0 0s0 0 0 0c0 0 0 0 0-.1zm-18 39.8c.4-2.3 .9-4.5 1.5-6.7l-1.2 1.2c-5.9 5.9-9.4 13.5-14.7 25.1c0 0 0 0 0 0c-1.3 2.9-2.8 6-4.4 9.4c-4.6 9.6-11.5 20.2-21.7 30.6c-26.7 27-60.7 36.8-83.8 43.5c0 0 0 0 0 0c-2.8 .8-5.5 1.6-7.9 2.3c-11.5 3.5-21.3 9-28.6 16.4c-20.8 21-20.8 55.2 0 76.2l79.9 80.8c20.6 20.9 54 20.9 74.6 0c7.3-7.4 12.8-17.4 16.3-29.1c.8-2.6 1.5-5.3 2.4-8.2c6.6-23.3 16.2-57.6 42.8-84.4c12.5-12.6 25.3-20.2 36.2-24.7c12.9-5.2 20-8.4 24.7-13.2l2.3-2.4c-4.6 1.1-9.7 1.7-15 1.6c-18-.5-35-9.6-52.1-26.9c0 0 0 0 0 0L248 233.2c0 0 0 0-.1-.1c-20.4-20.6-27.2-42.3-23.5-63.5z"]
};
const faArrowTurnDownRight = {
  prefix: 'far',
  iconName: 'arrow-turn-down-right',
  icon: [512, 512, [], "e3d6", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 224c0 48.6 39.4 88 88 88l342.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9L377 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l87 87L88 264c-22.1 0-40-17.9-40-40L48 56z"]
};
const faMoonCloud = {
  prefix: 'far',
  iconName: 'moon-cloud',
  icon: [640, 512, [], "f754", "M635.2 416.6c-2.6 2.5-5.2 5-7.9 7.3c-4.5 4-9.1 7.8-13.9 11.4c-1.8 1.4-3.7 2.7-5.5 4C571.5 465 527.2 480 479.5 480c-60.9 0-116.1-24.4-156.4-64c11.6-12 20.3-26.9 25-43.4C380.2 409 427.2 432 479.5 432c13.3 0 26.2-1.5 38.6-4.3C430.5 397.4 367.6 314 367.6 216c0-43 12.1-83.2 33.1-117.3C343.4 127.6 304 187.1 304 256l0 .3c-13.9-8.9-30.1-14.6-47.5-16c7.6-110.9 95.8-199.6 206.3-207.7c2.3-.2 4.6-.3 6.9-.4c3.2-.1 6.5-.2 9.8-.2c2.7 0 5.5 0 8.2 .1c3.6 .1 7.2 .3 10.7 .6c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-3.2 1.8-6.4 3.8-9.6 5.8c-4.3 2.8-8.5 5.8-12.5 9c-1.1 .8-2.1 1.7-3.2 2.6c-39.2 32.3-64.1 81.2-64.1 136c0 97.1 78.5 175.8 175.2 176l.3 0c1.2 0 2.5 0 3.7 0c5.2-.1 10.3-.4 15.3-1c3.7-.4 7.4-.9 11.1-1.6c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7zM64 416c-35.3 0-64-28.7-64-64s28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72s-32.2 72-72 72L64 416z"]
};
const faBreadSliceButter = {
  prefix: 'far',
  iconName: 'bread-slice-butter',
  icon: [512, 512, [], "e3e1", "M112 256l0 176 288 0 0-176c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16c0-34.5-24.6-62.3-74.9-83.9C340.2 87.2 282.8 80 256 80s-84.2 7.2-133.1 28.1C72.6 129.7 48 157.5 48 192c0 8.8 7.2 16 16 16c26.5 0 48 21.5 48 48zm336 0l0 48 0 128c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-128 0-48c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zm-265.4 9.4l50.7-50.7c12.5-12.5 32.8-12.5 45.3 0l50.7 50.7c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3z"]
};
const faCircleArrowRight = {
  prefix: 'far',
  iconName: 'circle-arrow-right',
  icon: [512, 512, ["arrow-circle-right"], "f0a9", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM305 361l88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L136 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l182.1 0-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"]
};
const faArrowCircleRight = faCircleArrowRight;
const faUserGroupCrown = {
  prefix: 'far',
  iconName: 'user-group-crown',
  icon: [640, 512, ["users-crown"], "f6a5", "M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zm-.1-124.9l.1 .1c10.2 7.5 23.8 8.3 34.9 2L209.1 4c4.6-2.6 9.7-4 14.9-4s10.4 1.4 14.9 4l30.2 17.2c11 6.3 24.7 5.5 34.9-2l.1-.1c.3-.2 .6-.4 .8-.6l3-2.4L323.6 3.5c2.8-2.3 6.4-3.5 10-3.5L336 0c8.8 0 16 7.2 16 16l0 23 0 3.2c0 0 0 .1 0 .1L352 144c0 70.7-57.3 128-128 128s-128-57.3-128-128L96 42.3c0 0 0-.1 0-.1L96 39l0-23c0-8.8 7.2-16 16-16l2.4 0c3.6 0 7.2 1.2 10 3.5L140 16l3 2.4c.3 .2 .6 .4 .8 .6zM48.3 464l351.5 0c-4.1-62.5-56.2-112-119.7-112l-112 0c-63.6 0-115.6 49.5-119.7 112zM0 472c0-92.8 75.2-168 168-168l112 0c92.8 0 168 75.2 168 168l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8zM432 256c-27.7 0-53-10.1-72.6-26.7c.5-.8 1-1.5 1.4-2.3c12.1-19.9 20-42.6 22.4-67c.5-5.3 .8-10.6 .8-16l0-101.2C398.5 35.9 414.8 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112zM609.3 512l-137.8 0c5.4-9.4 8.6-20.3 8.6-32l0-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2l61.4 0C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7z"]
};
const faUsersCrown = faUserGroupCrown;
const faCircleI = {
  prefix: 'far',
  iconName: 'circle-i',
  icon: [512, 512, [], "e111", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 160-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-160 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-72 0z"]
};
const faToiletPaperCheck = {
  prefix: 'far',
  iconName: 'toilet-paper-check',
  icon: [640, 512, [], "e5b2", "M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7c0 0 0 0 0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0L492.2 0c0 0 0 .1 0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464l260.1 0c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48L160 48zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-204.7-4.7l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L232 225.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faFilterCircleXmark = {
  prefix: 'far',
  iconName: 'filter-circle-xmark',
  icon: [576, 512, [], "e17b", "M0 41.7C0 18.7 18.7 0 41.7 0L469.9 0C493.2 0 512 18.8 512 42.1c0 8.9-2.8 17.6-8.1 24.8L411.6 193.2c-30.9 3.6-59.3 15.1-83.2 32.5L458.3 48 55 48 218.6 248.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4L256.3 358c-.2 3.3-.3 6.6-.3 10c0 20.8 3.6 40.7 10.2 59.2l-75.1-59.6c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 68C3.3 60.6 0 51.3 0 41.7zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
const faLocust = {
  prefix: 'far',
  iconName: 'locust',
  icon: [576, 512, [], "e520", "M304 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0c94.6 0 173.9 65.7 194.7 154c-12.9-6.4-27.4-10-42.7-10l-45.4 0-45.5-83.5c-3.9-7.2-11.3-11.9-19.4-12.5s-16.1 3.1-21 9.7l-35 47.5-29.4-46.2c-4.2-6.6-11.3-10.7-19-11.1s-15.2 3-20.1 9.1L176.6 224l-74.4 0C63.4 224 32 255.4 32 294.1c0 26.9 15.4 51.3 39.4 63.1L5.2 441.1c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l73.5-93.1 41.5 19-33.2 45c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1l42.5-57.6c11.8 2.3 23.9 3.4 36 3.4l33.4 0-16.1 28.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L330.5 416l110.7 0 25.4 50.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-15.2-30.3c46.2-6.9 81.6-46.7 81.7-94.7l0-.2 0-40C576 143 465 32 328 32l-24 0zm61 164.6l15 27.4-35.2 0L365 196.6zm-103.1-3.2L281.4 224l-43.6 0 24.2-30.6zM102.1 272l36.5 0L102 318.4l-9.1-4.2C85.1 310.7 80 302.8 80 294.1c0-12.2 9.9-22.1 22.1-22.1zm97.7 0L480 272c26.5 0 48 21.5 48 48s-21.5 48-48 48l-23.5 0c-.2 0-.3 0-.5 0s-.3 0-.5 0l-213.7 0c-20.7 0-41.1-4.4-59.9-13l-35-16 52.9-67zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faSort = {
  prefix: 'far',
  iconName: 'sort',
  icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176l178.7 0L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336 70.6 336zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
const faUnsorted = faSort;
const faListOl = {
  prefix: 'far',
  iconName: 'list-ol',
  icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM216 72l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faList12 = faListOl;
const faListNumeric = faListOl;
const faChartWaterfall = {
  prefix: 'far',
  iconName: 'chart-waterfall',
  icon: [512, 512, [], "e0eb", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm120-72l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM480 88l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSparkle = {
  prefix: 'far',
  iconName: 'sparkle',
  icon: [448, 512, [], "e5d6", "M224 32c9.4 0 17.9 5.4 21.8 13.9l59.5 128.8 128.8 59.5c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8L305.3 337.3 245.8 466.1c-3.9 8.5-12.4 13.9-21.8 13.9s-17.9-5.4-21.8-13.9L142.7 337.3 13.9 277.8C5.4 273.9 0 265.4 0 256s5.4-17.9 13.9-21.8l128.8-59.5L202.2 45.9C206.1 37.4 214.6 32 224 32zm0 81.2l-41.4 89.6c-2.4 5.2-6.5 9.3-11.7 11.7L81.2 256l89.6 41.4c5.2 2.4 9.3 6.5 11.7 11.7L224 398.8l41.4-89.6c2.4-5.2 6.5-9.3 11.7-11.7L366.8 256l-89.6-41.4c-5.2-2.4-9.3-6.5-11.7-11.7L224 113.2z"]
};
const faFaceParty = {
  prefix: 'far',
  iconName: 'face-party',
  icon: [640, 512, [], "e383", "M320 464c59 0 112.2-24.6 150.1-64l61.6 0C485.6 467.6 408 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0C433.4 0 529.7 73.8 563.3 176l-3.3 0c-15.9 0-30.7 4.6-43.2 12.6C488.9 106.8 411.3 48 320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208zM204.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zm160 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM416 316c0 6.9-3.1 13.2-7.3 18.3c-.5 .6-1 1.1-1.5 1.7L592 336c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-184.8 0c.5 .6 1 1.1 1.5 1.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM51.3 152.2l-20-52C46.6 71.8 66 46 88.8 23.4L132 37.8C96.5 68.5 68.5 107.7 51.3 152.2zM55.1 12.2C40.9 27.6 28 44.4 16.6 62.1L1.1 21.7C-1.2 16 .2 9.4 4.4 4.9S15.2-1.1 21.1 .8L55.1 12.2z"]
};
const faKidneys = {
  prefix: 'far',
  iconName: 'kidneys',
  icon: [640, 512, [], "f5fb", "M165.8 0c-24 0-52.6 6.6-76.2 27.3C58.2 54.8 0 119.5 0 221.2c0 23 3.2 49.4 6.4 70.3c8.9 57.7 59.1 95.9 113.3 95.9c69.6 0 123.8-60.3 116.4-129.5l-.5-5.1 15.9 7.9c2.7 1.4 4.4 4.1 4.4 7.2L256 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-21.2-12-40.6-31-50.1l-31-15.5 16.4-17.4c18.7-19.8 29.1-46 29.1-73.3c0-36.7-18.9-70.9-50-90.4L232.5 18 219.8 38.2 232.5 18C213.8 6.2 192.1 0 170 0l-4.2 0zM121.2 63.4C133.8 52.4 150 48 165.8 48l4.2 0c13.1 0 25.9 3.7 37 10.6l5.2 3.2c17.1 10.7 27.5 29.5 27.5 49.7c0 15-5.7 29.4-16 40.3l-16.9 17.8c-16.1 17-23.9 40.2-21.4 63.4l3.2 29.8c4.3 40.8-27.7 76.4-68.7 76.4c-32.4 0-60.9-22.6-65.9-55.1c-3.1-20.2-5.9-43.7-5.9-63c0-82 46.8-134.6 73.2-157.8zm310.7-4.8C443 51.7 455.8 48 468.9 48l4.2 0c15.8 0 32 4.4 44.6 15.4c26.4 23.2 73.2 75.8 73.2 157.8c0 19.3-2.8 42.7-5.9 63c-5 32.5-33.5 55.1-65.9 55.1c-41.1 0-73.1-35.6-68.7-76.4l3.2-29.8c2.5-23.3-5.4-46.4-21.4-63.4l-16.9-17.8c-10.3-10.9-16-25.3-16-40.3c0-20.2 10.4-39 27.5-49.7l5.2-3.2zM468.9 0c-22.1 0-43.8 6.2-62.5 18l-5.2 3.2c-31.1 19.5-50 53.6-50 90.4c0 27.2 10.4 53.5 29.1 73.3l16.8 17.7L367 217.7c-19 9.5-31 28.9-31 50.1L336 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220.2c0-3 1.7-5.8 4.4-7.2l14.8-7.4-.5 4.6c-7.4 69.2 46.9 129.5 116.4 129.5c54.3 0 104.5-38.1 113.3-95.9c3.2-20.9 6.4-47.3 6.4-70.3c0-101.7-58.2-166.3-89.6-193.9C525.8 6.6 497.2 0 473.2 0l-4.2 0z"]
};
const faWifiExclamation = {
  prefix: 'far',
  iconName: 'wifi-exclamation',
  icon: [640, 512, [], "e2cf", "M344 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 256c0 13.3 10.7 24 24 24s24-10.7 24-24l0-256zM8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c61.5-54.2 138.8-90.8 224.1-102L264 56c0-7.5 1.5-14.6 4.1-21.2C169 45.7 79.1 87.2 8.2 149.6zM119.9 285.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c31-28.4 69.2-49.1 111.6-58.9l0-49.1c-54.9 10.5-104.5 36.2-144.1 72.6zM376 213.3l0 49.1c42.4 9.8 80.6 30.4 111.6 58.9c9.8 9 25 8.3 33.9-1.5s8.3-24.9-1.5-33.9c-39.6-36.3-89.1-62-144.1-72.6zM264 424a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM376 56l0 27.7c85.3 11.2 162.6 47.8 224.1 102c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C560.9 87.2 471 45.7 371.9 34.8c2.7 6.5 4.1 13.7 4.1 21.2z"]
};
const faChartNetwork = {
  prefix: 'far',
  iconName: 'chart-network',
  icon: [640, 512, [], "f78a", "M288 64c0 16.9-6.5 32.2-17.2 43.6l26.9 57.5c12.2-3.4 25-5.2 38.3-5.2c39 0 74.4 15.5 100.3 40.7l77.6-56.9c-1.3-5-1.9-10.3-1.9-15.7c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-12.3 0-23.9-3.5-33.7-9.6l-77.6 56.9c9.8 19.4 15.3 41.4 15.3 64.6c0 18.5-3.5 36.2-9.9 52.5l67.3 40.4c10.7-8.1 24.1-12.9 38.5-12.9c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.4 .3-6.7 .8-9.9l-67.4-40.4C419 428.5 379.8 448 336 448c-71.4 0-130.6-51.9-142-120l-70.6 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l70.6 0c6.6-39.1 28.9-72.9 60.2-94.5l-26.9-57.6c-1.1 .1-2.2 .1-3.3 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm48 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faPersonDressBurst = {
  prefix: 'far',
  iconName: 'person-dress-burst',
  icon: [640, 512, [], "e544", "M480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-47.9-84.6 46.3 148c3.2 10.3-4.5 20.8-15.3 20.8L544 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.2 0c-10.8 0-18.5-10.5-15.3-20.8l46.3-148-47.9 84.6c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM526.7 336L480 186.5 433.3 336l93.4 0zM176 8c8.9 0 17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9L332.2 193l-31.7 56.1-32 8.6-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38-51.7 38c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8zm0 75.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2z"]
};
const faDiceD4 = {
  prefix: 'far',
  iconName: 'dice-d4',
  icon: [512, 512, [], "f6d0", "M256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0zM58.2 307.8L232 439.7l0-347.6L58.2 307.8zM280 92.1l0 347.6L453.8 307.8 280 92.1z"]
};
const faMoneyCheckDollar = {
  prefix: 'far',
  iconName: 'money-check-dollar',
  icon: [576, 512, ["money-check-alt"], "f53d", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM280 272l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24zm-76-48l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"]
};
const faMoneyCheckAlt = faMoneyCheckDollar;
const faVectorSquare = {
  prefix: 'far',
  iconName: 'vector-square',
  icon: [448, 512, [], "f5cb", "M360 72l48 0 0 48-48 0 0-48zm-8-40c-17.7 0-32 14.3-32 32l0 8L128 72l0-8c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-192 8 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM88 352l0-192 8 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 8-192 0 0-8c0-17.7-14.3-32-32-32l-8 0zM40 440l0-48 48 0 0 48-48 0zm320 0l0-48 48 0 0 48-48 0zM40 120l0-48 48 0 0 48-48 0z"]
};
const faBreadSlice = {
  prefix: 'far',
  iconName: 'bread-slice',
  icon: [512, 512, [], "f7ec", "M64 208c-8.8 0-16-7.2-16-16c0-34.5 24.6-62.3 74.9-83.9C171.8 87.2 229.2 80 256 80s84.2 7.2 133.1 28.1C439.4 129.7 464 157.5 464 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 176-288 0 0-176c0-26.5-21.5-48-48-48zm384 96l0-48c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64l0 48 0 128c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-128z"]
};
const faLanguage = {
  prefix: 'far',
  iconName: 'language',
  icon: [640, 512, [], "f1ab", "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l208 0 32 0 16 0 256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L320 64l-16 0-32 0L64 64zm512 48c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-256 0 0-288 256 0zM178.3 175.9l64 144c4.5 10.1-.1 21.9-10.2 26.4s-21.9-.1-26.4-10.2L196.8 316l-73.6 0-8.9 20.1c-4.5 10.1-16.3 14.6-26.4 10.2s-14.6-16.3-10.2-26.4l64-144c3.2-7.2 10.4-11.9 18.3-11.9s15.1 4.7 18.3 11.9zM179 276l-19-42.8L141 276l38 0zM456 164c-11 0-20 9-20 20l0 4-52 0c-11 0-20 9-20 20s9 20 20 20l72 0 35.1 0c-7.3 16.7-17.4 31.9-29.8 45l-.5-.5-14.6-14.6c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3L430 298.3c-5.9 3.6-12.1 6.9-18.5 9.8l-3.6 1.6c-10.1 4.5-14.6 16.3-10.2 26.4s16.3 14.6 26.4 10.2l3.6-1.6c12-5.3 23.4-11.8 34-19.4c4.3 3 8.6 5.8 13.1 8.5l18.9 11.3c9.5 5.7 21.8 2.6 27.4-6.9s2.6-21.8-6.9-27.4l-18.9-11.3c-.9-.5-1.8-1.1-2.7-1.6c17.2-18.8 30.7-40.9 39.6-65.4L534 228l2 0c11 0 20-9 20-20s-9-20-20-20l-16 0-44 0 0-4c0-11-9-20-20-20z"]
};
const faWheatAwnSlash = {
  prefix: 'far',
  iconName: 'wheat-awn-slash',
  icon: [640, 512, [], "e338", "M568.7 7.2c9.4 9.4 9.4 24.6 0 33.9L430.1 179.7c7.9 .9 15.8 2.5 23.4 4.8L535 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71.4 71.4c3.1 2.5 6 5.2 8.9 8.1l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c2.8 3.9 4.4 8.4 4.6 13L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L216.6 144.4l12.8-12.8c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9c2.9 2.9 5.7 5.9 8.2 9L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-81.6 81.6c2.3 7.6 3.9 15.4 4.8 23.2L534.7 7.2c9.4-9.4 24.6-9.4 33.9 0zM148.2 212.8L376.5 392.6c-3 .8-6 1.4-9 2c6.9 9.4 6 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.3-11.3s0 0 0 0L105 504.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l73.5-73.5s0 0 0 0l-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l15-15zM325.5 103.3c-25 25-25 65.5 0 90.5L335.7 204c20.5-31 17.2-73.3-10.2-100.6zM223.7 408.7c25 25 65.5 25 90.5 0c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1zm-56.5-56.5l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM382.1 250.4c25 25 65.5 25 90.5 0C445.2 223 403 219.7 371.9 240.2l10.1 10.1z"]
};
const faFaceKissWinkHeart = {
  prefix: 'far',
  iconName: 'face-kiss-wink-heart',
  icon: [512, 512, [128536, "kiss-wink-heart"], "f598", "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"]
};
const faKissWinkHeart = faFaceKissWinkHeart;
const faDagger = {
  prefix: 'far',
  iconName: 'dagger',
  icon: [384, 512, [], "f6cb", "M192 0c13.3 0 24 10.7 24 24l0 104 32 0 24 0 64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48l-16 0-48 0-32 0-32 0-48 0-16 0c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48l64 0 24 0 32 0 0-104c0-13.3 10.7-24 24-24zm32 397.9L224 208l48 0 0 189.9c0 11.5-3.5 22.7-10.1 32.1l-50.2 71.7c-4.5 6.4-11.8 10.2-19.7 10.2s-15.2-3.8-19.7-10.2L122.1 430c-6.6-9.4-10.1-20.6-10.1-32.1L112 208l48 0 0 189.9c0 1.6 .5 3.2 1.4 4.6L192 446.2l30.6-43.7c.9-1.3 1.4-2.9 1.4-4.6z"]
};
const faPodium = {
  prefix: 'far',
  iconName: 'podium',
  icon: [448, 512, [], "f680", "M168 72c-22.1 0-40 17.9-40 40l0 32 296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 192c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-32c0-48.6 39.4-88 88-88l14.4 0C190.7 9.7 206.2 0 224 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24L168 72zM73.5 455.2L47.3 224l48.3 0 25.7 225.8c.9 8.1 7.8 14.2 15.9 14.2l173.7 0c8.1 0 15-6.1 15.9-14.2L352.4 224l48.3 0L374.5 455.2c-3.7 32.3-31 56.8-63.6 56.8l-173.7 0c-32.6 0-59.9-24.4-63.6-56.8z"]
};
const faDiamonds4 = {
  prefix: 'far',
  iconName: 'diamonds-4',
  icon: [512, 512, [], "e68b", "M367.5 104.9c-.8-7-3.8-13.7-9.2-19.1L284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0L153.7 85.8c-5.3 5.3-8.4 12.1-9.2 19.1c-1 9.3 2 19 9.2 26.2l79.7 79.7c5.3 5.3 12.1 8.4 19.1 9.2c2.4 .3 4.7 .3 7.1 0c7-.8 13.7-3.8 19.1-9.2L358.3 131c7.2-7.2 10.2-16.8 9.2-26.2zM219.9 252.5c-.8-7-3.8-13.7-9.2-19.1L131 153.7c-7.2-7.2-16.8-10.2-26.2-9.2c-7 .8-13.7 3.8-19.1 9.2L11.7 227.7c-15.6 15.6-15.6 40.9 0 56.6l74.1 74.1c5.3 5.3 12.1 8.4 19.1 9.2c9.3 1 19-2 26.2-9.2l79.7-79.7c5.3-5.3 8.4-12.1 9.2-19.1c.3-2.4 .3-4.7 0-7.1zm32.5 39.6c-7 .8-13.7 3.8-19.1 9.2L153.7 381c-7.2 7.2-10.2 16.8-9.2 26.2c.8 7 3.8 13.7 9.2 19.1l74.1 74.1c15.6 15.6 40.9 15.6 56.6 0l74.1-74.1c5.3-5.3 8.4-12.1 9.2-19.1c1-9.3-2-19-9.2-26.2l-79.7-79.7c-5.3-5.3-12.1-8.4-19.1-9.2c-2.4-.3-4.7-.3-7.1 0zm39.6-32.5c.8 7 3.8 13.7 9.2 19.1L381 358.3c7.2 7.2 16.8 10.2 26.2 9.2c7-.8 13.7-3.8 19.1-9.2l74.1-74.1c15.6-15.6 15.6-40.9 0-56.6l-74.1-74.1c-5.3-5.3-12.1-8.4-19.1-9.2c-9.3-1-19 2-26.2 9.2l-79.7 79.7c-5.3 5.3-8.4 12.1-9.2 19.1c-.3 2.4-.3 4.7 0 7.1zM256 51.3l57.1 57.1L256 165.5l-57.1-57.1L256 51.3zM51.3 256l57.1-57.1L165.5 256l-57.1 57.1L51.3 256zM256 460.7l-57.1-57.1L256 346.5l57.1 57.1L256 460.7zM460.7 256l-57.1 57.1L346.5 256l57.1-57.1L460.7 256z"]
};
const faMemoCircleCheck = {
  prefix: 'far',
  iconName: 'memo-circle-check',
  icon: [576, 512, [], "e1d9", "M64 48l256 0c8.8 0 16 7.2 16 16l0 156.5c14.6-9.5 30.8-17 48-21.8L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c3.3 0 6.6-.3 9.7-.7c-17.9-12.8-33.3-28.8-45.3-47.3L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm456 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faRouteHighway = {
  prefix: 'far',
  iconName: 'route-highway',
  icon: [448, 512, [], "f61a", "M236.3 3.4c-7.6-4.6-17.1-4.6-24.7 0L202.3 9c-37.5 22.5-83.6 25.1-123.3 7C60.3 7.6 38.2 14.7 28.1 32.5L7.4 68.7c-6.6 11.6-7 25.8-1 37.7l8.5 16.9C26.1 145.9 32 170.8 32 196.1c0 20.7-3.9 41.2-11.6 60.4L8.7 285.7C2.9 300 0 315.3 0 330.7c0 46.7 26.8 89.2 68.8 109.4l144.8 69.5c6.6 3.2 14.2 3.2 20.8 0l144.8-69.5c42.1-20.2 68.8-62.7 68.8-109.4c0-15.4-2.9-30.7-8.7-45.1l-11.7-29.2c-7.7-19.2-11.6-39.7-11.6-60.4c0-25.2 5.9-50.1 17.2-72.7l8.5-16.9c6-12 5.6-26.1-1-37.7L419.9 32.5c-10.2-17.8-32.2-24.9-50.9-16.4c-39.8 18.1-85.9 15.4-123.3-7l-9.4-5.6zM80 192L368 192c0 1.4 0 2.7 0 4.1c0 26.8 5.1 53.3 15.1 78.2l11.7 29.2c3.5 8.7 5.2 17.9 5.2 27.2c0 28.2-16.2 53.9-41.6 66.1L224 461.4 89.6 396.9C64.2 384.7 48 359 48 330.7c0-9.3 1.8-18.6 5.2-27.2l11.7-29.2c10-24.9 15.1-51.4 15.1-78.2c0-1.4 0-2.7 0-4.1z"]
};
const faDownToLine = {
  prefix: 'far',
  iconName: 'down-to-line',
  icon: [384, 512, ["arrow-alt-to-bottom"], "f34a", "M82.2 224L192 334 301.8 224 248 224c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM192 384c-11.5 0-22.5-4.6-30.6-12.7L45.6 255.2C36.9 246.5 32 234.7 32 222.4C32 196.8 52.8 176 78.4 176l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L222.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zM24 432l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faArrowAltToBottom = faDownToLine;
const faFilter = {
  prefix: 'far',
  iconName: 'filter',
  icon: [512, 512, [], "f0b0", "M0 73.7C0 50.7 18.7 32 41.7 32l428.6 0c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5l0 143.2c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4 64 50.8L288 296c0-5.5 1.9-10.9 5.4-15.2L457 80 55 80z"]
};
const faSquareG = {
  prefix: 'far',
  iconName: 'square-g',
  icon: [448, 512, [], "e271", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256c0 44.2 35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6c9.9 8.8 10.7 24 1.9 33.9s-24 10.7-33.9 1.9C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80z"]
};
const faCirclePhone = {
  prefix: 'far',
  iconName: 'circle-phone',
  icon: [512, 512, ["phone-circle"], "e11b", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.7 128.7l-44 12C134 143.1 128 151 128 160c0 123.7 100.3 224 224 224c9 0 16.9-6 19.3-14.7l12-44c2.6-9.7-2.3-19.9-11.6-23.7l-48-20c-8.2-3.4-17.6-1-23.2 5.8L280.3 312c-35.2-16.6-63.7-45.1-80.3-80.3l24.7-20.2c6.8-5.6 9.2-15 5.8-23.2l-20-48c-3.9-9.3-14-14.2-23.7-11.6z"]
};
const faPhoneCircle = faCirclePhone;
const faClipboardPrescription = {
  prefix: 'far',
  iconName: 'clipboard-prescription',
  icon: [384, 512, [], "f5e8", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 204c-11 0-20 9-20 20l0 80 0 64c0 11 9 20 20 20s20-9 20-20l0-44 35.7 0 52 52-25.9 25.9c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0L240 404.3l25.9 25.9c7.8 7.8 20.5 7.8 28.3 0s7.8-20.5 0-28.3L268.3 376l25.9-25.9c7.8-7.8 7.8-20.5 0-28.3s-20.5-7.8-28.3 0L240 347.7l-32.6-32.6C224.6 304.6 236 285.6 236 264c0-33.1-26.9-60-60-60l-72 0zm72 80l-8 0-44 0 0-40 52 0c11 0 20 9 20 20s-9 20-20 20z"]
};
const faUserNurseHair = {
  prefix: 'far',
  iconName: 'user-nurse-hair',
  icon: [448, 512, [], "e45d", "M96 70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0 0-57.8zM304 160l-8 0c-20.5 0-38.7-9.6-50.4-24.5C231.9 159.7 205.8 176 176 176l-32 0c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM49.3 461.9l349.4 0c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7l-386.6 0c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4zM208 48l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8z"]
};
const faQuestion = {
  prefix: 'far',
  iconName: 'question',
  icon: [320, 512, [10067, 10068, 61736], "3f", "M64 160c0-44.2 35.8-80 80-80l32 0c44.2 0 80 35.8 80 80l0 4.6c0 24.1-12 46.6-32.1 59.9l-52.3 34.9C149.4 274.2 136 299.2 136 326l0 2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2c0-10.7 5.3-20.7 14.2-26.6l52.3-34.9c33.4-22.3 53.4-59.7 53.4-99.8l0-4.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 13.3 10.7 24 24 24s24-10.7 24-24zm96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faFileSignature = {
  prefix: 'far',
  iconName: 'file-signature',
  icon: [576, 512, [], "f573", "M64 464l256 0c8.8 0 16-7.2 16-16l0-6.7 39.8-9.9c2.8-.7 5.6-1.6 8.2-2.7l0 19.3c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 49.1-48 48 0-91.6-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-115l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2L96 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l8.2 0c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8 25.6 0 12-48.2c1.4-5.6 4.3-10.8 8.4-14.9L441.1 191.8l71 71L382.9 391.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-1.1 .3-2.1 .4-3.2 .5c-.8 .1-1.5 .2-2.3 .2L256 416c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L160 349zM549.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0z"]
};
const faToggleLargeOn = {
  prefix: 'far',
  iconName: 'toggle-large-on',
  icon: [576, 512, [], "e5b1", "M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192s-86-192-192-192L192 64zm192 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"]
};
const faUpDownLeftRight = {
  prefix: 'far',
  iconName: 'up-down-left-right',
  icon: [512, 512, ["arrows-alt"], "f0b2", "M256 55.8L289.5 96l-67 0L256 55.8zM229.8 12.3L168.2 86.2c-5.3 6.3-8.2 14.3-8.2 22.6c0 19.5 15.8 35.2 35.2 35.2l36.8 0 0 88-88 0 0-36.8c0-19.5-15.8-35.2-35.2-35.2c-8.2 0-16.2 2.9-22.6 8.2L12.3 229.8C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2c19.5 0 35.2-15.8 35.2-35.2l0-36.8 88 0 0 88-36.8 0c-19.5 0-35.2 15.8-35.2 35.2c0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6c0-19.5-15.8-35.2-35.2-35.2L280 368l0-88 88 0 0 36.8c0 19.5 15.8 35.2 35.2 35.2c8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2c-19.5 0-35.2 15.8-35.2 35.2l0 36.8-88 0 0-88 36.8 0c19.5 0 35.2-15.8 35.2-35.2c0-8.2-2.9-16.2-8.2-22.6L282.2 12.3C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2L222.5 416l67 0L256 456.2zM456.2 256L416 289.5l0-67L456.2 256zM96 289.5L55.8 256 96 222.5l0 67z"]
};
const faArrowsAlt = faUpDownLeftRight;
const faDryerHeat = {
  prefix: 'far',
  iconName: 'dryer-heat',
  icon: [448, 512, ["dryer-alt"], "f862", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM80 288a144 144 0 1 1 288 0A144 144 0 1 1 80 288zm107.3-83.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L177.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7zm80 0c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L257.4 240c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L270.6 336c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-12.7-12.7z"]
};
const faDryerAlt = faDryerHeat;
const faHouseChimneyUser = {
  prefix: 'far',
  iconName: 'house-chimney-user',
  icon: [576, 512, [], "e065", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6 512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 85.9L303.5 5.7zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM288 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM176 400c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80z"]
};
const faHandHoldingHeart = {
  prefix: 'far',
  iconName: 'hand-holding-heart',
  icon: [576, 512, [], "f4be", "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faArrowUpSmallBig = {
  prefix: 'far',
  iconName: 'arrow-up-small-big',
  icon: [576, 512, ["sort-size-up-alt"], "f88f", "M368 144l0-64 64 0 0 64-64 0zm-48 0c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 64zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39zM368 304l128 0 0 128-128 0 0-128zm-48 0l0 128c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-128 0c-26.5 0-48 21.5-48 48z"]
};
const faSortSizeUpAlt = faArrowUpSmallBig;
const faTrainTrack = {
  prefix: 'far',
  iconName: 'train-track',
  icon: [576, 512, [], "e453", "M222.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5L160.1 96 112 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l30.8 0L114 224l-42 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.7 0L67.9 352 32 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l18.7 0L33.4 447.9c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5L101.7 400l372.7 0 23.1 64.1c4.5 12.5 18.2 18.9 30.7 14.5s18.9-18.2 14.5-30.7L525.3 400l18.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-35.9 0-28.8-80 24.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-42 0-28.8-80 30.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.1 0L398.6 47.9c-4.5-12.5-18.2-18.9-30.7-14.5s-18.9 18.2-14.5 30.7L364.9 96 211.1 96l11.5-31.9zM193.8 144l188.3 0L411 224 165 224l28.8-80zM457.1 352l-338.1 0 28.8-80 280.5 0 28.8 80z"]
};
const faPuzzlePiece = {
  prefix: 'far',
  iconName: 'puzzle-piece',
  icon: [512, 512, [129513], "f12e", "M201.1 57.3C194.1 62.5 192 68 192 72c0 4.2 2.4 10.1 10.4 15.6c7.8 5.3 13.6 14.6 13.6 25.6c0 17-13.8 30.7-30.7 30.7L56 144c-4.4 0-8 3.6-8 8l0 52.5c7.4-2.9 15.5-4.5 24-4.5c43.1 0 72 39.4 72 80s-28.9 80-72 80c-8.5 0-16.6-1.6-24-4.5L48 456c0 4.4 3.6 8 8 8l100.5 0c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24l52.5 0c4.4 0 8-3.6 8-8l0-129.3c0-17 13.8-30.7 30.7-30.7c11.1 0 20.3 5.8 25.6 13.6c5.5 8 11.4 10.4 15.6 10.4c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-4.2 0-10.1 2.4-15.6 10.4c-5.3 7.8-14.6 13.6-25.6 13.6c-17 0-30.7-13.8-30.7-30.7l0-81.3c0-4.4-3.6-8-8-8l-81.3 0c-17 0-30.7-13.8-30.7-30.7c0-11.1 5.8-20.3 13.6-25.6c8-5.5 10.4-11.4 10.4-15.6c0-4-2.1-9.5-9.1-14.7S245 48 232 48s-23.8 4-30.9 9.3zM172.3 18.9C188.5 6.8 209.6 0 232 0s43.5 6.8 59.7 18.9S320 49.5 320 72c0 8.6-1.8 16.7-4.9 24L360 96c30.9 0 56 25.1 56 56l0 44.9c7.3-3.1 15.4-4.9 24-4.9c22.5 0 41 12.2 53.1 28.3S512 257.6 512 280s-6.8 43.5-18.9 59.7S462.5 368 440 368c-8.6 0-16.7-1.8-24-4.9l0 92.9c0 30.9-25.1 56-56 56l-78.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9L56 512c-30.9 0-56-25.1-56-56L0 329.9C0 311.2 15.2 296 33.9 296c10.1 0 18.5 4.5 24.2 9.9c4.3 4.2 9.2 6.1 13.9 6.1c9.9 0 24-10.7 24-32s-14.1-32-24-32c-4.7 0-9.5 1.9-13.9 6.1C52.4 259.5 44 264 33.9 264C15.2 264 0 248.8 0 230.1L0 152c0-30.9 25.1-56 56-56l92.9 0c-3.1-7.3-4.9-15.4-4.9-24c0-22.5 12.2-41 28.3-53.1z"]
};
const faMoneyCheck = {
  prefix: 'far',
  iconName: 'money-check',
  icon: [576, 512, [], "f53c", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm120 80l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM96 328c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24zM376 160l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"]
};
const faStarHalfStroke = {
  prefix: 'far',
  iconName: 'star-half-stroke',
  icon: [576, 512, ["star-half-alt"], "f5c0", "M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"]
};
const faStarHalfAlt = faStarHalfStroke;
const faFileExclamation = {
  prefix: 'far',
  iconName: 'file-exclamation',
  icon: [384, 512, [], "f31a", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM192 176c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCode = {
  prefix: 'far',
  iconName: 'code',
  icon: [640, 512, [], "f121", "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"]
};
const faWhiskeyGlass = {
  prefix: 'far',
  iconName: 'whiskey-glass',
  icon: [512, 512, [129347, "glass-whiskey"], "f7a0", "M80.8 288l350.3 0L461.5 80l-411 0L80.8 288zm7 48l10 68.6c2.3 15.7 15.8 27.4 31.7 27.4l253 0c15.9 0 29.4-11.7 31.7-27.4l10-68.6L87.8 336zM7.8 43.1C13.9 36 22.7 32 32 32l448 0c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5l-253 0c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"]
};
const faGlassWhiskey = faWhiskeyGlass;
const faMoonStars = {
  prefix: 'far',
  iconName: 'moon-stars',
  icon: [512, 512, [], "f755", "M295.8 137.8c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11 11 38.6zM403.8 310.8c1.6 5.5 6.6 9.2 12.2 9.2s10.7-3.8 12.2-9.2l16.6-58 58-16.6c5.5-1.6 9.2-6.6 9.2-12.2s-3.8-10.7-9.2-12.2l-58-16.6-16.6-58c-1.6-5.5-6.6-9.2-12.2-9.2s-10.7 3.8-12.2 9.2l-16.6 58-58 16.6c-5.5 1.6-9.2 6.6-9.2 12.2s3.8 10.7 9.2 12.2l58 16.6 16.6 58zM48 320c0-70 50-128.3 116.2-141.3C141.6 206.3 128 241.5 128 280c0 83.2 63.5 151.6 144.7 159.3c-23 15.6-50.8 24.7-80.7 24.7c-79.5 0-144-64.5-144-144zM192 128C86 128 0 214 0 320S86 512 192 512c69.4 0 130.2-36.9 163.9-92c5.3-8.7 4.6-19.9-2-27.8s-17.3-10.8-26.9-7.2c-12.1 4.5-25.3 7-39.1 7c-61.9 0-112-50.1-112-112c0-45 26.6-83.9 65-101.7c9.3-4.3 14.8-14 13.8-24.2s-8.4-18.6-18.3-20.9c-14.3-3.4-29.2-5.2-44.4-5.2z"]
};
const faBuildingCircleExclamation = {
  prefix: 'far',
  iconName: 'building-circle-exclamation',
  icon: [640, 512, [], "e4d3", "M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faClothesHanger = {
  prefix: 'far',
  iconName: 'clothes-hanger',
  icon: [640, 512, [], "e136", "M211.4 91.3C221 38.4 267 0 320.8 0C382.2 0 432 49.8 432 111.2l0 2.9c0 36.5-17.5 70.8-47 92.3l-23.2 16.9L611 391.7c18.1 12.2 29 32.7 29 54.5c0 36.3-29.5 65.8-65.8 65.8L65.8 512C29.5 512 0 482.5 0 446.2c0-21.9 10.9-42.3 29-54.5L306.2 204.3l50.6-36.8c17.1-12.4 27.2-32.3 27.2-53.5l0-2.9C384 76.3 355.7 48 320.8 48c-30.6 0-56.7 21.8-62.2 51.9l-3 16.4c-2.4 13-14.9 21.7-27.9 19.3s-21.7-14.9-19.3-27.9l3-16.4zM320 253L55.8 431.5c-4.9 3.3-7.8 8.8-7.8 14.7C48 456 56 464 65.8 464l508.4 0c9.8 0 17.8-8 17.8-17.8c0-5.9-2.9-11.4-7.8-14.7L320 253z"]
};
const faMobileNotch = {
  prefix: 'far',
  iconName: 'mobile-notch',
  icon: [384, 512, ["mobile-iphone"], "e1ee", "M256 48l0 16c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-16L96 48C78.3 48 64 62.3 64 80l0 352c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-352c0-17.7-14.3-32-32-32l-32 0zM16 80C16 35.8 51.8 0 96 0L288 0c44.2 0 80 35.8 80 80l0 352c0 44.2-35.8 80-80 80L96 512c-44.2 0-80-35.8-80-80L16 80z"]
};
const faMobileIphone = faMobileNotch;
const faMagnifyingGlassChart = {
  prefix: 'far',
  iconName: 'magnifying-glass-chart',
  icon: [512, 512, [], "e522", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM104 216l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faArrowUpRightFromSquare = {
  prefix: 'far',
  iconName: 'arrow-up-right-from-square',
  icon: [512, 512, ["external-link"], "f08e", "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faExternalLink = faArrowUpRightFromSquare;
const faCubesStacked = {
  prefix: 'far',
  iconName: 'cubes-stacked',
  icon: [448, 512, [], "e4e6", "M240 80l0 32 32 0 0-32-32 0zM224 32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM136.5 268.2l27.7-16-16-27.7-27.7 16 16 27.7zM71 250.7c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7L71 250.7zM304 272l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM368 432l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM208 400l0 32 32 0 0-32-32 0zm-16-48l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM48 432l32 0 0-32-32 0 0 32zM0 384c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64z"]
};
const faImagesUser = {
  prefix: 'far',
  iconName: 'images-user',
  icon: [576, 512, [], "e1b9", "M512 80L160 80c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l64 0c0-35.3 28.7-64 64-64l96 0c35.3 0 64 28.7 64 64l64 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zM160 32l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0C60.9 480 0 419.1 0 344L0 120c0-13.3 10.7-24 24-24zm248 80a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faWonSign = {
  prefix: 'far',
  iconName: 'won-sign',
  icon: [512, 512, [8361, "krw", "won"], "f159", "M71.1 49.5C67.5 36.8 54.3 29.3 41.5 32.9S21.3 49.7 24.9 62.5L79.1 256 24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l68.5 0 44.4 158.5c2.9 10.5 12.6 17.7 23.6 17.5s20.3-7.8 22.9-18.4L221.2 304l69.7 0 37.8 157.6c2.6 10.6 12 18.2 22.9 18.4s20.6-7 23.6-17.5L419.5 304l68.5 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.1 0L487.1 62.5c3.6-12.8-3.9-26-16.6-29.6s-26 3.9-29.6 16.6L383.1 256l-54.4 0L279.3 50.4C276.7 39.6 267.1 32 256 32s-20.7 7.6-23.3 18.4L183.3 256l-54.4 0L71.1 49.5zM142.4 304l29.4 0-13.6 56.6L142.4 304zm90.3-48L256 158.8 279.3 256l-46.6 0zm107.5 48l29.4 0-15.9 56.6L340.2 304z"]
};
const faKrw = faWonSign;
const faWon = faWonSign;
const faImagePolaroidUser = {
  prefix: 'far',
  iconName: 'image-polaroid-user',
  icon: [448, 512, [], "e1b6", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48L48 368l0 48zm286-96l66 0 0-224c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 224 66 0c7.1-27.6 32.2-48 62-48l96 0c29.8 0 54.9 20.4 62 48zM448 96l0 224 0 24 0 24 0 48c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-48 0-24 0-24L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64zM160 176a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faVirusCovid = {
  prefix: 'far',
  iconName: 'virus-covid',
  icon: [512, 512, [], "e4a8", "M216 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L125.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L46.7 103.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L92 125.9l23.8 23.8C97.9 173.2 85.8 201.3 81.6 232L48 232l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3L92 386.1 80.6 374.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L125.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c30.7-4.2 58.8-16.3 82.3-34.1L386.1 420l-11.3 11.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L420 386.1l-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3L420 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L408.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L386.1 92l-23.8 23.8C338.8 97.9 310.7 85.8 280 81.6L280 48l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 0zm40 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faSquareEllipsis = {
  prefix: 'far',
  iconName: 'square-ellipsis',
  icon: [448, 512, [], "e26e", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm160-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faPie = {
  prefix: 'far',
  iconName: 'pie',
  icon: [576, 512, [129383], "f705", "M525.8 225.1c3.1 7.8 8.8 14.4 16.3 18.2l16.2 8.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-29.6-14.8c-14.7-7.4-31.7-8.8-47.4-3.9l-41.6 12.8c-23.3 7.2-48.3 6.5-71.2-1.8l-30-10.9c-14.1-5.1-29.6-5.1-43.7 0l-30 10.9c-22.9 8.3-47.9 9-71.2 1.8l-41.6-12.8c-15.7-4.8-32.7-3.4-47.4 3.9L46.3 308.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l16.2-8.1c7.5-3.8 13.2-10.4 16.3-18.2C87.9 130.7 180.1 64 288 64s200.1 66.7 237.8 161.1zM199.2 129.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5c2.2 1.1 4.5 1.6 6.8 1.7l.7 0c5.7-.1 11.2-3.3 14-8.8l16-32c4-7.9 .7-17.5-7.2-21.5zm177.7 0c-7.9 4-11.1 13.6-7.2 21.5l16 32c2.7 5.5 8.2 8.7 14 8.8l.7 0c2.3 0 4.6-.6 6.8-1.7c7.9-4 11.1-13.6 7.2-21.5l-16-32c-4-7.9-13.6-11.1-21.5-7.2zM288 128c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zM90.2 322.4c4.2-2.1 8.8-3.2 13.4-3.4l23.3 70c2.2 6.5 8.3 10.9 15.2 10.9l291.7 0c6.9 0 13-4.4 15.2-10.9l23.3-70c4.6 .1 9.2 1.3 13.4 3.4l29.6 14.8c.4 .2 .9 .4 1.3 .6l-22.1 66.4c-8.7 26.1-33.2 43.8-60.7 43.8l-291.7 0c-27.5 0-52-17.6-60.7-43.8L59.3 337.9c.4-.2 .9-.4 1.3-.6l29.6-14.8z"]
};
const faChessKnightPiece = {
  prefix: 'far',
  iconName: 'chess-knight-piece',
  icon: [320, 512, ["chess-knight-alt"], "f442", "M68.9 112l79.8 0C216.8 112 272 167.2 272 235.3c0 11.3-1.6 22.5-4.6 33.4L243.9 352l49.9 0 19.8-70.3c4.3-15.1 6.4-30.7 6.4-46.4C320 140.7 243.3 64 148.7 64L40.8 64C18.5 64 .4 82.1 .4 104.5c0 11.6 5 22.5 13.3 30C5 148.3 .3 164.4 .3 181L.1 232C0 253.2 8 273.7 22.4 289.2l1.9 2c6.5 7 14 12.6 22 16.8c-8.3 13-13.1 28.2-13.8 43.9l48.1 0c1.1-11.5 7-22 16.2-29l25.1-15.4c2.7-1.4 5.3-3 7.8-4.8l42.9-26.3c11.3-6.9 14.8-21.7 7.9-33s-21.7-14.8-33-7.9l-42.7 26.2-.1-.2c-.5 .4-1 .8-1.5 1.2l-4.9 3c-12.8 6.4-28.7 3.8-38.8-7.1l-1.9-2c-6.2-6.6-9.6-15.4-9.5-24.4l.2-51c0-10.6 4.2-20.7 11.7-28.1l8-8c5.5-5.5 8-13.2 6.7-20.8c-.7-4.6-2.8-8.8-5.8-12.2zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM52.7 464l16.6-32 181.6 0 16.6 32L52.7 464zm207.9-80l-201 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l238.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
const faChessKnightAlt = faChessKnightPiece;
const faAustralSign = {
  prefix: 'far',
  iconName: 'austral-sign',
  icon: [448, 512, [], "e0a9", "M246.1 46.7C242.4 37.8 233.7 32 224 32s-18.4 5.8-22.1 14.7L127.4 224 24 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l83.2 0L87.1 320 24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l42.9 0L33.9 446.7c-5.1 12.2 .6 26.3 12.8 31.4s26.3-.6 31.4-12.8L119 368l210 0 40.9 97.3c5.1 12.2 19.2 18 31.4 12.8s18-19.2 12.8-31.4L381.1 368l42.9 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-63.1 0-20.2-48 83.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-103.4 0L246.1 46.7zM268.5 224l-89.1 0L224 118l44.5 106zM159.3 272l129.4 0 20.2 48-169.7 0 20.2-48z"]
};
const faCloudPlus = {
  prefix: 'far',
  iconName: 'cloud-plus',
  icon: [640, 512, [], "e35e", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM296 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faF = {
  prefix: 'far',
  iconName: 'f',
  icon: [320, 512, [102], "46", "M56 32C25.1 32 0 57.1 0 88L0 248 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 224 48 88c0-4.4 3.6-8 8-8l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32z"]
};
const faLeaf = {
  prefix: 'far',
  iconName: 'leaf',
  icon: [512, 512, [], "f06c", "M149.6 234.4c20.9-6.7 43.2-10.4 66.4-10.4l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-25.4 0-49.5 5.6-71 15.7C152.7 351 206.6 400 271.9 400c0 0 0 0 .1 0l.8 0c0 0 0 0 .1 0C370.2 399.5 464 299.7 464 156.6c0-12.8-.8-25.3-2.3-37.5C437 134.9 407.6 144 376 144l-104 0c-57.6 0-106.3 38.1-122.4 90.4zM96.4 260.1C102.5 168.5 178.8 96 272 96l104 0c28.7 0 54.8-10.8 74.6-28.5c.7-.6 1.4-1.3 2.1-1.9c6.6-6.2 12.5-13.2 17.4-20.9c1.6-2.5 3.2-5.1 4.6-7.8c3.5-6.5 13.6-6.8 16.2 .1c1.3 3.5 2.5 7 3.7 10.6c2.9 8.9 5.5 17.9 7.8 27.2c.5 1.9 .9 3.8 1.3 5.6c5.4 24.3 8.3 49.8 8.3 76.2C512 317.1 405.1 447.3 273 448l-1 0c-81.7 0-150.4-55.7-170.2-131.2C68.7 347.5 48 391.3 48 440l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-75.1 38.3-141.2 96.4-179.9z"]
};
const faBedBunk = {
  prefix: 'far',
  iconName: 'bed-bunk',
  icon: [576, 512, [], "f8f8", "M24 0C37.3 0 48 10.7 48 24l0 136 208 0 0-120c0-22.1 17.9-40 40-40L456 0c66.3 0 120 53.7 120 120l0 64 0 96 0 159.7 0 48.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24.3-248 0-232 0L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48.3L0 184 0 24C0 10.7 10.7 0 24 0zM256 415.7L256 296c0-22.1 17.9-40 40-40l232 0 0-48-248 0L48 208l0 207.7 208 0zM528 160l0-40c0-39.8-32.2-72-72-72L304 48l0 112 224 0zm0 144l-224 0 0 111.7 224 0L528 304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faRoad = {
  prefix: 'far',
  iconName: 'road',
  icon: [576, 512, [128739], "f018", "M185.7 32c-30.4 0-57.5 19-67.7 47.6L8.6 383.6C-8.3 430.5 26.4 480 76.3 480l423.4 0c49.9 0 84.6-49.5 67.7-96.4L458 79.6C447.7 51 420.6 32 390.3 32L185.7 32zM163.2 95.9c3.4-9.5 12.5-15.9 22.6-15.9L264 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l109.4 304c5.6 15.6-6 32.1-22.6 32.1L312 432l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L76.3 432c-16.6 0-28.2-16.5-22.6-32.1l109.4-304zM312 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80z"]
};
const faTaxi = {
  prefix: 'far',
  iconName: 'taxi',
  icon: [512, 512, [128662, "cab"], "f1ba", "M192 0c-17.7 0-32 14.3-32 32l0 32 0 .2c-35.2 2.2-65.9 25.2-77.7 58.8L48.1 220.8C19.3 237.4 0 268.4 0 304l0 80 0 48 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 416 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 0-48 0-80c0-35.6-19.4-66.6-48.1-83.2l-34.3-97.9C417.9 89.3 387.2 66.3 352 64.2l0-.2 0-32c0-17.7-14.3-32-32-32L192 0zM165.4 112l181.2 0c17 0 32.1 10.7 37.8 26.8L408.6 208l-305.1 0 24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM96 256l320 0c26.5 0 48 21.5 48 48l0 80L48 384l0-80c0-26.5 21.5-48 48-48zm48 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm256 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCab = faTaxi;
const faPersonCirclePlus = {
  prefix: 'far',
  iconName: 'person-circle-plus',
  icon: [576, 512, [], "e541", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faChartPie = {
  prefix: 'far',
  iconName: 'chart-pie',
  icon: [576, 512, ["pie-chart"], "f200", "M493.1 192L352 192l0-141.1C423.5 64 480 120.5 493.1 192zM352 240l175.4 0c9 0 16.6-7 16.6-16C544 100.3 443.7 0 320 0c-9 0-16 7.6-16 16.6L304 192l0 48 48 0zM222.1 321.9L348.4 448.2C325 458.4 299.2 464 272 464C166 464 80 378 80 272c0-83.6 53.4-154.7 128-181.1L208 288c0 12.7 5.1 24.9 14.1 33.9zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240c51.8 0 99.8-16.4 139-44.3c7.7-5.5 8.2-16.5 1.5-23.1L256 288l0-238.4c0-9.2-7.8-16.6-17-15.4zM558.4 288L320 288 478.7 446.7c5.8 5.8 15.2 6.3 21.2 .7c39.3-36.7 66.2-86.5 73.9-142.3c1.3-9.2-6.1-17-15.4-17z"]
};
const faPieChart = faChartPie;
const faBoltLightning = {
  prefix: 'far',
  iconName: 'bolt-lightning',
  icon: [384, 512, [], "e0b7", "M77 48L51.4 240 208 240c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192 176 192c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48 77 48zM30.4 34.7C33 14.8 50 0 70 0L208.6 0c28.1 0 47.5 28.3 37.3 54.5L211.1 144l126.8 0c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288l-135 0C18.1 288-.6 266.7 2.6 242.7l27.7-208z"]
};
const faClockEight = {
  prefix: 'far',
  iconName: 'clock-eight',
  icon: [512, 512, [], "e345", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2 232 120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSackXmark = {
  prefix: 'far',
  iconName: 'sack-xmark',
  icon: [512, 512, [], "e56a", "M293.3 152l-74.6 0-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48 187.4 48l31.1 45.2L226 104l60 0 7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96zM209 239l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faFileXls = {
  prefix: 'far',
  iconName: 'file-xls',
  icon: [512, 512, [], "e64d", "M64 464l80 0 0 48-80 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm160-96c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L259.2 432l17.2 25.8C284 469.1 288 482.4 288 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L240 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L220.8 432l-17.2-25.8C196 394.9 192 381.6 192 368c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 128l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16zm88-98.3c0-25.2 20.4-45.7 45.7-45.7l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L432 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l26.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7z"]
};
const faFileExcel = {
  prefix: 'far',
  iconName: 'file-excel',
  icon: [384, 512, [], "f1c3", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"]
};
const faFileContract = {
  prefix: 'far',
  iconName: 'file-contract',
  icon: [384, 512, [], "f56c", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM96 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 96zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0zm54.2 221.8L160 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l10.6-21.3c.6-1.2 1.8-1.9 3.1-1.9s2.5 .7 3.1 1.9l10.6 21.3c2.7 5.4 8.3 8.8 14.3 8.8l40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-30.1 0-6.2-12.4c-6-12-18.3-19.6-31.7-19.6c-8.6 0-16.8 3.1-23.1 8.6l-11.3-37.5C182.2 311.7 171.8 304 160 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4L96 384c-8.8 0-16 7.2-16 16s7.2 16 16 16l8.2 0c21.2 0 39.9-13.9 46-34.2z"]
};
const faFishFins = {
  prefix: 'far',
  iconName: 'fish-fins',
  icon: [576, 512, [], "e4f2", "M247.3 166c-13.1 6.7-25.4 14.5-36.5 22.8c-10.2 7.6-19.5 15.8-27.9 24c-14.2 13.9-35.5 17.6-53.6 9.3L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l58.7-26.9c18.1-8.3 39.4-4.6 53.6 9.3c8.4 8.3 17.8 16.4 27.9 24c11.2 8.4 23.5 16.3 36.8 23c16.7 8.4 27 25.8 26.3 44.4l-.8 23.6 46.2-36.3c7.7-6.1 17.2-9.6 27-10.2c44.7-2.5 83.7-21 114.9-44.5c29.4-22.1 51.3-48 64-67.2c-12.7-19.2-34.6-45.1-64-67.2c-31.3-23.5-70.2-42-114.9-44.5c-9.8-.5-19.2-4.1-27-10.2L272.9 97.6l.6 24.3c.5 18.5-9.7 35.7-26.3 44.1zM8.4 373.6C-1 363.3-2.7 348.2 4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l103.9 47.6c9.8-9.6 20.8-19.2 32.7-28.1c13.1-9.8 27.7-19.2 43.6-27.2L224 64.9c-.3-12.4 6.5-23.9 17.6-29.4s24.4-4.2 34.1 3.4L349 96.4c56.6 3.2 104.5 26.6 141.1 54c39.2 29.4 67.2 64.7 81.6 89.5c5.8 9.9 5.8 22.2 0 32.1c-14.4 24.8-42.5 60.1-81.6 89.5c-36.6 27.5-84.5 50.9-141.1 54l-73.2 57.5c-9.8 7.7-23.1 9-34.2 3.4s-17.9-17.2-17.5-29.6l1.9-57.9c-16.1-8.1-30.8-17.5-44-27.4c-12-9-22.9-18.5-32.7-28.1L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleQ = {
  prefix: 'far',
  iconName: 'circle-q',
  icon: [512, 512, [], "e11e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.4-3.3 25.9-9.1 37l-30-30c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l30 30c-11.1 5.8-23.7 9.1-37 9.1c-44.2 0-80-35.8-80-80zm208 0c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128c26.7 0 51.4-8.2 71.9-22.1L343 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-15.1-15.1c14-20.5 22.1-45.3 22.1-71.9z"]
};
const faBuildingFlag = {
  prefix: 'far',
  iconName: 'building-flag',
  icon: [640, 512, [], "e4d5", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM448 0c17.7 0 32 14.3 32 32l144 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-144 0 0 320-64 0 0-480c0-17.7 14.3-32 32-32z"]
};
const faFaceGrinBeam = {
  prefix: 'far',
  iconName: 'face-grin-beam',
  icon: [512, 512, [128516, "grin-beam"], "f582", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0zm160 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faGrinBeam = faFaceGrinBeam;
const faObjectUngroup = {
  prefix: 'far',
  iconName: 'object-ungroup',
  icon: [640, 512, [], "f248", "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5l0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3l0 105.3C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L123.3 40C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-105.3c16-6.5 28.9-19.3 35.3-35.3l201.3 0zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40l45.4 0c6.5 16 19.3 28.9 35.3 35.3l0 105.3c-16 6.5-28.9 19.3-35.3 35.3l-201.3 0c-6.5-16-19.3-28.9-35.3-35.3l0-36.7-48 0 0 36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l201.3 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3l0-105.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L448 200l0 16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm307-18.5a16 16 0 1 1 -5.5 31.5 16 16 0 1 1 5.5-31.5z"]
};
const faFaceDisguise = {
  prefix: 'far',
  iconName: 'face-disguise',
  icon: [512, 512, [], "e370", "M464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-16.5 1.9-32.6 5.6-48L72 208c0 50.1 38.4 91.2 87.3 95.6c-9.6 7.9-15.3 19.7-15.3 32.4c0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4 .7 4.8 1.3 7.2 1.8l0 25.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-25.2c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6L339.5 418c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4c49-4.4 87.3-45.5 87.3-95.6l18.4 0c3.6 15.4 5.6 31.5 5.6 48zM218 229.5l-21.4 35.7c-1.1 .6-1.9 1-2.6 1.3c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 2.5-.1 4.9-.4 7.3c-5.4 3.6-10.1 8.4-13.5 14.1zM280 208c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-.6-.3-1.5-.7-2.6-1.3L294 229.5c-3.5-5.8-8.1-10.6-13.5-14.1c-.3-2.4-.4-4.9-.4-7.3zm219.4-31.6C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1c3.3-2.9 5.3-7.2 5.3-11.9c0-7.7-5.4-14.1-12.6-15.6zM63.9 176c6.4-15.3 14.5-29.7 24.2-42.9c-.6 4.5 .2 9.3 2.4 13.6l1.4 2.7c-6.1 8-11 16.9-14.4 26.5l-13.5 0zm384.1 0l-13.5 0c-3.4-9.6-8.3-18.6-14.4-26.5l1.4-2.7c2.2-4.4 2.9-9.1 2.4-13.6c9.7 13.2 17.8 27.6 24.2 42.9zM104.9 113.1C142.8 73 196.5 48 256 48s113.2 25 151.1 65.1c-9-2.8-18.7 0-24.9 6.8c-2-.9-4.1-1.7-6.2-2.4l0-5.5c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.3c-1.5 .2-2.9 .5-4.4 .8c-6.7-9.6-19.6-13-30.3-7.6s-15.7 17.8-12.1 28.9c-10.7 9.3-19.4 21-25.2 34.2c-5.8-13.2-14.4-24.9-25.2-34.2c3.6-11.1-1.3-23.5-12.1-28.9s-23.6-1.9-30.4 7.6c-1.4-.3-2.9-.6-4.4-.8l0-1.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 5.5c-2.1 .7-4.2 1.6-6.2 2.4c-6.2-6.9-16-9.6-24.9-6.8zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4L245.5 246c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faCircleArrowDownRight = {
  prefix: 'far',
  iconName: 'circle-arrow-down-right',
  icon: [512, 512, [], "e0fa", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM192 368l152 0c13.3 0 24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1L185 151c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l135 135L192 320c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faAlien8bit = {
  prefix: 'far',
  iconName: 'alien-8bit',
  icon: [576, 512, [128126, "alien-monster"], "f8f6", "M120 32c13.3 0 24 10.7 24 24l24 0c13.3 0 24 10.7 24 24l0 48 192 0 0-48c0-13.3 10.7-24 24-24l24 0c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c0 13.3-10.7 24-24 24l-24 0 0 48 0 8 24 0c13.3 0 24 10.7 24 24l0 56 8 0 40 0 0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-40 0 0 72c0 13.3-10.7 24-24 24l-40 0 0 72c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 0-48-224 0 0 48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-72-40 0c-13.3 0-24-10.7-24-24l0-72-40 0c-13.3 0-24-10.7-24-24L0 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 40 0 8 0 0-56c0-13.3 10.7-24 24-24l24 0 0-8 0-48-24 0c-13.3 0-24-10.7-24-24l0-24c0-13.3 10.7-24 24-24zm72 144l0 8c0 13.3-10.7 24-24 24l-24 0 0 56c0 13.3-10.7 24-24 24l-8 0 0 48 40 0 272 0 40 0 0-48-8 0c-13.3 0-24-10.7-24-24l0-56-24 0c-13.3 0-24-10.7-24-24l0-8-192 0zm0 64c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48zm144-16l32 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
};
const faAlienMonster = faAlien8bit;
const faHandPointRibbon = {
  prefix: 'far',
  iconName: 'hand-point-ribbon',
  icon: [448, 512, [], "e1a6", "M112 48c8.8 0 16 7.2 16 16l0 16L96 80l0-16c0-8.8 7.2-16 16-16zm64 32l0-16c0-35.3-28.7-64-64-64S48 28.7 48 64l0 16L11.8 80C5.3 80 0 85.3 0 91.8c0 3.9 1.9 7.5 5.1 9.7L43.6 128 5.1 154.5c-3.2 2.2-5.1 5.8-5.1 9.7C0 170.7 5.3 176 11.8 176L48 176l0 96c-10 13.4-16 30-16 48c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-24 0-64c0-35.3-28.7-64-64-64c-11 0-21.3 2.8-30.3 7.6C309.9 185.2 292 176 272 176c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36l0-48c0-8.8-7.2-16-16-16zm-48 96l0 32 0 32-16 0c-5.5 0-10.8 .6-16 1.6L96 176l32 0zm24 112l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c11 0 21.3-2.8 30.3-7.6C314.1 374.8 332 384 352 384c3.2 0 6.3-.2 9.4-.7C345.1 430.3 300.5 464 248 464l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l40 0zm200-48c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16 0-48c0-8.8 7.2-16 16-16zm-144 2c-5.1-1.3-10.5-2-16-2l-16 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 2zm48-2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-24z"]
};
const faPoop = {
  prefix: 'far',
  iconName: 'poop',
  icon: [512, 512, [], "f619", "M201.8 14.8C205.5 5.8 214.3 0 224 0l8 0c71.6 0 131.6 49.5 147.7 116.1C410.8 133 432 166 432 204c0 1.1 0 2.2-.1 3.3c33 14 56.1 46.6 56.1 84.7c0 14.3-3.3 27.8-9.1 39.9c20.3 19 33.1 46 33.1 76.1c0 57.4-46.6 104-104 104l-304 0C46.6 512 0 465.4 0 408c0-30.1 12.8-57.1 33.1-76.1C27.3 319.8 24 306.3 24 292c0-38.1 23.1-70.7 56.1-84.7c0-1.1-.1-2.2-.1-3.3c0-48.1 33.9-88.2 79.1-97.8c5.7-1.4 11.7-2.2 17.8-2.2l3.1 0 14.7 0c16.2 0 29.3-13.1 29.3-29.3l0-3.2c0-8.6-3.4-16.9-9.5-23L207 41c-6.9-6.9-8.9-17.2-5.2-26.2zm68.5 40.5c1.1 5.3 1.6 10.7 1.6 16.1l0 3.2c0 42.7-34.6 77.3-77.3 77.3L180 152l-3.1 0c-2.2 0-4.3 .3-6.3 .8c-.4 .1-.8 .2-1.2 .3C145.8 158 128 178.9 128 204c0 4.9 .7 9.7 1.9 14.1c1.9 6.7 .8 13.9-3 19.7s-10 9.7-16.9 10.6c-21.5 2.9-38 21.3-38 43.6c0 11.4 4.3 21.8 11.4 29.6c5 5.4 7.1 12.9 5.9 20.1s-5.7 13.6-12.2 17.1C59.7 368.3 48 386.8 48 408c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56c0-21.2-11.8-39.7-29.2-49.2c-6.5-3.5-10.9-9.8-12.2-17.1s1-14.7 5.9-20.1c7.1-7.8 11.4-18.2 11.4-29.6c0-22.3-16.6-40.7-38-43.6c-6.9-.9-13-4.8-16.9-10.6s-4.9-13-3-19.7c1.3-4.5 1.9-9.2 1.9-14.1c0-22.3-14-41.4-33.8-48.7c-8.2-3-14-10.3-15.3-18.9c-5.6-37-30.7-67.6-64.5-81z"]
};
const faObjectExclude = {
  prefix: 'far',
  iconName: 'object-exclude',
  icon: [512, 512, [], "e49c", "M64 48l224 0c8.8 0 16 7.2 16 16l0 64 48 0 0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-48-64 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm96 336l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64-48 0zm128-32c35.3 0 64-28.7 64-64l-48 0c0 8.8-7.2 16-16 16l-32 0 0 48 32 0zm64-144l0-48-48 0-16 0 0 48 16 0 0 48 48 0 0-48zM224 352l0-48-16 0 0-48-48 0 0 48 0 48 48 0 16 0zM160 224l48 0c0-8.8 7.2-16 16-16l32 0 0-48-32 0c-35.3 0-64 28.7-64 64z"]
};
const faTelescope = {
  prefix: 'far',
  iconName: 'telescope',
  icon: [576, 512, [128301], "e03e", "M459.7 231.7l61.5-35.5-80-138.6L379.7 93.1l80 138.6zM328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c.6 4 .9 8.1 .9 12.3c0 20.1-7.4 38.5-19.7 52.5l49.9 122.4c5 12.3-.9 26.3-13.2 31.3s-26.3-.9-31.3-13.2l-47-115.3c-6 1.5-12.3 2.2-18.8 2.2s-12.8-.8-18.8-2.2l-47 115.3c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l44.3-108.8L149.5 418c-15.2 8.2-34.3 2.9-42.9-12.1l-.7-1.3L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6zm73.3 127.5l-49.5-85.7L101.3 300.7l39.1 67.7L226 322.1c-1.3-5.8-2-11.9-2-18.1c0-44.2 35.8-80 80-80c22.7 0 43.2 9.5 57.8 24.7l39.9-21.6zM304 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faLocationPin = {
  prefix: 'far',
  iconName: 'location-pin',
  icon: [384, 512, ["map-marker"], "f041", "M320.7 249.2c-10.5 24.8-25.4 52.2-42.5 79.9C249.8 375.3 216.8 420 192 451.7c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9C52.5 223.6 48 204.4 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2zm-105 250C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0z"]
};
const faMapMarker = faLocationPin;
const faSquareList = {
  prefix: 'far',
  iconName: 'square-list',
  icon: [448, 512, [], "e489", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faKaaba = {
  prefix: 'far',
  iconName: 'kaaba',
  icon: [576, 512, [128331], "f66b", "M288 48.8L490.4 112 288 175.2 85.6 112 288 48.8zm9.5 173.8l230.5-72 0 45.7L292.8 269.7c-3.1 1-6.4 1-9.5 0L48 196.2l0-45.7 230.5 72c6.2 1.9 12.9 1.9 19.1 0zM48 229.8l225.7 70.5c9.3 2.9 19.3 2.9 28.6 0L528 229.8l0 30.5-4.8 1.5c-8.4 2.6-13.1 11.6-10.5 20c2.1 6.8 8.5 11.2 15.3 11.2l0 95.2-240 75-240-75L48 293c6.8 0 13.1-4.4 15.3-11.2c2.6-8.4-2.1-17.4-10.5-20L48 260.2l0-30.5zM22.5 81.5C9.1 85.6 0 98 0 112L0 400c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400l0-288c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zm94.3 200.3c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"]
};
const faToiletPaper = {
  prefix: 'far',
  iconName: 'toilet-paper',
  icon: [640, 512, [129531], "f71e", "M16.9 487.4c-1.9-8-.7-16.5 3.6-23.7c0 0 0 0 0-.1c3.8-7 7.3-14.2 10.5-21.6C63.6 366.5 64 269.6 64 192C64 86 107 0 160 0L492.2 0c0 0 0 .1 0 .1c1.3-.1 2.6-.1 3.8-.1c24.5 0 44.1 11.4 58 24.5c13.6 13 23.7 29.4 31.1 46.1C600 104.2 608 147.1 608 192s-8 87.8-22.9 121.3c-7.4 16.7-17.5 33.2-31.1 46.1c-13.9 13.2-33.5 24.5-58 24.5c-17.8 0-33-6-45.3-14.3c3-18.3 5.8-38.5 7.9-60.8C469.1 326 482 336 496 336c35.3 0 64-64.5 64-144s-28.7-144-64-144c-1.6 0-3.1 .1-4.6 .4C458.2 53.7 432 116 432 192c0 58.9-3.8 108.1-9.3 148.6l-.1 .8c-9.4 68.1-23.7 111.3-33.3 134.5c-10 24-33.2 36.1-55.4 36.1L48 512c-11.5 0-22.2-6.2-27.8-16.2c-1.5-2.7-2.6-5.5-3.3-8.4zM160 48c-.1 0-.1 0-.3 0s-.4 .1-.9 .3c-.9 .4-2.7 1.3-5.2 3.4c-5.2 4.4-11.9 12.6-18.6 26C121.7 104.5 112 144.8 112 192c0 42.3-.1 93.4-5.9 144.1C101.2 378.5 92 423.1 73.8 464l260.1 0c2.7 0 5.3-.8 7.3-2c1.7-1 3-2.4 3.8-4.5C357.7 427 384 345.2 384 192c0-44.9 8-87.8 22.9-121.3C410.3 63 414.3 55.3 419 48L160 48zM520 192c0 26.5-10.7 48-24 48s-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48zm-344 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faHelmetSafety = {
  prefix: 'far',
  iconName: 'helmet-safety',
  icon: [576, 512, ["hard-hat", "hat-hard"], "f807", "M264 80l48 0c4.4 0 8 3.6 8 8l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-30.9-25.1-56-56-56l-48 0c-30.9 0-56 25.1-56 56l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208c0-4.4 3.6-8 8-8zM559.4 384L16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6zM32 288l0 64 48 0 0-64c0-68.4 39-127.7 96-156.8l0-52.5C91.8 110.9 32 192.5 32 288zm464-2.2l0 66.2 48 0 0-64 0-2.4c-1-94.5-60.5-174.9-144-206.9l0 52.5c56.4 28.8 95.2 87.2 96 154.6z"]
};
const faHardHat = faHelmetSafety;
const faHatHard = faHelmetSafety;
const faCommentCode = {
  prefix: 'far',
  iconName: 'comment-code',
  icon: [512, 512, [], "e147", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM217 193c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
const faSimCards = {
  prefix: 'far',
  iconName: 'sim-cards',
  icon: [448, 512, [], "e251", "M144 352c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-213.5c0-4.2-1.7-8.3-4.7-11.3L320.8 52.7c-3-3-7.1-4.7-11.3-4.7L160 48c-8.8 0-16 7.2-16 16l0 288zM429.3 93.3c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L309.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm184 80l64 0 0 64-16 0-80 0 0-32c0-17.7 14.3-32 32-32zM176 304l0-32 64 0 0 64-32 0c-17.7 0-32-14.3-32-32zm192 0c0 17.7-14.3 32-32 32l-64 0 0-64 16 0 80 0 0 32zm0-96l0 32-64 0 0-64 32 0c17.7 0 32 14.3 32 32z"]
};
const faStarship = {
  prefix: 'far',
  iconName: 'starship',
  icon: [640, 512, [], "e039", "M0 96C0 60.7 28.7 32 64 32l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-27.2 0 37.7 26.1 70.1-8.4C302.6 110.7 369.9 64 448 64c106 0 192 86 192 192s-86 192-192 192c-78.1 0-145.4-46.7-175.3-113.7l-70.1-8.4L164.8 352l27.2 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64s28.7-64 64-64l16.5 0 50.1-34.7-13.7-1.6C86.7 312 64 286.4 64 256s22.7-56 52.9-59.6l13.7-1.6L80.5 160 64 160C28.7 160 0 131.3 0 96zM64 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 80zm58.6 164c-6.1 .7-10.6 5.9-10.6 12s4.6 11.3 10.6 12l135.4 16.3c-1.4-9.2-2.1-18.6-2.1-28.2s.7-19 2.1-28.2L122.6 244zM48 416c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 400c-8.8 0-16 7.2-16 16zm400-16a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm32-144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
const faEject = {
  prefix: 'far',
  iconName: 'eject',
  icon: [448, 512, [9167], "f052", "M4.1 323.3c-7.7-17.4-4.3-37.7 8.6-51.8l176-192C197.7 69.6 210.5 64 224 64s26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352L48 352c-19 0-36.3-11.2-43.9-28.7zM48 304l352 0L224 112 48 304zM24 400l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCircleRight = {
  prefix: 'far',
  iconName: 'circle-right',
  icon: [512, 512, [61838, "arrow-alt-circle-right"], "f35a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 151.2c-4.2-4.6-10.1-7.2-16.4-7.2C266 144 256 154 256 166.3l0 41.7-96 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l96 0 0 41.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.4-7.2l84-91c3.5-3.8 5.4-8.7 5.4-13.9s-1.9-10.1-5.4-13.9l-84-91z"]
};
const faArrowAltCircleRight = faCircleRight;
const faPlaneCircleCheck = {
  prefix: 'far',
  iconName: 'plane-circle-check',
  icon: [640, 512, [], "e555", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faSeal = {
  prefix: 'far',
  iconName: 'seal',
  icon: [512, 512, [], "e241", "M210.4 97.9c-9 9-21.2 14.1-33.9 14.1L112 112l0 64.5c0 12.7-5.1 24.9-14.1 33.9L52.4 256l45.6 45.6c9 9 14.1 21.2 14.1 33.9l0 64.5 64.5 0c12.7 0 24.9 5.1 33.9 14.1L256 459.6l45.6-45.6c9-9 21.2-14.1 33.9-14.1l64.5 0 0-64.5c0-12.7 5.1-24.9 14.1-33.9L459.6 256l-45.6-45.6c-9-9-14.1-21.2-14.1-33.9l0-64.5-64.5 0c-12.7 0-24.9-5.1-33.9-14.1L256 52.4 210.4 97.9zm11.6-79.5c18.7-18.7 49.1-18.7 67.9 0L335.5 64 400 64c26.5 0 48 21.5 48 48l0 64.5 45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5l0 64.5c0 26.5-21.5 48-48 48l-64.5 0-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448 112 448c-26.5 0-48-21.5-48-48l0-64.5L18.4 289.9c-18.7-18.7-18.7-49.1 0-67.9L64 176.5 64 112c0-26.5 21.5-48 48-48l64.5 0 45.6-45.6z"]
};
const faUserCowboy = {
  prefix: 'far',
  iconName: 'user-cowboy',
  icon: [448, 512, [], "f8ea", "M208.5 9.9c4.8 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0c35.6 0 58.8 59.3 72.4 112c7.1-2.2 13.7-4.5 19.8-6.9c32.4-12.7 49.4-27.2 55-34.7c4.7-6.3 13.3-8.2 20.2-4.6s10.2 11.8 7.8 19.2c-9.3 27.9-35 62.4-72.5 89.9c-7.4 5.4-15.4 10.6-23.8 15.5c.8 5.8 1.2 11.6 1.2 17.6c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-6 .4-11.9 1.2-17.6c-8.4-4.8-16.4-10-23.8-15.5C35.8 147.5 10.1 113 .8 85.1c-2.5-7.4 .8-15.6 7.8-19.2s15.5-1.7 20.2 4.6c5.6 7.5 22.7 22 55 34.7c6.1 2.4 12.7 4.7 19.8 6.9C117.2 59.3 140.4 0 176 0c18 0 25.9 5.4 32.5 9.9zM224 224c-29 0-55.8-4.8-79.9-12.7c1.7 42.7 36.8 76.7 79.9 76.7s78.2-34.1 79.9-76.7C279.8 219.2 253 224 224 224zM54.2 458.7l-.6 5.3 340.7 0-.6-5.3c-2.7-24.3-23.2-42.7-47.7-42.7l-244.2 0c-24.5 0-45 18.4-47.7 42.7zM6.5 453.4C11.9 404.8 53 368 101.9 368l244.2 0c48.9 0 90 36.8 95.4 85.4l2.6 23.1c2.1 19-12.7 35.5-31.8 35.5L35.8 512c-19.1 0-33.9-16.6-31.8-35.5l2.6-23.1z"]
};
const faHexagonVerticalNft = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft',
  icon: [448, 512, [], "e505", "M260.9 495.5c-22.3 12.9-49.7 12.9-72 0L36 407.2C13.7 394.4 0 370.6 0 344.9L0 168.3c0-25.7 13.7-49.5 36-62.4L188.9 17.6c22.3-12.9 49.7-12.9 72 0l152.9 88.3c22.3 12.9 36 36.6 36 62.4l0 176.6c0 25.7-13.7 49.5-36 62.4L260.9 495.5zm-48-41.6c7.4 4.3 16.6 4.3 24 0l152.9-88.3c7.4-4.3 12-12.2 12-20.8l0-176.6c0-8.6-4.6-16.5-12-20.8L236.9 59.2c-7.4-4.3-16.6-4.3-24 0L60 147.5c-7.4 4.3-12 12.2-12 20.8l0 176.6c0 8.6 4.6 16.5 12 20.8l152.9 88.3zM95.8 170.6l33.1 82.9 0-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8L96.9 259.7l0 76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-80zm112-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faFaceRollingEyes = {
  prefix: 'far',
  iconName: 'face-rolling-eyes',
  icon: [512, 512, [128580, "meh-rolling-eyes"], "f5a5", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
};
const faMehRollingEyes = faFaceRollingEyes;
const faBreadLoaf = {
  prefix: 'far',
  iconName: 'bread-loaf',
  icon: [640, 512, [127838], "f7eb", "M64 208c-8.8 0-16-7.2-16-16c0-36.7 23.6-63.9 68.1-84.4C160.5 87.1 213.4 80 240 80s79.5 7.1 123.9 27.6C408.4 128.1 432 155.3 432 192c0 8.8-7.2 16-16 16c-26.5 0-48 21.5-48 48l0 176-48 0-208 0 0-176c0-26.5-21.5-48-48-48zm352 48l112 0 0 176-112 0 0-128 0-48zm155.3-47.8c-1.1-.1-2.2-.2-3.3-.2l-90 0c1.3-5.1 2-10.5 2-16c0-51.1-28-86.9-65.8-111.5c28.7 2 72.2 9.7 109.7 27C568.4 128.1 592 155.3 592 192c0 8.8-7.2 16-16 16c-1.6 0-3.1 .1-4.7 .2zM112 480l208 0 48 0 160 0c26.5 0 48-21.5 48-48l0-128 0-48c35.3 0 64-28.7 64-64C640 64 464 32 400 32L288 32l-48 0C176 32 0 64 0 192c0 35.3 28.7 64 64 64l0 48 0 128c0 26.5 21.5 48 48 48z"]
};
const faRingsWedding = {
  prefix: 'far',
  iconName: 'rings-wedding',
  icon: [512, 512, [], "f81b", "M119.9 105.1C50.2 128.6 0 194.4 0 272c0 97.2 78.8 176 176 176c7.8 0 15.5-.5 23-1.5c32.3 39.9 81.6 65.5 137 65.5c97.2 0 176-78.8 176-176c0-91.9-70.4-167.3-160.3-175.3c10.4 16.5 18.6 34.5 24.2 53.6C427.1 231.1 464 279.2 464 336c0 70.7-57.3 128-128 128c-32.8 0-62.7-12.3-85.3-32.6c0 0 0 0 0 0c-12.3-11-22.5-24.4-29.8-39.5c0 0 0 0 0 0C212.6 375 208 356.1 208 336c0-54.9 34.6-101.8 83.2-119.9C299.4 233 304 251.9 304 272c0 43.5-21.7 81.9-54.8 105c7 14.8 17.7 27.5 30.8 37c43.7-32 72-83.7 72-142c0-77.6-50.2-143.4-119.9-166.9l22.5-50.6c1.9-4.4 1.8-9.4-.3-13.7l-16-32C235.6 3.4 230.1 0 224 0L128 0c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.1 4.3-2.3 9.3-.3 13.7l22.5 50.6zM147.8 48l56.4 0 .4 .8L187.2 88l-22.4 0L147.4 48.8l.4-.8zM160 336c0 22.6 4.2 44.1 12 63.9C103.1 397.8 48 341.3 48 272c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6C201.5 204.7 160 265.5 160 336z"]
};
const faObjectGroup = {
  prefix: 'far',
  iconName: 'object-group',
  icon: [576, 512, [], "f247", "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16l344.4 0c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8l0 280.4c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16l-344.4 0c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8l0-280.4zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3l0 261.5c13.6 4.8 24.4 15.6 29.3 29.3l325.5 0c4.8-13.6 15.6-24.4 29.3-29.3l0-261.5c-13.6-4.8-24.4-15.6-29.3-29.3L125.3 96zm2.7 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-96zM256 320l32 0c35.3 0 64-28.7 64-64l0-32 64 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32z"]
};
const faFrenchFries = {
  prefix: 'far',
  iconName: 'french-fries',
  icon: [384, 512, [127839], "f803", "M167.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l32 16c5.4 2.7 8.8 8.1 8.8 14.1l0 238c-9.2 1.4-19.8 2.2-32 2.2s-22.8-.8-32-2.2l0-63.2s0 0 0 0L160 16c0-5.5 2.9-10.7 7.6-13.6zM128 261c-4.8-2.1-8.7-4.4-11.8-6.6c-12-8.4-16.7-18-18.7-24.3c-.4-1.1-.8-2.3-1.2-3.4l-32-192c-1.2-6.9 2.3-13.8 8.6-16.9l32-16c4.5-2.3 9.9-2.3 14.4 .1s7.7 6.6 8.5 11.6l.2 1.3L128 261zM58.2 193c-3.2-.7-6.6-1-10.2-1l-26.6 0c-1.6 0-3.2 .1-4.7 .2L.2 98.8C-.7 93.4 1.1 88 5.1 84.3s9.5-5.1 14.8-3.8l20.4 5.1L58.2 193zm309.1-.8c-1.6-.1-3.1-.2-4.7-.2L336 192c-3.1 0-6 .3-8.8 .8L346.2 85l17.9-4.5c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5l-16.5 93.4zM289.4 223c-1.1 2.4-2.1 4.7-2.8 7c-2 6.3-6.7 15.9-18.7 24.3c-3.2 2.2-7.1 4.5-11.8 6.6l0-206.4 .2-1.4C257.3 47 262 42 268.1 40.5l32-8c5.3-1.3 10.8 .1 14.8 3.8s5.8 9.1 4.8 14.5L289.4 223zM48 224c8.8 0 16.3 7.2 18.9 15.7C74.3 263 100.3 304 192 304s117.7-41 125.1-64.3c2.7-8.4 10.1-15.7 18.9-15.7l26.6 0c11.8 0 21.4 9.6 21.4 21.4c0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5L89.2 512c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224L48 224zm269.9 92.8c-1.4 1.1-2.8 2.1-4.3 3.1C284.7 340.1 244.9 352 192 352s-92.7-11.9-121.6-32.1c-1.5-1-2.9-2.1-4.3-3.1L101.8 464l180.5 0 35.7-147.2z"]
};
const faChartLine = {
  prefix: 'far',
  iconName: 'chart-line',
  icon: [512, 512, ["line-chart"], "f201", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM473 169c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-79-79c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0L473 169z"]
};
const faLineChart = faChartLine;
const faCalendarArrowDown = {
  prefix: 'far',
  iconName: 'calendar-arrow-down',
  icon: [448, 512, ["calendar-download"], "e0d0", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM248 248l0 102.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L200 248c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faCalendarDownload = faCalendarArrowDown;
const faSendBack = {
  prefix: 'far',
  iconName: 'send-back',
  icon: [640, 512, [], "f87e", "M192 48c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16L64 208c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l128 0zM64 0C28.7 0 0 28.7 0 64L0 192c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64L64 0zM576 304c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16l128 0zM448 256c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-128 0zM160 288l0 64c0 35.3 28.7 64 64 64l128 0 0-96c0-53 43-96 96-96l32 0 0-64c0-35.3-28.7-64-64-64L288 96l0 96c0 53-43 96-96 96l-32 0z"]
};
const faMaskVentilator = {
  prefix: 'far',
  iconName: 'mask-ventilator',
  icon: [640, 512, [], "e524", "M176 300.8c0 26.7 8.9 52.3 24.7 73.6c-.5-4.3-.7-8.7-.7-13.1c0-31.9 12.4-72.4 31.4-104.9c9.6-16.5 21.7-32.1 36-43.8C281.7 200.9 299.5 192 320 192c20.4 0 38.2 8.9 52.4 20.7s26.3 27.3 36 43.8c19.1 32.5 31.6 73 31.6 104.9c0 4.3-.2 8.5-.6 12.7C455 352.8 464 327.4 464 300.8c0-38.2-17.9-96.6-49.1-145.7C382.2 103.7 346.7 80 320 80c-27.3 0-62.7 23.8-95.2 75C193.7 204.1 176 262.5 176 300.8zm72 60.5c0 21.8 9.2 41.2 24 54.5l0 58.6c-45.3-10.8-84-36.5-109.8-71.1L90.9 385.5C37.5 372.1 0 324.1 0 269l0-85c0-30.9 25.1-56 56-56l129.1 0C219.8 73.8 267.4 32 320 32c52.1 0 99.7 41.8 134.5 96L584 128c30.9 0 56 25.1 56 56l0 85c0 55.1-37.5 103.1-90.9 116.4l-71.6 17.9c-26 34.6-64.7 60.2-109.5 71l0-58.7c14.7-13.3 24-32.6 24-54.3c0-21.6-9.2-53.7-25-80.6c-7.8-13.2-16.4-23.9-25.1-31.1s-16-9.7-21.9-9.7c-6 0-13.5 2.6-22.1 9.7c-8.7 7.1-17.3 17.8-25.1 31c-15.7 26.8-24.8 59-24.8 80.6zm257.6-14.5l31.8-8c32.1-8 54.5-36.8 54.5-69.9l0-85c0-4.4-3.6-8-8-8l-103.3 0c19.8 43.2 31.3 88.7 31.3 124.8c0 16-2.2 31.4-6.4 46.1zM159.1 176L56 176c-4.4 0-8 3.6-8 8l0 85c0 33 22.5 61.8 54.5 69.9l31.8 7.9c-4.1-14.7-6.3-30.1-6.3-46c0-36.1 11.4-81.6 31.1-124.8zM296 328c0-13.3 10.7-24 24-24s24 10.7 24 24l0 184-48 0 0-184z"]
};
const faTickets = {
  prefix: 'far',
  iconName: 'tickets',
  icon: [640, 512, [], "e658", "M160 80c-8.8 0-16 7.2-16 16l0 38.2c24 15.7 40 42.8 40 73.8s-16 58.1-40 73.8l0 38.2c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-38.2c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8L592 96c0-8.8-7.2-16-16-16L160 80zm0-48l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64l0-56c0-8.8 7.4-15.7 15.6-19.1c14.4-6.1 24.4-20.3 24.4-36.9s-10.1-30.8-24.4-36.9C103.4 167.7 96 160.8 96 152l0-56c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 240c0 39.8 32.2 72 72 72l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0C53.7 480 0 426.3 0 360L0 120c0-13.3 10.7-24 24-24zM464 240l0-64-192 0 0 64 192 0zM224 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-96z"]
};
const faSignatureLock = {
  prefix: 'far',
  iconName: 'signature-lock',
  icon: [640, 512, [], "e3ca", "M80 128c0-26.5 21.5-48 48-48s48 21.5 48 48l0 7.9c0 27.5-2.3 55-7 82.1L62 251.1C25.1 262.5 0 296.6 0 335.2L0 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c29.6-49.4 51.1-103.3 63.6-159.5l1-4.7 110.8-34.3-23.9 66.8c-2.6 7.4-1.5 15.5 3 21.9s11.8 10.2 19.6 10.2l72.6 0c5.6-9.7 13.7-17.8 23.4-23.4l0-24.6-61.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96s-96 43-96 96l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zM208.1 368c-7 16.3-14.8 32.4-23.3 48L384 416l0-48-175.9 0zM76.2 297l80.9-25c-11.7 43.2-29.4 84.5-52.4 123L88.8 421.3C84.8 428 77.7 432 70 432c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faArrowRight = {
  prefix: 'far',
  iconName: 'arrow-right',
  icon: [448, 512, [8594], "f061", "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"]
};
const faSignsPost = {
  prefix: 'far',
  iconName: 'signs-post',
  icon: [512, 512, ["map-signs"], "f277", "M232 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 160.3 0c4.9 0 9.5 2.2 12.5 6L504 102c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6L280 192l0 32 168 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-168 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104L71.7 384c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6L232 224l0-32L64 192c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l168 0 0-8zM80 80l0 64 344.9 0 25.6-32L424.9 80 80 80zM432 336l0-64L87.1 272 61.5 304l25.6 32L432 336z"]
};
const faMapSigns = faSignsPost;
const faOctagonPlus = {
  prefix: 'far',
  iconName: 'octagon-plus',
  icon: [512, 512, ["plus-octagon"], "f301", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faPlusOctagon = faOctagonPlus;
const faCashRegister = {
  prefix: 'far',
  iconName: 'cash-register',
  icon: [512, 512, [], "f788", "M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-56.5 0c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-59.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9L208 160l0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM48 448l0-16 416 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM440.3 221.7L463.5 384l-415 0L71.7 221.7c1.1-7.9 7.9-13.7 15.8-13.7l337 0c8 0 14.7 5.9 15.8 13.7zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
const faPersonCircleQuestion = {
  prefix: 'far',
  iconName: 'person-circle-question',
  icon: [576, 512, [], "e542", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6l0 6.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2l0 14.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-5.1 23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6z"]
};
const faMelonSlice = {
  prefix: 'far',
  iconName: 'melon-slice',
  icon: [512, 512, [], "e311", "M7 391c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7c-9.4-9.4-24.6-9.4-33.9 0L319 79c-6.2 6.2-8.5 15.3-6.1 23.7c0 0 0 0 0 0l.1 .4c.1 .5 .3 1.3 .6 2.4c.5 2.3 1.2 5.8 1.8 10.4c1.2 9.2 2.1 22.3 .6 37.9c-2.9 30.9-15.1 71.3-53 109.2c-42.3 42.3-82.7 54-111.6 55.9c-14.7 1-26.8-.5-35-2.2c-4.1-.8-7.2-1.7-9.2-2.3c-1-.3-1.7-.5-2-.7l-.3-.1C96 310.2 85.8 312.2 79 319L7 391zM313 102.7s0 0 0 0c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0-.1zm51.8 35.2C377.1 161.3 384 187.8 384 216c0 92.8-75.2 168-168 168c-26.2 0-51-6-73.1-16.7c3.8 0 7.7-.2 11.8-.4c39.9-2.7 91.4-19 142.2-69.9c47.2-47.2 63-98.7 66.8-138.6c.7-7.2 1-14.1 1-20.4zM81.2 384.8C118.1 414.3 165 432 216 432c119.3 0 216-96.7 216-216c0-51-17.7-97.9-47.2-134.8l22.4-22.4c80.4 97.4 75.3 241.5-15.8 332.6s-235.2 96.2-332.6 15.8l22.4-22.4z"]
};
const faSpaceStationMoon = {
  prefix: 'far',
  iconName: 'space-station-moon',
  icon: [512, 512, [], "e033", "M256 48c-16.5 0-32.5 1.9-47.8 5.5C245.4 66.8 272 102.3 272 144c0 53-43 96-96 96c-52.7 0-95.4-42.4-96-94.9C59.7 177.2 48 215.2 48 256c0 12.8 1.1 25.2 3.3 37.4c.5 .2 1 .3 1.5 .5C87.7 306.5 147.6 328 256 328s168.3-21.5 203.2-34.1c0 0 0 0 0 0c.5-.2 1-.4 1.5-.5c2.2-12.1 3.3-24.6 3.3-37.4c0-114.9-93.1-208-208-208zM441.3 350.7C402.1 362.7 343 376 256 376s-146.1-13.3-185.3-25.3C105.2 417.9 175.2 464 256 464s150.8-46.1 185.3-113.3zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM176 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faMessageSmile = {
  prefix: 'far',
  iconName: 'message-smile',
  icon: [512, 512, ["comment-alt-smile"], "f4aa", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM192 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM150.5 238.1c-9.9 8.8-10.7 24-1.9 33.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32c-8.8-9.9-24-10.7-33.9-1.9z"]
};
const faCommentAltSmile = faMessageSmile;
const faCupStraw = {
  prefix: 'far',
  iconName: 'cup-straw',
  icon: [384, 512, [129380], "e363", "M194.8 43.2l-20 84.8-94.7 0L32 128l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12 0 48.2 0 89.9 0 35.8 0 89.9 0 48.2 0 12 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.2 0-79.6 0 17.4-73.8c.9-3.6 4.1-6.2 7.8-6.2L280 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L249.3 0c-26 0-48.6 17.9-54.5 43.2zM38.7 208L60.3 468c2.1 24.9 22.9 44 47.8 44l167.7 0c25 0 45.8-19.1 47.8-44l21.7-260-48.2 0L275.8 464l-167.7 0L86.8 208l-48.2 0z"]
};
const faLeftFromLine = {
  prefix: 'far',
  iconName: 'left-from-line',
  icon: [448, 512, ["arrow-alt-from-right"], "f348", "M160 146.2L50 256 160 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM0 256c0-11.5 4.6-22.5 12.7-30.6L128.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L12.7 286.6C4.6 278.5 0 267.5 0 256zM400 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336z"]
};
const faArrowAltFromRight = faLeftFromLine;
const faH = {
  prefix: 'far',
  iconName: 'h',
  icon: [384, 512, [104], "48", "M336 256l0 200c0 13.3 10.7 24 24 24s24-10.7 24-24l0-232 0-168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152L48 208 48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-200 288 0z"]
};
const faBasketShoppingSimple = {
  prefix: 'far',
  iconName: 'basket-shopping-simple',
  icon: [576, 512, ["shopping-basket-alt"], "e0af", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240l-389 0 53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9zM144 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faShoppingBasketAlt = faBasketShoppingSimple;
const faHandsHoldingHeart = {
  prefix: 'far',
  iconName: 'hands-holding-heart',
  icon: [640, 512, ["hands-heart"], "f4c3", "M195.9 136.9L297.5 240.1c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4L444.1 136.9c29.4-29.8 29.4-78.2 0-108s-77-29.8-106.4 0L320 46.9l-17.7-18c-29.4-29.8-77-29.8-106.4 0s-29.4 78.2 0 108zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z"]
};
const faHandsHeart = faHandsHoldingHeart;
const faClockNine = {
  prefix: 'far',
  iconName: 'clock-nine',
  icon: [512, 512, [], "e34c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 136c0 13.3-10.7 24-24 24l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHammerBrush = {
  prefix: 'far',
  iconName: 'hammer-brush',
  icon: [640, 512, [], "e620", "M152 0C68.1 0 0 68.1 0 152l0 16c0 8.3 4.3 16 11.4 20.4s15.9 4.8 23.4 1.1l45.7-22.9c10.2 10.7 23.2 18.5 37.5 22.5L100.4 448.1C98 482.7 125.4 512 160 512s62-29.3 59.6-63.9L202.2 191.8c23.4-1.7 44.9-13.4 59-31.8l42.8 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-31.8 0-.2 0-80 0-.2L352 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-42.8 0C245.8 12.1 221.9 0 196.2 0L152 0zM304 112l-56 0c-9.1 0-17.4 5.1-21.5 13.3c-5.7 11.5-17.5 18.7-30.3 18.7l-56.4 0c-12.8 0-24.6-7.3-30.3-18.7c-5.9-11.9-20.3-16.7-32.2-10.7L50.8 127.7C61.8 82 102.9 48 152 48l44.2 0c12.8 0 24.6 7.3 30.3 18.7C230.6 74.9 238.9 80 248 80l56 0 0 32zM592 464l-112 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0 0-144 192 0 0 144zM380.5 237c-17.8 11.9-28.5 31.9-28.5 53.3L352 464c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-173.7c0-21.4-10.7-41.4-28.5-53.3L544 192l0-144c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 144-67.5 45zM480 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faTarp = {
  prefix: 'far',
  iconName: 'tarp',
  icon: [576, 512, [], "e57b", "M48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 160-80 0c-17.7 0-32 14.3-32 32l0 80L64 400c-8.8 0-16-7.2-16-16l0-256zm528 0c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l364.1 0c12.7 0 24.9-5.1 33.9-14.1l99.9-99.9c9-9 14.1-21.2 14.1-33.9L576 128zM112 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faFaceSleepy = {
  prefix: 'far',
  iconName: 'face-sleepy',
  icon: [512, 512, [], "e38e", "M256 464c47 0 90.4-15.6 125.2-41.9c2.7 14.8 2.8 29.6 2.8 41.9c0 4.5 .4 8.9 1.1 13.1C347.2 499.3 303.1 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 37-7.8 72.1-22 103.9c-7.4-6.2-15.1-11.8-22.7-16.7c-5.8-3.8-11.8-7.3-17.9-10.6C458.8 308.9 464 283 464 256c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208zm-80-74.5C191.1 364.8 221.3 348 256 348s64.9 16.8 80.1 41.5c6.8 11.1-6 20.7-18.3 16.4c-18.9-6.5-39.8-10.1-61.8-10.1s-42.9 3.6-61.8 10.1c-12.3 4.2-25.1-5.3-18.3-16.4zM326.2 250.3c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 293.2 371 300 351.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM159.6 260c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 293.2 179 300 159.6 300s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zM512 464c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-32 0-102.4-64-128c48 0 160 48 160 128z"]
};
const faHandHorns = {
  prefix: 'far',
  iconName: 'hand-horns',
  icon: [384, 512, [], "e1a9", "M80 48c8.8 0 16 7.2 16 16l0 144 0 32-16 0c-5.5 0-10.8 .6-16 1.6L64 64c0-8.8 7.2-16 16-16zM16 64l0 208C6 285.4 0 302 0 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-56 0-32 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 50c-5.1-1.3-10.5-2-16-2c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.5 0-10.9 .7-16 2l0-82c0-35.3-28.7-64-64-64S16 28.7 16 64zM336 256l0 32 0 56c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l40 0 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14c35.3 0 64-28.7 64-64l0-48 0-16 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 128zM160 240l-16 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 2c-5.1-1.3-10.5-2-16-2zm96 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16z"]
};
const faScrewdriverWrench = {
  prefix: 'far',
  iconName: 'screwdriver-wrench',
  icon: [512, 512, ["tools"], "f7d9", "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l54.1 0 109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109 0-54.1c0-7.5-3.5-14.5-9.4-19L78.6 5zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-8.9-17.6-12.8-37.1-11.6-56.3L101.3 454.9c-5.9 5.8-13.8 9.1-22.1 9.1C62 464 48 450 48 432.8c0-8.3 3.3-16.2 9.1-22.1L194.3 273.5l-33.9-33.9L23.2 376.8zM463.9 164c-1.4 38.9-22.6 72.8-53.8 91.8c1.1 1 2.1 2 3.1 3l31.6 31.6c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7L368 160c-8.8 0-16-7.2-16-16l0-25.4c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C294.7 0 244.4 30.1 216.2 75.4C221.2 84 224 93.8 224 104l0 40.8 16 16 0-.8c0-60.5 48-109.9 108-111.9L322.7 73.4s0 0 0 0c-12 12-18.7 28.3-18.7 45.3l0 25.4c0 35.3 28.7 64 64 64l25.4 0c17 0 33.3-6.7 45.3-18.7L463.9 164z"]
};
const faTools = faScrewdriverWrench;
const faArrowsToEye = {
  prefix: 'far',
  iconName: 'arrows-to-eye',
  icon: [640, 512, [], "e4bf", "M49 15C39.6 5.7 24.4 5.7 15 15S5.7 39.6 15 49l63 63L40 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 38.1L49 15zM320 352c-64.5 0-113.8-52.1-138.5-96c24.7-43.9 74-96 138.5-96s113.8 52.1 138.5 96c-24.7 43.9-74 96-138.5 96zm0-240c-97.3 0-161.4 81.6-186.5 131.9c-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zM625 15c-9.4-9.4-24.6-9.4-33.9 0l-63 63L528 40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 63-63c9.4-9.4 9.4-24.6 0-33.9zM49 497l63-63 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0L15 463c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm576 0c9.4-9.4 9.4-24.6 0-33.9l-63-63 38.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-38.1 63 63c9.4 9.4 24.6 9.4 33.9 0zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faCircleThreeQuarters = {
  prefix: 'far',
  iconName: 'circle-three-quarters',
  icon: [512, 512, [], "e125", "M256 304c-26.5 0-48-21.5-48-48l0-202.4C116.3 75.2 48 157.7 48 256c0 114.9 93.1 208 208 208c98.3 0 180.8-68.3 202.4-160L256 304zM224.1 2C241.6-.2 256 14.3 256 32l0 176 0 48 48 0 176 0c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512C114.6 512 0 397.4 0 256C0 125.4 97.8 17.7 224.1 2z"]
};
const faTrophyStar = {
  prefix: 'far',
  iconName: 'trophy-star',
  icon: [576, 512, ["trophy-alt"], "f2eb", "M176.9 48c6.4 160.7 44.3 231.4 71.8 261.7c13.7 15.1 25.9 21.4 33.1 24.1c2.6 1 4.7 1.5 6.1 1.9c1.4-.3 3.5-.9 6.1-1.9c7.2-2.7 19.4-9 33.1-24.1c27.5-30.3 65.5-101 71.8-261.7L176.9 48zM176 0L400 0c26.5 0 48.1 21.8 47.1 48.2c-.2 5.3-.4 10.6-.7 15.8L552 64c13.3 0 24 10.7 24 24c0 108.5-45.9 177.7-101.4 220.6c-53.9 41.7-115.7 57.6-149.5 63.7c-4.7 2.5-9.1 4.5-13.1 6.1l0 85.6 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-85.6c-4-1.6-8.4-3.6-13.1-6.1c-33.8-6-95.5-22-149.5-63.7C45.9 265.7 0 196.5 0 88C0 74.7 10.7 64 24 64l105.6 0c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zM390.8 302.6c18.1-8 36.8-18.4 54.4-32c40.6-31.3 75.9-80.2 81.9-158.6l-84.4 0c-9.1 90.1-29.2 150.3-51.9 190.6zm-260-32c17.5 13.6 36.3 24 54.4 32c-22.7-40.3-42.8-100.5-51.9-190.6l-84.4 0c6 78.4 41.3 127.3 81.9 158.6zM295.2 102.5l14.5 29.3c1.2 2.4 3.4 4 6 4.4l32.4 4.7c6.6 1 9.2 9 4.4 13.6l-23.4 22.8c-1.9 1.8-2.7 4.5-2.3 7.1l5.5 32.2c1.1 6.5-5.7 11.5-11.6 8.4l-29-15.2c-2.3-1.2-5.1-1.2-7.4 0l-29 15.2c-5.9 3.1-12.7-1.9-11.6-8.4l5.5-32.2c.4-2.6-.4-5.2-2.3-7.1l-23.4-22.8c-4.7-4.6-2.1-12.7 4.4-13.6l32.4-4.7c2.6-.4 4.9-2 6-4.4l14.5-29.3c2.9-5.9 11.4-5.9 14.3 0z"]
};
const faTrophyAlt = faTrophyStar;
const faPlugCircleBolt = {
  prefix: 'far',
  iconName: 'plug-circle-bolt',
  icon: [576, 512, [], "e55b", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"]
};
const faFaceThermometer = {
  prefix: 'far',
  iconName: 'face-thermometer',
  icon: [576, 512, [], "e39a", "M288 48C173.1 48 80 141.1 80 256s93.1 208 208 208c65.9 0 124.7-30.7 162.8-78.5c1.5-1.3 3-2.6 4.4-4L540 301.1C518.8 421 414 512 288 512C146.6 512 32 397.4 32 256S146.6 0 288 0c97 0 181.4 54 224.8 133.5c-16.5-.3-33.1 4.4-47.3 14.1C429 87.8 363.1 48 288 48zM546.8 180.1c19.8 19.8 19.4 52.1-.9 71.4L415.1 376.1c-1.2 4.2-3.4 8.1-6.8 11.2c-9.7 9-24.9 8.4-33.9-1.4C359.2 369.5 333.2 352 296 352s-63.2 17.5-78.4 33.9c-9 9.7-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9c22-23.8 60-49.4 113.6-49.4c16.2 0 31.1 2.3 44.4 6.3L477 179.4c19.6-18.8 50.6-18.4 69.8 .7zM401.3 345l28-26.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5 .3-25.6c-6.9-6.9-18-7-25-.3L372.5 323.9c11.2 6.3 20.8 13.7 28.9 21.1zm-193-169a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faGridRound4 = {
  prefix: 'far',
  iconName: 'grid-round-4',
  icon: [448, 512, [], "e5dd", "M44.8 64a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 76.8a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 76.8zM44.8 183.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM57.6 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM44.8 270.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM177.1 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM296.5 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm57.6 119.5a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 76.8a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM416 315.7a12.8 12.8 0 1 1 -25.6 0 12.8 12.8 0 1 1 25.6 0zm-12.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 151.5a12.8 12.8 0 1 1 0 25.6 12.8 12.8 0 1 1 0-25.6zm-44.8 12.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z"]
};
const faSignPostsWrench = {
  prefix: 'far',
  iconName: 'sign-posts-wrench',
  icon: [640, 512, [], "e626", "M64 24l0 8L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48l16 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 272 0c-10.8-14.3-19.2-30.5-24.7-48L48 368 48 80l480 0 0 80.8c16.9 1.7 33.1 6 48 12.5L576 80c0-26.5-21.5-48-48-48l-16 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L112 32l0-8c0-13.3-10.7-24-24-24S64 10.7 64 24zM640 320c0-47.4-25.7-88.8-64-110.9c-7.4-4.3-16 1.5-16 10l0 84.9c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-84.9c0-8.5-8.6-14.3-16-10c-38.3 22.1-64 63.5-64 110.9c0 40.4 18.7 76.5 48 99.9l0 56.1c0 19.9 16.1 36 36 36l88 0c19.9 0 36-16.1 36-36l0-56.1c29.3-23.5 48-59.5 48-99.9zM512.3 192l-.3 0-.3 0 .7 0z"]
};
const faShirtRunning = {
  prefix: 'far',
  iconName: 'shirt-running',
  icon: [384, 512, [], "e3c8", "M88 0c13.3 0 24 10.7 24 24l0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24c0 127.9 26.8 181 41.5 200.5c9.6 12.8 22.5 32.8 22.5 56.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 280.7c0-23.5 12.9-43.5 22.5-56.3C37.2 205 64 151.9 64 24C64 10.7 74.7 0 88 0zM60.8 253.4C52.2 264.8 48 273.9 48 280.7l0 110.1L299.3 209.3c-5.4-13.6-10.4-29.8-14.6-49.1C261.4 184.7 228.5 200 192 200s-69.4-15.3-92.7-39.8C89 206.9 74.1 235.7 60.8 253.4zM48.1 450c1 7.9 7.7 14 15.9 14l256 0c8.8 0 16-7.2 16-16l0-167.3c0-6.8-4.2-15.9-12.8-27.3c-.3-.4-.7-.9-1-1.4L48.1 450z"]
};
const faBookCircleArrowUp = {
  prefix: 'far',
  iconName: 'book-circle-arrow-up',
  icon: [640, 512, [], "e0bd", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l314.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l242.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 164.5c14.6-9.5 30.8-17 48-21.8L448 56c0-30.9-25.1-56-56-56L88 0zM496 224a144 144 0 1 0 0 288 144 144 0 1 0 0-288zM428.7 371.3c-6.2-6.2-6.2-16.4 0-22.6l56-56c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L512 342.6l0 89.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-89.4-28.7 28.7c-6.2 6.2-16.4 6.2-22.6 0z"]
};
const faFaceNauseated = {
  prefix: 'far',
  iconName: 'face-nauseated',
  icon: [512, 512, [], "e381", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335.6-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-12.3-84.7l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm121.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM172 267.2C189 277 202 293 208 312l96.2 0c6.1-18.8 19-34.5 35.8-44.2c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8c-9.4 5.5-15.7 15.6-15.7 27.2s6.3 21.8 15.7 27.2c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8c-17.1-9.9-30.2-26-36.2-45.3L208 360c-6 19-19.1 35-36 44.8c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8c9.5-5.5 15.7-15.6 15.7-27.2s-6.3-21.8-15.7-27.2c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8z"]
};
const faHeart = {
  prefix: 'far',
  iconName: 'heart',
  icon: [512, 512, [128153, 128154, 128155, 128156, 128420, 129293, 129294, 129505, 9829, 10084, 61578], "f004", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"]
};
const faFileChartPie = {
  prefix: 'far',
  iconName: 'file-chart-pie',
  icon: [384, 512, [], "f65a", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM160 240.1c8.7-1.5 16 5.8 16 14.7l0 65.3c0 8.8 7.2 16 16 16l64 0c8.9 0 16.3 7.4 14.6 16.1c-.5 2.5-1 5-1.7 7.4c-13.7 51.2-66.4 81.6-117.6 67.9s-81.6-66.4-67.9-117.6c10-37.4 40.8-63.7 76.5-69.8zm63.9-30.8c40.3 6.7 72 38.5 78.8 78.8c1.5 8.7-5.8 15.9-14.7 15.9l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16.1 15.9-14.7z"]
};
const faMarsAndVenus = {
  prefix: 'far',
  iconName: 'mars-and-venus',
  icon: [512, 512, [9893], "f224", "M352 24c0 13.3 10.7 24 24 24l38.1 0L371.2 90.9C340.3 64.2 300 48 256 48C158.8 48 80 126.8 80 224c0 89.1 66.2 162.7 152 174.4l0 17.6-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-17.6c85.8-11.7 152-85.3 152-174.4c0-35.8-10.7-69.2-29.1-97L448 81.9l0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24L376 0c-13.3 0-24 10.7-24 24zM256 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
const faHouseUser = {
  prefix: 'far',
  iconName: 'house-user',
  icon: [576, 512, ["home-user"], "e1b0", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM224 224a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm32 96l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
const faHomeUser = faHouseUser;
const faCircleArrowDownLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-down-left',
  icon: [512, 512, [], "e0f9", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zm64-144l-152 0c-13.3 0-24-10.7-24-24l0-160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.1L327 151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-135 135 94.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faDumpsterFire = {
  prefix: 'far',
  iconName: 'dumpster-fire',
  icon: [640, 512, [], "f794", "M49.7 32l90.8 0L114.9 160l-94 0C9.3 160 0 150.7 0 139.1c0-2.1 .3-4.1 .9-6.1L26.8 48.9C29.9 38.9 39.2 32 49.7 32zM272 160l-124.5 0L173.1 32 272 32l0 128zm32 0l0-128 98.9 0 14.4 72.1c-1.7 1.1-3.3 2.4-4.8 3.8c-18.4 16.4-35.4 34-50.5 52.1l-58 0zm209.9-23.7c-1.7 1.6-3.4 3.2-5 4.8C498 129.6 486.7 118.6 475 108c-7.6-6.9-17-10.8-26.6-11.8L435.5 32l90.8 0c10.5 0 19.8 6.9 22.9 16.9L575.1 133c.2 .7 .4 1.4 .5 2.1c-17.8-15-44.3-14.6-61.7 1.2zM80.4 192l257.1 0c-4.4 6.2-8.5 12.5-12.3 18.7c-5.8 9.5-11.3 19.3-16.2 29.3L86.4 240l20 160 199.7 0c8.1 17.5 18.8 33.7 31.5 48L112 448l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L42 272l-18 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l12 0-4-32 48.4 0zm425.3-15.7L518 162.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 259.2 640 290.2 640 320.2C640 408.8 568.7 480 480 480c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 368.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 295.1 416 331.6 416 368.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faHexagonMinus = {
  prefix: 'far',
  iconName: 'hexagon-minus',
  icon: [512, 512, ["minus-hexagon"], "f307", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMinusHexagon = faHexagonMinus;
const faLeftToLine = {
  prefix: 'far',
  iconName: 'left-to-line',
  icon: [448, 512, ["arrow-alt-to-left"], "f34b", "M256 146.2L146 256 256 365.8l0-53.8c0-13.3 10.7-24 24-24l120 0 0-64-120 0c-13.3 0-24-10.7-24-24l0-53.8zM96 256c0-11.5 4.6-22.5 12.7-30.6L224.8 109.6c8.7-8.7 20.5-13.6 32.8-13.6c25.6 0 46.4 20.8 46.4 46.4l0 33.6 96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0 0 33.6c0 25.6-20.8 46.4-46.4 46.4c-12.3 0-24.1-4.9-32.8-13.6L108.7 286.6C100.6 278.5 96 267.5 96 256zM48 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64s24 10.7 24 24z"]
};
const faArrowAltToLeft = faLeftToLine;
const faHouseCrack = {
  prefix: 'far',
  iconName: 'house-crack',
  icon: [576, 512, [], "e3b1", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-106.1 0L288 403.8l79.7-63.3c8.2-6.5 8-19.1-.4-25.3L252.2 229c-14.9-11.1-33.6 7.8-22.3 22.5L288 327.6l-84.8 67.3c-6.4 5.1-7.9 14.2-3.6 21.1L229.9 464 144 464c-17.7 0-32-14.3-32-32z"]
};
const faPawSimple = {
  prefix: 'far',
  iconName: 'paw-simple',
  icon: [448, 512, ["paw-alt"], "f701", "M192 80A48 48 0 1 0 96 80a48 48 0 1 0 96 0zm-.7 146.1c7.1-11.3 19.4-18.1 32.7-18.1s25.7 6.9 32.7 18.1l49.2 78.6c8.7 14 20.9 22.8 32.2 28.1c17.8 8.4 30 26.4 30 47.1c0 28.7-23.3 52-52 52c-11.1 0-21.2-3.4-29.6-9.2c-19.6-13.6-43.8-17.6-62.4-17.6s-42.8 4-62.4 17.6c-8.4 5.8-18.5 9.2-29.6 9.2c-28.7 0-52-23.3-52-52c0-20.8 12.2-38.8 30-47.1c11.2-5.3 23.4-14.1 32.2-28.1l49.2-78.6zm-89.9 53.2c-2.8 4.5-7.1 7.8-11.8 10.1C55.6 305.4 32 339.9 32 380c0 55.2 44.8 100 100 100c21.2 0 40.8-6.6 56.9-17.8c17.4-12 52.8-12 70.1 0C275.2 473.4 294.8 480 316 480c55.2 0 100-44.8 100-100c0-40.1-23.6-74.6-57.6-90.6c-4.8-2.2-9-5.6-11.8-10.1l-49.1-78.6C281.6 175.4 253.9 160 224 160s-57.6 15.4-73.4 40.7l-49.2 78.6zM304 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm144 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 240a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faPawAlt = faPawSimple;
const faArrowLeftLongToLine = {
  prefix: 'far',
  iconName: 'arrow-left-long-to-line',
  icon: [640, 512, [], "e3d4", "M0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88zM135 239c-9.4 9.4-9.4 24.6 0 33.9L271 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L616 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-406.1 0 95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L135 239z"]
};
const faBracketsRound = {
  prefix: 'far',
  iconName: 'brackets-round',
  icon: [512, 512, ["parentheses"], "e0c5", "M148.3 76.6c11.4-6.8 15.1-21.5 8.3-32.9s-21.5-15.1-32.9-8.3C82 60.2 0 137.9 0 256S82 451.8 123.7 476.6c11.4 6.8 26.1 3 32.9-8.3s3-26.1-8.3-32.9C115.3 415.7 48 351.3 48 256s67.3-159.7 100.3-179.4zm215.4 0C396.7 96.3 464 160.7 464 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C430 451.8 512 374.1 512 256s-82-195.8-123.7-220.6c-11.4-6.8-26.1-3-32.9 8.3s-3 26.1 8.3 32.9z"]
};
const faParentheses = faBracketsRound;
const faMartiniGlassCitrus = {
  prefix: 'far',
  iconName: 'martini-glass-citrus',
  icon: [576, 512, ["cocktail"], "f561", "M432 240c-14.3 0-27.9-3.1-40.1-8.7l-35.4 35.4C378.5 280.2 404.3 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C369.3 0 316 40.1 296.2 96l52.6 0c16.6-28.7 47.6-48 83.2-48c53 0 96 43 96 96s-43 96-96 96zM24 128c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l177 177L184 464l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-118.1L409 169c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8L24 128zm310.1 48L208 302.1 81.9 176l252.1 0z"]
};
const faCocktail = faMartiniGlassCitrus;
const faUserShakespeare = {
  prefix: 'far',
  iconName: 'user-shakespeare',
  icon: [448, 512, [], "e2c2", "M224 48c-44.2 0-80 35.8-80 80l0 32c0 40.1 29.5 73.3 68 79.1l0-15.1c0-6.6 5.4-12 12-12s12 5.4 12 12l0 15.1c38.5-5.8 68-39 68-79.1l0-32c0-44.2-35.8-80-80-80zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 23.2c0 10.9 3.7 21.5 10.5 30L373.6 195c6.7 8.4 10.4 18.8 10.4 29.6c0 26.2-21.2 47.4-47.4 47.4L286 272c-18.4 10.2-39.5 16-62 16s-43.6-5.8-62-16l-50.6 0C85.2 272 64 250.8 64 224.6c0-10.8 3.7-21.2 10.4-29.6l11.1-13.9c6.8-8.5 10.5-19.1 10.5-30L96 128zm96-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5c4.7-4.7 12.3-4.7 17 0zM240 416.7c-.3 8.5-7.4 15.3-16 15.3s-15.6-6.8-16-15.3c-23.1 1.9-42.4 7.7-56.5 13.5c-8.6 3.5-15.2 7-19.6 9.6c-2.2 1.3-3.8 2.3-4.8 2.9c-.5 .3-.8 .6-1 .7l-.1 .1c-7.3 5.3-16.9 6-24.9 1.9C93.1 441.3 88 433 88 424l0-29.1C67.7 412.1 53.5 436.4 49.3 464L208 464c0-8.8 7.2-16 16-16s16 7.2 16 16l158.7 0c-4.2-27.6-18.4-51.9-38.7-69.1l0 29.1c0 9-5.1 17.3-13.1 21.4c-8 4.1-17.6 3.3-24.9-1.9l-.1-.1c-.2-.1-.5-.3-1-.7c-1-.6-2.6-1.7-4.8-2.9c-4.4-2.5-11-6-19.6-9.6c-14.1-5.8-33.3-11.6-56.5-13.5zM117.9 325.9C133.4 312.3 153.7 304 176 304l96 0c22.3 0 42.6 8.3 58.1 21.9c68 18.9 117.9 81.3 117.9 155.4c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-74 49.9-136.4 117.9-155.4zM224 368c35.9 0 65.8 8 87.3 16.4C307.7 366 291.5 352 272 352l-96 0c-19.5 0-35.7 14-39.3 32.4C158.2 376 188.1 368 224 368z"]
};
const faArrowRightToArc = {
  prefix: 'far',
  iconName: 'arrow-right-to-arc',
  icon: [512, 512, [], "e4b2", "M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM232.3 134.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6s-2.8 13-7.7 17.6l-112 104c-9.7 9-24.9 8.5-33.9-1.3s-8.5-24.9 1.3-33.9L266.9 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l242.9 0-67.2-62.4c-9.7-9-10.3-24.2-1.3-33.9s24.2-10.3 33.9-1.3z"]
};
const faFaceSurprise = {
  prefix: 'far',
  iconName: 'face-surprise',
  icon: [512, 512, [128558, "surprise"], "f5c2", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faSurprise = faFaceSurprise;
const faBottleWater = {
  prefix: 'far',
  iconName: 'bottle-water',
  icon: [320, 512, [], "e4c5", "M120 0C106.7 0 96 10.7 96 24l0 59.4c-7.6 2.1-14.9 5-21.8 8.9L68 95.7c-27.1 15.1-44 43.7-44 74.8c0 15.9 4.3 30.8 11.9 43.5C28.4 226.2 24 240.6 24 256c0 18 6 34.6 16 48c-10 13.4-16 30-16 48c0 14.6 3.9 28.2 10.7 40C27.9 403.8 24 417.4 24 432c0 44.2 35.8 80 80 80l112 0c44.2 0 80-35.8 80-80c0-14.6-3.9-28.2-10.7-40c6.8-11.8 10.7-25.4 10.7-40c0-18-6-34.6-16-48c10-13.4 16-30 16-48c0-15.4-4.4-29.8-11.9-42c7.6-12.8 11.9-27.6 11.9-43.5c0-31.1-16.8-59.7-44-74.8l-6.2-3.4c-6.9-3.8-14.3-6.8-21.8-8.9L224 24c0-13.3-10.7-24-24-24L120 0zM76.7 239.2c9.4-15.2 9.6-34.3 .5-49.7c-3.3-5.5-5.2-12-5.2-19.1c0-13.6 7.4-26.2 19.3-32.8l6.2-3.4c7.4-4.1 15.6-6.2 24.1-6.2l76.9 0c8.4 0 16.7 2.1 24.1 6.2l6.2 3.4c11.9 6.6 19.3 19.2 19.3 32.8c0 7.1-1.9 13.5-5.2 19.1c-9.1 15.4-8.9 34.5 .5 49.7c3 4.8 4.7 10.5 4.7 16.8c0 7.3-2.4 13.8-6.4 19.2c-12.8 17.1-12.8 40.6 0 57.7c4 5.3 6.4 11.9 6.4 19.2c0 5.9-1.6 11.3-4.3 16c-8.6 14.9-8.6 33.2 0 48.1c2.7 4.7 4.3 10.1 4.3 16c0 17.7-14.3 32-32 32l-112 0c-17.7 0-32-14.3-32-32c0-5.9 1.6-11.3 4.3-16c8.6-14.9 8.6-33.2 0-48.1c-2.7-4.7-4.3-10.1-4.3-16c0-7.3 2.4-13.8 6.4-19.2c12.8-17.1 12.8-40.6 0-57.7c-4-5.3-6.4-11.9-6.4-19.2c0-6.2 1.7-11.9 4.7-16.8zM136 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM112 360c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faCirclePause = {
  prefix: 'far',
  iconName: 'circle-pause',
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faPauseCircle = faCirclePause;
const faGaugeCirclePlus = {
  prefix: 'far',
  iconName: 'gauge-circle-plus',
  icon: [640, 512, [], "e498", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm176 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faFolders = {
  prefix: 'far',
  iconName: 'folders',
  icon: [576, 512, [], "f660", "M512 336l-352 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l117.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8L512 144c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16zM160 384l352 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L394.5 96c-17 0-33.3-6.7-45.3-18.7L322.7 50.7c-12-12-28.3-18.7-45.3-18.7L160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"]
};
const faAngel = {
  prefix: 'far',
  iconName: 'angel',
  icon: [576, 512, [], "f779", "M384 64c0 0 0 .1 0 .2s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6s0-.1 0-.2s0-.1 0-.2s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6s0 .1 0 .2zM256 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM87.6 388.2c5.6-11.1 8.4-23.4 8.4-35.8l0-.9c0-12.4-2.9-24.7-8.4-35.8L69.2 279c-3.4-6.7-5.2-14.4-5.2-22.1c0-27.1 22-48.9 48.2-48.9c12.8 0 25 5.1 34.1 14.1l66.4 66.4c-6.8 7.2-12.7 15.5-17.3 24.7L120 464l-70.3 0 37.9-75.8zM253.8 261.8l-73.6-73.6c-18-18-42.5-28.2-68-28.2C59.1 160 16 203.8 16 256.9c0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3l0 .9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3L96 512l53.7 0 276.7 0 53.7 0 50.7 0c25 0 45.3-20.3 45.3-45.3c0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3l0-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9c-25.5 0-50 10.1-68 28.2l-73.6 73.6C311.4 258 299.8 256 288 256s-23.4 2-34.2 5.8zm109.6 26.7l66.4-66.4c9-9 21.3-14.1 34.1-14.1c26.1 0 48.2 21.8 48.2 48.9c0 7.7-1.8 15.4-5.2 22.1l-18.4 36.7c-5.6 11.1-8.4 23.4-8.4 35.8l0 .9c0 12.4 2.9 24.7 8.4 35.8L526.3 464 456 464 380.6 313.2c-4.6-9.2-10.4-17.5-17.3-24.7zm-25.7 46.2L402.3 464l-228.7 0 64.6-129.3C247.7 315.9 267 304 288 304s40.3 11.9 49.7 30.7z"]
};
const faValueAbsolute = {
  prefix: 'far',
  iconName: 'value-absolute',
  icon: [512, 512, [], "f6a6", "M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24L48 56c0-13.3-10.7-24-24-24zM177 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l79 79-79 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l79-79 79 79c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79-79 79-79c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-79 79-79-79zM512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400z"]
};
const faRabbit = {
  prefix: 'far',
  iconName: 'rabbit',
  icon: [512, 512, [128007], "f708", "M245.7 0c-24.4 0-45.1 17.9-48.5 42.1l-.7 4.9c-7.8 54.3 8.4 108.9 43.5 150.1l0 20.6c-66.8 20.7-119.8 73-141.4 139.4C90.3 353.8 81.4 352 72 352c-39.8 0-72 32.2-72 72s32.2 72 72 72c14.7 0 28.3-4.4 39.7-11.9C127.8 501.3 150.6 512 176 512l32 0 96 0c23.9 0 44.7-13.1 55.7-32.4l5.1 6.8c21.2 28.3 61.3 34 89.6 12.8s34-61.3 12.8-89.6L388 304c46.4-.1 84-37.8 84-84.3c0-25.3-11.4-49.3-31-65.3L404 124.3c-5.6-4.5-11.5-8.6-17.6-12c10.1-24.8 13.6-52.1 9.8-79.4l-.9-6C393.1 11.4 379.9 0 364.3 0c-8.2 0-16.2 3.3-22 9.1l-2 2c-5.8 5.7-11 11.9-15.7 18.3c14.7 21.5 25.1 45.4 30.7 70.4c-8.4-2.1-17-3.4-25.7-3.7c-8.2-29.3-23.8-56.6-46.2-78.8l-3.1-3.1L263.4 31.1l16.8-16.9C271 5.1 258.6 0 245.7 0zM88.7 406.7c-.4 5.7-.7 11.4-.7 17.3c0 5.6 .5 11.1 1.5 16.4C85.1 445.1 78.9 448 72 448c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.5 0 12.4 2.6 16.7 6.7zm156-357.9c.1-.5 .5-.9 1-.9c.3 0 .5 .1 .7 .3l3.1 3.1 16.8-16.9L249.5 51.4c20.4 20.2 33.2 46.2 37.2 73.7c1 6.7 4.7 12.6 10.3 16.4s12.5 5 19 3.5c2.7-.6 5.5-1 8.5-1c17.9 0 35.3 6.2 49.3 17.5l36.9 30.1c8.4 6.9 13.4 17.2 13.4 28.1c0 20-16.2 36.3-36.3 36.3L352 256c-13.3 0-24 10.7-24 24l0 16c0 5.2 1.7 10.2 4.8 14.4l96 128c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-68.6-91.4c-4.2-5.6-10.6-9-17.5-9.5s-13.8 2.1-18.7 7L271 391c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0-32 0c-22.1 0-40-17.9-40-40c0-80.8 57-148.2 133-164.3c11.1-2.4 19-12.1 19-23.5l0-48.3c0-6.1-2.4-12.1-6.6-16.5C251.8 140.1 237.8 96.8 244 53.8l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faToiletPaperSlash = {
  prefix: 'far',
  iconName: 'toilet-paper-slash',
  icon: [640, 512, [], "e072", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L518.1 380.8c14.4-4.3 26.5-12.4 35.9-21.3c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1c0 0 0-.1 0-.1L160 0c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM134 79.8c.3-.7 .7-1.4 1-2.1c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0l259 0c-4.7 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 29.8-1 57-2.7 81.6L134 79.8zM426.5 309c3.4-33.8 5.5-72.6 5.5-117c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144l-35 0-34.5-27zM20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512l285.9 0c22.3 0 45.4-12.1 55.4-36.1c5.4-12.9 12.2-32.1 18.8-58.4l-41.7-32.8c-7.5 35.6-15.8 59.2-21.5 72.8c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2L73.8 464c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-2.6 0-5.1 .1-7.7L66.5 148.4C64.9 162.4 64 177 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6c0 0 0 0 0 .1zM496 240c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z"]
};
const faCircleEuro = {
  prefix: 'far',
  iconName: 'circle-euro',
  icon: [512, 512, [], "e5ce", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128 16l16 0c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L128 240c-8.8 0-16-7.2-16-16s7.2-16 16-16l24.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-26.3 0-49.6 12.6-64.4 32l80.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-95.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2l95.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-81.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.1 0c-54.4 0-101-33.8-119.8-81.5L128 304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faAppleWhole = {
  prefix: 'far',
  iconName: 'apple-whole',
  icon: [448, 512, [127822, 127823, "apple-alt"], "f5d1", "M224 112l16 0c44.2 0 80-35.8 80-80l0-16c0-8.8-7.2-16-16-16L288 0c-44.2 0-80 35.8-80 80l0 16c0 8.8 7.2 16 16 16zM48 288c0-31.7 7.6-62.5 20.4-83.7C80.5 184.3 94.7 176 112 176c17.8 0 43.2 7.4 65.3 16c30 11.7 63.5 11.7 93.5 0c22.1-8.6 47.5-16 65.3-16c17.3 0 31.5 8.3 43.6 28.3C392.4 225.5 400 256.3 400 288c0 54.2-17 100-40.4 131.2c-24 32-51.2 44.8-71.6 44.8c-4.6 0-13.6-1.7-24.9-5.1c-25.4-7.6-52.7-7.6-78.1 0c-11.3 3.4-20.3 5.1-24.9 5.1c-20.4 0-47.6-12.8-71.6-44.8C65 388 48 342.2 48 288zm64-160C35.7 128 0 211.7 0 288C0 416 80 512 160 512c11.9 0 26.5-3.4 38.8-7.1c16.4-4.9 34.1-4.9 50.5 0c12.2 3.7 26.8 7.1 38.8 7.1c80 0 160-96 160-224c0-76.3-35.7-160-112-160c-27.3 0-59.7 10.3-82.7 19.3c-18.8 7.3-39.9 7.3-58.7 0C171.7 138.3 139.3 128 112 128z"]
};
const faAppleAlt = faAppleWhole;
const faKitchenSet = {
  prefix: 'far',
  iconName: 'kitchen-set',
  icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120l66.7 0c3.8-22.7 23.6-40 47.3-40l96 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-96 0c-23.8 0-43.5-17.3-47.3-40L286 168zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 264c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 144c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-144-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0 40 0 0-8zm-40 56l0 144 128 0 0-144-128 0zM32 336c0-8.8 7.2-16 16-16l80 0 16 0 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80zm128 48l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32zM0 488c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24zM400 128l0 32 96 0 0-32-96 0z"]
};
const faDiamondHalf = {
  prefix: 'far',
  iconName: 'diamond-half',
  icon: [512, 512, [], "e5b7", "M227.7 11.7C235.5 3.9 245.8 0 256 0l0 48 0 3.3 0 409.4 0 3.3 0 48c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM208 412.7l0-313.4L51.3 256 208 412.7z"]
};
const faLockKeyhole = {
  prefix: 'far',
  iconName: 'lock-keyhole',
  icon: [448, 512, ["lock-alt"], "f30d", "M224 48c44.2 0 80 35.8 80 80l0 64-160 0 0-64c0-44.2 35.8-80 80-80zM96 128l0 64-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64z"]
};
const faLockAlt = faLockKeyhole;
const faR = {
  prefix: 'far',
  iconName: 'r',
  icon: [320, 512, [114], "52", "M56 32C25.1 32 0 57.1 0 88L0 280 0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 109.9 0L276.5 469.9c7.7 10.8 22.7 13.3 33.5 5.6s13.3-22.7 5.6-33.5L214.5 300.6C274.9 286.7 320 232.6 320 168c0-75.1-60.9-136-136-136L56 32zM176 256L48 256 48 88c0-4.4 3.6-8 8-8l128 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-8 0z"]
};
const faTemperatureQuarter = {
  prefix: 'far',
  iconName: 'temperature-quarter',
  icon: [320, 512, ["temperature-1", "thermometer-1", "thermometer-quarter"], "f2ca", "M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7c0-8.8 7.2-16 16-16s16 7.2 16 16l0 50.7c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature1 = faTemperatureQuarter;
const faThermometer1 = faTemperatureQuarter;
const faThermometerQuarter = faTemperatureQuarter;
const faSquareInfo = {
  prefix: 'far',
  iconName: 'square-info',
  icon: [448, 512, [8505, "info-square"], "f30f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM184 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faInfoSquare = faSquareInfo;
const faWifiSlash = {
  prefix: 'far',
  iconName: 'wifi-slash',
  icon: [640, 512, [], "f6ac", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-267-209.3c47.2 8.4 89.8 30.2 123.8 61.4c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208c-7.2 0-14.3 .3-21.4 .8L169.4 107.5C216.2 89.7 267 80 320 80c107.4 0 205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32c-69.1 0-134.7 14.9-193.9 41.5L38.8 5.1zM76.9 156.6L37.7 125.7c-10.2 7.6-20 15.6-29.5 23.9c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2c11.8-10.4 24.1-20.1 37-29.1zM226.3 274.3L184 241c-23.4 12.1-44.9 27.2-64.1 44.8c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5c21.5-19.7 46.5-35.7 73.9-46.9zM376 424a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
};
const faToiletPaperXmark = {
  prefix: 'far',
  iconName: 'toilet-paper-xmark',
  icon: [512, 512, [], "e5b3", "M48 192c0 43.3 9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3l212.7 0c-3-4.5-5.7-9.3-8.2-14.1C298.5 287.4 288 241.5 288 192s10.5-95.4 28.5-129.9c2.5-4.8 5.3-9.5 8.2-14.1L112 48c-10.9 0-26.6 8.9-41 36.3C57.2 110.7 48 148.7 48 192zM359 84.3c-13.8 26.3-23 64.3-23 107.7s9.2 81.3 23 107.7c14.4 27.5 30.1 36.3 41 36.3s26.6-8.9 41-36.3c13.8-26.3 23-64.3 23-107.7s-9.2-81.3-23-107.7C426.6 56.9 410.9 48 400 48s-26.6 8.9-41 36.3zM464 456l0-104.9c-16.6 19.3-38.1 32.9-64 32.9l-288 0c-37.7 0-66-28.7-83.5-62.1C10.5 287.4 0 241.5 0 192S10.5 96.6 28.5 62.1C46 28.7 74.3 0 112 0L400 0c37.7 0 66 28.7 83.5 62.1C501.5 96.6 512 142.5 512 192l0 264c0 30.9-25.1 56-56 56l-240 0c-30.9 0-56-25.1-56-56l0-40 48 0 0 40c0 4.4 3.6 8 8 8l240 0c4.4 0 8-3.6 8-8zM400 240c-13.3 0-24-21.5-24-48s10.7-48 24-48s24 21.5 24 48s-10.7 48-24 48zM235.3 132.7c6.2 6.2 6.2 16.4 0 22.6L198.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L153.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faHandsHoldingDollar = {
  prefix: 'far',
  iconName: 'hands-holding-dollar',
  icon: [640, 512, ["hands-usd"], "f4c5", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 10.9c-6.9 1.8-13.8 4.5-20.2 8.2c-14.9 8.8-27.9 24.5-27.7 47.4c.1 22.1 13.1 36 26.6 44.1c11.4 6.9 25.6 11.2 36.4 14.4l1.9 .6c12.7 3.8 21.3 6.7 27.1 10.3c4 2.5 4 3.6 4 4.6l0 .2c0 2.3-.5 3.5-.8 4.1c-.4 .7-1.3 1.8-3.2 2.9c-4.1 2.6-11.2 4.4-19.2 4.1c-10.5-.3-20.2-3.6-33.9-8.3c-2.3-.8-4.8-1.6-7.3-2.5c-12.6-4.2-26.2 2.6-30.4 15.2s2.6 26.2 15.2 30.4c1.9 .6 3.9 1.3 6 2c7.4 2.6 16.2 5.6 25.6 7.8l0 11.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-10.6c7.4-1.8 14.6-4.7 21.3-8.8c15.3-9.5 27-25.9 26.7-48.5c-.3-22-12.8-36.3-26.4-44.9c-12-7.5-26.8-12-37.9-15.3c0 0 0 0 0 0l-.9-.3c-12.9-3.9-21.6-6.6-27.4-10.1c-2.4-1.5-3.2-2.4-3.3-2.6c0-.1 0-.3 0-.6c0-1.6 .4-2.3 .7-2.8c.4-.6 1.4-1.8 3.5-3c4.7-2.8 12-4.5 19.4-4.4c9.1 .1 19.3 2.1 30.2 5c12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4c-5.6-1.5-11.7-3-18.2-4.2L344 24zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z"]
};
const faHandsUsd = faHandsHoldingDollar;
const faCube = {
  prefix: 'far',
  iconName: 'cube',
  icon: [512, 512, [], "f1b2", "M258.8 50.7c-1.8-.7-3.8-.7-5.7 0L63.6 122.6 256 198.2l192.4-75.6L258.8 50.7zM48 377.9c0 3.3 2.1 6.3 5.2 7.5L232 453.2l0-212.9L48 168.1l0 209.8zm232 75.3l178.8-67.8c3.1-1.2 5.2-4.2 5.2-7.5l0-209.8L280 240.4l0 212.9zM236.1 5.9c12.8-4.9 26.9-4.9 39.7 0l200 75.9C497.6 90 512 110.8 512 134.1l0 243.8c0 23.3-14.4 44.1-36.1 52.4l-200 75.9c-12.8 4.9-26.9 4.9-39.7 0l-200-75.9C14.4 422 0 401.2 0 377.9L0 134.1C0 110.8 14.4 90 36.1 81.7l200-75.9z"]
};
const faArrowDownTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-down-triangle-square',
  icon: [576, 512, ["sort-shapes-down"], "f888", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM416 32c-9.9 0-19.1 5.2-24.2 13.7L307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9c0 13.8 11.2 25.1 25.1 25.1l173.9 0c13.8 0 25.1-11.2 25.1-25.1c0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32zM368 432l0-96 96 0 0 96-96 0zM416 98.6L462.4 176l-92.8 0L416 98.6zM320 432c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96z"]
};
const faSortShapesDown = faArrowDownTriangleSquare;
const faBitcoinSign = {
  prefix: 'far',
  iconName: 'bitcoin-sign',
  icon: [320, 512, [], "e0b4", "M64 24C64 10.7 74.7 0 88 0s24 10.7 24 24l0 40 32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40.7c54 6 96 51.8 96 107.3c0 27.5-10.3 52.6-27.2 71.6C295.9 261.5 320 297.9 320 340c0 59.6-48.4 108-108 108l-20 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-22.3 0C18.7 448 0 429.3 0 406.3L0 280l0-6.3L0 232 0 101.6C0 80.8 16.8 64 37.6 64L64 64l0-40zM48 232l132 0c33.1 0 60-26.9 60-60s-26.9-60-60-60L48 112l0 120zm132 48L48 280l0 120 164 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0z"]
};
const faShutters = {
  prefix: 'far',
  iconName: 'shutters',
  icon: [512, 512, [], "e449", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM13.7 128L.4 198c-.3 1.4-.4 2.7-.4 4.1C0 214.2 9.8 224 21.9 224l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 176l9.1-48-48.9 0zM.4 326c-.3 1.4-.4 2.7-.4 4.1C0 342.2 9.8 352 21.9 352l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 304l9.1-48-48.9 0L.4 326zm0 128c-.3 1.4-.4 2.7-.4 4.1C0 470.2 9.8 480 21.9 480l468.1 0c12.1 0 21.9-9.8 21.9-21.9c0-1.4-.1-2.8-.4-4.1l-13.3-70-48.9 0 9.1 48L53.4 432l9.1-48-48.9 0L.4 454z"]
};
const faShieldDog = {
  prefix: 'far',
  iconName: 'shield-dog',
  icon: [512, 512, [], "e573", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160.9 270.2l-15 30c-1.2 2.5-1.9 5.2-1.9 8c0 7.1 4.3 13.6 10.8 16.4l98.7 42.3c1.7 .7 3.4 1.1 5.2 1.1c7.3 0 13.3-5.9 13.3-13.3l0-50.7 48 0c44.2 0 80-35.8 80-80l0-32c0-8.8-7.2-16-16-16l-64 0-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7L240 144l0 64c0 35.3-28.7 64-64 64c-5.2 0-10.3-.6-15.1-1.8zM160 144c-8.8 0-16 7.2-16 16l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 0-32-8 0-40 0zm96 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faSolarPanel = {
  prefix: 'far',
  iconName: 'solar-panel',
  icon: [640, 512, [], "f5ba", "M114.5 48c-3.8 0-7.1 2.7-7.9 6.5L86.5 160l116.6 0L214.3 48l-99.8 0zm83.8 160L77.4 208 54.8 326.5c-.9 4.9 2.8 9.5 7.9 9.5l122.8 0 12.8-128zm48.2 0L233.7 336l172.6 0L393.5 208l-147 0zm142.2-48L377.5 48l-115 0L251.3 160l137.4 0zm53 48l12.8 128 122.8 0c5 0 8.8-4.6 7.9-9.5L562.6 208l-120.9 0zm111.8-48L533.4 54.5c-.7-3.8-4-6.5-7.9-6.5l-99.8 0 11.2 112 116.6 0zM59.5 45.5C64.5 19.1 87.6 0 114.5 0l411 0c26.9 0 50 19.1 55 45.5l51.8 272c6.6 34.5-19.9 66.5-55 66.5L344 384l0 80 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-80L62.7 384c-35.1 0-61.6-32-55-66.5l51.8-272z"]
};
const faLockOpen = {
  prefix: 'far',
  iconName: 'lock-open',
  icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72C560 57.3 502.7 0 432 0S304 57.3 304 128l0 64L64 192c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-32 0 0-64zM64 240l320 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16z"]
};
const faTableTree = {
  prefix: 'far',
  iconName: 'table-tree',
  icon: [512, 512, [], "e293", "M48 160l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256-336 0 0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-5.6 0-11-1-16-2.7l0 50.7c0 8.8 7.2 16 16 16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-26.5 0-48-21.5-48-48l0-96 0-64-48 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 240c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-32zm80 80l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
};
const faHouseChimneyHeart = {
  prefix: 'far',
  iconName: 'house-chimney-heart',
  icon: [576, 512, [], "e1b2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM237.3 208c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3c0-33.8 27.4-61.3 61.3-61.3z"]
};
const faTally3 = {
  prefix: 'far',
  iconName: 'tally-3',
  icon: [640, 512, [], "e296", "M128 40c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24zm128 0c13.3 0 24 10.7 24 24l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24zM408 64l0 384c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-384c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faElevator = {
  prefix: 'far',
  iconName: 'elevator',
  icon: [512, 512, [], "e16d", "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9L80 96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zm224 86.6l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9L432 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0zM64 176c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 176zM0 192c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zM272 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32zM128 352l64 0c26.5 0 48 21.5 48 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32c0-26.5 21.5-48 48-48zm176-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faMoneyBillTransfer = {
  prefix: 'far',
  iconName: 'money-bill-transfer',
  icon: [640, 512, [], "e528", "M558.1 64L535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-64.6 0s0 0 0 0L160 112l0 16c0 35.3-28.7 64-64 64l-16 0 0 93.5L50.7 314.7 32 333.5 32 128c0-35.3 28.7-64 64-64l287.6 0 .4 0 174.1 0zM560 320l0-93.5 29.3-29.3L608 178.5 608 384c0 35.3-28.7 64-64 64l-397.5 0s0 0 0 0l-64.6 0 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23L256 400c.1 0 .3 0 .4 0L480 400l0-16c0-35.3 28.7-64 64-64l16 0zM320 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faMoneyBillTrendUp = {
  prefix: 'far',
  iconName: 'money-bill-trend-up',
  icon: [512, 512, [], "e529", "M320 24c0 13.3 10.7 24 24 24l54.1 0L286.7 159.3 191.6 77.8c-9-7.7-22.4-7.7-31.3 .1l-120 104c-10 8.7-11.1 23.8-2.4 33.9s23.8 11.1 33.9 2.4l104.4-90.5 96.3 82.5c9.5 8.2 23.7 7.6 32.6-1.3l127-127 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L344 0c-13.3 0-24 10.7-24 24zM103.5 304l305 0c3.6 29 26.6 51.9 55.5 55.5l0 49c-29 3.6-51.9 26.6-55.5 55.5l-305 0c-3.6-29-26.6-51.9-55.5-55.5l0-49c28.9-3.6 51.9-26.6 55.5-55.5zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faHouseFloodWaterCircleArrowRight = {
  prefix: 'far',
  iconName: 'house-flood-water-circle-arrow-right',
  icon: [640, 512, [], "e50f", "M316.1 107.1c-3.5-16.5-9.4-32.2-17.2-46.7L378.1 4.4c8.3-5.9 19.4-5.9 27.7 0l192 136c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7l-2.1-1.5 0 103.3c-5.3-2.9-10.3-6.2-14.8-9.9c-9.7-8.2-21.3-13.1-33.2-14.6l0-112.9L392 53.4l-75.9 53.7zM143.9 318.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM112 430.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zM0 144a144 144 0 1 1 288 0A144 144 0 1 1 0 144zM140.7 76.7c-6.2 6.2-6.2 16.4 0 22.6L169.4 128 80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
const faSquarePollHorizontal = {
  prefix: 'far',
  iconName: 'square-poll-horizontal',
  icon: [448, 512, ["poll-h"], "f682", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM256 160c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24zm72 72c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0zM192 352c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z"]
};
const faPollH = faSquarePollHorizontal;
const faCircle = {
  prefix: 'far',
  iconName: 'circle',
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faLeftToBracket = {
  prefix: 'far',
  iconName: 'left-to-bracket',
  icon: [512, 512, [], "e66d", "M320 365.8L210 256 320 146.2l0 53.8c0 13.3 10.7 24 24 24l120 0 0 64-120 0c-13.3 0-24 10.7-24 24l0 53.8zM160 256c0 11.5 4.6 22.5 12.7 30.6L288.8 402.4c8.7 8.7 20.5 13.6 32.8 13.6c25.6 0 46.4-20.8 46.4-46.4l0-33.6 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-33.6c0-25.6-20.8-46.4-46.4-46.4c-12.3 0-24.1 4.9-32.8 13.6L172.7 225.4c-8.1 8.1-12.7 19.1-12.7 30.6zm8 176l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
const faCartCircleExclamation = {
  prefix: 'far',
  iconName: 'cart-circle-exclamation',
  icon: [640, 512, [], "e3f2", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faSword = {
  prefix: 'far',
  iconName: 'sword',
  icon: [512, 512, [128481], "f71c", "M507.3 4.7C503.7 1 498.5-.6 493.4 .2L417.6 12.8c-16.4 2.7-31.6 10.6-43.4 22.3L166.6 242.7l33.9 33.9L408.1 69.1c4.7-4.7 10.8-7.8 17.4-8.9l31.6-5.3-5.3 31.6c-1.1 6.6-4.2 12.7-8.9 17.4L235.3 311.4l33.9 33.9L476.8 137.8c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zM84.7 228.7l-16 16c-5.4 5.4-6.2 13.8-2 20.2l53.1 79.6c2.1 3.2 1.7 7.4-1 10.1L79.2 394.2c-2.1 2.1-5.3 2.9-8.2 1.9L37.1 384.8c-5.7-1.9-12.1-.4-16.4 3.9l-16 16c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l16-16c4.3-4.3 5.8-10.6 3.9-16.4L115.9 441c-1-2.9-.2-6 1.9-8.2l39.6-39.6c2.7-2.7 6.9-3.1 10.1-1l79.6 53.1c6.3 4.2 14.8 3.4 20.2-2l16-16c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0z"]
};
const faBackwardFast = {
  prefix: 'far',
  iconName: 'backward-fast',
  icon: [512, 512, [9198, "fast-backward"], "f049", "M16 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136.1L238.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8l0-130.3L462.6 440.6c5.4 4.8 12.4 7.4 19.6 7.4c16.5 0 29.8-13.3 29.8-29.8l0-324.4C512 77.3 498.7 64 482.2 64c-7.2 0-14.2 2.6-19.6 7.4L288 224.1l0-130.3C288 77.3 274.7 64 258.2 64c-7.2 0-14.2 2.6-19.6 7.4L64 224.1 64 88c0-13.3-10.7-24-24-24S16 74.7 16 88l0 336zM464 133.9l0 244.2L324.4 256 464 133.9zM240 378.1L100.4 256 240 133.9l0 244.2z"]
};
const faFastBackward = faBackwardFast;
const faRecycle = {
  prefix: 'far',
  iconName: 'recycle',
  icon: [512, 512, [9842, 9850, 9851], "f1b8", "M181.5 40.9C197.7 15.3 226 0 256 0s58.3 15.3 74.5 40.9L392.8 139l6.6-31.8c2.7-13 15.4-21.3 28.3-18.7s21.3 15.4 18.7 28.3l-19.4 94.4c-1.4 6.7-5.6 12.5-11.5 15.9s-13.1 4.2-19.6 2l-91.4-30.4c-12.6-4.2-19.4-17.8-15.2-30.3s17.8-19.4 30.3-15.2l32.2 10.7L290 66.6C282.7 55.1 269.8 48 256 48s-26.7 7.1-34 18.6l-21.5 33.9c-7 11-21.4 14.4-32.6 7.7c-11.6-6.9-15.1-22-7.9-33.4l21.5-33.9zM439 255.5c11.2-6.7 25.6-3.3 32.6 7.7l26.8 42.2c8.8 13.9 13.5 30 13.6 46.4c.3 48.6-39 88.2-87.6 88.2l-137.2 0 24.8 22c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2s7.9 25.1-2 33.9L287.1 392l137.3 0c22 0 39.8-17.9 39.6-39.9c0-7.4-2.2-14.7-6.2-21l-26.8-42.2c-7.2-11.4-3.7-26.5 7.9-33.4zm-311.6 3.7l-6.7-32.8L54.2 331.1c-4 6.3-6.1 13.6-6.2 21c-.1 22 17.7 39.9 39.6 39.9l48.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48.4 0C39 440-.3 400.5 0 351.9c.1-16.4 4.8-32.5 13.6-46.4L78.8 202.8 47.6 213.1c-12.6 4.2-26.2-2.6-30.3-15.2s2.6-26.2 15.2-30.3l91.4-30.4c6.5-2.2 13.6-1.4 19.6 2s10.1 9.2 11.5 15.9l19.4 94.4c2.7 13-5.7 25.7-18.7 28.3s-25.7-5.7-28.3-18.7z"]
};
const faUserAstronaut = {
  prefix: 'far',
  iconName: 'user-astronaut',
  icon: [448, 512, [], "f4fb", "M224 48a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm181.2 80.4C379 53.6 307.8 0 224 0S69 53.6 42.8 128.4C27.6 130.9 16 144.1 16 160l0 64c0 15.9 11.6 29.1 26.8 31.6c9.7 27.6 25.5 52.4 45.8 72.6C35.6 359.1 0 416.5 0 482.3C0 498.7 13.3 512 29.7 512L160 512l0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 226.3 0c16.4 0 29.7-13.3 29.7-29.7c0-65.8-35.6-123.2-88.6-154.1c20.3-20.2 36.2-45 45.8-72.6c15.2-2.5 26.8-15.7 26.8-31.6l0-64c0-15.9-11.6-29.1-26.8-31.6zM319.7 358.5c44.5 18 77.1 59.3 82.6 108.7l-66.4 0 0-19.2c0-17.7-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32l0 19.2-66.4 0c5.6-49.5 38.1-90.7 82.6-108.7C156.5 374.7 189.1 384 224 384s67.5-9.3 95.7-25.5zM160 128c-26.5 0-48 21.5-48 48l0 16c0 53 43 96 96 96l32 0c53 0 96-43 96-96l0-16c0-26.5-21.5-48-48-48l-128 0zm39.3 45.5l6 21.2 21.2 6c3.3 .9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5zM256 464a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faInterrobang = {
  prefix: 'far',
  iconName: 'interrobang',
  icon: [320, 512, [8253], "e5ba", "M144 80c-44.2 0-80 35.8-80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 4.6c0 40.1-20.1 77.6-53.4 99.8l-52.3 34.9c-8.9 5.9-14.2 15.9-14.2 26.6l0 2 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16 0-2 0-158c0-13.3 10.7-24 24-24s24 10.7 24 24l0 83.2 39.9-26.6c20-13.4 32.1-35.8 32.1-59.9l0-4.6c0-44.2-35.8-80-80-80l-32 0zM128 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faPlaneSlash = {
  prefix: 'far',
  iconName: 'plane-slash',
  icon: [640, 512, [], "e069", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L461 336l19 0c20.6 0 49.8-5.8 74.4-16.5c12.4-5.4 25-12.7 34.9-22.4c10-9.8 18.7-23.6 18.7-41.1c0-17.4-8.8-31.1-18.7-40.7c-9.9-9.6-22.4-16.9-34.8-22.4C530 182.1 500.7 176 480 176l-66.2 0L317.7 25.8C307.4 9.7 289.6 0 270.5 0L229.9 0c-27.1 0-46.4 26.4-38.1 52.2l31.1 97.2L38.8 5.1zM288.3 200.7c.1-2.7-.3-5.4-1.1-8L240.9 48l29.6 0c2.7 0 5.3 1.4 6.7 3.7l20.2-12.9L277.2 51.7 380.4 212.9c4.4 6.9 12 11.1 20.2 11.1l79.4 0c13.4 0 36.1 4.4 55.1 12.8c9.4 4.2 16.4 8.7 20.7 12.9c4.2 4.1 4.2 6.1 4.2 6.3c0 0 0 0 0 0c0 .6-.1 2.8-4.2 6.8c-4.3 4.2-11.2 8.6-20.6 12.7C516.3 283.8 493.6 288 480 288l-79.4 0c-.3 0-.6 0-.9 0L288.3 200.7zm88.9 192.5l-37.9-29.8-62.1 97c-1.5 2.3-4 3.7-6.7 3.7l-29.6 0 45.5-142.3L243.7 288 168 288c-7.6 0-14.7 3.6-19.2 9.6L108 352l-24.4 0 27.4-88.9c1.4-4.6 1.4-9.5 0-14.1L84.3 162.4 39.6 127.2c-4.8 6.3-7.6 14.2-7.6 22.7c0 3.8 .6 7.5 1.7 11.1c0 0 0 0 0 0L62.9 256 33.7 350.9s0 0 0 0c-1.1 3.6-1.7 7.4-1.7 11.1C32 383 49 400 69.9 400l42.1 0c12.6 0 24.4-5.9 32-16l-19.2-14.4L144 384l36-48 51.4 0L191.8 459.8c-8.3 25.8 11 52.2 38.1 52.2l40.6 0c19.1 0 36.9-9.7 47.2-25.8l59.5-93z"]
};
const faCircleDashed = {
  prefix: 'far',
  iconName: 'circle-dashed',
  icon: [512, 512, [], "e105", "M27.7 232c12.3 0 22.5-9.3 25.2-21.3c5.3-23.9 14.7-46.2 27.4-66.2c6.6-10.4 6-24.2-2.8-32.9c-10.1-10.1-26.8-9.4-34.7 2.5c-18.2 27.3-31.3 58.3-37.9 91.6c-2.8 14 8.5 26.3 22.8 26.3zM144.5 80.4c20-12.7 42.3-22.1 66.2-27.4c12-2.7 21.3-12.9 21.3-25.2c0-14.3-12.3-25.6-26.3-22.8c-33.3 6.6-64.3 19.7-91.6 37.9c-11.9 7.9-12.6 24.6-2.5 34.7c8.7 8.7 22.5 9.4 32.9 2.8zM280 484.3c0 14.3 12.3 25.6 26.3 22.8c33.3-6.6 64.3-19.7 91.6-37.9c11.9-7.9 12.6-24.6 2.5-34.7c-8.7-8.7-22.5-9.4-32.9-2.8c-20 12.7-42.3 22.1-66.2 27.4c-12 2.7-21.3 12.9-21.3 25.2zM431.6 367.5c-6.6 10.4-6 24.2 2.8 32.9c10.1 10.1 26.8 9.4 34.7-2.5c18.2-27.3 31.3-58.3 37.9-91.6c2.8-14-8.5-26.3-22.8-26.3c-12.3 0-22.5 9.3-25.2 21.3c-5.3 23.9-14.7 46.2-27.4 66.2zm-320 66.8c-10.1 10.1-9.4 26.8 2.5 34.7c27.3 18.2 58.3 31.3 91.6 37.9c14 2.8 26.3-8.5 26.3-22.8c0-12.3-9.3-22.5-21.3-25.2c-23.9-5.3-46.2-14.7-66.2-27.4c-10.4-6.6-24.2-6-32.9 2.8zM42.9 397.9c7.9 11.9 24.6 12.6 34.7 2.5c8.7-8.7 9.4-22.5 2.8-32.9c-12.7-20-22.1-42.3-27.4-66.2c-2.7-12-12.9-21.3-25.2-21.3c-14.3 0-25.6 12.3-22.8 26.3c6.6 33.3 19.7 64.3 37.9 91.6zM400.4 77.6c10.1-10.1 9.4-26.8-2.5-34.7c-27.3-18.2-58.3-31.3-91.6-37.9c-14-2.8-26.3 8.5-26.3 22.8c0 12.3 9.3 22.5 21.3 25.2c23.9 5.3 46.2 14.7 66.2 27.4c10.4 6.6 24.2 6 32.9-2.8zm31.2 66.8c12.7 20 22.1 42.3 27.4 66.2c2.7 12 12.9 21.3 25.2 21.3c14.3 0 25.6-12.3 22.8-26.3c-6.6-33.3-19.7-64.3-37.9-91.6c-7.9-11.9-24.6-12.6-34.7-2.5c-8.7 8.7-9.4 22.5-2.8 32.9z"]
};
const faTrademark = {
  prefix: 'far',
  iconName: 'trademark',
  icon: [640, 512, [8482], "f25c", "M331.4 105.8c-6.1-8.4-17-11.9-26.8-8.7s-16.6 12.4-16.6 22.8l0 272c0 13.3 10.7 24 24 24s24-10.7 24-24l0-198.5L444.6 342.2c4.5 6.2 11.7 9.8 19.4 9.8s14.9-3.7 19.4-9.8L592 193.5 592 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-10.4-6.7-19.6-16.6-22.8s-20.7 .3-26.8 8.7L464 287.3 331.4 105.8zM0 120c0 13.3 10.7 24 24 24l80 0 0 248c0 13.3 10.7 24 24 24s24-10.7 24-24l0-248 80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 96C10.7 96 0 106.7 0 120z"]
};
const faBasketball = {
  prefix: 'far',
  iconName: 'basketball',
  icon: [512, 512, [127936, "basketball-ball"], "f434", "M304 458.4c0-.8 0-1.6 0-2.4c0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zM256.2 464l-.2 0c-48.8 0-93.7-16.8-129.1-44.9L256 289.9l42.6 42.6C271.9 366.6 256 409.4 256 456c0 2.7 .1 5.3 .2 8zm76.4-165.4L289.9 256 419.1 126.9C447.2 162.3 464 207.2 464 256l0 .2c-2.7-.1-5.3-.2-8-.2c-46.6 0-89.4 15.9-123.4 42.6zM458.4 304c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9c.8 0 1.6 0 2.4 0zM256 222.1l-42.6-42.6C240.1 145.4 256 102.6 256 56c0-2.7-.1-5.3-.2-8l.2 0c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9L126.9 92.9c23.5-18.6 51-32.2 81.1-39.4c0 .8 0 1.6 0 2.4c0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9C120.1 197.3 89.3 208 56 208c-.8 0-1.6 0-2.4 0c7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7 .1 5.3 .2 8 .2c46.6 0 89.4-15.9 123.4-42.6L222.1 256 92.9 385.1C64.8 349.7 48 304.8 48 256l0-.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faBasketballBall = faBasketball;
const faForkKnife = {
  prefix: 'far',
  iconName: 'fork-knife',
  icon: [576, 512, ["utensils-alt"], "f2e6", "M467.2 9.6c8 10.6 5.8 25.6-4.8 33.6l-122.7 92c-2.6 2-5.1 4.1-7.4 6.4l-1.9 1.9C318.6 155.3 312 171.3 312 188s6.6 32.7 18.4 44.5l6.5 6.5c0 0 0 0 0 0s0 0 0 0l6.5 6.5C355.3 257.4 371.3 264 388 264s32.7-6.6 44.5-18.4l1.9-1.9c2.3-2.3 4.5-4.8 6.4-7.4l92-122.7c8-10.6 23-12.8 33.6-4.8s12.8 23 4.8 33.6l-92 122.7c-3.3 4.4-7 8.6-10.9 12.6l-1.9 1.9c-20.8 20.8-49 32.5-78.4 32.5c-24.5 0-48.1-8.1-67.3-22.8L105 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L286.8 255.3C272.1 236.1 264 212.4 264 188c0-29.4 11.7-57.6 32.5-78.4l1.9-1.9c3.9-3.9 8.1-7.6 12.6-10.9l122.7-92c10.6-8 25.6-5.8 33.6 4.8zM521 55c9.4 9.4 9.4 24.6 0 33.9L405 205c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L487 55c9.4-9.4 24.6-9.4 33.9 0zM382.2 343.9l123 127.4c9.2 9.5 8.9 24.7-.6 33.9s-24.7 8.9-33.9-.6L313.4 341.8l12.1-12.1c17.6 8.5 36.8 13.4 56.7 14.2zM235.6 261.2L48 66.8l0 16.8c0 52.8 20.9 103.5 58.2 141l70.2 70.6c4.6 4.7 10.3 7.6 16.3 8.8l-36.3 36.3c-5-3.2-9.7-6.9-14-11.3L72.1 258.5C25.9 212 0 149.1 0 83.6L0 35.2C0 15.8 15.8 0 35.2 0c9.6 0 18.7 3.9 25.3 10.8L232 188.3c0 21.7 5 42.9 14.4 62.1l-10.7 10.7z"]
};
const faUtensilsAlt = faForkKnife;
const faSatelliteDish = {
  prefix: 'far',
  iconName: 'satellite-dish',
  icon: [512, 512, [128225], "f7c0", "M192 24c0 13.3 10.7 24 24 24c137 0 248 111 248 248c0 13.3 10.7 24 24 24s24-10.7 24-24C512 132.5 379.5 0 216 0c-13.3 0-24 10.7-24 24zm24 80c-13.3 0-24 10.7-24 24s10.7 24 24 24c79.5 0 144 64.5 144 144c0 13.3 10.7 24 24 24s24-10.7 24-24c0-106-86-192-192-192zm-7 233l40-40c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-40 40L71 199c-13.5-13.5-35.9-12.3-45.1 4.4C9.4 233.2 0 267.5 0 304C0 418.9 93.1 512 208 512c36.5 0 70.8-9.4 100.6-25.9c16.7-9.2 17.8-31.6 4.4-45.1L209 337zM48 304c0-18.1 3-35.5 8.5-51.6L259.6 455.5C243.5 461 226.1 464 208 464c-88.4 0-160-71.6-160-160z"]
};
const faBadgeCheck = {
  prefix: 'far',
  iconName: 'badge-check',
  icon: [512, 512, [], "f336", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
};
const faCircleUp = {
  prefix: 'far',
  iconName: 'circle-up',
  icon: [512, 512, [61467, "arrow-alt-circle-up"], "f35b", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM151.2 217.4c-4.6 4.2-7.2 10.1-7.2 16.4c0 12.3 10 22.3 22.3 22.3l41.7 0 0 96c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-96 41.7 0c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.2-16.4l-91-84c-3.8-3.5-8.7-5.4-13.9-5.4s-10.1 1.9-13.9 5.4l-91 84z"]
};
const faArrowAltCircleUp = faCircleUp;
const faSlider = {
  prefix: 'far',
  iconName: 'slider',
  icon: [512, 512, [], "e252", "M352 144c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l32 0zM320 96c-35.3 0-64 28.7-64 64l0 192c0 35.3 28.7 64 64 64l32 0c35.3 0 64-28.7 64-64l0-72 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-72c0-35.3-28.7-64-64-64l-32 0zM0 256c0 13.3 10.7 24 24 24l200 0 0-48L24 232c-13.3 0-24 10.7-24 24z"]
};
const faMobileScreenButton = {
  prefix: 'far',
  iconName: 'mobile-screen-button',
  icon: [384, 512, ["mobile-alt"], "f3cd", "M64 448c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L64 368l0 80zm0-128l256 0 0-256c0-8.8-7.2-16-16-16L80 48c-8.8 0-16 7.2-16 16l0 256zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faMobileAlt = faMobileScreenButton;
const faClockOneThirty = {
  prefix: 'far',
  iconName: 'clock-one-thirty',
  icon: [512, 512, [], "e34f", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-128.7 60-90c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-64 96c-2.6 3.9-4 8.6-4 13.3l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faInboxOut = {
  prefix: 'far',
  iconName: 'inbox-out',
  icon: [512, 512, [128228, "inbox-arrow-up"], "f311", "M280 288c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-206.1-63 63c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L377 111c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-63-63L280 288zM149.1 405.5L130.3 368 48 368l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 421.7 338.2 432 320 432l-128 0c-18.2 0-34.8-10.3-42.9-26.5zm24.2-58.9L192 384l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l82.3 0c18.2 0 34.8 10.3 42.9 26.5z"]
};
const faInboxArrowUp = faInboxOut;
const faCloudSlash = {
  prefix: 'far',
  iconName: 'cloud-slash',
  icon: [640, 512, [], "e137", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-33.4-26.2C623.6 418.1 640 383 640 344c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32c-48.5 0-92.1 20.5-122.8 53.4L38.8 5.1zm140.4 110C200.9 93.4 230.9 80 264 80c36.3 0 68.8 16.1 90.9 41.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 27.8-12.9 52.6-33.1 68.8L179.2 115.1zM426.5 432L144 432c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c16.4-5.8 28.2-19.9 31.2-36.6L98.1 173.3C96.7 182 96 190.9 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 23.4 0-60.9-48z"]
};
const faVolumeHigh = {
  prefix: 'far',
  iconName: 'volume-high',
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256s-41.5-170.8-106.4-223.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.9 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32z"]
};
const faVolumeUp = faVolumeHigh;
const faUsersRays = {
  prefix: 'far',
  iconName: 'users-rays',
  icon: [640, 512, [], "e593", "M7 7C16.4-2.3 31.6-2.3 41 7l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM633 7c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L599 7c9.4-9.4 24.6-9.4 33.9 0zM41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505zm592 0c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2l32 0 32 0c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32l-64 0c-20.9 0-38.7 13.4-45.3 32l154.5 0zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3l69.3 0c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8l-46.6 0C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2l69.3 0c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7l-46.6 0zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faWallet = {
  prefix: 'far',
  iconName: 'wallet',
  icon: [512, 512, [], "f555", "M88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88l0-176c0-48.6-39.4-88-88-88l-304 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c22.1 0 40 17.9 40 40l0 176c0 22.1-17.9 40-40 40L88 432c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32zM384 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faOctagonCheck = {
  prefix: 'far',
  iconName: 'octagon-check',
  icon: [512, 512, [], "e426", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faFlatbreadStuffed = {
  prefix: 'far',
  iconName: 'flatbread-stuffed',
  icon: [576, 512, [129369], "e40c", "M272.2 4c-12.8-7-28.7-4.5-38.7 6.1L186.6 59.9c-4.6 4.9-10.5 8.2-17.1 9.5L102.4 82.7c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2L23.1 252.1c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l55.9-55.9C121.1 316.3 112 291.2 112 264c0-66.3 53.7-120 120-120c27.2 0 52.3 9.1 72.5 24.3L424.4 48.4c4.6-4.6 10-8.3 15.8-11.1c-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6 .8-13.3-.5-19.2-3.7L272.2 4zM159.3 313.5L281.5 191.3C267.4 181.6 250.4 176 232 176c-48.6 0-88 39.4-88 88c0 18.4 5.6 35.4 15.3 49.5zM275 243l-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272c0-64.7-24.9-121.2-61.2-166.9c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86zM395 191l43-43 23-23c21.8 34 35 72.7 35 115c0 123.7-100.3 224-224 224c-42.4 0-81-13.2-115-35l66-66 86-86 86-86zM296 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faClipboardCheck = {
  prefix: 'far',
  iconName: 'clipboard-check',
  icon: [384, 512, [], "f46c", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
};
const faCartCirclePlus = {
  prefix: 'far',
  iconName: 'cart-circle-plus',
  icon: [640, 512, [], "e3f3", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm208 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16z"]
};
const faTruckClock = {
  prefix: 'far',
  iconName: 'truck-clock',
  icon: [640, 512, ["shipping-timed"], "f48c", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 192a112 112 0 1 1 224 0A112 112 0 1 1 96 192zm112-64c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32c0-8.8-7.2-16-16-16z"]
};
const faShippingTimed = faTruckClock;
const faPool8Ball = {
  prefix: 'far',
  iconName: 'pool-8-ball',
  icon: [512, 512, [], "e3c5", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm120-56a136 136 0 1 1 272 0 136 136 0 1 1 -272 0zm173.3-25.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8zM240 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faFileAudio = {
  prefix: 'far',
  iconName: 'file-audio',
  icon: [384, 512, [], "f1c7", "M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 272l0 128c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376 112 376c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16l17.4 0 35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"]
};
const faTurnDownLeft = {
  prefix: 'far',
  iconName: 'turn-down-left',
  icon: [512, 512, [], "e331", "M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6c25.6 0 46.3-20.7 46.3-46.3l0-41.7 144 0c88.4 0 160-71.6 160-160l0-112c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-152 0 0-41.7c0-25.6-20.7-46.3-46.3-46.3c-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93l0 61.5c0 13.3 10.7 24 24 24l176 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 112c0 61.9-50.1 112-112 112l-168 0c-13.3 0-24 10.7-24 24l0 61.5L57 288 160 178.5z"]
};
const faLockHashtag = {
  prefix: 'far',
  iconName: 'lock-hashtag',
  icon: [448, 512, [], "e423", "M144 128l0 32 160 0 0-32c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 160l0-32C96 57.3 153.3 0 224 0s128 57.3 128 128l0 32 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l32 0zm0 48l-32 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-32 0-48 0-160 0-48 0zm88 16c13.3 0 24 10.7 24 24l0 24 32 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-32 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-24c0-13.3 10.7-24 24-24zm24 128l32 0 0-32-32 0 0 32z"]
};
const faChartRadar = {
  prefix: 'far',
  iconName: 'chart-radar',
  icon: [512, 512, [], "e0e7", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12l-176.6 0c-8.6 0-16.5-4.6-20.8-12L58.6 268zm231.5-87.2c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zM202 271.9l47.5-63.4 31.7 79.2L202 271.9z"]
};
const faStaff = {
  prefix: 'far',
  iconName: 'staff',
  icon: [512, 512, [], "f71b", "M238.8 57.5C256.4 22.3 292.4 0 331.8 0L408 0c57.4 0 104 46.6 104 104l0 103.9c0 42.8-26.1 80.8-65.1 96.5l-17.3 30.7c-4.3 7.7-14.1 10.4-21.8 6.1l-29.4-16.6L253.7 360.1 122.9 490.9C94.8 519 49.2 519 21.1 490.9l16.8-16.8L21.1 490.9C-7 462.8-7 417.2 21.1 389.1L96 314.2 96 288c0-8.8 7.2-16 16-16l26.2 0 21-21c12.5-12.5 28-21.6 45-26.5L368 177.7l0-33.7-12.1 0c-19.8 29.8-59.2 40.8-92.1 24.4c-35.6-17.8-50-61-32.2-96.6l7.2-14.3zm93-9.5c-21.2 0-40.6 12-50.1 31l-7.2 14.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l2.7-5.5c4.1-8.1 12.4-13.3 21.5-13.3L392 96c13.3 0 24 10.7 24 24l0 75.8c0 10.7-7.1 20.1-17.4 23.1L217.4 270.6c-9.2 2.6-17.5 7.5-24.2 14.2L55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L224.2 321.8c2.9-2.9 6.5-5 10.4-6.1l188.8-54c24-6.9 40.6-28.8 40.6-53.8L464 104c0-30.9-25.1-56-56-56l-76.2 0z"]
};
const faBurger = {
  prefix: 'far',
  iconName: 'burger',
  icon: [512, 512, ["hamburger"], "f805", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zM16 288c0-17.7 14.3-32 32-32l416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 320c-17.7 0-32-14.3-32-32z"]
};
const faHamburger = faBurger;
const faUtilityPole = {
  prefix: 'far',
  iconName: 'utility-pole',
  icon: [512, 512, [], "e2c3", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56L128 80l0-24c0-13.3-10.7-24-24-24S80 42.7 80 56l0 24L64.2 80c-.2 0-.3 0-.5 0L48 80l0-24c0-13.3-10.7-24-24-24S0 42.7 0 56L0 88c0 22.1 17.9 40 40 40l43.2 0L232 227.2l0 68.8 0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192 0-68.8L428.8 128l43.2 0c22.1 0 40-17.9 40-40l0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-15.8 0c-.2 0-.3 0-.5 0L432 80l0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L280 80l0-56zm91.2 104L280 188.8l0-60.8 91.2 0zM232 188.8L140.8 128l91.2 0 0 60.8z"]
};
const faTransporter6 = {
  prefix: 'far',
  iconName: 'transporter-6',
  icon: [512, 512, [], "e2a7", "M56.7 6.6L64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6zm416 352L480 384l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 416l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 416l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 384l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zM96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24zM224 0l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faArrowTurnLeft = {
  prefix: 'far',
  iconName: 'arrow-turn-left',
  icon: [512, 512, [], "e632", "M135 369c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87L424 248c22.1 0 40 17.9 40 40l0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168c0-48.6-39.4-88-88-88L81.9 200l87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 207c-9.4 9.4-9.4 24.6 0 33.9L135 369z"]
};
const faWrench = {
  prefix: 'far',
  iconName: 'wrench',
  icon: [512, 512, [128295], "f0ad", "M322.3 268c9.4 2.6 19.3 4 29.7 4c60.5 0 109.8-48 111.9-108l-25.3 25.3c-12 12-28.3 18.7-45.3 18.7L368 208c-35.3 0-64-28.7-64-64l0-25.4c0-17 6.7-33.3 18.7-45.3c0 0 0 0 0 0L348 48.1C288 50.1 240 99.5 240 160c0 10.3 1.4 20.3 4 29.7c4.6 16.6-.2 34.4-12.4 46.6L57.1 410.7c-5.9 5.8-9.1 13.8-9.1 22.1C48 450 62 464 79.2 464c8.3 0 16.2-3.3 22.1-9.1L275.7 280.4c12.2-12.2 30-16.9 46.6-12.4zM424.6 39.4l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3l0 25.4c0 8.8 7.2 16 16 16l25.4 0c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3c10.1 21 15.7 44.5 15.7 69.3c0 88.4-71.6 160-160 160c-14.7 0-28.9-2-42.3-5.7L135.2 488.8c-14.9 14.9-35 23.2-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56L197.7 202.3C194 188.9 192 174.7 192 160C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7c9.2 4.4 10.5 16.5 3.3 23.7zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faBugs = {
  prefix: 'far',
  iconName: 'bugs',
  icon: [576, 512, [], "e4d0", "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6l-17 0-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184l32 0 0 23.3-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3l0-23.3 32 0c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136l-17 0c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2zM144 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zm307.9 97.8l-32 55.4c-4.4 7.7-14.2 10.3-21.9 5.9s-10.3-14.2-5.9-21.9l32-55.4c4.4-7.7 14.2-10.3 21.9-5.9s10.3 14.2 5.9 21.9z"]
};
const faVectorPolygon = {
  prefix: 'far',
  iconName: 'vector-polygon',
  icon: [448, 512, [], "e2c7", "M360 72l48 0 0 48-48 0 0-48zm-8-40c-17.7 0-32 14.3-32 32l0 8L128 72l0-8c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l8 0 0 192-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-42.4 0-27.4-45.6c3.7-5.2 5.8-11.5 5.8-18.4l0-64c0-6.8-2.1-13.2-5.8-18.4L373.6 160l42.4 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM298.4 320l27.4 45.6c-3.7 5.2-5.8 11.5-5.8 18.4l0 8-192 0 0-8c0-17.7-14.3-32-32-32l-8 0 0-192 8 0c17.7 0 32-14.3 32-32l0-8 192 0 0 8c0 6.8 2.1 13.2 5.8 18.4L298.4 192 256 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l42.4 0zM40 440l0-48 48 0 0 48-48 0zm320 0l0-48 48 0 0 48-48 0zM40 120l0-48 48 0 0 48-48 0zM264 232l48 0 0 48-48 0 0-48z"]
};
const faDiagramNested = {
  prefix: 'far',
  iconName: 'diagram-nested',
  icon: [448, 512, [], "e157", "M144 80l0 96-96 0 0-96 96 0zM48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l24 0 0 96c0 48.6 39.4 88 88 88l96 0 0 24c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 24-96 0c-22.1 0-40-17.9-40-40l0-96 24 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32zM400 336l0 96-96 0 0-96 96 0z"]
};
const faRupeeSign = {
  prefix: 'far',
  iconName: 'rupee-sign',
  icon: [448, 512, [8360, "rupee"], "f156", "M0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176zm264.6 10.4c-1.2 7.9-.2 12.8 1 15.9s3.5 6.2 7.5 9.4c9.2 7.4 23.3 12.5 43.1 19.6l.8 .3c17.4 6.2 40 14.2 56.7 28.5c9 7.7 16.8 17.6 21.5 30.4c4.7 12.7 5.7 26.7 3.5 41.9c-3.9 26.6-19.1 46.5-41 57.6c-21 10.6-46.4 12.3-71.6 7.6l-.2 0s0 0 0 0c-9-1.7-20.2-5.7-29.5-9.2c-6.3-2.4-13-5.1-18.5-7.3c0 0 0 0 0 0s0 0 0 0c-2.7-1.1-5-2-6.9-2.8c-12.3-4.8-18.4-18.8-13.6-31.1s18.8-18.4 31.1-13.6c2.6 1 5.3 2.1 8.2 3.3c0 0 0 0 0 0s0 0 0 0c5.1 2.1 10.7 4.3 16.7 6.6c9.4 3.5 17 6 21.5 6.9c18.1 3.3 32.1 1.2 41.2-3.3c8.1-4.1 13.5-10.7 15.1-21.7c1.3-8.8 .4-14.5-1-18.3c-1.4-3.8-3.8-7.1-7.7-10.5c-9-7.7-22.9-13.1-42.4-20l-2.9-1c-16.8-5.9-38.1-13.5-54.1-26.2c-9-7.2-17.1-16.6-22.1-29s-6.2-26.1-4-40.8c7.8-52.8 62.2-74.5 112.6-65.2c7.1 1.3 28.4 6.1 36.5 8.7c12.6 4 19.7 17.4 15.7 30.1s-17.4 19.7-30.1 15.7c-5.5-1.7-24.7-6.1-30.8-7.3c-36.3-6.7-54.2 10.2-56.4 25z"]
};
const faRupee = faRupeeSign;
const faFileImage = {
  prefix: 'far',
  iconName: 'file-image',
  icon: [384, 512, [128443], "f1c5", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2l48 0 32 0 40 0 72 0c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"]
};
const faCircleQuestion = {
  prefix: 'far',
  iconName: 'circle-question',
  icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faQuestionCircle = faCircleQuestion;
const faTicketsPerforated = {
  prefix: 'far',
  iconName: 'tickets-perforated',
  icon: [640, 512, [], "e63f", "M160 80l416 0c8.8 0 16 7.2 16 16l0 38.2c-24 15.7-40 42.8-40 73.8s16 58.1 40 73.8l0 38.2c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-56c0-8.8-7.4-15.7-15.6-19.1C610.1 238.8 600 224.6 600 208s10.1-30.8 24.4-36.9c8.1-3.4 15.6-10.3 15.6-19.1l0-56c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zm400 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
};
const faImageUser = {
  prefix: 'far',
  iconName: 'image-user',
  icon: [512, 512, [], "e1b8", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm192 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0c-15.1 0-27.4-12.3-27.4-27.4z"]
};
const faBuoy = {
  prefix: 'far',
  iconName: 'buoy',
  icon: [576, 512, [], "e5b5", "M184 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l12.1 0L142.2 304 96 304c-17.7 0-32 14.3-32 32l0 16c0 13.3 1.8 26.1 5.2 38.3c15.8-7.3 33.9-7.9 50.2-1.5c-4.7-11.3-7.3-23.8-7.3-36.8l352 0c0 13.1-2.6 25.5-7.3 36.9c16.2-6.4 34.4-5.8 50.2 1.5c3.4-12.2 5.2-25.1 5.2-38.3l0-16c0-17.7-14.3-32-32-32l-46.2 0L379.9 48 392 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 0zM330.8 48l11.9 56.6L288 168.5l-54.8-63.9L245.2 48l85.7 0zM220.8 163.8l35.6 41.5-58.8 68.6 23.2-110.1zM288 242.2L341 304 235 304l53-61.8zm90.4 31.7l-58.8-68.6 35.6-41.5 23.2 110.1zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faPlaneDeparture = {
  prefix: 'far',
  iconName: 'plane-departure',
  icon: [640, 512, [128747], "f5b0", "M154.5 87.6c9.2-3.8 19.4-4.1 28.8-.8L369 152.8c6.3 2.2 13.2 1.7 19.2-1.4l83.1-43.5c14.9-7.8 31.4-11.9 48.3-11.9l50.8 0c11.2 0 18.6 11.6 13.9 21.8c-17.2 36.8-46 67-81.9 85.8L251.8 335.1c-1.1 .6-2.4 .9-3.7 .9l-121.4 0c-2.3 0-4.6-1-6.1-2.8L54.2 255.7l23-11.5c2.1-1.1 4.6-1.1 6.8-.2l58.2 25.9c6.7 3 14.4 2.7 20.9-.7l88.1-46.2c7.6-4 12.5-11.7 12.8-20.3s-3.9-16.7-11.2-21.3L124 100.4l30.5-12.7zm44.8-46c-20.6-7.3-43.1-6.7-63.3 1.7L91.3 62c-29.9 12.5-33.4 53.5-5.9 70.8L192 199.9l-40.9 21.4-47.6-21.2c-15.3-6.8-32.8-6.4-47.8 1.1L66.1 222 55.8 201.3 23.6 217.4C.3 229-5.8 259.4 11.1 279.2l73.1 85.3 17.6-15.1L84.2 364.4c10.6 12.4 26.2 19.6 42.5 19.6l121.4 0c9.1 0 18-2.2 26-6.4L524.5 246.1c45.3-23.8 81.5-61.7 103.1-108c19.6-42-11-90.1-57.4-90.1l-50.8 0c-24.6 0-48.8 6-70.5 17.4L375.1 104 199.3 41.6zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z"]
};
const faHandshakeSlash = {
  prefix: 'far',
  iconName: 'handshake-slash',
  icon: [640, 512, [], "e060", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L501.8 368l46.5 0c5.5 9.6 15.9 16 27.7 16l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-40 0-40 0-38.9 0L475 101.2C448 77.3 413.2 64 377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-50.1 47.4-31.2-24.4c8.3-5 17.2-8.9 26.5-11.5l51.1-51.1c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-34 0-66.9 11.4-93.6 32.2L38.8 5.1zM263.9 181.5l44.9-42.4c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l48 0 0 144-88 0-15.4 0-99.4-77.9 35.1-32.4c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-40.9 37.7-39-30.5zM96 171.6L40.6 128 16 128c-8.8 0-16 7.2-16 16L0 352c0 17.7 14.3 32 32 32l32 0c17.6 0 32-14.3 32-31.9c7.7 .5 14.9 3.8 20.4 9.3L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c7.3-7.3 12.8-15.6 16.6-24.5l-42-33.1c.8 8.5-2.1 17.2-8.6 23.7c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6C135.8 313 116.4 304.6 96 304l0-80 0-48 0-4.4zM32 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm560-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faBookBookmark = {
  prefix: 'far',
  iconName: 'book-bookmark',
  icon: [448, 512, [], "e0bb", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8l-40 0 0 158.7c0 13.4-15.5 20.9-26 12.5L272 176l-54 43.2c-10.5 8.4-26 .9-26-12.5L192 48 88 48C65.9 48 48 65.9 48 88l0 270.7z"]
};
const faBorderCenterH = {
  prefix: 'far',
  iconName: 'border-center-h',
  icon: [448, 512, [], "f89c", "M32 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z"]
};
const faCanFood = {
  prefix: 'far',
  iconName: 'can-food',
  icon: [384, 512, [129387], "e3e6", "M320 434.3c-3.4 3-10.2 7.5-21.7 12.2C273.5 456.6 235.9 464 192 464s-81.5-7.4-106.3-17.5c-11.5-4.7-18.3-9.2-21.7-12.2l0-144.8c14.2 6.1 31 11.3 49.7 15.1c7.6 36.3 39.8 63.5 78.3 63.5s70.7-27.2 78.3-63.5c18.7-3.8 35.5-8.9 49.7-15.1l0 144.8zm48 5.7l0-200 0-168c0-39.8-78.8-72-176-72S16 32.2 16 72l0 168 0 200c0 39.8 78.8 72 176 72s176-32.2 176-72zM304 72c0 13.3-50.1 24-112 24S80 85.3 80 72s50.1-24 112-24s112 10.7 112 24zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faTypewriter = {
  prefix: 'far',
  iconName: 'typewriter',
  icon: [512, 512, [], "f8e7", "M128 64c0-8.8 7.2-16 16-16l191.4 0c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3l0 63.4 48 0 0-63.4c0-17-6.7-33.3-18.7-45.3L380.7 18.7C368.7 6.7 352.4 0 335.4 0L144 0C108.7 0 80 28.7 80 64l0 96 48 0 0-96zM0 224l0 32c0 17.7 14.3 32 32 32l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-114.7 0c-8.5 0-16.6 3.4-22.6 9.4l-13.3 13.3c-6 6-14.1 9.4-22.6 9.4l-101.5 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L32 192c-17.7 0-32 14.3-32 32zm80 64l352 0 0 160c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-160zm48 112l0 16c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm40-60a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm92-20a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm52 20a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
const faArrowRightFromArc = {
  prefix: 'far',
  iconName: 'arrow-right-from-arc',
  icon: [512, 512, [], "e4b1", "M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM392.3 134.4c-9.7-9-24.9-8.5-33.9 1.3s-8.5 24.9 1.3 33.9L426.9 232 184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l242.9 0-67.2 62.4c-9.7 9-10.3 24.2-1.3 33.9s24.2 10.3 33.9 1.3l112-104c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104z"]
};
const faCircleK = {
  prefix: 'far',
  iconName: 'circle-k',
  icon: [512, 512, [], "e113", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm89.1-343.2c9.3-9.5 9.2-24.6-.3-33.9s-24.6-9.2-33.9 .3L208 239.8l0-87.8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 146.5 0 61.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.7 30-30.5 70.7 96.4c7.8 10.7 22.9 13 33.5 5.2s13-22.9 5.2-33.5L272.1 243.1l73.1-74.3z"]
};
const faFaceHandOverMouth = {
  prefix: 'far',
  iconName: 'face-hand-over-mouth',
  icon: [512, 512, [129762], "e378", "M256 48C141.1 48 48 141.1 48 256c0 59 24.6 112.2 64 150.1l0 10.7c0 21.9 5.5 42.5 15.3 60.5C51.2 433 0 350.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 113.1-73.3 209.1-175.1 242.9l49-49c11.7-11.7 16.1-27.9 13.2-43C439.1 369 464 315.4 464 256c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM299.3 276.7c6.2 6.2 6.2 16.4 0 22.6L248 350.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l67.3-67.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L280 382.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l51.3-51.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L312 414.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l19.3-19.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.8 56.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-32.8 0-53.6c0-11 9-20 20-20s20 9 20 20l0 19.7c0 7.1 8.6 10.7 13.7 5.7l79-79c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faPopcorn = {
  prefix: 'far',
  iconName: 'popcorn',
  icon: [448, 512, [127871], "f819", "M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4l-87.6 0-208.4 0-87.6 0c-.1-1.3-.2-2.7-.2-4zm22.3 84l62.2 224 215 0 62.2-224-47 0L303.6 419.7c-2.1 8.6-10.7 13.9-19.3 11.8s-13.9-10.7-11.8-19.3L313.8 240 240 240l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176-73.8 0 41.3 172.3c2.1 8.6-3.2 17.2-11.8 19.3s-17.2-3.2-19.3-11.8L101.3 240l-47 0zM224 192l195.8 0c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512l-215 0c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192L224 192z"]
};
const faHouseWater = {
  prefix: 'far',
  iconName: 'house-water',
  icon: [576, 512, ["house-flood"], "f74f", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 393c14.6-8.5 31.9-10.7 48-6.6l0-181.7L288 55.5 464 204.8l0 181.7c16.1-4.2 33.4-1.9 48 6.5l0-147.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM256 224l64 0 0 64-64 0 0-64zm-8-48c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-80 0zM111.9 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faHouseFlood = faHouseWater;
const faObjectSubtract = {
  prefix: 'far',
  iconName: 'object-subtract',
  icon: [512, 512, [], "e49e", "M64 48l32 0L96 0 64 0C28.7 0 0 28.7 0 64L0 96l48 0 0-32c0-8.8 7.2-16 16-16zm160 0l0-48L128 0l0 48 96 0zM48 128L0 128l0 96 48 0 0-96zm0 128L0 256l0 32c0 35.3 28.7 64 64 64l32 0 0-48-32 0c-8.8 0-16-7.2-16-16l0-32zm80 96l32 0 48 0 16 0 0-48-96 0 0 48zm32 32l0 64c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-64 0 0 48 64 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64-48 0zM352 208l0-48 0-32-48 0 0 96 48 0 0-16zm0-144c0-35.3-28.7-64-64-64L256 0l0 48 32 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32zM256 304l0 48 32 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16l-32 0z"]
};
const faCodeBranch = {
  prefix: 'far',
  iconName: 'code-branch',
  icon: [448, 512, [], "f126", "M80 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32c0 35.8-23.5 66.1-56 76.3l0 99.7c20.1-15.1 45-24 72-24l96 0c39.8 0 72-32.2 72-72l0-3.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 3.7c0 66.3-53.7 120-120 120l-96 0c-39.8 0-72 32.2-72 72l0 3.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-3.7 0-195.7C23.5 146.1 0 115.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm240 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faWarehouseFull = {
  prefix: 'far',
  iconName: 'warehouse-full',
  icon: [640, 512, ["warehouse-alt"], "f495", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240l0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-352 0zM376 416l64 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM176 312c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-48zm24 104l96 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"]
};
const faWarehouseAlt = faWarehouseFull;
const faHatCowboy = {
  prefix: 'far',
  iconName: 'hat-cowboy',
  icon: [640, 512, [], "f8c0", "M254.2 82.7c-2 2.8-4.4 6.7-7.1 11.8C236.8 114 226.9 142 218.2 173c-8.5 30.4-15.3 61-19.9 84.3c-.9 4.7-1.8 9.1-2.5 13.1c-16.8-5-32-10.6-45.7-16.6C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64s22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.4 0 84.4 152.2 97.9 221.9c-13.7 5.9-28.9 11.6-45.7 16.6c-.8-4-1.6-8.4-2.5-13.2c-4.6-23.3-11.3-54-19.9-84.3c-8.7-30.9-18.6-59-28.9-78.5c-2.7-5.1-5.1-9-7.1-11.8c-.5 .4-1 .9-1.6 1.4c-.5 .5-1.1 1-1.8 1.6c0 0 0 0 0 0s0 0 0 0C374 93.3 353.4 112 320 112s-54-18.7-62.3-26.2c0 0 0 0 0 0s0 0 0 0c-.7-.6-1.3-1.2-1.8-1.6c-.6-.5-1.2-1-1.6-1.4zM380.9 77c0 0 0 0-.1 0c0 0 0 0 0 0c0 0 0 0 .1 0zM259.1 77l.1 0c0 0 0 0-.1 0zm-148 193.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"]
};
const faBridge = {
  prefix: 'far',
  iconName: 'bridge',
  icon: [576, 512, [], "e4c8", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l48 0 0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM456 80l0 64-80 0 0-64 80 0zM328 80l0 64-80 0 0-64 80 0zM200 80l0 64-80 0 0-64 80 0zM24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24c26.5 0 48 21.5 48 48l0 104c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-96c0-30.9 25.1-56 56-56l32 0c30.9 0 56 25.1 56 56l0 96c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-104c0-26.5 21.5-48 48-48c13.3 0 24-10.7 24-24s-10.7-24-24-24c-53 0-96 43-96 96l0 96-48 0 0-88c0-57.4-46.6-104-104-104l-32 0c-57.4 0-104 46.6-104 104l0 88-48 0 0-96c0-53-43-96-96-96z"]
};
const faPhoneFlip = {
  prefix: 'far',
  iconName: 'phone-flip',
  icon: [512, 512, [128381, "phone-alt"], "f879", "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4 .9l112 24C498.8 28.8 512 45.1 512 64c0 0 0 0 0 0c0 231.2-175.2 421.5-400.1 445.5c-9.8 1-19.7 1.8-29.6 2.2c0 0 0 0 0 0c0 0-.1 0-.1 0c-6.1 .2-12.1 .4-18.3 .4c0 0 0 0 0 0c-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM70.5 464C286.3 460.5 460.5 286.2 464 70.5L364.8 49.2l-43 100.4L357.6 179c18.2 14.9 22.9 40.8 11.1 61.2c-30.9 53.3-75.3 97.7-128.6 128.6c-20.4 11.8-46.3 7.1-61.2-11.1l-29.4-35.9-100.4 43L70.5 464zM464 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faPhoneAlt = faPhoneFlip;
const faArrowDownFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-from-dotted-line',
  icon: [448, 512, [], "e090", "M241.5 472.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 395.5l0-83.5 0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128 0 83.5 86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faFileDoc = {
  prefix: 'far',
  iconName: 'file-doc',
  icon: [512, 512, [], "e5ed", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm16 128l16 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm40-8c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-80c0-4.4-3.6-8-8-8l-16 0z"]
};
const faSquareQuarters = {
  prefix: 'far',
  iconName: 'square-quarters',
  icon: [448, 512, [], "e44e", "M52.7 84.7L224 256 395.3 84.7c-2.9-2.9-6.9-4.7-11.3-4.7L64 80c-4.4 0-8.4 1.8-11.3 4.7zm0 342.6c2.9 2.9 6.9 4.7 11.3 4.7l320 0c4.4 0 8.4-1.8 11.3-4.7L224 256 52.7 427.3zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faTruckFront = {
  prefix: 'far',
  iconName: 'truck-front',
  icon: [512, 512, [], "e2b7", "M80 48C62.3 48 48 62.3 48 80l0 152c4.2-3.2 8.7-6.1 13.3-8.7l40-85.8C113.2 112.2 138.6 96 166.6 96l178.9 0c28 0 53.4 16.2 65.2 41.6l40 85.8c4.6 2.6 9.1 5.5 13.3 8.7l0-152c0-17.7-14.3-32-32-32L80 48zM48 328l0 40c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-40c0-39.8-32.2-72-72-72l-272 0c-39.8 0-72 32.2-72 72zM0 328L0 80C0 35.8 35.8 0 80 0L432 0c44.2 0 80 35.8 80 80l0 248 0 40c0 26.2-12.6 49.4-32 64l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40L80 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56C12.6 417.4 0 394.2 0 368l0-40zM121.4 208l269.2 0-23.4-50.1c-3.9-8.4-12.4-13.9-21.7-13.9l-178.9 0c-9.3 0-17.8 5.4-21.7 13.9L121.4 208zM96 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCat = {
  prefix: 'far',
  iconName: 'cat',
  icon: [576, 512, [128008], "f6be", "M361 0c10.9 0 21.3 4.3 29 12l36 36 44.1 0 36-36c7.7-7.7 18.1-12 29-12c22.6 0 41 18.3 41 41l0 119c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-119c0-22.6 18.3-41 41-41zm7 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-102.1L501.7 84.3C494.2 91.8 484 96 473.4 96l-50.7 0c-10.6 0-20.8-4.2-28.3-11.7L368 57.9 368 160zm48-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM285 182l4.4-.4c2.2 16.6 7 32.4 13.9 46.9l-14 1.3C188.9 238.9 112 323.1 112 423.9c0 0 0 .1 0 .1c0 22.1 17.9 40 40 40l104 0 0-64c0-17.7-14.3-32-32-32l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c39.4 0 72.2 28.5 78.8 66l93-54.7c7.4-4.4 16.6-4.4 24.1-.1s12.1 12.2 12.1 20.8l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128.8c16.9-1.7 33.1-6 48-12.5L512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-54L304 441l0 23 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-48.6 0-88-39.4-88-88c0 0 0-.1 0-.1l0-239.4c0-20.2-15-37.2-35-39.7l-7.9-1C7.9 142.2-1.5 130.2 .2 117S13.8 94.5 27 96.2l7.9 1c44 5.5 77.1 42.9 77.1 87.3l0 94.5c40-53.7 101.7-90.5 173-97z"]
};
const faTrashXmark = {
  prefix: 'far',
  iconName: 'trash-xmark',
  icon: [448, 512, [], "e2b4", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zm62.2 81.9c7.8-7.8 20.5-7.8 28.3 0L224 259.7l49.9-49.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L252.3 288l49.9 49.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L224 316.3l-49.9 49.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L195.7 288l-49.9-49.9c-7.8-7.8-7.8-20.5 0-28.3z"]
};
const faCircleCaretLeft = {
  prefix: 'far',
  iconName: 'circle-caret-left',
  icon: [512, 512, ["caret-circle-left"], "f32e", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zm-368 0c0 6.7 2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-208c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6z"]
};
const faCaretCircleLeft = faCircleCaretLeft;
const faFiles = {
  prefix: 'far',
  iconName: 'files',
  icon: [448, 512, [], "e178", "M160 368l224 0c8.8 0 16-7.2 16-16l0-224-48 0c-17.7 0-32-14.3-32-32l0-48L160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm224 48l-224 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64L325.5 0c17 0 33.3 6.7 45.3 18.7l58.5 58.5c12 12 18.7 28.3 18.7 45.3L448 352c0 35.3-28.7 64-64 64zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24z"]
};
const faAnchorCircleExclamation = {
  prefix: 'far',
  iconName: 'anchor-circle-exclamation',
  icon: [640, 512, [], "e4ab", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faFaceClouds = {
  prefix: 'far',
  iconName: 'face-clouds',
  icon: [640, 512, [], "e47d", "M128 0c27.9 0 51.7 17.9 60.4 42.8C198.6 36 210.8 32 224 32c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 160C28.7 160 0 131.3 0 96S28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0zM72.1 192l50 0c-6.5 20.2-10 41.7-10 64c0 80.2 45.4 149.9 112 184.6c.1 22.3 7.2 42.9 19.3 59.7C139.4 467.7 64 370.6 64 256c0-22.1 2.8-43.5 8.1-64zM307.4 48.4C296.8 29.8 280.1 15.2 260.1 7c19.2-4.6 39.2-7 59.9-7C461.4 0 576 114.6 576 256c0 14.8-1.3 29.3-3.7 43.5c-12.5-10.8-28.3-17.8-45.7-19.2c.9-8 1.4-16.1 1.4-24.3c0-114.9-93.1-208-208-208c-4.2 0-8.4 .1-12.6 .4zM208.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 368c0-44.2 35.8-80 80-80c29.3 0 54.9 15.8 68.9 39.3c8.8-9.4 21.3-15.3 35.1-15.3c26.5 0 48 21.5 48 48c0 2.7-.2 5.4-.7 8l.7 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-240 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l8 0z"]
};
const faUserCrown = {
  prefix: 'far',
  iconName: 'user-crown',
  icon: [448, 512, [], "f6a4", "M144 128l160 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16zm0-108.8l-.1-.1c-.3-.2-.6-.4-.8-.6L140 16 124.4 3.5C121.5 1.2 118 0 114.4 0L112 0c-8.8 0-16 7.2-16 16l0 23 0 3.2c0 0 0 .1 0 .1L96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-101.7c0 0 0-.1 0-.1l0-3.2 0-23c0-8.8-7.2-16-16-16l-2.4 0c-3.6 0-7.2 1.2-10 3.5L308 16l-3 2.4c-.3 .2-.6 .4-.8 .6l-.1 .1c-10.2 7.5-23.8 8.3-34.9 2L238.9 4c-4.6-2.6-9.7-4-14.9-4s-10.4 1.4-14.9 4L178.9 21.2c-11 6.3-24.7 5.5-34.9-2zM168 352l112 0c63.6 0 115.6 49.5 119.7 112L48.3 464c4.1-62.5 56.2-112 119.7-112zm0-48C75.2 304 0 379.2 0 472l0 8c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-8c0-92.8-75.2-168-168-168l-112 0z"]
};
const faBasketShoppingPlus = {
  prefix: 'far',
  iconName: 'basket-shopping-plus',
  icon: [576, 512, [], "e653", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM482.5 240l-389 0 53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9zM200 352c0-13.3 10.7-24 24-24l40 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24z"]
};
const faTruckField = {
  prefix: 'far',
  iconName: 'truck-field',
  icon: [640, 512, [], "e58d", "M336 80c8.8 0 16 7.2 16 16l0 8 0 120 0 96 0 16-108.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 336l0-48 0-160 0-32c0-8.8 7.2-16 16-16l256 0zM16 283.7L16 336l0 1.4C6.7 340.7 0 349.5 0 360s6.7 19.3 16 22.6l0 1.4 8 0 40 0c0 53 43 96 96 96s96-43 96-96l96 0 32 0c0 53 43 96 96 96s96-43 96-96l32 0 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48c0-35.3-28.7-64-64-64l-5 0-.3-.7L486.4 112.2c-9.2-19.6-29-32.2-50.7-32.2L398 80c-7.1-27.6-32.2-48-62-48L80 32C44.7 32 16 60.7 16 96l0 36.3C6.4 137.8 0 148.2 0 160l0 96c0 11.8 6.4 22.2 16 27.7zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM485.9 224L400 224l0-96 35.7 0c3.1 0 5.9 1.8 7.2 4.6l43 91.4zM528 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faRoute = {
  prefix: 'far',
  iconName: 'route',
  icon: [512, 512, [], "f4d7", "M438.6 155.7c-7.2 11.5-15 22.6-22.6 32.7c-7.5-10.1-15.4-21.2-22.6-32.7C375.7 127.3 368 106.3 368 96c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.3-7.7 31.3-25.4 59.7zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 33.3 25.9 77.3 50.8 112L328 208c-48.6 0-88 39.4-88 88s39.4 88 88 88l96 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-246.2 0c-2.7 3.8-5.5 7.6-8.2 11.2c-10.7 14.2-21.3 26.9-30 36.8L424 512c48.6 0 88-39.4 88-88s-39.4-88-88-88l-96 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l84.9 0c5.1 1.1 10.7-.6 14.5-5zM118.9 408.4c-7.3 11-15.3 21.7-22.9 31.2c-7.6-9.5-15.6-20.2-22.9-31.2C55.4 381.7 48 361.9 48 352c0-26.5 21.5-48 48-48s48 21.5 48 48c0 9.9-7.4 29.7-25.1 56.4zm19 55.6c25.9-33.1 54.1-77.3 54.1-112c0-53-43-96-96-96s-96 43-96 96c0 50.5 59.8 121 85 148.4c6 6.5 16 6.5 21.9 0c.1-.1 .2-.2 .3-.3c.3-.3 .6-.7 .9-1c2.8-3.1 6-6.7 9.5-10.7c.1-.1 .1-.1 .2-.2c6.1-7 13-15.2 20-24.2z"]
};
const faCartCircleCheck = {
  prefix: 'far',
  iconName: 'cart-circle-check',
  icon: [640, 512, [], "e3f1", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"]
};
const faClipboardQuestion = {
  prefix: 'far',
  iconName: 'clipboard-question',
  icon: [384, 512, [], "e4e3", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM105.8 229.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM224 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faPanorama = {
  prefix: 'far',
  iconName: 'panorama',
  icon: [640, 512, [], "e209", "M48 80.9C72.3 88.8 177.5 120 320 120s247.7-31.2 272-39.1l0 350.2c-9.8-3.2-32.9-10.2-66.3-17.4c-.5-1-1-1.9-1.6-2.8l-136-208c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9L264.8 330l-29.5-40.2c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8l-88 120c-1.3 1.8-2.4 3.8-3.1 5.8c-28.7 6.5-48.6 12.6-57.5 15.5L48 80.9zM579.6 34.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCommentMedical = {
  prefix: 'far',
  iconName: 'comment-medical',
  icon: [512, 512, [], "f7f5", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM224 160l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faTeethOpen = {
  prefix: 'far',
  iconName: 'teeth-open',
  icon: [576, 512, [], "f62f", "M480 48L96 48C69.5 48 48 69.5 48 96l0 29.4C63.9 102.8 90.2 88 120 88c15.2 0 29.5 3.9 42 10.7C178.1 77.6 203.5 64 232 64c21.3 0 40.8 7.5 56 20.1C303.2 71.5 322.7 64 344 64c28.5 0 53.9 13.6 70 34.7C426.5 91.9 440.8 88 456 88c29.8 0 56.1 14.8 72 37.4L528 96c0-26.5-21.5-48-48-48zm0 208l-48 0-64 0-48 0-64 0-48 0-64 0-48 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 43 43 0 96 0L480 0c53 0 96 43 96 96l0 96c0 35.3-28.7 64-64 64l-32 0zm0-48c8.8 0 16-7.2 16-16l0-16c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24l0 16c0 8.2 6.1 14.9 14 15.9c.6 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-16 0-24c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28l0 40c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-40c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19l0 24 0 16c0 8.2 6.1 14.9 14 15.9c.7 .1 1.3 .1 2 .1l48 0zm-112 0c.7 0 1.3 0 2-.1c7.9-1 14-7.7 14-15.9l0-16c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40l0 16c0 8.8 7.2 16 16 16l48 0zM480 464c26.5 0 48-21.5 48-48l0-5.4c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4l0 5.4c0 26.5 21.5 48 48 48l384 0zm0-128l-48 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40l0-8c0-8.8-7.2-16-16-16zm-112 0l-48 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.6-.1-1.3-.1-2-.1zm112-48l32 0c35.3 0 64 28.7 64 64l0 64c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-64c0-35.3 28.7-64 64-64l32 0 48 0 64 0 48 0 64 0 48 0 64 0 48 0zM96 336c-8.8 0-16 7.2-16 16l0 8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1l-48 0zm112 0c-.7 0-1.3 0-2 .1c-7.9 1-14 7.7-14 15.9l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-8.2-6.1-14.9-14-15.9c-.7-.1-1.3-.1-2-.1l-48 0z"]
};
const faUserTieHairLong = {
  prefix: 'far',
  iconName: 'user-tie-hair-long',
  icon: [448, 512, [], "e460", "M304 144c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 261.9 58.1 272 70.6 272L224 272l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-11C352 57.3 294.7 0 224 0zM168.2 511.1l-.2 .9 112 0-.2-.9 137.5 0c17 0 30.7-13.8 30.7-30.7c0-79.6-57.6-145.7-133.5-158.9c-6.6-1.1-12.9 2.4-15.9 8.4l-44 87.9-15.8-58.6 18.6-31c6.4-10.7-1.3-24.2-13.7-24.2L224 304l-19.7 0c-12.4 0-20.1 13.6-13.7 24.2l18.6 31-15.8 58.6-44-87.9c-3-6-9.4-9.5-15.9-8.4C57.6 334.7 0 400.8 0 480.4c0 17 13.8 30.7 30.7 30.7l137.5 0zM118.5 375.5l43.8 87.7-113 0c6.1-39.8 33-72.9 69.2-87.7zm167.2 87.7l43.8-87.7c36.2 14.8 63.1 47.8 69.2 87.7l-113 0z"]
};
const faFileCircleMinus = {
  prefix: 'far',
  iconName: 'file-circle-minus',
  icon: [576, 512, [], "e4ed", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
const faHeadSideMedical = {
  prefix: 'far',
  iconName: 'head-side-medical',
  icon: [512, 512, [], "f809", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM192 112l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faArrowTurnRight = {
  prefix: 'far',
  iconName: 'arrow-turn-right',
  icon: [512, 512, [], "e635", "M377 369c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87L88 248c-22.1 0-40 17.9-40 40l0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 288c0-48.6 39.4-88 88-88l342.1 0-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 207c9.4 9.4 9.4 24.6 0 33.9L377 369z"]
};
const faTags = {
  prefix: 'far',
  iconName: 'tags',
  icon: [512, 512, [], "f02c", "M345 39.1c-9.3-9.4-24.5-9.5-33.9-.2s-9.5 24.5-.2 33.9L438.6 202.1c33.9 34.3 33.9 89.4 0 123.7L326.7 439.1c-9.3 9.4-9.2 24.6 .2 33.9s24.6 9.2 33.9-.2L472.8 359.6c52.4-53 52.4-138.2 0-191.2L345 39.1zM242.7 50.7c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l168 168c25 25 65.5 25 90.5 0L410.7 309.3c25-25 25-65.5 0-90.5l-168-168zM48 80l149.5 0c4.2 0 8.3 1.7 11.3 4.7l168 168c6.2 6.2 6.2 16.4 0 22.6L243.3 408.8c-6.2 6.2-16.4 6.2-22.6 0l-168-168c-3-3-4.7-7.1-4.7-11.3L48 80zm96 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faWineGlass = {
  prefix: 'far',
  iconName: 'wine-glass',
  icon: [320, 512, [127863], "f4e3", "M184 464l0-114c44.4-7.5 81.5-35.5 101.7-73.6c13.6-24.4 20.4-53.2 17.7-83.7L287.5 14.5C286.8 6.2 279.9 0 271.8 0L264 0 56 0 48.2 0c-8.1 0-15 6.2-15.8 14.5L16.6 192.6c-2.7 30.5 4 59.3 17.7 83.7C54.5 314.5 91.6 342.5 136 350l0 114-64 0c-1 0-2.1 .1-3.1 .2C57.1 465.7 48 475.8 48 488c0 12.2 9.1 22.2 20.8 23.8c.9 .1 1.9 .2 2.9 .2l.3 0 88 0 88 0c1 0 2.1-.1 3.1-.2c11.8-1.5 20.9-11.6 20.9-23.8c0-12.2-9.1-22.2-20.8-23.8c-.9-.1-1.9-.2-2.9-.2l-.3 0-64 0zM78.2 48l163.6 0 6.3 80L71.9 128l6.3-80zM68.1 176l183.9 0 2.1 26.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7L68.1 176z"]
};
const faForwardFast = {
  prefix: 'far',
  iconName: 'forward-fast',
  icon: [512, 512, [9197, "fast-forward"], "f050", "M496 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1L273.4 440.6c-5.4 4.8-12.4 7.4-19.6 7.4c-16.5 0-29.8-13.3-29.8-29.8l0-130.3L49.4 440.6C44 445.4 37 448 29.8 448C13.3 448 0 434.7 0 418.2L0 93.8C0 77.3 13.3 64 29.8 64C37 64 44 66.6 49.4 71.4L224 224.1l0-130.3C224 77.3 237.3 64 253.8 64c7.2 0 14.2 2.6 19.6 7.4L448 224.1 448 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 336zM48 133.9l0 244.2L187.6 256 48 133.9zM272 378.1L411.6 256 272 133.9l0 244.2z"]
};
const faFastForward = faForwardFast;
const faFaceMehBlank = {
  prefix: 'far',
  iconName: 'face-meh-blank',
  icon: [512, 512, [128566, "meh-blank"], "f5a4", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faMehBlank = faFaceMehBlank;
const faUserRobot = {
  prefix: 'far',
  iconName: 'user-robot',
  icon: [448, 512, [], "e04b", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zm96 128l0 96c0 17.7-14.3 32-32 32l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32zm64 304l0 16-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-16c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM160 512l64 0 64 0 112 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l112 0zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM208 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faSquareParking = {
  prefix: 'far',
  iconName: 'square-parking',
  icon: [448, 512, [127359, "parking"], "f540", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM184 272l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-64 0 0 96zm64 48l-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64 0-136c0-17.7 14.3-32 32-32l80 0c53 0 96 43 96 96s-43 96-96 96z"]
};
const faParking = faSquareParking;
const faCardDiamond = {
  prefix: 'far',
  iconName: 'card-diamond',
  icon: [384, 512, [], "e3ea", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96z"]
};
const faFaceZipper = {
  prefix: 'far',
  iconName: 'face-zipper',
  icon: [512, 512, [], "e3a5", "M389.2 394.3l29.1 58.1c14.7 29.3 53.7 35.6 76.9 12.5l1.8-1.8c23.2-23.2 16.8-62.2-12.5-76.9l-58.1-29.1c-6.2-3.1-13.6-1.9-18.5 3l-15.7 15.7c-4.9 4.9-6.1 12.3-3 18.5zm91.3 38.2l-16 16c-4.7 4.7-12.3 4.7-17 0s-4.7-12.3 0-17l16-16c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c42.5 0 82-12.7 114.9-34.6l18.7 37.3c1 2 2 3.9 3.1 5.7C353.2 497.5 306.3 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 34.9-7 68.1-19.6 98.4l-43.1-21.5c9.5-23.8 14.7-49.7 14.7-76.9c0-114.9-93.1-208-208-208zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 320c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 336l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faFaceRaisedEyebrow = {
  prefix: 'far',
  iconName: 'face-raised-eyebrow',
  icon: [512, 512, [], "e388", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 352c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM328.8 141.8l-29.5 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l29.5-29.5c25-25 66.6-20.9 86.2 8.5l4.9 7.4c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7zM128 144l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faHouseSignal = {
  prefix: 'far',
  iconName: 'house-signal',
  icon: [576, 512, [], "e012", "M320.8 5.4c8.8-7.2 21.5-7.2 30.3 0l216 176c10.3 8.4 11.8 23.5 3.4 33.8s-23.5 11.8-33.8 3.4L512 198.4 512 360c0 30.9-25.1 56-56 56l-177.9 0c-4.7-16.7-11.1-32.8-18.8-48L456 368c4.4 0 8-3.6 8-8l0-200.7L336 55 208 159.3l0 139.4c-14.5-14.1-30.6-26.5-48-37l0-63.3-24.8 20.2c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176zM312 192l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM24 256c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 376c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
const faSquareChevronUp = {
  prefix: 'far',
  iconName: 'square-chevron-up',
  icon: [448, 512, ["chevron-square-up"], "f32c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm241 71L345 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 167c9.4-9.4 24.6-9.4 33.9 0z"]
};
const faChevronSquareUp = faSquareChevronUp;
const faNfcSymbol = {
  prefix: 'far',
  iconName: 'nfc-symbol',
  icon: [512, 512, [], "e531", "M357.4 473.6c7.7 7.2 19.2 8.5 28.3 3.2C461.4 433 512 349.3 512 256s-50.6-177-126.3-220.8c-11.5-6.6-26.2-2.7-32.8 8.8s-2.7 26.2 8.8 32.8C422.7 112.1 464 180.1 464 256c0 69.6-34.7 132.6-87.6 169.8L200.3 262.4c-9.7-9-24.9-8.4-33.9 1.3s-8.4 24.9 1.3 33.9l189.7 176zM154.6 38.4c-7.7-7.2-19.2-8.5-28.3-3.2C50.6 79 0 162.7 0 256s50.6 177 126.3 220.8c11.5 6.6 26.2 2.7 32.8-8.8s2.7-26.2-8.8-32.8C89.3 399.9 48 331.9 48 256c0-69.6 34.7-132.6 87.6-169.8L311.7 249.6c9.7 9 24.9 8.4 33.9-1.3s8.4-24.9-1.3-33.9L154.6 38.4z"]
};
const faBarsProgress = {
  prefix: 'far',
  iconName: 'bars-progress',
  icon: [512, 512, ["tasks-alt"], "f828", "M464 112l0 64-144 0 0-64 144 0zM48 64C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM464 336l0 64-272 0 0-64 272 0zM48 288c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z"]
};
const faTasksAlt = faBarsProgress;
const faFaucetDrip = {
  prefix: 'far',
  iconName: 'faucet-drip',
  icon: [512, 512, [128688], "e006", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21L96 32C78.3 32 64 46.3 64 64s14.3 32 32 32L200 83l0 45-18.7 0c-14.9 0-29.1 5.9-39.6 16.4L126.1 160 24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c6.4 0 12.5-2.5 17-7l22.6-22.6c1.5-1.5 3.5-2.3 5.7-2.3l93.5 0c2.1 0 4.2 .8 5.7 2.3L303 201c4.5 4.5 10.6 7 17 7l40 0c57.4 0 104 46.6 104 104l0 16c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56l-32.3 0c-8.2 0-15.8 4.2-20.2 11.1C277.2 305.3 252.3 320 224 320s-53.2-14.7-67.4-36.9c-4.4-6.9-12-11.1-20.2-11.1L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l100.1 0c23.4 29.2 59.5 48 99.9 48s76.5-18.8 99.9-48l20.1 0c4.4 0 8 3.6 8 8c0 30.9 25.1 56 56 56l48 0c30.9 0 56-25.1 56-56l0-16c0-83.9-68.1-152-152-152l-30.1 0-15.6-15.6c-10.5-10.5-24.7-16.4-39.6-16.4L248 128l0-45L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L248 45l0-21zM420.8 423.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4z"]
};
const faArrowsToLine = {
  prefix: 'far',
  iconName: 'arrows-to-line',
  icon: [448, 512, [], "e0a7", "M241 185l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1L169 79c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM0 256c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232c-13.3 0-24 10.7-24 24zm241 71c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"]
};
const faDolphin = {
  prefix: 'far',
  iconName: 'dolphin',
  icon: [512, 512, [], "e168", "M80 160c0 13.3 2.3 26 6.5 37.8c3.9 10.8-.4 22.8-10.2 28.7L56.8 238.2 44.7 217.9l12.1 20.2c-5.5 3.3-8.8 9.2-8.8 15.6c0 10.1 8.2 18.2 18.2 18.2L192 272l24 0 32.9 0c6.3 0 12.3 2.5 16.8 6.8L304 316.3l0-20.3c0-13.3 10.7-24 24-24l16 0c48.6 0 88 39.4 88 88l0 8c0 .9 0 1.8 0 2.6c19.9-21.2 32-49.6 32-81c0-60.8-22.4-116.2-59.4-158.7c-7.2-8.2-7.9-20.3-1.7-29.3c10.4-15.3 23.4-35.5 31.4-51.9c-27.3 4-58.4 14.3-84.2 24.6c-6.4 2.5-13.5 2.2-19.6-.8C297.9 57.2 261.2 48 222.3 48L192 48C130.1 48 80 98.1 80 160zM277.7 408l66.3 0c22.1 0 40-17.9 40-40l0-8c0-19.4-13.7-35.5-32-39.2l0 1.9c0 25-20.3 45.3-45.3 45.3c-11.8 0-23.2-4.6-31.7-12.9L239.1 320 216 320l-24 0L66.2 320C29.6 320 0 290.4 0 253.8C0 230.5 12.2 209 32.1 197l3.7-2.2C33.3 183.6 32 171.9 32 160C32 71.6 103.6 0 192 0l30.3 0C265 0 305.6 9.3 342.2 25.9C374.9 13.5 418.7 0 456 0c7.8 0 17.9 2.4 25.2 11.3c6.7 8.1 7.5 17.4 7.3 23.2c-.4 11.3-5.2 23.4-9.7 33.1c-7 15-17.1 31.8-26.4 46.2C489.8 162.5 512 223.5 512 289.7C512 381.5 437.5 456 345.7 456l-1.7 0-66.3 0c-19.9 34.5-56.8 56-97 56l-4.7 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L190.1 432l-28.4-56.8c-2.5-5-2.2-10.9 .7-15.6s8.1-7.6 13.6-7.6l4.7 0c40.2 0 77.1 21.5 97 56zM136 160a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faArrowUpRight = {
  prefix: 'far',
  iconName: 'arrow-up-right',
  icon: [384, 512, [], "e09f", "M328 96c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1L73 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l231-231L88 144c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0z"]
};
const faCircleR = {
  prefix: 'far',
  iconName: 'circle-r',
  icon: [512, 512, [], "e120", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 112 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 44 0 64.8 86.4c8 10.6 23 12.8 33.6 4.8s12.8-23 4.8-33.6L309.8 285c33.6-9.5 58.2-40.4 58.2-77c0-44.2-35.8-80-80-80l-104 0zm80 112l-56 0 0-64 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0z"]
};
const faCartFlatbed = {
  prefix: 'far',
  iconName: 'cart-flatbed',
  icon: [640, 512, ["dolly-flatbed"], "f474", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l48 0c4.4 0 8 3.6 8 8l0 352c0 30.9 25.1 56 56 56l24 0c0 26.5 21.5 48 48 48s48-21.5 48-48l192 0c0 26.5 21.5 48 48 48s48-21.5 48-48l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0-288 0-72 0c-4.4 0-8-3.6-8-8l0-352c0-30.9-25.1-56-56-56L24 0zM240 80l96 0 0 96c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L400 163.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-96 96 0 0 224-320 0 0-224zm-48 0l0 224c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L240 32c-26.5 0-48 21.5-48 48z"]
};
const faDollyFlatbed = faCartFlatbed;
const faBanSmoking = {
  prefix: 'far',
  iconName: 'ban-smoking',
  icon: [512, 512, [128685, "smoking-ban"], "f54d", "M92.9 126.9L385.1 419.1C349.7 447.2 304.8 464 256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1zm165 97.1L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L353.9 320l46.1 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-142.1 0zm32 32l94.1 0 0 32-62.1 0-32-32zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM112 224c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l128.8 0-96-96L112 224z"]
};
const faSmokingBan = faBanSmoking;
const faCircleSortUp = {
  prefix: 'far',
  iconName: 'circle-sort-up',
  icon: [512, 512, ["sort-circle-up"], "e032", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zm0 310.6c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96zM313.4 320l-114.7 0L256 377.4 313.4 320z"]
};
const faSortCircleUp = faCircleSortUp;
const faTerminal = {
  prefix: 'far',
  iconName: 'terminal',
  icon: [576, 512, [], "f120", "M6.3 72.2c-9-9.8-8.3-24.9 1.4-33.9s24.9-8.3 33.9 1.4l184 200c8.5 9.2 8.5 23.3 0 32.5l-184 200c-9 9.8-24.2 10.4-33.9 1.4s-10.4-24.2-1.4-33.9L175.4 256 6.3 72.2zM248 432l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMobileButton = {
  prefix: 'far',
  iconName: 'mobile-button',
  icon: [384, 512, [], "f10b", "M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM192 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHouseMedicalFlag = {
  prefix: 'far',
  iconName: 'house-medical-flag',
  icon: [640, 512, [], "e514", "M496 24l0 8 128 0c8.8 0 16 7.2 16 16l0 128c0 8.8-7.2 16-16 16l-128 0 0 320-48 0 0-320 0-160 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24zM286.3 36.7L416 133l0 59.8L272 85.9 112 204.6 112 432c0 17.7 14.3 32 32 32l256 0c5.8 0 11.3-1.6 16-4.3l0 50.7c-5.2 1-10.5 1.6-16 1.6l-256 0c-44.2 0-80-35.8-80-80l0-191.8L38.3 259.3c-10.6 7.9-25.7 5.7-33.6-5s-5.7-25.7 5-33.6l248-184c8.5-6.3 20.1-6.3 28.6 0zM240 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faBasketShopping = {
  prefix: 'far',
  iconName: 'basket-shopping',
  icon: [576, 512, ["shopping-basket"], "f291", "M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM93.5 240l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9-389 0zM224 312l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm64-24c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm112 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faShoppingBasket = faBasketShopping;
const faTape = {
  prefix: 'far',
  iconName: 'tape',
  icon: [576, 512, [], "f4db", "M224 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zM362.6 432c52-41 85.4-104.6 85.4-176C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-189.4 0zM224 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faChestnut = {
  prefix: 'far',
  iconName: 'chestnut',
  icon: [448, 512, [127792], "e3f6", "M154 90.5c13.9-11.4 27.8-22.7 41.1-34.8c7.6-6.9 12.7-12.3 15.5-16.6c3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6c13.3 12.1 27.2 23.4 41.1 34.8c19.6 16.1 39.3 32.1 57.3 50.2C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128l-192 0C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3c18.1-18.1 37.7-34.1 57.3-50.2zM393.3 384L54.7 384C67 412.3 95.2 432 128 432l192 0c32.8 0 61-19.7 73.3-48zm-76-209.4c-13.6-13.6-28.6-26.3-45.2-39.9c-2.7-2.2-5.5-4.5-8.2-6.8c0 0 0 0 0 0c-12.8-10.5-26.6-21.7-39.9-33.6c-13.3 11.9-27.1 23.1-39.9 33.6c0 0 0 0 0 0c-2.8 2.3-5.6 4.5-8.2 6.8c-16.6 13.6-31.6 26.3-45.2 39.9C88.9 216.4 53.4 268 48.6 336l350.9 0c-4.8-68-40.3-119.6-82.1-161.4z"]
};
const faBusSimple = {
  prefix: 'far',
  iconName: 'bus-simple',
  icon: [448, 512, ["bus-alt"], "f55e", "M51.5 96l345.7 0C381.4 78.9 335.2 48 224 48C121.8 48 69.8 78.3 51.5 96zM400 144L48 144l0 80 352 0 0-80zm0 128L48 272l0 104c0 13.3 10.7 24 24 24l228.2 0 75.8 0c13.3 0 24-10.7 24-24l0-104zM10.2 70C35.9 38.7 103.8 0 224 0C352.6 0 414 38.6 438.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9L448 376c0 25-12.7 47-32 59.9l0 52.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-67.8 0L80 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-52.1C12.7 423 0 401 0 376L0 100.4C0 91.6 2 80 10.2 70zM112 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBusAlt = faBusSimple;
const faEye = {
  prefix: 'far',
  iconName: 'eye',
  icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
};
const faFaceSadCry = {
  prefix: 'far',
  iconName: 'face-sad-cry',
  icon: [512, 512, [128557, "sad-cry"], "f5b3", "M400 406.1L400 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4L160 288c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
const faSadCry = faFaceSadCry;
const faHeat = {
  prefix: 'far',
  iconName: 'heat',
  icon: [448, 512, [], "e00c", "M176 32c13.3 0 24 10.7 24 24l0 88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144l0-88c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24l0 37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8l0 37.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-37.9c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9L0 120c0-13.3 10.7-24 24-24zm328 24l0 37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8l0 37.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-37.9c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9l0-37.9c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faTicketAirline = {
  prefix: 'far',
  iconName: 'ticket-airline',
  icon: [640, 512, ["ticket-perforated-plane", "ticket-plane"], "e29a", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-35c-41.4-10.7-72-48.2-72-93s30.6-82.3 72-93l0-35c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 61.3c0 11.2-12.8 18.7-24 18.7c-26.5 0-48 21.5-48 48s21.5 48 48 48c11.2 0 24 7.5 24 18.7l0 61.3c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm432 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM186.7 224l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5l31.1 0c8.5 0 16.4 4.5 20.7 11.9L262.7 224l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5C334.4 281.6 319 288 302.9 288l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.4-7.6-10.5L186.7 288 144 288l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4l-13.8 0c-5.2 0-9-4.9-7.8-9.9L103 259.9c.6-2.5 .6-5.2 0-7.8L90.5 201.9c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L144 224l42.7 0z"]
};
const faTicketPerforatedPlane = faTicketAirline;
const faTicketPlane = faTicketAirline;
const faBootHeeled = {
  prefix: 'far',
  iconName: 'boot-heeled',
  icon: [512, 512, [], "e33f", "M31.3 0C14 0 0 14 0 31.3c0 1.8 .1 3.9 .6 6.2C2.6 47.1 24 154.3 24 232c0 33.2-12.8 93.5-19.7 123.2C1.6 367 0 379.3 0 391.8L0 440l0 48c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-22.7 121.6 40.5c12.2 4.1 25 6.2 37.9 6.2L456 512l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-33.3c0-28.1-16.3-53.6-41.8-65.4L313.8 307.9c-25.5-11.8-41.8-37.3-41.8-65.4L272 24c0-13.3-10.7-24-24-24L31.3 0zM432 430.7l0 33.3-144.4 0c-7.7 0-15.4-1.2-22.8-3.7L135.6 417.2c-2.4-.8-5-1.2-7.6-1.2l-24 0-56 0 0-24.2c0-8.5 1.1-17.2 3.1-25.8C57.6 337.7 72 271.8 72 232C72 167.4 58.5 85.7 51.5 48L96 48l0 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184 80 0 0 194.6c0 46.8 27.2 89.3 69.7 109l124.3 57.4c8.5 3.9 13.9 12.4 13.9 21.8z"]
};
const faArrowsMinimize = {
  prefix: 'far',
  iconName: 'arrows-minimize',
  icon: [512, 512, ["compress-arrows"], "e0a5", "M23 23c9.4-9.4 24.6-9.4 33.9 0l119 119L176 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 13.3-10.7 24-24 24L56 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l86.1 0L23 57c-9.4-9.4-9.4-24.6 0-33.9zM489 23c9.4 9.4 9.4 24.6 0 33.9l-119 119 86.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24l0 86.1L455 23c9.4-9.4 24.6-9.4 33.9 0zM56 336c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-86.1L57 489c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l119-119L56 336zm232-24c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-86.1 0L489 455c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-119-119 0 86.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z"]
};
const faCompressArrows = faArrowsMinimize;
const faAudioDescription = {
  prefix: 'far',
  iconName: 'audio-description',
  icon: [576, 512, [], "f29e", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm213.5 77.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9-82.2 0-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2 42.2 0zM304 184c0-13.3 10.7-24 24-24l56 0c53 0 96 43 96 96s-43 96-96 96l-56 0c-13.3 0-24-10.7-24-24l0-144zm48 24l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"]
};
const faPersonMilitaryToPerson = {
  prefix: 'far',
  iconName: 'person-military-to-person',
  icon: [512, 512, [], "e54c", "M71 12.5L182.2 .1C191.7-1 200 6.5 200 16l0 14.1c0 8.8-7.2 16-16 16l-111.1 0C63.6 46.1 56 38.6 56 29.2c0-8.6 6.5-15.8 15-16.8zM384 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM336 256l0 16 96 0 0-16c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-48 0c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32zM66 80l124 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-5.5 .7-10.9 2-16zM224 432c0 6.9-3 13.5-8.2 18.1l-64 56c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9L136.1 456 24 456c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.1 0-15.9-13.9c-10-8.7-11-23.9-2.3-33.9s23.9-11 33.9-2.3l64 56c5.2 4.6 8.2 11.1 8.2 18.1zm72.2 18.1c-5.2-4.6-8.2-11.1-8.2-18.1s3-13.5 8.2-18.1l64-56c10-8.7 25.1-7.7 33.9 2.3s7.7 25.1-2.3 33.9L375.9 408 488 408c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112.1 0 15.9 13.9c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-64-56zM32 256c0-18.8 8.1-35.7 21-47.4l144.2 111c-1.7 .3-3.4 .4-5.2 .4L64 320c-17.7 0-32-14.3-32-32l0-32zm192 32c0 3.7-.6 7.2-1.8 10.5L85.1 192.9c3.6-.6 7.2-.9 10.9-.9l64 0c35.3 0 64 28.7 64 64l0 32z"]
};
const faFileShield = {
  prefix: 'far',
  iconName: 'file-shield',
  icon: [576, 512, [], "e4f0", "M64 464l246.7 0c11 14.4 24.1 28.1 39.5 40.4c-9 4.8-19.3 7.6-30.2 7.6L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 52.5-48 19.2 0-66.2-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"]
};
const faHexagon = {
  prefix: 'far',
  iconName: 'hexagon',
  icon: [512, 512, [11043], "f312", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24L365.1 420.9c-4.3 7.4-12.2 12-20.8 12l-176.6 0c-8.6 0-16.5-4.6-20.8-12L58.6 268z"]
};
const faManhole = {
  prefix: 'far',
  iconName: 'manhole',
  icon: [512, 512, [], "e1d6", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM281.4 115.4c5.8-7.5 14.5-14.7 23.6-11.8c64.4 20.7 111 81.1 111 152.4s-46.6 131.7-111 152.4c-9 2.9-17.8-4.3-23.6-11.8c-5.8-7.6-15.1-12.6-25.4-12.6s-19.6 4.9-25.4 12.6c-5.8 7.5-14.5 14.7-23.6 11.8C142.6 387.7 96 327.3 96 256s46.6-131.7 111-152.4c9-2.9 17.8 4.3 23.6 11.8c5.8 7.6 15.1 12.6 25.4 12.6s19.6-4.9 25.4-12.6zM192 176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm80-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-32 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
const faUserSlash = {
  prefix: 'far',
  iconName: 'user-slash',
  icon: [640, 512, [], "f506", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM290.5 202.4l-35.6-27.9C245.5 161.4 240 145.3 240 128c0-44.2 35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80c-10.4 0-20.4-2-29.5-5.6zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c3.9 0 7.6-.7 11-2.1L467.1 464l-321.8 0c8.9-63.3 63.3-112 129-112l50.6 0-60.6-47.7z"]
};
const faPen = {
  prefix: 'far',
  iconName: 'pen',
  icon: [512, 512, [128394], "f304", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L321 129 383 191 154.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4z"]
};
const faTowerObservation = {
  prefix: 'far',
  iconName: 'tower-observation',
  icon: [512, 512, [], "e586", "M245.7 2.3c6.5-3.1 14.1-3.1 20.6 0l168 80c12 5.7 17 20 11.3 32c-5.3 11.2-18.2 16.4-29.7 12.3l0 73.4c0 27.2-19.4 49.9-45.2 55l34.8 209 82.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l82.3 0 34.8-209c-25.7-5-45.2-27.7-45.2-55l0-73.4c-11.4 4.1-24.3-1.1-29.7-12.3c-5.7-12-.6-26.3 11.4-32l168-80zM256 50.6L144 103.9l0 24.1 224 0 0-24.1L256 50.6zM144 176l0 24c0 4.4 3.6 8 8 8l208 0c4.4 0 8-3.6 8-8l0-24-224 0zM330.8 464L256 400.7 181.2 464l149.7 0zM189.7 256l-3.7 22.5L256 337.8l70.1-59.3L322.3 256l-132.7 0zm-12.9 77.6l-13.8 83 55.9-47.3-42.1-35.6zm116.4 35.6l55.9 47.3-13.8-83-42.1 35.6z"]
};
const faFloppyDisks = {
  prefix: 'far',
  iconName: 'floppy-disks',
  icon: [512, 512, [], "e183", "M144 352c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-213.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9-33.9 33.9L384.8 52.7c-.3-.3-.5-.5-.8-.8l0 68.1c0 13.3-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24l0-72-16 0c-8.8 0-16 7.2-16 16l0 288zM224 0L373.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L512 352c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64L96 64c0-35.3 28.7-64 64-64l16 0 48 0zm0 48l0 48 112 0 0-48L224 48zM48 120l0 256c0 48.6 39.4 88 88 88l256 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-256 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24zM240 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faToiletPaperBlankUnder = {
  prefix: 'far',
  iconName: 'toilet-paper-blank-under',
  icon: [512, 512, ["toilet-paper-reverse-alt"], "e29f", "M71 84.3C85.4 56.9 101.1 48 112 48l212.7 0c-3 4.5-5.7 9.3-8.2 14.1C298.5 96.6 288 142.5 288 192s10.5 95.4 28.5 129.9c2.5 4.8 5.3 9.5 8.2 14.1L112 336c-10.9 0-26.6-8.9-41-36.3C57.2 273.3 48 235.3 48 192s9.2-81.3 23-107.7zM400 48c10.9 0 26.6 8.9 41 36.3c13.8 26.3 23 64.3 23 107.7s-9.2 81.3-23 107.7c-14.4 27.5-30.1 36.3-41 36.3s-26.6-8.9-41-36.3c-13.8-26.3-23-64.3-23-107.7s9.2-81.3 23-107.7C373.4 56.9 389.1 48 400 48zm64 303.1L464 456c0 4.4-3.6 8-8 8l-240 0c-4.4 0-8-3.6-8-8l0-40-48 0 0 40c0 30.9 25.1 56 56 56l240 0c30.9 0 56-25.1 56-56l0-264c0-49.5-10.5-95.4-28.5-129.9C466 28.7 437.7 0 400 0L112 0C74.3 0 46 28.7 28.5 62.1C10.5 96.6 0 142.5 0 192s10.5 95.4 28.5 129.9C46 355.3 74.3 384 112 384l288 0c25.9 0 47.4-13.6 64-32.9zM424 192c0-26.5-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48s24-21.5 24-48z"]
};
const faToiletPaperReverseAlt = faToiletPaperBlankUnder;
const faFileCode = {
  prefix: 'far',
  iconName: 'file-code',
  icon: [384, 512, [], "f1c9", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
const faSignal = {
  prefix: 'far',
  iconName: 'signal',
  icon: [640, 512, [128246, "signal-5", "signal-perfect"], "f012", "M576 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM448 96c13.3 0 24 10.7 24 24l0 368c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-368c0-13.3 10.7-24 24-24zM320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faSignal5 = faSignal;
const faSignalPerfect = faSignal;
const faPump = {
  prefix: 'far',
  iconName: 'pump',
  icon: [640, 512, [], "e442", "M88 0C74.7 0 64 10.7 64 24s10.7 24 24 24l8 0 0 160-48 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32L0 376l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 272 0 0-48L48 352l0-96 72 0c13.3 0 24-10.7 24-24l0-184 96 0 0 184c0 13.3 10.7 24 24 24l56 0 0-48-32 0 0-160 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L264 0 120 0 88 0zM458.5 146.7c2.6-1.8 5.7-2.7 8.9-2.7L576 144c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-108.6 0c-3.2 0-6.2-.9-8.9-2.7l-51.4-34.2c-4.4-3-7.1-8-7.1-13.3l0-219.5c0-5.3 2.7-10.3 7.1-13.3l51.4-34.3zM431.9 501.3c10.5 7 22.9 10.7 35.5 10.7L576 512c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L467.4 96c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3l0 219.5c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-8.8 0-16 7.2-16 16z"]
};
const faBus = {
  prefix: 'far',
  iconName: 'bus',
  icon: [576, 512, [128653], "f207", "M363.7 96l97.5 0C445.4 78.9 399.2 48 288 48C185.8 48 133.8 78.3 115.5 96l96.8 0c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16zM464 144l-152 0 0 80 152 0 0-80zm-352 0l0 80 152 0 0-80-152 0zm0 128l0 104c0 13.3 10.7 24 24 24l228.2 0 75.8 0c13.3 0 24-10.7 24-24l0-104-352 0zM74.2 70C99.9 38.7 167.8 0 288 0C416.6 0 478 38.6 502.4 70.6c7.5 9.8 9.6 20.9 9.6 29.9l0 27.6c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 120c0 25-12.7 47-32 59.9l0 52.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-67.8 0L144 448l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-52.1C76.7 423 64 401 64 376l0-120c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l0-27.6C64 91.6 66 80 74.2 70zM176 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHeartCircleXmark = {
  prefix: 'far',
  iconName: 'heart-circle-xmark',
  icon: [576, 512, [], "e501", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
const faArrowUpLeftFromCircle = {
  prefix: 'far',
  iconName: 'arrow-up-left-from-circle',
  icon: [512, 512, [], "e09e", "M184 0L24 0C10.7 0 0 10.7 0 24L0 184c0 13.3 10.7 24 24 24s24-10.7 24-24L48 81.9 295 329c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L81.9 48 184 48c13.3 0 24-10.7 24-24s-10.7-24-24-24zM288 64c-13.3 0-24 10.7-24 24s10.7 24 24 24c97.2 0 176 78.8 176 176s-78.8 176-176 176s-176-78.8-176-176c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"]
};
const faHouseChimney = {
  prefix: 'far',
  iconName: 'house-chimney',
  icon: [576, 512, [63499, "home-lg"], "e3af", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l48 0 0-152c0-22.1 17.9-40 40-40l112 0c22.1 0 40 17.9 40 40l0 152 48 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM336 320l-96 0 0 144 96 0 0-144z"]
};
const faHomeLg = faHouseChimney;
const faWindowMaximize = {
  prefix: 'far',
  iconName: 'window-maximize',
  icon: [512, 512, [128470], "f2d0", "M.3 89.5C.1 91.6 0 93.8 0 96L0 224 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-128c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"]
};
const faDryer = {
  prefix: 'far',
  iconName: 'dryer',
  icon: [448, 512, [], "f861", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 256c-44.7 0-82.3-30.6-93-72l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-53 0c10.7-41.4 48.2-72 93-72c53 0 96 43 96 96s-43 96-96 96zm0 48a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
};
const faFaceFrown = {
  prefix: 'far',
  iconName: 'face-frown',
  icon: [512, 512, [9785, "frown"], "f119", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faFrown = faFaceFrown;
const faChessBishopPiece = {
  prefix: 'far',
  iconName: 'chess-bishop-piece',
  icon: [256, 512, ["chess-bishop-alt"], "f43b", "M64 56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24c0 12.2-9.2 22.3-21 23.8c6.2 6.4 13.2 14.4 20.2 23.8C210.8 129.8 232 168.8 232 216c0 20-5.9 35.9-13.9 48.2c3.7 4.2 5.9 9.7 5.9 15.8c0 11.3-7.8 20.8-18.3 23.3l4.9 48.7-48.2 0-4.8-48-59 0-4.8 48-48.2 0 4.9-48.7C39.8 300.8 32 291.3 32 280c0-6 2.2-11.6 5.9-15.8C29.9 251.9 24 236 24 216c0-47.2 21.2-86.2 40.8-112.4c7-9.4 14.1-17.4 20.2-23.8C73.2 78.3 64 68.2 64 56zm93.3 200l7.5-5.1c9.6-6.5 19.2-16.9 19.2-34.9c0-13.8-2.6-26.9-6.9-39.2L161 193c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l26.1-26.1-.4-.5c-8.1-10.8-16.2-19.3-22.2-25.1c-.9-.9-1.8-1.7-2.6-2.5c-.8 .8-1.7 1.6-2.6 2.5c-6 5.8-14.1 14.4-22.2 25.1C86.8 154.2 72 183.2 72 216c0 18.1 9.6 28.5 19.2 34.9l7.5 5.1 58.7 0zM69.2 432L52.7 464l150.7 0-16.6-32L69.2 432zm-9.7-48l137 0c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384z"]
};
const faChessBishopAlt = faChessBishopPiece;
const faShirtTankTop = {
  prefix: 'far',
  iconName: 'shirt-tank-top',
  icon: [384, 512, [], "e3c9", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24c0 127.9-26.8 181-41.5 200.5C12.9 237.2 0 257.2 0 280.7L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-167.3c0-23.5-12.9-43.5-22.5-56.3C346.8 205 320 151.9 320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48zM99.3 160.2C122.6 184.7 155.5 200 192 200s69.4-15.3 92.7-39.8c10.3 46.7 25.2 75.5 38.5 93.1c8.6 11.4 12.8 20.5 12.8 27.3L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-167.3c0-6.8 4.2-15.9 12.8-27.3c13.3-17.6 28.2-46.5 38.5-93.1z"]
};
const faDiploma = {
  prefix: 'far',
  iconName: 'diploma',
  icon: [640, 512, ["scroll-ribbon"], "f5ea", "M320 80.3L302 59.7C286.6 42.1 264.4 32 241 32l-1 0c-44.2 0-80 35.8-80 80c0 11.4 2.4 22.2 6.7 32L96 144c-65.1 .3-96 71.5-96 128c0 56.9 24.1 119.2 81 140.7c10.5 4 22.5 4.2 33.4 1.8L256 383l0 81c0 6.2 3.6 11.9 9.2 14.5s12.3 1.8 17-2.2L320 444.8l37.8 31.5c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5l0-81 141.6 31.5c10.9 2.4 22.9 2.2 33.4-1.8c56.9-21.5 81-83.8 81-140.7c0-56.5-30.9-127.7-96-128l-70.7 0c4.3-9.8 6.7-20.6 6.7-32c0-44.2-35.8-80-80-80l-1 0c-23.4 0-45.6 10.1-61 27.7L320 80.3zM400 144l-8 0-46.4 0c-6.9 0-10.5-8.1-6-13.3l34.5-39.5c5.5-6.3 13.1-10.2 21.3-11.1c1.2-.1 2.3-.2 3.5-.2l1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32zm-105.6 0L240 144c-17.7 0-32-14.3-32-32s14.3-32 32-32l1 0c9.5 0 18.6 4.1 24.8 11.3l34.5 39.5c4.5 5.2 .9 13.3-6 13.3zM240 192l16 0 0 141.8L104 367.6c-1.5 .3-3.1 .5-4.3 .4c-1.1 0-1.6-.2-1.7-.2c0 0 0 0 0 0C68.1 356.5 48 319.7 48 272c0-20.6 5.9-43.3 16.1-59.3C73.6 197.8 84 192.1 96.1 192L240 192zm144 0l16 0 143.9 0c12.1 .1 22.6 5.8 32.1 20.7c10.2 16 16.1 38.7 16.1 59.3c0 47.7-20.1 84.5-50 95.8c0 0 0 0 0 0c-.1 0-.6 .2-1.7 .2c-1.3 .1-2.8-.1-4.3-.4L384 333.8 384 192z"]
};
const faScrollRibbon = faDiploma;
const faScreencast = {
  prefix: 'far',
  iconName: 'screencast',
  icon: [576, 512, [], "e23e", "M512 80L64 80c-8.8 0-16 7.2-16 16l0 97.1c-7.9-.7-15.9-1.1-24-1.1L0 192 0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-224 0 0-24c0-8.1-.4-16.1-1.1-24L512 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16zM24 224c128.1 0 232 103.9 232 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 344c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24z"]
};
const faWalker = {
  prefix: 'far',
  iconName: 'walker',
  icon: [448, 512, [], "f831", "M186.4 48L320 48c22.1 0 40 17.9 40 40l0 88-236 0 23.5-97.4c4.3-18 20.4-30.6 38.9-30.6zM360 224l0 164.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L408 88c0-48.6-39.4-88-88-88L186.4 0c-40.6 0-76 27.8-85.5 67.4L.7 482.4c-3.1 12.9 4.8 25.9 17.7 29s25.9-4.8 29-17.7L112.4 224 360 224zm24 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faPrescription = {
  prefix: 'far',
  iconName: 'prescription',
  icon: [448, 512, [], "f5b1", "M24 0C10.7 0 0 10.7 0 24L0 200l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 78.1 0 128 128L135 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L407 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L441 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119-95.3-95.3C246.6 214.7 288 168.2 288 112C288 50.1 237.9 0 176 0L24 0zM176 176L48 176 48 48l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64z"]
};
const faShop = {
  prefix: 'far',
  iconName: 'shop',
  icon: [640, 512, ["store-alt"], "f54f", "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25C90.8 9.6 106.9 0 124.5 0l391 0c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3c0 21.1-17.1 38.2-38.2 38.2L576 224l0 264c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264-144 0 0 248c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-248-25.8 0C17.1 224 0 206.9 0 185.8zM112 224l0 96 224 0 0-96-224 0zM515.5 48l-391 0L54.7 176l530.6 0L515.5 48zM112 464l224 0 0-96-224 0 0 96z"]
};
const faStoreAlt = faShop;
const faFloppyDisk = {
  prefix: 'far',
  iconName: 'floppy-disk',
  icon: [448, 512, [128190, 128426, "save"], "f0c7", "M48 96l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-245.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm80-16l0 80 144 0 0-80L128 80zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faSave = faFloppyDisk;
const faVihara = {
  prefix: 'far',
  iconName: 'vihara',
  icon: [640, 512, [], "f6a7", "M308.5 61.4c-31 21.7-64.8 39-100.5 51.3l0 47.3 112 0 112 0 0-47.3c-35.7-12.3-69.5-29.6-100.5-51.3L320 53.3l-11.5 8.1zm173.2 65.8l-1.7-.5 0 39.7 1.7 1.9 2.5 2.9c27.3 31.5 62.5 55.1 102.1 68.3l4.8 1.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 7s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-7 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4L544 288l0 36.6 4.3 7.4 1.9 3.3c17.2 29.6 43.4 52.9 74.8 66.5c8.8 3.6 15 12.2 15 22.3c0 13.3-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-184 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-184 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-40 0c-13.3 0-24-10.7-24-24c0-10.1 6.2-18.7 15-22.3c31.4-13.6 57.6-36.9 74.8-66.5l1.9-3.3 4.3-7.4L96 288l-39.4 0c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l4.8-1.6c39.5-13.2 74.8-36.8 102.1-68.3l2.5-2.9 1.7-1.9 0-39.7-1.7 .5c-12.8 3.5-26-4.1-29.5-16.8s4.1-26 16.8-29.5l23.6-6.4C209.2 63.5 247 45.8 281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23.6 6.4c12.8 3.5 20.3 16.7 16.8 29.5s-16.7 20.3-29.5 16.8zM496 320l0-32-176 0-176 0 0 32 176 0 176 0zM152.8 240L320 240l167.2 0c-12.3-9.6-23.9-20.3-34.5-32L320 208l-132.7 0c-10.6 11.7-22.2 22.4-34.5 32zM100.5 400L320 400l219.5 0c-9.5-9.8-18.1-20.5-25.5-32l-194 0-194 0c-7.5 11.5-16 22.2-25.5 32z"]
};
const faFaceKissClosedEyes = {
  prefix: 'far',
  iconName: 'face-kiss-closed-eyes',
  icon: [512, 512, [], "e37d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM175.6 220c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
const faScaleUnbalanced = {
  prefix: 'far',
  iconName: 'scale-unbalanced',
  icon: [640, 512, ["balance-scale-left"], "f515", "M542.9 16.7c4 12.6-2.9 26.1-15.5 30.2L399.6 87.7c-3.1 32.4-25.5 59.2-55.6 68.6L344 464l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-200 0c-13.3 0-24-10.7-24-24l0-331.7c-14.2-4.5-26.8-12.8-36.4-23.8L127.3 174.9c-12.6 4-26.1-2.9-30.2-15.5s2.9-26.1 15.5-30.2L240.4 88.3c-.3-2.7-.4-5.5-.4-8.3c0-44.2 35.8-80 80-80c29.8 0 55.8 16.3 69.6 40.5L512.7 1.1c12.6-4 26.1 2.9 30.2 15.5zM512 163.8L439.6 288l144.9 0L512 163.8zM386 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 350 574.9 384 512 384s-115.2-34-126-78.9zM56.7 416l144.9 0L129.2 291.8 56.7 416zm72.4 96C66.3 512 14 478 3.2 433.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C244.3 478 192 512 129.2 512zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBalanceScaleLeft = faScaleUnbalanced;
const faFileUser = {
  prefix: 'far',
  iconName: 'file-user',
  icon: [384, 512, [], "f65c", "M304 464c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-16 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16l-16 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM256 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faUserPoliceTie = {
  prefix: 'far',
  iconName: 'user-police-tie',
  icon: [448, 512, [], "e334", "M217.9 .8l-152 40c-8.6 2.3-15.3 9.1-17.3 17.8s1 17.8 7.8 23.6L80 102.5l0 8.4c0 10.7 5.3 20.8 15.1 25.2c24.1 10.8 68.6 24 128.9 24s104.8-13.2 128.9-24c9.8-4.4 15.1-14.5 15.1-25.2l0-8.4 23.6-20.2c6.8-5.8 9.8-14.9 7.8-23.6s-8.7-15.6-17.3-17.8l-152-40c-4-1.1-8.2-1.1-12.2 0zM221 48.6c1.9-.8 4-.8 5.9 0l32 12.8c3 1.2 5 4.2 5 7.4c0 17.2-7 46.1-36.9 58.6c-2 .8-4.2 .8-6.2 0C191 114.9 184 86 184 68.8c0-3.3 2-6.2 5-7.4l32-12.8zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-7.9-.7-15.7-2.1-23.2c-14 5.4-28.5 9.9-43.3 13.4c.4 3.2 .6 6.5 .6 9.8c0 46-37.2 83.2-83.2 83.2s-83.2-37.2-83.2-83.2c0-3.3 .2-6.6 .6-9.8c-14.8-3.6-29.3-8.1-43.3-13.4C96.7 176.3 96 184.1 96 192zm91.6 183.2L208 416l-12.2 48.9c0 0 0 0 0 0l-.5-.9s0 0 0 0L133 360.3c-3-5-8.6-8.1-14.4-7.4C51.8 360.8 0 417.5 0 486.4C0 500.5 11.5 512 25.6 512L168 512s0 0 0 0l1 0 21.2 0 1.7 0s0 0 0 0l64 0s0 0 0 0l1.7 0 21.2 0 1 0s0 0 0 0l142.4 0c14.1 0 25.6-11.5 25.6-25.6c0-68.9-51.8-125.6-118.6-133.5c-5.8-.7-11.4 2.4-14.4 7.4L252.8 464s0 0 0 0l-.5 .9c0 0 0 0 0 0L240 416l20.4-40.8c5.3-10.6-2.4-23.2-14.3-23.2l-44.2 0c-11.9 0-19.6 12.5-14.3 23.2zM139.2 464l-88.3 0c7.2-27 27.3-48.8 53.2-58.5L139.2 464zm257.8 0l-88.3 0 35.1-58.5c25.9 9.7 45.9 31.5 53.2 58.5z"]
};
const faFaceTongueMoney = {
  prefix: 'far',
  iconName: 'face-tongue-money',
  icon: [512, 512, [], "e39d", "M348.3 442.4c2.2-7.7 3.5-15.9 3.7-24.3c30.5-21.1 53.2-52.1 63.3-88.1c3.8-13.7-7.4-26.1-21.6-26.1L352 304l-32 0-128 0-32 0-41.6 0c-14.2 0-25.5 12.4-21.6 26.1c10.1 36 32.8 66.9 63.3 88.1c.2 8.4 1.5 16.5 3.7 24.3C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zm-44.4 16C292.2 471.7 275.1 480 256 480s-36.2-8.3-47.9-21.5c-5.5-6.2-9.8-13.5-12.6-21.6c-2.3-6.5-3.5-13.6-3.5-20.9l0-80 128 0 0 80c0 7.3-1.2 14.4-3.5 20.9c-2.8 8-7.1 15.3-12.6 21.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 120c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.3 9 27.2 11.2l1.1 .3c9.6 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8zm144-16c-8.8 0-16 7.2-16 16l0 9.3c-5.7 1.2-11.6 3.3-17 7.1c-7.5 5.4-12.6 13.5-14.4 23.6c-1.3 7.3-.7 14.5 2.2 21.2c2.9 6.6 7.6 11.3 12.4 14.6c8.4 5.8 19.4 9 27.2 11.2l1.1 .3c9.5 2.7 15.4 4.6 18.8 7c2.6 1.8 2.2 6.4-.6 8c0 0 0 0 0 0c-1.2 .7-3.8 1.6-8.8 1.5c-10.1-.2-22.5-3.9-32-7.1c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6l0 10.8c0 8.8 7.2 16 16 16s16-7.2 16-16l0-8.9c4.8-.9 9.8-2.5 14.4-5.2c9.1-5.5 15-14.4 17-25.9c1.3-7.3 .7-14.5-2.2-21.2c-2.9-6.6-7.6-11.3-12.4-14.6c-7.1-5-15.5-7.2-23.9-9.4c-8.2-2.2-16.4-4.3-23.3-9.1c-2.4-1.7-2.4-5.3 .2-7.2c1-.7 3.1-1.7 7.1-2.1c8.2-.9 18.7 1 27 3.2c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7l0-9.8c0-8.8-7.2-16-16-16zM267.2 355.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6l0 6.8c-4.3 .8-8.7 2.4-12.7 5.2c-5.6 4-9.5 9.8-10.8 17.2c-.9 5.3-.5 10.6 1.7 15.4c2.2 4.8 5.7 8.2 9.3 10.6c6.3 4.2 14.5 6.5 20.4 8.1l.8 .2c7.2 2 11.5 3.3 14.1 5.1c1.9 1.3 1.6 4.6-.4 5.8c0 0 0 0 0 0c-.9 .5-2.8 1.1-6.6 1.1c-7.6-.1-16.9-2.9-24-5.2c-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4l0 7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6l0-6.5c3.6-.6 7.3-1.8 10.8-3.8c6.8-4 11.2-10.5 12.7-18.9c.9-5.3 .5-10.6-1.7-15.4c-2.2-4.8-5.7-8.2-9.3-10.6c-5.4-3.6-11.7-5.2-17.9-6.8c-6.2-1.6-12.3-3.2-17.5-6.6c-1.8-1.2-1.8-3.9 .2-5.2c.7-.5 2.3-1.2 5.3-1.5c6.1-.6 14 .7 20.2 2.3c6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2l0-7.2z"]
};
const faTennisBall = {
  prefix: 'far',
  iconName: 'tennis-ball',
  icon: [512, 512, [127934], "f45e", "M248 463.8c0-55.2 21.1-110.4 63.3-152.6s97.4-63.2 152.6-63.3C459.7 139.5 372.5 52.3 264 48.2c0 55.2-21.1 110.4-63.3 152.6S103.4 264 48.2 264C52.3 372.5 139.5 459.7 248 463.8zm48-3.7C378.8 444 444 378.8 460.2 296c-41.7 1-83.1 17.3-114.9 49.2S297 418.4 296 460.2zM51.9 216c41.7-1 83.1-17.3 114.9-49.2S215 93.6 216 51.9C133.2 68 68 133.2 51.9 216zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faSquareL = {
  prefix: 'far',
  iconName: 'square-l',
  icon: [448, 512, [], "e275", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 56l0 184 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSortUp = {
  prefix: 'far',
  iconName: 'sort-up',
  icon: [320, 512, ["sort-asc"], "f0de", "M160 86.6L70.6 176l178.7 0L160 86.6zM137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"]
};
const faSortAsc = faSortUp;
const faCalendarArrowUp = {
  prefix: 'far',
  iconName: 'calendar-arrow-up',
  icon: [448, 512, ["calendar-upload"], "e0d1", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM200 408l0-102.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L248 408c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faCalendarUpload = faCalendarArrowUp;
const faCommentDots = {
  prefix: 'far',
  iconName: 'comment-dots',
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCommenting = faCommentDots;
const faPlantWilt = {
  prefix: 'far',
  iconName: 'plant-wilt',
  icon: [512, 512, [], "e5aa", "M280 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 18.7c-33.9 8-56 33.6-56 72.4c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4l0-18.7C456 50.1 405.9 0 344 0S232 50.1 232 112l0 36.1c-18.1-12.7-40.2-20.1-64-20.1c-61.9 0-112 50.1-112 112l0 18.7c-33.9 8-56 33.6-56 72.4C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-38.8-22.1-64.4-56-72.4l0-18.7c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32 0 216c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 0-32 0-128zM54.7 311.3c3.2-2.9 9.9-6.7 22.3-7.2c1 .1 2 .2 3.1 .2s2.1-.1 3.1-.2c12.3 .5 19.1 4.3 22.3 7.2c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3c0 0 0 0 0 0c0-11.9 3.8-17.1 6.7-19.8zM400 203.1c0-11.9 3.8-17.1 6.7-19.8c3.5-3.1 11-7.3 25.3-7.3s21.9 4.1 25.3 7.3c2.9 2.6 6.7 7.9 6.7 19.8c0 0 0 0 0 0c0 .1 0 .8-.3 2.3c-.3 1.6-.8 3.7-1.8 6.4c-1.8 5.4-4.9 12.2-9.3 19.9c-5.4 9.3-12.3 19.2-20.7 28.9c-8.3-9.7-15.3-19.6-20.7-28.9c-4.4-7.7-7.4-14.4-9.3-19.9c-.9-2.7-1.4-4.8-1.8-6.4c-.3-1.5-.3-2.2-.3-2.3c0 0 0 0 0 0z"]
};
const faScarf = {
  prefix: 'far',
  iconName: 'scarf',
  icon: [512, 512, [129507], "f7c1", "M306.7 256s0 0 0 0l33.9 33.9L362.7 312 312 362.7 162.4 213.1c-11.7-11.7-18.4-27.7-18.4-44.3c0-10.8 2.8-21.3 8-30.7l41.5-73.8C199.2 54.2 209.9 48 221.4 48l69.1 0c11.6 0 22.2 6.2 27.9 16.3L360 138.1c5.3 9.4 8 20 8 30.7c0 16.6-6.6 32.6-18.3 44.3l-9 9-50.7-50.7 8-8c3.9-3.9 6.1-9.1 6.1-14.6c0-11.4-9.3-20.7-20.7-20.7l-54.6 0c-11.4 0-20.7 9.3-20.7 20.7c0 5.5 2.2 10.7 6.1 14.6L306.7 256s0 0 0 0zm101.8 33.9l-11.9-11.9L374.6 256l9-9c20.8-20.8 32.4-48.9 32.4-78.2c0-19-4.9-37.7-14.2-54.2L360.3 40.8C346.1 15.6 319.5 0 290.6 0L221.4 0c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8C100.9 131.1 96 149.8 96 168.8c0 29.3 11.7 57.5 32.4 78.2L278.1 396.7l30.6 30.6s0 0 0 0l3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408l11.3-11.3L360 382.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360l14.1-14.1L408 334.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3s0 0 0 0l-18.7-18.7zM116.7 276.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6zm48 48l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l112-112-22.6-22.6z"]
};
const faAlbumCirclePlus = {
  prefix: 'far',
  iconName: 'album-circle-plus',
  icon: [576, 512, [], "e48c", "M64 80l320 0c8.8 0 16 7.2 16 16l0 98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faUserNurseHairLong = {
  prefix: 'far',
  iconName: 'user-nurse-hair-long',
  icon: [448, 512, [], "e45e", "M96 70.2L96 128l.3 0c-.2 2.6-.3 5.3-.3 8l0 24 0 11c0 33.9-13.5 66.5-37.5 90.5l-3.9 3.9c-4.2 4.2-6.6 10-6.6 16C48 293.9 58.1 304 70.6 304L224 304l153.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-3.9-3.9c-24-24-37.5-56.6-37.5-90.5l0-11 0-24c0-2.7-.1-5.4-.3-8l.3 0 0-57.8c0-13.3-8.3-25.3-20.8-30l-96-36c-7.2-2.7-15.2-2.7-22.5 0l-96 36C104.3 44.9 96 56.8 96 70.2zM304 160l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l32 0c29.8 0 55.9-16.3 69.6-40.5C257.3 150.4 275.5 160 296 160l8 0zM50 461.9c7.8-38.7 38-69.3 76.4-77.7l52.3 52.3c25 25 65.5 25 90.5 0l52.3-52.3c38.5 8.4 68.6 39 76.4 77.7L50 461.9zm80.4-127C56.9 343.6 0 406 0 481.8c0 15.6 12.6 28.2 28.2 28.2l391.7 0c15.6 0 28.2-12.6 28.2-28.2C448 406 391.1 343.6 317.6 335c-8.7-1-17.2 2.5-23.4 8.7l-58.9 58.9c-6.2 6.2-16.4 6.2-22.6 0l-58.9-58.9c-6.2-6.2-14.7-9.8-23.4-8.7zM208 48c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0 0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8l16 0 0-16z"]
};
const faDiamond = {
  prefix: 'far',
  iconName: 'diamond',
  icon: [512, 512, [9830], "f219", "M249 50.9L50.9 249c-1.9 1.9-2.9 4.4-2.9 7s1 5.2 2.9 7L249 461.1c1.9 1.9 4.4 2.9 7 2.9s5.2-1 7-2.9L461.1 263c1.9-1.9 2.9-4.4 2.9-7s-1-5.2-2.9-7L263 50.9c-1.9-1.9-4.4-2.9-7-2.9s-5.2 1-7 2.9zM17 215L215 17C225.9 6.1 240.6 0 256 0s30.1 6.1 41 17L495 215c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L297 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41z"]
};
const faSquareLeft = {
  prefix: 'far',
  iconName: 'square-left',
  icon: [448, 512, [11013, "arrow-alt-square-left"], "f351", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zM185.4 360.8l-84-91c-3.5-3.8-5.4-8.7-5.4-13.9s1.9-10.1 5.4-13.9l84-91c4.2-4.6 10.1-7.2 16.4-7.2c12.3 0 22.3 10 22.3 22.3l0 41.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 41.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.4-7.2z"]
};
const faArrowAltSquareLeft = faSquareLeft;
const faFaceGrinSquint = {
  prefix: 'far',
  iconName: 'face-grin-squint',
  icon: [512, 512, [128518, "grin-squint"], "f585", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"]
};
const faGrinSquint = faFaceGrinSquint;
const faCircleEllipsisVertical = {
  prefix: 'far',
  iconName: 'circle-ellipsis-vertical',
  icon: [512, 512, [], "e10b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHandHoldingDollar = {
  prefix: 'far',
  iconName: 'hand-holding-dollar',
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24l0 10.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3s0 0 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8l0 10.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11.4c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faHandHoldingUsd = faHandHoldingDollar;
const faGridDividers = {
  prefix: 'far',
  iconName: 'grid-dividers',
  icon: [512, 512, [], "e3ad", "M0 24C0 10.7 10.7 0 24 0L488 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24zM80 176l32 0 0-32-32 0 0 32zM32 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM80 464l32 0 0-32-32 0 0 32zM32 416c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM240 144l0 32 32 0 0-32-32 0zM224 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM400 144l0 32 32 0 0-32-32 0zM384 96l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 368l32 0 0-32-32 0 0 32zm-48-48c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM24 288l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 336c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faChartDiagram = {
  prefix: 'far',
  iconName: 'chart-diagram',
  icon: [512, 512, [], "e695", "M416 80c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 112c-8.8 0-16-7.2-16-16s7.2-16 16-16l320 0zM96 32C60.7 32 32 60.7 32 96s28.7 64 64 64l136 0 0 16-9.9 9.9-28.1 28.1L184 224l-56 0c-48.6 0-88 39.4-88 88l0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40c0-22.1 17.9-40 40-40l56 0 9.9 9.9 28.1 28.1L232 320l0 32-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-32 9.9-9.9 28.1-28.1L328 272l56 0c22.1 0 40 17.9 40 40l0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40c0-48.6-39.4-88-88-88l-56 0-9.9-9.9-28.1-28.1L280 176l0-16 136 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L96 32zM48 432l0-32 32 0 0 32-32 0zm192 0l0-32 32 0 0 32-32 0zm192 0l0-32 32 0 0 32-32 0zM227.9 248L256 219.9 284.1 248 256 276.1 227.9 248z"]
};
const faBacterium = {
  prefix: 'far',
  iconName: 'bacterium',
  icon: [512, 512, [], "e05a", "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-8.6 14.3-16.5 29.5-23.3 45.2l-9.8-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.4 4.5c-4.8 16.8-8.2 34-10 51c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3c.6-3.9 1.4-7.7 2.5-11.5l12.7 5.5c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM207.9 372.9c-.1 .7-.2 1.4-.3 2.1c-3.8 34.6-34.6 59.9-69.4 56.8c-35.1-3.2-61-34.2-58-69.2c4.4-41 20.4-84 42.9-121.4c38-63.4 107.9-131.1 230.5-159.4c34.4-7.9 68.8 13.5 76.8 48s-13.5 68.8-48 76.8C297 226.1 254.9 270.3 232.9 306.9c-10.8 18-21.1 40.8-25 66zM192 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm48-88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faHandPointer = {
  prefix: 'far',
  iconName: 'hand-pointer',
  icon: [448, 512, [], "f25a", "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"]
};
const faDrumSteelpan = {
  prefix: 'far',
  iconName: 'drum-steelpan',
  icon: [576, 512, [], "f56a", "M528 160c0-9.9-8-29.9-55-49.8c-20-8.5-44.3-15.4-71.9-20.6c-1.2 4.1-2.4 8.8-3.6 13.8c-4.5 18.9-7.6 39.2-5.7 53.3c2.2 16.3 10.4 35.1 19.3 51.1c4 7.3 7.9 13.5 10.9 18c19.1-4.5 36.2-9.9 51-16.2c47.1-19.9 55-39.9 55-49.8zM369.1 231.2c-6.9-12.5-14.9-28.8-20.1-46.3c-15.4 8-36 15.1-61 15.1s-45.6-7.1-61-15.1c-5.2 17.5-13.2 33.8-20.1 46.3c-.7 1.3-1.4 2.5-2.1 3.8c25.7 3.3 53.7 5 83.2 5s57.5-1.8 83.2-5c-.7-1.2-1.4-2.5-2.1-3.8zM350.8 92.3c.8-3.2 1.6-6.3 2.3-9.3c-20.6-2-42.4-3-65.1-3s-44.5 1-65.1 3c.8 2.9 1.6 6 2.3 9.3c2.6 11 5.4 24.5 6.7 38.4l.3 .2c2.6 2.3 6.6 5.4 11.8 8.6c10.5 6.4 25.4 12.5 44 12.5s33.5-6.2 44-12.5c5.2-3.2 9.2-6.3 11.8-8.6c.1-.1 .2-.2 .3-.2c1.3-13.9 4.1-27.4 6.7-38.4zM103 209.8c14.8 6.3 31.9 11.7 51 16.2c3-4.5 6.9-10.8 10.9-18c8.9-16 17.1-34.9 19.3-51.1c1.9-14.2-1.1-34.5-5.7-53.3c-1.2-5-2.5-9.7-3.6-13.8c-27.6 5.1-51.9 12.1-71.9 20.6C56 130.1 48 150.1 48 160s8 29.9 55 49.8zM576 160l0 192c0 24.3-11.3 44.9-28.1 61c-16.5 15.8-39.1 28.3-64.8 37.8C431.7 470.1 362.6 480 288 480s-143.7-9.9-195.1-29.1c-25.6-9.6-48.2-22-64.8-37.8C11.3 396.9 0 376.3 0 352L0 160C0 80 128.9 32 288 32s288 48 288 128zm-48 74.9C476.4 269 388.2 288 288 288s-188.4-19-240-53.1L48 352c0 8.2 3.5 16.9 13.3 26.3c10.2 9.7 26.2 19.3 48.4 27.6C153.9 422.4 216.8 432 288 432s134.1-9.6 178.3-26.1c22.1-8.3 38.2-17.8 48.4-27.6c9.9-9.4 13.3-18.2 13.3-26.3l0-117.1z"]
};
const faHandScissors = {
  prefix: 'far',
  iconName: 'hand-scissors',
  icon: [512, 512, [], "f257", "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"]
};
const faHandsPraying = {
  prefix: 'far',
  iconName: 'hands-praying',
  icon: [640, 512, ["praying-hands"], "f684", "M277.8 48c-5.9 0-11.4 2.9-14.8 7.7l-99.8 141c-12.4 17.6-19.1 38.6-19.1 60.1l0 40.2c0 24.1-15.4 45.5-38.3 53.1L31.6 374.8C19 379 5.4 372.2 1.2 359.6S3.8 333.4 16.4 329.2l74.1-24.7c3.3-1.1 5.5-4.1 5.5-7.6l0-40.2c0-31.5 9.8-62.2 28-87.9l99.8-141C236.2 10.4 256.4 0 277.8 0c16.1 0 30.8 5.8 42.2 15.3C331.4 5.8 346.1 0 362.2 0c21.5 0 41.6 10.4 54 27.9l99.8 141c18.2 25.7 28 56.4 28 87.9l0 40.2c0 3.4 2.2 6.5 5.5 7.6l74.1 24.7c12.6 4.2 19.4 17.8 15.2 30.4s-17.8 19.4-30.4 15.2l-74.1-24.7c-22.9-7.6-38.3-29-38.3-53.1l0-40.2c0-21.5-6.7-42.5-19.1-60.1L377 55.7c-3.4-4.8-8.9-7.7-14.8-7.7c-9.6 0-18 8-18.2 18.2l0 .4 0 .4c.1 3.7 1.3 7.4 3.3 10.3L416.5 178c10.1 14.7 15.5 32.1 15.5 49.9l0 8.1 0 60c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-60c0-11-9-20-20-20c-10.9 0-19.8 8.7-20 19.6l0 .4 0 74c0 .3 0 .6 0 .9c.4 46.6 31.8 87.3 76.9 99.5l201.4 54.4c12.8 3.5 20.4 16.6 16.9 29.4s-16.6 20.4-29.4 16.9L408.3 456.7C370.9 446.6 339.9 423 320 392c-19.9 31-50.9 54.6-88.3 64.8L30.3 511.2c-12.8 3.5-26-4.1-29.4-16.9s4.1-26 16.9-29.4l201.4-54.4c45.1-12.2 76.5-52.9 76.9-99.5c0-.3 0-.6 0-.9l0-74 0-.4c-.2-10.8-9.1-19.6-20-19.6c-11 0-20 9-20 20l0 60c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-60 0-8.1c0-17.8 5.4-35.2 15.5-49.9L292.7 77.3c2-2.9 3.2-6.6 3.3-10.3l0-.4 0-.4C295.8 56 287.4 48 277.8 48zM320 122.4L287.9 169c12.1 2.1 23.1 7.5 32.1 15.1c9-7.6 20-13 32.1-15.1L320 122.4z"]
};
const faPrayingHands = faHandsPraying;
const faFacePensive = {
  prefix: 'far',
  iconName: 'face-pensive',
  icon: [512, 512, [], "e384", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 368l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm143.6-84c10.6 0 19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C391.7 317.2 371 324 351.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9c5.5 5.8 14.8 9.7 25.4 9.7zm-217.4-9.7c5.5 5.8 14.8 9.7 25.4 9.7s19.9-3.8 25.4-9.7c7.6-8.1 20.2-8.5 28.3-.9s8.5 20.2 .9 28.3C199.7 317.2 179 324 159.6 324s-40.1-6.8-54.6-22.3c-7.6-8.1-7.1-20.7 .9-28.3s20.7-7.1 28.3 .9zM81.7 215.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5 .7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"]
};
const faUserMusic = {
  prefix: 'far',
  iconName: 'user-music',
  icon: [640, 512, [], "f8eb", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464L288 464s0 0 0 0c0 19.1 7.7 35.4 18.9 48L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c36.3 0 70.1 10.9 98.3 29.5l0 51.6c-3.2 .4-6.5 1-9.6 1.7C335.1 365.2 304 352 269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112zM630 164.5c6.3 4.5 10 11.8 10 19.5l0 48 0 160c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-88.2-144 48L448 464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5L400 296l0-48c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z"]
};
const faArrowRotateRight = {
  prefix: 'far',
  iconName: 'arrow-rotate-right',
  icon: [512, 512, [8635, "arrow-right-rotate", "arrow-rotate-forward", "redo"], "f01e", "M472 224c13.3 0 24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80.1-20-23.5C387 63.4 325.1 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c50.4 0 97-16.7 134.4-44.8c10.6-8 12.7-23 4.8-33.6s-23-12.7-33.6-4.8C332.2 418.9 295.7 432 256 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c54.3 0 102.9 24.6 135.2 63.4l.1 .2s0 0 0 0L418.9 176 328 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0z"]
};
const faArrowRightRotate = faArrowRotateRight;
const faArrowRotateForward = faArrowRotateRight;
const faRedo = faArrowRotateRight;
const faMessagesDollar = {
  prefix: 'far',
  iconName: 'messages-dollar',
  icon: [640, 512, ["comments-alt-dollar"], "f652", "M72 48C58.7 48 48 58.7 48 72l0 176c0 13.3 10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 19.2L202.7 276c3.9-2.6 8.6-4 13.3-4l128 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24L72 48zM0 72C0 32.2 32.2 0 72 0L344 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-120.7 0-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360l0-40-24 0c-39.8 0-72-32.2-72-72L0 72zM256 352l48 0 0 24c0 13.3 10.7 24 24 24l96 0c4.7 0 9.4 1.4 13.3 4L496 443.2l0-19.2c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-120 0 0-48 120 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-24 0 0 40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60L328 448c-39.8 0-72-32.2-72-72l0-24zM224 79.1l0 10.4c5.9 .9 11.6 2.3 16.8 3.6c8.6 2.2 13.7 10.9 11.5 19.5s-10.9 13.7-19.5 11.5c-8.8-2.3-17.3-3.9-25-4c-6.4-.1-13 1.4-17.4 3.9c-3.9 2.2-4.8 4.3-4.8 6.8l0 .1c0 1 0 2.2 4.1 4.6c5.1 3 12.5 5.2 22.7 8.2l.5 .2c9 2.6 20.4 6 29.6 11.6c10.2 6.3 19.6 16.6 19.8 32.8c.2 16.7-8.6 28.6-20 35.5c-5.7 3.4-12 5.7-18.4 7l0 10.3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-10.9c-8.2-1.7-15.8-4.3-22.5-6.5c0 0 0 0 0 0c-1.7-.6-3.3-1.1-4.9-1.6c-8.4-2.7-13-11.7-10.3-20.2s11.7-13 20.2-10.3c2 .7 3.9 1.3 5.8 1.9c0 0 0 0 0 0s0 0 0 0c10.9 3.6 19.2 6.4 28.2 6.6c6.9 .2 13.3-1.3 17.3-3.7c3.3-2 4.6-4.2 4.6-7.7c0-1.8-.4-3.4-4.5-5.9c-5-3.1-12.4-5.4-22.5-8.4l-1.4-.4c-8.7-2.5-19.7-5.8-28.4-10.9c-10.1-5.9-19.8-16-19.9-32.2c-.1-16.8 9.7-28.3 20.8-34.7c5.5-3.2 11.5-5.3 17.6-6.6l0-10.5c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faCommentsAltDollar = faMessagesDollar;
const faSensorOn = {
  prefix: 'far',
  iconName: 'sensor-on',
  icon: [640, 512, [], "e02b", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 96c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm381.3-20c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM536 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm13.3 140c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"]
};
const faBalloon = {
  prefix: 'far',
  iconName: 'balloon',
  icon: [384, 512, [], "e2e3", "M48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 35.8-18.4 74.2-46.5 110.7c-27.5 35.7-60.2 64.2-79 79.3c-7.6 6.1-13.8 13.5-18.4 21.8c-4.6-8.3-10.9-15.8-18.4-21.8c-18.9-15.1-51.5-43.6-79-79.3C66.4 266.2 48 227.8 48 192zM150.7 450.5L144 464l-.1 .1-3 6-11.6 23.2c-.9 1.8-1.4 3.8-1.4 5.8c0 7.1 5.8 12.9 12.9 12.9l25.9 0 6.7 0 .1 0 36.7 0 .1 0 6.7 0 25.9 0c7.1 0 12.9-5.8 12.9-12.9c0-2-.5-4-1.4-5.8l-11.6-23.2-3-6-.1-.1-6.7-13.5c-5.3-10.6-2.1-23.6 7.1-31C281.2 386.9 384 294.6 384 192C384 86 298 0 192 0S0 86 0 192C0 294.6 102.8 386.9 143.6 419.5c9.3 7.4 12.5 20.4 7.1 31zM128 184c0-30.9 25.1-56 56-56c13.3 0 24-10.7 24-24s-10.7-24-24-24C126.6 80 80 126.6 80 184c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faWebAwesome = {
  prefix: 'far',
  iconName: 'web-awesome',
  icon: [640, 512, [], "e682", "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192l102.2-20.4 2.2-.4c-5.3-7.7-8.4-17.1-8.4-27.1c0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48l-9.8 21.8L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L56.2 213.8 46.4 192C20.6 191.1 0 170 0 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1l2.2 .4L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1c0-28.7 23.3-52 52-52s52 23.3 52 52zm44.2 176.1L320 143.8l-96.4 84.3c-11.2 9.8-26.4 13.9-41 10.9L114 225.4l88.7 197.2c2.6 5.7 8.3 9.4 14.6 9.4l205.2 0c6.3 0 12-3.7 14.6-9.4L526 225.4l-68.5 13.7c-14.6 2.9-29.8-1.1-41-10.9z"]
};
const faBiohazard = {
  prefix: 'far',
  iconName: 'biohazard',
  icon: [576, 512, [9763], "f780", "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c3.3-6.2 5.9-12.8 7.3-19.8c-29.9-23.5-51.1-57.5-58.3-96.4c-7.1-2.2-14.4-3.4-21.7-3.8c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c3.8 6.9 8.5 13.3 14.3 18.8c18-7 37.5-10.8 57.9-10.8s40 3.8 57.9 10.8c5.8-5.5 10.5-11.9 14.3-18.8c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM445.3 301.3c-7.2 38.9-28.5 72.9-58.3 96.4c1.5 7 4 13.7 7.3 19.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-7.3 .3-14.6 1.5-21.7 3.8z"]
};
const faChessQueenPiece = {
  prefix: 'far',
  iconName: 'chess-queen-piece',
  icon: [256, 512, ["chess-queen-alt"], "f446", "M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM16 232c0-13.3 10.7-24 24-24l5.1 0L3.6 140.6c-6.4-10.4-4-24 5.7-31.5l2.5-1.9c6.1-4.7 14.1-6.3 21.5-4.1c2.1 .6 4.4 1 6.8 1c11.7 0 21.4-8.3 23.6-19.4c1.9-9.7 9.5-17.3 19.2-19s19.5 2.6 24.7 11C111.8 83.5 119.4 88 128 88s16.2-4.5 20.5-11.4c5.2-8.4 15-12.8 24.7-11s17.4 9.3 19.2 19c2.1 11 11.9 19.4 23.6 19.4c2.4 0 4.7-.3 6.8-1c7.4-2.2 15.4-.6 21.5 4.1l2.5 1.9c9.7 7.5 12.1 21.1 5.7 31.5L211 208l5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-15.2 0 4.4 96-48 0-4.4-96-49.4 0-4.4 96-48 0 4.4-96L40 256c-13.3 0-24-10.7-24-24zm138.6-24l37.1-60.2c-11.6-4.2-21.8-11.2-29.7-20.3c-10.1 5.4-21.6 8.5-33.9 8.5s-23.8-3.1-33.9-8.5c-8 9.1-18.2 16.1-29.7 20.3L101.4 208l53.2 0zM52.7 464l150.7 0-16.6-32L69.2 432 52.7 464zm143.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l137 0z"]
};
const faChessQueenAlt = faChessQueenPiece;
const faLocationCrosshairs = {
  prefix: 'far',
  iconName: 'location-crosshairs',
  icon: [512, 512, ["location"], "f601", "M256 0c13.3 0 24 10.7 24 24l0 41.5C366.8 76.3 435.7 145.2 446.5 232l41.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-41.5 0C435.7 366.8 366.8 435.7 280 446.5l0 41.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-41.5C145.2 435.7 76.3 366.8 65.5 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l41.5 0C76.3 145.2 145.2 76.3 232 65.5L232 24c0-13.3 10.7-24 24-24zM112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm192 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
};
const faLocation = faLocationCrosshairs;
const faMarsDouble = {
  prefix: 'far',
  iconName: 'mars-double',
  icon: [640, 512, [9891], "f227", "M288 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-83.7 83.7C338.7 227.2 352 264.1 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7L366.1 80 312 80c-13.3 0-24-10.7-24-24zM176 432a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM480 158.1L558.1 80 504 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-54.1-83.7 83.7C530.7 227.2 544 264.1 544 304c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12c14.3-11.2 27.1-24.2 38-38.6c8.4 1.7 17.1 2.6 26 2.6c70.7 0 128-57.3 128-128c0-35.7-14.7-68.1-38.3-91.3C471.3 202.5 480 186.3 480 168l0-9.9z"]
};
const faLeftFromBracket = {
  prefix: 'far',
  iconName: 'left-from-bracket',
  icon: [512, 512, [], "e66c", "M160 365.8L50 256 160 146.2l0 53.8c0 13.3 10.7 24 24 24l120 0 0 64-120 0c-13.3 0-24 10.7-24 24l0 53.8zM0 256c0 11.5 4.6 22.5 12.7 30.6L128.8 402.4c8.7 8.7 20.5 13.6 32.8 13.6c25.6 0 46.4-20.8 46.4-46.4l0-33.6 96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0 0-33.6c0-25.6-20.8-46.4-46.4-46.4c-12.3 0-24.1 4.9-32.8 13.6L12.7 225.4C4.6 233.5 0 244.5 0 256zM344 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c48.6 0 88-39.4 88-88l0-272c0-48.6-39.4-88-88-88l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c22.1 0 40 17.9 40 40l0 272c0 22.1-17.9 40-40 40l-80 0z"]
};
const faHousePersonLeave = {
  prefix: 'far',
  iconName: 'house-person-leave',
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM461.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm59 54.6l50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L434 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L439 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l9.5-21.3c17.1-38.5 49.6-68 89.5-81.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L633 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L570 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3zm-101.1 21l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L361 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4zM255.2 5.4L391.9 116.8c-14.8 7.8-28.4 17.5-40.5 28.9L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l200 0 40 0 14.9 0-6.6 16.5L336.8 416 120 416c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0zM160 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z"]
};
const faHouseLeave = faHousePersonLeave;
const faHousePersonDepart = faHousePersonLeave;
const faRulerTriangle = {
  prefix: 'far',
  iconName: 'ruler-triangle',
  icon: [512, 512, [128208], "f61c", "M48 448L48 67.9l66.7 66.7-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1 57.4 57.4-14.1 14.1c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l14.1-14.1L444.1 464 64 464c-8.8 0-16-7.2-16-16zm454.6 6.6L57.4 9.4C51.4 3.4 43.2 0 34.7 0L32 0C14.3 0 0 14.3 0 32L0 448c0 35.3 28.7 64 64 64l416 0c17.7 0 32-14.3 32-32l0-2.7c0-8.5-3.4-16.6-9.4-22.6zM128 256l0 128 128 0L128 256z"]
};
const faCardClub = {
  prefix: 'far',
  iconName: 'card-club',
  icon: [384, 512, [], "e3e9", "M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm66.1 208.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3z"]
};
const faChildDress = {
  prefix: 'far',
  iconName: 'child-dress',
  icon: [320, 512, [], "e59c", "M184 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM88 72a72 72 0 1 1 144 0A72 72 0 1 1 88 72zm-17 129.8c21.3-25.7 52.7-40.9 86-41.8c.7 0 1.4 0 2.2 0l.9 0 .9 0c.7 0 1.4 0 2.2 0c33.3 .9 64.6 16.1 86 41.8l65.4 78.8c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1l-43.1-52 36.3 109c2.4 7.3 1.2 15.4-3.3 21.6s-11.8 10-19.5 10l-24 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-32 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-24 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l36.3-109-43.1 52c-8.5 10.2-23.6 11.6-33.8 3.1S-2.9 290.9 5.5 280.7l65.4-78.8zM160 208c-.5 0-1 0-1.4 0c-3.2 .2-6.1 2.3-7.1 5.5L105.3 352l109.4 0L168.5 213.5c-1-3.1-3.9-5.3-7.1-5.5c-.5 0-1 0-1.4 0z"]
};
const faUsersBetweenLines = {
  prefix: 'far',
  iconName: 'users-between-lines',
  icon: [640, 512, [], "e591", "M24 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 48C10.7 48 0 37.3 0 24S10.7 0 24 0zm0 464l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zM321.6 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-60.5 80.8c4.1-.5 8.3-.8 12.5-.8l48 0 48 0c4.2 0 8.4 .3 12.5 .8c47.1 6.1 83.5 46.4 83.5 95.2c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c0 0 0 0 0 0c10.5-29.7 35.3-52.8 66.1-60.9c0 0 0 0 0 0c3.9-1 7.9-1.8 11.9-2.3zM273.6 240c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80s80 35.8 80 80c0 26.2-12.6 49.4-32 64c0 0 0 0 0 0c-13.4 10-30 16-48 16s-34.6-6-48-16c0 0 0 0 0 0zM392.7 341.9c-6.8-3.8-14.7-5.9-23.1-5.9l-96 0c-20.9 0-38.7 13.4-45.3 32l186.5 0c-2.6-7.3-6.9-13.8-12.4-19c-3.7-1.7-7-4.2-9.8-7.1zM147.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96 256l96 0c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6L64 352c-17.7 0-32-14.3-32-32c0-35.3 28.7-64 64-64zm480 96l-82.4 0c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6l96 0c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32zM499.2 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faLungsVirus = {
  prefix: 'far',
  iconName: 'lungs-virus',
  icon: [640, 512, [], "e067", "M344 24l0 126.4c-7.1-4.1-15.3-6.4-24-6.4s-16.9 2.3-24 6.4L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24zM256 165.3l0 24.1c-14.4-9.6-32.8-10.5-48-2.9l0-21.2c0-11.8-9.6-21.3-21.3-21.3c-6.8 0-12.8 3.2-16.4 8.3c-14.7 21.1-42.3 62.6-67.8 111.6C77 312.8 54.3 367.9 48 417l0 6c0 22.6 18.3 41 41 41c3.4 0 6.7-.4 9.9-1.2l72.7-18.2c6.4-1.6 12.3-4.5 17.3-8.3c1.8 2.9 4 5.6 6.6 8.2c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89l0-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3zm273.4 344l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c2.5-2.5 4.7-5.3 6.6-8.2c5 3.8 10.9 6.7 17.3 8.3l72.7 18.2c3.3 .8 6.6 1.2 9.9 1.2c22.6 0 41-18.3 41-41l0-6c-6.3-49.1-29-104.2-54.4-153.1c-25.5-49-53.1-90.5-67.8-111.6c-3.6-5.1-9.6-8.3-16.4-8.3c-11.8 0-21.3 9.6-21.3 21.3l0 21.2c-15.2-7.6-33.6-6.6-48 2.9l0-24.1C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4l0 7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7zM320 176c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faSpinnerThird = {
  prefix: 'far',
  iconName: 'spinner-third',
  icon: [512, 512, [], "f3f4", "M457 372c11.5 6.6 26.3 2.7 31.8-9.3C503.7 330.2 512 294.1 512 256C512 122.7 410.1 13.2 280 1.1C266.8-.1 256 10.7 256 24s10.8 23.9 24 25.4C383.5 61.2 464 149.2 464 256c0 29.3-6.1 57.3-17 82.6c-5.3 12.2-1.5 26.8 10 33.5z"]
};
const faFaceGrinTears = {
  prefix: 'far',
  iconName: 'face-grin-tears',
  icon: [640, 512, [128514, "grin-tears"], "f588", "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zm160 0s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z"]
};
const faGrinTears = faFaceGrinTears;
const faPhone = {
  prefix: 'far',
  iconName: 'phone',
  icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faComputerMouseScrollwheel = {
  prefix: 'far',
  iconName: 'computer-mouse-scrollwheel',
  icon: [384, 512, ["mouse-alt"], "f8cd", "M336 352l0-192c0-61.9-50.1-112-112-112l-64 0C98.1 48 48 98.1 48 160l0 192c0 61.9 50.1 112 112 112l64 0c61.9 0 112-50.1 112-112zM0 160C0 71.6 71.6 0 160 0l64 0c88.4 0 160 71.6 160 160l0 192c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 160zM192 96c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"]
};
const faMouseAlt = faComputerMouseScrollwheel;
const faCalendarXmark = {
  prefix: 'far',
  iconName: 'calendar-xmark',
  icon: [448, 512, ["calendar-times"], "f273", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faCalendarTimes = faCalendarXmark;
const faChildReaching = {
  prefix: 'far',
  iconName: 'child-reaching',
  icon: [384, 512, [], "e59d", "M192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 192 0a72 72 0 1 0 0 144zm-.2 32c-41.6 0-80-22.4-100.6-58.5L76.9 92.2c-6.5-11.5-21.2-15.6-32.7-9s-15.6 21.2-9 32.7l14.4 25.3c15 26.5 36.8 47.7 62.5 62.1L112 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 64 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-285c25-14 46.2-34.6 61.1-60.2l15.6-26.7c6.7-11.4 2.8-26.1-8.6-32.8s-26.1-2.8-32.8 8.6l-15.6 26.7C271 154.2 232.9 176 191.8 176zM224 336l-64 0 0-115.1c10.4 2.1 21 3.1 31.8 3.1c10.9 0 21.7-1.1 32.2-3.2L224 336z"]
};
const faTableLayout = {
  prefix: 'far',
  iconName: 'table-layout',
  icon: [512, 512, [], "e290", "M448 80c8.8 0 16 7.2 16 16l0 64L48 160l0-64c0-8.8 7.2-16 16-16l384 0zM48 416l0-208 96 0 0 224-80 0c-8.8 0-16-7.2-16-16zm144 16l0-224 272 0 0 208c0 8.8-7.2 16-16 16l-256 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faNarwhal = {
  prefix: 'far',
  iconName: 'narwhal',
  icon: [640, 512, [], "f6fe", "M639.4 20.5c2.3-7.7-1.6-16-9-19.2s-16-.4-20.1 6.5L516 167.3c-15.7-4.7-32.3-7.3-49.6-7.3c-53.1 0-104.4 19.5-144.1 54.8L177.9 343.2c-6.4 5.7-14.6 8.8-23.1 8.8c-19.2 0-34.8-15.6-34.8-34.8l0-13.2 0-45.3 37.9-26.5c21.4-15 34.1-39.4 34.1-65.5l0-54.7c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1L96 148.5 25.2 98.9c-4.9-3.4-11.3-3.8-16.6-1.1S0 106 0 112l0 54.7c0 26.1 12.7 50.6 34.1 65.5L72 258.7 72 304l0 13.2L72 352c0 88.4 71.6 160 160 160l232 0c97.2 0 176-80 176-177.2c0-50.1-21.2-95.5-55.1-127.5L639.4 20.5zM232 464c-46.3 0-86-28.1-103.1-68.1c8.1 2.7 16.8 4.1 25.9 4.1c20.3 0 39.8-7.4 55-20.9L354.2 250.7c30.9-27.5 70.9-42.7 112.2-42.7C535.4 208 592 265 592 334.8C592 405.9 534.3 464 464 464l-232 0zM496 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faRampLoading = {
  prefix: 'far',
  iconName: 'ramp-loading',
  icon: [448, 512, [], "f4d4", "M96 48l256 0c8.8 0 16 7.2 16 16l0 248.4 48 88L416 64c0-35.3-28.7-64-64-64L96 0C60.7 0 32 28.7 32 64l0 336.4 48-88L80 64c0-8.8 7.2-16 16-16zm67 240c-20.5 0-39.3 11.2-49.2 29.2l-74 135.7C25.3 479.5 44.6 512 75 512L373 512c30.4 0 49.7-32.5 35.1-59.2l-74-135.7c-9.8-18-28.7-29.2-49.2-29.2l-122 0zm-7 52.2c1.4-2.6 4.1-4.2 7-4.2l122 0c2.9 0 5.6 1.6 7 4.2L359.6 464 88.4 464 156 340.2z"]
};
const faCalendarCirclePlus = {
  prefix: 'far',
  iconName: 'calendar-circle-plus',
  icon: [576, 512, [], "e470", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-48 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faToothbrush = {
  prefix: 'far',
  iconName: 'toothbrush',
  icon: [576, 512, [129701], "f635", "M64 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l224 0c29.4 0 55.1-11.9 71-36.1c4.3-6.5 7.4-13.2 9.7-19.9c6.4 2.7 12 6 16.6 9.7c9.5 7.7 14.6 17 14.6 30.3c0 26.5-21.5 48-48 48L64 176zM0 160c0 35.3 28.7 64 64 64l288 0c53 0 96-43 96-96c0-58.5-51.6-89.9-104-95.2c-8.8-.9-15.8 6.4-16.4 15.2c-1.5 25.3-8.4 48-39.6 48L64 96C28.7 96 0 124.7 0 160zM80 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 80 0 80 0 80 0 80 0 176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-152 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 152-32 0 0-152z"]
};
const faBorderInner = {
  prefix: 'far',
  iconName: 'border-inner',
  icon: [448, 512, [], "f84e", "M416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zM32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm32 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 64c-13.3 0-24-10.7-24-24l0-176L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0 0-176c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176 176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0 0 176c0 13.3-10.7 24-24 24z"]
};
const faPawClaws = {
  prefix: 'far',
  iconName: 'paw-claws',
  icon: [512, 512, [], "f702", "M178.1 15.3L138.9 58.4C121.6 77.4 112 102.3 112 128c0 0 0 0 0 0c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2l0-50.5c0-7.3-9-10.8-13.9-5.4zm132 206.3c32.3 10.6 70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0 0 0 0 0 0c0-25.7-9.6-50.6-26.9-69.6L333.9 15.3C329 9.9 320 13.4 320 20.7l0 50.5c-18.3 9.8-34.3 28.9-42.5 53.6c-14.3 42.9 .3 86.2 32.6 96.8zm-209.7 8.9C91.1 214.7 77.9 203 64 196.8l0-44.2c0-7.7-9.9-11-14.5-4.7L12.2 199.2C4.3 210.1 0 223.3 0 236.8L0 240s0 0 0 0c-.1 13.3 3.7 27.8 11.6 41.4c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1zM256 304c20.6 0 96.1 15.4 141.7 137.7c1.4 3.7 2.3 8.5 2.3 14.2c0 4.5-3.6 8.1-8.1 8.1l-3.4 0c-2.2 0-4.3-.4-6.3-1.2l-72.7-29.1c-34.3-13.7-72.6-13.7-107 0l-72.7 29.1c-2 .8-4.2 1.2-6.3 1.2l-3.4 0c-4.5 0-8.1-3.6-8.1-8.1c0-5.7 .9-10.4 2.3-14.2C159.9 319.4 235.4 304 256 304zm0-48c-41.2 0-134.3 28.4-186.7 169c-3.7 9.9-5.3 20.4-5.3 31c0 31 25.1 56.1 56.1 56.1l3.4 0c8.3 0 16.5-1.6 24.2-4.7l72.7-29.1c22.9-9.2 48.4-9.2 71.3 0l72.7 29.1c7.7 3.1 15.9 4.7 24.2 4.7l3.4 0c31 0 56.1-25.1 56.1-56.1c0-10.5-1.6-21.1-5.3-31C390.3 284.4 297.2 256 256 256zm165.8 58.7c24.5 14 59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4c0 0 0 0 0 0l0-3.2c0-13.5-4.3-26.7-12.2-37.6l-37.3-51.3c-4.6-6.3-14.5-3-14.5 4.7l0 44.2c-13.9 6.1-27.1 17.8-36.4 33.7c-18.9 32.4-14.3 70.1 10.2 84.1z"]
};
const faKiwiFruit = {
  prefix: 'far',
  iconName: 'kiwi-fruit',
  icon: [448, 512, [], "e30c", "M399.8 265.3C358.7 298.6 295.3 320 224 320s-134.7-21.4-175.8-54.7C53.1 358.2 129.9 432 224 432s170.9-73.8 175.8-166.7zM448 176l0 80c0 123.7-100.3 224-224 224S0 379.7 0 256l0-80C0 96.5 100.3 32 224 32s224 64.5 224 144zM224 64c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM64 176c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm256 0c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm-96 56c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24c0-8.8-7.2-16-16-16zM139.3 92.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zm192 0c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6zm-176 150.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16zM280 176c0-13.3-25.1-24-56-24s-56 10.7-56 24s25.1 24 56 24s56-10.7 56-24z"]
};
const faTrafficLightSlow = {
  prefix: 'far',
  iconName: 'traffic-light-slow',
  icon: [320, 512, [], "f639", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-120a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM144 136a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"]
};
const faRectangleCode = {
  prefix: 'far',
  iconName: 'rectangle-code',
  icon: [512, 512, [], "e322", "M448 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM287 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0zM225 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"]
};
const faHeadSideVirus = {
  prefix: 'far',
  iconName: 'head-side-virus',
  icon: [512, 512, [], "e064", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zM224 72c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 160.1 129 200 96 200c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 294.5 208 311 208 344c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 271.9 319 232 352 232c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 137.5 240 121 240 88c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faKeyboardBrightness = {
  prefix: 'far',
  iconName: 'keyboard-brightness',
  icon: [640, 512, [], "e1c0", "M129 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80zm167 33c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112zm135 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80zM0 392c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm216-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zm320 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
};
const faBooksMedical = {
  prefix: 'far',
  iconName: 'books-medical',
  icon: [576, 512, [], "f7e8", "M112 416l0 48 64 0 0-48-64 0zm88 89.6c-7.1 4.1-15.3 6.4-24 6.4l-64 0c-26.5 0-48-21.5-48-48l0-48 0-24 0-8 112 0 0-16 0-48 48 0 0 48 64 0 0-224-64 0 0 48-48 0 0-48 0-16L64 128l0-8 0-24 0-48C64 21.5 85.5 0 112 0l64 0c8.7 0 16.9 2.3 24 6.4C207.1 2.3 215.3 0 224 0l64 0c20.6 0 38.1 12.9 45 31.1c5.6-6.1 12.9-10.7 21.4-13L413.9 1.6c24.7-6.8 50.1 8.3 56.7 33.8l18 69.2 6 23.2 61.8 238.3 6 23.2 11.9 46c6.6 25.5-8 51.7-32.7 58.5l-59.6 16.5c-24.7 6.8-50.1-8.3-56.7-33.8l-18-69.2-6-23.2L339.6 145.9 336 132.2l0 11.8 0 224 0 24 0 24 0 48c0 26.5-21.5 48-48 48l-64 0c-8.7 0-16.9-2.3-24-6.4zM224 464l64 0 0-48-64 0 0 48zM176 48l-64 0 0 48 64 0 0-48zm48 48l64 0 0-48-64 0 0 48zM504.1 355.7l-55.8-215-56.5 15.6 55.8 215 56.5-15.6zm-44.4 62.1l11.9 45.7L528 447.9c0-.1 0-.2 0-.3l0-.1-11.7-45.2-56.5 15.6zm-79.9-308l56.5-15.6L424.4 48.5 368 64.1c0 .1 0 .2 0 .4l11.7 45.2zM64 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faLightbulbSlash = {
  prefix: 'far',
  iconName: 'lightbulb-slash',
  icon: [640, 512, [], "f673", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-195-152.8c4.4-6.2 8.9-12.4 13.4-18.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.7 0 189.1 41.2 160.8 100.8L38.8 5.1zM200 131.4C218.1 82.7 265 48 320 48c70.7 0 128 57.3 128 128c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-4.6 6.3-9.5 13-14.4 20L268.9 185.5c1.9-2.6 3.1-5.9 3.1-9.5c0-26.5 21.5-48 48-48c8.8 0 16-7.2 16-16s-7.2-16-16-16c-40 0-73.1 29.3-79 67.6l-41-32.1zM400 424.9L388.7 416 240 416l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-7.1zM152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-2-3.7-4.2-7.5-6.5-11.2L152.4 229.8z"]
};
const faHouseBlank = {
  prefix: 'far',
  iconName: 'house-blank',
  icon: [576, 512, ["home-blank"], "e487", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8L464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 464 204.8z"]
};
const faHomeBlank = faHouseBlank;
const faSquare5 = {
  prefix: 'far',
  iconName: 'square-5',
  icon: [448, 512, [], "e25a", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm176 32l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0-7.8 43 61.4 6.9c40.1 4.5 70.4 38.4 70.4 78.8c0 43.8-35.5 79.3-79.3 79.3l-36 0c-27.5 0-53.3-13.7-68.6-36.6l-4.1-6.1c-7.4-11-4.5-25.9 6.5-33.3s25.9-4.5 33.3 6.5l4.1 6.1c6.4 9.6 17.2 15.3 28.8 15.3l36 0c17.3 0 31.3-14 31.3-31.3c0-15.9-12-29.3-27.8-31.1l-86.9-9.8c-6.6-.7-12.6-4.2-16.6-9.5s-5.5-12.1-4.4-18.6l16-88c2.1-11.4 12-19.7 23.6-19.7z"]
};
const faSquareHeart = {
  prefix: 'far',
  iconName: 'square-heart',
  icon: [448, 512, [128159, "heart-square"], "f4c8", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM335.7 265.6l-91.5 92.9c-5.6 5.7-13 8.5-20.3 8.5c-7.3 0-14.6-2.9-20.1-8.5l-91.5-92.9c-26.4-26.8-26.4-70.4 0-97.2s69.3-26.8 95.8 0l16 16.2 16-16.2c26.4-26.8 69.3-26.8 95.8 0s26.4 70.4 0 97.2z"]
};
const faHeartSquare = faSquareHeart;
const faPuzzle = {
  prefix: 'far',
  iconName: 'puzzle',
  icon: [512, 512, [], "e443", "M448 0c35.3 0 64 28.7 64 64l0 128c0 8.8-7.2 16-16 16l-52 0c-6.6 0-12 5.4-12 12l0 4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-4c0-6.6-5.4-12-12-12l-36 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16L448 0zM0 240L0 128C0 92.7 28.7 64 64 64l144 0c8.8 0 16 7.2 16 16l0 52c0 6.6 5.4 12 12 12l4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-4 0c-6.6 0-12 5.4-12 12l0 52c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8-7.2 16-16 16l-32 0 0 152c0 13.3 10.7 24 24 24l152 0 0-36c0-6.6-5.4-12-12-12l-4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l4 0c6.6 0 12-5.4 12-12l0-36c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 144c0 35.3-28.7 64-64 64l-128 0-16 0L72 512c-39.8 0-72-32.2-72-72L0 272l0-32z"]
};
const faUserGear = {
  prefix: 'far',
  iconName: 'user-gear',
  icon: [640, 512, ["user-cog"], "f4fe", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l287.3 0c3.3 4.2 6.7 8.2 10.3 12c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-3.6 2.3-7 5.1-9.9 8.4c-14.4-5.5-30.1-8.5-46.5-8.5l-91.4 0c-65.7 0-120.1 48.7-129 112zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
};
const faUserCog = faUserGear;
const faPipeCircleCheck = {
  prefix: 'far',
  iconName: 'pipe-circle-check',
  icon: [640, 512, [], "e436", "M24 96c13.3 0 24 10.7 24 24l0 8 272 0 144 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 40.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-18.9-144 0L48 176l0 160 274.9 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L48 384l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32L0 152l0-32c0-13.3 10.7-24 24-24zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
};
const faArrowUp19 = {
  prefix: 'far',
  iconName: 'arrow-up-1-9',
  icon: [576, 512, ["sort-numeric-up"], "f163", "M456 56l0 120 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-86.7-16.4 5.5C379 99 365.4 92.2 361.2 79.6S363.8 53.4 376.4 49.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM424 304a40 40 0 1 0 0 80 40 40 0 1 0 0-80zM406.1 430.2c-40-8.3-70.1-43.7-70.1-86.2c0-48.6 39.4-88 88-88s88 39.4 88 88c0 21.1-7.3 41.5-20.6 57.8l-56.8 69.4c-8.4 10.3-23.5 11.8-33.8 3.4s-11.8-23.5-3.4-33.8l8.7-10.6z"]
};
const faSortNumericUp = faArrowUp19;
const faOctagonExclamation = {
  prefix: 'far',
  iconName: 'octagon-exclamation',
  icon: [512, 512, [], "e204", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faDialLow = {
  prefix: 'far',
  iconName: 'dial-low',
  icon: [576, 512, [], "e15d", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 336c-53.6 0-98.4-37.7-109.4-88L288 312c13.3 0 24-10.7 24-24s-10.7-24-24-24l-109.4 0c11-50.3 55.8-88 109.4-88c61.9 0 112 50.1 112 112s-50.1 112-112 112zM128 288a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm448 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faDoorClosed = {
  prefix: 'far',
  iconName: 'door-closed',
  icon: [576, 512, [128682], "f52a", "M416 48c8.8 0 16 7.2 16 16l0 400-288 0 0-400c0-8.8 7.2-16 16-16l256 0zm64 416l0-400c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 400-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 48 0 288 0 48 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0zM368 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faLaptopMobile = {
  prefix: 'far',
  iconName: 'laptop-mobile',
  icon: [640, 512, ["phone-laptop"], "f87a", "M128 48l320 0c8.8 0 16 7.2 16 16l0 32 48 0 0-32c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 256-48 0c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48l304 0 0-64-240 0 0-256c0-8.8 7.2-16 16-16zM384 464c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48l0 288zm208 0l-160 0 0-288 160 0 0 288z"]
};
const faPhoneLaptop = faLaptopMobile;
const faConveyorBeltBoxes = {
  prefix: 'far',
  iconName: 'conveyor-belt-boxes',
  icon: [640, 512, ["conveyor-belt-alt"], "f46f", "M304 48l0 160-160 0 0-160 160 0zM144 0C117.5 0 96 21.5 96 48l0 160c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L144 0zM528 112l0 96-96 0 0-96 96 0zM432 64c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0zm96 272c35.3 0 64 28.7 64 64s-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l416 0zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l416 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-416 0zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faConveyorBeltAlt = faConveyorBeltBoxes;
const faShieldVirus = {
  prefix: 'far',
  iconName: 'shield-virus',
  icon: [512, 512, [], "e06c", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 96c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faStarfighterTwinIonEngineAdvanced = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine-advanced',
  icon: [640, 512, ["starfighter-alt-advanced"], "e28e", "M118.5 7.6c9-9.7 24.2-10.2 33.9-1.2s10.2 24.2 1.2 33.9L50.2 151.2c-1.4 1.5-2.2 3.4-2.2 5.5L48 195l137.9-26.3C214.4 124.9 263.8 96 320 96s105.6 28.9 134.1 72.7L592 195l0-38.4c0-2-.8-4-2.2-5.5L486.5 40.4c-9-9.7-8.5-24.9 1.2-33.9s24.9-8.5 33.9 1.2L624.9 118.4c9.7 10.4 15.1 24 15.1 38.2l0 47.5 0 19.9 0 64 0 19.9 0 47.5c0 14.2-5.4 27.8-15.1 38.2L521.5 504.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9L589.8 360.8c1.4-1.5 2.2-3.4 2.2-5.5l0-38.4L454.1 343.3C425.6 387.1 376.2 416 320 416s-105.6-28.9-134.1-72.7L48 317l0 38.4c0 2 .8 4 2.2 5.5L153.5 471.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2L15.1 393.6C5.4 383.2 0 369.6 0 355.4l0-47.5L0 288l0-64 0-19.9 0-47.5c0-14.2 5.4-27.8 15.1-38.2L118.5 7.6zM48 268.1l115.7 22c-2.4-11-3.7-22.4-3.7-34.2s1.3-23.2 3.7-34.2L48 243.9l0 24.3zm428.3-46.3c2.4 11 3.7 22.4 3.7 34.2s-1.3 23.2-3.7 34.2l115.7-22 0-24.3-115.7-22zM304 334.4c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2l0-32.5zm-50.7-34.3c-5.6-8.4-9.6-17.9-11.7-28.1l-32.5 0c2.7 19 10.2 36.4 21.2 51.1l23-23zM241.6 240c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1l32.5 0zm34.3-50.7c8.4-5.6 17.9-9.6 28.1-11.7l0-32.5c-19 2.7-36.4 10.2-51.1 21.2l23 23zM336 366.9c19-2.7 36.4-10.2 51.1-21.2l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7l0 32.5zM430.9 272l-32.5 0c-2.1 10.2-6.1 19.7-11.7 28.1l23 23c11-14.7 18.4-32.1 21.2-51.1zm-32.5-32l32.5 0c-2.7-19-10.2-36.4-21.2-51.1l-23 23c5.6 8.4 9.6 17.9 11.7 28.1zM336 145.1l0 32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23c-14.7-11-32.1-18.4-51.1-21.2zM352 256c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.2-9.2l-.5 0c-8.7 .1-16.5 3.6-22.2 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
const faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
const faDiceSix = {
  prefix: 'far',
  iconName: 'dice-six',
  icon: [448, 512, [9861], "f526", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faStarfighterTwinIonEngine = {
  prefix: 'far',
  iconName: 'starfighter-twin-ion-engine',
  icon: [576, 512, ["starfighter-alt"], "e038", "M24 32c13.3 0 24 10.7 24 24l0 137.7 105.8-24.9C182.4 125 231.8 96 288 96s105.6 29 134.2 72.8L528 193.7 528 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 149 0 19 0 64 0 19 0 149c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.7L422.2 343.2C393.6 387 344.2 416 288 416s-105.6-29-134.2-72.8L48 318.3 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 307l0-19 0-64 0-19L0 56C0 42.7 10.7 32 24 32zM444.7 288.6L528 269l0-26-83.3-19.6c2.2 10.5 3.3 21.4 3.3 32.6s-1.1 22.1-3.3 32.6zM48 269l83.3 19.6c-2.2-10.5-3.3-21.4-3.3-32.6s1.1-22.1 3.3-32.6L48 243l0 26zm224 97.9l0-32.5c-10.2-2.1-19.7-6.1-28.1-11.7l-23 23c14.7 11 32.1 18.4 51.1 21.2zm-73.7-43.8l23-23c-5.6-8.4-9.6-17.9-11.7-28.1l-32.5 0c2.7 19 10.2 36.4 21.2 51.1zM177.1 240l32.5 0c2.1-10.2 6.1-19.7 11.7-28.1l-23-23c-11 14.7-18.5 32.1-21.2 51.1zm43.8-73.7l23 23c8.4-5.6 17.9-9.6 28.1-11.7l0-32.5c-19 2.7-36.4 10.2-51.1 21.2zM355.1 345.7l-23-23c-8.4 5.6-17.9 9.6-28.1 11.7l0 32.5c19-2.7 36.4-10.2 51.1-21.2zm22.6-22.6c11-14.7 18.4-32.1 21.2-51.1l-32.5 0c-2.1 10.2-6.1 19.7-11.7 28.1l23 23zm-23-111.2c5.6 8.4 9.6 17.9 11.7 28.1l32.5 0c-2.7-19-10.2-36.4-21.2-51.1l-23 23zm.3-45.6c-14.7-11-32.1-18.4-51.1-21.2l0 32.5c10.2 2.1 19.7 6.1 28.1 11.7l23-23zM310.6 278.6c5.8-5.8 9.4-13.8 9.4-22.6c0-8.8-3.5-16.7-9.2-22.5l-.3-.3c-5.7-5.7-13.6-9.2-22.3-9.2l-.5 0c-8.7 .1-16.5 3.6-22.3 9.2l-.3 .3c-5.7 5.8-9.2 13.7-9.2 22.5c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4z"]
};
const faStarfighterAlt = faStarfighterTwinIonEngine;
const faRocketLaunch = {
  prefix: 'far',
  iconName: 'rocket-launch',
  icon: [512, 512, [128640], "e027", "M197.9 253.9c12.9 6.4 24.7 14.8 35 25.2s18.8 22.2 25.2 35c105.8-30 156.7-79.5 181.5-126c25-46.8 27.3-97.6 22-137.7c-40.1-5.3-90.9-3-137.7 22c-46.5 24.8-96 75.8-126 181.5zM384 312.1l0 82.2c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.2 0C281.7-3.8 408.8-8.5 483.9 5.3c11.6 2.1 20.7 11.2 22.8 22.8c13.8 75.1 9.1 202.2-122.7 284zM28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5C132.3 504.3 66 511 28.3 511.9zm50.2-64.5c12.8-.7 31.2-3.7 41.3-13.7c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9zM328 144a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faMosquitoNet = {
  prefix: 'far',
  iconName: 'mosquito-net',
  icon: [640, 512, [], "e52c", "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4l0-23.1L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5l0-22.6c0-14.9 10.1-27.3 23.8-31l0-43.3c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2l0 43.3c13.7 3.6 23.8 16.1 23.8 31l0 22.6 45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-13.3 0-25.3 5.4-34 14.1l-11.7-1.7 7.5 6.5c-3.4 4.5-6.1 9.6-7.8 15.2c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35 0 23.1 32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6l0 50c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM105.2 310c.8-.8 1.6-1.5 2.4-2.3l82-71.4L78.5 252.9c-.4 .1-.8 .1-1.1 .2C60.6 255.2 48 269.5 48 286.3c0 29.8 36.1 44.8 57.2 23.7zM512 256c8.8 0 16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 48 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-48 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-48-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 48 0 0-16c0-8.8 7.2-16 16-16zm16 112l48 0 0-48-48 0 0 48zm0 80l48 0 0-48-48 0 0 48zM448 320l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0z"]
};
const faFileFragment = {
  prefix: 'far',
  iconName: 'file-fragment',
  icon: [384, 512, [], "e697", "M320 464l-96 0 0 48 96 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 288l48 0L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM48 464l0-96 96 0 0 96-96 0zM0 352L0 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L32 320c-17.7 0-32 14.3-32 32z"]
};
const faVentDamper = {
  prefix: 'far',
  iconName: 'vent-damper',
  icon: [640, 512, [], "e465", "M512 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-384 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM128 64c-35.3 0-64 28.7-64 64l0 32-32 0c-17.7 0-32 14.3-32 32L0 320c0 17.7 14.3 32 32 32l32 0 0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32 32 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-32 0 0-32c0-35.3-28.7-64-64-64L128 64zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zm0 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z"]
};
const faBridgeWater = {
  prefix: 'far',
  iconName: 'bridge-water',
  icon: [576, 512, [], "e4ce", "M48 112l0 50.8c45.9 10.9 80 52.2 80 101.5l0 96.7c-14.8-8.5-32-10.6-48-6.5l0-90.2C80 233.2 54.8 208 23.7 208C10.6 208 0 197.4 0 184.3L0 96C0 78.3 14.3 64 32 64l512 0c17.7 0 32 14.3 32 32l0 88.3c0 13.1-10.6 23.7-23.7 23.7c-31.1 0-56.3 25.2-56.3 56.3l0 90.2c-16-4.1-33.2-2-48 6.6l0-96.7c0-49.2 34.1-90.5 80-101.5l0-50.8L48 112zM192 384.5c-5.2 0-10.5-.6-16-1.7L176 272c0-61.9 50.1-112 112-112s112 50.1 112 112l0 110.8c-5.5 1.1-10.8 1.7-16 1.7c-10.4 0-21.3-2.2-32-6.1L352 272c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 106.4c-10.3 3.8-21.1 6.1-32 6.1zm-80.1 13.6c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faBanBug = {
  prefix: 'far',
  iconName: 'ban-bug',
  icon: [512, 512, ["debug"], "f7f9", "M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm78.9-163c.2-1.1 .3-2.1 .5-3.2l29.5 5.9c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8l-35.1-7 0-18.6 35.1-7c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-29.5 5.9c-1.1-9.2-3.8-17.8-7.7-25.8l24.5-14.7c7.6-4.5 10-14.4 5.5-22s-14.4-10-22-5.5L307.8 163c-14-11.9-32.1-19-51.8-19c-21.6 0-41.2 8.6-55.6 22.5L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L334.9 301zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM140.9 272.3c-8.7 1.7-14.3 10.2-12.6 18.8s10.2 14.3 18.8 12.6l29.5-5.9c1.1 9.2 3.8 17.8 7.7 25.8l-24.5 14.7c-7.6 4.5-10 14.4-5.5 22s14.4 10 22 5.5L204.2 349c14 11.9 32.1 19 51.8 19c6.6 0 13-.8 19.2-2.3L175 265.5l-34.1 6.8z"]
};
const faDebug = faBanBug;
const faPersonBooth = {
  prefix: 'far',
  iconName: 'person-booth',
  icon: [576, 512, [], "f756", "M299.2 48l75.1 191.2c2.7 6.8 2.1 14.4-1.5 20.7L316.8 358c-3.1 5.5-4.8 11.7-4.8 18c0 13.3 10.7 24 24 24c8.3 0 15.7-4.2 20-10.7c4.4-6.7 11.9-10.7 20-10.7s15.5 4 20 10.7c4.3 6.5 11.7 10.7 20 10.7c8.6 0 16.2-4.5 20.5-11.5c4.3-6.9 11.8-11.2 19.9-11.4s15.8 3.8 20.4 10.5c5.1 7.5 13.6 12.3 23.2 12.3c13.2 0 24.3-9.2 27.3-21.5c.2-.9 .5-1.7 .7-2.5l0-3.9 0-316c0-4.4-3.6-8-8-8L299.2 48zM528 442.7c-8.7 3.4-18.1 5.3-28 5.3c-15.8 0-30.5-4.8-42.6-13.1c-11.7 8.2-26 13.1-41.4 13.1c-14.8 0-28.6-4.5-40-12.1c-11.4 7.7-25.2 12.1-40 12.1c-39.8 0-72-32.2-72-72c0-14.7 3.8-29.1 11.1-41.8l50.4-88.1L247.6 48c-4.3 .2-7.6 3.7-7.6 8l0 152-48 0 0-152c0-30.9 25.1-56 56-56l16 0L520 0c30.9 0 56 25.1 56 56l0 316 0 12 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-45.3zM192 320l48 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168zM64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM61.2 208c-7.3 0-13.2 5.9-13.2 13.2l0 42.2 0 .6 0 13c.1 1.7 .7 3.4 1.8 4.7L72 309l0-99.1c-3.4-1.2-7.1-1.9-10.8-1.9zM0 276.6l0-55.4C0 187.4 27.4 160 61.2 160c24.2 0 47.2 11 62.3 29.9l40 50.1 52.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56.3 0c-12.2 0-23.6-5.5-31.2-15L120 262.4l0 105.7 23 28.4c5.8 7.1 9 16 9 25.2l0 66.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-63.5L48 355.6 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 277.5l0-.9z"]
};
const faTextWidth = {
  prefix: 'far',
  iconName: 'text-width',
  icon: [448, 512, [], "f035", "M48 112l0-32 152 0 0 160-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-160 152 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24zM441 401c9.4-9.4 9.4-24.6 0-33.9l-64-64c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l23 23L81.9 360l23-23c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-23-23 284.1 0-23 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64z"]
};
const faGarageCar = {
  prefix: 'far',
  iconName: 'garage-car',
  icon: [640, 512, [], "e00a", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 240l0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-352 0zm127.9 85.9l-7 26.1L375 352l-7.5-26.2c-1-3.4-4.1-5.8-7.7-5.8l-80.2 0c-3.6 0-6.8 2.4-7.7 5.9zm-59.7 37l4.6-17.2 8.7-32.3c6.6-24.4 28.8-41.4 54.1-41.4l80.2 0c25 0 47 16.6 53.8 40.6l9.4 32.8 5.1 17.8C445 374.7 456 394.1 456 416l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-176 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-22.1 11.2-41.5 28.2-53zM408 416c0-8.8-7.2-16-16-16l-144 0c-8.8 0-16 7.2-16 16l0 16 176 0 0-16z"]
};
const faSquareKanban = {
  prefix: 'far',
  iconName: 'square-kanban',
  icon: [448, 512, [], "e488", "M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 288c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176zm-72-72c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24z"]
};
const faHatWizard = {
  prefix: 'far',
  iconName: 'hat-wizard',
  icon: [512, 512, [], "f6e8", "M327.7 227.6c-5.1-11.5-7.7-23.9-7.7-36.5c0-10.1 1.7-20.1 5-29.7l27.7-79.1-98.3 56.2c-26.6 15.2-47.7 38.5-60.1 66.5L100.5 416 48 416 150.4 185.5c16.6-37.4 44.7-68.4 80.2-88.7L376.9 13.2c0 0 .1 0 .1 0l2.1-1.2 16.6-9.5C398.5 .9 401.7 0 405 0c10.5 0 19 8.5 19 19l0 1.5c0 2.3-.4 4.6-1.2 6.8l-5 14.2-1.5 4.2-.1 .3-46 131.3c-1.6 4.4-2.4 9.1-2.4 13.8c0 5.9 1.2 11.7 3.6 17l-43.9 19.5zm43.9-19.5L464 416l-52.5 0L327.7 227.6l43.9-19.5zM246.2 416l-44.4 0-6.5-19.4-40.4-13.5C148.4 381 144 374.9 144 368s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4c2.2-6.5 8.3-10.9 15.2-10.9s13 4.4 15.2 10.9l13.5 40.4 40.4 13.5c6.5 2.2 10.9 8.3 10.9 15.2s-4.4 13-10.9 15.2l-40.4 13.5L246.2 416zM0 480c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32zM264 168c3.4 0 6.5 2.2 7.6 5.5l6.7 20.2 20.2 6.7c3.3 1.1 5.5 4.1 5.5 7.6s-2.2 6.5-5.5 7.6l-20.2 6.7-6.7 20.2c-1.1 3.3-4.1 5.5-7.6 5.5s-6.5-2.2-7.6-5.5l-6.7-20.2-20.2-6.7c-3.3-1.1-5.5-4.1-5.5-7.6s2.2-6.5 5.5-7.6l20.2-6.7 6.7-20.2c1.1-3.3 4.1-5.5 7.6-5.5z"]
};
const faChartKanban = {
  prefix: 'far',
  iconName: 'chart-kanban',
  icon: [448, 512, [], "e64f", "M368 432l0-352 32 0 0 352-32 0zm-48 0c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 352zM80 368l-32 0L48 80l32 0 0 288zM48 416l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 368c0 26.5 21.5 48 48 48zM240 240l-32 0 0-160 32 0 0 160zm-32 48l32 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48z"]
};
const faPenFancy = {
  prefix: 'far',
  iconName: 'pen-fancy',
  icon: [512, 512, [128395, 10002], "f5ac", "M399.4 59.9c7.1-7.6 17-11.9 27.3-11.9C447.3 48 464 64.7 464 85.3c0 10.4-4.3 20.2-11.9 27.3l-195.5 182-39.2-39.2 182-195.5zM426.7 0C403 0 380.4 9.8 364.2 27.2L170.8 234.9 97.2 257.6c-22.8 7-40.6 24.9-47.6 47.6L1.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l22.6-73.6L484.8 147.8C502.2 131.6 512 109 512 85.3C512 38.2 473.8 0 426.7 0zM228.8 334.8l-20.3 65.9c-2.3 7.6-8.3 13.5-15.9 15.9L85 449.7 134.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L62.3 427 95.5 319.3c2.3-7.6 8.3-13.5 15.9-15.9l65.9-20.3 51.6 51.6z"]
};
const faCoffeePot = {
  prefix: 'far',
  iconName: 'coffee-pot',
  icon: [512, 512, [], "e002", "M88 80c-22.1 0-40 17.9-40 40l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80C0 71.4 39.4 32 88 32l34.4 0L192 32l261.6 0C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9l0 8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480L158 480c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344l0-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80 88 80zm296.8 80l35.6-80L192 80l-36.4 0 35.6 80 193.6 0zm1.2 48L190 208c-41.8 21.6-71.7 63.1-77.1 112l350.2 0c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224l-260.5 0 .2 0L418 432l.2 0z"]
};
const faMouseField = {
  prefix: 'far',
  iconName: 'mouse-field',
  icon: [512, 512, [], "e5a8", "M393.4 50.8C397.9 49 402.8 48 408 48c22.1 0 40 17.9 40 40c0 8.1-2.4 15.6-6.5 21.9c-10.4-5.3-21.7-9.1-33.6-11.4c-.9-17.4-6.1-33.7-14.5-47.8zm86.2 88.4C489.9 124.8 496 107.1 496 88c0-48.6-39.4-88-88-88c-18.4 0-35.5 5.7-49.6 15.3C342.5 5.6 323.9 0 304 0C246.6 0 200 46.6 200 104l0 3.2c0 21.2 6.4 41.3 17.7 58.1C143.2 184.4 88 252 88 332.6c0 12.7 2.8 24.7 7.9 35.4L72 368c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l99.4 0L344 416l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-47.8 0 32-80 79.8 0c30.9 0 56-25.1 56-56l0-7.7c0-32.6-12.2-62.4-32.4-85.1zM292.6 368l-121.1 0c-19.6 0-35.4-15.9-35.4-35.4C136 263.8 191.8 208 260.6 208l19.4 0c11.4 0 21.2-8 23.5-19.2s-3.6-22.4-14.1-26.9l-7.5-3.2c-20.6-8.8-33.9-29.1-33.9-51.5l0-3.2c0-30.9 25.1-56 56-56s56 25.1 56 56l0 16c0 12.5 9.7 23 22.2 23.9l8 .6c41.7 3.2 73.9 38 73.9 79.8l0 7.7c0 4.4-3.6 8-8 8l-96 0c-9.8 0-18.6 6-22.3 15.1L292.6 368zM396 216a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"]
};
const faPersonDigging = {
  prefix: 'far',
  iconName: 'person-digging',
  icon: [576, 512, ["digging"], "f85e", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440.8 288c8.2 .3 15.7 4.7 19.8 11.8l104 176c4.4 7.4 4.5 16.6 .2 24.1s-12.2 12.1-20.8 12.1l-256 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l16-48c3.3-9.8 12.4-16.4 22.8-16.4l35.4 0 20.3-29.5L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4s19.1-18 31.4-12.9L61 210.1l19.8-36.2C96.2 145.6 125.8 128 158 128l3.8 0c52.3 0 98.5 33.8 114.4 83.6l32.3 101.6 79 32.9 32.8-47.7c4.6-6.8 12.4-10.7 20.6-10.4zm-190.4 1l-20-62.8c-9.5-29.9-37.3-50.2-68.6-50.2l-3.8 0c-14.6 0-28.1 8-35.1 20.8l-17.3 31.8L250.4 289zm188.1 67.6l-66.7 97L364.6 464l137.3 0L438.5 356.6zM81.4 301.1l128 54.4c8.9 3.8 14.6 12.5 14.6 22.1L224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-94.5L87.5 355.9 47 494.7c-3.7 12.7-17 20-29.8 16.3S-2.7 494 1 481.3L49 316.5l7.6-25.9 24.9 10.6z"]
};
const faDigging = faPersonDigging;
const faShowerDown = {
  prefix: 'far',
  iconName: 'shower-down',
  icon: [384, 512, ["shower-alt"], "e24d", "M192 0c13.3 0 24 10.7 24 24l0 9.8c77 11.6 136 78 136 158.2l0 16 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 256l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-16C32 111.8 91 45.4 168 33.8l0-9.8c0-13.3 10.7-24 24-24zM80 208l224 0 0-16c0-61.9-50.1-112-112-112S80 130.1 80 192l0 16zM52.8 295.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zm109.8 42.4l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zm64 128l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zm82.2-170.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4zM98.7 465.7l18.2-42.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1z"]
};
const faShowerAlt = faShowerDown;
const faBoxCircleCheck = {
  prefix: 'far',
  iconName: 'box-circle-check',
  icon: [576, 512, [], "e0c4", "M342.4 80c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80 94.4 0zM48 208l310.6 0c22.3-10.3 47.2-16 73.4-16c5.4 0 10.7 .2 16 .7l0-3.1c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16l0-208zm11.6-48L91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80L59.6 160zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faBrightness = {
  prefix: 'far',
  iconName: 'brightness',
  icon: [512, 512, [], "e0c9", "M232 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64zm24 120a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM0 256c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24zm424-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM256 512c13.3 0 24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24zM75 75c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM391.8 357.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3zM75 437c9.4 9.4 24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9zM357.8 120.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3z"]
};
const faCarSideBolt = {
  prefix: 'far',
  iconName: 'car-side-bolt',
  icon: [640, 512, [], "e344", "M134.2 105.1L99.4 192l28.6 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 96 21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l138.9 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l21.5 0 0-32c0-44.2-35.8-80-80-80l-96 0 0-48 46.1 0L384.5 95c-7.6-9.5-19.1-15-31.2-15L171.3 80c-16.4 0-31.1 10-37.1 25.1zM46.8 194.3l42.8-107C103 53.9 135.3 32 171.3 32l181.9 0c26.7 0 52 12.2 68.7 33L524 192.6c65.1 6 116 60.8 116 127.4l0 48c0 17.7-14.3 32-32 32l-33.3 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-130.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80L32 400c-17.7 0-32-14.3-32-32L0 256c0-29.4 19.8-54.2 46.8-61.7zM434.7 400a48 48 0 1 0 90.5-32 48 48 0 1 0 -90.5 32zM208 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM331.2 100.6c5.3 5.2 6.3 13.3 2.5 19.6L300.3 176l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L243.7 208 192 208c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
const faFileXml = {
  prefix: 'far',
  iconName: 'file-xml',
  icon: [512, 512, [], "e654", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm128-96c0 7.3 2.2 14.4 6.2 20.4l9.8 14.7 9.8-14.7c4-6.1 6.2-13.2 6.2-20.4c0-8.8 7.2-16 16-16s16 7.2 16 16c0 13.6-4 26.9-11.6 38.2L227.2 432l17.2 25.8C252 469.1 256 482.4 256 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-7.3-2.2-14.4-6.2-20.4L208 460.8l-9.8 14.7c-4 6.1-6.2 13.2-6.2 20.4c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-13.6 4-26.9 11.6-38.2L188.8 432l-17.2-25.8C164 394.9 160 381.6 160 368c0-8.8 7.2-16 16-16s16 7.2 16 16zM448 496l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM299.7 352.6c6.9-1.9 14.3 1 18 7.2L352 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-2.9-13.7-7.8L320 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4z"]
};
const faOrnament = {
  prefix: 'far',
  iconName: 'ornament',
  icon: [384, 512, [], "f7b8", "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 11.7 3.1 22.6 8.6 32L128 96c-17.7 0-32 14.3-32 32l0 25.7C38.6 186.9 0 248.9 0 320C0 426 86 512 192 512s192-86 192-192c0-71.1-38.6-133.1-96-166.3l0-25.7c0-17.7-14.3-32-32-32l-8.6 0zM192 176c42.6 0 81 18.5 107.3 48L84.7 224c26.4-29.5 64.7-48 107.3-48zM56.2 272l271.6 0c5.3 15 8.2 31.2 8.2 48s-2.9 33-8.2 48L56.2 368c-5.3-15-8.2-31.2-8.2-48s2.9-33 8.2-48zM84.7 416l214.7 0C273 445.5 234.6 464 192 464s-81-18.5-107.3-48z"]
};
const faPhoneArrowDownLeft = {
  prefix: 'far',
  iconName: 'phone-arrow-down-left',
  icon: [512, 512, ["phone-arrow-down", "phone-incoming"], "e223", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM505 41l-135 135 54.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54.1L471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faPhoneArrowDown = faPhoneArrowDownLeft;
const faPhoneIncoming = faPhoneArrowDownLeft;
const faCloudWord = {
  prefix: 'far',
  iconName: 'cloud-word',
  icon: [640, 512, [], "e138", "M410.8 134.2c-19.3 8.6-42 3.5-55.9-12.5C332.8 96.1 300.3 80 264 80c-66.3 0-120 53.7-120 120c0 0 0 0 0 0s0 0 0 0l0 .2c0 20.4-12.8 38.5-32 45.3C74.6 258.7 48 294.3 48 336c0 53 43 96 96 96l360 0 3.3 0c.6-.1 1.3-.1 1.9-.2c46.2-2.7 82.8-41 82.8-87.8c0-36-21.6-67.1-52.8-80.7c-20.1-8.8-31.6-30-28.1-51.7c.6-3.8 .9-7.7 .9-11.7c0-39.8-32.2-72-72-72c-10.5 0-20.4 2.2-29.2 6.2zM512 479.8l0 .2-8 0-40 0-320 0C64.5 480 0 415.5 0 336c0-62.7 40.1-116 96-135.8l0-.2c0-92.8 75.2-168 168-168c50.9 0 96.4 22.6 127.3 58.3C406.2 83.7 422.6 80 440 80c66.3 0 120 53.7 120 120c0 6.6-.5 13-1.5 19.3c48 21 81.5 68.9 81.5 124.7c0 72.4-56.6 131.6-128 135.8zM512 368c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16zM240 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l96 0zM128 304c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm272-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faHandFingersCrossed = {
  prefix: 'far',
  iconName: 'hand-fingers-crossed',
  icon: [384, 512, [], "e1a3", "M169.8 57.6c3.7-8 13.3-11.5 21.3-7.7s11.5 13.3 7.7 21.3L120 240l-35.3 0 55.7-119.5c1-1.7 1.9-3.5 2.5-5.3l26.8-57.6zM126.3 37.3l-6.5 14C102.9 24.1 68 13.1 38.3 27C6.3 41.9-7.6 80 7.3 112l42.1 90.2L22 261c-.9 2-1.5 4-1.9 6C7.6 281.1 0 299.7 0 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-5.4 0-10.7 .7-15.7 1.9l18-38.5c14.9-32 1.1-70.1-31-85.1s-70.1-1.1-85.1 31zM50.8 91.7c-3.7-8-.3-17.5 7.7-21.3s17.5-.3 21.3 7.7l13.7 29.3L75.9 145.4l-25-53.7zM240 176c8.8 0 16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zm0 128c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2zm96-48l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32z"]
};
const faTrash = {
  prefix: 'far',
  iconName: 'trash',
  icon: [448, 512, [], "f1f8", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"]
};
const faGaugeSimple = {
  prefix: 'far',
  iconName: 'gauge-simple',
  icon: [512, 512, ["gauge-simple-med", "tachometer-average"], "f629", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-22.3-13.1-41.6-32-50.6L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 181.4c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
const faGaugeSimpleMed = faGaugeSimple;
const faTachometerAverage = faGaugeSimple;
const faArrowDownSmallBig = {
  prefix: 'far',
  iconName: 'arrow-down-small-big',
  icon: [576, 512, ["sort-size-down-alt"], "f88d", "M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L136 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 342.1 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 144l64 0 0-64-64 0 0 64zm-48 0l0-64c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48zm48 160l0 128 128 0 0-128-128 0zm-48 0c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-128z"]
};
const faSortSizeDownAlt = faArrowDownSmallBig;
const faBookMedical = {
  prefix: 'far',
  iconName: 'book-medical',
  icon: [448, 512, [], "f7e6", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM208 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faFaceMelting = {
  prefix: 'far',
  iconName: 'face-melting',
  icon: [640, 512, [129760], "e483", "M528 256c0-114.9-93.1-208-208-208s-208 93.1-208 208c0 33.5 7.9 65 21.9 93c16.7 33.4 12.5 72.2-.1 100.7c-2.1 4.7-4.6 9.5-7.6 14.4l193.7 0c0 0 .1 0 .1 0c0 0 0 0 0 0s0 0 0 0c0 0 .1 0 .1 0l164 0c-2.7-7.5-4.1-15.6-4.1-24c0-32.6 21.6-60.1 51.3-69c-10.9-20.5-14.2-44.9-9.1-66.1c3.8-15.6 5.8-32 5.8-48.9zm40.9 60.1c-6 24.8 11.1 51.9 36.6 51.9c0 0 0 0 0 0l10.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-10.5 0s0 0 0 0L552 416c-13.3 0-24 10.7-24 24s10.7 24 24 24s24 10.7 24 24s-10.7 24-24 24l-231.9 0-.1 0-.1 0L46.6 512 24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.6 0c38.9 0 61.8-58.8 44.4-93.6C73.7 336 64 297.1 64 256C64 114.6 178.6 0 320 0S576 114.6 576 256c0 20.7-2.5 40.8-7.1 60.1zm-305.1-158a32 32 0 1 1 -16.6 61.8 32 32 0 1 1 16.6-61.8zm115.4 64A32 32 0 1 1 441 238.7a32 32 0 1 1 -61.8-16.6zM220.4 279.9c11.3 23.2 33.6 50.1 72.7 60.6s71.9-1.7 93.2-16.1c11-7.4 25.9-4.6 33.3 6.4s4.6 25.9-6.4 33.3c-29.5 19.9-76.5 37.8-132.5 22.8s-87.9-54-103.4-86c-5.8-11.9-.8-26.3 11.1-32.1s26.3-.8 32.1 11.1z"]
};
const faPoo = {
  prefix: 'far',
  iconName: 'poo',
  icon: [512, 512, [128169], "f2fe", "M224 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l7.4 7.4c6.1 6.1 9.5 14.4 9.5 23l0 3.2c0 16.2-13.1 29.3-29.3 29.3L180 104l-3.1 0c-6.1 0-12.1 .8-17.8 2.2C113.9 115.8 80 155.9 80 204c0 1.1 0 2.2 .1 3.3C47.1 221.3 24 253.9 24 292c0 14.3 3.3 27.8 9.1 39.9C12.8 350.9 0 377.9 0 408c0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104c0-30.1-12.8-57.1-33.1-76.1c5.8-12.1 9.1-25.6 9.1-39.9c0-38.1-23.1-70.7-56.1-84.7c0-1.1 .1-2.2 .1-3.3c0-38-21.2-71-52.3-87.9C363.6 49.5 303.6 0 232 0l-8 0zm48 71.4c0-5.5-.6-10.9-1.6-16.1c33.8 13.4 58.9 44 64.5 81c1.3 8.6 7.2 15.9 15.3 18.9C370 162.6 384 181.7 384 204c0 4.9-.7 9.7-1.9 14.1c-1.9 6.7-.8 13.9 3 19.7s10 9.7 16.9 10.6c21.5 2.9 38 21.3 38 43.6c0 11.4-4.3 21.8-11.4 29.6c-5 5.4-7.1 12.9-5.9 20.1s5.7 13.6 12.2 17.1c17.4 9.5 29.2 28 29.2 49.2c0 30.9-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56c0-21.2 11.7-39.7 29.2-49.2c6.5-3.5 10.9-9.8 12.2-17.1s-1-14.7-5.9-20.1C76.3 313.8 72 303.4 72 292c0-22.3 16.6-40.7 38-43.6c6.9-.9 13-4.8 16.9-10.6s4.9-13 3-19.7c-1.3-4.5-1.9-9.2-1.9-14.1c0-25.1 17.8-46 41.4-50.9c.4-.1 .8-.2 1.2-.3c2-.5 4.1-.8 6.3-.8l3.1 0 14.7 0c42.7 0 77.3-34.6 77.3-77.3l0-3.2zM192 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM172.3 352c-6.8 0-12.3 5.5-12.3 12.3c0 2.4 .7 4.8 2.2 6.7c8.2 10.5 39.5 45 93.8 45s85.6-34.6 93.8-45c1.5-1.9 2.2-4.3 2.2-6.7c0-6.8-5.5-12.3-12.3-12.3l-167.4 0z"]
};
const faPenClipSlash = {
  prefix: 'far',
  iconName: 'pen-clip-slash',
  icon: [640, 512, ["pen-alt-slash"], "e20f", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c25-25 25-65.5 0-90.5L517.3 19.3c-25-25-65.5-25-90.5 0L384 62.1 370.9 49c-28.1-28.1-73.7-28.1-101.8 0l-76.6 76.6L38.8 5.1zM230.5 155.4L303 82.9c9.4-9.4 24.6-9.4 33.9 0L350.1 96l-85.8 85.8-33.7-26.4zm71.8 56.2L384 129.9 446.1 192l-74.2 74.2-69.6-54.5zM197.5 316.5l36.3-36.3-38-29.9-32.3 32.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l47.7-47.7-38-29.9-43.6 43.6c-38.8 38.8-87.5 66-140.7 78.6c12.7-53.2 39.9-101.9 78.6-140.7z"]
};
const faPenAltSlash = faPenClipSlash;
const faQuoteRight = {
  prefix: 'far',
  iconName: 'quote-right',
  icon: [448, 512, [8221, "quote-right-alt"], "f10e", "M448 296c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32 0 32 0 72zm-48-72l0-32 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16zM64 240l64 0c8.8 0 16-7.2 16-16l0-32 0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16zm128-48l0 32 0 72c0 66.3-53.7 120-120 120l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0c39.8 0 72-32.2 72-72l0-10c-5.1 1.3-10.5 2-16 2l-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 32z"]
};
const faQuoteRightAlt = faQuoteRight;
const faScrollOld = {
  prefix: 'far',
  iconName: 'scroll-old',
  icon: [576, 512, [], "f70f", "M80 80c-17.7 0-32 14.3-32 32l0 48 32 0 0 48-32 0c-26.5 0-48-21.5-48-48l0-48C0 67.8 35.8 32 80 32l320 0c44.2 0 80 35.8 80 80l0 160-32 0-16 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-80-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-16c0-17.7-14.3-32-32-32L153.3 80c4.3 9.8 6.7 20.6 6.7 32l0 112 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5 21.5-48 48-48l.6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .6 0 .5 0 .6 0 .5 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0c26.5 0 48 21.5 48 48l0 48c0 44.2-35.8 80-80 80l-304 0c-44.2 0-80-35.8-80-80l0-288c0-17.7-14.3-32-32-32zM265.3 432L496 432c17.7 0 32-14.3 32-32l0-48s0 0 0 0l-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.5 0-.6 0-.5 0-.6 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0-.6 0s0 0 0 0l0 48c0 11.4-2.4 22.2-6.7 32z"]
};
const faGuitars = {
  prefix: 'far',
  iconName: 'guitars',
  icon: [512, 512, [], "f8bf", "M152 178l0-44.4 19.8-39.6c2.8-5.6 4.2-11.7 4.2-17.9L176 24c0-13.3-10.7-24-24-24L104 0C90.7 0 80 10.7 80 24l0 52.2c0 6.2 1.4 12.3 4.2 17.9L104 133.7l0 44.4c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104c29.3 0 56.3-8 77.8-21.4c-8.4-14.7-13.4-31.7-13.8-49.7c-13.1 12.9-34.3 23.2-64 23.2c-54 0-80-33.9-80-56c0-9.7 3.7-19.8 12.4-29.3c26.2-29 26.4-71.9 7.8-101.2c-3-4.8-4.2-9.2-4.2-13.5c0-9.6 11.2-29.7 40-37.1l0 85.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-85.1c28.8 7.4 40 27.5 40 37.1c0 4.2-1.2 8.7-4.2 13.5c-18.6 29.4-18.4 72.2 7.8 101.2c2.5 2.7 4.6 5.5 6.3 8.4c4.1-11.5 8.8-22.1 12.9-31.2c0 0 0 0 0 0l1-2.3c3.3-7.4 6.1-13.9 8.5-19.7c-3-10.1-1.5-21.8 4.1-30.7c1.1-1.7 2.1-3.5 3.1-5.3c-.9-4.9-2.7-10.7-5.7-19.3l-.4-1.3c-3.5-10-8.5-24.7-9.2-40.9c-.1-1.3-.1-2.5-.1-3.8l0-12.9 0-10.1c-15.8-15.7-38.2-27.1-64-31.5zm170.6-53.9L344 148.6l0 91.4c-23.7 0-38.6-8.8-48-19.8c-2.5-2.9-4.6-6-6.3-9.1c-3.7-6.6-6-13.3-7.4-19.1l0-.2c-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16l0 8 0 19.6 0 12.9c0 .8 0 1.7 .1 2.5c.5 11.5 4.2 22.3 7.9 33.1c4 11.6 8 23.3 8 35.9c0 20-9.3 40.9-19 62.5c-10.3 23.2-21 47.1-21 71.7c0 40.8 33 73.8 73.8 73.8l140.4 0c40.8 0 73.8-33 73.8-73.8c0-24.5-10.7-48.5-21-71.7c-9.6-21.6-19-42.5-19-62.5c0-12 4-22.9 8.1-33.8c0 0 0 0 0 0c3.3-8.9 6.6-17.8 7.6-27.2c.2-1.9 .3-3.8 .3-5.7l0-1.6 0-13.6 0-14c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5l-.2 .5c-1.9 4.5-4.7 9.4-9.1 14c-1 1.1-2.1 2.1-3.2 3.1c-9.4 8.3-24.3 14.9-48 14.9l0-165.9c9.6-6.4 16-17.3 16-29.7l0-4.6C408 17.8 390.2 0 368.2 0c-18.8 0-35 13.1-38.9 31.5L315.4 96.3c-2.1 9.9 .6 20.2 7.2 27.8zM344 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm81.9-99.7c-1.1 6.1-1.9 12.8-1.9 19.7c0 30.7 13.5 60.6 22.2 80c0 0 0 0 0 0c.7 1.5 1.4 3 2 4.4c10.7 24 15.8 38 15.8 49.8c0 14.2-11.6 25.8-25.8 25.8l-140.4 0c-14.2 0-25.8-11.6-25.8-25.8c0-11.9 5.2-25.8 15.8-49.8c.6-1.4 1.3-2.9 2-4.4c0 0 0 0 0 0c8.7-19.4 22.2-49.2 22.2-80c0-7.2-.8-14.1-1.9-20.5c10.4 2.9 21.7 4.5 33.9 4.5l48 0c12.1 0 23.4-1.3 33.9-3.7z"]
};
const faPhoneXmark = {
  prefix: 'far',
  iconName: 'phone-xmark',
  icon: [576, 512, [], "e227", "M361 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C207.2 485.6 32 295.2 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zm133.8 78.1l-100.4-43L365 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L80.1 70.5C83.5 286.2 257.8 460.5 473.5 464l21.3-99.2zM375 7c9.4-9.4 24.6-9.4 33.9 0l47 47L503 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47L375 41c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faHose = {
  prefix: 'far',
  iconName: 'hose',
  icon: [448, 512, [], "e419", "M312 128c13.3 0 24-10.7 24-24l0-2.3 80.2-11.5C417.3 98 423.9 104 432 104c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16c-8.1 0-14.7 6-15.8 13.7L336 26.3l0-2.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24zM8 488c0 13.3 10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464c-13.3 0-24 10.7-24 24zM32 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 384zM8 328c0 13.3 10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 304c-13.3 0-24 10.7-24 24zM56 156c0-37.6 30.4-68 68-68l132 0 0-48L124 40C59.9 40 8 91.9 8 156s51.9 116 116 116l292 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-292 0c-37.6 0-68-30.4-68-68z"]
};
const faClockSix = {
  prefix: 'far',
  iconName: 'clock-six',
  icon: [512, 512, [], "e352", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faShirt = {
  prefix: 'far',
  iconName: 'shirt',
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M146.3 27.8C167.9 9.8 195.1 0 223.2 0c18.2 0 31.1 13.6 34 28.5C263 57.8 288.9 80 320 80s57-22.2 62.8-51.5C385.7 13.6 398.7 0 416.8 0c28.1 0 55.3 9.8 76.8 27.8L478.3 46.3l15.4-18.4L619.8 133c11.6 9.7 18.8 23.6 20 38.6s-3.7 29.9-13.7 41.3l-56 64c-20 22.9-54.6 25.6-78 6.1L480 272.9 480 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-175.1L147.9 283c-23.4 19.5-58 16.7-78-6.1l-56-64C3.9 201.5-1 186.6 .2 171.6s8.4-29 20-38.6L146.3 27.8zm66.5 20.9c-13.1 1.9-25.5 7.4-35.8 15.9L50.9 169.9c-1.7 1.4-2.7 3.4-2.9 5.5s.5 4.3 2 5.9L31.9 197.1 50 181.3l56 64c2.9 3.3 7.8 3.7 11.1 .9l51.5-42.9c7.2-6 17.1-7.2 25.5-3.3s13.8 12.4 13.8 21.7L208 448c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-226.3c0-9.3 5.4-17.8 13.8-21.7s18.4-2.7 25.5 3.3l51.5 42.9c3.3 2.8 8.3 2.4 11.1-.9l56-64c1.4-1.6 2.1-3.7 2-5.9s-1.2-4.1-2.9-5.5L462.9 64.7c-10.3-8.6-22.7-14.1-35.8-15.9C413.1 94.6 370.5 128 320 128s-93.1-33.4-107.1-79.3z"]
};
const faTShirt = faShirt;
const faTshirt = faShirt;
const faBillboard = {
  prefix: 'far',
  iconName: 'billboard',
  icon: [640, 512, [], "e5cd", "M440 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L248 32l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L80 32C53.5 32 32 53.5 32 80l0 272-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 216 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 216 0 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-272c0-26.5-21.5-48-48-48L440 32l0-8zM320 352L80 352 80 80l120 0 0 48-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 144 0 0 48-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-48 120 0 0 272-240 0z"]
};
const faSquareR = {
  prefix: 'far',
  iconName: 'square-r',
  icon: [448, 512, [], "e27c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l104 0c44.2 0 80 35.8 80 80c0 36.6-24.6 67.5-58.2 77l45.4 60.6c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8L220 288l-44 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112c0-13.3 10.7-24 24-24zm80 112l24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0 64 56 0z"]
};
const faCubes = {
  prefix: 'far',
  iconName: 'cubes',
  icon: [576, 512, [], "f1b3", "M290.7 48.3c-1.7-.6-3.6-.6-5.4 0l-81.2 29L288 109.5l83.9-32.1-81.2-29zM176 207.2l88 31.4 0-86.9-88-33.7 0 89.3zm136 31.4l88-31.4 0-89.3-88 33.7 0 86.9zM448 93l0 114.6 91.9 34.8c21.8 8.2 36.1 29.1 36.1 52.4l0 119.1c0 22.2-13.1 42.3-33.5 51.3l-96.4 42.4c-14 6.1-29.8 6.3-43.9 .5L288 460.7 173.8 508c-14.1 5.8-30 5.7-43.9-.5L33.5 465.1C13.1 456.2 0 436.1 0 413.9L0 294.7c0-23.3 14.4-44.1 36.1-52.4L128 207.5 128 93c0-23.7 14.9-44.8 37.2-52.7l104-37.1c12.2-4.3 25.5-4.3 37.6 0l104 37.1C433.1 48.2 448 69.3 448 93zM264 320.2l-88 33.7 0 101.3 88-36.4 0-98.6zM52.8 421.2L128 454.3l0-100.4L48 323.2l0 90.7c0 3.2 1.9 6 4.8 7.3zM400 455.1l0-101.3-88-33.7 0 98.6 88 36.4zm48-.9l75.2-33.1c2.9-1.3 4.8-4.2 4.8-7.3l0-90.7-80 30.7 0 100.4zM155 250.7c-1.8-.6-3.7-.6-5.5 .1L70.8 280.6 152 311.7l83.9-32.1L155 250.7zm266 0l-80.9 28.9L424 311.7l81.2-31.1-78.7-29.8c-1.8-.7-3.7-.7-5.5-.1z"]
};
const faEnvelopeOpenDollar = {
  prefix: 'far',
  iconName: 'envelope-open-dollar',
  icon: [512, 512, [], "f657", "M120 48c-4.4 0-8 3.6-8 8l0 169.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2 400 56c0-4.4-3.6-8-8-8L120 48zM48 276.2L48 456c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-179.8L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9L512 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 237.9zM276 88l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20s20 9 20 20z"]
};
const faDivide = {
  prefix: 'far',
  iconName: 'divide',
  icon: [448, 512, [10135, 247], "f529", "M264 96a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm0 320a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM408 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0z"]
};
const faSunCloud = {
  prefix: 'far',
  iconName: 'sun-cloud',
  icon: [640, 512, [127780], "f763", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l8.1-44.3c-16.9 0-32.8-4.4-46.6-12.1l-2.1 11.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4-13.3 19.3c9.6-2.7 19.7-4.1 30.1-4.1c9.8 0 19.4 1.3 28.5 3.7l15.3-22.1c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM256 144c-61.9 0-112 50.1-112 112s50.1 112 112 112c11.4 0 22.3-1.7 32.6-4.8c-.4-3.7-.6-7.4-.6-11.2c0-21.4 7-41.2 18.8-57.1C295.1 310.1 276.7 320 256 320c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 14.2-4.6 27.3-12.4 37.9c13.2-17.3 32.1-30 54-35.3c1.8-4 3.8-8 6.1-11.7C363 189.3 314.8 144 256 144zM384 416l184 0c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64s28.7 64 64 64z"]
};
const faLampFloor = {
  prefix: 'far',
  iconName: 'lamp-floor',
  icon: [384, 512, [], "e015", "M55.6 176l272.7 0L277.2 48 106.8 48 55.6 176zM66.3 20.1C71.1 8 82.9 0 96 0L288 0c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8s-15.9 14.1-26.5 14.1L32 224c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM88 464l80 0 0-208 48 0 0 208 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0L88 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faSquare7 = {
  prefix: 'far',
  iconName: 'square-7',
  icon: [448, 512, [], "e25c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c8.4 0 16.3 4.4 20.6 11.7s4.5 16.2 .5 23.7l-112 208c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l93-172.6L152 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faTengeSign = {
  prefix: 'far',
  iconName: 'tenge-sign',
  icon: [384, 512, [8376, "tenge"], "f7d7", "M0 56C0 42.7 10.7 32 24 32l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM0 184c0-13.3 10.7-24 24-24l168 0 168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0 0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248L24 208c-13.3 0-24-10.7-24-24z"]
};
const faTenge = faTengeSign;
const faHeadphones = {
  prefix: 'far',
  iconName: 'headphones',
  icon: [512, 512, [127911], "f025", "M49.6 262C62.4 159.4 149.9 80 256 80s193.6 79.4 206.4 182c-9.4-3.9-19.6-6-30.4-6c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48c44.2 0 80-35.8 80-80l0-32 0-32 0-48C512 146.6 397.4 32 256 32S0 146.6 0 288l0 48 0 32 0 32c0 44.2 35.8 80 80 80c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48c-10.8 0-21 2.1-30.4 6zM48 336c0-17.7 14.3-32 32-32l0 128c-17.7 0-32-14.3-32-32l0-32 0-32zm416 0l0 32 0 32c0 17.7-14.3 32-32 32l0-128c17.7 0 32 14.3 32 32z"]
};
const faHandsHolding = {
  prefix: 'far',
  iconName: 'hands-holding',
  icon: [640, 512, [], "f4c2", "M72 64c39.8 0 72 32.2 72 72l0 128.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8L496 136c0-39.8 32.2-72 72-72s72 32.2 72 72l0 216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9L592 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9c0 0 0 0 0 0L473 393c0 0 0 0 0 0l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16c0 0 0 0 0 0l26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8l0 51.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359s0 0 0 0l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16c0 0 0 0 0 0l-26.7-26.7s0 0 0 0l-15.9-15.9C106.2 332.1 96 307.5 96 281.9L96 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2L0 136C0 96.2 32.2 64 72 64z"]
};
const faCampfire = {
  prefix: 'far',
  iconName: 'campfire',
  icon: [512, 512, [], "f6ba", "M279.1 43.9L262.1 25.8c-1.8-1.9-3.6-4-5.4-6.1c0 0 0 0 0 0C248.6 10.4 239.9 .3 227.2 0c-6.5-.2-13.1 2.1-18.3 6.8c-21.1 19.2-45 44.4-63.8 72.9c-18.7 28.3-33.1 61-33.1 95C112 255.2 175.4 320 256 320c79.8 0 144-64.7 144-145.3c0-27.3-9.9-55.4-23.6-80.1C362.7 69.7 344.7 47 326.9 30.4c-5-4.7-11.5-7.1-17.9-7.1c-6.8 0-14 2.5-18.8 8.1l-11 12.5zm36.5 174.4c0 32.1-26 58.2-58.2 58.2s-58.2-26-58.2-58.2c0-33.2 33.7-66.4 49.8-80.4c4.9-4.2 11.9-4.2 16.8 0c16.1 14 49.8 47.2 49.8 80.4zM32.5 289.6c-12.4-4.7-26.3 1.5-31 13.9s1.5 26.2 13.9 31L188.3 400 15.5 465.6c-12.4 4.7-18.6 18.6-13.9 31s18.6 18.6 31 13.9L256 425.7l223.5 84.8c12.4 4.7 26.3-1.5 31-13.9s-1.5-26.2-13.9-31L323.7 400l172.8-65.6c12.4-4.7 18.6-18.6 13.9-31s-18.6-18.6-31-13.9L256 374.3 32.5 289.6z"]
};
const faCircleAmpersand = {
  prefix: 'far',
  iconName: 'circle-ampersand',
  icon: [512, 512, [], "e0f8", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 191.6c0-8.6 7-15.6 15.6-15.6l19.2 0c7.3 0 13.2 5.9 13.2 13.2c0 4.2-2 8.1-5.4 10.6L235 217.1l-14.5-14.5c-2.9-2.9-4.6-6.9-4.6-11zm71 46.9c15.7-11.5 25-29.8 25-49.3c0-33.8-27.4-61.2-61.2-61.2l-19.2 0c-35.1 0-63.6 28.5-63.6 63.6c0 16.9 6.7 33 18.6 45l9.2 9.2-24.7 18.1c-17.1 12.5-27.2 32.4-27.2 53.6c0 36.7 29.8 66.5 66.5 66.5l32.2 0c24.1 0 46.9-10.9 62-29.4L327 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-28.4-28.4 31.1-45c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-26.2 37.8-28.7-28.7L287 238.5zm-87.5 64.1l30.7-22.5 40.1 40.1-1.4 2c-6 8.6-15.8 13.8-26.3 13.8l-32.2 0c-10.2 0-18.5-8.3-18.5-18.5c0-5.9 2.8-11.4 7.5-14.9z"]
};
const faSnowflakes = {
  prefix: 'far',
  iconName: 'snowflakes',
  icon: [640, 512, [], "f7cf", "M224 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4l0-76.5L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L200 24c0-13.3 10.7-24 24-24zM487 7c9.4-9.4 24.6-9.4 33.9 0l23 23L567 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L487 41c-9.4-9.4-9.4-24.6 0-33.9zm32 192c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faHandsClapping = {
  prefix: 'far',
  iconName: 'hands-clapping',
  icon: [512, 512, [], "e1a8", "M328 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM223.1 18.7c7.4-4.9 17.3-2.9 22.2 4.4l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2zM412 152c9.5-5.1 20.4-8 32-8c37.6 0 68 30.4 68 68l0 117.6c0 100.5-81.3 182-181.7 182.4c27.3-16.9 50.5-39.8 67.8-66.8c39.4-23.4 65.8-66.4 65.8-115.6L464 212c0-11-9-20-20-20c-5 0-9.6 1.9-13.1 4.9c-2.5-16.7-9.2-32-18.9-44.9zM410.7 23.1c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48zM320 208l0 40c0 3.3-.6 6.4-1.8 9.2s-2.9 5.5-5.2 7.8s-5 4-7.8 5.2s-5.9 1.8-9.2 1.8s-6.4-.6-9.2-1.8s-5.5-2.9-7.8-5.2L169 154.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7L233 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L121 202.9l-32-32c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l24 24L185 295c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L65 242.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l48 48s0 0 0 0L137 343c1.2 1.2 2.2 2.4 3.1 3.8c6.2 9.3 5.1 22-3.1 30.2c-9.4 9.4-24.6 9.4-33.9 0L65 338.9s0 0 0 0c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9c0 2.6 1 5.2 2.9 7l22 22s0 0 0 0l16 16s0 0 0 0l33.6 33.6c25.2 25.2 59.4 39.4 95 39.4C291.8 464 352 403.8 352 329.6L352 208c0-8.8-7.2-16-16-16s-16 7.2-16 16zM113.9 129.6c10.4-15.4 28.1-25.6 48.1-25.6c15.4 0 30.1 6.1 41 17L274 192.1c7.1-27.6 32.2-48.1 62-48.1c35.3 0 64 28.7 64 64l0 121.6C400 430.3 318.3 512 217.6 512c-48.4 0-94.8-19.2-129-53.4L55 425s0 0 0 0L39 409s0 0 0 0l-22-22C6.1 376 0 361.3 0 345.9c0-19.6 9.7-36.9 24.6-47.4L17 290.9C6.1 280 0 265.3 0 249.9c0-21.2 11.4-39.8 28.4-49.9c-2.9-7-4.4-14.5-4.4-22.1c0-32 25.9-57.9 57.9-57.9c11.4 0 22.5 3.4 31.9 9.6z"]
};
const faRepublican = {
  prefix: 'far',
  iconName: 'republican',
  icon: [640, 512, [], "f75e", "M152 32C68.1 32 0 100.1 0 184l0 80L0 424c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-40 160 0 0 40c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56l0-40 48 0 0 24c0 39.8 32.2 72 72 72s72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48 0-96 0-80c0-83.9-68.1-152-152-152L152 32zM496 288l0 48-72 0c-13.3 0-24 10.7-24 24l0 64c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-64c0-13.3-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24l0 64c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-136 448 0zm0-48L48 240l0-56C48 126.6 94.6 80 152 80l240 0c57.4 0 104 46.6 104 104l0 56zM405.7 115.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L450 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM271.9 112c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-122.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L194 154.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6z"]
};
const faLeafMaple = {
  prefix: 'far',
  iconName: 'leaf-maple',
  icon: [512, 512, [127809], "f6f6", "M344.8 13.3c-3.7-7.4-11-12.4-19.3-13.2s-16.4 2.8-21.4 9.5L249.9 82l-2.1-16.1c-.9-7-4.8-13.2-10.7-17.1s-13.2-4.9-19.9-2.9L181.8 56.4 147 15.9c-4.6-5.3-11.2-8.4-18.2-8.4s-13.7 3.1-18.2 8.4L74 58.5 27 52.6c-7.9-1-15.8 2-21 8S-1.2 74.7 .8 82.4L41.4 238 10.7 258.5c-7 4.6-11 12.6-10.7 20.9s5 15.9 12.3 20l106.9 59.4L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L153.2 392.8l59.4 106.9c4.1 7.3 11.6 12 20 12.3s16.3-3.7 20.9-10.7L274 470.6l155.6 40.6c7.7 2 15.9 .1 21.9-5.2s9-13.1 8-21l-5.4-42.8c-.3-2.7 .7-5.3 2.7-7.1l39.3-33.7c5.3-4.6 8.4-11.2 8.4-18.2s-3.1-13.7-8.4-18.2l-40.6-34.8 10.5-35.4c2-6.8 .9-14-2.9-19.9s-10.1-9.8-17.1-10.7L430 262.1l72.4-54.3c6.7-5 10.2-13.1 9.5-21.4s-5.7-15.6-13.2-19.3l-36.1-18.1c-3.4-1.7-5.2-5.7-4.1-9.4l22.6-79.2c2.4-8.4 .1-17.4-6.1-23.6s-15.2-8.5-23.6-6.1L372.2 53.5c-3.7 1.1-7.6-.7-9.4-4.1L344.8 13.3zM188.5 357.5L313.9 232.1c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L154.5 323.5 70.1 276.6l2.7-1.8c14.2-9.5 20.8-26.9 16.5-43.4L56.2 104.6l24.7 3.1c8 1 16-2.1 21.2-8.2l26.7-31.1 26.7 31.1c6.2 7.2 16 10.1 25.1 7.4l23.2-6.9 6 46.8c1.2 9.7 8.2 17.7 17.7 20.2s19.5-1 25.3-8.8l66.5-88.7 .7 1.4C332 95 359.5 107.1 385.4 99.7l37.7-10.8-10.8 37.7c-7.4 25.9 4.7 53.4 28.8 65.5l1.4 .7-88.7 66.5c-7.8 5.9-11.3 15.9-8.8 25.3s10.5 16.4 20.2 17.7l46.8 6-6.9 23.2c-2.7 9.1 .2 18.9 7.4 25.1l31.1 26.7-18.1 15.5c-14.3 12.2-21.5 30.8-19.1 49.5l1 7.7L280.6 422.8c-16.5-4.3-33.9 2.3-43.4 16.5l-1.8 2.7-46.9-84.5z"]
};
const faArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-left',
  icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
};
const faPersonCircleXmark = {
  prefix: 'far',
  iconName: 'person-circle-xmark',
  icon: [576, 512, [], "e543", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
const faRuler = {
  prefix: 'far',
  iconName: 'ruler',
  icon: [512, 512, [128207], "f545", "M63.2 379.3c-6.2-6.2-6.2-16.4 0-22.6l39.4-39.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 41.4-41.4 30.1 30.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-30.1-30.1 39.4-39.4c6.2-6.2 16.4-6.2 22.6 0l69.5 69.5c6.2 6.2 6.2 16.4 0 22.6L155.3 448.8c-6.2 6.2-16.4 6.2-22.6 0L63.2 379.3zM98.7 482.7c25 25 65.5 25 90.5 0L482.7 189.3c25-25 25-65.5 0-90.5L413.3 29.3c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"]
};
const faArrowLeftFromBracket = {
  prefix: 'far',
  iconName: 'arrow-left-from-bracket',
  icon: [512, 512, [], "e668", "M7 273c-9.4-9.4-9.4-24.6 0-33.9L135 111c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L328 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 280l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 273zM344 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c48.6 0 88 39.4 88 88l0 272c0 48.6-39.4 88-88 88l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c22.1 0 40-17.9 40-40l0-272c0-22.1-17.9-40-40-40l-80 0z"]
};
const faCupStrawSwoosh = {
  prefix: 'far',
  iconName: 'cup-straw-swoosh',
  icon: [384, 512, [], "e364", "M249.3 0L280 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.7 0c-3.7 0-6.9 2.6-7.8 6.2L224.2 128l79.6 0 48.2 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-12 0-48.2 0-89.9 0-35.8 0-89.9 0L36 176l-12 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 48.2 0 94.7 0 20-84.8C200.8 17.9 223.4 0 249.3 0zM60.3 468L38.7 208l48.2 0L99.7 362.4c15.7-3.1 27.5-7.3 36.9-11.9c19.3-9.5 30.1-22 42.8-37.6l1.9-2.3c12.3-15.2 27.4-33.8 53.1-47.7c16-8.6 35.4-15.1 59.8-18.9l3-36 48.2 0L323.7 468c-2.1 24.9-22.9 44-47.8 44l-167.7 0c-25 0-45.8-19.1-47.8-44zM290 293.5c-14.1 3.1-24.6 7.1-32.9 11.6c-17.2 9.3-26.9 21.2-39.9 37.2l-.7 .8c-13.3 16.4-29.5 35.9-58.7 50.4c-14.9 7.4-32.6 13.1-54.2 17l4.5 53.5 167.7 0L290 293.5z"]
};
const faTemperatureSun = {
  prefix: 'far',
  iconName: 'temperature-sun',
  icon: [640, 512, ["temperature-hot"], "f76a", "M320.6 98.5l-2.7-.5L303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1 13.4 112.2c-5.4 .9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6L208 363.5l70.8 49.6c4.5 3.1 10.3 3.8 15.4 1.6c.7-.3 1.5-.7 2.1-1.1c-5.4-16.9-8.3-35-8.3-53.7c0-37.7 11.8-72.6 32-101.2L320 112c0-4.5 .2-9 .6-13.5zM208 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6L400 112zM464 0C402.1 0 352 50.2 352 112l0 161.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L576 112C576 50.2 525.9 0 464 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L480 112c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faTemperatureHot = faTemperatureSun;
const faAlignLeft = {
  prefix: 'far',
  iconName: 'align-left',
  icon: [448, 512, [], "f036", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z"]
};
const faDiceD6 = {
  prefix: 'far',
  iconName: 'dice-d6',
  icon: [448, 512, [], "f6d1", "M243.9 7.7c-12.4-7-27.6-6.9-39.9 .3L19.8 115.6C7.5 122.8 0 135.9 0 150.1L0 366.6c0 14.5 7.8 27.8 20.5 34.9l184 103c12.1 6.8 26.9 6.8 39.1 0l184-103c12.6-7.1 20.5-20.4 20.5-34.9l0-219.9c0-14.4-7.7-27.7-20.3-34.8L243.9 7.7zM71.8 140.8L224.2 51.7l152 86.2L223.8 228.2l-152-87.4zM48 182.4l152 87.4 0 177.2L48 361.9l0-179.5zM248 447.1l0-177.4 152-90.1 0 182.4L248 447.1z"]
};
const faRestroom = {
  prefix: 'far',
  iconName: 'restroom',
  icon: [640, 512, [], "f7bd", "M128 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-7.3 80l14.6 0c3 0 5.9 .3 8.7 1l0 127-32 0 0-127c2.8-.6 5.7-1 8.7-1zM112 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236.6 17.6 45.3c4.8 12.4 18.7 18.5 31.1 13.7s18.5-18.7 13.7-31.1l-37-95.2c-13.2-33.8-45.7-56.1-82-56.1l-14.6 0c-36.3 0-68.9 22.3-82 56.1L1.6 279.3c-4.8 12.4 1.3 26.3 13.7 31.1s26.3-1.3 31.1-13.7L64 251.4 64 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM320 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM560 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48 80c-40.7 0-77.2 25-92 62.9l-34.4 88.4c-4.8 12.4 1.3 26.3 13.7 31.1c7.6 3 15.8 1.8 22.1-2.5l-15.7 55.8c-2.9 10.2 4.8 20.3 15.4 20.3l26.9 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.9 0c10.6 0 18.3-10.1 15.4-20.3l-15.7-55.8c6.3 4.2 14.5 5.4 22.1 2.5c12.4-4.8 18.5-18.7 13.7-31.1L604 190.9C589.2 153 552.7 128 512 128zm0 48c2.2 0 4 1.4 4.6 3.5l44 156.5-97.3 0 44-156.5c.6-2.1 2.5-3.5 4.6-3.5z"]
};
const faHighDefinition = {
  prefix: 'far',
  iconName: 'high-definition',
  icon: [576, 512, ["rectangle-hd"], "e1ae", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 184l0 144c0 13.3 10.7 24 24 24l56 0c53 0 96-43 96-96s-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24zm80 24c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96 32 0zM160 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 64 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-64 0 0-48z"]
};
const faRectangleHd = faHighDefinition;
const faJ = {
  prefix: 'far',
  iconName: 'j',
  icon: [320, 512, [106], "4a", "M296 32c13.3 0 24 10.7 24 24l0 264c0 88.4-71.6 160-160 160S0 408.4 0 320l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 61.9 50.1 112 112 112s112-50.1 112-112l0-264c0-13.3 10.7-24 24-24z"]
};
const faGalaxy = {
  prefix: 'far',
  iconName: 'galaxy',
  icon: [512, 512, [], "e008", "M160 184c0-68.3 50.4-124.9 116.1-134.5c-31.2 28.4-51.6 66.6-58 108.1c-1.4 9.3 2.7 18.6 10.6 23.7s18.1 5.2 26 .1C275.9 167.8 301 160 328 160c68.3 0 124.9 50.4 134.6 116.1c-28.4-31.2-66.6-51.6-108.1-58c-9.3-1.4-18.6 2.7-23.7 10.6s-5.2 18.1-.1 26C344.2 275.9 352 301 352 328c0 68.3-50.4 124.9-116.1 134.5c31.2-28.4 51.6-66.6 58-108.1c1.4-9.3-2.7-18.6-10.6-23.7s-18.1-5.2-26-.1C236.1 344.2 211 352 184 352c-68.3 0-124.9-50.4-134.5-116.1c28.4 31.2 66.6 51.6 108.1 58c9.3 1.4 18.6-2.7 23.7-10.6s5.2-18.1 .1-26C167.8 236.1 160 211 160 184zM296 0C194.4 0 112 82.4 112 184c0 15.9 2 31.3 5.8 46c-16.4-9.4-30.8-22.2-42.2-37.9l-13-17.9c-6.5-9-16.9-14.2-28-14.2C15.5 160 0 175.5 0 194.6L0 216C0 317.6 82.4 400 184 400c15.9 0 31.3-2 46-5.8c-9.4 16.4-22.2 30.8-37.9 42.2l-17.9 13c-9 6.5-14.2 16.9-14.2 28c0 19.1 15.5 34.6 34.6 34.6l21.4 0c101.6 0 184-82.4 184-184c0-15.9-2-31.3-5.8-46c16.4 9.4 30.8 22.2 42.2 37.9l13 17.9c6.5 9 16.9 14.2 28 14.2c19.1 0 34.6-15.5 34.6-34.6l0-21.4c0-101.6-82.4-184-184-184c-15.9 0-31.3 2-46 5.8c9.4-16.4 22.2-30.8 37.9-42.2l17.9-13-14-19.3 14 19.3c9-6.5 14.2-16.9 14.2-28C352 15.5 336.5 0 317.4 0L296 0zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faUsersViewfinder = {
  prefix: 'far',
  iconName: 'users-viewfinder',
  icon: [640, 512, [], "e595", "M48 48l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 32C0 14.3 14.3 0 32 0L136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L48 48zm544 0l-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24L608 0c17.7 0 32 14.3 32 32l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88zM136 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 512c-17.7 0-32-14.3-32-32L0 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0zm456 0l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 17.7-14.3 32-32 32l-104 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0zM320 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-51.6 82c6.3-1.3 12.9-2 19.6-2l32 0 32 0c6.7 0 13.3 .7 19.6 2c1.1 .2 2.2 .5 3.3 .7c23.6 5.8 43.8 20.3 56.9 39.9c1.2 1.7 2.3 3.5 3.3 5.4c8.2 14.1 12.8 30.5 12.8 48c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32c0-17.5 4.7-33.9 12.8-48c12.9-22.3 34.6-39 60.3-45.3c1.1-.3 2.2-.5 3.3-.7zm96.2-162.6A72 72 0 1 1 275.4 240.5a72 72 0 1 1 89.2-113.1zM397.3 368c-6.6-18.6-24.4-32-45.3-32l-64 0c-20.9 0-38.7 13.4-45.3 32l154.5 0zM127.8 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 309.3c0-29.5 23.9-53.3 53.3-53.3l69.3 0c9.8 0 18.9 2.6 26.8 7.2c-34.6 12.2-62.5 38.9-76.2 72.8l-46.6 0C107.9 336 96 324.1 96 309.3zM470.7 336c-13.7-33.9-41.5-60.6-76.2-72.8c7.9-4.6 17-7.2 26.8-7.2l69.3 0c29.5 0 53.3 23.9 53.3 53.3c0 14.7-11.9 26.7-26.7 26.7l-46.6 0zM416 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faFileVideo = {
  prefix: 'far',
  iconName: 'file-video',
  icon: [384, 512, [], "f1c8", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 288c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 16 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96z"]
};
const faCherries = {
  prefix: 'far',
  iconName: 'cherries',
  icon: [640, 512, [], "e0ec", "M288 24L302.1 4.5c-6.9-5-15.9-5.9-23.7-2.5s-13.2 10.7-14.2 19.1c0 0 0 0 0 0s0 0 0 0s0 0 0 0l0 .2-.1 .9c-.1 .9-.3 2.2-.6 4c-.6 3.6-1.5 9-2.9 15.8c-2.8 13.7-7.6 33.3-15.3 56.3c-14 42-37.4 94.7-75.8 143.7C152.3 233.5 126.5 224 96 224c0 0-96 0-96 112C0 480 144 512 192 512s192-16 192-176c0-112-96-112-96-112c-20.5 0-38.9 4.3-54 9.7c27.1-42.6 45-85.1 56.7-120.2c5.7-17 9.9-32.3 13-45.1c11.7 10.8 25.8 24.7 40.1 41.2c29.6 34.3 59.1 78.4 73.1 128.5c-12-5.3-27-10.3-44.2-12.7c16.3 14.8 30.1 35.3 37.4 63c1.8 1 3.3 2 4.6 2.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-12.3 0-36.6-3.4-61.7-13.4c-9.2 14.8-20.2 27.5-32.3 38.2C390.4 506.3 427.7 512 448 512c48 0 192-16 192-176c0-112-96-112-96-112c-32.3 0-59.2 10.6-76.3 19.6C453.5 176 415.2 118.9 380.2 78.3c-19.9-23-39.2-41.3-53.6-53.9c-7.2-6.3-13.2-11.2-17.5-14.5c-2.1-1.7-3.8-3-5-3.9c-.6-.4-1.1-.8-1.4-1l-.4-.3-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L288 24zM162.4 293.8c17.4 13.7 41.9 13.7 59.3 0l.4-.3c.6-.4 1.6-1.2 3.2-2.2c3.1-2 8-4.9 14.2-7.8c12.6-5.9 29.3-11.3 48-11.4l.1 0 .6 0c1.1 .1 3.1 .3 5.7 .8c5.3 1 11.9 3 18 6.6c9.1 5.3 24.2 17.4 24.2 56.5c0 62-26.1 90.5-53.8 106.3c-31.5 18-69.7 21.7-90.2 21.7c-16.7 0-55.6-6.3-88.7-26.8C72.7 418.3 48 388.4 48 336c0-39.1 15.1-51.2 24.2-56.5c6.1-3.6 12.7-5.6 18-6.6c2.6-.5 4.6-.7 5.7-.8c.3 0 .6 0 .7-.1c18.7 .1 35.4 5.5 48 11.4c6.2 2.9 11.1 5.8 14.2 7.8c1.5 1 2.6 1.8 3.2 2.2l.4 .3z"]
};
const faUpRightFromSquare = {
  prefix: 'far',
  iconName: 'up-right-from-square',
  icon: [512, 512, ["external-link-alt"], "f35d", "M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41l0-127c0-22.1-17.9-40-40-40L345 0c-22.6 0-41 18.3-41 41zm57.9 7L464 48l0 102.1L361.9 48zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faExternalLinkAlt = faUpRightFromSquare;
const faCircleSort = {
  prefix: 'far',
  iconName: 'circle-sort',
  icon: [512, 512, ["sort-circle"], "e030", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM267.3 100.7l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-192 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0zM244.7 411.3l-96-96c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l192 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0z"]
};
const faSortCircle = faCircleSort;
const faTableCells = {
  prefix: 'far',
  iconName: 'table-cells',
  icon: [512, 512, ["th"], "f00a", "M360 80l0 88 104 0 0-72c0-8.8-7.2-16-16-16l-88 0zm-48 0L200 80l0 88 112 0 0-88zM152 80L64 80c-8.8 0-16 7.2-16 16l0 72 104 0 0-88zM48 216l0 80 104 0 0-80L48 216zm0 128l0 72c0 8.8 7.2 16 16 16l88 0 0-88L48 344zm152 88l112 0 0-88-112 0 0 88zm160 0l88 0c8.8 0 16-7.2 16-16l0-72-104 0 0 88zM464 296l0-80-104 0 0 80 104 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 296l112 0 0-80-112 0 0 80z"]
};
const faTh = faTableCells;
const faBagShoppingMinus = {
  prefix: 'far',
  iconName: 'bag-shopping-minus',
  icon: [448, 512, [], "e650", "M224 48c35.3 0 64 28.7 64 64l0 48-128 0 0-48c0-35.3 28.7-64 64-64zM112 112l0 48-64 0c-26.5 0-48 21.5-48 48L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112zM48 208l352 0 0 208c0 26.5-21.5 48-48 48L96 464c-26.5 0-48-21.5-48-48l0-208zm96 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0z"]
};
const faFilePdf = {
  prefix: 'far',
  iconName: 'file-pdf',
  icon: [512, 512, [], "f1c1", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"]
};
const faSiren = {
  prefix: 'far',
  iconName: 'siren',
  icon: [448, 512, [], "e02d", "M345.6 304l48.4 0L375 152.1C371 120 343.8 96 311.5 96l-175 0C104.2 96 77 120 73 152.1L54 304l48.4 0 18.2-146c1-8 7.8-14 15.9-14l175 0c8.1 0 14.9 6 15.9 14l18.2 146zm-165.5 0l11.8-94c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-12.2 98 32.2 0zM48 384l352 0 0 48L48 432l0-48zM0 384l0 48c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-48c0-26.5-21.5-48-48-48L48 336c-26.5 0-48 21.5-48 48z"]
};
const faArrowUpToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-to-dotted-line',
  icon: [448, 512, [], "e0a1", "M32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM320 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM241.5 151.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 228.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"]
};
const faImageLandscape = {
  prefix: 'far',
  iconName: 'image-landscape',
  icon: [576, 512, ["landscape"], "e1b5", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l19.8 0 80.8-110.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L232.8 330l83.1-127.1c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L485 400l27 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM96 448l-32 0c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-40 0-200 0-72 0L96 448zm64-288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faLandscape = faImageLandscape;
const faTankWater = {
  prefix: 'far',
  iconName: 'tank-water',
  icon: [448, 512, [], "e452", "M277.2 80L263.9 55.7 251 32l133 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l133 0L184.1 55.7 170.8 80 64 80c-8.8 0-16 7.2-16 16l0 206.4c14.1-2.7 27.8-8.7 39.3-15.3c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 18.9 12.7c15.9 9 35.6 16.9 55.3 16.9s39.5-7.8 55.3-16.9c6.9-3.9 13.1-8.2 18.9-12.7c12.9-10 30.6-10 43.4 0c5.9 4.6 12 8.8 19 12.8c11.6 6.6 25.2 12.5 39.4 15.3L400 96c0-8.8-7.2-16-16-16L277.2 80zM48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-65c-25-3.1-47.1-13-63.1-22.1c-6.5-3.7-12.2-7.4-17-10.7c-4.7 3.3-10.5 7-16.9 10.7c-19.3 11-47.6 23.1-79.1 23.1s-59.7-12.2-79.1-23.1c-6.5-3.7-12.2-7.4-16.9-10.7c-4.7 3.3-10.5 7-16.9 10.7c-16 9.1-38.1 19-63 22.1l0 65zM212.2 71c2.4-4.3 6.9-7 11.8-7s9.5 2.7 11.8 7L273 139.2c4.6 8.4 7 17.9 7 27.5l0 1.4c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-1.4c0-9.6 2.4-19 7-27.5L212.2 71z"]
};
const faCurlingStone = {
  prefix: 'far',
  iconName: 'curling-stone',
  icon: [576, 512, [129356, "curling"], "f44a", "M264 80c-22.1 0-40 17.9-40 40l0 24 192 0c35.3 0 64 28.7 64 64l0 1.1c54.3 7.8 96 54.4 96 110.9l0 48c0 61.9-50.1 112-112 112l-352 0C50.1 480 0 429.9 0 368l0-48c0-56.4 41.7-103.1 96-110.9l0-1.1c0-35.3 28.7-64 64-64l16 0 0-24c0-48.6 39.4-88 88-88l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L264 80zM112 432l352 0c35.3 0 64-28.7 64-64L48 368c0 35.3 28.7 64 64 64zM48 320l480 0c0-35.3-28.7-64-64-64l-352 0c-35.3 0-64 28.7-64 64z"]
};
const faCurling = faCurlingStone;
const faGamepadModern = {
  prefix: 'far',
  iconName: 'gamepad-modern',
  icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 336l208 0c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3c33 0 59.8-26.8 59.8-59.8l0-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9C109.4 107.6 87.8 132 81.6 168L48.9 358.8c-.6 3.5-.9 7-.9 10.6l0 2.8c0 33 26.8 59.8 59.8 59.8c27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384l-208 0-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2l0-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7l0 2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168l0 32 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faGamepadAlt = faGamepadModern;
const faMessagesQuestion = {
  prefix: 'far',
  iconName: 'messages-question',
  icon: [640, 512, [], "e1e7", "M72 48C58.7 48 48 58.7 48 72l0 176c0 13.3 10.7 24 24 24l48 0c13.3 0 24 10.7 24 24l0 19.2L202.7 276c3.9-2.6 8.6-4 13.3-4l128 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24L72 48zM0 72C0 32.2 32.2 0 72 0L344 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-120.7 0-90 60c-7.4 4.9-16.8 5.4-24.6 1.2S96 368.9 96 360l0-40-24 0c-39.8 0-72-32.2-72-72L0 72zM256 352l48 0 0 24c0 13.3 10.7 24 24 24l96 0c4.7 0 9.4 1.4 13.3 4L496 443.2l0-19.2c0-13.3 10.7-24 24-24l48 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24l-120 0 0-48 120 0c39.8 0 72 32.2 72 72l0 176c0 39.8-32.2 72-72 72l-24 0 0 40c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-90-60L328 448c-39.8 0-72-32.2-72-72l0-24zM147.9 96.1c5.5-15.4 20.1-25.7 36.4-25.7l41.3 0c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 165.4l0 .3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7l-41.3 0c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 228a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
const faBookBible = {
  prefix: 'far',
  iconName: 'book-bible',
  icon: [448, 512, ["bible"], "f647", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM208 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 96c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-96-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faBible = faBookBible;
const faO = {
  prefix: 'far',
  iconName: 'o',
  icon: [448, 512, [111], "4f", "M224 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"]
};
const faSuitcaseMedical = {
  prefix: 'far',
  iconName: 'suitcase-medical',
  icon: [512, 512, ["medkit"], "f0fa", "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm240 88l0 288-224 0 0-288 8 0 208 0 8 0zM96 144l0 288-32 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0zM416 432l0-288 32 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-32 0zM229.3 224l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z"]
};
const faMedkit = faSuitcaseMedical;
const faBriefcaseArrowRight = {
  prefix: 'far',
  iconName: 'briefcase-arrow-right',
  icon: [512, 512, [], "e2f2", "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm24 88l208 0 88 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l88 0zm145 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L152 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l150.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
const faExpandWide = {
  prefix: 'far',
  iconName: 'expand-wide',
  icon: [512, 512, [], "f320", "M136 64c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64l112 0zM0 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 448c-13.3 0-24-10.7-24-24L0 312zM488 64c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zM464 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0 0-88z"]
};
const faClockElevenThirty = {
  prefix: 'far',
  iconName: 'clock-eleven-thirty',
  icon: [512, 512, [], "e348", "M48 256a208 208 0 1 0 416 0A208 208 0 1 0 48 256zm464 0A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM232 392l0-128.7-60-90c-7.4-11-4.4-25.9 6.7-33.3s25.9-4.4 33.3 6.7l64 96c2.6 3.9 4 8.6 4 13.3l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
};
const faRv = {
  prefix: 'far',
  iconName: 'rv',
  icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24L360 0c13.3 0 24 10.7 24 24l0 8 136 0c48.6 0 88 39.4 88 88l0 40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5l0 96.2c0 22.1-17.9 40-40 40l-25.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16l-9.6 0-153.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1c-1.3-.8-2.4-1.8-3.5-2.9L21.1 335C7.6 321.5 0 303.2 0 284.1L0 104C0 64.2 32.2 32 72 32l152 0 0-8zM72 80c-13.3 0-24 10.7-24 24l0 180.1c0 6.4 2.5 12.5 7 17L121.9 368l6.1 0c13.4-10 30-16 48-16s34.6 6 48 16l160 0 0-112 0-72c0-13.3 10.7-24 24-24l16 0 80 0 56 0 0-40c0-22.1-17.9-40-40-40L72 80zM556.8 256l-61.1-48L432 208l0 48 124.8 0zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM120 128l144 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faUserSecret = {
  prefix: 'far',
  iconName: 'user-secret',
  icon: [448, 512, [128373], "f21b", "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 13.4 22.1 25.6 57.7 34.3C88.6 169.4 88 176.6 88 184c0 13.9 2.1 27.4 6 40l-48.6 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512L168 512l112 0 138.3 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4L354 224c3.9-12.6 6-26.1 6-40c0-7.4-.6-14.6-1.7-21.7c35.6-8.7 57.7-20.9 57.7-34.3c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44 448l-24.8-99.1c-2.1-8.2-.8-16.9 3.6-24.2l15.7-26.2c25.7-7.6 48.3-22.6 65.2-42.5l23.8 0-19.8 49.5c-8.1 20.2-1.6 43.3 15.9 56.3c27.3 20.4 46.2 51 51.2 86.2L268 464zM185.5 314.5l15.7 26.2c4.4 7.3 5.7 16 3.6 24.2L180 464 49.3 464c4.9-35.2 23.9-65.8 51.2-86.2c17.4-13 23.9-36.1 15.9-56.3L96.5 272l23.8 0c16.9 19.9 39.5 34.9 65.2 42.5zM224 272c-38.2 0-70.7-24.4-82.9-58.4c7.1 6.5 16.5 10.4 26.9 10.4l12.4 0c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2l12.4 0c10.4 0 19.8-3.9 26.9-10.4c-12.2 34-44.7 58.4-82.9 58.4z"]
};
const faOtter = {
  prefix: 'far',
  iconName: 'otter',
  icon: [640, 512, [129446], "f700", "M135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2 12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185zM160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-5.1 0-10.1-.4-14.9-1.2c9.5 28.6 36.5 49.2 68.3 49.2l64 0c13.3 0 24 10.7 24 24c0 2.8-.5 5.5-1.4 8L352 336c0-11.4 2.4-22.2 6.7-32L328 304c-36.7 0-68.1-22.4-81.3-54.3c-10.3 4.1-21.5 6.3-33.3 6.3c-14.1 0-27.9-3.3-40.5-9.6L160 240zm250.8 16c10.8-45.9 52-80 101.2-80c13.3 0 24 10.7 24 24l0-5.7c0-38.8-24.9-73.3-61.7-85.6l-17.9-6c-12.1-4-18.9-16.8-15.6-29s15.7-19.8 28.1-17.2l16.2 3.4C575.4 78.9 640 158.5 640 250.8c0 120.3-92.6 218.9-210.4 228.5c-4.5 .5-9 .8-13.6 .8l-5.2 0L384 480l-126.4 0C133 480 32 379 32 254.4l0-37.6c-10.1-14.6-16-32.3-16-51.4L16 144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 8-1 15.7-3 23.1c12.4-7.9 27.2-12.5 43-12.5l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-16.6 0-30.2 12.6-31.8 28.7c4.9 2.1 10.2 3.3 15.8 3.3l82.8 0zM99.7 335.8l.1 .2 .3 0-.4-.2zM410.8 432c4.7 0 9.4-.2 14.1-.5c35.6-4.4 63.1-34.7 63.1-71.5l0-56 0-48 0-26.6c-18.9 9-32 28.3-32 50.6c0 13.3-10.7 24-24 24c-17.7 0-32 14.3-32 32l0 24c0 13.3-10.7 24-24 24l-239.8 0c31.8 29.8 74.5 48 121.4 48L384 432l26.8 0zM536 360c0 8.2-.8 16.3-2.4 24c35.9-33.1 58.4-80.6 58.4-133.3c0-16.7-2.8-32.8-8-47.9l0 5.1c0 35.5-19.3 66.6-48 83.2l0 68.8zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faDreidel = {
  prefix: 'far',
  iconName: 'dreidel',
  icon: [448, 512, [], "f792", "M441 39c9.4 9.4 9.4 24.6 0 33.9L327.6 186.3l67.7 67.7c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7L64 480c-35.3 0-64-28.7-64-64L0 269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l67.7 67.7L407 39c9.4-9.4 24.6-9.4 33.9 0zM106.3 204.3L52.7 257.9c-3 3-4.7 7.1-4.7 11.3L48 416c0 8.8 7.2 16 16 16l146.7 0c4.2 0 8.3-1.7 11.3-4.7l53.7-53.7L106.3 204.3zm33.9-33.9L309.7 339.7 361.4 288 192 118.6l-51.7 51.7z"]
};
const faPersonDress = {
  prefix: 'far',
  iconName: 'person-dress',
  icon: [320, 512, ["female"], "f182", "M208 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm21.7 185.7l37.4 66.1c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l37.4-66.1L53.7 363.7C50.8 373.9 58.5 384 69.1 384L96 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.9 0c10.6 0 18.3-10.1 15.4-20.3L229.7 233.7zM160 176c2.2 0 4 1.4 4.6 3.5l44 156.5-97.3 0 44-156.5c.6-2.1 2.5-3.5 4.6-3.5z"]
};
const faFemale = faPersonDress;
const faCommentDollar = {
  prefix: 'far',
  iconName: 'comment-dollar',
  icon: [512, 512, [], "f651", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM276 136c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
};
const faBusinessTime = {
  prefix: 'far',
  iconName: 'business-time',
  icon: [640, 512, ["briefcase-clock"], "f64a", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 32.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-34.9c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0 160 0 8.2 0c-21.9 26.6-36.2 59.7-39.5 96l-.7 0-96 0c-17.7 0-32-14.3-32-32l0-16L48 304l0 112c0 8.8 7.2 16 16 16l268 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"]
};
const faBriefcaseClock = faBusinessTime;
const faFlowerTulip = {
  prefix: 'far',
  iconName: 'flower-tulip',
  icon: [512, 512, [127799], "f801", "M273.9 8.1C269.4 2.9 262.9 0 256 0s-13.4 2.9-17.9 8.1L189 63.3 134.7 21.1c-7.2-5.6-17-6.6-25.3-2.6S96 30.8 96 40l0 112c0 75.1 60.9 136 136 136l0 85.4C191 321.4 127.4 288 56 288l-28 0c-15.5 0-28 12.5-28 28C0 424.2 87.8 512 196 512l36 0 48 0 36 0c108.2 0 196-87.8 196-196c0-15.5-12.5-28-28-28l-28 0c-71.4 0-135 33.4-176 85.4l0-85.4c75.1 0 136-60.9 136-136l0-112c0-9.2-5.2-17.5-13.5-21.6s-18-3-25.3 2.6L323 63.3 273.9 8.1zM280 240l-48 0c-48.6 0-88-39.4-88-88l0-62.9 33.3 25.9c10 7.8 24.3 6.5 32.7-3L256 60.1l46.1 51.8c8.4 9.5 22.7 10.8 32.7 3L368 89.1l0 62.9c0 48.6-39.4 88-88 88zM196 464c-75 0-136.9-55.7-146.7-128l6.7 0c80.6 0 148.5 54.1 169.4 128L196 464zm120 0l-29.4 0c20.9-73.9 88.8-128 169.4-128l6.7 0C452.9 408.3 391 464 316 464z"]
};
const faPeoplePantsSimple = {
  prefix: 'far',
  iconName: 'people-pants-simple',
  icon: [512, 512, [], "e21a", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L192 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM329.7 237.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L448 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3z"]
};
const faCloudDrizzle = {
  prefix: 'far',
  iconName: 'cloud-drizzle',
  icon: [512, 512, [], "f738", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM88 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm168-24c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24zm-72-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm168-24c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24z"]
};
const faTableCellsLarge = {
  prefix: 'far',
  iconName: 'table-cells-large',
  icon: [512, 512, ["th-large"], "f009", "M280 80l0 152 184 0 0-136c0-8.8-7.2-16-16-16L280 80zm-48 0L64 80c-8.8 0-16 7.2-16 16l0 136 184 0 0-152zM48 280l0 136c0 8.8 7.2 16 16 16l168 0 0-152L48 280zM280 432l168 0c8.8 0 16-7.2 16-16l0-136-184 0 0 152zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faThLarge = faTableCellsLarge;
const faBookTanakh = {
  prefix: 'far',
  iconName: 'book-tanakh',
  icon: [448, 512, ["tanakh"], "f827", "M448 88c0-48.6-39.4-88-88-88L56 0C25.1 0 0 25.1 0 56L0 344c0 22.3 13.1 41.6 32 50.6L32 464l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l344 0c44.2 0 80-35.8 80-80c0-2.7-.1-5.4-.4-8l.4 0 0-336zM368 400c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 464l0-64 288 0zm32-41.3c-9.8-4.3-20.6-6.7-32-6.7L56 352c-4.4 0-8-3.6-8-8L48 56c0-4.4 3.6-8 8-8l304 0c22.1 0 40 17.9 40 40l0 270.7zM216 104l13.9 24-27.7 0L216 104zM202.1 80l-27.7 48L119 128c-12.3 0-20 13.3-13.9 24l27.7 48-27.7 48c-6.2 10.7 1.5 24 13.9 24l55.4 0 27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48 55.4 0c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24l-55.4 0L229.9 80c-6.2-10.7-21.6-10.7-27.7 0zm-69.3 72l27.7 0-13.9 24-13.9-24zm55.4 0l55.4 0 27.7 48-27.7 48-55.4 0-27.7-48 27.7-48zm-55.4 96l13.9-24 13.9 24-27.7 0zM216 296l-13.9-24 27.7 0L216 296zm83.1-48l-27.7 0 13.9-24 13.9 24zm0-96l-13.9 24-13.9-24 27.7 0z"]
};
const faTanakh = faBookTanakh;
const faSolarSystem = {
  prefix: 'far',
  iconName: 'solar-system',
  icon: [512, 512, [], "e02f", "M464 256c0 42.1-12.5 81.3-34 114.1c-4.4-1.3-9.1-2.1-14-2.1c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464C141.1 464 48 370.9 48 256c0-42.1 12.5-81.3 34-114.1c4.4 1.3 9.1 2.1 14 2.1c26.5 0 48-21.5 48-48s-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-14.1-9.1-25.1-22.4-31.3-38.2c-26.1 11.8-55 18.3-85.5 18.3zM390.8 169.8c.8-3.1 1.2-6.4 1.2-9.8c0-22.1-17.9-40-40-40c-3.4 0-6.6 .4-9.8 1.2C317.3 105.2 287.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-31.8-9.3-61.3-25.2-86.2zM312 159c0 .3 0 .7 0 1c0 22.1 17.9 40 40 40c.3 0 .7 0 1 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c20.4 0 39.5 5.5 56 15zm-56 81a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faSealQuestion = {
  prefix: 'far',
  iconName: 'seal-question',
  icon: [512, 512, [], "e243", "M176 112c12.7 0 24.9-5.1 33.9-14.1L256 51.9l46.1 46.1c9 9 21.2 14.1 33.9 14.1l64 0 0 64c0 12.7 5.1 24.9 14.1 33.9l45.6 45.6-45.6 45.6c-9 9-14.1 21.2-14.1 33.9l0 64.9-64.9 0c-12.7 0-24.9 5.1-33.9 14.1L256 459.2l-45.1-45.1c-9-9-21.2-14.1-33.9-14.1L112 400l0-64.9c0-12.7-5.1-24.9-14.1-33.9L52.4 255.5l45.6-45.6c9-9 14.1-21.2 14.1-33.9l0-64 64 0zM289.9 17.9c-18.7-18.7-49.1-18.7-67.9 0L176 64l-64 0c-26.5 0-48 21.5-48 48l0 64L18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1 64 400c0 26.5 21.5 48 48 48l64.9 0 45.1 45.1c18.7 18.7 49.1 18.7 67.9 0L335.1 448l64.9 0c26.5 0 48-21.5 48-48l0-64.9 45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176l0-64c0-26.5-21.5-48-48-48l-64 0L289.9 17.9zM169.8 165.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faPhoneVolume = {
  prefix: 'far',
  iconName: 'phone-volume',
  icon: [512, 512, ["volume-control-phone"], "f2a0", "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zm73 166.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2z"]
};
const faVolumeControlPhone = faPhoneVolume;
const faDiscDrive = {
  prefix: 'far',
  iconName: 'disc-drive',
  icon: [512, 512, [], "f8b5", "M80 96l0 336 352 0 0-336c0-8.8-7.2-16-16-16L96 80c-8.8 0-16 7.2-16 16zm400 0l0 336 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 480l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64zM112 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm176 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faHatCowboySide = {
  prefix: 'far',
  iconName: 'hat-cowboy-side',
  icon: [640, 512, [], "f8c1", "M444.8 256l-133.5 0-31.5-25.6c-25-20.3-55-33-86.6-37.1l4.9-63.4c.3-3.6 2.9-6.5 6.4-7.2L412.3 81.2 444.8 256zM560 400l-40 0c0-1.4-.1-2.9-.4-4.4l-26-139.6c10.2 5.4 21.6 12 32.8 19.8C563.6 301.2 592 332.9 592 368c0 17.7-14.3 32-32 32zM498 204.6c-5.9-2.8-11.1-5.1-15.3-6.9l-24.6-132C454.6 46.2 437.6 32 417.7 32c-2.7 0-5.4 .3-8.1 .8L195.1 75.7c-24.6 4.9-42.9 25.6-44.9 50.6L145 194C62.9 206.8 0 277.9 0 363.6l0 18.8C0 418.6 29.4 448 65.6 448L464 448l16 0 80 0c44.2 0 80-35.8 80-80c0-60.9-47.6-105.2-86.4-131.8c-20.3-13.9-40.5-24.5-55.5-31.6zM48 363.6C48 295.3 103.3 240 171.6 240c28.4 0 55.9 9.8 77.9 27.7L412.4 400 65.6 400c-9.7 0-17.6-7.9-17.6-17.6l0-18.8z"]
};
const faTableRows = {
  prefix: 'far',
  iconName: 'table-rows',
  icon: [512, 512, ["rows"], "e292", "M448 432l-320 0 0-152 336 0 0 136c0 8.8-7.2 16-16 16zm16-200l-336 0 0-152 320 0c8.8 0 16 7.2 16 16l0 136zM0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z"]
};
const faRows = faTableRows;
const faLocationExclamation = {
  prefix: 'far',
  iconName: 'location-exclamation',
  icon: [384, 512, ["map-marker-exclamation"], "f608", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 96c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faMapMarkerExclamation = faLocationExclamation;
const faFaceFearful = {
  prefix: 'far',
  iconName: 'face-fearful',
  icon: [512, 512, [], "e375", "M464 256c0-43.5-13.3-83.9-36.2-117.2l-.1 .2c-6 6.5-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c8 1.1 15.7 2.8 23.2 5.2C342.4 62.2 300.9 48 256 48s-86.4 14.2-120.4 38.4c7.5-2.4 15.2-4.2 23.2-5.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8l-.1-.2C61.3 172.1 48 212.5 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48A80 80 0 1 1 80 224a80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
};
const faClipboardUser = {
  prefix: 'far',
  iconName: 'clipboard-user',
  icon: [384, 512, [], "f7f3", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-16 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-16 0c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faBusSchool = {
  prefix: 'far',
  iconName: 'bus-school',
  icon: [512, 512, [], "f5dd", "M96 95l0 1 84.3 0c5.5-9.6 15.9-16 27.7-16l96 0c11.8 0 22.2 6.4 27.7 16L416 96l0-1c0-.4 0-.8-.1-1c0 0 0 0 0-.1C404.2 79.4 363.5 48 256 48C156.9 48 109.6 79.1 96 94.3c0 .2 0 .4 0 .7zm0 49l0 82.8c7.7-1.8 15.7-2.8 24-2.8l112 0 0-80L96 144zm320 82.8l0-82.8-136 0 0 80 112 0c8.3 0 16.3 1 24 2.8zM464 95l0 33 16 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-13 0c17.9 18.7 29 44.1 29 72l0 56c0 29.8-20.4 54.9-48 62l0 42c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-288 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-42c-27.6-7.1-48-32.2-48-62l0-56c0-27.9 11-53.3 29-72l-13 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l16 0 0-33c0-8.8 2-20.6 10.4-30.6C82.9 35.2 145.9 0 256 0C373.7 0 430.9 35.1 454.3 65c7.7 9.8 9.7 21.1 9.7 30zM112 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM120 272c-30.9 0-56 25.1-56 56l0 56c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-56c0-30.9-25.1-56-56-56l-272 0z"]
};
const faFilmSlash = {
  prefix: 'far',
  iconName: 'film-slash',
  icon: [640, 512, [], "e179", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L89.5 44.9C100.2 36.8 113.6 32 128 32l384 0c35.3 0 64 28.7 64 64l0 320c0 3.3-.2 6.5-.7 9.6l55.5 43.5c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM176 112.6L176 80l-41.6 0L176 112.6zM328.3 232l87.7 0 0-40 0-112L224 80l0 70.3L328.3 232zM528 388.5l0-44.5-56.8 0L528 388.5zM416 423.8L487.4 480 128 480c-35.3 0-64-28.7-64-64l0-269.6L152.3 216 112 216l0 80 64 0 0-61.3L233.5 280l-9.5 0 0 40 0 112 192 0 0-8.2zM176 344l-64 0 0 72c0 8.8 7.2 16 16 16l48 0 0-88zM464 80l0 88 64 0 0-72c0-8.8-7.2-16-16-16l-48 0zm64 136l-64 0 0 80 64 0 0-80z"]
};
const faSquareArrowDownRight = {
  prefix: 'far',
  iconName: 'square-arrow-down-right',
  icon: [448, 512, [], "e262", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM160 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l94.1 0L119 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l135 135L288 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160c0 13.3-10.7 24-24 24l-152 0z"]
};
const faBookSparkles = {
  prefix: 'far',
  iconName: 'book-sparkles',
  icon: [448, 512, ["book-spells"], "f6b8", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM160 112l8.8-17.7c2.9-5.9 11.4-5.9 14.3 0L192 112l17.7 8.8c5.9 2.9 5.9 11.4 0 14.3L192 144l-8.8 17.7c-2.9 5.9-11.4 5.9-14.3 0L160 144l-17.7-8.8c-5.9-2.9-5.9-11.4 0-14.3L160 112zM264 216l16.6-38.8c2.8-6.5 11.9-6.5 14.7 0L312 216l38.8 16.6c6.5 2.8 6.5 11.9 0 14.7L312 264l-16.6 38.8c-2.8 6.5-11.9 6.5-14.7 0L264 264l-38.8-16.6c-6.5-2.8-6.5-11.9 0-14.7L264 216z"]
};
const faBookSpells = faBookSparkles;
const faWashingMachine = {
  prefix: 'far',
  iconName: 'washing-machine',
  icon: [448, 512, ["washer"], "f898", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM314.6 319.7c-3.5 .2-7 .3-10.6 .3c-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1 .2-10.7 .4C146.4 218.9 182 192 224 192c53 0 96 43 96 96c0 11.1-1.9 21.8-5.4 31.7zM368 288A144 144 0 1 0 80 288a144 144 0 1 0 288 0z"]
};
const faWasher = faWashingMachine;
const faChild = {
  prefix: 'far',
  iconName: 'child',
  icon: [320, 512, [], "f1ae", "M160 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-96a72 72 0 1 1 0 144A72 72 0 1 1 160 0zM128 214l0 122 64 0 0-121.6c-10.2-4.2-21.2-6.4-32.4-6.4c-11 0-21.6 2.1-31.6 6zm0 170l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-230.1L43.7 309.8c-7.6 10.9-22.6 13.5-33.4 5.9S-3.3 293.1 4.3 282.2L50.1 217c25-35.7 65.9-57 109.5-57c43.2 0 83.7 20.8 108.8 56L315.5 282c7.7 10.8 5.2 25.8-5.6 33.5s-25.8 5.2-33.5-5.6L240 258.9 240 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-64 0z"]
};
const faLiraSign = {
  prefix: 'far',
  iconName: 'lira-sign',
  icon: [320, 512, [8356], "f195", "M96 159.2C96 115.5 131.5 80 175.2 80c8.5 0 17 1.4 25.1 4.1l80.1 26.7c12.6 4.2 26.2-2.6 30.4-15.2s-2.6-26.2-15.2-30.4L215.5 38.5c-13-4.3-26.6-6.5-40.2-6.5C105 32 48 89 48 159.2L48 192l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 4.5c0 18.8-5.1 37.3-14.8 53.5L3.4 443.7c-4.4 7.4-4.6 16.6-.3 24.2S15.4 480 24 480l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L66.4 432l8-13.3C88.5 395.1 96 368.1 96 340.5l0-4.5 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 288l0-48 136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 192l0-32.8z"]
};
const faUserVisor = {
  prefix: 'far',
  iconName: 'user-visor',
  icon: [448, 512, [], "e04c", "M224 208c26.2 0 49.4-12.6 64-32l-128 0c14.6 19.4 37.8 32 64 32zm0 48c-54 0-100.2-33.5-119-80.8c-14.3-3.2-25-16-25-31.2l0-64c0-17.7 14.3-32 32-32l12.1 0C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L336 48c17.7 0 32 14.3 32 32l0 64c0 15.3-10.7 28-25 31.2C324.2 222.5 278 256 224 256zM128 112c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L144 96c-8.8 0-16 7.2-16 16zM269.7 352l-91.4 0c-65.7 0-120.1 48.7-129 112l349.5 0c-8.9-63.3-63.3-112-129-112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM313.5 429c-7.9 0-18.8 9.5-26.5 16.3c-2.1 1.9-4 3.5-5.5 4.7c-2.3 1.7-5.7 0-5.4-2.9c3.2-30.5 13.2-55.5 29.8-74.7c1.3-1.5 4.1-1.6 5.1 .1c15.8 20.6 24.2 45.9 25.1 75.3c0 3.2-4.1 4.7-6.1 2.1c-10.2-14.4-14.7-19.2-16.6-20.9z"]
};
const faFilePlusMinus = {
  prefix: 'far',
  iconName: 'file-plus-minus',
  icon: [384, 512, [], "e177", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40zM128 384c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z"]
};
const faChessClockFlip = {
  prefix: 'far',
  iconName: 'chess-clock-flip',
  icon: [640, 512, ["chess-clock-alt"], "f43e", "M384 56c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 32 88 0c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 176c0-35.3 28.7-64 64-64l32 0 0-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16l0 16 184 0 0-32-32 0c-13.3 0-24-10.7-24-24zM64 160c-8.8 0-16 7.2-16 16l0 240c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-240c0-8.8-7.2-16-16-16L64 160zm376 32a104 104 0 1 1 0 208 104 104 0 1 1 0-208zm16 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM126.5 222.5A104 104 0 1 1 273.5 369.5 104 104 0 1 1 126.5 222.5zm124.5 22.6c-6.2-6.2-16.4-6.2-22.6 0L194.3 279c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faChessClockAlt = faChessClockFlip;
const faSatellite = {
  prefix: 'far',
  iconName: 'satellite',
  icon: [512, 512, [128752], "f7bf", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l58.1 58.1c-50.9-9.8-105.5 3.2-147.2 39.7c-3.8 3.3-5.9 8-5.9 13l0 .5c0 4.9 1.9 9.6 5.4 13L103 375 55 423c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48 97.6 97.6c3.5 3.5 8.1 5.4 13 5.4l.5 0c5 0 9.8-2.2 13-5.9c36.5-41.7 49.6-96.3 39.7-147.2L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68L463 177c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L417 49c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17L309 75 241 7zm34.6 289.5c-6.4-9.7-13.8-18.8-22.3-27.3l-10.6-10.6c-8.5-8.5-17.6-15.9-27.3-22.3L369 82.9c1.9-1.9 4.4-2.9 7-2.9s5.2 1 7 2.9L429.1 129c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L275.6 296.6zM275 109L197 187l-51-51L224 57.9l51 51zM376 366.1l-51-51L403 237l51 51L376 366.1zM219.4 303.2c38.8 38.8 47.1 97 23.8 144.1L64.7 268.8c47.1-23.2 105.3-14.9 144.1 23.8l10.6 10.6z"]
};
const faTruckFire = {
  prefix: 'far',
  iconName: 'truck-fire',
  icon: [640, 512, [], "e65a", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 50.7C13.4 105.3 0 123.1 0 144L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l16 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-48 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-96 0 0-48 232 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM336 48l0 48-56 0 0-48 56 0zm0 96l48 0 0 80L48 224l0-80 288 0zM48 368l0-96 352 0c17.7 0 32-14.3 32-32l0-96 160 0 0 224-28.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48l-153.7 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L48 368zM232 48l0 48-48 0 0-48 48 0zm-96 0l0 48L80 96l0-48 56 0zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8-192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"]
};
const faPlaneLock = {
  prefix: 'far',
  iconName: 'plane-lock',
  icon: [640, 512, [], "e558", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 95.3 61c-8.3 14.1-13.5 30.2-14.9 47.4L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6c9 2.7 17.5 5.3 24.3 7.3l0-23.9-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5l82.5 26.4c-11 11.5-17.8 27.1-17.8 44.3l0 .4-48-15.4 0 27.4 48 36 0 79.3c0 7.9 1.4 15.4 4 22.4c-6.8 6.4-15.9 10.3-26 10.3c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zM528 240c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faSteeringWheel = {
  prefix: 'far',
  iconName: 'steering-wheel',
  icon: [512, 512, [], "f622", "M232 369l0 93.6C133.7 451.3 56.2 371.4 48.6 272l107.8 0 74.3 95.5c.4 .5 .8 1 1.3 1.5zm48 0c.4-.5 .9-1 1.3-1.5L355.6 272l107.8 0c-7.6 99.4-85 179.3-183.4 190.6l0-93.6zm72-145l-7.2-14.3c-5.4-10.8-16.5-17.7-28.6-17.7l-120.4 0c-12.1 0-23.2 6.8-28.6 17.7L160 224 50.4 224C65.8 124.3 152 48 256 48s190.2 76.3 205.6 176L352 224zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faTag = {
  prefix: 'far',
  iconName: 'tag',
  icon: [448, 512, [127991], "f02b", "M197.5 32c17 0 33.3 6.7 45.3 18.7l176 176c25 25 25 65.5 0 90.5L285.3 450.7c-25 25-65.5 25-90.5 0l-176-176C6.7 262.7 0 246.5 0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0zM48 229.5c0 4.2 1.7 8.3 4.7 11.3l176 176c6.2 6.2 16.4 6.2 22.6 0L384.8 283.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-3-3-7.1-4.7-11.3-4.7L48 80l0 149.5zM112 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faStretcher = {
  prefix: 'far',
  iconName: 'stretcher',
  icon: [640, 512, [], "f825", "M41.4 71.5c-9.1-9.6-24.3-10-33.9-.9s-10 24.3-.9 33.9L139.7 244.6c16.6 17.5 39.7 27.4 63.8 27.4L616 272c13.3 0 24-10.7 24-24s-10.7-24-24-24l-412.5 0c-11 0-21.4-4.5-29-12.4L41.4 71.5zM241.2 304l86 62.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 86-62.5-81.6 0L368 336.9 322.8 304l-81.6 0zM240 448a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faBookSection = {
  prefix: 'far',
  iconName: 'book-section',
  icon: [448, 512, ["book-law"], "e0c1", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM224.7 246.1c-20.7-5.5-63.7-17-55.7-58.8c2-10.5 7.5-19.2 15.6-25.8c-11.5-8.8-19.4-21.7-15.6-41.7c5.7-29.8 37.9-45 82-38.7c7.8 1.1 16.8 3.3 28.3 6.9c7.9 2.5 12.3 10.9 9.9 18.8c-2.5 7.9-11 12.3-18.8 9.9c-9.9-3.1-17.5-4.9-23.6-5.8c-26.1-3.8-46 2.3-48.4 14.7c-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c0 0 0 0 0 0c28.2 7.3 70.9 18.3 62.8 60.6c-2 10.5-7.5 19.2-15.6 25.9c11.8 8.9 19.4 21.7 15.6 41.6c-4.8 25.3-28.9 40.2-63.1 40.2c-6 0-12.3-.5-18.9-1.4c-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8c2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3c26.3 3.7 46.1-2.3 48.4-14.7c2.3-11.9-5.4-16.8-40.9-26l-7-1.8zM222 177.9c-8.1 1.1-21.6 4.5-23.6 15.1c-1.7 8.7-.2 15.1 34 24.1c0 0 13.2 3.5 16.6 4.4c8.2-1.1 21.6-4.5 23.6-15c2.3-11.9-5.4-16.8-40.9-26c0 0-8.8-2.3-9.7-2.6z"]
};
const faBookLaw = faBookSection;
const faInboxes = {
  prefix: 'far',
  iconName: 'inboxes',
  icon: [512, 512, [], "e1bb", "M62.5 96l67.9 0c18.2 0 34.8 10.3 42.9 26.5L192 160l128 0 18.7-37.5c8.1-16.3 24.8-26.5 42.9-26.5l67.8 0-40-48-307 0-40 48zM48 144l0 96 416 0 0-96-82.3 0-18.7 37.5C354.8 197.7 338.2 208 320 208l-128 0c-18.2 0-34.8-10.3-42.9-26.5L130.3 144 48 144zM0 144l0-30.6c0-11.2 3.9-22.1 11.1-30.7L65.6 17.3C74.7 6.3 88.2 0 102.5 0l307 0c14.2 0 27.8 6.3 36.9 17.3l54.5 65.4c7.2 8.6 11.1 19.5 11.1 30.7l0 30.6 0 96c0 26.5-21.5 48-48 48L48 288c-26.5 0-48-21.5-48-48l0-96zM310.1 432l-108.2 0c-24.2 0-46.4-13.7-57.2-35.4L130.3 368 48 368l0 96 416 0 0-96-82.3 0-14.3 28.6-42.6-21.3 42.6 21.3c-10.8 21.7-33 35.4-57.2 35.4zM48 320l82.3 0c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8l108.2 0c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5l82.3 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48z"]
};
const faCoffeeBean = {
  prefix: 'far',
  iconName: 'coffee-bean',
  icon: [448, 512, [], "e13e", "M385.9 133.1c-13.3 27.7-29.9 56.7-48.9 75.8c-34.5 34.8-69.6 52.3-101.5 68.2l-.8 .4c-32.1 16-61 30.6-89.7 59.4c-16.6 16.7-34.4 47-49.8 77.5c23.2 14.8 54.2 20.9 90.3 15.8c45.5-6.5 96.1-30.9 138.9-73.8s67.3-93.4 73.8-138.9c4.7-33.2-.1-61.9-12.3-84.4zM350.1 95.9c-22.9-13.6-52.9-19.1-87.7-14.2c-45.5 6.5-96.1 30.9-138.9 73.8S56.3 249 49.8 294.5c-4.6 32-.3 59.9 11.1 82.1c14.5-27.1 31.8-55 50.1-73.4c34.5-34.8 69.6-52.3 101.5-68.2l.8-.4c32.1-16 61-30.6 89.7-59.4c16.6-16.8 33.4-47.8 47.2-79.1zm53-19.1c74.2 74.2 54.2 214.6-44.8 313.6s-239.4 119-313.6 44.8S-9.4 220.6 89.6 121.6s239.4-119 313.6-44.8z"]
};
const faCircleYen = {
  prefix: 'far',
  iconName: 'circle-yen',
  icon: [512, 512, [], "e5d0", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM159.9 150.2c9.8-8.9 25-8.2 33.9 1.6L256 220.3l62.2-68.5c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9L288.4 256l31.6 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 32 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0 0 25c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l40 0 0-32-40 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l31.6 0-65.3-71.9c-8.9-9.8-8.2-25 1.6-33.9z"]
};
const faBracketsCurly = {
  prefix: 'far',
  iconName: 'brackets-curly',
  icon: [576, 512, [], "f7ea", "M152 32c-48.6 0-88 39.4-88 88l0 45.5c0 10.6-4.2 20.8-11.7 28.3L7 239c-9.4 9.4-9.4 24.6 0 33.9l45.3 45.3c7.5 7.5 11.7 17.7 11.7 28.3L64 392c0 48.6 39.4 88 88 88l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-22.1 0-40-17.9-40-40l0-45.5c0-23.3-9.3-45.7-25.8-62.2L57.9 256l28.3-28.3c16.5-16.5 25.8-38.9 25.8-62.2l0-45.5c0-22.1 17.9-40 40-40l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm272 0l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c22.1 0 40 17.9 40 40l0 45.5c0 23.3 9.3 45.7 25.8 62.2L518.1 256l-28.3 28.3c-16.5 16.5-25.8 38.9-25.8 62.2l0 45.5c0 22.1-17.9 40-40 40l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c48.6 0 88-39.4 88-88l0-45.5c0-10.6 4.2-20.8 11.7-28.3L569 273c9.4-9.4 9.4-24.6 0-33.9l-45.3-45.3c-7.5-7.5-11.7-17.7-11.7-28.3l0-45.5c0-48.6-39.4-88-88-88z"]
};
const faEllipsisStrokeVertical = {
  prefix: 'far',
  iconName: 'ellipsis-stroke-vertical',
  icon: [192, 512, ["ellipsis-v-alt"], "f39c", "M96 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 88A64 64 0 1 1 96 32a64 64 0 1 1 0 128zm24 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 256zm88 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 32 416z"]
};
const faEllipsisVAlt = faEllipsisStrokeVertical;
const faComment = {
  prefix: 'far',
  iconName: 'comment',
  icon: [512, 512, [128489, 61669], "f075", "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9l.3-.5z"]
};
const faSquare1 = {
  prefix: 'far',
  iconName: 'square-1',
  icon: [448, 512, [], "e256", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm172 99.2c-7.4-4.3-16.5-4.3-24-.1l-56 32c-11.5 6.6-15.5 21.2-8.9 32.7s21.2 15.5 32.7 8.9L200 193.4 200 336l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-184c0-8.6-4.6-16.5-12-20.8z"]
};
const faCakeCandles = {
  prefix: 'far',
  iconName: 'cake-candles',
  icon: [448, 512, [127874, "birthday-cake", "cake"], "f1fd", "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2L56 72c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM120 168c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-8 0c-35.3 0-64 28.7-64 64L0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-192c0-35.3-28.7-64-64-64l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-80 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-80 0 0-56zM64 272l320 0c8.8 0 16 7.2 16 16l0 60.8c-5.5-2.1-10.9-5.1-15.8-8.5c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C310.2 347 299 352 288 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7c-6.7-6.3-13.5-12.6-23.2-12.6c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5C182.2 347 171 352 160 352s-22.2-5-31.8-11.7c-3.2-2.2-6.1-5-9.1-7.7C112.4 326.3 105.7 320 96 320c-9.4 0-16.5 6.5-23.4 12.8c-2.9 2.7-5.8 5.4-8.9 7.5c-4.9 3.4-10.3 6.4-15.8 8.5L48 288c0-8.8 7.2-16 16-16zM400 398.5l0 65.5L48 464l0-65.5c17.5-3.3 33.9-11.6 48-22.3c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c18.4 14 40.6 23.8 64 23.8s45.6-9.8 64-23.8c14.1 10.7 30.5 19 48 22.3z"]
};
const faBirthdayCake = faCakeCandles;
const faCake = faCakeCandles;
const faHeadSide = {
  prefix: 'far',
  iconName: 'head-side',
  icon: [512, 512, [], "f6e9", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faTruckLadder = {
  prefix: 'far',
  iconName: 'truck-ladder',
  icon: [640, 512, [], "e657", "M0 24C0 37.3 10.7 48 24 48l8 0 0 96-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24zM272 144l-32 0 0-96 32 0 0 96zM160 48l32 0 0 96-32 0 0-96zm-48 96l-32 0 0-96 32 0 0 96zM408 96c-13.3 0-24 10.7-24 24l0 104L56 224c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l8 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l8 0c30.9 0 56-25.1 56-56l0-108.8c0-12.7-4.3-25.1-12.3-35L548.3 117c-10.6-13.3-26.7-21-43.7-21L408 96zM76.8 368L56 368c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l328 0 48 0 160 0 0 88c0 4.4-3.6 8-8 8l-20.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48l-153.7 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48zM432 224l0-80 72.6 0c2.4 0 4.7 1.1 6.2 3l61.6 77L432 224zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faEnvelope = {
  prefix: 'far',
  iconName: 'envelope',
  icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"]
};
const faDollyEmpty = {
  prefix: 'far',
  iconName: 'dolly-empty',
  icon: [576, 512, [], "f473", "M0 24C0 10.7 10.7 0 24 0l80.8 0C129 0 150.5 15.6 158 38.6L250 320.2c2-.1 4-.2 6-.2c33.2 0 62.5 16.9 79.8 42.5L544 289.4c12.5-4.4 26.2 2.2 30.6 14.7s-2.2 26.2-14.7 30.6L351.7 407.8c.2 2.7 .3 5.4 .3 8.2c0 53-43 96-96 96s-96-43-96-96c0-34 17.7-63.9 44.3-80.9L112.4 53.5c-1.1-3.3-4.1-5.5-7.6-5.5L24 48C10.7 48 0 37.3 0 24zM304 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faFaceTissue = {
  prefix: 'far',
  iconName: 'face-tissue',
  icon: [512, 512, [], "e39c", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 8.7 .5 17.3 1.6 25.7L8.1 288.7c-2 .3-4 .8-5.9 1.4C.8 278.9 0 267.5 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-11.5 0-22.9-.8-34-2.2c.6-1.9 1-3.9 1.4-5.9l6.9-41.5c8.4 1 17 1.6 25.7 1.6zm-13.3-76l9-54.1 4.3 3.4 25-20c8.2-6.5 19.6-7 28.3-1.2l31.6 21.1L351 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-24 24c-8.1 8.1-20.8 9.3-30.3 3l-33.4-22.3-26.3 21c-8.2 6.6-19.7 7-28.3 1.2zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zm-159.2 162c3.7 3.7 5.3 8.8 4.5 13.9l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5L51.9 479.5c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3 .8 13.9 4.5z"]
};
const faAnglesUp = {
  prefix: 'far',
  iconName: 'angles-up',
  icon: [448, 512, ["angle-double-up"], "f102", "M241 47c-9.4-9.4-24.6-9.4-33.9 0L47 207c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 241c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 47zM401 399L241 239c-9.4-9.4-24.6-9.4-33.9 0L47 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l143-143L367 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"]
};
const faAngleDoubleUp = faAnglesUp;
const faBinRecycle = {
  prefix: 'far',
  iconName: 'bin-recycle',
  icon: [576, 512, [], "e5f7", "M0 56C0 42.7 10.7 32 24 32l8 0 48.1 0 415.8 0L544 32l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.4 0L516.2 420.6C513.9 454.1 486 480 452.4 480l-328.8 0c-33.6 0-61.4-25.9-63.8-59.4L35.4 80 24 80C10.7 80 0 69.3 0 56zM83.6 80l24.1 337.1c.6 8.4 7.6 14.9 16 14.9l328.8 0c8.4 0 15.4-6.5 16-14.9L492.4 80 83.6 80zM288 176c-2.2 0-4.3 1.1-5.5 2.9l-20.7 29.6c-7.3 10.5-21.6 13.4-32.4 6.6c-11.7-7.3-14.8-22.9-6.9-34.1l20.7-29.6c10.2-14.6 27-23.3 44.8-23.3s34.6 8.7 44.8 23.3l20.7 29.6c7.9 11.3 4.7 26.8-6.9 34.1c-10.8 6.8-25.1 3.9-32.4-6.6l-20.7-29.6c-1.3-1.8-3.3-2.9-5.5-2.9zm-88.3 77.1c11.7 7.3 14.8 22.9 6.9 34.1l-21.5 30.7c-.8 1.1-1.2 2.4-1.2 3.7c0 3.5 2.9 6.4 6.4 6.4l49.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-49.6 0c-30.1 0-54.4-24.4-54.4-54.4c0-11.2 3.4-22.1 9.8-31.2l21.5-30.7c7.3-10.5 21.6-13.4 32.4-6.6zM312 352c0-13.3 10.7-24 24-24l49.6 0c3.5 0 6.4-2.9 6.4-6.4c0-1.3-.4-2.6-1.2-3.7l-21.5-30.7c-7.9-11.3-4.7-26.8 6.9-34.1c10.8-6.8 25.1-3.9 32.4 6.6l21.5 30.7c6.4 9.1 9.8 20 9.8 31.2c0 30.1-24.4 54.4-54.4 54.4L336 376c-13.3 0-24-10.7-24-24z"]
};
const faPaperclip = {
  prefix: 'far',
  iconName: 'paperclip',
  icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.3-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
};
const faChartLineDown = {
  prefix: 'far',
  iconName: 'chart-line-down',
  icon: [512, 512, [128201], "f64d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM320 296c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L321 127c-9.4-9.4-24.6-9.4-33.9 0l-79 79-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0l79-79L398.1 272 344 272c-13.3 0-24 10.7-24 24z"]
};
const faArrowRightToCity = {
  prefix: 'far',
  iconName: 'arrow-right-to-city',
  icon: [640, 512, [], "e4b3", "M336 56c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 160c0 13.3 10.7 24 24 24l80 0 16 0c4.4 0 8 3.6 8 8l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-28.2-20.9-51.6-48-55.4l0-72.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-32 0 0-136c0-30.9-25.1-56-56-56L344 0c-30.9 0-56 25.1-56 56l0 432c0 13.3 10.7 24 24 24s24-10.7 24-24l0-432zm32 40l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM368 288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM496 384l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160.1 158.2c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9L169.9 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l145.9 0-42.1 38.2c-9.8 8.9-10.5 24.1-1.6 33.9s24.1 10.5 33.9 1.6l88-80c5-4.5 7.9-11 7.9-17.8s-2.9-13.2-7.9-17.8l-88-80z"]
};
const faLockA = {
  prefix: 'far',
  iconName: 'lock-a',
  icon: [448, 512, [], "e422", "M224 48c44.2 0 80 35.8 80 80l0 32-160 0 0-32c0-44.2 35.8-80 80-80zM96 128l0 32-32 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-32 0 0-32C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208l32 0 48 0 160 0 48 0 32 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm58.5 197.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L178.8 400l90.3 0 13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2L245.6 245.5c-1.2-2.4-2.7-4.6-4.6-6.5c-2.2-2.2-4.7-3.9-7.4-5c-3.1-1.3-6.3-2-9.5-2s-6.4 .6-9.5 2c-2.7 1.2-5.3 2.9-7.4 5c-1.9 1.9-3.4 4.1-4.6 6.5L122.5 405.3zM202.8 352L224 309.7 245.2 352l-42.3 0z"]
};
const faRibbon = {
  prefix: 'far',
  iconName: 'ribbon',
  icon: [448, 512, [127895], "f4d6", "M6.5 415.6l96.6-103.4L136 347.4 60.5 428.2l40.3 28.2 68.5-73.3 32.8 35.1-80.5 86.2c-8.2 8.7-21.5 10.1-31.3 3.3l-80-56c-5.7-4-9.4-10.2-10.1-17.2s1.6-13.8 6.3-18.9zM245.9 159.4l7-7.5c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.1-42.5l-9.3-12.5c-7.3-.4-15.5-.6-24.4-.6l0-48c14.8 0 27.9 .6 39 1.5c9.1 .7 17 1.7 23.5 2.6c21.2 3.1 38.2 15.4 49.5 30.6l40.2 53.6c15.4 20.6 23.7 45.6 23.7 71.3c0 30.1-11.4 59.1-32 81.2l-23 24.6-32.8-35.2L332.9 208c12.3-13.1 19.1-30.4 19.1-48.4c0-15.3-5-30.2-14.2-42.5L319.5 92.6c.3 3.6 .5 7.3 .5 11c0 30.1-11.4 59.1-32 81.2l-9.2 9.8-32.8-35.2zM224 48c-8.9 0-17.1 .2-24.4 .6l-9.3 12.5c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L441.5 415.6c4.7 5.1 7.1 12 6.3 18.9s-4.4 13.2-10.1 17.2l-80 56c-9.8 6.9-23.1 5.5-31.3-3.3L80.1 240.7c-20.6-22-32-51-32-81.2c0-25.7 8.3-50.7 23.7-71.3L112 34.7c11.4-15.2 28.4-27.5 49.5-30.6c6.6-1 14.4-1.9 23.5-2.6C196.1 .6 209.2 0 224 0l0 48zM110.2 117.1c-9.2 12.3-14.1 27.2-14.1 42.5c0 18 6.8 35.3 19.1 48.4L347.3 456.4l40.3-28.2L160.1 184.7c-20.6-22-32-51-32-81.2c0-3.7 .2-7.4 .5-11l-18.4 24.5z"]
};
const faLungs = {
  prefix: 'far',
  iconName: 'lungs',
  icon: [640, 512, [129729], "f604", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 142.8c0 18.1-8.7 35.1-23.5 45.6L256 224.2l0-39.5 0-8.7 0-10.7C256 127 225 96 186.7 96c-21.7 0-42.8 10.2-55.8 28.8c-15.4 22.1-44.3 65.4-71 116.9C33.4 292.6 7.5 354.2 .2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l72.7-18.2C226 480.5 256 442.1 256 398l0-75.5-48 34.3 0 41.2c0 22-15 41.2-36.4 46.6L98.9 462.8c-3.3 .8-6.6 1.2-9.9 1.2c-22.6 0-41-18.3-41-41l0-6c6.3-49.1 29-104.2 54.4-153.1c25.5-49 53.1-90.5 67.8-111.6c3.6-5.1 9.6-8.3 16.4-8.3c11.8 0 21.3 9.6 21.3 21.3l0 10.7 0 43.2 0 39.3-69.9 50c-10.8 7.7-13.3 22.7-5.6 33.5s22.7 13.3 33.5 5.6l42.1-30 48-34.3 44.4-31.7c7.4-5.3 13.9-11.4 19.6-18.2c5.6 6.8 12.2 12.9 19.6 18.2L384 283.2l48 34.3 42.1 30c10.8 7.7 25.8 5.2 33.5-5.6s5.2-25.8-5.6-33.5l-69.9-50 0-39.3 0-43.2 0-10.7c0-11.8 9.6-21.3 21.3-21.3c6.8 0 12.8 3.2 16.4 8.3c14.7 21.1 42.3 62.6 67.8 111.6C563 312.8 585.7 367.9 592 417l0 6c0 22.6-18.3 41-41 41c-3.4 0-6.7-.4-9.9-1.2l-72.7-18.2C447 439.3 432 420.1 432 398l0-41.2-48-34.3 0 75.5c0 44.1 30 82.5 72.7 93.1l72.7 18.2c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-7.2-57.9-33.1-119.4-59.6-170.3c-26.8-51.5-55.6-94.8-71-116.9c-13-18.6-34-28.8-55.8-28.8C415 96 384 127 384 165.3l0 10.7 0 8.7 0 39.5-16.6-11.8c-14.7-10.5-23.4-27.5-23.4-45.6L344 24z"]
};
const faPersonPinball = {
  prefix: 'far',
  iconName: 'person-pinball',
  icon: [640, 512, [], "e21d", "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM48 186.2c0-5.6 4.6-10.2 10.2-10.2c4.9 0 9.7 1.3 13.8 3.7l0 120.1L50.6 279.9c-1.6-1.5-2.6-3.6-2.6-5.9l0-87.8zm72 158.2l0-88 6.5 11.5c7.1 12.5 20.4 20.2 34.7 20.2l30.7 0 0 88 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 352 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112 0-168 0-184c0-13.3-10.7-24-24-24L504 0c-13.3 0-24 10.7-24 24l0 42c0 6.9 1.3 13.8 3.8 20.3l44 113.2L251 249.3c-4.4-5.7-11.3-9.3-19-9.3l-66.1 0-42.3-74c-13.4-23.5-38.4-38-65.4-38C26.1 128 0 154.1 0 186.2L0 274c0 15.6 6.5 30.4 17.9 41L112 402.5l0 85.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89c0-11.1-4.6-21.7-12.8-29.3L120 344.4zM592 352l-352 0 0-51.9 32.1-5.8c0 .6-.1 1.1-.1 1.7c0 13.3 10.7 24 24 24s24-10.7 24-24c0-3.5-.8-6.9-2.2-9.9L592 236.7 592 352zM48 386.7L0 342.1 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-101.3zM528 66l0-18 64 0 0 139.2-16.5 2.4L528.5 68.9c-.4-.9-.5-1.9-.5-2.9z"]
};
const faArrowUp91 = {
  prefix: 'far',
  iconName: 'arrow-up-9-1',
  icon: [576, 512, ["sort-numeric-up-alt"], "f887", "M424 80a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm88 40c0 .8 0 1.6 0 2.5c-.6 20.2-7.9 39.7-20.9 55.3l-64.6 77.6c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L405.1 206c-39.5-8.6-69.1-43.8-69.1-86c0-48.6 39.4-88 88-88s88 39.4 88 88zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM456 312l0 120 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-86.7-16.4 5.5c-12.6 4.2-26.2-2.6-30.4-15.2s2.6-26.2 15.2-30.4l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
const faSortNumericUpAlt = faArrowUp91;
const faAppleCore = {
  prefix: 'far',
  iconName: 'apple-core',
  icon: [384, 512, [], "e08f", "M192 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM128 464c4.6 0 13.6-1.7 24.9-5.1c25.4-7.6 52.7-7.6 78.1 0c11.3 3.4 20.3 5.1 24.9 5.1c11.4 0 24.9-3.9 38.9-13.1C260.7 411.6 240 360.2 240 304c0-46 13.9-88.8 37.7-124.4c-12.7 3-26.4 7.5-39 12.4c-30 11.7-63.5 11.7-93.5 0c-12.6-4.9-26.2-9.4-39-12.4C130.1 215.2 144 258 144 304c0 56.2-20.7 107.6-54.9 146.9c14 9.2 27.4 13.1 38.9 13.1zM304 128c6.7 0 13 .6 19.1 1.9c0 0 0 0 0 0l.5 .1c11.3 2.3 21.5 6.7 30.6 12.7c8.6 5.6 7.3 17.9-.7 24.3c-40 32.3-65.5 81.7-65.5 137c0 54.4 24.7 103 63.4 135.3c7 5.9 8.8 16.3 2.7 23.1C325.8 493.7 290.9 512 256 512c-11.9 0-26.5-3.4-38.8-7.1c-16.4-4.9-34.1-4.9-50.5 0c-12.2 3.7-26.8 7.1-38.8 7.1c-34.9 0-69.8-18.3-98.1-49.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137c-8-6.5-9.3-18.7-.7-24.3c9.2-6 19.4-10.3 30.6-12.7l.5-.1s0 0 0 0C67 128.6 73.3 128 80 128c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3z"]
};
const faCircleY = {
  prefix: 'far',
  iconName: 'circle-y',
  icon: [512, 512, [], "e12f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM170.1 152.3c-8.7-10-23.8-11.1-33.9-2.4s-11.1 23.8-2.4 33.9L232 297l0 79c0 13.3 10.7 24 24 24s24-10.7 24-24l0-79 98.1-113.2c8.7-10 7.6-25.2-2.4-33.9s-25.2-7.6-33.9 2.4L256 251.4l-85.9-99.1z"]
};
const faH6 = {
  prefix: 'far',
  iconName: 'h6',
  icon: [640, 512, [], "e413", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM519 69.3c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296l.2 0c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L522.7 103c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faLitecoinSign = {
  prefix: 'far',
  iconName: 'litecoin-sign',
  icon: [384, 512, [], "e1d3", "M112 56c0-13.3-10.7-24-24-24S64 42.7 64 56l0 164.5L17.8 232.8C5 236.2-2.6 249.4 .8 262.2s16.6 20.4 29.4 17l33.8-9L64 456c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-248 0 0-174.6 158.2-42.2c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17L112 207.7 112 56z"]
};
const faBottleBaby = {
  prefix: 'far',
  iconName: 'bottle-baby',
  icon: [512, 512, [], "e673", "M220.6 49.7L224 48l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 3.4 1.7C308.9 58.5 320 76.4 320 96c17.7 0 32 14.3 32 32l0 16 21.8 21.8c27 27 42.2 63.6 42.2 101.8L416 448c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-180.4c0-38.2 15.2-74.8 42.2-101.8L160 144l0-16c0-17.7 14.3-32 32-32c0-19.6 11.1-37.5 28.6-46.3zM368 448l0-180.4c0-25.5-10.1-49.9-28.1-67.9l-7.8-7.8-152.2 0-7.8 7.8c-18 18-28.1 42.4-28.1 67.9l0 4.4 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 48 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 32c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16z"]
};
const faCircleSmall = {
  prefix: 'far',
  iconName: 'circle-small',
  icon: [320, 512, [], "e122", "M272 256A112 112 0 1 0 48 256a112 112 0 1 0 224 0zM0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z"]
};
const faBorderNone = {
  prefix: 'far',
  iconName: 'border-none',
  icon: [448, 512, [], "f850", "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faArrowTurnDownLeft = {
  prefix: 'far',
  iconName: 'arrow-turn-down-left',
  icon: [512, 512, [], "e2e1", "M464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168c0 48.6-39.4 88-88 88L81.9 312l87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-9.4-9.4-9.4-24.6 0-33.9L135 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87L424 264c22.1 0 40-17.9 40-40l0-168z"]
};
const faCircleWifiCircleWifi = {
  prefix: 'far',
  iconName: 'circle-wifi-circle-wifi',
  icon: [640, 512, ["circle-wifi-group"], "e67e", "M256 48c94.3 0 173.9 62.7 199.4 148.7c13-3.1 26.6-4.7 40.6-4.7c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c39.5 0 77-9 110.4-25c-11-12-20.4-25.5-27.7-40.1c-25.3 11-53.3 17.1-82.6 17.1C141.1 464 48 370.9 48 256S141.1 48 256 48zM416.6 205.6C374.1 167.3 317.7 144 256 144s-118.1 23.3-160.6 61.6c-9.8 8.9-10.6 24-1.8 33.9s24 10.6 33.9 1.8c34-30.7 79-49.3 128.5-49.3c46.8 0 89.7 16.7 123 44.5c12.2-10.9 26-20.1 40.9-27.3c-1-1.3-2-2.5-3.3-3.6zM256 240c-35.1 0-67.1 13.3-91.2 35.1c-9.8 8.9-10.6 24.1-1.7 33.9s24.1 10.6 33.9 1.7c15.6-14.1 36.3-22.7 59-22.7s43.4 8.6 59 22.7c3.7 3.3 8.1 5.3 12.6 5.9c4.5-14.9 11-29 19.1-42C322.7 253.1 290.9 240 256 240zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm384-32a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320c-27.2 0-51.9 10.2-70.6 27.1c-6.6 5.9-16.7 5.4-22.6-1.2s-5.4-16.7 1.2-22.6c24.4-21.9 56.6-35.3 92-35.3s67.7 13.4 92 35.3c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2C547.9 330.2 523.2 320 496 320zM476 432a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zm-11.5-35.9c-6.6 5.9-16.7 5.4-22.6-1.1s-5.4-16.7 1.1-22.6c14-12.7 32.6-20.4 53-20.4s39 7.7 53 20.4c6.6 5.9 7.1 16 1.1 22.6s-16 7.1-22.6 1.1c-8.3-7.5-19.4-12.1-31.5-12.1s-23.2 4.6-31.5 12.1z"]
};
const faCircleWifiGroup = faCircleWifiCircleWifi;
const faCircleNodes = {
  prefix: 'far',
  iconName: 'circle-nodes',
  icon: [512, 512, [], "e4e2", "M368 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-29.9 50.6c6.8 8.3 15.2 15.2 24.7 20.2L326 352.6c-11.5 1.4-22.2 5.3-31.7 11.1L153.3 240.2c4.3-9.9 6.7-20.7 6.7-32.2c0-2-.1-4.1-.2-6.1l178.3-71.3zM410 159.4c39.5-4.9 70-38.6 70-79.4c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 2 .1 4.1 .2 6.1L141.9 157.4C127.3 139.4 105 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.5-4.3 41.6-11.7L262.7 399.8c-4.3 9.9-6.7 20.7-6.7 32.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-30.7-17.3-57.4-42.7-70.8L410 159.4zM304 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faParachuteBox = {
  prefix: 'far',
  iconName: 'parachute-box',
  icon: [512, 512, [], "f4cd", "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16L232 192l0 128-24 0c-3.3 0-6.5 .3-9.6 1L96.3 188.9c-.2-4.3-.3-8.6-.3-12.9c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192L38 192 162.4 353c-1.6 4.7-2.4 9.8-2.4 15l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-5.3-.8-10.3-2.4-15L474 192l19.1 0c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 4.3-.1 8.6-.3 12.9L313.6 321c-3.1-.6-6.3-1-9.6-1l-24 0 0-128 103.5 0zM208 368l96 0 0 96-96 0 0-96z"]
};
const faReflectHorizontal = {
  prefix: 'far',
  iconName: 'reflect-horizontal',
  icon: [512, 512, [], "e664", "M256 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM48 166.6l0 178.7L137.4 256 48 166.6zM0 128c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S0 396.9 0 384L0 128zM374.6 256L464 345.4l0-178.7L374.6 256zM492.2 98.4c12 5 19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9z"]
};
const faMessageMedical = {
  prefix: 'far',
  iconName: 'message-medical',
  icon: [512, 512, ["comment-alt-medical"], "f7f4", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM224 128l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faCommentAltMedical = faMessageMedical;
const faRugbyBall = {
  prefix: 'far',
  iconName: 'rugby-ball',
  icon: [512, 512, [], "e3c6", "M336 16l32 0c70.7 0 128 57.3 128 128l0 32c0 176.7-143.3 320-320 320l-32 0C73.3 496 16 438.7 16 368l0-32C16 159.3 159.3 16 336 16zM308.5 65.4C252.1 71 200.9 93.9 160 128.6c-11.5 9.8-22.2 20.5-32 32.1c-34.8 41.3-57.6 93.1-62.8 150C88.5 266 125.5 216.6 172 170c45.1-45.1 92.9-81.2 136.4-104.6zm-108 381.5c57.2-5.1 109.3-27.9 150.8-62.9c11.6-9.8 22.3-20.5 32.1-32c34.9-41.1 57.8-92.6 63.3-149.3c-23.4 43.7-59.7 91.7-105 137c-46.8 46.8-96.4 83.9-141.3 107.2zM90.4 421.4c2.7 2.7 8.8 5.9 22.3 5c13.4-.9 31.2-5.8 52.5-15.6c42.3-19.4 93.5-55.8 142.7-105s85.6-100.4 105-142.7c9.8-21.2 14.7-39 15.6-52.5c.9-13.5-2.3-19.6-5-22.3s-8.8-5.9-22.3-5c-13.4 .9-31.2 5.8-52.5 15.6c-42.3 19.5-93.5 55.8-142.7 105s-85.6 100.4-105 142.7c-9.8 21.2-14.7 39-15.6 52.5c-.9 13.5 2.3 19.6 5 22.3z"]
};
const faCommentMusic = {
  prefix: 'far',
  iconName: 'comment-music',
  icon: [512, 512, [], "f8b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM352 128c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faIndent = {
  prefix: 'far',
  iconName: 'indent',
  icon: [448, 512, [], "f03c", "M0 64C0 77.3 10.7 88 24 88l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40C10.7 40 0 50.7 0 64zM192 192c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0zM0 448c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424c-13.3 0-24 10.7-24 24zM121 268.4c7.8-6.4 7.8-18.3 0-24.7L26.2 165.6C15.7 157 0 164.4 0 177.9L0 334.1c0 13.5 15.7 20.9 26.2 12.4L121 268.4z"]
};
const faTreeDeciduous = {
  prefix: 'far',
  iconName: 'tree-deciduous',
  icon: [512, 512, [127795, "tree-alt"], "f400", "M185.9 103.6c-1.4 6.2-5.3 11.6-10.7 15s-12 4.4-18.2 3c-4.1-1-8.5-1.5-13-1.5c-30.9 0-56 25.1-56 56c0 6.4 1.1 12.5 3 18.2c3.8 11.1-1 23.4-11.3 28.9C60.8 233.2 48 253.2 48 276c0 33.1 26.9 60 60 60l124 0 0-16 0-64 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 0 64 0 16 124 0c33.1 0 60-26.9 60-60c0-22.8-12.8-42.8-31.7-52.9c-10.4-5.6-15.2-17.8-11.3-28.9c1.9-5.7 3-11.8 3-18.2c0-30.9-25.1-56-56-56c-4.5 0-8.8 .5-13 1.5c-6.2 1.5-12.7 .4-18.2-3s-9.3-8.7-10.7-15C318.7 71.7 290.1 48 256 48s-62.7 23.7-70.1 55.6zM232 384l-124 0C48.4 384 0 335.6 0 276c0-34.4 16.1-65 41.1-84.8c-.7-5-1.1-10.1-1.1-15.2C40 118.6 86.6 72 144 72c.7 0 1.3 0 2 0C164.5 29.6 206.8 0 256 0s91.5 29.6 110 72c.7 0 1.3 0 2 0c57.4 0 104 46.6 104 104c0 5.2-.4 10.2-1.1 15.2C495.9 211 512 241.6 512 276c0 59.6-48.4 108-108 108l-124 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104z"]
};
const faTreeAlt = faTreeDeciduous;
const faPuzzlePieceSimple = {
  prefix: 'far',
  iconName: 'puzzle-piece-simple',
  icon: [640, 512, ["puzzle-piece-alt"], "e231", "M168 112c-4.4 0-8 3.6-8 8l0 79.1c0 22.6-18.3 40.9-40.9 40.9c-15 0-26.5-8.1-33.5-16.3c-4.9-5.9-9.8-7.7-13.6-7.7c-4 0-9.5 2.1-14.7 9.1S48 243 48 256s4 23.8 9.3 30.9s10.7 9.1 14.7 9.1c3.7 0 8.6-1.8 13.6-7.7c7-8.3 18.5-16.3 33.5-16.3c22.6 0 40.9 18.3 40.9 40.9l0 79.1c0 4.4 3.6 8 8 8l76.5 0c-2.9-7.4-4.5-15.5-4.5-24c0-43.1 39.4-72 80-72s80 28.9 80 72c0 8.5-1.6 16.6-4.5 24l76.5 0c4.4 0 8-3.6 8-8l0-79.1c0-22.6 18.3-40.9 40.9-40.9c15 0 26.5 8.1 33.5 16.3c4.9 5.9 9.8 7.7 13.6 7.7c4 0 9.5-2.1 14.7-9.1s9.3-17.9 9.3-30.9s-4-23.8-9.3-30.9s-10.7-9.1-14.7-9.1c-3.7 0-8.6 1.8-13.6 7.7c-7 8.3-18.5 16.3-33.5 16.3c-22.6 0-40.9-18.3-40.9-40.9l0-79.1c0-4.4-3.6-8-8-8l-76.5 0c2.9 7.4 4.5 15.5 4.5 24c0 43.1-39.4 72-80 72s-80-28.9-80-72c0-8.5 1.6-16.6 4.5-24L168 112zm-56 8c0-30.9 25.1-56 56-56l102.1 0C288.8 64 304 79.2 304 97.9c0 10.1-4.5 18.5-9.9 24.2c-4.2 4.3-6.1 9.2-6.1 13.9c0 9.9 10.7 24 32 24s32-14.1 32-24c0-4.7-1.9-9.5-6.1-13.9c-5.5-5.7-9.9-14.1-9.9-24.2C336 79.2 351.2 64 369.9 64L472 64c30.9 0 56 25.1 56 56l0 62.6c10.9-8.8 24.6-14.6 40-14.6c22.5 0 41 12.2 53.1 28.3S640 233.6 640 256s-6.8 43.5-18.9 59.7S590.5 344 568 344c-15.4 0-29.1-5.8-40-14.6l0 62.6c0 30.9-25.1 56-56 56l-102.1 0c-18.7 0-33.9-15.2-33.9-33.9c0-10.1 4.5-18.5 9.9-24.2c4.2-4.3 6.1-9.2 6.1-13.9c0-9.9-10.7-24-32-24s-32 14.1-32 24c0 4.7 1.9 9.5 6.1 13.9c5.5 5.7 9.9 14.1 9.9 24.2c0 18.7-15.2 33.9-33.9 33.9L168 448c-30.9 0-56-25.1-56-56l0-62.6C101.1 338.2 87.4 344 72 344c-22.5 0-41-12.2-53.1-28.3S0 278.4 0 256s6.8-43.5 18.9-59.7S49.5 168 72 168c15.4 0 29.1 5.8 40 14.6l0-62.6z"]
};
const faPuzzlePieceAlt = faPuzzlePieceSimple;
const faTruckFieldUn = {
  prefix: 'far',
  iconName: 'truck-field-un',
  icon: [640, 512, [], "e58e", "M80 80c-8.8 0-16 7.2-16 16l0 32 0 160 0 48 12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L352 336l0-16 0-96 0-120 0-8c0-8.8-7.2-16-16-16L80 80zM16 336l0-52.3C6.4 278.2 0 267.8 0 256l0-96c0-11.8 6.4-22.2 16-27.7L16 96c0-35.3 28.7-64 64-64l256 0c29.8 0 54.9 20.4 62 48l37.7 0c21.7 0 41.4 12.5 50.7 32.2l52.3 111.2 .3 .7 5 0c35.3 0 64 28.7 64 64l0 48 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0-96 0c0 53-43 96-96 96s-96-43-96-96l-40 0-8 0 0-1.4C6.7 379.3 0 370.5 0 360s6.7-19.3 16-22.6l0-1.4zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM400 224l85.9 0-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6L400 128l0 96zm80 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM253.3 135.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faNfcTrash = {
  prefix: 'far',
  iconName: 'nfc-trash',
  icon: [640, 512, [], "e1fd", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l314.2 0 3.4 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 66.7c-11.5 4.1-21.3 12.5-26.9 23.8l-2.7 5.5L400 192l0-96c0-8.8-7.2-16-16-16zM352 240c0 13.7 5.8 26.1 15 34.8l1 14.3 0 70.9c0 22.1-17.9 40-40 40l-208 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 192 0 0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40l0 52.2c-9.8 8.8-16 21.6-16 35.8zm97.7-39.2c2.7-5.4 8.2-8.8 14.3-8.8l96 0c6.1 0 11.6 3.4 14.3 8.8L585.9 224l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-128 0-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l38.1 0 11.6-23.2zM413.9 482.3L400 288l224 0L610.1 482.3C608.9 499 595 512 578.2 512l-132.4 0c-16.8 0-30.7-13-31.9-29.7z"]
};
const faHourglass = {
  prefix: 'far',
  iconName: 'hourglass',
  icon: [384, 512, [9203, 62032, "hourglass-empty"], "f254", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 19c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445l0 19-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-19c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67l0-19 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM192 289.9l81.5 81.5C293 391 304 417.4 304 445l0 19L80 464l0-19c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67l0-19 224 0 0 19c0 27.6-11 54-30.5 73.5L192 222.1z"]
};
const faHourglassEmpty = faHourglass;
const faMountain = {
  prefix: 'far',
  iconName: 'mountain',
  icon: [512, 512, [127956], "f6fc", "M464 424.1c0 4.4-3.5 7.9-7.9 7.9L55.9 432c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L149.6 260l39.5 50.8c4.6 5.9 11.7 9.3 19.2 9.3s14.5-3.6 19-9.6L268 256l92 0L462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zM329.8 208L256 208c-7.6 0-14.7 3.6-19.2 9.6l-29.1 38.9-30.9-39.8L256 90.3 329.8 208zM55.9 480l400.2 0c30.9 0 55.9-25 55.9-55.9c0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1C0 455 25 480 55.9 480z"]
};
const faFileXmark = {
  prefix: 'far',
  iconName: 'file-xmark',
  icon: [384, 512, ["file-times"], "f317", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm47 239c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faFileTimes = faFileXmark;
const faHouseHeart = {
  prefix: 'far',
  iconName: 'house-heart',
  icon: [576, 512, ["home-heart"], "f4c9", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zm64-162.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
const faHomeHeart = faHouseHeart;
const faHouseChimneyBlank = {
  prefix: 'far',
  iconName: 'house-chimney-blank',
  icon: [576, 512, [], "e3b0", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8L512 182.6 512 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 85.9L303.5 5.7zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32z"]
};
const faMeterBolt = {
  prefix: 'far',
  iconName: 'meter-bolt',
  icon: [640, 512, [], "e1e9", "M464 256c0 8.9-.6 17.6-1.6 26.2l49.3-39.4C504.8 107.5 393 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c73.7 0 140.1-31.1 186.8-81l7.5-15L432 416c-11.5 0-22.3-4.1-30.7-11.1C363.8 441.5 312.5 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208zM192 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm234.1 75.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L449.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
};
const faUserDoctor = {
  prefix: 'far',
  iconName: 'user-doctor',
  icon: [448, 512, ["user-md"], "f0f0", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm64 225c5.2-.7 10.6-1 16-1l96 0c5.4 0 10.8 .3 16 1l0 49c-27.6 7.1-48 32.2-48 62l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-32c0-29.8-20.4-54.9-48-62l0-40.7c46.9 19 80 65 80 118.7l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-97.2-78.8-176-176-176l-96 0C78.8 304 0 382.8 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-53.7 33.1-99.7 80-118.7l0 41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-49.3zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faUserMd = faUserDoctor;
const faSlashBack = {
  prefix: 'far',
  iconName: 'slash-back',
  icon: [320, 512, [], "5c", "M11.9 3.3C.4 10-3.4 24.7 3.3 36.1l272 464c6.7 11.4 21.4 15.3 32.8 8.6s15.3-21.4 8.6-32.8l-272-464C38 .4 23.3-3.4 11.9 3.3z"]
};
const faCircleInfo = {
  prefix: 'far',
  iconName: 'circle-info',
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faInfoCircle = faCircleInfo;
const faFishingRod = {
  prefix: 'far',
  iconName: 'fishing-rod',
  icon: [448, 512, [], "e3a8", "M280.4 48c-3.2 0-6.3 .5-9.3 1.4L206.6 69.2C136.1 90.9 88 156.1 88 229.8l0 42.9c22.7 3.8 40 23.6 40 47.3l0 144c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 320c0-23.8 17.3-43.5 40-47.3l0-42.9C40 135 101.8 51.2 192.5 23.4L256.9 3.5C264.5 1.2 272.4 0 280.4 0c44 0 79.6 35.7 79.6 79.6l0 56.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56.4C312 62.2 297.8 48 280.4 48zM48 320l0 144 32 0 0-144-32 0zm208 24c0-71.6 55.6-127.8 89-148.1c4.3-2.6 9.6-2.6 14 0c33.5 20.3 89 76.6 89 148.1c0 32-16 80-64 112l27.3 27.3c3 3 4.7 7.1 4.7 11.3l0 1.4c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-1.4c0-4.2 1.7-8.3 4.7-11.3L320 456c-48-32-64-80-64-112zm128-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faHammerCrash = {
  prefix: 'far',
  iconName: 'hammer-crash',
  icon: [640, 512, [], "e414", "M289.9 328.5l1.5 .7c15 7.5 31.5 8.6 46.4 4.2l-.3 1.8 54.1-23.5c9.6-4.2 20.9-1.6 27.7 6.3l38.6 44.6 15.4-56.9c2.7-10.1 11.7-17.3 22.2-17.7l58.9-2.3-34.9-47.5c-6.2-8.5-6.2-20 0-28.4l34.9-47.5L495.4 160c-10.5-.4-19.5-7.6-22.2-17.7L457.8 85.3l-20.3 23.6c-6-9.1-14.4-16.9-24.9-22.1L399 80l52-60.3c5.8-6.7 14.8-9.7 23.5-7.7s15.5 8.6 17.8 17.1l22.6 83.5 86.5 3.4c8.9 .3 16.8 5.6 20.7 13.6s3 17.5-2.3 24.6L568.6 224l51.3 69.7c5.3 7.2 6.1 16.6 2.3 24.6s-11.8 13.2-20.7 13.6l-86.5 3.4-22.6 83.5c-2.3 8.6-9.2 15.2-17.8 17.1s-17.7-1-23.5-7.7l-56.6-65.5-79.4 34.5c-8.1 3.5-17.6 2.3-24.5-3.3s-10.3-14.5-8.6-23.2l7.9-42.3zM81.9 64L53.5 120.8 312.8 250.5l49.7-99.4L188.2 64 81.9 64zM43.4 33.7C48.8 22.8 59.9 16 72 16l120 0c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3L186.4 241 69.5 474.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2L143.4 219.5 17.7 156.6C1.9 148.7-4.5 129.5 3.4 113.7l40-80z"]
};
const faMessageHeart = {
  prefix: 'far',
  iconName: 'message-heart',
  icon: [512, 512, [], "e5c9", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM205.3 112c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
const faCloudMeatball = {
  prefix: 'far',
  iconName: 'cloud-meatball',
  icon: [512, 512, [], "f73b", "M184 49.2c-38.7 0-72 33.3-72 76.8c0 2.8 .1 5.6 .4 8.4c1.2 11.9-6.5 22.8-18.1 25.7C68.5 166.5 48 191.5 48 222.6c0 35.5 26.4 62.6 57.2 64.1c.3 0 .7 0 1 .1l1.8 0 63.3 0c-18.3 9.2-31.6 27-34.6 48l-28.7 0-4 0c-1.2 0-2.4-.1-3.6-.3C43.3 330.4 0 280.9 0 222.6C0 177.4 25.9 137.7 64.1 120C67.1 54.9 118.6 1.2 184 1.2c34.2 0 64.8 14.8 86.4 38.2c14.7-8.3 31.6-13 49.6-13c47.9 0 87.2 33.2 99.7 77.4C472.9 113.5 512 162 512 218.4c0 63.2-49.1 116.4-112 116.4l-24.7 0c-3-21-16.3-38.8-34.6-48l59.3 0c34.3 0 64-29.5 64-68.4s-29.7-68.4-64-68.4c0 0 0 0 0 0l-.3 0c-12.4 0-22.8-9.4-23.9-21.7c-3-31.2-27.7-53.9-55.7-53.9c-14.4 0-27.6 5.8-37.7 15.6c-5.3 5.1-12.6 7.6-19.9 6.6s-13.7-5.2-17.5-11.6c-13-21.9-35.7-35.9-60.9-35.9zM288 320c0 1-.1 2.1-.1 3.1c.7-.8 1.3-1.6 2.1-2.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-.7 .7-1.5 1.4-2.3 2.1c1-.1 2.1-.1 3.1-.1c17.7 0 32 14.3 32 32s-14.3 32-32 32c-1 0-2.1-.1-3.1-.2c.8 .7 1.6 1.4 2.3 2.1c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0c-.7-.7-1.4-1.5-2.1-2.3c.1 1 .1 2.1 .1 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1 .1-2.1 .1-3.1c-.7 .8-1.3 1.6-2.1 2.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3c.7-.7 1.5-1.4 2.3-2.1c-1 .1-2.1 .2-3.1 .2c-17.7 0-32-14.3-32-32s14.3-32 32-32c1 0 2.1 0 3.1 .1c-.8-.7-1.6-1.3-2.3-2.1c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c.7 .7 1.4 1.5 2.1 2.3c-.1-1-.1-2.1-.1-3.1c0-17.7 14.3-32 32-32s32 14.3 32 32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm416 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faCameraPolaroid = {
  prefix: 'far',
  iconName: 'camera-polaroid',
  icon: [576, 512, [], "f8aa", "M512 432L64 432c-8.8 0-16-7.2-16-16l0-32 480 0 0 32c0 8.8-7.2 16-16 16zM68.4 336l32.9-49.3c7-10.5 10.7-22.9 10.7-35.5L112 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 155.2c0 12.6 3.7 25 10.7 35.5L507.6 336 68.4 336zM64 480l448 0c35.3 0 64-28.7 64-64l0-44.6c0-12.6-3.7-25-10.7-35.5L514.7 260c-1.8-2.6-2.7-5.7-2.7-8.9L512 96c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 155.2c0 3.2-.9 6.2-2.7 8.9L10.7 335.9C3.7 346.4 0 358.7 0 371.4L0 416c0 35.3 28.7 64 64 64zM408 112a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM288 288a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-32-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faCamera = {
  prefix: 'far',
  iconName: 'camera',
  icon: [512, 512, [62258, "camera-alt"], "f030", "M199.1 32c-24.1 0-45.5 15.4-53.1 38.3l22.8 7.6-22.8-7.6L137.4 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C358.4 47.4 337 32 312.9 32L199.1 32zm-7.6 53.5c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l90.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faCameraAlt = faCamera;
const faSquareVirus = {
  prefix: 'far',
  iconName: 'square-virus',
  icon: [448, 512, [], "e578", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 13.6c13.3 0 24 10.7 24 24c0 23.8 28.8 35.7 45.6 18.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.8 16.8-4.9 45.6 18.9 45.6c13.3 0 24 10.7 24 24s-10.7 24-24 24c-23.8 0-35.7 28.8-18.9 45.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.8-16.8-45.6-4.9-45.6 18.9c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-23.8-28.8-35.7-45.6-18.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.8-16.8 4.9-45.6-18.9-45.6c-13.3 0-24-10.7-24-24s10.7-24 24-24c23.8 0 35.7-28.8 18.9-45.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.8 16.8 45.6 4.9 45.6-18.9c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCartArrowUp = {
  prefix: 'far',
  iconName: 'cart-arrow-up',
  icon: [576, 512, [], "e3ee", "M296 184l0-102.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23L344 184c0 13.3-10.7 24-24 24s-24-10.7-24-24zM0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faMeteor = {
  prefix: 'far',
  iconName: 'meteor',
  icon: [512, 512, [9732], "f753", "M474.8 0c-5.2 0-10.3 1.1-15 3.2L324 62.9l1.4-18.2c2.5-34.2-36.2-55.5-63.7-35.1L82.7 142.5C30.6 181.2 0 242.7 0 307.5C0 419.8 91 512 203.6 512c65.7 0 127.4-31.8 165.7-85.3L495.6 249.8c19.7-27.6-1.8-65.7-35.6-63.1l-10.7 .8L508.8 52.2c2.1-4.7 3.2-9.8 3.2-15C512 16.7 495.3 0 474.8 0zm-168 122.9l147-64.7L389.2 204.9c-3.4 7.7-2.5 16.7 2.4 23.5s13 10.7 21.4 10.1l33.5-2.6-116.4 163C301 439.7 253.8 464 203.6 464C117.8 464 48 393.6 48 307.5c0-49.7 23.6-96.9 63.4-126.5L276.2 58.6l-3 40.6c-.6 8.4 3.2 16.5 10.1 21.4s15.8 5.8 23.5 2.4zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faCarOn = {
  prefix: 'far',
  iconName: 'car-on',
  icon: [512, 512, [], "e4dd", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM185.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L365.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM89.4 287.9c-.2 .5-.3 .9-.5 1.4C64.2 306.7 48 335.5 48 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L394 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8L89.4 287.9zM416 368l0 32L96 400l0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48zM160 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
const faSleigh = {
  prefix: 'far',
  iconName: 'sleigh',
  icon: [640, 512, [], "f7cc", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 176c0 62.5 44.8 114.5 104 125.8l0 50.2-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l504 0c44.2 0 80-35.8 80-80l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16c0 17.7-14.3 32-32 32l-120 0 0-48.2C507 379.6 560 324 560 256l0-112 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0-24 0-24 0-56 0c-22.1 0-40 17.9-40 40l0 45.7c0 23.3-18.9 42.3-42.3 42.3c-58.3 0-112.5-30-143.4-79.5l-18.9-30.2C182.5 67.9 133.7 38.1 80 32.8c-5.1-.5-10.2-.8-15.4-.8L64 32l-1 0L32 32l-8 0zM392 432l-208 0 0-48 208 0 0 48zm40-96l-40 0-208 0-24 0c-44.2 0-80-35.8-80-80L80 81.1c37.2 5 70.5 26.3 90.7 58.6L189.6 170c39.7 63.5 109.2 102 184.1 102c49.9 0 90.3-40.4 90.3-90.3l0-37.7 48 0 0 112c0 44.2-35.8 80-80 80z"]
};
const faArrowDown19 = {
  prefix: 'far',
  iconName: 'arrow-down-1-9',
  icon: [576, 512, ["sort-numeric-asc", "sort-numeric-down"], "f162", "M456 56c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-48 16C363.8 53.4 357 67 361.2 79.6S379 99 391.6 94.8L408 89.3l0 38.7 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-48 0-72zM143 473c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96zm281-89a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-17.9 46.2l-8.7 10.6c-8.4 10.3-6.9 25.4 3.4 33.8s25.4 6.9 33.8-3.4l56.8-69.4C504.7 385.5 512 365.1 512 344c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 42.5 30.1 77.9 70.1 86.2z"]
};
const faSortNumericAsc = faArrowDown19;
const faSortNumericDown = faArrowDown19;
const faBuoyMooring = {
  prefix: 'far',
  iconName: 'buoy-mooring',
  icon: [576, 512, [], "e5b6", "M264 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 42.6c42.6 9.4 76.7 43.2 85.3 87.5l47.1 241.2c-.4 .3-.8 .6-1.2 .9c-13.3 9.2-28.9 15.9-43.8 18.8L383.9 336l-191.9 0-15.4 78.9c-14.9-2.9-30.5-9.6-43.8-18.8c-.4-.3-.8-.6-1.3-.9l47.1-241.2c8.6-44.3 42.8-78.1 85.3-87.5L264 24zm24 88c-30.3 0-56.4 21.5-62.2 51.3L201.4 288l173.1 0L350.2 163.3C344.4 133.5 318.3 112 288 112zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faSquare4 = {
  prefix: 'far',
  iconName: 'square-4',
  icon: [448, 512, [], "e259", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm127.6 97.2c-12.6-4.2-26.2 2.6-30.4 15.2l-48 144c-2.4 7.3-1.2 15.4 3.3 21.6s11.8 10 19.5 10l104 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-70.7 0 37.5-112.4c4.2-12.6-2.6-26.2-15.2-30.4z"]
};
const faHandHoldingDroplet = {
  prefix: 'far',
  iconName: 'hand-holding-droplet',
  icon: [576, 512, ["hand-holding-water"], "f4c1", "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3l0 1.7c0 53-43 96-96 96s-96-43-96-96l0-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faHandHoldingWater = faHandHoldingDroplet;
const faFileEps = {
  prefix: 'far',
  iconName: 'file-eps',
  icon: [512, 512, [], "e644", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm96-96c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64 0-64zm144-16l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm117.7-80l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L424 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C417.8 430.8 408 415 408 397.7c0-25.2 20.4-45.7 45.7-45.7z"]
};
const faTricycleAdult = {
  prefix: 'far',
  iconName: 'tricycle-adult',
  icon: [640, 512, [], "e5c4", "M288 88c0-13.3 10.7-24 24-24l38.9 0c18.7 0 36.2 9.4 46.6 24.9L512.4 261.3c9.9-3.4 20.5-5.3 31.6-5.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-24.6 9.3-47 24.5-64l-13.4-20.1-39.8 53.1c-14.7 19.5-37.7 31.1-62.1 31.1c-5 0-10-.5-14.9-1.4l-55.1-10.7c.5 4 .8 8.1 .8 12.2c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c.6-.4 1.3-.8 1.9-1.1c-14.5 8.9-31.6 14-49.9 14c-53 0-96-43-96-96c0-24.4 9.1-46.6 24-63.5l-4.6-.9c-13-2.5-21.5-15.1-19-28.2s15.1-21.5 28.2-19l322.9 63c1.9 .4 3.8 .5 5.7 .5c9.3 0 18.1-4.4 23.7-11.9l50-66.6-73.3-110c-1.5-2.2-4-3.6-6.7-3.6L312 112c-13.3 0-24-10.7-24-24zM186.6 320.2c3.5 10 5.4 20.7 5.4 31.8c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-8.1-2-15.8-5.6-22.5l-47.8-9.3zM48.7 97.1c12.6-4 26.1 2.9 30.2 15.5l15.3 47.9c2.7 8.3 9.7 14.6 18.3 16.2l84.1 16.4c13 2.5 21.5 15.1 19 28.2s-15.1 21.5-28.2 19l-84.1-16.4c-25.8-5-46.8-23.7-54.8-48.7L33.1 127.3c-4-12.6 2.9-26.1 15.5-30.2zM144 352a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm448 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faWaveform = {
  prefix: 'far',
  iconName: 'waveform',
  icon: [640, 512, [], "f8f1", "M320 0c12 0 22.1 8.8 23.8 20.7l42 304.4L424.3 84.2c1.9-11.7 12-20.3 23.9-20.2s21.9 8.9 23.6 20.6l28.2 197.3 20.5-102.6c2.2-10.8 11.3-18.7 22.3-19.3s20.9 6.4 24.2 16.9L593.7 264l22.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-10.5 0-19.8-6.9-22.9-16.9l-4.1-13.4-29.4 147c-2.3 11.5-12.5 19.6-24.2 19.3s-21.4-9-23.1-20.6L446.7 248.3l-39 243.5c-1.9 11.7-12.1 20.3-24 20.2s-21.9-8.9-23.5-20.7L320 199.6 279.8 491.3c-1.6 11.8-11.6 20.6-23.5 20.7s-22.1-8.5-24-20.2l-39-243.5L167.8 427.4c-1.7 11.6-11.4 20.3-23.1 20.6s-21.9-7.8-24.2-19.3l-29.4-147-4.1 13.4C83.8 305.1 74.5 312 64 312l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.3 0 26.8-87.1c3.2-10.5 13.2-17.5 24.2-16.9s20.2 8.5 22.3 19.3l20.5 102.6L168.2 84.6c1.7-11.7 11.7-20.5 23.6-20.6s22 8.5 23.9 20.2l38.5 240.9 42-304.4C297.9 8.8 308 0 320 0z"]
};
const faWater = {
  prefix: 'far',
  iconName: 'water',
  icon: [576, 512, [], "f773", "M80 78.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7C41 104.8 62.8 93 80 78.1zm0 288c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm31.9-144c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faStarSharpHalfStroke = {
  prefix: 'far',
  iconName: 'star-sharp-half-stroke',
  icon: [576, 512, ["star-sharp-half-alt"], "e28d", "M310.9 16.7C307.7 6.8 298.5 0 288 0s-19.7 6.8-22.9 16.7L214.5 176 56 176c-10.3 0-19.4 6.5-22.7 16.2s-.1 20.4 8 26.7L172.1 320.7 121.1 480.7c-3.2 10 .5 21 9.1 27s20.2 5.7 28.5-.7L288 406.4 417.3 506.9c8.3 6.5 19.8 6.8 28.5 .7s12.3-16.9 9.1-27L403.9 320.7 534.7 218.9c8.1-6.3 11.3-17 8-26.7s-12.4-16.2-22.7-16.2l-158.4 0L310.9 16.7zM288 103.2s0 0 0 0l33.1 104.1c3.2 10 12.4 16.7 22.9 16.7l106.1 0-88.8 69.1c-7.9 6.2-11.2 16.6-8.1 26.2l32.5 102.3-82.9-64.5c-4.3-3.4-9.5-5.1-14.7-5.1l0-248.8z"]
};
const faStarSharpHalfAlt = faStarSharpHalfStroke;
const faNfcSignal = {
  prefix: 'far',
  iconName: 'nfc-signal',
  icon: [512, 512, [], "e1fb", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l166 0c-3.4 15.5-5.3 31.6-5.8 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 131c-16.6 2.5-32.6 6.6-48 12l0-143c0-8.8-7.2-16-16-16zm-16 72l0 100.8c-17.2 8.8-33.3 19.4-48 31.6L320 160l-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40zM239 400l-119 0c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 133.7 0c-9.1 15.1-16.7 31.1-22.7 48zM488 256c13.3 0 24 10.7 24 24s-10.7 24-24 24c-101.6 0-184 82.4-184 184c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1 103.9-232 232-232zm-8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-72c0 13.3-10.7 24-24 24c-48.6 0-88 39.4-88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1 60.9-136 136-136c13.3 0 24 10.7 24 24z"]
};
const faPlaneProp = {
  prefix: 'far',
  iconName: 'plane-prop',
  icon: [576, 512, [], "e22b", "M267.3 176l49.5 0L299.1 48l-14.2 0L267.3 176zM344.7 27.6l5 36.4c.7-.1 1.5-.1 2.2-.1l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-9.4 0 6.6 48 93.1 0c21 0 48.1 6.2 70.4 17.4C549.4 203.8 576 223.9 576 256c0 32.5-26.4 52.6-47.4 63c-22.5 11.1-49.5 17-70.3 17l-93.1 0-6.6 48 9.4 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-.8 0-1.5 0-2.2-.1l-5 36.4C342.5 500.2 329 512 313 512L271 512c-16 0-29.5-11.8-31.7-27.6l-5-36.4L224 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l1.4 0-7.2-52.4-75.7-9.1-5.8 34.3C134.3 372.4 120.8 384 105 384l-34 0c-15.9 0-29.4-11.7-31.7-27.4L28.7 287.8C12.6 286.2 0 272.5 0 256s12.6-30.2 28.7-31.8l10.7-68.7C41.6 139.7 55.1 128 71 128l34 0c15.8 0 29.3 11.6 31.6 27.2l5.8 34.3 75.7-9.1 7.2-52.4-1.4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l10.3 0 5-36.4C241.5 11.8 255 0 271 0L313 0c16 0 29.5 11.8 31.7 27.6zM267.3 336l17.7 128 14.2 0 17.7-128-49.5 0zm191.1-48c13.4 0 33.1-4.1 49-12c17.4-8.6 20.7-16.5 20.7-20c0-2.9-3.2-10.8-20.8-19.7c-15.9-8-35.7-12.3-48.9-12.3l-200.9 0L125.5 239.8c-12.7 1.5-24.4-7.2-26.5-19.8l-7.5-44-6.8 0L72.3 256l12.4 80 6.8 0L99 292c2.2-12.6 13.8-21.3 26.5-19.8L257.4 288l200.9 0z"]
};
const faCalendarCheck = {
  prefix: 'far',
  iconName: 'calendar-check',
  icon: [448, 512, [], "f274", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faClockDesk = {
  prefix: 'far',
  iconName: 'clock-desk',
  icon: [448, 512, [], "e134", "M400 224A176 176 0 1 0 48 224a176 176 0 1 0 352 0zM224 0C347.7 0 448 100.3 448 224l0 240c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 224C0 100.3 100.3 0 224 0zm0 96c13.3 0 24 10.7 24 24l0 94.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-4.5-4.5-7-10.6-7-17l0-104c0-13.3 10.7-24 24-24z"]
};
const faCalendarClock = {
  prefix: 'far',
  iconName: 'calendar-clock',
  icon: [576, 512, ["calendar-time"], "e0d2", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48-16 0-32 0-112 0L48 192l0 256c0 8.8 7.2 16 16 16l220.5 0c12.3 18.8 28 35.1 46.3 48L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"]
};
const faCalendarTime = faCalendarClock;
const faBraille = {
  prefix: 'far',
  iconName: 'braille',
  icon: [640, 512, [], "f2a1", "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM88 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm248 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faPrescriptionBottleMedical = {
  prefix: 'far',
  iconName: 'prescription-bottle-medical',
  icon: [384, 512, ["prescription-bottle-alt"], "f486", "M48 48l288 0 0 32L48 80l0-32zM32 0C14.3 0 0 14.3 0 32L0 96c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0zm0 160l0 288c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-288-48 0 0 288c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-288-48 0zm133.3 80l0 37.3-37.3 0c-8.8 0-16 7.2-16 16l0 21.3c0 8.8 7.2 16 16 16l37.3 0 0 37.3c0 8.8 7.2 16 16 16l21.3 0c8.8 0 16-7.2 16-16l0-37.3 37.3 0c8.8 0 16-7.2 16-16l0-21.3c0-8.8-7.2-16-16-16l-37.3 0 0-37.3c0-8.8-7.2-16-16-16l-21.3 0c-8.8 0-16 7.2-16 16z"]
};
const faPrescriptionBottleAlt = faPrescriptionBottleMedical;
const faPlateUtensils = {
  prefix: 'far',
  iconName: 'plate-utensils',
  icon: [640, 512, [58713], "e43b", "M24 16c13.3 0 24 10.7 24 24l0 128c0 4.4 3.6 8 8 8l8 0L64 40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136 8 0c4.4 0 8-3.6 8-8l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128c0 30.9-25.1 56-56 56l-8 0 0 248c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-248-8 0c-30.9 0-56-25.1-56-56L0 40C0 26.7 10.7 16 24 16zM560 160l0 112 32 0 0-56 0-130.8c-16.6 15.3-32 39.1-32 74.8zm32 160l-48 0c-17.7 0-32-14.3-32-32l0-128C512 59.2 596.2 23.2 613.1 17c2-.7 4-1 6.1-1c11.5 0 20.9 9.3 20.9 20.9L640 216l0 56 0 48 0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-152zM336 480c-81.5 0-152.8-43.5-192-108.6l0-118.8c5.7-1.6 11.1-3.8 16.3-6.4c-.2 3.2-.3 6.5-.3 9.7c0 97.2 78.8 176 176 176c70.8 0 131.8-41.8 159.7-102c10.6 12.2 25.8 20.3 42.8 21.8C502.6 427.6 425.4 480 336 480zM208 72.2C244.3 46.8 288.4 32 336 32c60.3 0 115 23.8 155.3 62.5c-6.5 17.5-10.6 37.5-11.2 60.3C448.2 109.6 395.6 80 336 80c-50.4 0-95.9 21.2-128 55.2l0-63.1zM416 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-208 0a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"]
};
const faFamilyPants = {
  prefix: 'far',
  iconName: 'family-pants',
  icon: [512, 512, [], "e302", "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 60.6 0c-3 10.1-4.6 20.9-4.6 32l0 16-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c9.2 0 18.1 1.6 26.4 4.5c-.5 3.8-.8 7.6-.8 11.5c0 11.4 2.4 22.2 6.7 32l-32.3 0L128 208l-22.4 0zM336 176c0-3.9-.3-7.8-.8-11.5c8.3-2.9 17.2-4.5 26.4-4.5l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L448 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0-16c0-11.1-1.6-21.9-4.6-32l60.6 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C436.9 220.8 423 208 406.4 208L384 208l-22.4 0-32.3 0c4.3-9.8 6.7-20.6 6.7-32zM320 64a64 64 0 1 1 128 0A64 64 0 1 1 320 64zm-64 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm32 208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16c0 8.8 7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16l0-16zm48 16c0 24-13.2 44.9-32.7 55.8c.5 2.7 .7 5.4 .7 8.2l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64c0-2.8 .2-5.5 .7-8.2C189.2 396.9 176 376 176 352l0-16c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16z"]
};
const faHoseReel = {
  prefix: 'far',
  iconName: 'hose-reel',
  icon: [640, 512, [], "e41a", "M320 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c45.6 0 87.7-14.6 122-39.5c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5C428 494 376.1 512 320 512C178.6 512 64 397.4 64 256S178.6 0 320 0S576 114.6 576 256l0 96 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-2.3 0-11.5 80.2c7.8 1.1 13.7 7.8 13.7 15.8c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16c0-8.1 6-14.7 13.7-15.8L514.3 400l-2.3 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96c0-114.9-93.1-208-208-208zM208 256a112 112 0 1 0 224 0 112 112 0 1 0 -224 0zM320 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faHouseWindow = {
  prefix: 'far',
  iconName: 'house-window',
  icon: [576, 512, [], "e3b3", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM256 288l0-64 64 0 0 64-64 0zm-48-72l0 80c0 22.1 17.9 40 40 40l80 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40z"]
};
const faLandmark = {
  prefix: 'far',
  iconName: 'landmark',
  icon: [512, 512, [127963], "f66f", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM256 51.4L423.8 144 88.2 144 256 51.4zM112 224l-48 0 0 160-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24z"]
};
const faTruck = {
  prefix: 'far',
  iconName: 'truck',
  icon: [640, 512, [128666, 9951], "f0d1", "M352 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-32 0-76.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l288 0zm32 368c0 53 43 96 96 96s96-43 96-96l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-122.7c0-14.9-5.9-29.1-16.4-39.6l-93.3-93.3C487.8 101.9 473.6 96 458.7 96L416 96l0-32c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64c0 53 43 96 96 96s96-43 96-96l64 0 32 0 24 0 8 0zM557.7 239.6c.1 .1 .3 .3 .4 .4l-142 0 0-96 42.7 0c2.1 0 4.2 .8 5.7 2.3l93.3 93.3zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faMusicMagnifyingGlass = {
  prefix: 'far',
  iconName: 'music-magnifying-glass',
  icon: [640, 512, [], "e662", "M352 367.2c80.9-8 144-76.2 144-159.2c0-88.4-71.6-160-160-160c-72.7 0-134 48.5-153.5 114.8l-52.6 17.5C143.3 78.6 230.5 0 336 0C450.9 0 544 93.1 544 208c0 48.8-16.8 93.7-44.9 129.1L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L465.1 371.1c-32 25.4-71.6 41.5-114.9 44.4c1.1-4.9 1.8-10.1 1.8-15.5c0-1.4 0-2.8-.1-4.2c.1-1.3 .1-2.5 .1-3.8l0-24.8zM320 184c0-7.7-3.7-15-10-19.5s-14.3-5.7-21.6-3.3l-192 64C86.6 228.5 80 237.7 80 248l0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48z"]
};
const faCrosshairs = {
  prefix: 'far',
  iconName: 'crosshairs',
  icon: [512, 512, [], "f05b", "M256 0c13.3 0 24 10.7 24 24l0 17.3C380.1 52.4 459.6 131.9 470.7 232l17.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-17.3 0C459.6 380.1 380.1 459.6 280 470.7l0 17.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.3C131.9 459.6 52.4 380.1 41.3 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l17.3 0C52.4 131.9 131.9 52.4 232 41.3L232 24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3l0-30.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.3c73.6-10.5 131.8-68.7 142.3-142.3L392 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.3 0C411.8 158.4 353.6 100.2 280 89.7l0 30.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-30.3C158.4 100.2 100.2 158.4 89.7 232l30.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.3 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCloudRainbow = {
  prefix: 'far',
  iconName: 'cloud-rainbow',
  icon: [576, 512, [], "f73e", "M291.5 195.2C344.7 107 441.5 48 552 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C420.9 0 306.5 71.7 245.9 178.1c10.8 6 20.8 13.4 29.6 21.9c5.2-1.9 10.5-3.5 16-4.8zM394.6 216c38.1-44.1 94.5-72 157.4-72c13.3 0 24-10.7 24-24s-10.7-24-24-24c-82.4 0-155.7 38.9-202.5 99.4c16.5 3.9 31.8 11 45.2 20.6zm42.9 53.3c9.8 2.8 19.2 6.7 28 11.6C486.1 255.9 517.2 240 552 240c13.3 0 24-10.7 24-24s-10.7-24-24-24c-50.1 0-94.8 23-124.1 59.1c3.7 5.8 6.9 11.8 9.7 18.2zM112 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 462.4 48 436.2 48 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C26.4 322.1 0 359.9 0 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 247 366.9 216 320 216c-18 0-34.9 4.6-49.7 12.6C248.5 206.1 217.9 192 184 192z"]
};
const faPersonCane = {
  prefix: 'far',
  iconName: 'person-cane',
  icon: [448, 512, [], "e53c", "M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 209.5L76.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L93.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l35 0c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L256 214.2 256 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1L176 176l0 128 32 0 0-127.9zM352 376l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-30.9 25.1-56 56-56s56 25.1 56 56l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
};
const faAlien = {
  prefix: 'far',
  iconName: 'alien',
  icon: [448, 512, [128125], "f8f5", "M194.7 503.2c8.6 5.9 18.9 8.8 29.3 8.8s20.7-2.9 29.3-8.8C299.2 471.7 448 359.3 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224C0 359.3 148.8 471.7 194.7 503.2zM224 48c97.2 0 176 78.8 176 176c0 50.4-28.2 101.3-68.2 146.9c-39.2 44.7-84.2 78.1-105.6 92.7c0 0 0 0 0 0s0 0 0 0c0 0 0 0-.1 0l-.1 0c0 0-.1 0-.1 0l-.1 0c-.3 .1-.9 .2-1.8 .2s-1.4-.1-1.8-.2c-.1 0-.2-.1-.2-.1l-.1 0c0 0 0 0-.1 0c0 0 0 0 0 0s0 0 0 0c-21.4-14.6-66.4-48-105.6-92.7C76.2 325.3 48 274.4 48 224c0-97.2 78.8-176 176-176zm16 258.3c0 7.6 6.1 13.7 13.7 13.7l32 0c45.4 0 82.3-36.8 82.3-82.3c0-7.6-6.1-13.7-13.7-13.7l-32 0c-45.4 0-82.3 36.8-82.3 82.3zM125.7 224l-32 0c-7.6 0-13.7 6.1-13.7 13.7c0 45.4 36.8 82.3 82.3 82.3l32 0c7.6 0 13.7-6.1 13.7-13.7c0-45.4-36.8-82.3-82.3-82.3z"]
};
const faTent = {
  prefix: 'far',
  iconName: 'tent',
  icon: [576, 512, [], "e57d", "M274.4 4.2c8.2-5.7 19-5.7 27.3 0L521.5 155.9c13.5 9.3 22.2 24 23.9 40.2l26.7 254c3.5 33.1-22.4 61.9-55.7 61.9L440 512l-176 0L59.5 512C26.3 512 .4 483.2 3.9 450.1l26.7-254c1.7-16.3 10.4-31 23.9-40.2L274.4 4.2zM516.5 464c4.7 0 8.5-4.1 8-8.8l-26.7-254c-.2-2.3-1.5-4.4-3.4-5.7L312 69.7l0 209.6L413.6 464l102.9 0zM264 69.7L81.7 195.4c-1.9 1.3-3.2 3.4-3.4 5.7l-26.7 254c-.5 4.7 3.2 8.8 8 8.8L264 464l0-136 0-136 0-122.3z"]
};
const faLaptopBinary = {
  prefix: 'far',
  iconName: 'laptop-binary',
  icon: [640, 512, [], "e5e7", "M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM200 128c-22.1 0-40 17.9-40 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-16 0zm80 40l0 32c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-32c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 16 32 0 0-32c0-8.8-7.2-16-16-16l-16 0zm240 0l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 16 32 0 0-32c0-8.8-7.2-16-16-16zm-64 40c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40l0 8 32 0 0-8c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 32 0 0-8z"]
};
const faVestPatches = {
  prefix: 'far',
  iconName: 'vest-patches',
  icon: [448, 512, [], "e086", "M178.5 81.5l28.8 95-25.1 82.8-64-211.2c-.3 0-.6-.1-.9-.1L104 48c-4.4 0-8 3.6-8 8l0 72 0 58.7c0 13-3.5 25.9-10.3 37L51.4 280.9c-2.2 3.7-3.4 8-3.4 12.3L48 456c0 4.4 3.6 8 8 8l120.4 0c1.6 17.6 8.4 33.8 18.8 46.9c-3.6 .7-7.4 1.1-11.2 1.1L56 512c-30.9 0-56-25.1-56-56L0 293.3c0-13 3.5-25.9 10.3-37l34.3-57.2c2.2-3.7 3.4-8 3.4-12.3L48 128l0-72C48 25.1 73.1 0 104 0l13.3 0 6.8 0c10.1 0 19.5 3.8 26.7 10.2c4.6 2.8 8.6 6 12 9C172.3 27.6 191.4 40 224 40s51.7-12.4 61.2-20.8c3.4-3.1 7.5-6.2 12-9C304.4 3.8 313.8 0 323.9 0l6.8 0L344 0c30.9 0 56 25.1 56 56l0 72 0 58.7c0 4.4 1.2 8.6 3.4 12.3l34.3 57.2c6.7 11.2 10.3 24 10.3 37L448 456c0 30.9-25.1 56-56 56l-128 0c-30.9 0-56-25.1-56-56l0-160.9c0-7.1 1-14.1 3.1-20.9L269.5 81.5c-13 4-28.1 6.5-45.5 6.5s-32.5-2.6-45.5-6.5zM329.8 48.1L257 288.2c-.7 2.3-1 4.6-1 7L256 456c0 4.4 3.6 8 8 8l128 0c4.4 0 8-3.6 8-8l0-162.7c0-4.4-1.2-8.6-3.4-12.3l-34.3-57.2c-6.7-11.2-10.3-24-10.3-37l0-58.7 0-72c0-3.9-2.7-7.1-6.4-7.8c-.5-.1-1.1-.2-1.6-.2l-13.3 0c-.3 0-.6 0-.9 .1zM288 288l0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-32 0c-8.8 0-16-7.2-16-16l0-32zM84.7 260.7c6.2-6.2 16.4-6.2 22.6 0L120 273.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 296l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 318.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 296 84.7 283.3c-6.2-6.2-6.2-16.4 0-22.6zM112 360a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faPeopleDressSimple = {
  prefix: 'far',
  iconName: 'people-dress-simple',
  icon: [512, 512, [], "e218", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM112.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L192.4 336 63.6 336 96.9 219.6c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L205.3 206.4c-7.9-27.5-33-46.4-61.5-46.4l-31.4 0zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM368.3 208l31.4 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336l-128.7 0 33.3-116.4c2-6.9 8.2-11.6 15.4-11.6zm0-48c-28.6 0-53.7 18.9-61.5 46.4L267.7 343.2c-5.8 20.4 9.5 40.8 30.8 40.8l21.6 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0z"]
};
const faCheckDouble = {
  prefix: 'far',
  iconName: 'check-double',
  icon: [448, 512, [], "f560", "M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z"]
};
const faArrowDownAZ = {
  prefix: 'far',
  iconName: 'arrow-down-a-z',
  icon: [576, 512, ["sort-alpha-asc", "sort-alpha-down"], "f15d", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zm305-89c-13.3 0-24 10.7-24 24s10.7 24 24 24l74.6 0L334.1 440.1c-6.3 7.1-7.8 17.2-4 25.8S342.6 480 352 480l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-74.6 0 92.5-104.1c6.3-7.1 7.8-17.2 4-25.8S489.4 288 480 288l-128 0zM416 32c-9.1 0-17.4 5.1-21.5 13.3l-80 160c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L370.8 200l85.2 0c1.7 0 3.3-.2 4.9-.5l13.6 27.2c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-80-160C433.4 37.1 425.1 32 416 32zM394.8 152L416 109.7 437.2 152l-42.3 0z"]
};
const faSortAlphaAsc = faArrowDownAZ;
const faSortAlphaDown = faArrowDownAZ;
const faBowlingBallPin = {
  prefix: 'far',
  iconName: 'bowling-ball-pin',
  icon: [576, 512, [], "e0c3", "M464 48c-17.7 0-32 14.3-32 32l0 4.4c0 5.8 .7 11.5 2.1 17.1l9.4 37.4c1.7 6.9 3 14 3.7 21.1l33.6 0c.7-7.1 2-14.2 3.7-21.1l9.4-37.4c1.4-5.6 2.1-11.3 2.1-17.1l0-4.4c0-17.7-14.3-32-32-32zM438.3 230.2l-1 2.7c-8.5-27.4-21.8-52.7-38.8-74.9c-.4-2.5-1-5-1.6-7.4l-9.4-37.4c-2.3-9.4-3.5-19-3.5-28.7l0-4.4c0-44.2 35.8-80 80-80s80 35.8 80 80l0 4.4c0 9.7-1.2 19.3-3.5 28.7l-9.4 37.4c-2.1 8.2-3.1 16.7-3.1 25.2l0 1c0 12.5 2.2 24.8 6.6 36.5L563 288.9c8.6 23 13 47.4 13 72c0 29.3-6.3 58.2-18.4 84.8L536 493.2c-5.2 11.4-16.6 18.8-29.1 18.8l-85.7 0c-12.6 0-23.9-7.3-29.1-18.8l-10.6-23.3c12.6-13.1 23.7-27.7 33-43.4l17 37.5 65.1 0 17.4-38.3c9.3-20.4 14.1-42.5 14.1-64.9c0-18.8-3.4-37.5-10-55.1l-28.3-75.5c-2.7-7.2-4.9-14.6-6.4-22.2l-38.5 0c-1.6 7.5-3.7 14.9-6.4 22.2zM168 196a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm28 60a28 28 0 1 1 0 56 28 28 0 1 1 0-56zM96 244a28 28 0 1 1 56 0 28 28 0 1 1 -56 0zm272 60A160 160 0 1 0 48 304a160 160 0 1 0 320 0zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304z"]
};
const faBellSchoolSlash = {
  prefix: 'far',
  iconName: 'bell-school-slash',
  icon: [640, 512, [], "f5d6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L570.7 422c3.4-6.6 5.3-14.1 5.3-22c0-26.5-21.5-48-48-48c-12.1 0-23.1 4.5-31.5 11.8L445 323.5c22.1-33 35-72.8 35-115.5C480 93.1 386.9 0 272 0C211.2 0 156.6 26.1 118.5 67.6L38.8 5.1zM156.5 97.3C185.6 66.9 226.6 48 272 48c88.4 0 160 71.6 160 160c0 31.6-9.1 61-24.9 85.8L356.3 254c7.5-13.7 11.7-29.3 11.7-46c0-53-43-96-96-96c-25 0-47.7 9.5-64.8 25.1L156.5 97.3zm161 126.2l-71.3-55.9c7.5-4.8 16.4-7.6 25.9-7.6c26.5 0 48 21.5 48 48c0 5.4-.9 10.6-2.6 15.5zM467.1 464L414 464c1.3-5.1 2-10.5 2-16l0-24.2-85-67C312.7 364 292.8 368 272 368c-88.4 0-160-71.6-160-160c0-7.6 .5-15.2 1.6-22.5l-42-33.1C66.6 170.1 64 188.7 64 208c0 59 24.6 112.2 64 150.1l0 89.9c0 35.3 28.7 64 64 64l144 0 16 0 128 0c13.1 0 25.3-3.5 35.9-9.6L467.1 464zM336 464l-144 0c-8.8 0-16-7.2-16-16l0-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4l0 55.4c0 8.8-7.2 16-16 16l-16 0z"]
};
const faPlusLarge = {
  prefix: 'far',
  iconName: 'plus-large',
  icon: [512, 512, [], "e59e", "M488 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208 208 0z"]
};
const faMoneyBillWheat = {
  prefix: 'far',
  iconName: 'money-bill-wheat',
  icon: [512, 512, [], "e52a", "M176 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zM56 16C42.7 16 32 26.7 32 40s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 16zM24 88C10.7 88 0 98.7 0 112s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 88zm8 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM272 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80c-8.8 0-16 7.2-16 16zM400 0c-8.8 0-16 7.2-16 16c0 44.2 35.8 80 80 80c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80zm80 144c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM352 128c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80c0-8.8-7.2-16-16-16zm-96 16c0-8.8-7.2-16-16-16c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16c44.2 0 80-35.8 80-80zM48 359.5c28.9-3.6 51.9-26.6 55.5-55.5l305 0c3.6 29 26.6 51.9 55.5 55.5l0 49c-29 3.6-51.9 26.6-55.5 55.5l-305 0c-3.6-29-26.6-51.9-55.5-55.5l0-49zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zM256 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faCameraViewfinder = {
  prefix: 'far',
  iconName: 'camera-viewfinder',
  icon: [512, 512, ["screenshot"], "e0da", "M56 0l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48c-4.4 0-8 3.6-8 8l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0zM376 0l80 0c30.9 0 56 25.1 56 56l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-4.4-3.6-8-8-8l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM48 376l0 80c0 4.4 3.6 8 8 8l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-30.9 0-56-25.1-56-56l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm464 0l0 80c0 30.9-25.1 56-56 56l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c4.4 0 8-3.6 8-8l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zM173.8 120.2c6.3-14.7 20.8-24.2 36.8-24.2l90.9 0c16 0 30.5 9.5 36.8 24.2l3.3 7.8 10.5 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l10.5 0 3.3-7.8zm42 23.8l-7.5 17.5c-3.8 8.8-12.5 14.5-22.1 14.5L160 176c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-26.3 0c-9.6 0-18.3-5.7-22.1-14.5L296.2 144l-80.3 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
const faScreenshot = faCameraViewfinder;
const faMessageMusic = {
  prefix: 'far',
  iconName: 'message-music',
  icon: [512, 512, ["comment-alt-music"], "f8af", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM352 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faCommentAltMusic = faMessageMusic;
const faCarBuilding = {
  prefix: 'far',
  iconName: 'car-building',
  icon: [640, 512, [], "f859", "M288 48L64 48c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l128 0 0 48L64 480c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 64.5c-17.5 1.7-33.9 7.7-48 17.1L304 64c0-8.8-7.2-16-16-16zM256 219.1l-13.1 36.6c-.9 .2-1.9 .3-2.9 .3l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 11.1zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM208 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm265.8-96c-10.1 0-19.2 6.4-22.6 15.9L322.1 272l219.9 0-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9l-140.3 0zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8l140.3 0c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368l0 32 0 16 0 32 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-320 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40 0-32 0-16 0-32c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320l-224 0c-26.5 0-48 21.5-48 48l0 32 320 0 0-32c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faBorderBottomRight = {
  prefix: 'far',
  iconName: 'border-bottom-right',
  icon: [448, 512, ["border-style-alt"], "f854", "M448 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 352c0 13.3-10.7 24-24 24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l352 0c39.8 0 72-32.2 72-72l0-352zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faBorderStyleAlt = faBorderBottomRight;
const faOctagon = {
  prefix: 'far',
  iconName: 'octagon',
  icon: [512, 512, [128721], "f306", "M170.5 57.4c6-6 14.1-9.4 22.6-9.4l125.7 0c8.5 0 16.6 3.4 22.6 9.4L454.6 170.5c6 6 9.4 14.1 9.4 22.6l0 125.7c0 8.5-3.4 16.6-9.4 22.6L341.5 454.6c-6 6-14.1 9.4-22.6 9.4l-125.7 0c-8.5 0-16.6-3.4-22.6-9.4L57.4 341.5c-6-6-9.4-14.1-9.4-22.6l0-125.7c0-8.5 3.4-16.6 9.4-22.6L170.5 57.4zM136.6 23.4L23.4 136.6C8.4 151.6 0 171.9 0 193.1L0 318.9c0 21.2 8.4 41.6 23.4 56.6L136.6 488.6c15 15 35.4 23.4 56.6 23.4l125.7 0c21.2 0 41.6-8.4 56.6-23.4L488.6 375.4c15-15 23.4-35.4 23.4-56.6l0-125.7c0-21.2-8.4-41.6-23.4-56.6L375.4 23.4C360.4 8.4 340.1 0 318.9 0L193.1 0c-21.2 0-41.6 8.4-56.6 23.4z"]
};
const faCommentArrowUpRight = {
  prefix: 'far',
  iconName: 'comment-arrow-up-right',
  icon: [512, 512, [], "e145", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM200 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-87 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0z"]
};
const faOctagonDivide = {
  prefix: 'far',
  iconName: 'octagon-divide',
  icon: [512, 512, [], "e203", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17l0 129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5l0-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1l129 0c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9l0 129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1l-129 0c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7l129 0c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17l0-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7l-129 0zM256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faCookie = {
  prefix: 'far',
  iconName: 'cookie',
  icon: [512, 512, [127850], "f563", "M240.5 64.6c-12-1.7-24.3 .5-35.1 6.2l-74 39.5C120.7 116 112 125 106.6 136L69.9 211.6c-5.4 11-7.1 23.5-5 35.6L79.4 330c2.1 12.1 8 23.2 16.8 31.7l60.3 58.4c8.8 8.5 20 14 32 15.7l83 11.7c12 1.7 24.3-.5 35.1-6.2l74-39.5C391.3 396 400 387 405.4 376l36.7-75.5c5.4-11 7.1-23.5 5-35.6L432.6 182c-2.1-12.1-8-23.2-16.8-31.7L355.5 91.9c-8.8-8.5-20-14-32-15.7l-83-11.7zM182.8 28.4c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1 .7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5c-19.7 10.5-42.3 14.5-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7L62.8 396.2C46.8 380.6 36 360.3 32.2 338.3L17.6 255.5c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM288 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faArrowRotateLeft = {
  prefix: 'far',
  iconName: 'arrow-rotate-left',
  icon: [512, 512, [8634, "arrow-left-rotate", "arrow-rotate-back", "arrow-rotate-backward", "undo"], "f0e2", "M40 224c-13.3 0-24-10.7-24-24L16 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80.1 20-23.5C125 63.4 186.9 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-50.4 0-97-16.7-134.4-44.8c-10.6-8-12.7-23-4.8-33.6s23-12.7 33.6-4.8C179.8 418.9 216.3 432 256 432c97.2 0 176-78.8 176-176s-78.8-176-176-176c-54.3 0-102.9 24.6-135.2 63.4l-.1 .2s0 0 0 0L93.1 176l90.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 224z"]
};
const faArrowLeftRotate = faArrowRotateLeft;
const faArrowRotateBack = faArrowRotateLeft;
const faArrowRotateBackward = faArrowRotateLeft;
const faUndo = faArrowRotateLeft;
const faTvMusic = {
  prefix: 'far',
  iconName: 'tv-music',
  icon: [640, 512, [], "f8e6", "M576 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l512 0zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM96 488c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-13.3 0-24 10.7-24 24zM416 96c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faHardDrive = {
  prefix: 'far',
  iconName: 'hard-drive',
  icon: [512, 512, [128436, "hdd"], "f0a0", "M64 80c-8.8 0-16 7.2-16 16l0 162c5.1-1.3 10.5-2 16-2l384 0c5.5 0 10.9 .7 16 2l0-162c0-8.8-7.2-16-16-16L64 80zM48 320l0 96c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L64 304c-8.8 0-16 7.2-16 16zM0 320L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 224 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faHdd = faHardDrive;
const faReel = {
  prefix: 'far',
  iconName: 'reel',
  icon: [448, 512, [], "e238", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l40 0 0 40c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L384 0 344 0 104 0 64 0 24 0zm80 72l0-24 240 0 0 24L104 72zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0 240 0 40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24L88 400c-13.3 0-24 10.7-24 24l0 40-40 0zm320 0l-240 0 0-24 240 0 0 24zM80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 144zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 208zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 272zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 336z"]
};
const faFaceGrinSquintTears = {
  prefix: 'far',
  iconName: 'face-grin-squint-tears',
  icon: [512, 512, [129315, "grin-squint-tears"], "f586", "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"]
};
const faGrinSquintTears = faFaceGrinSquintTears;
const faDumbbell = {
  prefix: 'far',
  iconName: 'dumbbell',
  icon: [640, 512, [], "f44b", "M128 88c0-30.9 25.1-56 56-56l16 0c30.9 0 56 25.1 56 56l0 144 128 0 0-144c0-30.9 25.1-56 56-56l16 0c30.9 0 56 25.1 56 56l0 16 24 0c30.9 0 56 25.1 56 56l0 72 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 30.9-25.1 56-56 56l-24 0 0 16c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-144-128 0 0 144c0 30.9-25.1 56-56 56l-16 0c-30.9 0-56-25.1-56-56l0-16-24 0c-30.9 0-56-25.1-56-56l0-72-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-72c0-30.9 25.1-56 56-56l24 0 0-16zm48 16l0 24 0 256 0 24 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-336c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 16zm-48 48l-24 0c-4.4 0-8 3.6-8 8l0 192c0 4.4 3.6 8 8 8l24 0 0-208zM464 384l0-256 0-24 0-16c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 0-24zm72-24c4.4 0 8-3.6 8-8l0-192c0-4.4-3.6-8-8-8l-24 0 0 208 24 0z"]
};
const faRectangleList = {
  prefix: 'far',
  iconName: 'rectangle-list',
  icon: [576, 512, ["list-alt"], "f022", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faListAlt = faRectangleList;
const faTarpDroplet = {
  prefix: 'far',
  iconName: 'tarp-droplet',
  icon: [576, 512, [], "e57c", "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128l133.5 0c7 19.8 20.3 36.6 37.5 48L64 176c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l352 0 0-80c0-17.7 14.3-32 32-32l80 0 0-160c0-8.8-7.2-16-16-16l-170.9 0c17.2-11.4 30.5-28.2 37.5-48L512 128c35.3 0 64 28.7 64 64l0 172.1c0 12.7-5.1 24.9-14.1 33.9l-99.9 99.9c-9 9-21.2 14.1-33.9 14.1L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64zm48 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faAlarmExclamation = {
  prefix: 'far',
  iconName: 'alarm-exclamation',
  icon: [512, 512, [], "f843", "M14.9 146.4C5.5 131.6 0 114 0 95.2C0 42.6 42.6 0 95.2 0c25 0 47.8 9.6 64.8 25.4L14.9 146.4zM432 288A176 176 0 1 0 80 288a176 176 0 1 0 352 0zM396.5 462.5C358.1 493.4 309.2 512 256 512s-102.1-18.6-140.5-49.5L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l42.5-42.5C50.6 390.1 32 341.2 32 288C32 164.3 132.3 64 256 64s224 100.3 224 224c0 53.2-18.6 102.1-49.5 140.5L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-42.5-42.5zM352 25.4C369 9.6 391.8 0 416.8 0C469.4 0 512 42.6 512 95.2c0 18.8-5.5 36.3-14.9 51.1L352 25.4zM256 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24-168l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHouseMedicalCircleCheck = {
  prefix: 'far',
  iconName: 'house-medical-circle-check',
  icon: [640, 512, [], "e511", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm32 112a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faTrafficCone = {
  prefix: 'far',
  iconName: 'traffic-cone',
  icon: [512, 512, [], "f636", "M217.8 15c3.7-9 12.5-15 22.2-15l32 0c9.8 0 18.6 5.9 22.2 15L476.9 464l11.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l11.1 0L217.8 15zM386 368l-260 0L86.9 464l338.1 0-39-96zm-19.5-48L320.9 208l-129.9 0L145.5 320l221 0zM210.6 160l90.8 0L256 48.4 210.6 160z"]
};
const faGrate = {
  prefix: 'far',
  iconName: 'grate',
  icon: [448, 512, [], "e193", "M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l72 0 96 0 96 0 72 0c30.9 0 56-25.1 56-56l0-168 0-168c0-30.9-25.1-56-56-56l-72 0-96 0-96 0L56 32zm48 48l0 152-56 0L48 88c0-4.4 3.6-8 8-8l48 0zM48 280l56 0 0 152-48 0c-4.4 0-8-3.6-8-8l0-144zM152 432l0-152 48 0 0 152-48 0zm96 0l0-152 48 0 0 152-48 0zm96 0l0-152 56 0 0 144c0 4.4-3.6 8-8 8l-48 0zm56-200l-56 0 0-152 48 0c4.4 0 8 3.6 8 8l0 144zM296 80l0 152-48 0 0-152 48 0zm-96 0l0 152-48 0 0-152 48 0z"]
};
const faArrowDownRight = {
  prefix: 'far',
  iconName: 'arrow-down-right',
  icon: [384, 512, [], "e093", "M328 416c13.3 0 24-10.7 24-24l0-240c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 182.1L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l231 231L88 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0z"]
};
const faPersonSkiingNordic = {
  prefix: 'far',
  iconName: 'person-skiing-nordic',
  icon: [576, 512, ["skiing-nordic"], "f7ca", "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8c1.2 1.5 2.6 2.7 4.1 3.8L67 464l-43 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l287.5 0c.4 0 .7 0 1.1 0L504 512c39.8 0 72-32.2 72-72l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 13.3-10.7 24-24 24l-69.4 0 27.2-176.7c10.4-2.6 18.2-12 18.2-23.3c0-13.3-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zM429.4 288L402.3 464l-57.6 0L371 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C361.3 272 383 288 407.6 288l21.7 0zM99.7 464l55.8-265.1 40.6-34.8c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L294.4 464l-103.7 0 36.8-109.8-8-4.5c-13.1-7.4-23.6-17.6-31.2-29.6L140.1 464l-40.3 0zM316.1 175.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L289 169l27.1 6.8z"]
};
const faSkiingNordic = faPersonSkiingNordic;
const faCalendarPlus = {
  prefix: 'far',
  iconName: 'calendar-plus',
  icon: [448, 512, [], "f271", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm176 40c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"]
};
const faPersonFromPortal = {
  prefix: 'far',
  iconName: 'person-from-portal',
  icon: [512, 512, ["portal-exit"], "e023", "M72.2 436C58.7 404.6 48 348.4 48 256s10.7-148.6 24.2-180C84.6 47.3 94.6 47.9 95.9 48l.1 0 .1 0c1.3-.1 11.3-.7 23.7 28c13.5 31.4 24.2 87.7 24.2 180c0 45.7-2.6 82.6-6.9 112L120 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l7 0s0 0 0 0l49.7 0s0 0 0 0l28.2 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6L199.4 368l-13.8 0c4.2-31.3 6.4-68.4 6.4-112c0-21.4-.5-41.2-1.6-59.6l37.7-32.4c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L184.7 138C170.3 38 136 0 96 0C43 0 0 66.6 0 256S43 512 96 512c28 0 53.2-18.6 70.7-64l-52.9 0c-9.5 16.5-16.7 16.1-17.8 16l-.1 0-.1 0c-1.3 .1-11.3 .7-23.7-28zM368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-19.9 79.8l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8z"]
};
const faPortalExit = faPersonFromPortal;
const faPlaneArrival = {
  prefix: 'far',
  iconName: 'plane-arrival',
  icon: [640, 512, [128748], "f5af", "M552.2 333.2c4.3 4 2.8 11.1-2.8 12.9c-26.5 8.8-54.9 9.7-81.9 2.6L141.9 264c-1.2-.3-2.3-.9-3.2-1.7l-87.7-75c-1.8-1.5-2.8-3.7-2.8-6.1l-.2-86.6 18.2 4.6c2.5 .6 4.5 2.4 5.5 4.8l25.9 64.8c2.8 7 8.8 12.3 16.1 14.3l113.9 30.4c8.4 2.2 17.4-.2 23.4-6.5s8.3-15.3 5.8-23.6L216.3 48 242 48 349.1 238.4c3.2 5.6 8.5 9.8 14.7 11.4l113 30.1c16.3 4.3 31.3 12.6 43.7 24l31.6 29.2zm12.3 58.5c40.3-13.3 51.5-65 20.3-93.8l-31.6-29.2c-18.1-16.7-40-28.8-63.8-35.1L386 206.1 281.5 20.4C274.4 7.8 261.1 0 246.6 0L205.5 0c-26.8 0-46 25.8-38.3 51.5l31.4 104.6-60.8-16.2L116.4 86.3c-6.7-16.7-21-29.2-38.4-33.5L49.7 45.7C24.5 39.4 0 58.5 0 84.6l.2 96.8s0 0 0 0c0 16.3 7.2 31.8 19.6 42.4l87.7 75c6.4 5.5 14.1 9.5 22.3 11.6l325.5 84.7c35.9 9.4 73.8 8.1 109.1-3.5zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464zm168-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCowbellCirclePlus = {
  prefix: 'far',
  iconName: 'cowbell-circle-plus',
  icon: [576, 512, ["cowbell-more"], "f8b4", "M176 48l96 0 0 48-96 0 0-48zm-48-8l0 56-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l214.6 0c-4.3-15.3-6.6-31.4-6.6-48L48 368l64-224 224 0 18.8 65.8c14.2-7 29.6-12.1 45.6-15l-18.3-64C376.3 110.2 357.4 96 336 96l-16 0 0-56c0-22.1-17.9-40-40-40L168 0c-22.1 0-40 17.9-40 40zm32 408c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6L160 448zm272 64a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faCowbellMore = faCowbellCirclePlus;
const faCircleLeft = {
  prefix: 'far',
  iconName: 'circle-left',
  icon: [512, 512, [61840, "arrow-alt-circle-left"], "f359", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3l0-57.7 96 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-96 0 0-57.7c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"]
};
const faArrowAltCircleLeft = faCircleLeft;
const faDistributeSpacingVertical = {
  prefix: 'far',
  iconName: 'distribute-spacing-vertical',
  icon: [512, 512, [], "e366", "M0 56C0 69.3 10.7 80 24 80l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32C10.7 32 0 42.7 0 56zM368 208l0 96-224 0 0-96 224 0zM144 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-224 0zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faSignalBarsFair = {
  prefix: 'far',
  iconName: 'signal-bars-fair',
  icon: [640, 512, ["signal-alt-2"], "f692", "M240 304c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm-64 16c0-35.3 28.7-64 64-64s64 28.7 64 64l0 128c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-128zM80 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64-16A64 64 0 1 1 16 448a64 64 0 1 1 128 0z"]
};
const faSignalAlt2 = faSignalBarsFair;
const faSportsball = {
  prefix: 'far',
  iconName: 'sportsball',
  icon: [512, 512, [], "e44b", "M447 99c3.8 33.4 4.4 70.2-.1 107c-25.6-8.1-49.2-20.8-69.7-37.2L447 99zm-9 154.5c-7.2 28-17.9 55.2-33 79.8c-4.7 7.7-9.9 15.1-15.5 22.3L289.9 256l53.1-53.1c27.5 22.9 59.7 40.3 94.9 50.6zM356.1 390.1c-19.4 16.1-42.4 29.6-69.7 39.8c-10.2 3.8-21 7.1-32.4 9.9c-10.2-35.9-27.8-68.7-51.1-96.7L256 289.9 356.1 390.1zM206.3 447.8c-31.5 3.2-67 3-106.9-1.3l69.3-69.3c16.6 20.8 29.5 44.6 37.5 70.6zM22.9 455.2s0 0 0 0c.5 2.7 1 5.3 1.6 7.9c1.6 7.5 5.7 14 11.4 18.6c4.2 3.3 9.2 5.6 14.6 6.5c103.9 17.4 187 11 252.6-13.3c66-24.5 112.2-66.5 142.9-116.5c60.2-98.2 59.1-224.7 41.6-309.5c-1.5-7.1-5.2-13.3-10.5-17.8c-.7-.6-1.5-1.3-2.3-1.8c-3.9-2.8-8.4-4.7-13.3-5.5c-2.1-.3-4.2-.7-6.2-1c0 0 0 0 0 0C395.7 13.3 343 11.7 296.6 16.9c0 0 0 0 0 0c-16.6 1.9-32.4 4.6-47.5 8.1c0 0 0 0 0 0c-14.1 3.3-27.5 7.4-40.3 12.1c-34.1 12.7-63 30-87.1 50.7c0 0 0 0 0 0C109.4 98.5 98.3 110 88.3 122.2c0 0 0 0 0 0c-8.2 10-15.6 20.5-22.2 31.4c-18.4 29.9-31 62.5-39.2 95.7c0 0 0 0 0 0c-3.9 15.7-6.8 31.6-8.8 47.4c0 0 0 0 0 0c-7.4 56.9-3.6 113 4.9 158.4zM65 413c-3.8-33.4-4.4-70.2 .1-107c25.6 8.1 49.2 20.8 69.7 37.2L65 413zm9-154.5c7.2-28 17.9-55.2 33-79.8c4.7-7.7 9.9-15.1 15.5-22.3L222.1 256l-53.1 53.1c-27.5-22.9-59.7-40.3-94.9-50.6zm81.9-136.6c19.4-16.1 42.4-29.6 69.7-39.8c10.2-3.8 21-7.1 32.4-9.9c10.2 35.9 27.8 68.7 51.1 96.7L256 222.1 155.9 121.9zM305.7 64.2c31.5-3.2 67-3 106.9 1.3l-69.3 69.3c-16.6-20.8-29.5-44.6-37.5-70.6z"]
};
const faGameConsoleHandheldCrank = {
  prefix: 'far',
  iconName: 'game-console-handheld-crank',
  icon: [576, 512, [], "e5b9", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 176 32 0 0-72 0-32c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24l-56 0 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm16 160c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zm120 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faTrainSubway = {
  prefix: 'far',
  iconName: 'train-subway',
  icon: [448, 512, ["subway"], "f239", "M200 48l0 160L48 208 48 96c0-26.5 21.5-48 48-48l104 0zm48 0l104 0c26.5 0 48 21.5 48 48l0 112-152 0 0-160zM48 352l0-96 352 0 0 96c0 26.5-21.5 48-48 48L96 400c-26.5 0-48-21.5-48-48zM96 0C43 0 0 43 0 96L0 352c0 42.8 28 79 66.6 91.4L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 188.1 0 57 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6C420 431 448 394.8 448 352l0-256c0-53-43-96-96-96L96 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faSubway = faTrainSubway;
const faChartGantt = {
  prefix: 'far',
  iconName: 'chart-gantt',
  icon: [512, 512, [], "e0e4", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm88 72l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faFaceSmileUpsideDown = {
  prefix: 'far',
  iconName: 'face-smile-upside-down',
  icon: [512, 512, [], "e395", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM177.6 193.9C192.8 177.5 218.8 160 256 160s63.2 17.5 78.4 33.9c9 9.7 24.2 10.4 33.9 1.4s10.4-24.2 1.4-33.9c-22-23.8-60-49.4-113.6-49.4s-91.7 25.5-113.6 49.4c-9 9.7-8.4 24.9 1.4 33.9s24.9 8.4 33.9-1.4zM208.4 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faBallPile = {
  prefix: 'far',
  iconName: 'ball-pile',
  icon: [576, 512, [], "f77e", "M336 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48 0c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96zm-96 96c-9.9 0-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zm0 64c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256zM144 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM336 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm48-112a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM528 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faBadgeDollar = {
  prefix: 'far',
  iconName: 'badge-dollar',
  icon: [512, 512, [], "f645", "M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zm20.9 140.4c0-11-9-20-20-20s-20 9-20 20l0 17.4c-8.8 1.8-17.7 4.8-25.7 9.6c-15 8.9-27.7 24.4-27.6 46.9c.1 21.5 12.6 35.1 26.3 43.4c11.9 7.2 27 11.7 39.1 15.4l1.9 .6c13.9 4.2 24.4 7.6 31.7 12.2c6.1 3.8 7.5 6.8 7.6 11c.1 6.5-2.5 10.4-7.6 13.6c-6 3.7-15.2 5.9-25.1 5.6c-12.7-.4-24.6-4.4-39.7-9.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-2.6-.9-5.2-1.8-8-2.7c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c2.2 .7 4.5 1.5 6.8 2.3c9.7 3.3 20.9 7.2 32.8 9.6l0 18c0 11 9 20 20 20s20-9 20-20l0-17.1c9.3-1.7 18.6-4.9 26.8-10.1c15.3-9.5 26.8-25.7 26.5-48.1c-.3-21.6-12.4-35.6-26.3-44.3c-12.5-7.9-28.3-12.6-40.8-16.4l-.6-.2c-14.1-4.3-24.6-7.5-31.9-11.9c-6.2-3.7-7-6.3-7-9.3c0-5.1 2.1-8.8 7.9-12.3c6.5-3.8 16-6 25-5.8c10.9 .2 22.9 2.6 35.2 5.8c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-7.8-2.1-16.3-4.1-25.1-5.4l0-17.3z"]
};
const faMoneyBillsSimple = {
  prefix: 'far',
  iconName: 'money-bills-simple',
  icon: [640, 512, ["money-bills-alt"], "e1f4", "M576 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l416 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM448 208a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 360c0 66.3 53.7 120 120 120l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-400 0c-39.8 0-72-32.2-72-72l0-240z"]
};
const faMoneyBillsAlt = faMoneyBillsSimple;
const faListTimeline = {
  prefix: 'far',
  iconName: 'list-timeline',
  icon: [512, 512, [], "e1d1", "M219.9 112L400 112l0-32L219.9 80l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L416 32c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm187.9 16L400 432l0-32-180.1 0-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L416 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-202.7 0c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM203.9 256l16 16L464 272l0-32-244.1 0-16 16zm-13.3 54.6l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4L480 192c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-266.7 0c-8.5 0-16.6-3.4-22.6-9.4z"]
};
const faIndianRupeeSign = {
  prefix: 'far',
  iconName: 'indian-rupee-sign',
  icon: [320, 512, ["indian-rupee", "inr"], "e1bc", "M0 56C0 42.7 10.7 32 24 32l80 0 192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84.7 0c17.7 19.8 30.1 44.6 34.7 72l50 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-50 0c-11.4 68.1-70.7 120-142 120l-5.1 0L262 436.5c10.8 7.7 13.3 22.7 5.6 33.5s-22.7 13.3-33.5 5.6l-224-160C1.6 309.5-2 298.6 1.1 288.7S13.6 272 24 272l80 0c44.7 0 82.3-30.6 93-72L24 200c-13.3 0-24-10.7-24-24s10.7-24 24-24l173 0c-10.7-41.4-48.2-72-93-72L24 80C10.7 80 0 69.3 0 56z"]
};
const faIndianRupee = faIndianRupeeSign;
const faInr = faIndianRupeeSign;
const faCropSimple = {
  prefix: 'far',
  iconName: 'crop-simple',
  icon: [512, 512, ["crop-alt"], "f565", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 56L24 80C10.7 80 0 90.7 0 104s10.7 24 24 24l56 0 0 248c0 30.9 25.1 56 56 56l216 0 0-48-216 0c-4.4 0-8-3.6-8-8l0-352zM384 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-248c0-30.9-25.1-56-56-56L160 80l0 48 216 0c4.4 0 8 3.6 8 8l0 352z"]
};
const faCropAlt = faCropSimple;
const faMoneyBill1 = {
  prefix: 'far',
  iconName: 'money-bill-1',
  icon: [576, 512, ["money-bill-alt"], "f3d1", "M112 112c0 35.3-28.7 64-64 64l0 160c35.3 0 64 28.7 64 64l352 0c0-35.3 28.7-64 64-64l0-160c-35.3 0-64-28.7-64-64l-352 0zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faMoneyBillAlt = faMoneyBill1;
const faLeftLong = {
  prefix: 'far',
  iconName: 'left-long',
  icon: [512, 512, ["long-arrow-alt-left"], "f30a", "M6.5 272.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 33.7 248 0c30.9 0 56 25.1 56 56l0 48c0 30.9-25.1 56-56 56l-248 0 0 33.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6L6.5 272.4zm153.5 93l0-53.5c0-13.3 10.7-24 24-24l272 0c4.4 0 8-3.6 8-8l0-48c0-4.4-3.6-8-8-8l-272 0c-6.4 0-12.5-2.5-17-7s-7-10.6-7-17l0-53.5L57 256 160 365.5z"]
};
const faLongArrowAltLeft = faLeftLong;
const faKeyboardDown = {
  prefix: 'far',
  iconName: 'keyboard-down',
  icon: [576, 512, [], "e1c2", "M64 48c-8.8 0-16 7.2-16 16l0 176c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-176c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 176c0 35.3-28.7 64-64 64L64 304c-35.3 0-64-28.7-64-64L0 64zM159 359c9.4-9.4 24.6-9.4 33.9 0l95 95 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L305 505c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L159 393c-9.4-9.4-9.4-24.6 0-33.9zm1-167c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16zM120 88l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm96-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm96-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"]
};
const faCircleUpRight = {
  prefix: 'far',
  iconName: 'circle-up-right',
  icon: [512, 512, [], "e129", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm96 313.4c0 12.5-10.1 22.6-22.6 22.6c-6 0-11.8-2.4-16-6.6L280 296l-66.3 66.3C210 366 205.1 368 200 368s-10-2-13.7-5.7l-36.7-36.7C146 322 144 317.1 144 312s2-10 5.7-13.7L216 232l-33.4-33.4c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6L336 160c8.8 0 16 7.2 16 16l0 137.4z"]
};
const faCloudBoltMoon = {
  prefix: 'far',
  iconName: 'cloud-bolt-moon',
  icon: [576, 512, ["thunderstorm-moon"], "f76d", "M361.4 79.9c31.2 18.7 52.5 52.2 54.3 90.8c33.3 15.8 57.6 47.5 63 85.3c.8 0 1.6 0 2.4 0c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C427.1 0 380.6 33 361.4 79.9zM128.1 160c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0l-72.1 0-8 16.1 18.3 0c20.3 0 38.4 12.8 45.2 31.9l16.1 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3C374.9 126.9 339.1 96 296.1 96c-14.7 0-28.5 3.6-40.6 9.9C238.1 80.6 209.1 64 176.1 64c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 169 .1 208.5 .1 256c0 43.4 28.8 80 68.3 91.9c3.1-6.6 7.6-12.6 13.6-17.4l33.3-26.6-16.4 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm154 67.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7l70.1 0L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7l-70.1 0 52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"]
};
const faThunderstormMoon = faCloudBoltMoon;
const faTurnLeftUp = {
  prefix: 'far',
  iconName: 'turn-left-up',
  icon: [384, 512, [], "e638", "M208.4 6.5c-9.2-8.7-23.7-8.7-32.9 0L46.6 127.9c-9.3 8.8-14.6 21-14.6 33.7C32 187.3 52.7 208 78.3 208l41.7 0 0 144c0 88.4 71.6 160 160 160l48 0c30.9 0 56-25.1 56-56l0-32c0-30.9-25.1-56-56-56l-56 0c-4.4 0-8-3.6-8-8l0-152 41.7 0c25.6 0 46.3-20.7 46.3-46.3c0-12.8-5.3-25-14.6-33.7L208.4 6.5zm93 153.5L240 160c-13.3 0-24 10.7-24 24l0 176c0 30.9 25.1 56 56 56l56 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8-8 8l-48 0c-61.9 0-112-50.1-112-112l0-168c0-13.3-10.7-24-24-24l-61.5 0L192 57 301.5 160z"]
};
const faDna = {
  prefix: 'far',
  iconName: 'dna',
  icon: [448, 512, [129516], "f471", "M416 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 2.7-.1 5.4-.2 8L80.2 32c-.2-2.6-.2-5.3-.2-8C80 10.7 69.3 0 56 0S32 10.7 32 24c0 55.6 24.5 101.9 58.1 141.9c27.2 32.4 61.5 62 95.8 90.1c-34.3 28.1-68.6 57.7-95.8 90.1C56.5 386.1 32 432.4 32 488c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.7 .1-5.4 .2-8l287.5 0c.2 2.6 .2 5.3 .2 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-55.6-24.5-101.9-58.1-141.9c-20.6-24.5-45.2-47.3-70.8-69.2c-8.7 7.1-17.3 14.1-25.7 20.9c0 0 0 0 0 0l-2.2 1.8c-3.4 2.7-6.7 5.5-10.1 8.1c11.2 9.4 22.1 18.8 32.3 28.3l-115 0c22-20.4 46.7-40.4 72.2-61c.3-.2 .5-.4 .8-.6l.7-.6c41.3-33.4 84.7-68.6 117.7-107.9C391.5 125.9 416 79.6 416 24zM121.1 384l205.8 0c12.4 15.7 22.4 31.6 29.4 48L91.7 432c7-16.4 17-32.3 29.4-48zM91.7 80l264.5 0c-7 16.4-17 32.3-29.4 48l-205.8 0c-12.4-15.7-22.4-31.6-29.4-48zm189.8 96c-17.8 16.4-37.2 32.6-57.5 49.1c-20.3-16.5-39.7-32.7-57.5-49.1l115 0z"]
};
const faVirusSlash = {
  prefix: 'far',
  iconName: 'virus-slash',
  icon: [640, 512, [], "e075", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1l11.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zM220 147.1c39 4.3 78.6-14.2 100-47.6c23.3 36.4 68.4 55.1 110.6 45.8c-9.3 42.2 9.4 87.3 45.8 110.6c-21.2 13.6-36.4 34.5-43.6 58L220 147.1zM402 412.7l-44.6-35.1c-14.9 8.2-27.9 20.1-37.4 34.8c-23.3-36.4-68.4-55.1-110.6-45.8c9.3-42.2-9.4-87.3-45.8-110.6c7.1-4.5 13.6-9.9 19.2-16l-38.1-30c-9.5 8.5-22.2 14-37.2 14L96 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5c0 17.7 14.3 32 32 32s32-14.3 32-32l0-11.5c0-31.2 23.6-52.7 50-55.7z"]
};
const faBracketRoundRight = {
  prefix: 'far',
  iconName: 'bracket-round-right',
  icon: [192, 512, [], "29", "M35.4 43.7c-6.8 11.4-3 26.1 8.3 32.9C76.7 96.3 144 160.7 144 256s-67.3 159.7-100.3 179.4c-11.4 6.8-15.1 21.5-8.3 32.9s21.5 15.1 32.9 8.3C110 451.8 192 374.1 192 256S110 60.2 68.3 35.4c-11.4-6.8-26.1-3-32.9 8.3z"]
};
const faCircleSterling = {
  prefix: 'far',
  iconName: 'circle-sterling',
  icon: [512, 512, [], "e5cf", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm261.5-96c-16.8 0-30.4 13.7-30.3 30.5l.2 33.5 40.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40.3 0 .1 9.7c.1 18.6-3.1 37-9.6 54.3L328 320c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-8.4 0-16.1-4.4-20.5-11.5s-4.7-16-.8-23.5l9.6-18.6c7.7-14.9 11.6-31.5 11.5-48.3l-.1-10.1-7.7 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l7.5 0-.2-33.1c-.3-43.5 34.8-78.9 78.3-78.9c10 0 19.8 1.9 29.1 5.6l30.3 12.1c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2z"]
};
const faCircle5 = {
  prefix: 'far',
  iconName: 'circle-5',
  icon: [512, 512, [], "e0f2", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 128c-11.6 0-21.5 8.3-23.6 19.7l-16 88c-1.2 6.5 .4 13.3 4.4 18.6s10 8.8 16.6 9.5l86.9 9.8c15.8 1.8 27.8 15.2 27.8 31.1c0 17.3-14 31.3-31.3 31.3l-36 0c-11.5 0-22.3-5.7-28.8-15.3l-4.1-6.1c-7.4-11-22.3-13.9-33.3-6.5s-13.9 22.3-6.5 33.3l4.1 6.1c15.4 22.9 41.1 36.6 68.6 36.6l36 0c43.8 0 79.3-35.5 79.3-79.3c0-40.3-30.3-74.3-70.4-78.8L220.2 219l7.8-43 84 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0z"]
};
const faMinus = {
  prefix: 'far',
  iconName: 'minus',
  icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
};
const faSubtract = faMinus;
const faFireFlame = {
  prefix: 'far',
  iconName: 'fire-flame',
  icon: [384, 512, ["flame"], "f6df", "M209.1 8.5c72.9 68 128.7 152.4 162.7 246.1l.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9L57.3 271l-.7 1.9c-5.7 15.6-8.6 32.1-8.6 48.7C48 399.7 112.8 464 192 464s144-64.3 144-142.4c0-16.6-2.9-33.1-8.6-48.7l42.3-15.4-42.3 15.4-.7-1.9c-29-79.8-75-152.2-134.7-212.2C132.3 118.8 86.3 191.2 57.3 271L12.2 254.6C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3zM189.3 163.8c1.7-2.4 4.4-3.8 7.4-3.8c5 0 9.1 4.1 9.1 9.1l0 10.8c0 7.8 3.1 15.3 8.5 20.8l44.1 45.1c19 19.4 29.6 45.5 29.6 72.6l0 1.6c0 53-43 96-96 96s-96-43-96-96l0-11.4c0-18.4 6.6-36.3 18.6-50.3l6-7c1.8-2.1 4.4-3.3 7.1-3.3c5.2 0 9.4 4.2 9.4 9.4l0 40.9c0 20.8 16.9 37.7 37.7 37.7s37.7-16.9 37.7-37.7l0-1.5c0-10.2-3.9-19.9-11-27.3l-11-11.4c-12.3-12.8-19.2-29.8-19.2-47.5c0-14.4 4.5-28.4 13-40.1l4.9-6.7z"]
};
const faFlame = faFireFlame;
const faRightToLine = {
  prefix: 'far',
  iconName: 'right-to-line',
  icon: [448, 512, ["arrow-alt-to-right"], "f34c", "M192 146.2L302 256 192 365.8l0-53.8c0-13.3-10.7-24-24-24L48 288l0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM352 256c0-11.5-4.6-22.5-12.7-30.6L223.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L339.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM400 88l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faArrowAltToRight = faRightToLine;
const faGif = {
  prefix: 'far',
  iconName: 'gif',
  icon: [576, 512, [], "e190", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM296 160c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm56 24l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM128 256c0-26.5 21.5-48 48-48c8 0 15.4 1.9 22 5.3c11.8 6.1 26.3 1.5 32.3-10.3s1.5-26.3-10.3-32.3c-13.2-6.8-28.2-10.7-44-10.7c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8c7-4.4 11.2-12.1 11.2-20.3l0-51.9c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 13.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48z"]
};
const faChess = {
  prefix: 'far',
  iconName: 'chess',
  icon: [512, 512, [], "f439", "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16L96 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 0 32L66.9 96C43.2 96 24 115.2 24 138.9c0 4.7 .8 9.4 2.3 13.8l19.6 57.5C37.7 214.1 32 222.4 32 232c0 11.6 8.2 21.3 19.2 23.5L49.1 352l48 0 2.1-96 57.6 0 2.1 96 48 0-2.1-96.5c10.9-2.2 19.2-11.9 19.2-23.5c0-9.6-5.7-17.9-13.9-21.8l19.6-57.5c1.5-4.5 2.3-9.1 2.3-13.8c0-23.7-19.2-42.9-42.9-42.9L144 96l0-32 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-16zm16.2 192l-64.4 0L74 144l108 0-21.8 64zm-91 224l117.6 0 16.6 32L52.7 464l16.6-32zm-9.7-48c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512L192 512l23.2 0 80.5 0 24.2 0 152.2 0c22 0 39.8-17.8 39.8-39.8c0-6.8-1.7-13.4-5-19.3l-31.4-56.6c-4.2-7.6-12.3-12.3-21-12.3l-141.2 0c-8.7 0-16.7 4.7-21 12.3L261 452.9c-3.2 5.8-5 12.4-5 19.1c0 0 0 0 0 0c0-.2 0-.5 0-.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3l-137 0zM256 184l0 72c0 5 1.6 9.9 4.5 13.9L296 319.7l0 32.3 48 0 0-40c0-5-1.6-9.9-4.5-13.9L304 248.3l0-40.3 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 32 0 0 40.3-35.5 49.7c-2.9 4.1-4.5 8.9-4.5 13.9l0 40 48 0 0-32.3 35.5-49.7c2.9-4.1 4.5-8.9 4.5-13.9l0-72c0-13.3-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm53.8 280l17.8-32 112.9 0 17.8 32-148.5 0z"]
};
const faTrashSlash = {
  prefix: 'far',
  iconName: 'trash-slash',
  icon: [640, 512, [], "e2b3", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L491.3 359.8 508.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0L413.5 24.9C403.1 9.4 385.6 0 366.9 0L273.1 0c-18.7 0-36.2 9.4-46.6 24.9L189.8 80l-13.7 0-41.8 0L38.8 5.1zM195.6 128l264.7 0L445.8 324.1 195.6 128zM479.2 473.6l-42.1-33.1-.6 8.7c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L188.3 244.4l-51.1-40.3 18.4 248.6c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c26.1 0 48.8-15.7 58.7-38.4zM273.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6z"]
};
const faArrowLeftLong = {
  prefix: 'far',
  iconName: 'arrow-left-long',
  icon: [512, 512, ["long-arrow-left"], "f177", "M7 239c-9.4 9.4-9.4 24.6 0 33.9L143 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-95-95L488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 232l95-95c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239z"]
};
const faLongArrowLeft = faArrowLeftLong;
const faPlugCircleCheck = {
  prefix: 'far',
  iconName: 'plug-circle-check',
  icon: [576, 512, [], "e55c", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faFontCase = {
  prefix: 'far',
  iconName: 'font-case',
  icon: [640, 512, [], "f866", "M198.4 47.5C194.9 38.2 186 32 176 32s-18.9 6.2-22.4 15.5l-152 400c-4.7 12.4 1.5 26.3 13.9 31s26.3-1.5 31-13.9L83.1 368l185.8 0 36.7 96.5c4.7 12.4 18.6 18.6 31 13.9s18.6-18.6 13.9-31l-152-400zM250.7 320l-149.3 0L176 123.6 250.7 320zM616 160c-13.3 0-24 10.7-24 24l0 8.8c-22.1-20.4-51.6-32.8-84-32.8c-68.5 0-124 55.5-124 124l0 72c0 68.5 55.5 124 124 124c32.4 0 61.9-12.4 84-32.8l0 8.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272c0-13.3-10.7-24-24-24zM432 284c0-42 34-76 76-76s76 34 76 76l0 72c0 42-34 76-76 76s-76-34-76-76l0-72z"]
};
const faStreetView = {
  prefix: 'far',
  iconName: 'street-view',
  icon: [512, 512, [], "f21d", "M256 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 96A72 72 0 1 0 256 0a72 72 0 1 0 0 144zM192 280s0 0 0 0l0-40c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 40s0 0 0 0c-19.4 4.9-33.8 21.3-36 41.2l-6.2 55.6c-.5 4.1-3.9 7.1-8 7.1l-27.8 0c-4.1 0-7.5-3.1-8-7.1L228 321.3c-2.2-19.9-16.6-36.3-36-41.2zm-5.6 102.2c3.2 28.4 27.1 49.8 55.7 49.8l27.8 0c28.5 0 52.5-21.5 55.7-49.8l6.2-55.6c20.8-5.2 36.3-24.1 36.3-46.6l0-40c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l0 40c0 22.5 15.4 41.3 36.3 46.6l6.2 55.6zm-54.1 12c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"]
};
const faArrowDownLeft = {
  prefix: 'far',
  iconName: 'arrow-down-left',
  icon: [384, 512, [], "e091", "M56 416c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1L311 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-231 231L296 368c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 416z"]
};
const faFrancSign = {
  prefix: 'far',
  iconName: 'franc-sign',
  icon: [320, 512, [], "e18f", "M72 32C58.7 32 48 42.7 48 56l0 160 0 104-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 320l0-80 168 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 192 96 80l200 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faFlaskRoundPoison = {
  prefix: 'far',
  iconName: 'flask-round-poison',
  icon: [448, 512, ["flask-poison"], "f6e0", "M176 48l96 0 0 109.7c0 24.3 13.5 44.9 32.3 55.9C352.1 241.4 384 293 384 352c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7l-219.6 0c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352c0-59 31.9-110.6 79.7-138.4c18.8-11 32.3-31.6 32.3-55.9L176 48zM320 157.7L320 48l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L304 0 144 0 120 0C106.7 0 96 10.7 96 24s10.7 24 24 24l8 0 0 109.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9c-5.2-3-8.5-8.4-8.5-14.4zM286.8 378.4c15.6-13 25.2-30.8 25.2-50.4c0-39.8-39.4-72-88-72s-88 32.2-88 72c0 19.6 9.6 37.4 25.2 50.4c4.1 3.4 6.8 8.3 6.8 13.6l0 8c0 8.8 7.2 16 16 16l80 0c8.8 0 16-7.2 16-16l0-8c0-5.3 2.7-10.2 6.8-13.6zM192 312a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faFlaskPoison = faFlaskRoundPoison;
const faVolumeOff = {
  prefix: 'far',
  iconName: 'volume-off',
  icon: [320, 512, [], "f026", "M272 102.3L159.9 201.9c-4.4 3.9-10.1 6.1-15.9 6.1l-88 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l88 0c5.9 0 11.6 2.2 15.9 6.1L272 409.7l0-307.3zm-1.6-62.8c5.5-4.8 12.5-7.5 19.8-7.5C306.7 32 320 45.3 320 61.8l0 388.4c0 16.5-13.3 29.8-29.8 29.8c-7.3 0-14.3-2.7-19.8-7.5L134.9 352 56 352c-30.9 0-56-25.1-56-56l0-80c0-30.9 25.1-56 56-56l78.9 0L270.4 39.5z"]
};
const faBookCircleArrowRight = {
  prefix: 'far',
  iconName: 'book-circle-arrow-right',
  icon: [640, 512, [], "e0bc", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l314.8 0c-18.3-12.9-34.1-29.2-46.3-48L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l242.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-5.4 .2-10.7 .7-16L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 164.5c14.6-9.5 30.8-17 48-21.8L448 56c0-30.9-25.1-56-56-56L88 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM492.7 300.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"]
};
const faChartUser = {
  prefix: 'far',
  iconName: 'chart-user',
  icon: [640, 512, ["user-chart"], "f6a3", "M576 48L224 48c-8.8 0-16 7.2-16 16l0 41.3c-14.8-6-31-9.3-48-9.3l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-239.2 0c-8.3-18-19.8-34.2-33.7-48L576 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM412.7 139.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l88 0c8.8 0 16 7.2 16 16l0 88c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-27-27L401 273c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 55.7-55.7-27-27zM160 272a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 400c-39.8 0-73.2 27.2-82.6 64l218.6 0c-9.5-36.8-42.9-64-82.6-64l-53.3 0zm0-48l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"]
};
const faUserChart = faChartUser;
const faHandsAslInterpreting = {
  prefix: 'far',
  iconName: 'hands-asl-interpreting',
  icon: [640, 512, ["american-sign-language-interpreting", "asl-interpreting", "hands-american-sign-language-interpreting"], "f2a3", "M186.3 55.8l-51.8 86.3c-5.8 9.6-17.4 14-28.1 10.5S89 138.6 90 127.5l5.9-61.9c.8-8.8-5.6-16.6-14.4-17.4s-16.6 5.6-17.4 14.4l-16 168-.1 .8 0 .8 0 32c0 61.9 50.1 112 112 112l48 0c31.6 0 60.5-14.5 76.2-41.6c4.4-7.7 1.8-17.4-5.8-21.9c-2.5-1.4-5.1-2.1-7.7-2.2l-.3 0-.3 0c-5.5 .1-10.7 3-13.6 8C247.4 334.1 230 344 208 344c-30.9 0-56-25.1-56-56s25.1-56 56-56c11.6 0 21.7 1.8 30.1 5.8c8.9 4.2 14.8 10.3 18.4 16.6c2.9 5 8.1 7.9 13.6 8l.3 0 .3 0c2.6 0 5.2-.7 7.7-2.2c7.6-4.4 10.3-14.2 5.8-21.9c-6-10.3-13.5-18-21.9-23.6c-7.1-4.8-11.1-12.9-10.5-21.5s5.6-16.1 13.2-19.9l46.2-23.1c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-87.4 43.7c-9.5 4.8-21.1 2.7-28.3-5.2s-8.5-19.5-3-28.7l35.6-59.4c4.5-7.6 2.1-17.4-5.5-22s-17.4-2.1-22 5.5zm92.8 349.5C257.5 417.8 232.7 424 208 424l-48 0C71.6 424 0 352.4 0 264l0-32 0-1.9c0-.8 0-1.5 .1-2.3l.2-1.9 16-168C19.6 22.8 50.9-3.1 86.1 .3c24.7 2.4 44.9 18.5 53.4 40.1l5.6-9.3c18.2-30.3 57.5-40.1 87.8-22c26.9 16.2 37.7 49 27 77.4l15.4-7.7c31.4-15.7 69.5-3.2 85.5 28C382.5 94.2 407.3 88 432 88l48 0c88.4 0 160 71.6 160 160l0 32 0 1.9c0 .8 0 1.5-.1 2.3l-.2 1.9-16 168c-3.4 35.2-34.6 61-69.8 57.6c-24.7-2.4-44.9-18.5-53.4-40.1l-5.6 9.3c-18.2 30.3-57.5 40.1-87.8 22c-26.9-16.2-37.7-49-27-77.4l-15.4 7.7c-31.4 15.7-69.5 3.2-85.5-28zm174.6 51l51.8-86.3c5.8-9.6 17.4-14 28.1-10.5s17.5 13.9 16.4 25.1l-5.9 61.9c-.8 8.8 5.6 16.6 14.4 17.4s16.6-5.6 17.4-14.4l16-168 .1-.8 0-.8 0-32c0-61.9-50.1-112-112-112l-48 0c-31.6 0-60.5 14.5-76.2 41.6c-4.4 7.6-1.8 17.4 5.8 21.9c2.5 1.4 5.1 2.1 7.7 2.2l.3 0 .3 0c5.5-.1 10.7-3 13.6-8C392.6 177.9 410 168 432 168c30.9 0 56 25.1 56 56s-25.1 56-56 56c-11.6 0-21.7-1.8-30.1-5.8c-8.9-4.2-14.8-10.3-18.4-16.6c-2.9-5-8.1-7.9-13.6-8l-.3 0-.3 0c-2.6 0-5.2 .7-7.7 2.2c-7.7 4.4-10.3 14.2-5.8 21.9c6 10.3 13.5 18 21.9 23.6c7.1 4.8 11.1 12.9 10.6 21.5s-5.6 16.1-13.2 19.9l-46.2 23.1c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l87.4-43.7c9.5-4.8 21.1-2.7 28.3 5.2s8.5 19.5 3 28.7l-35.6 59.4c-4.5 7.6-2.1 17.4 5.5 22s17.4 2.1 22-5.5zM224 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm208-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faAslInterpreting = faHandsAslInterpreting;
const faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
const faPresentationScreen = {
  prefix: 'far',
  iconName: 'presentation-screen',
  icon: [576, 512, ["presentation"], "f685", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm8 80l0 216c0 30.9 25.1 56 56 56l176 0 0 46.1-73 73c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73-73 0-46.1 176 0c30.9 0 56-25.1 56-56l0-216-48 0 0 216c0 4.4-3.6 8-8 8l-200 0L88 304c-4.4 0-8-3.6-8-8L80 80 32 80z"]
};
const faPresentation = faPresentationScreen;
const faCircleBolt = {
  prefix: 'far',
  iconName: 'circle-bolt',
  icon: [512, 512, [], "e0fe", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM330.1 115.6c5.8 4.7 7.6 12.9 4.2 19.6L281.9 240l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L230.1 272 160 272c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
const faFaceSmileHalo = {
  prefix: 'far',
  iconName: 'face-smile-halo',
  icon: [512, 512, [], "e38f", "M512 80C512 35.8 397.4 0 256 0S0 35.8 0 80s114.6 80 256 80s256-35.8 256-80zm-64 0c0 17.7-86 32-192 32S64 97.7 64 80s86-32 192-32s192 14.3 192 32zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5c-14 5.8-29.6 11.1-46.4 15.6c17.8 29.1 28 63.3 28 99.9c0 106-86 192-192 192S64 378 64 272c0-36.6 10.2-70.8 28-99.9c-16.9-4.6-32.4-9.8-46.4-15.6zm172 128.3s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 244.4 120 262.1 120 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm-73.9 47.9c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm233.9-47.9s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 244.4 280 262.1 280 280c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0z"]
};
const faCartCircleArrowDown = {
  prefix: 'far',
  iconName: 'cart-circle-arrow-down',
  icon: [640, 512, [], "e3ef", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-147.3c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0l-56-56c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 393.4l0-89.4c0-8.8 7.2-16 16-16s16 7.2 16 16l0 89.4 28.7-28.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faHousePersonReturn = {
  prefix: 'far',
  iconName: 'house-person-return',
  icon: [640, 512, ["house-person-arrive", "house-return"], "e011", "M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm66.2 266.6l-29.9-89.8c-7.7 1.2-15 3.6-21.7 7.1c.1 .3 .2 .7 .3 1l32.4 103.8 16.3-13.3c2.6-2.1 3.6-5.6 2.5-8.7zm-59 54.6l-28.5-91.3-10.5 36.7c-1.9 6.5-5.4 12.5-10.2 17.3L361 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l27.6-27.6 10.9-38.1c14.4-50.5 60.6-85.4 113.2-85.4l4.9 0c16.1 0 32.1 2.6 47.4 7.7c39.9 13.3 72.4 42.8 89.5 81.3l9.5 21.3c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-9.5-21.3c-10.9-24.4-30.9-43.5-55.6-53.3l22.8 68.3c7.4 22.1 .3 46.5-17.8 61.2L421.5 397.4l-22.1 96c-3 12.9-15.9 21-28.8 18s-21-15.9-18-28.8L375.4 384c2-8.7 6.8-16.4 13.8-22.1l50.1-40.7zm101.1 21l24.1 60.4L633 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-69.7-69.7c-3.8-3.8-6.8-8.4-8.9-13.4l-19.2-48 39-31.7zm-146.7-224l2.9 2.4c-13.5 8.9-25.6 20-35.7 32.8L240 55 112 159.3 112 360c0 4.4 3.6 8 8 8l226.8 0c-1.1 2.9-1.9 5.8-2.6 8.8L335.1 416 120 416c-30.9 0-56-25.1-56-56l0-161.6L39.2 218.6c-10.3 8.4-25.4 6.8-33.8-3.4s-6.8-25.4 3.4-33.8l216-176c8.8-7.2 21.5-7.2 30.3 0L371.1 99.8c6.3 7.4 14 13.7 22.6 18.4zM160 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64z"]
};
const faHousePersonArrive = faHousePersonReturn;
const faHouseReturn = faHousePersonReturn;
const faMessageXmark = {
  prefix: 'far',
  iconName: 'message-xmark',
  icon: [512, 512, ["comment-alt-times", "message-times"], "f4ab", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM175 127c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faCommentAltTimes = faMessageXmark;
const faMessageTimes = faMessageXmark;
const faFileCertificate = {
  prefix: 'far',
  iconName: 'file-certificate',
  icon: [512, 512, ["file-award"], "f5f3", "M448 464l-224 0 0 32c0 5.5-1 10.9-2.7 16L448 512c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L192 0c-35.3 0-64 28.7-64 64l0 71.1 .1-.1c1.5-.7 4-2 6.6-3c13.6-5.5 28.3-5.4 41.3-.5L176 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16zM109.2 161.6c-10-4.1-21.5-1-28.1 7.5L70.6 182.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.9-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2L9.1 241.1c-8.5 6.6-11.6 18.1-7.5 28.1L8 285c.8 1.9 .8 4.1 0 6.1L1.6 306.8c-4.1 10-1 21.5 7.5 28.1l13.5 10.5c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.9 19.1 20.5 20.6L64 390.2 64 496c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L128 483.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-105.8 15.5-2.1c10.7-1.5 19.1-9.9 20.5-20.6l2.3-16.9c.3-2.1 1.4-4 3-5.2l13.5-10.5c8.5-6.6 11.6-18.1 7.5-28.1L248 291c-.8-1.9-.8-4.1 0-6.1l6.5-15.8c4.1-10 1-21.5-7.5-28.1l-13.5-10.5c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.9-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3l-10.5-13.5c-6.6-8.5-18.1-11.6-28.1-7.5L131 168c-1.9 .8-4.1 .8-6.1 0l-15.8-6.5zM64 288a64 64 0 1 1 128 0A64 64 0 1 1 64 288z"]
};
const faFileAward = faFileCertificate;
const faUserDoctorHairLong = {
  prefix: 'far',
  iconName: 'user-doctor-hair-long',
  icon: [448, 512, [], "e459", "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zm80 224c-5.4 0-10.8 .3-16 1l0 49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-41c-46.9 19-80 65-80 118.7l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-97.2 78.8-176 176-176l96 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-53.7-33.1-99.7-80-118.7l0 40.7c27.6 7.1 48 32.2 48 62l0 32c0 8.8-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-29.8 20.4-54.9 48-62l0-49c-5.2-.7-10.6-1-16-1l-96 0zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCameraSecurity = {
  prefix: 'far',
  iconName: 'camera-security',
  icon: [448, 512, ["camera-home"], "f8fe", "M384 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l40.1 0L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3l272 0c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416l40.1 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM287.5 416l29.5 48-186.1 0 29.5-48 127 0zM336 208a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM224 144a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faCameraHome = faCameraSecurity;
const faGear = {
  prefix: 'far',
  iconName: 'gear',
  icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
};
const faCog = faGear;
const faDropletSlash = {
  prefix: 'far',
  iconName: 'droplet-slash',
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192c0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8c-11.9 27.6-17 48.2-17 61.1c0 79.5 64.5 144 144 144zm185.2-93.3l125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L205.8 136c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0l1.8 0c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.6-2.4 34.5-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6c0-13-5.1-33.5-17-61.1c-11.5-26.6-27.6-55.8-45.5-84.7c-29-46.8-61-90.2-81.5-117c-19.3 25.1-48.7 65-76.3 108.5L462.9 337.5zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6 .1 1.2 .1 1.7c0 30.9 25.1 56 56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z"]
};
const faTintSlash = faDropletSlash;
const faBookHeart = {
  prefix: 'far',
  iconName: 'book-heart',
  icon: [448, 512, [], "f499", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zm80-185.4c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
const faMosque = {
  prefix: 'far',
  iconName: 'mosque',
  icon: [640, 512, [128332], "f678", "M400 0c7.6 0 14.7 3.6 19.2 9.6c18 24 40.1 42.1 66.5 59.5c15.7 10.3 31.3 19.5 48.2 29.3c13.1 7.6 26.9 15.7 42.2 25.2c31 19.2 48 53.2 48 88.3c0 25.6-8.9 49.2-23.8 67.7C623.8 291.4 640 315.8 640 344l0 96c0 39.8-32.2 72-72 72l-120 0-96 0-112 0-8 0L72 512c-39.8 0-72-32.2-72-72L0 176l0-35.3C0 96.3 20.5 54.3 55.6 27l25.7-20c8.7-6.7 20.8-6.7 29.5 0l25.7 20c26.9 20.9 45.2 50.4 52.3 83.1c-24.1 21.6-38.9 51-43.3 81.9l-1.4 0-96 0 0 248c0 13.3 10.7 24 24 24l92.1 0c-2.7-7.5-4.1-15.6-4.1-24l0-96c0-28.2 16.2-52.6 39.8-64.4C184.9 261 176 237.5 176 211.8c0-35.1 17-69.1 48-88.3c15.2-9.4 29.1-17.5 42.2-25.2c0 0 0 0 0 0c16.9-9.9 32.5-19 48.2-29.3c26.4-17.4 48.5-35.5 66.4-59.5C385.3 3.6 392.4 0 400 0zM232 464l8 0 16 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 48 0 0-50c0-19 8.4-37 23-49.2L400 344l25 20.8C439.6 377 448 395 448 414l0 50 48 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 24 0c13.3 0 24-10.7 24-24l0-96c0-13.3-10.7-24-24-24l-52.2 0L400 320l-115.8 0L232 320c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24zM48 144l96 0 0-3.3c0-29.6-13.7-57.6-37.1-75.8L96 56.4 85.1 64.9C61.7 83.1 48 111.1 48 140.7l0 3.3zm528 67.8c0-19.9-9.6-37.7-25.3-47.5c-12.6-7.8-25.9-15.6-39-23.3c-18.3-10.8-36.5-21.4-52.4-31.9C438.2 95.3 418.1 80 400 61c-18.1 18.9-38.2 34.2-59.3 48.1c-16 10.5-34.1 21.1-52.4 31.9c-13.1 7.7-26.4 15.5-39 23.3C233.6 174.1 224 192 224 211.8c0 33.2 26.9 60.2 60.2 60.2L400 272l115.8 0c33.2 0 60.2-26.9 60.2-60.2z"]
};
const faDuck = {
  prefix: 'far',
  iconName: 'duck',
  icon: [512, 512, [129414], "f6d8", "M69.1 324.1c11.2 4.8 23.7 5.2 35.2 1l146.5-52.7c14.6-5.3 25.8-17.3 30-32.2s.9-31-8.8-43.1c-10-12.4-15.9-28-15.9-45.1c0-39.8 32.2-72 72-72s72 32.2 72 72c0 20.1-8.2 38.2-21.5 51.4l7.5 7.6-7.5-7.6c-7.1 7-13.6 15.5-18.4 25.5c-8.7 18.2-5.1 39.9 9 54.4c14.3 14.5 22.9 34.3 22.9 56l0 12.8c0 44.2-35.8 80-80 80l-116 0c-69.8 0-128.7-49.4-144.1-115.2l17.2 7.4zM446.8 135C438.5 76.8 388.5 32 328 32c-66.3 0-120 53.7-120 120c0 11.2 1.5 22 4.4 32.2c4.4 15.9 12.1 30.5 22.1 43l-47 16.9L88 280 37 258.1c-3.3-1.4-6.9-2.1-10.5-2.1C11.9 256 0 268.1 0 282.7C0 391 87.8 480 196 480l116 0c70.7 0 128-57.3 128-128l0-12.8c0-34.7-13.9-66.4-36.6-89.6c2.1-4.4 5.1-8.5 8.7-12c1.8-1.8 3.6-3.7 5.3-5.6l3.5 0c50.3 0 91.1-40.8 91.1-91.1c0-6.8-6-12.1-12.8-11.3L463.9 134c-5.7 .7-11.4 1-17.1 1zM344 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM299.2 289.1c-13.1-1.8-25.2 7.5-27 20.6c-2.7 20-18 38.3-40.8 44c-18.6 4.6-36.8-.5-49.3-11.6c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9c24.2 21.5 58.7 30.8 92.8 22.3c41.6-10.4 71.4-44.4 76.7-84.2c1.8-13.1-7.5-25.2-20.6-27z"]
};
const faMosquito = {
  prefix: 'far',
  iconName: 'mosquito',
  icon: [640, 512, [], "e52b", "M177.5 506.9c-10.3-8.2-12.2-23.5-4.3-34.1l43.1-57.3 0-55.6c0-5.8 2-11.4 5.7-15.8l62.3-74.6L154.6 387.8C97.6 447.6 0 405.2 0 320.6c0-47.9 34-88.3 79.3-94.2l153-23.9-40.8-40.9c-7.8-7.8-9.4-20.1-3.9-29.8l23.9-41.7L173.3 39.2c-8-10.6-6.1-25.9 4.3-34.1s25.2-6.3 33.2 4.4l48 63.9c5.9 7.9 6.6 18.6 1.7 27.2L237.8 140 288 190.3l0-38.1c0-14.9 10.2-27.4 24-31l0-57.2c0-4.4 3.6-8 8-8s8 3.6 8 8l0 57.2c13.8 3.6 24 16.1 24 31l0 38.2L402.2 140l-22.6-39.5c-4.9-8.6-4.2-19.3 1.7-27.2l48-63.9c8-10.6 22.8-12.6 33.2-4.4s12.2 23.5 4.3 34.1L428.5 90.1l23.9 41.7c5.5 9.7 3.9 22-3.9 29.8l-40.8 40.9 153 23.9c45.3 5.9 79.4 46.3 79.4 94.2c0 84.6-97.6 127-154.6 67.1L355.7 269.4 418 344c3.7 4.4 5.7 10 5.7 15.8l0 62.7 42.1 49c8.6 10.1 7.7 25.5-2.1 34.3s-24.7 7.9-33.4-2.1l-48-55.9c-3.8-4.4-5.9-10.2-5.9-16.1l0-62.9L352 339.7l0 68.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-68.1-24.3 29.2 0 54.9c0 5.4-1.7 10.6-4.9 14.9l-48 63.9c-8 10.6-22.8 12.6-33.2 4.4zM119.9 354.6c.8-.8 1.6-1.6 2.4-2.3L233.4 250.9l-146.6 23c-.4 .1-.8 .1-1.2 .2C65.8 276.6 48 295.1 48 320.6c0 22.3 12.2 37.3 27 43.7c14.5 6.3 31.3 4.5 44.9-9.7zM406.6 250.9L517.7 352.3c.8 .7 1.6 1.5 2.4 2.3c13.6 14.2 30.4 16 44.9 9.7c14.8-6.4 27-21.4 27-43.7c0-25.5-17.8-44-37.6-46.6c-.4-.1-.8-.1-1.2-.2L406.6 250.9z"]
};
const faStarOfDavid = {
  prefix: 'far',
  iconName: 'star-of-david',
  icon: [512, 512, [10017], "f69a", "M408.9 301.9L378.2 352l61.5 0-30.8-50.1zM380.8 256l-58.9-96-131.7 0-58.9 96 58.9 96 131.7 0 58.9-96zm56.3 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4l-109.8 0-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400 53.4 400C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112l109.8 0 56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112l109.8 0c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-58.9-96l30.7 50.1L439.7 160l-61.5 0zm-85.8-48L256 52.7 219.6 112l72.8 0zM133.8 160l-61.5 0 30.8 50.1L133.8 160zM103.1 301.9L72.3 352l61.5 0-30.8-50.1zM219.6 400L256 459.3 292.4 400l-72.8 0z"]
};
const faFlagSwallowtail = {
  prefix: 'far',
  iconName: 'flag-swallowtail',
  icon: [448, 512, ["flag-alt"], "f74c", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24l0 8L0 80 0 304l0 48L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 376 0c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L352 192 443.2 70.4c3.1-4.2 4.8-9.2 4.8-14.4c0-13.3-10.7-24-24-24L48 32l0-8zm0 56l328 0-62.4 83.2c-12.8 17.1-12.8 40.5 0 57.6L376 304 48 304 48 80z"]
};
const faFlagAlt = faFlagSwallowtail;
const faPersonMilitaryRifle = {
  prefix: 'far',
  iconName: 'person-military-rifle',
  icon: [512, 512, [], "e54b", "M160 39c0 13.8 11.2 25 25 25l151 0c8.8 0 16-7.2 16-16l0-30.6C352 8 344 .7 334.7 1.4L182.9 14.1C170 15.2 160 26 160 39zm277.9 1c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9L327.2 231.6c-10.1-3.8-20.8-6.2-31.7-7.1c-2.5-.3-5-.4-7.6-.4l-2.7 0-58.5 0-2.7 0c-2.6 0-5.1 .1-7.5 .4c-35.7 3.1-68.5 22-88.9 52L36.2 410.5c-7.5 11-4.6 25.9 6.3 33.4s25.9 4.6 33.3-6.3L160 314.1 160 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-165.9 84.2 123.5c7.5 11 22.4 13.8 33.4 6.3s13.8-22.4 6.3-33.3l-85.2-125 38.6-66.9c8.8-15.3 3.6-34.9-11.7-43.7l-1.6-.9 55.5-96.1c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8-13.9-8zM304 403.6L228.8 272l56.5 0c1.7 0 3.5 .1 5.2 .2c7.7 1.2 13.5 7.8 13.5 15.8l0 115.6zm-96-71.3L283.2 464 208 464l0-131.6zM176 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16l-50.7 0c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16l-50.7 0c-1 5.2-1.6 10.5-1.6 16z"]
};
const faCarGarage = {
  prefix: 'far',
  iconName: 'car-garage',
  icon: [640, 512, [], "f5e2", "M331.4 2.9c-7.1-3.8-15.7-3.8-22.8 0l-296 160c-11.7 6.3-16 20.9-9.7 32.5s20.9 16 32.5 9.7L320 51.3 604.6 205.1c11.7 6.3 26.2 2 32.5-9.7s2-26.2-9.7-32.5l-296-160zM249.8 208l140.3 0c10.1 0 19.2 6.4 22.6 15.9L429.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C128.2 306.7 112 335.5 112 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L458 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM432 320c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48l224 0zM224 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCartShopping = {
  prefix: 'far',
  iconName: 'cart-shopping',
  icon: [576, 512, [128722, "shopping-cart"], "f07a", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM131.1 80l389.6 0L482.4 222.2c-2.8 10.5-12.3 17.8-23.2 17.8l-297.6 0L131.1 80zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faShoppingCart = faCartShopping;
const faBookFont = {
  prefix: 'far',
  iconName: 'book-font',
  icon: [448, 512, [], "e0bf", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM261.5 93.3l88 176c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 256c-.4 0-.8 0-1.2 0l-96 0c-.4 0-.8 0-1.2 0l-17.4 34.8c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l88-176C222.6 85.1 230.9 80 240 80s17.4 5.1 21.5 13.3zM265.2 208L240 157.7 214.8 208l50.3 0z"]
};
const faShieldPlus = {
  prefix: 'far',
  iconName: 'shield-plus',
  icon: [512, 512, [], "e24a", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faVials = {
  prefix: 'far',
  iconName: 'vials',
  icon: [512, 512, [], "f493", "M0 56C0 42.7 10.7 32 24 32l32 0 112 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 320c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 176 64 0 0-176L80 80zM288 56c0-13.3 10.7-24 24-24l32 0 112 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 320c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-320-8 0c-13.3 0-24-10.7-24-24zm80 24l0 176 64 0 0-176-64 0z"]
};
const faEyeDropperFull = {
  prefix: 'far',
  iconName: 'eye-dropper-full',
  icon: [512, 512, [], "e172", "M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c0 0 0 0 0 0l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9l0 52.9-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28 52.9 0c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6 183.4 198.6 53.1 329z"]
};
const faDistributeSpacingHorizontal = {
  prefix: 'far',
  iconName: 'distribute-spacing-horizontal',
  icon: [512, 512, [], "e365", "M456 0c-13.3 0-24 10.7-24 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24l0-464c0-13.3-10.7-24-24-24zM304 368l-96 0 0-224 96 0 0 224zm48-224c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224zM80 24C80 10.7 69.3 0 56 0S32 10.7 32 24l0 464c0 13.3 10.7 24 24 24s24-10.7 24-24L80 24z"]
};
const faTabletRugged = {
  prefix: 'far',
  iconName: 'tablet-rugged',
  icon: [448, 512, [], "f48f", "M352 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l256 0zM96 0C66.6 0 41.8 19.8 34.3 46.8L8.8 59.6C3.4 62.3 0 67.8 0 73.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 176l0 16L8.8 203.6C3.4 206.3 0 211.8 0 217.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3L32 320l0 16L8.8 347.6C3.4 350.3 0 355.8 0 361.9l0 76.2c0 6.1 3.4 11.6 8.8 14.3l25.5 12.7C41.8 492.2 66.6 512 96 512l256 0c29.4 0 54.2-19.8 61.7-46.8l25.5-12.7c5.4-2.7 8.8-8.2 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 336l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L416 192l0-16 23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3l0-76.2c0-6.1-3.4-11.6-8.8-14.3L413.7 46.8C406.2 19.8 381.4 0 352 0L96 0z"]
};
const faTemperatureSnow = {
  prefix: 'far',
  iconName: 'temperature-snow',
  icon: [576, 512, ["temperature-frigid"], "f768", "M368 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5c7.1-9.5 12.8-22.1 12.8-36.6L368 112zM432 0C370.1 0 320 50.1 320 112l0 161.9c0 1.7-.7 4.4-3.2 7.8c-18.1 24.1-28.8 54-28.8 86.4c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L544 112C544 50.1 493.9 0 432 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM288 131.6l-88 50.8 0-55.8 35.3-35.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L200 81.4 200 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 25.4L139.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L152 126.6l0 55.8-48.3-27.9L90.7 106.3C88.5 97.7 79.7 92.7 71.2 95s-13.6 11.1-11.3 19.6l4.6 17.3-22-12.7C31 112.6 16.3 116.5 9.7 128s-2.7 26.2 8.8 32.8l22 12.7-17.3 4.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l48.2-12.9L128 224 79.7 251.9 31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l17.3 4.6-22 12.7C7 293.8 3.1 308.5 9.7 320s21.3 15.4 32.8 8.8l22-12.7-4.6 17.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l12.9-48.2L152 265.6l0 55.8-35.3 35.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L152 366.6l0 25.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-25.4 12.7 12.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L200 321.4l0-55.8 67.7 39.1c5.2-13.5 12-26.2 20.3-37.9l0-5.8-64-37 64-37 0-55.4z"]
};
const faTemperatureFrigid = faTemperatureSnow;
const faMoped = {
  prefix: 'far',
  iconName: 'moped',
  icon: [640, 512, [], "e3b9", "M328 56c0-13.3 10.7-24 24-24l41.3 0c23.8 0 45.1 15.1 52.9 37.6l8.1 23.3 51-25.5c4.4-2.2 9.3-3.4 14.3-3.4l8.4 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-8.4 0c-5 0-9.9-1.2-14.3-3.4l-34.9-17.5L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8c9.5 9.3 9.6 24.5 .3 33.9s-24.5 9.6-33.9 .3C570.2 284.2 542.6 272 512 272c-55.1 0-101 39.8-110.3 92.3c-2 11.5-12 19.8-23.6 19.8l-42.1 0c-.9 0-1.7 0-2.6-.1L288 384l-32 0c0 53-43 96-96 96s-96-43-96-96l-32 0c-17.7 0-32-14.3-32-32l0-32c0-70.7 57.3-128 128-128l96 0c17.7 0 32 14.3 32 32l0 80c0 17.7 14.3 32 32 32l40 0 31.3 0c14.5-46 49.1-83.1 93.6-100.7L400.8 85.4c-1.1-3.2-4.2-5.4-7.6-5.4L352 80c-13.3 0-24-10.7-24-24zM120 112l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 128l-80 0c-44.2 0-80 35.8-80 80l0 16 166.7 0c-4.3-9.8-6.7-20.6-6.7-32l0-64zM160 432c26.5 0 48-21.5 48-48l-96 0c0 26.5 21.5 48 48 48zm352 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faFaceSmilePlus = {
  prefix: 'far',
  iconName: 'face-smile-plus',
  icon: [640, 512, ["smile-plus"], "f5b9", "M544 0c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24zM400 288A176 176 0 1 0 48 288a176 176 0 1 0 352 0zM0 288a224 224 0 1 1 448 0A224 224 0 1 1 0 288zm144.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM146 332.8c19.1 21.6 46.9 35.2 78 35.2s58.9-13.6 78-35.2c8.8-9.9 23.9-10.9 33.9-2.1s10.9 23.9 2.1 33.9C310.2 396.1 269.4 416 224 416s-86.2-19.9-114-51.5c-8.8-9.9-7.8-25.1 2.1-33.9s25.1-7.8 33.9 2.1z"]
};
const faSmilePlus = faFaceSmilePlus;
const faRadioTuner = {
  prefix: 'far',
  iconName: 'radio-tuner',
  icon: [512, 512, ["radio-alt"], "f8d8", "M511.1 17.6c3.5 12.8-4 26-16.8 29.5L201.2 128 448 128c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 304 0 192l0-3.4c0-32.4 21.6-60.8 52.9-69.4L481.6 .9c12.8-3.5 26 4 29.5 16.8zM48 272l0 32 0 144c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-176L48 272zm256 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM96 320l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 64l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faRadioAlt = faRadioTuner;
const faFaceSwear = {
  prefix: 'far',
  iconName: 'face-swear',
  icon: [640, 512, [], "e399", "M320 48c114.9 0 208 93.1 208 208l48 0C576 114.6 461.4 0 320 0S64 114.6 64 256l48 0c0-114.9 93.1-208 208-208zM240.4 224c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32zM48 288c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48L48 288zm352 96l-16 0 0 32 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-32 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-32-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 32 0 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0l0 32 32 0 0-32-32 0zm250.4-52.1c6.7 5.8 7.5 15.8 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 320c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM184 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 336l0 1.8c4.6 .8 8.7 1.7 12.1 2.6c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9c-4.1 .5-6.3 1.4-7.4 2.2c-2.3 1.7-2.2 4.5-.1 5.9c6.9 4.7 14.9 6.9 22.9 9.2c0 0 0 0 0 0c8.6 2.4 17.2 4.8 24.6 10.2c4.7 3.4 9.3 8.2 12.1 14.7c2.9 6.6 3.4 13.8 2.2 21.1c-2 11.5-7.9 20.5-17 25.9c-4.9 3-10.1 4.6-15.3 5.4l0 .8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-3c-8.1-1.9-15.3-4.2-20.2-5.9c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1c5 .1 7.6-.8 8.8-1.5c0 0 0 0 0 0c3-1.8 2.9-6.7 .4-8.5c-6.8-5-15.2-7.3-23.6-9.7c-8.1-2.3-16.2-4.5-23.1-9.2c-4.7-3.2-9.4-7.7-12.4-14.1c-3.1-6.5-3.7-13.7-2.5-20.9c1.8-10.2 7-18.1 14.5-23.5c5.3-3.8 11.2-5.9 16.9-7l0-1.5c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faWaterArrowDown = {
  prefix: 'far',
  iconName: 'water-arrow-down',
  icon: [576, 512, ["water-lower"], "f774", "M312 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 137.7-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L312 161.7 312 24zM80 302.1C62.8 317 41 328.8 18.8 333.8C5.9 336.7-2.3 349.5 .6 362.5s15.7 21.1 28.7 18.2C58 374.2 81.6 360.2 96 350.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.7-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zm0 128C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0z"]
};
const faWaterLower = faWaterArrowDown;
const faScannerTouchscreen = {
  prefix: 'far',
  iconName: 'scanner-touchscreen',
  icon: [512, 512, [], "f48a", "M128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zM384 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-13.3-10.7-24-24-24zM64 144l224 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 80c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-144 0z"]
};
const faCircle7 = {
  prefix: 'far',
  iconName: 'circle-7',
  icon: [512, 512, [], "e0f4", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l103.8 0-93 172.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8l112-208c4-7.4 3.8-16.4-.5-23.7s-12.2-11.7-20.6-11.7l-144 0z"]
};
const faPlugCirclePlus = {
  prefix: 'far',
  iconName: 'plug-circle-plus',
  icon: [576, 512, [], "e55f", "M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16zM104 0c13.3 0 24 10.7 24 24l0 88-48 0 0-88C80 10.7 90.7 0 104 0zM280 0c13.3 0 24 10.7 24 24l0 88-48 0 0-88c0-13.3 10.7-24 24-24zM0 168c0-13.3 10.7-24 24-24l8 0 48 0 224 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 19.2c-18 9.2-34.2 21.4-48 36l0-55.2L80 192l0 64c0 61.9 50.1 112 112 112c24.3 0 46.9-7.8 65.2-20.9c-.8 6.9-1.2 13.9-1.2 20.9c0 11.4 1.1 22.5 3.1 33.3c-13.5 6.2-28 10.7-43.1 12.9l0 73.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-73.8C91 402.6 32 336.2 32 256l0-64-8 0c-13.3 0-24-10.7-24-24z"]
};
const faPersonSkiJumping = {
  prefix: 'far',
  iconName: 'person-ski-jumping',
  icon: [512, 512, ["ski-jump"], "f7c7", "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 120c0-13.3 10.7-24 24-24l165.2 0c37 0 54.2 45.9 26.3 70.2L202.4 275 171 385 433.7 249.1c18.6-9.6 30.3-28.8 30.3-49.7l0-7.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 7.3c0 38.9-21.7 74.5-56.2 92.4L35 509.3C23.3 515.4 8.8 510.8 2.7 499s-1.5-26.3 10.3-32.3l113.2-58.6c-5.4-5.9-7.6-14.4-5.3-22.7l37.2-130.1c.1-.2 .1-.5 .2-.7l8.3-29c2.7-9.4 7.8-18 14.9-24.9c11.1-10.7 36.2-34.6 60.8-56.8L136 144c-13.3 0-24-10.7-24-24z"]
};
const faSkiJump = faPersonSkiJumping;
const faPlaceOfWorship = {
  prefix: 'far',
  iconName: 'place-of-worship',
  icon: [640, 512, [], "f67f", "M320 0c6.8 0 13.3 2.9 17.8 7.9l67.9 75.4c6.6 7.3 10.3 16.9 10.3 26.8l0 75.4 38.4 24.9c15.9 10.3 25.6 28 25.6 47L480 464l88 0c13.3 0 24-10.7 24-24l0-69.9c0-8.1-4.1-15.7-11-20.2l-69-44.7 0-57.2 95.1 61.5c20.5 13.3 32.9 36 32.9 60.4l0 69.9c0 39.8-32.2 72-72 72l-184 0s0 0 0 0l-160 0s0 0 0 0L72 512c-39.8 0-72-32.2-72-72l0-69.9c0-24.4 12.4-47.2 32.9-60.5L128 248.1l0 57.2L59 350c-6.8 4.4-11 12-11 20.2L48 440c0 13.3 10.7 24 24 24l88 0 0-206.6c0-19 9.6-36.7 25.6-47L224 185.5l0-75.4c0-9.9 3.7-19.4 10.3-26.8L302.2 7.9C306.7 2.9 313.2 0 320 0zM272 113.2l0 85.4c0 8.1-4.1 15.7-11 20.1l-49.4 32c-2.3 1.5-3.7 4-3.7 6.7L208 464l64 0 0-96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 96 64 0 0-206.6c0-2.7-1.4-5.2-3.7-6.7l-49.4-32c-6.8-4.4-11-12-11-20.1l0-85.4L320 59.9l-48 53.3z"]
};
const faWaterArrowUp = {
  prefix: 'far',
  iconName: 'water-arrow-up',
  icon: [576, 512, ["water-rise"], "f775", "M312 216c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-137.7-47.9 43.5c-9.8 8.9-25 8.2-33.9-1.6s-8.2-25 1.6-33.9l88-80c9.2-8.3 23.1-8.3 32.3 0l88 80c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6L312 78.3 312 216zM80 302.1c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7zm0 128c9.1-8.1 22.8-8.1 31.9 0c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7z"]
};
const faWaterRise = faWaterArrowUp;
const faWaveformLines = {
  prefix: 'far',
  iconName: 'waveform-lines',
  icon: [640, 512, ["waveform-path"], "f8f2", "M320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM520 64c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24zM216 96c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zm208 32c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zM120 192c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zM24 224c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24zm592 0c13.3 0 24 10.7 24 24l0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24z"]
};
const faWaveformPath = faWaveformLines;
const faSplit = {
  prefix: 'far',
  iconName: 'split',
  icon: [512, 512, [], "e254", "M391 31c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-10.6 0-20.8 4.2-28.3 11.7L225.9 256l92.3 92.3c7.5 7.5 17.7 11.7 28.3 11.7l83.5 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-23.3 0-45.7-9.3-62.2-25.8L182.1 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l158.1 0L284.3 129.8c16.5-16.5 38.9-25.8 62.2-25.8l83.5 0L391 65c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faFilmCanister = {
  prefix: 'far',
  iconName: 'film-canister',
  icon: [576, 512, ["film-cannister"], "f8b7", "M96 32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l40 0 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 384 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L56 512l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0L32 80l-8 0C10.7 80 0 69.3 0 56S10.7 32 24 32l32 0 40 0zM80 80l0 384 192 0 0-384L80 80zm464 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32l-128 0 0-288 192 0zM392 184l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM392 344l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faFilmCannister = faFilmCanister;
const faFolderXmark = {
  prefix: 'far',
  iconName: 'folder-xmark',
  icon: [512, 512, ["folder-times"], "f65f", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM175 207c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faFolderTimes = faFolderXmark;
const faToiletPaperBlank = {
  prefix: 'far',
  iconName: 'toilet-paper-blank',
  icon: [640, 512, ["toilet-paper-alt"], "f71f", "M20.5 463.6c-4.3 7.2-5.5 15.8-3.6 23.7c.7 2.9 1.8 5.7 3.3 8.4C25.8 505.8 36.5 512 48 512l285.9 0c22.3 0 45.4-12.1 55.4-36.1c9.6-23.2 23.9-66.4 33.3-134.5l.1-.8c5.5-40.5 9.3-89.7 9.3-148.6c0-76 26.2-138.3 59.4-143.6c1.5-.2 3.1-.4 4.6-.4c35.3 0 64 64.5 64 144s-28.7 144-64 144c-13.9 0-26.9-10-37.4-27.1c-2.2 22.3-4.9 42.5-7.9 60.8C463 378 478.2 384 496 384c24.5 0 44.1-11.4 58-24.5c13.6-13 23.7-29.4 31.1-46.1C600 279.8 608 236.9 608 192s-8-87.8-22.9-121.3C577.7 54 567.6 37.5 554 24.5C540.1 11.4 520.5 0 496 0c-1.3 0-2.6 0-3.8 .1c0 0 0-.1 0-.1L160 0C107 0 64 86 64 192c0 77.6-.4 174.5-32.9 250c-3.2 7.4-6.7 14.6-10.5 21.6c0 0 0 0 0 .1zM419 48c-4.6 7.3-8.6 15-12.1 22.7C392 104.2 384 147.1 384 192c0 153.2-26.3 235-39 265.5c-.9 2.1-2.1 3.5-3.8 4.5c-2 1.2-4.6 2-7.3 2L73.8 464c18.1-40.9 27.3-85.5 32.2-127.9c5.9-50.6 5.9-101.7 5.9-144.1c0-47.2 9.7-87.5 23.1-114.3c6.7-13.4 13.4-21.6 18.6-26c2.5-2.1 4.3-3 5.2-3.4c.5-.2 .8-.3 .9-.3s.2 0 .3 0l259 0zm77 192c13.3 0 24-21.5 24-48s-10.7-48-24-48s-24 21.5-24 48s10.7 48 24 48z"]
};
const faToiletPaperAlt = faToiletPaperBlank;
const faTabletScreen = {
  prefix: 'far',
  iconName: 'tablet-screen',
  icon: [448, 512, ["tablet-android-alt"], "f3fc", "M48 448c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-80L48 368l0 80zm0-128l352 0 0-256c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 256zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faTabletAndroidAlt = faTabletScreen;
const faHexagonVerticalNftSlanted = {
  prefix: 'far',
  iconName: 'hexagon-vertical-nft-slanted',
  icon: [448, 512, [], "e506", "M188.9 495.5c22.3 12.9 49.7 12.9 72 0l152.9-88.3c22.3-12.9 36-36.6 36-62.4l0-176.6c0-25.7-13.7-49.5-36-62.4L260.9 17.6c-22.3-12.9-49.7-12.9-72 0L36 105.9C13.7 118.8 0 142.6 0 168.3L0 344.9c0 25.7 13.7 49.5 36 62.4l152.9 88.3zm48-41.6c-7.4 4.3-16.6 4.3-24 0L60 365.7c-7.4-4.3-12-12.2-12-20.8l0-176.6c0-8.6 4.6-16.5 12-20.8L212.9 59.2c7.4-4.3 16.6-4.3 24 0l152.9 88.3c7.4 4.3 12 12.2 12 20.8l0 176.6c0 8.6-4.6 16.5-12 20.8L236.9 453.9zm27-344.3c5 2.8 8.1 8.2 8.1 13.9c0 12.3-13.3 20-23.9 13.9l-24.2-13.8 0 117 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144 0-160.2c0-1.6 .2-3.2 .6-4.7c.5-1.9 1.4-3.7 2.6-5.2c1.1-1.5 2.5-2.8 4-3.7c2.5-1.7 5.6-2.6 8.8-2.6c0 0 .1 0 .1 0c.5 0 1 0 1.4 .1c2.5 .2 4.8 1 6.8 2.2l47.8 27.3zm32.1 55.2c-5-2.8-8.1-8.2-8.1-13.9c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3 0 155.9c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-174.2-23.8-13.6zM159.8 144.6l0 224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7L95.8 275.2l0 61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7L127.8 270l0-125.4c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faFolderMusic = {
  prefix: 'far',
  iconName: 'folder-music',
  icon: [512, 512, [], "e18d", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM352 192c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faDisplayMedical = {
  prefix: 'far',
  iconName: 'display-medical',
  icon: [576, 512, ["desktop-medical"], "e166", "M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM256 128l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faDesktopMedical = faDisplayMedical;
const faShareAll = {
  prefix: 'far',
  iconName: 'share-all',
  icon: [576, 512, [], "f367", "M367.5 73.4c-9.6-9.1-10-24.3-.9-33.9s24.3-10 33.9-.9L542.2 173.2c19.9 18.9 19.9 50.7 0 69.6L400.5 377.4c-9.6 9.1-24.8 8.7-33.9-.9s-8.7-24.8 .9-33.9L509.2 208 367.5 73.4zM224 240c0 0 0 0 0 0l24 0c13.3 0 24 10.7 24 24l0 24 0 28.1L392.1 208 272 99.9l0 28.1 0 24c0 13.3-10.7 24-24 24l-24 0-48 0c-70.7 0-128 57.3-128 128c0 15.3 1.9 29.1 5.2 41.5C70 284.7 125.8 240 192 240l32 0zm0 96l0-48-32 0c-5.5 0-10.8 .5-16 1.3c-45.4 7.6-80 47.1-80 94.7c0 17.3 4.2 30.5 9.5 40.2c1.6 2.9 3.3 5.5 5 7.9c2.6 3.5 5.3 6.4 7.7 8.6c.5 .5 1 .9 1.4 1.4c4.8 4.9 8.3 11.3 8.3 18.1c0 10.9-8.8 19.7-19.7 19.7c-2.8 0-5.6-.6-8.1-1.9c-2.6-1.4-6.3-3.5-10.8-6.5c-2.7-1.8-5.7-3.8-8.9-6.2c-3.7-2.7-7.6-5.8-11.7-9.3C38.6 430.2 0 382 0 304c0-97.2 78.8-176 176-176l48 0 0-48 0-16c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2l0-16z"]
};
const faPeapod = {
  prefix: 'far',
  iconName: 'peapod',
  icon: [512, 512, [], "e31c", "M416 48C212.8 48 48 212.8 48 416l0 48 48 0c203.2 0 368-164.8 368-368l0-48-48 0zm0-48l48 0c26.5 0 48 21.5 48 48l0 48c0 229.8-186.2 416-416 416l-48 0c-26.5 0-48-21.5-48-48l0-48C0 186.2 186.2 0 416 0zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faChessClock = {
  prefix: 'far',
  iconName: 'chess-clock',
  icon: [640, 512, [], "f43d", "M256 56c0-13.3-10.7-24-24-24L120 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32-88 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-240c0-35.3-28.7-64-64-64l-32 0 0-16c0-8.8-7.2-16-16-16L400 80c-8.8 0-16 7.2-16 16l0 16-184 0 0-32 32 0c13.3 0 24-10.7 24-24zM576 160c8.8 0 16 7.2 16 16l0 240c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-240c0-8.8 7.2-16 16-16l512 0zM200 400a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM184 240c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zM513.5 369.5A104 104 0 1 0 366.5 222.5 104 104 0 1 0 513.5 369.5zM490.9 245.1c6.2 6.2 6.2 16.4 0 22.6L457 301.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faAxe = {
  prefix: 'far',
  iconName: 'axe',
  icon: [640, 512, [129683], "f6b2", "M486.6 9.4c-12.5-12.5-32.8-12.5-45.3 0L408 42.7 374.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3L384 301.3l0 82.7c0 17.7 14.3 32 32 32c123.7 0 224-100.3 224-224c0-17.7-14.3-32-32-32l-82.7 0-56-56 33.4-33.4c12.5-12.5 12.5-32.8 0-45.3l-16-16zM305.4 267.9l-61.3-61.3L9.4 441.4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0L305.4 267.9zm185.9-73.9c9 9 21.2 14.1 33.9 14.1l66 0c-7.6 84.4-74.8 151.7-159.3 159.3l0-66c0-12.7-5.1-24.9-14.1-33.9L278.6 128 352 54.6 491.3 193.9z"]
};
const faSquareD = {
  prefix: 'far',
  iconName: 'square-d',
  icon: [448, 512, [], "e268", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm24 208l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z"]
};
const faGripVertical = {
  prefix: 'far',
  iconName: 'grip-vertical',
  icon: [320, 512, [], "f58e", "M40 440l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zm192-40l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 232l48 0 0 48-48 0 0-48zM0 280c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40zM40 72l48 0 0 48-48 0 0-48zM0 120c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32C17.9 32 0 49.9 0 72l0 48zm232 0l0-48 48 0 0 48-48 0zm0 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40z"]
};
const faMobileSignalOut = {
  prefix: 'far',
  iconName: 'mobile-signal-out',
  icon: [512, 512, [], "e1f0", "M64 48l160 0 0-48L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-160-48 0 0 160c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm80 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0zM280 0c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24C512 103.9 408.1 0 280 0zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM256 120c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"]
};
const faHexagonNodes = {
  prefix: 'far',
  iconName: 'hexagon-nodes',
  icon: [448, 512, [], "e699", "M224 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-24c0 26.9-16.5 49.9-40 59.3l0 73.3c23.5 9.5 40 32.5 40 59.3c0 3.4-.3 6.7-.8 10l58.2 34.9c4.5-3.4 9.4-6.1 14.5-8.2l0-73.3c-5.2-2.1-10-4.8-14.5-8.2l-29.4 17.6c-4.7-15.8-13.3-29.9-24.7-41.1l29.4-17.6c-4-25.4 7.7-51.7 31.2-65.4c30.6-17.7 69.8-7.2 87.4 23.4s7.2 69.8-23.4 87.4c-2.6 1.5-5.3 2.8-8 3.9l0 73.3c2.7 1.1 5.4 2.4 8 3.9c30.6 17.7 41.1 56.8 23.4 87.4s-56.8 41.1-87.4 23.4c-23.6-13.6-35.2-40-31.2-65.4l-58.2-34.9c-4.4 3.3-9.3 6.1-14.5 8.2l0 73.3c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-3.4 .3-6.7 .8-10l-58.2-34.9c-4.5 3.4-9.4 6.1-14.6 8.2l0 73.3c5.1 2.1 10 4.8 14.5 8.2l29.4-17.6c4.7 15.8 13.3 29.9 24.7 41.1L127.2 342c4 25.4-7.6 51.8-31.2 65.4C65.4 425.1 26.3 414.6 8.6 384S1.4 314.3 32 296.6c2.6-1.5 5.3-2.8 8-3.9l0-73.3c-2.7-1.1-5.4-2.4-8-3.9C1.4 197.8-9.1 158.6 8.6 128S65.4 86.9 96 104.6c23.6 13.6 35.2 40 31.2 65.4l58.2 34.9c4.4-3.3 9.3-6.1 14.5-8.2l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-35.3 28.7-64 64-64s64 28.7 64 64zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm172-99.2a24 24 0 1 0 -24-41.6 24 24 0 1 0 24 41.6zM84.8 172A24 24 0 1 0 43.2 148a24 24 0 1 0 41.6 24zM248 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM43.2 364a24 24 0 1 0 41.6-24A24 24 0 1 0 43.2 364zM396 331.2a24 24 0 1 0 -24 41.6 24 24 0 1 0 24-41.6z"]
};
const faArrowTurnUp = {
  prefix: 'far',
  iconName: 'arrow-turn-up',
  icon: [384, 512, ["level-up"], "f148", "M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z"]
};
const faLevelUp = faArrowTurnUp;
const faU = {
  prefix: 'far',
  iconName: 'u',
  icon: [384, 512, [117], "55", "M24 32c13.3 0 24 10.7 24 24l0 232c0 79.5 64.5 144 144 144s144-64.5 144-144l0-232c0-13.3 10.7-24 24-24s24 10.7 24 24l0 232c0 106-86 192-192 192S0 394 0 288L0 56C0 42.7 10.7 32 24 32z"]
};
const faArrowUpFromDottedLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-dotted-line',
  icon: [448, 512, [], "e09b", "M241.5 39.6C236.9 34.7 230.6 32 224 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L200 116.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM32 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faSquareRootVariable = {
  prefix: 'far',
  iconName: 'square-root-variable',
  icon: [576, 512, ["square-root-alt"], "f698", "M344.3 80c-3.6 0-6.7 2.4-7.7 5.8L231.1 462.5c-2.6 9.4-10.7 16.3-20.5 17.4s-19.1-3.9-23.8-12.5L83.9 276.2c-1.4-2.6-4.1-4.2-7-4.2L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l52.9 0c20.6 0 39.5 11.3 49.3 29.5l74.7 138.8L290.3 72.9C297.1 48.7 319.2 32 344.3 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L344.3 80zM399 239c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faSquareRootAlt = faSquareRootVariable;
const faLightSwitchOn = {
  prefix: 'far',
  iconName: 'light-switch-on',
  icon: [384, 512, [], "e019", "M169.4 48c3.3 9.3 12.2 16 22.6 16s19.3-6.7 22.6-16L320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-105.4 0c-3.3-9.3-12.2-16-22.6-16s-19.3 6.7-22.6 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l105.4 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm80 256l96 0 0 112-96 0 0-112zm0-160c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-96 0z"]
};
const faArrowDownArrowUp = {
  prefix: 'far',
  iconName: 'arrow-down-arrow-up',
  icon: [576, 512, ["sort-alt"], "f883", "M47 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L184 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L81 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM399 39l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L392 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L433 39c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faSortAlt = faArrowDownArrowUp;
const faRaindrops = {
  prefix: 'far',
  iconName: 'raindrops',
  icon: [448, 512, [], "f75c", "M105.9 106.6l41.9-67.8C150.4 34.6 155 32 160 32s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9l0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-2.5c0-12.3 3.4-24.4 9.9-34.9zm-96 192l41.9-67.8C54.4 226.6 59 224 64 224s9.6 2.6 12.2 6.8l41.9 67.8c6.5 10.5 9.9 22.6 9.9 34.9l0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-2.5c0-12.3 3.4-24.4 9.9-34.9zm242.6 11.5c-8.2 12.7-12.5 27.6-12.5 42.7c0 43.4 35.9 79.2 80 79.2s80-35.8 80-79.2c0-15.1-4.3-30-12.5-42.7L320 204.6 252.5 310.1zm-40.4-25.9l95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5C441 304.7 448 328.5 448 352.8C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"]
};
const faDash = {
  prefix: 'far',
  iconName: 'dash',
  icon: [512, 512, ["minus-large"], "e404", "M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z"]
};
const faMinusLarge = faDash;
const faClock = {
  prefix: 'far',
  iconName: 'clock',
  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faClockFour = faClock;
const faInputNumeric = {
  prefix: 'far',
  iconName: 'input-numeric',
  icon: [640, 512, [], "e1bd", "M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm40 120c0 13.3 10.7 24 24 24l8 0 0 96-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-120c0-13.3-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24zm190.6 30.4c5.7-8 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.2 0 34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9l-11.1 15.6c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]
};
const faTruckTow = {
  prefix: 'far',
  iconName: 'truck-tow',
  icon: [640, 512, [], "e2b8", "M96 64l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16L64 32C64 20.2 70.4 9.8 80 4.3C84.7 1.6 90.2 0 96 0l21.7 0 28 0c9.1 0 17.8 3.9 23.9 10.7L373.3 240l10.7 0 0-88c0-30.9 25.1-56 56-56l50.1 0c20.9 0 40.7 9.1 54.4 24.8l81.8 94.4c8.8 10.2 13.7 23.2 13.7 36.7L640 360c0 30.9-25.1 56-56 56l-8 0c0 53-43 96-96 96s-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-8 0c-30.9 0-56-25.1-56-56l0-64c0-30.9 25.1-56 56-56l128 0L96 64zM243.2 368l153.7 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l20.8 0c4.4 0 8-3.6 8-8l0-72-160 0-16 0-32 0-32.2 0L208 288 56 288c-4.4 0-8 3.6-8 8l0 64c0 4.4 3.6 8 8 8l20.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48zM145.8 56.3L237.7 240l71.4 0L145.8 56.3zM584.2 240l-76-87.7c-4.6-5.3-11.2-8.3-18.1-8.3L440 144c-4.4 0-8 3.6-8 8l0 88 152.2 0zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faBackwardStep = {
  prefix: 'far',
  iconName: 'backward-step',
  icon: [320, 512, ["step-backward"], "f048", "M80 88c0-13.3-10.7-24-24-24S32 74.7 32 88l0 138.7 0 58.6L32 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-105.1L256.7 442.6c5.1 3.5 11.1 5.4 17.3 5.4c16.6 0 30.1-13.5 30.1-30.1l0-323.8C304 77.5 290.5 64 273.9 64c-6.2 0-12.2 1.9-17.3 5.4L80 193.1 80 88zm0 172.3l0-8.6L256 128.5l0 255L80 260.3z"]
};
const faStepBackward = faBackwardStep;
const faPallet = {
  prefix: 'far',
  iconName: 'pallet',
  icon: [640, 512, [], "f482", "M24 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 96-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 232 0 232 0 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-96 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0-232 0L88 320l-64 0zm88 48l184 0 0 96-184 0 0-96zm232 0l184 0 0 96-184 0 0-96z"]
};
const faCarBolt = {
  prefix: 'far',
  iconName: 'car-bolt',
  icon: [512, 512, [], "e341", "M127.7 106.8L103.4 176l24.6 0 0 48-32 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-32 0 0-48 24.6 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM315.2 116.6c5.3 5.2 6.3 13.3 2.5 19.6L284.3 192l51.7 0c7.1 0 13.4 4.7 15.4 11.6s-.8 14.2-6.9 18l-128 80c-6.3 3.9-14.4 3-19.7-2.2s-6.3-13.3-2.5-19.6L227.7 224 176 224c-7.1 0-13.4-4.7-15.4-11.6s.8-14.2 6.9-18l128-80c6.3-3.9 14.4-3 19.7 2.2z"]
};
const faArrowsMaximize = {
  prefix: 'far',
  iconName: 'arrows-maximize',
  icon: [512, 512, ["expand-arrows"], "f31d", "M328 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l70.1 0L256 222.1 113.9 80 184 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32C42.7 32 32 42.7 32 56l0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-70.1L222.1 256 80 398.1 80 328c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-70.1 0L256 289.9 398.1 432 328 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 70.1L289.9 256 432 113.9l0 70.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-13.3-10.7-24-24-24L328 32z"]
};
const faExpandArrows = faArrowsMaximize;
const faFaucet = {
  prefix: 'far',
  iconName: 'faucet',
  icon: [512, 512, [], "e005", "M224 64c13.3 0 24 10.7 24 24l0 21L352 96c17.7 0 32 14.3 32 32s-14.3 32-32 32L248 147l0 45 26.7 0c14.9 0 29.1 5.9 39.6 16.4L329.9 224l30.1 0c83.9 0 152 68.1 152 152l0 16c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56c0-4.4-3.6-8-8-8l-20.1 0c-23.4 29.2-59.5 48-99.9 48s-76.5-18.8-99.9-48L24 384c-13.3 0-24-10.7-24-24s10.7-24 24-24l112.3 0c8.2 0 15.8 4.2 20.2 11.1C170.8 369.3 195.7 384 224 384s53.2-14.7 67.4-36.9c4.4-6.9 12-11.1 20.2-11.1l32.3 0c30.9 0 56 25.1 56 56c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-16c0-57.4-46.6-104-104-104l-40 0c-6.4 0-12.5-2.5-17-7l-22.6-22.6c-1.5-1.5-3.5-2.3-5.7-2.3l-93.5 0c-2.1 0-4.2 .8-5.7 2.3L153 265c-4.5 4.5-10.6 7-17 7L24 272c-13.3 0-24-10.7-24-24s10.7-24 24-24l102.1 0 15.6-15.6c10.5-10.5 24.7-16.4 39.6-16.4l18.7 0 0-45L96 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l104 13 0-21c0-13.3 10.7-24 24-24z"]
};
const faCloudSleet = {
  prefix: 'far',
  iconName: 'cloud-sleet',
  icon: [512, 512, [], "f741", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm272 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM216 376c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16zm256 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16z"]
};
const faLampStreet = {
  prefix: 'far',
  iconName: 'lamp-street',
  icon: [512, 512, [], "e1c5", "M48 172c0-68.5 55.5-124 124-124c65 0 118.3 50 123.6 113.5c-84 10.7-151.1 75.6-164.9 158.6C127.7 337.6 142.3 352 160 352l320 0c17.7 0 32.3-14.4 29.4-31.9C495.5 236.9 428 171.8 343.7 161.4C338.2 71.4 263.4 0 172 0C77 0 0 77 0 172L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-316zM455.8 304l-271.6 0c19.8-55.9 73.1-96 135.8-96s116.1 40.1 135.8 96zM320 448c35.3 0 64-28.7 64-64l-128 0c0 35.3 28.7 64 64 64z"]
};
const faListRadio = {
  prefix: 'far',
  iconName: 'list-radio',
  icon: [512, 512, [], "e1d0", "M64 32a64 64 0 1 0 0 128A64 64 0 1 0 64 32zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM64 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM40 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 0 416a64 64 0 1 0 128 0z"]
};
const faPenNibSlash = {
  prefix: 'far',
  iconName: 'pen-nib-slash',
  icon: [640, 512, [], "e4a1", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L448.6 326.3 476.2 225l10.4-10.4 71-71c21.9-21.9 21.9-57.3 0-79.2L511.6 18.3c-21.9-21.9-57.3-21.9-79.2 0l-71 71L351 99.8 209 138.5 38.8 5.1zM256.1 175.4l104.8-28.6 68.3 68.3-21.6 79.1L256.1 175.4zM272 352c13.5 0 25.7-5.6 34.4-14.6l-75-59.1c-4.7 7.4-7.4 16.2-7.4 25.7c0 7.4 1.7 14.4 4.7 20.7L126.5 426.9l63.6-181.1-39.8-31.4L71 440c-6.5 18.5-1.8 39.1 12 52.9s34.4 18.5 52.9 12l264.1-92.8 .8-.3-44.7-35.2L149.1 449.5 251.3 347.3c6.3 3 13.3 4.7 20.7 4.7z"]
};
const faBaseballBatBall = {
  prefix: 'far',
  iconName: 'baseball-bat-ball',
  icon: [512, 512, [], "f432", "M372 17.5C383.8 6.3 399.5 0 415.7 0c16.8 0 32.9 6.7 44.7 18.5l33 33c11.9 11.9 18.5 28 18.5 44.7c0 16.3-6.3 31.9-17.5 43.7L356.3 284.7c-14.1 14.8-30.3 27.5-48 37.8L201.8 384.2c-12.6 7.3-24.3 16.3-34.6 26.6l-38.6 38.6c-.3-.3-.6-.7-1-1l-64-64c-.3-.3-.7-.6-1-1l38.6-38.6c10.3-10.3 19.3-22 26.6-34.6l61.6-106.5c10.3-17.7 23-33.9 37.8-48L372 17.5zM171.9 329.9l10.2 10.2L284.2 281c13.8-8 26.4-17.9 37.3-29.4L459.8 106.8c2.7-2.8 4.2-6.6 4.2-10.5c0-4-1.6-7.9-4.5-10.8l-33-33c-2.9-2.9-6.7-4.5-10.8-4.5c-3.9 0-7.7 1.5-10.5 4.2L260.4 190.4c-11.5 11-21.4 23.6-29.4 37.3L171.9 329.9zM464 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM15 399c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L15 433c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faSquareUpLeft = {
  prefix: 'far',
  iconName: 'square-up-left',
  icon: [448, 512, [], "e282", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 313.4L128 176c0-8.8 7.2-16 16-16l137.4 0c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16L264 232l66.3 66.3c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C290 366 285.1 368 280 368s-10-2-13.7-5.7L200 296l-33.4 33.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6z"]
};
const faOverline = {
  prefix: 'far',
  iconName: 'overline',
  icon: [448, 512, [], "f876", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zm200 80c-97.2 0-176 78.8-176 176l0 16c0 97.2 78.8 176 176 176s176-78.8 176-176l0-16c0-97.2-78.8-176-176-176zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16z"]
};
const faS = {
  prefix: 'far',
  iconName: 's',
  icon: [320, 512, [115], "53", "M91.2 90.6c-24 10.1-37.9 26.2-41.8 48c-2.8 16.1-1 27.4 2.8 35.7c3.8 8.5 10.6 16.1 21.1 23.3c22.1 15.1 54.9 24.6 93.2 35.3c.8 .2 1.6 .4 2.4 .7c35.3 9.9 75.6 21.2 104.9 41.2c15.6 10.6 29.3 24.5 37.7 43.1c8.5 18.7 10.6 40 6.4 63.9c-7.2 40.8-34.4 68.8-70.5 83.9c-35.3 14.8-79.6 17.8-125.7 10.7l-.1 0c-24.5-3.9-64.3-17.2-90.9-26.2c-5.3-1.8-10-3.4-14-4.7C4 441.4-2.9 427.8 1.2 415.2s17.7-19.5 30.3-15.4c4.9 1.6 10.5 3.5 16.3 5.4c26.9 9 61.2 20.4 81.3 23.6c40.4 6.2 75.1 2.9 99.8-7.5c24-10.1 37.9-26.2 41.8-48c2.8-16.1 1-27.4-2.8-35.7c-3.8-8.5-10.6-16.1-21.1-23.3c-22.1-15.1-54.9-24.6-93.2-35.3l-2.4-.7c-35.3-9.9-75.6-21.2-104.9-41.2c-15.6-10.6-29.3-24.5-37.7-43.1c-8.5-18.7-10.6-40-6.4-63.9l23.6 4.2L2.1 130.3C9.3 89.5 36.5 61.5 72.6 46.4c35.3-14.8 79.6-17.8 125.7-10.7c13.7 2.1 55.1 9.9 69.7 13.8c12.8 3.3 20.5 16.5 17.2 29.3s-16.5 20.5-29.3 17.2c-12.4-3.2-52-10.8-64.9-12.8l3.6-23.7L191 83.1c-40.4-6.2-75.2-2.9-99.9 7.5z"]
};
const faTimeline = {
  prefix: 'far',
  iconName: 'timeline',
  icon: [640, 512, [], "e29c", "M128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24 108.3c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 35.8 23.5 66.1 56 76.3l0 59.7-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0 0 59.7c-32.5 10.2-56 40.5-56 76.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-59.7 272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-59.7c32.5-10.2 56-40.5 56-76.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 35.8 23.5 66.1 56 76.3l0 59.7-336 0 0-59.7zM320 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faKeyboard = {
  prefix: 'far',
  iconName: 'keyboard',
  icon: [576, 512, [9000], "f11c", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM176 320l224 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16zm16-96l16 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16z"]
};
const faArrowsFromDottedLine = {
  prefix: 'far',
  iconName: 'arrows-from-dotted-line',
  icon: [448, 512, [], "e0a3", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-86.1zM32 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faUsbDrive = {
  prefix: 'far',
  iconName: 'usb-drive',
  icon: [640, 512, [], "f8e9", "M64 144c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l336 0 0-224L64 144zM0 160c0-35.3 28.7-64 64-64l352 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32L64 416c-35.3 0-64-28.7-64-64L0 160zm608-32c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-128 0 0-256 128 0zm-48 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM536 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"]
};
const faBallot = {
  prefix: 'far',
  iconName: 'ballot',
  icon: [448, 512, [], "f732", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L96 96c-8.8 0-16 7.2-16 16zM96 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM80 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM200 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faCaretDown = {
  prefix: 'far',
  iconName: 'caret-down',
  icon: [320, 512, [], "f0d7", "M160 329.4L249.4 240 70.6 240 160 329.4zm22.6 45.3c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
};
const faLocationDotSlash = {
  prefix: 'far',
  iconName: 'location-dot-slash',
  icon: [640, 512, ["map-marker-alt-slash"], "f605", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4l-57.7-45.2C385.3 245.1 400 220.3 400 192c0-44.2-35.8-80-80-80c-35.1 0-65 22.7-75.7 54.1l-52-40.7zM318 223.9l-28.5-22.4c-.9-3-1.5-6.2-1.5-9.6c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-.7 0-1.3 0-2-.1zM191.3 249.2c-.5-1.2-1-2.5-1.5-3.7l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9z"]
};
const faMapMarkerAltSlash = faLocationDotSlash;
const faCards = {
  prefix: 'far',
  iconName: 'cards',
  icon: [640, 512, [], "e3ed", "M244.7 49c3.7-2.1 8.4-.9 10.5 2.8l167 289.3c2.1 3.7 .9 8.4-2.8 10.5L226.5 463c-3.7 2.1-8.4 .9-10.5-2.8L49 170.9c-2.1-3.7-.9-8.4 2.8-10.5L244.7 49zM27.8 118.8C1.2 134.2-7.9 168.2 7.5 194.9l167 289.3c15.4 26.6 49.4 35.8 76.1 20.4L443.4 393.2c26.6-15.4 35.8-49.4 20.4-76.1L296.8 27.8C281.4 1.2 247.3-7.9 220.7 7.5L27.8 118.8zM324.1 499c9.7 8.1 22.2 13 35.9 13l224 0c30.9 0 56-25.1 56-56l0-336c0-30.9-25.1-56-56-56L360 64c-1.8 0-3.5 .1-5.3 .2L491.5 301.1c24.2 41.9 9.8 95.6-32.1 119.8L324.1 499zM582 187.6l-48.2 49.9c-3.2 3.2-8.5 3.2-11.5 0l-48.4-49.9c-14-14.5-13.2-38.5 2.5-51.9c13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2c15.5 13.5 16.2 37.5 2.2 51.9zM171.4 174.3l-7.2 26.9-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.4-8.8c.1-.4 .2-.8 .3-1.1l17.7 30.7-12.1 7c-6.7 3.8-8.9 12.4-5.1 19s12.4 8.9 19 5.1l48.2-27.8c6.7-3.8 8.9-12.4 5.1-19s-12.4-8.9-19-5.1l-12.1 7-17.7-30.7c.4 .1 .8 .2 1.1 .3l8.8 2.4c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4L197 159.6c-11.1-3-22.6 3.6-25.6 14.8z"]
};
const faHouseChimneyMedical = {
  prefix: 'far',
  iconName: 'house-chimney-medical',
  icon: [576, 512, ["clinic-medical"], "f7f2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM272 192l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16z"]
};
const faClinicMedical = faHouseChimneyMedical;
const faBoxingGlove = {
  prefix: 'far',
  iconName: 'boxing-glove',
  icon: [448, 512, [129354, "glove-boxing"], "f438", "M48 120c0-39.8 32.2-72 72-72l152 0c39.8 0 72 32.2 72 72l0 8-32 0c-40.3 0-74.2 27.1-84.7 64l-59.8 0c-19.9 0-36.8-14.6-39.6-34.3l-.2-1.1c-1.9-13.1-14-22.2-27.2-20.4s-22.2 14-20.4 27.2l.2 1.1c6.2 43.4 43.3 75.6 87.1 75.6l59.8 0c10.4 36.9 44.4 64 84.7 64c13.3 0 24-10.7 24-24s-10.7-24-24-24c-22.1 0-40-17.9-40-40s17.9-40 40-40l51.1 0c.6 .1 1.2 .2 1.9 .3c19.7 2.5 35 19.3 35 39.7l0 38.9c0 14.9-5.9 29.1-16.4 39.6l-60.9 60.9c-12 12-18.7 28.3-18.7 45.3l0 47.4c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-88.4c0-6.8-2.9-13.3-8-17.9C57.2 328.5 48 309.3 48 288l0-168zM120 0C53.7 0 0 53.7 0 120L0 288c0 31.5 12.2 60.2 32 81.6L32 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-47.4c0-4.2 1.7-8.3 4.7-11.3l60.9-60.9c19.5-19.5 30.5-46 30.5-73.5l0-38.9c0-37.3-23.2-69.2-56-82l0-14C392 53.7 338.3 0 272 0L120 0zm32.9 346.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L192 411.2l39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 372.8l-39.1-26.1z"]
};
const faGloveBoxing = faBoxingGlove;
const faTemperatureThreeQuarters = {
  prefix: 'far',
  iconName: 'temperature-three-quarters',
  icon: [320, 512, ["temperature-3", "thermometer-3", "thermometer-three-quarters"], "f2c8", "M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 152c0-8.8 7.2-16 16-16s16 7.2 16 16l0 170.7c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature3 = faTemperatureThreeQuarters;
const faThermometer3 = faTemperatureThreeQuarters;
const faThermometerThreeQuarters = faTemperatureThreeQuarters;
const faBellSchool = {
  prefix: 'far',
  iconName: 'bell-school',
  icon: [512, 512, [], "f5d5", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM352 358.1c39.4-37.9 64-91.1 64-150.1C416 93.1 322.9 0 208 0S0 93.1 0 208c0 59 24.6 112.2 64 150.1L64 448c0 35.3 28.7 64 64 64l144 0 16 0 128 0c39.2 0 71.1-31.4 72-70.4c14.4-8.3 24-23.8 24-41.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 17.7 9.6 33.2 24 41.5c-.8 12.5-11.2 22.5-24 22.5l-66 0c1.3-5.1 2-10.5 2-16l0-89.9zM288 464l-16 0-144 0c-8.8 0-16-7.2-16-16l0-55.4c28.7 15 61.4 23.4 96 23.4s67.3-8.5 96-23.4l0 55.4c0 8.8-7.2 16-16 16zM208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"]
};
const faMobileScreen = {
  prefix: 'far',
  iconName: 'mobile-screen',
  icon: [384, 512, ["mobile-android-alt"], "f3cf", "M64 448c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-80L64 368l0 80zm0-128l256 0 0-256c0-8.8-7.2-16-16-16L80 48c-8.8 0-16 7.2-16 16l0 256zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faMobileAndroidAlt = faMobileScreen;
const faPlaneUp = {
  prefix: 'far',
  iconName: 'plane-up',
  icon: [512, 512, [], "e22d", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 150.2 96.1c16.1 10.3 25.8 28.1 25.8 47.2l0 40.6c0 27.1-26.4 46.4-52.2 38.1L336 336.6l0 27.4 48 36c10.1 7.6 16 19.4 16 32l0 42.1c0 20.9-17 37.9-37.9 37.9c-3.8 0-7.5-.6-11.1-1.7L256 481.1l-94.9 29.2c-3.6 1.1-7.4 1.7-11.1 1.7C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm21.5 54.2c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 24.4 88.9-27.4c4.6-1.4 9.5-1.4 14.1 0L352 460.4l0-24.4-54.4-40.8c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5L464 327.1l0-29.6c0-2.7-1.4-5.3-3.7-6.7L299.1 187.6c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7zM146.9 464.4s0 0 0 0c0 0 0 0 0 0z"]
};
const faFolderHeart = {
  prefix: 'far',
  iconName: 'folder-heart',
  icon: [512, 512, [], "e189", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM144 253.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
const faCircleLocationArrow = {
  prefix: 'far',
  iconName: 'circle-location-arrow',
  icon: [512, 512, ["location-circle"], "f602", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.2-73.3l-84 196c-3.5 8.1-11.4 13.3-20.2 13.3c-1.4 0-2.9-.1-4.4-.4C239.4 389.5 232 380.4 232 370l0-90-90 0c-10.4 0-19.5-7.4-21.5-17.6c-2.1-10.2 3.3-20.5 12.9-24.6l196-84c8.5-3.5 18-1.7 24.2 4.7c6.4 6.3 8.2 15.9 4.7 24.2z"]
};
const faLocationCircle = faCircleLocationArrow;
const faFaceHeadBandage = {
  prefix: 'far',
  iconName: 'face-head-bandage',
  icon: [576, 512, [], "e37a", "M71.3 354c6.6-9.7 13.4-19.2 20.6-28.4C120.5 406.2 197.5 464 288 464c114.9 0 208-93.1 208-208c0-13.2-1.2-26.2-3.6-38.7c11.9 3 23.7 6.3 35.4 9.8l15 4.5c.8 8 1.1 16.2 1.1 24.4c0 141.4-114.6 256-256 256c-99.5 0-185.8-56.8-228.2-139.8c2.5-3.8 4.8-7.5 6.7-10.7c1.9-3.1 3.5-5.7 4.7-7.5zM218.5 209.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c13.5-10.8 27.6-20.9 42.1-30.4zM368.1 12.8c-45.1 9.1-88.5 23-129.6 41.1c-13.9 3.4-27.2 8.2-39.8 14.2c-33.5 3.1-66.5 7.9-98.9 14.3C146.6 31.8 213.6 0 288 0c28 0 54.9 4.5 80.1 12.8zm-.3 382.7C352.2 381.2 328.4 368 296 368c-12.3 0-23.2 1.9-32.8 4.9c-12.6 4-26.1-3-30.1-15.7s3-26.1 15.7-30.1c14.2-4.5 30-7.1 47.2-7.1c46.5 0 81.4 19.3 104.2 39.9c9.8 8.9 10.5 24.1 1.6 33.9s-24.1 10.5-33.9 1.6zM336.4 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4c20.8 12.6 39.7 28 56.1 45.7C419.3 71.1 360.6 64.9 300.6 64.1zM406 103.4c34 4.3 67.3 10.5 100.1 18.3c14.1 22.8 24.6 47.9 31 74.7C458.2 172.7 374.6 160 288 160c-17.1 0-34.1 .5-51 1.5c-47.8 2.8-94.6 9.4-140 19.7c-19.6 4.4-39 9.5-58.1 15.3c6.4-26.8 17-51.9 31-74.7c48.4-11.6 98.2-19.5 149.3-23.2C241.9 96.8 264.9 96 288 96c40 0 79.3 2.5 118 7.4zM50.3 226.4c41-12.2 83.3-21.3 126.6-27.1c-51.6 37.5-96.5 83.8-132.2 136.7C36.5 310.9 32 284 32 256c0-3 .1-6.1 .2-9.1c5.9-7 12-13.8 18.2-20.5z"]
};
const faSushiRoll = {
  prefix: 'far',
  iconName: 'sushi-roll',
  icon: [448, 512, ["maki-roll", "makizushi"], "e48b", "M400 207.7c-13.2 11.2-29 19.7-45 26.1C319 248.2 272.7 256 224 256s-95-7.8-131-22.2c-16-6.4-31.9-14.9-45-26.1L48 368c0 3 3.6 18.5 39.1 36.3C119.6 420.5 168 432 224 432s104.4-11.5 136.9-27.7C396.4 386.5 400 371 400 368l0-160.3zM64 144c0 10.4 6.2 20.1 17.1 28.8c20.4-23.3 45.9-40.4 70.3-52.7c20.1-10.1 40.2-17.3 57.5-21.9c-1.7-5.8-3-11.7-3.8-17.7C125.7 84.2 64 111.2 64 144zm54 47.9c28.2 10 65.4 16.1 106 16.1c30.9 0 59.8-3.5 84.2-9.6c-35.3-13.5-63.8-36.1-82-63.4c-16 3.8-36.4 10.5-56.9 20.8c-18.6 9.3-36.6 21.3-51.4 36.1zM384 144c0-32.4-60.1-59.2-138.2-63.4c9.3 42.5 53.3 85.3 122.8 90.8c9.8-8.3 15.4-17.6 15.4-27.4zM224 32c123.7 0 224 50.1 224 112l0 224c0 61.9-100.3 112-224 112S0 429.9 0 368L0 144C0 82.1 100.3 32 224 32z"]
};
const faMakiRoll = faSushiRoll;
const faMakizushi = faSushiRoll;
const faCarBump = {
  prefix: 'far',
  iconName: 'car-bump',
  icon: [640, 512, [], "f5e0", "M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1s0 0 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5zM584.8 512c19.5 0 34.7-17.7 25.8-35c-18.6-36.2-56.3-61-99.7-61s-81.2 24.8-99.7 61c-8.9 17.3 6.3 35 25.8 35l147.9 0z"]
};
const faPiggyBank = {
  prefix: 'far',
  iconName: 'piggy-bank',
  icon: [576, 512, [], "f4d3", "M277.1 48c23 0 42.5 14.7 49.8 35.2c4.4 12.5 18.1 19 30.6 14.6s19-18.1 14.6-30.6C358.3 28.1 321 0 277.1 0S195.8 28.1 182 67.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6C234.5 62.7 254.1 48 277.1 48zM66.7 197.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-4.7 2.3C15.7 169.3 0 194.7 0 222.6c0 37.4 28 68.3 64.2 72.9C66.4 344.7 91 388.2 128 416l0 48c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-16 48 0 0 16c0 26.5 21.5 48 48 48l48 0c26.5 0 48-21.5 48-48l0-37.4c18.7-10.8 35.1-25.4 48-42.6l32 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-13.3 0c-8.2-18.8-19.9-35.7-34.2-49.8l11.3-36.8-22.9-7 22.9 7c6.3-20.6-9.1-41.4-30.6-41.4L456 96c-31.5 0-60.2 12.2-81.6 32L224 128c-74.4 0-137 50.8-154.9 119.6c-12-2-21.1-12.5-21.1-25.1c0-9.6 5.4-18.4 14.1-22.8l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM402.3 168c13.1-14.7 32.1-23.9 53.2-24L446 174.8c-2.9 9.4 .2 19.6 7.9 25.8c17.4 13.9 30.4 32.8 37.1 54.5c3.1 10.1 12.4 17 22.9 17l14 0 0 64-28.6 0c-8.3 0-16 4.3-20.3 11.3c-11.7 18.7-28.7 33.7-48.9 42.8C421.5 394 416 402.5 416 412l0 52-48 0 0-40c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 40-48 0 0-60.6c0-8.3-4.3-16-11.3-20.3c-31.7-19.8-52.7-55-52.7-95c0-61.9 50.1-112 112-112l160 0s0 0 0 0l.4 0c6.8 0 13.4-2.9 17.9-8z"]
};
const faRacquet = {
  prefix: 'far',
  iconName: 'racquet',
  icon: [512, 512, [], "f45a", "M349 48c31.9 0 61.1 10.9 82.6 32.4S464 131.2 464 163c0 40.6-17.7 84.9-52.9 120.1c-64 64-154.5 68.7-202.7 20.5C186.9 282.1 176 252.8 176 221c0-40.6 17.7-84.9 52.9-120.1S308.4 48 349 48zm0-48c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 17.2 2.4 34.3 7.3 50.6c8.2 27.4 7.6 58.9-9.9 80.6c-12.6-11.3-31.9-10.9-44 1.2l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.1-12.1 12.5-31.4 1.2-44c21.7-17.5 53.2-18 80.5-9.7c67.7 20.4 148.5-3.6 204.8-59.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM54.6 448L104 398.6l9.4 9.4L64 457.4 54.6 448z"]
};
const faCarMirrors = {
  prefix: 'far',
  iconName: 'car-mirrors',
  icon: [576, 512, [], "e343", "M197.4 80c-17 0-32.1 10.7-37.8 26.8L135.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L197.4 80zM44.8 224L40 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l44.6 0 29.8-85.1C126.7 55.6 160 32 197.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9L491.4 176l44.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-4.8 0c8.2 14.1 12.8 30.5 12.8 48l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L80 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-17.5 4.7-33.9 12.8-48zm83.2 0c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48l-320 0zm-16 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm320-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faIndustryWindows = {
  prefix: 'far',
  iconName: 'industry-windows',
  icon: [576, 512, [127981, "industry-alt"], "f3b3", "M80 88c0-4.4 3.6-8 8-8l48 0c4.4 0 8 3.6 8 8l0 126.7c0 8.6 4.6 16.5 12 20.8s16.6 4.2 24-.1L320 153.8l0 70.9c0 8.8 4.8 16.8 12.5 21.1s17.1 3.9 24.5-.8l139.1-89L496 304l0 16 0 88c0 13.3-10.7 24-24 24l-368 0c-13.3 0-24-10.7-24-24l0-56 0-48L80 88zm8-56C57.1 32 32 57.1 32 88l0 216 0 48 0 56c0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72l0-88 0-16 0-148.1c0-37.9-41.9-60.9-73.9-40.4L368 180.8l0-27c0-37-40.2-60.1-72.2-41.5L192 172.9 192 88c0-30.9-25.1-56-56-56L88 32zm56 264c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zm104 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm136-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0z"]
};
const faIndustryAlt = faIndustryWindows;
const faBoltAuto = {
  prefix: 'far',
  iconName: 'bolt-auto',
  icon: [576, 512, [], "e0b6", "M317.4 36.6C322.6 18.3 308.8 0 289.7 0c-6.8 0-13.5 2.4-18.7 6.9L11.8 228.6C4.3 235 0 244.4 0 254.3C0 272.9 15.1 288 33.7 288l86.4 0L66.6 475.4C61.4 493.7 75.2 512 94.3 512c6.8 0 13.4-2.4 18.6-6.8L371.7 285.6c7.8-6.6 12.3-16.4 12.3-26.6c0-19.3-15.6-34.9-34.9-34.9l-85.2 0L317.4 36.6zM72.4 240L253.6 85 208.9 241.4c-2.1 7.2-.6 15 3.9 21s11.6 9.5 19.2 9.5l81.5 0L130.3 427.5l44.8-156.9c2.1-7.2 .6-15-3.9-21s-11.6-9.5-19.2-9.5l-79.6 0zM464 288c-9.1 0-17.4 5.1-21.5 13.3l-88 176c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L410.8 472l106.3 0 13.4 26.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-88-176c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L493.2 424l-58.3 0L464 365.7z"]
};
const faBatteryHalf = {
  prefix: 'far',
  iconName: 'battery-half',
  icon: [576, 512, ["battery-3"], "f242", "M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm208 96L96 192l0 128 192 0 0-128z"]
};
const faBattery3 = faBatteryHalf;
const faFluxCapacitor = {
  prefix: 'far',
  iconName: 'flux-capacitor',
  icon: [448, 512, [], "f8ba", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM283.3 253.3c6.6 1.8 13.6 2.7 20.7 2.7c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80c7.2 0 14.1-.9 20.7-2.7l-49-49c-15.6-15.6-15.6-40.9 0-56.6s40.9-15.6 56.6 0L224 199.4l51.7-51.7c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-49 49zM180.4 268.9c-21.9 14.3-36.4 39-36.4 67.1c0 44.2 35.8 80 80 80s80-35.8 80-80c0-28.1-14.5-52.8-36.4-67.1l-3.6 3.6 0 63.4c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-63.4-3.6-3.6zM155.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L208 262.6l0 73.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73.4 75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"]
};
const faMountainCity = {
  prefix: 'far',
  iconName: 'mountain-city',
  icon: [640, 512, [], "e52e", "M344 48c-4.4 0-8 3.6-8 8l0 163.7-48-79.6L288 56c0-30.9 25.1-56 56-56L456 0c30.9 0 56 25.1 56 56l0 136 32 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72.6c27.1 3.9 48 27.2 48 55.4l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-4.4-3.6-8-8-8l-16 0-80 0c-13.3 0-24-10.7-24-24l0-160c0-4.4-3.6-8-8-8L344 48zm27.3 230.2c2.9-3.8 7.5-6.2 12.7-6.2l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-9.8 0-34.9-57.8zM384 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM368 192c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm128 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM224 188.9L154.5 304.1l21.3 30.8 28-37.3c4.5-6 11.6-9.6 19.2-9.6l60.8 0L224 188.9zM58 464L390 464 312.8 336 235 336l-40.8 54.4c-4.6 6.2-11.9 9.7-19.7 9.6s-14.9-4-19.3-10.4l-28-40.5L58 464zM253.4 144.7L442.9 458.9c6.5 10.8 6.7 24.3 .7 35.3s-17.6 17.8-30.1 17.8L34.5 512c-12.5 0-24-6.8-30.1-17.8s-5.8-24.5 .7-35.3L194.6 144.7C200.9 134.3 212 128 224 128s23.1 6.3 29.4 16.7z"]
};
const faCoins = {
  prefix: 'far',
  iconName: 'coins',
  icon: [512, 512, [], "f51e", "M176 88c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c.4 .3 .8 .7 1.2 1c-18.7 .4-36.9 1.7-54.4 4.1L128 88c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C226.4 7.5 271.5 0 320 0s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S512 70 512 88l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-9.6 3.7-20.1 6.9-31.3 9.6l0-49.7c5.1-1.5 9.8-3.1 14.2-4.8c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2c-13.7 5.2-29.4 9.6-46.3 12.9c-5.1-7.5-11-13.9-16.8-19.1c-10.1-9.1-21.8-16.5-34-22.6c31.7-2.3 59.3-8.2 80-16.1c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7C403.2 54.9 364.2 48 320 48s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM48 216c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c0 0 0-.5-.6-1.5c-.6-1.2-2-3.1-4.7-5.5c-5.5-5-14.9-10.6-28.5-15.7c-27-10.3-66-17.2-110.2-17.2s-83.2 6.9-110.2 17.2c-13.6 5.2-23 10.8-28.5 15.7c-2.7 2.4-4.1 4.3-4.7 5.5c-.6 1.1-.6 1.5-.6 1.5c0 0 0 0 0 0zM0 216c0-18 9.7-32.4 21.1-42.7s26.7-18.5 43.5-24.9C98.4 135.5 143.5 128 192 128s93.6 7.5 127.3 20.3c16.8 6.4 32.1 14.6 43.5 24.9S384 198 384 216l0 104 0 104c0 18-9.7 32.4-21.1 42.7s-26.7 18.5-43.5 24.9C285.6 504.5 240.5 512 192 512s-93.6-7.5-127.3-20.3c-16.8-6.4-32-14.6-43.5-24.9S0 442 0 424L0 320 0 216zM336 320l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 296.5 240.5 304 192 304s-93.6-7.5-127.3-20.3c-5.8-2.2-11.4-4.6-16.7-7.2L48 320c0 0 0 0 0 0c0 .1 .1 .6 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.5-.9 .6-1.4 .6-1.5c0 0 0 0 0 0c0 0 0 0 0 0zM64.7 387.7c-5.8-2.2-11.4-4.6-16.7-7.2L48 424s0 0 0 0c0 0 0 .5 .6 1.5c.6 1.2 2 3.1 4.7 5.5c5.5 5 14.9 10.6 28.5 15.7c27 10.3 66 17.2 110.2 17.2s83.2-6.9 110.2-17.2c13.6-5.2 23-10.8 28.5-15.7c2.7-2.4 4.1-4.3 4.7-5.5c.6-1.1 .6-1.5 .6-1.5c0 0 0 0 0 0l0-43.6c-5.3 2.6-10.9 5-16.7 7.2C285.6 400.5 240.5 408 192 408s-93.6-7.5-127.3-20.3z"]
};
const faHoneyPot = {
  prefix: 'far',
  iconName: 'honey-pot',
  icon: [448, 512, [127855], "e418", "M78.6 352c21.5 40.9 49 67 64.6 79.6c0 0 .1 0 .1 0c.4 .1 1.4 .4 3.1 .4l155.3 0c1.6 0 2.6-.2 3.1-.4c0 0 .1 0 .1 0c15.5-12.6 43.1-38.7 64.6-79.6L78.6 352zM48 224l352 0c0-79.5-64.5-144-144-144l-64 0c-5.4 0-10.7 .3-16 .9l0 55.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-41c-47.4 23.6-80 72.5-80 129zM56 32l96 0 40 0 64 0 136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-9 0c39.9 35.2 65 86.7 65 144c0 138.8-79.6 217.9-113.3 245.1c-9.3 7.5-21.1 10.9-33.1 10.9l-155.3 0c-12 0-23.7-3.3-33.1-10.9C79.6 441.9 0 362.8 0 224C0 166.7 25.1 115.2 65 80l-9 0C42.7 80 32 69.3 32 56s10.7-24 24-24z"]
};
const faOlive = {
  prefix: 'far',
  iconName: 'olive',
  icon: [448, 512, [], "e316", "M160 432C98.1 432 48 381.9 48 320c0-79.2 37-138.4 85.9-179.1C184.3 99 243.7 80 280 80c13.6 0 31.8 7.5 50.4 19.9c8.5 5.7 15.7 11.4 20.8 15.8c2.5 2.1 4.4 3.9 5.6 5c.6 .6 1 1 1.2 1.2l.1 .1 .1 .1c.2 .2 .6 .6 1.2 1.2c1.1 1.2 2.9 3.1 5 5.6c4.3 5 10.1 12.2 15.8 20.8C392.5 168.2 400 186.4 400 200c0 36.3-19 95.7-60.9 146.1C298.4 395 239.2 432 160 432zM0 320c0 88.4 71.6 160 160 160c192 0 288-181.9 288-280c0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zM271.1 208.9c30.3 30.3 69.6 40.1 87.8 21.9s8.4-57.5-21.9-87.8s-69.6-40.1-87.8-21.9s-8.4 57.5 21.9 87.8z"]
};
const faKhanda = {
  prefix: 'far',
  iconName: 'khanda',
  icon: [512, 512, [9772], "f66d", "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1s0 0 0 0s0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5l0 19.8 35.6-24.5c0 0 0 0 .1 0c0 0 0 0 0 0l41.1-28.2c72.1-49.6 86.2-151.1 39.1-221.7c-4-6-3.5-14 1.3-19.5s12.8-6.9 19.3-3.6c58.5 30 104.7 91.3 104.7 158.2c0 53.1-26.4 100.5-51.2 133.6c-14.8 19.7-31.7 38.7-50.6 54.7c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.1-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6c-19-15.9-35.8-35-50.6-54.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c15.4-15.4 32.7-29.2 52.2-39c6.5-3.2 14.3-1.7 19.2 3.7c6.9 7.8 3.4 16.3-1.5 23.7C76.1 162.6 95 262.9 164.4 310.6l41.1 28.2c0 0 0 0 .1 0L240 362.6l0-19.1-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9c0 0 0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1s0 0 0 0s0 0 0 0s0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1zM57.3 163C47 180.1 40 200.4 40 224c0 40.4 20.4 79.2 43.2 109.6c10 13.4 20.7 25.9 32 37l36-20.5-9.5-6.5C81.5 302.2 51.5 231.7 57.3 163zM429.9 333.6c22.8-30.4 43.2-69.2 43.2-109.6c0-24.3-7.4-45.1-18.2-62.5c6.7 68.5-20.8 138.9-83.6 182l-9.5 6.5 35.9 20.4c11.4-11.1 22.1-23.6 32.1-36.9z"]
};
const faFilterList = {
  prefix: 'far',
  iconName: 'filter-list',
  icon: [512, 512, [], "e17c", "M41.2 64C18.5 64 0 82.5 0 105.2c0 10.4 3.9 20.4 11 28.1l93 100.1 0 126c0 13.4 6.7 26 18 33.4l75.5 49.8c5.3 3.5 11.6 5.4 18 5.4c18 0 32.6-14.6 32.6-32.6l0-182 93-100.1c7.1-7.6 11-17.6 11-28.1C352 82.5 333.5 64 310.8 64L41.2 64zM145.6 207.7L56.8 112l238.5 0-88.8 95.7c-4.1 4.4-6.4 10.3-6.4 16.3l0 162.8-48-31.7L152 224c0-6.1-2.3-11.9-6.4-16.3zM344 392c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM320 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zM408 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
};
const faOutlet = {
  prefix: 'far',
  iconName: 'outlet',
  icon: [448, 512, [], "e01c", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM80 256c0-52.3 26.5-85.2 43.6-100.9c8.6-8 20.2-11.1 31.9-11.1l137 0c11.7 0 23.3 3.1 31.9 11.1c17 15.8 43.6 48.7 43.6 100.9s-26.5 85.2-43.6 100.9c-8.6 8-20.2 11.1-31.9 11.1l-137 0c-11.7 0-23.3-3.1-31.9-11.1C106.5 341.2 80 308.3 80 256zm96-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM200 296l0 16c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faSliders = {
  prefix: 'far',
  iconName: 'sliders',
  icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
};
const faSlidersH = faSliders;
const faCauldron = {
  prefix: 'far',
  iconName: 'cauldron',
  icon: [448, 512, [], "f6bf", "M160 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM74.2 252.5c9.6-17.7 20.1-33.2 28.6-44.5L224 208l121.2 0c8.5 11.4 19 26.9 28.6 44.5c15.9 29.2 26.2 58.5 26.2 81.9c0 39.2-18.3 70-49.4 92.5C318.3 450.2 272.6 464 224 464s-94.3-13.8-126.6-37.1C66.3 404.4 48 373.6 48 334.4c0-23.3 10.3-52.6 26.2-81.9zM44.6 208C22.5 243.4 0 290.8 0 334.4c0 37.4 11.9 69.4 32 95.5L32 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-15c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 15c0 13.3 10.7 24 24 24s24-10.7 24-24l0-58.1c20.1-26.1 32-58.1 32-95.5c0-43.6-22.5-91-44.6-126.4l20.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0-144 0L80 160l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l20.6 0z"]
};
const faPeople = {
  prefix: 'far',
  iconName: 'people',
  icon: [640, 512, [], "e216", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L176 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM144 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6 96 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM587.1 299.8c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7l-51.8-91.5c-19.8-35-56.9-56.6-97.1-56.6s-77.3 21.6-97.1 56.6l-51.8 91.5c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1l47.9-84.6-46.3 148c-3.2 10.3 4.5 20.8 15.3 20.8l26.2 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 26.2 0c10.8 0 18.5-10.5 15.3-20.8l-46.3-148 47.9 84.6zM526.7 336l-93.4 0L480 186.5 526.7 336z"]
};
const faFolderTree = {
  prefix: 'far',
  iconName: 'folder-tree',
  icon: [576, 512, [], "f802", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 136 0 392c0 30.9 25.1 56 56 56l200 0 0-48L56 400c-4.4 0-8-3.6-8-8l0-232 208 0 0-48L48 112l0-88zM336 176l0-128 44.1 0 17 17c9.6 9.6 22.6 15 36.2 15L528 80l0 96-192 0zM288 32l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L433.3 32c-.8 0-1.7-.3-2.3-.9L409.4 9.4c-6-6-14.1-9.4-22.6-9.4L320 0c-17.7 0-32 14.3-32 32zm48 432l0-128 44.1 0 17 17c9.6 9.6 22.6 15 36.2 15l94.7 0 0 96-192 0zM288 320l0 160c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-110.7 0c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4L320 288c-17.7 0-32 14.3-32 32z"]
};
const faNetworkWired = {
  prefix: 'far',
  iconName: 'network-wired',
  icon: [640, 512, [], "f6ff", "M400 48l0 96-160 0 0-96 160 0zM240 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l56 0 0 40L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0 0 40-56 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-56 0 0-40 272 0 0 40-56 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-56 0 0-40 112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0 0-40 56 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L240 0zM80 368l160 0 0 96L80 464l0-96zm480 0l0 96-160 0 0-96 160 0z"]
};
const faCroissant = {
  prefix: 'far',
  iconName: 'croissant',
  icon: [512, 512, [129360], "f7f6", "M323.7 242.1c2 18.9-4.5 38.1-18.4 51.9L294 305.3c-13.9 13.9-33 20.4-51.9 18.4L208 350.2l0 33.8 15.6 93.6c.3 1.6 .4 3.2 .4 4.9c0 16.3-13.2 29.6-29.6 29.6l-5.4 0c-4.2 0-8.3-.7-12.2-2.3c-35.8-14.3-67.5-36.5-93.2-64.3c-16.4 7.1-36 2.5-45.3-13.7C14 389.4 0 340.3 0 288c0-22.4 2.6-44.2 7.4-65.1C2.7 215.6 0 207 0 197.9c0-5 .8-10 2.5-14.6C33.2 99.6 99.6 33.2 183.3 2.5C188 .8 193 0 197.9 0c9.1 0 17.7 2.7 24.9 7.4C243.8 2.6 265.6 0 288 0c52.3 0 101.4 14 143.7 38.4c16.2 9.3 20.8 28.9 13.7 45.3c27.9 25.7 50 57.4 64.3 93.2c1.5 3.9 2.3 8 2.3 12.2l0 5.4c0 16.3-13.2 29.6-29.6 29.6c-1.6 0-3.3-.1-4.9-.4L384 208l-33.8 0-26.5 34.1zm-74.3-191l55.3 137.3L394.5 72.9C362.5 57 326.3 48 288 48c-13.1 0-26 1.1-38.6 3.1zM51.1 249.4C49.1 262 48 274.9 48 288c0 38.3 9 74.5 24.9 106.5l115.5-89.8L51.1 249.4zM388 160l3.9 .7 62 10.3c-10-17.9-22.6-34.3-37.2-48.4L387.6 160l.4 0zM171 453.9l-10.3-62L160 388l0-.4-37.4 29.1c14.2 14.6 30.5 27.2 48.4 37.2zm71.8-179c6 2.4 12.8 1 17.3-3.5l11.3-11.3c4.5-4.5 5.9-11.3 3.5-17.3l-78.2-194c-67.9 25.9-122 80-147.9 147.9l194 78.2z"]
};
const faMapPin = {
  prefix: 'far',
  iconName: 'map-pin',
  icon: [320, 512, [128205], "f276", "M64 144a96 96 0 1 1 192 0A96 96 0 1 1 64 144zM184 286c68.1-11.4 120-70.7 120-142C304 64.5 239.5 0 160 0S16 64.5 16 144c0 71.4 51.9 130.6 120 142l0 202c0 13.3 10.7 24 24 24s24-10.7 24-24l0-202z"]
};
const faHamsa = {
  prefix: 'far',
  iconName: 'hamsa',
  icon: [512, 512, [], "f665", "M184 104l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96 0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 176c0 13.3 10.7 24 24 24l48.4 0c8.6 0 15.6 7 15.6 15.6c0 4.1-1.6 8.1-4.6 11l-83.8 83.8C343.9 446.2 300.9 464 256 464s-87.9-17.8-119.6-49.5L52.6 330.6c-2.9-2.9-4.6-6.9-4.6-11C48 311 55 304 63.6 304l48.4 0c13.3 0 24-10.7 24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm7.8-64.6C182.2 34.7 171.4 32 160 32c-39.8 0-72 32.2-72 72l0 152-24.4 0C28.5 256 0 284.5 0 319.6c0 16.9 6.7 33 18.6 45l83.8 83.8c40.7 40.7 96 63.6 153.5 63.6s112.8-22.9 153.5-63.6l83.8-83.8c11.9-11.9 18.6-28.1 18.6-45c0-35.1-28.5-63.6-63.6-63.6L424 256l0-152c0-39.8-32.2-72-72-72c-11.4 0-22.2 2.7-31.8 7.4C308.3 16 284 0 256 0s-52.3 16-64.2 39.4zM165.4 338.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288s-76.8 35.8-90.6 50.2zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCentSign = {
  prefix: 'far',
  iconName: 'cent-sign',
  icon: [384, 512, [], "e3f5", "M216 0c13.3 0 24 10.7 24 24l0 48.5C277.9 75 313 88 341.9 108.4c10.8 7.7 13.4 22.6 5.7 33.5s-22.6 13.4-33.5 5.7C289.7 130.3 259.2 120 226 120c-82 0-146 62.2-146 136s64 136 146 136c33.3 0 63.7-10.3 88.2-27.6c10.8-7.7 25.8-5.1 33.5 5.7s5.1 25.8-5.7 33.5C313 424 277.9 437 240 439.5l0 48.5c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-50.8C102 422 32 347.7 32 256s70-166 160-181.2L192 24c0-13.3 10.7-24 24-24z"]
};
const faSwordsLaser = {
  prefix: 'far',
  iconName: 'swords-laser',
  icon: [640, 512, [], "e03d", "M204.6 250.7l42.9-39.3 50.7 55.5-37 40.5L281 327c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-.7-.7-59 59L105 501.7C98.3 508.3 89.4 512 80 512s-18.3-3.7-25-10.3L10.3 457C3.7 450.3 0 441.4 0 432s3.7-18.3 10.3-25l82.3-82.3c0 0 0 0 0 0s0 0 0 0l59-59-.7-.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l19.7 19.7zM505.7 40.2l-115.3 126-46.7-42.7L471.8 6.3c9.5-8.7 24.1-8.3 33.2 .7s9.4 23.7 .7 33.2zM177.1 361.6l-26.7-26.7-12.4 12.4 26.7 26.7 12.4-12.4zm-61.8 8.3L53.3 432 80 458.7l62.1-62.1-26.7-26.7zM173 312.3L199.7 339l12.7-12.7-26.7-26.7L173 312.3zM135 7c9.1-9.1 23.7-9.4 33.2-.7L360 181.8l0 105.1L134.3 40.2c-8.7-9.5-8.3-24.1 .7-33.2zM626.8 459.8l-39 39c-8.4 8.4-19.9 13.2-31.8 13.2s-23.4-4.7-31.8-13.2L398.1 372.7c-9-9-14.1-21.2-14.1-33.9l0-127.4c0-21.4 25.9-32.1 41-17L626.8 396.2c8.4 8.4 13.2 19.9 13.2 31.8s-4.7 23.4-13.2 31.8zM590.7 428l-66.1-66.1-34.7 34.7L556 462.7 590.7 428zm-88.7-88.7L432 269.3l0 69.5 35.3 35.3 34.7-34.7z"]
};
const faFlask = {
  prefix: 'far',
  iconName: 'flask',
  icon: [448, 512, [], "f0c3", "M176 196.8c0 20.7-5.8 41-16.6 58.7L119.7 320l208.6 0-39.7-64.5c-10.9-17.7-16.6-38-16.6-58.7L272 48l-96 0 0 148.8zM320 48l0 148.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 48l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L288 0l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z"]
};
const faPersonPregnant = {
  prefix: 'far',
  iconName: 'person-pregnant',
  icon: [384, 512, [], "e31e", "M240 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 352c0 17.7 14.3 32 32 32l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 16 0 16 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0 16 0c17.7 0 32-14.3 32-32l0-32c0-46.8-33.4-85.7-77.7-94.3l-6.1-32.5c-6.8-36.1-37.1-62.7-73.3-65.1c-1-.1-1.9-.2-2.9-.2l-2.4 0L176 128l-4.7 0c-32.5 0-62.3 17.9-77.6 46.5L34.8 284.7c-6.2 11.7-1.8 26.2 9.9 32.5s26.2 1.8 32.5-9.9L96 272.1 96 352zm80-176l13.6 0c15.4 0 28.6 11 31.5 26.1l6.1 32.5c3.6 19.4 18.7 34.5 38.1 38.3c22.1 4.3 38.8 23.8 38.8 47.1l0 16-112 0-48 0 0-128c0-17.7 14.3-32 32-32z"]
};
const faSquareU = {
  prefix: 'far',
  iconName: 'square-u',
  icon: [448, 512, [], "e281", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64l0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faWandSparkles = {
  prefix: 'far',
  iconName: 'wand-sparkles',
  icon: [512, 512, [], "f72b", "M455.9 49.3c.9-.8 2.1-1.3 3.3-1.3c2.7 0 4.9 2.2 4.9 4.9c0 1.2-.4 2.4-1.3 3.3L97.3 459.6c-2.5 2.8-6.1 4.4-9.9 4.4c-3.5 0-6.9-1.4-9.4-3.9L51.9 434c-2.5-2.5-3.9-5.9-3.9-9.4c0-3.8 1.6-7.3 4.4-9.9L455.9 49.3zM459.1 0C446 0 433.4 4.9 423.6 13.7l-263 238.2c-2.9 2.7-6.8 4.1-10.7 4.1L112 256c-8.8 0-16 7.2-16 16l0 31.3c0 4.5-1.9 8.8-5.3 11.9L20.2 379.1C7.3 390.7 0 407.2 0 424.5c0 16.3 6.5 31.9 18 43.4L44.1 494c11.5 11.5 27.1 18 43.4 18c17.3 0 33.8-7.3 45.4-20.2L399.7 197.3c3-3.3 7.3-5.3 11.9-5.3l20.4 0c8.8 0 16-7.2 16-16l0-25.9c0-4 1.5-7.8 4.1-10.7l46.2-51C507.1 78.6 512 66 512 52.9C512 23.7 488.3 0 459.1 0zM432 288c-3.6 0-6.7 2.4-7.7 5.8l-14.8 51.7-51.7 14.8c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8-14.8-51.7c-1-3.4-4.1-5.8-7.7-5.8zM87.7 69.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.4-7.7 5.8L57.5 121.5 5.8 136.3c-3.4 1-5.8 4.1-5.8 7.7s2.4 6.7 5.8 7.7l51.7 14.8 14.8 51.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.4 7.7-5.8l14.8-51.7 51.7-14.8c3.4-1 5.8-4.1 5.8-7.7s-2.4-6.7-5.8-7.7l-51.7-14.8L87.7 69.8zM208 0c-3.7 0-6.9 2.5-7.8 6.1l-6.8 27.3-27.3 6.8c-3.6 .9-6.1 4.1-6.1 7.8s2.5 6.9 6.1 7.8l27.3 6.8 6.8 27.3c.9 3.6 4.1 6.1 7.8 6.1s6.9-2.5 7.8-6.1l6.8-27.3 27.3-6.8c3.6-.9 6.1-4.1 6.1-7.8s-2.5-6.9-6.1-7.8l-27.3-6.8L215.8 6.1C214.9 2.5 211.7 0 208 0z"]
};
const faRouter = {
  prefix: 'far',
  iconName: 'router',
  icon: [576, 512, [], "f8da", "M198.6 105.9c-9.9 8.8-25.1 7.8-33.9-2.1s-7.8-25.1 2.1-33.9C216.2 26.4 281.1 0 352 0s135.8 26.4 185.1 69.9c9.9 8.8 10.9 23.9 2.1 33.9s-23.9 10.9-33.9 2.1C464.5 69.8 410.8 48 352 48s-112.5 21.8-153.4 57.9zM64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16L64 352zM0 368c0-35.3 28.7-64 64-64l264 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80zm104 16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM352 160c-28.6 0-54.9 10-75.5 26.7c-10.3 8.3-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C275.2 126 312 112 352 112s76.8 14 105.7 37.4c10.3 8.3 11.9 23.5 3.5 33.8s-23.5 11.9-33.8 3.5C406.9 170 380.6 160 352 160z"]
};
const faEllipsisVertical = {
  prefix: 'far',
  iconName: 'ellipsis-vertical',
  icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
};
const faEllipsisV = faEllipsisVertical;
const faSwordLaserAlt = {
  prefix: 'far',
  iconName: 'sword-laser-alt',
  icon: [512, 512, [], "e03c", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L225.1 232l105.1 0L505.7 40.2zM13.2 459.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2L310.6 304l1.1-1.1 8.3-8.3 11.3-11.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9l-16 0-11.7 0-1.5 0-117.5 0c-12.7 0-24.9 5.1-33.9 14.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8zM242.7 304l-70.1 70.1-34.7-34.7L173.3 304l69.5 0zm-92.7 92.7L84 462.7 49.3 428l66.1-66.1 34.7 34.7z"]
};
const faTicket = {
  prefix: 'far',
  iconName: 'ticket',
  icon: [576, 512, [127903], "f145", "M64 64C28.7 64 0 92.7 0 128l0 60.1c0 10.2 6.4 19.2 16 22.6c18.7 6.6 32 24.4 32 45.3s-13.3 38.7-32 45.3c-9.6 3.4-16 12.5-16 22.6L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-60.1c0-10.2-6.4-19.2-16-22.6c-18.7-6.6-32-24.4-32-45.3s13.3-38.7 32-45.3c9.6-3.4 16-12.5 16-22.6l0-60.1c0-35.3-28.7-64-64-64L64 64zM48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 44.9c-28.7 16.6-48 47.6-48 83.1s19.3 66.6 48 83.1l0 44.9c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-44.9c28.7-16.6 48-47.6 48-83.1s-19.3-66.6-48-83.1L48 128zM400 304l-224 0 0-96 224 0 0 96zM128 192l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z"]
};
const faPowerOff = {
  prefix: 'far',
  iconName: 'power-off',
  icon: [512, 512, [9211], "f011", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240zM134.2 107.3c10.7-7.9 12.9-22.9 5.1-33.6s-22.9-12.9-33.6-5.1C46.5 112.3 8 182.7 8 262C8 394.6 115.5 502 248 502s240-107.5 240-240c0-79.3-38.5-149.7-97.8-193.3c-10.7-7.9-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6c47.5 35 78.2 91.2 78.2 154.7c0 106-86 192-192 192S56 368 56 262c0-63.4 30.7-119.7 78.2-154.7z"]
};
const faCoin = {
  prefix: 'far',
  iconName: 'coin',
  icon: [512, 512, [129689], "f85c", "M98.5 268C59.1 245.8 48 222.7 48 208s11.1-37.8 50.5-60c37.9-21.3 93.5-36 157.5-36s119.6 14.7 157.5 36c39.4 22.2 50.5 45.3 50.5 60s-11.1 37.8-50.5 60C375.6 289.3 320 304 256 304s-119.6-14.7-157.5-36zM256 64C114.6 64 0 128.5 0 208l0 48 0 64c0 70.7 114.6 128 256 128s256-57.3 256-128l0-64 0-48c0-79.5-114.6-144-256-144zM216 350.3c13 1.1 26.4 1.7 40 1.7s27-.6 40-1.7l0 48c-12.9 1.1-26.3 1.7-40 1.7s-27.1-.6-40-1.7l0-48zm-32-4l0 48.1c-23.7-3.9-45.3-9.6-64-16.6l0-47.7c19.7 7 41.2 12.5 64 16.2zM48 292c11.6 9.1 25 17.4 40 24.7l0 46.5C54.2 344.2 48 326.8 48 320l0-28zM328 394.3l0-48.1c22.8-3.8 44.3-9.2 64-16.2l0 47.7c-18.7 7-40.3 12.7-64 16.6zm96-31.2l0-46.5c15-7.3 28.4-15.6 40-24.7l0 28c0 6.8-6.2 24.2-40 43.1zM256 184c40.2 0 75.7 5.2 100.3 12.9c11.8 3.7 19.9 7.7 24.7 11.1c-4.8 3.4-12.9 7.3-24.7 11.1c-24.6 7.8-60 12.9-100.3 12.9s-75.7-5.2-100.3-12.9c-11.8-3.7-19.9-7.7-24.7-11.1c4.8-3.4 12.9-7.3 24.7-11.1c24.6-7.8 60-12.9 100.3-12.9zm128.8 27.4s0-.1-.1-.2c.1 .1 .1 .2 .1 .2zm-.1-6.6c.1-.1 .1-.2 .1-.2s-.1 .1-.1 .2zm-257.4-.2s0 .1 .1 .2c-.1-.1-.1-.2-.1-.2zm.1 6.6c-.1 .1-.1 .2-.1 .2s.1-.1 .1-.2zM432 208c0-17.7-11.3-30.3-21.6-37.9c-10.7-8-24.6-14.2-39.7-18.9c-30.4-9.6-71-15.2-114.7-15.2s-84.3 5.6-114.7 15.2c-15.1 4.8-29 10.9-39.7 18.9C91.3 177.7 80 190.3 80 208s11.3 30.3 21.6 37.9c10.7 8 24.6 14.2 39.7 18.9c30.4 9.6 71 15.2 114.7 15.2s84.3-5.6 114.7-15.2c15.1-4.8 29-10.9 39.7-18.9c10.3-7.7 21.6-20.2 21.6-37.9z"]
};
const faLaptopSlash = {
  prefix: 'far',
  iconName: 'laptop-slash',
  icon: [640, 512, [], "e1c7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-20.3-15.9c18.2-17.5 29.5-42 29.5-69.2c0-17.7-14.3-32-32-32l-126.6 0L134.4 80 512 80c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zM542.6 400l46.6 0c-3.3 9.3-9.4 17.3-17.3 23l-29.4-23zM426.3 432L96 432c-20.9 0-38.7-13.4-45.3-32l334.9 0-60.9-48L32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l391.2 0-60.9-48zM112 184.4L64 146.6 64 320l48 0 0-135.6z"]
};
const faRightLong = {
  prefix: 'far',
  iconName: 'right-long',
  icon: [512, 512, ["long-arrow-alt-right"], "f30b", "M505.5 239.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-33.7L56 336c-30.9 0-56-25.1-56-56l0-48c0-30.9 25.1-56 56-56l248 0 0-33.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 146.5l0 53.5c0 13.3-10.7 24-24 24L56 224c-4.4 0-8 3.6-8 8l0 48c0 4.4 3.6 8 8 8l272 0c6.4 0 12.5 2.5 17 7s7 10.6 7 17l0 53.5L455 256 352 146.5z"]
};
const faLongArrowAltRight = faRightLong;
const faCircleB = {
  prefix: 'far',
  iconName: 'circle-b',
  icon: [512, 512, [], "e0fd", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152l0 104 0 104c0 13.3 10.7 24 24 24l108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0c-13.3 0-24 10.7-24 24zm144 52c0 15.5-12.5 28-28 28l-68 0 0-56 68 0c15.5 0 28 12.5 28 28zM208 336l0-56 68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0z"]
};
const faPersonDressSimple = {
  prefix: 'far',
  iconName: 'person-dress-simple',
  icon: [256, 512, [], "e21c", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM96.9 219.6L63.6 336l128.7 0L159.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.4 0c-7.1 0-13.4 4.7-15.4 11.6zM50.7 206.4c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L192 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8L50.7 206.4z"]
};
const faPipeCollar = {
  prefix: 'far',
  iconName: 'pipe-collar',
  icon: [512, 512, [], "e437", "M109.3 18.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L35.4 126C12.9 164.1 0 208.5 0 256s12.9 91.9 35.4 130L18.7 402.7c-25 25-25 65.5 0 90.5s65.5 25 90.5 0L126 476.6c38.1 22.5 82.6 35.4 130 35.4s91.9-12.9 130-35.4l16.7 16.7c25 25 65.5 25 90.5 0s25-65.5 0-90.5L476.6 386c22.5-38.1 35.4-82.6 35.4-130s-12.9-91.9-35.4-130l16.7-16.7c25-25 25-65.5 0-90.5s-65.5-25-90.5 0L386 35.4C347.9 12.9 303.5 0 256 0s-91.9 12.9-130 35.4L109.3 18.7zM48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zM256 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM48 64a16 16 0 1 1 32 0A16 16 0 1 1 48 64zm0 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm400-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM432 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faLightsHoliday = {
  prefix: 'far',
  iconName: 'lights-holiday',
  icon: [640, 512, [], "f7b2", "M35.3 66.8s0 0 0 0l.1 0 .6 .3c.6 .3 1.7 .8 3.1 1.5c2.8 1.4 7.3 3.4 13.2 5.8c11.9 4.9 30 11.6 54.1 18.3C154.5 106.3 226.4 120 320 120s165.5-13.7 213.5-27.1c24-6.7 42.1-13.4 54.1-18.3c6-2.5 10.4-4.5 13.2-5.8c1.4-.7 2.5-1.2 3.1-1.5l.6-.3c0 0 0 0 0 0c0 0 0 0 0 0c11.7-6.3 26.2-1.9 32.5 9.8s1.9 26.2-9.8 32.5L616 88c11.4 21.1 11.4 21.1 11.4 21.1s0 0 0 0s0 0 0 0l-.1 .1-.4 .2-1.2 .6c-1 .5-2.4 1.2-4.2 2c-3.6 1.7-8.8 4.1-15.6 6.9c-13.6 5.6-33.5 12.9-59.4 20.2C494.5 153.7 418.4 168 320 168s-174.5-14.3-226.5-28.9c-26-7.3-45.9-14.6-59.4-20.2c-6.8-2.8-12-5.2-15.6-6.9c-1.8-.9-3.2-1.5-4.2-2l-1.2-.6-.4-.2-.1-.1c0 0 0 0 0 0c0 0 0 0 0 0L24 88 12.6 109.1C1 102.8-3.4 88.3 2.9 76.6c6.3-11.7 20.8-16 32.5-9.8zm80 155.3L130 181c14.8 3.1 30.7 6.1 47.9 8.7l-17.3 48.6c27.2 20.5 39.2 56.9 27.2 90.7c-16.1 45.2-95.7 101.8-118.3 93.8s-48.6-102.2-32.5-147.4c12-33.7 44.4-54.4 78.3-53.1zM296 259.7l0-59.9c7.9 .2 15.9 .3 24 .3s16.1-.1 24-.3l0 59.9c32.5 10.2 56 40.5 56 76.3c0 48-56 128-80 128s-80-80-80-128c0-35.8 23.5-66.1 56-76.3zm183.4-21.4l-17.3-48.6c17.1-2.6 33.1-5.5 47.9-8.7l14.7 41.2c34-1.3 66.3 19.4 78.3 53.1c16.1 45.2-9.8 139.4-32.5 147.4s-102.2-48.6-118.3-93.8c-12-33.7 0-70.2 27.2-90.7zM82.2 291.4c-1.2 3.4-2.6 11-2.1 23.3c.4 11.6 2.3 24.6 5.3 37c1.3 5.3 2.7 10.2 4.2 14.6c3.9-2.5 8.1-5.4 12.5-8.7c10.2-7.7 19.9-16.6 27.5-25.4c8-9.2 11.8-16 13-19.4c5.9-16.7-2.8-35-19.4-40.9s-35 2.8-40.9 19.4zM288 336c0 3.6 1.3 11.3 5.8 22.6c4.3 10.8 10.4 22.4 17.4 33.1c3 4.6 6 8.7 8.8 12.4c2.8-3.7 5.8-7.8 8.8-12.4c7-10.7 13.1-22.3 17.4-33.1c4.5-11.4 5.8-19 5.8-22.6c0-17.7-14.3-32-32-32s-32 14.3-32 32zm228.9-64c-16.7 5.9-25.3 24.2-19.4 40.9c1.2 3.4 5 10.2 13 19.4c7.6 8.8 17.3 17.6 27.5 25.4c4.4 3.3 8.6 6.2 12.5 8.7c1.5-4.4 2.9-9.3 4.2-14.6c3-12.4 4.9-25.4 5.3-37c.4-12.2-.9-19.9-2.1-23.3c-5.9-16.7-24.2-25.3-40.9-19.4z"]
};
const faCitrus = {
  prefix: 'far',
  iconName: 'citrus',
  icon: [512, 512, [], "e2f4", "M304 128l80 0c53 0 96-43 96-96l0-16c0-8.8-7.2-16-16-16L384 0c-31 0-58.7 14.7-76.2 37.6c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272s107.5 240 240 240s240-107.5 240-240c0-49.5-15-95.5-40.7-133.7c-13.5 9.1-28.8 15.7-45.3 19.1c23.9 32 38 71.7 38 114.6c0 106-86 192-192 192S64 378 64 272S150 80 256 80c11.2 0 22.2 1 32.9 2.8c-.6 4.3-.9 8.7-.9 13.2l0 16c0 8.8 7.2 16 16 16z"]
};
const faFlagUsa = {
  prefix: 'far',
  iconName: 'flag-usa',
  icon: [448, 512, [], "f74d", "M24 0C37.3 0 48 10.7 48 24l0 28 85-21.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 66.2 0 51.3 0 52.7 0 51.3 0 74.2c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L48 404l0 84c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72 0-49.5 0-53.3L0 264l0-46.7L0 168 0 64 0 24C0 10.7 10.7 0 24 0zM400 93c-56.4 22.9-120.2 20.6-175-6.8c-15.3-7.7-32.1-11.8-49-12.3l0 60.7c18.8 .6 37.5 3.6 55.6 9l49.3 14.8c35.2 10.6 72.9 9.3 107.3-3.6l11.8-4.4L400 93zM48 252.9l68.5-15.8c39.8-9.2 81.4-6.9 119.9 6.6l41.9 14.7c37.1 13 77.6 12.5 114.5-1.3l7.3-2.7 0-52.8c-42.9 14.9-89.4 15.9-132.9 2.8l-49.3-14.8c-28-8.4-57.6-9.3-86.1-2.8L48 206.2l0 46.7zm0 49.3l0 52.4 68.6-17.2c52.2-13.1 107.4-7 155.6 17.1c32.2 16.1 69.7 18.1 103.4 5.4l24.4-9.1 0-45.4c-44.7 14.4-93.1 13.9-137.6-1.7L220.5 289c-30-10.5-62.3-12.3-93.3-5.1L48 302.2zM96 104a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 152a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faLaptopFile = {
  prefix: 'far',
  iconName: 'laptop-file',
  icon: [640, 512, [], "e51d", "M448 48L128 48c-8.8 0-16 7.2-16 16l0 256 208 0 0 64L48 384c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16l48 0L64 64C64 28.7 92.7 0 128 0L448 0c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16zM400 464l192 0 0-208-48 0c-17.7 0-32-14.3-32-32l0-48-112 0 0 288zm192 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l124.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L640 464c0 26.5-21.5 48-48 48z"]
};
const faTty = {
  prefix: 'far',
  iconName: 'tty',
  icon: [512, 512, ["teletype"], "f1e4", "M368 188.8l0 25.8 78.6 17.1 15.8-53.6c3.3-11.2-.3-17.4-2.5-19.4C421 123.4 349.4 80 256 80s-165 43.4-203.9 78.6c-2.2 2-5.8 8.2-2.5 19.4l15.8 53.6L144 214.5l0-25.8c0-19.3 11.6-36.8 29.5-44.3c52.8-22.1 112.3-22.1 165.1 0c17.8 7.5 29.5 24.9 29.5 44.3zm-48 25.8l0-25.8c-40.9-17.2-87.1-17.2-128 0l0 25.8c0 22.6-15.7 42.1-37.8 46.9L75.6 278.5c-24.6 5.3-49.1-9.2-56.2-33.3L3.5 191.7c-7.2-24.5-2.6-51.4 16.3-68.6C64.9 82.2 147.6 32 256 32s191.1 50.2 236.2 91.1c18.9 17.2 23.5 44.1 16.3 68.6l-15.8 53.6c-7.1 24.1-31.7 38.6-56.2 33.3l-78.6-17.1c-22.1-4.8-37.8-24.3-37.8-46.9zM32 336c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm0 96c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM144 320l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32z"]
};
const faTeletype = faTty;
const faChartTreeMap = {
  prefix: 'far',
  iconName: 'chart-tree-map',
  icon: [512, 512, [], "e0ea", "M176 80l0 112L48 192 48 80l128 0zM48 32C21.5 32 0 53.5 0 80L0 192c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 32zM176 320l0 112L48 432l0-112 128 0zM48 272c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-112c0-26.5-21.5-48-48-48L48 272zM304 80l160 0 0 32-160 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48L304 32c-26.5 0-48 21.5-48 48zM464 240l0 32-160 0 0-32 160 0zM304 192c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0zm0 208l160 0 0 32-160 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-160 0c-26.5 0-48 21.5-48 48z"]
};
const faDiagramNext = {
  prefix: 'far',
  iconName: 'diagram-next',
  icon: [512, 512, [], "e476", "M448 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l168 0 0 86.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-86.1 168 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-74.3 0c4.8 16 2.2 33.8-7.7 48l82 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-80 0-224 0-80 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l82 0c-9.9-14.2-12.5-32-7.7-48L64 288z"]
};
const faPersonRifle = {
  prefix: 'far',
  iconName: 'person-rifle',
  icon: [576, 512, [], "e54e", "M240 0c-44.2 0-80 35.8-80 80s35.8 80 80 80c43.9 0 79.5-35.3 80-79l0-2c-.5-43.7-36.1-79-80-79zm20.7 192l-41.3 0c-45.5 0-87 25.7-107.3 66.3L34.5 413.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L152 285.7 152 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-245.4c6.2-1.7 12.7-2.6 19.3-2.6l41.3 0c3.8 0 7.6 .3 11.3 .9L272 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216.8 0-63.5c-17.8-10.1-38.1-15.7-59.3-15.7zM208 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l32 0 0 48 0 64c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16L432 0 416 0zm16 336l-16 0-16 0 0-96 32 0 0 96z"]
};
const faClockFiveThirty = {
  prefix: 'far',
  iconName: 'clock-five-thirty',
  icon: [512, 512, [], "e34a", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-56.7 20 30c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-64-96c-5.9-8.8-16.8-12.7-26.9-9.7s-17 12.4-17 23l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faPipeValve = {
  prefix: 'far',
  iconName: 'pipe-valve',
  icon: [512, 512, [], "e439", "M280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21L128 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l104-13 0 77L48 192l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32L0 424l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 416 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-208 0-32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-184 0 0-77 104 13c17.7 0 32-14.3 32-32s-14.3-32-32-32L280 77l0-21zM48 400l0-160 208 0 208 0 0 160L48 400z"]
};
const faLightbulbMessage = {
  prefix: 'far',
  iconName: 'lightbulb-message',
  icon: [576, 512, [], "e687", "M310.4 224.7c6.2-15 9.6-31.4 9.6-48.7c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 16.6-2.3 32.7-6.6 48L320 224c-3.3 0-6.5 .2-9.6 .7zM192 416l64 0c0 14.4 4.8 27.7 12.8 38.4C259.1 487.7 228.4 512 192 512c-44.2 0-80-35.8-80-80l0-16 80 0zM144 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48zm400 78c17.7 0 32 14.3 32 32l0 130c0 17.7-14.3 32-32 32l-64 0 0 48c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L393.4 448 320 448c-17.7 0-32-14.3-32-32l0-130c0-17.7 14.3-32 32-32l224 0z"]
};
const faArrowUpFromArc = {
  prefix: 'far',
  iconName: 'arrow-up-from-arc',
  icon: [512, 512, [], "e4b4", "M256 464C141.1 464 48 370.9 48 256c0-13.3-10.7-24-24-24s-24 10.7-24 24C0 397.4 114.6 512 256 512s256-114.6 256-256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 114.9-93.1 208-208 208zM134.4 119.7c-9 9.7-8.5 24.9 1.3 33.9s24.9 8.5 33.9-1.3L232 85.1 232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-242.9 62.4 67.2c9 9.7 24.2 10.3 33.9 1.3s10.3-24.2 1.3-33.9l-104-112C269 2.8 262.7 0 256 0s-13 2.8-17.6 7.7l-104 112z"]
};
const faFaceSpiralEyes = {
  prefix: 'far',
  iconName: 'face-spiral-eyes',
  icon: [512, 512, [], "e485", "M464 256c0-114.9-93.1-208-208-208c-71 0-133.6 35.5-171.1 89.8c18.5-21.6 45.8-36.5 76.6-37.7c6.6-.3 12.2 4.9 12.5 11.5s-4.9 12.2-11.5 12.5c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.2-102.5-89.1c-1.2-11.3 0-22.5 3-33.3C53.5 201.5 48 228.1 48 256c0 114.9 93.1 208 208 208s208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm338.1 48.5c-.3-6.6 4.9-12.2 11.5-12.5c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.3-19.9 24l.1 .4 .1 .4c.9 4.3 3.4 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.9-2.8-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.2 5.2-79.6-25.8-82.9-69.3c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c5.5 53.8-41.1 108.1-101 110.5c-6.6 .3-12.2-4.9-12.5-11.5zm-35.9 46.6l6.7-4.5c22.2-14.8 51.8-11.9 70.7 7L385 359c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-5.4-5.4c-2.7-2.7-6.9-3.1-10.1-1l-6.7 4.5c-20.3 13.5-47 12.4-66-2.9l-1.7-1.4c-2.9-2.3-7.1-2.3-10 0l-1.7 1.4c-19 15.2-45.8 16.4-66 2.9l-6.7-4.5c-3.2-2.1-7.4-1.7-10.1 1L161 393c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l5.4-5.4c18.9-18.9 48.5-21.8 70.7-7l6.7 4.5c2.9 1.9 6.7 1.8 9.4-.4l1.7-1.4c20.5-16.4 49.5-16.4 70 0l1.7 1.4c2.7 2.2 6.5 2.3 9.4 .4z"]
};
const faCompressWide = {
  prefix: 'far',
  iconName: 'compress-wide',
  icon: [512, 512, [], "f326", "M160 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112zM24 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L24 288zM400 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-88zM376 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faCirclePhoneHangup = {
  prefix: 'far',
  iconName: 'circle-phone-hangup',
  icon: [512, 512, ["phone-circle-down"], "e11d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM391.4 294l21.7-35.2c4.8-7.8 3.4-17.5-3.4-23.8c-84.9-78.6-222.6-78.6-307.5 0c-6.8 6.3-8.2 16.1-3.4 23.8L120.6 294c5.3 8.6 16.8 12.3 26.7 8.5l46.2-17.6c8.7-3.3 14.1-11.6 13.1-20.3L203.7 238c33.8-10.8 70.8-10.8 104.6 0l-2.9 26.7c-.9 8.7 4.4 16.9 13.1 20.3l46.2 17.6c9.9 3.8 21.4 .2 26.7-8.5z"]
};
const faPhoneCircleDown = faCirclePhoneHangup;
const faGearComplexCode = {
  prefix: 'far',
  iconName: 'gear-complex-code',
  icon: [512, 512, [], "e5eb", "M188.2 36.7C193.4 15.2 212.7 0 234.9 0l42.2 0c22.2 0 41.5 15.2 46.7 36.7L332 71l1.1 .4 30-18.4c18.9-11.6 43.3-8.7 59 7l29.8 29.8c15.7 15.7 18.6 40.1 7 59l-18.4 30 .4 1.1 34.2 8.3c21.6 5.2 36.7 24.5 36.7 46.7l0 42.2c0 22.2-15.2 41.5-36.7 46.7L441 332l-.4 1.1 18.4 30c11.6 18.9 8.7 43.3-7 59l-29.8 29.8c-15.7 15.7-40.1 18.6-59 7l-30-18.4L332 441l-8.3 34.2c-5.2 21.6-24.5 36.7-46.7 36.7l-42.2 0c-22.2 0-41.5-15.2-46.7-36.7L180 441l-1.1-.4-30 18.4c-18.9 11.6-43.3 8.7-59-7L60.1 422.1c-15.7-15.7-18.6-40.1-7-59l18.4-30L71 332l-34.2-8.3C15.2 318.6 0 299.3 0 277.1l0-42.2c0-22.2 15.2-41.5 36.7-46.7L71 180l.4-1.1L53 148.9c-11.6-18.9-8.7-43.3 7-59L89.9 60.1c15.7-15.7 40.1-18.6 59-7l30 18.4L180 71l8.3-34.2zM277.1 48l-42.2 0L223.6 94.6c-1.9 8-7.9 14.5-15.7 17.1c-6.8 2.3-13.5 5-19.9 8.2c-7.4 3.7-16.2 3.3-23.3-1L123.8 94 94 123.8l25 40.9c4.3 7.1 4.7 15.9 1 23.3c-3.2 6.4-6 13-8.2 19.9c-2.6 7.9-9.1 13.8-17.1 15.7L48 234.9l0 42.2 46.6 11.3c8 1.9 14.5 7.9 17.1 15.7c2.3 6.8 5 13.5 8.2 19.9c3.7 7.4 3.3 16.2-1 23.3L94 388.2 123.8 418l40.9-25c7.1-4.3 15.9-4.7 23.3-1c6.4 3.2 13 6 19.9 8.2c7.9 2.6 13.8 9.1 15.7 17.1L234.9 464l42.2 0 11.3-46.6c1.9-8 7.9-14.5 15.7-17.1c6.8-2.3 13.5-5 19.9-8.2c7.4-3.7 16.2-3.3 23.3 1l40.9 25L418 388.2l-25-40.9c-4.3-7.1-4.7-15.9-1-23.3c3.2-6.4 6-13 8.2-19.9c2.6-7.9 9.1-13.8 17.1-15.7L464 277.1l0-42.2-46.6-11.3c-8-1.9-14.5-7.9-17.1-15.7c-2.3-6.8-5-13.5-8.2-19.9c-3.7-7.4-3.3-16.2 1-23.3l25-40.9L388.2 94l-40.9 25c-7.1 4.3-15.9 4.7-23.3 1c-6.4-3.2-13-6-19.9-8.2c-7.9-2.6-13.8-9.1-15.7-17.1L277.1 48zm14.6 115.3l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
const faHouseMedicalCircleExclamation = {
  prefix: 'far',
  iconName: 'house-medical-circle-exclamation',
  icon: [640, 512, [], "e512", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L526.1 194.6c-9.8-1.7-19.9-2.6-30.1-2.6c-14.2 0-28.1 1.7-41.3 4.9L288 55.5 112 204.8 112 432c0 17.7 14.3 32 32 32l204.5 0c12.3 18.8 28 35.1 46.3 48L144 512c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM320 256l40.2 0c-15.3 18.5-26.9 40.2-33.6 64l-6.6 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48zm176-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faBadminton = {
  prefix: 'far',
  iconName: 'badminton',
  icon: [576, 512, [], "e33a", "M228.9 100.9C193.7 136.1 176 180.4 176 221c0 31.9 10.9 61.1 32.4 82.6c48.2 48.2 138.8 43.5 202.7-20.5C446.3 247.9 464 203.6 464 163c0-31.9-10.9-61.1-32.4-82.6S380.8 48 349 48c-40.6 0-84.9 17.7-120.1 52.9zM194.9 66.9C238.5 23.4 294.8 0 349 0c42.8 0 84.9 14.8 116.6 46.5S512 120.2 512 163c0 54.2-23.4 110.5-66.9 154c-56.3 56.3-137 80.2-204.8 59.8c-27.3-8.2-58.7-7.8-80.5 9.7c11.3 12.6 10.9 31.9-1.2 44l-72 72c-12.5 12.5-32.8 12.5-45.3 0l-32-32c-12.5-12.5-12.5-32.8 0-45.3l72-72c12.1-12.1 31.4-12.5 44-1.2c17.5-21.8 18.1-53.3 9.9-80.6c-4.9-16.3-7.3-33.4-7.3-50.6c0-54.2 23.4-110.5 66.9-154zM104 398.6L54.6 448l9.4 9.4L113.4 408l-9.4-9.4zM512 352c26.5 0 48 21.5 48 48l0 32-96 0 0-32c0-26.5 21.5-48 48-48zm-50.3 96l33.4 0-15.8 52.6c-2.5 8.5-11.5 13.3-19.9 10.7s-13.3-11.5-10.7-19.9l13-43.4zm34.3 0l32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm32.9 0l33.4 0 13 43.4c2.5 8.5-2.3 17.4-10.7 19.9s-17.4-2.3-19.9-10.7L528.9 448z"]
};
const faClosedCaptioning = {
  prefix: 'far',
  iconName: 'closed-captioning',
  icon: [576, 512, [], "f20a", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"]
};
const faPersonHiking = {
  prefix: 'far',
  iconName: 'person-hiking',
  icon: [384, 512, ["hiking"], "f6ec", "M288 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM136.5 125.8c3.8-15.1-7.7-29.8-23.3-29.8l-4.2 0C73 96 41.4 120.1 31.9 155L7 246.4c-3.7 13.7 5.2 27.7 19.2 30l47.9 8c12.3 2.1 24.2-5.7 27.2-17.9l35.2-140.7zM384 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24-27.2 0-28.7-43.1c-11.2-16.9-28.6-28.7-48.5-32.9c-32-6.9-63.6 13.3-70.9 45.2l-19.8 86.5c-4.7 20.4 2.4 41.7 18.4 55.2L240 387.1 240 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104.6c0-11.8-5.2-22.9-14.2-30.5l-27.5-23.2 22.4-95.2 2.5 3.7c7.4 11.1 19.9 17.8 33.3 17.8l31.4 0 0 232c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304zm-162.4-5.1c3.6 .8 7 2.2 10 4.1L205.3 294.9l-14.9-12.6c-2.3-1.9-3.3-5-2.6-7.9l19.8-86.5c1.4-6.3 7.7-10.3 14.1-9zM80.9 481.5c-3.6 12.8 3.8 26 16.6 29.6s26-3.8 29.6-16.6l36.7-130-24.8-21c-5.6-4.7-10.5-10.1-14.6-15.8L80.9 481.5z"]
};
const faHiking = faPersonHiking;
const faRightFromLine = {
  prefix: 'far',
  iconName: 'right-from-line',
  icon: [448, 512, ["arrow-alt-from-left"], "f347", "M288 146.2L398 256 288 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM448 256c0-11.5-4.6-22.5-12.7-30.6L319.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L435.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88z"]
};
const faArrowAltFromLeft = faRightFromLine;
const faVenusDouble = {
  prefix: 'far',
  iconName: 'venus-double',
  icon: [640, 512, [9890], "f226", "M192 304a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM368 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6C82.2 338.7 16 265.1 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c10.9-11.7 20.5-24.6 28.5-38.6C393.7 294.9 419.8 304 448 304c70.7 0 128-57.3 128-128s-57.3-128-128-128c-28.2 0-54.3 9.1-75.5 24.6c-8-14-17.6-26.9-28.5-38.6C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 89.1-66.2 162.7-152 174.4l0 49.6 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.6c-29.7-4-57-15.5-80-32.4z"]
};
const faImages = {
  prefix: 'far',
  iconName: 'images',
  icon: [576, 512, [], "f302", "M160 80l352 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-21.2 0L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336 160 336c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM96 96l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCalculator = {
  prefix: 'far',
  iconName: 'calculator',
  icon: [384, 512, [128425], "f1ec", "M336 176l0 272c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-272 288 0zm0-48L48 128l0-64c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 64zm48 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 24 0 24L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-272 0-24 0-24zM80 232a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM80 408c0 13.3 10.7 24 24 24l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0c-13.3 0-24 10.7-24 24zM192 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM168 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM280 208a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM256 320a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 64a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"]
};
const faShuttlecock = {
  prefix: 'far',
  iconName: 'shuttlecock',
  icon: [512, 512, [], "f45b", "M247 48l-43.3 89.2L280 97.4 280 48l-33 0zM168.5 209.6l-38.9 80L159 319l75.9-75.9 25.7-81.5-92.1 48zM328 40l0 40 72 0c17.7 0 32 14.3 32 32l0 72 40 0c22.1 0 40 17.9 40 40l0 46c0 15.3-8.7 29.3-22.5 36l-242 117.5c-.7 1.4-1.7 2.7-2.8 3.8l-51.5 51.5c-21.2 21.2-50 33.1-80 33.1C50.7 512 0 461.3 0 398.9c0-30 11.9-58.8 33.1-80l51.5-51.5c1.2-1.2 2.5-2.1 3.8-2.8L206 22.5C212.7 8.7 226.7 0 242 0l46 0c22.1 0 40 17.9 40 40zM222.3 382.3l80-38.9 48-92.1-81.5 25.7L193 353l29.4 29.4zm70.4-163.1L384 190.4l0-62.4-62.4 0-28.8 91.2zM188.1 416L96 323.9 73.3 346.6l92.1 92.1L188.1 416zm-48.4 42.3l-86-86C50 380.6 48 389.6 48 398.9c0 36 29.2 65.1 65.1 65.1c9.2 0 18.3-2 26.6-5.7zm235.1-150L464 265l0-33-49.4 0-39.7 76.3z"]
};
const faUserHair = {
  prefix: 'far',
  iconName: 'user-hair',
  icon: [448, 512, [], "e45a", "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM49.6 464l348.7 0c-9.3-54.5-56.8-96-113.9-96l-120.9 0c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z"]
};
const faEyeEvil = {
  prefix: 'far',
  iconName: 'eye-evil',
  icon: [640, 512, [], "f6db", "M288.4 115.5L320 65l31.6 50.6c6.3 10 16 17.4 27.4 20.7c10.6 3.1 20.6 6.9 30 11.4c11 5.3 23.5 6.2 35.2 2.6l27.7-8.6-2.3 3.6c-10.6 16.2-10.5 37.1 .3 53.2c4.2 6.2 7.6 12.5 10.3 19c5.2 12.4 15.4 22 28.1 26.5L542.1 256l-33.9 12.1c-12.7 4.5-22.8 14.1-28.1 26.5c-2.7 6.5-6.2 12.8-10.3 19c-10.8 16.1-10.9 37-.3 53.2l2.3 3.6-27.7-8.6c-11.6-3.6-24.2-2.7-35.2 2.6c-9.4 4.5-19.4 8.4-30 11.4c-11.4 3.3-21.1 10.6-27.4 20.7L320 447l-31.6-50.6c-6.3-10-16-17.4-27.4-20.7c-10.6-3.1-20.6-6.9-30-11.4c-11-5.3-23.5-6.2-35.2-2.6l-27.7 8.6 2.3-3.6c10.6-16.2 10.5-37.1-.3-53.2c-4.2-6.2-7.6-12.5-10.3-19c-5.2-12.4-15.4-22-28.1-26.5L97.9 256l33.9-12.1c12.7-4.5 22.8-14.1 28.1-26.5c2.7-6.5 6.2-12.8 10.3-19c10.8-16.1 10.9-37 .3-53.2l-2.3-3.6 27.7 8.6c11.6 3.6 24.2 2.7 35.2-2.6c9.4-4.5 19.4-8.4 30-11.4c11.4-3.3 21.1-10.6 27.4-20.7zM392.3 90.1L344.5 13.6C339.2 5.1 330 0 320 0s-19.2 5.1-24.5 13.6L247.7 90.1c-13.1 3.8-25.7 8.6-37.5 14.3L114.9 74.7c-9.2-2.9-19.1 .3-24.9 8s-6.1 18.1-.8 26.1l41.3 62.7c-5.8 8.6-10.7 17.7-14.7 27.1L15.1 234.6C6 237.8 0 246.4 0 256s6 18.2 15.1 21.4l100.6 35.9c4 9.4 8.9 18.5 14.7 27.1L89.2 403.2c-5.3 8-4.9 18.5 .8 26.1s15.7 10.9 24.9 8l95.3-29.8c11.8 5.7 24.4 10.5 37.5 14.3l47.8 76.5C300.8 506.9 310 512 320 512s19.2-5.1 24.5-13.6l47.8-76.5c13.1-3.8 25.7-8.6 37.5-14.3l95.3 29.8c9.2 2.9 19.1-.3 24.9-8s6.1-18.1 .8-26.1l-41.3-62.7c5.8-8.6 10.7-17.7 14.7-27.1l100.6-35.9c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L524.3 198.7c-4-9.4-8.9-18.5-14.7-27.1l41.3-62.7c5.3-8 4.9-18.5-.8-26.1s-15.7-10.9-24.9-8l-95.3 29.8c-11.8-5.7-24.4-10.5-37.5-14.3zM256 245.5c12 4 24.5 7 37.3 8.7c.1 .4 .2 .7 .4 1.1c5.5 14.4 13.5 24.4 18.1 29.3c2.1 2.3 5.1 3.4 8.2 3.4s6.1-1.1 8.2-3.4c4.5-4.9 12.6-14.9 18.1-29.3c.1-.4 .3-.7 .4-1.1c12.9-1.7 25.3-4.6 37.3-8.7c0 .8 0 1.6 0 2.5c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-.8 0-1.6 0-2.5zM246 242s0 0 0 0c0 0 .1 0 .1 0l-.1 0c0 0 0 0 0 0zm148 0s0 0-.1 0c.1 0 .1 0 .1 0zM220.1 219c-2.7 9.2-4.1 18.9-4.1 29c0 57.4 46.6 104 104 104s104-46.6 104-104c0-10-1.4-19.8-4.1-29c-4.9-16.8-25-20.6-41.3-14.1C360.5 212.1 340.7 216 320 216s-40.5-3.9-58.6-11.1c-16.3-6.4-36.4-2.7-41.3 14.1z"]
};
const faPeoplePulling = {
  prefix: 'far',
  iconName: 'people-pulling',
  icon: [576, 512, [], "e535", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM48 271.9L48 328c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 184c0-30.9 25.1-56 56-56l58.4 0c15.1 0 29.9 3.9 43 11.2l122.5 68.7c17.9-34 48.4-60 85.1-72.3c15.3-5.1 31.3-7.7 47.4-7.7l4.9 0c52.5 0 98.7 34.8 113.2 85.4l10.9 38.1L569 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L506 283.9c-4.8-4.8-8.3-10.8-10.2-17.3l-10.5-36.7-28.5 91.3 50.1 40.7c6.9 5.6 11.8 13.4 13.8 22.1l22.8 98.6c3 12.9-5.1 25.8-18 28.8s-25.8-5.1-28.8-18l-22.1-96L370 312.6c-18.1-14.7-25.2-39.1-17.8-61.2L375 183.1c-24.7 9.8-44.7 28.9-55.6 53.3l-9.5 21.3c-5.4 12.1-19.6 17.6-31.7 12.2c-6.8-3-11.5-8.8-13.3-15.4L160.5 196l63 286.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L145.6 352l-30.9 0 28.7 130.9c2.8 12.9-5.3 25.7-18.3 28.6s-25.7-5.4-28.6-18.3L48 271.9zM106.9 176l-30.9 0 28.1 128 30.9 0L106.9 176zM464 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM397.8 266.6c-1.1 3.2 0 6.6 2.5 8.7l16.3 13.3 32.4-103.8c.1-.3 .2-.7 .3-1c-6.7-3.5-14-5.9-21.7-7.1l-29.9 89.8zm-42.1 75.6l39 31.7-19.2 48c-2 5-5 9.6-8.9 13.4L297 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.5-68.5 24.1-60.4z"]
};
const faN = {
  prefix: 'far',
  iconName: 'n',
  icon: [384, 512, [110], "4e", "M15.8 33.5c9.5-3.5 20.1-.6 26.6 7.1L336 390.1 336 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 10.1-6.3 19.1-15.8 22.6s-20.1 .6-26.6-7.1L48 121.9 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 45.9 6.3 36.9 15.8 33.5z"]
};
const faSwap = {
  prefix: 'far',
  iconName: 'swap',
  icon: [640, 512, [], "e609", "M240 119c0 22.6-18.3 41-41 41l-47 0 0 200c0 39.8 32.2 72 72 72s72-32.2 72-72l0-208c0-66.3 53.7-120 120-120s120 53.7 120 120l0 200 47 0c22.6 0 41 18.3 41 41c0 10.9-4.3 21.3-12 29l-83 83c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-83-83c-7.7-7.7-12-18.1-12-29c0-22.6 18.3-41 41-41l47 0 0-200c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 208c0 66.3-53.7 120-120 120s-120-53.7-120-120l0-200-47 0c-22.6 0-41-18.3-41-41c0-10.9 4.3-21.3 12-29L111 7c4.5-4.5 10.6-7 17-7s12.5 2.5 17 7l83 83c7.7 7.7 12 18.1 12 29zM73.9 112l108.1 0L128 57.9 73.9 112zm384 288L512 454.1 566.1 400l-108.1 0z"]
};
const faGarage = {
  prefix: 'far',
  iconName: 'garage',
  icon: [640, 512, [], "e009", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 368l0 120c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-120-352 0zm0-48l352 0 0-80-352 0 0 80zm136 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faCableCar = {
  prefix: 'far',
  iconName: 'cable-car',
  icon: [512, 512, [128673, 57551, "tram"], "f7da", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM432 288l0 64-80 0 0-80 64 0c8.8 0 16 7.2 16 16zm0 112l0 48c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-48 104 0 144 0 104 0zM80 352l0-64c0-8.8 7.2-16 16-16l64 0 0 80-80 0zm128-80l96 0 0 80-96 0 0-80zM96 224c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-136 0 0-76.5 212.9-44c13-2.7 21.3-15.4 18.6-28.4s-15.4-21.3-28.4-18.6l-232 48-232 48c-13 2.7-21.3 15.4-18.6 28.4s15.4 21.3 28.4 18.6l203.1-42 0 66.5L96 224z"]
};
const faTram = faCableCar;
const faShovelSnow = {
  prefix: 'far',
  iconName: 'shovel-snow',
  icon: [512, 512, [], "f7c3", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-31.4 31.4c-15.1 15.1-35.6 23.6-57 23.6c-13.5 0-26.2-3.3-37.4-9.2L297.9 248l35.3 35.3c19.8 19.8 21.9 51.2 4.9 73.5L236.7 489.9c-10.6 13.9-27.1 22.1-44.5 22.1l-2.9 0c-14.9 0-29.1-5.9-39.6-16.4L16.4 362.3C5.9 351.8 0 337.6 0 322.7l0-2.9c0-17.5 8.2-34 22.1-44.5L155.2 173.9c22.3-17 53.7-14.9 73.5 4.9L264 214.1l81.2-81.2c-5.9-11.2-9.2-23.9-9.2-37.4c0-21.4 8.5-41.9 23.6-57L391 7zm17 50.9L393.5 72.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L454.1 104 408 57.9zM184.3 212L51.2 313.5c-2 1.5-3.2 3.9-3.2 6.4l0 2.9c0 2.1 .8 4.2 2.3 5.7L183.6 461.7c1.5 1.5 3.5 2.3 5.7 2.3l2.9 0c2.5 0 4.9-1.2 6.4-3.2L300 327.7c2.4-3.2 2.1-7.7-.7-10.5L194.8 212.7c-2.8-2.8-7.3-3.1-10.5-.7zm5.8 90.1l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm48 48l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
const faCloudRain = {
  prefix: 'far',
  iconName: 'cloud-rain',
  icon: [512, 512, [127783, 9926], "f73d", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM89.2 372L54.2 436.6C50.1 444.1 48 452.5 48 461l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L102.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm160 0l-35.1 64.6c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L262.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4zm124.9 64.6c-4.1 7.5-6.2 15.8-6.2 24.3l0 3c0 26.5 21.5 48 48 48s48-21.5 48-48l0-3c0-8.5-2.1-16.9-6.2-24.3L422.8 372c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-35.1 64.6z"]
};
const faFaceLying = {
  prefix: 'far',
  iconName: 'face-lying',
  icon: [512, 512, [], "e37e", "M431.3 368L352 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-152 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l152 0c7.7 0 15.1 1.2 22.1 3.4C448.1 126.1 361.2 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c73.6 0 138.3-38.3 175.3-96zm67.4-30.3C464.6 439 368.8 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 8.8-.4 17.6-1.3 26.2c.9 4.5 1.3 9.1 1.3 13.8c0 15.6-4.9 30-13.3 41.7zM144.4 176a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM195.2 390.4c-8 10.6-23 12.7-33.6 4.8s-12.7-23-4.8-33.6C175.7 336.4 206 320 240 320c14.7 0 28.8 3.1 41.6 8.7c12.1 5.3 17.7 19.5 12.4 31.6s-19.5 17.7-31.6 12.4c-6.8-3-14.4-4.6-22.4-4.6c-18.3 0-34.6 8.8-44.8 22.4z"]
};
const faSprinkler = {
  prefix: 'far',
  iconName: 'sprinkler',
  icon: [512, 512, [], "e035", "M0 24a24 24 0 1 1 48 0A24 24 0 1 1 0 24zm24 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM512 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM488 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM424 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 136a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM97.8 270.8c3.7-9 12.5-14.8 22.2-14.8l112 0 0-168c0-13.3 10.7-24 24-24s24 10.7 24 24l0 168 112 0c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89 0 86.1c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-86.1-89-89c-6.9-6.9-8.9-17.2-5.2-26.2zM256 304l-78.1 0 55 55c4.5 4.5 7 10.6 7 17l0 88 32 0 0-88c0-6.4 2.5-12.5 7-17l55-55L256 304z"]
};
const faBuildingCircleXmark = {
  prefix: 'far',
  iconName: 'building-circle-xmark',
  icon: [640, 512, [], "e4d4", "M64 48l256 0c8.8 0 16 7.2 16 16l0 230.6c11.1-24.3 27.7-45.5 48-62.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c19.5 0 37-8.7 48.7-22.5c-13.4-14-24.5-30.3-32.7-48.1l0 6.6c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zm24 56l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faPersonSledding = {
  prefix: 'far',
  iconName: 'person-sledding',
  icon: [512, 512, ["sledding"], "f7cb", "M400 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 152c0-13.3 10.7-24 24-24l169.4 0c35.6 0 53.5 43.1 28.3 68.3L281.9 264l62.1 0c22.1 0 40 17.9 40 40l0 80c0 7.7-3.7 14.6-9.4 19l43.9 22.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 269.3C1.2 263.2-3.4 248.7 2.7 236.9s20.6-16.3 32.4-10.2l124.1 64.4c-4.3-11.5-2.2-25.4 8.8-35.1l90.7-80L152 176c-13.3 0-24-10.7-24-24zM336 312l-136.7 0L336 383l0-71z"]
};
const faSledding = faPersonSledding;
const faGameConsoleHandheld = {
  prefix: 'far',
  iconName: 'game-console-handheld',
  icon: [384, 512, [], "f8bb", "M64 48c-8.8 0-16 7.2-16 16l0 352c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-352c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 352c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 64zM232 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM128 288c8.8 0 16 7.2 16 16l0 16 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-16c0-8.8 7.2-16 16-16zM112 96l160 0c8.8 0 16 7.2 16 16l0 112c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-112c0-8.8 7.2-16 16-16z"]
};
const faShip = {
  prefix: 'far',
  iconName: 'ship',
  icon: [576, 512, [128674], "f21a", "M192 32c0-17.7 14.3-32 32-32L352 0c17.7 0 32 14.3 32 32l0 32 40 0c30.9 0 56 25.1 56 56l0 118.4 25.9 9.7c38.1 14.3 48.7 63.2 19.9 92L457 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l68.9-68.9c4.1-4.1 2.6-11.1-2.8-13.1L290.8 218.7c-1.8-.7-3.8-.7-5.6 0L87 293c-5.4 2-7 9-2.8 13.1L153 375c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L50.2 340.1c-28.8-28.8-18.2-77.7 19.9-92L96 238.4 96 120c0-30.9 25.1-56 56-56l40 0 0-32zm-48 88l0 100.4 124.3-46.6c12.7-4.8 26.6-4.8 39.3 0L432 220.4 432 120c0-4.4-3.6-8-8-8l-272 0c-4.4 0-8 3.6-8 8zM111.9 430.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faClockSixThirty = {
  prefix: 'far',
  iconName: 'clock-six-thirty',
  icon: [512, 512, [], "e353", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM280 392l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faBatterySlash = {
  prefix: 'far',
  iconName: 'battery-slash',
  icon: [640, 512, [], "f377", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6C563.1 386 576 362.5 576 336l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L154.8 96 38.8 5.1zM216 144l280 0c17.7 0 32 14.3 32 32l0 160c0 15.9-11.6 29.1-26.7 31.6L216 144zM406.2 416l-60.9-48L112 368c-17.7 0-32-14.3-32-32l0-160c0-5.1 1.2-10 3.4-14.3l-38-30C36.9 144.4 32 159.6 32 176l0 160c0 44.2 35.8 80 80 80l294.2 0z"]
};
const faTugrikSign = {
  prefix: 'far',
  iconName: 'tugrik-sign',
  icon: [384, 512, [], "e2ba", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l144 0 0 125.3L58.2 232.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 254.7l0 46.5L58.2 328.7c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5L168 350.7 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-117.3 109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 289.3l0-46.5 109.8-27.5c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5L216 193.3 216 80l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L192 32 24 32z"]
};
const faArrowsDownToLine = {
  prefix: 'far',
  iconName: 'arrows-down-to-line',
  icon: [576, 512, [], "e4b8", "M552 432L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24zm17-159c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63L472 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L431 377c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L569 273zM249 239c-9.4-9.4-24.6-9.4-33.9 0l-63 63L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 246.1L41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L111 377c9.4 9.4 24.6 9.4 33.9 0L249 273c9.4-9.4 9.4-24.6 0-33.9z"]
};
const faDownload = {
  prefix: 'far',
  iconName: 'download',
  icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faAnglesUpDown = {
  prefix: 'far',
  iconName: 'angles-up-down',
  icon: [448, 512, [], "e60d", "M239 498.7c-8.8 7-21.2 7-30 0L49 370.7c-10.4-8.3-12-23.4-3.7-33.7s23.4-12 33.7-3.8l145 116 145-116c10.3-8.3 25.5-6.6 33.7 3.8s6.6 25.5-3.7 33.7l-160 128zM399 141.3c10.4 8.3 12 23.4 3.8 33.7s-23.4 12-33.7 3.7L224 62.7 79 178.7c-10.4 8.3-25.5 6.6-33.7-3.7s-6.6-25.5 3.7-33.7l160-128c8.8-7 21.2-7 30 0l160 128z"]
};
const faShelves = {
  prefix: 'far',
  iconName: 'shelves',
  icon: [640, 512, ["inventory"], "f480", "M24 0C37.3 0 48 10.7 48 24l0 136 544 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 160 0 256 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L48 464l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48L0 184 0 24C0 10.7 10.7 0 24 0zM48 416l544 0 0-208L48 208l0 208zM352 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zM128 256l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm160 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"]
};
const faInventory = faShelves;
const faCloudSnow = {
  prefix: 'far',
  iconName: 'cloud-snow',
  icon: [512, 512, [127784], "f742", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM64 352c-13.3 0-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24zm192 32c-13.3 0-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16c0-13.3-10.7-24-24-24zm216-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-16z"]
};
const faFaceGrin = {
  prefix: 'far',
  iconName: 'face-grin',
  icon: [512, 512, [128512, "grin"], "f580", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGrin = faFaceGrin;
const faDeleteLeft = {
  prefix: 'far',
  iconName: 'delete-left',
  icon: [576, 512, [9003, "backspace"], "f55a", "M205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L205.3 64zM528 128l0 256c0 8.8-7.2 16-16 16l-306.7 0c-4.2 0-8.3-1.7-11.3-4.7L54.6 256 193.9 116.7c3-3 7.1-4.7 11.3-4.7L512 112c8.8 0 16 7.2 16 16zm-95 47c-9.4-9.4-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9z"]
};
const faBackspace = faDeleteLeft;
const faOven = {
  prefix: 'far',
  iconName: 'oven',
  icon: [448, 512, [], "e01d", "M352 48c26.5 0 48 21.5 48 48l0 64L48 160l0-64c0-26.5 21.5-48 48-48l256 0zm48 160l0 240c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-240 352 0zM96 0C43 0 0 43 0 96L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-352c0-53-43-96-96-96L96 0zm32 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-224 0zm32 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faCloudBinary = {
  prefix: 'far',
  iconName: 'cloud-binary',
  icon: [640, 512, [], "e601", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM176 216l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm72-16c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm120-16c-22.1 0-40 17.9-40 40l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0zm-8 40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16zM192 320c0 8.8 7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zm80 24l0 16c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 16c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-16c0-4.4 3.6-8 8-8zm88-32c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0z"]
};
const faEyeDropper = {
  prefix: 'far',
  iconName: 'eye-dropper',
  icon: [512, 512, ["eye-dropper-empty", "eyedropper"], "f1fb", "M199 169L233 202.9 309.1 279 343 313l8 8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-8-8 33.9-33.9 71.3-71.3c19.1-19.1 29.8-45 29.8-72C512 45.6 466.4 0 410.2 0c-27 0-52.9 10.7-72 29.8l-71.3 71.3L233 135l-8-8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c0 0 0 0 0 0l8 8zm249.2-29.1L343 245.1 266.9 169 372.1 63.8C382.2 53.7 395.9 48 410.2 48c29.7 0 53.8 24.1 53.8 53.8c0 14.3-5.7 28-15.8 38.1zM53.1 329C39.6 342.5 32 360.8 32 379.9l0 52.9-28 42c-6.3 9.5-5.1 22.2 3 30.3s20.8 9.3 30.3 3l42-28 52.9 0c19.1 0 37.4-7.6 50.9-21.1L313.4 328.6l-33.9-33.9L149.1 425c-4.5 4.5-10.6 7-17 7L80 432l0-52.1c0-6.4 2.5-12.5 7-17L217.4 232.6l-33.9-33.9L53.1 329z"]
};
const faEyeDropperEmpty = faEyeDropper;
const faEyedropper = faEyeDropper;
const faCommentCaptions = {
  prefix: 'far',
  iconName: 'comment-captions',
  icon: [512, 512, [], "e146", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM120 192c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm224 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM136 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0zm112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z"]
};
const faCommentsQuestion = {
  prefix: 'far',
  iconName: 'comments-question',
  icon: [640, 512, [], "e14e", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM147.9 112.1c5.5-15.4 20.1-25.7 36.4-25.7l41.3 0c24.2 0 43.7 19.6 43.7 43.7c0 15.7-8.4 30.1-22 37.9L224 181.4l0 .3c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2c0-6.5-5.3-11.7-11.7-11.7l-41.3 0c-2.8 0-5.3 1.8-6.3 4.4l-.3 .9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 244a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1 -45.3 0z"]
};
const faScribble = {
  prefix: 'far',
  iconName: 'scribble',
  icon: [512, 512, [], "e23f", "M183.3 21.4C198.3 7.7 218 0 238.4 0l1 0C283.9 0 320 36.1 320 80.6c0 21.4-8.5 41.9-23.6 57L89.5 344.4c-6.1 6.1-9.5 14.4-9.5 23c0 18 14.6 32.6 32.6 32.6c8.6 0 16.9-3.4 23-9.5L374.5 151.6c15.1-15.1 35.6-23.6 57-23.6c44.5 0 80.6 36.1 80.6 80.6c0 21.4-8.5 41.9-23.6 57L384.2 369.8c-10.4 10.3-16.2 24.4-16.2 39c0 30.5 24.7 55.2 55.2 55.2l4.4 0c5.6 0 11.2-.9 16.6-2.7l36.2-12.1c12.6-4.2 26.2 2.6 30.4 15.2s-2.6 26.2-15.2 30.4l-36.2 12.1c-10.2 3.4-21 5.2-31.8 5.2l-4.4 0c-57 0-103.2-46.2-103.2-103.2c0-27.4 10.9-53.6 30.2-73L454.5 231.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6c-8.6 0-16.9 3.4-23 9.5L169.5 424.4c-15.1 15.1-35.6 23.6-57 23.6C68.1 448 32 411.9 32 367.4c0-21.4 8.5-41.9 23.6-57L262.5 103.6c6.1-6.1 9.5-14.4 9.5-23c0-18-14.6-32.6-32.6-32.6l-1 0c-8.4 0-16.5 3.2-22.7 8.8L40.2 217.7c-9.8 9-25 8.3-33.9-1.5s-8.3-25 1.5-33.9L183.3 21.4z"]
};
const faRotateExclamation = {
  prefix: 'far',
  iconName: 'rotate-exclamation',
  icon: [512, 512, [], "e23c", "M256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1 448 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l54.1 0-52.1-52.1C333.8 95.8 295.7 80 256 80zM449.4 312.6c12.2 5.2 17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9 64 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-54.1 0 52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faFileCircleCheck = {
  prefix: 'far',
  iconName: 'file-circle-check',
  icon: [576, 512, [], "e5a0", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm224-96a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faGlass = {
  prefix: 'far',
  iconName: 'glass',
  icon: [384, 512, [129371], "f804", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM57.1 128L50.2 48l283.7 0-6.9 80L57.1 128zm4.1 48l261.6 0L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L61.2 176z"]
};
const faLoader = {
  prefix: 'far',
  iconName: 'loader',
  icon: [512, 512, [], "e1d4", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm0 384c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM0 256c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zm408-24c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM437 75c-9.4-9.4-24.6-9.4-33.9 0l-56.6 56.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9c9.4-9.4 9.4-24.6 0-33.9zM165.5 380.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l56.6-56.6zM75 75c-9.4 9.4-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0zM380.5 346.5c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56.6-56.6z"]
};
const faForward = {
  prefix: 'far',
  iconName: 'forward',
  icon: [512, 512, [9193], "f04e", "M224 94c0-16.6 13.5-30 30-30c6.3 0 12.5 2 17.6 5.7L502.1 236.6c6.2 4.5 9.9 11.7 9.9 19.4s-3.7 14.9-9.9 19.4L271.7 442.3c-5.1 3.7-11.3 5.7-17.6 5.7c-16.6 0-30-13.4-30-30l0-99.1L47.3 442.6c-5.1 3.5-11.1 5.4-17.3 5.4C13.5 448 0 434.5 0 417.9L0 94.1C0 77.5 13.5 64 30.1 64c6.2 0 12.2 1.9 17.3 5.4L224 193.1 224 94zm0 157.7L48 128.5l0 255L224 260.3l0-8.6zM447.1 256L272 129.2l0 253.6L447.1 256z"]
};
const faUserPilot = {
  prefix: 'far',
  iconName: 'user-pilot',
  icon: [448, 512, [], "e2c0", "M217.9 .8c4-1.1 8.2-1.1 12.2 0l152 40c8.6 2.3 15.3 9.1 17.3 17.8s-1 17.8-7.8 23.6L368 102.5l0 8.4c0 10.7-5.3 20.8-15.1 25.2c-24.1 10.8-68.6 24-128.9 24s-104.8-13.2-128.9-24C85.3 131.7 80 121.6 80 110.9l0-8.4L56.4 82.2c-6.8-5.8-9.8-14.9-7.8-23.6s8.7-15.6 17.3-17.8l152-40zM183.2 65.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1 183.2 65.7zM98.1 168.8c14 5.4 28.5 9.9 43.3 13.4c-.4 3.2-.6 6.5-.6 9.8c0 46 37.2 83.2 83.2 83.2s83.2-37.2 83.2-83.2c0-3.3-.2-6.6-.6-9.8c14.8-3.6 29.3-8.1 43.3-13.4c1.4 7.5 2.1 15.3 2.1 23.2c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-7.9 .7-15.7 2.1-23.2zM50.9 464l137.6 0c-2.3-1.5-4.5-3.2-6.6-5.1l-65.2-57.1c-31.9 6.7-57.3 30.9-65.7 62.2zm346.1 0c-8.4-31.2-33.8-55.5-65.7-62.2l-65.2 57.1c-2.1 1.9-4.3 3.6-6.6 5.1l137.6 0zM126.5 352.2c3.9-.2 7.8 1.2 10.7 3.8l76.3 66.7c6 5.3 15 5.3 21.1 0l76.3-66.7c3-2.6 6.8-4.1 10.7-3.8C392.1 356.3 448 414.8 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4c0-71.6 55.9-130.1 126.5-134.2z"]
};
const faMobile = {
  prefix: 'far',
  iconName: 'mobile',
  icon: [384, 512, [128241, "mobile-android", "mobile-phone"], "f3ce", "M80 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L80 48zM16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM160 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faMobileAndroid = faMobile;
const faMobilePhone = faMobile;
const faCodePullRequestClosed = {
  prefix: 'far',
  iconName: 'code-pull-request-closed',
  icon: [512, 512, [], "e3f9", "M144 80A32 32 0 1 0 80 80a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3l0 199.3c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-199.3C55.5 146.1 32 115.8 32 80C32 35.8 67.8 0 112 0s80 35.8 80 80zM112 464a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 48c-44.2 0-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L376 224c0-13.3 10.7-24 24-24s24 10.7 24 24l0 131.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80zM327 7c9.4-9.4 24.6-9.4 33.9 0l39 39L439 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L327 41c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faFaceMeh = {
  prefix: 'far',
  iconName: 'face-meh',
  icon: [512, 512, [128528, "meh"], "f11a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faMeh = faFaceMeh;
const faAlignCenter = {
  prefix: 'far',
  iconName: 'align-center',
  icon: [448, 512, [], "f037", "M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L120 40zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM96 320c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424z"]
};
const faBookSkull = {
  prefix: 'far',
  iconName: 'book-skull',
  icon: [448, 512, ["book-dead"], "f6b7", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM48 432c0 17.7 14.3 32 32 32l288 0 0-64L80 400c-17.7 0-32 14.3-32 32zm0-73.3c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM288 195.2l0 12.8c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-12.8c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM224 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128.8 234.9c2.8-8.4 11.9-12.9 20.2-10.1L240 255.1l90.9-30.3c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2L290.6 272l50.5 16.8c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1L240 288.9l-90.9 30.3c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2L189.4 272l-50.5-16.8c-8.4-2.8-12.9-11.9-10.1-20.2z"]
};
const faBookDead = faBookSkull;
const faIdCard = {
  prefix: 'far',
  iconName: 'id-card',
  icon: [576, 512, [62147, "drivers-license"], "f2c2", "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
};
const faDriversLicense = faIdCard;
const faFaceDotted = {
  prefix: 'far',
  iconName: 'face-dotted',
  icon: [512, 512, [129765], "e47f", "M256 0c-13.6 0-27 1.1-40 3.1c-13.1 2.1-22 14.3-20 27.4s14.3 22 27.4 20C234 48.9 244.9 48 256 48s22 .9 32.6 2.5c13.1 2.1 25.4-6.9 27.4-20s-6.9-25.4-20-27.4C283 1.1 269.6 0 256 0zM133.7 87.7c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3C83.8 64.7 64.7 83.8 48.9 105.5c-7.8 10.7-5.4 25.7 5.3 33.5s25.7 5.4 33.5-5.3c12.8-17.6 28.4-33.2 46.1-46.1zM406.5 48.9c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5c17.6 12.8 33.2 28.4 46 46.1c7.8 10.7 22.8 13.1 33.5 5.3s13.1-22.8 5.3-33.5c-15.8-21.7-34.9-40.8-56.6-56.6zM50.5 223.4c2.1-13.1-6.9-25.4-20-27.4s-25.4 6.9-27.4 20C1.1 229 0 242.4 0 256s1.1 27 3.1 40c2.1 13.1 14.3 22 27.4 20s22-14.3 20-27.4C48.9 278 48 267.1 48 256s.9-22 2.5-32.6zM508.9 216c-2.1-13.1-14.3-22-27.4-20s-22 14.3-20 27.4c1.7 10.6 2.5 21.5 2.5 32.6s-.9 22-2.5 32.6c-2.1 13.1 6.9 25.4 20 27.4s25.4-6.9 27.4-20c2.1-13.1 3.1-26.4 3.1-40s-1.1-27-3.1-40zM87.7 378.3c-7.8-10.7-22.8-13.1-33.5-5.3s-13.1 22.8-5.3 33.5c15.8 21.7 34.9 40.8 56.6 56.6c10.7 7.8 25.7 5.4 33.5-5.3s5.4-25.7-5.3-33.5c-17.6-12.8-33.2-28.4-46.1-46zm375.4 28.2c7.8-10.7 5.4-25.7-5.3-33.5s-25.7-5.4-33.5 5.3c-12.8 17.6-28.4 33.2-46 46c-10.7 7.8-13.1 22.8-5.3 33.5s22.8 13.1 33.5 5.3c21.7-15.8 40.8-34.9 56.6-56.6zm-239.7 55c-13.1-2.1-25.4 6.9-27.4 20s6.9 25.4 20 27.4c13.1 2.1 26.4 3.1 40 3.1s27-1.1 40-3.1c13.1-2.1 22-14.3 20-27.4s-14.3-22-27.4-20C278 463.1 267.1 464 256 464s-22-.9-32.6-2.5zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faFaceWorried = {
  prefix: 'far',
  iconName: 'face-worried',
  icon: [512, 512, [], "e3a3", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 414.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6 .8-22.6c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1c8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2c6.5 6 6.8 16.2 .8 22.6s-16.2 6.8-22.6 .8c-15.5-14.5-34.8-24-56.1-26.8z"]
};
const faOutdent = {
  prefix: 'far',
  iconName: 'outdent',
  icon: [448, 512, ["dedent"], "f03b", "M0 64C0 50.7 10.7 40 24 40l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 88C10.7 88 0 77.3 0 64zM192 192c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 104l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 448c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 472c-13.3 0-24-10.7-24-24zM7 268.4C-.8 262-.8 250 7 243.6l94.8-78.1c10.4-8.6 26.2-1.2 26.2 12.4l0 156.2c0 13.5-15.7 20.9-26.2 12.4L7 268.4z"]
};
const faDedent = faOutdent;
const faCourtSport = {
  prefix: 'far',
  iconName: 'court-sport',
  icon: [640, 512, [], "e643", "M64 80c-8.8 0-16 7.2-16 16l0 32 16 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-16 0 0 32c0 8.8 7.2 16 16 16l232 0 0-66.6c-50.3-11-88-55.8-88-109.4s37.7-98.4 88-109.4L296 80 64 80zM344 365.4l0 66.6 232 0c8.8 0 16-7.2 16-16l0-32-16 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l16 0 0-32c0-8.8-7.2-16-16-16L344 80l0 66.6c50.3 11 88 55.8 88 109.4s-37.7 98.4-88 109.4zm0-168.8l0 118.7c23.5-9.5 40-32.5 40-59.3s-16.5-49.9-40-59.3zm-48 0c-23.5 9.5-40 32.5-40 59.3s16.5 49.9 40 59.3l0-118.7zM48 176l0 160 16 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-16 0zM576 336l16 0 0-160-16 0c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faHeartCircleExclamation = {
  prefix: 'far',
  iconName: 'heart-circle-exclamation',
  icon: [576, 512, [], "e4fe", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faHouse = {
  prefix: 'far',
  iconName: 'house',
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-48 0 0-152c0-22.1-17.9-40-40-40l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32zm128 32l0-144 96 0 0 144-96 0z"]
};
const faHome = faHouse;
const faHomeAlt = faHouse;
const faHomeLgAlt = faHouse;
const faVectorCircle = {
  prefix: 'far',
  iconName: 'vector-circle',
  icon: [512, 512, [], "e2c6", "M232 88l48 0 0-48-48 0 0 48zM192 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 17.6c67.8 21 121.4 74.5 142.4 142.4l17.6 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-17.6 0c-21 67.8-74.5 121.4-142.4 142.4l0 17.6c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-17.6C124.2 441.4 70.6 387.8 49.6 320L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l17.6 0C70.6 124.2 124.2 70.6 192 49.6L192 32zM100.5 192.3C116 194.5 128 207.9 128 224l0 64c0 16.1-12 29.5-27.5 31.7c17 41.6 50.3 74.8 91.8 91.8C194.5 396 207.9 384 224 384l64 0c16.1 0 29.5 12 31.7 27.5c41.6-17 74.8-50.3 91.8-91.8C396 317.5 384 304.1 384 288l0-64c0-16.1 12-29.5 27.5-31.7c-17-41.6-50.3-74.8-91.8-91.8C317.5 116 304.1 128 288 128l-64 0c-16.1 0-29.5-12-31.7-27.5c-41.6 17-74.8 50.3-91.8 91.8zM424 232l0 48 48 0 0-48-48 0zM232 424l0 48 48 0 0-48-48 0zM40 232l0 48 48 0 0-48-48 0z"]
};
const faCarCircleBolt = {
  prefix: 'far',
  iconName: 'car-circle-bolt',
  icon: [640, 512, [], "e342", "M127.7 106.8L103.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9c2.6 1.5 5.2 3.2 7.6 4.9c-28.3 3.9-54.4 14.6-76.8 30.3L96 224c-26.5 0-48 21.5-48 48l0 80 272.7 0c-.5 5.3-.7 10.6-.7 16c0 10.9 1 21.6 2.9 32L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm384-32a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
const faCalendarWeek = {
  prefix: 'far',
  iconName: 'calendar-week',
  icon: [448, 512, [], "f784", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l224 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"]
};
const faFlyingDisc = {
  prefix: 'far',
  iconName: 'flying-disc',
  icon: [448, 512, [], "e3a9", "M390.4 89.6c7.9 7.9 16.9 31.4 .6 80.4c-15.3 45.9-49.5 101-100.7 152.2S183.9 407.6 138 422.9c-49 16.3-72.5 7.3-80.4-.6c-5.6-5.6-11.8-19.2-9-44.3c19.9 19.2 45.3 20.8 62.5 18.9c18.1-2 36.3-8.8 52.8-17c33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8c1.9-17.2 .3-42.6-18.9-62.5c25.1-2.8 38.7 3.3 44.3 9zM105.2 175.4C8.3 281.9-28.4 404.2 23.7 456.3C79 511.6 213.5 466.8 324.2 356.2S479.6 111 424.3 55.7C372.2 3.6 249.9 40.3 143.5 137.1c-6.6 6-13.2 12.2-19.7 18.7c-6.5 6.5-12.7 13-18.6 19.6zm35.6 32.2c5.4-6 11.1-11.9 17-17.8c5.9-5.9 11.9-11.6 17.9-17c57.9-52.3 116.2-78.4 135.5-59.1c21.4 21.4-12.7 90.1-76.1 153.4s-132.1 97.4-153.4 76.1c-19.4-19.4 6.8-77.7 59.1-135.6z"]
};
const faLaptopMedical = {
  prefix: 'far',
  iconName: 'laptop-medical',
  icon: [640, 512, [], "f812", "M128 80l384 0c8.8 0 16 7.2 16 16l0 224 48 0 0-224c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 224 48 0 0-224c0-8.8 7.2-16 16-16zM50.7 400l538.5 0c-6.6 18.6-24.4 32-45.3 32L96 432c-20.9 0-38.7-13.4-45.3-32zM32 352c-17.7 0-32 14.3-32 32c0 53 43 96 96 96l448 0c53 0 96-43 96-96c0-17.7-14.3-32-32-32L32 352zM288 144l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faSquareDownRight = {
  prefix: 'far',
  iconName: 'square-down-right',
  icon: [448, 512, [], "e26c", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM320 198.6L320 336c0 8.8-7.2 16-16 16l-137.4 0c-12.5 0-22.6-10.1-22.6-22.6c0-6 2.4-11.8 6.6-16L184 280l-66.3-66.3C114 210 112 205.1 112 200s2-10 5.7-13.7l36.7-36.7c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 216l33.4-33.4c4.2-4.2 10-6.6 16-6.6c12.5 0 22.6 10.1 22.6 22.6z"]
};
const faB = {
  prefix: 'far',
  iconName: 'b',
  icon: [320, 512, [98], "42", "M56 32C25.1 32 0 57.1 0 88L0 256 0 424c0 30.9 25.1 56 56 56l140 0c68.5 0 124-55.5 124-124c0-48.9-28.3-91.1-69.3-111.3c23-22.5 37.3-53.9 37.3-88.7c0-68.5-55.5-124-124-124L56 32zM164 232L48 232 48 88c0-4.4 3.6-8 8-8l108 0c42 0 76 34 76 76s-34 76-76 76zM48 280l116 0 28 0 4 0c42 0 76 34 76 76s-34 76-76 76L56 432c-4.4 0-8-3.6-8-8l0-144z"]
};
const faSeatAirline = {
  prefix: 'far',
  iconName: 'seat-airline',
  icon: [448, 512, [], "e244", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 142.9c0 14.7 3.1 29.2 9.1 42.5L89.1 364c14.2 31.6 45.6 52 80.3 52l46.6 0 0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48 88 0c29.1 0 55.3-17.5 66.5-44.3l27.7-66.5c3.1-7.4 2.3-15.9-2.2-22.5S432 272 424 272l-323.5 0L86.2 240 328 240c13.3 0 24-10.7 24-24s-10.7-24-24-24L64.6 192 52.9 165.8c-3.2-7.2-4.9-15-4.9-22.9L48 24zm84.9 320.4L122 320l266 0-13.8 33.2c-3.7 8.9-12.5 14.8-22.2 14.8l-182.6 0c-15.8 0-30.1-9.3-36.5-23.6z"]
};
const faMoonOverSun = {
  prefix: 'far',
  iconName: 'moon-over-sun',
  icon: [512, 512, ["eclipse-alt"], "f74a", "M361.3 1.8c7.5 3.1 12.9 9.8 14.4 17.8l18.1 98.5 98.5 18.1c8 1.5 14.7 6.9 17.8 14.4s2.2 16.1-2.4 22.8L450.9 256l56.9 82.5c4.6 6.7 5.5 15.3 2.4 22.8s-9.8 13-17.8 14.4l-98.5 18.1-18.1 98.5c-1.5 8-6.9 14.7-14.4 17.8s-16.1 2.2-22.8-2.4L256 450.9l-82.5 56.9c-6.7 4.6-15.3 5.5-22.8 2.4s-12.9-9.8-14.4-17.8l-18.1-98.5L19.7 375.7c-8-1.5-14.7-6.9-17.8-14.4s-2.2-16.1 2.4-22.8L61.1 256 4.2 173.5c-4.6-6.7-5.5-15.3-2.4-22.8s9.8-12.9 17.8-14.4l98.5-18.1 18.1-98.5c1.5-8 6.9-14.7 14.4-17.8s16.1-2.2 22.8 2.4L256 61.1 338.5 4.2c6.7-4.6 15.3-5.5 22.8-2.4zm-26.1 63L269.6 110c-8.2 5.7-19 5.7-27.2 0L176.8 64.8l-14.4 78.3c-1.8 9.8-9.5 17.5-19.3 19.3L64.8 176.8 110 242.4c5.7 8.2 5.7 19 0 27.2L64.8 335.2l78.3 14.4c9.8 1.8 17.5 9.5 19.3 19.3l14.4 78.3L242.4 402c8.2-5.7 19-5.7 27.2 0l65.6 45.2 14.4-78.3c1.8-9.8 9.5-17.5 19.3-19.3l78.3-14.4L402 269.6c-5.7-8.2-5.7-19 0-27.2l45.2-65.6-78.3-14.4c-9.8-1.8-17.5-9.5-19.3-19.3L335.2 64.8zM144 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm151.7 50.2C310.5 294.5 320 276.4 320 256c0-35.3-28.7-64-64-64c-.2 0-.4 0-.5 0c-12.3 12.2-19.9 29-19.9 47.5c0 34.4 26.2 62.9 60.1 66.7z"]
};
const faEclipseAlt = faMoonOverSun;
const faPipe = {
  prefix: 'far',
  iconName: 'pipe',
  icon: [64, 512, [], "7c", "M32 0C45.3 0 56 10.7 56 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L8 24C8 10.7 18.7 0 32 0z"]
};
const faFileMedical = {
  prefix: 'far',
  iconName: 'file-medical',
  icon: [384, 512, [], "f477", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm96 240l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faPotato = {
  prefix: 'far',
  iconName: 'potato',
  icon: [512, 512, [129364], "e440", "M464 144c0-53-43-96-96-96c-26.6 0-50.5 10.7-68 28.2C269.3 107 232 134.9 194 155.7c-16.1 8.8-29.4 22.1-38.2 38.2C134.9 232 107 269.3 76.2 300C58.7 317.5 48 341.4 48 368c0 53 43 96 96 96c20.2 0 38.9-6.2 54.3-16.8c31.8-21.9 67.9-39.9 104.3-52.2c29.5-10 53.5-34 62.1-66.1c11.5-42.8 36.5-84.4 68.8-114.7C452.4 196.6 464 171.7 464 144zm48 0c0 41.5-17.6 78.9-45.7 105.2c-25.8 24.2-46.1 57.9-55.2 92.1c-12.9 48.3-49 84.3-93.1 99.2c-32.3 10.9-64.4 26.9-92.5 46.2C202.4 502.7 174.3 512 144 512C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102C69.8 238.6 95 205 113.6 170.9c13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3C292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM352 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM168 256a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-8 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faDiceOne = {
  prefix: 'far',
  iconName: 'dice-one',
  icon: [448, 512, [9856], "f525", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCircleA = {
  prefix: 'far',
  iconName: 'circle-a',
  icon: [512, 512, [], "e0f7", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-400c-9.1 0-17.4 5.1-21.5 13.3l-104 208c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7L190.8 320l130.3 0 17.4 34.7c5.9 11.9 20.3 16.7 32.2 10.7s16.7-20.3 10.7-32.2l-104-208c-4.1-8.1-12.4-13.3-21.5-13.3zm0 77.7L297.2 272l-82.3 0L256 189.7z"]
};
const faHelmetBattle = {
  prefix: 'far',
  iconName: 'helmet-battle',
  icon: [576, 512, [], "f6eb", "M80 17.1L65.1 225.7c-1.2 17-15.4 30.2-32.5 30.2l-2.2 0C13.6 256 0 242.4 0 225.6c0-2.3 .3-4.6 .8-6.8L48.4 12.4c1.9-8.1 9.7-13.5 18-12.2s14.2 8.6 13.6 17zM75.5 420.5c-9.2-5.6-13.5-16.7-10.6-27.1C81.9 333.6 96 270.2 96 208c0-85 89.1-149.2 153.1-189c1.9-1.2 4-2.6 6.3-4.1C264.8 8.4 277.3 0 288 0s23.2 8.4 32.7 14.9c2.3 1.5 4.4 3 6.3 4.1C390.9 58.8 480 123 480 208c0 62.2 14.1 125.6 31.1 185.4c3 10.4-1.4 21.4-10.6 27.1L316.8 506c-8.5 3.9-17.7 6-27 6l-3.7 0c-9.3 0-18.6-2-27-6L75.5 420.5zM312 455.3l147.4-68.7C444.4 330.7 432 269.5 432 208c0-25-13.1-50.9-39.2-78.3c-26-27.1-60-50.6-91.2-70c-2.7-1.7-5.9-3.9-8.3-5.4l-1.5-1c-1.4-1-2.7-1.8-3.9-2.5c-1.2 .7-2.4 1.6-3.9 2.5l-1.5 1c-2.3 1.6-5.5 3.7-8.3 5.4c-31.2 19.4-65.2 42.9-91.2 70C157.1 157.1 144 183 144 208c0 61.5-12.4 122.7-27.4 178.7L264 455.3l0-156.1c0-6.7-4.2-12.7-10.5-15l-65.1-23.7c-7.4-2.7-12.4-9.8-12.4-17.7c0-10.4 8.4-18.8 18.8-18.8l186.4 0c10.4 0 18.8 8.4 18.8 18.8c0 7.9-5 15-12.4 17.7l-65.1 23.7c-6.3 2.3-10.5 8.3-10.5 15l0 156.1zM509.6 .2c8.3-1.2 16.1 4.1 18 12.2l47.6 206.4c.5 2.2 .8 4.5 .8 6.8c0 16.8-13.6 30.4-30.4 30.4l-2.2 0c-17.1 0-31.3-13.2-32.5-30.2L496 17.1c-.6-8.3 5.3-15.7 13.6-17z"]
};
const faButter = {
  prefix: 'far',
  iconName: 'butter',
  icon: [640, 512, [129480], "e3e4", "M464 112l0 176-48 0 0-176-288 0c-8.8 0-16 7.2-16 16l0 160-48 0 0-160c0-35.3 28.7-64 64-64l288 0 24 0 24 0 48 0c35.3 0 64 28.7 64 64l0 160-48 0 0-160c0-8.8-7.2-16-16-16l-48 0zM0 344c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 48c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32l0-48-8 0c-13.3 0-24-10.7-24-24z"]
};
const faBlanketFire = {
  prefix: 'far',
  iconName: 'blanket-fire',
  icon: [640, 512, [], "e3da", "M48 112c0-35.3 28.7-64 64-64l224 0c35.3 0 64 28.7 64 64l0 39.4c4.1-3.9 8.2-7.7 12.5-11.5c10-8.9 23-12.8 35.5-11.7l0-16.2C448 50.1 397.9 0 336 0L112 0C50.1 0 0 50.1 0 112L0 336c0 61.9 50.1 112 112 112l202.4 0c-8.7-14.9-15.4-31-19.9-48L112 400c-35.3 0-64-28.7-64-64s28.7-64 64-64l197 0c4.9-10 10.3-19.8 16.2-29.3c3.8-6.2 7.9-12.5 12.3-18.7L112 224c-23.8 0-45.9 7.4-64 20.1L48 112zM288 350.1c0-12.4 2-25.2 5.6-38.1L120 312c-13.3 0-24 10.7-24 24s10.7 24 24 24l168.3 0c-.2-3.3-.3-6.6-.3-9.9zM505.7 208.3l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.8 320 314.8 320 352.2C320 440.7 390.4 512 480 512c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400.2c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327.1 544 363.6 544 400.2z"]
};
const faKiwiBird = {
  prefix: 'far',
  iconName: 'kiwi-bird',
  icon: [576, 512, [], "f535", "M266.4 347.3c31.2-18.9 74.9-43.3 125.9-43.3l55.7 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-55.7 0c-51 0-94.7-24.4-125.9-43.3C244.7 87.6 219.3 80 192 80C112.5 80 48 144.5 48 224s64.5 144 144 144c27.3 0 52.7-7.6 74.4-20.7zM392.3 352c-36.4 0-69.9 17.6-101.1 36.4c-11.1 6.7-22.9 12.3-35.2 16.7l0 50.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40.7c-5.3 .4-10.6 .7-16 .7c-16.6 0-32.7-2.1-48-6l0 46c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-65.7C38.6 357.1 0 295.1 0 224C0 118 86 32 192 32c36.3 0 70.3 10.1 99.2 27.6C322.4 78.4 355.9 96 392.3 96L448 96c70.7 0 128 57.3 128 128l0 240c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7L477.6 348.6c-9.5 2.2-19.4 3.4-29.6 3.4l-55.7 0zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faCastle = {
  prefix: 'far',
  iconName: 'castle',
  icon: [640, 512, [], "e0de", "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 200-80 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 440c0 39.8 32.2 72 72 72l496 0c39.8 0 72-32.2 72-72l0-256c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-80 0 0-200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-64 0 0-40zm0 88l288 0 0 112-288 0 0-112zM48 272l544 0 0 168c0 13.3-10.7 24-24 24l-184 0 0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 80L72 464c-13.3 0-24-10.7-24-24l0-168z"]
};
const faGolfClub = {
  prefix: 'far',
  iconName: 'golf-club',
  icon: [512, 512, [], "f451", "M498.7 2.5c11.9 5.9 16.7 20.3 10.7 32.2L290.7 472.2c-12.2 24.4-37.1 39.8-64.4 39.8L56 512c-30.9 0-56-25.1-56-56L0 347.1c0-37.6 36.3-64.5 72.2-53.6L293 360.4 466.5 13.3c5.9-11.9 20.3-16.7 32.2-10.7zM271.2 404L58.3 339.5c-5.1-1.6-10.3 2.3-10.3 7.7L48 368l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 16 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 8c0 4.4 3.6 8 8 8l170.3 0c9.1 0 17.4-5.1 21.5-13.3L271.2 404z"]
};
const faArrowRightArrowLeft = {
  prefix: 'far',
  iconName: 'arrow-right-arrow-left',
  icon: [448, 512, [8644, "exchange"], "f0ec", "M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 360l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zM441 145c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l342.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z"]
};
const faExchange = faArrowRightArrowLeft;
const faRotateRight = {
  prefix: 'far',
  iconName: 'rotate-right',
  icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3L496 200c0 13.3-10.7 24-24 24l-116.7 0c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176l62.1 0 0-62.1z"]
};
const faRedoAlt = faRotateRight;
const faRotateForward = faRotateRight;
const faUtensils = {
  prefix: 'far',
  iconName: 'utensils',
  icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144L8 166.7 8 168l0 16c0 48.6 39.4 88 88 88l8 0 0 216c0 13.3 10.7 24 24 24s24-10.7 24-24l0-216 8 0c48.6 0 88-39.4 88-88l0-16 0-1.3-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3 .1s-22.7 13.3-21.2 26.5L200 169.3l0 14.7c0 22.1-17.9 40-40 40l-32 0-32 0c-22.1 0-40-17.9-40-40l0-14.7L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zM336 176c0-57.7 21.7-88.6 41.4-105.7c7.7-6.6 15.5-11.6 22.6-15.2L400 248l0 56-48 0c-8.8 0-16-7.2-16-16l0-112zm64 176l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 0-48 0-56 0-216c0-17.7-14.3-32-32-32C400 0 288 32 288 176l0 112c0 35.3 28.7 64 64 64l48 0z"]
};
const faCutlery = faUtensils;
const faArrowUpWideShort = {
  prefix: 'far',
  iconName: 'arrow-up-wide-short',
  icon: [576, 512, ["sort-amount-up"], "f161", "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L152 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM312 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0zm0-128c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L312 96z"]
};
const faSortAmountUp = faArrowUpWideShort;
const faChartPieSimpleCircleDollar = {
  prefix: 'far',
  iconName: 'chart-pie-simple-circle-dollar',
  icon: [640, 512, [], "e605", "M496 192c-46.8 0-89.3 18.2-120.8 48L272 240l0-223.4c0-9 7-16.6 16-16.6C401 0 494.5 83.7 509.8 192.5c-4.6-.4-9.2-.5-13.8-.5zM272 288l67.2 0c-7.6 14.9-13.2 31-16.3 48L224 336c-26.5 0-48-21.5-48-48l0-197.1C101.4 117.3 48 188.4 48 272c0 106 86 192 192 192c34.5 0 66.9-9.1 94.9-25c6.5 14.8 15 28.6 25.2 40.9C324.8 500.3 283.8 512 240 512C107.5 512 0 404.6 0 272C0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5L224 240l0 48 48 0zm80 80a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7 2.3 15.1 4.8 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6z"]
};
const faBalloons = {
  prefix: 'far',
  iconName: 'balloons',
  icon: [640, 512, [], "e2e4", "M272 160c0-61.9-50.1-112-112-112S48 98.1 48 160c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6zM112 400l10-20.1c3.5-6.9 1.6-15.3-4.4-20.3C87.2 334 0 252.5 0 160C0 71.6 71.6 0 160 0s160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L208 400l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-25.9 0-6.7 0-.1 0-36.7 0-.1 0-6.7 0s0 0 0 0l-25.9 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1zm48-264c-13.3 0-24 10.7-24 24s-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM437.7 423.7c-26.2-22.1-94.5-85.6-113-161.8C340.5 231.8 352 197.2 352 160c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 92.5-87.2 174-117.7 199.7c-5.9 5-7.8 13.4-4.4 20.3L528 464l.1 .1 3 6 11.6 23.2c.9 1.8 1.4 3.8 1.4 5.8c0 7.1-5.8 12.9-12.9 12.9l-25.9 0-6.7 0-.1 0-36.7 0-.1 0-6.7 0-25.9 0c-7.1 0-12.9-5.8-12.9-12.9c0-2 .5-4 1.4-5.8l11.6-23.2 3-6 .1-.1 10-20.1c3.5-6.9 1.6-15.3-4.4-20.3zM480 112c-61.9 0-112 50.1-112 112c0 31.6 15.3 65.1 38.2 96.6c22.5 30.8 48.7 54.8 62.4 66.3c4.4 3.7 8.2 7.9 11.4 12.5c3.2-4.6 7-8.8 11.4-12.5c13.7-11.5 39.9-35.5 62.4-66.3c23-31.5 38.2-65 38.2-96.6c0-61.9-50.1-112-112-112zM456 224c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-39.8 32.2-72 72-72c13.3 0 24 10.7 24 24s-10.7 24-24 24s-24 10.7-24 24z"]
};
const faMillSign = {
  prefix: 'far',
  iconName: 'mill-sign',
  icon: [384, 512, [], "e1ed", "M302.4 32.5c4.7-12.4-1.5-26.3-13.9-31s-26.3 1.5-31 13.9l-36.1 95.3c-11.3 6.6-21.2 15.2-29.4 25.3C172.2 111.6 141.9 96 108 96c-22.5 0-43.3 6.9-60.6 18.6C44.9 103.9 35.4 96 24 96C10.7 96 0 106.7 0 120l0 80c0 0 0 0 .1 0c0 1.3-.1 2.7-.1 4L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220c0-33.1 26.9-60 60-60s60 26.9 60 60l0 47.6L81.6 479.5c-4.7 12.4 1.5 26.2 13.9 31s26.3-1.5 31-13.9L168 386.9l0 29.1 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 0-155.6 43.3-114c5.3-1.5 10.9-2.4 16.7-2.4c33.1 0 60 26.9 60 60l0 220c0 13.3 10.7 24 24 24s24-10.7 24-24l0-220c0-58.9-47.1-106.7-105.7-108l24.1-63.5z"]
};
const faBowlRice = {
  prefix: 'far',
  iconName: 'bowl-rice',
  icon: [512, 512, [], "e2eb", "M176 56c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm24 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zM56 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm88.7 244.6c-4-13.5-13.8-24.6-26.8-30.3C82.7 374.9 56.7 342.7 49.8 304l412.4 0c-6.9 38.7-32.9 70.9-68.1 86.3c-12.9 5.7-22.7 16.7-26.8 30.3c-2 6.6-8.2 11.4-15.3 11.4l-192 0c-7.2 0-13.4-4.8-15.3-11.4zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480l192 0c29 0 53.5-19.3 61.4-45.7c58.1-25.4 98.6-83.4 98.6-150.8c0-15.1-12.3-27.4-27.4-27.4L27.4 256zM224 200c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-96 0c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm216 96c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zm120 96c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm-24-96c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0zM296 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0z"]
};
const faTimelineArrow = {
  prefix: 'far',
  iconName: 'timeline-arrow',
  icon: [640, 512, [], "e29d", "M160 96A32 32 0 1 0 96 96a32 32 0 1 0 64 0zm48 0c0 35.8-23.5 66.1-56 76.3l0 59.7 176 0 0-59.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3l0 59.7 178.6 0-58.9-54.4c-9.7-9-10.3-24.2-1.4-33.9s24.2-10.3 33.9-1.4l103.9 95.9c.1 .1 .3 .3 .4 .4c.3 .3 .6 .6 .9 .9c4 4.3 6.5 10.1 6.5 16.4s-2.5 12.1-6.5 16.4c-.3 .3-.6 .6-.9 .9c-.1 .1-.3 .3-.4 .4L528.3 369.6c-9.7 9-24.9 8.4-33.9-1.4s-8.4-24.9 1.4-33.9L554.6 280 248 280l0 59.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3l0-59.7L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0 0-59.7C71.5 162.1 48 131.8 48 96c0-44.2 35.8-80 80-80s80 35.8 80 80zM192 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM352 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faSkull = {
  prefix: 'far',
  iconName: 'skull',
  icon: [512, 512, [128128], "f54c", "M368 400c-.4-16 7.3-31.2 20.4-40.4C436.1 326.2 464 276.9 464 224c0-91.4-86.9-176-208-176S48 132.6 48 224c0 52.9 27.9 102.2 75.6 135.6c13.1 9.2 20.8 24.4 20.4 40.4c0 0 0 0 0 0l0 64 48 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 32 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 48 0 0-64s0 0 0 0zm48-1.1c0 .4 0 .7 0 1.1l0 64c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-64c0-.4 0-.7 0-1.1C37.5 357.8 0 294.7 0 224C0 100.3 114.6 0 256 0S512 100.3 512 224c0 70.7-37.5 133.8-96 174.9zM112 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm232-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
};
const faGameBoardSimple = {
  prefix: 'far',
  iconName: 'game-board-simple',
  icon: [448, 512, ["game-board-alt"], "f868", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm16 80l0 144 144 0 0-144L80 112zM224 256l0 144 144 0 0-144-144 0z"]
};
const faGameBoardAlt = faGameBoardSimple;
const faCircleVideo = {
  prefix: 'far',
  iconName: 'circle-video',
  icon: [512, 512, ["video-circle"], "e12b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144-56c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24l0-112zM364.9 317.9L320 288l0-64 44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3l0 103.4c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
};
const faVideoCircle = faCircleVideo;
const faChartScatterBubble = {
  prefix: 'far',
  iconName: 'chart-scatter-bubble',
  icon: [512, 512, [], "e0e9", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM176 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm200 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM240 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm168 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faHouseTurret = {
  prefix: 'far',
  iconName: 'house-turret',
  icon: [640, 512, [], "e1b4", "M56 48c-4.4 0-8 3.6-8 8l0 147.8c0 2 .7 3.9 2 5.3l55.9 62.9c3.9 4.4 6.1 10.1 6.1 15.9l0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-190.9L14.1 241C5 230.8 0 217.5 0 203.8L0 56C0 25.1 25.1 0 56 0L296 0c30.9 0 56 25.1 56 56l0 68.6-48 44L304 56c0-4.4-3.6-8-8-8l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-64 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40L56 48zm120 96c22.1 0 40 17.9 40 40l0 40c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-40c0-22.1 17.9-40 40-40zm100.8 93l128-117.3c24.5-22.4 62-22.4 86.5 0L619.2 237c13.2 12.1 20.8 29.2 20.8 47.2L640 448c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-163.8c0-17.9 7.5-35.1 20.8-47.2zM304 284.2L304 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-163.8c0-4.5-1.9-8.8-5.2-11.8L458.8 155c-6.1-5.6-15.5-5.6-21.6 0l-128 117.3c-3.3 3-5.2 7.3-5.2 11.8zM400 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48z"]
};
const faBanana = {
  prefix: 'far',
  iconName: 'banana',
  icon: [576, 512, [], "e2e5", "M352 144c0 46.7-10.5 90.9-29.3 130.4l-25.3-20.2c-4.4-3.5-9.1-6.8-13.9-9.8C296.7 213.6 304 179.7 304 144c0-31.4-5.6-61.3-15.9-89c-9.5-25.5 8.6-55 38-55c9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 10.9-.6 21.6-1.8 32.1c-10.9 .4-21.7 2.1-32.3 4.9l-17.6 4.7c2.4-13.5 3.6-27.5 3.6-41.7c0-59.5-21.7-114-57.6-156c6.2 24.3 9.6 49.7 9.6 76zM208.8 304c-15.5 0-30.4 5.5-42.2 15.6l-31.1 26.6c-10.1 8.6-25.2 7.5-33.8-2.6s-7.5-25.2 2.6-33.8l31.1-26.6c20.4-17.5 46.5-27.2 73.4-27.2c21.4 0 42.2 6.1 60.1 17.4l.1-.2c2.9 1.9 5.6 3.9 8.3 6l1.7 1.3 .2 .2 46.2 37s0 0 0 0l96.7-25.8s0 0 0 0c6.1-1.6 12.3-2.7 18.5-3.4c0 0 0 0 0 0c3.7-.4 7.5-.6 11.3-.6c40.7 0 78.4 21.3 99.3 56.2l21.3 35.4c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-21.3-35.4C497.9 348.5 475.8 336 452 336c-5.9 0-11.8 .8-17.5 2.3l-11.5 3.1C378.2 441.9 277.3 512 160 512L48 512c-26.5 0-48-21.5-48-48l0-16c0-26.5 21.5-48 48-48c76.9 0 145.9-33.9 192.8-87.6c-9.7-5.5-20.7-8.4-31.9-8.4z"]
};
const faHandHoldingSkull = {
  prefix: 'far',
  iconName: 'hand-holding-skull',
  icon: [576, 512, [], "e1a4", "M192 128c0 29.9 20.4 58.1 53.8 71.8c9.9 4.1 15.9 14.2 14.7 24.9L258.8 240l58.4 0-1.7-15.3c-1.2-10.6 4.8-20.8 14.7-24.9C363.6 186.1 384 157.9 384 128c0-41.1-39.6-80-96-80s-96 38.9-96 80zM288 0c76.2 0 144 54.2 144 128c0 46.7-27.7 86.1-66.9 108.2l2.8 25.2c.8 6.8-1.4 13.6-6 18.7s-11.1 8-17.9 8l-112 0c-6.8 0-13.3-2.9-17.9-8s-6.7-11.9-6-18.7l2.8-25.2C171.7 214.1 144 174.7 144 128C144 54.2 211.8 0 288 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0zM224 120a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM328 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPeopleDress = {
  prefix: 'far',
  iconName: 'people-dress',
  icon: [640, 512, [], "e217", "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM267.1 299.8l-37.4-66.1 36.5 129.9c2.9 10.2-4.8 20.3-15.4 20.3L224 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.9 0c-10.6 0-18.3-10.1-15.4-20.3L90.3 233.7 52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM155.4 179.5L111.4 336l97.3 0-44-156.5c-.6-2.1-2.5-3.5-4.6-3.5s-4 1.4-4.6 3.5zM480 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM587.1 299.8l-37.4-66.1 36.5 129.9c2.9 10.2-4.8 20.3-15.4 20.3L544 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-26.9 0c-10.6 0-18.3-10.1-15.4-20.3l36.5-129.9-37.4 66.1c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l51.8-91.5c19.8-35 56.9-56.6 97.1-56.6s77.3 21.6 97.1 56.6l51.8 91.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1zM475.4 179.5L431.4 336l97.3 0-44-156.5c-.6-2.1-2.5-3.5-4.6-3.5s-4 1.4-4.6 3.5z"]
};
const faLoveseat = {
  prefix: 'far',
  iconName: 'loveseat',
  icon: [512, 512, ["couch-small"], "f4cc", "M176 80l160 0c44.2 0 80 35.8 80 80l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8l0-34.8c0-70.7-57.3-128-128-128L176 32C105.3 32 48 89.3 48 160l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8L96 160c0-44.2 35.8-80 80-80zM462.5 227.6c-7.1-2.3-14.6-3.6-22.5-3.6c-9.5 0-18.5 1.8-26.8 5.2c-24.1 9.7-41.8 32-44.7 58.8l-224.9 0c-3-26.8-20.6-49.1-44.7-58.8C90.5 225.8 81.5 224 72 224c-7.9 0-15.4 1.3-22.5 3.6C20.7 237 0 264.1 0 296L0 432c0 26.5 21.5 48 48 48l48 0c20.9 0 38.7-13.4 45.3-32l229.5 0c6.6 18.6 24.4 32 45.3 32l48 0c26.5 0 48-21.5 48-48l0-136c0-31.9-20.7-59-49.5-68.4zM368 400l-224 0 0-64 32 0 160 0 32 0 0 64zM96 400l0 32-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 0 64zM464 296l0 136-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faCouchSmall = faLoveseat;
const faTowerBroadcast = {
  prefix: 'far',
  iconName: 'tower-broadcast',
  icon: [576, 512, ["broadcast-tower"], "f519", "M54.8 1.9C42.6-3.4 28.5 2.3 23.3 14.4C8.3 49.3 0 87.7 0 128s8.3 78.7 23.3 113.6c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5C54.9 193.6 48 161.6 48 128s6.9-65.6 19.4-94.6C72.6 21.2 67 7.1 54.8 1.9zm466.4 0C509 7.1 503.4 21.2 508.6 33.4c12.5 29 19.4 61 19.4 94.6s-6.9 65.6-19.4 94.6c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6c15-34.9 23.3-73.3 23.3-113.6s-8.3-78.7-23.3-113.6C547.5 2.3 533.4-3.4 521.2 1.9zM312 187.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 26.9 16.5 49.9 40 59.3L264 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-300.7zM166.5 87.6c4.2-12.6-2.6-26.2-15.2-30.3S125.1 59.8 121 72.4c-5.8 17.5-9 36.2-9 55.6s3.1 38.1 9 55.6c4.2 12.6 17.8 19.4 30.3 15.2s19.4-17.8 15.2-30.3c-4.2-12.7-6.5-26.3-6.5-40.4s2.3-27.7 6.5-40.4zM455 72.4c-4.2-12.6-17.8-19.4-30.3-15.2s-19.4 17.8-15.2 30.3c4.2 12.7 6.5 26.3 6.5 40.4s-2.3 27.7-6.5 40.4c-4.2 12.6 2.6 26.2 15.2 30.3s26.2-2.6 30.3-15.2c5.8-17.5 9-36.2 9-55.6s-3.1-38.1-9-55.6z"]
};
const faBroadcastTower = faTowerBroadcast;
const faTruckPickup = {
  prefix: 'far',
  iconName: 'truck-pickup',
  icon: [640, 512, [128763], "f63c", "M272 88l0 88 174.9 0L374.7 83.1c-1.5-1.9-3.8-3.1-6.3-3.1L280 80c-4.4 0-8 3.6-8 8zM412.6 53.6L507.7 176l44.3 0c30.9 0 56 25.1 56 56l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-1.3 0c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16l-98.7 0c.9 5.2 1.3 10.5 1.3 16c0 53-43 96-96 96s-96-43-96-96c0-5.5 .5-10.8 1.3-16L80 368l-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-88c0-30.9 25.1-56 56-56l136 0 0-88c0-30.9 25.1-56 56-56l88.3 0c17.3 0 33.6 8 44.2 21.6zM96 320l8.4 0c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32l8.4 0 128 0 8.4 0c17.6-19.6 43.1-32 71.6-32s54 12.4 71.6 32l8.4 0 16 0 0-88c0-4.4-3.6-8-8-8l-55.8 0-.5 0L248 224 88 224c-4.4 0-8 3.6-8 8l0 88 16 0zm128 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm240 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faBlockQuote = {
  prefix: 'far',
  iconName: 'block-quote',
  icon: [448, 512, [], "e0b5", "M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 72zM152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0zM128 416c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 424z"]
};
const faUpLong = {
  prefix: 'far',
  iconName: 'up-long',
  icon: [320, 512, ["long-arrow-alt-up"], "f30c", "M143.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3L240 208l0 248c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56l0-248-33.7 0C20.7 208 0 187.3 0 161.7c0-12.8 5.3-25 14.6-33.7L143.6 6.5zM50.5 160l53.5 0c13.3 0 24 10.7 24 24l0 272c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-272c0-13.3 10.7-24 24-24l53.5 0L160 57 50.5 160z"]
};
const faLongArrowAltUp = faUpLong;
const faStop = {
  prefix: 'far',
  iconName: 'stop',
  icon: [384, 512, [9209], "f04d", "M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z"]
};
const faCodeMerge = {
  prefix: 'far',
  iconName: 'code-merge',
  icon: [448, 512, [], "f387", "M80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm24.7 108.1C136.8 145.7 160 115.6 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3l0 199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-35.8-23.5-66.1-56-76.3l0-100.8c27.2 25.5 63.8 41.1 104 41.1l83.7 0c10.2 32.5 40.5 56 76.3 56c44.2 0 80-35.8 80-80s-35.8-80-80-80c-35.8 0-66.1 23.5-76.3 56L208 248c-53.3 0-97.3-40.2-103.3-91.9zM80 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM336 272a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faMoneyCheckDollarPen = {
  prefix: 'far',
  iconName: 'money-check-dollar-pen',
  icon: [640, 512, ["money-check-edit-alt"], "f873", "M512 112L64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l284.3 0c-5.6 7.1-9.6 15.3-11.8 24.1l-6 23.9L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64.6c-15.2 2-29.8 8.8-41.4 20.5l-6.6 6.6 0-91.6c0-8.8-7.2-16-16-16zM256 296c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm24-120l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM160 132c11 0 20 9 20 20l0 13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9l0 13.8c0 11-9 20-20 20s-20-9-20-20l0-14.6c-10.3-2.2-20-5.5-28.2-8.4c0 0 0 0 0 0s0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5l0-14c0-11 9-20 20-20zM613.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM375.9 417L505.1 287.8l71 71L446.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faMoneyCheckEditAlt = faMoneyCheckDollarPen;
const faUpFromLine = {
  prefix: 'far',
  iconName: 'up-from-line',
  icon: [384, 512, ["arrow-alt-from-bottom"], "f346", "M82.2 192L192 82 301.8 192 248 192c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM192 32c-11.5 0-22.5 4.6-30.6 12.7L45.6 160.8C36.9 169.5 32 181.3 32 193.6C32 219.2 52.8 240 78.4 240l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L222.6 44.7C214.5 36.6 203.5 32 192 32zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faArrowAltFromBottom = faUpFromLine;
const faUpload = {
  prefix: 'far',
  iconName: 'upload',
  icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95L280 360zm32-8l0-48 136 0c35.3 0 64 28.7 64 64l0 80c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-80c0-35.3 28.7-64 64-64l136 0 0 48L64 352c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16l-136 0zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faHurricane = {
  prefix: 'far',
  iconName: 'hurricane',
  icon: [384, 512, [], "f751", "M48 208C48 133.5 99 70.8 168 53l0 52.4c0 21.2 16 37.1 34.6 40.2C278.3 158.3 336 224.1 336 303.4c0 74.5-51 137.2-120 155l0-52.4c0-21.2-16-37.1-34.6-40.2C105.7 353.1 48 287.3 48 208zM216 42.1c0-22.7-20.1-43.4-45.6-38.7C73.5 21.1 0 105.9 0 208C0 309.2 72.3 393.5 168 412.2l0 57.1c0 22.7 20.1 43.4 45.6 38.7C310.5 490.3 384 405.5 384 303.4c0-101.2-72.3-185.5-168-204.2l0-57.1zM176 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
};
const faGridRound2Plus = {
  prefix: 'far',
  iconName: 'grid-round-2-plus',
  icon: [512, 512, [], "e5dc", "M80 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM80 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM384 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm96-48a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM384 272c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z"]
};
const faPeoplePants = {
  prefix: 'far',
  iconName: 'people-pants',
  icon: [640, 512, [], "e219", "M160 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L176 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM144 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L250.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L11.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L96 223.6 96 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L496 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM464 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6 416 488c0 13.3 10.7 24 24 24s24-10.7 24-24z"]
};
const faMound = {
  prefix: 'far',
  iconName: 'mound',
  icon: [576, 512, [], "e52d", "M485 368L91 368l94.8-164.9c21-36.6 60-59.1 102.2-59.1s81.2 22.6 102.2 59.1L485 368zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48l449.4 0c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"]
};
const faWindsock = {
  prefix: 'far',
  iconName: 'windsock',
  icon: [512, 512, [], "f777", "M24 0C37.3 0 48 10.7 48 24l0 72 80 0 0-8.6c0-20.3 18.7-35.5 38.5-31.3l320 66.7c14.8 3.1 25.5 16.2 25.5 31.3l0 108c0 15.2-10.6 28.2-25.5 31.3L166.5 360c-19.9 4.1-38.5-11-38.5-31.3l0-8.6-80 0 0 168c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 296 0 120 0 24C0 10.7 10.7 0 24 0zM48 144l0 128 80 0 0-128-80 0zM416 259l48-10 0-81.9-48-10L416 259zm-48 10L368 147l-80-16.7 0 155.3L368 269zM240 295.6l0-175.3L176 107 176 309l64-13.3z"]
};
const faCircleHalf = {
  prefix: 'far',
  iconName: 'circle-half',
  icon: [512, 512, [], "e110", "M208 53.6C116.3 75.2 48 157.7 48 256s68.3 180.8 160 202.4l0-404.9zM224.1 2C241.6-.2 256 14.3 256 32l0 448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"]
};
const faBrakeWarning = {
  prefix: 'far',
  iconName: 'brake-warning',
  icon: [640, 512, [], "e0c7", "M320 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 400a224 224 0 1 0 0-448 224 224 0 1 0 0 448zM83.9 75.8c-11.1-7.2-26-4-33.2 7.2C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173c7.2 11.1 22 14.4 33.2 7.2s14.4-22 7.2-33.2C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147c7.2-11.1 4-26-7.2-33.2zm472.2 0c-11.1 7.2-14.4 22-7.2 33.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147c-7.2 11.1-4 26 7.2 33.2s26 4 33.2-7.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173c-7.2-11.1-22-14.4-33.2-7.2zM320 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faToiletPortable = {
  prefix: 'far',
  iconName: 'toilet-portable',
  icon: [320, 512, [], "e583", "M48 72l0 24 224 0 0-24c0-13.3-10.7-24-24-24L72 48C58.7 48 48 58.7 48 72zm0 72l0 288 224 0 0-112-24 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l24 0 0-80L48 144zm0 336l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 72C0 32.2 32.2 0 72 0L248 0c39.8 0 72 32.2 72 72l0 416c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8L48 480z"]
};
const faCompactDisc = {
  prefix: 'far',
  iconName: 'compact-disc',
  icon: [512, 512, [128191, 128192, 128440], "f51f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM241.8 128.8c8.8-1 15.1-8.9 14.1-17.7s-8.9-15.1-17.7-14.1C164.1 105.2 105.2 164.1 97 238.2c-1 8.8 5.4 16.7 14.1 17.7s16.7-5.4 17.7-14.1c6.6-59.3 53.7-106.4 113-113z"]
};
const faFileArrowDown = {
  prefix: 'far',
  iconName: 'file-arrow-down',
  icon: [384, 512, ["file-download"], "f56d", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 232c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L216 232z"]
};
const faFileDownload = faFileArrowDown;
const faSaxophoneFire = {
  prefix: 'far',
  iconName: 'saxophone-fire',
  icon: [640, 512, ["sax-hot"], "f8db", "M256 153.6c0 7.6-.7 15.1-2 22.4l-77.6 0c-7.7-23.3-29.5-44.6-41-54.6c-4.3-3.7-10.5-3.7-14.8 0c-11.6 10-33.4 31.3-41 54.6L2 176c-1.3-7.3-2-14.8-2-22.4C0 92.3 50 37.9 85.8 10.1c4-3.1 8.7-4.6 13.4-4.7c6.4-.1 12.8 2.5 17.6 7.4l36.8 36.8 9.1-9.1c9.4-9.4 24.4-10.1 33.8-.8C243.6 86.4 256 128.1 256 153.6zM452.3 89.8C468.8 73.3 491.2 64 514.5 64l35 0c23.3 0 45.7 9.3 62.2 25.8l14.6 14.6c8.7 8.7 13.7 20.6 13.7 33c0 25.8-20.9 46.6-46.6 46.6l-50.6 0c-2.3 0-4.6 1-6.1 2.8l-224.5 263c-33.7 39.5-83 62.2-134.9 62.2l-5.5 0C76.9 512 0 435.1 0 340.2c0-9.5 .8-18.9 2.3-28.2l9.8-59.1C4.9 248.8 0 241 0 232c0-13.3 10.7-24 24-24l16 0 192 0 16 0c13.3 0 24 10.7 24 24c0 13-10.3 23.6-23.2 24l-21.2 58.3L318 224l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L366 176l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7L414 128l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l7 7 4.3-4.3zM255.6 354.2c-8.7 8.7-20.6 13.6-33 13.6l-2.4 0c-24.4 0-44.3-19.8-44.3-44.3c0-5.2 .9-10.3 2.7-15.1L197.7 256 60.3 256 49.7 319.9c-1.1 6.7-1.7 13.5-1.7 20.3C48 408.6 103.4 464 171.8 464l5.5 0c37.8 0 73.8-16.6 98.3-45.4l224.5-263c10.6-12.5 26.2-19.6 42.6-19.6l47.3 0-12.3-12.3c-7.5-7.5-17.7-11.7-28.3-11.7l-35 0c-10.6 0-20.8 4.2-28.3 11.7l-20.6 20.6c-.2 .2-.4 .5-.6 .7s-.5 .4-.7 .7L417.9 192c-.3 .3-.6 .7-1 1s-.7 .7-1 1l-45.8 45.8c-.4 .4-.8 .9-1.2 1.3s-.8 .8-1.3 1.2l-112.1 112zM120 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faSaxHot = faSaxophoneFire;
const faCameraWebSlash = {
  prefix: 'far',
  iconName: 'camera-web-slash',
  icon: [640, 512, ["webcam-slash"], "f833", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L485.3 355.1C516.9 317.5 536 269 536 216C536 96.7 439.3 0 320 0C248.3 0 184.8 34.9 145.5 88.7L38.8 5.1zM183.3 118.3C213.8 75.8 263.6 48 320 48c92.8 0 168 75.2 168 168c0 41.8-15.3 80-40.5 109.4l-37.8-29.7C428.5 274.6 440 246.6 440 216c0-66.3-53.7-120-120-120c-41 0-77.2 20.6-98.9 52l-37.8-29.7zM371.7 266.1L259 177.7c12.7-20.3 35.3-33.7 61-33.7c39.8 0 72 32.2 72 72c0 19.5-7.7 37.1-20.3 50.1zM359.6 379.3c-12.7 3.1-25.9 4.7-39.6 4.7c-92.8 0-168-75.2-168-168l0-.2-45.1-35.5C105 191.9 104 203.8 104 216c0 72.8 36 137.2 91.3 176.4l-62.3 81c-5.6 7.2-6.5 17-2.5 25.2s12.4 13.4 21.5 13.4l376 0-60.9-48-266.3 0 37.1-48.2C263.1 426.2 290.9 432 320 432c30 0 58.6-6.1 84.6-17.2l-45-35.5z"]
};
const faWebcamSlash = faCameraWebSlash;
const faFolderMedical = {
  prefix: 'far',
  iconName: 'folder-medical',
  icon: [512, 512, [], "e18c", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM224 256l-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 48z"]
};
const faFolderGear = {
  prefix: 'far',
  iconName: 'folder-gear',
  icon: [512, 512, ["folder-cog"], "e187", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L289.9 96 247 53.1C233.5 39.6 215.2 32 196.1 32L64 32zM48 96c0-8.8 7.2-16 16-16l132.1 0c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM353.2 264.2c6.3-3.6 9.5-11.2 6.8-17.9c-1.7-4.3-3.7-8.4-5.9-12.4l-2-3.5c-2.4-4-5.1-7.9-7.9-11.5c-4.5-5.7-12.6-6.8-18.9-3.1l-1.2 .7c-8 4.6-17.9 3.5-25.9-1.2s-14.1-12.7-14.1-21.9l0-1.4c0-7.3-4.9-13.8-12.2-14.8c-5.2-.7-10.5-1.1-15.8-1.1s-10.7 .4-15.8 1.1c-7.2 1-12.2 7.5-12.2 14.8l0 1.4c0 9.3-6.1 17.3-14.1 21.9s-17.9 5.8-25.9 1.2l-1.2-.7c-6.3-3.6-14.4-2.6-18.9 3.1c-2.9 3.7-5.5 7.5-8 11.5l-2 3.4c-2.2 4-4.2 8.2-5.9 12.5c-2.7 6.8 .4 14.3 6.8 17.9l1.2 .7c8 4.6 12 13.8 12 23.1s-4 18.4-12 23.1l-1.2 .7c-6.3 3.6-9.5 11.2-6.8 17.9c1.7 4.3 3.7 8.4 5.9 12.4l2.1 3.6c2.4 4 5 7.8 7.9 11.5c4.5 5.7 12.6 6.8 18.9 3.1l1.2-.7c8-4.6 17.9-3.5 25.9 1.2s14.1 12.7 14.1 21.9l0 1.4c0 7.3 4.9 13.8 12.2 14.8c5.2 .7 10.5 1.1 15.8 1.1s10.7-.4 15.8-1.1c7.2-1 12.2-7.5 12.2-14.8l0-1.4c0-9.3 6.1-17.3 14.1-21.9s17.9-5.8 25.9-1.2l1.2 .7c6.3 3.6 14.4 2.6 18.9-3.1c2.9-3.6 5.5-7.5 7.9-11.4l2.1-3.6c2.2-4 4.2-8.1 5.9-12.4c2.7-6.8-.4-14.3-6.8-17.9l-1.2-.7c-8-4.6-12-13.8-12-23.1s4-18.5 12-23.1l1.2-.7zM221 288a35 35 0 1 1 70 0 35 35 0 1 1 -70 0z"]
};
const faFolderCog = faFolderGear;
const faHandWave = {
  prefix: 'far',
  iconName: 'hand-wave',
  icon: [512, 512, [], "e1a7", "M336.2 82.3L335 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S281.5-1.1 290.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM80 68.7c17.9-17.9 43.8-23 66.2-15.2c3.1-6.8 7.4-13.1 13-18.7c25-25 65.5-25 90.5 0L368 153l0-5.2c0-35.3 28.7-64 64-64s64 28.7 64 64l0 157.7c0 1.6 0 3.1-.1 4.7c0 .6 .1 1.1 .1 1.7c0 109.9-88.7 199.2-198.5 200l-.5 0-1 0s0 0 0 0l-6.6 0c-53 0-103.9-21.1-141.4-58.6L34.7 340.2c-25-25-25-65.5 0-90.5c3.9-3.9 8.2-7.2 12.7-9.9l-1.4-1.4c-25-25-25-65.5 0-90.5c5.6-5.6 11.9-9.9 18.7-13C57 112.5 62.1 86.6 80 68.7zm79.3 56.7l-.1-.1-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l22.5 22.5 .1 .1L232.7 244c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1c0 0 0 0-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L119.5 244l.1 .1 56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L91.4 283.7l-.1-.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L181.9 419.5C210.4 448 249.1 464 289.4 464l6.6 0s0 0 0 0l.6 0 .2 0c82.8-.5 149.9-67.1 151.1-149.8c-.1-1-.1-2.1-.1-3.1c.1-1.8 .1-3.6 .1-5.5l0-157.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 63.1c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L215.8 68.7c-6.2-6.2-16.4-6.2-22.6 0c-6.2 6.2-6.2 16.3-.1 22.6l96.2 96.2c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96.1-96.1zM13.7 368.2c8.7-1.3 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.2 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 386.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
};
const faArrowUpArrowDown = {
  prefix: 'far',
  iconName: 'arrow-up-arrow-down',
  icon: [576, 512, ["sort-up-down"], "e099", "M529 377c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L440 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1-55-55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96zM177 39c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L136 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-342.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 39z"]
};
const faSortUpDown = faArrowUpArrowDown;
const faCaravan = {
  prefix: 'far',
  iconName: 'caravan',
  icon: [640, 512, [], "f8ff", "M416 80c61.9 0 112 50.1 112 112l0 176-48 0 0-200c0-22.1-17.9-40-40-40l-80 0c-22.1 0-40 17.9-40 40l0 200-44.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L80 368c-17.7 0-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32l336 0zM80 416l16 0c0 53 43 96 96 96s96-43 96-96l64 0 96 0 80 0 48 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-176c0-88.4-71.6-160-160-160L80 32C35.8 32 0 67.8 0 112L0 336c0 44.2 35.8 80 80 80zM432 224l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 96-64 0 0-192 64 0 0 48zM128 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0zm64 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faShieldCat = {
  prefix: 'far',
  iconName: 'shield-cat',
  icon: [512, 512, [], "e572", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM160 154.4L160 272c0 53 43 96 96 96s96-43 96-96l0-117.6c0-5.8-4.7-10.4-10.4-10.4l-.2 0c-3.4 0-6.5 1.6-8.5 4.3l-40 53.3c-3 4-7.8 6.4-12.8 6.4l-48 0c-5 0-9.8-2.4-12.8-6.4l-40-53.3c-2-2.7-5.2-4.3-8.5-4.3l-.2 0c-5.8 0-10.4 4.7-10.4 10.4zM216 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faMessageSlash = {
  prefix: 'far',
  iconName: 'message-slash',
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352l0-288c0-35.3-28.7-64-64-64L128 0C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-10.2 0L112.1 62.5zM406.2 416l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432l0-16c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16l0-167.8L64 146.4 64 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76 32.8 0z"]
};
const faCommentAltSlash = faMessageSlash;
const faBolt = {
  prefix: 'far',
  iconName: 'bolt',
  icon: [448, 512, [9889, "zap"], "f0e7", "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224l85.2 0c19.3 0 34.9 15.6 34.9 34.9c0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8c-19.1 0-32.9-18.3-27.6-36.6L152.2 288l-86.4 0C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9C308.3 2.4 314.9 0 321.7 0zM285.6 85L104.4 240l79.6 0c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21L162.3 427.5 345.5 272 264 272c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z"]
};
const faZap = faBolt;
const faTrashCanCheck = {
  prefix: 'far',
  iconName: 'trash-can-check',
  icon: [448, 512, [], "e2a9", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zM337 241L209 369c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 207c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faGlassWater = {
  prefix: 'far',
  iconName: 'glass-water',
  icon: [384, 512, [], "e4f4", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM57.6 134.3L50.2 48l283.7 0-7.4 86.3-25.2 14c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 155.6 99 157.3 82.8 148.3l-25.2-14zm5 57.6c32.7 16.6 72.1 12.6 100.9-10.4c16.7-13.3 40.4-13.3 57 0c28.8 23 68.3 27 100.9 10.4L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L62.6 191.9z"]
};
const faOilWell = {
  prefix: 'far',
  iconName: 'oil-well',
  icon: [576, 512, [], "e532", "M482 73.7c-4.6-17.1-22.1-27.2-39.2-22.6l58 216.4c17.1-4.6 27.2-22.1 22.6-39.2L482 73.7zm-51.6-69c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6L431.3 193.6 96 280.5 96 464l44.1 0L198 294.3l55.6-14.4L229.1 352l85.9 0-27.6-80.8 46.6-12.1 70 204.9L552 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 46.9 135.7-35.2 17.6-51.5c3.3-9.7 12.4-16.2 22.7-16.2s19.4 6.5 22.7 16.2l11 32.3 113.1-29.3L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM353.2 464l-21.9-64-118.6 0-21.9 64 162.4 0z"]
};
const faTableCellsColumnUnlock = {
  prefix: 'far',
  iconName: 'table-cells-column-unlock',
  icon: [640, 512, [], "e690", "M448 80c8.8 0 16 7.2 16 16l0 72-104 0 0-88 88 0zM200 80l112 0 0 88-112 0 0-88zM312 432l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 296l0-80 112 0 0 80-112 0zm296-24c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0-32 0-32 0 0-48z"]
};
const faPersonSimple = {
  prefix: 'far',
  iconName: 'person-simple',
  icon: [256, 512, [], "e220", "M128 128A64 64 0 1 0 128 0a64 64 0 1 0 0 128zM73.7 237.3C75.1 220.8 89 208 105.6 208l44.8 0c16.6 0 30.5 12.8 31.9 29.3l4.1 49.3c.8 9.3-6.6 17.3-15.9 17.3l-2.4 0-80 0-2.4 0c-9.4 0-16.7-8-15.9-17.3l4.1-49.3zM112 352l32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.7c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3C226.7 191.9 192 160 150.4 160l-44.8 0c-41.6 0-76.3 31.9-79.7 73.4l-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136z"]
};
const faArrowTurnLeftUp = {
  prefix: 'far',
  iconName: 'arrow-turn-left-up',
  icon: [384, 512, [], "e634", "M337 135c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87L216 424c0 22.1 17.9 40 40 40l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0c-48.6 0-88-39.4-88-88l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 7c9.4-9.4 24.6-9.4 33.9 0L337 135z"]
};
const faVault = {
  prefix: 'far',
  iconName: 'vault',
  icon: [576, 512, [], "e2c5", "M64 48c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-352c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-352 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64L0 64zM320 240a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM80 240a144 144 0 1 1 288 0A144 144 0 1 1 80 240zm144-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272-16c0 17.8-9.7 33.3-24 41.6L472 328c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-110.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48z"]
};
const faMars = {
  prefix: 'far',
  iconName: 'mars',
  icon: [448, 512, [9794], "f222", "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-83.7 83.7C252.8 141.3 215.9 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3L400 113.9l0 54.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24L312 32zM48 304a128 128 0 1 1 256 0A128 128 0 1 1 48 304z"]
};
const faToilet = {
  prefix: 'far',
  iconName: 'toilet',
  icon: [448, 512, [128701], "f7d8", "M0 24C0 37.3 10.7 48 24 48l32 0 336 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L392 0 56 0 24 0C10.7 0 0 10.7 0 24zM81.6 182.9l-1.6 .5L80 80 32 80l0 127.1-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c1.7 1.1 3.5 2.1 5.2 3.2L69.3 448.2c-3.5 6.3-5.3 13.5-5.3 20.7c0 23.8 19.3 43.1 43.1 43.1l233.8 0c23.8 0 43.1-19.3 43.1-43.1c0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4L416 80l-48 0 0 103.4-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zM373.8 326.8c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12zM312.3 426.8L332.6 464l-217.3 0 20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0z"]
};
const faPlaneCircleXmark = {
  prefix: 'far',
  iconName: 'plane-circle-xmark',
  icon: [640, 512, [], "e557", "M215.3 18.7C224.9 8.8 238.6 0 256 0c17.4 0 31.2 8.6 41.1 18.7c9.7 9.9 17 22.6 22.4 34.9C330.2 78.2 336 107.4 336 128l0 26.2 84.8 54.3c-16 7.5-30.6 17.4-43.5 29.2l-78.3-50.1c-6.9-4.4-11.1-12-11.1-20.2l0-39.4c0-13.6-4.2-36.3-12.5-55.2c-4.1-9.4-8.5-16.3-12.7-20.6c-4-4.1-6.2-4.2-6.8-4.2c0 0 0 0 0 0c-.2 0-2.2 0-6.3 4.2c-4.2 4.3-8.7 11.3-12.9 20.7c-8.4 19-12.8 41.7-12.8 55.1l0 39.4c0 8.2-4.2 15.8-11.1 20.2L51.7 290.8c-2.3 1.5-3.7 4-3.7 6.7l0 29.6 144.7-46.3c7.3-2.3 15.3-1 21.5 3.5s9.8 11.7 9.8 19.4l0 72.3c0 7.6-3.6 14.7-9.6 19.2L160 436l0 23.9c6.8-2.1 15.3-4.6 24.3-7.3c22.6-6.8 49.1-14.8 64.6-19.6c4.6-1.4 9.5-1.4 14.1 0c15.5 4.8 42 12.8 64.6 19.6l17.3 5.2c10.6 17.7 24.3 33.3 40.3 46.2c-6.4 5-14.5 7.9-23.2 7.9c-2.3 0-4.6-.3-6.9-1l6.9-23-6.9 23s0 0 0 0s0 0 0 0c0 0 0 0 0 0l-.2 0-.6-.2-2.4-.7-8.9-2.7c-7.5-2.2-17.8-5.4-29.2-8.8c-19.5-5.9-42-12.6-57.9-17.5c-15.9 4.9-38.4 11.6-57.9 17.5c-11.3 3.4-21.7 6.5-29.2 8.8l-8.9 2.7-2.4 .7-.6 .2-.2 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0l-6.9-23 6.9 23c-2.2 .7-4.5 1-6.9 1C129 512 112 495 112 474.1l0-42.1c0-12.6 5.9-24.4 16-32l48-36 0-27.4L52.2 376.2C26.4 384.4 0 365.2 0 338.1l0-40.6c0-19.1 9.7-36.9 25.8-47.2l12.9 20.2L25.8 250.3 176 154.2l0-26.2c0-20.7 6.1-50 16.9-74.5c5.5-12.3 12.8-24.9 22.4-34.8zm104 262.1l20.1 6.4C327 311.3 320 338.6 320 367.5c0 17.4 2.5 34.1 7.2 49.9l-29.6-22.2c-6-4.5-9.6-11.6-9.6-19.2l0-72.3c0-7.7 3.7-14.9 9.8-19.4s14.2-5.8 21.5-3.5zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"]
};
const faYenSign = {
  prefix: 'far',
  iconName: 'yen-sign',
  icon: [320, 512, [165, "cny", "jpy", "rmb", "yen"], "f157", "M43.8 42.5c-7.5-11-22.4-13.8-33.3-6.4S-3.3 58.5 4.2 69.5L109.2 224 40 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 48-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-48 96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-69.2 0L315.8 69.5c7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4L160 213.3 43.8 42.5z"]
};
const faCny = faYenSign;
const faJpy = faYenSign;
const faRmb = faYenSign;
const faYen = faYenSign;
const faGearCode = {
  prefix: 'far',
  iconName: 'gear-code',
  icon: [512, 512, [], "e5e8", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zm73.7 111.8l-32 192c-1.8 10.9-12.1 18.3-23 16.4s-18.3-12.1-16.4-23l32-192c1.8-10.9 12.1-18.3 23-16.4s18.3 12.1 16.4 23zm-93.6 66.9L172.3 256l25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3l40-40c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3zm144-28.3l40 40c7.8 7.8 7.8 20.5 0 28.3l-40 40c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3L339.7 256l-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0z"]
};
const faNotes = {
  prefix: 'far',
  iconName: 'notes',
  icon: [512, 512, [], "e202", "M144 96c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 192-48 0c-17.7 0-32 14.3-32 32l0 48-192 0c-8.8 0-16-7.2-16-16l0-256zM96 96l0 256c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3L480 96c0-35.3-28.7-64-64-64L160 32c-35.3 0-64 28.7-64 64zM320 488c0-13.3-10.7-24-24-24l-160 0c-48.6 0-88-39.4-88-88l0-224c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 376c0 75.1 60.9 136 136 136l160 0c13.3 0 24-10.7 24-24z"]
};
const faRubleSign = {
  prefix: 'far',
  iconName: 'ruble-sign',
  icon: [384, 512, [8381, "rouble", "rub", "ruble"], "f158", "M111.3 32C85.2 32 64 53.2 64 79.3L64 272l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 184 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-184 0 0-48 128 0c79.5 0 144-64.5 144-144s-64.5-144-144-144L111.3 32zM240 272l-128 0 0-192 128 0c53 0 96 43 96 96s-43 96-96 96z"]
};
const faRouble = faRubleSign;
const faRub = faRubleSign;
const faRuble = faRubleSign;
const faTrashUndo = {
  prefix: 'far',
  iconName: 'trash-undo',
  icon: [448, 512, ["trash-arrow-turn-left"], "f895", "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0zM222.9 194.7c-7.3-8.3-20-9-28.2-1.7l-72 64c-4.3 3.8-6.7 9.2-6.7 14.9s2.4 11.2 6.7 14.9l72 64c8.3 7.3 20.9 6.6 28.2-1.7s6.6-20.9-1.7-28.2L188.6 292l51.4 0c24.3 0 44 19.7 44 44l0 24c0 11 9 20 20 20s20-9 20-20l0-24c0-46.4-37.6-84-84-84l-51.4 0 32.7-29.1c8.3-7.3 9-20 1.7-28.2z"]
};
const faTrashArrowTurnLeft = faTrashUndo;
const faChampagneGlass = {
  prefix: 'far',
  iconName: 'champagne-glass',
  icon: [320, 512, ["glass-champagne"], "f79e", "M80 0C68.1 0 58 8.7 56.3 20.5L29.7 201C19.1 272.5 67.8 337.3 136 349.8L136 464l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-114.2c64.4-12.2 110.8-72.8 102.6-140.6l-22.8-188C262.4 9.1 252.1 0 240 0L80 0zm8.9 128l11.8-80 118 0 9.7 80L88.9 128zm-7.1 48l152.4 0 4.7 38.9c5.7 47.4-31.2 89.1-78.9 89.1c-51.1 0-90.3-45.4-82.9-96l4.7-32z"]
};
const faGlassChampagne = faChampagneGlass;
const faObjectsAlignCenterHorizontal = {
  prefix: 'far',
  iconName: 'objects-align-center-horizontal',
  icon: [512, 512, [], "e3bc", "M432 176L80 176l0-64 352 0 0 64zm48-64c0-26.5-21.5-48-48-48L280 64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L80 64c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l152 0 0 64-88 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l88 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 88 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-88 0 0-64 152 0c26.5 0 48-21.5 48-48l0-64zM368 400l-224 0 0-64 224 0 0 64z"]
};
const faSun = {
  prefix: 'far',
  iconName: 'sun',
  icon: [512, 512, [9728], "f185", "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
};
const faTrashCanSlash = {
  prefix: 'far',
  iconName: 'trash-can-slash',
  icon: [640, 512, ["trash-alt-slash"], "e2ad", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512 376l0-248 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0-13.8 0L413.5 24.9C403.1 9.4 385.6 0 366.9 0L273.1 0c-18.7 0-36.2 9.4-46.6 24.9L189.8 80 176 80l-41.6 0L38.8 5.1zM195.6 128L464 128l0 210.4-48-37.6L416 192c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 83.7L336 238l0-46c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 21L195.6 128zM454.9 454.4c-5.8 5.9-13.9 9.6-22.9 9.6l-224 0c-17.7 0-32-14.3-32-32l0-197.3-48-37.8L128 432c0 44.2 35.8 80 80 80l224 0c24.3 0 46-10.8 60.7-27.8l-37.8-29.8zM336 360.7l-32-25.2 0 64.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-39.3zM224 272.5L224 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-102.3-32-25.2zM273.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6z"]
};
const faTrashAltSlash = faTrashCanSlash;
const faScreenUsers = {
  prefix: 'far',
  iconName: 'screen-users',
  icon: [640, 512, ["users-class"], "f63d", "M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm256-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0zm320-96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM448 480c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64zM544 48L96 48c-8.8 0-16 7.2-16 16l0 161.3c-18.3 3.1-34.8 11.3-48 23.1L32 64C32 28.7 60.7 0 96 0L544 0c35.3 0 64 28.7 64 64l0 184.4c-13.2-11.8-29.7-20.1-48-23.1L560 64c0-8.8-7.2-16-16-16z"]
};
const faUsersClass = faScreenUsers;
const faGuitar = {
  prefix: 'far',
  iconName: 'guitar',
  icon: [512, 512, [], "f7a6", "M431 7c9.4-9.4 24.6-9.4 33.9 0l40 40c9.4 9.4 9.4 24.6 0 33.9l-48 48c-2.4 2.4-5.3 4.3-8.5 5.5l-59.1 22.2-35.8 35.8c38.2 50.8 41.4 115.2 4.6 152c-12 12-26.8 19.7-43.2 23.4c-18.1 4.1-33.5 20.8-34.5 39.4c-1.4 27.9-11.7 53.8-31.2 73.4C200.3 529.4 112 520.3 51.8 460.2S-17.4 311.7 31.4 262.8C51 243.2 76.9 233 104.8 231.5c18.5-.9 35.3-16.4 39.4-34.5c3.7-16.4 11.4-31.2 23.4-43.2c36.8-36.8 101.2-33.6 152 4.6l35.8-35.8 22.2-59.1c1.2-3.2 3.1-6.1 5.5-8.5L431 7zM254.4 291.6c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6l64.8-64.8c-36-24.5-70.6-18.1-83.8-5c-5 5-8.6 11.5-10.5 19.8c-8.3 37-41.6 69.7-83.8 71.9c-17.6 .9-31.7 7.1-41.9 17.3c-23.9 23.9-27.9 81.2 20.4 129.5s105.6 44.3 129.5 20.4c10.1-10.1 16.4-24.3 17.3-41.9c2.1-42.2 34.9-75.4 71.9-83.8c8.3-1.9 14.8-5.5 19.8-10.5c13.2-13.2 19.6-47.8-5-83.8l-64.8 64.8z"]
};
const faSquareArrowLeft = {
  prefix: 'far',
  iconName: 'square-arrow-left',
  icon: [448, 512, ["arrow-square-left"], "f33a", "M48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM87 273l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L344 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-182.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L87 239c-9.4 9.4-9.4 24.6 0 33.9z"]
};
const faArrowSquareLeft = faSquareArrowLeft;
const faSquare8 = {
  prefix: 'far',
  iconName: 'square-8',
  icon: [448, 512, [], "e25d", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm168 96l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72zm-16 96c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24c0 0 0 0 0 0l-16 0s0 0 0 0zm0 48c0 0 0 0 0 0l16 0c0 0 0 0 0 0l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0z"]
};
const faFaceSmileHearts = {
  prefix: 'far',
  iconName: 'face-smile-hearts',
  icon: [640, 512, [], "e390", "M553.5 361.1C568 329 576 293.4 576 256c0-24.5-3.4-48.2-9.9-70.6c-3.6-12.7-16.9-20.1-29.7-16.5s-20.1 16.9-16.5 29.7c5.2 18.2 8 37.4 8 57.4c0 35.3-8.8 68.5-24.3 97.6c16.7-3.7 34.5-1.2 49.8 7.4zM448.1 419.9C412.8 447.5 368.3 464 320 464c-50.4 0-96.6-17.9-132.6-47.7c-3.4 9.1-8.8 17.7-16.1 25l-13.1 13.1C202.4 490.4 258.7 512 320 512c53.3 0 102.8-16.3 143.8-44.2c-11.2-13.9-16.5-31-15.7-47.9zm-326-99.8C115.5 299.9 112 278.4 112 256c0-114.9 93.1-208 208-208c30.7 0 59.9 6.7 86.1 18.6c12.1 5.5 26.3 .2 31.8-11.9s.2-26.3-11.9-31.8C393.6 8.2 357.7 0 320 0C178.6 0 64 114.6 64 256c0 25.7 3.8 50.5 10.8 73.8c1.8 1.1 3.5 2.2 5.2 3.4c12.5-9 27.3-13.4 42-13.2zm85.7-3.3c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C383.2 334.5 357.2 352 320 352s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4zm6.5-87.1c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C279.7 186.8 259 180 239.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM399.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C439.7 186.8 419 180 399.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM573.7 11.5L560 25.3 546.3 11.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0zm54.9 384c-15.2-15.3-39.8-15.3-54.9 0L560 409.3l-13.7-13.8c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2zm-534.9-32L80 377.3 66.3 363.4c-15.2-15.3-39.8-15.3-54.9 0s-15.2 40 0 55.2l55.5 55.8c7.3 7.3 19.1 7.3 26.3 0l55.4-55.8c15.2-15.3 15.2-40 0-55.2s-39.8-15.3-54.9 0z"]
};
const faBracketsSquare = {
  prefix: 'far',
  iconName: 'brackets-square',
  icon: [448, 512, ["brackets"], "f7e9", "M56 32C25.1 32 0 57.1 0 88L0 424c0 30.9 25.1 56 56 56l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-4.4 0-8-3.6-8-8L48 88c0-4.4 3.6-8 8-8l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 32zm336 0l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c4.4 0 8 3.6 8 8l0 336c0 4.4-3.6 8-8 8l-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c30.9 0 56-25.1 56-56l0-336c0-30.9-25.1-56-56-56z"]
};
const faBrackets = faBracketsSquare;
const faLaptopArrowDown = {
  prefix: 'far',
  iconName: 'laptop-arrow-down',
  icon: [640, 512, [], "e1c6", "M256 32l0 48L128 80c-8.8 0-16 7.2-16 16l0 224-48 0L64 96c0-35.3 28.7-64 64-64l128 0zM384 80l0-48 128 0c35.3 0 64 28.7 64 64l0 224-48 0 0-224c0-8.8-7.2-16-16-16L384 80zM320 32c13.3 0 24 10.7 24 24l0 182.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L296 56c0-13.3 10.7-24 24-24zM96 432l448 0c20.9 0 38.7-13.4 45.3-32L50.7 400c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32l576 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96L96 480c-53 0-96-43-96-96z"]
};
const faHockeyStickPuck = {
  prefix: 'far',
  iconName: 'hockey-stick-puck',
  icon: [640, 512, [], "e3ae", "M499 2.7c11.8 6.1 16.4 20.6 10.3 32.3L282.7 473.1c-12.4 23.9-37 38.9-64 38.9L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l240 0c1.3 0 2.5 .1 3.7 .3L466.7 13C472.8 1.2 487.3-3.4 499 2.7zM283 368l-139 0 0 96 74.8 0c9 0 17.2-5 21.3-13L283 368zM64 368c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l32 0 0-96-32 0zm368 64l0 32 160 0 0-32-160 0zm-48 0c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-32z"]
};
const faHouseTree = {
  prefix: 'far',
  iconName: 'house-tree',
  icon: [640, 512, [], "e1b3", "M417.4 7.5C412.9 2.7 406.6 0 400 0s-12.9 2.7-17.4 7.5l-103.5 109 35.4 32.4 85.5-90L496.1 160 448 160c-9.6 0-18.2 5.7-22 14.5s-2 19 4.6 26L528.3 304 480 304c-9.4 0-17.9 5.4-21.8 13.9s-2.6 18.5 3.5 25.6L564.1 464 416 464c0 18-6 34.6-16 48l216 0c9.4 0 17.9-5.4 21.8-13.9s2.6-18.5-3.5-25.6L531.9 352l52.1 0c9.6 0 18.2-5.7 22-14.5s2-19-4.6-26L503.7 208l48.3 0c9.6 0 18.3-5.7 22.1-14.5s2-19-4.7-26l-152-160zM20.8 237C7.5 249.1 0 266.2 0 284.2L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-163.8c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237zM48 284.2c0-4.5 1.9-8.8 5.2-11.8L181.2 155c6.1-5.6 15.5-5.6 21.6 0l128 117.3c3.3 3 5.2 7.3 5.2 11.8L336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-163.8zM144 296l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faSignalFair = {
  prefix: 'far',
  iconName: 'signal-fair',
  icon: [640, 512, ["signal-2"], "f68d", "M192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faSignal2 = faSignalFair;
const faFaceLaughWink = {
  prefix: 'far',
  iconName: 'face-laugh-wink',
  icon: [512, 512, ["laugh-wink"], "f59c", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9l212.5 0c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
const faLaughWink = faFaceLaughWink;
const faCircleDollar = {
  prefix: 'far',
  iconName: 'circle-dollar',
  icon: [512, 512, ["dollar-circle", "usd-circle"], "f2e8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM276.8 133.6l0 14.2c9.7 1.2 19.4 3.9 29 6.6c1.9 .5 3.7 1 5.6 1.6c11.5 3.2 18.3 15.1 15.1 26.6s-15.1 18.2-26.6 15.1c-1.6-.4-3.1-.9-4.7-1.3c-7-2-14-3.9-21.1-5.3c-13.2-2.5-28.5-1.3-40.8 4c-11 4.8-20.1 16.4-7.6 24.4c9.8 6.3 21.8 9.5 33.2 12.6c2.4 .6 4.7 1.3 7 1.9c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 15.2c0 11.9-9.7 21.6-21.6 21.6s-21.6-9.7-21.6-21.6l0-17.4c-14.5-3.3-28.7-7.9-42.8-12.5c-11.3-3.7-17.5-16-13.7-27.3s16-17.5 27.3-13.7c2.5 .8 5 1.7 7.5 2.5c11.3 3.8 22.9 7.7 34.5 9.6c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c4-21.8 21-36.3 39-44.1c5.5-2.4 11.4-4.3 17.5-5.7l0-16.1c0-11.9 9.7-21.6 21.6-21.6s21.6 9.7 21.6 21.6z"]
};
const faDollarCircle = faCircleDollar;
const faUsdCircle = faCircleDollar;
const faHorseHead = {
  prefix: 'far',
  iconName: 'horse-head',
  icon: [640, 512, [], "f7ab", "M405.1 48.7c9.2-3.3 18.9 3.6 18.9 13.4c0 4.2-1.9 8.2-5.1 10.9l-34.3 28.5c-7.3 6.1-10.4 16-7.7 25.2s10.6 15.9 20.1 17.1l1.5 .2c31.3 3.9 58.7 23 73.3 51L520 287.8c11 21.3 7 47.2-9.9 64.2c-10.3 10.3-24.3 16.1-38.8 16.1l-7.4 0c-18.5 0-36-8-48.2-21.9l-26.2-30c-10.3-11.8-28-13.5-40.4-3.9c-27.6 21.5-67.3 17.2-89.7-9.7l-25-30c-8.5-10.2-23.6-11.6-33.8-3.1s-11.6 23.6-3.1 33.8l25 30c25 30 62.3 43.8 98.6 40l43.4 68.2c2.3 3.5 3.5 7.7 3.5 11.9c0 5.8-4.7 10.6-10.6 10.6L136 464c-13.3 0-24-10.7-24-24l0-123.3c0-98.2 61.8-185.7 154.3-218.6L405.1 48.7zm0 367l-21.5-33.8c21 21.7 50 34.1 80.4 34.1l7.4 0c27.3 0 53.5-10.8 72.8-30.1c31.7-31.7 39.2-80.4 18.5-120.2l-48.3-92.8c-14.4-27.8-37.3-49.6-64.7-63C463.8 98 472 80.5 472 62.1c0-43-42.5-73-83-58.6L250.2 52.9C138.6 92.5 64 198.2 64 316.7L64 440c0 39.8 32.2 72 72 72l221.4 0c32.4 0 58.6-26.2 58.6-58.6c0-13.3-3.8-26.4-11-37.6zM360 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faArrowsRepeat = {
  prefix: 'far',
  iconName: 'arrows-repeat',
  icon: [512, 512, ["repeat-alt"], "f364", "M0 254.5c-.8 13.2 9.2 24.6 22.5 25.5s24.6-9.2 25.5-22.5l.5-8C51.9 194.7 97.3 152 152.2 152l213.8 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-213.8 0C72 104 5.6 166.4 .5 246.5l-.5 8zm511.9 3c.8-13.2-9.2-24.6-22.5-25.5s-24.6 9.2-25.4 22.5l-.5 8c-3.4 54.8-48.9 97.5-103.8 97.5l-213.8 0 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L71 367c-9.4 9.4-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 213.8 0c80.3 0 146.7-62.4 151.7-142.5l.5-8z"]
};
const faRepeatAlt = faArrowsRepeat;
const faBoreHole = {
  prefix: 'far',
  iconName: 'bore-hole',
  icon: [512, 512, [], "e4c3", "M256 0c13.3 0 24 10.7 24 24l0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L232 24c0-13.3 10.7-24 24-24zm0 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM112 176l-32 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l352 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-32 0 0 112c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-112zm16-48c17.7 0 32 14.3 32 32l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-17.7 14.3-32 32-32l48 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 208c0-44.2 35.8-80 80-80l48 0z"]
};
const faIndustry = {
  prefix: 'far',
  iconName: 'industry',
  icon: [576, 512, [], "f275", "M88 80c-4.4 0-8 3.6-8 8l0 216 0 48 0 56c0 13.3 10.7 24 24 24l368 0c13.3 0 24-10.7 24-24l0-88 0-16 0-148.1-139.1 89c-7.4 4.7-16.8 5-24.5 .8s-12.5-12.3-12.5-21.1l0-70.9L180.1 235.4c-7.4 4.3-16.6 4.4-24 .1s-12-12.2-12-20.8L144 88c0-4.4-3.6-8-8-8L88 80zM32 88c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 84.9 103.8-60.6c32-18.7 72.2 4.4 72.2 41.5l0 27 102.1-65.4C502.1 95 544 117.9 544 155.9L544 304l0 16 0 88c0 39.8-32.2 72-72 72l-368 0c-39.8 0-72-32.2-72-72l0-56 0-48L32 88z"]
};
const faImagePolaroid = {
  prefix: 'far',
  iconName: 'image-polaroid',
  icon: [448, 512, [], "f8c4", "M400 368l0 48c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-48 352 0zM75.3 320L48 320 48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 224-23.6 0L284.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-56 85.6-16.6-22.6c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L75.3 320zM448 320l0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320l0 24 0 24 0 48c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-48 0-24 0-24zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faWaveTriangle = {
  prefix: 'far',
  iconName: 'wave-triangle',
  icon: [640, 512, [], "f89a", "M176.1 32c7.7 0 14.9 3.7 19.4 10L464.1 415.1 596.6 233.8c7.8-10.7 22.8-13 33.5-5.2s13 22.8 5.2 33.5l-152 208c-4.5 6.2-11.8 9.9-19.5 9.8s-14.9-3.7-19.4-10L175.9 96.9 43.4 278.2c-7.8 10.7-22.8 13-33.5 5.2s-13-22.8-5.2-33.5l152-208c4.5-6.2 11.8-9.9 19.5-9.8z"]
};
const faTurnLeftDown = {
  prefix: 'far',
  iconName: 'turn-left-down',
  icon: [384, 512, [], "e637", "M208.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L46.6 384.1c-9.3-8.8-14.6-21-14.6-33.7C32 324.7 52.7 304 78.3 304l41.7 0 0-144C120 71.6 191.6 0 280 0l48 0c30.9 0 56 25.1 56 56l0 32c0 30.9-25.1 56-56 56l-56 0c-4.4 0-8 3.6-8 8l0 152 41.7 0c25.6 0 46.3 20.7 46.3 46.3c0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5L240 352c-13.3 0-24-10.7-24-24l0-176c0-30.9 25.1-56 56-56l56 0c4.4 0 8-3.6 8-8l0-32c0-4.4-3.6-8-8-8l-48 0c-61.9 0-112 50.1-112 112l0 168c0 13.3-10.7 24-24 24l-61.5 0L192 455 301.5 352z"]
};
const faPersonRunningFast = {
  prefix: 'far',
  iconName: 'person-running-fast',
  icon: [512, 512, [], "e5ff", "M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6l-44.5 38.2c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L321.1 480.8c-4 12.7 3.1 26.1 15.8 30.1s26.1-3.1 30.1-15.8L403 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2C393.3 272 415 288 439.6 288l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L321 169l27.1 6.8zM218.5 317.1L199.4 368 120 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm-16 80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z"]
};
const faCircleDown = {
  prefix: 'far',
  iconName: 'circle-down',
  icon: [512, 512, [61466, "arrow-alt-circle-down"], "f358", "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3L304 256l0-96c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 96-57.7 0C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"]
};
const faArrowAltCircleDown = faCircleDown;
const faGrill = {
  prefix: 'far',
  iconName: 'grill',
  icon: [448, 512, [], "e5a3", "M48 80l352 0 0 16c0 97.2-78.8 176-176 176S48 193.2 48 96l0-16zM40 32C17.9 32 0 49.9 0 72L0 96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64l156.7 0 21.2 49.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L318.8 299C395.1 263.3 448 185.8 448 96l0-24c0-22.1-17.9-40-40-40L40 32zM151.8 368l22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4s33.4-1.9 49.3-5.4L296.2 368l-144.3 0zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faArrowsTurnToDots = {
  prefix: 'far',
  iconName: 'arrows-turn-to-dots',
  icon: [512, 512, [], "e4c1", "M255 31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39L424 104c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-174.1 0 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9l80-80zM257 287l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L88 408c-22.1 0-40 17.9-40 40l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-48.6 39.4-88 88-88l174.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm127 97a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"]
};
const faChartMixed = {
  prefix: 'far',
  iconName: 'chart-mixed',
  icon: [512, 512, ["analytics"], "f643", "M503.6 74.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6L320.2 168.3 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2l168-144zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-64c0-4.4 3.6-8 8-8s8 3.6 8 8l0 64zM64 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48zm264 16l0 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8zm-56 0l0 96c0 26.5 21.5 48 48 48s48-21.5 48-48l0-96c0-26.5-21.5-48-48-48s-48 21.5-48 48zm184 96c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-160c0-4.4 3.6-8 8-8s8 3.6 8 8l0 160zm-8-208c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160c0-26.5-21.5-48-48-48z"]
};
const faAnalytics = faChartMixed;
const faFlorinSign = {
  prefix: 'far',
  iconName: 'florin-sign',
  icon: [384, 512, [], "e184", "M315.3 32c-36 0-68.3 21.9-81.7 55.3L179 224 56 224c-13.3 0-24 10.7-24 24s10.7 24 24 24l103.8 0L105.8 406.9C99.7 422 85 432 68.7 432L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l44.7 0c36 0 68.3-21.9 81.7-55.3L211.4 272 328 272c13.3 0 24-10.7 24-24s-10.7-24-24-24l-97.4 0 47.5-118.9C284.3 90 299 80 315.3 80L360 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-44.7 0z"]
};
const faArrowDownShortWide = {
  prefix: 'far',
  iconName: 'arrow-down-short-wide',
  icon: [576, 512, ["sort-amount-desc", "sort-amount-down-alt"], "f884", "M15 377l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 342.1L49 343c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9zM312 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0z"]
};
const faSortAmountDesc = faArrowDownShortWide;
const faSortAmountDownAlt = faArrowDownShortWide;
const faLessThan = {
  prefix: 'far',
  iconName: 'less-than',
  icon: [384, 512, [62774], "3c", "M381.5 77.3c5.9 11.9 1.1 26.3-10.7 32.2L77.7 256 370.7 402.5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-336-168C5.1 273.4 0 265.1 0 256s5.1-17.4 13.3-21.5l336-168c11.9-5.9 26.3-1.1 32.2 10.7z"]
};
const faDisplayCode = {
  prefix: 'far',
  iconName: 'display-code',
  icon: [576, 512, ["desktop-code"], "e165", "M512 48c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-175.5 0c-.3 0-.6 0-.8 0l-95.2 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 416l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48L512 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64zm188.3 48l8-48 55.3 0 8 48-71.3 0zM249 177c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM361 143c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"]
};
const faDesktopCode = faDisplayCode;
const faFaceDrooling = {
  prefix: 'far',
  iconName: 'face-drooling',
  icon: [512, 512, [], "e372", "M48 256c0 114.9 93.1 208 208 208l0 48C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 80.8-37.5 152.9-96 199.9l0-66.9c30-36 48-82.4 48-132.9c0-114.9-93.1-208-208-208S48 141.1 48 256zm110.8-32.4c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4c3.8-11.3 12.2-26.8 25.8-39.8C153.2 155.2 173.5 144 200 144c13.3 0 24 10.7 24 24s-10.7 24-24 24c-11.9 0-20.9 4.8-27.9 11.4c-7.4 7-11.8 15.5-13.4 20.2zM129 309.3c10.4-8.3 25.5-6.6 33.7 3.7c18.7 23.4 49.8 47 93.3 47s74.5-23.6 93.3-47c8.3-10.4 23.4-12 33.7-3.7s12 23.4 3.8 33.7c-.9 1.1-1.8 2.2-2.7 3.3L384 496c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-119.6c-9.5 7-20.2 13.3-32 18.5l0 69.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-59.1c-10 2-20.7 3.1-32 3.1c-62.6 0-106.2-34.3-130.7-65c-8.3-10.3-6.6-25.5 3.7-33.7zM339.9 203.4c-7-6.6-16-11.4-27.9-11.4c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.5 0 46.8 11.2 60.9 24.6c13.7 13 22.1 28.5 25.8 39.8c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2c-1.6-4.7-6-13.2-13.4-20.2z"]
};
const faOilTemperature = {
  prefix: 'far',
  iconName: 'oil-temperature',
  icon: [576, 512, ["oil-temp"], "f614", "M264 24c0-13.3 10.7-24 24-24l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 83.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L264 120l0-96zm24 312a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM111.9 286.1c17.8 15.4 41.2 28.5 65 32.6c2.4 18.1 9.1 34.9 19.1 49.3c-1.3 0-2.7 .1-4.1 .1c-34.6 0-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0zM384 368c-1.3 0-2.7 0-4-.1c10-14.3 16.7-31.1 19.1-49.3c23.8-4.1 47.2-17.2 65-32.6c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8zm-272 62.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faOilTemp = faOilTemperature;
const faSquareQuestion = {
  prefix: 'far',
  iconName: 'square-question',
  icon: [448, 512, ["question-square"], "f2fd", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm137.8 69.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faQuestionSquare = faSquareQuestion;
const faAirConditioner = {
  prefix: 'far',
  iconName: 'air-conditioner',
  icon: [576, 512, [], "f8f4", "M64 48c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 256c-35.3 0-64-28.7-64-64L0 64zm120 64l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM368 288l0 104c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7c-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-104 48 0zM208 424l0-136 48 0 0 136c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2c11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
};
const faAngleDown = {
  prefix: 'far',
  iconName: 'angle-down',
  icon: [448, 512, [8964], "f107", "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"]
};
const faMountains = {
  prefix: 'far',
  iconName: 'mountains',
  icon: [640, 512, [9968], "f6fd", "M464 424.1c0 4.4-3.5 7.9-7.9 7.9L55.9 432c-4.4 0-7.9-3.5-7.9-7.9c0-1.5 .4-2.9 1.2-4.2L256 90.3 462.8 419.9c.8 1.3 1.2 2.7 1.2 4.2zm-464 0C0 455 25 480 55.9 480l400.2 0 122.8 0c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1z"]
};
const faOmega = {
  prefix: 'far',
  iconName: 'omega',
  icon: [448, 512, [], "f67a", "M224 80C126.8 80 48 158.8 48 256c0 63.7 33.8 119.5 84.6 150.4c11.4 7 19.4 19.6 19.4 34.2c0 21.8-17.6 39.4-39.4 39.4L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l61.4 0C33.4 391 0 327.4 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 71.4-33.4 135-85.4 176l61.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88.6 0c-21.8 0-39.4-17.6-39.4-39.4c0-14.6 8-27.2 19.4-34.2C366.2 375.5 400 319.7 400 256c0-97.2-78.8-176-176-176z"]
};
const faCarTunnel = {
  prefix: 'far',
  iconName: 'car-tunnel',
  icon: [512, 512, [], "e4de", "M256 48C141.1 48 48 141.1 48 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 256C0 114.6 114.6 0 256 0S512 114.6 512 256l0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232c0-114.9-93.1-208-208-208zM190.8 277.5L177 320l158 0-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5l-115.2 0c-3.5 0-6.5 2.2-7.6 5.5zM122.7 332l22.5-69.3c7.5-23.1 29-38.7 53.3-38.7l115.2 0c24.3 0 45.8 15.6 53.3 38.7L389.3 332c16.1 11.6 26.7 30.6 26.7 52l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-224 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-21.4 10.5-40.4 26.7-52zM144 432l224 0 0-48c0-8.8-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16l0 48zm16-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPersonDollyEmpty = {
  prefix: 'far',
  iconName: 'person-dolly-empty',
  icon: [512, 512, [], "f4d1", "M80 0a48 48 0 1 1 0 96A48 48 0 1 1 80 0zM0 488L0 340.3c.5 .4 1.1 .9 1.6 1.3L48 378.1 48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24zM60.6 176c-6.9 0-12.6 5.6-12.6 12.6l0 83.9c0 2.5 1.1 4.8 3.1 6.3L72 295.2l0-117c-3.6-1.4-7.5-2.2-11.4-2.2zM120 234.7l0 98.2 25.8 20.3c8.1 6.4 13.4 15.6 14.9 25.8l15.1 105.6c1.9 13.1-7.2 25.3-20.4 27.2s-25.3-7.2-27.2-20.4L113.6 388.9 21.4 316.5C7.9 305.9 0 289.6 0 272.4l0-83.9C0 155.1 27.1 128 60.6 128c24.8 0 48.2 11.7 63.1 31.5L172 224l35.3 0-6.5-26.2c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5l49.6 198.4c17.6 2.4 32.9 12 42.8 25.7l134.4-33.6c12.9-3.2 25.9 4.6 29.1 17.5s-4.6 25.9-17.5 29.1L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L219.3 272 168 272c-12.6 0-24.4-5.9-32-16l-16-21.3zM304 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faPanFood = {
  prefix: 'far',
  iconName: 'pan-food',
  icon: [640, 512, [129368], "e42b", "M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zM48 184l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 184c0-13.3 10.7-24 24-24s24 10.7 24 24zm568-24c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zM243.4 142.8C250.7 106.3 282.8 80 320 80s69.3 26.3 76.6 62.8l.6 3.2c1.4 7.3-4.1 14-11.5 14l-131.4 0c-7.4 0-12.9-6.8-11.5-14l.6-3.2zm-13.3 43.1c7.8 7.8 7.8 20.5 0 28.3l-32 32c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l32-32c7.8-7.8 20.5-7.8 28.3 0zM296 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM416 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM227.3 284.7c2.1 2.1 3.5 4.6 4.2 7.3c.4 1.7 .8 3.4 1.1 5.1c1.1 5.4 2.1 11 5.9 14.7l3.4 3.4c3 3 7.1 4.7 11.3 4.7l26.7 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-26.7c0-4.2-1.7-8.3-4.7-11.3l-3.4-3.4c-3.8-3.8-9.3-4.8-14.7-5.9c-1.7-.3-3.5-.7-5.1-1.1c-2.7-.7-5.2-2.1-7.3-4.2c-6.2-6.2-6.2-16.4 0-22.6l8-8 8-8c6.2-6.2 16.4-6.2 22.6 0zm132.9-4.9l79.6-79.6c4.5-4.5 11.9-4.5 16.4 0l2.8 2.8c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C446 315.2 432.4 320 418.4 320l-4.1 0c-19.4 0-38-7.7-51.8-21.4l-2.4-2.4c-4.5-4.5-4.5-11.9 0-16.4z"]
};
const faHeadSideCough = {
  prefix: 'far',
  iconName: 'head-side-cough',
  icon: [640, 512, [], "e061", "M224 48C126.8 48 48 126.8 48 224c0 42.2 14.8 80.8 39.5 111.1c13.6 16.6 24.5 38.5 24.5 63.4l0 89.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-89.4c0-10.7-4.8-22.2-13.7-33.1C18.9 326.9 0 277.6 0 224C0 100.3 100.3 0 224 0l24 0c78.8 0 151.4 47.6 183.2 116.2c4.2 9.1 8.2 18.4 12 27.3l1.5 3.5c4.3 10.1 8.5 19.7 13 29c9 18.6 18.7 34.5 31.4 47.1l4.4 4.4c11.9 11.9 18.6 28.1 18.6 45c0 35.1-28.5 63.6-63.6 63.6l-.4 0s0 0 0 0l0 24 0 64 0 8c0 35.3-28.7 64-64 64l-65.4 0c-3.3 9.3-12.2 16-22.6 16c-13.3 0-24-10.7-24-24l0-16c0-13.3 10.7-24 24-24l88 0c8.8 0 16-7.2 16-16l0-8 0-9.3-58.4-4.9c-12.2-1-21.6-11.2-21.6-23.4c0-10.8 7.3-20.2 17.8-22.8L400 348l0-12 0-8 0-16c0-13.3 10.7-24 24-24l24.4 0c8.6 0 15.6-7 15.6-15.6c0-4.1-1.6-8.1-4.6-11L455 257c-18.1-18.1-30.6-39.4-40.6-60.1c-5-10.4-9.6-21-13.9-31.1l-1.5-3.5c-3.8-9-7.5-17.6-11.4-25.9C363.7 84.7 308.1 48 248 48l-24 0zm80 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM488 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM528 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faGripLines = {
  prefix: 'far',
  iconName: 'grip-lines',
  icon: [448, 512, [], "f7a4", "M448 192c0-13.3-10.7-24-24-24L24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24zm0 128c0-13.3-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24z"]
};
const faThumbsDown = {
  prefix: 'far',
  iconName: 'thumbs-down',
  icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"]
};
const faUserLock = {
  prefix: 'far',
  iconName: 'user-lock',
  icon: [640, 512, [], "f502", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM49.3 464c8.9-63.3 63.3-112 129-112l91.4 0c49.3 0 92.1 27.3 114.3 67.7l0-67.7c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-16L49.3 464zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faArrowRightLong = {
  prefix: 'far',
  iconName: 'arrow-right-long',
  icon: [512, 512, ["long-arrow-right"], "f178", "M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"]
};
const faLongArrowRight = faArrowRightLong;
const faTicketsAirline = {
  prefix: 'far',
  iconName: 'tickets-airline',
  icon: [640, 512, ["tickets-perforated-plane", "tickets-plane"], "e29b", "M144 96l0 224c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-38.2c-24-15.7-40-42.8-40-73.8s16-58.1 40-73.8L592 96c0-8.8-7.2-16-16-16L160 80c-8.8 0-16 7.2-16 16zm16-64l416 0c35.3 0 64 28.7 64 64l0 56c0 8.8-7.4 15.7-15.6 19.1C610.1 177.2 600 191.4 600 208s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1l0 56c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM24 96c13.3 0 24 10.7 24 24l0 240c0 39.8 32.2 72 72 72l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0C53.7 480 0 426.3 0 360L0 120c0-13.3 10.7-24 24-24zm264.4 80l-23.2-69.5c-1.7-5.2 2.1-10.5 7.6-10.5L304 96c8.5 0 16.4 4.5 20.7 11.9L364.4 176l40.3 0c16.1 0 31.5 6.4 42.8 17.7c7.9 7.9 7.9 20.7 0 28.5c-11.4 11.4-26.8 17.7-42.8 17.7l-40.3 0-39.7 68.1c-4.3 7.4-12.2 11.9-20.7 11.9l-31.1 0c-5.5 0-9.3-5.3-7.6-10.5L288.4 240l-42.7 0-19.2 25.6c-3 4-7.8 6.4-12.8 6.4L200 272c-5.2 0-9-4.9-7.8-9.9l12.5-50.2c.6-2.5 .6-5.2 0-7.8l-12.5-50.2c-1.3-5 2.6-9.9 7.8-9.9l13.8 0c5 0 9.8 2.4 12.8 6.4L245.8 176l42.7 0z"]
};
const faTicketsPerforatedPlane = faTicketsAirline;
const faTicketsPlane = faTicketsAirline;
const faTentDoublePeak = {
  prefix: 'far',
  iconName: 'tent-double-peak',
  icon: [576, 512, [], "e627", "M131.3 93.4l30-37.5 6.1 6.1C199.4 94 242.8 112 288 112s88.6-18 120.6-49.9l6.1-6.1 30 37.5c16 20 34.5 37.9 55 53.3L528 168l0 24-216 0-48 0L48 192l0-24 28.4-21.3c20.5-15.4 39-33.3 55-53.3zM264 240l0 224L48 464l0-224 216 0zm48 0l216 0 0 224-112 0L312 240zM393.4 9.4L374.6 28.1C351.7 51.1 320.5 64 288 64s-63.7-12.9-86.6-35.9L182.6 9.4C176.2 2.9 167.3-.5 158.2 0s-17.5 4.9-23.2 12L93.9 63.5c-13.5 16.9-29 31.9-46.3 44.9L12.8 134.4C4.7 140.4 0 149.9 0 160L0 480c0 17.7 14.3 32 32 32l512 0c17.7 0 32-14.3 32-32l0-320c0-10.1-4.7-19.6-12.8-25.6l-34.7-26.1c-17.3-12.9-32.8-28-46.3-44.9L441 12C435.3 4.9 426.9 .6 417.8 0s-18 2.9-24.4 9.3z"]
};
const faAnchorCircleXmark = {
  prefix: 'far',
  iconName: 'anchor-circle-xmark',
  icon: [640, 512, [], "e4ac", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c17.2 0 33.9-2.4 49.7-6.8c-14.7-11.8-27.4-25.9-37.6-41.7c-4 .4-8 .5-12.1 .5l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faEllipsis = {
  prefix: 'far',
  iconName: 'ellipsis',
  icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
const faEllipsisH = faEllipsis;
const faNfcSlash = {
  prefix: 'far',
  iconName: 'nfc-slash',
  icon: [640, 512, [], "e1fc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68L544 96c0-35.3-28.7-64-64-64L160 32c-21.6 0-40.7 10.7-52.3 27.1L38.8 5.1zM145.7 88.9c2.6-5.3 8.1-8.9 14.3-8.9l320 0c8.8 0 16 7.2 16 16l0 267.5-32-25.1L464 152c0-22.1-17.9-40-40-40l-88 0c-22.1 0-40 17.9-40 40l0 54.7-60-47c11.4-1.9 20-11.8 20-23.7c0-13.3-10.7-24-24-24l-16 0c-10.5 0-20.1 4-27.2 10.7L145.7 88.9zM416 300.8l-48.5-38c.3-2.2 .5-4.5 .5-6.8c0-17.8-9.7-33.3-24-41.6l0-54.4 72 0 0 140.8zm70.9 178.9L426.5 432 160 432c-8.8 0-16-7.2-16-16l0-206.5L96 171.6 96 416c0 35.3 28.7 64 64 64l320 0c2.3 0 4.6-.1 6.9-.4zM385.8 400l-60.9-48L224 352l0-79.5-48-37.8L176 360c0 22.1 17.9 40 40 40l169.8 0z"]
};
const faChessPawn = {
  prefix: 'far',
  iconName: 'chess-pawn',
  icon: [320, 512, [9823], "f443", "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120l-12.6 0 10.7 80-48.4 0L195 272l-35 0-35 0-10.7 80-48.4 0 10.7-80L64 272c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464l214.7 0-16.6-32L69.2 432 52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L40.8 512C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384l201 0z"]
};
const faKitMedical = {
  prefix: 'far',
  iconName: 'kit-medical',
  icon: [576, 512, ["first-aid"], "f479", "M144 432l288 0 0-352L144 80l0 352zm-48 0L96 80 64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l32 0zM64 32l32 0 24 0 24 0 288 0 24 0 24 0 32 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-32 0-24 0-24 0-288 0-24 0-24 0-32 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM480 432l32 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-32 0 0 352zM256 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faFirstAid = faKitMedical;
const faGrid2Plus = {
  prefix: 'far',
  iconName: 'grid-2-plus',
  icon: [512, 512, [], "e197", "M176 80L80 80l0 96 96 0 0-96zM80 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm96 304l-96 0 0 96 96 0 0-96zM80 288l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM336 80l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm96 192c13.3 0 24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24z"]
};
const faBells = {
  prefix: 'far',
  iconName: 'bells',
  icon: [640, 512, [], "f77f", "M230.8 245.5C203.2 170.3 232.4 88.2 296.5 46c-4.5-2.2-9.1-4.2-13.9-6C214 15.1 138 50.4 112.8 119L98.2 159C84 197.8 57.6 231 23 253.7L14.9 259C4.7 265.7-.8 277.5 .6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c9.4-32.5 8.1-67.2-3.5-99.1l-18.7-51.2zm128.5-142c46.5-16.9 97.9 7 114.9 53.4l18.8 51.2c15.8 43.1 43.6 80.8 80.1 108.5L333.7 403.7c9.9-44.6 6.9-91.2-9-134.4L306 218.2c-17-46.4 6.9-97.8 53.3-114.7zM283.9 404.6l-4.6 15.8c-3.3 11.6 .1 24 9 32.2s21.5 10.8 32.8 6.7L618.6 351.1c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2C493.2 69.2 414.1 32.5 342.8 58.4s-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9zM480.8 480c35.6 0 64.5-28.8 64.5-64.3c0-1.3 0-2.6-.1-3.9L429.1 454.1c11.8 15.7 30.6 25.9 51.7 25.9zM94.3 376.2c-.3 2.5-.4 5-.4 7.5c0 35.5 28.9 64.3 64.5 64.3c22.3 0 41.9-11.3 53.5-28.4L94.3 376.2z"]
};
const faPersonThroughWindow = {
  prefix: 'far',
  iconName: 'person-through-window',
  icon: [640, 512, [], "e5a9", "M304 48l0 18.4c0 46.1-28.9 87.3-72.2 103.1C169.5 192.1 128 251.3 128 317.6l0 82.4-80 0L48 48l256 0zm48 0l240 0 0 352-81.7 0L499 385.4l-75.2-97.8c-7.6-9.8-19.3-15.6-31.7-15.6L333 272l-49.4-75.7c42.1-28.9 68.4-77.2 68.4-130L352 48zm97.7 352l-83.8 0 32 48L592 448c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 400c0 26.5 21.5 48 48 48l255.9 0 36.2 53.5c7.4 11 22.4 13.8 33.3 6.4s13.8-22.4 6.4-33.3L297.2 352.5 343.6 320l44.6 0 61.5 80zm-178.3 0L176 400l0-82.4c0-15.7 3.3-30.8 9.4-44.5l86 126.9zm-1.1-87.3l-54.1-79.9c7.3-6 15.4-11 24.2-15l51.9 79.6-22 15.4zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faToolbox = {
  prefix: 'far',
  iconName: 'toolbox',
  icon: [512, 512, [129520], "f552", "M184 80l144 0c4.4 0 8 3.6 8 8l0 40-160 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-28.1 0c-12.7 0-24.9 5.1-33.9 14.1L14.1 193.9c-9 9-14.1 21.2-14.1 33.9L0 328l0 88c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88 0-100.1c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1L384 128l0-40c0-30.9-25.1-56-56-56L184 32c-30.9 0-56 25.1-56 56zM464 304l-96 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-128 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-96 0 0-76.1L99.9 176l312.2 0L464 227.9l0 76.1zM48 352l96 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 128 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 96 0 0 64c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-64z"]
};
const faGlobeWifi = {
  prefix: 'far',
  iconName: 'globe-wifi',
  icon: [640, 512, [], "e685", "M256 464c7.4 0 27-7.2 47.6-48.4c6.2-12.4 11.8-26.7 16.5-42.5c1.2 43.9 18.6 83.8 46.3 114C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-26.2 0-51.1 5.7-73.4 16l-40.8 0c.8 8.1 1.3 16.3 1.7 24.7c-21.4 17.8-38.4 40.5-49.5 66.4c1.3-13.8 2-28.2 2-43.1c0-16.6-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48L332 304c-5.9 15.1-9.8 31.2-11.3 48l-134.3 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM186.4 160l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm254.2 0c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM169.9 445.4c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-48c27.2 0 51.9 10.2 70.6 27.1c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6c-24.4-21.9-56.6-35.3-92-35.3s-67.7 13.4-92 35.3c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2C444.1 330.2 468.9 320 496 320zm20 112a20 20 0 1 0 -40 0 20 20 0 1 0 40 0zm-51.5-35.9c8.3-7.5 19.4-12.1 31.5-12.1s23.2 4.6 31.5 12.1c6.6 5.9 16.7 5.4 22.6-1.1s5.4-16.7-1.1-22.6c-14-12.7-32.6-20.4-53-20.4s-39 7.7-53 20.4c-6.6 5.9-7.1 16-1.1 22.6s16 7.1 22.6 1.1z"]
};
const faEnvelopeDot = {
  prefix: 'far',
  iconName: 'envelope-dot',
  icon: [576, 512, ["envelope-badge"], "e16f", "M496 160A80 80 0 1 0 496 0a80 80 0 1 0 0 160zm16 224l0-193.1c-5.2 .7-10.6 1.1-16 1.1c-22.5 0-43.5-6.6-61-18.1L291.5 291.7c-20.7 17-50.4 17-71.1 0L48 150.1 48 128c0-8.8 7.2-16 16-16l324.6 0c-3-10.1-4.6-20.9-4.6-32c0-5.4 .4-10.8 1.1-16L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM48 212.2L190 328.8c38.4 31.5 93.7 31.5 132 0L464 212.2 464 384c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-171.8z"]
};
const faEnvelopeBadge = faEnvelopeDot;
const faMagnifyingGlassWaveform = {
  prefix: 'far',
  iconName: 'magnifying-glass-waveform',
  icon: [512, 512, [], "e661", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm24-280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144zm-80 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm160 16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48z"]
};
const faHandsHoldingCircle = {
  prefix: 'far',
  iconName: 'hands-holding-circle',
  icon: [640, 512, [], "e4fb", "M320 256A128 128 0 1 0 320 0a128 128 0 1 0 0 256zM144 136c0-39.8-32.2-72-72-72S0 96.2 0 136L0 352.2c0 31.8 12.6 62.3 35.1 84.9L103 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L69.1 403.1C55.6 389.6 48 371.3 48 352.2L48 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 145.9c0 25.6 10.2 50.2 28.3 68.4l15.9 15.9s0 0 0 0L167 393c0 0 0 0 0 0l16 16c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16-16s0 0 0 0l-26.7-26.7c-4-4-6.2-9.4-6.2-15c0-11.7 9.5-21.3 21.3-21.3c5.6 0 11 2.2 15 6.2l61.4 61.4C285.1 383 296 409.4 296 436.8l0 51.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-51.2c0-27.4 10.9-53.8 30.3-73.2l61.4-61.4c4-4 9.4-6.2 15-6.2c11.7 0 21.3 9.5 21.3 21.3c0 5.6-2.2 11-6.2 15L439 359c0 0 0 0 0 0l-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l16-16c0 0 0 0 0 0l26.7-26.7c0 0 0 0 0 0l15.9-15.9c18.1-18.1 28.3-42.7 28.3-68.4L544 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216.2c0 19.1-7.6 37.4-21.1 50.9L503 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l67.9-67.9c22.5-22.5 35.1-53 35.1-84.9L640 136c0-39.8-32.2-72-72-72s-72 32.2-72 72l0 128.8c-12.1-10.5-28-16.8-45.3-16.8c-18.4 0-36 7.3-49 20.3l-61.4 61.4c-7.7 7.7-14.5 16.2-20.4 25.3c-5.8-9.1-12.6-17.5-20.4-25.3l-61.4-61.4c-13-13-30.6-20.3-49-20.3c-17.3 0-33.1 6.3-45.3 16.8L144 136z"]
};
const faBug = {
  prefix: 'far',
  iconName: 'bug',
  icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4C161.3 165.7 180 160 200 160l112 0c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C410.3 225.3 416 244 416 264l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0 0 8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-70.9-70.9C339.3 462.5 299.7 480 256 480s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320l0-8-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zM144 264l0 56c0 53.6 37.7 98.4 88 109.4L232 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 149.4c50.3-11 88-55.8 88-109.4l0-56c0-30.9-25.1-56-56-56l-112 0c-30.9 0-56 25.1-56 56z"]
};
const faBowlChopsticks = {
  prefix: 'far',
  iconName: 'bowl-chopsticks',
  icon: [512, 512, [], "e2e9", "M18.5 125.1C8.8 126.6 0 119.1 0 109.3C0 101.6 5.5 95 13.1 93.6L484.4 5.2C498.7 2.5 512 13.5 512 28.1c0 11.5-8.4 21.2-19.7 23l-473.8 74zM0 159.7c0-8.8 7-16 15.7-16.2l471.9-14.7C501 128.3 512 139 512 152.4c0 13-10.6 23.6-23.6 23.6L16.2 176C7.3 176 0 168.7 0 159.7zM151.5 432.5c11.5 5.2 20.4 14.7 25 26.4c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C421.6 404.8 464 343.3 464 272L48 272c0 71.3 42.4 132.8 103.5 160.5zM0 272c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48c0 90.8-54.1 169-131.7 204.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C54.1 441 0 362.8 0 272z"]
};
const faCreditCard = {
  prefix: 'far',
  iconName: 'credit-card',
  icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faCreditCardAlt = faCreditCard;
const faCircleS = {
  prefix: 'far',
  iconName: 'circle-s',
  icon: [512, 512, [], "e121", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM207.6 196.2c1.1-6.2 5-11.8 15.4-15.8c11-4.3 27.6-6 47.8-2.9c6 .9 20.6 4 27.3 5.7c12.8 3.3 25.9-4.5 29.2-17.3s-4.5-25.9-17.3-29.2c-7.7-2-23.9-5.5-32-6.7c-25.6-3.9-51.3-2.6-72.6 5.7c-21.9 8.6-40.3 25.7-45 52c-2.6 14.4-1.3 28 4.4 40.3c5.6 12.1 14.7 20.8 24.1 27.2c17.2 11.6 40.3 18.1 58.6 23.2l2 .6c21.1 5.9 36.7 10.6 46.8 17.4c4.5 3 6.5 5.6 7.4 7.7c.9 1.9 1.8 5.2 .6 11.6c-1.1 6.2-5 11.8-15.4 15.8c-11 4.3-27.5 6-47.7 2.9c-12.2-1.9-36.1-8.9-50-13.4c-12.6-4-26.1 2.9-30.2 15.5s2.9 26.1 15.5 30.2c13.6 4.4 40.9 12.5 57.3 15.1c0 0 0 0 0 0l.1 0c25.6 3.9 51.3 2.6 72.6-5.7c21.9-8.6 40.3-25.7 45-52c2.6-14.4 1.4-28-4.4-40.3c-5.6-12.1-14.7-20.8-24.1-27.2c-17.2-11.6-40.3-18.1-58.6-23.2l-2-.6c-21.1-5.9-36.7-10.6-46.8-17.4c-4.5-3-6.5-5.6-7.4-7.7c-.9-1.9-1.8-5.2-.6-11.6z"]
};
const faBoxBallot = {
  prefix: 'far',
  iconName: 'box-ballot',
  icon: [576, 512, [128499], "f735", "M176 208l224 0 0-160L176 48l0 160zM128 32c0-17.7 14.3-32 32-32L416 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-192zM48 160l48 0 0 48-48 0 0 112 480 0 0-112-48 0 0-48 48 0c26.5 0 48 21.5 48 48l0 112 0 24 0 24 0 96c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-96 0-24 0-24L0 208c0-26.5 21.5-48 48-48zM528 368L48 368l0 96 480 0 0-96z"]
};
const faCar = {
  prefix: 'far',
  iconName: 'car',
  icon: [512, 512, [128664, "automobile"], "f1b9", "M127.7 106.8L103.4 176l305.1 0-24.2-69.2c-5.6-16-20.8-26.8-37.8-26.8L165.4 80c-17 0-32.1 10.7-37.8 26.8zm-79.6 82L82.3 90.9C94.7 55.6 128 32 165.4 32l181.2 0c37.4 0 70.7 23.6 83.1 58.9l34.3 97.9C492.6 205.4 512 236.4 512 272l0 80 0 48 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56L48 400l0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-48 0-80c0-35.6 19.3-66.6 48.1-83.2zM416 224L96 224c-26.5 0-48 21.5-48 48l0 80 416 0 0-80c0-26.5-21.5-48-48-48zM112 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faAutomobile = faCar;
const faHandHoldingHand = {
  prefix: 'far',
  iconName: 'hand-holding-hand',
  icon: [576, 512, [], "e4f7", "M388.6 192c7.9 0 15.6-2.3 22.2-6.7L490.7 132c3.9-2.6 8.6-4 13.3-4l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40.7 0-73.8 49.2C423 234.9 406 240 388.6 240L232 240c-35.3 0-64-28.7-64-64c0-.7 0-1.3 0-2l-64.9 40c-10.7 6.6-22.9 10-35.5 10l-7.4 0C27 224 0 197 0 163.7c0-20.4 10.4-39.5 27.5-50.6l95.6-61.9C142.6 38.7 165.2 32 188.4 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L188.4 80c-13.9 0-27.5 4-39.1 11.6L53.6 153.4c-3.5 2.3-5.6 6.1-5.6 10.3c0 6.8 5.5 12.3 12.3 12.3l7.4 0c3.6 0 7.2-1 10.3-2.9l93.5-57.5c3.8-2.3 8.1-3.6 12.6-3.6l48 0 24 0 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l156.6 0zM187.4 320c-7.9 0-15.6 2.3-22.2 6.7L85.3 380c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 277.1 170 272 187.4 272L344 272c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faUserTieHair = {
  prefix: 'far',
  iconName: 'user-tie-hair',
  icon: [448, 512, [], "e45f", "M304 144l0-16c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80zM224 0c70.7 0 128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16C96 57.3 153.3 0 224 0zm30.8 418.4l43.8-87.6c3-6 9.4-9.5 15.9-8.4C390.4 335.6 448 401.7 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3c0-79.6 57.6-145.7 133.5-158.9c6.6-1.1 12.9 2.4 15.9 8.4l43.8 87.6 15.9-59.2-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2l19.7 0 19.7 0c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 15.9 59.2zM118.5 376.3C82.3 391.1 55.4 424.2 49.3 464l113 0-43.8-87.7zM285.7 464l113 0c-6.1-39.8-33-72.9-69.2-87.7L285.7 464z"]
};
const faPodiumStar = {
  prefix: 'far',
  iconName: 'podium-star',
  icon: [448, 512, [], "f758", "M182.4 72c8.3 14.3 23.8 24 41.6 24l64 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L224 0c-17.8 0-33.3 9.7-41.6 24L168 24c-48.6 0-88 39.4-88 88l0 32-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-296 0 0-32c0-22.1 17.9-40 40-40l14.4 0zM47.3 224L73.5 455.2c3.7 32.3 31 56.8 63.6 56.8l173.7 0c32.6 0 59.9-24.4 63.6-56.8L400.7 224l-48.3 0L326.8 449.8c-.9 8.1-7.8 14.2-15.9 14.2l-173.7 0c-8.1 0-15-6.1-15.9-14.2L95.6 224l-48.3 0zm201.5 77.7l-18.2-41.3c-2.6-5.8-10.5-5.8-13.1 0l-18.2 41.3c-1.1 2.4-3.2 4-5.7 4.3l-43.2 5.4c-6.1 .8-8.6 8.7-4 13l31.9 30.9c1.8 1.8 2.7 4.4 2.2 7L171.9 407c-1.2 6.3 5.2 11.2 10.6 8.1l37.9-22.2c2.2-1.3 4.9-1.3 7 0L265.5 415c5.4 3.1 11.8-1.7 10.6-8.1l-8.5-44.6c-.5-2.6 .3-5.2 2.2-7l31.9-30.9c4.5-4.4 2.1-12.3-4-13L254.5 306c-2.5-.3-4.6-2-5.7-4.3z"]
};
const faUserHairMullet = {
  prefix: 'far',
  iconName: 'user-hair-mullet',
  icon: [448, 512, ["business-front", "party-back", "trian-balbot"], "e45c", "M304 128c0-5.7-.6-11.3-1.7-16.6c-30.6-3.1-58.5-17.9-78.3-40.6c-19.8 22.7-47.6 37.5-78.3 40.6c-1.1 5.4-1.7 10.9-1.7 16.6l0 16c0 18 6 34.6 16 48c0 0 0 0 0 0s0 0 0 0c14.6 19.4 37.8 32 64 32s49.4-12.6 64-32c0 0 0 0 0 0s0 0 0 0c10-13.4 16-30 16-48l0-16zM237.4 271.3c-4.4 .5-8.9 .7-13.4 .7s-9-.2-13.4-.7L193 289c-5.5 5.5-13.2 8-20.8 6.7s-14.2-6.1-17.6-13l-6.1-12.2-19.5 7.8c-9.3 3.7-19.8 1.3-26.6-6s-8.3-18.1-3.8-27c8.5-17 11-22.3 12.2-27.1c.7-2.9 1.1-5.9 1.2-12.3C101.8 187.5 96 166.4 96 144l0-16c0-7.1 .6-14 1.7-20.7C91.8 102.9 88 95.9 88 88c0-13.3 10.7-24 24-24l1.1 0C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64l1.1 0c13.3 0 24 10.7 24 24c0 7.9-3.8 14.9-9.7 19.3c1.1 6.8 1.7 13.7 1.7 20.7l0 16c0 22.4-5.8 43.5-15.9 61.8c.1 6.4 .5 9.4 1.2 12.3c1.2 4.8 3.7 10.1 12.2 27.1c4.5 8.9 2.9 19.7-3.8 27s-17.3 9.7-26.6 6l-19.5-7.8-6.1 12.2c-3.4 6.9-10 11.7-17.6 13s-15.4-1.3-20.8-6.7l-17.7-17.7zM49.6 464l348.7 0c-9.3-54.5-56.8-96-113.9-96l-120.9 0c-57.2 0-104.6 41.5-113.9 96zM0 483.6C0 393.2 73.2 320 163.6 320l120.9 0C374.8 320 448 393.2 448 483.6c0 15.7-12.7 28.4-28.4 28.4L28.4 512C12.7 512 0 499.3 0 483.6z"]
};
const faBusinessFront = faUserHairMullet;
const faPartyBack = faUserHairMullet;
const faTrianBalbot = faUserHairMullet;
const faMicrophoneStand = {
  prefix: 'far',
  iconName: 'microphone-stand',
  icon: [512, 512, [127908], "f8cb", "M476.9 204.9l1-1c45.9-46.9 45.6-122.2-1-168.7s-121.8-46.9-168.7-1l-1 .9s0 0 0 0l-16 16-16 16s0 0 0 0l-.9 1C251.8 91 240.4 120.7 240 150.5L17.2 388.2C6.1 400 0 415.5 0 431.6c0 16.8 6.7 33 18.6 44.9l16.8 16.8C47.4 505.3 63.5 512 80.4 512c16.1 0 31.7-6.1 43.4-17.2L232 393.4l0 94.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-139.6L361.5 272c29.8-.4 59.5-11.8 82.4-34.2l1-1 16-16 16-16zM361.9 224L325 187 288 150.1c.5-17.4 7.2-34.6 20.1-48L409.9 203.9c-13.4 12.9-30.7 19.6-48 20.1zm82-54L342.1 68.1c28.2-27.2 73-26.8 100.8 1s28.1 72.7 1 100.8zM80.4 464c-4.1 0-8.1-1.6-11-4.5L52.5 442.6c-2.9-2.9-4.5-6.9-4.5-11c0-3.9 1.5-7.7 4.2-10.6L264.6 194.5 291 221l26.5 26.5L91 459.8c-2.9 2.7-6.7 4.2-10.6 4.2z"]
};
const faBookOpenReader = {
  prefix: 'far',
  iconName: 'book-open-reader',
  icon: [512, 512, ["book-reader"], "f5da", "M256 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 0a96 96 0 1 1 0 192A96 96 0 1 1 256 0zM228 279l-.2-.1c-.7-.5-2.4-1.5-5.2-2.9c-5.5-2.8-15.4-7.3-30.6-12.2c-28-9-74.2-19.3-144-22.7l0 176.3c84.9 5 147.1 22.3 184 35.7L232 282l-4-3zm52 3l0 171.1c36.9-13.4 99.1-30.7 184-35.7l0-176.3c-69.9 3.4-116 13.7-144 22.7c-15.1 4.9-25 9.4-30.6 12.2c-2.8 1.4-4.5 2.4-5.2 2.9l-.2 .1-4 3zM32 192.5C199.2 197.4 256 240 256 240s56.8-42.6 224-47.5c17.7-.5 32 13.9 32 31.5l0 208c0 17.7-14.4 31.9-32 32.7c-114.9 4.7-186.9 33.7-208.8 43.8c-4.8 2.2-9.9 3.5-15.1 3.5s-10.4-1.3-15.1-3.5c-21.9-10.1-93.9-39.1-208.8-43.8c-17.7-.7-32-15-32-32.7L0 224c0-17.7 14.4-32.1 32-31.5z"]
};
const faBookReader = faBookOpenReader;
const faFamilyDress = {
  prefix: 'far',
  iconName: 'family-dress',
  icon: [512, 512, [], "e301", "M192 64A64 64 0 1 0 64 64a64 64 0 1 0 128 0zM112.3 208l15.7 0 15.7 0 38.9 0c-4.3-9.8-6.7-20.6-6.7-32c0-2.4 .1-4.8 .3-7.1c-9.6-5.7-20.8-8.9-32.6-8.9l-31.4 0c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384L64 384l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 37.5 0c-3.5-10-5.5-20.8-5.5-32l0-16-80.4 0L96.9 219.6c2-6.9 8.2-11.6 15.4-11.6zM336 176c0 11.4-2.4 22.2-6.7 32l38.9 0 15.7 0 15.7 0c7.1 0 13.4 4.7 15.4 11.6L448.4 336 368 336l0 16c0 11.2-1.9 22-5.5 32l37.5 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 21.6 0c21.3 0 36.6-20.3 30.8-40.8L461.3 206.4c-7.8-27.5-33-46.4-61.5-46.4l-31.4 0c-11.8 0-23 3.2-32.6 8.9c.2 2.3 .3 4.7 .3 7.1zM448 64A64 64 0 1 0 320 64a64 64 0 1 0 128 0zM256 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm32 112l0 16c0 8.8-7.2 16-16 16l-16 0-16 0c-8.8 0-16-7.2-16-16l0-16c0-17.7 14.3-32 32-32s32 14.3 32 32zm48 16l0-16c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16c0 24 13.2 44.9 32.7 55.8c-.5 2.7-.7 5.4-.7 8.2l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-2.8-.2-5.5-.7-8.2C322.8 396.9 336 376 336 352z"]
};
const faCircleX = {
  prefix: 'far',
  iconName: 'circle-x',
  icon: [512, 512, [], "e12e", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM186.3 136.5c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8L224.6 256l-74.9 88.5c-8.6 10.1-7.3 25.3 2.8 33.8s25.3 7.3 33.8-2.8L256 293.2l69.7 82.3c8.6 10.1 23.7 11.4 33.8 2.8s11.4-23.7 2.8-33.8L287.4 256l74.9-88.5c8.6-10.1 7.3-25.3-2.8-33.8s-25.3-7.3-33.8 2.8L256 218.8l-69.7-82.3z"]
};
const faCabin = {
  prefix: 'far',
  iconName: 'cabin',
  icon: [512, 512, [], "e46d", "M256 54.1L95.3 176l321.3 0L256 54.1zM231.8 12.2c14.3-10.8 34.1-10.8 48.4 0L432 127.4 432 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 107.8 22.5 17.1c8.2 6.2 11.5 17 8.2 26.8s-12.4 16.3-22.7 16.3L24 224c-10.3 0-19.5-6.6-22.7-16.3s0-20.5 8.2-26.8L231.8 12.2zM32 296c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 320c-13.3 0-24-10.7-24-24zm0 192c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 512c-13.3 0-24-10.7-24-24zM56 368l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 416c-13.3 0-24-10.7-24-24s10.7-24 24-24zm264-72c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm24 168l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-72c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM224 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faMountainSun = {
  prefix: 'far',
  iconName: 'mountain-sun',
  icon: [640, 512, [], "e52f", "M480 80a80 80 0 1 1 160 0A80 80 0 1 1 480 80zM412.7 281.7l48.2-79C465 196.1 472.2 192 480 192s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8c0 33.8-27.4 61.1-61.1 61.1l-122.8 0s0 0 0 0L55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7zm28.5 45.4l62.2 99.2c5.6 8.9 8.6 19.2 8.6 29.7c0 2.7-.2 5.3-.6 7.9l67.4 0c7.2 0 13.1-5.9 13.1-13.1c0-2.4-.7-4.8-1.9-6.8L480 263.6l-38.8 63.6zM456.1 464c4.4 0 7.9-3.5 7.9-7.9c0-1.5-.4-2.9-1.2-4.2L256 122.3 49.2 451.9c-.8 1.3-1.2 2.7-1.2 4.2c0 4.4 3.5 7.9 7.9 7.9l400.2 0z"]
};
const faChartSimpleHorizontal = {
  prefix: 'far',
  iconName: 'chart-simple-horizontal',
  icon: [448, 512, [], "e474", "M400 240L48 240l0 32 352 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 320c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 32zM208 400L48 400l0 32 160 0 0-32zm48 32c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32zm80-320l0-32L48 80l0 32 288 0zm0 48L48 160c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l288 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48z"]
};
const faBluetooth = {
  prefix: 'far',
  iconName: 'bluetooth',
  icon: [384, 512, [], "f293", "M182.1 2.1c8.6-3.9 18.7-2.4 25.8 3.9l136 120c5.3 4.7 8.2 11.4 8.1 18.4s-3.3 13.6-8.7 18.1L229.8 256l113.5 93.5c5.4 4.5 8.6 11.1 8.7 18.1s-2.8 13.8-8.1 18.4l-136 120c-7.1 6.2-17.2 7.8-25.8 3.9S168 497.4 168 488l0-181.1L71.3 386.5c-10.2 8.4-25.4 7-33.8-3.3s-7-25.4 3.3-33.8L154.2 256 40.7 162.5C30.5 154.1 29 139 37.5 128.7s23.6-11.7 33.8-3.3L168 205.1 168 24c0-9.4 5.5-18 14.1-21.9zM216 306.9l0 128 75-66.2-75-61.8zm0-101.7l75-61.8L216 77.2l0 128z"]
};
const faArrowsLeftRightToLine = {
  prefix: 'far',
  iconName: 'arrows-left-right-to-line',
  icon: [640, 512, [], "e4ba", "M24 64c13.3 0 24 10.7 24 24l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 74.7 10.7 64 24 64zm217 71c9.4 9.4 9.4 24.6 0 33.9l-63 63 284.1 0-63-63c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L537 239c9.4 9.4 9.4 24.6 0 33.9L433 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l63-63-284.1 0 63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L207 135c9.4-9.4 24.6-9.4 33.9 0zM640 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHandBackPointLeft = {
  prefix: 'far',
  iconName: 'hand-back-point-left',
  icon: [512, 512, [], "e19f", "M0 176c0-35.3 28.7-64 64-64l188.8 0c3.6-5.2 7.6-10.2 11.9-14.9l18.4-20.3C299.9 58.5 323.5 48 348.3 48l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 328c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-5.3 .7-10.5 1.9-15.5c-20.2-10.8-33.9-32-33.9-56.5c0-2.7 .2-5.4 .5-8L64 240c-35.3 0-64-28.7-64-64zm64-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l136 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16l8 0c10.3 0 19.5 6.6 22.8 16.4s-.1 20.6-8.3 26.8c-3.9 3-6.4 7.6-6.4 12.8c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l20-11.7-20 11.7-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1L301.5 128l42.5 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-78 0-2 0L64 160z"]
};
const faMessageDots = {
  prefix: 'far',
  iconName: 'message-dots',
  icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCommentAltDots = faMessageDots;
const faMessaging = faMessageDots;
const faFileHeart = {
  prefix: 'far',
  iconName: 'file-heart',
  icon: [384, 512, [], "e176", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM93.7 306.8c0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4c0-29.5-23.9-53.5-53.5-53.5l-1.5 0c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6l-1.5 0c-29.5 0-53.5 23.9-53.5 53.5z"]
};
const faBeerMug = {
  prefix: 'far',
  iconName: 'beer-mug',
  icon: [512, 512, ["beer-foam"], "e0b3", "M208 0c-26.8 0-51.1 11-68.5 28.8c0 0 0 0-.1 0C126.9 20.7 112 16 96 16C51.8 16 16 51.8 16 96s35.8 80 80 80c16 0 30.9-4.7 43.4-12.8c0 0 0 0 .1 0C156.9 181 181.2 192 208 192c26.5 0 50.6-10.8 68-28.2c0 0 0 0 0 0c12.8 8.5 28.2 13.5 44.6 13.5c44.5 0 80.6-36.1 80.6-80.6s-36.1-80.6-80.6-80.6c-16.1 0-31.2 4.8-43.9 13c0 0 0 0 0 0C259.3 11.1 234.9 0 208 0zM173.1 63c8.8-9.3 21.1-15 34.9-15c13.8 0 26.2 5.8 35 15.1c8.4 8.9 19.6 12.8 29.3 13.7c9.7 .9 20.9-1 30.4-7.4c5.2-3.4 11.3-5.4 18-5.4c18 0 32.6 14.6 32.6 32.6s-14.6 32.6-32.6 32.6c-6.8 0-13.1-2.1-18.3-5.6c-9.4-6.4-20.6-8.4-30.3-7.7c-9.7 .7-20.9 4.5-29.4 13.3c-8.8 9.1-21 14.7-34.6 14.7c-13.7 0-26.1-5.7-34.9-15c-8.4-8.9-19.6-12.7-29.2-13.6c-9.7-.8-20.8 1.1-30.3 7.3c-5 3.3-11.1 5.3-17.6 5.3c-17.7 0-32-14.3-32-32s14.3-32 32-32c6.5 0 12.6 1.9 17.6 5.3c9.5 6.3 20.6 8.2 30.3 7.3c9.7-.8 20.8-4.7 29.2-13.6zM32 187.9L32 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-.3 86.8-38c25-11 41.2-35.7 41.2-63l0-117.9c0-38-30.8-68.8-68.8-68.8l-29.4 0c-17.5 25.7-45.5 43.8-77.8 48.2l0 223.2c0 .4 0 .7 0 1.1l0 15.4c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16l0-241.1c-17.7-2.5-34-9.2-48-18.9zM208 224c-8.8 0-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16zM320.3 97.2c.1 0 .1 .1 .1 .1s0 0 0 0s.1 0 .2 0c.1 0 .2 0 .2 0s0 0 0 0c0 0 .1-.1 .2-.2s.1-.2 .2-.2c0 0 0 0 0 0s0-.1 0-.2s0-.2 0-.2s0 0 0 0c0 0-.1-.1-.2-.2s-.2-.1-.2-.2c0 0 0 0 0 0s-.1 0-.2 0c-.1 0-.1 0-.2 0s0 0 0 0c0 0 0 0 0 0l-.1 0-.9 .6 .8 .6zM96 96s0 0 0 0s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0zM443.2 208c11.5 0 20.8 9.3 20.8 20.8l0 117.9c0 8.3-4.9 15.7-12.5 19.1L384 395.3 384 208l59.2 0zM160 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160z"]
};
const faBeerFoam = faBeerMug;
const faDiceD20 = {
  prefix: 'far',
  iconName: 'dice-d20',
  icon: [512, 512, [], "f6cf", "M243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6l0 224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368l0-224c0-8.4 4.4-16.2 11.7-20.6l200-120zM80 191.1l0 83.4L112.8 215 80 191.1zm65.5 63.9L94.9 347l115 9.2L145.5 255.1zm10.6 145L232 445.6l0-39.5-75.9-6.1zM280 406.2l0 39.5 75.9-45.5L280 406.2zM432 274.6l0-83.4L399.2 215 432 274.6zM375 173.3l37.6-27.3L327.1 94.6 375 173.3zM184.9 94.6L99.4 145.9 137 173.3l47.9-78.6zM256 70.2L186.7 184l138.6 0L256 70.2zM324.3 232l-136.6 0L256 339.3 324.3 232zM302.1 356.2l115-9.2-50.6-92L302.1 356.2z"]
};
const faDrone = {
  prefix: 'far',
  iconName: 'drone',
  icon: [512, 512, [], "f85f", "M224 112C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c5.2 0 10.2-.3 15.2-1L88.7 171.6C64.9 162.3 48 139.1 48 112c0-35.3 28.7-64 64-64c27.1 0 50.3 16.9 59.6 40.7L223 127.2c.7-5 1-10.1 1-15.2zm-10.7 47.9l-39.8-29.9-29.7-22.3C141.7 92.1 128.2 80 112 80c-17.7 0-32 14.3-32 32c0 16.2 12.1 29.7 27.8 31.7l22.3 29.7 29.9 39.8 .1 .1 0 85.3-.1 .1-29.9 39.8-22.3 29.7C92.1 370.3 80 383.8 80 400c0 17.7 14.3 32 32 32c16.2 0 29.7-12.1 31.7-27.8l29.7-22.3 39.8-29.9 .1-.1 85.3 0 .1 .1 39.8 29.9 29.7 22.3c2.1 15.7 15.5 27.8 31.7 27.8c17.7 0 32-14.3 32-32c0-16.2-12.1-29.7-27.8-31.7l-22.3-29.7-29.9-39.8-.1-.1 0-85.3 .1-.1 29.9-39.8 22.3-29.7c15.7-2.1 27.8-15.5 27.8-31.7c0-17.7-14.3-32-32-32c-16.2 0-29.7 12.1-31.7 27.8l-29.7 22.3-39.8 29.9-.1 .1-85.3 0-.1-.1zM223 384.8l-51.3 38.5C162.3 447.1 139.1 464 112 464c-35.3 0-64-28.7-64-64c0-27.1 16.9-50.3 40.7-59.6L127.2 289c-5-.7-10.1-1-15.2-1C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-5.2-.3-10.2-1-15.2zM288 112c0 5.2 .3 10.2 1 15.2l51.3-38.5C349.7 64.9 372.9 48 400 48c35.3 0 64 28.7 64 64c0 27.1-16.9 50.3-40.7 59.6L384.8 223c5 .7 10.1 1 15.2 1c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm1 272.8c-.7 5-1 10.1-1 15.2c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-5.2 0-10.2 .3-15.2 1l38.5 51.3c23.8 9.3 40.7 32.5 40.7 59.6c0 35.3-28.7 64-64 64c-27.1 0-50.3-16.9-59.6-40.7L289 384.8zM224 208l64 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"]
};
const faTruckDroplet = {
  prefix: 'far',
  iconName: 'truck-droplet',
  icon: [640, 512, [], "e58c", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c-39.8 0-72-29.6-72-66c0-27 39.4-82.9 59.9-110.3c6.1-8.2 18.1-8.2 24.2 0C240.6 123 280 179 280 206c0 36.5-32.2 66-72 66z"]
};
const faFileCircleXmark = {
  prefix: 'far',
  iconName: 'file-circle-xmark',
  icon: [576, 512, [], "e5a1", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"]
};
const faTemperatureArrowUp = {
  prefix: 'far',
  iconName: 'temperature-arrow-up',
  icon: [576, 512, ["temperature-up"], "e040", "M176 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C87.1 326.5 80 346.4 80 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L240 112c0-35.3-28.7-64-64-64zM64 112C64 50.1 114.1 0 176 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S32 447.5 32 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L64 112zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3zM448 32c6.8 0 13.3 2.9 17.8 7.9l72 80c8.9 9.9 8.1 25-1.8 33.9s-25 8.1-33.9-1.8L472 118.5 472 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-337.5-30.2 33.5c-8.9 9.9-24 10.7-33.9 1.8s-10.7-24-1.8-33.9l72-80c4.6-5.1 11-7.9 17.8-7.9z"]
};
const faTemperatureUp = faTemperatureArrowUp;
const faMedal = {
  prefix: 'far',
  iconName: 'medal',
  icon: [512, 512, [127941], "f5a2", "M4.1 38.2L106.4 191.5c11.2-11.6 23.7-21.9 37.3-30.6L68.4 48l64.5 0 54.9 91.5c15.8-5.5 32.4-9.1 49.6-10.6l-6.1-10.1L169.3 15.5C163.5 5.9 153.1 0 141.9 0L24.6 0C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6zm276.6 80.5l-6.1 10.1c17.2 1.5 33.8 5.2 49.6 10.6L379.2 48l64.5 0L368.4 160.9c13.6 8.7 26.1 19 37.3 30.6L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0L370.1 0c-11.2 0-21.7 5.9-27.4 15.5L280.8 118.7zM256 208a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm7.2-257.5c-2.9-5.9-11.4-5.9-14.3 0l-19.2 38.9c-1.2 2.4-3.4 4-6 4.4L180.7 304c-6.6 1-9.2 9-4.4 13.6l31 30.2c1.9 1.8 2.7 4.5 2.3 7.1l-7.3 42.7c-1.1 6.5 5.7 11.5 11.6 8.4L252.3 386c2.3-1.2 5.1-1.2 7.4 0l38.4 20.2c5.9 3.1 12.7-1.9 11.6-8.4L302.4 355c-.4-2.6 .4-5.2 2.3-7.1l31-30.2c4.7-4.6 2.1-12.7-4.4-13.6l-42.9-6.2c-2.6-.4-4.9-2-6-4.4l-19.2-38.9z"]
};
const faPersonFairy = {
  prefix: 'far',
  iconName: 'person-fairy',
  icon: [640, 512, [], "e608", "M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm41.6 144c-16.6 0-30.5 12.8-31.9 29.3l-4.1 49.3c-.8 9.3 6.6 17.3 15.9 17.3l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C372.9 220.8 359 208 342.4 208l-44.8 0zM336 352l-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L384 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136zM32 32c89.4 0 169.4 40.8 222.2 104.7c-15 6.3-28.4 15.9-39.3 27.8C174.1 116.6 114.7 84.9 48 80.5L48 112c0 71.4 33.3 134.9 85.4 176l18.1 14.3c10.1 8 12.1 22.5 4.5 33L142.5 354c-16.3 22.3-26.9 49-29.7 78c43.3-.2 82.5-17.6 111.2-45.7l0 61C191.7 468 153.2 480 112 480l-16 0c-17.7 0-32-14.3-32-32c0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112L0 64C0 46.3 14.3 32 32 32zM425.1 164.5c-10.9-11.9-24.3-21.5-39.3-27.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32l0 48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32l-16 0c-41.2 0-79.7-12-112-32.7l0-61c28.7 28.2 67.9 45.5 111.2 45.7c-2.9-29-13.5-55.7-29.7-78l-13.6-18.7c-7.6-10.4-5.6-25 4.5-33L506.6 288C558.7 246.9 592 183.4 592 112l0-31.5c-66.7 4.4-126.1 36.1-166.9 84z"]
};
const faBed = {
  prefix: 'far',
  iconName: 'bed',
  icon: [640, 512, [128716], "f236", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 360l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 264 0 280 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96 0-112c0-66.3-53.7-120-120-120l-176 0c-30.9 0-56 25.1-56 56l0 152L48 336 48 56zM592 248l0 88-256 0 0-152c0-4.4 3.6-8 8-8l176 0c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z"]
};
const faBookCopy = {
  prefix: 'far',
  iconName: 'book-copy',
  icon: [576, 512, [], "e0be", "M192 88c0-48.6 39.4-88 88-88L528 0c26.5 0 48 21.5 48 48l0 112 0 96c0 20.9-13.4 38.7-32 45.3l0 66.7 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0-248 0c-44.2 0-80-35.8-80-80l0-248zM528 48L280 48c-22.1 0-40 17.9-40 40l0 174.7c9.8-4.3 20.6-6.7 32-6.7l248 0 8 0 0-96 0-112zM272 304c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 0-64-224 0zM160 96l0 48-72 0c-22.1 0-40 17.9-40 40l0 174.7c9.8-4.3 20.6-6.7 32-6.7l81.1 0c2.5 17.7 9.2 34 18.9 48L80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 0-16 48 0 0 16 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0L80 512c-44.2 0-80-35.8-80-80L0 184c0-48.6 39.4-88 88-88l72 0z"]
};
const faSquareH = {
  prefix: 'far',
  iconName: 'square-h',
  icon: [448, 512, ["h-square"], "f0fd", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm336 56l0 104 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-128 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80 128 0 0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faHSquare = faSquareH;
const faSquareC = {
  prefix: 'far',
  iconName: 'square-c',
  icon: [448, 512, [], "e266", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM167.4 199.4c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0z"]
};
const faClockTwo = {
  prefix: 'far',
  iconName: 'clock-two',
  icon: [512, 512, [], "e35a", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 91.2L338.7 172c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-7.4 4.9-16.8 5.4-24.6 1.2S232 264.9 232 256l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faSquareEllipsisVertical = {
  prefix: 'far',
  iconName: 'square-ellipsis-vertical',
  icon: [448, 512, [], "e26f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCalendarUsers = {
  prefix: 'far',
  iconName: 'calendar-users',
  icon: [640, 512, [], "e5e2", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-40 0c-35.3 0-64 28.7-64 64l0 16 0 48 16 0 32 0 16 0 320 0 16 0 32 0 16 0 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L248 64l0-40zm6.7 440c.9 5.2 1.3 10.5 1.3 16c0 11.7-3.1 22.6-8.6 32l145.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-5.5 .5-10.8 1.3-16l-130.7 0zM528 384a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-48 32c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0zM192 304A80 80 0 1 0 32 304a80 80 0 1 0 160 0zM0 480c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-35.3 0-64 28.7-64 64z"]
};
const faPodcast = {
  prefix: 'far',
  iconName: 'podcast',
  icon: [448, 512, [], "f2ce", "M400 224c0 61.1-31.1 115-78.4 146.5c-1.4 17-4.1 36.6-7.1 54.9l-.6 3.8C392.8 394.7 448 315.8 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-3-18.4-5.7-38.1-7.1-55.1C79.1 338.9 48 285.1 48 224c0-97.2 78.8-176 176-176s176 78.8 176 176zm-32 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9c1.6-7.1 4.3-13.9 8.1-20.3c5.1-8.5 11.7-15.2 18.8-20.5C138 272.9 128 249.6 128 224c0-53 43-96 96-96s96 43 96 96c0 25.6-10 48.9-26.4 66.1c7.2 5.2 13.7 11.9 18.8 20.5c3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 80a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM178.9 487.7c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2c0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2zM225.5 464c-.5 0-1 0-1.5 0s-1.1 0-1.5 0c-3.1-13.3-6.7-31.9-9.9-51.4c-3.9-23.7-6.5-45.4-7-59c.6-.1 1.4-.3 2.2-.4c4.3-.8 9.7-1.2 16.3-1.2s12 .4 16.3 1.2c.8 .1 1.5 .3 2.2 .4c-.5 13.5-3.1 35.1-7 58.8c-3.2 19.5-6.9 38.1-10 51.5z"]
};
const faBee = {
  prefix: 'far',
  iconName: 'bee',
  icon: [576, 512, [], "e0b2", "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96C63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2c-.6-5.1-.9-10.2-.9-15.2c0-11.2 1-22.2 3.1-32.8C74.5 266.1 48 237.2 48 208c0-32.2 32.3-64 80-64c37.3 0 65.2 19.5 75.6 43.3C167.5 213.5 144 256 144 304c0 83.8 103.6 179.7 129.9 202.8c3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-48-23.5-90.5-59.6-116.7C382.8 163.5 410.7 144 448 144c47.7 0 80 31.8 80 64c0 29.2-26.5 58.1-67.1 63.2c2 10.6 3.1 21.6 3.1 32.8c0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112c-29 0-57.7 9-80.5 24.9c.3-2.9 .5-5.9 .5-8.9c0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zm17.6 393.9c-3.8-4.9-7.5-9.8-10.9-14.6L350 384c-3.4 4.8-7 9.7-10.9 14.6c-17.6 22.5-36.7 42.2-51.1 56c-14.4-13.8-33.5-33.5-51.1-56zm140-62.6l-177.9 0c-4.6-11.7-7.1-22.5-7.1-32l192 0c0 9.5-2.5 20.3-7.1 32zm-5.8-80l-166.3 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48z"]
};
const faTemperatureFull = {
  prefix: 'far',
  iconName: 'temperature-full',
  icon: [320, 512, ["temperature-4", "thermometer-4", "thermometer-full"], "f2c7", "M160 48c-35.3 0-64 28.7-64 64l0 161.9c0 14.5-5.7 27.1-12.8 36.6C71.1 326.5 64 346.4 64 368c0 53 43 96 96 96s96-43 96-96c0-21.6-7.1-41.5-19.2-57.5c-7.1-9.5-12.8-22.1-12.8-36.6L224 112c0-35.3-28.7-64-64-64zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112l0 161.9c0 1.7 .7 4.4 3.2 7.8c18.1 24.1 28.8 54 28.8 86.4c0 79.5-64.5 144-144 144S16 447.5 16 368c0-32.4 10.7-62.3 28.8-86.4c2.5-3.4 3.2-6.1 3.2-7.8L48 112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L144 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3z"]
};
const faTemperature4 = faTemperatureFull;
const faThermometer4 = faTemperatureFull;
const faThermometerFull = faTemperatureFull;
const faBell = {
  prefix: 'far',
  iconName: 'bell',
  icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
const faCandyBar = {
  prefix: 'far',
  iconName: 'candy-bar',
  icon: [640, 512, [127851, "chocolate-bar"], "e3e8", "M0 320l0-96 128 0 0 96L0 320zm0 64l0-32 128 0 0 96-64 0c-35.3 0-64-28.7-64-64zm288 64l-128 0 0-96 128 0 0-32-128 0 0-96 128 0 0-32-128 0 0-128 128 0 48 0 240 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-240 0-48 0zM36.7 177C43.9 165 48 151 48 136c0-4-.3-7.9-.9-11.7c-1-7 6.2-14.2 13.1-13.1c3.8 .6 7.7 .9 11.7 .9c15 0 29-4.1 41-11.3c6.1-3.6 15 .4 15 7.4l0 51.8s0 0 0 0l0 32-8 0s0 0 0 0l-75.8 0c-7.1 0-11.1-9-7.4-15zM336 112l0 288 240 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16l-240 0z"]
};
const faChocolateBar = faCandyBar;
const faXmarkLarge = {
  prefix: 'far',
  iconName: 'xmark-large',
  icon: [448, 512, [], "e59b", "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z"]
};
const faPinata = {
  prefix: 'far',
  iconName: 'pinata',
  icon: [512, 512, [], "e3c3", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24L84.4 48C37.8 48 0 85.8 0 132.4c0 36.3 23.3 68.6 57.7 80.1L96 225.3 96 440c0 39.8 32.2 72 72 72l22.4 0c36.2 0 65.6-29.4 65.6-65.6c0-21.2 17.2-38.4 38.4-38.4l19.2 0c21.2 0 38.4 17.2 38.4 38.4c0 36.2 29.4 65.6 65.6 65.6l22.4 0c39.8 0 72-32.2 72-72l0-112c0-57.4-46.6-104-104-104l-136 0 0-200zM84.4 96L224 96l0 125.2-23.3 9.3-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 224.4l0-4.8c0-17.2-11-32.5-27.4-37.9L72.9 167C58 162 48 148.1 48 132.4C48 112.3 64.3 96 84.4 96zM212.6 260.2l17.5-7c7.1 11.3 19.6 18.8 33.9 18.8l144 0c20.2 0 37.8 10.7 47.7 26.7c-6.7-1.8-13.8-1.4-20.3 1.2l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-26.7 10.7-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1l-3.4 1.4 0-42.3 23.3-9.3 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1zM144 335.6l15.3-6.1 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 19.1 9.6c8.2 4.1 17.7 4.5 26.2 1.1l26.7-10.7 16.7 8.4 0 54.5-11.4-4.6c-8.5-3.4-18-3-26.2 1.1l-19.1 9.6-32.3-12.9c-15.7-15.8-37.3-25.5-61.3-25.5l-19.2 0c-24 0-45.7 9.8-61.3 25.5l-32.3 12.9-19.1-9.6c-8.2-4.1-17.7-4.5-26.2-1.1L144 392.4l0-56.7zm0 91.2l23.3-9.3 19.1 9.6c7.3 3.6 15.6 4.3 23.3 2.1c-1.1 5.6-1.7 11.3-1.7 17.2c0 9.7-7.9 17.6-17.6 17.6L168 464c-13.3 0-24-10.7-24-24l0-13.2zm296.7-9.3l23.3 9.3 0 13.2c0 13.3-10.7 24-24 24l-22.4 0c-9.7 0-17.6-7.9-17.6-17.6c0-5.9-.6-11.6-1.7-17.2c7.7 2.3 16 1.5 23.3-2.1l19.1-9.6zM176 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFilePpt = {
  prefix: 'far',
  iconName: 'file-ppt',
  icon: [512, 512, [], "e64a", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm208-64c0-8.8 7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112-16 0c-8.8 0-16-7.2-16-16z"]
};
const faArrowsFromLine = {
  prefix: 'far',
  iconName: 'arrows-from-line',
  icon: [448, 512, [], "e0a4", "M241 7c-9.4-9.4-24.6-9.4-33.9 0L135 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L241 7zm7 337c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-86.1zM24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 232z"]
};
const faSuperscript = {
  prefix: 'far',
  iconName: 'superscript',
  icon: [512, 512, [], "f12b", "M472 24c0-8-3.9-15.4-10.5-19.9s-15-5.4-22.4-2.4l-40 16c-12.3 4.9-18.3 18.9-13.4 31.2s18.9 18.3 31.2 13.4l7.1-2.8L424 176l-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-152zM24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l27.2 0 96 144-96 144L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8 0 15.5-4 20-10.7l92-138 92 138C272.5 444 280 448 288 448l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-27.2 0-96-144 96-144 27.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c-8 0-15.5 4-20 10.7l-92 138L84 74.7C79.5 68 72 64 64 64L24 64z"]
};
const faBowlSpoon = {
  prefix: 'far',
  iconName: 'bowl-spoon',
  icon: [512, 512, [129379], "e3e0", "M112 144c-42.6 0-64-28.2-64-48s21.4-48 64-48s64 28.2 64 48s-21.4 48-64 48zm0 48c52.2 0 96-30.6 108.5-72L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L220.5 72C208 30.6 164.2 0 112 0C50.1 0 0 43 0 96s50.1 96 112 96zm64.5 266.9c-4.5-11.7-13.5-21.2-25-26.4C90.4 404.8 48 343.3 48 272l416 0c0 71.3-42.4 132.8-103.5 160.5c-11.5 5.2-20.4 14.7-25 26.4c-1.2 3.1-4.2 5.1-7.5 5.1l-144 0c-3.3 0-6.3-2-7.5-5.1zM48 224c-26.5 0-48 21.5-48 48c0 90.8 54.1 169 131.7 204.2c8.1 21 28.4 35.8 52.3 35.8l144 0c23.8 0 44.2-14.9 52.3-35.8C457.9 441 512 362.8 512 272c0-26.5-21.5-48-48-48L48 224z"]
};
const faHexagonCheck = {
  prefix: 'far',
  iconName: 'hexagon-check',
  icon: [512, 512, [], "e416", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faPlugCircleXmark = {
  prefix: 'far',
  iconName: 'plug-circle-xmark',
  icon: [576, 512, [], "e560", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faStarOfLife = {
  prefix: 'far',
  iconName: 'star-of-life',
  icon: [512, 512, [], "f621", "M184 64c0-35.3 28.7-64 64-64l16 0c35.3 0 64 28.7 64 64l0 67.3 58.3-33.6c30.6-17.7 69.8-7.2 87.4 23.4l8 13.9c17.7 30.6 7.2 69.8-23.4 87.4L400 256l58.3 33.6c30.6 17.7 41.1 56.8 23.4 87.4l-8 13.9c-17.7 30.6-56.8 41.1-87.4 23.4L328 380.7l0 67.3c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-67.3-58.3 33.6C95.1 432 56 421.5 38.3 390.9l-8-13.9c-17.7-30.6-7.2-69.8 23.4-87.4L112 256 53.7 222.4c-30.6-17.7-41.1-56.8-23.4-87.4l8-13.9C56 90.5 95.1 80 125.7 97.6L184 131.3 184 64zm64-16c-8.8 0-16 7.2-16 16l0 108.9c0 8.6-4.6 16.5-12 20.8s-16.6 4.3-24 0l-94.3-54.4c-7.7-4.4-17.4-1.8-21.9 5.9l-8 13.9c-4.4 7.7-1.8 17.4 5.9 21.9L172 235.2c7.4 4.3 12 12.2 12 20.8s-4.6 16.5-12 20.8L77.7 331.2c-7.7 4.4-10.3 14.2-5.9 21.9l8 13.9c4.4 7.7 14.2 10.3 21.9 5.9L196 318.4c7.4-4.3 16.6-4.3 24 0s12 12.2 12 20.8L232 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-108.9c0-8.6 4.6-16.5 12-20.8s16.6-4.3 24 0l94.3 54.4c7.7 4.4 17.4 1.8 21.9-5.9l8-13.9c4.4-7.7 1.8-17.4-5.9-21.9L340 276.8c-7.4-4.3-12-12.2-12-20.8s4.6-16.5 12-20.8l94.3-54.4c7.7-4.4 10.3-14.2 5.9-21.9l-8-13.9c-4.4-7.7-14.2-10.3-21.9-5.9L316 193.6c-7.4 4.3-16.6 4.3-24 0s-12-12.2-12-20.8L280 64c0-8.8-7.2-16-16-16l-16 0z"]
};
const faPhoneSlash = {
  prefix: 'far',
  iconName: 'phone-slash',
  icon: [640, 512, [], "f3dd", "M601.2 5.1c10.4-8.2 25.5-6.3 33.7 4.1s6.3 25.5-4.1 33.7l-592 464c-10.4 8.2-25.5 6.3-33.7-4.1s-6.3-25.5 4.1-33.7l155.6-122C101.8 270 64 171.4 64 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c8.6 14.9 18.5 29 29.4 42.1L601.2 5.1zM240.4 287.9C228.1 273 217 257 207.2 240.2c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L112 70.5c1.5 93.7 35.2 179.6 90.5 247.1l37.8-29.6zm-6 127.7L273.2 385c65 48.5 145.3 77.6 232.3 79l21.3-99.2-100.4-43L397 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-8-4.6-15.7-9.5-23.3-14.7l39.8-31.3c2.5 1.5 5 3.1 7.6 4.5L384 297.7l31.4-24.7c7.9-1.7 16.4-1.1 24.3 2.3l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.3-.4c0 0 0 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2c-86.2-9.2-165.2-42.8-229.7-93.9z"]
};
const faTrafficLightStop = {
  prefix: 'far',
  iconName: 'traffic-light-stop',
  icon: [320, 512, [], "f63a", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM144 376a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM160 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 64a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm0-120a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
const faPaintRoller = {
  prefix: 'far',
  iconName: 'paint-roller',
  icon: [512, 512, [], "f5aa", "M352 48L64 48c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM64 0L352 0c35.3 0 64 28.7 64 64l0 8 0 48 0 8c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zm96 352c0-17.7 14.3-32 32-32l8 0 0-16c0-39.8 32.2-72 72-72l152 0c22.1 0 40-17.9 40-40l0-48c0-10.4-6.7-19.3-16-22.6l0-48.9c36 4 64 34.5 64 71.6l0 48c0 48.6-39.4 88-88 88l-152 0c-13.3 0-24 10.7-24 24l0 16 8 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-128z"]
};
const faAccentGrave = {
  prefix: 'far',
  iconName: 'accent-grave',
  icon: [192, 512, [], "60", "M80 65.3C80 55.8 87.8 48 97.3 48c8.4 0 15.6 6 17 14.3l18.2 102.1L82.9 79.9C81 76.6 80 72.9 80 69.2l0-3.9zm-48 0l0 3.9c0 12.3 3.3 24.4 9.5 35.1l57.3 97.4c8.1 13.8 23 22.3 39 22.3c28.2 0 49.5-25.5 44.6-53.3L161.6 53.8C156.1 22.7 129 0 97.3 0C61.2 0 32 29.2 32 65.3z"]
};
const faHandshakeAngle = {
  prefix: 'far',
  iconName: 'handshake-angle',
  icon: [640, 512, ["hands-helping"], "f4c4", "M264 320c39.8 0 72-32.2 72-72l0-8 104 0c13.3 0 24 10.7 24 24c0 11.7-8.4 21.5-19.4 23.6c-7.7 1.5-14.2 6.6-17.4 13.8s-2.7 15.5 1.4 22.2c2.2 3.6 3.4 7.8 3.4 12.4c0 13.3-10.7 24-24 24s-24 10.7-24 24c0 8.8-7.2 16-16 16l-16 0-32 0-66.7 0c-14.9 0-29.1 5.9-39.6 16.4L159 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l54.6-54.6c1.5-1.5 3.5-2.3 5.7-2.3l66.7 0 32 0 16 0c28 0 51.8-17.9 60.5-42.9c29.8-8.8 51.5-36.4 51.5-69.1c0-3.9-.3-7.8-.9-11.5C498.9 311.7 512 289.4 512 264c0-39.8-32.2-72-72-72l-104 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96c0-22.1 17.9-40 40-40l138.7 0c14.9 0 29.1-5.9 39.6-16.4L513 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L424.4 61.7c-1.5 1.5-3.5 2.3-5.7 2.3L280 64c-48.6 0-88 39.4-88 88l0 96c0 39.8 32.2 72 72 72zM160 132.5c-19 7.5-33.9 23.6-39.4 44.2L99 257.5c-.4 1.4-1.1 2.6-2.1 3.6L7 351c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L130.9 295c7-7 12-15.6 14.5-25.2L160 215.1l0-82.6zM543.2 250.8L633 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-75.3 75.3c10.3 13.9 17.1 30.5 19.4 48.5z"]
};
const faHandsHelping = faHandshakeAngle;
const faCircle0 = {
  prefix: 'far',
  iconName: 'circle-0',
  icon: [512, 512, [], "e0ed", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96l0 64c0 53 43 96 96 96s96-43 96-96l0-64c0-53-43-96-96-96zm-48 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64z"]
};
const faDialMedLow = {
  prefix: 'far',
  iconName: 'dial-med-low',
  icon: [576, 512, [], "e160", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 367.2c-37.9-37.9-43-96.2-15.1-139.6L271 305c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-77.4-77.4c43.4-27.8 101.7-22.8 139.6 15.1c43.7 43.7 43.7 114.7 0 158.4s-114.7 43.7-158.4 0zM174.9 174.9A160 160 0 1 0 401.1 401.1 160 160 0 1 0 174.9 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faLocationDot = {
  prefix: 'far',
  iconName: 'location-dot',
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
const faMapMarkerAlt = faLocationDot;
const faCrab = {
  prefix: 'far',
  iconName: 'crab',
  icon: [512, 512, [129408], "e3ff", "M.2 120s0 0 0 0s0 0 0 0C4.4 53 60 0 128 0l44.7 0c7.1 0 10.7 8.6 5.7 13.7L141.7 50.3c-5 5-1.5 13.7 5.7 13.7L184 64c4.4 0 8.1 3.6 7.5 8c-3.9 31.6-30.9 56-63.5 56l-80 0 0 33.3c0 9.4 5.4 17.9 13.9 21.8L133.3 216c16.9-12.2 37-20.3 58.7-23l0-41c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 41c21.7 2.7 41.7 10.9 58.7 23l71.4-32.9c8.5-3.9 13.9-12.4 13.9-21.8l0-33.3-80 0c-32.6 0-59.6-24.4-63.5-56c-.5-4.4 3.1-8 7.5-8l36.7 0c7.1 0 10.7-8.6 5.7-13.7L333.7 13.7c-5-5-1.5-13.7 5.7-13.7L384 0c68 0 123.6 53 127.8 120c0 0 0 0 0 0s0 0 0 0c0 .1 0 .3 0 .4l.2 7.6-7.9 0c0 0-.1 0-.1 0l8 0 0 33.3c0 28.1-16.3 53.6-41.8 65.4L413.1 253c2.2 3.6 4.2 7.2 6 11l31.2 0 26.9-13.5c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-32 16c-3.3 1.7-7 2.5-10.7 2.5l-24.2 0c.2 2.6 .2 5.3 .2 8l0 1.4 23.6 7.9c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-30-10L387 381l36.6 12.2c3.5 1.2 6.7 3.2 9.4 5.8l32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-28-28-54-18-2.2 2.2L371.7 435c7.6 4.2 12.3 12.3 12.3 21l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.9L297.9 449c-.6-.3-1.1-.6-1.6-1l-80.7 0c-.5 .3-1.1 .7-1.6 1L176 470.1l0 17.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-8.7 4.7-16.7 12.3-21l24.9-13.8L163 419l-54 18L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L125 381 107 363 77 373 49 401c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l32-32c2.6-2.6 5.8-4.6 9.4-5.8L80 321.4l0-1.4c0-2.7 .1-5.4 .2-8L56 312c-3.7 0-7.4-.9-10.7-2.5l-32-16C1.4 287.5-3.4 273.1 2.5 261.3s20.3-16.7 32.2-10.7L61.7 264l31.2 0c1.8-3.8 3.9-7.4 6-11L41.8 226.7C16.3 214.9 0 189.4 0 161.3L0 128l8 0c0 0-.1 0-.1 0L0 128l.2-7.6c0-.1 0-.3 0-.4zM296 240l-80 0-8 0c-42.9 0-77.9 33.8-79.9 76.2L211.9 400l88.2 0 83.8-83.8c-2-42.4-37-76.2-79.9-76.2l-8 0z"]
};
const faBoxOpenFull = {
  prefix: 'far',
  iconName: 'box-open-full',
  icon: [640, 512, ["box-full"], "f49c", "M480.9 3.1C456-6.2 428.4 6.3 419.1 31.2L384 124.8C382.2 55.6 325.6 0 256 0C185.3 0 128 57.3 128 128c0 2.2 .1 4.3 .2 6.5l65.5 8.2c-1.1-4.7-1.7-9.6-1.7-14.7c0-35.3 28.7-64 64-64s64 28.7 64 64c0 10.7-2.6 20.7-7.2 29.6l7.2 .9 161.4-20.2 27.5-73.4c9.3-24.8-3.3-52.5-28.1-61.8zM58.9 170.1L17.2 253.5c-9 17.9 .6 39.6 19.8 45.1l163.3 46.7c13.9 4 28.8-1.9 36.2-14.3L320 192 75.2 161.4c-6.7-.8-13.3 2.7-16.3 8.7zM576 339.6l-48 13.7 0 57.2-184 46L344 312c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 144.5-184-46 0-57.2L64 339.6l0 71c0 22 15 41.2 36.4 46.6l204.1 51c10.2 2.5 20.9 2.5 31 0l204.1-51c21.4-5.3 36.4-24.5 36.4-46.6l0-71zm46.8-86.1l-41.7-83.4c-3-6.1-9.6-9.6-16.3-8.7L320 192l83.4 139c7.4 12.4 22.3 18.3 36.2 14.3l163.3-46.7c19.3-5.5 28.8-27.2 19.8-45.1z"]
};
const faBoxFull = faBoxOpenFull;
const faFile = {
  prefix: 'far',
  iconName: 'file',
  icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"]
};
const faGreaterThan = {
  prefix: 'far',
  iconName: 'greater-than',
  icon: [384, 512, [62769], "3e", "M2.5 77.3c-5.9 11.9-1.1 26.3 10.7 32.2L306.3 256 13.3 402.5C1.4 408.5-3.4 422.9 2.5 434.7s20.3 16.7 32.2 10.7l336-168c8.1-4.1 13.3-12.4 13.3-21.5s-5.1-17.4-13.3-21.5l-336-168C22.9 60.6 8.5 65.4 2.5 77.3z"]
};
const faQuotes = {
  prefix: 'far',
  iconName: 'quotes',
  icon: [576, 512, [], "e234", "M0 96C0 43 43 0 96 0l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0C69.5 48 48 69.5 48 96l48 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-24 0-24L0 96zm48 72l0 24 48 0 0-48-48 0 0 24zM176 96c0-53 43-96 96-96l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0c-26.5 0-48 21.5-48 48l48 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-24 0-24 0-48zm48 48l0 24 0 24 48 0 0-48-48 0zM576 416c0 53-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48l-48 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 48zm-48-48l0-24 0-24-48 0 0 48 48 0zM400 416c0 53-43 96-96 96l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0c26.5 0 48-21.5 48-48l-48 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48l48 0c26.5 0 48 21.5 48 48l0 24 0 24 0 48zm-48-72l0-24-48 0 0 48 48 0 0-24z"]
};
const faPretzel = {
  prefix: 'far',
  iconName: 'pretzel',
  icon: [512, 512, [129384], "e441", "M56 184.2c0 52.5 20.3 100.3 53.5 135.9l19-26.8C103.3 264 88 225.9 88 184.2c0-39.9 32.3-72.2 72.2-72.2l3.8 0c42 0 76 34 76 76l0 5.1c0 16.8-5.2 33.2-14.9 46.9l-45.9 64.9-.1 .2-46.2 65.2-.1 .2-25.8 36.4c-5.1 7.2-3.4 17.2 3.8 22.3s17.2 3.4 22.3-3.8L163.7 382c6.2-8.7 17.3-12.3 27.4-8.8c20.3 7 42.2 10.8 65 10.8c11.2 0 22.3-.9 33-2.7l-21-29.7c-3.9 .3-7.9 .4-11.9 .4c-9.2 0-18.3-.7-27.2-2.2c-8.2-1.3-15.1-6.8-18.3-14.4s-2.2-16.4 2.6-23.1l23.3-32.9c4.5-6.4 11.8-10.1 19.6-10.1s15.1 3.8 19.6 10.1l11.5 16.3 11.8 16.6 .1 .1 49.3 69.5c0 0 .1 .1 .1 .1l30.6 43.2c5.1 7.2 15.1 8.9 22.3 3.8s8.9-15.1 3.8-22.3l-25.8-36.4c-7.3-10.2-5.4-24.3 4.3-32.4c44.3-36.7 72.4-92 72.4-153.8C456 126.7 409.3 80 351.8 80L348 80c-29.3 0-55.8 11.6-75.3 30.6c-9.3 9.1-24.1 9.1-33.5 0C219.8 91.6 193.3 80 164 80l-3.8 0C102.7 80 56 126.7 56 184.2zM81.2 360C36.1 315.1 8 253 8 184.2C8 100.1 76.1 32 160.2 32l3.8 0c34.4 0 66.2 11.2 92 30c25.8-18.9 57.6-30 92-30l3.8 0C435.8 32 504 100.1 504 184.2c0 68.7-28.1 130.9-73.2 175.8l13.5 19c20.4 28.8 13.6 68.8-15.2 89.2s-68.8 13.6-89.2-15.2c0 0 0 0 0 0s0 0 0 0l-20.6-29.1C299 429.2 277.8 432 256 432s-43-2.8-63.2-8.1L172.2 453c-20.4 28.8-60.4 35.7-89.2 15.2l13.3-18.8L83 468.2C54.2 447.8 47.3 407.8 67.8 379c0 0 0 0 0 0l13.5-19zM136 184.2c0 25.3 7.9 48.9 21.4 68.3l28.5-40.2c4-5.6 6.1-12.3 6.1-19.1l0-5.1c0-15.5-12.5-28-28-28l-3.8 0c-13.4 0-24.2 10.8-24.2 24.2zM320 188l0 5.1c0 6.9 2.1 13.5 6.1 19.1l28.5 40.2c13.5-19.4 21.4-42.9 21.4-68.3c0-13.4-10.8-24.2-24.2-24.2l-3.8 0c-15.5 0-28 12.5-28 28zm28-76l3.8 0c39.9 0 72.2 32.3 72.2 72.2c0 49.4-21.5 93.9-55.5 124.6c-5.1 4.6-11.9 6.8-18.7 6s-13-4.4-16.9-10L286.9 240c-9.7-13.7-14.9-30.1-14.9-46.9l0-5.1c0-42 34-76 76-76z"]
};
const faTRex = {
  prefix: 'far',
  iconName: 't-rex',
  icon: [640, 512, [], "e629", "M423.8 48C393.1 48 368 73.1 368 104c0 5.6-2 11.1-5.6 15.4l-40 48c-4.6 5.5-11.3 8.6-18.4 8.6l-41.9 0c-53.6 0-97.9 41.8-101 95.3c-1.3 22.9-20.3 40.7-43.2 40.7l-4.3 0c-21 0-39.5-13.7-45.7-33.7L57.6 244.7l-1 2.5c-5.7 14.2-8.6 29.3-8.6 44.6l0 4.3c0 57.4 46.6 104 104 104l40 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.1L297.9 464l86.1 0 0-16c0-8.8-7.2-16-16-16l-24 0c-8 0-15.5-4-20-10.7l-16-24c-5.8-8.7-5.3-20.1 1.2-28.3l18-22.5c5.7-7.1 8.8-15.9 8.8-25l0-1.6c0-26.5-21.5-48-48-48c-13.3 0-24-10.7-24-24s10.7-24 24-24c53 0 96 43 96 96l0 1.6c0 20-6.8 39.4-19.3 55l-6 7.5 9.3 0c35.3 0 64 28.7 64 64l0 40c0 13.3-10.7 24-24 24l-120 0c-6.4 0-12.5-2.5-17-7l-57-57L152 448C68.1 448 0 379.9 0 296l0-4.3c0-21.4 4.1-42.5 12-62.4l20.3-50.7C36.8 167.4 47.7 160 59.8 160c13 0 24.5 8.5 28.3 20.9l25.3 82.3C120.6 186.9 184.8 128 262.1 128l30.7 0 27.6-33.2C325 41.8 369.5 0 423.8 0c8.5 0 16.9 1 25 3.1C456.3 1.1 464.1 0 472 0c26.7 0 51.7 12 68.3 32.1C595.7 34.3 640 80 640 136l0 24c0 30.9-21.9 56.7-51 62.7l-5.8 7.7L564 216l19.2 14.4C571.1 246.5 552.1 256 532 256l-72 0-15.3 20.5 46.8 26c12.7 7.1 20.6 20.4 20.6 35l0 22.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.9-48.1-26.7c-.7-21.5-6.4-41.6-15.9-59.4l28.8-38.4c4.5-6 11.6-9.6 19.2-9.6l84 0c.8 0 1.5-.1 2.3-.2c-9.3-.8-18-4.9-24.6-11.5l-17.9-17.9c-1.5-1.5-3.5-2.3-5.7-2.3L464 176c-8.8 0-16-7.2-16-16s7.2-16 16-16l22.1 0c10.6 0 20.8 4.2 28.3 11.7l17.9 17.9c1.5 1.5 3.5 2.3 5.7 2.3l38.1 0c8.8 0 16-7.2 16-16l0-24c0-30.9-25.1-56-56-56l-8.2 0c-8.5 0-16.4-4.5-20.7-11.9C499.9 55.7 486.5 48 472 48c-5 0-9.8 .9-14.3 2.6c-5.2 1.9-10.9 2-16.1 .3C435.9 49 429.9 48 423.8 48zM456 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faPersonSwimming = {
  prefix: 'far',
  iconName: 'person-swimming',
  icon: [576, 512, [127946, "swimmer"], "f5c4", "M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM80 334.1C62.8 349 41 360.8 18.8 365.8C5.9 368.7-2.3 381.5 .6 394.5s15.7 21.1 28.7 18.2C58 406.2 81.6 392.2 96 382.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM256.5 193.9L403 318.1c13.8-3.2 27.9-9.6 40.2-18c2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-119.3 0-216 96.7-216 216l0 2.2c10.8 4 21.9 6.2 32 6.2c5.4 0 10.7-.5 16-1.6l0-6.9c0-46.1 18.5-87.8 48.5-118.1z"]
};
const faSwimmer = faPersonSwimming;
const faArrowDown = {
  prefix: 'far',
  iconName: 'arrow-down',
  icon: [384, 512, [8595], "f063", "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"]
};
const faUserRobotXmarks = {
  prefix: 'far',
  iconName: 'user-robot-xmarks',
  icon: [448, 512, [], "e4a7", "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-64 0c-44.2 0-80 35.8-80 80l0 96c0 44.2 35.8 80 80 80l160 0c44.2 0 80-35.8 80-80l0-96c0-44.2-35.8-80-80-80l-64 0 0-48zm96 128l0 96c0 17.7-14.3 32-32 32l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16-32 0 0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32zm64 304l0 16-96 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32-96 0 0-16c0-26.5 21.5-48 48-48l256 0c26.5 0 48 21.5 48 48zM224 512l64 0 112 0c26.5 0 48-21.5 48-48l0-16c0-53-43-96-96-96L96 352c-53 0-96 43-96 96l0 16c0 26.5 21.5 48 48 48l112 0 64 0zM16 128c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zM168 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0s-5.1 13.4 0 18.6L149.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L168 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L186.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L168 157.4zm78.7-14.7c-5.1 5.1-5.1 13.4 0 18.6L261.4 176l-14.7 14.7c-5.1 5.1-5.1 13.4 0 18.6s13.4 5.1 18.6 0L280 194.6l14.7 14.7c5.1 5.1 13.4 5.1 18.6 0s5.1-13.4 0-18.6L298.6 176l14.7-14.7c5.1-5.1 5.1-13.4 0-18.6s-13.4-5.1-18.6 0L280 157.4l-14.7-14.7c-5.1-5.1-13.4-5.1-18.6 0z"]
};
const faMessageQuote = {
  prefix: 'far',
  iconName: 'message-quote',
  icon: [512, 512, ["comment-alt-quote"], "e1e4", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM160 112c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0zm224 80l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3z"]
};
const faCommentAltQuote = faMessageQuote;
const faCandyCorn = {
  prefix: 'far',
  iconName: 'candy-corn',
  icon: [640, 512, [], "f6bd", "M612.6 18.1C570.4 4.2 524.1 0 480 0c-44 0-90 4.4-132.2 17.9C331.4 23.4 320 38.8 320 56c0 20.1 7 52 15.6 84c9.1 33.8 21.4 73 34.7 110.4c13.2 37.2 27.9 73.6 41.6 101.3c13.4 27 32.9 64.3 68.1 64.3s54.6-37.3 68.1-64.3c13.8-27.7 28.4-64.1 41.6-101.3C603 213 615.3 173.8 624.4 140C633 108 640 76.1 640 56c0-17.2-11-32.5-27.4-37.9zM480 280c14.2 0 32.1 2.4 45.4 4.6c-6.9 17-13.8 32.6-20.3 45.7c-7 14-12.8 24.8-19.3 32.3c-2.9 3.4-4.9 4.8-5.7 5.2l-.1 .1-.1-.1c-.8-.5-2.8-1.8-5.7-5.2c-6.5-7.5-12.3-18.3-19.3-32.3c-6.5-13.1-13.4-28.7-20.3-45.7c13.3-2.2 31.2-4.6 45.4-4.6zM583.2 107.4C556.2 102.6 512.4 96 480 96s-76.2 6.6-103.2 11.4c-4.7-19.2-7.7-35-8.5-45.5C402.6 51.7 441 48 480 48c39.2 0 77.7 3.6 111.7 13.8c-.9 10.6-3.9 26.4-8.5 45.6zM191.7 122.3c-39.6 20.1-75.4 49.9-106.6 81C54 234.5 24.5 270.1 4.3 309.5c-7.7 15.4-4.9 34.4 7.3 46.6c14.2 14.2 41.8 31.8 70.4 48.3c30.3 17.5 66.8 36.5 102.6 53.6c35.7 16.9 71.8 32.4 101 42.2c28.6 9.6 68.7 22.2 93.6-2.7s12.2-65 2.7-93.6c-9.8-29.3-25.2-65.4-42.2-101c-17-35.9-36.1-72.3-53.6-102.6c-16.5-28.7-34.2-56.2-48.3-70.4c-12.2-12.2-30.8-15.2-46.2-7.5zm91.4 279c10-10 24.4-21 35.4-28.8c7.2 16.9 13.3 32.8 18 46.7c5 14.8 8.5 26.6 9.2 36.5c.3 4.5-.1 6.9-.3 7.8l0 .1-.1 0c-.9 .3-3.3 .7-7.8 .3c-9.9-.7-21.7-4.3-36.5-9.2c-13.9-4.7-29.7-10.8-46.7-18c7.8-10.9 18.8-25.3 28.8-35.4zM234 206.3c-22.5 15.8-58.1 42-81 64.9s-49.2 58.5-64.9 81c-16.9-10.3-30.1-19.3-38.2-26.2c17.1-31.4 41.6-61.2 69.2-88.8c27.7-27.7 57.5-52.4 88.8-69.2c6.8 8.1 15.9 21.4 26.2 38.3z"]
};
const faFolderMagnifyingGlass = {
  prefix: 'far',
  iconName: 'folder-magnifying-glass',
  icon: [512, 512, ["folder-search"], "e18b", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM336 272c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faFolderSearch = faFolderMagnifyingGlass;
const faNotebook = {
  prefix: 'far',
  iconName: 'notebook',
  icon: [512, 512, [], "e201", "M240 48l176 0c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-176 0 0-416zm-48 0l0 416-64 0c-8.8 0-16-7.2-16-16l0-32 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-88 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-88 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0 0-32c0-8.8 7.2-16 16-16l64 0zM64 416l0 32c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64l0 32L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 88-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 88-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0z"]
};
const faCircleWifi = {
  prefix: 'far',
  iconName: 'circle-wifi',
  icon: [512, 512, [], "e67d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm127.5-14.7c-9.8 8.9-25 8.1-33.9-1.8s-8.1-25 1.8-33.9C137.9 167.3 194.3 144 256 144s118.1 23.3 160.6 61.6c9.8 8.9 10.6 24 1.8 33.9s-24 10.6-33.9 1.8c-34-30.7-79-49.3-128.5-49.3s-94.4 18.6-128.5 49.3zM256 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-48c-22.7 0-43.4 8.6-59 22.7c-9.8 8.9-25 8.1-33.9-1.7s-8.1-25 1.7-33.9C188.9 253.3 220.9 240 256 240s67.1 13.3 91.2 35.1c9.8 8.9 10.6 24.1 1.7 33.9s-24.1 10.6-33.9 1.7c-15.6-14.1-36.3-22.7-59-22.7z"]
};
const faDroplet = {
  prefix: 'far',
  iconName: 'droplet',
  icon: [384, 512, [128167, "tint"], "f043", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z"]
};
const faTint = faDroplet;
const faBullseyePointer = {
  prefix: 'far',
  iconName: 'bullseye-pointer',
  icon: [512, 512, [], "f649", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 5.5 .2 10.9 .6 16.3L1.8 286.1C.6 276.2 0 266.2 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.2 0-20.2-.6-30.1-1.8l13.8-46.9c5.4 .4 10.8 .6 16.3 .6zm-2.4-48l14.3-48.6C324.2 361.4 368 313.8 368 256c0-61.9-50.1-112-112-112c-57.8 0-105.4 43.8-111.4 100.1L96 258.4c0-.8 0-1.6 0-2.4c0-88.4 71.6-160 160-160s160 71.6 160 160s-71.6 160-160 160c-.8 0-1.6 0-2.4 0zM39 308.5l204.8-60.2c12.1-3.6 23.4 7.7 19.9 19.9L203.5 473c-4.1 13.9-23.2 15.6-29.7 2.6l-28.7-57.3c-.7-1.3-1.5-2.6-2.5-3.7l-88 88c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l88-88c-1.1-1-2.3-1.9-3.7-2.5L36.4 338.2c-13-6.5-11.3-25.6 2.6-29.7z"]
};
const faEraser = {
  prefix: 'far',
  iconName: 'eraser',
  icon: [576, 512, [], "f12d", "M97 319c-9.4 9.4-9.4 24.6 0 33.9l72 72c4.5 4.5 10.6 7 17 7l108.1 0c6.4 0 12.5-2.5 17-7l65-65L216 200 97 319zM285.1 63c28.1-28.1 73.7-28.1 101.8 0L513 189.1c28.1 28.1 28.1 73.7 0 101.8L371.9 432 520 432c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0s0 0 0 0c-.6 0-1.3 0-1.9 0l-108.1 0c-19.1 0-37.4-7.6-50.9-21.1l-72-72c-28.1-28.1-28.1-73.7 0-101.8L285.1 63z"]
};
const faHexagonImage = {
  prefix: 'far',
  iconName: 'hexagon-image',
  icon: [512, 512, [], "e504", "M17.1 220c-12.9 22.3-12.9 49.7 0 72l88.3 152.9c12.9 22.3 36.6 36 62.4 36l176.6 0c25.7 0 49.5-13.7 62.4-36L494.9 292c12.9-22.3 12.9-49.7 0-72L406.6 67.1c-12.9-22.3-36.6-36-62.4-36l-176.6 0c-25.7 0-49.5 13.7-62.4 36L17.1 220zm41.6 48c-4.3-7.4-4.3-16.6 0-24L146.9 91.1c4.3-7.4 12.2-12 20.8-12l176.6 0c8.6 0 16.5 4.6 20.8 12L453.4 244c4.3 7.4 4.3 16.6 0 24l-34.5 59.8-78.1-94c-4.6-5.5-11.3-8.7-18.5-8.7s-13.9 3.2-18.5 8.7L232.2 320l-38.9-40.6c-4.6-4.8-11-7.5-17.6-7.4s-13 2.9-17.4 7.8l-56.9 62.3L58.6 268zM232 160a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
const faEarthAmericas = {
  prefix: 'far',
  iconName: 'earth-americas',
  icon: [512, 512, [127758, "earth", "earth-america", "globe-americas"], "f57d", "M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
};
const faEarth = faEarthAmericas;
const faEarthAmerica = faEarthAmericas;
const faGlobeAmericas = faEarthAmericas;
const faFileSvg = {
  prefix: 'far',
  iconName: 'file-svg',
  icon: [512, 512, [], "e64b", "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM205.7 352l26.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-26.3 0c-7.5 0-13.7 6.1-13.7 13.7c0 5.2 2.9 9.9 7.6 12.2l31.2 15.6c15.5 7.7 25.2 23.5 25.2 40.8c0 25.2-20.4 45.7-45.7 45.7L176 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l34.3 0c7.5 0 13.7-6.1 13.7-13.7c0-5.2-2.9-9.9-7.6-12.2l-31.2-15.6C169.8 430.8 160 415 160 397.7c0-25.2 20.4-45.7 45.7-45.7zM456 352l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80c0-22.1 17.9-40 40-40zm-152 0c8.8 0 16 7.2 16 16l0 31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66l0-31.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6l0-31.6c0-8.8 7.2-16 16-16z"]
};
const faCrateApple = {
  prefix: 'far',
  iconName: 'crate-apple',
  icon: [512, 512, ["apple-crate"], "f6b1", "M160 54.9c0 5 4.1 9.1 9.1 9.1C199.4 64 224 39.4 224 9.1c0-5-4.1-9.1-9.1-9.1C184.6 0 160 24.6 160 54.9zM80 171.4c0-15.3 3.8-29 8.7-37.2c2.3-3.8 4.1-5.3 4.9-5.7c0 0 0 0 0 0c.4-.2 .8-.5 2.4-.5c2.2 0 6.5 .5 12.6 2.1c5.8 1.5 11.9 3.6 17.2 5.7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5c0 0 0 0 0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6l48.5 0c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4c0 7 .4 13.9 1.2 20.6l48.5 0c-1.1-6.5-1.7-13.3-1.7-20.6zM430.3 192l48.5 0c.8-6.7 1.2-13.5 1.2-20.6c0-43.6-20.4-91.4-64-91.4c-15.6 0-34.1 5.9-47.2 11c-10.7 4.2-22.8 4.2-33.5 0c-12.4-4.8-29.6-10.3-44.6-11c3.4 4 6.4 8.3 9 12.7c7.8 12.9 13.2 27.5 16.4 42.3l1.7 .7c21.9 8.5 46.4 8.5 68.3 0c5.4-2.1 11.4-4.2 17.2-5.7c6.1-1.6 10.3-2.1 12.6-2.1c1.6 0 2.1 .3 2.4 .5c0 0 0 0 0 0c.7 .5 2.6 1.9 4.9 5.7c4.9 8.2 8.7 21.9 8.7 37.2c0 7.2-.6 14.1-1.7 20.6zM406.9 0C376.6 0 352 24.6 352 54.9c0 5 4.1 9.1 9.1 9.1C391.4 64 416 39.4 416 9.1c0-5-4.1-9.1-9.1-9.1zM456 272c4.4 0 8 3.6 8 8l0 64L48 344l0-64c0-4.4 3.6-8 8-8l400 0zM48 456l0-64 416 0 0 64c0 4.4-3.6 8-8 8L56 464c-4.4 0-8-3.6-8-8zm8-232c-30.9 0-56 25.1-56 56L0 456c0 30.9 25.1 56 56 56l400 0c30.9 0 56-25.1 56-56l0-176c0-30.9-25.1-56-56-56L56 224zm360 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faAppleCrate = faCrateApple;
const faPersonBurst = {
  prefix: 'far',
  iconName: 'person-burst',
  icon: [640, 512, [], "e53b", "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L496 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM464 488l0-136 32 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-264.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L570.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L331.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L416 223.6 416 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 49.9-7.8 23.5-41.6-53.7-37L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"]
};
const faGameBoard = {
  prefix: 'far',
  iconName: 'game-board',
  icon: [448, 512, [], "f867", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM304 96l-80 0 0 80-80 0 0-80L64 96l0 80 80 0 0 80-80 0 0 80 80 0 0 80 80 0 0-80 80 0 0 80 80 0 0-80-80 0 0-80 80 0 0-80-80 0 0-80zM224 256l0 80-80 0 0-80 80 0zm0 0l0-80 80 0 0 80-80 0z"]
};
const faHatChef = {
  prefix: 'far',
  iconName: 'hat-chef',
  icon: [512, 512, [], "f86b", "M180.9 100.3C192.2 69.7 221.6 48 256 48s63.8 21.7 75.1 52.3c3.2 8.7 11.2 14.8 20.5 15.6s18.2-3.8 22.8-11.9c8.3-14.4 23.9-24 41.6-24c26.5 0 48 21.5 48 48c0 10.9-2.9 28.1-8.1 49.2c-5.1 20.6-11.9 43.2-18.8 64.4c-6.9 21.2-13.8 40.6-19 54.8c-1 2.7-1.9 5.3-2.8 7.6l-54.8 0 23.2-133.3c1.5-8.7-4.3-17-13-18.5s-17 4.3-18.5 13L328.1 304 272 304l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144-56.1 0L159.8 165.3c-1.5-8.7-9.8-14.5-18.5-13s-14.5 9.8-13 18.5L151.4 304l-54.8 0c-.9-2.3-1.8-4.9-2.8-7.6c-5.2-14.2-12.1-33.7-19-54.8c-6.9-21.2-13.7-43.8-18.8-64.4C50.9 156.1 48 138.9 48 128c0-26.5 21.5-48 48-48c17.7 0 33.3 9.6 41.6 24c4.7 8.1 13.6 12.7 22.8 11.9s17.3-6.9 20.5-15.6zM454.4 336.7L432 328l22.4 8.7s0 0 0 0s0 0 0 0l0-.1 .1-.3 .5-1.3c.4-1.1 1-2.7 1.8-4.8c1.6-4.1 3.8-10.1 6.4-17.3c5.3-14.6 12.4-34.6 19.5-56.4c7.1-21.8 14.3-45.7 19.7-67.8c5.3-21.7 9.4-43.5 9.4-60.6c0-53-43-96-96-96c-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0s-79.1 20.1-102.4 51.2c-16-12-36-19.2-57.6-19.2C43 32 0 75 0 128c0 17.1 4.1 38.9 9.4 60.6c5.4 22.2 12.6 46 19.7 67.8c7.1 21.8 14.2 41.9 19.5 56.4c2.7 7.3 4.9 13.2 6.4 17.3c.8 2.1 1.4 3.7 1.8 4.8l.5 1.3 .1 .3 0 .1s0 0 0 0s0 0 0 0L80 328l-22.4 8.7C61.2 345.9 70.1 352 80 352l352 0c9.9 0 18.8-6.1 22.4-15.3zM64 384l0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64-48 0 0 64c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-64-48 0z"]
};
const faHandBackPointRight = {
  prefix: 'far',
  iconName: 'hand-back-point-right',
  icon: [512, 512, [], "e1a1", "M512 176c0-35.3-28.7-64-64-64l-188.8 0c-3.6-5.2-7.6-10.2-11.9-14.9L228.8 76.8C212.1 58.5 188.5 48 163.7 48l-10.2 0C99.5 48 49.5 76.7 22.2 123.4L20.7 126C7.1 149.3 0 175.7 0 202.6L0 328c0 66.3 53.7 120 120 120l8 0 96 0c35.3 0 64-28.7 64-64c0-2.8-.2-5.6-.5-8.3c19.4-11 32.5-31.8 32.5-55.7c0-5.3-.7-10.5-1.9-15.5c20.2-10.8 33.9-32 33.9-56.5c0-2.7-.2-5.4-.5-8l96.5 0c35.3 0 64-28.7 64-64zm-64-16c8.8 0 16 7.2 16 16s-7.2 16-16 16l-136 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16l-8 0c-10.3 0-19.5 6.6-22.8 16.4s.1 20.6 8.3 26.8c3.9 3 6.4 7.6 6.4 12.8c0 8.8-7.2 16-16 16c-9.1 0-17.4 5.1-21.5 13.3s-3.2 17.9 2.3 25.1c2 2.7 3.2 6 3.2 9.6c0 8.8-7.2 16-16 16l-96 0-8 0c-39.8 0-72-32.2-72-72l0-125.4c0-18.4 4.9-36.5 14.2-52.4l-20-11.7 20 11.7 1.5-2.6c18.6-32 52.8-51.6 89.8-51.6l10.2 0c11.3 0 22 4.8 29.6 13.1L210.5 128 168 128c-8.8 0-16 7.2-16 16s7.2 16 16 16l78 0 2 0 200 0z"]
};
const faDove = {
  prefix: 'far',
  iconName: 'dove',
  icon: [512, 512, [128330], "f4ba", "M256.3 159c1-14.8 4.3-28.9 9.6-42C251.3 91.3 241.7 61.6 240.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8C190.2 22.2 174.9 44.5 161 76.1c13.4 29 36.1 50.6 63.1 66.9c10.5 6.3 21.4 11.6 32.2 16zM400 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM177.1 208c45.8 29 96.4 42.7 132 47c6.8 .8 13.7-1.3 18.8-5.9s8.1-11.1 8.1-18l0-63.2c0-30.9 25.1-56 56-56l61.8 0L436 138.7c-2.6 3.9-4 8.6-4 13.3l0 144c0 57.4-46.6 104-104 104l-58.4 0c-5.4 0-10.7 1.9-15 5.3L181.2 464c-62.2-.9-106.4-30.9-126.8-51.6l99.7-27.2c8.9-2.4 15.6-9.8 17.3-18.9s-2.1-18.3-9.5-23.7C125.4 316.3 80 267.5 80 184c0-31.8 3.9-55.5 8.9-73.1c20.4 43.4 53.2 74.9 88.2 97.1zM91.2 32c-9.9 0-19.4 4.9-25 13.6C52.7 66.3 32 106.2 32 184c0 77.3 31.8 131.1 66.1 166.7L29.5 369.4c-12.8 3.5-23 13.1-27.3 25.6S.1 421.4 8 432c22.2 29.6 84.5 80 176 80c9.1 0 17.9-3.1 25-8.8L278 448l50 0c83.9 0 152-68.1 152-152l0-136.7 25.9-38.9c4-6 6.1-13 6.1-20.1c0-20-16.2-36.3-36.3-36.3L392 64c-57.4 0-104 46.6-104 104l0 34.5c-26.3-6.1-57-17.3-85.2-35.1c-38.3-24.2-70.7-60-82.3-111.9C117.5 42.3 105.7 32 91.2 32z"]
};
const faSnowflakeDroplets = {
  prefix: 'far',
  iconName: 'snowflake-droplets',
  icon: [640, 512, [], "e5c1", "M320 0c13.3 0 24 10.7 24 24l0 46.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57 0 76.5 66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L469 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L493 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L368 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L493 328.2l28 16.2-22 42.7L469 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L344 297.6l0 76.5 57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23 0 46.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-46.1-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57 0-76.5-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l8.4-31.5-30.1 17.4-22-42.7 28-16.2-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L272 256l-66.2-38.2-77.8 20.9c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l31.5-8.4-37.1-21.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L171 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L296 214.4l0-76.5L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L296 24c0-13.3 10.7-24 24-24zM519.1 418.1l47.5-92.4c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5c0 35.3-28.7 64.3-64 64.3s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5zM54.7 325.7c1.8-3.5 5.4-5.7 9.3-5.7s7.5 2.2 9.3 5.7l47.5 92.4c4.7 9.1 7.1 19.3 7.1 29.5C128 483 99.3 512 64 512s-64-29-64-64.3c0-10.2 2.4-20.4 7.1-29.5l47.5-92.4z"]
};
const faBatteryEmpty = {
  prefix: 'far',
  iconName: 'battery-empty',
  icon: [576, 512, ["battery-0"], "f244", "M80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L80 144zM0 176c0-44.2 35.8-80 80-80l384 0c44.2 0 80 35.8 80 80l0 16c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 16c0 44.2-35.8 80-80 80L80 416c-44.2 0-80-35.8-80-80L0 176z"]
};
const faBattery0 = faBatteryEmpty;
const faGrid4 = {
  prefix: 'far',
  iconName: 'grid-4',
  icon: [448, 512, [], "e198", "M32 89.6L32 64l25.6 0 0 25.6L32 89.6zm57.6 16l0-57.6c0-8.8-7.2-16-16-16L16 32C7.2 32 0 39.2 0 48l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM16 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4L0 464c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zM32 209.1l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zM32 448l0-25.6 25.6 0 0 25.6L32 448zM151.5 89.6l0-25.6 25.6 0 0 25.6-25.6 0zm57.6 16l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9s0 0 0 0l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM135.5 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zm16-181.3l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zM270.9 64l25.6 0 0 25.6-25.6 0 0-25.6zm48.6 56c5.3-2.6 9-8.1 9-14.4l0-57.6c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6c0 0 0 0 0 0l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6zm0 33.1c-2.1-1-4.5-1.6-7-1.6c0 0 0 0 0 0l-57.6 0s0 0 0 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4zm0 119.5c-2.1-1-4.5-1.6-7-1.6l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4zm-7 117.8l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM270.9 183.5l25.6 0 0 25.6-25.6 0 0-25.6zm0 119.5l25.6 0 0 25.6-25.6 0 0-25.6zm0 119.5l25.6 0 0 25.6-25.6 0 0-25.6zM390.4 89.6l0-25.6L416 64l0 25.6-25.6 0zm57.6 16L448 48c0-8.8-7.2-16-16-16l-57.6 0c-8.8 0-16 7.2-16 16l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6c0 0 0 0 0 0l57.6 0s0 0 0 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4zm-16 45.9s0 0 0 0l-57.6 0s0 0 0 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zm0 119.5l-57.6 0c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 6.3 3.7 11.8 9 14.4c2.1 1 4.5 1.6 7 1.6l57.6 0c2.5 0 4.9-.6 7-1.6c5.3-2.6 9-8.1 9-14.4l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6zM374.4 390.4c-2.5 0-4.9 .6-7 1.6c-5.3 2.6-9 8.1-9 14.4l0 57.6c0 8.8 7.2 16 16 16l57.6 0c8.8 0 16-7.2 16-16l0-57.6c0-6.3-3.7-11.8-9-14.4c-2.1-1-4.5-1.6-7-1.6l-57.6 0zm16-181.3l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0zm0 119.5l0-25.6 25.6 0 0 25.6-25.6 0z"]
};
const faSocks = {
  prefix: 'far',
  iconName: 'socks',
  icon: [512, 512, [129510], "f696", "M288 48c0-17 5.3-32.8 14.4-45.8C297.9 .8 293 0 288 0L176 0c-26.5 0-48 21.5-48 48l0 186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54C12.8 362.2 0 389.1 0 417.5C0 469.7 42.3 512 94.5 512l6.9 0c22.6 0 44.6-7.6 62.5-21.5l12.9-10.1c-8.4-14.6-13.9-31-15.9-48.5l-26.6 20.8c-9.4 7.3-21 11.3-32.9 11.3l-6.9 0C68.8 464 48 443.2 48 417.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1l0-90.3 112 0 0-48L176 96l0-48 112 0zM368 0c-26.5 0-48 21.5-48 48l0 186.3c0 21.7-9.8 42.2-26.6 55.9l-66.5 54c-22.1 17.9-34.9 44.9-34.9 73.3c0 52.2 42.3 94.5 94.5 94.5l6.3 0c23.1 0 45.5-7.9 63.4-22.5l111.3-90.1c28.1-22.8 44.5-57.1 44.5-93.3L512 48c0-26.5-21.5-48-48-48L368 0zm0 48l96 0 0 48-96 0 0-48zm0 96l96 0 0 162.2c0 21.7-9.8 42.3-26.7 56L326 452.2c-9.4 7.6-21.1 11.8-33.2 11.8l-6.3 0c-25.7 0-46.5-20.8-46.5-46.5c0-14 6.3-27.2 17.2-36.1l66.5-54c28-22.8 44.3-57 44.3-93.1l0-90.3z"]
};
const faFaceSunglasses = {
  prefix: 'far',
  iconName: 'face-sunglasses',
  icon: [512, 512, [], "e398", "M256 464C141.1 464 48 370.9 48 256c0-16.3 1.9-32.2 5.4-47.4l3.9 23.3C61.2 255 81.2 272 104.7 272l78.7 0c23.5 0 43.5-17 47.3-40.1l6.6-39.9 37.3 0 6.6 39.9c3.9 23.1 23.9 40.1 47.3 40.1l78.7 0c23.5 0 43.5-17 47.3-40.1l3.9-23.3c3.6 15.2 5.4 31.1 5.4 47.4c0 114.9-93.1 208-208 208zM227.1 144c-8.7-9.8-21.4-16-35.8-16l-94.7 0c-1.6 0-3.2 .1-4.8 .2C129.9 79.4 189.3 48 256 48s126.1 31.4 164.1 80.2c-1.6-.2-3.2-.2-4.8-.2l-94.7 0c-14.4 0-27.1 6.2-35.8 16l-57.8 0zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM143.7 332.7c-9.7 9-10.4 24.2-1.4 33.9c22 23.8 60 49.4 113.6 49.4s91.7-25.5 113.6-49.4c9-9.7 8.4-24.9-1.4-33.9s-24.9-8.4-33.9 1.4C319.2 350.5 293.2 368 256 368s-63.2-17.5-78.4-33.9c-9-9.7-24.2-10.4-33.9-1.4z"]
};
const faInbox = {
  prefix: 'far',
  iconName: 'inbox',
  icon: [512, 512, [], "f01c", "M48 336l81.2 0 20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1l140.2 0c15.1 0 29-8.6 35.8-22.1L382.8 336l81.2 0 0 80c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-80zm406.5-48l-76.6 0c-15.1 0-29 8.6-35.8 22.1L321.2 352l-130.3 0-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1l-76.6 0 49-195.9C108.2 85 114.6 80 122 80L390 80c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32L122 32C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
};
const faSquare0 = {
  prefix: 'far',
  iconName: 'square-0',
  icon: [448, 512, [], "e255", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32c53 0 96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64c0-53 43-96 96-96zm-48 96l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z"]
};
const faSection = {
  prefix: 'far',
  iconName: 'section',
  icon: [256, 512, [], "e447", "M48.4 90.6c2.8-15.9 12.5-27.3 29-34.6c17.6-7.7 42.8-10.5 73.1-5.6L153.7 30l-3.3 20.5c9.7 1.6 39.9 7.6 49.1 10.1c12.8 3.5 26-4 29.5-16.8s-4-26-16.8-29.5C200.7 11.1 168.6 4.8 158.1 3C121.8-2.8 86.5-.5 58 12.1C28.6 25.1 6.7 49 .9 83.3c-.1 .4-.1 .8-.2 1.2c-2.2 19.5 .4 37 7.9 52.3c7.4 15.2 18.8 26.6 31.4 35.3c2.4 1.7 4.9 3.3 7.4 4.8C24.2 189.8 6.8 210.7 1.7 239.4c-.1 .4-.1 .9-.2 1.3c-2.3 18.8 .4 35.8 8.1 50.7c7.6 14.6 19.1 25.5 31.6 33.7c22.9 15.1 53.3 23.9 79.2 31.5l3.6 1c29 8.5 52.3 15.7 67.7 26.7c7.1 5.1 11.4 10.2 13.7 15.6c2.3 5.3 3.6 12.8 1.6 24.2c-2.5 14.2-11.6 25.1-28.5 32.2c-17.7 7.4-43.1 9.9-73.3 5.3c-14.9-2.4-40.4-10.8-61-17.7c-4.5-1.5-8.9-2.9-12.7-4.2c-12.6-4.1-26.1 2.8-30.2 15.4s2.8 26.1 15.4 30.2c3 1 6.5 2.1 10.5 3.5c0 0 0 0 0 0s0 0 0 0s0 0 0 0c20.3 6.7 51.4 17.1 70.6 20.2l.1 0c36 5.5 70.9 3.3 99.1-8.5c29-12.1 51.4-34.8 57.3-68.1c3.4-19 1.9-36.3-4.8-51.8c-6.7-15.3-17.6-26.8-29.8-35.6c0 0 0 0 0 0c17.7-13.5 30.5-32.7 34.7-58c3.3-19.7 1.8-37.5-4.7-53.4c-6.5-15.8-17.3-27.9-29.6-37.2c-23.2-17.5-55.1-27.4-81.8-35.6l-.7-.2c-29.3-9-53.3-16.5-69.9-28.1c-7.7-5.4-12.7-11-15.7-17c-2.8-5.8-4.6-13.7-3.4-25.1zM163.2 319.3c-8.6-2.8-17-5.2-25-7.6l-.8-.2C108.3 303 84.2 295.9 67.6 285c-7.8-5.1-12.6-10.3-15.4-15.7c-2.6-5-4.3-11.9-3.2-22.1c2.7-13.9 11.7-24.6 28.4-31.6c13-5.4 30.2-8.3 50.5-7.5c26.9 8.4 48.6 15.8 63.1 26.8c7.1 5.4 11.6 10.9 14.1 17.1c2.5 6.1 3.9 14.7 1.8 27.2c-3.3 19.4-17.2 33.8-43.7 40.1z"]
};
const faSquareThisWayUp = {
  prefix: 'far',
  iconName: 'square-this-way-up',
  icon: [448, 512, ["box-up"], "f49f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM120 352l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM328 192l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-25.5 0c-8 0-14.5-6.5-14.5-14.5c0-3.5 1.3-7 3.7-9.6L286.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5L328 192zM80 177.5c0-3.5 1.3-7 3.7-9.6L126.2 120c4.5-5.1 11-8 17.8-8s13.2 2.9 17.8 8l42.6 47.9c2.4 2.7 3.7 6.1 3.7 9.6c0 8-6.5 14.5-14.5 14.5L168 192l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-25.5 0c-8 0-14.5-6.5-14.5-14.5z"]
};
const faBoxUp = faSquareThisWayUp;
const faGaugeHigh = {
  prefix: 'far',
  iconName: 'gauge-high',
  icon: [512, 512, [62461, "tachometer-alt", "tachometer-alt-fast"], "f625", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 408c30.9 0 56-25.1 56-56c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM112 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm320-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTachometerAlt = faGaugeHigh;
const faTachometerAltFast = faGaugeHigh;
const faSquareAmpersand = {
  prefix: 'far',
  iconName: 'square-ampersand',
  icon: [448, 512, [], "e260", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm184 95.6c0 4.1 1.6 8.1 4.6 11L203 217.1l23.6-17.3c3.4-2.5 5.4-6.4 5.4-10.6c0-7.3-5.9-13.2-13.2-13.2l-19.2 0c-8.6 0-15.6 7-15.6 15.6zm71 46.9l-17.6 12.9 28.7 28.7 26.2-37.8c7.5-10.9 22.5-13.6 33.4-6.1s13.6 22.5 6.1 33.4l-31.1 45L329 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-22.4-22.4c-15.1 18.5-37.8 29.4-62 29.4l-32.2 0c-36.7 0-66.5-29.8-66.5-66.5c0-21.2 10.1-41.1 27.2-53.6l24.7-18.1-9.2-9.2c-11.9-11.9-18.6-28.1-18.6-45c0-35.1 28.5-63.6 63.6-63.6l19.2 0c33.8 0 61.2 27.4 61.2 61.2c0 19.5-9.3 37.8-25 49.3zm-87.5 64.1c-4.7 3.5-7.5 9-7.5 14.9c0 10.2 8.3 18.5 18.5 18.5l32.2 0c10.5 0 20.3-5.2 26.3-13.8l1.4-2-40.1-40.1-30.7 22.5z"]
};
const faEnvelopeOpenText = {
  prefix: 'far',
  iconName: 'envelope-open-text',
  icon: [512, 512, [], "f658", "M392 48L120 48c-4.4 0-8 3.6-8 8l0 169.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8L64 56C64 25.1 89.1 0 120 0L392 0c30.9 0 56 25.1 56 56l0 130.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2 400 56c0-4.4-3.6-8-8-8zM160 120c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM48 276.2L48 456c0 4.4 3.6 8 8 8l400 0c4.4 0 8-3.6 8-8l0-179.8L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9L512 456c0 30.9-25.1 56-56 56L56 512c-30.9 0-56-25.1-56-56L0 237.9z"]
};
const faLampDesk = {
  prefix: 'far',
  iconName: 'lamp-desk',
  icon: [512, 512, [], "e014", "M347.3 97.9L309.3 59.9C301.6 52.3 291.3 48 280.6 48C258.2 48 240 66.2 240 88.6c0 10.8 4.3 21.1 11.9 28.7l38.1 38.1c9 9 14.1 21.2 14.1 33.9l0 60.1L441.4 112l-60.1 0c-12.7 0-24.9-5.1-33.9-14.1zm-4.1-72L381.3 64 480 64c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-73.5 73.5-45.1 45.1-73.5 73.5c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-98.7-13.7-13.7c-.6 .7-1.3 1.4-2 2.1l-93.1 86L204.4 464 360 464c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l130.5 0L96.9 262.6c-2.5-8.7 .1-18.1 6.8-24.2l104-96c.5-.5 1-.9 1.5-1.3C198.1 126 192 107.6 192 88.6C192 39.7 231.7 0 280.6 0c23.5 0 46 9.3 62.6 25.9zM432 288c-14.7 0-27.8-6.6-36.6-16.9l67.7-67.7c10.3 8.8 16.9 21.9 16.9 36.6c0 26.5-21.5 48-48 48z"]
};
const faHospital = {
  prefix: 'far',
  iconName: 'hospital',
  icon: [640, 512, [127973, 62589, "hospital-alt", "hospital-wide"], "f0f8", "M232 0c-39.8 0-72 32.2-72 72l0 8L72 80C32.2 80 0 112.2 0 152L0 440c0 39.8 32.2 72 72 72l.2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0s0 0 0 0l272 0 8 0s0 0 0 0l104 0c39.8 0 72-32.2 72-72l0-288c0-39.8-32.2-72-72-72l-88 0 0-8c0-39.8-32.2-72-72-72L232 0zM480 128l88 0c13.3 0 24 10.7 24 24l0 40-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 104c0 13.3-10.7 24-24 24l-88 0 0-128 0-208zM72 128l88 0 0 336c0 0 0 0-.1 0l-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0c-13.2 0-24-10.7-24-24l0-104 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-48 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-40c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 264 0 128-64 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-64 0 0-392zm88 24l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faHospitalAlt = faHospital;
const faHospitalWide = faHospital;
const faPollPeople = {
  prefix: 'far',
  iconName: 'poll-people',
  icon: [640, 512, [], "f759", "M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM592 80l0 64-112 0 0-64 112 0zM272 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L272 32zM592 368l0 64-240 0 0-64 240 0zM272 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-320 0zM64 128c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0zm64 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 416c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-32 0z"]
};
const faWhiskeyGlassIce = {
  prefix: 'far',
  iconName: 'whiskey-glass-ice',
  icon: [512, 512, ["glass-whiskey-rocks"], "f7a1", "M50.5 80l411 0L414.2 404.6c-2.3 15.7-15.8 27.4-31.7 27.4l-253 0c-15.9 0-29.4-11.7-31.7-27.4L50.5 80zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5l253 0c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32L32 32zM255.4 179.3l.6-.6c-5-1.8-10.4-2.7-16-2.7l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l73.8 0-19-19c-8.5-8.5-14.7-18.4-18.6-29L144 320l0-96 66.7 0 44.7-44.7zM312 235.9l56.6 56.6L312 349l-56.6-56.6L312 235.9zm-33.9-33.9l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9L278.1 383c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9l-56.6-56.6c-18.7-18.7-49.1-18.7-67.9 0z"]
};
const faGlassWhiskeyRocks = faWhiskeyGlassIce;
const faWineBottle = {
  prefix: 'far',
  iconName: 'wine-bottle',
  icon: [512, 512, [], "f72f", "M391 7c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9c-7.5 7.5-18.8 9-27.9 4.4l-72.5 72.5c-8 8-10.9 19.6-9.6 30.9c4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0l36-36L88.7 312.7l-36 36L18.7 314.7 180.2 153.3c28.1-28.1 66.3-40.2 103-36.2c11.3 1.2 22.9-1.6 30.9-9.6l72.5-72.5c-4.6-9-3.1-20.3 4.4-27.9zM200.7 200.7L311.3 311.3l13.5-13.5c17.4-17.4 24.9-41 22.5-63.8c-2.4-21.8 2.6-49.3 23.4-70l70.7-70.7L418.7 70.6l-70.7 70.7c-20.8 20.8-48.2 25.8-70 23.4c-22.9-2.5-46.4 5-63.8 22.4l-13.5 13.5z"]
};
const faChessRook = {
  prefix: 'far',
  iconName: 'chess-rook',
  icon: [448, 512, [9820], "f447", "M80 80l0 112c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352l-48.3 0 9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192L32 72c0-22.1 17.9-40 40-40l304 0c22.1 0 40 17.9 40 40l0 120c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85-48.3 0-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4l0-112-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24-64 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24L80 80zm4.7 384l278.7 0-16.6-32-245.6 0L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8L72.8 512C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384l265 0zM208 288c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0z"]
};
const faUserBountyHunter = {
  prefix: 'far',
  iconName: 'user-bounty-hunter',
  icon: [448, 512, [], "e2bf", "M323 120C309.4 78 270 48 224 48s-85.4 30-99 72L323 120zm5.5 36.4L248 171.5l0 98.4 9.5-1.9c7.6-49.7 42.9-81.5 71.9-97.8l-.9-13.8zm-209 0l-.9 13.8c29 16.3 64.2 48.1 71.9 97.8l9.5 1.9 0-98.4-80.5-15.1zM96 70C123.1 27.7 170.5 0 224 0c80.1 0 146.5 62.2 151.7 142.2L383 256.5c1.3 20-12.4 37.9-32.1 41.8L250.1 318.4c-5.2 1-10.4 1.6-15.7 1.6l-20.9 0c-5.3 0-10.5-.5-15.7-1.6L97 298.3c-16.2-3.2-28.4-16-31.4-31.6c-1-3.4-1.6-7-1.6-10.7L64 16C64 7.2 71.2 0 80 0L96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l0 38zM313.6 400l-179.2 0c-40 0-73.6 27.1-83.5 64L160 464l59.2-44.4c2.8-2.1 6.8-2.1 9.6 0L288 464l109.1 0c-9.9-36.9-43.5-64-83.5-64zM0 486.4C0 412.2 60.2 352 134.4 352l179.2 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4z"]
};
const faBarsStaggered = {
  prefix: 'far',
  iconName: 'bars-staggered',
  icon: [512, 512, ["reorder", "stream"], "f550", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24L24 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24z"]
};
const faReorder = faBarsStaggered;
const faStream = faBarsStaggered;
const faDiagramSankey = {
  prefix: 'far',
  iconName: 'diagram-sankey',
  icon: [576, 512, [], "e158", "M329.9 80c-2.8 0-5.4 1.5-6.8 3.8L253.8 197.2c-10.2 16.6-28.3 26.8-47.8 26.8L24 224c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0c2.8 0 5.4-1.5 6.8-3.8L282.2 58.8C292.3 42.2 310.4 32 329.9 32L552 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L329.9 80zm-124 240l61.7 108c1.4 2.5 4.1 4 6.9 4L552 432c13.3 0 24 10.7 24 24s-10.7 24-24 24l-277.4 0c-20.1 0-38.7-10.8-48.6-28.2L150.6 320 24 320c-13.3 0-24-10.7-24-24s10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-346.1 0z"]
};
const faCloudHailMixed = {
  prefix: 'far',
  iconName: 'cloud-hail-mixed',
  icon: [512, 512, [], "f73a", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM81.5 353.9c-12.2-5.2-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24c5.2-12.2-.4-26.3-12.6-31.5zm120 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zm232 0c-12.2-5.2-26.3 .4-31.5 12.6l-48 112c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l48-112c5.2-12.2-.4-26.3-12.6-31.5zM326.1 385.5c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6l-10.3 24c-5.2 12.2 .4 26.3 12.6 31.5s26.3-.4 31.5-12.6l10.3-24zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm256-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCircleUpLeft = {
  prefix: 'far',
  iconName: 'circle-up-left',
  icon: [512, 512, [], "e128", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 313.4c0 12.5 10.1 22.6 22.6 22.6c6 0 11.8-2.4 16-6.6L232 296l66.3 66.3c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7l36.7-36.7c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7L296 232l33.4-33.4c4.2-4.2 6.6-10 6.6-16c0-12.5-10.1-22.6-22.6-22.6L176 160c-8.8 0-16 7.2-16 16l0 137.4z"]
};
const faDharmachakra = {
  prefix: 'far',
  iconName: 'dharmachakra',
  icon: [512, 512, [9784], "f655", "M232.4 24.7l.4 8.5c-44.4 4.6-85 22.1-117.9 48.8l-5.7-6.3c-9.1-10-24.6-10.3-34.2-.8s-9.2 25.1 .8 34.2l6.3 5.7c-26.7 32.9-44.3 73.4-48.8 117.9l-8.5-.4C11.3 231.8 0 242.5 0 256s11.3 24.2 24.7 23.6l8.5-.4c4.6 44.4 22.1 85 48.8 117.9l-6.3 5.7c-10 9.1-10.3 24.6-.8 34.2s25.1 9.2 34.2-.8l5.7-6.3c32.9 26.7 73.4 44.3 117.9 48.8l-.4 8.5c-.6 13.5 10.1 24.7 23.6 24.7s24.2-11.3 23.6-24.7l-.4-8.5c44.4-4.6 85-22.1 117.9-48.8l5.7 6.3c9.1 10 24.6 10.3 34.2 .8s9.2-25.1-.8-34.2l-6.3-5.7c26.7-32.9 44.3-73.4 48.8-117.9l8.5 .4c13.5 .6 24.7-10.1 24.7-23.6s-11.3-24.2-24.7-23.6l-8.5 .4c-4.6-44.4-22.1-85-48.8-117.9l6.3-5.7c10-9.1 10.3-24.6 .8-34.2s-25.1-9.2-34.2 .8L397.1 82c-32.9-26.7-73.4-44.3-117.9-48.8l.4-8.5C280.2 11.3 269.5 0 256 0s-24.2 11.3-23.6 24.7zM147.3 394.4l54.2-59.4c10.9 7.5 23.5 12.9 37.1 15.4l-3.7 80.3c-32.8-3.9-62.9-16.9-87.6-36.3zm29.6-84l-59.4 54.2C98.1 340 85.2 309.9 81.2 277.1l80.3-3.7c2.5 13.6 7.8 26.1 15.4 37.1zM81.2 234.9c3.9-32.8 16.9-62.9 36.3-87.6l59.4 54.2c-7.5 10.9-12.9 23.5-15.4 37.1l-80.3-3.7zm120.3-58l-54.2-59.4c24.7-19.4 54.8-32.4 87.6-36.3l3.7 80.3c-13.6 2.5-26.1 7.8-37.1 15.4zm108.9 0c-10.9-7.5-23.5-12.9-37.1-15.4l3.7-80.3c32.8 3.9 62.9 16.9 87.6 36.3l-54.2 59.4zm54.2 217.5c-24.7 19.4-54.8 32.4-87.6 36.3l-3.7-80.3c13.6-2.5 26.1-7.8 37.1-15.4l54.2 59.4zm29.8-29.8l-59.4-54.2c7.5-10.9 12.9-23.5 15.4-37.1l80.3 3.7c-3.9 32.8-16.9 62.9-36.3 87.6zm0-217.4c19.4 24.7 32.4 54.8 36.3 87.6l-80.3 3.7c-2.5-13.6-7.8-26.1-15.4-37.1l59.4-54.2zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faObjectsAlignLeft = {
  prefix: 'far',
  iconName: 'objects-align-left',
  icon: [512, 512, [], "e3be", "M0 24C0 10.7 10.7 0 24 0S48 10.7 48 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 24zM176 176l288 0 0-64-288 0 0 64zm-48-64c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48l0-64zm48 288l160 0 0-64-160 0 0 64zm-48-64c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-64z"]
};
const faOilCanDrip = {
  prefix: 'far',
  iconName: 'oil-can-drip',
  icon: [640, 512, [], "e205", "M352 88c0 13.3-10.7 24-24 24l-48 0 0 48 88.9 0c9.9 0 19.7 2.3 28.6 6.8L448 192l139.8-30 2.1-.4 11.3-2.4 13.9-3c18.1-3.9 30.7 17.6 18.4 31.5l-9.4 10.6-7.6 8.6-1.4 1.6L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7L144 416c-26.5 0-48-21.5-48-48l0-21.3-67.5-30C11.2 309 0 291.8 0 272.8L0 208c0-26.5 21.5-48 48-48l48 0 48 0 3.2 0 84.8 0 0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24zM458.7 242.1c-11.4 2.4-23.2 .9-33.6-4.3l-50.5-25.2c-1.8-.9-3.7-1.4-5.7-1.4l-221.7 0 0 153.6 255.9 0c3.7 0 7.2-1.6 9.6-4.3L530.8 226.6l-72.1 15.4zM96 211.2l0-3.2-48 0 0 64.8 48 21.3 0-82.9zM592 448c-26.5 0-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8c5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400c0 32-21.5 48-48 48z"]
};
const faFaceSmilingHands = {
  prefix: 'far',
  iconName: 'face-smiling-hands',
  icon: [640, 512, [], "e396", "M320 352c-27.4 0-48.6-9.4-64-20.9l0 52.9 0 2.5c18 8.1 39.4 13.5 64 13.5s46-5.4 64-13.5l0-2.5 0-52.9c-15.4 11.5-36.6 20.9-64 20.9zM112 252.3C114 139.1 206.4 48 320 48s206 91.1 208 204.3c13.3-11.9 31.7-15.2 47.7-9.6C568.7 107.5 456.9 0 320 0S71.3 107.5 64.3 242.6c16-5.5 34.4-2.3 47.7 9.6zm139 200c-4.6 15.8-12.2 30.4-22.1 43c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7c-9.9-12.6-17.5-27.2-22.1-43c-21.6 7.6-44.8 11.7-69 11.7s-47.4-4.1-69-11.7zm30.6-223.5s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm129.7 70.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-79 79c-5 5-13.7 1.5-13.7-5.7l0-19.7c0-11-9-20-20-20s-20 9-20 20l0 53.6 0 32.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l56.8-56.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L593.4 424c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L561.4 392c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l67.3-67.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L529.4 360c-2.6 2.6-6.8 2.6-9.4 0s-2.6-6.8 0-9.4l51.3-51.3zM68.7 276.7c-6.2 6.2-6.2 16.4 0 22.6L120 350.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L43.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L88 382.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L56 414.6c2.6 2.6 2.6 6.8 0 9.4s-6.8 2.6-9.4 0L27.3 404.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.8 56.8C79.3 502 103.6 512 128.8 512c52.6 0 95.2-42.6 95.2-95.2l0-32.8 0-53.6c0-11-9-20-20-20s-20 9-20 20l0 19.7c0 7.1-8.6 10.7-13.7 5.7l-79-79c-6.2-6.2-16.4-6.2-22.6 0z"]
};
const faBroccoli = {
  prefix: 'far',
  iconName: 'broccoli',
  icon: [512, 512, [129382], "e3e2", "M256 0c-37.2 0-69.5 21.2-85.4 52.1C162.2 49.4 153.3 48 144 48c-48.6 0-88 39.4-88 88c0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96l320 0c53 0 96-43 96-96c0-40.8-25.5-75.7-61.4-89.6c3.5-9.5 5.4-19.7 5.4-30.4c0-48.6-39.4-88-88-88c-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zM208.4 89.7C211.5 66.2 231.6 48 256 48s44.5 18.2 47.6 41.7c1.1 8.6 6.9 16 15 19.2s17.3 1.8 24.1-3.8c6.9-5.7 15.7-9.1 25.4-9.1c22.1 0 40 17.9 40 40c0 12-5.3 22.8-13.7 30.2c-7.8 6.8-10.4 17.9-6.3 27.4s13.7 15.4 24.1 14.6c1.3-.1 2.6-.2 4-.2c26.5 0 48 21.5 48 48s-21.5 48-48 48L96 304c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.3 0 2.7 .1 4 .2c10.3 .8 20-5 24.1-14.6s1.5-20.6-6.3-27.4C109.3 158.8 104 148 104 136c0-22.1 17.9-40 40-40c9.7 0 18.5 3.4 25.4 9.1c6.7 5.5 15.9 7 24.1 3.8s13.8-10.6 15-19.2zM192.2 490.3c5 12.8 17.1 21.7 30.9 21.7l65.9 0c13.8 0 25.9-8.9 30.9-21.7c17.6-45.3 39.6-82.1 56.1-106.3L280 384l-16.8 33.7c-2.9 5.9-11.4 5.9-14.3 0L232 384l-95.9 0c16.5 24.2 38.5 60.9 56.1 106.3z"]
};
const faRouteInterstate = {
  prefix: 'far',
  iconName: 'route-interstate',
  icon: [512, 512, [], "f61b", "M64 192l383.3 0c-3.3 42-12.4 79.6-27.6 113.3C391 369 338.9 421.2 255.5 461.7c-84.6-37.1-136.4-89.1-164.6-153.4C75.7 273.8 67 235.1 64 192zM272.6 6c-10.2-6.1-23-6.1-33.2 0c-53.2 31.8-107 33.5-178.8 20c-17.7-3.3-35 8.7-37.7 26.9C8 156.5 12.5 249.5 46.9 327.6c34.7 78.9 98.6 139.8 196.5 181.1c8.3 3.5 17.8 3.3 26-.5c95.4-44.7 158.9-105.4 194.1-183.2c34.9-77.2 40.4-168.5 25.5-272.2c-2.6-18.2-19.9-30.2-37.7-26.9C379.6 39.5 325.8 37.8 272.6 6z"]
};
const faEarMuffs = {
  prefix: 'far',
  iconName: 'ear-muffs',
  icon: [640, 512, [], "f795", "M320 48c-83.1 0-151.4 63.4-159.3 144.4c-2.9-.3-5.8-.4-8.7-.4c-14.4 0-27.9 3.4-39.9 9.5C115.5 89.7 207.3 0 320 0S524.5 89.7 527.9 201.5c-12-6.1-25.5-9.5-39.9-9.5c-3 0-5.9 .1-8.7 .4C471.4 111.4 403.1 48 320 48zM480 224.6c2.6-.4 5.3-.6 8-.6c12 0 23.2 3.8 32.3 10.2c5-1.5 10.3-2.2 15.7-2.2c19.9 0 37.5 10.4 47.4 26.1c23.4 6.7 40.6 28.3 40.6 53.9c0 5.1-.7 10.1-2 14.9c11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9c0 25.6-17.2 47.2-40.6 53.9C573.5 493.6 555.9 504 536 504c-5.5 0-10.7-.8-15.7-2.2C511.2 508.2 500 512 488 512c-30.9 0-56-25.1-56-56c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-11.9 3.7-22.9 10-32c-6.3-9.1-10-20.1-10-32c0-10.2 2.7-19.8 7.5-28c-4.8-8.2-7.5-17.8-7.5-28c0-28.2 20.9-51.6 48-55.4zM152 224c2.7 0 5.4 .2 8 .6c27.1 3.9 48 27.2 48 55.4c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 11.9-3.7 22.9-10 32c6.3 9.1 10 20.1 10 32c0 10.2-2.7 19.8-7.5 28c4.8 8.2 7.5 17.8 7.5 28c0 30.9-25.1 56-56 56c-12 0-23.2-3.8-32.3-10.2c-5 1.5-10.3 2.2-15.7 2.2c-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1 .7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9c0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7 .8 15.7 2.2C128.8 227.8 140 224 152 224zm7 108c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-4.4-3.6-8-8-8c-1.8 0-3.3 .5-4.6 1.4c-12 8.4-27.1 11-41.2 6.9c-.7-.2-1.4-.3-2.3-.3c-2.8 0-5.3 1.4-6.8 3.8c-6.3 10-16.1 17.3-27.4 20.5c-3.4 1-5.8 4.1-5.8 7.7c0 .8 .1 1.5 .3 2.2c4.8 17.3-.5 35.8-13.7 48c-1.7 1.5-2.6 3.6-2.6 5.9s.9 4.4 2.6 5.9c13.2 12.2 18.5 30.7 13.7 48c-.2 .6-.3 1.3-.3 2.2c0 3.6 2.4 6.7 5.8 7.7c11.4 3.2 21.1 10.5 27.4 20.5c1.5 2.4 4 3.8 6.8 3.8c.9 0 1.6-.1 2.3-.3c14-4.1 29.2-1.6 41.2 6.9c1.3 .9 2.8 1.4 4.6 1.4c4.4 0 8-3.6 8-8c0-1.5-.4-2.8-1-4c-8.6-14.9-8.6-33.2 0-48.1c.7-1.1 1-2.4 1-4c0-1.8-.5-3.3-1.4-4.5c-11.5-16.5-11.5-38.4 0-54.9c.9-1.3 1.4-2.8 1.4-4.5c0-1.5-.4-2.8-1-4zm321-52c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 1.8 .5 3.3 1.4 4.5c11.5 16.5 11.5 38.4 0 54.9c-.9 1.3-1.4 2.8-1.4 4.5c0 1.5 .4 2.8 1 4c8.6 14.9 8.6 33.2 0 48.1c-.7 1.1-1 2.4-1 4c0 4.4 3.6 8 8 8c1.8 0 3.3-.5 4.6-1.4c12-8.4 27.1-11 41.2-6.9c.7 .2 1.4 .3 2.3 .3c2.8 0 5.3-1.4 6.8-3.8c6.3-10 16.1-17.3 27.4-20.5c3.4-1 5.8-4.1 5.8-7.7c0-.8-.1-1.5-.3-2.2c-4.7-17.3 .5-35.8 13.7-48c1.7-1.5 2.6-3.6 2.6-5.9s-.9-4.4-2.6-5.9c-13.2-12.2-18.5-30.7-13.7-48c.2-.6 .3-1.3 .3-2.2c0-3.6-2.4-6.7-5.8-7.7c-11.4-3.2-21.1-10.5-27.4-20.5c-1.5-2.4-4-3.8-6.8-3.8c-.9 0-1.6 .1-2.3 .3c-14 4.1-29.2 1.6-41.2-6.9c-1.3-.9-2.8-1.4-4.6-1.4c-4.4 0-8 3.6-8 8z"]
};
const faHotdog = {
  prefix: 'far',
  iconName: 'hotdog',
  icon: [512, 512, [127789], "f80f", "M496.2 208.2l-34 34c1.2 1.7 1.9 3.7 1.9 5.8c0 2.6-1 5.2-2.9 7L255 461.1c-1.9 1.9-4.4 2.9-7 2.9c-2.1 0-4.1-.7-5.8-1.9l-34 34c10.7 10.2 25 15.8 39.8 15.8c15.4 0 30.1-6.1 41-17L495 289c10.9-10.9 17-25.6 17-41c0-14.8-5.7-29.1-15.8-39.8zM15.8 303.8l34-34c-1.2-1.7-1.9-3.7-1.9-5.8c0-2.6 1-5.2 2.9-7L17 223 50.9 257 257 50.9c1.9-1.9 4.4-2.9 7-2.9c2.1 0 4.1 .7 5.8 1.9l34-34C293.1 5.7 278.8 0 264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8zM447.6 143.6l-304 304c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l304-304c21.9-21.9 57.3-21.9 79.2 0s21.9 57.3 0 79.2zm33.9 33.9c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-7 7-12.5 10.8-17 13.1c-4.5 2.3-8.5 3.4-13.6 4.7l-1.5 .4c-4.7 1.2-10.9 2.7-17.3 5.6c-7.4 3.4-14.8 8.4-22.7 16.3c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.5 7.8-12.4 9.1c-3 1.3-5.8 1.7-10.6 2.4l-.4 .1c-4.6 .6-10.9 1.6-18 4.5c-7.4 3.1-14.8 8.1-22.6 15.9c-16.2 16.2-20.5 30.7-24 42.7c0 0 0 0 0 .1c-3.1 10.6-5.5 18.8-16 29.2c-5.5 5.5-9.7 8.1-13.3 9.8c-3.6 1.6-6.9 2.5-12 3.7l-1.2 .3c-5.6 1.4-12.6 3.2-20.4 7.3c-7.9 4-16 9.9-25 18.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1c4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4s0 0 0 0c4.7-1.2 10.9-2.7 17.3-5.6c7.4-3.4 14.8-8.4 22.7-16.3c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.5-7.8 12.4-9.1c3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5c7.4-3.1 14.8-8.1 22.6-15.9c16.2-16.2 20.5-30.7 24-42.7c0 0 0 0 0-.1c3.1-10.6 5.5-18.8 16-29.2c5.5-5.5 9.7-8.1 13.3-9.8c3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3c7.9-4 16-9.9 25-18.9z"]
};
const faTransporterEmpty = {
  prefix: 'far',
  iconName: 'transporter-empty',
  icon: [512, 512, [], "e046", "M96 488c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24z"]
};
const faPersonWalkingWithCane = {
  prefix: 'far',
  iconName: 'person-walking-with-cane',
  icon: [512, 512, ["blind"], "f29d", "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 32c-34.8 0-66.3 20.5-80.4 52.3l-47.1 106c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L120 211.1l0 68.7c0 17.8 8.5 34.6 22.9 45.2L240 396.2l0 91.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-95.9c0-12.7-6.1-24.7-16.3-32.3L240 336.6l0-129.4 68 102c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3L271 167.2c-16.3-24.5-43.8-39.2-73.2-39.2l-36.2 0zM168 279.8L168 176l24 0 0 125.4-20.7-15.2c-2.1-1.5-3.3-3.9-3.3-6.5zm175.4 70.1L450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L370.4 332.6c-3.2 3.7-7 7.1-11.3 10c-5 3.3-10.3 5.7-15.7 7.3zM96.7 482.4c-3.1 12.9 4.8 25.8 17.7 28.9s25.8-4.8 28.9-17.7l26.3-109.4-42-30.8-31 129z"]
};
const faBlind = faPersonWalkingWithCane;
const faAngle90 = {
  prefix: 'far',
  iconName: 'angle-90',
  icon: [448, 512, [], "e08d", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 456c0 13.3 10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L48 432 48 56zM96 97.6l0 48.3c31 3.6 60.4 12.5 87.4 25.7l25.3-41.1C174.2 113 136.2 101.6 96 97.6zm115.2 89.7c32.6 21 60.5 48.9 81.5 81.5l40.9-25.2c-25-39-58.2-72.2-97.2-97.2l-25.2 40.9zM334.1 384l48.3 0c-4-40.2-15.4-78.2-32.9-112.6l-41.1 25.3c13.2 26.9 22 56.3 25.7 87.4z"]
};
const faRectangleTerminal = {
  prefix: 'far',
  iconName: 'rectangle-terminal',
  icon: [512, 512, [], "e236", "M448 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm38.3 119.8c-9 9.8-8.3 25 1.5 33.9L180.5 256l-76.7 70.3c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5l96-88c5-4.5 7.8-11 7.8-17.7s-2.8-13.1-7.8-17.7l-96-88c-9.8-9-25-8.3-33.9 1.5zM248 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faKite = {
  prefix: 'far',
  iconName: 'kite',
  icon: [640, 512, [129665], "f6f4", "M368 48l216 0c2.2 0 4.2 .9 5.7 2.3L480 160 592 272l0 6.3c0 3.7-2.6 7-6.3 7.8L289.8 351.9c-.3-.3-.5-.6-.8-.9L480 160 368 48zm-61-4.1L234.1 372l-87.5 87.5c-2.9 2.9-6.9 4.6-11 4.6c-8.6 0-15.6-7-15.6-15.6l0-88.6-24-12-24 12 0 88.6c0 35.1 28.5 63.6 63.6 63.6c16.9 0 33-6.7 45-18.6L268 405.9 596.1 333c25.6-5.7 43.9-28.4 43.9-54.7L640 56c0-30.9-25.1-56-56-56L361.7 0c-26.2 0-49 18.2-54.7 43.9zM0 152c0 13.3 10.7 24 24 24l8 0c22.1 0 40 17.9 40 40l0 68L18.7 257.4c-1.8-.9-3.8-1.4-5.8-1.4C5.8 256 0 261.8 0 268.9l0 70.1C0 346.2 5.8 352 12.9 352c2 0 4-.5 5.8-1.4L72 324s0 0 0 0l9.7-4.8c4.5-2.3 9.4-3.4 14.3-3.4l.5 0c3.5 .1 7 .7 10.4 1.9c1.2 .4 2.3 .9 3.4 1.5c0 0 0 0 0 0L120 324l53.3 26.6c1.8 .9 3.8 1.4 5.8 1.4c7.1 0 12.9-5.8 12.9-12.9l0-70.1c0-7.1-5.8-12.9-12.9-12.9c-2 0-4 .5-5.8 1.4L120 284l0-68c0-48.6-39.4-88-88-88l-8 0c-13.3 0-24 10.7-24 24z"]
};
const faDrum = {
  prefix: 'far',
  iconName: 'drum',
  icon: [512, 512, [129345], "f569", "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208L0 368c0 24.9 14.9 44.5 33.2 58.7c18.5 14.3 43.6 25.5 72 33.9C147.4 473 199.8 480 256 480s108.6-7 150.8-19.5c28.4-8.4 53.5-19.6 72-33.9C497.1 412.5 512 392.9 512 368l0-160c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6zM424 293.2c15-5.6 28.4-12 40-19l0 93.8c0 4.1-2.3 11.2-14.5 20.7c-6.5 5-15 10-25.5 14.6l0-110.1zM280 319.5c34.4-1.3 66.9-5.6 96-12.2l0 111.7c-27.9 6.7-60.5 11.1-96 12.5l0-112zM136 307.4c29.1 6.6 61.6 10.8 96 12.2l0 112c-35.5-1.4-68.1-5.8-96-12.5l0-111.7zM48 274.2c11.6 7 25 13.4 40 19l0 110.1c-10.4-4.7-18.9-9.6-25.5-14.6C50.3 379.2 48 372.1 48 368l0-93.8z"]
};
const faScrubber = {
  prefix: 'far',
  iconName: 'scrubber',
  icon: [512, 512, [], "f2f8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faIceCream = {
  prefix: 'far',
  iconName: 'ice-cream',
  icon: [448, 512, [127848], "f810", "M224 0C140.9 0 72.6 63.3 64.8 144.4C28.4 148 0 178.7 0 216c0 39.8 32.2 72 72 72l64.4 0 175.3 0 64.4 0c39.8 0 72-32.2 72-72c0-37.3-28.4-68-64.8-71.6C375.4 63.3 307.1 0 224 0zM112 160c0-61.9 50.1-112 112-112s112 50.1 112 112c0 2.2-.1 4.4-.2 6.6c-.4 6.6 2 13.1 6.5 17.9s10.8 7.5 17.5 7.5l16.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64.4 0-175.3 0L72 240c-13.3 0-24-10.7-24-24s10.7-24 24-24l16.2 0c6.6 0 12.9-2.7 17.5-7.5s6.9-11.3 6.5-17.9c-.1-2.2-.2-4.4-.2-6.6zm88.1 338.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320 98.3 320 200.1 498.1z"]
};
const faHeartCircleBolt = {
  prefix: 'far',
  iconName: 'heart-circle-bolt',
  icon: [576, 512, [], "e4fc", "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
const faFishBones = {
  prefix: 'far',
  iconName: 'fish-bones',
  icon: [576, 512, [], "e304", "M96 166.9c0-7.2-3.3-14.1-8.9-18.7l-48-38.9c-8.8-7.1-21.3-7.1-30.1-.1s-11.5 19.2-6.6 29.3L54.9 245.4c3.3 6.7 3.3 14.5 0 21.2L2.5 373.4c-5 10.1-2.2 22.3 6.6 29.3s21.3 7 30.1-.1l48-38.9c5.6-4.6 8.9-11.4 8.9-18.7L96 304s0 0 0 0l0-24 40 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 40 0 0 101.1c0 16.9 17.1 28.4 31.8 20c16-9.1 30.6-19.7 43.7-30.7c39.1-33 66.9-72.4 81-99.8c4.7-9.2 4.7-20.1 0-29.3c-14.1-27.4-41.9-66.8-81-99.8c-13.1-11-27.7-21.6-43.7-30.7c-14.7-8.4-31.8 3.1-31.8 20L416 232l-40 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-40 0 0-24s0 0 0 0l0-41.1zM464 330.8l0-149.5c28.5 24.9 49.7 53.6 61.8 74.8c-12.1 21.2-33.3 49.9-61.8 74.8z"]
};
const faDeerRudolph = {
  prefix: 'far',
  iconName: 'deer-rudolph',
  icon: [576, 512, [], "f78f", "M240 0c8.8 0 16 7.2 16 16l0 24c0 13.3 10.7 24 24 24l8 0 8 0c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 8.6-1.9 16.7-5.4 24l39.5 0L416 64c13.3 0 24-10.7 24-24l0-24c0-8.8 7.2-16 16-16s16 7.2 16 16l0 24c0 20.7-11.2 38.7-27.9 48.4l43.7 39.7c7.3-9.8 19-16.2 32.1-16.2c22.1 0 40 17.9 40 40s-17.9 40-40 40l-.1 0c-2.3 35.7-31.9 64-68.2 64l-42.3 0-16.1 48.2c-.8 2.4-1.2 5-1.2 7.6L392 472c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-96-6.8 0c-22 0-43.7-4.6-63.8-13.3c-4.3 17.1-14.7 32.3-29.9 42.4l-6.5 4.3 17.8 48.8c9.5 26.1-9.8 53.7-37.6 53.7l-46 0c-16.8 0-31.8-10.5-37.6-26.3L31.2 423.9c-5.6-15.3-5.8-32-.6-47.4l8.2-24.7c.8-2.4 1.2-5 1.2-7.6l0-4.3c0-6.4-2.5-12.5-7-17l-1.1-1.1c-1 8.4-8.4 14.7-16.9 14.1c-8.8-.6-15.5-8.1-15-17l3.3-53c1.1-17.6 6.9-33.9 16.2-47.6c16.2-30 48-50.4 84.5-50.4l191 0 7.2-24L274 144c-9.9 0-18-8-18-18c0-8.2 5.6-15.4 13.6-17.4L320 96l-24 0-8 0-8 0c-30.9 0-56-25.1-56-56l0-24c0-8.8 7.2-16 16-16zM354.9 135.2l-19 63.6c-3 10.2-12.4 17.1-23 17.1L104 216c-26.5 0-48 21.5-48 48l0 4.1c0 6.4 2.5 12.5 7 17l3.9 3.9C80.4 302.5 88 320.8 88 339.9l0 4.3c0 7.7-1.2 15.4-3.7 22.8l-8.2 24.7c-1.7 5.1-1.6 10.7 .2 15.8L96.8 464l28.9 0-20.3-55.8c-3.8-10.4 0-22 9.2-28.2l22.2-14.8c7.9-5.2 11.9-14.6 10.4-23.9l-2.9-17.4c-1.6-9.4 2.6-18.9 10.6-24.1s18.4-5.1 26.3 .2l13.7 9.2c18.4 12.3 40 18.8 62.1 18.8l30.8 0c13.3 0 24 10.7 24 24l0 112 32 0 0-152.2c0-7.7 1.2-15.4 3.7-22.8l21.5-64.6c3.3-9.8 12.4-16.4 22.8-16.4l59.6 0c11.3 0 20.4-9.1 20.4-20.4c0-5.7-2.4-11.2-6.7-15.1L408 120.5c-6-5.5-13.8-8.5-21.9-8.5c-14.4 0-27.1 9.4-31.2 23.2zM400 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faFax = {
  prefix: 'far',
  iconName: 'fax',
  icon: [512, 512, [128224, 128439], "f1ac", "M176 64c0-8.8 7.2-16 16-16l191.4 0c4.2 0 8.3 1.7 11.3 4.7l32.6 32.6c3 3 4.7 7.1 4.7 11.3l0 63.4 48 0 0-63.4c0-17-6.7-33.3-18.7-45.3L428.7 18.7C416.7 6.7 400.4 0 383.4 0L192 0c-35.3 0-64 28.7-64 64l0 66c-5.1-1.3-10.5-2-16-2l-48 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l32 0 16 0 336 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-272 0 0-128zm0 176l272 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16l-274 0c1.3-5.1 2-10.5 2-16l0-208zM112 464l-16 0-32 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 24 0 232c0 8.8-7.2 16-16 16zM272 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM240 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM368 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM336 400a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faParagraph = {
  prefix: 'far',
  iconName: 'paragraph',
  icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160l64 0 168 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376-48 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-48 0c-88.4 0-160-71.6-160-160zM240 304l0-224-48 0C130.1 80 80 130.1 80 192s50.1 112 112 112l48 0z"]
};
const faHeadSideHeart = {
  prefix: 'far',
  iconName: 'head-side-heart',
  icon: [512, 512, [], "e1aa", "M48 224c0-97.2 78.8-176 176-176l24 0c60.1 0 115.7 36.7 139.6 88.3c3.9 8.4 7.5 17 11.4 25.9l1.5 3.5c4.3 10.1 8.9 20.7 13.9 31.1c10.1 20.8 22.5 42 40.6 60.1l4.4 4.4c2.9 2.9 4.6 6.9 4.6 11c0 8.6-7 15.6-15.6 15.6L424 288c-13.3 0-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-88 0c-13.3 0-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 64 0c35.3 0 64-28.7 64-64l0-48 .4 0c35.1 0 63.6-28.5 63.6-63.6c0-16.9-6.7-33-18.6-45L489 223c-12.7-12.7-22.4-28.5-31.4-47.1c-4.5-9.3-8.7-18.9-13-29l-1.5-3.5c-3.8-8.9-7.8-18.2-12-27.3C399.4 47.6 326.8 0 248 0L224 0C100.3 0 0 100.3 0 224c0 53.6 18.9 102.9 50.3 141.5c8.9 11 13.7 22.4 13.7 33.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-89.4c0-24.9-10.9-46.8-24.5-63.4C62.8 304.8 48 266.2 48 224zm64-34.7c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
const faSquareE = {
  prefix: 'far',
  iconName: 'square-e',
  icon: [448, 512, [], "e26d", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm152 32l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-120 0 0 56 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 56 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-104 0-104c0-13.3 10.7-24 24-24z"]
};
const faMeterFire = {
  prefix: 'far',
  iconName: 'meter-fire',
  icon: [640, 512, [], "e1eb", "M256 48c68.7 0 129.5 33.3 167.4 84.6c16.7-8 37.2-5.5 51.5 7.4c5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c33.6 0 65.7-6.5 95.1-18.3c-12.6-11.6-23.6-24.8-32.8-39.2c-19.7 6.2-40.6 9.5-62.3 9.5C141.1 464 48 370.9 48 256S141.1 48 256 48zM368 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 11.2 7.6 20.6 18 23.2c9-12.9 19.1-25.7 30-38.3l0-32.9zm-176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48zm225.7 56.1l-19-19.9c-2-2.1-4-4.4-6-6.7c0 0 0 0 0 0c-9-10.2-18.6-21.3-32.7-21.6c-7.3-.2-14.6 2.3-20.3 7.5c-23.4 21.1-50 48.9-70.9 80.2C336 278.6 320 314.7 320 352c0 88.6 70.4 159.8 160 159.8c88.7 0 160-71.2 160-159.8c0-30-11-60.9-26.2-88.1c-15.2-27.4-35.3-52.3-55-70.6c-5.6-5.2-12.8-7.8-19.9-7.8c-7.6 0-15.5 2.8-20.9 8.9l-12.3 13.8zM544 400c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-36.5 37-73 54.8-88.4c5.4-4.7 13.1-4.7 18.5 0C507 327 544 363.5 544 400z"]
};
const faCloudHail = {
  prefix: 'far',
  iconName: 'cloud-hail',
  icon: [512, 512, [], "f739", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM160 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faCheckToSlot = {
  prefix: 'far',
  iconName: 'check-to-slot',
  icon: [576, 512, ["vote-yea"], "f772", "M144 80l0 280 288 0 0-280L144 80zM96 360L96 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 280c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0-288 0-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 288l0 48-16 0 0 96 480 0 0-96-16 0 0-48 16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0zM385 179.6L278.3 286.3c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7L191 233c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L351 145.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faVoteYea = faCheckToSlot;
const faMoneyFromBracket = {
  prefix: 'far',
  iconName: 'money-from-bracket',
  icon: [640, 512, [], "e312", "M48 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L552 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88zm416 8l48 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352 48 0 0 304c35.3 0 64 28.7 64 64l160 0c0-35.3 28.7-64 64-64l0-304zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z"]
};
const faStarHalf = {
  prefix: 'far',
  iconName: 'star-half',
  icon: [576, 512, [61731], "f089", "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4l0 384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.3c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4 0-265.9z"]
};
const faCarBus = {
  prefix: 'far',
  iconName: 'car-bus',
  icon: [640, 512, [], "f85a", "M64.5 80L192 80l129.4 0C302.1 65.3 263.5 48 192 48C126.6 48 86.2 64.8 64.5 80zM48 128l0 80 120 0 0-80L48 128zm0 128l0 96c0 13.3 10.7 24 24 24l120 0 0 48L80 424l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-44.1C12.7 399 0 377 0 352L0 118.2c0-22 4.6-51.9 28.8-71.4C58.6 22.7 111.5 0 192 0c84.9 0 135.8 22.1 164.5 46.6c23.4 20 27.5 49.9 27.5 71.6l0 9.8-35.8 0c-4.1 0-8.2 .3-12.2 .8l0-.8-120 0 0 80 36.9 0-13.7 48L192 256 48 256zm56 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm257.8-80c-10.1 0-19.2 6.4-22.6 15.9L322.1 272l219.9 0-17.2-48.1c-3.4-9.6-12.5-15.9-22.6-15.9l-140.3 0zm-96.4 79.9L294 207.8c10.2-28.7 37.4-47.8 67.8-47.8l140.3 0c30.4 0 57.6 19.1 67.8 47.8l28.6 80.1c.2 .5 .3 .9 .5 1.4C623.8 306.7 640 335.5 640 368l0 32 0 16 0 32 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-320 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40 0-32 0-16 0-32c0-32.5 16.2-61.3 40.9-78.7c.1-.5 .3-.9 .5-1.4zM544 320l-224 0c-26.5 0-48 21.5-48 48l0 32 320 0 0-32c0-26.5-21.5-48-48-48zM336 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faSpeaker = {
  prefix: 'far',
  iconName: 'speaker',
  icon: [384, 512, [], "f8df", "M320 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l256 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM232 120a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM192 432a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM136 328a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
const faTimer = {
  prefix: 'far',
  iconName: 'timer',
  icon: [512, 512, [], "e29e", "M232 24c0-13.3 10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256S0 397.4 0 256c0-37.9 8.2-73.8 23-106.1c6-13.2 13.1-25.8 21.2-37.6l.1-.2C53.4 98.7 63.6 86.3 75 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-9.2 9.2-17.6 19.3-25 30.1l-.1 .2c-21.2 31.2-34.2 68.5-35.7 108.7c-.1 2.7-.2 5.4-.2 8.1c0 114.9 93.1 208 208 208s208-93.1 208-208c0-106.8-80.4-194.7-184-206.6l0 54.6c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80zM159 159c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faBoxesStacked = {
  prefix: 'far',
  iconName: 'boxes-stacked',
  icon: [576, 512, [62625, "boxes", "boxes-alt"], "f468", "M384 48c8.8 0 16 7.2 16 16l0 128 48 0 0-128c0-35.3-28.7-64-64-64L192 0c-35.3 0-64 28.7-64 64l0 128 48 0 0-128c0-8.8 7.2-16 16-16l56 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0zM327.6 512L512 512c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-184.4 0c11.8 13.2 20.1 29.7 23.1 48l25.3 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16l-161.3 0c-3.1 18.3-11.3 34.8-23.1 48zM256 272c8.8 0 16 7.2 16 16l0 160c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-160c0-8.8 7.2-16 16-16l56 0 0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-64 56 0zM64 224c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64L64 224z"]
};
const faBoxes = faBoxesStacked;
const faBoxesAlt = faBoxesStacked;
const faLandmarkMagnifyingGlass = {
  prefix: 'far',
  iconName: 'landmark-magnifying-glass',
  icon: [640, 512, [], "e622", "M448 288c-16.7 0-32.8-2.6-48-7.3L400 384l-64 0 0-141.7c-5.8-5.7-11.1-11.8-16-18.3l-32 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-96zM267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l267.3 0c-6.5-14.9-10.8-31.1-12.5-48L88.2 144 256 51.4l41.3 22.8c5.5-15.3 13.2-29.5 22.8-42.3L267.6 3zM0 488c0 13.3 10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM448 48.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 313.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faGrillHot = {
  prefix: 'far',
  iconName: 'grill-hot',
  icon: [448, 512, [], "e5a5", "M120 0C106.7 0 96 10.7 96 24l0 2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6c0-13.3-10.7-24-24-24zM48.9 208l350.2 0c-8 72-69 128-143.1 128l-64 0c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32c0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40L327 472l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L334.4 367.3c67-30 113.6-97.2 113.6-175.3c0-17.7-14.3-32-32-32L32 160zM147.5 410l12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7l64 0c11 0 21.7-.9 32.2-2.7L306.5 424l-151.1 0c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6z"]
};
const faBallotCheck = {
  prefix: 'far',
  iconName: 'ballot-check',
  icon: [448, 512, [], "f733", "M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM80 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L96 96c-8.8 0-16 7.2-16 16zM96 352c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80-224c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm32 128c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zM176 384c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm-4.7-140.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 257.4 99.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"]
};
const faLink = {
  prefix: 'far',
  iconName: 'link',
  icon: [640, 512, [128279, "chain"], "f0c1", "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"]
};
const faChain = faLink;
const faEarListen = {
  prefix: 'far',
  iconName: 'ear-listen',
  icon: [512, 512, ["assistive-listening-systems"], "f2a2", "M388.9 3.8C450.6 43 493.6 105.8 508 177.6l3.5 17.7c2.6 13-5.8 25.6-18.8 28.2s-25.6-5.8-28.2-18.8L460.9 187c-11.8-58.9-47.1-110.5-97.8-142.7c-11.2-7.1-14.5-22-7.4-33.1s21.9-14.5 33.1-7.4zM240 112c-70.7 0-128 57.3-128 128c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-97.2 78.8-176 176-176s176 78.8 176 176c0 47.5-18.8 90.6-49.4 122.2c-4.8 4.9-6.6 9.9-6.6 13.8c0 75.1-60.9 136-136 136c-13.3 0-24-10.7-24-24s10.7-24 24-24c48.6 0 88-39.4 88-88c0-19.1 8.9-35.5 20.1-47.1c22.3-23 35.9-54.4 35.9-88.9c0-70.7-57.3-128-128-128zm0 88c-22.1 0-40 17.9-40 40c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6 39.4-88 88-88s88 39.4 88 88c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.1-17.9-40-40-40zM168 320a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM24 464a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm57-97l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L47 401c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faAssistiveListeningSystems = faEarListen;
const faFileMinus = {
  prefix: 'far',
  iconName: 'file-minus',
  icon: [384, 512, [], "f318", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faTreeCity = {
  prefix: 'far',
  iconName: 'tree-city',
  icon: [640, 512, [], "e587", "M336 56c0-4.4 3.6-8 8-8l112 0c4.4 0 8 3.6 8 8l0 160c0 13.3 10.7 24 24 24l80 0 16 0c4.4 0 8 3.6 8 8l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-28.2-20.9-51.6-48-55.4l0-72.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-32 0 0-136c0-30.9-25.1-56-56-56L344 0c-30.9 0-56 25.1-56 56l0 432c0 13.3 10.7 24 24 24s24-10.7 24-24l0-432zm32 40l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM368 288l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM496 384l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM224 160c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240c0 45 35 80 80 80l16 0 0 160c0 18 14 32 32 32c17 0 32-14 32-32l0-160 16 0c44 0 80-35 80-80c0-26-14-50-34-64c1-5 2-10 2-16z"]
};
const faPlay = {
  prefix: 'far',
  iconName: 'play',
  icon: [384, 512, [9654], "f04b", "M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z"]
};
const faFont = {
  prefix: 'far',
  iconName: 'font',
  icon: [448, 512, [], "f031", "M246.2 46.9C242.5 37.9 233.8 32 224 32s-18.5 5.9-22.2 14.9L44.6 432 24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-39.5 0 32.7-80 189.8 0 32.7 80L312 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-20.6 0L246.2 46.9zM299.3 304l-150.6 0L224 119.5 299.3 304z"]
};
const faCupTogo = {
  prefix: 'far',
  iconName: 'cup-togo',
  icon: [448, 512, ["coffee-togo"], "f6c5", "M108.2 48l232 0c3 0 5.8 1.7 7.2 4.4L361.2 80 88 80l13-27.4c1.3-2.8 4.1-4.6 7.2-4.6zM414.8 80L390.3 31c-9.5-19-28.9-31-50.1-31l-232 0C86.6 0 66.9 12.4 57.6 32L34.8 80 24 80C10.7 80 0 90.7 0 104s10.7 24 24 24l26 0 350 0 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-9.2 0zM47.4 160L74.6 453.9c3 32.9 30.7 58.1 63.7 58.1l171.3 0c33.1 0 60.7-25.2 63.7-58.1L400.6 160l-48.2 0-5.9 64-244.9 0-5.9-64-48.2 0zm68.9 224l215.3 0-6.1 65.5c-.8 8.2-7.7 14.5-15.9 14.5l-171.3 0c-8.3 0-15.2-6.3-15.9-14.5L116.4 384z"]
};
const faCoffeeTogo = faCupTogo;
const faSquareDownLeft = {
  prefix: 'far',
  iconName: 'square-down-left',
  icon: [448, 512, [], "e26b", "M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 198.6L128 336c0 8.8 7.2 16 16 16l137.4 0c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L264 280l66.3-66.3c3.6-3.6 5.7-8.5 5.7-13.7s-2-10-5.7-13.7l-36.7-36.7C290 146 285.1 144 280 144s-10 2-13.7 5.7L200 216l-33.4-33.4c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6z"]
};
const faBurgerLettuce = {
  prefix: 'far',
  iconName: 'burger-lettuce',
  icon: [512, 512, [], "e3e3", "M396.5 134.9c-7.7-8.5-17-17.1-28.6-24.9c.1 .6 .1 1.3 .1 2c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-6.5 3.8-12 9.3-14.6c-19.9-9.1-44.5-15.6-75.3-17.1c1.2 2.3 1.9 4.9 1.9 7.7c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.8 .7-5.4 1.9-7.7c-30.7 1.5-55.4 8-75.3 17.1c5.5 2.5 9.3 8.1 9.3 14.6c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.7 0-1.3 .1-2c-11.6 7.8-21 16.4-28.6 24.9c-12.8 14.2-21.5 29-27.1 41.1l335.2 0c-5.7-12.1-14.3-26.9-27.1-41.1zM450.9 224L61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1zM128 432l256 0c20.9 0 38.7-13.4 45.3-32L82.7 400c6.6 18.6 24.4 32 45.3 32zM32 384c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96zm48-56c-20.1 0-35.8-5.1-46.7-10.5c-5.4-2.7-9.6-5.5-12.7-7.8c-1.5-1.1-2.7-2.1-3.7-3c-.5-.4-.9-.8-1.2-1.1l-.4-.4-.2-.2-.1-.1c0 0 0 0 0 0s0 0 0 0l17-17L15 305c-9.4-9.4-9.4-24.6 0-33.9c9.2-9.2 24.2-9.4 33.6-.4c.1 .1 .4 .3 .8 .6c1 .7 2.8 1.9 5.3 3.2c5.1 2.5 13.4 5.5 25.3 5.5c8.2 0 15.2-3.8 30-12.6l.2-.1c13.2-7.9 32.3-19.3 57.8-19.3c25.1 0 42.2 11.1 54.1 18.8l1.6 1c12 7.7 19.8 12.2 32.3 12.2c12.2 0 19-4.2 30.7-12l.6-.4c12.3-8.2 29.4-19.6 56.7-19.6c27.2 0 46.1 11.3 59.6 19.6c14.5 9 20.5 12.4 28.4 12.4c11.9 0 20.2-2.9 25.3-5.5c2.6-1.3 4.4-2.5 5.3-3.2c.4-.3 .7-.6 .8-.6c9.4-9 24.3-8.9 33.6 .4c9.4 9.4 9.4 24.6 0 33.9l-17-17c17 17 17 17 17 17s0 0 0 0s0 0 0 0l-.1 .1-.2 .2-.4 .4c-.3 .3-.7 .7-1.2 1.1c-.9 .8-2.1 1.8-3.7 3c-3 2.3-7.2 5.1-12.7 7.8C467.8 322.9 452.1 328 432 328c-22.2 0-39.3-10.7-50.8-17.9c-1-.6-1.9-1.2-2.7-1.7C365.9 300.7 356.8 296 344 296c-12.2 0-19 4.2-30.7 12l-.6 .4C300.4 316.6 283.3 328 256 328c-27.5 0-45.5-11.6-58.3-19.8c0 0 0 0 0 0C184.8 299.9 178.4 296 168 296c-11 0-19.8 4.5-33.4 12.6l-2.3 1.4c-12.1 7.3-29.9 18-52.2 18z"]
};
const faTableCellsRowLock = {
  prefix: 'far',
  iconName: 'table-cells-row-lock',
  icon: [640, 512, [], "e67a", "M48 296l0-80 104 0 0 80L48 296zm0 120l0-72 104 0 0 88-88 0c-8.8 0-16-7.2-16-16zm264 16l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 216l112 0 0 80-112 0 0-80zm328 24c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faRupiahSign = {
  prefix: 'far',
  iconName: 'rupiah-sign',
  icon: [512, 512, [], "e23d", "M0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176zm264-96l88 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-64 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-304c0-13.3 10.7-24 24-24zm88 176c35.3 0 64-28.7 64-64s-28.7-64-64-64l-64 0 0 128 64 0z"]
};
const faMagnifyingGlass = {
  prefix: 'far',
  iconName: 'magnifying-glass',
  icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
};
const faSearch = faMagnifyingGlass;
const faTableTennisPaddleBall = {
  prefix: 'far',
  iconName: 'table-tennis-paddle-ball',
  icon: [512, 512, [127955, "ping-pong-paddle-ball", "table-tennis"], "f45d", "M412.4 99.5c52.2 52.2 64.8 129 37.7 193.1c15.8 4.4 30.4 11.7 43.1 21.3c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L69.5 125.7c-24 24-37.5 56.6-37.5 90.5l0 2.7c0 33.9 13.5 66.5 37.5 90.5c13.4 13.4 12 35.6-3 47.2l-49.3 38C6.3 403.1 0 416 0 429.7c0 11.7 4.7 22.9 12.9 31.2l38.1 38.1c8.3 8.3 19.5 12.9 31.2 12.9c13.7 0 26.6-6.3 35-17.2l38-49.3c11.6-15 33.8-16.5 47.2-3c24 24 56.6 37.5 90.5 37.5l2.7 0c3.1 0 6.1-.1 9.2-.3c-8.3-14.4-13.8-30.6-16-47.8c-19.7-1-38.5-9.3-52.5-23.3l-33.9 33.9 33.9-33.9c-33.9-33.9-89.9-30.3-119.2 7.7L81.9 462l-32-32 45.8-35.3c38-29.3 41.6-85.3 7.7-119.2C88.4 260.5 80 240.2 80 219l0-2.7c0-11 2.3-21.8 6.6-31.7L290.9 388.8c3.7-17.2 10.9-33.2 20.8-47.1L116.5 146.6l47-47c68.7-68.7 180.2-68.7 248.9 0zM368 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"]
};
const faPingPongPaddleBall = faTableTennisPaddleBall;
const faTableTennis = faTableTennisPaddleBall;
const faPersonDotsFromLine = {
  prefix: 'far',
  iconName: 'person-dots-from-line',
  icon: [576, 512, ["diagnoses"], "f470", "M288 48a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM24 320L8.9 301.3C-1.4 309.7-3 324.8 5.3 335.1s23.4 11.9 33.7 3.6c0 0 0 0 0 0l.1-.1 .7-.6c.7-.5 1.8-1.4 3.3-2.4c3-2.2 7.5-5.4 13.4-9.2c11.9-7.7 29.3-18.2 51.5-28.6c19.4-9.2 42.3-18.3 68-25.6L176 432l48 0 0-170.7c20.2-3.3 41.6-5.3 64-5.3s43.8 1.9 64 5.3L352 432l48 0 0-159.9c25.7 7.4 48.5 16.5 68 25.6c22.2 10.5 39.6 20.9 51.5 28.6c5.9 3.9 10.4 7.1 13.4 9.2c1.5 1.1 2.6 1.9 3.3 2.4l.7 .6 .1 .1s0 0 0 0c10.3 8.3 25.4 6.7 33.7-3.6s6.7-25.4-3.6-33.8L552 320c15.1-18.7 15.1-18.7 15.1-18.7s0 0 0 0s0 0 0 0l-.1-.1-.3-.3-.6-.5-.6-.4c-1-.8-2.4-1.8-4.2-3.1c-3.6-2.6-8.8-6.3-15.5-10.7c-13.4-8.8-32.8-20.3-57.3-31.9C439.6 231.3 370.1 208 288 208s-151.6 23.3-200.4 46.3c-24.4 11.5-43.9 23.1-57.3 31.9c-6.7 4.4-11.9 8.1-15.5 10.7c-1.8 1.3-3.2 2.4-4.2 3.1c-.5 .4-.9 .7-1.2 .9l-.3 .3-.1 .1c0 0 0 0 0 0c0 0 0 0 0 0L24 320zM0 488c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464c-13.3 0-24 10.7-24 24zM56 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM336 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM488 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faDiagnoses = faPersonDotsFromLine;
const faChevronsDown = {
  prefix: 'far',
  iconName: 'chevrons-down',
  icon: [512, 512, ["chevron-double-down"], "f322", "M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"]
};
const faChevronDoubleDown = faChevronsDown;
const faTrashCanArrowUp = {
  prefix: 'far',
  iconName: 'trash-can-arrow-up',
  icon: [448, 512, ["trash-restore-alt"], "f82a", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm144 48c6.4 0 12.5 2.5 17 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L248 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c4.5-4.5 10.6-7 17-7z"]
};
const faTrashRestoreAlt = faTrashCanArrowUp;
const faSignalGood = {
  prefix: 'far',
  iconName: 'signal-good',
  icon: [640, 512, ["signal-3"], "f68e", "M320 192c13.3 0 24 10.7 24 24l0 272c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-272c0-13.3 10.7-24 24-24zM192 288c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zM64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faSignal3 = faSignalGood;
const faLocationQuestion = {
  prefix: 'far',
  iconName: 'location-question',
  icon: [384, 512, ["map-marker-question"], "f60b", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM105.8 133.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 232.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faMapMarkerQuestion = faLocationQuestion;
const faFloppyDiskCircleXmark = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-xmark',
  icon: [576, 512, ["floppy-disk-times", "save-circle-xmark", "save-times"], "e181", "M48 96l0 320c0 8.8 7.2 16 16 16l204 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-24.4c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80l0 80 144 0 0-80L128 80zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368z"]
};
const faFloppyDiskTimes = faFloppyDiskCircleXmark;
const faSaveCircleXmark = faFloppyDiskCircleXmark;
const faSaveTimes = faFloppyDiskCircleXmark;
const faNairaSign = {
  prefix: 'far',
  iconName: 'naira-sign',
  icon: [448, 512, [], "e1f6", "M107.8 42.5C101.9 33.8 91 30 80.9 33.1S64 45.5 64 56l0 200-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 115.6 0L340.2 469.5c5.9 8.7 16.8 12.5 26.9 9.4s16.9-12.4 16.9-22.9l0-152 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-200c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 200-83 0L107.8 42.5zM285.7 304l50.3 0 0 74-50.3-74zM195 256l-83 0 0-122 83 122z"]
};
const faPeach = {
  prefix: 'far',
  iconName: 'peach',
  icon: [512, 512, [], "e20b", "M96 32c0 34.7 18.4 65.1 46 82C61.6 126.5 0 196 0 280C0 416.2 199.3 494.6 240.6 509.4c5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-84-61.6-153.5-142-166c27.6-16.9 46-47.3 46-82l0-8c0-13.3-10.7-24-24-24L352 0c-53 0-96 43-96 96c0-53-43-96-96-96L120 0C106.7 0 96 10.7 96 24l0 8zm72 128c58.1 0 106.6 41.3 117.6 96.2c2.6 13 13.1 23.8 26.4 23.8s24.2-10.8 22.3-23.9c-4.7-32.9-19-62.8-39.9-86.7c4.1-1 8.2-2.1 12.2-3.5c11.7-3.8 24.3-5.9 37.4-5.9c66.3 0 120 53.7 120 120c0 43.4-32.4 84.6-84.3 120.9c-49.2 34.4-103.9 55.9-123.7 63c-19.8-7.1-74.5-28.6-123.7-63C80.4 364.6 48 323.4 48 280c0-66.3 53.7-120 120-120z"]
};
const faCirclesOverlap3 = {
  prefix: 'far',
  iconName: 'circles-overlap-3',
  icon: [512, 512, ["pronoun"], "e6a1", "M157 192.1c38.2 1.2 72.9 16.6 99 41.1c26-24.4 60.7-39.8 99-41.1c3.3-10.1 5-20.9 5-32.1c0-57.4-46.6-104-104-104s-104 46.6-104 104c0 11.2 1.8 22 5 32.1zm-48.2 6.1c-3.2-12.2-4.8-25-4.8-38.2C104 76.1 172.1 8 256 8s152 68.1 152 152c0 13.2-1.7 26-4.8 38.2C466.1 216.8 512 275 512 344c0 83.9-68.1 152-152 152c-40.2 0-76.8-15.6-104-41.1C228.8 480.4 192.2 496 152 496C68.1 496 0 427.9 0 344c0-69 45.9-127.2 108.8-145.8zm19.6 44.5C82.3 253.4 48 294.7 48 344c0 57.4 46.6 104 104 104c29.2 0 55.6-12 74.4-31.4C214.7 395 208 370.3 208 344c0-13.2 1.7-26 4.8-38.2c-35.1-10.4-64.9-33.1-84.4-63.1zm170.7 63.1c3.2 12.2 4.8 25 4.8 38.2c0 26.3-6.7 51-18.4 72.6C304.4 436 330.8 448 360 448c57.4 0 104-46.6 104-104c0-49.3-34.3-90.6-80.4-101.3c-19.5 30-49.3 52.7-84.4 63.1z"]
};
const faPronoun = faCirclesOverlap3;
const faTaxiBus = {
  prefix: 'far',
  iconName: 'taxi-bus',
  icon: [640, 512, [], "e298", "M192 48c71.5 0 110.1 17.3 129.4 32L192 80 64.5 80C86.2 64.8 126.6 48 192 48zM48 208l0-80 120 0 0 80L48 208zm0 144l0-96 144 0 47.2 0 13.7-48L216 208l0-80 112.6 0c3.6-25.4 24.3-45.2 50-47.7c-4-12.2-10.8-24-22-33.6C327.8 22.1 276.9 0 192 0C111.5 0 58.6 22.7 28.8 46.8C4.6 66.3 0 96.2 0 118.2L0 352c0 25 12.7 47 32 59.9L32 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 112 0 0-48L72 376c-13.3 0-24-10.7-24-24zm80-40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 144l0 16-6.2 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-6.2 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm-6.2 64l38.2 0 64 0 38.2 0c10.1 0 19.2 6.4 22.6 15.9L541.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM320 320l224 0c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48zm40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faBracketCurly = {
  prefix: 'far',
  iconName: 'bracket-curly',
  icon: [256, 512, ["bracket-curly-left"], "7b", "M64 120c0-48.6 39.4-88 88-88l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-22.1 0-40 17.9-40 40l0 45.5c0 23.3-9.3 45.7-25.8 62.2L57.9 256l28.3 28.3c16.5 16.5 25.8 38.9 25.8 62.2l0 45.5c0 22.1 17.9 40 40 40l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-48.6 0-88-39.4-88-88l0-45.5c0-10.6-4.2-20.8-11.7-28.3L7 273c-9.4-9.4-9.4-24.6 0-33.9l45.3-45.3c7.5-7.5 11.7-17.7 11.7-28.3L64 120z"]
};
const faBracketCurlyLeft = faBracketCurly;
const faLobster = {
  prefix: 'far',
  iconName: 'lobster',
  icon: [512, 512, [129438], "e421", "M80 8.2c0-3.7-2.5-6.9-6.1-7.5C70.7 .3 67.4 0 64 0C28.7 0 0 28.7 0 64l0 64c0 35.3 28.7 64 64 64l.7 0 41.8 27.9C126.2 233 149.4 240 173.1 240l2.9 0 0 16-32.9 0c-7.5 0-14.8-1.7-21.5-5.1L87.2 233.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4l32.9 0 0 16-53.6 0c-5.2 0-10.3-.8-15.2-2.5L69.1 288.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1l53.6 0 0 16-.9 0c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1l.9 0 23.8 66.6c-23.1 7.3-39.8 28.8-39.8 54.3c0 3.9 3.2 7.1 7.1 7.1l177.8 0c3.9 0 7.1-3.2 7.1-7.1c0-25.5-16.7-47-39.8-54.3L336 384l.9 0c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4l-.9 0 0-16 53.6 0c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5L336 304l0-16 32.9 0c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1L336 256l0-16 2.9 0c23.7 0 46.9-7 66.6-20.2L447.3 192l.7 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64c-3.4 0-6.7 .3-9.9 .8c-3.6 .6-6.1 3.8-6.1 7.5L432 72c0 7.7-9.8 11-14.4 4.8L397.4 49.9c-3.7-4.9-11.2-3.9-12.3 2.1c-.7 3.9-1.1 7.9-1.1 11.9l0 64c0 14.9 5.1 28.6 13.6 39.4l-18.7 12.5C367 187.8 353.1 192 338.9 192l-3.4 0c-2.6-22.5-16-42.9-31.5-59.2l0-52.1c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7l0 25c-3.2-2.2-6.3-4.1-9-5.8c-4.3-2.6-9.7-2.6-14 0c-2.8 1.6-5.8 3.6-9 5.8l0-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7l0 52.1c-15.5 16.3-28.9 36.7-31.5 59.2l-3.4 0c-14.2 0-28.1-4.2-39.9-12.1l-18.7-12.5c8.5-10.9 13.6-24.6 13.6-39.4l0-64c0-4.1-.4-8.1-1.1-11.9c-1.1-6-8.6-7.1-12.3-2.1L94.4 76.8C89.8 83 80 79.7 80 72L80 8.2zM262.2 448l-12.3 0L224 375.7 224 240l0-40c0-6.6 3.8-17 15.4-30.3c5.2-6 11-11.4 16.6-16c5.7 4.7 11.5 10.1 16.6 16C284.2 183 288 193.4 288 200l0 40 0 135.7L262.2 448z"]
};
const faCartFlatbedEmpty = {
  prefix: 'far',
  iconName: 'cart-flatbed-empty',
  icon: [640, 512, ["dolly-flatbed-empty"], "f476", "M0 24C0 10.7 10.7 0 24 0L72 0c30.9 0 56 25.1 56 56l0 352c0 4.4 3.6 8 8 8l72 0 288 0 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-192 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-24 0c-30.9 0-56-25.1-56-56L80 56c0-4.4-3.6-8-8-8L24 48C10.7 48 0 37.3 0 24z"]
};
const faDollyFlatbedEmpty = faCartFlatbedEmpty;
const faColon = {
  prefix: 'far',
  iconName: 'colon',
  icon: [192, 512, [], "3a", "M120 128a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 128zm96 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-96 0a72 72 0 1 1 144 0A72 72 0 1 1 24 384z"]
};
const faCartArrowDown = {
  prefix: 'far',
  iconName: 'cart-arrow-down',
  icon: [576, 512, [], "f218", "M0 24C0 10.7 10.7 0 24 0L69.5 0c26.9 0 50 19.1 55 45.5l37 194.5 297.6 0c10.9 0 20.4-7.3 23.2-17.8L528.8 49.8c3.4-12.8 16.6-20.4 29.4-16.9s20.4 16.6 16.9 29.4L528.7 234.7c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM344 24l0 102.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L296 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faWand = {
  prefix: 'far',
  iconName: 'wand',
  icon: [512, 512, [], "f72a", "M459.1 48c-1.2 0-2.4 .4-3.3 1.3L52.4 414.7c-2.8 2.5-4.4 6.1-4.4 9.9c0 3.5 1.4 6.9 3.9 9.4L78 460.1c2.5 2.5 5.9 3.9 9.4 3.9c3.8 0 7.3-1.6 9.9-4.4L462.7 56.1c.8-.9 1.3-2.1 1.3-3.3c0-2.7-2.2-4.9-4.9-4.9zM423.6 13.7C433.4 4.9 446 0 459.1 0C488.3 0 512 23.7 512 52.9c0 13.1-4.9 25.8-13.7 35.5l-46.2 51c-2.7 2.9-4.1 6.8-4.1 10.7l0 25.9c0 8.8-7.2 16-16 16l-20.4 0c-4.5 0-8.8 1.9-11.9 5.3L132.9 491.8C121.3 504.7 104.8 512 87.5 512c-16.3 0-31.9-6.5-43.4-18L18 467.9C6.5 456.4 0 440.8 0 424.5c0-17.3 7.3-33.8 20.2-45.4l70.6-63.9c3.3-3 5.3-7.3 5.3-11.9L96 272c0-8.8 7.2-16 16-16l37.9 0c4 0 7.8-1.5 10.7-4.1l263-238.2z"]
};
const faWalkieTalkie = {
  prefix: 'far',
  iconName: 'walkie-talkie',
  icon: [384, 512, [], "f8ef", "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24l0 72-8 0C25.1 96 0 121.1 0 152L0 305.4c0 10.6 4.2 20.8 11.7 28.3L32 353.9 32 456c0 30.9 25.1 56 56 56l208 0c30.9 0 56-25.1 56-56l0-102.1 20.3-20.3c7.5-7.5 11.7-17.7 11.7-28.3L384 152c0-30.9-25.1-56-56-56l-8 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-48 0 0-72zm80 120l96 0 40 0c4.4 0 8 3.6 8 8l0 150.1-20.3 20.3c-7.5 7.5-11.7 17.7-11.7 28.3L304 456c0 4.4-3.6 8-8 8L88 464c-4.4 0-8-3.6-8-8l0-105.4c0-10.6-4.2-20.8-11.7-28.3L48 302.1 48 152c0-4.4 3.6-8 8-8l32 0 104 0zm-56 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm0 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faFilePen = {
  prefix: 'far',
  iconName: 'file-pen',
  icon: [576, 512, [128221, "file-edit"], "f31c", "M64 464l198.6 0-5.1 20.5c-2.3 9.2-1.8 18.8 1.3 27.5L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 131.1-48 48L336 160l-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faFileEdit = faFilePen;
const faReceipt = {
  prefix: 'far',
  iconName: 'receipt',
  icon: [384, 512, [129534], "f543", "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24L0 488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8l0-464c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430L48 76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14 0 359.6-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM96 256c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24z"]
};
const faTablePicnic = {
  prefix: 'far',
  iconName: 'table-picnic',
  icon: [512, 512, [], "e32d", "M88 64C74.7 64 64 74.7 64 88s10.7 24 24 24l71.4 0L106.3 240 24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l62.4 0 52 0 235.3 0 52 0 62.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-82.3 0L352.6 112l71.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64zM438.9 320l-52 0 46.9 113.2c5.1 12.2 19.1 18.1 31.4 13s18.1-19.1 13-31.4L438.9 320zm-313.8 0l-52 0L33.8 414.8c-5.1 12.2 .7 26.3 13 31.4s26.3-.7 31.4-13L125.1 320zm33.2-80l53.1-128 89.3 0 53.1 128-195.5 0z"]
};
const faSquarePen = {
  prefix: 'far',
  iconName: 'square-pen',
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm325.8 43.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faPenSquare = faSquarePen;
const faPencilSquare = faSquarePen;
const faCircleMicrophoneLines = {
  prefix: 'far',
  iconName: 'circle-microphone-lines',
  icon: [512, 512, ["microphone-circle-alt"], "e117", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-416c-26.5 0-48 21.5-48 48l0 112c0 26.5 21.5 48 48 48s48-21.5 48-48l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-32-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0 0-16c0-26.5-21.5-48-48-48zM176 256c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 62.5 44.8 114.5 104 125.8l0 10.2c0 13.3 10.7 24 24 24s24-10.7 24-24l0-10.2c59.2-11.2 104-63.3 104-125.8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
const faMicrophoneCircleAlt = faCircleMicrophoneLines;
const faDisplaySlash = {
  prefix: 'far',
  iconName: 'display-slash',
  icon: [640, 512, ["desktop-slash"], "e2fa", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-70.5-55.2c27.4-7.2 47.6-32.2 47.6-61.9l0-288c0-35.3-28.7-64-64-64L96 0C79.6 0 64.6 6.2 53.2 16.4L38.8 5.1zm54.9 43c.7-.1 1.5-.2 2.3-.2l448 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-42.2 0L93.7 48.2zM80 352l0-192.8L32 121.4 32 352c0 35.3 28.7 64 64 64l147.7 0-8 48L184 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-51.7 0-8-48 9.6 0L345 368l-72.6 0c-.2 0-.4 0-.6 0c-.1 0-.2 0-.3 0L96 368c-8.8 0-16-7.2-16-16zm212.3 64l55.3 0 8 48-71.3 0 8-48z"]
};
const faDesktopSlash = faDisplaySlash;
const faSuitcaseRolling = {
  prefix: 'far',
  iconName: 'suitcase-rolling',
  icon: [384, 512, [], "f5c1", "M144 56l0 72 96 0 0-72c0-4.4-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8zM96 128l0-72c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 72 32 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-160 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l32 0zM64 176c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L64 176zm32 72c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zm0 112c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24z"]
};
const faPersonCircleExclamation = {
  prefix: 'far',
  iconName: 'person-circle-exclamation',
  icon: [576, 512, [], "e53f", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"]
};
const faTransporter2 = {
  prefix: 'far',
  iconName: 'transporter-2',
  icon: [512, 512, [], "e044", "M64 32l25.4 7.3C93.3 40.4 96 43.9 96 48s-2.7 7.6-6.6 8.7L64 64 56.7 89.4C55.6 93.3 52.1 96 48 96s-7.6-2.7-8.7-6.6L32 64 6.6 56.7C2.7 55.6 0 52.1 0 48s2.7-7.6 6.6-8.7L32 32 39.3 6.6C40.4 2.7 43.9 0 48 0s7.6 2.7 8.7 6.6L64 32zM480 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L480 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L448 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L448 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6L480 352zM120 464l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-272 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM180.4 224l-60.2 0 46.4-61.2c16.6-21.9 42.6-34.8 70.1-34.8l38.6 0c27.5 0 53.5 12.9 70.1 34.8L391.8 224l-60.2 0L320 224l-48 0 0-48-32 0 0 48-48 0-11.6 0zM112 256l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faUserHoodie = {
  prefix: 'far',
  iconName: 'user-hoodie',
  icon: [448, 512, [], "e68a", "M321.1 259.4c-26.1 30.3-20 77.8 13.9 100.2c35 23 59.3 60.8 64.1 104.4L48.9 464C53.7 420.4 78 382.6 113 359.6c33.9-22.3 40-69.9 13.9-100.2C107.6 237 96 207.9 96 176c0-70.7 57.3-128 128-128s128 57.3 128 128c0 31.9-11.6 61-30.9 83.4zm36.4 31.3C384 259.9 400 219.8 400 176C400 78.8 321.2 0 224 0S48 78.8 48 176c0 43.8 16 83.9 42.5 114.7c7.4 8.6 5.5 22.5-4 28.8C34.4 353.8 0 412.9 0 480c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32c0-67.1-34.4-126.2-86.6-160.5c-9.5-6.2-11.4-20.2-4-28.8zM176 352c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM144 176c0 45.8 40.9 83.4 64.2 101.1c9.4 7.1 22.1 7.1 31.5 0C263.1 259.4 304 221.8 304 176c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faHandsHoldingDiamond = {
  prefix: 'far',
  iconName: 'hands-holding-diamond',
  icon: [640, 512, ["hand-receiving"], "f47c", "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96zM72 64c39.8 0 72 32.2 72 72l0 128.8c12.1-10.5 28-16.8 45.3-16.8c18.4 0 36 7.3 49 20.3l61.4 61.4c7.7 7.7 14.5 16.2 20.4 25.3c5.8-9.1 12.6-17.5 20.4-25.3l61.4-61.4c13-13 30.6-20.3 49-20.3c17.3 0 33.1 6.3 45.3 16.8L496 136c0-39.8 32.2-72 72-72s72 32.2 72 72l0 216.2c0 31.8-12.6 62.3-35.1 84.9L537 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l67.9-67.9c13.5-13.5 21.1-31.8 21.1-50.9L592 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 145.9c0 25.6-10.2 50.2-28.3 68.4l-15.9 15.9c0 0 0 0 0 0L473 393c0 0 0 0 0 0l-16 16c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l16-16c0 0 0 0 0 0l26.7-26.7c4-4 6.2-9.4 6.2-15c0-11.7-9.5-21.3-21.3-21.3c-5.6 0-11 2.2-15 6.2l-61.4 61.4C354.9 383 344 409.4 344 436.8l0 51.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-51.2c0-27.4-10.9-53.8-30.3-73.2l-61.4-61.4c-4-4-9.4-6.2-15-6.2c-11.7 0-21.3 9.5-21.3 21.3c0 5.6 2.2 11 6.2 15L201 359s0 0 0 0l16 16c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-16-16c0 0 0 0 0 0l-26.7-26.7s0 0 0 0l-15.9-15.9C106.2 332.1 96 307.5 96 281.9L96 136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 216.2c0 19.1 7.6 37.4 21.1 50.9L137 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L35.1 437.1C12.6 414.6 0 384.1 0 352.2L0 136C0 96.2 32.2 64 72 64z"]
};
const faHandReceiving = faHandsHoldingDiamond;
const faMoneyBillSimpleWave = {
  prefix: 'far',
  iconName: 'money-bill-simple-wave',
  icon: [576, 512, [], "e1f2", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c73.7-18.9 160.5-41.1 248.8-20.9l0-291.7C461.8 68.7 393.6 83 310.3 104.1c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0C223.1 126.4 136.3 148.7 48 128.4l0 291.7c66.2 23.1 134.4 8.9 217.7-12.3zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
};
const faChevronDown = {
  prefix: 'far',
  iconName: 'chevron-down',
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
};
const faBatteryFull = {
  prefix: 'far',
  iconName: 'battery-full',
  icon: [576, 512, [128267, "battery", "battery-5"], "f240", "M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm368 96L96 192l0 128 352 0 0-128z"]
};
const faBattery = faBatteryFull;
const faBattery5 = faBatteryFull;
const faBellPlus = {
  prefix: 'far',
  iconName: 'bell-plus',
  icon: [448, 512, [], "f849", "M224 0c-17.7 0-32 14.3-32 32l0 17.9C119.5 61.4 64 124.2 64 200l0 33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L256 32c0-17.7-14.3-32-32-32zm0 96l8 0c57.4 0 104 46.6 104 104l0 33.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-33.4c0-57.4 46.6-104 104-104l8 0zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM224 152c-13.3 0-24 10.7-24 24l0 40-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24z"]
};
const faBookArrowRight = {
  prefix: 'far',
  iconName: 'book-arrow-right',
  icon: [640, 512, [], "e0b9", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-56-48 0 0 56c0 4.4-3.6 8-8 8L80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 72 48 0 0-72c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM553 111c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L280 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
const faHospitals = {
  prefix: 'far',
  iconName: 'hospitals',
  icon: [576, 512, [], "f80e", "M320 48l192 0c8.8 0 16 7.2 16 16l0 192-208 0 0 48 208 0 0 48-208 0 0 48 208 0 0 48c0 8.8-7.2 16-16 16l-192 0c0 17.3-5.5 33.2-14.7 46.3c4.7 1.1 9.7 1.7 14.7 1.7l192 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L320 0c-35.3 0-64 28.7-64 64l0 1.6c19.5 4 36.5 15 48 30.4l0-32c0-8.8 7.2-16 16-16zm88 48l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM136 176c-8.8 0-16 7.2-16 16l0 24-24 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l24 0 0 24c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-24 24 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-24 0 0-24c0-8.8-7.2-16-16-16l-16 0zM64 144l160 0c8.8 0 16 7.2 16 16l0 192L48 352l0-192c0-8.8 7.2-16 16-16zM48 400l192 0 0 48c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-48zM0 160L0 448c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96C28.7 96 0 124.7 0 160z"]
};
const faClub = {
  prefix: 'far',
  iconName: 'club',
  icon: [512, 512, [9827], "f327", "M352 146.4c0-.8 0-1.6 0-2.4c0-53-43-96-96-96s-96 43-96 96c0 .8 0 1.6 0 2.4c.6 22.9-15.1 42.9-37.4 48C79.9 204.1 48 242.4 48 288c0 53 43 96 96 96c30.1 0 57-13.8 74.7-35.7c9.1-11.3 22.8-17.8 37.3-17.8s28.2 6.5 37.3 17.8C311 370.2 337.9 384 368 384c53 0 96-43 96-96c0-45.6-31.9-83.9-74.6-93.6c-22.3-5.1-37.9-25.1-37.4-48zM368 432c-27.9 0-53.9-7.9-76-21.7c-4.1-2.6-8.1-5.4-12-8.3l0 62 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-62c-3.8 3-7.8 5.8-12 8.3c-22.1 13.7-48.1 21.7-76 21.7C64.5 432 0 367.5 0 288c0-68.5 47.9-125.9 112-140.4c0-1.2 0-2.4 0-3.6C112 64.5 176.5 0 256 0s144 64.5 144 144c0 1.2 0 2.4 0 3.6c64.1 14.5 112 71.9 112 140.4c0 79.5-64.5 144-144 144z"]
};
const faSkullCrossbones = {
  prefix: 'far',
  iconName: 'skull-crossbones',
  icon: [448, 512, [128369, 9760], "f714", "M290.1 185.8C309.6 170.4 320 149.5 320 128c0-39-37.5-80-96-80s-96 41-96 80c0 21.5 10.4 42.4 29.9 57.8c11.4 9.1 18.1 22.9 18.1 37.6l0 8.6c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8l0-8.6c0-14.6 6.7-28.5 18.1-37.6zM320 232c0 30.9-25.1 56-56 56l-80 0c-30.9 0-56-25.1-56-56l0-8.6C98.5 200 80 165.9 80 128C80 57.3 144.5 0 224 0s144 57.3 144 128c0 37.9-18.5 72-48 95.4l0 8.6zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L224 357l188.9-98.2c11.8-6.1 26.2-1.5 32.4 10.2s1.5 26.3-10.2 32.4L276 384l159.1 82.7c11.8 6.1 16.3 20.6 10.2 32.4s-20.6 16.3-32.4 10.2L224 411 35.1 509.3c-11.8 6.1-26.3 1.5-32.4-10.2s-1.5-26.2 10.2-32.4L172 384 12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM160 136a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faDropletDegree = {
  prefix: 'far',
  iconName: 'droplet-degree',
  icon: [512, 512, ["dewpoint"], "f748", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0l-1.8 0c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zM400 112a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faDewpoint = faDropletDegree;
const faCodeCompare = {
  prefix: 'far',
  iconName: 'code-compare',
  icon: [512, 512, [], "e13a", "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 48 16 0c39.8 0 72-32.2 72-72l0-163.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3L456 320c0 66.3-53.7 120-120 120l-16 0 0 48zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-48-16 0c-39.8 0-72 32.2-72 72l0 163.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L56 192c0-66.3 53.7-120 120-120l16 0 0-48zM48 432a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faListUl = {
  prefix: 'far',
  iconName: 'list-ul',
  icon: [512, 512, ["list-dots"], "f0ca", "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm120 8c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"]
};
const faListDots = faListUl;
const faHandHoldingMagic = {
  prefix: 'far',
  iconName: 'hand-holding-magic',
  icon: [576, 512, [], "f6e5", "M176 76c0 15.5 12.5 28 28 28l84 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-84 0c-42 0-76-34-76-76s34-76 76-76L328 0c66.3 0 120 53.7 120 120s-53.7 120-120 120l-48 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l72 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L204 48c-15.5 0-28 12.5-28 28zm11.4 276c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faWatermelonSlice = {
  prefix: 'far',
  iconName: 'watermelon-slice',
  icon: [512, 512, [], "e337", "M0 408c0-6.4 2.5-12.5 7-17L391 7c9.4-9.4 24.6-9.4 33.9 0c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c-4.5-4.5-7-10.6-7-17zm58.7-.8c97.4 80.4 241.5 75.3 332.6-15.8s96.2-235.2 15.8-332.6L384.8 81.2C414.3 118.1 432 165 432 216c0 119.3-96.7 216-216 216c-51 0-97.9-17.7-134.8-47.2L58.7 407.2zM384 216c0-37.7-12.4-72.6-33.4-100.6l-26.3 26.3 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-57.4 57.4 15 15c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-15-15-26.3 26.3c28 21 62.9 33.4 100.6 33.4c92.8 0 168-75.2 168-168zm-52.7 12.7l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80l16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"]
};
const faCircleEllipsis = {
  prefix: 'far',
  iconName: 'circle-ellipsis',
  icon: [512, 512, [], "e10a", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm32 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faSchoolLock = {
  prefix: 'far',
  iconName: 'school-lock',
  icon: [640, 512, [], "e56f", "M306.7 4c8.1-5.4 18.6-5.4 26.6 0l138 92L568 96c39.8 0 72 32.2 72 72l0 104c0-38.1-19-71.7-48-91.9l0-12.1c0-13.3-10.7-24-24-24l-104 0c-4.7 0-9.4-1.4-13.3-4L320 52.8 189.3 140c-3.9 2.6-8.6 4-13.3 4L72 144c-13.3 0-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l184 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80 0 16c0 11.7 3.1 22.6 8.6 32l-8.6 0-128 0L72 512c-39.8 0-72-32.2-72-72L0 168c0-39.8 32.2-72 72-72l96.7 0 138-92zM112 192l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0 128l32 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zM240 192a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm80-48c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-8.8-7.2-16-16-16zm208 96c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32l0-48z"]
};
const faTowerCell = {
  prefix: 'far',
  iconName: 'tower-cell',
  icon: [576, 512, [], "e585", "M51.8 1.6c12.4 4.8 18.5 18.7 13.8 31C54.3 62 48 94.2 48 128s6.3 66 17.6 95.4c4.8 12.4-1.4 26.3-13.8 31s-26.3-1.4-31-13.8C7.4 205.8 0 167.8 0 128S7.4 50.2 20.8 15.4C25.6 3 39.5-3.2 51.8 1.6zm472.4 0c12.4-4.8 26.3 1.4 31 13.8C568.6 50.2 576 88.2 576 128s-7.4 77.8-20.8 112.6c-4.8 12.4-18.7 18.5-31 13.8s-18.5-18.7-13.8-31C521.7 194 528 161.8 528 128s-6.3-66-17.6-95.4c-4.8-12.4 1.4-26.3 13.8-31zM291.3 191.9c-1.1 .1-2.2 .1-3.3 .1s-2.2 0-3.3-.1L239.8 288l96.4 0-44.8-96.1zM195 384l186 0-22.4-48-141.2 0L195 384zm-22.4 48l-30.9 66.2c-5.6 12-19.9 17.2-31.9 11.6s-17.2-19.9-11.6-31.9L241.2 171.6C230.5 160.2 224 144.9 224 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 16.9-6.5 32.2-17.2 43.6L477.7 477.9c5.6 12 .4 26.3-11.6 31.9s-26.3 .4-31.9-11.6L403.4 432l-230.8 0zM163.3 73.6C156 90.2 152 108.6 152 128s4 37.8 11.3 54.4c5.3 12.1-.2 26.3-12.4 31.6s-26.3-.2-31.6-12.4C109.5 179 104 154.1 104 128s5.5-51 15.3-73.6c5.3-12.1 19.5-17.7 31.6-12.4s17.7 19.5 12.4 31.6zM456.7 54.4C466.5 77 472 101.9 472 128s-5.5 51-15.3 73.6c-5.3 12.1-19.5 17.7-31.6 12.4s-17.7-19.5-12.4-31.6c7.3-16.6 11.3-35 11.3-54.4s-4-37.8-11.3-54.4c-5.3-12.1 .2-26.3 12.4-31.6s26.3 .2 31.6 12.4z"]
};
const faSdCards = {
  prefix: 'far',
  iconName: 'sd-cards',
  icon: [448, 512, [], "e240", "M400 352l0-288c0-8.8-7.2-16-16-16L234.5 48c-4.2 0-8.3 1.7-11.3 4.7l-74.5 74.5c-3 3-4.7 7.1-4.7 11.3L144 352c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16zM114.7 93.3l74.5-74.5C201.3 6.7 217.5 0 234.5 0L384 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-213.5c0-17 6.7-33.3 18.7-45.3zM24 96c13.3 0 24 10.7 24 24l0 256c0 48.6 39.4 88 88 88l224 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-224 0C60.9 512 0 451.1 0 376L0 120c0-13.3 10.7-24 24-24zm280 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0l0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faJugBottle = {
  prefix: 'far',
  iconName: 'jug-bottle',
  icon: [640, 512, [], "e5fb", "M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72s10.7-24 24-24l8 0 0-24zm32 152c-44.2 0-80 35.8-80 80l0 192c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-192c0-44.2-35.8-80-80-80l-128 0zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm224 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zM472 64l80 0c13.3 0 24 10.7 24 24l0 40-128 0 0-40c0-13.3 10.7-24 24-24zM417 392c-.3-.2-.7-.4-1-.6L416 256c0-24.7-5.6-48.1-15.6-69c5.1-5.3 11.1-9.8 18-13l13.2-6.2c11-5.1 23-7.8 35.1-7.8l90.6 0c12.1 0 24.1 2.7 35.1 7.8l13.2 6.2c21 9.9 34.4 31 34.4 54.2c0 22.8-12.7 42.6-31.5 52.7C627.4 292 640 312.5 640 336c0 24.1-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56c0 35.3-28.7 64-64 64l-128 0c-17 0-32.5-6.7-44-17.5c7.6-13.8 12-29.6 12-46.5l0-55.4c.3-.2 .7-.4 1-.6z"]
};
const faDownLong = {
  prefix: 'far',
  iconName: 'down-long',
  icon: [320, 512, ["long-arrow-alt-down"], "f309", "M176.4 505.5c-9.2 8.7-23.7 8.7-32.9 0L14.6 384.1C5.3 375.3 0 363.1 0 350.3C0 324.7 20.7 304 46.3 304L80 304 80 56c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 248 33.7 0c25.6 0 46.3 20.7 46.3 46.3c0 12.8-5.3 25-14.6 33.7l-129 121.4zm93-153.5L216 352c-13.3 0-24-10.7-24-24l0-272c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 272c0 6.4-2.5 12.5-7 17s-10.6 7-17 7l-53.5 0L160 455 269.5 352z"]
};
const faLongArrowAltDown = faDownLong;
const faEnvelopes = {
  prefix: 'far',
  iconName: 'envelopes',
  icon: [576, 512, [], "e170", "M512 80L160 80c-8.8 0-16 7.2-16 16l0 7.8L321.4 235.2c4.2 3.1 9.3 4.8 14.6 4.8s10.4-1.7 14.6-4.8L528 103.8l0-7.8c0-8.8-7.2-16-16-16zm16 83.5L379.1 273.8C366.7 283 351.5 288 336 288s-30.7-5-43.1-14.2L144 163.5 144 320c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16l0-156.5zM160 32l352 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-352 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64zM24 96c13.3 0 24 10.7 24 24l0 224c0 48.6 39.4 88 88 88l320 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-320 0C60.9 480 0 419.1 0 344L0 120c0-13.3 10.7-24 24-24z"]
};
const faPhoneOffice = {
  prefix: 'far',
  iconName: 'phone-office',
  icon: [576, 512, [], "f67d", "M160 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16l-48 0zM104.6 32C115.6 12.9 136.3 0 160 0l48 0c23.7 0 44.4 12.9 55.4 32L320 32l24 0 24 0 144 0c35.3 0 64 28.7 64 64l0 48 0 24 0 24 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l40.6 0zM96 80L64 80c-8.8 0-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256-168 0c-22.1 0-40-17.9-40-40l0-72-48 0 0 272c0 35.3-28.7 64-64 64l-48 0c-35.3 0-64-28.7-64-64L96 80zm272 0l0 64 160 0 0-48c0-8.8-7.2-16-16-16L368 80zm16 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM352 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM480 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM448 400a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faRankingStar = {
  prefix: 'far',
  iconName: 'ranking-star',
  icon: [640, 512, [], "e561", "M353.8 54.1l52.3 7.5c9.3 1.4 13.2 12.9 6.4 19.8l-38 36.6 9 52.1c1.4 9.3-8.2 16.5-16.8 12.2l-46.6-24.4-46.9 24.8c-8.6 4.3-18.3-2.9-16.8-12.2l9-52.1-38-37c-6.8-6.8-2.9-18.3 6.4-19.8l52.3-7.5L309.8 6.3c4.3-8.6 16.5-8.3 20.4 0l23.6 47.8zM272 304l0 160 96 0 0-160-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-160zM48 368l0 96 96 0 0-96-96 0zM0 368c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm592 32l-96 0 0 64 96 0 0-64zm-96-48l96 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48z"]
};
const faChessKing = {
  prefix: 'far',
  iconName: 'chess-king',
  icon: [448, 512, [9818], "f43f", "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 40L59.6 144C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352l52.3 0L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6L224 192l164.4 0c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352l52.3 0 54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6L248 144l0-40 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM101.2 432l245.6 0 16.6 32L84.7 464l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3l-265 0c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512l302.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"]
};
const faNfcPen = {
  prefix: 'far',
  iconName: 'nfc-pen',
  icon: [576, 512, [], "e1fa", "M384 80L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l206.5 0-12 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 139.6-48 48L400 96c0-8.8-7.2-16-16-16zM289.3 394.3c-1.8 1.8-3.5 3.7-5 5.7L120 400c-22.1 0-40-17.9-40-40l0-208c0-22.1 17.9-40 40-40l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 192 192 0 0-192-72 0 0 54.4c14.3 8.3 24 23.8 24 41.6c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-17.8 9.7-33.3 24-41.6l0-62.4c0-22.1 17.9-40 40-40l88 0c22.1 0 40 17.9 40 40l0 163.6-78.7 78.7zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faPersonHarassing = {
  prefix: 'far',
  iconName: 'person-harassing',
  icon: [576, 512, [], "e549", "M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM96 209.5L44.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1S-3.4 287.7 3.1 276.2L61.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l35 0c26 0 50.6 11.5 67.3 31.4l81.7 97.2c8.5 10.1 7.2 25.3-2.9 33.8s-25.3 7.2-33.8-2.9L224 214.2 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.5zm80-33.4c-.9-.1-1.8-.1-2.7-.1L144 176l0 128 32 0 0-127.9zM304 32l56 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm116 56c33.1 0 60 26.9 60 60l0 96c0 31.8-24.7 57.8-56 59.9l0 .1c-.7 0-1.5 0-2.2 0c-.6 0-1.2 0-1.8 0c-5.7 0-11.1-.8-16.3-2.2c-19.6-4.4-37.5-15.1-50.7-30.7l-44.6-52.7-39.3 73c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l56-104c3.8-7 10.7-11.7 18.6-12.5s15.7 2.3 20.8 8.4L456 413l0-57c0-33.1 26.9-60 60-60zm1.4 167.9c6-.7 10.6-5.8 10.6-11.9l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12l0 96c0 5.2 3.2 9.5 7.8 11.2c1.8 .3 3.7 .6 5.6 .7zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"]
};
const faMagnifyingGlassPlay = {
  prefix: 'far',
  iconName: 'magnifying-glass-play',
  icon: [512, 512, [], "e660", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1zM161.8 130.1c5-2.9 11.1-2.8 16 0l110.2 64c4.9 2.9 8 8.1 8 13.8s-3 11-8 13.8l-110.2 64c-4.9 2.9-11.1 2.9-16 0s-8-8.1-8-13.9l0-128c0-5.7 3.1-11 8-13.9z"]
};
const faHatWinter = {
  prefix: 'far',
  iconName: 'hat-winter',
  icon: [512, 512, [], "f7a8", "M256 0c-12.7 0-23 9.8-23.9 22.2c-9.4-8.1-23.7-7.7-32.6 1.2s-9.4 23.2-1.2 32.6C185.8 57 176 67.3 176 80s9.8 23 22.2 23.9c-8.1 9.4-7.7 23.7 1.2 32.6s23.2 9.4 32.6 1.2C233 150.2 243.3 160 256 160s23-9.8 23.9-22.2c9.4 8.1 23.7 7.7 32.6-1.2s9.4-23.2 1.2-32.6C326.2 103 336 92.7 336 80s-9.8-23-22.2-23.9c8.1-9.4 7.7-23.7-1.2-32.6s-23.2-9.4-32.6-1.2C279 9.8 268.7 0 256 0zM48 416c-26.5 0-48 21.5-48 48s21.5 48 48 48l416 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416zM162.5 134.6C42.8 199.9 32 384 32 384l48.1 0c.1-1.5 .3-3.7 .6-6.3c.7-6.5 2-16 4.2-27.4c.9-4.9 2-10.1 3.2-15.5l36.3-18.1c2.3-1.1 4.9-1.1 7.2 0L167 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0L295 334.3c15.8 7.9 34.3 7.9 50.1 0l35.4-17.7c2.3-1.1 4.9-1.1 7.2 0l36.3 18.1c1.2 5.4 2.3 10.6 3.2 15.5c2.1 11.5 3.4 21 4.2 27.4c.3 2.6 .5 4.7 .6 6.3l48.1 0s-10.8-184.1-130.5-249.4c-2.5 9-7.3 17.5-14.4 24.6c-5.6 5.6-12.2 9.8-19.2 12.6c41 17.8 67.7 53.9 86 95.6c.6 1.3 1.2 2.7 1.7 4c-14.5-5.5-30.8-4.7-44.9 2.3l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L281 273.7c-15.8-7.9-34.3-7.9-50.1 0l-35.4 17.7c-2.3 1.1-4.9 1.1-7.2 0L153 273.7c-14.1-7-30.3-7.8-44.9-2.3c.6-1.3 1.2-2.7 1.7-4c18.4-41.7 45.1-77.8 86-95.6c-7-2.7-13.5-6.9-19.2-12.6c-7.1-7.1-11.9-15.6-14.4-24.6z"]
};
const faBrazilianRealSign = {
  prefix: 'far',
  iconName: 'brazilian-real-sign',
  icon: [512, 512, [], "e46c", "M400 0c13.3 0 24 10.7 24 24l0 41.2c14.6 1.7 29 5.4 42.7 10.9l14.2 5.7c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4l-14.3-5.7c-14.2-5.7-29.3-8.6-44.6-8.6L392 112c-30.9 0-56 25.1-56 56c0 23.5 14.7 44.6 36.8 52.6l70.7 25.7c41.1 14.9 68.4 54 68.4 97.7c0 52-38.2 95.1-88 102.8l0 41.2c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-42.2c-17.1-3-33.7-8.9-48.9-17.6l-27-15.4c-11.5-6.6-15.5-21.2-8.9-32.7s21.2-15.5 32.7-8.9l27 15.4c15.4 8.8 32.8 13.4 50.6 13.4l6.6 0c30.9 0 56-25.1 56-56c0-23.5-14.7-44.6-36.8-52.6l-70.7-25.7c-41.1-14.9-68.4-54-68.4-97.7c0-52 38.2-95.1 88-102.8L376 24c0-13.3 10.7-24 24-24zM0 56C0 42.7 10.7 32 24 32l96 0c75.1 0 136 60.9 136 136c0 59.4-38.1 109.9-91.1 128.4l57.5 151c4.7 12.4-1.5 26.3-13.9 31s-26.3-1.5-31-13.9L116.4 304 48 304l0 152c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 280 0 56zM48 256l72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L48 80l0 176z"]
};
const faLandmarkDome = {
  prefix: 'far',
  iconName: 'landmark-dome',
  icon: [512, 512, ["landmark-alt"], "f752", "M256 0c13.3 0 24 10.7 24 24l0 9.5C369.5 44.6 439.9 117.4 447.3 208l8.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0-288 0-48 0-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8.7 0C72.1 117.4 142.5 44.6 232 33.5l0-9.5c0-13.3 10.7-24 24-24zM112.9 208l286.2 0c-8-72-69-128-143.1-128s-135.2 56-143.1 128zm-.9 80l0 96 64 0 0-96 48 0 0 96 64 0 0-96 48 0 0 96 64 0 0-96 48 0 0 96 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L64 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-96 48 0zM8 488c0-13.3 10.7-24 24-24l456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 512c-13.3 0-24-10.7-24-24z"]
};
const faLandmarkAlt = faLandmarkDome;
const faBoneBreak = {
  prefix: 'far',
  iconName: 'bone-break',
  icon: [640, 512, [], "f5d8", "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zM201 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L201 71zM473 105c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48zM296.1 264.8c-1.9-13.4-14.5-22.6-27.9-20.2L180.1 260c-4.1 .7-8-1.8-9.4-5.7c-14.3-39.1-55.3-63.6-98-56.1C24.9 206.6-7.1 251.8 1.4 299.3c4.5 25.1 19.3 45.7 39.4 58.4c4.7 3 5.8 9.5 2.5 13.9c-14.5 18.7-21.3 43.2-16.8 68.3c8.4 47.5 54.1 79.1 101.9 70.8c42.7-7.5 72.8-44.4 72.7-86c0-4.1 2.8-7.8 6.9-8.5L320 396.6l112.1 19.6c4.1 .7 6.9 4.4 6.9 8.5c-.1 41.6 30 78.5 72.7 86c47.9 8.4 93.5-23.3 101.9-70.8c4.5-25.1-2.4-49.5-16.8-68.3c-3.4-4.4-2.2-11 2.5-13.9c20.1-12.7 34.9-33.4 39.4-58.4c8.4-47.5-23.5-92.7-71.4-101.1c-42.7-7.5-83.7 17-98 56.1c-1.4 3.9-5.3 6.4-9.4 5.7l-88.1-15.4c-13.3-2.3-26 6.8-27.9 20.2c-1.8 12.8 6.9 24.8 19.6 27l88.1 15.4c29.1 5.1 54.1-12.9 62.8-36.5c6.4-17.4 24.9-28.7 44.6-25.3c22.1 3.9 36.1 24.4 32.4 45.4c-2 11.2-8.5 20.4-17.8 26.3c-28.5 18-35.6 57-14.8 83.8c6.6 8.5 9.5 19.4 7.6 30.5c-3.7 21.1-24.3 35.8-46.4 31.9c-19.6-3.4-33-20.2-33-38.6c0-25.3-17.4-50.8-46.6-55.9L324.8 348.7c-1.6-.3-3.2-.4-4.8-.4c-1.6 0-3.2 .1-4.8 .4L199.7 368.9C170.5 374 153 399.5 153 424.8c0 18.4-13.4 35.2-33 38.6c-22.2 3.9-42.7-10.8-46.4-31.9c-2-11.1 1-22 7.6-30.5c20.8-26.9 13.7-65.9-14.8-83.8c-9.2-5.8-15.8-15.1-17.8-26.3c-3.7-20.9 10.3-41.5 32.4-45.4c19.7-3.4 38.3 7.9 44.6 25.3c8.6 23.6 33.7 41.6 62.8 36.5l88.1-15.4c12.8-2.2 21.5-14.2 19.6-27z"]
};
const faArrowUp = {
  prefix: 'far',
  iconName: 'arrow-up',
  icon: [384, 512, [8593], "f062", "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"]
};
const faDownFromDottedLine = {
  prefix: 'far',
  iconName: 'down-from-dotted-line',
  icon: [448, 512, [], "e407", "M114.2 320L224 430 333.8 320 280 320c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 480c-11.5 0-22.5-4.6-30.6-12.7L77.6 351.2C68.9 342.5 64 330.7 64 318.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 467.3c-8.1 8.1-19.1 12.7-30.6 12.7zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96 0a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm64-32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faTv = {
  prefix: 'far',
  iconName: 'tv',
  icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM120 464l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-400 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faTelevision = faTv;
const faTvAlt = faTv;
const faBorderLeft = {
  prefix: 'far',
  iconName: 'border-left',
  icon: [448, 512, [], "f84f", "M24 480c-13.3 0-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24zm104-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM224 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
};
const faCircleDivide = {
  prefix: 'far',
  iconName: 'circle-divide',
  icon: [512, 512, [], "e106", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-88 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM288 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faShrimp = {
  prefix: 'far',
  iconName: 'shrimp',
  icon: [512, 512, [129424], "e448", "M0 104C0 64.2 32.2 32 72 32l352 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l264 0c97.2 0 176 78.8 176 176s-78.8 176-176 176l-88 0c-13.3 0-24-10.7-24-24c0-12 8.8-21.9 20.2-23.7l-4.9-1.9c-12.4-4.8-18.5-18.7-13.7-31.1s18.7-18.5 31.1-13.7l68.7 26.7c20.5 8 42.6-7.1 42.6-29.1c0-17.3-14-31.2-31.2-31.2l-77.3 0C158 352 74.5 274.6 64.9 175.7C28.5 172.1 0 141.4 0 104zM464 304c0-9.3-1-18.4-2.9-27.2L401 336.9c9.4 13 15 29 15 46.3c0 8.2-1.2 16-3.4 23.4C443.8 383.3 464 346 464 304zm-23.7-74.2c-21.8-30.5-56.6-51.1-96.3-53.5l0 128.1c6.2 .6 12.2 1.8 18 3.8l78.3-78.3zM296 176l-182.7 0c9.5 72.2 71.4 128 146.2 128l36.5 0 0-128zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faListCheck = {
  prefix: 'far',
  iconName: 'list-check',
  icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L216 72c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faTasks = faListCheck;
const faDiagramSubtask = {
  prefix: 'far',
  iconName: 'diagram-subtask',
  icon: [512, 512, [], "e479", "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-296 0 0 96c0 22.1 17.9 40 40 40l32 0 0-8c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-8-32 0c-48.6 0-88-39.4-88-88l0-96-40 0c-35.3 0-64-28.7-64-64L0 96zM448 336l-160 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z"]
};
const faJugDetergent = {
  prefix: 'far',
  iconName: 'jug-detergent',
  icon: [384, 512, [], "e519", "M120 0C106.7 0 96 10.7 96 24l0 24-8 0C74.7 48 64 58.7 64 72s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-24c0-13.3-10.7-24-24-24L120 0zM256 176c44.2 0 80 35.8 80 80l0 192c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-192c0-44.2 35.8-80 80-80l128 0zM128 128C57.3 128 0 185.3 0 256L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-192c0-70.7-57.3-128-128-128l-128 0zm128 96c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32z"]
};
const faCircleUser = {
  prefix: 'far',
  iconName: 'circle-user',
  icon: [512, 512, [62142, "user-circle"], "f2bd", "M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
};
const faUserCircle = faCircleUser;
const faSquareY = {
  prefix: 'far',
  iconName: 'square-y',
  icon: [448, 512, [], "e287", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm138.1 56.3L224 251.4l85.9-99.1c8.7-10 23.8-11.1 33.9-2.4s11.1 23.8 2.4 33.9L248 297l0 79c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-79L101.9 183.7c-8.7-10-7.6-25.2 2.4-33.9s25.2-7.6 33.9 2.4z"]
};
const faUserDoctorHair = {
  prefix: 'far',
  iconName: 'user-doctor-hair',
  icon: [448, 512, [], "e458", "M304 128l0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16c0-5.5 .6-10.8 1.6-16l30.4 0c29.8 0 55.9-16.3 69.6-40.5C257.3 86.4 275.5 96 296 96l1.3 0c4.3 9.8 6.7 20.6 6.7 32zM96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm64 225c5.2-.7 10.6-1 16-1l96 0c5.4 0 10.8 .3 16 1l0 49c-27.6 7.1-48 32.2-48 62l0 32c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-32c0-29.8-20.4-54.9-48-62l0-40.7c46.9 19 80 65 80 118.7l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-97.2-78.8-176-176-176l-96 0C78.8 304 0 382.8 0 480l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c0-53.7 33.1-99.7 80-118.7l0 41c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7l0-49.3zm-16 79a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPlanetRinged = {
  prefix: 'far',
  iconName: 'planet-ringed',
  icon: [512, 512, [129680], "e020", "M464 31.1c0 0 .1 .2 .1 .8c-.1-.5-.1-.8-.1-.8zm-5.2 22.1c-11.9 4.4-27 11.5-45 21.9c-13.4-11.8-27.9-21.8-43-30c63.8-40.5 113.9-56.2 133.1-37c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208c-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1c8.3 15.1 18.3 29.6 30 43c-10.4 18-17.6 33-21.9 45c12.6-4.6 28.7-12.3 48.1-23.8c8.2-4.8 16.7-10.2 25.4-16C78.8 380.9 48 322 48 256C48 141.1 141.1 48 256 48c66 0 124.9 30.8 163 78.8c5.8-8.8 11.2-17.3 16-25.4c11.4-19.4 19.2-35.5 23.8-48.1zM389.6 167.9C361 124.6 311.8 96 256 96C167.6 96 96 167.6 96 256c0 55.8 28.6 105 71.9 133.6c37.1-28.2 77.4-63.4 117.8-103.8s75.6-80.8 103.8-117.8zM217.9 411.4c12.2 3 25 4.6 38.1 4.6c88.4 0 160-71.6 160-160c0-13.1-1.6-25.9-4.6-38.1c-26.5 33-57.4 67.5-91.7 101.8s-68.8 65.2-101.8 91.7zM31.1 464c0 0 .3 0 .8 .1c-.6 0-.8 0-.8-.1zm16.8 16c.1 .5 .1 .8 .1 .8s-.1-.2-.1-.8zM480 47.9c.6 0 .8 0 .8 .1s-.3 0-.8-.1z"]
};
const faMushroom = {
  prefix: 'far',
  iconName: 'mushroom',
  icon: [512, 512, [127812], "e425", "M24 258.1C24 133.2 125.2 32 250.1 32l11.8 0C386.8 32 488 133.2 488 258.1c0 34.2-27.7 61.9-61.9 61.9l-105.5 0-129.1 0L85.9 320C51.7 320 24 292.3 24 258.1zm416 0c0-12-1.2-23.7-3.4-35C427.8 233.4 414.6 240 400 240c-26.5 0-48-21.5-48-48c0-26.1 20.8-47.3 46.7-48c-24.2-29-57.5-50.2-95.4-59.2c.5 3.7 .8 7.4 .8 11.2c0 44.2-35.8 80-80 80c-38.1 0-70-26.7-78.1-62.4C101.2 146 72 198.6 72 258.1c0 7.7 6.2 13.9 13.9 13.9l340.2 0c7.7 0 13.9-6.2 13.9-13.9zM234.3 352l-15 80 73.4 0-15-80 48.8 0 16.9 90.1c1.8 9.4-.7 19-6.8 26.3s-15.1 11.6-24.6 11.6l-112 0c-9.5 0-18.5-4.2-24.6-11.6s-8.6-17-6.8-26.3L185.4 352l48.8 0zM144 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faUserShield = {
  prefix: 'far',
  iconName: 'user-shield',
  icon: [640, 512, [], "f505", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l325.4 0c13.2 17.2 29.3 33.4 48.9 47.5c-1.7 .3-3.5 .5-5.3 .5L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c17.6 0 34.6 2.6 50.7 7.3c.9 16.6 3.4 35.3 8.3 54.8c-17.7-9-37.8-14.1-59-14.1l-91.4 0c-65.7 0-120.1 48.7-129 112zM487.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C634 277.4 640 286.2 640 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48zM591.4 312L496 273.8l0 187.8c68.2-33 91.5-99 95.4-149.7z"]
};
const faMegaphone = {
  prefix: 'far',
  iconName: 'megaphone',
  icon: [576, 512, [128227], "f675", "M552 32c-13.3 0-24 10.7-24 24l0 5.7L48 192.6l0-8.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 21.7L0 224l0 64 0 18.3L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8.6 117.6 32.1C162 361.7 160 372.6 160 384c0 53 43 96 96 96c46.9 0 86-33.6 94.3-78.1L528 450.3l0 5.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 0-352 0-24c0-13.3-10.7-24-24-24zM528 400.6L48 269.7l0-27.3L528 111.4l0 289.2zM208 384c0-7.1 1.5-13.8 4.3-19.8l91.5 24.9c-2.6 24.1-23 42.8-47.7 42.8c-26.5 0-48-21.5-48-48z"]
};
const faWreathLaurel = {
  prefix: 'far',
  iconName: 'wreath-laurel',
  icon: [640, 512, [], "e5d2", "M237.1 50.9l-11.8 .7c-20.3 1.1-36.6 17.4-37.7 37.7l-.7 11.8 11.8-.7c20.3-1.1 36.6-17.4 37.7-37.7l.7-11.8zM43.1 177.7c-11.4-30.3-9.7-65.3 7.8-95.6L71.5 46.4c6.3-10.9 20.2-14.6 31-8.3c15.9 9.2 28.9 21.4 38.8 35.5c8-38.5 41-67.7 81.3-70l38.6-2.1c14.3-.8 26.1 11 25.3 25.3l-2.1 38.6c-2.5 44.8-38.2 80.5-83 83l-24.6 1.4C155.6 180.8 144 217.8 144 256c0 97.2 78.8 176 176 176l11.6 0c43.5 0 86.3 10.1 125.2 29.6l9.9 5c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-9.9-5C403.1 488.4 367.6 480 331.6 480L320 480l-11.6 0c-36 0-71.5 8.4-103.8 24.5l-9.9 5c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l9.9-5c8.3-4.2 16.8-7.9 25.4-11.2c-5.5-3.1-10.8-6.5-15.9-10.1l-4.8 2.8-.3 .2c-4.6 2.7-9.4 4.9-14.2 6.9c-50.9 20.4-110.3 .8-138.5-48L14.2 366.4c-6.3-10.9-2.6-24.8 8.3-31c6-3.5 12.2-6.4 18.5-8.7C16 306.1 0 274.9 0 240l0-41.2C0 186.2 10.2 176 22.7 176c7 0 13.8 .6 20.4 1.7zm420-28l-24.6-1.4c-44.8-2.5-80.5-38.2-83-83l-2.1-38.6c-.8-14.3 11-26.1 25.3-25.3l38.6 2.1c40.3 2.2 73.3 31.5 81.3 70c9.9-14.1 22.9-26.3 38.8-35.5c10.9-6.3 24.8-2.6 31 8.3l20.6 35.7c17.5 30.3 19.2 65.3 7.8 95.6c6.6-1.1 13.4-1.7 20.4-1.7c12.6 0 22.7 10.2 22.7 22.7l0 41.2c0 34.9-16 66.1-41.1 86.7c6.3 2.3 12.5 5.2 18.5 8.7c10.9 6.3 14.6 20.2 8.3 31l-20.6 35.7c-21.6 37.4-61.5 57.6-101.8 55.9c-5.3-8.3-12.8-15.4-22.3-20.1l-9.9-5c-2.8-1.4-5.7-2.8-8.6-4.1c-10.4-4.8-21-9-31.8-12.6c-7.9-2.7-15.9-5-24-7C460 378.9 496 321.7 496 256c0-38.2-11.6-75.2-32.8-106.3zM414.7 51.6l-11.8-.7 .7 11.8c1.1 20.3 17.4 36.6 37.7 37.7l11.8 .7-.7-11.8c-1.1-20.3-17.4-36.6-37.7-37.7zM96 301.9l0-4.7c0-31.6-20-58.5-48-68.8L48 240c0 29.8 20.4 54.9 48 62zM544 297.2l0 4.7c27.6-7.1 48-32.2 48-62l0-11.5c-28 10.3-48 37.2-48 68.8zM149 407.8l-2.4-4.1c-15.8-27.3-46.5-40.6-75.9-35.6l5.7 9.9c14.9 25.8 45.1 37.3 72.5 29.7zM105.4 179.7c15.8-27.3 11.9-60.6-7.2-83.5l-5.7 9.9c-14.9 25.8-9.8 57.7 10.6 77.7l2.4-4.1zM537 183.8c20.3-20 25.5-51.8 10.6-77.7l-5.7-9.9c-19.1 22.9-22.9 56.2-7.2 83.5l2.4 4.1zM491 407.8c27.4 7.6 57.6-3.9 72.5-29.7l5.7-9.9c-29.4-5.1-60.1 8.2-75.9 35.6l-2.4 4.1z"]
};
const faCircleExclamationCheck = {
  prefix: 'far',
  iconName: 'circle-exclamation-check',
  icon: [640, 512, [], "e10d", "M48 256C48 141.1 141.1 48 256 48c84.1 0 156.7 50 189.4 121.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8C448.8 61.6 359.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c72.9 0 138.8-30.5 185.4-79.4c9.1-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8C368.7 439.2 315.3 464 256 464C141.1 464 48 370.9 48 256zM280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM625 175c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L625 209c9.4-9.4 9.4-24.6 0-33.9z"]
};
const faWind = {
  prefix: 'far',
  iconName: 'wind',
  icon: [512, 512, [], "f72e", "M288 24c0 13.3 10.7 24 24 24l44 0c24.3 0 44 19.7 44 44s-19.7 44-44 44L24 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l332 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L312 0c-13.3 0-24 10.7-24 24zm64 368c0 13.3 10.7 24 24 24l44 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l396 0c24.3 0 44 19.7 44 44s-19.7 44-44 44l-44 0c-13.3 0-24 10.7-24 24zM120 512l44 0c50.8 0 92-41.2 92-92s-41.2-92-92-92L24 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l140 0c24.3 0 44 19.7 44 44s-19.7 44-44 44l-44 0c-13.3 0-24 10.7-24 24s10.7 24 24 24z"]
};
const faBoxDollar = {
  prefix: 'far',
  iconName: 'box-dollar',
  icon: [448, 512, ["box-usd"], "f4a0", "M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zm-5.7 128L400 208l0 208c0 8.8-7.2 16-16 16l-141.7 0c1.1-2.5 1.7-5.2 1.7-8l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15c0 0 0 0 0 0l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9c0-2.8-.6-5.6-1.7-8zm-36.7 0c-1.1 2.4-1.7 5.2-1.7 8l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 2.8 .6 5.5 1.7 8L64 432c-8.8 0-16-7.2-16-16l0-208 157.7 0zM200 160L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70z"]
};
const faBoxUsd = faBoxDollar;
const faCarBurst = {
  prefix: 'far',
  iconName: 'car-burst',
  icon: [640, 512, ["car-crash"], "f5e1", "M197.2 20.7l30.1 56.7 63.1-11.8c1-.2 2.1-.3 3.1-.4c-3.6 4.1-7 8.4-10.2 13l-29.3 43-35.2 6.6c-10.3 1.9-20.7-3.1-25.6-12.3L176 83.2l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c1.9-1.4 3.9-2.4 6-3.2l-19.5 72.7-24 17.7c-7.2 5.3-16.6 6.1-24.6 2.3s-13.2-11.8-13.6-20.7l-2.5-64.2L21.6 241c-8.6-2.3-15.2-9.2-17.1-17.8s1-17.7 7.7-23.5l48.6-42L35.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C159 12.9 167.1 8 176 8s17 4.9 21.2 12.7zM536.5 148.5l-137-36.7c-16.4-4.4-33.8 2.1-43.4 16.1l-31 45.5c1.3 .3 2.5 .6 3.8 .9l237.6 63.7c1.3 .3 2.5 .7 3.7 1.1L566 184.1c-1.3-17-13.1-31.2-29.5-35.6zm77.4 32.1l7.2 96.4c15 22.2 20.7 50.6 13.2 78.6l-12.3 46-6.9 25.7-5.5 20.7-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.4-14.2-14.5-25.1l12.4-46.3-6.7-1.8L232.9 346.9l-6.7-1.8-12.4 46.3c-2.9 11-14.2 17.5-25.1 14.5s-17.5-14.2-14.5-25.1l12.4-46.3 12.4-46.4 12.3-46c7.5-28 26.6-49.7 50.7-61.5l54.5-79.9c21.1-30.9 59.4-45.1 95.5-35.4l137 36.7c36.1 9.7 62.2 41.1 65 78.4zM554 284.3L316.4 220.6c-25.6-6.9-51.9 8.3-58.8 33.9l-12.3 46 330.3 88.5 12.3-46c6.9-25.6-8.3-51.9-33.9-58.8zm14.3 53.3a27.4 27.4 0 1 1 -52.9-14.2 27.4 27.4 0 1 1 52.9 14.2zM310.9 240.3a27.4 27.4 0 1 1 -14.2 52.9 27.4 27.4 0 1 1 14.2-52.9z"]
};
const faCarCrash = faCarBurst;
const faY = {
  prefix: 'far',
  iconName: 'y',
  icon: [384, 512, [121], "59", "M43.4 41.9C35.7 31.2 20.7 28.8 9.9 36.6S-3.2 59.3 4.6 70.1L168 295.8 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160.2L379.4 70.1c7.8-10.7 5.4-25.7-5.4-33.5s-25.7-5.4-33.5 5.4L192 247.1 43.4 41.9z"]
};
const faUserHeadset = {
  prefix: 'far',
  iconName: 'user-headset',
  icon: [448, 512, [], "f82d", "M224 32C135.6 32 64 103.6 64 192l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16C32 86 118 0 224 0S416 86 416 192l0 16c0 61.9-50.1 112-112 112l-64 0-16 0-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l32 0c44.2 0 80-35.8 80-80l0-16c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128c0 13.9-2.2 27.3-6.3 39.8C337.4 246.3 321.8 256 304 256l-8.6 0c-2.7-4.7-6.1-9.1-9.9-12.9C297.1 229.2 304 211.4 304 192c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.4 6.9 37.2 18.4 51.1C151 254.6 144 270.5 144 288c0 1.4 0 2.7 .1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zM208 352l16 0 16 0 57.4 0 6.6 0 9.6 0C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6L25.6 512C11.5 512 0 500.5 0 486.4C0 412.2 60.2 352 134.4 352l16.2 0 57.4 0zm105.6 48l-179.2 0c-40 0-73.6 27.1-83.5 64l346.1 0c-9.9-36.9-43.5-64-83.5-64z"]
};
const faArrowsRetweet = {
  prefix: 'far',
  iconName: 'arrows-retweet',
  icon: [640, 512, ["retweet-alt"], "f361", "M145 71c-9.4-9.4-24.6-9.4-33.9 0L23 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L104 328c0 48.6 39.4 88 88 88l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0c-22.1 0-40-17.9-40-40l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L145 71zM312 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c22.1 0 40 17.9 40 40l0 182.1-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0l88-88c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47L536 184c0-48.6-39.4-88-88-88L312 96z"]
};
const faRetweetAlt = faArrowsRetweet;
const faPersonSnowboarding = {
  prefix: 'far',
  iconName: 'person-snowboarding',
  icon: [512, 512, [127938, "snowboarding"], "f7ce", "M204.3 3c11.6-6.4 26.2-2.3 32.6 9.3l31.9 57.4c1.3 2.3 3.6 3.8 6.2 4.1l33.8 3.4c24.1 2.4 46.9 12 65.4 27.6L503.5 213.6c10.1 8.5 11.4 23.7 2.9 33.8s-23.7 11.4-33.8 2.9l-68.2-57.5-82.3 43.9 24.7 18.9c24.9 19 34.6 51.9 24.1 81.4l-28.2 79c-1.4 3.8-3.6 7-6.3 9.6l93.3 35.7c4.6 1.8 9.4 2.6 14.3 2.6l28.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-28.2 0c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l19.4 7.4c-2.9-11.4 2.9-23.4 14-28.1L192 272l0-68.2c0-21.2 12-40.6 31-50.1L284.4 123l-14.1-1.4c-18.3-1.8-34.5-12.5-43.4-28.5L195 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zm91.8 407.2c-.3-3.4 .1-6.9 1.3-10.3l28.2-79c3.5-9.8 .3-20.8-8-27.1L240 234.4l0 42.9c0 16.1-9.7 30.7-24.6 36.9L134 348.2l162.1 62.1zM259.6 189l20.5 15.7 84.6-45.1-17.2-14.5L259.6 189zM384 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faSnowboarding = faPersonSnowboarding;
const faSquareChevronRight = {
  prefix: 'far',
  iconName: 'square-chevron-right',
  icon: [448, 512, ["chevron-square-right"], "f32b", "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM313 273L209 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L313 239c9.4 9.4 9.4 24.6 0 33.9z"]
};
const faChevronSquareRight = faSquareChevronRight;
const faLacrosseStickBall = {
  prefix: 'far',
  iconName: 'lacrosse-stick-ball',
  icon: [576, 512, [], "e3b6", "M344 48s0 0 0 0l.3 0c22.9 0 53 15.2 78.8 40.9s40.9 55.9 40.9 78.8l0 .3s0 0 0 0c0 37.4-24 70.7-59.5 82.5l-19.7 6.6c-18.9 6.3-36.5 16-51.9 28.6l-42 34.4c-12.6 10.3-28.3 15.9-44.5 15.9c-38.8 0-70.3-31.5-70.3-70.3c0-16.2 5.6-32 15.9-44.5l34.4-42c12.6-15.4 22.3-33 28.6-51.9l6.6-19.7C273.3 72 306.6 48 344 48zm0-48s0 0 0 0C285.9 0 234.3 37.2 215.9 92.3L209.4 112c-4.5 13.4-11.3 25.8-20.2 36.7l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9c0 24 7.1 46.3 19.4 65L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L181.4 364.6c18.6 12.3 41 19.4 65 19.4c27.3 0 53.8-9.4 74.9-26.7l42-34.4c10.9-8.9 23.3-15.8 36.7-20.2l19.7-6.6c55.1-18.4 92.3-70 92.3-128.1c0 0 0 0 0 0l0-.3c0-40.8-24.8-82.5-55-112.7S385.1 0 344.3 0L344 0zM464 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faTruckFast = {
  prefix: 'far',
  iconName: 'truck-fast',
  icon: [640, 512, ["shipping-fast"], "f48b", "M352 48L128 48c-8.8 0-16 7.2-16 16l0 32 128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-32C64 28.7 92.7 0 128 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96s-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96l0-48 0-80 48 0 0 44.8c14.1-8.2 30.5-12.8 48-12.8c35.5 0 66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM557.7 239.6l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0-.2-.2-.2-.2zM208 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm272 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM48 160l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 192c-8.8 0-16-7.2-16-16s7.2-16 16-16zM16 224l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faShippingFast = faTruckFast;
const faUserMagnifyingGlass = {
  prefix: 'far',
  iconName: 'user-magnifying-glass',
  icon: [640, 512, [], "e5c5", "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM49.3 464c8.9-63.3 63.3-112 129-112l91.4 0c7.5 0 14.8 .6 21.9 1.8c-2.3-10.9-3.6-22.2-3.6-33.8c0-5.1 .2-10.1 .7-15c-6.2-.7-12.6-1-19-1l-91.4 0C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7c0-.8 0-1.5 0-2.3c-25 0-48.7-5.8-69.8-16L49.3 464zM448 240.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faStarSharp = {
  prefix: 'far',
  iconName: 'star-sharp',
  icon: [576, 512, [], "e28b", "M288 0c10.5 0 19.7 6.8 22.9 16.7L361.5 176 520 176c10.3 0 19.4 6.5 22.7 16.2s.1 20.4-8 26.7L403.9 320.7l50.9 160.1c3.2 10-.5 21-9.1 27s-20.2 5.7-28.5-.7L288 406.4 158.7 506.9c-8.3 6.5-19.8 6.8-28.5 .7s-12.3-16.9-9.1-27l50.9-160.1L41.3 218.9c-8.1-6.3-11.3-17-8-26.7S45.7 176 56 176l158.5 0L265.1 16.7C268.3 6.8 277.5 0 288 0zm0 103.2L254.9 207.3c-3.2 10-12.4 16.7-22.9 16.7l-106.1 0 88.8 69.1c7.9 6.2 11.2 16.6 8.1 26.2L190.3 421.6l82.9-64.5c8.7-6.7 20.8-6.7 29.5 0l82.9 64.5L353.1 319.3c-3-9.6 .2-20 8.1-26.2L450.1 224 344 224c-10.5 0-19.7-6.8-22.9-16.7L288 103.2z"]
};
const faCommentHeart = {
  prefix: 'far',
  iconName: 'comment-heart',
  icon: [512, 512, [], "e5c8", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM205.3 160c-33.8 0-61.3 27.4-61.3 61.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"]
};
const faCircle1 = {
  prefix: 'far',
  iconName: 'circle-1',
  icon: [512, 512, [], "e0ee", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM268 131.2c7.4 4.3 12 12.2 12 20.8l0 184 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 0-142.6-20.1 11.5c-11.5 6.6-26.2 2.6-32.7-8.9s-2.6-26.2 8.9-32.7l56-32c7.4-4.2 16.6-4.2 24 .1z"]
};
const faCircleStar = {
  prefix: 'far',
  iconName: 'circle-star',
  icon: [512, 512, ["star-circle"], "e123", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-391c-6.1 0-11.7 3.5-14.3 8.9l-31.3 63.3-69.9 10.2c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4L182.2 280l-11.9 69.6c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.9 1.2L256 333.6l62.5 32.9c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.6L329.8 280l50.6-49.3c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-69.9-10.2-31.3-63.3c-2.7-5.5-8.3-8.9-14.3-8.9z"]
};
const faStarCircle = faCircleStar;
const faFish = {
  prefix: 'far',
  iconName: 'fish',
  icon: [576, 512, [128031], "f578", "M180.8 303.7c9.2 10.4 19.4 20.6 30.7 30.1c33.7 28.5 76 50.2 124.5 50.2s90.8-21.8 124.5-50.2c30.3-25.5 52.7-55.7 65.3-77.8c-12.6-22.1-35-52.2-65.3-77.8C426.8 149.7 384.5 128 336 128s-90.8 21.7-124.5 50.2c-11.3 9.5-21.5 19.7-30.7 30.1c-14 15.8-36.7 20.6-56 11.8L70.6 195.3l21.1 36.9c8.4 14.8 8.4 32.9 0 47.6L70.6 316.7l54.3-24.9c19.2-8.8 41.9-4 56 11.8zM4.2 336.1L50 256 4.2 175.9c-6.9-12.1-5.2-27.2 4.2-37.5s24.3-13.3 36.9-7.5l99.5 45.6c10.5-11.9 22.5-23.8 35.7-35C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-13.2-11.2-25.1-23.1-35.7-35L45.3 381.1c-12.6 5.8-27.6 2.8-36.9-7.5S-2.7 348.2 4.2 336.1zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faCloudFog = {
  prefix: 'far',
  iconName: 'cloud-fog',
  icon: [640, 512, [127787, "fog"], "f74e", "M176 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C137.3 270.4 112 244.2 112 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM248 0C184 0 131.7 50.1 128.2 113.3C90.4 130.1 64 167.9 64 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C470.5 55 430.9 24 384 24c-18 0-34.9 4.6-49.7 12.6C312.5 14.1 281.9 0 248 0zM0 392c0 13.3 10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 368c-13.3 0-24 10.7-24 24zm64 96c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 464c-13.3 0-24 10.7-24 24zm208 0c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-13.3 0-24 10.7-24 24z"]
};
const faFog = faCloudFog;
const faWaffle = {
  prefix: 'far',
  iconName: 'waffle',
  icon: [512, 512, [129479], "e466", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 112l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 64 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 64 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-64 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-64-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128l64 0 0-64-64 0 0 64zm96 0l64 0 0-64-64 0 0 64zm0 32l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64z"]
};
const faMusicNote = {
  prefix: 'far',
  iconName: 'music-note',
  icon: [384, 512, ["music-alt"], "f8cf", "M384 31.1C384 13.9 370.1 0 352.9 0c-2.7 0-5.3 .3-7.9 1L193.9 40.8C183.3 43.6 176 53.1 176 64l0 302.3c-18.1-9-40.2-14.3-64-14.3C50.1 352 0 387.8 0 432s50.1 80 112 80s112-35.8 112-80l0-236.6 141.9-36.1C376.6 156.6 384 147 384 136l0-104.9zM176 432c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C49.4 441.4 48 434.6 48 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM336 117.3L224 145.8l0-63.3L336 53l0 64.3z"]
};
const faMusicAlt = faMusicNote;
const faHexagonExclamation = {
  prefix: 'far',
  iconName: 'hexagon-exclamation',
  icon: [512, 512, [], "e417", "M17.1 292c-12.9-22.3-12.9-49.7 0-72L105.4 67.1c12.9-22.3 36.6-36 62.4-36l176.6 0c25.7 0 49.5 13.7 62.4 36L494.9 220c12.9 22.3 12.9 49.7 0 72L406.6 444.9c-12.9 22.3-36.6 36-62.4 36l-176.6 0c-25.7 0-49.5-13.7-62.4-36L17.1 292zm41.6-48c-4.3 7.4-4.3 16.6 0 24l88.3 152.9c4.3 7.4 12.2 12 20.8 12l176.6 0c8.6 0 16.5-4.6 20.8-12L453.4 268c4.3-7.4 4.3-16.6 0-24L365.1 91.1c-4.3-7.4-12.2-12-20.8-12l-176.6 0c-8.6 0-16.5 4.6-20.8 12L58.6 244zM256 128c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faCartShoppingFast = {
  prefix: 'far',
  iconName: 'cart-shopping-fast',
  icon: [640, 512, [], "e0dc", "M64 24C64 10.7 74.7 0 88 0l45.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L552 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5l-51.6-271c-.7-3.8-4-6.5-7.9-6.5L88 48C74.7 48 64 37.3 64 24zM225.6 240l297.6 0c10.9 0 20.4-7.3 23.2-17.8L584.7 80 195.1 80l30.5 160zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM24 96l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 304c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faObjectUnion = {
  prefix: 'far',
  iconName: 'object-union',
  icon: [512, 512, [], "e49f", "M160 304c26.5 0 48 21.5 48 48l0 96c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-96c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l96 0zm-48 48l-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 48 0 48 48 0 48 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-48 0-48-48 0z"]
};
const faUserGraduate = {
  prefix: 'far',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M228.7 .5c-3.1-.6-6.3-.6-9.4 0l-200 40C8.1 42.7 0 52.6 0 64C0 74.3 6.5 83.3 16 86.6l0 71.8L.3 236.9c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9l32 0c4.8 0 9.3-2.1 12.4-5.9s4.3-8.6 3.3-13.3L48 158.4l0-65.1 171.3 34.3c3.1 .6 6.3 .6 9.4 0l200-40C439.9 85.3 448 75.4 448 64s-8.1-21.3-19.3-23.5l-200-40zM49.3 464c5.8-37.6 30-69.2 63.3-85.1l63.6 71.5c5 5.6 10.7 10.1 16.9 13.6L49.3 464zm349.4 0l-143.8 0c6.2-3.4 11.9-7.9 16.9-13.6l63.6-71.5c33.3 15.8 57.5 47.4 63.3 85.1zM109.6 328.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7l386.6 0c17 0 30.7-13.8 30.7-30.7c0-71-45.9-131.3-109.6-152.8c-10.9-3.7-22.7 .4-30.3 9L236 418.5c-6.4 7.2-17.6 7.2-23.9 0l-72.1-81.1c-7.6-8.6-19.4-12.7-30.3-9zM96 160c0 70.7 57.3 128 128 128s128-57.3 128-128l0-24.5-48 9.6 0 14.9c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-14.9-48-9.6L96 160z"]
};
const faStarfighter = {
  prefix: 'far',
  iconName: 'starfighter',
  icon: [640, 512, [], "e037", "M254.4 35C256.9 15 274 0 294.1 0l51.8 0c20.2 0 37.2 15 39.7 35l25.8 206.4c4.1-.9 8.3-1.4 12.6-1.4l32 0c30.9 0 56 25.1 56 56l0 56 56 0 0-184c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 280c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-2.7-88 29.3 0 5.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-.6c-8.8-1.3-17-4.6-24-9.5c-9.1 6.3-20.1 10-32 10l-80 0c-11.9 0-22.9-3.7-32-10c-7 4.9-15.2 8.2-24 9.5l0 .6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-5.3L72 445.3l0 2.7c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-280c-13.3 0-24-10.7-24-24s10.7-24 24-24l0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24c13.3 0 24 10.7 24 24s-10.7 24-24 24l0 184 56 0 0-56c0-30.9 25.1-56 56-56l32 0c4.3 0 8.6 .5 12.6 1.4L254.4 35zM368 424l0-128 0-14.5L338.8 48l-37.6 0L272 281.5l0 14.5 0 128c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8zm48-128l0 128c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-128c0-4.4-3.6-8-8-8l-32 0c-4.4 0-8 3.6-8 8zm-200-8l-32 0c-4.4 0-8 3.6-8 8l0 128c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-128c0-4.4-3.6-8-8-8zm104-64c17.7 0 32 14.3 32 32l0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48c0-17.7 14.3-32 32-32z"]
};
const faCircleHalfStroke = {
  prefix: 'far',
  iconName: 'circle-half-stroke',
  icon: [512, 512, [9680, "adjust"], "f042", "M464 256c0-114.9-93.1-208-208-208l0 416c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faAdjust = faCircleHalfStroke;
const faArrowRightLongToLine = {
  prefix: 'far',
  iconName: 'arrow-right-long-to-line',
  icon: [640, 512, [], "e3d5", "M640 88l0 336c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24s24 10.7 24 24zM505 239c9.4 9.4 9.4 24.6 0 33.9L369 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l95-95L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l406.1 0-95-95c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L505 239z"]
};
const faSquareArrowDown = {
  prefix: 'far',
  iconName: 'square-arrow-down',
  icon: [448, 512, ["arrow-square-down"], "f339", "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM207 393l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L200 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0z"]
};
const faArrowSquareDown = faSquareArrowDown;
const faDiamondHalfStroke = {
  prefix: 'far',
  iconName: 'diamond-half-stroke',
  icon: [512, 512, [], "e5b8", "M256 464l0-416c2.6 0 5.2 1 7 2.9L461.1 249c1.9 1.9 2.9 4.4 2.9 7s-1 5.2-2.9 7L263 461.1c-1.9 1.9-4.4 2.9-7 2.9zM215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17z"]
};
const faClapperboard = {
  prefix: 'far',
  iconName: 'clapperboard',
  icon: [512, 512, [], "e131", "M48 208l416 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm352-48l-64 0 80-80 32 0c8.8 0 16 7.2 16 16l-64 64zM320 80l-80 80-64 0 80-80 64 0zM160 80L80 160l-32 0 0-32L96 80l64 0zm352 80l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 24 0 24L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208 0-24 0-24z"]
};
const faSquareChevronLeft = {
  prefix: 'far',
  iconName: 'square-chevron-left',
  icon: [448, 512, ["chevron-square-left"], "f32a", "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm71-241L239 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L135 273c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faChevronSquareLeft = faSquareChevronLeft;
const faPhoneIntercom = {
  prefix: 'far',
  iconName: 'phone-intercom',
  icon: [512, 512, [], "e434", "M112 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l48 0zm0 400c15.1 0 29-5.3 40-14c11 8.8 24.9 14 40 14l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L192 32c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l48 0zm64-64l0-320c0-8.8 7.2-16 16-16l256 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16zm80-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-80c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM240 112c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-160 0z"]
};
const faLinkHorizontal = {
  prefix: 'far',
  iconName: 'link-horizontal',
  icon: [640, 512, ["chain-horizontal"], "e1cb", "M143.9 64C64.4 64 0 128.4 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-52.9 42.9-95.9 95.9-95.9l160.3 0c52.9 0 95.9 42.9 95.9 95.9c0 50.5-39.1 92.3-89.5 95.6l-8.1 .5c-13.2 .9-23.2 12.3-22.4 25.5s12.3 23.2 25.5 22.3l8.1-.5c75.6-5 134.3-67.8 134.3-143.5C448 128.4 383.6 64 304.1 64L143.9 64zM496.1 448C575.6 448 640 383.6 640 304.1c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 52.9-42.9 95.9-95.9 95.9l-160.2 0c-53 0-95.9-42.9-95.9-95.9c0-50.5 39.1-92.3 89.5-95.7l7.1-.5c13.2-.9 23.2-12.3 22.3-25.6s-12.3-23.2-25.6-22.3l-7.1 .5C250.7 165.6 192 228.4 192 304.1C192 383.6 256.4 448 335.9 448l160.2 0z"]
};
const faChainHorizontal = faLinkHorizontal;
const faMango = {
  prefix: 'far',
  iconName: 'mango',
  icon: [512, 512, [], "e30f", "M344 0l32 0 64 0c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24l-39.7 0c-32.1 0-61.1-14.5-80.3-37.5l0 43.6 0 50.1 0 15.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24c-36.9 0-73.7 14.1-101.8 42.2l-1.7 1.7-1.9 1.6c-36.7 29.8-55.1 60.9-74.5 95.7l-3.1 5.6c-18.4 33-40.6 72.9-83 104.8c-2.3 1.8-4.1 4.3-5.1 7.4c-2.8 8.4 1.8 17.4 10.2 20.2l2 .7 1.8 .8s0 0 0 0c0 0 0 0 0 0c0 0 0 0 0 0l.5 .2c.5 .2 1.4 .6 2.6 1.1c2.5 1 6.4 2.5 11.6 4.3c10.4 3.6 26.1 8.6 46.1 13.6C163.7 453.9 220.7 464 288 464c66.9 0 109.2-28.7 136.2-64.3C452.6 362.2 464 316.5 464 288c0-36.9-14-73.7-42.2-101.8c-6.8-6.8-14.1-12.8-21.8-17.9l0-54.8c20.2 9.3 39.1 22.2 55.8 38.8C493.3 189.7 512 238.9 512 288c0 76.6-57.5 224-224 224c-144 0-244.1-43.3-244.1-43.3C10.3 457.6-7.9 421.4 3.3 387.9C7.4 375.4 15 365 24.7 357.5c34.3-25.7 52.1-57.6 71.2-91.8c20.6-36.8 42.6-76.3 88.4-113.5C221.7 114.7 270.9 96 320 96l0-72c0-13.3 10.7-24 24-24zm56 288c8.8 0 16 7.2 16 16c0 61.9-50.1 112-112 112c-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80c0-8.8 7.2-16 16-16z"]
};
const faMusicNoteSlash = {
  prefix: 'far',
  iconName: 'music-note-slash',
  icon: [640, 512, ["music-alt-slash"], "f8d0", "M512 31.1C512 13.9 498.1 0 480.9 0c-2.7 0-5.3 .3-7.9 1L321.9 40.8C311.3 43.6 304 53.1 304 64l0 149L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L352 250.6l0-55.2 141.9-36.1C504.6 156.6 512 147 512 136l0-104.9zM304 366.3c-18.1-9-40.2-14.3-64-14.3c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-58.7-48-37.8 0 30.8zm0 65.7c0 2.6-1.4 9.4-12.7 17.5c-11.2 8-29.2 14.5-51.3 14.5s-40.1-6.5-51.3-14.5C177.4 441.4 176 434.6 176 432s1.4-9.4 12.7-17.5c11.2-8 29.2-14.5 51.3-14.5s40.1 6.5 51.3 14.5c11.3 8.1 12.7 14.9 12.7 17.5zM464 117.3L352 145.8l0-63.3L464 53l0 64.3z"]
};
const faMusicAltSlash = faMusicNoteSlash;
const faCircleRadiation = {
  prefix: 'far',
  iconName: 'circle-radiation',
  icon: [512, 512, [9762, "radiation-alt"], "f7ba", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faRadiationAlt = faCircleRadiation;
const faFaceTongueSweat = {
  prefix: 'far',
  iconName: 'face-tongue-sweat',
  icon: [576, 512, [], "e39e", "M496 256c0 81.7-47.1 152.4-115.7 186.4c2.4-8.4 3.7-17.3 3.7-26.4l0-15.3c10.2-7.2 16-15.7 16-24.7c0-26.5-50.1-48-112-48s-112 21.5-112 48c0 9 5.8 17.5 16 24.7l0 15.3c0 9.2 1.3 18 3.7 26.4c-27.1-13.4-50.8-32.6-69.6-55.9c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369zm239.6-97a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm19.7-155.3c-6.2-6.2-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4c6.2-6.2 6.2-16.4 0-22.6zm121.4 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM352 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-21.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 21.4z"]
};
const faGlobeStand = {
  prefix: 'far',
  iconName: 'globe-stand',
  icon: [448, 512, [], "f5f6", "M15 367c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l18.5-18.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L401 49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L332.5 49.6c-9.4 9.4-9.4 24.6 0 33.9c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0c-9.4-9.4-24.6-9.4-33.9 0L15 367zm97-159a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm240 0A144 144 0 1 0 64 208a144 144 0 1 0 288 0z"]
};
const faBaseball = {
  prefix: 'far',
  iconName: 'baseball',
  icon: [512, 512, [129358, 9918, "baseball-ball"], "f433", "M248 463.8c0-6 .3-11.9 .7-17.8c1.1-13.2 12.7-23 25.9-21.9s23 12.7 21.9 25.9c-.3 3.4-.5 6.8-.5 10.2C378.8 444 444 378.8 460.2 296c-3.4 .1-6.8 .3-10.2 .5c-13.2 1.1-24.8-8.7-25.9-21.9s8.7-24.8 21.9-25.9c5.9-.5 11.8-.7 17.8-.7C459.7 139.5 372.5 52.3 264 48.2c0 6-.3 11.9-.7 17.8c-1.1 13.2-12.7 23-25.9 21.9s-23-12.7-21.9-25.9c.3-3.4 .5-6.8 .5-10.2C133.2 68 68 133.2 51.9 216c3.4-.1 6.8-.3 10.2-.5c13.2-1.1 24.8 8.7 25.9 21.9s-8.7 24.8-21.9 25.9c-5.9 .5-11.8 .7-17.8 .7C52.3 372.5 139.5 459.7 248 463.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm118-55.2c36.5-16.8 66-46.3 82.8-82.8c5.5-12 19.8-17.3 31.8-11.8s17.3 19.8 11.8 31.8C222.8 185 185 222.8 138 244.4c-12 5.5-26.3 .2-31.8-11.8s-.2-26.3 11.8-31.8zM394 311.2c-36.5 16.8-66 46.3-82.8 82.8c-5.5 12-19.8 17.3-31.8 11.8s-17.3-19.8-11.8-31.8C289.2 327 327 289.2 374 267.6c12-5.5 26.3-.2 31.8 11.8s.2 26.3-11.8 31.8z"]
};
const faBaseballBall = faBaseball;
const faCircleP = {
  prefix: 'far',
  iconName: 'circle-p',
  icon: [512, 512, [], "e11a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24l0 136 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 68 0c50.8 0 92-41.2 92-92s-41.2-92-92-92l-92 0zm92 136l-68 0 0-88 68 0c24.3 0 44 19.7 44 44s-19.7 44-44 44z"]
};
const faAwardSimple = {
  prefix: 'far',
  iconName: 'award-simple',
  icon: [384, 512, [], "e0ab", "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64.4 492.4L88 390.1c11.7 5.2 24.5 7.9 37.8 7.6l11.1-.3 9.5 5.8c28 17 63.1 17 91.1 0l9.5-5.8 11.1 .3c13.3 .3 26.1-2.4 37.8-7.6l23.6 102.3c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9z"]
};
const faJetFighterUp = {
  prefix: 'far',
  iconName: 'jet-fighter-up',
  icon: [512, 512, [], "e518", "M277.2 12.8C273.1 4.9 264.9 0 256 0s-17.1 4.9-21.2 12.8L168.4 138.2c-5.5 10.4-8.4 21.9-8.4 33.7l0 31.6L48 281.9 48 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80 0 32 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 112 0 0 1.1-41.9 66.3c-4 6.3-6.1 13.6-6.1 21.1c0 21.8 17.7 39.5 39.5 39.5l209 0c21.8 0 39.5-17.7 39.5-39.5c0-7.5-2.1-14.8-6.1-21.1L352 385.1l0-1.1 112 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 0-32 0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 33.9L352 203.5l0-31.6c0-11.7-2.9-23.3-8.4-33.7L277.2 12.8zM457.6 336L352 336l0-73.9L457.6 336zM304 360l0 32c0 4.5 1.3 9 3.7 12.8L345.1 464 280 464l0-56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 56-65.1 0 37.4-59.2c2.4-3.8 3.7-8.3 3.7-12.8l0-32 0-143.7 0-.6 0-43.7c0-3.9 1-7.8 2.8-11.2L256 75.3l45.2 85.4c1.8 3.5 2.8 7.3 2.8 11.2l0 43.7 0 .6L304 360zM160 336L54.4 336 160 262.1l0 73.9z"]
};
const faDiagramProject = {
  prefix: 'far',
  iconName: 'diagram-project',
  icon: [576, 512, ["project-diagram"], "f542", "M136 80c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l80 0zM56 32C25.1 32 0 57.1 0 88l0 80c0 30.9 25.1 56 56 56l80 0c5.6 0 11.1-.8 16.2-2.4l75.9 101.2c-2.7 6.5-4.1 13.7-4.1 21.2l0 80c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-5.6 0-11.1 .8-16.2 2.4L187.9 189.2c2.7-6.5 4.1-13.7 4.1-21.2l0-16 192 0 0 16c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56l0 16-192 0 0-16c0-30.9-25.1-56-56-56L56 32zM360 336c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l80 0zM440 80l80 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-80 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z"]
};
const faProjectDiagram = faDiagramProject;
const faPedestal = {
  prefix: 'far',
  iconName: 'pedestal',
  icon: [448, 512, [], "e20d", "M352 48L96 48c-8.8 0-16 7.2-16 16l0 368-48 0L32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 368-48 0 0-368c0-8.8-7.2-16-16-16zM24 464l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zm96-352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM304 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faChartPyramid = {
  prefix: 'far',
  iconName: 'chart-pyramid',
  icon: [512, 512, [], "e0e6", "M256 95.8L199.9 192l112.3 0L256 95.8zM125.2 320l261.6 0-46.7-80-168.3 0-46.7 80zm-28 48L59.9 432l392.3 0-37.3-64L97.2 368zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0L493.6 407.8c18.7 32-4.4 72.2-41.5 72.2L59.9 480c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"]
};
const faSidebar = {
  prefix: 'far',
  iconName: 'sidebar',
  icon: [512, 512, [], "e24e", "M224 80l0 352 224 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L224 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 96c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zM64 312c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faSnowmanHead = {
  prefix: 'far',
  iconName: 'snowman-head',
  icon: [448, 512, ["frosty-head"], "f79b", "M336 144l0 48-224 0 0-48 224 0zM64 64l0 128-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24.7 0C28 272.3 16 310.8 16 352c0 56 22.1 106.9 58.2 144.3C84.5 507 99.3 512 114.2 512l219.6 0c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-41.2-12-79.7-32.7-112l24.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-128c0-35.3-28.7-64-64-64L128 0C92.7 0 64 28.7 64 64zm0 288c0-43.6 17.4-83.1 45.7-112l2.3 0 224 0 2.3 0c28.3 28.9 45.7 68.4 45.7 112c0 43.1-17 82.1-44.7 110.9c-.1 .1-.3 .2-.8 .4c-.9 .4-2.5 .7-4.8 .7l-219.6 0c-2.2 0-3.8-.4-4.8-.7c-.4-.2-.7-.3-.8-.4C81 434.1 64 395.1 64 352zm88-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM219.3 445.2c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l23.8-46.3c2.3-4.5 3.5-9.6 3.5-14.7c0-17.7-14.3-32.2-32-32.2s-32 14.5-32 32.2c0 5.1 1.2 10.2 3.5 14.7l23.8 46.3z"]
};
const faFrostyHead = faSnowmanHead;
const faCopy = {
  prefix: 'far',
  iconName: 'copy',
  icon: [448, 512, [], "f0c5", "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"]
};
const faBurgerGlass = {
  prefix: 'far',
  iconName: 'burger-glass',
  icon: [640, 512, [], "e0ce", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c5.6 0 11-.6 16.2-1.8c-13.1-12.8-23.3-28.5-29.4-46.2L108 464c-12.5 0-22.8-9.5-23.9-21.9L64 208l247.9 0c15.5-12.4 35-24.1 59.2-32.7L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM59.8 160L50.2 48l283.7 0-9.7 112L59.8 160zm390.1 80.2c-1.2 2.3-1.9 4.9-1.9 7.6c0 8.8 7.2 16 16 16s16-7.2 16-16c0-2.8-.7-5.3-1.9-7.6c22.5 1.3 40.8 5.5 55.7 11.3c-3.5 2.9-5.8 7.4-5.8 12.3c0 8.8 7.2 16 16 16c8.3 0 15.2-6.4 15.9-14.6c18.4 12.7 27.4 26.8 31.1 33.6c.3 .7 1 2.3 1 6.1c0 17-13.8 30.8-30.8 30.8l-194.3 0c-17 0-30.8-13.8-30.8-30.8c0-3.7 .6-5.4 1-6.1c3.7-6.9 12.7-21 31.1-33.6c.7 8.2 7.6 14.6 15.9 14.6c8.8 0 16-7.2 16-16c0-4.9-2.2-9.4-5.8-12.3c14.8-5.8 33.1-10.1 55.7-11.3zM627.8 347.1c7.7-12.2 12.2-26.6 12.2-42.1c0-8.4-1.3-18.7-6.7-28.8C619 249.5 574.2 191.8 464 191.8s-155 57.7-169.3 84.4c-5.4 10-6.7 20.4-6.7 28.8c0 15.5 4.5 29.9 12.2 42.1c-7.5 7.3-12.2 17.5-12.2 28.7c0 8.1 2.4 15.6 6.5 21.8c-4.1 7.8-6.5 16.7-6.5 26.2c0 48.6 39.4 88 88 88l176 0c48.6 0 88-39.4 88-88c0-9.5-2.3-18.4-6.5-26.2c4.1-6.3 6.5-13.8 6.5-21.8c0-11.3-4.7-21.5-12.2-28.7zM344 415.8l240 0c4.4 0 8 3.6 8 8c0 22.1-17.9 40-40 40l-176 0c-22.1 0-40-17.9-40-40c0-4.4 3.6-8 8-8z"]
};
const faVolumeXmark = {
  prefix: 'far',
  iconName: 'volume-xmark',
  icon: [576, 512, ["volume-mute", "volume-times"], "f6a9", "M159.9 201.9L272 102.3l0 307.3L159.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160 56 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L270.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C320 45.3 306.7 32 290.2 32zM425 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55z"]
};
const faVolumeMute = faVolumeXmark;
const faVolumeTimes = faVolumeXmark;
const faHandSparkles = {
  prefix: 'far',
  iconName: 'hand-sparkles',
  icon: [640, 512, [], "e05d", "M262.4 36C272.8 14.7 294.7 0 320 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 163.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2-29.3 8.4c7.7-14.9 12.8-31.4 14.5-48.9c.1-1.3 .4-2.5 .7-3.7L496 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L416 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L336 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L304 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-43.7-43.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c30.9-1.5 59.1-13.4 81.2-32.1l0 .3c0 17.6 10.8 33.3 27 39.6c-28.5 22.8-63.8 37.3-102.5 39.9c-1.4 .3-3 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L82.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L176 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zm50.3 290.6L320 352l25.4 7.3c3.9 1.1 6.6 4.7 6.6 8.7s-2.7 7.6-6.6 8.7L320 384l-7.3 25.4c-1.1 3.9-4.7 6.6-8.7 6.6s-7.6-2.7-8.7-6.6L288 384l-25.4-7.3c-3.9-1.1-6.6-4.7-6.6-8.7s2.7-7.6 6.6-8.7L288 352l7.3-25.4c1.1-3.9 4.7-6.6 8.7-6.6s7.6 2.7 8.7 6.6zm257.5 33.1L584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7zM104 88l40 11.4 0 25.1L104 136 90.2 184.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 136 7.7 122.2C3.1 120.9 0 116.7 0 112s3.1-8.9 7.7-10.2L56 88 69.8 39.7C71.1 35.1 75.3 32 80 32s8.9 3.1 10.2 7.7L104 88z"]
};
const faBarsFilter = {
  prefix: 'far',
  iconName: 'bars-filter',
  icon: [448, 512, [], "e0ad", "M0 88C0 74.7 10.7 64 24 64l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 112C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24l272 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24z"]
};
const faPaintbrushPencil = {
  prefix: 'far',
  iconName: 'paintbrush-pencil',
  icon: [576, 512, [], "e206", "M181.3 19.3c-25-25-65.5-25-90.5 0L51.3 58.7c-3.1 3.1-5.9 6.5-8.2 10c-16.4 24.8-13.7 58.6 8.2 80.5l88.8 88.8c13.9-4 28.6-6.1 43.9-6.1l1.5 0 8.2-8.2L161 191 223 129l32.8 32.8 33.9-33.9L181.3 19.3zM414.2 320.1l37.3 37.3c.6 .6 1.2 1.2 1.7 1.8c3.9 4.4 6.7 9.6 8.4 15.2l6.9 23.4 16.1 54.8-54.8-16.1-23.4-6.9c-6.4-1.9-12.3-5.4-17-10.1l-37.3-37.3-8.1 8.1 0 1.7c0 15.2-2.1 29.9-6.1 43.9l17.6 17.6c1.3 1.3 2.6 2.6 4 3.8c9.6 8.5 21 14.8 33.4 18.4l78.1 23L513.2 511c8.4 2.5 17.5 .2 23.7-6.1s8.5-15.3 6.1-23.7L530.6 439l-23-78.1c-4.2-14.1-11.8-27-22.2-37.4l-37.3-37.3-33.9 33.9zM519 57c8.3 8.3 8.3 21.8 0 30.1L336.3 269.8l-30.1-30.1L489 57c8.3-8.3 21.8-8.3 30.1 0zM184 320c9.4 0 18.3 1.8 26.5 5L251 365.5c3.3 8.2 5 17.2 5 26.5c0 39.8-32.2 72-72 72l-85.6 0 .7-.9c11.6-16.9 17.1-38.6 13.8-60c-.5-3.6-.8-7.3-.8-11.1c0-39.8 32.2-72 72-72zM455 23L204.3 273.7c-6.6-1.1-13.4-1.7-20.3-1.7c-66.3 0-120 53.7-120 120c0 6.2 .5 12.4 1.4 18.4C68.1 428.2 56.1 448 38 448l-6 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l152 0c66.3 0 120-53.7 120-120c0-6.9-.6-13.7-1.7-20.3L553 121c27-27 27-70.9 0-97.9s-70.9-27-97.9 0z"]
};
const faPartyBell = {
  prefix: 'far',
  iconName: 'party-bell',
  icon: [512, 512, [], "e31a", "M48 224c0-97.2 78.8-176 176-176c27.8 0 54.1 6.5 77.5 17.9c.7 .4 1.2 .8 1.7 1.6c.5 .9 .9 2.1 .9 3.2c0 1.7-.7 3.4-1.9 4.6L75.3 302.1c-1.2 1.2-2.9 1.9-4.6 1.9c-1.1 0-2.3-.3-3.2-.9c-.7-.4-1.2-.9-1.6-1.7C54.5 278.1 48 251.8 48 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7C32.3 341.9 51.7 352 70.7 352c14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5c0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zM480 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM359 167c-9.4 9.4-9.4 24.6 0 33.9l8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3c13.2 1.5 25-8 26.5-21.2s-8-25-21.2-26.5l-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167c-9.4-9.4-24.6-9.4-33.9 0zM201 359c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4c1.5 13.2 13.3 22.7 26.5 21.2s22.7-13.3 21.2-26.5l-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359zM503.5 506.3c10.1-8.6 11.4-23.7 2.8-33.8l-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10c-8.6-10.1-23.7-11.4-33.8-2.8s-11.4 23.7-2.8 33.8l8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10c8.6 10.1 23.7 11.4 33.8 2.8z"]
};
const faUserVneckHair = {
  prefix: 'far',
  iconName: 'user-vneck-hair',
  icon: [448, 512, [], "e462", "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16zM48.3 464l351.5 0c-3.1-46.7-32.9-86.2-74.4-103.1l-50.2 66.9c-25.6 34.1-76.8 34.1-102.4 0l-50.2-66.9C81.2 377.8 51.3 417.3 48.3 464zm83.8-156.2c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472l0 8c0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32l0-8c0-80.5 56.6-147.7 132.1-164.2z"]
};
const faJackOLantern = {
  prefix: 'far',
  iconName: 'jack-o-lantern',
  icon: [576, 512, [127875], "f30e", "M275.5 10.4L231.6 110.6c-4 2.1-7.9 4.5-11.6 7.1C200 104.1 176.9 96 152 96c-45.4 0-84 26.5-110.2 64.2C15.5 198 0 248.9 0 304s15.5 106 41.8 143.8C68 485.5 106.6 512 152 512c24.9 0 48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6s48-8.1 68-21.6c20 13.6 43.1 21.6 68 21.6c45.4 0 84-26.5 110.2-64.2C560.5 410 576 359.1 576 304s-15.5-106-41.8-143.8C508 122.5 469.4 96 424 96c-24.9 0-48 8.1-68 21.6c-1.3-.9-2.7-1.8-4-2.6l0-79.6c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4l-1.2 0c-6.9 0-13.1 4.1-15.8 10.4zM81.2 187.6C101.3 158.7 126.7 144 152 144c18 0 35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C252.2 151.4 270 144 288 144s35.8 7.4 51.9 21.9c9.1 8.3 23 8.3 32.2 0C388.2 151.4 406 144 424 144c25.3 0 50.7 14.7 70.8 43.6c20 28.8 33.2 69.9 33.2 116.4s-13.2 87.6-33.2 116.4C474.7 449.3 449.3 464 424 464c-18 0-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C323.8 456.6 306 464 288 464s-35.8-7.4-51.9-21.9c-9.1-8.3-23-8.3-32.2 0C187.8 456.6 170 464 152 464c-25.3 0-50.7-14.7-70.8-43.6C61.2 391.6 48 350.5 48 304s13.2-87.6 33.2-116.4zm140.1 27.5c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48zM368 208c-5.4 0-10.3 2.7-13.3 7.1l-32 48c-3.3 4.9-3.6 11.2-.8 16.4s8.2 8.5 14.1 8.5l64 0c5.9 0 11.3-3.2 14.1-8.5s2.5-11.5-.8-16.4l-32-48c-3-4.5-8-7.1-13.3-7.1zM470.1 312c1.4-5-.3-10.2-4-13.8c-5.8-5.8-15.1-6.6-22.2-2.4C420.8 309.4 365.6 336 288 336l0 16c0 8.8-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16l0-19.5c-52.4-7.7-89.9-26.2-107.9-36.8c-7.1-4.2-16.4-3.4-22.2 2.4c-3.7 3.7-5.4 8.8-4 13.8c4.2 14.7 17.2 46.8 54.1 71.4c.3-8.6 7.3-15.4 16-15.4l16 0c8.8 0 16 7.2 16 16l0 21.5c21.8 6.5 48.2 10.5 80 10.5s58.2-4 80-10.5l0-21.5c0-8.8 7.2-16 16-16l16 0c8.6 0 15.7 6.9 16 15.4c36.9-24.7 49.9-56.7 54.1-71.4z"]
};
const faGrip = {
  prefix: 'far',
  iconName: 'grip',
  icon: [448, 512, ["grip-horizontal"], "f58d", "M408 376l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM408 184l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM200 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48zM40 376l48 0 0-48-48 0 0 48zm48 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0-232l0-48-48 0 0 48 48 0zm40 0c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48z"]
};
const faGripHorizontal = faGrip;
const faShareFromSquare = {
  prefix: 'far',
  iconName: 'share-from-square',
  icon: [576, 512, [61509, "share-square"], "f14d", "M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"]
};
const faShareSquare = faShareFromSquare;
const faKeynote = {
  prefix: 'far',
  iconName: 'keynote',
  icon: [512, 512, [], "f66c", "M198.4 72L184 72c-22.1 0-40 17.9-40 40l0 48 278.3 0c16.1 0 31 8 39.9 21.4l41.7 62.5c5.3 7.9 8.1 17.1 8.1 26.6l0 49.5c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32l0-49.5c0-9.5 2.8-18.7 8.1-26.6l41.7-62.5C58.7 168 73.6 160 89.7 160l6.3 0 0-48c0-48.6 39.4-88 88-88l14.4 0C206.7 9.7 222.2 0 240 0l64 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-64 0c-17.8 0-33.3-9.7-41.6-24zM48 304l416 0 0-33.5L422.3 208 89.7 208 48 270.5 48 304zm80 184c0-13.3 10.7-24 24-24l80 0 0-80 48 0 0 80 80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-104 0-104 0c-13.3 0-24-10.7-24-24z"]
};
const faChildCombatant = {
  prefix: 'far',
  iconName: 'child-combatant',
  icon: [576, 512, ["child-rifle"], "e4e0", "M160 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 0A64 64 0 1 0 112 64a64 64 0 1 0 128 0zM176 208c5.5 0 10.9 .9 16 2.6L192 336l-32 0 0-125.4c5.1-1.7 10.5-2.6 16-2.6zM160 488l0-104 32 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-223.2 27.7 44c7.1 11.2 21.9 14.6 33.1 7.5s14.6-21.9 7.5-33.1l-48.4-76.9C241.8 177.5 210.1 160 176 160s-65.8 17.5-83.9 46.3L43.7 283.2c-7.1 11.2-3.7 26 7.5 33.1s26 3.7 33.1-7.5l27.7-44L112 488c0 13.3 10.7 24 24 24s24-10.7 24-24zM416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32-16 0c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l32 0 0 48 0 64c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9L484 400l44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3L480 160c0-11.8-6.4-22.2-16-27.7L464 16c0-8.8-7.2-16-16-16L432 0 416 0zm16 336l-16 0-16 0 0-96 32 0 0 96z"]
};
const faChildRifle = faChildCombatant;
const faGun = {
  prefix: 'far',
  iconName: 'gun',
  icon: [576, 512, [], "e19b", "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L40 64C17.9 64 0 81.9 0 104l0 96c0 22.1 17.9 40 40 40l2 0c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l112 0c14.7 0 27.5-10 31-24.2L233 352l88.5 0c23.7 0 44.8-14.9 52.7-37.2L400.9 240l32.5 0c10.6 0 20.8-4.2 28.3-11.7L481.9 208l54.1 0c22.1 0 40-17.9 40-40l0-64c0-22.1-17.9-40-40-40l-8 0 0-8zM245 304l16-64 89 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3L245 304zm-33.5-64l-48 192-79 0 35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4l96.1 0zM267 192l-48 0L68.8 192 48 192l0-80 456 0 24 0 0 48-49.4 0c-10.6 0-20.8 4.2-28.3 11.7L430.1 192l-163 0z"]
};
const faSquarePhone = {
  prefix: 'far',
  iconName: 'square-phone',
  icon: [448, 512, ["phone-square"], "f098", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.7 32.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"]
};
const faPhoneSquare = faSquarePhone;
const faHatBeach = {
  prefix: 'far',
  iconName: 'hat-beach',
  icon: [640, 512, [], "e606", "M197.9 201.4C225.6 215.1 270 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-22 15.7-40.4 36.6-44.4C397.1 131.1 360.8 112 320 112c-57.2 0-105.7 37.6-122.1 89.4zM320 64c70.2 0 130.8 41.1 159 100.5c6.1-2.9 12.8-4.5 19.7-4.5c25 0 45.3 20.3 45.3 45.3c0 12-4.8 23.5-13.3 32L528 240l2.7 2.7c.8 .8 1.6 1.6 2.3 2.5l77.3 30.9c17.9 7.2 29.7 24.6 29.7 43.9c0 17.6-8.9 34.5-25.1 49.8c-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7l16.5-17.4L25.1 369.8C8.9 354.5 0 337.6 0 320c0-19.3 11.8-36.7 29.7-43.9l8.6 21.6-8.6-21.6 114.6-45.8C149.3 137.6 226.1 64 320 64zM429.3 320c-16.7 0-31.3-9-39.1-22.5c-21.2 4.1-45 6.5-70.2 6.5c-62.4 0-116.5-14.3-142.9-35.2c-.3 .1-.5 .2-.8 .3L48 320.5c.2 1.5 1.5 6.4 10.1 14.5c10.3 9.8 27.8 20.8 53.4 31C162.5 386.3 236.2 400 320 400s157.5-13.7 208.4-34.1c25.6-10.2 43.1-21.2 53.4-31c8.6-8.1 9.9-13 10.1-14.5l-54.7-21.9c-8 12.9-22.2 21.4-38.5 21.4c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3zM464 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faPlus = {
  prefix: 'far',
  iconName: 'plus',
  icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"]
};
const faAdd = faPlus;
const faExpand = {
  prefix: 'far',
  iconName: 'expand',
  icon: [448, 512, [], "f065", "M136 32c13.3 0 24 10.7 24 24s-10.7 24-24 24L48 80l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 42.7 10.7 32 24 32l112 0zM0 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24L0 344zM424 32c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zM400 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0 0-88z"]
};
const faComputer = {
  prefix: 'far',
  iconName: 'computer',
  icon: [640, 512, [], "e4e5", "M384 80c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-102.7 0L264 336l-80 0-17.3 0L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 384l86.7 0-16 48L88 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l30.7 0 33.3 0 144 0 33.3 0 30.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-46.7 0-16-48 86.7 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64zm121.3 48l16-48 45.4 0 16 48-77.4 0zM528 80l64 0 0 32-64 0 0-32zm0 80l64 0 0 32-64 0 0-32zm64 80l0 192-64 0 0-192 64 0zM480 80l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFort = {
  prefix: 'far',
  iconName: 'fort',
  icon: [640, 512, [], "e486", "M48 112l0 48c0 8.8 7.2 16 16 16l16 0 80 0c8.8 0 16-7.2 16-16l0-48-40 0-48 0-40 0zm176 48c0 5.5-.7 10.9-2 16l196 0c-1.3-5.1-2-10.5-2-16l0-48 0-8 0-40 0-40c0-13.3 10.7-24 24-24c7.1 0 13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C514.6 3.1 520.9 0 528 0s13.4 3.1 17.8 7.9c3.8 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C602.6 3.1 608.9 0 616 0c13.3 0 24 10.7 24 24l0 40 0 40 0 8 0 48c0 23.7-12.9 44.4-32 55.4l0 8.6 0 224c0 35.3-28.7 64-64 64l-160 0-128 0L96 512c-35.3 0-64-28.7-64-64l0-224 0-8.6C12.9 204.4 0 183.7 0 160l0-48 0-8L0 64 0 24C0 10.7 10.7 0 24 0c7.1 0 13.4 3.1 17.8 7.9C45.7 12.2 48 17.8 48 24l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C98.6 3.1 104.9 0 112 0s13.4 3.1 17.8 7.9c3.9 4.3 6.2 9.9 6.2 16.1l0 40 40 0 0-40c0-6.2 2.3-11.8 6.2-16.1C186.6 3.1 192.9 0 200 0c13.3 0 24 10.7 24 24l0 40 0 40 0 8 0 48zM384 464l64 0 0-240-256 0 0 240 64 0 0-80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 80zm112 0l48 0c8.8 0 16-7.2 16-16l0-224-64 0 0 240zM96 464l48 0 0-240-64 0 0 224c0 8.8 7.2 16 16 16zM560 176l16 0c8.8 0 16-7.2 16-16l0-48-40 0-48 0-40 0 0 48c0 8.8 7.2 16 16 16l80 0z"]
};
const faCloudCheck = {
  prefix: 'far',
  iconName: 'cloud-check',
  icon: [640, 512, [], "e35c", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM433 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L433 241z"]
};
const faXmark = {
  prefix: 'far',
  iconName: 'xmark',
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
};
const faClose = faXmark;
const faMultiply = faXmark;
const faRemove = faXmark;
const faTimes = faXmark;
const faFaceSmirking = {
  prefix: 'far',
  iconName: 'face-smirking',
  icon: [512, 512, [], "e397", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm382.3 88.9l-1.9 4.8c-12.2 30.4-41.6 50.3-74.3 50.3L184 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l122.1 0c13.1 0 24.9-8 29.7-20.1l1.9-4.8c4.9-12.3 18.9-18.3 31.2-13.4s18.3 18.9 13.4 31.2zM112 192l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0c-8.8 0-16-7.2-16-16z"]
};
const faArrowsUpDownLeftRight = {
  prefix: 'far',
  iconName: 'arrows-up-down-left-right',
  icon: [512, 512, ["arrows"], "f047", "M273 7c-9.4-9.4-24.6-9.4-33.9 0L167 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 232 81.9 232l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 239c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31L232 280l0 150.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31L280 280l150.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31L280 232l0-150.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L273 7z"]
};
const faArrows = faArrowsUpDownLeftRight;
const faChalkboardUser = {
  prefix: 'far',
  iconName: 'chalkboard-user',
  icon: [640, 512, ["chalkboard-teacher"], "f51c", "M576 48L224 48c-8.8 0-16 7.2-16 16l0 41.3c-14.8-6-31-9.3-48-9.3l0-32c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-32 0-24 0-128 0-24 0-31.2 0c-8.3-18-19.8-34.2-33.7-48l64.9 0 0-40c0-30.9 25.1-56 56-56l64 0c30.9 0 56 25.1 56 56l0 40 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16zM496 368l0-40c0-4.4-3.6-8-8-8l-64 0c-4.4 0-8 3.6-8 8l0 40 80 0zM208 224a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM50.7 464l218.6 0c-9.5-36.8-42.9-64-82.6-64l-53.3 0c-39.8 0-73.2 27.2-82.6 64zM0 485.3C0 411.7 59.7 352 133.3 352l53.3 0C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7L26.7 512C11.9 512 0 500.1 0 485.3z"]
};
const faChalkboardTeacher = faChalkboardUser;
const faRhombus = {
  prefix: 'far',
  iconName: 'rhombus',
  icon: [448, 512, [], "e23b", "M224 52.3L50.5 256 224 459.7 397.5 256 224 52.3zM9.6 230.1l184-216C201.2 5.1 212.3 0 224 0s22.8 5.1 30.4 14.1l184 216c12.7 14.9 12.7 36.9 0 51.9l-184 216c-7.6 8.9-18.7 14.1-30.4 14.1s-22.8-5.1-30.4-14.1l-184-216C-3.2 267-3.2 245 9.6 230.1z"]
};
const faClawMarks = {
  prefix: 'far',
  iconName: 'claw-marks',
  icon: [576, 512, [], "f6c2", "M39 7C48.4-2.3 63.6-2.3 73 7L176.6 110.6c15 15 23.4 35.4 23.4 56.6l0 16.8 16.8 0c21.2 0 41.6 8.4 56.6 23.4l95.2 95.2c15 15 23.4 35.4 23.4 56.6l0 16.8 16.8 0c21.2 0 41.6 8.4 56.6 23.4L537 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71.6-71.6c-6-6-14.1-9.4-22.6-9.4L368 424c-13.3 0-24-10.7-24-24l0-40.8c0-8.5-3.4-16.6-9.4-22.6l-95.2-95.2c-6-6-14.1-9.4-22.6-9.4L176 232c-13.3 0-24-10.7-24-24l0-40.8c0-8.5-3.4-16.6-9.4-22.6L39 41C29.7 31.6 29.7 16.4 39 7zm0 224c9.4-9.4 24.6-9.4 33.9 0L146.9 305c13.5 13.5 21.1 31.8 21.1 50.9l0 20.1 20.1 0c19.1 0 37.4 7.6 50.9 21.1L313 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L205.1 431c-4.5-4.5-10.6-7-17-7L144 424c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L39 265c-9.4-9.4-9.4-24.6 0-33.9zM297 7l9.9 9.9C320.4 30.5 328 48.8 328 67.9L328 88l20.1 0c19.1 0 37.4 7.6 50.9 21.1L434.9 145c13.5 13.5 21.1 31.8 21.1 50.9l0 20.1 20.1 0c19.1 0 37.4 7.6 50.9 21.1L537 247c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.9-9.9c-4.5-4.5-10.6-7-17-7L432 264c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L365.1 143c-4.5-4.5-10.6-7-17-7L304 136c-13.3 0-24-10.7-24-24l0-44.1c0-6.4-2.5-12.5-7-17L263 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faPesoSign = {
  prefix: 'far',
  iconName: 'peso-sign',
  icon: [384, 512, [], "e222", "M93.6 32C68.4 32 48 52.4 48 77.6L48 128l-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 48-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 72 0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88 88 0c67 0 124.9-39.2 151.8-96l24.2 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-9.7 0c1.1-7.8 1.7-15.9 1.7-24s-.6-16.2-1.7-24l9.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24.2 0C308.9 71.2 251 32 184 32L93.6 32zM280 128L96 128l0-48 88 0c39.3 0 74.1 18.9 96 48zM96 176l205.6 0c1.6 7.8 2.4 15.8 2.4 24s-.8 16.2-2.4 24L96 224l0-48zm184 96c-21.9 29.1-56.7 48-96 48l-88 0 0-48 184 0z"]
};
const faFaceSmileTongue = {
  prefix: 'far',
  iconName: 'face-smile-tongue',
  icon: [512, 512, [], "e394", "M419.5 453c-44.3 36.9-101.3 59-163.5 59C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256c0 27.2-4.2 53.4-12.1 77.9c9.1 23.9 7.8 51.5-6 75.4c-16 27.6-44.7 43.2-74.4 43.6zm-56.2-18.8l-44.2-27.4c-19.5 8-40.8 12.4-63.1 12.4c-70.4 0-130.1-43.8-157.5-105.5c-5.4-12.1 .1-26.3 12.2-31.7s26.3 .1 31.7 12.2c20.4 46.1 64.1 76.9 113.6 76.9c56.5 0 105.6-40.3 120.8-97.4c1.9-7.3 7.2-13.2 14.2-16.1s14.9-2.2 21.4 1.7l49 29.5c1.7-10.7 2.6-21.7 2.6-33c0-114.9-93.1-208-208-208S48 141.1 48 256s93.1 208 208 208c39.3 0 76-10.9 107.3-29.8zM217.6 228.8c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0zM398.5 399.6c18.8 11 42.9 4.7 53.8-14.2c11-19.1 4.5-43.6-14.6-54.6l-.4-.2s0 0 0 0l-24.7-14.9c-11.2 24.5-27.5 46.1-47.6 63.2l33.5 20.8zM377.6 228.8s0 0 0 0c0 0 0 0 0 0l-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8c0 0 0 0 0 0s0 0 0 0z"]
};
const faCartCircleXmark = {
  prefix: 'far',
  iconName: 'cart-circle-xmark',
  icon: [640, 512, [], "e3f4", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5l121 0c-.5-5.3-.7-10.6-.7-16c0-10.9 1-21.6 2.9-32l-123.2 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l168.5 0c9.2-18 21.4-34.2 36-48l-213.6 0L131.1 80l389.6 0L490.5 192.1c1.8-.1 3.7-.1 5.5-.1c14.8 0 29.1 1.8 42.8 5.2L569.7 82.4C576.6 57 557.4 32 531.1 32l-411 0C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm320 0a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faBuildingShield = {
  prefix: 'far',
  iconName: 'building-shield',
  icon: [576, 512, [], "e4d8", "M64 48l256 0c8.8 0 16 7.2 16 16l0 162.2L384 207l0-143c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c10.9 0 21.2-2.7 30.2-7.6c-15.4-12.4-28.5-26-39.5-40.4L240 464l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM296 232c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l24 0c.1-22.8 14-43.4 35.2-51.8l4.8-1.9 0-10.2zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm335.1-6.3l-120 48C294 277.4 288 286.2 288 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C550.1 464.8 576 359.3 576 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM527.4 312c-3.9 50.7-27.2 116.7-95.4 149.7l0-187.8L527.4 312z"]
};
const faCirclePhoneFlip = {
  prefix: 'far',
  iconName: 'circle-phone-flip',
  icon: [512, 512, ["phone-circle-alt"], "e11c", "M256 464a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zm69.3 128.7l44 12C378 143.1 384 151 384 160c0 123.7-100.3 224-224 224c-9 0-16.9-6-19.3-14.7l-12-44c-2.6-9.7 2.3-19.9 11.6-23.7l48-20c8.2-3.4 17.6-1 23.2 5.8L231.7 312c35.2-16.6 63.7-45.1 80.3-80.3l-24.7-20.2c-6.8-5.6-9.2-15-5.8-23.2l20-48c3.9-9.3 14-14.2 23.7-11.6z"]
};
const faPhoneCircleAlt = faCirclePhoneFlip;
const faBaby = {
  prefix: 'far',
  iconName: 'baby',
  icon: [448, 512, [], "f77c", "M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM107.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l18.7 18.7c12.8 12.8 27.5 23.4 43.4 31.5c8.1 4.1 13.1 12.4 13.1 21.4l0 13s0 0 0 0l128 0 0-13c0-9 5.1-17.3 13.1-21.4c15.9-8.1 30.6-18.6 43.4-31.5l18.7-18.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-18.7 18.7c-26 26-61.2 40.6-97.9 40.6s-72-14.6-97.9-40.6l-18.7-18.7zM304.6 341.5l-24.1 21.1L304 392.9c6.8 8.8 6.7 21.1-.2 29.7L291.5 438c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l32-40c4.6-5.8 4.7-14 .1-19.8l-44.1-56.7zm-137 21.1l-24.1-21.1L99.4 398.2c-4.5 5.8-4.5 14 .1 19.8l32 40c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.3-15.4c-6.9-8.7-7-21-.2-29.7l23.6-30.3zM50.7 146.7c25-25 65.5-25 90.5 0L160 165.5c17 17 40 26.5 64 26.5s47-9.5 64-26.5l18.7-18.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L378.5 256c-12.9 12.9-27.2 23.9-42.5 33.1l0 14.6 50.5 65c18.2 23.4 18 56.2-.5 79.3l-32 40c-22.1 27.6-62.4 32.1-90 10s-32.1-62.4-10-90l.5-.6-5.8-7.4-49.4 0-5.8 7.4 .5 .6c22.1 27.6 17.6 67.9-10 90s-67.9 17.6-90-10L62 448c-18.5-23.1-18.7-55.9-.5-79.3l50.5-65 0-14.6c-15.4-9.2-29.7-20.3-42.5-33.1L50.7 237.3c-25-25-25-65.5 0-90.5z"]
};
const faUsersLine = {
  prefix: 'far',
  iconName: 'users-line',
  icon: [640, 512, [], "e592", "M147.2 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM96 192c-35.3 0-64 28.7-64 64c0 17.7 14.3 32 32 32l98.7 0c18.2-31.4 49.3-54.4 86-61.6C238.1 206 216.7 192 192 192l-96 0zm480 96c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64l-96 0c-24.5 0-45.7 13.7-56.5 33.9c38 6.6 70.3 29.9 89 62.1l95.5 0zm-134.8 0c-14.6-16.3-34.6-27.5-57.1-30.9c-.6-.1-1.3-.2-1.9-.3c-4.1-.5-8.3-.8-12.5-.8l-48 0-48 0c-4.2 0-8.4 .3-12.5 .8c-1.7 .2-3.4 .5-5.1 .8c-21.3 3.9-40.1 14.9-53.9 30.4c-15.2 17-24.4 39.4-24.4 64c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32c0-24.6-9.2-47-24.4-64zm58-128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM321.6 112a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-48 96s0 0 0 0c13.4 10 30 16 48 16s34.6-6 48-16c0 0 0 0 0 0c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64zM414.9 336l-186.5 0c6.6-18.6 24.4-32 45.3-32l96 0c20.9 0 38.7 13.4 45.3 32zM0 456c0 13.3 10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24z"]
};
const faQuoteLeft = {
  prefix: 'far',
  iconName: 'quote-left',
  icon: [448, 512, [8220, "quote-left-alt"], "f10d", "M0 216C0 149.7 53.7 96 120 96l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-39.8 0-72 32.2-72 72l0 10c5.1-1.3 10.5-2 16-2l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32 0-32 0-72zm48 72l0 32 0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm336-16l-64 0c-8.8 0-16 7.2-16 16l0 32 0 32c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zM256 320l0-32 0-72c0-66.3 53.7-120 120-120l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-39.8 0-72 32.2-72 72l0 10c5.1-1.3 10.5-2 16-2l64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-32z"]
};
const faQuoteLeftAlt = faQuoteLeft;
const faTractor = {
  prefix: 'far',
  iconName: 'tractor',
  icon: [640, 512, [128668], "f722", "M152 48l114.3 0c3.3 0 6.2 2 7.4 5l42.8 107L192 160l-32 0-16 0 0-104c0-4.4 3.6-8 8-8zM96 56l0 136.6c-11.2-3.9-24.2-1.4-33.1 7.6L40.2 222.9c-12.5 12.5-12.5 32.8 0 45.3l5.8 5.8c-2.2 4.6-4.1 9.3-5.8 14.1L32 288c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l8.2 0c1.7 4.8 3.7 9.5 5.8 14.1l-5.8 5.8c-12.5 12.5-12.5 32.8 0 45.3l22.6 22.6c12.5 12.5 32.8 12.5 45.3 0l5.8-5.8c4.6 2.2 9.3 4.1 14.1 5.8l0 8.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-8.2c4.8-1.7 9.5-3.7 14.1-5.8l5.8 5.8c12.5 12.5 32.8 12.5 45.3 0l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3l-5.8-5.8c2.2-4.6 4.1-9.3 5.8-14.1l8.2 0 94.8 0c6.5-18.5 17.5-34.9 31.6-48L352 336l0-16c0-17.7-14.3-32-32-32l-8.2 0c-1.7-4.8-3.7-9.5-5.8-14.1l5.8-5.8c12.5-12.5 12.5-32.8 0-45.3L296.9 208l54.6 0c.4 0 .7 0 1.1 0L504 208l80 0c4.4 0 8 3.6 8 8l0 32.7c0 7.4-3.4 14.3-9.2 18.9l-46.7 36.7c20.1 1.3 38.9 7.7 55.1 17.7l21.3-16.7c17.4-13.6 27.5-34.5 27.5-56.6l0-32.7c0-30.9-25.1-56-56-56l-56 0 0-41.8c0-16.1 3.8-32.1 11-46.5l2.5-5c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7l-2.5 5c-10.6 21.1-16 44.4-16 68l0 41.8-111.8 0L318.3 35.2C309.8 13.9 289.2 0 266.3 0L152 0C121.1 0 96 25.1 96 56zm80 200a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM528 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 128a88 88 0 1 0 0-176 88 88 0 1 0 0 176z"]
};
const faDownFromBracket = {
  prefix: 'far',
  iconName: 'down-from-bracket',
  icon: [448, 512, [], "e66b", "M333.8 352L224 462 114.2 352l53.8 0c13.3 0 24-10.7 24-24l0-120 64 0 0 120c0 13.3 10.7 24 24 24l53.8 0zM224 512c11.5 0 22.5-4.6 30.6-12.7L370.4 383.2c8.7-8.7 13.6-20.5 13.6-32.8c0-25.6-20.8-46.4-46.4-46.4L304 304l0-96c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 96-33.6 0C84.8 304 64 324.8 64 350.4c0 12.3 4.9 24.1 13.6 32.8L193.4 499.3c8.1 8.1 19.1 12.7 30.6 12.7zM400 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-48.6-39.4-88-88-88L88 0C39.4 0 0 39.4 0 88l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-22.1 17.9-40 40-40l272 0c22.1 0 40 17.9 40 40l0 80z"]
};
const faKeySkeleton = {
  prefix: 'far',
  iconName: 'key-skeleton',
  icon: [448, 512, [128477], "f6f3", "M304 48a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144-64.5 144-144S383.5 0 304 0S160 64.5 160 144c0 31.1 9.9 59.9 26.6 83.4L7 407c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L88 393.9l47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 98.6-98.6C244.1 278.1 272.9 288 304 288z"]
};
const faTrashArrowUp = {
  prefix: 'far',
  iconName: 'trash-arrow-up',
  icon: [448, 512, ["trash-restore"], "f829", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zm154.5 65.9l64 64c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0L244 256.3 244 384c0 11-9 20-20 20s-20-9-20-20l0-127.7-29.9 29.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l64-64c7.8-7.8 20.5-7.8 28.3 0z"]
};
const faTrashRestore = faTrashArrowUp;
const faArrowDownUpLock = {
  prefix: 'far',
  iconName: 'arrow-down-up-lock',
  icon: [640, 512, [], "e4b0", "M145 505l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L152 280l264 0 0-8c0-14.1 2.6-27.6 7.4-40L344 232l0-150.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L337 7c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-96 96c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55L296 232l-144 0-48 0-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 150.1L49 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0zm7-313l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136 48 0zM296 320l0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136-48 0zm232-80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faArrowDownToBracket = {
  prefix: 'far',
  iconName: 'arrow-down-to-bracket',
  icon: [448, 512, [], "e094", "M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L200 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 246.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344l0 80c0 22.1 17.9 40 40 40l272 0c22.1 0 40-17.9 40-40l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faLinesLeaning = {
  prefix: 'far',
  iconName: 'lines-leaning',
  icon: [384, 512, [], "e51e", "M190.6 64.1c4.5-12.5-2-26.2-14.5-30.7s-26.2 2-30.7 14.5l-144 400c-4.5 12.5 2 26.2 14.5 30.7s26.2-2 30.7-14.5l144-400zm78.1-31.7c-13-2.6-25.6 5.8-28.2 18.8l-80 400c-2.6 13 5.8 25.6 18.8 28.2s25.6-5.8 28.2-18.8l80-400c2.6-13-5.8-25.6-18.8-28.2zM360 32c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24z"]
};
const faSquareQ = {
  prefix: 'far',
  iconName: 'square-q',
  icon: [448, 512, [], "e27b", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 256c0 44.2 35.8 80 80 80c13.4 0 25.9-3.3 37-9.1l-30-30c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l30 30c5.8-11.1 9.1-23.7 9.1-37c0-44.2-35.8-80-80-80s-80 35.8-80 80zm208 0c0 26.7-8.2 51.4-22.1 71.9L345 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15.1-15.1c-20.5 14-45.3 22.1-71.9 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128z"]
};
const faRulerCombined = {
  prefix: 'far',
  iconName: 'ruler-combined',
  icon: [512, 512, [], "f546", "M192 288l0-16 0-48-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 272 0 112c0 .6 0 1.2 .1 1.7c.8 8 7.7 14.3 15.9 14.3l112 0 272 0c8.8 0 16-7.2 16-16l0-112c0-8.8-7.2-16-16-16l-32 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-48 0-16 0 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0zm96-16l160 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-272 0L64 512C30.9 512 3.6 486.8 .3 454.5c-.2-2.2-.3-4.3-.3-6.5L0 336 0 64C0 28.7 28.7 0 64 0L176 0c35.3 0 64 28.7 64 64l0 160 0 48 48 0z"]
};
const faSymbols = {
  prefix: 'far',
  iconName: 'symbols',
  icon: [512, 512, [128291, "icons-alt"], "f86e", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zm0 80C10.7 80 0 90.7 0 104s10.7 24 24 24l64 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 80zM464 53.3l0 76.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-132.5c0-25.2-23.1-44.2-47.8-39.2l-128 25.6C317.5 33.6 304 50 304 69.1l0 92.4c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0 0 0 0 0 0l0-132.3L464 53.3zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm153-25c-9.4-9.4-24.6-9.4-33.9 0L295 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 329c9.4-9.4 9.4-24.6 0-33.9zM480 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM84 256c-37.7 0-68 30.8-68 68.2c0 19.3 8.2 37.9 22.6 50.8l4.5 4-17 13C9.6 404.8 0 424.4 0 445.1l0 1.4C0 482.7 29.3 512 65.5 512c14.9 0 29.3-5.1 40.9-14.3l36.3-29 41.3 37.2c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9l-35.5-31.9L215 410.7c10.4-8.3 12-23.4 3.7-33.7s-23.4-12-33.7-3.8l-40.6 32.5L118 381.9l7.9-6c16.5-12.7 26.1-32.2 26.1-53c0-36.9-29.9-66.9-66.9-66.9L84 256zM70.7 339.4c-4.2-3.8-6.7-9.4-6.7-15.2C64 313 73.1 304 84 304l1.1 0c10.4 0 18.9 8.5 18.9 18.9c0 5.9-2.7 11.4-7.4 15L81.8 349.3l-11-9.9zM55.4 430.1l24-18.4 27.1 24.4L76.4 460.2c-3.1 2.5-6.9 3.8-10.9 3.8c-9.6 0-17.5-7.8-17.5-17.5l0-1.4c0-5.9 2.7-11.4 7.4-15z"]
};
const faIconsAlt = faSymbols;
const faCopyright = {
  prefix: 'far',
  iconName: 'copyright',
  icon: [512, 512, [169], "f1f9", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"]
};
const faFlaskGear = {
  prefix: 'far',
  iconName: 'flask-gear',
  icon: [640, 512, [], "e5f1", "M176 48l0 148.8c0 20.7-5.8 41-16.6 58.7L100 352l225.8 0c.1 .1 .2 .1 .2 .2c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 6.7 1.5 13.5 4.2 19.7c-9 4.3-19 6.6-29.7 6.6L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 48l-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L288 0l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 148.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3c-5.2 9.1-9.6 18.4-13.1 27.9l-20.7-33.6c-10.9-17.7-16.6-38-16.6-58.7L272 48l-96 0zM447.3 203.4c-6.8 1.5-11.3 7.8-11.3 14.8l0 17.4c0 7.9-4.9 15-11.7 18.9c-6.8 3.9-15.2 4.5-22 .6l-13.6-7.8c-6.1-3.5-13.7-2.7-18.5 2.4c-7.5 8.1-14.3 17.2-20.1 27.2s-10.3 20.4-13.5 31c-2.1 6.7 1.1 13.7 7.2 17.2l14 8.1c6.5 3.8 10.1 11 10.1 18.6s-3.5 14.8-10.1 18.6l-14 8.1c-6.1 3.5-9.2 10.5-7.2 17.2c3.3 10.6 7.8 21 13.5 31s12.5 19.1 20.1 27.2c4.8 5.1 12.5 5.9 18.5 2.4l13.5-7.8c6.8-3.9 15.2-3.3 22 .6c6.9 3.9 11.7 11 11.7 18.9l0 17.4c0 7 4.5 13.3 11.3 14.8c10.5 2.4 21.5 3.7 32.7 3.7s22.2-1.3 32.7-3.7c6.8-1.5 11.3-7.8 11.3-14.8l0-17.7c0-7.8 4.8-14.8 11.6-18.7c6.7-3.9 15.1-4.5 21.8-.6l13.8 7.9c6.1 3.5 13.7 2.7 18.5-2.4c7.6-8.1 14.3-17.2 20.1-27.2s10.3-20.4 13.5-31c2.1-6.7-1.1-13.7-7.2-17.2l-14.4-8.3c-6.5-3.7-10-10.9-10-18.4s3.5-14.7 10-18.4l14.4-8.3c6.1-3.5 9.2-10.5 7.2-17.2c-3.3-10.6-7.8-21-13.5-31s-12.5-19.1-20.1-27.2c-4.8-5.1-12.5-5.9-18.5-2.4l-13.8 7.9c-6.7 3.9-15.1 3.3-21.8-.6c-6.8-3.9-11.6-10.9-11.6-18.7l0-17.7c0-7-4.5-13.3-11.3-14.8c-10.5-2.4-21.5-3.7-32.7-3.7s-22.2 1.3-32.7 3.7zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faHighlighterLine = {
  prefix: 'far',
  iconName: 'highlighter-line',
  icon: [576, 512, [], "e1af", "M169.9 330.6l-38.1 38.1 51.5 51.5 38.1-38.1c9-9 21.2-14.1 33.9-14.1l48 0 16.2-22.5-113-113L184 248.6l0 48c0 12.7-5.1 24.9-14.1 33.9zm178-24.6L502.8 90.2c.8-1.1 1.2-2.4 1.2-3.7c0-1.7-.7-3.3-1.9-4.5L470 49.9c-1.2-1.2-2.8-1.9-4.5-1.9c-1.3 0-2.6 .4-3.7 1.2L246 204.1 347.9 306zM303.4 416l-48 0-43.7 43.7c-10.7 10.7-26 14.1-39.5 10.1l-32.8 32.8c-6 6-14.1 9.4-22.6 9.4L32 512c-17.7 0-32-14.3-32-32l0-4.7c0-8.5 3.4-16.6 9.4-22.6l72.8-72.8c-4-13.6-.6-28.8 10.1-39.5L136 296.6l0-48c0-15.5 7.4-30 20-39L433.8 10.2C443 3.6 454.1 0 465.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4c0 11.4-3.6 22.5-10.2 31.7L342.4 396c-9 12.6-23.5 20-39 20zm-190.7 1.3L65.9 464l44.1 0 24.7-24.7-22.1-22.1zM248 464l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faBracketSquare = {
  prefix: 'far',
  iconName: 'bracket-square',
  icon: [192, 512, ["bracket", "bracket-left"], "5b", "M0 88C0 57.1 25.1 32 56 32l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 80c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-30.9 0-56-25.1-56-56L0 88z"]
};
const faBracket = faBracketSquare;
const faBracketLeft = faBracketSquare;
const faIslandTropical = {
  prefix: 'far',
  iconName: 'island-tropical',
  icon: [512, 512, [127965, "island-tree-palm"], "f811", "M114.3 93.7c-1.5 1.5-3.5 2.3-5.7 2.3L78.2 96c-8.8 0-16.1-7.2-13.8-15.8C73.6 44.8 112.8 0 190.2 0c58.4 0 95 25.5 113.5 53.2C323.6 40.6 350.2 32 384 32c77.4 0 116.6 44.8 125.8 80.2c2.2 8.6-5 15.8-13.8 15.8l-44.7 0c-2.1 0-4.2-.8-5.7-2.3l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24c-1.5 1.5-3.5 2.3-5.7 2.3l-61.3 0c3.5 15.4 7.2 35.7 9.5 59.7c4.4 45.4 3.7 104.4-13.9 167.1c57.7 12.4 101 63.7 101 125.1c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32c0-70.7 57.3-128 128-128l24.9 0c26-56.3 38-110.2 43.3-151.1c1.3-9.9 2.2-19 2.8-27.1l-71.8 71.8c-6.2 6.2-16.5 6.2-21-1.4c-18.5-31.6-22.5-90.9 32.3-145.7c1.4-1.4 2.8-2.7 4.1-4c-.3-.3-.7-.5-1-.8l-24-24c-3.1-3.1-8.2-3.1-11.3 0l-24 24zM237.3 352l28.5 0c18.5-59.2 19.5-115.9 15.3-159.7c-.6-6.1-1.3-12-2-17.5c-.7 9.6-1.7 20.5-3.3 32.4c-5.2 39.6-16 90.6-38.5 144.9zM288 400l-128 0c-38.7 0-71 27.5-78.4 64l284.8 0c-7.4-36.5-39.7-64-78.4-64z"]
};
const faIslandTreePalm = faIslandTropical;
const faArrowRightFromLine = {
  prefix: 'far',
  iconName: 'arrow-right-from-line',
  icon: [448, 512, [8614, "arrow-from-left"], "f343", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88zM440.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L363.5 232 280 232l-128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
};
const faArrowFromLeft = faArrowRightFromLine;
const faH2 = {
  prefix: 'far',
  iconName: 'h2',
  icon: [640, 512, [], "f314", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zm397.3 40.8C457.9 118 474 112 490.7 112l9.2 0c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3l224 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-162.6 0L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64l-9.2 0c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"]
};
const faEquals = {
  prefix: 'far',
  iconName: 'equals',
  icon: [448, 512, [62764], "3d", "M40 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 144zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l368 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 320z"]
};
const faCakeSlice = {
  prefix: 'far',
  iconName: 'cake-slice',
  icon: [512, 512, [127856, "shortcake"], "e3e5", "M464 304l0 .2 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3L48 352l0-48 416 0zM48 416l0-32 416 0 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM296 32c-7.2 0-14.2 2.4-19.8 6.9l-264 208C4.5 252.9 0 262.2 0 272L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.6 64-64l0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.2 0-.3 0-.2 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.3 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.4 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5 0-.5c0-74.3-32.8-130.8-76.1-168.2C393.6 51.2 340.3 32 296 32z"]
};
const faShortcake = faCakeSlice;
const faBuildingMagnifyingGlass = {
  prefix: 'far',
  iconName: 'building-magnifying-glass',
  icon: [640, 512, [], "e61c", "M64 48l256 0c8.8 0 16 7.2 16 16l0 141.7c13.8-13.5 30-24.6 48-32.4L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c29.2 0 53.9-19.6 61.6-46.4c-17-7.8-32.4-18.4-45.6-31.3l0 13.7c0 8.8-7.2 16-16 16l-80 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 64-80 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM296 232c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c4 0 7.6-1.5 10.4-3.9c1.3-7.6 3.2-15 5.6-22.2l0-37.9zM88 104l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zM232 88c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0zM88 232l0 48c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-48c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm360 8.1a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208c26.7 0 51.4-8.2 71.9-22.1L599 505.1c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-79.1-79.1c14-20.5 22.1-45.3 22.1-71.9c0-70.7-57.3-128-128-128s-128 57.3-128 128s57.3 128 128 128z"]
};
const faPeanut = {
  prefix: 'far',
  iconName: 'peanut',
  icon: [512, 512, [], "e430", "M435 218.4c18-18.1 29-42.9 29-70.4l0-68c0-17.7-14.3-32-32-32l-68 0c-13.6 0-26.5 2.7-38.3 7.6c0 0 0 0 0 0c-11.7 4.8-22.7 12-32.3 21.6l-.3 .3s0 0 0 0c-9.6 9.6-16.7 20.6-21.5 32.2c0 0 0 0 0 0c-2.7 6.4-4.7 13.2-5.9 20.2l-.1 .4-.1 .4c-5.3 26.6-15.3 63.2-43.4 91.3s-64.7 38.2-91.3 43.4l-.4 .1-.4 .1c-7 1.3-13.8 3.3-20.2 5.9c0 0 0 0 0 0C98 276.4 87 283.6 77.3 293.3c-9.7 9.7-16.9 20.7-21.7 32.4c0 0 0 0 0 0C50.7 337.5 48 350.4 48 364l0 68c0 17.7 14.3 32 32 32l68 0c27.4 0 52.1-10.9 70.2-28.7l32.7 33.2-32.7-33.2c.4-.4 .8-.7 1.1-1.1c0 0 0 0 0 0c9.4-9.5 16.4-20.4 21.1-31.9c0 0 0 0 0 0c2.7-6.4 4.7-13.2 5.9-20.2l.1-.4 .1-.4c5.3-26.6 15.3-63.2 43.4-91.3s64.7-38.2 91.3-43.4l.4-.1 .4-.1c7-1.3 13.8-3.3 20.2-5.9c0 0 0 0 0 0c11.6-4.8 22.6-11.9 32.2-21.4c0 0 0 0 0 0l.6-.6s0 0 0 0zM512 148c0 40.6-16.4 77.4-42.9 104.2l-.9 .9c-14.1 14-30.3 24.6-47.6 31.7c-9.5 4-19.6 6.9-30 8.8c-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30c-7.1 17.1-17.5 33.2-31.3 47.2c-.5 .6-1.1 1.1-1.7 1.7C225.1 495.8 188.5 512 148 512l-68 0c-44.2 0-80-35.8-80-80l0-68c0-20.1 4-39.2 11.2-56.7c7.2-17.5 17.9-33.8 32.1-48c14.2-14.2 30.6-24.9 48.1-32.1c9.5-4 19.6-6.9 30-8.8c24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30C234.4 74 245 57.8 259.1 43.6l.4-.4c14.2-14.1 30.5-24.8 47.8-32C324.8 4 343.9 0 364 0l68 0c44.2 0 80 35.8 80 80l0 68zM372.8 136a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-192 192a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 372.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM372.8 200a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM200 308.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z"]
};
const faWrenchSimple = {
  prefix: 'far',
  iconName: 'wrench-simple',
  icon: [384, 512, [], "e2d1", "M133 10.3c6.9 4.4 11 12 11 20.2l0 119.6 48 48 48-48 0-119.6c0-8.2 4.2-15.8 11-20.2s15.5-5 23-1.6C338.3 38.2 384 98.5 384 176c0 64.3-31.6 121.1-80 156l0 156c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-168.9c0-8.3 4.3-16.1 11.4-20.4C308.6 273.3 336 227.8 336 176c0-42.2-18.3-77.7-48-102.4l0 86.4c0 6.4-2.5 12.5-7 17l-72 72c-4.5 4.5-10.6 7-17 7s-12.5-2.5-17-7l-72-72c-4.5-4.5-7-10.6-7-17l0-86.4C66.3 98.3 48 133.8 48 176c0 51.8 27.4 97.3 68.6 122.7c7.1 4.4 11.4 12.1 11.4 20.4L128 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-156C31.6 297.1 0 240.3 0 176C0 98.5 45.7 38.2 110 8.7c7.4-3.4 16.1-2.8 23 1.6z"]
};
const faBlender = {
  prefix: 'far',
  iconName: 'blender',
  icon: [512, 512, [], "f517", "M0 80C0 35.8 35.8 0 80 0l48 0 32 0 16.2 0L471 0c20.8 0 36.1 19.6 31 39.8L425.6 345.5C457.8 361 480 393.9 480 432l0 16c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-16c0-40.5 25.1-75.1 60.6-89.2L149.3 256 80 256c-44.2 0-80-35.8-80-80L0 80zM144 432l0 16c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-16c0-26.5-21.5-48-48-48l-192 0c-26.5 0-48 21.5-48 48zM406.5 224L304 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l110.5 0 16-64L304 128c-8.8 0-16-7.2-16-16s7.2-16 16-16l134.5 0 12-48L180.2 48l24 288 174.4 0 28-112zM80 48C62.3 48 48 62.3 48 80l0 96c0 17.7 14.3 32 32 32l65.3 0L132 48 80 48zM288 400a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faTeeth = {
  prefix: 'far',
  iconName: 'teeth',
  icon: [576, 512, [], "f62e", "M96 80c-26.5 0-48 21.5-48 48l0 45.4C63.9 150.8 90.2 136 120 136c15.2 0 29.5 3.9 42 10.7c16.1-21.1 41.4-34.7 70-34.7c21.3 0 40.8 7.5 56 20.1c15.2-12.6 34.7-20.1 56-20.1c28.5 0 53.9 13.6 70 34.7c12.5-6.8 26.8-10.7 42-10.7c29.8 0 56.1 14.8 72 37.4l0-45.4c0-26.5-21.5-48-48-48L96 80zM48 362.6L48 384c0 26.5 21.5 48 48 48l384 0c26.5 0 48-21.5 48-48l0-21.4c-15.9 22.6-42.2 37.4-72 37.4c-21.3 0-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1s-40.8-7.5-56-20.1c-15.2 12.6-34.7 20.1-56 20.1c-29.8 0-56.1-14.8-72-37.4zM0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 128zm192 72l0 24 0 16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1l48 0c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2l0-40c0-10.9-4.4-20.8-11.4-28c-7.3-7.4-17.4-12-28.6-12c-15.2 0-28.4 8.5-35.2 21c-3.1 5.7-4.8 12.1-4.8 19zm64 88l-48 0c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.7-.1-1.3-.1-2-.1zm48 16l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12s21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9c-.6-.1-1.3-.1-2-.1l-48 0c-.7 0-1.3 0-2 .1c-7.2 .9-13 6.6-13.9 13.9c-.1 .7-.1 1.3-.1 2zm16-48l48 0c.7 0 1.3 0 2-.1c7.3-.9 13-6.6 13.9-13.9c.1-.7 .1-1.3 .1-2l0-16 0-24c0-6.9-1.7-13.4-4.8-19c-6.8-12.5-20-21-35.2-21c-11.2 0-21.3 4.6-28.6 12c-7.1 7.2-11.4 17.1-11.4 28l0 40c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9c.7 .1 1.3 .1 2 .1zm110-.1c.6 .1 1.3 .1 2 .1l48 0c8.2 0 14.9-6.1 15.9-14c.1-.7 .1-1.3 .1-2l0-16c0-22.1-17.9-40-40-40c-9.2 0-17.6 3.1-24.3 8.3c-2.9 2.2-5.5 4.8-7.7 7.7c-5 6.7-8 15-8 24l0 16c0 .7 0 1.3 .1 2c.9 7.2 6.6 13 13.9 13.9zM416.1 302c-.1 .7-.1 1.3-.1 2l0 8c0 10.9 4.4 20.8 11.4 28c7.3 7.4 17.4 12 28.6 12c22.1 0 40-17.9 40-40l0-8c0-.7 0-1.3-.1-2c-1-7.9-7.7-14-15.9-14l-48 0c-.7 0-1.3 0-2 .1c-7.3 .9-13 6.6-13.9 13.9zM146 288.1c-.7-.1-1.3-.1-2-.1l-48 0c-8.2 0-14.9 6.1-15.9 14c-.1 .7-.1 1.3-.1 2l0 8c0 22.1 17.9 40 40 40c11.2 0 21.3-4.6 28.6-12c7.1-7.2 11.4-17.1 11.4-28l0-8c0-.7 0-1.3-.1-2c-.9-7.2-6.6-13-13.9-13.9zM159.9 242c.1-.7 .1-1.3 .1-2l0-16c0-9-3-17.3-8-24c-2.2-2.9-4.8-5.5-7.7-7.7c-6.7-5.2-15.2-8.3-24.3-8.3c-22.1 0-40 17.9-40 40l0 16c0 .7 0 1.3 .1 2c1 7.9 7.7 14 15.9 14l48 0c.7 0 1.3 0 2-.1c7.2-.9 13-6.6 13.9-13.9z"]
};
const faTally2 = {
  prefix: 'far',
  iconName: 'tally-2',
  icon: [640, 512, [], "e295", "M152 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384zm128 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 384c0 13.3 10.7 24 24 24s24-10.7 24-24l0-384z"]
};
const faShekelSign = {
  prefix: 'far',
  iconName: 'shekel-sign',
  icon: [448, 512, [8362, "ils", "shekel", "sheqel", "sheqel-sign"], "f20b", "M40 32C26.7 32 16 42.7 16 56l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24L64 80l120 0c39.8 0 72 32.2 72 72l0 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-184c0-66.3-53.7-120-120-120L40 32zM312 480c66.3 0 120-53.7 120-120l0-304c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 304c0 39.8-32.2 72-72 72l-120 0 0-248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24l144 0z"]
};
const faIls = faShekelSign;
const faShekel = faShekelSign;
const faSheqel = faShekelSign;
const faSheqelSign = faShekelSign;
const faCars = {
  prefix: 'far',
  iconName: 'cars',
  icon: [640, 512, [], "f85b", "M137.8 48l140.3 0c10.1 0 19.2 6.4 22.6 15.9L317.9 112 98.1 112l17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zM41.4 127.9c-.2 .5-.3 .9-.5 1.4C16.2 146.7 0 175.5 0 208l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 172.1 0c5.3-6.6 11.3-12.7 17.8-18.2L248.5 240 48 240l0-32c0-26.5 21.5-48 48-48l190.8 0c19.2-20 46.1-32 75.1-32l12.8 0c0 0 0 0 0-.1L346 47.8C335.7 19.1 308.6 0 278.2 0L137.8 0C107.4 0 80.3 19.1 70 47.8L41.4 127.9zM112 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm249.8-16l140.3 0c10.1 0 19.2 6.4 22.6 15.9L541.9 272l-219.9 0 17.2-48.1c3.4-9.6 12.5-15.9 22.6-15.9zm-96.4 79.9c-.2 .5-.3 .9-.5 1.4C240.2 306.7 224 335.5 224 368l0 32 0 16 0 32 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 320 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 0-32 0-16 0-32c0-32.5-16.2-61.3-40.9-78.7c-.1-.5-.3-.9-.5-1.4L570 207.8c-10.2-28.7-37.4-47.8-67.8-47.8l-140.3 0c-30.4 0-57.6 19.1-67.8 47.8l-28.6 80.1zM544 320c26.5 0 48 21.5 48 48l0 32-320 0 0-32c0-26.5 21.5-48 48-48l224 0zM336 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faAxeBattle = {
  prefix: 'far',
  iconName: 'axe-battle',
  icon: [512, 512, [], "f6b3", "M120.8 70.4c15 20 39.3 40.8 79.2 51.1l0 49.2c-57.2-11.6-94.4-40.5-117.6-71.5c-3.1-4.2-6.2-8.6-9.2-13.3C57.2 119.3 48 156.7 48 192c0 36.8 10 76.1 27.4 110.7c4.4-6.6 9-12.9 13.8-18.8l37.3 30.3c-13.6 16.8-25 36.8-30.9 57.8c-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3c-4.4-5.3-8.7-10.9-12.8-16.6l-1-1.4c-1.1-1.6-2.3-3.3-3.4-4.9l-.2-.3C18.6 307.4 0 247.9 0 192C0 136.2 18.5 77.4 50 29.8l.7-1c2.1-3.1 4.2-6.1 6.3-9.1l.5-.7c3.3-4.5 6.7-8.9 10.2-13.2C71.8 .9 78.4-1.1 84.5 .7c6.1 1.8 10.5 7 11.3 13.3c.9 6.4 2.6 12.8 4.7 19l.2 .6c.6 1.7 1.2 3.3 1.9 5l.1 .2c4.6 11.4 11 22.2 18 31.7zm5.6 243.7L89.2 283.8c23.4-28.8 59.1-57.3 110.8-69.5l0 49.7c-34.2 10.7-57.6 30.4-73.6 50.1zM312 170.7l0-49.2c40-10.3 64.3-31.1 79.3-51.1c7.1-9.5 13.4-20.3 18-31.7l.1-.2c.7-1.6 1.3-3.3 1.9-5l.2-.6c2.2-6.2 3.8-12.6 4.7-19c.8-6.3 5.3-11.5 11.3-13.3c6.1-1.8 12.7 .2 16.8 5.1c3.5 4.3 6.9 8.7 10.2 13.2l.5 .7c2.2 3 4.3 6 6.3 9.1l.7 1c27.1 41.1 44.6 90.5 48.9 139.2L488 192l23.1 23.1c-4.3 48.9-22 98.9-49.4 140l-.2 .3c-1.1 1.7-2.2 3.3-3.4 4.9l-1 1.4c-4.1 5.7-8.3 11.3-12.8 16.6c-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8c-15.9-19.6-39.4-39.4-73.7-50.1l0-49.7c51.7 12.3 87.5 40.7 110.9 69.5c4.8 5.9 9.4 12.2 13.8 18.8c11.1-22.1 19.3-46.2 23.6-70.4l-6.3-6.3c-18.7-18.7-18.7-49.1 0-67.9l6.3-6.3c-4.1-22.6-11.5-45-21.5-65.9c-3 4.7-6 9.2-9.2 13.3c-23.2 31-60.5 59.9-117.7 71.5zM280 56l0 432c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-432c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faUserHairLong = {
  prefix: 'far',
  iconName: 'user-hair-long',
  icon: [448, 512, [], "e45b", "M304 128c0-11.4-2.4-22.2-6.7-32L296 96c-20.5 0-38.7-9.6-50.4-24.5C231.9 95.7 205.8 112 176 112l-30.4 0c-1 5.2-1.6 10.5-1.6 16l0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 11c0 33.9 13.5 66.5 37.5 90.5l3.9 3.9c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6L224 272 70.6 272C58.1 272 48 261.9 48 249.4c0-6 2.4-11.8 6.6-16l3.9-3.9c24-24 37.5-56.6 37.5-90.5l0-11zM49.3 464l349.4 0c-8.3-54.4-55.3-96-112-96l-125.4 0c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320l125.4 0C375.8 320 448 392.2 448 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z"]
};
const faMap = {
  prefix: 'far',
  iconName: 'map',
  icon: [576, 512, [128506, 62072], "f279", "M565.6 36.2C572.1 40.7 576 48.1 576 56l0 336c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456L0 120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5l0 284.6 120-45.7 0-284.6L48 136.5zM360 422.7l0-285.4-144-48 0 285.4 144 48zm48-1.5l120-45.7 0-284.6L408 136.5l0 284.6z"]
};
const faArrowLeftFromArc = {
  prefix: 'far',
  iconName: 'arrow-left-from-arc',
  icon: [512, 512, [], "e615", "M464 256c0-114.9-93.1-208-208-208c-13.3 0-24-10.7-24-24s10.7-24 24-24C397.4 0 512 114.6 512 256s-114.6 256-256 256c-13.3 0-24-10.7-24-24s10.7-24 24-24c114.9 0 208-93.1 208-208zM119.7 134.4c9.7-9 24.9-8.5 33.9 1.3s8.5 24.9-1.3 33.9L85.1 232 328 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L85.1 280l67.2 62.4c9.7 9 10.3 24.2 1.3 33.9s-24.2 10.3-33.9 1.3l-112-104C2.8 269 0 262.7 0 256s2.8-13 7.7-17.6l112-104z"]
};
const faFileCircleInfo = {
  prefix: 'far',
  iconName: 'file-circle-info',
  icon: [576, 512, [58604], "e493", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-32 48c0 8.8 7.2 16 16 16c0 0 0 0 0 0l0 48s0 0 0 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-64c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faFaceDisappointed = {
  prefix: 'far',
  iconName: 'face-disappointed',
  icon: [512, 512, [], "e36f", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM294.5 408.4c-7.4-7.9-20-16.4-38.5-16.4s-31.1 8.5-38.5 16.4c-9 9.7-24.2 10.2-33.9 1.2s-10.2-24.2-1.2-33.9C196.7 360.3 221.4 344 256 344s59.3 16.3 73.5 31.6c9 9.7 8.5 24.9-1.2 33.9s-24.9 8.5-33.9-1.2zM211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"]
};
const faLassoSparkles = {
  prefix: 'far',
  iconName: 'lasso-sparkles',
  icon: [576, 512, [], "e1c9", "M290.7 0L288 0C128.9 0 0 78.8 0 176c0 60.6 50.2 114.1 126.6 145.8l44.3 20.5c22.6 10.4 37.1 33 37.1 57.9c0 35.2-28.6 63.8-63.8 63.8L56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l88.2 0C205.9 512 256 461.9 256 400.2c0-17.8-4.2-34.9-11.9-50.2c14.3 1.3 29 2 43.9 2c159.1 0 288-78.8 288-176c0-76.4-79.6-141.4-191-165.8l5.6 15.1 26 9.6C435.5 42 448 59.9 448 80l0 .6c49.1 23.4 80 57.5 80 95.4c0 70.7-107.5 128-240 128S48 246.7 48 176c0-60.7 79.2-111.5 185.5-124.7c5.4-7.3 12.9-13 21.8-16.3l26-9.6L290.7 0zM351 10.4C348.7 4.2 342.7 0 336 0s-12.7 4.2-15 10.4L306.3 50.3 266.4 65c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L321 149.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L405.6 95c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15L365.7 50.3 351 10.4zM496 352c-6.7 0-12.7 4.2-15 10.4l-14.7 39.8L426.4 417c-6.3 2.3-10.4 8.3-10.4 15s4.2 12.7 10.4 15l39.8 14.7L481 501.6c2.3 6.3 8.3 10.4 15 10.4s12.7-4.2 15-10.4l14.7-39.8L565.6 447c6.3-2.3 10.4-8.3 10.4-15s-4.2-12.7-10.4-15l-39.8-14.7L511 362.4c-2.3-6.3-8.3-10.4-15-10.4z"]
};
const faClockEleven = {
  prefix: 'far',
  iconName: 'clock-eleven',
  icon: [512, 512, [], "e347", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 56.7-20-30c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l64 96c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faRocket = {
  prefix: 'far',
  iconName: 'rocket',
  icon: [512, 512, [], "f135", "M368.3 265c-44.5 30.1-129.3 68.2-175.7 88l-35-35c20.4-46.1 59.2-130 89.3-174.4C309.1 52 398.4 41.8 461.7 50.3c8.5 63.3-1.7 152.6-93.3 214.7zM118.5 288c-3.6 8-6.8 15.2-9.4 21.2c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9c6.5-2.7 14.3-6 23-9.8l0 96.2c0 8.6 4.6 16.6 12.1 20.9s16.7 4.2 24.1-.2l88.5-52.5c21.9-13 35.3-36.5 35.3-61.9l0-82.1c4-2.5 7.7-4.9 11.3-7.3C516.1 222.9 520.1 100.9 506.7 28.1c-2.1-11.6-11.2-20.6-22.8-22.8C411.1-8.1 289.1-4.1 207.2 116.7c-2.4 3.6-4.9 7.3-7.3 11.3l-82.1 0c-25.4 0-49 13.4-61.9 35.3L3.4 251.8c-4.4 7.4-4.5 16.6-.2 24.1S15.4 288 24 288l94.5 0zM408 144a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]
};
const faSirenOn = {
  prefix: 'far',
  iconName: 'siren-on',
  icon: [640, 512, [], "e02e", "M69.3 36l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zM597.3 76l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 192l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM490 304l-48.4 0L423.4 158c-1-8-7.8-14-15.9-14l-175 0c-8.1 0-14.9 6-15.9 14L198.4 304 150 304l19-151.9c4-32 31.2-56.1 63.5-56.1l175 0c32.3 0 59.5 24 63.5 56.1L490 304zm-246.1 0l12.2-98c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-11.8 94-32.2 0zM496 384l-352 0 0 48 352 0 0-48zM144 336l352 0c26.5 0 48 21.5 48 48l0 48c0 26.5-21.5 48-48 48l-352 0c-26.5 0-48-21.5-48-48l0-48c0-26.5 21.5-48 48-48z"]
};
const faClockTen = {
  prefix: 'far',
  iconName: 'clock-ten',
  icon: [512, 512, [], "e354", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 91.2L173.3 172c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l96 64c7.4 4.9 16.8 5.4 24.6 1.2S280 264.9 280 256l0-136c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faCandleHolder = {
  prefix: 'far',
  iconName: 'candle-holder',
  icon: [448, 512, [128367], "f6bc", "M128 112c0 17.7 14.3 32 32 32s32-14.3 32-32c0-3.2-3.6-14.8-17.4-33.6c-4.7-6.4-9.8-12.5-14.6-18.1c-4.9 5.5-9.9 11.7-14.6 18.1C131.6 97.2 128 108.8 128 112zm32 80c-44.2 0-80-35.8-80-80c0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zm-32 80l-32 0 0 192 128 0 0-192-48 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zM48 464l0-192c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 192 36.1 0c-2.7-7.5-4.1-15.6-4.1-24c0-39.8 32.2-72 72-72s72 32.2 72 72c0 39.7-32.2 71.9-71.8 72c0 0-.1 0-.1 0s0 0-.1 0l-104 0-48 0L96 512l-48 0-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0zm352-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faVideoArrowDownLeft = {
  prefix: 'far',
  iconName: 'video-arrow-down-left',
  icon: [576, 512, [], "e2c8", "M320 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l256 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-33 0-190 0-33c0-35.3-28.7-64-64-64L64 64zm464 84.6l0 214.7L416 313l0 52.6 104.3 46.9c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-241c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 146.4l0 52.6 112-50.4zM232 352c13.3 0 24-10.7 24-24s-10.7-24-24-24l-54.1 0L281 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-103 103 0-54.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l112 0z"]
};
const faPhotoFilm = {
  prefix: 'far',
  iconName: 'photo-film',
  icon: [640, 512, ["photo-video"], "f87c", "M256 48c-8.8 0-16 7.2-16 16l0 224c0 8.7 6.9 15.8 15.6 16l69.1-94.2c4.5-6.2 11.7-9.8 19.4-9.8s14.8 3.6 19.4 9.8L380 232.4l56-85.6c4.4-6.8 12-10.9 20.1-10.9s15.7 4.1 20.1 10.9L578.7 303.8c7.6-1.3 13.3-7.9 13.3-15.8l0-224c0-8.8-7.2-16-16-16L256 48zM192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224zm-56 64l24 0 0 48 0 88 0 112 0 8 0 80 192 0 0-80 48 0 0 80 48 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64l-48 0-24 0-24 0-192 0-24 0-24 0-48 0c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l48 0 24 0zm-24 48l-48 0c-8.8 0-16 7.2-16 16l0 48 64 0 0-64zm0 288l0-64-64 0 0 48c0 8.8 7.2 16 16 16l48 0zM48 352l64 0 0-64-64 0 0 64zM304 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPhotoVideo = faPhotoFilm;
const faFloppyDiskCircleArrowRight = {
  prefix: 'far',
  iconName: 'floppy-disk-circle-arrow-right',
  icon: [576, 512, ["save-circle-arrow-right"], "e180", "M48 96l0 320c0 8.8 7.2 16 16 16l204 0c6.9 17.5 16.4 33.7 28.2 48L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8L320 184c0 13.3-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24L80 80 64 80c-8.8 0-16 7.2-16 16zm381.3 29.3c12 12 18.7 28.3 18.7 45.3l0 22.2c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9l0-24.4c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9zM256 368c0 2.5 .1 4.9 .2 7.4c-9.4 5.5-20.4 8.6-32.2 8.6c-35.3 0-64-28.7-64-64s28.7-64 64-64c22.1 0 41.6 11.2 53.1 28.3C263.7 309.2 256 337.7 256 368zM128 80l0 80 144 0 0-80L128 80zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L457.4 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"]
};
const faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
const faFolderMinus = {
  prefix: 'far',
  iconName: 'folder-minus',
  icon: [512, 512, [], "f65d", "M251.7 127.6s0 0 0 0c10.5 10.5 24.7 16.4 39.6 16.4L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zm33.9-33.9L242.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L291.3 96c-2.1 0-4.2-.8-5.7-2.3zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faHexagonNodesBolt = {
  prefix: 'far',
  iconName: 'hexagon-nodes-bolt',
  icon: [576, 512, [], "e69a", "M224 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-24c0 26.9-16.5 49.9-40 59.3l0 73.3c23.5 9.5 40 32.5 40 59.3c0 3.4-.3 6.7-.8 10l1 .6c-9.2 13-16.7 27.4-22.1 42.7l-3.5-2.1c-4.4 3.3-9.3 6.1-14.5 8.2l0 73.3c3.4 1.4 6.7 3.1 9.9 5c3.8 26.3 13.5 50.8 27.7 72C277.9 492.4 253.2 512 224 512c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-3.4 .3-6.7 .8-10l-58.2-34.9c-4.5 3.4-9.4 6.1-14.6 8.2l0 73.3c5.1 2.1 10 4.8 14.5 8.2l29.4-17.6c4.7 15.8 13.3 29.9 24.7 41.1L127.2 342c4 25.4-7.6 51.8-31.2 65.4C65.4 425.1 26.3 414.6 8.6 384S1.4 314.3 32 296.6c2.6-1.5 5.3-2.8 8-3.9l0-73.3c-2.7-1.1-5.4-2.4-8-3.9C1.4 197.8-9.1 158.6 8.6 128S65.4 86.9 96 104.6c23.6 13.6 35.2 40 31.2 65.4l58.2 34.9c4.4-3.3 9.3-6.1 14.5-8.2l0-73.3c-23.5-9.5-40-32.5-40-59.3c0-35.3 28.7-64 64-64s64 28.7 64 64zM432 192c-30.3 0-58.8 7.7-83.7 21.1c-1-.6-1.9-1.3-2.8-2l-29.4 17.6c-4.7-15.8-13.3-29.9-24.7-41.1l29.4-17.6c-4-25.4 7.7-51.7 31.2-65.4c30.6-17.7 69.8-7.2 87.4 23.4c11.9 20.6 11 45-.1 64.1c-2.4-.1-4.9-.2-7.4-.2zM224 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm172-99.2a24 24 0 1 0 -24-41.6 24 24 0 1 0 24 41.6zM84.8 172A24 24 0 1 0 43.2 148a24 24 0 1 0 41.6 24zM248 448a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM43.2 364a24 24 0 1 0 41.6-24A24 24 0 1 0 43.2 364zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm47.9 63c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2l35.6 0-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1 .6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2l-35.6 0 30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"]
};
const faPlanetMoon = {
  prefix: 'far',
  iconName: 'planet-moon',
  icon: [576, 512, [], "e01f", "M512 0a64 64 0 1 1 0 128A64 64 0 1 1 512 0zM224 464c97.2 0 176-78.8 176-176c0-82.2-56.4-151.3-132.6-170.6l-71 82.9c-11.5 13.4-10.7 33.4 1.8 45.9c6.3 6.3 14.9 9.9 23.9 9.9l66 0c17.7 0 32 14.3 32 32l0 15.9c0 10.6-2.6 21-7.6 30.3l-41.3 76.6c-4.4 8.1-12.8 13.2-22 13.2c-13.8 0-25-11.2-25-25l0-47c-17.7 0-32-14.3-32-32l0-32-49.9-49.9c-9-9-21.2-14.1-33.9-14.1L60 224c-7.7 19.8-12 41.4-12 64c0 97.2 78.8 176 176 176zM0 288c0-52.3 17.9-100.5 48-138.6c1-1.3 2.1-2.6 3.2-3.9C92.2 95.7 154.4 64 224 64c13.3 0 26.4 1.2 39.1 3.4C368.2 85.9 448 177.6 448 288c0 123.7-100.3 224-224 224S0 411.7 0 288z"]
};
const faFaceEyesXmarks = {
  prefix: 'far',
  iconName: 'face-eyes-xmarks',
  icon: [512, 512, [], "e374", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM137 135l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zm192 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM256 304c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80z"]
};
const faChartScatter = {
  prefix: 'far',
  iconName: 'chart-scatter',
  icon: [512, 512, [], "f7ee", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 408c0 39.8 32.2 72 72 72l416 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 432c-13.3 0-24-10.7-24-24L48 56zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faCircleGf = {
  prefix: 'far',
  iconName: 'circle-gf',
  icon: [512, 512, [], "e67f", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM184 128c39.8 0 72 32.2 72 72c0 13.3-10.7 24-24 24s-24-10.7-24-24s-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0c13.3 0 24 10.7 24 24l0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112c0-39.8 32.2-72 72-72zm104 24c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 64 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96 0-112z"]
};
const faDisplayArrowDown = {
  prefix: 'far',
  iconName: 'display-arrow-down',
  icon: [576, 512, [], "e164", "M64 0L224 0l0 48L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L352 48l0-48L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM260.3 416l-8 48 71.3 0-8-48-55.3 0zM312 24l0 182.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39L264 24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faStore = {
  prefix: 'far',
  iconName: 'store',
  icon: [576, 512, [], "f54e", "M507.1 129.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-3.9 9.2-11.1 14.8-20.1 16c-2 .3-3.9 .4-5.8 .4c-11.7 0-22.2-5.1-29.7-13.2c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1c0 0 0 0 0 0s0 0 0 0L120.4 48l335.2 0 51.5 81.5zM483.5 224c4.1 0 8.1-.3 12-.8c55.5-7.4 81.8-72.5 52.1-119.4L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c0 0 0 0 0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c14.5 10.7 32.5 17.2 52.2 17.2c0 0 0 0 0 0zM112 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 336l0 48 0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64 0-48 0-83.4c-4 1-8 1.8-12.3 2.3c0 0 0 0-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-6.6 0-13.1-.5-19.4-1.6l0 81.6-352 0zm352 48l0 64c0 8.8-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16l0-64 352 0z"]
};
const faArrowTrendUp = {
  prefix: 'far',
  iconName: 'arrow-trend-up',
  icon: [576, 512, [], "e098", "M352 120c0-13.3 10.7-24 24-24l176 0c13.3 0 24 10.7 24 24l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-118.1L337 369c-9.4 9.4-24.6 9.4-33.9 0l-111-111L41 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L175 207c9.4-9.4 24.6-9.4 33.9 0l111 111L494.1 144 376 144c-13.3 0-24-10.7-24-24z"]
};
const faPlugCircleMinus = {
  prefix: 'far',
  iconName: 'plug-circle-minus',
  icon: [576, 512, [], "e55e", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"]
};
const faOliveBranch = {
  prefix: 'far',
  iconName: 'olive-branch',
  icon: [640, 512, [], "e317", "M2.7 53.1C13.8 41.6 59 0 128 0c66.9 0 111.4 39.1 124.2 52L306 26.7C343.3 9.1 384 0 425.2 0L616 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L425.2 48c-34.2 0-67.9 7.5-98.8 22.1L191.9 133.4C189.1 219.3 118.6 288 32 288l-16 0c-8.8 0-16-7.2-16-16l0-16c0-61.4 34.5-114.6 85.2-141.5C40.4 102.8 11.3 75.8 2.7 66.9C.9 65 0 62.6 0 60s.9-5 2.7-6.9zM399.4 427c19.3-25.7 32.6-63.3 32.6-107s-13.3-81.3-32.6-107c-19.2-25.7-42.2-37-63.4-37s-44.2 11.4-63.4 37C253.3 238.7 240 276.4 240 320s13.3 81.3 32.6 107c19.2 25.7 42.2 37 63.4 37s44.2-11.4 63.4-37zM336 512c-79.5 0-144-86-144-192s64.5-192 144-192s144 86 144 192s-64.5 192-144 192zm129.7-40.2c9.4-13.1 17.6-27.5 24.4-43.1c3.6 .8 7.1 1.5 10.5 2c31.1 4.6 55-3.6 70.2-19.3c15.4-16 23.9-42.1 19.2-76c-4.7-33.8-22.2-71.6-53.2-103.7c-18-18.7-37.7-32.5-57.2-41.7c-4.9-8.8-10.3-17.2-16.2-25c-10.5-14-22.7-26.5-36.2-36.9c48.2 1.6 101.3 25.8 144.2 70.3c75 77.8 90.2 188.1 33.9 246.4c-34.1 35.4-86.8 43.5-139.6 27z"]
};
const faAngle = {
  prefix: 'far',
  iconName: 'angle',
  icon: [448, 512, [], "e08c", "M253.3 67.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2l-208 400c-3.9 7.4-3.6 16.4 .8 23.5S15.6 480 24 480l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L63.5 432 253.3 67.1zM242 175.5l-22.6 43.4c19.3 15.8 36.5 34 51.3 54.1l40.8-25.6c-19.6-27.2-43-51.4-69.5-71.9zM322.7 392l48.8 0c-6-36.9-18-71.8-34.7-103.8l-40.8 25.6c12.4 24.3 21.5 50.6 26.8 78.2z"]
};
const faVacuumRobot = {
  prefix: 'far',
  iconName: 'vacuum-robot',
  icon: [512, 512, [], "e04e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm335-79c-43.6-43.6-114.4-43.6-158.1 0c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c62.4-62.4 163.5-62.4 225.9 0s62.4 163.5 0 225.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c43.6-43.6 43.6-114.4 0-158.1zM212.7 212.7c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"]
};
const faSignHanging = {
  prefix: 'far',
  iconName: 'sign-hanging',
  icon: [512, 512, ["sign"], "f4d9", "M88 0c13.3 0 24 10.7 24 24l0 40 376 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-376 0 0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376-40 0C10.7 112 0 101.3 0 88S10.7 64 24 64l40 0 0-40C64 10.7 74.7 0 88 0zM192 336l240 0 0-144-240 0 0 144zM144 176c0-17.7 14.3-32 32-32l272 0c17.7 0 32 14.3 32 32l0 176c0 17.7-14.3 32-32 32l-272 0c-17.7 0-32-14.3-32-32l0-176z"]
};
const faSign = faSignHanging;
const faSquareDivide = {
  prefix: 'far',
  iconName: 'square-divide',
  icon: [448, 512, [], "e26a", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM136 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm56 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faFolderCheck = {
  prefix: 'far',
  iconName: 'folder-check',
  icon: [512, 512, [], "e64e", "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L289.9 96 247 53.1C233.5 39.6 215.2 32 196.1 32L64 32zM48 96c0-8.8 7.2-16 16-16l132.1 0c6.4 0 12.5 2.5 17 7l45.3 45.3c7.5 7.5 17.7 11.7 28.3 11.7L448 144c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96zM369 241c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 241z"]
};
const faSignalStreamSlash = {
  prefix: 'far',
  iconName: 'signal-stream-slash',
  icon: [640, 512, [], "e250", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-91.7-71.9C562.6 355.5 576 307.3 576 256c0-69.7-24.8-133.6-66-183.4c-8.4-10.2-23.6-11.6-33.8-3.2s-11.6 23.6-3.2 33.8c34.3 41.5 55 94.7 55 152.8c0 40.1-9.8 77.9-27.2 111.2l-51.6-40.4c9.5-21.7 14.8-45.6 14.8-70.8c0-40.7-13.8-78.2-37-108c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7C406 199.2 416 226.4 416 256c0 13.9-2.2 27.3-6.3 39.8L38.8 5.1zm84.7 188.2C116.1 212.8 112 233.9 112 256c0 40.7 13.8 78.2 37 108c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7C170 312.8 160 285.6 160 256c0-10.7 1.3-21.1 3.8-31l-40.3-31.7zM33 122C11.9 162 0 207.6 0 256c0 69.7 24.8 133.6 66 183.4c8.4 10.2 23.6 11.6 33.8 3.2s11.6-23.6 3.2-33.8C68.6 367.3 48 314.1 48 256c0-37.1 8.4-72.3 23.5-103.7L33 122z"]
};
const faBezierCurve = {
  prefix: 'far',
  iconName: 'bezier-curve',
  icon: [640, 512, [], "f55b", "M352 80l0 64-64 0 0-64 64 0zM288 32c-26.5 0-48 21.5-48 48l0 8L123.3 88C113.9 64.5 90.9 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l79 0C138.2 173.8 93.9 241.5 88.5 320L80 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-7.3 0c5.9-68.4 49.2-126.1 109.4-152.6C254.3 182.1 270 192 288 192l64 0c18 0 33.7-9.9 41.9-24.6c60.2 26.4 103.5 84.1 109.4 152.6l-7.3 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-8.5 0c-5.3-78.5-49.7-146.2-113.8-184l79 0c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64s-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40L400 88l0-8c0-26.5-21.5-48-48-48l-64 0zM48 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm512 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM144 368l0 64-64 0 0-64 64 0zm352 0l64 0 0 64-64 0 0-64z"]
};
const faEyeDropperHalf = {
  prefix: 'far',
  iconName: 'eye-dropper-half',
  icon: [512, 512, [], "e173", "M233 202.9L199 169l-8-8s0 0 0 0c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8 8 33.9-33.9 71.3-71.3c19.1-19.1 45-29.8 72-29.8C466.4 0 512 45.6 512 101.8c0 27-10.7 52.9-29.8 72l-71.3 71.3L377 279l8 8c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-8-8L309.1 279 233 202.9zM343 245.1L448.2 139.9c10.1-10.1 15.8-23.8 15.8-38.1C464 72.1 439.9 48 410.2 48c-14.3 0-28 5.7-38.1 15.8L266.9 169 343 245.1zM183.4 198.6l33.9 33.9L129.9 320l124.1 0 25.4-25.4 33.9 33.9L183 458.9c-13.5 13.5-31.8 21.1-50.9 21.1l-52.9 0-42 28c-9.5 6.3-22.2 5.1-30.3-3s-9.3-20.8-3-30.3l28-42 0-52.9c0-19.1 7.6-37.4 21.1-50.9L183.4 198.6z"]
};
const faStoreLock = {
  prefix: 'far',
  iconName: 'store-lock',
  icon: [640, 512, [], "e4a6", "M507.1 129.5s0 0 0 0c5.8 9.2 6.4 20.5 2.3 30.1c-.3 .7-.6 1.5-1 2.2c6.4-1.1 13-1.7 19.7-1.7c10.4 0 20.5 1.4 30.1 4.1c4.4-19.8 1.5-41.5-10.4-60.3L490.3 13.1C485.2 5 476.1 0 466.4 0L109.6 0C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c0 0 0 0 0 0c19.6 0 37.5-6.4 51.9-17c4.8-3.5 9.2-7.6 13.2-11.9c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.6 0 37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12c4 4.4 8.4 8.4 13.2 11.9c14.5 10.6 32.4 17 52 17c19.8 0 37.8-6.5 52.3-17.3c4.7-3.5 9-7.4 12.9-11.7c3.9 4.3 8.3 8.3 13 11.8c1.2 .9 2.5 1.8 3.8 2.7c9.7-14.3 22.6-26.3 37.7-34.9c-7.4-2.1-13.9-6.2-19-11.8c-9.1-10-22-15.7-35.6-15.7s-26.5 5.8-35.5 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-11.8 0-22.3-5.1-29.6-13.2c-9.1-10.1-22-15.8-35.6-15.8s-26.5 5.7-35.6 15.8c-7.3 8.1-17.7 13.2-29.6 13.2c-1.8 0-3.8-.1-5.8-.4c-8.9-1.2-16-6.8-19.9-16c-4.1-9.6-3.5-20.9 2.3-30.1c0 0 0 0 0 0s0 0 0 0L120.4 48l335.2 0 51.5 81.5zM112 336l0-81.6c-6.4 1.1-12.9 1.6-19.6 1.6c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3L64 336l0 48 0 64c0 35.3 28.7 64 64 64l264.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-16-256 0c-8.8 0-16-7.2-16-16l0-64 272 0 0-32c0-5.5 .7-10.9 2-16l-274 0zm416-96c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"]
};
const faBellSlash = {
  prefix: 'far',
  iconName: 'bell-slash',
  icon: [640, 512, [128277, 61943], "f1f6", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4l0-33.4c0-75.8-55.5-138.6-128-150.1L352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96l8 0 8 0c57.4 0 104 46.6 104 104l0 33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48-176.9 0c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1l0 11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l286.2 0zM384 448l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
};
const faCloudBoltSun = {
  prefix: 'far',
  iconName: 'cloud-bolt-sun',
  icon: [640, 512, ["thunderstorm-sun"], "f76e", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm112.1 48c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48c0 20.6 12.9 38.1 31.1 44.9c-12.6 11.7-17.9 29.3-14 46c-37.9-12.9-65.1-48.7-65.1-90.9c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-16.1 0c3.5-10.1 3.7-21.3 0-31.8c-2.1-6.1-5.4-11.6-9.6-16.2l26.1 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-.6 .7-1.1 1.3-1.8 1.9c-6.1 1.1-12 3.5-17.4 7c-1.6 0-3.3-.2-4.9-.6c-8.9-2.1-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm154 35.6c5.8 4.7 7.6 12.9 4.2 19.6L425.9 352l70.1 0c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L374.1 384 304 384c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1z"]
};
const faThunderstormSun = faCloudBoltSun;
const faCameraSlash = {
  prefix: 'far',
  iconName: 'camera-slash',
  icon: [640, 512, [], "e0d9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6l0-256c0-35.3-28.7-64-64-64l-73.4 0-8.6-25.7C422.4 47.4 401 32 376.9 32L263.1 32c-24.1 0-45.5 15.4-53.1 38.3L201.4 96l-46.6 0L38.8 5.1zM216 144l2.7 0c10.3 0 19.5-6.6 22.8-16.4l14-42.1c1.1-3.3 4.1-5.5 7.6-5.5l113.9 0c3.4 0 6.5 2.2 7.6 5.5l14 42.1c3.3 9.8 12.4 16.4 22.8 16.4l90.7 0c8.8 0 16 7.2 16 16l0 228.5-98.4-77.2c1.6-7.5 2.4-15.4 2.4-23.4c0-61.9-50.1-112-112-112c-17.5 0-34.1 4-48.9 11.2L216 144zM382.6 274.6L318.1 224c.6 0 1.3 0 1.9 0c30.7 0 56.4 21.7 62.6 50.6zM487.4 480l-60.9-48L128 432c-8.8 0-16-7.2-16-16l0-231.8L65.2 147.4c-.8 4.1-1.2 8.3-1.2 12.6l0 256c0 35.3 28.7 64 64 64l359.4 0zM370.6 388l-45.9-36.1c-1.6 .1-3.1 .2-4.7 .2c-31.8 0-58.2-23.2-63.2-53.6L211 262.2c-1.9 8.3-3 16.9-3 25.8c0 61.9 50.1 112 112 112c18.2 0 35.4-4.3 50.6-12z"]
};
const faCommentQuote = {
  prefix: 'far',
  iconName: 'comment-quote',
  icon: [512, 512, [], "e14c", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM160 144c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3 0-24 0-24c0-17.7-14.3-32-32-32l-48 0zm224 80l0-24 0-24c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32l32 0 0 7.3c0 11.7-8.5 21.7-20.1 23.7l-7.9 1.3c-13.1 2.2-21.9 14.5-19.7 27.6s14.5 21.9 27.6 19.7l7.9-1.3c34.7-5.8 60.2-35.8 60.2-71l0-39.3z"]
};
const faTablet = {
  prefix: 'far',
  iconName: 'tablet',
  icon: [448, 512, ["tablet-android"], "f3fb", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM192 400l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faTabletAndroid = faTablet;
const faSchoolFlag = {
  prefix: 'far',
  iconName: 'school-flag',
  icon: [576, 512, [], "e56e", "M288 0L400 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-81.9 0 89.6 64 96.3 0c39.8 0 72 32.2 72 72l0 208c0 39.8-32.2 72-72 72l-168 0-96 0L72 512c-39.8 0-72-32.2-72-72L0 232c0-39.8 32.2-72 72-72l96.3 0L264 91.6 264 24c0-13.3 10.7-24 24-24zM504 464c13.3 0 24-10.7 24-24l0-208c0-13.3-10.7-24-24-24l-104 0c-5 0-9.9-1.6-13.9-4.5l-98.1-70-98.1 70c-4.1 2.9-8.9 4.5-13.9 4.5L72 208c-13.3 0-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24l168 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 168 0zM240 240a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM112 256l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm304 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM112 352l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm320 0l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
};
const faMessageCode = {
  prefix: 'far',
  iconName: 'message-code',
  icon: [512, 512, [], "e1df", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM217 161c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47zM329 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9l-64-64z"]
};
const faGlassHalf = {
  prefix: 'far',
  iconName: 'glass-half',
  icon: [384, 512, ["glass-half-empty", "glass-half-full"], "e192", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM66.7 240L50.2 48l283.7 0L317.3 240 66.7 240zm4.1 48l242.3 0L299.9 442.1C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9L70.8 288z"]
};
const faGlassHalfEmpty = faGlassHalf;
const faGlassHalfFull = faGlassHalf;
const faFill = {
  prefix: 'far',
  iconName: 'fill',
  icon: [512, 512, [], "f575", "M73 7C63.6-2.3 48.4-2.3 39 7s-9.4 24.6 0 33.9l89.4 89.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L162.3 96.4 73 7zm89.4 157.3L231 233c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-68.7-68.7L255 71.6c9.4-9.4 24.6-9.4 33.9 0L440.4 223c9.4 9.4 9.4 24.6 0 33.9l-31 31L51.2 288c1.6-9.5 6.1-18.6 13.4-25.9l97.8-97.8z"]
};
const faMessageMinus = {
  prefix: 'far',
  iconName: 'message-minus',
  icon: [512, 512, ["comment-alt-minus"], "f4a7", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM184 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faCommentAltMinus = faMessageMinus;
const faAngleUp = {
  prefix: 'far',
  iconName: 'angle-up',
  icon: [448, 512, [8963], "f106", "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"]
};
const faDinosaur = {
  prefix: 'far',
  iconName: 'dinosaur',
  icon: [640, 512, [], "e5fe", "M449.1 0c-16.8 0-33 6-45.7 16.9L375.7 40.7C360.7 53.5 352 72.4 352 92.2c0 37.5 30.4 67.8 67.8 67.8l52.2 0c13.3 0 24 10.7 24 24l0 19.2c0 11.5-9.3 20.8-20.8 20.8c-13 0-25.6-3.8-36.4-11L413.3 196c-35.2-23.5-76.6-36-119-36l-9.1 0c-60.8 0-119.5 22.7-164.5 63.6l-80.2 73C14.7 320 0 353.3 0 388.2C0 456.6 55.4 512 123.8 512l131.2 0c35.9 0 64.9-29.1 64.9-64.9c0-33-24.7-60.7-57.4-64.5l-103.2-12c-2.5-10.6-12-18.6-23.4-18.6c-13.3 0-24 10.7-24 24c0 21.3 16 39.2 37.1 41.7L257 430.3c8.5 1 15 8.2 15 16.8c0 9.3-7.6 16.9-16.9 16.9l-131.2 0C82 464 48 430 48 388.2c0-21.4 9-41.7 24.8-56.1l80.2-73c36.2-32.9 83.3-51.1 132.2-51.1l9.1 0c32.9 0 65 9.7 92.4 28l25.4 16.9c18.7 12.5 40.6 19.1 63.1 19.1c38 0 68.8-30.8 68.8-68.8l0-19.2c0-39.8-32.2-72-72-72l-52.2 0c-11 0-19.8-8.9-19.8-19.8c0-5.8 2.5-11.3 6.9-15.1l27.7-23.8c4-3.4 9.1-5.3 14.4-5.3l11.6 0C533.2 48 592 106.8 592 179.3l0 26.9c0 65-28.9 126.6-78.8 168.2l-8.6 7.2c-6.2 5.2-9.2 12.9-8.6 20.4c-.1 .7-.1 1.3-.1 2l0 52c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8-3.6-8-8l0-32c0-8-3.9-15.4-10.5-19.9c-6.6-4.4-14.9-5.4-22.3-2.4l-.1 0c-.2 .1-.5 .2-.9 .3c-.9 .3-2.4 .8-4.6 1.5c-4.2 1.3-10.8 3.1-19.5 5c-7.7 1.6-17.1 3.3-28.2 4.6c4 10.6 6.1 22 6.1 34c0 4.7-.3 9.3-1 13.8c12.7-1.5 23.7-3.4 32.9-5.4c0 0 0 0 .1 0l0 .5c0 30.9 25.1 56 56 56l48 0c30.9 0 56-25.1 56-56l0-44.8c60.8-50.7 96-125.8 96-205l0-26.9C640 80.3 559.7 0 460.7 0L449.1 0zM480 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
};
const faDrumstickBite = {
  prefix: 'far',
  iconName: 'drumstick-bite',
  icon: [512, 512, [], "f6d7", "M208 272c0 17.7 14.3 32 32 32l16 0 51.2 0c-2.1-10.4-3.2-21.1-3.2-32c0-82.8 62.8-150.8 143.4-159.1C425.4 74.1 383.7 48 336 48c-70.7 0-128 57.3-128 128l0 64 0 32zm-48-32l0-64C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8c2.1 11.8-10.3 20.1-22 17.6c-7.5-1.6-15.3-2.4-23.2-2.4c-61.9 0-112 50.1-112 112c0 19.2 4.8 37.2 13.3 53c5.7 10.5 1.1 24.8-10.8 26c-6.1 .6-12.3 1-18.5 1l-80 0-12 0c-17.7 0-31.3 15.6-41.5 30c-1.7 2.4-3.6 4.6-5.7 6.7c-12 12-11.1 31.5-6.8 47.9c1.3 4.9 2 10 2 15.4c0 33.1-26.9 60-60 60s-60-26.9-60-60c0-6.3-5.7-12-12-12c-33.1 0-60-26.9-60-60s26.9-60 60-60c5.3 0 10.5 .7 15.4 2c16.4 4.3 35.9 5.2 47.9-6.8c2.1-2.1 4.4-4 6.8-5.7c14.4-10.2 30-23.9 30-41.5l0-28z"]
};
const faLinkHorizontalSlash = {
  prefix: 'far',
  iconName: 'link-horizontal-slash',
  icon: [640, 512, ["chain-horizontal-slash"], "e1cc", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-56.4-44.2c39.5-25.6 65.6-70.1 65.6-120.7c0-75.7-58.7-138.5-134.3-143.5l-8.1-.5c-13.2-.9-24.7 9.1-25.5 22.4s9.1 24.7 22.3 25.5l8.1 .5c50.4 3.4 89.5 45.2 89.5 95.6c0 39.8-24.3 74-58.8 88.4L414.8 299.8c20.8-25 33.2-57.1 33.2-91.9C448 128.4 383.6 64 304.1 64L143.9 64c-9.1 0-18.1 .9-26.8 2.5L38.8 5.1zM175.2 112l129 0c52.9 0 95.9 42.9 95.9 95.9c0 23.7-8.6 45.5-23 62.3L175.2 112zM446.8 448l-60.9-48-49.9 0c-53 0-95.9-42.9-95.9-95.9c0-6 .6-12 1.6-17.7l-40.8-32.1c-5.7 15.6-8.9 32.4-8.9 49.8C192 383.6 256.4 448 335.9 448l110.9 0zM30.1 119.7C11.2 144.1 0 174.7 0 207.9c0 75.7 58.7 138.5 134.3 143.5l8.1 .5c13.2 .9 24.7-9.1 25.5-22.3s-9.1-24.7-22.4-25.5l-8.1-.5C87.1 300.2 48 258.3 48 207.9c0-22 7.4-42.2 19.8-58.4L30.1 119.7z"]
};
const faChainHorizontalSlash = faLinkHorizontalSlash;
const faHollyBerry = {
  prefix: 'far',
  iconName: 'holly-berry',
  icon: [512, 512, [], "f7aa", "M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM128 144a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm160 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM161.4 264.5c-1.7 58.6-42.3 107.5-97 121.6c6.2 22 7.2 45.1 2.7 67.4c24.9-6.1 50.9-5.4 75.4 1.9c1.7-58.6 42.3-107.5 97-121.6c-6.2-22-7.1-45.1-2.7-67.4c-24.9 6.1-50.9 5.4-75.4-1.9zM113.4 232c0-16.2 15.6-27.7 31.1-22.9l29.8 9.2c16.8 5.2 34.8 5.7 51.8 1.3l39-9.9c11.1-2.8 21.5 2.5 26.6 11.2c15.2 2.8 30.9 1.9 45.7-2.7l29.8-9.2c15.4-4.8 31.1 6.8 31.1 22.9l0 28.8c0 44.9 36.4 81.4 81.4 81.4c16.6 0 28.2 16.5 22.6 32.1l-6.7 18.6c-6.9 19.2-7.5 40.1-1.8 59.6l8.1 27.7c5.2 17.8-10.9 34.6-28.9 30l-39-9.9c-17.1-4.3-35-3.8-51.8 1.3l-29.8 9.2c-15.4 4.8-31.1-6.8-31.1-22.9l0-28.8c0-39.5-28.1-72.4-65.4-79.8c0 0 0 0 0 0c-37.4 7.4-65.6 40.3-65.6 79.8l0 28.8c0 16.2-15.6 27.7-31.1 22.9l-29.8-9.2c-16.8-5.2-34.8-5.7-51.8-1.3l-39 9.9c-18 4.6-34.2-12.2-28.9-30l8.1-27.7c5.8-19.6 5.1-40.4-1.8-59.6L9.5 374.3c-5.6-15.6 6-32.1 22.6-32.1c44.9 0 81.4-36.4 81.4-81.4l0-28.8zM292.7 341c44.2 19.7 75.2 63.4 76.7 114.5c24.5-7.3 50.6-8 75.4-1.9c-4.5-22.4-3.5-45.5 2.7-67.4c-54.7-14.1-95.3-62.9-97-121.6c-21.1 6.3-43.3 7.7-64.9 4.1c-5.4 19.2-4.7 39.7 2.1 58.5l5 13.9z"]
};
const faNose = {
  prefix: 'far',
  iconName: 'nose',
  icon: [448, 512, [], "e5bd", "M205.3 12.9C199.2 1.2 184.7-3.4 172.9 2.7s-16.3 20.6-10.2 32.4C237 178 327.3 280.7 374.8 329.6c16 16.4 25.2 37.6 25.2 59.2c0 41.5-33.7 75.2-75.2 75.2l-10.8 0-17-17-30.1-30.1c-21.1-21.1-49.7-32.9-79.5-32.9c-32.8 0-59.4 26.6-59.4 59.4l0 4.6c0 35.3 28.7 64 64 64l132.8 0C392.8 512 448 456.8 448 388.8c0-35.4-15.1-68.3-38.8-92.7C363.7 249.4 276.8 150.4 205.3 12.9zm27.6 437.9L246.1 464 192 464c-8.8 0-16-7.2-16-16l0-4.6c0-6.3 5.1-11.4 11.4-11.4c17.1 0 33.5 6.8 45.6 18.9zM141 303.5c13-2.8 21.2-15.5 18.4-28.5s-15.5-21.2-28.5-18.4l-22.8 4.9C45.1 274.9 0 330.7 0 395.2c0 40.6 18 79.1 49.2 105.1l7.4 6.2c10.2 8.5 25.3 7.1 33.8-3.1s7.1-25.3-3.1-33.8l-7.4-6.2C59.7 446.5 48 421.5 48 395.2c0-41.9 29.2-78 70.2-86.8l22.8-4.9z"]
};
const faArrowLeftToArc = {
  prefix: 'far',
  iconName: 'arrow-left-to-arc',
  icon: [512, 512, [], "e616", "M48 256C48 141.1 141.1 48 256 48c13.3 0 24-10.7 24-24s-10.7-24-24-24C114.6 0 0 114.6 0 256S114.6 512 256 512c13.3 0 24-10.7 24-24s-10.7-24-24-24C141.1 464 48 370.9 48 256zM279.7 134.4l-112 104c-4.9 4.5-7.7 10.9-7.7 17.6s2.8 13 7.7 17.6l112 104c9.7 9 24.9 8.5 33.9-1.3s8.5-24.9-1.3-33.9L245.1 280 488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-242.9 0 67.2-62.4c9.7-9 10.3-24.2 1.3-33.9s-24.2-10.3-33.9-1.3z"]
};
const faChevronLeft = {
  prefix: 'far',
  iconName: 'chevron-left',
  icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
};
const faBacteria = {
  prefix: 'far',
  iconName: 'bacteria',
  icon: [640, 512, [], "e059", "M304.9 .7c9.6 2.7 15.1 12.7 12.4 22.3l-2.9 10.3c15.4 7.9 28.3 20.5 36.4 36.4L361 66.7c9.6-2.7 19.5 2.8 22.3 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.8 17.6-4.1 34.6-13.2 48.8l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-7.9 5.1-16.8 8.9-26.4 11.1c-5.9 1.4-11.4 2.9-16.6 4.6l3 10.6c2.7 9.6-2.8 19.5-12.4 22.3s-19.5-2.8-22.3-12.4l-1.6-5.6c-17.8 10.8-29 23.4-36.5 34.5l8.5 3.6c9.1 3.9 13.4 14.5 9.5 23.6s-14.5 13.4-23.6 9.5l-9.6-4.1c-.8 2.9-1.4 5.8-1.8 8.7c-1.4 13.3-6 25.6-12.7 36.2l8 8c7 7 7 18.4 0 25.5s-18.4 7-25.5 0l-8-8c-14.1 9-31 13.9-48.8 13.2l-3.1 11c-2.7 9.6-12.7 15.1-22.3 12.4S64 370.6 66.7 361l2.9-10.3c-15.7-8.1-28.4-20.9-36.4-36.4l-10.3 2.9C13.4 320 3.4 314.5 .7 304.9s2.8-19.5 12.4-22.3l11-3.1c-.2-3.7-.1-7.4 .3-11.2c1.1-12.1 3.8-24.2 7-35.9c.2-.8 .4-1.5 .7-2.3l-8.7-3.5c-9.2-3.7-13.7-14.2-10-23.4s14.2-13.7 23.4-10l7.4 3c4.6-10.7 10.3-22.2 17.4-34c1.4-2.4 2.9-4.8 4.5-7.3l-11.2-9c-7.8-6.2-9-17.5-2.8-25.3s17.5-9 25.3-2.8L87.3 126c10.2-12.2 22-24.1 35.5-35.3L117 82c-5.5-8.3-3.3-19.4 5-25s19.4-3.3 25 5l4.9 7.4c13.7-8.8 28.7-16.8 45.2-23.9l-3.6-8.5c-3.9-9.1 .3-19.7 9.5-23.6s19.7 .3 23.6 9.5l4.4 10.3c8.4-2.6 17.1-4.9 26.2-7c7.5-1.7 15.1-2.4 22.4-2.1l3.1-11C285.4 3.5 295.4-2 304.9 .7zM143.8 279.9c.1-.7 .2-1.4 .3-2.1c3.2-20.9 11.7-39.5 20.3-53.8c18-30 52.2-65.4 119.7-80.9c19.4-4.5 31.5-23.8 27-43.2s-23.8-31.5-43.2-27c-88.4 20.4-138.2 69-165.3 114.1c-13.3 22.1-20.8 42.9-25 58.3c-2.8 10-4.7 19.2-5.5 27.6c-1.8 19.8 12.8 37.2 32.6 39c19.6 1.8 36.9-12.5 39-31.9zm352.4-47.8c-.1 .7-.2 1.4-.3 2.1c-3.2 20.9-11.7 39.5-20.3 53.8c-18 30-52.2 65.4-119.7 80.9c-19.4 4.5-31.5 23.8-27 43.2s23.8 31.5 43.2 27c88.4-20.4 138.2-69 165.3-114.1c13.3-22.1 20.8-42.9 25-58.3c2.8-10 4.7-19.2 5.5-27.6c1.8-19.8-12.8-37.2-32.6-39c-19.6-1.8-36.9 12.5-39 31.9zm39.3-80l3.1-11c2.7-9.6 12.7-15.1 22.3-12.4s15.1 12.7 12.4 22.3l-2.9 10.3c15.7 8.1 28.4 20.9 36.4 36.4l10.3-2.9c9.6-2.7 19.5 2.8 22.2 12.4s-2.8 19.5-12.4 22.3l-11 3.1c.2 3.7 .1 7.4-.3 11.2c-1.1 12.1-3.8 24.2-7 35.9l-.2 .8-.4 1.5 8.7 3.5c9.2 3.7 13.7 14.2 10 23.4s-14.2 13.7-23.4 10l-7.4-3c-4.6 10.7-10.3 22.2-17.4 34c-1.4 2.4-3 4.8-4.5 7.3l11.2 9c7.8 6.2 9 17.5 2.8 25.3s-17.5 9-25.3 2.8L552.7 386c-10.2 12.2-22 24.1-35.5 35.3L523 430c5.5 8.3 3.3 19.4-5 25s-19.4 3.3-25-5l-4.9-7.4c-13.7 8.8-28.7 16.8-45.2 23.9l3.6 8.5c3.9 9.1-.3 19.7-9.5 23.6s-19.7-.3-23.6-9.5l-4.4-10.3c-8.4 2.6-17.1 4.9-26.2 7c-7.5 1.7-15.1 2.4-22.5 2.1l-3.1 11c-2.7 9.6-12.7 15.1-22.2 12.4s-15.1-12.7-12.4-22.3l3-10.3c-15.4-7.9-28.3-20.5-36.4-36.4l-10.3 2.9c-9.6 2.7-19.5-2.8-22.3-12.4s2.8-19.5 12.4-22.2l11-3.1c-.8-17.6 4.1-34.6 13.2-48.8l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c7.9-5.1 16.8-8.9 26.4-11.1c5.9-1.4 11.4-2.9 16.6-4.6l-3-10.6c-2.7-9.6 2.8-19.5 12.4-22.3s19.5 2.8 22.3 12.4l1.6 5.6c17.8-10.8 29-23.4 36.5-34.5l-8.5-3.6c-9.1-3.9-13.4-14.5-9.5-23.6s14.5-13.4 23.6-9.5l9.6 4.1c.8-2.9 1.4-5.8 1.8-8.7c1.4-13.3 5.9-25.6 12.7-36.2l-8-8c-7-7-7-18.4 0-25.5s18.4-7 25.5 0l8 8c14.1-9 31-13.9 48.8-13.2zM192 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM400 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faClouds = {
  prefix: 'far',
  iconName: 'clouds',
  icon: [640, 512, [], "f744", "M272 112c0 .7 0 1.4 0 2c-.3 10.3 6 19.7 15.6 23.2s20.5 .6 27-7.4c8.8-10.9 22.3-17.9 37.4-17.9c26.5 0 48 21.5 48 48c0 8.7-2.3 16.8-6.3 23.8c3.6 2.3 7.1 4.8 10.6 7.4c12.8-4.4 26.5-6.8 40.7-7.2c2-7.7 3-15.7 3-24c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192s43 96 96 96l65.9 0c2.7-17.1 8.3-33.3 16.2-48L96 240c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.4 1 16.6 2.9c7.9 2.9 16.8 1.5 23.4-3.8s9.9-13.7 8.7-22c-.4-2.9-.6-6-.6-9.1c0-35.3 28.7-64 64-64s64 28.7 64 64zM240 312c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C201.3 462.4 176 436.2 176 404c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zm72-120c-64 0-116.3 50.1-119.8 113.3C154.4 322.1 128 359.9 128 404c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C534.5 247 494.9 216 448 216c-18 0-34.9 4.6-49.7 12.6C376.5 206.1 345.9 192 312 192z"]
};
const faMoneyBillSimple = {
  prefix: 'far',
  iconName: 'money-bill-simple',
  icon: [576, 512, [], "e1f1", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faHandLizard = {
  prefix: 'far',
  iconName: 'hand-lizard',
  icon: [512, 512, [], "f258", "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l168 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-10.7L281.1 384 136 384c-39.8 0-72-32.2-72-72s32.2-72 72-72l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L72 208c-39.8 0-72-32.2-72-72S32.2 64 72 64l209.6 0c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7L512 424c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-107.9c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9L72 112z"]
};
const faTablePivot = {
  prefix: 'far',
  iconName: 'table-pivot',
  icon: [512, 512, [], "e291", "M464 416c0 8.8-7.2 16-16 16l-320 0 0-240L0 192 0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L160 32l0 128 304 0 0 256zM64 32C28.7 32 0 60.7 0 96l0 64 128 0 0-128L64 32zM414.8 246.1c2.5-6 1.1-12.9-3.5-17.4l-32-32c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9l16 0 0 48c0 8.8-7.2 16-16 16l-48 0 0-16c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-32 32c-6.2 6.2-6.2 16.4 0 22.6l32 32c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8l0-16 48 0c26.5 0 48-21.5 48-48l0-48 16 0c6.5 0 12.3-3.9 14.8-9.9z"]
};
const faFilterSlash = {
  prefix: 'far',
  iconName: 'filter-slash',
  icon: [640, 512, [], "e17d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7l-429 0c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80L521 80 370.3 265 134.4 80zM400 411.2l-48-37.8 0 41.9-64-50.8 0-41.5-48-37.8 0 83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3l0-36.5z"]
};
const faTrashCanUndo = {
  prefix: 'far',
  iconName: 'trash-can-undo',
  icon: [448, 512, ["trash-can-arrow-turn-left", "trash-undo-alt"], "f896", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm145.9 64.1c8.8 9.9 7.9 25.1-2 33.9L199.1 248l40.9 0c48.6 0 88 39.4 88 88l0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24c0-22.1-17.9-40-40-40l-40.9 0 24.8 22.1c9.9 8.8 10.8 24 2 33.9s-24 10.8-33.9 2l-72-64c-5.1-4.6-8.1-11.1-8.1-17.9s2.9-13.4 8.1-17.9l72-64c9.9-8.8 25.1-7.9 33.9 2z"]
};
const faTrashCanArrowTurnLeft = faTrashCanUndo;
const faTrashUndoAlt = faTrashCanUndo;
const faNotdef = {
  prefix: 'far',
  iconName: 'notdef',
  icon: [384, 512, [], "e1fe", "M48 421.8L162.8 256 48 90.2l0 331.7zM77.2 464l229.6 0L192 298.2 77.2 464zm144-208L336 421.8l0-331.7L221.2 256zM306.8 48L77.2 48 192 213.8 306.8 48zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"]
};
const faDisease = {
  prefix: 'far',
  iconName: 'disease',
  icon: [512, 512, [], "f7fa", "M64.1 286.3c0-19.3-8.3-37.6-22.8-50.3L21.8 219C8 206.9 .1 189.5 .1 171.2c0-39.3 35.3-69.3 74.1-62.8l55.6 9.3c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3c0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8l0 25.2c0 32.7-26.5 59.3-59.3 59.3c-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3l-7.4 0c-9.6 0-19.2 1.2-28.5 3.5L91 433.2c-32.6 8.2-65.7-11.7-73.8-44.3c-5.7-22.6 2.1-46.4 20-61.4L49.8 317c9.1-7.6 14.3-18.9 14.3-30.7zM267 102.1c-31.8 47.7-88.6 72.3-145.1 62.9l-55.6-9.3c-9.5-1.6-18.2 5.8-18.2 15.4c0 4.5 1.9 8.8 5.3 11.7l19.5 17.1c24.9 21.8 39.2 53.3 39.2 86.4c0 26.1-11.5 50.8-31.5 67.5L68 364.3c-3.8 3.2-5.4 8.2-4.2 13c1.7 6.9 8.7 11.1 15.6 9.4l54.9-13.7c13.1-3.3 26.6-4.9 40.1-4.9l7.4 0c38.1 0 75.2 13 104.9 36.8l30.9 24.7c2 1.6 4.5 2.5 7 2.5c6.2 0 11.3-5 11.3-11.3l0-25.2c0-54.7 33.6-103.7 84.6-123.5l36.9-14.3c4-1.5 6.6-5.3 6.6-9.6c0-5-3.5-9.2-8.4-10.1l-28-5.1c-55.4-10.1-99.4-52.4-111.8-107.4L308.8 94c-1.8-8.2-9.1-14-17.5-14c-6 0-11.6 3-14.9 8L267 102.1zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm48-128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faPersonToDoor = {
  prefix: 'far',
  iconName: 'person-to-door',
  icon: [576, 512, [58704], "e433", "M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-90.7 12.6c-14-3.5-28.7-3.5-42.7 0l-1.8 .5c-13.3 3.3-25.6 9.7-35.9 18.6L56.4 165.8c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l44.5-38.2c4.7-4 10.3-6.9 16.3-8.4l1.8-.5c6.4-1.6 13-1.6 19.4 0l8.6 2.1-32.7 98c-8.5 25.5 2.3 53.4 25.7 66.5l88 49.5L225.1 480.8c-4 12.7 3.1 26.1 15.7 30.1s26.1-3.1 30.1-15.8L307 379.5c5.6-18-2.1-37.5-18.6-46.8l-32.1-18 28.1-84.4 5.6 18.2c7.2 23.5 28.9 39.5 53.5 39.5l48.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48.4 0c-3.5 0-6.6-2.3-7.6-5.6l-19.7-64.2c-5.8-18.7-20.9-33.1-39.9-37.9l-95-23.7zm70.8 67.2l-38.3 115-19-10.7c-3.3-1.9-4.9-5.9-3.7-9.5L225 169l27.1 6.8zM122.5 317.1L103.4 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l84.9 0c16.7 0 31.6-10.3 37.4-25.9l14.1-37.6-4.9-2.8c-14.1-8-25.4-19.3-33-32.6zM528 48l0 416-96 0 0-160.8c-10.2 10.4-24.3 16.8-40 16.8c-2.7 0-5.4-.2-8-.6L384 464c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L432 0c-26.5 0-48 21.5-48 48l0 160.6c2.6-.4 5.3-.6 8-.6c15.7 0 29.8 6.4 40 16.8L432 48l96 0z"]
};
const faTurntable = {
  prefix: 'far',
  iconName: 'turntable',
  icon: [576, 512, [], "f8e4", "M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 135.7c0 6.7-1.7 13.3-4.9 19.2l-40.2 73.7c-6.3 11.6-2.1 26.2 9.6 32.6s26.2 2.1 32.6-9.6l40.2-73.7c7-12.9 10.7-27.4 10.7-42.1L496 136z"]
};
const faBriefcaseMedical = {
  prefix: 'far',
  iconName: 'briefcase-medical',
  icon: [512, 512, [], "f469", "M184 48l144 0c4.4 0 8 3.6 8 8l0 40L176 96l0-40c0-4.4 3.6-8 8-8zm-56 8l0 40L64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-64 0 0-40c0-30.9-25.1-56-56-56L184 0c-30.9 0-56 25.1-56 56zm24 88l208 0 88 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l88 0zm72 64l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faGenderless = {
  prefix: 'far',
  iconName: 'genderless',
  icon: [384, 512, [], "f22d", "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 304a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"]
};
const faChevronRight = {
  prefix: 'far',
  iconName: 'chevron-right',
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
};
const faSignalWeak = {
  prefix: 'far',
  iconName: 'signal-weak',
  icon: [640, 512, ["signal-1"], "f68c", "M64 384c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24z"]
};
const faSignal1 = faSignalWeak;
const faClockFive = {
  prefix: 'far',
  iconName: 'clock-five',
  icon: [512, 512, [], "e349", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 128.7 60 90c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-64-96c-2.6-3.9-4-8.6-4-13.3l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faRetweet = {
  prefix: 'far',
  iconName: 'retweet',
  icon: [576, 512, [], "f079", "M120 208l31 0c22.6 0 41-18.3 41-41c0-10.9-4.3-21.3-12-29L113 71c-4.5-4.5-10.6-7-17-7s-12.5 2.5-17 7l-67 67c-7.7 7.7-12 18.1-12 29c0 22.6 18.3 41 41 41l31 0 0 120c0 48.6 39.4 88 88 88l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0c-22.1 0-40-17.9-40-40l0-120zM96 121.9L134.1 160l-76.1 0L96 121.9zM504 304l0-120c0-48.6-39.4-88-88-88L280 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c22.1 0 40 17.9 40 40l0 120-31 0c-22.6 0-41 18.3-41 41c0 10.9 4.3 21.3 12 29l67 67c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l67-67c7.7-7.7 12-18.1 12-29c0-22.6-18.3-41-41-41l-31 0zm-24 86.1L441.9 352l76.1 0L480 390.1z"]
};
const faCarRear = {
  prefix: 'far',
  iconName: 'car-rear',
  icon: [512, 512, ["car-alt"], "f5de", "M165.4 80l181.2 0c17 0 32.1 10.7 37.8 26.8L408.6 176l-305.1 0 24.2-69.2c5.6-16 20.8-26.8 37.8-26.8zM82.3 90.9L48.1 188.8C19.3 205.4 0 236.4 0 272l0 64c0 23.7 12.9 44.4 32 55.4L32 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56 352 0 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64.6c19.1-11.1 32-31.7 32-55.4l0-64c0-35.6-19.4-66.6-48.1-83.2L429.7 90.9C417.3 55.6 384 32 346.6 32L165.4 32C128 32 94.7 55.6 82.3 90.9zM96 224l320 0c20.9 0 38.7 13.4 45.3 32L408 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 32c0 8.8-7.2 16-16 16l-128 0 0-32c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 32L64 352c-8.8 0-16-7.2-16-16l0-32 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-53.3 0c6.6-18.6 24.4-32 45.3-32z"]
};
const faCarAlt = faCarRear;
const faPumpSoap = {
  prefix: 'far',
  iconName: 'pump-soap',
  icon: [448, 512, [], "e06b", "M112 56c0-30.9 25.1-56 56-56l48 0c25.4 0 46.8 16.9 53.7 40l46.4 0c19.1 0 37.4 7.6 50.9 21.1L409 103c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L333.1 95c-4.5-4.5-10.6-7-17-7L272 88l0 40-48 0 0-72c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8 3.6-8 8l0 72-48 0 0-72zM101.5 222.7l-18.7 224C82.1 456 89.4 464 98.8 464l186.4 0c9.4 0 16.7-8 15.9-17.3l-18.7-224c-.7-8.3-7.6-14.7-15.9-14.7l-149.1 0c-8.3 0-15.3 6.4-15.9 14.7zm-47.8-4c2.8-33.2 30.5-58.7 63.8-58.7l149.1 0c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3L98.8 512c-37.4 0-66.9-32-63.8-69.3l18.7-224zm125.8 59.9c2.9-4.1 7.5-6.6 12.6-6.6s9.7 2.5 12.6 6.6l33.3 48.1c6.6 9.5 10.1 20.8 10.1 32.4l0 .9c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-.9c0-11.6 3.5-22.9 10.1-32.4l33.3-48.1z"]
};
const faComputerClassic = {
  prefix: 'far',
  iconName: 'computer-classic',
  icon: [448, 512, [], "f8b1", "M384 48c8.8 0 16 7.2 16 16l0 304c0 8.8-7.2 16-16 16L64 384c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l320 0zM64 0C28.7 0 0 28.7 0 64L0 368c0 23.7 12.9 44.4 32 55.4L32 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-56.6c19.1-11.1 32-31.7 32-55.4l0-304c0-35.3-28.7-64-64-64L64 0zM80 432l288 0 0 32L80 464l0-32zm0-320l0 96c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L112 80c-17.7 0-32 14.3-32 32zM208 320c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16zm-88 32a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faFrame = {
  prefix: 'far',
  iconName: 'frame',
  icon: [448, 512, [], "e495", "M448 120c0-13.3-10.7-24-24-24l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L112 96l0-40c0-13.3-10.7-24-24-24S64 42.7 64 56l0 40L24 96C10.7 96 0 106.7 0 120s10.7 24 24 24l40 0 0 224-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 224 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-224 40 0c13.3 0 24-10.7 24-24zM112 368l0-224 224 0 0 224-224 0z"]
};
const faVideoSlash = {
  prefix: 'far',
  iconName: 'video-slash',
  icon: [640, 512, [], "f4e2", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L113.9 64 352 64c35.3 0 64 28.7 64 64l0 33 0 127 0 12.8L560 413.6l0-50.3 0-11.4 0-64 0-139.4L448 199l0-52.6L552.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5L608 352l0 24.5 0 74.8 22.8 17.9c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM368 263.1L368 128c0-8.8-7.2-16-16-16l-176.8 0L368 263.1zM32 128c0-2.2 .1-4.4 .3-6.5L80 159l0 225c0 8.8 7.2 16 16 16l256 0c8.2 0 15-6.2 15.9-14.1L407 416.7c-11.2 18.7-31.6 31.3-55 31.3L96 448c-35.3 0-64-28.7-64-64l0-256z"]
};
const faBatteryQuarter = {
  prefix: 'far',
  iconName: 'battery-quarter',
  icon: [576, 512, ["battery-2"], "f243", "M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm112 96l-96 0 0 128 96 0 0-128z"]
};
const faBattery2 = faBatteryQuarter;
const faEllipsisStroke = {
  prefix: 'far',
  iconName: 'ellipsis-stroke',
  icon: [512, 512, ["ellipsis-h-alt"], "f39b", "M416 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM256 280a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-88a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM120 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-88 0a64 64 0 1 0 128 0A64 64 0 1 0 32 256z"]
};
const faEllipsisHAlt = faEllipsisStroke;
const faRadio = {
  prefix: 'far',
  iconName: 'radio',
  icon: [512, 512, [128251], "f8d7", "M494.4 47.1c12.8-3.5 20.3-16.7 16.8-29.5S494.4-2.7 481.6 .9L52.9 119.1C21.6 127.8 0 156.2 0 188.5L0 192 0 304 0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-246.8 0L494.4 47.1zM48 192c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-144 0-112zm304 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 112a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zM96 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L96 304zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0z"]
};
const faBabyCarriage = {
  prefix: 'far',
  iconName: 'baby-carriage',
  icon: [512, 512, ["carriage-baby"], "f77d", "M138.9 22.9L256 192l144 0 0-40c0-30.9 25.1-56 56-56l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-4.4 0-8 3.6-8 8l0 40 0 32c0 28-6.1 55.6-17.7 81.1c-11.6 25.5-28.6 48.4-49.5 67.5c-21 19.1-45.6 34-72.5 44.1S252.8 432 224 432s-57.4-5.2-84.3-15.3s-51.5-25-72.5-44.1s-37.9-42-49.5-67.5C6.1 279.6 0 252 0 224l0-32 .1 0C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM56.1 272c1.5 4.5 3.3 8.9 5.3 13.2c8.8 19.4 21.8 37 38.2 51.9s35.7 26.6 57.1 34.7s44.2 12.2 67.4 12.2s46-4.1 67.4-12.2s40.8-19.8 57.1-34.7s29.3-32.5 38.2-51.9c2-4.3 3.7-8.8 5.3-13.2c3.6-10.4 6-21.1 7.2-32L48.9 240c1.2 10.9 3.6 21.6 7.2 32z"]
};
const faCarriageBaby = faBabyCarriage;
const faFaceExpressionless = {
  prefix: 'far',
  iconName: 'face-expressionless',
  icon: [512, 512, [], "e373", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm160 72l192 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-192 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM128 208c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm176-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
};
const faDownToDottedLine = {
  prefix: 'far',
  iconName: 'down-to-dotted-line',
  icon: [448, 512, [], "e408", "M114.2 224L224 334 333.8 224 280 224c-13.3 0-24-10.7-24-24l0-120-64 0 0 120c0 13.3-10.7 24-24 24l-53.8 0zM224 384c-11.5 0-22.5-4.6-30.6-12.7L77.6 255.2C68.9 246.5 64 234.7 64 222.4c0-25.6 20.8-46.4 46.4-46.4l33.6 0 0-96c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 96 33.6 0c25.6 0 46.4 20.8 46.4 46.4c0 12.3-4.9 24.1-13.6 32.8L254.6 371.3c-8.1 8.1-19.1 12.7-30.6 12.7zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM64 448A32 32 0 1 1 0 448a32 32 0 1 1 64 0z"]
};
const faCloudMusic = {
  prefix: 'far',
  iconName: 'cloud-music',
  icon: [640, 512, [], "f8ae", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM416 184c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faTrafficLight = {
  prefix: 'far',
  iconName: 'traffic-light',
  icon: [320, 512, [128678], "f637", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-288c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L256 0c35.3 0 64 28.7 64 64l0 288c0 88.4-71.6 160-160 160S0 440.4 0 352L0 64zM160 424a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-168a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-72a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
};
const faCloudMinus = {
  prefix: 'far',
  iconName: 'cloud-minus',
  icon: [640, 512, [], "e35d", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM248 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faThermometer = {
  prefix: 'far',
  iconName: 'thermometer',
  icon: [512, 512, [], "f491", "M369.8 64.2c10.3-10.4 24.4-16.2 39-16.2c30.5 0 55.2 24.7 55.2 55.2c0 14.6-5.8 28.7-16.2 39L224.4 365.7c-1.5 1.5-3.5 2.3-5.7 2.3L144 368l0-74.7c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 41.4-41.4 31 31c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-31-31 45.5-45.5zM96 293.3l0 88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l89-89 88.8 0c14.9 0 29.1-5.9 39.6-16.4L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L112.4 253.7C101.9 264.2 96 278.4 96 293.3z"]
};
const faShieldMinus = {
  prefix: 'far',
  iconName: 'shield-minus',
  icon: [512, 512, [], "e249", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faVrCardboard = {
  prefix: 'far',
  iconName: 'vr-cardboard',
  icon: [640, 512, [], "f729", "M560 112L80 112c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l110.6 0c12.1 0 23.2-6.8 28.6-17.7l34.7-69.5C266.4 287.8 292 272 320 272s53.6 15.8 66.1 40.8l34.7 69.5c5.4 10.8 16.5 17.7 28.6 17.7L560 400c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM80 64l480 0c44.2 0 80 35.8 80 80l0 224c0 44.2-35.8 80-80 80l-110.6 0c-30.3 0-58-17.1-71.6-44.2l-34.7-69.5c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-34.7 69.5c-13.6 27.1-41.3 44.2-71.6 44.2L80 448c-44.2 0-80-35.8-80-80L0 144C0 99.8 35.8 64 80 64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faCarTilt = {
  prefix: 'far',
  iconName: 'car-tilt',
  icon: [640, 512, [], "f5e5", "M142.2 101.6L307.3 57.4c16.4-4.4 33.8 2.1 43.4 16.1l38.6 56.6L107.5 205.6l5.1-68.4c1.3-17 13.1-31.2 29.5-35.6zM64.8 133.7l-7.6 101c-21.4 23.4-30.7 56.8-21.9 89.7l18.5 69.1L60 416.5l6.2 23.3L72.7 464 24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-495.5 0-9.7-36.1 1.7-.5L495.8 324.7l1.7-.5 13.9 52.1c3.3 12.3 16 19.6 28.3 16.3s19.6-16 16.3-28.3l-13.9-52.1s0 0 0 0L529.8 266l-18.5-69.1c-8.8-32.9-33.6-57.1-63.8-66.7L390.4 46.4C369.3 15.5 331 1.3 294.9 11L129.8 55.2c-36.1 9.7-62.2 41.1-65 78.4zm50.8 119.5l290.5-77.8c25.6-6.9 51.9 8.3 58.8 33.9l18.5 69.1L100.2 381.1 81.7 311.9c-6.9-25.6 8.3-51.9 33.9-58.8zm56.6 46.7a30.8 30.8 0 1 0 -59.5 15.9 30.8 30.8 0 1 0 59.5-15.9zm245.9-34a30.8 30.8 0 1 0 -15.9-59.5 30.8 30.8 0 1 0 15.9 59.5z"]
};
const faGaugeCircleMinus = {
  prefix: 'far',
  iconName: 'gauge-circle-minus',
  icon: [640, 512, [], "e497", "M256 464c29.4 0 57.3-6.1 82.6-17.1c7.4 14.7 16.7 28.2 27.7 40.1C333 503 295.5 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0C375.4 0 475.6 81.7 504 192.2c-2.6-.1-5.3-.2-8-.2c-14 0-27.5 1.6-40.6 4.7C429.9 110.7 350.3 48 256 48C141.1 48 48 141.1 48 256s93.1 208 208 208zm0-56c-30.9 0-56-25.1-56-56c0-22.3 13.1-41.6 32-50.6L232 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 181.4c18.9 9 32 28.3 32 50.6c0 30.9-25.1 56-56 56zM128 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-16 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm208-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 208a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"]
};
const faBrightnessLow = {
  prefix: 'far',
  iconName: 'brightness-low',
  icon: [512, 512, [], "e0ca", "M288 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM432 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM48 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM160 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faHandMiddleFinger = {
  prefix: 'far',
  iconName: 'hand-middle-finger',
  icon: [448, 512, [128405], "f806", "M224 0c-35.3 0-64 28.7-64 64l0 120.5c-2.6-.3-5.3-.5-8-.5c-35.3 0-64 28.7-64 64l0 10.8c-2.4 1.9-4.7 3.9-6.9 5.9L60.8 283.2C42.5 299.9 32 323.5 32 348.3l0 10.2c0 54.1 28.7 104.1 75.4 131.3l2.6 1.5c23.2 13.6 49.7 20.7 76.6 20.7L312 512c66.3 0 120-53.7 120-120l0-8 0-96c0-35.3-28.7-64-64-64c-5.3 0-10.5 .7-15.5 1.9c-10.8-20.2-32-33.9-56.5-33.9c-2.7 0-5.4 .2-8 .5L288 64c0-35.3-28.7-64-64-64zM208 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 168c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 8c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16l0 96 0 8c0 39.8-32.2 72-72 72l-125.4 0c-18.4 0-36.5-4.9-52.4-14.2l-11.7 20 11.7-20-2.6-1.5C99.6 429.7 80 395.5 80 358.5l0-10.2c0-11.3 4.8-22 13.1-29.6l10.9-9.9 0 35.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-73 0-7 0-16c0-8.8 7.2-16 16-16c5.2 0 9.9 2.5 12.8 6.4c6.2 8.3 17 11.6 26.8 8.3s16.4-12.4 16.4-22.8l0-160z"]
};
const faPercent = {
  prefix: 'far',
  iconName: 'percent',
  icon: [384, 512, [62101, 62785, "percentage"], "25", "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faPercentage = faPercent;
const faTruckMoving = {
  prefix: 'far',
  iconName: 'truck-moving',
  icon: [640, 512, [], "f4df", "M72 80c-13.3 0-24 10.7-24 24l0 222.7c9.8-4.3 20.6-6.7 32-6.7c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-248c0-13.3-10.7-24-24-24L72 80zM208 480c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-48 0-48L0 104C0 64.2 32.2 32 72 32l336 0c39.8 0 72 32.2 72 72l0 40 48.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l-8 0-8 0-144 0c0 44.2-35.8 80-80 80zM535 194.9c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0-50-61.1zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faGlassWaterDroplet = {
  prefix: 'far',
  iconName: 'glass-water-droplet',
  icon: [384, 512, [], "e4f5", "M24 0C17.3 0 10.9 2.8 6.3 7.8S-.5 19.4 .1 26.1L36.3 446.2C39.5 483.4 70.7 512 108 512L276 512c37.4 0 68.5-28.6 71.7-65.8L383.9 26.1c.6-6.7-1.7-13.3-6.2-18.3s-11-7.8-17.7-7.8L24 0zM73.5 319.2L50.2 48l283.7 0L310.5 319.2l-9.3 5.2c-16.2 9-36.2 7.3-50.7-4.3c-34.2-27.4-82.8-27.4-117 0C119 331.6 99 333.3 82.8 324.3l-9.3-5.2zm4.7 55c29 8.6 60.9 2.8 85.2-16.6c16.7-13.3 40.4-13.3 57 0c24.3 19.4 56.2 25.3 85.2 16.6l-5.9 67.9C298.8 454.5 288.4 464 276 464L108 464c-12.5 0-22.8-9.5-23.9-21.9l-5.9-67.9zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"]
};
const faConveyorBelt = {
  prefix: 'far',
  iconName: 'conveyor-belt',
  icon: [640, 512, [], "f46e", "M384 48l80 0 0 160-288 0 0-160 80 0 0 80c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8L320 115.2l39.1 26.1c4.9 3.3 11.2 3.6 16.4 .8s8.5-8.2 8.5-14.1l0-80zM128 48l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L176 0c-26.5 0-48 21.5-48 48zM592 400c0 35.3-28.7 64-64 64l-416 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l416 0c35.3 0 64 28.7 64 64zM112 288C50.1 288 0 338.1 0 400s50.1 112 112 112l416 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-416 0zm48 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faLocationCheck = {
  prefix: 'far',
  iconName: 'location-check',
  icon: [384, 512, ["map-marker-check"], "f606", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-95-20.4L182.3 278.3c-9.4 9.4-24.6 9.4-33.9 0L95 225c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36.4 36.4L255 137.7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
};
const faMapMarkerCheck = faLocationCheck;
const faCoinVertical = {
  prefix: 'far',
  iconName: 'coin-vertical',
  icon: [384, 512, [], "e3fd", "M204 413.5c-22.2 39.4-45.3 50.5-60 50.5s-37.8-11.1-60-50.5C62.7 375.6 48 320 48 256s14.7-119.6 36-157.5C106.2 59.1 129.3 48 144 48s37.8 11.1 60 50.5c21.3 37.9 36 93.5 36 157.5s-14.7 119.6-36 157.5zM0 256C0 397.4 64.5 512 144 512l48 0 64 0c70.7 0 128-114.6 128-256S326.7 0 256 0L192 0 144 0C64.5 0 0 114.6 0 256zm286.3 40c1.2-13 1.7-26.4 1.7-40s-.6-27-1.7-40l48 0c1.1 12.9 1.7 26.3 1.7 40s-.6 27.1-1.7 40l-48 0zm-4 32l48.1 0c-3.9 23.7-9.6 45.3-16.6 64L266 392c7-19.7 12.5-41.2 16.2-64zM228 464c9.1-11.6 17.4-25 24.7-40l46.5 0c-18.9 33.8-36.3 40-43.1 40l-28 0zM330.3 184l-48.1 0c-3.8-22.8-9.2-44.3-16.2-64l47.7 0c7 18.7 12.7 40.3 16.6 64zM299.1 88l-46.5 0C245.3 73 237 59.6 228 48l28 0c6.8 0 24.2 6.2 43.1 40zM120 256c0-40.2 5.2-75.7 12.9-100.3c3.7-11.8 7.7-19.9 11.1-24.7c3.4 4.8 7.3 12.9 11.1 24.7c7.8 24.6 12.9 60 12.9 100.3s-5.2 75.7-12.9 100.3c-3.7 11.8-7.7 19.9-11.1 24.7c-3.4-4.8-7.3-12.9-11.1-24.7c-7.8-24.6-12.9-60-12.9-100.3zm27.4-128.8s-.1 0-.2 .1c.1-.1 .2-.1 .2-.1zm-6.6 .1c-.1-.1-.2-.1-.2-.1s.1 .1 .2 .1zm-.2 257.4s.1 0 .2-.1c-.1 .1-.2 .1-.2 .1zm6.6-.1c.1 .1 .2 .1 .2 .1s-.1-.1-.2-.1zM144 80c-17.7 0-30.3 11.3-37.9 21.6c-8 10.7-14.2 24.6-18.9 39.7C77.6 171.7 72 212.3 72 256s5.6 84.3 15.2 114.7c4.8 15.1 10.9 29 18.9 39.7c7.7 10.3 20.2 21.6 37.9 21.6s30.3-11.3 37.9-21.6c8-10.7 14.2-24.6 18.9-39.7c9.6-30.4 15.2-71 15.2-114.7s-5.6-84.3-15.2-114.7c-4.8-15.1-10.9-29-18.9-39.7C174.3 91.3 161.7 80 144 80z"]
};
const faDisplay = {
  prefix: 'far',
  iconName: 'display',
  icon: [576, 512, [], "e163", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM211.7 416L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48zm48.7 0l-8 48 71.3 0-8-48-55.3 0z"]
};
const faPersonSign = {
  prefix: 'far',
  iconName: 'person-sign',
  icon: [512, 512, [], "f757", "M438.1 32.2c4.5-12.5-1.9-26.2-14.3-30.8S397.5 3.3 393 15.8l-4.6 12.7L328.7 6.7c-12.5-4.5-26.2 1.9-30.8 14.3L259.6 126.3c-4.5 12.5 1.9 26.2 14.3 30.8l59.7 21.7L316.5 226l-19.3-7.2c-12.1-4.6-22.8-12.3-30.9-22.4L238 161c-16.7-20.9-42-33-68.7-33l-39.6 0c-34.8 0-66.3 20.5-80.4 52.3L2.1 286.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2L80 229.1 80 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 52.2 0 27.1 59.6c.5 1 .7 2.2 .7 3.3l0 73.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.1c0-8-1.7-15.9-5-23.2l-35-77 0-104.4 12.7 15.9c13.5 16.9 31.3 29.8 51.6 37.4l19.7 7.4-11 30.3c-4.5 12.5 1.9 26.2 14.3 30.8s26.2-1.9 30.8-14.3l44.6-122.6 60.6 22c12.5 4.5 26.2-1.9 30.8-14.3L508.4 97.7c4.5-12.5-1.9-26.2-14.3-30.8l-60.6-22 4.6-12.7zM334.8 60l120.3 43.8L433.2 164 312.9 120.2 334.8 60zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-14.4 80l38.4 0 0 128-40 0 0-128c.5 0 1.1 0 1.6 0z"]
};
const faFaceSmile = {
  prefix: 'far',
  iconName: 'face-smile',
  icon: [512, 512, [128578, "smile"], "f118", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSmile = faFaceSmile;
const faPhoneHangup = {
  prefix: 'far',
  iconName: 'phone-hangup',
  icon: [640, 512, [], "e225", "M320 144C193.1 144 98.7 205.9 53.3 250.2c-4.6 4.5-6.6 12.9-2.1 21.8l36.1 71.5c1.6 3.2 5.2 4.9 8.7 4.2l102.4-20.3c3.7-.7 6.4-4 6.4-7.8l0-71.1c0-10.4 6.6-19.5 16.5-22.8l3.4-1.1c61.9-20.4 128.7-20.4 190.7 0l3.4 1.1c9.8 3.2 16.5 12.4 16.5 22.8l0 71.1c0 3.8 2.7 7.1 6.4 7.8L544 347.7c3.5 .7 7.1-1 8.7-4.2L588.8 272c4.5-8.9 2.6-17.3-2.1-21.8C541.3 205.9 446.9 144 320 144zM19.8 215.8C71.5 165.4 177.4 96 320 96s248.5 69.4 300.2 119.8c22 21.5 23.8 53.4 11.4 77.8l-36.1 71.5c-11.3 22.4-36.2 34.6-60.9 29.7L432.3 374.5c-26.2-5.2-45.1-28.2-45.1-54.9l0-53.4c-44-12-90.4-12-134.4 0l0 53.4c0 26.7-18.9 49.7-45.1 54.9L105.3 394.8c-24.7 4.9-49.6-7.3-60.9-29.7L8.3 293.6C-4 269.2-2.3 237.3 19.8 215.8z"]
};
const faSignatureSlash = {
  prefix: 'far',
  iconName: 'signature-slash',
  icon: [640, 512, [], "e3cb", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L563 416l53 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.2 0-61.2-48L552 320c13.3 0 24-10.7 24-24s-10.7-24-24-24l-101.9 0 28.5-79.9c3.1-8.6 1-18.1-5.3-24.7s-15.7-9-24.4-6.3l-133 41.2c2.7-22 4.1-44.2 4.1-66.4l0-7.9c0-53-43-96-96-96c-37 0-69.1 20.9-85.1 51.6L38.8 5.1zM178 114.2C183.9 94.4 202.3 80 224 80c26.5 0 48 21.5 48 48l0 7.9c0 16.7-.9 33.4-2.6 50L178 114.2zM343.5 243.9l73.7-22.8-22.5 63-51.2-40.2zM406.2 416l-60.9-48-41.1 0c-7 16.3-14.8 32.4-23.3 48l125.4 0zM158 251.1c-36.9 11.4-62 45.5-62 84.1L96 410c0 38.6 31.3 70 70 70c24.6 0 47.4-12.9 60-34l15.9-26.4c18.5-30.8 33.8-63.3 45.7-97l-40-31.6c-11.5 36.3-27.2 71.2-46.8 103.9l-15.9 26.4c-4 6.6-11.1 10.7-18.8 10.7c-12.1 0-22-9.8-22-22l0-74.8c0-17.5 11.4-33 28.2-38.2l59.5-18.4-45.8-36.1L158 251.1zM64 368l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.2 0c-.1-2-.2-4-.2-6l0-42z"]
};
const faThumbtack = {
  prefix: 'far',
  iconName: 'thumbtack',
  icon: [384, 512, [128204, 128392, "thumb-tack"], "f08d", "M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304 168 304l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 115.5 0-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7L134.8 48c0 1.2 0 2.5-.1 3.7zM168 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48L56 48c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0L86.8 0 297.2 0 328 0c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3l-30.8 0 3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-136 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z"]
};
const faThumbTack = faThumbtack;
const faWheatSlash = {
  prefix: 'far',
  iconName: 'wheat-slash',
  icon: [640, 512, [], "e339", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-174-136.4c3.6-2.8 7.1-5.9 10.5-9.3l16.9-16.9c8.5-8.5 9.3-21.7 2.4-31.1c21.9-3.8 42.9-14.2 59.8-31.1l16.9-16.9c9.4-9.4 9.4-24.6 0-33.9l-16.9-16.9c-11.6-11.6-24.8-20.4-38.9-26.7C546.8 140.9 576 105.9 576 64l0-40c0-13.3-10.7-24-24-24L512 0c-41.9 0-76.9 29.3-85.8 68.5C420 54.3 411 41 399.4 29.4L382.5 12.4c-9.4-9.4-24.6-9.4-33.9 0L331.6 29.4c-16.9 16.9-27.3 37.9-31.1 59.8c-9.4-6.9-22.6-6.1-31.1 2.4l-16.9 16.9c-12.5 12.5-21.5 27.3-26.8 43L38.8 5.1zM267.7 184.5c.8-15.3 7-30.3 18.6-42c19.9 20 27.1 47.8 21.6 73.5l-40.2-31.5zM372 266.3c22-1.3 44.5 6.4 61.3 23.3c-5 4.9-10.5 8.9-16.4 11.9L372 266.3zM173.3 346.1l11.3 11.3c0 0 0 0 0 0L71 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L218.5 391.4l11.2 11.2c43.7 43.7 114.6 43.7 158.4 0l.5-.5-38.1-30c-25.1 21.5-63 20.4-86.8-3.4l-10.1-10.2c20.1-13.3 44.8-16.6 67.2-9.8l-90.2-71.1c.1 15.6-4.3 31.2-13.2 44.7l-10.1-10.1c-17.6-17.6-22.8-43-15.6-65.2l-39.1-30.8c-21.4 42.1-14.5 94.8 20.7 129.9zM512 48l16 0 0 16c0 22.1-17.9 40-40 40l-16 0 0-16c0-22.1 17.9-40 40-40zM365.5 153.8c-25-25-25-65.5 0-90.5c27.3 27.4 30.7 69.6 10.2 100.6l-10.1-10.1zm147 56.5c-25 25-65.5 25-90.5 0l-10.1-10.1c31-20.5 73.3-17.2 100.6 10.2z"]
};
const faTrophy = {
  prefix: 'far',
  iconName: 'trophy',
  icon: [576, 512, [127942], "f091", "M248.8 309.7c-27.6-30.3-65.5-101-71.8-261.7l222.2 0c-6.4 160.7-44.3 231.4-71.8 261.7c-13.7 15.1-25.9 21.4-33.1 24.1c-2.6 1-4.7 1.5-6.1 1.9c-1.4-.3-3.5-.9-6.1-1.9c-7.2-2.7-19.4-9-33.1-24.1zM400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88C0 196.5 45.9 265.7 101.5 308.6c53.9 41.7 115.7 57.6 149.5 63.7c4.7 2.5 9.1 4.5 13.1 6.1l0 85.6-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-85.6c4-1.6 8.4-3.6 13.1-6.1c33.8-6 95.5-22 149.5-63.7C530.1 265.7 576 196.5 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zm42.7 112l84.4 0c-6 78.4-41.3 127.3-81.9 158.6c-17.5 13.6-36.3 24-54.4 32c22.7-40.3 42.8-100.5 51.9-190.6zM185.2 302.6c-18.1-8-36.8-18.4-54.4-32C90.2 239.3 54.9 190.4 48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6z"]
};
const faCloudsSun = {
  prefix: 'far',
  iconName: 'clouds-sun',
  icon: [640, 512, [], "f746", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 30.7 5.1c-26.4 10.6-47 32.6-55.7 59.9C276.8 132.7 244.8 112 208 112c-53 0-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm409.8 32.1l12.4 0c.6 0 1.2 0 1.8 0c13.2 0 24-10.7 24-24s-10.7-24-24-24c-1.1 0-2.2 .1-3.2 .2c-25.1 3.3-48.5-13.5-53.4-38.4c-2.9-14.7-15.9-25.8-31.4-25.8c-13.6 0-25.3 8.5-29.9 20.6c-9.2 24.3-36.2 36.9-60.8 28.2c-1.6-.6-3.4-.9-5.3-.9c-8.8 0-15.9 7.1-16 15.9l-.1 0c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72c0 30.4-18.8 56.3-45.4 66.9c-9.5-17.7-23.6-32.5-40.8-42.9zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
const faPersonPraying = {
  prefix: 'far',
  iconName: 'person-praying',
  icon: [448, 512, [128720, "pray"], "f683", "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM202.1 192c5.3 0 10.2 2.7 12.9 7.2l4.3 7.1L152.2 367.5l-9.4-6c-9.8-6.3-13.7-18.7-9.2-29.4l54.5-130.7c2.4-5.7 7.9-9.3 14-9.3zm48.3 64.7l7.4 12.1c12.8 20.9 41.2 25.4 59.9 9.6l89.8-76c10.1-8.6 11.4-23.7 2.8-33.8s-23.7-11.4-33.8-2.8l-82.7 70-37.9-61.6C244.4 155.4 224 144 202.1 144c-25.5 0-48.5 15.3-58.3 38.9L89.3 313.6c-13.4 32.3-1.8 69.5 27.6 88.3L214 464 56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c10.7 0 20-7 23-17.3s-1.1-21.2-10.1-27l-115.7-74 57.1-137.1z"]
};
const faPray = faPersonPraying;
const faHammer = {
  prefix: 'far',
  iconName: 'hammer',
  icon: [576, 512, [128296], "f6e3", "M432.8 204.9c-9.1-9.1-21.5-14.2-34.4-14.1c-11.3 .1-22.4-4.1-31-12.7L329.3 140c-5.9-5.9-9.3-14-9.3-22.4l0-12.1c0-17.6-9.6-33.7-25-42.1L273.3 51.5c8.4-2.3 17.1-3.5 25.8-3.5l18.1 0c24.5 0 48 9.3 65.8 26.1l44.6 42c9.7 9.1 14.3 21.7 13.5 34.1c-.8 13.7 4.3 27.1 14 36.8l37 37L472 244.1l-39.2-39.2zM216.7 75.3l.3 .2 55 30 0 12.1c0 21.1 8.4 41.4 23.3 56.3l38.1 38.1c18.1 18.1 41.8 26.9 65.4 26.7l39.2 39.2 1 1-16 16c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L569 217c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-8 8-1-1-37-37c1.6-26.1-8-52.7-28.5-72l-44.6-42C389.2 14 353.9 0 317.2 0L299.2 0C279 0 259.1 4.2 240.7 12.4L219.1 22l-.3 .1-6.2 2.8-19.1 8.5c-5.6 2.5-9.2 7.9-9.5 14s3 11.8 8.3 14.7l18.4 10 6 3.3zm44.2 107.3L27.4 377.1C10.1 391.6 0 413.1 0 435.7C0 477.8 34.1 512 76.3 512c22.6 0 44.1-10.1 58.6-27.4L330 250.4c-6.8-4.5-13.2-9.7-19.2-15.7l-38.1-38.1c-4.3-4.3-8.3-9-11.8-14z"]
};
const faFaceVomit = {
  prefix: 'far',
  iconName: 'face-vomit',
  icon: [576, 512, [], "e3a0", "M496 256c0 63.4-28.3 120.1-73 158.3c5.8 9.5 14.8 17 25.9 20.7l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.1-3.7 20.1-11.1 25.9-20.7C108.3 376.1 80 319.4 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM148 157.1c0 2.8 1 5.5 2.8 7.6l36 43.2-36 43.2c-1.8 2.1-2.8 4.8-2.8 7.6c0 9 9.6 14.7 17.5 10.5l89.9-47.9c10.7-5.7 10.7-21.1 0-26.8l-89.9-47.9c-7.9-4.2-17.5 1.5-17.5 10.5zm262.5-10.5l-89.9 47.9c-10.7 5.7-10.7 21.1 0 26.8l89.9 47.9c7.9 4.2 17.5-1.5 17.5-10.5c0-2.8-1-5.5-2.8-7.6l-36-43.2 36-43.2c1.8-2.1 2.8-4.8 2.8-7.6c0-9-9.6-14.7-17.5-10.5zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm544-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 396.1l0-58.3c10.8 4.3 18.7 8.5 23.1 11.5c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2C406.3 310.3 355.2 288 288 288s-118.3 22.3-136.9 34.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4c4.4-3 12.3-7.2 23.1-11.5l0 58.3c0 31-19.8 58.5-49.2 68.3l-34.1 11.4c-7.6 2.5-12.7 9.6-12.7 17.6c0 10.3 8.3 18.6 18.6 18.6l346.8 0c10.3 0 18.6-8.3 18.6-18.6c0-8-5.1-15.1-12.7-17.6l-34.1-11.4c-29.4-9.8-49.2-37.3-49.2-68.3zM304 416a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faSpeakers = {
  prefix: 'far',
  iconName: 'speakers',
  icon: [640, 512, [], "f8e0", "M64 0L248.4 0c-11.8 13.2-20.1 29.7-23.1 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l161.3 0c3.1 18.3 11.3 34.8 23.1 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0zM192 88c13.1 0 24.7 6.3 32 16l0 48c-7.3 9.7-18.9 16-32 16c-22.1 0-40-17.9-40-40s17.9-40 40-40zm0 120c11.1 0 21.9 1.6 32 4.6l0 51.9c-9.4-5.4-20.3-8.6-32-8.6c-35.3 0-64 28.7-64 64s28.7 64 64 64c11.7 0 22.6-3.1 32-8.6l0 51.9c-10.1 3-20.9 4.6-32 4.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zM320 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L320 48zM256 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-384zM448 88a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM336 320a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faTtyAnswer = {
  prefix: 'far',
  iconName: 'tty-answer',
  icon: [640, 512, ["teletype-answer"], "e2b9", "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C175.2 485.6 0 295.2 0 64c0 0 0 0 0 0C0 45.1 13.2 28.8 31.6 24.9l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L329 286.7zm133.8 78.1l-100.4-43L333 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L48.1 70.5C51.5 286.2 225.8 460.5 441.5 464l21.3-99.2zM304 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM288 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM592 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM576 176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM400 160l128 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"]
};
const faTeletypeAnswer = faTtyAnswer;
const faMugTeaSaucer = {
  prefix: 'far',
  iconName: 'mug-tea-saucer',
  icon: [640, 512, [], "e1f5", "M144 288c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-208L248 80l0 10.7c0 8.5 3.4 16.6 9.4 22.6l21.3 21.3c6 6 9.4 14.1 9.4 22.6l0 66.7c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32l0-66.7c0-8.5 3.4-16.6 9.4-22.6l21.3-21.3c6-6 9.4-14.1 9.4-22.6L216 80l-72 0 0 208zM96 64c0-17.7 14.3-32 32-32l320 0 64 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L96 64zM480 240l32 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-32 0 0 160zM24 432l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faDiagramLeanCanvas = {
  prefix: 'far',
  iconName: 'diagram-lean-canvas',
  icon: [640, 512, [], "e156", "M512 80l0 216 80 0 0-200c0-8.8-7.2-16-16-16l-64 0zm-48 0l-64 0 0 88 64 0 0-88zM352 80l-64 0 0 216 64 0 0-216zM240 80l-64 0 0 88 64 0 0-88zM128 80L64 80c-8.8 0-16 7.2-16 16l0 200 80 0 0-216zM48 344l0 72c0 8.8 7.2 16 16 16l232 0 0-88L48 344zm296 88l232 0c8.8 0 16-7.2 16-16l0-72-248 0 0 88zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM240 296l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z"]
};
const faAlt = {
  prefix: 'far',
  iconName: 'alt',
  icon: [640, 512, [], "e08a", "M467.9 120.4c4.6-5.3 11.2-8.4 18.2-8.4L616 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L486.1 64c-21 0-41 9.2-54.7 25.1L172.1 391.6c-4.6 5.3-11.2 8.4-18.2 8.4L24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l129.9 0c21 0 41-9.2 54.7-25.1L467.9 120.4zM440 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"]
};
const faDial = {
  prefix: 'far',
  iconName: 'dial',
  icon: [576, 512, ["dial-med-high"], "e15b", "M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM208.8 208.8c37.9-37.9 96.2-43 139.6-15.1L271 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l77.4-77.4c27.8 43.4 22.8 101.7-15.1 139.6c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4zm192.3-33.9A160 160 0 1 0 174.9 401.1 160 160 0 1 0 401.1 174.9zM576 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 96A32 32 0 1 0 64 96a32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 480a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faDialMedHigh = faDial;
const faHandPeace = {
  prefix: 'far',
  iconName: 'hand-peace',
  icon: [512, 512, [9996], "f25b", "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320c0 0 0 0 0 0l0 24c0 92.8 75.2 168 168 168l48 0c92.8 0 168-75.2 168-168l0-72 0-16 0-32c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192l0 48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2l-7.4 0-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240 144 240c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2l0 10c0 66.3-53.7 120-120 120l-48 0c-66.3 0-120-53.7-120-120l0-24s0 0 0 0c0-17.7 14.3-32 32-32l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 16z"]
};
const faCircleTrash = {
  prefix: 'far',
  iconName: 'circle-trash',
  icon: [512, 512, ["trash-circle"], "e126", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM160 128l41.4 0 11.3-11.3c3-3 7.1-4.7 11.3-4.7l64 0c4.2 0 8.3 1.7 11.3 4.7L310.6 128l41.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l192 0L338.4 354.7c-1.4 16.6-15.2 29.3-31.9 29.3l-101.1 0c-16.6 0-30.5-12.8-31.9-29.3L160 192z"]
};
const faTrashCircle = faCircleTrash;
const faRotate = {
  prefix: 'far',
  iconName: 'rotate',
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25c0 19.5 15.8 35.3 35.3 35.3L472 224c13.3 0 24-10.7 24-24l0-116.7C496 63.8 480.2 48 460.7 48c-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9l-4.1-4.1 35.7-35.7c6.6-6.6 10.3-15.6 10.3-25c0-19.5-15.8-35.3-35.3-35.3L40 288c-13.3 0-24 10.7-24 24l0 116.7C16 448.2 31.8 464 51.3 464c9.4 0 18.3-3.7 25-10.3L112 417.9l4.1 4.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9zM448 176l-62.1 0L448 113.9l0 62.1zM64 336l62.1 0L64 398.1 64 336z"]
};
const faSyncAlt = faRotate;
const faCircleQuarters = {
  prefix: 'far',
  iconName: 'circle-quarters',
  icon: [512, 512, [], "e3f8", "M108.9 403.1L256 256 403.1 403.1C440.7 365.4 464 313.4 464 256s-23.3-109.4-60.9-147.1L256 256 108.9 108.9C71.3 146.6 48 198.6 48 256s23.3 109.4 60.9 147.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faSpinner = {
  prefix: 'far',
  iconName: 'spinner',
  icon: [512, 512, [], "f110", "M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z"]
};
const faTowerControl = {
  prefix: 'far',
  iconName: 'tower-control',
  icon: [448, 512, [], "e2a2", "M160 24c0-13.3 10.7-24 24-24l40 0 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 48 40 0c17.7 0 32 14.3 32 32l93.2 0c21.4 0 36.8 20.7 30.6 41.2L402.7 306.5c7.9 3.9 13.3 12.1 13.3 21.5c0 13.3-10.7 24-24 24l-24 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-192 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-24 0c-13.3 0-24-10.7-24-24c0-9.4 5.4-17.6 13.3-21.5L4.1 169.2C-2.1 148.7 13.3 128 34.8 128l93.2 0c0-17.7 14.3-32 32-32l40 0 0-48-16 0c-13.3 0-24-10.7-24-24zM94.7 304l33.3 0 0-128-71.7 0L94.7 304zm81.3 0l96 0 0-128-96 0 0 128zM320 176l0 128 33.3 0 38.4-128L320 176z"]
};
const faArrowUpTriangleSquare = {
  prefix: 'far',
  iconName: 'arrow-up-triangle-square',
  icon: [576, 512, ["sort-shapes-up"], "f88a", "M416 32c9.9 0 19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9c0 13.8-11.2 25.1-25.1 25.1l-173.9 0c-13.8 0-25.1-11.2-25.1-25.1c0-4.5 1.2-9 3.6-12.9L391.8 45.7C396.9 37.2 406.1 32 416 32zM368 432l96 0 0-96-96 0 0 96zM416 98.6L369.6 176l92.8 0L416 98.6zM320 432l0-96c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96z"]
};
const faSortShapesUp = faArrowUpTriangleSquare;
const faWhale = {
  prefix: 'far',
  iconName: 'whale',
  icon: [640, 512, [128011], "f72c", "M175.8 13.4c-1-5.9-5.2-10.8-10.9-12.6s-12-.3-16.2 3.9L108 45.4C89.7 63.7 81.4 89.6 85.6 115.1l7.9 47.4L79.2 176.8 43.6 212.4C15.7 240.3 0 278.2 0 317.6C0 407.3 72.7 480 162.4 480L544 480c53 0 96-43 96-96l0-108.3C640 194.1 573.9 128 492.3 128c-80.5 0-158.6 27.4-221.4 77.7L139 311.2c-7.1 5.7-15.9 8.8-25 8.8l-1 0c-19 0-35.2-13.7-38.4-32.5c-1.7-9.9 .6-20.1 6.3-28.4l35.4-51.4 9.1-13.2 47.6 7.9c25.5 4.2 51.5-4.1 69.7-22.3l40.7-40.7c4.2-4.2 5.8-10.5 3.9-16.2s-6.7-9.9-12.6-10.9L189.9 98.1 175.8 13.4zM50.5 341.5C66.4 358 88.7 368 113 368l1 0c20 0 39.4-6.8 55-19.3L300.9 243.1C355.2 199.7 422.7 176 492.3 176c55 0 99.7 44.6 99.7 99.7L592 384c0 26.5-21.5 48-48 48l-381.6 0c-55 0-100.9-38.8-111.9-90.5zM392 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faRobot = {
  prefix: 'far',
  iconName: 'robot',
  icon: [640, 512, [129302], "f544", "M320 0c13.3 0 24 10.7 24 24l0 72 104 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-256 0c-53 0-96-43-96-96l0-224c0-53 43-96 96-96l104 0 0-72c0-13.3 10.7-24 24-24zM192 144c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-128 0-128 0zM48 224l16 0 0 192-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0 0-192 16 0zM208 384l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM200 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm200-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"]
};
const faPeace = {
  prefix: 'far',
  iconName: 'peace',
  icon: [512, 512, [9774], "f67c", "M232 462.6l0-156L111.3 405.4c32 31 74 51.9 120.7 57.2zM80.9 368.3L232 244.6l0-195.3C128.4 61.3 48 149.2 48 256c0 41.4 12.1 79.9 32.9 112.3zm319.8 37.1L280 306.6l0 156c46.7-5.4 88.7-26.2 120.7-57.2zm30.4-37.1C451.9 335.9 464 297.4 464 256c0-106.8-80.4-194.7-184-206.6l0 195.3L431.1 368.3zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
};
const faPartyHorn = {
  prefix: 'far',
  iconName: 'party-horn',
  icon: [512, 512, [], "e31b", "M32 32a32 32 0 1 1 64 0A32 32 0 1 1 32 32zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM167 153c-9.4-9.4-9.4-24.6 0-33.9l8.3-8.3c16.7-16.7 27.2-38.6 29.8-62.1l3-27.4C209.6 8.2 221.5-1.3 234.7 .1s22.7 13.3 21.2 26.5l-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L201 153c-9.4 9.4-24.6 9.4-33.9 0zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3c13.2-1.5 25 8 26.5 21.2s-8 25-21.2 26.5l-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8L393 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9zM506.3 8.5c8.6 10.1 7.3 25.3-2.8 33.8l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6c-16.6-.4-30.6 12.4-31.6 29l-1.8 30c-2.5 42.5-38.3 75.3-80.8 74.2c-7.6-.2-15 2.4-20.7 7.3l-10 8.5c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l10-8.5c14.8-12.5 33.7-19.1 53-18.6c16.6 .4 30.6-12.4 31.6-29l1.8-30c2.5-42.5 38.3-75.3 80.8-74.2c7.6 .2 15-2.4 20.7-7.3l10-8.5c10.1-8.6 25.3-7.3 33.8 2.8zM59.3 452.7l86.9-32.6L91.9 365.8 59.3 452.7zm200.1-75l-125-125-23.9 63.8 85.1 85.1 63.8-23.9zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4L310.9 361.3c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18.1 519.4-7.4 494 2 468.8L98.1 212.6z"]
};
const faGears = {
  prefix: 'far',
  iconName: 'gears',
  icon: [640, 512, ["cogs"], "f085", "M147.1 52.7l-6.5 23.5c-1.7 6.2-6.3 11.2-12.4 13.5c-10 3.7-19.1 9-27.2 15.7c-5 4.1-11.6 5.6-17.9 4l-23.6-6.2c-5 6.9-9.4 14.4-12.9 22.3l17.1 17.4c4.5 4.6 6.6 11.1 5.5 17.4c-.9 5.1-1.3 10.3-1.3 15.7s.5 10.6 1.3 15.7c1.1 6.4-.9 12.9-5.5 17.4L46.7 226.5c3.5 7.9 7.9 15.4 12.9 22.3l23.6-6.2c6.3-1.6 12.9-.1 17.9 4c8 6.7 17.2 12 27.2 15.7c6.1 2.2 10.7 7.2 12.4 13.5l6.5 23.5c4.2 .4 8.5 .7 12.9 .7s8.7-.2 12.9-.7l6.5-23.5c1.7-6.2 6.3-11.2 12.4-13.5c10-3.7 19.1-9 27.2-15.7c5-4.1 11.6-5.6 17.9-4l23.6 6.2c5-6.9 9.4-14.4 12.9-22.3l-17.1-17.4c-4.5-4.6-6.6-11.1-5.5-17.4c.9-5.1 1.3-10.3 1.3-15.7s-.5-10.6-1.3-15.7c-1.1-6.4 .9-12.9 5.5-17.4l17.1-17.4c-3.5-7.9-7.9-15.4-12.9-22.3l-23.6 6.2c-6.3 1.6-12.9 .1-17.9-4c-8-6.7-17.2-12-27.2-15.7c-6.1-2.2-10.7-7.2-12.4-13.5l-6.5-23.5c-4.2-.4-8.5-.7-12.9-.7s-8.7 .2-12.9 .7zM127.3 15.3C137.9 13.1 148.8 12 160 12s22.1 1.1 32.7 3.3c7.4 1.5 13.3 7 15.3 14.3l7.3 26.6c7.3 3.4 14.3 7.4 20.8 12l26.6-7c7.3-1.9 15 .4 20 6.1c14.4 16.3 25.7 35.5 32.8 56.7c2.4 7.1 .6 15-4.7 20.4L291.5 164c.4 4 .5 8 .5 12s-.2 8-.5 12l19.4 19.6c5.3 5.4 7.1 13.2 4.7 20.4c-7.1 21.2-18.3 40.4-32.8 56.7c-5 5.6-12.7 8-20 6.1l-26.6-7c-6.5 4.6-13.5 8.6-20.8 12L208 322.4c-2 7.3-7.9 12.8-15.3 14.3c-10.6 2.1-21.5 3.3-32.7 3.3s-22.1-1.1-32.7-3.3c-7.4-1.5-13.3-7-15.3-14.3l-7.3-26.6c-7.3-3.4-14.3-7.4-20.8-12l-26.6 7c-7.3 1.9-15-.4-20-6.1C22.8 268.4 11.5 249.2 4.4 228c-2.4-7.1-.6-15 4.7-20.4L28.5 188c-.4-4-.5-8-.5-12s.2-8 .5-12L9.2 144.4C3.9 139 2 131.1 4.4 124c7.1-21.2 18.3-40.4 32.8-56.7c5-5.6 12.7-8 20-6.1l26.6 7c6.5-4.6 13.5-8.6 20.8-12L112 29.6c2-7.3 7.9-12.8 15.3-14.3zM120 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM340.7 364.9l23.5 6.5c6.2 1.7 11.2 6.3 13.5 12.4c3.7 10 9 19.1 15.7 27.2c4.1 5 5.6 11.6 4 17.9l-6.2 23.6c6.9 5 14.4 9.4 22.3 12.9l17.4-17.1c4.6-4.5 11.1-6.6 17.4-5.5c5.1 .9 10.3 1.3 15.7 1.3s10.6-.5 15.7-1.3c6.4-1.1 12.8 .9 17.4 5.5l17.4 17.1c7.9-3.5 15.4-7.9 22.3-12.9l-6.2-23.6c-1.6-6.2-.1-12.9 4-17.9c6.7-8 12.1-17.2 15.7-27.2c2.2-6.1 7.2-10.7 13.5-12.4l23.5-6.5c.4-4.2 .7-8.5 .7-12.9s-.2-8.7-.7-12.9l-23.5-6.5c-6.2-1.7-11.2-6.3-13.5-12.4c-3.7-10-9-19.1-15.7-27.2c-4.1-5-5.6-11.6-4-17.9l6.2-23.6c-6.9-5-14.4-9.4-22.3-12.9l-17.4 17.1c-4.6 4.5-11.1 6.6-17.4 5.5c-5.1-.9-10.4-1.3-15.7-1.3s-10.6 .5-15.7 1.3c-6.4 1.1-12.9-.9-17.4-5.5l-17.4-17.1c-7.9 3.5-15.4 7.9-22.3 12.9l6.2 23.6c1.6 6.3 .1 12.9-4 17.9c-6.7 8-12.1 17.2-15.7 27.2c-2.2 6.1-7.2 10.7-13.5 12.4l-23.5 6.5c-.4 4.2-.7 8.5-.7 12.9s.2 8.7 .7 12.9zm-37.4 19.8c-2.1-10.6-3.3-21.5-3.3-32.7s1.1-22.1 3.3-32.7c1.5-7.4 7-13.3 14.3-15.3l26.6-7.3c3.4-7.3 7.4-14.3 12-20.8l-7-26.6c-1.9-7.3 .5-15 6.1-20c16.3-14.4 35.5-25.7 56.7-32.8c7.1-2.4 15-.6 20.4 4.7L452 220.5c4-.4 8-.5 12-.5s8 .2 12 .5l19.6-19.4c5.4-5.3 13.2-7.1 20.4-4.7c21.2 7.1 40.4 18.3 56.7 32.8c5.6 5 8 12.7 6.1 20l-7 26.6c4.6 6.5 8.6 13.5 12 20.8l26.6 7.3c7.3 2 12.8 7.9 14.3 15.3c2.1 10.6 3.3 21.5 3.3 32.7s-1.1 22.1-3.3 32.7c-1.5 7.4-7 13.3-14.3 15.3l-26.6 7.3c-3.4 7.3-7.4 14.3-12 20.8l7 26.6c1.9 7.3-.5 15-6.1 20c-16.3 14.4-35.5 25.7-56.7 32.8c-7.1 2.4-15 .6-20.4-4.7L476 483.5c-4 .4-8 .5-12 .5s-8-.2-12-.5l-19.6 19.4c-5.4 5.3-13.2 7.1-20.4 4.7c-21.2-7.1-40.4-18.3-56.7-32.8c-5.6-5-8-12.7-6.1-20l7-26.6c-4.6-6.5-8.6-13.5-12-20.8L317.6 400c-7.3-2-12.8-7.9-14.3-15.3zM464 392a40 40 0 1 1 0-80 40 40 0 1 1 0 80z"]
};
const faCogs = faGears;
const faSunBright = {
  prefix: 'far',
  iconName: 'sun-bright',
  icon: [512, 512, ["sun-alt"], "e28f", "M280 24l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24zm157 84.9l-45.3 45.3c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L403.1 75c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM108.9 75l45.3 45.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L75 108.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM24 232l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm400 0l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM154.2 391.8L108.9 437c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l45.3-45.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm237.6-33.9L437 403.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-45.3-45.3c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM280 424l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24s24 10.7 24 24zm40-168a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-176 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"]
};
const faSunAlt = faSunBright;
const faWarehouse = {
  prefix: 'far',
  iconName: 'warehouse',
  icon: [640, 512, [], "f494", "M323 51.1c-1.9-.8-4.1-.8-6 0L63 154.1c-9.1 3.7-15 12.5-15 22.2L48 488c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 176.3c0-29.3 17.8-55.7 44.9-66.7L299 6.6c13.5-5.5 28.6-5.5 42.1 0l254 103c27.2 11 45 37.4 45 66.7L640 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-311.7c0-9.8-5.9-18.6-15-22.2L323 51.1zM144 328l0 48 352 0 0-48-352 0zm0 136l352 0 0-40-352 0 0 40zm-23.7 48l-.3 0c-13.3 0-24-10.7-24-24l0-256c0-22.1 17.9-40 40-40l368 0c22.1 0 40 17.9 40 40l0 256c0 13.3-10.7 24-24 24l-.3 0-399.4 0zM144 280l352 0 0-40-352 0 0 40z"]
};
const faConveyorBeltArm = {
  prefix: 'far',
  iconName: 'conveyor-belt-arm',
  icon: [640, 512, [], "e5f8", "M152 0L328 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-69 0-4.5 26.9c6 5 10.8 11.4 13.9 18.8l198.8 26.5c13.1 1.8 22.4 13.8 20.6 27c-.8 5.9-3.7 11-7.8 14.7l0 30.1c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9L262 141.3c-8.8 11.4-22.6 18.7-38 18.7c-26.5 0-48-21.5-48-48c0-20.6 13-38.1 31.2-45l3.2-19L152 48c-13.3 0-24-10.7-24-24s10.7-24 24-24zm88 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM416 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 16 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-416 0C50.1 512 0 461.9 0 400c0-56.4 41.7-103.1 96-110.9L96 264c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 64 0 0-24zM112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l416 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-40 0-48 0-112 0-48 0-112 0-48 0-8 0zm16 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faLockKeyholeOpen = {
  prefix: 'far',
  iconName: 'lock-keyhole-open',
  icon: [576, 512, ["lock-open-alt"], "f3c2", "M432 48c-44.2 0-80 35.8-80 80l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l240 0 0-64C304 57.3 361.3 0 432 0s128 57.3 128 128l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-44.2-35.8-80-80-80zM384 240L64 240c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM256 376l-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faLockOpenAlt = faLockKeyholeOpen;
const faSquareFragile = {
  prefix: 'far',
  iconName: 'square-fragile',
  icon: [448, 512, ["box-fragile", "square-wine-glass-crack"], "f49b", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 38.3c0-12.3 10-22.3 22.3-22.3l25.7 0 32 64-32 32 80 64-32-64 48-32-32-64 57.7 0c12.3 0 22.3 10 22.3 22.3l0 89.7c0 47.6-34.6 87.1-80 94.7l0 49.3 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-49.3c-45.4-7.6-80-47.1-80-94.7l0-89.7z"]
};
const faBoxFragile = faSquareFragile;
const faSquareWineGlassCrack = faSquareFragile;
const faArrowUpRightDots = {
  prefix: 'far',
  iconName: 'arrow-up-right-dots',
  icon: [576, 512, [], "e4b7", "M128 24c0 13.3 10.7 24 24 24l86.1 0L7 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l231-231 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L152 0c-13.3 0-24 10.7-24 24zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faSquareN = {
  prefix: 'far',
  iconName: 'square-n',
  icon: [448, 512, [], "e277", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm154.3 40.5L288 294.5 288 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 10.1-6.3 19.1-15.7 22.5s-20.1 .7-26.6-7L160 217.5 160 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-10.1 6.3-19.1 15.7-22.5s20.1-.7 26.6 7z"]
};
const faSplotch = {
  prefix: 'far',
  iconName: 'splotch',
  icon: [512, 512, [], "f5bc", "M187.7 400.2L84.9 409.5c-11.2 1-20.9-7.8-20.9-19.1c0-4.2 1.3-8.2 3.8-11.5l18.8-25c16.7-22.3 25.4-49.5 24.8-77.3c-.5-23.1-7.5-45.7-20.2-65L50.6 149.7c-1.7-2.6-2.6-5.7-2.6-8.8c0-10.1 9.1-17.7 19-15.9l42.8 7.8c52.6 9.6 106.3-9.9 140.6-51l22.3-26.8c3.7-4.4 9.1-6.9 14.8-6.9c8.3 0 15.7 5.3 18.3 13.2l15 45.1c15.7 47.2 51.9 84.7 98.5 102.2l32.3 12.1c7.4 2.8 12.4 9.9 12.4 17.8c0 6-2.8 11.6-7.6 15.2l-62 46.5c-37.9 28.4-57.9 74.7-52.7 121.8l2.5 22.7c1.1 10.3-6.9 19.3-17.3 19.3c-3.9 0-7.8-1.3-10.9-3.8L279 430.5c-24.7-19.8-55.4-30.5-87-30.5c-1.5 0-2.9 .1-4.3 .2zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8c.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3c39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6c0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46c-20 0-38.9 8.9-51.7 24.2L213.5 51C190.3 78.8 154 92 118.4 85.5L75.6 77.7C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"]
};
const faFaceGrinHearts = {
  prefix: 'far',
  iconName: 'face-grin-hearts',
  icon: [512, 512, [128525, "grin-hearts"], "f584", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"]
};
const faGrinHearts = faFaceGrinHearts;
const faMeter = {
  prefix: 'far',
  iconName: 'meter',
  icon: [512, 512, [], "e1e8", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 152l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faMandolin = {
  prefix: 'far',
  iconName: 'mandolin',
  icon: [512, 512, [], "f6f9", "M435.3 3.6C444.8-2.3 457.1-.9 465 7l40 40c7.9 7.9 9.3 20.2 3.4 29.7l-40 64c-3.2 5.1-8.2 8.8-14 10.4l-81.8 22.3-50.6 50.6C324.6 305.1 317.5 512 176 512C78.8 512 0 433.2 0 336C0 194.5 206.9 187.4 287.9 190.1l50.6-50.6 22.3-81.9c1.6-5.8 5.3-10.8 10.4-14l64-40zm-246.8 286l51.5-51.5c-22.3 .8-47.1 2.8-71.6 7.1c-36.9 6.5-68.6 17.3-90.1 32.8C58.9 292.1 48 309.4 48 336c0 70.7 57.3 128 128 128c26.6 0 43.9-10.9 57.9-30.2c15.6-21.5 26.4-53.2 32.8-90.1c4.3-24.5 6.3-49.3 7.1-71.6l-51.5 51.5c1.1 4 1.6 8.1 1.6 12.4c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c4.3 0 8.5 .6 12.4 1.6z"]
};
const faDiceFour = {
  prefix: 'far',
  iconName: 'dice-four',
  icon: [448, 512, [9859], "f524", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM288 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faSimCard = {
  prefix: 'far',
  iconName: 'sim-card',
  icon: [384, 512, [], "f7c4", "M48 64l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-293.5c0-4.2-1.7-8.3-4.7-11.3L240.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16zM0 448L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64zM128 240l16 0 0 80-64 0 0-32c0-26.5 21.5-48 48-48zM80 384l0-32 80 0 48 0 0 80-80 0c-26.5 0-48-21.5-48-48zm176 48l-16 0 0-80 64 0 0 32c0 26.5-21.5 48-48 48zm48-144l0 32-80 0-48 0 0-80 80 0c26.5 0 48 21.5 48 48z"]
};
const faTransgender = {
  prefix: 'far',
  iconName: 'transgender',
  icon: [512, 512, [9895, "transgender-alt"], "f225", "M128 24c0-13.3-10.7-24-24-24L24 0C10.7 0 0 10.7 0 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-22.1L78.1 112l-7 7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2l0 17.8-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-17.8c77-11.6 136-78 136-158.2c0-35.5-11.6-68.3-31.2-94.9L464 81.9l0 22.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L408 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-7 7L81.9 48 104 48c13.3 0 24-10.7 24-24zM256 368c-61.9 0-112-50.1-112-112c0-29.8 11.7-56.9 30.7-77c.8-.6 1.6-1.3 2.3-2s1.4-1.5 2-2.3c20.1-19 47.2-30.7 77-30.7s56.9 11.7 77 30.7c.6 .8 1.3 1.6 2 2.3s1.5 1.4 2.3 2c19 20.1 30.7 47.2 30.7 77c0 61.9-50.1 112-112 112z"]
};
const faTransgenderAlt = faTransgender;
const faMercury = {
  prefix: 'far',
  iconName: 'mercury',
  icon: [384, 512, [9791], "f223", "M73 5.3C83.3-3 98.4-1.4 106.7 9c18.5 23.1 51.4 38.9 84.9 39l.3 0 .3 0c33.5-.1 66.4-15.9 84.9-39C285.6-1.4 300.7-3 311 5.3s12 23.4 3.7 33.7c-9.9 12.4-22.2 23.1-36 31.8C332 101.1 368 158.3 368 224c0 89.1-66.2 162.7-152 174.4l0 25.6 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0 0 16c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-25.6C82.2 386.7 16 313.1 16 224c0-65.7 36-122.9 89.3-153.2C91.5 62.1 79.2 51.4 69.3 39C61 28.7 62.6 13.6 73 5.3zM192 96l-.3 0C121.1 96.2 64 153.4 64 224c0 70.7 57.3 128 128 128s128-57.3 128-128c0-70.6-57.1-127.8-127.7-128l-.3 0z"]
};
const faUpFromBracket = {
  prefix: 'far',
  iconName: 'up-from-bracket',
  icon: [448, 512, [], "e590", "M114.2 160L224 50 333.8 160 280 160c-13.3 0-24 10.7-24 24l0 120-64 0 0-120c0-13.3-10.7-24-24-24l-53.8 0zM224 0c-11.5 0-22.5 4.6-30.6 12.7L77.6 128.8C68.9 137.5 64 149.3 64 161.6c0 25.6 20.8 46.4 46.4 46.4l33.6 0 0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96 33.6 0c25.6 0 46.4-20.8 46.4-46.4c0-12.3-4.9-24.1-13.6-32.8L254.6 12.7C246.5 4.6 235.5 0 224 0zM48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-80z"]
};
const faKnifeKitchen = {
  prefix: 'far',
  iconName: 'knife-kitchen',
  icon: [576, 512, [128298], "f6f5", "M488 0c-9.4 0-18.3 3.7-25 10.3L284.6 188.7l11.3 11.3L400.3 304.4l31-17.2c15.2-8.5 24.7-24.5 24.7-42l0-31.9c0-4.2 1.7-8.3 4.7-11.3l97-97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L513 10.3C506.3 3.7 497.4 0 488 0zM432 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM4.7 468.7c-8.4 8.4-4.7 22.9 6.5 26.6C43.4 505.7 78.1 512 112 512c123.3 0 209.4-62.8 287.3-140.7c6.2-6.2 6.2-16.4 0-22.6l-23-23-33.9 33.9C275 422.2 205.5 464 112 464c-10.7 0-21.6-.8-32.6-2.2L262 279.3l33.9-33.9L262 211.4l-33.9 33.9L4.7 468.7z"]
};
const faBorderRight = {
  prefix: 'far',
  iconName: 'border-right',
  icon: [448, 512, [], "f852", "M424 32c13.3 0 24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-400c0-13.3 10.7-24 24-24zM320 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192-32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faArrowTurnDown = {
  prefix: 'far',
  iconName: 'arrow-turn-down',
  icon: [384, 512, ["level-down"], "f149", "M24 48C10.7 48 0 37.3 0 24S10.7 0 24 0L128 0c48.6 0 88 39.4 88 88l0 342.1 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L209 505c-9.4 9.4-24.6 9.4-33.9 0L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87L168 88c0-22.1-17.9-40-40-40L24 48z"]
};
const faLevelDown = faArrowTurnDown;
const faSpade = {
  prefix: 'far',
  iconName: 'spade',
  icon: [512, 512, [9824], "f2f4", "M437.7 242.9s0 0 0 0L256.4 55 74.2 242.9c0 0 0 0 0 0c-37 38.4-34.9 102.3 6.7 138c0 0 0 0 0 0l.3 .2c32 27.9 86 25.1 120.8-10.2l19.7-20.7c9.2-9.7 22-15.1 35.4-14.9s26 5.9 35 15.8l18.3 20.2c34.3 34.4 87.3 38 121.7 9.5c40.6-35.7 42.6-99.6 5.7-138zM233.5 9.7c12-13 33-13 45.9 0L472.2 209.5c55.9 57.9 52.9 153.8-9 207.8c-50.7 42.6-122.8 39.2-173 .2c-3.5-2.7-6.9-5.6-10.2-8.7l0 55.2 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-55.3c-3.1 2.9-6.4 5.7-9.8 8.4c-50.4 39.4-123.4 43-172.5 .3c-62.9-53.9-65.9-149.8-10-207.8L233.5 9.7z"]
};
const faCardSpade = {
  prefix: 'far',
  iconName: 'card-spade',
  icon: [384, 512, [], "e3ec", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm175 77.2c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6 59.7 59.7c21.9 21.9 21.9 57.3 0 79.2s-57.3 21.9-79.2 0l-3.2-3.2c-.3-.3-.6-.6-1-.9l0 37.4 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-37.4c-.3 .3-.7 .6-1 .9l-3.2 3.2c-21.9 21.9-57.3 21.9-79.2 0s-21.9-57.3 0-79.2l59.7-59.7L175 141.2z"]
};
const faLineColumns = {
  prefix: 'far',
  iconName: 'line-columns',
  icon: [512, 512, [], "f870", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 40zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 168zM0 320c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 296c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 424zM288 192c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zM312 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L312 40zM288 320c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"]
};
const faAnt = {
  prefix: 'far',
  iconName: 'ant',
  icon: [640, 512, [], "e680", "M530.1 0c-19.7 0-37.9 10.3-48 27.2L469.6 48C413.3 49.3 368 95.4 368 152c0 15.5 3.4 30.2 9.5 43.4c-8.1-2.2-16.7-3.4-25.5-3.4c-24.5 0-46.8 9.1-63.7 24.2C270.8 169.4 225.7 136 172.8 136l-15.5 0C70.4 136 0 206.4 0 293.3C0 343.4 40.6 384 90.7 384l29.1 0L67.2 476.1c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l64-112c.7-1.3 1.3-2.6 1.8-3.9l9.4 0c5.6 0 11.1-.4 16.5-1.2l-53.3 93.3c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9L276.2 347c4.6 5.9 9.8 11.2 15.7 15.9l-.5 .8-.3 .4-64 112c-6.6 11.5-2.6 26.2 8.9 32.7s26.2 2.6 32.7-8.9l63.9-111.8 3.3-5.5c5.2 .9 10.6 1.3 16 1.3c13.6 0 26.5-2.8 38.2-7.9l39.6 39.6c3.8 3.8 6.8 8.4 8.9 13.4l27.1 67.8c4.9 12.3 18.9 18.3 31.2 13.4s18.3-18.9 13.4-31.2l-27.1-67.8c-4.4-11.1-11.1-21.1-19.5-29.5l-35.4-35.4c2.2-2.8 4.2-5.8 6.1-8.9l86.8 62c6.9 4.9 12 11.9 14.7 19.9l25.4 76.3c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-25.4-76.3c-5.9-17.6-17.2-33-32.3-43.8l-95.1-67.9-5.9-4.2 0-.2c0-13-2.6-25.5-7.3-36.8c9.9 3.1 20.4 4.8 31.3 4.8l58.7 0c42.7 0 77.3-34.6 77.3-77.3c0-56.8-36.3-105.2-86.9-123.2l2.2-3.6c1.4-2.4 4.1-3.9 6.9-3.9L584 48c13.3 0 24-10.7 24-24s-10.7-24-24-24L530.1 0zM416 152c0-30.9 25.1-56 56-56l5.3 0C523 96 560 133 560 178.7c0 16.2-13.1 29.3-29.3 29.3L472 208c-30.9 0-56-25.1-56-56zM400 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM157.3 184l15.5 0c41.5 0 75.2 33.7 75.2 75.2l0 12.8c0 35.3-28.7 64-64 64l-93.3 0C67.1 336 48 316.9 48 293.3C48 233 97 184 157.3 184zM520 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faArrowRightToLine = {
  prefix: 'far',
  iconName: 'arrow-right-to-line',
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"]
};
const faArrowToRight = faArrowRightToLine;
const faPersonFallingBurst = {
  prefix: 'far',
  iconName: 'person-falling-burst',
  icon: [640, 512, [], "e547", "M232 0c13.3 0 24 10.7 24 24l0 10.4c0 56.5-30.1 107.8-77.5 135.8L236.7 256l74.9 0c13.1 0 25.3 6.4 32.8 17.1l51.2 73.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L307.5 304l-49.6 0c-1.3 1.5-2.9 2.8-4.6 4l-53.9 36 84.8 131c7.2 11.1 4 26-7.1 33.2s-26 4-33.2-7.1L84.4 254.7C81.5 264.6 80 275 80 285.6L80 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-74.4c0-66.3 41.5-125.5 103.8-148.2c43.3-15.8 72.2-57 72.2-103.1L208 24c0-13.3 10.7-24 24-24zM173.3 303.6l26-17.3-64.8-95.5c-8.4 4.9-16.1 10.9-22.8 17.7l61.6 95.2zM0 80a48 48 0 1 1 96 0A48 48 0 1 1 0 80zM464 302.3l-33.3 24.5c-.7-1.2-1.5-2.3-2.3-3.4l-51.2-73.2c-15-21.4-39.4-34.1-65.5-34.1l-19.8 0c.5-6.2 3.4-12.1 8.2-16.3l48.6-42L323.1 98.8c-3.5-8.1-2.3-17.6 3.3-24.5s14.5-10.3 23.2-8.6l63.1 11.8 30.1-56.7C447 12.9 455.1 8 464 8s17 4.9 21.2 12.7l30.1 56.7 63.1-11.8c8.7-1.6 17.6 1.7 23.2 8.6s6.8 16.4 3.3 24.5l-25.6 58.9 48.6 42c6.7 5.8 9.7 14.8 7.7 23.5s-8.6 15.5-17.1 17.8l-62 16.7-2.5 64.2c-.3 8.9-5.6 16.8-13.6 20.7s-17.5 3-24.6-2.3l-51.7-38zm0-219.1l-17.2 32.4c-4.9 9.3-15.3 14.3-25.6 12.3l-36-6.7 14.6 33.6c4.2 9.6 1.6 20.9-6.3 27.7l-27.7 24 35.4 9.6c10.1 2.7 17.3 11.7 17.7 22.2l1.4 36.6 29.5-21.7c8.5-6.2 20-6.2 28.4 0l29.5 21.7 1.4-36.6c.4-10.5 7.6-19.5 17.7-22.2l35.4-9.6-27.7-24c-7.9-6.9-10.5-18.1-6.3-27.7l14.6-33.6-36 6.7c-10.3 1.9-20.7-3.1-25.6-12.3L464 83.2z"]
};
const faFlagPennant = {
  prefix: 'far',
  iconName: 'flag-pennant',
  icon: [448, 512, [128681, "pennant"], "f456", "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24l0 8L0 80 0 304l0 48L0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-137.1L432.9 213.4c9-3.2 15.1-11.8 15.1-21.4s-6-18.2-15.1-21.4L48 33.1 48 24zm0 60.1L350.1 192 48 299.9 48 84.1z"]
};
const faPennant = faFlagPennant;
const faConveyorBeltEmpty = {
  prefix: 'far',
  iconName: 'conveyor-belt-empty',
  icon: [640, 512, [], "e150", "M112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l416 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-416 0zM0 400c0-61.9 50.1-112 112-112l416 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-416 0C50.1 512 0 461.9 0 400zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faUserGroupSimple = {
  prefix: 'far',
  iconName: 'user-group-simple',
  icon: [640, 512, [], "e603", "M104 136a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm160 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm216 88a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM128 336l64 0c44.2 0 80 35.8 80 80l0 16L48 432l0-16c0-44.2 35.8-80 80-80zm0-48C57.3 288 0 345.3 0 416l0 16c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-16c0-70.7-57.3-128-128-128l-64 0zM448 480l64 0c70.7 0 128-57.3 128-128l0-16c0-26.5-21.5-48-48-48l-224 0c-21.8 0-40.3 14.6-46.1 34.6C340.8 348.9 352 381.1 352 416l0 16c0 1.5 0 3-.1 4.5C375.3 463.2 409.7 480 448 480z"]
};
const faAward = {
  prefix: 'far',
  iconName: 'award',
  icon: [384, 512, [], "f559", "M163.1 8.1c17.7-10.8 40-10.8 57.8 0l15.6 9.5c1.2 .7 2.7 1.1 4.1 1.1l18.3-.4c20.8-.5 40.1 10.7 50 28.9l8.8 16.1c.7 1.3 1.7 2.3 3 3L336.8 75c18.2 10 29.4 29.3 28.9 50l-.4 18.3c0 1.4 .3 2.9 1.1 4.1l9.5 15.6c10.8 17.7 10.8 40 0 57.8l-9.5 15.6c-.7 1.2-1.1 2.7-1.1 4.1l.4 18.3c.5 20.8-10.7 40.1-28.9 50l-16.1 8.8c-1.3 .7-2.3 1.7-3 3L309 336.8c-10 18.2-29.3 29.4-50 28.9l-18.3-.4c-1.4 0-2.9 .3-4.1 1.1l-15.6 9.5c-17.7 10.8-40 10.8-57.8 0l-15.6-9.5c-1.2-.7-2.7-1.1-4.1-1.1l-18.3 .4c-20.8 .5-40.1-10.7-50-28.9l-8.8-16.1c-.7-1.3-1.7-2.3-3-3L47.2 309c-18.2-10-29.4-29.3-28.9-50l.4-18.3c0-1.4-.3-2.9-1.1-4.1L8.1 220.9c-10.8-17.7-10.8-40 0-57.8l9.5-15.6c.7-1.2 1.1-2.7 1.1-4.1l-.4-18.3C17.8 104.3 29 85 47.2 75l16.1-8.8c1.3-.7 2.3-1.7 3-3L75 47.2c10-18.2 29.3-29.4 50-28.9l18.3 .4c1.4 0 2.9-.3 4.1-1.1l15.6-9.5zm32.8 41c-2.4-1.5-5.4-1.5-7.8 0l-15.6 9.5c-9.1 5.5-19.6 8.3-30.2 8.1l-18.3-.4c-2.8-.1-5.4 1.4-6.8 3.9l-8.8 16.1c-5.1 9.3-12.8 17-22.1 22.1l-16.1 8.8c-2.5 1.4-4 4-3.9 6.8l.4 18.3c.3 10.6-2.6 21.1-8.1 30.2l-9.5 15.6L28.6 175.6l20.5 12.5c-1.5 2.4-1.5 5.4 0 7.8l9.5 15.6c5.5 9.1 8.3 19.6 8.1 30.2l-.4 18.3c-.1 2.8 1.4 5.4 3.9 6.8l16.1 8.8c9.3 5.1 17 12.8 22.1 22.1l8.8 16.1c1.4 2.5 4 4 6.8 3.9l18.3-.4c10.6-.3 21.1 2.6 30.2 8.1l15.6 9.5c2.4 1.5 5.4 1.5 7.8 0l15.6-9.5c9.1-5.5 19.6-8.3 30.2-8.1l18.3 .4c2.8 .1 5.4-1.4 6.8-3.9l8.8-16.1c5.1-9.3 12.8-17 22.1-22.1l16.1-8.8c2.5-1.4 4-4 3.9-6.8l-.4-18.3c-.3-10.6 2.6-21.1 8.1-30.2l9.5-15.6c1.5-2.4 1.5-5.4 0-7.8l-9.5-15.6c-5.5-9.1-8.3-19.6-8.1-30.2l.4-18.3c.1-2.8-1.4-5.4-3.9-6.8l-16.1-8.8c-9.3-5.1-17-12.8-22.1-22.1l-8.8-16.1c-1.4-2.5-4-4-6.8-3.9l-18.3 .4c-10.6 .3-21.1-2.6-30.2-8.1l-15.6-9.5zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM1.3 441.8l41.2-97.9 4.5 8.2c15.7 28.7 46.1 46.3 78.9 45.5l11.1-.3 9.5 5.8c8 4.9 16.7 8.4 25.6 10.5l-37.3 88.5c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.7c8.9-2.1 17.5-5.6 25.5-10.5l9.5-5.8 11.1 .3c32.7 .8 63.2-16.8 78.9-45.5l4.5-8.2 41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"]
};
const faTicketSimple = {
  prefix: 'far',
  iconName: 'ticket-simple',
  icon: [576, 512, ["ticket-alt"], "f3ff", "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 60.1c0 10.2-6.4 19.2-16 22.6c-18.7 6.6-32 24.4-32 45.3s13.3 38.7 32 45.3c9.6 3.4 16 12.5 16 22.6l0 60.1c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-60.1c0-10.2 6.4-19.2 16-22.6c18.7-6.6 32-24.4 32-45.3s-13.3-38.7-32-45.3c-9.6-3.4-16-12.5-16-22.6L0 128zm64-16c-8.8 0-16 7.2-16 16l0 44.9c28.7 16.6 48 47.6 48 83.1s-19.3 66.6-48 83.1L48 384c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-44.9c-28.7-16.6-48-47.6-48-83.1s19.3-66.6 48-83.1l0-44.9c0-8.8-7.2-16-16-16L64 112z"]
};
const faTicketAlt = faTicketSimple;
const faBuilding = {
  prefix: 'far',
  iconName: 'building',
  icon: [384, 512, [127970, 61687], "f1ad", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"]
};
const faAnglesLeft = {
  prefix: 'far',
  iconName: 'angles-left',
  icon: [512, 512, [171, "angle-double-left"], "f100", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
const faAngleDoubleLeft = faAnglesLeft;
const faCamcorder = {
  prefix: 'far',
  iconName: 'camcorder',
  icon: [576, 512, [128249, "video-handheld"], "f8a8", "M96 120c0-22.1 17.9-40 40-40l160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 32c-48.6 0-88 39.4-88 88l0 42c-27.6 7.1-48 32.2-48 62L0 416c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-17 0-158 0-17c0-35.3-28.7-64-64-64L96 160l0-40zM64 208l256 0c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zM520.3 460.5c5.1 2.3 10.6 3.5 16.2 3.5c21.8 0 39.5-17.7 39.5-39.5l0-209c0-21.8-17.7-39.5-39.5-39.5c-5.6 0-11.1 1.2-16.2 3.5L416 226.4l0 52.6 112-50.4 0 182.7L416 361l0 52.6 104.3 46.9zM80 264c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24z"]
};
const faVideoHandheld = faCamcorder;
const faPancakes = {
  prefix: 'far',
  iconName: 'pancakes',
  icon: [512, 512, [129374], "e42d", "M256 192c0-17.7 14.3-31.9 32-32.6c108.6-4.4 192-31.1 192-63.4c0-35.3-100.3-64-224-64S32 60.7 32 96c0 13.8 15.3 26.6 41.3 37C86.5 138.3 96 150.6 96 164.8L96 264c0 13.3 10.7 24 24 24s24-10.7 24-24l0-76.7c0-18.8 15.8-33.2 34.4-31.2c16 1.7 29.6 15 29.6 31l0 28.9c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24zM192 80c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zM64 163.8c-12.1-4.7-23.1-10.1-32.3-16.3c-9.1-6.2-19.6-15.3-26-27.8C2 127.1 0 135.2 0 144c0 15.3 6 28.6 16.9 40C6 195.4 0 208.7 0 224s6 28.6 16.9 40C6 275.4 0 288.7 0 304s6 28.6 16.9 40C6 355.4 0 368.7 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-15.3-6-28.6-16.9-40C506 332.6 512 319.3 512 304s-6-28.6-16.9-40C506 252.6 512 239.3 512 224s-6-28.6-16.9-40C506 172.6 512 159.3 512 144c0-8.8-2-16.9-5.7-24.3c-6.3 12.4-16.9 21.6-26 27.8C465 157.7 445 165.8 423.2 172c-8.2 2.3-17 4.5-26.2 6.5c-29.9 7.1-67 11.5-109 12.9l0 24.5c0 8.4-1.9 16.5-5.2 23.6c68.3-1.9 128.5-11.1 170.1-28.6c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 264.8 324.4 272 256 272c-6.5 0-13-.1-19.3-.2c-1.6 .1-3.1 .2-4.7 .2c-2.7 0-5.3-.2-7.8-.5c-17-.6-33.1-1.7-48.3-3.2c-1.5 19.4-12.8 36-29 44.9C180 317.8 217 320 256 320c79.2 0 150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 344.8 324.4 352 256 352s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.7-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c4.9 2.1 10.2 4.1 15.6 5.9C68 287.7 64 276.3 64 264l0-23.9c-4.8-2.8-8.5-5.5-11.1-7.9c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9c1.6 .7 3.2 1.3 4.9 2l0-49.3zM59.1 371c47 19.8 117.7 29 196.9 29s150-9.2 196.9-29c2.5 1.7 4.5 3.3 6.2 4.9c4.9 4.6 4.9 6.9 4.9 8c0 0 0 .1 0 .1s0 .1 0 .1c0 1.2 0 3.4-4.9 8c-6.1 5.7-17.8 12.8-37.4 19.4C382.4 424.8 324.4 432 256 432s-126.4-7.2-165.6-20.4c-19.7-6.6-31.4-13.8-37.4-19.4c-4.9-4.6-4.9-6.9-4.9-8c0 0 0-.1 0-.1s0-.1 0-.1c0-1.2 0-3.4 4.9-8c1.6-1.5 3.7-3.2 6.2-4.9z"]
};
const faAlbumCircleUser = {
  prefix: 'far',
  iconName: 'album-circle-user',
  icon: [576, 512, [], "e48d", "M64 80l320 0c8.8 0 16 7.2 16 16l0 98.9c10.4-1.9 21.1-2.9 32-2.9c5.4 0 10.7 .2 16 .7L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l232.2 0c-11.8-14.3-21.4-30.5-28.2-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm160 32c-79.5 0-144 64.5-144 144s64.5 144 144 144c11.8 0 23.2-1.4 34.2-4.1c-1.4-9.1-2.2-18.4-2.2-27.9c0-71.4 42.5-132.9 103.6-160.5C339.7 151.8 286.5 112 224 112zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-66.3 80.7C489.5 468.1 462.2 480 432 480s-57.5-11.9-77.7-31.3c6.2-19 24-32.7 45.1-32.7l65.2 0c21 0 38.9 13.7 45.1 32.7zM384 336a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faSubtitlesSlash = {
  prefix: 'far',
  iconName: 'subtitles-slash',
  icon: [640, 512, [], "e610", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6L508.2 373c2.4-3.7 3.8-8.2 3.8-13c0-13.3-10.7-24-24-24l-27 0-67.2-52.6c4 2.9 8.9 4.6 14.2 4.6l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24c0 7.4 3.4 14 8.6 18.4L134.4 80zm353 400l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM365.5 384l-59.9-47.2C295.5 339.6 288 348.9 288 360c0 13.3 10.7 24 24 24l53.5 0zM243.7 288l-60.9-48L152 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l91.7 0zM152 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"]
};
const faQrcode = {
  prefix: 'far',
  iconName: 'qrcode',
  icon: [448, 512, [], "f029", "M144 80l0 96-96 0 0-96 96 0zM48 32C21.5 32 0 53.5 0 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48L48 32zm96 304l0 96-96 0 0-96 96 0zM48 288c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0zM304 80l96 0 0 96-96 0 0-96zm-48 0l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM72 120l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM328 120l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM256 304l0 160c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16s7.2 16 16 16l64 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zM368 448a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm64 0a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
const faDiceD10 = {
  prefix: 'far',
  iconName: 'dice-d10',
  icon: [512, 512, [], "f6cd", "M256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2L238 8.2C242.5 3 249.1 0 256 0zM91.6 247.4l50.9-12 36-86.9L91.6 247.4zM256 86.8L189.7 247 256 291.2 322.3 247 256 86.8zm100.6 195L280 332.8l0 102.8 156.7-135-80-18.8zm63.8-34.3l-86.9-98.9 36 86.9 50.9 12zM232 435.6l0-102.8-76.6-51.1-80 18.8L232 435.6z"]
};
const faFireplace = {
  prefix: 'far',
  iconName: 'fireplace',
  icon: [640, 512, [], "f79a", "M48 48l544 0 0 32L48 80l0-32zM32 0C14.3 0 0 14.3 0 32L0 96c0 17.7 14.3 32 32 32l0 360c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-120c0-88.4 71.6-160 160-160s160 71.6 160 160l0 120c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-360c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L32 0zM80 464l0-336 480 0 0 336-32 0 0-96c0-114.9-93.1-208-208-208s-208 93.1-208 208l0 96-32 0zM338 299.4l-13.3-14c-1.4-1.5-2.8-3.1-4.2-4.7c0 0 0 0 0 0c-6.3-7.2-13.1-14.9-22.9-15.1c-5.1-.1-10.2 1.6-14.2 5.3c-16.4 14.8-35 34.2-49.6 56.1c-14.5 21.8-25.8 47-25.8 73.1c0 62 49.3 111.9 112 111.9c62.1 0 112-49.8 112-111.9c0-21-7.7-42.6-18.3-61.7C403 319.3 389 301.8 375.2 289c-3.9-3.6-8.9-5.5-13.9-5.5c-5.3 0-10.9 2-14.6 6.2l-8.6 9.7zm26.8 134.3c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8c0-25.6 25.9-51.1 38.3-61.9c3.8-3.3 9.2-3.3 12.9 0c12.4 10.8 38.3 36.3 38.3 61.9z"]
};
const faBrowser = {
  prefix: 'far',
  iconName: 'browser',
  icon: [512, 512, [128468], "f37e", "M.3 89.5C.1 91.6 0 93.8 0 96l0 64L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256 0-64c0-35.3-28.7-64-64-64L64 32c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 160l416 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-256z"]
};
const faPenPaintbrush = {
  prefix: 'far',
  iconName: 'pen-paintbrush',
  icon: [576, 512, ["pencil-paintbrush"], "f618", "M68.4 360.9L45.4 439 33 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L105 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8L524.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L485.3 19.3c-25-25-65.5-25-90.5 0L90.6 323.5c-10.4 10.4-18 23.3-22.2 37.4zm46 13.5c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8L353 129 415 191 186.6 419.5c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9L91.4 452.6l16.1-54.8 6.9-23.4zm170.2 71.4C304.4 485.1 345 512 391.9 512l152 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-6 0c-18.1 0-30.1-19.8-27.4-37.6c.9-6 1.4-12.1 1.4-18.4c0-46.9-26.9-87.5-66.1-107.3l-37.2 37.2c31.7 7.5 55.3 36 55.3 70.1c0 3.8-.3 7.5-.8 11.1c-3.3 21.4 2.2 43.1 13.8 60l.7 .9-85.6 0c-34 0-62.5-23.6-70.1-55.3l-37.2 37.2zM136 24C105.1-6.9 54.9-6.9 24 24S-6.9 105.1 24 136l98.7 98.7 33.9-33.9L57.9 102.1c-12.2-12.2-12.2-31.9 0-44.1s31.9-12.2 44.1 0l98.7 98.7 33.9-33.9L136 24z"]
};
const faPencilPaintbrush = faPenPaintbrush;
const faFishCooked = {
  prefix: 'far',
  iconName: 'fish-cooked',
  icon: [576, 512, [], "f7fe", "M150 203.2c19.9-22.7 47.5-45.8 78-63.1c30.7-17.4 62.8-28.1 92-28.1c44.8 0 97.6 25.1 140.5 58.9c21.1 16.6 38.7 34.5 50.7 50.7C524 238.8 528 250.7 528 256s-4 17.2-16.8 34.4c-12.1 16.2-29.6 34.1-50.7 50.7C417.6 374.9 364.8 400 320 400c-29.1 0-61.2-10.6-91.8-28c-30.5-17.3-58.1-40.3-78-63c-8.3-9.4-22.4-10.9-32.4-3.4L58.5 350.1l19.1-81.3c2-8.4 2-17.2 0-25.7L58.9 163.6l58.8 43.1c10 7.4 24 5.8 32.2-3.5zM320 64c-40.2 0-80.5 14.4-115.7 34.3c-28.2 16-54.1 36.1-75.3 57.2L56.8 102.6C51 98.3 43.9 96 36.7 96c-22 0-38.2 20.5-33.2 41.9L30.9 254.2c.3 1.2 .3 2.5 0 3.7L1.7 382.2c-2.5 10.8 .7 22.1 8.5 29.9l17-17-17 17c11.2 11.2 29 12.5 41.8 3l77.5-58.1c21.2 20.9 47 41 75.1 56.9C239.6 433.7 279.9 448 320 448c60.2 0 123.4-32.2 170.2-69.1c23.8-18.7 44.5-39.5 59.6-59.8C564.1 299.8 576 277.4 576 256s-11.9-43.8-26.2-63.1c-15-20.3-35.8-41.1-59.6-59.8C443.4 96.2 380.2 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"]
};
const faChairOffice = {
  prefix: 'far',
  iconName: 'chair-office',
  icon: [448, 512, [], "f6c1", "M288 48c8.8 0 16 7.2 16 16l0 160 48 0 0-160c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 160 48 0 0-160c0-8.8 7.2-16 16-16l128 0zM64 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zm368 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zM248 400l122.5 0c25.2 0 45.5-20.4 45.5-45.5c0-5.5-1-10.9-2.9-16l-19.2-51.3c-7-18.7-24.9-31.1-44.9-31.1L99.1 256c-20 0-37.9 12.4-44.9 31.1L34.9 338.5C33 343.6 32 349 32 354.5C32 379.6 52.4 400 77.5 400L200 400l0 64-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-64zM99.1 304l249.8 0 18 48L224 352 81.1 352l18-48z"]
};
const faMagnifyingGlassMusic = {
  prefix: 'far',
  iconName: 'magnifying-glass-music',
  icon: [512, 512, [], "e65f", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1zM271.6 158.8c12.6-4.2 19.4-17.8 15.2-30.4s-17.8-19.4-30.4-15.2l-48 16c-9.8 3.3-16.4 12.4-16.4 22.8l0 57.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c35.3 0 63.9-21.4 64-47.9c0 0 0-.1 0-.1c0 0 0 0 0 0l0-86.7 31.6-10.5z"]
};
const faNestingDolls = {
  prefix: 'far',
  iconName: 'nesting-dolls',
  icon: [640, 512, [], "e3ba", "M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112l0 112L80 224l0-112zM200.7 64.9c-4.1-5.3-13.2-5.3-17.3 0c-11.7 15.1-28.7 26-48.2 29.7c-4 .8-7.2 4.2-6.8 8.2c1.5 14 7.6 27.7 18.4 38.5c25 25 65.5 25 90.5 0c10.8-10.8 16.9-24.4 18.4-38.5c.4-4.1-2.7-7.5-6.8-8.2c-19.5-3.7-36.5-14.6-48.2-29.7zM635.5 474.1c5.2 7.3 5.9 16.9 1.8 24.9s-12.4 13-21.3 13l-304 0c-9 0-17.2-5-21.3-13c-4.1-8-3.4-17.6 1.8-24.9c0 0 0 0 0 0l.2-.3c.2-.3 .6-.8 1-1.5c.9-1.4 2.3-3.5 4-6.3c3.4-5.6 7.9-13.8 12.5-23.8c9.2-20.3 17.8-46.8 17.8-74.1l0-8c0-75.1 60.9-136 136-136s136 60.9 136 136l0 8c0 27.3 8.6 53.7 17.8 74.1c4.6 10 9.1 18.2 12.5 23.8c1.7 2.8 3.1 5 4 6.3c.5 .7 .8 1.2 1 1.5l.2 .3s0 0 0 0s0 0 0 0zM455.3 320.9C440.7 339.8 417.8 352 392 352c-4.3 0-8 3.3-7.6 7.6c1.7 17.9 9.4 35.3 23.1 49c31.2 31.2 81.9 31.2 113.1 0c13.7-13.7 21.4-31.1 23.1-49c.4-4.3-3.3-7.6-7.6-7.6c-25.8 0-48.7-12.2-63.3-31.1c-4.1-5.3-13.2-5.3-17.3 0zM261.4 464c-7.1 15.1-7.3 32.7 0 48L74.5 512c-17 0-33.4-6.7-42.7-20.9C17.9 469.7 0 432.8 0 384c0-44.4 20.2-84.4 37.9-119.4c2.7-5.3 8.1-8.6 14-8.6l280.2 0c-11.3 14.3-20.3 30.5-26.5 48L71.9 304C57.9 332.9 48 358 48 384c0 35.9 12.8 63.3 23.2 79.6c.2 0 .4 .1 .6 .1c.7 .1 1.6 .3 2.7 .3l186.9 0z"]
};
const faClockRotateLeft = {
  prefix: 'far',
  iconName: 'clock-rotate-left',
  icon: [512, 512, ["history"], "f1da", "M48 106.7L48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 168c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.3 0c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"]
};
const faHistory = faClockRotateLeft;
const faTrumpet = {
  prefix: 'far',
  iconName: 'trumpet',
  icon: [640, 512, [127930], "f8e3", "M592 128.7l0 222.7c-10-10.5-21.8-22-35.2-33.2C519.9 287.4 467.9 256 408 256l-50.6 0L168 256 48 256l0-32 360 0c59.9 0 111.9-31.4 148.8-62.2c13.4-11.2 25.2-22.6 35.2-33.2zM352 304l0 112-40 0 0-112 40 0zm48 112l0-112 8 0c43.4 0 84.6 23.1 118 51c33 27.6 55.5 57.3 61 64.9c5.7 7.9 14.6 12.1 23.7 12.1c16.2 0 29.2-13.1 29.2-29.2l0-325.5C640 61.1 626.9 48 610.8 48c-9.1 0-18.1 4.2-23.7 12.1c-5.5 7.6-27.9 37.3-61 64.9c-33.4 27.9-74.6 51-118 51l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-40 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-40 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L48 176l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32 0 80 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 32.3 0C70 320.2 64 339.4 64 360c0 57.4 46.6 104 104 104l32 0 88 0 88 0 32 0c49.6 0 91-34.7 101.5-81.1c-1.3-1.1-2.6-2.2-3.9-3.3c-13.7-11.4-27.9-21.2-42.3-28.6c.5 2.9 .7 5.9 .7 9c0 30.9-25.1 56-56 56l-8 0zm-136 0l-40 0 0-112 40 0 0 112zm-88 0l-8 0c-30.9 0-56-25.1-56-56s25.1-56 56-56l8 0 0 112z"]
};
const faFaceGrinBeamSweat = {
  prefix: 'far',
  iconName: 'face-grin-beam-sweat',
  icon: [512, 512, [128517, "grin-beam-sweat"], "f583", "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8s0 0 0 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0zm160 0s0 0 0 0s0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8c0 0 0 0 0 0s0 0 0 0c0 0 0 0 0 0l.2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2c0 0 0 0 0 0c0 0 0 0 0 0z"]
};
const faGrinBeamSweat = faFaceGrinBeamSweat;
const faFireSmoke = {
  prefix: 'far',
  iconName: 'fire-smoke',
  icon: [640, 512, [], "f74b", "M293.5 3.8c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6c0 19.8 3.6 38.8 10.1 56.3c9.6 3.3 18.7 7.6 27.3 12.7c12.7-13.6 27.6-25 44.2-33.8c-1.1-5.5-1.6-11.3-1.6-17.4c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c8.6 15.8 11.3 33.7 8.4 50.4c16.6 8.8 31.5 20.2 44.2 33.8c8.5-5.1 17.6-9.3 27.1-12.6C476.4 231 480 212 480 192.2c0-20.2-9.6-50.9-24.2-79C441.1 84.7 420.2 54.7 395.5 32c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM233.2 361.3c7-41.6 43.2-73.3 86.8-73.3s79.8 31.7 86.8 73.3c1.8 10.7 10.5 18.8 21.2 19.9s20.9-5.1 24.8-15.2c10.4-27 36.6-46 67.2-46c39.8 0 72 32.2 72 72c0 37.7-29 68.7-66 71.8c-.7 .1-1.3 .1-2 .2l-4 0-200 0-200 0-4 0c-.7-.1-1.3-.2-2-.2c-36.9-3-66-34-66-71.8c0-39.8 32.2-72 72-72c30.6 0 56.7 19 67.2 46c3.9 10.1 14.1 16.3 24.8 15.2s19.4-9.2 21.2-19.9zM320 240c-49.4 0-92.7 26.4-116.5 65.8c-21.6-20.9-51-33.8-83.5-33.8C53.7 272 0 325.7 0 392c0 61.4 46.1 112 105.6 119.1c2 .6 4.2 .9 6.4 .9l8 0 200 0 200 0 8 0c2.2 0 4.3-.3 6.4-.9C593.9 504 640 453.4 640 392c0-66.3-53.7-120-120-120c-32.5 0-61.9 12.9-83.5 33.8C412.7 266.4 369.4 240 320 240z"]
};
const faPhoneMissed = {
  prefix: 'far',
  iconName: 'phone-missed',
  icon: [640, 512, [], "e226", "M120 0L232 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-54.1 0 55.4 55.4C254.2 124.3 282.5 136 312 136s57.8-11.7 78.6-32.6L487 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96.4 96.4C394.7 167.2 354.2 184 312 184s-82.7-16.8-112.6-46.6L144 81.9l0 54.1c0 13.3-10.7 24-24 24s-24-10.7-24-24L96 24c0-13.3 10.7-24 24-24zM448 392l0 49.3c0 3.9 2.8 7.2 6.6 7.9l85.8 15.6c3.7 .7 7.4-1.3 8.8-4.8l24.7-58.8c7.4-17.6 2.5-30.9-4.4-36.9C520 321.8 432.8 272 320 272s-200 49.8-249.5 92.3c-6.9 5.9-11.8 19.3-4.4 36.9L90.8 460c1.5 3.5 5.1 5.4 8.8 4.8l85.8-15.6c3.8-.7 6.6-4 6.6-7.9l0-49.3c0-19.6 11.9-37.3 30.2-44.6c62.8-25.1 132.9-25.1 195.7 0C436 354.7 448 372.4 448 392zm-48 49.3l0-49.3c-51.4-20.5-108.6-20.5-160 0l0 49.3c0 27.1-19.4 50.3-46 55.1L108.2 512c-25.8 4.7-51.4-9.2-61.6-33.4L21.8 419.8c-13.5-32-8.9-69.3 17.4-91.9C95 280 192.9 224 320 224s225 56 280.8 103.9c26.3 22.6 30.9 59.9 17.4 91.9l-24.8 58.8c-10.2 24.2-35.8 38.1-61.6 33.4L446 496.4c-26.6-4.8-46-28-46-55.1z"]
};
const faFileExport = {
  prefix: 'far',
  iconName: 'file-export',
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M336 448c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 96 48 0 0-101.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-80-48 0 0 80zM489 215c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L216 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l278.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
const faArrowRightFromFile = faFileExport;
const faShield = {
  prefix: 'far',
  iconName: 'shield',
  icon: [512, 512, [128737, "shield-blank"], "f132", "M256 49.4L73 127c-5.9 2.5-9.1 7.8-9 12.8c.5 91.4 38.4 249.3 186.4 320.1c3.6 1.7 7.8 1.7 11.3 0C409.7 389 447.6 231.2 448 139.7c0-5-3.1-10.2-9-12.8L256 49.4zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"]
};
const faShieldBlank = faShield;
const faArrowUpShortWide = {
  prefix: 'far',
  iconName: 'arrow-up-short-wide',
  icon: [576, 512, ["sort-amount-up-alt"], "f885", "M111 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L152 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L49 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zm201 9l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l240 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faSortAmountUpAlt = faArrowUpShortWide;
const faArrowsRepeat1 = {
  prefix: 'far',
  iconName: 'arrows-repeat-1',
  icon: [512, 512, ["repeat-1-alt"], "f366", "M22.5 280C9.3 279.1-.8 267.7 0 254.5l.5-8C5.6 166.4 72 104 152.2 104l213.8 0L311 49c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l96 96c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8l-271.8 0c-54.9 0-100.4 42.7-103.8 97.5l-.5 8c-.8 13.2-12.2 23.3-25.5 22.5zm467-47.9c13.2 .8 23.3 12.2 22.5 25.5l-.5 8C506.4 345.6 440 408 359.8 408l-213.8 0 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 401c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8l271.8 0c54.9 0 100.4-42.7 103.8-97.5l.5-8c.8-13.2 12.2-23.3 25.4-22.5zM288 216l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c-10 0-19.4-6.4-22.8-16.4c-4.2-12.6 2.6-26.2 15.2-30.4l24-8c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5z"]
};
const faRepeat1Alt = faArrowsRepeat1;
const faGunSlash = {
  prefix: 'far',
  iconName: 'gun-slash',
  icon: [640, 512, [], "e19c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L412.3 297.8 432.9 240l32.5 0c10.6 0 20.8-4.2 28.3-11.7L513.9 208l54.1 0c22.1 0 40-17.9 40-40l0-64c0-22.1-17.9-40-40-40l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8L113.9 64 38.8 5.1zM175.2 112L536 112l24 0 0 48-49.4 0c-10.6 0-20.8 4.2-28.3 11.7L462.1 192l-163 0-21.8 0L175.2 112zM338.5 240l43.4 0-9.5 26.6L338.5 240zM80 192l0-33L32 121.2 32 200c0 22.1 17.9 40 40 40l2 0c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480l112 0c14.7 0 27.5-10 31-24.2L265 352l59.9 0-91.4-72-38 152-79 0 35.1-140.6c4.5-18.1 2.5-35.9-4.3-51.4l35.4 0-60.9-48-21.1 0L80 192z"]
};
const faAvocado = {
  prefix: 'far',
  iconName: 'avocado',
  icon: [512, 512, [], "e0aa", "M464 144c0 29.9-13.6 56.5-35.1 74.2c-24.2 19.9-47.3 49.3-54.7 86.9c-8.9 45.7-29.5 88.5-53.1 112c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c23.6-23.6 66.3-44.2 112-53.1c37.6-7.4 67-30.4 86.9-54.7C311.5 61.6 338.1 48 368 48c53 0 96 43 96 96zM421.3 314.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144C512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6c-15.2 18.5-35.6 33.5-59.1 38.1c-51.9 10.2-104.5 34-136.7 66.3c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zM283.2 347.2c41.7-41.7 49.1-102.1 16.4-134.8s-93-25.3-134.8 16.4s-49.1 102.1-16.4 134.8s93 25.3 134.8-16.4z"]
};
const faBinary = {
  prefix: 'far',
  iconName: 'binary',
  icon: [384, 512, [], "e33b", "M328 24l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C251 67 237.4 60.2 233.2 47.6S235.8 21.4 248.4 17.2l48-16C303.7-1.2 311.8 0 318 4.5S328 16.3 328 24zM104 312l0 152 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-118.7-16.4 5.5C27 355 13.4 348.2 9.2 335.6S11.8 309.4 24.4 305.2l48-16c7.3-2.4 15.4-1.2 21.6 3.3s10 11.8 10 19.5zM0 72C0 32.2 32.2 0 72 0l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72L0 72zM72 48C58.7 48 48 58.7 48 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24L72 48zM264 288l48 0c39.8 0 72 32.2 72 72l0 80c0 39.8-32.2 72-72 72l-48 0c-39.8 0-72-32.2-72-72l0-80c0-39.8 32.2-72 72-72zm-24 72l0 80c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24z"]
};
const faCommentNodes = {
  prefix: 'far',
  iconName: 'comment-nodes',
  icon: [640, 512, [], "e696", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160c101 0 174.9 52.8 199.3 115.2c7.9-2.1 16.2-3.2 24.7-3.2c9.1 0 17.8 1.3 26.2 3.6C481.1 102.1 378.6 32 256 32C114.6 32 0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c10.8 0 21.5-.5 32-1.6c.3-15.8 4.4-31.7 12.9-46.4c.8-1.4 1.6-2.7 2.5-4.1c-15 2.6-30.8 4.1-47.4 4.1c-31.6 0-61.3-5.5-87.8-15.1zM328.6 416c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8c17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5c-25-3.4-50.6 8.3-64 31.4z"]
};
const faGlassesRound = {
  prefix: 'far',
  iconName: 'glasses-round',
  icon: [576, 512, [128083, "glasses-alt"], "f5f5", "M118.6 80c-11.5 0-21.4 7.9-24 19.1L64.4 228.3C85.2 215.4 109.7 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c26.3 0 50.8 7.4 71.6 20.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l40.5 173.7c4.9 20.9 7.3 42.2 7.3 63.6l0 10.5c0 .8 0 1.6-.1 2.4c.1 1.9 .1 3.8 .1 5.6c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0-1.9 0-3.8 .1-5.6c-.1-.8-.1-1.6-.1-2.4l0-10.5c0-21.4 2.5-42.8 7.3-63.6L47.9 88.2C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM136 432a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm392-88a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
};
const faGlassesAlt = faGlassesRound;
const faPhonePlus = {
  prefix: 'far',
  iconName: 'phone-plus',
  icon: [576, 512, [], "f4d2", "M424 200l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24zm-63 86.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6c0 0 0 0 0 0c-6.1 0-12.2-.1-18.2-.4c0 0-.1 0-.1 0c0 0 0 0 0 0c-10-.4-19.8-1.1-29.6-2.2C207.2 485.6 32 295.2 32 64c0 0 0 0 0 0c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1L361 286.7zm133.8 78.1l-100.4-43L365 357.6c-14.9 18.2-40.8 22.9-61.2 11.1c-53.3-30.9-97.7-75.3-128.6-128.6c-11.8-20.4-7.1-46.3 11.1-61.2l35.9-29.4-43-100.4L80.1 70.5C83.5 286.2 257.8 460.5 473.5 464l21.3-99.2z"]
};
const faDitto = {
  prefix: 'far',
  iconName: 'ditto',
  icon: [320, 512, [], "22", "M48 105.9c0 1.4 .1 2.8 .4 4.3L72 252 95.6 110.1s0 0 0 0c.2-1.4 .4-2.8 .4-4.3l0-1.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.9zm96 0c0 4.1-.3 8.1-1 12.1L118.6 264.5C114.8 287.3 95.1 304 72 304s-42.8-16.7-46.6-39.5L1 118c-.7-4-1-8.1-1-12.1L0 104C0 64.2 32.2 32 72 32s72 32.2 72 72l0 1.9zm80 0c0 1.4 .1 2.8 .4 4.3L248 252l23.6-141.9c.2-1.4 .4-2.8 .4-4.3l0-1.9c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 1.9zm96 0c0 4.1-.3 8.1-1 12.1L294.6 264.5C290.8 287.3 271.1 304 248 304s-42.8-16.7-46.6-39.5L177 118c-.7-4-1-8.1-1-12.1l0-1.9c0-39.8 32.2-72 72-72s72 32.2 72 72l0 1.9z"]
};
const faPersonSeat = {
  prefix: 'far',
  iconName: 'person-seat',
  icon: [384, 512, [], "e21e", "M144 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 92c0-6.6 5.4-12 12-12s12 5.4 12 12l0 92-16 0c-4.4 0-8-3.6-8-8l0-84zm72 92l0-56 56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-57.2 0c-5.6-27.4-29.8-48-58.8-48c-33.1 0-60 26.9-60 60l0 84c0 30.9 25.1 56 56 56l40 0 54 0c12 0 22.2 8.9 23.8 20.8l10.4 78.3C273.8 471.1 284 480 296 480l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-43 0-7.7-57.5C304.6 338.7 274.1 312 238 312l-30 0zM48 152c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 328c0 66.3 53.7 120 120 120l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-39.8 0-72-32.2-72-72l0-176z"]
};
const faHouseMedical = {
  prefix: 'far',
  iconName: 'house-medical',
  icon: [576, 512, [], "e3b2", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0l264 224c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM288 55.5L112 204.8 112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5zM256 208c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48z"]
};
const faGolfBallTee = {
  prefix: 'far',
  iconName: 'golf-ball-tee',
  icon: [384, 512, ["golf-ball"], "f450", "M336 192c0 55.7-31.7 104.1-78 128l77.1 0c30.4-34 48.9-78.8 48.9-128C384 86 298 0 192 0S0 86 0 192c0 49.2 18.5 94 48.9 128l77.1 0c-46.3-23.9-78-72.3-78-128c0-79.5 64.5-144 144-144s144 64.5 144 144zM226.1 248.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM64 376c0 13.3 10.7 24 24 24l64 0c8.8 0 16 7.2 16 16l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72c0-8.8 7.2-16 16-16l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 352c-13.3 0-24 10.7-24 24z"]
};
const faGolfBall = faGolfBallTee;
const faCircleChevronLeft = {
  prefix: 'far',
  iconName: 'circle-chevron-left',
  icon: [512, 512, ["chevron-circle-left"], "f137", "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135L167 239c-9.4 9.4-9.4 24.6 0 33.9L271 377c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87-87 87-87c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
};
const faChevronCircleLeft = faCircleChevronLeft;
const faHouseChimneyWindow = {
  prefix: 'far',
  iconName: 'house-chimney-window',
  icon: [576, 512, [], "e00d", "M272.5 5.7c9-7.6 22.1-7.6 31.1 0L464 141.9 464 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 126.6 55.5 47.1c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.3-33.8 2.8L512 245.5 512 432c0 44.2-35.8 80-80 80l-288 0c-44.2 0-80-35.8-80-80l0-186.5L39.5 266.3c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l264-224zM112 204.8L112 432c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-227.2L288 55.5 112 204.8zM256 288l64 0 0-64-64 0 0 64zm-48-72c0-22.1 17.9-40 40-40l80 0c22.1 0 40 17.9 40 40l0 80c0 22.1-17.9 40-40 40l-80 0c-22.1 0-40-17.9-40-40l0-80z"]
};
const faScythe = {
  prefix: 'far',
  iconName: 'scythe',
  icon: [640, 512, [], "f710", "M639.5 28.9c2.7-13-5.7-25.7-18.6-28.4s-25.7 5.7-28.4 18.6L536.9 288 408 288c-13.3 0-24 10.7-24 24s10.7 24 24 24l118.9 0L496.5 483.1c-2.7 13 5.7 25.7 18.6 28.4s25.7-5.7 28.4-18.6l96-464zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224l491.5 0 9.9-48L68.7 176C108.6 126.8 196.8 48 352 48l201.8 0 7.3-35.3c.9-4.5 2.4-8.7 4.2-12.7L352 0z"]
};
const faPenNib = {
  prefix: 'far',
  iconName: 'pen-nib',
  icon: [512, 512, [10001], "f5ad", "M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71L412.2 225 371.6 374.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440L99.8 175.9c6.1-17.4 20.3-30.6 38.1-35.5L287 99.8l10.4-10.4 71-71zM296.9 146.8L150.5 186.7c-2.5 .7-4.6 2.6-5.4 5.1L62.5 426.9 164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L85.1 449.5l235.1-82.6c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z"]
};
const faBanParking = {
  prefix: 'far',
  iconName: 'ban-parking',
  icon: [512, 512, ["parking-circle-slash"], "f616", "M256 464C141.1 464 48 370.9 48 256c0-48.8 16.8-93.7 44.9-129.1L385.1 419.1C349.7 447.2 304.8 464 256 464zm80-162c24.2-17.4 40-45.9 40-78c0-53-43-96-96-96l-80 0c-10.4 0-19.6 4.9-25.5 12.6L126.9 92.9C162.3 64.8 207.2 48 256 48c114.9 0 208 93.1 208 208c0 48.8-16.8 93.7-44.9 129.1L336 302zm-120-120l0-6.1 64 0c26.5 0 48 21.5 48 48c0 18.9-11 35.3-26.9 43.1L216 182.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 265.9l0 30.1 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 6.1 0L168 265.9z"]
};
const faParkingCircleSlash = faBanParking;
const faTentArrowTurnLeft = {
  prefix: 'far',
  iconName: 'tent-arrow-turn-left',
  icon: [576, 512, [], "e580", "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z"]
};
const faFaceDiagonalMouth = {
  prefix: 'far',
  iconName: 'face-diagonal-mouth',
  icon: [512, 512, [129764], "e47e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm358.1 79.2l-184 48c-12.8 3.3-25.9-4.3-29.3-17.2s4.3-25.9 17.2-29.3l184-48c12.8-3.3 25.9 4.3 29.3 17.2s-4.3 25.9-17.2 29.3zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faDiagramCells = {
  prefix: 'far',
  iconName: 'diagram-cells',
  icon: [512, 512, [], "e475", "M448 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l384 0zm16 128l0 64c0 8.8-7.2 16-16 16l-80 0-224 0-80 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16zm48 64l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64z"]
};
const faCricketBatBall = {
  prefix: 'far',
  iconName: 'cricket-bat-ball',
  icon: [512, 512, [127951, "cricket"], "f449", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143-24.4-24.4c-21.9-21.9-57.3-21.9-79.2 0L16.1 334C6.1 344-.6 358.4 .5 374.4c.8 11.3 2.8 28.6 8.2 46.4C13.8 438.1 22.9 457.9 39 473c15 16.2 34.9 25.2 52.2 30.4c17.8 5.4 35.1 7.4 46.4 8.2c16 1.1 30.4-5.6 40.4-15.6L386.3 287.6c21.9-21.9 21.9-57.3 0-79.2L361.9 184 505 41zM269.7 159.6l41.2 41.2 .2 .2 .2 .2 41.2 41.2c3.1 3.1 3.1 8.2 0 11.3L318.1 288 232 288c-4.4 0-8-3.6-8-8l0-86.1 34.3-34.3c3.1-3.1 8.2-3.1 11.3 0zM176 241.9l0 38.1c0 30.9 25.1 56 56 56l38.1 0-126 126c-.7 .7-1.5 1.2-2.1 1.5c-.5 .2-.8 .2-1.1 .2c-9.3-.6-22.6-2.2-35.7-6.2s-24-9.7-30.9-17.2c-.8-.8-1.6-1.7-2.4-2.4c-7.5-6.9-13.2-17.8-17.2-30.9s-5.6-26.5-6.2-35.7c0-.3 0-.6 .2-1.1c.2-.6 .7-1.4 1.5-2.1l126-126zM400 432a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faCricket = faCricketBatBall;
const faTents = {
  prefix: 'far',
  iconName: 'tents',
  icon: [640, 512, [], "e582", "M430.1 4.6c-8.4-6.1-19.8-6.1-28.2 0l-165 120c-1.7 1.2-3.3 2.6-4.8 4c10.9 1.4 21.5 5.6 30.7 12.6l16.1 12.3L416 53.7 566.8 163.4c1.8 1.3 2.9 3.2 3.2 5.4l17.2 126.1c.7 4.8-3.1 9.1-7.9 9.1L454 304c.6 2.1 1 4.3 1.3 6.5l6.2 41.5 117.8 0c33.9 0 60.1-29.9 55.5-63.6L617.6 162.3c-2.1-15.1-10.2-28.7-22.6-37.7l-165-120zM238.7 165c-8.6-6.7-20.7-6.7-29.3 0L43.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L5.5 448.1C.6 481.8 26.8 512 60.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L425.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L238.7 165zM73 331l127-98.2L200 464 60.9 464c-4.9 0-8.6-4.3-7.9-9.1L69.9 336.2c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L375 331c1.6 1.3 2.7 3.1 3 5.2L395 454.9c.7 4.8-3 9.1-7.9 9.1l-76.7 0L248 360z"]
};
const faWandMagic = {
  prefix: 'far',
  iconName: 'wand-magic',
  icon: [512, 512, ["magic"], "f0d0", "M319.7 157.7l34.6 34.6L464 82.6 429.4 48 319.7 157.7zm-33.9 33.9L48 429.4 82.6 464 320.3 226.2l-34.6-34.6zM14.1 395.4L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9z"]
};
const faMagic = faWandMagic;
const faDog = {
  prefix: 'far',
  iconName: 'dog',
  icon: [576, 512, [128021], "f6d3", "M318 342.2c11.4 9.1 18 22.9 18 37.4l0 68.4c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-173.7L300.5 223c-3.2 .7-6.5 1-9.9 1L144 224l-31.9 0-.1 .8L112 448c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-68.4c0-14.6 6.6-28.3 18-37.4s26.2-12.6 40.4-9.4c9.5 2.1 19.4 3.2 29.6 3.2s20.1-1.1 29.6-3.2c14.2-3.1 29.1 .3 40.4 9.4zM336.9 189l53.4 32.8c7.2-17.7 24.6-29.8 44.4-29.8l45.3 0c26.5 0 48-21.5 48-48l0-32-32 0c-12.7 0-24.9-5.1-33.9-14.1L444.1 80 368 80c-4.2 0-8.4-.6-12.4-1.6L338 183.9c-.3 1.7-.7 3.4-1.1 5.1zM64.2 220.2c-1.1-.3-2.2-.7-3.3-1.1c-27.4-9.6-49-32.4-56.4-61.8L.7 141.8c-3.2-12.9 4.6-25.9 17.5-29.1s25.9 4.6 29.1 17.5c0 0 0 0 0 0l3.9 15.5C55.6 163.5 71.6 176 90 176l54 0 146.7 0L313.5 39.3l.1-.4 .9-5.6 3.1-18.4C319 6.3 326.4 0 335.1 0c5.6 0 10.9 2.6 14.3 7.1l11.2 14.9 3.4 4.6 .2 .3L368 32l76.1 0c12.7 0 24.9 5.1 33.9 14.1L496 64l32 0c26.5 0 48 21.5 48 48l0 32c0 53-43 96-96 96l-45.3 0L432 256l0 192c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-19.4 0-48.9c-10.4 2.3-21.1 3.7-32 4.2c-2.7 .1-5.3 .2-8 .2s-5.3-.1-8-.2c-10.9-.5-21.6-1.9-32-4.2l0 48.9 0 19.4c0 35.3-28.7 64-64 64l-16 0c-35.3 0-64-28.7-64-64l0-224c0-1.3 .1-2.6 .2-3.8zM416 112a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faPenLine = {
  prefix: 'far',
  iconName: 'pen-line',
  icon: [576, 512, [], "e212", "M13.4 439l23-78.1c4.2-14.1 11.8-27 22.2-37.4L362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c3.1 3.1 5.9 6.5 8.2 10c16.4 24.8 13.7 58.6-8.2 80.5L188.5 453.4c-1.3 1.3-2.6 2.6-4 3.8c-9.6 8.5-21 14.8-33.4 18.4L73 498.6 30.8 511c-8.4 2.5-17.5 .2-23.7-6.1S-1.5 489.7 1 481.2L13.4 439zm62.2-41.2L59.4 452.6l54.8-16.1 23.4-6.9c6.4-1.9 12.3-5.4 17-10.1L383 191 321 129 92.5 357.4c-.6 .6-1.2 1.2-1.7 1.8c-3.9 4.4-6.7 9.6-8.4 15.2l-6.9 23.4zM248 464l304 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faAtomSimple = {
  prefix: 'far',
  iconName: 'atom-simple',
  icon: [512, 512, ["atom-alt"], "f5d3", "M89.6 422.4c7.9 7.9 31.4 16.9 80.4 .6c13.2-4.4 27.2-10.4 41.6-17.9c-18.9-14.4-37.7-30.8-55.8-48.9s-34.5-36.9-48.9-55.8c-7.5 14.4-13.5 28.4-17.9 41.6c-16.3 49-7.3 72.5 .6 80.4zM76.8 256C27.6 173.9 16.5 94.9 55.7 55.7S173.9 27.6 256 76.8c82.1-49.2 161.1-60.3 200.3-21.1s28.1 118.2-21.1 200.3c49.2 82.1 60.3 161.1 21.1 200.3s-118.2 28.1-200.3-21.1c-82.1 49.2-161.1 60.3-200.3 21.1S27.6 338.1 76.8 256zM107 211.6c14.4-18.9 30.8-37.7 48.9-55.8s36.9-34.5 55.8-48.9c-14.4-7.5-28.4-13.5-41.6-17.9c-49-16.3-72.5-7.3-80.4 .6s-16.9 31.4-.6 80.4c4.4 13.2 10.4 27.2 17.9 41.6zM256 134c-22.1 15.5-44.5 34.1-66.2 55.8s-40.3 44.1-55.8 66.2c15.5 22.1 34.1 44.5 55.8 66.2s44.1 40.3 66.2 55.8c22.1-15.5 44.5-34.1 66.2-55.8s40.3-44.1 55.8-66.2c-15.5-22.1-34.1-44.5-55.8-66.2s-44.1-40.3-66.2-55.8zm149 77.7c7.5-14.4 13.5-28.4 17.9-41.6c16.3-49 7.3-72.5-.6-80.4s-31.4-16.9-80.4-.6c-13.2 4.4-27.2 10.4-41.6 17.9c18.9 14.4 37.7 30.8 55.8 48.9s34.5 36.9 48.9 55.8zm0 88.7c-14.4 18.9-30.8 37.7-48.9 55.8s-36.9 34.5-55.8 48.9c14.4 7.5 28.4 13.5 41.6 17.9c49 16.3 72.5 7.3 80.4-.6s16.9-31.4 .6-80.4c-4.4-13.2-10.4-27.2-17.9-41.6zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
};
const faAtomAlt = faAtomSimple;
const faAmpersand = {
  prefix: 'far',
  iconName: 'ampersand',
  icon: [448, 512, [], "26", "M178 80l44.4 0c27.4 0 49.7 22.2 49.7 49.7c0 16.2-7.9 31.4-21.2 40.7l-61.4 43-47.2-48.5C133.1 155.5 128 143 128 130c0-27.6 22.4-50 50-50zm45.3 168.2l55.1-38.5c26.1-18.3 41.7-48.1 41.7-80C320 75.7 276.3 32 222.3 32L178 32c-54.1 0-98 43.9-98 98c0 25.5 10 50 27.7 68.3l41.8 43L75.9 292.8C48.4 312 32 343.5 32 377.1C32 433.9 78.1 480 134.9 480l77.8 0c35.1 0 67.8-17.7 87-47.1l14.6-22.3 60.4 62.1c9.2 9.5 24.4 9.7 33.9 .5s9.7-24.4 .5-33.9l-67.9-69.8 70.8-108.3c7.3-11.1 4.1-26-7-33.2s-26-4.1-33.2 7L307 334.2l-83.7-86zm-39.8 27.9l96.6 99.3-20.5 31.3c-10.3 15.8-28 25.4-46.9 25.4l-77.8 0C104.6 432 80 407.4 80 377.1c0-17.9 8.7-34.7 23.4-45l80-56z"]
};
const faCarrot = {
  prefix: 'far',
  iconName: 'carrot',
  icon: [512, 512, [129365], "f787", "M320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6C337.6 17 320 42.3 320 72zM199.3 197.4c13.2-8.6 28.9-13.4 45.3-13.4c46.1 0 83.4 37.3 83.4 83.4c0 32.5-18.9 62-48.3 75.7l-42.8 19.8L209 335c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15.4 15.4L73.3 438.7l94.8-204.6L207 273c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41.7-41.7zM34.1 509.8L299.8 386.6c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136c-51.2 0-97.7 29.7-119.2 76.2L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8z"]
};
const faArrowUpFromLine = {
  prefix: 'far',
  iconName: 'arrow-up-from-line',
  icon: [384, 512, [8613, "arrow-from-bottom"], "f342", "M209.5 39.6C204.9 34.7 198.6 32 192 32s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 116.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faArrowFromBottom = faArrowUpFromLine;
const faMoon = {
  prefix: 'far',
  iconName: 'moon',
  icon: [384, 512, [127769, 9214], "f186", "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0l-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"]
};
const faPenSlash = {
  prefix: 'far',
  iconName: 'pen-slash',
  icon: [640, 512, [], "e213", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L409.9 296 556.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L517.3 19.3c-25-25-65.5-25-90.5 0L264.2 181.8 38.8 5.1zM302.3 211.6L385 129 447 191l-75.1 75.1-69.6-54.5zm38.9 153.1l-38-29.9-84.6 84.6c-4.7 4.7-10.6 8.2-17 10.1l-23.4 6.9-54.8 16.1 16.1-54.8 6.9-23.4c1.7-5.6 4.5-10.8 8.4-15.2c.6-.6 1.1-1.2 1.7-1.8l77.3-77.3-38-29.9-73.2 73.2c-10.4 10.4-18 23.3-22.2 37.4L77.4 439 65 481.2c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1L137 498.6l78.1-23c12.4-3.6 23.7-9.9 33.4-18.4c1.4-1.2 2.7-2.5 4-3.8l88.6-88.6z"]
};
const faWineGlassEmpty = {
  prefix: 'far',
  iconName: 'wine-glass-empty',
  icon: [320, 512, ["wine-glass-alt"], "f5ce", "M56 0C43.5 0 33.1 9.6 32.1 22.1L18.1 198.5C12.3 273.1 64.8 337.9 136 350l0 114-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-114c71.2-12.1 123.7-76.9 117.9-151.5L287.9 22.1C286.9 9.6 276.5 0 264 0L56 0zM66 202.3L78.2 48l163.6 0L254 202.3c4.3 54.8-39 101.7-94 101.7s-98.3-46.9-94-101.7z"]
};
const faWineGlassAlt = faWineGlassEmpty;
const faSquareStar = {
  prefix: 'far',
  iconName: 'square-star',
  icon: [448, 512, [], "e27f", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 25c6.1 0 11.7 3.5 14.3 8.9l31.3 63.3 69.9 10.2c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4L297.8 280l11.9 69.6c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2L224 333.6l-62.5 32.9c-5.4 2.8-11.9 2.4-16.9-1.2s-7.4-9.6-6.4-15.6L150.2 280 99.7 230.7c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l69.9-10.2 31.3-63.3c2.7-5.5 8.3-8.9 14.3-8.9z"]
};
const faCheese = {
  prefix: 'far',
  iconName: 'cheese',
  icon: [512, 512, [], "f7ef", "M464 240.2l0 15.8L48 256c0-3.9 2-7.6 5.3-9.8L301.5 80.7c.7-.4 1.5-.7 2.3-.7C392.3 80 464 151.7 464 240.2zM48 304l416 0 0 112c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-112zm464-48l0-15.8C512 125.2 418.8 32 303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-160z"]
};
const faSendBackward = {
  prefix: 'far',
  iconName: 'send-backward',
  icon: [512, 512, [], "f87f", "M64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l64 0 0-128c0-53 43-96 96-96l128 0 0-64c0-35.3-28.7-64-64-64L64 0zM224 208l224 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm-64 16l0 224c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-224 0c-35.3 0-64 28.7-64 64z"]
};
const faYinYang = {
  prefix: 'far',
  iconName: 'yin-yang',
  icon: [512, 512, [9775], "f6ad", "M464 256c0 114.9-93.1 208-208 208c-50.9 0-92.2-41.2-92.2-92s41.3-92 92.2-92c77.3 0 140-62.7 140-140c0-15.4-2.5-30.1-7-44c45.9 38.2 75 95.7 75 160zM256 48c50.8 0 92 41.2 92 92s-41.2 92-92 92c-77.3 0-140.2 62.6-140.2 140c0 15.3 2.5 30 7 43.8C77.1 377.6 48 320.2 48 256C48 141.1 141.1 48 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faMusic = {
  prefix: 'far',
  iconName: 'music',
  icon: [512, 512, [127925], "f001", "M512 31c0-17.1-13.9-31-31-31c-3.1 0-6.2 .5-9.1 1.4l-311 95.7C150.9 100.2 144 109.5 144 120l0 120 0 122.7c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-171.8 272-83.7 0 122.2c-14.1-6.8-30.5-10.7-48-10.7c-53 0-96 35.8-96 80s43 80 96 80s96-35.8 96-80l0-223.4c0-.4 0-.7 0-1.1L512 31zM464 368c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM144 432c0 9.8-12.9 32-48 32s-48-22.2-48-32s12.9-32 48-32s48 22.2 48 32zM464 126.3L192 210l0-72.2L464 54l0 72.2z"]
};
const faCompassSlash = {
  prefix: 'far',
  iconName: 'compass-slash',
  icon: [640, 512, [], "f5e9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-95.4-74.8C561.1 354.5 576 307 576 256C576 114.6 461.4 0 320 0C246.8 0 180.9 30.7 134.2 79.9L38.8 5.1zM172.2 109.7C209.9 71.6 262.2 48 320 48c114.9 0 208 93.1 208 208c0 39.8-11.2 77-30.6 108.6L397.1 285.9l47.5-123.5c7.5-19.4-11.6-38.5-31-31L270.3 186.5l-98.1-76.9zM320 464c-114.9 0-208-93.1-208-208c0-22.3 3.5-43.8 10-63.9L82.3 160.8C70.5 190.2 64 222.4 64 256c0 141.4 114.6 256 256 256c55.2 0 106.3-17.5 148.1-47.2l-39.7-31.3C396.8 452.9 359.7 464 320 464zm-3-118.2l-92.2-72.6-29.4 76.5c-7.5 19.4 11.6 38.5 31 31L317 345.8z"]
};
const faClockOne = {
  prefix: 'far',
  iconName: 'clock-one',
  icon: [512, 512, [], "e34e", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120l0 56.7 20-30c7.4-11 22.3-14 33.3-6.7s14 22.3 6.7 33.3l-64 96c-5.9 8.8-16.8 12.7-26.9 9.7s-17-12.4-17-23l0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faFileMusic = {
  prefix: 'far',
  iconName: 'file-music',
  icon: [384, 512, [], "f8b6", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM304 208c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15l0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z"]
};
const faCodeCommit = {
  prefix: 'far',
  iconName: 'code-commit',
  icon: [640, 512, [], "f386", "M320 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm158.2-88c-11.6 77-78 136-158.2 136s-146.6-59-158.2-136L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l137.8 0c11.6-77 78-136 158.2-136s146.6 59 158.2 136L616 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-137.8 0z"]
};
const faTemperatureLow = {
  prefix: 'far',
  iconName: 'temperature-low',
  icon: [512, 512, [], "f76b", "M416 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM80 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 161.9c0 14.5 5.7 27.1 12.8 36.6c12 16 19.2 35.9 19.2 57.5c0 53-43 96-96 96s-96-43-96-96c0-21.6 7.1-41.5 19.2-57.5C74.3 301 80 288.4 80 273.9L80 112zM144 0C82.1 0 32 50.2 32 112l0 161.9c0 1.7-.7 4.4-3.2 7.8C10.7 305.7 0 335.7 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-32.4-10.7-62.3-28.8-86.4c-2.5-3.4-3.2-6.1-3.2-7.8L256 112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"]
};
const faPersonBiking = {
  prefix: 'far',
  iconName: 'person-biking',
  icon: [640, 512, [128692, "biking"], "f84a", "M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 384A80 80 0 1 1 48 384a80 80 0 1 1 160 0zM128 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM592 384a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM512 256a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM341.5 149.6c3.5-2.5 8.3-1.9 11 1.4l44.8 56c4.6 5.7 11.5 9 18.7 9l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-52.5 0L390 121c-18.8-23.5-52.7-27.9-76.9-10.1l-74.6 55c-38.5 28.4-33.4 87.4 9.3 108.8L304 302.8 304 416c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128c0-9.1-5.1-17.4-13.3-21.5l-69.6-34.8c-10.7-5.3-12-20.1-2.3-27.2l74.6-55z"]
};
const faBiking = faPersonBiking;
const faDisplayChartUpCircleCurrency = {
  prefix: 'far',
  iconName: 'display-chart-up-circle-currency',
  icon: [640, 512, [], "e5e5", "M64 48l448 0c8.8 0 16 7.2 16 16l0 130.9c17 3.1 33.1 8.7 48 16.3L576 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l147.7 0-8 48L152 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 128 0 42.8 0c-18.3-12.9-34.1-29.2-46.3-48l-24.8 0L288 464l-35.7 0 8-48 27.7 0 27.7 0 11 0c-4.3-15.3-6.6-31.4-6.6-48l-79.6 0c-.3 0-.6 0-.8 0L64 368c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16zM480 192.7l0-72.7c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l22.1 0L304 238.1l-63-63c-9.4-9.4-24.6-9.4-33.9 0L103 279c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87 63 63c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7l111-111 0 22.1c0 1.3 .1 2.6 .3 3.9c15-5.8 31-9.7 47.7-11.2zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM521.4 393.4a35.9 35.9 0 1 0 -50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-17.3 17.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-17.3-17.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L460.7 310c21.6-13.2 49.1-13.2 70.7 0l17.3-17.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l17.3 17.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L531.3 426z"]
};
const faSkeleton = {
  prefix: 'far',
  iconName: 'skeleton',
  icon: [512, 512, [], "f620", "M256 0c13.3 0 24 10.7 24 24l0 40 144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0 0 48 208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0 0 48 112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0 0 85.7 75.5-32.3c8.3-3.5 17.2-5.4 26.1-5.4c36.7 0 66.4 29.7 66.4 66.4l0 1.5c0 18-7.2 35.3-19.9 48l-25.8 25.8c-11.7 11.7-27.6 18.3-44.1 18.3l-204.3 0c-16.6 0-32.4-6.6-44.1-18.3L83.9 467.9c-12.7-12.7-19.9-30-19.9-48l0-1.5c0-36.7 29.7-66.4 66.4-66.4c9 0 17.9 1.8 26.1 5.4L232 389.7l0-85.7-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0 0-48L24 208c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0 0-48L88 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0 0-40c0-13.3 10.7-24 24-24zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faCircleG = {
  prefix: 'far',
  iconName: 'circle-g',
  icon: [512, 512, [], "e10f", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176 256c0-44.2 35.8-80 80-80c20.5 0 39.2 7.7 53.3 20.4c9.9 8.8 25.1 8 33.9-1.9s8-25-1.9-33.9C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128s128-57.3 128-128c0-13.3-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l52.3 0c-10.2 32.5-40.5 56-76.3 56c-44.2 0-80-35.8-80-80z"]
};
const faCircleArrowUpLeft = {
  prefix: 'far',
  iconName: 'circle-arrow-up-left',
  icon: [512, 512, [], "e0fb", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm64-368l-152 0c-13.3 0-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1L327 361c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-135-135 94.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"]
};
const faCoinBlank = {
  prefix: 'far',
  iconName: 'coin-blank',
  icon: [512, 512, [], "e3fb", "M256 304c64 0 119.6-14.7 157.5-36c39.4-22.2 50.5-45.3 50.5-60s-11.1-37.8-50.5-60C375.6 126.7 320 112 256 112s-119.6 14.7-157.5 36C59.1 170.2 48 193.3 48 208s11.1 37.8 50.5 60c37.9 21.3 93.5 36 157.5 36zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144l0 48 0 64c0 70.7-114.6 128-256 128S0 390.7 0 320l0-64 0-48zM256 352c-13.6 0-27-.6-40-1.7l0 48c12.9 1.1 26.3 1.7 40 1.7s27.1-.6 40-1.7l0-48c-13 1.1-26.4 1.7-40 1.7zM120 330l0 47.7c18.7 7 40.3 12.7 64 16.6l0-48.1c-22.8-3.8-44.3-9.2-64-16.2zM88 316.7C73 309.3 59.6 301 48 292l0 28c0 6.8 6.2 24.2 40 43.1l0-46.5zm240 29.6l0 48.1c23.7-3.9 45.3-9.6 64-16.6l0-47.7c-19.7 7-41.2 12.5-64 16.2zM464 320l0-28c-11.6 9.1-25 17.4-40 24.7l0 46.5c33.8-18.9 40-36.3 40-43.1z"]
};
const faBroom = {
  prefix: 'far',
  iconName: 'broom',
  icon: [576, 512, [129529], "f51a", "M569 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L335 207l-39-39c-5.1-5.1-12.1-8-19.4-8c-12.2 0-23 8.1-26.3 19.9l-15.9 55.6-.6-.1c-46.4-7.1-93.5 8.3-126.7 41.5L97 287c-18.4 18.4-29.7 42.4-32.4 68c-.4 3.8-.6 7.7-.6 11.6c0 9.6 7.8 17.3 17.3 17.3l22.7 0L81.3 404.9 57.1 427.3 7.2 473.4C2.6 477.6 0 483.5 0 489.7C0 502 10 512 22.3 512l172.7 0c39.1 0 76.6-15.5 104.2-43.2c33.2-33.2 48.6-80.2 41.5-126.7l-.1-.6 55.6-15.9c11.8-3.4 19.9-14.1 19.9-26.3c0-7.3-2.9-14.2-8-19.4l-39-39L569 41zM278.8 254.8l8-28.1 62.4 62.4-28.1 8-42.3-42.3zm-52.3 28l9.8 1.5 55.4 55.4 1.5 9.8c4.8 31.3-5.6 63-28 85.4c-18.6 18.6-43.9 29.1-70.3 29.1L88.1 464l48.5-44.7c14.5-13.4 19.3-34.3 12.1-52.7c-5.4-13.7-16.6-23.9-30.1-28.3c3.1-6.4 7.3-12.2 12.4-17.3l10.2-10.2c22.4-22.4 54.1-32.8 85.4-28z"]
};
const faVacuum = {
  prefix: 'far',
  iconName: 'vacuum',
  icon: [640, 512, [], "e04d", "M290 48c-27.1 0-50.6 19-56.2 45.5L206 224l-49.1 0L186.8 83.5C197.2 34.8 240.2 0 290 0L528 0c61.9 0 112 50.1 112 112c0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320l0 128c0 35.3-28.7 64-64 64l-75.3 0c14.8-13 26.5-29.4 34-48l41.3 0c8.8 0 16-7.2 16-16l0-128c0-79.5-64.5-144-144-144c-8.8 0-16 7.2-16 16l0 97c-5.2-.7-10.6-1-16-1c-11 0-21.8 1.4-32 4l0-100c0-35.3 28.7-64 64-64c47.9 0 91.8 17.6 125.4 46.6c28.9-6.1 50.6-31.9 50.6-62.6c0-35.3-28.7-64-64-64L290 48zM150.1 256l49.1 0L171.7 385.1c29.8 5.5 52.3 31.6 52.3 62.9c0 35.3-28.7 64-64 64L32 512c-17.7 0-32-14.3-32-32c0-53 43-96 96-96l26.9 0 27.2-128zM432 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM176 448c0-8.8-7.2-16-16-16l-64 0c-20.9 0-38.7 13.4-45.3 32L160 464c8.8 0 16-7.2 16-16zm208-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faShieldHeart = {
  prefix: 'far',
  iconName: 'shield-heart',
  icon: [512, 512, [], "e574", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM144 221.3c0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3c-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9c-33.8 0-61.3 27.4-61.3 61.3z"]
};
const faCardHeart = {
  prefix: 'far',
  iconName: 'card-heart',
  icon: [384, 512, [], "e3eb", "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0L97.9 264.6C86.5 253.1 80 237.5 80 221.3z"]
};
const faLightbulbCflOn = {
  prefix: 'far',
  iconName: 'lightbulb-cfl-on',
  icon: [640, 512, [], "e5a7", "M343.3 18.2C340.1 5.3 327-2.5 314.2 .7l-128 32c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l128-32c12.9-3.2 20.7-16.2 17.5-29.1zm110.5 93.1c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zm0 96c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-256 64c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l256-64zM416 416c0-17.7-14.3-32-32-32l-80 0 0-89.8-48 12 0 77.8c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l40 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 40 0c17.7 0 32-14.3 32-32l0-32zm37.8-112.7c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16-16 4s0 0 0 0l-8 2c-11.1 2.8-18.5 12.9-18.2 23.9l0 81.4 48 0 0-63.3 5.8-1.5 64-16zM53.3 4C42.3-3.3 27.4-.3 20 10.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L53.3 4zM613.3 44c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zm528 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0zM101.3 332c11-7.4 14-22.3 6.7-33.3s-22.3-14-33.3-6.7l-48 32c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7l48-32zm464-39.9c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l48 32c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3l-48-32z"]
};
const faMelon = {
  prefix: 'far',
  iconName: 'melon',
  icon: [512, 512, [], "e310", "M464 256c0-25.8-4.7-50.4-13.2-73.2c-14.9 51.3-51.2 110.5-104.3 163.6s-112.3 89.4-163.6 104.3c22.8 8.6 47.4 13.2 73.2 13.2c114.9 0 208-93.1 208-208zM61.2 329.2c14.9-51.3 51.2-110.5 104.3-163.6s112.3-89.4 163.6-104.3C306.4 52.7 281.8 48 256 48C141.1 48 48 141.1 48 256c0 25.8 4.7 50.4 13.2 73.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM403 109c-5.2-5.2-24.1-13.9-67.8 .7c-40.7 13.6-89.8 44-135.7 89.9s-76.3 95-89.9 135.7c-14.6 43.7-5.8 62.6-.7 67.8s24.1 13.9 67.8-.7c40.7-13.6 89.9-44 135.7-89.9s76.3-95 89.9-135.7c14.6-43.7 5.8-62.6 .7-67.8z"]
};
const faGopuram = {
  prefix: 'far',
  iconName: 'gopuram',
  icon: [512, 512, [], "f664", "M120 0c13.3 0 24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 32 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 0 32 0 16 0 48 0 2.7c18.6 6.6 32 24.4 32 45.3l0 48c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 64c0 .9 0 1.8-.1 2.7c18.7 6.6 32.1 24.4 32.1 45.3l0 80c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48l0-80c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7l0-64c0-20.9 13.4-38.7 32.1-45.3c0-.9-.1-1.8-.1-2.7l0-48c0-20.9 13.4-38.7 32-45.3l0-2.7 0-48 0-16 0-32 0-8c0-13.3 10.7-24 24-24zm24 80l0 48 224 0 0-48L144 80zm-32 96l0 48 48 0 0-48-16 0-32 0zm208 48l0-48-128 0 0 48 32 0c0-17.7 14.3-32 32-32s32 14.3 32 32l32 0zm32-48l0 48 48 0 0-48-32 0-16 0zm0 96l-192 0 0 64 64 0 0-16c0-17.7 14.3-32 32-32s32 14.3 32 32l0 16 64 0 0-64zm32 64l48 0 0-64-32 0-16 0 0 64zM128 464l80 0 0-16c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 80 0 0-80-32 0-192 0-32 0 0 80zm288 0l48 0 0-80-32 0-16 0 0 80zM128 272l-16 0-32 0 0 64 48 0 0-64zM96 384l-16 0-32 0 0 80 48 0 0-80z"]
};
const faEarthOceania = {
  prefix: 'far',
  iconName: 'earth-oceania',
  icon: [512, 512, ["globe-oceania"], "e47b", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3l-29.9 0c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 416c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-8.8 0-16-7.2-16-16zM423.2 290.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
};
const faGlobeOceania = faEarthOceania;
const faContainerStorage = {
  prefix: 'far',
  iconName: 'container-storage',
  icon: [640, 512, [], "f4b7", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l8 0 0 352-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 528 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-352 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 32 24 32zM80 432L80 80l480 0 0 352L80 432zm96-280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208z"]
};
const faFacePouting = {
  prefix: 'far',
  iconName: 'face-pouting',
  icon: [512, 512, [], "e387", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM161.3 382.1c-5.4 12.3 8.7 21.6 21.1 16.4c22.4-9.5 47.4-14.8 73.7-14.8s51.3 5.3 73.7 14.8c12.4 5.2 26.5-4.1 21.1-16.4c-16-36.6-52.4-62.1-94.8-62.1s-78.8 25.6-94.8 62.1zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
const faSquareXmark = {
  prefix: 'far',
  iconName: 'square-xmark',
  icon: [448, 512, [10062, "times-square", "xmark-square"], "f2d3", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm143 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faTimesSquare = faSquareXmark;
const faXmarkSquare = faSquareXmark;
const faFaceExplode = {
  prefix: 'far',
  iconName: 'face-explode',
  icon: [512, 512, ["exploding-head"], "e2fe", "M120 160c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0c-17.7 0-32 14.3-32 32l0 4.5c0 10.3 4.4 20.1 11.9 27l9.5 6c10.4 6.5 23.5 6.5 33.9 0l17.3-10.8c10.4-6.5 23.5-6.5 33.9 0l20.7 12.9c4.8 3 10.3 4.6 15.8 4.8c4.2 .2 8.5-.5 12.6-2.1l33.9-13.1c1.5 11.4 2.3 23 2.3 34.8c0 5.3-.2 10.7-.5 15.9C503.3 405.9 392 512 256 512S8.7 405.9 .5 271.9C.2 266.7 0 261.3 0 256c0-11.8 .8-23.4 2.3-34.8l34 13.1c4.1 1.6 8.4 2.3 12.6 2.1c5.5-.2 11-1.8 15.8-4.8l20.7-12.9c10.4-6.5 23.5-6.5 33.9 0l17.3 10.8c10.4 6.5 23.5 6.5 33.9 0l9.5-6c7.5-6.9 11.9-16.6 11.9-27l0-4.5c0-17.7-14.3-32-32-32l-40 0zm-8.8 110.1l-8.8-5.5-12.2 7.6C77.9 279.9 64 284 49.9 284.4C63.8 385.8 150.7 464 256 464s192.2-78.2 206.1-179.6c-14.1-.4-28-4.5-40.3-12.1l-12.2-7.6-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0l-8.8-5.5-8.8 5.5c-25.9 16.2-58.9 16.2-84.8 0zM176.4 304a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 368c26.5 0 48 21.5 48 48l0 5.3c0 5.9-4.8 10.7-10.7 10.7l-74.7 0c-5.9 0-10.7-4.8-10.7-10.7l0-5.3c0-26.5 21.5-48 48-48z"]
};
const faExplodingHead = faFaceExplode;
const faHashtag = {
  prefix: 'far',
  iconName: 'hashtag',
  icon: [448, 512, [62098], "23", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136l111 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136l71.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-81.1 0L314.1 328l77.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-87.5 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376l-111 0-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376 24 376c-13.3 0-24-10.7-24-24s10.7-24 24-24l81.1 0 28.8-144L56 184c-13.3 0-24-10.7-24-24s10.7-24 24-24l87.5 0 16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328l111 0 28.8-144-111 0z"]
};
const faUpRightAndDownLeftFromCenter = {
  prefix: 'far',
  iconName: 'up-right-and-down-left-from-center',
  icon: [512, 512, ["expand-alt"], "f424", "M323.3 0C303.8 0 288 15.8 288 35.3c0 9.4 3.7 18.3 10.3 25L326.1 88 264 150.1c-18.7 18.7-18.7 49.1 0 67.9L294.1 248c18.7 18.7 49.1 18.7 67.9 0L424 185.9l27.7 27.7c6.6 6.6 15.6 10.3 25 10.3c19.5 0 35.3-15.8 35.3-35.3L512 40c0-22.1-17.9-40-40-40L323.3 0zM377 71l-23-23L464 48l0 110.1-23-23c-9.4-9.4-24.6-9.4-33.9 0l-79 79L297.9 184l79-79c9.4-9.4 9.4-24.6 0-33.9zM188.7 512c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25L185.9 424 248 361.9c18.7-18.7 18.7-49.1 0-67.9L217.9 264c-18.7-18.7-49.1-18.7-67.9 0L88 326.1 60.3 298.3c-6.6-6.6-15.6-10.3-25-10.3C15.8 288 0 303.8 0 323.3L0 472c0 22.1 17.9 40 40 40l148.7 0zM135 441l23 23L48 464l0-110.1 23 23c9.4 9.4 24.6 9.4 33.9 0l79-79L214.1 328l-79 79c-9.4 9.4-9.4 24.6 0 33.9z"]
};
const faExpandAlt = faUpRightAndDownLeftFromCenter;
const faOilCan = {
  prefix: 'far',
  iconName: 'oil-can',
  icon: [640, 512, [], "f613", "M328 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48-84.8 0-3.2 0-48 0-48 0c-26.5 0-48 21.5-48 48l0 64.8c0 19 11.2 36.2 28.5 43.9l67.5 30L96 368c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L615 208.6l1.4-1.6 7.6-8.6 9.4-10.6c12.3-13.9-.3-35.4-18.4-31.5l-13.9 3-11.3 2.4-2.1 .4L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8L280 160l0-48 48 0zm97.1 125.8c10.4 5.2 22.3 6.7 33.6 4.3l72.1-15.4L412.7 360.5c-2.4 2.8-5.9 4.3-9.6 4.3l-255.9 0 0-153.6 221.7 0c2 0 3.9 .5 5.7 1.4l50.5 25.2zM96 294.1L48 272.8 48 208l48 0 0 3.2 0 82.9z"]
};
const faT = {
  prefix: 'far',
  iconName: 't',
  icon: [384, 512, [116], "54", "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l144 0 0 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-376 144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L192 32 24 32z"]
};
const faTransformerBolt = {
  prefix: 'far',
  iconName: 'transformer-bolt',
  icon: [384, 512, [], "e2a4", "M136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 8L64 32c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-24 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0 0-8zM48 112c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM24 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 256-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 272 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-256 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0L56 160l-32 0zM80 464l0-256 224 0 0 256L80 464zM233.4 243.1c-5.9-4.3-14-4-19.6 .7l-96 80c-5.2 4.3-7.1 11.4-4.8 17.7s8.3 10.6 15 10.6l40.4 0-23.2 58.1c-2.7 6.8-.5 14.6 5.5 18.9s14 4 19.6-.7l96-80c5.2-4.3 7.1-11.4 4.8-17.7s-8.3-10.6-15-10.6l-40.4 0 23.2-58.1c2.7-6.8 .5-14.6-5.5-18.9z"]
};
const faHippo = {
  prefix: 'far',
  iconName: 'hippo',
  icon: [640, 512, [129435], "f6ed", "M391 39c9.4-9.4 24.6-9.4 33.9 0l14.2 14.2C449.5 49.9 460.5 48 472 48l32 0c15.8 0 30.8 3.5 44.2 9.8L559 47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7c13.8 17.7 22 39.9 22 64c0 .3 .1 .6 .3 .7c19.4 17.6 31.7 43 31.7 71.3c0 28.4-12.4 54-32 71.6l0 .4 0 32c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-8-64 0 0 8c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-13.5c-37.3-13.2-64-48.7-64-90.5c0-16.2 4-31.4 11.1-44.8c2.9-5.6 4.9-11.7 4.9-18l0-9.2c0-8.9 1.1-17.5 3.2-25.8c-25.6-9.4-52.7-14.2-80-14.2L256 112l-24.8 0C147.7 112 80 179.7 80 263.2c0 19.7-4.1 39.2-12.1 57.2L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 153.2 121.2 64 231.2 64L256 64l35.2 0c35.1 0 69.9 6.6 102.6 19.5c1.2-1.4 2.4-2.7 3.7-4L391 73c-9.4-9.4-9.4-24.6 0-33.9zm81 57c-30.9 0-56 25.1-56 56l0 9.2c0 16.4-5.1 30.3-10.5 40.4c-3.5 6.6-5.5 14.2-5.5 22.4c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48c0-14.1-6-26.8-15.8-35.6C566 179.2 560 166 560 152c0-30.9-25.1-56-56-56l-32 0zM408 377.6c7.1 4.1 15.3 6.4 24 6.4l24 0 0 40c0 30.9-25.1 56-56 56l-48 0c-30.9 0-56-25.1-56-56l0-16.4c-26.4 5.4-53.6 5.4-80 0l0 16.4c0 30.9-25.1 56-56 56l-40 0c-30.9 0-56-25.1-56-56l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 4.4 3.6 8 8 8l40 0c4.4 0 8-3.6 8-8l0-48c0-7.6 3.6-14.8 9.8-19.3s14.1-5.8 21.4-3.6l11.3 3.6c29.6 9.3 61.4 9.3 91 0l11.3-3.6c7.3-2.3 15.2-1 21.4 3.6s9.8 11.7 9.8 19.3l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8-3.6 8-8l0-46.4zM464 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-56 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
};
const faChartColumn = {
  prefix: 'far',
  iconName: 'chart-column',
  icon: [512, 512, [], "e0e3", "M24 32c13.3 0 24 10.7 24 24l0 352c0 13.3 10.7 24 24 24l416 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 480c-39.8 0-72-32.2-72-72L0 56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm120-72l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM480 88l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faCassetteVhs = {
  prefix: 'far',
  iconName: 'cassette-vhs',
  icon: [576, 512, [128252, "vhs"], "f8ec", "M48 416l0-256 480 0 0 256c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM352 336l-128 0 0-80 128 0 0 80zM144 296c0-19.4 13.7-35.5 32-39.2l0 78.4c-18.3-3.7-32-19.8-32-39.2zm288 0c0 19.4-13.7 35.5-32 39.2l0-78.4c18.3 3.7 32 19.8 32 39.2zM96 296c0 48.6 39.4 88 88 88l208 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-208 0c-48.6 0-88 39.4-88 88z"]
};
const faVhs = faCassetteVhs;
const faInfinity = {
  prefix: 'far',
  iconName: 'infinity',
  icon: [640, 512, [8734, 9854], "f534", "M0 237.3C0 159.3 63.3 96 141.3 96c39 0 76.2 16.1 102.9 44.5L320 221l75.8-80.5C422.5 112.1 459.7 96 498.7 96c78 0 141.3 63.3 141.3 141.3l0 37.4c0 78-63.3 141.3-141.3 141.3c-39 0-76.2-16.1-102.9-44.5L320 291l-75.8 80.5C217.5 399.9 180.3 416 141.3 416C63.3 416 0 352.7 0 274.7l0-37.4zM287 256l-77.8-82.6c-17.6-18.7-42.2-29.4-68-29.4C89.8 144 48 185.8 48 237.3l0 37.4c0 51.5 41.8 93.3 93.3 93.3c25.7 0 50.3-10.6 68-29.4L287 256zm65.9 0l77.8 82.6c17.6 18.7 42.2 29.4 68 29.4c51.5 0 93.3-41.8 93.3-93.3l0-37.4c0-51.5-41.8-93.3-93.3-93.3c-25.7 0-50.3 10.6-68 29.4L353 256z"]
};
const faVialCircleCheck = {
  prefix: 'far',
  iconName: 'vial-circle-check',
  icon: [512, 512, [], "e596", "M0 56C0 42.7 10.7 32 24 32l8 0 48 0 96 0 48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 186.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96L32 80l-8 0C10.7 80 0 69.3 0 56zM80 80l0 112 96 0 0-112L80 80zm0 160l0 144c0 26.5 21.5 48 48 48s48-21.5 48-48l0-144-96 0zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faChimney = {
  prefix: 'far',
  iconName: 'chimney',
  icon: [448, 512, [], "f78b", "M48 176l352 0 0-96L48 80l0 96zM0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l0 136 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-80 0 0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80-56 0L80 384l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104 0-136c-17.7 0-32-14.3-32-32L0 64zM80 224l0 112 80 0 0-112-80 0zm128 0l0 112 56 0 104 0 0-112-160 0z"]
};
const faObjectIntersect = {
  prefix: 'far',
  iconName: 'object-intersect',
  icon: [512, 512, [], "e49d", "M96 48L64 48c-8.8 0-16 7.2-16 16l0 32L0 96 0 64C0 28.7 28.7 0 64 0L96 0l0 48zm32 0l0-48 96 0 0 48-96 0zM0 128l48 0 0 96L0 224l0-96zm352 32l0 48 0 48 0 32c0 35.3-28.7 64-64 64l-64 0-16 0-48 0 0-48 0-48 0-32c0-35.3 28.7-64 64-64l64 0 16 0 48 0zM160 416l48 0 0 32c0 8.8 7.2 16 16 16l32 0 0 48-32 0c-35.3 0-64-28.7-64-64l0-32zM352 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0 0-48 32 0c35.3 0 64 28.7 64 64zm64 144l0-48 32 0c35.3 0 64 28.7 64 64l0 32-48 0 0-32c0-8.8-7.2-16-16-16l-32 0zM96 304l0 48-32 0c-35.3 0-64-28.7-64-64l0-32 48 0 0 32c0 8.8 7.2 16 16 16l32 0zM288 464l96 0 0 48-96 0 0-48zm160 48l-32 0 0-48 32 0c8.8 0 16-7.2 16-16l0-32 48 0 0 32c0 35.3-28.7 64-64 64zm64-128l-48 0 0-96 48 0 0 96zM304 208l-80 0c-8.8 0-16 7.2-16 16l0 80 80 0c8.8 0 16-7.2 16-16l0-80z"]
};
const faPersonArrowDownToLine = {
  prefix: 'far',
  iconName: 'person-arrow-down-to-line',
  icon: [640, 512, [], "e538", "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-13.7 80l27.5 0c.8 0 1.5 0 2.3 .1L208 304l-32 0 0-127.9c.7 0 1.5-.1 2.3-.1zM176 464l0-112 32 0 0 112-32 0zm-48 0L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 80 0 384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-360 0 0-240.4 43.1 76.2c6.5 11.5 21.2 15.6 32.7 9.1s15.6-21.2 9.1-32.7L282.3 172.7c-15.6-27.6-44.9-44.7-76.6-44.7l-27.5 0c-31.7 0-61 17.1-76.6 44.7L43.1 276.2c-6.5 11.5-2.5 26.2 9.1 32.7s26.2 2.5 32.7-9.1L128 223.6 128 464zM472 56l0 281.7-47.9-43.5c-9.8-8.9-25-8.2-33.9 1.6s-8.2 25 1.6 33.9l88 80c9.2 8.3 23.1 8.3 32.3 0l88-80c9.8-8.9 10.5-24.1 1.6-33.9s-24.1-10.5-33.9-1.6L520 337.7 520 56c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
};
const faVoicemail = {
  prefix: 'far',
  iconName: 'voicemail',
  icon: [640, 512, [], "f897", "M144 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM251.3 336c22.8-25.5 36.7-59.1 36.7-96c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 36.9 13.9 70.5 36.7 96l-137.3 0zM496 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
};
const faBlockBrick = {
  prefix: 'far',
  iconName: 'block-brick',
  icon: [448, 512, ["wall-brick"], "e3db", "M144 80l0 48 56 0 48 0 56 0 0-48L144 80zM96 128l0-48L64 80c-8.8 0-16 7.2-16 16l0 32 48 0zM48 176l0 56 152 0 0-56L48 176zm0 160l48 0 0-56-48 0 0 56zm0 48l0 32c0 8.8 7.2 16 16 16l136 0 0-48-56 0-48 0-48 0zm96-48l160 0 0-56-160 0 0 56zm208 0l48 0 0-56-48 0 0 56zm48 48l-48 0-48 0-56 0 0 48 136 0c8.8 0 16-7.2 16-16l0-32zm0-208l-152 0 0 56 152 0 0-56zm0-48l0-32c0-8.8-7.2-16-16-16l-32 0 0 48 48 0zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faWallBrick = faBlockBrick;
const faFan = {
  prefix: 'far',
  iconName: 'fan',
  icon: [512, 512, [], "f863", "M304 40l-4.1 38.2-5.7 52.7c9.4-4 18.9-6.9 28.5-8.6c7-1.2 14-1.9 21-2.2c79-2.9 151.9 53.9 167.7 132.1c.5 2.5 .7 5.1 .7 7.7l0 4.2c0 22.1-17.9 40-40 40l-38.2-4.1-52.7-5.7c4 9.4 6.9 18.9 8.6 28.5c1.2 7 1.9 14 2.2 21c2.9 79-53.9 151.9-132.1 167.7c-2.5 .5-5.1 .7-7.7 .7l-4.2 0c-22.1 0-40-17.9-40-40l4.1-38.2 5.7-52.7c-9.4 4-18.9 6.9-28.5 8.6c-7 1.2-14 1.9-21 2.2C89.4 394.8 16.4 338 .7 259.8c-.5-2.5-.7-5.1-.7-7.7L0 248c0-22.1 17.9-40 40-40l38.2 4.1 52.7 5.7c-4-9.4-6.9-18.9-8.6-28.5c-1.2-7-1.9-14-2.2-21C117.2 89.4 174 16.4 252.2 .7c2.5-.5 5.1-.7 7.7-.7L264 0c22.1 0 40 17.9 40 40zm82.3 206.5l76.3 8.3c-15.2-56.4-73.6-95.1-131.8-85.1c-5.5 .9-11.4 2.7-17.8 5.4c-15.7 6.7-33.7 4.6-47.4-5.6s-21-26.8-19.2-43.7l8.3-76.3c-56.4 15.2-95.1 73.6-85.1 131.8c.9 5.5 2.7 11.4 5.4 17.8c6.7 15.7 4.6 33.7-5.6 47.4s-26.8 21-43.7 19.2l-76.3-8.3c15.2 56.4 73.6 95.1 131.8 85.1c5.5-.9 11.4-2.7 17.8-5.4c15.7-6.7 33.7-4.6 47.4 5.6s21 26.8 19.2 43.7l-8.3 76.3c56.4-15.2 95.1-73.6 85.1-131.8c-.9-5.5-2.7-11.4-5.4-17.8c-6.7-15.7-4.6-33.7 5.6-47.4s26.8-21 43.7-19.2zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBagsShopping = {
  prefix: 'far',
  iconName: 'bags-shopping',
  icon: [576, 512, [128717], "f847", "M176 96c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64-96 0 0-64zm-48 64l-64 0c-35.3 0-64 28.7-64 64L0 416c0 35.3 28.7 64 64 64l96 0 0-48-96 0c-8.8 0-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l48 0c0-35.3-28.7-64-64-64l-64 0 0-64c0-53-43-96-96-96s-96 43-96 96l0 64zm128 96c-35.3 0-64 28.7-64 64l0 128c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-128c0-35.3-28.7-64-64-64l-256 0zm64 80l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faParagraphLeft = {
  prefix: 'far',
  iconName: 'paragraph-left',
  icon: [384, 512, ["paragraph-rtl"], "f878", "M304 48l24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L224 0 200 0 168 0 144 0C82.1 0 32 50.1 32 112s50.1 112 112 112l32 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 0-24 0-152 32 0 0 248c0 13.3 10.7 24 24 24s24-10.7 24-24l0-248zM176 48l0 128-32 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l24 0 8 0zM120.1 361.8c9.9-8.9 10.7-24 1.8-33.9s-24-10.7-33.9-1.8l-80 72C2.9 402.7 0 409.2 0 416s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 440 360 440c13.3 0 24-10.7 24-24s-10.7-24-24-24L86.5 392l33.5-30.2z"]
};
const faParagraphRtl = faParagraphLeft;
const faPersonWalkingLuggage = {
  prefix: 'far',
  iconName: 'person-walking-luggage',
  icon: [576, 512, [], "e554", "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM365.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L384.7 288.6l-16.3-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L503 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C484.1 162.8 437.9 128 385.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7c-39.9 13.3-72.4 42.8-89.5 81.3l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3c10.9-24.4 30.9-43.5 55.6-53.3l-22.8 68.3c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L488.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21l-24.1 60.4L231 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zm-75.7-52c-7.6-4.4-17.4-1.8-21.9 5.8L203 335.9 147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c.6-1 1.1-1.9 1.5-2.9L253.8 312c4.4-7.6 1.8-17.4-5.8-21.9z"]
};
const faCaravanSimple = {
  prefix: 'far',
  iconName: 'caravan-simple',
  icon: [640, 512, ["caravan-alt"], "e000", "M80 80c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l28.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48L528 368l0-176c0-61.9-50.1-112-112-112L80 80zM96 416l-16 0c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l336 0c88.4 0 160 71.6 160 160l0 176 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0-48 0-240 0c0 53-43 96-96 96s-96-43-96-96zm0-256c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-64zm256-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM240 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
};
const faCaravanAlt = faCaravanSimple;
const faTurtle = {
  prefix: 'far',
  iconName: 'turtle',
  icon: [576, 512, [128034], "f726", "M336 240l0-32c0-70.7-57.3-128-128-128S80 137.3 80 208l0 32 256 0zm48-32l0 41.2c0 21.4-17.4 38.8-38.8 38.8L70.8 288C49.4 288 32 270.6 32 249.2L32 208c0-97.2 78.8-176 176-176s176 78.8 176 176zm96 80c-8.3 0-16.3-1.6-23.6-4.5C440.3 328 400.4 361 352 367l0 1 0 72c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-72-32 0 0 72c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-72-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0 48 0 32 0 48 0 32 0 48 0 32 0 32 0c44.2 0 80-35.8 80-80l0-16 0-32 0-16c0-35.3 28.7-64 64-64c53 0 96 43 96 96l0 16c0 35.3-28.7 64-64 64l-32 0zM272 368l0 64 32 0 0-64-32 0zm-160 0l0 64 32 0 0-64-32 0zM496 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faPencilMechanical = {
  prefix: 'far',
  iconName: 'pencil-mechanical',
  icon: [512, 512, [], "e5ca", "M500.7 36.7L475.3 11.3C468.1 4.1 458.2 0 448 0s-20.1 4.1-27.3 11.3L389.5 42.5c-4.3-1.6-8.9-2.5-13.5-2.5c-10.2 0-20.1 4.1-27.3 11.3L317 83 287.6 53.7c-21.9-21.9-57.3-21.9-79.2 0L103 159c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L242.3 87.6c3.1-3.1 8.2-3.1 11.3 0L283 117 72.8 327.2C67 333 62.8 340.1 60.6 348L32.8 445.3 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l25.7-25.7L164 451.4c7.8-2.2 15-6.4 20.8-12.2L460.7 163.3c7.2-7.2 11.3-17.1 11.3-27.3c0-4.7-.8-9.3-2.5-13.5l31.1-31.1C507.9 84.1 512 74.2 512 64s-4.1-20.1-11.3-27.3zM376 91.9L420.1 136 183 373.1 138.9 329 376 91.9zM89.1 422.9l16.9-59 42.2 42.2-59 16.9z"]
};
const faUpDown = {
  prefix: 'far',
  iconName: 'up-down',
  icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34c0 25.5-20.7 46.3-46.3 46.3l-9.7 0 0 160 9.7 0c25.5 0 46.3 20.7 46.3 46.3c0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0L14.9 416.2C5.4 407.5 0 395.2 0 382.3C0 356.7 20.7 336 46.3 336l9.7 0 0-160-9.7 0C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34L111.7 6.4zM50.7 128L80 128c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24l-29.3 0L128 455.3 205.3 384 176 384c-13.3 0-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24l29.3 0L128 56.7 50.7 128zM47.4 381s0 0 0 0l-1.2 1.3 1.2-1.3s0 0 0 0z"]
};
const faArrowsAltV = faUpDown;
const faCloudMoonRain = {
  prefix: 'far',
  iconName: 'cloud-moon-rain',
  icon: [576, 512, [], "f73c", "M353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5C417 0 363.5 46.5 353.7 107.6zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zM128.1 192c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.2 0-.4 0-.6 0c-.1 0-.2 0-.4 0l-266.9 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 201 .1 240.5 .1 288c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1l266 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9C238.1 112.6 209.1 96 176.1 96z"]
};
const faBoothCurtain = {
  prefix: 'far',
  iconName: 'booth-curtain',
  icon: [512, 512, [], "f734", "M56 48c-4.4 0-8 3.6-8 8l0 432c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 25.1 25.1 0 56 0l88 0 0 48L56 48zM416 0l40 0c30.9 0 56 25.1 56 56l0 40 0 296 0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-28.1c-7.5 2.7-15.6 4.1-24 4.1c-18.4 0-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3s-35.3-6.9-48-18.3c-12.7 11.4-29.6 18.3-48 18.3c-39.8 0-72-32.2-72-72l0-360c0-17.7 14.3-32 32-32l64 0 48 0 48 0 7.8 0L416 0zM368 48l-48 0 0 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-344zm96 344l0-296 0-40c0-4.4-3.6-8-8-8l-40 0 0 48 0 296c0 13.3 10.7 24 24 24s24-10.7 24-24zm-240 0c0 13.3 10.7 24 24 24s24-10.7 24-24l0-344-48 0 0 344z"]
};
const faCalendar = {
  prefix: 'far',
  iconName: 'calendar',
  icon: [448, 512, [128197, 128198], "f133", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"]
};
const faBoxHeart = {
  prefix: 'far',
  iconName: 'box-heart',
  icon: [448, 512, [], "f49d", "M248 80l94.4 0c6.3 0 12.1 3.7 14.6 9.5L388.4 160 248 160l0-80zM48 208l352 0 0 208c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-208zm152-48L59.6 160 91 89.5c2.6-5.8 8.3-9.5 14.6-9.5L200 80l0 80zM400.9 70c-10.3-23.1-33.2-38-58.5-38L105.6 32C80.3 32 57.4 46.9 47.1 70L5.5 163.6c-3.6 8.2-5.5 17-5.5 26L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-226.4c0-9-1.9-17.8-5.5-26L400.9 70zM212.7 404.7c6.2 6.2 16.4 6.2 22.6 0l77.3-77.3c20.5-20.5 20.5-53.8 0-74.3s-53.8-20.5-74.3 0L224 267.4l-14.3-14.3c-20.5-20.5-53.8-20.5-74.3 0s-20.5 53.8 0 74.3l77.3 77.3z"]
};
const faTrailer = {
  prefix: 'far',
  iconName: 'trailer',
  icon: [640, 512, [], "e041", "M64 80l432 0c8.8 0 16 7.2 16 16l0 240-236.8 0c-16.6-28.7-47.6-48-83.2-48s-66.6 19.3-83.2 48L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zM288 384l328 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0-240c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l32 0c0 53 43 96 96 96s96-43 96-96zM136 112c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zm96 0c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24zM144 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faUserDoctorMessage = {
  prefix: 'far',
  iconName: 'user-doctor-message',
  icon: [640, 512, ["user-md-chat"], "f82e", "M144 128a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm80 128A128 128 0 1 1 224 0a128 128 0 1 1 0 256zm-48 96c-5.4 0-10.8 .3-16 1l0 49.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-41c-46.9 19-80 65-80 118.7l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-97.2 78.8-176 176-176l96 0c97.2 0 176 78.8 176 176l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-53.7-33.1-99.7-80-118.7l0 40.7c27.6 7.1 48 32.2 48 62l0 32c0 8.8-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16 8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0c-8.8 0-16-7.2-16-16l0-32c0-29.8 20.4-54.9 48-62l0-49c-5.2-.7-10.6-1-16-1l-96 0zm-8 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM432 0L592 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0-83.2 62.4c-2.4 1.8-5.7 2.1-8.4 .8s-4.4-4.1-4.4-7.2l0-56-16 0c-26.5 0-48-21.5-48-48l0-128c0-26.5 21.5-48 48-48z"]
};
const faUserMdChat = faUserDoctorMessage;
const faBahai = {
  prefix: 'far',
  iconName: 'bahai',
  icon: [576, 512, ["haykal"], "f666", "M288 0c10.9 0 20.4 7.3 23.2 17.8l28.1 105.3 89.2-62.6c8.9-6.2 20.9-5.7 29.2 1.3s10.9 18.7 6.3 28.6L417.8 189l108.6 9.4c10.8 .9 19.7 9 21.6 19.7s-3.7 21.3-13.5 25.9L435.6 290l77.2 77c7.7 7.7 9.3 19.6 3.8 29s-16.5 14-27 11.2L384.4 378.8 394 487.4c1 10.8-5.5 21-15.7 24.7s-21.7 .1-27.9-8.8L288 413.9l-62.4 89.4c-6.2 8.9-17.7 12.5-27.9 8.8s-16.7-13.8-15.7-24.7l9.6-108.6L86.4 407.2c-10.5 2.8-21.6-1.8-27-11.2s-3.9-21.3 3.8-29l77.2-77L41.5 244.1c-9.9-4.6-15.4-15.2-13.5-25.9s10.7-18.8 21.6-19.7L158.2 189 112 90.3c-4.6-9.8-2-21.6 6.3-28.6s20.3-7.5 29.2-1.3l89.2 62.6L264.8 17.8C267.6 7.3 277.1 0 288 0zm0 117.1l-13.7 51.6c-2 7.6-7.6 13.7-15 16.4s-15.6 1.6-22-2.9l-43.7-30.7 22.6 48.3c3.3 7.1 3 15.4-1 22.2s-10.9 11.2-18.7 11.9l-53.2 4.6L191.8 261c7.1 3.3 12.2 9.9 13.5 17.6s-1.1 15.6-6.7 21.2l-37.8 37.7 51.5-13.9c7.6-2 15.7-.2 21.7 4.8s9.2 12.7 8.5 20.5L237.8 402l30.6-43.7c4.5-6.4 11.8-10.3 19.7-10.3s15.2 3.8 19.7 10.3L338.2 402l-4.7-53.1c-.7-7.8 2.5-15.5 8.5-20.5s14.1-6.8 21.7-4.8l51.5 13.9-37.8-37.7c-5.5-5.5-8-13.4-6.7-21.2s6.4-14.3 13.5-17.6l48.4-22.5-53.2-4.6c-7.8-.7-14.8-5.1-18.7-11.9s-4.3-15.1-1-22.2l22.6-48.3-43.7 30.7c-6.4 4.5-14.6 5.6-22 2.9s-13-8.8-15-16.4L288 117.1z"]
};
const faHaykal = faBahai;
const faLighthouse = {
  prefix: 'far',
  iconName: 'lighthouse',
  icon: [640, 512, [], "e612", "M33.5 1.9l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48C2.4 40.8-3.3 26.7 1.9 14.5S21.3-3.3 33.5 1.9zm112 204.1l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5zM308.6 2.9c7.1-3.8 15.7-3.8 22.8 0l104 56c11.7 6.3 16 20.8 9.8 32.5c-5.7 10.6-18.2 15.1-29.1 11.3l0 25.4-48 0 0-50.9L320 51.3 272 77.1l0 50.9-48 0 0-25.4c-11 3.9-23.4-.7-29.1-11.3c-6.3-11.7-1.9-26.2 9.8-32.5l104-56zM263.4 208L212.2 464l75.8 0 0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48 75.8 0L376.6 208l-113.3 0zM352 512l-64 0-98.9 0L152 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l11.2 0 51.2-256.1c-12.5-.8-22.4-11.2-22.4-23.9c0-13.3 10.7-24 24-24l8 0 192 0 8 0c13.3 0 24 10.7 24 24c0 12.7-9.9 23.1-22.4 23.9L476.8 464l11.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-37.1 0L352 512zM638.1 14.6c5.2 12.2-.4 26.3-12.6 31.5l-112 48c-12.2 5.2-26.3-.4-31.5-12.6s.4-26.3 12.6-31.5l112-48c12.2-5.2 26.3 .4 31.5 12.6zm-156.1 160c5.2-12.2 19.3-17.8 31.5-12.6l112 48c12.2 5.2 17.8 19.3 12.6 31.5s-19.3 17.8-31.5 12.6l-112-48c-12.2-5.2-17.8-19.3-12.6-31.5z"]
};
const faAmpGuitar = {
  prefix: 'far',
  iconName: 'amp-guitar',
  icon: [512, 512, [], "f8a1", "M256 0c-48.9 0-92.5 28.8-121.6 53.8c-10.7 9.2-20 18.3-27.5 26.2L64 80C28.7 80 0 108.7 0 144l0 80 0 24 0 24L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-176 0-24 0-24 0-80c0-35.3-28.7-64-64-64l-42.9 0c-7.5-7.9-16.8-17.1-27.5-26.2C348.5 28.8 304.9 0 256 0zm0 48c26.4 0 53.6 13.8 77.7 32L178.3 80c24.1-18.2 51.4-32 77.7-32zM464 272l0 176c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-176 416 0zm0-48L48 224l0-80c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 80zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM384 304a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-96-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm0 96a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm288-48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"]
};
const faSdCard = {
  prefix: 'far',
  iconName: 'sd-card',
  icon: [384, 512, [], "f7c2", "M336 64l0 384c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-293.5c0-4.2 1.7-8.3 4.7-11.3l90.5-90.5c3-3 7.1-4.7 11.3-4.7L320 48c8.8 0 16 7.2 16 16zm48 384l0-384c0-35.3-28.7-64-64-64L154.5 0c-17 0-33.3 6.7-45.3 18.7L18.7 109.3C6.7 121.3 0 137.5 0 154.5L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64zM176 96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"]
};
const faVolumeSlash = {
  prefix: 'far',
  iconName: 'volume-slash',
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6l0-188.8C352 45.3 338.7 32 322.2 32c-7.3 0-14.3 2.7-19.8 7.5L199.5 131 38.8 5.1zm199.1 156L304 102.3 304 213l-66.1-51.8zM32 216l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-76.9-48-37.8 0 74.2L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l54.2 0L81.7 160.4C53.7 163.5 32 187.2 32 216z"]
};
const faBorderBottom = {
  prefix: 'far',
  iconName: 'border-bottom',
  icon: [448, 512, [], "f84d", "M448 456c0 13.3-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0c13.3 0 24 10.7 24 24zM384 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 352A32 32 0 1 1 0 352a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 160a32 32 0 1 1 64 0A32 32 0 1 1 0 160zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM64 256A32 32 0 1 1 0 256a32 32 0 1 1 64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM0 64a32 32 0 1 1 64 0A32 32 0 1 1 0 64zm256 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM352 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 64a32 32 0 1 1 64 0A32 32 0 1 1 96 64zm64 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
};
const faWifiWeak = {
  prefix: 'far',
  iconName: 'wifi-weak',
  icon: [640, 512, ["wifi-1"], "f6aa", "M264 424a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"]
};
const faWifi1 = faWifiWeak;
const faDragon = {
  prefix: 'far',
  iconName: 'dragon',
  icon: [640, 512, [128009], "f6d5", "M273 17c3.1-10.1 12.4-17 23-17L424 0l24 0 27.8 0c35 0 68.3 15.3 91.1 41.9l56 65.4c11 12.8 17 29.1 17 46c0 39.1-31.7 70.7-70.7 70.7l-22.8 0c-23.3 0-45.7-9.3-62.2-25.8l-3.9-3.9c1.7 12.7 8.4 24.3 18.8 32L592 296c30.2 22.7 48 58.2 48 96c0 66.3-53.7 120-120 120l-88 0L56.5 512C27.7 512.3 3 490.4 .2 461.3c-2.9-30.8 19.7-58.1 50.5-61l345.6-32.6-12-13.1C353.3 320.6 336 276.2 336 230.2l0-42.1s0 0 0 0c0 0 0-.1 0-.1c0 0 0 0 0 0l0-32-49.7-22.1c-8.3-3.7-13.8-11.8-14.2-20.9s4.4-17.6 12.3-22l37.6-20.9L282.7 44C273.9 38.1 270 27.2 273 17zM375.3 48l6 4c7 4.6 11 12.6 10.7 20.9s-5 15.9-12.3 20l-29.9 16.6 20 8.9c8.7 3.9 14.3 12.4 14.3 21.9l0 47.5s0 0 0 0c0 0 0 .1 0 .1c0 0 0 0 0 0l0 42.1c0 34 12.8 66.8 35.7 91.9l44.6 48.7c6.2 6.7 8 16.3 4.7 24.8s-11.1 14.4-20.1 15.3L55.2 448c-4.4 .4-7.6 4.3-7.2 8.7c.4 4.2 3.9 7.3 8 7.3l.3 0s0 0 0 0L432 464l88 0c39.8 0 72-32.2 72-72c0-22.7-10.7-44-28.8-57.6l-92.8-69.6C446.2 246.7 432 218.2 432 188l0-20c0-13.3 10.7-24 24-24l32 0c6.4 0 12.5 2.5 17 7l13.3 13.3c7.5 7.5 17.7 11.7 28.3 11.7l22.8 0c12.5 0 22.7-10.2 22.7-22.7c0-5.4-1.9-10.7-5.5-14.8l-56-65.4C516.8 57.2 496.9 48 475.8 48L448 48l-24 0-48.7 0zM514.6 95.2c-1.8 2.2-4 4.1-6.6 5.6c-11.5 6.6-26.2 2.7-32.8-8.8c-1.3-2.3-2.2-4.8-2.7-7.3c-.9-4.6 3.7-7.7 8.3-6.5l29.6 7.4c4.5 1.1 7.2 6 4.2 9.6zM520 79.5l0 .9c0-.3 0-.6 0-.9zM189.4 112.4L304 188.8l0 41.4c0 31.2 6.8 61.8 19.5 89.8L112 320c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1z"]
};
const faShoePrints = {
  prefix: 'far',
  iconName: 'shoe-prints',
  icon: [640, 512, [], "f54b", "M323.7 62.6C355.1 54.7 390.3 48 416 48c41.2 0 89.8 10.6 126.5 28.9C582 96.7 592 116.3 592 128c0 9.4-5.1 21.5-35.9 33.1c-29.4 11.1-67 14.9-92.1 14.9c-34.7 0-53.5-10.4-80.2-25.7l-.7-.4c-20.6-11.8-45.1-25.8-79.1-33l0-49.1c6-1.7 12.7-3.4 19.7-5.2zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0C352.3 0 256 32 256 32l0 80 0 48s0 0 0 0zM128 96c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64zm67.7 353.4c-7-1.8-13.7-3.5-19.7-5.2l0-49.1c34-7.3 58.5-21.3 79.1-33l.7-.4C282.5 346.4 301.3 336 336 336c25.2 0 62.7 3.7 92.1 14.9C458.9 362.5 464 374.6 464 384c0 11.7-10 31.3-49.5 51.1C377.8 453.4 329.2 464 288 464c-25.7 0-60.9-6.7-92.3-14.6zM128 352s0 0 0 0l0 48 0 80s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zM0 416c0 35.3 28.7 64 64 64l32 0 0-128-32 0c-35.3 0-64 28.7-64 64z"]
};
const faCirclePlus = {
  prefix: 'far',
  iconName: 'circle-plus',
  icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faPlusCircle = faCirclePlus;
const faFaceGrinTongueWink = {
  prefix: 'far',
  iconName: 'face-grin-tongue-wink',
  icon: [512, 512, [128540, "grin-tongue-wink"], "f58b", "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4l0-52.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1l0 52.4c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-37.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6l0 37.4z"]
};
const faGrinTongueWink = faFaceGrinTongueWink;
const faHandHolding = {
  prefix: 'far',
  iconName: 'hand-holding',
  icon: [576, 512, [], "f4bd", "M165.2 358.7c6.6-4.4 14.3-6.7 22.2-6.7L344 352c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 24 0 48 0c4.4 0 8.8-1.2 12.6-3.6l93.5-57.5c3.1-1.9 6.7-2.9 10.3-2.9l7.4 0c6.8 0 12.3 5.5 12.3 12.3c0 4.2-2.1 8-5.6 10.3l-95.6 61.9C415.1 460 401.5 464 387.7 464L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l363.7 0c23.1 0 45.8-6.7 65.2-19.3l95.6-61.9c17.2-11.1 27.5-30.2 27.5-50.6c0-33.3-27-60.3-60.3-60.3l-7.4 0c-12.5 0-24.8 3.5-35.5 10L408 370c0-.7 0-1.3 0-2c0-35.3-28.7-64-64-64l-156.6 0c-17.4 0-34.4 5.1-48.8 14.8L64.7 368 24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.7 0 9.4-1.4 13.3-4l79.9-53.3z"]
};
const faPlugCircleExclamation = {
  prefix: 'far',
  iconName: 'plug-circle-exclamation',
  icon: [576, 512, [], "e55d", "M128 24c0-13.3-10.7-24-24-24S80 10.7 80 24l0 88 48 0 0-88zm176 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 88 48 0 0-88zM24 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 64c0 80.2 59 146.6 136 158.2l0 73.8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-73.8c15.2-2.3 29.7-6.7 43.1-12.9c-2.1-10.8-3.1-21.9-3.1-33.3c0-7.1 .4-14.1 1.2-20.9C238.9 360.2 216.3 368 192 368c-61.9 0-112-50.1-112-112l0-64 224 0 0 55.2c13.8-14.6 30-26.8 48-36l0-19.2 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48 0L80 144l-48 0-8 0zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faLinkSlash = {
  prefix: 'far',
  iconName: 'link-slash',
  icon: [640, 512, ["chain-broken", "chain-slash", "unlink"], "f127", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l91-91c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6l-95.1 95.1-45.5-35.7c24.2-53.3 14.1-117.9-29.3-161.3c-52.1-52.1-134.4-55.9-190.8-11.2L38.8 5.1zm186.3 146c36.9-22.3 85.6-17.6 117.4 14.3c26 26 34 63.3 23.7 96.4L225.1 151.1zM352.6 373.8c-20.2-2.7-39.7-11.7-55.2-27.3c-9.8-9.8-17-21.2-21.7-33.3l-54.2-42.7c-2.2 39.6 11.9 79.9 41.9 109.9c38.8 38.8 94.2 50.8 143.4 36l-54.2-42.7zm-236-186L59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6l60.9-60.9-38-29.9z"]
};
const faChainBroken = faLinkSlash;
const faChainSlash = faLinkSlash;
const faUnlink = faLinkSlash;
const faClone = {
  prefix: 'far',
  iconName: 'clone',
  icon: [512, 512, [], "f24d", "M64 464l224 0c8.8 0 16-7.2 16-16l0-64 48 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 48-64 0c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zM224 304l224 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16L224 48c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16zm-64-16l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z"]
};
const faPersonWalkingArrowLoopLeft = {
  prefix: 'far',
  iconName: 'person-walking-arrow-loop-left',
  icon: [640, 512, [], "e551", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM447 449c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-39-39 42.1 0c86.2 0 156-69.8 156-156s-69.8-156-156-156L344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l140 0c59.6 0 108 48.4 108 108s-48.4 108-108 108l-42.1 0 39-39c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9l80 80z"]
};
const faArrowUpZA = {
  prefix: 'far',
  iconName: 'arrow-up-z-a',
  icon: [576, 512, ["sort-alpha-up-alt"], "f882", "M352 32l128 0c9.4 0 18 5.5 21.9 14.2s2.3 18.7-4 25.8L405.4 176l74.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-9.4 0-18-5.5-21.9-14.2s-2.3-18.7 4-25.8L426.6 80 352 80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM143 39c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L184 456c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-342.1L81 169c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l96-96zM416 272c9.1 0 17.4 5.1 21.5 13.3l80 160c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-13.6-27.2c-1.6 .3-3.2 .5-4.9 .5l-85.2 0-13.4 26.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l80-160c4.1-8.1 12.4-13.3 21.5-13.3zM394.8 392l42.3 0L416 349.7 394.8 392z"]
};
const faSortAlphaUpAlt = faArrowUpZA;
const faFireFlameCurved = {
  prefix: 'far',
  iconName: 'fire-flame-curved',
  icon: [384, 512, ["fire-alt"], "f7e4", "M53.9 186.1C19.4 220.6 0 267.4 0 316.2l0 11.5C0 429.5 82.5 512 184.3 512l15.1 0C301.4 512 384 429.4 384 327.4c0-66.1-27.1-129.2-74.9-174.8L225.9 73.5c-6.3-6-9.9-14.4-9.9-23.2l0-13 0-16C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5L168 21.3l-9.9 13.2c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.3 3.9-.5 7.8-.4 11.7c.2 22.9 6.6 45.4 18.4 65c2.2 3.7 4.6 7.2 7.2 10.6L168 213.3l21.2 28.3c7 9.3 10.8 20.7 10.8 32.4l0 14c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-58.7 0-2.5 0-38.5c0-15.6-12.7-28.3-28.3-28.3c-1.3 0-2.6 .1-3.9 .3c-6 .8-11.7 3.6-16.1 8L53.9 186.1zm18.1 53L72 288c0 48.6 39.4 88 88 88s88-39.4 88-88l0-14c0-22.1-7.2-43.5-20.4-61.2l-32-42.7c-11.8-15.7-17.4-35.1-15.7-54.6l.9-10.8c.3-3.1 .7-6.1 1.3-9.1c3.1 4.5 6.7 8.8 10.8 12.6L276 187.4c38.3 36.5 60 87.1 60 140C336 402.9 274.9 464 199.4 464l-15.1 0C109 464 48 403 48 327.7l0-11.5c0-27.7 8.5-54.6 24-77.2z"]
};
const faFireAlt = faFireFlameCurved;
const faTornado = {
  prefix: 'far',
  iconName: 'tornado',
  icon: [448, 512, [127786], "f76f", "M332.4 48L48 48c.3 28 6.3 55.1 17 80l239.1 0c-.1-1.8-.1-3.6-.1-5.4C304 95 314.2 68.5 332.4 48zM317.5 176L94 176c15.5 19.3 34.6 35.9 56.6 48.9L203.5 256 376 256l-49.6-66.1c-3.3-4.4-6.3-9.1-8.9-13.9zm80.9 128l-115.6 0c19.9 15.1 36.1 34.6 47.3 57c8.9 17.8 14.4 37 16.4 56.5l23.6-23.6c19.1-19.1 29.8-45 29.8-72c0-6-.5-12.1-1.6-17.9zm5.7 123.9L340 492l-.4 .4L336 496l-10.1 10.1c-3.8 3.8-8.9 5.9-14.2 5.9c-12.4 0-21.8-11.1-19.8-23.4l2.4-14.1 .8-5 .1-.5 2.7-16c4-24 .3-48.7-10.6-70.5c-10-19.9-25.5-36.5-44.6-47.8L126.2 266.2C48 220.2 0 136.3 0 45.6L0 32C0 14.3 14.3 0 32 0L393.4 0C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16L370.8 77.2c-12 12-18.8 28.4-18.8 45.4c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9c0 39.7-15.8 77.8-43.9 105.9z"]
};
const faFileCirclePlus = {
  prefix: 'far',
  iconName: 'file-circle-plus',
  icon: [576, 512, [58606], "e494", "M64 464l220.5 0c12 18.4 27.4 34.5 45.3 47.3c-3.2 .5-6.4 .7-9.7 .7L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3l0 44.1c-17.2 4.9-33.4 12.3-48 21.8l0-60.5-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"]
};
const faDeleteRight = {
  prefix: 'far',
  iconName: 'delete-right',
  icon: [576, 512, [], "e154", "M370.7 64c17 0 33.3 6.7 45.3 18.7L566.6 233.4c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6L416 429.3c-12 12-28.3 18.7-45.3 18.7L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l306.7 0zM48 128l0 256c0 8.8 7.2 16 16 16l306.7 0c4.2 0 8.3-1.7 11.3-4.7L521.4 256 382.1 116.7c-3-3-7.1-4.7-11.3-4.7L64 112c-8.8 0-16 7.2-16 16zm95 47c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faBookQuran = {
  prefix: 'far',
  iconName: 'book-quran',
  icon: [448, 512, ["quran"], "f687", "M360 0c48.6 0 88 39.4 88 88l0 336-.4 0c.3 2.6 .4 5.3 .4 8c0 44.2-35.8 80-80 80L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-69.4c-18.9-9-32-28.3-32-50.6L0 56C0 25.1 25.1 0 56 0L360 0zM80 400l0 64 288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 400zm288-48c11.4 0 22.2 2.4 32 6.7L400 88c0-22.1-17.9-40-40-40L56 48c-4.4 0-8 3.6-8 8l0 288c0 4.4 3.6 8 8 8l312 0zM282.1 150.2c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7 .5 8 7.5 3.7 11.2L312 199.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L288 217.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zm-24.6-45.6c4.1 1.8 6.5 5.9 6.5 10.3c0 7.6-7.1 13.2-14.7 13.1c-.4 0-.8 0-1.3 0c-39.8 0-72 32.2-72 72s32.2 72 72 72c.4 0 .8 0 1.3 0c7.6-.1 14.7 5.5 14.7 13.1c0 4.4-2.4 8.5-6.5 10.3c-12.7 5.5-26.8 8.6-41.5 8.6c-57.4 0-104-46.6-104-104s46.6-104 104-104c14.8 0 28.8 3.1 41.5 8.6z"]
};
const faQuran = faBookQuran;
const faCircleQuarter = {
  prefix: 'far',
  iconName: 'circle-quarter',
  icon: [512, 512, [], "e11f", "M208 53.6L208 208 53.6 208C71.6 131.7 131.7 71.6 208 53.6zM2 224.1C-.2 241.6 14.3 256 32 256l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"]
};
const faAnchor = {
  prefix: 'far',
  iconName: 'anchor',
  icon: [576, 512, [9875], "f13d", "M320 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-44.2 0-80 35.8-80 80c0 35.9 23.7 66.3 56.3 76.4c-.2 1.2-.3 2.4-.3 3.6l0 32-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 224-24 0c-73.7 0-133.7-58.6-135.9-131.8l16.3 14c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.3-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6L56 332.1C58.2 431.8 139.8 512 240 512l48 0 48 0c100.2 0 181.8-80.2 184-179.9l16.4 14.1c10.1 8.6 25.2 7.5 33.8-2.6s7.5-25.2-2.6-33.8l-56-48c-9-7.7-22.2-7.7-31.2 0l-56 48c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l16.3-14C469.7 405.4 409.7 464 336 464l-24 0 0-224 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-32c0-1.2-.1-2.4-.3-3.6C344.3 146.3 368 115.9 368 80c0-44.2-35.8-80-80-80z"]
};
const faBorderAll = {
  prefix: 'far',
  iconName: 'border-all',
  icon: [448, 512, [], "f84c", "M384 80c8.8 0 16 7.2 16 16l0 136-152 0 0-152 136 0zm16 200l0 136c0 8.8-7.2 16-16 16l-136 0 0-152 152 0zM200 232L48 232 48 96c0-8.8 7.2-16 16-16l136 0 0 152zM48 280l152 0 0 152L64 432c-8.8 0-16-7.2-16-16l0-136zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"]
};
const faFunction = {
  prefix: 'far',
  iconName: 'function',
  icon: [640, 512, [], "f661", "M72 88c0-48.6 39.4-88 88-88l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-22.1 0-40 17.9-40 40l0 104 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 150.7c0 44.8-33.7 82.5-78.3 87.5l-15.1 1.7c-13.2 1.5-25-8-26.5-21.2s8-25 21.2-26.5l15.1-1.7C56.7 428.2 72 411.1 72 390.7L72 240l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0L72 88zm244.3 76.8C288.4 209.1 272 262.5 272 320s16.4 110.9 44.3 155.2c7.1 11.2 3.7 26-7.5 33.1s-26 3.7-33.1-7.5C243 448.9 224 386.7 224 320s19-128.9 51.7-180.8c7.1-11.2 21.9-14.6 33.1-7.5s14.6 21.9 7.5 33.1zm231.4 0c-7.1-11.2-3.7-26 7.5-33.1s26-3.7 33.1 7.5C621 191.1 640 253.3 640 320s-19 128.9-51.7 180.8c-7.1 11.2-21.9 14.6-33.1 7.5s-14.6-21.9-7.5-33.1C575.6 430.9 592 377.5 592 320s-16.4-110.9-44.3-155.2zM393 247l39 39 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faFaceAngry = {
  prefix: 'far',
  iconName: 'face-angry',
  icon: [512, 512, [128544, "angry"], "f556", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"]
};
const faAngry = faFaceAngry;
const faPeopleSimple = {
  prefix: 'far',
  iconName: 'people-simple',
  icon: [512, 512, [], "e21b", "M128 0a64 64 0 1 1 0 128A64 64 0 1 1 128 0zM73.7 237.3l-4.1 49.3C68.8 296 76.2 304 85.6 304l2.4 0 80 0 2.4 0c9.4 0 16.7-8 15.9-17.3l-4.1-49.3C180.9 220.8 167 208 150.4 208l-44.8 0c-16.6 0-30.5 12.8-31.9 29.3zm160.5 45.3c2.5 29.8-15.7 56.1-42.2 65.6L192 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-139.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3zM384 0a64 64 0 1 1 0 128A64 64 0 1 1 384 0zM352.9 219.6L319.6 336l128.7 0L415.1 219.6c-2-6.9-8.2-11.6-15.4-11.6l-31.4 0c-7.1 0-13.4 4.7-15.4 11.6zm-46.2-13.2c7.8-27.5 33-46.4 61.5-46.4l31.4 0c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8L448 384l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-32 0 0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104-21.6 0c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"]
};
const faCookieBite = {
  prefix: 'far',
  iconName: 'cookie-bite',
  icon: [512, 512, [], "f564", "M182.8 28.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4zm34.9 37.5c19 54.5 63.9 96.7 120 111.9c17.7 50.9 58.1 91.1 109.1 108.7c-1 4.8-2.5 9.5-4.7 13.9L405.4 376c-5.4 11-14.1 20.1-24.8 25.8l-74 39.5c-10.8 5.7-23 7.9-35.1 6.2l-83-11.7c-12-1.7-23.3-7.2-32-15.7l-29.7 30.7 29.7-30.7L96.2 361.7c-8.8-8.5-14.7-19.6-16.8-31.7L64.9 247.2c-2.1-12.1-.4-24.6 5-35.6L106.6 136c5.4-11 14.1-20.1 24.8-25.8l74-39.5c3.9-2.1 8.1-3.7 12.4-4.9zM192 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faArrowTrendDown = {
  prefix: 'far',
  iconName: 'arrow-trend-down',
  icon: [576, 512, [], "e097", "M352 392c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 118.1L337 143c-9.4-9.4-24.6-9.4-33.9 0l-111 111L41 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L175 305c9.4 9.4 24.6 9.4 33.9 0l111-111L494.1 368 376 368c-13.3 0-24 10.7-24 24z"]
};
const faRss = {
  prefix: 'far',
  iconName: 'rss',
  icon: [448, 512, ["feed"], "f09e", "M0 56C0 42.7 10.7 32 24 32c234.2 0 424 189.8 424 424c0 13.3-10.7 24-24 24s-24-10.7-24-24C400 248.3 231.7 80 24 80C10.7 80 0 69.3 0 56zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM24 176c154.6 0 280 125.4 280 280c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faFeed = faRss;
const faFaceMonocle = {
  prefix: 'far',
  iconName: 'face-monocle',
  icon: [512, 512, [], "e380", "M448 336.1L448 224c0-61.9-50.1-112-112-112s-112 50.1-112 112s50.1 112 112 112c31.3 0 59.7-12.9 80-33.6l0 86.5C377.8 434.8 320.3 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c16.7 0 32.9 2 48.4 5.7c-6.9 2.8-13.3 6.6-19.2 11.2L262 83.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6c8-6.4 18-9.9 28.2-9.9c8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c5.7 3.8 12.9 3.5 18.2-.3c48 38.1 78.7 96.9 78.7 163c0 28.4-5.7 55.5-16 80.1zm3.9 84.7C489.4 376.3 512 318.8 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM256 224a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm-79.6-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm144 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM144 352c0 8.8 7.2 16 16 16c14.3 0 37.9 2.9 60.6 11.7c22.8 8.8 42.7 22.7 53.1 43.4c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59C205.3 339.5 177.7 336 160 336c-8.8 0-16 7.2-16 16z"]
};
const faDrawPolygon = {
  prefix: 'far',
  iconName: 'draw-polygon',
  icon: [448, 512, [], "f5ee", "M80 96A16 16 0 1 0 48 96a16 16 0 1 0 32 0zm8 59.3l0 201.3c16 6.5 28.9 19.3 35.3 35.3l201.3 0c2.1-5.2 4.9-10.1 8.2-14.5L298 319.2c-3.2 .5-6.6 .8-10 .8c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.7 .3 10 .8l34.9-58.2c-3.3-4.4-6.1-9.3-8.2-14.5l-201.3 0c-6.5 16-19.3 28.9-35.3 35.3zM374.1 352.8c3.2-.5 6.6-.8 9.9-.8c35.3 0 64 28.7 64 64s-28.7 64-64 64c-26.9 0-49.9-16.5-59.3-40l-201.3 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-201.3C16.5 145.9 0 122.9 0 96C0 60.7 28.7 32 64 32c26.9 0 49.9 16.5 59.3 40l201.3 0c9.5-23.5 32.5-40 59.3-40c35.3 0 64 28.7 64 64s-28.7 64-64 64c-3.4 0-6.7-.3-9.9-.8l-34.9 58.2c8.1 10.7 12.9 24.1 12.9 38.5s-4.8 27.8-12.9 38.5l34.9 58.2zM400 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm336-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faScaleBalanced = {
  prefix: 'far',
  iconName: 'scale-balanced',
  icon: [640, 512, [9878, "balance-scale"], "f24e", "M520 48L393.3 48C381 19.7 352.8 0 320 0s-61 19.7-73.3 48L120 48c-13.3 0-24 10.7-24 24s10.7 24 24 24l121.6 0c5.8 28.6 26.9 51.7 54.4 60.3L296 464l-176 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l200 0 200 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0 0-307.7c27.5-8.6 48.6-31.7 54.4-60.3L520 96c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-8 147.8L584.4 320l-144.9 0L512 195.8zM386 337.1C396.8 382 449.1 416 512 416s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 305.1c-5.7 9.8-9.3 21.1-6.7 32.1zM54.4 320l72.4-124.2L199.3 320 54.4 320zm72.4 96c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 141.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 305.1c-5.7 9.8-9.3 21.1-6.7 32.1C11.7 382 64 416 126.8 416zM320 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faBalanceScale = faScaleBalanced;
const faCalendarLines = {
  prefix: 'far',
  iconName: 'calendar-lines',
  icon: [448, 512, ["calendar-note"], "e0d5", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256zm48 88c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"]
};
const faCalendarNote = faCalendarLines;
const faArrowDownBigSmall = {
  prefix: 'far',
  iconName: 'arrow-down-big-small',
  icon: [576, 512, ["sort-size-down"], "f88c", "M143 473L47 377c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L136 56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 342.1 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0zM368 368l0 64 64 0 0-64-64 0zm-48 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-64 0c-26.5 0-48-21.5-48-48l0-64zm48-160l128 0 0-128L368 80l0 128zm-48 0l0-128c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48z"]
};
const faSortSizeDown = faArrowDownBigSmall;
const faGaugeSimpleHigh = {
  prefix: 'far',
  iconName: 'gauge-simple-high',
  icon: [512, 512, [61668, "tachometer", "tachometer-fast"], "f62a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm56-160c0-14-5.1-26.8-13.7-36.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L254.4 296c-30.2 .8-54.4 25.6-54.4 56c0 30.9 25.1 56 56 56s56-25.1 56-56z"]
};
const faTachometer = faGaugeSimpleHigh;
const faTachometerFast = faGaugeSimpleHigh;
const faDoNotEnter = {
  prefix: 'far',
  iconName: 'do-not-enter',
  icon: [512, 512, [], "f5ec", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm128-48l256 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"]
};
const faShower = {
  prefix: 'far',
  iconName: 'shower',
  icon: [512, 512, [128703], "f2cc", "M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7C139.6 41.7 116.3 32 91.9 32C41.1 32 0 73.1 0 123.9L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-332.1zM269.5 115l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2c0 0 0 0 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faDiceD8 = {
  prefix: 'far',
  iconName: 'dice-d8',
  icon: [512, 512, [], "f6d2", "M239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7zM126.2 324.3L232 430.1l0-62L126.2 324.3zM280 368l0 62L385.8 324.3 280 368zM445.6 247.6L280 81.9l0 234.2 165.6-68.5zM232 81.9L66.4 247.6 232 316.1l0-234.2z"]
};
const faDesktop = {
  prefix: 'far',
  iconName: 'desktop',
  icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48L64 48c-8.8 0-16 7.2-16 16l0 192 480 0 0-192c0-8.8-7.2-16-16-16zm64 208l0 48 0 48c0 35.3-28.7 64-64 64l-147.7 0 8 48 51.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0-128 0-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l51.7 0 8-48L64 416c-35.3 0-64-28.7-64-64l0-48 0-48L0 64C0 28.7 28.7 0 64 0L512 0c35.3 0 64 28.7 64 64l0 192zM48 304l0 48c0 8.8 7.2 16 16 16l175.5 0c.3 0 .6 0 .8 0l95.2 0c.3 0 .6 0 .8 0L512 368c8.8 0 16-7.2 16-16l0-48L48 304zM252.3 464l71.3 0-8-48-55.3 0-8 48z"]
};
const faDesktopAlt = faDesktop;
const faM = {
  prefix: 'far',
  iconName: 'm',
  icon: [448, 512, [109], "4d", "M17.1 33C27.3 30 38.2 34 44 42.8L224 316.3 403.9 42.8C409.8 34 420.7 30 430.9 33S448 45.4 448 56l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-319.9-156 237c-4.4 6.7-12 10.8-20 10.8s-15.6-4.1-20-10.8L48 136.1 48 456c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 56C0 45.4 7 36.1 17.1 33z"]
};
const faSpinnerScale = {
  prefix: 'far',
  iconName: 'spinner-scale',
  icon: [512, 512, [], "e62a", "M256 52a12 12 0 1 1 0 24 12 12 0 1 1 0-24zM204 64a52 52 0 1 0 104 0A52 52 0 1 0 204 64zm20 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM480 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 220a36 36 0 1 0 0 72 36 36 0 1 0 0-72zm339.1-88.5a16 16 0 1 1 -22.6-22.6 16 16 0 1 1 22.6 22.6zm28.3-50.9a56 56 0 1 0 -79.2 79.2 56 56 0 1 0 79.2-79.2zM97.6 369.1a32 32 0 1 0 45.3 45.3A32 32 0 1 0 97.6 369.1zm316.8 45.3a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zM125.9 125.9a8 8 0 1 1 -11.3-11.3 8 8 0 1 1 11.3 11.3zm28.3-39.6A48 48 0 1 0 86.3 154.2a48 48 0 1 0 67.9-67.9z"]
};
const faGripDotsVertical = {
  prefix: 'far',
  iconName: 'grip-dots-vertical',
  icon: [256, 512, [], "e411", "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 416a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 448a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faFaceViewfinder = {
  prefix: 'far',
  iconName: 'face-viewfinder',
  icon: [512, 512, [], "e2ff", "M0 56l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-4.4 3.6-8 8-8l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C25.1 0 0 25.1 0 56zM352 24c0 13.3 10.7 24 24 24l80 0c4.4 0 8 3.6 8 8l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-30.9-25.1-56-56-56L376 0c-13.3 0-24 10.7-24 24zM24 352c-13.3 0-24 10.7-24 24l0 80c0 30.9 25.1 56 56 56l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-4.4 0-8-3.6-8-8l0-80c0-13.3-10.7-24-24-24zm464 0c-13.3 0-24 10.7-24 24l0 80c0 4.4-3.6 8-8 8l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c30.9 0 56-25.1 56-56l0-80c0-13.3-10.7-24-24-24zM240 216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 272a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 280c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"]
};
const faSoftServe = {
  prefix: 'far',
  iconName: 'soft-serve',
  icon: [384, 512, [127846, "creemee"], "e400", "M192 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L140 64c-42 0-76 34-76 76c0 5.4 .6 10.7 1.7 15.8C27.7 167.2 0 202.3 0 244c0 34.9 19.4 65.2 48 80.8L48 352c0 17.7 14.3 32 32 32l1.8 0 11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5l134.7 0c16.3 0 30-12.3 31.8-28.5L302.2 384l1.8 0c17.7 0 32-14.3 32-32l0-27.2c28.6-15.6 48-45.9 48-80.8c0-41.9-28.1-77.3-66.4-88.4c1.6-6.3 2.4-12.8 2.4-19.6l0-8C320 57.3 262.7 0 192 0zM292 288L92 288c-24.3 0-44-19.7-44-44s19.7-44 44-44l4 0 6.5 0 9.5 0c13.3 0 24-10.7 24-24c0-12.3-9.3-22.5-21.2-23.8c-1.8-3.7-2.8-7.8-2.8-12.2c0-15.5 12.5-28 28-28l37.3 0c29.7 0 53.9-23.7 54.7-53.3c23.9 13.8 40 39.7 40 69.3l0 8c0 5.8-1.5 11.3-4.3 16L216 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l63.2 0 8.8 0 4 0c24.3 0 44 19.7 44 44s-19.7 44-44 44z"]
};
const faCreemee = faSoftServe;
const faH5 = {
  prefix: 'far',
  iconName: 'h5',
  icon: [640, 512, [], "e412", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 248 0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-152 224 0 0 152c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176 0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136L48 224 48 88zM440 64c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1 .4 14.4 5 19.9s11.4 8.8 18.6 8.8l120 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-63.6 0c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2s-19.4 17.8-15.2 30.4l3.2 9.7C399.4 426 429.9 448 464.4 448l63.6 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-90.7 0 22.4-112L584 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L440 64z"]
};
const faHandBackPointDown = {
  prefix: 'far',
  iconName: 'hand-back-point-down',
  icon: [448, 512, [], "e19e", "M144 512c-35.3 0-64-28.7-64-64l0-188.8c-5.2-3.6-10.2-7.6-14.9-11.9L44.8 228.8C26.5 212.1 16 188.5 16 163.7l0-10.2C16 99.5 44.7 49.5 91.4 22.2L94 20.7C117.3 7.1 143.7 0 170.6 0L296 0c66.3 0 120 53.7 120 120l0 8 0 96c0 35.3-28.7 64-64 64c-2.8 0-5.6-.2-8.3-.5c-11 19.4-31.8 32.5-55.7 32.5c-5.3 0-10.5-.7-15.5-1.9c-10.8 20.2-32 33.9-56.5 33.9c-2.7 0-5.4-.2-8-.5l0 96.5c0 35.3-28.7 64-64 64zm-16-64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-136c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16l0-8c0-10.3 6.6-19.5 16.4-22.8s20.6 .1 26.8 8.3c3 3.9 7.6 6.4 12.8 6.4c8.8 0 16-7.2 16-16c0-9.1 5.1-17.4 13.3-21.5s17.9-3.2 25.1 2.3c2.7 2 6 3.2 9.6 3.2c8.8 0 16-7.2 16-16l0-96 0-8c0-39.8-32.2-72-72-72L170.6 48c-18.4 0-36.5 4.9-52.4 14.2l-11.7-20 11.7 20-2.6 1.5C83.6 82.3 64 116.5 64 153.5l0 10.2c0 11.3 4.8 22 13.1 29.6L96 210.5 96 168c0-8.8 7.2-16 16-16s16 7.2 16 16l0 78 0 2 0 200z"]
};
const faTableList = {
  prefix: 'far',
  iconName: 'table-list',
  icon: [512, 512, ["th-list"], "f00b", "M192 80l0 88 272 0 0-72c0-8.8-7.2-16-16-16L192 80zm-48 0L64 80c-8.8 0-16 7.2-16 16l0 72 96 0 0-88zM48 216l0 80 96 0 0-80-96 0zm0 128l0 72c0 8.8 7.2 16 16 16l80 0 0-88-96 0zm144 88l256 0c8.8 0 16-7.2 16-16l0-72-272 0 0 88zM464 296l0-80-272 0 0 80 272 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faThList = faTableList;
const faBasketShoppingMinus = {
  prefix: 'far',
  iconName: 'basket-shopping-minus',
  icon: [576, 512, [], "e652", "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192l-36.1 0L32 192l-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l20 0L99.9 463.5C107 492 132.6 512 162 512L414 512c29.4 0 55-20 62.1-48.5L532 240l20 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-49.5 0-36.1 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM93.5 240l389 0-53 211.9C427.8 459 421.4 464 414 464L162 464c-7.3 0-13.7-5-15.5-12.1L93.5 240zM224 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0z"]
};
const faCommentSms = {
  prefix: 'far',
  iconName: 'comment-sms',
  icon: [512, 512, ["sms"], "f7cd", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 176 96 192.5 96 212.8zM372.8 176c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 185.1 192 192l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 229.3l-35.2-46.9z"]
};
const faSms = faCommentSms;
const faRectangle = {
  prefix: 'far',
  iconName: 'rectangle',
  icon: [512, 512, [9644, "rectangle-landscape"], "f2fa", "M448 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z"]
};
const faRectangleLandscape = faRectangle;
const faClipboardListCheck = {
  prefix: 'far',
  iconName: 'clipboard-list-check',
  icon: [384, 512, [], "f737", "M320 64l-40 0-9.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L104 64 64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64zM80 112l0 24c0 13.3 10.7 24 24 24l88 0 88 0c13.3 0 24-10.7 24-24l0-24 16 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l16 0zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm3.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4 99.3 236.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faTurkey = {
  prefix: 'far',
  iconName: 'turkey',
  icon: [640, 512, [], "f725", "M472 56c0 22.1-1.2 49.3-19.3 62l-31.6 22.3C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384C0 512 160 512 288 512s288 0 288-128c0-63-27.3-121.1-67.3-168.3c-.4 .2-.7 .4-1 .6l-28.3 20c-3.2 2.3-6.2 5-9 8.3C505.8 285.7 528 334.2 528 384c0 21-6.1 32.8-13.9 41c-8.9 9.4-23.9 18.1-47.3 24.8C418.6 463.6 354 464 288 464s-130.6-.4-178.8-14.2c-23.4-6.7-38.4-15.4-47.3-24.8C54.1 416.8 48 405 48 384c0-62 34.5-122 86-168.3C186.4 168.8 247.4 144 288 144c20.5 0 46.3 6.4 73.6 18.7c-15.2 .8-30.8-.5-45.8-2.1c-28.5-3-58.2 4.9-82.2 24.3c-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c18.6-15 31.1-34.8 37.2-56.2c.2-.7 .4-1.3 .6-2c9.6-33.7 20.1-70.5 48.7-90.6L486.7 192l2.5-1.8c18.3-12.9 43.3-10.4 67.4-8c9.4 .9 18.6 1.8 27.3 1.8c30.9 0 56-25.1 56-56s-25.1-56-56-56c-1.1 0-2-1.1-1.7-2.2c1.1-4.4 1.7-9 1.7-13.8c0-30.9-25.1-56-56-56s-56 25.1-56 56z"]
};
const faBook = {
  prefix: 'far',
  iconName: 'book',
  icon: [448, 512, [128212], "f02d", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM152 112l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faUserPlus = {
  prefix: 'far',
  iconName: 'user-plus',
  icon: [640, 512, [], "f234", "M224 48a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 208A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 96l91.4 0c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112zm0-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zM504 312c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faIceSkate = {
  prefix: 'far',
  iconName: 'ice-skate',
  icon: [576, 512, [9976], "f7ac", "M296 0c13.3 0 24 10.7 24 24l0 120 0 38 128.6 37.5c37.5 11 63.4 45.4 63.4 84.5l0 24c0 30.9-25.1 56-56 56L88 384c-30.9 0-56-25.1-56-56l0-191.6c0-25.2 16.8-47.3 41.1-54L272 27.5l0-3.5c0-13.3 10.7-24 24-24zM272 128l0-50.7L85.9 128.7c-3.5 1-5.9 4.1-5.9 7.7L80 328c0 4.4 3.6 8 8 8l368 0c4.4 0 8-3.6 8-8l0-24c0-17.8-11.7-33.4-28.8-38.4L292.6 224 240 224c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0-32-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0zM552 408c13.3 0 24 10.7 24 24l0 8c0 39.8-32.2 72-72 72l-96 0-288 0-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 0-48 48 0 0 48 240 0 0-48 48 0 0 48 72 0c13.3 0 24-10.7 24-24l0-8c0-13.3 10.7-24 24-24z"]
};
const faCheck = {
  prefix: 'far',
  iconName: 'check',
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
};
const faBatteryThreeQuarters = {
  prefix: 'far',
  iconName: 'battery-three-quarters',
  icon: [576, 512, ["battery-4"], "f241", "M464 144c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L80 368c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32l384 0zM80 96C35.8 96 0 131.8 0 176L0 336c0 44.2 35.8 80 80 80l384 0c44.2 0 80-35.8 80-80l0-16c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-16c0-44.2-35.8-80-80-80L80 96zm272 96L96 192l0 128 256 0 0-128z"]
};
const faBattery4 = faBatteryThreeQuarters;
const faTomato = {
  prefix: 'far',
  iconName: 'tomato',
  icon: [512, 512, [], "e330", "M241 7L224 24C241 7 241 7 241 7s0 0 0 0s0 0 0 0l.1 .1 .2 .2 .5 .5c.4 .4 1 1 1.7 1.8c1.4 1.5 3.2 3.6 5.4 6.3c4.4 5.4 10.1 13.1 15.8 22.8c6.6 11.2 13.4 25.5 18 42.1c45.7 3.1 88.5 14.2 125.1 32.8c6.6 3.4 10 10.8 8.3 18s-8.2 12.3-15.6 12.3l-34.6 0 15.4 23.1c3.9 5.9 3.5 13.7-1 19.1s-12.1 7.3-18.6 4.5L256 145.4 150.3 190.7c-6.5 2.8-14.1 1-18.6-4.5s-4.9-13.2-1-19.1l15.5-23.3-31.3-.2c-7 1.5-14.3-1.7-17.7-8.4c-4-7.9-.9-17.5 7-21.5l.8-.4C142.2 94.6 185.6 83.5 232 80.7c-2.6-6.4-5.6-12.3-8.7-17.6c-4.3-7.3-8.6-13-11.7-16.9c-1.6-1.9-2.8-3.4-3.6-4.3c-.4-.4-.7-.8-.9-.9l-.1-.1c-9.3-9.4-9.3-24.5 .1-33.9c9.4-9.4 24.6-9.4 33.9 0zM71.1 154c6 9.4 14.9 16.1 25 19.5c-.4 6.6 .7 13.3 3.1 19.6C67.1 219.8 48 256.7 48 304c0 49.8 21.1 88 56.2 115c36.2 27.9 89.2 45 151.8 45s115.5-17.1 151.8-45c35.1-27 56.2-65.2 56.2-115c0-47.3-19.1-84.2-51.1-110.9c2.4-6.3 3.4-13 3.1-19.6c10.3-3.5 19.1-10.4 25-19.5c44 35.5 71.1 86.4 71.1 150c0 130.9-114.6 208-256 208S0 434.9 0 304c0-63.6 27.1-114.5 71.1-150z"]
};
const faSwordLaser = {
  prefix: 'far',
  iconName: 'sword-laser',
  icon: [512, 512, [], "e03b", "M505.7 40.2c8.7-9.5 8.3-24.1-.7-33.2s-23.7-9.4-33.2-.7L230.7 226.8l54.4 54.4L505.7 40.2zM185 231c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l.7 .7-59 59c0 0 0 0 0 0s0 0 0 0L10.3 407C3.7 413.7 0 422.6 0 432s3.7 18.3 10.3 25L55 501.7c6.6 6.6 15.6 10.3 25 10.3s18.3-3.7 25-10.3l82.3-82.3 59-59 .7 .7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96-96zm-20.3 143l-26.7-26.7 12.4-12.4 26.7 26.7-12.4 12.4zm-49.4-4.1l26.7 26.7L80 458.7 53.3 432l62.1-62.1zM173 312.3l12.7-12.7 26.7 26.7L199.7 339 173 312.3z"]
};
const faHouseCircleCheck = {
  prefix: 'far',
  iconName: 'house-circle-check',
  icon: [640, 512, [], "e509", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l250.8 0c-18.3-12.9-34.1-29.2-46.3-48L336 464s0 0 0 0l-96 0 0-144 86.6 0c4.8-17.1 12.2-33.2 21.7-47.8c-1.4-.2-2.9-.2-4.3-.2l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 454.7 196.9c13.3-3.2 27.1-4.9 41.3-4.9c10.3 0 20.3 .9 30.1 2.6L303.5 5.7zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"]
};
const faBuildings = {
  prefix: 'far',
  iconName: 'buildings',
  icon: [512, 512, [], "e0cc", "M448 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16l0-384c0-8.8 7.2-16 16-16l160 0zM288 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L288 0zM192 128L72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l144.4 0c-11.8-13.2-20.1-29.7-23.1-48L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l120 0 0-48zM112 320c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm224 16c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32zM112 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM336 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 144l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16z"]
};
const faAngleLeft = {
  prefix: 'far',
  iconName: 'angle-left',
  icon: [320, 512, [8249], "f104", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"]
};
const faCartFlatbedBoxes = {
  prefix: 'far',
  iconName: 'cart-flatbed-boxes',
  icon: [640, 512, ["dolly-flatbed-alt"], "f475", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l48 0c4.4 0 8 3.6 8 8l0 352c0 30.9 25.1 56 56 56l24 0c0 26.5 21.5 48 48 48s48-21.5 48-48l192 0c0 26.5 21.5 48 48 48s48-21.5 48-48l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0-288 0-72 0c-4.4 0-8-3.6-8-8l0-352c0-30.9-25.1-56-56-56L24 0zM240 80l128 0 0 224-128 0 0-224zm-48 0l0 224c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L240 32c-26.5 0-48 21.5-48 48zm368 0l0 64-64 0 0-64 64 0zM496 32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-64 0zm0 240l96 0 0 32-96 0 0-32zm-48 0l0 32c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48z"]
};
const faDollyFlatbedAlt = faCartFlatbedBoxes;
const faDiagramSuccessor = {
  prefix: 'far',
  iconName: 'diagram-successor',
  icon: [512, 512, [], "e47a", "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM240 160c0 8.8-7.2 16-16 16L64 176c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16l144 0 16 0c8.8 0 16 7.2 16 16l0 64zm48-64c0-5.5-.7-10.9-2-16l82 0c13.3 0 24 10.7 24 24l0 38.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-38.1c0-39.8-32.2-72-72-72L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-64z"]
};
const faTruckArrowRight = {
  prefix: 'far',
  iconName: 'truck-arrow-right',
  icon: [640, 512, [], "e58b", "M64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l12.8 0c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48l76.8 0 32 0c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48zM480 512c-53 0-96-43-96-96l-8 0-24 0-32 0-64 0c0 53-43 96-96 96s-96-43-96-96c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l0 32 42.7 0c14.9 0 29.1 5.9 39.6 16.4l93.3 93.3c10.5 10.5 16.4 24.7 16.4 39.6L608 368l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c0 53-43 96-96 96zm78-272c-.1-.1-.2-.3-.4-.4l-93.3-93.3c-1.5-1.5-3.5-2.3-5.7-2.3L416 144l0 96 142 0zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM241 95l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39L112 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l134.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faSquareW = {
  prefix: 'far',
  iconName: 'square-w',
  icon: [448, 512, [], "e285", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm118.9 64.7L160 289.3l41.1-128.6c3.2-9.9 12.4-16.7 22.9-16.7s19.7 6.7 22.9 16.7L288 289.3l41.1-128.6c4-12.6 17.5-19.6 30.2-15.5s19.6 17.5 15.5 30.2l-64 200c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7L224 246.7 182.9 375.3c-3.2 9.9-12.4 16.7-22.9 16.7s-19.7-6.7-22.9-16.7l-64-200c-4-12.6 2.9-26.1 15.5-30.2s26.1 2.9 30.2 15.5z"]
};
const faArrowsSplitUpAndLeft = {
  prefix: 'far',
  iconName: 'arrows-split-up-and-left',
  icon: [512, 512, [], "e4bc", "M241 137c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7c9.4-9.4 24.6-9.4 33.9 0l96 96c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55L344 384l0 8c0 39.8 32.2 72 72 72l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-66.3 0-120-53.7-120-120l0-8c0-39.8-32.2-72-72-72L81.9 312l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 305c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l96-96c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55L224 264c27 0 51.9 8.9 72 24l0-206.1-55 55z"]
};
const faLamp = {
  prefix: 'far',
  iconName: 'lamp',
  icon: [448, 512, [], "f4ca", "M2.5 211.7l80-192C87.4 7.8 99.1 0 112 0L336 0c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1s-15.9 14.2-26.6 14.2L32 256c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1zM56 208l336 0L325.3 48 122.7 48 56 208zm88 105.4l0-25.4 48 0 0 25.4c0 17-6.7 32-16.2 42.9C165.7 368 144 398.1 144 432c0 12.2 3.7 23.1 8.4 31.9c.6 .1 1.3 .1 2.1 .1l139 0c.8 0 1.5-.1 2.1-.1c4.6-8.8 8.4-19.7 8.4-31.9c0-32.3-22.1-63.8-32.6-76.4c-9.2-10.9-15.4-25.6-15.4-42l0-25.6 48 0 0 25.6c0 4.1 1.6 8 4.2 11.2c11.7 14 43.8 56.9 43.8 107.2c0 24.4-8.3 44.6-16.4 58.7c-8.5 14.7-25.2 21.3-42.1 21.3l-139 0c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-51.9 31.6-93.4 43.5-107.1c2.8-3.2 4.5-7.3 4.5-11.5z"]
};
const faAirplay = {
  prefix: 'far',
  iconName: 'airplay',
  icon: [576, 512, [], "e089", "M480 80L96 80c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l53.5 0-34.7 34.7c-4 4-7.4 8.5-10.2 13.3L96 416c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l384 0c53 0 96 43 96 96l0 192c0 53-43 96-96 96l-8.6 0c-2.8-4.8-6.2-9.2-10.2-13.3L426.5 368l53.5 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48zM198.6 432l178.7 0L288 342.6 198.6 432zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0z"]
};
const faHandFist = {
  prefix: 'far',
  iconName: 'hand-fist',
  icon: [448, 512, [9994, "fist-raised"], "f6de", "M112 80c8.8 0 16 7.2 16 16l0 80-16 0c-5.5 0-10.8 .6-16 1.6L96 96c0-8.8 7.2-16 16-16zm0 144l40 0 40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4c10.4 21.3 32.3 36 57.6 36c5.2 0 10.2-.6 15-1.8c-4.4 32.4-23.8 60.1-51.1 75.9c-7.4 4.3-12 12.2-12 20.8L304 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-108.1c38.7-27.5 64-72.8 64-123.9l0-48 0-16 0-32c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2l0-2c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C239.2 14.7 217.3 0 192 0s-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4C76.7 32 48 60.7 48 96l0 104c0 2.3 .3 4.6 1 6.7C38.3 220.3 32 237.4 32 256c0 64.2 39.8 119 96 141.3l0 90.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-108c0-11-7.4-20.5-18-23.2C113.1 345.2 80 304.4 80 256c0-17.7 14.3-32 32-32zm256-32l0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32zM176 176l0-80 0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32 0 80 0 2c-5.1-1.3-10.5-2-16-2l-16 0zm80 0l0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16z"]
};
const faFistRaised = faHandFist;
const faShieldQuartered = {
  prefix: 'far',
  iconName: 'shield-quartered',
  icon: [512, 512, [], "e575", "M73 127c-5.9 2.5-9.1 7.8-9 12.8c.1 17.9 1.6 38.4 5.1 60.3L232 200l0-140.4L73 127zm6.7 121c20.9 73.9 65.9 153.7 152.3 202.3L232 248 79.7 248zM280 248l0 202.4C366.4 401.8 411.4 322 432.3 248L280 248zm162.9-48c3.5-21.9 5-42.3 5.1-60.3c0-5-3.1-10.2-9-12.8L280 59.6 280 200l162.9 0zM269.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0s9.2 1 13.4 2.9z"]
};
const faSlashForward = {
  prefix: 'far',
  iconName: 'slash-forward',
  icon: [320, 512, [], "2f", "M308.1 3.3c11.4 6.7 15.3 21.4 8.6 32.8l-272 464c-6.7 11.4-21.4 15.3-32.8 8.6S-3.4 487.3 3.3 475.9l272-464C282 .4 296.7-3.4 308.1 3.3z"]
};
const faLocationPen = {
  prefix: 'far',
  iconName: 'location-pen',
  icon: [384, 512, ["map-marker-edit"], "f607", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM276.8 107c14.7 14.7 14.7 38.6 0 53.3l-14.9 14.9L208.6 122 223.5 107c14.7-14.7 38.6-14.7 53.3 0zM114.1 216.5L186 144.6l53.3 53.3-71.9 71.9c-4.1 4.1-9.2 7-14.9 8.4l-36.6 9.2c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l9.2-36.7c1.4-5.6 4.3-10.8 8.4-14.9z"]
};
const faMapMarkerEdit = faLocationPen;
const faCloudMoon = {
  prefix: 'far',
  iconName: 'cloud-moon',
  icon: [640, 512, [], "f6c3", "M495.8 0C389.8 0 304 86.1 304 192.2c0 10.8 .9 21.5 2.6 31.8c58.8 1.4 106.4 48.2 109.2 106.7c22.8 10.8 41.4 29.1 52.6 51.7c8.9 1.3 18.1 1.9 27.4 1.9c52 0 99.1-20.7 133.6-54.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1c-80.7 0-146.2-65.6-146.2-146.6c0-54.8 30-102.6 74.4-127.8c6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7zM128.1 320c0-26.5 21.5-48 48-48c22.8 0 41.9 15.9 46.8 37.2c2.1 8.9 9 15.9 18 18s18.3-1.2 24.1-8.3c7.4-9.1 18.6-14.9 31.1-14.9c20.3 0 37.2 15.2 39.7 34.8c.1 .6 .2 1.2 .3 1.7l0 1.1c0 .3 0 .6 0 .9c0 .5 0 1 0 1.5s0 1 0 1.5c0 .3 0 .6 0 .9l0 30.2c0 7 3 13.6 8.3 18.1s12.2 6.6 19.1 5.6c1.5-.2 3-.3 4.6-.3c17.7 0 32 14.3 32 32s-14.3 32-32 32c-.4 0-.9 0-1.3 0c-.3 0-.6 0-1 0l-266.9 0c-.3 0-.6 0-.9 0c-.6 0-1.2 0-1.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48c1.4 0 2.7 .1 4 .2c13.2 1.1 24.8-8.7 25.9-21.9l2-23.8c.1-.8 .1-1.6 .1-2.5zm48-96c-52.6 0-95.4 42.4-96 94.8l-.2 2.5C34.6 329 .1 368.5 .1 416c0 53 43 96 96 96c1.1 0 2.2 0 3.2-.1l266 0c.9 0 1.8 0 2.7 0c44.2 0 80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-6.9c0-.9 0-1.8 0-2.7s0-1.8 0-2.7l0-5.3c0-2.9-.5-5.7-1.5-8.3c-7.7-40.8-43.4-71.7-86.5-71.7c-14.7 0-28.5 3.6-40.6 9.9c-17.3-25.3-46.3-41.9-79.3-41.9z"]
};
const faPotFood = {
  prefix: 'far',
  iconName: 'pot-food',
  icon: [640, 512, [127858], "e43f", "M112 24c0 26.5 10.5 38.7 25.9 56.1l.4 .4C154.8 99 176 122.9 176 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C85.2 93 64 69.1 64 24C64 10.7 74.7 0 88 0s24 10.7 24 24zm112 0c0 26.5 10.5 38.7 25.9 56.1l.4 .4C266.8 99 288 122.9 288 168c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-26.5-10.5-38.7-25.9-56.1l-.4-.4C197.2 93 176 69.1 176 24c0-13.3 10.7-24 24-24s24 10.7 24 24zm208 88c50.7 0 93.6 33.7 107.4 80l-214.7 0c13.8-46.3 56.6-80 107.4-80zM16 280c0-13.3 10.7-24 24-24l26.7 0c6.6-18.6 24.4-32 45.3-32l416 0c20.9 0 38.7 13.4 45.3 32l26.7 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-26.3 0c-11 76.9-61.1 141.2-129.5 172.2c-8.1 21-28.4 35.8-52.3 35.8l-144 0c-23.8 0-44.2-14.9-52.3-35.8C127.3 445.2 77.3 380.9 66.3 304L40 304c-13.3 0-24-10.7-24-24zM240.5 458.9c1.2 3.1 4.2 5.1 7.5 5.1l144 0c3.3 0 6.3-2 7.5-5.1c4.5-11.7 13.5-21.2 25-26.4C485.6 404.8 528 343.3 528 272l-416 0c0 71.3 42.4 132.8 103.5 160.5c11.5 5.2 20.4 14.7 25 26.4z"]
};
const faBriefcase = {
  prefix: 'far',
  iconName: 'briefcase',
  icon: [512, 512, [128188], "f0b1", "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 64 0c35.3 0 64 28.7 64 64l0 120 0 136c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 280 0 160c0-35.3 28.7-64 64-64l64 0zM48 304l0 112c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-112-144 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16L48 304zm144-48l128 0 144 0 0-96c0-8.8-7.2-16-16-16l-88 0-208 0-88 0c-8.8 0-16 7.2-16 16l0 96 144 0z"]
};
const faPersonFalling = {
  prefix: 'far',
  iconName: 'person-falling',
  icon: [512, 512, [], "e546", "M320 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 10.4c0 46.1-28.9 87.3-72.2 103.1C137.5 160.1 96 219.3 96 285.6L96 360c0 13.3 10.7 24 24 24s24-10.7 24-24l0-74.4c0-10.7 1.5-21.1 4.4-30.9L307.9 501c7.2 11.1 22.1 14.3 33.2 7.1s14.3-22.1 7.1-33.2L263.6 344.3 327 304l46.3 0 64.8 72.1c8.9 9.9 24 10.6 33.9 1.8s10.6-24 1.8-33.9l-67.2-74.7c-7.6-8.4-18.4-13.2-29.7-13.2l-56.6 0-.6 0-19 0-58.2-85.9c47.4-28 77.5-79.3 77.5-135.8L320 24zM263.9 287.2L237.5 304l-61.8-95.5c6.7-6.8 14.4-12.8 22.8-17.7l65.4 96.4zM112 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
};
const faImagePortrait = {
  prefix: 'far',
  iconName: 'image-portrait',
  icon: [384, 512, ["portrait"], "f3e0", "M320 48L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16zm0-48c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6l86.9 0c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4l-169.1 0C92.3 384 80 371.7 80 356.6z"]
};
const faPortrait = faImagePortrait;
const faUserTag = {
  prefix: 'far',
  iconName: 'user-tag',
  icon: [640, 512, [], "f507", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM398.7 464c-.5-3.4-1.1-6.7-1.8-10l45.6 45.6c-5.4 7.5-14.2 12.5-24.2 12.5L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c17.5 0 34.3 2.5 50.3 7.2l0 33c0 6.4 .8 12.7 2.3 18.8c-16.1-7.1-33.9-11-52.6-11l-91.4 0c-65.7 0-120.1 48.7-129 112l349.5 0zM384 224l82.7 0c17 0 33.3 6.7 45.3 18.7L619.3 350.1c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3l0-82.7c0-17.7 14.3-32 32-32zm72 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faRug = {
  prefix: 'far',
  iconName: 'rug',
  icon: [640, 512, [], "e569", "M24 64C10.7 64 0 74.7 0 88s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 32-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 40-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 24 0 480 0 24 0 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-32 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-40 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0-24 0L80 64 56 64 24 64zm56 48l48 0 0 288-48 0 0-64 0-80 0-80 0-64zM464 400l-288 0 0-288 288 0 0 288zm48 0l0-288 48 0 0 64 0 80 0 80 0 64-48 0z"]
};
const faPrintSlash = {
  prefix: 'far',
  iconName: 'print-slash',
  icon: [640, 512, [], "f686", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400l1.4 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64l-234.8 0L176 112.6 176 64c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L466.7 18.7C454.7 6.7 438.5 0 421.5 0L192 0c-35.3 0-64 28.7-64 64l0 11L38.8 5.1zM338.5 240L512 240c8.8 0 16 7.2 16 16l0 96-16 0-16 0-14.6 0L338.5 240zm-155.7 0l-60.6-47.7C89.6 195.2 64 222.6 64 256l0 112c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c15.5 0 28.5-11 31.4-25.7L448 449l0 15-256 0 0-96 153.2 0-60.9-48L176 320c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l54.8 0z"]
};
const faEarthEurope = {
  prefix: 'far',
  iconName: 'earth-europe',
  icon: [512, 512, ["globe-europe"], "f7a2", "M256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c3.5 0 6.9 .1 10.3 .3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c-4.1 12.6-9.3 24.7-15.6 36.1c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c-5.6 .5-11.4 .7-17.1 .7zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM187.3 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"]
};
const faGlobeEurope = faEarthEurope;
const faCartFlatbedSuitcase = {
  prefix: 'far',
  iconName: 'cart-flatbed-suitcase',
  icon: [640, 512, ["luggage-cart"], "f59d", "M0 24C0 10.7 10.7 0 24 0L72 0c30.9 0 56 25.1 56 56l0 352c0 4.4 3.6 8 8 8l72 0 288 0 120 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-192 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-24 0c-30.9 0-56-25.1-56-56L80 56c0-4.4-3.6-8-8-8L24 48C10.7 48 0 37.3 0 24zM360 48c-4.4 0-8 3.6-8 8l0 40 96 0 0-40c0-4.4-3.6-8-8-8l-80 0zM496 96l48 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-128c0-35.3 28.7-64 64-64l48 0 0-40c0-30.9 25.1-56 56-56l80 0c30.9 0 56 25.1 56 56l0 40zM256 144c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l32 0 0-160-32 0zm80 0l0 160 128 0 0-160-128 0zM544 304c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-32 0 0 160 32 0z"]
};
const faLuggageCart = faCartFlatbedSuitcase;
const faHandBackPointRibbon = {
  prefix: 'far',
  iconName: 'hand-back-point-ribbon',
  icon: [448, 512, [], "e1a0", "M96 64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32 0 64 0 .5c2.6-.3 5.3-.5 8-.5c24.5 0 45.7 13.7 56.5 33.9c5-1.2 10.2-1.9 15.5-1.9c23.9 0 44.8 13.1 55.7 32.5c2.7-.3 5.5-.5 8.3-.5c35.3 0 64 28.7 64 64l0 96 0 8c0 66.3-53.7 120-120 120l-125.4 0c-26.9 0-53.3-7.1-76.6-20.7l-2.6-1.5C60.7 462.5 32 412.5 32 358.5l0-10.2c0-24.8 10.5-48.4 28.8-65.1l20.3-18.4c4.8-4.3 9.7-8.3 14.9-11.9L96 176l-52.2 0c-6.5 0-11.8-5.3-11.8-11.8c0-3.9 1.9-7.5 5.1-9.7L75.6 128 37.1 101.5c-3.2-2.2-5.1-5.8-5.1-9.7C32 85.3 37.3 80 43.8 80L96 80l0-16zm48 112l0 88 0 2 0 78c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-42.5L93.1 318.7C84.8 326.3 80 337 80 348.3l0 10.2c0 37 19.6 71.2 51.6 89.8l2.6 1.5-11.7 20 11.7-20c15.9 9.3 34 14.2 52.4 14.2L312 464c39.8 0 72-32.2 72-72l0-8 0-96c0-8.8-7.2-16-16-16c-3.6 0-6.9 1.2-9.6 3.2c-7.3 5.5-17 6.3-25.1 2.3s-13.3-12.4-13.3-21.5c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8l0-8c0-8.8-7.2-16-16-16c-5.2 0-9.9 2.5-12.8 6.4c-6.2 8.3-17 11.6-26.8 8.3s-16.4-12.4-16.4-22.8l0-24-32 0zm32-96l0-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 16 32 0z"]
};
const faRectangleXmark = {
  prefix: 'far',
  iconName: 'rectangle-xmark',
  icon: [512, 512, [62164, "rectangle-times", "times-rectangle", "window-close"], "f410", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
};
const faRectangleTimes = faRectangleXmark;
const faTimesRectangle = faRectangleXmark;
const faWindowClose = faRectangleXmark;
const faTireRugged = {
  prefix: 'far',
  iconName: 'tire-rugged',
  icon: [512, 512, [], "f634", "M213.1 62c1-8 7.8-14 15.9-14l54.1 0c8.1 0 14.9 6 15.9 14c1.2 9.1 7.4 16.8 16.1 19.7c7.7 2.6 15.2 5.7 22.4 9.3c8.2 4.1 18.1 3.1 25.3-2.5c6.3-4.9 15.4-4.4 21.1 1.3l38.3 38.3c5.7 5.7 6.3 14.8 1.3 21.1c-5.6 7.3-6.6 17.1-2.5 25.3c3.6 7.2 6.7 14.7 9.3 22.4c2.9 8.7 10.6 15 19.7 16.1c8 1 14 7.8 14 15.9l0 54.1c0 8.1-6 14.9-14 15.9c-9.1 1.2-16.8 7.4-19.7 16.1c-2.6 7.7-5.7 15.2-9.3 22.4c-4.1 8.2-3.1 18.1 2.5 25.3c4.9 6.3 4.4 15.4-1.3 21.1l-38.3 38.3c-5.7 5.7-14.8 6.3-21.1 1.3c-7.3-5.6-17.1-6.6-25.3-2.5c-7.2 3.6-14.7 6.7-22.4 9.3c-8.7 2.9-15 10.6-16.1 19.7c-1 8-7.8 14-15.9 14l-54.1 0c-8.1 0-14.9-6-15.9-14c-1.2-9.1-7.4-16.8-16.1-19.7c-7.7-2.6-15.2-5.7-22.4-9.3c-8.2-4.1-18.1-3.1-25.3 2.5c-6.3 4.9-15.4 4.4-21.1-1.3L89.8 383.9c-5.7-5.7-6.3-14.8-1.3-21.1c5.6-7.3 6.6-17.1 2.5-25.3c-3.6-7.2-6.7-14.7-9.3-22.4c-2.9-8.7-10.6-15-19.7-16.1c-8-1-14-7.8-14-15.9l0-54.1c0-8.1 6-14.9 14-15.9c9.1-1.2 16.8-7.4 19.7-16.1c2.6-7.7 5.7-15.2 9.3-22.4c4.1-8.2 3.1-18.1-2.5-25.3c-4.9-6.3-4.4-15.4 1.3-21.1l38.3-38.3c5.7-5.7 14.8-6.3 21.1-1.3c7.3 5.6 17.1 6.6 25.3 2.5c7.2-3.6 14.7-6.7 22.4-9.3c8.7-2.9 15-10.6 16.1-19.7zM228.9 0C202 0 178.6 16.7 169.3 40.8c-1.4 .6-2.8 1.1-4.2 1.7c-23.6-10.4-51.9-5.7-71 13.4L55.8 94.1c-19 19-23.7 47.4-13.4 71c-.6 1.4-1.2 2.8-1.7 4.2C16.7 178.6 0 202 0 228.9l0 54.1c0 26.9 16.7 50.3 40.8 59.6c.6 1.4 1.1 2.8 1.7 4.2c-10.4 23.6-5.7 51.9 13.4 71l38.3 38.3c19 19 47.4 23.7 71 13.4c1.4 .6 2.8 1.2 4.2 1.7c9.4 24 32.7 40.8 59.6 40.8l54.1 0c26.9 0 50.3-16.7 59.6-40.8c1.4-.6 2.8-1.1 4.2-1.7c23.6 10.4 51.9 5.7 71-13.4l38.3-38.3c19-19 23.7-47.4 13.4-71c.6-1.4 1.2-2.8 1.7-4.2c24-9.4 40.8-32.7 40.8-59.6l0-54.1c0-26.9-16.7-50.3-40.8-59.6c-.6-1.4-1.1-2.8-1.7-4.2c10.4-23.6 5.7-51.9-13.4-71L417.9 55.8c-19-19-47.4-23.7-71-13.4c-1.4-.6-2.8-1.2-4.2-1.7C333.4 16.7 310 0 283.1 0L228.9 0zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM232 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-67.3 42.3a24 24 0 1 1 45.7 14.8 24 24 0 1 1 -45.7-14.8zm152.4-15.4a24 24 0 1 1 14.8 45.7 24 24 0 1 1 -14.8-45.7zm-4.6 122.7a24 24 0 1 1 -28.2-38.8 24 24 0 1 1 28.2 38.8zm-79.3-5.3a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2z"]
};
const faLightbulbDollar = {
  prefix: 'far',
  iconName: 'lightbulb-dollar',
  icon: [384, 512, [], "f670", "M320 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8.1 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C72.4 228.3 64 203.2 64 176c0-70.7 57.3-128 128-128s128 57.3 128 128zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zm16-400c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6c0 0 0 0 0 0s0 0 0 0c7.1 2.3 15.1 4.9 23.7 6.6l0 11.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-10.8c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5c0 0 0 0 0-.1c-.1-1.9 .3-2.9 .8-3.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7l0-9.4z"]
};
const faCowbell = {
  prefix: 'far',
  iconName: 'cowbell',
  icon: [448, 512, [], "f8b3", "M176 48l96 0 0 48-96 0 0-48zm-48-8l0 56-16 0c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416l352 0c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96l-16 0 0-56c0-22.1-17.9-40-40-40L168 0c-22.1 0-40 17.9-40 40zM112 144l224 0 64 224L48 368l64-224zM288 448l-128 0c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faBahtSign = {
  prefix: 'far',
  iconName: 'baht-sign',
  icon: [320, 512, [], "e0ac", "M136 0c-13.3 0-24 10.7-24 24l0 40L37.6 64C16.8 64 0 80.8 0 101.6L0 232l0 41.7L0 280 0 406.3c0 23 18.7 41.7 41.7 41.7l70.3 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 52 0c59.6 0 108-48.4 108-108c0-42.1-24.1-78.5-59.2-96.4C277.7 224.6 288 199.5 288 172c0-59.6-48.4-108-108-108l-20 0 0-40c0-13.3-10.7-24-24-24zM112 112l0 120-64 0 0-120 64 0zm48 120l0-120 20 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-20 0zm-48 48l0 120-64 0 0-120 64 0zm48 120l0-120 20 0 32 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-52 0z"]
};
const faCorner = {
  prefix: 'far',
  iconName: 'corner',
  icon: [448, 512, [], "e3fe", "M0 184c0-13.3 10.7-24 24-24l368 0c30.9 0 56 25.1 56 56l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-4.4-3.6-8-8-8L24 208c-13.3 0-24-10.7-24-24z"]
};
const faChevronsRight = {
  prefix: 'far',
  iconName: 'chevrons-right',
  icon: [512, 512, ["chevron-double-right"], "f324", "M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"]
};
const faChevronDoubleRight = faChevronsRight;
const faBookOpen = {
  prefix: 'far',
  iconName: 'book-open',
  icon: [576, 512, [128214, 128366], "f518", "M156 32C100.6 32 48.8 46.6 27.1 53.6C10.3 59 0 74.5 0 91.1L0 403.5c0 26.1 24 44.2 48 40.2c19.8-3.3 54.8-7.7 100-7.7c54 0 97.5 25.5 112.5 35.6c7.5 5 16.8 8.4 27 8.4c11.5 0 21.6-4.2 29.3-9.9C330.2 460.3 369.1 436 428 436c47.7 0 80.5 4 99 7.2c23.9 4.1 49-13.8 49-40.6l0-311.5c0-16.5-10.3-32.1-27.1-37.5C527.2 46.6 475.4 32 420 32c-36.8 0-71.8 6.4-97.4 12.7c-12.8 3.2-23.5 6.3-30.9 8.7c-1.3 .4-2.6 .8-3.7 1.2c-1.1-.4-2.4-.8-3.7-1.2c-7.5-2.4-18.1-5.5-30.9-8.7C227.8 38.4 192.8 32 156 32zM264 97.3l0 320.6C238 404.2 196.8 388 148 388c-42.9 0-77.4 3.7-100 7.1L48 97.3C70.3 90.6 112.4 80 156 80c31.6 0 62.6 5.6 85.9 11.3c8.6 2.1 16.1 4.2 22.1 6zm48 319.2l0-319.2c6-1.8 13.5-3.9 22.1-6C357.4 85.6 388.4 80 420 80c43.6 0 85.7 10.6 108 17.3l0 297.4c-21.7-3.3-54.9-6.7-100-6.7c-51.4 0-90.8 15-116 28.6z"]
};
const faBookJournalWhills = {
  prefix: 'far',
  iconName: 'book-journal-whills',
  icon: [448, 512, ["journal-whills"], "f66a", "M0 88C0 39.4 39.4 0 88 0L392 0c30.9 0 56 25.1 56 56l0 288c0 22.3-13.1 41.6-32 50.6l0 69.4 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L80 512c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8L0 424 0 88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0 0-64L80 400zM48 358.7c9.8-4.3 20.6-6.7 32-6.7l312 0c4.4 0 8-3.6 8-8l0-288c0-4.4-3.6-8-8-8L88 48C65.9 48 48 65.9 48 88l0 270.7zM148.8 190.5c3.4 3.4 8.9 3.4 12.3 0s3.4-8.9 0-12.3l-28.8-28.9c8.2-17 20.2-31.8 35-43.4c3.9-3.1 9.3 1.9 7.9 6.7c-6.9 23.5-.9 49.4 16.5 67.2c3.3 3.4 3.6 8.8 .9 12.6c-11 15.4-14.4 35.2-8.7 53.5c6.4 21.1 24 37.2 45.7 41.7L231 252l-11.3 7.8c-.7 .4-1.6 .7-2.5 .7c-1.1 0-2.2-.4-3-1.1c-.8-1-1.4-2-1.4-3.3c0-.7 .3-1.5 .5-2.2l9.4-15.5-19.6-4.1c-1.9-.4-3.4-2.3-3.4-4.4s1.5-3.8 3.4-4.2l19.6-4.1L213.4 206c-1-1.8-.7-4.1 .8-5.5s3.8-1.6 5.5-.4l13.1 8.9 5-120.8c.1-2.5 2-4.2 4.4-4.2s4.2 1.8 4.4 4.2l5.2 122.5 15.4-10.5c.6-.5 1.5-.7 2.3-.8l.1 0c1.6 0 3 .8 3.8 2.2s.7 3.1-.1 4.5L264 221.6l19.6 4.1c1.9 .4 3.4 2.2 3.4 4.2s-1.5 4-3.4 4.4l-19.6 4 9.3 15.7c.8 1.4 1 3 .1 4.4s-2.2 2.2-3.8 2.2c-.8 0-1.8-.3-2.5-.7l-13.8-9.4 1.5 37.4c21.7-4.5 39.3-20.6 45.7-41.7c5.7-18.3 2.3-38.2-8.7-53.5c-2.8-3.8-2.4-9.3 .9-12.7c17.4-17.9 23.4-43.8 16.4-67.3c-1.4-4.8 4-9.7 7.9-6.7c14.8 11.5 26.8 26.4 35 43.5l-28.8 28.9c-3.4 3.4-3.4 8.9 0 12.3s8.9 3.4 12.3 0l23.2-23.2c3.3 11 5.6 22.5 5.6 34.5c0 .3 0 .5-.1 .8s-.1 .5-.1 .8l-40.5 35.5c-1.8 1.8-2.9 4.1-3 6.5c.1 2 .8 4.1 2.2 5.7c1.8 1.8 4.1 2.9 6.5 3c2.2 0 4.2-.8 5.7-2.2L361 229.5C348.3 283.6 300.1 324 242.2 324s-106.1-40.4-118.8-94.5L149.2 252c1.6 1.4 3.7 2 5.7 2.2c3.7 0 6.8-2.3 8.2-5.6c1.2-3.4 .3-7.4-2.5-9.7l-40.5-35.5c0-.3 0-.5-.1-.8s-.1-.5-.1-.8c0-12 2.3-23.5 5.6-34.5l23.2 23.2z"]
};
const faJournalWhills = faBookJournalWhills;
const faInhaler = {
  prefix: 'far',
  iconName: 'inhaler',
  icon: [576, 512, [], "f5f9", "M429.8 32.7l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248 386.9 101.6l14-51.8c3.4-12.6 16.3-20.2 29-17zM389 216.9l-2.1 7.8C379.4 252.6 354 272 325.1 272L240 272l0 160 209.9 0 33-121.2-94-94zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480l-224 0c-22.1 0-40-17.9-40-40l0-176c0-22.1 17.9-40 40-40l93.1 0c7.2 0 13.6-4.9 15.4-11.8L357 150.9c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM0 256a32 32 0 1 1 64 0A32 32 0 1 1 0 256zm0 96a32 32 0 1 1 64 0A32 32 0 1 1 0 352zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm128-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faHandcuffs = {
  prefix: 'far',
  iconName: 'handcuffs',
  icon: [640, 512, [], "e4f8", "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32zm0 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 352c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1l0-16c0-13.3 10.7-24 24-24l8 0c0-17.7 14.3-32 32-32s32 14.3 32 32l8 0c13.3 0 24 10.7 24 24l0 16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm240 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faSnake = {
  prefix: 'far',
  iconName: 'snake',
  icon: [512, 512, [128013], "f716", "M305.6 96l-22.7 0L168 96C110.6 96 64 142.6 64 200s46.6 104 104 104l152 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-63.9 0c0 0 0 0-.1 0c0 0 0 0 0 0l-137.3 0c-7.5 0-14.8 1.7-21.5 5.1L75.3 448l21.9 10.9c6.7 3.3 14 5.1 21.5 5.1l57.2 0c0 0 0 0 .1 0c0 0 .1 0 .1 0c0 0 0 0 .1 0L320 464c53 0 96-43 96-96s-43-96-96-96l-152 0c-39.8 0-72-32.2-72-72s32.2-72 72-72l114.9 0 22.7 0L320 145.5c11.6 14.1 29 22.5 47.6 22.5c9 0 17.9-2 26.1-5.8l54.4-25.4c9.6-4.5 15.8-14.2 15.8-24.8s-6.2-20.3-15.8-24.8L393.8 61.8C385.6 58 376.7 56 367.7 56c-18.6 0-36 8.4-47.6 22.5L305.6 96zM176 512l-.1 0-57.2 0c-14.9 0-29.6-3.5-42.9-10.1L14.3 471.2C5.5 466.8 0 457.8 0 448s5.5-18.8 14.3-23.2l61.4-30.7c6.5-3.3 13.3-5.7 20.4-7.4c7.4-1.8 14.9-2.7 22.6-2.7l49.3 0 88 0 .1 0 36.2 0 27.7 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-27.7 0-36.1 0c0 0 0 0 0 0s0 0-.1 0s0 0 0 0l-88 0c-17.3 0-33.9-2.9-49.3-8.2c-5.7-2-11.3-4.2-16.7-6.8c-50.9-24.6-86-76.7-86-137C16 116.1 84.1 48 168 48l114.9 0c20.6-25.1 51.6-40 84.7-40c16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-49.6 23.1-4.9 2.3c-14.5 6.8-30.4 10.3-46.4 10.3c-16.8 0-33-3.8-47.7-10.9c-14.2-6.9-26.9-16.7-37.1-29.1L168 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l94.7 0 20.2 0 37.1 0c16.7 0 32.7 2.8 47.7 8.1c16.5 5.8 31.6 14.5 44.7 25.5C443.9 283.9 464 323.6 464 368c0 79.5-64.5 144-144 144l-144 0zM352 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faTriangleExclamation = {
  prefix: 'far',
  iconName: 'triangle-exclamation',
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z"]
};
const faExclamationTriangle = faTriangleExclamation;
const faWarning = faTriangleExclamation;
const faNoteMedical = {
  prefix: 'far',
  iconName: 'note-medical',
  icon: [448, 512, [], "e200", "M384 80c8.8 0 16 7.2 16 16l0 224-80 0c-17.7 0-32 14.3-32 32l0 80L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 480l224 0 5.5 0c17 0 33.3-6.7 45.3-18.7l90.5-90.5c12-12 18.7-28.3 18.7-45.3l0-5.5 0-224c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64zM192 144l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faDatabase = {
  prefix: 'far',
  iconName: 'database',
  icon: [448, 512, [], "f1c0", "M400 86l0 88.7c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 203 269.5 208 224 208s-87.3-5-121.2-13.4C79.6 188.9 61.3 182 48 174.7L48 86l.6-.5C53.9 81 64.5 74.8 81.8 68.6C115.9 56.5 166.2 48 224 48s108.1 8.5 142.2 20.6c17.3 6.2 27.8 12.4 33.2 16.9l.6 .5zm0 141.5l0 75.2c-13.3 7.2-31.6 14.2-54.8 19.9C311.3 331 269.5 336 224 336s-87.3-5-121.2-13.4C79.6 316.9 61.3 310 48 302.7l0-75.2c13.3 5.3 27.9 9.9 43.3 13.7C129.5 250.6 175.2 256 224 256s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7zM48 426l0-70.4c13.3 5.3 27.9 9.9 43.3 13.7C129.5 378.6 175.2 384 224 384s94.5-5.4 132.7-14.8c15.4-3.8 30-8.3 43.3-13.7l0 70.4-.6 .5c-5.3 4.5-15.9 10.7-33.2 16.9C332.1 455.5 281.8 464 224 464s-108.1-8.5-142.2-20.6c-17.3-6.2-27.8-12.4-33.2-16.9L48 426zm354.1-2.1s0 .1-.2 .2l.1-.2c0 0 0 0 0-.1zm-356.1 0s0 .1 .2 .2c-.1-.1-.1-.2-.2-.2zm0-335.8s.1-.1 .2-.2c-.1 .1-.2 .2-.2 .2zm356-.2c.1 .1 .2 .2 .2 .2s0-.1-.2-.2zM448 432l0-352C448 35.8 347.7 0 224 0S0 35.8 0 80L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80z"]
};
const faDownLeft = {
  prefix: 'far',
  iconName: 'down-left',
  icon: [384, 512, [], "e16a", "M64 384l0-193.4c0-1.7 .8-3.2 2.1-4.2c2.1-1.6 5-1.4 6.9 .5L127 241c9.4 9.4 24.6 9.4 33.9 0L285.7 116.3c2.7-2.7 6.5-4.3 10.3-4.3s7.6 1.5 10.3 4.3l25.4 25.4c2.7 2.7 4.3 6.5 4.3 10.3s-1.5 7.6-4.3 10.3L207 287c-9.4 9.4-9.4 24.6 0 33.9L261.1 375c1.8 1.8 2.1 4.8 .5 6.9c-1 1.3-2.5 2.1-4.2 2.1L64 384zm-48 8c0 22.1 17.9 40 40 40l201.4 0c16.8 0 32.5-7.9 42.6-21.3c15.9-21.2 13.8-50.9-4.9-69.6L257.9 304 365.7 196.3C377.4 184.5 384 168.6 384 152s-6.6-32.5-18.3-44.3L340.3 82.4C328.5 70.6 312.6 64 296 64s-32.5 6.6-44.3 18.3L144 190.1 106.9 153c-18.7-18.7-48.4-20.8-69.6-5C23.9 158.1 16 173.9 16 190.6L16 392z"]
};
const faShare = {
  prefix: 'far',
  iconName: 'share',
  icon: [512, 512, ["mail-forward"], "f064", "M288 240l-96 0c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128l112 0 24 0c13.3 0 24-10.7 24-24l0-24 0-28.1L456.1 208 336 316.1l0-28.1 0-24c0-13.3-10.7-24-24-24l-24 0zm0 48l0 48 0 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2l0 16 0 48-48 0-64 0C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96l48 0 48 0z"]
};
const faMailForward = faShare;
const faFaceThinking = {
  prefix: 'far',
  iconName: 'face-thinking',
  icon: [512, 512, [], "e39b", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352l0 28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8 .2 7.7 .3 11.6 .3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352l0 48.4 167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1 .4-.3 .8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6L112 512c-26.5 0-48-21.5-48-48l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faTurnDownRight = {
  prefix: 'far',
  iconName: 'turn-down-right',
  icon: [512, 512, [], "e455", "M505.5 271.6c8.7 9.2 8.7 23.7 0 32.9l-121.4 129c-8.8 9.3-21 14.6-33.7 14.6c-25.6 0-46.3-20.7-46.3-46.3l0-41.7-144 0C71.6 360 0 288.4 0 200L0 88C0 57.1 25.1 32 56 32l32 0c30.9 0 56 25.1 56 56l0 120c0 4.4 3.6 8 8 8l152 0 0-41.7c0-25.6 20.7-46.3 46.3-46.3c12.8 0 25 5.3 33.7 14.6l121.4 129zM352 178.5l0 61.5c0 13.3-10.7 24-24 24l-176 0c-30.9 0-56-25.1-56-56L96 88c0-4.4-3.6-8-8-8L56 80c-4.4 0-8 3.6-8 8l0 112c0 61.9 50.1 112 112 112l168 0c13.3 0 24 10.7 24 24l0 61.5L455 288 352 178.5z"]
};
const faBottleDroplet = {
  prefix: 'far',
  iconName: 'bottle-droplet',
  icon: [320, 512, [], "e4c4", "M128 48l0 104.2c0 16-8 31-21.3 39.9C80.9 209.4 64 238.8 64 272l0 176c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16l0-176c0-33.2-16.9-62.6-42.7-79.9C200 183.2 192 168.3 192 152.2L192 48l-64 0zM256 24c0 10.4-6.7 19.3-16 22.6l0 105.6c38.6 25.8 64 69.8 64 119.8l0 176c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64l0-176c0-49.9 25.4-93.9 64-119.8L80 46.6C70.7 43.3 64 34.5 64 24C64 10.7 74.7 0 88 0L232 0c13.3 0 24 10.7 24 24zM160 384c-26.5 0-48-21.5-48-48c0-22.2 23-52 37.2-68.2c5.8-6.7 15.9-6.7 21.7 0C185 284 208 313.8 208 336c0 32-21.5 48-48 48z"]
};
const faMaskFace = {
  prefix: 'far',
  iconName: 'mask-face',
  icon: [640, 512, [], "e1d7", "M320 112c17.7 0 35 5.2 49.8 15.1l37.1 24.8c23.7 15.8 51.4 24.2 79.9 24.2l9.2 0 0 48c0 59.5-29.5 112.1-74.7 143.9l-3.1 .8 .3 1.2c-28.1 19-62 30.1-98.5 30.1s-70.4-11.1-98.5-30.1l.3-1.2-3.1-.8C173.5 336.1 144 283.5 144 224l0-48 9.2 0c28.4 0 56.2-8.4 79.9-24.2l37.1-24.8c14.7-9.8 32-15.1 49.8-15.1zM96 224c0 45.1 13.4 87.2 36.3 122.3l-29.8-7.4C70.5 330.9 48 302.1 48 269l0-85c0-4.4 3.6-8 8-8l40 0 0 48zM90.9 385.5l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269l0-85c0-30.9-25.1-56-56-56l-72 0-16 0-9.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1l-9.2 0-16 0-72 0c-30.9 0-56 25.1-56 56l0 85c0 55.1 37.5 103.1 90.9 116.4zm446.6-46.6l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3l0-48 40 0c4.4 0 8 3.6 8 8l0 85c0 33-22.5 61.8-54.5 69.9zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0zm-16 80c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0z"]
};
const faHillRockslide = {
  prefix: 'far',
  iconName: 'hill-rockslide',
  icon: [576, 512, [], "e508", "M128 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm124.4 71.8c-2.7-4.9-2.7-10.8 0-15.7l27-48c2.8-5 8.2-8.2 13.9-8.2l53.3 0c5.8 0 11.1 3.1 13.9 8.2l27 48c2.7 4.9 2.7 10.8 0 15.7l-27 48c-2.8 5-8.2 8.2-13.9 8.2l-53.3 0c-5.8 0-11.1-3.1-13.9-8.2l-27-48zM48 145.9L48 440c0 13.3 10.7 24 24 24l294.1 0L48 145.9zM0 126.6C0 91 43.1 73.1 68.3 98.3L413.7 443.7c25.2 25.2 7.4 68.3-28.3 68.3L72 512c-39.8 0-72-32.2-72-72L0 126.6zm504.2 277l-48-27c-5-2.8-8.2-8.2-8.2-13.9l0-53.3c0-5.8 3.1-11.1 8.2-13.9l48-27c4.9-2.7 10.8-2.7 15.7 0l48 27c5 2.8 8.2 8.2 8.2 13.9l0 53.3c0 5.8-3.1 11.1-8.2 13.9l-48 27c-4.9 2.7-10.8 2.7-15.7 0zM352 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faScannerKeyboard = {
  prefix: 'far',
  iconName: 'scanner-keyboard',
  icon: [512, 512, [], "f489", "M128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176 0l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM240 0c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zM384 16l0 256c0 8.8 7.2 16 16 16s16-7.2 16-16l0-256c0-8.8-7.2-16-16-16s-16 7.2-16 16zM488 0c-13.3 0-24 10.7-24 24l0 240c0 13.3 10.7 24 24 24s24-10.7 24-24l0-240c0-13.3-10.7-24-24-24zM64 144l224 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16zm0-48C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 96zm40 80c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-32c0-13.3-10.7-24-24-24l-144 0zM96 304c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0zM80 400l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16zm128-96c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0zm-16 96l0 16c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0c-8.8 0-16 7.2-16 16z"]
};
const faCircleO = {
  prefix: 'far',
  iconName: 'circle-o',
  icon: [512, 512, [], "e119", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-256a80 80 0 1 1 -160 0 80 80 0 1 1 160 0zM256 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"]
};
const faGridHorizontal = {
  prefix: 'far',
  iconName: 'grid-horizontal',
  icon: [448, 512, [], "e307", "M40 168l0 48 48 0 0-48-48 0zM0 168c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM40 328l0 48 48 0 0-48-48 0zM0 328c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM248 168l-48 0 0 48 48 0 0-48zm-48-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 200l0 48 48 0 0-48-48 0zm-40 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48zM408 168l-48 0 0 48 48 0 0-48zm-48-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm0 200l0 48 48 0 0-48-48 0zm-40 0c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48z"]
};
const faMessageDollar = {
  prefix: 'far',
  iconName: 'message-dollar',
  icon: [512, 512, ["comment-alt-dollar"], "f650", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM276 104c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
};
const faCommentAltDollar = faMessageDollar;
const faRightLeft = {
  prefix: 'far',
  iconName: 'right-left',
  icon: [512, 512, ["exchange-alt"], "f362", "M336 215c0 22.6 18.3 41 41 41c10.9 0 21.3-4.3 29-12l99-99c4.5-4.5 7-10.6 7-17s-2.5-12.5-7-17l-99-99c-7.7-7.7-18.1-12-29-12c-22.6 0-41 18.3-41 41l0 63L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l312 0 0 63zm118.1-87L384 198.1l0-140.1L454.1 128zM135 256c-10.9 0-21.3 4.3-29 12L7 367c-4.5 4.5-7 10.6-7 17s2.5 12.5 7 17l99 99c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41l0-63 312 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-312 0 0-63c0-22.6-18.3-41-41-41zm-7 198.1L57.9 384 128 313.9l0 140.1z"]
};
const faExchangeAlt = faRightLeft;
const faColumns3 = {
  prefix: 'far',
  iconName: 'columns-3',
  icon: [640, 512, [], "e361", "M448 80l0 352 128 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L448 80zm-48 0L240 80l0 352 160 0 0-352zM192 432l0-352L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l128 0zM0 96C0 60.7 28.7 32 64 32l512 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z"]
};
const faPaperPlane = {
  prefix: 'far',
  iconName: 'paper-plane',
  icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
};
const faRoadCircleExclamation = {
  prefix: 'far',
  iconName: 'road-circle-exclamation',
  icon: [640, 512, [], "e565", "M217.7 32c-30.4 0-57.5 19-67.7 47.6L40.6 383.6C23.7 430.5 58.4 480 108.3 480l251.9 0c-21.9-26.6-36.2-59.7-39.5-96c-.2 0-.5 0-.7 0c-13.3 0-24 10.7-24 24l0 24-187.7 0c-16.6 0-28.2-16.5-22.6-32.1l109.4-304c3.4-9.5 12.5-15.9 22.6-15.9L296 80l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 78.3 0c10.1 0 19.2 6.3 22.6 15.9l34.9 96.9c5.4-.5 10.8-.7 16.3-.7c12.3 0 24.2 1.3 35.8 3.6L490 79.6C479.7 51 452.6 32 422.3 32L217.7 32zM326.9 319c4.1-14.1 9.8-27.4 17.1-39.8l0-63.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24c2.4 0 4.7-.4 6.9-1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"]
};
const faDungeon = {
  prefix: 'far',
  iconName: 'dungeon',
  icon: [512, 512, [], "f6d9", "M256 128c-6.9 0-13.7 .5-20.4 1.4l-.2 0c-7.8 1-15.6-3-18.5-10.3l-.7-1.8L199 74.3l-.2-.5c-3-7.6 .2-16.2 7.2-19.5c.9-.4 1.9-.8 2.9-1C224.1 49.8 239.8 48 256 48s31.9 1.8 47.1 5.3c1 .2 2 .6 2.9 1c7 3.3 10.3 11.9 7.2 19.5l-.2 .5-17.2 43.1-.7 1.8c-2.9 7.3-10.7 11.3-18.5 10.3l-.2 0c-6.6-.9-13.4-1.4-20.4-1.4zM96 512l32 0 256 0 32 0 32 0c35.3 0 64-28.7 64-64l0-40c0-11.7-3.1-22.6-8.6-32c5.4-9.4 8.6-20.3 8.6-32l0-40c0-11.7-3.1-22.6-8.6-32c5.8-10.2 8.9-22.3 7.8-35.6c-2.2-28.6-9.1-56-19.9-81.2c-6.1-14.3-16.2-24.5-28-30.6c-.6-13.3-5.5-26.7-15.8-38.3c-16.8-18.9-36.4-35.4-58.1-48.7c-13.2-8.1-27.3-10.6-40.5-8.8c-8.2-10.5-20-18.7-35.1-22.1C295.2 2.3 275.9 0 256 0s-39.2 2.3-57.9 6.6C183 10.1 171.2 18.2 163 28.7c-13.2-1.8-27.3 .7-40.5 8.8C100.8 50.8 81.2 67.3 64.4 86.2c-10.2 11.6-15.2 25-15.8 38.3c-11.8 6.2-21.9 16.3-28 30.6C9.8 180.4 2.9 207.8 .7 236.4c-1 13.3 2 25.4 7.8 35.6C3.1 281.4 0 292.3 0 304l0 40c0 11.7 3.1 22.6 8.6 32C3.1 385.4 0 396.3 0 408l0 40c0 35.3 28.7 64 64 64l32 0zM371.4 165.2c-6.4 4.3-14.8 3.3-20.7-1.6l-.2-.2c-5.5-4.8-11.4-9.2-17.6-13.1l-.2-.2c-6.3-4.2-9.6-11.8-7.7-19c.2-.6 .4-1.2 .6-1.8l17.2-43.1 .2-.5c3.2-7.4 11.4-11.1 18.7-8.6c1 .3 1.9 .8 2.8 1.3c17.7 10.8 33.6 24.2 47.2 39.6c.7 .8 1.3 1.7 1.8 2.6c3.8 6.7 1.5 15.4-5.2 19.9l-1.1 .8-32.6 21.7-3.2 2.1zm15.4 46.4l-.2-.4c-2.8-6.5-1.8-14 2.8-19c.9-.9 1.8-1.8 2.9-2.5l32.6-21.7c.4-.3 .8-.5 1.2-.7c6.8-3.8 15.3-2 19.6 4.1c.6 .8 1.1 1.7 1.5 2.7c8.8 20.5 14.4 42.7 16.2 66c0 .6 .1 1.2 0 1.9c-.4 7.9-7.2 14.1-15.4 14.1l-32 0-2.6 0c-7.8 0-14.3-5.7-16.4-13.2c-.1-.3-.2-.7-.2-1c-2.2-10.6-5.7-20.7-10.1-30.3zM400 304c0-.5 0-.9 .1-1.4c.6-7.3 6.2-13.3 13.4-14.4c.8-.1 1.7-.2 2.6-.2l32 0c8.1 0 14.9 6.1 15.9 14c.1 .7 .1 1.4 .1 2l0 40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14l-32 0c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2l0-40zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14l32 0c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2l0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40zM147.6 78.5c.9-.6 1.8-1 2.8-1.3c7.3-2.6 15.5 1.2 18.7 8.6l.2 .5 17.2 43.1c.2 .6 .4 1.2 .6 1.8c1.9 7.2-1.4 14.8-7.7 19l-.3 .2c-6.2 3.9-12.1 8.3-17.6 13.1l-.2 .2c-5.9 4.9-14.3 5.9-20.7 1.6l-3.2-2.1-32.6-21.7-1.1-.8c-6.7-4.5-9-13.2-5.2-19.9c.5-.9 1.1-1.8 1.8-2.6c13.7-15.4 29.6-28.8 47.2-39.6zM64.8 174.1c.4-1 .9-1.9 1.5-2.7c4.3-6.1 12.8-7.9 19.6-4.1c.4 .2 .8 .5 1.2 .7l32.6 21.7c1.1 .7 2.1 1.6 2.9 2.5c4.6 5 5.6 12.6 2.8 19l-.2 .4c-4.4 9.6-7.8 19.7-10.1 30.3c-.1 .3-.1 .7-.2 1c-2 7.5-8.6 13.2-16.4 13.2L96 256l-32 0c-8.2 0-15-6.2-15.4-14.1c0-.6 0-1.2 0-1.9c1.8-23.3 7.4-45.5 16.2-66zM48 304c0-.7 0-1.4 .1-2c1-7.9 7.7-14 15.9-14l32 0c.9 0 1.7 .1 2.6 .2c7.2 1.2 12.8 7.1 13.4 14.4c0 .5 .1 .9 .1 1.4l0 40c0 .7 0 1.3-.1 2c-1 7.9-7.7 14-15.9 14l-32 0c-8.2 0-14.9-6.1-15.9-14c-.1-.6-.1-1.3-.1-2l0-40zm0 104c0-.7 0-1.3 .1-2c1-7.9 7.7-14 15.9-14l32 0c8.2 0 14.9 6.1 15.9 14c.1 .6 .1 1.3 .1 2l0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40zM272 192l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 32l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 0l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
};
const faHandHoldingBox = {
  prefix: 'far',
  iconName: 'hand-holding-box',
  icon: [576, 512, [], "f47b", "M432 48l-80 0 0 73.7c0 3.5-2.8 6.3-6.3 6.3c-1.1 0-2.2-.3-3.1-.8l-46.6-26.6c-4.9-2.8-11-2.8-15.9 0l-46.6 26.6c-1 .5-2 .8-3.1 .8c-3.5 0-6.3-2.8-6.3-6.3L224 48l-80 0 0 160 288 0 0-160zm0-48c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48L96 48c0-26.5 21.5-48 48-48l80 0L352 0l80 0zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faInputText = {
  prefix: 'far',
  iconName: 'input-text',
  icon: [640, 512, [], "e1bf", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7-75.5 0-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280l32.8 0L184 243.1zM304 184c0-13.3 10.7-24 24-24l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0c-13.3 0-24-10.7-24-24l0-8 0-64 0-64 0-8zm48 24l0 24 28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0zm0 96l44 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24z"]
};
const faWindowFlip = {
  prefix: 'far',
  iconName: 'window-flip',
  icon: [512, 512, ["window-alt"], "f40f", "M512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64 0 48 0 16L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192 0-16 0-48 0-64zM48 224l416 0 0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192zM416 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faWindowAlt = faWindowFlip;
const faAlignRight = {
  prefix: 'far',
  iconName: 'align-right',
  icon: [448, 512, [], "f038", "M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24L184 88c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 216c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0zm24 152c0 13.3-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0c13.3 0 24 10.7 24 24zM424 424c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 472c-13.3 0-24-10.7-24-24s10.7-24 24-24l400 0z"]
};
const faScannerGun = {
  prefix: 'far',
  iconName: 'scanner-gun',
  icon: [576, 512, ["scanner"], "f488", "M112 80c-35.3 0-64 28.7-64 64s28.7 64 64 64l120.4 0 55.6 0 16 0 0-128L112 80zM79.1 251.1C33.3 237.1 0 194.4 0 144C0 82.1 50.1 32 112 32l192 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-44 0L144.3 454.4c-13.4 23-42.9 30.7-65.8 17.2L25 440.1C2.3 426.8-5.4 397.6 7.8 374.8L79.1 251.1zm52.6 4.9L49.4 398.8l53.5 31.4L204.4 256l-72.7 0zM440 32l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L440 80c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 216c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm24 216l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM416 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm16 144l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z"]
};
const faScanner = faScannerGun;
const faTire = {
  prefix: 'far',
  iconName: 'tire',
  icon: [512, 512, [], "f631", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 .9l39.2 12.8c.5-4.5 .8-9 .8-13.6c0-31.2-11.9-59.6-31.4-80.9l-24.2 33.4c9.8 13.3 15.6 29.7 15.6 47.5c0 .3 0 .6 0 .9zm-14.9 45.6c-10 14-24.4 24.6-41.2 29.9l0 41.3c34.4-7 63.5-28.7 80.4-58.3l-39.3-12.8zM232 373.6l0-41.3c-16.7-5.3-31.1-15.9-41.1-29.8l-39.3 12.8c16.8 29.6 45.9 51.3 80.3 58.3zm-95.2-104L176 256.9c0-.3 0-.6 0-.9c0-17.8 5.8-34.2 15.6-47.5l-1.7-2.3-22.6-31.1C147.9 196.4 136 224.8 136 256c0 4.6 .3 9.2 .8 13.6zm93.6-89.5c8-2.7 16.6-4.2 25.6-4.2s17.6 1.5 25.6 4.2l24.2-33.4c-15.2-6.9-32-10.8-49.8-10.8s-34.6 3.9-49.8 10.8L228.8 178l1.6 2.2zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 88a168 168 0 1 1 0 336 168 168 0 1 1 0-336z"]
};
const faEngine = {
  prefix: 'far',
  iconName: 'engine',
  icon: [640, 512, [], "e16e", "M424 88c0 13.3-10.7 24-24 24l-72 0 0 32 68.6 0c12.6 0 25 3.7 35.5 10.7L483.5 189c17.8 11.9 28.5 31.9 28.5 53.3L512 384c0 35.3-28.7 64-64 64l-193.2 0c-19.4 0-37.8-8.8-50-24l-32-40L144 384c-35.3 0-64-28.7-64-64l0-40-32 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 160c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 32 0 0-24c0-35.3 28.7-64 64-64l16 0 32 0 88 0 0-32-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c13.3 0 24 10.7 24 24zM288 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM172.8 336c14.6 0 28.4 6.6 37.5 18l32 40c3 3.8 7.6 6 12.5 6L448 400c8.8 0 16-7.2 16-16l0-141.7c0-5.3-2.7-10.3-7.1-13.3l-51.4-34.3c-2.6-1.8-5.7-2.7-8.9-2.7L192 192l-32 0-16 0c-8.8 0-16 7.2-16 16l0 112c0 8.8 7.2 16 16 16l28.8 0zM576 192l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32z"]
};
const faMoneyBill1Wave = {
  prefix: 'far',
  iconName: 'money-bill-1-wave',
  icon: [576, 512, ["money-bill-wave-alt"], "f53b", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4c0 0 0 0 0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7l0-176c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5c0 0 0 0 0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192l0 176c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5L0 113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5L576 399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM256 208c0 8.8 7.2 16 16 16l0 64-8 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-8 0 0-80c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"]
};
const faMoneyBillWaveAlt = faMoneyBill1Wave;
const faLifeRing = {
  prefix: 'far',
  iconName: 'life-ring',
  icon: [512, 512, [], "f1cd", "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
};
const faHands = {
  prefix: 'far',
  iconName: 'hands',
  icon: [576, 512, ["sign-language", "signing"], "f2a7", "M528 143.8c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 37.4c0 10.9-7.3 20.4-17.8 23.2s-21.6-1.8-27-11.2L369.7 52c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9c0 0 0 0 0 .1l48 83.1c6.2 10.7 3.2 24.3-6.7 31.4c-15.1-14.3-32.3-26.5-51.5-36.1L314.3 84l-8-13.9c0 0 0 0 0-.1l-8-13.8c-2.2-3.8-7.1-5.1-10.9-2.9s-5.1 7.1-2.9 10.9l8 13.9 8 13.9c0 0 0 0 0 .1l20.2 35-53-23.5c-22.8-10.1-47.6-9.8-69-1c4.1-12.6 12.8-23.9 25.2-31c3.8-2.2 7.7-3.9 11.7-5.1c-2.3-21.4 7.8-43.2 27.7-54.6s43.8-9.4 61.1 3.3c3.1-2.9 6.5-5.4 10.3-7.6C361.6-8 395.8 1.2 411.3 28l46.9 81.2c11.4-17.7 31.3-29.4 53.9-29.4c35.3 0 64 28.7 64 64l0 84.6c0 69.4-36.7 133.6-96.5 168.8c-10.4 6.1-21 11.1-31.9 15.1c8-19.2 13.3-39.9 15.4-61.4c40.5-27.4 65-73.2 65-122.4l0-84.6zm-353.9 13c15.1-32 53.2-45.7 85.2-30.7l56.4 26.5c36 16.9 65.4 43.7 85.7 76.1c19.6 29.4 30.7 64.4 30.7 101.2c0 1 0 2 0 3c0 1 0 2.1 0 3.1c0 1.2-.1 2.3-.2 3.4c-5 96.1-84.5 172.6-181.8 172.6L120 512c-30.9 0-56-25.1-56-56c0-4.4 .5-8.6 1.5-12.7C45.8 434.6 32 414.9 32 392c0-4.4 .5-8.6 1.5-12.7C13.8 370.6 0 350.9 0 328s13.8-42.6 33.5-51.3c-.9-4.1-1.5-8.3-1.5-12.7c0-30.9 25.1-56 56-56l84.7 0c-6.4-16-6.5-34.5 1.4-51.3zM72 320l-.2 0L56 320c-4.4 0-8 3.6-8 8s3.6 8 8 8l32 0 .2 0 95.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96.1 0c-4.4 0-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8l31.9 0 .2 0 63.9 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64.1 0c-4.4 .1-7.9 3.6-7.9 8c0 4.4 3.6 8 8 8l129.9 0c72.3 0 131.3-57.3 134-128.9c0-.4 0-.9 .1-1.3l0-.5 0-.6 0-.3c0-.8 0-1.7 0-2.5c0-27.2-8.2-53.1-22.8-74.8c-.2-.2-.3-.5-.5-.7c-15.5-24.9-38-45.4-65.5-58.4l-56.4-26.5c-8-3.8-17.5-.3-21.3 7.7s-.3 17.5 7.7 21.3l25.1 11.8c10.2 4.8 15.7 16 13.2 27s-12.2 18.8-23.4 18.8L88 256c-4.4 0-8 3.6-8 8s3.6 8 8 8l.2 0 95.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L72 320z"]
};
const faSignLanguage = faHands;
const faSigning = faHands;
const faCircleCaretRight = {
  prefix: 'far',
  iconName: 'circle-caret-right',
  icon: [512, 512, ["caret-circle-right"], "f330", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm368 0c0-6.7-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 208c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104c4.9-4.5 7.7-10.9 7.7-17.6z"]
};
const faCaretCircleRight = faCircleCaretRight;
const faTurnLeft = {
  prefix: 'far',
  iconName: 'turn-left',
  icon: [512, 512, [], "e636", "M6.5 240.4c-8.7-9.2-8.7-23.7 0-32.9l121.4-129c8.8-9.3 21-14.6 33.7-14.6c25.6 0 46.3 20.7 46.3 46.3l0 41.7 144 0c88.4 0 160 71.6 160 160l0 112c0 30.9-25.1 56-56 56l-32 0c-30.9 0-56-25.1-56-56l0-120c0-4.4-3.6-8-8-8l-152 0 0 41.7c0 25.6-20.7 46.3-46.3 46.3c-12.8 0-25-5.3-33.7-14.6L6.5 240.4zm153.5 93l0-61.5c0-13.3 10.7-24 24-24l176 0c30.9 0 56 25.1 56 56l0 120c0 4.4 3.6 8 8 8l32 0c4.4 0 8-3.6 8-8l0-112c0-61.9-50.1-112-112-112l-168 0c-13.3 0-24-10.7-24-24l0-61.5L57 224 160 333.5z"]
};
const faWheat = {
  prefix: 'far',
  iconName: 'wheat',
  icon: [512, 512, [], "f72d", "M448 48c-22.1 0-40 17.9-40 40l0 16 16 0c22.1 0 40-17.9 40-40l0-16-16 0zM362.2 68.5C371.1 29.3 406.1 0 448 0l40 0c13.3 0 24 10.7 24 24l0 40c0 41.9-29.2 76.9-68.4 85.8c14.1 6.2 27.3 15.1 38.9 26.7l16.9 16.9c9.4 9.4 9.4 24.6 0 33.9l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-16.9 16.9-37.9 27.3-59.8 31.1c6.9 9.4 6.1 22.6-2.4 31.1l-16.9 16.9c-43.7 43.7-114.6 43.7-158.4 0l-11.2-11.2L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L120.6 357.5c0 0 0 0 0 0l-11.3-11.3c-43.7-43.7-43.7-114.7 0-158.4l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c8.5-8.5 21.7-9.3 31.1-2.4c3.8-21.9 14.2-42.9 31.1-59.8l16.9-16.9c9.4-9.4 24.6-9.4 33.9 0l16.9 16.9C347 41 356 54.3 362.2 68.5zm-60.6 85.4L311.7 164c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zM222.4 233l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm-79.2 79.2l10.1 10.1c20.5-31 17.2-73.3-10.2-100.6c-25 25-25 65.5 0 90.5zm147 56.5c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.2c25 25 65.5 25 90.5 0zm79.2-79.2c-27.4-27.3-69.6-30.7-100.6-10.2l10.1 10.1c25 25 65.5 25 90.5 0zm79.2-79.2C421.2 183 379 179.7 347.9 200.2l10.1 10.1c25 25 65.5 25 90.5 0z"]
};
const faFileSpreadsheet = {
  prefix: 'far',
  iconName: 'file-spreadsheet',
  icon: [384, 512, [], "f65b", "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM176 256l0 48-64 0 0-48 64 0zm-64 80l64 0 0 48-64 0 0-48zm96 0l64 0 0 48-64 0 0-48zm-16 80l16 0 64 0c17.7 0 32-14.3 32-32l0-48 0-16 0-16 0-48c0-17.7-14.3-32-32-32l-64 0-16 0-16 0-64 0c-17.7 0-32 14.3-32 32l0 48 0 16 0 16 0 48c0 17.7 14.3 32 32 32l64 0 16 0zm16-112l0-48 64 0 0 48-64 0z"]
};
const faAudioDescriptionSlash = {
  prefix: 'far',
  iconName: 'audio-description-slash',
  icon: [640, 512, [], "e0a8", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-30-23.5c4.6-8.8 7.2-18.9 7.2-29.6l0-320c0-35.3-28.7-64-64-64L96 32c-6.7 0-13.1 1-19.2 2.9L38.8 5.1zM134.4 80L544 80c8.8 0 16 7.2 16 16l0 317.6-95.4-74.8C493 322.1 512 291.3 512 256c0-53-43-96-96-96l-56 0c-13.3 0-24 10.7-24 24l0 54L134.4 80zM419.9 303.8L384 275.7l0-67.7 32 0c26.5 0 48 21.5 48 48c0 25.2-19.4 45.8-44.1 47.8zM487.4 480l-60.9-48L96 432c-8.8 0-16-7.2-16-16l0-257L32 121.2 32 416c0 35.3 28.7 64 64 64l391.4 0zM130.5 317.3c-5.9 11.9-1.1 26.3 10.7 32.2s26.3 1.1 32.2-10.7l9.4-18.9 82.2 0 9.4 18.9c5.9 11.9 20.3 16.7 32.2 10.7c3-1.5 5.5-3.5 7.5-5.9l-80.9-63.8-30.4 0 8.6-17.2L173 232.3l-42.5 85z"]
};
const faBellRing = {
  prefix: 'far',
  iconName: 'bell-ring',
  icon: [512, 512, [], "e62c", "M256 0c-17.7 0-32 14.3-32 32l0 19.2C151 66 96 130.6 96 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L37.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C431.5 322.9 416 278.8 416 233.4l0-25.4c0-77.4-55-142-128-156.8L288 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6l-303.4 0c25.8-40 39.7-86.7 39.7-134.6l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3zM113.4 15.4c-9.1-9.6-24.3-10-33.9-.8C30.5 61.2 0 127.1 0 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-59.3 24.8-112.7 64.6-150.6c9.6-9.1 10-24.3 .8-33.9zM399.4 49.4C439.2 87.3 464 140.7 464 200c0 13.3 10.7 24 24 24s24-10.7 24-24c0-72.9-30.5-138.8-79.4-185.4c-9.6-9.1-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9z"]
};
const faCalendarDay = {
  prefix: 'far',
  iconName: 'calendar-day',
  icon: [448, 512, [], "f783", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z"]
};
const faWaterLadder = {
  prefix: 'far',
  iconName: 'water-ladder',
  icon: [576, 512, ["ladder-water", "swimming-pool"], "f5c5", "M128 128c0-53 43-96 96-96s96 43 96 96l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 96.2 208 0 0-96.2c0-53 43-96 96-96s96 43 96 96l0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 120.2L432 371c-15.5 8.4-32.8 13.5-48 13.5c0 0 0 0 0 0l0-112.3-208 0 0 110.6c-14.7-2.9-30-9.6-43.1-18.7c-1.6-1.1-3.2-2.2-4.9-3.1l0-112.9L128 128zM111.9 398.1c21.5 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c21.6 18.6 51.2 33.9 80 33.9s58.5-15.3 80-33.9c9.1-8.1 22.8-8.1 31.9 0c16.9 15.1 39.3 26.8 61.3 31.8c12.9 2.9 21.1 15.7 18.2 28.7s-15.7 21.1-28.7 18.2c-28.7-6.4-52.3-20.5-66.7-30.4c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-28.1 19.5-61.4 33.8-96 33.8s-67.9-14.3-96-33.8c-14.4 10-38 24-66.7 30.4c-12.9 2.9-25.8-5.2-28.7-18.2s5.2-25.8 18.2-28.7c22.2-5 44-16.8 61.2-31.7c9.1-8.1 22.8-8.1 31.9 0z"]
};
const faLadderWater = faWaterLadder;
const faSwimmingPool = faWaterLadder;
const faArrowsUpDown = {
  prefix: 'far',
  iconName: 'arrows-up-down',
  icon: [320, 512, ["arrows-v"], "f07d", "M177 7c-9.4-9.4-24.6-9.4-33.9 0L47 103c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 0 348.1L81 375c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l96 96c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55 0-348.1 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L177 7z"]
};
const faArrowsV = faArrowsUpDown;
const faChessPawnPiece = {
  prefix: 'far',
  iconName: 'chess-pawn-piece',
  icon: [256, 512, ["chess-pawn-alt"], "f444", "M128 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm73.4 144c12.6-.7 22.6-11.2 22.6-24c0-9.7-5.8-18.1-14.1-21.9c8.9-14.6 14.1-31.8 14.1-50.1c0-53-43-96-96-96s-96 43-96 96c0 18.4 5.2 35.5 14.1 50.1C37.8 245.9 32 254.3 32 264c0 12.8 10 23.3 22.6 24l-3.6 64 48.1 0 3.6-64 25.3 0 25.3 0 3.6 64 48.1 0-3.6-64zM52.7 464l16.6-32 117.6 0 16.6 32L52.7 464zm143.9-80l-137 0c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512l174.5 0c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"]
};
const faChessPawnAlt = faChessPawnPiece;
const faFaceGrimace = {
  prefix: 'far',
  iconName: 'face-grimace',
  icon: [512, 512, [128556, "grimace"], "f57f", "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0-48-8 0zm40 48l32 0 0-48-32 0 0 48zm96 0l0-48-32 0 0 48 32 0zm32 0l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48zM168 288l176 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-176 0c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faGrimace = faFaceGrimace;
const faWheelchairMove = {
  prefix: 'far',
  iconName: 'wheelchair-move',
  icon: [448, 512, ["wheelchair-alt"], "e2ce", "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208.6 113c-8-3.4-17.2-2.2-24 3.2l-49.8 38.7c-10.5 8.1-25.5 6.3-33.7-4.2s-6.3-25.5 4.2-33.7l49.8-38.7c20.6-16 48.1-19.6 72.1-9.5l84.2 35.5c35.7 15 45.7 60.9 19.5 89.5L288.6 240l113.9 0c26.8 0 46 25.8 38.3 51.5L399 430.9c-3.8 12.7-17.2 19.9-29.9 16.1s-19.9-17.2-16.1-29.9L391.7 288l-85.1 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c1.2 0 2.5 0 3.7 0l68.9-68.9-24-10.1zm87 48.2c3.7-4.1 2.3-10.6-2.8-12.8l-20.4-8.6-60.7 60.7c11.8 4 22.9 9.4 33.3 15.9l50.6-55.2zM160 464a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"]
};
const faWheelchairAlt = faWheelchairMove;
const faTurnDown = {
  prefix: 'far',
  iconName: 'turn-down',
  icon: [384, 512, [10549, "level-down-alt"], "f3be", "M175.6 505.5c9.2 8.7 23.7 8.7 32.9 0l129-121.4c9.3-8.8 14.6-21 14.6-33.7c0-25.6-20.7-46.3-46.3-46.3L264 304l0-144C264 71.6 192.4 0 104 0L56 0C25.1 0 0 25.1 0 56L0 88c0 30.9 25.1 56 56 56l56 0c4.4 0 8 3.6 8 8l0 152-41.7 0C52.7 304 32 324.7 32 350.3c0 12.8 5.3 25 14.6 33.7l129 121.4zM82.5 352l61.5 0c13.3 0 24-10.7 24-24l0-176c0-30.9-25.1-56-56-56L56 96c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8 8-8l48 0c61.9 0 112 50.1 112 112l0 168c0 13.3 10.7 24 24 24l61.5 0L192 455 82.5 352z"]
};
const faLevelDownAlt = faTurnDown;
const faSquareS = {
  prefix: 'far',
  iconName: 'square-s',
  icon: [448, 512, [], "e27d", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM175.6 196.2c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6s0 0 0 0c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1c-12.6-4-19.6-17.6-15.5-30.2s17.6-19.6 30.2-15.5c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4l-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c12.8 3.3 20.6 16.4 17.3 29.2s-16.4 20.6-29.2 17.3c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8z"]
};
const faRectangleBarcode = {
  prefix: 'far',
  iconName: 'rectangle-barcode',
  icon: [576, 512, ["barcode-alt"], "f463", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm120 32c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm136-24c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z"]
};
const faBarcodeAlt = faRectangleBarcode;
const faPersonWalkingArrowRight = {
  prefix: 'far',
  iconName: 'person-walking-arrow-right',
  icon: [640, 512, [], "e552", "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM141.8 266.6l29.9-89.8c7.7 1.2 15 3.6 21.7 7.1c-.1 .3-.2 .7-.3 1L160.7 288.6l-16.4-13.3c-2.6-2.1-3.6-5.6-2.5-8.7zm59 54.6l28.5-91.3 10.5 36.7c1.9 6.5 5.4 12.5 10.2 17.3L279 313c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-27.6-27.6-10.9-38.1C260.1 162.8 213.9 128 161.3 128l-4.9 0c-16.1 0-32.1 2.6-47.4 7.7C69.1 149 36.6 178.5 19.5 217l-9.5 21.3c-5.4 12.1 .1 26.3 12.2 31.7s26.3-.1 31.7-12.2l9.5-21.3C74.3 212 94.3 192.9 119 183.1L96.2 251.4c-7.4 22.1-.3 46.5 17.8 61.2l104.4 84.8 22.1 96c3 12.9 15.9 21 28.8 18s21-15.9 18-28.8L264.6 384c-2-8.7-6.8-16.4-13.8-22.1l-50.1-40.7zm-101.1 21L75.5 402.5 7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l69.7-69.7c3.8-3.8 6.8-8.4 8.9-13.4l19.2-48-39-31.7zM553 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39L392 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l166.1 0-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]
};
const faSquareEnvelope = {
  prefix: 'far',
  iconName: 'square-envelope',
  icon: [448, 512, ["envelope-square"], "f199", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM216.7 255.6L96.1 189.3C97.5 172.9 111.3 160 128 160l192 0c16.7 0 30.5 12.9 31.9 29.3L231.3 255.6c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9zm30 28L352 225.7l0 94.3c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-94.3 105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8z"]
};
const faEnvelopeSquare = faSquareEnvelope;
const faDice = {
  prefix: 'far',
  iconName: 'dice',
  icon: [640, 512, [127922], "f522", "M241 68.3c-9.4-9.4-24.6-9.4-33.9 0L68.3 207c-9.4 9.4-9.4 24.6 0 33.9L207 379.7c9.4 9.4 24.6 9.4 33.9 0L379.7 241c9.4-9.4 9.4-24.6 0-33.9L241 68.3zM173.1 34.3c28.1-28.1 73.7-28.1 101.8 0L413.7 173.1c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 413.8L436.3 297.5c28.6-28.6 37-69.6 25.4-105.5L576 192c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-34.2zM504 352a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM120 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104-56a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 208a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faUnicorn = {
  prefix: 'far',
  iconName: 'unicorn',
  icon: [640, 512, [129412], "f727", "M426.8 .6c1.7-.4 3.4-.6 5.2-.6l8 0 32 0 .5 0c2.5 0 5 .1 7.5 .3l0-.3 56 0c13.3 0 24 10.7 24 24c0 8.5-4.4 16-11.1 20.3c3.5 6.1 6.3 12.7 8.3 19.7l73.5 0c5.1 0 9.3 4.2 9.3 9.3c0 4-2.6 7.6-6.4 8.8l-69.8 23.3 5.6 39.4c5.2 36.7-15.3 72.2-49.7 86c-18.3 7.3-38 7.5-55.8 1.5l0 7.8 0 .7 0 1.6c0 33.2-12.2 62.9-32 85.5L432 464c0 26.5-21.5 48-48 48l-48 0c-26.5 0-48-21.5-48-48l0-99.5-51.8-15.1c-1 3.8-2.2 7.5-3.6 11.2l-12.1 32.3c-.6 1.6-.7 3.3-.2 5l14.8 53.3c8.5 30.6-14.5 60.8-46.2 60.8l-49.8 0c-21.6 0-40.5-14.4-46.2-35.2L81.6 436.4c-8.6-31-7.2-63.9 4.1-94.1l8.2-21.7L72 265.9c-5.3-13.3-8-27.4-8-41.7c0-2.9 .1-5.7 .3-8.5C54.4 223 48 234.8 48 248l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-47.3 37.3-85.9 84.1-87.9c20.3-29.1 54-48.1 92.1-48.1l22.6 0 33.1 0 61.3 0C309.8 51.5 362.6 6.1 426.8 .6zM416 239l0-55c0-10.2 6.4-19.3 16.1-22.6s20.3-.3 26.7 7.7l5.9 7.3c8.9 11.1 24.1 15.1 37.3 9.8c13.9-5.5 22.2-19.9 20-34.7l-9.9-69.2C509.3 62.6 492.4 48 472.5 48l-.5 0-32 0-4.6 0c-.6 .1-1.3 .2-2 .2c-50 3.1-90.5 41.6-96.6 90.8c-1.5 12-11.7 21-23.8 21l-81 0-33.1 0-22.6 0c-35.5 0-64.2 28.8-64.2 64.2c0 8.2 1.6 16.3 4.6 23.9l21.9 54.6c4.4 11.1 4.6 23.5 .4 34.7l-8.2 21.7c-7.7 20.6-8.7 43.1-2.8 64.4L139.1 464l49.8 0-14.8-53.3c-3.2-11.4-2.6-23.6 1.5-34.6l12.1-32.3c2.8-7.5 4.3-15.4 4.3-23.5c0-.4 0-.9 0-1.3c-.2-7.6 3.3-14.9 9.4-19.5s14-6.1 21.3-4l88 25.7c2.1 .6 4.2 1.1 6.3 1.6c11.1 2.3 19 12.1 19 23.5L336 464l48 0 0-145.8c0-6.5 2.6-12.7 7.3-17.2c15.1-14.8 24.7-35.3 24.7-58.8c0-.6 0-1.2 0-1.7c0-.5 0-1 0-1.5zM464 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faBowlingBall = {
  prefix: 'far',
  iconName: 'bowling-ball',
  icon: [512, 512, [], "f436", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
};
const faPompebled = {
  prefix: 'far',
  iconName: 'pompebled',
  icon: [512, 512, [], "e43d", "M254.4 22.8c45.2 31.3 55.3 91.3 38 147.2c45.1-35.6 103.5-47.2 148.3-15c64.6 45.8 71.6 140.2 25.7 208.1c0 0 0 0 0 0C386.7 480.8 219.2 542 98.5 455.5C-21.8 369.5-25.9 190 53.9 72.2c46-68.6 135.3-95.4 200.5-49.4zm21.5 185.1c0 0 0 0 0 0c0 0 0 0 0 0zM226.7 62.1c-38-26.9-98.3-15-133 36.9l-.1 .1c-69.9 103.1-60.2 251 32.8 317.4c0 0 0 0 0 0c91.7 65.7 230.3 23 300.2-80.2c34.9-51.7 24.7-114.9-13.8-142.1l-.1-.1c-25.6-18.4-73.5-11.7-111.5 33.9c-12.9 17.5-37.4 21.8-55.4 8.7c-17.6-12.7-21.9-36.7-10.4-54.7c28.6-52.7 17.8-101.6-8.5-119.7l-.2-.2s0 0 0 0z"]
};
const faBrain = {
  prefix: 'far',
  iconName: 'brain',
  icon: [512, 512, [129504], "f5dc", "M153.5 76.9c-1.9 6.8-6.8 12.4-13.2 15.3c-16.6 7.5-28.2 24.1-28.3 43.5c-.1 9.1-5.2 17.3-13.3 21.3C82.8 164.9 72 181.2 72 200c0 7.1 1.5 13.7 4.2 19.7c4.4 9.7 1.9 21-6.1 28C56.5 259.4 48 276.7 48 296c0 20.2 9.3 38.1 23.9 49.9c6.7 5.4 10 14 8.7 22.5c-.4 2.5-.6 5-.6 7.6c0 26.1 20.8 47.3 46.7 48c9.2 .3 17.4 5.7 21.2 14.1c6.9 15.3 22.3 25.9 40.1 25.9c24.3 0 44-19.7 44-44l0-332c0-22.1-17.9-40-40-40c-18.2 0-33.7 12.2-38.5 28.9zM256 482c-16.8 18.5-41.1 30-68 30c-32.2 0-60.5-16.5-76.9-41.5c-45-8-79.1-47.3-79.1-94.5c0-.5 0-1.1 0-1.6C12.2 354.2 0 326.5 0 296c0-27.8 10.1-53.2 26.8-72.7C25 215.8 24 208 24 200c0-32.6 16.3-61.5 41.1-78.8c4.5-28.9 21.8-53.5 45.9-67.8C124.5 22 155.7 0 192 0c25.2 0 48 10.6 64 27.6C272 10.6 294.8 0 320 0c36.3 0 67.5 22 80.9 53.4c24.1 14.3 41.5 38.9 45.9 67.8C471.7 138.5 488 167.4 488 200c0 8-1 15.8-2.8 23.3c16.7 19.6 26.8 45 26.8 72.7c0 30.5-12.2 58.2-32 78.4c0 .5 0 1.1 0 1.6c0 47.3-34.1 86.5-79.1 94.5c-16.4 25-44.7 41.5-76.9 41.5c-26.9 0-51.2-11.6-68-30zm24-62c0 24.3 19.7 44 44 44c17.8 0 33.2-10.6 40.1-25.9c3.8-8.4 12-13.9 21.2-14.1c25.9-.7 46.7-21.9 46.7-48c0-2.6-.2-5.2-.6-7.6c-1.4-8.5 2-17.1 8.7-22.5C454.7 334.1 464 316.2 464 296c0-19.3-8.5-36.6-22.1-48.3c-8-6.9-10.5-18.3-6.1-28c2.7-6 4.2-12.6 4.2-19.7c0-18.8-10.8-35.1-26.7-43c-8.1-4-13.3-12.3-13.3-21.3c-.1-19.3-11.7-36-28.3-43.5c-6.4-2.9-11.3-8.5-13.2-15.3C353.7 60.2 338.2 48 320 48c-22.1 0-40 17.9-40 40l0 332z"]
};
const faWatchSmart = {
  prefix: 'far',
  iconName: 'watch-smart',
  icon: [384, 512, [], "e2cc", "M64 48.3C64 21.6 85.6 0 112.3 0L271.7 0C298.4 0 320 21.6 320 48.3l0 17.3c36.5 7.4 64 39.7 64 78.4l0 224c0 38.7-27.5 71-64 78.4l0 17.6c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-17.6C27.5 439 0 406.7 0 368L0 144c0-38.7 27.5-71 64-78.4l0-17.3zM80 112c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L80 112zm136 72l0 60.8 39.4 32.8c10.2 8.5 11.6 23.6 3.1 33.8s-23.6 11.6-33.8 3.1l-48-40c-5.5-4.6-8.6-11.3-8.6-18.4l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faBookUser = {
  prefix: 'far',
  iconName: 'book-user',
  icon: [448, 512, [], "f7e7", "M88 0C39.4 0 0 39.4 0 88L0 424l.4 0c-.3 2.6-.4 5.3-.4 8c0 44.2 35.8 80 80 80l344 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-69.4c18.9-9 32-28.3 32-50.6l0-288c0-30.9-25.1-56-56-56L88 0zM368 400l0 64L80 464c-17.7 0-32-14.3-32-32s14.3-32 32-32l288 0zM80 352c-11.4 0-22.2 2.4-32 6.7L48 88c0-22.1 17.9-40 40-40l304 0c4.4 0 8 3.6 8 8l0 288c0 4.4-3.6 8-8 8l-40 0 0-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l0 16-48 0zM240 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
};
const faSensorCloud = {
  prefix: 'far',
  iconName: 'sensor-cloud',
  icon: [640, 512, ["sensor-smoke"], "e02c", "M64 80l320 0c8.8 0 16 7.2 16 16l0 128c17.2 0 33.5 3.9 48 10.8L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l170.8 0c-6.9-14.5-10.8-30.8-10.8-48L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16zm80 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm96 360l224 0c44.2 0 80-35.8 80-80c0-39-27.9-71.5-64.8-78.6c.5-3.1 .8-6.2 .8-9.4c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C284.4 359.9 256 392.6 256 432c0 44.2 35.8 80 80 80z"]
};
const faSensorSmoke = faSensorCloud;
const faClapperboardPlay = {
  prefix: 'far',
  iconName: 'clapperboard-play',
  icon: [512, 512, [], "e132", "M48 416c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-208L48 208l0 208zM336 160l64 0 64-64c0-8.8-7.2-16-16-16l-32 0-80 80zm-96 0l80-80-64 0-80 80 64 0zM80 160l80-80L96 80 48 128l0 32 32 0zM512 96l0 64 0 24 0 24 0 208c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 208l0-24 0-24L0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64zM216.5 241.9c5.2-2.8 11.5-2.5 16.4 .8l96 64c4.4 3 7.1 8 7.1 13.3s-2.7 10.3-7.1 13.3l-96 64c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1l0-128c0-5.9 3.2-11.3 8.5-14.1z"]
};
const faBandage = {
  prefix: 'far',
  iconName: 'bandage',
  icon: [640, 512, [129657, "band-aid"], "f462", "M448 144l0 224 112 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-112 0zM192 96l256 0 112 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80l-112 0-256 0L80 416c-44.2 0-80-35.8-80-80L0 176c0-44.2 35.8-80 80-80l112 0zm0 272l0-224L80 144c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32l112 0zm80-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
};
const faBandAid = faBandage;
const faCalendarMinus = {
  prefix: 'far',
  iconName: 'calendar-minus',
  icon: [448, 512, [], "f272", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM296 352l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"]
};
const faCircleXmark = {
  prefix: 'far',
  iconName: 'circle-xmark',
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faTimesCircle = faCircleXmark;
const faXmarkCircle = faCircleXmark;
const faCircle4 = {
  prefix: 'far',
  iconName: 'circle-4',
  icon: [512, 512, [], "e0f1", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM223.6 129.2c12.6 4.2 19.4 17.8 15.2 30.4L201.3 272l70.7 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-104 0c-7.7 0-15-3.7-19.5-10s-5.7-14.3-3.3-21.6l48-144c4.2-12.6 17.8-19.4 30.4-15.2z"]
};
const faGifts = {
  prefix: 'far',
  iconName: 'gifts',
  icon: [640, 512, [], "f79c", "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96 64 96C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64l136.6 0c-5.4-9.4-8.6-20.3-8.6-32l0-16L64 464c-8.8 0-16-7.2-16-16l0-288c0-8.8 7.2-16 16-16l80 0c0 0 0 0 .1 0l80 0 32.4 0c5.3-8.2 11.7-15.7 19-22.1C263.8 106.2 245.1 96 224 96l-6.2 0 28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24l-4.1 0c-26.5 0-48 21.5-48 48l0 192c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-4.1 0c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zm0 72l72 0 56 0 8 0 0 72-136 0 0-72zm0 120l136 0 0 72-136 0 0-72zm320 0l0 72-136 0 0-72 136 0zM456 344l0-72 8 0 56 0 72 0 0 72-136 0zm88-144c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"]
};
const faAlbumCollection = {
  prefix: 'far',
  iconName: 'album-collection',
  icon: [512, 512, [], "f8a0", "M56 0L456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM6.2 232.3C1.1 194 30.9 160 69.6 160l372.8 0c38.7 0 68.5 34 63.5 72.3l-29.5 224C472.2 488.2 445 512 412.9 512L99.1 512c-32.1 0-59.3-23.8-63.5-55.7L6.2 232.3zM69.6 208c-9.7 0-17.1 8.5-15.9 18.1l29.5 224c1 8 7.8 13.9 15.9 13.9l313.8 0c8 0 14.8-6 15.9-13.9l29.5-224c1.3-9.6-6.2-18.1-15.9-18.1L69.6 208zM400 336c0 57.4-64.5 104-144 104s-144-46.6-144-104s64.5-104 144-104s144 46.6 144 104zM16 104c0-13.3 10.7-24 24-24l432 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 128c-13.3 0-24-10.7-24-24zM256 368c17.7 0 32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24z"]
};
const faHotel = {
  prefix: 'far',
  iconName: 'hotel',
  icon: [512, 512, [127976], "f594", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 416-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-416 8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 0zM432 48l0 416-128 0 0-80 32 0c8.8 0 16.1-7.2 14.7-15.9C343.1 322.6 303.6 288 256 288s-87.1 34.6-94.7 80.1c-1.5 8.7 5.8 15.9 14.7 15.9l32 0 0 80L80 464 80 48l352 0zM144 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM336 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM128 208l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"]
};
const faEarthAsia = {
  prefix: 'far',
  iconName: 'earth-asia',
  icon: [512, 512, [127759, "globe-asia"], "f57e", "M464 256c0-90.7-58.1-167.9-139.1-196.3l-16.4 40.9c-2.9 7.2-9 12.5-16.5 14.4l-17 4.3c-16.7 4.2-23.7 24-13.4 37.7l16.1 21.5c6.1 8.1 6.4 19.2 .8 27.7l-10.7 16.1C260.5 233.3 248 240 234.6 240l-2.3 0c-16.1 0-27.6 15.5-23 30.9l6 19.9c4.4 14.6-6.5 29.2-21.7 29.2c-10.7 0-20.6-6.1-25.4-15.7l-9.3-18.5c-7.3-14.7-26.9-17.8-38.4-6.2l-15.4 15.4c-5.7 5.7-13.8 8.1-21.7 6.6l-31.7-6.3C70 391.3 154.5 464 256 464c48.1 0 92.3-16.3 127.5-43.7l-5.9-4.3L359 422.9c-19.8 7.4-41.8-1.9-50.4-21.1L303 389.4c-8.5-18.9-1.1-41.2 17-51.3L356.2 318c2.3-1.3 4.3-3.1 5.7-5.3l6.1-9.5c6-9.4 16.4-15.1 27.6-15.1s21.6 5.7 27.6 15.1l2 3.1c3.7 5.8 10.8 8.6 17.5 6.7l14.6-4.1c4.4-16.9 6.8-34.5 6.8-52.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm163.9 80.5l32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 11c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zM350.3 135.2l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"]
};
const faGlobeAsia = faEarthAsia;
const faIdCardClip = {
  prefix: 'far',
  iconName: 'id-card-clip',
  icon: [576, 512, ["id-card-alt"], "f47f", "M256 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L256 0zM192 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L384 64l0 48 128 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l128 0 0-48zm96 240a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0z"]
};
const faIdCardAlt = faIdCardClip;
const faMagnifyingGlassPlus = {
  prefix: 'far',
  iconName: 'magnifying-glass-plus',
  icon: [512, 512, ["search-plus"], "f00e", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"]
};
const faSearchPlus = faMagnifyingGlassPlus;
const faThumbsUp = {
  prefix: 'far',
  iconName: 'thumbs-up',
  icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"]
};
const faCloudShowers = {
  prefix: 'far',
  iconName: 'cloud-showers',
  icon: [512, 512, [], "f73f", "M112 120c0-39.8 32.2-72 72-72c25.8 0 48.5 13.6 61.2 34c3.8 6.1 10.1 10.2 17.2 11.1s14.3-1.3 19.5-6.2c10-9.3 23.4-15 38.1-15c29 0 52.9 22.1 55.7 50.4c1.2 12.3 11.6 21.7 23.9 21.6l.3 0s0 0 0 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-292 0-1.9 0c-.3 0-.7-.1-1-.1C73.3 270.4 48 244.2 48 212c0-28.3 19.6-52.1 46.1-58.4c11.8-2.8 19.6-13.9 18.3-25.9c-.3-2.5-.4-5.1-.4-7.7zM184 0C120 0 67.7 50.1 64.2 113.3C26.4 130.1 0 167.9 0 212c0 57.1 44.3 103.9 100.5 107.7c1.2 .2 2.3 .3 3.5 .3l4 0 292 0c61.9 0 112-50.1 112-112c0-55.2-39.9-101.1-92.5-110.3C406.5 55 366.9 24 320 24c-18 0-34.9 4.6-49.7 12.6C248.5 14.1 217.9 0 184 0zM112 352c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm192 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm-72 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm168-24c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z"]
};
const faUserClock = {
  prefix: 'far',
  iconName: 'user-clock',
  icon: [640, 512, [], "f4fd", "M224 208a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM49.3 464l299.2 0c12.3 18.8 28 35.1 46.3 48L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304l45.7 0 45.7 0c20.6 0 40.4 3.5 58.8 9.9c-4.9 15.3-7.8 31.4-8.4 48.2c-15.5-6.5-32.5-10.1-50.4-10.1l-91.4 0c-65.7 0-120.1 48.7-129 112zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"]
};
const faOnion = {
  prefix: 'far',
  iconName: 'onion',
  icon: [448, 512, [129477], "e427", "M171.3 33.9c.2-.7 .4-1.5 .6-2.2c1-3.8 1.9-7.8 2.5-11.9C176.2 9 184.9 0 195.8 0c6.3 0 12.1 3 15.8 7.9c0 0 0 0 0 0c.7 .9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3c0 0 0 0 0 0C240.1 3 245.9 0 252.2 0c10.9 0 19.6 9 21.3 19.8c.6 4.1 1.5 8.1 2.5 11.9c.2 .7 .4 1.5 .6 2.2c0 0 0 0 0 .1c11.6 39.7 43.1 65.3 76 92C399 163.7 448 203.5 448 288c0 80.4-58 135.2-131.9 160.3l10.7 32.1c4.2 12.6-2.6 26.2-15.2 30.4s-26.2-2.6-30.4-15.2L269.4 460c-7.1 1.2-14.2 2.1-21.4 2.7l0 25.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-25.3c-7.2-.7-14.3-1.6-21.4-2.7l-11.9 35.6c-4.2 12.6-17.8 19.4-30.4 15.2s-19.4-17.8-15.2-30.4l10.7-32.1C58 423.2 0 368.4 0 288c0-84.5 49-124.3 95.3-162c32.9-26.7 64.4-52.4 76-92c0 0 0 0 0-.1zm31.3 48.2c-7.9 13.9-17.4 26-27.5 36.8c-.5 .5-1 1.1-1.5 1.6c-.4 .8-.9 1.9-1.5 3.2c-1.5 3.2-3.6 7.9-6.2 13.7c-5.1 11.7-12 28.2-18.9 46.9c-13.9 38.1-27 83.8-27 119.5c0 32.5 9.2 60.2 18.5 79.8c3.8 8.1 7.6 14.7 10.8 19.7c17.4 5.8 36.1 9.6 55.3 11.4C194.2 389.7 184 354.2 184 312c0-61.9 6.1-128.6 12.1-179.6c2.3-19.3 4.6-36.4 6.5-50.2zm34.3-13.5c-.3 1.8-.6 3.8-.9 5.8c-2.2 15.1-5.2 36.5-8.2 61.7C221.9 186.6 216 251.9 216 312c0 37.9 9.4 69.8 18.8 92.2c1.7 4 3.3 7.7 4.9 11c21.3-1.7 41.9-5.9 61-12.4c3.3-4.4 7.1-10.2 11-17.2c9.9-17.9 19.7-43.2 19.7-73.6c0-37.1-15.8-88.6-32.6-132.5c-8.3-21.6-16.6-40.7-22.8-54.5c-.8-1.9-1.7-3.7-2.4-5.3c-.2-.2-.4-.5-.7-.7c-13.2-14.2-25.6-30.8-34.5-50.7c-.5 .1-.9 .2-1.4 .3zm91.9 99.9c16.8 43.9 34.6 100.1 34.6 143.5c0 25.2-5.5 47.4-12.6 65.7C382.1 355.2 400 325.3 400 288c0-53.7-25.3-81.3-63.6-113.2c-2.4-2-5-4.1-7.6-6.3zM102.6 381.4C94.6 360.5 88 334.1 88 304c0-41.6 14.9-91.9 29-130.5c.6-1.5 1.1-3.1 1.7-4.6c-2.5 2-4.8 4-7.1 5.8C73.3 206.7 48 234.3 48 288c0 37.7 18.2 67.7 50 90.2c1.5 1.1 3.1 2.1 4.6 3.2z"]
};
const faClockTwelveThirty = {
  prefix: 'far',
  iconName: 'clock-twelve-thirty',
  icon: [512, 512, [], "e359", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 152l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
};
const faArrowDownToDottedLine = {
  prefix: 'far',
  iconName: 'arrow-down-to-dotted-line',
  icon: [448, 512, [], "e095", "M32 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM241.5 360.4c-4.5 4.8-10.9 7.6-17.5 7.6s-12.9-2.7-17.5-7.6l-128-136c-9.1-9.7-8.6-24.8 1-33.9s24.8-8.6 33.9 1L200 283.5l0-83.5 0-128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 128 0 83.5 86.5-91.9c9.1-9.7 24.3-10.1 33.9-1s10.1 24.3 1 33.9l-128 136z"]
};
const faHandDots = {
  prefix: 'far',
  iconName: 'hand-dots',
  icon: [512, 512, ["allergies"], "f461", "M198.4 36C208.8 14.7 230.7 0 256 0s47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c35.3 0 64 28.7 64 64l0 2c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 176c0 1.5-.1 3-.4 4.5c-6.2 91.7-79.4 165-171.1 171.1c-1.5 .3-2.9 .4-4.5 .4l-8 0-8.5 0c-67.9 0-133-27-181-75L18.7 349.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l2.7 2.7L112 96c0-35.3 28.7-64 64-64c7.9 0 15.4 1.4 22.4 4zM240 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136.1c0-8.8-7.2-15.9-16-15.9c-8.8 0-16 7.2-16 16l0 223.4c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2L75.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l87.8 87.8c39 39 91.9 60.9 147.1 60.9l8.5 0 4.9 0c.6-.1 1.3-.1 1.9-.2c69.7-3.4 125.6-59.3 129-129c0-.6 .1-1.3 .2-1.9L432 160c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 0 0 .1 0 .1l0 71.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0 0 0-.1 0-.1L352 96c0-8.8-7.2-16-16-16s-16 7.1-16 16c0 0 0 0 0 .1l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136 0-.1L272 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 32 0 .1L240 232zm0 88a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM320 416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
};
const faAllergies = faHandDots;
const faFileInvoice = {
  prefix: 'far',
  iconName: 'file-invoice',
  icon: [384, 512, [], "f570", "M64 464l256 0c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm80 48c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zM192 400c0-8.8 7.2-16 16-16l80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0c-8.8 0-16-7.2-16-16zM112 224l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"]
};
const faWindowMinimize = {
  prefix: 'far',
  iconName: 'window-minimize',
  icon: [512, 512, [128469], "f2d1", "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faRectangleWide = {
  prefix: 'far',
  iconName: 'rectangle-wide',
  icon: [640, 512, [], "f2fc", "M576 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l512 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z"]
};
const faCommentArrowUp = {
  prefix: 'far',
  iconName: 'comment-arrow-up',
  icon: [512, 512, [], "e144", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM280 217.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L232 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-110.1z"]
};
const faGarlic = {
  prefix: 'far',
  iconName: 'garlic',
  icon: [512, 512, [129476], "e40e", "M376 131.2c-15.2-12.1-24-30.5-24-50L352 48c0-26.5-21.5-48-48-48L208 0c-26.5 0-48 21.5-48 48l0 33.2c0 19.4-8.8 37.8-24 50L52.7 197.8C19.4 224.5 0 264.8 0 307.5C0 385.1 62.9 448 140.5 448l-4.5 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 16 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-4.5 0C449.1 448 512 385.1 512 307.5c0-42.7-19.4-83-52.7-109.7L376 131.2zm-168-56L208 48l32 0 0 27.2c0 48.1 15 95 43 134.1l17.4 24.4c12.7 17.8 19.6 39.2 19.6 61.1l0 9.2c0 53-43 96-96 96s-96-43-96-96l0-9.2c0-21.9 6.8-43.3 19.6-61.1L165 209.3c24.1-33.7 38.6-73.2 42.1-114.2c.6-4.6 .9-9.2 .9-13.9l0-6.1zM272 48l32 0 0 33.2c0 34 15.5 66.2 42 87.5l83.3 66.6c21.9 17.6 34.7 44.1 34.7 72.2c0 51.1-41.4 92.5-92.5 92.5l-62.9 0c26.6-23.5 43.3-57.8 43.3-96l0-9.2c0-28.6-8.9-56.5-25.5-79.7L309 190.7c-24.1-33.7-37-74.1-37-115.5L272 48zM139.3 400C88.8 399.4 48 358.2 48 307.5c0-28.1 12.8-54.7 34.7-72.2l57-45.6c-.2 .3-.5 .6-.7 1l-17.4 24.4C104.9 238.4 96 266.2 96 294.8l0 9.2c0 38.2 16.8 72.5 43.3 96z"]
};
const faMugSaucer = {
  prefix: 'far',
  iconName: 'mug-saucer',
  icon: [640, 512, ["coffee"], "f0f4", "M144 80l288 0 0 208c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-208zM128 32c-17.7 0-32 14.3-32 32l0 224c0 53 43 96 96 96l192 0c53 0 96-43 96-96l32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-64 0L128 32zM512 240l-32 0 0-160 32 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l528 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432z"]
};
const faCoffee = faMugSaucer;
const faBrush = {
  prefix: 'far',
  iconName: 'brush',
  icon: [384, 512, [], "f55d", "M48 288L48 64c0-8.8 7.2-16 16-16l32 0 0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96 64 0 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 96 0c8.8 0 16 7.2 16 16l0 224L48 288zM0 320c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 320zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faFileHalfDashed = {
  prefix: 'far',
  iconName: 'file-half-dashed',
  icon: [384, 512, [], "e698", "M48 272L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 112L48 272zm288 48l16 0 32 0 0-165.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0C28.7 0 0 28.7 0 64L0 320l32 0 16 0 288 0zM0 352l0 64 48 0 0-64L0 352zM64 512l0-48c-8.8 0-16-7.2-16-16L0 448c0 35.3 28.7 64 64 64zm256-48l0 48c35.3 0 64-28.7 64-64l-48 0c0 8.8-7.2 16-16 16zm64-112l-48 0 0 64 48 0 0-64zM96 464l0 48 80 0 0-48-80 0zm112 0l0 48 80 0 0-48-80 0z"]
};
const faTreeDecorated = {
  prefix: 'far',
  iconName: 'tree-decorated',
  icon: [448, 512, [], "f7dc", "M242.9 9.3C238.4 3.4 231.4 0 224 0s-14.4 3.4-18.9 9.3L66.8 186.9c-5.6 7.2-6.6 17-2.6 25.3s12.4 13.5 21.6 13.5l16.5 0L35.1 326.2c-4.9 7.4-5.4 16.8-1.2 24.6s12.3 12.7 21.2 12.7l24 0L4.1 474.6c-5 7.4-5.5 16.9-1.3 24.7S15.1 512 24 512l400 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.3-24.7L369 363.5l24 0c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6L345.7 225.6l16.5 0c9.2 0 17.5-5.2 21.6-13.5s3-18-2.6-25.3L242.9 9.3zM147.2 177.6l-12.3 0L224 63.1l89.1 114.5-12.3 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l67.2 100.6-24.2 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.3 24.7L378.9 464 69.1 464l74.9-111.1c5-7.4 5.5-16.9 1.3-24.7s-12.3-12.7-21.2-12.7l-24.2 0 67.2-100.6c4.9-7.4 5.4-16.8 1.2-24.6s-12.3-12.7-21.2-12.7zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faMask = {
  prefix: 'far',
  iconName: 'mask',
  icon: [576, 512, [], "f6fa", "M91.4 162.3C61 188.5 48 225.2 48 272c0 43.9 15.3 74.8 36.8 95c22 20.6 53.7 33 91.2 33l8.4 0c6.1 0 11.6-3.4 14.3-8.8l23.2-46.3 39 19.5-39-19.5C234.4 319.8 260 304 288 304s53.6 15.8 66.1 40.8l23.2 46.3c2.7 5.4 8.2 8.8 14.3 8.8l8.4 0c37.4 0 69.2-12.4 91.2-33c21.5-20.2 36.8-51.1 36.8-95c0-46.8-13-83.5-43.4-109.7C452.9 134.9 394.3 112 288 112s-164.9 22.9-196.6 50.3zM0 272C0 160 64 64 288 64s288 96 288 208s-80 176-176 176l-8.4 0c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4l-8.4 0C80 448 0 384 0 272zm96-16a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
};
const faCalendarHeart = {
  prefix: 'far',
  iconName: 'calendar-heart',
  icon: [448, 512, [], "e0d3", "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 301.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"]
};
const faMagnifyingGlassMinus = {
  prefix: 'far',
  iconName: 'magnifying-glass-minus',
  icon: [512, 512, ["search-minus"], "f010", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"]
};
const faSearchMinus = faMagnifyingGlassMinus;
const faFlower = {
  prefix: 'far',
  iconName: 'flower',
  icon: [448, 512, [127804, 10047], "f7ff", "M448 168c0 33.6-12.2 64.3-32.3 88c20.1 23.7 32.3 54.4 32.3 88c0 75.1-60.9 136-136 136c-33.6 0-64.3-12.2-88-32.3c-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168C0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM192.9 100.9C177.6 87.8 157.8 80 136 80c-48.6 0-88 39.4-88 88c0 21.8 7.8 41.6 20.9 56.9c15.2 17.9 15.2 44.2 0 62.2C55.8 302.4 48 322.2 48 344c0 48.6 39.4 88 88 88c21.8 0 41.6-7.8 56.9-20.9c17.9-15.2 44.2-15.2 62.2 0C270.4 424.2 290.2 432 312 432c48.6 0 88-39.4 88-88c0-21.8-7.8-41.6-20.9-56.9c-15.2-17.9-15.2-44.2 0-62.2C392.2 209.6 400 189.8 400 168c0-48.6-39.4-88-88-88c-21.8 0-41.6 7.8-56.9 20.9c-17.9 15.2-44.2 15.2-62.2 0zM256 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
};
const faArrowDownFromArc = {
  prefix: 'far',
  iconName: 'arrow-down-from-arc',
  icon: [512, 512, [], "e614", "M256 48C141.1 48 48 141.1 48 256c0 13.3-10.7 24-24 24s-24-10.7-24-24C0 114.6 114.6 0 256 0S512 114.6 512 256c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-114.9-93.1-208-208-208zM134.4 392.3c-9-9.7-8.5-24.9 1.3-33.9s24.9-8.5 33.9 1.3L232 426.9 232 184c0-13.3 10.7-24 24-24s24 10.7 24 24l0 242.9 62.4-67.2c9-9.7 24.2-10.3 33.9-1.3s10.3 24.2 1.3 33.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7s-13-2.8-17.6-7.7l-104-112z"]
};
const faRightLeftLarge = {
  prefix: 'far',
  iconName: 'right-left-large',
  icon: [640, 512, [], "e5e1", "M182.1 504c-15.4 0-30.1-6.1-41-17L20.7 366.6C12.6 358.5 8 347.5 8 336s4.6-22.5 12.7-30.6L141.1 185c10.9-10.9 25.6-17 41-17c32 0 57.9 25.9 57.9 57.9V232H432c8.8 0 16 7.2 16 16v38.1c0 5.5 4.5 9.9 9.9 9.9c2.6 0 5.2-1 7-2.9L582.1 176 465 58.9c-1.9-1.9-4.4-2.9-7-2.9c-5.5 0-9.9 4.5-9.9 9.9V104c0 8.8-7.2 16-16 16H320c-13.3 0-24-10.7-24-24s10.7-24 24-24h80V65.9C400 33.9 425.9 8 457.9 8c15.4 0 30.1 6.1 41 17L619.3 145.4c8.1 8.1 12.7 19.1 12.7 30.6s-4.6 22.5-12.7 30.6L498.9 327c-10.9 10.9-25.6 17-41 17c-32 0-57.9-25.9-57.9-57.9V280H208c-8.8 0-16-7.2-16-16V225.9c0-5.5-4.5-9.9-9.9-9.9c-2.6 0-5.2 1-7 2.9L57.9 336 175 453.1c1.9 1.9 4.4 2.9 7 2.9c5.5 0 9.9-4.5 9.9-9.9V408c0-8.8 7.2-16 16-16H320c13.3 0 24 10.7 24 24s-10.7 24-24 24H240v6.1c0 32-25.9 57.9-57.9 57.9z"]
};
const faRulerVertical = {
  prefix: 'far',
  iconName: 'ruler-vertical',
  icon: [256, 512, [], "f548", "M192 48c8.8 0 16 7.2 16 16l0 32-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 64-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l128 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0z"]
};
const faCirclesOverlap = {
  prefix: 'far',
  iconName: 'circles-overlap',
  icon: [640, 512, [], "e600", "M192 288c0 40.8 10.9 79 30 112c-96.3-1.1-174-79.5-174-176c0-97.2 78.8-176 176-176c38.9 0 74.8 12.6 104 34C248 116.2 192 195.5 192 288zm32 160c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224S100.3 448 224 448zm192 16c-38.9 0-74.8-12.6-104-34C392 395.8 448 316.5 448 224c0-40.8-10.9-79-30-112c96.3 1.1 174 79.5 174 176c0 97.2-78.8 176-176 176z"]
};
const faUserLarge = {
  prefix: 'far',
  iconName: 'user-large',
  icon: [512, 512, ["user-alt"], "f406", "M352 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM49.3 464l413.4 0c-8.3-54.4-55.3-96-112-96l-189.4 0c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320l189.4 0C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z"]
};
const faUserAlt = faUserLarge;
const faStarshipFreighter = {
  prefix: 'far',
  iconName: 'starship-freighter',
  icon: [576, 512, [], "e03a", "M400 256c0-97.2-78.8-176-176-176S48 158.8 48 256s78.8 176 176 176c14.8 0 29.1-1.8 42.8-5.2L208 350.7c-45.4-7.6-80-47.1-80-94.7c0-53 43-96 96-96s96 43 96 96c0 1.3 0 2.7-.1 4l60 77.7C392.7 313.3 400 285.5 400 256zm40 112c1.1 0 2.3 0 3.4 .1L528 335.2l0-55.2-81.3 0c-3.4 31.8-13.4 61.6-28.7 88l22 0zm6.7-136l81.3 0 0-55.2-118.2-46c19.9 29.5 32.9 63.9 36.9 101.1zM555.6 375.9l-57 22.2C507 409.9 512 424.4 512 440c0 39.8-32.2 72-72 72l-72 0c-22.3 0-43.3-10.3-57-28l-9.9-12.9C275.9 477 250 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2l207.9 80.9c12.3 4.8 20.4 16.6 20.4 29.8l0 90.1 0 90.1c0 13.2-8.1 25-20.4 29.8zM88 240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm152-80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm77 198.7c4.5 5.9 11.6 9.3 19 9.3l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-60.2 0L300.7 313.7c-9.7 12.9-22.6 23.3-37.5 30l85.8 111z"]
};
const faTrainTram = {
  prefix: 'far',
  iconName: 'train-tram',
  icon: [448, 512, [128650], "e5b4", "M55.5 63c7.6-9.5 19.1-15 31.2-15L200 48l0 48-40 0c-53 0-96 43-96 96l0 160c0 26 10.3 49.6 27.2 66.9L39 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l60.6-60.6c8.4 2.4 17.2 3.7 26.4 3.7l128 0c9.2 0 18-1.3 26.4-3.7L375 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-52.1-52.1C373.7 401.6 384 378 384 352l0-160c0-53-43-96-96-96l-40 0 0-48 113.2 0c12.2 0 23.6 5.5 31.2 15l12.8 16c8.3 10.4 23.4 12 33.7 3.7s12-23.4 3.8-33.7L430 33C413.3 12.2 388 0 361.2 0L86.8 0C60 0 34.7 12.2 18 33L5.3 49C-3 59.4-1.3 74.5 9 82.7S34.5 89.3 42.7 79L55.5 63zM160 144l128 0c26.5 0 48 21.5 48 48l0 48-224 0 0-48c0-26.5 21.5-48 48-48zM112 288l224 0 0 64c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-64zm72 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
};
const faBridgeSuspension = {
  prefix: 'far',
  iconName: 'bridge-suspension',
  icon: [640, 512, [], "e4cd", "M149.1 12.5C145 5 137.1 0 128 0c-8.8 0-16.5 4.7-20.7 11.8C94.3 33 80.7 53.9 65.3 71.5c-15.5 17.7-31.7 30.6-49.4 36.9C3.4 113-3.1 126.7 1.4 139.2s18.2 18.9 30.7 14.4c28.2-10.2 50.8-29.4 69.2-50.4c.9-1 1.8-2 2.6-3L104 240l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l592 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-139.8c.9 1 1.7 2 2.6 3c18.4 21 41.1 40.3 69.2 50.4c12.5 4.5 26.2-2 30.7-14.4s-2-26.2-14.4-30.7c-17.7-6.4-33.9-19.3-49.4-36.9c-15.4-17.6-29-38.6-42-59.8C528.5 4.7 520.8 0 512 0c-9.1 0-17 5-21.1 12.5C455.8 73.6 390.3 112 320 112s-135.8-38.4-170.9-99.5zM200 240l-48 0 0-147.2c14.5 13.7 30.7 25.6 48 35.4L200 240zm96 0l-48 0 0-91c15.5 4.8 31.6 8.1 48 9.8l0 81.2zm96 0l-48 0 0-81.2c16.4-1.6 32.5-4.9 48-9.8l0 91zm96 0l-48 0 0-111.7c17.3-9.8 33.5-21.7 48-35.4L488 240zM0 360c0 13.3 10.7 24 24 24l16 0c30.9 0 56 25.1 56 56l0 24c0 26.5 21.5 48 48 48l49.4 0c25.7 0 46.6-20.9 46.6-46.6l0-1.4c0-44.2 35.8-80 80-80s80 35.8 80 80l0 1.4c0 25.7 20.9 46.6 46.6 46.6l49.4 0c26.5 0 48-21.5 48-48l0-24c0-30.9 25.1-56 56-56l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-57.4 0-104 46.6-104 104l0 24-48 0c0-70.7-57.3-128-128-128s-128 57.3-128 128l-48 0 0-24c0-57.4-46.6-104-104-104l-16 0c-13.3 0-24 10.7-24 24z"]
};
const faTrashCheck = {
  prefix: 'far',
  iconName: 'trash-check',
  icon: [448, 512, [], "e2af", "M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80l13.7 0L416 80l8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.6 0L388.4 452.7c-2.5 33.4-30.3 59.3-63.8 59.3l-201.1 0c-33.5 0-61.3-25.9-63.8-59.3L35.6 128 24 128c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48.1 0 13.7 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM83.7 128l23.8 321.2c.6 8.4 7.6 14.8 16 14.8l201.1 0c8.4 0 15.3-6.5 16-14.8L364.3 128 83.7 128zM318.1 246.1l-104 104c-7.8 7.8-20.5 7.8-28.3 0l-40-40c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0L200 307.7l89.9-89.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3z"]
};
const faUserNurse = {
  prefix: 'far',
  iconName: 'user-nurse',
  icon: [448, 512, [], "f82f", "M96 128l0-57.8c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30l0 57.8-.3 0c.2 2.6 .3 5.3 .3 8l0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40c0-2.7 .1-5.4 .3-8l-.3 0zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16-160 0 0 16zM216 40c-4.4 0-8 3.6-8 8l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8l-16 0zM49.3 461.9l349.4 0c-6-39.3-32.2-72-67.7-87.1l-61.7 61.7c-25 25-65.5 25-90.5 0l-61.7-61.7c-35.5 15.1-61.7 47.8-67.7 87.1zm65.1-137.1c10.1-3.1 20.9 .4 28.4 7.9l69.8 69.8c6.2 6.2 16.4 6.2 22.6 0l69.8-69.8c7.5-7.5 18.3-11 28.4-7.9C399.8 344.9 448 406.4 448 479.2c0 17-13.8 30.7-30.7 30.7l-386.6 0c-17 0-30.7-13.8-30.7-30.7c0-72.8 48.2-134.3 114.4-154.4z"]
};
const faBoombox = {
  prefix: 'far',
  iconName: 'boombox',
  icon: [640, 512, [128254], "f8a5", "M136 48l368 0c22.1 0 40 17.9 40 40l0 72-96 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-32 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l-96 0 0-72c0-22.1 17.9-40 40-40zM48 88l0 74c-27.6 7.1-48 32.2-48 62L0 448c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-224c0-29.8-20.4-54.9-48-62l0-74c0-48.6-39.4-88-88-88L136 0C87.4 0 48 39.4 48 88zM64 208l512 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zM176 432a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-48-96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm432 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
};
const faSyringe = {
  prefix: 'far',
  iconName: 'syringe',
  icon: [512, 512, [128137], "f48e", "M407 7c-9.4 9.4-9.4 24.6 0 33.9l15 15L384 94.1 329 39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72 72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L456 89.9l15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L473 39 441 7c-9.4-9.4-24.6-9.4-33.9 0zM271.4 94.6l-191 191C69.9 296.2 64 310.4 64 325.3l0 88.8L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 88.8 0c14.9 0 29.1-5.9 39.6-16.4l191-191c-.3-.3-.7-.6-1-1l-33-33-191 191c-1.5 1.5-3.5 2.3-5.7 2.3L112 400l0-74.7c0-2.1 .8-4.2 2.3-5.7l27.3-27.3 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 41.4-41.4 23 23c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-23-23 13.1-13.1-33-33c-.3-.3-.6-.7-1-1z"]
};
const faCloudSun = {
  prefix: 'far',
  iconName: 'cloud-sun',
  icon: [640, 512, [9925], "f6c4", "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM320.1 320c0 .8 0 1.7-.1 2.5l-2 23.8c-1.1 13.2-12.7 23-25.9 21.9c-1.3-.1-2.6-.2-4-.2c-26.5 0-48 21.5-48 48s21.5 48 48 48c.6 0 1.3 0 1.9 0c.3 0 .6 0 .9 0l266.9 0c.3 0 .6 0 1 0c.4 0 .9 0 1.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1.6 0-3.1 .1-4.6 .3c-6.9 1-13.9-1.1-19.1-5.6s-8.3-11.2-8.3-18.1l0-30.2c0-.3 0-.6 0-.9c0-.5 0-1 0-1.5s0-1 0-1.5c0-.3 0-.6 0-.9l0-1.1c-.1-.6-.2-1.1-.3-1.7c-2.5-19.6-19.3-34.8-39.7-34.8c-12.6 0-23.8 5.8-31.1 14.9c-5.8 7.1-15.1 10.4-24.1 8.3s-15.9-9.1-18-18c-4.9-21.3-24-37.2-46.8-37.2c-26.5 0-48 21.5-48 48zm48-96c33 0 62 16.6 79.3 41.9c12.2-6.3 26-9.9 40.6-9.9c43 0 78.8 30.9 86.5 71.7c1 2.6 1.5 5.4 1.5 8.3l0 5.3c0 .9 0 1.8 0 2.7s0 1.8 0 2.7l0 6.9c36.5 7.4 64 39.7 64 78.4c0 44.2-35.8 80-80 80c-.9 0-1.8 0-2.7 0l-266 0c-1.1 0-2.1 .1-3.2 .1c-53 0-96-43-96-96c0-47.5 34.5-86.9 79.8-94.6l.2-2.5c.6-52.5 43.4-94.8 96-94.8z"]
};
const faShieldExclamation = {
  prefix: 'far',
  iconName: 'shield-exclamation',
  icon: [512, 512, [], "e247", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM256 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faStopwatch20 = {
  prefix: 'far',
  iconName: 'stopwatch-20',
  icon: [448, 512, [], "e06f", "M168 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120l31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-29.2 29.2c-31.1-27.5-70.4-45.9-113.8-50.9L248 48l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L168 0zM64 304a160 160 0 1 1 320 0A160 160 0 1 1 64 304zm172-48l0 96c0 28.7 23.3 52 52 52s52-23.3 52-52l0-96c0-28.7-23.3-52-52-52s-52 23.3-52 52zm52-12c6.6 0 12 5.4 12 12l0 96c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-96c0-6.6 5.4-12 12-12zm-132.4 8.6c1.7-5.1 6.5-8.6 11.9-8.6c6.9 0 12.5 5.6 12.5 12.5l0 2.2c0 3.6-1.3 7.1-3.7 9.8l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8l0 15.7c0 11 9 20 20 20l64 0c11 0 20-9 20-20s-9-20-20-20l-43.8 0c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23 13.8-36.4l0-2.2c0-29-23.5-52.5-52.5-52.5c-22.6 0-42.7 14.5-49.8 35.9l-.6 1.7c-3.5 10.5 2.2 21.8 12.6 25.3s21.8-2.2 25.3-12.6l.6-1.7z"]
};
const faSquareFull = {
  prefix: 'far',
  iconName: 'square-full',
  icon: [512, 512, [128997, 128998, 128999, 129000, 129001, 129002, 129003, 11035, 11036], "f45c", "M464 48l0 416L48 464 48 48l416 0zM48 0L0 0 0 48 0 464l0 48 48 0 416 0 48 0 0-48 0-416 0-48L464 0 48 0z"]
};
const faGripDots = {
  prefix: 'far',
  iconName: 'grip-dots',
  icon: [448, 512, [], "e410", "M352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM224 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
};
const faCommentExclamation = {
  prefix: 'far',
  iconName: 'comment-exclamation',
  icon: [512, 512, [], "f4af", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM256 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faPenSwirl = {
  prefix: 'far',
  iconName: 'pen-swirl',
  icon: [512, 512, [], "e214", "M441.2 59.1L453.1 71c9.4 9.4 9.4 24.6 0 33.9L432 126.1 386.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM231.9 236.8L352.6 114.5 398.1 160 276.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L215 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM373 25.5L197.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.3-9.7 36.1-19.6L487.1 138.9c28.1-28.1 28.1-73.7 0-101.8L475.1 25.2C446.9-3.1 401-2.9 373 25.5zm-48.3-7.9C302.9 11.4 279.8 8 256 8C119 8 8 119 8 256S119 504 256 504c13.3 0 24-10.7 24-24s-10.7-24-24-24C145.5 456 56 366.5 56 256S145.5 56 256 56c9.7 0 19.3 .7 28.7 2l40-40.4zM454.1 228.4c1.2 9 1.9 18.2 1.9 27.6c0 57.4-46.6 104-104 104c-13.3 0-24 10.7-24 24s10.7 24 24 24c83.9 0 152-68.1 152-152c0-23.6-3.3-46.4-9.4-68l-40.4 40.5z"]
};
const faFalafel = {
  prefix: 'far',
  iconName: 'falafel',
  icon: [576, 512, [129478], "e40a", "M147.4 120.3c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-2.3 9-1.9 18.2 .6 26.6c-20.8-9-45-2.4-58.5 15.9c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6c-15.2 18.4-15.2 45.1 0 63.5c.3 .4 .5 1 .3 1.6c-5.8 23 5.4 47.3 27.3 57.3c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .5-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c10.2-4.7 18.1-12.4 23-21.7c4.9 9.3 12.8 17.1 23 21.7c.2 .1 .6 .4 .7 1.1c4.6 23.4 25.2 40.6 49.4 39.9c.1 0 .4 0 .7 .4c14.3 19.4 40.5 25.6 61.9 14.3c.1-.1 .2-.1 .3-.1s.2 0 .3 .1c21.5 11.3 47.7 5 61.9-14.3c.3-.4 .6-.4 .7-.4c24.3 .7 44.9-16.5 49.4-39.9c.1-.6 .5-1 .7-1.1c16.4-7.5 26.7-22.9 28.5-39.9c-18.6 7.3-39.4 6-56.9 1.2c0 0 0 0-.1 0c-10 7.3-17 18.2-19.4 30.6c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3s-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 0-.1 0-.1 .1c0 0 0 0-.1 0s0 0-.1 0s0 0-.1 0s0 0-.1 0c-.1 0-.2-.1-.2-.1s-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c8.7 .2 17.1-1.8 24.5-5.9c-.9-11.7 .3-23.8 4.6-35.2c7.1-4.1 16-4.4 23.7-.4l.4 .2c13.8-12.1 20-31.3 15.4-49.7c-.2-.6 0-1.3 .3-1.6c15.2-18.4 15.2-45.1 0-63.5c-.3-.4-.5-1-.3-1.6c5.8-23-5.4-47.3-27.3-57.3c-.2-.1-.6-.4-.7-1.1c-4.6-23.4-25.2-40.6-49.4-39.9c-.1 0-.4 0-.7-.4C335.9 .6 309.7-5.7 288.3 5.6c-.1 .1-.2 .1-.3 .1s-.2 0-.3-.1c-21.5-11.3-47.7-5-61.9 14.3c-.3 .4-.5 .4-.7 .4c-24.3-.7-44.9 16.5-49.4 39.9c-.1 .6-.5 1-.7 1.1c-21.9 10-33.1 34.3-27.3 57.3c.2 .6 0 1.3-.3 1.6zM324.5 243.4c-5 3.2-9.4 7.3-13 12.2c-.1 .2-.2 .2-.3 .3s-.2 .1-.2 .1s-.1 0-.2 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1s-.1 0-.1 0c0 0 0 0-.1 0c-.1 0-.2 0-.2-.1s-.2-.1-.3-.3c-3.6-4.9-8-9-13-12.2c-7.8-8.2-18.4-13.6-30.2-14.9c-4.2-12.9-13.7-23.7-26.3-29.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0c0 0 0 0 .1 0s0 0 .1 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.4-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-12.6 5.8-22.1 16.6-26.3 29.5c-11.8 1.2-22.4 6.7-30.2 14.9zM48.4 361.1c-.2-.3-.4-.7-.4-1.1s.2-.9 .4-1.1c10.1-12.3 13.8-28.6 9.9-44c-.1-.5-.1-.9 .1-1.3s.4-.5 .6-.6c14.6-6.7 24.8-20 27.9-35.5c.1-.5 .3-.8 .5-.9s.3-.2 .4-.2c16.1 .5 31.2-7.1 40.7-19.9c.1-.2 .2-.2 .3-.3s.2-.1 .2-.1s.1 0 .2 0c0 0 .1 0 .2 .1c14.2 7.5 31.1 7.5 45.3 0c.1-.1 .2-.1 .2-.1c0 0 .1 0 .2 0c0 0 .1 0 .1 0c0 0 0 0 0 0c0 0 .1 0 .1 .1c.1 0 .2 .1 .3 .3c9.5 12.8 24.6 20.4 40.7 19.9c.1 0 .2 0 .4 .2s.4 .5 .5 .9c3 15.6 13.3 28.9 27.9 35.5c.2 .1 .4 .2 .6 .6s.2 .8 .1 1.3c-3.9 15.3-.3 31.7 9.9 44c.2 .3 .4 .7 .4 1.1s-.2 .9-.4 1.1c-10.1 12.3-13.8 28.6-9.9 44c.1 .5 .1 .9-.1 1.3s-.4 .5-.6 .6c-14.6 6.7-24.8 20-27.9 35.5c-.1 .5-.3 .8-.5 .9s-.3 .2-.4 .2c-16.1-.5-31.2 7.1-40.7 19.9c-.1 .2-.2 .2-.3 .3c0 0-.1 0-.1 .1c0 0-.1 0-.1 0c0 0 0 0-.1 0s0 0-.1 0s0 0-.1 0c0 0-.1 0-.2-.1c-14.2-7.5-31.1-7.5-45.3 0c-.1 .1-.2 .1-.2 .1c0 0-.1 0-.2 0s-.2-.1-.2-.1s-.2-.1-.3-.3c-9.5-12.8-24.6-20.4-40.7-19.9c-.1 0-.2 0-.4-.2s-.4-.5-.5-.9c-3-15.6-13.3-28.9-27.9-35.5c-.2-.1-.4-.2-.6-.6s-.2-.8-.1-1.3c3.9-15.4 .3-31.7-9.9-44zM416 261c-1 24.2 13.6 56 40.3 82.7c19.3 19.3 41.4 32.3 61.3 37.6c19.5 5.2 37 3 47.9-7.9c5.5-5.5 8.8-12.7 10-20.9c2.1-14.2-1.8-31.6-10.9-49.3c-5.2-10.1-12.1-20.3-20.6-30.1c-2.6-3-5.4-5.9-8.2-8.8l-.5-.5c-33.5-33.3-74.9-47.5-99.3-35.9c-3.5 1.7-6.6 3.8-9.4 6.6c-6.7 6.7-10.1 15.9-10.5 26.5zM112 352a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm224-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM224 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
};
const faCircle2 = {
  prefix: 'far',
  iconName: 'circle-2',
  icon: [512, 512, [], "e0ef", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-83.3 0 64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z"]
};
const faMagnet = {
  prefix: 'far',
  iconName: 'magnet',
  icon: [448, 512, [129522], "f076", "M48 256c0 97.2 78.8 176 176 176s176-78.8 176-176l0-64-64 0 0 64c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-64-64 0 0 64zM0 88C0 57.1 25.1 32 56 32l48 0c30.9 0 56 25.1 56 56l0 168c0 35.3 28.7 64 64 64s64-28.7 64-64l0-168c0-30.9 25.1-56 56-56l48 0c30.9 0 56 25.1 56 56l0 168c0 123.7-100.3 224-224 224S0 379.7 0 256L0 88z"]
};
const faJar = {
  prefix: 'far',
  iconName: 'jar',
  icon: [320, 512, [], "e516", "M32 24c0 13.3 10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 0C42.7 0 32 10.7 32 24zM256 128c8.8 0 16 7.2 16 16l0 80L48 224l0-80c0-8.8 7.2-16 16-16l192 0zm16 240l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80 224 0zM64 80C28.7 80 0 108.7 0 144L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-304c0-35.3-28.7-64-64-64L64 80z"]
};
const faGramophone = {
  prefix: 'far',
  iconName: 'gramophone',
  icon: [384, 512, [], "f8bd", "M127 0c10.5-.4 20 6 23.6 15.9c0 0 0 .1 0 .1l.3 .7c.3 .7 .7 1.7 1.3 3.2c1.2 2.9 3.2 7.3 6 12.8c5.7 11.1 14.8 27 28.2 45.1c26.9 36.2 71.4 81.5 141.3 116.8c17.3 8.7 31.6 22.9 40.1 40.4c5.4 10.9 8.2 23 8.2 35l0 .3 0 .3c0 45-36.5 81.4-81.4 81.4L184 352c-13.3 0-24-10.7-24-24c0-1.7 .2-3.3 .5-4.8c2.2-10.9 11.9-19.2 23.5-19.2l110 0c18.7 0 33.9-15.1 34-33.7c-.1-5.4-1.5-10.7-4.1-15.6c-3.1-4.9-7.7-7.8-12.4-8.6c-44.1-7.3-133.1-7.9-241.4 69.4c-.3 .2-.7 .5-1 .7c-2.7 1.8-5.6 2.9-8.7 3.5c-3.2 .6-6.6 .6-10-.2c-1.4-.3-2.7-.8-4-1.3c-.4-.2-.8-.4-1.2-.6c-1.4-.7-2.7-1.5-3.9-2.4c-.7-.5-1.3-1.1-1.9-1.7c-1.3-1.2-2.4-2.6-3.4-4.1c-1.8-2.8-3-5.8-3.6-8.9c-.6-3.1-.5-6.4 .2-9.6c.1-.3 .2-.7 .3-1L104.8 17.9C107.5 7.7 116.5 .4 127 0zM94.8 243.4c54.3-29.5 103.6-42.4 144.6-46.7c-41.1-30.1-70.7-62.3-91.5-90.2c-4.5-6.1-8.6-11.9-12.3-17.5L94.8 243.4zM0 488c0-13.3 10.7-24 24-24l8 0 0-32c0-26.5 21.5-48 48-48l224 0c26.5 0 48 21.5 48 48l0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0L80 512l-48 0-8 0c-13.3 0-24-10.7-24-24zm304-24l0-32L80 432l0 32 224 0z"]
};
const faDiceD12 = {
  prefix: 'far',
  iconName: 'dice-d12',
  icon: [512, 512, [], "f6ce", "M200.3 48L158.7 72 256 102.8 353.3 72 311.7 48 200.3 48zm-97.1 56.7L49.7 197.3l83.9 93.1L232 241.2l0-95.6L103.2 104.7zM48 267.1l0 44.7 55.7 96.5L140 429.2l-33.1-96.8L48 267.1zM202.7 464l108 0 43.9-131.8L256 282.8l-98.5 49.3L202.7 464zm170.5-35.4l35.2-20.3L464 311.7l0-44.7-58.8 65.3-32.1 96.2zm89.2-231.3l-53.4-92.5L280 145.6l0 95.6 98.4 49.2 83.9-93.1zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4L311.7 0c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24l0 111.5c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4l-111.5 0c-8.4 0-16.7-2.2-24-6.4L79.7 449.8c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24L0 200.3c0-8.4 2.2-16.7 6.4-24L62.2 79.7c4.2-7.3 10.3-13.4 17.6-17.6L176.3 6.4z"]
};
const faNoteSticky = {
  prefix: 'far',
  iconName: 'note-sticky',
  icon: [448, 512, [62026, "sticky-note"], "f249", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l224 0 0-80c0-17.7 14.3-32 32-32l80 0 0-224c0-8.8-7.2-16-16-16L64 80zM288 480L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 224 0 5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7l-5.5 0z"]
};
const faStickyNote = faNoteSticky;
const faDown = {
  prefix: 'far',
  iconName: 'down',
  icon: [384, 512, ["arrow-alt-down"], "f354", "M192 429.6L49.3 279.7c-.8-.8-1.3-2-1.3-3.2c0-2.5 2-4.6 4.6-4.6l83.4 0c13.3 0 24-10.7 24-24l0-168 64 0 0 168c0 13.3 10.7 24 24 24l83.4 0c2.5 0 4.6 2 4.6 4.6c0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3L161.1 466.8c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2L369.5 312.8c9.3-9.8 14.5-22.8 14.5-36.3c0-29-23.5-52.6-52.6-52.6L272 224l0-144c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 144-59.4 0C23.5 224 0 247.5 0 276.6z"]
};
const faArrowAltDown = faDown;
const faHundredPoints = {
  prefix: 'far',
  iconName: 'hundred-points',
  icon: [512, 512, [128175, "100"], "e41c", "M171.2 99.6C175.3 61.2 207.8 32 246.5 32c45 0 80.1 39 75.3 83.8L308.8 236.4c-4.1 38.5-36.6 67.6-75.3 67.6c-45 0-80.1-39-75.3-83.8L171.2 99.6zM246.5 80c-14.2 0-26 10.7-27.5 24.8L206 225.3c-1.8 16.4 11.1 30.7 27.5 30.7c14.2 0 26-10.7 27.5-24.8L274 110.7C275.8 94.3 262.9 80 246.5 80zm-128-43.4c6.9 5.1 10.4 13.4 9.4 22l-32 256c-1.6 13.2-13.6 22.7-26.8 21.3s-22.5-13.3-20.8-26.4L75 95 41.4 109.9c-12.2 5.4-26.3 0-31.5-12.1s.4-26.3 12.6-31.7l72-32c7.9-3.5 17-2.6 23.9 2.5zM431.7 32c44.4 0 79.2 37.9 75.6 82.1l-7.4 88.4c-3.3 39.3-36.1 69.5-75.6 69.5c-44.4 0-79.2-37.9-75.6-82.1l7.4-88.4C359.4 62.2 392.2 32 431.7 32zM404 105.5l-7.4 88.4C395.2 210.1 408 224 424.3 224c14.5 0 26.5-11.1 27.7-25.5l7.4-88.4C460.8 93.9 448 80 431.7 80c-14.5 0-26.5 11.1-27.7 25.5zM511.7 323.9c2.3 13.1-6.5 25.5-19.6 27.7l-464 80C15 433.9 2.6 425.1 .3 412.1s6.5-25.5 19.6-27.7l464-80c13.1-2.3 25.5 6.5 27.7 19.6zM459.9 439.7l-240 40c-13.1 2.2-25.4-6.7-27.6-19.7s6.7-25.4 19.7-27.6l240-40c13.1-2.2 25.4 6.7 27.6 19.7s-6.7 25.4-19.7 27.6z"]
};
const fa100 = faHundredPoints;
const faPaperclipVertical = {
  prefix: 'far',
  iconName: 'paperclip-vertical',
  icon: [384, 512, [], "e3c2", "M48 108C48 48.4 96.4 0 156 0s108 48.4 108 108l0 236c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-192c0-13.3 10.7-24 24-24s24 10.7 24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-236c0-33.1-26.9-60-60-60s-60 26.9-60 60l0 260c0 53 43 96 96 96s96-43 96-96l0-216c0-13.3 10.7-24 24-24s24 10.7 24 24l0 216c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-260z"]
};
const faWindWarning = {
  prefix: 'far',
  iconName: 'wind-warning',
  icon: [640, 512, ["wind-circle-exclamation"], "f776", "M224 432c61.8 0 116.1-31.8 147.5-80l54.9 0c-36 75.7-113.1 128-202.4 128C100.3 480 0 379.7 0 256S100.3 32 224 32c118.3 0 215.2 91.8 223.4 208l-48.2 0C391.2 150.3 315.8 80 224 80C126.8 80 48 158.8 48 256s78.8 176 176 176zm0-304c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM192 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM478 224c-2.1-16.5-5.7-32.6-10.8-48l76.7 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0c53 0 96 43 96 96s-43 96-96 96l-66 0zm-6 256c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-192 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l192 0c57.4 0 104 46.6 104 104s-46.6 104-104 104l-64 0z"]
};
const faWindCircleExclamation = faWindWarning;
const faLocationPinSlash = {
  prefix: 'far',
  iconName: 'location-pin-slash',
  icon: [640, 512, ["map-marker-slash"], "f60c", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L459 334.5c30-51.6 53-103.7 53-142.5C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4L38.8 5.1zM192.3 125.4C216.3 79.4 264.5 48 320 48c79.5 0 144 64.5 144 144c0 12.4-4.5 31.6-15.3 57.2c-7.4 17.4-16.9 36.2-27.9 55.4L192.3 125.4zm-2.5 120.1l-61.7-48.6c4.2 88.2 117.8 239.3 168.2 302.2c12.3 15.3 35.1 15.3 47.4 0c16.2-20.2 39-49.6 62.5-83.1l-37.8-29.8c-17.3 24.6-34.2 47.2-48.5 65.4c-24.8-31.8-57.8-76.4-86.2-122.6c-17.1-27.7-32-55.1-42.5-79.9c-.5-1.2-1-2.5-1.5-3.7z"]
};
const faMapMarkerSlash = faLocationPinSlash;
const faFaceSadSweat = {
  prefix: 'far',
  iconName: 'face-sad-sweat',
  icon: [576, 512, [], "e38a", "M496 256c0 114.9-93.1 208-208 208c-65.4 0-123.8-30.2-162-77.5c-3.9 17.1-13.4 32-26.4 42.8C146.4 480.2 213.5 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256c0 1.1 0 2.2 0 3.3c16.3-7.1 36.4-2.8 48 12.8l.7 .9c-.5-5.6-.7-11.3-.7-17C80 141.1 173.1 48 288 48s208 93.1 208 208zM35.7 299.4C21.4 319.1 0 351.7 0 369c0 26 21.5 47 48 47c12 0 23-4.3 31.5-11.5C89.6 395.9 96 383.2 96 369c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-1.7 2.3-3.8 5-5.9 8.1zM360.4 409.5c9.7-9 10.2-24.2 1.2-33.9C347.3 360.3 322.6 344 288 344s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM367.6 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-192-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm51.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4c-8.7 1.5-14.6 9.7-13.2 18.4s9.7 14.6 18.4 13.2l2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zm121.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4c8.7 1.5 17-4.4 18.4-13.2s-4.4-17-13.2-18.4l-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4c-6.2-6.2-16.4-6.2-22.6 0z"]
};
const faBugSlash = {
  prefix: 'far',
  iconName: 'bug-slash',
  icon: [640, 512, [], "e490", "M224 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zm73.7 112L432 313.3l0-49.3c0-30.9-25.1-56-56-56l-78.3 0zM477.4 348.9L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L240 162.8c7.7-1.8 15.8-2.8 24-2.8l112 0c20 0 38.7 5.7 54.6 15.5L503 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C474.3 225.3 480 244 480 264l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0 0 8c0 9.9-.9 19.5-2.6 28.9zm-46.6 86.5C402.1 463 363 480 320 480c-43.7 0-83.3-17.5-112.2-45.9L137 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8c-12-22.4-18.8-48.1-18.8-75.3l0-8-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c0-12.9 2.4-25.3 6.7-36.7L208.1 260c-.1 1.3-.1 2.7-.1 4l0 56c0 53.6 37.7 98.4 88 109.4l0-100.2L344 367l0 62.4c18.3-4 34.8-12.4 48.6-24.1l38.2 30.1z"]
};
const faCupcake = {
  prefix: 'far',
  iconName: 'cupcake',
  icon: [448, 512, [129473], "e402", "M224 0c-8.9 0-17 4.9-21.2 12.7s-3.7 17.3 1.2 24.6l10.8 16.3c.7 1.1 1.1 2.4 1.1 3.7c0 3.7-3 6.7-6.7 6.7L152 64c-39.8 0-72 32.2-72 72l0 .8C34.9 142.7 0 181.3 0 228c0 50.8 41.2 92 92 92l264 0c50.8 0 92-41.2 92-92c0-46.8-35-85.5-80.2-91.3c.2-2 .2-4 .2-6.1C368 58.5 309.5 0 237.3 0L224 0zm40 57.3c0-1.7-.1-3.3-.2-5c32.7 11 56.2 41.9 56.2 78.3c0 6-1.8 11.5-4.8 16.1c-4.9 7.4-5.3 16.8-1.1 24.6s12.3 12.6 21.1 12.6l20.8 0c24.3 0 44 19.7 44 44s-19.7 44-44 44L92 272c-24.3 0-44-19.7-44-44s19.7-44 44-44l18.4 0c8.6 0 16.5-4.6 20.8-12s4.3-16.6 0-24c-2-3.5-3.2-7.6-3.2-12c0-13.3 10.7-24 24-24l57.3 0c30.2 0 54.7-24.5 54.7-54.7zM89.3 471.9C93.2 495 113.2 512 136.7 512l11.2 0-20-160-58.5 0 20 119.9zM180.1 512l87.8 0 20-160-127.8 0 20 160zm120 0l11.2 0c23.5 0 43.5-17 47.3-40.1l20-119.9-58.5 0-20 160z"]
};
const faLightSwitchOff = {
  prefix: 'far',
  iconName: 'light-switch-off',
  icon: [384, 512, [], "e018", "M169.4 464c3.3-9.3 12.2-16 22.6-16s19.3 6.7 22.6 16L320 464c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L214.6 48c-3.3 9.3-12.2 16-22.6 16s-19.3-6.7-22.6-16L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l105.4 0zM64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512zm80-256l96 0 0-112-96 0 0 112zm0 160c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-96 0z"]
};
const faToggleLargeOff = {
  prefix: 'far',
  iconName: 'toggle-large-off',
  icon: [576, 512, [], "e5b0", "M192 400a144 144 0 1 1 0-288 144 144 0 1 1 0 288zm0 48l192 0c106 0 192-86 192-192s-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448zm127-48c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144l65 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-65 0z"]
};
const faPenFancySlash = {
  prefix: 'far',
  iconName: 'pen-fancy-slash',
  icon: [640, 512, [], "e210", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L398.9 287.3 548.8 147.8C566.2 131.6 576 109 576 85.3C576 38.2 537.8 0 490.7 0C467 0 444.4 9.8 428.2 27.2L275.8 190.9 38.8 5.1zM313.7 220.6L463.4 59.9c7.1-7.6 17-11.9 27.3-11.9C511.3 48 528 64.7 528 85.3c0 10.4-4.3 20.2-11.9 27.3L360.6 257.4l-46.9-36.8zm19.9 144.6l-40.4-31.8-20.7 67.3c-2.3 7.6-8.3 13.5-15.9 15.9L149 449.7 198.7 400c.4 0 .9 0 1.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24c0 .4 0 .9 0 1.3L126.3 427l33.1-107.7c2.3-7.6 8.3-13.5 15.9-15.9l57.5-17.7L187 249.7l-25.8 7.9c-22.8 7-40.6 24.9-47.6 47.6L65.9 460.1c-9.4 30.7 19.3 59.4 50 50l154.8-47.6c22.8-7 40.6-24.9 47.6-47.6l15.3-49.6z"]
};
const faTruckContainer = {
  prefix: 'far',
  iconName: 'truck-container',
  icon: [640, 512, [], "f4dc", "M0 104C0 64.2 32.2 32 72 32l256 0c39.8 0 72 32.2 72 72l0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-184c0-13.3-10.7-24-24-24L72 80c-13.3 0-24 10.7-24 24l0 184c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 104zM608 400c0 44.2-35.8 80-80 80s-80-35.8-80-80l-16 0-144 0c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l160 0 0-96 0-88c0-13.3 10.7-24 24-24l72.8 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 80c0 17.7-14.3 32-32 32zM585 256l-50-61.1c-1.5-1.9-3.8-2.9-6.2-2.9L480 192l0 64 105 0zM136 136l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-13.3 10.7-24 24-24s24 10.7 24 24zM528 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM80 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faBoot = {
  prefix: 'far',
  iconName: 'boot',
  icon: [512, 512, [129406], "f782", "M32 0L352 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L0 128 0 32C0 14.3 14.3 0 32 0zM0 464l0-6.6L0 448l0-32L0 160l48 0 0 256 416 0 0-56.6c0-21.2-13.9-39.9-34.2-46L345 288l-105 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l66.7 0c-1.8-5-2.7-10.4-2.7-16l0-16-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0 0-32 48 0 0 80 91.6 27.5c40.6 12.2 68.4 49.6 68.4 92l0 56.6 0 32 0 9.4 0 6.6-.4 0c-1.5 12-6.9 23.3-15.6 32c-10.2 10.2-24.1 16-38.6 16l-14.9 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-11 0c-17 0-33.3-6.7-45.3-18.7l-7.6-7.6c-3.1-3.1-8.2-3.1-11.3 0l-7.6 7.6c-12 12-28.3 18.7-45.3 18.7l-14.9 0c-14.5 0-28.4-5.8-38.6-16C7.3 487.3 1.9 476 .4 464L0 464z"]
};
const faArrowUpFromWaterPump = {
  prefix: 'far',
  iconName: 'arrow-up-from-water-pump',
  icon: [576, 512, [], "e4b6", "M112 0C85.5 0 64 21.5 64 48l0 208c-35.3 0-64 28.7-64 64L0 425c5.3-3.1 11.2-5.4 17.5-6.9c10.4-2.4 21.2-7.2 30.5-13.5L48 320c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 84.6c9.3 6.3 20.1 11.1 30.5 13.6c6.3 1.5 12.1 3.8 17.5 6.9l0-105c0-35.3-28.7-64-64-64l-40 0 0-174.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L465 7c-9.4-9.4-24.6-9.4-33.9 0L351 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L424 256l-136 0 0-208c0-26.5-21.5-48-48-48L112 0zm-.1 430.1c-9.1-8.1-22.8-8.1-31.9 0C62.8 445 41 456.8 18.8 461.8C5.9 464.7-2.3 477.5 .6 490.5s15.7 21.1 28.7 18.2C58 502.2 81.6 488.2 96 478.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9z"]
};
const faFileCheck = {
  prefix: 'far',
  iconName: 'file-check',
  icon: [384, 512, [], "f316", "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM289 267.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-89.7 89.7L129 287c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l53.3 53.3c4.5 4.5 10.6 7 17 7s12.5-2.5 17-7L289 267.6z"]
};
const faBone = {
  prefix: 'far',
  iconName: 'bone',
  icon: [576, 512, [129460], "f5d7", "M127.4 177c-3.3-18.8-19.7-33-39.4-33c-22.1 0-40 17.9-40 40c0 11.7 4.9 22.1 13 29.5c24.8 22.8 24.8 62.2 0 85c-8 7.4-13 17.8-13 29.5c0 22.1 17.9 40 40 40c19.7 0 36.1-14.3 39.4-33c4.3-24.6 25.7-47 55.6-47L393 288c29.9 0 51.3 22.4 55.6 47c3.3 18.8 19.7 33 39.4 33c22.1 0 40-17.9 40-40c0-11.7-4.9-22.1-13-29.5c-24.8-22.8-24.8-62.2 0-85c8-7.4 13-17.8 13-29.5c0-22.1-17.9-40-40-40c-19.7 0-36.1 14.3-39.4 33c-4.3 24.6-25.7 47-55.6 47L183 224c-29.9 0-51.3-22.4-55.6-47zm47.3-8.3c.7 4.1 4.1 7.3 8.3 7.3L393 176c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88c0 25.7-11 48.8-28.5 64.9c-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88c-43.4 0-79.5-31.4-86.7-72.7c-.7-4.1-4.1-7.3-8.3-7.3L183 336c-4.1 0-7.6 3.2-8.3 7.3C167.5 384.6 131.4 416 88 416c-48.6 0-88-39.4-88-88c0-25.7 11-48.8 28.5-64.9c4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88c43.4 0 79.5 31.4 86.7 72.7z"]
};
const faCardsBlank = {
  prefix: 'far',
  iconName: 'cards-blank',
  icon: [640, 512, [], "e4df", "M51.8 160.4c-3.7 2.1-4.9 6.8-2.8 10.5l167 289.3c2.1 3.7 6.8 4.9 10.5 2.8L419.4 351.6c3.7-2.1 4.9-6.8 2.8-10.5L255.2 51.8c-2.1-3.7-6.8-4.9-10.5-2.8L51.8 160.4zM7.5 194.9c-15.4-26.6-6.3-60.7 20.4-76.1L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.4 26.6 6.2 60.7-20.4 76.1L250.5 504.5c-26.6 15.4-60.7 6.2-76.1-20.4L7.5 194.9zm451.9 226c41.9-24.2 56.3-77.8 32.1-119.8L354.7 64.2c1.7-.2 3.5-.2 5.3-.2l224 0c30.9 0 56 25.1 56 56l0 336c0 30.9-25.1 56-56 56l-224 0c-13.7 0-26.2-4.9-35.9-13l135.3-78.1z"]
};
const faCircle3 = {
  prefix: 'far',
  iconName: 'circle-3',
  icon: [512, 512, [], "e0f0", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l66.3 0-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2L240 336c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384l27.8 0c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4s-12.5-15.3-22.4-15.3l-128 0z"]
};
const faBenchTree = {
  prefix: 'far',
  iconName: 'bench-tree',
  icon: [640, 512, [], "e2e7", "M578.7 150c-14.7-10.6-22.1-28.5-19.3-46.4c.4-2.5 .6-5 .6-7.6c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 2.6 .2 5.2 .6 7.6c2.8 17.9-4.6 35.8-19.3 46.4c-8.2 5.9-13.3 15.3-13.3 26c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32c0-10.6-5.1-20.1-13.3-26zM608 96c0 5.1-.4 10.2-1.2 15.1C626.9 125.7 640 149.3 640 176c0 44.2-35.8 80-80 80l-24 0 0 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-232-24 0c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c-.8-4.9-1.2-10-1.2-15.1c0-53 43-96 96-96s96 43 96 96zM80 272l224 0 0-32L80 240l0 32zM32 224c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64c0 14.9-10.2 27.4-24 31l0 33 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88L80 400l0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0 0-33c-13.8-3.6-24-16.1-24-31l0-64zm72 96l0 32 176 0 0-32-176 0z"]
};
const faKeyboardBrightnessLow = {
  prefix: 'far',
  iconName: 'keyboard-brightness-low',
  icon: [640, 512, [], "e1c1", "M320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm88-16c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-208 0z"]
};
const faSkiBootSki = {
  prefix: 'far',
  iconName: 'ski-boot-ski',
  icon: [640, 512, [], "e3cd", "M415.6 28.5c2.5-13-6-25.6-19-28.1s-25.6 6-28.1 19L366 32 176 32c-11.3 0-21.1 7.9-23.5 19L88.8 348.3c-7.5 34.9 19.1 67.7 54.8 67.7L424 416c30.9 0 56-25.1 56-56l0-52.9c0-20.6-11.3-39.5-29.4-49.3l-71.7-38.6L415.6 28.5zM275 80l81.8 0-15.4 80L304 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l31.3 0-6.2 32L288 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l57.9 0 81.8 44.1c2.6 1.4 4.2 4.1 4.2 7l0 52.9c0 4.4-3.6 8-8 8l-280.4 0c-5.1 0-8.9-4.7-7.8-9.7l26-121.3C202 215.7 249.2 171.2 275 80zm-33.4 0c-17.9 57.7-44.8 92-70.3 112.5L195.4 80l46.2 0zM640 408c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 30.9-25.1 56-56 56L24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l512 0c57.4 0 104-46.6 104-104z"]
};
const faBrainCircuit = {
  prefix: 'far',
  iconName: 'brain-circuit',
  icon: [512, 512, [], "e0c6", "M192 48c22.1 0 40 17.9 40 40l0 40-19.3 0c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24l19.3 0 0 96-40 0c-26.5 0-48 21.5-48 48l0 11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3c0-8.8 7.2-16 16-16l40 0 0 132c0 24.3-19.7 44-44 44c-17.8 0-33.2-10.6-40.1-25.9c-3.8-8.4-12-13.9-21.2-14.1c-25.9-.7-46.7-21.9-46.7-48c0-2.6 .2-5.2 .6-7.6c1.4-8.5-2-17.1-8.7-22.5C57.3 334.1 48 316.2 48 296c0-19.3 8.5-36.6 22.1-48.3c8-6.9 10.5-18.3 6.1-28c-2.7-6-4.2-12.6-4.2-19.7c0-18.8 10.8-35.1 26.7-43c8.1-4 13.3-12.3 13.3-21.3c.1-19.3 11.7-36 28.3-43.5c6.4-2.9 11.3-8.5 13.2-15.3C158.3 60.2 173.8 48 192 48zm-4 464c26.9 0 51.2-11.6 68-30c16.8 18.5 41.1 30 68 30c32.2 0 60.5-16.5 76.9-41.5c45-8 79.1-47.3 79.1-94.5c0-.5 0-1.1 0-1.6c19.8-20.2 32-47.9 32-78.4c0-27.8-10.1-53.2-26.8-72.7C487 215.8 488 208 488 200c0-32.6-16.3-61.5-41.1-78.8c-4.5-28.9-21.8-53.5-45.9-67.8C387.5 22 356.3 0 320 0c-25.2 0-48 10.6-64 27.6C240 10.6 217.2 0 192 0c-36.3 0-67.5 22-80.9 53.4C86.9 67.7 69.6 92.3 65.1 121.2C40.3 138.5 24 167.4 24 200c0 8 1 15.8 2.8 23.3C10.1 242.8 0 268.2 0 296c0 30.5 12.2 58.2 32 78.4c0 .5 0 1.1 0 1.6c0 47.3 34.1 86.5 79.1 94.5c16.4 25 44.7 41.5 76.9 41.5zm136-48c-24.3 0-44-19.7-44-44l0-68 51.3 0c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L280 320l0-160 40 0c8.8 0 16 7.2 16 16l0 11.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3c0-26.5-21.5-48-48-48l-40 0 0-40c0-22.1 17.9-40 40-40c18.2 0 33.7 12.2 38.5 28.9c1.9 6.8 6.8 12.4 13.2 15.3c16.6 7.5 28.2 24.1 28.3 43.5c.1 9.1 5.2 17.3 13.3 21.3c15.9 7.9 26.7 24.2 26.7 43c0 7.1-1.5 13.7-4.2 19.7c-4.4 9.7-1.9 21 6.1 28c13.5 11.8 22.1 29 22.1 48.3c0 20.2-9.3 38.1-23.9 49.9c-6.7 5.4-10 14-8.7 22.5c.4 2.5 .6 5 .6 7.6c0 26.1-20.8 47.3-46.7 48c-9.2 .3-17.4 5.7-21.2 14.1C357.2 453.4 341.8 464 324 464zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
};
const faTableCellsRowUnlock = {
  prefix: 'far',
  iconName: 'table-cells-row-unlock',
  icon: [640, 512, [], "e691", "M48 296l0-80 104 0 0 80L48 296zm0 120l0-72 104 0 0 88-88 0c-8.8 0-16-7.2-16-16zm264 16l-112 0 0-88 112 0 0 88zm72 0l-24 0 0-88 24.5 0c2.5-20.3 14.6-37.6 31.5-47.4l0-.6-56 0 0-80 71 0c16.8-29.1 46.4-49.9 81-54.9L512 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0 0-48zM200 216l112 0 0 80-112 0 0-80zm296 56c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-48 0-32 0-32 0 0-48z"]
};
const faUserInjured = {
  prefix: 'far',
  iconName: 'user-injured',
  icon: [448, 512, [], "f728", "M224 208c-44.2 0-80-35.8-80-80l32 0 128 0c0 44.2-35.8 80-80 80zM150.7 96C163 67.7 191.2 48 224 48c1.2 0 2.5 0 3.7 .1L170.2 96l-19.6 0zM264.6 59c14.5 8.5 26 21.5 32.8 37l-77.2 0 44.4-37zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM49.3 464c4.7-33.3 21.9-62.5 46.7-82.7L96 464l-46.7 0zm246.3 0l-34.3 0-32-48 46.7 0c15.5 0 28 12.5 28 28c0 7.8-3.2 14.9-8.4 20zm37 0c2.2-6.3 3.4-13 3.4-20c0-33.1-26.9-60-60-60l-68 0-21.3-32 83 0c65.7 0 120.1 48.7 129 112l-66.1 0zM178.3 304C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"]
};
const faBlockBrickFire = {
  prefix: 'far',
  iconName: 'block-brick-fire',
  icon: [640, 512, ["firewall"], "e3dc", "M176 80l0 48 32 0 48 0 80 0 0-48L176 80zm-48 48l0-48L96 80c-8.8 0-16 7.2-16 16l0 32 48 0zM80 176l0 56 128 0 0-56L80 176zm0 160l48 0 0-56-48 0 0 56zm0 48l0 32c0 8.8 7.2 16 16 16l112 0 0-48-32 0-48 0-48 0zm96-48l112.8 0c-.5 4.7-.8 9.4-.8 14.1c0 11.5 1 22.9 3 33.9l-35 0 0 48 50.1 0c8.1 17.5 18.8 33.7 31.5 48L96 480c-35.3 0-64-28.7-64-64L32 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 48.6c-1.7-1.5-3.3-3.1-5-4.6c-17.7-16-44.7-16-62.5-.1c-12.9 11.5-25.1 23.7-36.5 36.1L256 176l0 56 76 0c-2.4 3.6-4.7 7.2-6.9 10.7c-7.4 12-14.2 24.5-19.9 37.3L176 280l0 56zM432 128l0-32c0-8.8-7.2-16-16-16l-32 0 0 48 48 0zm73.7 80.3L518 194.5c5.4-6.1 13.3-8.8 20.9-8.9c7.2 0 14.3 2.6 19.9 7.8c19.7 18.3 39.8 43.2 55 70.6C629 291.2 640 322.2 640 352.2C640 440.8 568.7 512 480 512c-89.6 0-160-71.3-160-159.8c0-37.3 16-73.4 36.8-104.5c20.9-31.3 47.5-59 70.9-80.2c5.7-5.2 13.1-7.7 20.3-7.5c14.1 .3 23.8 11.4 32.7 21.6c0 0 0 0 0 0c2 2.3 4 4.6 6 6.7l19 19.9zM544 400.2c0-36.5-37-73-54.8-88.4c-5.4-4.7-13.1-4.7-18.5 0C453 327.1 416 363.6 416 400.2c0 35.3 28.7 64 64 64s64-28.7 64-64z"]
};
const faFirewall = faBlockBrickFire;
const faFaceSadTear = {
  prefix: 'far',
  iconName: 'face-sad-tear',
  icon: [512, 512, [128546, "sad-tear"], "f5b4", "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faSadTear = faFaceSadTear;
const faPlane = {
  prefix: 'far',
  iconName: 'plane',
  icon: [576, 512, [], "f072", "M557.3 215.3c9.9 9.7 18.7 23.3 18.7 40.7c0 17.4-8.6 31.2-18.7 41.1c-9.9 9.7-22.6 17-34.9 22.4C497.8 330.2 468.6 336 448 336l-66.2 0L285.7 486.2c-10.3 16.1-28.1 25.8-47.2 25.8l-40.6 0c-27.1 0-46.4-26.4-38.1-52.2L199.4 336 148 336l-36 48L92.8 369.6 112 384c-7.6 10.1-19.4 16-32 16l-42.1 0C17 400 0 383 0 362.1c0-3.8 .6-7.5 1.7-11.1c0 0 0 0 0 0L30.9 256 1.7 161.1s0 0 0 0C.6 157.4 0 153.7 0 149.9C0 129 17 112 37.9 112L80 112c12.6 0 24.4 5.9 32 16l36 48 51.4 0L159.8 52.2C151.6 26.4 170.8 0 197.9 0l40.6 0c19.1 0 36.9 9.7 47.2 25.8L381.8 176l66.2 0c20.7 0 50 6.1 74.5 16.9c12.3 5.5 24.9 12.8 34.8 22.4zm-54.2 21.5c-19-8.4-41.7-12.8-55.1-12.8l-79.4 0c-8.2 0-15.8-4.2-20.2-11.1L245.2 51.7l20.2-12.9L245.2 51.7c-1.5-2.3-4-3.7-6.7-3.7l-29.6 0 46.3 144.7c2.3 7.3 1 15.3-3.5 21.5s-11.7 9.8-19.4 9.8L136 224c-7.6 0-14.7-3.6-19.2-9.6L76 160l-24.4 0 27.4 88.9c1.4 4.6 1.4 9.5 0 14.1L51.6 352 76 352l40.8-54.4c4.5-6 11.6-9.6 19.2-9.6l96.3 0c7.7 0 14.9 3.7 19.4 9.8s5.8 14.2 3.5 21.5L208.9 464l29.6 0c2.7 0 5.3-1.4 6.7-3.7L348.4 299.1c4.4-6.9 12-11.1 20.2-11.1l79.4 0c13.6 0 36.3-4.2 55.2-12.5c9.4-4.1 16.3-8.5 20.6-12.7c4.1-4 4.2-6.2 4.2-6.8c0 0 0 0 0 0c0-.2 0-2.2-4.2-6.3c-4.3-4.2-11.3-8.7-20.7-12.9zM47.6 365s0 0 0 0s0 0 0 0s0 0 0 0zm0-218.1s0 0 0 0s0 0 0 0s0 0 0 0z"]
};
const faTentArrowsDown = {
  prefix: 'far',
  iconName: 'tent-arrows-down',
  icon: [576, 512, [], "e581", "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L488 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM302.7 165c-8.6-6.7-20.7-6.7-29.3 0L107.6 293.1c-11.5 8.9-19.1 22-21.2 36.4L69.5 448.1C64.6 481.8 90.8 512 124.9 512l326.2 0c34.1 0 60.3-30.2 55.4-63.9L489.6 329.5c-2.1-14.4-9.7-27.5-21.2-36.4L302.7 165zM137 331l127-98.2L264 464l-139.1 0c-4.9 0-8.6-4.3-7.9-9.1l16.9-118.6c.3-2.1 1.4-3.9 3-5.2zm175 29l0-127.1L439 331c1.6 1.3 2.7 3.1 3 5.2L459 454.9c.7 4.8-3.1 9.1-7.9 9.1l-76.7 0L312 360z"]
};
const faExclamation = {
  prefix: 'far',
  iconName: 'exclamation',
  icon: [128, 512, [10069, 10071, 61738], "21", "M88 56c0-13.3-10.7-24-24-24S40 42.7 40 56l0 288c0 13.3 10.7 24 24 24s24-10.7 24-24L88 56zM64 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faArrowsSpin = {
  prefix: 'far',
  iconName: 'arrows-spin',
  icon: [512, 512, [], "e4bb", "M257.1 87.5c-11.3 0-22.4 1.1-33.1 3.3l0-48.7c10.8-1.7 21.9-2.5 33.1-2.5c56 0 107 21.3 145.4 56.2l35.1-35.1c10.1-10.1 27.3-2.9 27.3 11.3l0 105.4c0 8.8-7.2 16-16 16l-105.4 0c-14.3 0-21.4-17.2-11.3-27.3l36.3-36.3c-29.6-26.3-68.7-42.2-111.4-42.2zM129.9 145.9c-25.4 29.4-40.7 67.8-40.7 109.7c0 11.1 1.1 22 3.1 32.5l-48.7 0c-1.6-10.6-2.4-21.4-2.4-32.5c0-55.2 20.7-105.5 54.7-143.7L60.7 76.7C50.6 66.6 57.7 49.4 72 49.4l105.4 0c8.8 0 16 7.2 16 16l0 105.4c0 14.3-17.2 21.4-27.3 11.3l-36.2-36.2zm52.2 202.4l-34.6 34.6c29.4 25.4 67.8 40.7 109.7 40.7c10.5 0 20.9-1 30.9-2.8l0 48.6c-10.1 1.4-20.4 2.2-30.9 2.2c-55.2 0-105.5-20.7-143.7-54.7L76.7 453.6c-10.1 10.1-27.3 2.9-27.3-11.3l0-105.4c0-8.8 7.2-16 16-16l105.4 0c14.3 0 21.4 17.2 11.3 27.3zm166.2-16l34.7 34.7c26.3-29.6 42.2-68.7 42.2-111.4c0-10.8-1-21.3-3-31.5l48.7 0c1.5 10.3 2.3 20.8 2.3 31.5c0 56-21.3 107-56.2 145.4l36.7 36.7c10.1 10.1 2.9 27.3-11.3 27.3l-105.4 0c-8.8 0-16-7.2-16-16l0-105.4c0-14.3 17.2-21.4 27.3-11.3z"]
};
const faFaceSmileRelaxed = {
  prefix: 'far',
  iconName: 'face-smile-relaxed',
  icon: [512, 512, [], "e392", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm-2-98.1c-10.6 0-19.9 3.8-25.4 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7zm134.6 9.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"]
};
const faCommentXmark = {
  prefix: 'far',
  iconName: 'comment-xmark',
  icon: [512, 512, ["comment-times"], "f4b5", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM175 159c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
};
const faCommentTimes = faCommentXmark;
const faPrint = {
  prefix: 'far',
  iconName: 'print',
  icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z"]
};
const faTurkishLiraSign = {
  prefix: 'far',
  iconName: 'turkish-lira-sign',
  icon: [384, 512, ["try", "turkish-lira"], "e2bb", "M88 32c13.3 0 24 10.7 24 24l0 56.2L249.4 72.9c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 162.1l0 46.1 137.4-39.3c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7L112 258.1 112 432l71.8 0c81.3 0 148.2-63.9 151.8-145.1l.4-8c.6-13.2 11.8-23.5 25.1-22.9s23.5 11.8 22.9 25.1l-.4 8C378.8 395.9 290.7 480 183.8 480L88 480c-13.3 0-24-10.7-24-24l0-184.2-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11 0-46.1-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11L64 56c0-13.3 10.7-24 24-24z"]
};
const faTry = faTurkishLiraSign;
const faTurkishLira = faTurkishLiraSign;
const faFaceNoseSteam = {
  prefix: 'far',
  iconName: 'face-nose-steam',
  icon: [576, 512, [], "e382", "M288 464c-21.6 0-42.4-3.3-61.9-9.4c-3.1 8.6-8.1 16.7-15 23.6c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-7-7-12-15.2-15.1-23.9c-19 5.7-39.2 8.8-60 8.8zM496 256c0 21.3-3.2 41.8-9.1 61.1c8.5 3.1 16.5 8.1 23.4 14.9c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4l4 4-4-4c7.2-7.2 15.7-12.3 24.7-15.4C83 296.8 80 276.8 80 256C80 141.1 173.1 48 288 48s208 93.1 208 208zM377.9 443.6s0 0 0 0c1.5 4.7 4.1 9.1 7.9 12.9c.7 .7 1.3 1.3 2 1.9c4.2 3.6 9.2 5.9 14.4 6.9c-1.8 3.7-2.8 7.7-3.1 11.7c-.1 1.3-.1 2.7 0 4c0 .6 .1 1.3 .2 1.9c.8 6.9 3.9 13.6 9.2 18.9c12.5 12.5 32.8 12.5 45.3 0c2.1-2.1 3.8-4.3 5.2-6.7c18.8 14.5 45.9 13.1 63.1-4.2s18.6-44.3 4.2-63.1c2.4-1.4 4.7-3.1 6.7-5.2c12.5-12.5 12.5-32.8 0-45.3c-4.3-4.3-9.5-7.1-15-8.5c0 0 0 0 0 0c-1.9-.5-3.8-.8-5.8-.9c-5.4-.3-10.8 .7-15.7 3.1c-1-5.2-3.3-10.1-6.9-14.4c-.6-.7-1.2-1.4-1.8-2c-3.6-3.6-7.9-6.2-12.5-7.7c0 0 0 0 0 0c-11.1-3.7-23.9-1.1-32.8 7.7c-4.4 4.4-7.2 9.7-8.5 15.3l-69.1-46.8c-2.7-1.9-6.4-1.5-8.7 .8c-2.3 2.3-2.7 5.9-.9 8.7l46 70c-5.6 1.3-10.9 4.2-15.3 8.5c-8.8 8.8-11.4 21.3-7.9 32.4zM174.4 485.5c.4-1.8 .7-3.6 .8-5.4c.3-5.4-.7-10.8-3.1-15.7c5.2-1 10.1-3.3 14.4-6.9c.7-.6 1.4-1.2 2-1.8c3.7-3.7 6.3-8.2 7.9-12.9c3.5-11 .9-23.6-7.9-32.4c-4.4-4.4-9.7-7.2-15.3-8.5l47.6-69.1c1.9-2.7 1.5-6.4-.8-8.8c-2.3-2.3-5.9-2.7-8.6-.9l-70.9 46.1c-1.3-5.6-4.2-10.9-8.5-15.3c-8.6-8.6-20.8-11.3-31.6-8.1c-5 1.5-9.7 4.2-13.6 8.1c-.7 .7-1.3 1.3-1.9 2c-3.6 4.3-5.9 9.2-6.9 14.4c-4.9-2.4-10.3-3.4-15.7-3.1c-1.5 .1-3.1 .3-4.6 .6c-5.9 1.2-11.6 4.1-16.2 8.7c-12.5 12.5-12.5 32.8 0 45.3c2.1 2.1 4.3 3.8 6.7 5.2c-14.4 18.8-13.1 45.9 4.2 63.1s44.3 18.6 63.1 4.2c1.4 2.4 3.1 4.7 5.2 6.7c12.5 12.5 32.8 12.5 45.3 0c4.4-4.4 7.2-9.8 8.5-15.4zM144 224c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0zm95.2-101.1c-2.8-8.4-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1c8.4-2.8 12.9-11.9 10.1-20.2zm-286.4 0c-2.8 8.4 1.7 17.4 10.1 20.2c35.5 11.8 64.4 34.8 73.7 44.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9c-8.4-2.8-17.4 1.7-20.2 10.1z"]
};
const faCircleWaveformLines = {
  prefix: 'far',
  iconName: 'circle-waveform-lines',
  icon: [512, 512, ["waveform-circle"], "e12d", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-368c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 224c0 13.3 10.7 24 24 24s24-10.7 24-24l0-224zm80 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zM176 216c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm240 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32z"]
};
const faWaveformCircle = faCircleWaveformLines;
const faDollarSign = {
  prefix: 'far',
  iconName: 'dollar-sign',
  icon: [320, 512, [128178, 61781, "dollar", "usd"], "24", "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 47.7c-3.1 .1-6.2 .3-9.3 .6c-23.2 1.9-47.2 7.4-67.2 20.1C38.7 105.6 23.5 126 18 154.2c-3.9 20.3-2 38.8 6.1 55.2c8 16 20.9 27.6 34.8 36.2c26.2 16.2 61.9 25.3 92.9 33.2l2.3 .6c33.9 8.6 62.6 16.1 81.7 28c9 5.6 14.3 11.2 17.1 16.9c2.7 5.3 4.2 12.8 2 24.5c-2.9 14.7-13.4 26.9-34.5 34.9c-21.6 8.2-52 10.9-87.6 5.9c-22.6-3.3-61.8-12.7-83-22.1c-12.1-5.4-26.3 .1-31.7 12.2s.1 26.3 12.2 31.7C57 423.2 101.1 433.4 126 437l.1 0c3.3 .5 6.6 .9 9.9 1.2l0 49.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48.6c19.3-1.3 37.4-4.9 53.5-11c31.9-12.1 57.7-35.2 64.5-70.6c3.9-20.3 2-38.8-6.1-55.2c-8-16-20.9-27.6-34.8-36.2c-26.2-16.2-61.9-25.3-92.9-33.2l-2.3-.6c-33.9-8.6-62.6-16.1-81.7-28c-9-5.6-14.3-11.2-17.1-16.9c-2.7-5.3-4.2-12.8-2-24.5c2.9-14.8 10.1-24 20.2-30.4c10.9-6.9 26.3-11.2 45.3-12.7c38.3-3.1 83.1 5.3 113.9 12.5c12.9 3.1 25.8-4.9 28.9-17.8S268.4 89 255.5 86c-18.7-4.4-44.2-9.7-71.5-12.5L184 24z"]
};
const faDollar = faDollarSign;
const faUsd = faDollarSign;
const faFerrisWheel = {
  prefix: 'far',
  iconName: 'ferris-wheel',
  icon: [512, 512, [], "e174", "M371.4 73.4c-20.4-13-43.2-22.6-67.5-28.1C302.5 20.1 281.6 0 256 0s-46.5 20.1-47.9 45.3c-24.3 5.5-47.1 15.1-67.5 28.1c-8-5.9-17.9-9.4-28.5-9.4c-26.5 0-48 21.5-48 48c0 10.7 3.5 20.6 9.4 28.5c-13 20.4-22.6 43.2-28.1 67.5C20.1 209.5 0 230.4 0 256s20.1 46.5 45.3 47.9c5.5 24.3 15.1 47.1 28.1 67.5c-5.9 8-9.4 17.9-9.4 28.6c0 25.6 20 46.4 45.1 47.9l38.5-80c-7.4-8.3-17.7-13.9-29.3-15.5c-14.8-21.1-24.9-45.7-28.7-72.4l90 0c-2.4-7.6-3.7-15.6-3.7-24s1.3-16.4 3.7-24l-90 0c3.8-26.7 13.9-51.3 28.7-72.4c2.1-.3 4.1-.7 6-1.2L185.1 219c7.6-14.5 19.5-26.4 33.9-33.9l-60.6-60.6c.5-2 .9-4 1.2-6c21.1-14.8 45.7-24.9 72.4-28.7l0 90c7.6-2.4 15.6-3.7 24-3.7s16.4 1.3 24 3.7l0-90c26.7 3.8 51.3 13.9 72.4 28.7c.3 2.1 .7 4.1 1.2 6L293 185.1c14.5 7.6 26.4 19.5 33.9 33.9l60.6-60.6c2 .5 4 .9 6 1.2c14.8 21.1 24.9 45.7 28.7 72.4l-90 0c2.4 7.6 3.7 15.6 3.7 24s-1.3 16.4-3.7 24l90 0c-3.8 26.7-13.9 51.3-28.7 72.4c-11.6 1.5-21.8 7.2-29.3 15.5l38.5 80C428 446.4 448 425.6 448 400c0-10.7-3.5-20.6-9.4-28.6c13-20.4 22.6-43.2 28.1-67.5c25.3-1.4 45.3-22.3 45.3-47.9s-20.1-46.5-45.3-47.9c-5.5-24.3-15.1-47.1-28.1-67.5c5.9-8 9.4-17.9 9.4-28.5c0-26.5-21.5-48-48-48c-10.7 0-20.6 3.5-28.6 9.4zM304 256c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.6 4.1 22.3 11 30.6L130.2 477.9c-3.5 7.4-2.9 16.1 1.5 23s12 11.1 20.2 11.1l208 0c8.2 0 15.8-4.2 20.2-11.1s5-15.6 1.5-23L293 286.6c6.9-8.3 11-19 11-30.6zm18.4 208l-132.8 0L256 321l66.4 143z"]
};
const faComputerSpeaker = {
  prefix: 'far',
  iconName: 'computer-speaker',
  icon: [640, 512, [], "f8b2", "M312.4 480c-11.8-13.2-20.1-29.7-23.1-48L120 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l192.4 0zM64 32C28.7 32 0 60.7 0 96L0 320c0 35.3 28.7 64 64 64l224 0 0-48L64 336c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l225.3 0c3.1-18.3 11.3-34.8 23.1-48L64 32zM576 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l192 0zM384 32c-35.3 0-64 28.7-64 64l0 320c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L384 32zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM448 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
};
const faSkullCow = {
  prefix: 'far',
  iconName: 'skull-cow',
  icon: [640, 512, [], "f8de", "M63.2 21.1c2.5-7.4-.7-15.4-7.5-19.1S40.3 0 35.5 6L28 15.3C9.9 38 0 66.4 0 95.5C0 166.1 57.2 224 128 224c0 0 0 0 0 0l16 0 0 64c0 45 31 82.8 72.7 93.2l25.6 85.2c8.1 27.1 33 45.6 61.3 45.6l32.8 0c28.3 0 53.2-18.5 61.3-45.6l25.6-85.2C465 370.8 496 333 496 288l0-64 16 0s0 0 0 0c70.8 0 128-57.9 128-128.5c0-29-9.9-57.4-28-80.1L604.5 6c-4.8-6.1-13.3-7.8-20.1-4.1s-10 11.8-7.5 19.1L588 54.5c2.5 7.5 3.4 15.4 2.6 23.2C587.7 106.3 563.7 128 535 128l-23 0s0 0 0 0l-40.4 0C454 108.4 428.4 96 400 96L240 96c-28.4 0-54 12.4-71.6 32L128 128s0 0 0 0l-23 0c-28.7 0-52.7-21.7-55.6-50.3c-.8-7.8 .1-15.8 2.6-23.2L63.2 21.1zM228.3 334.6C207.4 329.4 192 310.4 192 288l0-64 0-32c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 32 0 64c0 22.4-15.4 41.4-36.3 46.6c-16.4 4.1-29.5 16.6-34.4 32.8l-25.6 85.2c-2 6.8-8.3 11.4-15.3 11.4l-32.8 0c-7.1 0-13.3-4.6-15.3-11.4l-25.6-85.2c-4.9-16.2-17.9-28.7-34.4-32.8zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
};
const faX = {
  prefix: 'far',
  iconName: 'x',
  icon: [384, 512, [120], "58", "M378.4 71.4c8.5-10.1 7.2-25.3-2.9-33.8s-25.3-7.2-33.8 2.9L192 218.7 42.4 40.6C33.9 30.4 18.7 29.1 8.6 37.6S-2.9 61.3 5.6 71.4L160.7 256 5.6 440.6c-8.5 10.2-7.2 25.3 2.9 33.8s25.3 7.2 33.8-2.9L192 293.3 341.6 471.4c8.5 10.2 23.7 11.5 33.8 2.9s11.5-23.7 2.9-33.8L223.3 256l155-184.6z"]
};
const faMagnifyingGlassDollar = {
  prefix: 'far',
  iconName: 'magnifying-glass-dollar',
  icon: [512, 512, ["search-dollar"], "f688", "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm20-312c0-11-9-20-20-20s-20 9-20 20l0 14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1c0 0 0 0 0 0s0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4l0 14.6c0 11 9 20 20 20s20-9 20-20l0-13.8c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7l0-13.9z"]
};
const faSearchDollar = faMagnifyingGlassDollar;
const faUsersGear = {
  prefix: 'far',
  iconName: 'users-gear',
  icon: [640, 512, ["users-cog"], "f509", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320l213.3 0c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7l-42.7 0C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2l-103.2 0C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7l300.6 0c-2.1-5.2-3.2-10.9-3.2-16.4l0-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-199.4 0c9.5-36.8 42.9-64 82.6-64l110.5 0c3.6-5 8.2-9.1 13.5-12.2l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192l-42.7 0c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3l0-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6l0 3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM624.6 355.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6l0-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9l0 21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6l0 21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9l0-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"]
};
const faUsersCog = faUsersGear;
const faPersonMilitaryPointing = {
  prefix: 'far',
  iconName: 'person-military-pointing',
  icon: [576, 512, [], "e54a", "M224 39c0-13 10-23.8 22.9-24.9L398.7 1.4C408 .7 416 8 416 17.4L416 48c0 8.8-7.2 16-16 16L249 64c-13.8 0-25-11.2-25-25zM32 248c0-13.3 10.7-24 24-24l176 0 8 0 104 0 .6 0c42.9 0 82.5 22.9 103.9 60l92.3 160c6.6 11.5 2.7 26.2-8.8 32.8s-26.2 2.7-32.8-8.8L416 323.8 416 480c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-208L56 272c-13.3 0-24-10.7-24-24zm240 24l0 82.1L345.4 272c-.5 0-1 0-1.4 0l-72 0zm0 192l96 0 0-32-96 0 0 32zm96-145.2L309.7 384l58.3 0 0-65.2zM240 112c0-5.5 .6-10.8 1.6-16l50.7 0c-2.7 4.7-4.3 10.2-4.3 16c0 17.7 14.3 32 32 32s32-14.3 32-32c0-5.8-1.6-11.3-4.3-16l50.7 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
};
const faBuildingColumns = {
  prefix: 'far',
  iconName: 'building-columns',
  icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192l443.9 0c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144L88.2 144 256 51.4 423.8 144l-140.1 0c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224l0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0 0 160-64 0 0-160-48 0zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l456 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464z"]
};
const faBank = faBuildingColumns;
const faInstitution = faBuildingColumns;
const faMuseum = faBuildingColumns;
const faUniversity = faBuildingColumns;
const faCircleT = {
  prefix: 'far',
  iconName: 'circle-t',
  icon: [512, 512, [], "e124", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 168c0 13.3 10.7 24 24 24s24-10.7 24-24l0-168 80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-104 0-104 0z"]
};
const faSack = {
  prefix: 'far',
  iconName: 'sack',
  icon: [512, 512, [], "f81c", "M293.3 152l-74.6 0-13.8 8.8C150.9 195.4 48 277 48 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48c0-139-102.9-220.6-156.9-255.2L293.3 152zm.2-58.8L324.6 48 187.4 48l31.1 45.2L226 104l60 0 7.5-10.8zM0 416C0 274.8 89.4 185.5 150.8 139.9c10.4-7.7 20-14.2 28.2-19.4L151.8 80.9 121.9 37.6C111 21.7 122.4 0 141.7 0L370.3 0c19.3 0 30.7 21.7 19.8 37.6L360.2 80.9 333 120.4c8.2 5.3 17.8 11.7 28.2 19.4C422.6 185.5 512 274.8 512 416c0 53-43 96-96 96L96 512c-53 0-96-43-96-96z"]
};
const faGrid2 = {
  prefix: 'far',
  iconName: 'grid-2',
  icon: [512, 512, [], "e196", "M80 80l0 96 96 0 0-96L80 80zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 336l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 80l-96 0 0 96 96 0 0-96zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 304l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z"]
};
const faCameraCctv = {
  prefix: 'far',
  iconName: 'camera-cctv',
  icon: [576, 512, ["cctv"], "f8ac", "M54.9 192.2l169.3 70.5 .2 .1c.6 .2 1.1 .4 1.6 .7l92.2 38.4 160-106.7L134.9 52.2l-80 140zM185.2 298.5l-165.5-69c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9L229.5 317 182.4 440.5C178.9 449.8 170 456 160 456L48 456l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32 95.5 0 41.7-109.5zm211.8 47.1l132.9-88.6 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-1.7 4-4.9 7.2-8.9 8.7s-8.5 1.5-12.5-.3L396.9 345.6z"]
};
const faCctv = faCameraCctv;
const faUmbrella = {
  prefix: 'far',
  iconName: 'umbrella',
  icon: [576, 512, [], "f0e9", "M288 0c13.3 0 24 10.7 24 24l0 24.9c123.7 9.6 226.1 93 255.5 204.4c.4 1.4 .7 2.9 1.1 4.3c1.4 5.8 2.7 11.7 3.7 17.6c.6 3.5 1.1 7.1 1.6 10.7c2 15.6-17.3 24.4-27.8 12.7c-2.5-2.8-5.5-5.5-8.8-8c-3.4-2.5-7.1-4.9-11.1-7l-.7-.4-.6-.3c-13.5-6.8-29.7-11-44.9-11c-30.1 0-56.3 16.6-70 41.2c-.5 .9-1 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6c-13.7-24.6-39.9-41.2-70-41.2s-56.3 16.6-70 41.2c-.5 .9-.9 1.7-1.4 2.6c-2.1 4.1-3.8 8.3-5.1 12.8c-.7 2.4-1.4 4.9-1.9 7.5c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9c-.5-2.5-1.1-5-1.9-7.5c-1.4-4.4-3.1-8.7-5.1-12.8c-.5-.9-.9-1.8-1.4-2.6C152.3 288.6 126.1 272 96 272c-15.2 0-31.4 4.2-44.9 11c-.4 .2-.9 .5-1.3 .7c-4 2.1-7.7 4.4-11.1 7c-3.3 2.5-6.3 5.2-8.8 8C19.4 310.4 .1 301.5 2.1 285.9c.5-3.6 1-7.2 1.6-10.7c1-5.9 2.3-11.8 3.7-17.6c.4-1.4 .7-2.9 1.1-4.3C37.9 141.9 140.3 58.6 264 48.9L264 24c0-13.3 10.7-24 24-24zm96 267.3c23.4-26.6 57.7-43.3 96-43.3c8.6 0 17.5 .9 26.4 2.6C468.9 150.2 386.1 96 288 96s-180.9 54.2-218.4 130.6c8.9-1.7 17.8-2.6 26.4-2.6c38.3 0 72.6 16.8 96 43.3c23.4-26.6 57.7-43.3 96-43.3s72.6 16.8 96 43.3zM288 304c8.7 0 16.9 2.3 24 6.4l0 128.1c0 40.6-32.9 73.4-73.4 73.4c-27.8 0-53.2-15.7-65.7-40.6l-2.3-4.7c-5.9-11.9-1.1-26.3 10.7-32.2s26.3-1.1 32.2 10.7l2.3 4.7c4.3 8.6 13.1 14.1 22.8 14.1c14.1 0 25.4-11.4 25.4-25.4l0-128.1c7.1-4.1 15.3-6.4 24-6.4z"]
};
const faTrowel = {
  prefix: 'far',
  iconName: 'trowel',
  icon: [512, 512, [], "e589", "M340.4 142L370 171.6l87.9-87.9c8.2-8.2 8.2-21.4 0-29.6s-21.4-8.2-29.6 0L340.4 142zM491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-5.4-5.4L237.9 308l75 75c5.9 5.9 8.3 14.5 6.4 22.6s-8 14.6-15.9 17.2l-272 88c-8.6 2.8-18 .5-24.4-5.9s-8.6-15.8-5.9-24.4l88-272c2.6-7.9 9.1-14 17.2-15.9s16.7 .5 22.6 6.4l75 75L304.3 173.8l-5.4-5.4c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zM251.3 389.2L122.8 260.7l-61.5 190 190-61.5z"]
};
const faHorizontalRule = {
  prefix: 'far',
  iconName: 'horizontal-rule',
  icon: [640, 512, [8213], "f86c", "M0 256c0-13.3 10.7-24 24-24l592 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24z"]
};
const faBedFront = {
  prefix: 'far',
  iconName: 'bed-front',
  icon: [512, 512, ["bed-alt"], "f8f7", "M32 80l0 125.8c14.5-7.7 30.8-12.4 48-13.6l0-.3 0-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 32 32 0 0-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 32 0 .3c17.2 1.1 33.5 5.9 48 13.6L480 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80zM88 224c-48.6 0-88 39.4-88 88l0 80 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 416 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 0-80c0-48.6-39.4-88-88-88L88 224zM464 368L48 368l0-56c0-22.1 17.9-40 40-40l336 0c22.1 0 40 17.9 40 40l0 56z"]
};
const faBedAlt = faBedFront;
const faD = {
  prefix: 'far',
  iconName: 'd',
  icon: [384, 512, [100], "44", "M56 80c-4.4 0-8 3.6-8 8l0 336c0 4.4 3.6 8 8 8l104 0c97.2 0 176-78.8 176-176s-78.8-176-176-176L56 80zM0 88C0 57.1 25.1 32 56 32l104 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L56 480c-30.9 0-56-25.1-56-56L0 88z"]
};
const faStapler = {
  prefix: 'far',
  iconName: 'stapler',
  icon: [640, 512, [], "e5af", "M448 384l0 48L56 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l392 0 48 0 24 0 72 0c26.5 0 48-21.5 48-48l0-96 0-36.7 0-11.3-.7-.1c-3.8-31.8-23.3-59.9-52.4-74.4L260.7 50.4C236.6 38.3 209.9 32 182.9 32C128.2 32 76.7 57.8 43.8 101.6L11.5 144.7C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L64 240l0 104c0 22.1 17.9 40 40 40l344 0zm0-48l-336 0 0-84 336 84zm72 96l-24 0 0-96c0-22-15-41.2-36.4-46.6L55.2 188.3c-4.2-1.1-7.2-4.8-7.2-9.2c0-2 .7-4 1.9-5.7l32.3-43.1C106 98.7 143.3 80 182.9 80c19.5 0 38.8 4.6 56.3 13.3L565.5 256.4c14.5 7.3 24.3 21.3 26.2 37.2c.1 .8 .2 1.6 .3 2.4l0 3.4 0 36.7 0 96-72 0z"]
};
const faMasksTheater = {
  prefix: 'far',
  iconName: 'masks-theater',
  icon: [640, 512, [127917, "theater-masks"], "f630", "M376.1 32.1c-41.2 .7-71.8 7.8-94.3 16.7c-23.1-2-53.9-1.4-94 5.2C95.6 69.1 60.7 98 49.3 110.7L76.8 271.9c4.9 28.7 17.5 52.2 36.1 67.2c20.3 16.4 45.2 34 70.7 46.2c10.4 5 20 8.6 28.8 11.1c1.7 3.1 3.4 6.1 5.3 9.2c8.1 13 17.9 27.5 29.1 42.1c-58 4.9-123.3-37.8-165-71.7c-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28c1.7 1.2 3.2 2.5 4.5 4zM194 282.3c-15.6 5.8-29.7 14-42.1 24.2c-6.6 5.4-16.8 1.7-15.6-6.6c5.4-35 31.3-64.6 67.2-74.3l-8.5 49.6c-.4 2.3-.8 4.7-1.1 7zM176.7 153.7c4.5-3.2 11.1-2.2 12.2 3.1c.1 .5 .2 1.1 .3 1.6c3.7 21.7-11.2 42.2-33.4 45.8s-43.1-11-46.8-32.7c-.1-.5-.2-1.1-.2-1.6c-.7-5.4 5.3-8.4 10.5-6.9c9.3 2.8 19.5 3.6 29.8 1.9s19.6-5.7 27.5-11.3zM385.1 510.6c-60-9.8-110.5-74.6-140.1-122c-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9C289.5 76.8 344 51.8 460.2 70.9S619.5 131 634.5 152.1c5.8 8.1 6.4 18.2 4.7 28L611.3 343.8c-6.4 37.2-23.5 72.2-53.2 96.2c-43.7 35.4-113.1 80.5-173 70.7zm-47-80.7c20.7 20.3 39.5 31 55 33.6s36.9-1.6 63.2-14.2c25.5-12.2 50.4-29.8 70.7-46.2c18.6-15.1 31.2-38.6 36.1-67.3l27.5-161.2C579.3 162 544.4 133.1 452.1 118s-134.9 1-149.9 9.4L274.7 288.6c-4.9 28.7-.8 54.9 11.8 75.1c13.7 22 31.5 46.6 51.5 66.2zm57.3-193.4c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6c-1.1 5.3-7.8 6.3-12.2 3.1zm140.4 17.9c-1.1 5.3-7.8 6.3-12.2 3.1c-7.9-5.6-17.2-9.6-27.5-11.3s-20.4-.9-29.8 1.9c-5.3 1.6-11.2-1.5-10.5-6.9c.1-.5 .2-1.1 .2-1.6c3.7-21.7 24.6-36.3 46.8-32.7s37.1 24.1 33.4 45.8c-.1 .5-.2 1.1-.3 1.6zm-20.3 56.6c7.9-3.2 16.5 3.5 12.8 11.1c-21.1 44.3-70.3 71.2-121.9 62.8s-89.2-49.7-94.4-98.2c-.9-8.3 9.4-12 15.8-6.4c24.3 21.2 54.8 36.2 89.3 41.8s68.3 1.2 98.3-11.1z"]
};
const faTheaterMasks = faMasksTheater;
const faFileGif = {
  prefix: 'far',
  iconName: 'file-gif',
  icon: [512, 512, [], "e645", "M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm160-72c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8c0-4.4-3.6-8-8-8l-16 0c-4.4 0-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-8c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 24c0 22.1-17.9 40-40 40l-16 0c-22.1 0-40-17.9-40-40l0-80zm160-24l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm48-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64c0-8.8 7.2-16 16-16z"]
};
const faKipSign = {
  prefix: 'far',
  iconName: 'kip-sign',
  icon: [384, 512, [], "e1c4", "M88 32c13.3 0 24 10.7 24 24l0 154.5L312.3 37.8c10-8.7 25.2-7.5 33.8 2.5s7.5 25.2-2.5 33.8L160.6 232 360 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-199.4 0L343.7 437.8c10 8.7 11.2 23.8 2.5 33.8s-23.8 11.2-33.8 2.5L112 301.5 112 457c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-177-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40 0L64 56c0-13.3 10.7-24 24-24z"]
};
const faFaceWoozy = {
  prefix: 'far',
  iconName: 'face-woozy',
  icon: [512, 512, [], "e3a2", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 208c0-35.3-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64s32-28.7 32-64zM213.8 247.3c12.9-3.2 20.7-16.2 17.5-29.1s-16.2-20.7-29.1-17.5l-64 16c-12.9 3.2-20.7 16.2-17.5 29.1s16.2 20.7 29.1 17.5l64-16zM200.9 98.7c-7.4-4.9-17.3-2.9-22.2 4.4c-23.2 34.8-58.4 53.2-71.7 57.7c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1c18.6-6.2 60.3-28.3 88.3-70.3c4.9-7.4 2.9-17.3-4.4-22.2zM385.8 360.1c8.9-9.8 8.2-25-1.6-33.9s-25-8.2-33.9 1.6L319 362.3c-3.3 3.6-7.9 5.7-12.8 5.7c-3.5 0-6.9-1.1-9.8-3l-11.7-8.1c-24-16.5-54.7-19.4-81.4-7.7c-11.7 5.2-25.3 3.7-35.7-3.9l-9.4-6.9c-10.7-7.8-25.7-5.6-33.6 5.1s-5.6 25.7 5.1 33.6l9.4 6.9c24.2 17.8 56 21.2 83.4 9.1c11.4-5 24.5-3.8 34.8 3.3l11.7 8.1c10.9 7.5 23.8 11.5 37 11.5c18.4 0 36-7.8 48.3-21.4l31.3-34.5z"]
};
const faCloudQuestion = {
  prefix: 'far',
  iconName: 'cloud-question',
  icon: [640, 512, [], "e492", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2l-3.3 0-360 0c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2s0 0 0 0s0 0 0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480l0-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144l320 0 40 0 8 0zM233.8 197.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3l58.3 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1l-58.3 0c-23.7 0-44.8 14.9-52.8 37.3zM352 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
const faPineapple = {
  prefix: 'far',
  iconName: 'pineapple',
  icon: [512, 512, [], "e31f", "M423.1 1.7c4.2 2.1 7.3 5.9 8.4 10.5l3.6 14.3C447 19.6 460.6 16 474.5 16l5.5 0c8.8 0 16 7.2 16 16l0 5.5c0 13.9-3.6 27.5-10.4 39.4l14.3 3.6c4.6 1.1 8.4 4.2 10.5 8.4s2.2 9.1 .4 13.4c-6.8 15.9-19.5 26.7-34.1 31.6l14.7 14.7c6.2 6.2 6.2 16.4 0 22.6c-15.4 15.4-35.3 23.6-55.5 24.5c8 18.9 12.2 39.3 12.2 60.2c0 41-16.3 80.3-45.3 109.3L301.3 466.7C272.3 495.7 233 512 192 512s-80.3-16.3-109.3-45.3L45.3 429.3l33.9-33.9 37.5 37.5c20 20 47.1 31.2 75.3 31.2s55.3-11.2 75.3-31.2L368.8 331.3c20-20 31.2-47.1 31.2-75.3s-11.2-55.3-31.2-75.3l-37.5-37.5c-20-20-47.1-31.2-75.3-31.2s-55.3 11.2-75.3 31.2L79.2 244.7C59.2 264.7 48 291.8 48 320s11.2 55.3 31.2 75.3L45.3 429.3C16.3 400.3 0 361 0 320s16.3-80.3 45.3-109.3L146.7 109.3C175.7 80.3 215 64 256 64c20.9 0 41.3 4.2 60.2 12.2c.9-20.2 9.1-40.1 24.5-55.5c6.2-6.2 16.4-6.2 22.6 0l14.7 14.7C383 20.8 393.8 8.1 409.7 1.3c4.3-1.8 9.2-1.7 13.4 .4zm-235.8 211L208 233.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80L128 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM288 313.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 313.4zM164.7 372.7c6.2-6.2 16.4-6.2 22.6 0L208 393.4l20.7-20.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-32 32c-6.2 6.2-16.4 6.2-22.6 0l-32-32c-6.2-6.2-6.2-16.4 0-22.6z"]
};
const faHandPointLeft = {
  prefix: 'far',
  iconName: 'hand-point-left',
  icon: [512, 512, [], "f0a5", "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"]
};
const faGalleryThumbnails = {
  prefix: 'far',
  iconName: 'gallery-thumbnails',
  icon: [576, 512, [], "e3aa", "M512 48c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16L64 304c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l448 0zM64 0C28.7 0 0 28.7 0 64L0 288c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L64 0zM0 448l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0zm128 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32zm192-32c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-32 0z"]
};
const faCircleJ = {
  prefix: 'far',
  iconName: 'circle-j',
  icon: [512, 512, [], "e112", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-360c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 136c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 53 43 96 96 96s96-43 96-96l0-136z"]
};
const faEyes = {
  prefix: 'far',
  iconName: 'eyes',
  icon: [640, 512, [], "e367", "M255.6 385.2C231.4 416.6 201.5 432 172 432s-59.4-15.4-83.6-46.8c-9.1-11.9-17.1-25.7-23.5-41.2c9.2 5.1 19.8 8 31.1 8c35.3 0 64-28.7 64-64s-28.7-64-64-64c-19 0-36.1 8.3-47.8 21.4c2-47.8 17.7-89.3 40.2-118.6C112.6 95.4 142.5 80 172 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2zM320 141.8C290 76.1 235 32 172 32C77 32 0 132.3 0 256S77 480 172 480c63 0 118-44.1 148-109.8C350 435.9 405 480 468 480c95 0 172-100.3 172-224s-77-224-172-224c-63 0-118 44.1-148 109.8zm42.8 206.6c6.6 2.3 13.7 3.6 21.2 3.6c35.3 0 64-28.7 64-64s-28.7-64-64-64c-14.8 0-28.5 5-39.3 13.5c3.3-44.4 18.5-83 39.8-110.6C408.6 95.4 438.5 80 468 80s59.4 15.4 83.6 46.8c24.1 31.4 40.4 77 40.4 129.2s-16.3 97.7-40.4 129.2C527.4 416.6 497.5 432 468 432s-59.4-15.4-83.6-46.8c-8.2-10.7-15.5-23.1-21.6-36.7z"]
};
const faHandshakeSimple = {
  prefix: 'far',
  iconName: 'handshake-simple',
  icon: [640, 512, [129309, "handshake-alt"], "f4c6", "M272.2 64.6c-4.4-.4-8.8-.6-13.2-.6l-10.3 0c-37.2 0-73.2 13.7-101 38.4L121.1 126c-1.5 1.3-3.4 2-5.3 2L56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l59.8 0c13.7 0 27-5 37.2-14.1l26.5-23.6c12-10.7 26.2-18.3 41.5-22.5l51.1-51.1zM377.1 64c-37.6 0-73.9 14.4-101.2 40.2l-70.1 66.2c-30.8 29.1-30.1 78.3 1.6 106.5c27.8 24.7 69.7 24.3 97-.9l35.8-33 75.8 75.8c9.4 9.4 9.4 24.6 0 33.9c-8.4 8.4-21.6 9.3-30.9 2.6c-7.1-5.1-16.5-5.9-24.4-2.1s-13.1 11.6-13.6 20.4c-.4 7.1-3.2 14-8.6 19.4c-11.6 11.6-30.4 11.6-41.9 0l-10.7-10.7c-5.8-5.8-14.2-8.2-22.2-6.5s-14.6 7.5-17.3 15.3c-.8 2.1-2 4.1-3.7 5.8c-6.2 6.2-16.4 6.2-22.6 0L193 370.1c0 0 0 0 0 0l-7-7-35.6-35.6c-15-15-35.4-23.4-56.6-23.4L56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l37.7 0c8.5 0 16.6 3.4 22.6 9.4L152 397l7 7L185.9 431c23.6 23.6 60.9 24.9 86 4.1c30.4 22 73 19.3 100.4-8.1c6.1-6.1 10.9-12.9 14.6-20.2c22.2 3.8 45.8-2.9 63-20.1c5.6-5.6 10.1-11.9 13.5-18.7L584 368c13.3 0 24-10.7 24-24s-10.7-24-24-24l-114.8 0c-2.9-12.9-9.3-25.1-19.4-35.1l-74.4-74.4 .8-.8c9.7-9 10.3-24.2 1.4-33.9s-24.2-10.3-33.9-1.4l-71.9 66.4c-9.2 8.5-23.2 8.6-32.5 .3c-10.6-9.4-10.9-26-.5-35.7l70.1-66.2c18.5-17.4 42.9-27.1 68.3-27.1c24.4 0 47.9 8.9 66.1 25.1l36.9 32.8c4.4 3.9 10.1 6.1 15.9 6.1l88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-78.9 0L475 101.2C448 77.3 413.2 64 377.1 64z"]
};
const faHandshakeAlt = faHandshakeSimple;
const faPageCaretUp = {
  prefix: 'far',
  iconName: 'page-caret-up',
  icon: [384, 512, ["file-caret-up"], "e42a", "M48 448c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-309.5c0-4.2-1.7-8.3-4.7-11.3L256.8 52.7c-3-3-7.1-4.7-11.3-4.7L64 48c-8.8 0-16 7.2-16 16l0 384zm272 64L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L245.5 0c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64zM192 192c4.5 0 8.8 1.9 11.8 5.2l75.7 82.6c14.1 15.4 3.2 40.2-17.7 40.2l-139.6 0c-20.9 0-31.8-24.8-17.7-40.2l75.7-82.6c3-3.3 7.3-5.2 11.8-5.2z"]
};
const faFileCaretUp = faPageCaretUp;
const faJetFighter = {
  prefix: 'far',
  iconName: 'jet-fighter',
  icon: [640, 512, ["fighter-jet"], "f0fb", "M216 0l23.8 0 .4 0L296 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-6.9 0c4.7 6.1 9.8 12.6 15.1 19.6c25.3 32.8 56.8 74.1 81.8 108.4l97.1 0c5.7 0 11.3 .9 16.7 2.5l108.1 33.8C627 218.3 640 236 640 256s-13 37.7-32.1 43.7L499.8 333.4c-5.4 1.7-11 2.6-16.7 2.6L386 336 288.5 464l7.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-55.8 0-.5 0L216 512l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-128-14.1 0-31.6 31.6c-10.5 10.5-24.7 16.4-39.6 16.4L88 384c-30.9 0-56-25.1-56-56l0-48-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-48c0-30.9 25.1-56 56-56l18.7 0c14.9 0 29.1 5.9 39.6 16.4L177.9 176l14.1 0 0-128-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l32 0zm24 176l86.4 0c-19.9-26.7-41.6-55.1-60.1-79.1C256.3 84 247.3 72.4 240 63l0 113zM80 280l0 48c0 4.4 3.6 8 8 8l18.7 0c2.1 0 4.2-.8 5.7-2.3L151 295c4.5-4.5 10.6-7 17-7l315.1 0c.8 0 1.6-.1 2.4-.4L586.7 256 485.5 224.4c-.8-.2-1.6-.4-2.4-.4L168 224c-6.4 0-12.5-2.5-17-7l-38.6-38.6c-1.5-1.5-3.5-2.3-5.7-2.3L88 176c-4.4 0-8 3.6-8 8l0 48 56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0zm160 56l0 112.4L325.6 336 240 336z"]
};
const faFighterJet = faJetFighter;
const faComet = {
  prefix: 'far',
  iconName: 'comet',
  icon: [512, 512, [], "e003", "M459.8 3.2c4.7-2.1 9.8-3.2 15-3.2C495.3 0 512 16.7 512 37.2c0 5.2-1.1 10.3-3.2 15L449.3 187.5l10.7-.8c33.9-2.6 55.4 35.5 35.6 63.1L369.2 426.7C331 480.2 269.3 512 203.6 512C91 512 0 419.8 0 307.5c0-64.8 30.6-126.3 82.7-165L261.6 9.6c27.5-20.4 66.3 .9 63.7 35.1L324 62.9 459.8 3.2zm-6 55.1l-147 64.7c-7.7 3.4-16.6 2.5-23.5-2.4s-10.7-13-10.1-21.4l3-40.6L111.4 181C71.6 210.6 48 257.8 48 307.5C48 393.6 117.8 464 203.6 464c50.2 0 97.4-24.3 126.6-65.2l116.4-163L413 238.5c-8.4 .6-16.5-3.2-21.4-10.1s-5.8-15.8-2.4-23.5L453.8 58.3zM208 200c6.1 0 11.7 3.5 14.3 8.9l24.5 49.6 54.8 8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-39.6 38.6 9.4 54.5c1 6-1.4 12.1-6.4 15.7s-11.5 4.1-16.8 1.2l-49-25.8-49 25.8c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.7l9.4-54.5-39.6-38.6c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l54.8-8 24.5-49.6c2.7-5.5 8.3-8.9 14.3-8.9z"]
};
const faSquareShareNodes = {
  prefix: 'far',
  iconName: 'square-share-nodes',
  icon: [448, 512, ["share-alt-square"], "f1e1", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm352 80c0 26.5-21.5 48-48 48c-9.8 0-18.9-2.9-26.5-7.9L197.7 256l79.9 39.9c7.6-5 16.7-7.9 26.5-7.9c26.5 0 48 21.5 48 48s-21.5 48-48 48c-25.5 0-46.4-20-47.9-45.1l-85.6-42.8c-7.6 5-16.7 7.9-26.5 7.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c9.8 0 18.9 2.9 26.5 7.9l85.6-42.8C257.6 148 278.5 128 304 128c26.5 0 48 21.5 48 48z"]
};
const faShareAltSquare = faSquareShareNodes;
const faReflectVertical = {
  prefix: 'far',
  iconName: 'reflect-vertical',
  icon: [512, 512, [], "e665", "M0 256c0-13.3 10.7-24 24-24l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24zM166.6 464l178.7 0L256 374.6 166.6 464zM128 512c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8l-256 0zM256 137.4L345.4 48 166.6 48 256 137.4zM98.4 19.8C103.4 7.8 115.1 0 128 0L384 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9z"]
};
const faShieldKeyhole = {
  prefix: 'far',
  iconName: 'shield-keyhole',
  icon: [512, 512, [], "e248", "M73 127L256 49.4 439 127c5.9 2.5 9.1 7.8 9 12.8c-.4 91.4-38.4 249.3-186.3 320.1c-3.6 1.7-7.8 1.7-11.3 0C102.4 389 64.5 231.2 64 139.7c0-5 3.1-10.2 9-12.8zM457.7 82.8L269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.8 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2zM312 208c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4c0 13.3 10.7 24 24 24s24-10.7 24-24l0-69.4c18.9-9 32-28.3 32-50.6z"]
};
const faFileMp4 = {
  prefix: 'far',
  iconName: 'file-mp4',
  icon: [512, 512, [], "e649", "M64 464l16 0 0 48-16 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zm93.7-104.2L192 416.9l34.3-57.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-70.2-18.3 30.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8L160 425.8l0 70.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2zM304 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm84.7 11.3c-3-3-4.7-7.1-4.7-11.3l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-4.2 0-8.3-1.7-11.3-4.7z"]
};
const faBarcode = {
  prefix: 'far',
  iconName: 'barcode',
  icon: [512, 512, [], "f02a", "M24 32C10.7 32 0 42.7 0 56L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24L48 56c0-13.3-10.7-24-24-24zm88 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zm112 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zM464 56l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-64-8l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
};
const faBulldozer = {
  prefix: 'far',
  iconName: 'bulldozer',
  icon: [640, 512, [], "e655", "M80 88l0 88 141.9 0-43-91.4c-1.3-2.8-4.1-4.6-7.2-4.6L88 80c-4.4 0-8 3.6-8 8zM32 176l0-88c0-30.9 25.1-56 56-56l83.7 0c21.7 0 41.4 12.5 50.7 32.2L275 176l53 0 0-56c0-13.3 10.7-24 24-24s24 10.7 24 24l0 56c39.8 0 72 32.2 72 72l0 48 64 0 0-31.3c0-21.9 8.2-43 22.9-59.2l63.4-69.7c8.9-9.8 24.1-10.5 33.9-1.6s10.5 24.1 1.6 33.9l-63.4 69.7c-6.7 7.4-10.4 17-10.4 26.9l0 110.5c0 9.9 3.7 19.5 10.4 26.9l63.4 69.7c8.9 9.8 8.2 25-1.6 33.9s-25 8.2-33.9-1.6l-63.4-69.7c-14.7-16.2-22.9-37.3-22.9-59.2l0-31.3-47 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400c0-30.5 12.2-58.2 32-78.4L32 224l0-24 0-24zM80 292.6c10.1-3 20.9-4.6 32-4.6l256 0c11.1 0 21.9 1.6 32 4.6l0-44.6c0-13.3-10.7-24-24-24L80 224l0 68.6zM112 336c-35.3 0-64 28.7-64 64s28.7 64 64 64l256 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-256 0zM96 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
};
const faPlusMinus = {
  prefix: 'far',
  iconName: 'plus-minus',
  icon: [384, 512, [], "e43c", "M216 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 120L48 152c-13.3 0-24 10.7-24 24s10.7 24 24 24l120 0 0 120c0 13.3 10.7 24 24 24s24-10.7 24-24l0-120 120 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-120 0 0-120zM8 488c0 13.3 10.7 24 24 24l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L32 464c-13.3 0-24 10.7-24 24z"]
};
const faSquareSlidersVertical = {
  prefix: 'far',
  iconName: 'square-sliders-vertical',
  icon: [448, 512, ["sliders-v-square"], "f3f2", "M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 96c-13.3 0-24 10.7-24 24l0 32-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-32c0-13.3-10.7-24-24-24zm184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-128z"]
};
const faSlidersVSquare = faSquareSlidersVertical;
const faVideo = {
  prefix: 'far',
  iconName: 'video',
  icon: [576, 512, ["video-camera"], "f03d", "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 33 0 190 0 33c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM528 363.4l0-214.7L416 199l0-52.6L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5l0 241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6l0-52.6 112 50.4z"]
};
const faVideoCamera = faVideo;
const faMessageMiddle = {
  prefix: 'far',
  iconName: 'message-middle',
  icon: [512, 512, ["comment-middle-alt"], "e1e1", "M343.5 368L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l104.5 0c14.2 0 27.8 6.3 36.9 17.3L256 446l50.6-60.7c9.1-10.9 22.6-17.3 36.9-17.3zm-175 48L64 416c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-104.5 0-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"]
};
const faCommentMiddleAlt = faMessageMiddle;
const faGraduationCap = {
  prefix: 'far',
  iconName: 'graduation-cap',
  icon: [640, 512, [127891, "mortar-board"], "f19d", "M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z"]
};
const faMortarBoard = faGraduationCap;
const faHandHoldingMedical = {
  prefix: 'far',
  iconName: 'hand-holding-medical',
  icon: [576, 512, [], "e05c", "M224 24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l56 0 0-56zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l40.7 0 73.8-49.2C153 309.1 170 304 187.4 304L344 304c35.3 0 64 28.7 64 64c0 .7 0 1.3 0 2l64.9-40c10.7-6.6 22.9-10 35.5-10l7.4 0c33.3 0 60.3 27 60.3 60.3c0 20.4-10.4 39.5-27.5 50.6l-95.6 61.9c-19.4 12.6-42.1 19.3-65.2 19.3L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l363.7 0c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3c0-6.8-5.5-12.3-12.3-12.3l-7.4 0c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6l-48 0-24 0-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 24 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-156.6 0z"]
};
const faPersonCircleCheck = {
  prefix: 'far',
  iconName: 'person-circle-check',
  icon: [576, 512, [], "e53e", "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm32 128.1L144 304l32 0 0-127.9c-.7 0-1.5-.1-2.3-.1l-27.5 0c-.8 0-1.5 0-2.3 .1zM144 352l0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-264.4L52.9 299.8c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7L69.7 172.7c15.6-27.6 44.9-44.7 76.6-44.7l27.5 0c31.7 0 61 17.1 76.6 44.7L297 255.1c-11.7 14-21.3 29.9-28.3 47.1c-.6-.8-1.1-1.6-1.6-2.4L224 223.6 224 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136-32 0zm144 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"]
};
const faSquareZ = {
  prefix: 'far',
  iconName: 'square-z',
  icon: [448, 512, [], "e288", "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm136 32l176 0c9.3 0 17.8 5.4 21.8 13.9s2.6 18.5-3.5 25.6L187.7 336 312 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L260.3 176 136 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
};
const faMessageText = {
  prefix: 'far',
  iconName: 'message-text',
  icon: [512, 512, ["comment-alt-text"], "e1e6", "M208 416c0-26.5-21.5-48-48-48l-96 0c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 288c0 8.8-7.2 16-16 16l-138.7 0c-10.4 0-20.5 3.4-28.8 9.6L208 432l0-16zm-.2 76.2l.2-.2 101.3-76L448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l48 0 48 0 0 48 0 4 0 .3 0 6.4 0 21.3c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM168 112c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 136c0 13.3 10.7 24 24 24s24-10.7 24-24l0-136 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0-88 0z"]
};
const faCommentAltText = faMessageText;
const faTurnUp = {
  prefix: 'far',
  iconName: 'turn-up',
  icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3L264 208l0 144c0 88.4-71.6 160-160 160l-48 0c-30.9 0-56-25.1-56-56l0-32c0-30.9 25.1-56 56-56l56 0c4.4 0 8-3.6 8-8l0-152-41.7 0C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7L175.6 6.5zM82.5 160l61.5 0c13.3 0 24 10.7 24 24l0 176c0 30.9-25.1 56-56 56l-56 0c-4.4 0-8 3.6-8 8l0 32c0 4.4 3.6 8 8 8l48 0c61.9 0 112-50.1 112-112l0-168c0-13.3 10.7-24 24-24l61.5 0L192 57 82.5 160z"]
};
const faLevelUpAlt = faTurnUp;
var icons = {
  fa0,
  fa1,
  fa2,
  fa3,
  fa4,
  fa5,
  fa6,
  fa7,
  fa8,
  fa9,
  faFillDrip,
  faArrowsToCircle,
  faCircleChevronRight,
  faChevronCircleRight,
  faWagonCovered,
  faLineHeight,
  faBagel,
  faTransporter7,
  faAt,
  faRectanglesMixed,
  faPhoneArrowUpRight,
  faPhoneArrowUp,
  faPhoneOutgoing,
  faTrashCan,
  faTrashAlt,
  faCircleL,
  faHeadSideGoggles,
  faHeadVr,
  faTextHeight,
  faUserXmark,
  faUserTimes,
  faFaceHandYawn,
  faGaugeSimpleMin,
  faTachometerSlowest,
  faStethoscope,
  faCoffin,
  faMessage,
  faCommentAlt,
  faSalad,
  faBowlSalad,
  faInfo,
  faRobotAstromech,
  faRingDiamond,
  faFonduePot,
  faTheta,
  faFaceHandPeeking,
  faSquareUser,
  faDownLeftAndUpRightToCenter,
  faCompressAlt,
  faExplosion,
  faFileLines,
  faFileAlt,
  faFileText,
  faWaveSquare,
  faRing,
  faBuildingUn,
  faDiceThree,
  faTirePressureWarning,
  faWifiFair,
  faWifi2,
  faCalendarDays,
  faCalendarAlt,
  faMp3Player,
  faAnchorCircleCheck,
  faTally4,
  faRectangleHistory,
  faBuildingCircleArrowRight,
  faVolleyball,
  faVolleyballBall,
  faSunHaze,
  faTextSize,
  faUfo,
  faFork,
  faUtensilFork,
  faArrowsUpToLine,
  faMobileSignal,
  faBarcodeScan,
  faSortDown,
  faSortDesc,
  faFolderArrowDown,
  faFolderDownload,
  faCircleMinus,
  faMinusCircle,
  faFaceIcicles,
  faShovel,
  faDoorOpen,
  faFilms,
  faRightFromBracket,
  faSignOutAlt,
  faFaceGlasses,
  faNfc,
  faAtom,
  faSoap,
  faIcons,
  faHeartMusicCameraBolt,
  faMicrophoneLinesSlash,
  faMicrophoneAltSlash,
  faClosedCaptioningSlash,
  faCalculatorSimple,
  faCalculatorAlt,
  faBridgeCircleCheck,
  faSlidersUp,
  faSlidersV,
  faLocationMinus,
  faMapMarkerMinus,
  faPumpMedical,
  faFingerprint,
  faSkiBoot,
  faStandardDefinition,
  faRectangleSd,
  faH1,
  faHandPointRight,
  faMagnifyingGlassLocation,
  faSearchLocation,
  faMessageBot,
  faForwardStep,
  faStepForward,
  faFaceSmileBeam,
  faSmileBeam,
  faLightCeiling,
  faMessageExclamation,
  faCommentAltExclamation,
  faBowlScoop,
  faBowlShavedIce,
  faSquareX,
  faBuildingMemo,
  faUtilityPoleDouble,
  faFlagCheckered,
  faChevronsUp,
  faChevronDoubleUp,
  faFootball,
  faFootballBall,
  faUserVneck,
  faSchoolCircleExclamation,
  faCrop,
  faAnglesDown,
  faAngleDoubleDown,
  faUsersRectangle,
  faPeopleRoof,
  faSquareArrowRight,
  faArrowSquareRight,
  faLocationPlus,
  faMapMarkerPlus,
  faLightbulbExclamationOn,
  faPeopleLine,
  faBeerMugEmpty,
  faBeer,
  faCarpool,
  faCarPeople,
  faCrateEmpty,
  faDiagramPredecessor,
  faTransporter,
  faCalendarCircleUser,
  faArrowUpLong,
  faLongArrowUp,
  faPersonCarryBox,
  faPersonCarry,
  faFireFlameSimple,
  faBurn,
  faPerson,
  faMale,
  faLaptop,
  faFileCsv,
  faMenorah,
  faUnion,
  faChevronsLeft,
  faChevronDoubleLeft,
  faCircleHeart,
  faHeartCircle,
  faTruckPlane,
  faRecordVinyl,
  faBringForward,
  faSquareP,
  faFaceGrinStars,
  faGrinStars,
  faSigma,
  faCameraMovie,
  faBong,
  faClarinet,
  faTruckFlatbed,
  faSpaghettiMonsterFlying,
  faPastafarianism,
  faArrowDownUpAcrossLine,
  faArrowsRotateReverse,
  faLeafHeart,
  faHouseBuilding,
  faCheeseSwiss,
  faSpoon,
  faUtensilSpoon,
  faJarWheat,
  faEnvelopesBulk,
  faMailBulk,
  faFileCircleExclamation,
  faBowArrow,
  faCartXmark,
  faHexagonXmark,
  faTimesHexagon,
  faXmarkHexagon,
  faCircleH,
  faHospitalSymbol,
  faMerge,
  faPager,
  faCartMinus,
  faAddressBook,
  faContactBook,
  faPanFrying,
  faGrid,
  faGrid3,
  faFootballHelmet,
  faHandLove,
  faTrees,
  faStrikethrough,
  faPage,
  faK,
  faDiagramPrevious,
  faGaugeMin,
  faTachometerAltSlowest,
  faFolderGrid,
  faEggplant,
  faExcavator,
  faRam,
  faLandmarkFlag,
  faLips,
  faPencil,
  faPencilAlt,
  faBackward,
  faCaretRight,
  faComments,
  faPaste,
  faFileClipboard,
  faDesktopArrowDown,
  faCodePullRequest,
  faPumpkin,
  faClipboardList,
  faPenField,
  faChartSine,
  faBlueberries,
  faTruckRampBox,
  faTruckLoading,
  faNote,
  faArrowDownToSquare,
  faUserCheck,
  faCloudXmark,
  faVialVirus,
  faBookBlank,
  faBookAlt,
  faGolfFlagHole,
  faMessageArrowDown,
  faCommentAltArrowDown,
  faFaceUnamused,
  faSheetPlastic,
  faCircle9,
  faBlog,
  faUserNinja,
  faPencilSlash,
  faBowlingPins,
  faPersonArrowUpFromLine,
  faDownRight,
  faScrollTorah,
  faTorah,
  faWebhook,
  faBlindsOpen,
  faFence,
  faUp,
  faArrowAltUp,
  faBroomBall,
  faQuidditch,
  faQuidditchBroomBall,
  faDrumstick,
  faSquareV,
  faFaceAwesome,
  faGaveDandy,
  faDialOff,
  faToggleOff,
  faFaceSmileHorns,
  faBoxArchive,
  faArchive,
  faGrapes,
  faPersonDrowning,
  faDialMax,
  faCircleM,
  faCalendarImage,
  faCircleCaretDown,
  faCaretCircleDown,
  faArrowDown91,
  faSortNumericDesc,
  faSortNumericDownAlt,
  faFaceGrinTongueSquint,
  faGrinTongueSquint,
  faShishKebab,
  faSprayCan,
  faAlarmSnooze,
  faScarecrow,
  faTruckMonster,
  faGiftCard,
  faW,
  faCodePullRequestDraft,
  faSquareB,
  faElephant,
  faEarthAfrica,
  faGlobeAfrica,
  faRainbow,
  faCircleNotch,
  faTabletScreenButton,
  faTabletAlt,
  faPaw,
  faMessageQuestion,
  faCloud,
  faTrowelBricks,
  faSquare3,
  faFaceFlushed,
  faFlushed,
  faHospitalUser,
  faMicrowave,
  faChfSign,
  faTentArrowLeftRight,
  faCartCircleArrowUp,
  faTrashClock,
  faReflectBoth,
  faGavel,
  faLegal,
  faSprinklerCeiling,
  faBrowsers,
  faTrillium,
  faTableCellsUnlock,
  faMusicSlash,
  faTruckRamp,
  faBinoculars,
  faMicrophoneSlash,
  faBoxTissue,
  faCircleC,
  faStarChristmas,
  faChartBullet,
  faMotorcycle,
  faTreeChristmas,
  faTireFlat,
  faSunglasses,
  faBadge,
  faMessagePen,
  faCommentAltEdit,
  faMessageEdit,
  faBellConcierge,
  faConciergeBell,
  faPenRuler,
  faPencilRuler,
  faFileMp3,
  faArrowProgress,
  faChessRookPiece,
  faChessRookAlt,
  faSquareRoot,
  faAlbumCollectionCirclePlus,
  faPeopleArrows,
  faPeopleArrowsLeftRight,
  faSignPost,
  faFaceAngryHorns,
  faMarsAndVenusBurst,
  faTombstone,
  faSquareCaretRight,
  faCaretSquareRight,
  faScissors,
  faCut,
  faListMusic,
  faSunPlantWilt,
  faToiletsPortable,
  faHockeyPuck,
  faMustache,
  faHyphen,
  faTable,
  faUserChef,
  faMessageImage,
  faCommentAltImage,
  faUsersMedical,
  faSensorTriangleExclamation,
  faSensorAlert,
  faMagnifyingGlassArrowRight,
  faTachographDigital,
  faDigitalTachograph,
  faFaceMask,
  faPickleball,
  faStarSharpHalf,
  faUsersSlash,
  faClover,
  faMeat,
  faReply,
  faMailReply,
  faStarAndCrescent,
  faEmptySet,
  faHouseFire,
  faSquareMinus,
  faMinusSquare,
  faHelicopter,
  faBird,
  faCompass,
  faSquareCaretDown,
  faCaretSquareDown,
  faHeartHalfStroke,
  faHeartHalfAlt,
  faFileCircleQuestion,
  faTruckUtensils,
  faLaptopCode,
  faJoystick,
  faGrillFire,
  faRectangleVerticalHistory,
  faSwatchbook,
  faPrescriptionBottle,
  faBars,
  faNavicon,
  faKeyboardLeft,
  faPeopleGroup,
  faHourglassEnd,
  faHourglass3,
  faHeartCrack,
  faHeartBroken,
  faFaceBeamHandOverMouth,
  faDropletPercent,
  faHumidity,
  faSquareUpRight,
  faExternalLinkSquareAlt,
  faFaceKissBeam,
  faKissBeam,
  faCorn,
  faRollerCoaster,
  faPhotoFilmMusic,
  faRadar,
  faSickle,
  faFilm,
  faCoconut,
  faRulerHorizontal,
  faShieldCross,
  faCassetteTape,
  faSquareTerminal,
  faPeopleRobbery,
  faLightbulb,
  faCaretLeft,
  faCommentMiddle,
  faTrashCanList,
  faBlock,
  faCircleExclamation,
  faExclamationCircle,
  faSchoolCircleXmark,
  faArrowRightFromBracket,
  faSignOut,
  faFaceFrownSlight,
  faCircleChevronDown,
  faChevronCircleDown,
  faSidebarFlip,
  faUnlockKeyhole,
  faUnlockAlt,
  faTemperatureList,
  faCloudShowersHeavy,
  faHeadphonesSimple,
  faHeadphonesAlt,
  faSitemap,
  faPipeSection,
  faSpaceStationMoonConstruction,
  faSpaceStationMoonAlt,
  faCircleDollarToSlot,
  faDonate,
  faMemory,
  faFaceSleeping,
  faRoadSpikes,
  faFireBurner,
  faSquirrel,
  faArrowUpToLine,
  faArrowToTop,
  faFlag,
  faFaceCowboyHat,
  faHanukiah,
  faChartScatter3d,
  faDisplayChartUp,
  faSquareCode,
  faFeather,
  faVolumeLow,
  faVolumeDown,
  faXmarkToSlot,
  faTimesToSlot,
  faVoteNay,
  faBoxTaped,
  faBoxAlt,
  faCommentSlash,
  faSwords,
  faCloudSunRain,
  faAlbum,
  faCircleN,
  faCompress,
  faWheatAwn,
  faWheatAlt,
  faAnkh,
  faHandsHoldingChild,
  faAsterisk,
  faKeySkeletonLeftRight,
  faCommentLines,
  faLuchadorMask,
  faLuchador,
  faMaskLuchador,
  faSquareCheck,
  faCheckSquare,
  faShredder,
  faBookOpenCover,
  faBookOpenAlt,
  faSandwich,
  faPesetaSign,
  faSquareParkingSlash,
  faParkingSlash,
  faTrainTunnel,
  faHeading,
  faHeader,
  faGhost,
  faFaceAnguished,
  faHockeySticks,
  faAbacus,
  faFilmSimple,
  faFilmAlt,
  faList,
  faListSquares,
  faTreePalm,
  faSquarePhoneFlip,
  faPhoneSquareAlt,
  faUserBeardBolt,
  faCartPlus,
  faGamepad,
  faBorderCenterV,
  faCircleDot,
  faDotCircle,
  faClipboardMedical,
  faFaceDizzy,
  faDizzy,
  faEgg,
  faUpToLine,
  faArrowAltToTop,
  faHouseMedicalCircleXmark,
  faWatchFitness,
  faClockNineThirty,
  faCampground,
  faFolderPlus,
  faJug,
  faFutbol,
  faFutbolBall,
  faSoccerBall,
  faSnowBlowing,
  faPaintbrush,
  faPaintBrush,
  faLock,
  faArrowDownFromLine,
  faArrowFromTop,
  faGasPump,
  faSignalBarsSlash,
  faSignalAltSlash,
  faMonkey,
  faRectanglePro,
  faPro,
  faHouseNight,
  faHotTubPerson,
  faHotTub,
  faGlobePointer,
  faBlanket,
  faMapLocation,
  faMapMarked,
  faHouseFloodWater,
  faCommentsQuestionCheck,
  faTree,
  faArrowsCross,
  faBackpack,
  faSquareSmall,
  faFolderArrowUp,
  faFolderUpload,
  faBridgeLock,
  faCrosshairsSimple,
  faSackDollar,
  faPenToSquare,
  faEdit,
  faSquareSliders,
  faSlidersHSquare,
  faCarSide,
  faMessageMiddleTop,
  faCommentMiddleTopAlt,
  faLightbulbOn,
  faKnife,
  faUtensilKnife,
  faShareNodes,
  faShareAlt,
  faDisplayChartUpCircleDollar,
  faWaveSine,
  faHeartCircleMinus,
  faCircleW,
  faCircleCalendar,
  faCalendarCircle,
  faHourglassHalf,
  faHourglass2,
  faMicroscope,
  faSunset,
  faSink,
  faCalendarExclamation,
  faTruckContainerEmpty,
  faHandHeart,
  faBagShopping,
  faShoppingBag,
  faArrowDownZA,
  faSortAlphaDesc,
  faSortAlphaDownAlt,
  faMitten,
  faReplyClock,
  faReplyTime,
  faPersonRays,
  faRight,
  faArrowAltRight,
  faCircleF,
  faUsers,
  faFacePleading,
  faEyeSlash,
  faFlaskVial,
  faPoliceBox,
  faCucumber,
  faHeadSideBrain,
  faHand,
  faHandPaper,
  faPersonBikingMountain,
  faBikingMountain,
  faUtensilsSlash,
  faPrintMagnifyingGlass,
  faPrintSearch,
  faTurnRight,
  faFolderBookmark,
  faArrowTurnLeftDown,
  faOm,
  faPi,
  faFlaskRoundPotion,
  faFlaskPotion,
  faFaceShush,
  faWorm,
  faHouseCircleXmark,
  faPlug,
  faCalendarCircleExclamation,
  faSquareI,
  faChevronUp,
  faFaceSaluting,
  faGaugeSimpleLow,
  faTachometerSlow,
  faFacePersevering,
  faCircleCamera,
  faCameraCircle,
  faHandSpock,
  faSpiderWeb,
  faCircleMicrophone,
  faMicrophoneCircle,
  faBookArrowUp,
  faPopsicle,
  faCommand,
  faBlinds,
  faStopwatch,
  faSaxophone,
  faSquare2,
  faFieldHockeyStickBall,
  faFieldHockey,
  faArrowUpSquareTriangle,
  faSortShapesUpAlt,
  faFaceScream,
  faSquareM,
  faCameraWeb,
  faWebcam,
  faCommentArrowDown,
  faLightbulbCfl,
  faWindowFrameOpen,
  faFaceKiss,
  faKiss,
  faBridgeCircleXmark,
  faPeriod,
  faFaceGrinTongue,
  faGrinTongue,
  faUpToDottedLine,
  faThoughtBubble,
  faSkeletonRibs,
  faRaygun,
  faFlute,
  faAcorn,
  faVideoArrowUpRight,
  faGrateDroplet,
  faSealExclamation,
  faChessBishop,
  faMessageSms,
  faCoffeeBeans,
  faHatWitch,
  faFaceGrinWink,
  faGrinWink,
  faClockThreeThirty,
  faEarDeaf,
  faDeaf,
  faDeafness,
  faHardOfHearing,
  faAlarmClock,
  faEclipse,
  faFaceRelieved,
  faRoadCircleCheck,
  faDiceFive,
  faOctagonMinus,
  faMinusOctagon,
  faSquareRss,
  faRssSquare,
  faFaceZany,
  faTricycle,
  faLandMineOn,
  faSquareArrowUpLeft,
  faICursor,
  faChartMixedUpCircleDollar,
  faSaltShaker,
  faStamp,
  faFilePlus,
  faDrawSquare,
  faToiletPaperUnderSlash,
  faToiletPaperReverseSlash,
  faStairs,
  faDroneFront,
  faDroneAlt,
  faGlassEmpty,
  faDialHigh,
  faUserHelmetSafety,
  faUserConstruction,
  faUserHardHat,
  faI,
  faHryvniaSign,
  faHryvnia,
  faArrowDownLeftAndArrowUpRightToCenter,
  faPills,
  faFaceGrinWide,
  faGrinAlt,
  faTooth,
  faBasketballHoop,
  faObjectsAlignBottom,
  faV,
  faSparkles,
  faSquid,
  faLeafyGreen,
  faCircleArrowUpRight,
  faCalendars,
  faBangladeshiTakaSign,
  faBicycle,
  faHammerWar,
  faCircleD,
  faSpiderBlackWidow,
  faStaffSnake,
  faRodAsclepius,
  faRodSnake,
  faStaffAesculapius,
  faPear,
  faHeadSideCoughSlash,
  faFileMov,
  faTriangle,
  faApartment,
  faTruckMedical,
  faAmbulance,
  faPepper,
  faPiano,
  faGunSquirt,
  faWheatAwnCircleExclamation,
  faSnowman,
  faUserAlien,
  faShieldCheck,
  faMortarPestle,
  faRoadBarrier,
  faChartCandlestick,
  faBriefcaseBlank,
  faSchool,
  faIgloo,
  faBracketRound,
  faParenthesis,
  faJoint,
  faHorseSaddle,
  faMugMarshmallows,
  faFilters,
  faBellOn,
  faAngleRight,
  faDialMed,
  faHorse,
  faQ,
  faMonitorWaveform,
  faMonitorHeartRate,
  faLinkSimple,
  faWhistle,
  faG,
  faWineGlassCrack,
  faFragile,
  faSlotMachine,
  faNotesMedical,
  faCarWash,
  faEscalator,
  faCommentImage,
  faTemperatureHalf,
  faTemperature2,
  faThermometer2,
  faThermometerHalf,
  faDongSign,
  faDonut,
  faDoughnut,
  faCapsules,
  faPooStorm,
  faPooBolt,
  faTally1,
  faFileVector,
  faFaceFrownOpen,
  faFrownOpen,
  faSquareDashed,
  faBagShoppingPlus,
  faSquareJ,
  faHandPointUp,
  faMoneyBill,
  faArrowUpBigSmall,
  faSortSizeUp,
  faBarcodeRead,
  faBaguette,
  faBowlSoftServe,
  faFaceHoldingBackTears,
  faSquareUp,
  faArrowAltSquareUp,
  faTrainSubwayTunnel,
  faSubwayTunnel,
  faSquareExclamation,
  faExclamationSquare,
  faSemicolon,
  faBookmark,
  faFanTable,
  faAlignJustify,
  faBatteryLow,
  faBattery1,
  faCreditCardFront,
  faBrainArrowCurvedRight,
  faMindShare,
  faUmbrellaBeach,
  faHelmetUn,
  faLocationSmile,
  faMapMarkerSmile,
  faArrowLeftToLine,
  faArrowToLeft,
  faBullseye,
  faSushi,
  faNigiri,
  faMessageCaptions,
  faCommentAltCaptions,
  faTrashList,
  faBacon,
  faOption,
  faRaccoon,
  faHandPointDown,
  faArrowUpFromBracket,
  faHeadSideGear,
  faTrashPlus,
  faFileCad,
  faObjectsAlignTop,
  faFolder,
  faFolderBlank,
  faFaceAnxiousSweat,
  faCreditCardBlank,
  faFileWaveform,
  faFileMedicalAlt,
  faMicrochipAi,
  faMug,
  faPlaneUpSlash,
  faRadiation,
  faPenCircle,
  faBagSeedling,
  faChartSimple,
  faCrutches,
  faCircleParking,
  faParkingCircle,
  faMarsStroke,
  faLeafOak,
  faSquareBolt,
  faVial,
  faGauge,
  faDashboard,
  faGaugeMed,
  faTachometerAltAverage,
  faWandMagicSparkles,
  faMagicWandSparkles,
  faLambda,
  faE,
  faPizza,
  faBowlChopsticksNoodles,
  faH3,
  faPenClip,
  faPenAlt,
  faBridgeCircleExclamation,
  faBadgePercent,
  faRotateReverse,
  faUser,
  faSensor,
  faComma,
  faSchoolCircleCheck,
  faToiletPaperUnder,
  faToiletPaperReverse,
  faLightEmergency,
  faArrowDownToArc,
  faDumpster,
  faVanShuttle,
  faShuttleVan,
  faBuildingUser,
  faLightSwitch,
  faSquareCaretLeft,
  faCaretSquareLeft,
  faHighlighter,
  faWavePulse,
  faHeartRate,
  faKey,
  faArrowLeftToBracket,
  faHatSanta,
  faTamale,
  faBoxCheck,
  faBullhorn,
  faSteak,
  faLocationCrosshairsSlash,
  faLocationSlash,
  faPersonDolly,
  faGlobe,
  faSynagogue,
  faFileChartColumn,
  faFileChartLine,
  faPersonHalfDress,
  faFolderImage,
  faCalendarPen,
  faCalendarEdit,
  faRoadBridge,
  faFaceSmileTear,
  faMessagePlus,
  faCommentAltPlus,
  faLocationArrow,
  faC,
  faTabletButton,
  faPersonDressFairy,
  faRectangleHistoryCircleUser,
  faBuildingLock,
  faChartLineUp,
  faMailbox,
  faSignPosts,
  faTruckBolt,
  faPizzaSlice,
  faMoneyBillWave,
  faChartArea,
  faAreaChart,
  faHouseFlag,
  faCircleThreeQuartersStroke,
  faPersonCircleMinus,
  faScalpel,
  faBan,
  faCancel,
  faBellExclamation,
  faCircleBookmark,
  faBookmarkCircle,
  faEggFried,
  faFaceWeary,
  faUniformMartialArts,
  faCameraRotate,
  faSunDust,
  faCommentText,
  faSprayCanSparkles,
  faAirFreshener,
  faSignalBars,
  faSignalAlt,
  faSignalAlt4,
  faSignalBarsStrong,
  faDiamondExclamation,
  faStar,
  faDialMin,
  faRepeat,
  faCross,
  faPageCaretDown,
  faFileCaretDown,
  faBox,
  faVenusMars,
  faClockSevenThirty,
  faArrowPointer,
  faMousePointer,
  faClockFourThirty,
  faSignalBarsGood,
  faSignalAlt3,
  faCactus,
  faLightbulbGear,
  faMaximize,
  faExpandArrowsAlt,
  faChargingStation,
  faShapes,
  faTriangleCircleSquare,
  faPlaneTail,
  faGaugeSimpleMax,
  faTachometerFastest,
  faCircleU,
  faShieldSlash,
  faSquarePhoneHangup,
  faPhoneSquareDown,
  faArrowUpLeft,
  faTransporter1,
  faPeanuts,
  faShuffle,
  faRandom,
  faPersonRunning,
  faRunning,
  faMobileRetro,
  faGripLinesVertical,
  faBinBottlesRecycle,
  faArrowUpFromSquare,
  faFileDashedLine,
  faPageBreak,
  faBracketCurlyRight,
  faSpider,
  faClockThree,
  faHandsBound,
  faScalpelLineDashed,
  faScalpelPath,
  faFileInvoiceDollar,
  faPipeSmoking,
  faFaceAstonished,
  faWindow,
  faPlaneCircleExclamation,
  faEar,
  faFileLock,
  faDiagramVenn,
  faArrowDownFromBracket,
  faXRay,
  faGoalNet,
  faCoffinCross,
  faOctopus,
  faSpellCheck,
  faLocationXmark,
  faMapMarkerTimes,
  faMapMarkerXmark,
  faCircleQuarterStroke,
  faLasso,
  faSlash,
  faPersonToPortal,
  faPortalEnter,
  faCalendarStar,
  faComputerMouse,
  faMouse,
  faArrowRightToBracket,
  faSignIn,
  faPegasus,
  faFilesMedical,
  faCannon,
  faNfcLock,
  faPersonSkiLift,
  faSkiLift,
  faSquare6,
  faShopSlash,
  faStoreAltSlash,
  faWindTurbine,
  faSlidersSimple,
  faGridRound,
  faBadgeSheriff,
  faServer,
  faVirusCovidSlash,
  faIntersection,
  faShopLock,
  faFamily,
  faHourglassStart,
  faHourglass1,
  faUserHairBuns,
  faBlenderPhone,
  faHourglassClock,
  faPersonSeatReclined,
  faPaperPlaneTop,
  faPaperPlaneAlt,
  faSend,
  faMessageArrowUp,
  faCommentAltArrowUp,
  faLightbulbExclamation,
  faLayerMinus,
  faLayerGroupMinus,
  faChartPieSimpleCircleCurrency,
  faCircleE,
  faBuildingWheat,
  faGaugeMax,
  faTachometerAltFastest,
  faPersonBreastfeeding,
  faApostrophe,
  faFilePng,
  faFireHydrant,
  faRightToBracket,
  faSignInAlt,
  faVideoPlus,
  faSquareRight,
  faArrowAltSquareRight,
  faCommentSmile,
  faVenus,
  faPassport,
  faThumbtackSlash,
  faThumbTackSlash,
  faInboxIn,
  faInboxArrowDown,
  faHeartPulse,
  faHeartbeat,
  faCircle8,
  faCloudsMoon,
  faClockTenThirty,
  faPeopleCarryBox,
  faPeopleCarry,
  faFolderUser,
  faTrashCanXmark,
  faTemperatureHigh,
  faMicrochip,
  faLeftLongToLine,
  faCrown,
  faWeightHanging,
  faXmarksLines,
  faFilePrescription,
  faTableCellsLock,
  faCalendarRange,
  faFlowerDaffodil,
  faHandBackPointUp,
  faWeightScale,
  faWeight,
  faArrowUpToArc,
  faStarExclamation,
  faBooks,
  faUserGroup,
  faUserFriends,
  faArrowUpAZ,
  faSortAlphaUp,
  faLayerPlus,
  faLayerGroupPlus,
  faPlayPause,
  faBlockQuestion,
  faSnooze,
  faZzz,
  faScannerImage,
  faTvRetro,
  faSquareT,
  faFarm,
  faBarnSilo,
  faChessKnight,
  faBarsSort,
  faPalletBoxes,
  faPaletteBoxes,
  faPalletAlt,
  faFaceLaughSquint,
  faLaughSquint,
  faCodeSimple,
  faBoltSlash,
  faPanelFire,
  faBinaryCircleCheck,
  faCommentMinus,
  faBurrito,
  faViolin,
  faObjectsColumn,
  faSquareChevronDown,
  faChevronSquareDown,
  faCommentPlus,
  faTriangleInstrument,
  faTriangleMusic,
  faWheelchair,
  faUserPilotTie,
  faPianoKeyboard,
  faBedEmpty,
  faCircleArrowUp,
  faArrowCircleUp,
  faToggleOn,
  faRectangleVertical,
  faRectanglePortrait,
  faPersonWalking,
  faWalking,
  faL,
  faSignalStream,
  faDownToBracket,
  faCircleZ,
  faStars,
  faFire,
  faBedPulse,
  faProcedures,
  faHouseDay,
  faShuttleSpace,
  faSpaceShuttle,
  faShirtLongSleeve,
  faChartPieSimple,
  faChartPieAlt,
  faFaceLaugh,
  faLaugh,
  faFolderOpen,
  faAlbumCollectionCircleUser,
  faCandy,
  faBowlHot,
  faSoup,
  faFlatbread,
  faHeartCirclePlus,
  faCodeFork,
  faCity,
  faSignalBarsWeak,
  faSignalAlt1,
  faMicrophoneLines,
  faMicrophoneAlt,
  faClockTwelve,
  faPepperHot,
  faCitrusSlice,
  faSheep,
  faUnlock,
  faColonSign,
  faHeadset,
  faBadgerHoney,
  faH4,
  faStoreSlash,
  faRoadCircleXmark,
  faSignalSlash,
  faUserMinus,
  faMarsStrokeUp,
  faMarsStrokeV,
  faChampagneGlasses,
  faGlassCheers,
  faTaco,
  faHexagonPlus,
  faPlusHexagon,
  faClipboard,
  faHouseCircleExclamation,
  faFileArrowUp,
  faFileUpload,
  faWifi,
  faWifi3,
  faWifiStrong,
  faMessages,
  faCommentsAlt,
  faBath,
  faBathtub,
  faUmbrellaSimple,
  faUmbrellaAlt,
  faRectangleHistoryCirclePlus,
  faUnderline,
  faPrescriptionBottlePill,
  faUserPen,
  faUserEdit,
  faBinarySlash,
  faSquareO,
  faCaduceus,
  faSignature,
  faStroopwafel,
  faBold,
  faAnchorLock,
  faBuildingNgo,
  faTransporter3,
  faEngineWarning,
  faEngineExclamation,
  faCircleDownRight,
  faSquareK,
  faManatSign,
  faMoneyCheckPen,
  faMoneyCheckEdit,
  faNotEqual,
  faBorderTopLeft,
  faBorderStyle,
  faMapLocationDot,
  faMapMarkedAlt,
  faTilde,
  faJedi,
  faSquarePollVertical,
  faPoll,
  faArrowDownSquareTriangle,
  faSortShapesDownAlt,
  faMugHot,
  faDogLeashed,
  faCarBattery,
  faBatteryCar,
  faFaceDowncastSweat,
  faMailboxFlagUp,
  faMemoCircleInfo,
  faGift,
  faDiceTwo,
  faVolume,
  faVolumeMedium,
  faTransporter5,
  faGaugeCircleBolt,
  faCoinFront,
  faFileSlash,
  faMessageArrowUpRight,
  faTreasureChest,
  faChessQueen,
  faPaintbrushFine,
  faPaintBrushAlt,
  faPaintBrushFine,
  faPaintbrushAlt,
  faGlasses,
  faHoodCloak,
  faSquareQuote,
  faUpLeft,
  faBringFront,
  faChessBoard,
  faBurgerCheese,
  faCheeseburger,
  faBuildingCircleCheck,
  faRepeat1,
  faArrowDownToLine,
  faArrowToBottom,
  faGrid5,
  faSwapArrows,
  faRightLongToLine,
  faPersonChalkboard,
  faMarsStrokeRight,
  faMarsStrokeH,
  faHandBackFist,
  faHandRock,
  faGridRound5,
  faTally,
  faTally5,
  faSquareCaretUp,
  faCaretSquareUp,
  faCloudShowersWater,
  faChartBar,
  faBarChart,
  faHandsBubbles,
  faHandsWash,
  faLessThanEqual,
  faTrain,
  faUpFromDottedLine,
  faEyeLowVision,
  faLowVision,
  faTrafficLightGo,
  faFaceExhaling,
  faSensorFire,
  faUserUnlock,
  faHexagonDivide,
  fa00,
  faCrow,
  faCassetteBetamax,
  faBetamax,
  faSailboat,
  faWindowRestore,
  faNfcMagnifyingGlass,
  faFileBinary,
  faCircleV,
  faSquarePlus,
  faPlusSquare,
  faBowlScoops,
  faMistletoe,
  faCustard,
  faLacrosseStick,
  faHockeyMask,
  faSunrise,
  faSubtitles,
  faPanelEws,
  faToriiGate,
  faCloudExclamation,
  faMessageLines,
  faCommentAltLines,
  faFrog,
  faBucket,
  faFloppyDiskPen,
  faImage,
  faWindowFrame,
  faMicrophone,
  faCow,
  faFileZip,
  faSquareRing,
  faDownFromLine,
  faArrowAltFromTop,
  faCaretUp,
  faShieldXmark,
  faShieldTimes,
  faScrewdriver,
  faCircleSortDown,
  faSortCircleDown,
  faFolderClosed,
  faHouseTsunami,
  faSquareNfi,
  faForklift,
  faArrowUpFromGroundWater,
  faBracketSquareRight,
  faMartiniGlass,
  faGlassMartiniAlt,
  faSquareBinary,
  faRotateLeft,
  faRotateBack,
  faRotateBackward,
  faUndoAlt,
  faTableColumns,
  faColumns,
  faSquareA,
  faTick,
  faLemon,
  faHeadSideMask,
  faHandshake,
  faGem,
  faDolly,
  faDollyBox,
  faSmoking,
  faMinimize,
  faCompressArrowsAlt,
  faRefrigerator,
  faMonument,
  faOctagonXmark,
  faTimesOctagon,
  faXmarkOctagon,
  faAlignSlash,
  faSnowplow,
  faAnglesRight,
  faAngleDoubleRight,
  faTruckRampCouch,
  faTruckCouch,
  faCannabis,
  faCirclePlay,
  faPlayCircle,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faLocationArrowUp,
  faTablets,
  fa360Degrees,
  faEthernet,
  faEuroSign,
  faEur,
  faEuro,
  faChair,
  faCircleCheck,
  faCheckCircle,
  faSquareDashedCirclePlus,
  faHandHoldingCircleDollar,
  faMoneySimpleFromBracket,
  faBat,
  faCircleStop,
  faStopCircle,
  faHeadSideHeadphones,
  faPhoneRotary,
  faArrowUpToBracket,
  faCompassDrafting,
  faDraftingCompass,
  faPlateWheat,
  faCalendarCircleMinus,
  faChopsticks,
  faCarWrench,
  faCarMechanic,
  faIcicles,
  faPersonShelter,
  faNeuter,
  faIdBadge,
  faKazoo,
  faMarker,
  faBinBottles,
  faFaceLaughBeam,
  faLaughBeam,
  faSquareArrowDownLeft,
  faBatteryBolt,
  faTreeLarge,
  faHelicopterSymbol,
  faAperture,
  faUniversalAccess,
  faGearComplex,
  faFileMagnifyingGlass,
  faFileSearch,
  faUpRight,
  faCircleChevronUp,
  faChevronCircleUp,
  faUserPolice,
  faLariSign,
  faVolcano,
  faTeddyBear,
  faStocking,
  faPersonWalkingDashedLineArrowRight,
  faImageSlash,
  faMaskSnorkel,
  faSmoke,
  faSterlingSign,
  faGbp,
  faPoundSign,
  faBatteryExclamation,
  faViruses,
  faSquarePersonConfined,
  faUserTie,
  faUpToBracket,
  faArrowDownLong,
  faLongArrowDown,
  faTentArrowDownToLine,
  faCertificate,
  faCrystalBall,
  faReplyAll,
  faMailReplyAll,
  faSuitcase,
  faPersonSkating,
  faSkating,
  faStarShooting,
  faBinaryLock,
  faFilterCircleDollar,
  faFunnelDollar,
  faCameraRetro,
  faCircleArrowDown,
  faArrowCircleDown,
  faCommentPen,
  faCommentEdit,
  faFileImport,
  faArrowRightToFile,
  faBanjo,
  faSquareArrowUpRight,
  faExternalLinkSquare,
  faLightEmergencyOn,
  faKerning,
  faBoxOpen,
  faSquareF,
  faScroll,
  faSpa,
  faArrowLeftFromLine,
  faArrowFromRight,
  faStrawberry,
  faLocationPinLock,
  faPause,
  faClockEightThirty,
  faPlaneEngines,
  faPlaneAlt,
  faHillAvalanche,
  faTemperatureEmpty,
  faTemperature0,
  faThermometer0,
  faThermometerEmpty,
  faBomb,
  faGaugeLow,
  faTachometerAltSlow,
  faRegistered,
  faTrashCanPlus,
  faAddressCard,
  faContactCard,
  faVcard,
  faChartFft,
  faScaleUnbalancedFlip,
  faBalanceScaleRight,
  faGlobeSnow,
  faSubscript,
  faDiamondTurnRight,
  faDirections,
  faIntegral,
  faBurst,
  faHouseLaptop,
  faLaptopHouse,
  faFaceTired,
  faTired,
  faMoneyBills,
  faBlindsRaised,
  faSmog,
  faUfoBeam,
  faHydra,
  faCircleCaretUp,
  faCaretCircleUp,
  faUserVneckHairLong,
  faSquareALock,
  faCrutch,
  faGasPumpSlash,
  faFontAwesome,
  faFontAwesomeFlag,
  faFontAwesomeLogoFull,
  faCloudArrowUp,
  faCloudUpload,
  faCloudUploadAlt,
  faPalette,
  faTransporter4,
  faChartMixedUpCircleCurrency,
  faObjectsAlignRight,
  faArrowsTurnRight,
  faVest,
  faPig,
  faInboxFull,
  faCircleEnvelope,
  faEnvelopeCircle,
  faTrianglePersonDigging,
  faConstruction,
  faFerry,
  faBullseyeArrow,
  faArrowsDownToPeople,
  faSeedling,
  faSprout,
  faClockSeven,
  faLeftRight,
  faArrowsAltH,
  faBoxesPacking,
  faCircleArrowLeft,
  faArrowCircleLeft,
  faFlashlight,
  faFileJpg,
  faGroupArrowsRotate,
  faBowlFood,
  faSquare9,
  faCandyCane,
  faArrowDownWideShort,
  faSortAmountAsc,
  faSortAmountDown,
  faSquareDollar,
  faDollarSquare,
  faUsdSquare,
  faPhoneArrowRight,
  faHandHoldingSeedling,
  faMessageCheck,
  faCommentAltCheck,
  faCloudBolt,
  faThunderstorm,
  faChartLineUpDown,
  faTextSlash,
  faRemoveFormat,
  faWatch,
  faCircleDownLeft,
  faText,
  faProjector,
  faFaceSmileWink,
  faSmileWink,
  faTombstoneBlank,
  faTombstoneAlt,
  faChessKingPiece,
  faChessKingAlt,
  faCircle6,
  faWavesSine,
  faLeft,
  faArrowAltLeft,
  faFileWord,
  faFilePowerpoint,
  faSquareDown,
  faArrowAltSquareDown,
  faObjectsAlignCenterVertical,
  faArrowsLeftRight,
  faArrowsH,
  faHouseLock,
  faCloudArrowDown,
  faCloudDownload,
  faCloudDownloadAlt,
  faWreath,
  faChildren,
  faMeterDroplet,
  faChalkboard,
  faBlackboard,
  faUserLargeSlash,
  faUserAltSlash,
  faSignalStrong,
  faSignal4,
  faLollipop,
  faLollypop,
  faListTree,
  faEnvelopeOpen,
  faDrawCircle,
  faCatSpace,
  faHandshakeSimpleSlash,
  faHandshakeAltSlash,
  faRabbitRunning,
  faRabbitFast,
  faMemoPad,
  faMattressPillow,
  faAlarmPlus,
  faAlicorn,
  faCommentQuestion,
  faGingerbreadMan,
  faGuaraniSign,
  faBurgerFries,
  faMugTea,
  faBorderTop,
  faArrowsRotate,
  faRefresh,
  faSync,
  faCircleBookOpen,
  faBookCircle,
  faArrowsToDottedLine,
  faFireExtinguisher,
  faMagnifyingGlassArrowsRotate,
  faGarageOpen,
  faShelvesEmpty,
  faCruzeiroSign,
  faWatchApple,
  faWatchCalculator,
  faListDropdown,
  faCabinetFiling,
  faBurgerSoda,
  faSquareArrowUp,
  faArrowSquareUp,
  faGreaterThanEqual,
  faPalletBox,
  faFaceConfounded,
  faShieldHalved,
  faShieldAlt,
  faTruckPlow,
  faBookAtlas,
  faAtlas,
  faVirus,
  faGridRound2,
  faCommentMiddleTop,
  faWave,
  faEnvelopeCircleCheck,
  faLayerGroup,
  faRestroomSimple,
  faArrowsToDot,
  faBorderOuter,
  faHashtagLock,
  faClockTwoThirty,
  faArchway,
  faHeartCircleCheck,
  faHouseChimneyCrack,
  faHouseDamage,
  faFileZipper,
  faFileArchive,
  faTicketPerforated,
  faHeartHalf,
  faCommentCheck,
  faSquare,
  faMemo,
  faMartiniGlassEmpty,
  faGlassMartini,
  faCouch,
  faCediSign,
  faItalic,
  faGlassCitrus,
  faCalendarLinesPen,
  faTableCellsColumnLock,
  faChurch,
  faPersonSnowmobiling,
  faSnowmobile,
  faFaceHushed,
  faCommentsDollar,
  faTicketsSimple,
  faPickaxe,
  faLinkSimpleSlash,
  faDemocrat,
  faFaceConfused,
  faPinball,
  faZ,
  faPersonSkiing,
  faSkiing,
  faDeer,
  faInputPipe,
  faRoadLock,
  faA,
  faBookmarkSlash,
  faTemperatureArrowDown,
  faTemperatureDown,
  faMace,
  faFeatherPointed,
  faFeatherAlt,
  faSausage,
  faTrashCanClock,
  faP,
  faBroomWide,
  faSnowflake,
  faStomach,
  faNewspaper,
  faRectangleAd,
  faAd,
  faGuitarElectric,
  faArrowTurnDownRight,
  faMoonCloud,
  faBreadSliceButter,
  faCircleArrowRight,
  faArrowCircleRight,
  faUserGroupCrown,
  faUsersCrown,
  faCircleI,
  faToiletPaperCheck,
  faFilterCircleXmark,
  faLocust,
  faSort,
  faUnsorted,
  faListOl,
  faList12,
  faListNumeric,
  faChartWaterfall,
  faSparkle,
  faFaceParty,
  faKidneys,
  faWifiExclamation,
  faChartNetwork,
  faPersonDressBurst,
  faDiceD4,
  faMoneyCheckDollar,
  faMoneyCheckAlt,
  faVectorSquare,
  faBreadSlice,
  faLanguage,
  faWheatAwnSlash,
  faFaceKissWinkHeart,
  faKissWinkHeart,
  faDagger,
  faPodium,
  faDiamonds4,
  faMemoCircleCheck,
  faRouteHighway,
  faDownToLine,
  faArrowAltToBottom,
  faFilter,
  faSquareG,
  faCirclePhone,
  faPhoneCircle,
  faClipboardPrescription,
  faUserNurseHair,
  faQuestion,
  faFileSignature,
  faToggleLargeOn,
  faUpDownLeftRight,
  faArrowsAlt,
  faDryerHeat,
  faDryerAlt,
  faHouseChimneyUser,
  faHandHoldingHeart,
  faArrowUpSmallBig,
  faSortSizeUpAlt,
  faTrainTrack,
  faPuzzlePiece,
  faMoneyCheck,
  faStarHalfStroke,
  faStarHalfAlt,
  faFileExclamation,
  faCode,
  faWhiskeyGlass,
  faGlassWhiskey,
  faMoonStars,
  faBuildingCircleExclamation,
  faClothesHanger,
  faMobileNotch,
  faMobileIphone,
  faMagnifyingGlassChart,
  faArrowUpRightFromSquare,
  faExternalLink,
  faCubesStacked,
  faImagesUser,
  faWonSign,
  faKrw,
  faWon,
  faImagePolaroidUser,
  faVirusCovid,
  faSquareEllipsis,
  faPie,
  faChessKnightPiece,
  faChessKnightAlt,
  faAustralSign,
  faCloudPlus,
  faF,
  faLeaf,
  faBedBunk,
  faRoad,
  faTaxi,
  faCab,
  faPersonCirclePlus,
  faChartPie,
  faPieChart,
  faBoltLightning,
  faClockEight,
  faSackXmark,
  faFileXls,
  faFileExcel,
  faFileContract,
  faFishFins,
  faCircleQ,
  faBuildingFlag,
  faFaceGrinBeam,
  faGrinBeam,
  faObjectUngroup,
  faFaceDisguise,
  faCircleArrowDownRight,
  faAlien8bit,
  faAlienMonster,
  faHandPointRibbon,
  faPoop,
  faObjectExclude,
  faTelescope,
  faLocationPin,
  faMapMarker,
  faSquareList,
  faKaaba,
  faToiletPaper,
  faHelmetSafety,
  faHardHat,
  faHatHard,
  faCommentCode,
  faSimCards,
  faStarship,
  faEject,
  faCircleRight,
  faArrowAltCircleRight,
  faPlaneCircleCheck,
  faSeal,
  faUserCowboy,
  faHexagonVerticalNft,
  faFaceRollingEyes,
  faMehRollingEyes,
  faBreadLoaf,
  faRingsWedding,
  faObjectGroup,
  faFrenchFries,
  faChartLine,
  faLineChart,
  faCalendarArrowDown,
  faCalendarDownload,
  faSendBack,
  faMaskVentilator,
  faTickets,
  faSignatureLock,
  faArrowRight,
  faSignsPost,
  faMapSigns,
  faOctagonPlus,
  faPlusOctagon,
  faCashRegister,
  faPersonCircleQuestion,
  faMelonSlice,
  faSpaceStationMoon,
  faMessageSmile,
  faCommentAltSmile,
  faCupStraw,
  faLeftFromLine,
  faArrowAltFromRight,
  faH,
  faBasketShoppingSimple,
  faShoppingBasketAlt,
  faHandsHoldingHeart,
  faHandsHeart,
  faClockNine,
  faHammerBrush,
  faTarp,
  faFaceSleepy,
  faHandHorns,
  faScrewdriverWrench,
  faTools,
  faArrowsToEye,
  faCircleThreeQuarters,
  faTrophyStar,
  faTrophyAlt,
  faPlugCircleBolt,
  faFaceThermometer,
  faGridRound4,
  faSignPostsWrench,
  faShirtRunning,
  faBookCircleArrowUp,
  faFaceNauseated,
  faHeart,
  faFileChartPie,
  faMarsAndVenus,
  faHouseUser,
  faHomeUser,
  faCircleArrowDownLeft,
  faDumpsterFire,
  faHexagonMinus,
  faMinusHexagon,
  faLeftToLine,
  faArrowAltToLeft,
  faHouseCrack,
  faPawSimple,
  faPawAlt,
  faArrowLeftLongToLine,
  faBracketsRound,
  faParentheses,
  faMartiniGlassCitrus,
  faCocktail,
  faUserShakespeare,
  faArrowRightToArc,
  faFaceSurprise,
  faSurprise,
  faBottleWater,
  faCirclePause,
  faPauseCircle,
  faGaugeCirclePlus,
  faFolders,
  faAngel,
  faValueAbsolute,
  faRabbit,
  faToiletPaperSlash,
  faCircleEuro,
  faAppleWhole,
  faAppleAlt,
  faKitchenSet,
  faDiamondHalf,
  faLockKeyhole,
  faLockAlt,
  faR,
  faTemperatureQuarter,
  faTemperature1,
  faThermometer1,
  faThermometerQuarter,
  faSquareInfo,
  faInfoSquare,
  faWifiSlash,
  faToiletPaperXmark,
  faHandsHoldingDollar,
  faHandsUsd,
  faCube,
  faArrowDownTriangleSquare,
  faSortShapesDown,
  faBitcoinSign,
  faShutters,
  faShieldDog,
  faSolarPanel,
  faLockOpen,
  faTableTree,
  faHouseChimneyHeart,
  faTally3,
  faElevator,
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faHouseFloodWaterCircleArrowRight,
  faSquarePollHorizontal,
  faPollH,
  faCircle,
  faLeftToBracket,
  faCartCircleExclamation,
  faSword,
  faBackwardFast,
  faFastBackward,
  faRecycle,
  faUserAstronaut,
  faInterrobang,
  faPlaneSlash,
  faCircleDashed,
  faTrademark,
  faBasketball,
  faBasketballBall,
  faForkKnife,
  faUtensilsAlt,
  faSatelliteDish,
  faBadgeCheck,
  faCircleUp,
  faArrowAltCircleUp,
  faSlider,
  faMobileScreenButton,
  faMobileAlt,
  faClockOneThirty,
  faInboxOut,
  faInboxArrowUp,
  faCloudSlash,
  faVolumeHigh,
  faVolumeUp,
  faUsersRays,
  faWallet,
  faOctagonCheck,
  faFlatbreadStuffed,
  faClipboardCheck,
  faCartCirclePlus,
  faTruckClock,
  faShippingTimed,
  faPool8Ball,
  faFileAudio,
  faTurnDownLeft,
  faLockHashtag,
  faChartRadar,
  faStaff,
  faBurger,
  faHamburger,
  faUtilityPole,
  faTransporter6,
  faArrowTurnLeft,
  faWrench,
  faBugs,
  faVectorPolygon,
  faDiagramNested,
  faRupeeSign,
  faRupee,
  faFileImage,
  faCircleQuestion,
  faQuestionCircle,
  faTicketsPerforated,
  faImageUser,
  faBuoy,
  faPlaneDeparture,
  faHandshakeSlash,
  faBookBookmark,
  faBorderCenterH,
  faCanFood,
  faTypewriter,
  faArrowRightFromArc,
  faCircleK,
  faFaceHandOverMouth,
  faPopcorn,
  faHouseWater,
  faHouseFlood,
  faObjectSubtract,
  faCodeBranch,
  faWarehouseFull,
  faWarehouseAlt,
  faHatCowboy,
  faBridge,
  faPhoneFlip,
  faPhoneAlt,
  faArrowDownFromDottedLine,
  faFileDoc,
  faSquareQuarters,
  faTruckFront,
  faCat,
  faTrashXmark,
  faCircleCaretLeft,
  faCaretCircleLeft,
  faFiles,
  faAnchorCircleExclamation,
  faFaceClouds,
  faUserCrown,
  faBasketShoppingPlus,
  faTruckField,
  faRoute,
  faCartCircleCheck,
  faClipboardQuestion,
  faPanorama,
  faCommentMedical,
  faTeethOpen,
  faUserTieHairLong,
  faFileCircleMinus,
  faHeadSideMedical,
  faArrowTurnRight,
  faTags,
  faWineGlass,
  faForwardFast,
  faFastForward,
  faFaceMehBlank,
  faMehBlank,
  faUserRobot,
  faSquareParking,
  faParking,
  faCardDiamond,
  faFaceZipper,
  faFaceRaisedEyebrow,
  faHouseSignal,
  faSquareChevronUp,
  faChevronSquareUp,
  faNfcSymbol,
  faBarsProgress,
  faTasksAlt,
  faFaucetDrip,
  faArrowsToLine,
  faDolphin,
  faArrowUpRight,
  faCircleR,
  faCartFlatbed,
  faDollyFlatbed,
  faBanSmoking,
  faSmokingBan,
  faCircleSortUp,
  faSortCircleUp,
  faTerminal,
  faMobileButton,
  faHouseMedicalFlag,
  faBasketShopping,
  faShoppingBasket,
  faTape,
  faChestnut,
  faBusSimple,
  faBusAlt,
  faEye,
  faFaceSadCry,
  faSadCry,
  faHeat,
  faTicketAirline,
  faTicketPerforatedPlane,
  faTicketPlane,
  faBootHeeled,
  faArrowsMinimize,
  faCompressArrows,
  faAudioDescription,
  faPersonMilitaryToPerson,
  faFileShield,
  faHexagon,
  faManhole,
  faUserSlash,
  faPen,
  faTowerObservation,
  faFloppyDisks,
  faToiletPaperBlankUnder,
  faToiletPaperReverseAlt,
  faFileCode,
  faSignal,
  faSignal5,
  faSignalPerfect,
  faPump,
  faBus,
  faHeartCircleXmark,
  faArrowUpLeftFromCircle,
  faHouseChimney,
  faHomeLg,
  faWindowMaximize,
  faDryer,
  faFaceFrown,
  faFrown,
  faChessBishopPiece,
  faChessBishopAlt,
  faShirtTankTop,
  faDiploma,
  faScrollRibbon,
  faScreencast,
  faWalker,
  faPrescription,
  faShop,
  faStoreAlt,
  faFloppyDisk,
  faSave,
  faVihara,
  faFaceKissClosedEyes,
  faScaleUnbalanced,
  faBalanceScaleLeft,
  faFileUser,
  faUserPoliceTie,
  faFaceTongueMoney,
  faTennisBall,
  faSquareL,
  faSortUp,
  faSortAsc,
  faCalendarArrowUp,
  faCalendarUpload,
  faCommentDots,
  faCommenting,
  faPlantWilt,
  faScarf,
  faAlbumCirclePlus,
  faUserNurseHairLong,
  faDiamond,
  faSquareLeft,
  faArrowAltSquareLeft,
  faFaceGrinSquint,
  faGrinSquint,
  faCircleEllipsisVertical,
  faHandHoldingDollar,
  faHandHoldingUsd,
  faGridDividers,
  faChartDiagram,
  faBacterium,
  faHandPointer,
  faDrumSteelpan,
  faHandScissors,
  faHandsPraying,
  faPrayingHands,
  faFacePensive,
  faUserMusic,
  faArrowRotateRight,
  faArrowRightRotate,
  faArrowRotateForward,
  faRedo,
  faMessagesDollar,
  faCommentsAltDollar,
  faSensorOn,
  faBalloon,
  faWebAwesome,
  faBiohazard,
  faChessQueenPiece,
  faChessQueenAlt,
  faLocationCrosshairs,
  faLocation,
  faMarsDouble,
  faLeftFromBracket,
  faHousePersonLeave,
  faHouseLeave,
  faHousePersonDepart,
  faRulerTriangle,
  faCardClub,
  faChildDress,
  faUsersBetweenLines,
  faLungsVirus,
  faSpinnerThird,
  faFaceGrinTears,
  faGrinTears,
  faPhone,
  faComputerMouseScrollwheel,
  faMouseAlt,
  faCalendarXmark,
  faCalendarTimes,
  faChildReaching,
  faTableLayout,
  faNarwhal,
  faRampLoading,
  faCalendarCirclePlus,
  faToothbrush,
  faBorderInner,
  faPawClaws,
  faKiwiFruit,
  faTrafficLightSlow,
  faRectangleCode,
  faHeadSideVirus,
  faKeyboardBrightness,
  faBooksMedical,
  faLightbulbSlash,
  faHouseBlank,
  faHomeBlank,
  faSquare5,
  faSquareHeart,
  faHeartSquare,
  faPuzzle,
  faUserGear,
  faUserCog,
  faPipeCircleCheck,
  faArrowUp19,
  faSortNumericUp,
  faOctagonExclamation,
  faDialLow,
  faDoorClosed,
  faLaptopMobile,
  faPhoneLaptop,
  faConveyorBeltBoxes,
  faConveyorBeltAlt,
  faShieldVirus,
  faStarfighterTwinIonEngineAdvanced,
  faStarfighterAltAdvanced,
  faDiceSix,
  faStarfighterTwinIonEngine,
  faStarfighterAlt,
  faRocketLaunch,
  faMosquitoNet,
  faFileFragment,
  faVentDamper,
  faBridgeWater,
  faBanBug,
  faDebug,
  faPersonBooth,
  faTextWidth,
  faGarageCar,
  faSquareKanban,
  faHatWizard,
  faChartKanban,
  faPenFancy,
  faCoffeePot,
  faMouseField,
  faPersonDigging,
  faDigging,
  faShowerDown,
  faShowerAlt,
  faBoxCircleCheck,
  faBrightness,
  faCarSideBolt,
  faFileXml,
  faOrnament,
  faPhoneArrowDownLeft,
  faPhoneArrowDown,
  faPhoneIncoming,
  faCloudWord,
  faHandFingersCrossed,
  faTrash,
  faGaugeSimple,
  faGaugeSimpleMed,
  faTachometerAverage,
  faArrowDownSmallBig,
  faSortSizeDownAlt,
  faBookMedical,
  faFaceMelting,
  faPoo,
  faPenClipSlash,
  faPenAltSlash,
  faQuoteRight,
  faQuoteRightAlt,
  faScrollOld,
  faGuitars,
  faPhoneXmark,
  faHose,
  faClockSix,
  faShirt,
  faTShirt,
  faTshirt,
  faBillboard,
  faSquareR,
  faCubes,
  faEnvelopeOpenDollar,
  faDivide,
  faSunCloud,
  faLampFloor,
  faSquare7,
  faTengeSign,
  faTenge,
  faHeadphones,
  faHandsHolding,
  faCampfire,
  faCircleAmpersand,
  faSnowflakes,
  faHandsClapping,
  faRepublican,
  faLeafMaple,
  faArrowLeft,
  faPersonCircleXmark,
  faRuler,
  faArrowLeftFromBracket,
  faCupStrawSwoosh,
  faTemperatureSun,
  faTemperatureHot,
  faAlignLeft,
  faDiceD6,
  faRestroom,
  faHighDefinition,
  faRectangleHd,
  faJ,
  faGalaxy,
  faUsersViewfinder,
  faFileVideo,
  faCherries,
  faUpRightFromSquare,
  faExternalLinkAlt,
  faCircleSort,
  faSortCircle,
  faTableCells,
  faTh,
  faBagShoppingMinus,
  faFilePdf,
  faSiren,
  faArrowUpToDottedLine,
  faImageLandscape,
  faLandscape,
  faTankWater,
  faCurlingStone,
  faCurling,
  faGamepadModern,
  faGamepadAlt,
  faMessagesQuestion,
  faBookBible,
  faBible,
  faO,
  faSuitcaseMedical,
  faMedkit,
  faBriefcaseArrowRight,
  faExpandWide,
  faClockElevenThirty,
  faRv,
  faUserSecret,
  faOtter,
  faDreidel,
  faPersonDress,
  faFemale,
  faCommentDollar,
  faBusinessTime,
  faBriefcaseClock,
  faFlowerTulip,
  faPeoplePantsSimple,
  faCloudDrizzle,
  faTableCellsLarge,
  faThLarge,
  faBookTanakh,
  faTanakh,
  faSolarSystem,
  faSealQuestion,
  faPhoneVolume,
  faVolumeControlPhone,
  faDiscDrive,
  faHatCowboySide,
  faTableRows,
  faRows,
  faLocationExclamation,
  faMapMarkerExclamation,
  faFaceFearful,
  faClipboardUser,
  faBusSchool,
  faFilmSlash,
  faSquareArrowDownRight,
  faBookSparkles,
  faBookSpells,
  faWashingMachine,
  faWasher,
  faChild,
  faLiraSign,
  faUserVisor,
  faFilePlusMinus,
  faChessClockFlip,
  faChessClockAlt,
  faSatellite,
  faTruckFire,
  faPlaneLock,
  faSteeringWheel,
  faTag,
  faStretcher,
  faBookSection,
  faBookLaw,
  faInboxes,
  faCoffeeBean,
  faCircleYen,
  faBracketsCurly,
  faEllipsisStrokeVertical,
  faEllipsisVAlt,
  faComment,
  faSquare1,
  faCakeCandles,
  faBirthdayCake,
  faCake,
  faHeadSide,
  faTruckLadder,
  faEnvelope,
  faDollyEmpty,
  faFaceTissue,
  faAnglesUp,
  faAngleDoubleUp,
  faBinRecycle,
  faPaperclip,
  faChartLineDown,
  faArrowRightToCity,
  faLockA,
  faRibbon,
  faLungs,
  faPersonPinball,
  faArrowUp91,
  faSortNumericUpAlt,
  faAppleCore,
  faCircleY,
  faH6,
  faLitecoinSign,
  faBottleBaby,
  faCircleSmall,
  faBorderNone,
  faArrowTurnDownLeft,
  faCircleWifiCircleWifi,
  faCircleWifiGroup,
  faCircleNodes,
  faParachuteBox,
  faReflectHorizontal,
  faMessageMedical,
  faCommentAltMedical,
  faRugbyBall,
  faCommentMusic,
  faIndent,
  faTreeDeciduous,
  faTreeAlt,
  faPuzzlePieceSimple,
  faPuzzlePieceAlt,
  faTruckFieldUn,
  faNfcTrash,
  faHourglass,
  faHourglassEmpty,
  faMountain,
  faFileXmark,
  faFileTimes,
  faHouseHeart,
  faHomeHeart,
  faHouseChimneyBlank,
  faMeterBolt,
  faUserDoctor,
  faUserMd,
  faSlashBack,
  faCircleInfo,
  faInfoCircle,
  faFishingRod,
  faHammerCrash,
  faMessageHeart,
  faCloudMeatball,
  faCameraPolaroid,
  faCamera,
  faCameraAlt,
  faSquareVirus,
  faCartArrowUp,
  faMeteor,
  faCarOn,
  faSleigh,
  faArrowDown19,
  faSortNumericAsc,
  faSortNumericDown,
  faBuoyMooring,
  faSquare4,
  faHandHoldingDroplet,
  faHandHoldingWater,
  faFileEps,
  faTricycleAdult,
  faWaveform,
  faWater,
  faStarSharpHalfStroke,
  faStarSharpHalfAlt,
  faNfcSignal,
  faPlaneProp,
  faCalendarCheck,
  faClockDesk,
  faCalendarClock,
  faCalendarTime,
  faBraille,
  faPrescriptionBottleMedical,
  faPrescriptionBottleAlt,
  faPlateUtensils,
  faFamilyPants,
  faHoseReel,
  faHouseWindow,
  faLandmark,
  faTruck,
  faMusicMagnifyingGlass,
  faCrosshairs,
  faCloudRainbow,
  faPersonCane,
  faAlien,
  faTent,
  faLaptopBinary,
  faVestPatches,
  faPeopleDressSimple,
  faCheckDouble,
  faArrowDownAZ,
  faSortAlphaAsc,
  faSortAlphaDown,
  faBowlingBallPin,
  faBellSchoolSlash,
  faPlusLarge,
  faMoneyBillWheat,
  faCameraViewfinder,
  faScreenshot,
  faMessageMusic,
  faCommentAltMusic,
  faCarBuilding,
  faBorderBottomRight,
  faBorderStyleAlt,
  faOctagon,
  faCommentArrowUpRight,
  faOctagonDivide,
  faCookie,
  faArrowRotateLeft,
  faArrowLeftRotate,
  faArrowRotateBack,
  faArrowRotateBackward,
  faUndo,
  faTvMusic,
  faHardDrive,
  faHdd,
  faReel,
  faFaceGrinSquintTears,
  faGrinSquintTears,
  faDumbbell,
  faRectangleList,
  faListAlt,
  faTarpDroplet,
  faAlarmExclamation,
  faHouseMedicalCircleCheck,
  faTrafficCone,
  faGrate,
  faArrowDownRight,
  faPersonSkiingNordic,
  faSkiingNordic,
  faCalendarPlus,
  faPersonFromPortal,
  faPortalExit,
  faPlaneArrival,
  faCowbellCirclePlus,
  faCowbellMore,
  faCircleLeft,
  faArrowAltCircleLeft,
  faDistributeSpacingVertical,
  faSignalBarsFair,
  faSignalAlt2,
  faSportsball,
  faGameConsoleHandheldCrank,
  faTrainSubway,
  faSubway,
  faChartGantt,
  faFaceSmileUpsideDown,
  faBallPile,
  faBadgeDollar,
  faMoneyBillsSimple,
  faMoneyBillsAlt,
  faListTimeline,
  faIndianRupeeSign,
  faIndianRupee,
  faInr,
  faCropSimple,
  faCropAlt,
  faMoneyBill1,
  faMoneyBillAlt,
  faLeftLong,
  faLongArrowAltLeft,
  faKeyboardDown,
  faCircleUpRight,
  faCloudBoltMoon,
  faThunderstormMoon,
  faTurnLeftUp,
  faDna,
  faVirusSlash,
  faBracketRoundRight,
  faCircleSterling,
  faCircle5,
  faMinus,
  faSubtract,
  faFireFlame,
  faFlame,
  faRightToLine,
  faArrowAltToRight,
  faGif,
  faChess,
  faTrashSlash,
  faArrowLeftLong,
  faLongArrowLeft,
  faPlugCircleCheck,
  faFontCase,
  faStreetView,
  faArrowDownLeft,
  faFrancSign,
  faFlaskRoundPoison,
  faFlaskPoison,
  faVolumeOff,
  faBookCircleArrowRight,
  faChartUser,
  faUserChart,
  faHandsAslInterpreting,
  faAmericanSignLanguageInterpreting,
  faAslInterpreting,
  faHandsAmericanSignLanguageInterpreting,
  faPresentationScreen,
  faPresentation,
  faCircleBolt,
  faFaceSmileHalo,
  faCartCircleArrowDown,
  faHousePersonReturn,
  faHousePersonArrive,
  faHouseReturn,
  faMessageXmark,
  faCommentAltTimes,
  faMessageTimes,
  faFileCertificate,
  faFileAward,
  faUserDoctorHairLong,
  faCameraSecurity,
  faCameraHome,
  faGear,
  faCog,
  faDropletSlash,
  faTintSlash,
  faBookHeart,
  faMosque,
  faDuck,
  faMosquito,
  faStarOfDavid,
  faFlagSwallowtail,
  faFlagAlt,
  faPersonMilitaryRifle,
  faCarGarage,
  faCartShopping,
  faShoppingCart,
  faBookFont,
  faShieldPlus,
  faVials,
  faEyeDropperFull,
  faDistributeSpacingHorizontal,
  faTabletRugged,
  faTemperatureSnow,
  faTemperatureFrigid,
  faMoped,
  faFaceSmilePlus,
  faSmilePlus,
  faRadioTuner,
  faRadioAlt,
  faFaceSwear,
  faWaterArrowDown,
  faWaterLower,
  faScannerTouchscreen,
  faCircle7,
  faPlugCirclePlus,
  faPersonSkiJumping,
  faSkiJump,
  faPlaceOfWorship,
  faWaterArrowUp,
  faWaterRise,
  faWaveformLines,
  faWaveformPath,
  faSplit,
  faFilmCanister,
  faFilmCannister,
  faFolderXmark,
  faFolderTimes,
  faToiletPaperBlank,
  faToiletPaperAlt,
  faTabletScreen,
  faTabletAndroidAlt,
  faHexagonVerticalNftSlanted,
  faFolderMusic,
  faDisplayMedical,
  faDesktopMedical,
  faShareAll,
  faPeapod,
  faChessClock,
  faAxe,
  faSquareD,
  faGripVertical,
  faMobileSignalOut,
  faHexagonNodes,
  faArrowTurnUp,
  faLevelUp,
  faU,
  faArrowUpFromDottedLine,
  faSquareRootVariable,
  faSquareRootAlt,
  faLightSwitchOn,
  faArrowDownArrowUp,
  faSortAlt,
  faRaindrops,
  faDash,
  faMinusLarge,
  faClock,
  faClockFour,
  faInputNumeric,
  faTruckTow,
  faBackwardStep,
  faStepBackward,
  faPallet,
  faCarBolt,
  faArrowsMaximize,
  faExpandArrows,
  faFaucet,
  faCloudSleet,
  faLampStreet,
  faListRadio,
  faPenNibSlash,
  faBaseballBatBall,
  faSquareUpLeft,
  faOverline,
  faS,
  faTimeline,
  faKeyboard,
  faArrowsFromDottedLine,
  faUsbDrive,
  faBallot,
  faCaretDown,
  faLocationDotSlash,
  faMapMarkerAltSlash,
  faCards,
  faHouseChimneyMedical,
  faClinicMedical,
  faBoxingGlove,
  faGloveBoxing,
  faTemperatureThreeQuarters,
  faTemperature3,
  faThermometer3,
  faThermometerThreeQuarters,
  faBellSchool,
  faMobileScreen,
  faMobileAndroidAlt,
  faPlaneUp,
  faFolderHeart,
  faCircleLocationArrow,
  faLocationCircle,
  faFaceHeadBandage,
  faSushiRoll,
  faMakiRoll,
  faMakizushi,
  faCarBump,
  faPiggyBank,
  faRacquet,
  faCarMirrors,
  faIndustryWindows,
  faIndustryAlt,
  faBoltAuto,
  faBatteryHalf,
  faBattery3,
  faFluxCapacitor,
  faMountainCity,
  faCoins,
  faHoneyPot,
  faOlive,
  faKhanda,
  faFilterList,
  faOutlet,
  faSliders,
  faSlidersH,
  faCauldron,
  faPeople,
  faFolderTree,
  faNetworkWired,
  faCroissant,
  faMapPin,
  faHamsa,
  faCentSign,
  faSwordsLaser,
  faFlask,
  faPersonPregnant,
  faSquareU,
  faWandSparkles,
  faRouter,
  faEllipsisVertical,
  faEllipsisV,
  faSwordLaserAlt,
  faTicket,
  faPowerOff,
  faCoin,
  faLaptopSlash,
  faRightLong,
  faLongArrowAltRight,
  faCircleB,
  faPersonDressSimple,
  faPipeCollar,
  faLightsHoliday,
  faCitrus,
  faFlagUsa,
  faLaptopFile,
  faTty,
  faTeletype,
  faChartTreeMap,
  faDiagramNext,
  faPersonRifle,
  faClockFiveThirty,
  faPipeValve,
  faLightbulbMessage,
  faArrowUpFromArc,
  faFaceSpiralEyes,
  faCompressWide,
  faCirclePhoneHangup,
  faPhoneCircleDown,
  faGearComplexCode,
  faHouseMedicalCircleExclamation,
  faBadminton,
  faClosedCaptioning,
  faPersonHiking,
  faHiking,
  faRightFromLine,
  faArrowAltFromLeft,
  faVenusDouble,
  faImages,
  faCalculator,
  faShuttlecock,
  faUserHair,
  faEyeEvil,
  faPeoplePulling,
  faN,
  faSwap,
  faGarage,
  faCableCar,
  faTram,
  faShovelSnow,
  faCloudRain,
  faFaceLying,
  faSprinkler,
  faBuildingCircleXmark,
  faPersonSledding,
  faSledding,
  faGameConsoleHandheld,
  faShip,
  faClockSixThirty,
  faBatterySlash,
  faTugrikSign,
  faArrowsDownToLine,
  faDownload,
  faAnglesUpDown,
  faShelves,
  faInventory,
  faCloudSnow,
  faFaceGrin,
  faGrin,
  faDeleteLeft,
  faBackspace,
  faOven,
  faCloudBinary,
  faEyeDropper,
  faEyeDropperEmpty,
  faEyedropper,
  faCommentCaptions,
  faCommentsQuestion,
  faScribble,
  faRotateExclamation,
  faFileCircleCheck,
  faGlass,
  faLoader,
  faForward,
  faUserPilot,
  faMobile,
  faMobileAndroid,
  faMobilePhone,
  faCodePullRequestClosed,
  faFaceMeh,
  faMeh,
  faAlignCenter,
  faBookSkull,
  faBookDead,
  faIdCard,
  faDriversLicense,
  faFaceDotted,
  faFaceWorried,
  faOutdent,
  faDedent,
  faCourtSport,
  faHeartCircleExclamation,
  faHouse,
  faHome,
  faHomeAlt,
  faHomeLgAlt,
  faVectorCircle,
  faCarCircleBolt,
  faCalendarWeek,
  faFlyingDisc,
  faLaptopMedical,
  faSquareDownRight,
  faB,
  faSeatAirline,
  faMoonOverSun,
  faEclipseAlt,
  faPipe,
  faFileMedical,
  faPotato,
  faDiceOne,
  faCircleA,
  faHelmetBattle,
  faButter,
  faBlanketFire,
  faKiwiBird,
  faCastle,
  faGolfClub,
  faArrowRightArrowLeft,
  faExchange,
  faRotateRight,
  faRedoAlt,
  faRotateForward,
  faUtensils,
  faCutlery,
  faArrowUpWideShort,
  faSortAmountUp,
  faChartPieSimpleCircleDollar,
  faBalloons,
  faMillSign,
  faBowlRice,
  faTimelineArrow,
  faSkull,
  faGameBoardSimple,
  faGameBoardAlt,
  faCircleVideo,
  faVideoCircle,
  faChartScatterBubble,
  faHouseTurret,
  faBanana,
  faHandHoldingSkull,
  faPeopleDress,
  faLoveseat,
  faCouchSmall,
  faTowerBroadcast,
  faBroadcastTower,
  faTruckPickup,
  faBlockQuote,
  faUpLong,
  faLongArrowAltUp,
  faStop,
  faCodeMerge,
  faMoneyCheckDollarPen,
  faMoneyCheckEditAlt,
  faUpFromLine,
  faArrowAltFromBottom,
  faUpload,
  faHurricane,
  faGridRound2Plus,
  faPeoplePants,
  faMound,
  faWindsock,
  faCircleHalf,
  faBrakeWarning,
  faToiletPortable,
  faCompactDisc,
  faFileArrowDown,
  faFileDownload,
  faSaxophoneFire,
  faSaxHot,
  faCameraWebSlash,
  faWebcamSlash,
  faFolderMedical,
  faFolderGear,
  faFolderCog,
  faHandWave,
  faArrowUpArrowDown,
  faSortUpDown,
  faCaravan,
  faShieldCat,
  faMessageSlash,
  faCommentAltSlash,
  faBolt,
  faZap,
  faTrashCanCheck,
  faGlassWater,
  faOilWell,
  faTableCellsColumnUnlock,
  faPersonSimple,
  faArrowTurnLeftUp,
  faVault,
  faMars,
  faToilet,
  faPlaneCircleXmark,
  faYenSign,
  faCny,
  faJpy,
  faRmb,
  faYen,
  faGearCode,
  faNotes,
  faRubleSign,
  faRouble,
  faRub,
  faRuble,
  faTrashUndo,
  faTrashArrowTurnLeft,
  faChampagneGlass,
  faGlassChampagne,
  faObjectsAlignCenterHorizontal,
  faSun,
  faTrashCanSlash,
  faTrashAltSlash,
  faScreenUsers,
  faUsersClass,
  faGuitar,
  faSquareArrowLeft,
  faArrowSquareLeft,
  faSquare8,
  faFaceSmileHearts,
  faBracketsSquare,
  faBrackets,
  faLaptopArrowDown,
  faHockeyStickPuck,
  faHouseTree,
  faSignalFair,
  faSignal2,
  faFaceLaughWink,
  faLaughWink,
  faCircleDollar,
  faDollarCircle,
  faUsdCircle,
  faHorseHead,
  faArrowsRepeat,
  faRepeatAlt,
  faBoreHole,
  faIndustry,
  faImagePolaroid,
  faWaveTriangle,
  faTurnLeftDown,
  faPersonRunningFast,
  faCircleDown,
  faArrowAltCircleDown,
  faGrill,
  faArrowsTurnToDots,
  faChartMixed,
  faAnalytics,
  faFlorinSign,
  faArrowDownShortWide,
  faSortAmountDesc,
  faSortAmountDownAlt,
  faLessThan,
  faDisplayCode,
  faDesktopCode,
  faFaceDrooling,
  faOilTemperature,
  faOilTemp,
  faSquareQuestion,
  faQuestionSquare,
  faAirConditioner,
  faAngleDown,
  faMountains,
  faOmega,
  faCarTunnel,
  faPersonDollyEmpty,
  faPanFood,
  faHeadSideCough,
  faGripLines,
  faThumbsDown,
  faUserLock,
  faArrowRightLong,
  faLongArrowRight,
  faTicketsAirline,
  faTicketsPerforatedPlane,
  faTicketsPlane,
  faTentDoublePeak,
  faAnchorCircleXmark,
  faEllipsis,
  faEllipsisH,
  faNfcSlash,
  faChessPawn,
  faKitMedical,
  faFirstAid,
  faGrid2Plus,
  faBells,
  faPersonThroughWindow,
  faToolbox,
  faGlobeWifi,
  faEnvelopeDot,
  faEnvelopeBadge,
  faMagnifyingGlassWaveform,
  faHandsHoldingCircle,
  faBug,
  faBowlChopsticks,
  faCreditCard,
  faCreditCardAlt,
  faCircleS,
  faBoxBallot,
  faCar,
  faAutomobile,
  faHandHoldingHand,
  faUserTieHair,
  faPodiumStar,
  faUserHairMullet,
  faBusinessFront,
  faPartyBack,
  faTrianBalbot,
  faMicrophoneStand,
  faBookOpenReader,
  faBookReader,
  faFamilyDress,
  faCircleX,
  faCabin,
  faMountainSun,
  faChartSimpleHorizontal,
  faBluetooth,
  faArrowsLeftRightToLine,
  faHandBackPointLeft,
  faMessageDots,
  faCommentAltDots,
  faMessaging,
  faFileHeart,
  faBeerMug,
  faBeerFoam,
  faDiceD20,
  faDrone,
  faTruckDroplet,
  faFileCircleXmark,
  faTemperatureArrowUp,
  faTemperatureUp,
  faMedal,
  faPersonFairy,
  faBed,
  faBookCopy,
  faSquareH,
  faHSquare,
  faSquareC,
  faClockTwo,
  faSquareEllipsisVertical,
  faCalendarUsers,
  faPodcast,
  faBee,
  faTemperatureFull,
  faTemperature4,
  faThermometer4,
  faThermometerFull,
  faBell,
  faCandyBar,
  faChocolateBar,
  faXmarkLarge,
  faPinata,
  faFilePpt,
  faArrowsFromLine,
  faSuperscript,
  faBowlSpoon,
  faHexagonCheck,
  faPlugCircleXmark,
  faStarOfLife,
  faPhoneSlash,
  faTrafficLightStop,
  faPaintRoller,
  faAccentGrave,
  faHandshakeAngle,
  faHandsHelping,
  faCircle0,
  faDialMedLow,
  faLocationDot,
  faMapMarkerAlt,
  faCrab,
  faBoxOpenFull,
  faBoxFull,
  faFile,
  faGreaterThan,
  faQuotes,
  faPretzel,
  faTRex,
  faPersonSwimming,
  faSwimmer,
  faArrowDown,
  faUserRobotXmarks,
  faMessageQuote,
  faCommentAltQuote,
  faCandyCorn,
  faFolderMagnifyingGlass,
  faFolderSearch,
  faNotebook,
  faCircleWifi,
  faDroplet,
  faTint,
  faBullseyePointer,
  faEraser,
  faHexagonImage,
  faEarthAmericas,
  faEarth,
  faEarthAmerica,
  faGlobeAmericas,
  faFileSvg,
  faCrateApple,
  faAppleCrate,
  faPersonBurst,
  faGameBoard,
  faHatChef,
  faHandBackPointRight,
  faDove,
  faSnowflakeDroplets,
  faBatteryEmpty,
  faBattery0,
  faGrid4,
  faSocks,
  faFaceSunglasses,
  faInbox,
  faSquare0,
  faSection,
  faSquareThisWayUp,
  faBoxUp,
  faGaugeHigh,
  faTachometerAlt,
  faTachometerAltFast,
  faSquareAmpersand,
  faEnvelopeOpenText,
  faLampDesk,
  faHospital,
  faHospitalAlt,
  faHospitalWide,
  faPollPeople,
  faWhiskeyGlassIce,
  faGlassWhiskeyRocks,
  faWineBottle,
  faChessRook,
  faUserBountyHunter,
  faBarsStaggered,
  faReorder,
  faStream,
  faDiagramSankey,
  faCloudHailMixed,
  faCircleUpLeft,
  faDharmachakra,
  faObjectsAlignLeft,
  faOilCanDrip,
  faFaceSmilingHands,
  faBroccoli,
  faRouteInterstate,
  faEarMuffs,
  faHotdog,
  faTransporterEmpty,
  faPersonWalkingWithCane,
  faBlind,
  faAngle90,
  faRectangleTerminal,
  faKite,
  faDrum,
  faScrubber,
  faIceCream,
  faHeartCircleBolt,
  faFishBones,
  faDeerRudolph,
  faFax,
  faParagraph,
  faHeadSideHeart,
  faSquareE,
  faMeterFire,
  faCloudHail,
  faCheckToSlot,
  faVoteYea,
  faMoneyFromBracket,
  faStarHalf,
  faCarBus,
  faSpeaker,
  faTimer,
  faBoxesStacked,
  faBoxes,
  faBoxesAlt,
  faLandmarkMagnifyingGlass,
  faGrillHot,
  faBallotCheck,
  faLink,
  faChain,
  faEarListen,
  faAssistiveListeningSystems,
  faFileMinus,
  faTreeCity,
  faPlay,
  faFont,
  faCupTogo,
  faCoffeeTogo,
  faSquareDownLeft,
  faBurgerLettuce,
  faTableCellsRowLock,
  faRupiahSign,
  faMagnifyingGlass,
  faSearch,
  faTableTennisPaddleBall,
  faPingPongPaddleBall,
  faTableTennis,
  faPersonDotsFromLine,
  faDiagnoses,
  faChevronsDown,
  faChevronDoubleDown,
  faTrashCanArrowUp,
  faTrashRestoreAlt,
  faSignalGood,
  faSignal3,
  faLocationQuestion,
  faMapMarkerQuestion,
  faFloppyDiskCircleXmark,
  faFloppyDiskTimes,
  faSaveCircleXmark,
  faSaveTimes,
  faNairaSign,
  faPeach,
  faCirclesOverlap3,
  faPronoun,
  faTaxiBus,
  faBracketCurly,
  faBracketCurlyLeft,
  faLobster,
  faCartFlatbedEmpty,
  faDollyFlatbedEmpty,
  faColon,
  faCartArrowDown,
  faWand,
  faWalkieTalkie,
  faFilePen,
  faFileEdit,
  faReceipt,
  faTablePicnic,
  faSquarePen,
  faPenSquare,
  faPencilSquare,
  faCircleMicrophoneLines,
  faMicrophoneCircleAlt,
  faDisplaySlash,
  faDesktopSlash,
  faSuitcaseRolling,
  faPersonCircleExclamation,
  faTransporter2,
  faUserHoodie,
  faHandsHoldingDiamond,
  faHandReceiving,
  faMoneyBillSimpleWave,
  faChevronDown,
  faBatteryFull,
  faBattery,
  faBattery5,
  faBellPlus,
  faBookArrowRight,
  faHospitals,
  faClub,
  faSkullCrossbones,
  faDropletDegree,
  faDewpoint,
  faCodeCompare,
  faListUl,
  faListDots,
  faHandHoldingMagic,
  faWatermelonSlice,
  faCircleEllipsis,
  faSchoolLock,
  faTowerCell,
  faSdCards,
  faJugBottle,
  faDownLong,
  faLongArrowAltDown,
  faEnvelopes,
  faPhoneOffice,
  faRankingStar,
  faChessKing,
  faNfcPen,
  faPersonHarassing,
  faMagnifyingGlassPlay,
  faHatWinter,
  faBrazilianRealSign,
  faLandmarkDome,
  faLandmarkAlt,
  faBoneBreak,
  faArrowUp,
  faDownFromDottedLine,
  faTv,
  faTelevision,
  faTvAlt,
  faBorderLeft,
  faCircleDivide,
  faShrimp,
  faListCheck,
  faTasks,
  faDiagramSubtask,
  faJugDetergent,
  faCircleUser,
  faUserCircle,
  faSquareY,
  faUserDoctorHair,
  faPlanetRinged,
  faMushroom,
  faUserShield,
  faMegaphone,
  faWreathLaurel,
  faCircleExclamationCheck,
  faWind,
  faBoxDollar,
  faBoxUsd,
  faCarBurst,
  faCarCrash,
  faY,
  faUserHeadset,
  faArrowsRetweet,
  faRetweetAlt,
  faPersonSnowboarding,
  faSnowboarding,
  faSquareChevronRight,
  faChevronSquareRight,
  faLacrosseStickBall,
  faTruckFast,
  faShippingFast,
  faUserMagnifyingGlass,
  faStarSharp,
  faCommentHeart,
  faCircle1,
  faCircleStar,
  faStarCircle,
  faFish,
  faCloudFog,
  faFog,
  faWaffle,
  faMusicNote,
  faMusicAlt,
  faHexagonExclamation,
  faCartShoppingFast,
  faObjectUnion,
  faUserGraduate,
  faStarfighter,
  faCircleHalfStroke,
  faAdjust,
  faArrowRightLongToLine,
  faSquareArrowDown,
  faArrowSquareDown,
  faDiamondHalfStroke,
  faClapperboard,
  faSquareChevronLeft,
  faChevronSquareLeft,
  faPhoneIntercom,
  faLinkHorizontal,
  faChainHorizontal,
  faMango,
  faMusicNoteSlash,
  faMusicAltSlash,
  faCircleRadiation,
  faRadiationAlt,
  faFaceTongueSweat,
  faGlobeStand,
  faBaseball,
  faBaseballBall,
  faCircleP,
  faAwardSimple,
  faJetFighterUp,
  faDiagramProject,
  faProjectDiagram,
  faPedestal,
  faChartPyramid,
  faSidebar,
  faSnowmanHead,
  faFrostyHead,
  faCopy,
  faBurgerGlass,
  faVolumeXmark,
  faVolumeMute,
  faVolumeTimes,
  faHandSparkles,
  faBarsFilter,
  faPaintbrushPencil,
  faPartyBell,
  faUserVneckHair,
  faJackOLantern,
  faGrip,
  faGripHorizontal,
  faShareFromSquare,
  faShareSquare,
  faKeynote,
  faChildCombatant,
  faChildRifle,
  faGun,
  faSquarePhone,
  faPhoneSquare,
  faHatBeach,
  faPlus,
  faAdd,
  faExpand,
  faComputer,
  faFort,
  faCloudCheck,
  faXmark,
  faClose,
  faMultiply,
  faRemove,
  faTimes,
  faFaceSmirking,
  faArrowsUpDownLeftRight,
  faArrows,
  faChalkboardUser,
  faChalkboardTeacher,
  faRhombus,
  faClawMarks,
  faPesoSign,
  faFaceSmileTongue,
  faCartCircleXmark,
  faBuildingShield,
  faCirclePhoneFlip,
  faPhoneCircleAlt,
  faBaby,
  faUsersLine,
  faQuoteLeft,
  faQuoteLeftAlt,
  faTractor,
  faDownFromBracket,
  faKeySkeleton,
  faTrashArrowUp,
  faTrashRestore,
  faArrowDownUpLock,
  faArrowDownToBracket,
  faLinesLeaning,
  faSquareQ,
  faRulerCombined,
  faSymbols,
  faIconsAlt,
  faCopyright,
  faFlaskGear,
  faHighlighterLine,
  faBracketSquare,
  faBracket,
  faBracketLeft,
  faIslandTropical,
  faIslandTreePalm,
  faArrowRightFromLine,
  faArrowFromLeft,
  faH2,
  faEquals,
  faCakeSlice,
  faShortcake,
  faBuildingMagnifyingGlass,
  faPeanut,
  faWrenchSimple,
  faBlender,
  faTeeth,
  faTally2,
  faShekelSign,
  faIls,
  faShekel,
  faSheqel,
  faSheqelSign,
  faCars,
  faAxeBattle,
  faUserHairLong,
  faMap,
  faArrowLeftFromArc,
  faFileCircleInfo,
  faFaceDisappointed,
  faLassoSparkles,
  faClockEleven,
  faRocket,
  faSirenOn,
  faClockTen,
  faCandleHolder,
  faVideoArrowDownLeft,
  faPhotoFilm,
  faPhotoVideo,
  faFloppyDiskCircleArrowRight,
  faSaveCircleArrowRight,
  faFolderMinus,
  faHexagonNodesBolt,
  faPlanetMoon,
  faFaceEyesXmarks,
  faChartScatter,
  faCircleGf,
  faDisplayArrowDown,
  faStore,
  faArrowTrendUp,
  faPlugCircleMinus,
  faOliveBranch,
  faAngle,
  faVacuumRobot,
  faSignHanging,
  faSign,
  faSquareDivide,
  faFolderCheck,
  faSignalStreamSlash,
  faBezierCurve,
  faEyeDropperHalf,
  faStoreLock,
  faBellSlash,
  faCloudBoltSun,
  faThunderstormSun,
  faCameraSlash,
  faCommentQuote,
  faTablet,
  faTabletAndroid,
  faSchoolFlag,
  faMessageCode,
  faGlassHalf,
  faGlassHalfEmpty,
  faGlassHalfFull,
  faFill,
  faMessageMinus,
  faCommentAltMinus,
  faAngleUp,
  faDinosaur,
  faDrumstickBite,
  faLinkHorizontalSlash,
  faChainHorizontalSlash,
  faHollyBerry,
  faNose,
  faArrowLeftToArc,
  faChevronLeft,
  faBacteria,
  faClouds,
  faMoneyBillSimple,
  faHandLizard,
  faTablePivot,
  faFilterSlash,
  faTrashCanUndo,
  faTrashCanArrowTurnLeft,
  faTrashUndoAlt,
  faNotdef,
  faDisease,
  faPersonToDoor,
  faTurntable,
  faBriefcaseMedical,
  faGenderless,
  faChevronRight,
  faSignalWeak,
  faSignal1,
  faClockFive,
  faRetweet,
  faCarRear,
  faCarAlt,
  faPumpSoap,
  faComputerClassic,
  faFrame,
  faVideoSlash,
  faBatteryQuarter,
  faBattery2,
  faEllipsisStroke,
  faEllipsisHAlt,
  faRadio,
  faBabyCarriage,
  faCarriageBaby,
  faFaceExpressionless,
  faDownToDottedLine,
  faCloudMusic,
  faTrafficLight,
  faCloudMinus,
  faThermometer,
  faShieldMinus,
  faVrCardboard,
  faCarTilt,
  faGaugeCircleMinus,
  faBrightnessLow,
  faHandMiddleFinger,
  faPercent,
  faPercentage,
  faTruckMoving,
  faGlassWaterDroplet,
  faConveyorBelt,
  faLocationCheck,
  faMapMarkerCheck,
  faCoinVertical,
  faDisplay,
  faPersonSign,
  faFaceSmile,
  faSmile,
  faPhoneHangup,
  faSignatureSlash,
  faThumbtack,
  faThumbTack,
  faWheatSlash,
  faTrophy,
  faCloudsSun,
  faPersonPraying,
  faPray,
  faHammer,
  faFaceVomit,
  faSpeakers,
  faTtyAnswer,
  faTeletypeAnswer,
  faMugTeaSaucer,
  faDiagramLeanCanvas,
  faAlt,
  faDial,
  faDialMedHigh,
  faHandPeace,
  faCircleTrash,
  faTrashCircle,
  faRotate,
  faSyncAlt,
  faCircleQuarters,
  faSpinner,
  faTowerControl,
  faArrowUpTriangleSquare,
  faSortShapesUp,
  faWhale,
  faRobot,
  faPeace,
  faPartyHorn,
  faGears,
  faCogs,
  faSunBright,
  faSunAlt,
  faWarehouse,
  faConveyorBeltArm,
  faLockKeyholeOpen,
  faLockOpenAlt,
  faSquareFragile,
  faBoxFragile,
  faSquareWineGlassCrack,
  faArrowUpRightDots,
  faSquareN,
  faSplotch,
  faFaceGrinHearts,
  faGrinHearts,
  faMeter,
  faMandolin,
  faDiceFour,
  faSimCard,
  faTransgender,
  faTransgenderAlt,
  faMercury,
  faUpFromBracket,
  faKnifeKitchen,
  faBorderRight,
  faArrowTurnDown,
  faLevelDown,
  faSpade,
  faCardSpade,
  faLineColumns,
  faAnt,
  faArrowRightToLine,
  faArrowToRight,
  faPersonFallingBurst,
  faFlagPennant,
  faPennant,
  faConveyorBeltEmpty,
  faUserGroupSimple,
  faAward,
  faTicketSimple,
  faTicketAlt,
  faBuilding,
  faAnglesLeft,
  faAngleDoubleLeft,
  faCamcorder,
  faVideoHandheld,
  faPancakes,
  faAlbumCircleUser,
  faSubtitlesSlash,
  faQrcode,
  faDiceD10,
  faFireplace,
  faBrowser,
  faPenPaintbrush,
  faPencilPaintbrush,
  faFishCooked,
  faChairOffice,
  faMagnifyingGlassMusic,
  faNestingDolls,
  faClockRotateLeft,
  faHistory,
  faTrumpet,
  faFaceGrinBeamSweat,
  faGrinBeamSweat,
  faFireSmoke,
  faPhoneMissed,
  faFileExport,
  faArrowRightFromFile,
  faShield,
  faShieldBlank,
  faArrowUpShortWide,
  faSortAmountUpAlt,
  faArrowsRepeat1,
  faRepeat1Alt,
  faGunSlash,
  faAvocado,
  faBinary,
  faCommentNodes,
  faGlassesRound,
  faGlassesAlt,
  faPhonePlus,
  faDitto,
  faPersonSeat,
  faHouseMedical,
  faGolfBallTee,
  faGolfBall,
  faCircleChevronLeft,
  faChevronCircleLeft,
  faHouseChimneyWindow,
  faScythe,
  faPenNib,
  faBanParking,
  faParkingCircleSlash,
  faTentArrowTurnLeft,
  faFaceDiagonalMouth,
  faDiagramCells,
  faCricketBatBall,
  faCricket,
  faTents,
  faWandMagic,
  faMagic,
  faDog,
  faPenLine,
  faAtomSimple,
  faAtomAlt,
  faAmpersand,
  faCarrot,
  faArrowUpFromLine,
  faArrowFromBottom,
  faMoon,
  faPenSlash,
  faWineGlassEmpty,
  faWineGlassAlt,
  faSquareStar,
  faCheese,
  faSendBackward,
  faYinYang,
  faMusic,
  faCompassSlash,
  faClockOne,
  faFileMusic,
  faCodeCommit,
  faTemperatureLow,
  faPersonBiking,
  faBiking,
  faDisplayChartUpCircleCurrency,
  faSkeleton,
  faCircleG,
  faCircleArrowUpLeft,
  faCoinBlank,
  faBroom,
  faVacuum,
  faShieldHeart,
  faCardHeart,
  faLightbulbCflOn,
  faMelon,
  faGopuram,
  faEarthOceania,
  faGlobeOceania,
  faContainerStorage,
  faFacePouting,
  faSquareXmark,
  faTimesSquare,
  faXmarkSquare,
  faFaceExplode,
  faExplodingHead,
  faHashtag,
  faUpRightAndDownLeftFromCenter,
  faExpandAlt,
  faOilCan,
  faT,
  faTransformerBolt,
  faHippo,
  faChartColumn,
  faCassetteVhs,
  faVhs,
  faInfinity,
  faVialCircleCheck,
  faChimney,
  faObjectIntersect,
  faPersonArrowDownToLine,
  faVoicemail,
  faBlockBrick,
  faWallBrick,
  faFan,
  faBagsShopping,
  faParagraphLeft,
  faParagraphRtl,
  faPersonWalkingLuggage,
  faCaravanSimple,
  faCaravanAlt,
  faTurtle,
  faPencilMechanical,
  faUpDown,
  faArrowsAltV,
  faCloudMoonRain,
  faBoothCurtain,
  faCalendar,
  faBoxHeart,
  faTrailer,
  faUserDoctorMessage,
  faUserMdChat,
  faBahai,
  faHaykal,
  faLighthouse,
  faAmpGuitar,
  faSdCard,
  faVolumeSlash,
  faBorderBottom,
  faWifiWeak,
  faWifi1,
  faDragon,
  faShoePrints,
  faCirclePlus,
  faPlusCircle,
  faFaceGrinTongueWink,
  faGrinTongueWink,
  faHandHolding,
  faPlugCircleExclamation,
  faLinkSlash,
  faChainBroken,
  faChainSlash,
  faUnlink,
  faClone,
  faPersonWalkingArrowLoopLeft,
  faArrowUpZA,
  faSortAlphaUpAlt,
  faFireFlameCurved,
  faFireAlt,
  faTornado,
  faFileCirclePlus,
  faDeleteRight,
  faBookQuran,
  faQuran,
  faCircleQuarter,
  faAnchor,
  faBorderAll,
  faFunction,
  faFaceAngry,
  faAngry,
  faPeopleSimple,
  faCookieBite,
  faArrowTrendDown,
  faRss,
  faFeed,
  faFaceMonocle,
  faDrawPolygon,
  faScaleBalanced,
  faBalanceScale,
  faCalendarLines,
  faCalendarNote,
  faArrowDownBigSmall,
  faSortSizeDown,
  faGaugeSimpleHigh,
  faTachometer,
  faTachometerFast,
  faDoNotEnter,
  faShower,
  faDiceD8,
  faDesktop,
  faDesktopAlt,
  faM,
  faSpinnerScale,
  faGripDotsVertical,
  faFaceViewfinder,
  faSoftServe,
  faCreemee,
  faH5,
  faHandBackPointDown,
  faTableList,
  faThList,
  faBasketShoppingMinus,
  faCommentSms,
  faSms,
  faRectangle,
  faRectangleLandscape,
  faClipboardListCheck,
  faTurkey,
  faBook,
  faUserPlus,
  faIceSkate,
  faCheck,
  faBatteryThreeQuarters,
  faBattery4,
  faTomato,
  faSwordLaser,
  faHouseCircleCheck,
  faBuildings,
  faAngleLeft,
  faCartFlatbedBoxes,
  faDollyFlatbedAlt,
  faDiagramSuccessor,
  faTruckArrowRight,
  faSquareW,
  faArrowsSplitUpAndLeft,
  faLamp,
  faAirplay,
  faHandFist,
  faFistRaised,
  faShieldQuartered,
  faSlashForward,
  faLocationPen,
  faMapMarkerEdit,
  faCloudMoon,
  faPotFood,
  faBriefcase,
  faPersonFalling,
  faImagePortrait,
  faPortrait,
  faUserTag,
  faRug,
  faPrintSlash,
  faEarthEurope,
  faGlobeEurope,
  faCartFlatbedSuitcase,
  faLuggageCart,
  faHandBackPointRibbon,
  faRectangleXmark,
  faRectangleTimes,
  faTimesRectangle,
  faWindowClose,
  faTireRugged,
  faLightbulbDollar,
  faCowbell,
  faBahtSign,
  faCorner,
  faChevronsRight,
  faChevronDoubleRight,
  faBookOpen,
  faBookJournalWhills,
  faJournalWhills,
  faInhaler,
  faHandcuffs,
  faSnake,
  faTriangleExclamation,
  faExclamationTriangle,
  faWarning,
  faNoteMedical,
  faDatabase,
  faDownLeft,
  faShare,
  faMailForward,
  faFaceThinking,
  faTurnDownRight,
  faBottleDroplet,
  faMaskFace,
  faHillRockslide,
  faScannerKeyboard,
  faCircleO,
  faGridHorizontal,
  faMessageDollar,
  faCommentAltDollar,
  faRightLeft,
  faExchangeAlt,
  faColumns3,
  faPaperPlane,
  faRoadCircleExclamation,
  faDungeon,
  faHandHoldingBox,
  faInputText,
  faWindowFlip,
  faWindowAlt,
  faAlignRight,
  faScannerGun,
  faScanner,
  faTire,
  faEngine,
  faMoneyBill1Wave,
  faMoneyBillWaveAlt,
  faLifeRing,
  faHands,
  faSignLanguage,
  faSigning,
  faCircleCaretRight,
  faCaretCircleRight,
  faTurnLeft,
  faWheat,
  faFileSpreadsheet,
  faAudioDescriptionSlash,
  faBellRing,
  faCalendarDay,
  faWaterLadder,
  faLadderWater,
  faSwimmingPool,
  faArrowsUpDown,
  faArrowsV,
  faChessPawnPiece,
  faChessPawnAlt,
  faFaceGrimace,
  faGrimace,
  faWheelchairMove,
  faWheelchairAlt,
  faTurnDown,
  faLevelDownAlt,
  faSquareS,
  faRectangleBarcode,
  faBarcodeAlt,
  faPersonWalkingArrowRight,
  faSquareEnvelope,
  faEnvelopeSquare,
  faDice,
  faUnicorn,
  faBowlingBall,
  faPompebled,
  faBrain,
  faWatchSmart,
  faBookUser,
  faSensorCloud,
  faSensorSmoke,
  faClapperboardPlay,
  faBandage,
  faBandAid,
  faCalendarMinus,
  faCircleXmark,
  faTimesCircle,
  faXmarkCircle,
  faCircle4,
  faGifts,
  faAlbumCollection,
  faHotel,
  faEarthAsia,
  faGlobeAsia,
  faIdCardClip,
  faIdCardAlt,
  faMagnifyingGlassPlus,
  faSearchPlus,
  faThumbsUp,
  faCloudShowers,
  faUserClock,
  faOnion,
  faClockTwelveThirty,
  faArrowDownToDottedLine,
  faHandDots,
  faAllergies,
  faFileInvoice,
  faWindowMinimize,
  faRectangleWide,
  faCommentArrowUp,
  faGarlic,
  faMugSaucer,
  faCoffee,
  faBrush,
  faFileHalfDashed,
  faTreeDecorated,
  faMask,
  faCalendarHeart,
  faMagnifyingGlassMinus,
  faSearchMinus,
  faFlower,
  faArrowDownFromArc,
  faRightLeftLarge,
  faRulerVertical,
  faCirclesOverlap,
  faUserLarge,
  faUserAlt,
  faStarshipFreighter,
  faTrainTram,
  faBridgeSuspension,
  faTrashCheck,
  faUserNurse,
  faBoombox,
  faSyringe,
  faCloudSun,
  faShieldExclamation,
  faStopwatch20,
  faSquareFull,
  faGripDots,
  faCommentExclamation,
  faPenSwirl,
  faFalafel,
  faCircle2,
  faMagnet,
  faJar,
  faGramophone,
  faDiceD12,
  faNoteSticky,
  faStickyNote,
  faDown,
  faArrowAltDown,
  faHundredPoints,
  fa100,
  faPaperclipVertical,
  faWindWarning,
  faWindCircleExclamation,
  faLocationPinSlash,
  faMapMarkerSlash,
  faFaceSadSweat,
  faBugSlash,
  faCupcake,
  faLightSwitchOff,
  faToggleLargeOff,
  faPenFancySlash,
  faTruckContainer,
  faBoot,
  faArrowUpFromWaterPump,
  faFileCheck,
  faBone,
  faCardsBlank,
  faCircle3,
  faBenchTree,
  faKeyboardBrightnessLow,
  faSkiBootSki,
  faBrainCircuit,
  faTableCellsRowUnlock,
  faUserInjured,
  faBlockBrickFire,
  faFirewall,
  faFaceSadTear,
  faSadTear,
  faPlane,
  faTentArrowsDown,
  faExclamation,
  faArrowsSpin,
  faFaceSmileRelaxed,
  faCommentXmark,
  faCommentTimes,
  faPrint,
  faTurkishLiraSign,
  faTry,
  faTurkishLira,
  faFaceNoseSteam,
  faCircleWaveformLines,
  faWaveformCircle,
  faDollarSign,
  faDollar,
  faUsd,
  faFerrisWheel,
  faComputerSpeaker,
  faSkullCow,
  faX,
  faMagnifyingGlassDollar,
  faSearchDollar,
  faUsersGear,
  faUsersCog,
  faPersonMilitaryPointing,
  faBuildingColumns,
  faBank,
  faInstitution,
  faMuseum,
  faUniversity,
  faCircleT,
  faSack,
  faGrid2,
  faCameraCctv,
  faCctv,
  faUmbrella,
  faTrowel,
  faHorizontalRule,
  faBedFront,
  faBedAlt,
  faD,
  faStapler,
  faMasksTheater,
  faTheaterMasks,
  faFileGif,
  faKipSign,
  faFaceWoozy,
  faCloudQuestion,
  faPineapple,
  faHandPointLeft,
  faGalleryThumbnails,
  faCircleJ,
  faEyes,
  faHandshakeSimple,
  faHandshakeAlt,
  faPageCaretUp,
  faFileCaretUp,
  faJetFighter,
  faFighterJet,
  faComet,
  faSquareShareNodes,
  faShareAltSquare,
  faReflectVertical,
  faShieldKeyhole,
  faFileMp4,
  faBarcode,
  faBulldozer,
  faPlusMinus,
  faSquareSlidersVertical,
  faSlidersVSquare,
  faVideo,
  faVideoCamera,
  faMessageMiddle,
  faCommentMiddleAlt,
  faGraduationCap,
  faMortarBoard,
  faHandHoldingMedical,
  faPersonCircleCheck,
  faSquareZ,
  faMessageText,
  faCommentAltText,
  faTurnUp,
  faLevelUpAlt
};




/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 82222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 15761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class FocusManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();


//# sourceMappingURL=focusManager.mjs.map


/***/ }),

/***/ 30819:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ defaultLogger; }
/* harmony export */ });
const defaultLogger = console;


//# sourceMappingURL=logger.mjs.map


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _logger_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30819);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30081);
/* harmony import */ var _removable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89643);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72379);





// CLASS
class Mutation extends _removable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.options = { ...config.defaultOptions,
      ...config.options
    };
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || _logger_mjs__WEBPACK_IMPORTED_MODULE_1__/* .defaultLogger */ ._;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.updateCacheTime(this.options.cacheTime);
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onError, _this$options4, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, error, this.state.variables, this.state.context, this));

        if (false) {}

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .canFetch */ .Kw)(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__/* .notifyManager.batch */ .V.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}


//# sourceMappingURL=mutation.mjs.map


/***/ }),

/***/ 30081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();


//# sourceMappingURL=notifyManager.mjs.map


/***/ }),

/***/ 96474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class OnlineManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(listener => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();


//# sourceMappingURL=onlineManager.mjs.map


/***/ }),

/***/ 89643:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}


//# sourceMappingURL=removable.mjs.map


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15761);
/* harmony import */ var _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96474);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32161);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !_focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== 'always' && !_onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        if (isResolved || !shouldPause()) {
          return continueResolve(value);
        }
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      continueFn == null ? void 0 : continueFn();
    },
    cancelRetry,
    continueRetry
  };
}


//# sourceMappingURL=retryer.mjs.map


/***/ }),

/***/ 33989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
class Subscribable {
  constructor() {
    this.listeners = [];
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    this.listeners.push(listener);
    this.onSubscribe();
    return () => {
      this.listeners = this.listeners.filter(x => x !== listener);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.length > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}


//# sourceMappingURL=subscribable.mjs.map


/***/ }),

/***/ 32161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, isError, isPlainArray, isPlainObject, isQueryKey, parseMutationFilterArgs, partialDeepEqual, replaceAt, replaceEqualDeep */
// TYPES
// UTILS
const isServer = typeof window === 'undefined' || 'Deno' in window;
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
  return array1.filter(x => array2.indexOf(x) === -1);
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return { ...arg3,
        mutationKey: arg1,
        mutationFn: arg2
      };
    }

    return { ...arg2,
      mutationKey: arg1
    };
  }

  if (typeof arg1 === 'function') {
    return { ...arg2,
      mutationFn: arg1
    };
  }

  return { ...arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    mutationKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 90041:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ReactQueryDevtools; }
/* harmony export */ });
/* unused harmony export ReactQueryDevtoolsPanel */
'use client';


const ReactQueryDevtools =  true ? function () {
  return null;
} : 0;
const ReactQueryDevtoolsPanel = (/* unused pure expression or super */ null && ( true ? function () {
  return null;
} : 0));


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 85945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const defaultContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = react__WEBPACK_IMPORTED_MODULE_0__.useContext(getQueryClientContext(context, react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (false) {}

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: client
  }, children));
};


//# sourceMappingURL=QueryClientProvider.mjs.map


/***/ }),

/***/ 67848:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs






class QueryObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.length === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = [];
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (false) {}

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    return this.createResult(query, options);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    const time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,retryer/* canFetch */.Kw)(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (false) {}

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (false) {}

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;

      if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
}


//# sourceMappingURL=queryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs


function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => react.useContext(QueryErrorResetBoundaryContext); // COMPONENT

const QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};


//# sourceMappingURL=QueryErrorResetBoundary.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/isRestoring.mjs


const IsRestoringContext = /*#__PURE__*/react.createContext(false);
const useIsRestoring = () => react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;


//# sourceMappingURL=isRestoring.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(53314);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/errorBoundaryUtils.mjs



const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,lib_utils/* shouldThrowError */.L)(useErrorBoundary, [result.error, query]);
};


//# sourceMappingURL=errorBoundaryUtils.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/suspense.mjs
const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});


//# sourceMappingURL=suspense.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs









function useBaseQuery(options, Observer) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => isRestoring ? () => undefined : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  react.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


//# sourceMappingURL=useBaseQuery.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61688);


// Temporary workaround due to an issue with react-native uSES - https://github.com/TanStack/query/pull/3601
const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 53314:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45695);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 45695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 29749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ye": function() { return /* binding */ Location; },
  "WU": function() { return /* binding */ Token; },
  "UG": function() { return /* binding */ isNode; }
});

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(45695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),

/***/ 16297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: Parser, parseType, parseValue

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/polyfills/symbols.mjs
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs
function GraphQLError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { GraphQLError_typeof = function _typeof(obj) { return typeof obj; }; } else { GraphQLError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return GraphQLError_typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (GraphQLError_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs + 2 modules
var ast = __webpack_require__(29749);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs
function instanceOf_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { instanceOf_typeof = function _typeof(obj) { return typeof obj; }; } else { instanceOf_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return instanceOf_typeof(obj); }


/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
/* harmony default export */ var instanceOf = ( true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0);

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs
function source_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function source_createClass(Constructor, protoProps, staticProps) { if (protoProps) source_defineProperties(Constructor.prototype, protoProps); if (staticProps) source_defineProperties(Constructor, staticProps); return Constructor; }






/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat((0,inspect/* default */.Z)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  source_createClass(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === tokenKind_TokenKind.BANG || kind === tokenKind_TokenKind.DOLLAR || kind === tokenKind_TokenKind.AMP || kind === tokenKind_TokenKind.PAREN_L || kind === tokenKind_TokenKind.PAREN_R || kind === tokenKind_TokenKind.SPREAD || kind === tokenKind_TokenKind.COLON || kind === tokenKind_TokenKind.EQUALS || kind === tokenKind_TokenKind.AT || kind === tokenKind_TokenKind.BRACKET_L || kind === tokenKind_TokenKind.BRACKET_R || kind === tokenKind_TokenKind.BRACE_L || kind === tokenKind_TokenKind.PIPE || kind === tokenKind_TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new ast/* Token */.WU(tokenKind_TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new ast/* Token */.WU(tokenKind_TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new ast/* Token */.WU(tokenKind_TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new ast/* Token */.WU(tokenKind_TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new ast/* Token */.WU(tokenKind_TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new ast/* Token */.WU(tokenKind_TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new ast/* Token */.WU(tokenKind_TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new ast/* Token */.WU(tokenKind_TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new ast/* Token */.WU(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new ast/* Token */.WU(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new ast/* Token */.WU(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new ast/* Token */.WU(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: kinds/* Kind.NULL */.h.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || this.peek(tokenKind_TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new ast/* Location */.Ye(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}


/***/ }),

/***/ 39011:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ print; }
/* harmony export */ });
/* harmony import */ var _visitor_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77304);
/* harmony import */ var _blockString_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87392);


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,_visitor_mjs__WEBPACK_IMPORTED_MODULE_0__/* .visit */ .Vn)(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,_blockString_mjs__WEBPACK_IMPORTED_MODULE_1__/* .printBlockString */ .LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ }),

/***/ 77304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports QueryDocumentKeys, visitInParallel, getVisitFn */
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25821);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29749);


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node)) {
        throw new Error("Invalid AST Node: ".concat((0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 28673:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inheritsLoose; }
});

;// CONCATENATED MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/react-transition-group/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 43992:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),

/***/ 27563:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ab": function() { return /* binding */ COMMENT; },
/* harmony export */   "Fr": function() { return /* binding */ RULESET; },
/* harmony export */   "G$": function() { return /* binding */ WEBKIT; },
/* harmony export */   "K$": function() { return /* binding */ IMPORT; },
/* harmony export */   "MS": function() { return /* binding */ MS; },
/* harmony export */   "h5": function() { return /* binding */ DECLARATION; },
/* harmony export */   "lK": function() { return /* binding */ KEYFRAMES; },
/* harmony export */   "uj": function() { return /* binding */ MOZ; }
/* harmony export */ });
/* unused harmony exports PAGE, MEDIA, CHARSET, VIEWPORT, SUPPORTS, DOCUMENT, NAMESPACE, FONT_FACE, COUNTER_STYLE, FONT_FEATURE_VALUES */
var MS = '-ms-'
var MOZ = '-moz-'
var WEBKIT = '-webkit-'

var COMMENT = 'comm'
var RULESET = 'rule'
var DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'


/***/ }),

/***/ 94582:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qR": function() { return /* binding */ middleware; },
  "Ji": function() { return /* binding */ prefixer; },
  "cD": function() { return /* binding */ rulesheet; }
});

// UNUSED EXPORTS: namespace

// EXTERNAL MODULE: ./node_modules/stylis/src/Enum.js
var Enum = __webpack_require__(27563);
// EXTERNAL MODULE: ./node_modules/stylis/src/Utility.js
var Utility = __webpack_require__(26686);
// EXTERNAL MODULE: ./node_modules/stylis/src/Tokenizer.js
var Tokenizer = __webpack_require__(46411);
// EXTERNAL MODULE: ./node_modules/stylis/src/Serializer.js
var Serializer = __webpack_require__(20211);
;// CONCATENATED MODULE: ./node_modules/stylis/src/Prefixer.js



/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch ((0,Utility/* hash */.vp)(value, length)) {
		// color-adjust
		case 5103:
			return Enum/* WEBKIT */.G$ + 'print-' + value + value
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return Enum/* WEBKIT */.G$ + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return Enum/* WEBKIT */.G$ + value + Enum/* MOZ */.uj + value + Enum.MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + value + value
		// order
		case 6165:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + 'flex-' + value + value
		// align-items
		case 5187:
			return Enum/* WEBKIT */.G$ + value + (0,Utility/* replace */.gx)(value, /(\w+).+(:[^]+)/, Enum/* WEBKIT */.G$ + 'box-$1$2' + Enum.MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + 'flex-item-' + (0,Utility/* replace */.gx)(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + 'flex-line-pack' + (0,Utility/* replace */.gx)(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return Enum/* WEBKIT */.G$ + 'box-' + (0,Utility/* replace */.gx)(value, '-grow', '') + Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return Enum/* WEBKIT */.G$ + (0,Utility/* replace */.gx)(value, /([^-])(transform)/g, '$1' + Enum/* WEBKIT */.G$ + '$2') + value
		// cursor
		case 6187:
			return (0,Utility/* replace */.gx)((0,Utility/* replace */.gx)((0,Utility/* replace */.gx)(value, /(zoom-|grab)/, Enum/* WEBKIT */.G$ + '$1'), /(image-set)/, Enum/* WEBKIT */.G$ + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return (0,Utility/* replace */.gx)(value, /(image-set\([^]*)/, Enum/* WEBKIT */.G$ + '$1' + '$`$1')
		// justify-content
		case 4968:
			return (0,Utility/* replace */.gx)((0,Utility/* replace */.gx)(value, /(.+:)(flex-)?(.*)/, Enum/* WEBKIT */.G$ + 'box-pack:$3' + Enum.MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum/* WEBKIT */.G$ + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return (0,Utility/* replace */.gx)(value, /(.+)-inline(.+)/, Enum/* WEBKIT */.G$ + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if ((0,Utility/* strlen */.to)(value) - 1 - length > 6)
				switch ((0,Utility/* charat */.uO)(value, length + 1)) {
					// (m)ax-content, (m)in-content
					case 109:
						// -
						if ((0,Utility/* charat */.uO)(value, length + 4) !== 45)
							break
					// (f)ill-available, (f)it-content
					case 102:
						return (0,Utility/* replace */.gx)(value, /(.+:)(.+)-([^]+)/, '$1' + Enum/* WEBKIT */.G$ + '$2-$3' + '$1' + Enum/* MOZ */.uj + ((0,Utility/* charat */.uO)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~(0,Utility/* indexof */.Cw)(value, 'stretch') ? prefix((0,Utility/* replace */.gx)(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if ((0,Utility/* charat */.uO)(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex)
		case 6444:
			switch ((0,Utility/* charat */.uO)(value, (0,Utility/* strlen */.to)(value) - 3 - (~(0,Utility/* indexof */.Cw)(value, '!important') && 10))) {
				// stic(k)y
				case 107:
					return (0,Utility/* replace */.gx)(value, ':', ':' + Enum/* WEBKIT */.G$) + value
				// (inline-)?fl(e)x
				case 101:
					return (0,Utility/* replace */.gx)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum/* WEBKIT */.G$ + ((0,Utility/* charat */.uO)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum/* WEBKIT */.G$ + '$2$3' + '$1' + Enum.MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch ((0,Utility/* charat */.uO)(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return Enum/* WEBKIT */.G$ + value + Enum.MS + (0,Utility/* replace */.gx)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return Enum/* WEBKIT */.G$ + value + Enum.MS + value + value
	}

	return value
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = (0,Utility/* sizeof */.Ei)(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case Enum/* DECLARATION */.h5: element.return = prefix(element.value, element.length)
					break
				case Enum/* KEYFRAMES */.lK:
					return (0,Serializer/* serialize */.q)([(0,Tokenizer/* copy */.JG)(element, {value: (0,Utility/* replace */.gx)(element.value, '@', '@' + Enum/* WEBKIT */.G$)})], callback)
				case Enum/* RULESET */.Fr:
					if (element.length)
						return (0,Utility/* combine */.$e)(element.props, function (value) {
							switch ((0,Utility/* match */.EQ)(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return (0,Serializer/* serialize */.q)([(0,Tokenizer/* copy */.JG)(element, {props: [(0,Utility/* replace */.gx)(value, /:(read-\w+)/, ':' + Enum/* MOZ */.uj + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return (0,Serializer/* serialize */.q)([
										(0,Tokenizer/* copy */.JG)(element, {props: [(0,Utility/* replace */.gx)(value, /:(plac\w+)/, ':' + Enum/* WEBKIT */.G$ + 'input-$1')]}),
										(0,Tokenizer/* copy */.JG)(element, {props: [(0,Utility/* replace */.gx)(value, /:(plac\w+)/, ':' + Enum/* MOZ */.uj + '$1')]}),
										(0,Tokenizer/* copy */.JG)(element, {props: [(0,Utility/* replace */.gx)(value, /:(plac\w+)/, Enum.MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}


/***/ }),

/***/ 92190:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MY": function() { return /* binding */ compile; }
/* harmony export */ });
/* unused harmony exports parse, ruleset, comment, declaration */
/* harmony import */ var _Enum_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27563);
/* harmony import */ var _Utility_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26686);
/* harmony import */ var _Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46411);




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .dealloc */ .cE)(parse('', null, null, null, [''], value = (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .alloc */ .un)(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .next */ .lp)()) {
			// (
			case 40:
				if (previous != 108 && characters.charCodeAt(length - 1) == 58) {
					if ((0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .indexof */ .Cw)(characters += (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .replace */ .gx)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .delimit */ .iF)(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .delimit */ .iF)(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .whitespace */ .Qb)(previous)
				break
			// \
			case 92:
				characters += (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .escaping */ .kq)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .caret */ .Ud)() - 1, 7)
				continue
			// /
			case 47:
				switch ((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .peek */ .fj)()) {
					case 42: case 47:
						;(0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .append */ .R3)(comment((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .commenter */ .q6)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .next */ .lp)(), (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .caret */ .Ud)()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset:
						if (property > 0 && ((0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(characters) - length))
							(0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .append */ .R3)(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration((0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .replace */ .gx)(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						;(0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .append */ .R3)(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .append */ .R3)(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .prev */ .mp)() == 125)
						continue

				switch (characters += (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .from */ .Dp)(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = ((0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if ((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .peek */ .fj)() === 45)
							characters += (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .delimit */ .iF)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .next */ .lp)())

						atrule = (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .peek */ .fj)(), offset = length = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(type = characters += (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .identifier */ .QU)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .caret */ .Ud)())), character++
						break
					// -
					case 45:
						if (previous === 45 && (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .strlen */ .to)(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .sizeof */ .Ei)(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .substr */ .tb)(value, post + 1, post = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .abs */ .Wn)(j = points[i])), z = value; x < size; ++x)
			if (z = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .trim */ .fy)(j > 0 ? rule[x] + ' ' + y : (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .replace */ .gx)(y, /&\f/g, rule[x])))
				props[k++] = z

	return (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .node */ .dH)(value, root, parent, offset === 0 ? _Enum_js__WEBPACK_IMPORTED_MODULE_2__/* .RULESET */ .Fr : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .node */ .dH)(value, root, parent, _Enum_js__WEBPACK_IMPORTED_MODULE_2__/* .COMMENT */ .Ab, (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .from */ .Dp)((0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .char */ .Tb)()), (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .substr */ .tb)(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return (0,_Tokenizer_js__WEBPACK_IMPORTED_MODULE_0__/* .node */ .dH)(value, root, parent, _Enum_js__WEBPACK_IMPORTED_MODULE_2__/* .DECLARATION */ .h5, (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .substr */ .tb)(value, 0, length), (0,_Utility_js__WEBPACK_IMPORTED_MODULE_1__/* .substr */ .tb)(value, length + 1, -1), length)
}


/***/ }),

/***/ 20211:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ stringify; },
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
/* harmony import */ var _Enum_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27563);
/* harmony import */ var _Utility_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26686);



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = ''
	var length = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .sizeof */ .Ei)(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case _Enum_js__WEBPACK_IMPORTED_MODULE_1__/* .IMPORT */ .K$: case _Enum_js__WEBPACK_IMPORTED_MODULE_1__/* .DECLARATION */ .h5: return element.return = element.return || element.value
		case _Enum_js__WEBPACK_IMPORTED_MODULE_1__/* .COMMENT */ .Ab: return ''
		case _Enum_js__WEBPACK_IMPORTED_MODULE_1__/* .KEYFRAMES */ .lK: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case _Enum_js__WEBPACK_IMPORTED_MODULE_1__/* .RULESET */ .Fr: element.value = element.props.join(',')
	}

	return (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .strlen */ .to)(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}


/***/ }),

/***/ 46411:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ position; },
/* harmony export */   "JG": function() { return /* binding */ copy; },
/* harmony export */   "QU": function() { return /* binding */ identifier; },
/* harmony export */   "Qb": function() { return /* binding */ whitespace; },
/* harmony export */   "Tb": function() { return /* binding */ char; },
/* harmony export */   "Ud": function() { return /* binding */ caret; },
/* harmony export */   "cE": function() { return /* binding */ dealloc; },
/* harmony export */   "dH": function() { return /* binding */ node; },
/* harmony export */   "fj": function() { return /* binding */ peek; },
/* harmony export */   "iF": function() { return /* binding */ delimit; },
/* harmony export */   "kq": function() { return /* binding */ escaping; },
/* harmony export */   "lp": function() { return /* binding */ next; },
/* harmony export */   "mp": function() { return /* binding */ prev; },
/* harmony export */   "q6": function() { return /* binding */ commenter; },
/* harmony export */   "r": function() { return /* binding */ token; },
/* harmony export */   "tP": function() { return /* binding */ slice; },
/* harmony export */   "un": function() { return /* binding */ alloc; }
/* harmony export */ });
/* unused harmony exports line, column, length, character, characters, tokenize, tokenizer, delimiter */
/* harmony import */ var _Utility_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26686);


var line = 1
var column = 1
var length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy (root, props) {
	return (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .charat */ .uO)(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < length ? (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .charat */ .uO)(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .charat */ .uO)(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .substr */ .tb)(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .strlen */ .to)(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .trim */ .fy)(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + (0,_Utility_js__WEBPACK_IMPORTED_MODULE_0__/* .from */ .Dp)(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}


/***/ }),

/***/ 26686:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "Cw": function() { return /* binding */ indexof; },
/* harmony export */   "Dp": function() { return /* binding */ from; },
/* harmony export */   "EQ": function() { return /* binding */ match; },
/* harmony export */   "Ei": function() { return /* binding */ sizeof; },
/* harmony export */   "R3": function() { return /* binding */ append; },
/* harmony export */   "Wn": function() { return /* binding */ abs; },
/* harmony export */   "f0": function() { return /* binding */ assign; },
/* harmony export */   "fy": function() { return /* binding */ trim; },
/* harmony export */   "gx": function() { return /* binding */ replace; },
/* harmony export */   "tb": function() { return /* binding */ substr; },
/* harmony export */   "to": function() { return /* binding */ strlen; },
/* harmony export */   "uO": function() { return /* binding */ charat; },
/* harmony export */   "vp": function() { return /* binding */ hash; }
/* harmony export */ });
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}


/***/ }),

/***/ 33600:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');

/***/ }),

/***/ 59323:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');

/***/ }),

/***/ 29591:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","QUOT":"\\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}');

/***/ }),

/***/ 2586:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);